function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9UXSF", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$fe84270dc6a6bcec$export$2e2bcd8739ae039);
    var $3cgJ4;
    var $hyZG6 = parcelRequire("hyZG6");
    var $eVD3E = parcelRequire("eVD3E");
    var $tVHge = parcelRequire("tVHge");
    var $jRbER = parcelRequire("jRbER");
    var $l9sxf = parcelRequire("l9sxf");
    var $fWEk3 = parcelRequire("fWEk3");
    var $ixSW4 = parcelRequire("ixSW4");
    var $koBOk = parcelRequire("koBOk");
    var $aP4KL = parcelRequire("aP4KL");
    var $lJdz7 = parcelRequire("lJdz7");
    var $8QHq4 = parcelRequire("8QHq4");
    var $fbVhf;
    var $fe84270dc6a6bcec$export$2e2bcd8739ae039 = (0, $ixSW4.provideComponents)({
        FieldSelect: $lJdz7.SelectForColumnCell,
        FieldAsyncSelect: $lJdz7.AsyncSelectForColumnCell,
        FieldPrioritySelect: $lJdz7.SelectForColumnCell,
        FieldMultiSelectCell: $eVD3E.default,
        FieldDatePicker: $hyZG6.default,
        FieldUserAvatarCell: $tVHge.default,
        CellSelectWithRollup: $lJdz7.CellSelectWithRollup,
        CellTextField: (0, (0, parcelRequire("3cgJ4")).default),
        AdvancedFieldsMenu: $l9sxf.default,
        FilterDependencyGraphFromRoadmap: $koBOk.default,
        QuickFilter: $aP4KL.default,
        IssueSearchWarningClearFilter: $jRbER.default,
        NowLine: $fWEk3.default,
        UserPicker: $8QHq4.default
    })((0, (0, parcelRequire("fbVhf")).default));
});
parcelRegister("3cgJ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c63daeab88add0f3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $kY99m;
    var $b06Yt = parcelRequire("b06Yt");
    class $c63daeab88add0f3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            if (this.inputEl && this.inputEl.type === 'number') {
                this.inputEl.addEventListener('input', this.onInputNative);
                this.inputEl.addEventListener('mousedown', this.onChildMouseDown);
                this.inputEl.setAttribute('step', this.props.step && this.props.step.toString() || 'any');
            }
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.value !== this.props.value) this.setState({
                value: nextProps.value,
                oldValue: nextProps.value
            });
        }
        componentWillUnmount() {
            if (this.inputEl && this.inputEl.type === 'number') {
                this.inputEl.removeEventListener('mousedown', this.onChildMouseDown);
                this.inputEl.removeEventListener('input', this.onInputNative);
            }
        }
        render() {
            const { isAlignRight: isAlignRight, isTransparentBackground: isTransparentBackground, isReadOnly: isReadOnly, onDone: onDone, errorMessage: errorMessage, ...props } = this.props;
            const className = (0, ($parcel$interopDefault($9ci4W)))({
                [$b06Yt.isTransparentBackground]: isTransparentBackground,
                [$b06Yt.isAlignRight]: isAlignRight,
                [$b06Yt.error]: !this.state.valid,
                [$b06Yt.isReadOnly]: isReadOnly
            });
            const { value: value } = this.state;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: className
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                ...props,
                isReadOnly: isReadOnly,
                onBlur: this.onBlur,
                onChange: this.onChange,
                onFocus: this.onFocus,
                onKeyDown: this.onKeyDown,
                ref: (inputEl)=>{
                    if (inputEl) this.inputEl = inputEl;
                },
                value: value === null || value === undefined ? '' : value
            })));
        }
        constructor(...args){
            super(...args);
            this.state = {
                oldValue: this.props.value,
                value: this.props.value,
                valid: true
            };
            this.onChildMouseDown = ()=>{
                this.inputEl.focus();
            };
            this.onBlur = (e)=>{
                const { oldValue: oldValue, value: value, valid: valid } = this.state;
                let newValue = value;
                if (valid) {
                    if (this.props.type === 'number' && value !== undefined) newValue = `${Math.round(parseFloat(value) * 1000) / 1000}`;
                    this.setState({
                        value: newValue,
                        oldValue: newValue,
                        valid: true
                    });
                } else {
                    this.setState({
                        value: oldValue,
                        valid: true
                    });
                    newValue = oldValue;
                }
                if (this.props.onDone) this.props.onDone(newValue);
                if (this.props.onBlur) this.props.onBlur(e);
            };
            this.onInputNative = (e)=>{
                const target = e.target;
                if (target instanceof HTMLInputElement) {
                    const { value: value, validity: { valid: valid } } = target;
                    this.setState({
                        value: value,
                        valid: valid
                    });
                }
            };
            this.onKeyDown = (e)=>{
                const target = e.target;
                if (e.key === 'Escape') this.setState({
                    value: this.props.value
                }, ()=>{
                    if (target instanceof HTMLInputElement) target.blur();
                });
                if (e.key === 'Enter') {
                    if (target instanceof HTMLInputElement) target.blur();
                }
                if (this.props.onKeyDown) this.props.onKeyDown(e);
            };
            this.onFocus = (event)=>{
                if (this.props.isReadOnly) event.preventDefault();
                else if (this.props.onFocus) this.props.onFocus(event);
            };
            this.onChange = (e)=>{
                if (e.target instanceof HTMLInputElement) {
                    this.setState({
                        value: e.target.value
                    });
                    if (this.props.onChange) this.props.onChange(e);
                }
            };
        }
    }
});
parcelRegister("9ci4W", function(module, exports) {
    (function() {
        'use strict';
        var hasOwn = {}.hasOwnProperty;
        function classNames() {
            var classes = '';
            for(var i = 0; i < arguments.length; i++){
                var arg = arguments[i];
                if (arg) classes = appendClass(classes, parseValue(arg));
            }
            return classes;
        }
        function parseValue(arg) {
            if (typeof arg === 'string' || typeof arg === 'number') return arg;
            if (typeof arg !== 'object') return '';
            if (Array.isArray(arg)) return classNames.apply(null, arg);
            if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
            var classes = '';
            for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
            return classes;
        }
        function appendClass(value, newClass) {
            if (!newClass) return value;
            if (value) return value + ' ' + newClass;
            return value + newClass;
        }
        if (0, module.exports) {
            classNames.default = classNames;
            module.exports = classNames;
        } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define('classnames', [], function() {
            return classNames;
        });
        else window.classNames = classNames;
    })();
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("b06Yt", function(module, exports) {
    $parcel$export(module.exports, "error", ()=>$80251ac710992b66$export$a3bc9b8ed74fc, (v)=>$80251ac710992b66$export$a3bc9b8ed74fc = v);
    $parcel$export(module.exports, "isAlignRight", ()=>$80251ac710992b66$export$314135682d277cb4, (v)=>$80251ac710992b66$export$314135682d277cb4 = v);
    $parcel$export(module.exports, "isReadOnly", ()=>$80251ac710992b66$export$2498094d90b6ac72, (v)=>$80251ac710992b66$export$2498094d90b6ac72 = v);
    $parcel$export(module.exports, "isTransparentBackground", ()=>$80251ac710992b66$export$2183c3f1b0e8f02a, (v)=>$80251ac710992b66$export$2183c3f1b0e8f02a = v);
    var $80251ac710992b66$export$a3bc9b8ed74fc;
    var $80251ac710992b66$export$314135682d277cb4;
    var $80251ac710992b66$export$2498094d90b6ac72;
    var $80251ac710992b66$export$2183c3f1b0e8f02a;
    $80251ac710992b66$export$a3bc9b8ed74fc = `Brmfbq_error`;
    $80251ac710992b66$export$314135682d277cb4 = `Brmfbq_isAlignRight`;
    $80251ac710992b66$export$2498094d90b6ac72 = `Brmfbq_isReadOnly`;
    $80251ac710992b66$export$2183c3f1b0e8f02a = `Brmfbq_isTransparentBackground`;
});
parcelRegister("hyZG6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ee55763a9a2c11a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hjUAf;
    function $2ee55763a9a2c11a$export$2e2bcd8739ae039({ ...props }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hjUAf")).default), props);
    }
});
parcelRegister("hjUAf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08e9a3f4597147b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cHapz;
    var $k5uoT;
    var $lzeFL;
    var $co1wz;
    var $4R6GH;
    var $koVbs;
    var $1p96B;
    var $DVljb;
    var $aipk9;
    var $iqIcG;
    class $08e9a3f4597147b4$export$2452ee3d2335d0d0 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isTransparentBackground: true,
                isDisabled: false,
                isActiveOnFirstRender: false,
                showClearIndicator: false
            };
        }
        componentDidMount() {
            if (!(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') && this.datePickerRef) window.addEventListener('click', this.onWindowClick);
        }
        componentWillUnmount() {
            if (!(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition')) window.removeEventListener('click', this.onWindowClick);
        }
        render() {
            const { isTransparentBackground: isTransparentBackground, onToggle: onToggle, onChange: onChange, isDisabled: isDisabled, isActiveOnFirstRender: isActiveOnFirstRender, showClearIndicator: showClearIndicator, styles: styles, placeholder: placeholder, weekStartDay: weekStartDay, ariaLabel: ariaLabel, formatOption: formatOption, locale: locale, intl: intl, ...props } = this.props;
            const selectProps = {
                ref: this.selectRef,
                isSearchable: isActiveOnFirstRender,
                styles: {
                    ...styles,
                    menuPortal: (styles)=>({
                            ...styles,
                            ...(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? {
                                zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
                                marginTop: `calc(${"var(--ds-space-negative-100, -8px)"} - ${"var(--ds-space-400, 32px)"})`
                            } : {}
                        }),
                    control: (styles, state)=>(0, (0, parcelRequire("iqIcG")).injectMouseOverStyles)(styles, true, state.isFocused, !!isTransparentBackground)
                },
                ...(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? {
                    menuPortalTarget: document.body
                } : {}
            };
            const appearance = isTransparentBackground ? 'subtle' : 'default';
            const placeholderString = isDisabled || placeholder === '' ? ' ' : placeholder;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHapz")).default), {
                ...props,
                hideIcon: props.hideIcon || !showClearIndicator,
                isDisabled: isDisabled,
                onFocus: ()=>{
                    onToggle && onToggle(true);
                },
                onBlur: ()=>{
                    onToggle && onToggle(false);
                },
                appearance: appearance,
                onChange: onChange,
                selectProps: selectProps,
                ref: this.datePickerRef,
                placeholder: placeholderString,
                weekStartDay: weekStartDay ?? 0,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jira-portfolio-3-portfolio-a11y-label-part-1') && {
                    label: ariaLabel
                },
                locale: locale && (0, (0, parcelRequire("lzeFL")).standardizeLocale)(locale),
                ...(0, (0, parcelRequire("4R6GH")).fg)('jira-portfolio-3-portfolio-a11y-label-part-1') ? {
                    formatDisplayLabel: intl ? (date)=>(0, (0, parcelRequire("aipk9")).formatDateWithIntl)(intl, date, formatOption) : undefined
                } : {
                    formatDisplayLabel: intl ? (date)=>(0, (0, parcelRequire("aipk9")).formatDateWithIntl)(intl, date) : undefined
                }
            }));
        }
        constructor(...args){
            super(...args);
            this.selectRef = (0, $5uXOq.createRef)();
            this.datePickerRef = (0, $5uXOq.createRef)();
            this.onWindowClick = (e)=>{
                const datePicker = this.datePickerRef.current;
                const node = e.target;
                if (datePicker && datePicker.state.isOpen && !datePicker.containerRef.contains(node) && document.body && document.body.contains(node)) datePicker.onSelectBlur(e);
            };
        }
    }
    function $08e9a3f4597147b4$export$2e2bcd8739ae039(props) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const weekStartDay = (0, (0, parcelRequire("1p96B")).getLocale)(locale)?.options?.weekStartsOn || 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($08e9a3f4597147b4$export$2452ee3d2335d0d0, {
            ...props,
            weekStartDay: weekStartDay,
            intl: intl,
            locale: locale
        });
    }
});
parcelRegister("cHapz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a844b50b385d50f7$export$2e2bcd8739ae039);
    var $VSDnB;
    var $cKsfY;
    var $2TI0z;
    var $jcbUF;
    const $a844b50b385d50f7$var$DatePicker = (0, (0, parcelRequire("cKsfY")).componentWithCondition)(()=>(0, (0, parcelRequire("VSDnB")).fg)('dst-date-picker-use-functional-component'), (0, (0, parcelRequire("jcbUF")).default), (0, (0, parcelRequire("2TI0z")).default));
    var $a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;
});
parcelRegister("cKsfY", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$8f027f90da2b6bac$export$6e8ea24b15199873);
    var $5uXOq = parcelRequire("5uXOq");
    function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $5uXOq.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("2TI0z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19201d0a1f7d7d54$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $9KnKW;
    var $acknU;
    var $cTemL;
    var $7qZ1x;
    var $VSDnB;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $7K5PP;
    var $7VXAu;
    var $jldZL;
    var $jHBnA;
    var $5RLF6;
    var $iaQLg;
    var $gtijU;
    var $6AqCE;
    var $dBs4v;
    function $19201d0a1f7d7d54$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
    const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
    const $19201d0a1f7d7d54$var$dropdownIndicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $19201d0a1f7d7d54$var$CalendarIcon = (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("acknU"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cTemL")))));
    const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
        defaultIsOpen: false,
        defaultValue: '',
        disabled: [],
        disabledDateFilter: (_)=>false,
        locale: 'en-US',
        onBlur: (_event)=>{},
        onChange: (_value)=>{},
        onFocus: (_event)=>{}
    };
    const $19201d0a1f7d7d54$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $19201d0a1f7d7d54$var$iconContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        insetBlockStart: 0,
        insetInlineEnd: 0,
        transition: `color 150ms`,
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        }
    });
    const $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles = {
        name: "jd0mtf",
        styles: "margin-inline-end:var(--ds-space-400, 2rem)"
    };
    const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew = {
        name: "129q61y",
        styles: "margin-inline-end:var(--ds-space-050, 0.25rem)"
    };
    const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles = {
        name: "sz3drw",
        styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
    };
    const $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $19201d0a1f7d7d54$var$calendarButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
        }
        constructor(props){
            super(props);
            this.containerRef = null;
            this.calendarRef = (0, $5uXOq.createRef)();
            this.calendarButtonRef = (0, $5uXOq.createRef)();
            this.getValue = ()=>this.props.value ?? this.state.value;
            this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen;
            this.onCalendarChange = ({ iso: iso })=>{
                this.setState({
                    calendarValue: (0, (0, parcelRequire("5RLF6")).getParsedISO)({
                        iso: iso
                    })
                });
            };
            this.onCalendarSelect = ({ iso: iso })=>{
                this.setState({
                    selectInputValue: '',
                    isOpen: false,
                    calendarValue: iso,
                    value: iso,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onChange(iso);
                if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                this.setState({
                    isOpen: false
                });
            };
            this.onInputClick = ()=>{
                if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onContainerBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (!this.containerRef?.contains(newlyFocusedElement)) {
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    this.props.onBlur(event);
                }
            };
            this.onContainerFocus = ()=>{
                this.setState({
                    shouldSetFocusOnCurrentDay: false
                });
            };
            this.onSelectBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (this.state.clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else if (!this.containerRef?.contains(newlyFocusedElement)) this.setState({
                    isOpen: false,
                    isFocused: false,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onSelectFocus = (event)=>{
                const { clearingFromIcon: clearingFromIcon } = this.state;
                const value = this.getValue();
                if (clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else this.setState({
                    isOpen: !this.props.shouldShowCalendarButton,
                    calendarValue: value,
                    isFocused: true,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onFocus(event);
            };
            this.onTextInput = (event)=>{
                const inputValue = event.target.value;
                if (inputValue) {
                    const parsed = (0, (0, parcelRequire("5RLF6")).parseDate)(inputValue, {
                        parseInputValue: this.props.parseInputValue,
                        dateFormat: this.props.dateFormat,
                        l10n: this.state.l10n
                    });
                    if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) this.setState({
                        calendarValue: (0, (0, parcelRequire("6AqCE")).getShortISOString)(parsed)
                    });
                }
                this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onInputKeyDown = (event)=>{
                const { calendarValue: calendarValue } = this.state;
                const value = this.getValue();
                const keyPressed = event.key.toLowerCase();
                if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
                switch(keyPressed){
                    case 'escape':
                        if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                        else {
                            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                            innerCombobox?.focus();
                        }
                        this.setState({
                            isOpen: false,
                            shouldSetFocusOnCurrentDay: false,
                            wasOpenedFromCalendarButton: false
                        });
                        break;
                    case 'backspace':
                    case 'delete':
                        {
                            const inputCount = 0;
                            if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) this.setState({
                                clearingFromIcon: false,
                                value: ''
                            });
                            break;
                        }
                    case 'enter':
                        if (!this.state.isOpen) return;
                        event.preventDefault();
                        if (!(0, (0, parcelRequire("5RLF6")).isDateDisabled)(calendarValue, {
                            disabled: this.props.disabled
                        })) {
                            const safeCalendarValue = (0, (0, parcelRequire("6AqCE")).getSafeCalendarValue)(calendarValue);
                            const valueChanged = safeCalendarValue !== value;
                            this.setState({
                                selectInputValue: '',
                                isOpen: false,
                                value: safeCalendarValue,
                                calendarValue: safeCalendarValue,
                                wasOpenedFromCalendarButton: false
                            });
                            if (valueChanged) this.props.onChange(safeCalendarValue);
                        }
                        break;
                    case 'arrowdown':
                    case 'arrowup':
                        if (this.state.isOpen && !this.state.shouldSetFocusOnCurrentDay) this.setState({
                            shouldSetFocusOnCurrentDay: true
                        });
                        break;
                    default:
                        break;
                }
            };
            this.onCalendarButtonKeyDown = (e)=>{
                if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                    e.stopPropagation();
                    this.setState({
                        isKeyDown: true,
                        wasOpenedFromCalendarButton: true
                    });
                }
            };
            this.onCalendarButtonClick = (e)=>{
                this.setState({
                    isOpen: !this.state.isOpen,
                    wasOpenedFromCalendarButton: true
                }, ()=>{
                    if (!this.state.isKeyDown) return;
                    this.setState({
                        isKeyDown: false
                    });
                    this.calendarRef?.current?.querySelector('button')?.focus();
                });
                e.stopPropagation();
            };
            this.onClear = ()=>{
                let changedState = {
                    value: '',
                    calendarValue: this.props.defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date())
                };
                if (!this.props.hideIcon) changedState = {
                    ...changedState,
                    clearingFromIcon: true
                };
                this.setState(changedState);
                this.props.onChange('');
            };
            this.onSelectChange = (_value, action)=>{
                if (action.action === 'clear') this.onClear();
            };
            this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
                const onInputChange = this.props.selectProps?.onInputChange;
                if (onInputChange) onInputChange(selectInputValue, actionMeta);
                this.setState({
                    selectInputValue: selectInputValue
                });
            };
            this.getContainerRef = (ref)=>{
                const oldRef = this.containerRef;
                this.containerRef = ref;
                if (oldRef == null && ref != null) this.forceUpdate();
            };
            this.state = {
                isKeyDown: false,
                isOpen: this.props.defaultIsOpen,
                isFocused: false,
                clearingFromIcon: false,
                selectInputValue: this.props.selectProps?.inputValue || '',
                value: this.props.value || this.props.defaultValue,
                calendarValue: this.props.value || this.props.defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()),
                l10n: (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(this.props.locale),
                locale: this.props.locale,
                shouldSetFocusOnCurrentDay: false,
                wasOpenedFromCalendarButton: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.locale !== prevState.locale) return {
                l10n: (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(nextProps.locale),
                locale: nextProps.locale
            };
            else return null;
        }
        render() {
            const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = $19201d0a1f7d7d54$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
            const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
            const value = this.getValue();
            let actualSelectInputValue;
            actualSelectInputValue = selectInputValue;
            const menuIsOpen = this.getIsOpen() && !isDisabled;
            const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
            let clearIndicator = Icon;
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $19201d0a1f7d7d54$var$dropdownIndicatorStyles
                }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
            const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
            const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
                lang: this.props.locale
            });
            const selectComponents = {
                DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("jHBnA")).EmptyComponent) : dropDownIcon,
                ...shouldShowCalendarButton ? {
                    IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iaQLg")).IndicatorsContainer), {
                            ...props,
                            showClearIndicator: showClearIndicator
                        })
                } : {},
                Menu: (0, parcelRequire("gtijU")).Menu,
                SingleValue: SingleValue,
                ...!showClearIndicator && {
                    ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
                }
            };
            const { styles: selectStyles = {} } = selectProps;
            const disabledStyle = isDisabled ? {
                pointerEvents: 'none',
                color: "var(--ds-icon-disabled, inherit)"
            } : {};
            const calendarProps = {
                calendarContainerRef: this.containerRef,
                calendarDisabled: disabled,
                calendarDisabledDateFilter: disabledDateFilter,
                calendarMaxDate: maxDate,
                calendarMinDate: minDate,
                calendarRef: this.calendarRef,
                calendarValue: value && (0, (0, parcelRequire("6AqCE")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(value)),
                calendarView: calendarValue,
                onCalendarChange: this.onCalendarChange,
                onCalendarSelect: this.onCalendarSelect,
                calendarLocale: locale,
                calendarWeekStartDay: weekStartDay,
                shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
            };
            const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
                control: (base)=>({
                        ...base,
                        ...disabledStyle
                    }),
                indicatorsContainer: (base)=>({
                        ...base,
                        paddingLeft: "var(--ds-space-025, 2px)",
                        paddingRight: "var(--ds-space-075, 6px)"
                    })
            });
            const initialValue = value ? {
                label: (0, (0, parcelRequire("5RLF6")).formatDate)(value, {
                    formatDisplayLabel: this.props.formatDisplayLabel,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }),
                value: value
            } : null;
            const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...innerProps,
                css: $19201d0a1f7d7d54$var$pickerContainerStyles,
                role: "presentation",
                onBlur: this.onContainerBlur,
                onFocus: this.onContainerFocus,
                onClick: this.onInputClick,
                onInput: this.onTextInput,
                onKeyDown: this.onInputKeyDown,
                ref: this.getContainerRef,
                "data-testid": testId && `${testId}--container`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7K5PP")).default), {
                appearance: this.props.appearance,
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                components: selectComponents,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: this.onSelectBlur,
                onChange: this.onSelectChange,
                onFocus: this.onSelectFocus,
                onInputChange: this.handleSelectInputChange,
                placeholder: (0, (0, parcelRequire("5RLF6")).getPlaceholder)({
                    placeholder: this.props.placeholder,
                    l10n: this.state.l10n
                }),
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
            }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9KnKW")).IdProvider), {
                prefix: "open-calendar-label--"
            }, ({ id: openCalendarLabelId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: [
                        $19201d0a1f7d7d54$var$iconContainerStyles,
                        value && !hideIcon ? $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew : $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles
                    ]
                }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
                    id: openCalendarLabelId
                }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
                    ...inputLabelId ? {
                        'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
                    } : {
                        'aria-label': fullopenCalendarLabel
                    },
                    onClick: this.onCalendarButtonClick,
                    onKeyDown: this.onCalendarButtonKeyDown,
                    ref: this.calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`,
                    type: "button",
                    backgroundColor: "color.background.neutral.subtle",
                    padding: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
                    xcss: [
                        $19201d0a1f7d7d54$var$calendarButtonStyles,
                        (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') && $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles
                    ]
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($19201d0a1f7d7d54$var$CalendarIcon, {
                    label: "",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                        color: "var(--ds-icon, #44546F)"
                    } : {
                        primaryColor: "var(--ds-icon, #44546F)"
                    }
                })))) : null));
        }
    }
    const $19201d0a1f7d7d54$var$DatePicker = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'datePicker',
        packageName: $19201d0a1f7d7d54$var$packageName,
        packageVersion: $19201d0a1f7d7d54$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: (0, (0, parcelRequire("gB4mS")).default)('atlaskit')({
            action: 'selectedDate',
            actionSubject: 'datePicker',
            attributes: {
                componentName: 'datePicker',
                packageName: $19201d0a1f7d7d54$var$packageName,
                packageVersion: $19201d0a1f7d7d54$var$packageVersion
            }
        })
    })($19201d0a1f7d7d54$export$df43d21f5faca9f7));
    var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;
});
parcelRegister("acknU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));
    var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
    function $76cad653a4883392$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $76cad653a4883392$var$CalendarIcon = (props)=>$76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
            LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
        }, props));
    $76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
    var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;
});
parcelRegister("3fesp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $25cdfcb8bb836404$var$_UNSAFE_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25cdfcb8bb836404$var$CalendarIcon = (props)=>$25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
        }, props));
    $25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
    var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;
});
parcelRegister("cTemL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
    function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9625c3edd02eaf26$var$CalendarIcon = (props)=>$9625c3edd02eaf26$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
        }, props, {
            newIcon: $9625c3edd02eaf26$var$_calendar.default
        }));
    $9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
    var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;
});
parcelRegister("7qZ1x", function(module, exports) {
    $parcel$export(module.exports, "createLocalizationProvider", ()=>$71bdd27445bf5301$export$ea56ca58f08ffa52);
    var $lCAti;
    var $is0Fy;
    var $1cWOp;
    const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
        const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
                hour: 'numeric',
                minute: 'numeric'
            }).format(date);
        const getDays = (weekStartDay = 0, length)=>{
            const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
                weekday: length
            });
            const weekdays = [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
            const rotatedWeekdays = weekStartDay > 0 ? [
                ...weekdays.slice(weekStartDay),
                ...weekdays.slice(0, weekStartDay)
            ] : weekdays;
            return rotatedWeekdays.map((day)=>{
                const result = dayFormatter.format(new Date(2000, 9, day + 1, 12)).replace(/[\s\u200E]/g, '');
                if (length === 'short') return result.substring(0, 3);
                else return result;
            });
        };
        const getDaysShort = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'short');
        };
        const getDaysLong = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'long');
        };
        const getMonthsLong = ()=>{
            const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
                month: 'long'
            });
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map((month)=>monthFormatter.format(new Date(2020, month, 1)));
        };
        const parseDate = (date)=>(0, (0, parcelRequire("is0Fy")).createDateParser)(normalizedLocale)(date);
        const formatToParts = (date = new Date())=>{
            const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
            const fixedDate = new Date(date);
            fixedDate.setFullYear(2020);
            const fixedParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(fixedDate));
            const originalParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(date));
            if (fixedParts.year) fixedParts.year = originalParts.year;
            if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
            return fixedParts;
        };
        return {
            getDaysShort: getDaysShort,
            getDaysLong: getDaysLong,
            getMonthsLong: getMonthsLong,
            formatDate: formatDate,
            formatTime: formatTime,
            parseDate: parseDate,
            formatToParts: formatToParts
        };
    };
});
parcelRegister("lCAti", function(module, exports) {
    $parcel$export(module.exports, "normalizeLocale", ()=>$13af55a9724edafd$export$dca0327c9b9c6498);
    const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
});
parcelRegister("is0Fy", function(module, exports) {
    $parcel$export(module.exports, "createDateParser", ()=>$d8bb223589902df4$export$cfa2ef2687faeda2);
    var $3wYKB;
    var $lCAti;
    const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
    const $d8bb223589902df4$var$INVARIANT = {
        year: 1993,
        month: 2,
        day: 18
    };
    const $d8bb223589902df4$var$INVARIANT_DATE = (0, (0, parcelRequire("3wYKB")).toDate)($d8bb223589902df4$var$INVARIANT);
    const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
    const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
    const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
    const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
        return matchResult.splice(1, 4).map((datePart)=>parseInt(datePart, 10));
    };
    const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
        const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
        const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
        const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
        if (!formatMatch) throw new Error('Unable to create DateParser');
        const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
        const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
        const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
        const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
        return (date)=>{
            const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
            if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
            const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
            const extractedDate = {
                year: dateParts[yearPosition],
                month: dateParts[monthPosition],
                day: dateParts[dayPosition]
            };
            const normalizedDate = (0, (0, parcelRequire("3wYKB")).normalizeDate)(extractedDate);
            if (!(0, (0, parcelRequire("3wYKB")).isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
            return (0, (0, parcelRequire("3wYKB")).toDate)(normalizedDate);
        };
    };
});
parcelRegister("3wYKB", function(module, exports) {
    $parcel$export(module.exports, "toDate", ()=>$121d324fc62f760d$export$e67a095c620b86fe);
    $parcel$export(module.exports, "isValid", ()=>$121d324fc62f760d$export$1ea939691cdc45b8);
    $parcel$export(module.exports, "normalizeDate", ()=>$121d324fc62f760d$export$fcc71269590ba0a8);
    const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        });
    const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>new Date(date.year, date.month - 1, date.day);
    const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    };
    const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
        if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
        return [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][month - 1];
    };
    const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
        const { year: year, month: month, day: day } = date;
        const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
        return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
    };
    const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
        const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
        const { year: year, month: month, day: day } = date;
        const fullYear = year < 100 ? 2000 + year : year;
        const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
        const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
        const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
        return {
            year: normalizedYear,
            month: normalizedMonth,
            day: normalizedDay
        };
    };
});
parcelRegister("1cWOp", function(module, exports) {
    $parcel$export(module.exports, "toFormattedParts", ()=>$56bd04270448c035$export$9b7ca29af37c192);
    const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
                ...result,
                [datePart.type]: datePart.value
            }), {});
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true,
        unstyled: false
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props);
            this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            };
            this.blockOptionHover = false;
            this.isComposing = false;
            this.initialTouchX = 0;
            this.initialTouchY = 0;
            this.openAfterFocus = false;
            this.scrollToFocusedOptionOnUpdate = false;
            this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)();
            this.controlRef = null;
            this.getControlRef = (ref)=>{
                this.controlRef = ref;
            };
            this.focusedOptionRef = null;
            this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            };
            this.menuListRef = null;
            this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            };
            this.inputRef = null;
            this.getInputRef = (ref)=>{
                this.inputRef = ref;
            };
            this.focus = this.focusInput;
            this.blur = this.blurInput;
            this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            };
            this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            };
            this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            };
            this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            };
            this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            };
            this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            };
            this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            };
            this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            };
            this.getValue = ()=>this.state.selectValue;
            this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args);
            this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            };
            this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            };
            this.getStyles = (key, props)=>{
                const { unstyled: unstyled } = this.props;
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props, unstyled);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            };
            this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
            this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            };
            this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            };
            this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue);
            this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
            this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
            this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
            this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            };
            this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            };
            this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            };
            this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            };
            this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            };
            this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            };
            this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            };
            this.onCompositionStart = ()=>{
                this.isComposing = true;
            };
            this.onCompositionEnd = ()=>{
                this.isComposing = false;
            };
            this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            };
            this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            };
            this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            };
            this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            };
            this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            };
            this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            };
            this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            };
            this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            };
            this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            };
            this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            };
            this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            };
            this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            };
            this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('safari') && !ua.includes('chrome');
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            ...unstyled ? {} : {
                padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
            }
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
                borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
                borderRadius: borderRadius,
                borderStyle: 'solid',
                borderWidth: 1,
                boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
                '&:hover': {
                    borderColor: isFocused ? colors.primary : colors.neutral30
                }
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        };
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            ...unstyled ? {} : {
                color: colors.neutral40,
                fontSize: '75%',
                fontWeight: 500,
                marginBottom: '0.25em',
                paddingLeft: spacing.baseUnit * 3,
                paddingRight: spacing.baseUnit * 3,
                textTransform: 'uppercase'
            }
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2,
                ':hover': {
                    color: isFocused ? colors.neutral80 : colors.neutral40
                }
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
                marginBottom: baseUnit * 2,
                marginTop: baseUnit * 2
            }
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2
            }
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            ...unstyled ? {} : {
                margin: spacing.baseUnit / 2,
                paddingBottom: spacing.baseUnit / 2,
                paddingTop: spacing.baseUnit / 2,
                color: colors.neutral80
            }
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral0,
                borderRadius: borderRadius,
                boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
                marginBottom: spacing.menuGutter,
                marginTop: spacing.menuGutter
            }
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            ...unstyled ? {} : {
                paddingBottom: baseUnit,
                paddingTop: baseUnit
            }
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            textAlign: 'center',
            ...unstyled ? {} : {
                color: colors.neutral40,
                padding: `${baseUnit * 2}px ${baseUnit * 3}px`
            }
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral10,
                borderRadius: borderRadius / 2,
                margin: spacing.baseUnit / 2
            }
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                color: colors.neutral80,
                fontSize: '85%',
                padding: 3,
                paddingLeft: 6
            }
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
            alignItems: 'center',
            display: 'flex',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                backgroundColor: isFocused ? colors.dangerLight : undefined,
                paddingLeft: spacing.baseUnit,
                paddingRight: spacing.baseUnit,
                ':hover': {
                    backgroundColor: colors.dangerLight,
                    color: colors.danger
                }
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            ...unstyled ? {} : {
                backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
                color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
                padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
                }
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            ...unstyled ? {} : {
                color: colors.neutral50,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                color: isDisabled ? colors.neutral40 : colors.neutral80,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("jHBnA", function(module, exports) {
    $parcel$export(module.exports, "EmptyComponent", ()=>$91948b176ea23188$export$5e30e9a24d6c1203);
    $parcel$export(module.exports, "placeholderDatetime", ()=>$91948b176ea23188$export$fff8babee5abe3e2);
    $parcel$export(module.exports, "defaultTimes", ()=>$91948b176ea23188$export$b42ffb9f09b1861b);
    $parcel$export(module.exports, "defaultTimeFormat", ()=>$91948b176ea23188$export$9e6d8fcf62256b85);
    $parcel$export(module.exports, "defaultDateFormat", ()=>$91948b176ea23188$export$75032c84f56650eb);
    $parcel$export(module.exports, "padToTwo", ()=>$91948b176ea23188$export$a7de57e5b672ccdb);
    $parcel$export(module.exports, "formatDateTimeZoneIntoIso", ()=>$91948b176ea23188$export$2eeb05a2ecc2ce0a);
    const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
    const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
    const $91948b176ea23188$export$b42ffb9f09b1861b = [
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00'
    ];
    const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
    const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
    function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
        return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
    }
    function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
        const needsLeadingZero = /^\d:/;
        const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
        return `${date}T${sanitizedTime}${zone}`;
    }
});
parcelRegister("5RLF6", function(module, exports) {
    $parcel$export(module.exports, "isDateDisabled", ()=>$e0db4b6edb7dbfac$export$d38e7e283938128c);
    $parcel$export(module.exports, "getParsedISO", ()=>$e0db4b6edb7dbfac$export$38db26406d1a1ee2);
    $parcel$export(module.exports, "parseDate", ()=>$e0db4b6edb7dbfac$export$6b862160d295c8e);
    $parcel$export(module.exports, "formatDate", ()=>$e0db4b6edb7dbfac$export$3ae94a2503e890a1);
    $parcel$export(module.exports, "getPlaceholder", ()=>$e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
    var $k7m40;
    var $5I2ju;
    var $eZDAP;
    var $2ucUe;
    var $jHBnA;
    const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
        const { disabled: disabled } = di;
        return disabled.indexOf(date) > -1;
    };
    const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
        const { iso: iso } = di;
        const [year, month, date] = iso.split('-');
        let newIso = iso;
        const parsedDate = parseInt(date, 10);
        const parsedMonth = parseInt(month, 10);
        const parsedYear = parseInt(year, 10);
        const lastDayInMonth = (0, (0, parcelRequire("5I2ju")).default)(new Date(parsedYear, parsedMonth - 1)).getDate();
        if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(lastDayInMonth)}`;
        else newIso = `${parsedYear}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedDate)}`;
        return newIso;
    };
    const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
        const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
        if (parseInputValue) return parseInputValue(date, dateFormat || (0, (0, parcelRequire("jHBnA")).defaultDateFormat));
        return l10n.parseDate(date);
    };
    const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
        const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
        if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, (0, parcelRequire("jHBnA")).defaultDateFormat));
        const date = (0, (0, parcelRequire("eZDAP")).default)(value);
        return dateFormat ? (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)(dateFormat)) : l10n.formatDate(date);
    };
    const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
        const { placeholder: placeholder, l10n: l10n } = di;
        return placeholder || l10n.formatDate((0, (0, parcelRequire("jHBnA")).placeholderDatetime));
    };
});
parcelRegister("2ucUe", function(module, exports) {
    $parcel$export(module.exports, "convertTokens", ()=>$ca6f20a476eda5dc$export$4d5430175be73d45);
    const $ca6f20a476eda5dc$var$tokensMap = {
        M: 'L',
        Mo: 'Mo',
        MM: 'LL',
        MMM: 'LLL',
        MMMM: 'LLLL',
        Q: 'q',
        Qo: 'qo',
        D: 'd',
        Do: 'do',
        DD: 'dd',
        DDD: 'D',
        DDDo: 'Do',
        DDDD: 'DDD',
        d: 'i',
        do: 'io',
        dd: 'iiiiii',
        ddd: 'iii',
        dddd: 'iiii',
        A: 'a',
        a: 'a',
        aa: 'aaaa',
        E: 'i',
        W: 'I',
        Wo: 'Io',
        WW: 'II',
        YY: 'yy',
        YYYY: 'yyyy',
        GG: 'RR',
        GGGG: 'RRRR',
        H: 'H',
        HH: 'HH',
        h: 'h',
        hh: 'hh',
        m: 'm',
        mm: 'mm',
        s: 's',
        ss: 'ss',
        S: 'S',
        SS: 'SS',
        SSS: 'SSS',
        Z: 'xxx',
        ZZ: 'xx',
        X: 't',
        x: 'T'
    };
    const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
    const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp("(\\[[^\\[]*\\])|(\\\\)?('.+'|" + $ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
    function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
        const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
        if (!tokensCaptures) return format;
        return tokensCaptures.reduce((parsed, tokenString, index)=>{
            const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
            if (!v2token) {
                const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
                if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
                else parsed.escapedTextBuffer.push(tokenString);
            }
            const endOfString = index === tokensCaptures.length - 1;
            if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
                const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
                parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
                parsed.escapedTextBuffer = [];
            }
            if (v2token) parsed.formatBuffer.push(v2token);
            return parsed;
        }, {
            formatBuffer: [],
            escapedTextBuffer: []
        }).formatBuffer.join('');
    }
});
parcelRegister("iaQLg", function(module, exports) {
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$d73476b891de3e0c$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $bChGW;
    function $d73476b891de3e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d73476b891de3e0c$var$calendarButtonInclusionStyles = {
        name: "i3e4rp",
        styles: "margin-inline-start:var(--ds-space-400, 32px)"
    };
    const $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles = {
        name: "19a3ait",
        styles: "margin-inline-start:var(--ds-space-300, 24px)"
    };
    const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: showClearIndicator ? $d73476b891de3e0c$var$calendarButtonInclusionStyles : $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorsContainer, rest));
});
parcelRegister("gtijU", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$e800a879ee1613fc$export$d9b273488cd8ce6f);
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $1f0Hs;
    var $9MHPe;
    var $k5uoT;
    var $avHVh;
    function $e800a879ee1613fc$var$getValidDate(isos) {
        return isos.reduce((acc, iso)=>{
            const date = (0, (0, parcelRequire("eZDAP")).default)(iso);
            return (0, (0, parcelRequire("jovBr")).default)(date) ? {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear()
            } : acc;
        }, {});
    }
    const $e800a879ee1613fc$var$menuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog(),
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        overflow: 'hidden'
    });
    const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
        const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
        const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
            calendarValue,
            calendarView
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avHVh")).default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $e800a879ee1613fc$var$menuStyles,
                ...innerProps
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1f0Hs")).default), {
                day: day,
                month: month,
                year: year,
                disabled: selectProps.calendarDisabled,
                disabledDateFilter: selectProps.calendarDisabledDateFilter,
                minDate: selectProps.calendarMinDate,
                maxDate: selectProps.calendarMaxDate,
                nextMonthLabel: selectProps.nextMonthLabel,
                onChange: selectProps.onCalendarChange,
                onSelect: selectProps.onCalendarSelect,
                previousMonthLabel: selectProps.previousMonthLabel,
                ref: selectProps.calendarRef,
                selected: [
                    selectProps.calendarValue
                ],
                shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                locale: selectProps.calendarLocale,
                testId: selectProps.testId && `${selectProps.testId}--calendar`,
                weekStartDay: selectProps.calendarWeekStartDay
            })),
            testId: selectProps.testId
        }));
    };
});
parcelRegister("1f0Hs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16abbcd9b9109722$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $ePz3p;
    var $lJWdi;
    var $avO9B;
    var $iioJV;
    var $jihAA;
    var $bbnGB;
    var $hbcve;
    var $2TGJ3;
    var $f9D1v;
    var $9efze;
    const $16abbcd9b9109722$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-block',
        userSelect: 'none'
    });
    const $16abbcd9b9109722$var$analyticsAttributes = {
        componentName: 'calendar',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $16abbcd9b9109722$var$InnerCalendar = (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, (0, parcelRequire("iioJV")).blankStringArray), defaultSelected: defaultSelected = (0, (0, parcelRequire("iioJV")).blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, (0, parcelRequire("eGmKJ")).default), onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), onFocus: onFocus = (0, (0, parcelRequire("eGmKJ")).default), onSelect: onSelect = (0, (0, parcelRequire("eGmKJ")).default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
        const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, (0, parcelRequire("jihAA")).default)({
            day: day,
            defaultDay: defaultDay,
            month: month,
            defaultMonth: defaultMonth,
            year: year,
            defaultYear: defaultYear,
            today: today,
            selected: selected,
            defaultSelected: defaultSelected,
            previouslySelected: previouslySelected,
            defaultPreviouslySelected: defaultPreviouslySelected
        });
        const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            ...$16abbcd9b9109722$var$analyticsAttributes
        });
        const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, (0, parcelRequire("2TGJ3")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            shouldSetFocus: [
                shouldSetFocus,
                setShouldSetFocus
            ],
            onChange: onChangeWithAnalytics
        });
        const onSelectWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onSelect,
            action: 'selected',
            analyticsData: analyticsContext,
            ...$16abbcd9b9109722$var$analyticsAttributes
        });
        const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, (0, parcelRequire("f9D1v")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                ,
                setPreviouslySelectedValue
            ],
            onSelect: onSelectWithAnalytics,
            navigate: navigate
        });
        const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, (0, parcelRequire("bbnGB")).default)({
            onFocus: onFocus,
            onBlur: onBlur
        });
        const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, (0, parcelRequire("9efze")).default)({
            locale: locale,
            weekStartDay: weekStartDay
        });
        const weeks = (0, (0, parcelRequire("hbcve")).default)({
            day: dayValue,
            month: monthValue,
            year: yearValue,
            today: todayValue,
            selected: selectedValue,
            previouslySelected: previouslySelectedValue,
            disabled: disabled,
            disabledDateFilter: disabledDateFilter,
            minDate: minDate,
            maxDate: maxDate,
            daysLong: daysLong,
            weekStartDay: weekStartDay
        });
        const getNextHeading = ()=>{
            const nextMonth = monthValue % 12;
            const showNextYear = monthValue === 12;
            return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
        };
        const getPreviousHeading = ()=>{
            const previousMonth = (monthValue + 12 - 2) % 12;
            const showPreviousYear = monthValue === 1;
            return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
        };
        const headerId = (0, (0, parcelRequire("9KnKW")).useId)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            style: style,
            onBlur: handleContainerBlur,
            onFocus: handleContainerFocus,
            "data-testid": testId && `${testId}--container`,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $16abbcd9b9109722$var$boxStyles,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ePz3p")).default), {
            monthLongTitle: monthsLong[monthValue - 1],
            year: yearValue,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel,
            nextHeading: getNextHeading(),
            previousHeading: getPreviousHeading(),
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev,
            headerId: headerId,
            tabIndex: tabIndex,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            role: "grid",
            onKeyDown: handleContainerKeyDown,
            "aria-labelledby": headerId,
            testId: testId && `${testId}--calendar-dates`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avO9B")).default), {
            daysShort: daysShort,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lJWdi")).default), {
            weeks: weeks,
            handleClickDay: handleClickDay,
            monthsLong: monthsLong,
            shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
            tabIndex: tabIndex,
            testId: testId
        })))));
    });
    const $16abbcd9b9109722$var$Calendar = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Calendar(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($16abbcd9b9109722$var$InnerCalendar, {
            ...props,
            ref: ref
        });
    }));
    $16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
    var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;
});
parcelRegister("ePz3p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$995afee12cb828f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $42CjB;
    var $9KnKW;
    var $1dJ6S;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    const $995afee12cb828f6$var$Header = (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
        const announceId = (0, (0, parcelRequire("9KnKW")).useId)();
        const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $5uXOq.useState)(false);
        const handlePrevMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickPrev(e);
        };
        const handleNextMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickNext(e);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            paddingInline: "space.100"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevMonthInteraction,
            testId: testId && `${testId}--previous-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))),
            label: `${previousMonthLabel}, ${previousHeading}`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
            id: announceId,
            testId: testId && `${testId}--current-month-year--container`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall",
            as: "h2",
            id: headerId,
            testId: testId && `${testId}--current-month-year`
        }, `${monthLongTitle} ${year}`)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextMonthInteraction,
            testId: testId && `${testId}--next-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("6s76W"))))),
            label: `${nextMonthLabel}, ${nextHeading}`
        })));
    });
    $995afee12cb828f6$var$Header.displayName = 'Header';
    var $995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("lJWdi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43f22a52ec309eeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $1q4y8;
    var $h581D;
    const $43f22a52ec309eeb$var$WeekDays = (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            role: "rowgroup",
            testId: testId && `${testId}--month`
        }, weeks.map((week, i)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("h581D")).default), {
                key: i,
                testId: testId && `${testId}--week`
            }, week.values.map((weekDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1q4y8")).default), {
                    key: `${week.id}-${weekDay.id}`,
                    isDisabled: weekDay.isDisabled,
                    isFocused: weekDay.isFocused,
                    isToday: weekDay.isToday,
                    dayLong: weekDay.weekDayName,
                    month: weekDay.month,
                    monthLong: monthsLong[weekDay.month - 1],
                    onClick: handleClickDay,
                    isPreviouslySelected: weekDay.isPreviouslySelected,
                    isSelected: weekDay.isSelected,
                    isSibling: weekDay.isSiblingMonth,
                    year: weekDay.year,
                    shouldSetFocus: shouldSetFocus,
                    tabIndex: tabIndex,
                    testId: testId
                }, weekDay.day)))));
    });
    $43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
    var $43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;
});
parcelRegister("1q4y8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d70b02566a310b79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eGmKJ;
    var $bgrar;
    var $h0WbJ;
    const $d70b02566a310b79$var$Date = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, (0, parcelRequire("eGmKJ")).default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
        const dateRef = (0, $5uXOq.useRef)({
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: day,
                month: month,
                year: year,
                isDisabled: isDisabled
            };
        }, [
            day,
            month,
            year,
            isDisabled
        ]);
        const focusRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
        }, [
            isFocused,
            shouldSetFocus
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
            if (!isDisabledValue) onClick({
                day: dayValue,
                month: monthValue,
                year: yearValue
            });
        }, [
            onClick
        ]);
        const dateCellStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("h0WbJ")).dateCellStyles)());
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bgrar")).default), {
            role: "gridcell",
            alignItems: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: dateCellStyles,
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
        }, day));
    }));
    $d70b02566a310b79$var$Date.displayName = 'Date';
    var $d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;
});
parcelRegister("h0WbJ", function(module, exports) {
    $parcel$export(module.exports, "dateCellStyles", ()=>$a52fc59169f9ec00$export$f62807af68630d86);
    const $a52fc59169f9ec00$export$f62807af68630d86 = ()=>({
            all: 'unset',
            display: 'block',
            padding: `${"var(--ds-space-050, 4px)"} 9px`,
            position: 'relative',
            backgroundColor: 'transparent',
            border: '2px solid transparent',
            borderRadius: 3,
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'pointer',
            flexGrow: 1,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            textAlign: 'center',
            '&[data-sibling]': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            },
            '&[data-today]': {
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`,
                fontWeight: "var(--ds-font-weight-bold, bold)",
                '&::after': {
                    display: 'block',
                    height: 2,
                    position: 'absolute',
                    right: "var(--ds-space-025, 2px)",
                    bottom: "var(--ds-space-025, 2px)",
                    left: "var(--ds-space-025, 2px)",
                    backgroundColor: 'currentColor',
                    content: '""'
                }
            },
            '&[data-prev-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`,
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$29a4f05edc054374})`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`,
                cursor: 'not-allowed'
            },
            '&:focus-visible': {
                border: `2px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`,
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&:active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&[data-selected]:hover': {
                backgroundColor: `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-prev-selected]:hover': {
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-sibling]:hover': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            },
            '&[data-disabled]:hover': {
                backgroundColor: 'transparent',
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`
            }
        });
});
parcelRegister("h581D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c8aba25f4ae00ff$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $bgrar;
    const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
        const row = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bgrar")).default), {
            testId: testId,
            templateColumns: "repeat(7, minmax(max-content, 1fr))",
            role: "row"
        }, children);
        return isHidden ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-hidden": "true"
        }, row) : row;
    };
    var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;
});
parcelRegister("avO9B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f29b1b1295ce3a84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $h581D;
    const $f29b1b1295ce3a84$var$columnHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: 'size.400',
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'center'
    });
    const $f29b1b1295ce3a84$var$WeekHeader = (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("h581D")).default), {
            isHidden: true,
            testId: testId && `${testId}--column-headers`
        }, daysShort.map((shortDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$columnHeaderStyles,
                key: shortDay,
                role: "columnheader",
                testId: testId && `${testId}--column-header`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                weight: "bold",
                size: "UNSAFE_small",
                align: "center",
                color: "color.text.subtle"
            }, shortDay))));
    });
    $f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
    var $f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;
});
parcelRegister("iioJV", function(module, exports) {
    $parcel$export(module.exports, "arrowKeys", ()=>$85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
    $parcel$export(module.exports, "daysPerWeek", ()=>$85c2ac8e9452c4bf$export$3ae905d9742bef55);
    $parcel$export(module.exports, "monthsPerYear", ()=>$85c2ac8e9452c4bf$export$c9b7c010035d60c6);
    $parcel$export(module.exports, "blankStringArray", ()=>$85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
    const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
        ArrowDown: 'down',
        ArrowLeft: 'left',
        ArrowRight: 'right',
        ArrowUp: 'up'
    };
    const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
    const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
    const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];
});
parcelRegister("jihAA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$654a69afe715a212$export$2e2bcd8739ae039);
    var $33etG;
    var $f8qry;
    var $3EtUb;
    function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
        const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, (0, parcelRequire("f8qry")).default)(()=>{
            const now = new Date();
            const thisDay = now.getDate();
            const thisMonth = now.getMonth() + 1;
            const thisYear = now.getFullYear();
            return {
                thisDay: thisDay,
                thisMonth: thisMonth,
                thisYear: thisYear
            };
        });
        const [dayValue, setDayValue] = (0, (0, parcelRequire("33etG")).default)(day, ()=>defaultDay || thisDay);
        const [monthValue, setMonthValue] = (0, (0, parcelRequire("33etG")).default)(month, ()=>defaultMonth || thisMonth);
        const [yearValue, setYearValue] = (0, (0, parcelRequire("33etG")).default)(year, ()=>defaultYear || thisYear);
        const [todayValue] = (0, (0, parcelRequire("33etG")).default)(today, ()=>today || `${thisYear}-${(0, (0, parcelRequire("3EtUb")).default)(thisMonth)}-${(0, (0, parcelRequire("3EtUb")).default)(thisDay)}`);
        const [selectedValue, setSelectedValue] = (0, (0, parcelRequire("33etG")).default)(selected, ()=>defaultSelected);
        const [previouslySelectedValue, setPreviouslySelectedValue] = (0, (0, parcelRequire("33etG")).default)(previouslySelected, ()=>defaultPreviouslySelected);
        return {
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            today: [
                todayValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                previouslySelectedValue,
                setPreviouslySelectedValue
            ]
        };
    }
});
parcelRegister("3EtUb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd804e1790f6d755$export$2e2bcd8739ae039);
    function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
        return num < 10 ? `0${num}` : `${num}`;
    }
});
parcelRegister("bbnGB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ccb38b64bb63461$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
        const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur(event);
        }, [
            onBlur
        ]);
        const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
            onFocus(event);
        }, [
            onFocus
        ]);
        return {
            handleContainerBlur: handleContainerBlur,
            handleContainerFocus: handleContainerFocus
        };
    }
});
parcelRegister("hbcve", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fe53b5f3382c02e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZDAP;
    var $iioJV;
    var $6ASl9;
    var $5wbTt;
    function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
        const shouldDisplaySixthWeek = calendar.length % 6;
        const calendarLastValue = calendar[calendar.length - 1];
        return (0, $5uXOq.useMemo)(()=>{
            if (shouldDisplaySixthWeek) {
                const lastDayIsSibling = calendarLastValue.siblingMonth;
                const sliceStart = lastDayIsSibling ? (0, (0, parcelRequire("iioJV")).daysPerWeek) : 0;
                return (0, (0, parcelRequire("5wbTt")).default)(year, month, {
                    weekStartDay: weekStartDay
                }).slice(sliceStart, sliceStart + (0, (0, parcelRequire("iioJV")).daysPerWeek)).map((date)=>({
                        ...date,
                        siblingMonth: true
                    }));
            }
        }, [
            calendarLastValue,
            month,
            shouldDisplaySixthWeek,
            weekStartDay,
            year
        ]);
    }
    function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
        const calendar = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("5wbTt")).default)(year, month - 1, {
                weekStartDay: weekStartDay
            }), [
            month,
            weekStartDay,
            year
        ]);
        const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
            month: month,
            year: year,
            weekStartDay: weekStartDay
        });
        if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
        const minDate = minDateString ? (0, (0, parcelRequire("eZDAP")).default)(minDateString) : undefined;
        const maxDate = maxDateString ? (0, (0, parcelRequire("eZDAP")).default)(maxDateString) : undefined;
        const needJsDate = minDateString || maxDateString;
        return (0, $5uXOq.useMemo)(()=>{
            const weeks = [];
            calendar.forEach((date)=>{
                const dateAsString = (0, (0, parcelRequire("6ASl9")).default)(date, {
                    fixMonth: true
                });
                const JSDate = needJsDate ? (0, (0, parcelRequire("eZDAP")).default)(dateAsString) : undefined;
                let week;
                if (date.weekDay === weekStartDay) {
                    week = {
                        id: dateAsString,
                        values: []
                    };
                    weeks.push(week);
                } else week = weeks[weeks.length - 1];
                const weekDayOffset = (date.weekDay - weekStartDay) % 7;
                const weekDayName = daysLong[weekDayOffset];
                const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
                const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
                const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
                const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
                const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
                const isFocused = day === date.day && !date.siblingMonth;
                const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
                const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
                const isSiblingMonth = !!date.siblingMonth;
                const isToday = today === dateAsString;
                week.values.push({
                    id: dateAsString,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isToday: isToday,
                    month: date.month + 1,
                    isPreviouslySelected: isPreviouslySelected,
                    isSelected: isSelected,
                    isSiblingMonth: isSiblingMonth,
                    year: date.year,
                    day: date.day,
                    weekDayName: weekDayName
                });
            });
            return weeks;
        }, [
            calendar,
            day,
            disabled,
            disabledDateFilter,
            minDate,
            maxDate,
            needJsDate,
            previouslySelected,
            selected,
            today,
            weekStartDay,
            daysLong
        ]);
    }
});
parcelRegister("6ASl9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6ae62fd51c4538f$export$2e2bcd8739ae039);
    var $3EtUb;
    function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
        return `${date.year}-${(0, (0, parcelRequire("3EtUb")).default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, (0, parcelRequire("3EtUb")).default)(date.day)}`;
    }
});
parcelRegister("5wbTt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3dff1ed1384abe91$export$2e2bcd8739ae039);
    var $iioJV;
    var $9Zmg7;
    function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
        weekStartDay: 0
    }) {
        const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        const utcYear = date.getUTCFullYear();
        const utcMonth = date.getUTCMonth();
        const calendar = [];
        const firstDay = date.getUTCDay();
        const firstDate = -(((0, (0, parcelRequire("iioJV")).daysPerWeek) - weekStartDay + firstDay) % (0, (0, parcelRequire("iioJV")).daysPerWeek));
        const lastDate = (0, (0, parcelRequire("9Zmg7")).default)(utcYear, utcMonth);
        const lastDay = (lastDate - firstDate) % (0, (0, parcelRequire("iioJV")).daysPerWeek);
        const lastDateOfPreviousMonth = (0, (0, parcelRequire("9Zmg7")).default)(utcYear, utcMonth - 1);
        let dateCounter = firstDate;
        let currentDay;
        let currentDate;
        let currentDateObject = null;
        let calculatedMonth;
        let calculatedYear;
        const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, (0, parcelRequire("iioJV")).daysPerWeek) - lastDay : 0) + firstDate;
        while(dateCounter < maxDateCount){
            currentDate = dateCounter + 1;
            currentDay = ((dateCounter < 1 ? (0, (0, parcelRequire("iioJV")).daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, (0, parcelRequire("iioJV")).daysPerWeek);
            if (currentDate < 1 || currentDate > lastDate) {
                if (currentDate < 1) {
                    calculatedMonth = utcMonth - 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth < 0) {
                        calculatedMonth = (0, (0, parcelRequire("iioJV")).monthsPerYear) - 1;
                        calculatedYear--;
                    }
                    currentDate = lastDateOfPreviousMonth + currentDate;
                } else if (currentDate > lastDate) {
                    calculatedMonth = utcMonth + 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth > (0, (0, parcelRequire("iioJV")).monthsPerYear) - 1) {
                        calculatedMonth = 0;
                        calculatedYear++;
                    }
                    currentDate = dateCounter - lastDate + 1;
                }
                if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                    day: currentDate,
                    weekDay: currentDay,
                    month: calculatedMonth,
                    year: calculatedYear,
                    siblingMonth: true
                };
            } else currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: utcMonth,
                year: utcYear
            };
            calendar.push(currentDateObject);
            dateCounter++;
        }
        return calendar;
    }
});
parcelRegister("9Zmg7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$878800070b837d93$export$2e2bcd8739ae039);
    function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
        return new Date(year, month + 1, 0).getDate();
    }
});
parcelRegister("2TGJ3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$caae4eff24f6e8d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iioJV;
    var $6ASl9;
    var $9Zmg7;
    const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === (0, (0, parcelRequire("iioJV")).monthsPerYear)) {
            month = 1;
            year += 1;
        } else month += 1;
        return {
            month: month,
            year: year
        };
    };
    const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === 1) {
            month = (0, (0, parcelRequire("iioJV")).monthsPerYear);
            year -= 1;
        } else month -= 1;
        return {
            month: month,
            year: year
        };
    };
    function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
            const iso = (0, (0, parcelRequire("6ASl9")).default)({
                year: year,
                month: month,
                day: day
            });
            const isFocusableType = [
                'up',
                'down',
                'left',
                'right'
            ].includes(type);
            onChange({
                day: day,
                month: month,
                year: year,
                iso: iso,
                type: type
            });
            setDayValue(day);
            setMonthValue(month);
            setYearValue(year);
            setShouldSetFocus(isFocusableType);
        }, [
            onChange,
            setDayValue,
            setMonthValue,
            setYearValue,
            setShouldSetFocus
        ]);
        const navigate = (0, $5uXOq.useCallback)((type)=>{
            const { day: day, month: month, year: year } = dateRef.current;
            if (type === 'down') {
                const next = day + (0, (0, parcelRequire("iioJV")).daysPerWeek);
                const daysInMonth = (0, (0, parcelRequire("9Zmg7")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: next - daysInMonth,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'left') {
                const prev = day - 1;
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("9Zmg7")).default)(prevYear, prevMonth - 1);
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            } else if (type === 'right') {
                const next = day + 1;
                const daysInMonth = (0, (0, parcelRequire("9Zmg7")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: 1,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'up') {
                const prev = day - (0, (0, parcelRequire("iioJV")).daysPerWeek);
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("9Zmg7")).default)(prevYear, prevMonth - 1) + prev;
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            }
        }, [
            triggerOnChange
        ]);
        const handleClickNext = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'next'
            });
        }, [
            triggerOnChange
        ]);
        const handleClickPrev = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'prev'
            });
        }, [
            triggerOnChange
        ]);
        return {
            navigate: navigate,
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev
        };
    }
});
parcelRegister("f9D1v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42ec54640e7b9de4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iioJV;
    var $6ASl9;
    function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            const iso = (0, (0, parcelRequire("6ASl9")).default)({
                year: year,
                month: month,
                day: day
            });
            onSelect({
                day: day,
                month: month,
                year: year,
                iso: iso
            });
            setPreviouslySelectedValue(selectedValue);
            setSelectedValue([
                iso
            ]);
        }, [
            onSelect,
            selectedValue,
            setPreviouslySelectedValue,
            setSelectedValue
        ]);
        const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            triggerOnSelect({
                year: year,
                month: month,
                day: day
            });
        }, [
            triggerOnSelect
        ]);
        const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
            const { key: key } = e;
            const arrowKey = (0, (0, parcelRequire("iioJV")).arrowKeys)[key];
            if (key === 'Enter' || key === ' ') {
                e.preventDefault();
                triggerOnSelect(dateRef.current);
            } else if (arrowKey) {
                e.preventDefault();
                navigate(arrowKey);
            }
        }, [
            triggerOnSelect,
            navigate
        ]);
        return {
            handleClickDay: handleClickDay,
            handleContainerKeyDown: handleContainerKeyDown
        };
    }
});
parcelRegister("9efze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbd6f430b06675a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7qZ1x;
    function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
        const l10n = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(locale), [
            locale
        ]);
        const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
            l10n
        ]);
        const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        return {
            monthsLong: monthsLong,
            daysShort: daysShort,
            daysLong: daysLong
        };
    }
});
parcelRegister("avHVh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac07968b7cb494a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $5owSH;
    var $gkD4s;
    var $4oNEb;
    var $1V7PR;
    var $k5uoT;
    class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            if (prevProps.inputValue !== this.props.inputValue) this.update();
        }
        render() {
            const { containerRef: containerRef, content: content, testId: testId } = this.props;
            if (!containerRef) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null);
            const divStyles = {
                background: 'transparent',
                position: 'absolute',
                top: 0,
                height: containerRef.getBoundingClientRect().height,
                width: containerRef.getBoundingClientRect().width - parseInt((0, (0, parcelRequire("5owSH")).sizes).small.slice(0, -2)) - (0, (0, parcelRequire("k5uoT")).gridSize)()
            };
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gkD4s")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1V7PR")).Reference), null, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    "data-layer-child": true,
                    style: divStyles
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), null, ({ ref: ref, style: style, update: update })=>{
                this.update = update;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    style: {
                        ...style,
                        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog()
                    },
                    "data-testid": testId && `${testId}--popper--container`
                }, content);
            })));
        }
        constructor(...args){
            super(...args);
            this.update = (0, (0, parcelRequire("eGmKJ")).default);
        }
    }
});
parcelRegister("6AqCE", function(module, exports) {
    $parcel$export(module.exports, "getShortISOString", ()=>$caee16c105163c22$export$77d5bc49fed7ef14);
    $parcel$export(module.exports, "getSafeCalendarValue", ()=>$caee16c105163c22$export$ff525416014fb67d);
    var $k7m40;
    var $2ucUe;
    function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
        return (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)('YYYY-MM-DD'));
    }
    function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
        const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
        if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
        return calendarValue;
    }
});
parcelRegister("dBs4v", function(module, exports) {
    $parcel$export(module.exports, "makeSingleValue", ()=>$9661917c82165ad2$export$6e30bf8cb1347b56);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).SingleValue, {
                ...rest,
                className: className,
                clearValue: clearValue,
                cx: cx,
                data: data,
                getStyles: getStyles,
                getValue: getValue,
                hasValue: hasValue,
                innerProps: {
                    lang: lang
                },
                isDisabled: isDisabled,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: selectProps,
                setValue: setValue,
                theme: theme
            }, children);
        };
});
parcelRegister("jcbUF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48f5b21daaca02ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $6QvkM;
    var $9KnKW;
    var $acknU;
    var $cTemL;
    var $7qZ1x;
    var $VSDnB;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $7K5PP;
    var $7VXAu;
    var $jldZL;
    var $jHBnA;
    var $5RLF6;
    var $iaQLg;
    var $gtijU;
    var $6AqCE;
    var $dBs4v;
    function $48f5b21daaca02ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48f5b21daaca02ab$var$packageName = "platform-pkg";
    const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
    const $48f5b21daaca02ab$var$analyticsAttributes = {
        componentName: 'datePicker',
        packageName: $48f5b21daaca02ab$var$packageName,
        packageVersion: $48f5b21daaca02ab$var$packageVersion
    };
    const $48f5b21daaca02ab$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $48f5b21daaca02ab$var$dropdownIndicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $48f5b21daaca02ab$var$CalendarIcon = (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("acknU"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cTemL")))));
    const $48f5b21daaca02ab$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: 'color.text.subtlest',
        insetBlockStart: 'space.0',
        insetInlineEnd: 'space.0',
        transition: `color 150ms`,
        ':hover': {
            color: 'color.text.subtle'
        }
    });
    const $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.400'
    });
    const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.050'
    });
    const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.025'
    });
    const $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $48f5b21daaca02ab$var$calendarButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $48f5b21daaca02ab$var$DatePicker = (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const calendarRef = (0, $5uXOq.useRef)(null);
        const calendarButtonRef = (0, $5uXOq.useRef)(null);
        const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = $48f5b21daaca02ab$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const [_, setIsFocused] = (0, $5uXOq.useState)(false);
        const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
        const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
        const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
        const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()));
        const [l10n, setL10n] = (0, $5uXOq.useState)((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(propLocale));
        const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
        const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
        const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
        const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
        const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
        const onChangePropWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChangeProp,
            action: 'selectedDate',
            actionSubject: 'datePicker',
            ...$48f5b21daaca02ab$var$analyticsAttributes
        });
        if (propLocale !== locale) {
            setL10n((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(propLocale));
            setLocale(propLocale);
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!isKeyDown) return;
            if (isOpen && wasOpenedFromCalendarButton) {
                setIsKeyDown(false);
                calendarRef?.current?.querySelector('button')?.focus();
            }
        }, [
            isKeyDown,
            calendarRef,
            isOpen,
            wasOpenedFromCalendarButton
        ]);
        const getValue = ()=>propValue ?? value;
        const getIsOpen = ()=>isOpenProp ?? isOpen;
        const onCalendarChange = ({ iso: iso })=>{
            setCalendarValue((0, (0, parcelRequire("5RLF6")).getParsedISO)({
                iso: iso
            }));
        };
        const onCalendarSelect = ({ iso: iso })=>{
            setSelectInputValue('');
            setIsOpen(false);
            setCalendarValue(iso);
            setValue(iso);
            setWasOpenedFromCalendarButton(false);
            onChangePropWithAnalytics(iso);
            if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
            else {
                const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            setIsOpen(false);
        };
        const onInputClick = ()=>{
            if (!isDisabled && !getIsOpen()) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                onBlur(event);
            }
        };
        const onContainerFocus = ()=>{
            setShouldSetFocusOnCurrentDay(false);
        };
        const onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (clearingFromIcon) setClearingFromIcon(false);
            else if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setIsFocused(false);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onSelectFocus = (event)=>{
            const value = getValue();
            if (clearingFromIcon) setClearingFromIcon(false);
            else {
                setIsOpen(!shouldShowCalendarButton);
                setCalendarValue(value);
                setIsFocused(true);
                setWasOpenedFromCalendarButton(false);
            }
            onFocus(event);
        };
        const onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, (0, parcelRequire("5RLF6")).parseDate)(inputValue, {
                    parseInputValue: rest?.parseInputValue,
                    dateFormat: rest?.dateFormat,
                    l10n: l10n
                });
                if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) setCalendarValue((0, (0, parcelRequire("6AqCE")).getShortISOString)(parsed));
            }
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        };
        const onInputKeyDown = (event)=>{
            const value = getValue();
            const keyPressed = event.key.toLowerCase();
            if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
            switch(keyPressed){
                case 'escape':
                    if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    setIsOpen(false);
                    setShouldSetFocusOnCurrentDay(false);
                    setWasOpenedFromCalendarButton(false);
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                            setClearingFromIcon(false);
                            setValue('');
                        }
                        break;
                    }
                case 'enter':
                    if (!isOpen) return;
                    event.preventDefault();
                    if (!(0, (0, parcelRequire("5RLF6")).isDateDisabled)(calendarValue, {
                        disabled: disabled
                    })) {
                        const safeCalendarValue = (0, (0, parcelRequire("6AqCE")).getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        setSelectInputValue('');
                        setIsOpen(false);
                        setValue(safeCalendarValue);
                        setCalendarValue(safeCalendarValue);
                        setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                        if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (isOpen && !shouldSetFocusOnCurrentDay) setShouldSetFocusOnCurrentDay(true);
                    break;
                default:
                    break;
            }
        };
        const onCalendarButtonKeyDown = (e)=>{
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                setIsKeyDown(true);
                setWasOpenedFromCalendarButton(true);
            }
        };
        const onCalendarButtonClick = (e)=>{
            setIsOpen(!isOpen);
            setWasOpenedFromCalendarButton(true);
            e.stopPropagation();
        };
        const onClear = ()=>{
            setValue('');
            setCalendarValue(defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()));
            if (!hideIcon) setClearingFromIcon(true);
            onChangePropWithAnalytics('');
        };
        const onSelectChange = (_value, action)=>{
            if (action.action === 'clear') onClear();
        };
        const handleSelectInputChange = (selectInputValue, actionMeta)=>{
            if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
            setSelectInputValue(selectInputValue);
        };
        const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
            const oldRef = containerRef.current;
            containerRef.current = ref;
            if (oldRef == null && ref != null) forceUpdate();
        }, [
            containerRef
        ]);
        const getterValue = getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $48f5b21daaca02ab$var$dropdownIndicatorStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
            lang: propLocale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("jHBnA")).EmptyComponent) : dropDownIcon,
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iaQLg")).IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: (0, parcelRequire("gtijU")).Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: containerRef.current,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: calendarRef,
            calendarValue: getterValue && (0, (0, parcelRequire("6AqCE")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(getterValue)),
            calendarView: calendarValue,
            onCalendarChange: onCalendarChange,
            onCalendarSelect: onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-075, 6px)"
                })
        });
        const initialValue = getterValue ? {
            label: (0, (0, parcelRequire("5RLF6")).formatDate)(getterValue, {
                formatDisplayLabel: formatDisplayLabel,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }),
            value: getterValue
        } : null;
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
        const openCalendarLabelId = `open-calendar-label--${(0, (0, parcelRequire("9KnKW")).useId)()}`;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...innerProps,
            css: $48f5b21daaca02ab$var$pickerContainerStyles,
            "data-testid": testId && `${testId}--container`,
            onBlur: onContainerBlur,
            onFocus: onContainerFocus,
            onClick: onInputClick,
            onInput: onTextInput,
            onKeyDown: onInputKeyDown,
            ref: getContainerRef,
            role: "presentation"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            name: name,
            type: "hidden",
            value: getterValue,
            "data-testid": testId && `${testId}--input`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7K5PP")).default), {
            appearance: appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: onSelectBlur,
            onChange: onSelectChange,
            onFocus: onSelectFocus,
            onInputChange: handleSelectInputChange,
            placeholder: (0, (0, parcelRequire("5RLF6")).getPlaceholder)({
                placeholder: placeholder,
                l10n: l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $48f5b21daaca02ab$var$iconContainerStyles,
                value && !hideIcon ? $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew : $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles
            ]
        }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            id: openCalendarLabelId
        }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            ...inputLabelId ? {
                'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
            } : {
                'aria-label': fullopenCalendarLabel
            },
            onClick: onCalendarButtonClick,
            onKeyDown: onCalendarButtonKeyDown,
            ref: calendarButtonRef,
            testId: testId && `${testId}--open-calendar-button`,
            type: "button",
            backgroundColor: "color.background.neutral.subtle",
            padding: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
            xcss: [
                $48f5b21daaca02ab$var$calendarButtonStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') && $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($48f5b21daaca02ab$var$CalendarIcon, {
            label: "",
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                color: "var(--ds-icon, #44546F)"
            } : {
                primaryColor: "var(--ds-icon, #44546F)"
            }
        }))) : null));
    });
    var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;
});
parcelRegister("aipk9", function(module, exports) {
    $parcel$export(module.exports, "getDayLabel", ()=>$da1491eee903a2d8$export$77c6667acb2335c);
    $parcel$export(module.exports, "getMonthLabel", ()=>$da1491eee903a2d8$export$5492c4ce9d26d774);
    $parcel$export(module.exports, "formatDateUTC", ()=>$da1491eee903a2d8$export$f6ec9a122d9a3697);
    $parcel$export(module.exports, "formatTimestampWithIntl", ()=>$da1491eee903a2d8$export$a70c08d756ec4ebf);
    $parcel$export(module.exports, "formatDateWithIntl", ()=>$da1491eee903a2d8$export$41d39199b76e5fba);
    $parcel$export(module.exports, "useDateFormatter", ()=>$da1491eee903a2d8$export$85fd5fdf27bacc79);
    var $5uXOq = parcelRequire("5uXOq");
    var $jovBr;
    var $koVbs;
    var $gh61P;
    const $da1491eee903a2d8$export$32db56fbc0b29120 = (day)=>{
        switch(day){
            case 0:
                return 'Sunday';
            case 1:
                return 'Monday';
            case 2:
                return 'Tuesday';
            case 3:
                return 'Wednesday';
            case 4:
                return 'Thursday';
            case 5:
                return 'Friday';
            default:
                return 'Saturday';
        }
    };
    const $da1491eee903a2d8$export$e5b0222dbac9656 = (month)=>{
        switch(month){
            case 0:
                return 'January';
            case 1:
                return 'February';
            case 2:
                return 'March';
            case 3:
                return 'April';
            case 4:
                return 'May';
            case 5:
                return 'June';
            case 6:
                return 'July';
            case 7:
                return 'August';
            case 8:
                return 'September';
            case 9:
                return 'October';
            case 10:
                return 'November';
            default:
                return 'December';
        }
    };
    const $da1491eee903a2d8$export$77c6667acb2335c = (day)=>$da1491eee903a2d8$export$32db56fbc0b29120(day).substr(0, 3);
    const $da1491eee903a2d8$export$5492c4ce9d26d774 = (month)=>$da1491eee903a2d8$export$e5b0222dbac9656(month).substr(0, 3);
    const $da1491eee903a2d8$export$b27aef2de915d062 = (format)=>{
        let stringFormat = format;
        let match;
        let parts = [];
        const DATE_FORMATS_SPLIT = /((?:[^YMDHhmsaAZzE']+)|(?:'(?:[^']|'')*')|(?:E+|Y+|M+|D+|H+|h+|m+|s+|a|A|Z|z))(.*)/;
        const slice = [].slice;
        const concatMethod = (array1, array2, index)=>array1.concat(slice.call(array2, index));
        while(stringFormat){
            match = DATE_FORMATS_SPLIT.exec(stringFormat);
            if (match) {
                parts = concatMethod(parts, match, 1);
                stringFormat = parts.pop();
            } else {
                parts.push(format);
                stringFormat = null;
            }
        }
        return parts;
    };
    const $da1491eee903a2d8$export$f6ec9a122d9a3697 = (time, format)=>{
        const date = new Date(time);
        if (!(0, (0, parcelRequire("jovBr")).default)(date)) throw new Error('Date passed to formatDateUTC function is not valid');
        const dayOfWeekIndex = date.getUTCDay();
        const month = date.getUTCMonth();
        const fullYear = date.getUTCFullYear().toString();
        const fullMonth = $da1491eee903a2d8$export$e5b0222dbac9656(month);
        const shortMonth = $da1491eee903a2d8$export$5492c4ce9d26d774(month);
        const digitMonth = month + 1;
        const hour = date.getUTCHours();
        const minutes = date.getUTCMinutes();
        const seconds = date.getUTCSeconds();
        const formatArray = $da1491eee903a2d8$export$b27aef2de915d062(format);
        const getFormatVal = (part)=>{
            let val;
            switch(part){
                case 'YYYY':
                    val = fullYear.padStart(4, '0');
                    break;
                case 'YY':
                    val = fullYear.padStart(4, '0').substr(-2);
                    break;
                case 'MMMM':
                    val = fullMonth;
                    break;
                case 'MMM':
                    val = shortMonth;
                    break;
                case 'MM':
                    val = digitMonth.toString().padStart(2, '0');
                    break;
                case 'M':
                    val = digitMonth;
                    break;
                case 'EEEE':
                    val = $da1491eee903a2d8$export$32db56fbc0b29120(dayOfWeekIndex);
                    break;
                case 'EEE':
                    val = $da1491eee903a2d8$export$77c6667acb2335c(dayOfWeekIndex);
                    break;
                case 'DD':
                    val = date.getUTCDate().toString().padStart(2, '0');
                    break;
                case 'D':
                    val = date.getUTCDate();
                    break;
                case 'hh':
                    val = 12;
                    if (hour !== 0) {
                        const diff = hour - 12;
                        val = diff > 0 ? diff.toString().padStart(2, '0') : hour.toString().padStart(2, '0');
                    }
                    break;
                case 'h':
                    val = 12;
                    if (hour !== 0) val = hour > 12 ? hour - 12 : hour;
                    break;
                case 'HH':
                    val = hour.toString().padStart(2, '0');
                    break;
                case 'H':
                    val = hour;
                    break;
                case 'mm':
                    val = minutes.toString().padStart(2, '0');
                    break;
                case 'm':
                    val = minutes;
                    break;
                case 'ss':
                    val = seconds.toString().padStart(2, '0');
                    break;
                case 's':
                    val = seconds;
                    break;
                case 'a':
                    val = hour >= 12 ? 'pm' : 'am';
                    break;
                case 'A':
                    val = hour >= 12 ? 'PM' : 'AM';
                    break;
                default:
                    val = part;
            }
            val = typeof val !== 'undefined' ? val.toString() : part;
            return val;
        };
        let dateVal = '';
        formatArray.forEach((part)=>{
            dateVal += getFormatVal(part);
        });
        return dateVal;
    };
    const $da1491eee903a2d8$export$a70c08d756ec4ebf = (intl, timestamp, formatOptions = (0, (0, parcelRequire("gh61P")).longDateFormat))=>intl.formatDate(timestamp, formatOptions);
    const $da1491eee903a2d8$export$41d39199b76e5fba = (intl, iso, formatOptions = (0, (0, parcelRequire("gh61P")).longDateFormat))=>{
        const date = new Date(iso);
        return intl.formatDate(date.getTime(), formatOptions);
    };
    const $da1491eee903a2d8$export$85fd5fdf27bacc79 = ()=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const formatTimestamp = (0, $5uXOq.useCallback)((timestamp, formatOptions)=>$da1491eee903a2d8$export$a70c08d756ec4ebf(intl, timestamp, formatOptions), [
            intl
        ]);
        const formatDate = (0, $5uXOq.useCallback)((iso, formatOptions)=>{
            const date = new Date(iso);
            return $da1491eee903a2d8$export$a70c08d756ec4ebf(intl, date.getTime(), formatOptions);
        }, [
            intl
        ]);
        return {
            formatTimestamp: formatTimestamp,
            formatDate: formatDate
        };
    };
});
parcelRegister("gh61P", function(module, exports) {
    $parcel$export(module.exports, "longDateFormat", ()=>$874bf1b243ba3957$export$7bc415832e79e22c);
    $parcel$export(module.exports, "dateMonthFormat", ()=>$874bf1b243ba3957$export$f9c3f52e4a5f8635);
    $parcel$export(module.exports, "longDateTimeFormat", ()=>$874bf1b243ba3957$export$f2f390060309965);
    $parcel$export(module.exports, "shortDateFormat", ()=>$874bf1b243ba3957$export$1a445e44d9863af);
    $parcel$export(module.exports, "weekdayFormat", ()=>$874bf1b243ba3957$export$faf60e60fca9bed1);
    $parcel$export(module.exports, "weekdayFormatLong", ()=>$874bf1b243ba3957$export$a28e4d9035dd351c);
    $parcel$export(module.exports, "DateUnits", ()=>$874bf1b243ba3957$export$c7e7da0fa6bb60a7);
    $parcel$export(module.exports, "DATE_UNIT_MAX_VALUES", ()=>$874bf1b243ba3957$export$637d8b0948b783c7);
    $parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", ()=>$874bf1b243ba3957$export$78e07fecfaf51c7b);
    $parcel$export(module.exports, "DefaultDateFormat", ()=>$874bf1b243ba3957$export$14ae725d0cc7daa1);
    $parcel$export(module.exports, "IsoDateFormat", ()=>$874bf1b243ba3957$export$7288711b5316ff78);
    $parcel$export(module.exports, "DEFAULT_WEEK_START_DAY", ()=>$874bf1b243ba3957$export$845e1054649a85c2);
    const $874bf1b243ba3957$export$7bc415832e79e22c = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$f9c3f52e4a5f8635 = {
        day: '2-digit',
        month: 'short',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$352fb2bc78f82ff2 = {
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$f2f390060309965 = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$1a445e44d9863af = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$faf60e60fca9bed1 = {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$a28e4d9035dd351c = {
        weekday: 'long',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
    };
    const $874bf1b243ba3957$export$c7e7da0fa6bb60a7 = {
        DAYS: 'days',
        MONTHS: 'months',
        WEEKS: 'weeks'
    };
    const $874bf1b243ba3957$export$637d8b0948b783c7 = {
        [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.DAYS]: 3650,
        [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.WEEKS]: 520,
        [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.MONTHS]: 120
    };
    const $874bf1b243ba3957$export$78e07fecfaf51c7b = {
        FIXED: 'fixed',
        RELATIVE: 'relative'
    };
    const $874bf1b243ba3957$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
    const $874bf1b243ba3957$export$7288711b5316ff78 = 'YYYY-MM-DD';
    const $874bf1b243ba3957$export$845e1054649a85c2 = 0;
});
parcelRegister("iqIcG", function(module, exports) {
    $parcel$export(module.exports, "selectUtils", ()=>$842d278e6d1e2dec$export$9fd93ba4d7fb167b);
    $parcel$export(module.exports, "selectOptionWithAvatar", ()=>$842d278e6d1e2dec$export$645b47931df64cd);
    $parcel$export(module.exports, "selectIssueOption", ()=>$842d278e6d1e2dec$export$a9d867c834fa6cc9);
    $parcel$export(module.exports, "injectMouseOverStyles", ()=>$842d278e6d1e2dec$export$cba7cac47550e20c);
    $parcel$export(module.exports, "Select", ()=>$842d278e6d1e2dec$export$ef9b1a59e592288f);
    $parcel$export(module.exports, "AsyncSelectWithTimelineStyles", ()=>$842d278e6d1e2dec$export$80d68ef05324cca2);
    $parcel$export(module.exports, "AkSelect", ()=>(parcelRequire("7K5PP")).default);
    $parcel$export(module.exports, "AsyncSelect", ()=>(parcelRequire("d7FF4")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $d7FF4;
    var $itpgN;
    var $94bNw;
    var $bChGW;
    var $iOwNT;
    var $5JAlL;
    var $7K5PP;
    var $b9dFI;
    var $k5uoT;
    var $co1wz;
    var $gJZ5D;
    var $f9Tpd;
    var $7chIQ;
    var $1KSaX = parcelRequire("1KSaX");
    const $842d278e6d1e2dec$export$9fd93ba4d7fb167b = {
        createFilter: (0, (0, parcelRequire("5JAlL")).createFilter)
    };
    const $842d278e6d1e2dec$export$645b47931df64cd = ({ icon: icon, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1KSaX["select-option"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1KSaX.avatar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "xsmall",
            src: icon,
            borderColor: "transparent"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1KSaX.label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $1KSaX.truncated
        }, label)));
    const $842d278e6d1e2dec$export$a9d867c834fa6cc9 = ({ icon: icon, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1KSaX["select-option"]
        }, icon && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1KSaX["issue-icon"],
            style: {
                backgroundSize: 'contain',
                backgroundImage: `url(${icon})`
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$1KSaX["issue-summary"]} ${$1KSaX.truncated}`
        }, label));
    const $842d278e6d1e2dec$export$cba7cac47550e20c = (styles, shouldInjectMouseOverStyles, isFocused, isTransparentBackground)=>{
        const mouseOver = {
            backgroundColor: (0, (0, parcelRequire("gJZ5D")).default).N20_TRANSPARENT,
            borderColor: (0, (0, parcelRequire("gJZ5D")).default).N20_TRANSPARENT
        };
        const resultStyles = {
            ...styles,
            ':hover': shouldInjectMouseOverStyles ? {
                ...styles[':hover'],
                ...mouseOver
            } : styles[':hover']
        };
        if (isTransparentBackground) return {
            ...resultStyles,
            backgroundColor: isFocused ? styles.backgroundColor : 'transparent',
            borderColor: isFocused ? styles.borderColor : 'transparent'
        };
        return resultStyles;
    };
    const $842d278e6d1e2dec$var$customStylesFunc = (ref, isTransparentBackground, minSelectWidth)=>({
            container: (containerStyles)=>({
                    ...containerStyles,
                    width: '100%',
                    height: '100%',
                    paddingRight: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? undefined : '1px'
                }),
            control: (controlStyles, state)=>{
                const { isFocused: isFocused } = state;
                const resultStyles = $842d278e6d1e2dec$export$cba7cac47550e20c(controlStyles, !isFocused, isFocused, !!isTransparentBackground);
                if (isTransparentBackground) return {
                    ...resultStyles,
                    padding: 0,
                    flexWrap: 'nowrap'
                };
                return resultStyles;
            },
            groupHeading: (groupHeadingStyles, state)=>({
                    ...groupHeadingStyles,
                    color: `var(--ds-text-subtlest, ${(0, (0, parcelRequire("gJZ5D")).default).N200})`,
                    padding: `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
                    display: state.data.label ? 'block' : 'none',
                    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                }),
            menu: (menuStyles)=>{
                if (minSelectWidth) {
                    const { left: left = 0 } = ref && ref.getBoundingClientRect() || {};
                    return {
                        ...menuStyles,
                        minWidth: minSelectWidth,
                        right: left + minSelectWidth > window.innerWidth ? 0 : 'auto'
                    };
                }
                return menuStyles;
            },
            menuPortal: (menuStyles)=>({
                    ...menuStyles,
                    zIndex: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? (0, (0, parcelRequire("k5uoT")).layers).dialog() : 10
                })
        });
    class $842d278e6d1e2dec$export$ef9b1a59e592288f extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isTransparentBackground: true,
                menuIsOpen: false,
                placeholder: '',
                scrollLock: false,
                isCreatable: false
            };
        }
        static{
            this.createFilter = (0, (0, parcelRequire("5JAlL")).createFilter);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.menuIsOpen !== this.props.menuIsOpen) this.setState({
                menuIsOpen: nextProps.menuIsOpen
            });
        }
        render() {
            const { components: components = {}, isDisabled: isDisabled, isSearchable: isSearchable, isTransparentBackground: isTransparentBackground, minSelectWidth: minSelectWidth, placeholder: placeholder, scrollLock: scrollLock, styles: styles, isCreatable: isCreatable } = this.props;
            const { menuIsOpen: menuIsOpen } = this.state;
            const customStyles = $842d278e6d1e2dec$var$customStylesFunc(this.ref, isTransparentBackground, minSelectWidth);
            const SelectComponent = isCreatable ? (0, (0, parcelRequire("iOwNT")).default) : (0, (0, parcelRequire("7K5PP")).default);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: (node)=>{
                    if (node) this.ref = node;
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9Tpd")).default), {
                enabled: scrollLock && menuIsOpen
            }), (0, ($parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
                ...this.props,
                components: {
                    Input: (0, parcelRequire("7chIQ")).default,
                    ...components
                },
                styles: {
                    ...customStyles,
                    ...styles
                },
                menuIsOpen: menuIsOpen,
                onMenuOpen: this.onMenuOpen,
                onMenuClose: this.onMenuClose,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                isSearchable: isSearchable,
                placeholder: !isDisabled && placeholder
            }));
        }
        constructor(...args){
            super(...args);
            this.state = {
                menuIsOpen: this.props.menuIsOpen
            };
            this.handleWindowMouseDown = (e)=>{
                if (!this.state.menuIsOpen) return;
                if (!this.ref) return;
                const node = e.target;
                if (this.ref.contains(node) || !node.parentNode) return;
                this.onMenuClose();
            };
            this.onMenuOpen = ()=>{
                window.addEventListener('mousedown', this.handleWindowMouseDown);
                const { onMenuOpen: onMenuOpen } = this.props;
                const { menuIsOpen: menuIsOpen } = this.state;
                if (menuIsOpen) return;
                this.setState({
                    menuIsOpen: true
                });
                if (onMenuOpen) onMenuOpen();
            };
            this.onMenuClose = ()=>{
                window.removeEventListener('mousedown', this.handleWindowMouseDown);
                const { onMenuClose: onMenuClose } = this.props;
                this.setState({
                    menuIsOpen: false
                });
                if (onMenuClose) onMenuClose();
            };
            this.onBlur = (e)=>{
                const { onBlur: onBlur } = this.props;
                if (onBlur) onBlur(e);
            };
            this.onFocus = (e)=>{
                const { onFocus: onFocus } = this.props;
                if (onFocus) onFocus(e);
            };
        }
    }
    const $842d278e6d1e2dec$export$49305560555295c = 300;
    function $842d278e6d1e2dec$export$80d68ef05324cca2(props) {
        const { minSelectWidth: minSelectWidth, isTransparentBackground: isTransparentBackground, styles: styles } = props;
        const [divRef, setDivRef] = (0, $5uXOq.useState)(undefined);
        const customStyles = $842d278e6d1e2dec$var$customStylesFunc(divRef, isTransparentBackground, minSelectWidth);
        const menuPlacement = ()=>{
            const { bottom: bottom = 0 } = divRef && divRef.getBoundingClientRect() || {};
            return bottom + $842d278e6d1e2dec$export$49305560555295c + 1 > window.innerHeight ? 'top' : 'bottom';
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: (node)=>{
                if (node) setDivRef(node);
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
            ...props,
            styles: {
                ...customStyles,
                ...styles
            },
            menuPlacement: menuPlacement(),
            maxMenuHeight: $842d278e6d1e2dec$export$49305560555295c
        }));
    }
});
parcelRegister("d7FF4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac4d84cf4438daea$export$2e2bcd8739ae039);
    var $eAthk;
    var $3c98u;
    const $ac4d84cf4438daea$var$AsyncSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    var $ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;
});
parcelRegister("itpgN", function(module, exports) {
    $parcel$export(module.exports, "CheckboxOption", ()=>$f5875245cd0ad0c1$export$d40cc97ecda916f9);
    $parcel$export(module.exports, "RadioOption", ()=>$f5875245cd0ad0c1$export$82ab7168879267a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6aY6N;
    var $iQHJo;
    function $f5875245cd0ad0c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f5875245cd0ad0c1$var$getPrimitiveStyles = (props)=>{
        const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
        const baseStyles = {
            alignItems: 'center',
            backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : 'transparent',
            color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
            display: 'flex ',
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-050, 4px)",
            boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}` : 'none',
            ':active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            },
            '@media screen and (-ms-high-contrast: active)': {
                borderLeft: isFocused ? '2px solid transparent' : ''
            }
        };
        const augmentedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
            ...getStyles('option', props),
            ...baseStyles
        });
        const bemClasses = {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        };
        return [
            augmentedStyles,
            cx(bemClasses, className)
        ];
    };
    const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isActive) return `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
        else if (isFocused) return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
        else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (!isSelected) return 'transparent';
        return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isActive) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused) return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
    };
    const $f5875245cd0ad0c1$var$baseIconStyles = {
        name: "35x0q3",
        styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
    };
    const $f5875245cd0ad0c1$var$baseOptionStyles = {
        name: "16e0ede",
        styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    class $f5875245cd0ad0c1$var$ControlOption extends (0, $5uXOq.Component) {
        render() {
            const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
            const props = {
                ...innerProps,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            const [styles, classes] = $f5875245cd0ad0c1$var$getPrimitiveStyles({
                getStyles: getStyles,
                ...rest
            });
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: styles,
                className: classes,
                ref: innerRef,
                ...props
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $f5875245cd0ad0c1$var$baseIconStyles,
                    {
                        '& svg rect, & svg circle:first-of-type': {
                            stroke: $f5875245cd0ad0c1$var$getBorderColor({
                                ...this.props,
                                ...this.state
                            })
                        }
                    }
                ]
            }, !!Icon ? (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
                label: "",
                primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                    ...this.props,
                    ...this.state
                }),
                secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                    ...this.props,
                    ...this.state
                }),
                isFacadeDisabled: true
            }) : null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $f5875245cd0ad0c1$var$baseOptionStyles
            }, children)));
        }
        constructor(...args){
            super(...args);
            this.state = {
                isActive: false
            };
            this.onMouseDown = ()=>this.setState({
                    isActive: true
                });
            this.onMouseUp = ()=>this.setState({
                    isActive: false
                });
            this.onMouseLeave = ()=>this.setState({
                    isActive: false
                });
        }
    }
    const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("6aY6N"))))),
            ...props
        });
    const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("iQHJo"))))),
            ...props
        });
});
parcelRegister("6aY6N", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
    function $47f24d9003b82760$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $47f24d9003b82760$var$CheckboxIcon = (props)=>$47f24d9003b82760$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $47f24d9003b82760$var$_checkboxChecked.default
        }));
    $47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
    var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;
});
parcelRegister("aoKYM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79209663d32c0c44$var$_UNSAFE_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $79209663d32c0c44$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>$79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
    var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;
});
parcelRegister("iQHJo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
    function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $db8f016a0af5fda9$var$RadioIcon = (props)=>$db8f016a0af5fda9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
        }, props, {
            newIcon: $db8f016a0af5fda9$var$_radioChecked.default
        }));
    $db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
    var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;
});
parcelRegister("kqGQn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $edf7783e719984ba$var$_UNSAFE_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $edf7783e719984ba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>$edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
        }, props));
    $edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
    var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;
});
parcelRegister("94bNw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebf832c571222d72$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7K5PP;
    var $itpgN;
    const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
        const mergedComponents = (0, $5uXOq.useMemo)(()=>({
                ...components,
                Option: (0, (0, parcelRequire("itpgN")).CheckboxOption)
            }), [
            components
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            closeMenuOnSelect: false,
            hideSelectedOptions: false,
            isMulti: true,
            ...props,
            components: mergedComponents
        });
    };
    const $ebf832c571222d72$var$CheckboxSelect = (0, ($parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
    var $ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;
});
parcelRegister("iOwNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59b6485f0cb008dd$export$2e2bcd8739ae039);
    var $9OU1i;
    var $3c98u;
    const $59b6485f0cb008dd$var$CreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("9OU1i")).default));
    var $59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;
});
parcelRegister("9OU1i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b29f1caecd9c7d5a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useCreatable", ()=>(parcelRequire("2HH7Y")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $2HH7Y;
    var $9uJ4X;
    const $b29f1caecd9c7d5a$var$CreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(props);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;
});
parcelRegister("2HH7Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$994aeb783b6f955a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eEtcC;
    var $gyjU7;
    const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
        const candidate = String(inputValue).toLowerCase();
        const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
        const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
        return optionValue === candidate || optionLabel === candidate;
    };
    const $994aeb783b6f955a$var$builtins = {
        formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
        isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
        getNewOptionData: (inputValue, optionLabel)=>({
                label: optionLabel,
                value: inputValue,
                __isNew__: true
            })
    };
    function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
        const { getOptionValue: getOptionValue = (0, (0, parcelRequire("eEtcC")).getOptionValue), getOptionLabel: getOptionLabel = (0, (0, parcelRequire("eEtcC")).getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
        const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, (0, parcelRequire("gyjU7")).cleanValue)(value), propsOptions, {
                getOptionValue: getOptionValue,
                getOptionLabel: getOptionLabel
            }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
            formatCreateLabel,
            getNewOptionData,
            getOptionLabel,
            getOptionValue,
            inputValue,
            isValidNewOption,
            propsOptions,
            value
        ]);
        const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
                newOption,
                ...propsOptions
            ] : [
                ...propsOptions,
                newOption
            ] : propsOptions, [
            allowCreateWhileLoading,
            createOptionPosition,
            isLoading,
            newOption,
            propsOptions
        ]);
        const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
            const valueArray = Array.isArray(newValue) ? newValue : [
                newValue
            ];
            if (valueArray[valueArray.length - 1] === newOption) {
                if (onCreateOption) onCreateOption(inputValue);
                else {
                    const newOptionData = getNewOptionData(inputValue, inputValue);
                    const newActionMeta = {
                        action: 'create-option',
                        name: name,
                        option: newOptionData
                    };
                    propsOnChange((0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, [
                        ...(0, (0, parcelRequire("gyjU7")).cleanValue)(value),
                        newOptionData
                    ], newOptionData), newActionMeta);
                }
                return;
            }
            propsOnChange(newValue, actionMeta);
        }, [
            getNewOptionData,
            inputValue,
            isMulti,
            name,
            newOption,
            onCreateOption,
            propsOnChange,
            value
        ]);
        return {
            ...restSelectProps,
            options: options,
            onChange: onChange
        };
    }
});
parcelRegister("b9dFI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$768d8504b373d7ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $9ZKDH = parcelRequire("9ZKDH");
    var $dI393 = parcelRequire("dI393");
    var $5n5w4;
    var $283js;
    var $iGDLS;
    var $4wJSY = parcelRequire("4wJSY");
    var $9KnKW;
    var $VSDnB;
    var $7VXAu;
    var $7K5PP;
    var $eaXSR;
    var $1DATb;
    var $hT6ku;
    const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $768d8504b373d7ff$var$FocusLock = (0, (0, parcelRequire("VSDnB")).fg)('platform_dst_select-bump-react-focus-lock') ? (0, $9ZKDH.default) : (0, $ao4Ml.default);
    const $768d8504b373d7ff$var$modifiers = [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 5,
                boundary: 'clippingParents',
                altAxis: true,
                altBoundary: true
            }
        }
    ];
    const $768d8504b373d7ff$var$defaultPopperProps = {
        modifiers: $768d8504b373d7ff$var$modifiers,
        placement: 'bottom-start'
    };
    const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
    class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                closeMenuOnSelect: true,
                shouldCloseMenuOnTab: true,
                components: {},
                maxMenuHeight: 300,
                maxMenuWidth: 440,
                minMenuWidth: 220,
                popperProps: {},
                isSearchable: true,
                searchThreshold: 5,
                styles: {},
                options: []
            };
        }
        static getDerivedStateFromProps(props, state) {
            const newState = {};
            const mergedPopperProps = {
                ...$768d8504b373d7ff$var$defaultPopperProps,
                ...props.popperProps
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
            const mergedComponents = {
                ...(0, (0, parcelRequire("hT6ku")).defaultComponents),
                ...props.components
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
            if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
            return null;
        }
        componentDidMount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: this.handleClick,
                options: {
                    capture: true
                }
            });
        }
        componentWillUnmount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick?.();
            this.unbindWindowClick = null;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }
        componentDidUpdate(prevProps) {
            const { isOpen: isOpen } = this.props;
            if (prevProps.isOpen !== isOpen) {
                if (isOpen === true) this.open({
                    controlOverride: true
                });
                else if (isOpen === false) this.close({
                    controlOverride: true
                });
            }
        }
        render() {
            const { target: target } = this.props;
            const { isOpen: isOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5n5w4")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9KnKW")).IdProvider), {
                postfix: "-popup-select"
            }, ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iGDLS")).Reference), null, ({ ref: ref })=>target && target({
                        isOpen: isOpen,
                        onKeyDown: this.handleTargetKeyDown,
                        ref: this.resolveTargetRef(ref),
                        'aria-haspopup': 'true',
                        'aria-expanded': isOpen,
                        'aria-controls': isOpen ? id : undefined
                    })), this.renderSelect(id))));
        }
        constructor(...args){
            super(...args);
            this.menuRef = null;
            this.selectRef = null;
            this.targetRef = null;
            this.unbindWindowClick = null;
            this.unbindWindowKeydown = null;
            this.defaultStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
                groupHeading: (provided)=>({
                        ...provided,
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                    })
            });
            this.isOpenControlled = this.props.isOpen !== undefined;
            this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
            this.state = {
                focusLockEnabled: false,
                isOpen: this.defaultOpenState ?? false,
                mergedComponents: (0, (0, parcelRequire("hT6ku")).defaultComponents),
                mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
            };
            this.handleTargetKeyDown = (event)=>{
                switch(event.key){
                    case 'ArrowDown':
                        this.open();
                        break;
                    default:
                }
            };
            this.handleKeyDown = (event)=>{
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
                switch(event.key){
                    case 'Escape':
                    case 'Esc':
                        this.close();
                        break;
                    default:
                }
                if (this.props.onKeyDown) this.props.onKeyDown(event);
            };
            this.handleClick = ({ target: target })=>{
                const { isOpen: isOpen } = this.state;
                if (!(target instanceof Element)) return;
                if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
                if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
            };
            this.handleSelectChange = (value, actionMeta)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
                if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
                if (onChange) onChange(value, actionMeta);
            };
            this.handleFirstPopperUpdate = ()=>{
                this.setState({
                    focusLockEnabled: true
                });
            };
            this.open = (options)=>{
                const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onOpen) onOpen();
                if (onMenuOpen && (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
                this.setState({
                    isOpen: true
                }, ()=>{
                    if (this.selectRef) this.selectRef.select?.openMenu('first');
                });
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: this.handleKeyDown,
                    options: {
                        capture: true
                    }
                });
            };
            this.close = (options)=>{
                const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onClose) onClose();
                if (onMenuClose && (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
                this.setState({
                    isOpen: false
                });
                this.setState({
                    focusLockEnabled: false
                });
                if (this.targetRef != null) this.targetRef.focus();
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown?.();
                this.unbindWindowKeydown = null;
            };
            this.resolveTargetRef = (popperRef)=>(ref)=>{
                    if (!this.targetRef && popperRef && ref) {
                        this.targetRef = ref;
                        if (typeof popperRef === 'function') popperRef(ref);
                        else popperRef.current = ref;
                    }
                };
            this.resolveMenuRef = (popperRef)=>(ref)=>{
                    this.menuRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                };
            this.getSelectRef = (ref)=>{
                this.selectRef = ref;
            };
            this.getItemCount = ()=>{
                const { options: options } = this.props;
                let count = 0;
                options.forEach((groupOrOption)=>{
                    if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                    else count++;
                });
                return count;
            };
            this.getMaxHeight = ()=>{
                const { maxMenuHeight: maxMenuHeight } = this.props;
                if (!this.selectRef) return maxMenuHeight;
                const showSearchControl = this.showSearchControl();
                const controlRef = this.selectRef.select?.controlRef;
                const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
                const maxHeight = maxMenuHeight - offsetHeight;
                return maxHeight;
            };
            this.showSearchControl = ()=>{
                const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
                return isSearchable && this.getItemCount() > searchThreshold;
            };
            this.renderSelect = (id)=>{
                const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
                const menuHandlers = !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver') ? {
                    onMenuOpen: onMenuOpen,
                    onMenuClose: onMenuClose
                } : {};
                const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
                const showSearchControl = this.showSearchControl();
                const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
                if (!portalDestination || !isOpen) return null;
                const selectComponents = {
                    ...mergedComponents,
                    Control: showSearchControl ? mergedComponents.Control : (0, (0, parcelRequire("hT6ku")).DummyControl)
                };
                const getLabel = ()=>{
                    if (label) return label;
                    else if (typeof placeholder === 'string') return placeholder;
                };
                const providedAriaLabel = getLabel();
                const updateInputAriaLabel = (ariaLabelText)=>{
                    if (this.selectRef?.select?.inputRef) {
                        if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                        this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                    }
                };
                const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                    const { focused: focused } = onFocusProps;
                    const options = props?.options || [];
                    const totalLength = options?.length;
                    const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                    const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                    const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                    return ariaLabelText;
                };
                const onReactSelectFocus = (onFocusProps)=>{
                    const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                    let ariaLabelText = '';
                    let ariaLiveMessage = '';
                    if (props.options?.length) {
                        if ((0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options)) {
                            const totalLength = (0, (0, parcelRequire("1DATb")).countAllOptions)(props.options);
                            ariaLiveMessage = (0, (0, parcelRequire("1DATb")).onFocus)(onFocusProps, props.options);
                            ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                        } else {
                            ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                            ariaLiveMessage = ariaLabelText;
                        }
                        updateInputAriaLabel(ariaLabelText);
                        return ariaLiveMessage;
                    }
                    return ariaLiveMessage;
                };
                const popper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("283js")).Popper), {
                    ...mergedPopperProps,
                    onFirstUpdate: (state)=>{
                        this.handleFirstPopperUpdate();
                        mergedPopperProps.onFirstUpdate?.(state);
                    }
                }, ({ placement: placement, ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement($768d8504b373d7ff$var$ConditionalNodeResolverWrapper, {
                        hasNodeResolver: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver'),
                        innerRef: this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hT6ku")).MenuDialog), {
                        style: style,
                        "data-placement": placement,
                        minWidth: minMenuWidth,
                        maxWidth: maxMenuWidth,
                        id: id,
                        testId: testId,
                        ref: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement($768d8504b373d7ff$var$FocusLock, {
                        disabled: !focusLockEnabled,
                        returnFocus: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        "aria-label": providedAriaLabel,
                        backspaceRemovesValue: false,
                        controlShouldRenderValue: false,
                        isClearable: false,
                        tabSelectsValue: false,
                        menuIsOpen: true,
                        placeholder: placeholder,
                        ref: this.getSelectRef,
                        ...props,
                        ...menuHandlers,
                        isSearchable: showSearchControl,
                        styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)(this.defaultStyles, props.styles || {}),
                        maxMenuHeight: this.getMaxHeight(),
                        components: selectComponents,
                        onChange: this.handleSelectChange,
                        ariaLiveMessages: !showSearchControl ? {
                            onFocus: onReactSelectFocus,
                            ...props.ariaLiveMessages
                        } : props.ariaLiveMessages
                    }), footer))));
                return mergedPopperProps.strategy === 'fixed' ? popper : (0, $7nsd3.createPortal)(popper, portalDestination);
            };
        }
    }
    const $768d8504b373d7ff$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
        if (hasNodeResolver) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($dI393))), {
            innerRef: innerRef
        }, children);
        return children;
    };
});
parcelRegister("5n5w4", function(module, exports) {
    $parcel$export(module.exports, "ManagerReferenceNodeContext", ()=>$3e93612641040812$export$3dbd3405086fec7b);
    $parcel$export(module.exports, "ManagerReferenceNodeSetterContext", ()=>$3e93612641040812$export$cbabb21c2529b130);
    $parcel$export(module.exports, "Manager", ()=>$3e93612641040812$export$d0d38e7dec7a1a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
    var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
    function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
        var children = _ref.children;
        var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
        var hasUnmounted = $5uXOq.useRef(false);
        $5uXOq.useEffect(function() {
            return function() {
                hasUnmounted.current = true;
            };
        }, []);
        var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
            if (!hasUnmounted.current) setReferenceNode(node);
        }, []);
        return $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
            value: referenceNode
        }, $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
            value: handleSetReferenceNode
        }, children));
    }
});
parcelRegister("283js", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$18cee5f949ac4034$export$badac9ada3a0bdf9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5n5w4;
    var $eclLw;
    var $fNOWl;
    var $18cee5f949ac4034$var$NOOP = function NOOP() {
        return void 0;
    };
    var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
        return Promise.resolve(null);
    };
    var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
    function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
        var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
        var referenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeContext));
        var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
        var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
        $5uXOq.useEffect(function() {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, popperElement);
        }, [
            innerRef,
            popperElement
        ]);
        var options = $5uXOq.useMemo(function() {
            return {
                placement: placement,
                strategy: strategy,
                onFirstUpdate: onFirstUpdate,
                modifiers: [].concat(modifiers, [
                    {
                        name: 'arrow',
                        enabled: arrowElement != null,
                        options: {
                            element: arrowElement
                        }
                    }
                ])
            };
        }, [
            placement,
            strategy,
            onFirstUpdate,
            modifiers,
            arrowElement
        ]);
        var _usePopper = (0, (0, parcelRequire("fNOWl")).usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
        var childrenProps = $5uXOq.useMemo(function() {
            return {
                ref: setPopperElement,
                style: styles.popper,
                placement: state ? state.placement : placement,
                hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
                isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
                arrowProps: {
                    style: styles.arrow,
                    ref: setArrowElement
                },
                forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
                update: update || $18cee5f949ac4034$var$NOOP_PROMISE
            };
        }, [
            setPopperElement,
            setArrowElement,
            placement,
            state,
            styles,
            update,
            forceUpdate
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)(childrenProps);
    }
});
parcelRegister("eclLw", function(module, exports) {
    $parcel$export(module.exports, "unwrapArray", ()=>$a56311d537d20f47$export$f52c55943429c8b6);
    $parcel$export(module.exports, "safeInvoke", ()=>$a56311d537d20f47$export$3dfa7c28635fe028);
    $parcel$export(module.exports, "setRef", ()=>$a56311d537d20f47$export$4bb192c7cacf928f);
    $parcel$export(module.exports, "fromEntries", ()=>$a56311d537d20f47$export$5150077fc2e7c662);
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$a56311d537d20f47$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
        return Array.isArray(arg) ? arg[0] : arg;
    };
    var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
        if (typeof fn === 'function') {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return fn.apply(void 0, args);
        }
    };
    var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
        if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
        else if (ref != null) ref.current = node;
    };
    var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
        return entries.reduce(function(acc, _ref) {
            var key = _ref[0], value = _ref[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
});
parcelRegister("fNOWl", function(module, exports) {
    $parcel$export(module.exports, "usePopper", ()=>$b812f23d0bbb9e85$export$f4d5bf230a36dd6e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $8Pv9O;
    var $lHrkK = parcelRequire("lHrkK");
    var $eclLw;
    var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
    var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
        if (options === void 0) options = {};
        var prevOptions = $5uXOq.useRef(null);
        var optionsWithDefaults = {
            onFirstUpdate: options.onFirstUpdate,
            placement: options.placement || 'bottom',
            strategy: options.strategy || 'absolute',
            modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
        };
        var _React$useState = $5uXOq.useState({
            styles: {
                popper: {
                    position: optionsWithDefaults.strategy,
                    left: '0',
                    top: '0'
                },
                arrow: {
                    position: 'absolute'
                }
            },
            attributes: {}
        }), state = _React$useState[0], setState = _React$useState[1];
        var updateStateModifier = $5uXOq.useMemo(function() {
            return {
                name: 'updateState',
                enabled: true,
                phase: 'write',
                fn: function fn(_ref) {
                    var state = _ref.state;
                    var elements = Object.keys(state.elements);
                    $7nsd3.flushSync(function() {
                        setState({
                            styles: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.styles[element] || {}
                                ];
                            })),
                            attributes: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.attributes[element]
                                ];
                            }))
                        });
                    });
                },
                requires: [
                    'computeStyles'
                ]
            };
        }, []);
        var popperOptions = $5uXOq.useMemo(function() {
            var newOptions = {
                onFirstUpdate: optionsWithDefaults.onFirstUpdate,
                placement: optionsWithDefaults.placement,
                strategy: optionsWithDefaults.strategy,
                modifiers: [].concat(optionsWithDefaults.modifiers, [
                    updateStateModifier,
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ])
            };
            if ((0, ($parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
            else {
                prevOptions.current = newOptions;
                return newOptions;
            }
        }, [
            optionsWithDefaults.onFirstUpdate,
            optionsWithDefaults.placement,
            optionsWithDefaults.strategy,
            optionsWithDefaults.modifiers,
            updateStateModifier
        ]);
        var popperInstanceRef = $5uXOq.useRef();
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
        }, [
            popperOptions
        ]);
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (referenceElement == null || popperElement == null) return;
            var createPopper = options.createPopper || (0, (0, parcelRequire("8Pv9O")).createPopper);
            var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
            popperInstanceRef.current = popperInstance;
            return function() {
                popperInstance.destroy();
                popperInstanceRef.current = null;
            };
        }, [
            referenceElement,
            popperElement,
            options.createPopper
        ]);
        return {
            state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
            styles: state.styles,
            attributes: state.attributes,
            update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
            forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
        };
    };
});
parcelRegister("8Pv9O", function(module, exports) {
    $parcel$export(module.exports, "createPopper", ()=>$66db415bc009fd50$export$8f7491d57c8f97a9);
    var $dsn8Y;
    var $4TVC8;
    var $j8nKB;
    var $baic6;
    var $1AoLg;
    var $gy4Xr;
    var $3dDWl;
    var $1DdSC;
    var $gzAfz;
    var $6iLAT;
    var $66db415bc009fd50$export$d34966752335dd47 = [
        (0, (0, parcelRequire("4TVC8")).default),
        (0, (0, parcelRequire("j8nKB")).default),
        (0, (0, parcelRequire("baic6")).default),
        (0, (0, parcelRequire("1AoLg")).default),
        (0, (0, parcelRequire("gy4Xr")).default),
        (0, (0, parcelRequire("3dDWl")).default),
        (0, (0, parcelRequire("1DdSC")).default),
        (0, (0, parcelRequire("gzAfz")).default),
        (0, (0, parcelRequire("6iLAT")).default)
    ];
    var $66db415bc009fd50$export$8f7491d57c8f97a9 = (0, (0, parcelRequire("dsn8Y")).popperGenerator)({
        defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
    });
});
parcelRegister("dsn8Y", function(module, exports) {
    $parcel$export(module.exports, "popperGenerator", ()=>$9cbfd7bdb6a4f3f1$export$ed5e13716264f202);
    var $gvlia;
    var $jkGDj;
    var $2r6BH;
    var $gbHJy;
    var $kcmIg;
    var $a8clb;
    var $i9xH7;
    var $gmkfg;
    var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function $9cbfd7bdb6a4f3f1$var$areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: (0, (0, parcelRequire("gmkfg")).isElement)(reference) ? (0, (0, parcelRequire("2r6BH")).default)(reference) : reference.contextElement ? (0, (0, parcelRequire("2r6BH")).default)(reference.contextElement) : [],
                        popper: (0, (0, parcelRequire("2r6BH")).default)(popper)
                    };
                    var orderedModifiers = (0, (0, parcelRequire("kcmIg")).default)((0, (0, parcelRequire("i9xH7")).default)([].concat(defaultModifiers, state.options.modifiers)));
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
                    if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                    state.rects = {
                        reference: (0, (0, parcelRequire("gvlia")).default)(reference, (0, (0, parcelRequire("gbHJy")).default)(popper), state.options.strategy === 'fixed'),
                        popper: (0, (0, parcelRequire("jkGDj")).default)(popper)
                    };
                    state.reset = false;
                    state.placement = state.options.placement;
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                update: (0, (0, parcelRequire("a8clb")).default)(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            });
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = $9cbfd7bdb6a4f3f1$export$ed5e13716264f202();
});
parcelRegister("gvlia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0400ebb908e52cb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $9FFjG;
    var $f5IBt;
    var $gmkfg;
    var $imzt5;
    var $eVELE;
    var $c6EdA;
    var $90xPK;
    function $c0400ebb908e52cb$var$isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = (0, (0, parcelRequire("90xPK")).round)(rect.width) / element.offsetWidth || 1;
        var scaleY = (0, (0, parcelRequire("90xPK")).round)(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    }
    function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent);
        var offsetParentIsScaled = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
        var documentElement = (0, (0, parcelRequire("eVELE")).default)(offsetParent);
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) !== 'body' || (0, (0, parcelRequire("c6EdA")).default)(documentElement)) scroll = (0, (0, parcelRequire("9FFjG")).default)(offsetParent);
            if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent)) {
                offsets = (0, (0, parcelRequire("g2O7Z")).default)(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = (0, (0, parcelRequire("imzt5")).default)(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
});
parcelRegister("g2O7Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bae3b796a534b2cf$export$2e2bcd8739ae039);
    var $gmkfg;
    var $90xPK;
    var $1Prpe;
    var $d8bsQ;
    function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            scaleX = element.offsetWidth > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = (0, (0, parcelRequire("gmkfg")).isElement)(element) ? (0, (0, parcelRequire("1Prpe")).default)(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !(0, (0, parcelRequire("d8bsQ")).default)() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
});
parcelRegister("gmkfg", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$be8e67adfa808002$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$be8e67adfa808002$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isShadowRoot", ()=>$be8e67adfa808002$export$af51f0f06c0f328a);
    var $1Prpe;
    function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
});
parcelRegister("1Prpe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$154fd01b154b825f$export$2e2bcd8739ae039);
    function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
});
parcelRegister("90xPK", function(module, exports) {
    $parcel$export(module.exports, "max", ()=>$68ee5bce69e9df7e$export$8960430cfd85939f);
    $parcel$export(module.exports, "min", ()=>$68ee5bce69e9df7e$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "round", ()=>$68ee5bce69e9df7e$export$2077e0241d6afd3c);
    var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
    var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
    var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;
});
parcelRegister("d8bsQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98f4ea48bb7f7060$export$2e2bcd8739ae039);
    var $j5Xhq;
    function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
        return !/^((?!chrome|android).)*safari/i.test((0, (0, parcelRequire("j5Xhq")).default)());
    }
});
parcelRegister("j5Xhq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de6c77c242bcf4cf$export$2e2bcd8739ae039);
    function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
});
parcelRegister("9FFjG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70a7fdf85bb2e8b8$export$2e2bcd8739ae039);
    var $8YTLN;
    var $1Prpe;
    var $gmkfg;
    var $i1ad3;
    function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
        if (node === (0, (0, parcelRequire("1Prpe")).default)(node) || !(0, (0, parcelRequire("gmkfg")).isHTMLElement)(node)) return (0, (0, parcelRequire("8YTLN")).default)(node);
        else return (0, (0, parcelRequire("i1ad3")).default)(node);
    }
});
parcelRegister("8YTLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$689f300ec0defb42$export$2e2bcd8739ae039);
    var $1Prpe;
    function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
});
parcelRegister("i1ad3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1e03d69dfb9832f$export$2e2bcd8739ae039);
    function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
});
parcelRegister("f5IBt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afc9ebf0aa1487e4$export$2e2bcd8739ae039);
    function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
});
parcelRegister("imzt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5e5cb506db8cdcb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $eVELE;
    var $8YTLN;
    function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("g2O7Z")).default)((0, (0, parcelRequire("eVELE")).default)(element)).left + (0, (0, parcelRequire("8YTLN")).default)(element).scrollLeft;
    }
});
parcelRegister("eVELE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ade6032ba4b824fe$export$2e2bcd8739ae039);
    var $gmkfg;
    function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
        return (((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
});
parcelRegister("c6EdA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d053e13cecc73ee$export$2e2bcd8739ae039);
    var $1ix2F;
    function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
        var _getComputedStyle = (0, (0, parcelRequire("1ix2F")).default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
});
parcelRegister("1ix2F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f211a5db2cb1d1b$export$2e2bcd8739ae039);
    var $1Prpe;
    function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("1Prpe")).default)(element).getComputedStyle(element);
    }
});
parcelRegister("jkGDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e130f49f6e9ebcb4$export$2e2bcd8739ae039);
    var $g2O7Z;
    function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
        var clientRect = (0, (0, parcelRequire("g2O7Z")).default)(element);
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
});
parcelRegister("2r6BH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c633a6ac170841a$export$2e2bcd8739ae039);
    var $k82dT;
    var $eTUzl;
    var $1Prpe;
    var $c6EdA;
    function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = (0, (0, parcelRequire("k82dT")).default)(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = (0, (0, parcelRequire("1Prpe")).default)(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], (0, (0, parcelRequire("c6EdA")).default)(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(target)));
    }
});
parcelRegister("k82dT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea7647704a508683$export$2e2bcd8739ae039);
    var $eTUzl;
    var $c6EdA;
    var $f5IBt;
    var $gmkfg;
    function $ea7647704a508683$export$2e2bcd8739ae039(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(node)) >= 0) return node.ownerDocument.body;
        if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(node) && (0, (0, parcelRequire("c6EdA")).default)(node)) return node;
        return $ea7647704a508683$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(node));
    }
});
parcelRegister("eTUzl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad921528f26834dd$export$2e2bcd8739ae039);
    var $f5IBt;
    var $eVELE;
    var $gmkfg;
    function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
        if ((0, (0, parcelRequire("f5IBt")).default)(element) === 'html') return element;
        return (element.assignedSlot || element.parentNode || ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(element) ? element.host : null) || (0, (0, parcelRequire("eVELE")).default)(element));
    }
});
parcelRegister("gbHJy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8f9908a1e4106f$export$2e2bcd8739ae039);
    var $1Prpe;
    var $f5IBt;
    var $1ix2F;
    var $gmkfg;
    var $6hs9X;
    var $eTUzl;
    var $j5Xhq;
    function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
        if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || (0, (0, parcelRequire("1ix2F")).default)(element).position === 'fixed') return null;
        return element.offsetParent;
    }
    function $bc8f9908a1e4106f$var$getContainingBlock(element) {
        var isFirefox = /firefox/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        var isIE = /Trident/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        if (isIE && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            var elementCss = (0, (0, parcelRequire("1ix2F")).default)(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = (0, (0, parcelRequire("eTUzl")).default)(element);
        if ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(currentNode)) currentNode = currentNode.host;
        while((0, (0, parcelRequire("gmkfg")).isHTMLElement)(currentNode) && [
            'html',
            'body'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(currentNode)) < 0){
            var css = (0, (0, parcelRequire("1ix2F")).default)(currentNode);
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    }
    function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
        var window = (0, (0, parcelRequire("1Prpe")).default)(element);
        var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
        while(offsetParent && (0, (0, parcelRequire("6hs9X")).default)(offsetParent) && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
        if (offsetParent && ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'html' || (0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'body' && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')) return window;
        return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
    }
});
parcelRegister("6hs9X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$492a2c861940c94d$export$2e2bcd8739ae039);
    var $f5IBt;
    function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(element)) >= 0;
    }
});
parcelRegister("kcmIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb468bf0752088cc$export$2e2bcd8739ae039);
    var $kJPed;
    function $eb468bf0752088cc$var$order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        });
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) sort(modifier);
        });
        return result;
    }
    function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
        var orderedModifiers = $eb468bf0752088cc$var$order(modifiers);
        return (0, (0, parcelRequire("kJPed")).modifierPhases).reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
});
parcelRegister("kJPed", function(module, exports) {
    $parcel$export(module.exports, "top", ()=>$f18fbf7b212a7c8e$export$1e95b668f3b82d);
    $parcel$export(module.exports, "bottom", ()=>$f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
    $parcel$export(module.exports, "right", ()=>$f18fbf7b212a7c8e$export$79ffe56a765070d2);
    $parcel$export(module.exports, "left", ()=>$f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
    $parcel$export(module.exports, "auto", ()=>$f18fbf7b212a7c8e$export$dfb5619354ba860);
    $parcel$export(module.exports, "basePlacements", ()=>$f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
    $parcel$export(module.exports, "start", ()=>$f18fbf7b212a7c8e$export$b3571188c770cc5a);
    $parcel$export(module.exports, "end", ()=>$f18fbf7b212a7c8e$export$bd5df0f255a350f8);
    $parcel$export(module.exports, "clippingParents", ()=>$f18fbf7b212a7c8e$export$390fd549c5303b4d);
    $parcel$export(module.exports, "viewport", ()=>$f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
    $parcel$export(module.exports, "popper", ()=>$f18fbf7b212a7c8e$export$ae5ab1c730825774);
    $parcel$export(module.exports, "reference", ()=>$f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
    $parcel$export(module.exports, "variationPlacements", ()=>$f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
    $parcel$export(module.exports, "placements", ()=>$f18fbf7b212a7c8e$export$803cd8101b6c182b);
    $parcel$export(module.exports, "modifierPhases", ()=>$f18fbf7b212a7c8e$export$d087d3878fdf71d5);
    var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
    var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
    var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
    var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
    var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
    var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
        $f18fbf7b212a7c8e$export$1e95b668f3b82d,
        $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
        $f18fbf7b212a7c8e$export$79ffe56a765070d2,
        $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
    ];
    var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
    var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
    var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
    var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
    var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
    var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
    var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$803cd8101b6c182b = [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
        $f18fbf7b212a7c8e$export$dfb5619354ba860
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
    var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
    var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead';
    var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
    var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
    var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain';
    var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
    var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
    var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
    var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
        $f18fbf7b212a7c8e$export$421679a7c3d56e,
        $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
        $f18fbf7b212a7c8e$export$6964f6c886723980,
        $f18fbf7b212a7c8e$export$c65e99957a05207c,
        $f18fbf7b212a7c8e$export$f22da7240b7add18,
        $f18fbf7b212a7c8e$export$bab79516f2d662fe,
        $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
        $f18fbf7b212a7c8e$export$68d8715fc104d294,
        $f18fbf7b212a7c8e$export$70a6e5159acce2e6
    ];
});
parcelRegister("a8clb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7604395822cc5d61$export$2e2bcd8739ae039);
    function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
});
parcelRegister("i9xH7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3733441fcf2e882$export$2e2bcd8739ae039);
    function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {});
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
});
parcelRegister("4TVC8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3918fd6b815bcf57$export$2e2bcd8739ae039);
    var $1Prpe;
    var $3918fd6b815bcf57$var$passive = {
        passive: true
    };
    function $3918fd6b815bcf57$var$effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window = (0, (0, parcelRequire("1Prpe")).default)(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
            });
            if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        };
    }
    var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: $3918fd6b815bcf57$var$effect,
        data: {}
    };
});
parcelRegister("j8nKB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dee1300a39219bb5$export$2e2bcd8739ae039);
    var $dJ0Jl;
    function $dee1300a39219bb5$var$popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        state.modifiersData[name] = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    }
    var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: $dee1300a39219bb5$var$popperOffsets,
        data: {}
    };
});
parcelRegister("dJ0Jl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fe00b5c334118ac$export$2e2bcd8739ae039);
    var $QXpw1;
    var $cGRJ4;
    var $9GF9F;
    var $kJPed;
    function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? (0, (0, parcelRequire("QXpw1")).default)(placement) : null;
        var variation = placement ? (0, (0, parcelRequire("cGRJ4")).default)(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case 0, (0, parcelRequire("kJPed")).top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 0, (0, parcelRequire("kJPed")).left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? (0, (0, parcelRequire("9GF9F")).default)(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case 0, (0, parcelRequire("kJPed")).start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case 0, (0, parcelRequire("kJPed")).end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
                default:
            }
        }
        return offsets;
    }
});
parcelRegister("QXpw1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f2f123ac4a9fdf$export$2e2bcd8739ae039);
    function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[0];
    }
});
parcelRegister("cGRJ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93d315208040ceed$export$2e2bcd8739ae039);
    function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[1];
    }
});
parcelRegister("9GF9F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70d7f5cda4210aa3$export$2e2bcd8739ae039);
    function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
});
parcelRegister("baic6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$820ebddbe0682e4f$export$2e2bcd8739ae039);
    var $kJPed;
    var $gbHJy;
    var $1Prpe;
    var $eVELE;
    var $1ix2F;
    var $QXpw1;
    var $cGRJ4;
    var $90xPK;
    var $820ebddbe0682e4f$var$unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    };
    function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: (0, (0, parcelRequire("90xPK")).round)(x * dpr) / dpr || 0,
            y: (0, (0, parcelRequire("90xPK")).round)(y * dpr) / dpr || 0
        };
    }
    function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = (0, (0, parcelRequire("kJPed")).left);
        var sideY = (0, (0, parcelRequire("kJPed")).top);
        var win = window;
        if (adaptive) {
            var offsetParent = (0, (0, parcelRequire("gbHJy")).default)(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === (0, (0, parcelRequire("1Prpe")).default)(popper)) {
                offsetParent = (0, (0, parcelRequire("eVELE")).default)(popper);
                if ((0, (0, parcelRequire("1ix2F")).default)(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            }
            offsetParent;
            if (placement === (0, (0, parcelRequire("kJPed")).top) || (placement === (0, (0, parcelRequire("kJPed")).left) || placement === (0, (0, parcelRequire("kJPed")).right)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideY = (0, (0, parcelRequire("kJPed")).bottom);
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === (0, (0, parcelRequire("kJPed")).left) || (placement === (0, (0, parcelRequire("kJPed")).top) || placement === (0, (0, parcelRequire("kJPed")).bottom)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideX = (0, (0, parcelRequire("kJPed")).right);
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && $820ebddbe0682e4f$var$unsetSides);
        var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
            x: x,
            y: y
        }, (0, (0, parcelRequire("1Prpe")).default)(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function $820ebddbe0682e4f$var$computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: (0, (0, parcelRequire("QXpw1")).default)(state.placement),
            variation: (0, (0, parcelRequire("cGRJ4")).default)(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    }
    var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: $820ebddbe0682e4f$var$computeStyles,
        data: {}
    };
});
parcelRegister("1AoLg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$127c5c56b9511f5f$export$2e2bcd8739ae039);
    var $f5IBt;
    var $gmkfg;
    function $127c5c56b9511f5f$var$applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name];
            if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function $127c5c56b9511f5f$var$effect(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {});
                if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    }
    var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: $127c5c56b9511f5f$var$applyStyles,
        effect: $127c5c56b9511f5f$var$effect,
        requires: [
            'computeStyles'
        ]
    };
});
parcelRegister("gy4Xr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0c3aad300d72ee1$export$2e2bcd8739ae039);
    var $QXpw1;
    var $kJPed;
    function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
        var invertDistance = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).top)
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function $c0c3aad300d72ee1$var$offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = (0, (0, parcelRequire("kJPed")).placements).reduce(function(acc, placement) {
            acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    }
    var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: $c0c3aad300d72ee1$var$offset
    };
});
parcelRegister("3dDWl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$258191447a7022df$export$2e2bcd8739ae039);
    var $jwSgb;
    var $QXpw1;
    var $4tIVJ;
    var $kgkit;
    var $cqF2x;
    var $kJPed;
    var $cGRJ4;
    function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
        if ((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto)) return [];
        var oppositePlacement = (0, (0, parcelRequire("jwSgb")).default)(placement);
        return [
            (0, (0, parcelRequire("4tIVJ")).default)(placement),
            oppositePlacement,
            (0, (0, parcelRequire("4tIVJ")).default)(oppositePlacement)
        ];
    }
    function $258191447a7022df$var$flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            (0, (0, parcelRequire("jwSgb")).default)(preferredPlacement)
        ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto) ? (0, (0, parcelRequire("cqF2x")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
            var isStartVariation = (0, (0, parcelRequire("cGRJ4")).default)(placement) === (0, (0, parcelRequire("kJPed")).start);
            var isVertical = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).bottom)
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? (0, (0, parcelRequire("kJPed")).right) : (0, (0, parcelRequire("kJPed")).left) : isStartVariation ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).top);
            if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var altVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    }
    var $258191447a7022df$export$2e2bcd8739ae039 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: $258191447a7022df$var$flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
});
parcelRegister("jwSgb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37b1862c86f39c4$export$2e2bcd8739ae039);
    var $e37b1862c86f39c4$var$hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return $e37b1862c86f39c4$var$hash[matched];
        });
    }
});
parcelRegister("4tIVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342cb90cb2622617$export$2e2bcd8739ae039);
    var $342cb90cb2622617$var$hash = {
        start: 'end',
        end: 'start'
    };
    function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return $342cb90cb2622617$var$hash[matched];
        });
    }
});
parcelRegister("kgkit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec050bcf5e349283$export$2e2bcd8739ae039);
    var $dknpr;
    var $eVELE;
    var $g2O7Z;
    var $dJ0Jl;
    var $h8W1z;
    var $kJPed;
    var $gmkfg;
    var $gIXWB;
    var $50KfK;
    function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, (0, parcelRequire("kJPed")).clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, (0, parcelRequire("kJPed")).viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, (0, parcelRequire("kJPed")).popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
        var altContext = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? (0, (0, parcelRequire("kJPed")).reference) : (0, (0, parcelRequire("kJPed")).popper);
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = (0, (0, parcelRequire("dknpr")).default)((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element : element.contextElement || (0, (0, parcelRequire("eVELE")).default)(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = (0, (0, parcelRequire("g2O7Z")).default)(state.elements.reference);
        var popperOffsets = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = (0, (0, parcelRequire("h8W1z")).default)(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? popperClientRect : referenceClientRect;
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset;
        if (elementContext === (0, (0, parcelRequire("kJPed")).popper) && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    (0, (0, parcelRequire("kJPed")).right),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    (0, (0, parcelRequire("kJPed")).top),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
});
parcelRegister("dknpr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3f4d3932acb3b2$export$2e2bcd8739ae039);
    var $kJPed;
    var $3V2hG;
    var $9NXD7;
    var $2r6BH;
    var $gbHJy;
    var $eVELE;
    var $1ix2F;
    var $gmkfg;
    var $g2O7Z;
    var $eTUzl;
    var $j6yPg;
    var $f5IBt;
    var $h8W1z;
    var $90xPK;
    function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === (0, (0, parcelRequire("kJPed")).viewport) ? (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("3V2hG")).default)(element, strategy)) : (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("9NXD7")).default)((0, (0, parcelRequire("eVELE")).default)(element)));
    }
    function $9b3f4d3932acb3b2$var$getClippingParents(element) {
        var clippingParents = (0, (0, parcelRequire("2r6BH")).default)((0, (0, parcelRequire("eTUzl")).default)(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf((0, (0, parcelRequire("1ix2F")).default)(element).position) >= 0;
        var clipperElement = canEscapeClipping && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) ? (0, (0, parcelRequire("gbHJy")).default)(element) : element;
        if (!(0, (0, parcelRequire("gmkfg")).isElement)(clipperElement)) return [];
        return clippingParents.filter(function(clippingParent) {
            return (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) && (0, (0, parcelRequire("j6yPg")).default)(clippingParent, clipperElement) && (0, (0, parcelRequire("f5IBt")).default)(clippingParent) !== 'body';
        });
    }
    function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = (0, (0, parcelRequire("90xPK")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("90xPK")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("90xPK")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("90xPK")).max)(rect.left, accRect.left);
            return accRect;
        }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
});
parcelRegister("3V2hG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2da877912142c34b$export$2e2bcd8739ae039);
    var $1Prpe;
    var $eVELE;
    var $imzt5;
    var $d8bsQ;
    function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(element);
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0, (0, parcelRequire("d8bsQ")).default)();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + (0, (0, parcelRequire("imzt5")).default)(element),
            y: y
        };
    }
});
parcelRegister("9NXD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7236f1f1532b7fe8$export$2e2bcd8739ae039);
    var $eVELE;
    var $1ix2F;
    var $imzt5;
    var $8YTLN;
    var $90xPK;
    function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
        var _element$ownerDocumen;
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var winScroll = (0, (0, parcelRequire("8YTLN")).default)(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = (0, (0, parcelRequire("90xPK")).max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = (0, (0, parcelRequire("90xPK")).max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + (0, (0, parcelRequire("imzt5")).default)(element);
        var y = -winScroll.scrollTop;
        if ((0, (0, parcelRequire("1ix2F")).default)(body || html).direction === 'rtl') x += (0, (0, parcelRequire("90xPK")).max)(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
});
parcelRegister("j6yPg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de89978be23479c4$export$2e2bcd8739ae039);
    var $gmkfg;
    function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode();
        if (parent.contains(child)) return true;
        else if (rootNode && (0, (0, parcelRequire("gmkfg")).isShadowRoot)(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                next = next.parentNode || next.host;
            }while (next)
        }
        return false;
    }
});
parcelRegister("h8W1z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7b0316bb2f8fd97$export$2e2bcd8739ae039);
    function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
});
parcelRegister("gIXWB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2cf410c4fe133f4$export$2e2bcd8739ae039);
    var $1ANH0;
    function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
        return Object.assign({}, (0, (0, parcelRequire("1ANH0")).default)(), paddingObject);
    }
});
parcelRegister("1ANH0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128fb32b18b92ffa$export$2e2bcd8739ae039);
    function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
});
parcelRegister("50KfK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
    function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
});
parcelRegister("cqF2x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c7bf65fbdbec33$export$2e2bcd8739ae039);
    var $cGRJ4;
    var $kJPed;
    var $kgkit;
    var $QXpw1;
    function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, (0, parcelRequire("kJPed")).placements) : _options$allowedAutoP;
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(placement);
        var placements = variation ? flipVariations ? (0, (0, parcelRequire("kJPed")).variationPlacements) : (0, (0, parcelRequire("kJPed")).variationPlacements).filter(function(placement) {
            return (0, (0, parcelRequire("cGRJ4")).default)(placement) === variation;
        }) : (0, (0, parcelRequire("kJPed")).basePlacements);
        var allowedPlacements = placements.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements;
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[(0, (0, parcelRequire("QXpw1")).default)(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
});
parcelRegister("1DdSC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13043339457d5bc5$export$2e2bcd8739ae039);
    var $kJPed;
    var $QXpw1;
    var $9GF9F;
    var $dNtrn;
    var $4WpIh;
    var $jkGDj;
    var $gbHJy;
    var $kgkit;
    var $cGRJ4;
    var $1ANH0;
    var $90xPK;
    function $13043339457d5bc5$var$preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var altAxis = (0, (0, parcelRequire("dNtrn")).default)(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var altSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === (0, (0, parcelRequire("kJPed")).start) ? referenceRect[len] : popperRect[len];
            var maxLen = variation === (0, (0, parcelRequire("kJPed")).start) ? -popperRect[len] : -referenceRect[len];
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? (0, (0, parcelRequire("jkGDj")).default)(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, (0, parcelRequire("1ANH0")).default)();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide];
            var arrowLen = (0, (0, parcelRequire("4WpIh")).within)(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && (0, (0, parcelRequire("gbHJy")).default)(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0, (0, parcelRequire("4WpIh")).within)(tether ? (0, (0, parcelRequire("90xPK")).min)(min, tetherMin) : min, offset, tether ? (0, (0, parcelRequire("90xPK")).max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var _altSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).left)
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? (0, (0, parcelRequire("4WpIh")).withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, (0, parcelRequire("4WpIh")).within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
    var $13043339457d5bc5$export$2e2bcd8739ae039 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: $13043339457d5bc5$var$preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
});
parcelRegister("dNtrn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
    function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
});
parcelRegister("4WpIh", function(module, exports) {
    $parcel$export(module.exports, "within", ()=>$3990864f59117d05$export$f28d906d67a997f3);
    $parcel$export(module.exports, "withinMaxClamp", ()=>$3990864f59117d05$export$86c8af6d3ef0b4a);
    var $90xPK;
    function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
        return (0, (0, parcelRequire("90xPK")).max)(min, (0, (0, parcelRequire("90xPK")).min)(value, max));
    }
    function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
        var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
        return v > max ? max : v;
    }
});
parcelRegister("gzAfz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c10c08bd5e0ed9fb$export$2e2bcd8739ae039);
    var $QXpw1;
    var $jkGDj;
    var $j6yPg;
    var $gbHJy;
    var $9GF9F;
    var $4WpIh;
    var $gIXWB;
    var $50KfK;
    var $kJPed;
    var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
    };
    function $c10c08bd5e0ed9fb$var$arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var axis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var isVertical = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
        var arrowRect = (0, (0, parcelRequire("jkGDj")).default)(arrowElement);
        var minProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
        var maxProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = (0, (0, parcelRequire("gbHJy")).default)(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2;
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = (0, (0, parcelRequire("4WpIh")).within)(min, center, max);
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function $c10c08bd5e0ed9fb$var$effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!(0, (0, parcelRequire("j6yPg")).default)(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    }
    var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: $c10c08bd5e0ed9fb$var$arrow,
        effect: $c10c08bd5e0ed9fb$var$effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
});
parcelRegister("6iLAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$496957b0c691a0ed$export$2e2bcd8739ae039);
    var $kJPed;
    var $kgkit;
    function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
        return [
            (0, (0, parcelRequire("kJPed")).top),
            (0, (0, parcelRequire("kJPed")).right),
            (0, (0, parcelRequire("kJPed")).bottom),
            (0, (0, parcelRequire("kJPed")).left)
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function $496957b0c691a0ed$var$hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    }
    var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: $496957b0c691a0ed$var$hide
    };
});
parcelRegister("iGDLS", function(module, exports) {
    $parcel$export(module.exports, "Reference", ()=>$d9aafffd117cbcc1$export$e0be378c32fb70a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBYjV = parcelRequire("hBYjV");
    var $5n5w4;
    var $eclLw;
    function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
        var children = _ref.children, innerRef = _ref.innerRef;
        var setReferenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeSetterContext));
        var refHandler = $5uXOq.useCallback(function(node) {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, node);
            (0, (0, parcelRequire("eclLw")).safeInvoke)(setReferenceNode, node);
        }, [
            innerRef,
            setReferenceNode
        ]);
        $5uXOq.useEffect(function() {
            return function() {
                return (0, (0, parcelRequire("eclLw")).setRef)(innerRef, null);
            };
        }, []);
        $5uXOq.useEffect(function() {
            (0, ($parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        }, [
            setReferenceNode
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)({
            ref: refHandler
        });
    }
});
parcelRegister("4wJSY", function(module, exports) {
    $parcel$export(module.exports, "shallowEqualObjects", ()=>$34bdbe885d924a05$export$3e67810a3f0e9f1c);
    function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
        if (arrA === arrB) return true;
        if (!arrA || !arrB) return false;
        const len = arrA.length;
        if (arrB.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (arrA[i] !== arrB[i]) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
        if (objA === objB) return true;
        if (!objA || !objB) return false;
        const aKeys = Object.keys(objA);
        const bKeys = Object.keys(objB);
        const len = aKeys.length;
        if (bKeys.length !== len) return false;
        for(let i = 0; i < len; i++){
            const key = aKeys[i];
            if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
        const aIsArr = Array.isArray(a);
        const bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;
        if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
        return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
    }
});
parcelRegister("hT6ku", function(module, exports) {
    $parcel$export(module.exports, "MenuDialog", ()=>$3f79b132df1e01ff$export$c94219dad7c0e37d);
    $parcel$export(module.exports, "DummyControl", ()=>$3f79b132df1e01ff$export$87ce933b7fc29b8c);
    $parcel$export(module.exports, "defaultComponents", ()=>$3f79b132df1e01ff$export$71abc632aa29e6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gMMNe;
    var $bChGW;
    var $k5uoT;
    var $jldZL;
    function $3f79b132df1e01ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3f79b132df1e01ff$var$menuDialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`
    });
    const $3f79b132df1e01ff$export$c94219dad7c0e37d = (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: [
                $3f79b132df1e01ff$var$menuDialogStyles,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ],
            style: style,
            id: id,
            "data-testid": testId && `${testId}--menu`
        }, children));
    const $3f79b132df1e01ff$var$dropdownStyles = {
        name: "7693z9",
        styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
    };
    const $3f79b132df1e01ff$var$DropdownIndicator = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3f79b132df1e01ff$var$dropdownStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("gMMNe"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "open"
        }));
    const $3f79b132df1e01ff$var$controlStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            css: $3f79b132df1e01ff$var$controlStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, {
            ...props,
            innerProps: innerProps
        }));
    const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, props));
    const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $3f79b132df1e01ff$var$IndicatorSeparator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorSeparator, props);
    const $3f79b132df1e01ff$var$ClearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, props);
    const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props);
    const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
        Control: $3f79b132df1e01ff$var$Control,
        DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
        Menu: $3f79b132df1e01ff$var$Menu,
        IndicatorSeparator: $3f79b132df1e01ff$var$IndicatorSeparator,
        ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
        MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
    };
});
parcelRegister("gMMNe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));
    var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
    function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c386fa4cb21167b0$var$SearchIcon = (props)=>$c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
        }, props));
    $c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
    var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;
});
parcelRegister("77ZoC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>$5308cfd5e45a5605$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $5308cfd5e45a5605$var$_search.default
        }));
    $5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;
});
parcelRegister("gJZ5D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f411f5fafa8df6da$export$2e2bcd8739ae039);
    const $f411f5fafa8df6da$var$N20_TRANSPARENT = "var(--ds-background-neutral, rgba(35, 55, 95, 0.05))";
    var $f411f5fafa8df6da$export$2e2bcd8739ae039 = {
        ...(0, $829f609a65d26a98$exports),
        N20_TRANSPARENT: $f411f5fafa8df6da$var$N20_TRANSPARENT
    };
});
parcelRegister("f9Tpd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8e922cecc90207c$export$2e2bcd8739ae039);
    var $co1wz;
    var $7XYc4;
    var $ehHLT;
    var $6svjF;
    const $a8e922cecc90207c$var$ScrollLock = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition'), (0, (0, parcelRequire("6svjF")).default), (0, (0, parcelRequire("ehHLT")).default));
    var $a8e922cecc90207c$export$2e2bcd8739ae039 = $a8e922cecc90207c$var$ScrollLock;
});
parcelRegister("ehHLT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5f371d3236f3c7a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $b5f371d3236f3c7a$var$getLockableScrollAreas = ()=>document.querySelectorAll('[data-scroll="lockable"]');
    let $b5f371d3236f3c7a$var$lockCount = 0;
    function $b5f371d3236f3c7a$export$5cfba70f0315a03f() {
        const nodes = $b5f371d3236f3c7a$var$getLockableScrollAreas();
        $b5f371d3236f3c7a$var$lockCount++;
        Array.from(nodes).forEach((node)=>{
            node.style.overflowY = 'hidden';
        });
    }
    function $b5f371d3236f3c7a$export$bf957eb8a462d4f3() {
        const nodes = $b5f371d3236f3c7a$var$getLockableScrollAreas();
        if ($b5f371d3236f3c7a$var$lockCount > 0) $b5f371d3236f3c7a$var$lockCount--;
        if ($b5f371d3236f3c7a$var$lockCount === 0) Array.from(nodes).forEach((node)=>{
            node.style.overflowY = 'auto';
        });
    }
    function $b5f371d3236f3c7a$export$db7b55565b101966() {
        return $b5f371d3236f3c7a$var$lockCount > 0;
    }
    const $b5f371d3236f3c7a$var$useScrollLock = (enabled)=>{
        (0, $5uXOq.useEffect)(()=>{
            if (enabled) {
                $b5f371d3236f3c7a$export$5cfba70f0315a03f();
                return $b5f371d3236f3c7a$export$bf957eb8a462d4f3;
            }
        }, [
            enabled
        ]);
    };
    const $b5f371d3236f3c7a$var$ScrollLock = ({ children: children = null, enabled: enabled = true })=>{
        $b5f371d3236f3c7a$var$useScrollLock(enabled);
        return children;
    };
    var $b5f371d3236f3c7a$export$2e2bcd8739ae039 = $b5f371d3236f3c7a$var$ScrollLock;
});
parcelRegister("6svjF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$853d17cc1337de7e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $853d17cc1337de7e$var$getLockableScrollAreas = ()=>document.querySelectorAll('[data-scroll="lockable"]');
    const $853d17cc1337de7e$var$lockCounts = {
        horizontal: 0,
        vertical: 0
    };
    function $853d17cc1337de7e$export$db7b55565b101966(axis = (0, $a2e452f6106f8574$export$61b49a5ae59d663)) {
        switch(axis){
            case 0, $a2e452f6106f8574$export$f318c07624159aa0:
                return $853d17cc1337de7e$var$lockCounts.horizontal > 0;
            case 0, $a2e452f6106f8574$export$9f2fe7df0ae9fdea:
                return $853d17cc1337de7e$var$lockCounts.vertical > 0;
            default:
                return $853d17cc1337de7e$var$lockCounts.horizontal > 0 || $853d17cc1337de7e$var$lockCounts.vertical > 0;
        }
    }
    function $853d17cc1337de7e$export$5cfba70f0315a03f(axis) {
        const nodes = $853d17cc1337de7e$var$getLockableScrollAreas();
        const lockHorizontal = axis === (0, $a2e452f6106f8574$export$f318c07624159aa0) || axis === (0, $a2e452f6106f8574$export$61b49a5ae59d663);
        const lockVertical = axis === (0, $a2e452f6106f8574$export$9f2fe7df0ae9fdea) || axis === (0, $a2e452f6106f8574$export$61b49a5ae59d663);
        if (lockHorizontal) $853d17cc1337de7e$var$lockCounts.horizontal++;
        if (lockVertical) $853d17cc1337de7e$var$lockCounts.vertical++;
        Array.from(nodes).forEach((node)=>{
            if ($853d17cc1337de7e$export$db7b55565b101966((0, $a2e452f6106f8574$export$f318c07624159aa0))) node.style.overflowX = 'hidden';
            if ($853d17cc1337de7e$export$db7b55565b101966((0, $a2e452f6106f8574$export$9f2fe7df0ae9fdea))) node.style.overflowY = 'hidden';
        });
    }
    function $853d17cc1337de7e$export$bf957eb8a462d4f3(axis) {
        const nodes = $853d17cc1337de7e$var$getLockableScrollAreas();
        const unlockHorizontal = axis === (0, $a2e452f6106f8574$export$f318c07624159aa0) || axis === (0, $a2e452f6106f8574$export$61b49a5ae59d663);
        const unlockVertical = axis === (0, $a2e452f6106f8574$export$9f2fe7df0ae9fdea) || axis === (0, $a2e452f6106f8574$export$61b49a5ae59d663);
        if ($853d17cc1337de7e$export$db7b55565b101966((0, $a2e452f6106f8574$export$f318c07624159aa0)) && unlockHorizontal) $853d17cc1337de7e$var$lockCounts.horizontal--;
        if ($853d17cc1337de7e$export$db7b55565b101966((0, $a2e452f6106f8574$export$9f2fe7df0ae9fdea)) && unlockVertical) $853d17cc1337de7e$var$lockCounts.vertical--;
        Array.from(nodes).forEach((node)=>{
            if (!$853d17cc1337de7e$export$db7b55565b101966((0, $a2e452f6106f8574$export$f318c07624159aa0))) node.style.overflowX = 'auto';
            if (!$853d17cc1337de7e$export$db7b55565b101966((0, $a2e452f6106f8574$export$9f2fe7df0ae9fdea))) node.style.overflowY = 'auto';
        });
    }
    const $853d17cc1337de7e$var$useScrollLock = (axis, enabled)=>{
        (0, $5uXOq.useEffect)(()=>{
            if (enabled) {
                $853d17cc1337de7e$export$5cfba70f0315a03f(axis);
                return ()=>$853d17cc1337de7e$export$bf957eb8a462d4f3(axis);
            }
        }, [
            axis,
            enabled
        ]);
    };
    const $853d17cc1337de7e$var$ScrollLock = ({ children: children = null, axis: axis = (0, $a2e452f6106f8574$export$9f2fe7df0ae9fdea), enabled: enabled = true })=>{
        $853d17cc1337de7e$var$useScrollLock(axis, enabled);
        return children;
    };
    var $853d17cc1337de7e$export$2e2bcd8739ae039 = $853d17cc1337de7e$var$ScrollLock;
});
const $a2e452f6106f8574$export$f318c07624159aa0 = 'horizontal';
const $a2e452f6106f8574$export$9f2fe7df0ae9fdea = 'vertical';
const $a2e452f6106f8574$export$61b49a5ae59d663 = 'all';
parcelRegister("7chIQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57e5023fdfd11a17$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    const $57e5023fdfd11a17$var$inputStyle = (isHidden)=>({
            background: 0,
            border: 0,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            opacity: isHidden ? 0 : 1,
            outline: 0,
            padding: 0,
            color: 'inherit',
            boxSizing: 'content-box',
            width: '100%'
        });
    const $57e5023fdfd11a17$var$Input = ({ className: className, cx: cx, getStyles: getStyles, innerRef: innerRef, isHidden: isHidden, isDisabled: isDisabled, selectProps: selectProps, ...props })=>{
        const { isMulti: isMulti, isRtl: isRtl, hasValue: hasValue, setValue: setValue, getValue: getValue, clearValue: clearValue, selectOption: selectOption, ...validHTMLProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                ...getStyles('input', props),
                gridTemplateColumns: 'unset'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            autoFocus: !(0, parcelRequire("3nPAF")).default(selectProps.value) && selectProps.menuIsOpen,
            className: cx(null, {
                input: true
            }, className),
            ref: innerRef,
            style: $57e5023fdfd11a17$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...validHTMLProps,
            "aria-describedby": selectProps['aria-describedby']
        }));
    };
    var $57e5023fdfd11a17$export$2e2bcd8739ae039 = $57e5023fdfd11a17$var$Input;
});
parcelRegister("3nPAF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$276b89ddbe7c5b3b$export$2e2bcd8739ae039);
    var $ccUYa;
    var $9r4IJ;
    var $8EB5I;
    var $276b89ddbe7c5b3b$var$isEmpty = (0, (0, parcelRequire("ccUYa")).default)(function isEmpty(x) {
        return x != null && (0, (0, parcelRequire("8EB5I")).default)(x, (0, (0, parcelRequire("9r4IJ")).default)(x));
    });
    var $276b89ddbe7c5b3b$export$2e2bcd8739ae039 = $276b89ddbe7c5b3b$var$isEmpty;
});
parcelRegister("ccUYa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e32cbf2c9cb3af3$export$2e2bcd8739ae039);
    var $iU24A;
    function $8e32cbf2c9cb3af3$export$2e2bcd8739ae039(fn) {
        return function f1(a) {
            if (arguments.length === 0 || (0, (0, parcelRequire("iU24A")).default)(a)) return f1;
            else return fn.apply(this, arguments);
        };
    }
});
parcelRegister("iU24A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc2f10a18a9bb545$export$2e2bcd8739ae039);
    function $dc2f10a18a9bb545$export$2e2bcd8739ae039(a) {
        return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
    }
});
parcelRegister("9r4IJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6dea4c13d578361d$export$2e2bcd8739ae039);
    var $ccUYa;
    var $4M6EI;
    var $cWyha;
    var $3jGND;
    var $fsmuk;
    var $6dea4c13d578361d$var$empty = (0, (0, parcelRequire("ccUYa")).default)(function empty(x) {
        return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : (0, (0, parcelRequire("cWyha")).default)(x) ? [] : (0, (0, parcelRequire("fsmuk")).default)(x) ? '' : (0, (0, parcelRequire("3jGND")).default)(x) ? {} : (0, (0, parcelRequire("4M6EI")).default)(x) ? function() {
            return arguments;
        }() : void 0;
    });
    var $6dea4c13d578361d$export$2e2bcd8739ae039 = $6dea4c13d578361d$var$empty;
});
parcelRegister("4M6EI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37a0cecd8848dd87$export$2e2bcd8739ae039);
    var $65NM6;
    var $37a0cecd8848dd87$var$toString = Object.prototype.toString;
    var $37a0cecd8848dd87$var$_isArguments = function() {
        return $37a0cecd8848dd87$var$toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
            return $37a0cecd8848dd87$var$toString.call(x) === '[object Arguments]';
        } : function _isArguments(x) {
            return (0, (0, parcelRequire("65NM6")).default)('callee', x);
        };
    }();
    var $37a0cecd8848dd87$export$2e2bcd8739ae039 = $37a0cecd8848dd87$var$_isArguments;
});
parcelRegister("65NM6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46f9d1f5172cef26$export$2e2bcd8739ae039);
    function $46f9d1f5172cef26$export$2e2bcd8739ae039(prop, obj) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
});
parcelRegister("cWyha", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c57d451049b334$export$2e2bcd8739ae039);
    var $96c57d451049b334$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
        return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
    };
});
parcelRegister("3jGND", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26a4588812abfefb$export$2e2bcd8739ae039);
    function $26a4588812abfefb$export$2e2bcd8739ae039(x) {
        return Object.prototype.toString.call(x) === '[object Object]';
    }
});
parcelRegister("fsmuk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b40aea3ed3f7f884$export$2e2bcd8739ae039);
    function $b40aea3ed3f7f884$export$2e2bcd8739ae039(x) {
        return Object.prototype.toString.call(x) === '[object String]';
    }
});
parcelRegister("8EB5I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64ced4b0fe17463d$export$2e2bcd8739ae039);
    var $c9RLn;
    var $d6Mlv;
    var $64ced4b0fe17463d$var$equals = (0, (0, parcelRequire("c9RLn")).default)(function equals(a, b) {
        return (0, (0, parcelRequire("d6Mlv")).default)(a, b, [], []);
    });
    var $64ced4b0fe17463d$export$2e2bcd8739ae039 = $64ced4b0fe17463d$var$equals;
});
parcelRegister("c9RLn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8da0078a7b144f9d$export$2e2bcd8739ae039);
    var $ccUYa;
    var $iU24A;
    function $8da0078a7b144f9d$export$2e2bcd8739ae039(fn) {
        return function f2(a, b) {
            switch(arguments.length){
                case 0:
                    return f2;
                case 1:
                    return (0, (0, parcelRequire("iU24A")).default)(a) ? f2 : (0, (0, parcelRequire("ccUYa")).default)(function(_b) {
                        return fn(a, _b);
                    });
                default:
                    return (0, (0, parcelRequire("iU24A")).default)(a) && (0, (0, parcelRequire("iU24A")).default)(b) ? f2 : (0, (0, parcelRequire("iU24A")).default)(a) ? (0, (0, parcelRequire("ccUYa")).default)(function(_a) {
                        return fn(_a, b);
                    }) : (0, (0, parcelRequire("iU24A")).default)(b) ? (0, (0, parcelRequire("ccUYa")).default)(function(_b) {
                        return fn(a, _b);
                    }) : fn(a, b);
            }
        };
    }
});
parcelRegister("d6Mlv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98b1565d93335ab5$export$2e2bcd8739ae039);
    var $hPJXF;
    var $hTO4g;
    var $7BXxl;
    var $65NM6;
    var $ebXyp;
    var $76p2G;
    var $lTdwg;
    function $98b1565d93335ab5$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
        var a = (0, (0, parcelRequire("hPJXF")).default)(aIterator);
        var b = (0, (0, parcelRequire("hPJXF")).default)(bIterator);
        function eq(_a, _b) {
            return $98b1565d93335ab5$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
        }
        return !(0, (0, parcelRequire("hTO4g")).default)(function(b, aItem) {
            return !(0, (0, parcelRequire("hTO4g")).default)(eq, aItem, b);
        }, b, a);
    }
    function $98b1565d93335ab5$export$2e2bcd8739ae039(a, b, stackA, stackB) {
        if ((0, (0, parcelRequire("ebXyp")).default)(a, b)) return true;
        var typeA = (0, (0, parcelRequire("lTdwg")).default)(a);
        if (typeA !== (0, (0, parcelRequire("lTdwg")).default)(b)) return false;
        if (a == null || b == null) return false;
        if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
        if (typeof a.equals === 'function' || typeof b.equals === 'function') return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
        switch(typeA){
            case 'Arguments':
            case 'Array':
            case 'Object':
                if (typeof a.constructor === 'function' && (0, (0, parcelRequire("7BXxl")).default)(a.constructor) === 'Promise') return a === b;
                break;
            case 'Boolean':
            case 'Number':
            case 'String':
                if (!(typeof a === typeof b && (0, (0, parcelRequire("ebXyp")).default)(a.valueOf(), b.valueOf()))) return false;
                break;
            case 'Date':
                if (!(0, (0, parcelRequire("ebXyp")).default)(a.valueOf(), b.valueOf())) return false;
                break;
            case 'Error':
                return a.name === b.name && a.message === b.message;
            case 'RegExp':
                if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
                break;
        }
        var idx = stackA.length - 1;
        while(idx >= 0){
            if (stackA[idx] === a) return stackB[idx] === b;
            idx -= 1;
        }
        switch(typeA){
            case 'Map':
                if (a.size !== b.size) return false;
                return $98b1565d93335ab5$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                    a
                ]), stackB.concat([
                    b
                ]));
            case 'Set':
                if (a.size !== b.size) return false;
                return $98b1565d93335ab5$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                    a
                ]), stackB.concat([
                    b
                ]));
            case 'Arguments':
            case 'Array':
            case 'Object':
            case 'Boolean':
            case 'Number':
            case 'String':
            case 'Date':
            case 'Error':
            case 'RegExp':
            case 'Int8Array':
            case 'Uint8Array':
            case 'Uint8ClampedArray':
            case 'Int16Array':
            case 'Uint16Array':
            case 'Int32Array':
            case 'Uint32Array':
            case 'Float32Array':
            case 'Float64Array':
            case 'ArrayBuffer':
                break;
            default:
                return false;
        }
        var keysA = (0, (0, parcelRequire("76p2G")).default)(a);
        if (keysA.length !== (0, (0, parcelRequire("76p2G")).default)(b).length) return false;
        var extendedStackA = stackA.concat([
            a
        ]);
        var extendedStackB = stackB.concat([
            b
        ]);
        idx = keysA.length - 1;
        while(idx >= 0){
            var key = keysA[idx];
            if (!((0, (0, parcelRequire("65NM6")).default)(key, b) && $98b1565d93335ab5$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
            idx -= 1;
        }
        return true;
    }
});
parcelRegister("hPJXF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfbada0a0e1fe1ed$export$2e2bcd8739ae039);
    function $cfbada0a0e1fe1ed$export$2e2bcd8739ae039(iter) {
        var list = [];
        var next;
        while(!(next = iter.next()).done)list.push(next.value);
        return list;
    }
});
parcelRegister("hTO4g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d07e6924a8704a1e$export$2e2bcd8739ae039);
    function $d07e6924a8704a1e$export$2e2bcd8739ae039(pred, x, list) {
        var idx = 0;
        var len = list.length;
        while(idx < len){
            if (pred(x, list[idx])) return true;
            idx += 1;
        }
        return false;
    }
});
parcelRegister("7BXxl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58aa2be261b1373c$export$2e2bcd8739ae039);
    function $58aa2be261b1373c$export$2e2bcd8739ae039(f) {
        var match = String(f).match(/^function (\w*)/);
        return match == null ? '' : match[1];
    }
});
parcelRegister("ebXyp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a55049f47253014f$export$2e2bcd8739ae039);
    function $a55049f47253014f$var$_objectIs(a, b) {
        if (a === b) return a !== 0 || 1 / a === 1 / b;
        else return a !== a && b !== b;
    }
    var $a55049f47253014f$export$2e2bcd8739ae039 = typeof Object.is === 'function' ? Object.is : $a55049f47253014f$var$_objectIs;
});
parcelRegister("76p2G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52bc84d2b6befa28$export$2e2bcd8739ae039);
    var $ccUYa;
    var $65NM6;
    var $4M6EI;
    var $52bc84d2b6befa28$var$hasEnumBug = !({
        toString: null
    }).propertyIsEnumerable('toString');
    var $52bc84d2b6befa28$var$nonEnumerableProps = [
        'constructor',
        'valueOf',
        'isPrototypeOf',
        'toString',
        'propertyIsEnumerable',
        'hasOwnProperty',
        'toLocaleString'
    ];
    var $52bc84d2b6befa28$var$hasArgsEnumBug = function() {
        'use strict';
        return arguments.propertyIsEnumerable('length');
    }();
    var $52bc84d2b6befa28$var$contains = function contains(list, item) {
        var idx = 0;
        while(idx < list.length){
            if (list[idx] === item) return true;
            idx += 1;
        }
        return false;
    };
    var $52bc84d2b6befa28$var$keys = typeof Object.keys === 'function' && !$52bc84d2b6befa28$var$hasArgsEnumBug ? (0, (0, parcelRequire("ccUYa")).default)(function keys(obj) {
        return Object(obj) !== obj ? [] : Object.keys(obj);
    }) : (0, (0, parcelRequire("ccUYa")).default)(function keys(obj) {
        if (Object(obj) !== obj) return [];
        var prop, nIdx;
        var ks = [];
        var checkArgsLength = $52bc84d2b6befa28$var$hasArgsEnumBug && (0, (0, parcelRequire("4M6EI")).default)(obj);
        for(prop in obj)if ((0, (0, parcelRequire("65NM6")).default)(prop, obj) && (!checkArgsLength || prop !== 'length')) ks[ks.length] = prop;
        if ($52bc84d2b6befa28$var$hasEnumBug) {
            nIdx = $52bc84d2b6befa28$var$nonEnumerableProps.length - 1;
            while(nIdx >= 0){
                prop = $52bc84d2b6befa28$var$nonEnumerableProps[nIdx];
                if ((0, (0, parcelRequire("65NM6")).default)(prop, obj) && !$52bc84d2b6befa28$var$contains(ks, prop)) ks[ks.length] = prop;
                nIdx -= 1;
            }
        }
        return ks;
    });
    var $52bc84d2b6befa28$export$2e2bcd8739ae039 = $52bc84d2b6befa28$var$keys;
});
parcelRegister("lTdwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fef938ace5d66616$export$2e2bcd8739ae039);
    var $ccUYa;
    var $fef938ace5d66616$var$type = (0, (0, parcelRequire("ccUYa")).default)(function type(val) {
        return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
    });
    var $fef938ace5d66616$export$2e2bcd8739ae039 = $fef938ace5d66616$var$type;
});
parcelRegister("1KSaX", function(module, exports) {
    $parcel$export(module.exports, "avatar", ()=>$14741c7bf13ae9bc$export$345c5736c8054f22, (v)=>$14741c7bf13ae9bc$export$345c5736c8054f22 = v);
    $parcel$export(module.exports, "issue-icon", ()=>$14741c7bf13ae9bc$export$39bed5d6a23c78de, (v)=>$14741c7bf13ae9bc$export$39bed5d6a23c78de = v);
    $parcel$export(module.exports, "issue-summary", ()=>$14741c7bf13ae9bc$export$ace0486c2e1c4abe, (v)=>$14741c7bf13ae9bc$export$ace0486c2e1c4abe = v);
    $parcel$export(module.exports, "label", ()=>$14741c7bf13ae9bc$export$1237798dc640739a, (v)=>$14741c7bf13ae9bc$export$1237798dc640739a = v);
    $parcel$export(module.exports, "select-option", ()=>$14741c7bf13ae9bc$export$25439fa9d099d50b, (v)=>$14741c7bf13ae9bc$export$25439fa9d099d50b = v);
    $parcel$export(module.exports, "truncated", ()=>$14741c7bf13ae9bc$export$23ef198012fb7186, (v)=>$14741c7bf13ae9bc$export$23ef198012fb7186 = v);
    var $14741c7bf13ae9bc$export$345c5736c8054f22;
    var $14741c7bf13ae9bc$export$39bed5d6a23c78de;
    var $14741c7bf13ae9bc$export$ace0486c2e1c4abe;
    var $14741c7bf13ae9bc$export$1237798dc640739a;
    var $14741c7bf13ae9bc$export$25439fa9d099d50b;
    var $14741c7bf13ae9bc$export$23ef198012fb7186;
    $14741c7bf13ae9bc$export$345c5736c8054f22 = `BubBCW_avatar`;
    $14741c7bf13ae9bc$export$39bed5d6a23c78de = `BubBCW_issue-icon`;
    $14741c7bf13ae9bc$export$ace0486c2e1c4abe = `BubBCW_issue-summary`;
    $14741c7bf13ae9bc$export$1237798dc640739a = `BubBCW_label`;
    $14741c7bf13ae9bc$export$25439fa9d099d50b = `BubBCW_select-option`;
    $14741c7bf13ae9bc$export$23ef198012fb7186 = `BubBCW_truncated`;
});
parcelRegister("eVD3E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f669390bd9cefae5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8eWTv = parcelRequire("8eWTv");
    var $f669390bd9cefae5$export$2e2bcd8739ae039 = ({ isReadOnly: isReadOnly, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $8eWTv.default), {
            ...props,
            isDisabled: isReadOnly,
            isReadOnly: isReadOnly
        });
});
parcelRegister("8eWTv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6bd349992292ed3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $34ck9 = parcelRequire("34ck9");
    var $9ci4W = parcelRequire("9ci4W");
    var $d9xxV;
    var $3bDjY;
    var $iwfmd;
    var $bChGW;
    var $3FQWJ = parcelRequire("3FQWJ");
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $cSDJf = parcelRequire("cSDJf");
    var $jfSkn = parcelRequire("jfSkn");
    var $dzoWn = parcelRequire("dzoWn");
    class $6bd349992292ed3c$export$4ae427e87d8482e2 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isCreatable: false,
                HoverObserver: (0, parcelRequire("iwfmd")).default
            };
        }
        static getDerivedStateFromProps(props, state) {
            return {
                ...state,
                selectedOptions: props.getValues(props.issue, props.attribute)
            };
        }
        componentDidMount() {
            if (this.props.menuIsOpen) this.getOptions('');
        }
        getOptions(query) {
            this.setState({
                isLoading: true
            });
            this.props.fetchOptions(query).then((options)=>{
                this.setState({
                    options: options,
                    isLoading: false
                });
            });
        }
        render() {
            const { attribute: attribute, issue: issue, messages: messages, FieldSelect: FieldSelect, isReadOnly: isReadOnly, isDisabled: isDisabled, isCreatable: isCreatable, customNoOptionsMessage: customNoOptionsMessage, formatCreateLabel: formatCreateLabel, validateInputForCreation: validateInputForCreation, HoverObserver: HoverObserver, menuIsOpen: menuIsOpen } = this.props;
            const values = this.state.selectedOptions;
            const noOptionsMessage = ({ inputValue: inputValue })=>{
                if (customNoOptionsMessage) {
                    const message = customNoOptionsMessage(inputValue);
                    if (message) return message;
                }
                if (inputValue === '' && (0, ($parcel$interopDefault($gccSB)))(values)) return messages.noLabels;
                if (inputValue === '' && !(0, ($parcel$interopDefault($gccSB)))(values)) return messages.noLabelsLeft;
                return messages.noMatch;
            };
            const getFieldSelect = ()=>isDisabled || isReadOnly ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $jfSkn.labelsContainer
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $jfSkn.itemsWrapper
                }, values && values.length > 0 && this.renderMultipleLabels(values, (0, ($parcel$interopDefault($9ci4W)))($jfSkn.item, {
                    [$jfSkn.disabled]: isDisabled && !isReadOnly
                })))) : (0, ($parcel$interopDefault($5uXOq))).createElement(FieldSelect, {
                    isMulti: true,
                    isCreatable: isCreatable,
                    formatCreateLabel: formatCreateLabel,
                    isLoading: this.state.isLoading,
                    value: values,
                    onChange: this.handleChange,
                    onMenuOpen: ()=>this.getOptions(''),
                    onInputChange: this.handleInputChange,
                    options: this.state.options,
                    closeMenuOnSelect: false,
                    styles: (0, $dzoWn.selectStyles),
                    minSelectWidth: (0, $cSDJf.MIN_SELECT_WIDTH),
                    isTransparentBackground: false,
                    placeholder: messages.placeholder,
                    noOptionsMessage: noOptionsMessage,
                    issueId: issue.id,
                    attribute: attribute,
                    components: {
                        Control: this.getControlComponent
                    },
                    isDisabled: isReadOnly || isDisabled,
                    onCreateOption: this.handleCreateOption,
                    isValidNewOption: validateInputForCreation,
                    menuIsOpen: menuIsOpen
                });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
                attribute: attribute,
                issue: issue,
                isScrolling: false,
                showOptimizations: false
            }, (0, $4nDwW.isDefined)(HoverObserver) ? (0, ($parcel$interopDefault($5uXOq))).createElement(HoverObserver, {
                onHoverChanged: this.setHovered
            }, getFieldSelect()) : getFieldSelect());
        }
        constructor(...args){
            super(...args);
            this.state = {
                isLoading: false,
                options: [],
                isHovered: false,
                selectedOptions: []
            };
            this.throttledGetOptions = (0, ($parcel$interopDefault($34ck9)))(this.getOptions, 250);
            this.handleInputChange = (value, { action: action })=>{
                if (action === 'input-change' || action === 'input-blur') this.throttledGetOptions(value);
                if (action === 'set-value') this.throttledGetOptions('');
            };
            this.setHovered = (isHovered)=>this.setState({
                    isHovered: isHovered
                });
            this.handleChange = (options)=>{
                this.setState({
                    selectedOptions: Array.isArray(options) ? options : []
                });
                this.props.onChange(this.props.issue, options || []);
            };
            this.handleCreateOption = (inputValue)=>{
                this.props.onCreateOption && this.props.onCreateOption(inputValue);
                const newOption = this.props.convertCreatedLabelToOption && this.props.convertCreatedLabelToOption(inputValue) || {};
                const newSelectedOptions = [
                    ...this.state.selectedOptions,
                    newOption
                ];
                this.setState({
                    selectedOptions: newSelectedOptions
                });
                this.props.onChange(this.props.issue, newSelectedOptions);
            };
            this.renderMultipleLabels = (selectedValues, itemClasses)=>{
                const title = selectedValues.map((value)=>value.label).join(', ');
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: title
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $jfSkn.tagContainer
                }, selectedValues.map(({ label: label, value: value })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        key: value,
                        className: itemClasses
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
                        text: label
                    })))));
            };
            this.getControlComponent = (props)=>{
                const { isReadOnly: isReadOnly, isDisabled: isDisabled } = this.props;
                const { isHovered: isHovered } = this.state;
                const { selectProps: { menuIsOpen: menuIsOpen, value: value, onMenuOpen: onMenuOpen } } = props;
                const isDefaultControl = menuIsOpen || isHovered && (0, ($parcel$interopDefault($gccSB)))(value) && !isDisabled && !isReadOnly;
                const className = (0, ($parcel$interopDefault($9ci4W)))($jfSkn.componentsContainer, {
                    [$jfSkn.componentsContainerDisabled]: isDisabled,
                    [$jfSkn.hiddenContainer]: isDefaultControl
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Control, {
                    ...props,
                    isFocused: menuIsOpen
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isDefaultControl && props.children, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: className,
                    role: "button",
                    tabIndex: 0,
                    onClick: onMenuOpen
                }, value && value.length > 0 && this.renderMultipleLabels(value, (0, ($parcel$interopDefault($9ci4W)))($jfSkn.item, {
                    [$jfSkn.disabled]: isDisabled && !isReadOnly
                })))));
            };
        }
    }
    var $6bd349992292ed3c$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        FieldSelect: (0, $ixSW4.slots).FieldSelect
    })($6bd349992292ed3c$export$4ae427e87d8482e2);
});
parcelRegister("d9xxV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87927dab24395a15$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5oSQr;
    var $aXLIT;
    var $eYXIO;
    const $87927dab24395a15$var$SimpleTagComponent = (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
        const content = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eYXIO")).default), {
            elemBefore: elemBefore,
            isRemovable: false,
            text: text,
            color: color,
            href: href,
            linkComponent: linkComponent
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5oSQr")).default), {
            ref: ref,
            testId: testId,
            href: href,
            appearance: appearance,
            color: color,
            before: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aXLIT")).default), {
                elemBefore: elemBefore
            }),
            contentElement: content
        });
    });
    const $87927dab24395a15$var$SimpleTag = (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
    var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;
});
parcelRegister("5oSQr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db35d9df42c66ff0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $e6s40;
    var $2hnSR;
    function $db35d9df42c66ff0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $db35d9df42c66ff0$var$baseStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        minWidth: 0,
        height: (0, (0, parcelRequire("e6s40")).tagHeight),
        margin: (0, (0, parcelRequire("e6s40")).defaultMargin),
        padding: "var(--ds-space-0, 0px)",
        position: 'relative',
        backgroundColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.background.default})`,
        borderRadius: `var(${(0, (0, parcelRequire("e6s40")).cssVar).borderRadius})`,
        color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.default})`,
        cursor: 'default'
    });
    const $db35d9df42c66ff0$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        minWidth: 0,
        height: (0, (0, parcelRequire("e6s40")).tagHeight),
        margin: (0, (0, parcelRequire("e6s40")).defaultMargin),
        position: 'relative',
        alignItems: 'center',
        gap: "var(--ds-space-050, 4px)",
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        border: 'solid',
        borderColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.borderColor})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        color: "var(--ds-text, #172B4D)",
        cursor: 'default',
        paddingInline: "var(--ds-space-050, 4px)"
    });
    const $db35d9df42c66ff0$var$interactiveStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.background.hover})`
        },
        '&:active': {
            backgroundColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.background.active})`
        }
    });
    const $db35d9df42c66ff0$var$interactiveStyles = {
        name: "jcdcgl",
        styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
    };
    const $db35d9df42c66ff0$var$focusRingStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:focus-within': {
            boxShadow: `0 0 0 2px var(${(0, (0, parcelRequire("e6s40")).cssVar).color.focusRing})`,
            outline: 'none'
        }
    });
    const $db35d9df42c66ff0$var$focusRingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:focus-within': {
            outline: `2px solid ${(0, parcelRequire("2hnSR")).focusRingColors}`,
            outlineOffset: '2px '
        }
    });
    const $db35d9df42c66ff0$var$nonStandardLinkStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:active': {
            color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.active})`
        }
    });
    const $db35d9df42c66ff0$var$BaseTag = (0, ($parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
        const isLink = Boolean(href);
        const isRemovable = Boolean(after);
        const isInteractive = isLink || isRemovable;
        const isStandardLink = isLink && color === 'standard';
        const textLinkColors = isStandardLink ? (0, parcelRequire("2hnSR")).textColors['standardLink'] : (0, parcelRequire("2hnSR")).textColors[color];
        const backgroundHoverColors = isRemovable && !isLink ? (0, parcelRequire("2hnSR")).backgroundColors[color] : (0, parcelRequire("2hnSR")).linkHoverBackgroundColors[color];
        const backgroundActiveColors = isRemovable && !isLink ? (0, parcelRequire("2hnSR")).backgroundColors[color] : (0, parcelRequire("2hnSR")).linkActiveBackgroundColors[color];
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...other,
            ref: ref,
            css: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$baseStyles : $db35d9df42c66ff0$var$baseStylesOld,
                isInteractive && ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$focusRingStyles : $db35d9df42c66ff0$var$focusRingStylesOld),
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? isLink && $db35d9df42c66ff0$var$interactiveStyles : undefined,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $db35d9df42c66ff0$var$nonStandardLinkStyles,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && isInteractive && $db35d9df42c66ff0$var$interactiveStylesOld
            ],
            style: {
                [(0, (0, parcelRequire("e6s40")).cssVar).color.borderColor]: (0, parcelRequire("2hnSR")).borderColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.default]: (0, parcelRequire("2hnSR")).textColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.hover]: (0, parcelRequire("2hnSR")).textHoverColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.active]: (0, parcelRequire("2hnSR")).textActiveColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.link]: textLinkColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.background.default]: (0, parcelRequire("2hnSR")).backgroundColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.background.hover]: backgroundHoverColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.background.active]: backgroundActiveColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.focusRing]: (0, parcelRequire("2hnSR")).focusRingColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.removeButton.default]: (0, parcelRequire("2hnSR")).removeButtonColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.removeButton.hover]: (0, parcelRequire("2hnSR")).removeButtonHoverColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).borderRadius]: (0, parcelRequire("2hnSR")).borderRadius[appearance],
                ...style
            },
            className: className,
            "data-testid": testId
        }, before, contentElement, after);
    });
    var $db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;
});
parcelRegister("e6s40", function(module, exports) {
    $parcel$export(module.exports, "tagHeight", ()=>$1dd8b7ac532261be$export$5b2b1030a679f37);
    $parcel$export(module.exports, "buttonWidthUnitless", ()=>$1dd8b7ac532261be$export$c6f3ea2b4cffd0ca);
    $parcel$export(module.exports, "maxTextWidthUnitless", ()=>$1dd8b7ac532261be$export$2e3bcb01bf928995);
    $parcel$export(module.exports, "maxTextWidth", ()=>$1dd8b7ac532261be$export$982d4a1a6de11130);
    $parcel$export(module.exports, "defaultBorderRadius", ()=>$1dd8b7ac532261be$export$35d5d1e251b985cf);
    $parcel$export(module.exports, "defaultRoundedBorderRadius", ()=>$1dd8b7ac532261be$export$c49771100fee18c8);
    $parcel$export(module.exports, "defaultMargin", ()=>$1dd8b7ac532261be$export$6728fea658cfb92e);
    $parcel$export(module.exports, "defaultTextPadding", ()=>$1dd8b7ac532261be$export$c2d03c4c68282362);
    $parcel$export(module.exports, "textPaddingRight", ()=>$1dd8b7ac532261be$export$b5686dedf408caa0);
    $parcel$export(module.exports, "textMarginLeft", ()=>$1dd8b7ac532261be$export$b824cac86306f7a2);
    $parcel$export(module.exports, "cssVar", ()=>$1dd8b7ac532261be$export$8b4981022bd80a4e);
    var $k5uoT;
    const $1dd8b7ac532261be$var$gridSizeValue = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $1dd8b7ac532261be$var$borderRadiusValue = (0, (0, parcelRequire("k5uoT")).borderRadius)();
    const $1dd8b7ac532261be$export$b4d89c3994664204 = 2.5 * $1dd8b7ac532261be$var$gridSizeValue;
    const $1dd8b7ac532261be$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$1dd8b7ac532261be$export$b4d89c3994664204}px`})`;
    const $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca = $1dd8b7ac532261be$export$b4d89c3994664204;
    const $1dd8b7ac532261be$export$aba002ef70684916 = $1dd8b7ac532261be$export$5b2b1030a679f37;
    const $1dd8b7ac532261be$export$d5949a2c2ea9dcea = 25 * $1dd8b7ac532261be$var$gridSizeValue;
    const $1dd8b7ac532261be$export$488fda99655ff65a = `${$1dd8b7ac532261be$export$d5949a2c2ea9dcea}px`;
    const $1dd8b7ac532261be$export$2e3bcb01bf928995 = $1dd8b7ac532261be$export$d5949a2c2ea9dcea - $1dd8b7ac532261be$export$b4d89c3994664204;
    const $1dd8b7ac532261be$export$982d4a1a6de11130 = `${$1dd8b7ac532261be$export$2e3bcb01bf928995}px`;
    const $1dd8b7ac532261be$export$35d5d1e251b985cf = `${$1dd8b7ac532261be$var$borderRadiusValue}px`;
    const $1dd8b7ac532261be$export$c49771100fee18c8 = `${$1dd8b7ac532261be$export$c6f3ea2b4cffd0ca / 2}px`;
    const $1dd8b7ac532261be$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
    const $1dd8b7ac532261be$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
    const $1dd8b7ac532261be$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $1dd8b7ac532261be$var$gridSizeValue}px`})`;
    const $1dd8b7ac532261be$export$b824cac86306f7a2 = $1dd8b7ac532261be$export$5b2b1030a679f37;
    const $1dd8b7ac532261be$export$8b4981022bd80a4e = {
        color: {
            background: {
                default: '--ds-cb',
                hover: '--ds-cbh',
                active: '--ds-cba'
            },
            borderColor: '--ds-bc',
            focusRing: '--ds-cfr',
            text: {
                default: '--ds-ct',
                hover: '--ds-cth',
                active: '--ds-ctp',
                link: '--ds-ctl'
            },
            removeButton: {
                default: '--ds-rb',
                hover: '--ds-rbh'
            }
        },
        borderRadius: '--ds-br'
    };
});
parcelRegister("2hnSR", function(module, exports) {
    $parcel$export(module.exports, "textColors", ()=>$5b444d8505b9cc3c$export$daa0ace263cb20d2);
    $parcel$export(module.exports, "borderColors", ()=>$5b444d8505b9cc3c$export$1c1b571cf296eca7);
    $parcel$export(module.exports, "textHoverColors", ()=>$5b444d8505b9cc3c$export$7c7104a5f052cab7);
    $parcel$export(module.exports, "textActiveColors", ()=>$5b444d8505b9cc3c$export$382469baad253eb7);
    $parcel$export(module.exports, "backgroundColors", ()=>$5b444d8505b9cc3c$export$b9d7c59a579c23c6);
    $parcel$export(module.exports, "linkHoverBackgroundColors", ()=>$5b444d8505b9cc3c$export$4410079763249c74);
    $parcel$export(module.exports, "linkActiveBackgroundColors", ()=>$5b444d8505b9cc3c$export$76be99c5e13e3566);
    $parcel$export(module.exports, "focusRingColors", ()=>$5b444d8505b9cc3c$export$2a31dbe82788f940);
    $parcel$export(module.exports, "borderRadius", ()=>$5b444d8505b9cc3c$export$7a57f79000377ca2);
    $parcel$export(module.exports, "removalHoverBackgroundColors", ()=>$5b444d8505b9cc3c$export$1202b7eb21da7b58);
    $parcel$export(module.exports, "removalActiveBackgroundColors", ()=>$5b444d8505b9cc3c$export$62ace793ebb16bda);
    $parcel$export(module.exports, "removalTextColors", ()=>$5b444d8505b9cc3c$export$17d206ccea111bbb);
    $parcel$export(module.exports, "removeButtonColors", ()=>$5b444d8505b9cc3c$export$f64c7641cbc22da7);
    $parcel$export(module.exports, "removeButtonHoverColors", ()=>$5b444d8505b9cc3c$export$b03fbc2a369c563e);
    var $e6s40;
    const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
        standard: `var(--ds-text, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
        standardLink: `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime-bolder, #37471F)",
        magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
        grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
        magentaLight: "var(--ds-text-accent-magenta, #943D73)",
        orangeLight: "var(--ds-text-accent-orange, #974F0C)",
        greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
        standard: '#B7B9BE',
        blue: '#669DF1',
        red: '#F87168',
        yellow: '#DDB30E',
        green: '#4BCE97',
        teal: '#6CC3E0',
        purple: '#C97CF4',
        lime: '#94C748',
        magenta: '#E774BB',
        orange: '#FCA700',
        grey: '#B7B9BE',
        standardLink: '#B7B9BE',
        blueLight: '#669DF1',
        redLight: '#F87168',
        yellowLight: '#DDB30E',
        greenLight: '#4BCE97',
        tealLight: '#6CC3E0',
        purpleLight: '#C97CF4',
        limeLight: '#94C748',
        magentaLight: '#E774BB',
        orangeLight: '#FCA700',
        greyLight: '#B7B9BE'
    };
    const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
        standard: `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime-bolder, #37471F)",
        magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
        grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
        magentaLight: "var(--ds-text-accent-magenta, #943D73)",
        orangeLight: "var(--ds-text-accent-orange, #974F0C)",
        greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$382469baad253eb7 = {
        standard: `var(--ds-link-pressed, ${$829f609a65d26a98$export$e62e8919cca44969})`,
        blue: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime, #4C6B1F)",
        magenta: "var(--ds-text-accent-magenta, #943D73)",
        orange: "var(--ds-text-accent-orange, #974F0C)",
        grey: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
        magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
        greyLight: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
        standard: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        blue: `var(--ds-background-accent-blue-subtle, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        red: `var(--ds-background-accent-red-subtle, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
        yellow: `var(--ds-background-accent-yellow-subtle, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
        green: `var(--ds-background-accent-green-subtle, ${$829f609a65d26a98$export$747d86715d4175de})`,
        teal: `var(--ds-background-accent-teal-subtle, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
        purple: `var(--ds-background-accent-purple-subtle, ${$829f609a65d26a98$export$6011520a64d9a187})`,
        lime: "var(--ds-background-accent-lime-subtle, #94C748)",
        magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
        grey: `var(--ds-background-accent-gray-subtle, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        blueLight: `var(--ds-background-accent-blue-subtler, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
        redLight: `var(--ds-background-accent-red-subtler, ${$829f609a65d26a98$export$b34b069eff244586})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
        greenLight: `var(--ds-background-accent-green-subtler, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
        tealLight: `var(--ds-background-accent-teal-subtler, ${$829f609a65d26a98$export$776c9c497ef08533})`,
        purpleLight: `var(--ds-background-accent-purple-subtler, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
        limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
        greyLight: `var(--ds-background-accent-gray-subtler, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
    };
    const $5b444d8505b9cc3c$export$4410079763249c74 = {
        standard: `var(--ds-background-neutral-hovered, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        blue: `var(--ds-background-accent-blue-subtle-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
        red: `var(--ds-background-accent-red-subtle-hovered, ${$829f609a65d26a98$export$b34b069eff244586})`,
        yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
        green: `var(--ds-background-accent-green-subtle-hovered, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
        teal: `var(--ds-background-accent-teal-subtle-hovered, ${$829f609a65d26a98$export$776c9c497ef08533})`,
        purple: `var(--ds-background-accent-purple-subtle-hovered, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
        lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
        magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
        orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
        grey: `var(--ds-background-accent-gray-subtle-hovered, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        redLight: `var(--ds-background-accent-red-subtler-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
        greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
        tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
        purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$829f609a65d26a98$export$363e4475840015bb})`,
        limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
        magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
        orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
        greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
    const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
        standard: `var(--ds-background-neutral-pressed, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        blue: `var(--ds-background-accent-blue-subtle-pressed, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        red: `var(--ds-background-accent-red-subtle-pressed, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
        yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
        green: `var(--ds-background-accent-green-subtle-pressed, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
        teal: `var(--ds-background-accent-teal-subtle-pressed, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
        purple: `var(--ds-background-accent-purple-subtle-pressed, ${$829f609a65d26a98$export$363e4475840015bb})`,
        grey: `var(--ds-background-accent-gray-subtle-pressed, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
        lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
        magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
        orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
        blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        redLight: `var(--ds-background-accent-red-subtler-pressed, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
        greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$829f609a65d26a98$export$747d86715d4175de})`,
        tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
        purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$829f609a65d26a98$export$6011520a64d9a187})`,
        limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
        magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
        orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
        greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$829f609a65d26a98$export$8754fc7e6d8b3000})`
    };
    const $5b444d8505b9cc3c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`;
    const $5b444d8505b9cc3c$export$7a57f79000377ca2 = {
        default: (0, (0, parcelRequire("e6s40")).defaultBorderRadius),
        rounded: (0, (0, parcelRequire("e6s40")).defaultRoundedBorderRadius)
    };
    const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
    const $5b444d8505b9cc3c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
    const $5b444d8505b9cc3c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`;
    const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
        standard: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        lime: `var(--ds-text-accent-lime-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        magenta: `var(--ds-text-accent-magenta-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        orange: `var(--ds-text-accent-orange-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        limeLight: `var(--ds-text-accent-lime, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        magentaLight: `var(--ds-text-accent-magenta, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        orangeLight: `var(--ds-text-accent-orange, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
        standard: `var(--ds-text-danger, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
        standardLink: `var(--ds-text-danger, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        blue: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        magenta: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        orange: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        grey: `var(--ds-text-danger, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        magentaLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        orangeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        greyLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
});
parcelRegister("aXLIT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b11e671062d0fc5$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $e6s40;
    function $4b11e671062d0fc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4b11e671062d0fc5$var$beforeElementStyles = {
        name: "cfjv6",
        styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
    };
    const $4b11e671062d0fc5$var$beforeElementStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: `var(${(0, (0, parcelRequire("e6s40")).cssVar).borderRadius})`,
        insetBlockStart: "var(--ds-space-0, 0px)"
    });
    const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $4b11e671062d0fc5$var$beforeElementStyles : $4b11e671062d0fc5$var$beforeElementStylesOld
        }, elemBefore) : null;
    var $4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;
});
parcelRegister("eYXIO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c46b06918fbe54e8$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $e6s40;
    function $c46b06918fbe54e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c46b06918fbe54e8$var$baseStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: (0, (0, parcelRequire("e6s40")).maxTextWidth),
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        overflow: 'hidden',
        paddingInlineEnd: (0, (0, parcelRequire("e6s40")).defaultTextPadding),
        paddingInlineStart: (0, (0, parcelRequire("e6s40")).defaultTextPadding),
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
    const $c46b06918fbe54e8$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: (0, (0, parcelRequire("e6s40")).maxTextWidth),
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
    const $c46b06918fbe54e8$var$linkStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.link})`,
        pointerEvents: 'auto',
        textDecoration: 'none',
        '&:hover': {
            color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.hover})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.active})`,
            textDecoration: 'underline'
        },
        '&:focus': {
            outline: 'none'
        }
    });
    const $c46b06918fbe54e8$var$linkStyles = {
        name: "1e5oc06",
        styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
    };
    const $c46b06918fbe54e8$var$hasAfterStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: `${(0, (0, parcelRequire("e6s40")).maxTextWidthUnitless) - (0, (0, parcelRequire("e6s40")).buttonWidthUnitless)}px`,
        paddingInlineEnd: (0, (0, parcelRequire("e6s40")).textPaddingRight)
    });
    const $c46b06918fbe54e8$var$hasAfterStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: `${(0, (0, parcelRequire("e6s40")).maxTextWidthUnitless) - (0, (0, parcelRequire("e6s40")).buttonWidthUnitless)}px`
    });
    const $c46b06918fbe54e8$var$hasBeforeStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginInlineStart: (0, (0, parcelRequire("e6s40")).textMarginLeft)
    });
    const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
        const Link = linkComponent ?? 'a';
        if (href) return (0, (0, parcelRequire("f8Sb3")).jsx)(Link, {
            href: href,
            "data-color": color,
            css: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$linkStyles : $c46b06918fbe54e8$var$linkStylesOld,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
                isRemovable && (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
                isRemovable && !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
            ]
        }, text);
        else return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
                isRemovable && (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
                isRemovable && !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
            ]
        }, text);
    };
    var $c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;
});
parcelRegister("iwfmd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$077bdaef72fb9991$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    class $077bdaef72fb9991$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.node = this.getDomNode();
            this.node.addEventListener('mouseenter', this.onMouseEnter);
            this.node.addEventListener('mouseleave', this.onMouseLeave);
        }
        componentWillUnmount() {
            if (this.node) {
                this.node.removeEventListener('mouseenter', this.onMouseEnter);
                this.node.removeEventListener('mouseleave', this.onMouseLeave);
            }
        }
        getDomNode() {
            const node = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(this);
            if (!(node instanceof Element)) throw new Error('Only plain DOM elements could be observed');
            return node;
        }
        render() {
            return this.props.children;
        }
        constructor(...args){
            super(...args);
            this.node = null;
            this.onMouseEnter = ()=>{
                this.props.onHoverChanged(true);
            };
            this.onMouseLeave = ()=>{
                this.props.onHoverChanged(false);
            };
        }
    }
});
parcelRegister("3FQWJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9af40470fdc722ac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JlG5;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $co1wz;
    var $J8W7q;
    var $l38L3 = parcelRequire("l38L3");
    var $kC16r = parcelRequire("kC16r");
    var $cz8HY = parcelRequire("cz8HY");
    const $9af40470fdc722ac$export$836a69893daa1f7c = (current, optimized, delta)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $cz8HY.default), {
            current: current,
            optimized: optimized,
            delta: delta
        });
    class $9af40470fdc722ac$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                ChangeIndicator: $kC16r.default
            };
        }
        render() {
            const { showFlyout: showFlyout } = this.state;
            const { issue: issue, attribute: attribute, valueMapper: valueMapper, showOptimizations: showOptimizations, delta: delta, isCellDirty: isCellDirty, ChangeIndicator: ChangeIndicator, locale: locale, children: children } = this.props;
            let isDirty = false;
            if (isCellDirty) isDirty = isCellDirty();
            else isDirty = issue.originals && (0, parcelRequire("2JlG5")).default(attribute, issue.originals);
            const shouldShowChangeIndicator = isDirty && !showOptimizations;
            let shouldShowFlyout = false;
            let flyout = null;
            if (showOptimizations) {
                let optimizedValue = (0, $l38L3.getOptimizedValue)(issue, attribute);
                let currentValue = (0, $l38L3.getCurrentValue)(issue, attribute);
                const hasOptimizedValue = (0, $l38L3.hasValueChanged)(currentValue, optimizedValue);
                const deltaValue = typeof delta === 'function' ? delta(currentValue, optimizedValue, locale) : '';
                if (valueMapper) {
                    optimizedValue = valueMapper(issue, optimizedValue);
                    currentValue = valueMapper(issue, currentValue);
                }
                flyout = $9af40470fdc722ac$export$836a69893daa1f7c(currentValue, optimizedValue, deltaValue);
                shouldShowFlyout = hasOptimizedValue && showFlyout;
            }
            if ((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                trigger: ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        ref: ref,
                        onMouseEnter: this.showFlyout,
                        onMouseLeave: this.hideFlyout,
                        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.cell.div"
                    }, children, shouldShowChangeIndicator && ChangeIndicator && (0, ($parcel$interopDefault($5uXOq))).createElement(ChangeIndicator, null)),
                isOpen: shouldShowFlyout,
                content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                        xcss: $9af40470fdc722ac$var$flyoutWrapperStyles
                    }, flyout)
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                onMouseEnter: this.showFlyout,
                onMouseLeave: this.hideFlyout,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.cell.div"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                content: flyout,
                isOpen: shouldShowFlyout
            }, this.props.children, shouldShowChangeIndicator && ChangeIndicator && (0, ($parcel$interopDefault($5uXOq))).createElement(ChangeIndicator, null)));
        }
        constructor(...args){
            super(...args);
            this.state = {
                showFlyout: false
            };
            this.showFlyout = ()=>{
                this.setState({
                    showFlyout: true
                });
            };
            this.hideFlyout = ()=>{
                this.setState({
                    showFlyout: false
                });
            };
        }
    }
    const $9af40470fdc722ac$var$flyoutWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.200'
    });
});
parcelRegister("2JlG5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1fd099864ff8afd7$export$2e2bcd8739ae039);
    var $c9RLn;
    var $9Qayl;
    var $1fd099864ff8afd7$var$has = (0, (0, parcelRequire("c9RLn")).default)(function has(prop, obj) {
        return (0, (0, parcelRequire("9Qayl")).default)([
            prop
        ], obj);
    });
    var $1fd099864ff8afd7$export$2e2bcd8739ae039 = $1fd099864ff8afd7$var$has;
});
parcelRegister("9Qayl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72a127f56ab84d7f$export$2e2bcd8739ae039);
    var $c9RLn;
    var $65NM6;
    var $72a127f56ab84d7f$var$hasPath = (0, (0, parcelRequire("c9RLn")).default)(function hasPath(_path, obj) {
        if (_path.length === 0) return false;
        var val = obj;
        var idx = 0;
        while(idx < _path.length){
            if ((0, (0, parcelRequire("65NM6")).default)(_path[idx], val)) {
                val = val[_path[idx]];
                idx += 1;
            } else return false;
        }
        return true;
    });
    var $72a127f56ab84d7f$export$2e2bcd8739ae039 = $72a127f56ab84d7f$var$hasPath;
});
parcelRegister("J8W7q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$866e6794e0ff4648$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $ctg8C;
    const $866e6794e0ff4648$var$INLINE_DIALOG_PADDING = 32;
    const $866e6794e0ff4648$var$THRESHOLD = 50;
    const $866e6794e0ff4648$var$TIMEOUT = 500;
    function $866e6794e0ff4648$var$WithCloseOnScroll({ isOpen: isOpen, children: children }) {
        const containerElement = document.body;
        const distanceXRef = (0, $5uXOq.useRef)(0);
        const distanceYRef = (0, $5uXOq.useRef)(0);
        const timeoutIdRef = (0, $5uXOq.useRef)();
        const shouldClose = ()=>Math.abs(distanceXRef.current) >= $866e6794e0ff4648$var$THRESHOLD || Math.abs(distanceYRef.current) >= $866e6794e0ff4648$var$THRESHOLD;
        const resetThresholdChecking = (0, $5uXOq.useCallback)(()=>{
            distanceYRef.current = 0;
            distanceXRef.current = 0;
            timeoutIdRef.current = undefined;
        }, []);
        const closeDialog = (0, $5uXOq.useCallback)(()=>containerElement?.click(), [
            containerElement
        ]);
        const handleWheel = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            distanceXRef.current += e.deltaX;
            distanceYRef.current += e.deltaY;
            if (shouldClose()) {
                closeDialog();
                resetThresholdChecking();
            }
            if (!timeoutIdRef.current) timeoutIdRef.current = setTimeout(()=>{
                if (shouldClose()) closeDialog();
                resetThresholdChecking();
            }, $866e6794e0ff4648$var$TIMEOUT);
        }, [
            closeDialog,
            resetThresholdChecking
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen) window.addEventListener('wheel', handleWheel, {
                passive: true
            });
            else window.removeEventListener('wheel', handleWheel);
            return ()=>window.removeEventListener('wheel', handleWheel);
        }, [
            isOpen,
            handleWheel
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
    class $866e6794e0ff4648$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                testId: 'data-inline-dialog-content'
            };
        }
        componentDidMount() {
            this.updateContainerStyles();
        }
        componentDidUpdate() {
            this.updateContainerStyles();
        }
        render() {
            return this.props.closeOnScroll ? (0, ($parcel$interopDefault($5uXOq))).createElement($866e6794e0ff4648$var$WithCloseOnScroll, {
                isOpen: this.props.isOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctg8C")).default), this.props)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctg8C")).default), this.props);
        }
        constructor(...args){
            super(...args);
            this.updateContainerStyles = ()=>{
                const { maxWidth: maxWidth, minWidth: minWidth, isOpen: isOpen, noPaddings: noPaddings, noHorizontalScroll: noHorizontalScroll, zIndex: zIndex, overflow: overflow } = this.props;
                if (!isOpen) return;
                const node = (0, $7nsd3.findDOMNode)(this);
                const container = node && node.nextElementSibling;
                if (!(container instanceof HTMLElement)) return;
                if (noPaddings) container.style.padding = '0';
                if (maxWidth) {
                    const width = noPaddings ? maxWidth : maxWidth + $866e6794e0ff4648$var$INLINE_DIALOG_PADDING;
                    container.style.maxWidth = `${width}px`;
                    container.style.overflow = 'auto';
                }
                if (minWidth) {
                    const width = noPaddings ? minWidth : minWidth + $866e6794e0ff4648$var$INLINE_DIALOG_PADDING;
                    container.style.minWidth = `${width}px`;
                    container.style.overflow = 'auto';
                }
                if (overflow) container.style.overflow = overflow;
                if (noHorizontalScroll) container.style.maxWidth = 'initial';
                container.style.maxHeight = 'initial';
                container.style.zIndex = zIndex;
            };
        }
    }
});
parcelRegister("l38L3", function(module, exports) {
    $parcel$export(module.exports, "getHighlightRowId", ()=>$70347e51b2de3186$export$a23875ea10851868);
    $parcel$export(module.exports, "getCurrentValue", ()=>$70347e51b2de3186$export$f277181e65de46c7);
    $parcel$export(module.exports, "getOptimizedValue", ()=>$70347e51b2de3186$export$f2a3a2f8a1013b3);
    $parcel$export(module.exports, "hasValueChanged", ()=>$70347e51b2de3186$export$95598ecadc03a242);
    $parcel$export(module.exports, "getInlineCreateIssueTypeId", ()=>$70347e51b2de3186$export$be1dd65e66c75e08);
    $parcel$export(module.exports, "toggleRowHighlighter", ()=>$70347e51b2de3186$export$55759e443003e7b2);
    $parcel$export(module.exports, "shouldSetOnboardingWidth", ()=>$70347e51b2de3186$export$bba978883a886a);
    $parcel$export(module.exports, "getSectionsData", ()=>$70347e51b2de3186$export$a822c88ebfae7388);
    $parcel$export(module.exports, "getExperienceName", ()=>$70347e51b2de3186$export$4ce0bedef4e84bb7);
    $parcel$export(module.exports, "getRowHighlighter", ()=>$70347e51b2de3186$export$3d44be5a96fa58c3);
    var $5uXOq = parcelRequire("5uXOq");
    var $2pJJi = parcelRequire("2pJJi");
    var $8QpSo;
    var $cTYeP;
    var $8EB5I;
    var $2JlG5;
    var $lV634;
    var $dC5iT;
    var $8CUq3;
    var $3J2mc;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    const $70347e51b2de3186$var$MIN_VIEWPORT_WIDTH = 1024;
    const $70347e51b2de3186$var$ONBOARDING_MESSAGE_WIDTH = 320;
    const $70347e51b2de3186$export$a23875ea10851868 = (group, issueId = '')=>(0, ($parcel$interopDefault($2pJJi)))((0, $4nDwW.isDefined)(group) ? `${group}_${issueId}` : issueId);
    const $70347e51b2de3186$export$f277181e65de46c7 = (issue, attribute)=>issue.inferred && (0, parcelRequire("2JlG5")).default(attribute, issue.inferred) ? undefined : issue[attribute];
    const $70347e51b2de3186$export$f2a3a2f8a1013b3 = (issue, attribute)=>issue.optimized && (0, parcelRequire("2JlG5")).default(attribute, issue.optimized) ? issue.optimized[attribute] : $70347e51b2de3186$export$f277181e65de46c7(issue, attribute);
    const $70347e51b2de3186$export$95598ecadc03a242 = (currentValue, optimizedValue)=>{
        if ((0, parcelRequire("lV634")).default(currentValue) && (0, parcelRequire("lV634")).default(optimizedValue)) return false;
        return !(0, parcelRequire("8EB5I")).default(currentValue, optimizedValue);
    };
    const $70347e51b2de3186$export$be1dd65e66c75e08 = (level, inlineCreateProject, props)=>{
        const { issueTypeId: issueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy, typeToLevel: typeToLevel } = props;
        if (IssueTypeIdForHierarchy && (0, $4nDwW.isDefined)(IssueTypeIdForHierarchy[level]) && (0, parcelRequire("cTYeP")).default(IssueTypeIdForHierarchy[level], inlineCreateProject.issueTypeIds) && typeToLevel(IssueTypeIdForHierarchy[level]) === level) return IssueTypeIdForHierarchy[level];
        if ((0, parcelRequire("cTYeP")).default(issueTypeId, inlineCreateProject.issueTypeIds) && typeToLevel(issueTypeId) === level) return issueTypeId;
        const inlineCreateIssueTypeId = inlineCreateProject.issueTypeIds.find((id)=>typeToLevel(id) === level);
        if (!(0, $4nDwW.isDefined)(inlineCreateIssueTypeId)) throw new Error(`inlineCreateProject doesn't have issue type corresponding to the ${level}`);
        return inlineCreateIssueTypeId;
    };
    const $70347e51b2de3186$export$55759e443003e7b2 = (id, isOn)=>{
        const opacity = isOn ? '0.08' : '0';
        const query = `[data-highlight-row="${id}"]`;
        for (const element of document.querySelectorAll(query))element.style.opacity = opacity;
    };
    const $70347e51b2de3186$export$bba978883a886a = (section, containerWidth)=>{
        if (containerWidth < $70347e51b2de3186$var$MIN_VIEWPORT_WIDTH) return false;
        if (section.id === 'scope-column' && section.width + $70347e51b2de3186$var$ONBOARDING_MESSAGE_WIDTH >= containerWidth) return true;
        if (section.id === 'fields-column' && (section.width <= section.minWidth || section.width + 2 * $70347e51b2de3186$var$ONBOARDING_MESSAGE_WIDTH > containerWidth)) return true;
        return section.id === 'timeline-column' && section.width <= section.minWidth;
    };
    const $70347e51b2de3186$export$a822c88ebfae7388 = (0, (0, parcelRequire("8QpSo")).default)(({ formatMessage: formatMessage }, viewMode)=>{
        const sections = [
            {
                initialWidth: 300,
                minWidth: 300,
                isFixed: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE,
                id: (0, $TTKUQ.SECTION_ITEM_KEYS).SCOPE,
                title: formatMessage((0, $ihPUd.default).scope),
                collapsible: false,
                onboardingWidth: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE ? 30 : 50
            },
            {
                initialWidth: 3 * (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
                minWidth: 32,
                isFixed: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE,
                id: (0, $TTKUQ.SECTION_ITEM_KEYS).FIELDS,
                title: formatMessage((0, $ihPUd.default).fields),
                collapsible: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE,
                onboardingWidth: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE ? 35 : 50
            }
        ];
        if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE) sections.push({
            initialWidth: 100,
            minWidth: 32,
            isFixed: false,
            id: (0, $TTKUQ.SECTION_ITEM_KEYS).TIMELINE,
            title: formatMessage((0, $ihPUd.default).timeline),
            collapsible: true,
            onboardingWidth: 35
        });
        return sections;
    });
    const $70347e51b2de3186$export$4ce0bedef4e84bb7 = (isReportMode, isConfluenceMacro, isEmbedReportView)=>{
        if (isEmbedReportView) return 'viewPortfolio3Embed';
        if (isConfluenceMacro) return 'viewPortfolio3ConfluenceEmbed';
        if (isReportMode) return 'viewPortfolio3Report';
        return 'viewPortfolio3Roadmap';
    };
    const $70347e51b2de3186$export$3d44be5a96fa58c3 = (group, issueId)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $70347e51b2de3186$var$getRowHighlighterStyles,
            "data-highlight-row": $70347e51b2de3186$export$a23875ea10851868(group, issueId)
        });
    const $70347e51b2de3186$var$getRowHighlighterStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        pointerEvents: 'none',
        backgroundColor: 'color.background.neutral.bold.pressed',
        height: '100%',
        width: '100%',
        opacity: 0
    });
});
parcelRegister("2pJJi", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $1c2163866d9a1ec5$var$func = $lVx1a('escape', (parcelRequire("6JUGo")), (parcelRequire("bUoRH")));
    $1c2163866d9a1ec5$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $1c2163866d9a1ec5$var$func;
});
parcelRegister("lVx1a", function(module, exports) {
    var $iIayQ = parcelRequire("iIayQ");
    var $7sR67 = parcelRequire("7sR67");
    function $ff688881095ae098$var$convert(name, func, options) {
        return $iIayQ($7sR67, name, func, options);
    }
    module.exports = $ff688881095ae098$var$convert;
});
parcelRegister("iIayQ", function(module, exports) {
    var $lTdwm = parcelRequire("lTdwm");
    var $aPsMW = parcelRequire("aPsMW");
    var $d9f487426e0f9b59$var$push = Array.prototype.push;
    function $d9f487426e0f9b59$var$baseArity(func, n) {
        return n == 2 ? function(a, b) {
            return func.apply(undefined, arguments);
        } : function(a) {
            return func.apply(undefined, arguments);
        };
    }
    function $d9f487426e0f9b59$var$baseAry(func, n) {
        return n == 2 ? function(a, b) {
            return func(a, b);
        } : function(a) {
            return func(a);
        };
    }
    function $d9f487426e0f9b59$var$cloneArray(array) {
        var length = array ? array.length : 0, result = Array(length);
        while(length--)result[length] = array[length];
        return result;
    }
    function $d9f487426e0f9b59$var$createCloner(func) {
        return function(object) {
            return func({}, object);
        };
    }
    function $d9f487426e0f9b59$var$flatSpread(func, start) {
        return function() {
            var length = arguments.length, lastIndex = length - 1, args = Array(length);
            while(length--)args[length] = arguments[length];
            var array = args[start], otherArgs = args.slice(0, start);
            if (array) $d9f487426e0f9b59$var$push.apply(otherArgs, array);
            if (start != lastIndex) $d9f487426e0f9b59$var$push.apply(otherArgs, args.slice(start + 1));
            return func.apply(this, otherArgs);
        };
    }
    function $d9f487426e0f9b59$var$wrapImmutable(func, cloner) {
        return function() {
            var length = arguments.length;
            if (!length) return;
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var result = args[0] = cloner.apply(undefined, args);
            func.apply(undefined, args);
            return result;
        };
    }
    function $d9f487426e0f9b59$var$baseConvert(util, name, func, options) {
        var isLib = typeof name == 'function', isObj = name === Object(name);
        if (isObj) {
            options = func;
            func = name;
            name = undefined;
        }
        if (func == null) throw new TypeError;
        options || (options = {});
        var config = {
            'cap': 'cap' in options ? options.cap : true,
            'curry': 'curry' in options ? options.curry : true,
            'fixed': 'fixed' in options ? options.fixed : true,
            'immutable': 'immutable' in options ? options.immutable : true,
            'rearg': 'rearg' in options ? options.rearg : true
        };
        var defaultHolder = isLib ? func : $aPsMW, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
        var helpers = isLib ? func : {
            'ary': util.ary,
            'assign': util.assign,
            'clone': util.clone,
            'curry': util.curry,
            'forEach': util.forEach,
            'isArray': util.isArray,
            'isError': util.isError,
            'isFunction': util.isFunction,
            'isWeakMap': util.isWeakMap,
            'iteratee': util.iteratee,
            'keys': util.keys,
            'rearg': util.rearg,
            'toInteger': util.toInteger,
            'toPath': util.toPath
        };
        var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
        var aryMethodKeys = keys($lTdwm.aryMethod);
        var wrappers = {
            'castArray': function(castArray) {
                return function() {
                    var value = arguments[0];
                    return isArray(value) ? castArray($d9f487426e0f9b59$var$cloneArray(value)) : castArray.apply(undefined, arguments);
                };
            },
            'iteratee': function(iteratee) {
                return function() {
                    var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                    if (config.cap && typeof arity == 'number') {
                        arity = arity > 2 ? arity - 2 : 1;
                        return length && length <= arity ? result : $d9f487426e0f9b59$var$baseAry(result, arity);
                    }
                    return result;
                };
            },
            'mixin': function(mixin) {
                return function(source) {
                    var func = this;
                    if (!isFunction(func)) return mixin(func, Object(source));
                    var pairs = [];
                    each(keys(source), function(key) {
                        if (isFunction(source[key])) pairs.push([
                            key,
                            func.prototype[key]
                        ]);
                    });
                    mixin(func, Object(source));
                    each(pairs, function(pair) {
                        var value = pair[1];
                        if (isFunction(value)) func.prototype[pair[0]] = value;
                        else delete func.prototype[pair[0]];
                    });
                    return func;
                };
            },
            'nthArg': function(nthArg) {
                return function(n) {
                    var arity = n < 0 ? 1 : toInteger(n) + 1;
                    return curry(nthArg(n), arity);
                };
            },
            'rearg': function(rearg) {
                return function(func, indexes) {
                    var arity = indexes ? indexes.length : 0;
                    return curry(rearg(func, indexes), arity);
                };
            },
            'runInContext': function(runInContext) {
                return function(context) {
                    return $d9f487426e0f9b59$var$baseConvert(util, runInContext(context), options);
                };
            }
        };
        function castCap(name, func) {
            if (config.cap) {
                var indexes = $lTdwm.iterateeRearg[name];
                if (indexes) return iterateeRearg(func, indexes);
                var n = !isLib && $lTdwm.iterateeAry[name];
                if (n) return iterateeAry(func, n);
            }
            return func;
        }
        function castCurry(name, func, n) {
            return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
        }
        function castFixed(name, func, n) {
            if (config.fixed && (forceFixed || !$lTdwm.skipFixed[name])) {
                var data = $lTdwm.methodSpread[name], start = data && data.start;
                return start === undefined ? ary(func, n) : $d9f487426e0f9b59$var$flatSpread(func, start);
            }
            return func;
        }
        function castRearg(name, func, n) {
            return config.rearg && n > 1 && (forceRearg || !$lTdwm.skipRearg[name]) ? rearg(func, $lTdwm.methodRearg[name] || $lTdwm.aryRearg[n]) : func;
        }
        function cloneByPath(object, path) {
            path = toPath(path);
            var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
            while(nested != null && ++index < length){
                var key = path[index], value = nested[key];
                if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
                nested = nested[key];
            }
            return result;
        }
        function convertLib(options) {
            return _.runInContext.convert(options)(undefined);
        }
        function createConverter(name, func) {
            var realName = $lTdwm.aliasToReal[name] || name, methodName = $lTdwm.remap[realName] || realName, oldOptions = options;
            return function(options) {
                var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
                return $d9f487426e0f9b59$var$baseConvert(newUtil, realName, newFunc, newOptions);
            };
        }
        function iterateeAry(func, n) {
            return overArg(func, function(func) {
                return typeof func == 'function' ? $d9f487426e0f9b59$var$baseAry(func, n) : func;
            });
        }
        function iterateeRearg(func, indexes) {
            return overArg(func, function(func) {
                var n = indexes.length;
                return $d9f487426e0f9b59$var$baseArity(rearg($d9f487426e0f9b59$var$baseAry(func, n), indexes), n);
            });
        }
        function overArg(func, transform) {
            return function() {
                var length = arguments.length;
                if (!length) return func();
                var args = Array(length);
                while(length--)args[length] = arguments[length];
                var index = config.rearg ? 0 : length - 1;
                args[index] = transform(args[index]);
                return func.apply(undefined, args);
            };
        }
        function wrap(name, func, placeholder) {
            var result, realName = $lTdwm.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
            if (wrapper) wrapped = wrapper(func);
            else if (config.immutable) {
                if ($lTdwm.mutate.array[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$cloneArray);
                else if ($lTdwm.mutate.object[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$createCloner(func));
                else if ($lTdwm.mutate.set[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, cloneByPath);
            }
            each(aryMethodKeys, function(aryKey) {
                each($lTdwm.aryMethod[aryKey], function(otherName) {
                    if (realName == otherName) {
                        var data = $lTdwm.methodSpread[realName], afterRearg = data && data.afterRearg;
                        result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                        result = castCap(realName, result);
                        result = castCurry(realName, result, aryKey);
                        return false;
                    }
                });
                return !result;
            });
            result || (result = wrapped);
            if (result == func) result = forceCurry ? curry(result, 1) : function() {
                return func.apply(this, arguments);
            };
            result.convert = createConverter(realName, func);
            result.placeholder = func.placeholder = placeholder;
            return result;
        }
        if (!isObj) return wrap(name, func, defaultHolder);
        var _ = func;
        var pairs = [];
        each(aryMethodKeys, function(aryKey) {
            each($lTdwm.aryMethod[aryKey], function(key) {
                var func = _[$lTdwm.remap[key] || key];
                if (func) pairs.push([
                    key,
                    wrap(key, func, _)
                ]);
            });
        });
        each(keys(_), function(key) {
            var func = _[key];
            if (typeof func == 'function') {
                var length = pairs.length;
                while(length--){
                    if (pairs[length][0] == key) return;
                }
                func.convert = createConverter(key, func);
                pairs.push([
                    key,
                    func
                ]);
            }
        });
        each(pairs, function(pair) {
            _[pair[0]] = pair[1];
        });
        _.convert = convertLib;
        _.placeholder = _;
        each(keys(_), function(key) {
            each($lTdwm.realToAlias[key] || [], function(alias) {
                _[alias] = _[key];
            });
        });
        return _;
    }
    module.exports = $d9f487426e0f9b59$var$baseConvert;
});
parcelRegister("lTdwm", function(module, exports) {
    $parcel$export(module.exports, "aliasToReal", ()=>$fef938fb92c31507$export$bd0f5e6e44efa6b4, (v)=>$fef938fb92c31507$export$bd0f5e6e44efa6b4 = v);
    $parcel$export(module.exports, "aryMethod", ()=>$fef938fb92c31507$export$85c665b4d7da9cb4, (v)=>$fef938fb92c31507$export$85c665b4d7da9cb4 = v);
    $parcel$export(module.exports, "aryRearg", ()=>$fef938fb92c31507$export$42564e045b285e32, (v)=>$fef938fb92c31507$export$42564e045b285e32 = v);
    $parcel$export(module.exports, "iterateeAry", ()=>$fef938fb92c31507$export$81e17196e6a22b07, (v)=>$fef938fb92c31507$export$81e17196e6a22b07 = v);
    $parcel$export(module.exports, "iterateeRearg", ()=>$fef938fb92c31507$export$30975ceb42167ebd, (v)=>$fef938fb92c31507$export$30975ceb42167ebd = v);
    $parcel$export(module.exports, "methodRearg", ()=>$fef938fb92c31507$export$8ceb0ad7e94d3801, (v)=>$fef938fb92c31507$export$8ceb0ad7e94d3801 = v);
    $parcel$export(module.exports, "methodSpread", ()=>$fef938fb92c31507$export$fbaeb3f87df3cf26, (v)=>$fef938fb92c31507$export$fbaeb3f87df3cf26 = v);
    $parcel$export(module.exports, "mutate", ()=>$fef938fb92c31507$export$57e795267c26e600, (v)=>$fef938fb92c31507$export$57e795267c26e600 = v);
    $parcel$export(module.exports, "realToAlias", ()=>$fef938fb92c31507$export$1eb71a7e27943e71, (v)=>$fef938fb92c31507$export$1eb71a7e27943e71 = v);
    $parcel$export(module.exports, "remap", ()=>$fef938fb92c31507$export$aee1dbae5de2db9d, (v)=>$fef938fb92c31507$export$aee1dbae5de2db9d = v);
    $parcel$export(module.exports, "skipFixed", ()=>$fef938fb92c31507$export$87ffbe4821a5d5e0, (v)=>$fef938fb92c31507$export$87ffbe4821a5d5e0 = v);
    $parcel$export(module.exports, "skipRearg", ()=>$fef938fb92c31507$export$b4d07413ce528c90, (v)=>$fef938fb92c31507$export$b4d07413ce528c90 = v);
    var $fef938fb92c31507$export$bd0f5e6e44efa6b4;
    var $fef938fb92c31507$export$85c665b4d7da9cb4;
    var $fef938fb92c31507$export$42564e045b285e32;
    var $fef938fb92c31507$export$81e17196e6a22b07;
    var $fef938fb92c31507$export$30975ceb42167ebd;
    var $fef938fb92c31507$export$8ceb0ad7e94d3801;
    var $fef938fb92c31507$export$fbaeb3f87df3cf26;
    var $fef938fb92c31507$export$57e795267c26e600;
    var $fef938fb92c31507$export$1eb71a7e27943e71;
    var $fef938fb92c31507$export$aee1dbae5de2db9d;
    var $fef938fb92c31507$export$87ffbe4821a5d5e0;
    var $fef938fb92c31507$export$b4d07413ce528c90;
    $fef938fb92c31507$export$bd0f5e6e44efa6b4 = {
        'each': 'forEach',
        'eachRight': 'forEachRight',
        'entries': 'toPairs',
        'entriesIn': 'toPairsIn',
        'extend': 'assignIn',
        'extendAll': 'assignInAll',
        'extendAllWith': 'assignInAllWith',
        'extendWith': 'assignInWith',
        'first': 'head',
        'conforms': 'conformsTo',
        'matches': 'isMatch',
        'property': 'get',
        '__': 'placeholder',
        'F': 'stubFalse',
        'T': 'stubTrue',
        'all': 'every',
        'allPass': 'overEvery',
        'always': 'constant',
        'any': 'some',
        'anyPass': 'overSome',
        'apply': 'spread',
        'assoc': 'set',
        'assocPath': 'set',
        'complement': 'negate',
        'compose': 'flowRight',
        'contains': 'includes',
        'dissoc': 'unset',
        'dissocPath': 'unset',
        'dropLast': 'dropRight',
        'dropLastWhile': 'dropRightWhile',
        'equals': 'isEqual',
        'identical': 'eq',
        'indexBy': 'keyBy',
        'init': 'initial',
        'invertObj': 'invert',
        'juxt': 'over',
        'omitAll': 'omit',
        'nAry': 'ary',
        'path': 'get',
        'pathEq': 'matchesProperty',
        'pathOr': 'getOr',
        'paths': 'at',
        'pickAll': 'pick',
        'pipe': 'flow',
        'pluck': 'map',
        'prop': 'get',
        'propEq': 'matchesProperty',
        'propOr': 'getOr',
        'props': 'at',
        'symmetricDifference': 'xor',
        'symmetricDifferenceBy': 'xorBy',
        'symmetricDifferenceWith': 'xorWith',
        'takeLast': 'takeRight',
        'takeLastWhile': 'takeRightWhile',
        'unapply': 'rest',
        'unnest': 'flatten',
        'useWith': 'overArgs',
        'where': 'conformsTo',
        'whereEq': 'isMatch',
        'zipObj': 'zipObject'
    };
    $fef938fb92c31507$export$85c665b4d7da9cb4 = {
        '1': [
            'assignAll',
            'assignInAll',
            'attempt',
            'castArray',
            'ceil',
            'create',
            'curry',
            'curryRight',
            'defaultsAll',
            'defaultsDeepAll',
            'floor',
            'flow',
            'flowRight',
            'fromPairs',
            'invert',
            'iteratee',
            'memoize',
            'method',
            'mergeAll',
            'methodOf',
            'mixin',
            'nthArg',
            'over',
            'overEvery',
            'overSome',
            'rest',
            'reverse',
            'round',
            'runInContext',
            'spread',
            'template',
            'trim',
            'trimEnd',
            'trimStart',
            'uniqueId',
            'words',
            'zipAll'
        ],
        '2': [
            'add',
            'after',
            'ary',
            'assign',
            'assignAllWith',
            'assignIn',
            'assignInAllWith',
            'at',
            'before',
            'bind',
            'bindAll',
            'bindKey',
            'chunk',
            'cloneDeepWith',
            'cloneWith',
            'concat',
            'conformsTo',
            'countBy',
            'curryN',
            'curryRightN',
            'debounce',
            'defaults',
            'defaultsDeep',
            'defaultTo',
            'delay',
            'difference',
            'divide',
            'drop',
            'dropRight',
            'dropRightWhile',
            'dropWhile',
            'endsWith',
            'eq',
            'every',
            'filter',
            'find',
            'findIndex',
            'findKey',
            'findLast',
            'findLastIndex',
            'findLastKey',
            'flatMap',
            'flatMapDeep',
            'flattenDepth',
            'forEach',
            'forEachRight',
            'forIn',
            'forInRight',
            'forOwn',
            'forOwnRight',
            'get',
            'groupBy',
            'gt',
            'gte',
            'has',
            'hasIn',
            'includes',
            'indexOf',
            'intersection',
            'invertBy',
            'invoke',
            'invokeMap',
            'isEqual',
            'isMatch',
            'join',
            'keyBy',
            'lastIndexOf',
            'lt',
            'lte',
            'map',
            'mapKeys',
            'mapValues',
            'matchesProperty',
            'maxBy',
            'meanBy',
            'merge',
            'mergeAllWith',
            'minBy',
            'multiply',
            'nth',
            'omit',
            'omitBy',
            'overArgs',
            'pad',
            'padEnd',
            'padStart',
            'parseInt',
            'partial',
            'partialRight',
            'partition',
            'pick',
            'pickBy',
            'propertyOf',
            'pull',
            'pullAll',
            'pullAt',
            'random',
            'range',
            'rangeRight',
            'rearg',
            'reject',
            'remove',
            'repeat',
            'restFrom',
            'result',
            'sampleSize',
            'some',
            'sortBy',
            'sortedIndex',
            'sortedIndexOf',
            'sortedLastIndex',
            'sortedLastIndexOf',
            'sortedUniqBy',
            'split',
            'spreadFrom',
            'startsWith',
            'subtract',
            'sumBy',
            'take',
            'takeRight',
            'takeRightWhile',
            'takeWhile',
            'tap',
            'throttle',
            'thru',
            'times',
            'trimChars',
            'trimCharsEnd',
            'trimCharsStart',
            'truncate',
            'union',
            'uniqBy',
            'uniqWith',
            'unset',
            'unzipWith',
            'without',
            'wrap',
            'xor',
            'zip',
            'zipObject',
            'zipObjectDeep'
        ],
        '3': [
            'assignInWith',
            'assignWith',
            'clamp',
            'differenceBy',
            'differenceWith',
            'findFrom',
            'findIndexFrom',
            'findLastFrom',
            'findLastIndexFrom',
            'getOr',
            'includesFrom',
            'indexOfFrom',
            'inRange',
            'intersectionBy',
            'intersectionWith',
            'invokeArgs',
            'invokeArgsMap',
            'isEqualWith',
            'isMatchWith',
            'flatMapDepth',
            'lastIndexOfFrom',
            'mergeWith',
            'orderBy',
            'padChars',
            'padCharsEnd',
            'padCharsStart',
            'pullAllBy',
            'pullAllWith',
            'rangeStep',
            'rangeStepRight',
            'reduce',
            'reduceRight',
            'replace',
            'set',
            'slice',
            'sortedIndexBy',
            'sortedLastIndexBy',
            'transform',
            'unionBy',
            'unionWith',
            'update',
            'xorBy',
            'xorWith',
            'zipWith'
        ],
        '4': [
            'fill',
            'setWith',
            'updateWith'
        ]
    };
    $fef938fb92c31507$export$42564e045b285e32 = {
        '2': [
            1,
            0
        ],
        '3': [
            2,
            0,
            1
        ],
        '4': [
            3,
            2,
            0,
            1
        ]
    };
    $fef938fb92c31507$export$81e17196e6a22b07 = {
        'dropRightWhile': 1,
        'dropWhile': 1,
        'every': 1,
        'filter': 1,
        'find': 1,
        'findFrom': 1,
        'findIndex': 1,
        'findIndexFrom': 1,
        'findKey': 1,
        'findLast': 1,
        'findLastFrom': 1,
        'findLastIndex': 1,
        'findLastIndexFrom': 1,
        'findLastKey': 1,
        'flatMap': 1,
        'flatMapDeep': 1,
        'flatMapDepth': 1,
        'forEach': 1,
        'forEachRight': 1,
        'forIn': 1,
        'forInRight': 1,
        'forOwn': 1,
        'forOwnRight': 1,
        'map': 1,
        'mapKeys': 1,
        'mapValues': 1,
        'partition': 1,
        'reduce': 2,
        'reduceRight': 2,
        'reject': 1,
        'remove': 1,
        'some': 1,
        'takeRightWhile': 1,
        'takeWhile': 1,
        'times': 1,
        'transform': 2
    };
    $fef938fb92c31507$export$30975ceb42167ebd = {
        'mapKeys': [
            1
        ],
        'reduceRight': [
            1,
            0
        ]
    };
    $fef938fb92c31507$export$8ceb0ad7e94d3801 = {
        'assignInAllWith': [
            1,
            0
        ],
        'assignInWith': [
            1,
            2,
            0
        ],
        'assignAllWith': [
            1,
            0
        ],
        'assignWith': [
            1,
            2,
            0
        ],
        'differenceBy': [
            1,
            2,
            0
        ],
        'differenceWith': [
            1,
            2,
            0
        ],
        'getOr': [
            2,
            1,
            0
        ],
        'intersectionBy': [
            1,
            2,
            0
        ],
        'intersectionWith': [
            1,
            2,
            0
        ],
        'isEqualWith': [
            1,
            2,
            0
        ],
        'isMatchWith': [
            2,
            1,
            0
        ],
        'mergeAllWith': [
            1,
            0
        ],
        'mergeWith': [
            1,
            2,
            0
        ],
        'padChars': [
            2,
            1,
            0
        ],
        'padCharsEnd': [
            2,
            1,
            0
        ],
        'padCharsStart': [
            2,
            1,
            0
        ],
        'pullAllBy': [
            2,
            1,
            0
        ],
        'pullAllWith': [
            2,
            1,
            0
        ],
        'rangeStep': [
            1,
            2,
            0
        ],
        'rangeStepRight': [
            1,
            2,
            0
        ],
        'setWith': [
            3,
            1,
            2,
            0
        ],
        'sortedIndexBy': [
            2,
            1,
            0
        ],
        'sortedLastIndexBy': [
            2,
            1,
            0
        ],
        'unionBy': [
            1,
            2,
            0
        ],
        'unionWith': [
            1,
            2,
            0
        ],
        'updateWith': [
            3,
            1,
            2,
            0
        ],
        'xorBy': [
            1,
            2,
            0
        ],
        'xorWith': [
            1,
            2,
            0
        ],
        'zipWith': [
            1,
            2,
            0
        ]
    };
    $fef938fb92c31507$export$fbaeb3f87df3cf26 = {
        'assignAll': {
            'start': 0
        },
        'assignAllWith': {
            'start': 0
        },
        'assignInAll': {
            'start': 0
        },
        'assignInAllWith': {
            'start': 0
        },
        'defaultsAll': {
            'start': 0
        },
        'defaultsDeepAll': {
            'start': 0
        },
        'invokeArgs': {
            'start': 2
        },
        'invokeArgsMap': {
            'start': 2
        },
        'mergeAll': {
            'start': 0
        },
        'mergeAllWith': {
            'start': 0
        },
        'partial': {
            'start': 1
        },
        'partialRight': {
            'start': 1
        },
        'without': {
            'start': 1
        },
        'zipAll': {
            'start': 0
        }
    };
    $fef938fb92c31507$export$57e795267c26e600 = {
        'array': {
            'fill': true,
            'pull': true,
            'pullAll': true,
            'pullAllBy': true,
            'pullAllWith': true,
            'pullAt': true,
            'remove': true,
            'reverse': true
        },
        'object': {
            'assign': true,
            'assignAll': true,
            'assignAllWith': true,
            'assignIn': true,
            'assignInAll': true,
            'assignInAllWith': true,
            'assignInWith': true,
            'assignWith': true,
            'defaults': true,
            'defaultsAll': true,
            'defaultsDeep': true,
            'defaultsDeepAll': true,
            'merge': true,
            'mergeAll': true,
            'mergeAllWith': true,
            'mergeWith': true
        },
        'set': {
            'set': true,
            'setWith': true,
            'unset': true,
            'update': true,
            'updateWith': true
        }
    };
    $fef938fb92c31507$export$1eb71a7e27943e71 = function() {
        var hasOwnProperty = Object.prototype.hasOwnProperty, object = $fef938fb92c31507$export$bd0f5e6e44efa6b4, result = {};
        for(var key in object){
            var value = object[key];
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }
        return result;
    }();
    $fef938fb92c31507$export$aee1dbae5de2db9d = {
        'assignAll': 'assign',
        'assignAllWith': 'assignWith',
        'assignInAll': 'assignIn',
        'assignInAllWith': 'assignInWith',
        'curryN': 'curry',
        'curryRightN': 'curryRight',
        'defaultsAll': 'defaults',
        'defaultsDeepAll': 'defaultsDeep',
        'findFrom': 'find',
        'findIndexFrom': 'findIndex',
        'findLastFrom': 'findLast',
        'findLastIndexFrom': 'findLastIndex',
        'getOr': 'get',
        'includesFrom': 'includes',
        'indexOfFrom': 'indexOf',
        'invokeArgs': 'invoke',
        'invokeArgsMap': 'invokeMap',
        'lastIndexOfFrom': 'lastIndexOf',
        'mergeAll': 'merge',
        'mergeAllWith': 'mergeWith',
        'padChars': 'pad',
        'padCharsEnd': 'padEnd',
        'padCharsStart': 'padStart',
        'propertyOf': 'get',
        'rangeStep': 'range',
        'rangeStepRight': 'rangeRight',
        'restFrom': 'rest',
        'spreadFrom': 'spread',
        'trimChars': 'trim',
        'trimCharsEnd': 'trimEnd',
        'trimCharsStart': 'trimStart',
        'zipAll': 'zip'
    };
    $fef938fb92c31507$export$87ffbe4821a5d5e0 = {
        'castArray': true,
        'flow': true,
        'flowRight': true,
        'iteratee': true,
        'mixin': true,
        'rearg': true,
        'runInContext': true
    };
    $fef938fb92c31507$export$b4d07413ce528c90 = {
        'add': true,
        'assign': true,
        'assignIn': true,
        'bind': true,
        'bindKey': true,
        'concat': true,
        'difference': true,
        'divide': true,
        'eq': true,
        'gt': true,
        'gte': true,
        'isEqual': true,
        'lt': true,
        'lte': true,
        'matchesProperty': true,
        'merge': true,
        'multiply': true,
        'overArgs': true,
        'partial': true,
        'partialRight': true,
        'propertyOf': true,
        'random': true,
        'range': true,
        'rangeRight': true,
        'subtract': true,
        'zip': true,
        'zipObject': true,
        'zipObjectDeep': true
    };
});
parcelRegister("aPsMW", function(module, exports) {
    module.exports = {};
});
parcelRegister("7sR67", function(module, exports) {
    module.exports = {
        'ary': (parcelRequire("lEyvi")),
        'assign': (parcelRequire("bqJNK")),
        'clone': (parcelRequire("91VA7")),
        'curry': (parcelRequire("a7NzZ")),
        'forEach': (parcelRequire("fmP8r")),
        'isArray': (parcelRequire("8LQ84")),
        'isError': (parcelRequire("aZFhV")),
        'isFunction': (parcelRequire("5vD8v")),
        'isWeakMap': (parcelRequire("5UxIS")),
        'iteratee': (parcelRequire("5qDt4")),
        'keys': (parcelRequire("hR3Ue")),
        'rearg': (parcelRequire("iZlmO")),
        'toInteger': (parcelRequire("kPZpS")),
        'toPath': (parcelRequire("6TYHJ"))
    };
});
parcelRegister("lEyvi", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $fc3819207d6eebc6$var$WRAP_ARY_FLAG = 128;
    function $fc3819207d6eebc6$var$ary(func, n, guard) {
        n = guard ? undefined : n;
        n = func && n == null ? func.length : n;
        return $5oTQF(func, $fc3819207d6eebc6$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }
    module.exports = $fc3819207d6eebc6$var$ary;
});
parcelRegister("5oTQF", function(module, exports) {
    var $g1o5k = parcelRequire("g1o5k");
    var $1BSxH = parcelRequire("1BSxH");
    var $gQoGK = parcelRequire("gQoGK");
    var $2pq1V = parcelRequire("2pq1V");
    var $cwXqG = parcelRequire("cwXqG");
    var $dzqxs = parcelRequire("dzqxs");
    var $c8pf3 = parcelRequire("c8pf3");
    var $4EzKU = parcelRequire("4EzKU");
    var $iKqmZ = parcelRequire("iKqmZ");
    var $kPZpS = parcelRequire("kPZpS");
    var $3eea84024a50d6cf$var$FUNC_ERROR_TEXT = 'Expected a function';
    var $3eea84024a50d6cf$var$WRAP_BIND_FLAG = 1, $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG = 2, $3eea84024a50d6cf$var$WRAP_CURRY_FLAG = 8, $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG = 16, $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG = 32, $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
    var $3eea84024a50d6cf$var$nativeMax = Math.max;
    function $3eea84024a50d6cf$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
        var isBindKey = bitmask & $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != 'function') throw new TypeError($3eea84024a50d6cf$var$FUNC_ERROR_TEXT);
        var length = partials ? partials.length : 0;
        if (!length) {
            bitmask &= ~($3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined;
        }
        ary = ary === undefined ? ary : $3eea84024a50d6cf$var$nativeMax($kPZpS(ary), 0);
        arity = arity === undefined ? arity : $kPZpS(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined;
        }
        var data = isBindKey ? undefined : $dzqxs(func);
        var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary,
            arity
        ];
        if (data) $c8pf3(newData, data);
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $3eea84024a50d6cf$var$nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & ($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG);
        if (!bitmask || bitmask == $3eea84024a50d6cf$var$WRAP_BIND_FLAG) var result = $1BSxH(func, bitmask, thisArg);
        else if (bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_FLAG || bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG) result = $gQoGK(func, bitmask, arity);
        else if ((bitmask == $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG || bitmask == ($3eea84024a50d6cf$var$WRAP_BIND_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $cwXqG(func, bitmask, thisArg, partials);
        else result = $2pq1V.apply(undefined, newData);
        var setter = data ? $g1o5k : $4EzKU;
        return $iKqmZ(setter(result, newData), func, bitmask);
    }
    module.exports = $3eea84024a50d6cf$var$createWrap;
});
parcelRegister("g1o5k", function(module, exports) {
    var $etyzk = parcelRequire("etyzk");
    var $hQCy5 = parcelRequire("hQCy5");
    var $ba9f6c1d52531584$var$baseSetData = !$hQCy5 ? $etyzk : function(func, data) {
        $hQCy5.set(func, data);
        return func;
    };
    module.exports = $ba9f6c1d52531584$var$baseSetData;
});
parcelRegister("1BSxH", function(module, exports) {
    var $iJkMv = parcelRequire("iJkMv");
    var $1V15E = parcelRequire("1V15E");
    var $12c38e2c5009183b$var$WRAP_BIND_FLAG = 1;
    function $12c38e2c5009183b$var$createBind(func, bitmask, thisArg) {
        var isBind = bitmask & $12c38e2c5009183b$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
        function wrapper() {
            var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
    }
    module.exports = $12c38e2c5009183b$var$createBind;
});
parcelRegister("iJkMv", function(module, exports) {
    var $ady43 = parcelRequire("ady43");
    var $k0qYG = parcelRequire("k0qYG");
    function $da2c8caf7ae3955a$var$createCtor(Ctor) {
        return function() {
            var args = arguments;
            switch(args.length){
                case 0:
                    return new Ctor;
                case 1:
                    return new Ctor(args[0]);
                case 2:
                    return new Ctor(args[0], args[1]);
                case 3:
                    return new Ctor(args[0], args[1], args[2]);
                case 4:
                    return new Ctor(args[0], args[1], args[2], args[3]);
                case 5:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                case 6:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                case 7:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = $ady43(Ctor.prototype), result = Ctor.apply(thisBinding, args);
            return $k0qYG(result) ? result : thisBinding;
        };
    }
    module.exports = $da2c8caf7ae3955a$var$createCtor;
});
parcelRegister("gQoGK", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $iJkMv = parcelRequire("iJkMv");
    var $2pq1V = parcelRequire("2pq1V");
    var $6fuEo = parcelRequire("6fuEo");
    var $8ZIC5 = parcelRequire("8ZIC5");
    var $kBUUu = parcelRequire("kBUUu");
    var $1V15E = parcelRequire("1V15E");
    function $c434a7442e0e841e$var$createCurry(func, bitmask, arity) {
        var Ctor = $iJkMv(func);
        function wrapper() {
            var length = arguments.length, args = Array(length), index = length, placeholder = $8ZIC5(wrapper);
            while(index--)args[index] = arguments[index];
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBUUu(args, placeholder);
            length -= holders.length;
            if (length < arity) return $6fuEo(func, bitmask, $2pq1V, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
            var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            return $hlchF(fn, this, args);
        }
        return wrapper;
    }
    module.exports = $c434a7442e0e841e$var$createCurry;
});
parcelRegister("2pq1V", function(module, exports) {
    var $k8MLc = parcelRequire("k8MLc");
    var $eqXBf = parcelRequire("eqXBf");
    var $khpbX = parcelRequire("khpbX");
    var $iJkMv = parcelRequire("iJkMv");
    var $6fuEo = parcelRequire("6fuEo");
    var $8ZIC5 = parcelRequire("8ZIC5");
    var $3Prcz = parcelRequire("3Prcz");
    var $kBUUu = parcelRequire("kBUUu");
    var $1V15E = parcelRequire("1V15E");
    var $1c121b92b9034c1f$var$WRAP_BIND_FLAG = 1, $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG = 2, $1c121b92b9034c1f$var$WRAP_CURRY_FLAG = 8, $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG = 16, $1c121b92b9034c1f$var$WRAP_ARY_FLAG = 128, $1c121b92b9034c1f$var$WRAP_FLIP_FLAG = 512;
    function $1c121b92b9034c1f$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
        var isAry = bitmask & $1c121b92b9034c1f$var$WRAP_ARY_FLAG, isBind = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_FLAG, isBindKey = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($1c121b92b9034c1f$var$WRAP_CURRY_FLAG | $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $1c121b92b9034c1f$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $iJkMv(func);
        function wrapper() {
            var length = arguments.length, args = Array(length), index = length;
            while(index--)args[index] = arguments[index];
            if (isCurried) var placeholder = $8ZIC5(wrapper), holdersCount = $khpbX(args, placeholder);
            if (partials) args = $k8MLc(args, partials, holders, isCurried);
            if (partialsRight) args = $eqXBf(args, partialsRight, holdersRight, isCurried);
            length -= holdersCount;
            if (isCurried && length < arity) {
                var newHolders = $kBUUu(args, placeholder);
                return $6fuEo(func, bitmask, $1c121b92b9034c1f$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) args = $3Prcz(args, argPos);
            else if (isFlip && length > 1) args.reverse();
            if (isAry && ary < length) args.length = ary;
            if (this && this !== $1V15E && this instanceof wrapper) fn = Ctor || $iJkMv(fn);
            return fn.apply(thisBinding, args);
        }
        return wrapper;
    }
    module.exports = $1c121b92b9034c1f$var$createHybrid;
});
parcelRegister("k8MLc", function(module, exports) {
    var $ea9a60ca966f8da9$var$nativeMax = Math.max;
    function $ea9a60ca966f8da9$var$composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $ea9a60ca966f8da9$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
        while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
        while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
        while(rangeLength--)result[leftIndex++] = args[argsIndex++];
        return result;
    }
    module.exports = $ea9a60ca966f8da9$var$composeArgs;
});
parcelRegister("eqXBf", function(module, exports) {
    var $a821b9ab167c5b82$var$nativeMax = Math.max;
    function $a821b9ab167c5b82$var$composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $a821b9ab167c5b82$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
        while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
        var offset = argsIndex;
        while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
        while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
        return result;
    }
    module.exports = $a821b9ab167c5b82$var$composeArgsRight;
});
parcelRegister("khpbX", function(module, exports) {
    function $ec38efbc1ab3f809$var$countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    module.exports = $ec38efbc1ab3f809$var$countHolders;
});
parcelRegister("6fuEo", function(module, exports) {
    var $2dCKt = parcelRequire("2dCKt");
    var $4EzKU = parcelRequire("4EzKU");
    var $iKqmZ = parcelRequire("iKqmZ");
    var $48cbeb57943323d5$var$WRAP_BIND_FLAG = 1, $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG = 2, $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG = 4, $48cbeb57943323d5$var$WRAP_CURRY_FLAG = 8, $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG = 32, $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
    function $48cbeb57943323d5$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
        var isCurry = bitmask & $48cbeb57943323d5$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
        bitmask |= isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG);
        if (!(bitmask & $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($48cbeb57943323d5$var$WRAP_BIND_FLAG | $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG);
        var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary,
            arity
        ];
        var result = wrapFunc.apply(undefined, newData);
        if ($2dCKt(func)) $4EzKU(result, newData);
        result.placeholder = placeholder;
        return $iKqmZ(result, func, bitmask);
    }
    module.exports = $48cbeb57943323d5$var$createRecurry;
});
parcelRegister("4EzKU", function(module, exports) {
    var $g1o5k = parcelRequire("g1o5k");
    var $eqv0t = parcelRequire("eqv0t");
    var $3636a22a88d50b78$var$setData = $eqv0t($g1o5k);
    module.exports = $3636a22a88d50b78$var$setData;
});
parcelRegister("iKqmZ", function(module, exports) {
    var $d25DY = parcelRequire("d25DY");
    var $iPKwQ = parcelRequire("iPKwQ");
    var $8pgNR = parcelRequire("8pgNR");
    var $1ZcUe = parcelRequire("1ZcUe");
    function $da60fa5a8c702882$var$setWrapToString(wrapper, reference, bitmask) {
        var source = reference + '';
        return $8pgNR(wrapper, $iPKwQ(source, $1ZcUe($d25DY(source), bitmask)));
    }
    module.exports = $da60fa5a8c702882$var$setWrapToString;
});
parcelRegister("d25DY", function(module, exports) {
    var $97cfd7023a392295$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $97cfd7023a392295$var$reSplitDetails = /,? & /;
    function $97cfd7023a392295$var$getWrapDetails(source) {
        var match = source.match($97cfd7023a392295$var$reWrapDetails);
        return match ? match[1].split($97cfd7023a392295$var$reSplitDetails) : [];
    }
    module.exports = $97cfd7023a392295$var$getWrapDetails;
});
parcelRegister("iPKwQ", function(module, exports) {
    var $db61150bcd231438$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
    function $db61150bcd231438$var$insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) return source;
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
        details = details.join(length > 2 ? ', ' : ' ');
        return source.replace($db61150bcd231438$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }
    module.exports = $db61150bcd231438$var$insertWrapDetails;
});
parcelRegister("1ZcUe", function(module, exports) {
    var $fmP8r = parcelRequire("fmP8r");
    var $fUP98 = parcelRequire("fUP98");
    var $17257fcfcc231370$var$WRAP_BIND_FLAG = 1, $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG = 2, $17257fcfcc231370$var$WRAP_CURRY_FLAG = 8, $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG = 16, $17257fcfcc231370$var$WRAP_PARTIAL_FLAG = 32, $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $17257fcfcc231370$var$WRAP_ARY_FLAG = 128, $17257fcfcc231370$var$WRAP_REARG_FLAG = 256, $17257fcfcc231370$var$WRAP_FLIP_FLAG = 512;
    var $17257fcfcc231370$var$wrapFlags = [
        [
            'ary',
            $17257fcfcc231370$var$WRAP_ARY_FLAG
        ],
        [
            'bind',
            $17257fcfcc231370$var$WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            $17257fcfcc231370$var$WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            $17257fcfcc231370$var$WRAP_FLIP_FLAG
        ],
        [
            'partial',
            $17257fcfcc231370$var$WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            $17257fcfcc231370$var$WRAP_REARG_FLAG
        ]
    ];
    function $17257fcfcc231370$var$updateWrapDetails(details, bitmask) {
        $fmP8r($17257fcfcc231370$var$wrapFlags, function(pair) {
            var value = '_.' + pair[0];
            if (bitmask & pair[1] && !$fUP98(details, value)) details.push(value);
        });
        return details.sort();
    }
    module.exports = $17257fcfcc231370$var$updateWrapDetails;
});
parcelRegister("8ZIC5", function(module, exports) {
    function $68c6a086039b9437$var$getHolder(func) {
        var object = func;
        return object.placeholder;
    }
    module.exports = $68c6a086039b9437$var$getHolder;
});
parcelRegister("3Prcz", function(module, exports) {
    var $jHlUS = parcelRequire("jHlUS");
    var $e8U1z = parcelRequire("e8U1z");
    var $2c9b3c36ffa24094$var$nativeMin = Math.min;
    function $2c9b3c36ffa24094$var$reorder(array, indexes) {
        var arrLength = array.length, length = $2c9b3c36ffa24094$var$nativeMin(indexes.length, arrLength), oldArray = $jHlUS(array);
        while(length--){
            var index = indexes[length];
            array[length] = $e8U1z(index, arrLength) ? oldArray[index] : undefined;
        }
        return array;
    }
    module.exports = $2c9b3c36ffa24094$var$reorder;
});
parcelRegister("kBUUu", function(module, exports) {
    var $f0136883d4267917$var$PLACEHOLDER = '__lodash_placeholder__';
    function $f0136883d4267917$var$replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === $f0136883d4267917$var$PLACEHOLDER) {
                array[index] = $f0136883d4267917$var$PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    module.exports = $f0136883d4267917$var$replaceHolders;
});
parcelRegister("cwXqG", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $iJkMv = parcelRequire("iJkMv");
    var $1V15E = parcelRequire("1V15E");
    var $91f6929c17575724$var$WRAP_BIND_FLAG = 1;
    function $91f6929c17575724$var$createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & $91f6929c17575724$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
        function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
            while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
            return $hlchF(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
    }
    module.exports = $91f6929c17575724$var$createPartial;
});
parcelRegister("c8pf3", function(module, exports) {
    var $k8MLc = parcelRequire("k8MLc");
    var $eqXBf = parcelRequire("eqXBf");
    var $kBUUu = parcelRequire("kBUUu");
    var $8d59cfe3586d6695$var$PLACEHOLDER = '__lodash_placeholder__';
    var $8d59cfe3586d6695$var$WRAP_BIND_FLAG = 1, $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG = 2, $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG = 4, $8d59cfe3586d6695$var$WRAP_CURRY_FLAG = 8, $8d59cfe3586d6695$var$WRAP_ARY_FLAG = 128, $8d59cfe3586d6695$var$WRAP_REARG_FLAG = 256;
    var $8d59cfe3586d6695$var$nativeMin = Math.min;
    function $8d59cfe3586d6695$var$mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($8d59cfe3586d6695$var$WRAP_BIND_FLAG | $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG | $8d59cfe3586d6695$var$WRAP_ARY_FLAG);
        var isCombo = srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG || srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($8d59cfe3586d6695$var$WRAP_ARY_FLAG | $8d59cfe3586d6695$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) return data;
        if (srcBitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG ? 0 : $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
            var partials = data[3];
            data[3] = partials ? $k8MLc(partials, value, source[4]) : value;
            data[4] = partials ? $kBUUu(data[3], $8d59cfe3586d6695$var$PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
            partials = data[5];
            data[5] = partials ? $eqXBf(partials, value, source[6]) : value;
            data[6] = partials ? $kBUUu(data[5], $8d59cfe3586d6695$var$PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) data[7] = value;
        if (srcBitmask & $8d59cfe3586d6695$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $8d59cfe3586d6695$var$nativeMin(data[8], source[8]);
        if (data[9] == null) data[9] = source[9];
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
    }
    module.exports = $8d59cfe3586d6695$var$mergeData;
});
parcelRegister("91VA7", function(module, exports) {
    var $7MmCC = parcelRequire("7MmCC");
    var $6930df867851495d$var$CLONE_SYMBOLS_FLAG = 4;
    function $6930df867851495d$var$clone(value) {
        return $7MmCC(value, $6930df867851495d$var$CLONE_SYMBOLS_FLAG);
    }
    module.exports = $6930df867851495d$var$clone;
});
parcelRegister("a7NzZ", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $75f10447dad5f8f2$var$WRAP_CURRY_FLAG = 8;
    function $75f10447dad5f8f2$var$curry(func, arity, guard) {
        arity = guard ? undefined : arity;
        var result = $5oTQF(func, $75f10447dad5f8f2$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = $75f10447dad5f8f2$var$curry.placeholder;
        return result;
    }
    $75f10447dad5f8f2$var$curry.placeholder = {};
    module.exports = $75f10447dad5f8f2$var$curry;
});
parcelRegister("aZFhV", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $1QOns = parcelRequire("1QOns");
    var $800fa0dabdb52684$var$domExcTag = '[object DOMException]', $800fa0dabdb52684$var$errorTag = '[object Error]';
    function $800fa0dabdb52684$var$isError(value) {
        if (!$fC1Kz(value)) return false;
        var tag = $beQoo(value);
        return tag == $800fa0dabdb52684$var$errorTag || tag == $800fa0dabdb52684$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$1QOns(value);
    }
    module.exports = $800fa0dabdb52684$var$isError;
});
parcelRegister("5UxIS", function(module, exports) {
    var $jtBGw = parcelRequire("jtBGw");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $44dc5758474a5c9f$var$weakMapTag = '[object WeakMap]';
    function $44dc5758474a5c9f$var$isWeakMap(value) {
        return $fC1Kz(value) && $jtBGw(value) == $44dc5758474a5c9f$var$weakMapTag;
    }
    module.exports = $44dc5758474a5c9f$var$isWeakMap;
});
parcelRegister("5qDt4", function(module, exports) {
    var $7MmCC = parcelRequire("7MmCC");
    var $bxDef = parcelRequire("bxDef");
    var $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG = 1;
    function $3f3dfefad45dde4d$var$iteratee(func) {
        return $bxDef(typeof func == 'function' ? func : $7MmCC(func, $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG));
    }
    module.exports = $3f3dfefad45dde4d$var$iteratee;
});
parcelRegister("iZlmO", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $9SRAA = parcelRequire("9SRAA");
    var $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG = 256;
    var $dd2e7f874e5ccea3$var$rearg = $9SRAA(function(func, indexes) {
        return $5oTQF(func, $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });
    module.exports = $dd2e7f874e5ccea3$var$rearg;
});
parcelRegister("6TYHJ", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $jHlUS = parcelRequire("jHlUS");
    var $8LQ84 = parcelRequire("8LQ84");
    var $4faK3 = parcelRequire("4faK3");
    var $h5JBK = parcelRequire("h5JBK");
    var $gzebZ = parcelRequire("gzebZ");
    var $jJVtR = parcelRequire("jJVtR");
    function $5066f7c1bc1a55ec$var$toPath(value) {
        if ($8LQ84(value)) return $1nIHN(value, $gzebZ);
        return $4faK3(value) ? [
            value
        ] : $jHlUS($h5JBK($jJVtR(value)));
    }
    module.exports = $5066f7c1bc1a55ec$var$toPath;
});
parcelRegister("6JUGo", function(module, exports) {
    var $8SMZJ = parcelRequire("8SMZJ");
    var $jJVtR = parcelRequire("jJVtR");
    var $4e82ea10714905a8$var$reUnescapedHtml = /[&<>"']/g, $4e82ea10714905a8$var$reHasUnescapedHtml = RegExp($4e82ea10714905a8$var$reUnescapedHtml.source);
    function $4e82ea10714905a8$var$escape(string) {
        string = $jJVtR(string);
        return string && $4e82ea10714905a8$var$reHasUnescapedHtml.test(string) ? string.replace($4e82ea10714905a8$var$reUnescapedHtml, $8SMZJ) : string;
    }
    module.exports = $4e82ea10714905a8$var$escape;
});
parcelRegister("8SMZJ", function(module, exports) {
    var $h2dNA = parcelRequire("h2dNA");
    var $67795f32b2638007$var$htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    var $67795f32b2638007$var$escapeHtmlChar = $h2dNA($67795f32b2638007$var$htmlEscapes);
    module.exports = $67795f32b2638007$var$escapeHtmlChar;
});
parcelRegister("bUoRH", function(module, exports) {
    module.exports = {
        'cap': false,
        'curry': false,
        'fixed': false,
        'immutable': false,
        'rearg': false
    };
});
parcelRegister("cTYeP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$964959221802308d$export$2e2bcd8739ae039);
    var $4MZp5;
    var $c9RLn;
    var $964959221802308d$var$contains = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("4MZp5")).default));
    var $964959221802308d$export$2e2bcd8739ae039 = $964959221802308d$var$contains;
});
parcelRegister("4MZp5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37cb4698d7b04f23$export$2e2bcd8739ae039);
    var $3gH8c;
    function $37cb4698d7b04f23$export$2e2bcd8739ae039(a, list) {
        return (0, (0, parcelRequire("3gH8c")).default)(list, a, 0) >= 0;
    }
});
parcelRegister("3gH8c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$261452b0a38e606a$export$2e2bcd8739ae039);
    var $8EB5I;
    function $261452b0a38e606a$export$2e2bcd8739ae039(list, a, idx) {
        var inf, item;
        if (typeof list.indexOf === 'function') switch(typeof a){
            case 'number':
                if (a === 0) {
                    inf = 1 / a;
                    while(idx < list.length){
                        item = list[idx];
                        if (item === 0 && 1 / item === inf) return idx;
                        idx += 1;
                    }
                    return -1;
                } else if (a !== a) {
                    while(idx < list.length){
                        item = list[idx];
                        if (typeof item === 'number' && item !== item) return idx;
                        idx += 1;
                    }
                    return -1;
                }
                return list.indexOf(a, idx);
            case 'string':
            case 'boolean':
            case 'function':
            case 'undefined':
                return list.indexOf(a, idx);
            case 'object':
                if (a === null) return list.indexOf(a, idx);
        }
        while(idx < list.length){
            if ((0, (0, parcelRequire("8EB5I")).default)(list[idx], a)) return idx;
            idx += 1;
        }
        return -1;
    }
});
parcelRegister("lV634", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff539cfa546b6cd8$export$2e2bcd8739ae039);
    var $ccUYa;
    var $ff539cfa546b6cd8$var$isNil = (0, (0, parcelRequire("ccUYa")).default)(function isNil(x) {
        return x == null;
    });
    var $ff539cfa546b6cd8$export$2e2bcd8739ae039 = $ff539cfa546b6cd8$var$isNil;
});
parcelRegister("3J2mc", function(module, exports) {
    $parcel$export(module.exports, "VIEW_MODES", ()=>$bfddb4bc2c4b7926$export$f4c4d822ceaa9764);
    const $bfddb4bc2c4b7926$export$f4c4d822ceaa9764 = {
        TIMELINE: 'timeline',
        LIST: 'list'
    };
});
parcelRegister("4nDwW", function(module, exports) {
    $parcel$export(module.exports, "chain", ()=>$9335a76542a4a558$export$e08e3b67e392101e);
    $parcel$export(module.exports, "fromPairs", ()=>$9335a76542a4a558$export$8995636b7242f090);
    $parcel$export(module.exports, "values", ()=>$9335a76542a4a558$export$68c286be0e7e55b7);
    $parcel$export(module.exports, "groupBy", ()=>$9335a76542a4a558$export$3f063810d7bf01bd);
    $parcel$export(module.exports, "indexBy", ()=>$9335a76542a4a558$export$e620e98009814b79);
    $parcel$export(module.exports, "sortWith", ()=>$9335a76542a4a558$export$a9e7d1a6fdcfefde);
    $parcel$export(module.exports, "ascend", ()=>$9335a76542a4a558$export$417c3e637c1bc965);
    $parcel$export(module.exports, "descend", ()=>$9335a76542a4a558$export$748246bdd9c122ea);
    $parcel$export(module.exports, "isDefined", ()=>$9335a76542a4a558$export$4e62c701997796c1);
    $parcel$export(module.exports, "filterDefined", ()=>$9335a76542a4a558$export$68250b7674019b05);
    $parcel$export(module.exports, "filterMap", ()=>$9335a76542a4a558$export$a04c6c6965dd4709);
    $parcel$export(module.exports, "valuesLength", ()=>$9335a76542a4a558$export$745491ed4818e2e8);
    $parcel$export(module.exports, "valuesKeysLength", ()=>$9335a76542a4a558$export$44e3e1a05911fec9);
    $parcel$export(module.exports, "mapValues", ()=>$9335a76542a4a558$export$825e789796ab7275);
    $parcel$export(module.exports, "pickBy", ()=>$9335a76542a4a558$export$b460b275d6c6aa0);
    $parcel$export(module.exports, "pluck", ()=>$9335a76542a4a558$export$c44985b87d605eff);
    $parcel$export(module.exports, "mapObject", ()=>$9335a76542a4a558$export$d6051a0f7a227332);
    $parcel$export(module.exports, "move", ()=>$9335a76542a4a558$export$d947e5f4f4c48d48);
    $parcel$export(module.exports, "mapGroupsToIds", ()=>$9335a76542a4a558$export$28674149d4fdfa90);
    var $gOcYF;
    var $2rMKg;
    function $9335a76542a4a558$export$e08e3b67e392101e(callback, array) {
        const result = [];
        for (const elements of array.map(callback))Array.prototype.push.apply(result, elements);
        return result;
    }
    function $9335a76542a4a558$export$8995636b7242f090(pairs) {
        const result = {};
        for (const [k, v] of pairs)result[k] = v;
        return result;
    }
    const $9335a76542a4a558$export$68c286be0e7e55b7 = (object)=>Object.values(object);
    function $9335a76542a4a558$export$3f063810d7bf01bd(keyFn, array) {
        const result = {};
        for (const element of array){
            const key = keyFn(element);
            if (!result[key]) result[key] = [];
            result[key].push(element);
        }
        return result;
    }
    function $9335a76542a4a558$export$e620e98009814b79(keyFn, array) {
        const result = {};
        for (const element of array){
            const key = keyFn(element);
            result[key] = element;
        }
        return result;
    }
    function $9335a76542a4a558$export$a9e7d1a6fdcfefde(comparators) {
        return (array)=>[
                ...array
            ].sort((a, b)=>{
                let comparison = 0;
                for (const comparator of comparators){
                    comparison = comparator(a, b);
                    if (comparison !== 0) return comparison;
                }
                return comparison;
            });
    }
    function $9335a76542a4a558$export$417c3e637c1bc965(keyFn) {
        return (a, b)=>{
            const keyA = keyFn(a);
            const keyB = keyFn(b);
            if (typeof keyA === 'number' && typeof keyB === 'number') {
                if (keyA < keyB) return -1;
                if (keyA > keyB) return 1;
                return 0;
            }
            if (typeof keyA === 'string' && typeof keyB === 'string') {
                if (keyA < keyB) return -1;
                if (keyA > keyB) return 1;
                return 0;
            }
            throw new Error('keyFn must return number or string consistently');
        };
    }
    function $9335a76542a4a558$export$748246bdd9c122ea(keyFn) {
        return (a, b)=>{
            const keyA = keyFn(a);
            const keyB = keyFn(b);
            if (typeof keyA === 'number' && typeof keyB === 'number') {
                if (keyA > keyB) return -1;
                if (keyA < keyB) return 1;
                return 0;
            }
            if (typeof keyA === 'string' && typeof keyB === 'string') {
                if (keyA > keyB) return -1;
                if (keyA < keyB) return 1;
                return 0;
            }
            throw new Error('keyFn must return number or string consistently');
        };
    }
    function $9335a76542a4a558$export$448332262467e042(array) {
        let counter = array.length;
        const result = [
            ...array
        ];
        while(counter > 0){
            const index = Math.floor(Math.random() * counter);
            counter -= 1;
            const temp = result[counter];
            result[counter] = result[index];
            result[index] = temp;
        }
        return result;
    }
    function $9335a76542a4a558$export$66c1ae025e96b4bc(array) {
        const reversed = [];
        for(let i = array.length - 1; i >= 0; i -= 1)reversed.push(array[i]);
        return reversed;
    }
    function $9335a76542a4a558$export$4e62c701997796c1(thing) {
        return thing !== undefined && thing !== null;
    }
    function $9335a76542a4a558$export$68250b7674019b05(array) {
        const filtered = [];
        for (const e of array)if ($9335a76542a4a558$export$4e62c701997796c1(e)) filtered.push(e);
        return filtered;
    }
    function $9335a76542a4a558$export$a04c6c6965dd4709(filter, map, array) {
        const result = [];
        for(let i = 0; i < array.length; i++){
            const element = array[i];
            if (filter(element)) result.push(map(element, i));
        }
        return result;
    }
    function $9335a76542a4a558$export$745491ed4818e2e8(object) {
        let result = 0;
        for (const array of Object.values(object))result += array.length;
        return result;
    }
    function $9335a76542a4a558$export$44e3e1a05911fec9(object) {
        let result = 0;
        for (const child of Object.values(object))result += Object.keys(child).length;
        return result;
    }
    function $9335a76542a4a558$export$825e789796ab7275(f, object) {
        const result = {};
        for (const k of Object.keys(object))result[k] = object[k].map(f);
        return result;
    }
    function $9335a76542a4a558$export$b460b275d6c6aa0(f, obj) {
        return Object.entries(obj).reduce((acc, [key, value])=>{
            if (f(value, key)) {
                acc[key] = value;
                return acc;
            }
            return acc;
        }, {});
    }
    function $9335a76542a4a558$export$c44985b87d605eff(prop, array) {
        return array.map((x)=>x[prop]);
    }
    function $9335a76542a4a558$export$d6051a0f7a227332(f, object) {
        const result = {};
        for (const k of Object.keys(object))result[k] = f(k, object[k]);
        return result;
    }
    function $9335a76542a4a558$export$d947e5f4f4c48d48(fromIndex, toIndex, array) {
        return (0, parcelRequire("gOcYF")).default(fromIndex, toIndex, array);
    }
    function $9335a76542a4a558$export$28674149d4fdfa90(object) {
        return $9335a76542a4a558$export$825e789796ab7275((0, parcelRequire("2rMKg")).default('id'), object);
    }
});
parcelRegister("gOcYF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3cb61e65a9bbbf5$export$2e2bcd8739ae039);
    var $IYMZh;
    var $c3cb61e65a9bbbf5$var$move = (0, (0, parcelRequire("IYMZh")).default)(function(from, to, list) {
        var length = list.length;
        var result = list.slice();
        var positiveFrom = from < 0 ? length + from : from;
        var positiveTo = to < 0 ? length + to : to;
        var item = result.splice(positiveFrom, 1);
        return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
    });
    var $c3cb61e65a9bbbf5$export$2e2bcd8739ae039 = $c3cb61e65a9bbbf5$var$move;
});
parcelRegister("IYMZh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$087343a0f2c6357f$export$2e2bcd8739ae039);
    var $ccUYa;
    var $c9RLn;
    var $iU24A;
    function $087343a0f2c6357f$export$2e2bcd8739ae039(fn) {
        return function f3(a, b, c) {
            switch(arguments.length){
                case 0:
                    return f3;
                case 1:
                    return (0, (0, parcelRequire("iU24A")).default)(a) ? f3 : (0, (0, parcelRequire("c9RLn")).default)(function(_b, _c) {
                        return fn(a, _b, _c);
                    });
                case 2:
                    return (0, (0, parcelRequire("iU24A")).default)(a) && (0, (0, parcelRequire("iU24A")).default)(b) ? f3 : (0, (0, parcelRequire("iU24A")).default)(a) ? (0, (0, parcelRequire("c9RLn")).default)(function(_a, _c) {
                        return fn(_a, b, _c);
                    }) : (0, (0, parcelRequire("iU24A")).default)(b) ? (0, (0, parcelRequire("c9RLn")).default)(function(_b, _c) {
                        return fn(a, _b, _c);
                    }) : (0, (0, parcelRequire("ccUYa")).default)(function(_c) {
                        return fn(a, b, _c);
                    });
                default:
                    return (0, (0, parcelRequire("iU24A")).default)(a) && (0, (0, parcelRequire("iU24A")).default)(b) && (0, (0, parcelRequire("iU24A")).default)(c) ? f3 : (0, (0, parcelRequire("iU24A")).default)(a) && (0, (0, parcelRequire("iU24A")).default)(b) ? (0, (0, parcelRequire("c9RLn")).default)(function(_a, _b) {
                        return fn(_a, _b, c);
                    }) : (0, (0, parcelRequire("iU24A")).default)(a) && (0, (0, parcelRequire("iU24A")).default)(c) ? (0, (0, parcelRequire("c9RLn")).default)(function(_a, _c) {
                        return fn(_a, b, _c);
                    }) : (0, (0, parcelRequire("iU24A")).default)(b) && (0, (0, parcelRequire("iU24A")).default)(c) ? (0, (0, parcelRequire("c9RLn")).default)(function(_b, _c) {
                        return fn(a, _b, _c);
                    }) : (0, (0, parcelRequire("iU24A")).default)(a) ? (0, (0, parcelRequire("ccUYa")).default)(function(_a) {
                        return fn(_a, b, c);
                    }) : (0, (0, parcelRequire("iU24A")).default)(b) ? (0, (0, parcelRequire("ccUYa")).default)(function(_b) {
                        return fn(a, _b, c);
                    }) : (0, (0, parcelRequire("iU24A")).default)(c) ? (0, (0, parcelRequire("ccUYa")).default)(function(_c) {
                        return fn(a, b, _c);
                    }) : fn(a, b, c);
            }
        };
    }
});
parcelRegister("2rMKg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c83ea276f4e80cb$export$2e2bcd8739ae039);
    var $c9RLn;
    var $fZhYM;
    var $1c83ea276f4e80cb$var$prop = (0, (0, parcelRequire("c9RLn")).default)(function prop(p, obj) {
        return (0, (0, parcelRequire("fZhYM")).default)([
            p
        ], obj);
    });
    var $1c83ea276f4e80cb$export$2e2bcd8739ae039 = $1c83ea276f4e80cb$var$prop;
});
parcelRegister("fZhYM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba3a7fdd4184b2df$export$2e2bcd8739ae039);
    var $c9RLn;
    var $ba3a7fdd4184b2df$var$path = (0, (0, parcelRequire("c9RLn")).default)(function path(paths, obj) {
        var val = obj;
        var idx = 0;
        while(idx < paths.length){
            if (val == null) return;
            val = val[paths[idx]];
            idx += 1;
        }
        return val;
    });
    var $ba3a7fdd4184b2df$export$2e2bcd8739ae039 = $ba3a7fdd4184b2df$var$path;
});
parcelRegister("TTKUQ", function(module, exports) {
    $parcel$export(module.exports, "DefaultDateFormat", ()=>$5e0415637054ea24$export$14ae725d0cc7daa1);
    $parcel$export(module.exports, "EXPORT_FILE_DATE_FORMAT", ()=>$5e0415637054ea24$export$363270f5bff80927);
    $parcel$export(module.exports, "SCENARIO_ISSUE_ID_PREFIX", ()=>$5e0415637054ea24$export$c8c7cce628cf5c4e);
    $parcel$export(module.exports, "DIRECTIONS", ()=>$5e0415637054ea24$export$4aabe0d20c9c03b3);
    $parcel$export(module.exports, "PLANNING_UNITS", ()=>$5e0415637054ea24$export$c56f9fa2106f4847);
    $parcel$export(module.exports, "CROSS_PROJECT_RELEASE", ()=>$5e0415637054ea24$export$7b04eb9e81ba1c56);
    $parcel$export(module.exports, "NONE", ()=>$5e0415637054ea24$export$c53d0f541b41b88e);
    $parcel$export(module.exports, "PROJECT", ()=>$5e0415637054ea24$export$fe791c4fa892e400);
    $parcel$export(module.exports, "RELEASE", ()=>$5e0415637054ea24$export$5c698591c0e586a2);
    $parcel$export(module.exports, "ASCENDING", ()=>$5e0415637054ea24$export$6e386ac144cffab5);
    $parcel$export(module.exports, "DEFAULT", ()=>$5e0415637054ea24$export$e6952b12ade67489);
    $parcel$export(module.exports, "LINES", ()=>$5e0415637054ea24$export$e0de529f548a9140);
    $parcel$export(module.exports, "COUNT", ()=>$5e0415637054ea24$export$d61684373eacdf61);
    $parcel$export(module.exports, "ENTITY", ()=>$5e0415637054ea24$export$fa20de1d199f87ac);
    $parcel$export(module.exports, "SCENARIO_TYPE", ()=>$5e0415637054ea24$export$6952e648aa2551c8);
    $parcel$export(module.exports, "GROUPING", ()=>$5e0415637054ea24$export$a9c30cbc241a4f57);
    $parcel$export(module.exports, "STRING", ()=>$5e0415637054ea24$export$a0e01ba2ebef17f2);
    $parcel$export(module.exports, "ISSUE_FIELD_TYPES", ()=>$5e0415637054ea24$export$a8827164bd516a88);
    $parcel$export(module.exports, "SORT_DIRECTION", ()=>$5e0415637054ea24$export$2e66878530bcbbc7);
    $parcel$export(module.exports, "COMPLETED_SPRINTS_GROUP", ()=>$5e0415637054ea24$export$cc61be5f9aa609ee);
    $parcel$export(module.exports, "COMPLETED_RELEASES_GROUP", ()=>$5e0415637054ea24$export$93d3dc39c0269fe3);
    $parcel$export(module.exports, "RELEASE_STATUSES", ()=>$5e0415637054ea24$export$7082e4b62554b72d);
    $parcel$export(module.exports, "RELEASE_STATUSES_APPEARANCE_SPA", ()=>$5e0415637054ea24$export$311d2f5af921faaa);
    $parcel$export(module.exports, "CustomFieldTypes", ()=>$5e0415637054ea24$export$331c42b4f42400fb);
    $parcel$export(module.exports, "CustomFieldTypesToDataType", ()=>$5e0415637054ea24$export$fea945adb3660cc7);
    $parcel$export(module.exports, "CustomFields", ()=>$5e0415637054ea24$export$a1d1fd7da6e94a65);
    $parcel$export(module.exports, "PREVIEW_OPACITY", ()=>$5e0415637054ea24$export$8ffcc37b9e9dd572);
    $parcel$export(module.exports, "ISSUE_STATUS_CATEGORIES_CONST", ()=>$5e0415637054ea24$export$16f1a8408ee71016);
    $parcel$export(module.exports, "ISSUE_STATUS_CATEGORIES", ()=>$5e0415637054ea24$export$2b1f4448b6b508db);
    $parcel$export(module.exports, "ISSUE_STATUS_APPEARANCE", ()=>$5e0415637054ea24$export$86fc137548f2fce5);
    $parcel$export(module.exports, "SPRINT_STATES", ()=>$5e0415637054ea24$export$73a0206a4dc59760);
    $parcel$export(module.exports, "EXTERNAL_SPRINT", ()=>$5e0415637054ea24$export$f1b6d0605ff9b7e6);
    $parcel$export(module.exports, "DEFAULT_FIELD_WIDTH", ()=>$5e0415637054ea24$export$e5d805200f62f81d);
    $parcel$export(module.exports, "SCOPE_ROW_HEIGHT", ()=>$5e0415637054ea24$export$6edf6d7514b31ffa);
    $parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_SCOPE_WIDTH", ()=>$5e0415637054ea24$export$a705d305be7bd15d);
    $parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_FIELDS_WIDTH", ()=>$5e0415637054ea24$export$9a8b9408dd2830b);
    $parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_TIMELINE_WIDTH", ()=>$5e0415637054ea24$export$4cd768253686885b);
    $parcel$export(module.exports, "NUM_ISSUES_IN_EXPORT_PREVIEW", ()=>$5e0415637054ea24$export$36a3ce28e91ef989);
    $parcel$export(module.exports, "AUTO_SCHEDULE_OVERWRITE", ()=>$5e0415637054ea24$export$de3ef5bf994b7018);
    $parcel$export(module.exports, "ISSUE_VALUES", ()=>$5e0415637054ea24$export$f9c0c7ff9184db0);
    $parcel$export(module.exports, "PlanningUnits", ()=>$5e0415637054ea24$export$448fe702ac76034a);
    $parcel$export(module.exports, "UNDEFINED_KEY", ()=>$5e0415637054ea24$export$75989ea7860b85e9);
    $parcel$export(module.exports, "STICKY_HEADER_CONTAINER_PREFIX", ()=>$5e0415637054ea24$export$6bc4f75201f6f12e);
    $parcel$export(module.exports, "CHECKBOX_STATES", ()=>$5e0415637054ea24$export$e3c19de1b019757c);
    $parcel$export(module.exports, "PLUGIN_PERMISSION", ()=>$5e0415637054ea24$export$3bf3c26d6d69f3b1);
    $parcel$export(module.exports, "SHARE_AS", ()=>$5e0415637054ea24$export$40628b030ac72445);
    $parcel$export(module.exports, "SCHEDULE_MODE", ()=>$5e0415637054ea24$export$5b1b1523594baa6e);
    $parcel$export(module.exports, "INSTANCE_USER_ROLE", ()=>$5e0415637054ea24$export$b4d5766fd1973953);
    $parcel$export(module.exports, "PLAN_USER_ROLE", ()=>$5e0415637054ea24$export$183f45c476faaff2);
    $parcel$export(module.exports, "ISSUE_LINK_DIRECTION", ()=>$5e0415637054ea24$export$deea8c9ae0e3c1ca);
    $parcel$export(module.exports, "ISSUE_SOURCE_TYPES", ()=>$5e0415637054ea24$export$86e2f9653c14c34);
    $parcel$export(module.exports, "PERFORMANCE_KEYS", ()=>$5e0415637054ea24$export$f048d91ccaf92408);
    $parcel$export(module.exports, "PROFILE_KEYS", ()=>$5e0415637054ea24$export$4eb5c0330ef8fab4);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$5e0415637054ea24$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", ()=>$5e0415637054ea24$export$f27a837467ec20e5);
    $parcel$export(module.exports, "ERROR_REPORTING_TEAM", ()=>$5e0415637054ea24$export$cfeee2ee86ead336);
    $parcel$export(module.exports, "MAX_BULK_CHANGE_ISSUES", ()=>$5e0415637054ea24$export$bf7af18c7898a31);
    $parcel$export(module.exports, "DEPENDENCY_SETTINGS", ()=>$5e0415637054ea24$export$37e30ab04b9b1705);
    $parcel$export(module.exports, "HORIZONTAL_SCROLL_OFFSET", ()=>$5e0415637054ea24$export$e24665e8d921f93e);
    $parcel$export(module.exports, "PROJECT_TYPE_KEY", ()=>$5e0415637054ea24$export$22ed55708a9d1966);
    $parcel$export(module.exports, "ZOOM_LEVELS", ()=>$5e0415637054ea24$export$8b7222fa92892b49);
    $parcel$export(module.exports, "TIMELINE_MODES", ()=>$5e0415637054ea24$export$bbbec7054427e57b);
    $parcel$export(module.exports, "CUSTOM_DATE_RANGES", ()=>$5e0415637054ea24$export$b0f7807f8d64b44a);
    $parcel$export(module.exports, "VALID_LEADING_TIME_FOR_DEPENDENCIES", ()=>$5e0415637054ea24$export$46a3b4b81e5a44ac);
    $parcel$export(module.exports, "NOTIFY_WATCHERS_KEY", ()=>$5e0415637054ea24$export$954b02519e22ad3c);
    $parcel$export(module.exports, "TIMELINE_SHARE_TYPE", ()=>$5e0415637054ea24$export$cb60c924e8198091);
    $parcel$export(module.exports, "DEPENDENCY_REPORT_SHARE_TYPE", ()=>$5e0415637054ea24$export$16c8656f8d888a96);
    $parcel$export(module.exports, "SECTION_KEYS", ()=>$5e0415637054ea24$export$d37ffa307efd6838);
    $parcel$export(module.exports, "SECTION_ITEM_KEYS", ()=>$5e0415637054ea24$export$cb4feb832f4bb576);
    $parcel$export(module.exports, "ORIGINAL_STATUS_TRANSITION", ()=>$5e0415637054ea24$export$ce125fc0306b71a0);
    $parcel$export(module.exports, "BREAKDOWN_SPRINT_CAPACITY_BY", ()=>$5e0415637054ea24$export$c773c9bd947df9ae);
    $parcel$export(module.exports, "IPH_IDS", ()=>$5e0415637054ea24$export$253194752488840a);
    var $flnZx;
    const $5e0415637054ea24$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
    const $5e0415637054ea24$export$1d279fd478aab274 = 'dd/MMM/yy';
    const $5e0415637054ea24$export$10b28f765b682c36 = 'yyyy-MM-dd';
    const $5e0415637054ea24$export$ce46174a69ff80b3 = 'DD MMM YYYY h:mma';
    const $5e0415637054ea24$export$4255b3d650213d61 = 'D MMM';
    const $5e0415637054ea24$export$cc2582ada357cd5 = 'D MMM YYYY';
    const $5e0415637054ea24$export$363270f5bff80927 = 'DDMMYYYY';
    const $5e0415637054ea24$export$c8c7cce628cf5c4e = 'SCEN-';
    const $5e0415637054ea24$export$4aabe0d20c9c03b3 = {
        AFTER: 'after',
        BEFORE: 'before'
    };
    const $5e0415637054ea24$export$c56f9fa2106f4847 = {
        STORY_POINTS: 'StoryPoints',
        DAYS: 'Days',
        HOURS: 'Hours'
    };
    const $5e0415637054ea24$export$f8f7545d2bb78afb = 'ASSIGNEE';
    const $5e0415637054ea24$export$6d7021166edc895c = 'REPORTER';
    const $5e0415637054ea24$export$af1e30ebbae9df3b = 'COMPONENT';
    const $5e0415637054ea24$export$3d393c30a30490eb = 'GOALS';
    const $5e0415637054ea24$export$a75a0417fc96ea63 = 'IDEAS';
    const $5e0415637054ea24$export$7b04eb9e81ba1c56 = 'CROSS_PROJECT_RELEASE';
    const $5e0415637054ea24$export$76a449e52fa0e1e8 = 'ISSUE';
    const $5e0415637054ea24$export$37aee82a3cb1e8f7 = 'LABEL';
    const $5e0415637054ea24$export$c53d0f541b41b88e = 'NONE';
    const $5e0415637054ea24$export$fe791c4fa892e400 = 'PROJECT';
    const $5e0415637054ea24$export$5c698591c0e586a2 = 'RELEASE';
    const $5e0415637054ea24$export$84ba8fa7099b85b = 'RESOURCE';
    const $5e0415637054ea24$export$bc8b984358922f81 = 'TEAM';
    const $5e0415637054ea24$export$c3d7e0f1e63de60e = 'RANK';
    const $5e0415637054ea24$export$6e386ac144cffab5 = 'ASCENDING';
    const $5e0415637054ea24$export$f634ff5a7f1c8f3 = 'DESCENDING';
    const $5e0415637054ea24$export$a316570a0dbfd2b0 = 'SPRINT';
    const $5e0415637054ea24$export$3e0a40c59fa4032 = 'PLANNED_CAPACITY';
    const $5e0415637054ea24$export$e6952b12ade67489 = 'default';
    const $5e0415637054ea24$export$e0de529f548a9140 = 'lines';
    const $5e0415637054ea24$export$d61684373eacdf61 = 'count';
    const $5e0415637054ea24$export$fa20de1d199f87ac = {
        ISSUE: $5e0415637054ea24$export$76a449e52fa0e1e8,
        RELEASE: $5e0415637054ea24$export$5c698591c0e586a2,
        CROSS_PROJECT_RELEASE: $5e0415637054ea24$export$7b04eb9e81ba1c56,
        TEAM: $5e0415637054ea24$export$bc8b984358922f81,
        RESOURCE: $5e0415637054ea24$export$84ba8fa7099b85b,
        PLANNED_CAPACITY: $5e0415637054ea24$export$3e0a40c59fa4032,
        SPRINT: $5e0415637054ea24$export$a316570a0dbfd2b0,
        NONE: $5e0415637054ea24$export$c53d0f541b41b88e
    };
    const $5e0415637054ea24$export$6952e648aa2551c8 = {
        ADDED: 'ADDED',
        UPDATED: 'UPDATED',
        DELETED: 'DELETED',
        DELETEDFROMJIRA: 'DELETEDFROMJIRA',
        NONE: 'NONE',
        MULTIPLE: 'MULTIPLE',
        EXCLUDED: 'EXCLUDED',
        ADDEDEXISTING: 'ADDEDEXISTING',
        UNKNOWN: 'UNKNOWN'
    };
    const $5e0415637054ea24$export$a9c30cbc241a4f57 = {
        NONE: $5e0415637054ea24$export$c53d0f541b41b88e,
        ASSIGNEE: $5e0415637054ea24$export$f8f7545d2bb78afb,
        COMPONENT: $5e0415637054ea24$export$af1e30ebbae9df3b,
        GOALS: $5e0415637054ea24$export$3d393c30a30490eb,
        IDEAS: $5e0415637054ea24$export$a75a0417fc96ea63,
        LABEL: $5e0415637054ea24$export$37aee82a3cb1e8f7,
        PROJECT: $5e0415637054ea24$export$fe791c4fa892e400,
        RELEASE: $5e0415637054ea24$export$5c698591c0e586a2,
        REPORTER: $5e0415637054ea24$export$6d7021166edc895c,
        TEAM: $5e0415637054ea24$export$bc8b984358922f81,
        SPRINT: $5e0415637054ea24$export$a316570a0dbfd2b0
    };
    const $5e0415637054ea24$export$a0e01ba2ebef17f2 = 'string';
    const $5e0415637054ea24$export$501a7fac1df67a49 = 'date';
    const $5e0415637054ea24$export$4e8bcd47a31d751c = 'number';
    const $5e0415637054ea24$export$a8827164bd516a88 = {
        DATE: $5e0415637054ea24$export$501a7fac1df67a49,
        STRING: $5e0415637054ea24$export$a0e01ba2ebef17f2,
        NUMBER: $5e0415637054ea24$export$4e8bcd47a31d751c
    };
    const $5e0415637054ea24$export$2e66878530bcbbc7 = {
        ASCENDING: $5e0415637054ea24$export$6e386ac144cffab5,
        DESCENDING: $5e0415637054ea24$export$f634ff5a7f1c8f3
    };
    const $5e0415637054ea24$export$cc61be5f9aa609ee = 'COMPLETED_SPRINTS_GROUP';
    const $5e0415637054ea24$export$93d3dc39c0269fe3 = 'COMPLETED_RELEASES_GROUP';
    const $5e0415637054ea24$var$UNRELEASED = '0';
    const $5e0415637054ea24$var$RELEASED = '1';
    const $5e0415637054ea24$var$OFFTRACK = '2';
    const $5e0415637054ea24$var$ONTRACK = '3';
    const $5e0415637054ea24$export$7082e4b62554b72d = {
        UNRELEASED: $5e0415637054ea24$var$UNRELEASED,
        RELEASED: $5e0415637054ea24$var$RELEASED,
        OFFTRACK: $5e0415637054ea24$var$OFFTRACK,
        ONTRACK: $5e0415637054ea24$var$ONTRACK
    };
    const $5e0415637054ea24$export$311d2f5af921faaa = {
        [$5e0415637054ea24$var$UNRELEASED]: 'inprogress',
        [$5e0415637054ea24$var$RELEASED]: 'success',
        [$5e0415637054ea24$var$OFFTRACK]: 'removed',
        [$5e0415637054ea24$var$ONTRACK]: 'inprogress'
    };
    const $5e0415637054ea24$export$331c42b4f42400fb = {
        AssetObject: 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype',
        TextField: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
        SingleSelect: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
        MultiSelect: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
        DatePicker: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker',
        NumberField: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
        MultiCheckboxes: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
        RadioButtons: 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
        UserPicker: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
        Url: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
        Labels: 'com.atlassian.jira.plugin.system.customfieldtypes:labels'
    };
    const $5e0415637054ea24$export$fea945adb3660cc7 = {
        [$5e0415637054ea24$export$331c42b4f42400fb.DatePicker]: $5e0415637054ea24$export$a8827164bd516a88.DATE,
        [$5e0415637054ea24$export$331c42b4f42400fb.NumberField]: $5e0415637054ea24$export$a8827164bd516a88.NUMBER,
        [$5e0415637054ea24$export$331c42b4f42400fb.SingleSelect]: $5e0415637054ea24$export$a8827164bd516a88.STRING
    };
    const $5e0415637054ea24$export$a1d1fd7da6e94a65 = {
        WritableFields: [
            $5e0415637054ea24$export$331c42b4f42400fb.DatePicker,
            $5e0415637054ea24$export$331c42b4f42400fb.Labels,
            $5e0415637054ea24$export$331c42b4f42400fb.MultiCheckboxes,
            $5e0415637054ea24$export$331c42b4f42400fb.MultiSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.NumberField,
            $5e0415637054ea24$export$331c42b4f42400fb.RadioButtons,
            $5e0415637054ea24$export$331c42b4f42400fb.SingleSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.TextField,
            $5e0415637054ea24$export$331c42b4f42400fb.UserPicker
        ],
        ReadOnlyFields: [
            $5e0415637054ea24$export$331c42b4f42400fb.Url,
            $5e0415637054ea24$export$331c42b4f42400fb.AssetObject
        ],
        FilterableFields: [
            $5e0415637054ea24$export$331c42b4f42400fb.SingleSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.Labels,
            $5e0415637054ea24$export$331c42b4f42400fb.MultiCheckboxes,
            $5e0415637054ea24$export$331c42b4f42400fb.MultiSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.RadioButtons,
            $5e0415637054ea24$export$331c42b4f42400fb.AssetObject
        ],
        GroupableSingleValueFields: [
            $5e0415637054ea24$export$331c42b4f42400fb.SingleSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.UserPicker
        ],
        GroupableMultiValueFields: [
            $5e0415637054ea24$export$331c42b4f42400fb.Labels,
            $5e0415637054ea24$export$331c42b4f42400fb.MultiSelect,
            $5e0415637054ea24$export$331c42b4f42400fb.AssetObject
        ]
    };
    const $5e0415637054ea24$export$8ffcc37b9e9dd572 = 0.5;
    const $5e0415637054ea24$export$16f1a8408ee71016 = {
        TODO: 2,
        INPROGRESS: 4,
        DONE: 3
    };
    const $5e0415637054ea24$export$2b1f4448b6b508db = {
        TODO: 2,
        INPROGRESS: 4,
        DONE: 3
    };
    const $5e0415637054ea24$export$86fc137548f2fce5 = {
        [$5e0415637054ea24$export$2b1f4448b6b508db.TODO]: 'default',
        [$5e0415637054ea24$export$2b1f4448b6b508db.INPROGRESS]: 'inprogress',
        [$5e0415637054ea24$export$2b1f4448b6b508db.DONE]: 'success'
    };
    const $5e0415637054ea24$export$73a0206a4dc59760 = {
        CLOSED: 'CLOSED',
        ACTIVE: 'ACTIVE',
        FUTURE: 'FUTURE'
    };
    const $5e0415637054ea24$export$f1b6d0605ff9b7e6 = 'EXTERNAL_SPRINT';
    const $5e0415637054ea24$export$8c8dab1ad613072e = 3000;
    const $5e0415637054ea24$export$e5d805200f62f81d = {
        SMALL: 64,
        MEDIUM: 128,
        LARGE: 160,
        EXTRALARGE: 240
    };
    const $5e0415637054ea24$export$6edf6d7514b31ffa = 40;
    const $5e0415637054ea24$export$a705d305be7bd15d = 440;
    const $5e0415637054ea24$export$9a8b9408dd2830b = 600;
    const $5e0415637054ea24$export$4cd768253686885b = 900;
    const $5e0415637054ea24$export$36a3ce28e91ef989 = 20;
    const $5e0415637054ea24$export$f777897e7e87cb69 = 'ALL_VALUES';
    const $5e0415637054ea24$export$2933446418f07e42 = 'EMPTY_VALUES_ONLY';
    const $5e0415637054ea24$export$de3ef5bf994b7018 = {
        ALL_VALUES: $5e0415637054ea24$export$f777897e7e87cb69,
        EMPTY_VALUES_ONLY: $5e0415637054ea24$export$2933446418f07e42
    };
    const $5e0415637054ea24$export$f9c0c7ff9184db0 = {
        SPRINT: $5e0415637054ea24$export$a316570a0dbfd2b0,
        RELEASE: $5e0415637054ea24$export$5c698591c0e586a2,
        TEAM: $5e0415637054ea24$export$bc8b984358922f81
    };
    const $5e0415637054ea24$export$448fe702ac76034a = {
        storyPoints: 'StoryPoints',
        days: 'Days',
        hours: 'Hours'
    };
    const $5e0415637054ea24$export$75989ea7860b85e9 = 'UNDEFINED';
    const $5e0415637054ea24$export$6bc4f75201f6f12e = 'sticky-header-cell';
    const $5e0415637054ea24$export$e3c19de1b019757c = {
        CHECKED: 'checked',
        UNCHECKED: 'unchecked',
        INDETERMINATE: 'indeterminate'
    };
    const $5e0415637054ea24$export$3bf3c26d6d69f3b1 = {
        VIEWER: 'Viewer',
        FULL_EDITOR: 'FullEditor',
        NON_PUBLISHING_EDITOR: 'NonPublishingEditor'
    };
    const $5e0415637054ea24$export$40628b030ac72445 = {
        LINK: 'Link',
        EMBED: 'Embed',
        CONFLUENCE: 'Confluence',
        CSV: 'Csv',
        PNG: 'Png',
        DEPENDENCY_REPORT_CONFLUENCE: 'DependencyReportConfluence'
    };
    const $5e0415637054ea24$export$5b1b1523594baa6e = {
        kanban: 'Kanban',
        scrum: 'Scrum'
    };
    const $5e0415637054ea24$export$b4d5766fd1973953 = {
        ADMIN: 'Admin',
        EDITOR: 'Editor',
        VIEWER: 'Viewer',
        RESTRICTED_USER: 'Restricted'
    };
    const $5e0415637054ea24$export$183f45c476faaff2 = {
        EDITOR: 'Editor',
        VIEWER: 'Viewer',
        REPORT_CONSUMER: 'ReportConsumer',
        CONFLUENCE_CONSUMER: 'ConfluenceConsumer'
    };
    const $5e0415637054ea24$export$deea8c9ae0e3c1ca = {
        OUTWARD: 'outward',
        INWARD: 'inward'
    };
    const $5e0415637054ea24$export$86e2f9653c14c34 = {
        PROJECT: 'Project',
        BOARD: 'Board',
        FILTER: 'Filter'
    };
    const $5e0415637054ea24$export$5b6c28c7dca07ad7 = 'portfolio-3';
    const $5e0415637054ea24$export$d39436cd641938a9 = 'portfolio-3.create-plan-wizard';
    const $5e0415637054ea24$export$f048d91ccaf92408 = {
        COMMIT_CHANGES_TIME_TO_SAVE: 'commit-changes.time-to-save',
        COMMIT_CHANGES_TIME_TO_PERSIST: 'commit-changes.time-to-persist',
        RENDER_APP: 'page-plan.render-app',
        EXPORT_PNG: {
            INITIAL_PREVIEW: 'page-plan.export-png.initial-preview',
            SUBSEQUENT_PREVIEW: 'page-plan.export-png.subsequent-preview',
            EXPORT: 'page-plan.export-png.export'
        }
    };
    const $5e0415637054ea24$export$4eb5c0330ef8fab4 = {
        RENDER: {
            SCOPE_TABLE: 'renderScopeTable'
        },
        EXPORT_PNG: {
            INITIAL_LOAD: 'page-plan.export-png.profile.initial-load',
            REACT_RENDER: 'page-plan.export-png.profile.react-render',
            PREPARE_FOR_EXPORT: 'page-plan.export-png.profile.prepare-for-export',
            CANVAS_RENDER: 'page-plan.export-png.profile.canvas-render'
        }
    };
    const $5e0415637054ea24$export$b8b9d90f9e5bd72b = 'jiraPortfolio3Portfolio';
    const $5e0415637054ea24$export$f27a837467ec20e5 = {
        APP: 'app',
        ROADMAP: 'roadmapTab',
        TEAMS: 'teamsTab',
        RELEASES: 'releasesTab',
        DEPENDENCIES: 'dependenciesTab',
        SETTINGS: 'settings',
        REDUX: 'redux',
        REDUX_SAGA: 'reduxSaga',
        PLAN_WIZARD: 'planWizard',
        UNHANDLED: 'unhandled',
        ENVIRONMENT: 'environment',
        GIC: 'GIC',
        SUMMARY: 'summaryTab'
    };
    const $5e0415637054ea24$export$cfeee2ee86ead336 = 'advanced-roadmaps';
    const $5e0415637054ea24$export$bf7af18c7898a31 = 100;
    const $5e0415637054ea24$export$37e30ab04b9b1705 = {
        DEFAULT: $5e0415637054ea24$export$e6952b12ade67489,
        LINES: $5e0415637054ea24$export$e0de529f548a9140,
        COUNT: $5e0415637054ea24$export$d61684373eacdf61
    };
    const $5e0415637054ea24$export$e24665e8d921f93e = 1e6;
    const $5e0415637054ea24$export$22ed55708a9d1966 = {
        SOFTWARE: 'software',
        WORK_MANAGEMENT: 'business',
        SERVICE_MANAGEMENT: 'service_desk'
    };
    const $5e0415637054ea24$export$8b7222fa92892b49 = {
        WEEKS: 'weeks',
        MONTHS: 'months',
        QUARTERS: 'quarters',
        YEARS: 'years'
    };
    const $5e0415637054ea24$export$bbbec7054427e57b = {
        ...$5e0415637054ea24$export$8b7222fa92892b49,
        CUSTOM: 'custom'
    };
    const $5e0415637054ea24$export$b0f7807f8d64b44a = {
        SMALL: 14,
        MEDIUM: 93,
        LARGE: 364
    };
    const $5e0415637054ea24$export$46a3b4b81e5a44ac = (0, (0, parcelRequire("flnZx")).ONE_DAY);
    const $5e0415637054ea24$export$e433769a2e1c823 = 1 / 7 * 100;
    const $5e0415637054ea24$export$954b02519e22ad3c = 'jira.user.arj.notify.watchers';
    const $5e0415637054ea24$export$cb60c924e8198091 = 'timeline';
    const $5e0415637054ea24$export$16c8656f8d888a96 = 'dependency-report';
    const $5e0415637054ea24$export$d37ffa307efd6838 = {
        MAIN: 'main-sections',
        FIELD: 'fields-section',
        LIST_MAIN: 'list-main-sections',
        LIST_FIELD: 'list-fields-section'
    };
    const $5e0415637054ea24$export$cb4feb832f4bb576 = {
        SCOPE: 'scope-column',
        FIELDS: 'fields-column',
        TIMELINE: 'timeline-column'
    };
    const $5e0415637054ea24$export$ce125fc0306b71a0 = {
        id: '__original_status_transition_id__',
        name: '__original_status_transition_name__'
    };
    const $5e0415637054ea24$export$c773c9bd947df9ae = {
        STATUS: 'status',
        ESTIMATE: 'estimate'
    };
    const $5e0415637054ea24$export$253194752488840a = {
        AUTO_SCHEDULE: '72BaKCMhh1aBiQprnER3pL',
        SHARE_CONFLUENCE: '8xdMiPoU4Fr4KWxzGJdXL',
        WARNING_CENTER: '5NX3sX9eqNEXSGhi4cMQ4L',
        SAVED_VIEWS: '636NO7TUPjErcJvohzMo9f',
        MANAGE_SAVED_VIEWS: '59mAhBw1bktXGV50c5c3ax',
        DEPENDENCIES: '2HQv4dgTi14DCpGY1YU2ZF',
        SUMMARY: '2lAziig1qpzuPCelr0CWB3',
        TEAMS: '30yplH4RxkjUZwmNwOxT2k',
        TEAM_CAPACITY: '1iT8GgcEZ2tikuwlnTq8Ij',
        DEPENDENCIES_REPORT: '2N5Dc7LkkoTjytZVPp9PQV',
        ISSUE_SOURCE: '1HTUp4iLEAeRVWDAI6pCaB',
        EXCLUSION_RULES: '2okV00HG5KCXjcw9oxv2kv',
        PERMISSIONS: '2GnX12bqw32MnTSVnDooC'
    };
});
parcelRegister("flnZx", function(module, exports) {
    $parcel$export(module.exports, "ONE_HOUR", ()=>$baaac68c54c7e711$export$82541edf19e5e3b0);
    $parcel$export(module.exports, "ONE_DAY", ()=>$baaac68c54c7e711$export$a97a1358cbb650ab);
    $parcel$export(module.exports, "ONE_WEEK", ()=>$baaac68c54c7e711$export$8187f416f1cc43d8);
    $parcel$export(module.exports, "isISOCompatible", ()=>$baaac68c54c7e711$export$19585d8c4023da60);
    $parcel$export(module.exports, "dateDiffFromUTC", ()=>$baaac68c54c7e711$export$c0a5d57ff50684cd);
    $parcel$export(module.exports, "endOfUtcDay", ()=>$baaac68c54c7e711$export$28816be40db3c661);
    $parcel$export(module.exports, "startOfUtcDay", ()=>$baaac68c54c7e711$export$5232bbb29ed7bb90);
    $parcel$export(module.exports, "startOfUtcWeek", ()=>$baaac68c54c7e711$export$beda72ac2de463b);
    $parcel$export(module.exports, "startOfUtcMonth", ()=>$baaac68c54c7e711$export$6f42959055abfd71);
    $parcel$export(module.exports, "buildStartOfUtcQuarter", ()=>$baaac68c54c7e711$export$2fc2f60e244962d8);
    $parcel$export(module.exports, "buildStartOfUtcYear", ()=>$baaac68c54c7e711$export$d9d30b5ea3d906ae);
    $parcel$export(module.exports, "distanceInWordsWithPolarity", ()=>$baaac68c54c7e711$export$6c9763c5fdf1d9bf);
    $parcel$export(module.exports, "distanceInWordsToNowWithPolarity", ()=>$baaac68c54c7e711$export$2b43273db3dc8a06);
    $parcel$export(module.exports, "endOfUtcWeek", ()=>$baaac68c54c7e711$export$cd5772ae045b582a);
    $parcel$export(module.exports, "endOfUtcMonth", ()=>$baaac68c54c7e711$export$7eaba70871f25263);
    $parcel$export(module.exports, "buildEndOfUtcQuarter", ()=>$baaac68c54c7e711$export$15d62cfd22087517);
    $parcel$export(module.exports, "buildEndOfUtcYear", ()=>$baaac68c54c7e711$export$ea7270449a050df5);
    $parcel$export(module.exports, "getWorkingMillionSecondsBetweenTwoDates", ()=>$baaac68c54c7e711$export$11174f5b39020529);
    $parcel$export(module.exports, "convertShortFormatDate", ()=>$baaac68c54c7e711$export$51353e55e1015915);
    $parcel$export(module.exports, "distanceInWordsByShortFormat", ()=>$baaac68c54c7e711$export$6fd795612f323dcc);
    $parcel$export(module.exports, "getRelativeDates", ()=>$baaac68c54c7e711$export$f1b9e31b5813ebf9);
    $parcel$export(module.exports, "getWeekStartDay", ()=>$baaac68c54c7e711$export$99291c0265ff1d37);
    var $9XE6b = parcelRequire("9XE6b");
    var $cRGLB = parcelRequire("cRGLB");
    var $gwejS;
    var $3DR3e;
    var $16v6W;
    var $2kh23;
    var $jNuzB;
    var $2753q;
    var $pyK8a;
    var $kAAot;
    var $4PxOH;
    var $7myQy;
    var $1p96B;
    var $gh61P;
    const $baaac68c54c7e711$export$82541edf19e5e3b0 = 3600000;
    const $baaac68c54c7e711$export$a97a1358cbb650ab = 86400000;
    const $baaac68c54c7e711$export$8187f416f1cc43d8 = 7 * $baaac68c54c7e711$export$a97a1358cbb650ab;
    const $baaac68c54c7e711$export$3ff59674890cae52 = $baaac68c54c7e711$export$a97a1358cbb650ab - 1;
    const $baaac68c54c7e711$export$5dddd410b460512a = /^\d{4}-\d{2}-\d{2}\s?/;
    const $baaac68c54c7e711$export$f5b73408663c3e14 = /^\d{2}\/\w{3}\/\d{2}\s?/;
    const $baaac68c54c7e711$export$63484a545c40ee32 = /^\d{2}\/\w{3}\/\d{4}\s?/;
    const $baaac68c54c7e711$export$ce02ba817385328 = (str)=>new Date(`${str} UTC`).getTime();
    const $baaac68c54c7e711$export$f7a957134186c558 = (date)=>{
        if ($baaac68c54c7e711$export$5dddd410b460512a.test(date)) {
            const trimmedDate = date.substring(0, 10);
            return new Date(trimmedDate);
        }
        if ($baaac68c54c7e711$export$63484a545c40ee32.test(date)) {
            const trimmedDate = date.substring(0, 11);
            const parsedDate = (0, (0, parcelRequire("2753q")).default)(trimmedDate, 'dd/MMM/yyyy', new Date());
            const time = parsedDate.getTime();
            const timeOffset = parsedDate.getTimezoneOffset() * 60000;
            return new Date(time - timeOffset);
        }
        if ($baaac68c54c7e711$export$f5b73408663c3e14.test(date)) {
            const trimmedDate = date.substring(0, 9);
            const parsedDate = (0, (0, parcelRequire("2753q")).default)(trimmedDate, 'dd/MMM/yy', new Date());
            const time = parsedDate.getTime();
            const timeOffset = parsedDate.getTimezoneOffset() * 60000;
            return new Date(time - timeOffset);
        }
        throw new Error(`Non ISO date format provided to create UTC date: ${date}`);
    };
    const $baaac68c54c7e711$export$19585d8c4023da60 = (date)=>$baaac68c54c7e711$export$f5b73408663c3e14.test(date) || $baaac68c54c7e711$export$5dddd410b460512a.test(date);
    const $baaac68c54c7e711$export$c0a5d57ff50684cd = ()=>{
        const now = new Date();
        const tzInHours = -now.getTimezoneOffset() / 60;
        const utcHours = (now.getHours() + now.getMinutes() / 60 - tzInHours + 24) % 24;
        if (utcHours + tzInHours > 24) return 1;
        if (utcHours + tzInHours < 0) return -1;
        return 0;
    };
    const $baaac68c54c7e711$export$28816be40db3c661 = (date)=>new Date((0, parcelRequire("7myQy")).default(Number, date) ? date : $baaac68c54c7e711$export$f7a957134186c558(date.toString())).setUTCHours(23, 59, 59, 999);
    const $baaac68c54c7e711$export$5232bbb29ed7bb90 = (date)=>new Date((0, parcelRequire("7myQy")).default(Number, date) ? date : $baaac68c54c7e711$export$f7a957134186c558(date.toString())).setUTCHours(0, 0, 0, 0);
    const $baaac68c54c7e711$export$beda72ac2de463b = (value)=>{
        const startOfDay = $baaac68c54c7e711$export$5232bbb29ed7bb90(new Date(value).getTime());
        const dayOfWeek = new Date(startOfDay).getUTCDay();
        const millisecondsToSubstract = $baaac68c54c7e711$export$a97a1358cbb650ab * dayOfWeek;
        const date = new Date(startOfDay - millisecondsToSubstract);
        const year = date.getUTCFullYear();
        const month = (0, ($parcel$interopDefault($cRGLB)))(`${date.getUTCMonth() + 1}`, 2, '0');
        const day = (0, ($parcel$interopDefault($cRGLB)))(`${date.getUTCDate()}`, 2, '0');
        const startOfWeek = new Date(`${year}-${month}-${day}T00:00:00Z`);
        return startOfWeek;
    };
    const $baaac68c54c7e711$export$6f42959055abfd71 = (value)=>{
        const date = new Date(value);
        const year = date.getUTCFullYear();
        const month = (0, ($parcel$interopDefault($cRGLB)))(`${date.getUTCMonth() + 1}`, 2, '0');
        const startOfMonth = new Date(`${year}-${month}-01T00:00:00Z`);
        return startOfMonth;
    };
    const $baaac68c54c7e711$export$f8d6d59f9413fa73 = (value)=>{
        const date = new Date(value);
        const year = date.getUTCFullYear();
        const UTCmonth = date.getUTCMonth();
        let month;
        if (UTCmonth >= 0 && UTCmonth <= 2) month = '01';
        else if (UTCmonth >= 3 && UTCmonth <= 5) month = '04';
        else if (UTCmonth >= 6 && UTCmonth <= 8) month = '07';
        else month = '10';
        const startOfQuarter = new Date(`${year}-${month}-01T00:00:00Z`);
        return startOfQuarter;
    };
    const $baaac68c54c7e711$export$2fc2f60e244962d8 = (fyStartMonth)=>(value)=>{
            const date = new Date(value);
            const year = date.getUTCFullYear();
            const month = date.getUTCMonth() + 1;
            const nextFYStartMonth = fyStartMonth + 12;
            let firstMonthOfThisQuarter = nextFYStartMonth;
            while(month < firstMonthOfThisQuarter)firstMonthOfThisQuarter -= 3;
            const willWrapToPreviousYear = firstMonthOfThisQuarter < 1;
            const dateString = `${willWrapToPreviousYear ? year - 1 : year}-${willWrapToPreviousYear ? 12 + firstMonthOfThisQuarter : `0${firstMonthOfThisQuarter}`.slice(-2)}-01T00:00:00Z`;
            return new Date(dateString);
        };
    const $baaac68c54c7e711$export$fea0669370045ef2 = (value)=>{
        const date = new Date(value);
        const startOfYear = new Date(`${date.getUTCFullYear()}-01-01T00:00:00Z`);
        return startOfYear;
    };
    const $baaac68c54c7e711$export$d9d30b5ea3d906ae = (fyStartMonth)=>(value)=>{
            const date = new Date(value);
            const currentUtcYear = date.getUTCFullYear();
            const currentUtcMonth = date.getUTCMonth() + 1;
            return new Date(`${currentUtcYear - (currentUtcMonth >= fyStartMonth ? 0 : 1)}-${`0${fyStartMonth}`.slice(-2)}-01T00:00:00Z`);
        };
    const $baaac68c54c7e711$export$55d224f4c8cb5e91 = ()=>{
        if (Date.prototype.__msh_oldSetFullYear) Date.prototype.setFullYear = function setFullYear(...args) {
            const d = new Date(this);
            d.__msh_oldSetFullYear && d.__msh_oldSetFullYear.call(d, ...args);
            if (d.getMonth() !== this.getMonth()) this.setDate(28);
            return this.__msh_oldSetFullYear ? this.__msh_oldSetFullYear.call(this, ...args) : Number.NaN;
        };
    };
    const $baaac68c54c7e711$export$b767725b8ed07921 = ()=>{
        if (globalThis.document) {
            if (globalThis.document.readyState === 'loading') globalThis.document.addEventListener('DOMContentLoaded', $baaac68c54c7e711$export$55d224f4c8cb5e91);
            else $baaac68c54c7e711$export$55d224f4c8cb5e91();
        }
    };
    $baaac68c54c7e711$export$b767725b8ed07921();
    const $baaac68c54c7e711$export$6c9763c5fdf1d9bf = (fromDate, toDate, locale)=>{
        const sign = new Date(fromDate).getTime() < new Date(toDate).getTime() ? '+' : '-';
        const distanceStr = (0, (0, parcelRequire("2kh23")).default)(toDate, fromDate, {
            locale: locale !== undefined ? (0, (0, parcelRequire("1p96B")).getLocale)(locale) : undefined
        });
        return distanceStr.split(' ').map((str)=>Number.isNaN(Number(str)) ? str : `${sign}${str}`).join(' ');
    };
    const $baaac68c54c7e711$export$2b43273db3dc8a06 = (locale, date)=>$baaac68c54c7e711$export$6c9763c5fdf1d9bf(Date.now(), date, locale);
    const $baaac68c54c7e711$export$cd5772ae045b582a = (value)=>{
        const startOfWeek = $baaac68c54c7e711$export$beda72ac2de463b(value);
        const endOfWeek = startOfWeek.getTime() + 7 * $baaac68c54c7e711$export$a97a1358cbb650ab - 1;
        return new Date(endOfWeek);
    };
    const $baaac68c54c7e711$export$7eaba70871f25263 = (value)=>{
        const date = new Date(value);
        let year = date.getUTCFullYear();
        let month = date.getUTCMonth();
        month++;
        if (month > 11) {
            month = 0;
            year++;
        }
        const paddedMonth = (0, ($parcel$interopDefault($cRGLB)))(`${month + 1}`, 2, '0');
        const firstDayOfNextYear = new Date(`${year}-${paddedMonth}-01T00:00:00.000Z`);
        const endOfYear = new Date(firstDayOfNextYear.getTime() - 1);
        return endOfYear;
    };
    const $baaac68c54c7e711$export$893511aa1d64d04 = (value)=>{
        const date = new Date(value);
        const year = date.getUTCFullYear();
        const UTCmonth = date.getUTCMonth();
        let month;
        let day = '31';
        if (UTCmonth >= 0 && UTCmonth <= 2) month = '03';
        else if (UTCmonth >= 3 && UTCmonth <= 5) {
            month = '06';
            day = '30';
        } else if (UTCmonth >= 6 && UTCmonth <= 8) {
            month = '09';
            day = '30';
        } else month = '12';
        const lastDayOfQuarter = new Date(`${year}-${month}-${day}T23:59:59.999Z`);
        return lastDayOfQuarter;
    };
    const $baaac68c54c7e711$export$15d62cfd22087517 = (fyStartMonth)=>(value)=>{
            const date = new Date(value);
            const year = date.getUTCFullYear();
            const month = date.getUTCMonth() + 1;
            const nextFYStartMonth = fyStartMonth + 12;
            let firstMonthOfThisQuarter = nextFYStartMonth;
            while(month < firstMonthOfThisQuarter)firstMonthOfThisQuarter -= 3;
            const firstMonthOfNextQuarter = firstMonthOfThisQuarter + 3;
            const willWrapToNextYear = firstMonthOfNextQuarter > 12;
            if (willWrapToNextYear) return new Date(new Date(`${year + 1}-0${firstMonthOfNextQuarter % 12}-01T00:00:00Z`).getTime() - 1);
            return new Date(new Date(`${year}-${`0${firstMonthOfNextQuarter}`.slice(-2)}-01T00:00:00Z`).getTime() - 1);
        };
    const $baaac68c54c7e711$export$73a64972c33eed9e = (value)=>{
        const date = new Date(value);
        const currentUtcYear = date.getUTCFullYear();
        return new Date(`${currentUtcYear}-12-31T23:59:59.999Z`);
    };
    const $baaac68c54c7e711$export$ea7270449a050df5 = (fyStartMonth)=>(value)=>{
            const date = new Date(value);
            const currentUtcYear = date.getUTCFullYear();
            const currentUtcMonth = date.getUTCMonth() + 1;
            return new Date(new Date(`${currentUtcYear + (currentUtcMonth >= fyStartMonth ? 1 : 0)}-${`0${fyStartMonth}`.slice(-2)}-01T00:00:00Z`).getTime() - 1);
        };
    const $baaac68c54c7e711$export$66ad6b2cba030df5 = (startTime, endTime)=>(0, (0, parcelRequire("jNuzB")).default)($baaac68c54c7e711$export$beda72ac2de463b(startTime), $baaac68c54c7e711$export$beda72ac2de463b(endTime));
    const $baaac68c54c7e711$export$dbbb7786eda0de5f = (value)=>{
        const startTimeOfUtcWeek = $baaac68c54c7e711$export$beda72ac2de463b(value).getTime();
        return {
            start: startTimeOfUtcWeek + $baaac68c54c7e711$export$a97a1358cbb650ab,
            end: startTimeOfUtcWeek + 6 * $baaac68c54c7e711$export$a97a1358cbb650ab
        };
    };
    const $baaac68c54c7e711$export$11174f5b39020529 = (startTime, endTime)=>{
        const { start: startWorkingTimeOfStartTime, end: endWorkingTimeOfStartTime } = $baaac68c54c7e711$export$dbbb7786eda0de5f(startTime);
        if ($baaac68c54c7e711$export$66ad6b2cba030df5(startTime, endTime)) {
            if (endTime < startWorkingTimeOfStartTime || startTime > endWorkingTimeOfStartTime) return 0;
            return Math.min(endWorkingTimeOfStartTime, endTime) - Math.max(startWorkingTimeOfStartTime, startTime);
        }
        const { start: startWorkingTimeOfEndTime, end: endWorkingTimeOfEndTime } = $baaac68c54c7e711$export$dbbb7786eda0de5f(endTime);
        const weeks = Math.floor((startWorkingTimeOfEndTime - endWorkingTimeOfStartTime) / $baaac68c54c7e711$export$8187f416f1cc43d8);
        const workingMillionSecondsOfMiddleWeeks = weeks * (5 * $baaac68c54c7e711$export$a97a1358cbb650ab);
        const workingMillionSecondsOfFirstWeek = startTime > endWorkingTimeOfStartTime ? 0 : endWorkingTimeOfStartTime - Math.max(startTime, startWorkingTimeOfStartTime);
        const workingMillionSecondsOfLastWeek = endTime < startWorkingTimeOfEndTime ? 0 : Math.min(endTime, endWorkingTimeOfEndTime) - startWorkingTimeOfEndTime;
        return workingMillionSecondsOfFirstWeek + workingMillionSecondsOfLastWeek + workingMillionSecondsOfMiddleWeeks;
    };
    const $baaac68c54c7e711$var$getUnifiedEnglishDateUnit = (unitStr)=>{
        const regx = /((\w+)(?=s))|([^s]+)/g;
        const resultArr = unitStr.match(regx);
        if (Array.isArray(resultArr) && resultArr.length > 0) return resultArr[0];
        return unitStr;
    };
    const $baaac68c54c7e711$export$51353e55e1015915 = (number, unit, localeStr)=>new Intl.NumberFormat(localeStr, {
            style: 'unit',
            unit: unit,
            unitDisplay: 'narrow'
        }).format(number);
    const $baaac68c54c7e711$export$6fd795612f323dcc = (fromDate, toDate, localeStr)=>{
        const sign = new Date(fromDate).getTime() < new Date(toDate).getTime() ? '+' : '-';
        const distanceStr = (0, (0, parcelRequire("2kh23")).default)(toDate, fromDate);
        const distanceStrArray = distanceStr.split(' ');
        const locale = (0, (0, parcelRequire("1p96B")).getLocale)(localeStr);
        if (distanceStrArray.length === 2) {
            const unit = $baaac68c54c7e711$var$getUnifiedEnglishDateUnit(distanceStrArray[1]);
            const number = distanceStrArray[0];
            return `${sign}${$baaac68c54c7e711$export$51353e55e1015915(Number(number), unit, locale.code)}`;
        }
        if (distanceStrArray.length === 3) {
            const suffix = (0, (0, parcelRequire("2kh23")).default)(toDate, fromDate, {
                locale: locale
            }).split(' ')[0];
            const number = distanceStrArray[1];
            const unit = $baaac68c54c7e711$var$getUnifiedEnglishDateUnit(distanceStrArray[2]);
            return `${suffix} ${sign}${$baaac68c54c7e711$export$51353e55e1015915(Number(number), unit, locale.code)}`;
        }
        return distanceStr;
    };
    const $baaac68c54c7e711$export$f1b9e31b5813ebf9 = ({ toNowUnitCount: toNowUnitCount = 0, fromNowUnitCount: fromNowUnitCount = 0, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit }, today)=>{
        const start = toNowUnit === (0, (0, parcelRequire("gh61P")).DateUnits).WEEKS ? (0, (0, parcelRequire("4PxOH")).default)(today, toNowUnitCount) : (0, (0, parcelRequire("kAAot")).default)(today, toNowUnitCount);
        const end = fromNowUnit === (0, (0, parcelRequire("gh61P")).DateUnits).WEEKS ? (0, (0, parcelRequire("16v6W")).default)(today, fromNowUnitCount) : (0, (0, parcelRequire("3DR3e")).default)(today, fromNowUnitCount);
        if (toNowUnitCount === 0 && fromNowUnitCount === 0) return {
            start: $baaac68c54c7e711$export$5232bbb29ed7bb90(start.getTime()),
            end: $baaac68c54c7e711$export$28816be40db3c661(end.getTime())
        };
        if (toNowUnitCount && fromNowUnitCount || toNowUnitCount) return {
            start: $baaac68c54c7e711$export$5232bbb29ed7bb90((0, (0, parcelRequire("gwejS")).default)(start, 1).getTime()),
            end: $baaac68c54c7e711$export$28816be40db3c661(end.getTime())
        };
        return {
            start: $baaac68c54c7e711$export$5232bbb29ed7bb90(start.getTime()),
            end: $baaac68c54c7e711$export$28816be40db3c661((0, (0, parcelRequire("pyK8a")).default)(end, 1).getTime())
        };
    };
    const $baaac68c54c7e711$export$99291c0265ff1d37 = (locale)=>(0, ($parcel$interopDefault($9XE6b)))((0, (0, parcelRequire("1p96B")).getLocale)(locale), 'options.weekStartsOn', (0, (0, parcelRequire("gh61P")).DEFAULT_WEEK_START_DAY));
});
parcelRegister("cRGLB", function(module, exports) {
    var $9tfrR = parcelRequire("9tfrR");
    var $ifYxh = parcelRequire("ifYxh");
    var $kPZpS = parcelRequire("kPZpS");
    var $jJVtR = parcelRequire("jJVtR");
    function $95db9be3f601d040$var$padStart(string, length, chars) {
        string = $jJVtR(string);
        length = $kPZpS(length);
        var strLength = length ? $ifYxh(string) : 0;
        return length && strLength < length ? $9tfrR(length - strLength, chars) + string : string;
    }
    module.exports = $95db9be3f601d040$var$padStart;
});
parcelRegister("9tfrR", function(module, exports) {
    var $kkyYH = parcelRequire("kkyYH");
    var $kHBB0 = parcelRequire("kHBB0");
    var $gvFfr = parcelRequire("gvFfr");
    var $axH2S = parcelRequire("axH2S");
    var $ifYxh = parcelRequire("ifYxh");
    var $jx6Tp = parcelRequire("jx6Tp");
    var $6e52ce3a438da7ad$var$nativeCeil = Math.ceil;
    function $6e52ce3a438da7ad$var$createPadding(length, chars) {
        chars = chars === undefined ? ' ' : $kHBB0(chars);
        var charsLength = chars.length;
        if (charsLength < 2) return charsLength ? $kkyYH(chars, length) : chars;
        var result = $kkyYH(chars, $6e52ce3a438da7ad$var$nativeCeil(length / $ifYxh(chars)));
        return $axH2S(chars) ? $gvFfr($jx6Tp(result), 0, length).join('') : result.slice(0, length);
    }
    module.exports = $6e52ce3a438da7ad$var$createPadding;
});
parcelRegister("kkyYH", function(module, exports) {
    var $ecd0ced035e30e58$var$MAX_SAFE_INTEGER = 9007199254740991;
    var $ecd0ced035e30e58$var$nativeFloor = Math.floor;
    function $ecd0ced035e30e58$var$baseRepeat(string, n) {
        var result = '';
        if (!string || n < 1 || n > $ecd0ced035e30e58$var$MAX_SAFE_INTEGER) return result;
        do {
            if (n % 2) result += string;
            n = $ecd0ced035e30e58$var$nativeFloor(n / 2);
            if (n) string += string;
        }while (n)
        return result;
    }
    module.exports = $ecd0ced035e30e58$var$baseRepeat;
});
parcelRegister("ifYxh", function(module, exports) {
    var $dkmPN = parcelRequire("dkmPN");
    var $axH2S = parcelRequire("axH2S");
    var $61ekh = parcelRequire("61ekh");
    function $d4a895dd16218f22$var$stringSize(string) {
        return $axH2S(string) ? $61ekh(string) : $dkmPN(string);
    }
    module.exports = $d4a895dd16218f22$var$stringSize;
});
parcelRegister("dkmPN", function(module, exports) {
    var $8hdQS = parcelRequire("8hdQS");
    var $9b3edb0cff432526$var$asciiSize = $8hdQS('length');
    module.exports = $9b3edb0cff432526$var$asciiSize;
});
parcelRegister("61ekh", function(module, exports) {
    var $461df2ef275f3803$var$rsAstralRange = '\\ud800-\\udfff', $461df2ef275f3803$var$rsComboMarksRange = '\\u0300-\\u036f', $461df2ef275f3803$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $461df2ef275f3803$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $461df2ef275f3803$var$rsComboRange = $461df2ef275f3803$var$rsComboMarksRange + $461df2ef275f3803$var$reComboHalfMarksRange + $461df2ef275f3803$var$rsComboSymbolsRange, $461df2ef275f3803$var$rsVarRange = '\\ufe0e\\ufe0f';
    var $461df2ef275f3803$var$rsAstral = '[' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsCombo = '[' + $461df2ef275f3803$var$rsComboRange + ']', $461df2ef275f3803$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $461df2ef275f3803$var$rsModifier = '(?:' + $461df2ef275f3803$var$rsCombo + '|' + $461df2ef275f3803$var$rsFitz + ')', $461df2ef275f3803$var$rsNonAstral = '[^' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $461df2ef275f3803$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $461df2ef275f3803$var$rsZWJ = '\\u200d';
    var $461df2ef275f3803$var$reOptMod = $461df2ef275f3803$var$rsModifier + '?', $461df2ef275f3803$var$rsOptVar = '[' + $461df2ef275f3803$var$rsVarRange + ']?', $461df2ef275f3803$var$rsOptJoin = '(?:' + $461df2ef275f3803$var$rsZWJ + '(?:' + [
        $461df2ef275f3803$var$rsNonAstral,
        $461df2ef275f3803$var$rsRegional,
        $461df2ef275f3803$var$rsSurrPair
    ].join('|') + ')' + $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + ')*', $461df2ef275f3803$var$rsSeq = $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + $461df2ef275f3803$var$rsOptJoin, $461df2ef275f3803$var$rsSymbol = '(?:' + [
        $461df2ef275f3803$var$rsNonAstral + $461df2ef275f3803$var$rsCombo + '?',
        $461df2ef275f3803$var$rsCombo,
        $461df2ef275f3803$var$rsRegional,
        $461df2ef275f3803$var$rsSurrPair,
        $461df2ef275f3803$var$rsAstral
    ].join('|') + ')';
    var $461df2ef275f3803$var$reUnicode = RegExp($461df2ef275f3803$var$rsFitz + '(?=' + $461df2ef275f3803$var$rsFitz + ')|' + $461df2ef275f3803$var$rsSymbol + $461df2ef275f3803$var$rsSeq, 'g');
    function $461df2ef275f3803$var$unicodeSize(string) {
        var result = $461df2ef275f3803$var$reUnicode.lastIndex = 0;
        while($461df2ef275f3803$var$reUnicode.test(string))++result;
        return result;
    }
    module.exports = $461df2ef275f3803$var$unicodeSize;
});
parcelRegister("7myQy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55c59e4aaf37a546$export$2e2bcd8739ae039);
    var $c9RLn;
    var $55c59e4aaf37a546$var$is = (0, (0, parcelRequire("c9RLn")).default)(function is(Ctor, val) {
        return val != null && val.constructor === Ctor || val instanceof Ctor;
    });
    var $55c59e4aaf37a546$export$2e2bcd8739ae039 = $55c59e4aaf37a546$var$is;
});
parcelRegister("ihPUd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b0b9e39fe9c43b5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6b0b9e39fe9c43b5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        add: {
            "id": "portfolio-3-portfolio.common.add",
            "defaultMessage": "Add"
        },
        after: {
            "id": "portfolio-3-portfolio.common.after",
            "defaultMessage": "after"
        },
        afterAllIssuesAreCompleted: {
            "id": "portfolio-3-portfolio.common.after-all-issues-are-completed",
            "defaultMessage": "After all issues are completed"
        },
        afterCapitalized: {
            "id": "portfolio-3-portfolio.common.after-capitalized",
            "defaultMessage": "After"
        },
        allOtherIssues: {
            "id": "portfolio-3-portfolio.common.all-other-issues",
            "defaultMessage": "All other issues"
        },
        apply: {
            "id": "portfolio-3-portfolio.common.apply",
            "defaultMessage": "Apply"
        },
        asEarlyAsPossible: {
            "id": "portfolio-3-portfolio.common.as-early-as-possible",
            "defaultMessage": "As early as possible"
        },
        assignee: {
            "id": "portfolio-3-portfolio.common.assignee",
            "defaultMessage": "Assignee"
        },
        reporter: {
            "id": "portfolio-3-portfolio.common.reporter",
            "defaultMessage": "Reporter"
        },
        before: {
            "id": "portfolio-3-portfolio.common.before",
            "defaultMessage": "before"
        },
        beforeCapitalized: {
            "id": "portfolio-3-portfolio.common.before-capitalized",
            "defaultMessage": "Before"
        },
        cancel: {
            "id": "portfolio-3-portfolio.common.cancel",
            "defaultMessage": "Cancel"
        },
        confirm: {
            "id": "portfolio-3-portfolio.common.confirm",
            "defaultMessage": "Confirm"
        },
        changeIndicatorTooltip: {
            "id": "portfolio-3-portfolio.common.change-indicator-tooltip",
            "defaultMessage": "To apply issue changes beyond your plan, review and save changes."
        },
        clearFilterText: {
            "id": "portfolio-3-portfolio.common.clear-filter-text",
            "defaultMessage": "Clear selected items"
        },
        close: {
            "id": "portfolio-3-portfolio.common.close",
            "defaultMessage": "Close"
        },
        component: {
            "id": "portfolio-3-portfolio.common.component",
            "defaultMessage": "Component"
        },
        chooseConfigurableDatesUnavailableHeading: {
            "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-heading",
            "defaultMessage": "Custom {count, plural,\n            one {date}\n            other {dates}\n          } no longer available"
        },
        chooseConfigurableDatesUnavailableContentStartDate: {
            "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-content-start-date",
            "defaultMessage": "<strong>{startDateTitle}</strong> is no longer available for scheduling issues. Use other custom start dates, or keep default start dates."
        },
        chooseConfigurableDatesUnavailableContentEndDate: {
            "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-content-end-date",
            "defaultMessage": "<strong>{endDateTitle}</strong> is no longer available for scheduling issues. Use other custom end dates, or keep default end dates."
        },
        chooseConfigurableDatesUnavailableContentStartAndEndDate: {
            "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-content-start-and-end-date",
            "defaultMessage": "<strong>{startDateTitle}</strong> and <strong>{endDateTitle}</strong> are no longer available for scheduling issues. Use other custom dates, or keep default dates."
        },
        chooseConfigurableDatesUnavailableContentStartDateTooltip: {
            "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-content-start-date-tooltip",
            "defaultMessage": "{startDateTitle} is no longer available for scheduling issues. Use other custom start dates, or keep default start dates."
        },
        chooseConfigurableDatesUnavailableContentEndDateTooltip: {
            "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-content-end-date-tooltip",
            "defaultMessage": "{endDateTitle} is no longer available for scheduling issues. Use other custom end dates, or keep default end dates."
        },
        chooseConfigurableDateNotExistContent: {
            "id": "portfolio-3-portfolio.common.choose-configurable-date-not-exist-content",
            "defaultMessage": "The previously used custom {count, plural,\n                one {date is}\n                other {dates are}\n              } no longer available for scheduling issues. Use other custom dates, or keep using default dates."
        },
        create: {
            "id": "portfolio-3-portfolio.common.create",
            "defaultMessage": "Create"
        },
        crossProjectRelease: {
            "id": "portfolio-3-portfolio.common.cross-project-release",
            "defaultMessage": "Cross-project release"
        },
        crossProjectReleases: {
            "id": "portfolio-3-portfolio.common.cross-project-releases",
            "defaultMessage": "Cross-project releases"
        },
        current: {
            "id": "portfolio-3-portfolio.common.current",
            "defaultMessage": "Current"
        },
        dates: {
            "id": "portfolio-3-portfolio.common.dates",
            "defaultMessage": "Dates"
        },
        dateRange: {
            "id": "portfolio-3-portfolio.common.date-range",
            "defaultMessage": "Date range"
        },
        days: {
            "id": "portfolio-3-portfolio.common.days",
            "defaultMessage": "Days"
        },
        delete: {
            "id": "portfolio-3-portfolio.common.delete",
            "defaultMessage": "Delete"
        },
        dueDate: {
            "id": "portfolio-3-portfolio.common.due-date",
            "defaultMessage": "Due date"
        },
        edit: {
            "id": "portfolio-3-portfolio.common.edit",
            "defaultMessage": "Edit"
        },
        epic: {
            "id": "portfolio-3-portfolio.common.epic",
            "defaultMessage": "Epic"
        },
        estimate: {
            "id": "portfolio-3-portfolio.common.estimate",
            "defaultMessage": "Estimate"
        },
        fixedDate: {
            "id": "portfolio-3-portfolio.common.fixed-date",
            "defaultMessage": "Fixed date"
        },
        goals: {
            "id": "portfolio-3-portfolio.common.goals",
            "defaultMessage": "Goals"
        },
        ideas: {
            "id": "portfolio-3-portfolio.common.ideas",
            "defaultMessage": "Idea"
        },
        groupBy: {
            "id": "portfolio-3-portfolio.common.group-by",
            "defaultMessage": "Group by"
        },
        issueType: {
            "id": "portfolio-3-portfolio.common.issue-type",
            "defaultMessage": "Issue type"
        },
        issueLinkType: {
            "id": "portfolio-3-portfolio.common.issue-link-type",
            "defaultMessage": "Issue link type"
        },
        jira: {
            "id": "portfolio-3-portfolio.common.jira",
            "defaultMessage": "Jira"
        },
        label: {
            "id": "portfolio-3-portfolio.common.label",
            "defaultMessage": "Label"
        },
        learnMore: {
            "id": "portfolio-3-portfolio.common.learn-more",
            "defaultMessage": "Learn more"
        },
        loadingIssuesMessage: {
            "id": "portfolio-3-portfolio.common.loading-issues-message",
            "defaultMessage": "Loading issues..."
        },
        loading: {
            "id": "portfolio-3-portfolio.common.loading",
            "defaultMessage": "Loading"
        },
        name: {
            "id": "portfolio-3-portfolio.common.name",
            "defaultMessage": "Name"
        },
        new: {
            "id": "portfolio-3-portfolio.common.new",
            "defaultMessage": "New"
        },
        next: {
            "id": "portfolio-3-portfolio.common.next",
            "defaultMessage": "Next"
        },
        noMatchFoundText: {
            "id": "portfolio-3-portfolio.common.no-match-found-text",
            "defaultMessage": "No matches"
        },
        none: {
            "id": "portfolio-3-portfolio.common.none",
            "defaultMessage": "None"
        },
        notInPlan: {
            "id": "portfolio-3-portfolio.common.not-in-plan",
            "defaultMessage": "Not in plan"
        },
        plan: {
            "id": "portfolio-3-portfolio.common.plan",
            "defaultMessage": "Plan"
        },
        planNotFound: {
            "id": "portfolio-3-portfolio.common.plan-not-found",
            "defaultMessage": "We couldn\u2019t find that plan. It might have been deleted by its owner or the URL might be wrong."
        },
        priority: {
            "id": "portfolio-3-portfolio.common.priority",
            "defaultMessage": "Priority"
        },
        project: {
            "id": "portfolio-3-portfolio.common.project",
            "defaultMessage": "Project"
        },
        relativeToPreviousRelease: {
            "id": "portfolio-3-portfolio.common.relative-to-previous-release",
            "defaultMessage": "{factor} previous release date"
        },
        relativeToPreviousReleaseMethod: {
            "id": "portfolio-3-portfolio.common.relative-to-previous-release-method",
            "defaultMessage": "Relative to previous release date"
        },
        requiredField: {
            "id": "portfolio-3-portfolio.common.required-field",
            "defaultMessage": "A value must be provided"
        },
        release: {
            "id": "portfolio-3-portfolio.common.release",
            "defaultMessage": "Release"
        },
        releases: {
            "id": "portfolio-3-portfolio.common.releases",
            "defaultMessage": "Releases"
        },
        remove: {
            "id": "portfolio-3-portfolio.common.remove",
            "defaultMessage": "Remove"
        },
        save: {
            "id": "portfolio-3-portfolio.common.save",
            "defaultMessage": "Save"
        },
        done: {
            "id": "portfolio-3-portfolio.common.done",
            "defaultMessage": "Done"
        },
        sprint: {
            "id": "portfolio-3-portfolio.common.sprint",
            "defaultMessage": "Sprint"
        },
        sprints: {
            "id": "portfolio-3-portfolio.common.sprints",
            "defaultMessage": "Sprints"
        },
        status: {
            "id": "portfolio-3-portfolio.common.status",
            "defaultMessage": "Status"
        },
        statusBreakdown: {
            "id": "portfolio-3-portfolio.common.status-breakdown",
            "defaultMessage": "Progress (issue count)"
        },
        team: {
            "id": "portfolio-3-portfolio.common.team",
            "defaultMessage": "Team"
        },
        teams: {
            "id": "portfolio-3-portfolio.common.teams",
            "defaultMessage": "Teams"
        },
        unassigned: {
            "id": "portfolio-3-portfolio.common.unassigned",
            "defaultMessage": "Unassigned"
        },
        viewIn: {
            "id": "portfolio-3-portfolio.common.view-in",
            "defaultMessage": "View in"
        },
        weeks: {
            "id": "portfolio-3-portfolio.common.weeks",
            "defaultMessage": "Weeks"
        },
        whenPreviousReleaseEnds: {
            "id": "portfolio-3-portfolio.common.when-previous-release-ends",
            "defaultMessage": "When previous release ends"
        },
        targetStart: {
            "id": "portfolio-3-portfolio.common.target-start",
            "defaultMessage": "Target start"
        },
        targetEnd: {
            "id": "portfolio-3-portfolio.common.target-end",
            "defaultMessage": "Target end"
        },
        invalidDateStartBeforeEnd: {
            "id": "portfolio-3-portfolio.common.invalid-date-start-before-end",
            "defaultMessage": "The start date of the issue must be before its end date."
        },
        invalidDateEndAfterStart: {
            "id": "portfolio-3-portfolio.common.invalid-date-end-after-start",
            "defaultMessage": "The end date of the issue must be after its start date."
        },
        invalidDateTitle: {
            "id": "portfolio-3-portfolio.common.invalid-date-title",
            "defaultMessage": "That didn't work"
        },
        disabledSortByPriorityTooltip: {
            "id": "portfolio-3-portfolio.common.disabled-sort-by-priority-tooltip",
            "defaultMessage": "To sort issues by priority, the projects in the plan must be using the same priority scheme."
        },
        onTrackRelease: {
            "id": "portfolio-3-portfolio.common.on-track-release",
            "defaultMessage": "On-Track"
        },
        offTrackRelease: {
            "id": "portfolio-3-portfolio.common.off-track-release",
            "defaultMessage": "Off-Track"
        },
        releasedRelease: {
            "id": "portfolio-3-portfolio.common.released-release",
            "defaultMessage": "Released"
        },
        unReleasedRelease: {
            "id": "portfolio-3-portfolio.common.un-released-release",
            "defaultMessage": "Unreleased"
        },
        dependency: {
            "id": "portfolio-3-portfolio.common.dependency",
            "defaultMessage": "Dependency"
        },
        dependencyWarning: {
            "id": "portfolio-3-portfolio.common.dependency-warning",
            "defaultMessage": "Dependency warning"
        },
        dependencyOffTrack: {
            "id": "portfolio-3-portfolio.common.dependency-off-track",
            "defaultMessage": "Off-track dependencies"
        },
        unsavedChanges: {
            "id": "portfolio-3-portfolio.common.unsaved-changes",
            "defaultMessage": "Unsaved changes"
        },
        externalLozenge: {
            "id": "portfolio-3-portfolio.common.external-lozenge",
            "defaultMessage": "EXT"
        },
        datesOutsideRange: {
            "id": "portfolio-3-portfolio.common.dates-outside-range",
            "defaultMessage": "Dates outside current view range"
        },
        teamSettings: {
            "id": "portfolio-3-portfolio.common.team-settings",
            "defaultMessage": "Team settings"
        },
        scope: {
            "id": "portfolio-3-portfolio.common.scope",
            "defaultMessage": "Scope"
        },
        fields: {
            "id": "portfolio-3-portfolio.common.fields",
            "defaultMessage": "Fields"
        },
        timeline: {
            "id": "portfolio-3-portfolio.common.timeline",
            "defaultMessage": "Timeline"
        },
        issueSource: {
            "id": "portfolio-3-portfolio.common.issue-source",
            "defaultMessage": "Issue source"
        },
        customFields: {
            "id": "portfolio-3-portfolio.common.custom-fields",
            "defaultMessage": "Custom fields"
        },
        more: {
            "id": "portfolio-3-portfolio.common.more",
            "defaultMessage": "+ {count} more"
        },
        noAssociatedTeams: {
            "id": "portfolio-3-portfolio.common.no-associated-teams",
            "defaultMessage": "No associated teams"
        },
        otherSprints: {
            "id": "portfolio-3-portfolio.common.other-sprints",
            "defaultMessage": "Other sprints"
        },
        futureProjectedSprint: {
            "id": "portfolio-3-portfolio.common.future-projected-sprint",
            "defaultMessage": "Projected sprint"
        },
        futureSprint: {
            "id": "portfolio-3-portfolio.common.future-sprint",
            "defaultMessage": "Future sprint"
        },
        completedSprint: {
            "id": "portfolio-3-portfolio.common.completed-sprint",
            "defaultMessage": "Completed sprint"
        },
        activeSprint: {
            "id": "portfolio-3-portfolio.common.active-sprint",
            "defaultMessage": "Active sprint"
        },
        futureSprintState: {
            "id": "portfolio-3-portfolio.common.future-sprint-state",
            "defaultMessage": "Future"
        },
        completedSprintState: {
            "id": "portfolio-3-portfolio.common.completed-sprint-state",
            "defaultMessage": "Completed"
        },
        activeSprintState: {
            "id": "portfolio-3-portfolio.common.active-sprint-state",
            "defaultMessage": "Active"
        },
        externalSprintState: {
            "id": "portfolio-3-portfolio.common.external-sprint-state",
            "defaultMessage": "external"
        },
        completedSprintsLabel: {
            "id": "portfolio-3-portfolio.common.completed-sprints-label",
            "defaultMessage": "All completed sprints"
        },
        activeSprintsLabel: {
            "id": "portfolio-3-portfolio.common.active-sprints-label",
            "defaultMessage": "All active sprints"
        },
        futureSprintsLabel: {
            "id": "portfolio-3-portfolio.common.future-sprints-label",
            "defaultMessage": "All future sprints"
        },
        externalSprintsLabel: {
            "id": "portfolio-3-portfolio.common.external-sprints-label",
            "defaultMessage": "All external sprints"
        },
        noSprintLabel: {
            "id": "portfolio-3-portfolio.common.no-sprint-label",
            "defaultMessage": "No sprint assigned"
        },
        moreInformation: {
            "id": "portfolio-3-portfolio.common.more-information",
            "defaultMessage": "More information"
        }
    });
});
parcelRegister("kC16r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c699f066563c176$export$2e2bcd8739ae039);
    var $bC2fB;
    var $k9YUm = parcelRequire("k9YUm");
    var $lApuj = parcelRequire("lApuj");
    var $4c699f066563c176$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $k9YUm.default), {})((0, $lApuj.default));
});
parcelRegister("k9YUm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e148d0195b0ecfad$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    const $e148d0195b0ecfad$var$mapStateToProps = (state)=>({
            currentScenarioColor: (0, $bHTqr.getCurrentScenarioColor)(state)
        });
    var $e148d0195b0ecfad$export$2e2bcd8739ae039 = $e148d0195b0ecfad$var$mapStateToProps;
});
parcelRegister("bHTqr", function(module, exports) {
    $parcel$export(module.exports, "getPlan", ()=>$8aa67d7cd913af5c$export$235c374fac5f5d1b);
    $parcel$export(module.exports, "getPlanType", ()=>$8aa67d7cd913af5c$export$c5009b13f979c1b6);
    $parcel$export(module.exports, "getIsSamplePlan", ()=>$8aa67d7cd913af5c$export$e1349dde19453d1f);
    $parcel$export(module.exports, "getIsCrossTeamPlanning", ()=>$8aa67d7cd913af5c$export$b8d7dd0bfb4fa4fe);
    $parcel$export(module.exports, "getPlanTitle", ()=>$8aa67d7cd913af5c$export$3a977cd83f945733);
    $parcel$export(module.exports, "getAutoSchedulerEnabled", ()=>$8aa67d7cd913af5c$export$c396215c7d30980f);
    $parcel$export(module.exports, "getIssueSources", ()=>$8aa67d7cd913af5c$export$16bdc72ef65977db);
    $parcel$export(module.exports, "getPlanningUnit", ()=>$8aa67d7cd913af5c$export$7bd856f542fb6dc5);
    $parcel$export(module.exports, "getSyncStartEnabled", ()=>$8aa67d7cd913af5c$export$efb081429119caca);
    $parcel$export(module.exports, "getIssueSourcesById", ()=>$8aa67d7cd913af5c$export$8834a5bc0beb2ee5);
    $parcel$export(module.exports, "findIssueSourceById", ()=>$8aa67d7cd913af5c$export$722eb315d83d8783);
    $parcel$export(module.exports, "getPlanScenarios", ()=>$8aa67d7cd913af5c$export$dcfb6bc2956ec132);
    $parcel$export(module.exports, "isMultiScenarioEnabled", ()=>$8aa67d7cd913af5c$export$5c0e252a3e94185a);
    $parcel$export(module.exports, "currentScenarioId", ()=>$8aa67d7cd913af5c$export$518c73faa0b23138);
    $parcel$export(module.exports, "getCurrentScenarioColor", ()=>$8aa67d7cd913af5c$export$a352f0a83e7a1027);
    $parcel$export(module.exports, "getAutoScheduleConfiguration", ()=>$8aa67d7cd913af5c$export$9e519e3d0791b75);
    $parcel$export(module.exports, "getCreatedTimestamp", ()=>$8aa67d7cd913af5c$export$c25ddf5c19130650);
    $parcel$export(module.exports, "getPlanIssueInferredDateSelection", ()=>$8aa67d7cd913af5c$export$21b3bfe6331442bb);
    $parcel$export(module.exports, "getDateConfiguration", ()=>$8aa67d7cd913af5c$export$6eea2a2f8d211a5c);
    $parcel$export(module.exports, "hasWarningInConfiguredDates", ()=>$8aa67d7cd913af5c$export$f428dfac2965faf0);
    var $2rMKg;
    var $gJZ5D;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $5fACX = parcelRequire("5fACX");
    const $8aa67d7cd913af5c$export$235c374fac5f5d1b = (state)=>state.domain.plan;
    const $8aa67d7cd913af5c$export$c5009b13f979c1b6 = (state)=>{
        switch(state.domain.plan.planType){
            case 'CROSS_TEAM':
            case 'CROSS_TEAM_PLANNING':
            case 'SAFE':
                return state.domain.plan.planType;
            default:
                return 'STANDARD';
        }
    };
    const $8aa67d7cd913af5c$export$e1349dde19453d1f = (state)=>!!state.domain.plan.isSamplePlan;
    const $8aa67d7cd913af5c$export$b8d7dd0bfb4fa4fe = (state)=>state.domain.plan.planType === 'CROSS_TEAM_PLANNING';
    const $8aa67d7cd913af5c$export$3a977cd83f945733 = (state)=>state.domain.plan.title;
    const $8aa67d7cd913af5c$export$c396215c7d30980f = (state)=>!!state.domain.plan.autoSchedulerEnabled;
    const $8aa67d7cd913af5c$export$fb7a5df85a35a8d0 = (state)=>!!state.domain.plan.planStatus;
    const $8aa67d7cd913af5c$export$16bdc72ef65977db = (state)=>state.domain.plan.issueSources;
    const $8aa67d7cd913af5c$export$7bd856f542fb6dc5 = (state)=>state.domain.plan.planningUnit;
    const $8aa67d7cd913af5c$export$efb081429119caca = (state)=>state.domain.plan.syncStartEnabled;
    const $8aa67d7cd913af5c$export$a78de2f73ee50e7c = (state, issueSourceId)=>{
        const issueSources = $8aa67d7cd913af5c$export$16bdc72ef65977db(state);
        return issueSources.find((issueSource)=>issueSource.id === issueSourceId);
    };
    const $8aa67d7cd913af5c$export$2419cd984fa6ae80 = (issueSources)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), issueSources);
    const $8aa67d7cd913af5c$export$8834a5bc0beb2ee5 = (0, $3YtPS.createSelector)([
        $8aa67d7cd913af5c$export$16bdc72ef65977db
    ], $8aa67d7cd913af5c$export$2419cd984fa6ae80);
    const $8aa67d7cd913af5c$export$722eb315d83d8783 = (issueSources, issueSourceId)=>issueSources.find((issueSource)=>issueSource.id === issueSourceId);
    const $8aa67d7cd913af5c$export$dcfb6bc2956ec132 = (state)=>state.domain.plan.scenarios ?? [];
    const $8aa67d7cd913af5c$export$5c0e252a3e94185a = (state)=>state.domain.plan.multiScenarioEnabled;
    const $8aa67d7cd913af5c$export$518c73faa0b23138 = (state)=>state.domain.plan.currentScenarioId;
    const $8aa67d7cd913af5c$export$a352f0a83e7a1027 = (0, $3YtPS.createSelector)([
        $8aa67d7cd913af5c$export$dcfb6bc2956ec132,
        $8aa67d7cd913af5c$export$518c73faa0b23138,
        $8aa67d7cd913af5c$export$5c0e252a3e94185a
    ], (scenarios, currentScenarioId, isMultiScenarioEnabled)=>{
        if (scenarios && isMultiScenarioEnabled) {
            const scenario = scenarios.find((scenario)=>scenario.id === currentScenarioId);
            return scenario ? scenario.color : (0, (0, parcelRequire("gJZ5D")).default).Y400;
        }
        return (0, (0, parcelRequire("gJZ5D")).default).Y400;
    });
    const $8aa67d7cd913af5c$export$9e519e3d0791b75 = (state)=>state.domain.plan.autoScheduleConfiguration;
    const $8aa67d7cd913af5c$export$c25ddf5c19130650 = (state)=>state.domain.plan.createdTimestamp;
    const $8aa67d7cd913af5c$export$21b3bfe6331442bb = (state)=>state.domain.plan.issueInferredDateSelection;
    const $8aa67d7cd913af5c$export$27162fa81fdb5f6f = (state)=>state.domain.plan.baselineStartField;
    const $8aa67d7cd913af5c$export$c3047bd55ed2ff53 = (state)=>state.domain.plan.baselineEndField;
    const $8aa67d7cd913af5c$export$6eea2a2f8d211a5c = (0, $3YtPS.createSelector)([
        $8aa67d7cd913af5c$export$27162fa81fdb5f6f,
        $8aa67d7cd913af5c$export$c3047bd55ed2ff53
    ], (baselineStartField, baselineEndField)=>({
            baselineStartField: baselineStartField,
            baselineEndField: baselineEndField
        }));
    const $8aa67d7cd913af5c$export$f428dfac2965faf0 = (0, $3YtPS.createSelector)([
        $8aa67d7cd913af5c$export$6eea2a2f8d211a5c
    ], (dateConfiguration)=>{
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
        return (0, $4nDwW.isDefined)(baselineStartField.warning) || (0, $4nDwW.isDefined)(baselineEndField.warning);
    });
});
parcelRegister("3YtPS", function(module, exports) {
    $parcel$export(module.exports, "equals", ()=>$33e3da3bc9e69c94$export$e9bab7fafb253603);
    $parcel$export(module.exports, "createSelector", ()=>$33e3da3bc9e69c94$export$595d22ed68ca2841);
    $parcel$export(module.exports, "createStructuredSelector", ()=>$33e3da3bc9e69c94$export$75979cfcd91bf38f);
    var $dGvGJ = parcelRequire("dGvGJ");
    const $33e3da3bc9e69c94$var$EQUALS_DEPTH_LIMIT = 1;
    const $33e3da3bc9e69c94$export$e9bab7fafb253603 = (a, b, maxDepth = $33e3da3bc9e69c94$var$EQUALS_DEPTH_LIMIT, depth = 0)=>{
        if (a === b) return true;
        if (depth > maxDepth) return false;
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$33e3da3bc9e69c94$export$e9bab7fafb253603(a[i], b[i], maxDepth, depth + 1)) return false;
            }
            return true;
        }
        if (a && b && typeof a === 'object' && typeof b === 'object') {
            if (a instanceof Set && b instanceof Set) {
                if (a.size !== b.size) return false;
                const c = new Set(b);
                for (const x of a){
                    if (!c.has(x)) return false;
                    c.delete(x);
                }
                if (c.size > 0) return false;
                return true;
            }
            const k1 = Object.keys(a);
            const k2 = Object.keys(b);
            if (k1.length !== k2.length) return false;
            for(let i = 0; i < k1.length; i++){
                if (k1[i] !== k2[i]) return false;
                if (!$33e3da3bc9e69c94$export$e9bab7fafb253603(a[k1[i]], b[k2[i]], maxDepth, depth + 1)) return false;
            }
            return true;
        }
        return false;
    };
    const $33e3da3bc9e69c94$export$595d22ed68ca2841 = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize), $33e3da3bc9e69c94$export$e9bab7fafb253603);
    const $33e3da3bc9e69c94$export$75979cfcd91bf38f = (selectors, selectorCreator = $33e3da3bc9e69c94$export$595d22ed68ca2841)=>(0, $dGvGJ.createStructuredSelector)(selectors, selectorCreator);
});
parcelRegister("5fACX", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_INFERRED_DATE_SELECTION", ()=>$96f6917a32c93118$export$d20a030b70ab1266);
    $parcel$export(module.exports, "DUE_DATE", ()=>$96f6917a32c93118$export$cf7e173386d30cdd);
    $parcel$export(module.exports, "TARGET_START_FIELD", ()=>$96f6917a32c93118$export$77f4fd573f5dd5b2);
    $parcel$export(module.exports, "TARGET_END_FIELD", ()=>$96f6917a32c93118$export$1906d795dad222a2);
    $parcel$export(module.exports, "TARGET_START_END_API_MAP", ()=>$96f6917a32c93118$export$a977ae1ec7868242);
    $parcel$export(module.exports, "BUILT_IN_DATE_FIELDS", ()=>$96f6917a32c93118$export$5b772dcefb474518);
    $parcel$export(module.exports, "DATEFIELD_TYPES", ()=>$96f6917a32c93118$export$f1b7783d68321e17);
    $parcel$export(module.exports, "DATEFIELD_WARNINGS", ()=>$96f6917a32c93118$export$4a3a3d3681d6aef2);
    $parcel$export(module.exports, "DUE_DATE_FIELD", ()=>$96f6917a32c93118$export$f4a47f55547a932c);
    $parcel$export(module.exports, "TARGET_START_DATE_FIELD", ()=>$96f6917a32c93118$export$d8edc8f6b75c5d36);
    $parcel$export(module.exports, "TARGET_END_DATE_FIELD", ()=>$96f6917a32c93118$export$8e3f7c464f9fbc67);
    $parcel$export(module.exports, "DateFieldStatus", ()=>$96f6917a32c93118$export$741035fa3d533c);
    $parcel$export(module.exports, "RANK_TOP", ()=>$96f6917a32c93118$export$44676822f5e6b099);
    $parcel$export(module.exports, "RANK_LAST", ()=>$96f6917a32c93118$export$6d8ebc2b2a45c68f);
    $parcel$export(module.exports, "RANK_BEFORE", ()=>$96f6917a32c93118$export$72384426ccc8b8e7);
    $parcel$export(module.exports, "RANK_AFTER", ()=>$96f6917a32c93118$export$7b4abdf7cd37b163);
    var $5fc53;
    const $96f6917a32c93118$export$d20a030b70ab1266 = {
        ROLL_UP: -1,
        NONE: 0,
        SPRINT: 1,
        RELEASE: 2
    };
    const $96f6917a32c93118$export$cf7e173386d30cdd = (0, (0, parcelRequire("5fc53")).DUE_DATE_PORTFOLIO_TYPE);
    const $96f6917a32c93118$export$77f4fd573f5dd5b2 = (0, (0, parcelRequire("5fc53")).TARGET_START_TYPE);
    const $96f6917a32c93118$export$1906d795dad222a2 = (0, (0, parcelRequire("5fc53")).TARGET_END_TYPE);
    const $96f6917a32c93118$export$a977ae1ec7868242 = Object.freeze({
        [$96f6917a32c93118$export$77f4fd573f5dd5b2]: 'baselineStart',
        [$96f6917a32c93118$export$1906d795dad222a2]: 'baselineEnd'
    });
    const $96f6917a32c93118$export$5b772dcefb474518 = Object.freeze([
        $96f6917a32c93118$export$cf7e173386d30cdd,
        $96f6917a32c93118$export$77f4fd573f5dd5b2,
        $96f6917a32c93118$export$1906d795dad222a2
    ]);
    const $96f6917a32c93118$export$f1b7783d68321e17 = Object.freeze({
        BUILT_IN: 'BuiltIn',
        CUSTOM: 'Custom'
    });
    const $96f6917a32c93118$export$4a3a3d3681d6aef2 = Object.freeze({
        NOT_EXIST: 'NOT_EXIST',
        UNAVAILABLE: 'VALUE_NO_LONGER_AVAILABLE'
    });
    const $96f6917a32c93118$export$f4a47f55547a932c = {
        id: $96f6917a32c93118$export$cf7e173386d30cdd,
        key: $96f6917a32c93118$export$cf7e173386d30cdd,
        type: $96f6917a32c93118$export$f1b7783d68321e17.BUILT_IN
    };
    const $96f6917a32c93118$export$d8edc8f6b75c5d36 = {
        id: $96f6917a32c93118$export$77f4fd573f5dd5b2,
        key: $96f6917a32c93118$export$77f4fd573f5dd5b2,
        type: $96f6917a32c93118$export$f1b7783d68321e17.BUILT_IN
    };
    const $96f6917a32c93118$export$8e3f7c464f9fbc67 = {
        id: $96f6917a32c93118$export$1906d795dad222a2,
        key: $96f6917a32c93118$export$1906d795dad222a2,
        type: $96f6917a32c93118$export$f1b7783d68321e17.BUILT_IN
    };
    const $96f6917a32c93118$export$741035fa3d533c = {
        OK: 'ok',
        NOT_EXIST: "doesn't exist",
        UNAVAILABLE: 'unavailable'
    };
    const $96f6917a32c93118$export$44676822f5e6b099 = 'TOP';
    const $96f6917a32c93118$export$6d8ebc2b2a45c68f = 'LAST';
    const $96f6917a32c93118$export$72384426ccc8b8e7 = 'BEFORE';
    const $96f6917a32c93118$export$7b4abdf7cd37b163 = 'AFTER';
});
parcelRegister("lApuj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88f00ea19acc220f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $koVbs;
    var $gJZ5D;
    var $ihPUd = parcelRequire("ihPUd");
    var $d4Pfd = parcelRequire("d4Pfd");
    function $88f00ea19acc220f$export$eb0ebb5fe48d40a7({ currentScenarioColor: currentScenarioColor = `var(--ds-text-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y400})`, appearance: appearance = 'triangle', borderRadius: borderRadius }) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: intl.formatMessage((0, $ihPUd.default).changeIndicatorTooltip),
            position: "mouse"
        }, appearance === 'triangle' ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.common.change-indicator",
            className: $d4Pfd.triangle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            viewBox: "0 0 100 100",
            xmlns: "http://www.w3.org/2000/svg",
            width: "10",
            height: "10",
            style: {
                borderTopRightRadius: borderRadius
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            points: "0,0  100,0  100,100",
            style: {
                fill: currentScenarioColor
            }
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.common.change-indicator",
            className: $d4Pfd[appearance],
            style: {
                backgroundColor: currentScenarioColor,
                borderTopLeftRadius: borderRadius,
                borderBottomLeftRadius: borderRadius
            }
        }));
    }
    var $88f00ea19acc220f$export$2e2bcd8739ae039 = $88f00ea19acc220f$export$eb0ebb5fe48d40a7;
});
parcelRegister("d4Pfd", function(module, exports) {
    $parcel$export(module.exports, "bar", ()=>$98536628fcdec0bc$export$d927737047eb3867, (v)=>$98536628fcdec0bc$export$d927737047eb3867 = v);
    $parcel$export(module.exports, "triangle", ()=>$98536628fcdec0bc$export$9eed783d03e0135c, (v)=>$98536628fcdec0bc$export$9eed783d03e0135c = v);
    var $98536628fcdec0bc$export$d927737047eb3867;
    var $98536628fcdec0bc$export$9eed783d03e0135c;
    $98536628fcdec0bc$export$d927737047eb3867 = `_6DYw6W_bar`;
    $98536628fcdec0bc$export$9eed783d03e0135c = `_6DYw6W_triangle`;
});
parcelRegister("cz8HY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d40636bb9d321a4e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGdV2;
    var $ousew;
    var $8RXs9;
    var $ihPUd = parcelRequire("ihPUd");
    var $4B8cI = parcelRequire("4B8cI");
    var $8TnVu = parcelRequire("8TnVu");
    function $d40636bb9d321a4e$var$FieldFlyout(props) {
        const { optimized: optimized, intl: intl, current: current, delta: delta } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8TnVu.flyout,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.cell.flyout.changes-flyout"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8TnVu.column
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8TnVu.heading
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).current)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: current ? $8TnVu.value : $8TnVu["no-value"]
        }, current || intl.formatMessage({
            ...(0, $4B8cI.default).noValue
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8TnVu.column
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eGdV2"))))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8TnVu.column
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8TnVu.heading
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $4B8cI.default).whenAccepted)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: optimized ? $8TnVu.value : $8TnVu["no-value"]
        }, optimized ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, optimized, " ", delta) : intl.formatMessage({
            ...(0, $4B8cI.default).noValue
        }))));
    }
    $d40636bb9d321a4e$var$FieldFlyout.defaultProps = {
        delta: ''
    };
    var $d40636bb9d321a4e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($d40636bb9d321a4e$var$FieldFlyout);
});
parcelRegister("eGdV2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aaffc8f190d8dd35$var$_react = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $aaffc8f190d8dd35$var$_arrowRight = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("h1TKi")));
    var $aaffc8f190d8dd35$var$_arrowRight2 = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("8RBk4")));
    function $aaffc8f190d8dd35$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aaffc8f190d8dd35$var$ArrowRightIcon = (props)=>$aaffc8f190d8dd35$var$_react.default.createElement($aaffc8f190d8dd35$var$_arrowRight.default, Object.assign({
            LEGACY_fallbackIcon: $aaffc8f190d8dd35$var$_arrowRight2.default
        }, props));
    $aaffc8f190d8dd35$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
    var $aaffc8f190d8dd35$var$_default = module.exports.default = $aaffc8f190d8dd35$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("8RBk4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $6740397d4ba98b13$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>$6740397d4ba98b13$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $6740397d4ba98b13$var$_arrowRight.default
        }));
    $6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;
});
parcelRegister("4B8cI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6af47aff843d2f6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a6af47aff843d2f6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        whenAccepted: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.cell.flyout.when-accepted",
            "defaultMessage": "When accepted"
        },
        noValue: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.cell.flyout.no-value",
            "defaultMessage": "None"
        }
    });
});
parcelRegister("8TnVu", function(module, exports) {
    $parcel$export(module.exports, "column", ()=>$6796050c6baa1f6d$export$4e0c71f277ca26b3, (v)=>$6796050c6baa1f6d$export$4e0c71f277ca26b3 = v);
    $parcel$export(module.exports, "flyout", ()=>$6796050c6baa1f6d$export$ec4922be16378791, (v)=>$6796050c6baa1f6d$export$ec4922be16378791 = v);
    $parcel$export(module.exports, "heading", ()=>$6796050c6baa1f6d$export$46e4a324ac90507f, (v)=>$6796050c6baa1f6d$export$46e4a324ac90507f = v);
    $parcel$export(module.exports, "no-value", ()=>$6796050c6baa1f6d$export$5b267f5c7fc66f30, (v)=>$6796050c6baa1f6d$export$5b267f5c7fc66f30 = v);
    $parcel$export(module.exports, "value", ()=>$6796050c6baa1f6d$export$2ab9a8f9f1186f14, (v)=>$6796050c6baa1f6d$export$2ab9a8f9f1186f14 = v);
    var $6796050c6baa1f6d$export$4e0c71f277ca26b3;
    var $6796050c6baa1f6d$export$ec4922be16378791;
    var $6796050c6baa1f6d$export$46e4a324ac90507f;
    var $6796050c6baa1f6d$export$5b267f5c7fc66f30;
    var $6796050c6baa1f6d$export$2ab9a8f9f1186f14;
    $6796050c6baa1f6d$export$4e0c71f277ca26b3 = `oXsrEG_column`;
    $6796050c6baa1f6d$export$ec4922be16378791 = `oXsrEG_flyout`;
    $6796050c6baa1f6d$export$46e4a324ac90507f = `oXsrEG_heading`;
    $6796050c6baa1f6d$export$5b267f5c7fc66f30 = `oXsrEG_no-value`;
    $6796050c6baa1f6d$export$2ab9a8f9f1186f14 = `oXsrEG_value`;
});
parcelRegister("ixSW4", function(module, exports) {
    $parcel$export(module.exports, "slots", ()=>$65b8144826556e3a$export$bbd679b9fab4c947);
    $parcel$export(module.exports, "provideComponents", ()=>$65b8144826556e3a$export$bf97b3f3c826d1af);
    $parcel$export(module.exports, "withSlots", ()=>$65b8144826556e3a$export$bb4665f044311879);
    var $5uXOq = parcelRequire("5uXOq");
    const $65b8144826556e3a$export$bbd679b9fab4c947 = {};
    const $65b8144826556e3a$export$f0b2358e80e9bcad = [
        'FieldComponents',
        'FieldDatePicker',
        'CellSelectWithRollup',
        'CellTextField',
        'FieldMultiSelectCell',
        'FieldSelect',
        'FieldAsyncSelect',
        'FieldPrioritySelect',
        'AdvancedFieldsMenu',
        'FilterDependencyGraphFromRoadmap',
        'QuickFilter',
        'IssueSearchWarningClearFilter',
        'NowLine',
        'UserPicker',
        'FieldUserAvatarCell'
    ];
    const $65b8144826556e3a$var$contexts = {};
    $65b8144826556e3a$export$f0b2358e80e9bcad.forEach((slotName)=>{
        const context = (0, $5uXOq.createContext)(()=>null);
        $65b8144826556e3a$var$contexts[slotName] = context;
        $65b8144826556e3a$export$bbd679b9fab4c947[slotName] = slotName;
    });
    function $65b8144826556e3a$export$bf97b3f3c826d1af(slots) {
        return (WrappedComponent)=>function ComponentSlotsContentsProvider(props) {
                let acc = (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
                for (const slotName of Object.keys(slots)){
                    if (!$65b8144826556e3a$export$f0b2358e80e9bcad.includes(slotName)) throw new TypeError(`slot with name ${slotName} not supported`);
                    const { Provider: Provider } = $65b8144826556e3a$var$contexts[slotName];
                    acc = (0, ($parcel$interopDefault($5uXOq))).createElement(Provider, {
                        value: slots[slotName]
                    }, acc);
                }
                return acc;
            };
    }
    function $65b8144826556e3a$export$bb4665f044311879(slotsByProps) {
        return (WrappedComponent)=>{
            function HoC(props) {
                const render = Object.entries(slotsByProps).reduce((acc, [propName, slotName])=>{
                    if (typeof slotName !== 'string') throw new TypeError('slotName must be string');
                    if (!$65b8144826556e3a$export$f0b2358e80e9bcad.includes(slotName)) throw new TypeError(`slot with name ${slotName} not supported`);
                    const { Consumer: Consumer } = $65b8144826556e3a$var$contexts[slotName];
                    return (injecting)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Consumer, null, (Slot)=>acc({
                                ...injecting,
                                [propName]: Slot
                            }));
                }, (injecting)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...props,
                        ...injecting
                    }));
                return render();
            }
            const compName = WrappedComponent.displayName || WrappedComponent.name || '';
            HoC.displayName = `WithSlots(${compName})`;
            HoC.WrappedComponent = WrappedComponent;
            HoC.slotsByProps = slotsByProps;
            return HoC;
        };
    }
    function $65b8144826556e3a$export$9203a8e84125433c() {}
});
parcelRegister("cSDJf", function(module, exports) {
    $parcel$export(module.exports, "MIN_SELECT_WIDTH", ()=>$4d2d690997abde12$export$c5e8dc4078d1dc65);
    $parcel$export(module.exports, "AsyncSelect", ()=>$4d2d690997abde12$export$aca05dd54e009a80);
    $parcel$export(module.exports, "AsyncSelectForColumnCell", ()=>$4d2d690997abde12$export$8ec70a3e94138773);
    $parcel$export(module.exports, "SelectForColumnCell", ()=>$4d2d690997abde12$export$6385b193dd4b511d);
    $parcel$export(module.exports, "default", ()=>$4d2d690997abde12$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $4R6GH;
    var $koVbs;
    var $iwfmd;
    var $f9Tpd;
    parcelRequire("iqIcG");
    var $d7FF4;
    var $iqIcG;
    var $cy8s7 = parcelRequire("cy8s7");
    var $4y9A5 = parcelRequire("4y9A5");
    var $coVrx = parcelRequire("coVrx");
    const $4d2d690997abde12$export$c5e8dc4078d1dc65 = 300;
    const $4d2d690997abde12$var$sharedSelectStyles = (isSmartLink)=>({
            placeholder: (placeholderStyles)=>({
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    ...placeholderStyles
                }),
            ...isSmartLink ? {
                dropdownIndicator: (dropdownIndicatorStyles)=>({
                        ...dropdownIndicatorStyles,
                        display: 'none'
                    }),
                multiValue: (multiValueStyles)=>({
                        ...multiValueStyles,
                        color: "var(--ds-text, #172B4D)"
                    }),
                singleValue: (singleValueStyles)=>({
                        ...singleValueStyles,
                        color: "var(--ds-text, #172B4D)"
                    })
            } : {}
        });
    function $4d2d690997abde12$export$ef9b1a59e592288f({ noOptionsMessage: noOptionsMessage, ...props }) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const selectProps = {
            ...props,
            noOptionsMessage: noOptionsMessage || (()=>intl.formatMessage({
                    ...(0, $coVrx.default).noMatchesText
                }))
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqIcG")).Select), selectProps);
    }
    const $4d2d690997abde12$export$aca05dd54e009a80 = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { noOptionsMessage: noOptionsMessage = ()=>intl.formatMessage({
                ...(0, $coVrx.default).noMatchesText
            }), ...restProps } = props;
        const selectProps = {
            ...restProps,
            noOptionsMessage: noOptionsMessage
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), selectProps);
    };
    function $4d2d690997abde12$export$8ec70a3e94138773({ showPlaceholder: showPlaceholder, issueId: issueId, lockInlineCreate: lockInlineCreate, placeholder: placeholder, onMenuClose: onMenuClose, onMenuOpen: onMenuOpen, styles: styles, loadOptions: loadOptions, isSmartLink: isSmartLink, ...selectProps }) {
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(false);
        const [placeholderState, setPlaceholderState] = (0, $5uXOq.useState)('');
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (issueId === (0, $cy8s7.INLINE_CREATE_ID)) lockInlineCreate(false);
        }, [
            issueId,
            lockInlineCreate
        ]);
        const handleMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (issueId === (0, $cy8s7.INLINE_CREATE_ID)) lockInlineCreate(true);
            setPlaceholderState(placeholder ?? '');
            setMenuIsOpen(true);
            setIsLoading(true);
            loadOptions('', defaultOptionsCallback);
            if (onMenuOpen) onMenuOpen();
        }, [
            issueId,
            loadOptions,
            lockInlineCreate,
            onMenuOpen,
            placeholder
        ]);
        const handleMenuClose = ()=>{
            if (issueId === (0, $cy8s7.INLINE_CREATE_ID)) lockInlineCreate(false);
            setPlaceholderState('');
            setMenuIsOpen(false);
            if (onMenuClose) onMenuClose();
        };
        const defaultOptionsCallback = (defaultOrganizations)=>{
            setDefaultOptions && setDefaultOptions(defaultOrganizations);
            setIsLoading(false);
        };
        const loadOptionsDebounced = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(loadOptions, 250, {
                leading: true
            }), [
            loadOptions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9Tpd")).default), {
            enabled: menuIsOpen
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqIcG")).AsyncSelectWithTimelineStyles), {
            menuPlacement: "auto",
            cacheOptions: true,
            menuPortalTarget: (0, $4y9A5.getBody)(),
            minSelectWidth: $4d2d690997abde12$export$c5e8dc4078d1dc65,
            onMenuClose: handleMenuClose,
            onMenuOpen: handleMenuOpen,
            scrollLock: true,
            placeholder: placeholderState,
            appearance: "subtle",
            minMenuHeight: 300,
            styles: {
                ...(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? $4d2d690997abde12$var$sharedSelectStyles(isSmartLink ?? false) : {
                    placeholder: (placeholderStyles)=>({
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            ...placeholderStyles
                        })
                },
                ...styles
            },
            defaultOptions: defaultOptions,
            isLoading: isLoading,
            loadOptions: loadOptionsDebounced,
            noOptionsMessage: ()=>intl.formatMessage({
                    ...(0, $coVrx.default).noMatchesText
                }),
            ...selectProps
        }));
    }
    class $4d2d690997abde12$export$6385b193dd4b511d extends (0, $5uXOq.Component) {
        componentWillUnmount() {
            if (this.props.issueId === (0, $cy8s7.INLINE_CREATE_ID)) this.props.lockInlineCreate(false);
        }
        render() {
            const { issueId: issueId, onMenuClose: onMenuClose, onMenuOpen: onMenuOpen, attribute: attribute, lockInlineCreate: lockInlineCreate, styles: styles, placeholder: placeholder, isSmartLink: isSmartLink, ...selectProps } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
                onHoverChanged: this.setHovered
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($4d2d690997abde12$export$ef9b1a59e592288f, {
                menuPlacement: "auto",
                menuPortalTarget: (0, $4y9A5.getBody)(),
                minSelectWidth: $4d2d690997abde12$export$c5e8dc4078d1dc65,
                onMenuClose: this.onMenuClose,
                onMenuOpen: this.onMenuOpen,
                scrollLock: true,
                placeholder: this.state.placeholder,
                styles: {
                    ...(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? $4d2d690997abde12$var$sharedSelectStyles(isSmartLink ?? false) : {
                        placeholder: (placeholderStyles)=>({
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                ...placeholderStyles
                            })
                    },
                    ...styles
                },
                ...selectProps
            }));
        }
        constructor(...args){
            super(...args);
            this.state = {
                isHovered: this.props.showPlaceholder || false,
                placeholder: ''
            };
            this.setHovered = (isHovered)=>this.setState({
                    isHovered: isHovered
                });
            this.onMenuOpen = ()=>{
                if (this.props.issueId === (0, $cy8s7.INLINE_CREATE_ID)) this.props.lockInlineCreate(true);
                this.setState({
                    placeholder: this.props.placeholder ?? ''
                });
                if (this.props.onMenuOpen) this.props.onMenuOpen();
            };
            this.onMenuClose = ()=>{
                if (this.props.issueId === (0, $cy8s7.INLINE_CREATE_ID)) this.props.lockInlineCreate(false);
                this.setState({
                    placeholder: ''
                });
                if (this.props.onMenuClose) this.props.onMenuClose();
            };
        }
    }
    var $4d2d690997abde12$export$2e2bcd8739ae039 = $4d2d690997abde12$export$ef9b1a59e592288f;
});
parcelRegister("cy8s7", function(module, exports) {
    $parcel$export(module.exports, "INLINE_CREATE_ID", ()=>$dc91bff02dd75999$export$2ec38414760ef1ba);
    $parcel$export(module.exports, "default", ()=>$dc91bff02dd75999$export$2e2bcd8739ae039);
    var $c12LJ;
    var $bREsp = parcelRequire("bREsp");
    var $bqD5G = parcelRequire("bqD5G");
    var $b9Xhh = parcelRequire("b9Xhh");
    var $7K8Pq = parcelRequire("7K8Pq");
    const $dc91bff02dd75999$export$2ec38414760ef1ba = '__INLINE_CREATE_ID__';
    const $dc91bff02dd75999$var$defaultValues = {
        project: (0, $bREsp.DEFAULT_PROJECT_ID),
        assignee: 'unassigned',
        assignments: [],
        associatedIssueIds: [],
        associatedIssues: []
    };
    const $dc91bff02dd75999$export$d4c72bab9d6cc13a = {
        id: $dc91bff02dd75999$export$2ec38414760ef1ba,
        hierarchyLevel: (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL),
        isOpen: false,
        openLockedMap: {},
        issueTypeId: 0,
        parentId: null,
        siblingId: null,
        projectId: 0,
        values: $dc91bff02dd75999$var$defaultValues,
        IssueTypeIdForHierarchy: {},
        isGlobalCreateIssue: true,
        isCreatingIssues: false
    };
    const $dc91bff02dd75999$var$reducer = (state = $dc91bff02dd75999$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $7K8Pq.SET_IS_CREATING_ISSUES:
                return {
                    ...state,
                    isCreatingIssues: action.payload.isCreatingIssues
                };
            case 0, $7K8Pq.CLEAR_INLINE_CREATE:
                return {
                    ...state,
                    isOpen: false,
                    startInlineCreateInEmptyGroup: false
                };
            case 0, $7K8Pq.SET_GLOBAL_CREATE_ISSUE:
                return {
                    ...state,
                    isGlobalCreateIssue: action.payload.isGlobalCreateIssue
                };
            case 0, $7K8Pq.SET_ISSUE_TYPE_ID:
                {
                    const { payload: { issueTypeId: issueTypeId } } = action;
                    return {
                        ...state,
                        issueTypeId: issueTypeId
                    };
                }
            case 0, $7K8Pq.SET_PROJECT_ID:
                {
                    const { payload: { projectId: projectId } } = action;
                    return {
                        ...state,
                        projectId: projectId,
                        values: {
                            ...state.values,
                            project: projectId
                        }
                    };
                }
            case 0, $7K8Pq.SET_SIBLING_ID:
                {
                    const { payload: { siblingId: siblingId } } = action;
                    return {
                        ...state,
                        siblingId: siblingId
                    };
                }
            case 0, $7K8Pq.START_INLINE_CREATE:
                {
                    const { payload: { parentId: parentId, issueTypeId: issueTypeId, hierarchyLevel: hierarchyLevel, projectId: projectId, siblingId: siblingId, group: group, groupCombination: groupCombination, startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup, valuesFromGrouping: valuesFromGrouping } } = action;
                    return {
                        ...state,
                        group: group,
                        groupCombination: groupCombination,
                        isOpen: true,
                        parentId: parentId,
                        siblingId: siblingId,
                        issueTypeId: issueTypeId,
                        hierarchyLevel: hierarchyLevel,
                        projectId: projectId,
                        startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup,
                        values: {
                            ...$dc91bff02dd75999$var$defaultValues,
                            project: projectId,
                            ...valuesFromGrouping
                        }
                    };
                }
            case 0, $7K8Pq.UPDATE_INLINE_CREATE:
                return {
                    ...state,
                    values: {
                        ...state.values,
                        ...action.payload
                    }
                };
            case 0, $7K8Pq.SET_OPEN_LOCKED:
                {
                    const { attribute: attribute, isLocked: isLocked } = action.payload;
                    return {
                        ...state,
                        openLockedMap: {
                            ...state.openLockedMap,
                            [attribute]: isLocked
                        }
                    };
                }
            case 0, $7K8Pq.SET_ISSUE_TYPE_ID_FOR_HIERARCHY:
                {
                    const { hierarchyLevel: hierarchyLevel, issueTypeId: issueTypeId } = action.payload;
                    return {
                        ...state,
                        IssueTypeIdForHierarchy: {
                            ...state.IssueTypeIdForHierarchy,
                            [hierarchyLevel]: issueTypeId
                        }
                    };
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $dc91bff02dd75999$export$2e2bcd8739ae039 = (0, $b9Xhh.persistReducer)({
        key: (0, $bqD5G.getPlanPrefixedKey)('issues-type-for-hierarchy'),
        whitelist: [
            'IssueTypeIdForHierarchy'
        ]
    }, $dc91bff02dd75999$var$reducer);
});
parcelRegister("c12LJ", function(module, exports) {
    $parcel$export(module.exports, "SUB_TASK_LEVEL", ()=>$3e10307c482ddd45$export$629eb88199636e31);
    $parcel$export(module.exports, "STORY_LEVEL", ()=>$3e10307c482ddd45$export$5851ccd68c79bc39);
    $parcel$export(module.exports, "EPIC_LEVEL", ()=>$3e10307c482ddd45$export$346285e0085a3842);
    $parcel$export(module.exports, "INITIATIVE_LEVEL", ()=>$3e10307c482ddd45$export$3dc28f07aa7629a3);
    var $g4tDr;
    const $3e10307c482ddd45$export$629eb88199636e31 = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_SUBTASK);
    const $3e10307c482ddd45$export$5851ccd68c79bc39 = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE);
    const $3e10307c482ddd45$export$346285e0085a3842 = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC);
    const $3e10307c482ddd45$export$3dc28f07aa7629a3 = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_INITIATIVE);
    const $3e10307c482ddd45$export$6b568e78303247cb = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_STRATEGY);
    const $3e10307c482ddd45$export$8d7949e6fbe9c22a = (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_GOAL);
});
parcelRegister("bREsp", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_PROJECT_ID", ()=>$7bab0d0d854708b2$export$2d57479448be0d61);
    $parcel$export(module.exports, "DEFAULT_SCRATCH_ISSUE_TYPE", ()=>$7bab0d0d854708b2$export$5331cbeee80032d1);
    $parcel$export(module.exports, "prepareIssues", ()=>$7bab0d0d854708b2$export$7ee48aec63e12327);
    $parcel$export(module.exports, "prepareIssueGoals", ()=>$7bab0d0d854708b2$export$10fa05fcb84f4152);
    $parcel$export(module.exports, "prepareIssueLabels", ()=>$7bab0d0d854708b2$export$8c647deb657d24f3);
    $parcel$export(module.exports, "prepareCustomLabels", ()=>$7bab0d0d854708b2$export$e4e5ef06a110b4fe);
    $parcel$export(module.exports, "prepareIssueLinks", ()=>$7bab0d0d854708b2$export$77be91e7c3f75d53);
    $parcel$export(module.exports, "prepareOriginalIssues", ()=>$7bab0d0d854708b2$export$2369010677cffb11);
    $parcel$export(module.exports, "prepareOriginalTeams", ()=>$7bab0d0d854708b2$export$9f9189c6bd7cd5f2);
    $parcel$export(module.exports, "prepareOriginalResources", ()=>$7bab0d0d854708b2$export$7c7246f1cd0fb982);
    $parcel$export(module.exports, "preparePlan", ()=>$7bab0d0d854708b2$export$ba899063f8c1fb3);
    $parcel$export(module.exports, "prepareProjects", ()=>$7bab0d0d854708b2$export$bdd0152d88205d11);
    $parcel$export(module.exports, "prepareReleaseStatuses", ()=>$7bab0d0d854708b2$export$5973c8d181359244);
    $parcel$export(module.exports, "prepareSprints", ()=>$7bab0d0d854708b2$export$a493e3df6f49328a);
    $parcel$export(module.exports, "prepareSolution", ()=>$7bab0d0d854708b2$export$a2595bd0c9ce474b);
    $parcel$export(module.exports, "prepareTeam", ()=>$7bab0d0d854708b2$export$399f8f703c757cc2);
    $parcel$export(module.exports, "prepareTeams", ()=>$7bab0d0d854708b2$export$cc413d722ead6efe);
    $parcel$export(module.exports, "prepareVersions", ()=>$7bab0d0d854708b2$export$56367a2df59d4d2c);
    $parcel$export(module.exports, "prepareOriginalVersions", ()=>$7bab0d0d854708b2$export$fd78157933f7abd6);
    $parcel$export(module.exports, "prepareCrossProjectVersions", ()=>$7bab0d0d854708b2$export$aef37bed4a9e5dd5);
    $parcel$export(module.exports, "prepareOriginalCrossProjectVersions", ()=>$7bab0d0d854708b2$export$8c1dc82bd60fadde);
    $parcel$export(module.exports, "isFlagHidden", ()=>$7bab0d0d854708b2$export$2336e431db64bb71);
    $parcel$export(module.exports, "prepareWRMPlannedCapacities", ()=>$7bab0d0d854708b2$export$3adcaa8cd98b8f6a);
    $parcel$export(module.exports, "prepareWRMOriginalPlannedCapacities", ()=>$7bab0d0d854708b2$export$2656d9c43b9d53c6);
    $parcel$export(module.exports, "updateRefs", ()=>$7bab0d0d854708b2$export$a193e7f93f99fcee);
    var $fcToA;
    var $b1yMp;
    var $kSwbB;
    var $jVZZA;
    var $4wiYB;
    var $2JlG5;
    var $3nPAF;
    var $76p2G;
    var $4Rr1a;
    var $ik0Qc;
    var $cDKdi;
    var $iavfW;
    var $8r8wv;
    var $bQZTk;
    var $2rMKg;
    var $sqeVT;
    var $cXTmV;
    var $3JFoT;
    var $d8iBX;
    var $f5OZ1;
    var $cBX85;
    var $bjzU8;
    var $g4tDr;
    var $lDLaq;
    var $4ENQh;
    var $flnZx;
    var $c12LJ;
    var $eJyeb = parcelRequire("eJyeb");
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $h0oWC = parcelRequire("h0oWC");
    var $iOPeP = parcelRequire("iOPeP");
    const $7bab0d0d854708b2$export$2d57479448be0d61 = -1;
    const $7bab0d0d854708b2$export$daec004a13bf7323 = {
        id: -2,
        name: 'Story',
        iconUrl: (0, $eJyeb.proxyContextSafeUrl)((0, (0, parcelRequire("lDLaq")).puppies).puppy1),
        level: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE)
    };
    const $7bab0d0d854708b2$export$5331cbeee80032d1 = $7bab0d0d854708b2$export$daec004a13bf7323;
    function $7bab0d0d854708b2$export$d12436df6b5b161e(dateConfiguration) {
        return function normalizeDates(x) {
            const result = {
                ...x
            };
            const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
            for (const [f, props] of [
                [
                    (0, (0, parcelRequire("flnZx")).startOfUtcDay),
                    [
                        'start',
                        baselineStartField.key
                    ]
                ],
                [
                    (0, (0, parcelRequire("flnZx")).endOfUtcDay),
                    [
                        'end',
                        baselineEndField.key
                    ]
                ]
            ])for (const prop of props){
                if ((0, $4nDwW.isDefined)(x[prop])) result[prop] = f(x[prop]);
                else if ((0, $4nDwW.isDefined)(x.customFields) && (0, $4nDwW.isDefined)(x.customFields[prop])) result.customFields[prop] = f(x.customFields[prop]);
            }
            return result;
        };
    }
    function $7bab0d0d854708b2$var$normalizeParentTeamAndSprintForSubtasks(issuesById) {
        return (issue)=>{
            const parentIssue = issuesById[issue.parent || ''];
            if (!(0, $4nDwW.isDefined)(parentIssue)) return issue;
            if (issue.level >= parentIssue.level) return (0, parcelRequire("iavfW")).default([
                'parent'
            ], issue);
            if (issue.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL) && (issue.team !== parentIssue.team || issue.sprint !== parentIssue.sprint)) {
                const changes = {
                    team: parentIssue.team,
                    sprint: parentIssue.sprint
                };
                return (0, parcelRequire("ik0Qc")).default(issue, changes);
            }
            return issue;
        };
    }
    const $7bab0d0d854708b2$export$7ee48aec63e12327 = (apiIssues = [], { levels: levels, issueTypes: issueTypes, dateConfiguration: dateConfiguration, releasesDisabledProject: releasesDisabledProject })=>{
        const typeToLevel = (0, $h0oWC.getTypeToLevelPure)(levels, issueTypes);
        const normalizeDates = $7bab0d0d854708b2$export$d12436df6b5b161e(dateConfiguration);
        const issues = apiIssues.map(({ id: id, issueKey: issueKey, assignments: assignments, annotations: annotations, issueSources: issueSources, values: { assignee: assignee, associatedIssueIds: associatedIssueIds, reporter: reporter, baselineStart: baselineStart, baselineEnd: baselineEnd, color: color, customFields: customFields, description: description, dueDate: dueDate, earliestStart: earliestStart, excluded: excluded, fixVersions: fixVersions, goals: goals, labels: labels, lexoRank: lexoRank, originalStoryPoints: originalStoryPoints, originalTimeEstimate: originalTimeEstimate, parent: parent, priority: priority, project: project, sprint: sprint, completedSprints: completedSprints, status: status, storyPoints: storyPoints, summary: summary, team: team, timeEstimate: timeEstimate, timeSpent: timeSpent, type: type, components: components, associatedIssues: associatedIssues }, originals: { completedSprints: ogCompletedSprints } })=>normalizeDates({
                assignments: assignments?.map(normalizeDates) ?? [],
                annotations: annotations ?? [],
                assignee: assignee || 'unassigned',
                associatedIssueIds: associatedIssueIds || [],
                associatedIssues: associatedIssues || [],
                reporter: reporter,
                color: color,
                customFields: customFields,
                description: description,
                dueDate: dueDate,
                earliestStart: earliestStart,
                excluded: excluded,
                fixVersions: releasesDisabledProject.includes(project) ? [] : fixVersions,
                goals: goals,
                id: id,
                issueKey: issueKey,
                level: typeToLevel(type),
                labels: labels,
                lexoRank: lexoRank,
                issueSources: issueSources,
                originalStoryPoints: originalStoryPoints,
                originalTimeEstimate: originalTimeEstimate,
                parent: parent,
                priority: priority,
                project: project,
                sprint: sprint,
                completedSprints: [
                    ...completedSprints || [],
                    ...ogCompletedSprints || []
                ],
                status: status,
                storyPoints: storyPoints,
                summary: summary,
                [$5fACX.TARGET_START_FIELD]: baselineStart,
                [$5fACX.TARGET_END_FIELD]: baselineEnd,
                team: team,
                timeEstimate: timeEstimate,
                timeSpent: timeSpent,
                components: components,
                type: (0, $4nDwW.isDefined)(type) || project ? type : $7bab0d0d854708b2$export$daec004a13bf7323.id
            }));
        const issuesById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), issues);
        return issues.map($7bab0d0d854708b2$var$normalizeParentTeamAndSprintForSubtasks(issuesById));
    };
    const $7bab0d0d854708b2$export$10fa05fcb84f4152 = (issues, originalIssues)=>{
        const result = new Set();
        for (const { goals: goals } of issues)for (const goal of goals || [])result.add(goal);
        for (const { goals: goals } of (0, $4nDwW.values)(originalIssues))for (const goal of goals || [])result.add(goal);
        return Array.from(result).sort();
    };
    const $7bab0d0d854708b2$export$8c647deb657d24f3 = (issues, originalIssues)=>{
        const result = new Set();
        for (const { labels: labels } of issues)for (const label of labels || [])result.add(label);
        for (const { labels: labels } of (0, $4nDwW.values)(originalIssues))for (const label of labels || [])result.add(label);
        return Array.from(result).sort();
    };
    const $7bab0d0d854708b2$export$e4e5ef06a110b4fe = (issues, originalIssues, customFields)=>{
        const result = {};
        const labelFieldIds = customFields.filter((field)=>(0, $cScrq.isLabelCustomField)(field?.type?.key)).map((field)=>field.id);
        if (labelFieldIds.length < 1) return result;
        const getCustomLabels = (issue)=>{
            labelFieldIds.forEach((fieldId)=>{
                const customFieldValue = issue?.customFields?.[fieldId];
                if (Array.isArray(customFieldValue) && (0, $4nDwW.isDefined)(fieldId)) {
                    const customLabels = result[fieldId];
                    if (Array.isArray(customLabels)) result[Number(fieldId)] = (0, parcelRequire("d8iBX")).default(customLabels.concat(customFieldValue));
                    else result[Number(fieldId)] = customFieldValue;
                }
            });
        };
        issues.forEach(getCustomLabels);
        (0, $4nDwW.values)(originalIssues).forEach(getCustomLabels);
        return result;
    };
    const $7bab0d0d854708b2$export$5e8aad9fb5510614 = (currentCustomLabels, newCustomLabels)=>(0, parcelRequire("cDKdi")).default((0, parcelRequire("bQZTk")).default((0, parcelRequire("kSwbB")).default, (0, parcelRequire("d8iBX")).default), currentCustomLabels, newCustomLabels);
    const $7bab0d0d854708b2$export$eb3bc0a67206b042 = (issues, originalIssues)=>{
        const result = new Set();
        for (const { components: components } of issues)for (const component of components || [])result.add(component);
        for (const { components: components } of (0, $4nDwW.values)(originalIssues))for (const component of components || [])result.add(component);
        return Array.from(result).sort();
    };
    const $7bab0d0d854708b2$export$77be91e7c3f75d53 = (issues, dependencySettingsInfo)=>{
        const result = {
            values: {},
            originals: {}
        };
        const modes = [
            'values',
            'originals'
        ];
        const linkTypes = new Set((0, $4nDwW.pluck)('issueLinkTypeId', dependencySettingsInfo.dependencyIssueLinkTypes));
        const dependencyIssueLinkTypeById = (0, $4nDwW.indexBy)((dependencyIssueLinkType)=>dependencyIssueLinkType.issueLinkTypeId, dependencySettingsInfo.dependencyIssueLinkTypes);
        for (const issue of issues){
            const { id: id } = issue;
            for (const mode of modes){
                let links = issue[mode].issueLinks;
                if (links) {
                    links = links.map((link)=>{
                        if (dependencyIssueLinkTypeById[link.type] && !dependencyIssueLinkTypeById[link.type].isOutward) return {
                            ...link,
                            sourceItemKey: link.targetItemKey,
                            targetItemKey: link.sourceItemKey
                        };
                        return link;
                    });
                    result[mode][id] = (0, $4nDwW.indexBy)((x)=>x.itemKey, links.filter((x)=>linkTypes.has(x.type)));
                }
            }
        }
        return result;
    };
    const $7bab0d0d854708b2$export$2369010677cffb11 = (issues, dateConfiguration, scenarioRemovedIssues)=>{
        const originalIssues = {};
        const normalizeDates = $7bab0d0d854708b2$export$d12436df6b5b161e(dateConfiguration);
        for (const { id: id, issueKey: issueKey, originals: rawOriginals } of [
            ...issues,
            ...scenarioRemovedIssues || []
        ]){
            const { issueLinks: issueLinks, statusTransition: statusTransition, ...originals } = rawOriginals;
            if (!(0, parcelRequire("3nPAF")).default(originals)) {
                const { baselineStart: baselineStart, baselineEnd: baselineEnd, ...otherOriginals } = originals;
                const originalValues = {
                    ...otherOriginals
                };
                if ((0, parcelRequire("2JlG5")).default('baselineStart')(originals)) originalValues[$5fACX.TARGET_START_FIELD] = baselineStart;
                if ((0, parcelRequire("2JlG5")).default('baselineEnd')(originals)) originalValues[$5fACX.TARGET_END_FIELD] = baselineEnd;
                originalIssues[id] = normalizeDates(originalValues);
            } else if (!(0, $4nDwW.isDefined)(issueKey)) originalIssues[id] = {};
        }
        return originalIssues;
    };
    const $7bab0d0d854708b2$export$9f9189c6bd7cd5f2 = (teams)=>{
        const originalTeams = {};
        for (const { id: id, originals: originals, itemKey: itemKey, scenarioType: scenarioType } of teams){
            if (!(0, parcelRequire("3nPAF")).default(originals)) originalTeams[itemKey] = originals;
            else if (!itemKey) originalTeams[id] = {};
            else if (scenarioType) originalTeams[itemKey] = {};
        }
        return originalTeams;
    };
    const $7bab0d0d854708b2$export$7c7246f1cd0fb982 = (teams)=>{
        const originalResources = {};
        for (const { resources: resources } of teams)resources.filter((resource)=>resource.scenarioType).forEach((resource)=>{
            originalResources[resource.itemKey] = {};
        });
        return originalResources;
    };
    const $7bab0d0d854708b2$export$ba899063f8c1fb3 = ({ currentScenarioId: currentScenarioId, plan: { id: id, title: title, planningUnit: planningUnit, issueSources: issueSources, multiScenarioEnabled: multiScenarioEnabled, includeCompletedIssuesFor: includeCompletedIssuesFor, calculationConfiguration: calculationConfiguration, syncStartEnabled: syncStartEnabled, issueInferredDateSelection: issueInferredDateSelection, baselineStartField: baselineStartField, baselineEndField: baselineEndField, createdTimestamp: createdTimestamp, creatorAccountId: creatorAccountId, leadAccountId: leadAccountId }, scenarios: scenarios, isSamplePlan: isSamplePlan = false, autoSchedulerEnabled: autoSchedulerEnabled = true, planStatus: planStatus = 'ACTIVE', planType: planType })=>({
            id: id,
            title: title,
            currentScenarioId: currentScenarioId,
            planningUnit: planningUnit,
            issueSources: issueSources,
            multiScenarioEnabled: multiScenarioEnabled,
            scenarios: scenarios,
            includeCompletedIssuesFor: includeCompletedIssuesFor,
            autoScheduleConfiguration: calculationConfiguration,
            syncStartEnabled: syncStartEnabled,
            issueInferredDateSelection: issueInferredDateSelection,
            baselineStartField: baselineStartField,
            baselineEndField: baselineEndField,
            createdTimestamp: createdTimestamp,
            isSamplePlan: isSamplePlan,
            autoSchedulerEnabled: autoSchedulerEnabled,
            planStatus: planStatus,
            creatorAccountId: creatorAccountId,
            leadAccountId: leadAccountId,
            planType: planType
        });
    const $7bab0d0d854708b2$var$getPrioritiesForProject = (issuePriorityInformation, projectId)=>{
        const { issuePrioritySchemes: issuePrioritySchemes, projectToPrioritySchemeAssociations: projectToPrioritySchemeAssociations } = issuePriorityInformation;
        const prioritySchemeId = projectToPrioritySchemeAssociations[projectId];
        return issuePrioritySchemes[prioritySchemeId];
    };
    const $7bab0d0d854708b2$export$53e809f11defc51 = ({ id: id, key: key, name: name, avatarUrl: avatarUrl, versions: versions, issueTypeIds: issueTypeIds, issueStatusIds: issueStatusIds, components: components, isSimplified: isSimplified, projectTypeKey: projectTypeKey, isReleasesEnabled: isReleasesEnabled }, defaultIssuePriorityScheme)=>{
        const { defaultIssuePriorityId: defaultIssuePriorityId, issuePriorityIds: issuePriorityIds = [], id: prioritySchemaId } = defaultIssuePriorityScheme;
        return {
            id: id,
            key: key,
            name: name,
            avatarUrl: avatarUrl,
            versions: versions.filter((0, parcelRequire("fcToA")).default((0, parcelRequire("sqeVT")).default('scenarioType', (0, $TTKUQ.SCENARIO_TYPE).DELETED))).map((0, parcelRequire("2rMKg")).default('itemKey')),
            components: components,
            issueStatusIds: issueStatusIds,
            issueTypeIds: issueTypeIds.map((x)=>parseInt(x, 10)),
            issuePriorityIds: issuePriorityIds,
            defaultIssuePriorityId: defaultIssuePriorityId,
            prioritySchemaId: prioritySchemaId,
            isSimplified: isSimplified,
            projectTypeKey: projectTypeKey,
            isReleasesEnabled: isReleasesEnabled ?? true
        };
    };
    const $7bab0d0d854708b2$export$bdd0152d88205d11 = (projects, issuePriorityInformation)=>projects.map((project)=>$7bab0d0d854708b2$export$53e809f11defc51(project, $7bab0d0d854708b2$var$getPrioritiesForProject(issuePriorityInformation, project.id)));
    const $7bab0d0d854708b2$export$5973c8d181359244 = (releaseStatuses)=>[
            ...releaseStatuses,
            (0, $iOPeP.offTrack),
            (0, $iOPeP.onTrack)
        ];
    const $7bab0d0d854708b2$export$b1987cbfdb1ff1f6 = (sprints, planInfo)=>{
        const sprintIssueSources = {};
        planInfo.plan.issueSources.forEach((issueSource)=>{
            if (issueSource.sprintIds && Array.isArray(issueSource.sprintIds)) issueSource.sprintIds.forEach((sprintId)=>{
                if (!sprintIssueSources[sprintId]) sprintIssueSources[sprintId] = new Set();
                sprintIssueSources[sprintId].add(issueSource.id);
            });
        });
        return (0, parcelRequire("bQZTk")).default((0, parcelRequire("4Rr1a")).default((sprint)=>({
                ...sprint,
                issueSources: Array.from(sprintIssueSources[sprint.id] || []),
                id: `${sprint.id}`
            })), (0, parcelRequire("3JFoT")).default, (0, parcelRequire("f5OZ1")).default((s)=>s.id), (0, parcelRequire("3JFoT")).default)(sprints);
    };
    const $7bab0d0d854708b2$export$a493e3df6f49328a = (0, (0, parcelRequire("4ENQh")).monitor).timeFunction($7bab0d0d854708b2$export$b1987cbfdb1ff1f6, 'state_domain_util_prepareSprints');
    const $7bab0d0d854708b2$var$groupPlannedCapacities = (plannedCapacities)=>(0, parcelRequire("b1yMp")).default((0, parcelRequire("4Rr1a")).default((plannedCapacitiesInGroup)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('iterationId'), plannedCapacitiesInGroup)), (0, parcelRequire("4wiYB")).default((0, parcelRequire("2rMKg")).default('teamId')))(plannedCapacities);
    const $7bab0d0d854708b2$export$8ee5116566102c9e = (arr)=>$7bab0d0d854708b2$var$groupPlannedCapacities(arr);
    const $7bab0d0d854708b2$export$c6aff91679d072cd = (arr)=>$7bab0d0d854708b2$var$groupPlannedCapacities(arr);
    const $7bab0d0d854708b2$export$a2595bd0c9ce474b = ({ id: id, solution: solution, calculationConfiguration: calculationConfiguration })=>{
        if (!solution) throw new Error('Expected calculationResult with solution');
        const { projects: projects, teams: teams } = solution;
        return {
            id: id,
            projects: projects,
            teams: teams,
            calculationConfiguration: calculationConfiguration
        };
    };
    const $7bab0d0d854708b2$export$399f8f703c757cc2 = ({ itemKey: itemKey, resources: resources, shareable: shareable, scenarioType: scenarioType, values: values, originals: originals, externalId: externalId, isPlanTeam: isPlanTeam })=>({
            id: itemKey,
            resources: resources,
            shareable: shareable,
            originals: originals,
            scenarioType: scenarioType,
            ...values,
            avatarUrl: values.avatarUrl || '',
            externalId: externalId,
            isPlanTeam: isPlanTeam
        });
    const $7bab0d0d854708b2$export$cc413d722ead6efe = (teams)=>teams.map($7bab0d0d854708b2$export$399f8f703c757cc2);
    const $7bab0d0d854708b2$export$1fe0089a80242df0 = (allVersions, projectId, versions, isPreparingRemovedVersions)=>{
        const newAllVersions = allVersions;
        let versionsToProcess;
        if (isPreparingRemovedVersions) versionsToProcess = versions.filter((0, parcelRequire("sqeVT")).default('scenarioType', (0, $TTKUQ.SCENARIO_TYPE).DELETED));
        else versionsToProcess = versions.filter((0, parcelRequire("fcToA")).default((0, parcelRequire("sqeVT")).default('scenarioType', (0, $TTKUQ.SCENARIO_TYPE).DELETED)));
        for (const { itemKey: itemKey, values: values } of versionsToProcess){
            const mappedValues = {
                ...values
            };
            if ((0, $4nDwW.isDefined)(mappedValues.end)) mappedValues.end = (0, (0, parcelRequire("flnZx")).endOfUtcDay)(mappedValues.end);
            const prev = allVersions[itemKey] || {
                projects: []
            };
            newAllVersions[itemKey] = {
                ...prev,
                ...mappedValues,
                id: itemKey,
                projects: Array.from(new Set([
                    ...prev.projects,
                    projectId
                ]))
            };
        }
        return newAllVersions;
    };
    const $7bab0d0d854708b2$export$56367a2df59d4d2c = (projects, crossProjectVersions, { isPreparingRemovedVersions: isPreparingRemovedVersions })=>{
        let allVersions = {};
        const crossProjectVersionsByIdMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('itemKey'), crossProjectVersions);
        for (const { id: id, versions: versions } of projects)allVersions = $7bab0d0d854708b2$export$1fe0089a80242df0(allVersions, id, versions, isPreparingRemovedVersions);
        for (const versionId of Object.keys(allVersions)){
            const crossProjectVersion = allVersions[versionId].crossProjectVersion;
            if ((0, $4nDwW.isDefined)(crossProjectVersion) && !(0, $4nDwW.isDefined)(crossProjectVersionsByIdMap[crossProjectVersion])) allVersions[versionId].crossProjectVersion = null;
        }
        return (0, parcelRequire("bjzU8")).default(allVersions);
    };
    const $7bab0d0d854708b2$export$fd78157933f7abd6 = (projects, crossProjectVersions)=>{
        const allVersions = [];
        const crossProjectVersionsByIdMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('itemKey'), crossProjectVersions);
        for (const { versions: versions } of projects)allVersions.push(...versions);
        const originalVersions = {};
        allVersions.forEach(({ itemKey: id, originals: originals, scenarioType: scenarioType })=>{
            if (scenarioType) {
                const originalValues = {
                    ...originals
                };
                const { crossProjectVersion: crossProjectVersion } = originals;
                if ((0, $4nDwW.isDefined)(crossProjectVersion) && !(0, $4nDwW.isDefined)(crossProjectVersionsByIdMap[crossProjectVersion])) originalValues.crossProjectVersion = null;
                originalVersions[id] = originalValues;
            }
            return originalVersions;
        });
        return originalVersions;
    };
    const $7bab0d0d854708b2$export$1999a22f899a37d4 = (crossProjectVersionId, versions)=>versions.filter(({ crossProjectVersion: crossProjectVersion })=>(0, $4nDwW.isDefined)(crossProjectVersion) && crossProjectVersion === crossProjectVersionId).map(({ id: id })=>id);
    const $7bab0d0d854708b2$export$aef37bed4a9e5dd5 = (crossProjectVersions, versions, { isPreparingDeletedCrossProjectVersions: isPreparingDeletedCrossProjectVersions })=>{
        const [deletedCrossProjectVersions, existingCrossProjectVersions] = (0, parcelRequire("8r8wv")).default((0, parcelRequire("sqeVT")).default('scenarioType', (0, $TTKUQ.SCENARIO_TYPE).DELETED), crossProjectVersions).map((crossProjectVersions)=>crossProjectVersions.map(({ itemKey: itemKey, values: { name: name } })=>({
                    id: itemKey,
                    name: name,
                    versions: $7bab0d0d854708b2$export$1999a22f899a37d4(itemKey, versions)
                })));
        if (isPreparingDeletedCrossProjectVersions) return deletedCrossProjectVersions;
        return existingCrossProjectVersions;
    };
    const $7bab0d0d854708b2$export$8c1dc82bd60fadde = (crossProjectVersions)=>{
        const originalCrossProjectVersions = {};
        crossProjectVersions.forEach(({ itemKey: id, originals: originals, scenarioType: scenarioType })=>{
            if (scenarioType) originalCrossProjectVersions[id] = {
                ...originals
            };
            return originalCrossProjectVersions;
        });
        return originalCrossProjectVersions;
    };
    const $7bab0d0d854708b2$export$2336e431db64bb71 = (flagName, hiddenFlags)=>{
        const currentHiddenFlag = hiddenFlags[flagName];
        const currentTimeStamp = Date.now();
        return !!(currentHiddenFlag && currentTimeStamp < currentHiddenFlag.hiddenUntilTimestamp);
    };
    const $7bab0d0d854708b2$var$plannedCapacityIsDeleted = (plannedCapacity)=>plannedCapacity.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).DELETED;
    const $7bab0d0d854708b2$var$mapWRMPlannedCapacity = (plannedCapacity)=>{
        const { itemKey: itemKey, values: { teamKey: teamKey, iterationId: iterationId, schedulingMode: schedulingMode, planningUnit: planningUnit, capacity: capacity } } = plannedCapacity;
        return {
            itemKey: itemKey,
            teamId: teamKey,
            iterationId: String(iterationId),
            schedulingMode: schedulingMode,
            planningUnit: planningUnit,
            capacity: capacity
        };
    };
    const $7bab0d0d854708b2$var$mapWRMOriginalPlannedCapacity = (plannedCapacity)=>{
        const { itemKey: itemKey, values: { teamKey: teamKey, iterationId: iterationId, schedulingMode: schedulingMode, planningUnit: planningUnit, capacity: capacity }, originals: originals } = plannedCapacity;
        if ($7bab0d0d854708b2$var$plannedCapacityIsDeleted(plannedCapacity)) return {
            itemKey: itemKey,
            teamId: teamKey,
            iterationId: String(iterationId),
            schedulingMode: schedulingMode,
            planningUnit: planningUnit,
            capacity: capacity
        };
        return {
            itemKey: itemKey,
            teamId: teamKey,
            iterationId: String(iterationId),
            schedulingMode: schedulingMode,
            planningUnit: planningUnit,
            capacity: typeof originals.capacity === 'number' ? originals.capacity : null
        };
    };
    const $7bab0d0d854708b2$var$indexBySprintId = (capacityArray)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('iterationId'), capacityArray);
    const $7bab0d0d854708b2$var$validCapacity = (plannedCapacity)=>!!plannedCapacity.values.teamKey;
    const $7bab0d0d854708b2$export$3adcaa8cd98b8f6a = (plannedCapacityList)=>(0, parcelRequire("bQZTk")).default((0, parcelRequire("jVZZA")).default($7bab0d0d854708b2$var$validCapacity), (0, parcelRequire("jVZZA")).default((plannedCapacity)=>!$7bab0d0d854708b2$var$plannedCapacityIsDeleted(plannedCapacity)), (0, parcelRequire("4Rr1a")).default($7bab0d0d854708b2$var$mapWRMPlannedCapacity), (0, parcelRequire("4wiYB")).default((it)=>it.teamId), (0, parcelRequire("4Rr1a")).default($7bab0d0d854708b2$var$indexBySprintId))(plannedCapacityList);
    const $7bab0d0d854708b2$export$2656d9c43b9d53c6 = (plannedCapacityList)=>(0, parcelRequire("bQZTk")).default((0, parcelRequire("jVZZA")).default($7bab0d0d854708b2$var$validCapacity), (0, parcelRequire("jVZZA")).default((c)=>!!c.scenarioType), (0, parcelRequire("4Rr1a")).default($7bab0d0d854708b2$var$mapWRMOriginalPlannedCapacity), (0, parcelRequire("4wiYB")).default((it)=>it.teamId), (0, parcelRequire("4Rr1a")).default($7bab0d0d854708b2$var$indexBySprintId))(plannedCapacityList);
    const $7bab0d0d854708b2$var$updateSingleRef = (item, key, oldRef, newRef)=>{
        if (item[key] !== oldRef) return item;
        return {
            ...item,
            [key]: newRef
        };
    };
    const $7bab0d0d854708b2$var$updateMultiRef = (item, key, oldRef, newRef)=>{
        const refs = item[key];
        const index = refs.indexOf(oldRef);
        if (index < 0) return item;
        return {
            ...item,
            [key]: newRef === null ? (0, parcelRequire("cXTmV")).default(index, 1, refs) : (0, parcelRequire("cBX85")).default(index, newRef, refs)
        };
    };
    const $7bab0d0d854708b2$var$updateRef = (item, key, oldRef, newRef)=>{
        if (oldRef === newRef) return item;
        if (Array.isArray(item[key])) return $7bab0d0d854708b2$var$updateMultiRef(item, key, oldRef, newRef);
        return $7bab0d0d854708b2$var$updateSingleRef(item, key, oldRef, newRef);
    };
    function $7bab0d0d854708b2$export$a193e7f93f99fcee(items, refs) {
        return (0, parcelRequire("4Rr1a")).default((item)=>(0, parcelRequire("76p2G")).default(refs).reduce((item, key)=>refs[key].reduce((item, [oldRef, newRef])=>$7bab0d0d854708b2$var$updateRef(item, key, oldRef, newRef), item), item), items);
    }
});
parcelRegister("fcToA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b122f26492d45b4b$export$2e2bcd8739ae039);
    var $cNOik;
    var $5XN59;
    var $b122f26492d45b4b$var$complement = (0, (0, parcelRequire("cNOik")).default)((0, (0, parcelRequire("5XN59")).default));
    var $b122f26492d45b4b$export$2e2bcd8739ae039 = $b122f26492d45b4b$var$complement;
});
parcelRegister("cNOik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0267c25f4ab94eff$export$2e2bcd8739ae039);
    var $ccUYa;
    var $j509z;
    var $0267c25f4ab94eff$var$lift = (0, (0, parcelRequire("ccUYa")).default)(function lift(fn) {
        return (0, (0, parcelRequire("j509z")).default)(fn.length, fn);
    });
    var $0267c25f4ab94eff$export$2e2bcd8739ae039 = $0267c25f4ab94eff$var$lift;
});
parcelRegister("j509z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de3e9a6abf6f9555$export$2e2bcd8739ae039);
    var $c9RLn;
    var $42qCL;
    var $hTl3I;
    var $9J1HQ;
    var $4Rr1a;
    var $de3e9a6abf6f9555$var$liftN = (0, (0, parcelRequire("c9RLn")).default)(function liftN(arity, fn) {
        var lifted = (0, (0, parcelRequire("9J1HQ")).default)(arity, fn);
        return (0, (0, parcelRequire("9J1HQ")).default)(arity, function() {
            return (0, (0, parcelRequire("42qCL")).default)((0, (0, parcelRequire("hTl3I")).default), (0, (0, parcelRequire("4Rr1a")).default)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
        });
    });
    var $de3e9a6abf6f9555$export$2e2bcd8739ae039 = $de3e9a6abf6f9555$var$liftN;
});
parcelRegister("42qCL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f0c0059676289cf$export$2e2bcd8739ae039);
    var $6kmm1;
    var $8vQt6;
    var $coiKL;
    function $2f0c0059676289cf$var$_arrayReduce(xf, acc, list) {
        var idx = 0;
        var len = list.length;
        while(idx < len){
            acc = xf['@@transducer/step'](acc, list[idx]);
            if (acc && acc['@@transducer/reduced']) {
                acc = acc['@@transducer/value'];
                break;
            }
            idx += 1;
        }
        return xf['@@transducer/result'](acc);
    }
    function $2f0c0059676289cf$var$_iterableReduce(xf, acc, iter) {
        var step = iter.next();
        while(!step.done){
            acc = xf['@@transducer/step'](acc, step.value);
            if (acc && acc['@@transducer/reduced']) {
                acc = acc['@@transducer/value'];
                break;
            }
            step = iter.next();
        }
        return xf['@@transducer/result'](acc);
    }
    function $2f0c0059676289cf$var$_methodReduce(xf, acc, obj, methodName) {
        return xf['@@transducer/result'](obj[methodName]((0, (0, parcelRequire("coiKL")).default)(xf['@@transducer/step'], xf), acc));
    }
    var $2f0c0059676289cf$var$symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
    function $2f0c0059676289cf$export$2e2bcd8739ae039(fn, acc, list) {
        if (typeof fn === 'function') fn = (0, (0, parcelRequire("8vQt6")).default)(fn);
        if ((0, (0, parcelRequire("6kmm1")).default)(list)) return $2f0c0059676289cf$var$_arrayReduce(fn, acc, list);
        if (typeof list['fantasy-land/reduce'] === 'function') return $2f0c0059676289cf$var$_methodReduce(fn, acc, list, 'fantasy-land/reduce');
        if (list[$2f0c0059676289cf$var$symIterator] != null) return $2f0c0059676289cf$var$_iterableReduce(fn, acc, list[$2f0c0059676289cf$var$symIterator]());
        if (typeof list.next === 'function') return $2f0c0059676289cf$var$_iterableReduce(fn, acc, list);
        if (typeof list.reduce === 'function') return $2f0c0059676289cf$var$_methodReduce(fn, acc, list, 'reduce');
        throw new TypeError('reduce: list must be array or iterable');
    }
});
parcelRegister("6kmm1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49b5f364c0adbe9d$export$2e2bcd8739ae039);
    var $ccUYa;
    var $cWyha;
    var $fsmuk;
    var $49b5f364c0adbe9d$var$_isArrayLike = (0, (0, parcelRequire("ccUYa")).default)(function isArrayLike(x) {
        if ((0, (0, parcelRequire("cWyha")).default)(x)) return true;
        if (!x) return false;
        if (typeof x !== 'object') return false;
        if ((0, (0, parcelRequire("fsmuk")).default)(x)) return false;
        if (x.nodeType === 1) return !!x.length;
        if (x.length === 0) return true;
        if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
        return false;
    });
    var $49b5f364c0adbe9d$export$2e2bcd8739ae039 = $49b5f364c0adbe9d$var$_isArrayLike;
});
parcelRegister("8vQt6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6329eb1aa289cf16$export$2e2bcd8739ae039);
    var $6329eb1aa289cf16$var$XWrap = function() {
        function XWrap(fn) {
            this.f = fn;
        }
        XWrap.prototype['@@transducer/init'] = function() {
            throw new Error('init not implemented on XWrap');
        };
        XWrap.prototype['@@transducer/result'] = function(acc) {
            return acc;
        };
        XWrap.prototype['@@transducer/step'] = function(acc, x) {
            return this.f(acc, x);
        };
        return XWrap;
    }();
    function $6329eb1aa289cf16$export$2e2bcd8739ae039(fn) {
        return new $6329eb1aa289cf16$var$XWrap(fn);
    }
});
parcelRegister("coiKL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$905645ea1072964a$export$2e2bcd8739ae039);
    var $kDMA6;
    var $c9RLn;
    var $905645ea1072964a$var$bind = (0, (0, parcelRequire("c9RLn")).default)(function bind(fn, thisObj) {
        return (0, (0, parcelRequire("kDMA6")).default)(fn.length, function() {
            return fn.apply(thisObj, arguments);
        });
    });
    var $905645ea1072964a$export$2e2bcd8739ae039 = $905645ea1072964a$var$bind;
});
parcelRegister("kDMA6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f06d2265e8cec211$export$2e2bcd8739ae039);
    function $f06d2265e8cec211$export$2e2bcd8739ae039(n, fn) {
        switch(n){
            case 0:
                return function() {
                    return fn.apply(this, arguments);
                };
            case 1:
                return function(a0) {
                    return fn.apply(this, arguments);
                };
            case 2:
                return function(a0, a1) {
                    return fn.apply(this, arguments);
                };
            case 3:
                return function(a0, a1, a2) {
                    return fn.apply(this, arguments);
                };
            case 4:
                return function(a0, a1, a2, a3) {
                    return fn.apply(this, arguments);
                };
            case 5:
                return function(a0, a1, a2, a3, a4) {
                    return fn.apply(this, arguments);
                };
            case 6:
                return function(a0, a1, a2, a3, a4, a5) {
                    return fn.apply(this, arguments);
                };
            case 7:
                return function(a0, a1, a2, a3, a4, a5, a6) {
                    return fn.apply(this, arguments);
                };
            case 8:
                return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                    return fn.apply(this, arguments);
                };
            case 9:
                return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                    return fn.apply(this, arguments);
                };
            case 10:
                return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                    return fn.apply(this, arguments);
                };
            default:
                throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
        }
    }
});
parcelRegister("hTl3I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d067e8958cb1a0de$export$2e2bcd8739ae039);
    var $6VFfk;
    var $c9RLn;
    var $42qCL;
    var $4Rr1a;
    var $d067e8958cb1a0de$var$ap = (0, (0, parcelRequire("c9RLn")).default)(function ap(applyF, applyX) {
        return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function(x) {
            return applyF(x)(applyX(x));
        } : (0, (0, parcelRequire("42qCL")).default)(function(acc, f) {
            return (0, (0, parcelRequire("6VFfk")).default)(acc, (0, (0, parcelRequire("4Rr1a")).default)(f, applyX));
        }, [], applyF);
    });
    var $d067e8958cb1a0de$export$2e2bcd8739ae039 = $d067e8958cb1a0de$var$ap;
});
parcelRegister("6VFfk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50b80f99a79c6da1$export$2e2bcd8739ae039);
    function $50b80f99a79c6da1$export$2e2bcd8739ae039(set1, set2) {
        set1 = set1 || [];
        set2 = set2 || [];
        var idx;
        var len1 = set1.length;
        var len2 = set2.length;
        var result = [];
        idx = 0;
        while(idx < len1){
            result[result.length] = set1[idx];
            idx += 1;
        }
        idx = 0;
        while(idx < len2){
            result[result.length] = set2[idx];
            idx += 1;
        }
        return result;
    }
});
parcelRegister("4Rr1a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38a111d907e3cc49$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5DTpU;
    var $7Mz99;
    var $42qCL;
    var $kL7fL;
    var $9J1HQ;
    var $76p2G;
    var $38a111d907e3cc49$var$map = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("5DTpU")).default)([
        'fantasy-land/map',
        'map'
    ], (0, (0, parcelRequire("kL7fL")).default), function map(fn, functor) {
        switch(Object.prototype.toString.call(functor)){
            case '[object Function]':
                return (0, (0, parcelRequire("9J1HQ")).default)(functor.length, function() {
                    return fn.call(this, functor.apply(this, arguments));
                });
            case '[object Object]':
                return (0, (0, parcelRequire("42qCL")).default)(function(acc, key) {
                    acc[key] = fn(functor[key]);
                    return acc;
                }, {}, (0, (0, parcelRequire("76p2G")).default)(functor));
            default:
                return (0, (0, parcelRequire("7Mz99")).default)(fn, functor);
        }
    }));
    var $38a111d907e3cc49$export$2e2bcd8739ae039 = $38a111d907e3cc49$var$map;
});
parcelRegister("5DTpU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41bb94e50f650600$export$2e2bcd8739ae039);
    var $cWyha;
    var $6RCbt;
    function $41bb94e50f650600$export$2e2bcd8739ae039(methodNames, xf, fn) {
        return function() {
            if (arguments.length === 0) return fn();
            var args = Array.prototype.slice.call(arguments, 0);
            var obj = args.pop();
            if (!(0, (0, parcelRequire("cWyha")).default)(obj)) {
                var idx = 0;
                while(idx < methodNames.length){
                    if (typeof obj[methodNames[idx]] === 'function') return obj[methodNames[idx]].apply(obj, args);
                    idx += 1;
                }
                if ((0, (0, parcelRequire("6RCbt")).default)(obj)) {
                    var transducer = xf.apply(null, args);
                    return transducer(obj);
                }
            }
            return fn.apply(this, arguments);
        };
    }
});
parcelRegister("6RCbt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ff54fe34795bc9f$export$2e2bcd8739ae039);
    function $4ff54fe34795bc9f$export$2e2bcd8739ae039(obj) {
        return obj != null && typeof obj['@@transducer/step'] === 'function';
    }
});
parcelRegister("7Mz99", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5aa8477b9174524a$export$2e2bcd8739ae039);
    function $5aa8477b9174524a$export$2e2bcd8739ae039(fn, functor) {
        var idx = 0;
        var len = functor.length;
        var result = Array(len);
        while(idx < len){
            result[idx] = fn(functor[idx]);
            idx += 1;
        }
        return result;
    }
});
parcelRegister("kL7fL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f1cdd2ce29b5f977$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7D5kn;
    var $f1cdd2ce29b5f977$var$XMap = function() {
        function XMap(f, xf) {
            this.xf = xf;
            this.f = f;
        }
        XMap.prototype['@@transducer/init'] = (0, (0, parcelRequire("7D5kn")).default).init;
        XMap.prototype['@@transducer/result'] = (0, (0, parcelRequire("7D5kn")).default).result;
        XMap.prototype['@@transducer/step'] = function(result, input) {
            return this.xf['@@transducer/step'](result, this.f(input));
        };
        return XMap;
    }();
    var $f1cdd2ce29b5f977$var$_xmap = (0, (0, parcelRequire("c9RLn")).default)(function _xmap(f, xf) {
        return new $f1cdd2ce29b5f977$var$XMap(f, xf);
    });
    var $f1cdd2ce29b5f977$export$2e2bcd8739ae039 = $f1cdd2ce29b5f977$var$_xmap;
});
parcelRegister("7D5kn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58e04ee2eef7ce42$export$2e2bcd8739ae039);
    var $58e04ee2eef7ce42$export$2e2bcd8739ae039 = {
        init: function() {
            return this.xf['@@transducer/init']();
        },
        result: function(result) {
            return this.xf['@@transducer/result'](result);
        }
    };
});
parcelRegister("9J1HQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7149a3d847445a08$export$2e2bcd8739ae039);
    var $kDMA6;
    var $ccUYa;
    var $c9RLn;
    var $mfqvs;
    var $7149a3d847445a08$var$curryN = (0, (0, parcelRequire("c9RLn")).default)(function curryN(length, fn) {
        if (length === 1) return (0, (0, parcelRequire("ccUYa")).default)(fn);
        return (0, (0, parcelRequire("kDMA6")).default)(length, (0, (0, parcelRequire("mfqvs")).default)(length, [], fn));
    });
    var $7149a3d847445a08$export$2e2bcd8739ae039 = $7149a3d847445a08$var$curryN;
});
parcelRegister("mfqvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$042e059314e29170$export$2e2bcd8739ae039);
    var $kDMA6;
    var $iU24A;
    function $042e059314e29170$export$2e2bcd8739ae039(length, received, fn) {
        return function() {
            var combined = [];
            var argsIdx = 0;
            var left = length;
            var combinedIdx = 0;
            while(combinedIdx < received.length || argsIdx < arguments.length){
                var result;
                if (combinedIdx < received.length && (!(0, (0, parcelRequire("iU24A")).default)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
                else {
                    result = arguments[argsIdx];
                    argsIdx += 1;
                }
                combined[combinedIdx] = result;
                if (!(0, (0, parcelRequire("iU24A")).default)(result)) left -= 1;
                combinedIdx += 1;
            }
            return left <= 0 ? fn.apply(this, combined) : (0, (0, parcelRequire("kDMA6")).default)(left, $042e059314e29170$export$2e2bcd8739ae039(length, combined, fn));
        };
    }
});
parcelRegister("5XN59", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4578892059551555$export$2e2bcd8739ae039);
    var $ccUYa;
    var $4578892059551555$var$not = (0, (0, parcelRequire("ccUYa")).default)(function not(a) {
        return !a;
    });
    var $4578892059551555$export$2e2bcd8739ae039 = $4578892059551555$var$not;
});
parcelRegister("b1yMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$806ac43b3913313a$export$2e2bcd8739ae039);
    var $bQZTk;
    var $3JFoT;
    function $806ac43b3913313a$export$2e2bcd8739ae039() {
        if (arguments.length === 0) throw new Error('compose requires at least one argument');
        return (0, (0, parcelRequire("bQZTk")).default).apply(this, (0, (0, parcelRequire("3JFoT")).default)(arguments));
    }
});
parcelRegister("bQZTk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a148f676482e3d5$export$2e2bcd8739ae039);
    var $kDMA6;
    var $fqVfb;
    var $j0d94;
    var $4Fwck;
    function $8a148f676482e3d5$export$2e2bcd8739ae039() {
        if (arguments.length === 0) throw new Error('pipe requires at least one argument');
        return (0, (0, parcelRequire("kDMA6")).default)(arguments[0].length, (0, (0, parcelRequire("j0d94")).default)((0, (0, parcelRequire("fqVfb")).default), arguments[0], (0, (0, parcelRequire("4Fwck")).default)(arguments)));
    }
});
parcelRegister("fqVfb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3c5b028f113ca9f$export$2e2bcd8739ae039);
    function $b3c5b028f113ca9f$export$2e2bcd8739ae039(f, g) {
        return function() {
            return g.call(this, f.apply(this, arguments));
        };
    }
});
parcelRegister("j0d94", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dd5836c86b9f068a$export$2e2bcd8739ae039);
    var $IYMZh;
    var $42qCL;
    var $dd5836c86b9f068a$var$reduce = (0, (0, parcelRequire("IYMZh")).default)((0, (0, parcelRequire("42qCL")).default));
    var $dd5836c86b9f068a$export$2e2bcd8739ae039 = $dd5836c86b9f068a$var$reduce;
});
parcelRegister("4Fwck", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3663f797940f9253$export$2e2bcd8739ae039);
    var $b3IvY;
    var $ccUYa;
    var $blU6m;
    var $3663f797940f9253$var$tail = (0, (0, parcelRequire("ccUYa")).default)((0, (0, parcelRequire("b3IvY")).default)('tail', (0, (0, parcelRequire("blU6m")).default)(1, Infinity)));
    var $3663f797940f9253$export$2e2bcd8739ae039 = $3663f797940f9253$var$tail;
});
parcelRegister("b3IvY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80d2813a9951a61c$export$2e2bcd8739ae039);
    var $cWyha;
    function $80d2813a9951a61c$export$2e2bcd8739ae039(methodname, fn) {
        return function() {
            var length = arguments.length;
            if (length === 0) return fn();
            var obj = arguments[length - 1];
            return (0, (0, parcelRequire("cWyha")).default)(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
        };
    }
});
parcelRegister("blU6m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$843d2c78fc3f1336$export$2e2bcd8739ae039);
    var $b3IvY;
    var $IYMZh;
    var $843d2c78fc3f1336$var$slice = (0, (0, parcelRequire("IYMZh")).default)((0, (0, parcelRequire("b3IvY")).default)('slice', function slice(fromIndex, toIndex, list) {
        return Array.prototype.slice.call(list, fromIndex, toIndex);
    }));
    var $843d2c78fc3f1336$export$2e2bcd8739ae039 = $843d2c78fc3f1336$var$slice;
});
parcelRegister("3JFoT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b85b058f3537240$export$2e2bcd8739ae039);
    var $ccUYa;
    var $fsmuk;
    var $2b85b058f3537240$var$reverse = (0, (0, parcelRequire("ccUYa")).default)(function reverse(list) {
        return (0, (0, parcelRequire("fsmuk")).default)(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
    });
    var $2b85b058f3537240$export$2e2bcd8739ae039 = $2b85b058f3537240$var$reverse;
});
parcelRegister("kSwbB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f331d148bf3510dc$export$2e2bcd8739ae039);
    var $c9RLn;
    var $cWyha;
    var $j8oua;
    var $fsmuk;
    var $thm1N;
    var $f331d148bf3510dc$var$concat = (0, (0, parcelRequire("c9RLn")).default)(function concat(a, b) {
        if ((0, (0, parcelRequire("cWyha")).default)(a)) {
            if ((0, (0, parcelRequire("cWyha")).default)(b)) return a.concat(b);
            throw new TypeError((0, (0, parcelRequire("thm1N")).default)(b) + ' is not an array');
        }
        if ((0, (0, parcelRequire("fsmuk")).default)(a)) {
            if ((0, (0, parcelRequire("fsmuk")).default)(b)) return a + b;
            throw new TypeError((0, (0, parcelRequire("thm1N")).default)(b) + ' is not a string');
        }
        if (a != null && (0, (0, parcelRequire("j8oua")).default)(a['fantasy-land/concat'])) return a['fantasy-land/concat'](b);
        if (a != null && (0, (0, parcelRequire("j8oua")).default)(a.concat)) return a.concat(b);
        throw new TypeError((0, (0, parcelRequire("thm1N")).default)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
    });
    var $f331d148bf3510dc$export$2e2bcd8739ae039 = $f331d148bf3510dc$var$concat;
});
parcelRegister("j8oua", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dee1c1fd3b54d245$export$2e2bcd8739ae039);
    function $dee1c1fd3b54d245$export$2e2bcd8739ae039(x) {
        return Object.prototype.toString.call(x) === '[object Function]';
    }
});
parcelRegister("thm1N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05802bbf8e16dff1$export$2e2bcd8739ae039);
    var $ccUYa;
    var $guDDe;
    var $05802bbf8e16dff1$var$toString = (0, (0, parcelRequire("ccUYa")).default)(function toString(val) {
        return (0, (0, parcelRequire("guDDe")).default)(val, []);
    });
    var $05802bbf8e16dff1$export$2e2bcd8739ae039 = $05802bbf8e16dff1$var$toString;
});
parcelRegister("guDDe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c01e30bc79982c57$export$2e2bcd8739ae039);
    var $4MZp5;
    var $7Mz99;
    var $ammTJ;
    var $cQgxe;
    var $76p2G;
    var $7p8Aa;
    function $c01e30bc79982c57$export$2e2bcd8739ae039(x, seen) {
        var recur = function recur(y) {
            var xs = seen.concat([
                x
            ]);
            return (0, (0, parcelRequire("4MZp5")).default)(y, xs) ? '<Circular>' : $c01e30bc79982c57$export$2e2bcd8739ae039(y, xs);
        };
        var mapPairs = function(obj, keys) {
            return (0, (0, parcelRequire("7Mz99")).default)(function(k) {
                return (0, (0, parcelRequire("ammTJ")).default)(k) + ': ' + recur(obj[k]);
            }, keys.slice().sort());
        };
        switch(Object.prototype.toString.call(x)){
            case '[object Arguments]':
                return '(function() { return arguments; }(' + (0, (0, parcelRequire("7Mz99")).default)(recur, x).join(', ') + '))';
            case '[object Array]':
                return '[' + (0, (0, parcelRequire("7Mz99")).default)(recur, x).concat(mapPairs(x, (0, (0, parcelRequire("7p8Aa")).default)(function(k) {
                    return /^\d+$/.test(k);
                }, (0, (0, parcelRequire("76p2G")).default)(x)))).join(', ') + ']';
            case '[object Boolean]':
                return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
            case '[object Date]':
                return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : (0, (0, parcelRequire("ammTJ")).default)((0, (0, parcelRequire("cQgxe")).default)(x))) + ')';
            case '[object Null]':
                return 'null';
            case '[object Number]':
                return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
            case '[object String]':
                return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : (0, (0, parcelRequire("ammTJ")).default)(x);
            case '[object Undefined]':
                return 'undefined';
            default:
                if (typeof x.toString === 'function') {
                    var repr = x.toString();
                    if (repr !== '[object Object]') return repr;
                }
                return '{' + mapPairs(x, (0, (0, parcelRequire("76p2G")).default)(x)).join(', ') + '}';
        }
    }
});
parcelRegister("ammTJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78adb880116fc433$export$2e2bcd8739ae039);
    function $78adb880116fc433$export$2e2bcd8739ae039(s) {
        var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b').replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
        return '"' + escaped.replace(/"/g, '\\"') + '"';
    }
});
parcelRegister("cQgxe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95972ad8f9fd1e55$export$2e2bcd8739ae039);
    var $95972ad8f9fd1e55$var$pad = function pad(n) {
        return (n < 10 ? '0' : '') + n;
    };
    var $95972ad8f9fd1e55$var$_toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
        return d.toISOString();
    } : function _toISOString(d) {
        return d.getUTCFullYear() + '-' + $95972ad8f9fd1e55$var$pad(d.getUTCMonth() + 1) + '-' + $95972ad8f9fd1e55$var$pad(d.getUTCDate()) + 'T' + $95972ad8f9fd1e55$var$pad(d.getUTCHours()) + ':' + $95972ad8f9fd1e55$var$pad(d.getUTCMinutes()) + ':' + $95972ad8f9fd1e55$var$pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
    };
    var $95972ad8f9fd1e55$export$2e2bcd8739ae039 = $95972ad8f9fd1e55$var$_toISOString;
});
parcelRegister("7p8Aa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56418677377868ca$export$2e2bcd8739ae039);
    var $dmXsE;
    var $c9RLn;
    var $jVZZA;
    var $56418677377868ca$var$reject = (0, (0, parcelRequire("c9RLn")).default)(function reject(pred, filterable) {
        return (0, (0, parcelRequire("jVZZA")).default)((0, (0, parcelRequire("dmXsE")).default)(pred), filterable);
    });
    var $56418677377868ca$export$2e2bcd8739ae039 = $56418677377868ca$var$reject;
});
parcelRegister("dmXsE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9bbb74331699c5cb$export$2e2bcd8739ae039);
    function $9bbb74331699c5cb$export$2e2bcd8739ae039(f) {
        return function() {
            return !f.apply(this, arguments);
        };
    }
});
parcelRegister("jVZZA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8336d9095f62c57$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5DTpU;
    var $hMKEN;
    var $3jGND;
    var $42qCL;
    var $3q5E1;
    var $76p2G;
    var $e8336d9095f62c57$var$filter = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("5DTpU")).default)([
        'filter'
    ], (0, (0, parcelRequire("3q5E1")).default), function(pred, filterable) {
        return (0, (0, parcelRequire("3jGND")).default)(filterable) ? (0, (0, parcelRequire("42qCL")).default)(function(acc, key) {
            if (pred(filterable[key])) acc[key] = filterable[key];
            return acc;
        }, {}, (0, (0, parcelRequire("76p2G")).default)(filterable)) : (0, (0, parcelRequire("hMKEN")).default)(pred, filterable);
    }));
    var $e8336d9095f62c57$export$2e2bcd8739ae039 = $e8336d9095f62c57$var$filter;
});
parcelRegister("hMKEN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cf2b1c7e574a0f42$export$2e2bcd8739ae039);
    function $cf2b1c7e574a0f42$export$2e2bcd8739ae039(fn, list) {
        var idx = 0;
        var len = list.length;
        var result = [];
        while(idx < len){
            if (fn(list[idx])) result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    }
});
parcelRegister("3q5E1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27d82dadf498155a$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7D5kn;
    var $27d82dadf498155a$var$XFilter = function() {
        function XFilter(f, xf) {
            this.xf = xf;
            this.f = f;
        }
        XFilter.prototype['@@transducer/init'] = (0, (0, parcelRequire("7D5kn")).default).init;
        XFilter.prototype['@@transducer/result'] = (0, (0, parcelRequire("7D5kn")).default).result;
        XFilter.prototype['@@transducer/step'] = function(result, input) {
            return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
        };
        return XFilter;
    }();
    var $27d82dadf498155a$var$_xfilter = (0, (0, parcelRequire("c9RLn")).default)(function _xfilter(f, xf) {
        return new $27d82dadf498155a$var$XFilter(f, xf);
    });
    var $27d82dadf498155a$export$2e2bcd8739ae039 = $27d82dadf498155a$var$_xfilter;
});
parcelRegister("4wiYB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34a8dee67f345865$export$2e2bcd8739ae039);
    var $b3IvY;
    var $c9RLn;
    var $1fVsD;
    var $34a8dee67f345865$var$groupBy = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("b3IvY")).default)('groupBy', (0, (0, parcelRequire("1fVsD")).default)(function(acc, item) {
        if (acc == null) acc = [];
        acc.push(item);
        return acc;
    }, null)));
    var $34a8dee67f345865$export$2e2bcd8739ae039 = $34a8dee67f345865$var$groupBy;
});
parcelRegister("1fVsD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ea3c3b12cafe572$export$2e2bcd8739ae039);
    var $mfqvs;
    var $5DTpU;
    var $65NM6;
    var $42qCL;
    var $8rueU;
    var $0ea3c3b12cafe572$var$reduceBy = (0, (0, parcelRequire("mfqvs")).default)(4, [], (0, (0, parcelRequire("5DTpU")).default)([], (0, (0, parcelRequire("8rueU")).default), function reduceBy(valueFn, valueAcc, keyFn, list) {
        return (0, (0, parcelRequire("42qCL")).default)(function(acc, elt) {
            var key = keyFn(elt);
            acc[key] = valueFn((0, (0, parcelRequire("65NM6")).default)(key, acc) ? acc[key] : valueAcc, elt);
            return acc;
        }, {}, list);
    }));
    var $0ea3c3b12cafe572$export$2e2bcd8739ae039 = $0ea3c3b12cafe572$var$reduceBy;
});
parcelRegister("8rueU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62584d4b79c04b6f$export$2e2bcd8739ae039);
    var $mfqvs;
    var $65NM6;
    var $7D5kn;
    var $62584d4b79c04b6f$var$XReduceBy = function() {
        function XReduceBy(valueFn, valueAcc, keyFn, xf) {
            this.valueFn = valueFn;
            this.valueAcc = valueAcc;
            this.keyFn = keyFn;
            this.xf = xf;
            this.inputs = {};
        }
        XReduceBy.prototype['@@transducer/init'] = (0, (0, parcelRequire("7D5kn")).default).init;
        XReduceBy.prototype['@@transducer/result'] = function(result) {
            var key;
            for(key in this.inputs)if ((0, (0, parcelRequire("65NM6")).default)(key, this.inputs)) {
                result = this.xf['@@transducer/step'](result, this.inputs[key]);
                if (result['@@transducer/reduced']) {
                    result = result['@@transducer/value'];
                    break;
                }
            }
            this.inputs = null;
            return this.xf['@@transducer/result'](result);
        };
        XReduceBy.prototype['@@transducer/step'] = function(result, input) {
            var key = this.keyFn(input);
            this.inputs[key] = this.inputs[key] || [
                key,
                this.valueAcc
            ];
            this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
            return result;
        };
        return XReduceBy;
    }();
    var $62584d4b79c04b6f$var$_xreduceBy = (0, (0, parcelRequire("mfqvs")).default)(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
        return new $62584d4b79c04b6f$var$XReduceBy(valueFn, valueAcc, keyFn, xf);
    });
    var $62584d4b79c04b6f$export$2e2bcd8739ae039 = $62584d4b79c04b6f$var$_xreduceBy;
});
parcelRegister("ik0Qc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d56abf3b3d027057$export$2e2bcd8739ae039);
    var $kClQu;
    var $c9RLn;
    var $d56abf3b3d027057$var$merge = (0, (0, parcelRequire("c9RLn")).default)(function merge(l, r) {
        return (0, (0, parcelRequire("kClQu")).default)({}, l, r);
    });
    var $d56abf3b3d027057$export$2e2bcd8739ae039 = $d56abf3b3d027057$var$merge;
});
parcelRegister("kClQu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f0284d58a1af5e18$export$2e2bcd8739ae039);
    var $65NM6;
    function $f0284d58a1af5e18$var$_objectAssign(target) {
        if (target == null) throw new TypeError('Cannot convert undefined or null to object');
        var output = Object(target);
        var idx = 1;
        var length = arguments.length;
        while(idx < length){
            var source = arguments[idx];
            if (source != null) {
                for(var nextKey in source)if ((0, (0, parcelRequire("65NM6")).default)(nextKey, source)) output[nextKey] = source[nextKey];
            }
            idx += 1;
        }
        return output;
    }
    var $f0284d58a1af5e18$export$2e2bcd8739ae039 = typeof Object.assign === 'function' ? Object.assign : $f0284d58a1af5e18$var$_objectAssign;
});
parcelRegister("cDKdi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$933cf98f99d15e3d$export$2e2bcd8739ae039);
    var $IYMZh;
    var $ejhbF;
    var $933cf98f99d15e3d$var$mergeDeepWith = (0, (0, parcelRequire("IYMZh")).default)(function mergeDeepWith(fn, lObj, rObj) {
        return (0, (0, parcelRequire("ejhbF")).default)(function(k, lVal, rVal) {
            return fn(lVal, rVal);
        }, lObj, rObj);
    });
    var $933cf98f99d15e3d$export$2e2bcd8739ae039 = $933cf98f99d15e3d$var$mergeDeepWith;
});
parcelRegister("ejhbF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6b02c1002be5653$export$2e2bcd8739ae039);
    var $IYMZh;
    var $3jGND;
    var $5H7dz;
    var $a6b02c1002be5653$var$mergeDeepWithKey = (0, (0, parcelRequire("IYMZh")).default)(function mergeDeepWithKey(fn, lObj, rObj) {
        return (0, (0, parcelRequire("5H7dz")).default)(function(k, lVal, rVal) {
            if ((0, (0, parcelRequire("3jGND")).default)(lVal) && (0, (0, parcelRequire("3jGND")).default)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
            else return fn(k, lVal, rVal);
        }, lObj, rObj);
    });
    var $a6b02c1002be5653$export$2e2bcd8739ae039 = $a6b02c1002be5653$var$mergeDeepWithKey;
});
parcelRegister("5H7dz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4256913993b74729$export$2e2bcd8739ae039);
    var $IYMZh;
    var $65NM6;
    var $4256913993b74729$var$mergeWithKey = (0, (0, parcelRequire("IYMZh")).default)(function mergeWithKey(fn, l, r) {
        var result = {};
        var k;
        for(k in l)if ((0, (0, parcelRequire("65NM6")).default)(k, l)) result[k] = (0, (0, parcelRequire("65NM6")).default)(k, r) ? fn(k, l[k], r[k]) : l[k];
        for(k in r)if ((0, (0, parcelRequire("65NM6")).default)(k, r) && !(0, (0, parcelRequire("65NM6")).default)(k, result)) result[k] = r[k];
        return result;
    });
    var $4256913993b74729$export$2e2bcd8739ae039 = $4256913993b74729$var$mergeWithKey;
});
parcelRegister("iavfW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3a167f9dedc742c$export$2e2bcd8739ae039);
    var $c9RLn;
    var $d3a167f9dedc742c$var$omit = (0, (0, parcelRequire("c9RLn")).default)(function omit(names, obj) {
        var result = {};
        var index = {};
        var idx = 0;
        var len = names.length;
        while(idx < len){
            index[names[idx]] = 1;
            idx += 1;
        }
        for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
        return result;
    });
    var $d3a167f9dedc742c$export$2e2bcd8739ae039 = $d3a167f9dedc742c$var$omit;
});
parcelRegister("8r8wv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$624774def602e5df$export$2e2bcd8739ae039);
    var $jVZZA;
    var $8EeRK;
    var $7p8Aa;
    var $624774def602e5df$var$partition = (0, (0, parcelRequire("8EeRK")).default)([
        (0, (0, parcelRequire("jVZZA")).default),
        (0, (0, parcelRequire("7p8Aa")).default)
    ]);
    var $624774def602e5df$export$2e2bcd8739ae039 = $624774def602e5df$var$partition;
});
parcelRegister("8EeRK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64bd97393e32347f$export$2e2bcd8739ae039);
    var $ccUYa;
    var $dw2a4;
    var $64bd97393e32347f$var$juxt = (0, (0, parcelRequire("ccUYa")).default)(function juxt(fns) {
        return (0, (0, parcelRequire("dw2a4")).default)(function() {
            return Array.prototype.slice.call(arguments, 0);
        }, fns);
    });
    var $64bd97393e32347f$export$2e2bcd8739ae039 = $64bd97393e32347f$var$juxt;
});
parcelRegister("dw2a4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d6ff0bfe9b2155e$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7Mz99;
    var $9J1HQ;
    var $aTOU9;
    var $bEQF2;
    var $j0d94;
    var $9d6ff0bfe9b2155e$var$converge = (0, (0, parcelRequire("c9RLn")).default)(function converge(after, fns) {
        return (0, (0, parcelRequire("9J1HQ")).default)((0, (0, parcelRequire("j0d94")).default)((0, (0, parcelRequire("aTOU9")).default), 0, (0, (0, parcelRequire("bEQF2")).default)('length', fns)), function() {
            var args = arguments;
            var context = this;
            return after.apply(context, (0, (0, parcelRequire("7Mz99")).default)(function(fn) {
                return fn.apply(context, args);
            }, fns));
        });
    });
    var $9d6ff0bfe9b2155e$export$2e2bcd8739ae039 = $9d6ff0bfe9b2155e$var$converge;
});
parcelRegister("aTOU9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ef6870b3bab56bd$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7ef6870b3bab56bd$var$max = (0, (0, parcelRequire("c9RLn")).default)(function max(a, b) {
        return b > a ? b : a;
    });
    var $7ef6870b3bab56bd$export$2e2bcd8739ae039 = $7ef6870b3bab56bd$var$max;
});
parcelRegister("bEQF2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87cc47827c4003ad$export$2e2bcd8739ae039);
    var $c9RLn;
    var $4Rr1a;
    var $2rMKg;
    var $87cc47827c4003ad$var$pluck = (0, (0, parcelRequire("c9RLn")).default)(function pluck(p, list) {
        return (0, (0, parcelRequire("4Rr1a")).default)((0, (0, parcelRequire("2rMKg")).default)(p), list);
    });
    var $87cc47827c4003ad$export$2e2bcd8739ae039 = $87cc47827c4003ad$var$pluck;
});
parcelRegister("sqeVT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0556f853eeac6c66$export$2e2bcd8739ae039);
    var $IYMZh;
    var $8EB5I;
    var $0556f853eeac6c66$var$propEq = (0, (0, parcelRequire("IYMZh")).default)(function propEq(name, val, obj) {
        return (0, (0, parcelRequire("8EB5I")).default)(val, obj[name]);
    });
    var $0556f853eeac6c66$export$2e2bcd8739ae039 = $0556f853eeac6c66$var$propEq;
});
parcelRegister("cXTmV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9705f1c982cf1a8e$export$2e2bcd8739ae039);
    var $IYMZh;
    var $9705f1c982cf1a8e$var$remove = (0, (0, parcelRequire("IYMZh")).default)(function remove(start, count, list) {
        var result = Array.prototype.slice.call(list, 0);
        result.splice(start, count);
        return result;
    });
    var $9705f1c982cf1a8e$export$2e2bcd8739ae039 = $9705f1c982cf1a8e$var$remove;
});
parcelRegister("d8iBX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98fa75892e8f3953$export$2e2bcd8739ae039);
    var $83IGl;
    var $f5OZ1;
    var $98fa75892e8f3953$var$uniq = (0, (0, parcelRequire("f5OZ1")).default)((0, (0, parcelRequire("83IGl")).default));
    var $98fa75892e8f3953$export$2e2bcd8739ae039 = $98fa75892e8f3953$var$uniq;
});
parcelRegister("83IGl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5de14371485acfcb$export$2e2bcd8739ae039);
    var $ccUYa;
    var $btPXa;
    var $5de14371485acfcb$var$identity = (0, (0, parcelRequire("ccUYa")).default)((0, (0, parcelRequire("btPXa")).default));
    var $5de14371485acfcb$export$2e2bcd8739ae039 = $5de14371485acfcb$var$identity;
});
parcelRegister("btPXa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85bab4027e350fb9$export$2e2bcd8739ae039);
    function $85bab4027e350fb9$export$2e2bcd8739ae039(x) {
        return x;
    }
});
parcelRegister("f5OZ1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afcededcd0ec0ac8$export$2e2bcd8739ae039);
    var $8tYYg;
    var $c9RLn;
    var $afcededcd0ec0ac8$var$uniqBy = (0, (0, parcelRequire("c9RLn")).default)(function uniqBy(fn, list) {
        var set = new (0, (0, parcelRequire("8tYYg")).default)();
        var result = [];
        var idx = 0;
        var appliedItem, item;
        while(idx < list.length){
            item = list[idx];
            appliedItem = fn(item);
            if (set.add(appliedItem)) result.push(item);
            idx += 1;
        }
        return result;
    });
    var $afcededcd0ec0ac8$export$2e2bcd8739ae039 = $afcededcd0ec0ac8$var$uniqBy;
});
parcelRegister("8tYYg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62d053b558175705$export$2e2bcd8739ae039);
    var $4MZp5;
    var $62d053b558175705$var$_Set = function() {
        function _Set() {
            this._nativeSet = typeof Set === 'function' ? new Set() : null;
            this._items = {};
        }
        _Set.prototype.add = function(item) {
            return !$62d053b558175705$var$hasOrAdd(item, true, this);
        };
        _Set.prototype.has = function(item) {
            return $62d053b558175705$var$hasOrAdd(item, false, this);
        };
        return _Set;
    }();
    function $62d053b558175705$var$hasOrAdd(item, shouldAdd, set) {
        var type = typeof item;
        var prevSize, newSize;
        switch(type){
            case 'string':
            case 'number':
                if (item === 0 && 1 / item === -Infinity) {
                    if (set._items['-0']) return true;
                    else {
                        if (shouldAdd) set._items['-0'] = true;
                        return false;
                    }
                }
                if (set._nativeSet !== null) {
                    if (shouldAdd) {
                        prevSize = set._nativeSet.size;
                        set._nativeSet.add(item);
                        newSize = set._nativeSet.size;
                        return newSize === prevSize;
                    } else return set._nativeSet.has(item);
                } else {
                    if (!(type in set._items)) {
                        if (shouldAdd) {
                            set._items[type] = {};
                            set._items[type][item] = true;
                        }
                        return false;
                    } else if (item in set._items[type]) return true;
                    else {
                        if (shouldAdd) set._items[type][item] = true;
                        return false;
                    }
                }
            case 'boolean':
                if (type in set._items) {
                    var bIdx = item ? 1 : 0;
                    if (set._items[type][bIdx]) return true;
                    else {
                        if (shouldAdd) set._items[type][bIdx] = true;
                        return false;
                    }
                } else {
                    if (shouldAdd) set._items[type] = item ? [
                        false,
                        true
                    ] : [
                        true,
                        false
                    ];
                    return false;
                }
            case 'function':
                if (set._nativeSet !== null) {
                    if (shouldAdd) {
                        prevSize = set._nativeSet.size;
                        set._nativeSet.add(item);
                        newSize = set._nativeSet.size;
                        return newSize === prevSize;
                    } else return set._nativeSet.has(item);
                } else {
                    if (!(type in set._items)) {
                        if (shouldAdd) set._items[type] = [
                            item
                        ];
                        return false;
                    }
                    if (!(0, (0, parcelRequire("4MZp5")).default)(item, set._items[type])) {
                        if (shouldAdd) set._items[type].push(item);
                        return false;
                    }
                    return true;
                }
            case 'undefined':
                if (set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type] = true;
                    return false;
                }
            case 'object':
                if (item === null) {
                    if (!set._items['null']) {
                        if (shouldAdd) set._items['null'] = true;
                        return false;
                    }
                    return true;
                }
            default:
                type = Object.prototype.toString.call(item);
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, (0, parcelRequire("4MZp5")).default)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
        }
    }
    var $62d053b558175705$export$2e2bcd8739ae039 = $62d053b558175705$var$_Set;
});
parcelRegister("cBX85", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92e6cea102360efd$export$2e2bcd8739ae039);
    var $IYMZh;
    var $02IP9;
    var $UNzeF;
    var $92e6cea102360efd$var$update = (0, (0, parcelRequire("IYMZh")).default)(function update(idx, x, list) {
        return (0, (0, parcelRequire("02IP9")).default)(idx, (0, (0, parcelRequire("UNzeF")).default)(x), list);
    });
    var $92e6cea102360efd$export$2e2bcd8739ae039 = $92e6cea102360efd$var$update;
});
parcelRegister("02IP9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0082f52210890658$export$2e2bcd8739ae039);
    var $6VFfk;
    var $IYMZh;
    var $0082f52210890658$var$adjust = (0, (0, parcelRequire("IYMZh")).default)(function adjust(idx, fn, list) {
        if (idx >= list.length || idx < -list.length) return list;
        var start = idx < 0 ? list.length : 0;
        var _idx = start + idx;
        var _list = (0, (0, parcelRequire("6VFfk")).default)(list);
        _list[_idx] = fn(list[_idx]);
        return _list;
    });
    var $0082f52210890658$export$2e2bcd8739ae039 = $0082f52210890658$var$adjust;
});
parcelRegister("UNzeF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0aabae1d1dfa1b83$export$2e2bcd8739ae039);
    var $ccUYa;
    var $0aabae1d1dfa1b83$var$always = (0, (0, parcelRequire("ccUYa")).default)(function always(val) {
        return function() {
            return val;
        };
    });
    var $0aabae1d1dfa1b83$export$2e2bcd8739ae039 = $0aabae1d1dfa1b83$var$always;
});
parcelRegister("bjzU8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83cd51e7b4a1d95c$export$2e2bcd8739ae039);
    var $ccUYa;
    var $76p2G;
    var $83cd51e7b4a1d95c$var$values = (0, (0, parcelRequire("ccUYa")).default)(function values(obj) {
        var props = (0, (0, parcelRequire("76p2G")).default)(obj);
        var len = props.length;
        var vals = [];
        var idx = 0;
        while(idx < len){
            vals[idx] = obj[props[idx]];
            idx += 1;
        }
        return vals;
    });
    var $83cd51e7b4a1d95c$export$2e2bcd8739ae039 = $83cd51e7b4a1d95c$var$values;
});
parcelRegister("lDLaq", function(module, exports) {
    $parcel$export(module.exports, "kittens", ()=>$5cc93a7da6518ffa$export$9efba97d8fa872be);
    $parcel$export(module.exports, "puppies", ()=>$5cc93a7da6518ffa$export$7f1ab90efc5648fa);
    $parcel$export(module.exports, "issuePriorities", ()=>$5cc93a7da6518ffa$export$dea2e031cf462e5d);
    var $65Wvy = parcelRequire("65Wvy");
    var $btGqW = parcelRequire("btGqW");
    var $cM0Lz = parcelRequire("cM0Lz");
    var $c52RC = parcelRequire("c52RC");
    var $jZAu4 = parcelRequire("jZAu4");
    var $3v3kx = parcelRequire("3v3kx");
    var $eFgOQ = parcelRequire("eFgOQ");
    var $c9SpG = parcelRequire("c9SpG");
    var $4IOgZ = parcelRequire("4IOgZ");
    var $eEepn = parcelRequire("eEepn");
    var $e4xRU = parcelRequire("e4xRU");
    var $9tI7y = parcelRequire("9tI7y");
    var $hVpSm = parcelRequire("hVpSm");
    var $df8Ge = parcelRequire("df8Ge");
    var $dJmwR = parcelRequire("dJmwR");
    var $7nGYn = parcelRequire("7nGYn");
    var $jzMCS = parcelRequire("jzMCS");
    var $hQ4CM = parcelRequire("hQ4CM");
    var $51ftk = parcelRequire("51ftk");
    var $daxBS = parcelRequire("daxBS");
    var $cYaVp = parcelRequire("cYaVp");
    var $4JK1x = parcelRequire("4JK1x");
    var $5X4v5 = parcelRequire("5X4v5");
    var $68nRG = parcelRequire("68nRG");
    var $jquUi = parcelRequire("jquUi");
    var $lNyKE = parcelRequire("lNyKE");
    var $eqXHH = parcelRequire("eqXHH");
    var $hqNRq = parcelRequire("hqNRq");
    var $9kuE0 = parcelRequire("9kuE0");
    var $4ODLE = parcelRequire("4ODLE");
    var $iz7zt = parcelRequire("iz7zt");
    var $3wjaF = parcelRequire("3wjaF");
    var $i0a6d = parcelRequire("i0a6d");
    const $5cc93a7da6518ffa$export$4313e66a20025fb5 = {
        text: 'Sample Text to be used for a file download content'
    };
    const $5cc93a7da6518ffa$export$9efba97d8fa872be = {
        kitten1: ($parcel$interopDefault($jzMCS)),
        kitten2: ($parcel$interopDefault($hQ4CM)),
        kitten3: ($parcel$interopDefault($51ftk)),
        kitten4: ($parcel$interopDefault($daxBS)),
        kitten5: ($parcel$interopDefault($cYaVp))
    };
    const $5cc93a7da6518ffa$export$7f1ab90efc5648fa = {
        buckleyCaffeinating: ($parcel$interopDefault($4JK1x)),
        buckleyClassy: ($parcel$interopDefault($5X4v5)),
        buckleyCoding: ($parcel$interopDefault($68nRG)),
        buckleyListening: ($parcel$interopDefault($jquUi)),
        puppy1: ($parcel$interopDefault($4ODLE)),
        puppy2: ($parcel$interopDefault($iz7zt)),
        puppy3: ($parcel$interopDefault($3wjaF)),
        puppy4: ($parcel$interopDefault($i0a6d))
    };
    const $5cc93a7da6518ffa$export$581c23707211238b = {
        epic: ($parcel$interopDefault($eEepn)),
        task: ($parcel$interopDefault($df8Ge)),
        story: ($parcel$interopDefault($9tI7y)),
        bug: ($parcel$interopDefault($4IOgZ)),
        subtask: ($parcel$interopDefault($hVpSm)),
        idea: ($parcel$interopDefault($e4xRU))
    };
    const $5cc93a7da6518ffa$export$dea2e031cf462e5d = {
        lowest: ($parcel$interopDefault($jZAu4)),
        low: ($parcel$interopDefault($c52RC)),
        minor: ($parcel$interopDefault($c9SpG)),
        medium: ($parcel$interopDefault($eFgOQ)),
        high: ($parcel$interopDefault($cM0Lz)),
        major: ($parcel$interopDefault($3v3kx))
    };
    const $5cc93a7da6518ffa$export$31d6f2c3562ba09e = {
        unassigned: ($parcel$interopDefault($btGqW)),
        avatarLetterA: ($parcel$interopDefault($65Wvy))
    };
    const $5cc93a7da6518ffa$export$df03f54e09e486fa = {
        cat: (0, ($parcel$interopDefault($dJmwR))),
        cats: (0, ($parcel$interopDefault($7nGYn))),
        dog: (0, ($parcel$interopDefault($lNyKE))),
        pawColor: (0, ($parcel$interopDefault($hqNRq))),
        pawColorAlternate: (0, ($parcel$interopDefault($eqXHH))),
        paw: (0, ($parcel$interopDefault($9kuE0)))
    };
    const $5cc93a7da6518ffa$export$80dbe9c6c40b7d25 = {
        atlas: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABcVBMVEUAAAAmhP8mg/8AWs8FV9IMY90kgvwjgPwggP8JXtgJWtQTbOYYcOseffcgfPceevUOZN8NY94LYNoQcOcZcu0ZdfEJW9YIXtkQYM8gd+8dd/EZd/EQaOcSaeISa+UNY94OZN0bcOoYcewWcOwYcOcIaN8QaOMRaeQQcN8VbOUUbeYeePQiffkmhP8jgf0ggP8Wb+kYcOsUaOMRauQmg/8nhP8ffPcYcO8ac+8Zdu8QaN8lhf8Wb+odefQddvIZdO8VbeclhP4lgv4JXtomg/8khf8MZN4NZN8Zc+0LYdolhP8mg/8Ra+QTaeQnhP8UbOMJX9kNYt0ogP8kg/8YcOoYcesmhP8IYNcIYNclhf8nhf8gfPgdePMWcOkHXdYkhP8lgP8qhf8mhP8FW9QHXNgmhf8dd/IIXtUQUM8mhP8IXdclgv4if/kSauQYcesLYdsjgPwPZuAXcOoMYtwOZN4GWtQJX9kif/oZdO4kgvz///8vzF5RAAAAaXRSTlMAf4Awn+7vnyBvkJB/n/5/f98wIN9vcN4QIN9vIKCfv4AwoJ8gIEDuEKCP34Dv7xDfQEDe76/eIJ+PIDDPj1C/n8/fb98/z0+g34+fv1+/QK+fIECfgK9AIG/ur7+A73AwMM/vb5/fgBAJDM76AAAAAWJLR0R6ONWFagAAAAd0SU1FB+YHDAUeI4TSvdEAAADPSURBVBjTY2CAAEYmBiTAzMKamcnGzgHjc2ZxcWfn8PDy8UP4AoJCwiKiYuISklLSIL5MrgyDrBwDg7wCg2KeMFBASZlBJV+VgUFNXYNBUwsooK3DpKunD2QYGDIYGQPpAhPTzEwzaXMGC0sGq0KgQKY1g42tnX2Rg6OTvnMxUMDFlcHNnYFBxSMzs6TUEyjg5c3g4wuyzs/FPyAQSAfpBoeEggTCmMLLIkCMyKjoGJCES2ycM8Sp8Sbl7AmJSRXJKTDPBKUmZVampWcwYAMAeCgij+XGLr4AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDctMTJUMDU6MzA6MzUrMDA6MDAwjjdPAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTA3LTEyVDA1OjMwOjM1KzAwOjAwQdOP8wAAAABJRU5ErkJggg==',
        purpleLightning: 'data:image/svg+xml;base64,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',
        robot: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMjU2IDI1NiI+PGRlZnM+PHN0eWxlPi5jbHMtMSwuY2xzLTE5LC5jbHMtMjB7ZmlsbDpub25lO30uY2xzLTJ7ZmlsbDp1cmwoI05ld19HcmFkaWVudF9Td2F0Y2hfNSk7fS5jbHMtM3tmaWxsOnVybCgjbGluZWFyLWdyYWRpZW50KTt9LmNscy00e2ZpbGw6IzM0NDU2Mzt9LmNscy01e2NsaXAtcGF0aDp1cmwoI2NsaXAtcGF0aCk7fS5jbHMtNntjbGlwLXBhdGg6dXJsKCNjbGlwLXBhdGgtMik7fS5jbHMtN3tmaWxsOiNmZjk5MWY7fS5jbHMtOHtmaWxsOiNmZjhiMDA7fS5jbHMtOXtmaWxsOnVybCgjTmV3X0dyYWRpZW50X1N3YXRjaF81LTMpO30uY2xzLTEwe2ZpbGw6dXJsKCNOZXdfR3JhZGllbnRfU3dhdGNoXzUtNCk7fS5jbHMtMTF7Y2xpcC1wYXRoOnVybCgjY2xpcC1wYXRoLTMpO30uY2xzLTEye2ZpbGw6dXJsKCNsaW5lYXItZ3JhZGllbnQtMyk7fS5jbHMtMTN7ZmlsbDp1cmwoI2xpbmVhci1ncmFkaWVudC00KTt9LmNscy0xNHtmaWxsOnVybCgjbGluZWFyLWdyYWRpZW50LTUpO30uY2xzLTE1e2ZpbGw6dXJsKCNOZXdfR3JhZGllbnRfU3dhdGNoXzUtNSk7fS5jbHMtMTYsLmNscy0xN3tvcGFjaXR5OjAuNDU7fS5jbHMtMTZ7ZmlsbDp1cmwoI2xpbmVhci1ncmFkaWVudC02KTt9LmNscy0xN3tmaWxsOnVybCgjbGluZWFyLWdyYWRpZW50LTcpO30uY2xzLTE4e2ZpbGw6IzE3MmI0ZDt9LmNscy0xOSwuY2xzLTIwe3N0cm9rZTojZmZhYjAwO3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDozcHg7fS5jbHMtMTl7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7fTwvc3R5bGU+PGxpbmVhckdyYWRpZW50IGlkPSJOZXdfR3JhZGllbnRfU3dhdGNoXzUiIHgxPSI1MS45OCIgeTE9IjIyMy4xMiIgeDI9IjIwNC4wMiIgeTI9IjIyMy4xMiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZmOTkxZiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZmYzQwMCIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHgxPSIxMjgiIHkxPSIyMjguMDMiIHgyPSIxMjgiIHkyPSIxNjIuNDQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZjhiMDAiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZmM0MDAiLz48L2xpbmVhckdyYWRpZW50PjxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoIj48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEyOCIgY3k9IjEyOCIgcj0iMTI4Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aC0yIj48cGF0aCBpZD0iX0NsaXBwaW5nX1BhdGhfIiBkYXRhLW5hbWU9IiZsdDtDbGlwcGluZyBQYXRoJmd0OyIgY2xhc3M9ImNscy0yIiBkPSJNMTQ4LjQ0LDE5MC4yNEgxMDcuNTZBNTguMjgsNTguMjgsMCwwLDAsNTIsMjMxYTEyOCwxMjgsMCwwLDAsMTUyLDBBNTguMjgsNTguMjgsMCwwLDAsMTQ4LjQ0LDE5MC4yNFoiLz48L2NsaXBQYXRoPjxsaW5lYXJHcmFkaWVudCBpZD0iTmV3X0dyYWRpZW50X1N3YXRjaF81LTMiIHgxPSIxOTMuMzQiIHkxPSIxMzEuOTIiIHgyPSIxOTMuMzQiIHkyPSI5MS44OSIgeGxpbms6aHJlZj0iI05ld19HcmFkaWVudF9Td2F0Y2hfNSIvPjxsaW5lYXJHcmFkaWVudCBpZD0iTmV3X0dyYWRpZW50X1N3YXRjaF81LTQiIHgxPSI2Mi42NiIgeTE9IjEzMS45MiIgeDI9IjYyLjY2IiB5Mj0iOTEuODkiIHhsaW5rOmhyZWY9IiNOZXdfR3JhZGllbnRfU3dhdGNoXzUiLz48Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aC0zIj48cGF0aCBpZD0iX0NsaXBwaW5nX1BhdGhfMiIgZGF0YS1uYW1lPSImbHQ7Q2xpcHBpbmcgUGF0aCZndDsiIGNsYXNzPSJjbHMtMyIgZD0iTTEyOCwyMjhoMGEyMSwyMSwwLDAsMS0yMS0yMVYxNjIuNDRoNDJWMjA3QTIxLDIxLDAsMCwxLDEyOCwyMjhaIi8+PC9jbGlwUGF0aD48bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudC0zIiB5MT0iMjE4LjY5IiB5Mj0iMTUzLjA5IiB4bGluazpocmVmPSIjbGluZWFyLWdyYWRpZW50Ii8+PGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQtNCIgeTE9IjIwOS4zNCIgeTI9IjE0My43NSIgeGxpbms6aHJlZj0iI2xpbmVhci1ncmFkaWVudCIvPjxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50LTUiIHkxPSIyMDAiIHkyPSIxMzQuNDEiIHhsaW5rOmhyZWY9IiNsaW5lYXItZ3JhZGllbnQiLz48bGluZWFyR3JhZGllbnQgaWQ9Ik5ld19HcmFkaWVudF9Td2F0Y2hfNS01IiB4MT0iNzAuMDkiIHkxPSIxNzIuOTIiIHgyPSIxODUuNzMiIHkyPSI1Ny4yOSIgeGxpbms6aHJlZj0iI05ld19HcmFkaWVudF9Td2F0Y2hfNSIvPjxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50LTYiIHgxPSI3OC42NyIgeTE9IjExOS40MiIgeDI9IjExNS41IiB5Mj0iODIuNTkiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3Ljg3IDMuNjkpIHJvdGF0ZSg4OS44NykiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmM0MDAiLz48c3RvcCBvZmZzZXQ9IjAuMDIiIHN0b3AtY29sb3I9IiNmZmM3MGQiLz48c3RvcCBvZmZzZXQ9IjAuMDgiIHN0b3AtY29sb3I9IiNmZmQxMzQiLz48c3RvcCBvZmZzZXQ9IjAuMTUiIHN0b3AtY29sb3I9IiNmZmQ5NTYiLz48c3RvcCBvZmZzZXQ9IjAuMjIiIHN0b3AtY29sb3I9IiNmZmUwNzMiLz48c3RvcCBvZmZzZXQ9IjAuMyIgc3RvcC1jb2xvcj0iI2ZmZTY4YSIvPjxzdG9wIG9mZnNldD0iMC40IiBzdG9wLWNvbG9yPSIjZmZlYjljIi8+PHN0b3Agb2Zmc2V0PSIwLjUxIiBzdG9wLWNvbG9yPSIjZmZlZWE5Ii8+PHN0b3Agb2Zmc2V0PSIwLjY2IiBzdG9wLWNvbG9yPSIjZmZlZmIwIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmZmMGIyIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudC03IiB4MT0iMTQwLjUiIHkxPSIxMTkuNjYiIHgyPSIxNzcuMzMiIHkyPSI4Mi44NCIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgyNTkuOCAtNTcuOSkgcm90YXRlKDg5Ljg3KSIgeGxpbms6aHJlZj0iI2xpbmVhci1ncmFkaWVudC02Ii8+PC9kZWZzPjx0aXRsZT5NZWVwbGVzLUJlZXAgQm9vcDwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9Ik1lZXBsZXMiPjxjaXJjbGUgY2xhc3M9ImNscy00IiBjeD0iMTI4IiBjeT0iMTI4IiByPSIxMjgiLz48ZyBjbGFzcz0iY2xzLTUiPjxwYXRoIGlkPSJfQ2xpcHBpbmdfUGF0aF8zIiBkYXRhLW5hbWU9IiZsdDtDbGlwcGluZyBQYXRoJmd0OyIgY2xhc3M9ImNscy0yIiBkPSJNMTQ4LjQ0LDE5MC4yNEgxMDcuNTZBNTguMjgsNTguMjgsMCwwLDAsNTIsMjMxYTEyOCwxMjgsMCwwLDAsMTUyLDBBNTguMjgsNTguMjgsMCwwLDAsMTQ4LjQ0LDE5MC4yNFoiLz48ZyBjbGFzcz0iY2xzLTYiPjxwYXRoIGNsYXNzPSJjbHMtNyIgZD0iTTEyOCwyMjcuOWEzOS42NywzOS42NywwLDEsMSwwLTc5LjM0WiIvPjwvZz48Y2lyY2xlIGNsYXNzPSJjbHMtOCIgY3g9IjgwLjk4IiBjeT0iMjMxLjI1IiByPSI0LjQzIi8+PGNpcmNsZSBjbGFzcz0iY2xzLTgiIGN4PSI5NS4zOCIgY3k9IjIzMS4yNSIgcj0iNC40MyIvPjxjaXJjbGUgY2xhc3M9ImNscy05IiBjeD0iMTkzLjM0IiBjeT0iMTExLjkiIHI9IjIwLjAxIi8+PGNpcmNsZSBjbGFzcz0iY2xzLTEwIiBjeD0iNjIuNjYiIGN5PSIxMTEuOSIgcj0iMjAuMDEiLz48cGF0aCBpZD0iX0NsaXBwaW5nX1BhdGhfNCIgZGF0YS1uYW1lPSImbHQ7Q2xpcHBpbmcgUGF0aCZndDsiIGNsYXNzPSJjbHMtMyIgZD0iTTEyOCwyMjhoMGEyMSwyMSwwLDAsMS0yMS0yMVYxNjIuNDRoNDJWMjA3QTIxLDIxLDAsMCwxLDEyOCwyMjhaIi8+PGcgY2xhc3M9ImNscy0xMSI+PHBhdGggY2xhc3M9ImNscy0xMiIgZD0iTTEyOCwyMTguNjloMGEyMSwyMSwwLDAsMS0yMS0yMVYxNTMuMDloNDJ2NDQuNTlBMjEsMjEsMCwwLDEsMTI4LDIxOC42OVoiLz48cGF0aCBjbGFzcz0iY2xzLTEzIiBkPSJNMTI4LDIwOS4zNGgwYTIxLDIxLDAsMCwxLTIxLTIxVjE0My43NWg0MnY0NC41OUEyMSwyMSwwLDAsMSwxMjgsMjA5LjM0WiIvPjxwYXRoIGNsYXNzPSJjbHMtMTQiIGQ9Ik0xMjgsMjAwaDBhMjEsMjEsMCwwLDEtMjEtMjFWMTM0LjQxaDQyVjE3OUEyMSwyMSwwLDAsMSwxMjgsMjAwWiIvPjxwYXRoIGNsYXNzPSJjbHMtOCIgZD0iTTEyOCwxOTAuNjZoMGEyMSwyMSwwLDAsMS0yMS0yMVYxMjUuMDZoNDJ2NDQuNTlBMjEsMjEsMCwwLDEsMTI4LDE5MC42NloiLz48cGF0aCBjbGFzcz0iY2xzLTgiIGQ9Ik0xMjgsMTgxLjMxaDBhMjEsMjEsMCwwLDEtMjEtMjFWMTE1LjcyaDQydjQ0LjU5QTIxLDIxLDAsMCwxLDEyOCwxODEuMzFaIi8+PC9nPjxwYXRoIGNsYXNzPSJjbHMtMTUiIGQ9Ik02MS42NCw5M2E2Ni4zNiw2Ni4zNiwwLDAsMSw2Ny4yNC02Ni4zNWMzNi40Ny40Nyw2NS40OCwzMC44Nyw2NS40OCw2Ny4zNHY2Mi4yYTE5LjksMTkuOSwwLDAsMS0xOS45LDE5LjlIODEuNTRhMTkuOSwxOS45LDAsMCwxLTE5LjktMTkuOVoiLz48ZWxsaXBzZSBjbGFzcz0iY2xzLTE2IiBjeD0iOTcuMDgiIGN5PSIxMDEiIHJ4PSIyNi4wNyIgcnk9IjI2LjAxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNC4xNCAxOTcuODYpIHJvdGF0ZSgtODkuODcpIi8+PGVsbGlwc2UgY2xhc3M9ImNscy0xNyIgY3g9IjE1OC45MiIgY3k9IjEwMS4yNSIgcng9IjI2LjA3IiByeT0iMjYuMDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU3LjMxIDI1OS45Mykgcm90YXRlKC04OS44NykiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMTgiIGN4PSIxNTguOTEiIGN5PSIxMDEuMjUiIHI9IjUuNDEiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMTgiIGN4PSI5Ny4wOCIgY3k9IjEwMSIgcj0iNS40MSIvPjxwYXRoIGNsYXNzPSJjbHMtMTkiIGQ9Ik04My42NiwxMDFhMTMuNDMsMTMuNDMsMCwxLDEsMjYuODYuMDYiLz48cGF0aCBjbGFzcz0iY2xzLTE5IiBkPSJNMTQ1LjQ5LDEwMWExMy40MywxMy40MywwLDEsMSwyNi44Ni4wNiIvPjwvZz48cGF0aCBjbGFzcz0iY2xzLTgiIGQ9Ik0xMTUuNjMsNDFjMCw4Ljk1LDUuNTQsMTYuMiwxMi4zNywxNi4yUzE0MC4zNyw1MCwxNDAuMzcsNDFWMjNhNS44LDUuOCwwLDAsMC01LjgtNS44SDEyMS40M2E1LjgsNS44LDAsMCwwLTUuOCw1LjhaIi8+PGxpbmUgY2xhc3M9ImNscy0yMCIgeDE9IjU3LjA4IiB5MT0iMTExLjYiIHgyPSIyOC4zMiIgeTI9IjExMS42Ii8+PGxpbmUgY2xhc3M9ImNscy0yMCIgeDE9IjIyNy44OSIgeTE9IjExMS42IiB4Mj0iMTk5LjEyIiB5Mj0iMTExLjYiLz48Y2lyY2xlIGNsYXNzPSJjbHMtOCIgY3g9IjI4LjMyIiBjeT0iMTExLjYiIHI9IjQuODEiLz48Y2lyY2xlIGNsYXNzPSJjbHMtOCIgY3g9IjIyNy44OSIgY3k9IjExMS42IiByPSI0LjgxIi8+PHBhdGggY2xhc3M9ImNscy04IiBkPSJNMTI4LDE1My4wOWE1MS45Myw1MS45MywwLDAsMS0xNi4yMi0yLjYyLDUsNSwwLDAsMS0yLjg5LTYuNzVoMEE1LDUsMCwwLDEsMTE1LDE0MWE0MS44NSw0MS44NSwwLDAsMCwxMywyLjFoLjE2QTQxLjg1LDQxLjg1LDAsMCwwLDE0MSwxNDFhNSw1LDAsMCwxLDYuMDksMi42NmwwLC4wNWE1LDUsMCwwLDEtMy4wNSw2LjgsNTEuOTEsNTEuOTEsMCwwLDEtMTUuODUsMi41N1oiLz48L2c+PC9nPjwvc3ZnPg==',
        breadSlices: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIzMnB4IiBoZWlnaHQ9IjMycHgiIHZpZXdCb3g9IjAgMCAzMiAzMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5ib2FyZF9hdmF0YXI8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+ICAgICAgICA8ZyBpZD0iYm9hcmRfYXZhdGFyIj4gICAgICAgICAgICA8cmVjdCBpZD0iaXNzdWUtdHlwZV9pY29uIiBmaWxsPSIjMkU4N0ZCIiB4PSIwIiB5PSIwIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHJ4PSIyIj48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iI0ZGRkZGRiIgeD0iNyIgeT0iOCIgd2lkdGg9IjQuOTA5MDkwOTEiIGhlaWdodD0iMTYiIHJ4PSIxIj48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1Db3B5IiBmaWxsPSIjRkZGRkZGIiB4PSIxMy41NDU0NTQ1IiB5PSI4IiB3aWR0aD0iNC45MDkwOTA5MSIgaGVpZ2h0PSIxNiIgcng9IjEiPjwvcmVjdD4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLUNvcHktMiIgZmlsbD0iI0ZGRkZGRiIgeD0iMjAuMDkwOTA5MSIgeT0iOCIgd2lkdGg9IjQuOTA5MDkwOTEiIGhlaWdodD0iMTYiIHJ4PSIxIj48L3JlY3Q+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=',
        target: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAVFBMVEUAAAD/ZjP/YED/VTn/XS7/Tif/Wi3/WC7/VjH/WDD/VzD/VjD/VTH/Vy//VjD/Vy//Vi//VTH/VjD/VjD/VjH/VjD/VzD/VjD/Vi//VjD/VjD///9mBMtqAAAAGnRSTlMABQgJCw0RPT5AcHR+gYaHrK2ur7K14Obn6jjiiqUAAAABYktHRBsCYNSkAAAAZklEQVQoz7XSSQ6AIAxA0dYBcCxOINz/oCYqm0ITN/5lX0KYAMnFLEcIFIvN4MvgIQr9AlYrZZYcergbOFh42xjoBB2DJkH7FcSl9gQH3+74zKfSAavarP9eIodTelrxMyCFfBwIL2ppMdyhdcybAAAAAElFTkSuQmCC',
        upArrow: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTWVkaXVtIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDY0IDY0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2NCA2NCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBmaWxsPSIjRUE3RDI0IiBkPSJNMzIsNTUuOTYzTDMyLDU1Ljk2M2MyLjIsMCw0LTEuOCw0LTRWMTIuMDM3YzAtMi4yLTEuOC00LTQtNGgwYy0yLjIsMC00LDEuOC00LDR2MzkuOTI2DQoJQzI4LDU0LjE2MywyOS44LDU1Ljk2MywzMiw1NS45NjN6Ii8+DQo8cGF0aCBmaWxsPSIjRUE3RDI0IiBkPSJNNDkuNTkzLDI5LjYzTDQ5LjU5MywyOS42M2MxLjU1Ni0xLjU1NiwxLjU1Ni00LjEwMSwwLTUuNjU3TDM0LjgyNCw5LjIwNGMtMS41NTYtMS41NTYtNC4xMDEtMS41NTYtNS42NTcsMA0KCWwwLDBjLTEuNTU2LDEuNTU2LTEuNTU2LDQuMTAxLDAsNS42NTdMNDMuOTM2LDI5LjYzQzQ1LjQ5MSwzMS4xODUsNDguMDM3LDMxLjE4NSw0OS41OTMsMjkuNjN6Ii8+DQo8cGF0aCBmaWxsPSIjRUE3RDI0IiBkPSJNMTQuMjQxLDI5LjYzTDE0LjI0MSwyOS42M2MtMS41NTYtMS41NTYtMS41NTYtNC4xMDEsMC01LjY1N0wyOS4wMSw5LjIwNGMxLjU1Ni0xLjU1Niw0LjEwMS0xLjU1Niw1LjY1NywwDQoJbDAsMGMxLjU1NiwxLjU1NiwxLjU1Niw0LjEwMSwwLDUuNjU3TDE5Ljg5NywyOS42M0MxOC4zNDIsMzEuMTg1LDE1Ljc5NiwzMS4xODUsMTQuMjQxLDI5LjYzeiIvPg0KPC9zdmc+DQo=',
        greyTarget: 'data:image/png;base64,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',
        hand: 'data:image/png;base64,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',
        angel: 'data:image/png;base64,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',
        person: 'data:image/svg+xml;base64,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'
    };
    const $5cc93a7da6518ffa$export$ad200f2ca1a7d990 = {
        jiraNavRefresh: 'data:image/png;base64,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'
    };
});
parcelRegister("65Wvy", function(module, exports) {
    module.exports = new URL("avatar-letter-a.a574ddda.png", import.meta.url).toString();
});
parcelRegister("btGqW", function(module, exports) {
    module.exports = new URL("unassigned.4cbf42ba.svg", import.meta.url).toString();
});
parcelRegister("cM0Lz", function(module, exports) {
    module.exports = new URL("high.19a3b29d.svg", import.meta.url).toString();
});
parcelRegister("c52RC", function(module, exports) {
    module.exports = new URL("low.8e8e01f6.svg", import.meta.url).toString();
});
parcelRegister("jZAu4", function(module, exports) {
    module.exports = new URL("lowest.e96804a1.svg", import.meta.url).toString();
});
parcelRegister("3v3kx", function(module, exports) {
    module.exports = new URL("major.b6ad486f.svg", import.meta.url).toString();
});
parcelRegister("eFgOQ", function(module, exports) {
    module.exports = new URL("medium.825ac8e1.svg", import.meta.url).toString();
});
parcelRegister("c9SpG", function(module, exports) {
    module.exports = new URL("minor.45ace9ea.svg", import.meta.url).toString();
});
parcelRegister("4IOgZ", function(module, exports) {
    module.exports = new URL("bug.ee818e22.svg", import.meta.url).toString();
});
parcelRegister("eEepn", function(module, exports) {
    module.exports = new URL("epic.51b289d0.svg", import.meta.url).toString();
});
parcelRegister("e4xRU", function(module, exports) {
    module.exports = new URL("idea.877bae0a.svg", import.meta.url).toString();
});
parcelRegister("9tI7y", function(module, exports) {
    module.exports = new URL("story.c031d198.svg", import.meta.url).toString();
});
parcelRegister("hVpSm", function(module, exports) {
    module.exports = new URL("subtask.db935aa5.svg", import.meta.url).toString();
});
parcelRegister("df8Ge", function(module, exports) {
    module.exports = new URL("task.ce7fec8e.svg", import.meta.url).toString();
});
parcelRegister("dJmwR", function(module, exports) {
    module.exports = new URL("cat-animal-icon.2cb08d7b.svg", import.meta.url).toString();
});
parcelRegister("7nGYn", function(module, exports) {
    module.exports = new URL("cats-icon.8c9e32fe.svg", import.meta.url).toString();
});
parcelRegister("jzMCS", function(module, exports) {
    module.exports = new URL("kitten1.0108c4aa.png", import.meta.url).toString();
});
parcelRegister("hQ4CM", function(module, exports) {
    module.exports = new URL("kitten2.05362e79.png", import.meta.url).toString();
});
parcelRegister("51ftk", function(module, exports) {
    module.exports = new URL("kitten3.11981e32.png", import.meta.url).toString();
});
parcelRegister("daxBS", function(module, exports) {
    module.exports = new URL("kitten4.1765b4f7.png", import.meta.url).toString();
});
parcelRegister("cYaVp", function(module, exports) {
    module.exports = new URL("kitten5.e9f78ddc.png", import.meta.url).toString();
});
parcelRegister("4JK1x", function(module, exports) {
    module.exports = new URL("buckley-caffeinating.74873d4e.png", import.meta.url).toString();
});
parcelRegister("5X4v5", function(module, exports) {
    module.exports = new URL("buckley-classy.abfdadec.png", import.meta.url).toString();
});
parcelRegister("68nRG", function(module, exports) {
    module.exports = new URL("buckley-coding.844c6201.png", import.meta.url).toString();
});
parcelRegister("jquUi", function(module, exports) {
    module.exports = new URL("buckley-listening.1dbf5142.png", import.meta.url).toString();
});
parcelRegister("lNyKE", function(module, exports) {
    module.exports = new URL("dog-icon.1c9050b4.svg", import.meta.url).toString();
});
parcelRegister("eqXHH", function(module, exports) {
    module.exports = new URL("paw-color-icon-2.47f7229a.svg", import.meta.url).toString();
});
parcelRegister("hqNRq", function(module, exports) {
    module.exports = new URL("paw-color-icon.aa5e7c89.svg", import.meta.url).toString();
});
parcelRegister("9kuE0", function(module, exports) {
    module.exports = new URL("paw-icon.216b0259.svg", import.meta.url).toString();
});
parcelRegister("4ODLE", function(module, exports) {
    module.exports = new URL("puppy1.c99cbd16.png", import.meta.url).toString();
});
parcelRegister("iz7zt", function(module, exports) {
    module.exports = new URL("puppy2.28a0168d.png", import.meta.url).toString();
});
parcelRegister("3wjaF", function(module, exports) {
    module.exports = new URL("puppy3.b1a61ea7.png", import.meta.url).toString();
});
parcelRegister("i0a6d", function(module, exports) {
    module.exports = new URL("puppy4.c55fdff0.png", import.meta.url).toString();
});
parcelRegister("4ENQh", function(module, exports) {
    $parcel$export(module.exports, "SPA_APP_NAME", ()=>$7022219d2d87e7c6$export$3121747bb6e73d1c);
    $parcel$export(module.exports, "TTI_SLO", ()=>$7022219d2d87e7c6$export$748427380a6493b0);
    $parcel$export(module.exports, "ARJ_EARLY_PRELOAD_PREFIX", ()=>$7022219d2d87e7c6$export$1b60784a15ad91a9);
    $parcel$export(module.exports, "monitor", ()=>$7022219d2d87e7c6$export$ec5b303098bc4b7f);
    var $99gkn;
    var $aOr3t;
    var $bFU4G;
    var $21pfT;
    var $dGrdR;
    var $4dRjY;
    var $2SVPM;
    var $fdim1;
    var $6NgSc;
    const $7022219d2d87e7c6$export$3121747bb6e73d1c = 'advanced-roadmaps';
    const $7022219d2d87e7c6$export$748427380a6493b0 = 4000;
    const $7022219d2d87e7c6$export$2a97570d48bcd64d = 1000;
    const $7022219d2d87e7c6$export$1b60784a15ad91a9 = 'jira.fe-spa.advanced-roadmaps.early-preload';
    const $7022219d2d87e7c6$var$INTERACTION_PREFIX = $7022219d2d87e7c6$export$3121747bb6e73d1c;
    const $7022219d2d87e7c6$var$ARJ_EARLY_PRELOAD = 'arj-early-preload';
    const $7022219d2d87e7c6$var$PRODUCT_PREFIX = 'jira.fe-spa.advanced-roadmaps.product';
    const $7022219d2d87e7c6$var$taskKeyToInteractionKey = (taskKey)=>`${$7022219d2d87e7c6$var$INTERACTION_PREFIX}.${taskKey.toLowerCase()}`;
    const $7022219d2d87e7c6$export$4726438eb4db5074 = '__initial_render__';
    const $7022219d2d87e7c6$var$MAX_ENTRIES_PER_MARK = 5;
    class $7022219d2d87e7c6$export$3de16b9a4e4a99f4 {
        constructor(options){
            this.featureFlags = [];
            this.profiles = new Map();
            this.timings = [];
            this.tasks = new Map();
            this.contextualAnalyticsData = {
                planId: '',
                scenarioId: ''
            };
            this.browserMetrics = (options || {}).browserMetrics || (0, (0, parcelRequire("21pfT")).browserMetrics);
            this.metrics = (options || {}).metrics || (0, (0, parcelRequire("dGrdR")).metrics);
            this.resetInitialRenderTask();
            (0, (0, parcelRequire("fdim1")).injectCallbackIntoGetBooleanFeatureFlag)((flag)=>{
                this.registerBooleanFeatureFlag(flag);
            });
        }
        initializeContextualAnalyticsData(data) {
            this.contextualAnalyticsData = {
                ...data
            };
        }
        addContextualAnalyticsData(newData) {
            this.contextualAnalyticsData = {
                ...this.contextualAnalyticsData,
                ...newData
            };
        }
        finishInitialRender(options) {
            const task = this.tasks.get($7022219d2d87e7c6$export$4726438eb4db5074);
            if (!task) return;
            this.recordEarlyPreloadTimings();
            const bm3Marks = {};
            this.timings.forEach(({ key: key, startTime: startTime, endTime: endTime })=>{
                bm3Marks[`${key}:start`] = startTime;
                bm3Marks[`${key}:end`] = endTime;
            });
            const bm3CustomTimings = this.timings.map(({ key: key })=>({
                    key: key,
                    startMark: `${key}:start`,
                    endMark: `${key}:end`
                }));
            (0, (0, parcelRequire("aOr3t")).addBM3TimingsToUFO)(bm3Marks, bm3CustomTimings);
            (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
            const { scalingFactors: scalingFactors } = options;
            const customData = this.collectCustomData({
                scalingFactors: scalingFactors
            }, task.executionTimes, task.marks);
            (0, (0, parcelRequire("99gkn")).addUFOCustomData)(customData);
            (0, (0, parcelRequire("bFU4G")).addApdexToAll)({
                key: 'plans',
                stopTime: performance.now()
            });
            this.resetInitialRenderTask();
        }
        startTask(taskKey, options, customStartTime) {
            if (this.tasks.has(taskKey)) return;
            const interaction = this.metrics.custom({
                key: $7022219d2d87e7c6$var$taskKeyToInteractionKey(taskKey),
                featureFlags: this.featureFlags,
                slo: {
                    threshold: $7022219d2d87e7c6$export$2a97570d48bcd64d
                }
            });
            customStartTime !== undefined ? interaction.start({
                startTime: customStartTime
            }) : interaction.start();
            const justOptions = options || {
                scalingFactors: {}
            };
            const executionTimes = new Map();
            const marks = new Set();
            const task = {
                interaction: interaction,
                options: justOptions,
                executionTimes: executionTimes,
                marks: marks
            };
            this.tasks.set(taskKey, task);
            this.setMark(`${taskKey}_start`);
        }
        finishTask(taskKey, options) {
            const task = this.tasks.get(taskKey);
            if (!task) return;
            const { sloSuccessThreshold: sloSuccessThreshold = $7022219d2d87e7c6$export$2a97570d48bcd64d, scalingFactors: scalingFactors } = options || {};
            if (typeof task.interaction.config !== 'undefined') task.interaction.config.slo.threshold = sloSuccessThreshold;
            if (scalingFactors) Object.assign(task.options.scalingFactors, scalingFactors);
            const customData = this.collectCustomData(task.options, task.executionTimes, task.marks);
            task.interaction.stop({
                customData: customData
            });
            this.tasks.delete(taskKey);
            this.setMark(`${taskKey}_end`);
        }
        timeTask(task, taskKey, options) {
            return (...args)=>{
                this.startTask(taskKey, options);
                const result = task(...args);
                this.finishTask(taskKey);
                return result;
            };
        }
        timeFunction(fn, fnKey) {
            return (...args)=>{
                this.startProfile(fnKey);
                const result = fn(...args);
                this.finishProfile(fnKey);
                return result;
            };
        }
        startProfile(profileKey) {
            if (this.profiles.has(profileKey)) return;
            this.profiles.set(profileKey, {
                start: performance.now()
            });
        }
        finishProfile(profileKey) {
            const profile = this.profiles.get(profileKey);
            if (!profile) return;
            this.recordProfile(profileKey, profile);
            this.profiles.delete(profileKey);
        }
        startProfileConcurrent(profileKey) {
            const profile = {
                start: performance.now()
            };
            return ()=>this.recordProfile(profileKey, profile);
        }
        registerBooleanFeatureFlag(flag) {
            this.featureFlags.push(flag);
        }
        setMark(markKey) {
            if (!performance.mark) return;
            performance.mark(markKey);
            for (const { marks: marks } of this.tasks.values())marks.add(markKey);
        }
        resetInitialRenderTask() {
            const executionTimes = new Map();
            const marks = new Set();
            const task = {
                interaction: {},
                options: {
                    scalingFactors: {}
                },
                executionTimes: executionTimes,
                marks: marks
            };
            this.tasks.set($7022219d2d87e7c6$export$4726438eb4db5074, task);
        }
        recordProfile(profileKey, profile) {
            const profileEnd = performance.now();
            const measurement = {
                start: profile.start,
                end: profileEnd
            };
            for (const { executionTimes: executionTimes } of this.tasks.values()){
                const times = executionTimes.get(profileKey);
                if (times) times.push(measurement);
                else executionTimes.set(profileKey, [
                    measurement
                ]);
            }
        }
        recordCustomProfile(profileKey, customProfile) {
            const measurement = {
                ...customProfile
            };
            for (const { executionTimes: executionTimes } of this.tasks.values()){
                const times = executionTimes.get(profileKey);
                if (times) times.push(measurement);
                else executionTimes.set(profileKey, [
                    measurement
                ]);
            }
        }
        recordEarlyPreloadTimings() {
            const resources = [
                '',
                'backlog',
                'info-metadata',
                'initial-checks-for-report',
                'plan-info-for-report'
            ];
            this.timings.push(...resources.map((resource)=>{
                const start = Math.floor((0, (0, parcelRequire("6NgSc")).extractStartTime)(`${$7022219d2d87e7c6$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:start`));
                const end = Math.ceil((0, (0, parcelRequire("6NgSc")).extractStartTime)(`${$7022219d2d87e7c6$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:end`));
                return {
                    key: resource ? `${$7022219d2d87e7c6$var$ARJ_EARLY_PRELOAD}/${resource}` : $7022219d2d87e7c6$var$ARJ_EARLY_PRELOAD,
                    startTime: start,
                    endTime: end
                };
            }));
        }
        recordProductTimings() {
            const resources = [
                'parse-json'
            ];
            this.timings.push(...resources.map((resource)=>{
                const start = Math.floor((0, (0, parcelRequire("6NgSc")).extractStartTime)(`${$7022219d2d87e7c6$var$PRODUCT_PREFIX}.${resource}:start`));
                const end = Math.ceil((0, (0, parcelRequire("6NgSc")).extractStartTime)(`${$7022219d2d87e7c6$var$PRODUCT_PREFIX}.${resource}:end`));
                return {
                    key: `product/${resource}`,
                    startTime: start,
                    endTime: end
                };
            }));
        }
        collectCustomData(options, executionTimes, marks) {
            const pageStart = this.pageStart();
            const report = {
                ...this.contextualAnalyticsData,
                scalingFactors: {},
                executionTimes: {},
                marks: {}
            };
            const scalingFactors = options.scalingFactors || {};
            for (const factor of Object.keys(scalingFactors))report.scalingFactors[factor] = scalingFactors[factor];
            for (const [fnKey, allTimes] of executionTimes){
                const times = allTimes.filter(({ start: start })=>start >= pageStart);
                const n = times.length;
                if (n > 0) {
                    const start = times[0].start;
                    let lastEnd = start;
                    let min = Infinity;
                    let max = -Infinity;
                    let sum = 0;
                    for (const { start: start, end: end } of times){
                        const duration = end - start;
                        sum += duration;
                        min = Math.min(min, duration);
                        max = Math.max(max, duration);
                        lastEnd = Math.max(lastEnd, end);
                    }
                    const mean = sum / n;
                    let devSum = 0;
                    for (const { start: start, end: end } of times){
                        const dev = end - start - mean;
                        devSum += dev * dev;
                    }
                    const stddev = n > 1 ? Math.sqrt(devSum / (n - 1)) : 0;
                    report.executionTimes[fnKey] = {
                        start: start - pageStart,
                        end: lastEnd - pageStart,
                        min: min,
                        max: max,
                        mean: mean,
                        stddev: stddev,
                        count: n,
                        sum: sum
                    };
                }
            }
            if (performance.getEntriesByName) for (const mark of marks){
                let i = 0;
                for (const m of performance.getEntriesByName(mark) || []){
                    if (i > $7022219d2d87e7c6$var$MAX_ENTRIES_PER_MARK) break;
                    const start = m.startTime - pageStart;
                    if (start >= 0) {
                        report.marks[`${mark}_${i}`] = start;
                        i++;
                    }
                }
            }
            return report;
        }
        pageStart() {
            return this.browserMetrics.getPageLoadMetric()?.startTime || 0;
        }
    }
    const $7022219d2d87e7c6$export$ec5b303098bc4b7f = new $7022219d2d87e7c6$export$3de16b9a4e4a99f4();
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
parcelRegister("fdim1", function(module, exports) {
    $parcel$export(module.exports, "injectCallbackIntoGetBooleanFeatureFlag", ()=>$944db6b8bf5461ba$export$fe8eedb8c1059343);
    $parcel$export(module.exports, "getBooleanFeatureFlag", ()=>$944db6b8bf5461ba$export$a4658325ccb88f03);
    var $co1wz;
    const $944db6b8bf5461ba$var$callbacks = [];
    const $944db6b8bf5461ba$export$fe8eedb8c1059343 = (callback)=>{
        $944db6b8bf5461ba$var$callbacks.push(callback);
    };
    const $944db6b8bf5461ba$export$d930a8564fce9bcd = (flag)=>{
        const urlParams = new URLSearchParams(window.location.search);
        const ffOverrides = urlParams.get('ffOverrides');
        if (ffOverrides === undefined || ffOverrides === null) return null;
        const item = ffOverrides.split(',').find((item)=>item.startsWith(`${flag}:`));
        return item !== undefined && item.split(':')[1] || null;
    };
    const $944db6b8bf5461ba$export$a4658325ccb88f03 = (flag, defaultValue = false, storybookDefault = true)=>{
        for (const cb of $944db6b8bf5461ba$var$callbacks)cb(flag, defaultValue, storybookDefault);
        if (window?.STORYBOOK_ENV) {
            const overrideValue = $944db6b8bf5461ba$export$d930a8564fce9bcd(flag);
            if (overrideValue !== null) return overrideValue === 'true';
            return storybookDefault;
        }
        return (0, (0, parcelRequire("co1wz")).ff)(flag, defaultValue);
    };
    const $944db6b8bf5461ba$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues = [], storybookDefault)=>{
        if (window?.STORYBOOK_ENV) {
            const overrideValue = $944db6b8bf5461ba$export$d930a8564fce9bcd(featureFlagName);
            if (overrideValue !== null) return overrideValue;
            return typeof storybookDefault === 'string' ? storybookDefault : defaultValue;
        }
        return (0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)(featureFlagName, defaultValue, possibleValues);
    };
});
parcelRegister("6NgSc", function(module, exports) {
    $parcel$export(module.exports, "extractStartTime", ()=>$b554ac6908eada1d$export$97ed9769a496ce6e);
    const $b554ac6908eada1d$export$97ed9769a496ce6e = (markName)=>(performance.getEntriesByName(markName, 'mark')[0] || {
            startTime: 0
        }).startTime;
});
parcelRegister("eJyeb", function(module, exports) {
    $parcel$export(module.exports, "proxyContextSafeUrl", ()=>$d9ba6924f6683c87$export$ff2a151586ba6aa1);
    const $d9ba6924f6683c87$export$ff2a151586ba6aa1 = (url)=>`${window.integrationApiUrl || window.AJS && window.AJS.contextPath && window.AJS.contextPath() || ''}${url}`;
});
parcelRegister("cScrq", function(module, exports) {
    $parcel$export(module.exports, "isRoadmapGroupedByCustomField", ()=>$5018dda1bcaa7d3e$export$ab9f09a1d4f7c122);
    $parcel$export(module.exports, "getCustomFieldIdFromCustomFieldGrouping", ()=>$5018dda1bcaa7d3e$export$8f12e0ea293cf738);
    $parcel$export(module.exports, "isMultiSelectCustomField", ()=>$5018dda1bcaa7d3e$export$44fc3b70a457386d);
    $parcel$export(module.exports, "isLabelCustomField", ()=>$5018dda1bcaa7d3e$export$f9c878cce6945b43);
    var $TTKUQ = parcelRequire("TTKUQ");
    const $5018dda1bcaa7d3e$export$ab9f09a1d4f7c122 = (grouping)=>/^customfield_/.test(grouping);
    const $5018dda1bcaa7d3e$export$8f12e0ea293cf738 = (grouping)=>grouping.substring(12);
    const $5018dda1bcaa7d3e$export$44fc3b70a457386d = (fieldType)=>fieldType === (0, $TTKUQ.CustomFieldTypes).MultiSelect;
    const $5018dda1bcaa7d3e$export$f9c878cce6945b43 = (fieldType)=>fieldType === (0, $TTKUQ.CustomFieldTypes).Labels;
});
parcelRegister("h0oWC", function(module, exports) {
    $parcel$export(module.exports, "getTypeToLevelPure", ()=>$22b5d2a4f76f1280$export$3c4e701e817f6c92);
    $parcel$export(module.exports, "getEnrichedHierarchyLevelsPure", ()=>$22b5d2a4f76f1280$export$61f53636045c576c);
    var $3pSjV;
    var $4Rr1a;
    var $2rMKg;
    var $c12LJ;
    var $4nDwW = parcelRequire("4nDwW");
    const $22b5d2a4f76f1280$export$3c4e701e817f6c92 = (levels = [], issueTypes)=>{
        const issueTypesById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), issueTypes);
        const typeToLevelMap = (0, $4nDwW.fromPairs)((0, $4nDwW.chain)(({ level: level, issueTypes: issueTypes = [] })=>issueTypes.map((type)=>[
                    type,
                    level
                ]), levels));
        return (type)=>(0, parcelRequire("3pSjV")).default(issueTypesById[type] && issueTypesById[type].subTask === true ? (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL) : (0, (0, parcelRequire("c12LJ")).STORY_LEVEL), typeToLevelMap[type]);
    };
    const $22b5d2a4f76f1280$export$61f53636045c576c = (levels = [], issueTypes)=>{
        const typeToLevel = $22b5d2a4f76f1280$export$3c4e701e817f6c92(levels, issueTypes);
        const enriched = (0, parcelRequire("4Rr1a")).default(({ level: level, title: title })=>({
                level: level,
                title: title,
                issueTypes: []
            }), levels);
        for (const type of issueTypes){
            const level = typeToLevel(type.id);
            const enrichedLevelIndex = enriched.findIndex((enrichedLevel)=>enrichedLevel.level === level);
            enriched[enrichedLevelIndex].issueTypes.push(type);
        }
        return enriched;
    };
});
parcelRegister("3pSjV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27cdd7c52efc2262$export$2e2bcd8739ae039);
    var $c9RLn;
    var $27cdd7c52efc2262$var$defaultTo = (0, (0, parcelRequire("c9RLn")).default)(function defaultTo(d, v) {
        return v == null || v !== v ? d : v;
    });
    var $27cdd7c52efc2262$export$2e2bcd8739ae039 = $27cdd7c52efc2262$var$defaultTo;
});
parcelRegister("iOPeP", function(module, exports) {
    $parcel$export(module.exports, "offTrack", ()=>$0501d605f3bef527$export$cd48b0013ee54170);
    $parcel$export(module.exports, "onTrack", ()=>$0501d605f3bef527$export$8e8c195be1d237dd);
    var $TTKUQ = parcelRequire("TTKUQ");
    const $0501d605f3bef527$export$cd48b0013ee54170 = {
        id: (0, $TTKUQ.RELEASE_STATUSES).OFFTRACK,
        name: 'Off track'
    };
    const $0501d605f3bef527$export$8e8c195be1d237dd = {
        id: (0, $TTKUQ.RELEASE_STATUSES).ONTRACK,
        name: 'On track'
    };
});
parcelRegister("bqD5G", function(module, exports) {
    $parcel$export(module.exports, "getPlanPrefixedKey", ()=>$3d6cbc0511434301$export$61368afd1d6e9efc);
    var $g7G9N = parcelRequire("g7G9N");
    var $b9Xhh = parcelRequire("b9Xhh");
    const $3d6cbc0511434301$export$61368afd1d6e9efc = (key)=>{
        const planId = (0, $g7G9N.getPlanId)() || 'none';
        return `jpo-app-simple-plans-${planId}-${key}`;
    };
});
parcelRegister("g7G9N", function(module, exports) {
    $parcel$export(module.exports, "getPlanId", ()=>$0d826dc3b218e484$export$203ed8b65c3b2a28);
    $parcel$export(module.exports, "getScenarioId", ()=>$0d826dc3b218e484$export$8572797243a693b9);
    $parcel$export(module.exports, "getViewId", ()=>$0d826dc3b218e484$export$b86807180a5e2759);
    $parcel$export(module.exports, "getReportHash", ()=>$0d826dc3b218e484$export$bba909e367ded43b);
    var $4nDwW = parcelRequire("4nDwW");
    var $idmiV = parcelRequire("idmiV");
    const $0d826dc3b218e484$export$2d09f4703b637141 = (param)=>{
        const paramMatch = window.location.search.match(`[?&]${param}=([^&]*)`);
        if (paramMatch) return paramMatch[1];
        return undefined;
    };
    const $0d826dc3b218e484$export$203ed8b65c3b2a28 = ()=>+(0, $idmiV.getPathParams)().id || undefined;
    const $0d826dc3b218e484$export$8572797243a693b9 = ()=>+(0, $idmiV.getPathParams)().sid || undefined;
    const $0d826dc3b218e484$export$b86807180a5e2759 = ()=>+$0d826dc3b218e484$export$2d09f4703b637141('vid') || undefined;
    const $0d826dc3b218e484$export$bba909e367ded43b = ()=>{
        if ((0, $4nDwW.isDefined)((0, $idmiV.getPathParams)().r)) return (0, $idmiV.getPathParams)().r;
        return $0d826dc3b218e484$export$2d09f4703b637141('r');
    };
});
parcelRegister("idmiV", function(module, exports) {
    $parcel$export(module.exports, "PLAN_PAGES", ()=>$71b9c13c38b023cf$export$aa80e59bd6a86321);
    $parcel$export(module.exports, "buildManageViewsPath", ()=>$71b9c13c38b023cf$export$163eb352faa92361);
    $parcel$export(module.exports, "redirect", ()=>$71b9c13c38b023cf$export$89e12c5b50f7529d);
    $parcel$export(module.exports, "openInNewTab", ()=>$71b9c13c38b023cf$export$9e52b10d57ddf9e3);
    $parcel$export(module.exports, "reload", ()=>$71b9c13c38b023cf$export$32da5b5043dcd88c);
    $parcel$export(module.exports, "redirectToSettingsSubPage", ()=>$71b9c13c38b023cf$export$30c1dc5285e5b7c5);
    $parcel$export(module.exports, "redirectToIssueSourceSetup", ()=>$71b9c13c38b023cf$export$c1647ef31d453e4e);
    $parcel$export(module.exports, "userAgent", ()=>$71b9c13c38b023cf$export$3dcce53a3755dc8c);
    $parcel$export(module.exports, "getLocation", ()=>$71b9c13c38b023cf$export$e7fd20fad3cf4b5f);
    $parcel$export(module.exports, "parseQueryParams", ()=>$71b9c13c38b023cf$export$67c4cee80a3410cd);
    $parcel$export(module.exports, "getQueryParameters", ()=>$71b9c13c38b023cf$export$2c02b58bdf58d1c3);
    $parcel$export(module.exports, "getPathParams", ()=>$71b9c13c38b023cf$export$da250964c4d72448);
    $parcel$export(module.exports, "updateQueryString", ()=>$71b9c13c38b023cf$export$a725689b9dc0457f);
    $parcel$export(module.exports, "redirectToNewScenario", ()=>$71b9c13c38b023cf$export$11f26f7d7225123e);
    $parcel$export(module.exports, "isReportView", ()=>$71b9c13c38b023cf$export$60b6d4de09d53c54);
    $parcel$export(module.exports, "isEmbedReportView", ()=>$71b9c13c38b023cf$export$cf369e206dbfd4ce);
    $parcel$export(module.exports, "isConfluenceReportView", ()=>$71b9c13c38b023cf$export$62a9a65b5c5c27e);
    $parcel$export(module.exports, "isConfluenceReportProxyView", ()=>$71b9c13c38b023cf$export$b990f18079f6b40d);
    $parcel$export(module.exports, "isExportView", ()=>$71b9c13c38b023cf$export$cf7a8de77e0c8209);
    $parcel$export(module.exports, "isExportPreview", ()=>$71b9c13c38b023cf$export$ad6637fa30ef33ef);
    $parcel$export(module.exports, "getNonTimelineWidth", ()=>$71b9c13c38b023cf$export$9bd1947787a14301);
    $parcel$export(module.exports, "getExportTimelineDateRange", ()=>$71b9c13c38b023cf$export$fc5fb6d4b5cb9b11);
    $parcel$export(module.exports, "isPageUnloading", ()=>$71b9c13c38b023cf$export$806b710b4d1b901c);
    $parcel$export(module.exports, "getPlanUrl", ()=>$71b9c13c38b023cf$export$c64539b90bced4a);
    var $3T6Xo = parcelRequire("3T6Xo");
    var $eJyeb = parcelRequire("eJyeb");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $71b9c13c38b023cf$export$7b854f4176fe4984 = {
        PLAN: 'plan',
        SETTINGS: 'settings'
    };
    const $71b9c13c38b023cf$export$aa80e59bd6a86321 = {
        ROADMAP: 'backlog',
        RELEASES: 'releases',
        TEAMS: 'teams',
        DEPENDENCIES_REPORT: 'dependencies'
    };
    const $71b9c13c38b023cf$export$50ce986ba03069e4 = {
        ROADMAP: `${$71b9c13c38b023cf$export$7b854f4176fe4984.PLAN}/${$71b9c13c38b023cf$export$aa80e59bd6a86321.ROADMAP}`,
        RELEASES: `${$71b9c13c38b023cf$export$7b854f4176fe4984.PLAN}/${$71b9c13c38b023cf$export$aa80e59bd6a86321.RELEASES}`,
        TEAMS: `${$71b9c13c38b023cf$export$7b854f4176fe4984.PLAN}/${$71b9c13c38b023cf$export$aa80e59bd6a86321.TEAMS}`,
        DEPENDENCIES_REPORT: `${$71b9c13c38b023cf$export$7b854f4176fe4984.PLAN}/${$71b9c13c38b023cf$export$aa80e59bd6a86321.DEPENDENCIES_REPORT}`
    };
    const $71b9c13c38b023cf$export$331e0cdfec693a91 = {
        CUSTOM_FIELDS: 'customFields',
        EXCLUSION_RULES: 'setExclusionRules',
        ISSUE_SOURCES: 'issueSources',
        PERMISSIONS: 'permissions',
        REMOVED_ISSUES: 'removedIssues',
        SAVED_VIEWS: 'savedViews',
        SCENARIOS: 'scenarios',
        AUTO_SCHEDULER: 'auto-scheduler',
        SCHEDULING: 'scheduling',
        SOURCES: 'sources',
        FIND_YOUR_ISSUE: 'findYourIssue'
    };
    const $71b9c13c38b023cf$export$f8b09fb9bf12a66d = {
        CUSTOM_FIELDS: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.CUSTOM_FIELDS}`,
        EXCLUSION_RULES: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.EXCLUSION_RULES}`,
        ISSUE_SOURCES: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.ISSUE_SOURCES}`,
        PERMISSIONS: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.PERMISSIONS}`,
        REMOVED_ISSUES: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.REMOVED_ISSUES}`,
        SAVED_VIEWS: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.SAVED_VIEWS}`,
        SCENARIOS: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.SCENARIOS}`,
        AUTO_SCHEDULER: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.AUTO_SCHEDULER}`,
        SCHEDULING: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.SCHEDULING}`,
        SOURCES: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.SOURCES}`,
        FIND_YOUR_ISSUE: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.FIND_YOUR_ISSUE}`
    };
    const $71b9c13c38b023cf$export$163eb352faa92361 = (planId, scenarioId)=>`/jira/plans/${planId}/scenarios/${scenarioId}/settings/${(0, ($parcel$interopDefault($3T6Xo)))($71b9c13c38b023cf$export$331e0cdfec693a91.SAVED_VIEWS)}`;
    const $71b9c13c38b023cf$export$92e12da00cfa0a30 = (planId, scenarioId)=>`/jira/plans/${planId}/scenarios/${scenarioId}/settings/${(0, ($parcel$interopDefault($3T6Xo)))($71b9c13c38b023cf$export$331e0cdfec693a91.REMOVED_ISSUES)}`;
    const $71b9c13c38b023cf$export$89e12c5b50f7529d = (url)=>{
        window.location.href = url;
    };
    const $71b9c13c38b023cf$export$9e52b10d57ddf9e3 = (url)=>{
        window.open(url, '_blank')?.focus();
    };
    const $71b9c13c38b023cf$export$32da5b5043dcd88c = ()=>{
        window.location.reload();
    };
    const $71b9c13c38b023cf$export$91c50705ae840697 = (planId, scenarioId)=>{
        $71b9c13c38b023cf$export$89e12c5b50f7529d((0, $eJyeb.proxyContextSafeUrl)(`/jira/plans/${planId}/scenarios/${scenarioId}`));
    };
    const $71b9c13c38b023cf$export$fac3bf18cd62bfe3 = ()=>{
        window.location.hash = `#${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}`;
    };
    const $71b9c13c38b023cf$export$30c1dc5285e5b7c5 = (page)=>{
        window.location.hash = `#${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${page}`;
    };
    const $71b9c13c38b023cf$export$8ccbd58c5a1933be = (tab)=>{
        window.location.hash = `#${$71b9c13c38b023cf$export$7b854f4176fe4984.PLAN}${tab}`;
    };
    const $71b9c13c38b023cf$export$c1647ef31d453e4e = (planId)=>{
        $71b9c13c38b023cf$export$89e12c5b50f7529d((0, $eJyeb.proxyContextSafeUrl)(`/secure/PortfolioPlanSetup.jspa?id=${planId}&3.0plan`));
    };
    const $71b9c13c38b023cf$export$3dcce53a3755dc8c = globalThis.navigator?.userAgent || 'unknown';
    const $71b9c13c38b023cf$export$e7fd20fad3cf4b5f = ()=>window.location;
    const $71b9c13c38b023cf$export$67c4cee80a3410cd = (rawParams)=>{
        if (!rawParams) return {};
        const result = {};
        rawParams.slice(1).split('&').map((queryParam)=>{
            const keyValue = queryParam.split('=');
            return {
                key: keyValue[0],
                value: keyValue[1]
            };
        }).forEach((keyValue)=>{
            result[keyValue.key] = keyValue.value;
        });
        return result;
    };
    const $71b9c13c38b023cf$export$2c02b58bdf58d1c3 = ()=>$71b9c13c38b023cf$export$67c4cee80a3410cd(window.location.search);
    const $71b9c13c38b023cf$export$62c1abd9d82e0215 = (path)=>{
        const pathparams = [
            'id',
            'sid',
            'r'
        ];
        const paramToPathNameMap = {
            id: 'plans',
            sid: 'scenarios',
            r: 'reports'
        };
        const params = {};
        pathparams.forEach((param)=>{
            const regex = new RegExp(`/${paramToPathNameMap[param]}/(\\w+)`, 'g');
            const matches = Array.from(path.matchAll(regex), (match)=>match[1]);
            params[param] = matches[0];
        });
        return params;
    };
    const $71b9c13c38b023cf$export$da250964c4d72448 = ()=>$71b9c13c38b023cf$export$62c1abd9d82e0215(window.location.pathname);
    const $71b9c13c38b023cf$export$a725689b9dc0457f = (locationSearch, newParams)=>{
        const currentParams = $71b9c13c38b023cf$export$67c4cee80a3410cd(locationSearch);
        const updatedParams = {
            ...currentParams,
            ...newParams
        };
        const searchString = Object.keys(updatedParams).filter((key)=>updatedParams[key] !== undefined).map((key)=>`${key}=${updatedParams[key]}`).join('&');
        return `?${searchString}`;
    };
    const $71b9c13c38b023cf$export$11f26f7d7225123e = (browserHistory, sid)=>{
        const regex = new RegExp('(/scenarios/)\\w+', 'g');
        const url = `${window.location.pathname.replace(regex, (_, $1)=>`${$1}${sid}`)}${window.location.search}${window.location.hash}`;
        browserHistory.push(url);
    };
    const $71b9c13c38b023cf$export$60b6d4de09d53c54 = ()=>{
        return window && (window.location.pathname.includes('reports') || window.location.pathname.includes('PortfolioEmbeddedReportView') || window.location.pathname.includes('PlanEmbeddedReport') || window.location.pathname.includes('PortfolioRoadmapConfluence'));
    };
    const $71b9c13c38b023cf$export$cf369e206dbfd4ce = ()=>window && (window.location.pathname.includes('PortfolioEmbeddedReportView') || window.location.pathname.includes('PlanEmbeddedReport'));
    const $71b9c13c38b023cf$export$62a9a65b5c5c27e = ()=>window && window.location.pathname.indexOf('PortfolioRoadmapConfluence') !== -1;
    const $71b9c13c38b023cf$export$b990f18079f6b40d = ()=>window && window.location.pathname.indexOf('/plugins/servlet/PortfolioRoadmapConfluence') !== -1;
    const $71b9c13c38b023cf$export$cf7a8de77e0c8209 = ()=>Boolean(window?.location.pathname.indexOf('plans') !== -1 && window?.location.pathname.indexOf('scenarios') !== -1 && window?.location.pathname.indexOf('/export') !== -1) || Boolean(window?.location.href.indexOf('forceExportMode=1') !== -1);
    const $71b9c13c38b023cf$export$ad6637fa30ef33ef = ()=>Boolean(window?.location.href.indexOf('startInPreviewMode=1') !== -1);
    const $71b9c13c38b023cf$export$2399fb6b8ed70468 = ()=>{
        const params = $71b9c13c38b023cf$export$2c02b58bdf58d1c3();
        const width = parseInt(params.scopeWidth || (0, $TTKUQ.EXPORT_VIEW_DEFAULT_SCOPE_WIDTH), 10);
        return Number.isNaN(width) ? (0, $TTKUQ.EXPORT_VIEW_DEFAULT_SCOPE_WIDTH) : width;
    };
    const $71b9c13c38b023cf$export$661aa4dfe4b50072 = ()=>{
        const params = $71b9c13c38b023cf$export$2c02b58bdf58d1c3();
        const width = parseInt(params.fieldsWidth || (0, $TTKUQ.EXPORT_VIEW_DEFAULT_FIELDS_WIDTH), 10);
        return Number.isNaN(width) ? (0, $TTKUQ.EXPORT_VIEW_DEFAULT_FIELDS_WIDTH) : width;
    };
    const $71b9c13c38b023cf$export$9bd1947787a14301 = ()=>$71b9c13c38b023cf$export$2399fb6b8ed70468() + $71b9c13c38b023cf$export$661aa4dfe4b50072();
    const $71b9c13c38b023cf$export$fc5fb6d4b5cb9b11 = ()=>{
        const params = $71b9c13c38b023cf$export$2c02b58bdf58d1c3();
        const fromDate = parseInt(params.fromDate || '', 10);
        const toDate = parseInt(params.toDate || '', 10);
        return {
            fromDate: Number.isNaN(fromDate) ? undefined : fromDate,
            toDate: Number.isNaN(toDate) ? undefined : toDate
        };
    };
    let $71b9c13c38b023cf$var$isPageUnloadingFlag = false;
    if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
        $71b9c13c38b023cf$var$isPageUnloadingFlag = true;
    });
    const $71b9c13c38b023cf$export$806b710b4d1b901c = ()=>$71b9c13c38b023cf$var$isPageUnloadingFlag;
    const $71b9c13c38b023cf$export$c64539b90bced4a = ({ planId: planId, scenarioId: scenarioId, confluenceMacroType: confluenceMacroType })=>{
        const baseUrl = scenarioId != null ? `/jira/plans/${planId}/scenarios/${scenarioId}/` : `/jira/plans/${planId}/`;
        switch(confluenceMacroType){
            case 0, $TTKUQ.DEPENDENCY_REPORT_SHARE_TYPE:
                return `${baseUrl}${$71b9c13c38b023cf$export$aa80e59bd6a86321.DEPENDENCIES_REPORT}`;
            default:
                return `${baseUrl}${$71b9c13c38b023cf$export$aa80e59bd6a86321.ROADMAP}`;
        }
    };
});
parcelRegister("b9Xhh", function(module, exports) {
    $parcel$export(module.exports, "persistReducer", ()=>$4adb895a05422875$export$1e2465eba28351ae);
    parcelRequire("5j69e");
    var $lJVSs = parcelRequire("lJVSs");
    var $eeTwB;
    const $4adb895a05422875$export$1e2465eba28351ae = (persistConfig, reducer)=>{
        const fullPersistConfig = {
            storage: (0, (0, parcelRequire("eeTwB")).promiseStorage),
            ...persistConfig
        };
        return (0, $lJVSs.default)(fullPersistConfig, reducer);
    };
});
parcelRegister("5j69e", function(module, exports) {
    $parcel$export(module.exports, "persistReducer", ()=>(parcelRequire("lJVSs")).default);
    $parcel$export(module.exports, "persistStore", ()=>(parcelRequire("5gmG2")).default);
    $parcel$export(module.exports, "createTransform", ()=>(parcelRequire("bL3GI")).default);
    var $lJVSs = parcelRequire("lJVSs");
    var $gf4Z2 = parcelRequire("gf4Z2");
    var $5gmG2 = parcelRequire("5gmG2");
    var $8JGkd = parcelRequire("8JGkd");
    var $bL3GI = parcelRequire("bL3GI");
    var $74Nd0 = parcelRequire("74Nd0");
    var $9sGkr = parcelRequire("9sGkr");
    var $cXr6Y = parcelRequire("cXr6Y");
    parcelRequire("fCbHL");
});
parcelRegister("lJVSs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd3ab2292ebff197$export$2e2bcd8739ae039);
    var $fCbHL = parcelRequire("fCbHL");
    var $ascdj = parcelRequire("ascdj");
    var $9sGkr = parcelRequire("9sGkr");
    var $74Nd0 = parcelRequire("74Nd0");
    var $cXr6Y = parcelRequire("cXr6Y");
    var $fd3ab2292ebff197$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $fd3ab2292ebff197$var$_objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    var $fd3ab2292ebff197$var$DEFAULT_TIMEOUT = 5000;
    function $fd3ab2292ebff197$export$2e2bcd8739ae039(config, baseReducer) {
        var version = config.version !== undefined ? config.version : (0, $fCbHL.DEFAULT_VERSION);
        var debug = config.debug || false;
        var stateReconciler = config.stateReconciler === undefined ? (0, $ascdj.default) : config.stateReconciler;
        var getStoredState = config.getStoredState || (0, $74Nd0.default);
        var timeout = config.timeout !== undefined ? config.timeout : $fd3ab2292ebff197$var$DEFAULT_TIMEOUT;
        var _persistoid = null;
        var _purge = false;
        var _paused = true;
        var conditionalUpdate = function conditionalUpdate(state) {
            state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
            return state;
        };
        return function(state, action) {
            var _ref = state || {}, _persist = _ref._persist, rest = $fd3ab2292ebff197$var$_objectWithoutProperties(_ref, [
                '_persist'
            ]);
            var restState = rest;
            if (action.type === (0, $fCbHL.PERSIST)) {
                var _sealed = false;
                var _rehydrate = function _rehydrate(payload, err) {
                    if (!_sealed) {
                        action.rehydrate(config.key, payload, err);
                        _sealed = true;
                    }
                };
                timeout && setTimeout(function() {
                    !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "' + config.key + '"'));
                }, timeout);
                _paused = false;
                if (!_persistoid) _persistoid = (0, $9sGkr.default)(config);
                if (_persist) return state;
                if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
                action.register(config.key);
                getStoredState(config).then(function(restoredState) {
                    var migrate = config.migrate || function(s, v) {
                        return Promise.resolve(s);
                    };
                    migrate(restoredState, version).then(function(migratedState) {
                        _rehydrate(migratedState);
                    }, function(migrateErr) {
                        _rehydrate(undefined, migrateErr);
                    });
                }, function(err) {
                    _rehydrate(undefined, err);
                });
                return $fd3ab2292ebff197$var$_extends({}, baseReducer(restState, action), {
                    _persist: {
                        version: version,
                        rehydrated: false
                    }
                });
            } else if (action.type === (0, $fCbHL.PURGE)) {
                _purge = true;
                action.result((0, $cXr6Y.default)(config));
                return $fd3ab2292ebff197$var$_extends({}, baseReducer(restState, action), {
                    _persist: _persist
                });
            } else if (action.type === (0, $fCbHL.FLUSH)) {
                action.result(_persistoid && _persistoid.flush());
                return $fd3ab2292ebff197$var$_extends({}, baseReducer(restState, action), {
                    _persist: _persist
                });
            } else if (action.type === (0, $fCbHL.PAUSE)) _paused = true;
            else if (action.type === (0, $fCbHL.REHYDRATE)) {
                if (_purge) return $fd3ab2292ebff197$var$_extends({}, restState, {
                    _persist: $fd3ab2292ebff197$var$_extends({}, _persist, {
                        rehydrated: true
                    })
                });
                if (action.key === config.key) {
                    var reducedState = baseReducer(restState, action);
                    var inboundState = action.payload;
                    var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                    var _newState = $fd3ab2292ebff197$var$_extends({}, reconciledRest, {
                        _persist: $fd3ab2292ebff197$var$_extends({}, _persist, {
                            rehydrated: true
                        })
                    });
                    return conditionalUpdate(_newState);
                }
            }
            if (!_persist) return baseReducer(state, action);
            var newState = baseReducer(restState, action);
            if (newState === restState) return state;
            else {
                newState._persist = _persist;
                return conditionalUpdate(newState);
            }
        };
    }
});
parcelRegister("fCbHL", function(module, exports) {
    $parcel$export(module.exports, "KEY_PREFIX", ()=>$b5e37bf77a4ec3c9$export$711117ad6ad27992);
    $parcel$export(module.exports, "FLUSH", ()=>$b5e37bf77a4ec3c9$export$2aaee4793dd13a52);
    $parcel$export(module.exports, "REHYDRATE", ()=>$b5e37bf77a4ec3c9$export$1647ef958242c4e2);
    $parcel$export(module.exports, "PAUSE", ()=>$b5e37bf77a4ec3c9$export$dd1033c27a16bbd3);
    $parcel$export(module.exports, "PERSIST", ()=>$b5e37bf77a4ec3c9$export$913fe0e161ed92a2);
    $parcel$export(module.exports, "PURGE", ()=>$b5e37bf77a4ec3c9$export$5514fc3b4067675f);
    $parcel$export(module.exports, "REGISTER", ()=>$b5e37bf77a4ec3c9$export$51e82cdd7353a0e1);
    $parcel$export(module.exports, "DEFAULT_VERSION", ()=>$b5e37bf77a4ec3c9$export$363ebe89e6e7aeef);
    var $b5e37bf77a4ec3c9$export$711117ad6ad27992 = 'persist:';
    var $b5e37bf77a4ec3c9$export$2aaee4793dd13a52 = 'persist/FLUSH';
    var $b5e37bf77a4ec3c9$export$1647ef958242c4e2 = 'persist/REHYDRATE';
    var $b5e37bf77a4ec3c9$export$dd1033c27a16bbd3 = 'persist/PAUSE';
    var $b5e37bf77a4ec3c9$export$913fe0e161ed92a2 = 'persist/PERSIST';
    var $b5e37bf77a4ec3c9$export$5514fc3b4067675f = 'persist/PURGE';
    var $b5e37bf77a4ec3c9$export$51e82cdd7353a0e1 = 'persist/REGISTER';
    var $b5e37bf77a4ec3c9$export$363ebe89e6e7aeef = -1;
});
parcelRegister("ascdj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c5fe529284a0f2$export$2e2bcd8739ae039);
    var $79c5fe529284a0f2$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var $79c5fe529284a0f2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $79c5fe529284a0f2$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
        var debug = _ref.debug;
        var newState = $79c5fe529284a0f2$var$_extends({}, reducedState);
        if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : $79c5fe529284a0f2$var$_typeof(inboundState)) === 'object') Object.keys(inboundState).forEach(function(key) {
            if (key === '_persist') return;
            if (originalState[key] !== reducedState[key]) return;
            newState[key] = inboundState[key];
        });
        return newState;
    }
});
parcelRegister("9sGkr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e3790288489615a$export$2e2bcd8739ae039);
    var $fCbHL = parcelRequire("fCbHL");
    function $6e3790288489615a$export$2e2bcd8739ae039(config) {
        var blacklist = config.blacklist || null;
        var whitelist = config.whitelist || null;
        var transforms = config.transforms || [];
        var throttle = config.throttle || 0;
        var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : (0, $fCbHL.KEY_PREFIX)) + config.key;
        var storage = config.storage;
        var serialize = config.serialize === false ? function(x) {
            return x;
        } : $6e3790288489615a$var$defaultSerialize;
        var lastState = {};
        var stagedState = {};
        var keysToProcess = [];
        var timeIterator = null;
        var writePromise = null;
        var update = function update(state) {
            Object.keys(state).forEach(function(key) {
                if (!passWhitelistBlacklist(key)) return;
                if (lastState[key] === state[key]) return;
                if (keysToProcess.indexOf(key) !== -1) return;
                keysToProcess.push(key);
            });
            Object.keys(lastState).forEach(function(key) {
                if (state[key] === undefined) keysToProcess.push(key);
            });
            if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
            lastState = state;
        };
        function processNextKey() {
            if (keysToProcess.length === 0) {
                if (timeIterator) clearInterval(timeIterator);
                timeIterator = null;
                return;
            }
            var key = keysToProcess.shift();
            var endState = transforms.reduce(function(subState, transformer) {
                return transformer.in(subState, key, lastState);
            }, lastState[key]);
            if (endState !== undefined) try {
                stagedState[key] = serialize(endState);
            } catch (err) {
                console.error('redux-persist/createPersistoid: error serializing state', err);
            }
            else delete stagedState[key];
            if (keysToProcess.length === 0) writeStagedState();
        }
        function writeStagedState() {
            Object.keys(stagedState).forEach(function(key) {
                if (lastState[key] === undefined) delete stagedState[key];
            });
            writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
        }
        function passWhitelistBlacklist(key) {
            if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
            if (blacklist && blacklist.indexOf(key) !== -1) return false;
            return true;
        }
        function onWriteFail(err) {}
        var flush = function flush() {
            while(keysToProcess.length !== 0)processNextKey();
            return writePromise || Promise.resolve();
        };
        return {
            update: update,
            flush: flush
        };
    }
    function $6e3790288489615a$var$defaultSerialize(data) {
        return JSON.stringify(data);
    }
});
parcelRegister("74Nd0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$526f13f15afac226$export$2e2bcd8739ae039);
    var $fCbHL = parcelRequire("fCbHL");
    function $526f13f15afac226$export$2e2bcd8739ae039(config) {
        var transforms = config.transforms || [];
        var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : (0, $fCbHL.KEY_PREFIX)) + config.key;
        var storage = config.storage;
        var debug = config.debug;
        var deserialize = config.serialize === false ? function(x) {
            return x;
        } : $526f13f15afac226$var$defaultDeserialize;
        return storage.getItem(storageKey).then(function(serialized) {
            if (!serialized) return undefined;
            else try {
                var state = {};
                var rawState = deserialize(serialized);
                Object.keys(rawState).forEach(function(key) {
                    state[key] = transforms.reduceRight(function(subState, transformer) {
                        return transformer.out(subState, key, rawState);
                    }, deserialize(rawState[key]));
                });
                return state;
            } catch (err) {
                throw err;
            }
        });
    }
    function $526f13f15afac226$var$defaultDeserialize(serial) {
        return JSON.parse(serial);
    }
});
parcelRegister("cXr6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96f0067a94ce98aa$export$2e2bcd8739ae039);
    var $fCbHL = parcelRequire("fCbHL");
    function $96f0067a94ce98aa$export$2e2bcd8739ae039(config) {
        var storage = config.storage;
        var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : (0, $fCbHL.KEY_PREFIX)) + config.key;
        return storage.removeItem(storageKey, $96f0067a94ce98aa$var$warnIfRemoveError);
    }
    function $96f0067a94ce98aa$var$warnIfRemoveError(err) {}
});
parcelRegister("gf4Z2", function(module, exports) {
    var $3f2cs = parcelRequire("3f2cs");
    var $lJVSs = parcelRequire("lJVSs");
    var $kd5Lc = parcelRequire("kd5Lc");
    function $bd31e9a88c98f905$export$2e2bcd8739ae039(config, reducers) {
        config.stateReconciler = config.stateReconciler === undefined ? (0, $kd5Lc.default) : config.stateReconciler;
        return (0, $lJVSs.default)(config, (0, $3f2cs.combineReducers)(reducers));
    }
});
parcelRegister("kd5Lc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb697d6af3b9ed7c$export$2e2bcd8739ae039);
    var $eb697d6af3b9ed7c$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var $eb697d6af3b9ed7c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $eb697d6af3b9ed7c$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
        var debug = _ref.debug;
        var newState = $eb697d6af3b9ed7c$var$_extends({}, reducedState);
        if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : $eb697d6af3b9ed7c$var$_typeof(inboundState)) === 'object') Object.keys(inboundState).forEach(function(key) {
            if (key === '_persist') return;
            if (originalState[key] !== reducedState[key]) return;
            if ($eb697d6af3b9ed7c$var$isPlainEnoughObject(reducedState[key])) {
                newState[key] = $eb697d6af3b9ed7c$var$_extends({}, newState[key], inboundState[key]);
                return;
            }
            newState[key] = inboundState[key];
        });
        return newState;
    }
    function $eb697d6af3b9ed7c$var$isPlainEnoughObject(o) {
        return o !== null && !Array.isArray(o) && (typeof o === 'undefined' ? 'undefined' : $eb697d6af3b9ed7c$var$_typeof(o)) === 'object';
    }
});
parcelRegister("5gmG2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d50098d15c02418$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    parcelRequire("lJVSs");
    var $fCbHL = parcelRequire("fCbHL");
    var $3d50098d15c02418$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $3d50098d15c02418$var$_toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    }
    var $3d50098d15c02418$var$initialState = {
        registry: [],
        bootstrapped: false
    };
    var $3d50098d15c02418$var$persistorReducer = function persistorReducer() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $3d50098d15c02418$var$initialState;
        var action = arguments[1];
        switch(action.type){
            case 0, $fCbHL.REGISTER:
                return $3d50098d15c02418$var$_extends({}, state, {
                    registry: [].concat($3d50098d15c02418$var$_toConsumableArray(state.registry), [
                        action.key
                    ])
                });
            case 0, $fCbHL.REHYDRATE:
                var firstIndex = state.registry.indexOf(action.key);
                var registry = [].concat($3d50098d15c02418$var$_toConsumableArray(state.registry));
                registry.splice(firstIndex, 1);
                return $3d50098d15c02418$var$_extends({}, state, {
                    registry: registry,
                    bootstrapped: registry.length === 0
                });
            default:
                return state;
        }
    };
    function $3d50098d15c02418$export$2e2bcd8739ae039(store, options, cb) {
        var optionsToTest, bannedKeys;
        var boostrappedCb = cb || false;
        var _pStore = (0, $3f2cs.createStore)($3d50098d15c02418$var$persistorReducer, $3d50098d15c02418$var$initialState, options ? options.enhancer : undefined);
        var register = function register(key) {
            _pStore.dispatch({
                type: (0, $fCbHL.REGISTER),
                key: key
            });
        };
        var rehydrate = function rehydrate(key, payload, err) {
            var rehydrateAction = {
                type: (0, $fCbHL.REHYDRATE),
                payload: payload,
                err: err,
                key: key
            };
            store.dispatch(rehydrateAction);
            _pStore.dispatch(rehydrateAction);
            if (boostrappedCb && persistor.getState().bootstrapped) {
                boostrappedCb();
                boostrappedCb = false;
            }
        };
        var persistor = $3d50098d15c02418$var$_extends({}, _pStore, {
            purge: function purge() {
                var results = [];
                store.dispatch({
                    type: (0, $fCbHL.PURGE),
                    result: function result(purgeResult) {
                        results.push(purgeResult);
                    }
                });
                return Promise.all(results);
            },
            flush: function flush() {
                var results = [];
                store.dispatch({
                    type: (0, $fCbHL.FLUSH),
                    result: function result(flushResult) {
                        results.push(flushResult);
                    }
                });
                return Promise.all(results);
            },
            pause: function pause() {
                store.dispatch({
                    type: (0, $fCbHL.PAUSE)
                });
            },
            persist: function persist() {
                store.dispatch({
                    type: (0, $fCbHL.PERSIST),
                    register: register,
                    rehydrate: rehydrate
                });
            }
        });
        persistor.persist();
        return persistor;
    }
});
parcelRegister("8JGkd", function(module, exports) {
    var $fCbHL = parcelRequire("fCbHL");
    function $01a42ee5617b45e7$export$2e2bcd8739ae039(migrations, config) {
        var _ref = config || {}, debug = _ref.debug;
        return function(state, currentVersion) {
            if (!state) return Promise.resolve(undefined);
            var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $fCbHL.DEFAULT_VERSION);
            if (inboundVersion === currentVersion) return Promise.resolve(state);
            if (inboundVersion > currentVersion) return Promise.resolve(state);
            var migrationKeys = Object.keys(migrations).map(function(ver) {
                return parseInt(ver);
            }).filter(function(key) {
                return currentVersion >= key && key > inboundVersion;
            }).sort(function(a, b) {
                return a - b;
            });
            try {
                var migratedState = migrationKeys.reduce(function(state, versionKey) {
                    return migrations[versionKey](state);
                }, state);
                return Promise.resolve(migratedState);
            } catch (err) {
                return Promise.reject(err);
            }
        };
    }
});
parcelRegister("bL3GI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88f6f1dd69706909$export$2e2bcd8739ae039);
    function $88f6f1dd69706909$export$2e2bcd8739ae039(inbound, outbound) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var whitelist = config.whitelist || null;
        var blacklist = config.blacklist || null;
        function whitelistBlacklistCheck(key) {
            if (whitelist && whitelist.indexOf(key) === -1) return true;
            if (blacklist && blacklist.indexOf(key) !== -1) return true;
            return false;
        }
        return {
            in: function _in(state, key, fullState) {
                return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
            },
            out: function out(state, key, fullState) {
                return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
            }
        };
    }
});
parcelRegister("eeTwB", function(module, exports) {
    $parcel$export(module.exports, "promiseStorage", ()=>$8d745803d29bdc89$export$192c9db47d7c59a4);
    const $8d745803d29bdc89$var$isStorageAvailable = (type)=>{
        let storage;
        try {
            storage = window[type];
            const x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return (e && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage && storage.length !== 0);
        }
    };
    const $8d745803d29bdc89$var$localStorageAvailable = $8d745803d29bdc89$var$isStorageAvailable('localStorage');
    const $8d745803d29bdc89$var$inMemoryStorage = {};
    const $8d745803d29bdc89$var$setItemInLocalStorage = (key, value)=>{
        if ($8d745803d29bdc89$var$localStorageAvailable) window.localStorage.setItem(key, value);
        else $8d745803d29bdc89$var$inMemoryStorage[key] = value;
    };
    const $8d745803d29bdc89$var$getItemFromLocalStorage = (key)=>{
        if ($8d745803d29bdc89$var$localStorageAvailable) return window.localStorage.getItem(key);
        return $8d745803d29bdc89$var$inMemoryStorage[key];
    };
    const $8d745803d29bdc89$var$removeItemFromLocalStorage = (key)=>{
        if ($8d745803d29bdc89$var$localStorageAvailable) window.localStorage.removeItem(key);
        else delete $8d745803d29bdc89$var$inMemoryStorage[key];
    };
    const $8d745803d29bdc89$export$ddcffe0146c8f882 = {
        getItem: (key)=>$8d745803d29bdc89$var$getItemFromLocalStorage(key),
        setItem: (key, value)=>$8d745803d29bdc89$var$setItemInLocalStorage(key, value),
        removeItem: (key)=>$8d745803d29bdc89$var$removeItemFromLocalStorage(key)
    };
    const $8d745803d29bdc89$export$192c9db47d7c59a4 = {
        getItem: (key)=>Promise.resolve($8d745803d29bdc89$var$getItemFromLocalStorage(key)),
        setItem: (key, value)=>Promise.resolve($8d745803d29bdc89$var$setItemInLocalStorage(key, value)),
        removeItem: (key)=>Promise.resolve($8d745803d29bdc89$var$removeItemFromLocalStorage(key))
    };
});
parcelRegister("7K8Pq", function(module, exports) {
    $parcel$export(module.exports, "CLEAR_INLINE_CREATE", ()=>$941b6f0c52cc7d6a$export$1a9a8a01b7182017);
    $parcel$export(module.exports, "SET_ISSUE_TYPE_ID", ()=>$941b6f0c52cc7d6a$export$b5b06234341e4e89);
    $parcel$export(module.exports, "SET_PROJECT_ID", ()=>$941b6f0c52cc7d6a$export$7a6c7dbea71065c6);
    $parcel$export(module.exports, "SET_SIBLING_ID", ()=>$941b6f0c52cc7d6a$export$98cade42b641eb6c);
    $parcel$export(module.exports, "START_INLINE_CREATE", ()=>$941b6f0c52cc7d6a$export$e4b545016f01a38c);
    $parcel$export(module.exports, "UPDATE_INLINE_CREATE", ()=>$941b6f0c52cc7d6a$export$32dcb826f20ea035);
    $parcel$export(module.exports, "SET_ISSUE_TYPE_ID_FOR_HIERARCHY", ()=>$941b6f0c52cc7d6a$export$70b83d224b93b6b8);
    $parcel$export(module.exports, "SET_GLOBAL_CREATE_ISSUE", ()=>$941b6f0c52cc7d6a$export$e335aa41e2ecdc00);
    $parcel$export(module.exports, "SET_OPEN_LOCKED", ()=>$941b6f0c52cc7d6a$export$b6f8461edbea9f82);
    $parcel$export(module.exports, "SET_IS_CREATING_ISSUES", ()=>$941b6f0c52cc7d6a$export$6a40659e7d7d768c);
    $parcel$export(module.exports, "clearInlineCreate", ()=>$941b6f0c52cc7d6a$export$619728c77bf26024);
    $parcel$export(module.exports, "startInlineCreate", ()=>$941b6f0c52cc7d6a$export$3b53adae66ce2b28);
    $parcel$export(module.exports, "setIssueTypeId", ()=>$941b6f0c52cc7d6a$export$b3b6c9f64a9db332);
    $parcel$export(module.exports, "setProjectId", ()=>$941b6f0c52cc7d6a$export$b3b5d26bd744f328);
    $parcel$export(module.exports, "setSiblingId", ()=>$941b6f0c52cc7d6a$export$ef019bea9344af30);
    $parcel$export(module.exports, "setIssueTypeIdForHierarchy", ()=>$941b6f0c52cc7d6a$export$151bc49debc6e194);
    $parcel$export(module.exports, "updateInlineCreate", ()=>$941b6f0c52cc7d6a$export$c3b45d8c36e75acb);
    $parcel$export(module.exports, "setGlobalCreateIssue", ()=>$941b6f0c52cc7d6a$export$e8934634f77b30a3);
    $parcel$export(module.exports, "setOpenLocked", ()=>$941b6f0c52cc7d6a$export$c2b4d1403d5a92c9);
    $parcel$export(module.exports, "setIsCreatingIssues", ()=>$941b6f0c52cc7d6a$export$fe44897a6b27fbce);
    const $941b6f0c52cc7d6a$export$1a9a8a01b7182017 = 'state.ui.main.tabs.roadmap.scope.inline-create.CLEAR_INLINE_CREATE';
    const $941b6f0c52cc7d6a$export$b5b06234341e4e89 = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_ISSUE_TYPE_ID';
    const $941b6f0c52cc7d6a$export$7a6c7dbea71065c6 = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_PROJECT_ID';
    const $941b6f0c52cc7d6a$export$98cade42b641eb6c = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_SIBLING_ID';
    const $941b6f0c52cc7d6a$export$e4b545016f01a38c = 'state.ui.main.tabs.roadmap.scope.inline-create.START_INLINE_CREATE';
    const $941b6f0c52cc7d6a$export$32dcb826f20ea035 = 'state.ui.main.tabs.roadmap.scope.inline-create.UPDATE_INLINE_CREATE';
    const $941b6f0c52cc7d6a$export$70b83d224b93b6b8 = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_ISSUE_TYPE_ID_FOR_HIERARCHY';
    const $941b6f0c52cc7d6a$export$e335aa41e2ecdc00 = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_GLOBAL_CREATE_ISSUE';
    const $941b6f0c52cc7d6a$export$b6f8461edbea9f82 = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_OPEN_LOCKED';
    const $941b6f0c52cc7d6a$export$6a40659e7d7d768c = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_IS_CREATING_ISSUES';
    const $941b6f0c52cc7d6a$export$619728c77bf26024 = ()=>({
            type: $941b6f0c52cc7d6a$export$1a9a8a01b7182017
        });
    const $941b6f0c52cc7d6a$export$3b53adae66ce2b28 = (payload)=>({
            type: $941b6f0c52cc7d6a$export$e4b545016f01a38c,
            payload: payload
        });
    const $941b6f0c52cc7d6a$export$b3b6c9f64a9db332 = (issueTypeId)=>({
            type: $941b6f0c52cc7d6a$export$b5b06234341e4e89,
            payload: {
                issueTypeId: issueTypeId
            }
        });
    const $941b6f0c52cc7d6a$export$b3b5d26bd744f328 = (projectId)=>({
            type: $941b6f0c52cc7d6a$export$7a6c7dbea71065c6,
            payload: {
                projectId: projectId
            }
        });
    const $941b6f0c52cc7d6a$export$ef019bea9344af30 = (siblingId)=>({
            type: $941b6f0c52cc7d6a$export$98cade42b641eb6c,
            payload: {
                siblingId: siblingId
            }
        });
    const $941b6f0c52cc7d6a$export$151bc49debc6e194 = (hierarchyLevel, issueTypeId)=>({
            type: $941b6f0c52cc7d6a$export$70b83d224b93b6b8,
            payload: {
                hierarchyLevel: hierarchyLevel,
                issueTypeId: issueTypeId
            }
        });
    const $941b6f0c52cc7d6a$export$c3b45d8c36e75acb = (payload)=>({
            type: $941b6f0c52cc7d6a$export$32dcb826f20ea035,
            payload: payload
        });
    const $941b6f0c52cc7d6a$export$e8934634f77b30a3 = (isGlobalCreateIssue)=>({
            type: $941b6f0c52cc7d6a$export$e335aa41e2ecdc00,
            payload: {
                isGlobalCreateIssue: isGlobalCreateIssue
            }
        });
    const $941b6f0c52cc7d6a$export$c2b4d1403d5a92c9 = (payload)=>({
            type: $941b6f0c52cc7d6a$export$b6f8461edbea9f82,
            payload: payload
        });
    const $941b6f0c52cc7d6a$export$fe44897a6b27fbce = (isCreating)=>({
            type: $941b6f0c52cc7d6a$export$6a40659e7d7d768c,
            payload: {
                isCreatingIssues: isCreating
            }
        });
});
parcelRegister("4y9A5", function(module, exports) {
    $parcel$export(module.exports, "getBody", ()=>$7c752900b78c322b$export$135b49d4bc2964c6);
    $parcel$export(module.exports, "removeNode", ()=>$7c752900b78c322b$export$1d0aa160432dfea5);
    $parcel$export(module.exports, "getViewportSize", ()=>$7c752900b78c322b$export$125915cfb610b3c2);
    const $7c752900b78c322b$export$135b49d4bc2964c6 = ()=>{
        const body = document.body;
        if (!body) throw new Error('document body is not found');
        return body;
    };
    const $7c752900b78c322b$export$1d0aa160432dfea5 = (node)=>{
        if (node.parentNode) node.parentNode.removeChild(node);
    };
    const $7c752900b78c322b$export$125915cfb610b3c2 = ()=>{
        let width = 0;
        let height = 0;
        if (window.innerWidth !== undefined && window.innerHeight !== undefined) {
            width = Math.max(width, window.innerWidth);
            height = Math.max(height, window.innerHeight);
        }
        if (document.documentElement) {
            const { clientWidth: clientWidth, clientHeight: clientHeight } = document.documentElement;
            width = Math.max(width, clientWidth);
            height = Math.max(height, clientHeight);
        }
        return {
            width: width,
            height: height
        };
    };
});
parcelRegister("coVrx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3ca4c5bf0710e84$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f3ca4c5bf0710e84$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noMatchesText: {
            "id": "portfolio-3-portfolio.common.select.no-matches-text",
            "defaultMessage": "No matches"
        },
        rolledUpValueLabel: {
            "id": "portfolio-3-portfolio.common.select.rolled-up-value-label",
            "defaultMessage": "Rolled-up values"
        },
        releaseActualValueLabel: {
            "id": "portfolio-3-portfolio.common.select.release-actual-value-label",
            "defaultMessage": "Release of this issue"
        },
        sprintActualValueLabel: {
            "id": "portfolio-3-portfolio.common.select.sprint-actual-value-label",
            "defaultMessage": "Sprint of this issue"
        },
        teamActualValueLabel: {
            "id": "portfolio-3-portfolio.common.select.team-actual-value-label",
            "defaultMessage": "Team of this issue"
        }
    });
});
parcelRegister("jfSkn", function(module, exports) {
    $parcel$export(module.exports, "componentsContainer", ()=>$e0498f6383dead0e$export$77d38a6d62c7a7c9, (v)=>$e0498f6383dead0e$export$77d38a6d62c7a7c9 = v);
    $parcel$export(module.exports, "componentsContainerDisabled", ()=>$e0498f6383dead0e$export$f8fe21d67e4e5ecf, (v)=>$e0498f6383dead0e$export$f8fe21d67e4e5ecf = v);
    $parcel$export(module.exports, "disabled", ()=>$e0498f6383dead0e$export$683472f6198a076e, (v)=>$e0498f6383dead0e$export$683472f6198a076e = v);
    $parcel$export(module.exports, "hiddenContainer", ()=>$e0498f6383dead0e$export$182c1d64f1533c1d, (v)=>$e0498f6383dead0e$export$182c1d64f1533c1d = v);
    $parcel$export(module.exports, "item", ()=>$e0498f6383dead0e$export$7061c75fc5af8b7e, (v)=>$e0498f6383dead0e$export$7061c75fc5af8b7e = v);
    $parcel$export(module.exports, "itemsWrapper", ()=>$e0498f6383dead0e$export$c11ed2585ba4746a, (v)=>$e0498f6383dead0e$export$c11ed2585ba4746a = v);
    $parcel$export(module.exports, "labelsContainer", ()=>$e0498f6383dead0e$export$dc574f36aa67ced6, (v)=>$e0498f6383dead0e$export$dc574f36aa67ced6 = v);
    $parcel$export(module.exports, "tagContainer", ()=>$e0498f6383dead0e$export$89a4c13858b336ea, (v)=>$e0498f6383dead0e$export$89a4c13858b336ea = v);
    var $e0498f6383dead0e$export$77d38a6d62c7a7c9;
    var $e0498f6383dead0e$export$f8fe21d67e4e5ecf;
    var $e0498f6383dead0e$export$683472f6198a076e;
    var $e0498f6383dead0e$export$182c1d64f1533c1d;
    var $e0498f6383dead0e$export$7061c75fc5af8b7e;
    var $e0498f6383dead0e$export$c11ed2585ba4746a;
    var $e0498f6383dead0e$export$dc574f36aa67ced6;
    var $e0498f6383dead0e$export$89a4c13858b336ea;
    $e0498f6383dead0e$export$77d38a6d62c7a7c9 = `or0DHa_componentsContainer`;
    $e0498f6383dead0e$export$f8fe21d67e4e5ecf = `or0DHa_componentsContainerDisabled`;
    $e0498f6383dead0e$export$683472f6198a076e = `or0DHa_disabled`;
    $e0498f6383dead0e$export$182c1d64f1533c1d = `or0DHa_hiddenContainer`;
    $e0498f6383dead0e$export$7061c75fc5af8b7e = `or0DHa_item`;
    $e0498f6383dead0e$export$c11ed2585ba4746a = `or0DHa_itemsWrapper`;
    $e0498f6383dead0e$export$dc574f36aa67ced6 = `or0DHa_labelsContainer`;
    $e0498f6383dead0e$export$89a4c13858b336ea = `or0DHa_tagContainer`;
});
parcelRegister("dzoWn", function(module, exports) {
    $parcel$export(module.exports, "selectStyles", ()=>$e9a198b18b8fd814$export$70a9ea0b017c448a);
    const $e9a198b18b8fd814$export$70a9ea0b017c448a = {
        container: (styles, { selectProps: { menuIsOpen: menuIsOpen } })=>({
                ...styles,
                ...menuIsOpen ? {
                    zIndex: 1
                } : {}
            }),
        control: (styles, { hasValue: hasValue, selectProps: { menuIsOpen: menuIsOpen } })=>menuIsOpen ? {
                ...styles,
                zIndex: 99999
            } : {
                ...styles,
                background: 'none',
                borderColor: 'transparent',
                [':hover']: {
                    ...styles[':hover'],
                    background: 'none',
                    ...hasValue ? {
                        borderColor: 'transparent'
                    } : {}
                }
            },
        dropdownIndicator (styles) {
            return {
                ...styles,
                alignSelf: 'flex-start'
            };
        },
        valueContainer (styles) {
            return {
                ...styles,
                maxHeight: 150,
                overflow: 'auto',
                flex: '1'
            };
        }
    };
});
parcelRegister("tVHge", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$674fc58980f2e6f0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    var $3bDjY;
    var $4nDwW = parcelRequire("4nDwW");
    const $674fc58980f2e6f0$export$6170d04d90efda45 = ({ title: title, avatarUrl: avatarUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            delay: 1000,
            content: title
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($674fc58980f2e6f0$var$ReadViewContainer, null, (0, $4nDwW.isDefined)(avatarUrl) ? (0, ($parcel$interopDefault($5uXOq))).createElement($674fc58980f2e6f0$var$AvatarContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            borderColor: "transparent",
            src: avatarUrl,
            size: "xsmall"
        })) : null, (0, ($parcel$interopDefault($5uXOq))).createElement($674fc58980f2e6f0$var$NameWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, title))));
    var $674fc58980f2e6f0$export$2e2bcd8739ae039 = $674fc58980f2e6f0$export$6170d04d90efda45;
    const $674fc58980f2e6f0$var$ReadViewContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1h6o _1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $674fc58980f2e6f0$var$NameWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _vwz4gktf _s7n4nkob _1e0c1o8l",
                __cmplp.className
            ])
        });
    });
    const $674fc58980f2e6f0$var$AvatarContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3igktf _18s812x7 _1yt41b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jRbER", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29beacf6b7c5729c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4wTHP = parcelRequire("4wTHP");
    var $h3R7G = parcelRequire("h3R7G");
    var $29beacf6b7c5729c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $4wTHP.default))((0, $h3R7G.default));
});
parcelRegister("4wTHP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b3c7c2d65d46e5c$export$2e2bcd8739ae039);
    var $lIIFg = parcelRequire("lIIFg");
    var $eiyR0 = parcelRequire("eiyR0");
    const $8b3c7c2d65d46e5c$var$mapDispatchToProps = (dispatch)=>({
            clearCustomFieldFilter: (customFields)=>{
                customFields.forEach((customField)=>dispatch((0, $eiyR0.clear)({
                        customField: customField
                    })));
            },
            clearFilter: (filterId)=>{
                dispatch((0, $lIIFg.clear)(filterId));
            }
        });
    var $8b3c7c2d65d46e5c$export$2e2bcd8739ae039 = $8b3c7c2d65d46e5c$var$mapDispatchToProps;
});
parcelRegister("lIIFg", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$3a67e50cbe8ba549$export$4a991c87e640ef77);
    $parcel$export(module.exports, "CHANGE", ()=>$3a67e50cbe8ba549$export$4bef51da9b53f613);
    $parcel$export(module.exports, "CLEAR", ()=>$3a67e50cbe8ba549$export$6c4d37c7f376a1de);
    $parcel$export(module.exports, "CLEAR_ALL", ()=>$3a67e50cbe8ba549$export$a4b3b534f9c4179f);
    $parcel$export(module.exports, "change", ()=>$3a67e50cbe8ba549$export$d8a7b8f475ec0161);
    $parcel$export(module.exports, "clear", ()=>$3a67e50cbe8ba549$export$42ffd38884aecdac);
    $parcel$export(module.exports, "clearAll", ()=>$3a67e50cbe8ba549$export$1042faa6df30c26);
    const $3a67e50cbe8ba549$export$4a991c87e640ef77 = 'state.domain.view-settings.filters.RESET';
    const $3a67e50cbe8ba549$export$4bef51da9b53f613 = 'state.domain.view-settings.filters.CHANGE';
    const $3a67e50cbe8ba549$export$6c4d37c7f376a1de = 'state.domain.view-settings.filters.CLEAR';
    const $3a67e50cbe8ba549$export$a4b3b534f9c4179f = 'state.domain.view-settings.filters.CLEAR_ALL';
    const $3a67e50cbe8ba549$export$aad8462122ac592b = (payload)=>({
            type: $3a67e50cbe8ba549$export$4a991c87e640ef77,
            payload: payload
        });
    const $3a67e50cbe8ba549$export$d8a7b8f475ec0161 = (payload, bypassAnalytics = false)=>({
            type: $3a67e50cbe8ba549$export$4bef51da9b53f613,
            payload: payload,
            bypassAnalytics: bypassAnalytics
        });
    const $3a67e50cbe8ba549$export$42ffd38884aecdac = (payload)=>({
            type: $3a67e50cbe8ba549$export$6c4d37c7f376a1de,
            payload: payload
        });
    const $3a67e50cbe8ba549$export$1042faa6df30c26 = ()=>({
            type: $3a67e50cbe8ba549$export$a4b3b534f9c4179f
        });
});
parcelRegister("eiyR0", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$c4c7b3ad4aceb934$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$c4c7b3ad4aceb934$export$e271b26eefe41db8);
    $parcel$export(module.exports, "CLEAR", ()=>$c4c7b3ad4aceb934$export$6c4d37c7f376a1de);
    $parcel$export(module.exports, "CLEAR_ALL", ()=>$c4c7b3ad4aceb934$export$a4b3b534f9c4179f);
    $parcel$export(module.exports, "reset", ()=>$c4c7b3ad4aceb934$export$aad8462122ac592b);
    $parcel$export(module.exports, "update", ()=>$c4c7b3ad4aceb934$export$722fbec263ad908a);
    $parcel$export(module.exports, "clear", ()=>$c4c7b3ad4aceb934$export$42ffd38884aecdac);
    $parcel$export(module.exports, "clearAll", ()=>$c4c7b3ad4aceb934$export$1042faa6df30c26);
    const $c4c7b3ad4aceb934$export$4a991c87e640ef77 = 'state.domain.view-settings.filters.custom-field-filter.RESET';
    const $c4c7b3ad4aceb934$export$e271b26eefe41db8 = 'state.domain.view-settings.filters.custom-field-filter.UPDATE';
    const $c4c7b3ad4aceb934$export$6c4d37c7f376a1de = 'state.domain.view-settings.filters.custom-field-filter.CLEAR';
    const $c4c7b3ad4aceb934$export$a4b3b534f9c4179f = 'state.domain.view-settings.filters.custom-field-filter.CLEAR_ALL';
    const $c4c7b3ad4aceb934$export$aad8462122ac592b = (payload)=>({
            type: $c4c7b3ad4aceb934$export$4a991c87e640ef77,
            payload: payload
        });
    const $c4c7b3ad4aceb934$export$722fbec263ad908a = (payload)=>({
            type: $c4c7b3ad4aceb934$export$e271b26eefe41db8,
            payload: payload
        });
    const $c4c7b3ad4aceb934$export$42ffd38884aecdac = (payload)=>({
            type: $c4c7b3ad4aceb934$export$6c4d37c7f376a1de,
            payload: payload
        });
    const $c4c7b3ad4aceb934$export$1042faa6df30c26 = (payload)=>({
            type: $c4c7b3ad4aceb934$export$a4b3b534f9c4179f,
            payload: payload
        });
});
parcelRegister("h3R7G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$372f9d1ca73c8faa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $aCpcO;
    var $5z9YS = parcelRequire("5z9YS");
    var $376GG = parcelRequire("376GG");
    function $372f9d1ca73c8faa$var$ClearFilterForIssueSearchWarning({ intl: intl, filters: filters, clearFilter: clearFilter, clearCustomFieldFilter: clearCustomFieldFilter }) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $376GG.clearButton
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "link",
            onClick: ()=>{
                filters.forEach((item)=>{
                    if (item.type === 'custom') clearCustomFieldFilter(item.filters);
                    else clearFilter(item.id);
                });
            }
        }, intl.formatMessage((0, $5z9YS.default).clearFilterLink, {
            filterCount: filters && filters.reduce((acc, item)=>acc + (item.type === 'custom' ? item.filters.length : 1), 0)
        }))));
    }
    var $372f9d1ca73c8faa$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($372f9d1ca73c8faa$var$ClearFilterForIssueSearchWarning);
});
parcelRegister("aCpcO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ee660cadc7fa9e5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2rqOp;
    var $fVnbM;
    const $0ee660cadc7fa9e5$var$Button = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { ariaLabel: ariaLabel, isLoading: isLoading, ...restProps } = props;
        if (isLoading !== undefined && isLoading !== null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            ref: ref,
            isLoading: isLoading,
            ...restProps
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ref: ref,
            ...restProps,
            "aria-label": ariaLabel
        });
    });
    var $0ee660cadc7fa9e5$export$2e2bcd8739ae039 = $0ee660cadc7fa9e5$var$Button;
});
parcelRegister("5z9YS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9993027f2777db6f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9993027f2777db6f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clearFilterLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.component-slot-content.issue-search-warning-clear-filter.clear-filter-link",
            "defaultMessage": "Clear {filterCount, plural, one {this filter} other {these filters}}"
        }
    });
});
parcelRegister("376GG", function(module, exports) {
    $parcel$export(module.exports, "clearButton", ()=>$2447368b7546a7ae$export$52aab205873de00, (v)=>$2447368b7546a7ae$export$52aab205873de00 = v);
    var $2447368b7546a7ae$export$52aab205873de00;
    $2447368b7546a7ae$export$52aab205873de00 = `wxrwna_clearButton`;
});
parcelRegister("l9sxf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$edb8ef6367b04ee1$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $bC2fB;
    var $562Ic = parcelRequire("562Ic");
    const $edb8ef6367b04ee1$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        viewMode: (0, $kWDpn.getViewMode),
        isReadOnly: $1CGdp.isReadOnly
    });
    var $edb8ef6367b04ee1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($edb8ef6367b04ee1$var$mapStateToProps, {})((0, $562Ic.default));
});
parcelRegister("1CGdp", function(module, exports) {
    $parcel$export(module.exports, "getMode", ()=>$61211b3862899246$export$1fc0f6205829e19c);
    $parcel$export(module.exports, "getAnalyticsEvent", ()=>$61211b3862899246$export$32b073657518c6bb);
    $parcel$export(module.exports, "isOptimizedMode", ()=>$61211b3862899246$export$cd4751658902d6e8);
    $parcel$export(module.exports, "isReadOnlyPure", ()=>$61211b3862899246$export$37f5d101f9e0e691);
    $parcel$export(module.exports, "isReadOnly", ()=>$61211b3862899246$export$2498094d90b6ac72);
    $parcel$export(module.exports, "isArchived", ()=>$61211b3862899246$export$e254a38a69007d83);
    $parcel$export(module.exports, "isReportMode", ()=>$61211b3862899246$export$e8610bde98f41d48);
    $parcel$export(module.exports, "isExportMode", ()=>$61211b3862899246$export$b01a4f610a5e4f02);
    $parcel$export(module.exports, "isExportPreview", ()=>$61211b3862899246$export$ad6637fa30ef33ef);
    $parcel$export(module.exports, "isEditMode", ()=>$61211b3862899246$export$57957ca6633a6742);
    $parcel$export(module.exports, "isConfluenceMacro", ()=>$61211b3862899246$export$5e9f5d03e746bc0e);
    $parcel$export(module.exports, "isEmbed", ()=>$61211b3862899246$export$6a4806a2b2fc6ddd);
    $parcel$export(module.exports, "isConfluenceMacroProxy", ()=>$61211b3862899246$export$22aa145eff09f442);
    $parcel$export(module.exports, "isSmartLink", ()=>$61211b3862899246$export$c506b995404fa02e);
    $parcel$export(module.exports, "getPlanUserRole", ()=>$61211b3862899246$export$7f15cac1ccc346b0);
    $parcel$export(module.exports, "getPlanModeForAnalytics", ()=>$61211b3862899246$export$399cb6b07601f91);
    $parcel$export(module.exports, "getIsPlanInfoReady", ()=>$61211b3862899246$export$9f4fce2c8690a6c4);
    var $5jgat;
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $idmiV = parcelRequire("idmiV");
    const $61211b3862899246$export$1fc0f6205829e19c = (state)=>state.domain.app.mode;
    const $61211b3862899246$export$abc1d5d6f276a713 = (state)=>state.domain.plan.planStatus === 'ARCHIVED';
    const $61211b3862899246$export$534eb0b3e1a26ec7 = (state)=>state.domain.app.isExportPreview;
    const $61211b3862899246$export$fb4d124cbc4fe01f = (state)=>state.domain.app.hasReportedInitialLoadAnalytics;
    const $61211b3862899246$export$32b073657518c6bb = (state)=>state.domain.app.analyticsEvent;
    const $61211b3862899246$export$cd4751658902d6e8 = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], (mode)=>mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771));
    const $61211b3862899246$export$37f5d101f9e0e691 = (mode)=>mode === (0, $ab4be2e1e204af69$export$b07c15b79440feb8) || mode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) || mode === (0, $ab4be2e1e204af69$export$f79b1fae3e63e441);
    const $61211b3862899246$export$2498094d90b6ac72 = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], $61211b3862899246$export$37f5d101f9e0e691);
    const $61211b3862899246$export$e254a38a69007d83 = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$abc1d5d6f276a713
    ], (archived)=>archived);
    const $61211b3862899246$export$e8610bde98f41d48 = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], (mode)=>mode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) || mode === (0, $ab4be2e1e204af69$export$f79b1fae3e63e441));
    const $61211b3862899246$export$b01a4f610a5e4f02 = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], (mode)=>mode === (0, $ab4be2e1e204af69$export$f79b1fae3e63e441));
    const $61211b3862899246$export$ad6637fa30ef33ef = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c,
        $61211b3862899246$export$534eb0b3e1a26ec7
    ], (mode, isPreview)=>mode === (0, $ab4be2e1e204af69$export$f79b1fae3e63e441) && isPreview);
    const $61211b3862899246$export$57957ca6633a6742 = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], (mode)=>mode === (0, $ab4be2e1e204af69$export$250171a898bf7ef));
    const $61211b3862899246$export$5e9f5d03e746bc0e = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], (mode)=>mode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) && (0, $idmiV.isConfluenceReportView)());
    const $61211b3862899246$export$6a4806a2b2fc6ddd = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], (mode)=>mode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) && (0, $idmiV.isEmbedReportView)());
    const $61211b3862899246$export$22aa145eff09f442 = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], (mode)=>mode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) && (0, $idmiV.isConfluenceReportProxyView)());
    const $61211b3862899246$export$c506b995404fa02e = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], (mode)=>mode === (0, $ab4be2e1e204af69$export$b07c15b79440feb8) && (0, (0, parcelRequire("5jgat")).isEmbedSmartLinkView)());
    const $61211b3862899246$export$7f15cac1ccc346b0 = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], (mode)=>{
        switch(mode){
            case 0, $ab4be2e1e204af69$export$e3d31417f21c1ce7:
            case 0, $ab4be2e1e204af69$export$f79b1fae3e63e441:
                return (0, $idmiV.isConfluenceReportView)() ? (0, $TTKUQ.PLAN_USER_ROLE).CONFLUENCE_CONSUMER : (0, $TTKUQ.PLAN_USER_ROLE).REPORT_CONSUMER;
            case 0, $ab4be2e1e204af69$export$b07c15b79440feb8:
                return (0, $TTKUQ.PLAN_USER_ROLE).VIEWER;
            default:
                return (0, $TTKUQ.PLAN_USER_ROLE).EDITOR;
        }
    });
    const $61211b3862899246$export$47e5056eea334725 = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$7f15cac1ccc346b0
    ], (planUserRole)=>planUserRole === (0, $TTKUQ.PLAN_USER_ROLE).EDITOR);
    const $61211b3862899246$export$6c84b521e280798b = {
        REPORT: 'REPORT',
        EXPORT: 'EXPORT',
        READONLY: 'READ-ONLY',
        EDIT: 'EDIT'
    };
    const $61211b3862899246$export$399cb6b07601f91 = (0, $3YtPS.createSelector)([
        $61211b3862899246$export$1fc0f6205829e19c
    ], (mode)=>{
        switch(mode){
            case 0, $ab4be2e1e204af69$export$e3d31417f21c1ce7:
                return $61211b3862899246$export$6c84b521e280798b.REPORT;
            case 0, $ab4be2e1e204af69$export$f79b1fae3e63e441:
                return $61211b3862899246$export$6c84b521e280798b.EXPORT;
            case 0, $ab4be2e1e204af69$export$b07c15b79440feb8:
                return $61211b3862899246$export$6c84b521e280798b.READONLY;
            default:
                return $61211b3862899246$export$6c84b521e280798b.EDIT;
        }
    });
    const $61211b3862899246$export$9f4fce2c8690a6c4 = (state)=>state.domain.app.isPlanInfoReady;
});
parcelRegister("5jgat", function(module, exports) {
    $parcel$export(module.exports, "isEmbedSmartLinkView", ()=>$cdc5cbb71bc67330$export$3ede2a0e58c65203);
    const $cdc5cbb71bc67330$export$3ede2a0e58c65203 = ()=>window && window?.location.pathname.includes('plans') && window?.location.pathname.includes('scenarios') && window?.location.pathname.includes('/embed');
});
const $ab4be2e1e204af69$export$250171a898bf7ef = 'state.domain.app.EDIT';
const $ab4be2e1e204af69$export$e3d31417f21c1ce7 = 'state.domain.app.REPORT';
const $ab4be2e1e204af69$export$7536581a3f6533cb = 'state.domain.app.OPTIMIZING';
const $ab4be2e1e204af69$export$e91bb82ec00eb771 = 'state.domain.app.OPTIMIZED';
const $ab4be2e1e204af69$export$b07c15b79440feb8 = 'state.domain.app.READONLY';
const $ab4be2e1e204af69$export$f79b1fae3e63e441 = 'state.domain.app.EXPORT';
parcelRegister("kWDpn", function(module, exports) {
    $parcel$export(module.exports, "getViewSettings", ()=>$7af49da63dc7625f$export$3ae70db4a97563c);
    $parcel$export(module.exports, "getIsCalendarView", ()=>$7af49da63dc7625f$export$7ac48ee147a124b8);
    $parcel$export(module.exports, "getFiltersViewSettings", ()=>$7af49da63dc7625f$export$de5b47246a90a380);
    $parcel$export(module.exports, "getColorByViewSettings", ()=>$7af49da63dc7625f$export$89c287e1b70fc517);
    $parcel$export(module.exports, "getTimeScaleViewSettings", ()=>$7af49da63dc7625f$export$bb9c5abbffcc2d9);
    $parcel$export(module.exports, "getIssueExpansionsViewSettings", ()=>$7af49da63dc7625f$export$667cd472c0cbffff);
    $parcel$export(module.exports, "getFilterOptionsViewSettings", ()=>$7af49da63dc7625f$export$7b90d9dd3b52e40d);
    $parcel$export(module.exports, "getRollupViewSettings", ()=>$7af49da63dc7625f$export$cb42a8226d9928a0);
    $parcel$export(module.exports, "getHighlightedVersionsViewSettings", ()=>$7af49da63dc7625f$export$24cd3e812c6fd651);
    $parcel$export(module.exports, "getComponentGroupsViewSettings", ()=>$7af49da63dc7625f$export$29948f4864a35d5);
    $parcel$export(module.exports, "getLabelsGroupViewSettings", ()=>$7af49da63dc7625f$export$3a3f88dcba27590);
    $parcel$export(module.exports, "getCustomFieldValuesGroupsViewSettings", ()=>$7af49da63dc7625f$export$c6774389fcc31261);
    $parcel$export(module.exports, "getWarningViewSettings", ()=>$7af49da63dc7625f$export$bff0f8c53c029824);
    $parcel$export(module.exports, "getVisualisationViewSettings", ()=>$7af49da63dc7625f$export$3815c5ababe87c29);
    $parcel$export(module.exports, "getShowRolledUpDates", ()=>$7af49da63dc7625f$export$9bb477be981b6a4e);
    $parcel$export(module.exports, "getDependencySettings", ()=>$7af49da63dc7625f$export$5b652ca76283f3ee);
    $parcel$export(module.exports, "getShowRolledUpOthers", ()=>$7af49da63dc7625f$export$37497680880cdb7c);
    $parcel$export(module.exports, "getDependencySettingsDisplay", ()=>$7af49da63dc7625f$export$52fff7345d751053);
    $parcel$export(module.exports, "getComponentGroupsById", ()=>$7af49da63dc7625f$export$16fb8d1a8cf90d64);
    $parcel$export(module.exports, "getLabelGroupsById", ()=>$7af49da63dc7625f$export$92cc93af4bfd2a4f);
    $parcel$export(module.exports, "getViewMode", ()=>$7af49da63dc7625f$export$956c1b0ab1ddf9f1);
    $parcel$export(module.exports, "getFieldColumnsViewSettingsByViewMode", ()=>$7af49da63dc7625f$export$685fbbb7108a90e1);
    var $2rMKg;
    var $3J2mc;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    const $7af49da63dc7625f$export$3ae70db4a97563c = (state)=>state.domain.viewSettings;
    const $7af49da63dc7625f$export$7ac48ee147a124b8 = (state)=>state.domain.viewSettings.activeFilterViewV0 === 'calendar';
    const $7af49da63dc7625f$export$de5b47246a90a380 = (state)=>$7af49da63dc7625f$export$7ac48ee147a124b8(state) ? state.domain.viewSettings.calendarFiltersV1 : state.domain.viewSettings.filtersV1;
    const $7af49da63dc7625f$export$89c287e1b70fc517 = (state)=>state.domain.viewSettings.colourByV2;
    const $7af49da63dc7625f$export$bb9c5abbffcc2d9 = (state)=>state.domain.viewSettings.timeScaleV1;
    const $7af49da63dc7625f$export$667cd472c0cbffff = (state)=>state.domain.viewSettings.issueExpansionsV0;
    const $7af49da63dc7625f$export$cda31cc46b3c6999 = (state)=>state.domain.viewSettings.fieldColumnsV0;
    const $7af49da63dc7625f$var$getListFieldColumnsViewSettings = (state)=>state.domain.viewSettings.listFieldColumnsV0;
    const $7af49da63dc7625f$export$7b90d9dd3b52e40d = (state)=>state.domain.viewSettings.filterOptionsV1;
    const $7af49da63dc7625f$export$cb42a8226d9928a0 = (state)=>state.domain.viewSettings.rollupSettingsV0;
    const $7af49da63dc7625f$export$24cd3e812c6fd651 = (state)=>state.domain.viewSettings.highlightedVersionsV0;
    const $7af49da63dc7625f$export$29948f4864a35d5 = (state)=>state.domain.viewSettings.componentGroupsV0;
    const $7af49da63dc7625f$export$3a3f88dcba27590 = (state)=>state.domain.viewSettings.labelGroupsV0;
    const $7af49da63dc7625f$export$c6774389fcc31261 = (state)=>state.domain.viewSettings.customFieldValuesGroupsV0;
    const $7af49da63dc7625f$export$bff0f8c53c029824 = (state)=>state.domain.viewSettings.warningSettingsV1;
    const $7af49da63dc7625f$export$545de9d49422239c = (state)=>state.domain.viewSettings.dateConstraintsV0;
    const $7af49da63dc7625f$export$3815c5ababe87c29 = (state)=>state.domain.viewSettings.visualisationsV0;
    const $7af49da63dc7625f$export$9bb477be981b6a4e = (state)=>$7af49da63dc7625f$export$cb42a8226d9928a0(state).showingRolledUpDate;
    const $7af49da63dc7625f$export$5b652ca76283f3ee = (state)=>state.domain.viewSettings.dependencySettingsV0;
    const $7af49da63dc7625f$var$getViewModeViewSettingsDefault = {
        mode: (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE
    };
    const $7af49da63dc7625f$export$56600ac9e6d65e1d = (state)=>state.domain.viewSettings.viewModeV0 || $7af49da63dc7625f$var$getViewModeViewSettingsDefault;
    const $7af49da63dc7625f$export$37497680880cdb7c = (0, $3YtPS.createSelector)([
        $7af49da63dc7625f$export$cb42a8226d9928a0
    ], (rollupViewSettings)=>rollupViewSettings.showRolledUpOthers);
    const $7af49da63dc7625f$export$52fff7345d751053 = (0, $3YtPS.createSelector)([
        $7af49da63dc7625f$export$5b652ca76283f3ee
    ], (dependencySettings)=>dependencySettings.display);
    const $7af49da63dc7625f$export$16fb8d1a8cf90d64 = (0, $3YtPS.createSelector)([
        $7af49da63dc7625f$export$29948f4864a35d5
    ], (componentGroupsViewSettings)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), componentGroupsViewSettings));
    const $7af49da63dc7625f$export$92cc93af4bfd2a4f = (0, $3YtPS.createSelector)([
        $7af49da63dc7625f$export$3a3f88dcba27590
    ], (labelsGroupViewSettings)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), labelsGroupViewSettings));
    const $7af49da63dc7625f$export$956c1b0ab1ddf9f1 = (0, $3YtPS.createSelector)([
        $7af49da63dc7625f$export$56600ac9e6d65e1d
    ], ({ mode: mode })=>mode);
    const $7af49da63dc7625f$export$685fbbb7108a90e1 = (0, $3YtPS.createSelector)([
        $7af49da63dc7625f$export$cda31cc46b3c6999,
        $7af49da63dc7625f$var$getListFieldColumnsViewSettings,
        $7af49da63dc7625f$export$956c1b0ab1ddf9f1
    ], (fieldColumns, listFieldColumns, viewMode)=>viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST ? listFieldColumns : fieldColumns);
});
const $10afd8ee8013ce61$export$526fec6b76d5bc5 = 'all_other_issues';
parcelRegister("562Ic", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46a40dd9005c6807$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b1yMp;
    var $fkC9P;
    var $70lzE;
    var $644ik;
    var $8r8wv;
    var $2rMKg;
    var $h35CY;
    var $cDmJv;
    var $6cslg;
    var $fVnbM;
    var $6Ingq;
    var $lj8SI;
    var $1I7E8;
    var $dC5iT;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $1iMQ1;
    var $bVLLf;
    var $86zlq;
    var $1qMX7;
    var $7lpPk = parcelRequire("7lpPk");
    var $g7G9N = parcelRequire("g7G9N");
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    var $cSDJf = parcelRequire("cSDJf");
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $lVJAU;
    var $fAImD = parcelRequire("fAImD");
    var $4lfs5 = parcelRequire("4lfs5");
    var $4O3BE = parcelRequire("4O3BE");
    var $bONMW = parcelRequire("bONMW");
    var $2YLR0 = parcelRequire("2YLR0");
    var $8nAYy = parcelRequire("8nAYy");
    const $46a40dd9005c6807$var$getColumnTitle = (column, intl)=>{
        if (typeof column.title === 'string') return (0, parcelRequire("b1yMp")).default((0, parcelRequire("fkC9P")).default(''), (0, parcelRequire("644ik")).default((0, parcelRequire("70lzE")).default(0), (0, parcelRequire("cDmJv")).default), (0, parcelRequire("6cslg")).default)(column.title);
        return intl.formatMessage(column.groupTitle || column.title);
    };
    const $46a40dd9005c6807$var$SelectMenuContainer = ({ isVisuallyRefreshed: isVisuallyRefreshed, children: children })=>{
        return isVisuallyRefreshed ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingInline: "space.100",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.select"
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $2YLR0["afm-dropdown-menu-header"],
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.select"
        }, children);
    };
    const $46a40dd9005c6807$var$localizeColumns = (columns, intl)=>columns.map((column)=>{
            const { id: id, isVisible: isVisible, isCustomField: isCustomField, projectId: projectId } = column;
            const localizedTitle = $46a40dd9005c6807$var$getColumnTitle(column, intl);
            const localizedColumn = {
                id: id,
                isVisible: isVisible,
                localizedTitle: localizedTitle,
                isCustomField: isCustomField,
                projectId: projectId
            };
            return localizedColumn;
        });
    const $46a40dd9005c6807$var$AdvancedFieldsMenu = ({ columns: columns, isDropMenuOpenByDefault: isDropMenuOpenByDefault, getMatchingConfiguredDate: getMatchingConfiguredDate, hideColumn: hideColumn, moveColumn: moveColumn, showColumn: showColumn, isDropMenuSelectOpenByDefault: isDropMenuSelectOpenByDefault = false, isReadOnly: isReadOnly, viewMode: viewMode, id: id, isShortcutEnabled: isShortcutEnabled = true, renderMenuTrigger: renderMenuTrigger, placement: placement = 'bottom-start' })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = intl;
        const [localizedColumns, setLocalizedColumns] = (0, $5uXOq.useState)($46a40dd9005c6807$var$localizeColumns(columns, intl));
        const [isAdvancedFieldsMenuOpen, setIsAdvancedFieldsMenuOpen] = (0, $5uXOq.useState)(isDropMenuOpenByDefault || false);
        (0, $5uXOq.useEffect)(()=>{
            setLocalizedColumns($46a40dd9005c6807$var$localizeColumns(columns, intl));
        }, [
            columns,
            intl
        ]);
        const toggleAdvancedFieldsMenu = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'fieldsMenu', {
                viewMode: viewMode,
                trigger: id
            });
            setIsAdvancedFieldsMenuOpen(!isAdvancedFieldsMenuOpen);
        }, [
            createAnalyticsEvent,
            id,
            viewMode,
            isAdvancedFieldsMenuOpen
        ]);
        const openDropMenu = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'fieldsMenu', {
                viewMode: viewMode,
                trigger: id
            });
            setIsAdvancedFieldsMenuOpen(true);
        }, [
            createAnalyticsEvent,
            id,
            viewMode
        ]);
        const updateRef = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            updateRef.current?.();
        }, [
            columns,
            updateRef
        ]);
        const planId = (0, $g7G9N.getPlanId)();
        const scenarioId = (0, $g7G9N.getScenarioId)();
        const getSearchFieldOptions = (options)=>{
            const listableColumns = (0, $8nAYy.getListableColumns)(options);
            return (0, parcelRequire("h35CY")).default((option)=>(0, $4nDwW.isDefined)(option) && option[0].localizedTitle, listableColumns).map((group)=>{
                const localizedTitle = group && group[0] ? group[0].localizedTitle : '';
                const columns = (0, parcelRequire("h35CY")).default((0, parcelRequire("2rMKg")).default('id'), group);
                const compoundId = columns.map((0, parcelRequire("2rMKg")).default('id')).join(':');
                const configurableDate = getMatchingConfiguredDate(compoundId);
                return {
                    value: group,
                    label: localizedTitle,
                    isCustomField: group.find((e)=>e.isCustomField),
                    configurableDate: configurableDate
                };
            });
        };
        const renderCustomFieldLozenge = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $2YLR0["afm-custom-field-lozenge"],
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.custom-lozenge"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, intl.formatMessage((0, $4O3BE.default).advancedFieldsMenuCustomFieldLozenge)));
        const renderOptionLabel = (option)=>{
            const { configurableDate: configurableDate, label: label, isCustomField: isCustomField, value: value = [] } = option;
            const tooltip = (0, $fAImD.getConfiguredDateTooltip)(configurableDate);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $2YLR0["afm-field-option"],
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.option-${value[0] && value[0].id}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $2YLR0["afm-field-option-title"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bVLLf")).default), {
                icon: configurableDate && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                    testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.option-${value[0] && value[0].id}.configurable-date-lozenge`
                }, formatMessage((0, $4O3BE.default).dateLozenge)),
                tooltip: tooltip && intl.formatMessage(tooltip, {
                    title: label
                }),
                mode: "inline"
            }, label)), isCustomField && (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $2YLR0["afm-field-option-custom-lozenge"]
            }, renderCustomFieldLozenge()));
        };
        const formatOptionLabel = (option)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $2YLR0["afm-select-option-label"]
            }, renderOptionLabel(option));
        const safeLocalizedColumns = localizedColumns.filter(({ id: id })=>id !== (0, $7lpPk.ADD_FIELDS_COLUMN_ID));
        const [selected, unselected] = (0, parcelRequire("8r8wv")).default((0, parcelRequire("2rMKg")).default('isVisible'), safeLocalizedColumns);
        const noFieldsMessage = intl.formatMessage(unselected && unselected.length ? (0, $4O3BE.default).advancedFieldsMenuNoFieldsMatchCriteria : (0, $4O3BE.default).advancedFieldsMenuAllFieldsSelected);
        const onSelectChange = (value, _)=>{
            if (value != null) value.value.forEach(({ id: id, isCustomField: isCustomField, projectId: projectId })=>{
                showColumn(id);
                if (isCustomField && projectId) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: 'changed',
                    actionSubject: 'select'
                }), 'addTmpCustomFieldToTimeline');
            });
        };
        const renderDialogContent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $2YLR0["afm-dropdown-container"],
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.menu"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($46a40dd9005c6807$var$SelectMenuContainer, {
                isVisuallyRefreshed: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2')
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cSDJf.default), {
                autoFocus: true,
                isTransparentBackground: false,
                options: getSearchFieldOptions(unselected),
                menuPlacement: "auto",
                value: null,
                onChange: onSelectChange,
                formatOptionLabel: formatOptionLabel,
                placeholder: intl.formatMessage((0, $4O3BE.default).advancedFieldsMenuSelectPlaceholder),
                noOptionsMessage: ()=>noFieldsMessage,
                menuIsOpen: isDropMenuSelectOpenByDefault,
                "aria-label": intl.formatMessage((0, $4O3BE.default).advancedFieldsMenuSelectLabel)
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bONMW.default), {
                selectedColumns: selected,
                moveColumn: moveColumn,
                hideColumn: hideColumn,
                getMatchingConfiguredDate: getMatchingConfiguredDate
            }), !isReadOnly && planId && scenarioId && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $2YLR0["afm-dropdown-menu-divider"]
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                onClick: ()=>push(`/jira/plans/${planId}/scenarios/${scenarioId}/settings/custom-fields`)
            }, intl.formatMessage((0, $4O3BE.default).advancedFieldsMenuManageCustomFieldsLink))));
        const renderTriggerButton = (triggerProps)=>{
            if (renderMenuTrigger !== undefined) return renderMenuTrigger({
                ...triggerProps,
                onClick: toggleAdvancedFieldsMenu,
                isSelected: isAdvancedFieldsMenuOpen
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                ...triggerProps,
                onClick: toggleAdvancedFieldsMenu,
                appearance: "subtle",
                isSelected: isAdvancedFieldsMenuOpen,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.trigger-menu-button",
                iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.trigger-menu-icon",
                    label: ""
                })
            }, intl.formatMessage((0, $ihPUd.default).fields));
        };
        const renderTrigger = (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: isShortcutEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qMX7")).default), {
                    letter: "A",
                    message: (0, $4O3BE.default).advancedFieldsMenuAddFieldTooltip
                }) : intl.formatMessage((0, $4O3BE.default).advancedFieldsMenuAddFieldTooltip),
                position: "bottom"
            }, renderTriggerButton(triggerProps));
        const renderContent = ({ update: update })=>{
            updateRef.current = update;
            return renderDialogContent();
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $2YLR0["afm-header-left"]
        }, isShortcutEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86zlq")).UseShortcuts), {
            shortcutKey: "KeyA",
            onKeyDown: openDropMenu
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            placement: placement,
            fallbackPlacements: [
                'bottom',
                'bottom-end'
            ],
            autoFocus: false,
            isOpen: isAdvancedFieldsMenuOpen,
            onClose: ()=>setIsAdvancedFieldsMenuOpen(false),
            popupComponent: (0, $4lfs5.default),
            trigger: renderTrigger,
            content: renderContent,
            shouldUseCaptureOnOutsideClick: true
        })));
    };
    var $46a40dd9005c6807$export$2e2bcd8739ae039 = $46a40dd9005c6807$var$AdvancedFieldsMenu;
});
parcelRegister("fkC9P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b296529656270ade$export$2e2bcd8739ae039);
    var $6huGS;
    var $b296529656270ade$var$join = (0, (0, parcelRequire("6huGS")).default)(1, 'join');
    var $b296529656270ade$export$2e2bcd8739ae039 = $b296529656270ade$var$join;
});
parcelRegister("6huGS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$492c231c82f3e9d2$export$2e2bcd8739ae039);
    var $c9RLn;
    var $j8oua;
    var $9J1HQ;
    var $thm1N;
    var $492c231c82f3e9d2$var$invoker = (0, (0, parcelRequire("c9RLn")).default)(function invoker(arity, method) {
        return (0, (0, parcelRequire("9J1HQ")).default)(arity + 1, function() {
            var target = arguments[arity];
            if (target != null && (0, (0, parcelRequire("j8oua")).default)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
            throw new TypeError((0, (0, parcelRequire("thm1N")).default)(target) + ' does not have a method named "' + method + '"');
        });
    });
    var $492c231c82f3e9d2$export$2e2bcd8739ae039 = $492c231c82f3e9d2$var$invoker;
});
parcelRegister("70lzE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$519944a9f0b65f1b$export$2e2bcd8739ae039);
    var $ccUYa;
    var $6OTrI;
    var $4J98j;
    var $cBX85;
    var $519944a9f0b65f1b$var$lensIndex = (0, (0, parcelRequire("ccUYa")).default)(function lensIndex(n) {
        return (0, (0, parcelRequire("6OTrI")).default)((0, (0, parcelRequire("4J98j")).default)(n), (0, (0, parcelRequire("cBX85")).default)(n));
    });
    var $519944a9f0b65f1b$export$2e2bcd8739ae039 = $519944a9f0b65f1b$var$lensIndex;
});
parcelRegister("6OTrI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f726c010cd86ad5$export$2e2bcd8739ae039);
    var $c9RLn;
    var $4Rr1a;
    var $4f726c010cd86ad5$var$lens = (0, (0, parcelRequire("c9RLn")).default)(function lens(getter, setter) {
        return function(toFunctorFn) {
            return function(target) {
                return (0, (0, parcelRequire("4Rr1a")).default)(function(focus) {
                    return setter(focus, target);
                }, toFunctorFn(getter(target)));
            };
        };
    });
    var $4f726c010cd86ad5$export$2e2bcd8739ae039 = $4f726c010cd86ad5$var$lens;
});
parcelRegister("4J98j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3712730519bfe13d$export$2e2bcd8739ae039);
    var $c9RLn;
    var $fsmuk;
    var $3712730519bfe13d$var$nth = (0, (0, parcelRequire("c9RLn")).default)(function nth(offset, list) {
        var idx = offset < 0 ? list.length + offset : offset;
        return (0, (0, parcelRequire("fsmuk")).default)(list) ? list.charAt(idx) : list[idx];
    });
    var $3712730519bfe13d$export$2e2bcd8739ae039 = $3712730519bfe13d$var$nth;
});
parcelRegister("644ik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46a672a3fb0bfba6$export$2e2bcd8739ae039);
    var $IYMZh;
    var $46a672a3fb0bfba6$var$Identity = function(x) {
        return {
            value: x,
            map: function(f) {
                return $46a672a3fb0bfba6$var$Identity(f(x));
            }
        };
    };
    var $46a672a3fb0bfba6$var$over = (0, (0, parcelRequire("IYMZh")).default)(function over(lens, f, x) {
        return lens(function(y) {
            return $46a672a3fb0bfba6$var$Identity(f(y));
        })(x).value;
    });
    var $46a672a3fb0bfba6$export$2e2bcd8739ae039 = $46a672a3fb0bfba6$var$over;
});
parcelRegister("h35CY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c697150523f7feb3$export$2e2bcd8739ae039);
    var $c9RLn;
    var $c697150523f7feb3$var$sortBy = (0, (0, parcelRequire("c9RLn")).default)(function sortBy(fn, list) {
        return Array.prototype.slice.call(list, 0).sort(function(a, b) {
            var aa = fn(a);
            var bb = fn(b);
            return aa < bb ? -1 : aa > bb ? 1 : 0;
        });
    });
    var $c697150523f7feb3$export$2e2bcd8739ae039 = $c697150523f7feb3$var$sortBy;
});
parcelRegister("cDmJv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$932ac2db94fb9c5d$export$2e2bcd8739ae039);
    var $6huGS;
    var $932ac2db94fb9c5d$var$toUpper = (0, (0, parcelRequire("6huGS")).default)(0, 'toUpperCase');
    var $932ac2db94fb9c5d$export$2e2bcd8739ae039 = $932ac2db94fb9c5d$var$toUpper;
});
parcelRegister("6cslg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4839d931d63adaf5$export$2e2bcd8739ae039);
    var $ccUYa;
    var $4839d931d63adaf5$var$ws = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
    var $4839d931d63adaf5$var$zeroWidth = '\u200b';
    var $4839d931d63adaf5$var$hasProtoTrim = typeof String.prototype.trim === 'function';
    var $4839d931d63adaf5$var$trim = !$4839d931d63adaf5$var$hasProtoTrim || $4839d931d63adaf5$var$ws.trim() || !$4839d931d63adaf5$var$zeroWidth.trim() ? (0, (0, parcelRequire("ccUYa")).default)(function trim(str) {
        var beginRx = new RegExp('^[' + $4839d931d63adaf5$var$ws + '][' + $4839d931d63adaf5$var$ws + ']*');
        var endRx = new RegExp('[' + $4839d931d63adaf5$var$ws + '][' + $4839d931d63adaf5$var$ws + ']*$');
        return str.replace(beginRx, '').replace(endRx, '');
    }) : (0, (0, parcelRequire("ccUYa")).default)(function trim(str) {
        return str.trim();
    });
    var $4839d931d63adaf5$export$2e2bcd8739ae039 = $4839d931d63adaf5$var$trim;
});
parcelRegister("1iMQ1", function(module, exports) {
    $parcel$export(module.exports, "DropMenuItem", ()=>$d77c8f7744cc698f$export$1d16dd19bd2e4d57);
    $parcel$export(module.exports, "default", ()=>$d77c8f7744cc698f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $BLPHT;
    var $6B7KL;
    var $co1wz;
    var $2OMDV;
    const $d77c8f7744cc698f$export$1d16dd19bd2e4d57 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('dropMenuItem', {
        onClick: 'clicked'
    })((0, (0, parcelRequire("6B7KL")).default));
    class $d77c8f7744cc698f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                defaultOpen: false,
                isLoading: false,
                isOpen: false,
                onOpenChange: ()=>{},
                placement: 'bottom-start',
                testId: ''
            };
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.isOpen !== this.props.isOpen) this.setState({
                isOpen: !!nextProps.isOpen
            });
        }
        render() {
            const { isOpen: isOpen } = this.state;
            const { children: children, isLoading: isLoading, placement: placement, testId: testId, trigger: trigger, shouldRenderToParent: shouldRenderToParent = true } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
                isOpen: isOpen,
                isLoading: isLoading,
                onOpenChange: this.handleOpenChange,
                placement: placement,
                testId: testId,
                trigger: trigger,
                shouldRenderToParent: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? shouldRenderToParent : true
            }, children);
        }
        constructor(...args){
            super(...args);
            this.state = {
                isOpen: this.props.defaultOpen || false
            };
            this.handleOpenChange = (attrs)=>{
                this.setState({
                    isOpen: attrs.isOpen
                });
                if (this.props.onOpenChange) this.props.onOpenChange(attrs);
            };
        }
    }
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("2OMDV", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsEventToProps", ()=>$28422a5dfa4a4065$export$3e9ef96ba97ea9dc);
    var $cb25w;
    const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key],
                    actionSubject: componentName
                }
            }), {});
    const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>(WrappedComponent)=>(0, (0, parcelRequire("cb25w")).default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);
});
parcelRegister("bVLLf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5c8d933905b97f8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $3bDjY;
    var $5N7xc = parcelRequire("5N7xc");
    const $a5c8d933905b97f8$var$TitleWithIcon = ({ icon: icon, tooltip: tooltip = '', mode: mode, children: children })=>{
        const titleStyle = (0, ($parcel$interopDefault($9ci4W)))({
            [$5N7xc.title]: true,
            [$5N7xc.__header]: mode === 'header'
        });
        const iconStyle = (0, ($parcel$interopDefault($9ci4W)))({
            [$5N7xc["title-icon"]]: true,
            [$5N7xc.__collapsed]: mode === 'collapsed'
        });
        const element = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: titleStyle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $5N7xc["truncate-text"]
        }, children), icon !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: iconStyle,
            "data-testid": "portfolio-3-common.sections.title-icon"
        }, icon));
        return tooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltip
        }, element) : element;
    };
    var $a5c8d933905b97f8$export$2e2bcd8739ae039 = $a5c8d933905b97f8$var$TitleWithIcon;
});
parcelRegister("5N7xc", function(module, exports) {
    $parcel$export(module.exports, "__collapsed", ()=>$43775f89248624f4$export$ee2c026c2cbf6421, (v)=>$43775f89248624f4$export$ee2c026c2cbf6421 = v);
    $parcel$export(module.exports, "__header", ()=>$43775f89248624f4$export$ff68220f8e4ae00, (v)=>$43775f89248624f4$export$ff68220f8e4ae00 = v);
    $parcel$export(module.exports, "collapsedSection", ()=>$43775f89248624f4$export$e075d8876bc6f9dd, (v)=>$43775f89248624f4$export$e075d8876bc6f9dd = v);
    $parcel$export(module.exports, "columnText", ()=>$43775f89248624f4$export$87335a0dd85d937a, (v)=>$43775f89248624f4$export$87335a0dd85d937a = v);
    $parcel$export(module.exports, "columnTextTitle", ()=>$43775f89248624f4$export$9f0f00525fe7c162, (v)=>$43775f89248624f4$export$9f0f00525fe7c162 = v);
    $parcel$export(module.exports, "columnTexts", ()=>$43775f89248624f4$export$94e99beec2cab04b, (v)=>$43775f89248624f4$export$94e99beec2cab04b = v);
    $parcel$export(module.exports, "drag-active", ()=>$43775f89248624f4$export$99d5fd10140fa6b7, (v)=>$43775f89248624f4$export$99d5fd10140fa6b7 = v);
    $parcel$export(module.exports, "handle", ()=>$43775f89248624f4$export$8f34ce051745d39e, (v)=>$43775f89248624f4$export$8f34ce051745d39e = v);
    $parcel$export(module.exports, "section", ()=>$43775f89248624f4$export$fe2e36411d703b3d, (v)=>$43775f89248624f4$export$fe2e36411d703b3d = v);
    $parcel$export(module.exports, "sections", ()=>$43775f89248624f4$export$5a1dbaa3e4449344, (v)=>$43775f89248624f4$export$5a1dbaa3e4449344 = v);
    $parcel$export(module.exports, "separator", ()=>$43775f89248624f4$export$3e523c77c1f23f8c, (v)=>$43775f89248624f4$export$3e523c77c1f23f8c = v);
    $parcel$export(module.exports, "title", ()=>$43775f89248624f4$export$fb184b623420d9be, (v)=>$43775f89248624f4$export$fb184b623420d9be = v);
    $parcel$export(module.exports, "title-icon", ()=>$43775f89248624f4$export$8465d27022f5235a, (v)=>$43775f89248624f4$export$8465d27022f5235a = v);
    $parcel$export(module.exports, "truncate-text", ()=>$43775f89248624f4$export$e6ca8839261504b0, (v)=>$43775f89248624f4$export$e6ca8839261504b0 = v);
    var $43775f89248624f4$export$ee2c026c2cbf6421;
    var $43775f89248624f4$export$ff68220f8e4ae00;
    var $43775f89248624f4$export$e075d8876bc6f9dd;
    var $43775f89248624f4$export$87335a0dd85d937a;
    var $43775f89248624f4$export$9f0f00525fe7c162;
    var $43775f89248624f4$export$94e99beec2cab04b;
    var $43775f89248624f4$export$99d5fd10140fa6b7;
    var $43775f89248624f4$export$8f34ce051745d39e;
    var $43775f89248624f4$export$fe2e36411d703b3d;
    var $43775f89248624f4$export$5a1dbaa3e4449344;
    var $43775f89248624f4$export$3e523c77c1f23f8c;
    var $43775f89248624f4$export$6ea4444824e687db;
    var $43775f89248624f4$export$fb184b623420d9be;
    var $43775f89248624f4$export$8465d27022f5235a;
    var $43775f89248624f4$export$e6ca8839261504b0;
    $43775f89248624f4$export$ee2c026c2cbf6421 = `VqplxG___collapsed`;
    $43775f89248624f4$export$ff68220f8e4ae00 = `VqplxG___header`;
    $43775f89248624f4$export$e075d8876bc6f9dd = `VqplxG_collapsedSection`;
    $43775f89248624f4$export$87335a0dd85d937a = `VqplxG_columnText`;
    $43775f89248624f4$export$9f0f00525fe7c162 = `VqplxG_columnTextTitle`;
    $43775f89248624f4$export$94e99beec2cab04b = `VqplxG_columnTexts`;
    $43775f89248624f4$export$99d5fd10140fa6b7 = `VqplxG_drag-active`;
    $43775f89248624f4$export$8f34ce051745d39e = `VqplxG_handle`;
    $43775f89248624f4$export$fe2e36411d703b3d = `VqplxG_section`;
    $43775f89248624f4$export$5a1dbaa3e4449344 = `VqplxG_sections`;
    $43775f89248624f4$export$3e523c77c1f23f8c = `VqplxG_separator`;
    $43775f89248624f4$export$6ea4444824e687db = `VqplxG_story-title`;
    $43775f89248624f4$export$fb184b623420d9be = `VqplxG_title`;
    $43775f89248624f4$export$8465d27022f5235a = `VqplxG_title-icon`;
    $43775f89248624f4$export$e6ca8839261504b0 = `VqplxG_truncate-text`;
});
parcelRegister("86zlq", function(module, exports) {
    $parcel$export(module.exports, "UseShortcuts", ()=>$cb5e0ca6dec3a37d$export$65eedd797745cae9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $9IeM0;
    var $8zOmE;
    var $2NMNM;
    var $bw1fG;
    const $cb5e0ca6dec3a37d$export$a1ca853c6e4bb6fb = (key, callback)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [actionSubject, action] = (0, $e8c73282555962ec$export$6a05d0dd2493170b).split(' ');
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        const [{ isEnabled: isKeyboardShortcutsEnabled }] = (0, (0, parcelRequire("9IeM0")).useKeyboardShortcutsToggle)();
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (!(0, (0, parcelRequire("bw1fG")).isRelevantKeyEvent)(e) || !isKeyboardShortcutsEnabled) return;
            if (e.code === key) {
                e.preventDefault();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: action,
                    actionSubject: actionSubject
                }), {
                    key: e.code
                });
                callback(e);
            }
        }, [
            action,
            actionSubject,
            analyticsEvent,
            callback,
            isKeyboardShortcutsEnabled,
            key
        ]);
        const debouncedHandleKeyDown = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($lFKmC)))(handleKeyDown, 1000, {
            leading: true
        }));
        (0, $5uXOq.useEffect)(()=>{
            debouncedHandleKeyDown.current = (0, ($parcel$interopDefault($lFKmC)))(handleKeyDown, 1000, {
                leading: true
            });
        }, [
            isKeyboardShortcutsEnabled,
            handleKeyDown
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handler = (e)=>debouncedHandleKeyDown.current(e);
            document.addEventListener('keydown', handler);
            return ()=>document.removeEventListener('keydown', handler);
        }, []);
    };
    const $cb5e0ca6dec3a37d$export$65eedd797745cae9 = ({ shortcutKey: shortcutKey, onKeyDown: onKeyDown })=>{
        $cb5e0ca6dec3a37d$export$a1ca853c6e4bb6fb(shortcutKey, onKeyDown);
        return null;
    };
});
parcelRegister("9IeM0", function(module, exports) {
    $parcel$export(module.exports, "useKeyboardShortcutsToggle", ()=>$dc712fc9bec05022$export$a33a81f1fc5458ad);
    var $jcw0u;
    var $eusud;
    var $j8DrX;
    var $8zOmE;
    var $3sQ5x;
    var $iXqE5;
    const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
    const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState().isEnabled;
            const status = currentState ? 'off' : 'on';
            const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(url);
                setState({
                    isEnabled: !currentState,
                    error: null
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                    isEnabled: !currentState
                });
            } catch (err) {
                setState({
                    error: err
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'keyboardShortcutToggleFailure',
                        packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                    },
                    error: err
                });
            }
        };
    const $dc712fc9bec05022$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isEnabled: false ? false : !((0, (0, parcelRequire("j8DrX")).default)('ajs-keyboard-shortcuts-enabled') === 'false'),
            error: null
        },
        actions: {
            toggle: $dc712fc9bec05022$export$b62f67be35e65859
        }
    });
    const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, (0, parcelRequire("3sQ5x")).createHook)($dc712fc9bec05022$var$Store);
});
const $e8c73282555962ec$export$6a05d0dd2493170b = 'arjKeyboardShortcut pressed';
parcelRegister("bw1fG", function(module, exports) {
    $parcel$export(module.exports, "isRelevantKeyEvent", ()=>$54ceef1041cfa38d$export$f1fe560ca916816e);
    const $54ceef1041cfa38d$var$ignoredKeys = {
        Control: true,
        Meta: true,
        Shift: true,
        Alt: true,
        AltGraph: true,
        CapsLock: true,
        Fn: true,
        FnLock: true,
        Hyper: true,
        NumLock: true,
        OS: true,
        ScrollLock: true,
        Super: true,
        Symbol: true,
        SymbolLock: true
    };
    const $54ceef1041cfa38d$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
    const $54ceef1041cfa38d$var$isEditable = (node)=>node.nodeName === 'INPUT' || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
    const $54ceef1041cfa38d$export$f1fe560ca916816e = (e)=>{
        const { key: key, target: target } = e;
        return target && target instanceof HTMLElement && typeof e.key === 'string' && (e.key === 'Escape' || !$54ceef1041cfa38d$var$isEditable(target) && !$54ceef1041cfa38d$var$ignoredKeys[key]) && !($54ceef1041cfa38d$export$6159e43e50a41987() && e.metaKey || !$54ceef1041cfa38d$export$6159e43e50a41987() && e.ctrlKey);
    };
});
parcelRegister("1qMX7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be137e68093bd18b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $ousew;
    const $be137e68093bd18b$var$KeyboardShortcutTooltip = ({ letter: letter, message: message })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $be137e68093bd18b$var$tooltipContainerStyles
        }, message ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $be137e68093bd18b$var$textContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), message)) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $be137e68093bd18b$var$shortcutContainerStyles
        }, letter));
    const $be137e68093bd18b$var$tooltipContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        paddingTop: 'space.025',
        paddingBottom: 'space.025',
        paddingLeft: '0',
        paddingRight: '0'
    });
    const $be137e68093bd18b$var$shortcutContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.neutral',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'color.border.inverse',
        borderRadius: '2px',
        paddingTop: '0',
        paddingBottom: '0',
        paddingLeft: 'space.050',
        paddingRight: 'space.050',
        marginTop: 'space.025',
        marginBottom: 'space.025',
        marginRight: '0',
        marginLeft: '0'
    });
    const $be137e68093bd18b$var$textContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        marginRight: 'space.050'
    });
    var $be137e68093bd18b$export$2e2bcd8739ae039 = $be137e68093bd18b$var$KeyboardShortcutTooltip;
});
parcelRegister("7lpPk", function(module, exports) {
    $parcel$export(module.exports, "ADD_FIELDS_COLUMN_ID", ()=>$af8f0533f2395534$export$302cf7e916671595);
    $parcel$export(module.exports, "getColumnIds", ()=>$af8f0533f2395534$export$3d88032e6be0ee47);
    $parcel$export(module.exports, "defaultWidthOfColumnTimeline", ()=>$af8f0533f2395534$export$2430e422fe504be0);
    $parcel$export(module.exports, "defaultWidthOfColumnList", ()=>$af8f0533f2395534$export$6743df29cb997fb5);
    $parcel$export(module.exports, "isColumnId", ()=>$af8f0533f2395534$export$e10c6e1e5f10eae8);
    var $co1wz;
    var $TTKUQ = parcelRequire("TTKUQ");
    const $af8f0533f2395534$export$302cf7e916671595 = 'addFields';
    const $af8f0533f2395534$var$columnIds = [
        'targetStart',
        'targetEnd',
        'assignee',
        'team',
        'issueStatus',
        'release',
        'estimate',
        'breakdown',
        'progressByEstimation',
        'sprint',
        'incomingDependencies',
        'outgoingDependencies',
        'components',
        'labels',
        'dueDate',
        'parent',
        'priority',
        'reporter',
        'goal',
        $af8f0533f2395534$export$302cf7e916671595
    ];
    const $af8f0533f2395534$var$columnIdsWithIdeas = [
        'targetStart',
        'targetEnd',
        'assignee',
        'team',
        'issueStatus',
        'release',
        'estimate',
        'breakdown',
        'progressByEstimation',
        'sprint',
        'incomingDependencies',
        'outgoingDependencies',
        'components',
        'labels',
        'dueDate',
        'parent',
        'priority',
        'reporter',
        'goal',
        'ideas',
        $af8f0533f2395534$export$302cf7e916671595
    ];
    const $af8f0533f2395534$export$3d88032e6be0ee47 = (isEmbedMode, isConfluenceMacroMode)=>{
        const isEmbedOrMacro = isEmbedMode || isConfluenceMacroMode;
        if ((0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') && !isEmbedOrMacro) return $af8f0533f2395534$var$columnIdsWithIdeas;
        return $af8f0533f2395534$var$columnIds;
    };
    const $af8f0533f2395534$export$2430e422fe504be0 = {
        targetStart: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        targetEnd: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        assignee: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        team: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).EXTRALARGE,
        issueStatus: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        release: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).EXTRALARGE,
        estimate: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        breakdown: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        progressByEstimation: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        sprint: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).EXTRALARGE,
        incomingDependencies: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        outgoingDependencies: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        components: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).EXTRALARGE,
        ideas: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).EXTRALARGE,
        labels: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).EXTRALARGE,
        dueDate: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        parent: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        priority: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        reporter: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        addFields: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        [(0, $TTKUQ.CustomFieldTypes).TextField]: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        [(0, $TTKUQ.CustomFieldTypes).MultiSelect]: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        [(0, $TTKUQ.CustomFieldTypes).AssetObject]: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        [(0, $TTKUQ.CustomFieldTypes).SingleSelect]: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        DEFAULT: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM
    };
    const $af8f0533f2395534$export$6743df29cb997fb5 = {
        assignee: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).EXTRALARGE,
        targetStart: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        targetEnd: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        issueStatus: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        dueDate: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        [(0, $TTKUQ.CustomFieldTypes).DatePicker]: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE,
        estimate: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        priority: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM,
        DEFAULT: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).LARGE
    };
    function $af8f0533f2395534$export$e10c6e1e5f10eae8(key, isEmbedMode, isConfluenceMacroMode) {
        return $af8f0533f2395534$export$3d88032e6be0ee47(isEmbedMode, isConfluenceMacroMode).includes(key);
    }
});
parcelRegister("fAImD", function(module, exports) {
    $parcel$export(module.exports, "getEstimateColumnTitle", ()=>$10ff3fcedbb025d5$export$961e02836694eb96);
    $parcel$export(module.exports, "getProgressByEstimateColumnTitle", ()=>$10ff3fcedbb025d5$export$8b71285ce3a3c6ed);
    $parcel$export(module.exports, "getConfiguredDateTooltip", ()=>$10ff3fcedbb025d5$export$d1378ae5a88a63b9);
    $parcel$export(module.exports, "getHeaderMessage", ()=>$10ff3fcedbb025d5$export$9872ef3877d2d3b2);
    $parcel$export(module.exports, "default", ()=>$10ff3fcedbb025d5$export$2e2bcd8739ae039);
    var $4R6GH;
    var $7VHMR;
    var $edp6D;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    const $10ff3fcedbb025d5$var$planningUnits = {
        storyPoints: 'StoryPoints',
        days: 'Days',
        hours: 'Hours'
    };
    const $10ff3fcedbb025d5$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        targetStartColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.target-start-column-header",
            "defaultMessage": "Target start"
        },
        targetEndColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.target-end-column-header",
            "defaultMessage": "Target end"
        },
        unmappedColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.unmapped-column-header",
            "defaultMessage": "Unmapped"
        },
        teamColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.team-column-header",
            "defaultMessage": "Team"
        },
        issueStatusColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.issue-status-column-header",
            "defaultMessage": "Status"
        },
        storyPointsEstimateColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.story-points-estimate-column-header",
            "defaultMessage": "Story points"
        },
        hoursEstimateColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.hours-estimate-column-header",
            "defaultMessage": "Estimates (h)"
        },
        daysEstimateColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.days-estimate-column-header",
            "defaultMessage": "Estimates (d)"
        },
        breakdownColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.breakdown-column-header",
            "defaultMessage": "Progress (issue count)"
        },
        progressEstimateByPointsColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.progress-estimate-by-points-column-header",
            "defaultMessage": "Progress (story points)"
        },
        progressEstimateByHoursColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.progress-estimate-by-hours-column-header",
            "defaultMessage": "Progress (hours)"
        },
        progressEstimateByDaysColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.progress-estimate-by-days-column-header",
            "defaultMessage": "Progress (days)"
        },
        incomingDependenciesColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.incoming-dependencies-column-header",
            "defaultMessage": "Incoming dependencies"
        },
        outgoingDependenciesColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.outgoing-dependencies-column-header",
            "defaultMessage": "Outgoing dependencies"
        },
        blockedByColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.blocked-by-column-header",
            "defaultMessage": "Blocked by"
        },
        blocksColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.blocks-column-header",
            "defaultMessage": "Blocks"
        },
        dependenciesColumnsHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.dependencies-columns-header",
            "defaultMessage": "Dependencies"
        },
        componentsColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.components-column-header",
            "defaultMessage": "Components"
        },
        labelsColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.labels-column-header",
            "defaultMessage": "Labels"
        },
        parentColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.parent-column-header",
            "defaultMessage": "Parent"
        },
        priorityColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.priority-column-header",
            "defaultMessage": "Priority"
        },
        goalColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.goal-column-header",
            "defaultMessage": "Goal"
        },
        ideasColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.ideas-column-header",
            "defaultMessage": "Idea"
        },
        configuredDateStart: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.configured-date-start",
            "defaultMessage": "{title} is being used as the start date for the issues in this plan."
        },
        configuredDateEnd: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.configured-date-end",
            "defaultMessage": "{title} is being used as the end date for the issues in this plan."
        },
        addFieldsColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.add-fields-column-header",
            "defaultMessage": "Add fields"
        }
    });
    const $10ff3fcedbb025d5$export$961e02836694eb96 = (planningUnit)=>{
        switch(planningUnit){
            case $10ff3fcedbb025d5$var$planningUnits.storyPoints:
                return $10ff3fcedbb025d5$var$messages.storyPointsEstimateColumnHeader;
            case $10ff3fcedbb025d5$var$planningUnits.days:
                return $10ff3fcedbb025d5$var$messages.daysEstimateColumnHeader;
            case $10ff3fcedbb025d5$var$planningUnits.hours:
            default:
                return $10ff3fcedbb025d5$var$messages.hoursEstimateColumnHeader;
        }
    };
    const $10ff3fcedbb025d5$export$8b71285ce3a3c6ed = (planningUnit)=>{
        switch(planningUnit){
            case $10ff3fcedbb025d5$var$planningUnits.storyPoints:
                return $10ff3fcedbb025d5$var$messages.progressEstimateByPointsColumnHeader;
            case $10ff3fcedbb025d5$var$planningUnits.days:
                return $10ff3fcedbb025d5$var$messages.progressEstimateByDaysColumnHeader;
            case $10ff3fcedbb025d5$var$planningUnits.hours:
            default:
                return $10ff3fcedbb025d5$var$messages.progressEstimateByHoursColumnHeader;
        }
    };
    const $10ff3fcedbb025d5$export$d1378ae5a88a63b9 = (configurableDate)=>{
        switch(configurableDate){
            case (0, (0, parcelRequire("edp6D")).ConfigurableDateTypes).start:
                return $10ff3fcedbb025d5$var$messages.configuredDateStart;
            case (0, (0, parcelRequire("edp6D")).ConfigurableDateTypes).end:
                return $10ff3fcedbb025d5$var$messages.configuredDateEnd;
            default:
        }
    };
    const $10ff3fcedbb025d5$export$9872ef3877d2d3b2 = (sectionId, planningUnit)=>{
        switch(sectionId){
            case 'targetStart':
                return $10ff3fcedbb025d5$var$messages.targetStartColumnHeader;
            case 'targetEnd':
                return $10ff3fcedbb025d5$var$messages.targetEndColumnHeader;
            case 'dueDate':
                return (0, $ihPUd.default).dueDate;
            case 'assignee':
                return (0, $ihPUd.default).assignee;
            case 'sprint':
                return (0, $ihPUd.default).sprint;
            case 'unmapped':
                return $10ff3fcedbb025d5$var$messages.unmappedColumnHeader;
            case 'team':
                return $10ff3fcedbb025d5$var$messages.teamColumnHeader;
            case 'issueStatus':
                return $10ff3fcedbb025d5$var$messages.issueStatusColumnHeader;
            case 'release':
                return (0, $ihPUd.default).releases;
            case 'breakdown':
                return $10ff3fcedbb025d5$var$messages.breakdownColumnHeader;
            case 'incomingDependencies':
                return (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_field_column_adjustments__a2f7') ? $10ff3fcedbb025d5$var$messages.blockedByColumnHeader : $10ff3fcedbb025d5$var$messages.incomingDependenciesColumnHeader;
            case 'outgoingDependencies':
                return (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_field_column_adjustments__a2f7') ? $10ff3fcedbb025d5$var$messages.blocksColumnHeader : $10ff3fcedbb025d5$var$messages.outgoingDependenciesColumnHeader;
            case 'dependencies':
                return $10ff3fcedbb025d5$var$messages.dependenciesColumnsHeader;
            case 'components':
                return $10ff3fcedbb025d5$var$messages.componentsColumnHeader;
            case 'labels':
                return $10ff3fcedbb025d5$var$messages.labelsColumnHeader;
            case 'parent':
                return $10ff3fcedbb025d5$var$messages.parentColumnHeader;
            case 'priority':
                return $10ff3fcedbb025d5$var$messages.priorityColumnHeader;
            case 'estimate':
                switch(planningUnit){
                    case (0, $TTKUQ.PLANNING_UNITS).HOURS:
                        return $10ff3fcedbb025d5$var$messages.hoursEstimateColumnHeader;
                    case (0, $TTKUQ.PLANNING_UNITS).STORY_POINTS:
                        return $10ff3fcedbb025d5$var$messages.storyPointsEstimateColumnHeader;
                    case (0, $TTKUQ.PLANNING_UNITS).DAYS:
                        return $10ff3fcedbb025d5$var$messages.daysEstimateColumnHeader;
                    default:
                        return undefined;
                }
            case 'progressByEstimation':
                switch(planningUnit){
                    case (0, $TTKUQ.PLANNING_UNITS).HOURS:
                        return $10ff3fcedbb025d5$var$messages.progressEstimateByHoursColumnHeader;
                    case (0, $TTKUQ.PLANNING_UNITS).STORY_POINTS:
                        return $10ff3fcedbb025d5$var$messages.progressEstimateByPointsColumnHeader;
                    case (0, $TTKUQ.PLANNING_UNITS).DAYS:
                        return $10ff3fcedbb025d5$var$messages.progressEstimateByDaysColumnHeader;
                    default:
                        return undefined;
                }
            default:
        }
    };
    var $10ff3fcedbb025d5$export$2e2bcd8739ae039 = $10ff3fcedbb025d5$var$messages;
});
parcelRegister("edp6D", function(module, exports) {
    $parcel$export(module.exports, "ConfigurableDateTypes", ()=>$7b0576b0307d597b$export$e202020d6b90ab1e);
    const $7b0576b0307d597b$export$e202020d6b90ab1e = Object.freeze({
        start: 'CONFIGURABLE_DATE_START',
        end: 'CONFIGURABLE_DATE_END'
    });
    const $7b0576b0307d597b$export$4d4da49430f168be = '@portfolio/common/sections';
});
parcelRegister("4lfs5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee9829c8c50e656f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aaiNz = parcelRequire("aaiNz");
    const $ee9829c8c50e656f$var$CustomPopupContainer = (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ...props,
            className: $aaiNz["afm-custom-popup-container"]
        }, children), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-role": "afm-dropdown-menu-drag-handle",
            key: "afm-dropdown-menu-drag-handle"
        })));
    var $ee9829c8c50e656f$export$2e2bcd8739ae039 = $ee9829c8c50e656f$var$CustomPopupContainer;
});
parcelRegister("aaiNz", function(module, exports) {
    $parcel$export(module.exports, "afm-custom-popup-container", ()=>$76696b8c415cb7e5$export$c624532f0d686e13, (v)=>$76696b8c415cb7e5$export$c624532f0d686e13 = v);
    var $76696b8c415cb7e5$export$c624532f0d686e13;
    $76696b8c415cb7e5$export$c624532f0d686e13 = `v2i7oq_afm-custom-popup-container`;
});
parcelRegister("4O3BE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10d14146457d856e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $10d14146457d856e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        dateLozenge: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.date-lozenge",
            "defaultMessage": "D"
        },
        advancedFieldsMenuSelectPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-select-placeholder",
            "defaultMessage": "Choose fields..."
        },
        advancedFieldsMenuNoFieldsMatchCriteria: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-no-fields-match-criteria",
            "defaultMessage": "No fields match the search criteria"
        },
        advancedFieldsMenuAllFieldsSelected: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-all-fields-selected",
            "defaultMessage": "All fields have been selected"
        },
        advancedFieldsMenuCustomFieldLozenge: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-custom-field-lozenge",
            "defaultMessage": "CUSTOM"
        },
        advancedFieldsMenuManageCustomFieldsLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-manage-custom-fields-link",
            "defaultMessage": "Manage custom fields"
        },
        advancedFieldsMenuAddFieldTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-add-field-tooltip",
            "defaultMessage": "Add fields"
        },
        advancedFieldsMenuSelectLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-select-label",
            "defaultMessage": "Select fields"
        }
    });
});
parcelRegister("bONMW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47da579754088700$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2rMKg;
    var $h35CY;
    var $cLDON = parcelRequire("cLDON");
    var $42CjB;
    var $fVnbM;
    var $78tet;
    var $2C7j9;
    var $bjGSs;
    var $dQO6P;
    var $lj8SI;
    var $kgoHi;
    var $3bDjY;
    var $jldZL;
    var $4R6GH;
    var $koVbs;
    var $bVLLf;
    var $fAImD = parcelRequire("fAImD");
    var $dCm1o;
    var $8nAYy = parcelRequire("8nAYy");
    var $7U3Fb = parcelRequire("7U3Fb");
    var $hzOyB = parcelRequire("hzOyB");
    const $47da579754088700$var$SortableItem = (0, $cLDON.SortableElement)(({ children: children })=>children);
    const $47da579754088700$var$SortableContainerWrapper = (0, $cLDON.SortableContainer)(({ children: children })=>children);
    const $47da579754088700$var$SelectableFieldSectionContainer = ({ isVisuallyRefreshed: isVisuallyRefreshed, children: children })=>isVisuallyRefreshed ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            columnGap: "space.150"
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $hzOyB["afm-selected-field-item-section"]
        }, children);
    const $47da579754088700$var$AdvancedFieldsMenu = ({ selectedColumns: selectedColumns, getMatchingConfiguredDate: getMatchingConfiguredDate, hideColumn: hideColumn, moveColumn: moveColumn })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [sortingAnnouncement, setSortingAnnouncement] = (0, $5uXOq.useState)('');
        const [sortableInfo, setSortableInfo] = (0, $5uXOq.useState)(null);
        const [initialPosition, setInitialPosition] = (0, $5uXOq.useState)(null);
        const renderCustomFieldLozenge = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $hzOyB["afm-custom-field-lozenge"],
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.custom-lozenge"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, formatMessage((0, $7U3Fb.default).advancedFieldsMenuCustomFieldLozenge)));
        const renderSelectedFields = (columns)=>(0, $8nAYy.getListableColumns)(columns).map((group, index)=>{
                const localizedTitle = group[0].localizedTitle;
                const columns = (0, parcelRequire("h35CY")).default((0, parcelRequire("2rMKg")).default('id'), group);
                const isCustomField = columns.every(({ isCustomField: isCustomField })=>isCustomField);
                const compoundId = columns.map((0, parcelRequire("2rMKg")).default('id')).join(':');
                const configurableDate = getMatchingConfiguredDate(compoundId);
                const tooltip = (0, $fAImD.getConfiguredDateTooltip)(configurableDate);
                return ((0, ($parcel$interopDefault($5uXOq))).createElement($47da579754088700$var$SortableItem, {
                    id: compoundId,
                    index: index,
                    key: compoundId
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    tabIndex: 0,
                    "data-title": localizedTitle,
                    id: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-${compoundId}`,
                    role: "button",
                    "aria-labelledby": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-${compoundId} portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-a11y-text`,
                    "aria-label": localizedTitle,
                    key: `item-${localizedTitle}`,
                    "data-test-class": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field",
                    className: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $hzOyB["afm-selected-field-item"] : $hzOyB["afm-selected-field-item-old"],
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-${compoundId}`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($47da579754088700$var$SelectableFieldSectionContainer, {
                    isVisuallyRefreshed: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2')
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, $7U3Fb.default).advancedFieldsMenuSelectedFieldDragTooltip)
                }, (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        ...triggerProps,
                        className: $hzOyB["afm-selected-field-item-drag-icon"]
                    }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dQO6P"))))), {
                        label: formatMessage((0, $7U3Fb.default).advancedFieldsMenuSelectedFieldDragTooltip),
                        color: "currentColor"
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("78tet"))))), {
                        label: formatMessage((0, $7U3Fb.default).advancedFieldsMenuSelectedFieldDragTooltip)
                    }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $hzOyB["afm-selected-field-item-title"]
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bVLLf")).default), {
                    icon: configurableDate && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                        testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-${compoundId}.configurable-date-lozenge`
                    }, "D"),
                    tooltip: tooltip && formatMessage(tooltip, {
                        title: localizedTitle
                    }),
                    mode: "inline"
                }, localizedTitle))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $hzOyB["afm-selected-field-item-section"]
                }, isCustomField && renderCustomFieldLozenge(), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $hzOyB["afm-selected-field-item-remove-icon"],
                    "data-drag": "false",
                    "data-test-class": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.remove-button",
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-${compoundId}-remove-button`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, $7U3Fb.default).advancedFieldsMenuSelectedFieldRemoveTooltip)
                }, (triggerProps)=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                        ...triggerProps,
                        appearance: "subtle",
                        label: formatMessage((0, $7U3Fb.default).advancedFieldsMenuSelectedFieldRemoveAriaLabel, {
                            fieldName: localizedTitle
                        }),
                        icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                                label: "",
                                color: "currentColor",
                                spacing: "spacious"
                            }),
                        onClick: ()=>{
                            columns.forEach(({ id: id })=>{
                                hideColumn(id);
                            });
                        },
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.selected-field-remove-button"
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                        ...triggerProps,
                        appearance: "subtle",
                        spacing: "none",
                        iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2C7j9"))))), {
                            label: ""
                        }),
                        onClick: ()=>{
                            columns.forEach(({ id: id })=>{
                                hideColumn(id);
                            });
                        },
                        className: $hzOyB["afm-selected-field-item-remove-icon-button"],
                        "aria-label": formatMessage((0, $7U3Fb.default).advancedFieldsMenuSelectedFieldRemoveAriaLabel, {
                            fieldName: localizedTitle
                        }),
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.selected-field-remove-button"
                    })))))));
            });
        const handleSortStart = (0, $5uXOq.useCallback)((sortStart, event)=>{
            const { node: node, isKeySorting: isKeySorting, index: index } = sortStart;
            const fieldName = node.getAttribute('data-title');
            setSortableInfo(sortStart);
            isKeySorting && setSortingAnnouncement(formatMessage((0, $7U3Fb.default).advancedFieldMenuGrabbedFieldAnnouncement, {
                fieldName: fieldName
            }));
            setInitialPosition(index + 1);
            event.preventDefault();
        }, [
            formatMessage
        ]);
        const handleSortEnd = (sortEnd)=>{
            const { oldIndex: oldIndex, newIndex: newIndex, isKeySorting: isKeySorting, nodes: nodes } = sortEnd;
            const columns = (0, $8nAYy.getListableColumns)(selectedColumns);
            const columnToMove = columns[oldIndex][0].id;
            const moveToTheIndexOf = columns[newIndex][0].id;
            moveColumn(columnToMove, moveToTheIndexOf);
            const fieldName = nodes[oldIndex].node.getAttribute('data-title');
            const position = newIndex + 1;
            if (isKeySorting && oldIndex !== newIndex) setSortingAnnouncement(formatMessage((0, $7U3Fb.default).advancedFieldMenuDroppedFieldAnnouncement, {
                fieldName: fieldName,
                position: position
            }));
            setInitialPosition(null);
            setSortableInfo(null);
        };
        const handleSortMove = (e)=>{
            if (sortableInfo && initialPosition && !e.ignoreTransition) {
                const { node: node, helper: helper } = sortableInfo;
                const fieldName = node.getAttribute('data-title');
                const { top: top } = node.getBoundingClientRect();
                const { height: height } = helper.getBoundingClientRect();
                const currentPosition = Math.ceil(initialPosition + (e.pageY - top) / height);
                setSortingAnnouncement(formatMessage((0, $7U3Fb.default).advancedFieldMenuMovedFieldAnnouncement, {
                    fieldName: fieldName,
                    initialPosition: initialPosition,
                    currentPosition: currentPosition
                }));
            }
        };
        const shouldCancelStart = (e)=>Boolean(e.target.closest('div[data-drag="false"]'));
        const renderDialogContent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hzOyB["afm-dropdown-menu-body"],
                "data-role": "afm-dropdown-menu-body"
            }, selectedColumns.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), {
                id: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.visually-hidden"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("label", {
                id: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-a11y-text"
            }, formatMessage((0, $7U3Fb.default).advancedFieldMenuFocusedFieldAnnouncement)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                role: "status",
                "aria-live": "polite",
                "aria-atomic": true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: sortingAnnouncement
            }, sortingAnnouncement))), (0, ($parcel$interopDefault($5uXOq))).createElement($47da579754088700$var$SortableContainerWrapper, {
                helperClass: $hzOyB["afm-sortable-helper"],
                onSortStart: handleSortStart,
                onSortEnd: handleSortEnd,
                shouldCancelStart: shouldCancelStart,
                lockToContainerEdges: true,
                onSortMove: handleSortMove,
                lockAxis: "y",
                helperContainer: document.querySelector("div[data-role='afm-dropdown-menu-drag-handle']") || undefined,
                getContainer: ()=>document.querySelector("div[data-role='afm-dropdown-menu-body']")
            }, renderSelectedFields(selectedColumns))) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hzOyB["afm-no-selected-fields"],
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.no-selected-field"
            }, formatMessage((0, $7U3Fb.default).advancedFieldsMenuNoSelectedFields)));
        return renderDialogContent();
    };
    var $47da579754088700$export$2e2bcd8739ae039 = $47da579754088700$var$AdvancedFieldsMenu;
});
parcelRegister("cLDON", function(module, exports) {
    $parcel$export(module.exports, "SortableContainer", ()=>$94b8c2e7a95a5264$export$a4b10e5599330dd0);
    $parcel$export(module.exports, "SortableElement", ()=>$94b8c2e7a95a5264$export$58d1e4fb0d207bf7);
    var $bS32t = parcelRequire("bS32t");
    var $5qOly = parcelRequire("5qOly");
    var $5qo9W = parcelRequire("5qo9W");
    var $joEwT = parcelRequire("joEwT");
    var $6tg7d = parcelRequire("6tg7d");
    var $lthwC = parcelRequire("lthwC");
    var $k8Nlm = parcelRequire("k8Nlm");
    var $1SDbw = parcelRequire("1SDbw");
    var $hmqmu = parcelRequire("hmqmu");
    var $eHiP8 = parcelRequire("eHiP8");
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $aE1Lc = parcelRequire("aE1Lc");
    var $1UctI = parcelRequire("1UctI");
    var $8rCP3;
    var $94b8c2e7a95a5264$var$Manager = function() {
        function Manager() {
            (0, $joEwT.default)(this, Manager);
            (0, $eHiP8.default)(this, "refs", {});
        }
        (0, $6tg7d.default)(Manager, [
            {
                key: "add",
                value: function add(collection, ref) {
                    if (!this.refs[collection]) this.refs[collection] = [];
                    this.refs[collection].push(ref);
                }
            },
            {
                key: "remove",
                value: function remove(collection, ref) {
                    var index = this.getIndex(collection, ref);
                    if (index !== -1) this.refs[collection].splice(index, 1);
                }
            },
            {
                key: "isActive",
                value: function isActive() {
                    return this.active;
                }
            },
            {
                key: "getActive",
                value: function getActive() {
                    var _this = this;
                    return this.refs[this.active.collection].find(function(_ref) {
                        var node = _ref.node;
                        return node.sortableInfo.index == _this.active.index;
                    });
                }
            },
            {
                key: "getIndex",
                value: function getIndex(collection, ref) {
                    return this.refs[collection].indexOf(ref);
                }
            },
            {
                key: "getOrderedRefs",
                value: function getOrderedRefs() {
                    var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
                    return this.refs[collection].sort($94b8c2e7a95a5264$var$sortByIndex);
                }
            }
        ]);
        return Manager;
    }();
    function $94b8c2e7a95a5264$var$sortByIndex(_ref2, _ref3) {
        var index1 = _ref2.node.sortableInfo.index;
        var index2 = _ref3.node.sortableInfo.index;
        return index1 - index2;
    }
    function $94b8c2e7a95a5264$export$5d49d615ad5ea2b0(array, from, to) {
        array = array.slice();
        array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
        return array;
    }
    function $94b8c2e7a95a5264$var$omit(obj, keysToOmit) {
        return Object.keys(obj).reduce(function(acc, key) {
            if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
            return acc;
        }, {});
    }
    var $94b8c2e7a95a5264$var$events = {
        end: [
            'touchend',
            'touchcancel',
            'mouseup'
        ],
        move: [
            'touchmove',
            'mousemove'
        ],
        start: [
            'touchstart',
            'mousedown'
        ]
    };
    var $94b8c2e7a95a5264$var$vendorPrefix = function() {
        if (typeof window === 'undefined' || typeof document === 'undefined') return '';
        var styles = window.getComputedStyle(document.documentElement, '') || [
            '-moz-hidden-iframe'
        ];
        var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && [
            '',
            'o'
        ])[1];
        switch(pre){
            case 'ms':
                return 'ms';
            default:
                return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
        }
    }();
    function $94b8c2e7a95a5264$var$setInlineStyles(node, styles) {
        Object.keys(styles).forEach(function(key) {
            node.style[key] = styles[key];
        });
    }
    function $94b8c2e7a95a5264$var$setTranslate3d(node, translate) {
        node.style["".concat($94b8c2e7a95a5264$var$vendorPrefix, "Transform")] = translate == null ? '' : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
    }
    function $94b8c2e7a95a5264$var$setTransitionDuration(node, duration) {
        node.style["".concat($94b8c2e7a95a5264$var$vendorPrefix, "TransitionDuration")] = duration == null ? '' : "".concat(duration, "ms");
    }
    function $94b8c2e7a95a5264$var$closest(el, fn) {
        while(el){
            if (fn(el)) return el;
            el = el.parentNode;
        }
        return null;
    }
    function $94b8c2e7a95a5264$var$limit(min, max, value1) {
        return Math.max(min, Math.min(value1, max));
    }
    function $94b8c2e7a95a5264$var$getPixelValue(stringValue) {
        if (stringValue.substr(-2) === 'px') return parseFloat(stringValue);
        return 0;
    }
    function $94b8c2e7a95a5264$var$getElementMargin(element) {
        var style = window.getComputedStyle(element);
        return {
            bottom: $94b8c2e7a95a5264$var$getPixelValue(style.marginBottom),
            left: $94b8c2e7a95a5264$var$getPixelValue(style.marginLeft),
            right: $94b8c2e7a95a5264$var$getPixelValue(style.marginRight),
            top: $94b8c2e7a95a5264$var$getPixelValue(style.marginTop)
        };
    }
    function $94b8c2e7a95a5264$var$provideDisplayName(prefix, Component$$1) {
        var componentName = Component$$1.displayName || Component$$1.name;
        return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
    }
    function $94b8c2e7a95a5264$var$getScrollAdjustedBoundingClientRect(node, scrollDelta) {
        var boundingClientRect = node.getBoundingClientRect();
        return {
            top: boundingClientRect.top + scrollDelta.top,
            left: boundingClientRect.left + scrollDelta.left
        };
    }
    function $94b8c2e7a95a5264$var$getPosition(event) {
        if (event.touches && event.touches.length) return {
            x: event.touches[0].pageX,
            y: event.touches[0].pageY
        };
        else if (event.changedTouches && event.changedTouches.length) return {
            x: event.changedTouches[0].pageX,
            y: event.changedTouches[0].pageY
        };
        else return {
            x: event.pageX,
            y: event.pageY
        };
    }
    function $94b8c2e7a95a5264$var$isTouchEvent(event) {
        return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
    }
    function $94b8c2e7a95a5264$var$getEdgeOffset(node, parent) {
        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            left: 0,
            top: 0
        };
        if (!node) return undefined;
        var nodeOffset = {
            left: offset.left + node.offsetLeft,
            top: offset.top + node.offsetTop
        };
        if (node.parentNode === parent) return nodeOffset;
        return $94b8c2e7a95a5264$var$getEdgeOffset(node.parentNode, parent, nodeOffset);
    }
    function $94b8c2e7a95a5264$var$getTargetIndex(newIndex, prevIndex, oldIndex) {
        if (newIndex < oldIndex && newIndex > prevIndex) return newIndex - 1;
        else if (newIndex > oldIndex && newIndex < prevIndex) return newIndex + 1;
        else return newIndex;
    }
    function $94b8c2e7a95a5264$var$getLockPixelOffset(_ref) {
        var lockOffset = _ref.lockOffset, width = _ref.width, height = _ref.height;
        var offsetX = lockOffset;
        var offsetY = lockOffset;
        var unit = 'px';
        if (typeof lockOffset === 'string') {
            var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
            (0, ($parcel$interopDefault($aE1Lc)))(match !== null, 'lockOffset value should be a number or a string of a number followed by "px" or "%". Given %s', lockOffset);
            offsetX = parseFloat(lockOffset);
            offsetY = parseFloat(lockOffset);
            unit = match[1];
        }
        (0, ($parcel$interopDefault($aE1Lc)))(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);
        if (unit === '%') {
            offsetX = offsetX * width / 100;
            offsetY = offsetY * height / 100;
        }
        return {
            x: offsetX,
            y: offsetY
        };
    }
    function $94b8c2e7a95a5264$var$getLockPixelOffsets(_ref2) {
        var height = _ref2.height, width = _ref2.width, lockOffset = _ref2.lockOffset;
        var offsets = Array.isArray(lockOffset) ? lockOffset : [
            lockOffset,
            lockOffset
        ];
        (0, ($parcel$interopDefault($aE1Lc)))(offsets.length === 2, "lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given %s", lockOffset);
        var _offsets = (0, $5qOly.default)(offsets, 2), minLockOffset = _offsets[0], maxLockOffset = _offsets[1];
        return [
            $94b8c2e7a95a5264$var$getLockPixelOffset({
                height: height,
                lockOffset: minLockOffset,
                width: width
            }),
            $94b8c2e7a95a5264$var$getLockPixelOffset({
                height: height,
                lockOffset: maxLockOffset,
                width: width
            })
        ];
    }
    function $94b8c2e7a95a5264$var$isScrollable(el) {
        var computedStyle = window.getComputedStyle(el);
        var overflowRegex = /(auto|scroll)/;
        var properties = [
            'overflow',
            'overflowX',
            'overflowY'
        ];
        return properties.find(function(property) {
            return overflowRegex.test(computedStyle[property]);
        });
    }
    function $94b8c2e7a95a5264$var$getScrollingParent(el) {
        if (!(el instanceof HTMLElement)) return null;
        else if ($94b8c2e7a95a5264$var$isScrollable(el)) return el;
        else return $94b8c2e7a95a5264$var$getScrollingParent(el.parentNode);
    }
    function $94b8c2e7a95a5264$var$getContainerGridGap(element) {
        var style = window.getComputedStyle(element);
        if (style.display === 'grid') return {
            x: $94b8c2e7a95a5264$var$getPixelValue(style.gridColumnGap),
            y: $94b8c2e7a95a5264$var$getPixelValue(style.gridRowGap)
        };
        return {
            x: 0,
            y: 0
        };
    }
    var $94b8c2e7a95a5264$var$KEYCODE = {
        TAB: 9,
        ESC: 27,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
    };
    var $94b8c2e7a95a5264$var$NodeType = {
        Anchor: 'A',
        Button: 'BUTTON',
        Canvas: 'CANVAS',
        Input: 'INPUT',
        Option: 'OPTION',
        Textarea: 'TEXTAREA',
        Select: 'SELECT'
    };
    function $94b8c2e7a95a5264$var$cloneNode(node) {
        var selector = 'input, textarea, select, canvas, [contenteditable]';
        var fields = node.querySelectorAll(selector);
        var clonedNode = node.cloneNode(true);
        var clonedFields = (0, $1UctI.default)(clonedNode.querySelectorAll(selector));
        clonedFields.forEach(function(field, i) {
            if (field.type !== 'file') field.value = fields[i].value;
            if (field.type === 'radio' && field.name) field.name = "__sortableClone__".concat(field.name);
            if (field.tagName === $94b8c2e7a95a5264$var$NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
                var destCtx = field.getContext('2d');
                destCtx.drawImage(fields[i], 0, 0);
            }
        });
        return clonedNode;
    }
    function $94b8c2e7a95a5264$export$680929e2aec3ce89(WrappedComponent) {
        var _class, _temp;
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            withRef: false
        };
        return _temp = _class = function(_React$Component) {
            (0, $1SDbw.default)(WithSortableHandle, _React$Component);
            function WithSortableHandle() {
                var _getPrototypeOf2;
                var _this;
                (0, $joEwT.default)(this, WithSortableHandle);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = (0, $lthwC.default)(this, (_getPrototypeOf2 = (0, $k8Nlm.default)(WithSortableHandle)).call.apply(_getPrototypeOf2, [
                    this
                ].concat(args)));
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "wrappedInstance", (0, $5uXOq.createRef)());
                return _this;
            }
            (0, $6tg7d.default)(WithSortableHandle, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        var node = (0, $7nsd3.findDOMNode)(this);
                        node.sortableHandle = true;
                    }
                },
                {
                    key: "getWrappedInstance",
                    value: function getWrappedInstance() {
                        (0, ($parcel$interopDefault($aE1Lc)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
                        return this.wrappedInstance.current;
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var ref = config.withRef ? this.wrappedInstance : null;
                        return (0, $5uXOq.createElement)(WrappedComponent, (0, $bS32t.default)({
                            ref: ref
                        }, this.props));
                    }
                }
            ]);
            return WithSortableHandle;
        }((0, $5uXOq.Component)), (0, $eHiP8.default)(_class, "displayName", $94b8c2e7a95a5264$var$provideDisplayName('sortableHandle', WrappedComponent)), _temp;
    }
    function $94b8c2e7a95a5264$var$isSortableHandle(node) {
        return node.sortableHandle != null;
    }
    var $94b8c2e7a95a5264$var$AutoScroller = function() {
        function AutoScroller(container, onScrollCallback) {
            (0, $joEwT.default)(this, AutoScroller);
            this.container = container;
            this.onScrollCallback = onScrollCallback;
        }
        (0, $6tg7d.default)(AutoScroller, [
            {
                key: "clear",
                value: function clear() {
                    if (this.interval == null) return;
                    clearInterval(this.interval);
                    this.interval = null;
                }
            },
            {
                key: "update",
                value: function update(_ref) {
                    var _this = this;
                    var translate = _ref.translate, minTranslate = _ref.minTranslate, maxTranslate = _ref.maxTranslate, width = _ref.width, height = _ref.height;
                    var direction = {
                        x: 0,
                        y: 0
                    };
                    var speed = {
                        x: 1,
                        y: 1
                    };
                    var acceleration = {
                        x: 10,
                        y: 10
                    };
                    var _this$container = this.container, scrollTop = _this$container.scrollTop, scrollLeft = _this$container.scrollLeft, scrollHeight = _this$container.scrollHeight, scrollWidth = _this$container.scrollWidth, clientHeight = _this$container.clientHeight, clientWidth = _this$container.clientWidth;
                    var isTop = scrollTop === 0;
                    var isBottom = scrollHeight - scrollTop - clientHeight === 0;
                    var isLeft = scrollLeft === 0;
                    var isRight = scrollWidth - scrollLeft - clientWidth === 0;
                    if (translate.y >= maxTranslate.y - height / 2 && !isBottom) {
                        direction.y = 1;
                        speed.y = acceleration.y * Math.abs((maxTranslate.y - height / 2 - translate.y) / height);
                    } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
                        direction.x = 1;
                        speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
                    } else if (translate.y <= minTranslate.y + height / 2 && !isTop) {
                        direction.y = -1;
                        speed.y = acceleration.y * Math.abs((translate.y - height / 2 - minTranslate.y) / height);
                    } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
                        direction.x = -1;
                        speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
                    }
                    if (this.interval) {
                        this.clear();
                        this.isAutoScrolling = false;
                    }
                    if (direction.x !== 0 || direction.y !== 0) this.interval = setInterval(function() {
                        _this.isAutoScrolling = true;
                        var offset = {
                            left: speed.x * direction.x,
                            top: speed.y * direction.y
                        };
                        _this.container.scrollTop += offset.top;
                        _this.container.scrollLeft += offset.left;
                        _this.onScrollCallback(offset);
                    }, 5);
                }
            }
        ]);
        return AutoScroller;
    }();
    function $94b8c2e7a95a5264$var$defaultGetHelperDimensions(_ref) {
        var node = _ref.node;
        return {
            height: node.offsetHeight,
            width: node.offsetWidth
        };
    }
    function $94b8c2e7a95a5264$var$defaultShouldCancelStart(event) {
        var interactiveElements = [
            $94b8c2e7a95a5264$var$NodeType.Input,
            $94b8c2e7a95a5264$var$NodeType.Textarea,
            $94b8c2e7a95a5264$var$NodeType.Select,
            $94b8c2e7a95a5264$var$NodeType.Option,
            $94b8c2e7a95a5264$var$NodeType.Button
        ];
        if (interactiveElements.indexOf(event.target.tagName) !== -1) return true;
        if ($94b8c2e7a95a5264$var$closest(event.target, function(el) {
            return el.contentEditable === 'true';
        })) return true;
        return false;
    }
    var $94b8c2e7a95a5264$var$propTypes = {
        axis: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOf([
            'x',
            'y',
            'xy'
        ]),
        contentWindow: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).any,
        disableAutoscroll: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        distance: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number,
        getContainer: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        getHelperDimensions: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        helperClass: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
        helperContainer: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
            typeof HTMLElement === 'undefined' ? (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).any : (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).instanceOf(HTMLElement)
        ]),
        hideSortableGhost: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        keyboardSortingTransitionDuration: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number,
        lockAxis: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
        lockOffset: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number,
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).arrayOf((0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
                (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number,
                (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string
            ]))
        ]),
        lockToContainerEdges: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        onSortEnd: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        onSortMove: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        onSortOver: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        onSortStart: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        pressDelay: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number,
        pressThreshold: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number,
        keyCodes: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).shape({
            lift: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).arrayOf((0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number),
            drop: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).arrayOf((0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number),
            cancel: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).arrayOf((0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number),
            up: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).arrayOf((0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number),
            down: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).arrayOf((0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number)
        }),
        shouldCancelStart: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        transitionDuration: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number,
        updateBeforeSortStart: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        useDragHandle: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        useWindowAsScrollContainer: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool
    };
    var $94b8c2e7a95a5264$var$defaultKeyCodes = {
        lift: [
            $94b8c2e7a95a5264$var$KEYCODE.SPACE
        ],
        drop: [
            $94b8c2e7a95a5264$var$KEYCODE.SPACE
        ],
        cancel: [
            $94b8c2e7a95a5264$var$KEYCODE.ESC
        ],
        up: [
            $94b8c2e7a95a5264$var$KEYCODE.UP,
            $94b8c2e7a95a5264$var$KEYCODE.LEFT
        ],
        down: [
            $94b8c2e7a95a5264$var$KEYCODE.DOWN,
            $94b8c2e7a95a5264$var$KEYCODE.RIGHT
        ]
    };
    var $94b8c2e7a95a5264$var$defaultProps = {
        axis: 'y',
        disableAutoscroll: false,
        distance: 0,
        getHelperDimensions: $94b8c2e7a95a5264$var$defaultGetHelperDimensions,
        hideSortableGhost: true,
        lockOffset: '50%',
        lockToContainerEdges: false,
        pressDelay: 0,
        pressThreshold: 5,
        keyCodes: $94b8c2e7a95a5264$var$defaultKeyCodes,
        shouldCancelStart: $94b8c2e7a95a5264$var$defaultShouldCancelStart,
        transitionDuration: 300,
        useWindowAsScrollContainer: false
    };
    var $94b8c2e7a95a5264$var$omittedProps = Object.keys($94b8c2e7a95a5264$var$propTypes);
    function $94b8c2e7a95a5264$var$validateProps(props) {
        (0, ($parcel$interopDefault($aE1Lc)))(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
    }
    function $94b8c2e7a95a5264$var$_finallyRethrows(body, finalizer) {
        try {
            var result = body();
        } catch (e) {
            return finalizer(true, e);
        }
        if (result && result.then) return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
        return finalizer(false, value);
    }
    var $94b8c2e7a95a5264$var$SortableContext = (0, $5uXOq.createContext)({
        manager: {}
    });
    function $94b8c2e7a95a5264$export$a4b10e5599330dd0(WrappedComponent) {
        var _class, _temp;
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            withRef: false
        };
        return _temp = _class = function(_React$Component) {
            (0, $1SDbw.default)(WithSortableContainer, _React$Component);
            function WithSortableContainer(props) {
                var _this;
                (0, $joEwT.default)(this, WithSortableContainer);
                _this = (0, $lthwC.default)(this, (0, $k8Nlm.default)(WithSortableContainer).call(this, props));
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "state", {});
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "handleStart", function(event) {
                    var _this$props = _this.props, distance = _this$props.distance, shouldCancelStart = _this$props.shouldCancelStart;
                    if (event.button === 2 || shouldCancelStart(event)) return;
                    _this.touched = true;
                    _this.position = $94b8c2e7a95a5264$var$getPosition(event);
                    var node = $94b8c2e7a95a5264$var$closest(event.target, function(el) {
                        return el.sortableInfo != null;
                    });
                    if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
                        var useDragHandle = _this.props.useDragHandle;
                        var _node$sortableInfo = node.sortableInfo, index = _node$sortableInfo.index, collection = _node$sortableInfo.collection, disabled = _node$sortableInfo.disabled;
                        if (disabled) return;
                        if (useDragHandle && !$94b8c2e7a95a5264$var$closest(event.target, $94b8c2e7a95a5264$var$isSortableHandle)) return;
                        _this.manager.active = {
                            collection: collection,
                            index: index
                        };
                        if (!$94b8c2e7a95a5264$var$isTouchEvent(event) && event.target.tagName === $94b8c2e7a95a5264$var$NodeType.Anchor) event.preventDefault();
                        if (!distance) {
                            if (_this.props.pressDelay === 0) _this.handlePress(event);
                            else _this.pressTimer = setTimeout(function() {
                                return _this.handlePress(event);
                            }, _this.props.pressDelay);
                        }
                    }
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "nodeIsChild", function(node) {
                    return node.sortableInfo.manager === _this.manager;
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "handleMove", function(event) {
                    var _this$props2 = _this.props, distance = _this$props2.distance, pressThreshold = _this$props2.pressThreshold;
                    if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
                        var position = $94b8c2e7a95a5264$var$getPosition(event);
                        var delta = {
                            x: _this.position.x - position.x,
                            y: _this.position.y - position.y
                        };
                        var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
                        _this.delta = delta;
                        if (!distance && (!pressThreshold || combinedDelta >= pressThreshold)) {
                            clearTimeout(_this.cancelTimer);
                            _this.cancelTimer = setTimeout(_this.cancel, 0);
                        } else if (distance && combinedDelta >= distance && _this.manager.isActive()) _this.handlePress(event);
                    }
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "handleEnd", function() {
                    _this.touched = false;
                    _this.cancel();
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "cancel", function() {
                    var distance = _this.props.distance;
                    var sorting = _this.state.sorting;
                    if (!sorting) {
                        if (!distance) clearTimeout(_this.pressTimer);
                        _this.manager.active = null;
                    }
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "handlePress", function(event) {
                    try {
                        var active = _this.manager.getActive();
                        var _temp6 = function() {
                            if (active) {
                                var _temp7 = function _temp7() {
                                    var index = _node.sortableInfo.index;
                                    var margin = $94b8c2e7a95a5264$var$getElementMargin(_node);
                                    var gridGap = $94b8c2e7a95a5264$var$getContainerGridGap(_this.container);
                                    var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();
                                    var dimensions = _getHelperDimensions({
                                        index: index,
                                        node: _node,
                                        collection: _collection
                                    });
                                    _this.node = _node;
                                    _this.margin = margin;
                                    _this.gridGap = gridGap;
                                    _this.width = dimensions.width;
                                    _this.height = dimensions.height;
                                    _this.marginOffset = {
                                        x: _this.margin.left + _this.margin.right + _this.gridGap.x,
                                        y: Math.max(_this.margin.top, _this.margin.bottom, _this.gridGap.y)
                                    };
                                    _this.boundingClientRect = _node.getBoundingClientRect();
                                    _this.containerBoundingRect = containerBoundingRect;
                                    _this.index = index;
                                    _this.newIndex = index;
                                    _this.axis = {
                                        x: _axis.indexOf('x') >= 0,
                                        y: _axis.indexOf('y') >= 0
                                    };
                                    _this.offsetEdge = $94b8c2e7a95a5264$var$getEdgeOffset(_node, _this.container);
                                    if (_isKeySorting) _this.initialOffset = $94b8c2e7a95a5264$var$getPosition((0, $5qo9W.default)({}, event, {
                                        pageX: _this.boundingClientRect.left,
                                        pageY: _this.boundingClientRect.top
                                    }));
                                    else _this.initialOffset = $94b8c2e7a95a5264$var$getPosition(event);
                                    _this.initialScroll = {
                                        left: _this.scrollContainer.scrollLeft,
                                        top: _this.scrollContainer.scrollTop
                                    };
                                    _this.initialWindowScroll = {
                                        left: window.pageXOffset,
                                        top: window.pageYOffset
                                    };
                                    _this.helper = _this.helperContainer.appendChild($94b8c2e7a95a5264$var$cloneNode(_node));
                                    $94b8c2e7a95a5264$var$setInlineStyles(_this.helper, {
                                        boxSizing: 'border-box',
                                        height: "".concat(_this.height, "px"),
                                        left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                                        pointerEvents: 'none',
                                        position: 'fixed',
                                        top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                                        width: "".concat(_this.width, "px")
                                    });
                                    if (_isKeySorting) _this.helper.focus();
                                    if (_hideSortableGhost) {
                                        _this.sortableGhost = _node;
                                        $94b8c2e7a95a5264$var$setInlineStyles(_node, {
                                            opacity: 0,
                                            visibility: 'hidden'
                                        });
                                    }
                                    _this.minTranslate = {};
                                    _this.maxTranslate = {};
                                    if (_isKeySorting) {
                                        var _ref = _useWindowAsScrollContainer ? {
                                            top: 0,
                                            left: 0,
                                            width: _this.contentWindow.innerWidth,
                                            height: _this.contentWindow.innerHeight
                                        } : _this.containerBoundingRect, containerTop = _ref.top, containerLeft = _ref.left, containerWidth = _ref.width, containerHeight = _ref.height;
                                        var containerBottom = containerTop + containerHeight;
                                        var containerRight = containerLeft + containerWidth;
                                        if (_this.axis.x) {
                                            _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                                            _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                                        }
                                        if (_this.axis.y) {
                                            _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                                            _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                                        }
                                    } else {
                                        if (_this.axis.x) {
                                            _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                                            _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                                        }
                                        if (_this.axis.y) {
                                            _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                                            _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                                        }
                                    }
                                    if (_helperClass) _helperClass.split(' ').forEach(function(className) {
                                        return _this.helper.classList.add(className);
                                    });
                                    _this.listenerNode = event.touches ? event.target : _this.contentWindow;
                                    if (_isKeySorting) {
                                        _this.listenerNode.addEventListener('wheel', _this.handleKeyEnd, true);
                                        _this.listenerNode.addEventListener('mousedown', _this.handleKeyEnd, true);
                                        _this.listenerNode.addEventListener('keydown', _this.handleKeyDown);
                                    } else {
                                        $94b8c2e7a95a5264$var$events.move.forEach(function(eventName) {
                                            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                                        });
                                        $94b8c2e7a95a5264$var$events.end.forEach(function(eventName) {
                                            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                                        });
                                    }
                                    _this.setState({
                                        sorting: true,
                                        sortingIndex: index
                                    });
                                    if (_onSortStart) _onSortStart({
                                        node: _node,
                                        index: index,
                                        collection: _collection,
                                        isKeySorting: _isKeySorting,
                                        nodes: _this.manager.getOrderedRefs(),
                                        helper: _this.helper
                                    }, event);
                                    if (_isKeySorting) _this.keyMove(0);
                                };
                                var _this$props3 = _this.props, _axis = _this$props3.axis, _getHelperDimensions = _this$props3.getHelperDimensions, _helperClass = _this$props3.helperClass, _hideSortableGhost = _this$props3.hideSortableGhost, updateBeforeSortStart = _this$props3.updateBeforeSortStart, _onSortStart = _this$props3.onSortStart, _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
                                var _node = active.node, _collection = active.collection;
                                var _isKeySorting = _this.manager.isKeySorting;
                                var _temp8 = function() {
                                    if (typeof updateBeforeSortStart === 'function') {
                                        _this._awaitingUpdateBeforeSortStart = true;
                                        var _temp9 = $94b8c2e7a95a5264$var$_finallyRethrows(function() {
                                            var index = _node.sortableInfo.index;
                                            return Promise.resolve(updateBeforeSortStart({
                                                collection: _collection,
                                                index: index,
                                                node: _node,
                                                isKeySorting: _isKeySorting
                                            }, event)).then(function() {});
                                        }, function(_wasThrown, _result) {
                                            _this._awaitingUpdateBeforeSortStart = false;
                                            if (_wasThrown) throw _result;
                                            return _result;
                                        });
                                        if (_temp9 && _temp9.then) return _temp9.then(function() {});
                                    }
                                }();
                                return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
                            }
                        }();
                        return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function() {}) : void 0);
                    } catch (e) {
                        return Promise.reject(e);
                    }
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "handleSortMove", function(event) {
                    var onSortMove = _this.props.onSortMove;
                    if (typeof event.preventDefault === 'function' && event.cancelable) event.preventDefault();
                    _this.updateHelperPosition(event);
                    _this.animateNodes();
                    _this.autoscroll();
                    if (onSortMove) onSortMove(event);
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "handleSortEnd", function(event) {
                    var _this$props4 = _this.props, hideSortableGhost = _this$props4.hideSortableGhost, onSortEnd = _this$props4.onSortEnd;
                    var _this$manager = _this.manager, collection = _this$manager.active.collection, isKeySorting = _this$manager.isKeySorting;
                    var nodes = _this.manager.getOrderedRefs();
                    if (_this.listenerNode) {
                        if (isKeySorting) {
                            _this.listenerNode.removeEventListener('wheel', _this.handleKeyEnd, true);
                            _this.listenerNode.removeEventListener('mousedown', _this.handleKeyEnd, true);
                            _this.listenerNode.removeEventListener('keydown', _this.handleKeyDown);
                        } else {
                            $94b8c2e7a95a5264$var$events.move.forEach(function(eventName) {
                                return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
                            });
                            $94b8c2e7a95a5264$var$events.end.forEach(function(eventName) {
                                return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
                            });
                        }
                    }
                    _this.helper.parentNode.removeChild(_this.helper);
                    if (hideSortableGhost && _this.sortableGhost) $94b8c2e7a95a5264$var$setInlineStyles(_this.sortableGhost, {
                        opacity: '',
                        visibility: ''
                    });
                    for(var i = 0, len = nodes.length; i < len; i++){
                        var _node2 = nodes[i];
                        var el = _node2.node;
                        _node2.edgeOffset = null;
                        _node2.boundingClientRect = null;
                        $94b8c2e7a95a5264$var$setTranslate3d(el, null);
                        $94b8c2e7a95a5264$var$setTransitionDuration(el, null);
                        _node2.translate = null;
                    }
                    _this.autoScroller.clear();
                    _this.manager.active = null;
                    _this.manager.isKeySorting = false;
                    _this.setState({
                        sorting: false,
                        sortingIndex: null
                    });
                    if (typeof onSortEnd === 'function') onSortEnd({
                        collection: collection,
                        newIndex: _this.newIndex,
                        oldIndex: _this.index,
                        isKeySorting: isKeySorting,
                        nodes: nodes
                    }, event);
                    _this.touched = false;
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "autoscroll", function() {
                    var disableAutoscroll = _this.props.disableAutoscroll;
                    var isKeySorting = _this.manager.isKeySorting;
                    if (disableAutoscroll) {
                        _this.autoScroller.clear();
                        return;
                    }
                    if (isKeySorting) {
                        var translate = (0, $5qo9W.default)({}, _this.translate);
                        var scrollX = 0;
                        var scrollY = 0;
                        if (_this.axis.x) {
                            translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
                            scrollX = _this.translate.x - translate.x;
                        }
                        if (_this.axis.y) {
                            translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
                            scrollY = _this.translate.y - translate.y;
                        }
                        _this.translate = translate;
                        $94b8c2e7a95a5264$var$setTranslate3d(_this.helper, _this.translate);
                        _this.scrollContainer.scrollLeft += scrollX;
                        _this.scrollContainer.scrollTop += scrollY;
                        return;
                    }
                    _this.autoScroller.update({
                        height: _this.height,
                        maxTranslate: _this.maxTranslate,
                        minTranslate: _this.minTranslate,
                        translate: _this.translate,
                        width: _this.width
                    });
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "onAutoScroll", function(offset) {
                    _this.translate.x += offset.left;
                    _this.translate.y += offset.top;
                    _this.animateNodes();
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "handleKeyDown", function(event) {
                    var keyCode = event.keyCode;
                    var _this$props5 = _this.props, shouldCancelStart = _this$props5.shouldCancelStart, _this$props5$keyCodes = _this$props5.keyCodes, customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;
                    var keyCodes = (0, $5qo9W.default)({}, $94b8c2e7a95a5264$var$defaultKeyCodes, customKeyCodes);
                    if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) return;
                    event.stopPropagation();
                    event.preventDefault();
                    if (keyCodes.lift.includes(keyCode) && !_this.manager.active) _this.keyLift(event);
                    else if (keyCodes.drop.includes(keyCode) && _this.manager.active) _this.keyDrop(event);
                    else if (keyCodes.cancel.includes(keyCode)) {
                        _this.newIndex = _this.manager.active.index;
                        _this.keyDrop(event);
                    } else if (keyCodes.up.includes(keyCode)) _this.keyMove(-1);
                    else if (keyCodes.down.includes(keyCode)) _this.keyMove(1);
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "keyLift", function(event) {
                    var target = event.target;
                    var node = $94b8c2e7a95a5264$var$closest(target, function(el) {
                        return el.sortableInfo != null;
                    });
                    var _node$sortableInfo2 = node.sortableInfo, index = _node$sortableInfo2.index, collection = _node$sortableInfo2.collection;
                    _this.initialFocusedNode = target;
                    _this.manager.isKeySorting = true;
                    _this.manager.active = {
                        index: index,
                        collection: collection
                    };
                    _this.handlePress(event);
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "keyMove", function(shift) {
                    var nodes = _this.manager.getOrderedRefs();
                    var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
                    var newIndex = _this.newIndex + shift;
                    var prevIndex = _this.newIndex;
                    if (newIndex < 0 || newIndex > lastIndex) return;
                    _this.prevIndex = prevIndex;
                    _this.newIndex = newIndex;
                    var targetIndex = $94b8c2e7a95a5264$var$getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
                    var target = nodes.find(function(_ref2) {
                        var node = _ref2.node;
                        return node.sortableInfo.index === targetIndex;
                    });
                    var targetNode = target.node;
                    var scrollDelta = _this.containerScrollDelta;
                    var targetBoundingClientRect = target.boundingClientRect || $94b8c2e7a95a5264$var$getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
                    var targetTranslate = target.translate || {
                        x: 0,
                        y: 0
                    };
                    var targetPosition = {
                        top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
                        left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
                    };
                    var shouldAdjustForSize = prevIndex < newIndex;
                    var sizeAdjustment = {
                        x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
                        y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
                    };
                    _this.handleSortMove({
                        pageX: targetPosition.left + sizeAdjustment.x,
                        pageY: targetPosition.top + sizeAdjustment.y,
                        ignoreTransition: shift === 0
                    });
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "keyDrop", function(event) {
                    _this.handleSortEnd(event);
                    if (_this.initialFocusedNode) _this.initialFocusedNode.focus();
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "handleKeyEnd", function(event) {
                    if (_this.manager.active) _this.keyDrop(event);
                });
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "isValidSortingTarget", function(event) {
                    var useDragHandle = _this.props.useDragHandle;
                    var target = event.target;
                    var node = $94b8c2e7a95a5264$var$closest(target, function(el) {
                        return el.sortableInfo != null;
                    });
                    return node && node.sortableInfo && !node.sortableInfo.disabled && (useDragHandle ? $94b8c2e7a95a5264$var$isSortableHandle(target) : target.sortableInfo);
                });
                var manager = new $94b8c2e7a95a5264$var$Manager();
                $94b8c2e7a95a5264$var$validateProps(props);
                _this.manager = manager;
                _this.wrappedInstance = (0, $5uXOq.createRef)();
                _this.sortableContextValue = {
                    manager: manager
                };
                _this.events = {
                    end: _this.handleEnd,
                    move: _this.handleMove,
                    start: _this.handleStart
                };
                return _this;
            }
            (0, $6tg7d.default)(WithSortableContainer, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        var _this2 = this;
                        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                        var container = this.getContainer();
                        Promise.resolve(container).then(function(containerNode) {
                            _this2.container = containerNode;
                            _this2.document = _this2.container.ownerDocument || document;
                            var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
                            _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
                            _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : $94b8c2e7a95a5264$var$getScrollingParent(_this2.container) || _this2.container;
                            _this2.autoScroller = new $94b8c2e7a95a5264$var$AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
                            Object.keys(_this2.events).forEach(function(key) {
                                return $94b8c2e7a95a5264$var$events[key].forEach(function(eventName) {
                                    return _this2.container.addEventListener(eventName, _this2.events[key], false);
                                });
                            });
                            _this2.container.addEventListener('keydown', _this2.handleKeyDown);
                        });
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        var _this3 = this;
                        if (this.helper && this.helper.parentNode) this.helper.parentNode.removeChild(this.helper);
                        if (!this.container) return;
                        Object.keys(this.events).forEach(function(key) {
                            return $94b8c2e7a95a5264$var$events[key].forEach(function(eventName) {
                                return _this3.container.removeEventListener(eventName, _this3.events[key]);
                            });
                        });
                        this.container.removeEventListener('keydown', this.handleKeyDown);
                    }
                },
                {
                    key: "updateHelperPosition",
                    value: function updateHelperPosition(event) {
                        var _this$props6 = this.props, lockAxis = _this$props6.lockAxis, lockOffset = _this$props6.lockOffset, lockToContainerEdges = _this$props6.lockToContainerEdges, transitionDuration = _this$props6.transitionDuration, _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration, keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
                        var isKeySorting = this.manager.isKeySorting;
                        var ignoreTransition = event.ignoreTransition;
                        var offset = $94b8c2e7a95a5264$var$getPosition(event);
                        var translate = {
                            x: offset.x - this.initialOffset.x,
                            y: offset.y - this.initialOffset.y
                        };
                        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
                        translate.x -= window.pageXOffset - this.initialWindowScroll.left;
                        this.translate = translate;
                        if (lockToContainerEdges) {
                            var _getLockPixelOffsets = $94b8c2e7a95a5264$var$getLockPixelOffsets({
                                height: this.height,
                                lockOffset: lockOffset,
                                width: this.width
                            }), _getLockPixelOffsets2 = (0, $5qOly.default)(_getLockPixelOffsets, 2), minLockOffset = _getLockPixelOffsets2[0], maxLockOffset = _getLockPixelOffsets2[1];
                            var minOffset = {
                                x: this.width / 2 - minLockOffset.x,
                                y: this.height / 2 - minLockOffset.y
                            };
                            var maxOffset = {
                                x: this.width / 2 - maxLockOffset.x,
                                y: this.height / 2 - maxLockOffset.y
                            };
                            translate.x = $94b8c2e7a95a5264$var$limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
                            translate.y = $94b8c2e7a95a5264$var$limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
                        }
                        if (lockAxis === 'x') translate.y = 0;
                        else if (lockAxis === 'y') translate.x = 0;
                        if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) $94b8c2e7a95a5264$var$setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
                        $94b8c2e7a95a5264$var$setTranslate3d(this.helper, translate);
                    }
                },
                {
                    key: "animateNodes",
                    value: function animateNodes() {
                        var _this$props7 = this.props, transitionDuration = _this$props7.transitionDuration, hideSortableGhost = _this$props7.hideSortableGhost, onSortOver = _this$props7.onSortOver;
                        var containerScrollDelta = this.containerScrollDelta, windowScrollDelta = this.windowScrollDelta;
                        var nodes = this.manager.getOrderedRefs();
                        var sortingOffset = {
                            left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
                            top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
                        };
                        var isKeySorting = this.manager.isKeySorting;
                        var prevIndex = this.newIndex;
                        this.newIndex = null;
                        for(var i = 0, len = nodes.length; i < len; i++){
                            var _node3 = nodes[i].node;
                            var index = _node3.sortableInfo.index;
                            var width = _node3.offsetWidth;
                            var height = _node3.offsetHeight;
                            var offset = {
                                height: this.height > height ? height / 2 : this.height / 2,
                                width: this.width > width ? width / 2 : this.width / 2
                            };
                            var mustShiftBackward = isKeySorting && index > this.index && index <= prevIndex;
                            var mustShiftForward = isKeySorting && index < this.index && index >= prevIndex;
                            var translate = {
                                x: 0,
                                y: 0
                            };
                            var edgeOffset = nodes[i].edgeOffset;
                            if (!edgeOffset) {
                                edgeOffset = $94b8c2e7a95a5264$var$getEdgeOffset(_node3, this.container);
                                nodes[i].edgeOffset = edgeOffset;
                                if (isKeySorting) nodes[i].boundingClientRect = $94b8c2e7a95a5264$var$getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
                            }
                            var nextNode = i < nodes.length - 1 && nodes[i + 1];
                            var prevNode = i > 0 && nodes[i - 1];
                            if (nextNode && !nextNode.edgeOffset) {
                                nextNode.edgeOffset = $94b8c2e7a95a5264$var$getEdgeOffset(nextNode.node, this.container);
                                if (isKeySorting) nextNode.boundingClientRect = $94b8c2e7a95a5264$var$getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
                            }
                            if (index === this.index) {
                                if (hideSortableGhost) {
                                    this.sortableGhost = _node3;
                                    $94b8c2e7a95a5264$var$setInlineStyles(_node3, {
                                        opacity: 0,
                                        visibility: 'hidden'
                                    });
                                }
                                continue;
                            }
                            if (transitionDuration) $94b8c2e7a95a5264$var$setTransitionDuration(_node3, transitionDuration);
                            if (this.axis.x) {
                                if (this.axis.y) {
                                    if (mustShiftForward || index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                                        translate.x = this.width + this.marginOffset.x;
                                        if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                                            if (nextNode) {
                                                translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                                                translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                                            }
                                        }
                                        if (this.newIndex === null) this.newIndex = index;
                                    } else if (mustShiftBackward || index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                                        translate.x = -(this.width + this.marginOffset.x);
                                        if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                                            if (prevNode) {
                                                translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                                                translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                                            }
                                        }
                                        this.newIndex = index;
                                    }
                                } else {
                                    if (mustShiftBackward || index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                                        translate.x = -(this.width + this.marginOffset.x);
                                        this.newIndex = index;
                                    } else if (mustShiftForward || index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                                        translate.x = this.width + this.marginOffset.x;
                                        if (this.newIndex == null) this.newIndex = index;
                                    }
                                }
                            } else if (this.axis.y) {
                                if (mustShiftBackward || index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
                                    translate.y = -(this.height + this.marginOffset.y);
                                    this.newIndex = index;
                                } else if (mustShiftForward || index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
                                    translate.y = this.height + this.marginOffset.y;
                                    if (this.newIndex == null) this.newIndex = index;
                                }
                            }
                            $94b8c2e7a95a5264$var$setTranslate3d(_node3, translate);
                            nodes[i].translate = translate;
                        }
                        if (this.newIndex == null) this.newIndex = this.index;
                        if (isKeySorting) this.newIndex = prevIndex;
                        var oldIndex = isKeySorting ? this.prevIndex : prevIndex;
                        if (onSortOver && this.newIndex !== oldIndex) onSortOver({
                            collection: this.manager.active.collection,
                            index: this.index,
                            newIndex: this.newIndex,
                            oldIndex: oldIndex,
                            isKeySorting: isKeySorting,
                            nodes: nodes,
                            helper: this.helper
                        });
                    }
                },
                {
                    key: "getWrappedInstance",
                    value: function getWrappedInstance() {
                        (0, ($parcel$interopDefault($aE1Lc)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
                        return this.wrappedInstance.current;
                    }
                },
                {
                    key: "getContainer",
                    value: function getContainer() {
                        var getContainer = this.props.getContainer;
                        if (typeof getContainer !== 'function') return (0, $7nsd3.findDOMNode)(this);
                        return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var ref = config.withRef ? this.wrappedInstance : null;
                        return (0, $5uXOq.createElement)($94b8c2e7a95a5264$var$SortableContext.Provider, {
                            value: this.sortableContextValue
                        }, (0, $5uXOq.createElement)(WrappedComponent, (0, $bS32t.default)({
                            ref: ref
                        }, $94b8c2e7a95a5264$var$omit(this.props, $94b8c2e7a95a5264$var$omittedProps))));
                    }
                },
                {
                    key: "helperContainer",
                    get: function get() {
                        var helperContainer = this.props.helperContainer;
                        if (typeof helperContainer === 'function') return helperContainer();
                        return this.props.helperContainer || this.document.body;
                    }
                },
                {
                    key: "containerScrollDelta",
                    get: function get() {
                        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                        if (useWindowAsScrollContainer) return {
                            left: 0,
                            top: 0
                        };
                        return {
                            left: this.scrollContainer.scrollLeft - this.initialScroll.left,
                            top: this.scrollContainer.scrollTop - this.initialScroll.top
                        };
                    }
                },
                {
                    key: "windowScrollDelta",
                    get: function get() {
                        return {
                            left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
                            top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
                        };
                    }
                }
            ]);
            return WithSortableContainer;
        }((0, $5uXOq.Component)), (0, $eHiP8.default)(_class, "displayName", $94b8c2e7a95a5264$var$provideDisplayName('sortableList', WrappedComponent)), (0, $eHiP8.default)(_class, "defaultProps", $94b8c2e7a95a5264$var$defaultProps), (0, $eHiP8.default)(_class, "propTypes", $94b8c2e7a95a5264$var$propTypes), _temp;
    }
    var $94b8c2e7a95a5264$var$propTypes$1 = {
        index: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number.isRequired,
        collection: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).number,
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string
        ]),
        disabled: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool
    };
    var $94b8c2e7a95a5264$var$omittedProps$1 = Object.keys($94b8c2e7a95a5264$var$propTypes$1);
    function $94b8c2e7a95a5264$export$58d1e4fb0d207bf7(WrappedComponent) {
        var _class, _temp;
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            withRef: false
        };
        return _temp = _class = function(_React$Component) {
            (0, $1SDbw.default)(WithSortableElement, _React$Component);
            function WithSortableElement() {
                var _getPrototypeOf2;
                var _this;
                (0, $joEwT.default)(this, WithSortableElement);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = (0, $lthwC.default)(this, (_getPrototypeOf2 = (0, $k8Nlm.default)(WithSortableElement)).call.apply(_getPrototypeOf2, [
                    this
                ].concat(args)));
                (0, $eHiP8.default)((0, $hmqmu.default)((0, $hmqmu.default)(_this)), "wrappedInstance", (0, $5uXOq.createRef)());
                return _this;
            }
            (0, $6tg7d.default)(WithSortableElement, [
                {
                    key: "componentDidMount",
                    value: function componentDidMount() {
                        this.register();
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function componentDidUpdate(prevProps) {
                        if (this.node) {
                            if (prevProps.index !== this.props.index) this.node.sortableInfo.index = this.props.index;
                            if (prevProps.disabled !== this.props.disabled) this.node.sortableInfo.disabled = this.props.disabled;
                        }
                        if (prevProps.collection !== this.props.collection) {
                            this.unregister(prevProps.collection);
                            this.register();
                        }
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function componentWillUnmount() {
                        this.unregister();
                    }
                },
                {
                    key: "register",
                    value: function register() {
                        var _this$props = this.props, collection = _this$props.collection, disabled = _this$props.disabled, index = _this$props.index;
                        var node = (0, $7nsd3.findDOMNode)(this);
                        node.sortableInfo = {
                            collection: collection,
                            disabled: disabled,
                            index: index,
                            manager: this.context.manager
                        };
                        this.node = node;
                        this.ref = {
                            node: node
                        };
                        this.context.manager.add(collection, this.ref);
                    }
                },
                {
                    key: "unregister",
                    value: function unregister() {
                        var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.collection;
                        this.context.manager.remove(collection, this.ref);
                    }
                },
                {
                    key: "getWrappedInstance",
                    value: function getWrappedInstance() {
                        (0, ($parcel$interopDefault($aE1Lc)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
                        return this.wrappedInstance.current;
                    }
                },
                {
                    key: "render",
                    value: function render() {
                        var ref = config.withRef ? this.wrappedInstance : null;
                        return (0, $5uXOq.createElement)(WrappedComponent, (0, $bS32t.default)({
                            ref: ref
                        }, $94b8c2e7a95a5264$var$omit(this.props, $94b8c2e7a95a5264$var$omittedProps$1)));
                    }
                }
            ]);
            return WithSortableElement;
        }((0, $5uXOq.Component)), (0, $eHiP8.default)(_class, "displayName", $94b8c2e7a95a5264$var$provideDisplayName('sortableElement', WrappedComponent)), (0, $eHiP8.default)(_class, "contextType", $94b8c2e7a95a5264$var$SortableContext), (0, $eHiP8.default)(_class, "propTypes", $94b8c2e7a95a5264$var$propTypes$1), (0, $eHiP8.default)(_class, "defaultProps", {
            collection: 0
        }), _temp;
    }
});
parcelRegister("5qOly", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f466f431aa10d88$export$2e2bcd8739ae039);
    var $8GLdb = parcelRequire("8GLdb");
    var $aC1R7 = parcelRequire("aC1R7");
    var $25oAX = parcelRequire("25oAX");
    var $93sLP = parcelRequire("93sLP");
    function $3f466f431aa10d88$export$2e2bcd8739ae039(r, e) {
        return (0, $8GLdb.default)(r) || (0, $aC1R7.default)(r, e) || (0, $25oAX.default)(r, e) || (0, $93sLP.default)();
    }
});
parcelRegister("8GLdb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6536de3a6357906a$export$2e2bcd8739ae039);
    function $6536de3a6357906a$export$2e2bcd8739ae039(r) {
        if (Array.isArray(r)) return r;
    }
});
parcelRegister("aC1R7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b9ee4848e0ed3bc$export$2e2bcd8739ae039);
    function $7b9ee4848e0ed3bc$export$2e2bcd8739ae039(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
});
parcelRegister("25oAX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$184f207ecf6bdfe1$export$2e2bcd8739ae039);
    var $850Co = parcelRequire("850Co");
    function $184f207ecf6bdfe1$export$2e2bcd8739ae039(r, a) {
        if (r) {
            if ("string" == typeof r) return (0, $850Co.default)(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $850Co.default)(r, a) : void 0;
        }
    }
});
parcelRegister("850Co", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e1f451d7ddfcd3c$export$2e2bcd8739ae039);
    function $5e1f451d7ddfcd3c$export$2e2bcd8739ae039(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
});
parcelRegister("93sLP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$697ab6131f3ef83b$export$2e2bcd8739ae039);
    function $697ab6131f3ef83b$export$2e2bcd8739ae039() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
});
parcelRegister("5qo9W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f321efe254d58f3$export$2e2bcd8739ae039);
    var $eHiP8 = parcelRequire("eHiP8");
    function $3f321efe254d58f3$export$2e2bcd8739ae039(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t);
            "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })), o.forEach(function(r) {
                (0, $eHiP8.default)(e, r, t[r]);
            });
        }
        return e;
    }
});
parcelRegister("joEwT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1efb285dd714ea1$export$2e2bcd8739ae039);
    function $e1efb285dd714ea1$export$2e2bcd8739ae039(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
});
parcelRegister("6tg7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b61f3b5c2442de6$export$2e2bcd8739ae039);
    var $586Rz = parcelRequire("586Rz");
    function $4b61f3b5c2442de6$var$_defineProperties(e, r) {
        for(var t = 0; t < r.length; t++){
            var o = r[t];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $586Rz.default)(o.key), o);
        }
    }
    function $4b61f3b5c2442de6$export$2e2bcd8739ae039(e, r, t) {
        return r && $4b61f3b5c2442de6$var$_defineProperties(e.prototype, r), t && $4b61f3b5c2442de6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
});
parcelRegister("lthwC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa19e6855af9d09c$export$2e2bcd8739ae039);
    var $eKtAb = parcelRequire("eKtAb");
    var $hmqmu = parcelRequire("hmqmu");
    function $fa19e6855af9d09c$export$2e2bcd8739ae039(t, e) {
        if (e && ("object" == (0, $eKtAb.default)(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return (0, $hmqmu.default)(t);
    }
});
parcelRegister("k8Nlm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea9ad49ce98982b9$export$2e2bcd8739ae039);
    function $ea9ad49ce98982b9$export$2e2bcd8739ae039(t) {
        return $ea9ad49ce98982b9$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t);
        }, $ea9ad49ce98982b9$export$2e2bcd8739ae039(t);
    }
});
parcelRegister("1SDbw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15e93ae86cf373c6$export$2e2bcd8739ae039);
    var $ghG7M = parcelRequire("ghG7M");
    function $15e93ae86cf373c6$export$2e2bcd8739ae039(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(t, "prototype", {
            writable: !1
        }), e && (0, $ghG7M.default)(t, e);
    }
});
parcelRegister("1UctI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1634b355e69ccb88$export$2e2bcd8739ae039);
    var $jkXj8 = parcelRequire("jkXj8");
    var $5HclJ = parcelRequire("5HclJ");
    var $25oAX = parcelRequire("25oAX");
    var $9DYiy = parcelRequire("9DYiy");
    function $1634b355e69ccb88$export$2e2bcd8739ae039(r) {
        return (0, $jkXj8.default)(r) || (0, $5HclJ.default)(r) || (0, $25oAX.default)(r) || (0, $9DYiy.default)();
    }
});
parcelRegister("jkXj8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e13de3da34e49a69$export$2e2bcd8739ae039);
    var $850Co = parcelRequire("850Co");
    function $e13de3da34e49a69$export$2e2bcd8739ae039(r) {
        if (Array.isArray(r)) return (0, $850Co.default)(r);
    }
});
parcelRegister("5HclJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$425a8c4646652284$export$2e2bcd8739ae039);
    function $425a8c4646652284$export$2e2bcd8739ae039(r) {
        if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
});
parcelRegister("9DYiy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7056878776ef3b21$export$2e2bcd8739ae039);
    function $7056878776ef3b21$export$2e2bcd8739ae039() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
});
parcelRegister("78tet", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $531ff4bbcd008815$var$_react = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $531ff4bbcd008815$var$_dragHandle = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("idRxN")));
    function $531ff4bbcd008815$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $531ff4bbcd008815$var$DragHandlerIcon = (props)=>$531ff4bbcd008815$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
        }, props, {
            newIcon: $531ff4bbcd008815$var$_dragHandle.default
        }));
    $531ff4bbcd008815$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
    var $531ff4bbcd008815$var$_default = module.exports.default = $531ff4bbcd008815$var$DragHandlerIcon;
});
parcelRegister("idRxN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d442f9a78d3217d7$var$_react = $d442f9a78d3217d7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d442f9a78d3217d7$var$_UNSAFE_baseNew = $d442f9a78d3217d7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $d442f9a78d3217d7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d442f9a78d3217d7$var$DragHandleIcon = (props)=>$d442f9a78d3217d7$var$_react.default.createElement($d442f9a78d3217d7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
        }, props));
    $d442f9a78d3217d7$var$DragHandleIcon.displayName = 'DragHandleIcon';
    var $d442f9a78d3217d7$var$_default = module.exports.default = $d442f9a78d3217d7$var$DragHandleIcon;
});
parcelRegister("2C7j9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
    function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>$1e74cc92a54dd799$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $1e74cc92a54dd799$var$_close.default
        }));
    $1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;
});
parcelRegister("dQO6P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a157005563d95297$var$_react = $a157005563d95297$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a157005563d95297$var$_UNSAFE_baseNew = $a157005563d95297$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a157005563d95297$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a157005563d95297$var$DragHandleIcon = (props)=>$a157005563d95297$var$_react.default.createElement($a157005563d95297$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M5 2.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M5 6a1.25 1.25 0 1 1-2.5 0A1.25 1.25 0 0 1 5 6m4.5 0A1.25 1.25 0 1 1 7 6a1.25 1.25 0 0 1 2.5 0M5 9.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m4.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"/>`,
            type: 'utility'
        }, props));
    $a157005563d95297$var$DragHandleIcon.displayName = 'DragHandleIcon';
    var $a157005563d95297$var$_default = module.exports.default = $a157005563d95297$var$DragHandleIcon;
});
parcelRegister("8nAYy", function(module, exports) {
    $parcel$export(module.exports, "getListableColumns", ()=>$8635d67e7a1d8b4e$export$b130bbab35fbab57);
    var $bjzU8;
    var $4nDwW = parcelRequire("4nDwW");
    const $8635d67e7a1d8b4e$var$INCOMING_DEPENDENCY = 'incomingDependencies';
    const $8635d67e7a1d8b4e$var$OUTGOING_DEPENDENCY = 'outgoingDependencies';
    const $8635d67e7a1d8b4e$export$b130bbab35fbab57 = (columns)=>(0, parcelRequire("bjzU8")).default((0, $4nDwW.groupBy)((column)=>[
                $8635d67e7a1d8b4e$var$INCOMING_DEPENDENCY,
                $8635d67e7a1d8b4e$var$OUTGOING_DEPENDENCY
            ].includes(column.id) ? 'dependency' : `${column.localizedTitle}-${column.id}`, columns));
});
parcelRegister("7U3Fb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be7f827aa173767c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $be7f827aa173767c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        advancedFieldsMenuNoSelectedFields: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-fields-menu-no-selected-fields",
            "defaultMessage": "No fields have been selected."
        },
        advancedFieldsMenuCustomFieldLozenge: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-fields-menu-custom-field-lozenge",
            "defaultMessage": "CUSTOM"
        },
        advancedFieldsMenuSelectedFieldDragTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-fields-menu-selected-field-drag-tooltip",
            "defaultMessage": "Rearrange field order"
        },
        advancedFieldsMenuSelectedFieldRemoveTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-fields-menu-selected-field-remove-tooltip",
            "defaultMessage": "Remove field"
        },
        advancedFieldsMenuSelectedFieldRemoveAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-fields-menu-selected-field-remove-aria-label",
            "defaultMessage": "Remove {fieldName} field"
        },
        advancedFieldMenuFocusedFieldAnnouncement: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-field-menu-focused-field-announcement",
            "defaultMessage": "Draggable item. Ensure your screen reader is not in browse mode and then press the space bar to lift."
        },
        advancedFieldMenuGrabbedFieldAnnouncement: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-field-menu-grabbed-field-announcement",
            "defaultMessage": "You have lifted {fieldName} field. Use the arrow keys to move, space bar to drop, and escape to cancel."
        },
        advancedFieldMenuDroppedFieldAnnouncement: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-field-menu-dropped-field-announcement",
            "defaultMessage": "You have moved {fieldName} field to Position {position}."
        },
        advancedFieldMenuMovedFieldAnnouncement: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-field-menu-moved-field-announcement",
            "defaultMessage": "You have moved an item from the Position {initialPosition} to Position {currentPosition}. Use the arrow keys to move, space bar to drop, and escape to cancel.\""
        }
    });
});
parcelRegister("hzOyB", function(module, exports) {
    $parcel$export(module.exports, "afm-custom-field-lozenge", ()=>$ccbcec2110ea70c7$export$51a969aafb1f991c, (v)=>$ccbcec2110ea70c7$export$51a969aafb1f991c = v);
    $parcel$export(module.exports, "afm-dropdown-menu-body", ()=>$ccbcec2110ea70c7$export$43df9b5ce18a8b4, (v)=>$ccbcec2110ea70c7$export$43df9b5ce18a8b4 = v);
    $parcel$export(module.exports, "afm-no-selected-fields", ()=>$ccbcec2110ea70c7$export$8abc7ba865f0cc7f, (v)=>$ccbcec2110ea70c7$export$8abc7ba865f0cc7f = v);
    $parcel$export(module.exports, "afm-selected-field-item", ()=>$ccbcec2110ea70c7$export$fcb0fc7018fc0e10, (v)=>$ccbcec2110ea70c7$export$fcb0fc7018fc0e10 = v);
    $parcel$export(module.exports, "afm-selected-field-item-drag-icon", ()=>$ccbcec2110ea70c7$export$f7ad72c054fabedb, (v)=>$ccbcec2110ea70c7$export$f7ad72c054fabedb = v);
    $parcel$export(module.exports, "afm-selected-field-item-old", ()=>$ccbcec2110ea70c7$export$98d89a6b9ae963f6, (v)=>$ccbcec2110ea70c7$export$98d89a6b9ae963f6 = v);
    $parcel$export(module.exports, "afm-selected-field-item-remove-icon", ()=>$ccbcec2110ea70c7$export$94fc5f115eb0699b, (v)=>$ccbcec2110ea70c7$export$94fc5f115eb0699b = v);
    $parcel$export(module.exports, "afm-selected-field-item-remove-icon-button", ()=>$ccbcec2110ea70c7$export$5349758fd85eb4be, (v)=>$ccbcec2110ea70c7$export$5349758fd85eb4be = v);
    $parcel$export(module.exports, "afm-selected-field-item-section", ()=>$ccbcec2110ea70c7$export$d6f135831cf0ddc1, (v)=>$ccbcec2110ea70c7$export$d6f135831cf0ddc1 = v);
    $parcel$export(module.exports, "afm-selected-field-item-title", ()=>$ccbcec2110ea70c7$export$b81eed1372b5b4de, (v)=>$ccbcec2110ea70c7$export$b81eed1372b5b4de = v);
    $parcel$export(module.exports, "afm-sortable-helper", ()=>$ccbcec2110ea70c7$export$d838166ee9717897, (v)=>$ccbcec2110ea70c7$export$d838166ee9717897 = v);
    var $ccbcec2110ea70c7$export$51a969aafb1f991c;
    var $ccbcec2110ea70c7$export$43df9b5ce18a8b4;
    var $ccbcec2110ea70c7$export$8abc7ba865f0cc7f;
    var $ccbcec2110ea70c7$export$fcb0fc7018fc0e10;
    var $ccbcec2110ea70c7$export$d099f59ae3e2e288;
    var $ccbcec2110ea70c7$export$f7ad72c054fabedb;
    var $ccbcec2110ea70c7$export$98d89a6b9ae963f6;
    var $ccbcec2110ea70c7$export$94fc5f115eb0699b;
    var $ccbcec2110ea70c7$export$5349758fd85eb4be;
    var $ccbcec2110ea70c7$export$d6f135831cf0ddc1;
    var $ccbcec2110ea70c7$export$b81eed1372b5b4de;
    var $ccbcec2110ea70c7$export$d838166ee9717897;
    $ccbcec2110ea70c7$export$51a969aafb1f991c = `GgeTjW_afm-custom-field-lozenge`;
    $ccbcec2110ea70c7$export$43df9b5ce18a8b4 = `GgeTjW_afm-dropdown-menu-body`;
    $ccbcec2110ea70c7$export$8abc7ba865f0cc7f = `GgeTjW_afm-no-selected-fields`;
    $ccbcec2110ea70c7$export$fcb0fc7018fc0e10 = `GgeTjW_afm-selected-field-item`;
    $ccbcec2110ea70c7$export$d099f59ae3e2e288 = `GgeTjW_afm-selected-field-item-custom-lozenge`;
    $ccbcec2110ea70c7$export$f7ad72c054fabedb = `GgeTjW_afm-selected-field-item-drag-icon`;
    $ccbcec2110ea70c7$export$98d89a6b9ae963f6 = `GgeTjW_afm-selected-field-item-old`;
    $ccbcec2110ea70c7$export$94fc5f115eb0699b = `GgeTjW_afm-selected-field-item-remove-icon`;
    $ccbcec2110ea70c7$export$5349758fd85eb4be = `GgeTjW_afm-selected-field-item-remove-icon-button`;
    $ccbcec2110ea70c7$export$d6f135831cf0ddc1 = `GgeTjW_afm-selected-field-item-section`;
    $ccbcec2110ea70c7$export$b81eed1372b5b4de = `GgeTjW_afm-selected-field-item-title`;
    $ccbcec2110ea70c7$export$d838166ee9717897 = `GgeTjW_afm-sortable-helper`;
});
parcelRegister("2YLR0", function(module, exports) {
    $parcel$export(module.exports, "afm-custom-field-lozenge", ()=>$22b64e2906718804$export$51a969aafb1f991c, (v)=>$22b64e2906718804$export$51a969aafb1f991c = v);
    $parcel$export(module.exports, "afm-dropdown-container", ()=>$22b64e2906718804$export$95815578c4856fea, (v)=>$22b64e2906718804$export$95815578c4856fea = v);
    $parcel$export(module.exports, "afm-dropdown-menu-divider", ()=>$22b64e2906718804$export$8c2501616d9e2d73, (v)=>$22b64e2906718804$export$8c2501616d9e2d73 = v);
    $parcel$export(module.exports, "afm-dropdown-menu-header", ()=>$22b64e2906718804$export$39c716ad17a14d42, (v)=>$22b64e2906718804$export$39c716ad17a14d42 = v);
    $parcel$export(module.exports, "afm-field-option", ()=>$22b64e2906718804$export$c4dc84db340240de, (v)=>$22b64e2906718804$export$c4dc84db340240de = v);
    $parcel$export(module.exports, "afm-field-option-custom-lozenge", ()=>$22b64e2906718804$export$dfe7b0b9ad68beaf, (v)=>$22b64e2906718804$export$dfe7b0b9ad68beaf = v);
    $parcel$export(module.exports, "afm-field-option-title", ()=>$22b64e2906718804$export$513e2dab2e941930, (v)=>$22b64e2906718804$export$513e2dab2e941930 = v);
    $parcel$export(module.exports, "afm-header-left", ()=>$22b64e2906718804$export$6c74d3971ac3113, (v)=>$22b64e2906718804$export$6c74d3971ac3113 = v);
    $parcel$export(module.exports, "afm-select-option-label", ()=>$22b64e2906718804$export$a0bf72b5860d98, (v)=>$22b64e2906718804$export$a0bf72b5860d98 = v);
    var $22b64e2906718804$export$21220cda0bbe516b;
    var $22b64e2906718804$export$51a969aafb1f991c;
    var $22b64e2906718804$export$95815578c4856fea;
    var $22b64e2906718804$export$560c6189393c16e;
    var $22b64e2906718804$export$43df9b5ce18a8b4;
    var $22b64e2906718804$export$8c2501616d9e2d73;
    var $22b64e2906718804$export$e6b766ff3c71a859;
    var $22b64e2906718804$export$ce1082ff2dcc4f0d;
    var $22b64e2906718804$export$39c716ad17a14d42;
    var $22b64e2906718804$export$590974056234d93e;
    var $22b64e2906718804$export$c4dc84db340240de;
    var $22b64e2906718804$export$dfe7b0b9ad68beaf;
    var $22b64e2906718804$export$513e2dab2e941930;
    var $22b64e2906718804$export$6c74d3971ac3113;
    var $22b64e2906718804$export$a0bf72b5860d98;
    var $22b64e2906718804$export$fcb0fc7018fc0e10;
    var $22b64e2906718804$export$d099f59ae3e2e288;
    var $22b64e2906718804$export$f7ad72c054fabedb;
    var $22b64e2906718804$export$94fc5f115eb0699b;
    var $22b64e2906718804$export$b81eed1372b5b4de;
    var $22b64e2906718804$export$d838166ee9717897;
    var $22b64e2906718804$export$9f40be408ef90a09;
    var $22b64e2906718804$export$fa60ad54036b1f7a;
    var $22b64e2906718804$export$ed632e85719c4e08;
    $22b64e2906718804$export$21220cda0bbe516b = `_2rlvoW_afm-custom-field-label`;
    $22b64e2906718804$export$51a969aafb1f991c = `_2rlvoW_afm-custom-field-lozenge`;
    $22b64e2906718804$export$95815578c4856fea = `_2rlvoW_afm-dropdown-container`;
    $22b64e2906718804$export$560c6189393c16e = `_2rlvoW_afm-dropdown-container-old`;
    $22b64e2906718804$export$43df9b5ce18a8b4 = `_2rlvoW_afm-dropdown-menu-body`;
    $22b64e2906718804$export$8c2501616d9e2d73 = `_2rlvoW_afm-dropdown-menu-divider`;
    $22b64e2906718804$export$e6b766ff3c71a859 = `_2rlvoW_afm-dropdown-menu-footer`;
    $22b64e2906718804$export$ce1082ff2dcc4f0d = `_2rlvoW_afm-dropdown-menu-footer-old`;
    $22b64e2906718804$export$39c716ad17a14d42 = `_2rlvoW_afm-dropdown-menu-header`;
    $22b64e2906718804$export$590974056234d93e = `_2rlvoW_afm-dropdown-menu-header-old`;
    $22b64e2906718804$export$c4dc84db340240de = `_2rlvoW_afm-field-option`;
    $22b64e2906718804$export$dfe7b0b9ad68beaf = `_2rlvoW_afm-field-option-custom-lozenge`;
    $22b64e2906718804$export$513e2dab2e941930 = `_2rlvoW_afm-field-option-title`;
    $22b64e2906718804$export$6c74d3971ac3113 = `_2rlvoW_afm-header-left`;
    $22b64e2906718804$export$a0bf72b5860d98 = `_2rlvoW_afm-select-option-label`;
    $22b64e2906718804$export$fcb0fc7018fc0e10 = `_2rlvoW_afm-selected-field-item`;
    $22b64e2906718804$export$d099f59ae3e2e288 = `_2rlvoW_afm-selected-field-item-custom-lozenge`;
    $22b64e2906718804$export$f7ad72c054fabedb = `_2rlvoW_afm-selected-field-item-drag-icon`;
    $22b64e2906718804$export$94fc5f115eb0699b = `_2rlvoW_afm-selected-field-item-remove-icon`;
    $22b64e2906718804$export$b81eed1372b5b4de = `_2rlvoW_afm-selected-field-item-title`;
    $22b64e2906718804$export$d838166ee9717897 = `_2rlvoW_afm-sortable-helper`;
    $22b64e2906718804$export$9f40be408ef90a09 = `_2rlvoW_afm-trigger-button`;
    $22b64e2906718804$export$fa60ad54036b1f7a = `_2rlvoW_afm-trigger-button-icon`;
    $22b64e2906718804$export$ed632e85719c4e08 = `_2rlvoW_afm-trigger-button-text`;
});
parcelRegister("fWEk3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca80622a5755a020$export$2e2bcd8739ae039);
    var $bC2fB;
    var $26wQU = parcelRequire("26wQU");
    var $61Qs7 = parcelRequire("61Qs7");
    var $ca80622a5755a020$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $26wQU.default), {})((0, $61Qs7.default));
});
parcelRegister("26wQU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb5855f458d89307$export$2e2bcd8739ae039);
    var $f1uil;
    var $it1wb;
    var $pyK8a;
    var $flnZx;
    var $1CGdp = parcelRequire("1CGdp");
    var $jAIJh = parcelRequire("jAIJh");
    var $3YtPS = parcelRequire("3YtPS");
    const $eb5855f458d89307$export$195ac24e17449cb1 = (timelineRange)=>{
        const { start: start, end: end } = timelineRange;
        const startDate = new Date(start);
        const endDate = new Date(end);
        const todayDate = (0, $jAIJh.getTodayDate)();
        let staticAxisPosition = {};
        if (todayDate.getTime() < startDate.getTime() || todayDate.getTime() > endDate.getTime()) return staticAxisPosition;
        const totalDays = (end - start) / (0, (0, parcelRequire("flnZx")).ONE_DAY);
        let startTime = start;
        const widthUnit = 100 / totalDays;
        let width = 0;
        for(let day = 0; day < Math.round(totalDays); day++){
            if ((0, (0, parcelRequire("f1uil")).default)((0, (0, parcelRequire("it1wb")).default)(startTime), (0, (0, parcelRequire("it1wb")).default)((0, (0, parcelRequire("pyK8a")).default)(todayDate, (0, (0, parcelRequire("flnZx")).dateDiffFromUTC)())))) {
                staticAxisPosition = {
                    offset: width,
                    widthPercentage: widthUnit
                };
                break;
            }
            startTime += (0, (0, parcelRequire("flnZx")).ONE_DAY);
            width += widthUnit;
        }
        return staticAxisPosition;
    };
    var $eb5855f458d89307$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $jAIJh.getTimelineRange),
        (0, $1CGdp.isExportMode)
    ], (timelineRange, isExportMode)=>({
            isExportMode: isExportMode,
            staticAxisPosition: $eb5855f458d89307$export$195ac24e17449cb1(timelineRange)
        }));
});
parcelRegister("jAIJh", function(module, exports) {
    $parcel$export(module.exports, "getZoomLevel", ()=>$9567ae782bebd1bf$export$deb0f277a5f91a79);
    $parcel$export(module.exports, "getOnlyEnabledIssueId", ()=>$9567ae782bebd1bf$export$b2e09724b4c97912);
    $parcel$export(module.exports, "getTimelineContainerWidth", ()=>$9567ae782bebd1bf$export$b1656acc76a5947a);
    $parcel$export(module.exports, "getTodayDate", ()=>$9567ae782bebd1bf$export$1118e4272ea1e258);
    $parcel$export(module.exports, "get3mthTimeScale", ()=>$9567ae782bebd1bf$export$191c1aeefec6bc61);
    $parcel$export(module.exports, "getTimelineRange", ()=>$9567ae782bebd1bf$export$6ab0dc7299631a53);
    $parcel$export(module.exports, "getScrollableTimelineRange", ()=>$9567ae782bebd1bf$export$8b224e5b226711ba);
    $parcel$export(module.exports, "getQuarterLabel", ()=>$9567ae782bebd1bf$export$5fd62420000921f7);
    $parcel$export(module.exports, "getDayUnits", ()=>$9567ae782bebd1bf$export$bc6ab2cf11089d43);
    $parcel$export(module.exports, "getMonthUnits", ()=>$9567ae782bebd1bf$export$3611c2007b9f6598);
    $parcel$export(module.exports, "getQuarterUnits", ()=>$9567ae782bebd1bf$export$f2b0db57c6dfcb37);
    $parcel$export(module.exports, "getYearUnits", ()=>$9567ae782bebd1bf$export$a3c3cfbcf0c80ed4);
    $parcel$export(module.exports, "getTimelineUnits", ()=>$9567ae782bebd1bf$export$4762a276da75583a);
    var $cRGLB = parcelRequire("cRGLB");
    var $3DR3e;
    var $k7m40;
    var $2753q;
    var $7myQy;
    var $gh61P;
    var $aipk9;
    var $flnZx;
    var $cGv9m;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $kWDpn = parcelRequire("kWDpn");
    var $82Qle = parcelRequire("82Qle");
    const $9567ae782bebd1bf$export$deb0f277a5f91a79 = (state)=>{
        const { mode: mode } = (0, $kWDpn.getTimeScaleViewSettings)(state);
        return (0, (0, parcelRequire("cGv9m")).getZoomLevel)(mode);
    };
    const $9567ae782bebd1bf$export$b2e09724b4c97912 = (state)=>state.ui.Main.Tabs.Roadmap.Timeline.Schedule.onlyEnabledIssueId;
    const $9567ae782bebd1bf$export$b1656acc76a5947a = (state, viewportWidth)=>{
        if (viewportWidth == null) return viewportWidth;
        const { mode: mode } = (0, $kWDpn.getTimeScaleViewSettings)(state);
        switch(mode){
            case (0, $TTKUQ.ZOOM_LEVELS).WEEKS:
            case (0, $TTKUQ.ZOOM_LEVELS).MONTHS:
            case (0, $TTKUQ.ZOOM_LEVELS).QUARTERS:
            case (0, $TTKUQ.ZOOM_LEVELS).YEARS:
                return (0, (0, parcelRequire("cGv9m")).getContainerWidth)(mode);
            default:
                return viewportWidth;
        }
    };
    const $9567ae782bebd1bf$export$1118e4272ea1e258 = ()=>{
        const todayDate = new Date();
        return todayDate;
    };
    const $9567ae782bebd1bf$export$710a62793fa7376f = (date)=>date.toISOString().substr(0, 10);
    const $9567ae782bebd1bf$export$191c1aeefec6bc61 = (today)=>{
        const in3Months = (0, (0, parcelRequire("3DR3e")).default)(today, 3);
        const start = (0, (0, parcelRequire("flnZx")).startOfUtcDay)($9567ae782bebd1bf$export$710a62793fa7376f(today));
        const end = (0, (0, parcelRequire("flnZx")).endOfUtcDay)($9567ae782bebd1bf$export$710a62793fa7376f(in3Months));
        return {
            start: start,
            end: end
        };
    };
    const $9567ae782bebd1bf$var$getCustomFixedDates = ({ fromDate: fromDate, toDate: toDate })=>{
        const getFormattedDate = (date)=>{
            if (!(0, parcelRequire("7myQy")).default(Number, date)) return (0, (0, parcelRequire("k7m40")).default)(typeof date === 'string' ? (0, (0, parcelRequire("2753q")).default)(date, 'yyyy/MM/dd', new Date()) : date, 'yyyy-MM-dd');
            return date;
        };
        return {
            start: (0, (0, parcelRequire("flnZx")).startOfUtcDay)(getFormattedDate(fromDate ?? '')),
            end: (0, (0, parcelRequire("flnZx")).endOfUtcDay)(getFormattedDate(toDate ?? ''))
        };
    };
    const $9567ae782bebd1bf$export$1f976157d092b952 = (timeScale, today)=>{
        const { mode: mode } = timeScale;
        let start;
        let end;
        switch(mode){
            case (0, $TTKUQ.ZOOM_LEVELS).WEEKS:
            case (0, $TTKUQ.ZOOM_LEVELS).MONTHS:
            case (0, $TTKUQ.ZOOM_LEVELS).QUARTERS:
            case (0, $TTKUQ.ZOOM_LEVELS).YEARS:
                start = (0, (0, parcelRequire("flnZx")).startOfUtcDay)($9567ae782bebd1bf$export$710a62793fa7376f(today));
                end = start + (0, (0, parcelRequire("cGv9m")).getContainerDuration)(mode);
                return {
                    start: start,
                    end: end
                };
            case (0, $TTKUQ.TIMELINE_MODES).CUSTOM:
                {
                    const { customDateRange: customDateRange } = timeScale;
                    if (customDateRange) {
                        const { fromDate: fromDate = '', toDate: toDate = '', toNowUnitCount: toNowUnitCount, fromNowUnitCount: fromNowUnitCount, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit, typeOfCustomDateRange: typeOfCustomDateRange = (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).FIXED } = customDateRange;
                        if (typeOfCustomDateRange === (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).FIXED && fromDate !== '' && toDate !== '') {
                            const timescale = $9567ae782bebd1bf$var$getCustomFixedDates(customDateRange);
                            start = timescale.start;
                            end = timescale.end;
                        } else if (typeOfCustomDateRange === (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).RELATIVE && (0, $4nDwW.isDefined)(toNowUnitCount) && (0, $4nDwW.isDefined)(fromNowUnitCount) && toNowUnit && fromNowUnit) {
                            const timescale = (0, (0, parcelRequire("flnZx")).getRelativeDates)(customDateRange, today);
                            start = timescale.start;
                            end = timescale.end;
                        } else {
                            const timescale = $9567ae782bebd1bf$export$191c1aeefec6bc61(today);
                            start = timescale.start;
                            end = timescale.end;
                        }
                    } else {
                        const timescale = $9567ae782bebd1bf$export$191c1aeefec6bc61(today);
                        start = timescale.start;
                        end = timescale.end;
                    }
                    break;
                }
            default:
                start = (0, (0, parcelRequire("flnZx")).startOfUtcDay)($9567ae782bebd1bf$export$710a62793fa7376f(today));
                end = start + (0, (0, parcelRequire("cGv9m")).getContainerDuration)((0, $TTKUQ.ZOOM_LEVELS).MONTHS);
                return {
                    start: start,
                    end: end
                };
        }
        if (!(0, $4nDwW.isDefined)(start) || !(0, $4nDwW.isDefined)(end)) throw new Error('Both start and end must be calculated');
        return {
            start: start,
            end: end
        };
    };
    const $9567ae782bebd1bf$export$6ab0dc7299631a53 = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getTimeScaleViewSettings),
        $9567ae782bebd1bf$export$1118e4272ea1e258
    ], $9567ae782bebd1bf$export$1f976157d092b952);
    const $9567ae782bebd1bf$export$d5e1b6167e68d71a = (zoomLevel, containerTimelineRange)=>{
        if (zoomLevel === undefined) return containerTimelineRange;
        return {
            start: -Infinity,
            end: Infinity
        };
    };
    const $9567ae782bebd1bf$export$8b224e5b226711ba = (0, $3YtPS.createSelector)([
        $9567ae782bebd1bf$export$deb0f277a5f91a79,
        $9567ae782bebd1bf$export$6ab0dc7299631a53
    ], $9567ae782bebd1bf$export$d5e1b6167e68d71a);
    const $9567ae782bebd1bf$export$322ac48b0e5b3019 = (month)=>Math.floor(month / 3);
    const $9567ae782bebd1bf$export$5fd62420000921f7 = (month, fiscalMonth = 1)=>`${(0, $82Qle.calculateQuarter)(month + 1, fiscalMonth)}`;
    const $9567ae782bebd1bf$export$ba186f0a8a0dd8dd = (value)=>{
        const date = new Date(value);
        const day = (0, (0, parcelRequire("aipk9")).getDayLabel)(date.getUTCDay());
        const month = (0, (0, parcelRequire("aipk9")).getMonthLabel)(date.getUTCMonth());
        const dayOfMonth = (0, ($parcel$interopDefault($cRGLB)))(`${date.getUTCDate()}`, 2, '0');
        return `${day} ${dayOfMonth}/${month}`;
    };
    const $9567ae782bebd1bf$export$bc6ab2cf11089d43 = (startTime, totalDays)=>{
        const days = [];
        let start = startTime;
        for(let day = 0; day < Math.round(totalDays); day++){
            days.push({
                startTime: start,
                widthPercentage: 100 / totalDays
            });
            start += (0, (0, parcelRequire("flnZx")).ONE_DAY);
        }
        return days;
    };
    const $9567ae782bebd1bf$export$b5aaf8277821bbfa = (startTime, totalDays)=>{
        const daysInUnits = [];
        const widthPercentage = 100 / totalDays;
        let days = [];
        let date = new Date(startTime);
        let currStartTime = startTime;
        let startMonth = date.getUTCMonth();
        for(let day = 0; day < Math.round(totalDays); day++){
            date = new Date(currStartTime);
            if (date.getUTCMonth() !== startMonth) {
                daysInUnits.push(days);
                days = [];
                startMonth = date.getUTCMonth();
            }
            days.push({
                startTime: currStartTime,
                widthPercentage: widthPercentage
            });
            currStartTime += (0, (0, parcelRequire("flnZx")).ONE_DAY);
        }
        daysInUnits.push(days);
        return daysInUnits;
    };
    const $9567ae782bebd1bf$export$d383a29b14c36a14 = (value)=>{
        const date = new Date(value);
        const month = (0, (0, parcelRequire("aipk9")).getMonthLabel)(date.getUTCMonth());
        const dayOfMonth = (0, ($parcel$interopDefault($cRGLB)))(date.getUTCDate().toString(), 2, '0');
        return `${dayOfMonth}/${month}`;
    };
    const $9567ae782bebd1bf$export$7a054ec37aaa58a2 = (value)=>(0, (0, parcelRequire("aipk9")).getMonthLabel)(new Date(value).getUTCMonth());
    const $9567ae782bebd1bf$export$a15b3dee161ca4e2 = (value)=>{
        const date = new Date(value);
        const month = (0, (0, parcelRequire("aipk9")).getMonthLabel)(date.getUTCMonth());
        const quarter = $9567ae782bebd1bf$export$5fd62420000921f7(date.getUTCMonth());
        const year = date.getUTCFullYear().toString().substr(2);
        return `${month} Q${quarter}/${year}`;
    };
    const $9567ae782bebd1bf$export$e04713337367b621 = (value)=>new Date(value).getUTCFullYear().toString();
    const $9567ae782bebd1bf$export$94a11c5658544737 = (startTime, endTime, startOfUnit, endOfUnit)=>{
        const units = [];
        const timelineLength = endTime - startTime;
        const calcWidthPercentage = (start, end, rangeLength)=>{
            const unitLength = end - start;
            return unitLength / rangeLength * 100;
        };
        let lastTime = startTime;
        let leftOffset = 0;
        while(endTime > lastTime){
            const unitStartDate = startOfUnit(lastTime);
            const unitEndDate = endOfUnit(lastTime);
            const unitStartTime = unitStartDate.getTime();
            const unitEndTime = unitEndDate.getTime();
            let widthPercentage = 0;
            let unitTime;
            if (startTime > unitStartTime) {
                widthPercentage = calcWidthPercentage(startTime, unitEndTime, timelineLength);
                unitTime = startTime;
            } else if (endTime < unitEndTime) {
                widthPercentage = calcWidthPercentage(unitStartTime, endTime, timelineLength);
                unitTime = unitStartTime;
            } else {
                widthPercentage = calcWidthPercentage(unitStartTime, unitEndTime, timelineLength);
                unitTime = unitStartTime;
            }
            units.push({
                startTime: unitTime,
                widthPercentage: widthPercentage,
                leftOffset: leftOffset
            });
            lastTime = unitEndTime + 1;
            leftOffset += widthPercentage;
        }
        return units;
    };
    const $9567ae782bebd1bf$export$167945d407df178d = (startDate, endDate)=>$9567ae782bebd1bf$export$94a11c5658544737(startDate, endDate, (0, (0, parcelRequire("flnZx")).startOfUtcWeek), (0, (0, parcelRequire("flnZx")).endOfUtcWeek));
    const $9567ae782bebd1bf$export$3611c2007b9f6598 = (startDate, endDate)=>$9567ae782bebd1bf$export$94a11c5658544737(startDate, endDate, (0, (0, parcelRequire("flnZx")).startOfUtcMonth), (0, (0, parcelRequire("flnZx")).endOfUtcMonth));
    const $9567ae782bebd1bf$export$f2b0db57c6dfcb37 = (startDate, endDate, fiscalMonth = 1)=>$9567ae782bebd1bf$export$94a11c5658544737(startDate, endDate, (0, (0, parcelRequire("flnZx")).buildStartOfUtcQuarter)(fiscalMonth), (0, (0, parcelRequire("flnZx")).buildEndOfUtcQuarter)(fiscalMonth));
    const $9567ae782bebd1bf$export$a3c3cfbcf0c80ed4 = (startDate, endDate, fiscalMonth = 1)=>$9567ae782bebd1bf$export$94a11c5658544737(startDate, endDate, (0, (0, parcelRequire("flnZx")).buildStartOfUtcYear)(fiscalMonth), (0, (0, parcelRequire("flnZx")).buildEndOfUtcYear)(fiscalMonth));
    const $9567ae782bebd1bf$export$10239d34ccbe7258 = (timelineRange)=>{
        const { start: start, end: end } = timelineRange;
        const daysInRange = (end - start) / (0, (0, parcelRequire("flnZx")).ONE_DAY);
        if (daysInRange <= 14) return $9567ae782bebd1bf$export$bc6ab2cf11089d43(start, daysInRange);
        if (daysInRange <= 93) return $9567ae782bebd1bf$export$167945d407df178d(start, end);
        if (daysInRange <= 364) return $9567ae782bebd1bf$export$3611c2007b9f6598(start, end);
        if (daysInRange <= 1825) return $9567ae782bebd1bf$export$f2b0db57c6dfcb37(start, end);
        return $9567ae782bebd1bf$export$a3c3cfbcf0c80ed4(start, end);
    };
    const $9567ae782bebd1bf$export$4762a276da75583a = (0, $3YtPS.createSelector)([
        $9567ae782bebd1bf$export$6ab0dc7299631a53
    ], $9567ae782bebd1bf$export$10239d34ccbe7258);
});
parcelRegister("cGv9m", function(module, exports) {
    $parcel$export(module.exports, "getContainerWidth", ()=>$676cc111f22372f4$export$4bc9150518443cd1);
    $parcel$export(module.exports, "getContainerDuration", ()=>$676cc111f22372f4$export$fe35704a86ff59e5);
    $parcel$export(module.exports, "getZoomLevel", ()=>$676cc111f22372f4$export$deb0f277a5f91a79);
    var $5lEJp;
    function $676cc111f22372f4$export$4bc9150518443cd1(zoomLevel) {
        switch(zoomLevel){
            case (0, (0, parcelRequire("5lEJp")).ZOOM_LEVELS).WEEKS:
                return (0, (0, parcelRequire("5lEJp")).NUM_OF_SCALABLE_COLUMNS) * (0, (0, parcelRequire("5lEJp")).ESTIMATED_MIN_COLUMN_WIDTH_WEEKS);
            case (0, (0, parcelRequire("5lEJp")).ZOOM_LEVELS).MONTHS:
                return (0, (0, parcelRequire("5lEJp")).NUM_OF_SCALABLE_COLUMNS) * (0, (0, parcelRequire("5lEJp")).ESTIMATED_MIN_COLUMN_WIDTH_MONTHS);
            case (0, (0, parcelRequire("5lEJp")).ZOOM_LEVELS).QUARTERS:
                return (0, (0, parcelRequire("5lEJp")).NUM_OF_SCALABLE_COLUMNS) * (0, (0, parcelRequire("5lEJp")).ESTIMATED_MIN_COLUMN_WIDTH_QUARTERS);
            case (0, (0, parcelRequire("5lEJp")).ZOOM_LEVELS).YEARS:
                return (0, (0, parcelRequire("5lEJp")).NUM_OF_SCALABLE_COLUMNS) * (0, (0, parcelRequire("5lEJp")).ESTIMATED_MIN_COLUMN_WIDTH_YEARS);
            default:
                return (0, (0, parcelRequire("5lEJp")).NUM_OF_SCALABLE_COLUMNS) * (0, (0, parcelRequire("5lEJp")).ESTIMATED_MIN_COLUMN_WIDTH_MONTHS);
        }
    }
    function $676cc111f22372f4$export$fe35704a86ff59e5(zoomLevel) {
        const msPerDay = 86400000;
        const adjustment = -1;
        switch(zoomLevel){
            case 'weeks':
                return (0, (0, parcelRequire("5lEJp")).NUM_OF_SCALABLE_COLUMNS) * 7 * msPerDay + adjustment;
            case 'months':
                return (0, (0, parcelRequire("5lEJp")).NUM_OF_SCALABLE_COLUMNS) * 30 * msPerDay + adjustment;
            case 'quarters':
                return (0, (0, parcelRequire("5lEJp")).NUM_OF_SCALABLE_COLUMNS) * 91 * msPerDay + adjustment;
            case 'years':
                return (0, (0, parcelRequire("5lEJp")).NUM_OF_SCALABLE_COLUMNS) * 365 * msPerDay + adjustment;
            default:
                return zoomLevel;
        }
    }
    function $676cc111f22372f4$export$deb0f277a5f91a79(timeScaleSelection) {
        switch(timeScaleSelection){
            case 'weeks':
            case 'months':
            case 'quarters':
            case 'years':
                return timeScaleSelection;
            default:
                return undefined;
        }
    }
});
parcelRegister("5lEJp", function(module, exports) {
    $parcel$export(module.exports, "NUM_OF_SCALABLE_COLUMNS", ()=>$5cd0c3be8ab141d4$export$4ebc98cbc6faf8fa);
    $parcel$export(module.exports, "ESTIMATED_MAX_COLUMN_WIDTH", ()=>$5cd0c3be8ab141d4$export$d409274947a693d3);
    $parcel$export(module.exports, "KEY_ARROW_LEFT", ()=>$5cd0c3be8ab141d4$export$842fd6cf65a6b80c);
    $parcel$export(module.exports, "KEY_ARROW_RIGHT", ()=>$5cd0c3be8ab141d4$export$695331c89a36efd6);
    $parcel$export(module.exports, "SCROLL_BUTTON_STEP", ()=>$5cd0c3be8ab141d4$export$328d7e29ebafe4ff);
    $parcel$export(module.exports, "ESTIMATED_MIN_COLUMN_WIDTH_WEEKS", ()=>$5cd0c3be8ab141d4$export$c236885cdc8a70c9);
    $parcel$export(module.exports, "ESTIMATED_MIN_COLUMN_WIDTH_MONTHS", ()=>$5cd0c3be8ab141d4$export$812af5a2153a5f6);
    $parcel$export(module.exports, "ESTIMATED_MIN_COLUMN_WIDTH_QUARTERS", ()=>$5cd0c3be8ab141d4$export$e1a0270a2def2eca);
    $parcel$export(module.exports, "ESTIMATED_MIN_COLUMN_WIDTH_YEARS", ()=>$5cd0c3be8ab141d4$export$faa0cb0b47c6fd7a);
    $parcel$export(module.exports, "ZOOM_LEVELS", ()=>$5cd0c3be8ab141d4$export$8b7222fa92892b49);
    $parcel$export(module.exports, "ANALYTICS_SCROLL_TIMELINE", ()=>$5cd0c3be8ab141d4$export$1840ec5bca458d3e);
    $parcel$export(module.exports, "ANALYITICS_TIMELINE_HORIZONTAL_SCROLLED", ()=>$5cd0c3be8ab141d4$export$f99ad8548d6a625e);
    $parcel$export(module.exports, "SPA_APP_NAME", ()=>$5cd0c3be8ab141d4$export$3121747bb6e73d1c);
    const $5cd0c3be8ab141d4$export$4ebc98cbc6faf8fa = 4.5;
    const $5cd0c3be8ab141d4$export$554f7958a7f8ff1c = 120;
    const $5cd0c3be8ab141d4$export$d409274947a693d3 = 250;
    const $5cd0c3be8ab141d4$export$842fd6cf65a6b80c = 37;
    const $5cd0c3be8ab141d4$export$695331c89a36efd6 = 39;
    const $5cd0c3be8ab141d4$export$328d7e29ebafe4ff = 0.25;
    const $5cd0c3be8ab141d4$export$c236885cdc8a70c9 = 252;
    const $5cd0c3be8ab141d4$export$812af5a2153a5f6 = 240;
    const $5cd0c3be8ab141d4$export$e1a0270a2def2eca = 252;
    const $5cd0c3be8ab141d4$export$faa0cb0b47c6fd7a = 252;
    const $5cd0c3be8ab141d4$export$8b7222fa92892b49 = {
        WEEKS: 'weeks',
        MONTHS: 'months',
        QUARTERS: 'quarters',
        YEARS: 'years'
    };
    const $5cd0c3be8ab141d4$export$1840ec5bca458d3e = 'timeline scrolled';
    const $5cd0c3be8ab141d4$export$f99ad8548d6a625e = 'timelineHorizontalScrollPerformance measured';
    const $5cd0c3be8ab141d4$export$3121747bb6e73d1c = 'advanced-roadmaps';
});
parcelRegister("82Qle", function(module, exports) {
    $parcel$export(module.exports, "calculateQuarter", ()=>$e0ca63d1858d1d27$export$a1ca9a6cfffeccdd);
    const $e0ca63d1858d1d27$export$a1ca9a6cfffeccdd = (month, fyStartMonth = 1)=>{
        const sameMonth = month + 12;
        const monthsSinceFYStart = sameMonth - fyStartMonth;
        const monthsInAQuarter = 3;
        const fullQuartersSinceFYStart = Math.floor(monthsSinceFYStart / monthsInAQuarter);
        const quarter = fullQuartersSinceFYStart % 4 + 1;
        return quarter;
    };
});
parcelRegister("61Qs7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a5341c9c7c6d1cc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $co1wz;
    var $flnZx;
    var $hE4fC;
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $h1LGZ = parcelRequire("h1LGZ");
    function $4a5341c9c7c6d1cc$export$2e2bcd8739ae039({ isExportMode: isExportMode = false, noMarker: noMarker = false, showInCustomRangeDialog: showInCustomRangeDialog = false, staticAxisPosition: staticAxisPosition = {}, topOffset: topOffset = 0 }) {
        const [{ getPercentageOffset: getPercentageOffset }] = (0, (0, parcelRequire("hE4fC")).useHorizontalPercentageOffset)();
        const [container] = (0, (0, parcelRequire("hE4fC")).useContainer)();
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        if (isExportMode) return null;
        const withZIndexOverride = (children)=>{
            if (!(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2')) return children(undefined);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
                layer: (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS
            }, (zIndex)=>children(zIndex ?? 'initial'));
        };
        if (zoomLevel) {
            const offsetInMs = (0, (0, parcelRequire("flnZx")).dateDiffFromUTC)() * (0, (0, parcelRequire("flnZx")).ONE_DAY);
            const todayOffset = getPercentageOffset(offsetInMs);
            const width = getPercentageOffset(offsetInMs + (0, (0, parcelRequire("flnZx")).ONE_DAY)) - todayOffset;
            return withZIndexOverride((zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.now",
                    className: `${$h1LGZ.nowLine} ${!noMarker ? $h1LGZ.marker : ''}`,
                    style: {
                        left: `calc(${todayOffset}% + ${container.width * (width / 100) / 2}px)`,
                        top: topOffset,
                        zIndex: zIndex
                    }
                }));
        }
        if (!(0, parcelRequire("3nPAF")).default(staticAxisPosition)) {
            const { offset: offset = 0, widthPercentage: widthPercentage = 0 } = staticAxisPosition;
            return withZIndexOverride((zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.now",
                    className: $h1LGZ.nowLineStaticAxisWrapper,
                    style: {
                        left: `calc(${offset}% + ${"var(--ds-space-025, 2px)"})`,
                        width: `${widthPercentage}%`
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $h1LGZ.nowLineStaticAxisSubWrapper
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: `${$h1LGZ.nowLine} ${!noMarker ? $h1LGZ.marker : ''}`,
                    style: {
                        top: topOffset,
                        zIndex: zIndex
                    }
                }))));
        }
        if (showInCustomRangeDialog) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.now",
            className: `${$h1LGZ.nowLine} ${!noMarker ? $h1LGZ.marker : ''}`,
            style: {
                top: topOffset
            }
        });
        return null;
    }
});
parcelRegister("hE4fC", function(module, exports) {
    $parcel$export(module.exports, "useHorizontalScrolling", ()=>$d2f7cd1a1306118b$export$97744631e5b676f5);
    $parcel$export(module.exports, "createHorizontalScrollingHook", ()=>$d2f7cd1a1306118b$export$c64aea07291af4d8);
    $parcel$export(module.exports, "useZoomLevel", ()=>$d2f7cd1a1306118b$export$83457f1b00e4d97b);
    $parcel$export(module.exports, "useToday", ()=>$d2f7cd1a1306118b$export$6d84255ad587f3b5);
    $parcel$export(module.exports, "useSmooth", ()=>$d2f7cd1a1306118b$export$665d75b0980ae645);
    $parcel$export(module.exports, "useContainer", ()=>$d2f7cd1a1306118b$export$b537cf6ebaf7ff54);
    $parcel$export(module.exports, "useTimelineRuler", ()=>$d2f7cd1a1306118b$export$cb80d2fae0ecdd66);
    $parcel$export(module.exports, "useRenderingWindow", ()=>$d2f7cd1a1306118b$export$2acc4f37cfc616a1);
    $parcel$export(module.exports, "useHorizontalPercentageOffset", ()=>$d2f7cd1a1306118b$export$e1fd0a2978f600ad);
    $parcel$export(module.exports, "subscribeHorizontalScrolling", ()=>$d2f7cd1a1306118b$export$63c91c16e36ba6b9);
    var $flnZx;
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $bKpgX;
    var $5lEJp;
    var $cGv9m;
    const $d2f7cd1a1306118b$var$initialState = {
        zoomLevel: undefined,
        viewport: {
            offset: 0,
            width: 0,
            position: {
                left: 0,
                top: 0
            }
        },
        container: {
            duration: 0,
            width: 0
        },
        smooth: false,
        isScrollingWithScrollBar: false,
        today: (0, (0, parcelRequire("flnZx")).startOfUtcDay)(Date.now()),
        lastScrollTrigger: null,
        scrollEventHandlers: []
    };
    const $d2f7cd1a1306118b$var$actions = {
        nudge: (deltaX)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const state = getState();
                const { viewport: viewport, container: container } = state;
                const deltaT = deltaX * container.duration / container.width;
                const offset = viewport.offset + deltaT;
                setState({
                    ...state,
                    lastScrollTrigger: 'mousewheel',
                    viewport: {
                        ...viewport,
                        offset: offset
                    }
                });
                dispatch($d2f7cd1a1306118b$var$actions.syncToday());
            },
        setViewportOffset: (offset, source)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const state = getState();
                const nextOffset = typeof offset === 'function' ? offset(state.viewport.offset) : offset;
                setState({
                    ...state,
                    lastScrollTrigger: source,
                    viewport: {
                        ...state.viewport,
                        offset: nextOffset
                    }
                });
                dispatch($d2f7cd1a1306118b$var$actions.syncToday());
                dispatch($d2f7cd1a1306118b$var$actions.triggerScrollEventHandlers(nextOffset, state.smooth, source));
            },
        resize: (payload)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const state = getState();
                setState({
                    ...state,
                    viewport: {
                        ...state.viewport,
                        ...payload.viewport
                    },
                    container: payload.container
                });
                dispatch($d2f7cd1a1306118b$var$actions.syncToday());
            },
        changeZoomLevel: (zoomLevel)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const state = getState();
                const newScrollTrigger = 'zoomLevelChange';
                let newState = {
                    ...state,
                    lastScrollTrigger: newScrollTrigger,
                    zoomLevel: zoomLevel
                };
                if (zoomLevel) newState = {
                    ...newState,
                    container: {
                        duration: (0, (0, parcelRequire("cGv9m")).getContainerDuration)(zoomLevel),
                        width: (0, (0, parcelRequire("cGv9m")).getContainerWidth)(zoomLevel)
                    }
                };
                setState(newState);
                dispatch($d2f7cd1a1306118b$var$actions.syncToday());
            },
        scrollTo: (offsetInPx, source)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const state = getState();
                const { viewport: viewport, container: container } = state;
                const offsetT = offsetInPx * container.duration / container.width;
                setState({
                    ...state,
                    lastScrollTrigger: source,
                    viewport: {
                        ...viewport,
                        offset: offsetT
                    }
                });
                dispatch($d2f7cd1a1306118b$var$actions.syncToday());
            },
        shiftTimeline: (direction, source)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const state = getState();
                const { viewport: viewport, container: container } = state;
                const msToPx = (ms)=>ms * container.width / (container.duration || 1);
                const offsetInPx = msToPx(viewport.offset) + viewport.width * (0, (0, parcelRequire("5lEJp")).SCROLL_BUTTON_STEP) * (direction === 'left' ? -1 : 1);
                const offset = offsetInPx * container.duration / container.width;
                setState({
                    ...state,
                    lastScrollTrigger: source,
                    viewport: {
                        ...viewport,
                        offset: offset
                    }
                });
                dispatch($d2f7cd1a1306118b$var$actions.syncToday());
                dispatch($d2f7cd1a1306118b$var$actions.triggerScrollEventHandlers(offset, state.smooth, source));
            },
        scrollToView: ({ timestamp: timestamp }, source)=>({ getState: getState, dispatch: dispatch })=>{
                const { viewport: viewport, container: container, today: today } = getState();
                const msPerPx = container.duration / container.width;
                const viewportDuration = viewport.width * msPerPx;
                const margin = 24;
                const leftEdge = today + viewport.offset;
                const rightEdge = today + viewport.offset + viewportDuration;
                if (timestamp < leftEdge) {
                    const nextViewportOffset = timestamp - today - margin * msPerPx;
                    dispatch($d2f7cd1a1306118b$var$actions.setViewportOffset(nextViewportOffset, source));
                }
                if (timestamp > rightEdge) {
                    const nextViewportOffset = timestamp - today - viewportDuration + margin * msPerPx;
                    dispatch($d2f7cd1a1306118b$var$actions.setViewportOffset(nextViewportOffset, source));
                }
                dispatch($d2f7cd1a1306118b$var$actions.syncToday());
            },
        setSmooth: (newSmoothState)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const state = getState();
                setState({
                    ...state,
                    smooth: newSmoothState
                });
                dispatch($d2f7cd1a1306118b$var$actions.syncToday());
            },
        setScrollingWithScrollBar: (newScrollingState)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const state = getState();
                setState({
                    ...state,
                    isScrollingWithScrollBar: newScrollingState
                });
                dispatch($d2f7cd1a1306118b$var$actions.syncToday());
            },
        backToToday: ()=>({ getState: getState, dispatch: dispatch })=>{
                const { container: container } = getState();
                const msPerPx = container.duration / container.width;
                const margin = (0, (0, parcelRequire("5lEJp")).ESTIMATED_MAX_COLUMN_WIDTH);
                const nextViewportOffset = -margin * msPerPx;
                dispatch($d2f7cd1a1306118b$var$actions.setViewportOffset(nextViewportOffset, 'todayButton'));
                dispatch($d2f7cd1a1306118b$var$actions.syncToday());
            },
        syncToday: ()=>({ getState: getState, setState: setState })=>{
                const state = getState();
                const startOfToday = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(Date.now());
                if (state.today !== startOfToday) setState({
                    ...state,
                    today: startOfToday
                });
            },
        triggerScrollEventHandlers: (offset, smooth, source)=>({ getState: getState })=>{
                const { container: container, scrollEventHandlers: scrollEventHandlers } = getState();
                const offsetInPx = offset * container.width / container.duration;
                scrollEventHandlers.forEach((callback)=>callback({
                        offsetInPx: offsetInPx,
                        smooth: smooth,
                        source: source
                    }));
            },
        addScrollHandler: (callback)=>({ getState: getState, setState: setState })=>{
                setState({
                    scrollEventHandlers: getState().scrollEventHandlers.concat(callback)
                });
            },
        removeScrollHandler: (callback)=>({ getState: getState, setState: setState })=>{
                setState({
                    scrollEventHandlers: getState().scrollEventHandlers.filter((eventHandler)=>eventHandler !== callback)
                });
            }
    };
    const $d2f7cd1a1306118b$export$390f32400eaf98c9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $d2f7cd1a1306118b$var$initialState,
        actions: $d2f7cd1a1306118b$var$actions,
        name: 'portfolio-3/horizontal-scrolling'
    });
    const $d2f7cd1a1306118b$export$97744631e5b676f5 = (0, (0, parcelRequire("3sQ5x")).createHook)($d2f7cd1a1306118b$export$390f32400eaf98c9);
    const $d2f7cd1a1306118b$export$c64aea07291af4d8 = (selector)=>(0, (0, parcelRequire("3sQ5x")).createHook)($d2f7cd1a1306118b$export$390f32400eaf98c9, {
            selector: selector
        });
    const $d2f7cd1a1306118b$export$83457f1b00e4d97b = $d2f7cd1a1306118b$export$c64aea07291af4d8((state)=>state.zoomLevel);
    const $d2f7cd1a1306118b$export$6d84255ad587f3b5 = $d2f7cd1a1306118b$export$c64aea07291af4d8((state)=>state.today);
    const $d2f7cd1a1306118b$export$665d75b0980ae645 = $d2f7cd1a1306118b$export$c64aea07291af4d8((state)=>state.smooth);
    const $d2f7cd1a1306118b$export$b537cf6ebaf7ff54 = $d2f7cd1a1306118b$export$c64aea07291af4d8((0, (0, parcelRequire("6dDSs")).createSelector)(({ container: container })=>container.duration, ({ container: container })=>container.width, (duration, width)=>({
            duration: duration,
            width: width
        })));
    const $d2f7cd1a1306118b$export$cb80d2fae0ecdd66 = $d2f7cd1a1306118b$export$c64aea07291af4d8((0, (0, parcelRequire("6dDSs")).createSelector)(({ container: container })=>container.duration, ({ container: container })=>container.width, (duration, width)=>({
            pxToMs: (px)=>px * duration / (width || 1),
            msToPx: (ms)=>ms * width / (duration || 1)
        })));
    const $d2f7cd1a1306118b$var$DEFAULT_OVERSCAN = 1;
    const $d2f7cd1a1306118b$var$getViewportDuration = ({ container: container, viewport: viewport })=>container.duration / container.width * viewport.width;
    const $d2f7cd1a1306118b$var$getRenderingOverscan = (0, (0, parcelRequire("6dDSs")).createSelector)($d2f7cd1a1306118b$var$getViewportDuration, (viewportDuration)=>$d2f7cd1a1306118b$var$DEFAULT_OVERSCAN * viewportDuration);
    const $d2f7cd1a1306118b$var$getRenderingFrom = (0, (0, parcelRequire("6dDSs")).createSelector)($d2f7cd1a1306118b$var$getRenderingOverscan, ({ viewport: viewport })=>viewport.offset, (overscan, viewportOffset)=>{
        const step = overscan / 2;
        return Math.floor(viewportOffset / step) * step - step;
    });
    const $d2f7cd1a1306118b$var$getRenderingTo = (0, (0, parcelRequire("6dDSs")).createSelector)($d2f7cd1a1306118b$var$getRenderingOverscan, $d2f7cd1a1306118b$var$getViewportDuration, $d2f7cd1a1306118b$var$getRenderingFrom, (overscan, viewportDuration, renderingFrom)=>renderingFrom + overscan + viewportDuration + overscan);
    const $d2f7cd1a1306118b$export$2acc4f37cfc616a1 = $d2f7cd1a1306118b$export$c64aea07291af4d8((0, (0, parcelRequire("6dDSs")).createSelector)($d2f7cd1a1306118b$var$getRenderingFrom, $d2f7cd1a1306118b$var$getRenderingTo, ({ today: today })=>today, (from, to, today)=>{
        const start = today + from;
        const end = today + to;
        return {
            today: today,
            from: from,
            timelineRange: {
                start: start,
                end: end
            },
            to: to
        };
    }));
    const $d2f7cd1a1306118b$export$e1fd0a2978f600ad = (0, (0, parcelRequire("3sQ5x")).createHook)($d2f7cd1a1306118b$export$390f32400eaf98c9, {
        selector: (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.container.duration, (state)=>state.today, (duration, today)=>({
                getPercentageOffset: (offset)=>100 * offset / duration,
                getPercentageOffsetFromToday: (offset)=>100 * (offset - today) / duration
            }))
    });
    const $d2f7cd1a1306118b$export$63c91c16e36ba6b9 = (callback)=>{
        const { storeState: storeState } = (0, (0, parcelRequire("bKpgX")).defaultRegistry).getStore($d2f7cd1a1306118b$export$390f32400eaf98c9);
        return storeState.subscribe(()=>{
            callback(storeState.getState());
        });
    };
});
parcelRegister("6hYE8", function(module, exports) {
    $parcel$export(module.exports, "Z_INDEX_LEVEL", ()=>$89480becec246d97$export$7a4b3b772ed42462);
    $parcel$export(module.exports, "Z_INDEX_LEVEL_OLD", ()=>$89480becec246d97$export$81258ea2b6960638);
    $parcel$export(module.exports, "Z_INDEX_LAYER", ()=>$89480becec246d97$export$e01d1c0ad4a0aead);
    const $89480becec246d97$export$7a4b3b772ed42462 = {
        TOP: 9,
        SCOPE_HEADER: 8,
        SCOPE_SUBHEADER: 7,
        SCOPE_STICKY: 6,
        SCOPE: 5,
        SUBHEADER: 4,
        HEADER: 3,
        STICKY: 2,
        FOCUSED: 1,
        DEFAULT: 0
    };
    const $89480becec246d97$export$81258ea2b6960638 = {
        TOP: 5,
        HEADER: 4,
        SUBHEADER: 3,
        STICKY: 2,
        FOCUSED: 1,
        DEFAULT: 0
    };
    const $89480becec246d97$export$e01d1c0ad4a0aead = {
        AXIS_STICKY_TIME_UNIT: 'AXIS_STICKY_TIME_UNIT',
        DEPENDENCY_LINES: 'DEPENDENCY_LINES',
        ISSUE_BARS: 'ISSUE_BARS',
        ISSUE_BARS_ARROWS: 'ISSUE_BARS_ARROWS',
        DEPENDENCY_LINE_DRAG_PREVIEW: 'DEPENDENCY_LINE_DRAG_PREVIEW',
        STICKY_HEADER_SCROLL_SHADOW: 'STICKY_HEADER_SCROLL_SHADOW',
        EMPTY_LIST_OVERLAY: 'EMPTY_LIST_OVERLAY',
        STICKY_GROUP_SCROLL_SHADOW: 'STICKY_GROUP_SCROLL_SHADOW',
        HORIZONTAL_SCROLL_BAR: 'HORIZONTAL_SCROLL_BAR'
    };
});
parcelRegister("eHJCm", function(module, exports) {
    $parcel$export(module.exports, "ZIndexProvider", ()=>$5a024cc905e4997e$export$b2c68a9be9405621);
    $parcel$export(module.exports, "useZIndex", ()=>$5a024cc905e4997e$export$3e7906d4075187a4);
    $parcel$export(module.exports, "ZIndex", ()=>$5a024cc905e4997e$export$ccb31788083e2069);
    var $5uXOq = parcelRequire("5uXOq");
    const $5a024cc905e4997e$var$context = (0, $5uXOq.createContext)(()=>0);
    const $5a024cc905e4997e$export$b2c68a9be9405621 = ({ children: children, zIndex: zIndex })=>(0, ($parcel$interopDefault($5uXOq))).createElement($5a024cc905e4997e$var$context.Provider, {
            value: zIndex
        }, children);
    const $5a024cc905e4997e$export$3e7906d4075187a4 = (params)=>(0, $5uXOq.useContext)($5a024cc905e4997e$var$context)(params);
    const $5a024cc905e4997e$export$ccb31788083e2069 = (props)=>{
        const zIndex = $5a024cc905e4997e$export$3e7906d4075187a4(props);
        return props.children(zIndex);
    };
});
parcelRegister("h1LGZ", function(module, exports) {
    $parcel$export(module.exports, "marker", ()=>$c657865ef8d54679$export$ffc4d0086f1a4c9, (v)=>$c657865ef8d54679$export$ffc4d0086f1a4c9 = v);
    $parcel$export(module.exports, "nowLine", ()=>$c657865ef8d54679$export$f96e531e4f621bc9, (v)=>$c657865ef8d54679$export$f96e531e4f621bc9 = v);
    $parcel$export(module.exports, "nowLineStaticAxisSubWrapper", ()=>$c657865ef8d54679$export$78ae15454ce25516, (v)=>$c657865ef8d54679$export$78ae15454ce25516 = v);
    $parcel$export(module.exports, "nowLineStaticAxisWrapper", ()=>$c657865ef8d54679$export$a799fcb3eca512fe, (v)=>$c657865ef8d54679$export$a799fcb3eca512fe = v);
    var $c657865ef8d54679$export$ffc4d0086f1a4c9;
    var $c657865ef8d54679$export$f96e531e4f621bc9;
    var $c657865ef8d54679$export$78ae15454ce25516;
    var $c657865ef8d54679$export$a799fcb3eca512fe;
    $c657865ef8d54679$export$ffc4d0086f1a4c9 = `Rrwtxa_marker`;
    $c657865ef8d54679$export$f96e531e4f621bc9 = `Rrwtxa_nowLine`;
    $c657865ef8d54679$export$78ae15454ce25516 = `Rrwtxa_nowLineStaticAxisSubWrapper`;
    $c657865ef8d54679$export$a799fcb3eca512fe = `Rrwtxa_nowLineStaticAxisWrapper`;
});
parcelRegister("koBOk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6cddfb04a5bad47$export$2e2bcd8739ae039);
    var $bC2fB;
    var $8i4Qp = parcelRequire("8i4Qp");
    var $k1ipo = parcelRequire("k1ipo");
    var $d6cddfb04a5bad47$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $8i4Qp.default))((0, $k1ipo.default));
});
parcelRegister("8i4Qp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46b3e5f0375e137c$export$2e2bcd8739ae039);
    var $iLfHk = parcelRequire("iLfHk");
    const $46b3e5f0375e137c$var$mapDispatchToProps = (dispatch)=>({
            filterDependencyGraphByIssue: (issueId)=>dispatch((0, $iLfHk.setIssueFilter)(issueId))
        });
    var $46b3e5f0375e137c$export$2e2bcd8739ae039 = $46b3e5f0375e137c$var$mapDispatchToProps;
});
parcelRegister("iLfHk", function(module, exports) {
    $parcel$export(module.exports, "SET_ROLLUP_FILTER", ()=>$7415083453733b01$export$a6c2d7a80cfb3455);
    $parcel$export(module.exports, "SET_ISSUE_IN_FOCUS", ()=>$7415083453733b01$export$b87ffec8d0dafc38);
    $parcel$export(module.exports, "SET_GROUP_BY", ()=>$7415083453733b01$export$8f090af48253b08d);
    $parcel$export(module.exports, "SET_ISSUE_FILTER", ()=>$7415083453733b01$export$713aca294e2edbeb);
    $parcel$export(module.exports, "SET_PROJECT_FILTER", ()=>$7415083453733b01$export$a1c04670e5db534f);
    $parcel$export(module.exports, "SET_ISSUE_LINK_TYPE_FILTER", ()=>$7415083453733b01$export$ad9d21923e98779d);
    $parcel$export(module.exports, "SET_SPRINT_FILTER", ()=>$7415083453733b01$export$f721bf1c7400b42f);
    $parcel$export(module.exports, "RESET_FILTERS", ()=>$7415083453733b01$export$ff065b13677c68b8);
    $parcel$export(module.exports, "INITIATE_FILTERS", ()=>$7415083453733b01$export$ba398c435aa70db);
    $parcel$export(module.exports, "setRollUp", ()=>$7415083453733b01$export$455c2e9a45ca6d44);
    $parcel$export(module.exports, "setIssueInFocus", ()=>$7415083453733b01$export$a04195565eafede1);
    $parcel$export(module.exports, "setGroupBy", ()=>$7415083453733b01$export$3b589469d04138c6);
    $parcel$export(module.exports, "setIssueFilter", ()=>$7415083453733b01$export$2031bedc653a753d);
    $parcel$export(module.exports, "setProjectFilter", ()=>$7415083453733b01$export$f059b4545b91cdfa);
    $parcel$export(module.exports, "setIssueLinkTypeFilter", ()=>$7415083453733b01$export$b46d89818ecd6846);
    $parcel$export(module.exports, "setSprintFilter", ()=>$7415083453733b01$export$e1616f34263e93a4);
    $parcel$export(module.exports, "resetFilters", ()=>$7415083453733b01$export$8da0d8f55c4b51d0);
    $parcel$export(module.exports, "initiateFilters", ()=>$7415083453733b01$export$e9cb6e729c902aaa);
    const $7415083453733b01$export$a6c2d7a80cfb3455 = 'state.ui.main.tabs.dependencies.filters.SET_ROLLUP_FILTER';
    const $7415083453733b01$export$b87ffec8d0dafc38 = 'state.ui.main.tabs.dependencies.filters.SET_ISSUE_IN_FOCUS';
    const $7415083453733b01$export$8f090af48253b08d = 'state.ui.main.tabs.dependencies.filters.SET_GROUP_BY';
    const $7415083453733b01$export$713aca294e2edbeb = 'state.ui.main.tabs.dependencies.filters.SET_ISSUE_FILTER';
    const $7415083453733b01$export$a1c04670e5db534f = 'state.ui.main.tabs.dependencies.filters.SET_PROJECT_FILTER';
    const $7415083453733b01$export$ad9d21923e98779d = 'state.ui.main.tabs.dependencies.filters.SET_ISSUE_LINK_TYPE_FILTER';
    const $7415083453733b01$export$f721bf1c7400b42f = 'state.ui.main.tabs.dependencies.filters.SET_SPRINT_FILTER';
    const $7415083453733b01$export$ff065b13677c68b8 = 'state.ui.main.tabs.dependencies.filters.RESET_FILTERS';
    const $7415083453733b01$export$ba398c435aa70db = 'state.ui.main.tabs.dependencies.filters.INITIATE_FILTERS';
    const $7415083453733b01$export$455c2e9a45ca6d44 = (rollupBy, rollupHierarchyLevel)=>({
            type: $7415083453733b01$export$a6c2d7a80cfb3455,
            payload: {
                rollupBy: rollupBy,
                rollupHierarchyLevel: rollupHierarchyLevel
            }
        });
    const $7415083453733b01$export$a04195565eafede1 = (issueId)=>({
            type: $7415083453733b01$export$b87ffec8d0dafc38,
            payload: issueId
        });
    const $7415083453733b01$export$3b589469d04138c6 = (groupBy)=>({
            type: $7415083453733b01$export$8f090af48253b08d,
            payload: groupBy
        });
    const $7415083453733b01$export$2031bedc653a753d = (issueFilter)=>({
            type: $7415083453733b01$export$713aca294e2edbeb,
            payload: issueFilter
        });
    const $7415083453733b01$export$f059b4545b91cdfa = (projectFilter)=>({
            type: $7415083453733b01$export$a1c04670e5db534f,
            payload: projectFilter
        });
    const $7415083453733b01$export$b46d89818ecd6846 = (issueLinkTypeFilter)=>({
            type: $7415083453733b01$export$ad9d21923e98779d,
            payload: issueLinkTypeFilter
        });
    const $7415083453733b01$export$e1616f34263e93a4 = (sprintFilter)=>({
            type: $7415083453733b01$export$f721bf1c7400b42f,
            payload: sprintFilter
        });
    const $7415083453733b01$export$8da0d8f55c4b51d0 = ()=>({
            type: $7415083453733b01$export$ff065b13677c68b8
        });
    const $7415083453733b01$export$e9cb6e729c902aaa = (payload)=>({
            type: $7415083453733b01$export$ba398c435aa70db,
            payload: payload
        });
});
parcelRegister("k1ipo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed6c734d85832886$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $aCpcO;
    var $g7G9N = parcelRequire("g7G9N");
    var $lVJAU;
    var $4nDwW = parcelRequire("4nDwW");
    var $1yT0t = parcelRequire("1yT0t");
    function $ed6c734d85832886$export$2e2bcd8739ae039({ children: children, ariaLabel: ariaLabel, issueId: issueId, filterDependencyGraphByIssue: filterDependencyGraphByIssue }) {
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const planId = (0, $g7G9N.getPlanId)();
        const scenarioId = (0, $g7G9N.getScenarioId)();
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) {
                if ((0, $4nDwW.isDefined)(issueId) && planId && scenarioId) push(`/jira/plans/${planId}/scenarios/${scenarioId}/dependencies?issueFilter=${issueId}`);
                return;
            }
            if ((0, $4nDwW.isDefined)(issueId)) {
                if (planId && scenarioId) push(`/jira/plans/${planId}/scenarios/${scenarioId}/dependencies`);
                filterDependencyGraphByIssue(issueId);
            }
        }, [
            push,
            planId,
            scenarioId,
            filterDependencyGraphByIssue,
            issueId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1yT0t.footerActionsSeparator
        }, "\xb7"), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "link",
            spacing: "none",
            onClick: handleClick,
            ariaLabel: ariaLabel,
            testId: `portfolio-3-portfolio.common.filter-dependency-graph-from-roadmap.issue-${issueId}`
        }, children));
    }
});
parcelRegister("1yT0t", function(module, exports) {
    $parcel$export(module.exports, "footerActionsSeparator", ()=>$1233a294551f4203$export$7a30fd13ff41b95b, (v)=>$1233a294551f4203$export$7a30fd13ff41b95b = v);
    var $1233a294551f4203$export$7a30fd13ff41b95b;
    $1233a294551f4203$export$7a30fd13ff41b95b = `icFyjG_footerActionsSeparator`;
});
parcelRegister("aP4KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07258c1d146143e0$export$2e2bcd8739ae039);
    var $bC2fB;
    var $jb4Oc = parcelRequire("jb4Oc");
    var $gR2ry = parcelRequire("gR2ry");
    var $gmhgt = parcelRequire("gmhgt");
    var $07258c1d146143e0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $gR2ry.default), (0, $jb4Oc.default))((0, $gmhgt.default));
});
parcelRegister("jb4Oc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$990b4e340b98a564$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    const $990b4e340b98a564$var$mapDispatchToProps = (dispatch)=>({
            quickFilter: (id, value)=>{
                dispatch((0, $834it.clearAll)());
                dispatch((0, $834it.change)({
                    id: id,
                    value: value
                }));
            },
            clearFilter: ()=>dispatch((0, $834it.clearAll)())
        });
    var $990b4e340b98a564$export$2e2bcd8739ae039 = $990b4e340b98a564$var$mapDispatchToProps;
});
parcelRegister("834it", function(module, exports) {
    $parcel$export(module.exports, "change", ()=>$a26fb2d5b966a73c$export$d8a7b8f475ec0161);
    $parcel$export(module.exports, "clear", ()=>$a26fb2d5b966a73c$export$42ffd38884aecdac);
    $parcel$export(module.exports, "clearAll", ()=>$a26fb2d5b966a73c$export$1042faa6df30c26);
    $parcel$export(module.exports, "setInitialFilterValues", ()=>$a26fb2d5b966a73c$export$f464458558a6e458);
    $parcel$export(module.exports, "default", ()=>$a26fb2d5b966a73c$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $eTXmK;
    var $4nDwW = parcelRequire("4nDwW");
    var $1Cyfv = parcelRequire("1Cyfv");
    var $19iju = parcelRequire("19iju");
    var $1cIjo = parcelRequire("1cIjo");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $fP57B = parcelRequire("fP57B");
    var $lIIFg = parcelRequire("lIIFg");
    var $eiyR0 = parcelRequire("eiyR0");
    var $cGbfF = parcelRequire("cGbfF");
    var $3ODbh = parcelRequire("3ODbh");
    const $a26fb2d5b966a73c$export$80504656bcc6d2d9 = 'command.filters.SET_INITIAL_FILTER_VALUES';
    const $a26fb2d5b966a73c$export$3b0c369061fa00ff = 'command.filters.CHANGE_FILTER_VALUE';
    const $a26fb2d5b966a73c$export$80f6e3f69ac5bef4 = 'command.filters.CLEAR_FILTER';
    const $a26fb2d5b966a73c$export$12b8b0c2680dfdd3 = 'command.filters.CLEAR_ALL_FILTERS';
    const $a26fb2d5b966a73c$export$d8a7b8f475ec0161 = (payload)=>({
            type: $a26fb2d5b966a73c$export$3b0c369061fa00ff,
            payload: payload
        });
    const $a26fb2d5b966a73c$export$42ffd38884aecdac = (payload)=>({
            type: $a26fb2d5b966a73c$export$80f6e3f69ac5bef4,
            payload: payload
        });
    const $a26fb2d5b966a73c$export$1042faa6df30c26 = ()=>({
            type: $a26fb2d5b966a73c$export$12b8b0c2680dfdd3
        });
    const $a26fb2d5b966a73c$export$f464458558a6e458 = ()=>({
            type: $a26fb2d5b966a73c$export$80504656bcc6d2d9
        });
    function* $a26fb2d5b966a73c$export$14836535de8c6504() {
        yield (0, $aNOuE.put)((0, $3ODbh.toggleSelectedIssues)({
            ids: [],
            isSelected: false,
            toggleAll: true
        }));
        const hierarchyFilter = yield (0, $aNOuE.select)((0, $1cIjo.getHierarchyRangeFilterState));
        if (!(0, $4nDwW.isDefined)(hierarchyFilter) || !(0, $4nDwW.isDefined)(hierarchyFilter.value)) {
            const value = yield (0, $aNOuE.select)((0, $bI9dZ.getInitialFilterValues));
            yield (0, $aNOuE.put)((0, $lIIFg.change)({
                id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                value: {
                    start: value.start + 1,
                    end: value.end + 1
                }
            }, true));
            yield (0, $aNOuE.put)((0, $lIIFg.change)({
                id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                value: value
            }, true));
        }
    }
    function* $a26fb2d5b966a73c$export$b2959731240e2fac({ payload: payload }) {
        (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).CHANGE_FILTER_VALUE);
        yield (0, $aNOuE.put)((0, $lIIFg.change)(payload));
        yield (0, $aNOuE.put)((0, $3ODbh.toggleSelectedIssues)({
            ids: [],
            isSelected: false,
            toggleAll: true
        }));
    }
    function* $a26fb2d5b966a73c$export$e2c2d6ba49cf760f({ payload: payload }) {
        (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).CHANGE_FILTER_VALUE);
        yield (0, $aNOuE.put)((0, $lIIFg.clear)(payload));
        yield (0, $aNOuE.put)((0, $3ODbh.toggleSelectedIssues)({
            ids: [],
            isSelected: false,
            toggleAll: true
        }));
    }
    function* $a26fb2d5b966a73c$export$576439df9878db3a() {
        yield (0, $aNOuE.put)((0, $lIIFg.clearAll)());
        yield (0, $aNOuE.put)((0, $eiyR0.clearAll)({
            customFields: yield (0, $aNOuE.select)((0, $19iju.getCustomFields))
        }));
        yield (0, $aNOuE.put)((0, $3ODbh.toggleSelectedIssues)({
            ids: [],
            isSelected: false,
            toggleAll: true
        }));
    }
    function* $a26fb2d5b966a73c$export$abdcbce35d8f856d() {
        yield (0, $aNOuE.all)([
            (0, $aNOuE.take)($a26fb2d5b966a73c$export$80504656bcc6d2d9),
            (0, $aNOuE.take)((0, $fP57B.RESET_BACKLOG))
        ]);
        yield* $a26fb2d5b966a73c$export$14836535de8c6504();
    }
    function* $a26fb2d5b966a73c$export$2dcb0e711f5da649() {
        yield (0, $6u3NN.takeEvery)($a26fb2d5b966a73c$export$3b0c369061fa00ff, $a26fb2d5b966a73c$export$b2959731240e2fac);
    }
    function* $a26fb2d5b966a73c$export$8095d7c9e65e4027() {
        yield (0, $6u3NN.takeEvery)($a26fb2d5b966a73c$export$80f6e3f69ac5bef4, $a26fb2d5b966a73c$export$e2c2d6ba49cf760f);
    }
    function* $a26fb2d5b966a73c$export$9859c65de122217b() {
        yield (0, $6u3NN.takeEvery)($a26fb2d5b966a73c$export$12b8b0c2680dfdd3, $a26fb2d5b966a73c$export$576439df9878db3a);
    }
    function* $a26fb2d5b966a73c$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($a26fb2d5b966a73c$export$abdcbce35d8f856d);
        yield (0, $aNOuE.fork)($a26fb2d5b966a73c$export$2dcb0e711f5da649);
        yield (0, $aNOuE.fork)($a26fb2d5b966a73c$export$8095d7c9e65e4027);
        yield (0, $aNOuE.fork)($a26fb2d5b966a73c$export$9859c65de122217b);
    }
});
parcelRegister("kUiRw", function(module, exports) {
    $parcel$export(module.exports, "take", ()=>(parcelRequire("aNOuE")).take);
    $parcel$export(module.exports, "put", ()=>(parcelRequire("aNOuE")).put);
    $parcel$export(module.exports, "all", ()=>(parcelRequire("aNOuE")).all);
    $parcel$export(module.exports, "call", ()=>(parcelRequire("aNOuE")).call);
    $parcel$export(module.exports, "fork", ()=>(parcelRequire("aNOuE")).fork);
    $parcel$export(module.exports, "join", ()=>(parcelRequire("aNOuE")).join);
    $parcel$export(module.exports, "cancel", ()=>(parcelRequire("aNOuE")).cancel);
    $parcel$export(module.exports, "select", ()=>(parcelRequire("aNOuE")).select);
    $parcel$export(module.exports, "takeEvery", ()=>(parcelRequire("6u3NN")).takeEvery);
    $parcel$export(module.exports, "takeLatest", ()=>(parcelRequire("6u3NN")).takeLatest);
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
});
parcelRegister("aNOuE", function(module, exports) {
    $parcel$export(module.exports, "asEffect", ()=>$020793314dc5bef0$export$6338d86c17f4b021);
    $parcel$export(module.exports, "take", ()=>$020793314dc5bef0$export$b7df5d561049483a);
    $parcel$export(module.exports, "put", ()=>$020793314dc5bef0$export$327f7b26ebf455db);
    $parcel$export(module.exports, "all", ()=>$020793314dc5bef0$export$84bf76cd7afc7469);
    $parcel$export(module.exports, "call", ()=>$020793314dc5bef0$export$848feb93d8f32b9b);
    $parcel$export(module.exports, "fork", ()=>$020793314dc5bef0$export$7a5058c6b79333e0);
    $parcel$export(module.exports, "join", ()=>$020793314dc5bef0$export$f7e2c8231c57a8bd);
    $parcel$export(module.exports, "cancel", ()=>$020793314dc5bef0$export$70b61ad426ddbe54);
    $parcel$export(module.exports, "select", ()=>$020793314dc5bef0$export$2e6c959c16ff56b8);
    $parcel$export(module.exports, "actionChannel", ()=>$020793314dc5bef0$export$64c6ba3aace17f8f);
    var $hIYGf = parcelRequire("hIYGf");
    var $020793314dc5bef0$var$IO = (0, $hIYGf.sym)('IO');
    var $020793314dc5bef0$var$TAKE = 'TAKE';
    var $020793314dc5bef0$var$PUT = 'PUT';
    var $020793314dc5bef0$var$ALL = 'ALL';
    var $020793314dc5bef0$var$RACE = 'RACE';
    var $020793314dc5bef0$var$CALL = 'CALL';
    var $020793314dc5bef0$var$CPS = 'CPS';
    var $020793314dc5bef0$var$FORK = 'FORK';
    var $020793314dc5bef0$var$JOIN = 'JOIN';
    var $020793314dc5bef0$var$CANCEL = 'CANCEL';
    var $020793314dc5bef0$var$SELECT = 'SELECT';
    var $020793314dc5bef0$var$ACTION_CHANNEL = 'ACTION_CHANNEL';
    var $020793314dc5bef0$var$CANCELLED = 'CANCELLED';
    var $020793314dc5bef0$var$FLUSH = 'FLUSH';
    var $020793314dc5bef0$var$GET_CONTEXT = 'GET_CONTEXT';
    var $020793314dc5bef0$var$SET_CONTEXT = 'SET_CONTEXT';
    var $020793314dc5bef0$var$TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';
    var $020793314dc5bef0$var$effect = function effect(type, payload) {
        var _ref;
        return _ref = {}, _ref[$020793314dc5bef0$var$IO] = true, _ref[type] = payload, _ref;
    };
    var $020793314dc5bef0$export$3f780019ff766da6 = function detach(eff) {
        (0, $hIYGf.check)($020793314dc5bef0$export$6338d86c17f4b021.fork(eff), (0, $hIYGf.is).object, 'detach(eff): argument must be a fork effect');
        eff[$020793314dc5bef0$var$FORK].detached = true;
        return eff;
    };
    function $020793314dc5bef0$export$b7df5d561049483a() {
        var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
        if (arguments.length) (0, $hIYGf.check)(arguments[0], (0, $hIYGf.is).notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
        if ((0, $hIYGf.is).pattern(patternOrChannel)) return $020793314dc5bef0$var$effect($020793314dc5bef0$var$TAKE, {
            pattern: patternOrChannel
        });
        if ((0, $hIYGf.is).channel(patternOrChannel)) return $020793314dc5bef0$var$effect($020793314dc5bef0$var$TAKE, {
            channel: patternOrChannel
        });
        throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
    }
    $020793314dc5bef0$export$b7df5d561049483a.maybe = function() {
        var eff = $020793314dc5bef0$export$b7df5d561049483a.apply(undefined, arguments);
        eff[$020793314dc5bef0$var$TAKE].maybe = true;
        return eff;
    };
    var $020793314dc5bef0$export$a83b02dcc7b6ebeb = (0, $hIYGf.deprecate)($020793314dc5bef0$export$b7df5d561049483a.maybe, (0, $hIYGf.updateIncentive)('takem', 'take.maybe'));
    function $020793314dc5bef0$export$327f7b26ebf455db(channel, action) {
        if (arguments.length > 1) {
            (0, $hIYGf.check)(channel, (0, $hIYGf.is).notUndef, 'put(channel, action): argument channel is undefined');
            (0, $hIYGf.check)(channel, (0, $hIYGf.is).channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
            (0, $hIYGf.check)(action, (0, $hIYGf.is).notUndef, 'put(channel, action): argument action is undefined');
        } else {
            (0, $hIYGf.check)(channel, (0, $hIYGf.is).notUndef, 'put(action): argument action is undefined');
            action = channel;
            channel = null;
        }
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$PUT, {
            channel: channel,
            action: action
        });
    }
    $020793314dc5bef0$export$327f7b26ebf455db.resolve = function() {
        var eff = $020793314dc5bef0$export$327f7b26ebf455db.apply(undefined, arguments);
        eff[$020793314dc5bef0$var$PUT].resolve = true;
        return eff;
    };
    $020793314dc5bef0$export$327f7b26ebf455db.sync = (0, $hIYGf.deprecate)($020793314dc5bef0$export$327f7b26ebf455db.resolve, (0, $hIYGf.updateIncentive)('put.sync', 'put.resolve'));
    function $020793314dc5bef0$export$84bf76cd7afc7469(effects) {
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$ALL, effects);
    }
    function $020793314dc5bef0$export$236c05de452bec2(effects) {
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$RACE, effects);
    }
    function $020793314dc5bef0$var$getFnCallDesc(meth, fn, args) {
        (0, $hIYGf.check)(fn, (0, $hIYGf.is).notUndef, meth + ': argument fn is undefined');
        var context = null;
        if ((0, $hIYGf.is).array(fn)) {
            var _fn = fn;
            context = _fn[0];
            fn = _fn[1];
        } else if (fn.fn) {
            var _fn2 = fn;
            context = _fn2.context;
            fn = _fn2.fn;
        }
        if (context && (0, $hIYGf.is).string(fn) && (0, $hIYGf.is).func(context[fn])) fn = context[fn];
        (0, $hIYGf.check)(fn, (0, $hIYGf.is).func, meth + ': argument ' + fn + ' is not a function');
        return {
            context: context,
            fn: fn,
            args: args
        };
    }
    function $020793314dc5bef0$export$848feb93d8f32b9b(fn) {
        for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$CALL, $020793314dc5bef0$var$getFnCallDesc('call', fn, args));
    }
    function $020793314dc5bef0$export$5635d7ef4b8fee1c(context, fn) {
        var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$CALL, $020793314dc5bef0$var$getFnCallDesc('apply', {
            context: context,
            fn: fn
        }, args));
    }
    function $020793314dc5bef0$export$488893254e5e098(fn) {
        for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$CPS, $020793314dc5bef0$var$getFnCallDesc('cps', fn, args));
    }
    function $020793314dc5bef0$export$7a5058c6b79333e0(fn) {
        for(var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$FORK, $020793314dc5bef0$var$getFnCallDesc('fork', fn, args));
    }
    function $020793314dc5bef0$export$1713f5ac2bf0caf5(fn) {
        for(var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        return $020793314dc5bef0$export$3f780019ff766da6($020793314dc5bef0$export$7a5058c6b79333e0.apply(undefined, [
            fn
        ].concat(args)));
    }
    function $020793314dc5bef0$export$f7e2c8231c57a8bd() {
        for(var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++)tasks[_key5] = arguments[_key5];
        if (tasks.length > 1) return $020793314dc5bef0$export$84bf76cd7afc7469(tasks.map(function(t) {
            return $020793314dc5bef0$export$f7e2c8231c57a8bd(t);
        }));
        var task = tasks[0];
        (0, $hIYGf.check)(task, (0, $hIYGf.is).notUndef, 'join(task): argument task is undefined');
        (0, $hIYGf.check)(task, (0, $hIYGf.is).task, 'join(task): argument ' + task + ' is not a valid Task object ' + $020793314dc5bef0$var$TEST_HINT);
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$JOIN, task);
    }
    function $020793314dc5bef0$export$70b61ad426ddbe54() {
        for(var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++)tasks[_key6] = arguments[_key6];
        if (tasks.length > 1) return $020793314dc5bef0$export$84bf76cd7afc7469(tasks.map(function(t) {
            return $020793314dc5bef0$export$70b61ad426ddbe54(t);
        }));
        var task = tasks[0];
        if (tasks.length === 1) {
            (0, $hIYGf.check)(task, (0, $hIYGf.is).notUndef, 'cancel(task): argument task is undefined');
            (0, $hIYGf.check)(task, (0, $hIYGf.is).task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + $020793314dc5bef0$var$TEST_HINT);
        }
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$CANCEL, task || (0, $hIYGf.SELF_CANCELLATION));
    }
    function $020793314dc5bef0$export$2e6c959c16ff56b8(selector) {
        for(var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++)args[_key7 - 1] = arguments[_key7];
        if (arguments.length === 0) selector = (0, $hIYGf.ident);
        else {
            (0, $hIYGf.check)(selector, (0, $hIYGf.is).notUndef, 'select(selector,[...]): argument selector is undefined');
            (0, $hIYGf.check)(selector, (0, $hIYGf.is).func, 'select(selector,[...]): argument ' + selector + ' is not a function');
        }
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$SELECT, {
            selector: selector,
            args: args
        });
    }
    function $020793314dc5bef0$export$64c6ba3aace17f8f(pattern, buffer) {
        (0, $hIYGf.check)(pattern, (0, $hIYGf.is).notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
        if (arguments.length > 1) {
            (0, $hIYGf.check)(buffer, (0, $hIYGf.is).notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
            (0, $hIYGf.check)(buffer, (0, $hIYGf.is).buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
        }
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$ACTION_CHANNEL, {
            pattern: pattern,
            buffer: buffer
        });
    }
    function $020793314dc5bef0$export$b108ea1063c657e3() {
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$CANCELLED, {});
    }
    function $020793314dc5bef0$export$4909b86c8034bf73(channel) {
        (0, $hIYGf.check)(channel, (0, $hIYGf.is).channel, 'flush(channel): argument ' + channel + ' is not valid channel');
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$FLUSH, channel);
    }
    function $020793314dc5bef0$export$31553aaa555c1514(prop) {
        (0, $hIYGf.check)(prop, (0, $hIYGf.is).string, 'getContext(prop): argument ' + prop + ' is not a string');
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$GET_CONTEXT, prop);
    }
    function $020793314dc5bef0$export$2f04de43fe27971a(props) {
        (0, $hIYGf.check)(props, (0, $hIYGf.is).object, (0, $hIYGf.createSetContextWarning)(null, props));
        return $020793314dc5bef0$var$effect($020793314dc5bef0$var$SET_CONTEXT, props);
    }
    var $020793314dc5bef0$var$createAsEffectType = function createAsEffectType(type) {
        return function(effect) {
            return effect && effect[$020793314dc5bef0$var$IO] && effect[type];
        };
    };
    var $020793314dc5bef0$export$6338d86c17f4b021 = {
        take: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$TAKE),
        put: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$PUT),
        all: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$ALL),
        race: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$RACE),
        call: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$CALL),
        cps: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$CPS),
        fork: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$FORK),
        join: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$JOIN),
        cancel: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$CANCEL),
        select: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$SELECT),
        actionChannel: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$ACTION_CHANNEL),
        cancelled: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$CANCELLED),
        flush: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$FLUSH),
        getContext: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$GET_CONTEXT),
        setContext: $020793314dc5bef0$var$createAsEffectType($020793314dc5bef0$var$SET_CONTEXT)
    };
});
parcelRegister("hIYGf", function(module, exports) {
    $parcel$export(module.exports, "sym", ()=>$ce759d95dda64ede$export$fe4bf738d66b6b12);
    $parcel$export(module.exports, "TASK", ()=>$ce759d95dda64ede$export$9355e489ad16f98e);
    $parcel$export(module.exports, "MATCH", ()=>$ce759d95dda64ede$export$5a1a83be8f503735);
    $parcel$export(module.exports, "CANCEL", ()=>$ce759d95dda64ede$export$2b10f4b30fb65583);
    $parcel$export(module.exports, "SAGA_ACTION", ()=>$ce759d95dda64ede$export$7d963e45ecdffba1);
    $parcel$export(module.exports, "SELF_CANCELLATION", ()=>$ce759d95dda64ede$export$3f4d38f8b89bfda7);
    $parcel$export(module.exports, "kTrue", ()=>$ce759d95dda64ede$export$efbbf28b4361f147);
    $parcel$export(module.exports, "noop", ()=>$ce759d95dda64ede$export$8793edee2d425525);
    $parcel$export(module.exports, "ident", ()=>$ce759d95dda64ede$export$7b66c250b210a314);
    $parcel$export(module.exports, "check", ()=>$ce759d95dda64ede$export$35dc45686fc2dbd7);
    $parcel$export(module.exports, "log", ()=>$ce759d95dda64ede$export$bef1f36f5486a6a3);
    $parcel$export(module.exports, "is", ()=>$ce759d95dda64ede$export$226b3eccf92c9ed9);
    $parcel$export(module.exports, "object", ()=>$ce759d95dda64ede$export$be5493f9613cbbe);
    $parcel$export(module.exports, "remove", ()=>$ce759d95dda64ede$export$cd7f480d6b8286c3);
    $parcel$export(module.exports, "array", ()=>$ce759d95dda64ede$export$2f23118c22fb2630);
    $parcel$export(module.exports, "deferred", ()=>$ce759d95dda64ede$export$b37aab7cecdd910a);
    $parcel$export(module.exports, "delay", ()=>$ce759d95dda64ede$export$1391212d75b2ee65);
    $parcel$export(module.exports, "uid", ()=>$ce759d95dda64ede$export$e2a22331486dcca0);
    $parcel$export(module.exports, "makeIterator", ()=>$ce759d95dda64ede$export$81c40ebfe660d3ca);
    $parcel$export(module.exports, "deprecate", ()=>$ce759d95dda64ede$export$b680e6b2c82f8c2f);
    $parcel$export(module.exports, "updateIncentive", ()=>$ce759d95dda64ede$export$415a43e38195481b);
    $parcel$export(module.exports, "internalErr", ()=>$ce759d95dda64ede$export$7127e4a0685605ed);
    $parcel$export(module.exports, "createSetContextWarning", ()=>$ce759d95dda64ede$export$8f9f9318fd98b7c9);
    $parcel$export(module.exports, "wrapSagaDispatch", ()=>$ce759d95dda64ede$export$e34107956f29fe3b);
    var $ce759d95dda64ede$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var $ce759d95dda64ede$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var $ce759d95dda64ede$export$fe4bf738d66b6b12 = function sym(id) {
        return '@@redux-saga/' + id;
    };
    var $ce759d95dda64ede$export$9355e489ad16f98e = $ce759d95dda64ede$export$fe4bf738d66b6b12('TASK');
    var $ce759d95dda64ede$export$6f5f529ff1aab24d = $ce759d95dda64ede$export$fe4bf738d66b6b12('HELPER');
    var $ce759d95dda64ede$export$5a1a83be8f503735 = $ce759d95dda64ede$export$fe4bf738d66b6b12('MATCH');
    var $ce759d95dda64ede$export$2b10f4b30fb65583 = $ce759d95dda64ede$export$fe4bf738d66b6b12('CANCEL_PROMISE');
    var $ce759d95dda64ede$export$7d963e45ecdffba1 = $ce759d95dda64ede$export$fe4bf738d66b6b12('SAGA_ACTION');
    var $ce759d95dda64ede$export$3f4d38f8b89bfda7 = $ce759d95dda64ede$export$fe4bf738d66b6b12('SELF_CANCELLATION');
    var $ce759d95dda64ede$export$bb6635af2cb49569 = function konst(v) {
        return function() {
            return v;
        };
    };
    var $ce759d95dda64ede$export$efbbf28b4361f147 = $ce759d95dda64ede$export$bb6635af2cb49569(true);
    var $ce759d95dda64ede$export$9842751ca2ee3424 = $ce759d95dda64ede$export$bb6635af2cb49569(false);
    var $ce759d95dda64ede$export$8793edee2d425525 = function noop() {};
    var $ce759d95dda64ede$export$7b66c250b210a314 = function ident(v) {
        return v;
    };
    function $ce759d95dda64ede$export$35dc45686fc2dbd7(value, predicate, error) {
        if (!predicate(value)) {
            $ce759d95dda64ede$export$bef1f36f5486a6a3('error', 'uncaught at check', error);
            throw new Error(error);
        }
    }
    var $ce759d95dda64ede$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    function $ce759d95dda64ede$export$b5a638e9b3fff9f3(object, property) {
        return $ce759d95dda64ede$export$226b3eccf92c9ed9.notUndef(object) && $ce759d95dda64ede$var$hasOwnProperty.call(object, property);
    }
    var $ce759d95dda64ede$export$226b3eccf92c9ed9 = {
        undef: function undef(v) {
            return v === null || v === undefined;
        },
        notUndef: function notUndef(v) {
            return v !== null && v !== undefined;
        },
        func: function func(f) {
            return typeof f === 'function';
        },
        number: function number(n) {
            return typeof n === 'number';
        },
        string: function string(s) {
            return typeof s === 'string';
        },
        array: Array.isArray,
        object: function object(obj) {
            return obj && !$ce759d95dda64ede$export$226b3eccf92c9ed9.array(obj) && (typeof obj === 'undefined' ? 'undefined' : $ce759d95dda64ede$var$_typeof(obj)) === 'object';
        },
        promise: function promise(p) {
            return p && $ce759d95dda64ede$export$226b3eccf92c9ed9.func(p.then);
        },
        iterator: function iterator(it) {
            return it && $ce759d95dda64ede$export$226b3eccf92c9ed9.func(it.next) && $ce759d95dda64ede$export$226b3eccf92c9ed9.func(it.throw);
        },
        iterable: function iterable(it) {
            return it && $ce759d95dda64ede$export$226b3eccf92c9ed9.func(Symbol) ? $ce759d95dda64ede$export$226b3eccf92c9ed9.func(it[Symbol.iterator]) : $ce759d95dda64ede$export$226b3eccf92c9ed9.array(it);
        },
        task: function task(t) {
            return t && t[$ce759d95dda64ede$export$9355e489ad16f98e];
        },
        observable: function observable(ob) {
            return ob && $ce759d95dda64ede$export$226b3eccf92c9ed9.func(ob.subscribe);
        },
        buffer: function buffer(buf) {
            return buf && $ce759d95dda64ede$export$226b3eccf92c9ed9.func(buf.isEmpty) && $ce759d95dda64ede$export$226b3eccf92c9ed9.func(buf.take) && $ce759d95dda64ede$export$226b3eccf92c9ed9.func(buf.put);
        },
        pattern: function pattern(pat) {
            return pat && ($ce759d95dda64ede$export$226b3eccf92c9ed9.string(pat) || (typeof pat === 'undefined' ? 'undefined' : $ce759d95dda64ede$var$_typeof(pat)) === 'symbol' || $ce759d95dda64ede$export$226b3eccf92c9ed9.func(pat) || $ce759d95dda64ede$export$226b3eccf92c9ed9.array(pat));
        },
        channel: function channel(ch) {
            return ch && $ce759d95dda64ede$export$226b3eccf92c9ed9.func(ch.take) && $ce759d95dda64ede$export$226b3eccf92c9ed9.func(ch.close);
        },
        helper: function helper(it) {
            return it && it[$ce759d95dda64ede$export$6f5f529ff1aab24d];
        },
        stringableFunc: function stringableFunc(f) {
            return $ce759d95dda64ede$export$226b3eccf92c9ed9.func(f) && $ce759d95dda64ede$export$b5a638e9b3fff9f3(f, 'toString');
        }
    };
    var $ce759d95dda64ede$export$be5493f9613cbbe = {
        assign: function assign(target, source) {
            for(var i in source)if ($ce759d95dda64ede$export$b5a638e9b3fff9f3(source, i)) target[i] = source[i];
        }
    };
    function $ce759d95dda64ede$export$cd7f480d6b8286c3(array, item) {
        var index = array.indexOf(item);
        if (index >= 0) array.splice(index, 1);
    }
    var $ce759d95dda64ede$export$2f23118c22fb2630 = {
        from: function from(obj) {
            var arr = Array(obj.length);
            for(var i in obj)if ($ce759d95dda64ede$export$b5a638e9b3fff9f3(obj, i)) arr[i] = obj[i];
            return arr;
        }
    };
    function $ce759d95dda64ede$export$b37aab7cecdd910a() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var def = $ce759d95dda64ede$var$_extends({}, props);
        var promise = new Promise(function(resolve, reject) {
            def.resolve = resolve;
            def.reject = reject;
        });
        def.promise = promise;
        return def;
    }
    function $ce759d95dda64ede$export$2d997e4cfcc3111d(length) {
        var arr = [];
        for(var i = 0; i < length; i++)arr.push($ce759d95dda64ede$export$b37aab7cecdd910a());
        return arr;
    }
    function $ce759d95dda64ede$export$1391212d75b2ee65(ms) {
        var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var timeoutId = void 0;
        var promise = new Promise(function(resolve) {
            timeoutId = setTimeout(function() {
                return resolve(val);
            }, ms);
        });
        promise[$ce759d95dda64ede$export$2b10f4b30fb65583] = function() {
            return clearTimeout(timeoutId);
        };
        return promise;
    }
    function $ce759d95dda64ede$export$d17c7504aef5c28d() {
        var _ref;
        var running = true;
        var _result = void 0, _error = void 0;
        return _ref = {}, _ref[$ce759d95dda64ede$export$9355e489ad16f98e] = true, _ref.isRunning = function isRunning() {
            return running;
        }, _ref.result = function result() {
            return _result;
        }, _ref.error = function error() {
            return _error;
        }, _ref.setRunning = function setRunning(b) {
            return running = b;
        }, _ref.setResult = function setResult(r) {
            return _result = r;
        }, _ref.setError = function setError(e) {
            return _error = e;
        }, _ref;
    }
    function $ce759d95dda64ede$export$7b18e57694835208() {
        var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return function() {
            return ++seed;
        };
    }
    var $ce759d95dda64ede$export$e2a22331486dcca0 = $ce759d95dda64ede$export$7b18e57694835208();
    var $ce759d95dda64ede$var$kThrow = function kThrow(err) {
        throw err;
    };
    var $ce759d95dda64ede$var$kReturn = function kReturn(value) {
        return {
            value: value,
            done: true
        };
    };
    function $ce759d95dda64ede$export$81c40ebfe660d3ca(next) {
        var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ce759d95dda64ede$var$kThrow;
        var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        var isHelper = arguments[3];
        var iterator = {
            name: name,
            next: next,
            throw: thro,
            return: $ce759d95dda64ede$var$kReturn
        };
        if (isHelper) iterator[$ce759d95dda64ede$export$6f5f529ff1aab24d] = true;
        if (typeof Symbol !== 'undefined') iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    }
    function $ce759d95dda64ede$export$bef1f36f5486a6a3(level, message) {
        var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        if (typeof window === 'undefined') console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
        else console[level](message, error);
    }
    function $ce759d95dda64ede$export$b680e6b2c82f8c2f(fn, deprecationWarning) {
        return function() {
            return fn.apply(undefined, arguments);
        };
    }
    var $ce759d95dda64ede$export$415a43e38195481b = function updateIncentive(deprecated, preferred) {
        return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
    };
    var $ce759d95dda64ede$export$7127e4a0685605ed = function internalErr(err) {
        return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
    };
    var $ce759d95dda64ede$export$8f9f9318fd98b7c9 = function createSetContextWarning(ctx, props) {
        return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
    };
    var $ce759d95dda64ede$export$e34107956f29fe3b = function wrapSagaDispatch(dispatch) {
        return function(action) {
            return dispatch(Object.defineProperty(action, $ce759d95dda64ede$export$7d963e45ecdffba1, {
                value: true
            }));
        };
    };
    var $ce759d95dda64ede$export$f2053ff14a3b4370 = function cloneableGenerator(generatorFunc) {
        return function() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var history = [];
            var gen = generatorFunc.apply(undefined, args);
            return {
                next: function next(arg) {
                    history.push(arg);
                    return gen.next(arg);
                },
                clone: function clone() {
                    var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
                    history.forEach(function(arg) {
                        return clonedGen.next(arg);
                    });
                    return clonedGen;
                },
                return: function _return(value) {
                    return gen.return(value);
                },
                throw: function _throw(exception) {
                    return gen.throw(exception);
                }
            };
        };
    };
});
parcelRegister("6u3NN", function(module, exports) {
    $parcel$export(module.exports, "takeEvery", ()=>$4b887e7885b29df8$export$4e24be1e1c9d5c69);
    $parcel$export(module.exports, "takeLatest", ()=>$4b887e7885b29df8$export$ca010cea618a298a);
    var $aNOuE = parcelRequire("aNOuE");
    parcelRequire("kZUFp");
    var $3JC0e = parcelRequire("3JC0e");
    var $2V6ng = parcelRequire("2V6ng");
    var $jNlnT = parcelRequire("jNlnT");
    function $4b887e7885b29df8$export$4e24be1e1c9d5c69(patternOrChannel, worker) {
        for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return (0, $aNOuE.fork).apply(undefined, [
            (0, $3JC0e.default),
            patternOrChannel,
            worker
        ].concat(args));
    }
    function $4b887e7885b29df8$export$ca010cea618a298a(patternOrChannel, worker) {
        for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
        return (0, $aNOuE.fork).apply(undefined, [
            (0, $2V6ng.default),
            patternOrChannel,
            worker
        ].concat(args));
    }
    function $4b887e7885b29df8$export$de363e709c412c8a(ms, pattern, worker) {
        for(var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++)args[_key3 - 3] = arguments[_key3];
        return (0, $aNOuE.fork).apply(undefined, [
            (0, $jNlnT.default),
            ms,
            pattern,
            worker
        ].concat(args));
    }
});
parcelRegister("kZUFp", function(module, exports) {
    $parcel$export(module.exports, "takeEveryHelper", ()=>(parcelRequire("3JC0e")).default);
    $parcel$export(module.exports, "takeLatestHelper", ()=>(parcelRequire("2V6ng")).default);
    $parcel$export(module.exports, "throttleHelper", ()=>(parcelRequire("jNlnT")).default);
    var $3JC0e = parcelRequire("3JC0e");
    var $2V6ng = parcelRequire("2V6ng");
    var $jNlnT = parcelRequire("jNlnT");
    var $hIYGf = parcelRequire("hIYGf");
    var $f4957604aec151f5$var$deprecationWarning = function deprecationWarning(helperName) {
        return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
    };
    var $f4957604aec151f5$export$4e24be1e1c9d5c69 = (0, $hIYGf.deprecate)((0, $3JC0e.default), $f4957604aec151f5$var$deprecationWarning('takeEvery'));
    var $f4957604aec151f5$export$ca010cea618a298a = (0, $hIYGf.deprecate)((0, $2V6ng.default), $f4957604aec151f5$var$deprecationWarning('takeLatest'));
    var $f4957604aec151f5$export$de363e709c412c8a = (0, $hIYGf.deprecate)((0, $jNlnT.default), $f4957604aec151f5$var$deprecationWarning('throttle'));
});
parcelRegister("3JC0e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b830d9c15b15871$export$2e2bcd8739ae039);
    var $4nDxS = parcelRequire("4nDxS");
    var $aNOuE = parcelRequire("aNOuE");
    var $fk7jx = parcelRequire("fk7jx");
    function $2b830d9c15b15871$export$2e2bcd8739ae039(patternOrChannel, worker) {
        for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var yTake = {
            done: false,
            value: (0, $aNOuE.take)(patternOrChannel)
        };
        var yFork = function yFork(ac) {
            return {
                done: false,
                value: (0, $aNOuE.fork).apply(undefined, [
                    worker
                ].concat(args, [
                    ac
                ]))
            };
        };
        var action = void 0, setAction = function setAction(ac) {
            return action = ac;
        };
        return (0, $4nDxS.default)({
            q1: function q1() {
                return [
                    'q2',
                    yTake,
                    setAction
                ];
            },
            q2: function q2() {
                return action === (0, $fk7jx.END) ? [
                    (0, $4nDxS.qEnd)
                ] : [
                    'q1',
                    yFork(action)
                ];
            }
        }, 'q1', 'takeEvery(' + (0, $4nDxS.safeName)(patternOrChannel) + ', ' + worker.name + ')');
    }
});
parcelRegister("4nDxS", function(module, exports) {
    $parcel$export(module.exports, "qEnd", ()=>$3307fc507e414473$export$41cf03a0ef8df852);
    $parcel$export(module.exports, "safeName", ()=>$3307fc507e414473$export$13bcac93470fc5a);
    $parcel$export(module.exports, "default", ()=>$3307fc507e414473$export$2e2bcd8739ae039);
    var $hIYGf = parcelRequire("hIYGf");
    var $3307fc507e414473$var$done = {
        done: true,
        value: undefined
    };
    var $3307fc507e414473$export$41cf03a0ef8df852 = {};
    function $3307fc507e414473$export$13bcac93470fc5a(patternOrChannel) {
        if ((0, $hIYGf.is).channel(patternOrChannel)) return 'channel';
        else if (Array.isArray(patternOrChannel)) return String(patternOrChannel.map(function(entry) {
            return String(entry);
        }));
        else return String(patternOrChannel);
    }
    function $3307fc507e414473$export$2e2bcd8739ae039(fsm, q0) {
        var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
        var updateState = void 0, qNext = q0;
        function next(arg, error) {
            if (qNext === $3307fc507e414473$export$41cf03a0ef8df852) return $3307fc507e414473$var$done;
            if (error) {
                qNext = $3307fc507e414473$export$41cf03a0ef8df852;
                throw error;
            } else {
                updateState && updateState(arg);
                var _fsm$qNext = fsm[qNext](), q = _fsm$qNext[0], output = _fsm$qNext[1], _updateState = _fsm$qNext[2];
                qNext = q;
                updateState = _updateState;
                return qNext === $3307fc507e414473$export$41cf03a0ef8df852 ? $3307fc507e414473$var$done : output;
            }
        }
        return (0, $hIYGf.makeIterator)(next, function(error) {
            return next(null, error);
        }, name, true);
    }
});
parcelRegister("fk7jx", function(module, exports) {
    $parcel$export(module.exports, "END", ()=>$b27e65b4b7241d3c$export$32239d68d9c6cb49);
    $parcel$export(module.exports, "isEnd", ()=>$b27e65b4b7241d3c$export$42af6f45c6e0d09f);
    $parcel$export(module.exports, "emitter", ()=>$b27e65b4b7241d3c$export$bad24218ebd77223);
    $parcel$export(module.exports, "eventChannel", ()=>$b27e65b4b7241d3c$export$dfc3101b3180c292);
    $parcel$export(module.exports, "stdChannel", ()=>$b27e65b4b7241d3c$export$e987d166a3a4f3ec);
    var $hIYGf = parcelRequire("hIYGf");
    var $jq2wL = parcelRequire("jq2wL");
    var $8Zfai = parcelRequire("8Zfai");
    var $b27e65b4b7241d3c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var $b27e65b4b7241d3c$var$CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
    var $b27e65b4b7241d3c$export$32239d68d9c6cb49 = {
        type: $b27e65b4b7241d3c$var$CHANNEL_END_TYPE
    };
    var $b27e65b4b7241d3c$export$42af6f45c6e0d09f = function isEnd(a) {
        return a && a.type === $b27e65b4b7241d3c$var$CHANNEL_END_TYPE;
    };
    function $b27e65b4b7241d3c$export$bad24218ebd77223() {
        var subscribers = [];
        function subscribe(sub) {
            subscribers.push(sub);
            return function() {
                return (0, $hIYGf.remove)(subscribers, sub);
            };
        }
        function emit(item) {
            var arr = subscribers.slice();
            for(var i = 0, len = arr.length; i < len; i++)arr[i](item);
        }
        return {
            subscribe: subscribe,
            emit: emit
        };
    }
    var $b27e65b4b7241d3c$export$bf9cf0a07cf1d9ff = 'invalid buffer passed to channel factory function';
    var $b27e65b4b7241d3c$export$8c86d8be17ae885 = 'Saga was provided with an undefined action';
    function $b27e65b4b7241d3c$export$1f95fbd68d964d36() {
        var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $jq2wL.buffers).fixed();
        var closed = false;
        var takers = [];
        (0, $hIYGf.check)(buffer, (0, $hIYGf.is).buffer, $b27e65b4b7241d3c$export$bf9cf0a07cf1d9ff);
        function checkForbiddenStates() {
            if (closed && takers.length) throw (0, $hIYGf.internalErr)('Cannot have a closed channel with pending takers');
            if (takers.length && !buffer.isEmpty()) throw (0, $hIYGf.internalErr)('Cannot have pending takers with non empty buffer');
        }
        function put(input) {
            checkForbiddenStates();
            (0, $hIYGf.check)(input, (0, $hIYGf.is).notUndef, $b27e65b4b7241d3c$export$8c86d8be17ae885);
            if (closed) return;
            if (!takers.length) return buffer.put(input);
            for(var i = 0; i < takers.length; i++){
                var cb = takers[i];
                if (!cb[0, $hIYGf.MATCH] || cb[0, $hIYGf.MATCH](input)) {
                    takers.splice(i, 1);
                    return cb(input);
                }
            }
        }
        function take(cb) {
            checkForbiddenStates();
            (0, $hIYGf.check)(cb, (0, $hIYGf.is).func, "channel.take's callback must be a function");
            if (closed && buffer.isEmpty()) cb($b27e65b4b7241d3c$export$32239d68d9c6cb49);
            else if (!buffer.isEmpty()) cb(buffer.take());
            else {
                takers.push(cb);
                cb.cancel = function() {
                    return (0, $hIYGf.remove)(takers, cb);
                };
            }
        }
        function flush(cb) {
            checkForbiddenStates();
            (0, $hIYGf.check)(cb, (0, $hIYGf.is).func, "channel.flush' callback must be a function");
            if (closed && buffer.isEmpty()) {
                cb($b27e65b4b7241d3c$export$32239d68d9c6cb49);
                return;
            }
            cb(buffer.flush());
        }
        function close() {
            checkForbiddenStates();
            if (!closed) {
                closed = true;
                if (takers.length) {
                    var arr = takers;
                    takers = [];
                    for(var i = 0, len = arr.length; i < len; i++)arr[i]($b27e65b4b7241d3c$export$32239d68d9c6cb49);
                }
            }
        }
        return {
            take: take,
            put: put,
            flush: flush,
            close: close,
            get __takers__ () {
                return takers;
            },
            get __closed__ () {
                return closed;
            }
        };
    }
    function $b27e65b4b7241d3c$export$dfc3101b3180c292(subscribe) {
        var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $jq2wL.buffers).none();
        var matcher = arguments[2];
        if (arguments.length > 2) (0, $hIYGf.check)(matcher, (0, $hIYGf.is).func, 'Invalid match function passed to eventChannel');
        var chan = $b27e65b4b7241d3c$export$1f95fbd68d964d36(buffer);
        var close = function close() {
            if (!chan.__closed__) {
                if (unsubscribe) unsubscribe();
                chan.close();
            }
        };
        var unsubscribe = subscribe(function(input) {
            if ($b27e65b4b7241d3c$export$42af6f45c6e0d09f(input)) {
                close();
                return;
            }
            if (matcher && !matcher(input)) return;
            chan.put(input);
        });
        if (chan.__closed__) unsubscribe();
        if (!(0, $hIYGf.is).func(unsubscribe)) throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
        return {
            take: chan.take,
            flush: chan.flush,
            close: close
        };
    }
    function $b27e65b4b7241d3c$export$e987d166a3a4f3ec(subscribe) {
        var chan = $b27e65b4b7241d3c$export$dfc3101b3180c292(function(cb) {
            return subscribe(function(input) {
                if (input[0, $hIYGf.SAGA_ACTION]) {
                    cb(input);
                    return;
                }
                (0, $8Zfai.asap)(function() {
                    return cb(input);
                });
            });
        });
        return $b27e65b4b7241d3c$var$_extends({}, chan, {
            take: function take(cb, matcher) {
                if (arguments.length > 1) {
                    (0, $hIYGf.check)(matcher, (0, $hIYGf.is).func, "channel.take's matcher argument must be a function");
                    cb[0, $hIYGf.MATCH] = matcher;
                }
                chan.take(cb);
            }
        });
    }
});
parcelRegister("jq2wL", function(module, exports) {
    $parcel$export(module.exports, "buffers", ()=>$e23267ec8a8b24c1$export$e131ba331971b277);
    var $hIYGf = parcelRequire("hIYGf");
    var $e23267ec8a8b24c1$export$9293dc23fd60380b = "Channel's Buffer overflow!";
    var $e23267ec8a8b24c1$var$ON_OVERFLOW_THROW = 1;
    var $e23267ec8a8b24c1$var$ON_OVERFLOW_DROP = 2;
    var $e23267ec8a8b24c1$var$ON_OVERFLOW_SLIDE = 3;
    var $e23267ec8a8b24c1$var$ON_OVERFLOW_EXPAND = 4;
    var $e23267ec8a8b24c1$var$zeroBuffer = {
        isEmpty: (0, $hIYGf.kTrue),
        put: (0, $hIYGf.noop),
        take: (0, $hIYGf.noop)
    };
    function $e23267ec8a8b24c1$var$ringBuffer() {
        var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
        var overflowAction = arguments[1];
        var arr = new Array(limit);
        var length = 0;
        var pushIndex = 0;
        var popIndex = 0;
        var push = function push(it) {
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            length++;
        };
        var take = function take() {
            if (length != 0) {
                var it = arr[popIndex];
                arr[popIndex] = null;
                length--;
                popIndex = (popIndex + 1) % limit;
                return it;
            }
        };
        var flush = function flush() {
            var items = [];
            while(length)items.push(take());
            return items;
        };
        return {
            isEmpty: function isEmpty() {
                return length == 0;
            },
            put: function put(it) {
                if (length < limit) push(it);
                else {
                    var doubledLimit = void 0;
                    switch(overflowAction){
                        case $e23267ec8a8b24c1$var$ON_OVERFLOW_THROW:
                            throw new Error($e23267ec8a8b24c1$export$9293dc23fd60380b);
                        case $e23267ec8a8b24c1$var$ON_OVERFLOW_SLIDE:
                            arr[pushIndex] = it;
                            pushIndex = (pushIndex + 1) % limit;
                            popIndex = pushIndex;
                            break;
                        case $e23267ec8a8b24c1$var$ON_OVERFLOW_EXPAND:
                            doubledLimit = 2 * limit;
                            arr = flush();
                            length = arr.length;
                            pushIndex = arr.length;
                            popIndex = 0;
                            arr.length = doubledLimit;
                            limit = doubledLimit;
                            push(it);
                            break;
                        default:
                    }
                }
            },
            take: take,
            flush: flush
        };
    }
    var $e23267ec8a8b24c1$export$e131ba331971b277 = {
        none: function none() {
            return $e23267ec8a8b24c1$var$zeroBuffer;
        },
        fixed: function fixed(limit) {
            return $e23267ec8a8b24c1$var$ringBuffer(limit, $e23267ec8a8b24c1$var$ON_OVERFLOW_THROW);
        },
        dropping: function dropping(limit) {
            return $e23267ec8a8b24c1$var$ringBuffer(limit, $e23267ec8a8b24c1$var$ON_OVERFLOW_DROP);
        },
        sliding: function sliding(limit) {
            return $e23267ec8a8b24c1$var$ringBuffer(limit, $e23267ec8a8b24c1$var$ON_OVERFLOW_SLIDE);
        },
        expanding: function expanding(initialSize) {
            return $e23267ec8a8b24c1$var$ringBuffer(initialSize, $e23267ec8a8b24c1$var$ON_OVERFLOW_EXPAND);
        }
    };
});
parcelRegister("8Zfai", function(module, exports) {
    $parcel$export(module.exports, "suspend", ()=>$68afc8b265448ca4$export$a1428c8f7ba796e8);
    $parcel$export(module.exports, "asap", ()=>$68afc8b265448ca4$export$dc4d482300a341e1);
    $parcel$export(module.exports, "flush", ()=>$68afc8b265448ca4$export$4909b86c8034bf73);
    var $68afc8b265448ca4$var$queue = [];
    var $68afc8b265448ca4$var$semaphore = 0;
    function $68afc8b265448ca4$var$exec(task) {
        try {
            $68afc8b265448ca4$export$a1428c8f7ba796e8();
            task();
        } finally{
            $68afc8b265448ca4$var$release();
        }
    }
    function $68afc8b265448ca4$export$dc4d482300a341e1(task) {
        $68afc8b265448ca4$var$queue.push(task);
        if (!$68afc8b265448ca4$var$semaphore) {
            $68afc8b265448ca4$export$a1428c8f7ba796e8();
            $68afc8b265448ca4$export$4909b86c8034bf73();
        }
    }
    function $68afc8b265448ca4$export$a1428c8f7ba796e8() {
        $68afc8b265448ca4$var$semaphore++;
    }
    function $68afc8b265448ca4$var$release() {
        $68afc8b265448ca4$var$semaphore--;
    }
    function $68afc8b265448ca4$export$4909b86c8034bf73() {
        $68afc8b265448ca4$var$release();
        var task = void 0;
        while(!$68afc8b265448ca4$var$semaphore && (task = $68afc8b265448ca4$var$queue.shift()) !== undefined)$68afc8b265448ca4$var$exec(task);
    }
});
parcelRegister("2V6ng", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2205d96b2dce1906$export$2e2bcd8739ae039);
    var $4nDxS = parcelRequire("4nDxS");
    var $aNOuE = parcelRequire("aNOuE");
    var $fk7jx = parcelRequire("fk7jx");
    function $2205d96b2dce1906$export$2e2bcd8739ae039(patternOrChannel, worker) {
        for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var yTake = {
            done: false,
            value: (0, $aNOuE.take)(patternOrChannel)
        };
        var yFork = function yFork(ac) {
            return {
                done: false,
                value: (0, $aNOuE.fork).apply(undefined, [
                    worker
                ].concat(args, [
                    ac
                ]))
            };
        };
        var yCancel = function yCancel(task) {
            return {
                done: false,
                value: (0, $aNOuE.cancel)(task)
            };
        };
        var task = void 0, action = void 0;
        var setTask = function setTask(t) {
            return task = t;
        };
        var setAction = function setAction(ac) {
            return action = ac;
        };
        return (0, $4nDxS.default)({
            q1: function q1() {
                return [
                    'q2',
                    yTake,
                    setAction
                ];
            },
            q2: function q2() {
                return action === (0, $fk7jx.END) ? [
                    (0, $4nDxS.qEnd)
                ] : task ? [
                    'q3',
                    yCancel(task)
                ] : [
                    'q1',
                    yFork(action),
                    setTask
                ];
            },
            q3: function q3() {
                return [
                    'q1',
                    yFork(action),
                    setTask
                ];
            }
        }, 'q1', 'takeLatest(' + (0, $4nDxS.safeName)(patternOrChannel) + ', ' + worker.name + ')');
    }
});
parcelRegister("jNlnT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6932e6b4b0268ac$export$2e2bcd8739ae039);
    var $4nDxS = parcelRequire("4nDxS");
    var $aNOuE = parcelRequire("aNOuE");
    var $fk7jx = parcelRequire("fk7jx");
    var $jq2wL = parcelRequire("jq2wL");
    var $hIYGf = parcelRequire("hIYGf");
    function $e6932e6b4b0268ac$export$2e2bcd8739ae039(delayLength, pattern, worker) {
        for(var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
        var action = void 0, channel = void 0;
        var yActionChannel = {
            done: false,
            value: (0, $aNOuE.actionChannel)(pattern, (0, $jq2wL.buffers).sliding(1))
        };
        var yTake = function yTake() {
            return {
                done: false,
                value: (0, $aNOuE.take)(channel)
            };
        };
        var yFork = function yFork(ac) {
            return {
                done: false,
                value: (0, $aNOuE.fork).apply(undefined, [
                    worker
                ].concat(args, [
                    ac
                ]))
            };
        };
        var yDelay = {
            done: false,
            value: (0, $aNOuE.call)((0, $hIYGf.delay), delayLength)
        };
        var setAction = function setAction(ac) {
            return action = ac;
        };
        var setChannel = function setChannel(ch) {
            return channel = ch;
        };
        return (0, $4nDxS.default)({
            q1: function q1() {
                return [
                    'q2',
                    yActionChannel,
                    setChannel
                ];
            },
            q2: function q2() {
                return [
                    'q3',
                    yTake(),
                    setAction
                ];
            },
            q3: function q3() {
                return action === (0, $fk7jx.END) ? [
                    (0, $4nDxS.qEnd)
                ] : [
                    'q4',
                    yFork(action)
                ];
            },
            q4: function q4() {
                return [
                    'q2',
                    yDelay
                ];
            }
        }, 'q1', 'throttle(' + (0, $4nDxS.safeName)(pattern) + ', ' + worker.name + ')');
    }
});
parcelRegister("1Cyfv", function(module, exports) {
    $parcel$export(module.exports, "KEYS", ()=>$f8f8cee6a6ec61e0$export$f9ba527e25c2bc92);
    const $f8f8cee6a6ec61e0$export$f9ba527e25c2bc92 = {
        EXPAND_ALL_ISSUES: 'arj-timeline-expand-all-issues',
        COLLAPSE_ALL_ISSUES: 'arj-timeline-collapse-all-issues',
        EXPAND_ISSUE: 'arj-timeline-expand-issue',
        COLLAPSE_ISSUE: 'arj-timeline-collapse-issue',
        EXPAND_ISSUE_WITHOUT_PARENT: 'arj-timeline-expand-issue-without-parent',
        CREATE_ISSUE: 'arj-timeline-create-issue',
        COLLAPSE_ISSUE_WITHOUT_PARENT: 'arj-timeline-collapse-issue-without-parent',
        CHANGE_COLOR_BY_SETTING: 'arj-timeline-change-color-by-setting',
        CHANGE_GROUP_BY_SETTING: 'arj-timeline-change-group-by-setting',
        CHANGE_FILTER_VALUE: 'arj-timeline-change-filter-value',
        SORT_BY_FIELD: 'arj-timeline-sort-by-field',
        OPEN_REVIEW_CHANGES: 'arj-timeline-open-review-changes',
        SAVE_REVIEW_CHANGES: 'arj-timeline-save-review-changes',
        SWITCH_VIEW: 'arj-timeline-switch-view',
        CREATE_TEAM: 'arj-teams-create-team',
        UPDATE_TEAM: 'arj-teams-update-team',
        CREATE_RELEASE: 'arj-releases-create-release',
        UPDATE_RELEASE: 'arj-releases-update-release'
    };
});
parcelRegister("19iju", function(module, exports) {
    $parcel$export(module.exports, "getCustomFields", ()=>$7d0ef85f9645356e$export$38306747bc0912a4);
    $parcel$export(module.exports, "getCustomFieldsById", ()=>$7d0ef85f9645356e$export$dada3f92779aaf9a);
    $parcel$export(module.exports, "getSupportedCustomFields", ()=>$7d0ef85f9645356e$export$9369dee44a26a06c);
    $parcel$export(module.exports, "getFilterableCustomFields", ()=>$7d0ef85f9645356e$export$3b1b52240ef3572e);
    $parcel$export(module.exports, "getCustomFieldsByKey", ()=>$7d0ef85f9645356e$export$d8a0fc111d5e2ab0);
    $parcel$export(module.exports, "getCustomFieldById", ()=>$7d0ef85f9645356e$export$793123b5ff3f40ad);
    $parcel$export(module.exports, "getSelectOptions", ()=>$7d0ef85f9645356e$export$fd440e53dd69ddad);
    $parcel$export(module.exports, "getSelectOptionsById", ()=>$7d0ef85f9645356e$export$b3a0f99c6d5c0eb0);
    $parcel$export(module.exports, "getUserPickerOptions", ()=>$7d0ef85f9645356e$export$a4fdd23a97f272c8);
    $parcel$export(module.exports, "getUserPickerOptionsUserList", ()=>$7d0ef85f9645356e$export$9bfa891f0e97567);
    $parcel$export(module.exports, "getUserPickerOptionsUserListById", ()=>$7d0ef85f9645356e$export$4fb91df5858ae1d4);
    $parcel$export(module.exports, "getUserPickerUIState", ()=>$7d0ef85f9645356e$export$d488418c9141b6ed);
    $parcel$export(module.exports, "getCustomLabelFieldIds", ()=>$7d0ef85f9645356e$export$d1d1f3bde590a033);
    var $2rMKg;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    const $7d0ef85f9645356e$export$38306747bc0912a4 = (state)=>state.domain.customFields;
    const $7d0ef85f9645356e$export$dada3f92779aaf9a = (0, $3YtPS.createSelector)([
        $7d0ef85f9645356e$export$38306747bc0912a4
    ], (customFields)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), customFields));
    const $7d0ef85f9645356e$export$9369dee44a26a06c = (0, $3YtPS.createSelector)([
        $7d0ef85f9645356e$export$38306747bc0912a4
    ], (customFields)=>customFields.filter((field)=>(0, $TTKUQ.CustomFields).WritableFields.includes(field.type.key) || (0, $TTKUQ.CustomFields).ReadOnlyFields.includes(field.type.key)));
    const $7d0ef85f9645356e$export$3b1b52240ef3572e = (0, $3YtPS.createSelector)([
        $7d0ef85f9645356e$export$38306747bc0912a4
    ], (customFields)=>customFields.filter((field)=>(0, $TTKUQ.CustomFields).FilterableFields.includes(field.type.key)));
    const $7d0ef85f9645356e$export$d8a0fc111d5e2ab0 = (key, customFields)=>customFields.filter((customField)=>customField.type.key === key);
    const $7d0ef85f9645356e$export$793123b5ff3f40ad = (id, customFields)=>customFields.filter((customField)=>customField.id === id);
    const $7d0ef85f9645356e$export$fd440e53dd69ddad = (state)=>state.domain.selectOptions;
    const $7d0ef85f9645356e$export$b3a0f99c6d5c0eb0 = (0, $3YtPS.createSelector)([
        $7d0ef85f9645356e$export$fd440e53dd69ddad
    ], (selectOptions)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), selectOptions));
    const $7d0ef85f9645356e$export$a4fdd23a97f272c8 = (state)=>state.domain.userPickerOptions;
    const $7d0ef85f9645356e$export$9bfa891f0e97567 = (state)=>state.domain.userPickerOptions.userList;
    const $7d0ef85f9645356e$export$4fb91df5858ae1d4 = (0, $3YtPS.createSelector)([
        $7d0ef85f9645356e$export$9bfa891f0e97567
    ], (userList)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('value'), userList));
    const $7d0ef85f9645356e$export$d488418c9141b6ed = (state)=>state.ui.Main.Tabs.Roadmap.Fields.CustomFields.UserPicker;
    const $7d0ef85f9645356e$export$d1d1f3bde590a033 = (0, $3YtPS.createSelector)([
        $7d0ef85f9645356e$export$38306747bc0912a4
    ], (customFields)=>customFields.filter((customField)=>(0, $cScrq.isLabelCustomField)(customField.type.key)).map((customField)=>`${customField.id}`));
});
parcelRegister("1cIjo", function(module, exports) {
    $parcel$export(module.exports, "getHierarchyRangeFilterState", ()=>$9ad5ca0d5f68edb0$export$cbede2dc3b8b4300);
    $parcel$export(module.exports, "getHierarchyRangeFilter", ()=>$9ad5ca0d5f68edb0$export$e9935447b3518591);
    $parcel$export(module.exports, "applyHierarchyRangeFilter", ()=>$9ad5ca0d5f68edb0$export$713199788b3f01f0);
    var $g4tDr;
    var $cGbfF = parcelRequire("cGbfF");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $kWDpn = parcelRequire("kWDpn");
    const $9ad5ca0d5f68edb0$export$cbede2dc3b8b4300 = (state)=>{
        const { value: value } = (0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.HIERARCHY_RANGE_FILTER_ID] || {};
        return {
            id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
            value: value
        };
    };
    const $9ad5ca0d5f68edb0$export$7f7144ee25fd419b = (hierarchyFilter, hierarchyRange, isCalendarView)=>{
        const { min: min, max: max } = hierarchyRange;
        const currentValue = hierarchyFilter.value || {
            start: undefined,
            end: undefined
        };
        if (!(0, $4nDwW.isDefined)(currentValue.start)) currentValue.start = isCalendarView ? (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC) : max;
        if (!(0, $4nDwW.isDefined)(currentValue.end)) currentValue.end = isCalendarView ? (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC) : min;
        const clamp = (val, minValue, maxValue)=>Math.min(Math.max(val, minValue), maxValue);
        const clampedStart = clamp(currentValue.start, min, max);
        const clampedEnd = isCalendarView ? clampedStart : clamp(currentValue.end, min, clampedStart);
        const newValue = {
            start: clampedStart,
            end: clampedEnd
        };
        return {
            ...hierarchyFilter,
            value: newValue
        };
    };
    const $9ad5ca0d5f68edb0$export$e9935447b3518591 = (0, $3YtPS.createSelector)([
        $9ad5ca0d5f68edb0$export$cbede2dc3b8b4300,
        (0, $6Ayrn.getHierarchyRange),
        (0, $kWDpn.getIsCalendarView)
    ], $9ad5ca0d5f68edb0$export$7f7144ee25fd419b);
    const $9ad5ca0d5f68edb0$export$713199788b3f01f0 = (issue, filter)=>{
        const { start: start, end: end } = filter.value;
        return start >= issue.level && issue.level >= end;
    };
});
parcelRegister("cGbfF", function(module, exports) {
    $parcel$export(module.exports, "HIERARCHY_FILTER_ID", ()=>$1b7b65e9d134100e$export$9ca65f4dca18a9fc);
    $parcel$export(module.exports, "HIERARCHY_RANGE_FILTER_ID", ()=>$1b7b65e9d134100e$export$c4a2a48e7b94aaa5);
    $parcel$export(module.exports, "PROJECT_FILTER_ID", ()=>$1b7b65e9d134100e$export$d0da0a0b0cd817d8);
    $parcel$export(module.exports, "CROSS_PROJECT_RELEASE_FILTER_ID", ()=>$1b7b65e9d134100e$export$585fb3e81bcfccad);
    $parcel$export(module.exports, "RELEASE_FILTER_ID", ()=>$1b7b65e9d134100e$export$53e2f8996e102881);
    $parcel$export(module.exports, "TEAM_FILTER_ID", ()=>$1b7b65e9d134100e$export$8abe69ceb26771cd);
    $parcel$export(module.exports, "ASSIGNEE_FILTER_ID", ()=>$1b7b65e9d134100e$export$43596ee088b165a);
    $parcel$export(module.exports, "REPORTER_FILTER_ID", ()=>$1b7b65e9d134100e$export$20140793a0aa2b3c);
    $parcel$export(module.exports, "SUMMARY_FILTER_ID", ()=>$1b7b65e9d134100e$export$e32eeae4866f112c);
    $parcel$export(module.exports, "DEPENDENCIES_FILTER_ID", ()=>$1b7b65e9d134100e$export$a849f806e27a57e8);
    $parcel$export(module.exports, "LABEL_FILTER_ID", ()=>$1b7b65e9d134100e$export$7e257b719377371e);
    $parcel$export(module.exports, "COMPONENT_FILTER_ID", ()=>$1b7b65e9d134100e$export$6022538efc28a609);
    $parcel$export(module.exports, "STATUS_FILTER_ID", ()=>$1b7b65e9d134100e$export$e3608e8ffa9df136);
    $parcel$export(module.exports, "STATUS_KEY_FILTER_ID", ()=>$1b7b65e9d134100e$export$9b51ec1115932c53);
    $parcel$export(module.exports, "ISSUE_WARNING_FILTER_ID", ()=>$1b7b65e9d134100e$export$59af687b450af7eb);
    $parcel$export(module.exports, "SPRINT_FILTER_ID", ()=>$1b7b65e9d134100e$export$46cb1c3e9f7a5fbb);
    $parcel$export(module.exports, "GOAL_FILTER_ID", ()=>$1b7b65e9d134100e$export$861e775e082be75a);
    $parcel$export(module.exports, "IDEA_FILTER_ID", ()=>$1b7b65e9d134100e$export$cffc66ae4b1fddaa);
    $parcel$export(module.exports, "ISSUE_TYPES_FILTER_ID", ()=>$1b7b65e9d134100e$export$ef1873c24394b0a7);
    $parcel$export(module.exports, "ISSUE_TYPE_KEY_FILTER_ID", ()=>$1b7b65e9d134100e$export$a8ec3260a009d752);
    $parcel$export(module.exports, "ISSUE_PRIORITIES_FILTER_ID", ()=>$1b7b65e9d134100e$export$b6fe2739dbbe2e5d);
    $parcel$export(module.exports, "CUSTOM_FIELD_FILTER_ID", ()=>$1b7b65e9d134100e$export$3b798637a628dacc);
    $parcel$export(module.exports, "DATE_RANGE_FILTER_ID", ()=>$1b7b65e9d134100e$export$82db1960569473ff);
    $parcel$export(module.exports, "ROADMAP_FILTER_SOURCE", ()=>$1b7b65e9d134100e$export$f4ac8734c859ca93);
    $parcel$export(module.exports, "RELEASE_FILTER_SOURCE", ()=>$1b7b65e9d134100e$export$eb2de919d11696d);
    const $1b7b65e9d134100e$export$9ca65f4dca18a9fc = 'state.domain.view-settings.filters.HIERARCHY_FILTER_ID';
    const $1b7b65e9d134100e$export$c4a2a48e7b94aaa5 = 'state.domain.view-settings.filters.HIERARCHY_RANGE_FILTER_ID';
    const $1b7b65e9d134100e$export$d0da0a0b0cd817d8 = 'state.domain.view-settings.filters.PROJECT_FILTER_ID';
    const $1b7b65e9d134100e$export$585fb3e81bcfccad = 'state.domain.view-settings.filters.CROSS_PROJECT_RELEASE_FILTER_ID';
    const $1b7b65e9d134100e$export$53e2f8996e102881 = 'state.domain.view-settings.filters.RELEASE_FILTER_ID';
    const $1b7b65e9d134100e$export$8abe69ceb26771cd = 'state.domain.view-settings.filters.TEAM_FILTER_ID';
    const $1b7b65e9d134100e$export$43596ee088b165a = 'state.domain.view-settings.filters.ASSIGNEE_FILTER_ID';
    const $1b7b65e9d134100e$export$20140793a0aa2b3c = 'state.domain.view-settings.filters.REPORTER_FILTER_ID';
    const $1b7b65e9d134100e$export$e32eeae4866f112c = 'state.domain.view-settings.filters.SUMMARY_FILTER_ID';
    const $1b7b65e9d134100e$export$a849f806e27a57e8 = 'state.domain.view-settings.filters.DEPENDENCIES_FILTER_ID';
    const $1b7b65e9d134100e$export$7e257b719377371e = 'state.domain.view-settings.filters.LABEL_FILTER_ID';
    const $1b7b65e9d134100e$export$6022538efc28a609 = 'state.domain.view-settings.filters.COMPONENT_FILTER_ID';
    const $1b7b65e9d134100e$export$e3608e8ffa9df136 = 'state.domain.view-settings.filters.STATUS_FILTER_ID';
    const $1b7b65e9d134100e$export$9b51ec1115932c53 = 'state.domain.view-settings.filters.STATUS_KEY_FILTER_ID';
    const $1b7b65e9d134100e$export$59af687b450af7eb = 'state.domain.view-settings.filters.ISSUE_WARNING_FILTER_ID';
    const $1b7b65e9d134100e$export$46cb1c3e9f7a5fbb = 'state.domain.view-settings.filters.SPRINT_FILTER_ID';
    const $1b7b65e9d134100e$export$861e775e082be75a = 'state.domain.view-settings.filters.GOAL_FILTER_ID';
    const $1b7b65e9d134100e$export$cffc66ae4b1fddaa = 'state.domain.view-settings.filters.IDEA_FILTER_ID';
    const $1b7b65e9d134100e$export$ef1873c24394b0a7 = 'state.domain.view-settings.filters.ISSUE_TYPES_FILTER_ID';
    const $1b7b65e9d134100e$export$a8ec3260a009d752 = 'state.domain.view-settings.filters.ISSUE_TYPE_KEY_FILTER_ID';
    const $1b7b65e9d134100e$export$b6fe2739dbbe2e5d = 'state.domain.view-settings.filters.ISSUE_PRIORITIES_FILTER_ID';
    const $1b7b65e9d134100e$export$3b798637a628dacc = 'state.domain.view-settings.filters.CUSTOM_FIELD_FILTER_ID';
    const $1b7b65e9d134100e$export$82db1960569473ff = 'state.domain.view-settings.filters.DATE_RANGE_FILTER_ID';
    const $1b7b65e9d134100e$export$f4ac8734c859ca93 = 'roadmap';
    const $1b7b65e9d134100e$export$eb2de919d11696d = 'release';
    const $1b7b65e9d134100e$var$listOfFilterIdsV0 = [
        $1b7b65e9d134100e$export$9ca65f4dca18a9fc,
        $1b7b65e9d134100e$export$c4a2a48e7b94aaa5,
        $1b7b65e9d134100e$export$d0da0a0b0cd817d8,
        $1b7b65e9d134100e$export$585fb3e81bcfccad,
        $1b7b65e9d134100e$export$53e2f8996e102881,
        $1b7b65e9d134100e$export$8abe69ceb26771cd,
        $1b7b65e9d134100e$export$43596ee088b165a,
        $1b7b65e9d134100e$export$20140793a0aa2b3c,
        $1b7b65e9d134100e$export$e32eeae4866f112c,
        $1b7b65e9d134100e$export$a849f806e27a57e8,
        $1b7b65e9d134100e$export$7e257b719377371e,
        $1b7b65e9d134100e$export$9b51ec1115932c53,
        $1b7b65e9d134100e$export$6022538efc28a609,
        $1b7b65e9d134100e$export$59af687b450af7eb,
        $1b7b65e9d134100e$export$46cb1c3e9f7a5fbb,
        $1b7b65e9d134100e$export$a8ec3260a009d752,
        $1b7b65e9d134100e$export$b6fe2739dbbe2e5d,
        $1b7b65e9d134100e$export$3b798637a628dacc,
        $1b7b65e9d134100e$export$861e775e082be75a,
        $1b7b65e9d134100e$export$cffc66ae4b1fddaa,
        $1b7b65e9d134100e$export$82db1960569473ff
    ];
    const $1b7b65e9d134100e$export$42f7b1727a7768ed = $1b7b65e9d134100e$var$listOfFilterIdsV0;
});
parcelRegister("6Ayrn", function(module, exports) {
    $parcel$export(module.exports, "getHierarchy", ()=>$6a552c26f4604bc6$export$9447fd3d4b10cb5f);
    $parcel$export(module.exports, "getHierarchyLevels", ()=>$6a552c26f4604bc6$export$f6802dd3df2c9c9f);
    $parcel$export(module.exports, "getHierarchyLevelsByLevel", ()=>$6a552c26f4604bc6$export$476530a7d255f7a6);
    $parcel$export(module.exports, "getTypeToLevel", ()=>$6a552c26f4604bc6$export$c2a7df7fd3eb5955);
    $parcel$export(module.exports, "getIssueTypeWithLevelById", ()=>$6a552c26f4604bc6$export$9c54f3dd2a3e8b6b);
    $parcel$export(module.exports, "getIssueTypesByLevel", ()=>$6a552c26f4604bc6$export$34839371792557f6);
    $parcel$export(module.exports, "getEnrichedHierarchyLevels", ()=>$6a552c26f4604bc6$export$f82081736949f180);
    $parcel$export(module.exports, "getHierarchyRange", ()=>$6a552c26f4604bc6$export$ce581c08d4a52de0);
    $parcel$export(module.exports, "getHierarchyTitles", ()=>$6a552c26f4604bc6$export$710b1fdedb2df3ad);
    var $fn8B5 = parcelRequire("fn8B5");
    var $4Xk2W = parcelRequire("4Xk2W");
    var $g4tDr;
    var $c12LJ;
    var $3YtPS = parcelRequire("3YtPS");
    var $h0oWC = parcelRequire("h0oWC");
    var $kllqP = parcelRequire("kllqP");
    const $6a552c26f4604bc6$export$9447fd3d4b10cb5f = (state)=>state.domain.hierarchy.levels;
    const $6a552c26f4604bc6$export$746d16b887d46fe3 = (hierarchy)=>{
        const hierarchyLevels = [
            ...hierarchy
        ];
        return hierarchyLevels.sort((a, b)=>b.level - a.level);
    };
    const $6a552c26f4604bc6$export$f6802dd3df2c9c9f = (0, $3YtPS.createSelector)([
        $6a552c26f4604bc6$export$9447fd3d4b10cb5f
    ], $6a552c26f4604bc6$export$746d16b887d46fe3);
    const $6a552c26f4604bc6$export$94fac7b50826b632 = (hierarchy)=>{
        const hierarchyLevels = [
            ...hierarchy
        ];
        return (0, ($parcel$interopDefault($4Xk2W)))(hierarchyLevels, 'level');
    };
    const $6a552c26f4604bc6$export$476530a7d255f7a6 = (0, $3YtPS.createSelector)([
        $6a552c26f4604bc6$export$9447fd3d4b10cb5f
    ], $6a552c26f4604bc6$export$94fac7b50826b632);
    const $6a552c26f4604bc6$export$c2a7df7fd3eb5955 = (0, $3YtPS.createSelector)([
        $6a552c26f4604bc6$export$9447fd3d4b10cb5f,
        (0, $kllqP.getIssueTypes)
    ], (0, $h0oWC.getTypeToLevelPure));
    const $6a552c26f4604bc6$export$5f725a76f1d1e1b2 = (issueTypes, hierarchyLevels)=>{
        const issueTypeIdToLevel = issueTypes.reduce((acc, { id: id, level: level })=>{
            acc[`${id}`] = level;
            return acc;
        }, {});
        hierarchyLevels.forEach(({ level: level, issueTypes: issueTypes = [] })=>{
            issueTypes.forEach((issueTypeId)=>{
                if (issueTypeIdToLevel[issueTypeId] === undefined) issueTypeIdToLevel[issueTypeId] = level;
            });
        });
        return issueTypeIdToLevel;
    };
    const $6a552c26f4604bc6$export$2e66c1118674a4e7 = (0, $3YtPS.createSelector)([
        (0, $kllqP.getIssueTypes),
        $6a552c26f4604bc6$export$9447fd3d4b10cb5f
    ], $6a552c26f4604bc6$export$5f725a76f1d1e1b2);
    const $6a552c26f4604bc6$export$c92a4ded8a03a436 = (issueTypes, issueTypeIdToLevel)=>issueTypes.reduce((acc, { id: id, name: name, iconUrl: iconUrl })=>{
            const level = issueTypeIdToLevel[`${id}`] ?? (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE);
            acc[id] = {
                id: id,
                name: name,
                iconUrl: iconUrl,
                level: level
            };
            return acc;
        }, {});
    const $6a552c26f4604bc6$export$9c54f3dd2a3e8b6b = (0, $3YtPS.createSelector)([
        (0, $kllqP.getIssueTypes),
        $6a552c26f4604bc6$export$2e66c1118674a4e7
    ], $6a552c26f4604bc6$export$c92a4ded8a03a436);
    const $6a552c26f4604bc6$export$384a76490e77fdf = (issueTypes, issueTypeIdToLevel)=>(0, ($parcel$interopDefault($fn8B5)))(issueTypes, (issueType)=>issueTypeIdToLevel[`${issueType.id}`]);
    const $6a552c26f4604bc6$export$34839371792557f6 = (0, $3YtPS.createSelector)([
        (0, $kllqP.getIssueTypes),
        $6a552c26f4604bc6$export$2e66c1118674a4e7
    ], $6a552c26f4604bc6$export$384a76490e77fdf);
    const $6a552c26f4604bc6$export$f82081736949f180 = (0, $3YtPS.createSelector)([
        $6a552c26f4604bc6$export$9447fd3d4b10cb5f,
        (0, $kllqP.getIssueTypes)
    ], (0, $h0oWC.getEnrichedHierarchyLevelsPure));
    const $6a552c26f4604bc6$export$e6655097f86f8d45 = (levels)=>{
        if (levels.length > 0) {
            const hierarchyRangeLevels = levels.map(({ level: level })=>level);
            return {
                max: Math.max(...hierarchyRangeLevels),
                min: Math.min(...hierarchyRangeLevels)
            };
        }
        return {
            max: (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL),
            min: (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)
        };
    };
    const $6a552c26f4604bc6$export$ce581c08d4a52de0 = (0, $3YtPS.createSelector)([
        $6a552c26f4604bc6$export$9447fd3d4b10cb5f
    ], $6a552c26f4604bc6$export$e6655097f86f8d45);
    const $6a552c26f4604bc6$export$47548a2aea415bb0 = (levels)=>levels.reduce((acc, { level: level, title: title })=>{
            acc[level] = title;
            return acc;
        }, {});
    const $6a552c26f4604bc6$export$710b1fdedb2df3ad = (0, $3YtPS.createSelector)([
        $6a552c26f4604bc6$export$9447fd3d4b10cb5f
    ], $6a552c26f4604bc6$export$47548a2aea415bb0);
});
parcelRegister("4Xk2W", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $4CZTG = parcelRequire("4CZTG");
    var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
        $1m3dq(result, key, value);
    });
    module.exports = $39bc38f0156cacc0$var$keyBy;
});
parcelRegister("kllqP", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypes", ()=>$57713b34c7b862af$export$4cf4b24b88599615);
    $parcel$export(module.exports, "getIssueTypesById", ()=>$57713b34c7b862af$export$4c667e9a92bbd1ef);
    $parcel$export(module.exports, "getIssueTypesByName", ()=>$57713b34c7b862af$export$e980f590d46b59b4);
    $parcel$export(module.exports, "getIssueTypesByProjectId", ()=>$57713b34c7b862af$export$2b8ea6367a1048bb);
    $parcel$export(module.exports, "getIssueTypeIds", ()=>$57713b34c7b862af$export$ad4e1aa4d2c7ef98);
    $parcel$export(module.exports, "getIssueTypeIdsOfCompanyManagedProjects", ()=>$57713b34c7b862af$export$c276bc4d7b5b95e1);
    $parcel$export(module.exports, "getTeamManagedProjectByIssueTypeId", ()=>$57713b34c7b862af$export$35747f0693c3c228);
    $parcel$export(module.exports, "getIssueTypesByIdForCompanyManagedProjects", ()=>$57713b34c7b862af$export$c21f9b5f8889e9a6);
    $parcel$export(module.exports, "getIssueTypeIconByKey", ()=>$57713b34c7b862af$export$8696f212ec31e9f7);
    $parcel$export(module.exports, "getIssueTypeIconByName", ()=>$57713b34c7b862af$export$f67c89b26645faf6);
    var $fn8B5 = parcelRequire("fn8B5");
    var $4Rr1a;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $jpXKt = parcelRequire("jpXKt");
    const $57713b34c7b862af$export$4cf4b24b88599615 = (state)=>state.domain.issueTypes;
    const $57713b34c7b862af$export$4c667e9a92bbd1ef = (0, $3YtPS.createSelector)([
        $57713b34c7b862af$export$4cf4b24b88599615
    ], (issueTypes)=>(0, $4nDwW.indexBy)(({ id: id })=>id, issueTypes));
    const $57713b34c7b862af$export$e980f590d46b59b4 = (0, $3YtPS.createSelector)([
        $57713b34c7b862af$export$4cf4b24b88599615
    ], (issueTypes)=>(0, ($parcel$interopDefault($fn8B5)))(issueTypes, ({ name: name })=>name));
    const $57713b34c7b862af$export$2b8ea6367a1048bb = (0, $3YtPS.createSelector)([
        (0, $jpXKt.getProjects),
        $57713b34c7b862af$export$4c667e9a92bbd1ef
    ], (projects, issueTypes)=>Object.fromEntries(projects.map((project)=>[
                project.id,
                project.issueTypeIds.map((id)=>issueTypes[id])
            ])));
    const $57713b34c7b862af$export$ad4e1aa4d2c7ef98 = (0, $3YtPS.createSelector)([
        $57713b34c7b862af$export$4cf4b24b88599615
    ], (issueTypes)=>(0, parcelRequire("4Rr1a")).default(({ id: id })=>id, issueTypes));
    const $57713b34c7b862af$export$2d61f545ccc89c9e = (projects)=>[
            ...new Set((0, $4nDwW.chain)((x)=>x.issueTypeIds, projects))
        ];
    const $57713b34c7b862af$export$c276bc4d7b5b95e1 = (0, $3YtPS.createSelector)([
        (0, $jpXKt.getCompanyManagedProjects)
    ], $57713b34c7b862af$export$2d61f545ccc89c9e);
    const $57713b34c7b862af$export$d31015b408eb24 = (projects)=>projects.reduce((acc, project)=>{
            project.issueTypeIds.forEach((issueTypeId)=>{
                acc[issueTypeId] = project;
            });
            return acc;
        }, {});
    const $57713b34c7b862af$export$35747f0693c3c228 = (0, $3YtPS.createSelector)([
        (0, $jpXKt.getTeamManagedProjects)
    ], $57713b34c7b862af$export$d31015b408eb24);
    const $57713b34c7b862af$export$c21f9b5f8889e9a6 = (0, $3YtPS.createSelector)([
        $57713b34c7b862af$export$4cf4b24b88599615,
        $57713b34c7b862af$export$c276bc4d7b5b95e1
    ], (issueTypes, issueTypeIdsOfCompanyManagedProjects)=>{
        const issueTypesForCompanyManagedProjects = issueTypes.filter((issueType)=>issueTypeIdsOfCompanyManagedProjects.includes(issueType.id));
        return (0, $4nDwW.indexBy)(({ id: id })=>id, issueTypesForCompanyManagedProjects);
    });
    const $57713b34c7b862af$export$2dc055bad16afadb = (issueTypes)=>issueTypes.reduce((acc, { level: level, name: name, iconUrl: iconUrl })=>{
            const currentIconUrl = acc[`${level} ${name}`];
            if (currentIconUrl === undefined || currentIconUrl.localeCompare(iconUrl) === 1) acc[`${level} ${name}`] = iconUrl;
            return acc;
        }, {});
    const $57713b34c7b862af$export$8696f212ec31e9f7 = (0, $3YtPS.createSelector)([
        $57713b34c7b862af$export$4cf4b24b88599615
    ], $57713b34c7b862af$export$2dc055bad16afadb);
    const $57713b34c7b862af$export$a9ecc8e21e9a38b0 = (issueTypes)=>{
        const issueTypeLevelAndIconByName = issueTypes.reduce((acc, { level: level, name: name, iconUrl: iconUrl })=>{
            const currentLevelAndIconUrl = acc[name];
            if (currentLevelAndIconUrl === undefined || level >= currentLevelAndIconUrl.level && currentLevelAndIconUrl.iconUrl.localeCompare(iconUrl) === 1) acc[name] = {
                level: level,
                iconUrl: iconUrl
            };
            return acc;
        }, {});
        return Object.entries(issueTypeLevelAndIconByName).reduce((acc, [name, { iconUrl: iconUrl }])=>{
            acc[name] = iconUrl;
            return acc;
        }, {});
    };
    const $57713b34c7b862af$export$f67c89b26645faf6 = (0, $3YtPS.createSelector)([
        $57713b34c7b862af$export$4cf4b24b88599615
    ], $57713b34c7b862af$export$a9ecc8e21e9a38b0);
});
parcelRegister("jpXKt", function(module, exports) {
    $parcel$export(module.exports, "getProjects", ()=>$48b373b0b8df480c$export$b00a271f69f3d728);
    $parcel$export(module.exports, "getProjectsById", ()=>$48b373b0b8df480c$export$c1c858cbec61800c);
    $parcel$export(module.exports, "getCompanyManagedProjects", ()=>$48b373b0b8df480c$export$bb44f8d3716d4f81);
    $parcel$export(module.exports, "getTeamManagedProjects", ()=>$48b373b0b8df480c$export$16d1d0520626b714);
    $parcel$export(module.exports, "getTeamManagedProjectsSortedByName", ()=>$48b373b0b8df480c$export$f3912c620acff892);
    $parcel$export(module.exports, "getIsSimplifiedProjectAvailable", ()=>$48b373b0b8df480c$export$18a4e9a6f18c938b);
    $parcel$export(module.exports, "getDefaultProjectId", ()=>$48b373b0b8df480c$export$ac9e364a395b5304);
    $parcel$export(module.exports, "getIssuePriorityIdsByProjectId", ()=>$48b373b0b8df480c$export$327c22d922f3f070);
    $parcel$export(module.exports, "getDefaultIssuePriorityByProjectId", ()=>$48b373b0b8df480c$export$3b205f854fdaea78);
    $parcel$export(module.exports, "getReleasesDisabledProject", ()=>$48b373b0b8df480c$export$1f93e90bc93b7dd3);
    $parcel$export(module.exports, "getIssueTypesByProjectId", ()=>$48b373b0b8df480c$export$2b8ea6367a1048bb);
    var $8BDMi;
    var $jVZZA;
    var $9U6ZH;
    var $2rMKg;
    var $sqeVT;
    var $7Zjd1;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    const $48b373b0b8df480c$export$b00a271f69f3d728 = (state)=>state.domain.projects;
    const $48b373b0b8df480c$export$c1c858cbec61800c = (0, $3YtPS.createSelector)([
        $48b373b0b8df480c$export$b00a271f69f3d728
    ], (projects)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), projects));
    const $48b373b0b8df480c$export$bb44f8d3716d4f81 = (0, $3YtPS.createSelector)([
        $48b373b0b8df480c$export$b00a271f69f3d728
    ], (0, parcelRequire("jVZZA")).default(({ isSimplified: isSimplified })=>!isSimplified));
    const $48b373b0b8df480c$export$16d1d0520626b714 = (0, $3YtPS.createSelector)([
        $48b373b0b8df480c$export$b00a271f69f3d728
    ], (0, parcelRequire("jVZZA")).default(({ isSimplified: isSimplified })=>isSimplified));
    const $48b373b0b8df480c$export$f3912c620acff892 = (0, $3YtPS.createSelector)([
        $48b373b0b8df480c$export$16d1d0520626b714
    ], (0, parcelRequire("7Zjd1")).default((a, b)=>a.name.localeCompare(b.name)));
    const $48b373b0b8df480c$export$18a4e9a6f18c938b = (0, $3YtPS.createSelector)([
        $48b373b0b8df480c$export$b00a271f69f3d728
    ], (0, parcelRequire("8BDMi")).default((0, parcelRequire("2rMKg")).default('isSimplified')));
    const $48b373b0b8df480c$var$getDefaultProjectIdPure = (projects)=>{
        const defaultProject = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('isDefault', true))(projects) || {
            id: undefined
        };
        return defaultProject.id;
    };
    const $48b373b0b8df480c$export$ac9e364a395b5304 = (0, $3YtPS.createSelector)([
        $48b373b0b8df480c$export$b00a271f69f3d728
    ], $48b373b0b8df480c$var$getDefaultProjectIdPure);
    const $48b373b0b8df480c$export$1b195f62369b1585 = (projects)=>projects.reduce((acc, project)=>Object.assign(acc, {
                [project.id]: project.issuePriorityIds
            }), {});
    const $48b373b0b8df480c$export$327c22d922f3f070 = (0, $3YtPS.createSelector)([
        $48b373b0b8df480c$export$b00a271f69f3d728
    ], $48b373b0b8df480c$export$1b195f62369b1585);
    const $48b373b0b8df480c$export$bcff2c2aa178e37a = (projects)=>projects.reduce((acc, project)=>Object.assign(acc, {
                [project.id]: project.defaultIssuePriorityId
            }), {});
    const $48b373b0b8df480c$export$3b205f854fdaea78 = (0, $3YtPS.createSelector)([
        $48b373b0b8df480c$export$b00a271f69f3d728
    ], $48b373b0b8df480c$export$bcff2c2aa178e37a);
    const $48b373b0b8df480c$export$1f93e90bc93b7dd3 = (0, $3YtPS.createSelector)([
        $48b373b0b8df480c$export$b00a271f69f3d728
    ], (0, parcelRequire("jVZZA")).default(({ isReleasesEnabled: isReleasesEnabled })=>!isReleasesEnabled));
    const $48b373b0b8df480c$export$2b8ea6367a1048bb = (0, $3YtPS.createSelector)([
        $48b373b0b8df480c$export$c1c858cbec61800c
    ], (projectsById)=>(projectId)=>{
            return projectsById[projectId]?.issueTypeIds;
        });
});
parcelRegister("8BDMi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6440a283b44591bf$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5DTpU;
    var $5cpIR;
    var $6440a283b44591bf$var$any = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("5DTpU")).default)([
        'any'
    ], (0, (0, parcelRequire("5cpIR")).default), function any(fn, list) {
        var idx = 0;
        while(idx < list.length){
            if (fn(list[idx])) return true;
            idx += 1;
        }
        return false;
    }));
    var $6440a283b44591bf$export$2e2bcd8739ae039 = $6440a283b44591bf$var$any;
});
parcelRegister("5cpIR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c9206b1baa55d84$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7C2oN;
    var $7D5kn;
    var $3c9206b1baa55d84$var$XAny = function() {
        function XAny(f, xf) {
            this.xf = xf;
            this.f = f;
            this.any = false;
        }
        XAny.prototype['@@transducer/init'] = (0, (0, parcelRequire("7D5kn")).default).init;
        XAny.prototype['@@transducer/result'] = function(result) {
            if (!this.any) result = this.xf['@@transducer/step'](result, false);
            return this.xf['@@transducer/result'](result);
        };
        XAny.prototype['@@transducer/step'] = function(result, input) {
            if (this.f(input)) {
                this.any = true;
                result = (0, (0, parcelRequire("7C2oN")).default)(this.xf['@@transducer/step'](result, true));
            }
            return result;
        };
        return XAny;
    }();
    var $3c9206b1baa55d84$var$_xany = (0, (0, parcelRequire("c9RLn")).default)(function _xany(f, xf) {
        return new $3c9206b1baa55d84$var$XAny(f, xf);
    });
    var $3c9206b1baa55d84$export$2e2bcd8739ae039 = $3c9206b1baa55d84$var$_xany;
});
parcelRegister("7C2oN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58adf1609bf84ffd$export$2e2bcd8739ae039);
    function $58adf1609bf84ffd$export$2e2bcd8739ae039(x) {
        return x && x['@@transducer/reduced'] ? x : {
            '@@transducer/value': x,
            '@@transducer/reduced': true
        };
    }
});
parcelRegister("9U6ZH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$735ec4e3e7edd683$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5DTpU;
    var $daKqn;
    var $735ec4e3e7edd683$var$find = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("5DTpU")).default)([
        'find'
    ], (0, (0, parcelRequire("daKqn")).default), function find(fn, list) {
        var idx = 0;
        var len = list.length;
        while(idx < len){
            if (fn(list[idx])) return list[idx];
            idx += 1;
        }
    }));
    var $735ec4e3e7edd683$export$2e2bcd8739ae039 = $735ec4e3e7edd683$var$find;
});
parcelRegister("daKqn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$997038726937a0a5$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7C2oN;
    var $7D5kn;
    var $997038726937a0a5$var$XFind = function() {
        function XFind(f, xf) {
            this.xf = xf;
            this.f = f;
            this.found = false;
        }
        XFind.prototype['@@transducer/init'] = (0, (0, parcelRequire("7D5kn")).default).init;
        XFind.prototype['@@transducer/result'] = function(result) {
            if (!this.found) result = this.xf['@@transducer/step'](result, void 0);
            return this.xf['@@transducer/result'](result);
        };
        XFind.prototype['@@transducer/step'] = function(result, input) {
            if (this.f(input)) {
                this.found = true;
                result = (0, (0, parcelRequire("7C2oN")).default)(this.xf['@@transducer/step'](result, input));
            }
            return result;
        };
        return XFind;
    }();
    var $997038726937a0a5$var$_xfind = (0, (0, parcelRequire("c9RLn")).default)(function _xfind(f, xf) {
        return new $997038726937a0a5$var$XFind(f, xf);
    });
    var $997038726937a0a5$export$2e2bcd8739ae039 = $997038726937a0a5$var$_xfind;
});
parcelRegister("7Zjd1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d0d216f35c69ef1$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5d0d216f35c69ef1$var$sort = (0, (0, parcelRequire("c9RLn")).default)(function sort(comparator, list) {
        return Array.prototype.slice.call(list, 0).sort(comparator);
    });
    var $5d0d216f35c69ef1$export$2e2bcd8739ae039 = $5d0d216f35c69ef1$var$sort;
});
parcelRegister("bI9dZ", function(module, exports) {
    $parcel$export(module.exports, "getAllSortedIssues", ()=>$29fc238df01a2d37$export$7c3a06b6c8e04cb6);
    $parcel$export(module.exports, "getIsIssuesLoading", ()=>$29fc238df01a2d37$export$43a88fed19edd69);
    $parcel$export(module.exports, "getIssuesByLevel", ()=>$29fc238df01a2d37$export$6c7f4547348bb8cc);
    $parcel$export(module.exports, "getOriginalIssues", ()=>$29fc238df01a2d37$export$78e865af1b622bce);
    $parcel$export(module.exports, "getAncestors", ()=>$29fc238df01a2d37$export$c6fd3ab3f44300d0);
    $parcel$export(module.exports, "getDescendantIdsByParent", ()=>$29fc238df01a2d37$export$10cf9ac9d0b5c754);
    $parcel$export(module.exports, "getIssueFilterMatcher", ()=>$29fc238df01a2d37$export$1f42b2c834376f59);
    $parcel$export(module.exports, "getFilteredIssues", ()=>$29fc238df01a2d37$export$637f6f4447a6cb4);
    $parcel$export(module.exports, "getIssueFilterMatcherWithFilterId", ()=>$29fc238df01a2d37$export$81a180583deb97be);
    $parcel$export(module.exports, "getParentAndDescendant", ()=>$29fc238df01a2d37$export$eb2109d2e87ee1e2);
    $parcel$export(module.exports, "getWholeHierarchyParentAndDescendant", ()=>$29fc238df01a2d37$export$22b9a03ec1eb8dd6);
    $parcel$export(module.exports, "getFilteredIssuesWithHierarchy", ()=>$29fc238df01a2d37$export$82c01ac68f22904d);
    $parcel$export(module.exports, "getFilteredIssuesWithHierarchyById", ()=>$29fc238df01a2d37$export$28e54faad0065b6f);
    $parcel$export(module.exports, "getIssueChangesMetaData", ()=>$29fc238df01a2d37$export$fa48bdc11248955a);
    $parcel$export(module.exports, "getIssueChangesData", ()=>$29fc238df01a2d37$export$c913ecfe262dc703);
    $parcel$export(module.exports, "getChangedAttributes", ()=>$29fc238df01a2d37$export$3c13bed81ee9bbc8);
    $parcel$export(module.exports, "getIssueChanges", ()=>$29fc238df01a2d37$export$a6de124506edd2c9);
    $parcel$export(module.exports, "getIssueChangesWithChangedLinks", ()=>$29fc238df01a2d37$export$f951d26970afc90);
    $parcel$export(module.exports, "getIssueAttributeChangeCounts", ()=>$29fc238df01a2d37$export$e46b31cf3437f90c);
    $parcel$export(module.exports, "getCreatedIssueCount", ()=>$29fc238df01a2d37$export$43f0babde21e402);
    $parcel$export(module.exports, "getIssueChangeCount", ()=>$29fc238df01a2d37$export$de1b72009d6b1dfc);
    $parcel$export(module.exports, "getIssueChangesWithChangedLinksCount", ()=>$29fc238df01a2d37$export$eea625218b940c41);
    $parcel$export(module.exports, "getInitialFilterValues", ()=>$29fc238df01a2d37$export$63f0253ea18e1b2b);
    $parcel$export(module.exports, "getIssuesByVersionMap", ()=>$29fc238df01a2d37$export$615c37ad4901bd5c);
    $parcel$export(module.exports, "getHistoryIssues", ()=>$29fc238df01a2d37$export$65ea2b70e1e8b23d);
    $parcel$export(module.exports, "isLoadingHistory", ()=>$29fc238df01a2d37$export$bb6e9f1f80fa26a);
    $parcel$export(module.exports, "isSavingIssue", ()=>$29fc238df01a2d37$export$570537f670c4986d);
    $parcel$export(module.exports, "getSelected", ()=>$29fc238df01a2d37$export$f9f1f4119b3df74);
    $parcel$export(module.exports, "getSelectedIssues", ()=>$29fc238df01a2d37$export$5e52d79ee962d3c1);
    $parcel$export(module.exports, "getSelectedIssuesByProjectId", ()=>$29fc238df01a2d37$export$584afdbe1174e39e);
    $parcel$export(module.exports, "getCPRsForSelectedIssues", ()=>$29fc238df01a2d37$export$adefbe0a9c7ccb6a);
    $parcel$export(module.exports, "toApiIssue", ()=>$29fc238df01a2d37$export$d4820931b5475426);
    $parcel$export(module.exports, "getIssues", ()=>(parcelRequire("gFhwb")).getIssues);
    $parcel$export(module.exports, "getIssueMapById", ()=>(parcelRequire("gFhwb")).getIssueMapById);
    $parcel$export(module.exports, "getDescendants", ()=>(parcelRequire("4sJY8")).getDescendants);
    $parcel$export(module.exports, "getChildrenIdsByParent", ()=>(parcelRequire("4sJY8")).getChildrenIdsByParent);
    var $9XE6b = parcelRequire("9XE6b");
    var $6Kx1w = parcelRequire("6Kx1w");
    var $h2uoz;
    var $8Tt2N;
    var $cDeeP;
    var $dl2NH;
    var $8EB5I;
    var $jVZZA;
    var $4wiYB;
    var $2JlG5;
    var $4DrGU;
    var $iavfW;
    var $fZhYM;
    var $2rMKg;
    var $7p8Aa;
    var $5TQ3w;
    var $thm1N;
    var $cDmJv;
    var $dJl1T;
    var $c12LJ;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cGbfF = parcelRequire("cGbfF");
    var $1CGdp = parcelRequire("1CGdp");
    var $19iju = parcelRequire("19iju");
    var $gl667 = parcelRequire("gl667");
    var $iIikD = parcelRequire("iIikD");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $ddv1K = parcelRequire("ddv1K");
    var $bHTqr = parcelRequire("bHTqr");
    var $gFhwb = parcelRequire("gFhwb");
    var $4sJY8 = parcelRequire("4sJY8");
    var $ja8Lc = parcelRequire("ja8Lc");
    var $9FFuD = parcelRequire("9FFuD");
    var $gFhwb = parcelRequire("gFhwb");
    var $4sJY8 = parcelRequire("4sJY8");
    const $29fc238df01a2d37$export$eb0a0f4026d4f504 = (issues, sort)=>sort(issues);
    const $29fc238df01a2d37$export$7c3a06b6c8e04cb6 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getAllIssues),
        (0, $ja8Lc.getSort)
    ], $29fc238df01a2d37$export$eb0a0f4026d4f504);
    const $29fc238df01a2d37$export$43a88fed19edd69 = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Issues.isLoading;
    const $29fc238df01a2d37$export$6c7f4547348bb8cc = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssues),
        (state, targetLevel)=>targetLevel
    ], (issues, targetLevel)=>issues.filter(({ level: level })=>level === targetLevel));
    const $29fc238df01a2d37$export$78e865af1b622bce = (state)=>state.domain.originalIssues;
    const $29fc238df01a2d37$export$c6fd3ab3f44300d0 = (issue, issueMap, maxAncestorLevel)=>{
        const ancestorsIds = [];
        const ancestors = [];
        let currentIssue = issue;
        while(currentIssue && currentIssue.level < maxAncestorLevel && currentIssue.parent){
            currentIssue = issueMap[currentIssue.parent];
            if (!currentIssue) break;
            if (ancestorsIds.includes(currentIssue.id)) break;
            ancestorsIds.push(currentIssue.id);
            ancestors.push(currentIssue);
        }
        return ancestors;
    };
    const $29fc238df01a2d37$export$10cf9ac9d0b5c754 = (0, $3YtPS.createSelector)([
        (0, $4sJY8.getDescendantsByParent)
    ], (0, $4nDwW.mapGroupsToIds));
    const $29fc238df01a2d37$export$3f223538464739b6 = (filters, optimizedMode, customFields)=>(issue, options)=>{
            return (0, $iIikD.matchFilter)(filters, optimizedMode, customFields, issue, {
                ...options,
                exclude: options?.exclude?.concat((0, $cGbfF.HIERARCHY_FILTER_ID)) || [
                    (0, $cGbfF.HIERARCHY_FILTER_ID)
                ]
            });
        };
    const $29fc238df01a2d37$export$1f42b2c834376f59 = (0, $3YtPS.createSelector)([
        (0, $iIikD.getFilters),
        (0, $1CGdp.isOptimizedMode),
        (0, $19iju.getCustomFields)
    ], $29fc238df01a2d37$export$3f223538464739b6);
    const $29fc238df01a2d37$export$19412d4e3ba084c2 = (issues, issueFilterMatcher)=>(0, parcelRequire("jVZZA")).default(issueFilterMatcher)(issues);
    const $29fc238df01a2d37$export$637f6f4447a6cb4 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssues),
        $29fc238df01a2d37$export$1f42b2c834376f59
    ], $29fc238df01a2d37$export$19412d4e3ba084c2);
    const $29fc238df01a2d37$export$81a180583deb97be = (0, $3YtPS.createSelector)([
        (0, $iIikD.getFilters),
        (0, $1CGdp.isOptimizedMode),
        (0, $19iju.getCustomFields)
    ], (filters, optimizedMode, customFields)=>(issue)=>(0, $iIikD.getUnmatchedFiltersList)(filters, optimizedMode, customFields, issue));
    const $29fc238df01a2d37$export$5de7d1d2af779977 = (filteredIssues, { start: start, end: end }, issueMap, descendantsMap)=>{
        const resultMap = {};
        for (const filteredIssue of filteredIssues)resultMap[filteredIssue.id] = {
            ancestors: $29fc238df01a2d37$export$c6fd3ab3f44300d0(filteredIssue, issueMap, start),
            descendants: (0, $4sJY8.getDescendants)(filteredIssue, issueMap, descendantsMap, end)
        };
        return resultMap;
    };
    const $29fc238df01a2d37$export$eb2109d2e87ee1e2 = (0, $3YtPS.createSelector)([
        $29fc238df01a2d37$export$637f6f4447a6cb4,
        (0, $iIikD.getFilters),
        (0, $gFhwb.getIssueMapById),
        (0, $4sJY8.getChildrenIdsByParent)
    ], (filteredIssues, filters, issueMap, descendantsMap)=>$29fc238df01a2d37$export$5de7d1d2af779977(filteredIssues, {
            start: filters[0, $cGbfF.HIERARCHY_RANGE_FILTER_ID].value.start,
            end: filters[0, $cGbfF.HIERARCHY_RANGE_FILTER_ID].value.end
        }, issueMap, descendantsMap));
    const $29fc238df01a2d37$export$22b9a03ec1eb8dd6 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getAllIssues),
        (0, $6Ayrn.getHierarchyRange),
        (0, $gFhwb.getIssueMapById),
        (0, $4sJY8.getChildrenIdsByParent)
    ], (issues, { max: start, min: end }, issueMap, descendantsMap)=>$29fc238df01a2d37$export$5de7d1d2af779977(issues, {
            start: start,
            end: end
        }, issueMap, descendantsMap));
    const $29fc238df01a2d37$export$a679b46e98507a98 = (flatIssues, ancestorsAndDescendants, showFullHierarchy)=>(0, $gl667.applyOption)(flatIssues, ancestorsAndDescendants, showFullHierarchy);
    const $29fc238df01a2d37$export$82c01ac68f22904d = (0, $3YtPS.createSelector)([
        $29fc238df01a2d37$export$637f6f4447a6cb4,
        $29fc238df01a2d37$export$eb2109d2e87ee1e2,
        (0, $gl667.getShowFullHierarchy)
    ], $29fc238df01a2d37$export$a679b46e98507a98);
    const $29fc238df01a2d37$export$28e54faad0065b6f = (0, $3YtPS.createSelector)([
        $29fc238df01a2d37$export$82c01ac68f22904d
    ], (filteredIssuesWithHierarchy)=>(0, parcelRequire("4DrGU")).default((0, parcelRequire("2rMKg")).default('id'), filteredIssuesWithHierarchy));
    const $29fc238df01a2d37$export$fa48bdc11248955a = (state)=>(0, parcelRequire("fZhYM")).default([
            'domain',
            'updateJira',
            'changes',
            'data',
            'metaData',
            'issues'
        ], state) || {};
    const $29fc238df01a2d37$export$c913ecfe262dc703 = (state)=>{
        const issues = (0, $gFhwb.getIssueMapById)(state);
        const changes = (0, parcelRequire("fZhYM")).default([
            'domain',
            'updateJira',
            'changes',
            'data',
            'issues'
        ], state) || [];
        return changes.map((change)=>{
            const issue = issues[change.id];
            if (!(0, $4nDwW.isDefined)(issue) || !(0, $4nDwW.isDefined)(change.values)) return change;
            const isSameParent = (0, parcelRequire("dl2NH")).default('parent', issue, change.values);
            return isSameParent ? change : (0, parcelRequire("h2uoz")).default([
                'values',
                'parent'
            ], issue.parent, change);
        });
    };
    const $29fc238df01a2d37$export$2cdbb6213e588813 = (issue, attributeName)=>{
        if (!(0, parcelRequire("2JlG5")).default(attributeName)(issue.originals)) return issue;
        const originalItems = issue.originals[attributeName] || [];
        const valueItems = issue.values[attributeName] || [];
        const addedItems = (0, parcelRequire("cDeeP")).default(valueItems, originalItems);
        const removedItems = (0, parcelRequire("cDeeP")).default(originalItems, valueItems);
        const haveAddedItems = addedItems.length > 0;
        const haveRemovedItems = removedItems.length > 0;
        if (!haveAddedItems && !haveRemovedItems) return issue;
        if (haveAddedItems || haveRemovedItems) {
            delete issue.values[attributeName];
            delete issue.originals[attributeName];
        }
        const capitalize = (0, parcelRequire("5TQ3w")).default(/^./, (0, parcelRequire("cDmJv")).default);
        const addedAttributeName = `added${capitalize(attributeName)}`;
        const removedAttributeName = `removed${capitalize(attributeName)}`;
        return {
            ...issue,
            originals: {
                ...issue.originals,
                ...haveAddedItems ? {
                    [addedAttributeName]: []
                } : {},
                ...haveRemovedItems ? {
                    [removedAttributeName]: []
                } : {}
            },
            values: {
                ...issue.values,
                ...haveAddedItems ? {
                    [addedAttributeName]: addedItems
                } : {},
                ...haveRemovedItems ? {
                    [removedAttributeName]: removedItems
                } : {}
            }
        };
    };
    const $29fc238df01a2d37$export$4998ea759a3625dd = (issue, customFields, scenarioType)=>{
        const multiSelectFields = (0, $19iju.getCustomFieldsByKey)((0, $TTKUQ.CustomFieldTypes).MultiSelect, customFields);
        multiSelectFields.forEach(({ id: multiSelectField })=>{
            if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED && (0, parcelRequire("2JlG5")).default(multiSelectField.toString())(issue.values.customFields || {}) || issue.originals.customFields && (0, parcelRequire("2JlG5")).default(multiSelectField.toString())(issue.originals.customFields || {})) {
                const originalItems = issue.originals.customFields && issue.originals.customFields[multiSelectField] || [];
                const valueItems = issue.values.customFields && issue.values.customFields[multiSelectField] || [];
                const addedItems = (0, parcelRequire("cDeeP")).default(valueItems, originalItems);
                const removedItems = (0, parcelRequire("cDeeP")).default(originalItems, valueItems);
                const haveAddedItems = addedItems.length > 0;
                const haveRemovedItems = removedItems.length > 0;
                if (haveAddedItems) {
                    issue.values[`customFieldValueAdded-${multiSelectField}`] = {
                        id: multiSelectField,
                        typeKey: (0, $TTKUQ.CustomFieldTypes).MultiSelect,
                        value: addedItems
                    };
                    issue.originals[`customFieldValueAdded-${multiSelectField}`] = {
                        id: multiSelectField,
                        typeKey: (0, $TTKUQ.CustomFieldTypes).MultiSelect,
                        value: []
                    };
                }
                if (haveRemovedItems) {
                    issue.values[`customFieldValueRemoved-${multiSelectField}`] = {
                        id: multiSelectField,
                        typeKey: (0, $TTKUQ.CustomFieldTypes).MultiSelect,
                        value: removedItems
                    };
                    issue.originals[`customFieldValueRemoved-${multiSelectField}`] = {
                        id: multiSelectField,
                        typeKey: (0, $TTKUQ.CustomFieldTypes).MultiSelect,
                        value: []
                    };
                }
                if (!haveRemovedItems && !haveAddedItems) {
                    issue.values[`customField-${multiSelectField}`] = {
                        id: multiSelectField,
                        typeKey: (0, $TTKUQ.CustomFieldTypes).MultiSelect,
                        value: valueItems?.length > 0 ? valueItems : undefined
                    };
                    issue.originals[`customField-${multiSelectField}`] = {
                        id: multiSelectField,
                        typeKey: (0, $TTKUQ.CustomFieldTypes).MultiSelect,
                        value: originalItems?.length > 0 ? originalItems : undefined
                    };
                }
            }
        });
        const filterMultiSelectCustomFields = (customFieldsValues)=>Object.entries(customFieldsValues).filter(([fieldId])=>{
                const customField = (0, $19iju.getCustomFieldById)(Number(fieldId), customFields)[0];
                return !customField || customField && customField.type.key !== (0, $TTKUQ.CustomFieldTypes).MultiSelect;
            });
        const getCustomFieldTypeKey = (fieldId)=>{
            const customField = (0, $19iju.getCustomFieldById)(Number(fieldId), customFields)[0];
            return customField && customField.type ? customField.type.key : undefined;
        };
        if (issue.values.customFields) {
            filterMultiSelectCustomFields(issue.values.customFields).forEach(([fieldId, value])=>{
                issue.values[`customField-${fieldId}`] = {
                    id: fieldId,
                    value: value,
                    typeKey: getCustomFieldTypeKey(fieldId)
                };
            });
            delete issue.values.customFields;
        }
        if (issue.originals.customFields) {
            filterMultiSelectCustomFields(issue.originals.customFields).forEach(([fieldId, value])=>{
                issue.originals[`customField-${fieldId}`] = {
                    id: fieldId,
                    value: value,
                    typeKey: getCustomFieldTypeKey(fieldId)
                };
            });
            delete issue.originals.customFields;
        }
        return issue;
    };
    const $29fc238df01a2d37$export$3c13bed81ee9bbc8 = ({ values: values, originals: originals }, scenarioType)=>{
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED) {
            const { summary: summary, lexoRank: lexoRank, project: project, type: type, color: color, ...remainingValues } = values;
            return Object.keys(remainingValues);
        }
        return Object.keys(originals);
    };
    const $29fc238df01a2d37$export$7208ce03e8a0ca7d = (valueObject, plan)=>{
        const { planningUnit: planningUnit } = plan;
        const attributes = Object.keys(valueObject);
        const { completedSprints: completedSprints, ...values } = valueObject;
        const valuesToRemove = [];
        if (attributes.includes('storyPoints') && (planningUnit === (0, $TTKUQ.PlanningUnits).hours || planningUnit === (0, $TTKUQ.PlanningUnits).days)) valuesToRemove.push('storyPoints');
        if (attributes.includes('timeEstimate') && planningUnit === (0, $TTKUQ.PlanningUnits).storyPoints) valuesToRemove.push('timeEstimate');
        if (attributes.includes('theme')) valuesToRemove.push('theme');
        if (attributes.includes('distribution')) valuesToRemove.push('distribution');
        return (0, parcelRequire("iavfW")).default(valuesToRemove, values);
    };
    const $29fc238df01a2d37$export$8372f47f7c4a2a9 = (changedAttributes, scenarioType)=>{
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED || changedAttributes.length !== 1) return;
        const attributeName = changedAttributes[0];
        return attributeName;
    };
    const $29fc238df01a2d37$export$6038614360f9e2c3 = ({ domain: { updateJira: { warnings: warnings } } })=>warnings[(0, $TTKUQ.ENTITY).ISSUE];
    const $29fc238df01a2d37$export$153214b5bd108ed3 = ({ domain: { updateJira: { changesWarnings: changesWarnings } } })=>changesWarnings[(0, $TTKUQ.ENTITY).ISSUE];
    const $29fc238df01a2d37$var$getIssueChangesWithLinks = (planInfo, issue, metaData, warnings = [], issueLinks = [], issueLinksMetaData, customFields)=>{
        const scenarioType = metaData.scenarioType;
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED) issue.values = $29fc238df01a2d37$export$7208ce03e8a0ca7d(issue.values, planInfo);
        else issue.originals = $29fc238df01a2d37$export$7208ce03e8a0ca7d(issue.originals, planInfo);
        for (const link of issueLinks){
            const { itemKey: itemKey, scenarioType: scenarioType } = link;
            const linkMeta = issueLinksMetaData[itemKey];
            if (linkMeta.lastChangeTimestamp > metaData.lastChangeTimestamp) {
                metaData.lastChangeTimestamp = linkMeta.lastChangeTimestamp;
                metaData.lastChangeUser = linkMeta.lastChangeUser;
            }
            const attributeName = `issueLink-${itemKey}`;
            switch(scenarioType){
                case (0, $TTKUQ.SCENARIO_TYPE).ADDED:
                    issue.values[attributeName] = link;
                    issue.originals[attributeName] = null;
                    break;
                case (0, $TTKUQ.SCENARIO_TYPE).DELETED:
                    issue.values[attributeName] = null;
                    issue.originals[attributeName] = link;
                    break;
                default:
                    throw new Error(`Unexpected issue link scenarioType: ${scenarioType}`);
            }
        }
        const issueWithComponentsChange = $29fc238df01a2d37$export$2cdbb6213e588813(issue, 'components');
        const issueWithLabelsChange = $29fc238df01a2d37$export$2cdbb6213e588813(issueWithComponentsChange, 'labels');
        const issueWithCustomFieldChanges = $29fc238df01a2d37$export$4998ea759a3625dd(issueWithLabelsChange, customFields, scenarioType);
        const changedAttributes = $29fc238df01a2d37$export$3c13bed81ee9bbc8(issueWithCustomFieldChanges, scenarioType);
        return {
            id: issueWithCustomFieldChanges.id,
            category: (0, $TTKUQ.ENTITY).ISSUE,
            metaData: metaData,
            changeCount: changedAttributes.length,
            warnings: warnings,
            attributeName: $29fc238df01a2d37$export$8372f47f7c4a2a9(changedAttributes, scenarioType),
            details: issueWithCustomFieldChanges
        };
    };
    const $29fc238df01a2d37$export$577045878cf2f430 = (planInfo, issues = [], entityMetaData, warnings, issueLinks, issueLinksMetaData, changesWarnings, customFields)=>{
        const issueChangeDataByIdMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), issues);
        const changes = (0, $4nDwW.filterMap)((id)=>(0, $4nDwW.isDefined)(issueChangeDataByIdMap[id]), (id)=>{
            const issue = issueChangeDataByIdMap[id];
            const metaData = entityMetaData[id];
            return $29fc238df01a2d37$var$getIssueChangesWithLinks(planInfo, {
                ...issue
            }, {
                ...metaData
            }, [
                ...changesWarnings[id] || [],
                ...warnings[id] || []
            ], issueLinks[id], issueLinksMetaData, customFields);
        }, Object.keys(entityMetaData));
        const issueLinkOnlyChanges = (0, $4nDwW.filterMap)((id)=>!(0, $4nDwW.isDefined)(entityMetaData[id]) && (0, $4nDwW.isDefined)(issueChangeDataByIdMap[id]), (id)=>{
            const issue = issueChangeDataByIdMap[id];
            const metaData = {
                lastChangeTimestamp: 0,
                lastChangeUser: 'unassigned',
                scenarioType: (0, $TTKUQ.SCENARIO_TYPE).UPDATED
            };
            return $29fc238df01a2d37$var$getIssueChangesWithLinks(planInfo, {
                ...issue
            }, metaData, [
                ...changesWarnings[id] || [],
                ...warnings[id] || []
            ], issueLinks[id], issueLinksMetaData, customFields);
        }, Object.keys(issueLinks));
        return changes.concat(issueLinkOnlyChanges).filter(({ metaData: { scenarioType: scenarioType }, details: { originals: originals } })=>scenarioType === (0, $TTKUQ.SCENARIO_TYPE).UPDATED && Object.keys(originals).length > 0 || scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED || scenarioType === (0, $TTKUQ.SCENARIO_TYPE).DELETED);
    };
    const $29fc238df01a2d37$export$a6de124506edd2c9 = (0, $3YtPS.createSelector)([
        (0, $bHTqr.getPlan),
        $29fc238df01a2d37$export$c913ecfe262dc703,
        $29fc238df01a2d37$export$fa48bdc11248955a,
        $29fc238df01a2d37$export$6038614360f9e2c3,
        (0, $ddv1K.getIssueLinkChangesData),
        (0, $ddv1K.getIssueLinkChangesMetaData),
        $29fc238df01a2d37$export$153214b5bd108ed3,
        (0, $19iju.getCustomFields)
    ], $29fc238df01a2d37$export$577045878cf2f430);
    const $29fc238df01a2d37$export$ad6b984a9b918985 = (issueChanges)=>issueChanges.filter((change)=>{
            const changedAttributes = Object.keys(change.details.originals);
            return changedAttributes.some((attribute)=>attribute.match(/^issueLink-/));
        });
    const $29fc238df01a2d37$export$f951d26970afc90 = (0, $3YtPS.createSelector)([
        $29fc238df01a2d37$export$a6de124506edd2c9
    ], $29fc238df01a2d37$export$ad6b984a9b918985);
    const $29fc238df01a2d37$export$f853033d86d5092a = (issueChanges)=>{
        const customFieldChangeKey = /^customField-\d+$/;
        const simplifyAttributeList = (attributes)=>{
            const multiValueFields = [
                [
                    'labels',
                    [
                        'addedLabels',
                        'removedLabels'
                    ]
                ],
                [
                    'components',
                    [
                        'addedComponents',
                        'removedComponents'
                    ]
                ]
            ];
            let simplifiedAttributes = attributes.map((attribute)=>attribute.match(customFieldChangeKey) ? 'customField' : attribute);
            multiValueFields.forEach(([key, fields])=>{
                if (fields.some((field)=>simplifiedAttributes.includes(field))) {
                    simplifiedAttributes = simplifiedAttributes.filter((attribute)=>!fields.includes(attribute));
                    simplifiedAttributes.push(key);
                }
            });
            return simplifiedAttributes;
        };
        return issueChanges.filter((issue)=>issue.metaData.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).UPDATED).map((issue)=>$29fc238df01a2d37$export$3c13bed81ee9bbc8(issue.details, issue.metaData.scenarioType)).reduce((attributeCounts, changedAttributes)=>{
            const simplifiedChangedAttributes = simplifyAttributeList(changedAttributes);
            simplifiedChangedAttributes.forEach((attribute)=>{
                attributeCounts[attribute] = (attributeCounts[attribute] || 0) + 1;
            });
            return attributeCounts;
        }, {});
    };
    const $29fc238df01a2d37$export$e46b31cf3437f90c = (0, $3YtPS.createSelector)([
        $29fc238df01a2d37$export$a6de124506edd2c9
    ], $29fc238df01a2d37$export$f853033d86d5092a);
    const $29fc238df01a2d37$export$3953dcb78b9e2829 = (issueChanges)=>issueChanges.filter((issue)=>issue.metaData.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED).length;
    const $29fc238df01a2d37$export$43f0babde21e402 = (0, $3YtPS.createSelector)([
        $29fc238df01a2d37$export$a6de124506edd2c9
    ], $29fc238df01a2d37$export$3953dcb78b9e2829);
    function $29fc238df01a2d37$var$getIdsOfIssuesWithChangedLinks(incomingIssueLinks, originalIncomingIssueLinks, outgoingIssueLinks, originalOutgoingIssueLinks) {
        const changedLinkIssues = new Set();
        const linksData = [
            [
                incomingIssueLinks,
                originalIncomingIssueLinks
            ],
            [
                outgoingIssueLinks,
                originalOutgoingIssueLinks
            ]
        ];
        for (const [issueLinks, originalIssueLinks] of linksData){
            const issueLinkIds = new Set(Object.keys(issueLinks).concat(Object.keys(originalIssueLinks)));
            for (const id of issueLinkIds){
                const changedLinks = (0, ($parcel$interopDefault($6Kx1w)))(issueLinks[id] || [], originalIssueLinks[id] || [], (link, originalLink)=>(0, ($parcel$interopDefault($9XE6b)))(link, 'itemKey') === (0, ($parcel$interopDefault($9XE6b)))(originalLink, 'itemKey'));
                if (changedLinks.length > 0) changedLinkIssues.add(id);
            }
        }
        return changedLinkIssues;
    }
    const $29fc238df01a2d37$export$7a4cbbca987bfc8 = (planInfo, originalIssues, incomingIssueLinks, originalIncomingIssueLinks, outgoingIssueLinks, originalOutgoingIssueLinks)=>{
        const changedIssues = new Set(Object.keys(originalIssues));
        for (const id of [
            ...changedIssues
        ])if (Object.keys(originalIssues[id]).length >= 1) {
            const processedOriginalIssue = $29fc238df01a2d37$export$7208ce03e8a0ca7d(originalIssues[id], planInfo);
            if (id == null) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('plans.accessing-property-of-undefined', 'getIssueChangeCountPure id is undefined');
            if (!id?.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX)) && Object.keys(processedOriginalIssue).length < 1) changedIssues.delete(id);
        }
        const changedLinkIssues = $29fc238df01a2d37$var$getIdsOfIssuesWithChangedLinks(incomingIssueLinks, originalIncomingIssueLinks, outgoingIssueLinks, originalOutgoingIssueLinks);
        changedLinkIssues.forEach(changedIssues.add, changedIssues);
        return changedIssues.size;
    };
    const $29fc238df01a2d37$export$de1b72009d6b1dfc = (0, $3YtPS.createSelector)([
        (0, $bHTqr.getPlan),
        $29fc238df01a2d37$export$78e865af1b622bce,
        (0, $ddv1K.getIncomingLinks),
        (0, $ddv1K.getIncomingLinkOriginals),
        (0, $ddv1K.getOutgoingLinks),
        (0, $ddv1K.getOutgoingLinkOriginals)
    ], $29fc238df01a2d37$export$7a4cbbca987bfc8);
    const $29fc238df01a2d37$export$861bb780dd70ec3c = (incomingIssueLinks, originalIncomingIssueLinks, outgoingIssueLinks, originalOutgoingIssueLinks)=>$29fc238df01a2d37$var$getIdsOfIssuesWithChangedLinks(incomingIssueLinks, originalIncomingIssueLinks, outgoingIssueLinks, originalOutgoingIssueLinks).size;
    const $29fc238df01a2d37$export$eea625218b940c41 = (0, $3YtPS.createSelector)([
        (0, $ddv1K.getIncomingLinks),
        (0, $ddv1K.getIncomingLinkOriginals),
        (0, $ddv1K.getOutgoingLinks),
        (0, $ddv1K.getOutgoingLinkOriginals)
    ], $29fc238df01a2d37$export$861bb780dd70ec3c);
    const $29fc238df01a2d37$export$376ed4e7d3bbaa04 = (issues)=>{
        const issueCountByLevel = (0, parcelRequire("8Tt2N")).default((issue)=>issue.level.toString(), issues);
        const startLevel = Object.keys(issueCountByLevel).reduce((startLevel, level)=>{
            const currentLevel = parseFloat(level);
            if (currentLevel > startLevel && issueCountByLevel[level] > 1) return currentLevel;
            return startLevel;
        }, (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL));
        return {
            start: startLevel,
            end: (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)
        };
    };
    const $29fc238df01a2d37$export$63f0253ea18e1b2b = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssues)
    ], $29fc238df01a2d37$export$376ed4e7d3bbaa04);
    const $29fc238df01a2d37$export$e36f9fa7514e08e1 = (versions, issues)=>{
        const issuesByVersionMap = {};
        for (const { id: id } of versions)issuesByVersionMap[id] = [];
        for (const issue of issues)for (const versionId of issue.fixVersions || []){
            if (typeof issuesByVersionMap[versionId] === 'undefined') issuesByVersionMap[versionId] = [];
            issuesByVersionMap[versionId].push(issue);
        }
        return issuesByVersionMap;
    };
    const $29fc238df01a2d37$export$615c37ad4901bd5c = (0, $3YtPS.createSelector)([
        (0, $9FFuD.getVersions),
        (0, $gFhwb.getIssues)
    ], $29fc238df01a2d37$export$e36f9fa7514e08e1);
    const $29fc238df01a2d37$export$65ea2b70e1e8b23d = (state)=>state.domain.historyIssues;
    const $29fc238df01a2d37$export$bb6e9f1f80fa26a = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Issues.isLoadingHistory;
    const $29fc238df01a2d37$export$570537f670c4986d = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Issues.isSavingIssue;
    const $29fc238df01a2d37$export$f9f1f4119b3df74 = (state)=>new Set(state.ui.Main.Tabs.Roadmap.Scope.Issues.selected);
    const $29fc238df01a2d37$export$ddca736c9a2b0f6d = (issuesById, selectedIds)=>Array.from(selectedIds).map((id)=>issuesById[id]).filter((0, $4nDwW.isDefined));
    const $29fc238df01a2d37$export$5e52d79ee962d3c1 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssueMapById),
        $29fc238df01a2d37$export$f9f1f4119b3df74
    ], $29fc238df01a2d37$export$ddca736c9a2b0f6d);
    const $29fc238df01a2d37$export$263f4881943c16ad = (selectedIssues)=>(0, parcelRequire("4wiYB")).default(({ project: project })=>(0, parcelRequire("thm1N")).default(project), selectedIssues);
    const $29fc238df01a2d37$export$584afdbe1174e39e = (0, $3YtPS.createSelector)([
        $29fc238df01a2d37$export$5e52d79ee962d3c1
    ], $29fc238df01a2d37$export$263f4881943c16ad);
    const $29fc238df01a2d37$export$5cb8a36a11d27820 = (projectsByCPRsMap, selectedIssuesByProject)=>{
        const selectedProjectIds = Object.keys(selectedIssuesByProject);
        return (0, parcelRequire("jVZZA")).default((cprId)=>selectedProjectIds.every((issueProjectId)=>projectsByCPRsMap[cprId].includes(Number(issueProjectId))), Object.keys(projectsByCPRsMap));
    };
    const $29fc238df01a2d37$export$adefbe0a9c7ccb6a = (0, $3YtPS.createSelector)([
        (0, $9FFuD.getProjectIdsByCrossProjectVersionsMap),
        $29fc238df01a2d37$export$584afdbe1174e39e
    ], $29fc238df01a2d37$export$5cb8a36a11d27820);
    const $29fc238df01a2d37$export$d4820931b5475426 = (issue, originals, scenarioType = (0, $TTKUQ.SCENARIO_TYPE).UPDATED)=>{
        const { id: id, issueKey: issueKey, assignments: assignments = [], annotations: annotations = [], issueSources: issueSources = [], level: level, inferred: inferred, ...rest } = issue;
        let values = (0, parcelRequire("7p8Aa")).default((0, parcelRequire("8EB5I")).default(undefined))(rest);
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED) {
            values = (0, parcelRequire("7p8Aa")).default((0, parcelRequire("8EB5I")).default(null))(values);
            delete values.baselineStart;
            delete values.baselineEnd;
            return {
                id: id,
                assignments: assignments,
                annotations: annotations,
                issueSources: issueSources,
                values: values,
                originals: originals
            };
        }
        return {
            id: id,
            issueKey: issueKey,
            assignments: assignments,
            annotations: annotations,
            issueSources: issueSources,
            values: values,
            originals: originals
        };
    };
});
parcelRegister("6Kx1w", function(module, exports) {
    var $2GdQn = parcelRequire("2GdQn");
    var $g7i7g = parcelRequire("g7i7g");
    var $7txx8 = parcelRequire("7txx8");
    var $f3SOL = parcelRequire("f3SOL");
    var $hYfgW = parcelRequire("hYfgW");
    var $4ea0a7c2fafe415b$var$xorWith = $g7i7g(function(arrays) {
        var comparator = $hYfgW(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined;
        return $7txx8($2GdQn(arrays, $f3SOL), undefined, comparator);
    });
    module.exports = $4ea0a7c2fafe415b$var$xorWith;
});
parcelRegister("7txx8", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $ekcP3 = parcelRequire("ekcP3");
    var $7CoLY = parcelRequire("7CoLY");
    function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
        var length = arrays.length;
        if (length < 2) return length ? $7CoLY(arrays[0]) : [];
        var index = -1, result = Array(length);
        while(++index < length){
            var array = arrays[index], othIndex = -1;
            while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
        }
        return $7CoLY($ekcP3(result, 1), iteratee, comparator);
    }
    module.exports = $571540db172adafd$var$baseXor;
});
parcelRegister("h2uoz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c67a33710da9f33f$export$2e2bcd8739ae039);
    var $IYMZh;
    var $65NM6;
    var $cWyha;
    var $5oZ01;
    var $2XSIf;
    var $lV634;
    var $c67a33710da9f33f$var$assocPath = (0, (0, parcelRequire("IYMZh")).default)(function assocPath(path, val, obj) {
        if (path.length === 0) return val;
        var idx = path[0];
        if (path.length > 1) {
            var nextObj = !(0, (0, parcelRequire("lV634")).default)(obj) && (0, (0, parcelRequire("65NM6")).default)(idx, obj) ? obj[idx] : (0, (0, parcelRequire("5oZ01")).default)(path[1]) ? [] : {};
            val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
        }
        if ((0, (0, parcelRequire("5oZ01")).default)(idx) && (0, (0, parcelRequire("cWyha")).default)(obj)) {
            var arr = [].concat(obj);
            arr[idx] = val;
            return arr;
        } else return (0, (0, parcelRequire("2XSIf")).default)(idx, val, obj);
    });
    var $c67a33710da9f33f$export$2e2bcd8739ae039 = $c67a33710da9f33f$var$assocPath;
});
parcelRegister("5oZ01", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3eee82d7ba88aa0b$export$2e2bcd8739ae039);
    var $3eee82d7ba88aa0b$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
        return n << 0 === n;
    };
});
parcelRegister("2XSIf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$228b883fb0a76e86$export$2e2bcd8739ae039);
    var $IYMZh;
    var $228b883fb0a76e86$var$assoc = (0, (0, parcelRequire("IYMZh")).default)(function assoc(prop, val, obj) {
        var result = {};
        for(var p in obj)result[p] = obj[p];
        result[prop] = val;
        return result;
    });
    var $228b883fb0a76e86$export$2e2bcd8739ae039 = $228b883fb0a76e86$var$assoc;
});
parcelRegister("8Tt2N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6799fd589034d1bd$export$2e2bcd8739ae039);
    var $1fVsD;
    var $6799fd589034d1bd$var$countBy = (0, (0, parcelRequire("1fVsD")).default)(function(acc, elem) {
        return acc + 1;
    }, 0);
    var $6799fd589034d1bd$export$2e2bcd8739ae039 = $6799fd589034d1bd$var$countBy;
});
parcelRegister("cDeeP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93242bf1c0023970$export$2e2bcd8739ae039);
    var $c9RLn;
    var $8tYYg;
    var $93242bf1c0023970$var$difference = (0, (0, parcelRequire("c9RLn")).default)(function difference(first, second) {
        var out = [];
        var idx = 0;
        var firstLen = first.length;
        var secondLen = second.length;
        var toFilterOut = new (0, (0, parcelRequire("8tYYg")).default)();
        for(var i = 0; i < secondLen; i += 1)toFilterOut.add(second[i]);
        while(idx < firstLen){
            if (toFilterOut.add(first[idx])) out[out.length] = first[idx];
            idx += 1;
        }
        return out;
    });
    var $93242bf1c0023970$export$2e2bcd8739ae039 = $93242bf1c0023970$var$difference;
});
parcelRegister("dl2NH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b5f68abae5be9e8$export$2e2bcd8739ae039);
    var $IYMZh;
    var $8EB5I;
    var $9b5f68abae5be9e8$var$eqProps = (0, (0, parcelRequire("IYMZh")).default)(function eqProps(prop, obj1, obj2) {
        return (0, (0, parcelRequire("8EB5I")).default)(obj1[prop], obj2[prop]);
    });
    var $9b5f68abae5be9e8$export$2e2bcd8739ae039 = $9b5f68abae5be9e8$var$eqProps;
});
parcelRegister("4DrGU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$360048d3ee52416c$export$2e2bcd8739ae039);
    var $1fVsD;
    var $360048d3ee52416c$var$indexBy = (0, (0, parcelRequire("1fVsD")).default)(function(acc, elem) {
        return elem;
    }, null);
    var $360048d3ee52416c$export$2e2bcd8739ae039 = $360048d3ee52416c$var$indexBy;
});
parcelRegister("5TQ3w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44ba78010e32c621$export$2e2bcd8739ae039);
    var $IYMZh;
    var $44ba78010e32c621$var$replace = (0, (0, parcelRequire("IYMZh")).default)(function replace(regex, replacement, str) {
        return str.replace(regex, replacement);
    });
    var $44ba78010e32c621$export$2e2bcd8739ae039 = $44ba78010e32c621$var$replace;
});
parcelRegister("gl667", function(module, exports) {
    $parcel$export(module.exports, "applyOption", ()=>$ebdc1603f15ef8db$export$a8d7808c320ee36b);
    $parcel$export(module.exports, "getShowFullHierarchy", ()=>$ebdc1603f15ef8db$export$4d043fada9b9f718);
    var $kWDpn = parcelRequire("kWDpn");
    const $ebdc1603f15ef8db$export$a8d7808c320ee36b = (filteredIssues = [], ancestorsAndDescendants, showFullHierarchy)=>{
        const result = [];
        const uniqIds = new Set();
        const addItem = (item)=>{
            if (!uniqIds.has(item.id)) {
                uniqIds.add(item.id);
                result.push(item);
            }
        };
        for (const issue of filteredIssues){
            const { ancestors: ancestors, descendants: descendants } = ancestorsAndDescendants[issue.id];
            ancestors.forEach((ancestor)=>addItem(ancestor));
            addItem(issue);
            if (showFullHierarchy) descendants.forEach((descendant)=>addItem(descendant));
        }
        return result;
    };
    const $ebdc1603f15ef8db$export$4d043fada9b9f718 = (state)=>(0, $kWDpn.getFilterOptionsViewSettings)(state).includeDescendants;
});
parcelRegister("iIikD", function(module, exports) {
    $parcel$export(module.exports, "getFilters", ()=>$934b4cef00b3b4f5$export$1933a9fe712fc1fd);
    $parcel$export(module.exports, "getFiltersAndHierarchyLevelsForAnalytics", ()=>$934b4cef00b3b4f5$export$848df232fa46588e);
    $parcel$export(module.exports, "getFilterCount", ()=>$934b4cef00b3b4f5$export$93837b363b30db3a);
    $parcel$export(module.exports, "getRawFilters", ()=>$934b4cef00b3b4f5$export$bdb6d3f30d16cca7);
    $parcel$export(module.exports, "filterById", ()=>$934b4cef00b3b4f5$export$ff9a17ccab304c79);
    $parcel$export(module.exports, "matchFilter", ()=>$934b4cef00b3b4f5$export$c6f8482e724e56c5);
    $parcel$export(module.exports, "getUnmatchedFiltersList", ()=>$934b4cef00b3b4f5$export$a494cbe4bae883bb);
    var $hGgHi = parcelRequire("hGgHi");
    var $3nPAF;
    var $lV634;
    var $76p2G;
    var $fZhYM;
    var $2rMKg;
    var $co1wz;
    var $c12LJ;
    var $1CGdp = parcelRequire("1CGdp");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $cGbfF = parcelRequire("cGbfF");
    var $19iju = parcelRequire("19iju");
    var $jpgxP = parcelRequire("jpgxP");
    var $kWDpn = parcelRequire("kWDpn");
    var $3zBJm = parcelRequire("3zBJm");
    var $9sUIN = parcelRequire("9sUIN");
    var $1dvM4 = parcelRequire("1dvM4");
    var $eOe9K = parcelRequire("eOe9K");
    var $MT6jL = parcelRequire("MT6jL");
    var $6SQpK = parcelRequire("6SQpK");
    var $kpLy8 = parcelRequire("kpLy8");
    var $7bnpM = parcelRequire("7bnpM");
    var $1cIjo = parcelRequire("1cIjo");
    var $cjriJ = parcelRequire("cjriJ");
    var $b8dZ0 = parcelRequire("b8dZ0");
    var $hHRm5 = parcelRequire("hHRm5");
    var $aKeKY = parcelRequire("aKeKY");
    var $kHGzZ = parcelRequire("kHGzZ");
    var $1LpPL = parcelRequire("1LpPL");
    var $lz7VR = parcelRequire("lz7VR");
    var $hHrJz = parcelRequire("hHrJz");
    var $eqNmi = parcelRequire("eqNmi");
    var $48ZJQ = parcelRequire("48ZJQ");
    var $jrYap = parcelRequire("jrYap");
    var $l3m9K = parcelRequire("l3m9K");
    var $cGbfF = parcelRequire("cGbfF");
    const $934b4cef00b3b4f5$export$1933a9fe712fc1fd = (0, $3YtPS.createStructuredSelector)({
        [(0, $cGbfF.ASSIGNEE_FILTER_ID)]: (0, $3zBJm.getAssigneeFilter),
        [(0, $cGbfF.COMPONENT_FILTER_ID)]: (0, $9sUIN.getComponentFilter),
        [(0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID)]: (0, $1dvM4.getCrossProjectReleaseFilter),
        [(0, $cGbfF.CUSTOM_FIELD_FILTER_ID)]: (0, $eOe9K.getCustomFieldFilter),
        [(0, $cGbfF.DEPENDENCIES_FILTER_ID)]: (0, $6SQpK.getDependenciesFilter),
        [(0, $cGbfF.GOAL_FILTER_ID)]: (0, $kpLy8.getGoalFilter),
        [(0, $cGbfF.IDEA_FILTER_ID)]: (0, $cjriJ.getIdeaFilter),
        [(0, $cGbfF.HIERARCHY_FILTER_ID)]: (0, $7bnpM.getHierarchyFilter),
        [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: (0, $1cIjo.getHierarchyRangeFilter),
        [(0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID)]: (0, $b8dZ0.getIssuePrioritiesFilter),
        [(0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID)]: (0, $hHRm5.getIssueTypeKeyFilter),
        [(0, $cGbfF.LABEL_FILTER_ID)]: (0, $kHGzZ.getLabelFilter),
        [(0, $cGbfF.PROJECT_FILTER_ID)]: (0, $1LpPL.getProjectFilter),
        [(0, $cGbfF.RELEASE_FILTER_ID)]: (0, $lz7VR.getReleaseFilter),
        [(0, $cGbfF.REPORTER_FILTER_ID)]: (0, $hHrJz.getReporterFilter),
        [(0, $cGbfF.SPRINT_FILTER_ID)]: (0, $eqNmi.getSprintFilter),
        [(0, $cGbfF.STATUS_KEY_FILTER_ID)]: (0, $48ZJQ.getStatusKeyFilter),
        [(0, $cGbfF.SUMMARY_FILTER_ID)]: (0, $jrYap.getSummaryFilter),
        [(0, $cGbfF.TEAM_FILTER_ID)]: (0, $l3m9K.getTeamFilter),
        [(0, $cGbfF.ISSUE_WARNING_FILTER_ID)]: (0, $aKeKY.getIssueWarningFilter),
        [(0, $cGbfF.DATE_RANGE_FILTER_ID)]: (0, $MT6jL.getDateRangeFilter)
    });
    const $934b4cef00b3b4f5$export$848df232fa46588e = (state)=>{
        const filters = $934b4cef00b3b4f5$export$1933a9fe712fc1fd(state);
        const customFieldsById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), (0, $19iju.getCustomFields)(state));
        const hierarchyLevels = {
            start: (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL),
            end: (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)
        };
        const ignoredFilters = [
            (0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID),
            (0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID),
            (0, $cGbfF.CUSTOM_FIELD_FILTER_ID),
            (0, $cGbfF.HIERARCHY_FILTER_ID),
            (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
            (0, $cGbfF.DEPENDENCIES_FILTER_ID),
            (0, $cGbfF.SUMMARY_FILTER_ID),
            (0, $cGbfF.DATE_RANGE_FILTER_ID)
        ];
        const selectedFilters = [];
        for (const [filterKey, filterValue] of Object.entries(filters)){
            if (filterKey === (0, $cGbfF.CUSTOM_FIELD_FILTER_ID)) for (const [customFieldId, selectedOptionsIds] of Object.entries((0, parcelRequire("fZhYM")).default([
                'value'
            ], filterValue))){
                const customFieldTypeKey = (0, parcelRequire("fZhYM")).default([
                    'type',
                    'key'
                ], customFieldsById[customFieldId]);
                if ((0, $4nDwW.isDefined)(customFieldTypeKey) && selectedOptionsIds && selectedOptionsIds.length) selectedFilters.push(customFieldTypeKey);
            }
            else if (filterKey === (0, $cGbfF.DEPENDENCIES_FILTER_ID) && (0, parcelRequire("fZhYM")).default([
                'value',
                'type'
            ], filterValue) !== 'off') selectedFilters.push(filterKey);
            else if (filterKey === (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)) {
                const { start: start, end: end } = filterValue?.value || {};
                if (!(0, ($parcel$interopDefault($hGgHi)))(start)) hierarchyLevels.start = start;
                if (!(0, ($parcel$interopDefault($hGgHi)))(end)) hierarchyLevels.end = end;
            } else if (filterKey === (0, $cGbfF.SUMMARY_FILTER_ID) && (0, parcelRequire("fZhYM")).default([
                'value'
            ], filterValue)) selectedFilters.push(filterKey);
            else if (filterValue.id === (0, $cGbfF.DATE_RANGE_FILTER_ID) && (filterValue.value?.startDate || filterValue.value?.endDate)) selectedFilters.push(filterKey);
            else if (!ignoredFilters.includes(filterKey)) {
                const selectedFilterValue = (0, parcelRequire("fZhYM")).default([
                    'value'
                ], filterValue);
                if (selectedFilterValue && selectedFilterValue.length) selectedFilters.push(filterKey);
            }
        }
        return {
            selectedFilters: selectedFilters,
            hierarchyLevels: hierarchyLevels
        };
    };
    const $934b4cef00b3b4f5$export$537d4ab858fa5f4a = ({ value: value })=>(0, parcelRequire("lV634")).default(value) || (0, parcelRequire("3nPAF")).default(value) || value.type === 'off' || value === false;
    const $934b4cef00b3b4f5$export$573fe4d6049b5e1b = (customFieldCount, isAtlasConnectInstalledCheck, { [(0, $cGbfF.HIERARCHY_FILTER_ID)]: _, [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: __, [(0, $cGbfF.CUSTOM_FIELD_FILTER_ID)]: ___, ...remainingFilters }, isEmbedMode, isConfluenceMacroMode)=>{
        const isEmbedOrMacro = isEmbedMode || isConfluenceMacroMode;
        const nonEmptyFilters = Object.entries(remainingFilters).filter(([_, filter])=>!$934b4cef00b3b4f5$export$537d4ab858fa5f4a(filter)).map(([filterId, _])=>filterId);
        let adjustment = 0;
        if (nonEmptyFilters.indexOf((0, $cGbfF.STATUS_KEY_FILTER_ID)) > -1 && nonEmptyFilters.indexOf((0, $cGbfF.STATUS_FILTER_ID)) > -1) adjustment += 1;
        if (nonEmptyFilters.indexOf((0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID)) > -1 && nonEmptyFilters.indexOf((0, $cGbfF.ISSUE_TYPES_FILTER_ID)) > -1) adjustment += 1;
        if (!isAtlasConnectInstalledCheck && nonEmptyFilters.includes((0, $cGbfF.GOAL_FILTER_ID))) adjustment += 1;
        if ((!(0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') || (0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') && isEmbedOrMacro) && nonEmptyFilters.includes((0, $cGbfF.IDEA_FILTER_ID))) adjustment += 1;
        return customFieldCount + nonEmptyFilters.length - adjustment;
    };
    const $934b4cef00b3b4f5$export$93837b363b30db3a = (0, $3YtPS.createSelector)([
        (0, $eOe9K.getCustomFieldFilterCount),
        (0, $jpgxP.isAtlasConnectInstalled),
        $934b4cef00b3b4f5$export$1933a9fe712fc1fd,
        (0, $1CGdp.isEmbed),
        (0, $1CGdp.isConfluenceMacro)
    ], $934b4cef00b3b4f5$export$573fe4d6049b5e1b);
    const $934b4cef00b3b4f5$export$bdb6d3f30d16cca7 = (state)=>(0, $kWDpn.getFiltersViewSettings)(state);
    const $934b4cef00b3b4f5$export$ff9a17ccab304c79 = {
        [(0, $cGbfF.PROJECT_FILTER_ID)]: (0, $1LpPL.applyFilter),
        [(0, $cGbfF.HIERARCHY_FILTER_ID)]: (0, $7bnpM.applyFilter),
        [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: (0, $1cIjo.applyHierarchyRangeFilter),
        [(0, $cGbfF.RELEASE_FILTER_ID)]: (0, $lz7VR.applyFilter),
        [(0, $cGbfF.TEAM_FILTER_ID)]: (0, $l3m9K.applyFilter),
        [(0, $cGbfF.ASSIGNEE_FILTER_ID)]: (0, $3zBJm.applyFilter),
        [(0, $cGbfF.REPORTER_FILTER_ID)]: (0, $hHrJz.applyFilter),
        [(0, $cGbfF.SUMMARY_FILTER_ID)]: (0, $jrYap.applyFilter),
        [(0, $cGbfF.DEPENDENCIES_FILTER_ID)]: (0, $6SQpK.applyFilter),
        [(0, $cGbfF.LABEL_FILTER_ID)]: (0, $kHGzZ.applyFilter),
        [(0, $cGbfF.STATUS_KEY_FILTER_ID)]: (0, $48ZJQ.applyFilter),
        [(0, $cGbfF.COMPONENT_FILTER_ID)]: (0, $9sUIN.applyFilter),
        [(0, $cGbfF.ISSUE_WARNING_FILTER_ID)]: (0, $aKeKY.applyFilter),
        [(0, $cGbfF.SPRINT_FILTER_ID)]: (0, $eqNmi.applyFilter),
        [(0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID)]: (0, $hHRm5.applyFilter),
        [(0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID)]: (0, $b8dZ0.applyFilter),
        [(0, $cGbfF.CUSTOM_FIELD_FILTER_ID)]: (0, $eOe9K.applyFilter),
        [(0, $cGbfF.GOAL_FILTER_ID)]: (0, $kpLy8.applyFilter),
        [(0, $cGbfF.IDEA_FILTER_ID)]: (0, $cjriJ.applyFilter),
        [(0, $cGbfF.DATE_RANGE_FILTER_ID)]: (0, $MT6jL.applyFilter)
    };
    function $934b4cef00b3b4f5$export$c6f8482e724e56c5(filters, optimizedMode, customFields, issue, options = {}) {
        const exclude = options.exclude || [];
        for (const filterId of (0, parcelRequire("76p2G")).default(filters)){
            const filterFn = $934b4cef00b3b4f5$export$ff9a17ccab304c79[filterId];
            if (typeof filterFn === 'function' && !exclude.includes(filterId)) {
                if (filterId === (0, $cGbfF.CUSTOM_FIELD_FILTER_ID)) {
                    if (!filterFn(issue, filters[filterId], customFields)) return false;
                } else if (!filterFn(issue, filters[filterId], optimizedMode)) return false;
            }
        }
        return true;
    }
    function $934b4cef00b3b4f5$export$a494cbe4bae883bb(filters, optimizedMode, customFields, issue) {
        const customFieldsById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), customFields);
        const appliedCustomFilters = (filters)=>{
            const customFilters = [];
            for (const [key, value] of Object.entries(filters))if (value && value.length) customFilters.push(customFieldsById[key]);
            return customFilters;
        };
        const unmatchedList = [];
        for (const filterId of (0, parcelRequire("76p2G")).default(filters)){
            const filterFn = $934b4cef00b3b4f5$export$ff9a17ccab304c79[filterId];
            if (typeof filterFn === 'function') {
                if (filterId === (0, $cGbfF.CUSTOM_FIELD_FILTER_ID)) {
                    if (!filterFn(issue, filters[filterId], customFields)) unmatchedList.push({
                        id: filterId,
                        type: 'custom',
                        filters: appliedCustomFilters(filters[filterId].value)
                    });
                } else if (!filterFn(issue, filters[filterId], optimizedMode)) unmatchedList.push({
                    id: filterId,
                    type: 'standard',
                    filters: []
                });
            }
        }
        return unmatchedList;
    }
});
parcelRegister("jpgxP", function(module, exports) {
    $parcel$export(module.exports, "getSystemInfo", ()=>$e180bbdbbf3994e6$export$d51248ece03722d6);
    $parcel$export(module.exports, "getAgileInfo", ()=>$e180bbdbbf3994e6$export$2e685c300dc2bca1);
    $parcel$export(module.exports, "getJiraHoursPerDay", ()=>$e180bbdbbf3994e6$export$6052ef45443f5a7c);
    $parcel$export(module.exports, "getLoadingLimitsInfo", ()=>$e180bbdbbf3994e6$export$8b9416d87c4e395c);
    $parcel$export(module.exports, "getDateFormat", ()=>$e180bbdbbf3994e6$export$fa96065c64444af6);
    $parcel$export(module.exports, "getIssueLinkTypesInfo", ()=>$e180bbdbbf3994e6$export$d4e01b8a05970fd7);
    $parcel$export(module.exports, "getDependencySettingsInfo", ()=>$e180bbdbbf3994e6$export$a452921f8f88500f);
    $parcel$export(module.exports, "getFiscalMonth", ()=>$e180bbdbbf3994e6$export$b4f0c59b6883adbf);
    $parcel$export(module.exports, "isNonPublishingEditor", ()=>$e180bbdbbf3994e6$export$f0c949045c6f435d);
    $parcel$export(module.exports, "getInstanceUserRole", ()=>$e180bbdbbf3994e6$export$f07b48fa83dcf606);
    $parcel$export(module.exports, "isAtlasConnectInstalledSystem", ()=>$e180bbdbbf3994e6$export$3440da41cf51a346);
    $parcel$export(module.exports, "isAtlasConnectInstalled", ()=>$e180bbdbbf3994e6$export$fe67de28f66ce62b);
    $parcel$export(module.exports, "getHasAtlasPermissions", ()=>$e180bbdbbf3994e6$export$eb44a0ec15e48ae);
    var $4R6GH;
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $1CGdp = parcelRequire("1CGdp");
    const $e180bbdbbf3994e6$export$d51248ece03722d6 = (state)=>state.domain.system.systemInfo;
    const $e180bbdbbf3994e6$export$2e685c300dc2bca1 = (state)=>state.domain.system.agileInfo;
    const $e180bbdbbf3994e6$export$6052ef45443f5a7c = (state)=>state.domain.system.systemInfo.jiraHoursPerDay;
    const $e180bbdbbf3994e6$export$8b9416d87c4e395c = (state)=>state.domain.system.loadingLimitsInfo;
    const $e180bbdbbf3994e6$export$fa96065c64444af6 = (state)=>state.domain.system.systemInfo.lookAndFeel.dateFormat;
    const $e180bbdbbf3994e6$export$d4e01b8a05970fd7 = (state)=>state.domain.system.issueLinkTypesInfo;
    const $e180bbdbbf3994e6$export$a452921f8f88500f = (state)=>state.domain.system.dependencySettingsInfo;
    const $e180bbdbbf3994e6$export$b4f0c59b6883adbf = (state)=>state.domain.system.systemInfo.fiscalMonth;
    const $e180bbdbbf3994e6$export$6728be6ff2068a47 = (0, $3YtPS.createSelector)([
        $e180bbdbbf3994e6$export$d51248ece03722d6
    ], (systemInfo)=>systemInfo.permission);
    const $e180bbdbbf3994e6$export$f0c949045c6f435d = (0, $3YtPS.createSelector)([
        $e180bbdbbf3994e6$export$d51248ece03722d6
    ], (systemInfo)=>systemInfo.permission === (0, $TTKUQ.PLUGIN_PERMISSION).NON_PUBLISHING_EDITOR && !systemInfo.isAdmin);
    const $e180bbdbbf3994e6$export$f07b48fa83dcf606 = (0, $3YtPS.createSelector)([
        $e180bbdbbf3994e6$export$d51248ece03722d6
    ], (systemInfo)=>{
        if (systemInfo.isAdmin) return (0, $TTKUQ.INSTANCE_USER_ROLE).ADMIN;
        if (systemInfo.permission === (0, $TTKUQ.PLUGIN_PERMISSION).FULL_EDITOR) return (0, $TTKUQ.INSTANCE_USER_ROLE).EDITOR;
        if (systemInfo.permission === (0, $TTKUQ.PLUGIN_PERMISSION).VIEWER) return (0, $TTKUQ.INSTANCE_USER_ROLE).VIEWER;
        if (systemInfo.permission === (0, $TTKUQ.PLUGIN_PERMISSION).NON_PUBLISHING_EDITOR) return (0, $TTKUQ.INSTANCE_USER_ROLE).RESTRICTED_USER;
        return '';
    });
    const $e180bbdbbf3994e6$export$3440da41cf51a346 = (state)=>state.domain.system.isAtlasConnectInstalled;
    const $e180bbdbbf3994e6$export$fe67de28f66ce62b = (0, $3YtPS.createSelector)([
        (0, $1CGdp.isConfluenceMacroProxy),
        $e180bbdbbf3994e6$export$3440da41cf51a346
    ], (isMacroProxy, isInstalled)=>(0, (0, parcelRequire("4R6GH")).fg)('remove_goal_field_on_plan_macro') ? !isMacroProxy && isInstalled : isInstalled);
    const $e180bbdbbf3994e6$export$eb44a0ec15e48ae = (state)=>state.domain.system.hasAtlasPermissions;
});
parcelRegister("3zBJm", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$388d8d0ce334fc3b$export$1b001418845b471c);
    $parcel$export(module.exports, "getAssigneeForFilter", ()=>$388d8d0ce334fc3b$export$be11142e7392d31);
    $parcel$export(module.exports, "getAssigneeFilter", ()=>$388d8d0ce334fc3b$export$9c158e12671c7642);
    var $3JOCw = parcelRequire("3JOCw");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $hu7Cn = parcelRequire("hu7Cn");
    var $ageG6 = parcelRequire("ageG6");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $cGbfF = parcelRequire("cGbfF");
    const $388d8d0ce334fc3b$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, filter.value, 'assignee', optimizedMode);
    const $388d8d0ce334fc3b$var$getTeamsAssignees = (0, $3YtPS.createSelector)([
        (0, $ageG6.getTeamsPersons),
        (0, $hu7Cn.getAssigneeList)
    ], (persons, assignees)=>{
        const jiraUserIds = persons.reduce((acc, person)=>{
            if (person.jiraUser) acc.add(person.jiraUser.accountId);
            return acc;
        }, new Set());
        return assignees.filter((assignee)=>jiraUserIds.has(assignee.jiraUser.accountId));
    });
    const $388d8d0ce334fc3b$export$be11142e7392d31 = (0, $3YtPS.createSelector)([
        $388d8d0ce334fc3b$var$getTeamsAssignees,
        (0, $hu7Cn.getAssigneesOfIssues)
    ], (teamsAssignees, issuesAssignees)=>(0, ($parcel$interopDefault($3JOCw)))([
            ...teamsAssignees,
            ...issuesAssignees
        ], ({ personId: personId })=>personId));
    const $388d8d0ce334fc3b$export$a9062f4ed8b94d99 = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.ASSIGNEE_FILTER_ID] || {
            id: (0, $cGbfF.ASSIGNEE_FILTER_ID),
            value: []
        };
    const $388d8d0ce334fc3b$export$9c158e12671c7642 = (0, $3YtPS.createSelector)([
        $388d8d0ce334fc3b$export$be11142e7392d31,
        $388d8d0ce334fc3b$export$a9062f4ed8b94d99
    ], (assignees, { id: id, value: value = [] })=>{
        const assigneeSet = new Set(assignees.map(({ personId: personId })=>personId));
        return {
            id: id,
            value: value.filter((personId)=>assigneeSet.has(personId))
        };
    });
});
parcelRegister("hu7Cn", function(module, exports) {
    $parcel$export(module.exports, "getAssigneeListFetchStatus", ()=>$cab0f53d2823039f$export$e3b989a9b8bf61ec);
    $parcel$export(module.exports, "getIssueIdForFetchAssigneeListProgress", ()=>$cab0f53d2823039f$export$32e3a14387dac47b);
    $parcel$export(module.exports, "getAssigneeList", ()=>$cab0f53d2823039f$export$e57275653c7a8d26);
    $parcel$export(module.exports, "getAssigneesById", ()=>$cab0f53d2823039f$export$67f3f388d3197338);
    $parcel$export(module.exports, "getAssigneesOfIssues", ()=>$cab0f53d2823039f$export$69b494dd078e2e04);
    var $2rMKg;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $gFhwb = parcelRequire("gFhwb");
    const $cab0f53d2823039f$export$e3b989a9b8bf61ec = (state)=>state.ui.Main.Tabs.Roadmap.Fields.Assignee.isFetchAssigneeListInProgress;
    const $cab0f53d2823039f$export$32e3a14387dac47b = (state)=>state.ui.Main.Tabs.Roadmap.Fields.Assignee.issueIdForFetchAssigneeListProgress;
    const $cab0f53d2823039f$export$e57275653c7a8d26 = (state)=>state.domain.assignees.assigneeList;
    const $cab0f53d2823039f$export$67f3f388d3197338 = (0, $3YtPS.createSelector)([
        $cab0f53d2823039f$export$e57275653c7a8d26
    ], (assignees)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('personId'), assignees));
    const $cab0f53d2823039f$export$d6727e3bcb79811f = (issues, assigneeList)=>{
        const assignees = new Set();
        issues.forEach((issue)=>{
            const userId = issue.assignee;
            const assignee = assigneeList.find((assignee)=>assignee.jiraUser.accountId === userId);
            if (assignee) assignees.add(assignee);
        });
        return Array.from(assignees);
    };
    const $cab0f53d2823039f$export$69b494dd078e2e04 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssues),
        $cab0f53d2823039f$export$e57275653c7a8d26
    ], $cab0f53d2823039f$export$d6727e3bcb79811f);
});
parcelRegister("gFhwb", function(module, exports) {
    $parcel$export(module.exports, "getAllIssues", ()=>$fb89387e020cb5b0$export$7d1865fcc78ac59e);
    $parcel$export(module.exports, "getOriginalIssues", ()=>$fb89387e020cb5b0$export$78e865af1b622bce);
    $parcel$export(module.exports, "getIssuesWithRolledUpDates", ()=>$fb89387e020cb5b0$export$34dfe67491b3b80a);
    $parcel$export(module.exports, "getIssues", ()=>$fb89387e020cb5b0$export$73a53226406d7fe);
    $parcel$export(module.exports, "createIssueMapByIdPure", ()=>$fb89387e020cb5b0$export$920c5c5c2a4b2e13);
    $parcel$export(module.exports, "getIssueMapById", ()=>$fb89387e020cb5b0$export$f997fcc0f824766c);
    $parcel$export(module.exports, "getScenarioRemovedIssueMapById", ()=>$fb89387e020cb5b0$export$5731605119919ca9);
    $parcel$export(module.exports, "getTeamsWorkingWithSprints", ()=>$fb89387e020cb5b0$export$186ba9706085d67f);
    var $ejRbr = parcelRequire("ejRbr");
    var $fn8B5 = parcelRequire("fn8B5");
    var $D5mr3 = parcelRequire("D5mr3");
    var $3pSjV;
    var $bCilb;
    var $3nPAF;
    var $aTOU9;
    var $QclR4;
    var $2rMKg;
    var $h35CY;
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $1CGdp = parcelRequire("1CGdp");
    var $7ppNi = parcelRequire("7ppNi");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $2QLMT = parcelRequire("2QLMT");
    var $cZF7S = parcelRequire("cZF7S");
    var $ljmcc = parcelRequire("ljmcc");
    var $6TEBn = parcelRequire("6TEBn");
    var $dRVQG = parcelRequire("dRVQG");
    var $9FFuD = parcelRequire("9FFuD");
    var $ipX5U = parcelRequire("ipX5U");
    var $kWDpn = parcelRequire("kWDpn");
    const $fb89387e020cb5b0$export$7d1865fcc78ac59e = (state)=>state.domain.issues;
    const $fb89387e020cb5b0$export$78e865af1b622bce = (state)=>state.domain.originalIssues;
    const $fb89387e020cb5b0$export$8f046b32de3888d3 = (state)=>state.domain.scenarioRemovedIssues;
    const $fb89387e020cb5b0$var$doesNotBelongToRemovedVersion = (fixVersions, removedVersionsById)=>!(0, $4nDwW.isDefined)(fixVersions) || fixVersions.length === 0 || fixVersions.some((vid)=>!Object.prototype.hasOwnProperty.call(removedVersionsById, vid));
    const $fb89387e020cb5b0$var$inferSprintDates = (sprintsWithFutureDates, issueStatusesById)=>(issue)=>{
            if ((0, $4nDwW.isDefined)(issue.baselineStart) || (0, $4nDwW.isDefined)(issue.baselineEnd)) return issue;
            const sprints = (0, $ljmcc.getFutureSprintsForIssue)(issue, sprintsWithFutureDates);
            if ((0, parcelRequire("3nPAF")).default(sprints)) return issue;
            const { rawStartDate: rawStartDate, rawEndDate: rawEndDate } = (0, $6TEBn.getTargetDatesFromSprints)(issue, sprints, issueStatusesById);
            return {
                ...issue,
                baselineStart: rawStartDate,
                baselineEnd: rawEndDate,
                inferred: {
                    baselineStart: (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).SPRINT,
                    baselineEnd: (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).SPRINT
                }
            };
        };
    const $fb89387e020cb5b0$var$inferReleaseDates = (versions)=>(issue)=>{
            if ((0, $4nDwW.isDefined)(issue.baselineStart) || (0, $4nDwW.isDefined)(issue.baselineEnd)) return issue;
            const targetDates = (0, $ipX5U.getTargetDatesFromReleases)(issue, versions);
            if (!(0, $4nDwW.isDefined)(targetDates)) return issue;
            const { startDate: startDate, endDate: endDate } = targetDates;
            if (!(0, $4nDwW.isDefined)(startDate) && !(0, $4nDwW.isDefined)(endDate)) return issue;
            return {
                ...issue,
                baselineStart: startDate,
                baselineEnd: endDate,
                inferred: {
                    baselineStart: startDate ? (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).RELEASE : (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).NONE,
                    baselineEnd: endDate ? (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).RELEASE : (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).NONE
                }
            };
        };
    const $fb89387e020cb5b0$var$appendOptimizedValues = (dateConfiguration, selectedIssuesForCalculation, solution)=>(issue)=>{
            const { assignments: assignments, id: id } = issue;
            if (selectedIssuesForCalculation.length === 0 || selectedIssuesForCalculation.includes(id)) {
                const undefinedIfInsane = (num)=>!(0, ($parcel$interopDefault($D5mr3)))(num) ? undefined : num;
                const baselineStart = undefinedIfInsane(assignments.reduce((acc, { start: start })=>Math.min(acc, start || Infinity), Infinity));
                const baselineEnd = undefinedIfInsane(assignments.reduce((acc, { end: end })=>Math.max(acc, end || -Infinity), -Infinity));
                const { team: team } = assignments.find(({ team: team })=>(0, $4nDwW.isDefined)(team)) || issue;
                const optimized = {
                    baselineStart: (0, $4nDwW.isDefined)(baselineStart) ? baselineStart : issue.baselineStart,
                    baselineEnd: (0, $4nDwW.isDefined)(baselineEnd) ? baselineEnd : issue.baselineEnd,
                    team: team,
                    fixVersions: (0, $2QLMT.getOptimizedFixVersion)(issue, solution),
                    sprint: (0, $2QLMT.getOptimizedSprint)(issue, solution)
                };
                return {
                    ...issue,
                    optimized: {
                        ...optimized,
                        [dateConfiguration.baselineStartField.key]: optimized.baselineStart,
                        [dateConfiguration.baselineEndField.key]: optimized.baselineEnd
                    }
                };
            }
            return {
                ...issue,
                optimized: {}
            };
        };
    const $fb89387e020cb5b0$var$getConfiguredDate = (dateField, issue)=>{
        if (dateField.type === (0, $5fACX.DATEFIELD_TYPES).BUILT_IN) return issue[dateField.key];
        if (dateField.type === (0, $5fACX.DATEFIELD_TYPES).CUSTOM && (0, $4nDwW.isDefined)(issue.customFields)) return issue.customFields[dateField.key];
        return null;
    };
    const $fb89387e020cb5b0$var$seedRolledUpDates = (0, parcelRequire("3pSjV")).default({
        baselineStart: Infinity,
        baselineEnd: -Infinity
    });
    const $fb89387e020cb5b0$export$34dfe67491b3b80a = (issues)=>{
        const rolledUpDatesById = {};
        const issuesSortedByLevelFromLowerToHigher = (0, parcelRequire("h35CY")).default((0, parcelRequire("2rMKg")).default('level'), issues);
        const rollUpDatesForAnIssue = ({ parent: parent, baselineStart: baselineStart, baselineEnd: baselineEnd })=>{
            const hasAtLeastOneDate = (0, $4nDwW.isDefined)(baselineStart) || (0, $4nDwW.isDefined)(baselineEnd);
            if ((0, $4nDwW.isDefined)(parent) && hasAtLeastOneDate) rolledUpDatesById[parent] = (0, parcelRequire("bCilb")).default({
                baselineStart: (0, parcelRequire("QclR4")).default((0, parcelRequire("3pSjV")).default(-Infinity, baselineStart)),
                baselineEnd: (0, parcelRequire("aTOU9")).default((0, parcelRequire("3pSjV")).default(Infinity, baselineEnd))
            }, $fb89387e020cb5b0$var$seedRolledUpDates(rolledUpDatesById[parent]));
        };
        return issuesSortedByLevelFromLowerToHigher.map((issue)=>{
            const rolledUpDates = rolledUpDatesById[issue.id];
            if (!rolledUpDates || (0, $4nDwW.isDefined)(issue.baselineStart) && (0, $4nDwW.isDefined)(issue.baselineEnd)) {
                rollUpDatesForAnIssue(issue);
                return issue;
            }
            const transformedIssue = {
                ...issue,
                inferred: issue.inferred || {}
            };
            for (const date of [
                'baselineStart',
                'baselineEnd'
            ])if (!(0, $4nDwW.isDefined)(issue[date])) {
                transformedIssue.inferred[date] = (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
                if (Number.isFinite(rolledUpDates[date])) transformedIssue[date] = rolledUpDates[date];
            }
            rollUpDatesForAnIssue(transformedIssue);
            return transformedIssue;
        });
    };
    const $fb89387e020cb5b0$export$ef6f826be9f0f699 = (issues, projects, versionsById, removedVersionsById, allTeams, sprintsWithFutureDates, issueInferredDateSelection, dateConfiguration, issueStatusesById, shouldShowRollUpDates, isOptimizedMode, solution)=>{
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
        const projectIds = new Set(projects.map((x)=>x.id));
        const allTeamIds = new Set(allTeams.map((x)=>x.id));
        const isNotRemoved = ({ project: project, fixVersions: fixVersions })=>(0, parcelRequire("3nPAF")).default(removedVersionsById) ? projectIds.has(project) : projectIds.has(project) && $fb89387e020cb5b0$var$doesNotBelongToRemovedVersion(fixVersions, removedVersionsById);
        const removeNotExistingTeam = (issue)=>{
            if (issue.team && !allTeamIds.has(issue.team)) return {
                ...issue,
                team: undefined
            };
            return issue;
        };
        const configureBaselineDates = (issue)=>({
                ...issue,
                baselineStart: $fb89387e020cb5b0$var$getConfiguredDate(baselineStartField, issue),
                baselineEnd: $fb89387e020cb5b0$var$getConfiguredDate(baselineEndField, issue)
            });
        const transformations = [
            removeNotExistingTeam,
            configureBaselineDates
        ];
        if (issueInferredDateSelection === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).SPRINT) transformations.push($fb89387e020cb5b0$var$inferSprintDates(sprintsWithFutureDates, issueStatusesById));
        else if (issueInferredDateSelection === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).RELEASE) transformations.push($fb89387e020cb5b0$var$inferReleaseDates(versionsById));
        if (isOptimizedMode) {
            const selectedIssuesForCalculation = solution.calculationConfiguration && solution.calculationConfiguration.selectedIssueIds ? solution.calculationConfiguration.selectedIssueIds : [];
            transformations.push($fb89387e020cb5b0$var$appendOptimizedValues(dateConfiguration, selectedIssuesForCalculation, solution));
        }
        const transformedIssues = (0, $4nDwW.filterMap)(isNotRemoved, (0, ($parcel$interopDefault($ejRbr)))(transformations), issues);
        return shouldShowRollUpDates ? $fb89387e020cb5b0$export$34dfe67491b3b80a(transformedIssues) : transformedIssues;
    };
    const $fb89387e020cb5b0$export$73a53226406d7fe = (0, $3YtPS.createSelector)([
        $fb89387e020cb5b0$export$7d1865fcc78ac59e,
        (0, $jpXKt.getProjects),
        (0, $9FFuD.getVersionsById),
        (0, $9FFuD.getRemovedVersionsById),
        (0, $dRVQG.getAllTeams),
        (0, $ljmcc.getSprintsWithFutureDates),
        (0, $bHTqr.getPlanIssueInferredDateSelection),
        (0, $bHTqr.getDateConfiguration),
        (0, $7ppNi.getIssueStatusById),
        (0, $kWDpn.getShowRolledUpDates),
        (0, $1CGdp.isOptimizedMode),
        (0, $cZF7S.getSolution)
    ], $fb89387e020cb5b0$export$ef6f826be9f0f699);
    const $fb89387e020cb5b0$export$920c5c5c2a4b2e13 = (issues)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), issues);
    const $fb89387e020cb5b0$export$f997fcc0f824766c = (0, $3YtPS.createSelector)([
        $fb89387e020cb5b0$export$73a53226406d7fe
    ], $fb89387e020cb5b0$export$920c5c5c2a4b2e13);
    const $fb89387e020cb5b0$export$5731605119919ca9 = (0, $3YtPS.createSelector)([
        $fb89387e020cb5b0$export$8f046b32de3888d3
    ], $fb89387e020cb5b0$export$920c5c5c2a4b2e13);
    const $fb89387e020cb5b0$export$6468d3e39efadce4 = (issues)=>{
        const groupedByTeam = (0, ($parcel$interopDefault($fn8B5)))(issues, 'team');
        return new Set(Object.entries(groupedByTeam).filter(([, teamIssues])=>teamIssues.some((issue)=>issue.sprint)).map(([teamId])=>teamId));
    };
    const $fb89387e020cb5b0$export$186ba9706085d67f = (0, $3YtPS.createSelector)([
        $fb89387e020cb5b0$export$73a53226406d7fe
    ], $fb89387e020cb5b0$export$6468d3e39efadce4);
});
parcelRegister("ejRbr", function(module, exports) {
    module.exports = (parcelRequire("g1VnK"));
});
parcelRegister("g1VnK", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $bab9403b96f3051c$var$func = $lVx1a('flow', (parcelRequire("basmW")));
    $bab9403b96f3051c$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $bab9403b96f3051c$var$func;
});
parcelRegister("D5mr3", function(module, exports) {
    var $1V15E = parcelRequire("1V15E");
    var $0757cd3024f91218$var$nativeIsFinite = $1V15E.isFinite;
    function $0757cd3024f91218$var$isFinite(value) {
        return typeof value == 'number' && $0757cd3024f91218$var$nativeIsFinite(value);
    }
    module.exports = $0757cd3024f91218$var$isFinite;
});
parcelRegister("bCilb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8751785f1870d240$export$2e2bcd8739ae039);
    var $c9RLn;
    var $8751785f1870d240$var$evolve = (0, (0, parcelRequire("c9RLn")).default)(function evolve(transformations, object) {
        var result = object instanceof Array ? [] : {};
        var transformation, key, type;
        for(key in object){
            transformation = transformations[key];
            type = typeof transformation;
            result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
        }
        return result;
    });
    var $8751785f1870d240$export$2e2bcd8739ae039 = $8751785f1870d240$var$evolve;
});
parcelRegister("QclR4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09ce7031a9b72bb8$export$2e2bcd8739ae039);
    var $c9RLn;
    var $09ce7031a9b72bb8$var$min = (0, (0, parcelRequire("c9RLn")).default)(function min(a, b) {
        return b < a ? b : a;
    });
    var $09ce7031a9b72bb8$export$2e2bcd8739ae039 = $09ce7031a9b72bb8$var$min;
});
parcelRegister("7ppNi", function(module, exports) {
    $parcel$export(module.exports, "getIssueStatuses", ()=>$110b247b3ee2686c$export$62f3835c38e7545f);
    $parcel$export(module.exports, "getIssueStatusById", ()=>$110b247b3ee2686c$export$6da1c7e84cedf7);
    $parcel$export(module.exports, "getIssueStatusByKey", ()=>$110b247b3ee2686c$export$17d3a761803fe8b8);
    $parcel$export(module.exports, "getIssueStatusByIdForCompanyManagedProjects", ()=>$110b247b3ee2686c$export$422f19a1ad3809f8);
    var $fn8B5 = parcelRequire("fn8B5");
    var $27NS3 = parcelRequire("27NS3");
    var $dDkmN = parcelRequire("dDkmN");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $jpXKt = parcelRequire("jpXKt");
    const $110b247b3ee2686c$export$62f3835c38e7545f = (state)=>state.domain.issueStatuses;
    const $110b247b3ee2686c$var$getIssueStatusByIdMap = (statuses)=>(0, $4nDwW.indexBy)((status)=>status.id, statuses);
    const $110b247b3ee2686c$export$6da1c7e84cedf7 = (0, $3YtPS.createSelector)([
        $110b247b3ee2686c$export$62f3835c38e7545f
    ], $110b247b3ee2686c$var$getIssueStatusByIdMap);
    const $110b247b3ee2686c$export$17d3a761803fe8b8 = (0, $3YtPS.createSelector)([
        $110b247b3ee2686c$export$62f3835c38e7545f
    ], (statuses)=>(0, ($parcel$interopDefault($fn8B5)))(statuses, ({ categoryId: categoryId, name: name })=>`${categoryId} ${name}`));
    const $110b247b3ee2686c$var$getIssueStatusTypeIdsOfCompanyManagedProjects = (0, $3YtPS.createSelector)([
        (0, $jpXKt.getCompanyManagedProjects)
    ], (projects)=>(0, ($parcel$interopDefault($27NS3)))(projects, (current, { issueStatusIds: issueStatusIds })=>(0, ($parcel$interopDefault($dDkmN)))(issueStatusIds, current), []));
    const $110b247b3ee2686c$export$422f19a1ad3809f8 = (0, $3YtPS.createSelector)([
        $110b247b3ee2686c$export$62f3835c38e7545f,
        $110b247b3ee2686c$var$getIssueStatusTypeIdsOfCompanyManagedProjects
    ], (issueStatuses, issueStatusIdsOfCompanyManagedProjects)=>issueStatuses.filter((issueStatus)=>issueStatusIdsOfCompanyManagedProjects.includes(issueStatus.id)));
});
parcelRegister("27NS3", function(module, exports) {
    var $2YkAc = parcelRequire("2YkAc");
    var $e7pfQ = parcelRequire("e7pfQ");
    var $bxDef = parcelRequire("bxDef");
    var $87mh8 = parcelRequire("87mh8");
    var $8LQ84 = parcelRequire("8LQ84");
    function $18c2eb891b6f17d9$var$reduce(collection, iteratee, accumulator) {
        var func = $8LQ84(collection) ? $2YkAc : $87mh8, initAccum = arguments.length < 3;
        return func(collection, $bxDef(iteratee, 4), accumulator, initAccum, $e7pfQ);
    }
    module.exports = $18c2eb891b6f17d9$var$reduce;
});
parcelRegister("87mh8", function(module, exports) {
    function $5e90419f1ca7764f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    module.exports = $5e90419f1ca7764f$var$baseReduce;
});
parcelRegister("dDkmN", function(module, exports) {
    var $ekcP3 = parcelRequire("ekcP3");
    var $g7i7g = parcelRequire("g7i7g");
    var $7CoLY = parcelRequire("7CoLY");
    var $f3SOL = parcelRequire("f3SOL");
    var $9eceb74c74389aa2$var$union = $g7i7g(function(arrays) {
        return $7CoLY($ekcP3(arrays, 1, $f3SOL, true));
    });
    module.exports = $9eceb74c74389aa2$var$union;
});
parcelRegister("2QLMT", function(module, exports) {
    $parcel$export(module.exports, "getGroupKey", ()=>$4bd1545ca55b0897$export$54ec6941e5eeb2d3);
    $parcel$export(module.exports, "getIssuesHierarchy", ()=>$4bd1545ca55b0897$export$5a0621fb8f463d9);
    $parcel$export(module.exports, "getOptimizedFixVersion", ()=>$4bd1545ca55b0897$export$6133bf612955a1ac);
    $parcel$export(module.exports, "getOptimizedSprint", ()=>$4bd1545ca55b0897$export$e860cd1899972684);
    $parcel$export(module.exports, "addIssueToGroup", ()=>$4bd1545ca55b0897$export$74ebd6ddbf709589);
    $parcel$export(module.exports, "getTeamsBySprintGroups", ()=>$4bd1545ca55b0897$export$4e7e6196f09f0c44);
    $parcel$export(module.exports, "getTeamsByAncestorSprintGroups", ()=>$4bd1545ca55b0897$export$ad3cc6f16dbcc30a);
    $parcel$export(module.exports, "getTeamsByAncestorSprintGroupsOld", ()=>$4bd1545ca55b0897$export$ceda851c0358dfb6);
    $parcel$export(module.exports, "getReleasesGroups", ()=>$4bd1545ca55b0897$export$49a0d7a2330233a9);
    $parcel$export(module.exports, "getAncestorReleasesGroups", ()=>$4bd1545ca55b0897$export$eb6dc1899ce09205);
    $parcel$export(module.exports, "getAncestorReleasesGroupsOld", ()=>$4bd1545ca55b0897$export$562c3129906c6370);
    var $9U6ZH;
    var $2JlG5;
    var $lV634;
    var $ik0Qc;
    var $fZhYM;
    var $sqeVT;
    var $4ENQh;
    var $c12LJ;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $4bd1545ca55b0897$export$dcda7e10772ff7e8 = (0, $TTKUQ.UNDEFINED_KEY);
    const $4bd1545ca55b0897$export$54ec6941e5eeb2d3 = (groupCombination)=>(0, $4nDwW.filterMap)((grouping)=>(0, $4nDwW.isDefined)(grouping[1]), ([attr, group])=>`${attr}-${String(group)}`, Object.entries(groupCombination).sort(([attr1], [attr2])=>attr1.localeCompare(attr2))).join('-') || $4bd1545ca55b0897$export$dcda7e10772ff7e8;
    const $4bd1545ca55b0897$export$82269f08f5e108b8 = ({ depth: depth = 0, hierarchyIssueIds: hierarchyIssueIds = [], issues: issues, issuesByParent: issuesByParent, isExpanded: isExpanded, issuesInGroupMap: issuesInGroupMap, rootIndex: parentRootIndex, group: group = '', groupCombination: groupCombination, ignoreExpandingState: ignoreExpandingState = false, parentsExpanded: parentsExpanded = true })=>{
        const result = [];
        for(let index = 0; index < issues.length; index++){
            const issue = issues[index];
            const { id: id } = issue;
            let children = issuesByParent[id];
            const rootIndex = (0, parcelRequire("lV634")).default(parentRootIndex) ? index : parentRootIndex;
            const idSuffix = groupCombination ? `:${$4bd1545ca55b0897$export$54ec6941e5eeb2d3(groupCombination)}` : '';
            const expandId = `${id}${idSuffix}`;
            if (children) {
                if ((0, $4nDwW.isDefined)(issuesInGroupMap)) children = children.filter((child)=>!!issuesInGroupMap[child.id] && !hierarchyIssueIds.includes(child.id));
                else children = children.filter((child)=>!hierarchyIssueIds.includes(child.id));
            }
            const isIssueExpanded = isExpanded && !!isExpanded[expandId];
            const processChildren = ignoreExpandingState || isIssueExpanded;
            const scopeIssue = (0, parcelRequire("ik0Qc")).default(issue, {
                depth: depth,
                isExpanded: isIssueExpanded,
                isExpandable: !!children && children.length > 0,
                rootIndex: rootIndex,
                group: group,
                parentsExpanded: parentsExpanded
            });
            result.push(scopeIssue);
            hierarchyIssueIds.push(scopeIssue.id);
            if (processChildren && children) Array.prototype.push.apply(result, $4bd1545ca55b0897$export$82269f08f5e108b8({
                depth: depth + 1,
                issues: children,
                issuesByParent: issuesByParent,
                isExpanded: isExpanded,
                issuesInGroupMap: issuesInGroupMap,
                rootIndex: rootIndex,
                group: group,
                hierarchyIssueIds: hierarchyIssueIds,
                groupCombination: groupCombination,
                ignoreExpandingState: ignoreExpandingState,
                parentsExpanded: parentsExpanded && isIssueExpanded
            }));
        }
        return result;
    };
    const $4bd1545ca55b0897$export$5a0621fb8f463d9 = (0, (0, parcelRequire("4ENQh")).monitor).timeFunction($4bd1545ca55b0897$export$82269f08f5e108b8, 'query_scope_util_getIssuesHierarchy');
    const $4bd1545ca55b0897$export$6133bf612955a1ac = (issue, solution)=>{
        const { assignments: assignments } = issue;
        if (issue.fixVersions && issue.fixVersions.length && !(0, parcelRequire("fZhYM")).default([
            'calculationConfiguration',
            'ignoreReleases'
        ], solution)) return issue.fixVersions;
        if (assignments.length === 0) return issue.fixVersions;
        const { projects: projects } = solution;
        const projectVersions = projects[Number(issue.project)] && projects[Number(issue.project)].versions || [];
        const endedAtForVersion = (version)=>{
            const projectVersion = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('key', version))(projectVersions);
            if (!(0, $4nDwW.isDefined)(projectVersion)) return undefined;
            if ((0, $4nDwW.isDefined)(projectVersion.fixedEnd)) return projectVersion.fixedEnd;
            return projectVersion.end;
        };
        const { laterVersions: laterVersions, latestVersion: latestVersion } = assignments.reduce(({ laterVersions: laterVersions, latestVersion: latestVersion }, { version: version })=>{
            if ((0, $4nDwW.isDefined)(version)) {
                if (version.endsWith('-later')) laterVersions.push(version);
                else {
                    const endedAt = endedAtForVersion(version);
                    if ((0, $4nDwW.isDefined)(endedAt) && endedAt > latestVersion.endedAt) return {
                        laterVersions: laterVersions,
                        latestVersion: {
                            version: version,
                            endedAt: endedAt
                        }
                    };
                    if (latestVersion.endedAt === 0) return {
                        laterVersions: laterVersions,
                        latestVersion: {
                            version: version,
                            endedAt: 0
                        }
                    };
                }
            }
            return {
                laterVersions: laterVersions,
                latestVersion: latestVersion
            };
        }, {
            laterVersions: [],
            latestVersion: {
                version: undefined,
                endedAt: 0
            }
        });
        if (laterVersions.length === 0 && (0, $4nDwW.isDefined)(latestVersion.version)) return [
            latestVersion.version
        ];
    };
    const $4bd1545ca55b0897$export$e860cd1899972684 = (issue, solution)=>{
        const { teams: teams } = solution;
        const { assignments: assignments } = issue;
        if (assignments.length === 0 || issue.level >= (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL) || assignments.length === 1 && !(0, $4nDwW.isDefined)(assignments[0].team) && (0, $4nDwW.isDefined)(assignments[0].interval)) return issue.sprint;
        const { sprintId: sprintId } = assignments.reduce((earliestSprint, { interval: interval, team: team })=>{
            if ((0, $4nDwW.isDefined)(team) && (0, $4nDwW.isDefined)(interval)) {
                const sprint = (0, parcelRequire("fZhYM")).default([
                    team,
                    'intervals',
                    interval
                ], teams);
                if ((0, $4nDwW.isDefined)(sprint) && (!(0, $4nDwW.isDefined)(earliestSprint.start) || sprint.start < earliestSprint.start)) return sprint;
            }
            return earliestSprint;
        }, {
            start: undefined,
            sprintId: undefined
        });
        if (solution.calculationConfiguration && !solution.calculationConfiguration.ignoreSprints && !(0, $4nDwW.isDefined)(sprintId)) return issue.sprint;
        return sprintId;
    };
    const $4bd1545ca55b0897$export$74ebd6ddbf709589 = (issuesByGroup, issue, issueGroup)=>{
        const copiedIsssueByGroup = {
            ...issuesByGroup
        };
        const { issues: issues, parentGroup: parentGroup, ...group } = issueGroup;
        const groupKey = $4bd1545ca55b0897$export$54ec6941e5eeb2d3(group);
        const grouping = copiedIsssueByGroup[groupKey];
        if (grouping && grouping.issues) grouping.issues.add(issue);
        else {
            const newGroup = {
                ...group,
                issues: new Set([
                    issue
                ]),
                ...(0, $4nDwW.isDefined)(parentGroup) ? {
                    parentGroup: parentGroup
                } : {}
            };
            copiedIsssueByGroup[groupKey] = newGroup;
        }
        return copiedIsssueByGroup;
    };
    const $4bd1545ca55b0897$export$4e7e6196f09f0c44 = (issue, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById)=>{
        const groups = [];
        const issueSprint = isOptimizedMode && (0, $4nDwW.isDefined)(issue.optimized) && issue.optimized.sprint || issue.sprint || null;
        const issueTeam = isOptimizedMode && (0, $4nDwW.isDefined)(issue.optimized) && issue.optimized.team || issue.team || null;
        if (issue.completedSprints && issue.completedSprints.length > 0) issue.completedSprints.forEach((completedSprintId)=>{
            if ((0, parcelRequire("2JlG5")).default(completedSprintId, sprintsByIdMap)) groups.push({
                sprint: completedSprintId,
                parentGroup: (0, $TTKUQ.COMPLETED_SPRINTS_GROUP)
            });
        });
        if (issue.completedSprints && issue.completedSprints.includes(issueSprint)) ;
        else if (issueSprint && (0, parcelRequire("2JlG5")).default(issueSprint, sprintsByIdMap)) groups.push({
            sprint: issueSprint
        });
        else if (!issue.completedSprints || !issue.completedSprints.length) groups.push({
            sprint: null
        });
        return groups.map((group)=>{
            const newGroup = {
                ...group
            };
            const sprintWithTeam = newGroup.sprint && issueTeam && sprintsForTeam && sprintsForTeam[issueTeam] && sprintsForTeam[issueTeam].find((sprint)=>sprint.id === newGroup.sprint);
            const isKanbanTeam = issueTeam && teamsById && teamsById[issueTeam] && teamsById[issueTeam].schedulingMode === 'Kanban';
            if (sprintWithTeam && !isKanbanTeam) newGroup.team = issueTeam;
            return newGroup;
        });
    };
    const $4bd1545ca55b0897$export$ad3cc6f16dbcc30a = (issue, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById, issuesById)=>{
        let groups = [];
        let parent = issuesById[issue.parent || ''];
        const ancestorsIds = [];
        while(parent){
            if (ancestorsIds.includes(parent.id)) break;
            groups = groups.concat($4bd1545ca55b0897$export$4e7e6196f09f0c44(parent, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById));
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return groups;
    };
    const $4bd1545ca55b0897$export$ceda851c0358dfb6 = (issue, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById, issuesById)=>{
        let groups = [];
        let parent = issuesById[issue.parent || ''];
        const ancestorsIds = [];
        while(parent && !groups.length){
            if (ancestorsIds.includes(parent.id)) break;
            groups = $4bd1545ca55b0897$export$4e7e6196f09f0c44(parent, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById).filter(({ sprint: sprint })=>sprint !== null);
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return groups;
    };
    const $4bd1545ca55b0897$export$49a0d7a2330233a9 = (issue, isOptimizedMode, versionsById)=>{
        const groups = [];
        let issueFixVersions;
        if (isOptimizedMode && (0, $4nDwW.isDefined)(issue.optimized) && (0, parcelRequire("2JlG5")).default('fixVersions', issue.optimized)) issueFixVersions = issue.optimized.fixVersions;
        else issueFixVersions = issue.fixVersions;
        if (!issueFixVersions || issueFixVersions.length === 0) return [
            {
                release: null
            }
        ];
        issueFixVersions.forEach((fixVersion)=>{
            const version = versionsById[fixVersion];
            if (version && version.releaseStatusId === (0, $TTKUQ.RELEASE_STATUSES).RELEASED) groups.push({
                release: fixVersion,
                parentGroup: (0, $TTKUQ.COMPLETED_RELEASES_GROUP)
            });
            else if (version) groups.push({
                release: fixVersion
            });
        });
        if (groups.length === 0) return [
            {
                release: null
            }
        ];
        return groups;
    };
    const $4bd1545ca55b0897$export$eb6dc1899ce09205 = (issue, isOptimizedMode, versionsById, issuesById)=>{
        let groups = [];
        let parent = issuesById[issue.parent || ''];
        const ancestorsIds = [];
        while(parent){
            if (ancestorsIds.includes(parent.id)) break;
            groups = groups.concat($4bd1545ca55b0897$export$49a0d7a2330233a9(parent, isOptimizedMode, versionsById));
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return groups;
    };
    const $4bd1545ca55b0897$export$562c3129906c6370 = (issue, isOptimizedMode, versionsById, issuesById)=>{
        let groups = [];
        let parent = issuesById[issue.parent || ''];
        const ancestorsIds = [];
        while(parent && !groups.length){
            if (ancestorsIds.includes(parent.id)) break;
            groups = $4bd1545ca55b0897$export$49a0d7a2330233a9(parent, isOptimizedMode, versionsById).filter(({ release: release })=>release !== null);
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return groups;
    };
});
parcelRegister("cZF7S", function(module, exports) {
    $parcel$export(module.exports, "getIsSolutionLatest", ()=>$91dd02589d92c4a1$export$a0ce90303719b0f1);
    $parcel$export(module.exports, "getIsSolutionValid", ()=>$91dd02589d92c4a1$export$99af26022344ca72);
    $parcel$export(module.exports, "getSolution", ()=>$91dd02589d92c4a1$export$aa83c3a07763586);
    $parcel$export(module.exports, "getApplyingProgress", ()=>$91dd02589d92c4a1$export$ce4821395b01b556);
    const $91dd02589d92c4a1$export$a0ce90303719b0f1 = (state)=>state.domain.solution.isLatest;
    const $91dd02589d92c4a1$export$99af26022344ca72 = (state)=>state.domain.solution.isValid;
    const $91dd02589d92c4a1$export$aa83c3a07763586 = (state)=>state.domain.solution;
    const $91dd02589d92c4a1$export$ce4821395b01b556 = (state)=>state.domain.solution.applyingProgress;
    const $91dd02589d92c4a1$export$dffc07d1b5a91631 = (state)=>state.domain.solution.calculationConfiguration;
});
parcelRegister("ljmcc", function(module, exports) {
    $parcel$export(module.exports, "getSprints", ()=>$bd1c0d9cd1ff95f9$export$1b132ed8629e9cb0);
    $parcel$export(module.exports, "getExternalSprints", ()=>$bd1c0d9cd1ff95f9$export$a116ea7be7faa950);
    $parcel$export(module.exports, "getSprintsWithFutureDates", ()=>$bd1c0d9cd1ff95f9$export$890993119fd2e3d2);
    $parcel$export(module.exports, "getFutureSprintsForIssue", ()=>$bd1c0d9cd1ff95f9$export$fe70fca007a8ca4e);
    var $8BDMi;
    var $jB947;
    var $3DBzg;
    var $bQZTk;
    var $2rMKg;
    var $efn2I;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $iGHBn = parcelRequire("iGHBn");
    var $bHTqr = parcelRequire("bHTqr");
    var $dRVQG = parcelRequire("dRVQG");
    var $6TEBn = parcelRequire("6TEBn");
    const $bd1c0d9cd1ff95f9$export$1b132ed8629e9cb0 = (state)=>state.domain.sprints;
    const $bd1c0d9cd1ff95f9$export$a116ea7be7faa950 = (state)=>state.domain.externalSprints;
    const $bd1c0d9cd1ff95f9$export$136e69b79f9b3bc6 = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getTeams),
        (0, $bHTqr.getIssueSources),
        $bd1c0d9cd1ff95f9$export$1b132ed8629e9cb0
    ], (0, $6TEBn.getSprintsForTeamPure));
    const $bd1c0d9cd1ff95f9$export$890993119fd2e3d2 = (0, $3YtPS.createSelector)([
        $bd1c0d9cd1ff95f9$export$136e69b79f9b3bc6,
        (0, $dRVQG.getTeams),
        (0, $bHTqr.getIssueSources),
        $bd1c0d9cd1ff95f9$export$1b132ed8629e9cb0,
        (0, $iGHBn.getDefaultIterationLength)
    ], (0, $6TEBn.getSprintsWithFutureDatesPure));
    const $bd1c0d9cd1ff95f9$export$fe70fca007a8ca4e = ({ team: team, sprint: sprint, completedSprints: completedSprints }, sprintsWithDates)=>{
        const requiredSprintsForIssue = [
            ...completedSprints || [],
            ...sprint ? [
                sprint
            ] : []
        ];
        if ((0, $4nDwW.isDefined)(team)) {
            const futureSprintsForTeam = sprintsWithDates.team[team];
            if ((0, $4nDwW.isDefined)(futureSprintsForTeam)) {
                const sprintIds = futureSprintsForTeam.map((sprint)=>sprint.id);
                if (requiredSprintsForIssue.some((sprintId)=>sprintIds.includes(sprintId))) return futureSprintsForTeam;
            }
        }
        if ((0, $4nDwW.isDefined)(sprint)) {
            const futureSprintsBasedOnIssueSource = sprintsWithDates.sprint[sprint];
            if ((0, $4nDwW.isDefined)(futureSprintsBasedOnIssueSource)) {
                const sprintIds = futureSprintsBasedOnIssueSource.map((sprint)=>sprint.id);
                if (requiredSprintsForIssue.some((sprintId)=>sprintIds.includes(sprintId))) return futureSprintsBasedOnIssueSource;
            }
        }
        if (completedSprints && completedSprints.length) {
            const hasSprints = (id)=>!!sprintsWithDates.sprint[id] && (0, parcelRequire("8BDMi")).default((el)=>(0, parcelRequire("3DBzg")).default((0, parcelRequire("2rMKg")).default('id', el))(requiredSprintsForIssue))(sprintsWithDates.sprint[id]);
            return (0, parcelRequire("bQZTk")).default((0, parcelRequire("efn2I")).default(hasSprints), (0, parcelRequire("jB947")).default, (id)=>id ? sprintsWithDates.sprint[id] : [])(completedSprints);
        }
        return [];
    };
});
parcelRegister("jB947", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e44881384f24038a$export$2e2bcd8739ae039);
    var $4J98j;
    var $e44881384f24038a$var$head = (0, (0, parcelRequire("4J98j")).default)(0);
    var $e44881384f24038a$export$2e2bcd8739ae039 = $e44881384f24038a$var$head;
});
parcelRegister("3DBzg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a6227d0012e3ec6$export$2e2bcd8739ae039);
    var $4MZp5;
    var $c9RLn;
    var $2a6227d0012e3ec6$var$includes = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("4MZp5")).default));
    var $2a6227d0012e3ec6$export$2e2bcd8739ae039 = $2a6227d0012e3ec6$var$includes;
});
parcelRegister("efn2I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5f45738cbb843d7$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5DTpU;
    var $kzWUc;
    var $blU6m;
    var $a5f45738cbb843d7$var$takeWhile = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("5DTpU")).default)([
        'takeWhile'
    ], (0, (0, parcelRequire("kzWUc")).default), function takeWhile(fn, xs) {
        var idx = 0;
        var len = xs.length;
        while(idx < len && fn(xs[idx]))idx += 1;
        return (0, (0, parcelRequire("blU6m")).default)(0, idx, xs);
    }));
    var $a5f45738cbb843d7$export$2e2bcd8739ae039 = $a5f45738cbb843d7$var$takeWhile;
});
parcelRegister("kzWUc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efb4c4e8ff231648$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7C2oN;
    var $7D5kn;
    var $efb4c4e8ff231648$var$XTakeWhile = function() {
        function XTakeWhile(f, xf) {
            this.xf = xf;
            this.f = f;
        }
        XTakeWhile.prototype['@@transducer/init'] = (0, (0, parcelRequire("7D5kn")).default).init;
        XTakeWhile.prototype['@@transducer/result'] = (0, (0, parcelRequire("7D5kn")).default).result;
        XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
            return this.f(input) ? this.xf['@@transducer/step'](result, input) : (0, (0, parcelRequire("7C2oN")).default)(result);
        };
        return XTakeWhile;
    }();
    var $efb4c4e8ff231648$var$_xtakeWhile = (0, (0, parcelRequire("c9RLn")).default)(function _xtakeWhile(f, xf) {
        return new $efb4c4e8ff231648$var$XTakeWhile(f, xf);
    });
    var $efb4c4e8ff231648$export$2e2bcd8739ae039 = $efb4c4e8ff231648$var$_xtakeWhile;
});
parcelRegister("iGHBn", function(module, exports) {
    $parcel$export(module.exports, "getDefaultTeamVelocity", ()=>$8ae7994b77444960$export$ed5c36f37a54350e);
    $parcel$export(module.exports, "getDefaultIterationLength", ()=>$8ae7994b77444960$export$f37877a682ee0aaf);
    $parcel$export(module.exports, "getPlanDefaults", ()=>$8ae7994b77444960$export$6495a62a7818a20e);
    $parcel$export(module.exports, "getDefaultSyncStartEnabled", ()=>$8ae7994b77444960$export$2aeef20d067b1e04);
    const $8ae7994b77444960$export$ed5c36f37a54350e = (state)=>state.domain.planDefaults.defaultTeamVelocity || 0;
    const $8ae7994b77444960$export$f37877a682ee0aaf = (state)=>state.domain.planDefaults.defaultIterationLength;
    const $8ae7994b77444960$export$6495a62a7818a20e = (state)=>state.domain.planDefaults;
    const $8ae7994b77444960$export$2aeef20d067b1e04 = (state)=>!!state.domain.planDefaults.defaultSyncStartEnabled;
});
parcelRegister("dRVQG", function(module, exports) {
    $parcel$export(module.exports, "getTeams", ()=>$31ac4c27db466957$export$5a622455e94bac3);
    $parcel$export(module.exports, "getExistingTeams", ()=>$31ac4c27db466957$export$40026669047b0e00);
    $parcel$export(module.exports, "getScenarioRemovedAtlassianTeams", ()=>$31ac4c27db466957$export$320d72aabf95a2ad);
    $parcel$export(module.exports, "getAdditionalTeams", ()=>$31ac4c27db466957$export$8cb15b8f966ebbb9);
    $parcel$export(module.exports, "getAllTeams", ()=>$31ac4c27db466957$export$ff848de5b4c70793);
    $parcel$export(module.exports, "getAllExistingTeams", ()=>$31ac4c27db466957$export$a200a25405172a9f);
    $parcel$export(module.exports, "getOriginalTeams", ()=>$31ac4c27db466957$export$e0a864ffe5709a49);
    $parcel$export(module.exports, "getTeamById", ()=>$31ac4c27db466957$export$5dcc6aff8319c1fe);
    $parcel$export(module.exports, "getAllTeamsById", ()=>$31ac4c27db466957$export$ea9a67254fdb719d);
    $parcel$export(module.exports, "getTeamsById", ()=>$31ac4c27db466957$export$b54b70b5214dea1a);
    $parcel$export(module.exports, "getAdditionalTeamsById", ()=>$31ac4c27db466957$export$d368aeefd0fe1c0);
    $parcel$export(module.exports, "findTeamById", ()=>$31ac4c27db466957$export$93627fd7a1a1fc10);
    $parcel$export(module.exports, "findResourceFromTeam", ()=>$31ac4c27db466957$export$9d1939bc8063970f);
    $parcel$export(module.exports, "findTeamAssociatedWithResource", ()=>$31ac4c27db466957$export$9b2a78fec47a5cad);
    $parcel$export(module.exports, "isTeamwithoutResources", ()=>$31ac4c27db466957$export$2a1144896824746b);
    $parcel$export(module.exports, "getCommitWarningsForTeams", ()=>$31ac4c27db466957$export$3b9a598ad04ed144);
    $parcel$export(module.exports, "getTeamChangesMetaData", ()=>$31ac4c27db466957$export$29c139115e056a14);
    $parcel$export(module.exports, "getWeeklyCapacityByTeam", ()=>$31ac4c27db466957$export$c35afbe880471269);
    $parcel$export(module.exports, "getAddedTWPInfo", ()=>$31ac4c27db466957$export$954edddbabdfd076);
    $parcel$export(module.exports, "getDialogMode", ()=>$31ac4c27db466957$export$dfca671db15d2f8a);
    $parcel$export(module.exports, "getEditedTeam", ()=>$31ac4c27db466957$export$49c12233d021d66b);
    var $3nPAF;
    var $lV634;
    var $4Rr1a;
    var $4R6GH;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $iGHBn = parcelRequire("iGHBn");
    const $31ac4c27db466957$export$5a622455e94bac3 = (state)=>state.domain.teams;
    const $31ac4c27db466957$export$40026669047b0e00 = (0, $3YtPS.createSelector)([
        $31ac4c27db466957$export$5a622455e94bac3
    ], (teams)=>teams.filter((team)=>team.scenarioType !== (0, $TTKUQ.SCENARIO_TYPE).DELETED));
    const $31ac4c27db466957$export$320d72aabf95a2ad = (0, $3YtPS.createSelector)([
        $31ac4c27db466957$export$5a622455e94bac3
    ], (teams)=>teams.filter((team)=>team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).DELETED && team.shareable));
    const $31ac4c27db466957$export$8cb15b8f966ebbb9 = (state)=>{
        return (0, (0, parcelRequire("4R6GH")).fg)('eou_open_team_dialog_in_timeline') ? state.domain.teamsAdditional.filter(({ id: id })=>!state.domain.teams.some((team)=>team.id === id)) : state.domain.teamsAdditional;
    };
    const $31ac4c27db466957$export$99158a173ae93ce8 = (0, $3YtPS.createSelector)([
        $31ac4c27db466957$export$8cb15b8f966ebbb9
    ], (teams)=>teams.filter((team)=>team.scenarioType !== (0, $TTKUQ.SCENARIO_TYPE).DELETED));
    const $31ac4c27db466957$export$ff848de5b4c70793 = (0, $3YtPS.createSelector)([
        $31ac4c27db466957$export$5a622455e94bac3,
        $31ac4c27db466957$export$8cb15b8f966ebbb9
    ], (teams, additionalTeams)=>teams.concat(additionalTeams));
    const $31ac4c27db466957$export$a200a25405172a9f = (0, $3YtPS.createSelector)([
        $31ac4c27db466957$export$ff848de5b4c70793
    ], (teams)=>teams.filter((team)=>team.scenarioType !== (0, $TTKUQ.SCENARIO_TYPE).DELETED));
    const $31ac4c27db466957$export$e0a864ffe5709a49 = (state)=>state.domain.originalTeams;
    const $31ac4c27db466957$export$5dcc6aff8319c1fe = (state, teamId)=>{
        const teams = $31ac4c27db466957$export$5a622455e94bac3(state);
        return teams.find((team)=>team.id === teamId);
    };
    const $31ac4c27db466957$export$6cbb2fc52fbb30a6 = (teams)=>(0, $4nDwW.indexBy)((x)=>x.id, teams);
    const $31ac4c27db466957$export$ea9a67254fdb719d = (0, $3YtPS.createSelector)([
        $31ac4c27db466957$export$ff848de5b4c70793
    ], $31ac4c27db466957$export$6cbb2fc52fbb30a6);
    const $31ac4c27db466957$export$b54b70b5214dea1a = (0, $3YtPS.createSelector)([
        $31ac4c27db466957$export$5a622455e94bac3
    ], $31ac4c27db466957$export$6cbb2fc52fbb30a6);
    const $31ac4c27db466957$export$d368aeefd0fe1c0 = (0, $3YtPS.createSelector)([
        $31ac4c27db466957$export$8cb15b8f966ebbb9
    ], $31ac4c27db466957$export$6cbb2fc52fbb30a6);
    const $31ac4c27db466957$export$88f9e108414d3399 = (teams, defaultTeamVelocity)=>{
        const velocityMap = {};
        teams.forEach((team)=>{
            velocityMap[team.id] = team.velocity || team.velocity === 0 ? team.velocity : defaultTeamVelocity;
        });
        return velocityMap;
    };
    const $31ac4c27db466957$export$2a00e87e65278669 = (0, $3YtPS.createSelector)([
        $31ac4c27db466957$export$5a622455e94bac3,
        (0, $iGHBn.getDefaultTeamVelocity)
    ], $31ac4c27db466957$export$88f9e108414d3399);
    const $31ac4c27db466957$export$93627fd7a1a1fc10 = (teams, teamId)=>teams.find((team)=>team.id === teamId);
    const $31ac4c27db466957$export$9d1939bc8063970f = (team, resourceKey)=>team.resources.find((resource)=>resource.itemKey === resourceKey);
    const $31ac4c27db466957$export$9b2a78fec47a5cad = (teams, resourceKey)=>teams.find((team)=>$31ac4c27db466957$export$9d1939bc8063970f(team, resourceKey));
    const $31ac4c27db466957$export$2a1144896824746b = (team)=>(0, parcelRequire("lV634")).default(team.resources) || (0, parcelRequire("3nPAF")).default(team.resources) || team.resources.filter(({ scenarioType: scenarioType })=>scenarioType !== (0, $TTKUQ.SCENARIO_TYPE).DELETED).length === 0;
    const $31ac4c27db466957$export$3b9a598ad04ed144 = ({ domain: { updateJira: { warnings: warnings } } })=>warnings[(0, $TTKUQ.ENTITY).TEAM];
    const $31ac4c27db466957$export$29c139115e056a14 = ({ domain: { updateJira: updateJira } })=>{
        if (updateJira && updateJira.changes && updateJira.changes.data && updateJira.changes.data.metaData && updateJira.changes.data.metaData.teams) return updateJira.changes.data.metaData.teams;
    };
    const $31ac4c27db466957$export$1e467c0c5872b46b = (state)=>state.ui.Top.TitleBar.UpdateJira.expandedChanges.TEAM;
    const $31ac4c27db466957$export$a6380030161f6417 = (state)=>state.ui.Top.TitleBar.UpdateJira.selectedChanges.TEAM;
    const $31ac4c27db466957$var$getWeeklyCapacity = (planDefaults)=>(team)=>{
            if (team.weeklyHours || team.weeklyHours === 0) return team.weeklyHours;
            return planDefaults.defaultTeamWeeklyHours || 0;
        };
    const $31ac4c27db466957$export$c35afbe880471269 = (0, $3YtPS.createSelector)([
        $31ac4c27db466957$export$b54b70b5214dea1a,
        (0, $iGHBn.getPlanDefaults)
    ], (teamsById, planDefaults)=>(0, parcelRequire("4Rr1a")).default($31ac4c27db466957$var$getWeeklyCapacity(planDefaults), teamsById));
    const $31ac4c27db466957$export$954edddbabdfd076 = (state)=>({
            teamTitle: state.ui.Main.Tabs.Teams.CreateTeam.addedTWPTeamTitle,
            teamId: state.ui.Main.Tabs.Teams.CreateTeam.addedTWPTeamId
        });
    const $31ac4c27db466957$export$dfca671db15d2f8a = (state)=>state.ui.Main.Tabs.Teams.TeamsList.dialogMode;
    const $31ac4c27db466957$export$49c12233d021d66b = (state)=>state.ui.Main.Tabs.Teams.TeamsList.editedTeam;
});
parcelRegister("6TEBn", function(module, exports) {
    $parcel$export(module.exports, "getSprintsForTeamPure", ()=>$c9acad0f0ca67023$export$9243dfc1617c55b8);
    $parcel$export(module.exports, "getSprintsForIssueSourcesPure", ()=>$c9acad0f0ca67023$export$75614dbaeb172566);
    $parcel$export(module.exports, "getSprintsAndTeamsByIssueSourcesPure", ()=>$c9acad0f0ca67023$export$83fd28707f2693a7);
    $parcel$export(module.exports, "getSprintStatesCategoriesPure", ()=>$c9acad0f0ca67023$export$84f58648e5fd0982);
    $parcel$export(module.exports, "getSprintById", ()=>$c9acad0f0ca67023$export$2408d631da3b8ccd);
    $parcel$export(module.exports, "getSprintByIdMapPure", ()=>$c9acad0f0ca67023$export$7218eb788b037547);
    $parcel$export(module.exports, "getIssuesByKanbanIterationPure", ()=>$c9acad0f0ca67023$export$6456c14aff191bdf);
    $parcel$export(module.exports, "getIssuesBySprintPure", ()=>$c9acad0f0ca67023$export$39b9f591cb5babf9);
    $parcel$export(module.exports, "getIssuesBySprintOptimizedPure", ()=>$c9acad0f0ca67023$export$352df393d87c6e45);
    $parcel$export(module.exports, "getSprintStreamsForTeamsPure", ()=>$c9acad0f0ca67023$export$366891b86c1a480d);
    $parcel$export(module.exports, "getSprintsStreamsGetterPure", ()=>$c9acad0f0ca67023$export$2c19bb597f3993ce);
    $parcel$export(module.exports, "getSprintIdsWithDatesIsInconsistentPure", ()=>$c9acad0f0ca67023$export$c501cbd65c882409);
    $parcel$export(module.exports, "getSprintStreamsUnitsForTeamsPure", ()=>$c9acad0f0ca67023$export$a2649b86fe314f7f);
    $parcel$export(module.exports, "getSprintStreamsUnitsGetterPure", ()=>$c9acad0f0ca67023$export$364b800ef2163c);
    $parcel$export(module.exports, "getSprintsWithFutureDatesPure", ()=>$c9acad0f0ca67023$export$eb0254c397e556b3);
    $parcel$export(module.exports, "getTargetDatesFromSprints", ()=>$c9acad0f0ca67023$export$6b6ffbeb66570a75);
    $parcel$export(module.exports, "getFutureSprintGroups", ()=>$c9acad0f0ca67023$export$d7616b811073c058);
    $parcel$export(module.exports, "getSprintsCapacityOnTimelinePure", ()=>$c9acad0f0ca67023$export$230a55ad90f8755);
    $parcel$export(module.exports, "convertCapacityByPlanningUnit", ()=>$c9acad0f0ca67023$export$570cdbd5979ccd);
    $parcel$export(module.exports, "convertCapacityFromPlanningUnitToSeconds", ()=>$c9acad0f0ca67023$export$acbcfbe3e761e0b4);
    $parcel$export(module.exports, "getPlannedCapacityChangesPure", ()=>$c9acad0f0ca67023$export$5389b2bbf0271c30);
    $parcel$export(module.exports, "getSprintChangesPure", ()=>$c9acad0f0ca67023$export$7ad618a806be26f0);
    $parcel$export(module.exports, "formatSprintUTCTime", ()=>$c9acad0f0ca67023$export$c0501b9f0bd00198);
    $parcel$export(module.exports, "formatDateRange", ()=>$c9acad0f0ca67023$export$2e9241a0bdf6c8b8);
    $parcel$export(module.exports, "getLozengeContent", ()=>$c9acad0f0ca67023$export$9f71a9790fe294f);
    $parcel$export(module.exports, "getLozengeAppearance", ()=>$c9acad0f0ca67023$export$4d9e331cafeacb9d);
    $parcel$export(module.exports, "getSprintStateLozengeContent", ()=>$c9acad0f0ca67023$export$fd6ceee9e9533c99);
    $parcel$export(module.exports, "getSprintStateLabel", ()=>$c9acad0f0ca67023$export$6f891d146561f05a);
    var $561FV = parcelRequire("561FV");
    var $ggSx2 = parcelRequire("ggSx2");
    var $D5mr3 = parcelRequire("D5mr3");
    var $gamDR = parcelRequire("gamDR");
    var $h2uoz;
    var $7WM3o;
    var $b1yMp;
    var $8Tt2N;
    var $dl2NH;
    var $jVZZA;
    var $25ys6;
    var $4wiYB;
    var $jB947;
    var $83IGl;
    var $3nPAF;
    var $lV634;
    var $3A0dU;
    var $4Rr1a;
    var $ik0Qc;
    var $8r8wv;
    var $fZhYM;
    var $bQZTk;
    var $2rMKg;
    var $b8GVJ;
    var $7Zjd1;
    var $h35CY;
    var $2HSYk;
    var $l7aHc;
    var $6nTyZ;
    var $bjzU8;
    var $4R6GH;
    var $gh61P;
    var $aipk9;
    var $flnZx;
    var $c12LJ;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    const { TODO: $c9acad0f0ca67023$var$TODO, INPROGRESS: $c9acad0f0ca67023$var$INPROGRESS, DONE: $c9acad0f0ca67023$var$DONE } = (0, $TTKUQ.ISSUE_STATUS_CATEGORIES);
    const $c9acad0f0ca67023$export$4ff47658dac00b1a = (0, (0, parcelRequire("flnZx")).ONE_WEEK);
    const $c9acad0f0ca67023$var$isInfiniteTimelineRange = (timelineRange)=>Math.abs(timelineRange.start) + Math.abs(timelineRange.end) === Infinity;
    const $c9acad0f0ca67023$export$14dc3d2554a83ab1 = (sprintsInOrder, sprints)=>{
        const sprintOrdering = (0, ($parcel$interopDefault($ggSx2)))(sprintsInOrder);
        return sprints.filter((sprint)=>(0, ($parcel$interopDefault($561FV)))(sprintOrdering, sprint.id)).sort((a, b)=>{
            const indexA = parseInt(sprintOrdering[a.id], 10);
            const indexB = parseInt(sprintOrdering[b.id], 10);
            return indexA - indexB;
        });
    };
    const $c9acad0f0ca67023$export$98922a1700a2456 = ({ teams: teams })=>({ team: team, interval: interval })=>(0, $4nDwW.isDefined)(team) && (0, $4nDwW.isDefined)(interval) ? (0, parcelRequire("fZhYM")).default([
                team,
                'intervals',
                interval
            ], teams) : null;
    const $c9acad0f0ca67023$export$1b132ed8629e9cb0 = (state)=>state.domain.sprints;
    const $c9acad0f0ca67023$export$9243dfc1617c55b8 = (teams, issueSources, sprints)=>{
        const teamsToSprintMap = {};
        teams.forEach((team)=>{
            let sprintsForTeam;
            const issueSource = issueSources.find((issueSource)=>issueSource.id === team.issueSource);
            if ((0, $4nDwW.isDefined)(issueSource) && (0, $4nDwW.isDefined)(issueSource.sprintIds)) sprintsForTeam = $c9acad0f0ca67023$export$14dc3d2554a83ab1(issueSource.sprintIds, sprints);
            teamsToSprintMap[team.id] = sprintsForTeam || [];
        });
        return teamsToSprintMap;
    };
    const $c9acad0f0ca67023$export$75614dbaeb172566 = (issueSourcesById, sprintsById, disabledSprintsById)=>(0, parcelRequire("4Rr1a")).default(({ sprintIds: sprintIds = [] })=>(0, parcelRequire("b8GVJ")).default(sprintIds.map((x)=>`${x}`).filter((x)=>disabledSprintsById[x] === undefined), sprintsById), issueSourcesById);
    const $c9acad0f0ca67023$export$83fd28707f2693a7 = (issueSourcesById, sprintsById, teams, disabledSprintsById)=>{
        const sprintsAndTeamsByIssueSources = {
            sprintsWithTeams: [],
            sprintsWithoutTeams: []
        };
        const uniqueSprintIds = new Set();
        for (const [issueSourceId, issueSource] of Object.entries(issueSourcesById)){
            const sprintIds = (0, parcelRequire("2rMKg")).default('sprintIds', issueSource);
            if (sprintIds && sprintIds.length) {
                const sprints = sprintIds.map((x)=>`${x}`).filter((x)=>disabledSprintsById[x] === undefined).map((sprintId)=>sprintsById[sprintId]);
                const teamTitles = (0, $4nDwW.filterMap)((team)=>team.issueSource === Number(issueSourceId), (team)=>team.title, teams);
                if (teamTitles && teamTitles.length) sprintsAndTeamsByIssueSources.sprintsWithTeams.push({
                    teams: teamTitles,
                    sprints: sprints
                });
                else sprints.forEach((sprint)=>{
                    if (!uniqueSprintIds.has(sprint.id)) {
                        uniqueSprintIds.add(sprint.id);
                        sprintsAndTeamsByIssueSources.sprintsWithoutTeams.push(sprint);
                    }
                });
            }
        }
        return sprintsAndTeamsByIssueSources;
    };
    const $c9acad0f0ca67023$export$de039e868213edc8 = (sprintIds, uniqueFilteredSprints)=>{
        if (uniqueFilteredSprints.size > 0) {
            if (sprintIds.length > 0 && sprintIds.length <= uniqueFilteredSprints.size && !sprintIds.some((el)=>!uniqueFilteredSprints.has(el))) return (0, $TTKUQ.CHECKBOX_STATES).CHECKED;
            if (sprintIds.some((el)=>uniqueFilteredSprints.has(el))) return (0, $TTKUQ.CHECKBOX_STATES).INDETERMINATE;
        }
        return (0, $TTKUQ.CHECKBOX_STATES).UNCHECKED;
    };
    const $c9acad0f0ca67023$export$84f58648e5fd0982 = (sprintsIdsByState, externalSprintIds, uniqueFilteredSprints)=>{
        const sprintStateCategories = [];
        Object.keys((0, $TTKUQ.SPRINT_STATES)).forEach((sprintState)=>{
            const sprintIds = sprintsIdsByState[sprintState] || [];
            sprintStateCategories.push({
                checkboxState: $c9acad0f0ca67023$export$de039e868213edc8(sprintIds, uniqueFilteredSprints),
                sprintIds: sprintIds,
                sprintState: sprintState
            });
        });
        if (externalSprintIds.length) sprintStateCategories.push({
            checkboxState: $c9acad0f0ca67023$export$de039e868213edc8(externalSprintIds, uniqueFilteredSprints),
            sprintIds: externalSprintIds,
            sprintState: (0, $TTKUQ.EXTERNAL_SPRINT)
        });
        return sprintStateCategories;
    };
    const $c9acad0f0ca67023$export$2408d631da3b8ccd = (sprints, sprintId)=>sprints.find((sprint)=>sprint.id === sprintId);
    const $c9acad0f0ca67023$export$7218eb788b037547 = (sprints)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), sprints);
    const $c9acad0f0ca67023$export$c3dd5085da5f7cb7 = (start, end, timeline)=>{
        const unitLength = Math.min(timeline.end, end) - Math.max(timeline.start, start);
        const rangeLength = timeline.end - timeline.start;
        return 100 * unitLength / rangeLength;
    };
    const $c9acad0f0ca67023$var$calcOffsetPercentage = (startOfUtcDate, timeline)=>{
        const offsetLength = Math.max(timeline.start, startOfUtcDate) - timeline.start;
        return 100 * offsetLength / (timeline.end - timeline.start);
    };
    const $c9acad0f0ca67023$var$sprintStartsWithinTimeline = (timeline, sprint)=>timeline.end >= sprint.startDate && sprint.startDate >= timeline.start;
    const $c9acad0f0ca67023$var$sprintEndsWithinTimeline = (timeline, sprint)=>sprint.endDate >= timeline.start && timeline.end >= sprint.endDate;
    const $c9acad0f0ca67023$var$sprintAppearsOnTimeline = (timeline, sprint)=>$c9acad0f0ca67023$var$sprintStartsWithinTimeline(timeline, sprint) || $c9acad0f0ca67023$var$sprintEndsWithinTimeline(timeline, sprint);
    const $c9acad0f0ca67023$var$createPastSprint = (startDate, endDate, schedulingMode)=>({
            id: 'PAST',
            title: 'Past Sprint',
            state: (0, $TTKUQ.SPRINT_STATES).CLOSED,
            startDate: startDate,
            endDate: endDate,
            issueSources: [],
            schedulingMode: schedulingMode,
            rawStartDate: startDate,
            rawEndDate: endDate
        });
    const $c9acad0f0ca67023$var$createFutureSprint = (startDate, endDate, schedulingMode)=>({
            id: 'FUTURE',
            title: 'Future Sprint',
            state: (0, $TTKUQ.SPRINT_STATES).FUTURE,
            startDate: startDate,
            endDate: endDate,
            issueSources: [],
            schedulingMode: schedulingMode,
            rawStartDate: startDate,
            rawEndDate: endDate
        });
    const $c9acad0f0ca67023$export$16f1e219d71d96ad = (sprints)=>{
        if (sprints.length < 2) return [
            sprints
        ];
        const streams = [];
        let pool = sprints;
        let nextPool = [];
        while(pool.length > 0){
            let cursor = pool[0];
            const stream = [
                cursor
            ];
            for (const sprint of pool.slice(1))if (cursor.rawEndDate && sprint.rawStartDate && (0, (0, parcelRequire("flnZx")).endOfUtcDay)(cursor.rawEndDate) - (0, (0, parcelRequire("flnZx")).startOfUtcDay)(sprint.rawStartDate) > (0, (0, parcelRequire("flnZx")).ONE_DAY)) nextPool.push(sprint);
            else {
                cursor = sprint;
                stream.push(cursor);
            }
            streams.push(stream);
            pool = nextPool;
            nextPool = [];
        }
        return streams;
    };
    const $c9acad0f0ca67023$var$startDateAscend = (0, $4nDwW.ascend)((x)=>x.startDate);
    const $c9acad0f0ca67023$var$endDateAscend = (0, $4nDwW.ascend)((x)=>x.endDate);
    const $c9acad0f0ca67023$export$f698cc36cb31ff11 = (sprints)=>sprints.map((sprint)=>{
            const endDate = sprint.endDate && (0, (0, parcelRequire("flnZx")).startOfUtcDay)(sprint.completeDate || sprint.endDate) - 1;
            return {
                ...sprint,
                startDate: (0, (0, parcelRequire("flnZx")).startOfUtcDay)(sprint.startDate),
                endDate: endDate,
                rawStartDate: sprint.startDate,
                rawEndDate: sprint.completeDate || sprint.endDate
            };
        }).sort((a, b)=>$c9acad0f0ca67023$var$startDateAscend(a, b) || $c9acad0f0ca67023$var$endDateAscend(a, b));
    const $c9acad0f0ca67023$export$770b406429d15ffa = (sprints, start, sprintLengthInMillis)=>{
        const startOfTomorrow = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(Date.now()) + (0, (0, parcelRequire("flnZx")).ONE_DAY);
        let currentStart = Math.max((0, (0, parcelRequire("flnZx")).startOfUtcDay)(start + 1), startOfTomorrow);
        return sprints.map((sprint)=>{
            let rawStartDate = sprint.startDate || currentStart;
            let startDate = sprint.startDate ? (0, (0, parcelRequire("flnZx")).startOfUtcDay)(sprint.startDate) : currentStart;
            if (!(0, $4nDwW.isDefined)(sprint.startDate) && (0, $4nDwW.isDefined)(sprint.endDate)) {
                rawStartDate = sprint.endDate - sprintLengthInMillis;
                startDate = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(rawStartDate);
            }
            const sprintLengthAdjusted = sprintLengthInMillis - (0, (0, parcelRequire("flnZx")).ONE_DAY);
            const rawEndDate = sprint.endDate || (0, (0, parcelRequire("flnZx")).endOfUtcDay)(startDate + sprintLengthAdjusted);
            const endDate = (0, (0, parcelRequire("flnZx")).endOfUtcDay)(sprint.endDate || startDate + sprintLengthAdjusted);
            currentStart = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(endDate + (0, (0, parcelRequire("flnZx")).ONE_DAY));
            return {
                ...sprint,
                startDate: startDate,
                endDate: endDate,
                rawStartDate: rawStartDate,
                rawEndDate: rawEndDate
            };
        });
    };
    const $c9acad0f0ca67023$export$800f6e20804f9ed1 = (start, end, sprintLengthInMillis, schedulingMode)=>{
        const sprints = [];
        if ($c9acad0f0ca67023$var$isInfiniteTimelineRange({
            start: start,
            end: end
        })) return sprints;
        let endDate = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(end);
        while(endDate > start){
            const startDate = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(endDate - sprintLengthInMillis);
            sprints.push($c9acad0f0ca67023$var$createPastSprint(startDate, endDate - 1, schedulingMode));
            endDate = startDate;
        }
        return sprints.reverse();
    };
    const $c9acad0f0ca67023$export$ce1cefb45c8832 = (start, end, sprintLengthInMillis, schedulingMode)=>{
        const sprints = [];
        if ($c9acad0f0ca67023$var$isInfiniteTimelineRange({
            start: start,
            end: end
        })) return sprints;
        let startDate = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(start + 1000);
        while(startDate < end){
            const endDate = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(startDate + sprintLengthInMillis);
            sprints.push($c9acad0f0ca67023$var$createFutureSprint(startDate, endDate - 1, schedulingMode));
            startDate = endDate;
        }
        return sprints;
    };
    const $c9acad0f0ca67023$export$ac96f955bd8392a1 = (sprints, timeline, omitGaps = false)=>{
        const units = [];
        let cursor = timeline.start;
        for (const { title: title, id: id, state: state, startDate: startDate, endDate: endDate, issueSources: issueSources, planned: planned, rawStartDate: rawStartDate, rawEndDate: rawEndDate, ...rest } of sprints){
            if (cursor + 1 < startDate && !omitGaps) units.push({
                id: 'GAP',
                widthPercentage: $c9acad0f0ca67023$export$c3dd5085da5f7cb7(cursor, startDate, timeline),
                label: {
                    display: 'none'
                },
                offset: $c9acad0f0ca67023$var$calcOffsetPercentage((0, (0, parcelRequire("flnZx")).startOfUtcDay)(startDate), timeline),
                state: state,
                startDate: cursor,
                endDate: startDate,
                issueSources: issueSources,
                planned: planned,
                rawStartDate: cursor,
                rawEndDate: rawEndDate
            });
            units.push({
                id: id,
                widthPercentage: $c9acad0f0ca67023$export$c3dd5085da5f7cb7(startDate, endDate, timeline),
                label: {
                    display: title
                },
                offset: $c9acad0f0ca67023$var$calcOffsetPercentage((0, (0, parcelRequire("flnZx")).startOfUtcDay)(startDate), timeline),
                state: state,
                startDate: startDate,
                endDate: endDate,
                issueSources: issueSources,
                planned: planned,
                rawStartDate: rawStartDate,
                rawEndDate: rawEndDate,
                ...rest
            });
            cursor = endDate;
        }
        if (cursor < timeline.end && !omitGaps) units.push({
            id: 'GAP',
            widthPercentage: $c9acad0f0ca67023$export$c3dd5085da5f7cb7(cursor, timeline.end, timeline),
            label: {
                display: 'none'
            },
            offset: $c9acad0f0ca67023$var$calcOffsetPercentage((0, (0, parcelRequire("flnZx")).startOfUtcDay)(timeline.end), timeline),
            state: (0, $TTKUQ.SPRINT_STATES).FUTURE,
            startDate: cursor,
            endDate: timeline.end,
            issueSources: [],
            planned: false,
            rawStartDate: cursor,
            rawEndDate: timeline.end
        });
        return units;
    };
    const $c9acad0f0ca67023$var$getIssueDates = (issue, mode)=>{
        const isOptimized = mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771);
        const { assignments: assignments, baselineStart: baselineStart, baselineEnd: baselineEnd } = issue;
        let start = baselineStart;
        let end = baselineEnd;
        if (isOptimized) {
            const optimizedStart = assignments.reduce((acc, { start: start })=>Math.min(acc, start || acc), Infinity);
            if ((0, ($parcel$interopDefault($D5mr3)))(optimizedStart)) start = optimizedStart;
            const optimizedEnd = assignments.reduce((acc, { end: end })=>Math.max(acc, end || acc), -Infinity);
            if ((0, ($parcel$interopDefault($D5mr3)))(optimizedStart)) end = optimizedEnd;
        }
        return {
            start: start,
            end: end
        };
    };
    const $c9acad0f0ca67023$export$58007ae5dd91fcc6 = (team, sprintsForTeam, defaultIterationLength)=>{
        if (!(0, $4nDwW.isDefined)(team.issueSource)) return [];
        const sprintLengthInMillis = (team.iterationLength || defaultIterationLength || 0) * (0, (0, parcelRequire("flnZx")).ONE_WEEK);
        if (sprintLengthInMillis === 0) return [];
        const [futureSprints, pastAndActiveSprints] = (0, parcelRequire("8r8wv")).default((x)=>x.state === (0, $TTKUQ.SPRINT_STATES).FUTURE, sprintsForTeam[team.id]);
        const pastAndActiveSprintsSortedByDate = $c9acad0f0ca67023$export$f698cc36cb31ff11(pastAndActiveSprints);
        const lastRealSprint = (0, parcelRequire("3A0dU")).default(pastAndActiveSprintsSortedByDate);
        const lastRealEndDate = lastRealSprint && lastRealSprint.endDate || 0;
        const futureSprintsWithDates = $c9acad0f0ca67023$export$770b406429d15ffa(futureSprints, lastRealEndDate, sprintLengthInMillis);
        return [
            ...pastAndActiveSprintsSortedByDate,
            ...futureSprintsWithDates
        ].sort((a, b)=>$c9acad0f0ca67023$var$startDateAscend(a, b) || $c9acad0f0ca67023$var$endDateAscend(a, b));
    };
    const $c9acad0f0ca67023$export$79672c235d041dc0 = (mode, adjustment)=>(0, $4nDwW.sortWith)([
            (0, $4nDwW.ascend)((issue)=>$c9acad0f0ca67023$var$getIssueDates(issue, mode).end || 0),
            (0, $4nDwW.ascend)(({ level: level })=>level),
            (0, $4nDwW.ascend)(({ lexoRank: lexoRank })=>lexoRank || ''),
            (0, $4nDwW.ascend)(({ id: id })=>adjustment.indexOf(id))
        ]);
    const $c9acad0f0ca67023$export$1395453ccdeb45c4 = (numberOfMembersInTheTeam, capacityOfTeam)=>{
        const adjustedNumberOfMembersInTheTeam = numberOfMembersInTheTeam === 0 ? 1 : numberOfMembersInTheTeam;
        const roundCapacityPerMember = Math.floor(capacityOfTeam / adjustedNumberOfMembersInTheTeam);
        let remainingCapacity = capacityOfTeam % adjustedNumberOfMembersInTheTeam;
        return (0, parcelRequire("l7aHc")).default(()=>{
            let availableCapacity = roundCapacityPerMember;
            if (remainingCapacity > 0) {
                availableCapacity += 1;
                remainingCapacity -= 1;
            }
            return {
                availableCapacity: availableCapacity,
                usedCapacity: 0
            };
        }, adjustedNumberOfMembersInTheTeam);
    };
    const $c9acad0f0ca67023$export$78919c276404a113 = ({ defaultTeamVelocity: defaultTeamVelocity, issuesBySprint: issuesBySprint, issueStatusById: issueStatusById, planningUnit: planningUnit, stream: stream, team: team, weeklyCapacityByTeam: weeklyCapacityByTeam, boardId: boardId, mode: mode, issueLexoRankAdjustments: issueLexoRankAdjustments, issuesByTeam: issuesByTeam, plannedCapacities: plannedCapacities })=>{
        const estimateAttribute = planningUnit === (0, $TTKUQ.PlanningUnits).storyPoints ? 'storyPoints' : 'timeEstimate';
        const sorter = $c9acad0f0ca67023$export$79672c235d041dc0(mode, issueLexoRankAdjustments);
        const carryOver = new Map();
        const updatedStream = [];
        const numberOfMembersInTheTeam = team.resources.filter(({ scenarioType: scenarioType })=>scenarioType !== (0, $TTKUQ.SCENARIO_TYPE).DELETED).length || 1;
        const getCapacityOfTeam = (team, sprint)=>{
            const iterationId = team.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).kanban ? String(sprint.startDate) : sprint.id;
            const plannedCapacity = (0, parcelRequire("fZhYM")).default([
                team.id,
                iterationId
            ], plannedCapacities);
            if (plannedCapacity) return plannedCapacity.capacity;
            if (planningUnit === (0, $TTKUQ.PlanningUnits).storyPoints) return team.velocity || team.velocity === 0 ? team.velocity : defaultTeamVelocity;
            return (0, (0, parcelRequire("flnZx")).ONE_HOUR) * weeklyCapacityByTeam[team.id] * (0, (0, parcelRequire("flnZx")).getWorkingMillionSecondsBetweenTwoDates)(sprint.startDate, sprint.endDate) / (5 * (0, (0, parcelRequire("flnZx")).ONE_DAY)) / 1000;
        };
        const getIssuesThatFallInTheSprint = (sprint)=>(issuesByTeam[team.id] || []).filter((issue)=>{
                const { start: start, end: end } = $c9acad0f0ca67023$var$getIssueDates(issue, mode);
                if (issue.sprint && team.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).scrum) return false;
                if (!(0, $4nDwW.isDefined)(sprint.startDate) || !(0, $4nDwW.isDefined)(sprint.endDate) || !(0, $4nDwW.isDefined)(start) || !(0, $4nDwW.isDefined)(end)) return false;
                if (!issue.sprint && issue.completedSprints && !(0, parcelRequire("3nPAF")).default(issue.completedSprints) && issue.status && issueStatusById[issue.status] && issueStatusById[issue.status].categoryId === (0, $TTKUQ.ISSUE_STATUS_CATEGORIES).DONE && end < sprint.rawStartDate) return false;
                return start >= sprint.startDate && start <= sprint.endDate || end >= sprint.startDate && end <= sprint.endDate || start <= sprint.startDate && end >= sprint.endDate;
            });
        const getIssuesAssignedToTheSprint = (sprint)=>(issuesByTeam[team.id] || []).filter((issue)=>{
                const optimizedSprint = (0, parcelRequire("fZhYM")).default([
                    'optimized',
                    'sprint'
                ], issue);
                return mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771) ? optimizedSprint === sprint.id : issue.sprint === sprint.id;
            });
        const getNextAssignableMemberBucket = (memberBuckets, estimateOfIssue)=>{
            const sortedByCapacity = (0, parcelRequire("h35CY")).default((0, parcelRequire("2rMKg")).default('usedCapacity'), memberBuckets);
            const assignableMiniBucket = sortedByCapacity.find((bucket)=>{
                const remainingBucketCapacity = bucket.availableCapacity - bucket.usedCapacity;
                return remainingBucketCapacity >= estimateOfIssue;
            });
            if (!assignableMiniBucket) return sortedByCapacity.find((bucket)=>bucket.availableCapacity - bucket.usedCapacity > 0);
            return assignableMiniBucket;
        };
        const isTheLastSprintOfIssue = (issue, sprint)=>{
            const { end: end } = $c9acad0f0ca67023$var$getIssueDates(issue, mode);
            return end && end >= sprint.startDate && end <= sprint.endDate;
        };
        const getAssignableCapacity = ({ issue: issue, nextAssignableMemberBucket: nextAssignableMemberBucket, estimateOfIssue: estimateOfIssue, assignRemainingEstimateToBucket: assignRemainingEstimateToBucket })=>{
            let usedSprintCapacity = 0;
            const remainingCapacityInBucket = nextAssignableMemberBucket ? Math.max(nextAssignableMemberBucket.availableCapacity - nextAssignableMemberBucket.usedCapacity, 0) : 0;
            if (estimateOfIssue <= remainingCapacityInBucket || assignRemainingEstimateToBucket) {
                if (nextAssignableMemberBucket) nextAssignableMemberBucket.usedCapacity += estimateOfIssue;
                usedSprintCapacity = estimateOfIssue;
                carryOver.set(issue.id, 0);
            } else {
                if (nextAssignableMemberBucket) nextAssignableMemberBucket.usedCapacity += remainingCapacityInBucket;
                usedSprintCapacity = remainingCapacityInBucket;
                carryOver.set(issue.id, estimateOfIssue - remainingCapacityInBucket);
            }
            return usedSprintCapacity;
        };
        for (const sprint of stream){
            let statusBreakdown = {
                byCategoryId: {
                    [String($c9acad0f0ca67023$var$TODO)]: 0,
                    [String($c9acad0f0ca67023$var$INPROGRESS)]: 0,
                    [String($c9acad0f0ca67023$var$DONE)]: 0
                },
                total: 0
            };
            const allContributingIssues = {};
            let issueWithoutSprintCount = 0;
            let usedCapacity = 0;
            const capacityOfTeam = getCapacityOfTeam(team, sprint);
            const memberBuckets = $c9acad0f0ca67023$export$1395453ccdeb45c4(numberOfMembersInTheTeam, capacityOfTeam);
            if (sprint.state !== (0, $TTKUQ.SPRINT_STATES).CLOSED) {
                const issuesInTheSprint = getIssuesThatFallInTheSprint(sprint);
                const issuesInTheSprintSorted = sorter(issuesInTheSprint);
                const issuesAssignedToTheSprint = getIssuesAssignedToTheSprint(sprint);
                const issuesToBeDistributed = [
                    ...issuesAssignedToTheSprint,
                    ...issuesInTheSprintSorted
                ];
                issuesToBeDistributed.forEach((issue)=>{
                    const estimate = issue[estimateAttribute];
                    if (!issue.sprint) issueWithoutSprintCount += 1;
                    if (!(0, $4nDwW.isDefined)(estimate)) sprint.unestimatedIssuesCount += 1;
                    let estimateOfIssue = carryOver.has(issue.id) ? carryOver.get(issue.id) || 0 : estimate || 0;
                    let nextAssignableMemberBucket = getNextAssignableMemberBucket(memberBuckets, estimateOfIssue);
                    const lastSprintOfTheIssue = issuesAssignedToTheSprint.includes(issue) || isTheLastSprintOfIssue(issue, sprint);
                    const addCapacityToCategory = (capacity)=>{
                        const category = (0, parcelRequire("fZhYM")).default([
                            issue.status || '',
                            'categoryId'
                        ], issueStatusById) || $c9acad0f0ca67023$var$TODO;
                        if (!category) return statusBreakdown;
                        const currentVal = (0, parcelRequire("fZhYM")).default([
                            'byCategoryId',
                            category
                        ], statusBreakdown);
                        return (0, parcelRequire("h2uoz")).default([
                            'byCategoryId',
                            category
                        ], (currentVal || 0) + capacity, statusBreakdown);
                    };
                    let contributingCapacity = 0;
                    const assignCapacity = (capacity)=>{
                        usedCapacity += capacity;
                        contributingCapacity += capacity;
                        statusBreakdown = addCapacityToCategory(capacity);
                    };
                    if (issue.level > (0, (0, parcelRequire("c12LJ")).STORY_LEVEL)) while(estimateOfIssue > 0 && nextAssignableMemberBucket || estimateOfIssue > 0 && lastSprintOfTheIssue){
                        const capacity = getAssignableCapacity({
                            issue: issue,
                            nextAssignableMemberBucket: nextAssignableMemberBucket,
                            estimateOfIssue: estimateOfIssue,
                            assignRemainingEstimateToBucket: lastSprintOfTheIssue && !nextAssignableMemberBucket
                        });
                        assignCapacity(capacity);
                        estimateOfIssue = carryOver.has(issue.id) ? carryOver.get(issue.id) || 0 : estimate || 0;
                        nextAssignableMemberBucket = getNextAssignableMemberBucket(memberBuckets, estimateOfIssue);
                    }
                    else if (nextAssignableMemberBucket || lastSprintOfTheIssue) {
                        const capacity = getAssignableCapacity({
                            issue: issue,
                            nextAssignableMemberBucket: nextAssignableMemberBucket,
                            estimateOfIssue: estimateOfIssue,
                            assignRemainingEstimateToBucket: lastSprintOfTheIssue
                        });
                        assignCapacity(capacity);
                    }
                    allContributingIssues[issue.id] = {
                        ...issue,
                        contributingCapacity: contributingCapacity
                    };
                });
                if ([
                    (0, $TTKUQ.PLANNING_UNITS).HOURS,
                    (0, $TTKUQ.PLANNING_UNITS).DAYS
                ].includes(planningUnit)) statusBreakdown.byCategoryId = (0, parcelRequire("b1yMp")).default((0, parcelRequire("ik0Qc")).default({
                    [String($c9acad0f0ca67023$var$TODO)]: 0,
                    [String($c9acad0f0ca67023$var$INPROGRESS)]: 0,
                    [String($c9acad0f0ca67023$var$DONE)]: 0
                }), (0, parcelRequire("8Tt2N")).default((issue)=>String((0, parcelRequire("fZhYM")).default([
                        issue.status || '',
                        'categoryId'
                    ], issueStatusById) || $c9acad0f0ca67023$var$TODO)))(issuesToBeDistributed);
            }
            const unestimatedIssuesCount = (issuesBySprint[sprint.id] || []).filter((issue)=>issue.team === team.id && !(0, $4nDwW.isDefined)(issue[estimateAttribute])).length;
            statusBreakdown.total = (0, parcelRequire("2HSYk")).default((0, parcelRequire("bjzU8")).default(statusBreakdown.byCategoryId));
            updatedStream.push({
                ...sprint,
                availableCapacity: Number(capacityOfTeam?.toFixed(1)),
                doneEstimate: statusBreakdown.byCategoryId[String($c9acad0f0ca67023$var$DONE)],
                schedulingMode: team.schedulingMode,
                unestimatedIssuesCount: unestimatedIssuesCount,
                issueWithoutSprintCount: issueWithoutSprintCount,
                usedCapacity: usedCapacity,
                statusBreakdown: statusBreakdown,
                allContributingIssues: allContributingIssues,
                boardId: boardId
            });
        }
        return updatedStream;
    };
    const $c9acad0f0ca67023$var$getSprintStreamsForKanbanTeam = ({ issueStatusById: issueStatusById, issuesByKanbanIteration: issuesByKanbanIteration, mode: mode, team: team, timelineRange: timelineRange, weeklyCapacityByTeam: weeklyCapacityByTeam, planningUnit: planningUnit, defaultTeamVelocity: defaultTeamVelocity, issueLexoRankAdjustments: issueLexoRankAdjustments, issuesByTeam: issuesByTeam, boardId: boardId, plannedCapacities: plannedCapacities })=>{
        const activeIterationStart = (0, (0, parcelRequire("flnZx")).startOfUtcWeek)(Date.now()).getTime();
        const activeIterationEnd = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(activeIterationStart + $c9acad0f0ca67023$export$4ff47658dac00b1a) - 1;
        const activeSprint = {
            id: 'ACTIVE',
            title: 'Active Sprint',
            state: (0, $TTKUQ.SPRINT_STATES).ACTIVE,
            startDate: activeIterationStart,
            endDate: activeIterationEnd,
            issueSources: [],
            rawStartDate: activeIterationStart,
            rawEndDate: activeIterationEnd
        };
        const futureSprints = $c9acad0f0ca67023$export$ce1cefb45c8832(activeIterationEnd, timelineRange.end, $c9acad0f0ca67023$export$4ff47658dac00b1a, (0, $TTKUQ.SCHEDULE_MODE).kanban);
        const allSprints = [
            activeSprint,
            ...futureSprints
        ];
        const allSprintsWithCapacity = $c9acad0f0ca67023$export$78919c276404a113({
            defaultTeamVelocity: defaultTeamVelocity,
            issuesBySprint: issuesByKanbanIteration,
            issueStatusById: issueStatusById,
            planningUnit: planningUnit,
            stream: allSprints,
            team: team,
            weeklyCapacityByTeam: weeklyCapacityByTeam,
            boardId: boardId,
            mode: mode,
            issueLexoRankAdjustments: issueLexoRankAdjustments,
            issuesByTeam: issuesByTeam,
            plannedCapacities: plannedCapacities
        });
        const sprintsWithCapacity = allSprintsWithCapacity.filter((sprint)=>$c9acad0f0ca67023$var$sprintAppearsOnTimeline(timelineRange, sprint));
        return [
            sprintsWithCapacity
        ];
    };
    const $c9acad0f0ca67023$export$df033e038ec34c36 = ({ defaultIterationLength: defaultIterationLength, defaultTeamVelocity: defaultTeamVelocity, issueStatusById: issueStatusById, issuesByKanbanIteration: issuesByKanbanIteration, issuesBySprint: issuesBySprint, mode: mode, planningUnit: planningUnit, sprintsForTeam: sprintsForTeam, timelineRange: timelineRange, weeklyCapacityByTeam: weeklyCapacityByTeam, issueSources: issueSources, issueLexoRankAdjustments: issueLexoRankAdjustments, issuesByTeam: issuesByTeam, plannedCapacities: plannedCapacities, filteredSprints: filteredSprints })=>(team)=>{
            const { value: boardId } = issueSources.find((source)=>source.id === team.issueSource) || {};
            if (team.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).kanban) return $c9acad0f0ca67023$var$getSprintStreamsForKanbanTeam({
                issueStatusById: issueStatusById,
                issuesByKanbanIteration: issuesByKanbanIteration,
                mode: mode,
                team: team,
                timelineRange: timelineRange,
                weeklyCapacityByTeam: weeklyCapacityByTeam,
                planningUnit: planningUnit,
                defaultTeamVelocity: defaultTeamVelocity,
                issuesByTeam: issuesByTeam,
                issueLexoRankAdjustments: issueLexoRankAdjustments,
                boardId: boardId,
                plannedCapacities: plannedCapacities
            });
            let sprintsInStream = [];
            sprintsInStream = $c9acad0f0ca67023$export$58007ae5dd91fcc6(team, sprintsForTeam, defaultIterationLength);
            if (!sprintsInStream) return [];
            const tomorrow = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(Date.now() + (0, (0, parcelRequire("flnZx")).ONE_DAY));
            const sprintLengthInMillis = (team.iterationLength || defaultIterationLength || 0) * (0, (0, parcelRequire("flnZx")).ONE_WEEK);
            const firstRealSprint = (0, parcelRequire("jB947")).default(sprintsInStream);
            const fakePastSprints = $c9acad0f0ca67023$export$800f6e20804f9ed1(timelineRange.start, firstRealSprint && firstRealSprint.startDate || tomorrow, sprintLengthInMillis, (0, $TTKUQ.SCHEDULE_MODE).scrum);
            const lastRealSprint = (0, parcelRequire("3A0dU")).default(sprintsInStream);
            const fakeFutureSprints = $c9acad0f0ca67023$export$ce1cefb45c8832(lastRealSprint && lastRealSprint.endDate || tomorrow, timelineRange.end, sprintLengthInMillis, (0, $TTKUQ.SCHEDULE_MODE).scrum);
            const streams = $c9acad0f0ca67023$export$16f1e219d71d96ad(sprintsInStream);
            const topStream = streams[0];
            topStream.splice(0, 0, ...fakePastSprints);
            Array.prototype.push.apply(topStream, fakeFutureSprints);
            const excludeEmptyStreams = (stream)=>{
                if (!(0, (0, parcelRequire("4R6GH")).fg)('sprint_stacking_filtering')) return true;
                const hasFilteredSprints = filteredSprints && filteredSprints.size > 0;
                return !hasFilteredSprints || stream.some((sprint)=>filteredSprints.has(sprint.id));
            };
            const streamsContainVisibleSprint = streams.filter(excludeEmptyStreams).reduce((streamsContainVisibleSprint, stream)=>{
                const visibleSprint = stream.filter((sprint)=>$c9acad0f0ca67023$var$sprintAppearsOnTimeline(timelineRange, sprint));
                if (visibleSprint.length > 0) {
                    if (!issuesByTeam[team.id] && mode !== (0, $ab4be2e1e204af69$export$e91bb82ec00eb771)) return [];
                    const allSprintsWithCapacity = $c9acad0f0ca67023$export$78919c276404a113({
                        defaultTeamVelocity: defaultTeamVelocity,
                        issuesBySprint: issuesBySprint,
                        issueStatusById: issueStatusById,
                        planningUnit: planningUnit,
                        stream: stream,
                        team: team,
                        weeklyCapacityByTeam: weeklyCapacityByTeam,
                        boardId: boardId,
                        mode: mode,
                        issueLexoRankAdjustments: issueLexoRankAdjustments,
                        issuesByTeam: issuesByTeam,
                        plannedCapacities: plannedCapacities
                    });
                    const visibleSprintsWithCapacity = allSprintsWithCapacity.filter((sprint)=>$c9acad0f0ca67023$var$sprintAppearsOnTimeline(timelineRange, sprint));
                    streamsContainVisibleSprint.push(visibleSprintsWithCapacity);
                }
                return streamsContainVisibleSprint;
            }, []);
            return streamsContainVisibleSprint;
        };
    const $c9acad0f0ca67023$export$6456c14aff191bdf = (issues, mode)=>{
        const issuesByKanbanIteration = {};
        for (const issue of issues){
            const { start: start, end: end } = $c9acad0f0ca67023$var$getIssueDates(issue, mode);
            if ((0, $4nDwW.isDefined)(start) && (0, $4nDwW.isDefined)(end)) {
                let iterationStart = (0, (0, parcelRequire("flnZx")).startOfUtcWeek)(start).getTime();
                while(iterationStart < end){
                    if (!issuesByKanbanIteration[iterationStart]) issuesByKanbanIteration[iterationStart] = [];
                    issuesByKanbanIteration[iterationStart].push(issue);
                    iterationStart = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(iterationStart + $c9acad0f0ca67023$export$4ff47658dac00b1a);
                }
            }
        }
        return issuesByKanbanIteration;
    };
    const $c9acad0f0ca67023$export$39b9f591cb5babf9 = (issues)=>(0, $4nDwW.groupBy)((x)=>x.sprint || '', issues.filter((x)=>x.sprint));
    const $c9acad0f0ca67023$export$352df393d87c6e45 = (issues, solution)=>{
        const getAssignedSprint = $c9acad0f0ca67023$export$98922a1700a2456(solution);
        const getIssueSprint = ({ level: level, sprint: sprint, assignments: assignments })=>{
            if (level > (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL)) return sprint;
            const sprintAssignments = assignments.filter(getAssignedSprint);
            if (sprintAssignments.length === 1) {
                const assignedSprint = getAssignedSprint(sprintAssignments[0]);
                return assignedSprint && assignedSprint.sprintId;
            }
            return sprint;
        };
        const getIssueTeam = ({ team: team, assignments: assignments })=>{
            const teamAssignment = assignments.find(getAssignedSprint) || assignments.find((x)=>x.team);
            return teamAssignment && teamAssignment.team || team;
        };
        return (0, $4nDwW.groupBy)((x)=>x.sprint || '', (0, $4nDwW.filterMap)((issue)=>!!getIssueSprint(issue), (issue)=>({
                ...issue,
                sprint: getIssueSprint(issue),
                team: getIssueTeam(issue)
            }), issues));
    };
    const $c9acad0f0ca67023$export$366891b86c1a480d = (sprintsAreShown, teams, context)=>sprintsAreShown ? (0, parcelRequire("4Rr1a")).default($c9acad0f0ca67023$export$df033e038ec34c36(context), (0, $4nDwW.indexBy)((x)=>x.id, teams)) : {};
    const $c9acad0f0ca67023$export$2c19bb597f3993ce = (sprintsAreShown, _, context)=>(timelineRange, team)=>{
            const contextWithUpdatedTimelineRange = {
                ...context,
                timelineRange: timelineRange
            };
            return sprintsAreShown ? $c9acad0f0ca67023$export$df033e038ec34c36(contextWithUpdatedTimelineRange)(team) : [];
        };
    const $c9acad0f0ca67023$var$getAssignedStartAndEndDateForFutureSprint = (streamsUnitsForTeams)=>{
        const futureSprintsWithStartandEndDate = {};
        (0, parcelRequire("25ys6")).default((streams, teamId)=>{
            const allFutureSprint = streams.reduce((allFutureSprint, stream, index)=>allFutureSprint.concat(stream.filter((sprint)=>sprint.state === (0, $TTKUQ.SPRINT_STATES).FUTURE && sprint.id !== 'GAP' && sprint.id !== 'FUTURE').map((sprint)=>({
                        ...sprint,
                        streamIndex: index
                    }))), []);
            allFutureSprint.forEach((sprint)=>{
                const { id: id, endDate: endDate, startDate: startDate, streamIndex: streamIndex } = sprint;
                if ((0, parcelRequire("lV634")).default(futureSprintsWithStartandEndDate[id])) futureSprintsWithStartandEndDate[id] = [];
                futureSprintsWithStartandEndDate[id].push({
                    endDate: endDate,
                    startDate: startDate,
                    teamId: teamId,
                    streamIndex: streamIndex
                });
            });
        }, streamsUnitsForTeams);
        return futureSprintsWithStartandEndDate;
    };
    const $c9acad0f0ca67023$export$c501cbd65c882409 = (streamsUnitsForTeams)=>{
        const futureSprintsWithStartAndEndDate = $c9acad0f0ca67023$var$getAssignedStartAndEndDateForFutureSprint(streamsUnitsForTeams);
        const sprintAreInconsistent = [];
        (0, parcelRequire("25ys6")).default((dateArray, sprintId)=>{
            let isTimeRangeDifferentInTeams = false;
            for(let i = 0, len = dateArray.length; i < len - 1; i++)if (!((0, parcelRequire("dl2NH")).default('startDate', dateArray[i], dateArray[i + 1]) && (0, parcelRequire("dl2NH")).default('endDate', dateArray[i], dateArray[i + 1]))) {
                isTimeRangeDifferentInTeams = true;
                break;
            }
            if (isTimeRangeDifferentInTeams) sprintAreInconsistent.push(sprintId);
        }, futureSprintsWithStartAndEndDate);
        return [
            ...new Set(sprintAreInconsistent)
        ];
    };
    const $c9acad0f0ca67023$export$a2649b86fe314f7f = (streamsForTeams, timelineRange)=>{
        const omitGaps = !Number.isFinite(timelineRange.start * timelineRange.end);
        return (0, parcelRequire("4Rr1a")).default((streams)=>streams.map((sprints)=>$c9acad0f0ca67023$export$ac96f955bd8392a1(sprints, timelineRange, omitGaps)), streamsForTeams);
    };
    const $c9acad0f0ca67023$export$364b800ef2163c = (getSprintStreams, zoomLevel)=>(timelineRange, team)=>{
            const omitGaps = zoomLevel !== undefined;
            return getSprintStreams(timelineRange, team).map((sprints)=>$c9acad0f0ca67023$export$ac96f955bd8392a1(sprints, timelineRange, omitGaps));
        };
    const $c9acad0f0ca67023$export$eb0254c397e556b3 = (sprintsByTeam, teams, issueSources, sprints, defaultIterationLength)=>{
        const result = {
            team: {},
            sprint: {}
        };
        const addDates = (sprints, sprintLengthInMillis)=>{
            const [futureSprints, pastAndActiveSprints] = (0, parcelRequire("8r8wv")).default((x)=>x.state === (0, $TTKUQ.SPRINT_STATES).FUTURE, sprints);
            const pastAndActiveSprintsSortedByDate = $c9acad0f0ca67023$export$f698cc36cb31ff11(pastAndActiveSprints);
            const lastRealSprint = (0, parcelRequire("3A0dU")).default(pastAndActiveSprintsSortedByDate);
            const lastRealEndDate = lastRealSprint && lastRealSprint.endDate || 0;
            const futureSprintsWithDates = $c9acad0f0ca67023$export$770b406429d15ffa(futureSprints, lastRealEndDate, sprintLengthInMillis);
            return [
                ...pastAndActiveSprintsSortedByDate,
                ...futureSprintsWithDates
            ];
        };
        for (const team of teams){
            const sprintsForTeam = sprintsByTeam[team.id] || [];
            const sprintLengthInMillis = (team.iterationLength || defaultIterationLength || 0) * (0, (0, parcelRequire("flnZx")).ONE_WEEK);
            const futureSprintsForTeam = addDates(sprintsForTeam, sprintLengthInMillis);
            if (futureSprintsForTeam.length > 0) result.team[team.id] = [
                ...futureSprintsForTeam
            ];
        }
        issueSources.filter((issueSource)=>issueSource.type === (0, $TTKUQ.ISSUE_SOURCE_TYPES).BOARD).forEach((issueSource)=>{
            const sprintLengthInMillis = (defaultIterationLength || 0) * (0, (0, parcelRequire("flnZx")).ONE_WEEK);
            const sprintForIssueSource = $c9acad0f0ca67023$export$14dc3d2554a83ab1(issueSource.sprintIds || [], sprints);
            const futureSprintsForIssueSource = addDates(sprintForIssueSource, sprintLengthInMillis);
            if (futureSprintsForIssueSource.length > 0) (issueSource.sprintIds || []).forEach((sprintId)=>{
                if (!result.sprint[sprintId]) result.sprint[sprintId] = [
                    ...futureSprintsForIssueSource
                ];
            });
        });
        return result;
    };
    const $c9acad0f0ca67023$var$sortDateAsc = (firstDate, secondDate)=>firstDate - secondDate;
    const $c9acad0f0ca67023$var$sortDateDsc = (firstDate, secondDate)=>secondDate - firstDate;
    const $c9acad0f0ca67023$export$9c9d199864f2b0a1 = (sprints, prop)=>{
        const dates = sprints.map((sprint)=>sprint[prop] ?? undefined);
        const datesWithoutNulls = dates.filter((date)=>date !== undefined);
        const sortFn = prop === 'startDate' || prop === 'rawStartDate' ? $c9acad0f0ca67023$var$sortDateAsc : $c9acad0f0ca67023$var$sortDateDsc;
        const sortedArray = (0, parcelRequire("7Zjd1")).default(sortFn)(datesWithoutNulls);
        return sortedArray[0];
    };
    const $c9acad0f0ca67023$export$6b6ffbeb66570a75 = (issue, sprints, issueStatusById)=>{
        const sprintsById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), sprints);
        const mapSprints = (0, parcelRequire("b1yMp")).default((0, parcelRequire("jVZZA")).default((0, $4nDwW.isDefined)), (0, parcelRequire("4Rr1a")).default((id)=>sprintsById[id]));
        const statusCategory = issueStatusById && (0, parcelRequire("fZhYM")).default([
            issue.status || '',
            'categoryId'
        ], issueStatusById);
        if (!issue.sprint && (statusCategory === $c9acad0f0ca67023$var$TODO || statusCategory === $c9acad0f0ca67023$var$INPROGRESS)) {
            const sprints = mapSprints(issue.completedSprints || []);
            return {
                startDate: $c9acad0f0ca67023$export$9c9d199864f2b0a1(sprints, 'startDate'),
                endDate: $c9acad0f0ca67023$export$9c9d199864f2b0a1(sprints, 'endDate'),
                rawStartDate: $c9acad0f0ca67023$export$9c9d199864f2b0a1(sprints, 'rawStartDate'),
                rawEndDate: $c9acad0f0ca67023$export$9c9d199864f2b0a1(sprints, 'rawEndDate')
            };
        }
        const allSprintsIds = [
            ...issue.completedSprints || [],
            ...issue.sprint ? [
                issue.sprint
            ] : []
        ];
        const mappedSprints = mapSprints(allSprintsIds);
        return {
            startDate: $c9acad0f0ca67023$export$9c9d199864f2b0a1(mappedSprints, 'startDate'),
            endDate: $c9acad0f0ca67023$export$9c9d199864f2b0a1(mappedSprints, 'endDate'),
            rawStartDate: $c9acad0f0ca67023$export$9c9d199864f2b0a1(mappedSprints, 'rawStartDate'),
            rawEndDate: $c9acad0f0ca67023$export$9c9d199864f2b0a1(mappedSprints, 'rawEndDate')
        };
    };
    const $c9acad0f0ca67023$export$d7616b811073c058 = (teamOfIssue, sprintOfIssue, sprintsByIssueSources, sprintsByTeam, additionalTeamsById, teams, teamsById, otherSprintsLabel)=>{
        const otherSprints = [];
        const result = Object.entries(sprintsByIssueSources).reduce((previous, [issueSource, sprints])=>{
            const currentSprintBelongsToCurrentTeam = (teamOfIssue && sprintsByTeam[teamOfIssue] || []).some((sprint)=>sprint.id === sprintOfIssue);
            const isExternalTeam = teamOfIssue && additionalTeamsById && (0, $4nDwW.isDefined)(additionalTeamsById[teamOfIssue]);
            const issueSourceBelongsToATeam = teams.some((team)=>team.issueSource === Number(issueSource));
            if (!issueSourceBelongsToATeam) otherSprints.push(...sprints.filter((sprint)=>sprint.state !== (0, $TTKUQ.SPRINT_STATES).CLOSED));
            const teamsOfIssueSource = teams.filter((team)=>{
                if (team.issueSource !== Number(issueSource)) return false;
                if (isExternalTeam) return true;
                if (teamOfIssue && teamsById && teamsById[teamOfIssue] && !teamsById[teamOfIssue].issueSource) return true;
                if (sprintOfIssue && teamOfIssue) {
                    if (currentSprintBelongsToCurrentTeam) return team.id === teamOfIssue;
                    return true;
                }
                if (teamOfIssue) return team.id === teamOfIssue;
                return true;
            });
            if (teamsOfIssueSource.length > 0) {
                const label = teamsOfIssueSource.map((team)=>team.title).join(', ');
                const futureSprints = sprints.filter((sprint)=>sprint.state !== (0, $TTKUQ.SPRINT_STATES).CLOSED);
                previous.set(label, futureSprints);
            }
            return previous;
        }, new Map());
        if (otherSprints.length) return result.set(otherSprintsLabel, otherSprints);
        return result;
    };
    const $c9acad0f0ca67023$export$230a55ad90f8755 = (teams, { defaultIterationLength: defaultIterationLength, defaultTeamVelocity: defaultTeamVelocity, issueStatusById: issueStatusById, issuesBySprint: issuesBySprint, mode: mode, planningUnit: planningUnit, sprintsForTeam: sprintsForTeam, timelineRange: timelineRange, weeklyCapacityByTeam: weeklyCapacityByTeam, issueSources: issueSources = [], issueLexoRankAdjustments: issueLexoRankAdjustments, issuesByTeam: issuesByTeam, plannedCapacities: plannedCapacities })=>{
        const result = {};
        for (const team of teams)if (team.schedulingMode !== (0, $TTKUQ.SCHEDULE_MODE).kanban) {
            const alignedSprints = $c9acad0f0ca67023$export$58007ae5dd91fcc6(team, sprintsForTeam, defaultIterationLength);
            if ((0, $4nDwW.isDefined)(alignedSprints)) {
                const { value: boardId } = issueSources.find((source)=>source.id === team.issueSource) || {};
                const sprintsWithCapacity = $c9acad0f0ca67023$export$78919c276404a113({
                    defaultTeamVelocity: defaultTeamVelocity,
                    issuesBySprint: issuesBySprint,
                    issueStatusById: issueStatusById,
                    planningUnit: planningUnit,
                    stream: alignedSprints,
                    team: team,
                    weeklyCapacityByTeam: weeklyCapacityByTeam,
                    boardId: boardId,
                    mode: mode,
                    issueLexoRankAdjustments: issueLexoRankAdjustments,
                    issuesByTeam: issuesByTeam,
                    plannedCapacities: plannedCapacities
                });
                const sprintsWithCapacityById = (0, $4nDwW.indexBy)((x)=>x.id, sprintsWithCapacity);
                result[team.id] = (0, parcelRequire("4Rr1a")).default((sprintWithCapacity)=>$c9acad0f0ca67023$export$ac96f955bd8392a1([
                        sprintWithCapacity
                    ], timelineRange), sprintsWithCapacityById);
            }
        }
        return result;
    };
    const $c9acad0f0ca67023$export$570cdbd5979ccd = ({ capacity: capacity, planningUnit: planningUnit, workingHours: workingHours })=>{
        const hourInSeconds = (0, (0, parcelRequire("flnZx")).ONE_HOUR) / 1000;
        const { days: days, hours: hours } = (0, $TTKUQ.PlanningUnits);
        switch(planningUnit){
            case days:
                return (0, ($parcel$interopDefault($gamDR)))(capacity / (hourInSeconds * workingHours), 2);
            case hours:
                return (0, ($parcel$interopDefault($gamDR)))(capacity / hourInSeconds, 2);
            default:
                return (0, ($parcel$interopDefault($gamDR)))(capacity, 2);
        }
    };
    const $c9acad0f0ca67023$export$acbcfbe3e761e0b4 = ({ capacity: capacity, planningUnit: planningUnit, workingHours: workingHours })=>{
        const hourInSeconds = (0, (0, parcelRequire("flnZx")).ONE_HOUR) / 1000;
        const { days: days, hours: hours } = (0, $TTKUQ.PlanningUnits);
        switch(planningUnit){
            case days:
                return capacity * hourInSeconds * workingHours;
            case hours:
                return capacity * hourInSeconds;
            default:
                return capacity;
        }
    };
    const $c9acad0f0ca67023$var$calculateDefaultSprintCapacity = (sprint, team, planningUnit, weeklyCapacity, defaultTeamVelocity)=>{
        let availableCapacity = 0;
        if (planningUnit === (0, $TTKUQ.PlanningUnits).storyPoints) availableCapacity = team.velocity || team.velocity === 0 ? team.velocity : defaultTeamVelocity;
        else availableCapacity = (0, (0, parcelRequire("flnZx")).ONE_HOUR) * weeklyCapacity * (0, (0, parcelRequire("flnZx")).getWorkingMillionSecondsBetweenTwoDates)(sprint.startDate, sprint.endDate) / (5 * (0, (0, parcelRequire("flnZx")).ONE_DAY)) / 1000;
        return availableCapacity;
    };
    const $c9acad0f0ca67023$export$5389b2bbf0271c30 = (plannedCapacities, originalPlannedCapacities, { team: sprintsByTeam }, planningUnit, defaultTeamVelocity, weeklyCapacityByTeam, teamsById, metaData)=>{
        const twoLevelObjectValues = (0, parcelRequire("bQZTk")).default((0, parcelRequire("bjzU8")).default, (0, parcelRequire("7WM3o")).default((0, parcelRequire("bjzU8")).default));
        const flattenedOriginals = twoLevelObjectValues(originalPlannedCapacities);
        const applyDefaultCapacity = (plannedCapacity)=>{
            if (Number.isInteger(plannedCapacity.capacity)) return plannedCapacity;
            const weeklyCapacity = weeklyCapacityByTeam[plannedCapacity.teamId];
            let defaultCapacity;
            if (plannedCapacity.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).scrum) {
                const teamSprints = sprintsByTeam[plannedCapacity.teamId] || [];
                const sprint = teamSprints.find((sprint)=>sprint.id === plannedCapacity.iterationId);
                if (!sprint) return plannedCapacity;
                const team = teamsById[plannedCapacity.teamId];
                defaultCapacity = $c9acad0f0ca67023$var$calculateDefaultSprintCapacity(sprint, team, planningUnit, weeklyCapacity, defaultTeamVelocity);
            } else defaultCapacity = (0, (0, parcelRequire("flnZx")).ONE_HOUR) * weeklyCapacity / 1000;
            return {
                ...plannedCapacity,
                capacity: defaultCapacity
            };
        };
        const changes = flattenedOriginals.map((original)=>{
            const newValue = (0, parcelRequire("fZhYM")).default([
                original.teamId,
                original.iterationId
            ], plannedCapacities) || {
                ...original,
                capacity: null
            };
            return {
                iterationId: original.iterationId,
                teamId: original.teamId,
                values: applyDefaultCapacity(newValue),
                originals: applyDefaultCapacity(original),
                metaData: metaData && original.itemKey ? metaData[original.itemKey] : null
            };
        });
        return changes;
    };
    const $c9acad0f0ca67023$export$7ad618a806be26f0 = (plannedCapacityChanges, { sprint: sprintsWithDates })=>{
        const velocityChangesBySprint = (0, parcelRequire("4wiYB")).default((0, parcelRequire("2rMKg")).default('iterationId'), plannedCapacityChanges);
        const entries = (0, parcelRequire("6nTyZ")).default(velocityChangesBySprint);
        const changes = entries.map(([sprintId, capacityChanges])=>{
            const changeCount = capacityChanges.length;
            const attributeName = changeCount === 1 ? `teamVelocity-${capacityChanges[0].teamId}` : undefined;
            let sprintWithoutCapacities;
            if (capacityChanges[0].values.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).scrum) sprintWithoutCapacities = sprintsWithDates[sprintId].find((sprint)=>sprint.id === sprintId);
            else {
                const iterationStart = +sprintId;
                const iterationEnd = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(iterationStart + $c9acad0f0ca67023$export$4ff47658dac00b1a) - 1000;
                sprintWithoutCapacities = $c9acad0f0ca67023$var$createFutureSprint(iterationStart, iterationEnd, (0, $TTKUQ.SCHEDULE_MODE).kanban);
                sprintWithoutCapacities.id = sprintId;
            }
            const sprintWithNewVelocities = {
                ...sprintWithoutCapacities
            };
            capacityChanges.forEach((change)=>{
                sprintWithNewVelocities[`teamVelocity-${change.teamId}`] = change.values;
            });
            const originals = {};
            capacityChanges.forEach((change)=>{
                originals[`teamVelocity-${change.teamId}`] = change.originals;
            });
            let metaData = {
                lastChangeTimestamp: 1579059707222,
                lastChangeUser: '',
                scenarioType: (0, $TTKUQ.SCENARIO_TYPE).UPDATED
            };
            const metaDataObjects = capacityChanges.map((change)=>({
                    ...change.metaData,
                    scenarioType: (0, $TTKUQ.SCENARIO_TYPE).UPDATED
                })).filter((0, parcelRequire("83IGl")).default);
            metaDataObjects.sort((a, b)=>b.lastChangeTimestamp - a.lastChangeTimestamp);
            if (metaDataObjects.length) metaData = metaDataObjects[0];
            return {
                attributeName: attributeName,
                changeCount: changeCount,
                id: sprintId,
                warnings: [],
                category: (0, $TTKUQ.ENTITY).SPRINT,
                details: {
                    values: sprintWithNewVelocities,
                    originals: originals
                },
                metaData: metaData
            };
        });
        return changes;
    };
    const $c9acad0f0ca67023$export$5841f9eb9773f25f = (startTime, endTime)=>{
        const startDate = new Date(startTime);
        const endDate = new Date(endTime);
        return startDate.getUTCFullYear() === endDate.getUTCFullYear();
    };
    const $c9acad0f0ca67023$export$c0501b9f0bd00198 = (intl, startDate, endDate)=>{
        const dateTimeFormatWithoutYearOptions = {
            day: '2-digit',
            month: 'short',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZone: 'UTC',
            timeZoneName: 'short'
        };
        const dateTimeFormatWithYearOptions = {
            ...dateTimeFormatWithoutYearOptions,
            year: 'numeric'
        };
        const formatDateTimeString = $c9acad0f0ca67023$export$5841f9eb9773f25f(startDate, endDate) ? dateTimeFormatWithoutYearOptions : dateTimeFormatWithYearOptions;
        return {
            startDate: (0, (0, parcelRequire("aipk9")).formatTimestampWithIntl)(intl, startDate, formatDateTimeString),
            endDate: (0, (0, parcelRequire("aipk9")).formatTimestampWithIntl)(intl, endDate, formatDateTimeString)
        };
    };
    const $c9acad0f0ca67023$export$a18c89cbd24170ff = (startTime, endTime)=>{
        const startDate = new Date(startTime);
        const endDate = new Date(endTime);
        return startDate.getUTCMonth() === endDate.getUTCMonth();
    };
    const $c9acad0f0ca67023$export$2e9241a0bdf6c8b8 = (intl, startDate, endDate)=>{
        if ($c9acad0f0ca67023$export$a18c89cbd24170ff(startDate, endDate)) {
            const startDateOfMonth = new Date(startDate).getUTCDate();
            return `${startDateOfMonth} \u2013 ${(0, (0, parcelRequire("aipk9")).formatTimestampWithIntl)(intl, endDate, (0, (0, parcelRequire("gh61P")).dateMonthFormat))}`;
        }
        const formatDateString = $c9acad0f0ca67023$export$5841f9eb9773f25f(startDate, endDate) ? (0, (0, parcelRequire("gh61P")).dateMonthFormat) : (0, (0, parcelRequire("gh61P")).longDateFormat);
        return `${(0, (0, parcelRequire("aipk9")).formatTimestampWithIntl)(intl, startDate, formatDateString)} \u2013 ${(0, (0, parcelRequire("aipk9")).formatTimestampWithIntl)(intl, endDate, formatDateString)} `;
    };
    const $c9acad0f0ca67023$export$9f71a9790fe294f = (intl)=>({ sprint: sprint, isFutureProjectedSprint: isFutureProjectedSprint })=>{
            if (isFutureProjectedSprint) return intl.formatMessage((0, $ihPUd.default).futureProjectedSprint);
            switch(sprint.state){
                case (0, $TTKUQ.SPRINT_STATES).CLOSED:
                    return intl.formatMessage((0, $ihPUd.default).completedSprint);
                case (0, $TTKUQ.SPRINT_STATES).ACTIVE:
                    return intl.formatMessage((0, $ihPUd.default).activeSprint);
                case (0, $TTKUQ.SPRINT_STATES).FUTURE:
                    return intl.formatMessage((0, $ihPUd.default).futureSprint);
                default:
                    return '';
            }
        };
    const $c9acad0f0ca67023$export$4d9e331cafeacb9d = (state)=>{
        switch(state){
            case (0, $TTKUQ.SPRINT_STATES).CLOSED:
                return 'success';
            case (0, $TTKUQ.SPRINT_STATES).ACTIVE:
                return 'inprogress';
            case (0, $TTKUQ.SPRINT_STATES).FUTURE:
                return 'default';
            default:
                return 'default';
        }
    };
    const $c9acad0f0ca67023$export$fd6ceee9e9533c99 = (intl)=>(state)=>{
            switch(state){
                case (0, $TTKUQ.SPRINT_STATES).CLOSED:
                    return intl.formatMessage((0, $ihPUd.default).completedSprintState);
                case (0, $TTKUQ.SPRINT_STATES).ACTIVE:
                    return intl.formatMessage((0, $ihPUd.default).activeSprintState);
                case (0, $TTKUQ.SPRINT_STATES).FUTURE:
                    return intl.formatMessage((0, $ihPUd.default).futureSprintState);
                case 0, $TTKUQ.EXTERNAL_SPRINT:
                    return intl.formatMessage((0, $ihPUd.default).externalSprintState);
                default:
                    return '';
            }
        };
    const $c9acad0f0ca67023$export$6f891d146561f05a = (intl)=>(state)=>{
            switch(state){
                case (0, $TTKUQ.SPRINT_STATES).CLOSED:
                    return intl.formatMessage((0, $ihPUd.default).completedSprintsLabel);
                case (0, $TTKUQ.SPRINT_STATES).ACTIVE:
                    return intl.formatMessage((0, $ihPUd.default).activeSprintsLabel);
                case (0, $TTKUQ.SPRINT_STATES).FUTURE:
                    return intl.formatMessage((0, $ihPUd.default).futureSprintsLabel);
                case 0, $TTKUQ.EXTERNAL_SPRINT:
                    return intl.formatMessage((0, $ihPUd.default).externalSprintsLabel);
                default:
                    return '';
            }
        };
});
parcelRegister("gamDR", function(module, exports) {
    var $aza9E = parcelRequire("aza9E");
    var $bc4f24b4027c5e7d$var$round = $aza9E('round');
    module.exports = $bc4f24b4027c5e7d$var$round;
});
parcelRegister("aza9E", function(module, exports) {
    var $1V15E = parcelRequire("1V15E");
    var $kPZpS = parcelRequire("kPZpS");
    var $1sXeC = parcelRequire("1sXeC");
    var $jJVtR = parcelRequire("jJVtR");
    var $7b150cc928607d87$var$nativeIsFinite = $1V15E.isFinite, $7b150cc928607d87$var$nativeMin = Math.min;
    function $7b150cc928607d87$var$createRound(methodName) {
        var func = Math[methodName];
        return function(number, precision) {
            number = $1sXeC(number);
            precision = precision == null ? 0 : $7b150cc928607d87$var$nativeMin($kPZpS(precision), 292);
            if (precision && $7b150cc928607d87$var$nativeIsFinite(number)) {
                var pair = ($jJVtR(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                pair = ($jJVtR(value) + 'e').split('e');
                return +(pair[0] + 'e' + (+pair[1] - precision));
            }
            return func(number);
        };
    }
    module.exports = $7b150cc928607d87$var$createRound;
});
parcelRegister("7WM3o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c9339a8fa0bfdbe$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5DTpU;
    var $alz1M;
    var $heFOH;
    var $4Rr1a;
    var $5c9339a8fa0bfdbe$var$chain = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("5DTpU")).default)([
        'fantasy-land/chain',
        'chain'
    ], (0, (0, parcelRequire("heFOH")).default), function chain(fn, monad) {
        if (typeof monad === 'function') return function(x) {
            return fn(monad(x))(x);
        };
        return (0, (0, parcelRequire("alz1M")).default)(false)((0, (0, parcelRequire("4Rr1a")).default)(fn, monad));
    }));
    var $5c9339a8fa0bfdbe$export$2e2bcd8739ae039 = $5c9339a8fa0bfdbe$var$chain;
});
parcelRegister("alz1M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7887094ebfa011f2$export$2e2bcd8739ae039);
    var $6kmm1;
    function $7887094ebfa011f2$export$2e2bcd8739ae039(recursive) {
        return function flatt(list) {
            var value, jlen, j;
            var result = [];
            var idx = 0;
            var ilen = list.length;
            while(idx < ilen){
                if ((0, (0, parcelRequire("6kmm1")).default)(list[idx])) {
                    value = recursive ? flatt(list[idx]) : list[idx];
                    j = 0;
                    jlen = value.length;
                    while(j < jlen){
                        result[result.length] = value[j];
                        j += 1;
                    }
                } else result[result.length] = list[idx];
                idx += 1;
            }
            return result;
        };
    }
});
parcelRegister("heFOH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8c42e6ab0127a6a$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5dXH4;
    var $4Rr1a;
    var $c8c42e6ab0127a6a$var$_xchain = (0, (0, parcelRequire("c9RLn")).default)(function _xchain(f, xf) {
        return (0, (0, parcelRequire("4Rr1a")).default)(f, (0, (0, parcelRequire("5dXH4")).default)(xf));
    });
    var $c8c42e6ab0127a6a$export$2e2bcd8739ae039 = $c8c42e6ab0127a6a$var$_xchain;
});
parcelRegister("5dXH4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3cdc78923f213602$export$2e2bcd8739ae039);
    var $2q7fm;
    var $6kmm1;
    var $42qCL;
    var $7D5kn;
    var $3cdc78923f213602$var$preservingReduced = function(xf) {
        return {
            '@@transducer/init': (0, (0, parcelRequire("7D5kn")).default).init,
            '@@transducer/result': function(result) {
                return xf['@@transducer/result'](result);
            },
            '@@transducer/step': function(result, input) {
                var ret = xf['@@transducer/step'](result, input);
                return ret['@@transducer/reduced'] ? (0, (0, parcelRequire("2q7fm")).default)(ret) : ret;
            }
        };
    };
    var $3cdc78923f213602$var$_flatCat = function _xcat(xf) {
        var rxf = $3cdc78923f213602$var$preservingReduced(xf);
        return {
            '@@transducer/init': (0, (0, parcelRequire("7D5kn")).default).init,
            '@@transducer/result': function(result) {
                return rxf['@@transducer/result'](result);
            },
            '@@transducer/step': function(result, input) {
                return !(0, (0, parcelRequire("6kmm1")).default)(input) ? (0, (0, parcelRequire("42qCL")).default)(rxf, result, [
                    input
                ]) : (0, (0, parcelRequire("42qCL")).default)(rxf, result, input);
            }
        };
    };
    var $3cdc78923f213602$export$2e2bcd8739ae039 = $3cdc78923f213602$var$_flatCat;
});
parcelRegister("2q7fm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c33a1893ae0e2d3$export$2e2bcd8739ae039);
    function $1c33a1893ae0e2d3$export$2e2bcd8739ae039(x) {
        return {
            '@@transducer/value': x,
            '@@transducer/reduced': true
        };
    }
});
parcelRegister("25ys6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1856c5e1ccdca760$export$2e2bcd8739ae039);
    var $c9RLn;
    var $76p2G;
    var $1856c5e1ccdca760$var$forEachObjIndexed = (0, (0, parcelRequire("c9RLn")).default)(function forEachObjIndexed(fn, obj) {
        var keyList = (0, (0, parcelRequire("76p2G")).default)(obj);
        var idx = 0;
        while(idx < keyList.length){
            var key = keyList[idx];
            fn(obj[key], key, obj);
            idx += 1;
        }
        return obj;
    });
    var $1856c5e1ccdca760$export$2e2bcd8739ae039 = $1856c5e1ccdca760$var$forEachObjIndexed;
});
parcelRegister("3A0dU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29b4e838ca7c3b08$export$2e2bcd8739ae039);
    var $4J98j;
    var $29b4e838ca7c3b08$var$last = (0, (0, parcelRequire("4J98j")).default)(-1);
    var $29b4e838ca7c3b08$export$2e2bcd8739ae039 = $29b4e838ca7c3b08$var$last;
});
parcelRegister("b8GVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81c1be1d27f491b4$export$2e2bcd8739ae039);
    var $c9RLn;
    var $81c1be1d27f491b4$var$props = (0, (0, parcelRequire("c9RLn")).default)(function props(ps, obj) {
        var len = ps.length;
        var out = [];
        var idx = 0;
        while(idx < len){
            out[idx] = obj[ps[idx]];
            idx += 1;
        }
        return out;
    });
    var $81c1be1d27f491b4$export$2e2bcd8739ae039 = $81c1be1d27f491b4$var$props;
});
parcelRegister("2HSYk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f8a3d3423ee54aa$export$2e2bcd8739ae039);
    var $3Amtz;
    var $j0d94;
    var $1f8a3d3423ee54aa$var$sum = (0, (0, parcelRequire("j0d94")).default)((0, (0, parcelRequire("3Amtz")).default), 0);
    var $1f8a3d3423ee54aa$export$2e2bcd8739ae039 = $1f8a3d3423ee54aa$var$sum;
});
parcelRegister("3Amtz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29c62b21b132ad06$export$2e2bcd8739ae039);
    var $c9RLn;
    var $29c62b21b132ad06$var$add = (0, (0, parcelRequire("c9RLn")).default)(function add(a, b) {
        return Number(a) + Number(b);
    });
    var $29c62b21b132ad06$export$2e2bcd8739ae039 = $29c62b21b132ad06$var$add;
});
parcelRegister("l7aHc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5f28c5cfcc6d62e$export$2e2bcd8739ae039);
    var $c9RLn;
    var $f5f28c5cfcc6d62e$var$times = (0, (0, parcelRequire("c9RLn")).default)(function times(fn, n) {
        var len = Number(n);
        var idx = 0;
        var list;
        if (len < 0 || isNaN(len)) throw new RangeError('n must be a non-negative number');
        list = new Array(len);
        while(idx < len){
            list[idx] = fn(idx);
            idx += 1;
        }
        return list;
    });
    var $f5f28c5cfcc6d62e$export$2e2bcd8739ae039 = $f5f28c5cfcc6d62e$var$times;
});
parcelRegister("6nTyZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a5ffdc40507c909$export$2e2bcd8739ae039);
    var $ccUYa;
    var $65NM6;
    var $4a5ffdc40507c909$var$toPairs = (0, (0, parcelRequire("ccUYa")).default)(function toPairs(obj) {
        var pairs = [];
        for(var prop in obj)if ((0, (0, parcelRequire("65NM6")).default)(prop, obj)) pairs[pairs.length] = [
            prop,
            obj[prop]
        ];
        return pairs;
    });
    var $4a5ffdc40507c909$export$2e2bcd8739ae039 = $4a5ffdc40507c909$var$toPairs;
});
parcelRegister("9FFuD", function(module, exports) {
    $parcel$export(module.exports, "getVersions", ()=>$e5f2c462c1105623$export$cbd9528a83fbffa1);
    $parcel$export(module.exports, "getVersionsById", ()=>$e5f2c462c1105623$export$6276b9eb21b360da);
    $parcel$export(module.exports, "getRemovedVersions", ()=>$e5f2c462c1105623$export$c13a2a631377464a);
    $parcel$export(module.exports, "getRemovedVersionsById", ()=>$e5f2c462c1105623$export$2c2ed1c3fa0848e9);
    $parcel$export(module.exports, "getReleaseStatusesById", ()=>$e5f2c462c1105623$export$d7ec23def82b181e);
    $parcel$export(module.exports, "getSortByHighestRank", ()=>$e5f2c462c1105623$export$3e8f3b624e136113);
    $parcel$export(module.exports, "getSortByLowestRank", ()=>$e5f2c462c1105623$export$fde25415e63b943f);
    $parcel$export(module.exports, "getVersionWithHighestRankInProject", ()=>$e5f2c462c1105623$export$701ca456028faee4);
    $parcel$export(module.exports, "getOriginalVersions", ()=>$e5f2c462c1105623$export$6fb02f212999533e);
    $parcel$export(module.exports, "getCommitWarningsForVersions", ()=>$e5f2c462c1105623$export$293e3ececda5ef14);
    $parcel$export(module.exports, "getEnrichedVersions", ()=>$e5f2c462c1105623$export$768e48b2c317ec1);
    $parcel$export(module.exports, "getSolutionVersionsById", ()=>$e5f2c462c1105623$export$7c50d111c2b02c6f);
    $parcel$export(module.exports, "getVersionChangeCount", ()=>$e5f2c462c1105623$export$d97dab6022ceb421);
    $parcel$export(module.exports, "getVersionChanges", ()=>$e5f2c462c1105623$export$17954408be2c7691);
    $parcel$export(module.exports, "getReleasesTableRankingStatus", ()=>$e5f2c462c1105623$export$92d3fa6211fa94a4);
    $parcel$export(module.exports, "getEnrichedVersionsById", ()=>$e5f2c462c1105623$export$264ae8bd37fe59e6);
    $parcel$export(module.exports, "getProjectIdsByCrossProjectVersionsMap", ()=>$e5f2c462c1105623$export$2e0a86e15fc298ce);
    $parcel$export(module.exports, "getCompletedVersionsById", ()=>$e5f2c462c1105623$export$df487cb7cbf7a3ba);
    var $bWXax;
    var $jVZZA;
    var $4wiYB;
    var $bQZTk;
    var $2rMKg;
    var $j0d94;
    var $icdh8;
    var $48UFW;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $6tk1y = parcelRequire("6tk1y");
    var $jpXKt = parcelRequire("jpXKt");
    var $cZF7S = parcelRequire("cZF7S");
    var $ipX5U = parcelRequire("ipX5U");
    var $ipX5U = parcelRequire("ipX5U");
    var $6X8w9 = parcelRequire("6X8w9");
    const $e5f2c462c1105623$export$cbd9528a83fbffa1 = (state)=>state.domain.versions;
    const $e5f2c462c1105623$export$6276b9eb21b360da = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$export$cbd9528a83fbffa1
    ], (versions)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), versions));
    const $e5f2c462c1105623$export$c13a2a631377464a = (state)=>state.domain.removedVersions;
    const $e5f2c462c1105623$export$2c2ed1c3fa0848e9 = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$export$c13a2a631377464a
    ], (versions)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), versions));
    const $e5f2c462c1105623$export$e91aef70d413a5eb = (state)=>state.domain.releaseStatuses;
    const $e5f2c462c1105623$export$d7ec23def82b181e = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$export$e91aef70d413a5eb
    ], (releaseStatuses)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), releaseStatuses));
    const $e5f2c462c1105623$export$7ece973307d52dd2 = (lexoRankAdjustments)=>(versions)=>(0, parcelRequire("icdh8")).default([
                (0, $4nDwW.descend)(({ lexoRank: lexoRank })=>lexoRank || ''),
                (0, $4nDwW.descend)(({ id: id })=>lexoRankAdjustments.indexOf(id))
            ])(versions);
    const $e5f2c462c1105623$export$3e8f3b624e136113 = (0, $3YtPS.createSelector)([
        (0, $6tk1y.getVersionLexoRankAdjustments)
    ], $e5f2c462c1105623$export$7ece973307d52dd2);
    const $e5f2c462c1105623$export$f035ce36fd097cb6 = (lexoRankAdjustments)=>(versions)=>(0, parcelRequire("icdh8")).default([
                (0, $4nDwW.ascend)(({ lexoRank: lexoRank })=>lexoRank || ''),
                (0, $4nDwW.ascend)(({ id: id })=>lexoRankAdjustments.indexOf(id))
            ])(versions);
    const $e5f2c462c1105623$export$fde25415e63b943f = (0, $3YtPS.createSelector)([
        (0, $6tk1y.getVersionLexoRankAdjustments)
    ], $e5f2c462c1105623$export$f035ce36fd097cb6);
    const $e5f2c462c1105623$export$4c4992f425d2e683 = (versions, sortVersionsByHighestRank)=>{
        if (versions.length === 0) return;
        if (versions.length === 1) return versions[0];
        const sortedVersions = sortVersionsByHighestRank(versions);
        return sortedVersions[0];
    };
    const $e5f2c462c1105623$export$e32aae4224e2cdad = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$export$cbd9528a83fbffa1,
        $e5f2c462c1105623$export$3e8f3b624e136113
    ], $e5f2c462c1105623$export$4c4992f425d2e683);
    const $e5f2c462c1105623$export$701ca456028faee4 = (state, projectId)=>{
        const versions = $e5f2c462c1105623$export$cbd9528a83fbffa1(state);
        const versionsInProject = versions.filter((version)=>version.projects.includes(projectId));
        return $e5f2c462c1105623$export$4c4992f425d2e683(versionsInProject, $e5f2c462c1105623$export$3e8f3b624e136113(state));
    };
    const $e5f2c462c1105623$export$6fb02f212999533e = (state)=>state.domain.originalVersions;
    const $e5f2c462c1105623$export$293e3ececda5ef14 = (state)=>state.domain.updateJira.warnings[(0, $TTKUQ.ENTITY).RELEASE];
    const $e5f2c462c1105623$export$f3cd71750a928238 = (versions, projects)=>{
        const projectsByIdMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), projects);
        return versions.map(({ projects: projects, ...rest })=>({
                ...rest,
                projects: projects.map((id)=>projectsByIdMap[id])
            }));
    };
    const $e5f2c462c1105623$export$768e48b2c317ec1 = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$export$cbd9528a83fbffa1,
        (0, $jpXKt.getProjects)
    ], $e5f2c462c1105623$export$f3cd71750a928238);
    const $e5f2c462c1105623$export$f4a2370bd2a02a4c = (solution)=>{
        if (!(0, $4nDwW.isDefined)(solution)) return [];
        const solutionProjects = (0, $4nDwW.values)(solution.projects);
        return solutionProjects.flatMap(({ versions: versions })=>versions);
    };
    const $e5f2c462c1105623$export$4f1c1f3ec6b290e5 = (0, $3YtPS.createSelector)([
        (0, $cZF7S.getSolution)
    ], $e5f2c462c1105623$export$f4a2370bd2a02a4c);
    const $e5f2c462c1105623$export$7c50d111c2b02c6f = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$export$4f1c1f3ec6b290e5
    ], (solutionVersions)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('key'), solutionVersions));
    const $e5f2c462c1105623$export$d97dab6022ceb421 = ({ domain: { originalVersions: originalVersions } })=>Object.keys(originalVersions).length;
    const $e5f2c462c1105623$export$9d001e5246befab = ({ domain: { updateJira: updateJira } })=>{
        if (updateJira && updateJira.changes && updateJira.changes.data) return updateJira.changes.data.metaData.versions;
        return {};
    };
    const $e5f2c462c1105623$export$b1e188784551697f = (versions, removedVersions, originalVersions, versionChangesMetadata, warnings, projectsById)=>{
        const enrichedVersions = [
            ...versions,
            ...removedVersions
        ].map(({ projects: projects, ...rest })=>({
                ...rest,
                projects: projects.map((id)=>projectsById[id])
            }));
        const versionsByIdMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), enrichedVersions);
        const changes = Object.keys(versionChangesMetadata).filter((versionId)=>(0, $4nDwW.isDefined)(versionsByIdMap[versionId])).filter((versionId)=>(0, $4nDwW.isDefined)(originalVersions[versionId])).map((versionId)=>{
            const version = versionsByIdMap[versionId];
            const { id: id, projects: projects, ...values } = version;
            const originalValues = originalVersions[versionId];
            const metaData = versionChangesMetadata[versionId];
            const { scenarioType: scenarioType } = metaData;
            const changedAttributes = (0, $ipX5U.getChangedAttributes)(values, originalValues, scenarioType);
            return {
                id: id,
                category: (0, $TTKUQ.ENTITY).RELEASE,
                metaData: metaData,
                changeCount: changedAttributes.length,
                warnings: warnings[versionId] || [],
                attributeName: (0, $ipX5U.getChangedAttributeName)(changedAttributes, scenarioType),
                details: {
                    id: id,
                    projects: projects,
                    values: {
                        ...values
                    },
                    originals: {
                        ...originalValues
                    }
                }
            };
        });
        return changes;
    };
    const $e5f2c462c1105623$export$17954408be2c7691 = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$export$cbd9528a83fbffa1,
        $e5f2c462c1105623$export$c13a2a631377464a,
        $e5f2c462c1105623$export$6fb02f212999533e,
        $e5f2c462c1105623$export$9d001e5246befab,
        $e5f2c462c1105623$export$293e3ececda5ef14,
        (0, $jpXKt.getProjectsById)
    ], $e5f2c462c1105623$export$b1e188784551697f);
    const $e5f2c462c1105623$export$92d3fa6211fa94a4 = (state)=>state.ui.Main.Tabs.Releases.ProjectReleases.ReleasesTable.isRanking;
    const $e5f2c462c1105623$export$264ae8bd37fe59e6 = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$export$768e48b2c317ec1
    ], (versions)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), versions));
    const $e5f2c462c1105623$export$c34bf9b5248be50b = (versions)=>(0, parcelRequire("bQZTk")).default((0, parcelRequire("4wiYB")).default((version)=>version.crossProjectVersion || 'omit'), (0, parcelRequire("bWXax")).default('omit'), (versionsByCPV)=>Object.keys(versionsByCPV).reduce((projectIdsByCPR, cprId)=>{
                const versionsWithCPV = versionsByCPV[cprId];
                const projects = (0, parcelRequire("j0d94")).default((projects, v)=>(0, parcelRequire("48UFW")).default(projects, v.projects), [])(versionsWithCPV);
                return Object.assign(projectIdsByCPR, {
                    [cprId]: projects
                });
            }, {}))(versions);
    const $e5f2c462c1105623$export$2e0a86e15fc298ce = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$export$cbd9528a83fbffa1
    ], $e5f2c462c1105623$export$c34bf9b5248be50b);
    const $e5f2c462c1105623$var$getCompletedVersionsPure = (versions)=>(0, parcelRequire("jVZZA")).default((version)=>version.releaseStatusId === (0, $TTKUQ.RELEASE_STATUSES).RELEASED, versions);
    const $e5f2c462c1105623$var$getCompletedVersions = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$export$cbd9528a83fbffa1
    ], $e5f2c462c1105623$var$getCompletedVersionsPure);
    const $e5f2c462c1105623$export$df487cb7cbf7a3ba = (0, $3YtPS.createSelector)([
        $e5f2c462c1105623$var$getCompletedVersions
    ], (completedVersion)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), completedVersion));
});
parcelRegister("bWXax", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b330233733d1dff$export$2e2bcd8739ae039);
    var $c9RLn;
    var $8b330233733d1dff$var$dissoc = (0, (0, parcelRequire("c9RLn")).default)(function dissoc(prop, obj) {
        var result = {};
        for(var p in obj)result[p] = obj[p];
        delete result[prop];
        return result;
    });
    var $8b330233733d1dff$export$2e2bcd8739ae039 = $8b330233733d1dff$var$dissoc;
});
parcelRegister("icdh8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3f3a53416808601$export$2e2bcd8739ae039);
    var $c9RLn;
    var $d3f3a53416808601$var$sortWith = (0, (0, parcelRequire("c9RLn")).default)(function sortWith(fns, list) {
        return Array.prototype.slice.call(list, 0).sort(function(a, b) {
            var result = 0;
            var i = 0;
            while(result === 0 && i < fns.length){
                result = fns[i](a, b);
                i += 1;
            }
            return result;
        });
    });
    var $d3f3a53416808601$export$2e2bcd8739ae039 = $d3f3a53416808601$var$sortWith;
});
parcelRegister("48UFW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3043df533f5aa60e$export$2e2bcd8739ae039);
    var $6VFfk;
    var $c9RLn;
    var $b1yMp;
    var $d8iBX;
    var $3043df533f5aa60e$var$union = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("b1yMp")).default)((0, (0, parcelRequire("d8iBX")).default), (0, (0, parcelRequire("6VFfk")).default)));
    var $3043df533f5aa60e$export$2e2bcd8739ae039 = $3043df533f5aa60e$var$union;
});
parcelRegister("6tk1y", function(module, exports) {
    $parcel$export(module.exports, "getIssueLexoRankAdjustments", ()=>$3b52e774f9528a7f$export$263b62c0d6fc0959);
    $parcel$export(module.exports, "getVersionLexoRankAdjustments", ()=>$3b52e774f9528a7f$export$edd7701f656ba11f);
    const $3b52e774f9528a7f$export$263b62c0d6fc0959 = (state)=>state.domain.lexorank.issueAdjustments;
    const $3b52e774f9528a7f$export$edd7701f656ba11f = (state)=>state.domain.lexorank.versionAdjustments;
});
parcelRegister("ipX5U", function(module, exports) {
    $parcel$export(module.exports, "getMillisecondsDateReference", ()=>$315df16e1d44deff$export$b40a93d7ad7a9349);
    $parcel$export(module.exports, "getStartDateMethod", ()=>$315df16e1d44deff$export$37dd434ed790acdc);
    $parcel$export(module.exports, "getEndDateMethod", ()=>$315df16e1d44deff$export$bd9c4c37a91873f3);
    $parcel$export(module.exports, "getChangedAttributes", ()=>$315df16e1d44deff$export$3c13bed81ee9bbc8);
    $parcel$export(module.exports, "getChangedAttributeName", ()=>$315df16e1d44deff$export$8372f47f7c4a2a9);
    $parcel$export(module.exports, "getTargetDatesFromReleases", ()=>$315df16e1d44deff$export$ec4d0087f9018a86);
    var $3nPAF;
    var $gh61P;
    var $flnZx;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $6X8w9 = parcelRequire("6X8w9");
    const $315df16e1d44deff$var$getDateReferenceFromMilliseconds = (delta)=>{
        const days = delta / (0, (0, parcelRequire("flnZx")).ONE_DAY);
        const direction = delta > 0 ? (0, $TTKUQ.DIRECTIONS).AFTER : (0, $TTKUQ.DIRECTIONS).BEFORE;
        const canBeDisplayedAsWeeks = days % 7 === 0;
        return canBeDisplayedAsWeeks ? {
            quantity: Math.abs(days) / 7,
            unit: (0, (0, parcelRequire("gh61P")).DateUnits).WEEKS,
            direction: direction
        } : {
            quantity: Math.abs(days),
            unit: (0, (0, parcelRequire("gh61P")).DateUnits).DAYS,
            direction: direction
        };
    };
    const $315df16e1d44deff$export$b40a93d7ad7a9349 = ({ quantity: quantity, unit: unit, direction: direction })=>{
        const milliseconds = unit === (0, (0, parcelRequire("gh61P")).DateUnits).DAYS ? quantity * (0, (0, parcelRequire("flnZx")).ONE_DAY) : quantity * (0, (0, parcelRequire("flnZx")).ONE_WEEK);
        return direction === (0, $TTKUQ.DIRECTIONS).AFTER ? milliseconds : -1 * milliseconds;
    };
    const $315df16e1d44deff$export$37dd434ed790acdc = (start, delta)=>{
        if (!(0, $4nDwW.isDefined)(start) && !(0, $4nDwW.isDefined)(delta)) return {
            method: (0, $6X8w9.DATE_METHODS).AS_EARLY_AS_POSSIBLE
        };
        if ((0, $4nDwW.isDefined)(start)) return {
            method: (0, $6X8w9.DATE_METHODS).FIXED_DATE
        };
        let dateReference;
        if ((0, $4nDwW.isDefined)(delta)) dateReference = $315df16e1d44deff$var$getDateReferenceFromMilliseconds(delta);
        return {
            method: (0, $6X8w9.DATE_METHODS).RELATIVE_TO_PREVIOUS_RELEASE,
            ...dateReference
        };
    };
    const $315df16e1d44deff$export$bd9c4c37a91873f3 = (end)=>{
        if ((0, $4nDwW.isDefined)(end)) return {
            method: (0, $6X8w9.DATE_METHODS).FIXED_DATE
        };
        return {
            method: (0, $6X8w9.DATE_METHODS).AFTER_ALL_ISSUES_ARE_COMPLETED
        };
    };
    const $315df16e1d44deff$export$3c13bed81ee9bbc8 = (values, originals, scenarioType)=>{
        const originalKeys = Object.keys(originals);
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED) {
            const { delta: delta, lexoRank: lexoRank, releaseStatusId: releaseStatusId, ...rest } = values;
            if (!(0, $4nDwW.isDefined)(values.description)) delete rest.description;
            if (!(0, $4nDwW.isDefined)(values.crossProjectVersion)) delete rest.crossProjectVersion;
            return Object.keys(rest);
        }
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).DELETED) return [];
        if (originalKeys.includes('delta')) return originalKeys.includes('start') ? originalKeys.filter((key)=>key !== 'delta') : originalKeys.map((key)=>key === 'delta' ? 'start' : key);
        return originalKeys;
    };
    const $315df16e1d44deff$export$8372f47f7c4a2a9 = (changedAttributes, scenarioType)=>{
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED || changedAttributes.length !== 1) return;
        const attributeName = changedAttributes[0];
        return attributeName;
    };
    const $315df16e1d44deff$export$ec4d0087f9018a86 = (issue, releases)=>{
        if ((0, parcelRequire("3nPAF")).default(issue.fixVersions) || !(0, $4nDwW.isDefined)(issue.fixVersions)) return null;
        if (issue.fixVersions.length > 1) {
            const { startDate: startDate, endDate: endDate } = issue.fixVersions.reduce((acc, fixVersion)=>{
                const fixVersionStartDate = releases[fixVersion]?.start;
                if (fixVersionStartDate) acc.startDate = Math.min(acc.startDate, fixVersionStartDate);
                else acc.startDate = -Infinity;
                const fixVersionEndDate = releases[fixVersion]?.end;
                if (fixVersionEndDate) acc.endDate = Math.min(acc.endDate, fixVersionEndDate);
                return acc;
            }, {
                startDate: Infinity,
                endDate: Infinity
            });
            return {
                startDate: Number.isFinite(startDate) ? startDate : null,
                endDate: Number.isFinite(endDate) ? endDate : null
            };
        }
        const fixVersion = issue.fixVersions[0];
        const startDate = releases[fixVersion]?.start;
        const endDate = releases[fixVersion]?.end;
        return {
            startDate: startDate,
            endDate: endDate
        };
    };
});
parcelRegister("6X8w9", function(module, exports) {
    $parcel$export(module.exports, "DATE_METHODS", ()=>$b85e86641eaa04ec$export$850c860d7b37834e);
    const $b85e86641eaa04ec$export$850c860d7b37834e = {
        LEAVE_AS_IS: 'leaveAsIs',
        AS_EARLY_AS_POSSIBLE: 'asEarlyAsPossible',
        RELATIVE_TO_PREVIOUS_RELEASE: 'relativeToPreviousRelease',
        FIXED_DATE: 'fixedDate',
        AFTER_ALL_ISSUES_ARE_COMPLETED: 'afterAllIssuesAreCompleted'
    };
});
parcelRegister("ageG6", function(module, exports) {
    $parcel$export(module.exports, "getPersons", ()=>$1be34ce0a96a12bd$export$a65219a764b7ed0b);
    $parcel$export(module.exports, "getPersonByItemKey", ()=>$1be34ce0a96a12bd$export$2b4d70a437cfed20);
    $parcel$export(module.exports, "getTeamsPersons", ()=>$1be34ce0a96a12bd$export$d6f9c7178699f78f);
    $parcel$export(module.exports, "getTeamsAssigneeAccountIds", ()=>$1be34ce0a96a12bd$export$5df6d993def6aa15);
    var $3YtPS = parcelRequire("3YtPS");
    var $dRVQG = parcelRequire("dRVQG");
    const $1be34ce0a96a12bd$export$a65219a764b7ed0b = (state)=>state.domain.persons;
    const $1be34ce0a96a12bd$export$2b4d70a437cfed20 = (persons, itemKey)=>persons.find((person)=>person.itemKey === itemKey);
    const $1be34ce0a96a12bd$export$810f09e034097552 = (teams, persons)=>{
        const resources = teams.flatMap((team)=>team.resources);
        const personItemKeys = new Set(resources.map((resource)=>resource.personItemKey));
        return persons.filter((person)=>personItemKeys.has(person.itemKey));
    };
    const $1be34ce0a96a12bd$export$d6f9c7178699f78f = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getExistingTeams),
        $1be34ce0a96a12bd$export$a65219a764b7ed0b
    ], $1be34ce0a96a12bd$export$810f09e034097552);
    const $1be34ce0a96a12bd$export$be4040e7528db5fb = (persons)=>persons.reduce((acc, person)=>{
            if (person.jiraUser) acc.push(person.jiraUser.accountId);
            return acc;
        }, []);
    const $1be34ce0a96a12bd$export$5df6d993def6aa15 = (0, $3YtPS.createSelector)([
        $1be34ce0a96a12bd$export$d6f9c7178699f78f
    ], $1be34ce0a96a12bd$export$be4040e7528db5fb);
});
parcelRegister("5FmOW", function(module, exports) {
    $parcel$export(module.exports, "matchFilter", ()=>$1b23c8745b2dc56d$export$c6f8482e724e56c5);
    $parcel$export(module.exports, "applyFilter", ()=>$1b23c8745b2dc56d$export$1b001418845b471c);
    var $SZGT2;
    var $3nPAF;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    function $1b23c8745b2dc56d$export$c6f8482e724e56c5(filterValue, attrValue) {
        return attrValue.some((v)=>filterValue.includes(v));
    }
    const $1b23c8745b2dc56d$export$1b001418845b471c = (issue, filterValue, attrName, optimizedMode)=>{
        if (!filterValue || filterValue.length === 0) return true;
        const attrValue = optimizedMode ? [
            ...issue.assignments.map((el)=>el[attrName]).filter((el)=>el),
            issue[attrName]
        ] : issue[attrName];
        if (attrValue instanceof Array) {
            const matchable = (0, parcelRequire("3nPAF")).default(attrValue) ? [
                (0, $TTKUQ.UNDEFINED_KEY)
            ] : (0, parcelRequire("SZGT2")).default(attrValue);
            return $1b23c8745b2dc56d$export$c6f8482e724e56c5(filterValue, matchable);
        }
        const matchable = !(0, $4nDwW.isDefined)(attrValue) ? [
            (0, $TTKUQ.UNDEFINED_KEY)
        ] : [
            attrValue
        ];
        return $1b23c8745b2dc56d$export$c6f8482e724e56c5(filterValue, matchable);
    };
});
parcelRegister("SZGT2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a54e5c0a798e76e$export$2e2bcd8739ae039);
    var $ccUYa;
    var $alz1M;
    var $0a54e5c0a798e76e$var$flatten = (0, (0, parcelRequire("ccUYa")).default)((0, (0, parcelRequire("alz1M")).default)(true));
    var $0a54e5c0a798e76e$export$2e2bcd8739ae039 = $0a54e5c0a798e76e$var$flatten;
});
parcelRegister("9sUIN", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$24cf7ec73e42089c$export$1b001418845b471c);
    $parcel$export(module.exports, "getComponentFilter", ()=>$24cf7ec73e42089c$export$bcd437988954b9c8);
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $5nMRY = parcelRequire("5nMRY");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $cGbfF = parcelRequire("cGbfF");
    const $24cf7ec73e42089c$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, filter.value, 'components', optimizedMode);
    const $24cf7ec73e42089c$export$b546ae0f6e6b7b86 = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.COMPONENT_FILTER_ID] || {
            id: (0, $cGbfF.COMPONENT_FILTER_ID),
            value: []
        };
    const $24cf7ec73e42089c$export$bcd437988954b9c8 = (0, $3YtPS.createSelector)([
        (0, $5nMRY.getComponents),
        $24cf7ec73e42089c$export$b546ae0f6e6b7b86
    ], (components, pureFilter)=>{
        const { value: value = [] } = pureFilter;
        const componentIds = new Set(components.map(({ id: id })=>id));
        const existingComponents = value.filter((component)=>componentIds.has(component));
        return {
            id: (0, $cGbfF.COMPONENT_FILTER_ID),
            value: existingComponents
        };
    });
});
parcelRegister("5nMRY", function(module, exports) {
    $parcel$export(module.exports, "getComponents", ()=>$eab670107a35086e$export$4e811121b221213b);
    $parcel$export(module.exports, "getComponentsById", ()=>$eab670107a35086e$export$1cb6b3a2bacfcd71);
    $parcel$export(module.exports, "getComponentsByProjectId", ()=>$eab670107a35086e$export$d273028e2d6ef56c);
    var $4Rr1a;
    var $2rMKg;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $jpXKt = parcelRequire("jpXKt");
    const $eab670107a35086e$export$69acd92c48f788f7 = (projects)=>(0, $4nDwW.chain)(({ components: components })=>components || [], projects);
    const $eab670107a35086e$export$4e811121b221213b = (0, $3YtPS.createSelector)([
        (0, $jpXKt.getProjects)
    ], $eab670107a35086e$export$69acd92c48f788f7);
    const $eab670107a35086e$export$1cb6b3a2bacfcd71 = (0, $3YtPS.createSelector)([
        $eab670107a35086e$export$4e811121b221213b
    ], (components)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), components));
    const $eab670107a35086e$export$d273028e2d6ef56c = (0, $3YtPS.createSelector)([
        (0, $jpXKt.getProjectsById)
    ], (projectsById)=>(0, parcelRequire("4Rr1a")).default((project)=>project.components ?? [], projectsById));
});
parcelRegister("1dvM4", function(module, exports) {
    $parcel$export(module.exports, "getCrossProjectReleaseFilter", ()=>$ef67b7cfdc26f27c$export$d3efc13c7bb14288);
    var $cGbfF = parcelRequire("cGbfF");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $jw86H = parcelRequire("jw86H");
    var $kWDpn = parcelRequire("kWDpn");
    var $cGbfF = parcelRequire("cGbfF");
    const $ef67b7cfdc26f27c$export$1fb508e90d4dba03 = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID] || {
            id: (0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID),
            value: []
        };
    const $ef67b7cfdc26f27c$export$d3efc13c7bb14288 = (0, $3YtPS.createSelector)([
        (0, $jw86H.getCrossProjectVersionsById),
        $ef67b7cfdc26f27c$export$1fb508e90d4dba03
    ], (crossProjectVersionsById, pureFilter)=>{
        const { value: value = [] } = pureFilter;
        return {
            id: (0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID),
            value: value.reduce((result, cprId)=>{
                const crossProjectVersion = crossProjectVersionsById[cprId];
                if ((0, $4nDwW.isDefined)(crossProjectVersion)) result.push(cprId);
                return result;
            }, []),
            crossProjectVersionsById: crossProjectVersionsById
        };
    });
});
parcelRegister("jw86H", function(module, exports) {
    $parcel$export(module.exports, "getCrossProjectVersions", ()=>$d924821645f146a7$export$96aefa9e5b339235);
    $parcel$export(module.exports, "getCrossProjectVersionsById", ()=>$d924821645f146a7$export$34f7a353be0fbd5a);
    $parcel$export(module.exports, "getRemovedCrossProjectVersions", ()=>$d924821645f146a7$export$541a8daa218b27a8);
    $parcel$export(module.exports, "getRemovedCrossProjectVersionsById", ()=>$d924821645f146a7$export$8c7c88d6ff048be3);
    $parcel$export(module.exports, "getOriginalCrossProjectVersions", ()=>$d924821645f146a7$export$15354078c9227d29);
    $parcel$export(module.exports, "getCrossProjectVersionChangeCount", ()=>$d924821645f146a7$export$a8e5eb8dd701e4cf);
    $parcel$export(module.exports, "getCrossProjectVersionChanges", ()=>$d924821645f146a7$export$82c61cf2cd5affb4);
    $parcel$export(module.exports, "getEnrichedCrossProjectVersions", ()=>$d924821645f146a7$export$b0aa263c5f8aad6a);
    $parcel$export(module.exports, "getEnrichedCrossProjectVersionsById", ()=>$d924821645f146a7$export$be19acca0e4271d3);
    $parcel$export(module.exports, "getEnrichedCrossProjectVersionsSortedByName", ()=>$d924821645f146a7$export$af5dc8974c602aef);
    var $ik0Qc;
    var $fZhYM;
    var $2rMKg;
    var $h35CY;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $9FFuD = parcelRequire("9FFuD");
    const $d924821645f146a7$export$96aefa9e5b339235 = (state)=>state.domain.crossProjectVersions;
    const $d924821645f146a7$export$34f7a353be0fbd5a = (0, $3YtPS.createSelector)([
        $d924821645f146a7$export$96aefa9e5b339235
    ], (crossProjectVersions)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), crossProjectVersions));
    const $d924821645f146a7$export$541a8daa218b27a8 = (state)=>state.domain.removedCrossProjectVersions;
    const $d924821645f146a7$export$8c7c88d6ff048be3 = (0, $3YtPS.createSelector)([
        $d924821645f146a7$export$541a8daa218b27a8
    ], (removedCrossProjectVersions)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), removedCrossProjectVersions));
    const $d924821645f146a7$export$15354078c9227d29 = (state)=>state.domain.originalCrossProjectVersions;
    const $d924821645f146a7$export$a8e5eb8dd701e4cf = ({ domain: { originalCrossProjectVersions: originalCrossProjectVersions } })=>Object.keys(originalCrossProjectVersions).length;
    const $d924821645f146a7$export$a4034dcb9c848c74 = (state)=>(0, parcelRequire("fZhYM")).default([
            'domain',
            'updateJira',
            'changes',
            'data',
            'metaData',
            'crossProjectVersions'
        ], state) || {};
    const $d924821645f146a7$export$d4d0f421f97c57fe = (state)=>state.domain.updateJira.warnings[(0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE];
    const $d924821645f146a7$export$ee9e0efc68f3757b = (crossProjectVersions = [], removedCrossProjectVersions = [], originalCrossProjectVersions = {}, entityMetaData, warnings)=>{
        const crossProjectVersionsById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), [
            ...crossProjectVersions,
            ...removedCrossProjectVersions
        ]);
        return (0, $4nDwW.filterMap)((id)=>(0, $4nDwW.isDefined)(crossProjectVersionsById[id]), (id)=>{
            const crossProjectVersion = crossProjectVersionsById[id];
            const metaData = entityMetaData[id];
            return {
                attributeName: metaData.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED ? null : 'name',
                category: (0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE,
                changeCount: metaData.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED ? 0 : 1,
                details: {
                    values: crossProjectVersion,
                    originals: (0, parcelRequire("ik0Qc")).default(originalCrossProjectVersions[id], {})
                },
                id: id,
                metaData: metaData,
                warnings: warnings[id] || []
            };
        }, Object.keys(entityMetaData));
    };
    const $d924821645f146a7$export$82c61cf2cd5affb4 = (0, $3YtPS.createSelector)([
        $d924821645f146a7$export$96aefa9e5b339235,
        $d924821645f146a7$export$541a8daa218b27a8,
        $d924821645f146a7$export$15354078c9227d29,
        $d924821645f146a7$export$a4034dcb9c848c74,
        $d924821645f146a7$export$d4d0f421f97c57fe
    ], $d924821645f146a7$export$ee9e0efc68f3757b);
    const $d924821645f146a7$export$ad60801a43040a2 = (crossProjectVersions, versionsByIdMap)=>crossProjectVersions.map(({ versions: versions, ...rest })=>({
                ...rest,
                versions: versions.map((vid)=>versionsByIdMap[vid])
            }));
    const $d924821645f146a7$export$b0aa263c5f8aad6a = (0, $3YtPS.createSelector)([
        $d924821645f146a7$export$96aefa9e5b339235,
        (0, $9FFuD.getVersionsById)
    ], $d924821645f146a7$export$ad60801a43040a2);
    const $d924821645f146a7$export$be19acca0e4271d3 = (0, $3YtPS.createSelector)([
        $d924821645f146a7$export$b0aa263c5f8aad6a
    ], (versions)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), versions));
    const $d924821645f146a7$export$34c32ae6954e6b88 = (enrichedCrossProjectVersions)=>(0, parcelRequire("h35CY")).default((0, parcelRequire("2rMKg")).default('name'), enrichedCrossProjectVersions);
    const $d924821645f146a7$export$af5dc8974c602aef = (0, $3YtPS.createSelector)([
        $d924821645f146a7$export$b0aa263c5f8aad6a
    ], $d924821645f146a7$export$34c32ae6954e6b88);
});
parcelRegister("eOe9K", function(module, exports) {
    $parcel$export(module.exports, "NO_CUSTOM_FIELD_VALUE_ID", ()=>$5ef97e902db2491c$export$ee2197aa1f91e426);
    $parcel$export(module.exports, "applyFilter", ()=>$5ef97e902db2491c$export$1b001418845b471c);
    $parcel$export(module.exports, "getCustomFieldFilter", ()=>$5ef97e902db2491c$export$bdbfb790183fd77b);
    $parcel$export(module.exports, "getCustomFieldFilterCount", ()=>$5ef97e902db2491c$export$673e7236e5e3896);
    $parcel$export(module.exports, "getCustomFieldsWithFilteringAllowed", ()=>$5ef97e902db2491c$export$9eed4354878b09d1);
    var $3nPAF;
    var $4R6GH;
    var $cGbfF = parcelRequire("cGbfF");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $19iju = parcelRequire("19iju");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $cGbfF = parcelRequire("cGbfF");
    const $5ef97e902db2491c$export$ee2197aa1f91e426 = (0, $TTKUQ.UNDEFINED_KEY);
    const $5ef97e902db2491c$export$1b001418845b471c = (issue, customFieldFilter, customFields)=>{
        const matches = Object.keys(customFieldFilter.value).map((fieldId)=>{
            const customField = customFields.find(({ id: id })=>id === Number(fieldId));
            const filterValue = customFieldFilter.value[fieldId];
            const attribute = issue.customFields && issue.customFields[fieldId];
            if (!(0, $4nDwW.isDefined)(customField)) throw new Error('customField not found for the filter');
            switch(customField.type.key){
                case (0, $TTKUQ.CustomFieldTypes).Labels:
                case (0, $TTKUQ.CustomFieldTypes).MultiCheckboxes:
                case (0, $TTKUQ.CustomFieldTypes).AssetObject:
                case (0, $TTKUQ.CustomFieldTypes).MultiSelect:
                    {
                        if (!(0, (0, parcelRequire("4R6GH")).fg)('asset-custom-field-internal-support')) {
                            if (customField.type.key === (0, $TTKUQ.CustomFieldTypes).AssetObject) return true;
                        }
                        const emptyFilter = filterValue.length === 0;
                        if (emptyFilter) return true;
                        const matchable = attribute instanceof Array && !(0, parcelRequire("3nPAF")).default(attribute) ? attribute : [
                            $5ef97e902db2491c$export$ee2197aa1f91e426
                        ];
                        return (0, $5FmOW.matchFilter)(filterValue, matchable);
                    }
                case (0, $TTKUQ.CustomFieldTypes).RadioButtons:
                case (0, $TTKUQ.CustomFieldTypes).SingleSelect:
                    {
                        if (!Array.isArray(filterValue)) throw new Error(`value of filter for ${customField.title} is not an array`);
                        const emptyFilter = filterValue.length === 0;
                        if (emptyFilter) return true;
                        const matchable = attribute ? [
                            attribute
                        ] : [
                            $5ef97e902db2491c$export$ee2197aa1f91e426
                        ];
                        return (0, $5FmOW.matchFilter)(filterValue, matchable);
                    }
                default:
                    return true;
            }
        });
        return matches.reduce((a, b)=>a && b, true);
    };
    const $5ef97e902db2491c$var$getRawCustomFieldFilter = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.CUSTOM_FIELD_FILTER_ID] || {
            id: (0, $cGbfF.CUSTOM_FIELD_FILTER_ID),
            value: {}
        };
    const $5ef97e902db2491c$export$bdbfb790183fd77b = (0, $3YtPS.createSelector)([
        $5ef97e902db2491c$var$getRawCustomFieldFilter,
        (0, $19iju.getCustomFields)
    ], (customFieldFilter, customFields)=>{
        const value = customFields.reduce((acc, customField)=>{
            const id = String(customField.id);
            const filterValue = customFieldFilter.value[id];
            switch(customField.type.key){
                case (0, $TTKUQ.CustomFieldTypes).Labels:
                case (0, $TTKUQ.CustomFieldTypes).MultiCheckboxes:
                case (0, $TTKUQ.CustomFieldTypes).AssetObject:
                case (0, $TTKUQ.CustomFieldTypes).MultiSelect:
                case (0, $TTKUQ.CustomFieldTypes).RadioButtons:
                case (0, $TTKUQ.CustomFieldTypes).SingleSelect:
                    if (!(0, (0, parcelRequire("4R6GH")).fg)('asset-custom-field-internal-support')) {
                        if (customField.type.key === (0, $TTKUQ.CustomFieldTypes).AssetObject) return acc;
                    }
                    if (!Array.isArray(filterValue)) return Object.assign(acc, {
                        [id]: []
                    });
                    return Object.assign(acc, {
                        [id]: filterValue
                    });
                default:
                    return acc;
            }
        }, {});
        return {
            ...customFieldFilter,
            value: value
        };
    });
    const $5ef97e902db2491c$var$getCustomFieldFilterCountPure = (customFieldFilter, customFields)=>{
        if (customFields.length === 0) return 0;
        return Object.keys(customFieldFilter.value).reduce((count, fieldId)=>{
            const customField = customFields.find(({ id: id })=>id === Number(fieldId));
            const filterValue = customFieldFilter.value[fieldId];
            if (!(0, $4nDwW.isDefined)(customField)) throw new Error('customField not found for the filter');
            switch(customField.type.key){
                case (0, $TTKUQ.CustomFieldTypes).Labels:
                case (0, $TTKUQ.CustomFieldTypes).MultiCheckboxes:
                case (0, $TTKUQ.CustomFieldTypes).AssetObject:
                case (0, $TTKUQ.CustomFieldTypes).MultiSelect:
                case (0, $TTKUQ.CustomFieldTypes).RadioButtons:
                case (0, $TTKUQ.CustomFieldTypes).SingleSelect:
                    if (!(0, (0, parcelRequire("4R6GH")).fg)('asset-custom-field-internal-support')) {
                        if (customField.type.key === (0, $TTKUQ.CustomFieldTypes).AssetObject) return count;
                    }
                    if (!Array.isArray(filterValue)) throw new Error(`value of filter for ${customField.title} is not an array`);
                    return filterValue.length > 0 ? count + 1 : count;
                default:
                    return count;
            }
        }, 0);
    };
    const $5ef97e902db2491c$export$673e7236e5e3896 = (0, $3YtPS.createSelector)([
        $5ef97e902db2491c$export$bdbfb790183fd77b,
        (0, $19iju.getCustomFields)
    ], (customFieldFilter, customFields)=>$5ef97e902db2491c$var$getCustomFieldFilterCountPure(customFieldFilter, customFields));
    const $5ef97e902db2491c$export$9eed4354878b09d1 = (0, $3YtPS.createSelector)([
        (0, $19iju.getFilterableCustomFields)
    ], (customFields)=>customFields.filter((field)=>field.filteringAllowed));
});
parcelRegister("MT6jL", function(module, exports) {
    $parcel$export(module.exports, "getDateRangeFilter", ()=>$5c80eaa40a1f6a51$export$4adc666d0ec1b95a);
    $parcel$export(module.exports, "applyFilter", ()=>$5c80eaa40a1f6a51$export$1b001418845b471c);
    var $cGbfF = parcelRequire("cGbfF");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $kWDpn = parcelRequire("kWDpn");
    var $cGbfF = parcelRequire("cGbfF");
    const $5c80eaa40a1f6a51$export$8ef11a90fa2d53e4 = (state)=>{
        const { value: value } = (0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.DATE_RANGE_FILTER_ID] || {};
        return {
            id: (0, $cGbfF.DATE_RANGE_FILTER_ID),
            value: value
        };
    };
    const $5c80eaa40a1f6a51$export$cb4ac493812837a8 = (dateRangeFilter)=>({
            ...dateRangeFilter,
            value: dateRangeFilter.value || {}
        });
    const $5c80eaa40a1f6a51$export$4adc666d0ec1b95a = (0, $3YtPS.createSelector)([
        $5c80eaa40a1f6a51$export$8ef11a90fa2d53e4
    ], $5c80eaa40a1f6a51$export$cb4ac493812837a8);
    const $5c80eaa40a1f6a51$export$1b001418845b471c = ({ baselineEnd: baselineEnd, baselineStart: baselineStart }, { value: { startDate: startDate, endDate: endDate } })=>(!(0, $4nDwW.isDefined)(startDate) || (0, $4nDwW.isDefined)(baselineStart) && baselineStart >= startDate || (0, $4nDwW.isDefined)(baselineEnd) && baselineEnd >= startDate) && (!(0, $4nDwW.isDefined)(endDate) || (0, $4nDwW.isDefined)(baselineEnd) && baselineEnd <= endDate || (0, $4nDwW.isDefined)(baselineStart) && baselineStart <= endDate);
});
parcelRegister("6SQpK", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$7e09e0dfebe4ca23$export$1b001418845b471c);
    $parcel$export(module.exports, "getDependenciesFilter", ()=>$7e09e0dfebe4ca23$export$7e5efb93ed83c18f);
    var $4ENQh;
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $ddv1K = parcelRequire("ddv1K");
    var $aDKIU = parcelRequire("aDKIU");
    var $7ppNi = parcelRequire("7ppNi");
    var $bHTqr = parcelRequire("bHTqr");
    var $gFhwb = parcelRequire("gFhwb");
    var $kWDpn = parcelRequire("kWDpn");
    var $cGbfF = parcelRequire("cGbfF");
    const $7e09e0dfebe4ca23$export$1b001418845b471c = (issue, filter)=>{
        const { value: value, issuesWithLinks: issuesWithLinks = new Set(), specificIssueLinks: specificIssueLinks = new Set(), offtrackIssueLinks: offtrackIssueLinks = new Set() } = filter;
        switch(value.type){
            case 'on':
                return issuesWithLinks.has(issue.id);
            case 'specificIssue':
                return !value.issueId || specificIssueLinks.has(issue.id) || value.issueId === issue.id;
            case 'offtrack':
                return offtrackIssueLinks.has(issue.id);
            default:
                return true;
        }
    };
    const $7e09e0dfebe4ca23$export$c0e0bfc86fb01b8f = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.DEPENDENCIES_FILTER_ID] || {
            value: {
                type: 'off'
            }
        };
    const $7e09e0dfebe4ca23$export$14dac874d99ad1a4 = (value, incomingLinks, outgoingLinks)=>{
        const specificIssueLinks = new Set();
        if (value.type === 'specificIssue' && value.issueId) {
            if (value.includeTransitive) {
                const queue = [
                    value.issueId
                ];
                while(queue.length > 0){
                    const id = queue.pop();
                    for (const link of incomingLinks[id] || []){
                        const id = link.sourceItemKey;
                        if (!specificIssueLinks.has(id)) {
                            specificIssueLinks.add(id);
                            queue.push(id);
                        }
                    }
                    for (const link of outgoingLinks[id] || []){
                        const id = link.targetItemKey;
                        if (!specificIssueLinks.has(id)) {
                            specificIssueLinks.add(id);
                            queue.push(id);
                        }
                    }
                }
            } else {
                for (const link of incomingLinks[value.issueId || ''] || [])specificIssueLinks.add(link.sourceItemKey);
                for (const link of outgoingLinks[value.issueId || ''] || [])specificIssueLinks.add(link.targetItemKey);
            }
        }
        return specificIssueLinks;
    };
    const $7e09e0dfebe4ca23$export$f16b4b4ef2c78b0d = (issueMap, outgoingLinks, issueStatusById, syncStartEnabled)=>{
        const offtrackIssueLinks = new Set();
        for (const issueLinks of Object.values(outgoingLinks))for (const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey } of issueLinks){
            const overlapping = (0, $aDKIU.getIssueLinkIfOverlapping)(issueMap[sourceItemKey], issueMap[targetItemKey], issueStatusById, syncStartEnabled);
            if (overlapping) {
                offtrackIssueLinks.add(sourceItemKey);
                offtrackIssueLinks.add(targetItemKey);
            }
        }
        return offtrackIssueLinks;
    };
    const $7e09e0dfebe4ca23$export$f325f5532978989e = (0, (0, parcelRequire("4ENQh")).monitor).timeFunction($7e09e0dfebe4ca23$export$f16b4b4ef2c78b0d, 'query_filters_dependenciesFilter_index_getOfftrackIssueLinks');
    const $7e09e0dfebe4ca23$export$7e5efb93ed83c18f = (0, $3YtPS.createSelector)([
        $7e09e0dfebe4ca23$export$c0e0bfc86fb01b8f,
        (0, $ddv1K.getAllIssuesWithLinks),
        (0, $ddv1K.getInternalIncomingLinks),
        (0, $ddv1K.getInternalOutgoingLinks),
        (0, $gFhwb.getIssueMapById),
        (0, $7ppNi.getIssueStatusById),
        (0, $bHTqr.getSyncStartEnabled)
    ], (filterState, issuesWithLinks, incomingLinks, outgoingLinks, issueMap, issueStatusById, syncStartEnabled)=>{
        const { value: value = {
            type: 'off'
        } } = filterState || {};
        return {
            id: (0, $cGbfF.DEPENDENCIES_FILTER_ID),
            value: value,
            issuesWithLinks: issuesWithLinks,
            specificIssueLinks: $7e09e0dfebe4ca23$export$14dac874d99ad1a4(value, incomingLinks, outgoingLinks),
            offtrackIssueLinks: $7e09e0dfebe4ca23$export$f325f5532978989e(issueMap, outgoingLinks, issueStatusById, syncStartEnabled)
        };
    });
});
parcelRegister("ddv1K", function(module, exports) {
    $parcel$export(module.exports, "getIssueLinks", ()=>$c812ca2ce5d155c5$export$58c9baa89092141d);
    $parcel$export(module.exports, "getIssueLinkOriginals", ()=>$c812ca2ce5d155c5$export$1afd614b829de1af);
    $parcel$export(module.exports, "getOutgoingLinks", ()=>$c812ca2ce5d155c5$export$c13f12ce68344b34);
    $parcel$export(module.exports, "getOutgoingLinkOriginals", ()=>$c812ca2ce5d155c5$export$c7e01775a6d5ac01);
    $parcel$export(module.exports, "getInternalOutgoingLinks", ()=>$c812ca2ce5d155c5$export$4512d9d5dd191b3b);
    $parcel$export(module.exports, "getInternalOutgoingLinkOriginals", ()=>$c812ca2ce5d155c5$export$12bed64401d7ce47);
    $parcel$export(module.exports, "getExternalOutgoingLinks", ()=>$c812ca2ce5d155c5$export$cdbd80b3d29e5c05);
    $parcel$export(module.exports, "getIncomingLinks", ()=>$c812ca2ce5d155c5$export$1ed684a0d7ab81ae);
    $parcel$export(module.exports, "getIncomingLinkOriginals", ()=>$c812ca2ce5d155c5$export$6ad957af4df4a3e9);
    $parcel$export(module.exports, "getInternalIncomingLinks", ()=>$c812ca2ce5d155c5$export$5567029344c01af9);
    $parcel$export(module.exports, "getInternalIncomingLinkOriginals", ()=>$c812ca2ce5d155c5$export$55f70301dcb7a9b5);
    $parcel$export(module.exports, "getExternalIncomingLinks", ()=>$c812ca2ce5d155c5$export$503854918648e210);
    $parcel$export(module.exports, "getAllIssuesWithLinks", ()=>$c812ca2ce5d155c5$export$6b72ce8376e8916a);
    $parcel$export(module.exports, "getUniqueLinks", ()=>$c812ca2ce5d155c5$export$4592e5de25d61d15);
    $parcel$export(module.exports, "getDependencyIssueLinkTypes", ()=>$c812ca2ce5d155c5$export$2bf90898c9560ad8);
    $parcel$export(module.exports, "getDependencyIssueLinkTypesById", ()=>$c812ca2ce5d155c5$export$8f21fbdff6c58479);
    $parcel$export(module.exports, "getIssueCountByLinkType", ()=>$c812ca2ce5d155c5$export$9d514c9fb87fc17a);
    $parcel$export(module.exports, "getIssueLinkChangesDataPure", ()=>$c812ca2ce5d155c5$export$b2866f3fe0e9bd20);
    $parcel$export(module.exports, "getIssueLinkChangesData", ()=>$c812ca2ce5d155c5$export$aefbf48531b950e);
    $parcel$export(module.exports, "getIssueLinkChangesMetaData", ()=>$c812ca2ce5d155c5$export$ec9cbadd3b83e825);
    var $8Tt2N;
    var $SZGT2;
    var $3nPAF;
    var $4Rr1a;
    var $fZhYM;
    var $2rMKg;
    var $7p8Aa;
    var $bjzU8;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $gFhwb = parcelRequire("gFhwb");
    var $jpgxP = parcelRequire("jpgxP");
    const $c812ca2ce5d155c5$export$58c9baa89092141d = (state)=>state.domain.issueLinks.values;
    const $c812ca2ce5d155c5$export$1afd614b829de1af = (state)=>state.domain.issueLinks.originals;
    const $c812ca2ce5d155c5$export$10359de6952f0fb3 = (issueLinks, issuesById)=>(0, parcelRequire("4Rr1a")).default((links)=>links.filter((x)=>issuesById[x.sourceItemKey] && issuesById[x.targetItemKey]), issueLinks);
    const $c812ca2ce5d155c5$export$ec401995dee39995 = (issueLinks, issuesById)=>(0, parcelRequire("4Rr1a")).default((links)=>links.filter((x)=>!issuesById[x.sourceItemKey] || !issuesById[x.targetItemKey]), issueLinks);
    const $c812ca2ce5d155c5$export$6f5ee8e3e5b8730d = (issueLinks)=>(0, $4nDwW.mapObject)((issueId, links)=>(0, parcelRequire("bjzU8")).default(links).filter((x)=>x.sourceItemKey === issueId), issueLinks);
    const $c812ca2ce5d155c5$export$c13f12ce68344b34 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$58c9baa89092141d
    ], $c812ca2ce5d155c5$export$6f5ee8e3e5b8730d);
    const $c812ca2ce5d155c5$export$c7e01775a6d5ac01 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$1afd614b829de1af
    ], $c812ca2ce5d155c5$export$6f5ee8e3e5b8730d);
    const $c812ca2ce5d155c5$export$4512d9d5dd191b3b = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$c13f12ce68344b34,
        (0, $gFhwb.getIssueMapById)
    ], $c812ca2ce5d155c5$export$10359de6952f0fb3);
    const $c812ca2ce5d155c5$export$12bed64401d7ce47 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$c7e01775a6d5ac01,
        (0, $gFhwb.getIssueMapById)
    ], $c812ca2ce5d155c5$export$10359de6952f0fb3);
    const $c812ca2ce5d155c5$export$cdbd80b3d29e5c05 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$c13f12ce68344b34,
        (0, $gFhwb.getIssueMapById)
    ], $c812ca2ce5d155c5$export$ec401995dee39995);
    const $c812ca2ce5d155c5$export$9011cf2b1d0ca0e0 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$c7e01775a6d5ac01,
        (0, $gFhwb.getIssueMapById)
    ], $c812ca2ce5d155c5$export$ec401995dee39995);
    const $c812ca2ce5d155c5$export$1adf7387341603d7 = (issueLinks)=>(0, $4nDwW.mapObject)((issueId, links)=>(0, parcelRequire("bjzU8")).default(links).filter((x)=>x.targetItemKey === issueId), issueLinks);
    const $c812ca2ce5d155c5$export$1ed684a0d7ab81ae = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$58c9baa89092141d
    ], $c812ca2ce5d155c5$export$1adf7387341603d7);
    const $c812ca2ce5d155c5$export$6ad957af4df4a3e9 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$1afd614b829de1af
    ], $c812ca2ce5d155c5$export$1adf7387341603d7);
    const $c812ca2ce5d155c5$export$5567029344c01af9 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$1ed684a0d7ab81ae,
        (0, $gFhwb.getIssueMapById)
    ], $c812ca2ce5d155c5$export$10359de6952f0fb3);
    const $c812ca2ce5d155c5$export$55f70301dcb7a9b5 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$6ad957af4df4a3e9,
        (0, $gFhwb.getIssueMapById)
    ], $c812ca2ce5d155c5$export$10359de6952f0fb3);
    const $c812ca2ce5d155c5$export$503854918648e210 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$1ed684a0d7ab81ae,
        (0, $gFhwb.getIssueMapById)
    ], $c812ca2ce5d155c5$export$ec401995dee39995);
    const $c812ca2ce5d155c5$export$66da17e536ea1124 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$6ad957af4df4a3e9,
        (0, $gFhwb.getIssueMapById)
    ], $c812ca2ce5d155c5$export$ec401995dee39995);
    const $c812ca2ce5d155c5$export$6b72ce8376e8916a = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$58c9baa89092141d
    ], (issueLinks)=>new Set(Object.keys((0, parcelRequire("7p8Aa")).default((0, parcelRequire("3nPAF")).default, issueLinks))));
    const $c812ca2ce5d155c5$export$4592e5de25d61d15 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$58c9baa89092141d
    ], (issueLinks)=>{
        const cleanIssueLinks = (0, parcelRequire("SZGT2")).default((0, parcelRequire("4Rr1a")).default((0, parcelRequire("bjzU8")).default, (0, parcelRequire("bjzU8")).default((0, parcelRequire("7p8Aa")).default((0, parcelRequire("3nPAF")).default, issueLinks))));
        const seen = new Set();
        return cleanIssueLinks.filter((issueLink)=>{
            if (seen.has(issueLink.itemKey)) return false;
            seen.add(issueLink.itemKey);
            return true;
        });
    });
    const $c812ca2ce5d155c5$export$73624b3e4f1f5f78 = ({ issueLinkTypes: issueLinkTypes }, { dependencyIssueLinkTypes: dependencyIssueLinkTypes })=>{
        const linkTypes = new Set(dependencyIssueLinkTypes.map(({ issueLinkTypeId: issueLinkTypeId })=>issueLinkTypeId));
        return issueLinkTypes.filter(({ id: id })=>linkTypes.has(id));
    };
    const $c812ca2ce5d155c5$export$2bf90898c9560ad8 = (0, $3YtPS.createSelector)([
        (0, $jpgxP.getIssueLinkTypesInfo),
        (0, $jpgxP.getDependencySettingsInfo)
    ], $c812ca2ce5d155c5$export$73624b3e4f1f5f78);
    const $c812ca2ce5d155c5$export$8f21fbdff6c58479 = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$2bf90898c9560ad8
    ], (dependencyIssueLinkTypes)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), dependencyIssueLinkTypes));
    const $c812ca2ce5d155c5$export$77b826244302fe5c = (issueLinks)=>(0, parcelRequire("8Tt2N")).default((issue)=>issue.type)(issueLinks);
    const $c812ca2ce5d155c5$export$9d514c9fb87fc17a = (0, $3YtPS.createSelector)([
        $c812ca2ce5d155c5$export$4592e5de25d61d15
    ], $c812ca2ce5d155c5$export$77b826244302fe5c);
    const $c812ca2ce5d155c5$export$b2866f3fe0e9bd20 = (issueLinks = [])=>{
        const result = {};
        for (const link of issueLinks){
            const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey } = link;
            if (!result[sourceItemKey]) result[sourceItemKey] = [];
            if (!result[targetItemKey]) result[targetItemKey] = [];
            result[sourceItemKey].push({
                ...link,
                direction: (0, $TTKUQ.ISSUE_LINK_DIRECTION).INWARD
            });
            result[targetItemKey].push({
                ...link,
                direction: (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD
            });
        }
        return result;
    };
    const $c812ca2ce5d155c5$export$aefbf48531b950e = (0, $3YtPS.createSelector)([
        (0, parcelRequire("fZhYM")).default([
            'domain',
            'updateJira',
            'changes',
            'data',
            'issueLinks'
        ])
    ], $c812ca2ce5d155c5$export$b2866f3fe0e9bd20);
    const $c812ca2ce5d155c5$export$ec9cbadd3b83e825 = (state)=>(0, parcelRequire("fZhYM")).default([
            'domain',
            'updateJira',
            'changes',
            'data',
            'metaData',
            'issueLinks'
        ], state) || {};
});
parcelRegister("aDKIU", function(module, exports) {
    $parcel$export(module.exports, "getIssueLinkIfOverlapping", ()=>$04ec0efccd1d22d2$export$bfc725baf7746c7e);
    $parcel$export(module.exports, "getIssueLinkLeadTime", ()=>$04ec0efccd1d22d2$export$a7e1a952eb4b8aaf);
    var $4R6GH;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fHJiO = parcelRequire("fHJiO");
    const $04ec0efccd1d22d2$var$isIssueDone = (issue, issueStatusById)=>{
        if ('statusCategoryId' in issue && typeof issue.statusCategoryId === 'number') return issue.statusCategoryId === (0, $TTKUQ.ISSUE_STATUS_CATEGORIES).DONE;
        if ('status' in issue && typeof issue.status === 'string') return issueStatusById[issue.status]?.categoryId === (0, $TTKUQ.ISSUE_STATUS_CATEGORIES).DONE;
        return false;
    };
    const $04ec0efccd1d22d2$export$bfc725baf7746c7e = (sourceIssue, targetIssue, issueStatusById, syncStartEnabled)=>{
        if (!(0, $4nDwW.isDefined)(sourceIssue) || !(0, $4nDwW.isDefined)(targetIssue)) return false;
        if ($04ec0efccd1d22d2$var$isIssueDone(sourceIssue, issueStatusById) || $04ec0efccd1d22d2$var$isIssueDone(targetIssue, issueStatusById)) return false;
        let sourceIssueSprint;
        const { baselineStart: sourceIssueStartTime, baselineEnd: sourceIssueEndTime } = (0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline') ? (0, $fHJiO.swapIssueBaselineDatesIfInverted)(sourceIssue) : sourceIssue;
        if ('sprint' in sourceIssue && sourceIssue.sprint !== 'undefined') sourceIssueSprint = sourceIssue.sprint;
        let targetIssueSprint;
        const { baselineStart: targetIssueStartTime, baselineEnd: targetIssueEndTime } = (0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline') ? (0, $fHJiO.swapIssueBaselineDatesIfInverted)(targetIssue) : targetIssue;
        if ('sprint' in targetIssue && targetIssue.sprint !== 'undefined') targetIssueSprint = targetIssue.sprint;
        if ((0, $4nDwW.isDefined)(sourceIssueSprint) && (0, $4nDwW.isDefined)(targetIssueSprint) && sourceIssueSprint === targetIssueSprint && syncStartEnabled) {
            if ((0, $4nDwW.isDefined)(sourceIssueStartTime)) {
                if ((0, $4nDwW.isDefined)(targetIssueStartTime)) return sourceIssueStartTime > targetIssueStartTime;
                if (!(0, $4nDwW.isDefined)(targetIssueEndTime)) return false;
                return sourceIssueStartTime > targetIssueEndTime;
            }
            return false;
        }
        if ((0, $4nDwW.isDefined)(targetIssueEndTime)) {
            if (!(0, $4nDwW.isDefined)(sourceIssueEndTime)) return true;
            if (!(0, $4nDwW.isDefined)(targetIssueStartTime)) return true;
            return sourceIssueEndTime - targetIssueStartTime > (0, $TTKUQ.VALID_LEADING_TIME_FOR_DEPENDENCIES);
        }
        return false;
    };
    const $04ec0efccd1d22d2$export$a7e1a952eb4b8aaf = (sourceIssue, targetIssue)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline')) {
            const sourceIssueOrderedDates = (0, $fHJiO.swapIssueBaselineDatesIfInverted)(sourceIssue);
            const targetIssueOrderedDates = (0, $fHJiO.swapIssueBaselineDatesIfInverted)(targetIssue);
            if ((0, $4nDwW.isDefined)(sourceIssueOrderedDates) && (0, $4nDwW.isDefined)(sourceIssueOrderedDates.baselineEnd) && (0, $4nDwW.isDefined)(targetIssueOrderedDates) && (0, $4nDwW.isDefined)(targetIssueOrderedDates.baselineStart)) return targetIssueOrderedDates.baselineStart - sourceIssueOrderedDates.baselineEnd;
            return null;
        }
        if ((0, $4nDwW.isDefined)(sourceIssue) && (0, $4nDwW.isDefined)(sourceIssue.baselineEnd) && (0, $4nDwW.isDefined)(targetIssue) && (0, $4nDwW.isDefined)(targetIssue.baselineStart)) return targetIssue.baselineStart - sourceIssue.baselineEnd;
        return null;
    };
});
parcelRegister("fHJiO", function(module, exports) {
    $parcel$export(module.exports, "getIssuesStatusBreakdown", ()=>$f2bf1a351f380137$export$dae9c33c40f899e8);
    $parcel$export(module.exports, "getEstimateBreakdown", ()=>$f2bf1a351f380137$export$a1f397ecb6d56961);
    $parcel$export(module.exports, "isIssueSubTaskType", ()=>$f2bf1a351f380137$export$58e9558e964135a4);
    $parcel$export(module.exports, "getPossibleParentIssues", ()=>$f2bf1a351f380137$export$ab64a2584557c8a1);
    $parcel$export(module.exports, "swapIssueBaselineDatesIfInverted", ()=>$f2bf1a351f380137$export$87cc699475952888);
    var $fZhYM;
    var $dJl1T;
    var $c12LJ;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ekXoi = parcelRequire("ekXoi");
    const $f2bf1a351f380137$export$dae9c33c40f899e8 = (issues, issueStatusesById, option)=>{
        const getCategoryId = (statusId)=>{
            const issueStatus = issueStatusesById[statusId];
            if (issueStatus) return String(issueStatus.categoryId);
            (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('portfolio.issue-helper', `Issue status not found: ${statusId}`);
            return '';
        };
        const issuesGroupedByStatusCategory = issues.reduce((acc, issue)=>{
            if (issue.status) {
                const categoryId = getCategoryId(issue.status);
                if (categoryId !== '') {
                    if (acc[categoryId]) acc[categoryId].push(issue);
                    else acc[categoryId] = [
                        issue
                    ];
                }
            }
            return acc;
        }, {});
        let totalEstimatedWork = 0;
        const estimatedWorkGroupedByStatusCategory = Object.fromEntries(Object.entries(issuesGroupedByStatusCategory).map(([categoryId, issuesInThisCategory])=>{
            if (option !== undefined) {
                const { planningUnit: planningUnit, workingHours: workingHours } = option;
                const estimatedWork = issuesInThisCategory.reduce((acc, issue)=>{
                    switch(planningUnit){
                        case (0, $TTKUQ.PlanningUnits).days:
                        case (0, $TTKUQ.PlanningUnits).hours:
                            return acc + (0, $ekXoi.getEstimateValue)(planningUnit, issue, workingHours);
                        case (0, $TTKUQ.PlanningUnits).storyPoints:
                            return acc + (issue.storyPoints ?? 0);
                        default:
                            return acc + 1;
                    }
                }, 0);
                totalEstimatedWork += estimatedWork;
                return [
                    categoryId,
                    estimatedWork
                ];
            }
            totalEstimatedWork += issuesInThisCategory.length;
            return [
                categoryId,
                issuesInThisCategory.length
            ];
        }));
        const { TODO: TODO, INPROGRESS: INPROGRESS, DONE: DONE } = (0, $TTKUQ.ISSUE_STATUS_CATEGORIES_CONST);
        return {
            byCategoryId: {
                [String(TODO)]: estimatedWorkGroupedByStatusCategory[TODO] ?? 0,
                [String(INPROGRESS)]: estimatedWorkGroupedByStatusCategory[INPROGRESS] ?? 0,
                [String(DONE)]: estimatedWorkGroupedByStatusCategory[DONE] ?? 0
            },
            total: totalEstimatedWork
        };
    };
    const $f2bf1a351f380137$export$a1f397ecb6d56961 = (issue, childIssues, issueStatuses, planningUnit, workingHours)=>{
        const { TODO: TODO, INPROGRESS: INPROGRESS, DONE: DONE } = (0, $TTKUQ.ISSUE_STATUS_CATEGORIES_CONST);
        const breakdown = {
            byCategoryId: {
                [TODO]: 0,
                [INPROGRESS]: 0,
                [DONE]: 0
            },
            total: 0,
            unestimated: 0,
            issueCount: 0
        };
        const updateBreakdown = (issue)=>{
            if ((0, $ekXoi.isEstimated)(planningUnit, issue)) {
                const categoryId = (0, parcelRequire("fZhYM")).default([
                    issue.status || '',
                    'categoryId'
                ], issueStatuses) || TODO;
                const remainingEstimate = (0, $ekXoi.getEstimateValue)(planningUnit, issue, workingHours);
                const timeSpent = (0, $ekXoi.getTimeSpentValue)(planningUnit, issue, workingHours);
                if (categoryId === DONE) breakdown.byCategoryId[categoryId] = (breakdown.byCategoryId[categoryId] || 0) + remainingEstimate + timeSpent;
                else {
                    breakdown.byCategoryId[categoryId] = (breakdown.byCategoryId[categoryId] || 0) + remainingEstimate;
                    breakdown.byCategoryId[DONE] = (breakdown.byCategoryId[DONE] || 0) + timeSpent;
                }
                breakdown.total += remainingEstimate + timeSpent;
                breakdown.issueCount += 1;
            } else breakdown.unestimated += 1;
        };
        childIssues.forEach(updateBreakdown);
        updateBreakdown(issue);
        return breakdown;
    };
    const $f2bf1a351f380137$export$58e9558e964135a4 = ({ issue: issue, issueTypesById: issueTypesById })=>{
        const { type: type } = issue;
        const issueType = issueTypesById[type];
        return issueType && !!issueType.subTask;
    };
    const $f2bf1a351f380137$export$ab64a2584557c8a1 = ({ issue: issue, issues: issues, issueTypesById: issueTypesById, projectsById: projectsById })=>{
        const { level: issueLevel, project: issueProjectId } = issue;
        const isIssueSubtask = $f2bf1a351f380137$export$58e9558e964135a4({
            issue: issue,
            issueTypesById: issueTypesById
        });
        const { isSimplified: isIssueSimplified } = projectsById[issueProjectId] ?? {
            isSimplified: false
        };
        const isIssueLevelOne = issueLevel === (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL);
        return issues.filter((currentIssue)=>{
            if (isIssueSimplified) return (currentIssue.level === issueLevel + 1 && (currentIssue.project === issueProjectId || isIssueLevelOne));
            const { isSimplified: isCurrentIssueSimplified } = projectsById[currentIssue.project] ?? {
                isSimplified: false
            };
            if (isCurrentIssueSimplified) return false;
            return isIssueSubtask ? currentIssue.level !== issueLevel : currentIssue.level === issueLevel + 1;
        });
    };
    const $f2bf1a351f380137$export$87cc699475952888 = (issue)=>{
        if (issue?.baselineStart && issue?.baselineEnd) {
            const { baselineStart: baselineStart, baselineEnd: baselineEnd } = issue;
            return {
                ...issue,
                baselineStart: Math.min(baselineStart, baselineEnd),
                baselineEnd: Math.max(baselineStart, baselineEnd)
            };
        }
        return issue;
    };
});
parcelRegister("ekXoi", function(module, exports) {
    $parcel$export(module.exports, "convertSecondsToHours", ()=>$53405a2209afea8c$export$9446e10eb5cfa53);
    $parcel$export(module.exports, "convertSecondsToDays", ()=>$53405a2209afea8c$export$c6ce755da034e875);
    $parcel$export(module.exports, "isEstimated", ()=>$53405a2209afea8c$export$28d842baedf9b186);
    $parcel$export(module.exports, "getEstimateRollupValue", ()=>$53405a2209afea8c$export$dacf8be5aae1988);
    $parcel$export(module.exports, "getEstimateValue", ()=>$53405a2209afea8c$export$16b3694ec6544c81);
    $parcel$export(module.exports, "getTimeSpentValue", ()=>$53405a2209afea8c$export$cd24e7ac392945a5);
    $parcel$export(module.exports, "convertEstimate", ()=>$53405a2209afea8c$export$bf9e57c9a45f6fd9);
    var $3nPAF;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $53405a2209afea8c$export$9446e10eb5cfa53 = (seconds)=>seconds / 3600;
    const $53405a2209afea8c$export$c6ce755da034e875 = (seconds, hoursPerDay)=>$53405a2209afea8c$export$9446e10eb5cfa53(seconds) / hoursPerDay;
    const $53405a2209afea8c$export$28d842baedf9b186 = (planningUnit, issue)=>{
        switch(planningUnit){
            case (0, $TTKUQ.PlanningUnits).storyPoints:
                return (0, $4nDwW.isDefined)(issue.storyPoints) && !(0, parcelRequire("3nPAF")).default(issue.storyPoints);
            case (0, $TTKUQ.PlanningUnits).days:
            case (0, $TTKUQ.PlanningUnits).hours:
                return (0, $4nDwW.isDefined)(issue.timeEstimate) && !(0, parcelRequire("3nPAF")).default(issue.timeEstimate);
            default:
                throw new Error(`Unexpected planningUnit: ${planningUnit}`);
        }
    };
    const $53405a2209afea8c$export$dacf8be5aae1988 = (estimate, planningUnit, workingHours)=>{
        if (estimate === null) return '';
        switch(planningUnit){
            case (0, $TTKUQ.PlanningUnits).days:
                return Math.round($53405a2209afea8c$export$c6ce755da034e875(estimate, workingHours) * 100) / 100;
            case (0, $TTKUQ.PlanningUnits).hours:
                return Math.round($53405a2209afea8c$export$9446e10eb5cfa53(estimate) * 100) / 100;
            default:
                return Math.round(estimate * 10) / 10;
        }
    };
    const $53405a2209afea8c$export$16b3694ec6544c81 = (planningUnit, issue, hoursPerDay)=>{
        switch(planningUnit){
            case (0, $TTKUQ.PlanningUnits).storyPoints:
                return issue.storyPoints ? issue.storyPoints : 0;
            case (0, $TTKUQ.PlanningUnits).days:
                return issue.timeEstimate ? $53405a2209afea8c$export$c6ce755da034e875(issue.timeEstimate, hoursPerDay) : 0;
            case (0, $TTKUQ.PlanningUnits).hours:
                return issue.timeEstimate ? $53405a2209afea8c$export$9446e10eb5cfa53(issue.timeEstimate) : 0;
            default:
                throw new Error(`Unexpected planningUnit: ${planningUnit}`);
        }
    };
    const $53405a2209afea8c$export$cd24e7ac392945a5 = (planningUnit, issue, hoursPerDay)=>{
        switch(planningUnit){
            case (0, $TTKUQ.PlanningUnits).storyPoints:
                return 0;
            case (0, $TTKUQ.PlanningUnits).days:
                return issue.timeSpent ? $53405a2209afea8c$export$c6ce755da034e875(issue.timeSpent, hoursPerDay) : 0;
            case (0, $TTKUQ.PlanningUnits).hours:
                return issue.timeSpent ? $53405a2209afea8c$export$9446e10eb5cfa53(issue.timeSpent) : 0;
            default:
                throw new Error(`Unexpected planningUnit: ${planningUnit}`);
        }
    };
    const $53405a2209afea8c$var$convertHoursToSeconds = (hours)=>hours * 3600;
    const $53405a2209afea8c$var$convertDaysToSeconds = (days, workingHours)=>days * workingHours * 3600;
    const $53405a2209afea8c$var$round = (number)=>Math.round(number * 1000) / 1000;
    const $53405a2209afea8c$var$floorSecondsToNearestMinute = (seconds)=>Math.floor(seconds / 60) * 60;
    const $53405a2209afea8c$export$bf9e57c9a45f6fd9 = (planningUnit, value, workingHours)=>{
        switch(planningUnit){
            case (0, $TTKUQ.PlanningUnits).storyPoints:
                return $53405a2209afea8c$var$round(value);
            case (0, $TTKUQ.PlanningUnits).days:
                return $53405a2209afea8c$var$floorSecondsToNearestMinute($53405a2209afea8c$var$convertDaysToSeconds(value, workingHours));
            case (0, $TTKUQ.PlanningUnits).hours:
                return $53405a2209afea8c$var$floorSecondsToNearestMinute($53405a2209afea8c$var$convertHoursToSeconds(value));
            default:
                throw new Error(`Unexpected value: ${value}`);
        }
    };
});
parcelRegister("kpLy8", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$27d46d8afcc7b10d$export$1b001418845b471c);
    $parcel$export(module.exports, "getGoalFilter", ()=>$27d46d8afcc7b10d$export$6da7d7f535a37598);
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $bZA5o = parcelRequire("bZA5o");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $cGbfF = parcelRequire("cGbfF");
    const $27d46d8afcc7b10d$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, filter.value, 'goals', optimizedMode);
    const $27d46d8afcc7b10d$export$cb2e83517b340370 = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.GOAL_FILTER_ID] || {
            id: (0, $cGbfF.GOAL_FILTER_ID),
            value: []
        };
    const $27d46d8afcc7b10d$export$6da7d7f535a37598 = (0, $3YtPS.createSelector)([
        (0, $bZA5o.getIssueGoalARIs),
        $27d46d8afcc7b10d$export$cb2e83517b340370
    ], (issueGoalARIs, pureFilter)=>{
        const { value: value = [] } = pureFilter;
        const filteredGoals = value.filter((goalARI)=>issueGoalARIs.some((issueGoalARI)=>issueGoalARI === goalARI));
        return {
            id: (0, $cGbfF.GOAL_FILTER_ID),
            value: filteredGoals
        };
    });
});
parcelRegister("bZA5o", function(module, exports) {
    $parcel$export(module.exports, "getLazyGoalsByARI", ()=>$a0c1168a185788d8$export$76ba3e359a0c56b5);
    $parcel$export(module.exports, "getGoalSearchesInProgress", ()=>$a0c1168a185788d8$export$c4ce86f508aac1be);
    $parcel$export(module.exports, "getIssueGoalARIs", ()=>$a0c1168a185788d8$export$ee7a2e4f209f098d);
    $parcel$export(module.exports, "getAllLazyGoals", ()=>$a0c1168a185788d8$export$9d0fae47092c66b1);
    $parcel$export(module.exports, "getDefinedGoals", ()=>$a0c1168a185788d8$export$3ddb67713abdba37);
    $parcel$export(module.exports, "getIsGoalsLoading", ()=>$a0c1168a185788d8$export$edb68bdb35ce9e6c);
    var $7qDUb = parcelRequire("7qDUb");
    var $3YtPS = parcelRequire("3YtPS");
    var $gFhwb = parcelRequire("gFhwb");
    const $a0c1168a185788d8$export$76ba3e359a0c56b5 = (state)=>state.domain.goals.lazyGoalsByARI;
    const $a0c1168a185788d8$export$c4ce86f508aac1be = (state)=>state.domain.goals.searchesInProgress;
    const $a0c1168a185788d8$export$8bf852117a0e9c82 = (issues, originalIssues)=>{
        const goalARIs = new Set();
        issues.forEach((issue)=>{
            if (issue.goals) issue.goals.forEach((goalARI)=>goalARIs.add(goalARI));
        });
        Object.values(originalIssues).forEach((issue)=>{
            if (issue.goals) issue.goals.forEach((goalARI)=>goalARIs.add(goalARI));
        });
        return Array.from(goalARIs);
    };
    const $a0c1168a185788d8$export$ee7a2e4f209f098d = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getAllIssues),
        (0, $gFhwb.getOriginalIssues)
    ], $a0c1168a185788d8$export$8bf852117a0e9c82);
    const $a0c1168a185788d8$var$sortLazyGoals = (goals)=>(0, ($parcel$interopDefault($7qDUb)))(goals, (goal)=>goal.goal?.name);
    const $a0c1168a185788d8$export$6881d02331c59265 = (lazyGoalsByARI)=>$a0c1168a185788d8$var$sortLazyGoals(Object.values(lazyGoalsByARI));
    const $a0c1168a185788d8$export$9d0fae47092c66b1 = (0, $3YtPS.createSelector)([
        $a0c1168a185788d8$export$76ba3e359a0c56b5
    ], $a0c1168a185788d8$export$6881d02331c59265);
    const $a0c1168a185788d8$export$97a7e74e32e749e0 = (lazyGoalsByARI)=>{
        return Object.fromEntries(Object.entries(lazyGoalsByARI).filter((entry)=>{
            const [, lazyGoal] = entry;
            return lazyGoal.goal !== undefined && !lazyGoal.isLoading;
        }).map(([goalARI, lazyGoal])=>[
                goalARI,
                lazyGoal.goal
            ]));
    };
    const $a0c1168a185788d8$export$3ddb67713abdba37 = (0, $3YtPS.createSelector)([
        $a0c1168a185788d8$export$76ba3e359a0c56b5
    ], $a0c1168a185788d8$export$97a7e74e32e749e0);
    const $a0c1168a185788d8$export$1fcd23e7ff09b7ad = (lazyGoalsByARI)=>Object.values(lazyGoalsByARI).some((lazyGoal)=>lazyGoal.isLoading);
    const $a0c1168a185788d8$export$edb68bdb35ce9e6c = (0, $3YtPS.createSelector)([
        $a0c1168a185788d8$export$76ba3e359a0c56b5
    ], $a0c1168a185788d8$export$1fcd23e7ff09b7ad);
});
parcelRegister("7bnpM", function(module, exports) {
    $parcel$export(module.exports, "getHierarchyFilter", ()=>$04b5bdd4b5a3d60f$export$e1c94a7e3ef179d9);
    $parcel$export(module.exports, "applyFilter", ()=>$04b5bdd4b5a3d60f$export$1b001418845b471c);
    var $c12LJ;
    var $cGbfF = parcelRequire("cGbfF");
    var $4nDwW = parcelRequire("4nDwW");
    var $kWDpn = parcelRequire("kWDpn");
    var $1cIjo = parcelRequire("1cIjo");
    const $04b5bdd4b5a3d60f$export$30c35db60c3f32f5 = (state)=>{
        const { value: value } = (0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.HIERARCHY_FILTER_ID] || {};
        return {
            id: (0, $cGbfF.HIERARCHY_FILTER_ID),
            value: value
        };
    };
    const $04b5bdd4b5a3d60f$export$dd998d0ed23710ab = (hierarchyFilter, hierarchyRange, isCalendarView)=>{
        const { min: min, max: max } = hierarchyRange;
        const currentValue = hierarchyFilter.value || {
            start: undefined,
            end: undefined
        };
        if (!(0, $4nDwW.isDefined)(currentValue.start)) currentValue.start = isCalendarView ? (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL) : max;
        if (!(0, $4nDwW.isDefined)(currentValue.end)) currentValue.end = isCalendarView ? (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL) : min;
        const clamp = (val, min, max)=>Math.min(Math.max(val, min), max);
        const clampedStart = clamp(currentValue.start, min, max);
        const clampedEnd = isCalendarView ? clampedStart : clamp(currentValue.end, min, clampedStart);
        const newValue = {
            start: clampedStart,
            end: clampedEnd
        };
        return {
            ...hierarchyFilter,
            value: newValue
        };
    };
    const $04b5bdd4b5a3d60f$export$e1c94a7e3ef179d9 = (0, $1cIjo.getHierarchyRangeFilter);
    const $04b5bdd4b5a3d60f$export$1b001418845b471c = (issue, filter)=>{
        const { start: start, end: end } = filter.value;
        return start >= issue.level && issue.level >= end;
    };
});
parcelRegister("cjriJ", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$e832927ae3dc07e5$export$1b001418845b471c);
    $parcel$export(module.exports, "getIdeaFilter", ()=>$e832927ae3dc07e5$export$2850cea2f4d23422);
    var $co1wz;
    var $1CGdp = parcelRequire("1CGdp");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    const $e832927ae3dc07e5$var$EMPTY_IDEA_FILTER = {
        id: (0, $cGbfF.IDEA_FILTER_ID),
        value: []
    };
    const $e832927ae3dc07e5$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, filter.value, 'associatedIssueIds', optimizedMode);
    const $e832927ae3dc07e5$export$7dc83125f0102c26 = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.IDEA_FILTER_ID] || $e832927ae3dc07e5$var$EMPTY_IDEA_FILTER;
    const $e832927ae3dc07e5$export$2850cea2f4d23422 = (0, $3YtPS.createSelector)([
        $e832927ae3dc07e5$export$7dc83125f0102c26,
        (0, $1CGdp.isEmbed),
        (0, $1CGdp.isConfluenceMacro)
    ], (pureFilter, isEmbedMode, isConfluenceMacroMode)=>{
        const isEmbedOrMacro = isEmbedMode || isConfluenceMacroMode;
        if (!(0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') || (0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') && isEmbedOrMacro) return $e832927ae3dc07e5$var$EMPTY_IDEA_FILTER;
        const { value: value = [] } = pureFilter;
        return {
            id: (0, $cGbfF.IDEA_FILTER_ID),
            value: value
        };
    });
});
parcelRegister("b8dZ0", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$bd3aaada169bf9f7$export$1b001418845b471c);
    $parcel$export(module.exports, "getIssuePrioritiesFilter", ()=>$bd3aaada169bf9f7$export$1d973cb7e23b6d1d);
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $io4Ja = parcelRequire("io4Ja");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $cGbfF = parcelRequire("cGbfF");
    const $bd3aaada169bf9f7$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, filter.value, 'priority', optimizedMode);
    const $bd3aaada169bf9f7$export$f6da05142cfdf21d = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID] || {
            id: (0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID),
            value: []
        };
    const $bd3aaada169bf9f7$export$1d973cb7e23b6d1d = (0, $3YtPS.createSelector)([
        (0, $io4Ja.getIssuePriorities),
        $bd3aaada169bf9f7$export$f6da05142cfdf21d
    ], (issuePriorities, filter)=>{
        const { value: value = [] } = filter;
        const filteredIssuePriorities = value.filter((issuePriorityId)=>Object.values(issuePriorities).some(({ id: id })=>id === issuePriorityId));
        return {
            id: (0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID),
            value: filteredIssuePriorities
        };
    });
});
parcelRegister("io4Ja", function(module, exports) {
    $parcel$export(module.exports, "getIssuePriorities", ()=>$02b298a6da08cc2b$export$98d3203068a2d313);
    $parcel$export(module.exports, "getIssuePrioritiesById", ()=>$02b298a6da08cc2b$export$44140bf6dfd56211);
    $parcel$export(module.exports, "getIssuePrioritiesIdList", ()=>$02b298a6da08cc2b$export$30b64fafed1a8d33);
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    const $02b298a6da08cc2b$export$98d3203068a2d313 = (state)=>state.domain.issuePriorities;
    const $02b298a6da08cc2b$export$44140bf6dfd56211 = (0, $3YtPS.createSelector)([
        $02b298a6da08cc2b$export$98d3203068a2d313
    ], (issuePriorities)=>(0, $4nDwW.indexBy)(({ id: id })=>id, Object.values(issuePriorities)));
    const $02b298a6da08cc2b$export$30b64fafed1a8d33 = (0, $3YtPS.createSelector)([
        $02b298a6da08cc2b$export$98d3203068a2d313
    ], (issuePriorities)=>{
        const issuePrioritiesIdList = Object.values(issuePriorities).sort((a, b)=>a.sequence - b.sequence).map(({ id: id })=>id);
        return issuePrioritiesIdList.length ? issuePrioritiesIdList : null;
    });
});
parcelRegister("hHRm5", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$f01f49c4f56516a7$export$1b001418845b471c);
    $parcel$export(module.exports, "getIssueTypeKeyFilterValue", ()=>$f01f49c4f56516a7$export$68fbb55423a6c5a4);
    $parcel$export(module.exports, "getIssueTypeKeyFilter", ()=>$f01f49c4f56516a7$export$16acaef7acc9fa68);
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $5oBf2 = parcelRequire("5oBf2");
    const $f01f49c4f56516a7$export$1b001418845b471c = (issue, { value: value }, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, value, 'type', optimizedMode);
    const $f01f49c4f56516a7$var$getNewIssueTypeFilterValues = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getFiltersViewSettings)
    ], ({ [(0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID)]: filter })=>filter?.value ?? []);
    const $f01f49c4f56516a7$var$getOldIssueTypeFilterValues = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getFiltersViewSettings)
    ], ({ [(0, $cGbfF.ISSUE_TYPES_FILTER_ID)]: filter })=>filter?.value ?? []);
    const $f01f49c4f56516a7$export$68fbb55423a6c5a4 = (0, $3YtPS.createSelector)([
        $f01f49c4f56516a7$var$getOldIssueTypeFilterValues,
        $f01f49c4f56516a7$var$getNewIssueTypeFilterValues,
        (0, $6Ayrn.getIssueTypeWithLevelById)
    ], (0, $5oBf2.getIssueTypeKeyValuesPure));
    const $f01f49c4f56516a7$export$16acaef7acc9fa68 = (0, $3YtPS.createSelector)([
        $f01f49c4f56516a7$export$68fbb55423a6c5a4,
        (0, $6Ayrn.getIssueTypesByLevel)
    ], (0, $5oBf2.getIssueTypeKeyFilterPure));
});
parcelRegister("5oBf2", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypeKeyValuesPure", ()=>$621b14cc0aa7aa3f$export$977ae805a1ff1ddc);
    $parcel$export(module.exports, "getIssueTypeKeyFilterPure", ()=>$621b14cc0aa7aa3f$export$b34f9f337ddcb9e9);
    var $cGbfF = parcelRequire("cGbfF");
    const $621b14cc0aa7aa3f$var$issueTypeIdsToIssueTypeKeys = (issueTypeIds, issueTypesById)=>{
        const issueTypeNamesByLevel = issueTypeIds.reduce((acc, id)=>{
            const issueType = issueTypesById[id];
            if (issueType !== undefined) {
                const names = acc[issueType.level];
                if (names !== undefined) names.add(issueType.name);
                else {
                    const newNames = new Set();
                    newNames.add(issueType.name);
                    acc[issueType.level] = newNames;
                }
            }
            return acc;
        }, {});
        return Object.entries(issueTypeNamesByLevel).reduce((acc, [level, names])=>{
            names.forEach((name)=>acc.push({
                    level: Number(level),
                    name: name
                }));
            return acc;
        }, []);
    };
    const $621b14cc0aa7aa3f$var$issueTypeKeysToIssueTypeIds = (issueTypeKeys, issueTypesByHierarchy)=>issueTypeKeys.reduce((acc, { level: level, name: keyName })=>{
            const issueTypesMatchingLevelAndName = (issueTypesByHierarchy[level] ?? []).filter(({ name: name })=>name === keyName);
            return acc.concat(issueTypesMatchingLevelAndName.map(({ id: id })=>id));
        }, []);
    const $621b14cc0aa7aa3f$export$977ae805a1ff1ddc = (oldIssueTypeFilterValue, newIssueTypeKeyFilterValue, issueTypesById)=>{
        if (newIssueTypeKeyFilterValue.length > 0) return newIssueTypeKeyFilterValue;
        return $621b14cc0aa7aa3f$var$issueTypeIdsToIssueTypeKeys(oldIssueTypeFilterValue, issueTypesById);
    };
    const $621b14cc0aa7aa3f$export$b34f9f337ddcb9e9 = (issueTypeKeyValue, issueTypesByHierarchy)=>({
            id: (0, $cGbfF.ISSUE_TYPES_FILTER_ID),
            value: $621b14cc0aa7aa3f$var$issueTypeKeysToIssueTypeIds(issueTypeKeyValue, issueTypesByHierarchy)
        });
});
parcelRegister("aKeKY", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$bbddc48ea74fd5a6$export$1b001418845b471c);
    $parcel$export(module.exports, "getIssueWarningFilter", ()=>$bbddc48ea74fd5a6$export$dc6e663d6e389fd9);
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $kWDpn = parcelRequire("kWDpn");
    var $eIyFU = parcelRequire("eIyFU");
    var $5FmOW = parcelRequire("5FmOW");
    const $bbddc48ea74fd5a6$export$1b001418845b471c = (issue, { value: value, issueIdsWithWarnings: issueIdsWithWarnings })=>{
        if (value.length === 0) return true;
        if (!issueIdsWithWarnings.length) return false;
        return (0, $5FmOW.applyFilter)(issue, issueIdsWithWarnings, 'id');
    };
    const $bbddc48ea74fd5a6$export$8911a9f6301ebc3d = (filterSate)=>filterSate[0, $cGbfF.ISSUE_WARNING_FILTER_ID]?.value ?? [];
    const $bbddc48ea74fd5a6$var$getIssueWarningFilterValue = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getFiltersViewSettings)
    ], $bbddc48ea74fd5a6$export$8911a9f6301ebc3d);
    const $bbddc48ea74fd5a6$export$3221b5007fc3ddc8 = (warningIssueHash, value)=>{
        const issueIdsWithWarnings = [];
        const filteredWarnings = new Set(value);
        for (const [issueId, warnings] of Object.entries(warningIssueHash))if (warnings.some((warning)=>filteredWarnings.has(warning.type))) issueIdsWithWarnings.push(issueId);
        return {
            id: (0, $cGbfF.ISSUE_WARNING_FILTER_ID),
            value: value,
            issueIdsWithWarnings: issueIdsWithWarnings
        };
    };
    const $bbddc48ea74fd5a6$export$dc6e663d6e389fd9 = (0, $3YtPS.createSelector)([
        (0, $eIyFU.getAllWarningsIssueHash),
        $bbddc48ea74fd5a6$var$getIssueWarningFilterValue
    ], $bbddc48ea74fd5a6$export$3221b5007fc3ddc8);
});
parcelRegister("eIyFU", function(module, exports) {
    $parcel$export(module.exports, "getWarnings", ()=>$409034ac39da1fe0$export$86d329c847012ae2);
    $parcel$export(module.exports, "getAllWarningsIssueHash", ()=>$409034ac39da1fe0$export$b57778db38fddaef);
    $parcel$export(module.exports, "getAggregatedWarnings", ()=>$409034ac39da1fe0$export$eb155605f8c3215b);
    $parcel$export(module.exports, "getDisabledWarnings", ()=>$409034ac39da1fe0$export$7f31179b1c3042fc);
    var $3YtPS = parcelRequire("3YtPS");
    var $kWDpn = parcelRequire("kWDpn");
    const $409034ac39da1fe0$export$86d329c847012ae2 = (state)=>state.domain.warnings;
    const $409034ac39da1fe0$export$b57778db38fddaef = (state)=>state.domain.warnings.allWarningsByIssue ?? {};
    const $409034ac39da1fe0$export$b2df6730bf20ee08 = (warnings)=>{
        const byType = {};
        for (const [issueId, value] of Object.entries(warnings.byIssue)){
            const warnings = value;
            for (const warning of warnings){
                const type = warning.type;
                if (!byType[type]) byType[type] = [];
                byType[type].push(issueId);
            }
        }
        return byType;
    };
    const $409034ac39da1fe0$export$eb155605f8c3215b = (0, $3YtPS.createSelector)([
        $409034ac39da1fe0$export$86d329c847012ae2
    ], $409034ac39da1fe0$export$b2df6730bf20ee08);
    const $409034ac39da1fe0$export$7f31179b1c3042fc = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getWarningViewSettings)
    ], (warningViewSettings)=>warningViewSettings.disabledWarnings);
});
parcelRegister("kHGzZ", function(module, exports) {
    $parcel$export(module.exports, "NO_LABEL_ID", ()=>$efcf15bdb36a6ea4$export$a8155a8d6b3722d6);
    $parcel$export(module.exports, "applyFilter", ()=>$efcf15bdb36a6ea4$export$1b001418845b471c);
    $parcel$export(module.exports, "getLabelFilter", ()=>$efcf15bdb36a6ea4$export$7947209750252631);
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $abnJk = parcelRequire("abnJk");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $cGbfF = parcelRequire("cGbfF");
    const $efcf15bdb36a6ea4$export$a8155a8d6b3722d6 = (0, $TTKUQ.UNDEFINED_KEY);
    const $efcf15bdb36a6ea4$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, filter.value, 'labels', optimizedMode);
    const $efcf15bdb36a6ea4$export$367a351aa5ad067f = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.LABEL_FILTER_ID] || {
            id: (0, $cGbfF.LABEL_FILTER_ID),
            value: []
        };
    const $efcf15bdb36a6ea4$export$7947209750252631 = (0, $3YtPS.createSelector)([
        (0, $abnJk.getIssueLabels),
        $efcf15bdb36a6ea4$export$367a351aa5ad067f
    ], (issueLabels, pureFilter)=>{
        const { value: value = [] } = pureFilter;
        const existingLabels = value.filter((label)=>issueLabels.some((issueLabel)=>issueLabel === label) || label === $efcf15bdb36a6ea4$export$a8155a8d6b3722d6);
        return {
            id: (0, $cGbfF.LABEL_FILTER_ID),
            value: existingLabels
        };
    });
});
parcelRegister("abnJk", function(module, exports) {
    $parcel$export(module.exports, "getIssueLabels", ()=>$21a48c22f050f620$export$424a50dfd4d5b981);
    const $21a48c22f050f620$export$424a50dfd4d5b981 = (state)=>state.domain.issueLabels;
});
parcelRegister("1LpPL", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$ed35ac8497e51560$export$1b001418845b471c);
    $parcel$export(module.exports, "getProjectFilter", ()=>$ed35ac8497e51560$export$4939fc722e810d76);
    $parcel$export(module.exports, "getFilteredProjects", ()=>$ed35ac8497e51560$export$dd7c4fe962efad41);
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $jpXKt = parcelRequire("jpXKt");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $cGbfF = parcelRequire("cGbfF");
    const $ed35ac8497e51560$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, filter.value, 'project', optimizedMode);
    const $ed35ac8497e51560$export$5d95a6a4ccb5cadb = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.PROJECT_FILTER_ID] || {
            id: (0, $cGbfF.PROJECT_FILTER_ID),
            value: []
        };
    const $ed35ac8497e51560$export$4939fc722e810d76 = (0, $3YtPS.createSelector)([
        (0, $jpXKt.getProjects),
        $ed35ac8497e51560$export$5d95a6a4ccb5cadb
    ], (projects, pureFilter)=>{
        const { value: value = [] } = pureFilter;
        const filteredProjects = value.filter((projectId)=>projects.some(({ id: id })=>id === projectId));
        return {
            id: (0, $cGbfF.PROJECT_FILTER_ID),
            value: filteredProjects
        };
    });
    const $ed35ac8497e51560$export$48773ecb6624dbb4 = (projects, { value: value })=>projects.filter(({ id: id })=>value.length === 0 || value.includes(id));
    const $ed35ac8497e51560$export$dd7c4fe962efad41 = (0, $3YtPS.createSelector)([
        (0, $jpXKt.getProjects),
        $ed35ac8497e51560$export$4939fc722e810d76
    ], $ed35ac8497e51560$export$48773ecb6624dbb4);
});
parcelRegister("lz7VR", function(module, exports) {
    $parcel$export(module.exports, "NO_RELEASE_ID", ()=>$2b4319aea9332099$export$94e199d2d0bac60a);
    $parcel$export(module.exports, "applyFilter", ()=>$2b4319aea9332099$export$1b001418845b471c);
    $parcel$export(module.exports, "getReleaseFilterPure", ()=>$2b4319aea9332099$export$1cc314758e6c1f41);
    $parcel$export(module.exports, "getReleaseFilter", ()=>$2b4319aea9332099$export$6c10eb7bc4b783e);
    var $cGbfF = parcelRequire("cGbfF");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $9FFuD = parcelRequire("9FFuD");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $1dvM4 = parcelRequire("1dvM4");
    var $cGbfF = parcelRequire("cGbfF");
    const $2b4319aea9332099$export$94e199d2d0bac60a = (0, $TTKUQ.UNDEFINED_KEY);
    const $2b4319aea9332099$export$852eff6db828121c = 'EMPTY_CPR_ID';
    const $2b4319aea9332099$export$1b001418845b471c = (issue, filter, optimizedMode)=>{
        const { value: value, versionsFromCrossProjectReleaseFilterValue: versionsFromCrossProjectReleaseFilterValue } = filter;
        const filterValue = (0, $4nDwW.isDefined)(versionsFromCrossProjectReleaseFilterValue) ? [
            ...value,
            ...versionsFromCrossProjectReleaseFilterValue
        ] : value;
        return (0, $5FmOW.applyFilter)(issue, filterValue, 'fixVersions', optimizedMode);
    };
    const $2b4319aea9332099$export$1cc314758e6c1f41 = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.RELEASE_FILTER_ID] || {
            id: (0, $cGbfF.RELEASE_FILTER_ID),
            value: []
        };
    const $2b4319aea9332099$export$6c10eb7bc4b783e = (0, $3YtPS.createSelector)([
        (0, $9FFuD.getVersions),
        (0, $1dvM4.getCrossProjectReleaseFilter),
        $2b4319aea9332099$export$1cc314758e6c1f41
    ], (versions, crossProjectReleaseFilter, pureFilter)=>{
        const { value: value = [] } = pureFilter;
        const filteredVersions = value.filter((versionId)=>versions.some(({ id: id })=>id === versionId) || versionId === $2b4319aea9332099$export$94e199d2d0bac60a);
        const { crossProjectVersionsById: crossProjectVersionsById = {}, value: crossProjectReleaseFilterValue = [] } = crossProjectReleaseFilter;
        const versionsFromCrossProjectReleaseFilterValue = crossProjectReleaseFilterValue.reduce((acc, cprId)=>{
            const crossProjectVersion = crossProjectVersionsById[cprId];
            if (crossProjectVersion) acc.push(...crossProjectVersion.versions);
            return acc;
        }, []);
        if (crossProjectReleaseFilterValue.length !== 0 && versionsFromCrossProjectReleaseFilterValue.length === 0) versionsFromCrossProjectReleaseFilterValue.push($2b4319aea9332099$export$852eff6db828121c);
        return {
            id: (0, $cGbfF.RELEASE_FILTER_ID),
            value: filteredVersions,
            versionsFromCrossProjectReleaseFilterValue: versionsFromCrossProjectReleaseFilterValue
        };
    });
});
parcelRegister("hHrJz", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$82b90bef08b5ad6c$export$1b001418845b471c);
    $parcel$export(module.exports, "getReporterForFilter", ()=>$82b90bef08b5ad6c$export$c7d736d901652cb8);
    $parcel$export(module.exports, "getReporterFilter", ()=>$82b90bef08b5ad6c$export$88d268cefa9b9990);
    var $4Rr1a;
    var $2rMKg;
    var $f5OZ1;
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $bzDof = parcelRequire("bzDof");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $cGbfF = parcelRequire("cGbfF");
    const $82b90bef08b5ad6c$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, filter.value, 'reporter', optimizedMode);
    const $82b90bef08b5ad6c$export$c7d736d901652cb8 = (0, $3YtPS.createSelector)([
        (0, $bzDof.getUniqueReportersOfIssues)
    ], (issuesReporters)=>(0, parcelRequire("f5OZ1")).default((0, parcelRequire("2rMKg")).default('personId'))([
            ...issuesReporters
        ]));
    const $82b90bef08b5ad6c$export$c2ef75efa427967 = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.REPORTER_FILTER_ID] || {
            id: (0, $cGbfF.REPORTER_FILTER_ID),
            value: []
        };
    const $82b90bef08b5ad6c$export$88d268cefa9b9990 = (0, $3YtPS.createSelector)([
        $82b90bef08b5ad6c$export$c7d736d901652cb8,
        $82b90bef08b5ad6c$export$c2ef75efa427967
    ], (reporters, { id: id, value: value = [] })=>{
        const reporterSet = new Set((0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('personId'), reporters));
        return {
            id: id,
            value: value.filter((personId)=>reporterSet.has(personId))
        };
    });
});
parcelRegister("bzDof", function(module, exports) {
    $parcel$export(module.exports, "getIssueReporterMap", ()=>$5158a0bb9324681e$export$42587cd54d399808);
    $parcel$export(module.exports, "getUniqueReportersOfIssues", ()=>$5158a0bb9324681e$export$13c1420a9d57662e);
    $parcel$export(module.exports, "getReportersById", ()=>$5158a0bb9324681e$export$9771ac378c0c93c6);
    var $2rMKg;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $gFhwb = parcelRequire("gFhwb");
    const $5158a0bb9324681e$export$42587cd54d399808 = (state)=>state.domain.reporters.issueReporterMap;
    const $5158a0bb9324681e$export$6cade5530a24c0d4 = (issues, reporterMapByIssueId)=>{
        const reporters = new Set();
        issues.forEach((issue)=>{
            const reporterPerson = reporterMapByIssueId[issue.id];
            if (reporterPerson) reporters.add(reporterPerson);
        });
        return Array.from(reporters);
    };
    const $5158a0bb9324681e$export$13c1420a9d57662e = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssues),
        $5158a0bb9324681e$export$42587cd54d399808
    ], $5158a0bb9324681e$export$6cade5530a24c0d4);
    const $5158a0bb9324681e$export$9771ac378c0c93c6 = (0, $3YtPS.createSelector)([
        $5158a0bb9324681e$export$13c1420a9d57662e
    ], (reporter)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('personId'), reporter));
});
parcelRegister("eqNmi", function(module, exports) {
    $parcel$export(module.exports, "NO_SPRINT_ID", ()=>$53dce850bb860fee$export$43e4bd26116c3832);
    $parcel$export(module.exports, "applyFilter", ()=>$53dce850bb860fee$export$1b001418845b471c);
    $parcel$export(module.exports, "getSprintFilter", ()=>$53dce850bb860fee$export$d63c00efb8ec5b93);
    var $cGbfF = parcelRequire("cGbfF");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ljmcc = parcelRequire("ljmcc");
    var $kWDpn = parcelRequire("kWDpn");
    var $cGbfF = parcelRequire("cGbfF");
    const $53dce850bb860fee$export$43e4bd26116c3832 = (0, $TTKUQ.UNDEFINED_KEY);
    const $53dce850bb860fee$export$1b001418845b471c = (issue, { value: value })=>{
        if (value.length === 0) return true;
        const filterSprints = new Set(value);
        const issueSprints = [
            ...issue.completedSprints || [],
            issue.sprint
        ].filter((0, $4nDwW.isDefined));
        if (filterSprints.has($53dce850bb860fee$export$43e4bd26116c3832) && issueSprints.length === 0) return true;
        filterSprints.delete($53dce850bb860fee$export$43e4bd26116c3832);
        return issueSprints.some((id)=>filterSprints.has(id));
    };
    const $53dce850bb860fee$export$10eeae1e8c2ca5bc = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.SPRINT_FILTER_ID] || {
            id: (0, $cGbfF.SPRINT_FILTER_ID),
            value: []
        };
    const $53dce850bb860fee$export$d63c00efb8ec5b93 = (0, $3YtPS.createSelector)([
        (0, $ljmcc.getSprints),
        (0, $ljmcc.getExternalSprints),
        $53dce850bb860fee$export$10eeae1e8c2ca5bc
    ], (sprints, externalSprints, { value: value = [] })=>{
        const sprintsInPlan = new Set([
            ...sprints,
            ...externalSprints
        ].map((x)=>x.id));
        const existingSprints = value.filter((sprintId)=>sprintsInPlan.has(sprintId) || sprintId === $53dce850bb860fee$export$43e4bd26116c3832);
        return {
            id: (0, $cGbfF.SPRINT_FILTER_ID),
            value: existingSprints
        };
    });
});
parcelRegister("48ZJQ", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$c64f441596f9c6ee$export$1b001418845b471c);
    $parcel$export(module.exports, "getStatusKeyFilterValue", ()=>$c64f441596f9c6ee$export$e16c6fcb26f91d3e);
    $parcel$export(module.exports, "getStatusKeyFilterOptionsByCategory", ()=>$c64f441596f9c6ee$export$a29aeec6e1389748);
    $parcel$export(module.exports, "getAllStatusKeyOfCategoryChecked", ()=>$c64f441596f9c6ee$export$d25277796925c242);
    $parcel$export(module.exports, "getStatusKeyFilter", ()=>$c64f441596f9c6ee$export$472e823661b0066e);
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $g91SX = parcelRequire("g91SX");
    var $7ppNi = parcelRequire("7ppNi");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $lQB2Q = parcelRequire("lQB2Q");
    var $cGbfF = parcelRequire("cGbfF");
    var $lQB2Q = parcelRequire("lQB2Q");
    const $c64f441596f9c6ee$export$1b001418845b471c = (issue, { value: value }, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, value, 'status', optimizedMode);
    const $c64f441596f9c6ee$var$getOldStatusFilterValue = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getFiltersViewSettings)
    ], (filters)=>{
        const statusFilters = filters[0, $cGbfF.STATUS_FILTER_ID];
        return statusFilters?.value ?? [];
    });
    const $c64f441596f9c6ee$var$getNewStatusKeyFilterValue = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getFiltersViewSettings)
    ], (filters)=>{
        const statusKeyFilters = filters[0, $cGbfF.STATUS_KEY_FILTER_ID];
        return statusKeyFilters?.value ?? [];
    });
    const $c64f441596f9c6ee$export$e16c6fcb26f91d3e = (0, $3YtPS.createSelector)([
        (0, $7ppNi.getIssueStatusById),
        $c64f441596f9c6ee$var$getOldStatusFilterValue,
        $c64f441596f9c6ee$var$getNewStatusKeyFilterValue
    ], (0, $lQB2Q.getStatusKeyFilterValuePure));
    const $c64f441596f9c6ee$export$a29aeec6e1389748 = (0, $3YtPS.createSelector)([
        (0, $7ppNi.getIssueStatuses),
        (0, $g91SX.getCategoryNameById)
    ], (0, $lQB2Q.getStatusKeyFilterOptionsByCategoryPure));
    const $c64f441596f9c6ee$export$d25277796925c242 = (0, $3YtPS.createSelector)([
        $c64f441596f9c6ee$export$e16c6fcb26f91d3e,
        $c64f441596f9c6ee$export$a29aeec6e1389748,
        (0, $g91SX.getCategoryNameById)
    ], (0, $lQB2Q.getIsAllStatusKeyOfCategorySelectedPure));
    const $c64f441596f9c6ee$export$472e823661b0066e = (0, $3YtPS.createSelector)([
        (0, $7ppNi.getIssueStatusById),
        (0, $7ppNi.getIssueStatusByKey),
        $c64f441596f9c6ee$var$getOldStatusFilterValue,
        $c64f441596f9c6ee$var$getNewStatusKeyFilterValue
    ], (0, $lQB2Q.getStatusKeyFilterPure));
});
parcelRegister("g91SX", function(module, exports) {
    $parcel$export(module.exports, "getStatusCategoryById", ()=>$d7af285c2d969676$export$27be3f1f634c6db8);
    $parcel$export(module.exports, "getCategoryNameById", ()=>$d7af285c2d969676$export$90d9bee9a9c242be);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $2rMKg;
    var $4nDwW = parcelRequire("4nDwW");
    const $d7af285c2d969676$export$29350702a509e1b9 = (state)=>state.domain.issueStatusCategories;
    const $d7af285c2d969676$export$27be3f1f634c6db8 = (state)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), state.domain.issueStatusCategories);
    const $d7af285c2d969676$export$90d9bee9a9c242be = (0, $dGvGJ.createSelector)([
        $d7af285c2d969676$export$29350702a509e1b9
    ], (statusCategories)=>new Map(statusCategories.map(({ id: id, name: name })=>[
                `${id}`,
                name
            ])));
});
parcelRegister("lQB2Q", function(module, exports) {
    $parcel$export(module.exports, "getStatusKeyFilterValuePure", ()=>$34b0b65cfa10ade8$export$21d86fd023fcea16);
    $parcel$export(module.exports, "UNSAVED_STATUS", ()=>$34b0b65cfa10ade8$export$6ffc1063451c988d);
    $parcel$export(module.exports, "getStatusKeyFilterOptionsByCategoryPure", ()=>$34b0b65cfa10ade8$export$976ea5918c04a147);
    $parcel$export(module.exports, "getIsAllStatusKeyOfCategorySelectedPure", ()=>$34b0b65cfa10ade8$export$3c1dd3a395fc993a);
    $parcel$export(module.exports, "getStatusKeyFilterPure", ()=>$34b0b65cfa10ade8$export$5fc99df4db8f9996);
    var $fn8B5 = parcelRequire("fn8B5");
    var $ajpes = parcelRequire("ajpes");
    var $kGsr8 = parcelRequire("kGsr8");
    var $vNXgH = parcelRequire("vNXgH");
    var $cGbfF = parcelRequire("cGbfF");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cGbfF = parcelRequire("cGbfF");
    const $34b0b65cfa10ade8$var$statusIdToStatusKey = (issueStatusById, statusIds)=>{
        const statusKeys = statusIds.reduce((acc, statusId)=>{
            const status = issueStatusById[statusId];
            if (status !== undefined) acc.push({
                category: `${status.categoryId}`,
                name: status.name
            });
            return acc;
        }, []);
        return (0, ($parcel$interopDefault($vNXgH)))(statusKeys, (0, ($parcel$interopDefault($ajpes))));
    };
    const $34b0b65cfa10ade8$export$21d86fd023fcea16 = (issueStatusById, oldStatusFilterValue, newStatusKeyFilterValue)=>{
        if (newStatusKeyFilterValue.length > 0) return newStatusKeyFilterValue;
        return $34b0b65cfa10ade8$var$statusIdToStatusKey(issueStatusById, oldStatusFilterValue);
    };
    const $34b0b65cfa10ade8$export$6ffc1063451c988d = {
        id: (0, $TTKUQ.UNDEFINED_KEY),
        categoryId: 2,
        name: 'UNSAVED'
    };
    const $34b0b65cfa10ade8$export$976ea5918c04a147 = (statuses, categoryNameById)=>{
        const statusByCategory = (0, ($parcel$interopDefault($fn8B5)))(statuses, ({ categoryId: categoryId })=>`${categoryId}`);
        const result = new Map();
        for (const categoryId of categoryNameById.keys()){
            const statusNames = (statusByCategory[categoryId] ?? []).map(({ name: name })=>name);
            if (categoryId === `${$34b0b65cfa10ade8$export$6ffc1063451c988d.categoryId}`) statusNames.push($34b0b65cfa10ade8$export$6ffc1063451c988d.name);
            if (statusNames.length > 0) result.set(categoryId, (0, ($parcel$interopDefault($kGsr8)))(statusNames));
        }
        return result;
    };
    const $34b0b65cfa10ade8$export$3c1dd3a395fc993a = (selectedStatusKeys, statusNamesByCategory, categoryNameById)=>{
        const result = {};
        for (const categoryId of categoryNameById.keys()){
            const allStatusNamesOfCategory = statusNamesByCategory.get(categoryId) ?? [];
            const selectedStatusNamesOfCategory = allStatusNamesOfCategory.filter((statusName)=>selectedStatusKeys.find(({ category: category, name: name })=>category === categoryId && name === statusName) !== undefined);
            if (allStatusNamesOfCategory.length === 0 || selectedStatusNamesOfCategory.length === 0) result[categoryId] = (0, $TTKUQ.CHECKBOX_STATES).UNCHECKED;
            else if (allStatusNamesOfCategory.length === selectedStatusNamesOfCategory.length) result[categoryId] = (0, $TTKUQ.CHECKBOX_STATES).CHECKED;
            else result[categoryId] = (0, $TTKUQ.CHECKBOX_STATES).INDETERMINATE;
        }
        return result;
    };
    const $34b0b65cfa10ade8$var$statusIdFromStatusKey = (issueStatusByKey, statusKeys)=>statusKeys.map(({ category: category, name: name })=>issueStatusByKey[`${category} ${name}`]?.map(({ id: id })=>id) ?? []).flat();
    const $34b0b65cfa10ade8$export$5fc99df4db8f9996 = (issueStatusById, issueStatusByKey, oldStatusFilterValue, newStatusKeyFilterValue)=>{
        if (newStatusKeyFilterValue.length > 0) {
            const containsUnsavedStatus = newStatusKeyFilterValue.some(({ category: category, name: name })=>category === `${$34b0b65cfa10ade8$export$6ffc1063451c988d.categoryId}` && name === $34b0b65cfa10ade8$export$6ffc1063451c988d.name);
            return {
                id: (0, $cGbfF.STATUS_FILTER_ID),
                value: (containsUnsavedStatus ? [
                    $34b0b65cfa10ade8$export$6ffc1063451c988d.id
                ] : []).concat($34b0b65cfa10ade8$var$statusIdFromStatusKey(issueStatusByKey, newStatusKeyFilterValue))
            };
        }
        const containsUnsavedStatus = oldStatusFilterValue.some((id)=>id === $34b0b65cfa10ade8$export$6ffc1063451c988d.id);
        return {
            id: (0, $cGbfF.STATUS_FILTER_ID),
            value: (containsUnsavedStatus ? [
                $34b0b65cfa10ade8$export$6ffc1063451c988d.id
            ] : []).concat($34b0b65cfa10ade8$var$statusIdFromStatusKey(issueStatusByKey, $34b0b65cfa10ade8$var$statusIdToStatusKey(issueStatusById, oldStatusFilterValue)))
        };
    };
});
parcelRegister("vNXgH", function(module, exports) {
    var $7CoLY = parcelRequire("7CoLY");
    function $05f9a56040cc5a05$var$uniqWith(array, comparator) {
        comparator = typeof comparator == 'function' ? comparator : undefined;
        return array && array.length ? $7CoLY(array, undefined, comparator) : [];
    }
    module.exports = $05f9a56040cc5a05$var$uniqWith;
});
parcelRegister("jrYap", function(module, exports) {
    $parcel$export(module.exports, "applyFilter", ()=>$ca2f00cd3a3ca18a$export$1b001418845b471c);
    $parcel$export(module.exports, "getSummaryFilter", ()=>$ca2f00cd3a3ca18a$export$3e1a3421edad933);
    var $cGbfF = parcelRequire("cGbfF");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $jpXKt = parcelRequire("jpXKt");
    var $kWDpn = parcelRequire("kWDpn");
    var $cGbfF = parcelRequire("cGbfF");
    const $ca2f00cd3a3ca18a$export$1b001418845b471c = (issue, filter)=>{
        const { queries: queries, projectsById: projectsById = {} } = filter;
        const { summary: summary = '', issueKey: issueKey = '', project: project } = issue;
        if (queries.length === 0) return true;
        let title = `${issueKey} ${summary}`;
        if ((0, $4nDwW.isDefined)(project)) {
            const projectDetails = projectsById[project];
            if ((0, $4nDwW.isDefined)(projectDetails)) {
                const projectKey = projectDetails.key;
                title = `${projectKey}-${issueKey} ${summary}`;
            }
        }
        title = title.toLowerCase();
        return queries.some((term)=>title.includes(term));
    };
    const $ca2f00cd3a3ca18a$export$1886090eaf2edb60 = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.SUMMARY_FILTER_ID] || {
            id: (0, $cGbfF.SUMMARY_FILTER_ID),
            value: ''
        };
    const $ca2f00cd3a3ca18a$export$b7b2a481b84622e6 = (query)=>(query.match(/[^,;]+/g) || []).map((x)=>x.trim().toLowerCase()).filter((x)=>x.length > 0);
    const $ca2f00cd3a3ca18a$export$3e1a3421edad933 = (0, $3YtPS.createSelector)([
        $ca2f00cd3a3ca18a$export$1886090eaf2edb60,
        (0, $jpXKt.getProjectsById)
    ], ({ value: value = '' }, projectsById)=>({
            id: (0, $cGbfF.SUMMARY_FILTER_ID),
            value: value,
            queries: $ca2f00cd3a3ca18a$export$b7b2a481b84622e6(value),
            projectsById: projectsById
        }));
});
parcelRegister("l3m9K", function(module, exports) {
    $parcel$export(module.exports, "NO_TEAM_ID", ()=>$c685b575e4601c42$export$53782b65600ab96d);
    $parcel$export(module.exports, "applyFilter", ()=>$c685b575e4601c42$export$1b001418845b471c);
    $parcel$export(module.exports, "getTeamsFilterPure", ()=>$c685b575e4601c42$export$b64e4243796e514a);
    $parcel$export(module.exports, "getTeamFilter", ()=>$c685b575e4601c42$export$5f62ef45898119c1);
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $dRVQG = parcelRequire("dRVQG");
    var $kWDpn = parcelRequire("kWDpn");
    var $5FmOW = parcelRequire("5FmOW");
    var $cGbfF = parcelRequire("cGbfF");
    const $c685b575e4601c42$export$53782b65600ab96d = (0, $TTKUQ.UNDEFINED_KEY);
    const $c685b575e4601c42$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $5FmOW.applyFilter)(issue, filter.value, 'team', optimizedMode);
    const $c685b575e4601c42$export$b64e4243796e514a = (state)=>(0, $kWDpn.getFiltersViewSettings)(state)[0, $cGbfF.TEAM_FILTER_ID] || {
            id: (0, $cGbfF.TEAM_FILTER_ID),
            value: []
        };
    const $c685b575e4601c42$export$5f62ef45898119c1 = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getTeams),
        $c685b575e4601c42$export$b64e4243796e514a
    ], (teams, pureFilter)=>{
        const { value: value = [] } = pureFilter;
        const filteredTeams = value.filter((teamId)=>teams.some(({ id: id })=>id === teamId) || teamId === $c685b575e4601c42$export$53782b65600ab96d);
        return {
            id: (0, $cGbfF.TEAM_FILTER_ID),
            value: filteredTeams
        };
    });
});
parcelRegister("4sJY8", function(module, exports) {
    $parcel$export(module.exports, "getChildrenByParentPure", ()=>$f15dfef495212845$export$cfcbda58efe6fed9);
    $parcel$export(module.exports, "getChildrenByParent", ()=>$f15dfef495212845$export$65544d51bd5cdae8);
    $parcel$export(module.exports, "getChildrenIdsByParent", ()=>$f15dfef495212845$export$da55948f2286493c);
    $parcel$export(module.exports, "getDescendants", ()=>$f15dfef495212845$export$d607bcb6675e3e03);
    $parcel$export(module.exports, "getDescendantsByParent", ()=>$f15dfef495212845$export$3a123be6fa1e1089);
    $parcel$export(module.exports, "getRollupMap", ()=>$f15dfef495212845$export$61e0876ed41cdcfd);
    var $jVZZA;
    var $4wiYB;
    var $2JlG5;
    var $lV634;
    var $4Rr1a;
    var $bQZTk;
    var $2rMKg;
    var $c12LJ;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $bHTqr = parcelRequire("bHTqr");
    var $kWDpn = parcelRequire("kWDpn");
    var $gFhwb = parcelRequire("gFhwb");
    const $f15dfef495212845$export$1b6ef61469955f33 = (sprints, descendant)=>{
        if (!(0, $4nDwW.isDefined)(descendant.sprint) && descendant.completedSprints && descendant.completedSprints.length === 0 || descendant.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)) return sprints;
        if (!(0, $4nDwW.isDefined)(descendant.sprint)) return [
            ...sprints || [],
            ...descendant.completedSprints || []
        ];
        return [
            ...sprints || [],
            descendant.sprint,
            ...descendant.completedSprints || []
        ];
    };
    const $f15dfef495212845$export$ad7f62d8b8ed8f29 = (issues, descendantsMap, planningUnit, showRolledUpOthers)=>{
        const estimateAttribute = planningUnit === 'StoryPoints' ? 'storyPoints' : 'timeEstimate';
        const rollupMap = {};
        if (!showRolledUpOthers) return rollupMap;
        const getEstimate = (estimateSum, descendant)=>{
            if (estimateSum == null && (0, parcelRequire("lV634")).default(descendant[estimateAttribute])) return null;
            if ((0, parcelRequire("lV634")).default(descendant[estimateAttribute])) return estimateSum;
            return (estimateSum || 0) + (descendant[estimateAttribute] || 0);
        };
        const getReleases = (releases, descendant)=>{
            if (releases === null && (0, parcelRequire("lV634")).default(descendant.fixVersions)) return null;
            if ((0, parcelRequire("lV634")).default(descendant.fixVersions)) return releases;
            return [
                ...releases || [],
                ...descendant.fixVersions || []
            ];
        };
        const getTeam = (team, descendant)=>{
            if (team === null && (0, parcelRequire("lV634")).default(descendant.team)) return null;
            if ((0, parcelRequire("lV634")).default(descendant.team) || descendant.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)) return team;
            return [
                ...team || [],
                descendant.team
            ];
        };
        for (const issue of issues)rollupMap[issue.id] = descendantsMap[issue.id] && descendantsMap[issue.id].reduce(({ estimate: estimate, release: release, team: team, sprint: sprint }, descendant)=>({
                release: [
                    ...new Set(getReleases(release, descendant))
                ],
                estimate: getEstimate(estimate, descendant),
                team: [
                    ...new Set(getTeam(team, descendant))
                ],
                sprint: [
                    ...new Set($f15dfef495212845$export$1b6ef61469955f33(sprint, descendant))
                ]
            }), {
            estimate: null,
            release: null,
            team: null,
            sprint: null
        });
        return rollupMap;
    };
    const $f15dfef495212845$export$cfcbda58efe6fed9 = (issues)=>(0, parcelRequire("bQZTk")).default((0, parcelRequire("jVZZA")).default((0, parcelRequire("2JlG5")).default('parent')), (0, parcelRequire("4wiYB")).default((0, parcelRequire("2rMKg")).default('parent')))(issues);
    const $f15dfef495212845$export$65544d51bd5cdae8 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssues)
    ], $f15dfef495212845$export$cfcbda58efe6fed9);
    const $f15dfef495212845$export$da55948f2286493c = (0, $3YtPS.createSelector)([
        $f15dfef495212845$export$65544d51bd5cdae8
    ], (0, $4nDwW.mapGroupsToIds));
    const $f15dfef495212845$export$d607bcb6675e3e03 = (issue, issueMap, descendantsMap, maxDescendantsLevel, descendants = [], descendantParents = new Set())=>{
        descendantParents.add(issue.id);
        for (const descendantId of descendantsMap[issue.id] || []){
            const issueObj = issueMap[descendantId];
            if (issueObj.level >= maxDescendantsLevel && !descendantParents.has(issueObj.id)) {
                descendants.push(issueObj);
                $f15dfef495212845$export$d607bcb6675e3e03(issueObj, issueMap, descendantsMap, maxDescendantsLevel, descendants, descendantParents);
            }
        }
        return descendants;
    };
    const $f15dfef495212845$export$3da908157953bd63 = (issuesById, childrenIdsByParent)=>(0, parcelRequire("4Rr1a")).default((issue)=>$f15dfef495212845$export$d607bcb6675e3e03(issue, issuesById, childrenIdsByParent, (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)), issuesById);
    const $f15dfef495212845$export$3a123be6fa1e1089 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssueMapById),
        $f15dfef495212845$export$da55948f2286493c
    ], $f15dfef495212845$export$3da908157953bd63);
    const $f15dfef495212845$export$61e0876ed41cdcfd = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getAllIssues),
        $f15dfef495212845$export$3a123be6fa1e1089,
        (0, $bHTqr.getPlanningUnit),
        (0, $kWDpn.getShowRolledUpOthers)
    ], $f15dfef495212845$export$ad7f62d8b8ed8f29);
});
parcelRegister("ja8Lc", function(module, exports) {
    $parcel$export(module.exports, "getFieldKey", ()=>$fcde2a53de730acd$export$d6ccbf9dc458bdae);
    $parcel$export(module.exports, "getSort", ()=>$fcde2a53de730acd$export$9cf0cb3e0918cf99);
    var $9J1HQ;
    var $lV634;
    var $fZhYM;
    var $7Mt7i;
    var $3JFoT;
    var $hpnKp;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $bstHg = parcelRequire("bstHg");
    var $hu7Cn = parcelRequire("hu7Cn");
    var $19iju = parcelRequire("19iju");
    var $io4Ja = parcelRequire("io4Ja");
    var $7ppNi = parcelRequire("7ppNi");
    var $6tk1y = parcelRequire("6tk1y");
    var $bHTqr = parcelRequire("bHTqr");
    var $dRVQG = parcelRequire("dRVQG");
    var $kWDpn = parcelRequire("kWDpn");
    var $4sJY8 = parcelRequire("4sJY8");
    const $fcde2a53de730acd$export$d6ccbf9dc458bdae = (fieldId, planningUnit)=>{
        if (fieldId === (0, $bstHg.ISSUE_FIELDS).ESTIMATE) return planningUnit === (0, $TTKUQ.PlanningUnits).storyPoints ? 'storyPoints' : 'timeEstimate';
        return fieldId;
    };
    const $fcde2a53de730acd$export$2c9b3f539cb25b05 = (isCustomField, field, issue)=>isCustomField ? (0, parcelRequire("fZhYM")).default([
            'customFields',
            field
        ], issue) : issue[field];
    const $fcde2a53de730acd$export$cb8ab7d6e878141 = (allTeamsById, direction)=>(comparatorFunction)=>[
                ({ team: teamOfIssueA }, { team: teamOfIssueB })=>{
                    if (teamOfIssueA && teamOfIssueB) return comparatorFunction((team)=>(0, parcelRequire("7Mt7i")).default('', [
                            team,
                            'title'
                        ], allTeamsById).toLowerCase())(teamOfIssueA, teamOfIssueB);
                    if (!teamOfIssueA && !teamOfIssueB) return 0;
                    if (direction === (0, $TTKUQ.SORT_DIRECTION).ASCENDING) return teamOfIssueA ? -1 : 1;
                    return teamOfIssueA ? 1 : -1;
                }
            ];
    const $fcde2a53de730acd$export$f56cdb802f24d250 = (issuePrioritiesIdList)=>(comparatorFunction)=>[
                comparatorFunction(({ priority: priority })=>issuePrioritiesIdList.indexOf(priority))
            ];
    const $fcde2a53de730acd$export$57707817503254eb = (issueStatusById)=>(comparatorFunction)=>{
            const categoriesMap = {
                [(0, $TTKUQ.ISSUE_STATUS_CATEGORIES).TODO]: 1,
                [(0, $TTKUQ.ISSUE_STATUS_CATEGORIES).INPROGRESS]: 2,
                [(0, $TTKUQ.ISSUE_STATUS_CATEGORIES).DONE]: 3
            };
            return [
                comparatorFunction(({ status: status })=>{
                    if (!(0, $4nDwW.isDefined)(status)) return 0;
                    const issueStatus = issueStatusById[status];
                    if (!(0, $4nDwW.isDefined)(issueStatus)) return 0;
                    return categoriesMap[issueStatus.categoryId];
                }),
                comparatorFunction(({ status: status })=>{
                    if (!(0, $4nDwW.isDefined)(status)) return '';
                    return (0, parcelRequire("7Mt7i")).default('', [
                        status,
                        'name'
                    ], issueStatusById).toLowerCase();
                })
            ];
        };
    const $fcde2a53de730acd$export$4aa9d781e270fa16 = (assigneesById, direction)=>(comparatorFunction)=>[
                ({ assignee: assigneeOfIssueA }, { assignee: assigneeOfIssueB })=>{
                    if (assigneeOfIssueA !== 'unassigned' && assigneeOfIssueB !== 'unassigned') return comparatorFunction((assignee)=>(0, parcelRequire("7Mt7i")).default('', [
                            assignee,
                            'jiraUser',
                            'title'
                        ], assigneesById).toLowerCase())(assigneeOfIssueA, assigneeOfIssueB);
                    if (assigneeOfIssueA === 'unassigned' && assigneeOfIssueB === 'unassigned') return 0;
                    if (direction === (0, $TTKUQ.SORT_DIRECTION).ASCENDING) return assigneeOfIssueA === 'unassigned' ? 1 : -1;
                    return assigneeOfIssueA === 'unassigned' ? -1 : 1;
                }
            ];
    const $fcde2a53de730acd$export$8e2c99fad461c86f = (state)=>(0, $kWDpn.getVisualisationViewSettings)(state).sorting;
    const $fcde2a53de730acd$export$e52fa2f2cecb999c = (0, parcelRequire("9J1HQ")).default(3, (fn, a, b)=>{
        const aa = fn(a);
        const bb = fn(b);
        if ((0, parcelRequire("lV634")).default(aa) && (0, parcelRequire("lV634")).default(bb)) return 0;
        if ((0, parcelRequire("lV634")).default(aa)) return -1;
        if ((0, parcelRequire("lV634")).default(bb)) return 1;
        if (aa < bb) return -1;
        if (aa > bb) return 1;
        return 0;
    });
    const $fcde2a53de730acd$export$b2276edb91189a53 = (0, parcelRequire("9J1HQ")).default(3, (fn, a, b)=>{
        const aa = fn(a);
        const bb = fn(b);
        if ((0, parcelRequire("lV634")).default(aa) && (0, parcelRequire("lV634")).default(bb)) return 0;
        if ((0, parcelRequire("lV634")).default(aa)) return 1;
        if ((0, parcelRequire("lV634")).default(bb)) return -1;
        if (aa > bb) return -1;
        if (aa < bb) return 1;
        return 0;
    });
    const $fcde2a53de730acd$export$95525488fdeaaa55 = (lexoRankAdjustments, sorting, dateConfiguration, issueStatusById, showRolledUpOthers = false, planningUnit, rollupMap, issuePrioritiesIdList, allTeamsById, assigneesById, selectOptionsById)=>{
        const comparatorFunction = (0, $4nDwW.isDefined)(sorting.direction) && sorting.direction === (0, $TTKUQ.SORT_DIRECTION).DESCENDING ? $fcde2a53de730acd$export$b2276edb91189a53 : $fcde2a53de730acd$export$e52fa2f2cecb999c;
        const defaultSortFunctions = [
            (0, $4nDwW.ascend)(({ lexoRank: lexoRank })=>lexoRank || ''),
            (0, $4nDwW.ascend)(({ id: id })=>lexoRankAdjustments.indexOf(id))
        ];
        const { baselineStartField: { key: configuredStartField }, baselineEndField: { key: configuredEndField } } = dateConfiguration;
        const sortByStringFunctionsMap = {
            [(0, $bstHg.ISSUE_FIELDS).PRIORITY_FIELD]: issuePrioritiesIdList ? $fcde2a53de730acd$export$f56cdb802f24d250((0, parcelRequire("3JFoT")).default(issuePrioritiesIdList)) : ()=>[],
            [(0, $bstHg.ISSUE_FIELDS).TEAM_FIELD]: $fcde2a53de730acd$export$cb8ab7d6e878141(allTeamsById, sorting.direction),
            [(0, $bstHg.ISSUE_FIELDS).STATUS_FIELD]: $fcde2a53de730acd$export$57707817503254eb(issueStatusById),
            [(0, $bstHg.ISSUE_FIELDS).ASSIGNEE_FIELD]: $fcde2a53de730acd$export$4aa9d781e270fa16(assigneesById, sorting.direction)
        };
        switch(sorting.type){
            case (0, $TTKUQ.ISSUE_FIELD_TYPES).DATE:
                return (0, $4nDwW.sortWith)([
                    comparatorFunction((issue)=>{
                        if (sorting.field === configuredStartField) return issue.baselineStart || 0;
                        if (sorting.field === configuredEndField) return issue.baselineEnd || 0;
                        const dateAttribute = $fcde2a53de730acd$export$2c9b3f539cb25b05(sorting.isCustomField, sorting.field, issue);
                        return dateAttribute || 0;
                    }),
                    ...defaultSortFunctions
                ]);
            case (0, $TTKUQ.ISSUE_FIELD_TYPES).STRING:
                {
                    const getSortBy = sortByStringFunctionsMap[sorting.field];
                    if (!getSortBy) return (0, $4nDwW.sortWith)([
                        comparatorFunction((issue)=>{
                            const field = $fcde2a53de730acd$export$2c9b3f539cb25b05(sorting.isCustomField, sorting.field, issue);
                            if (sorting.isCustomField) {
                                const customFieldValue = field && selectOptionsById[field] && selectOptionsById[field].value;
                                return (0, $4nDwW.isDefined)(customFieldValue) ? (0, parcelRequire("hpnKp")).default(customFieldValue) : customFieldValue;
                            }
                            return (0, $4nDwW.isDefined)(field) ? (0, parcelRequire("hpnKp")).default(field) : field;
                        }),
                        ...defaultSortFunctions
                    ]);
                    return (0, $4nDwW.sortWith)([
                        ...getSortBy(comparatorFunction),
                        ...defaultSortFunctions
                    ]);
                }
            case (0, $TTKUQ.ISSUE_FIELD_TYPES).NUMBER:
                return (0, $4nDwW.sortWith)([
                    comparatorFunction((issue)=>{
                        const rollupIssueValues = rollupMap[issue.id];
                        const attributeKey = sorting.isCustomField ? sorting.field : $fcde2a53de730acd$export$d6ccbf9dc458bdae(sorting.field, planningUnit);
                        const value = $fcde2a53de730acd$export$2c9b3f539cb25b05(sorting.isCustomField, attributeKey, issue);
                        const isValueDefined = (0, $4nDwW.isDefined)(value);
                        if (showRolledUpOthers) {
                            const isRollupValueDefined = (0, $4nDwW.isDefined)(rollupIssueValues[sorting.field]);
                            if (!isRollupValueDefined) return value;
                            if (!isValueDefined) return rollupIssueValues[sorting.field];
                            return value + rollupIssueValues[sorting.field];
                        }
                        return value;
                    }),
                    ...defaultSortFunctions
                ]);
            default:
                return (0, $4nDwW.sortWith)(defaultSortFunctions);
        }
    };
    const $fcde2a53de730acd$export$9cf0cb3e0918cf99 = (0, $3YtPS.createSelector)([
        (0, $6tk1y.getIssueLexoRankAdjustments),
        $fcde2a53de730acd$export$8e2c99fad461c86f,
        (0, $bHTqr.getDateConfiguration),
        (0, $7ppNi.getIssueStatusById),
        (0, $kWDpn.getShowRolledUpOthers),
        (0, $bHTqr.getPlanningUnit),
        (0, $4sJY8.getRollupMap),
        (0, $io4Ja.getIssuePrioritiesIdList),
        (0, $dRVQG.getAllTeamsById),
        (0, $hu7Cn.getAssigneesById),
        (0, $19iju.getSelectOptionsById)
    ], $fcde2a53de730acd$export$95525488fdeaaa55);
});
parcelRegister("7Mt7i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5aa39a0e8a7be9a2$export$2e2bcd8739ae039);
    var $IYMZh;
    var $3pSjV;
    var $fZhYM;
    var $5aa39a0e8a7be9a2$var$pathOr = (0, (0, parcelRequire("IYMZh")).default)(function pathOr(d, p, obj) {
        return (0, (0, parcelRequire("3pSjV")).default)(d, (0, (0, parcelRequire("fZhYM")).default)(p, obj));
    });
    var $5aa39a0e8a7be9a2$export$2e2bcd8739ae039 = $5aa39a0e8a7be9a2$var$pathOr;
});
parcelRegister("hpnKp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cac73141c8bd1dca$export$2e2bcd8739ae039);
    var $6huGS;
    var $cac73141c8bd1dca$var$toLower = (0, (0, parcelRequire("6huGS")).default)(0, 'toLowerCase');
    var $cac73141c8bd1dca$export$2e2bcd8739ae039 = $cac73141c8bd1dca$var$toLower;
});
parcelRegister("bstHg", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_FIELDS", ()=>$9f3397535f614d61$export$e2d863e73993291c);
    $parcel$export(module.exports, "TARGET_DATE_FIELD_TO_API_DATE_FIELD_MAP", ()=>$9f3397535f614d61$export$2cfb2d0810bc071e);
    $parcel$export(module.exports, "ISSUE_FIELD_TO_TYPE_MAP", ()=>$9f3397535f614d61$export$192a285e6a49f870);
    var $5fc53;
    var $5fACX = parcelRequire("5fACX");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $5fACX = parcelRequire("5fACX");
    const $9f3397535f614d61$export$c3d7e0f1e63de60e = 'lexoRank';
    const $9f3397535f614d61$export$e2d863e73993291c = {
        DUE_DATE: $5fACX.DUE_DATE,
        RANK: $9f3397535f614d61$export$c3d7e0f1e63de60e,
        TARGET_START_FIELD: $5fACX.TARGET_START_FIELD,
        TARGET_END_FIELD: $5fACX.TARGET_END_FIELD,
        TEAM_FIELD: (0, parcelRequire("5fc53")).TEAM_TYPE,
        STATUS_FIELD: (0, parcelRequire("5fc53")).STATUS_TYPE,
        ESTIMATE: (0, parcelRequire("5fc53")).ESTIMATE_TYPE,
        PRIORITY_FIELD: (0, parcelRequire("5fc53")).PRIORITY_TYPE,
        ASSIGNEE_FIELD: (0, parcelRequire("5fc53")).ASSIGNEE_TYPE,
        REPORTER_FIELD: (0, parcelRequire("5fc53")).REPORTER_TYPE
    };
    const $9f3397535f614d61$export$2cfb2d0810bc071e = Object.freeze({
        [(0, $5fACX.TARGET_START_FIELD)]: 'baselineStart',
        [(0, $5fACX.TARGET_END_FIELD)]: 'baselineEnd'
    });
    const $9f3397535f614d61$export$192a285e6a49f870 = {
        [(0, $5fACX.DUE_DATE)]: (0, $TTKUQ.ISSUE_FIELD_TYPES).DATE,
        [$9f3397535f614d61$export$c3d7e0f1e63de60e]: (0, $TTKUQ.ISSUE_FIELD_TYPES).STRING,
        [(0, $5fACX.TARGET_START_FIELD)]: (0, $TTKUQ.ISSUE_FIELD_TYPES).DATE,
        [(0, $5fACX.TARGET_END_FIELD)]: (0, $TTKUQ.ISSUE_FIELD_TYPES).DATE,
        [(0, (0, parcelRequire("5fc53")).TEAM_TYPE)]: (0, $TTKUQ.ISSUE_FIELD_TYPES).STRING,
        [(0, (0, parcelRequire("5fc53")).STATUS_TYPE)]: (0, $TTKUQ.ISSUE_FIELD_TYPES).STRING,
        [(0, (0, parcelRequire("5fc53")).ESTIMATE_TYPE)]: (0, $TTKUQ.ISSUE_FIELD_TYPES).NUMBER,
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: (0, $TTKUQ.ISSUE_FIELD_TYPES).STRING,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: (0, $TTKUQ.ISSUE_FIELD_TYPES).STRING,
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: (0, $TTKUQ.ISSUE_FIELD_TYPES).STRING
    };
});
parcelRegister("fP57B", function(module, exports) {
    $parcel$export(module.exports, "SET_PLAN_INFO", ()=>$78b0b52fa28a5a1e$export$c75f54816444e80b);
    $parcel$export(module.exports, "RESET_BACKLOG", ()=>$78b0b52fa28a5a1e$export$c396d703a224b390);
    $parcel$export(module.exports, "AFTER_RESET_BACKLOG", ()=>$78b0b52fa28a5a1e$export$a18f376ec94e9a69);
    $parcel$export(module.exports, "UPDATE_ISSUE_REFERENCES", ()=>$78b0b52fa28a5a1e$export$506f8b03e3eeeb49);
    $parcel$export(module.exports, "setPlanInfo", ()=>$78b0b52fa28a5a1e$export$47293510bb7e9633);
    $parcel$export(module.exports, "resetBacklog", ()=>$78b0b52fa28a5a1e$export$3089734ef4d8a726);
    $parcel$export(module.exports, "afterResetBacklog", ()=>$78b0b52fa28a5a1e$export$c889522a21dc6b24);
    $parcel$export(module.exports, "updateIssueReferences", ()=>$78b0b52fa28a5a1e$export$3dc49f90a30d81dc);
    const $78b0b52fa28a5a1e$export$c75f54816444e80b = 'state.domain.SET_PLAN_INFO';
    const $78b0b52fa28a5a1e$export$c396d703a224b390 = 'state.domain.RESET_BACKLOG';
    const $78b0b52fa28a5a1e$export$a18f376ec94e9a69 = 'state.domain.AFTER_RESET_BACKLOG';
    const $78b0b52fa28a5a1e$export$506f8b03e3eeeb49 = 'state.domain.UPDATE_ISSUE_REFERENCES';
    const $78b0b52fa28a5a1e$export$47293510bb7e9633 = (payload)=>({
            type: $78b0b52fa28a5a1e$export$c75f54816444e80b,
            payload: payload
        });
    const $78b0b52fa28a5a1e$export$3089734ef4d8a726 = (payload)=>({
            type: $78b0b52fa28a5a1e$export$c396d703a224b390,
            payload: payload
        });
    const $78b0b52fa28a5a1e$export$c889522a21dc6b24 = ()=>({
            type: $78b0b52fa28a5a1e$export$a18f376ec94e9a69
        });
    const $78b0b52fa28a5a1e$export$3dc49f90a30d81dc = (payload)=>({
            type: $78b0b52fa28a5a1e$export$506f8b03e3eeeb49,
            payload: payload
        });
});
parcelRegister("3ODbh", function(module, exports) {
    $parcel$export(module.exports, "TargetTypes", ()=>$b0888f483915cec3$export$61728fee2ed143fe);
    $parcel$export(module.exports, "TOGGLE_SELECTED_ISSUES", ()=>$b0888f483915cec3$export$8c9ac2746bcaefa7);
    $parcel$export(module.exports, "toggleSelectedIssues", ()=>$b0888f483915cec3$export$d2807327ad419922);
    const $b0888f483915cec3$export$61728fee2ed143fe = {
        single: (0, $c7d85f642f0ffa55$export$9bf4e7d6b603dbce),
        all: (0, $c7d85f642f0ffa55$export$9dddd83352737cc1),
        singleAndDescendants: (0, $c7d85f642f0ffa55$export$28c9c1d4094b974f),
        descendants: (0, $c7d85f642f0ffa55$export$eb5df195279ddc82)
    };
    const $b0888f483915cec3$export$8c9ac2746bcaefa7 = 'state.ui.main.tabs.roadmap.scope.issues.selectable-issue.TOGGLE_SELECTED_ISSUES';
    const $b0888f483915cec3$export$d2807327ad419922 = (payload)=>({
            type: $b0888f483915cec3$export$8c9ac2746bcaefa7,
            payload: payload
        });
});
const $c7d85f642f0ffa55$export$9bf4e7d6b603dbce = 'SINGLE';
const $c7d85f642f0ffa55$export$9dddd83352737cc1 = 'ALL';
const $c7d85f642f0ffa55$export$28c9c1d4094b974f = 'SINGLE_AND_DESCENDANTS';
const $c7d85f642f0ffa55$export$eb5df195279ddc82 = 'DESCENDANTS';
parcelRegister("gR2ry", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27399a48f3ed1bf6$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $3YtPS = parcelRequire("3YtPS");
    var $27399a48f3ed1bf6$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        filterValueFor: (state)=>(id)=>(0, $iIikD.getFilters)(state)[id].value
    });
});
parcelRegister("gmhgt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$babaf143b85e2357$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8EB5I;
    var $aCpcO;
    function $babaf143b85e2357$export$2e2bcd8739ae039({ ariaLabel: ariaLabel, children: children, clearable: clearable, clearFilter: clearFilter, clearText: clearText, filterValueFor: filterValueFor, onFilterApply: onFilterApply = (0, ($parcel$interopDefault($8Rkzz))), quickFilter: quickFilter, value: filter }) {
        const currentValue = filterValueFor(filter.id);
        const hasSameValue = (0, parcelRequire("8EB5I")).default(currentValue, filter.value);
        if (hasSameValue && clearable === true) {
            const handleClick = ()=>clearFilter();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                appearance: "subtle-link",
                spacing: "none",
                onClick: handleClick
            }, clearText);
        }
        const handleClick = (_, analyticsEvent)=>{
            quickFilter(filter.id, filter.value);
            onFilterApply(analyticsEvent);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "link",
            spacing: "none",
            onClick: handleClick,
            ariaLabel: ariaLabel
        }, children);
    }
});
parcelRegister("lJdz7", function(module, exports) {
    $parcel$export(module.exports, "SelectForColumnCell", ()=>$1e961fb80940ce8c$export$6385b193dd4b511d);
    $parcel$export(module.exports, "CellSelectWithRollup", ()=>$1e961fb80940ce8c$export$716b30d2725b585e);
    $parcel$export(module.exports, "AsyncSelectForColumnCell", ()=>$1e961fb80940ce8c$export$8ec70a3e94138773);
    $parcel$export(module.exports, "AsyncCellSelectWithRollup", ()=>$1e961fb80940ce8c$export$bb966582f7dbd566);
    var $cSD7y;
    var $bC2fB;
    var $nQX2n = parcelRequire("nQX2n");
    var $6CKH7 = parcelRequire("6CKH7");
    var $cSDJf = parcelRequire("cSDJf");
    var $gldeA = parcelRequire("gldeA");
    var $cSDJf = parcelRequire("cSDJf");
    var $1e961fb80940ce8c$export$2e2bcd8739ae039 = (0, $cSDJf.default);
    const $1e961fb80940ce8c$export$6385b193dd4b511d = (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', (0, (0, parcelRequire("bC2fB")).connect)((0, $6CKH7.mapStateToProps), (0, $nQX2n.mapDispatchSelect))((0, $cSDJf.SelectForColumnCell)), (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $nQX2n.mapDispatchSelect))((0, $cSDJf.SelectForColumnCell)));
    const $1e961fb80940ce8c$export$716b30d2725b585e = (0, (0, parcelRequire("bC2fB")).connect)((0, $6CKH7.mapStateRollupSelect), (0, $nQX2n.mapDispatchRollupSelect))((0, $gldeA.default));
    const $1e961fb80940ce8c$export$8ec70a3e94138773 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', (0, (0, parcelRequire("bC2fB")).connect)((0, $6CKH7.mapStateToProps), (0, $nQX2n.mapDispatchAsyncSelect))((0, $cSDJf.AsyncSelectForColumnCell)), (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $nQX2n.mapDispatchAsyncSelect))((0, $cSDJf.AsyncSelectForColumnCell)));
    const $1e961fb80940ce8c$export$bb966582f7dbd566 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6CKH7.mapStateRollupSelect), (0, $nQX2n.mapDispatchAsyncRollupSelect))((0, $gldeA.AsyncSelectWithRollup));
});
parcelRegister("nQX2n", function(module, exports) {
    $parcel$export(module.exports, "mapDispatchSelect", ()=>$0649f6c26b049605$export$bf7a1c4da7756943);
    $parcel$export(module.exports, "mapDispatchAsyncSelect", ()=>$0649f6c26b049605$export$af449af6bd41cf72);
    $parcel$export(module.exports, "mapDispatchRollupSelect", ()=>$0649f6c26b049605$export$921fe94c23f30b4b);
    $parcel$export(module.exports, "mapDispatchAsyncRollupSelect", ()=>$0649f6c26b049605$export$d1e1623a7b87592b);
    var $7K8Pq = parcelRequire("7K8Pq");
    const $0649f6c26b049605$var$mapDispatchBase = (dispatch, ownProps)=>({
            lockInlineCreate: (isLocked)=>{
                dispatch((0, $7K8Pq.setOpenLocked)({
                    attribute: ownProps.attribute,
                    isLocked: isLocked
                }));
            }
        });
    const $0649f6c26b049605$export$bf7a1c4da7756943 = $0649f6c26b049605$var$mapDispatchBase;
    const $0649f6c26b049605$export$af449af6bd41cf72 = $0649f6c26b049605$var$mapDispatchBase;
    const $0649f6c26b049605$export$921fe94c23f30b4b = $0649f6c26b049605$var$mapDispatchBase;
    const $0649f6c26b049605$export$d1e1623a7b87592b = $0649f6c26b049605$var$mapDispatchBase;
});
parcelRegister("6CKH7", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$5d57ee87d8119855$export$c31df4bd766f9c35);
    $parcel$export(module.exports, "mapStateRollupSelect", ()=>$5d57ee87d8119855$export$4096c099965f1b71);
    var $4R6GH;
    var $1CGdp = parcelRequire("1CGdp");
    var $kWDpn = parcelRequire("kWDpn");
    const $5d57ee87d8119855$export$c31df4bd766f9c35 = (state)=>({
            isSmartLink: (0, $1CGdp.isSmartLink)(state)
        });
    const $5d57ee87d8119855$export$4096c099965f1b71 = (state)=>({
            showRolledUpEstimate: (0, $kWDpn.getShowRolledUpOthers)(state),
            ...(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? {
                isSmartLink: (0, $1CGdp.isSmartLink)(state)
            } : {}
        });
});
parcelRegister("gldeA", function(module, exports) {
    $parcel$export(module.exports, "AsyncSelectWithRollup", ()=>$e2c3cc1479d70bad$export$693ef00d592b32a6);
    $parcel$export(module.exports, "default", ()=>$e2c3cc1479d70bad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $bChGW;
    var $ixSW4 = parcelRequire("ixSW4");
    var $02zmV = parcelRequire("02zmV");
    var $nFY7c = parcelRequire("nFY7c");
    var $coVrx = parcelRequire("coVrx");
    const $e2c3cc1479d70bad$var$rollupContext = (0, $5uXOq.createContext)({
        rolledUpValues: [],
        showRolledUpEstimate: false,
        isSmartLink: false
    });
    const $e2c3cc1479d70bad$var$ValueContainer = ({ children: children, ...innerProps })=>{
        const value = innerProps.selectProps.value;
        const { rolledUpValues: rolledUpValues, showRolledUpEstimate: showRolledUpEstimate, isSmartLink: isSmartLink } = (0, $5uXOq.useContext)($e2c3cc1479d70bad$var$rollupContext);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).ValueContainer, innerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $02zmV.default), {
            menuIsOpen: innerProps.selectProps.menuIsOpen,
            isDisabled: innerProps.selectProps.isDisabled,
            showRollup: showRolledUpEstimate && rolledUpValues && rolledUpValues.length > 0,
            isMultiSelect: innerProps.selectProps.isMulti,
            rolledUpValues: rolledUpValues,
            withValue: Array.isArray(value) ? !(0, parcelRequire("3nPAF")).default(value) : !!value,
            ...(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? {
                isSmartLink: isSmartLink
            } : {}
        }, children)));
    };
    const $e2c3cc1479d70bad$var$getValueLabelKey = (attribute)=>{
        if (attribute === 'sprint') return 'sprintActualValueLabel';
        if (attribute === 'team') return 'teamActualValueLabel';
        return 'releaseActualValueLabel';
    };
    const $e2c3cc1479d70bad$export$41d2812e56379983 = ({ value: value, showRolledUpEstimate: showRolledUpEstimate, rolledUpValues: rolledUpValues, menuIsOpen: menuIsOpen, attribute: attribute, formatMessage: formatMessage })=>{
        let actualValue;
        if (Array.isArray(value)) actualValue = value.map((option)=>option.label).join(', ');
        else actualValue = value ? String(value.label || '') : '';
        if (showRolledUpEstimate && rolledUpValues && rolledUpValues.length > 0 && !menuIsOpen) {
            const rolledUpValuesStr = rolledUpValues ? rolledUpValues.join(', ') : '';
            const label = $e2c3cc1479d70bad$var$getValueLabelKey(attribute);
            const actualValueTooltipLabel = formatMessage((0, $coVrx.default)[label]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, `${actualValue}`.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, ' ', actualValueTooltipLabel, ": ", actualValue, ' '), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $coVrx.default).rolledUpValueLabel), ": ", rolledUpValuesStr));
        }
        if (`${actualValue}`.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, actualValue);
        return null;
    };
    const $e2c3cc1479d70bad$var$sharedRollupStyles = (menuIsOpen, isMulti, isSmartLink)=>({
            multiValueLabel: (styles)=>({
                    ...styles,
                    minWidth: 'auto',
                    maxWidth: '240px',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    height: '18px',
                    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
                    fontSize: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    lineHeight: '14px',
                    paddingLeft: "var(--ds-space-050, 4px)",
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            valueContainer: (styles)=>({
                    ...styles,
                    flexWrap: 'nowrap'
                }),
            singleValue: (styles)=>({
                    ...styles,
                    ...menuIsOpen ? {} : {
                        top: 0,
                        transform: 'none',
                        position: 'relative'
                    },
                    ...isSmartLink && (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? {
                        color: "var(--ds-text, #172B4D)"
                    } : {}
                }),
            input: ()=>({
                    flex: isMulti && menuIsOpen ? '1 1 auto' : '1 1 0'
                }),
            multiValueRemove: (styles, state)=>({
                    ...styles,
                    display: state.selectProps.menuIsOpen ? 'flex' : 'none'
                }),
            clearIndicator: (styles, state)=>({
                    ...styles,
                    display: state.selectProps.menuIsOpen ? 'flex' : 'none'
                }),
            container: (styles, { selectProps: { menuIsOpen: menuIsOpen, isMulti: isMulti } })=>({
                    ...styles,
                    ...menuIsOpen && isMulti ? {
                        zIndex: 1
                    } : {}
                }),
            control: (styles, { hasValue: hasValue, selectProps: { menuIsOpen: menuIsOpen, isMulti: isMulti } })=>menuIsOpen && isMulti ? {
                    ...styles,
                    zIndex: 99999
                } : {
                    ...styles,
                    background: 'none',
                    borderColor: 'transparent',
                    [':hover']: {
                        ...styles[':hover'],
                        background: 'none',
                        ...hasValue ? {
                            borderColor: 'transparent'
                        } : {}
                    }
                }
        });
    const $e2c3cc1479d70bad$export$214eae6755eabc35 = (0, $ixSW4.withSlots)({
        FieldSelect: (0, $ixSW4.slots).FieldSelect
    })((props)=>{
        const { rolledUpValues: rolledUpValues, showRolledUpEstimate: showRolledUpEstimate, isSmartLink: isSmartLink, FieldSelect: FieldSelect, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...selectProps } = props;
        const { attribute: attribute, value: value } = selectProps;
        const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(false);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const getToolTipContentFunc = ()=>$e2c3cc1479d70bad$export$41d2812e56379983({
                value: value,
                showRolledUpEstimate: showRolledUpEstimate,
                rolledUpValues: rolledUpValues,
                menuIsOpen: menuIsOpen,
                attribute: attribute,
                formatMessage: intl.formatMessage
            });
        const handleMenuOpen = (0, $5uXOq.useCallback)(()=>{
            setMenuIsOpen(true);
            if (onMenuOpen) onMenuOpen();
        }, [
            onMenuOpen
        ]);
        const handleMenuClose = (0, $5uXOq.useCallback)(()=>{
            setMenuIsOpen(false);
            if (onMenuClose) onMenuClose();
        }, [
            onMenuClose
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$nFY7c.selectRollupContainer} `
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: getToolTipContentFunc()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e2c3cc1479d70bad$var$rollupContext.Provider, {
            value: {
                rolledUpValues: rolledUpValues,
                showRolledUpEstimate: showRolledUpEstimate,
                isSmartLink: (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? isSmartLink : false
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(FieldSelect, {
            onMenuOpen: handleMenuOpen,
            onMenuClose: handleMenuClose,
            ...selectProps,
            styles: $e2c3cc1479d70bad$var$sharedRollupStyles(menuIsOpen, selectProps.isMulti, isSmartLink),
            components: {
                ...selectProps.components,
                ValueContainer: $e2c3cc1479d70bad$var$ValueContainer
            },
            menuIsOpen: menuIsOpen,
            ...(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? {
                isSmartLink: isSmartLink
            } : {}
        })))));
    });
    const $e2c3cc1479d70bad$export$693ef00d592b32a6 = (0, $ixSW4.withSlots)({
        FieldAsyncSelect: (0, $ixSW4.slots).FieldAsyncSelect
    })((props)=>{
        const { rolledUpValues: rolledUpValues, showRolledUpEstimate: showRolledUpEstimate, isSmartLink: isSmartLink, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, isConfluenceMacro: isConfluenceMacro, FieldAsyncSelect: FieldAsyncSelect, ...asyncSelectProps } = props;
        const { attribute: attribute, value: value } = asyncSelectProps;
        const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(false);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const getToolTipContentFunc = ()=>$e2c3cc1479d70bad$export$41d2812e56379983({
                value: value,
                showRolledUpEstimate: showRolledUpEstimate,
                rolledUpValues: rolledUpValues,
                menuIsOpen: menuIsOpen,
                attribute: attribute,
                formatMessage: intl.formatMessage
            });
        const handleMenuOpen = (0, $5uXOq.useCallback)(()=>{
            setMenuIsOpen(true);
            if (onMenuOpen) onMenuOpen();
        }, [
            onMenuOpen
        ]);
        const handleMenuClose = (0, $5uXOq.useCallback)(()=>{
            setMenuIsOpen(false);
            if (onMenuClose) onMenuClose();
        }, [
            onMenuClose
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$nFY7c.selectRollupContainer} `
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: getToolTipContentFunc()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e2c3cc1479d70bad$var$rollupContext.Provider, {
            value: {
                rolledUpValues: rolledUpValues,
                showRolledUpEstimate: showRolledUpEstimate,
                isSmartLink: (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? isSmartLink : false
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(FieldAsyncSelect, {
            onMenuOpen: handleMenuOpen,
            onMenuClose: handleMenuClose,
            ...asyncSelectProps,
            styles: $e2c3cc1479d70bad$var$sharedRollupStyles(menuIsOpen, asyncSelectProps.isMulti, isSmartLink),
            components: {
                ...props.components,
                ValueContainer: $e2c3cc1479d70bad$var$ValueContainer
            },
            menuIsOpen: menuIsOpen,
            ...(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? {
                isSmartLink: isSmartLink,
                isDisabled: isSmartLink || asyncSelectProps.isDisabled
            } : {}
        })))));
    });
    var $e2c3cc1479d70bad$export$2e2bcd8739ae039 = $e2c3cc1479d70bad$export$214eae6755eabc35;
});
parcelRegister("02zmV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aeef3d0203dbc3ca$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $4R6GH;
    var $90ldD = parcelRequire("90ldD");
    var $nFY7c = parcelRequire("nFY7c");
    function $aeef3d0203dbc3ca$var$RollupContainer({ showRollup: showRollup, children: children, rolledUpValues: rolledUpValues = [], isDisabled: isDisabled = false, withValue: withValue, readonly: readonly = false, menuIsOpen: menuIsOpen = false, isMultiSelect: isMultiSelect = false, isSmartLink: isSmartLink = false }) {
        const styleNameForRollup = (0, ($parcel$interopDefault($9ci4W)))({
            [$nFY7c.rollup]: true,
            [$nFY7c.disabledRollup]: isDisabled,
            [$nFY7c.onlyRollup]: !withValue && !readonly,
            [$nFY7c.onlyRollupReadOnly]: !withValue && readonly,
            [$nFY7c.rollupSmartLink]: isSmartLink && (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')
        });
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$nFY7c.rollupWrapper} ${isDisabled ? $nFY7c.disabledRollupWrapper : ''}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: styleNameForRollup,
            style: {
                display: !showRollup || menuIsOpen ? 'none' : undefined
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $90ldD.default), {
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $nFY7c.rollupValue
        }, rolledUpValues && rolledUpValues.join(', '))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                flexWrap: isMultiSelect && menuIsOpen ? 'wrap' : 'nowrap'
            },
            className: (0, ($parcel$interopDefault($9ci4W)))($nFY7c.childrenWrapper, {
                [$nFY7c.placeholder]: !withValue && showRollup,
                [$nFY7c.childrenWrapperWithRollupValue]: rolledUpValues.length > 0 && !menuIsOpen
            })
        }, children)));
    }
    var $aeef3d0203dbc3ca$export$2e2bcd8739ae039 = $aeef3d0203dbc3ca$var$RollupContainer;
});
parcelRegister("90ldD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$009b6ae19b6a6472$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $009b6ae19b6a6472$var$Glyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            version: "1.1",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "currentColor",
            d: "M14.586 11l-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 13H10a1 1 0 0 0-1 1v7a1 1 0 0 1-2 0v-7a3 3 0 0 1 3-3h4.586z"
        }));
    var $009b6ae19b6a6472$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $009b6ae19b6a6472$var$Glyph,
            ...props
        });
});
parcelRegister("nFY7c", function(module, exports) {
    $parcel$export(module.exports, "childrenWrapper", ()=>$0472b42fd573a861$export$976523451128e394, (v)=>$0472b42fd573a861$export$976523451128e394 = v);
    $parcel$export(module.exports, "childrenWrapperWithRollupValue", ()=>$0472b42fd573a861$export$6448e42458359282, (v)=>$0472b42fd573a861$export$6448e42458359282 = v);
    $parcel$export(module.exports, "disabledRollup", ()=>$0472b42fd573a861$export$8fc2859090092516, (v)=>$0472b42fd573a861$export$8fc2859090092516 = v);
    $parcel$export(module.exports, "disabledRollupWrapper", ()=>$0472b42fd573a861$export$5b235e02afd947a8, (v)=>$0472b42fd573a861$export$5b235e02afd947a8 = v);
    $parcel$export(module.exports, "onlyRollup", ()=>$0472b42fd573a861$export$7f37be09c0fafa00, (v)=>$0472b42fd573a861$export$7f37be09c0fafa00 = v);
    $parcel$export(module.exports, "onlyRollupReadOnly", ()=>$0472b42fd573a861$export$d6c3a1a50fade065, (v)=>$0472b42fd573a861$export$d6c3a1a50fade065 = v);
    $parcel$export(module.exports, "placeholder", ()=>$0472b42fd573a861$export$c7187bbd1a7a9244, (v)=>$0472b42fd573a861$export$c7187bbd1a7a9244 = v);
    $parcel$export(module.exports, "rollup", ()=>$0472b42fd573a861$export$97e11c0b0230f130, (v)=>$0472b42fd573a861$export$97e11c0b0230f130 = v);
    $parcel$export(module.exports, "rollupSmartLink", ()=>$0472b42fd573a861$export$95dbe49e85b16cc7, (v)=>$0472b42fd573a861$export$95dbe49e85b16cc7 = v);
    $parcel$export(module.exports, "rollupValue", ()=>$0472b42fd573a861$export$409b770e9b28d1a3, (v)=>$0472b42fd573a861$export$409b770e9b28d1a3 = v);
    $parcel$export(module.exports, "rollupWrapper", ()=>$0472b42fd573a861$export$5fb402ec83a32662, (v)=>$0472b42fd573a861$export$5fb402ec83a32662 = v);
    $parcel$export(module.exports, "selectRollupContainer", ()=>$0472b42fd573a861$export$c4493537ac0c5f1c, (v)=>$0472b42fd573a861$export$c4493537ac0c5f1c = v);
    var $0472b42fd573a861$export$976523451128e394;
    var $0472b42fd573a861$export$6448e42458359282;
    var $0472b42fd573a861$export$8fc2859090092516;
    var $0472b42fd573a861$export$5b235e02afd947a8;
    var $0472b42fd573a861$export$7f37be09c0fafa00;
    var $0472b42fd573a861$export$d6c3a1a50fade065;
    var $0472b42fd573a861$export$2c2896b483654bfa;
    var $0472b42fd573a861$export$c7187bbd1a7a9244;
    var $0472b42fd573a861$export$97e11c0b0230f130;
    var $0472b42fd573a861$export$95dbe49e85b16cc7;
    var $0472b42fd573a861$export$409b770e9b28d1a3;
    var $0472b42fd573a861$export$5fb402ec83a32662;
    var $0472b42fd573a861$export$c4493537ac0c5f1c;
    $0472b42fd573a861$export$976523451128e394 = `pnFITa_childrenWrapper`;
    $0472b42fd573a861$export$6448e42458359282 = `pnFITa_childrenWrapperWithRollupValue`;
    $0472b42fd573a861$export$8fc2859090092516 = `pnFITa_disabledRollup`;
    $0472b42fd573a861$export$5b235e02afd947a8 = `pnFITa_disabledRollupWrapper`;
    $0472b42fd573a861$export$7f37be09c0fafa00 = `pnFITa_onlyRollup`;
    $0472b42fd573a861$export$d6c3a1a50fade065 = `pnFITa_onlyRollupReadOnly`;
    $0472b42fd573a861$export$2c2896b483654bfa = `pnFITa_openedRollup`;
    $0472b42fd573a861$export$c7187bbd1a7a9244 = `pnFITa_placeholder`;
    $0472b42fd573a861$export$97e11c0b0230f130 = `pnFITa_rollup`;
    $0472b42fd573a861$export$95dbe49e85b16cc7 = `pnFITa_rollupSmartLink`;
    $0472b42fd573a861$export$409b770e9b28d1a3 = `pnFITa_rollupValue`;
    $0472b42fd573a861$export$5fb402ec83a32662 = `pnFITa_rollupWrapper`;
    $0472b42fd573a861$export$c4493537ac0c5f1c = `pnFITa_selectRollupContainer`;
});
parcelRegister("8QHq4", function(module, exports) {
    $parcel$export(module.exports, "UserSelectItem", ()=>$714d381e165b4d72$export$7f3c0720363a56f3);
    $parcel$export(module.exports, "formatOptionLabel", ()=>$714d381e165b4d72$export$322216d90ffb8d0e);
    $parcel$export(module.exports, "default", ()=>$714d381e165b4d72$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1sWm7 = parcelRequire("1sWm7");
    var $chc6P = parcelRequire("chc6P");
    var $80afZ = parcelRequire("80afZ");
    var $5XLFM = parcelRequire("5XLFM");
    var $b1yMp;
    var $8ibtc;
    var $jVZZA;
    var $3DBzg;
    var $fkC9P;
    var $4Rr1a;
    var $b8GVJ;
    var $k4L9z;
    var $hpnKp;
    var $ujWmd;
    var $iqIcG;
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $eQu06 = parcelRequire("eQu06");
    var $4TdTJ = parcelRequire("4TdTJ");
    const $714d381e165b4d72$export$7f3c0720363a56f3 = ({ icon: icon, email: email, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eQu06.option
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eQu06.optionAvatar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "small",
            src: icon,
            borderColor: "transparent"
        })), email && label ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, label), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eQu06.optionEmail
        }, email)) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eQu06.optionUnassigned
        }, label));
    const $714d381e165b4d72$export$322216d90ffb8d0e = (opt, { context: context })=>context === 'value' ? (0, (0, parcelRequire("iqIcG")).selectOptionWithAvatar)(opt) : (0, ($parcel$interopDefault($5uXOq))).createElement($714d381e165b4d72$export$7f3c0720363a56f3, opt);
    class $714d381e165b4d72$var$UserPicker extends (0, $5uXOq.Component) {
        getDisplayedUsers(userOptions, query) {
            const { maxOptionsPerGroup: maxOptionsPerGroup } = this.props;
            if (maxOptionsPerGroup) {
                const getFullText = (0, parcelRequire("b1yMp")).default((0, parcelRequire("hpnKp")).default, (0, parcelRequire("fkC9P")).default(' '), (0, parcelRequire("b8GVJ")).default([
                    'label',
                    'email'
                ]));
                const matchQuery = (0, parcelRequire("8ibtc")).default((query, option)=>(0, parcelRequire("3DBzg")).default((0, parcelRequire("hpnKp")).default(query))(getFullText(option)));
                const transformOptions = (0, parcelRequire("b1yMp")).default((0, parcelRequire("k4L9z")).default(maxOptionsPerGroup), (array)=>query ? (0, parcelRequire("jVZZA")).default(matchQuery(query), array) : array);
                return (0, $4TdTJ.isGroupedOptions)(userOptions) ? (0, parcelRequire("4Rr1a")).default(({ options: options, ...rest })=>({
                        options: transformOptions(options),
                        ...rest
                    }))(userOptions) : transformOptions(userOptions);
            }
            return userOptions;
        }
        render() {
            const { FieldSelect: FieldSelect, user: user, userList: userList, selectProps: selectProps, issueId: issueId, attribute: attribute, placeholder: placeholder } = this.props;
            const currentUserValue = user?.value || '';
            const selectedUser = (0, $4TdTJ.isGroupedOptions)(userList) ? (0, ($parcel$interopDefault($1sWm7)))((0, ($parcel$interopDefault($chc6P)))((0, ($parcel$interopDefault($80afZ)))(userList, 'options')), (0, ($parcel$interopDefault($5XLFM)))('value', currentUserValue)) : (0, ($parcel$interopDefault($1sWm7)))(userList, (0, ($parcel$interopDefault($5XLFM)))('value', currentUserValue));
            const onQuerySearch = (query, { action: action })=>{
                if (action === 'input-change') {
                    const { onFetchUserList: onFetchUserList } = this.props;
                    onFetchUserList(query);
                    this.setState(()=>({
                            query: query
                        }));
                }
            };
            const props = {
                formatOptionLabel: $714d381e165b4d72$export$322216d90ffb8d0e,
                options: this.getDisplayedUsers(userList, this.state.query),
                onChange: this.onUserChange,
                onMenuOpen: this.onMenuOpen,
                onMenuClose: this.onMenuClose,
                onInputChange: onQuerySearch,
                value: (0, $4nDwW.isDefined)(selectedUser) ? selectedUser : null,
                issueId: issueId,
                attribute: attribute,
                filterOption: $4TdTJ.filterOption,
                placeholder: placeholder,
                ...selectProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(FieldSelect, props);
        }
        constructor(...args){
            super(...args);
            this.state = {
                query: ''
            };
            this.onUserChange = (selection)=>{
                const { onUserChange: onUserChange } = this.props;
                if (selection && typeof selection.value === 'string') onUserChange(selection.value);
                else onUserChange(null);
            };
            this.onMenuOpen = ()=>{
                const { onFetchUserList: onFetchUserList, updateUserOption: updateUserOption, user: user } = this.props;
                onFetchUserList('');
                if ((0, $4nDwW.isDefined)(updateUserOption)) updateUserOption(user && user.value);
            };
            this.onMenuClose = ()=>{
                this.setState(()=>({
                        query: ''
                    }));
            };
        }
    }
    var $714d381e165b4d72$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        FieldSelect: (0, $ixSW4.slots).FieldSelect
    })($714d381e165b4d72$var$UserPicker);
});
parcelRegister("1sWm7", function(module, exports) {
    var $bptzf = parcelRequire("bptzf");
    var $fW7cr = parcelRequire("fW7cr");
    var $1115ac3ae60cc7bc$var$find = $bptzf($fW7cr);
    module.exports = $1115ac3ae60cc7bc$var$find;
});
parcelRegister("bptzf", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $hTJwX = parcelRequire("hTJwX");
    var $66FNL = parcelRequire("66FNL");
    function $84e8f705a13e859f$var$createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
            var iterable = Object(collection);
            if (!$hTJwX(collection)) {
                var iteratee = $bxDef(predicate, 3);
                collection = $66FNL(collection);
                predicate = function(key) {
                    return iteratee(iterable[key], key, iterable);
                };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
        };
    }
    module.exports = $84e8f705a13e859f$var$createFind;
});
parcelRegister("fW7cr", function(module, exports) {
    var $b5dwA = parcelRequire("b5dwA");
    var $bxDef = parcelRequire("bxDef");
    var $kPZpS = parcelRequire("kPZpS");
    var $b9a1db7d7901532f$var$nativeMax = Math.max;
    function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) return -1;
        var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
        if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
        return $b5dwA(array, $bxDef(predicate, 3), index);
    }
    module.exports = $b9a1db7d7901532f$var$findIndex;
});
parcelRegister("5XLFM", function(module, exports) {
    var $7MmCC = parcelRequire("7MmCC");
    var $cd4kg = parcelRequire("cd4kg");
    var $45777148468b4b4e$var$CLONE_DEEP_FLAG = 1;
    function $45777148468b4b4e$var$matchesProperty(path, srcValue) {
        return $cd4kg(path, $7MmCC(srcValue, $45777148468b4b4e$var$CLONE_DEEP_FLAG));
    }
    module.exports = $45777148468b4b4e$var$matchesProperty;
});
parcelRegister("8ibtc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6098e6e3fc565bb3$export$2e2bcd8739ae039);
    var $ccUYa;
    var $9J1HQ;
    var $6098e6e3fc565bb3$var$curry = (0, (0, parcelRequire("ccUYa")).default)(function curry(fn) {
        return (0, (0, parcelRequire("9J1HQ")).default)(fn.length, fn);
    });
    var $6098e6e3fc565bb3$export$2e2bcd8739ae039 = $6098e6e3fc565bb3$var$curry;
});
parcelRegister("k4L9z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9d8c20c101469c5$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5DTpU;
    var $lipUa;
    var $blU6m;
    var $e9d8c20c101469c5$var$take = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("5DTpU")).default)([
        'take'
    ], (0, (0, parcelRequire("lipUa")).default), function take(n, xs) {
        return (0, (0, parcelRequire("blU6m")).default)(0, n < 0 ? Infinity : n, xs);
    }));
    var $e9d8c20c101469c5$export$2e2bcd8739ae039 = $e9d8c20c101469c5$var$take;
});
parcelRegister("lipUa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f80f5f98e070f6d1$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7C2oN;
    var $7D5kn;
    var $f80f5f98e070f6d1$var$XTake = function() {
        function XTake(n, xf) {
            this.xf = xf;
            this.n = n;
            this.i = 0;
        }
        XTake.prototype['@@transducer/init'] = (0, (0, parcelRequire("7D5kn")).default).init;
        XTake.prototype['@@transducer/result'] = (0, (0, parcelRequire("7D5kn")).default).result;
        XTake.prototype['@@transducer/step'] = function(result, input) {
            this.i += 1;
            var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
            return this.n >= 0 && this.i >= this.n ? (0, (0, parcelRequire("7C2oN")).default)(ret) : ret;
        };
        return XTake;
    }();
    var $f80f5f98e070f6d1$var$_xtake = (0, (0, parcelRequire("c9RLn")).default)(function _xtake(n, xf) {
        return new $f80f5f98e070f6d1$var$XTake(n, xf);
    });
    var $f80f5f98e070f6d1$export$2e2bcd8739ae039 = $f80f5f98e070f6d1$var$_xtake;
});
parcelRegister("eQu06", function(module, exports) {
    $parcel$export(module.exports, "option", ()=>$aced318564927654$export$a75d1723e6bda2ec, (v)=>$aced318564927654$export$a75d1723e6bda2ec = v);
    $parcel$export(module.exports, "optionAvatar", ()=>$aced318564927654$export$74d139e8e4ac3515, (v)=>$aced318564927654$export$74d139e8e4ac3515 = v);
    $parcel$export(module.exports, "optionEmail", ()=>$aced318564927654$export$a1cdb2bb0f192cfd, (v)=>$aced318564927654$export$a1cdb2bb0f192cfd = v);
    $parcel$export(module.exports, "optionUnassigned", ()=>$aced318564927654$export$4b31fbead0475bc4, (v)=>$aced318564927654$export$4b31fbead0475bc4 = v);
    var $aced318564927654$export$a75d1723e6bda2ec;
    var $aced318564927654$export$74d139e8e4ac3515;
    var $aced318564927654$export$a1cdb2bb0f192cfd;
    var $aced318564927654$export$4b31fbead0475bc4;
    $aced318564927654$export$a75d1723e6bda2ec = `NKUPUW_option`;
    $aced318564927654$export$74d139e8e4ac3515 = `NKUPUW_optionAvatar`;
    $aced318564927654$export$a1cdb2bb0f192cfd = `NKUPUW_optionEmail`;
    $aced318564927654$export$4b31fbead0475bc4 = `NKUPUW_optionUnassigned`;
});
parcelRegister("4TdTJ", function(module, exports) {
    $parcel$export(module.exports, "isGroupedOptions", ()=>$8ca07b7e446b8abc$export$16eb355a03e2df95);
    $parcel$export(module.exports, "filterOption", ()=>$8ca07b7e446b8abc$export$9ec48f819895657b);
    var $b1yMp;
    var $8ibtc;
    var $3DBzg;
    var $fkC9P;
    var $2rMKg;
    var $b8GVJ;
    var $hpnKp;
    var $6cslg;
    const $8ca07b7e446b8abc$export$16eb355a03e2df95 = (options = [])=>options.some((el)=>'options' in el);
    const $8ca07b7e446b8abc$export$9ec48f819895657b = (candidate, input)=>{
        if (input) {
            const getFullText = (0, parcelRequire("b1yMp")).default((0, parcelRequire("hpnKp")).default, (0, parcelRequire("fkC9P")).default(' '), (0, parcelRequire("b8GVJ")).default([
                'label',
                'value',
                'email'
            ]), (0, parcelRequire("2rMKg")).default('data'));
            const matchQuery = (0, parcelRequire("8ibtc")).default((query, option)=>(0, parcelRequire("3DBzg")).default((0, parcelRequire("6cslg")).default((0, parcelRequire("hpnKp")).default(query)))(getFullText(option)));
            return matchQuery(input, candidate);
        }
        return true;
    };
});
parcelRegister("fbVhf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b364a254fa9fb08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    parcelRequire("kKX9u");
    var $ousew;
    var $35DHi;
    var $dAB51 = parcelRequire("dAB51");
    var $fQqna = parcelRequire("fQqna");
    var $hijPv = parcelRequire("hijPv");
    var $9equ5 = parcelRequire("9equ5");
    var $4eyJU = parcelRequire("4eyJU");
    var $dLSrE = parcelRequire("dLSrE");
    var $jtvPP = parcelRequire("jtvPP");
    var $hIIRC = parcelRequire("hIIRC");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $l8ruj;
    var $cDVLS;
    var $2QgzU;
    const $0b364a254fa9fb08$var$HeaderBar = ()=>{
        const [headerMode, setHeaderMode] = (0, $5uXOq.useState)('visible');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, headerMode !== 'hidden' && (0, ($parcel$interopDefault($5uXOq))).createElement($0b364a254fa9fb08$var$HeaderContent, null, headerMode !== 'toolbar' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4eyJU.default), {
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2QgzU")).default).timeline),
            titleDecorators: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jtvPP.default), null),
            actions: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("35DHi")).FeedbackButtonLazyComponent), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hIIRC.default), {
                confluenceMacroType: (0, $TTKUQ.TIMELINE_SHARE_TYPE)
            })),
            showPlanTitle: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dLSrE.default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9equ5.default), {
            mode: headerMode,
            setMode: setHeaderMode
        }));
    };
    const $0b364a254fa9fb08$var$PlanReport = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "plan-report-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cDVLS")).ReportAppBase), {
            withReduxStore: true,
            paddingRight: false,
            paddingLeft: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dAB51.default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($0b364a254fa9fb08$var$HeaderContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0b364a254fa9fb08$var$HeaderBar, null)), (0, ($parcel$interopDefault($5uXOq))).createElement($0b364a254fa9fb08$var$RoadmapContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hijPv.default), props)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fQqna.default), null))));
    var $0b364a254fa9fb08$export$2e2bcd8739ae039 = $0b364a254fa9fb08$var$PlanReport;
    const $0b364a254fa9fb08$var$RoadmapContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_x3doi319 _1kl7i319 _13li1y44 _kqswh2mm _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _18u01ejb",
                __cmplp.className
            ])
        });
    });
    const $0b364a254fa9fb08$var$HeaderContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _19bv1ejb",
                __cmplp.className
            ])
        });
    });
    const $0b364a254fa9fb08$var$HeaderContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0q1ejb _u5f31ejb _1bchidpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kKX9u", function(module, exports) {
    const $f1c5fce03f5da046$var$style = document.createElement('style');
    $f1c5fce03f5da046$var$style.textContent = `:root{--jpo-common-base-spacing:8px;--jpo-common-min-app-width:1000px;--adg3-color-R50:#ffebe6;--adg3-color-R75:#ffbdad;--adg3-color-R100:#ff8f73;--adg3-color-R200:#ff7452;--adg3-color-R300:#ff5630;--adg3-color-R400:#de350b;--adg3-color-R500:#bf2600;--adg3-color-Y50:#fffae6;--adg3-color-Y75:#fff0b3;--adg3-color-Y100:#ffe380;--adg3-color-Y200:#ffc400;--adg3-color-Y300:#ffab00;--adg3-color-Y400:#ff991f;--adg3-color-Y500:#ff8b00;--adg3-color-G50:#e3fcef;--adg3-color-G75:#abf5d1;--adg3-color-G100:#79f2c0;--adg3-color-G200:#57d9a3;--adg3-color-G300:#36b37e;--adg3-color-G400:#00875a;--adg3-color-G500:#064;--adg3-color-B50:#deebff;--adg3-color-B75:#b3d4ff;--adg3-color-B100:#4c9aff;--adg3-color-B200:#2684ff;--adg3-color-B300:#0065ff;--adg3-color-B400:#0052cc;--adg3-color-B500:#0747a6;--adg3-color-P50:#eae6ff;--adg3-color-P75:#c0b6f2;--adg3-color-P100:#998dd9;--adg3-color-P200:#8777d9;--adg3-color-P300:#6554c0;--adg3-color-P400:#5243aa;--adg3-color-P500:#403294;--adg3-color-T50:#e6fcff;--adg3-color-T75:#b3f5ff;--adg3-color-T100:#79e2f2;--adg3-color-T200:#00c7e6;--adg3-color-T300:#00b8d9;--adg3-color-T400:#00a3bf;--adg3-color-T500:#008da6;--adg3-color-N0:#fff;--adg3-color-N10:#fafbfc;--adg3-color-N20:#f4f5f7;--adg3-color-N30:#ebecf0;--adg3-color-N40:#dfe1e6;--adg3-color-N50:#c1c7d0;--adg3-color-N60:#b3bac5;--adg3-color-N70:#a5adba;--adg3-color-N80:#97a0af;--adg3-color-N90:#8993a4;--adg3-color-N100:#7a869a;--adg3-color-N200:#6b778c;--adg3-color-N300:#5e6c84;--adg3-color-N400:#505f79;--adg3-color-N500:#42526e;--adg3-color-N600:#344563;--adg3-color-N700:#253858;--adg3-color-N800:#172b4d;--adg3-color-N900:#091e42;--adg3-color-N10A:#091e4205;--adg3-color-N20A:#091e420a;--adg3-color-N30A:#091e4214;--adg3-color-N40A:#091e4221;--adg3-color-N50A:#091e4240;--adg3-color-N60A:#091e424f;--adg3-color-N70A:#091e425c;--adg3-color-N80A:#091e426b;--adg3-color-N90A:#091e427a;--adg3-color-N100A:#091e428a;--adg3-color-N200A:#091e4299;--adg3-color-N300A:#091e42a8;--adg3-color-N400A:#091e42b5;--adg3-color-N500A:#091e42c4;--adg3-color-N600A:#091e42d1;--adg3-color-N700A:#091e42e3;--adg3-color-N800A:#091e42f2;--adg3-color-DN900:#e6edfa;--adg3-color-DN800:#dce5f5;--adg3-color-DN700:#ced9eb;--adg3-color-DN600:#b8c7e0;--adg3-color-DN500:#abbbd6;--adg3-color-DN400:#9fb0cc;--adg3-color-DN300:#8c9cb8;--adg3-color-DN200:#7988a3;--adg3-color-DN100:#67758f;--adg3-color-DN90:#56637a;--adg3-color-DN80:#455166;--adg3-color-DN70:#3b475c;--adg3-color-DN60:#313d52;--adg3-color-DN50:#283447;--adg3-color-DN40:#202b3d;--adg3-color-DN30:#1b2638;--adg3-color-DN20:#121a29;--adg3-color-DN10:#0e1624;--adg3-color-DN0:#0d1424;--adg3-color-DN800A:#0d14240f;--adg3-color-DN700A:#0d142424;--adg3-color-DN600A:#0d14242e;--adg3-color-DN500A:#0d14244a;--adg3-color-DN400A:#0d14245c;--adg3-color-DN300A:#0d142466;--adg3-color-DN200A:#0d142478;--adg3-color-DN100A:#0d142487;--adg3-color-DN90A:#0d1424a1;--adg3-color-DN80A:#0d1424ba;--adg3-color-DN70A:#0d1424c7;--adg3-color-DN60A:#0d1424cf;--adg3-color-DN50A:#0d1424d9;--adg3-color-DN40A:#0d1424e3;--adg3-color-DN30A:#0d1424eb;--adg3-color-DN20A:#0d1424f2;--adg3-color-DN10A:#0d1424f7;--adg3-color-background-light:#fff;--adg3-color-background-dark:#1b2638;--adg3-color-text-light:#091e42;--adg3-color-text-dark:#b8c7e0;--adg3-color-subtleText-light:#5e6c84;--adg3-color-subtleText-dark:#8c9cb8;--adg3-color-placeholderText-light:#7a869a;--adg3-color-placeholderText-dark:#7988a3;--adg3-color-heading-light:#172b4d;--adg3-color-heading-dark:#b8c7e0;--adg3-color-subtleHeading-light:#5e6c84;--adg3-color-subtleHeading-dark:#8c9cb8;--adg3-color-codeBlock-light:#f4f5f7;--adg3-color-codeBlock-dark:#283447;--adg3-color-link-light:#0052cc;--adg3-color-link-dark:#4c9aff;--adg3-color-linkHover-light:#0065ff;--adg3-color-linkHover-dark:#2684ff;--adg3-color-linkActive-light:#0747a6;--adg3-color-linkActive-dark:#4c9aff;--adg3-color-linkOutline-light:#4c9aff;--adg3-color-linkOutline-dark:#2684ff;--adg3-color-primary-light:#0052cc;--adg3-color-primary-dark:#4c9aff;--adg3-color-blue-light:#0052cc;--adg3-color-blue-dark:#4c9aff;--adg3-color-teal-light:#00b8d9;--adg3-color-teal-dark:#00c7e6;--adg3-color-purple-light:#6554c0;--adg3-color-purple-dark:#998dd9;--adg3-color-red-light:#ff5630;--adg3-color-red-dark:#ff5630;--adg3-color-yellow-light:#ffab00;--adg3-color-yellow-dark:#ffab00;--adg3-color-green-light:#36b37e;--adg3-color-green-dark:#36b37e;--jpo-icon-size-small:16px;--jpo-icon-size-medium:24px;--jpo-icon-size-large:32px;--jpo-icon-size-xlarge:40px;--jpo-toolbar-dropdown-offset:290px;--jira-top-navigation-height:56px;--adg3-color-N20-transparent:#23375f0d;--jpo-spacing:var(--jpo-common-base-spacing);--jpo-theme-color:var(--adg3-color-B400);--jpo-text-default-color:var(--adg3-color-N800);--jpo-text-secondary-color:var(--adg3-color-N200);--jpo-text-muted-color:var(--adg3-color-N70);--jpo-text-error-color:var(--adg3-color-R400);--jpo-bg-default-color:var(--adg3-color-N0);--jpo-bg-reverse-color:var(--adg3-color-N20);--jpo-bg-warning-color:var(--adg3-color-Y50);--jpo-bg-dark-color:var(--adg3-color-N800);--jpo-border-default-color:var(--adg3-color-N50);--jpo-border-secondary-color:var(--adg3-color-N40);--jpo-z-index-date-tooltip:4;--jpo-z-index-dependency-marker-hovered:2;--jpo-z-index-dependency-marker:3;--jpo-z-index-dependency-bar:3;--jpo-z-index-dependency-arrow:3;--jpo-z-index-issue-arrow:3;--jpo-z-index-dependency-handle:10;--jpo-z-index-horizontal-scrolling-overlay:10000}`;
    document.querySelector('head').appendChild($f1c5fce03f5da046$var$style);
});
parcelRegister("35DHi", function(module, exports) {
    $parcel$export(module.exports, "FeedbackButtonLazyComponent", ()=>$b9660bade7a50212$export$e1559a22f6313482);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $3g1Fk;
    var $39xOx;
    var $ousew;
    var $lfTZh;
    var $kxZPA;
    var $9S3aT;
    const $b9660bade7a50212$var$FallbackComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3g1Fk"))))), {
                label: ""
            }),
            isDisabled: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("9S3aT")).default).giveFeedback));
    const $b9660bade7a50212$var$FeedbackButtonLazy = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("3z6Pi")).then((module)=>module.FeedbackButton), {
        moduleId: "./src/packages/portfolio-3/feedback-collector/src/ui/index.tsx"
    });
    const $b9660bade7a50212$export$e1559a22f6313482 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "advanced-roadmaps-plan.feedback-collector",
            packageName: "jira-portfolio-3-feedback-collector",
            teamName: "axolotl",
            fallback: $b9660bade7a50212$var$FallbackComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "feedback-button",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($b9660bade7a50212$var$FallbackComponent, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b9660bade7a50212$var$FeedbackButtonLazy, null)));
});
parcelRegister("3g1Fk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
    function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>$25f4287f17f73dc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
        }, props, {
            newIcon: $25f4287f17f73dc4$var$_feedback.default
        }));
    $25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;
});
parcelRegister("5dqGX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3cc2df171aca9493$var$_UNSAFE_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3cc2df171aca9493$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3cc2df171aca9493$var$FeedbackIcon = (props)=>$3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
        }, props));
    $3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;
});
parcelRegister("9S3aT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e5920e982cb63c0f$export$2e2bcd8739ae039);
    var $7VHMR;
    const $e5920e982cb63c0f$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        canContactPrompt: {
            "id": "portfolio-3-feedback-collector.ui.can-contact-prompt",
            "defaultMessage": "Atlassian may contact me about this feedback."
        },
        canContactPromptLink: {
            "id": "portfolio-3-feedback-collector.ui.can-contact-prompt-link",
            "defaultMessage": "Privacy policy"
        },
        contactSupport: {
            "id": "portfolio-3-feedback-collector.ui.contact-support",
            "defaultMessage": "contact our support team"
        },
        enrollInResearchPrompt: {
            "id": "portfolio-3-feedback-collector.ui.enroll-in-research-prompt",
            "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
        },
        enrollInResearchLink: {
            "id": "portfolio-3-feedback-collector.ui.enroll-in-research-link",
            "defaultMessage": "Atlassian Research Group"
        },
        giveFeedback: {
            "id": "portfolio-3-feedback-collector.ui.give-feedback",
            "defaultMessage": "Give feedback"
        },
        reportBug: {
            "id": "portfolio-3-feedback-collector.ui.report-bug",
            "defaultMessage": "If you have technical issues or find a bug in {productName}, please {contactSupportLink}."
        },
        plansReportBug: {
            "id": "portfolio-3-feedback-collector.ui.plans-report-bug",
            "defaultMessage": "If you have technical issues or find a bug in Plans, please {contactSupportLink}."
        }
    });
    var $e5920e982cb63c0f$export$2e2bcd8739ae039 = $e5920e982cb63c0f$var$messages;
});
parcelRegister("3z6Pi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l28hf").then(()=>parcelRequire('65gdw'));
});
parcelRegister("dAB51", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$075eba14ebdbe865$export$2e2bcd8739ae039);
    var $bC2fB;
    var $18LRd = parcelRequire("18LRd");
    var $8GfFp = parcelRequire("8GfFp");
    var $075eba14ebdbe865$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $18LRd.default), {})((0, $8GfFp.default));
});
parcelRegister("18LRd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f47cc7f75238a9c9$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $bzvH1 = parcelRequire("bzvH1");
    const $f47cc7f75238a9c9$var$mapStateToProps = (state)=>({
            associatedIssueIds: (0, $bzvH1.getAssociatedIssueIds)(state),
            isConfluenceMacro: (0, $1CGdp.isConfluenceMacro)(state),
            isEmbed: (0, $1CGdp.isEmbed)(state)
        });
    var $f47cc7f75238a9c9$export$2e2bcd8739ae039 = $f47cc7f75238a9c9$var$mapStateToProps;
});
parcelRegister("bzvH1", function(module, exports) {
    $parcel$export(module.exports, "getAssociatedIssueIds", ()=>$97306a1631efea28$export$6f62a10975052989);
    var $3YtPS = parcelRequire("3YtPS");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $gFhwb = parcelRequire("gFhwb");
    var $97ucx = parcelRequire("97ucx");
    const $97306a1631efea28$export$6f62a10975052989 = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getIsIssuesLoading),
        (0, $gFhwb.getAllIssues),
        (0, $gFhwb.getOriginalIssues)
    ], (isIssuesLoading, issues, originalIssues)=>isIssuesLoading ? undefined : (0, $97ucx.getAllAssociatedIssueIds)(issues, originalIssues));
});
parcelRegister("97ucx", function(module, exports) {
    $parcel$export(module.exports, "getAllAssociatedIssueIds", ()=>$4aa655f4724ddbe0$export$97d04cf539fd55bd);
    const $4aa655f4724ddbe0$export$97d04cf539fd55bd = (issues, originalIssues)=>{
        const associatedIssuesIds = issues.map((issue)=>issue.associatedIssueIds || []).flat();
        const issuesIds = issues.map((issue)=>issue.id);
        const originalsIds = issuesIds.map((id)=>originalIssues[id]?.associatedIssueIds || []).flat();
        return Array.from(new Set([
            ...associatedIssuesIds,
            ...originalsIds
        ])) || [];
    };
});
parcelRegister("8GfFp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3b2cab1996aaccc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $pa9q9;
    var $koVbs;
    var $apXzN;
    var $koeKL;
    var $dxKiH = parcelRequire("dxKiH");
    var $bI449 = parcelRequire("bI449");
    const $f3b2cab1996aaccc$var$Wrapper = ({ associatedIssueIds: associatedIssueIds, children: children, isEmbed: isEmbed, isConfluenceMacro: isConfluenceMacro })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const intlApi = (0, (0, parcelRequire("koVbs")).default)();
        const isEmbedOrMacro = isConfluenceMacro || isEmbed;
        const isFlagAbleToShow = !isEmbedOrMacro && (0, (0, parcelRequire("co1wz")).ff)('polaris.possibility-of-updating-ideas-in-plans');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("apXzN")).AssociatedIssuesContainer), {
            associatedIssueIds: associatedIssueIds,
            cloudId: cloudId,
            showFlag: showFlag,
            intlApi: intlApi,
            isEmbedOrMacro: isEmbedOrMacro
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bI449.default), null), children, isFlagAbleToShow ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dxKiH.AssociatedIssuesChangeboardingFlag), null) : null);
    };
    var $f3b2cab1996aaccc$export$2e2bcd8739ae039 = $f3b2cab1996aaccc$var$Wrapper;
});
parcelRegister("apXzN", function(module, exports) {
    $parcel$export(module.exports, "AssociatedIssuesContainer", ()=>$77b21116d419d214$export$6b5d5209e8b70003);
    $parcel$export(module.exports, "initialState", ()=>$77b21116d419d214$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "useAssociatedIssues", ()=>$77b21116d419d214$export$170f0814c1650002);
    $parcel$export(module.exports, "useAssociatedIssuesInitialized", ()=>$77b21116d419d214$export$ab8985dd1a93b572);
    $parcel$export(module.exports, "useAssociatedIssuesState", ()=>$77b21116d419d214$export$5109766d3c29a7d);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $cHFln;
    var $jwsTD;
    const $77b21116d419d214$export$6b5d5209e8b70003 = (0, (0, parcelRequire("gg7kZ")).createContainer)();
    const $77b21116d419d214$var$handlers = {
        onInit: (0, (0, parcelRequire("cHFln")).loadMissingAssociatedIssues),
        onContainerUpdate: (0, (0, parcelRequire("cHFln")).loadMissingAssociatedIssues)
    };
    const $77b21116d419d214$export$d4c72bab9d6cc13a = {
        associatedIssues: undefined,
        lastAssociatedIssueIds: undefined
    };
    const $77b21116d419d214$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        containedBy: $77b21116d419d214$export$6b5d5209e8b70003,
        initialState: $77b21116d419d214$export$d4c72bab9d6cc13a,
        actions: {},
        handlers: $77b21116d419d214$var$handlers
    });
    const $77b21116d419d214$export$170f0814c1650002 = (0, (0, parcelRequire("3sQ5x")).createHook)($77b21116d419d214$var$Store, {
        selector: (0, (0, parcelRequire("jwsTD")).getAssociatedIssues)
    });
    const $77b21116d419d214$export$ab8985dd1a93b572 = (0, (0, parcelRequire("3sQ5x")).createHook)($77b21116d419d214$var$Store, {
        selector: (0, (0, parcelRequire("jwsTD")).getIsInitialized)
    });
    const $77b21116d419d214$export$5109766d3c29a7d = (0, (0, parcelRequire("3sQ5x")).createHook)($77b21116d419d214$var$Store);
});
parcelRegister("cHFln", function(module, exports) {
    $parcel$export(module.exports, "loadMissingAssociatedIssues", ()=>$8e611ee1aa1dcb66$export$7bf832faf9b09eb5);
    var $ajpes = parcelRequire("ajpes");
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $3f570;
    var $jwsTD;
    var $bQoWJ;
    const $8e611ee1aa1dcb66$var$getIssueIdsToFetch = (issueIds, availableIssues)=>{
        if (!issueIds || issueIds.length === 0) return [];
        if (!availableIssues) return issueIds;
        return issueIds.filter((id)=>!availableIssues[id]);
    };
    const $8e611ee1aa1dcb66$export$7bf832faf9b09eb5 = ()=>({ getState: getState, setState: setState }, { associatedIssueIds: associatedIssueIds, cloudId: cloudId, showFlag: showFlag, intlApi: intlApi, isEmbedOrMacro: isEmbedOrMacro })=>{
            if (!(0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') || (0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') && isEmbedOrMacro) {
                setState({
                    associatedIssues: {}
                });
                return;
            }
            if (!associatedIssueIds) return;
            if (getState().lastAssociatedIssueIds && (0, ($parcel$interopDefault($ajpes)))(getState().lastAssociatedIssueIds, associatedIssueIds) && (0, (0, parcelRequire("4R6GH")).fg)('polaris-arj-ideas-limit')) return;
            const issueIdsToFetch = $8e611ee1aa1dcb66$var$getIssueIdsToFetch(associatedIssueIds || [], (0, (0, parcelRequire("jwsTD")).getAssociatedIssues)(getState()));
            if (issueIdsToFetch.length === 0) {
                if ((0, (0, parcelRequire("jwsTD")).getAssociatedIssues)(getState()) === undefined) setState({
                    associatedIssues: {}
                });
                return;
            }
            if ((0, (0, parcelRequire("4R6GH")).fg)('polaris-arj-ideas-limit')) {
                (0, (0, parcelRequire("3f570")).fetchAssociatedIssuesById)(issueIdsToFetch, cloudId).then((fetchResult)=>{
                    setState({
                        associatedIssues: {
                            ...(0, (0, parcelRequire("jwsTD")).getAssociatedIssues)(getState()),
                            ...fetchResult.associatedIssues
                        }
                    });
                    if (fetchResult.appliedLimit) {
                        showFlag({
                            type: 'error',
                            id: 'jpd-ideas-in-plans-fetch-limit',
                            key: 'jpd-ideas-in-plans-fetch-limit',
                            title: intlApi.formatMessage((0, (0, parcelRequire("bQoWJ")).default).fetchLimitErrorFlagTitle),
                            description: intlApi.formatMessage((0, (0, parcelRequire("bQoWJ")).default).fetchLimitErrorFlagDescription)
                        });
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                packageName: 'jiraPortfolio3AssociatedIssues',
                                id: 'fetchAssociatedIssuesLimitExceeded',
                                teamName: 'jpd-juno'
                            },
                            attributes: {
                                requestedIssues: issueIdsToFetch.length
                            },
                            error: new Error('Ideas fetch limit exceeded'),
                            sendToPrivacyUnsafeSplunk: false
                        });
                    }
                }).catch((error)=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('polaris.possibility-of-updating-ideas-in-plans')) showFlag({
                        type: 'error',
                        id: 'jpd-ideas-in-plans-error',
                        key: 'jpd-ideas-in-plans-error',
                        title: intlApi.formatMessage((0, (0, parcelRequire("bQoWJ")).default).errorFlagTitle),
                        description: intlApi.formatMessage((0, (0, parcelRequire("bQoWJ")).default).errorFlagDescription)
                    });
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            packageName: 'jiraPortfolio3AssociatedIssues',
                            id: 'fetchAssociatedIssues',
                            teamName: 'jpd-juno'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: false
                    });
                });
                return;
            }
            (0, (0, parcelRequire("3f570")).fetchAssociatedIssues)(issueIdsToFetch, cloudId).then((fetchedIssues)=>{
                setState({
                    associatedIssues: {
                        ...(0, (0, parcelRequire("jwsTD")).getAssociatedIssues)(getState()),
                        ...fetchedIssues
                    }
                });
            }).catch((error)=>{
                setState({
                    associatedIssues: {}
                });
                if ((0, (0, parcelRequire("co1wz")).ff)('polaris.possibility-of-updating-ideas-in-plans')) showFlag({
                    type: 'error',
                    id: 'jpd-ideas-in-plans-error',
                    key: 'jpd-ideas-in-plans-error',
                    title: intlApi.formatMessage((0, (0, parcelRequire("bQoWJ")).default).errorFlagTitle),
                    description: intlApi.formatMessage((0, (0, parcelRequire("bQoWJ")).default).errorFlagDescription)
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        packageName: 'jiraPortfolio3AssociatedIssues',
                        id: 'fetchAssociatedIssues',
                        teamName: 'jpd-juno'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: false
                });
            });
        };
});
parcelRegister("3f570", function(module, exports) {
    $parcel$export(module.exports, "fetchAssociatedIssues", ()=>$77539b25520802d4$export$2fa93be020e5415c);
    $parcel$export(module.exports, "fetchAssociatedIssuesById", ()=>$77539b25520802d4$export$ac97ba023e842f8c);
    $parcel$export(module.exports, "fetchAssociatedIssuesForSelectOptions", ()=>$77539b25520802d4$export$abe9b440cc672132);
    var $d0qLr;
    var $azYnG = parcelRequire("azYnG");
    var $e4v2N = parcelRequire("e4v2N");
    var $kGsr8 = parcelRequire("kGsr8");
    var $8Uumt = parcelRequire("8Uumt");
    var $dJl1T;
    var $co1wz;
    var $jJZqs;
    var $5yJb9;
    var $5a0Nh;
    var $d0qLr;
    var $7iPAQ;
    const $77539b25520802d4$var$MAX_ISSUES = 50;
    const $77539b25520802d4$var$handleResponse = (data)=>{
        const associatedIssues = {};
        data?.jira?.issueSearchStable?.edges?.forEach((edge)=>{
            const id = edge?.node?.issueId;
            const key = edge?.node?.key;
            const summary = edge?.node?.summaryField?.text;
            const iconUrl = edge?.node?.issueTypeField?.issueType?.avatar?.medium;
            if (!id || !key || !summary || !iconUrl) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('portfolio-3.associated-issues.invalid-data', 'Invalid data received.');
                return;
            }
            associatedIssues[id] = {
                id: id,
                key: key,
                summary: summary,
                iconUrl: iconUrl
            };
        });
        return associatedIssues;
    };
    const $77539b25520802d4$var$fetchAssociatedIssuesChunk = (cloudId, jql)=>new Promise((resolve, reject)=>{
            const errorCollector = (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)();
            (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("d0qLr")).default), {
                cloudId: cloudId,
                jql: jql,
                limit: $77539b25520802d4$var$MAX_ISSUES
            }).toPromise().then((data)=>{
                if (!(0, (0, parcelRequire("co1wz")).ff)('polaris.possibility-of-updating-ideas-in-plans')) {
                    (0, (0, parcelRequire("5a0Nh")).stopCaptureGraphQlErrors)(errorCollector);
                    return resolve($77539b25520802d4$var$handleResponse(data));
                }
                const servicesAssociatedIssueOperationName = (0, (0, parcelRequire("d0qLr")).default).params.name;
                const { isError: isError, isPermissionError: isPermissionError, cause: cause, statusCode: statusCode } = (0, (0, parcelRequire("7iPAQ")).getErrorsAndStopCapture)(errorCollector, servicesAssociatedIssueOperationName);
                if (!isError && data?.jira?.issueSearchStable) {
                    const associatedIssuesData = $77539b25520802d4$var$handleResponse(data);
                    resolve(associatedIssuesData);
                } else if (isPermissionError) resolve({});
                else reject(new (0, (0, parcelRequire("jJZqs")).ValidationError)(cause ?? 'Error fetching ideas', [], statusCode));
            });
        });
    const $77539b25520802d4$export$2fa93be020e5415c = (ids, cloudId)=>{
        if (ids.length === 0) return Promise.resolve({});
        if (ids.length > $77539b25520802d4$var$MAX_ISSUES * (0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('polaris-limit-ideas-loaded-in-arj-plan-integration', 20)) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('portfolio-3.associated-issues.limit-exceeded', 'Ideas not loaded because limit exceeded.');
            return Promise.resolve({});
        }
        return Promise.all((0, ($parcel$interopDefault($azYnG)))(ids, $77539b25520802d4$var$MAX_ISSUES).map((idChunk)=>$77539b25520802d4$var$fetchAssociatedIssuesChunk(cloudId, `id in (${idChunk.join(',')}) AND projectType = ${(0, (0, parcelRequire("7iPAQ")).PROJECT_TYPE)}`))).then((results)=>{
            const allAssociatedIssues = {};
            results.forEach((associatedIssues)=>{
                Object.assign(allAssociatedIssues, associatedIssues);
            });
            return allAssociatedIssues;
        });
    };
    const $77539b25520802d4$export$ac97ba023e842f8c = (ids, cloudId)=>{
        if (ids.length === 0) return Promise.resolve({
            associatedIssues: {}
        });
        const issueFetchLimit = $77539b25520802d4$var$MAX_ISSUES * (0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('polaris-limit-ideas-loaded-in-arj-plan-integration', 20);
        const uniqueIds = (0, ($parcel$interopDefault($kGsr8)))(ids);
        return Promise.all((0, ($parcel$interopDefault($azYnG)))((0, ($parcel$interopDefault($e4v2N)))(uniqueIds, issueFetchLimit), $77539b25520802d4$var$MAX_ISSUES).map((idChunk)=>$77539b25520802d4$var$fetchAssociatedIssuesChunk(cloudId, `id in (${idChunk.join(',')}) AND projectType = ${(0, (0, parcelRequire("7iPAQ")).PROJECT_TYPE)}`))).then((results)=>{
            const associatedIssues = {};
            results.forEach((result)=>{
                Object.assign(associatedIssues, result);
            });
            return {
                associatedIssues: associatedIssues,
                appliedLimit: uniqueIds.length > issueFetchLimit ? issueFetchLimit : undefined
            };
        });
    };
    const $77539b25520802d4$export$abe9b440cc672132 = (cloudId, query = '')=>$77539b25520802d4$var$fetchAssociatedIssuesChunk(cloudId, (0, (0, parcelRequire("7iPAQ")).createJqlQuery)(query));
});
parcelRegister("d0qLr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26787fde547aaa19$export$2e2bcd8739ae039);
    const $26787fde547aaa19$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "jql"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "limit"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "limit"
            },
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "jql",
                        "variableName": "jql"
                    }
                ],
                "kind": "ObjectValue",
                "name": "issueSearchInput"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "issueId"
        }, v3 = {
            "kind": "ScalarField",
            "name": "key"
        }, v4 = {
            "kind": "ScalarField",
            "name": "text"
        }, v5 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "medium"
                }
            ]
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "servicesAssociatedIssuesDataQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issueSearchStable",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2,
                                                    v3,
                                                    {
                                                        "concreteType": "JiraSingleLineTextField",
                                                        "kind": "LinkedField",
                                                        "name": "summaryField",
                                                        "plural": false,
                                                        "selections": [
                                                            v4
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v5
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "servicesAssociatedIssuesDataQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issueSearchStable",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2,
                                                    v3,
                                                    {
                                                        "concreteType": "JiraSingleLineTextField",
                                                        "kind": "LinkedField",
                                                        "name": "summaryField",
                                                        "plural": false,
                                                        "selections": [
                                                            v4,
                                                            v6
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v5,
                                                                    v6
                                                                ]
                                                            },
                                                            v6
                                                        ]
                                                    },
                                                    v6
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "295e9c13dcaba5fbc89c35438bd5aa7c8b062d06e38ceb609d20bdd567686b27",
                "metadata": {},
                "name": "servicesAssociatedIssuesDataQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $26787fde547aaa19$var$node.hash = "2ce662069ab8b60463b1f7ee3b63ae5e";
    var $26787fde547aaa19$export$2e2bcd8739ae039 = $26787fde547aaa19$var$node;
});
parcelRegister("e4v2N", function(module, exports) {
    var $dM3Z8 = parcelRequire("dM3Z8");
    var $kPZpS = parcelRequire("kPZpS");
    function $a3e985251d714418$var$take(array, n, guard) {
        if (!(array && array.length)) return [];
        n = guard || n === undefined ? 1 : $kPZpS(n);
        return $dM3Z8(array, 0, n < 0 ? 0 : n);
    }
    module.exports = $a3e985251d714418$var$take;
});
parcelRegister("7iPAQ", function(module, exports) {
    $parcel$export(module.exports, "getErrorsAndStopCapture", ()=>$fa7216cf3cc65530$export$cc7e5b414054bb76);
    $parcel$export(module.exports, "PROJECT_TYPE", ()=>$fa7216cf3cc65530$export$91a9dba2d38d9a6f);
    $parcel$export(module.exports, "createJqlQuery", ()=>$fa7216cf3cc65530$export$dc828f1bc2893f5c);
    var $gccSB = parcelRequire("gccSB");
    var $5a0Nh;
    const $fa7216cf3cc65530$var$getGraphQLErrorsForOperation = (errorCollector, operationName)=>{
        const errorsWithMeta = (0, (0, parcelRequire("5a0Nh")).stopCaptureGraphQlErrors)(errorCollector);
        if (Array.isArray(errorsWithMeta)) return errorsWithMeta.filter((errorWithMeta)=>errorWithMeta.meta.operationName === operationName).flatMap((errorWithMeta)=>errorWithMeta.errors);
        return [];
    };
    const $fa7216cf3cc65530$export$cc7e5b414054bb76 = (errorCollector, graphQLOperationName)=>{
        const relevantErrors = $fa7216cf3cc65530$var$getGraphQLErrorsForOperation(errorCollector, graphQLOperationName);
        const isError = relevantErrors.length > 0;
        const isPermissionError = isError && relevantErrors.some((relevantError)=>relevantError?.extensions?.statusCode === 400);
        return {
            isError: isError,
            isPermissionError: isPermissionError,
            cause: relevantErrors[0]?.message ?? '',
            statusCode: relevantErrors[0]?.extensions?.statusCode
        };
    };
    const $fa7216cf3cc65530$export$91a9dba2d38d9a6f = 'product_discovery';
    const $fa7216cf3cc65530$var$isIssueKey = (query)=>query.match(/^[A-Za-z0-9]+-\d+$/) !== null;
    const $fa7216cf3cc65530$export$dc828f1bc2893f5c = (query)=>{
        const trimmedQuery = query.trim();
        if ((0, ($parcel$interopDefault($gccSB)))(trimmedQuery)) return `projectType=${$fa7216cf3cc65530$export$91a9dba2d38d9a6f}`;
        if ($fa7216cf3cc65530$var$isIssueKey(trimmedQuery)) return `projectType=${$fa7216cf3cc65530$export$91a9dba2d38d9a6f} AND (summary ~ '${trimmedQuery}*' OR issueKey = ${trimmedQuery})`;
        return `projectType=${$fa7216cf3cc65530$export$91a9dba2d38d9a6f} AND summary ~ '${trimmedQuery}*'`;
    };
});
parcelRegister("jwsTD", function(module, exports) {
    $parcel$export(module.exports, "getAssociatedIssues", ()=>$16d7d9d605f7666f$export$b5b4d0e5ac99bf25);
    $parcel$export(module.exports, "getIsInitialized", ()=>$16d7d9d605f7666f$export$837b9dcf8f380a60);
    const $16d7d9d605f7666f$export$b5b4d0e5ac99bf25 = (state)=>state.associatedIssues;
    const $16d7d9d605f7666f$export$837b9dcf8f380a60 = (state)=>state.associatedIssues !== undefined;
});
parcelRegister("bQoWJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e6b1704952551e1$export$2e2bcd8739ae039);
    var $7VHMR;
    const $5e6b1704952551e1$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "portfolio-3.associated-issues.src.controllers.action.error-flag-title",
            "defaultMessage": "Something went wrong"
        },
        errorFlagDescription: {
            "id": "portfolio-3.associated-issues.src.controllers.actions.error-flag.error-flag-description",
            "defaultMessage": "There was an error when loading ideas. Please try refreshing the page."
        },
        fetchLimitErrorFlagTitle: {
            "id": "portfolio-3-associated-issues.controllers.actions.fetch-limit-error-flag-title",
            "defaultMessage": "Limit exceeded"
        },
        fetchLimitErrorFlagDescription: {
            "id": "portfolio-3-associated-issues.controllers.actions.fetch-limit-error-flag-description",
            "defaultMessage": "We could not fetch all of the linked ideas for this plan."
        },
        errorFlagIconLabel: {
            "id": "portfolio-3.associated-issues.src.controllers.action.error-flag-icon-label",
            "defaultMessage": "Error"
        }
    });
    var $5e6b1704952551e1$export$2e2bcd8739ae039 = $5e6b1704952551e1$var$messages;
});
parcelRegister("dxKiH", function(module, exports) {
    $parcel$export(module.exports, "AssociatedIssuesChangeboardingFlag", ()=>$d070827fa2f4650d$export$bcb9e6cc5a736299);
    var $5uXOq = parcelRequire("5uXOq");
    var $3g1Fk;
    var $89SaW;
    var $jcw0u;
    var $4R6GH;
    var $d4xRU;
    var $3KRpp;
    var $koVbs;
    var $90yGq;
    var $hDzhb;
    var $doZTA;
    var $fhizA = parcelRequire("fhizA");
    const $d070827fa2f4650d$export$8483b5e317972371 = 'jpd.arjxideas.changeboarding.flag.dismiss';
    const $d070827fa2f4650d$var$READ_MORE_LINK = '';
    const $d070827fa2f4650d$var$JPD_LINK = '/issues/?jql=projectType=product_discovery order by created';
    const $d070827fa2f4650d$export$bcb9e6cc5a736299 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [isFlagAvailable, setIsFlagAvailable] = (0, $5uXOq.useState)(false);
        const [_, routerActions] = (0, (0, parcelRequire("doZTA")).useRouter)();
        (0, $5uXOq.useEffect)(()=>{
            const fetch = async ()=>{
                try {
                    await (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId ?? '', $d070827fa2f4650d$export$8483b5e317972371);
                } catch (error) {
                    if (error.statusCode === 404) setIsFlagAvailable(true);
                }
            };
            fetch();
        }, [
            accountId
        ]);
        const onDismissChangelogFlag = async ()=>{
            setIsFlagAvailable(false);
            try {
                await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId ?? '', $d070827fa2f4650d$export$8483b5e317972371, 'true');
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: `setUserProperties-${$d070827fa2f4650d$export$8483b5e317972371}`,
                        teamName: 'jpd-juno'
                    },
                    error: new Error('Cannot set user property.')
                });
            }
        };
        const description = formatMessage((0, $fhizA.default).changeboardingFlagDescription, {
            a: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
                    href: $d070827fa2f4650d$var$JPD_LINK,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, chunks)
        });
        const actions = (0, (0, parcelRequire("4R6GH")).fg)('polaris-hide-read-more-in-flag-for-arj-x-ideas') ? [
            {
                content: formatMessage((0, $fhizA.default).changeboardingFlagReadMore),
                onClick: ()=>routerActions.push($d070827fa2f4650d$var$READ_MORE_LINK)
            },
            {
                content: formatMessage((0, $fhizA.default).changeboardingFlagDismiss),
                onClick: onDismissChangelogFlag
            }
        ] : [
            {
                content: formatMessage((0, $fhizA.default).changeboardingFlagDismiss),
                onClick: onDismissChangelogFlag
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).FlagGroup), {
            onDismissed: onDismissChangelogFlag
        }, isFlagAvailable && accountId ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            id: "arjx-ideas-integration-changeboarding-flag",
            key: "arjx-ideas-integration-changeboarding-flag",
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3g1Fk"))))), {
                label: "",
                primaryColor: "var(--ds-text-accent-purple, #5E4DB2)"
            }),
            title: formatMessage((0, $fhizA.default).changeboardingFlagTitle),
            description: description,
            actions: actions
        }) : null);
    };
});
parcelRegister("d4xRU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61381db0e069bc03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $3KRpp;
    const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            flagType: "info",
            ...props
        }));
    var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $kxZPA;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("fhizA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ed8caa48b4f9df0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6ed8caa48b4f9df0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        changeboardingFlagTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.associated-issues-provider.associated-issues-changeboarding-flag.changeboarding-flag-title",
            "defaultMessage": "Filter or group linked work by ideas"
        },
        changeboardingFlagDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.associated-issues-provider.associated-issues-changeboarding-flag.changeboarding-flag-description",
            "defaultMessage": "<a>Ideas by Jira Product Discovery</a> will now show up in your plan as a field."
        },
        changeboardingFlagDismiss: {
            "id": "portfolio-3-portfolio.app-simple-plans.associated-issues-provider.associated-issues-changeboarding-flag.changeboarding-flag-dismiss",
            "defaultMessage": "Dismiss"
        },
        changeboardingFlagReadMore: {
            "id": "portfolio-3-portfolio.app-simple-plans.associated-issues-provider.associated-issues-changeboarding-flag.changeboarding-flag-read-more",
            "defaultMessage": "Read more"
        }
    });
});
parcelRegister("bI449", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8ecab6befda24df$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $apXzN;
    var $6wsPo = parcelRequire("6wsPo");
    var $bC2fB;
    const $a8ecab6befda24df$export$41d2efc46c436b3 = ({ setAssociatedIssues: dispatchSetAssociatedIssues })=>{
        const [state] = (0, (0, parcelRequire("apXzN")).useAssociatedIssuesState)();
        (0, $5uXOq.useEffect)(()=>{
            dispatchSetAssociatedIssues(state);
        }, [
            state,
            dispatchSetAssociatedIssues
        ]);
        return null;
    };
    var $a8ecab6befda24df$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, {
        setAssociatedIssues: $6wsPo.setAssociatedIssues
    })($a8ecab6befda24df$export$41d2efc46c436b3);
});
parcelRegister("6wsPo", function(module, exports) {
    $parcel$export(module.exports, "SET_ASSOCIATED_ISSUES", ()=>$b2819ea54085a98c$export$1b2d0726dc221500);
    $parcel$export(module.exports, "setAssociatedIssues", ()=>$b2819ea54085a98c$export$4a4b7cc83ed870e8);
    const $b2819ea54085a98c$export$1b2d0726dc221500 = 'state.domain.associated-issues.SET_ASSOCIATED_ISSUES';
    const $b2819ea54085a98c$export$4a4b7cc83ed870e8 = (payload)=>({
            type: $b2819ea54085a98c$export$1b2d0726dc221500,
            payload: payload
        });
});
parcelRegister("fQqna", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9535139e7881b243$export$2e2bcd8739ae039);
    var $bC2fB;
    var $2i5TZ = parcelRequire("2i5TZ");
    var $4FWOe = parcelRequire("4FWOe");
    var $15Ec0 = parcelRequire("15Ec0");
    var $9535139e7881b243$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $4FWOe.default), (0, $2i5TZ.default))((0, $15Ec0.default));
});
parcelRegister("2i5TZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3be8d1b7e4e2376d$export$2e2bcd8739ae039);
    var $fI3Hm = parcelRequire("fI3Hm");
    var $dBbgF = parcelRequire("dBbgF");
    const $3be8d1b7e4e2376d$var$mapDispatchToProps = {
        onDismissFlag: (0, $fI3Hm.dismissFlag),
        onChangeSort: (0, $dBbgF.changeSort)
    };
    var $3be8d1b7e4e2376d$export$2e2bcd8739ae039 = $3be8d1b7e4e2376d$var$mapDispatchToProps;
});
parcelRegister("fI3Hm", function(module, exports) {
    $parcel$export(module.exports, "ADD_FLAG", ()=>$383c545ea945743b$export$8db129480af5aa95);
    $parcel$export(module.exports, "PUSH_FLAG", ()=>$383c545ea945743b$export$23178c8e8290d2c3);
    $parcel$export(module.exports, "REMOVE_FLAG", ()=>$383c545ea945743b$export$f49894fce0f25653);
    $parcel$export(module.exports, "DISMISS_FLAG", ()=>$383c545ea945743b$export$1eb56620df104bf);
    $parcel$export(module.exports, "addFlag", ()=>$383c545ea945743b$export$820a1da46c7a4303);
    $parcel$export(module.exports, "pushFlag", ()=>$383c545ea945743b$export$5619f969d0372640);
    $parcel$export(module.exports, "removeFlag", ()=>$383c545ea945743b$export$f2c4075a13a8b485);
    $parcel$export(module.exports, "dismissFlag", ()=>$383c545ea945743b$export$900a08a292ad23cd);
    const $383c545ea945743b$export$8db129480af5aa95 = 'state.domain.flags.ADD_FLAG';
    const $383c545ea945743b$export$23178c8e8290d2c3 = 'state.domain.flags.PUSH_FLAG';
    const $383c545ea945743b$export$f49894fce0f25653 = 'state.domain.flags.REMOVE_FLAG';
    const $383c545ea945743b$export$1eb56620df104bf = 'state.domain.flags.DISMISS_FLAG';
    const $383c545ea945743b$export$820a1da46c7a4303 = (payload)=>({
            type: $383c545ea945743b$export$8db129480af5aa95,
            payload: payload
        });
    const $383c545ea945743b$export$5619f969d0372640 = (payload)=>({
            type: $383c545ea945743b$export$23178c8e8290d2c3,
            payload: payload
        });
    const $383c545ea945743b$export$f2c4075a13a8b485 = (payload)=>({
            type: $383c545ea945743b$export$f49894fce0f25653,
            payload: payload
        });
    const $383c545ea945743b$export$900a08a292ad23cd = (payload)=>({
            type: $383c545ea945743b$export$1eb56620df104bf,
            payload: payload
        });
});
parcelRegister("dBbgF", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$f5f41b60a858f493$export$4a991c87e640ef77);
    $parcel$export(module.exports, "CHANGE_GROUP", ()=>$f5f41b60a858f493$export$b4ef27f82439f936);
    $parcel$export(module.exports, "CHANGE_SORT", ()=>$f5f41b60a858f493$export$d7e9ddd59e8f46a1);
    $parcel$export(module.exports, "TOGGLE_EXPAND_GROUP", ()=>$f5f41b60a858f493$export$8078ee4dffbc67dd);
    $parcel$export(module.exports, "TOGGLE_SHOW_SPRINTS", ()=>$f5f41b60a858f493$export$3d122ed49958660e);
    $parcel$export(module.exports, "changeGroup", ()=>$f5f41b60a858f493$export$4574bce4737c2ea6);
    $parcel$export(module.exports, "changeSort", ()=>$f5f41b60a858f493$export$302198af71c74ff0);
    $parcel$export(module.exports, "toggleExpandGroup", ()=>$f5f41b60a858f493$export$e39ccd5e591a7b90);
    $parcel$export(module.exports, "toggleShowSprints", ()=>$f5f41b60a858f493$export$78af749f6ae1eb58);
    const $f5f41b60a858f493$export$4a991c87e640ef77 = 'state.domain.view-settings.visualisations.RESET';
    const $f5f41b60a858f493$export$b4ef27f82439f936 = 'state.domain.view-settings.visualisations.CHANGE_GROUP';
    const $f5f41b60a858f493$export$d7e9ddd59e8f46a1 = 'state.domain.view-settings.visualisations.CHANGE_SORT';
    const $f5f41b60a858f493$export$8078ee4dffbc67dd = 'state.domain.view-settings.visualisations.TOGGLE_EXPAND_GROUP';
    const $f5f41b60a858f493$export$3d122ed49958660e = 'state.domain.view-settings.visualisations.TOGGLE_SHOW_SPRINTS';
    const $f5f41b60a858f493$export$aad8462122ac592b = (payload)=>({
            type: $f5f41b60a858f493$export$4a991c87e640ef77,
            payload: payload
        });
    const $f5f41b60a858f493$export$4574bce4737c2ea6 = (payload)=>({
            type: $f5f41b60a858f493$export$b4ef27f82439f936,
            payload: payload
        });
    const $f5f41b60a858f493$export$302198af71c74ff0 = (payload)=>({
            type: $f5f41b60a858f493$export$d7e9ddd59e8f46a1,
            payload: payload
        });
    const $f5f41b60a858f493$export$e39ccd5e591a7b90 = (payload)=>({
            type: $f5f41b60a858f493$export$8078ee4dffbc67dd,
            payload: payload
        });
    const $f5f41b60a858f493$export$78af749f6ae1eb58 = (payload)=>({
            type: $f5f41b60a858f493$export$3d122ed49958660e,
            payload: payload
        });
});
parcelRegister("4FWOe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1dca42a7c70eba3c$export$2e2bcd8739ae039);
    var $3YtPS = parcelRequire("3YtPS");
    var $9wckG = parcelRequire("9wckG");
    var $j0XCX = parcelRequire("j0XCX");
    var $1dca42a7c70eba3c$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        flags: (0, $9wckG.getFlags),
        sorting: (0, $j0XCX.getVisualisationSorting)
    });
});
parcelRegister("9wckG", function(module, exports) {
    $parcel$export(module.exports, "getFlags", ()=>$836c2f31d9d5979e$export$d5815430bcc75df0);
    const $836c2f31d9d5979e$export$d5815430bcc75df0 = (state)=>state.domain.flags;
});
const $9e169ee721864a4b$export$42d68c08a5ace658 = 'state.domain.flags.ISSUE_LIMIT_WARNING';
const $9e169ee721864a4b$export$a1a68e80ebef1446 = 'state.domain.flags.PROJECT_LIMIT_WARNING';
const $9e169ee721864a4b$export$8a72c64e90d56fab = 'state.domain.flags.REPARENT_TMP_TO_EXTERNAL_WARNING';
const $9e169ee721864a4b$export$ac1a967dceae5708 = 'state.domain.flags.REPARENT_CMP_TO_TMP_WARNING';
const $9e169ee721864a4b$export$225669431bad5551 = 'state.domain.flags.ISSUE_SEARCH_WARNING';
const $9e169ee721864a4b$export$5d75f74c1d4d448d = 'state.domain.flags.SORTED_PREVENT_ISSUE_RANKING_WARNING';
const $9e169ee721864a4b$export$1c67cc6ab03450a2 = 'project-limit-exceeded';
const $9e169ee721864a4b$export$a23067a331938f15 = 'no-jira-software-access-for-user';
const $9e169ee721864a4b$export$f21a7cfcdb7aed8e = 'jpo-goals-error-flag';
parcelRegister("j0XCX", function(module, exports) {
    $parcel$export(module.exports, "getStickyHeaderScrollTop", ()=>$9c099cd6b30d8e09$export$20068a88fa6c5af7);
    $parcel$export(module.exports, "getVisualisationGrouping", ()=>$9c099cd6b30d8e09$export$6d374601688ff387);
    $parcel$export(module.exports, "getVisualisationSorting", ()=>$9c099cd6b30d8e09$export$8e2c99fad461c86f);
    $parcel$export(module.exports, "getShowSprints", ()=>$9c099cd6b30d8e09$export$6b80bdc7be3201ec);
    $parcel$export(module.exports, "getSprintsAreShown", ()=>$9c099cd6b30d8e09$export$7c3fd961263a77cc);
    $parcel$export(module.exports, "getColorByValue", ()=>$9c099cd6b30d8e09$export$f663f23222699c31);
    $parcel$export(module.exports, "getColourMaps", ()=>$9c099cd6b30d8e09$export$dc402cc25706a1d9);
    $parcel$export(module.exports, "getColourIssueTypes", ()=>$9c099cd6b30d8e09$export$5724381328eeee06);
    $parcel$export(module.exports, "getColourLabels", ()=>$9c099cd6b30d8e09$export$9b80d63cbee94715);
    $parcel$export(module.exports, "getColourComponents", ()=>$9c099cd6b30d8e09$export$2baa3bc0767a767b);
    $parcel$export(module.exports, "getColourPriorities", ()=>$9c099cd6b30d8e09$export$93dce55de70fbd71);
    $parcel$export(module.exports, "getColourSelects", ()=>$9c099cd6b30d8e09$export$138250857b33c4c9);
    $parcel$export(module.exports, "getColourByIssueTypeColourMap", ()=>$9c099cd6b30d8e09$export$dc50c92d9f08f06d);
    $parcel$export(module.exports, "getColourByLabelColourMap", ()=>$9c099cd6b30d8e09$export$1cbb1202b144d067);
    $parcel$export(module.exports, "getColourByComponentColourMap", ()=>$9c099cd6b30d8e09$export$49637d2c4b6ad582);
    $parcel$export(module.exports, "getColourByPriorityColourMap", ()=>$9c099cd6b30d8e09$export$679b944fd77daa3);
    $parcel$export(module.exports, "getColourBySelectColourMap", ()=>$9c099cd6b30d8e09$export$d1a26b5685d69490);
    $parcel$export(module.exports, "isColorByCustomFieldOption", ()=>$9c099cd6b30d8e09$export$f2e3afe6b51cb1fe);
    $parcel$export(module.exports, "getSelectOptionsFromIssues", ()=>$9c099cd6b30d8e09$export$33345bc5757ddb24);
    $parcel$export(module.exports, "getCustomFieldValuesGroups", ()=>$9c099cd6b30d8e09$export$bf794e171dc086eb);
    $parcel$export(module.exports, "isGroupByMultiValueCustomField", ()=>$9c099cd6b30d8e09$export$de65305314931ab0);
    $parcel$export(module.exports, "getCustomFieldValuesGroupsById", ()=>$9c099cd6b30d8e09$export$4cb7ee4ce12522c5);
    var $2JlG5;
    var $lV634;
    var $2rMKg;
    var $4R6GH;
    var $3J2mc;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $gITL8 = parcelRequire("gITL8");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $19iju = parcelRequire("19iju");
    var $gFhwb = parcelRequire("gFhwb");
    var $kWDpn = parcelRequire("kWDpn");
    var $dBbgF = parcelRequire("dBbgF");
    var $8pJHi = parcelRequire("8pJHi");
    const $9c099cd6b30d8e09$export$20068a88fa6c5af7 = (state)=>state.ui.Main.Tabs.Roadmap.StickyHeader.scrollTop;
    const $9c099cd6b30d8e09$export$6d374601688ff387 = (state)=>(0, $kWDpn.getVisualisationViewSettings)(state).grouping;
    const $9c099cd6b30d8e09$export$8e2c99fad461c86f = (state)=>(0, $kWDpn.getVisualisationViewSettings)(state).sorting;
    const $9c099cd6b30d8e09$export$6b80bdc7be3201ec = (state)=>(0, $kWDpn.getVisualisationViewSettings)(state).showSprints;
    const $9c099cd6b30d8e09$export$7c3fd961263a77cc = (state)=>{
        if ((0, $kWDpn.getViewMode)(state) !== (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE && (0, (0, parcelRequire("4R6GH")).fg)('sprint_stacking_filtering')) return false;
        return $9c099cd6b30d8e09$export$6b80bdc7be3201ec(state) && ($9c099cd6b30d8e09$export$6d374601688ff387(state) === (0, $TTKUQ.GROUPING).TEAM || $9c099cd6b30d8e09$export$6d374601688ff387(state) === (0, $TTKUQ.GROUPING).SPRINT);
    };
    const $9c099cd6b30d8e09$export$f663f23222699c31 = (state)=>(0, $kWDpn.getColorByViewSettings)(state).colourByValue;
    const $9c099cd6b30d8e09$export$dc402cc25706a1d9 = (state)=>(0, $kWDpn.getColorByViewSettings)(state).colourMaps;
    const $9c099cd6b30d8e09$export$cf14d565a2ef3c90 = (state)=>(0, $kWDpn.getColorByViewSettings)(state).lastUsed;
    const $9c099cd6b30d8e09$export$5724381328eeee06 = (state)=>(0, $kWDpn.getColorByViewSettings)(state).colourIssueTypes;
    const $9c099cd6b30d8e09$export$9b80d63cbee94715 = (state)=>(0, $kWDpn.getColorByViewSettings)(state).colourLabels;
    const $9c099cd6b30d8e09$export$2baa3bc0767a767b = (state)=>(0, $kWDpn.getColorByViewSettings)(state).colourComponents;
    const $9c099cd6b30d8e09$export$93dce55de70fbd71 = (state)=>(0, $kWDpn.getColorByViewSettings)(state).colourPriorities;
    const $9c099cd6b30d8e09$export$138250857b33c4c9 = (state)=>(0, $kWDpn.getColorByViewSettings)(state).colourSelects;
    const $9c099cd6b30d8e09$export$bb6b047bffa50ce5 = (colourIssueTypes)=>{
        const result = {};
        for (const { colour: colour, issueTypes: issueTypes } of colourIssueTypes){
            if (colour && issueTypes) for (const issueType of issueTypes)result[issueType] = colour;
        }
        return result;
    };
    const $9c099cd6b30d8e09$export$47c6097f7c97c7e7 = (colourLabels)=>{
        const result = {};
        for (const { colour: colour, labels: labels } of colourLabels){
            if (colour) for (const label of labels)result[label] = colour;
        }
        return result;
    };
    const $9c099cd6b30d8e09$export$9cb076f9ce17918f = (colourComponents)=>{
        const result = {};
        for (const { colour: colour, components: components } of colourComponents){
            if (colour) for (const component of components)result[component] = colour;
        }
        return result;
    };
    const $9c099cd6b30d8e09$export$9d7ac11983e3f8db = (colourPriorities = [])=>{
        const result = {};
        for (const { colour: colour, priorities: priorities } of colourPriorities){
            if (colour && priorities) for (const priority of priorities)result[priority] = colour;
        }
        return result;
    };
    const $9c099cd6b30d8e09$export$dc50c92d9f08f06d = (0, $3YtPS.createSelector)([
        $9c099cd6b30d8e09$export$5724381328eeee06
    ], $9c099cd6b30d8e09$export$bb6b047bffa50ce5);
    const $9c099cd6b30d8e09$export$1cbb1202b144d067 = (0, $3YtPS.createSelector)([
        $9c099cd6b30d8e09$export$9b80d63cbee94715
    ], $9c099cd6b30d8e09$export$47c6097f7c97c7e7);
    const $9c099cd6b30d8e09$export$49637d2c4b6ad582 = (0, $3YtPS.createSelector)([
        $9c099cd6b30d8e09$export$2baa3bc0767a767b
    ], $9c099cd6b30d8e09$export$9cb076f9ce17918f);
    const $9c099cd6b30d8e09$export$679b944fd77daa3 = (0, $3YtPS.createSelector)([
        $9c099cd6b30d8e09$export$93dce55de70fbd71
    ], $9c099cd6b30d8e09$export$9d7ac11983e3f8db);
    const $9c099cd6b30d8e09$export$2d7070b8c3d8a5fe = (colorByValue, colourOptions)=>{
        const result = {};
        for (const { colour: colour, options: options } of colourOptions[colorByValue] || []){
            if (colour) for (const option of options)result[option] = colour;
        }
        return result;
    };
    const $9c099cd6b30d8e09$export$d1a26b5685d69490 = (0, $3YtPS.createSelector)([
        $9c099cd6b30d8e09$export$f663f23222699c31,
        $9c099cd6b30d8e09$export$138250857b33c4c9
    ], $9c099cd6b30d8e09$export$2d7070b8c3d8a5fe);
    const $9c099cd6b30d8e09$export$f2e3afe6b51cb1fe = (id)=>!(0, parcelRequire("lV634")).default(id) && ![
            (0, $gITL8.colourByOptions).COMPONENT,
            (0, $gITL8.colourByOptions).EPIC,
            (0, $gITL8.colourByOptions).ISSUE_TYPE,
            (0, $gITL8.colourByOptions).LABEL,
            (0, $gITL8.colourByOptions).NONE,
            (0, $gITL8.colourByOptions).PRIORITY,
            (0, $gITL8.colourByOptions).PROJECT,
            (0, $gITL8.colourByOptions).STATUS,
            (0, $gITL8.colourByOptions).TEAM
        ].includes(id);
    const $9c099cd6b30d8e09$export$dec6094604a65c25 = (colorByValue, availableCustomFields, issues)=>{
        const field = (0, $19iju.getCustomFieldById)(Number(colorByValue), availableCustomFields)[0];
        if (!field) return [];
        const issuesWithColorByCustomFields = issues.filter(({ customFields: customFields = {} })=>(0, parcelRequire("2JlG5")).default(colorByValue, customFields));
        const options = issuesWithColorByCustomFields.reduce((ids, { customFields: customFields = {} })=>{
            const fieldValue = customFields[field.id];
            Array.prototype.push.apply(ids, Array.isArray(fieldValue) ? fieldValue : [
                fieldValue
            ]);
            return ids;
        }, []).filter((id)=>!(0, parcelRequire("lV634")).default(id)).map((id)=>id && id.toString());
        return [
            ...new Set(options)
        ];
    };
    const $9c099cd6b30d8e09$export$33345bc5757ddb24 = (0, $3YtPS.createSelector)([
        $9c099cd6b30d8e09$export$f663f23222699c31,
        (0, $19iju.getCustomFields),
        (0, $gFhwb.getIssues)
    ], $9c099cd6b30d8e09$export$dec6094604a65c25);
    const $9c099cd6b30d8e09$var$getAllOtherIssuesGroup = (grouping)=>({
            id: (0, $36c0257b9da5ad27$export$526fec6b76d5bc5),
            name: '',
            isExpanded: false,
            [grouping]: []
        });
    const $9c099cd6b30d8e09$export$bf794e171dc086eb = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getCustomFieldValuesGroupsViewSettings),
        $9c099cd6b30d8e09$export$6d374601688ff387
    ], (customFieldValuesGroupsState, grouping)=>customFieldValuesGroupsState[grouping] || [
            $9c099cd6b30d8e09$var$getAllOtherIssuesGroup(grouping)
        ]);
    const $9c099cd6b30d8e09$export$95a03f06c11e24b1 = (grouping, customFieldsById)=>{
        if (!(0, $cScrq.isRoadmapGroupedByCustomField)(grouping)) return false;
        const fieldId = (0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping);
        if (!customFieldsById[fieldId]) return false;
        return (0, $TTKUQ.CustomFields).GroupableMultiValueFields.includes(customFieldsById[fieldId].type.key);
    };
    const $9c099cd6b30d8e09$export$de65305314931ab0 = (0, $3YtPS.createSelector)([
        $9c099cd6b30d8e09$export$6d374601688ff387,
        (0, $19iju.getCustomFieldsById)
    ], $9c099cd6b30d8e09$export$95a03f06c11e24b1);
    const $9c099cd6b30d8e09$export$4cb7ee4ce12522c5 = (0, $3YtPS.createSelector)([
        $9c099cd6b30d8e09$export$bf794e171dc086eb
    ], (customFieldValuesGroups)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), customFieldValuesGroups));
});
parcelRegister("gITL8", function(module, exports) {
    $parcel$export(module.exports, "priorityColourMap", ()=>$d701a1c4328f21ef$export$9e46ca4a9d72a47a);
    $parcel$export(module.exports, "statusColourMap", ()=>$d701a1c4328f21ef$export$b165e7a83b8d071e);
    $parcel$export(module.exports, "colourPalette", ()=>$d701a1c4328f21ef$export$62574e55be2dec4c);
    $parcel$export(module.exports, "colourPickerPalette", ()=>$d701a1c4328f21ef$export$64eb68126e172885);
    $parcel$export(module.exports, "colourPickerPaletteLabels", ()=>$d701a1c4328f21ef$export$91b816e18e6c5df8);
    $parcel$export(module.exports, "colourPaletteTextColoursMap", ()=>$d701a1c4328f21ef$export$417e78c88d312f43);
    $parcel$export(module.exports, "DEFAULT_COLOR", ()=>$d701a1c4328f21ef$export$37394b0fa44b998c);
    $parcel$export(module.exports, "OPTIMIZED_COLOR", ()=>$d701a1c4328f21ef$export$5f382c549e49b03c);
    $parcel$export(module.exports, "colourByOptions", ()=>$d701a1c4328f21ef$export$48e6473fbcf263ed);
    $parcel$export(module.exports, "statusBreakdownColourMap", ()=>$d701a1c4328f21ef$export$8d0430f655bb72d1);
    $parcel$export(module.exports, "epicColorToARJColor", ()=>$d701a1c4328f21ef$export$6dd3d3f0ff9ad95d);
    var $kFsv3;
    var $gJZ5D;
    var $9C2Oc = parcelRequire("9C2Oc");
    const $d701a1c4328f21ef$export$9e46ca4a9d72a47a = [
        (0, (0, parcelRequire("gJZ5D")).default).R400,
        (0, (0, parcelRequire("gJZ5D")).default).Y400,
        (0, (0, parcelRequire("gJZ5D")).default).B400
    ];
    const $d701a1c4328f21ef$export$b165e7a83b8d071e = {
        '2': (0, (0, parcelRequire("gJZ5D")).default).N500,
        '4': (0, (0, parcelRequire("gJZ5D")).default).B500,
        '3': (0, (0, parcelRequire("gJZ5D")).default).G500
    };
    const $d701a1c4328f21ef$export$62574e55be2dec4c = [
        (0, (0, parcelRequire("gJZ5D")).default).P400,
        (0, (0, parcelRequire("gJZ5D")).default).B400,
        (0, (0, parcelRequire("gJZ5D")).default).T400,
        (0, (0, parcelRequire("gJZ5D")).default).G400,
        (0, (0, parcelRequire("gJZ5D")).default).Y400,
        (0, (0, parcelRequire("gJZ5D")).default).R100,
        (0, (0, parcelRequire("gJZ5D")).default).P75,
        (0, (0, parcelRequire("gJZ5D")).default).B100,
        (0, (0, parcelRequire("gJZ5D")).default).T100,
        (0, (0, parcelRequire("gJZ5D")).default).G100,
        (0, (0, parcelRequire("gJZ5D")).default).Y100,
        (0, (0, parcelRequire("gJZ5D")).default).R400
    ];
    const $d701a1c4328f21ef$export$64eb68126e172885 = [
        (0, (0, parcelRequire("gJZ5D")).default).R400,
        (0, (0, parcelRequire("gJZ5D")).default).P400,
        (0, (0, parcelRequire("gJZ5D")).default).B400,
        (0, (0, parcelRequire("gJZ5D")).default).T400,
        (0, (0, parcelRequire("gJZ5D")).default).G400,
        (0, (0, parcelRequire("gJZ5D")).default).Y400,
        (0, (0, parcelRequire("gJZ5D")).default).R100,
        (0, (0, parcelRequire("gJZ5D")).default).P75,
        (0, (0, parcelRequire("gJZ5D")).default).B100,
        (0, (0, parcelRequire("gJZ5D")).default).T100,
        (0, (0, parcelRequire("gJZ5D")).default).G100,
        (0, (0, parcelRequire("gJZ5D")).default).Y100
    ];
    const $d701a1c4328f21ef$export$91b816e18e6c5df8 = {
        [(0, (0, parcelRequire("gJZ5D")).default).R400]: (0, $9C2Oc.default).r400,
        [(0, (0, parcelRequire("gJZ5D")).default).P400]: (0, $9C2Oc.default).p400,
        [(0, (0, parcelRequire("gJZ5D")).default).B400]: (0, $9C2Oc.default).b400,
        [(0, (0, parcelRequire("gJZ5D")).default).T400]: (0, $9C2Oc.default).t400,
        [(0, (0, parcelRequire("gJZ5D")).default).G400]: (0, $9C2Oc.default).g400,
        [(0, (0, parcelRequire("gJZ5D")).default).Y400]: (0, $9C2Oc.default).y400,
        [(0, (0, parcelRequire("gJZ5D")).default).R100]: (0, $9C2Oc.default).r100,
        [(0, (0, parcelRequire("gJZ5D")).default).P75]: (0, $9C2Oc.default).p75,
        [(0, (0, parcelRequire("gJZ5D")).default).B100]: (0, $9C2Oc.default).b100,
        [(0, (0, parcelRequire("gJZ5D")).default).T100]: (0, $9C2Oc.default).t100,
        [(0, (0, parcelRequire("gJZ5D")).default).G100]: (0, $9C2Oc.default).g100,
        [(0, (0, parcelRequire("gJZ5D")).default).Y100]: (0, $9C2Oc.default).y100,
        [(0, (0, parcelRequire("gJZ5D")).default).N100]: (0, $9C2Oc.default).n100
    };
    const $d701a1c4328f21ef$export$417e78c88d312f43 = {
        [(0, (0, parcelRequire("gJZ5D")).default).R400]: (0, (0, parcelRequire("gJZ5D")).default).N0,
        [(0, (0, parcelRequire("gJZ5D")).default).P400]: (0, (0, parcelRequire("gJZ5D")).default).N0,
        [(0, (0, parcelRequire("gJZ5D")).default).B400]: (0, (0, parcelRequire("gJZ5D")).default).N0,
        [(0, (0, parcelRequire("gJZ5D")).default).T400]: (0, (0, parcelRequire("gJZ5D")).default).N0,
        [(0, (0, parcelRequire("gJZ5D")).default).G400]: (0, (0, parcelRequire("gJZ5D")).default).N0,
        [(0, (0, parcelRequire("gJZ5D")).default).R100]: (0, (0, parcelRequire("gJZ5D")).default).N800,
        [(0, (0, parcelRequire("gJZ5D")).default).P75]: (0, (0, parcelRequire("gJZ5D")).default).N800,
        [(0, (0, parcelRequire("gJZ5D")).default).B100]: (0, (0, parcelRequire("gJZ5D")).default).N800,
        [(0, (0, parcelRequire("gJZ5D")).default).T100]: (0, (0, parcelRequire("gJZ5D")).default).N800,
        [(0, (0, parcelRequire("gJZ5D")).default).G100]: (0, (0, parcelRequire("gJZ5D")).default).N800,
        [(0, (0, parcelRequire("gJZ5D")).default).Y100]: (0, (0, parcelRequire("gJZ5D")).default).N800,
        [(0, (0, parcelRequire("gJZ5D")).default).Y400]: (0, (0, parcelRequire("gJZ5D")).default).N800
    };
    const $d701a1c4328f21ef$export$37394b0fa44b998c = (0, (0, parcelRequire("gJZ5D")).default).N100;
    const $d701a1c4328f21ef$export$5f382c549e49b03c = (0, (0, parcelRequire("gJZ5D")).default).P300;
    const $d701a1c4328f21ef$export$48e6473fbcf263ed = {
        COMPONENT: 'component',
        EPIC: 'epic',
        ISSUE_TYPE: 'issueType',
        ISSUE_TYPE_KEY: 'issueTypeKey',
        LABEL: 'label',
        NONE: 'none',
        PRIORITY: 'priority',
        PROJECT: 'project',
        STATUS: 'status',
        TEAM: 'team'
    };
    const $d701a1c4328f21ef$export$8d0430f655bb72d1 = {
        TODO: `var(--ds-border, ${(0, (0, parcelRequire("gJZ5D")).default).N50})`,
        INPROGRESS: `var(--ds-border-information, ${(0, (0, parcelRequire("gJZ5D")).default).B400})`,
        DONE: `var(--ds-border-success, ${(0, (0, parcelRequire("gJZ5D")).default).G300})`
    };
    const $d701a1c4328f21ef$export$6dd3d3f0ff9ad95d = {
        [(0, (0, parcelRequire("kFsv3")).Colors).DARK_ORANGE]: (0, (0, parcelRequire("gJZ5D")).default).R400,
        [(0, (0, parcelRequire("kFsv3")).Colors).DARK_PURPLE]: (0, (0, parcelRequire("gJZ5D")).default).P400,
        [(0, (0, parcelRequire("kFsv3")).Colors).DARK_BLUE]: (0, (0, parcelRequire("gJZ5D")).default).B400,
        [(0, (0, parcelRequire("kFsv3")).Colors).DARK_TEAL]: (0, (0, parcelRequire("gJZ5D")).default).T400,
        [(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREEN]: (0, (0, parcelRequire("gJZ5D")).default).G400,
        [(0, (0, parcelRequire("kFsv3")).Colors).DARK_YELLOW]: (0, (0, parcelRequire("gJZ5D")).default).Y400,
        [(0, (0, parcelRequire("kFsv3")).Colors).ORANGE]: (0, (0, parcelRequire("gJZ5D")).default).R100,
        [(0, (0, parcelRequire("kFsv3")).Colors).PURPLE]: (0, (0, parcelRequire("gJZ5D")).default).P75,
        [(0, (0, parcelRequire("kFsv3")).Colors).BLUE]: (0, (0, parcelRequire("gJZ5D")).default).B100,
        [(0, (0, parcelRequire("kFsv3")).Colors).TEAL]: (0, (0, parcelRequire("gJZ5D")).default).T100,
        [(0, (0, parcelRequire("kFsv3")).Colors).GREEN]: (0, (0, parcelRequire("gJZ5D")).default).G100,
        [(0, (0, parcelRequire("kFsv3")).Colors).YELLOW]: (0, (0, parcelRequire("gJZ5D")).default).Y100,
        [(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREY]: (0, (0, parcelRequire("gJZ5D")).default).N400,
        [(0, (0, parcelRequire("kFsv3")).Colors).GREY]: (0, (0, parcelRequire("gJZ5D")).default).N100
    };
});
parcelRegister("kFsv3", function(module, exports) {
    $parcel$export(module.exports, "PURPLE", ()=>$da8a77f13d52b186$export$7ffdeca4b2f927a2);
    $parcel$export(module.exports, "DARK_PURPLE", ()=>$da8a77f13d52b186$export$c815fe495e8174a0);
    $parcel$export(module.exports, "BLUE", ()=>$da8a77f13d52b186$export$738c3b9a44c87ecc);
    $parcel$export(module.exports, "DARK_BLUE", ()=>$da8a77f13d52b186$export$1225f83626261b80);
    $parcel$export(module.exports, "GREEN", ()=>$da8a77f13d52b186$export$48d4b2cd5bc0e88b);
    $parcel$export(module.exports, "DARK_GREEN", ()=>$da8a77f13d52b186$export$c6f4cf2e5768eb78);
    $parcel$export(module.exports, "TEAL", ()=>$da8a77f13d52b186$export$d0446fe88325854e);
    $parcel$export(module.exports, "DARK_TEAL", ()=>$da8a77f13d52b186$export$bb848c92687e69dc);
    $parcel$export(module.exports, "YELLOW", ()=>$da8a77f13d52b186$export$aab610c505c06a8f);
    $parcel$export(module.exports, "DARK_YELLOW", ()=>$da8a77f13d52b186$export$466af87757d343a2);
    $parcel$export(module.exports, "ORANGE", ()=>$da8a77f13d52b186$export$3de5e29ed1757f9b);
    $parcel$export(module.exports, "DARK_ORANGE", ()=>$da8a77f13d52b186$export$da02e4820b6ab753);
    $parcel$export(module.exports, "GREY", ()=>$da8a77f13d52b186$export$7d278ca694634874);
    $parcel$export(module.exports, "DARK_GREY", ()=>$da8a77f13d52b186$export$26453300bfc61cb8);
    $parcel$export(module.exports, "COLORS", ()=>$da8a77f13d52b186$export$56d196d2844d1ca1);
    $parcel$export(module.exports, "SERVER_PURPLE", ()=>$da8a77f13d52b186$export$792af22a0198af8d);
    $parcel$export(module.exports, "SERVER_DARK_PURPLE", ()=>$da8a77f13d52b186$export$588af712afdcb006);
    $parcel$export(module.exports, "SERVER_BLUE", ()=>$da8a77f13d52b186$export$84c4918645391802);
    $parcel$export(module.exports, "SERVER_DARK_BLUE", ()=>$da8a77f13d52b186$export$b8f1f5838352a33a);
    $parcel$export(module.exports, "SERVER_GREEN", ()=>$da8a77f13d52b186$export$9384b7e350ee6542);
    $parcel$export(module.exports, "SERVER_DARK_GREEN", ()=>$da8a77f13d52b186$export$87d3fb8d8656d38b);
    $parcel$export(module.exports, "SERVER_TEAL", ()=>$da8a77f13d52b186$export$b0b4ce3e99e66aae);
    $parcel$export(module.exports, "SERVER_DARK_TEAL", ()=>$da8a77f13d52b186$export$a89b77a449bd223e);
    $parcel$export(module.exports, "SERVER_YELLOW", ()=>$da8a77f13d52b186$export$9a33b5e3cde94885);
    $parcel$export(module.exports, "SERVER_DARK_YELLOW", ()=>$da8a77f13d52b186$export$33253d7862bceb8a);
    $parcel$export(module.exports, "SERVER_ORANGE", ()=>$da8a77f13d52b186$export$6609c2b23fc42f39);
    $parcel$export(module.exports, "SERVER_DARK_ORANGE", ()=>$da8a77f13d52b186$export$cd994662b5911917);
    $parcel$export(module.exports, "SERVER_GREY", ()=>$da8a77f13d52b186$export$1793d43e13e078c5);
    $parcel$export(module.exports, "SERVER_DARK_GREY", ()=>$da8a77f13d52b186$export$487a6e9145526564);
    $parcel$export(module.exports, "GHX_LABEL_1", ()=>$da8a77f13d52b186$export$e4bdf2d4c4bbb15e);
    $parcel$export(module.exports, "GHX_LABEL_2", ()=>$da8a77f13d52b186$export$8f5c1c5512278dc6);
    $parcel$export(module.exports, "GHX_LABEL_3", ()=>$da8a77f13d52b186$export$94ac87c81ed074a7);
    $parcel$export(module.exports, "GHX_LABEL_4", ()=>$da8a77f13d52b186$export$6bc9ab1f489f76f7);
    $parcel$export(module.exports, "GHX_LABEL_5", ()=>$da8a77f13d52b186$export$610a2c132b6fcf96);
    $parcel$export(module.exports, "GHX_LABEL_6", ()=>$da8a77f13d52b186$export$8e4997dba71f1c40);
    $parcel$export(module.exports, "GHX_LABEL_7", ()=>$da8a77f13d52b186$export$18a545b4e69b27b4);
    $parcel$export(module.exports, "GHX_LABEL_8", ()=>$da8a77f13d52b186$export$27fff1a0d295292a);
    $parcel$export(module.exports, "GHX_LABEL_9", ()=>$da8a77f13d52b186$export$e57aa662a56724e1);
    $parcel$export(module.exports, "GHX_LABEL_10", ()=>$da8a77f13d52b186$export$4b0d63e2c3be2072);
    $parcel$export(module.exports, "GHX_LABEL_11", ()=>$da8a77f13d52b186$export$457ecb9560f2bf83);
    $parcel$export(module.exports, "GHX_LABEL_12", ()=>$da8a77f13d52b186$export$a866db37165a696c);
    $parcel$export(module.exports, "GHX_LABEL_13", ()=>$da8a77f13d52b186$export$9b18447c1168a1b6);
    $parcel$export(module.exports, "GHX_LABEL_14", ()=>$da8a77f13d52b186$export$93b9ad4020e271b7);
    $parcel$export(module.exports, "AGILE_COLOR_1", ()=>$da8a77f13d52b186$export$5cd2af17b34de3e3);
    $parcel$export(module.exports, "AGILE_COLOR_2", ()=>$da8a77f13d52b186$export$987671fa69482a7b);
    $parcel$export(module.exports, "AGILE_COLOR_3", ()=>$da8a77f13d52b186$export$70ba8a5b1f4c7446);
    $parcel$export(module.exports, "AGILE_COLOR_4", ()=>$da8a77f13d52b186$export$fcd1c42d8d3ebd36);
    $parcel$export(module.exports, "AGILE_COLOR_5", ()=>$da8a77f13d52b186$export$f80a5bd2fa0ba256);
    $parcel$export(module.exports, "AGILE_COLOR_6", ()=>$da8a77f13d52b186$export$37ad5ce8d2aeaf78);
    $parcel$export(module.exports, "AGILE_COLOR_7", ()=>$da8a77f13d52b186$export$9dc62d5d151cb355);
    $parcel$export(module.exports, "AGILE_COLOR_8", ()=>$da8a77f13d52b186$export$1ed15b30f5663f92);
    $parcel$export(module.exports, "AGILE_COLOR_9", ()=>$da8a77f13d52b186$export$5d23a84d55ac1644);
    $parcel$export(module.exports, "AGILE_COLOR_10", ()=>$da8a77f13d52b186$export$bf08c9a6ed42e349);
    $parcel$export(module.exports, "AGILE_COLOR_11", ()=>$da8a77f13d52b186$export$66c5d8f0b5ff279c);
    $parcel$export(module.exports, "AGILE_COLOR_12", ()=>$da8a77f13d52b186$export$da30755a37c3a597);
    $parcel$export(module.exports, "AGILE_COLOR_13", ()=>$da8a77f13d52b186$export$721cf84faff6bf19);
    $parcel$export(module.exports, "AGILE_COLOR_14", ()=>$da8a77f13d52b186$export$4b8f8666bd7b61dd);
    $parcel$export(module.exports, "Colors", ()=>$da8a77f13d52b186$export$c537fa0d021d010b);
    $parcel$export(module.exports, "ServerColors", ()=>$da8a77f13d52b186$export$d33d39828a18210a);
    $parcel$export(module.exports, "ClassicEpicColors", ()=>$da8a77f13d52b186$export$f476e6e43e0101e7);
    $parcel$export(module.exports, "AgileColors", ()=>$da8a77f13d52b186$export$4b7407b8700035bd);
    const $da8a77f13d52b186$export$7ffdeca4b2f927a2 = 'PURPLE';
    const $da8a77f13d52b186$export$c815fe495e8174a0 = 'DARK_PURPLE';
    const $da8a77f13d52b186$export$738c3b9a44c87ecc = 'BLUE';
    const $da8a77f13d52b186$export$1225f83626261b80 = 'DARK_BLUE';
    const $da8a77f13d52b186$export$48d4b2cd5bc0e88b = 'GREEN';
    const $da8a77f13d52b186$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
    const $da8a77f13d52b186$export$d0446fe88325854e = 'TEAL';
    const $da8a77f13d52b186$export$bb848c92687e69dc = 'DARK_TEAL';
    const $da8a77f13d52b186$export$aab610c505c06a8f = 'YELLOW';
    const $da8a77f13d52b186$export$466af87757d343a2 = 'DARK_YELLOW';
    const $da8a77f13d52b186$export$3de5e29ed1757f9b = 'ORANGE';
    const $da8a77f13d52b186$export$da02e4820b6ab753 = 'DARK_ORANGE';
    const $da8a77f13d52b186$export$7d278ca694634874 = 'GREY';
    const $da8a77f13d52b186$export$26453300bfc61cb8 = 'DARK_GREY';
    const $da8a77f13d52b186$export$56d196d2844d1ca1 = [
        $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        $da8a77f13d52b186$export$c815fe495e8174a0,
        $da8a77f13d52b186$export$738c3b9a44c87ecc,
        $da8a77f13d52b186$export$1225f83626261b80,
        $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        $da8a77f13d52b186$export$d0446fe88325854e,
        $da8a77f13d52b186$export$bb848c92687e69dc,
        $da8a77f13d52b186$export$aab610c505c06a8f,
        $da8a77f13d52b186$export$466af87757d343a2,
        $da8a77f13d52b186$export$3de5e29ed1757f9b,
        $da8a77f13d52b186$export$da02e4820b6ab753,
        $da8a77f13d52b186$export$7d278ca694634874,
        $da8a77f13d52b186$export$26453300bfc61cb8
    ];
    const $da8a77f13d52b186$export$792af22a0198af8d = 'purple';
    const $da8a77f13d52b186$export$588af712afdcb006 = 'dark_purple';
    const $da8a77f13d52b186$export$84c4918645391802 = 'blue';
    const $da8a77f13d52b186$export$b8f1f5838352a33a = 'dark_blue';
    const $da8a77f13d52b186$export$9384b7e350ee6542 = 'green';
    const $da8a77f13d52b186$export$87d3fb8d8656d38b = 'dark_green';
    const $da8a77f13d52b186$export$b0b4ce3e99e66aae = 'teal';
    const $da8a77f13d52b186$export$a89b77a449bd223e = 'dark_teal';
    const $da8a77f13d52b186$export$9a33b5e3cde94885 = 'yellow';
    const $da8a77f13d52b186$export$33253d7862bceb8a = 'dark_yellow';
    const $da8a77f13d52b186$export$6609c2b23fc42f39 = 'orange';
    const $da8a77f13d52b186$export$cd994662b5911917 = 'dark_orange';
    const $da8a77f13d52b186$export$1793d43e13e078c5 = 'grey';
    const $da8a77f13d52b186$export$487a6e9145526564 = 'dark_grey';
    const $da8a77f13d52b186$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
    const $da8a77f13d52b186$export$8f5c1c5512278dc6 = 'ghx-label-2';
    const $da8a77f13d52b186$export$94ac87c81ed074a7 = 'ghx-label-3';
    const $da8a77f13d52b186$export$6bc9ab1f489f76f7 = 'ghx-label-4';
    const $da8a77f13d52b186$export$610a2c132b6fcf96 = 'ghx-label-5';
    const $da8a77f13d52b186$export$8e4997dba71f1c40 = 'ghx-label-6';
    const $da8a77f13d52b186$export$18a545b4e69b27b4 = 'ghx-label-7';
    const $da8a77f13d52b186$export$27fff1a0d295292a = 'ghx-label-8';
    const $da8a77f13d52b186$export$e57aa662a56724e1 = 'ghx-label-9';
    const $da8a77f13d52b186$export$4b0d63e2c3be2072 = 'ghx-label-10';
    const $da8a77f13d52b186$export$457ecb9560f2bf83 = 'ghx-label-11';
    const $da8a77f13d52b186$export$a866db37165a696c = 'ghx-label-12';
    const $da8a77f13d52b186$export$9b18447c1168a1b6 = 'ghx-label-13';
    const $da8a77f13d52b186$export$93b9ad4020e271b7 = 'ghx-label-14';
    const $da8a77f13d52b186$export$5cd2af17b34de3e3 = 'color_1';
    const $da8a77f13d52b186$export$987671fa69482a7b = 'color_2';
    const $da8a77f13d52b186$export$70ba8a5b1f4c7446 = 'color_3';
    const $da8a77f13d52b186$export$fcd1c42d8d3ebd36 = 'color_4';
    const $da8a77f13d52b186$export$f80a5bd2fa0ba256 = 'color_5';
    const $da8a77f13d52b186$export$37ad5ce8d2aeaf78 = 'color_6';
    const $da8a77f13d52b186$export$9dc62d5d151cb355 = 'color_7';
    const $da8a77f13d52b186$export$1ed15b30f5663f92 = 'color_8';
    const $da8a77f13d52b186$export$5d23a84d55ac1644 = 'color_9';
    const $da8a77f13d52b186$export$bf08c9a6ed42e349 = 'color_10';
    const $da8a77f13d52b186$export$66c5d8f0b5ff279c = 'color_11';
    const $da8a77f13d52b186$export$da30755a37c3a597 = 'color_12';
    const $da8a77f13d52b186$export$721cf84faff6bf19 = 'color_13';
    const $da8a77f13d52b186$export$4b8f8666bd7b61dd = 'color_14';
    const $da8a77f13d52b186$export$c537fa0d021d010b = {
        PURPLE: $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        DARK_PURPLE: $da8a77f13d52b186$export$c815fe495e8174a0,
        BLUE: $da8a77f13d52b186$export$738c3b9a44c87ecc,
        DARK_BLUE: $da8a77f13d52b186$export$1225f83626261b80,
        GREEN: $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        DARK_GREEN: $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        TEAL: $da8a77f13d52b186$export$d0446fe88325854e,
        DARK_TEAL: $da8a77f13d52b186$export$bb848c92687e69dc,
        YELLOW: $da8a77f13d52b186$export$aab610c505c06a8f,
        DARK_YELLOW: $da8a77f13d52b186$export$466af87757d343a2,
        ORANGE: $da8a77f13d52b186$export$3de5e29ed1757f9b,
        DARK_ORANGE: $da8a77f13d52b186$export$da02e4820b6ab753,
        GREY: $da8a77f13d52b186$export$7d278ca694634874,
        DARK_GREY: $da8a77f13d52b186$export$26453300bfc61cb8
    };
    const $da8a77f13d52b186$export$d33d39828a18210a = {
        SERVER_PURPLE: $da8a77f13d52b186$export$792af22a0198af8d,
        SERVER_DARK_PURPLE: $da8a77f13d52b186$export$588af712afdcb006,
        SERVER_BLUE: $da8a77f13d52b186$export$84c4918645391802,
        SERVER_DARK_BLUE: $da8a77f13d52b186$export$b8f1f5838352a33a,
        SERVER_GREEN: $da8a77f13d52b186$export$9384b7e350ee6542,
        SERVER_DARK_GREEN: $da8a77f13d52b186$export$87d3fb8d8656d38b,
        SERVER_TEAL: $da8a77f13d52b186$export$b0b4ce3e99e66aae,
        SERVER_DARK_TEAL: $da8a77f13d52b186$export$a89b77a449bd223e,
        SERVER_YELLOW: $da8a77f13d52b186$export$9a33b5e3cde94885,
        SERVER_DARK_YELLOW: $da8a77f13d52b186$export$33253d7862bceb8a,
        SERVER_ORANGE: $da8a77f13d52b186$export$6609c2b23fc42f39,
        SERVER_DARK_ORANGE: $da8a77f13d52b186$export$cd994662b5911917,
        SERVER_GREY: $da8a77f13d52b186$export$1793d43e13e078c5,
        SERVER_DARK_GREY: $da8a77f13d52b186$export$487a6e9145526564
    };
    const $da8a77f13d52b186$export$f476e6e43e0101e7 = {
        GHX_LABEL_1: $da8a77f13d52b186$export$e4bdf2d4c4bbb15e,
        GHX_LABEL_2: $da8a77f13d52b186$export$8f5c1c5512278dc6,
        GHX_LABEL_3: $da8a77f13d52b186$export$94ac87c81ed074a7,
        GHX_LABEL_4: $da8a77f13d52b186$export$6bc9ab1f489f76f7,
        GHX_LABEL_5: $da8a77f13d52b186$export$610a2c132b6fcf96,
        GHX_LABEL_6: $da8a77f13d52b186$export$8e4997dba71f1c40,
        GHX_LABEL_7: $da8a77f13d52b186$export$18a545b4e69b27b4,
        GHX_LABEL_8: $da8a77f13d52b186$export$27fff1a0d295292a,
        GHX_LABEL_9: $da8a77f13d52b186$export$e57aa662a56724e1,
        GHX_LABEL_10: $da8a77f13d52b186$export$4b0d63e2c3be2072,
        GHX_LABEL_11: $da8a77f13d52b186$export$457ecb9560f2bf83,
        GHX_LABEL_12: $da8a77f13d52b186$export$a866db37165a696c,
        GHX_LABEL_13: $da8a77f13d52b186$export$9b18447c1168a1b6,
        GHX_LABEL_14: $da8a77f13d52b186$export$93b9ad4020e271b7
    };
    const $da8a77f13d52b186$export$4b7407b8700035bd = {
        AGILE_COLOR_1: $da8a77f13d52b186$export$5cd2af17b34de3e3,
        AGILE_COLOR_2: $da8a77f13d52b186$export$987671fa69482a7b,
        AGILE_COLOR_3: $da8a77f13d52b186$export$70ba8a5b1f4c7446,
        AGILE_COLOR_4: $da8a77f13d52b186$export$fcd1c42d8d3ebd36,
        AGILE_COLOR_5: $da8a77f13d52b186$export$f80a5bd2fa0ba256,
        AGILE_COLOR_6: $da8a77f13d52b186$export$37ad5ce8d2aeaf78,
        AGILE_COLOR_7: $da8a77f13d52b186$export$9dc62d5d151cb355,
        AGILE_COLOR_8: $da8a77f13d52b186$export$1ed15b30f5663f92,
        AGILE_COLOR_9: $da8a77f13d52b186$export$5d23a84d55ac1644,
        AGILE_COLOR_10: $da8a77f13d52b186$export$bf08c9a6ed42e349,
        AGILE_COLOR_11: $da8a77f13d52b186$export$66c5d8f0b5ff279c,
        AGILE_COLOR_12: $da8a77f13d52b186$export$da30755a37c3a597,
        AGILE_COLOR_13: $da8a77f13d52b186$export$721cf84faff6bf19,
        AGILE_COLOR_14: $da8a77f13d52b186$export$4b8f8666bd7b61dd
    };
});
parcelRegister("9C2Oc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$809b49782598ff0a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $809b49782598ff0a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        r400: {
            "id": "portfolio-3-portfolio.common.colours.r-400",
            "defaultMessage": "Red"
        },
        p400: {
            "id": "portfolio-3-portfolio.common.colours.p-400",
            "defaultMessage": "Purple"
        },
        b400: {
            "id": "portfolio-3-portfolio.common.colours.b-400",
            "defaultMessage": "Blue"
        },
        t400: {
            "id": "portfolio-3-portfolio.common.colours.t-400",
            "defaultMessage": "Teal"
        },
        g400: {
            "id": "portfolio-3-portfolio.common.colours.g-400",
            "defaultMessage": "Green"
        },
        y400: {
            "id": "portfolio-3-portfolio.common.colours.y-400",
            "defaultMessage": "Orange"
        },
        r100: {
            "id": "portfolio-3-portfolio.common.colours.r-100",
            "defaultMessage": "Light red"
        },
        p75: {
            "id": "portfolio-3-portfolio.common.colours.p-75",
            "defaultMessage": "Light purple"
        },
        b100: {
            "id": "portfolio-3-portfolio.common.colours.b-100",
            "defaultMessage": "Light blue"
        },
        t100: {
            "id": "portfolio-3-portfolio.common.colours.t-100",
            "defaultMessage": "Light teal"
        },
        g100: {
            "id": "portfolio-3-portfolio.common.colours.g-100",
            "defaultMessage": "Light green"
        },
        y100: {
            "id": "portfolio-3-portfolio.common.colours.y-100",
            "defaultMessage": "Light yellow"
        },
        n100: {
            "id": "portfolio-3-portfolio.common.colours.n-100",
            "defaultMessage": "Gray"
        }
    });
});
const $36c0257b9da5ad27$export$526fec6b76d5bc5 = 'all_other_issues';
parcelRegister("8pJHi", function(module, exports) {
    $parcel$export(module.exports, "defaultSorting", ()=>$0c2397744c26736f$export$6655f0b167885296);
    var $TTKUQ = parcelRequire("TTKUQ");
    var $bstHg = parcelRequire("bstHg");
    const $0c2397744c26736f$export$6655f0b167885296 = {
        field: (0, $bstHg.ISSUE_FIELDS).RANK,
        type: (0, $TTKUQ.ISSUE_FIELD_TYPES).STRING,
        direction: (0, $TTKUQ.SORT_DIRECTION).ASCENDING
    };
});
parcelRegister("15Ec0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a26cb0d1e2a88b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3KRpp;
    var $8pJHi = parcelRequire("8pJHi");
    var $4hkqI = parcelRequire("4hkqI");
    var $8Mmmy = parcelRequire("8Mmmy");
    var $hthh2 = parcelRequire("hthh2");
    var $bNljn = parcelRequire("bNljn");
    var $qSHu9 = parcelRequire("qSHu9");
    var $ZMqjm = parcelRequire("ZMqjm");
    var $20VBk = parcelRequire("20VBk");
    var $5MKXV = parcelRequire("5MKXV");
    var $87RRv = parcelRequire("87RRv");
    const $8a26cb0d1e2a88b0$var$applyFlags = (flags, sortByRank, redirectToSpaPlanPage)=>flags.reduce((accum, { key: key, context: context = {} })=>{
            switch(key){
                case 0, $9e169ee721864a4b$export$a23067a331938f15:
                    return accum.concat((0, $ZMqjm.getJSWNoAccessErrorFlag));
                case 0, $9e169ee721864a4b$export$225669431bad5551:
                    return accum.concat((0, $qSHu9.getIssueSearchWarningFlag));
                case 0, $9e169ee721864a4b$export$8a72c64e90d56fab:
                    return accum.concat(()=>(0, $87RRv.getReparentTMPWarningFlag)({
                            context: context
                        }));
                case 0, $9e169ee721864a4b$export$ac1a967dceae5708:
                    return accum.concat(()=>(0, $5MKXV.getReparentCMPWarningFlag)({
                            context: context
                        }));
                case 0, $9e169ee721864a4b$export$42d68c08a5ace658:
                    return accum.concat((Description)=>(0, $hthh2.getIssueLimitWarningFlag)(Description, redirectToSpaPlanPage));
                case 0, $9e169ee721864a4b$export$a1a68e80ebef1446:
                    return accum.concat((0, $20VBk.getProjectLimitWarningFlag));
                case 0, $9e169ee721864a4b$export$5d75f74c1d4d448d:
                    return accum.concat(()=>(0, $bNljn.getIssueRankWarningFlag)({
                            sortByRank: sortByRank
                        }));
                case 0, $9e169ee721864a4b$export$f21a7cfcdb7aed8e:
                    return accum.concat((0, $8Mmmy.GoalsErrorFlag));
                default:
                    return accum;
            }
        }, []);
    const $8a26cb0d1e2a88b0$var$FlagGroup = ({ flags: flags, onDismissFlag: onDismissFlag, onChangeSort: onChangeSort, sorting: sorting })=>{
        const [shownFlags, setShownFlags] = (0, $5uXOq.useState)([]);
        const redirectToSpaPlanPage = (0, $4hkqI.useRedirectToSpaPlanPage)();
        (0, $5uXOq.useEffect)(()=>{
            const sortByRank = ({ sorting: sorting })=>{
                onChangeSort({
                    sorting: sorting
                });
                onDismissFlag({
                    key: (0, $9e169ee721864a4b$export$5d75f74c1d4d448d)
                });
            };
            const filteredFlags = $8a26cb0d1e2a88b0$var$applyFlags(flags, sortByRank, redirectToSpaPlanPage);
            setShownFlags(filteredFlags);
        }, [
            flags,
            onDismissFlag,
            onChangeSort
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (sorting.field === (0, $8pJHi.defaultSorting).field && flags.some(({ key: key })=>key === (0, $9e169ee721864a4b$export$5d75f74c1d4d448d))) onDismissFlag({
                key: (0, $9e169ee721864a4b$export$5d75f74c1d4d448d)
            });
        }, [
            sorting,
            flags,
            onDismissFlag
        ]);
        const onDismissed = (flagKey)=>{
            onDismissFlag({
                key: flagKey.toString()
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).FlagGroup), {
            onDismissed: onDismissed
        }, shownFlags.map((getFlag)=>getFlag()));
    };
    var $8a26cb0d1e2a88b0$export$2e2bcd8739ae039 = $8a26cb0d1e2a88b0$var$FlagGroup;
});
parcelRegister("4hkqI", function(module, exports) {
    $parcel$export(module.exports, "useRedirectToSpaPlanPage", ()=>$a636e5d36faab830$export$ca60ba613d31bd2a);
    $parcel$export(module.exports, "default", ()=>$a636e5d36faab830$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3HwlS;
    var $doZTA;
    const $a636e5d36faab830$export$ca60ba613d31bd2a = ()=>{
        const [{ match: match, location: location }, { replace: replace, push: push }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        return (page, plan)=>{
            if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && plan) {
                const newUrl = `/jira/plans/${plan.planId}/scenarios/${plan.scenarioId}${page}`;
                if (newUrl === location.pathname) return;
                push(newUrl);
            } else {
                if (!match.params?.planId || !match.params?.scenarioId) return;
                const newUrl = `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${page}`;
                if (newUrl === location.pathname) return;
                replace(newUrl);
            }
        };
    };
    const $a636e5d36faab830$var$withRedirectToSpaPlanPage = (WrappedComponent)=>(props)=>{
            const redirectToSpaPlanPage = $a636e5d36faab830$export$ca60ba613d31bd2a();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                redirectToSpaPlanPage: redirectToSpaPlanPage
            });
        };
    var $a636e5d36faab830$export$2e2bcd8739ae039 = $a636e5d36faab830$var$withRedirectToSpaPlanPage;
});
parcelRegister("8Mmmy", function(module, exports) {
    $parcel$export(module.exports, "GoalsErrorFlag", ()=>$3ba07d5cabff8a5e$export$81d814c33a9f5a60);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nnPp;
    var $d4xRU;
    var $koVbs;
    var $hCG46 = parcelRequire("hCG46");
    const $3ba07d5cabff8a5e$export$81d814c33a9f5a60 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            key: "jpo-goals-error-flag",
            id: "jpo-goals-error-flag",
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                label: formatMessage((0, $hCG46.default).errorFlagIconLabel),
                primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
            }),
            title: formatMessage((0, $hCG46.default).errorFlagTitle),
            description: formatMessage((0, $hCG46.default).errorFlagDescription)
        });
    };
});
parcelRegister("hCG46", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dae34dd27e9d64a4$export$2e2bcd8739ae039);
    var $7VHMR;
    const $dae34dd27e9d64a4$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.goals-error-flag.error-flag-title",
            "defaultMessage": "Something went wrong"
        },
        errorFlagDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.goals-error-flag.error-flag-description",
            "defaultMessage": "There was an error when loading in Atlas goals. Please try refreshing the page."
        },
        errorFlagIconLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.goals-error-flag.error-flag-icon-label",
            "defaultMessage": "Error"
        }
    });
    var $dae34dd27e9d64a4$export$2e2bcd8739ae039 = $dae34dd27e9d64a4$var$messages;
});
parcelRegister("hthh2", function(module, exports) {
    $parcel$export(module.exports, "getIssueLimitWarningFlag", ()=>$8a98515fdc8b6e63$export$cd775572da7c8bd3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gtreQ;
    var $d4xRU;
    var $ousew;
    var $gJZ5D;
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    var $sesqh = parcelRequire("sesqh");
    var $gparT = parcelRequire("gparT");
    const $8a98515fdc8b6e63$export$cd775572da7c8bd3 = (Description = (0, $sesqh.default), redirectToSpaPlanPage)=>{
        const handleUpdateIssueSourcesButtonClick = (_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                actionSubject: 'issueLimitWarningModal',
                action: 'updateLinkClicked'
            }));
            redirectToSpaPlanPage('/settings/issue-sources');
        };
        const handleSetExclusionRulesButtonClick = (_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                actionSubject: 'issueLimitWarningModal',
                action: 'setExclusionRulesLinkClicked'
            }));
            redirectToSpaPlanPage('/settings/exclusion-rules');
        };
        const actions = [
            {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $gparT.default).updateEditIssueSources),
                onClick: handleUpdateIssueSourcesButtonClick
            },
            {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $gparT.default).setExclusionRules),
                onClick: handleSetExclusionRulesButtonClick
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            key: "issue-limit-warning",
            id: "issue-limit-warning",
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
                sourceName: "issueLimitWarning"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
                onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $gparT.default).title), ' '),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement(Description, null),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                label: "",
                primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
            }),
            actions: actions
        });
    };
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("sesqh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$36b7baaa08f4c479$export$2e2bcd8739ae039);
    var $bC2fB;
    var $cfDwp = parcelRequire("cfDwp");
    var $7e1W2 = parcelRequire("7e1W2");
    var $36b7baaa08f4c479$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $cfDwp.default), {})((0, $7e1W2.default));
});
parcelRegister("cfDwp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3fe0485945a1c85$export$2e2bcd8739ae039);
    var $jpgxP = parcelRequire("jpgxP");
    var $3YtPS = parcelRequire("3YtPS");
    var $c3fe0485945a1c85$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        loadingLimitsInfo: (0, $jpgxP.getLoadingLimitsInfo)
    });
});
parcelRegister("7e1W2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0346915a17b19c98$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $61tm5 = parcelRequire("61tm5");
    const $0346915a17b19c98$var$Description = ({ loadingLimitsInfo: loadingLimitsInfo })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $61tm5.default).descriptionWithLimit,
            values: {
                issueLimit: loadingLimitsInfo.absoluteIssueLimit
            }
        });
    var $0346915a17b19c98$export$2e2bcd8739ae039 = $0346915a17b19c98$var$Description;
});
parcelRegister("61tm5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8a104e0c658fc26$export$2e2bcd8739ae039);
    var $7VHMR;
    const $c8a104e0c658fc26$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        descriptionWithLimit: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-limit-warning-flag.description.description-with-limit",
            "defaultMessage": "The maximum issue count for a plan is {issueLimit} {issueLimit, plural, one {issue} other {issues}}. Try choosing an issue source with fewer issues, or edit your exclusion rules to reduce issue count."
        }
    });
    var $c8a104e0c658fc26$export$2e2bcd8739ae039 = $c8a104e0c658fc26$var$messages;
});
parcelRegister("gparT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51753975b3f6a585$export$2e2bcd8739ae039);
    var $7VHMR;
    const $51753975b3f6a585$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-limit-warning-flag.title",
            "defaultMessage": "Issue limit exceeded"
        },
        updateEditIssueSources: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-limit-warning-flag.update-edit-issue-sources",
            "defaultMessage": "Edit issue sources"
        },
        setExclusionRules: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-limit-warning-flag.set-exclusion-rules",
            "defaultMessage": "Set exclusion rules"
        }
    });
    var $51753975b3f6a585$export$2e2bcd8739ae039 = $51753975b3f6a585$var$messages;
});
parcelRegister("bNljn", function(module, exports) {
    $parcel$export(module.exports, "getIssueRankWarningFlag", ()=>$06a99364c1321b9d$export$d77a5d6b75a012da);
    var $5uXOq = parcelRequire("5uXOq");
    var $gtreQ;
    var $cgL5K;
    var $d4xRU;
    var $ousew;
    var $gJZ5D;
    var $8pJHi = parcelRequire("8pJHi");
    var $dw6DF = parcelRequire("dw6DF");
    const $06a99364c1321b9d$export$d77a5d6b75a012da = ({ sortByRank: sortByRank })=>{
        const handleSortByRankButtonClick = (_)=>{
            sortByRank({
                sorting: (0, $8pJHi.defaultSorting)
            });
        };
        const actions = [
            {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dw6DF.default).sortByRank),
                onClick: handleSortByRankButtonClick
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            key: "issue-rank-warning-flag",
            id: "issue-rank-warning-flag",
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dw6DF.default).title),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $dw6DF.default).sortedPreventIssueRankingDescription,
                values: {
                    strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                            as: "strong"
                        }, chunks)
                }
            })),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                label: "",
                primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
            }),
            actions: actions
        });
    };
});
parcelRegister("dw6DF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce81f28f719992cb$export$2e2bcd8739ae039);
    var $7VHMR;
    const $ce81f28f719992cb$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sortByRank: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-rank-warning-flag.sort-by-rank",
            "defaultMessage": "Sort by Rank"
        },
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-rank-warning-flag.title",
            "defaultMessage": "Issue couldn\u2019t be moved"
        },
        sortedPreventIssueRankingDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-rank-warning-flag.sorted-prevent-issue-ranking-description",
            "defaultMessage": "Sort issues by <strong>Rank</strong> to enable drag and drop."
        }
    });
    var $ce81f28f719992cb$export$2e2bcd8739ae039 = $ce81f28f719992cb$var$messages;
});
parcelRegister("qSHu9", function(module, exports) {
    $parcel$export(module.exports, "getIssueSearchWarningFlag", ()=>$f3c2da31783187f6$export$3fa9c14edc12458);
    var $5uXOq = parcelRequire("5uXOq");
    var $gtreQ;
    var $d4xRU;
    var $ousew;
    var $gJZ5D;
    var $7MHqd = parcelRequire("7MHqd");
    var $g5RJ7 = parcelRequire("g5RJ7");
    const $f3c2da31783187f6$export$3fa9c14edc12458 = (Description = (0, $7MHqd.default))=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            key: "issue-search-warning",
            id: "issue-search-warning",
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                label: "",
                primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
            }),
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $g5RJ7.default).hiddenByFilterTitle),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement(Description, null)
        });
});
parcelRegister("7MHqd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d9648e9ff18eed3$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4Lahf = parcelRequire("4Lahf");
    var $eUIco = parcelRequire("eUIco");
    var $gg3Ds = parcelRequire("gg3Ds");
    var $6d9648e9ff18eed3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $eUIco.default), (0, $4Lahf.default))((0, $gg3Ds.default));
});
parcelRegister("4Lahf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10b758b4a1f0d91c$export$2e2bcd8739ae039);
    var $lIIFg = parcelRequire("lIIFg");
    var $eiyR0 = parcelRequire("eiyR0");
    const $10b758b4a1f0d91c$var$mapDispatchToProps = (dispatch)=>({
            clearCustomFieldFilter: (customFields)=>{
                customFields.forEach((customField)=>dispatch((0, $eiyR0.clear)({
                        customField: customField
                    })));
            },
            clearFilter: (filterId)=>{
                dispatch((0, $lIIFg.clear)(filterId));
            }
        });
    var $10b758b4a1f0d91c$export$2e2bcd8739ae039 = $10b758b4a1f0d91c$var$mapDispatchToProps;
});
parcelRegister("eUIco", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5fef00890307c889$export$2e2bcd8739ae039);
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $jLI87 = parcelRequire("jLI87");
    var $3YtPS = parcelRequire("3YtPS");
    var $5fef00890307c889$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        issuesById: (0, $gFhwb.getIssueMapById),
        issueSearchResults: (0, $jLI87.searchForIssues),
        issueTypesById: (0, $kllqP.getIssueTypesById),
        projectsById: (0, $jpXKt.getProjectsById)
    });
});
parcelRegister("jLI87", function(module, exports) {
    $parcel$export(module.exports, "getIsExpanded", ()=>$1cac8ef626479962$export$8c797d2c6f8c1a2b);
    $parcel$export(module.exports, "getSortedIssues", ()=>$1cac8ef626479962$export$a7e6813e541a5ff8);
    $parcel$export(module.exports, "UNDEFINED_GROUP", ()=>$1cac8ef626479962$export$dcda7e10772ff7e8);
    $parcel$export(module.exports, "UNASSIGNED_GROUP", ()=>$1cac8ef626479962$export$36304411fc607ee8);
    $parcel$export(module.exports, "getAncestorsOfIssue", ()=>$1cac8ef626479962$export$1465021a0c4b5a3e);
    $parcel$export(module.exports, "getGroupAttribute", ()=>$1cac8ef626479962$export$66c297e813a21e25);
    $parcel$export(module.exports, "getIssuesByGroup", ()=>$1cac8ef626479962$export$97e315c357c4faa0);
    $parcel$export(module.exports, "buildScope", ()=>$1cac8ef626479962$export$cc6f39777f861b93);
    $parcel$export(module.exports, "groupSortComparator", ()=>$1cac8ef626479962$export$56c13c77705fe953);
    $parcel$export(module.exports, "getIssuesWithOriginalsAndOptimized", ()=>$1cac8ef626479962$export$2dc22532bb2facbd);
    $parcel$export(module.exports, "getAllIssuesWithOriginalAndOptimized", ()=>$1cac8ef626479962$export$5e57a775e538d605);
    $parcel$export(module.exports, "getAllIssuesWithOriginalAndOptimizedById", ()=>$1cac8ef626479962$export$10ba2fa27c7f7e0c);
    $parcel$export(module.exports, "getIssuesByTeam", ()=>$1cac8ef626479962$export$e10d3122e31e969c);
    $parcel$export(module.exports, "getScope", ()=>$1cac8ef626479962$export$5d887aaef2abf9e2);
    $parcel$export(module.exports, "countVisibleIssues", ()=>$1cac8ef626479962$export$190897ce30bb27ad);
    $parcel$export(module.exports, "getSearchQuery", ()=>$1cac8ef626479962$export$1664b92369554829);
    $parcel$export(module.exports, "getActiveSearchResultIndex", ()=>$1cac8ef626479962$export$e467ab9db30aa64c);
    $parcel$export(module.exports, "splitString", ()=>$1cac8ef626479962$export$d05bbe0328e41cc6);
    $parcel$export(module.exports, "equalsIgnoreCase", ()=>$1cac8ef626479962$export$d9ffdbc590df6d8a);
    $parcel$export(module.exports, "searchForIssues", ()=>$1cac8ef626479962$export$df7b5ec530ae24ca);
    $parcel$export(module.exports, "getActiveSearchIssue", ()=>$1cac8ef626479962$export$6ab3c2d73db706ef);
    $parcel$export(module.exports, "getGroupCombinationByIssueId", ()=>$1cac8ef626479962$export$269e836147dd799c);
    $parcel$export(module.exports, "getGroupOptions", ()=>$1cac8ef626479962$export$66039435427a1c15);
    var $b1yMp;
    var $kSwbB;
    var $8EB5I;
    var $jVZZA;
    var $9U6ZH;
    var $SZGT2;
    var $4wiYB;
    var $83IGl;
    var $4DrGU;
    var $4S1OS;
    var $3nPAF;
    var $lV634;
    var $gCN7c;
    var $4Rr1a;
    var $ik0Qc;
    var $dXWaA;
    var $8r8wv;
    var $fZhYM;
    var $bvxTs;
    var $bQZTk;
    var $2rMKg;
    var $sqeVT;
    var $cn3Ob;
    var $j0d94;
    var $7Zjd1;
    var $1T7bg;
    var $hpnKp;
    var $bjzU8;
    var $co1wz;
    var $4R6GH;
    var $4ENQh;
    var $c12LJ;
    var $1CGdp = parcelRequire("1CGdp");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $cGbfF = parcelRequire("cGbfF");
    var $1CGdp = parcelRequire("1CGdp");
    var $hu7Cn = parcelRequire("hu7Cn");
    var $9SFhm = parcelRequire("9SFhm");
    var $19iju = parcelRequire("19iju");
    var $iIikD = parcelRequire("iIikD");
    var $gk0jw = parcelRequire("gk0jw");
    var $bZA5o = parcelRequire("bZA5o");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $ja8Lc = parcelRequire("ja8Lc");
    var $bzDof = parcelRequire("bzDof");
    var $ljmcc = parcelRequire("ljmcc");
    var $6TEBn = parcelRequire("6TEBn");
    var $jpgxP = parcelRequire("jpgxP");
    var $dRVQG = parcelRequire("dRVQG");
    var $9FFuD = parcelRequire("9FFuD");
    var $kWDpn = parcelRequire("kWDpn");
    var $j0XCX = parcelRequire("j0XCX");
    var $2QLMT = parcelRequire("2QLMT");
    var $2QLMT = parcelRequire("2QLMT");
    const $1cac8ef626479962$export$1b132ed8629e9cb0 = (state)=>state.domain.sprints;
    const $1cac8ef626479962$export$8c797d2c6f8c1a2b = (state)=>(0, $kWDpn.getIssueExpansionsViewSettings)(state).isExpanded;
    const $1cac8ef626479962$export$d7ad569e206d3043 = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$1b132ed8629e9cb0
    ], (0, $6TEBn.getSprintByIdMapPure));
    const $1cac8ef626479962$export$136e69b79f9b3bc6 = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getTeams),
        (0, $bHTqr.getIssueSources),
        $1cac8ef626479962$export$1b132ed8629e9cb0
    ], (0, $6TEBn.getSprintsForTeamPure));
    const $1cac8ef626479962$export$9ac265cc37a57f7 = (issues, sort)=>sort(issues);
    const $1cac8ef626479962$export$9bdb9e03b1a7d7af = (0, (0, parcelRequire("4ENQh")).monitor).timeFunction($1cac8ef626479962$export$9ac265cc37a57f7, 'query_scope_index_getSortedIssuesPure');
    const $1cac8ef626479962$export$a7e6813e541a5ff8 = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getFilteredIssuesWithHierarchy),
        (0, $ja8Lc.getSort)
    ], $1cac8ef626479962$export$9bdb9e03b1a7d7af);
    const $1cac8ef626479962$export$1762232de55aae51 = (issues, originalIssues)=>issues.map((issue)=>(0, parcelRequire("ik0Qc")).default(issue, {
                originals: originalIssues[issue.id]
            }));
    const $1cac8ef626479962$export$dd8fe8767b0c9948 = (issue, groupAttribute, isOptimizedMode)=>{
        const group = isOptimizedMode && (0, $4nDwW.isDefined)(issue.optimized) && issue.optimized[groupAttribute] || issue[groupAttribute] || issue.customFields && (0, $cScrq.isRoadmapGroupedByCustomField)(groupAttribute) && issue.customFields[(0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(groupAttribute)] || null;
        return group;
    };
    const $1cac8ef626479962$var$getCustomFieldValues = (issue, valueAttribute)=>{
        if ((0, $cScrq.isRoadmapGroupedByCustomField)(valueAttribute)) {
            const values = issue.customFields && issue.customFields[(0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(valueAttribute)];
            return values?.map((value)=>Number.isNaN(parseInt(value, 10)) ? value : parseInt(value, 10));
        }
        return issue[valueAttribute];
    };
    const $1cac8ef626479962$export$6d6bd5139b41ba0d = (issue, groups, isOptimizedMode, valueAttribute)=>{
        const values = isOptimizedMode && (0, $4nDwW.isDefined)(issue.optimized) && issue.optimized[valueAttribute] || issue[valueAttribute] || $1cac8ef626479962$var$getCustomFieldValues(issue, valueAttribute);
        if (!(0, $4nDwW.isDefined)(values)) return [
            (0, $10afd8ee8013ce61$export$526fec6b76d5bc5)
        ];
        const groupsWhereIssueValuesBelong = new Set();
        values.forEach((value)=>groups.filter((group)=>group[valueAttribute].includes(value)).forEach((group)=>groupsWhereIssueValuesBelong.add(group)));
        if (groupsWhereIssueValuesBelong.size === 0) return [
            (0, $10afd8ee8013ce61$export$526fec6b76d5bc5)
        ];
        return [
            ...groupsWhereIssueValuesBelong
        ].map(({ id: id })=>id);
    };
    const $1cac8ef626479962$export$ed69939cb80b5082 = (issue, groups, isOptimizedMode, valueAttribute, issuesById)=>{
        let ancestorGroups = [];
        const ancestorsIds = [];
        let parent = issuesById[issue.parent || ''];
        while(parent){
            if (ancestorsIds.includes(parent.id)) break;
            ancestorGroups = ancestorGroups.concat($1cac8ef626479962$export$6d6bd5139b41ba0d(parent, groups, isOptimizedMode, valueAttribute));
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return ancestorGroups;
    };
    const $1cac8ef626479962$export$5dc8141bb29109df = (issue, groups, isOptimizedMode, valueAttribute, issuesById)=>{
        let ancestorGroups = [];
        const ancestorsIds = [];
        let parent = issuesById[issue.parent || ''];
        while(parent && !ancestorGroups.length){
            if (ancestorsIds.includes(parent.id)) break;
            ancestorGroups = $1cac8ef626479962$export$6d6bd5139b41ba0d(parent, groups, isOptimizedMode, valueAttribute).filter((group)=>group !== (0, $10afd8ee8013ce61$export$526fec6b76d5bc5));
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return ancestorGroups;
    };
    const $1cac8ef626479962$export$dcda7e10772ff7e8 = (0, $TTKUQ.UNDEFINED_KEY);
    const $1cac8ef626479962$export$36304411fc607ee8 = 'unassigned';
    const $1cac8ef626479962$export$1465021a0c4b5a3e = (issue, issuesById)=>{
        const ancestors = [];
        const ancestorsIds = [];
        let parent = issuesById[issue.parent || ''];
        while(parent){
            if (ancestorsIds.includes(parent.id)) break;
            ancestorsIds.push(parent.id);
            ancestors.push(parent);
            parent = issuesById[parent.parent || ''];
        }
        return ancestors;
    };
    const $1cac8ef626479962$export$c50cc9c681527f77 = (issue, groupAttribute, isOptimizedMode, issuesById)=>{
        let ancestorGroups = [];
        const ancestorsIds = [];
        let parent = issuesById[issue.parent || ''];
        while(parent){
            if (ancestorsIds.includes(parent.id)) break;
            ancestorGroups = ancestorGroups.concat($1cac8ef626479962$export$dd8fe8767b0c9948(parent, groupAttribute, isOptimizedMode));
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return ancestorGroups;
    };
    const $1cac8ef626479962$export$10e719d95e641f86 = (issue, groupAttribute, isOptimizedMode, issuesById)=>{
        let group = null;
        const ancestorsIds = [];
        let parent = issuesById[issue.parent || ''];
        while(parent && (group === null || group === $1cac8ef626479962$export$36304411fc607ee8)){
            if (ancestorsIds.includes(parent.id)) break;
            group = $1cac8ef626479962$export$dd8fe8767b0c9948(parent, groupAttribute, isOptimizedMode);
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return group;
    };
    const $1cac8ef626479962$export$2d659ee56a9a2e4 = (issue, issuesById, lazyGoalsByARI)=>{
        let goals = [];
        const ancestorsIds = [];
        let parent = issuesById[issue.parent || ''];
        while(parent){
            if (ancestorsIds.includes(parent.id)) break;
            goals = goals.concat(parent.goals?.filter((goal)=>{
                const lazyGoal = lazyGoalsByARI[goal];
                return lazyGoal && !lazyGoal.isLoading;
            }) ?? []);
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return goals;
    };
    const $1cac8ef626479962$export$65bd6de1adc33c5b = (issue, issuesById, lazyGoalsByARI)=>{
        let goals = [];
        const ancestorsIds = [];
        let parent = issuesById[issue.parent || ''];
        while(parent && !goals.length){
            if (ancestorsIds.includes(parent.id)) break;
            goals = parent.goals?.filter((goal)=>{
                const lazyGoal = lazyGoalsByARI[goal];
                return lazyGoal && !lazyGoal.isLoading;
            }) ?? [];
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return goals;
    };
    const $1cac8ef626479962$export$15a62ab86bb8b7ec = (issue, associatedIssues, issuesById)=>{
        let ancestorIdeaIds = [];
        const ancestorsIds = [];
        let parent = issuesById[issue.parent || ''];
        while(parent){
            if (ancestorsIds.includes(parent.id)) break;
            ancestorIdeaIds = ancestorIdeaIds.concat(parent.associatedIssueIds?.filter((id)=>associatedIssues?.[id]) || []);
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return ancestorIdeaIds;
    };
    const $1cac8ef626479962$export$b92b976bbbec0b1e = (issue, associatedIssues, issuesById)=>{
        let nonEmptyIdeasId = [];
        const ancestorsIds = [];
        let parent = issuesById[issue.parent || ''];
        while(parent && !nonEmptyIdeasId?.length){
            if (ancestorsIds.includes(parent.id)) break;
            nonEmptyIdeasId = parent.associatedIssueIds?.filter((id)=>associatedIssues?.[id]);
            ancestorsIds.push(parent.id);
            parent = issuesById[parent.parent || ''];
        }
        return nonEmptyIdeasId?.length ? nonEmptyIdeasId : [];
    };
    const $1cac8ef626479962$export$66c297e813a21e25 = (group)=>{
        if ((0, $cScrq.isRoadmapGroupedByCustomField)(group)) return group;
        switch(group){
            case (0, $TTKUQ.GROUPING).ASSIGNEE:
                return 'assignee';
            case (0, $TTKUQ.GROUPING).REPORTER:
                return 'reporter';
            case (0, $TTKUQ.GROUPING).COMPONENT:
                return 'components';
            case (0, $TTKUQ.GROUPING).LABEL:
                return 'labels';
            case (0, $TTKUQ.GROUPING).PROJECT:
                return 'project';
            case (0, $TTKUQ.GROUPING).RELEASE:
                return 'release';
            case (0, $TTKUQ.GROUPING).SPRINT:
                return 'sprint';
            case (0, $TTKUQ.GROUPING).TEAM:
                return 'team';
            case (0, $TTKUQ.GROUPING).GOALS:
                return 'goals';
            case (0, $TTKUQ.GROUPING).IDEAS:
                return 'ideas';
            default:
                throw new Error(`Grouping by ${group} is not supported yet.`);
        }
    };
    const $1cac8ef626479962$export$8f96112d7c990471 = (group, isOptimizedMode, issue, issuesByGroup, issuesById, isAncestorGroupMatchCustom)=>{
        let copiedIssuesByGroup = {
            ...issuesByGroup
        };
        copiedIssuesByGroup = (0, $2QLMT.addIssueToGroup)(copiedIssuesByGroup, issue, group);
        $1cac8ef626479962$export$1465021a0c4b5a3e(issue, issuesById).forEach((ancestor)=>{
            const isAncestorGroupMatch = Object.keys(group).every((groupAttr)=>(0, $4nDwW.isDefined)(isAncestorGroupMatchCustom) ? isAncestorGroupMatchCustom(group[groupAttr], ancestor, isOptimizedMode) : group[groupAttr] === $1cac8ef626479962$export$dd8fe8767b0c9948(ancestor, groupAttr, isOptimizedMode));
            if (!isAncestorGroupMatch) copiedIssuesByGroup = (0, $2QLMT.addIssueToGroup)(copiedIssuesByGroup, ancestor, group);
        });
        return copiedIssuesByGroup;
    };
    const $1cac8ef626479962$export$95faac342fd66174 = (issues, issuesById, grouping = (0, $TTKUQ.GROUPING).NONE, isOptimizedMode, { componentGroups: componentGroups, labelGroups: labelGroups, teamsById: teamsById, sprintsByIdMap: sprintsByIdMap, sprintsForTeam: sprintsForTeam, versionsById: versionsById, lazyGoalsByARI: lazyGoalsByARI, customFieldValuesGroups: customFieldValuesGroups = [], isGroupByMultiValueCustomField: isGroupByMultiValueCustomField = false, associatedIssues: associatedIssues }, isEmbedMode, isConfluenceMacroMode)=>{
        let issuesByGroup = {};
        const groupAttribute = grouping !== (0, $TTKUQ.GROUPING).NONE ? $1cac8ef626479962$export$66c297e813a21e25(grouping) : '';
        const isEmbedOrMacro = isEmbedMode || isConfluenceMacroMode;
        switch(grouping){
            case (0, $TTKUQ.GROUPING).COMPONENT:
                issues.forEach((issue)=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGroups = $1cac8ef626479962$export$ed69939cb80b5082(issue, componentGroups, isOptimizedMode, groupAttribute, issuesById);
                        ancestorGroups.forEach((ancestorGroup)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                [`${groupAttribute}`]: ancestorGroup
                            }, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    $1cac8ef626479962$export$6d6bd5139b41ba0d(issue, componentGroups, isOptimizedMode, groupAttribute).forEach((group)=>{
                        if (group === (0, $10afd8ee8013ce61$export$526fec6b76d5bc5) && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                            const ancestorGroups = $1cac8ef626479962$export$5dc8141bb29109df(issue, componentGroups, isOptimizedMode, groupAttribute, issuesById);
                            ancestorGroups.forEach((ancestorGroup)=>{
                                issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                    [`${groupAttribute}`]: ancestorGroup
                                }, isOptimizedMode, issue, issuesByGroup, issuesById);
                            });
                        }
                        issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                            [`${groupAttribute}`]: group
                        }, isOptimizedMode, issue, issuesByGroup, issuesById);
                    });
                });
                break;
            case (0, $TTKUQ.GROUPING).LABEL:
                issues.forEach((issue)=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGroups = $1cac8ef626479962$export$ed69939cb80b5082(issue, labelGroups, isOptimizedMode, groupAttribute, issuesById);
                        ancestorGroups.forEach((ancestorGroup)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                [`${groupAttribute}`]: ancestorGroup
                            }, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    $1cac8ef626479962$export$6d6bd5139b41ba0d(issue, labelGroups, isOptimizedMode, groupAttribute).forEach((group)=>{
                        if (group === (0, $10afd8ee8013ce61$export$526fec6b76d5bc5) && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                            const ancestorGroups = $1cac8ef626479962$export$5dc8141bb29109df(issue, labelGroups, isOptimizedMode, groupAttribute, issuesById);
                            ancestorGroups.forEach((ancestorGroup)=>{
                                issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                    [`${groupAttribute}`]: ancestorGroup
                                }, isOptimizedMode, issue, issuesByGroup, issuesById);
                            });
                        }
                        issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                            [`${groupAttribute}`]: group
                        }, isOptimizedMode, issue, issuesByGroup, issuesById);
                    });
                });
                break;
            case (0, $TTKUQ.GROUPING).GOALS:
                issues.forEach((issue)=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGoals = $1cac8ef626479962$export$2d659ee56a9a2e4(issue, issuesById, lazyGoalsByARI);
                        ancestorGoals.forEach((ancestorGoal)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                [`${groupAttribute}`]: ancestorGoal
                            }, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    const loadedGoals = issue.goals?.filter((goal)=>{
                        const lazyGoal = lazyGoalsByARI[goal];
                        return lazyGoal && !lazyGoal.isLoading;
                    }) ?? [];
                    const goals = !loadedGoals.length ? [
                        $1cac8ef626479962$export$dcda7e10772ff7e8
                    ] : loadedGoals;
                    goals.forEach((goal)=>{
                        if (goal === $1cac8ef626479962$export$dcda7e10772ff7e8 && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                            const ancestorGoals = $1cac8ef626479962$export$65bd6de1adc33c5b(issue, issuesById, lazyGoalsByARI);
                            ancestorGoals.forEach((ancestorGoal)=>{
                                issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                    [`${groupAttribute}`]: ancestorGoal
                                }, isOptimizedMode, issue, issuesByGroup, issuesById);
                            });
                        }
                        issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                            [`${groupAttribute}`]: goal
                        }, isOptimizedMode, issue, issuesByGroup, issuesById);
                    });
                });
                break;
            case (0, $TTKUQ.GROUPING).RELEASE:
                issues.forEach((issue)=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGroups = (0, $2QLMT.getAncestorReleasesGroups)(issue, isOptimizedMode, versionsById, issuesById);
                        ancestorGroups.forEach((ancestorGroup)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471(ancestorGroup, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    (0, $2QLMT.getReleasesGroups)(issue, isOptimizedMode, versionsById).forEach((group)=>{
                        if (group.release === null && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                            const ancestorGroups = (0, $2QLMT.getAncestorReleasesGroupsOld)(issue, isOptimizedMode, versionsById, issuesById);
                            ancestorGroups.forEach((ancestorGroup)=>{
                                issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471(ancestorGroup, isOptimizedMode, issue, issuesByGroup, issuesById);
                            });
                        }
                        issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471(group, isOptimizedMode, issue, issuesByGroup, issuesById, (groupAttrValue, ancestor, isOptimizedMode)=>{
                            const fixVersions = $1cac8ef626479962$export$dd8fe8767b0c9948(ancestor, 'fixVersions', isOptimizedMode) || [];
                            return fixVersions.includes(groupAttrValue);
                        });
                    });
                });
                break;
            case (0, $TTKUQ.GROUPING).SPRINT:
                issues.forEach((issue)=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGroups = (0, $2QLMT.getTeamsByAncestorSprintGroups)(issue, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById, issuesById);
                        ancestorGroups.forEach((ancestorGroup)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471(ancestorGroup, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    (0, $2QLMT.getTeamsBySprintGroups)(issue, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById).forEach((group)=>{
                        if (group.sprint === null && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                            const ancestorGroups = (0, $2QLMT.getTeamsByAncestorSprintGroupsOld)(issue, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById, issuesById);
                            ancestorGroups.forEach((ancestorGroup)=>{
                                issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471(ancestorGroup, isOptimizedMode, issue, issuesByGroup, issuesById);
                            });
                        }
                        issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471(group, isOptimizedMode, issue, issuesByGroup, issuesById);
                    });
                });
                break;
            case (0, $TTKUQ.GROUPING).TEAM:
                issues.forEach((issue)=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGroups = $1cac8ef626479962$export$c50cc9c681527f77(issue, groupAttribute, isOptimizedMode, issuesById);
                        ancestorGroups.forEach((ancestorGroup)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                [`${groupAttribute}`]: ancestorGroup
                            }, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    if (issue.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)) {
                        const parentId = issue.parent;
                        if ((0, $4nDwW.isDefined)(parentId)) {
                            const parentIssue = issuesById[parentId];
                            if (parentIssue) {
                                const group = $1cac8ef626479962$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode);
                                if ((group === null || group === $1cac8ef626479962$export$36304411fc607ee8) && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                                    const ancestorGroup = $1cac8ef626479962$export$10e719d95e641f86(issue, groupAttribute, isOptimizedMode, issuesById);
                                    if (ancestorGroup !== null && ancestorGroup !== $1cac8ef626479962$export$36304411fc607ee8) issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                        [`${groupAttribute}`]: ancestorGroup
                                    }, isOptimizedMode, issue, issuesByGroup, issuesById);
                                }
                                issuesByGroup = (0, $2QLMT.addIssueToGroup)(issuesByGroup, issue, {
                                    [`${groupAttribute}`]: group
                                });
                            }
                        } else issuesByGroup = (0, $2QLMT.addIssueToGroup)(issuesByGroup, issue, {
                            [`${groupAttribute}`]: $1cac8ef626479962$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode)
                        });
                    } else {
                        const group = $1cac8ef626479962$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode);
                        if ((group === null || group === $1cac8ef626479962$export$36304411fc607ee8) && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                            const ancestorGroup = $1cac8ef626479962$export$10e719d95e641f86(issue, groupAttribute, isOptimizedMode, issuesById);
                            if (ancestorGroup !== null && ancestorGroup !== $1cac8ef626479962$export$36304411fc607ee8) issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                [`${groupAttribute}`]: ancestorGroup
                            }, isOptimizedMode, issue, issuesByGroup, issuesById);
                        }
                        issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                            [`${groupAttribute}`]: group
                        }, isOptimizedMode, issue, issuesByGroup, issuesById);
                    }
                });
                break;
            case (0, $cScrq.isRoadmapGroupedByCustomField)(grouping) && grouping:
                if (isGroupByMultiValueCustomField) issues.forEach((issue)=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGroups = $1cac8ef626479962$export$ed69939cb80b5082(issue, customFieldValuesGroups, isOptimizedMode, groupAttribute, issuesById);
                        ancestorGroups.forEach((ancestorGroup)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                [`${groupAttribute}`]: ancestorGroup
                            }, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    $1cac8ef626479962$export$6d6bd5139b41ba0d(issue, customFieldValuesGroups, isOptimizedMode, groupAttribute).forEach((group)=>{
                        if (group === (0, $10afd8ee8013ce61$export$526fec6b76d5bc5) && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                            const ancestorGroups = $1cac8ef626479962$export$5dc8141bb29109df(issue, customFieldValuesGroups, isOptimizedMode, groupAttribute, issuesById);
                            ancestorGroups.forEach((ancestorGroup)=>{
                                issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                    [`${groupAttribute}`]: ancestorGroup
                                }, isOptimizedMode, issue, issuesByGroup, issuesById);
                            });
                        }
                        issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                            [`${groupAttribute}`]: group
                        }, isOptimizedMode, issue, issuesByGroup, issuesById);
                    });
                });
                else issues.forEach((issue)=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGroups = $1cac8ef626479962$export$c50cc9c681527f77(issue, groupAttribute, isOptimizedMode, issuesById);
                        ancestorGroups.forEach((ancestorGroup)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                [`${groupAttribute}`]: ancestorGroup
                            }, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    const group = $1cac8ef626479962$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode);
                    if ((group === null || group === $1cac8ef626479962$export$36304411fc607ee8) && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGroup = $1cac8ef626479962$export$10e719d95e641f86(issue, groupAttribute, isOptimizedMode, issuesById);
                        if (ancestorGroup !== null && ancestorGroup !== $1cac8ef626479962$export$36304411fc607ee8) issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                            [`${groupAttribute}`]: ancestorGroup
                        }, isOptimizedMode, issue, issuesByGroup, issuesById);
                    }
                    issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                        [`${groupAttribute}`]: group
                    }, isOptimizedMode, issue, issuesByGroup, issuesById);
                });
                break;
            case (0, $TTKUQ.GROUPING).IDEAS:
                if ((0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') && !isEmbedOrMacro) issues.forEach((issue)=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorIdeas = $1cac8ef626479962$export$15a62ab86bb8b7ec(issue, associatedIssues, issuesById);
                        ancestorIdeas.forEach((ancestorIdea)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                [`${groupAttribute}`]: ancestorIdea
                            }, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    const nonEmptyIdeasId = issue.associatedIssueIds?.filter((id)=>associatedIssues && associatedIssues[id]);
                    const ideaIds = !nonEmptyIdeasId?.length ? [
                        $1cac8ef626479962$export$dcda7e10772ff7e8
                    ] : nonEmptyIdeasId;
                    if (!nonEmptyIdeasId?.length && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorIdeas = $1cac8ef626479962$export$b92b976bbbec0b1e(issue, associatedIssues, issuesById);
                        ancestorIdeas.forEach((ancestorIdea)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                [`${groupAttribute}`]: ancestorIdea
                            }, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    ideaIds.forEach((ideaId)=>{
                        issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                            [`${groupAttribute}`]: ideaId
                        }, isOptimizedMode, issue, issuesByGroup, issuesById);
                    });
                });
                else issues.forEach((issue)=>{
                    issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                        [`${groupAttribute}`]: $1cac8ef626479962$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode)
                    }, isOptimizedMode, issue, issuesByGroup, issuesById);
                });
                break;
            default:
                issues.forEach((issue)=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGroups = $1cac8ef626479962$export$c50cc9c681527f77(issue, groupAttribute, isOptimizedMode, issuesById);
                        ancestorGroups.forEach((ancestorGroup)=>{
                            issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                                [`${groupAttribute}`]: ancestorGroup
                            }, isOptimizedMode, issue, issuesByGroup, issuesById);
                        });
                    }
                    const group = $1cac8ef626479962$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode);
                    if ((group === null || group === $1cac8ef626479962$export$36304411fc607ee8) && !(0, (0, parcelRequire("4R6GH")).fg)('plans_group_by_to_show_all_children')) {
                        const ancestorGroup = $1cac8ef626479962$export$10e719d95e641f86(issue, groupAttribute, isOptimizedMode, issuesById);
                        if (ancestorGroup !== null && ancestorGroup !== $1cac8ef626479962$export$36304411fc607ee8) issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                            [`${groupAttribute}`]: ancestorGroup
                        }, isOptimizedMode, issue, issuesByGroup, issuesById);
                    }
                    issuesByGroup = $1cac8ef626479962$export$8f96112d7c990471({
                        [`${groupAttribute}`]: group
                    }, isOptimizedMode, issue, issuesByGroup, issuesById);
                });
                break;
        }
        return issuesByGroup;
    };
    const $1cac8ef626479962$export$fbb72383d7fe83f = (issues, grouping = (0, $TTKUQ.GROUPING).NONE, isOptimizedMode, groupingData, isEmbedMode, isConfluenceMacroMode)=>{
        const issuesById = (0, $4nDwW.indexBy)(({ id: id })=>id, issues);
        return $1cac8ef626479962$export$95faac342fd66174(issues, issuesById, grouping, isOptimizedMode, groupingData, isEmbedMode, isConfluenceMacroMode);
    };
    const $1cac8ef626479962$var$getGroupingData = (0, $3YtPS.createStructuredSelector)({
        componentGroups: (0, $kWDpn.getComponentGroupsViewSettings),
        labelGroups: (0, $kWDpn.getLabelsGroupViewSettings),
        sprintsByIdMap: $1cac8ef626479962$export$d7ad569e206d3043,
        sprintsForTeam: $1cac8ef626479962$export$136e69b79f9b3bc6,
        teamsById: (0, $dRVQG.getAllTeamsById),
        versionsById: (0, $9FFuD.getVersionsById),
        lazyGoalsByARI: (0, $bZA5o.getLazyGoalsByARI),
        customFieldValuesGroups: (0, $j0XCX.getCustomFieldValuesGroups),
        isGroupByMultiValueCustomField: $j0XCX.isGroupByMultiValueCustomField,
        associatedIssues: (0, $9SFhm.getAssociatedIssues)
    });
    const $1cac8ef626479962$export$97e315c357c4faa0 = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getFilteredIssuesWithHierarchy),
        (0, $gFhwb.getIssueMapById),
        (0, $j0XCX.getVisualisationGrouping),
        (0, $1CGdp.isOptimizedMode),
        $1cac8ef626479962$var$getGroupingData,
        (0, $1CGdp.isEmbed),
        (0, $1CGdp.isConfluenceMacro)
    ], $1cac8ef626479962$export$95faac342fd66174);
    const $1cac8ef626479962$export$2d0a064b4b76d506 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getAllIssues),
        (0, $gFhwb.getIssueMapById),
        (0, $j0XCX.getVisualisationGrouping),
        (0, $1CGdp.isOptimizedMode),
        $1cac8ef626479962$var$getGroupingData,
        (0, $1CGdp.isEmbed),
        (0, $1CGdp.isConfluenceMacro)
    ], $1cac8ef626479962$export$95faac342fd66174);
    const $1cac8ef626479962$export$cc6f39777f861b93 = (issues, issuesByParent, issuesById, isExpanded, start, end, group, groupCombination, issuesInGroup, ignoreExpandingState)=>{
        const rootIssues = issues.filter(({ level: level })=>level === start);
        let issuesInGroupMap;
        if (issuesInGroup) issuesInGroupMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), issuesInGroup);
        const startLevelIssues = {
            rootIssuesCount: rootIssues.length,
            issues: (0, $2QLMT.getIssuesHierarchy)({
                issues: rootIssues,
                issuesByParent: issuesByParent,
                isExpanded: isExpanded,
                group: group,
                groupCombination: groupCombination,
                issuesInGroupMap: issuesInGroupMap,
                ignoreExpandingState: ignoreExpandingState
            }),
            level: start
        };
        const issuesWithoutParent = issues.filter(({ level: level, parent: parent })=>level < start && !(parent && issuesById[parent]));
        const issuesWithoutParentByLevel = (0, $4nDwW.groupBy)(({ level: level })=>level, issuesWithoutParent);
        const issuesWithoutParentFlattenForest = [];
        const headerIdSuffix = groupCombination ? `:${(0, $2QLMT.getGroupKey)(groupCombination)}` : '';
        const headerId = `IssuesWithoutParentHeader${headerIdSuffix}`;
        for (const level of (0, parcelRequire("cn3Ob")).default(end, start).reverse()){
            const rootIssues = issuesWithoutParentByLevel[level];
            const idSuffix = groupCombination ? `:${(0, $2QLMT.getGroupKey)(groupCombination)}` : '';
            const id = `IssuesWithoutParent-${level}${idSuffix}`;
            if (rootIssues) issuesWithoutParentFlattenForest.push({
                id: id,
                isExpanded: isExpanded[id],
                issues: (0, $2QLMT.getIssuesHierarchy)({
                    issues: rootIssues,
                    issuesByParent: issuesByParent,
                    isExpanded: isExpanded,
                    group: group,
                    groupCombination: groupCombination,
                    issuesInGroupMap: issuesInGroupMap,
                    ignoreExpandingState: ignoreExpandingState
                }),
                level: level,
                rootIssuesCount: rootIssues.length
            });
            else issuesWithoutParentFlattenForest.push({
                id: id,
                isExpanded: isExpanded[id],
                issues: [],
                level: level,
                rootIssuesCount: 0
            });
        }
        return {
            startLevelIssues: startLevelIssues,
            issuesWithoutParent: issuesWithoutParentFlattenForest,
            issuesWithoutParentHeaderData: {
                id: headerId,
                isExpanded: isExpanded[headerId]
            }
        };
    };
    const $1cac8ef626479962$export$a06a68c30cc52c94 = '';
    const $1cac8ef626479962$var$getExpandedGroups = (state)=>(0, $kWDpn.getVisualisationViewSettings)(state).expandedItems;
    const $1cac8ef626479962$export$c3687f28f0f07b51 = (grouping, groupName, expandedState)=>expandedState?.[grouping]?.[groupName];
    const $1cac8ef626479962$export$213ef3bd851839cf = (componentGroups = [], labelGroups = [], teamsById = {}, projects = [], assignees = [], reporters = [], sprintsByIdMap = {}, grouping = (0, $TTKUQ.GROUPING).TEAM, groupId, versionsById, lazyGoalsByARI, associatedIssues)=>{
        const group = groupId && groupId.toString();
        if (!group || group === $1cac8ef626479962$export$dcda7e10772ff7e8) return {
            name: $1cac8ef626479962$export$a06a68c30cc52c94,
            grouping: grouping,
            group: $1cac8ef626479962$export$dcda7e10772ff7e8
        };
        switch(grouping){
            case (0, $TTKUQ.GROUPING).COMPONENT:
                {
                    const componentGroup = componentGroups.find(({ id: id })=>id === group);
                    const groupName = (0, $4nDwW.isDefined)(componentGroup) && componentGroup.name || $1cac8ef626479962$export$a06a68c30cc52c94;
                    return {
                        name: groupName,
                        group: group,
                        grouping: grouping
                    };
                }
            case (0, $TTKUQ.GROUPING).LABEL:
                {
                    const labelGroup = labelGroups.find(({ id: id })=>id === group);
                    const groupName = (0, $4nDwW.isDefined)(labelGroup) && labelGroup.name || $1cac8ef626479962$export$a06a68c30cc52c94;
                    return {
                        name: groupName,
                        group: group,
                        grouping: grouping
                    };
                }
            case (0, $TTKUQ.GROUPING).TEAM:
                {
                    const team = teamsById[group];
                    const teamName = (0, $4nDwW.isDefined)(team) && team.title || $1cac8ef626479962$export$a06a68c30cc52c94;
                    return {
                        name: teamName,
                        group: group,
                        grouping: grouping,
                        url: team && team.avatarUrl
                    };
                }
            case (0, $TTKUQ.GROUPING).ASSIGNEE:
                {
                    const assignee = assignees.find((assignee)=>assignee.jiraUser.accountId === group);
                    const assigneeName = (0, $4nDwW.isDefined)(assignee) && assignee.jiraUser.title || $1cac8ef626479962$export$a06a68c30cc52c94;
                    return {
                        name: assigneeName,
                        group: group,
                        grouping: grouping,
                        url: assignee && assignee.jiraUser.avatarUrl
                    };
                }
            case (0, $TTKUQ.GROUPING).REPORTER:
                {
                    const reporter = reporters.find((reporter)=>reporter.jiraUser.accountId === group);
                    const reporterName = (0, $4nDwW.isDefined)(reporter) && reporter.jiraUser.title || $1cac8ef626479962$export$a06a68c30cc52c94;
                    return {
                        name: reporterName,
                        group: group,
                        grouping: grouping,
                        url: reporter && reporter.jiraUser.avatarUrl
                    };
                }
            case (0, $TTKUQ.GROUPING).PROJECT:
                {
                    const project = projects.find((project)=>project.id === parseInt(group, 10));
                    const projectName = (0, $4nDwW.isDefined)(project) && project.name || $1cac8ef626479962$export$a06a68c30cc52c94;
                    return {
                        name: projectName,
                        group: group,
                        grouping: grouping,
                        url: project && project.avatarUrl
                    };
                }
            case (0, $TTKUQ.GROUPING).SPRINT:
                return {
                    name: sprintsByIdMap[group].title || $1cac8ef626479962$export$a06a68c30cc52c94,
                    group: group,
                    grouping: grouping
                };
            case (0, $TTKUQ.GROUPING).RELEASE:
                {
                    const release = versionsById[group];
                    return {
                        name: release ? release.name : $1cac8ef626479962$export$a06a68c30cc52c94,
                        group: group,
                        grouping: grouping
                    };
                }
            case (0, $TTKUQ.GROUPING).GOALS:
                {
                    const goal = lazyGoalsByARI[group];
                    const name = goal && !goal.isLoading && goal.goal ? goal.goal.name : group;
                    return {
                        name: name,
                        group: group,
                        grouping: grouping
                    };
                }
            case (0, $TTKUQ.GROUPING).IDEAS:
                if ((0, (0, parcelRequire("co1wz")).ff)('polaris.possibility-of-updating-ideas-in-plans')) {
                    const idea = associatedIssues && associatedIssues[group];
                    const name = idea?.summary ? idea.summary : group;
                    return {
                        name: name,
                        group: group,
                        grouping: grouping
                    };
                }
                return {
                    name: group,
                    group: group,
                    grouping: grouping
                };
            default:
                return {
                    name: $1cac8ef626479962$export$a06a68c30cc52c94,
                    grouping: grouping,
                    group: group
                };
        }
    };
    const $1cac8ef626479962$export$56c13c77705fe953 = (group1, group2)=>{
        if (group1.groupName === '') return 1;
        if (group2.groupName === '') return -1;
        const g1 = group1.groupName.toLowerCase();
        const g2 = group2.groupName.toLowerCase();
        if (g2 === $1cac8ef626479962$export$36304411fc607ee8) return -1;
        if (g1 === $1cac8ef626479962$export$36304411fc607ee8) return 1;
        if (g1 === g2) return 0;
        return g1 > g2 ? 1 : -1;
    };
    const $1cac8ef626479962$export$c70054835d4cf76 = (sprintsWithFutureDates, groupCombination = {})=>{
        const { team: team, sprint: sprint } = groupCombination;
        const findSprint = (arr)=>arr && (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('id', sprint), arr);
        return team ? findSprint(sprintsWithFutureDates.team[team]) : (0, $4nDwW.isDefined)(sprint) && findSprint(sprintsWithFutureDates.sprint[sprint]);
    };
    const $1cac8ef626479962$export$25033657b811db0f = (teamsByIdMap = {}, sprintsWithFutureDates = {
        team: {},
        sprint: {}
    })=>({ groupCombination: groupCombination1 }, { groupCombination: groupCombination2 })=>{
            if (!groupCombination2) return -1;
            if (!groupCombination1) return 1;
            const sprint1 = $1cac8ef626479962$export$c70054835d4cf76(sprintsWithFutureDates, groupCombination1);
            const sprint2 = $1cac8ef626479962$export$c70054835d4cf76(sprintsWithFutureDates, groupCombination2);
            if (!sprint1) return 1;
            if (!sprint2) return -1;
            let g1;
            let g2;
            const team1 = groupCombination1.team && teamsByIdMap[groupCombination1.team];
            const team2 = groupCombination2.team && teamsByIdMap[groupCombination2.team];
            if (sprint1.startDate === sprint2.startDate) {
                g1 = team1 && team1.title.toLowerCase();
                g2 = team2 && team2.title.toLowerCase();
                if (team1 && team2 && g1 === g2) {
                    g1 = sprint1.title.toLowerCase();
                    g2 = sprint2.title.toLowerCase();
                }
            } else {
                g1 = sprint1.startDate;
                g2 = sprint2.startDate;
            }
            if ((0, parcelRequire("lV634")).default(g1)) return 1;
            if ((0, parcelRequire("lV634")).default(g2)) return -1;
            if (g1 === g2) return 0;
            return g1 > g2 ? 1 : -1;
        };
    const $1cac8ef626479962$export$39d3423359f09c19 = (versionsById)=>({ groupCombination: groupCombination1 }, { groupCombination: groupCombination2 })=>{
            if (!groupCombination2) return -1;
            if (!groupCombination1) return 1;
            const release1 = (0, $4nDwW.isDefined)(groupCombination1.release) && versionsById[groupCombination1.release];
            const release2 = (0, $4nDwW.isDefined)(groupCombination2.release) && versionsById[groupCombination2.release];
            if (!release1) return 1;
            if (!release2) return -1;
            const g1 = release1.end;
            const g2 = release2.end;
            if ((0, parcelRequire("lV634")).default(g1)) return 1;
            if ((0, parcelRequire("lV634")).default(g2)) return -1;
            if (g1 === g2) return 0;
            return g1 > g2 ? 1 : -1;
        };
    const $1cac8ef626479962$export$2411a98ccc307764 = (groups, grouping, teamsById, versionsById = {}, sprintsWithFutureDates)=>{
        if (grouping === (0, $TTKUQ.GROUPING).SPRINT) return (0, parcelRequire("bQZTk")).default((0, parcelRequire("8r8wv")).default((0, parcelRequire("bvxTs")).default([
            'parentGroup'
        ], (0, $TTKUQ.COMPLETED_SPRINTS_GROUP))), (0, parcelRequire("4Rr1a")).default((0, parcelRequire("7Zjd1")).default($1cac8ef626479962$export$25033657b811db0f(teamsById, sprintsWithFutureDates))), (0, parcelRequire("j0d94")).default((0, parcelRequire("kSwbB")).default, []))(groups);
        if (grouping === (0, $TTKUQ.GROUPING).RELEASE) return (0, parcelRequire("bQZTk")).default((0, parcelRequire("8r8wv")).default((0, parcelRequire("bvxTs")).default([
            'parentGroup'
        ], (0, $TTKUQ.COMPLETED_RELEASES_GROUP))), (0, parcelRequire("4Rr1a")).default((0, parcelRequire("7Zjd1")).default($1cac8ef626479962$export$39d3423359f09c19(versionsById))), (0, parcelRequire("j0d94")).default((0, parcelRequire("kSwbB")).default, []))(groups);
        return groups.sort($1cac8ef626479962$export$56c13c77705fe953);
    };
    const $1cac8ef626479962$export$9c28870bc535869b = (grouping, group, filters, issues)=>{
        if (!group) return true;
        switch(grouping){
            case (0, $TTKUQ.GROUPING).ASSIGNEE:
                {
                    const filteredAssignees = filters[0, $cGbfF.ASSIGNEE_FILTER_ID].value;
                    return filteredAssignees.length === 0 || filteredAssignees.some((assignee)=>assignee === group);
                }
            case (0, $TTKUQ.GROUPING).REPORTER:
                {
                    const filteredReporters = filters[0, $cGbfF.REPORTER_FILTER_ID].value;
                    return filteredReporters.length === 0 || filteredReporters.some((reporter)=>reporter === group);
                }
            case (0, $TTKUQ.GROUPING).COMPONENT:
                {
                    const filteredComponents = filters[0, $cGbfF.COMPONENT_FILTER_ID].value;
                    if (filteredComponents.length === 0) return true;
                    return issues.some((issue)=>issue.components && !(0, parcelRequire("3nPAF")).default(issue.components) && (0, parcelRequire("4S1OS")).default(issue.components, filteredComponents).length > 0);
                }
            case (0, $TTKUQ.GROUPING).LABEL:
                {
                    const filteredLabels = filters[0, $cGbfF.LABEL_FILTER_ID].value;
                    if (filteredLabels.length === 0) return true;
                    if (filteredLabels.includes($1cac8ef626479962$export$dcda7e10772ff7e8)) return issues.some((issue)=>issue.labels && ((0, parcelRequire("3nPAF")).default(issue.labels) || (0, parcelRequire("4S1OS")).default(issue.labels, filteredLabels).length > 0));
                    return issues.some((issue)=>issue.labels && !(0, parcelRequire("3nPAF")).default(issue.labels) && (0, parcelRequire("4S1OS")).default(issue.labels, filteredLabels).length > 0);
                }
            case (0, $TTKUQ.GROUPING).PROJECT:
                {
                    const filteredProjects = filters[0, $cGbfF.PROJECT_FILTER_ID].value;
                    return filteredProjects.length === 0 || filteredProjects.some((project)=>project.toString() === group.toString());
                }
            case (0, $TTKUQ.GROUPING).RELEASE:
                {
                    const { value: filteredReleases, versionsFromCrossProjectReleaseFilterValue: filteredCPReleases = [] } = filters[0, $cGbfF.RELEASE_FILTER_ID];
                    return (filteredReleases.length === 0 || filteredReleases.some((project)=>project.toString() === group)) && (filteredCPReleases.length === 0 || filteredCPReleases.some((project)=>project.toString() === group));
                }
            case (0, $TTKUQ.GROUPING).SPRINT:
                {
                    const filteredSprints = filters[0, $cGbfF.SPRINT_FILTER_ID].value;
                    return filteredSprints.length === 0 || filteredSprints.some((sprint)=>sprint === group);
                }
            case (0, $TTKUQ.GROUPING).TEAM:
                {
                    const filteredTeams = filters[0, $cGbfF.TEAM_FILTER_ID].value;
                    return filteredTeams.length === 0 || filteredTeams.some((team)=>team === group);
                }
            default:
                return true;
        }
    };
    const $1cac8ef626479962$export$896f0b9c47e9ce0b = (issues, isExpanded, filters, sort, inlineCreateState, { isAtlasConnectInstalled: isAtlasConnectInstalled, grouping: grouping = (0, $TTKUQ.GROUPING).NONE }, issuesByGroupArg = {}, teamsById = {}, groupDetailsMap, expandedGroups, sprintsWithFutureDates, versionsById = {})=>{
        const { [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: { value: { start: start, end: end } } } = filters;
        const issuesById = (0, $4nDwW.indexBy)(({ id: id })=>id, issues);
        const issuesByParent = (0, $4nDwW.groupBy)(({ parent: parent })=>parent || 'Flow cannot get filter meaning', issues.filter(({ parent: parent })=>parent));
        let groups = [];
        let groupCount = 0;
        const getGroupDetailsFromMap = (id)=>{
            const unknownDetails = {
                name: $1cac8ef626479962$export$a06a68c30cc52c94,
                grouping: grouping,
                group: $1cac8ef626479962$export$dcda7e10772ff7e8
            };
            if (id) return groupDetailsMap?.[id] ?? unknownDetails;
            return unknownDetails;
        };
        if (grouping !== (0, $TTKUQ.GROUPING).NONE && !(grouping === (0, $TTKUQ.GROUPING).GOALS && !isAtlasConnectInstalled)) {
            const issuesByGroup = issuesByGroupArg;
            const groupAttribute = $1cac8ef626479962$export$66c297e813a21e25(grouping);
            for (const [groupMapKey, group] of Object.entries(issuesByGroup))if ($1cac8ef626479962$export$9c28870bc535869b(grouping, group[groupAttribute], filters, group.issues ? Array.from(group.issues) : [])) {
                const { issues: issues, parentGroup: parentGroup, ...groupCombination } = group;
                const groupKey = groupMapKey;
                const issuesInGroup = issues ? $1cac8ef626479962$export$9bdb9e03b1a7d7af(Array.from(issues), sort) : [];
                groupCount++;
                const { name: name, url: url } = getGroupDetailsFromMap(groupKey);
                const groupExpanded = $1cac8ef626479962$export$c3687f28f0f07b51(grouping, groupKey, expandedGroups);
                const scope = $1cac8ef626479962$export$cc6f39777f861b93(issuesInGroup, issuesByParent, issuesById, isExpanded, start, end, groupKey, groupCombination, issuesInGroup, true);
                let isParentGroupExpanded;
                if (parentGroup) isParentGroupExpanded = $1cac8ef626479962$export$c3687f28f0f07b51(grouping, parentGroup, expandedGroups);
                groups.push({
                    groupName: name,
                    grouping: grouping,
                    groupUrl: url,
                    scope: scope,
                    isExpanded: groupExpanded,
                    group: groupKey,
                    groupCombination: groupCombination,
                    ...(0, $4nDwW.isDefined)(parentGroup) ? {
                        parentGroup: parentGroup,
                        isParentGroupExpanded: isParentGroupExpanded
                    } : {}
                });
            }
            const { groupCombination: groupCombination, startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup } = inlineCreateState;
            if (startInlineCreateInEmptyGroup && groupCombination) {
                const groupKey = (0, $2QLMT.getGroupKey)(groupCombination);
                const { name: name, url: url } = getGroupDetailsFromMap(groupCombination[groupAttribute]);
                const groupExpanded = $1cac8ef626479962$export$c3687f28f0f07b51(grouping, groupKey, expandedGroups);
                const scope = $1cac8ef626479962$export$cc6f39777f861b93([], issuesByParent, issuesById, isExpanded, start, end, groupKey, groupCombination, []);
                groups.push({
                    groupName: name,
                    grouping: grouping,
                    groupUrl: url,
                    scope: scope,
                    isExpanded: groupExpanded,
                    group: groupKey,
                    groupCombination: groupCombination
                });
                groupCount++;
            }
            groups = $1cac8ef626479962$export$2411a98ccc307764(groups, grouping, teamsById, versionsById, sprintsWithFutureDates);
            const scope = {
                startLevelIssues: {
                    level: start,
                    issues: [],
                    rootIssuesCount: 0
                },
                issuesWithoutParent: [],
                issuesWithoutParentHeaderData: {
                    id: 'itemsWithoutParentsHeader',
                    isExpanded: true
                }
            };
            return {
                groupCount: groupCount,
                groups: groups,
                ...scope
            };
        }
        const scope = $1cac8ef626479962$export$cc6f39777f861b93(issues, issuesByParent, issuesById, isExpanded, start, end, undefined, undefined, undefined, true);
        groups.push({
            groupName: $1cac8ef626479962$export$dcda7e10772ff7e8,
            grouping: (0, $TTKUQ.GROUPING).NONE,
            group: $1cac8ef626479962$export$dcda7e10772ff7e8,
            scope: scope
        });
        return {
            groupCount: groupCount,
            groups: groups,
            ...scope
        };
    };
    const $1cac8ef626479962$export$611c3bba6a5df07a = (fullScope)=>{
        const visibleFilter = (scopeIssue)=>!!scopeIssue.parentsExpanded;
        const issuesWithoutParentMap = (scopeIssues)=>({
                ...scopeIssues,
                issues: scopeIssues.issues.filter(visibleFilter)
            });
        return {
            startLevelIssues: {
                ...fullScope.startLevelIssues,
                issues: fullScope.startLevelIssues.issues.filter(visibleFilter)
            },
            issuesWithoutParent: fullScope.issuesWithoutParent.map(issuesWithoutParentMap),
            issuesWithoutParentHeaderData: {
                ...fullScope.issuesWithoutParentHeaderData
            },
            extraIssues: fullScope.extraIssues ? fullScope.extraIssues.filter(visibleFilter) : undefined,
            groupCount: fullScope.groupCount,
            groups: fullScope.groups ? fullScope.groups.filter((group)=>group.grouping !== (0, $TTKUQ.GROUPING).NONE).map((group)=>group.isExpanded ? {
                    ...group,
                    scope: {
                        startLevelIssues: {
                            ...group.scope.startLevelIssues,
                            issues: group.scope.startLevelIssues.issues.filter(visibleFilter)
                        },
                        issuesWithoutParent: group.scope.issuesWithoutParent.map(issuesWithoutParentMap),
                        issuesWithoutParentHeaderData: {
                            ...group.scope.issuesWithoutParentHeaderData
                        },
                        extraIssues: group.scope.extraIssues ? group.scope.extraIssues.filter(visibleFilter) : undefined
                    }
                } : {
                    ...group,
                    scope: {
                        startLevelIssues: {
                            ...group.scope.startLevelIssues,
                            issues: [],
                            rootIssuesCount: 0
                        },
                        issuesWithoutParent: group.scope.issuesWithoutParent.map((scopeIssues)=>({
                                ...scopeIssues,
                                issues: [],
                                rootIssuesCount: 0
                            })),
                        issuesWithoutParentHeaderData: {
                            ...group.scope.issuesWithoutParentHeaderData
                        },
                        extraIssues: []
                    }
                }) : undefined
        };
    };
    const $1cac8ef626479962$export$2dc22532bb2facbd = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$a7e6813e541a5ff8,
        (0, $bI9dZ.getOriginalIssues)
    ], $1cac8ef626479962$export$1762232de55aae51);
    const $1cac8ef626479962$export$5e57a775e538d605 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssues),
        (0, $bI9dZ.getOriginalIssues)
    ], $1cac8ef626479962$export$1762232de55aae51);
    const $1cac8ef626479962$export$10ba2fa27c7f7e0c = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$5e57a775e538d605
    ], (allIssuesWithOriginalAndOptimized)=>(0, parcelRequire("4DrGU")).default((0, parcelRequire("2rMKg")).default('id'), allIssuesWithOriginalAndOptimized));
    const $1cac8ef626479962$var$getIssuesWithOriginalsAndOptimizedByGroup = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$2dc22532bb2facbd,
        (0, $j0XCX.getVisualisationGrouping),
        (0, $1CGdp.isOptimizedMode),
        $1cac8ef626479962$var$getGroupingData,
        (0, $1CGdp.isEmbed),
        (0, $1CGdp.isConfluenceMacro)
    ], $1cac8ef626479962$export$fbb72383d7fe83f);
    const $1cac8ef626479962$export$e10d3122e31e969c = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$2dc22532bb2facbd,
        (0, $1CGdp.isOptimizedMode)
    ], (issues, isOptimized)=>(0, parcelRequire("4wiYB")).default((issue)=>{
            const team = isOptimized ? (0, parcelRequire("fZhYM")).default([
                'optimized',
                'team'
            ], issue) : issue.team;
            return team || '';
        }, issues));
    const $1cac8ef626479962$export$f37748fb501e94bc = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getLabelsGroupViewSettings),
        (0, $kWDpn.getComponentGroupsViewSettings)
    ], (labelGroups, componentGroups)=>({
            labelGroups: labelGroups,
            componentGroups: componentGroups
        }));
    const $1cac8ef626479962$export$90e66d86e8725e1d = (issuesByGroup, grouping, labelAndComponentGroups = {}, teamsById = {}, sprintsByIdMap = {}, versionsById = {}, groupByCustomFieldDetailsMap, lazyGoalsByARI, projects, assignees, reporters, associatedIssues)=>{
        if (Object.keys(groupByCustomFieldDetailsMap).length > 0) return groupByCustomFieldDetailsMap;
        const groupDetails = {};
        if (grouping !== (0, $TTKUQ.GROUPING).NONE) for (const [groupKey, group] of Object.entries(issuesByGroup)){
            const groupAttribute = $1cac8ef626479962$export$66c297e813a21e25(grouping);
            if (groupKey) {
                const details = $1cac8ef626479962$export$213ef3bd851839cf(labelAndComponentGroups?.componentGroups ?? [], labelAndComponentGroups?.labelGroups ?? [], teamsById, projects ?? [], assignees ?? [], reporters ?? [], sprintsByIdMap, grouping, group[groupAttribute], versionsById, lazyGoalsByARI, associatedIssues);
                groupDetails[groupKey] = details;
            }
        }
        return groupDetails;
    };
    const $1cac8ef626479962$var$getGroupDetailsMapForCustomField = (groupId, grouping, isGroupByMultiValueCustomField, customFieldValuesGroups, customFieldsById, userPickerOptionsById, selectOptionsById)=>{
        const group = groupId;
        if (!group || group === $1cac8ef626479962$export$dcda7e10772ff7e8) return {
            name: $1cac8ef626479962$export$a06a68c30cc52c94,
            grouping: grouping,
            group: $1cac8ef626479962$export$dcda7e10772ff7e8
        };
        if (isGroupByMultiValueCustomField) {
            const customFieldValuesGroup = customFieldValuesGroups.find(({ id: id })=>id === group);
            return {
                name: customFieldValuesGroup?.name || $1cac8ef626479962$export$a06a68c30cc52c94,
                group: group,
                grouping: grouping
            };
        }
        const fieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
        const customField = customFieldsById[fieldId];
        if (customField) {
            if (customField.type.key === (0, $TTKUQ.CustomFieldTypes).UserPicker) {
                const option = userPickerOptionsById[group];
                return {
                    name: option ? option.label : $1cac8ef626479962$export$a06a68c30cc52c94,
                    group: group,
                    grouping: grouping,
                    url: option ? option.icon : ''
                };
            }
            const option = selectOptionsById[group];
            return {
                name: option ? option.value : $1cac8ef626479962$export$a06a68c30cc52c94,
                group: group,
                grouping: grouping
            };
        }
        return {
            name: $1cac8ef626479962$export$a06a68c30cc52c94,
            grouping: grouping,
            group: group
        };
    };
    const $1cac8ef626479962$var$getGroupDetailsMapForCustomFieldSelector = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$var$getIssuesWithOriginalsAndOptimizedByGroup,
        (0, $j0XCX.getVisualisationGrouping),
        (0, $19iju.getCustomFieldsById),
        (0, $19iju.getSelectOptionsById),
        (0, $j0XCX.getCustomFieldValuesGroups),
        (0, $j0XCX.isGroupByMultiValueCustomField),
        (0, $19iju.getUserPickerOptionsUserListById)
    ], (issuesByGroup, grouping, customFieldsById, selectOptionsById, customFieldValuesGroups, isGroupByMultiValueCustomField, userPickerOptionsById)=>{
        const groupDetails = {};
        if ((0, $cScrq.isRoadmapGroupedByCustomField)(grouping)) for (const [groupKey, issuesGroup] of Object.entries(issuesByGroup)){
            const groupAttribute = $1cac8ef626479962$export$66c297e813a21e25(grouping);
            if (groupKey) {
                const details = $1cac8ef626479962$var$getGroupDetailsMapForCustomField(issuesGroup[groupAttribute], grouping, isGroupByMultiValueCustomField, customFieldValuesGroups, customFieldsById, userPickerOptionsById, selectOptionsById);
                groupDetails[groupKey] = details;
            }
        }
        return groupDetails;
    });
    const $1cac8ef626479962$var$getGroupDetailsMap = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$var$getIssuesWithOriginalsAndOptimizedByGroup,
        (0, $j0XCX.getVisualisationGrouping),
        $1cac8ef626479962$export$f37748fb501e94bc,
        (0, $dRVQG.getAllTeamsById),
        $1cac8ef626479962$export$d7ad569e206d3043,
        (0, $9FFuD.getVersionsById),
        $1cac8ef626479962$var$getGroupDetailsMapForCustomFieldSelector,
        (0, $bZA5o.getLazyGoalsByARI),
        (0, $jpXKt.getProjects),
        (0, $hu7Cn.getAssigneeList),
        (0, $bzDof.getUniqueReportersOfIssues),
        (0, $9SFhm.getAssociatedIssues)
    ], $1cac8ef626479962$export$90e66d86e8725e1d);
    const $1cac8ef626479962$var$getGroupingWithIsAtlasConnectInstalled = (0, $3YtPS.createSelector)([
        (0, $jpgxP.isAtlasConnectInstalled),
        (0, $j0XCX.getVisualisationGrouping)
    ], (isAtlasConnectInstalled, grouping)=>({
            isAtlasConnectInstalled: isAtlasConnectInstalled,
            grouping: grouping
        }));
    const $1cac8ef626479962$export$1641f2070ecb49b2 = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$2dc22532bb2facbd,
        $1cac8ef626479962$export$8c797d2c6f8c1a2b,
        (0, $iIikD.getFilters),
        (0, $ja8Lc.getSort),
        (0, $gk0jw.getInlineCreateState),
        $1cac8ef626479962$var$getGroupingWithIsAtlasConnectInstalled,
        $1cac8ef626479962$var$getIssuesWithOriginalsAndOptimizedByGroup,
        (0, $dRVQG.getAllTeamsById),
        $1cac8ef626479962$var$getGroupDetailsMap,
        $1cac8ef626479962$var$getExpandedGroups,
        (0, $ljmcc.getSprintsWithFutureDates),
        (0, $9FFuD.getVersionsById)
    ], $1cac8ef626479962$export$896f0b9c47e9ce0b);
    const $1cac8ef626479962$export$5d887aaef2abf9e2 = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$1641f2070ecb49b2
    ], $1cac8ef626479962$export$611c3bba6a5df07a);
    const $1cac8ef626479962$export$6a9094aa95a25d0d = (scope)=>{
        if (scope.groupCount !== undefined && scope.groupCount > 0) {
            const issueIds = new Set();
            (scope.groups ?? []).forEach((group)=>{
                if (group.parentGroup !== undefined) {
                    if (group.isParentGroupExpanded && group.isExpanded) $1cac8ef626479962$export$c3ff3eda8ed23c68(group.scope).forEach((id)=>{
                        issueIds.add(id);
                    });
                } else if (group.isExpanded) $1cac8ef626479962$export$c3ff3eda8ed23c68(group.scope).forEach((id)=>{
                    issueIds.add(id);
                });
            });
            return issueIds.size;
        }
        return $1cac8ef626479962$export$c3ff3eda8ed23c68(scope).size;
    };
    const $1cac8ef626479962$export$c3ff3eda8ed23c68 = (scope)=>{
        const issueIds = new Set();
        scope.startLevelIssues.issues.forEach((issue)=>{
            issueIds.add(issue.id);
        });
        if (scope.issuesWithoutParentHeaderData.isExpanded) (scope.issuesWithoutParent ?? []).forEach((section)=>{
            if (section.isExpanded) section.issues.forEach((issue)=>{
                issueIds.add(issue.id);
            });
        });
        return issueIds;
    };
    const $1cac8ef626479962$export$190897ce30bb27ad = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$5d887aaef2abf9e2
    ], $1cac8ef626479962$export$6a9094aa95a25d0d);
    const $1cac8ef626479962$export$1664b92369554829 = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Header.Search.searchQuery;
    const $1cac8ef626479962$export$e467ab9db30aa64c = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Header.Search.activeSearchResultIndex;
    const $1cac8ef626479962$export$642c6002a1fbcb9c = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Header.Search.isSearchBoxOpen;
    const $1cac8ef626479962$export$6f6fcc622ed0431a = (string)=>string.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    const $1cac8ef626479962$export$f02f6625a39c8cf2 = (searchQuery)=>new RegExp(`(${$1cac8ef626479962$export$6f6fcc622ed0431a(searchQuery)})`, 'gi');
    const $1cac8ef626479962$export$d05bbe0328e41cc6 = (searchQuery, title)=>(0, parcelRequire("b1yMp")).default((0, parcelRequire("jVZZA")).default((0, parcelRequire("83IGl")).default), (0, parcelRequire("1T7bg")).default($1cac8ef626479962$export$f02f6625a39c8cf2(searchQuery)))(title);
    const $1cac8ef626479962$export$d9ffdbc590df6d8a = (str1, str2)=>(0, parcelRequire("8EB5I")).default((0, parcelRequire("hpnKp")).default(str1), (0, parcelRequire("hpnKp")).default(str2));
    const $1cac8ef626479962$export$cf96ff633ce1ed2a = (projectsById, { issueKey: issueKey, project: project })=>{
        let issueLink = `${issueKey || ''}`;
        if ((0, $4nDwW.isDefined)(project) && (0, $4nDwW.isDefined)(projectsById[project])) issueLink = `${projectsById[project].key}${issueKey ? `-${issueKey}` : ''}`;
        return issueLink;
    };
    const $1cac8ef626479962$export$2bbb1aef9a2e8a75 = (issueLink, searchQuery, issue)=>(0, parcelRequire("gCN7c")).default(`${issueLink} ${issue.summary}`.match(new RegExp($1cac8ef626479962$export$6f6fcc622ed0431a(searchQuery), 'gi')) || []);
    const $1cac8ef626479962$export$6134a38b10ca9c9d = (allIssuesByGroup, scope, filteredIssuesById, projects, grouping, isSearchBoxOpen, searchQuery, issueFilterMatcherWithFilterId)=>{
        const results = {
            hasNestedMatches: {},
            total: 0,
            resultsHiddenByFilter: [],
            searchMatches: []
        };
        if (!isSearchBoxOpen || searchQuery.trim() === '') return results;
        const projectsById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), projects);
        const isChunkAlreadyInSearchMatches = (internalIndex, id, linkMatch, group)=>results.searchMatches.find((match)=>[
                    match.internalIndex,
                    match.id,
                    match.linkMatch,
                    match.group
                ].join('|') === [
                    internalIndex,
                    id,
                    linkMatch,
                    group
                ].join('|'));
        const searchForMatchingIssuesInGroup = (issue, group)=>{
            const { id: id, summary: summary, parent: parent } = issue;
            const issueLink = $1cac8ef626479962$export$cf96ff633ce1ed2a(projectsById, issue);
            const total = $1cac8ef626479962$export$2bbb1aef9a2e8a75(issueLink, searchQuery, issue);
            if (total && filteredIssuesById[id]) {
                if (parent) results.hasNestedMatches = (0, parcelRequire("dXWaA")).default(results.hasNestedMatches, {
                    [`${group}`]: {
                        [parent]: true
                    }
                });
                let internalIndex = 0;
                const linkChunks = $1cac8ef626479962$export$d05bbe0328e41cc6(searchQuery, issueLink);
                for (const chunk of linkChunks){
                    if ($1cac8ef626479962$export$d9ffdbc590df6d8a(chunk, searchQuery) && !isChunkAlreadyInSearchMatches(internalIndex, id, true, group)) {
                        results.searchMatches.push({
                            internalIndex: internalIndex,
                            id: id,
                            linkMatch: true,
                            group: group
                        });
                        results.total += 1;
                    }
                    internalIndex++;
                }
                const summaryChunks = $1cac8ef626479962$export$d05bbe0328e41cc6(searchQuery, summary);
                for (const chunk of summaryChunks){
                    if ($1cac8ef626479962$export$d9ffdbc590df6d8a(chunk, searchQuery) && !isChunkAlreadyInSearchMatches(internalIndex, id, false, group)) {
                        results.searchMatches.push({
                            internalIndex: internalIndex,
                            id: id,
                            linkMatch: false,
                            group: group
                        });
                        results.total += 1;
                    }
                    internalIndex++;
                }
            }
        };
        const browseIssuesInGroup = (scope, group)=>{
            const { startLevelIssues: startLevelIssues, issuesWithoutParent: issuesWithoutParent } = scope;
            const flattenIssuesWithoutParent = (0, parcelRequire("SZGT2")).default((0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('issues'), issuesWithoutParent));
            const issueGroup = grouping !== (0, $TTKUQ.GROUPING).NONE ? group : '';
            const allIssues = [
                ...startLevelIssues.issues,
                ...flattenIssuesWithoutParent
            ];
            allIssues.forEach((issue)=>{
                searchForMatchingIssuesInGroup(issue, issueGroup);
            });
        };
        scope.groups.forEach(({ scope: scope, group: group })=>{
            browseIssuesInGroup(scope, group);
        });
        (0, parcelRequire("bjzU8")).default(allIssuesByGroup).forEach((group)=>{
            [
                ...group.issues
            ].forEach((issue)=>{
                const issueLink = $1cac8ef626479962$export$cf96ff633ce1ed2a(projectsById, issue);
                const total = $1cac8ef626479962$export$2bbb1aef9a2e8a75(issueLink, searchQuery, issue);
                if (total && !filteredIssuesById[issue.id]) results.resultsHiddenByFilter.push({
                    id: issue.id,
                    unmatchedFilters: issueFilterMatcherWithFilterId(issue)
                });
            });
        });
        return results;
    };
    const $1cac8ef626479962$export$df7b5ec530ae24ca = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$2d0a064b4b76d506,
        $1cac8ef626479962$export$1641f2070ecb49b2,
        (0, $bI9dZ.getFilteredIssuesWithHierarchyById),
        (0, $jpXKt.getProjects),
        (0, $j0XCX.getVisualisationGrouping),
        $1cac8ef626479962$export$642c6002a1fbcb9c,
        $1cac8ef626479962$export$1664b92369554829,
        (0, $bI9dZ.getIssueFilterMatcherWithFilterId)
    ], $1cac8ef626479962$export$6134a38b10ca9c9d);
    const $1cac8ef626479962$export$24686634b40470a0 = ({ searchMatches: searchMatches }, activeSearchResultIndex)=>(0, $4nDwW.isDefined)(searchMatches[activeSearchResultIndex]) ? searchMatches[activeSearchResultIndex] : undefined;
    const $1cac8ef626479962$export$6ab3c2d73db706ef = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$df7b5ec530ae24ca,
        $1cac8ef626479962$export$e467ab9db30aa64c
    ], $1cac8ef626479962$export$24686634b40470a0);
    const $1cac8ef626479962$export$67b67276ed3edc87 = (issuesByGroup)=>{
        const map = {};
        for (const { issues: issues = new Set(), parentGroup: parentGroup, ...groupCombination } of (0, parcelRequire("bjzU8")).default(issuesByGroup))for (const issue of issues){
            if (!map[issue.id]) map[issue.id] = [];
            map[issue.id].push({
                groupCombination: groupCombination,
                parentGroup: parentGroup
            });
        }
        return map;
    };
    const $1cac8ef626479962$export$269e836147dd799c = (0, $3YtPS.createSelector)($1cac8ef626479962$export$97e315c357c4faa0, $1cac8ef626479962$export$67b67276ed3edc87);
    const $1cac8ef626479962$export$66039435427a1c15 = (0, $3YtPS.createSelector)([
        $1cac8ef626479962$export$5d887aaef2abf9e2
    ], ({ groups: groups })=>groups?.map(({ scope: scope, ...group })=>group) ?? []);
});
parcelRegister("4S1OS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38bd9deb123c9d0d$export$2e2bcd8739ae039);
    var $4MZp5;
    var $c9RLn;
    var $hMKEN;
    var $gfe9F;
    var $d8iBX;
    var $38bd9deb123c9d0d$var$intersection = (0, (0, parcelRequire("c9RLn")).default)(function intersection(list1, list2) {
        var lookupList, filteredList;
        if (list1.length > list2.length) {
            lookupList = list1;
            filteredList = list2;
        } else {
            lookupList = list2;
            filteredList = list1;
        }
        return (0, (0, parcelRequire("d8iBX")).default)((0, (0, parcelRequire("hMKEN")).default)((0, (0, parcelRequire("gfe9F")).default)((0, (0, parcelRequire("4MZp5")).default))(lookupList), filteredList));
    });
    var $38bd9deb123c9d0d$export$2e2bcd8739ae039 = $38bd9deb123c9d0d$var$intersection;
});
parcelRegister("gfe9F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd3906eafb18e86b$export$2e2bcd8739ae039);
    var $ccUYa;
    var $9J1HQ;
    var $bd3906eafb18e86b$var$flip = (0, (0, parcelRequire("ccUYa")).default)(function flip(fn) {
        return (0, (0, parcelRequire("9J1HQ")).default)(fn.length, function(a, b) {
            var args = Array.prototype.slice.call(arguments, 0);
            args[0] = b;
            args[1] = a;
            return fn.apply(this, args);
        });
    });
    var $bd3906eafb18e86b$export$2e2bcd8739ae039 = $bd3906eafb18e86b$var$flip;
});
parcelRegister("gCN7c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1a64b3754ecba40$export$2e2bcd8739ae039);
    var $ccUYa;
    var $lfT53;
    var $c1a64b3754ecba40$var$length = (0, (0, parcelRequire("ccUYa")).default)(function length(list) {
        return list != null && (0, (0, parcelRequire("lfT53")).default)(list.length) ? list.length : NaN;
    });
    var $c1a64b3754ecba40$export$2e2bcd8739ae039 = $c1a64b3754ecba40$var$length;
});
parcelRegister("lfT53", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f795b98e0092a5c8$export$2e2bcd8739ae039);
    function $f795b98e0092a5c8$export$2e2bcd8739ae039(x) {
        return Object.prototype.toString.call(x) === '[object Number]';
    }
});
parcelRegister("dXWaA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2ade8596520c9d6$export$2e2bcd8739ae039);
    var $c9RLn;
    var $ejhbF;
    var $a2ade8596520c9d6$var$mergeDeepLeft = (0, (0, parcelRequire("c9RLn")).default)(function mergeDeepLeft(lObj, rObj) {
        return (0, (0, parcelRequire("ejhbF")).default)(function(k, lVal, rVal) {
            return lVal;
        }, lObj, rObj);
    });
    var $a2ade8596520c9d6$export$2e2bcd8739ae039 = $a2ade8596520c9d6$var$mergeDeepLeft;
});
parcelRegister("bvxTs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$860ce183dffa87e2$export$2e2bcd8739ae039);
    var $IYMZh;
    var $8EB5I;
    var $fZhYM;
    var $860ce183dffa87e2$var$pathEq = (0, (0, parcelRequire("IYMZh")).default)(function pathEq(_path, val, obj) {
        return (0, (0, parcelRequire("8EB5I")).default)((0, (0, parcelRequire("fZhYM")).default)(_path, obj), val);
    });
    var $860ce183dffa87e2$export$2e2bcd8739ae039 = $860ce183dffa87e2$var$pathEq;
});
parcelRegister("cn3Ob", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$901a964bff635515$export$2e2bcd8739ae039);
    var $c9RLn;
    var $lfT53;
    var $901a964bff635515$var$range = (0, (0, parcelRequire("c9RLn")).default)(function range(from, to) {
        if (!((0, (0, parcelRequire("lfT53")).default)(from) && (0, (0, parcelRequire("lfT53")).default)(to))) throw new TypeError('Both arguments to range must be numbers');
        var result = [];
        var n = from;
        while(n < to){
            result.push(n);
            n += 1;
        }
        return result;
    });
    var $901a964bff635515$export$2e2bcd8739ae039 = $901a964bff635515$var$range;
});
parcelRegister("1T7bg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16007f7328c1e88a$export$2e2bcd8739ae039);
    var $6huGS;
    var $16007f7328c1e88a$var$split = (0, (0, parcelRequire("6huGS")).default)(1, 'split');
    var $16007f7328c1e88a$export$2e2bcd8739ae039 = $16007f7328c1e88a$var$split;
});
parcelRegister("9SFhm", function(module, exports) {
    $parcel$export(module.exports, "getAssociatedIssues", ()=>$1def17f5f39e9395$export$b5b4d0e5ac99bf25);
    const $1def17f5f39e9395$export$b5b4d0e5ac99bf25 = (state)=>state.domain.associatedIssues.associatedIssues ?? {};
});
parcelRegister("gk0jw", function(module, exports) {
    $parcel$export(module.exports, "getInlineCreateState", ()=>$3fe597b312537e17$export$b165df9027afb05a);
    var $3YtPS = parcelRequire("3YtPS");
    var $cy8s7 = parcelRequire("cy8s7");
    const $3fe597b312537e17$export$b165df9027afb05a = (state)=>state.ui.Main.Tabs.Roadmap.Scope.InlineCreate;
    const $3fe597b312537e17$var$getInlineCreatePositionPure = (inlineState)=>({
            isOpen: inlineState.isOpen,
            parentId: inlineState.parentId,
            hierarchyLevel: inlineState.hierarchyLevel
        });
    const $3fe597b312537e17$export$552de75b329ed590 = (0, $3YtPS.createSelector)([
        $3fe597b312537e17$export$b165df9027afb05a
    ], $3fe597b312537e17$var$getInlineCreatePositionPure);
});
parcelRegister("gg3Ds", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f61244520d760156$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $4R6GH;
    var $8RXs9;
    var $darOt = parcelRequire("darOt");
    var $ixSW4 = parcelRequire("ixSW4");
    var $f0bWg = parcelRequire("f0bWg");
    var $9wQxR = parcelRequire("9wQxR");
    var $gs2Kp = parcelRequire("gs2Kp");
    function $f61244520d760156$var$Description({ issueSearchResults: { resultsHiddenByFilter: resultsHiddenByFilter }, issuesById: issuesById, projectsById: projectsById, issueTypesById: issueTypesById, intl: intl, IssueSearchWarningClearFilter: IssueSearchWarningClearFilter }) {
        const showHiddenIssuesList = resultsHiddenByFilter && resultsHiddenByFilter.length > 0 && resultsHiddenByFilter.length <= 2;
        const unMatchedFiltersOld = (0, $5uXOq.useCallback)((unmatchedFilter)=>{
            if (unmatchedFilter.type === 'custom') return unmatchedFilter.filters.map((e)=>e.title).join(', ');
            return intl.formatMessage((0, $darOt.default)[unmatchedFilter.id]);
        }, [
            intl
        ]);
        const unMatchedFilters = (0, $5uXOq.useCallback)((unmatchedFilter)=>{
            if (unmatchedFilter.type === 'custom') return unmatchedFilter.filters.map((e)=>e.title).join(', ');
            const { id: id } = unmatchedFilter;
            if (Object.prototype.hasOwnProperty.call((0, $darOt.default), id)) return intl.formatMessage((0, $darOt.default)[id]);
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('plans.issue-search-warning-flag.filterNameMessages', 'unmatchedFilter id not found in filterNameMessages');
            return '';
        }, [
            intl
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.description.issue-search"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gs2Kp.messageText
        }, intl.formatMessage((0, $9wQxR.default).hiddenByFilterBody, {
            filterCount: resultsHiddenByFilter.length
        }), !showHiddenIssuesList && intl.formatMessage((0, $9wQxR.default).hiddenByClearFilterBody)), showHiddenIssuesList && resultsHiddenByFilter.map((item, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $f0bWg.default), {
                issue: issuesById[item.id],
                projectKey: projectsById[issuesById[item.id].project.toString()].key,
                issueType: issueTypesById[issuesById[item.id].type.toString()]
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gs2Kp.filterDetails
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gs2Kp.filters
            }, intl.formatMessage((0, $9wQxR.default).hiddenByFilterLabel), item.unmatchedFilters.map((0, (0, parcelRequire("4R6GH")).fg)('issue-search-intl-bug-fix') ? unMatchedFilters : unMatchedFiltersOld).join(', ')), (0, ($parcel$interopDefault($5uXOq))).createElement(IssueSearchWarningClearFilter, {
                filters: item.unmatchedFilters
            })))));
    }
    var $f61244520d760156$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)((0, $ixSW4.withSlots)({
        IssueSearchWarningClearFilter: (0, $ixSW4.slots).IssueSearchWarningClearFilter
    })($f61244520d760156$var$Description));
});
parcelRegister("darOt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1589fd742b87bf58$export$2e2bcd8739ae039);
    var $7VHMR;
    const $1589fd742b87bf58$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        dialogLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dialog-label",
            "defaultMessage": "Filter dialog"
        },
        header: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.header",
            "defaultMessage": "Filter"
        },
        headerOld: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.header-old",
            "defaultMessage": "Filters"
        },
        clearAllFiltersLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.clear-all-filters-label",
            "defaultMessage": "Clear all filters"
        },
        selected: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.selected",
            "defaultMessage": "selected"
        },
        'state.domain.view-settings.filters.HIERARCHY_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter-id",
            "defaultMessage": "Hierarchy"
        },
        'state.domain.view-settings.filters.PROJECT_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter-id",
            "defaultMessage": "Projects"
        },
        'state.domain.view-settings.filters.ISSUE_TYPE_KEY_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-type-key-filter-id",
            "defaultMessage": "Issue types"
        },
        'state.domain.view-settings.filters.ISSUE_PRIORITIES_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter-id",
            "defaultMessage": "Priorities"
        },
        'state.domain.view-settings.filters.RELEASE_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter-id",
            "defaultMessage": "Releases"
        },
        'state.domain.view-settings.filters.SUMMARY_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.summary-filter-id",
            "defaultMessage": "Issue details"
        },
        'state.domain.view-settings.filters.TEAM_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter-id",
            "defaultMessage": "Teams"
        },
        'state.domain.view-settings.filters.ASSIGNEE_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter-id",
            "defaultMessage": "Assignees"
        },
        'state.domain.view-settings.filters.REPORTER_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter-id",
            "defaultMessage": "Reporters"
        },
        'state.domain.view-settings.filters.DEPENDENCIES_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter-id",
            "defaultMessage": "Dependencies"
        },
        'state.domain.view-settings.filters.LABEL_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter-id",
            "defaultMessage": "Labels"
        },
        'state.domain.view-settings.filters.STATUS_KEY_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter-id",
            "defaultMessage": "Statuses"
        },
        'state.domain.view-settings.filters.COMPONENT_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter-id",
            "defaultMessage": "Components"
        },
        'state.domain.view-settings.filters.ISSUE_WARNING_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-warning-filter-id",
            "defaultMessage": "Warnings"
        },
        'state.domain.view-settings.filters.SPRINT_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter-id",
            "defaultMessage": "Sprints"
        },
        'state.domain.view-settings.filters.GOAL_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter-id",
            "defaultMessage": "Goals"
        },
        'state.domain.view-settings.filters.IDEA_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.idea-filter-id",
            "defaultMessage": "Ideas"
        },
        'state.domain.view-settings.filters.DATE_RANGE_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.date-range-filter-id",
            "defaultMessage": "Date range"
        },
        'state.domain.view-settings.filters.HIERARCHY_RANGE_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-range-filter-id",
            "defaultMessage": "Hierarchy"
        },
        'state.domain.view-settings.filters.CROSS_PROJECT_RELEASE_FILTER_ID': {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.cross-project-release-filter-id",
            "defaultMessage": "Cross project release"
        }
    });
    var $1589fd742b87bf58$export$2e2bcd8739ae039 = $1589fd742b87bf58$var$messages;
});
parcelRegister("f0bWg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9a7f70448949fd6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8CUq3;
    var $3bDjY;
    var $2FvnI;
    var $uT3PH = parcelRequire("uT3PH");
    function $b9a7f70448949fd6$export$2e2bcd8739ae039(props) {
        const { issue: issue, issueType: issueType, projectKey: projectKey } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: issue.summary
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $uT3PH.issueTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $uT3PH.issueIcon,
            style: {
                backgroundImage: issueType && `url(${issueType.iconUrl})`
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $uT3PH.issueSummary
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvnI")).default), {
            issueKey: issue.issueKey,
            projectKey: projectKey,
            xcssStyles: $b9a7f70448949fd6$var$issueLinkStyles
        }), issue.summary)));
    }
    const $b9a7f70448949fd6$var$issueLinkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        marginRight: 'space.075'
    });
});
parcelRegister("2FvnI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33a521d9c353e74c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhmo0;
    var $8CUq3;
    var $4R6GH;
    var $fb9D1;
    function $33a521d9c353e74c$export$2e2bcd8739ae039(props) {
        const { projectKey: projectKey, issueKey: issueKey, issueId: issueId, xcssStyles: xcssStyles, children: children } = props;
        const fullIssueKey = issueKey ? `${projectKey}-${issueKey}` : projectKey;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            href: (0, (0, parcelRequire("fb9D1")).proxyContextSafeUrl)(`/browse/${fullIssueKey}`),
            rel: "noopener noreferrer",
            id: issueId && `issue-link-${issueId}`,
            xcss: [
                $33a521d9c353e74c$var$anchorStyles,
                ...xcssStyles ? [
                    xcssStyles
                ] : []
            ],
            target: "_blank",
            draggable: (0, (0, parcelRequire("4R6GH")).fg)('allows_dragging_an_issue_from_issue_link') ? false : undefined
        }, children || fullIssueKey);
    }
    const $33a521d9c353e74c$var$anchorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        outlineOffset: 'space.0'
    });
});
parcelRegister("fb9D1", function(module, exports) {
    $parcel$export(module.exports, "proxyContextSafeUrl", ()=>$b99acc067b5c8cc7$export$ff2a151586ba6aa1);
    const $b99acc067b5c8cc7$export$ff2a151586ba6aa1 = (url)=>`${window.integrationApiUrl || window.AJS && window.AJS.contextPath && window.AJS.contextPath() || ''}${url}`;
});
parcelRegister("uT3PH", function(module, exports) {
    $parcel$export(module.exports, "issueIcon", ()=>$05cd83638f346936$export$415983cbc1f2b3fe, (v)=>$05cd83638f346936$export$415983cbc1f2b3fe = v);
    $parcel$export(module.exports, "issueSummary", ()=>$05cd83638f346936$export$7c7bc027bbbea103, (v)=>$05cd83638f346936$export$7c7bc027bbbea103 = v);
    $parcel$export(module.exports, "issueTitle", ()=>$05cd83638f346936$export$12781bd67c11efd8, (v)=>$05cd83638f346936$export$12781bd67c11efd8 = v);
    var $05cd83638f346936$export$415983cbc1f2b3fe;
    var $05cd83638f346936$export$7c7bc027bbbea103;
    var $05cd83638f346936$export$12781bd67c11efd8;
    $05cd83638f346936$export$415983cbc1f2b3fe = `R8WuXW_issueIcon`;
    $05cd83638f346936$export$7c7bc027bbbea103 = `R8WuXW_issueSummary`;
    $05cd83638f346936$export$12781bd67c11efd8 = `R8WuXW_issueTitle`;
});
parcelRegister("9wQxR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e31b375960f91582$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e31b375960f91582$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        hiddenByFilterBody: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.description.hidden-by-filter-body",
            "defaultMessage": "{filterCount} matching {filterCount, plural, one {issue is} other {issues are}} not displaying due to the filters being used in the plan."
        },
        hiddenByClearFilterBody: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.description.hidden-by-clear-filter-body",
            "defaultMessage": " Clear all filters, then try again."
        },
        hiddenByFilterLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.description.hidden-by-filter-label",
            "defaultMessage": "Hidden by: "
        }
    });
});
parcelRegister("gs2Kp", function(module, exports) {
    $parcel$export(module.exports, "filterDetails", ()=>$bfa1647710d1b92d$export$f6b2c2cc1afb66a, (v)=>$bfa1647710d1b92d$export$f6b2c2cc1afb66a = v);
    $parcel$export(module.exports, "filters", ()=>$bfa1647710d1b92d$export$82462a21aead86ed, (v)=>$bfa1647710d1b92d$export$82462a21aead86ed = v);
    $parcel$export(module.exports, "messageText", ()=>$bfa1647710d1b92d$export$c43aefe7b0ad01ce, (v)=>$bfa1647710d1b92d$export$c43aefe7b0ad01ce = v);
    var $bfa1647710d1b92d$export$f6b2c2cc1afb66a;
    var $bfa1647710d1b92d$export$82462a21aead86ed;
    var $bfa1647710d1b92d$export$c43aefe7b0ad01ce;
    $bfa1647710d1b92d$export$f6b2c2cc1afb66a = `NbYNVa_filterDetails`;
    $bfa1647710d1b92d$export$82462a21aead86ed = `NbYNVa_filters`;
    $bfa1647710d1b92d$export$c43aefe7b0ad01ce = `NbYNVa_messageText`;
});
parcelRegister("g5RJ7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$def31409cd6fdc9f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $def31409cd6fdc9f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        hiddenByFilterTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.hidden-by-filter-title",
            "defaultMessage": "Matching results currently not visible"
        }
    });
});
parcelRegister("ZMqjm", function(module, exports) {
    $parcel$export(module.exports, "getJSWNoAccessErrorFlag", ()=>$c3d7c6a17320ac93$export$f180b5dec38323d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nnPp;
    var $d4xRU;
    var $ousew;
    var $gJZ5D;
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    var $aKYsM = parcelRequire("aKYsM");
    const $c3d7c6a17320ac93$export$f180b5dec38323d9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            key: "jsw-no-access-error",
            id: "jsw-no-access-error",
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
                sourceName: "nswNoAccessError"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
                onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $aKYsM.default).title)),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $aKYsM.default).descriptionSpork),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                label: "",
                primaryColor: `var(--ds-icon-danger, ${(0, (0, parcelRequire("gJZ5D")).default).R300})`
            })
        });
});
parcelRegister("aKYsM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4f05faad298dd13$export$2e2bcd8739ae039);
    var $7VHMR;
    const $e4f05faad298dd13$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.jsw-no-access-error-flag.title",
            "defaultMessage": "This plan isn't available"
        },
        descriptionSpork: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.jsw-no-access-error-flag.description-spork",
            "defaultMessage": "Your Jira permissions have changed, and you can no longer view this plan. Contact an administrator to restore access."
        }
    });
    var $e4f05faad298dd13$export$2e2bcd8739ae039 = $e4f05faad298dd13$var$messages;
});
parcelRegister("20VBk", function(module, exports) {
    $parcel$export(module.exports, "getProjectLimitWarningFlag", ()=>$90f2a85b6c4ecfbe$export$1fe8482a6799df4d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nnPp;
    var $d4xRU;
    var $ousew;
    var $gJZ5D;
    var $idmiV = parcelRequire("idmiV");
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    var $bOFra = parcelRequire("bOFra");
    const $90f2a85b6c4ecfbe$export$1fe8482a6799df4d = ()=>{
        const handleUpdateIssueSourcesButtonClick = (_, analyticsEvent)=>{
            const { id: planId } = (0, $idmiV.getPathParams)();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                actionSubject: 'projectLimitWarningModal',
                action: 'updateLinkClicked'
            }));
            (0, $idmiV.redirectToIssueSourceSetup)(planId);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            key: "project-limit-warning",
            id: "project-limit-warning",
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
                sourceName: "projectLimitWarning"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
                onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bOFra.default).title)),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bOFra.default).description),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                label: "ProjectLimitException",
                primaryColor: `var(--ds-icon-danger, ${(0, (0, parcelRequire("gJZ5D")).default).R400})`
            }),
            actions: [
                {
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bOFra.default).updateEditIssueSources),
                    onClick: handleUpdateIssueSourcesButtonClick
                }
            ]
        });
    };
});
parcelRegister("bOFra", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f1ae246fe77e5f4$export$2e2bcd8739ae039);
    var $7VHMR;
    const $0f1ae246fe77e5f4$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.project-limit-warning-flag.title",
            "defaultMessage": "Your plan includes too many projects"
        },
        description: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.project-limit-warning-flag.description",
            "defaultMessage": "The number of projects in your plan exceeds the limit set by your administrator. Select fewer issue sources to continue."
        },
        updateEditIssueSources: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.project-limit-warning-flag.update-edit-issue-sources",
            "defaultMessage": "Configure issue sources"
        }
    });
    var $0f1ae246fe77e5f4$export$2e2bcd8739ae039 = $0f1ae246fe77e5f4$var$messages;
});
parcelRegister("5MKXV", function(module, exports) {
    $parcel$export(module.exports, "getReparentCMPWarningFlag", ()=>$d671a5bae59a7566$export$f7c3261e72e1f2af);
    var $5uXOq = parcelRequire("5uXOq");
    var $gtreQ;
    var $d4xRU;
    var $ousew;
    var $gJZ5D;
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    var $a2bZa = parcelRequire("a2bZa");
    const $d671a5bae59a7566$export$f7c3261e72e1f2af = ({ context: context })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            key: "reparent-cmp-warning",
            id: "reparent-cmp-warning",
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
                sourceName: "getReparentCMPWarningFlag"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
                onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $a2bZa.default).title)),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $a2bZa.default).description,
                values: context
            }),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                label: "",
                primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
            })
        });
});
parcelRegister("a2bZa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8c9a0987022a52f$export$2e2bcd8739ae039);
    var $7VHMR;
    const $e8c9a0987022a52f$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.reparent-cmp-to-tmp-warning-flag.title",
            "defaultMessage": "Issue can't be moved"
        },
        description: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.reparent-cmp-to-tmp-warning-flag.description",
            "defaultMessage": "{issueKey} is part of a company-managed project, and can't be added to {destinationProjectName}."
        }
    });
    var $e8c9a0987022a52f$export$2e2bcd8739ae039 = $e8c9a0987022a52f$var$messages;
});
parcelRegister("87RRv", function(module, exports) {
    $parcel$export(module.exports, "getReparentTMPWarningFlag", ()=>$116a1c524a14fbbf$export$be86b81c21258a33);
    var $5uXOq = parcelRequire("5uXOq");
    var $gtreQ;
    var $d4xRU;
    var $ousew;
    var $gJZ5D;
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    var $by6AX = parcelRequire("by6AX");
    const $116a1c524a14fbbf$export$be86b81c21258a33 = ({ context: context })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            key: "reparent-tmp-warning",
            id: "reparent-tmp-warning",
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
                sourceName: "getReparentTMPWarningFlag"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
                onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $by6AX.default).title)),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $by6AX.default).description,
                values: context
            }),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                label: "",
                primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
            })
        });
});
parcelRegister("by6AX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd5191026df852b5$export$2e2bcd8739ae039);
    var $7VHMR;
    const $bd5191026df852b5$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.reparent-tmp-to-external-warning-flag.title",
            "defaultMessage": "Issue can't be moved"
        },
        description: {
            "id": "portfolio-3-portfolio.app-simple-plans.flag-group.reparent-tmp-to-external-warning-flag.description",
            "defaultMessage": "{issueKey} is part of a team-managed project, and can't be moved outside of {projectName}."
        }
    });
    var $bd5191026df852b5$export$2e2bcd8739ae039 = $bd5191026df852b5$var$messages;
});
parcelRegister("hijPv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$284ffd853c80541f$export$2e2bcd8739ae039);
    var $bC2fB;
    var $gW9ZM = parcelRequire("gW9ZM");
    var $eGmTM = parcelRequire("eGmTM");
    var $284ffd853c80541f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $gW9ZM.default), {})((0, $eGmTM.default));
});
parcelRegister("gW9ZM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fd9c0e408aa2c79$export$2e2bcd8739ae039);
    var $3YtPS = parcelRequire("3YtPS");
    var $bZA5o = parcelRequire("bZA5o");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $9fd9c0e408aa2c79$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        isLoading: (0, $bI9dZ.getIsIssuesLoading),
        isGoalsLoading: (0, $bZA5o.getIsGoalsLoading)
    });
});
parcelRegister("eGmTM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$edfa0ecdcfb76ca7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $4R6GH;
    var $9UGIm = parcelRequire("9UGIm");
    var $17BhC = parcelRequire("17BhC");
    var $hN22E = parcelRequire("hN22E");
    var $93t2h = parcelRequire("93t2h");
    var $lyodz = parcelRequire("lyodz");
    const $edfa0ecdcfb76ca7$var$RoadmapWrapper = ({ isLoading: isLoading, ...props })=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition')) return isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hN22E.TableSkeleton), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("4R6GH")).fg)('plans_performance_improvements_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $93t2h.PlanTableWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $17BhC.PlanTable), null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $17BhC.PlanTable), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lyodz.default), null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9UGIm.default), props);
    };
    var $edfa0ecdcfb76ca7$export$2e2bcd8739ae039 = $edfa0ecdcfb76ca7$var$RoadmapWrapper;
});
parcelRegister("9UGIm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$248d010ca02b6333$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $248d010ca02b6333$var$LazyComponent = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("g3QQ6")).then((module)=>module.default), {
        moduleId: "./src/packages/portfolio-3/portfolio/src/app-simple-plans/view/main/tabs/roadmap/index.tsx"
    });
    const $248d010ca02b6333$var$AsyncComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "plan-roadmap"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($248d010ca02b6333$var$LazyComponent, props));
    var $248d010ca02b6333$export$2e2bcd8739ae039 = $248d010ca02b6333$var$AsyncComponent;
});
parcelRegister("g3QQ6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("fnPw8")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9NvmD")
    ]).then(()=>parcelRequire('9Ew47'));
});
parcelRegister("17BhC", function(module, exports) {
    $parcel$export(module.exports, "PlanTable", ()=>$fbdd57ffe5834132$export$361ae292a480e348);
    var $bC2fB;
    var $1ZUz5 = parcelRequire("1ZUz5");
    var $68kaG = parcelRequire("68kaG");
    var $3vHWp = parcelRequire("3vHWp");
    const $fbdd57ffe5834132$export$361ae292a480e348 = (0, (0, parcelRequire("bC2fB")).connect)((0, $68kaG.default), (0, $1ZUz5.default))((0, $3vHWp.PlanTable));
});
parcelRegister("1ZUz5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ae9cc67b7794b5a$export$2e2bcd8739ae039);
    var $4R6GH;
    var $i6pdT = parcelRequire("i6pdT");
    var $jfp3Z = parcelRequire("jfp3Z");
    var $aqDY3 = parcelRequire("aqDY3");
    const $7ae9cc67b7794b5a$var$mapDispatchToProps = (dispatch)=>({
            onRoadmapView: (analyticsEvent)=>{
                dispatch((0, $i6pdT.sendViewRoadmapScreenAnalyticsEvent)(analyticsEvent));
                if ((0, (0, parcelRequire("4R6GH")).fg)('plans_timeline_-_always_persist_vid_in_url')) dispatch((0, $aqDY3.updateRoadmapViewId)());
            },
            reportTimeToInteractive: (payload)=>dispatch((0, $jfp3Z.reportTimeToInteractive)(payload))
        });
    var $7ae9cc67b7794b5a$export$2e2bcd8739ae039 = $7ae9cc67b7794b5a$var$mapDispatchToProps;
});
parcelRegister("i6pdT", function(module, exports) {
    $parcel$export(module.exports, "sendViewRoadmapScreenAnalyticsEvent", ()=>$ffa707a382903285$export$226fbff13f644206);
    $parcel$export(module.exports, "default", ()=>$ffa707a382903285$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $5eMyh = parcelRequire("5eMyh");
    const $ffa707a382903285$export$d07ff7a48940cdf1 = 'command.analytics.SEND_VIEW_ROADMAP_SCREEN';
    const $ffa707a382903285$export$226fbff13f644206 = (payload)=>({
            type: $ffa707a382903285$export$d07ff7a48940cdf1,
            payload: payload
        });
    function* $ffa707a382903285$export$e3c3228736aa99e3() {
        const [{ payload: payload }] = yield (0, $aNOuE.all)([
            (0, $aNOuE.take)($ffa707a382903285$export$d07ff7a48940cdf1),
            (0, $aNOuE.take)((0, $7abf4765f09faedb$export$a60cf13a28cbf30f))
        ]);
        yield (0, $aNOuE.put)((0, $5eMyh.viewRoadmap)(payload));
    }
    function* $ffa707a382903285$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($ffa707a382903285$export$e3c3228736aa99e3);
    }
});
const $7abf4765f09faedb$export$bf72183eb20c4d57 = 'command.INITIAL_LOAD';
const $7abf4765f09faedb$export$a60cf13a28cbf30f = 'command.AFTER_INITIAL_LOAD';
parcelRegister("5eMyh", function(module, exports) {
    $parcel$export(module.exports, "VIEW_ROADMAP", ()=>$17c08ea03d54427f$export$d26ca220cb0a4bd7);
    $parcel$export(module.exports, "viewRoadmap", ()=>$17c08ea03d54427f$export$115724b6e7221e4d);
    var $7oNzf = parcelRequire("7oNzf");
    const $17c08ea03d54427f$export$d26ca220cb0a4bd7 = 'command.roadmap.VIEW_ROADMAP';
    const $17c08ea03d54427f$export$115724b6e7221e4d = (analyticsEvent)=>({
            type: $17c08ea03d54427f$export$d26ca220cb0a4bd7,
            meta: {
                analyticsEvent: analyticsEvent
            }
        });
});
parcelRegister("7oNzf", function(module, exports) {
    $parcel$export(module.exports, "SET_STICKY_HEADER_SCROLL", ()=>$eb0b76083b23d948$export$de6494ad10940845);
    $parcel$export(module.exports, "setScrollingScrollTop", ()=>$eb0b76083b23d948$export$f1596fbaf8604e30);
    const $eb0b76083b23d948$export$de6494ad10940845 = 'state.ui.main.tabs.roadmap.sticky-header.SET_STICKY_HEADER_SCROLL';
    const $eb0b76083b23d948$export$f1596fbaf8604e30 = (payload)=>({
            type: $eb0b76083b23d948$export$de6494ad10940845,
            payload: payload
        });
});
parcelRegister("jfp3Z", function(module, exports) {
    $parcel$export(module.exports, "reportTimeToInteractive", ()=>$8186abd4c5198bbf$export$7f6790acfc0478b9);
    $parcel$export(module.exports, "default", ()=>$8186abd4c5198bbf$export$2e2bcd8739ae039);
    var $83IGl;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $4ENQh;
    var $bI9dZ = parcelRequire("bI9dZ");
    var $jLI87 = parcelRequire("jLI87");
    const $8186abd4c5198bbf$var$numberOfIssueLinks = (values)=>{
        let count = 0;
        for (const issueId of Object.keys(values))count += Object.keys(values[issueId] ?? {}).length;
        return Math.floor(count / 2);
    };
    const $8186abd4c5198bbf$export$7f6790acfc0478b9 = (payload)=>({
            type: (0, $e879947c57b977c0$export$d1ca64071165c7e5),
            payload: payload
        });
    function* $8186abd4c5198bbf$var$doReportTimeToInteractive({ payload: { isNewSidebarEnabled: isNewSidebarEnabled, isTransposed: isTransposed = false } }) {
        const { domain: { assignees: assignees, crossProjectVersions: crossProjectVersions, customFields: customFields, issues: issues, issueLinks: issueLinks, persons: persons, projects: projects, sprints: sprints, teams: teams, versions: versions, views: views } } = yield (0, $aNOuE.select)((0, (0, parcelRequire("83IGl")).default));
        const visibleIssueCount = yield (0, $aNOuE.select)((0, $jLI87.countVisibleIssues));
        const filteredIssueCount = (yield (0, $aNOuE.select)((0, $bI9dZ.getFilteredIssuesWithHierarchy))).length;
        (0, (0, parcelRequire("4ENQh")).monitor).addContextualAnalyticsData({
            isNewSidebarEnabled: isNewSidebarEnabled,
            isTransposed: isTransposed
        });
        (0, (0, parcelRequire("4ENQh")).monitor).finishInitialRender({
            scalingFactors: {
                assignees: assignees.assigneeList.length,
                crossProjectReleases: crossProjectVersions.length,
                customFields: customFields.length,
                issues: issues.length,
                issuesPostFiltering: filteredIssueCount,
                visibleIssues: visibleIssueCount,
                issueLinks: $8186abd4c5198bbf$var$numberOfIssueLinks(issueLinks.values),
                persons: persons.length,
                projects: projects.length,
                releases: versions.length,
                sprints: sprints.length,
                teams: teams.length,
                views: views.length
            }
        });
    }
    function* $8186abd4c5198bbf$var$watchReportTimeToInteractive() {
        yield (0, $6u3NN.takeEvery)((0, $e879947c57b977c0$export$d1ca64071165c7e5), $8186abd4c5198bbf$var$doReportTimeToInteractive);
    }
    function* $8186abd4c5198bbf$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($8186abd4c5198bbf$var$watchReportTimeToInteractive);
    }
});
const $e879947c57b977c0$export$d1ca64071165c7e5 = 'command.time-to-interactive.REPORT_TIME_TO_INTERACTIVE';
parcelRegister("aqDY3", function(module, exports) {
    $parcel$export(module.exports, "switchView", ()=>$7a65575005d6f99b$export$adaf8a367aa41030);
    $parcel$export(module.exports, "modifyView", ()=>$7a65575005d6f99b$export$d47a9f66421ac6ac);
    $parcel$export(module.exports, "discardChanges", ()=>$7a65575005d6f99b$export$a1371969d487fc2a);
    $parcel$export(module.exports, "saveView", ()=>$7a65575005d6f99b$export$5c85e4ea5ae8a7f2);
    $parcel$export(module.exports, "saveViewAs", ()=>$7a65575005d6f99b$export$771c355a80466f9b);
    $parcel$export(module.exports, "deleteView", ()=>$7a65575005d6f99b$export$443d89549b135c95);
    $parcel$export(module.exports, "markAsDefaultView", ()=>$7a65575005d6f99b$export$65c8c09b8f8e5243);
    $parcel$export(module.exports, "fetchHistoricalIssueForView", ()=>$7a65575005d6f99b$export$74f46688edc62a6d);
    $parcel$export(module.exports, "applyModificationsForInactiveViews", ()=>$7a65575005d6f99b$export$423d927bdcf0d280);
    $parcel$export(module.exports, "updateRoadmapViewId", ()=>$7a65575005d6f99b$export$95dd61142e2558d1);
    $parcel$export(module.exports, "populateReportViewSettings", ()=>$7a65575005d6f99b$export$60fcc8898bd8f5d0);
    $parcel$export(module.exports, "initializeViews", ()=>$7a65575005d6f99b$export$6fa92c81825ed985);
    $parcel$export(module.exports, "default", ()=>$7a65575005d6f99b$export$2e2bcd8739ae039);
    var $2XSIf;
    var $ik0Qc;
    var $bCWbL;
    var $2rMKg;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $4R6GH;
    var $4nDwW = parcelRequire("4nDwW");
    var $idmiV = parcelRequire("idmiV");
    var $bHTqr = parcelRequire("bHTqr");
    var $kWDpn = parcelRequire("kWDpn");
    var $7QGzp = parcelRequire("7QGzp");
    var $8vuta = parcelRequire("8vuta");
    var $3t3Pr = parcelRequire("3t3Pr");
    var $edCT0 = parcelRequire("edCT0");
    var $c5JsS = parcelRequire("c5JsS");
    var $g7G9N = parcelRequire("g7G9N");
    var $bYhSc = parcelRequire("bYhSc");
    var $24CMK = parcelRequire("24CMK");
    var $asXbx = parcelRequire("asXbx");
    var $bkasS = parcelRequire("bkasS");
    var $iXfSG = parcelRequire("iXfSG");
    var $CLvmV = parcelRequire("CLvmV");
    const $7a65575005d6f99b$var$SWITCH_VIEW = 'command.views.SWITCH_VIEW';
    const $7a65575005d6f99b$var$MODIFY_VIEW = 'command.views.MODIFY_VIEW';
    const $7a65575005d6f99b$var$SAVE_VIEW = 'command.views.SAVE_VIEW';
    const $7a65575005d6f99b$var$SAVE_VIEW_AS = 'command.views.SAVE_VIEW_AS';
    const $7a65575005d6f99b$var$DISCARD_CHANGES = 'command.views.DISCARD_CHANGES';
    const $7a65575005d6f99b$var$DELETE_VIEW = 'command.views.DELETE_VIEW';
    const $7a65575005d6f99b$var$FETCH_HISTORICAL_ISSUE_FOR_VIEW = 'command.views.FETCH_HISTORICAL_ISSUE_FOR_VIEW';
    const $7a65575005d6f99b$var$MARK_AS_DEFAULT_VIEW = 'command.views.MARK_AS_DEFAULT_VIEW';
    const $7a65575005d6f99b$var$APPLY_MODIFICATIONS_FOR_INACTIVE_VIEWS = 'command.views.APPLY_MODIFICATIONS_FOR_INACTIVE_VIEWS';
    const $7a65575005d6f99b$var$UPDATE_ROADMAP_VIEW_ID = 'command.views.UPDATE_ROADMAP_VIEW_ID';
    const $7a65575005d6f99b$export$adaf8a367aa41030 = (id)=>({
            type: $7a65575005d6f99b$var$SWITCH_VIEW,
            payload: {
                id: id
            }
        });
    const $7a65575005d6f99b$export$d47a9f66421ac6ac = (payload)=>({
            type: $7a65575005d6f99b$var$MODIFY_VIEW,
            payload: payload
        });
    const $7a65575005d6f99b$export$a1371969d487fc2a = (id)=>({
            type: $7a65575005d6f99b$var$DISCARD_CHANGES,
            payload: {
                id: id
            }
        });
    const $7a65575005d6f99b$export$5c85e4ea5ae8a7f2 = (payload)=>({
            type: $7a65575005d6f99b$var$SAVE_VIEW,
            payload: payload
        });
    const $7a65575005d6f99b$export$771c355a80466f9b = (payload)=>({
            type: $7a65575005d6f99b$var$SAVE_VIEW_AS,
            payload: payload
        });
    const $7a65575005d6f99b$export$443d89549b135c95 = (id, shouldCallAPI = true)=>({
            type: $7a65575005d6f99b$var$DELETE_VIEW,
            payload: {
                id: id,
                shouldCallAPI: shouldCallAPI
            }
        });
    const $7a65575005d6f99b$export$65c8c09b8f8e5243 = (id)=>({
            type: $7a65575005d6f99b$var$MARK_AS_DEFAULT_VIEW,
            payload: {
                id: id
            }
        });
    const $7a65575005d6f99b$export$74f46688edc62a6d = ()=>({
            type: $7a65575005d6f99b$var$FETCH_HISTORICAL_ISSUE_FOR_VIEW
        });
    const $7a65575005d6f99b$export$423d927bdcf0d280 = (savedViewsInfo)=>({
            type: $7a65575005d6f99b$var$APPLY_MODIFICATIONS_FOR_INACTIVE_VIEWS,
            payload: savedViewsInfo
        });
    const $7a65575005d6f99b$export$95dd61142e2558d1 = ()=>({
            type: $7a65575005d6f99b$var$UPDATE_ROADMAP_VIEW_ID
        });
    function* $7a65575005d6f99b$export$aea62a1ac812f7bb(viewSettings) {
        const viewSettingsData = ()=>viewSettings;
        yield (0, $aNOuE.put)((0, $8vuta.reset)(viewSettingsData()));
    }
    function* $7a65575005d6f99b$export$60fcc8898bd8f5d0(viewSettings) {
        yield (0, $aNOuE.call)($7a65575005d6f99b$export$aea62a1ac812f7bb, (yield (0, $aNOuE.call)($iXfSG.getReportViewSettings, viewSettings)));
    }
    function* $7a65575005d6f99b$export$57a10d00b7d9e806(view) {
        const changedPrefs = yield (0, $aNOuE.call)($7a65575005d6f99b$export$aea62a1ac812f7bb, view.preferences);
        if (changedPrefs) {
            const mergePrefs = (0, parcelRequire("bCWbL")).default(changedPrefs);
            const preferences = mergePrefs(view.preferences);
            return (0, parcelRequire("bCWbL")).default({
                preferences: preferences
            })(view);
        }
    }
    function* $7a65575005d6f99b$export$60f6a189695639d0(action) {
        const { id: viewId } = action.payload;
        yield* (0, $bYhSc.default)(function*() {
            const views = yield (0, $aNOuE.select)((0, $7QGzp.getViews));
            const selected = views.find(({ id: id })=>id === viewId);
            if (!selected) return;
            const updated = yield (0, $aNOuE.call)($7a65575005d6f99b$export$57a10d00b7d9e806, selected);
            if (updated) yield (0, $aNOuE.put)($3t3Pr.updateView(updated));
            yield (0, $aNOuE.put)($3t3Pr.setActiveView(selected));
            yield (0, $aNOuE.call)($iXfSG.replaceURLForViewId, viewId);
        });
        yield (0, $aNOuE.call)($iXfSG.pushActiveViewId, viewId);
        yield (0, $aNOuE.put)($7a65575005d6f99b$export$74f46688edc62a6d());
    }
    function* $7a65575005d6f99b$export$6fa92c81825ed985(payload) {
        if (!payload || !payload.savedViews) return;
        return yield (0, $aNOuE.call)((0, $asXbx.withErrorTolerated), function*() {
            const isSample = yield (0, $aNOuE.select)((0, $bHTqr.getIsSamplePlan));
            const isCrossTeamPlanning = $iXfSG.isCrossTeamPlanningTemplateExperimentEnabled() ? yield (0, $aNOuE.select)((0, $bHTqr.getIsCrossTeamPlanning)) : undefined;
            const { vid: vid } = (0, $idmiV.parseQueryParams)(window.location.search);
            const views = yield (0, $aNOuE.call)($iXfSG.initializeViews, payload, {
                forSamplePlan: isSample,
                forCrossTeamPlanning: isCrossTeamPlanning
            });
            const active = views.find((0, parcelRequire("2rMKg")).default('active'));
            yield* (0, $bYhSc.default)(function*() {
                yield (0, $aNOuE.put)($3t3Pr.reset(views));
                const updated = yield (0, $aNOuE.call)($7a65575005d6f99b$export$57a10d00b7d9e806, active);
                if (updated) yield (0, $aNOuE.put)($3t3Pr.updateView(updated));
            });
            const viewForVid = views.find((view)=>view.id === Number(vid));
            if (isSample) yield (0, $aNOuE.call)($iXfSG.replaceURLForSamplePlan);
            if (viewForVid && active.id !== viewForVid.id) yield (0, $aNOuE.call)($7a65575005d6f99b$export$60f6a189695639d0, $7a65575005d6f99b$export$adaf8a367aa41030(viewForVid.id));
            else {
                if ((0, (0, parcelRequire("4R6GH")).fg)('plans_timeline_-_always_persist_vid_in_url')) {
                    if (window.location.pathname.indexOf('timeline') > -1) yield (0, $aNOuE.call)($iXfSG.replaceURLForViewId, active.id);
                } else yield (0, $aNOuE.call)($iXfSG.replaceURLForViewId, active.id);
                yield (0, $aNOuE.put)($7a65575005d6f99b$export$74f46688edc62a6d());
            }
        });
    }
    function* $7a65575005d6f99b$export$fdd4f54ef4770039() {
        yield (0, $6u3NN.takeLatest)($7a65575005d6f99b$var$SWITCH_VIEW, $7a65575005d6f99b$export$60f6a189695639d0);
    }
    function* $7a65575005d6f99b$export$d5f781a73c19a677(action) {
        yield (0, $aNOuE.put)($3t3Pr.modifyView(action.payload));
        const views = yield (0, $aNOuE.select)((0, $7QGzp.getViews));
        const modifiedView = views.find(({ id: id })=>id === action.payload.id);
        if (!modifiedView) throw new Error('modified view not found');
        yield (0, $aNOuE.call)($iXfSG.pushModifiedView, modifiedView);
    }
    function* $7a65575005d6f99b$export$b05193c1480d5bf3() {
        yield (0, $6u3NN.takeEvery)($7a65575005d6f99b$var$MODIFY_VIEW, $7a65575005d6f99b$export$d5f781a73c19a677);
    }
    function* $7a65575005d6f99b$export$937c45f7777ca9e7(action) {
        const viewId = action.payload.id;
        const view = (yield (0, $aNOuE.select)((0, $7QGzp.getViews))).find((one)=>one.id === viewId);
        if (!view) throw new Error('view to discard not found');
        if (view.original) {
            const updated = yield (0, $aNOuE.call)($7a65575005d6f99b$export$57a10d00b7d9e806, (0, parcelRequire("2XSIf")).default('active', true)(view.original));
            if (updated) yield (0, $aNOuE.put)($3t3Pr.updateView(updated));
        }
        yield (0, $aNOuE.put)($3t3Pr.discardChanges(view.id));
        yield (0, $aNOuE.call)($iXfSG.deleteModifiedView, view.id);
    }
    function* $7a65575005d6f99b$export$891357a43e298c1() {
        yield (0, $6u3NN.takeEvery)($7a65575005d6f99b$var$DISCARD_CHANGES, $7a65575005d6f99b$export$937c45f7777ca9e7);
    }
    function* $7a65575005d6f99b$export$819415907a77688(action) {
        yield (0, $aNOuE.put)((0, $edCT0.setRenameSaving)(true));
        const active = action.payload.view || (yield (0, $aNOuE.select)((0, $7QGzp.getPrunedActiveView)));
        if (!active.modified && !action.payload.renameOnly) throw new Error('cannot save unmodifed view');
        try {
            const version = action.payload.overwrite && active.original ? active.original.version : active.version;
            const { version: nextVersion } = yield (0, $aNOuE.call)($iXfSG.updateView, (0, parcelRequire("ik0Qc")).default(active, {
                version: version
            }), action.payload.renameOnly);
            yield (0, $aNOuE.put)($3t3Pr.saveView(active.id, nextVersion, active.name));
            if (!action.payload.renameOnly) yield (0, $aNOuE.call)($iXfSG.deleteModifiedView, active.id);
        } catch (err) {
            if (err instanceof $CLvmV.UpdateErrorConflicted) {
                const view = yield (0, $aNOuE.call)($iXfSG.fetchSavedView, active.id);
                yield (0, $aNOuE.put)($3t3Pr.updateView({
                    id: active.id,
                    original: view
                }));
                yield (0, $aNOuE.put)($c5JsS.addError(new $CLvmV.UpdateErrorConflicted({
                    ...err,
                    modifiedBy: view.updatedBy
                })));
            } else if (err instanceof $CLvmV.UpdateErrorNotExists) yield (0, $aNOuE.put)($c5JsS.addError(err));
            else if (err instanceof $CLvmV.SaveAsErrorDuplicateView) yield (0, $aNOuE.put)($c5JsS.addError(err));
            else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: err,
                stackTrace: err.stack
            }));
        }
        yield (0, $aNOuE.put)((0, $edCT0.setRenameSaving)(false));
    }
    function* $7a65575005d6f99b$export$6822aa1f0a093909() {
        yield (0, $6u3NN.takeEvery)($7a65575005d6f99b$var$SAVE_VIEW, $7a65575005d6f99b$export$819415907a77688);
    }
    function* $7a65575005d6f99b$export$8417e6604a78ce1(action) {
        const { name: name, asDefault: isDefault, duplicateSection: duplicateSection, sourceViewId: sourceViewId } = action.payload;
        const fromSettingsPage = !!sourceViewId;
        const currentView = (0, $4nDwW.isDefined)(sourceViewId) ? yield (0, $aNOuE.select)((0, $7QGzp.getViewById), sourceViewId) : yield (0, $aNOuE.select)((0, $7QGzp.getPrunedActiveView));
        const views = yield (0, $aNOuE.select)((0, $7QGzp.getViews));
        const currentJiraUser = yield (0, $aNOuE.call)($iXfSG.getCurrentUserInViewFormat);
        const tempId = function _r(id) {
            if (views.some((one)=>one.id === id)) return _r(id - 1);
            return id;
        }(-1);
        const newView = {
            id: tempId,
            name: name,
            preferences: currentView.preferences,
            persisted: currentView.persisted,
            version: 0,
            isDefault: isDefault,
            active: false,
            modified: false,
            original: null,
            createdBy: currentJiraUser,
            updatedAt: new Date(),
            updatedBy: currentJiraUser
        };
        yield (0, $aNOuE.call)((0, $asXbx.withErrorTolerated), function*() {
            yield (0, $aNOuE.put)($c5JsS.setSaveViewAsDialogStatus('SAVING'));
            const { id: actualId, errorCode: errorCode } = yield (0, $aNOuE.call)($iXfSG.createView, newView);
            if (errorCode === 'DUPLICATE_VIEW') {
                const error = new $CLvmV.SaveAsErrorDuplicateView({
                    viewId: tempId,
                    viewName: currentView.name,
                    newName: newView.name
                });
                yield (0, $aNOuE.put)($c5JsS.addError(error));
                yield (0, $aNOuE.put)($c5JsS.setSaveViewAsDialogStatus('OPEN'));
                return;
            }
            yield (0, $aNOuE.put)($c5JsS.setSaveViewAsDialogStatus('CLOSED'));
            yield* (0, $bYhSc.default)(function*() {
                yield (0, $aNOuE.put)($3t3Pr.addView(newView));
                if (!fromSettingsPage || fromSettingsPage && currentView.active) yield (0, $aNOuE.put)($3t3Pr.setActiveView({
                    id: tempId
                }));
                if (currentView.id === (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28)) yield (0, $aNOuE.put)($3t3Pr.removeView(currentView.id));
                else {
                    if (fromSettingsPage) yield (0, $aNOuE.put)($3t3Pr.removeView(currentView.id));
                    yield (0, $aNOuE.put)($3t3Pr.discardChanges(currentView.id));
                }
            });
            yield (0, $aNOuE.call)($iXfSG.deleteModifiedView, currentView.id);
            yield (0, $aNOuE.put)($3t3Pr.changeId(tempId, actualId));
            if (duplicateSection) $iXfSG.duplicateSectionState({
                sourceViewId: currentView.id,
                targetViewId: actualId,
                duplicateSection: duplicateSection
            });
            if (!fromSettingsPage || fromSettingsPage && currentView.active) yield (0, $aNOuE.call)($7a65575005d6f99b$export$60f6a189695639d0, $7a65575005d6f99b$export$adaf8a367aa41030(actualId));
        });
    }
    function* $7a65575005d6f99b$export$c554e9fd017b5411() {
        yield (0, $6u3NN.takeEvery)($7a65575005d6f99b$var$SAVE_VIEW_AS, $7a65575005d6f99b$export$8417e6604a78ce1);
    }
    function* $7a65575005d6f99b$export$42488dc94da29116(action) {
        const { id: viewId } = action.payload;
        const views = yield (0, $aNOuE.select)((0, $7QGzp.getViews));
        const viewToRemove = views.find(({ id: id })=>id === viewId);
        const defaultView = yield (0, $aNOuE.select)((0, $7QGzp.getDefaultView));
        const { shouldCallAPI: shouldCallAPI } = action.payload;
        yield (0, $aNOuE.call)((0, $asXbx.withErrorTolerated), function*() {
            if (shouldCallAPI && viewToRemove.id !== (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28)) {
                const deleteResponse = yield (0, $aNOuE.call)($iXfSG.deleteView, viewToRemove.id);
                if ((0, $4nDwW.isDefined)(deleteResponse) && deleteResponse.errorCode === 'DEFAULT_VIEW') {
                    yield (0, $aNOuE.put)($3t3Pr.markAsDefaultView(viewToRemove.id));
                    yield (0, $aNOuE.put)($c5JsS.addError(new $CLvmV.DeleteErrorDefaultView({
                        viewId: viewToRemove.id,
                        viewName: viewToRemove.name
                    })));
                    return;
                }
            }
            yield (0, $aNOuE.call)($7a65575005d6f99b$export$937c45f7777ca9e7, $7a65575005d6f99b$export$a1371969d487fc2a(viewToRemove.id));
            yield (0, $aNOuE.put)($3t3Pr.removeView(viewToRemove.id));
            if (viewToRemove.active) yield (0, $aNOuE.call)($7a65575005d6f99b$export$60f6a189695639d0, $7a65575005d6f99b$export$adaf8a367aa41030(defaultView.id));
        });
    }
    function* $7a65575005d6f99b$export$d96b7cdfdceeb949() {
        const fields = yield (0, $aNOuE.select)((0, $kWDpn.getFieldColumnsViewSettingsByViewMode));
        const hasBreakdown = fields.columns.find((column)=>column.id === 'breakdown');
        const hasBreakdownByEstimate = fields.columns.find((column)=>column.id === 'progressByEstimation');
        if (hasBreakdown && hasBreakdown.isVisible === true || hasBreakdownByEstimate && hasBreakdownByEstimate.isVisible === true) yield (0, $aNOuE.put)((0, $bkasS.fetchHistoricalDoneIssues)());
    }
    function* $7a65575005d6f99b$export$d926b2deb1f6679f(action) {
        const { activeViewId: activeViewId, modifiedSavedViews: modifiedSavedViews } = action.payload;
        const modifiedInactiveViews = [];
        for (const view of modifiedSavedViews)if (view.id !== activeViewId) modifiedInactiveViews.push((yield (0, $aNOuE.call)($iXfSG.prepareModifiedView, view)));
        yield* (0, $bYhSc.default)(function*() {
            for (const view of modifiedInactiveViews)yield (0, $aNOuE.put)($3t3Pr.modifyView(view));
        });
    }
    function* $7a65575005d6f99b$export$e944914df7c62610() {
        yield (0, $6u3NN.takeEvery)($7a65575005d6f99b$var$DELETE_VIEW, $7a65575005d6f99b$export$42488dc94da29116);
    }
    function* $7a65575005d6f99b$export$ce5df739bd41a75e() {
        yield (0, $6u3NN.takeEvery)($7a65575005d6f99b$var$FETCH_HISTORICAL_ISSUE_FOR_VIEW, $7a65575005d6f99b$export$d96b7cdfdceeb949);
    }
    function* $7a65575005d6f99b$export$ac7387aac4bb66ae(action) {
        const { id: viewId } = action.payload;
        yield (0, $aNOuE.put)($3t3Pr.markAsDefaultView(viewId));
        yield (0, $aNOuE.call)($iXfSG.markAsDefaultView, {
            id: viewId,
            isDefault: true
        });
    }
    function* $7a65575005d6f99b$export$e5281f3ef11f93a2() {
        yield (0, $6u3NN.takeEvery)($7a65575005d6f99b$var$MARK_AS_DEFAULT_VIEW, $7a65575005d6f99b$export$ac7387aac4bb66ae);
    }
    function* $7a65575005d6f99b$export$b9e892138c4d10a6() {
        yield (0, $6u3NN.takeEvery)($7a65575005d6f99b$var$APPLY_MODIFICATIONS_FOR_INACTIVE_VIEWS, $7a65575005d6f99b$export$d926b2deb1f6679f);
    }
    function* $7a65575005d6f99b$export$f44881f9cca99c() {
        if ((0, $g7G9N.getViewId)() === undefined) {
            const activeView = yield (0, $aNOuE.select)((0, $7QGzp.getActiveView));
            if (activeView) yield (0, $aNOuE.call)($iXfSG.replaceURLForViewId, activeView.id);
        }
    }
    function* $7a65575005d6f99b$export$26eab6ba61eddd53() {
        yield (0, $6u3NN.takeLatest)($7a65575005d6f99b$var$UPDATE_ROADMAP_VIEW_ID, $7a65575005d6f99b$export$f44881f9cca99c);
    }
    function* $7a65575005d6f99b$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($7a65575005d6f99b$export$fdd4f54ef4770039);
        yield (0, $aNOuE.fork)($7a65575005d6f99b$export$b05193c1480d5bf3);
        yield (0, $aNOuE.fork)($7a65575005d6f99b$export$891357a43e298c1);
        yield (0, $aNOuE.fork)($7a65575005d6f99b$export$6822aa1f0a093909);
        yield (0, $aNOuE.fork)($7a65575005d6f99b$export$c554e9fd017b5411);
        yield (0, $aNOuE.fork)($7a65575005d6f99b$export$e944914df7c62610);
        yield (0, $aNOuE.fork)($7a65575005d6f99b$export$e5281f3ef11f93a2);
        yield (0, $aNOuE.fork)($7a65575005d6f99b$export$ce5df739bd41a75e);
        yield (0, $aNOuE.fork)($7a65575005d6f99b$export$b9e892138c4d10a6);
        yield (0, $aNOuE.fork)($7a65575005d6f99b$export$26eab6ba61eddd53);
    }
});
parcelRegister("bCWbL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8770615f0716ade5$export$2e2bcd8739ae039);
    var $kClQu;
    var $c9RLn;
    var $8770615f0716ade5$var$mergeLeft = (0, (0, parcelRequire("c9RLn")).default)(function mergeLeft(l, r) {
        return (0, (0, parcelRequire("kClQu")).default)({}, r, l);
    });
    var $8770615f0716ade5$export$2e2bcd8739ae039 = $8770615f0716ade5$var$mergeLeft;
});
parcelRegister("7QGzp", function(module, exports) {
    $parcel$export(module.exports, "getViews", ()=>$1ede447599431dd6$export$1146ecde69e3aab7);
    $parcel$export(module.exports, "getErrors", ()=>$1ede447599431dd6$export$501239432719417d);
    $parcel$export(module.exports, "getSaveViewAsDialogStatus", ()=>$1ede447599431dd6$export$3d79349e74ca1dd4);
    $parcel$export(module.exports, "getActiveView", ()=>$1ede447599431dd6$export$eeafe3a59ebae959);
    $parcel$export(module.exports, "getActiveViewId", ()=>$1ede447599431dd6$export$1d07d3ed6ca0f6c4);
    $parcel$export(module.exports, "getNamespaceForView", ()=>$1ede447599431dd6$export$7ca3723ed727a96b);
    $parcel$export(module.exports, "getPrunedActiveView", ()=>$1ede447599431dd6$export$25a2142beadf5fa6);
    $parcel$export(module.exports, "getNamespaceFromActiveView", ()=>$1ede447599431dd6$export$f58e4c494e4d972d);
    $parcel$export(module.exports, "getDefaultView", ()=>$1ede447599431dd6$export$29c7e3796b1cc2e7);
    $parcel$export(module.exports, "getViewById", ()=>$1ede447599431dd6$export$b292b237cbc170ca);
    var $2rMKg;
    var $sqeVT;
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $kbGxr = parcelRequire("kbGxr");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $4sJY8 = parcelRequire("4sJY8");
    var $d3quy = parcelRequire("d3quy");
    var $dRVQG = parcelRequire("dRVQG");
    var $9FFuD = parcelRequire("9FFuD");
    var $kWDpn = parcelRequire("kWDpn");
    var $eAhNi = parcelRequire("eAhNi");
    const $1ede447599431dd6$export$1146ecde69e3aab7 = (state)=>state.domain.views || [];
    const $1ede447599431dd6$export$501239432719417d = (state)=>state.ui.Top.ViewBar.errors;
    const $1ede447599431dd6$export$3d79349e74ca1dd4 = (state)=>state.ui.Top.ViewBar.saveViewAsDialogStatus;
    const $1ede447599431dd6$export$eeafe3a59ebae959 = (0, $3YtPS.createSelector)([
        $1ede447599431dd6$export$1146ecde69e3aab7
    ], (views)=>views.find((0, parcelRequire("2rMKg")).default('active')) || views[0]);
    const $1ede447599431dd6$export$1d07d3ed6ca0f6c4 = (0, $3YtPS.createSelector)([
        $1ede447599431dd6$export$eeafe3a59ebae959
    ], (view)=>view?.id || 0);
    const $1ede447599431dd6$export$7ca3723ed727a96b = (id)=>`view-${id}`;
    const $1ede447599431dd6$export$e1e3861e7c1dfb81 = (activeView, issuesById, issues, projectsById, versionsById, teamsById, sprintsById, labelGroupsById, componentGroupsById, descendantsByParent)=>{
        const { preferences: preferences } = activeView;
        const expandedState = preferences.issueExpansionsV0.isExpanded;
        let prunedExpandedState = Object.entries(expandedState).reduce((acc, [key, value])=>{
            const issueId = key.split(':')[0];
            if (Number(issueId) || (0, $kbGxr.isScenarioIssue)(issueId)) {
                if (!issuesById[issueId] || (descendantsByParent[issueId] || []).length === 0) return acc;
            }
            acc[key] = value;
            return acc;
        }, {});
        prunedExpandedState = Object.entries(prunedExpandedState).reduce((acc, [key, value])=>{
            if (key.includes(':components-')) {
                const componentGroupName = key.split('-')[1];
                if (!componentGroupsById[componentGroupName]) return acc;
            }
            acc[key] = value;
            return acc;
        }, {});
        preferences.issueExpansionsV0.isExpanded = prunedExpandedState;
        const groupingExpandedItems = preferences.visualisationsV0.expandedItems;
        if (!groupingExpandedItems) return activeView;
        if (groupingExpandedItems[(0, $TTKUQ.GROUPING).ASSIGNEE]) {
            const uniqueAssignees = new Set();
            issues.forEach((issue)=>{
                uniqueAssignees.add(issue.assignee);
            });
            const prunedAssigneeGrouping = Object.entries(groupingExpandedItems[(0, $TTKUQ.GROUPING).ASSIGNEE]).reduce((acc, [key, value])=>{
                if (key === 'assignee-unassigned' || uniqueAssignees.has(key.split('-')[1])) acc[key] = value;
                return acc;
            }, {});
            groupingExpandedItems[(0, $TTKUQ.GROUPING).ASSIGNEE] = prunedAssigneeGrouping;
        }
        if (groupingExpandedItems[(0, $TTKUQ.GROUPING).PROJECT]) {
            const prunedProjectGrouping = Object.entries(groupingExpandedItems[(0, $TTKUQ.GROUPING).PROJECT]).reduce((acc, [key, value])=>{
                if (projectsById[key.split('-')[1]]) acc[key] = value;
                return acc;
            }, {});
            groupingExpandedItems[(0, $TTKUQ.GROUPING).PROJECT] = prunedProjectGrouping;
        }
        if (groupingExpandedItems[(0, $TTKUQ.GROUPING).RELEASE]) {
            const prunedReleaseGrouping = Object.entries(groupingExpandedItems[(0, $TTKUQ.GROUPING).RELEASE]).reduce((acc, [key, value])=>{
                if (key === 'UNDEFINED' || versionsById[key.split('-')[1]]) acc[key] = value;
                return acc;
            }, {});
            groupingExpandedItems[(0, $TTKUQ.GROUPING).RELEASE] = prunedReleaseGrouping;
        }
        if (groupingExpandedItems[(0, $TTKUQ.GROUPING).TEAM]) {
            const prunedTeamGrouping = Object.entries(groupingExpandedItems[(0, $TTKUQ.GROUPING).TEAM]).reduce((acc, [key, value])=>{
                if (key === 'UNDEFINED' || teamsById[key.split('-')[1]]) acc[key] = value;
                return acc;
            }, {});
            groupingExpandedItems[(0, $TTKUQ.GROUPING).TEAM] = prunedTeamGrouping;
        }
        if (groupingExpandedItems[(0, $TTKUQ.GROUPING).SPRINT]) {
            const prunedSprintGrouping = Object.entries(groupingExpandedItems[(0, $TTKUQ.GROUPING).SPRINT]).reduce((acc, [key, value])=>{
                if (key === 'UNDEFINED' || sprintsById[key.split('-')[1]]) acc[key] = value;
                return acc;
            }, {});
            groupingExpandedItems[(0, $TTKUQ.GROUPING).SPRINT] = prunedSprintGrouping;
        }
        if (groupingExpandedItems[(0, $TTKUQ.GROUPING).LABEL]) {
            const prunedLabelGrouping = Object.entries(groupingExpandedItems[(0, $TTKUQ.GROUPING).LABEL]).reduce((acc, [key, value])=>{
                if (key === `labels-${0, $10afd8ee8013ce61$export$526fec6b76d5bc5}` || labelGroupsById[key.split('-')[1]]) acc[key] = value;
                return acc;
            }, {});
            groupingExpandedItems[(0, $TTKUQ.GROUPING).LABEL] = prunedLabelGrouping;
        }
        if (groupingExpandedItems[(0, $TTKUQ.GROUPING).COMPONENT]) {
            const prunedComponentGrouping = Object.entries(groupingExpandedItems[(0, $TTKUQ.GROUPING).COMPONENT]).reduce((acc, [key, value])=>{
                if (key === `components-${0, $10afd8ee8013ce61$export$526fec6b76d5bc5}` || componentGroupsById[key.split('-')[1]]) acc[key] = value;
                return acc;
            }, {});
            groupingExpandedItems[(0, $TTKUQ.GROUPING).COMPONENT] = prunedComponentGrouping;
        }
        return activeView;
    };
    const $1ede447599431dd6$export$25a2142beadf5fa6 = (0, $3YtPS.createSelector)([
        $1ede447599431dd6$export$eeafe3a59ebae959,
        (0, $gFhwb.getIssueMapById),
        (0, $gFhwb.getAllIssues),
        (0, $jpXKt.getProjectsById),
        (0, $9FFuD.getVersionsById),
        (0, $dRVQG.getTeamsById),
        (0, $d3quy.getSprintByIdMap),
        (0, $kWDpn.getLabelGroupsById),
        (0, $kWDpn.getComponentGroupsById),
        (0, $4sJY8.getDescendantsByParent)
    ], $1ede447599431dd6$export$e1e3861e7c1dfb81);
    const $1ede447599431dd6$export$f58e4c494e4d972d = (0, $3YtPS.createSelector)([
        $1ede447599431dd6$export$1146ecde69e3aab7
    ], (views)=>{
        const activeView = views.find((0, parcelRequire("2rMKg")).default('active'));
        return activeView && $1ede447599431dd6$export$7ca3723ed727a96b(activeView.id) || 'default-view';
    });
    const $1ede447599431dd6$export$29c7e3796b1cc2e7 = (0, $3YtPS.createSelector)([
        $1ede447599431dd6$export$1146ecde69e3aab7
    ], (views)=>views.find((0, parcelRequire("2rMKg")).default('isDefault')));
    const $1ede447599431dd6$export$b292b237cbc170ca = (state, viewId)=>{
        const views = $1ede447599431dd6$export$1146ecde69e3aab7(state);
        return views.find((0, parcelRequire("sqeVT")).default('id', viewId));
    };
});
parcelRegister("kbGxr", function(module, exports) {
    $parcel$export(module.exports, "isScenarioIssue", ()=>$fbdc685bf640096c$export$44ef32448ae567e6);
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $fbdc685bf640096c$export$44ef32448ae567e6 = (issueId = '')=>(0, $4nDwW.isDefined)(issueId) && issueId.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX));
});
parcelRegister("d3quy", function(module, exports) {
    $parcel$export(module.exports, "getSprints", ()=>$53de331a2ac308ad$export$1b132ed8629e9cb0);
    $parcel$export(module.exports, "getExternalSprints", ()=>$53de331a2ac308ad$export$a116ea7be7faa950);
    $parcel$export(module.exports, "getOriginalPlannedCapacities", ()=>$53de331a2ac308ad$export$14005bd74601c99d);
    $parcel$export(module.exports, "getCapacityForTeamAndIteration", ()=>$53de331a2ac308ad$export$de8654fbc16cb65c);
    $parcel$export(module.exports, "getOriginalCapacityForTeamAndIteration", ()=>$53de331a2ac308ad$export$d2861cf68b3b2255);
    $parcel$export(module.exports, "getAllSprints", ()=>$53de331a2ac308ad$export$60a2c24a37c53cfb);
    $parcel$export(module.exports, "getAllSprintsById", ()=>$53de331a2ac308ad$export$9c229a6c0d778e9d);
    $parcel$export(module.exports, "getSprintsForTeam", ()=>$53de331a2ac308ad$export$136e69b79f9b3bc6);
    $parcel$export(module.exports, "getSprintByIdMap", ()=>$53de331a2ac308ad$export$d7ad569e206d3043);
    $parcel$export(module.exports, "getAllSprintsByIdMap", ()=>$53de331a2ac308ad$export$664e5a6e15bdf42d);
    $parcel$export(module.exports, "getAllSprintsIncludingDisabledByIdMap", ()=>$53de331a2ac308ad$export$bea5ded2bfc86d51);
    $parcel$export(module.exports, "getExternalSprintsById", ()=>$53de331a2ac308ad$export$254f1dd35d84707c);
    $parcel$export(module.exports, "getExternalSprintsIds", ()=>$53de331a2ac308ad$export$da62f646ce4fc45b);
    $parcel$export(module.exports, "getInternalSprintIds", ()=>$53de331a2ac308ad$export$6c8d31396a9af8fd);
    $parcel$export(module.exports, "getAllSprintIds", ()=>$53de331a2ac308ad$export$5da48e6f568fdf9d);
    $parcel$export(module.exports, "getSprintsIdsByState", ()=>$53de331a2ac308ad$export$8b47d16a8f839acb);
    $parcel$export(module.exports, "getUniqueFilterSprints", ()=>$53de331a2ac308ad$export$5e2f833fb9b859c6);
    $parcel$export(module.exports, "getSprintsForIssueSources", ()=>$53de331a2ac308ad$export$28ef6e3452a3bed3);
    $parcel$export(module.exports, "getSprintsAndTeamsByIssueSources", ()=>$53de331a2ac308ad$export$a3925a094e8f739c);
    $parcel$export(module.exports, "getSprintStatesCategories", ()=>$53de331a2ac308ad$export$14fe519a54423fb3);
    $parcel$export(module.exports, "getIssuesBySprint", ()=>$53de331a2ac308ad$export$77c13d5fe7506b9c);
    $parcel$export(module.exports, "getSprintStreamsForTeams", ()=>$53de331a2ac308ad$export$9e42c5283bf29884);
    $parcel$export(module.exports, "getSprintStreamsUnitsForTeams", ()=>$53de331a2ac308ad$export$89652c3da48f620d);
    $parcel$export(module.exports, "getSprintStreamsUnitsGetter", ()=>$53de331a2ac308ad$export$bfc3ff48117f3949);
    $parcel$export(module.exports, "getSprintsWithFutureDates", ()=>$53de331a2ac308ad$export$890993119fd2e3d2);
    $parcel$export(module.exports, "getSprintIdsWithDatesIsInconsistent", ()=>$53de331a2ac308ad$export$17db666a912c2fcd);
    $parcel$export(module.exports, "getSprintsCapacityOnTimeline", ()=>$53de331a2ac308ad$export$17eff8862a1d335b);
    $parcel$export(module.exports, "getPlannedCapacityChanges", ()=>$53de331a2ac308ad$export$846232223ccbf4ee);
    $parcel$export(module.exports, "getSprintChanges", ()=>$53de331a2ac308ad$export$137af5bfd2a1d324);
    $parcel$export(module.exports, "getSprintChangeCount", ()=>$53de331a2ac308ad$export$77d969bb56813bf0);
    var $4Rr1a;
    var $fZhYM;
    var $2rMKg;
    var $1fVsD;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $cGbfF = parcelRequire("cGbfF");
    var $1CGdp = parcelRequire("1CGdp");
    var $iIikD = parcelRequire("iIikD");
    var $7ppNi = parcelRequire("7ppNi");
    var $kllqP = parcelRequire("kllqP");
    var $6tk1y = parcelRequire("6tk1y");
    var $iGHBn = parcelRequire("iGHBn");
    var $bHTqr = parcelRequire("bHTqr");
    var $gFhwb = parcelRequire("gFhwb");
    var $jLI87 = parcelRequire("jLI87");
    var $cZF7S = parcelRequire("cZF7S");
    var $dRVQG = parcelRequire("dRVQG");
    var $jAIJh = parcelRequire("jAIJh");
    var $j0XCX = parcelRequire("j0XCX");
    var $6TEBn = parcelRequire("6TEBn");
    var $6TEBn = parcelRequire("6TEBn");
    const $53de331a2ac308ad$var$extractFromProps = (key)=>(_, props)=>props && props[key];
    const $53de331a2ac308ad$export$1b132ed8629e9cb0 = (state)=>state.domain.sprints;
    const $53de331a2ac308ad$export$a116ea7be7faa950 = (state)=>state.domain.externalSprints;
    const $53de331a2ac308ad$export$7672b228993575c9 = (state)=>state.domain.disabledSprints;
    const $53de331a2ac308ad$export$dfef5308140d2a3b = (state)=>state.domain.plannedCapacities;
    const $53de331a2ac308ad$export$14005bd74601c99d = (state)=>state.domain.originalPlannedCapacities;
    const $53de331a2ac308ad$export$157720fb6cc88d59 = (state)=>(0, parcelRequire("fZhYM")).default([
            'domain',
            'updateJira',
            'changes',
            'data',
            'metaData',
            'plannedcapacity'
        ], state);
    const $53de331a2ac308ad$export$de8654fbc16cb65c = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$dfef5308140d2a3b,
        $53de331a2ac308ad$var$extractFromProps('teamId'),
        $53de331a2ac308ad$var$extractFromProps('iterationId')
    ], (plannedCapacities, teamId, iterationId)=>(0, parcelRequire("fZhYM")).default([
            teamId,
            iterationId
        ], plannedCapacities));
    const $53de331a2ac308ad$export$d2861cf68b3b2255 = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$14005bd74601c99d,
        $53de331a2ac308ad$var$extractFromProps('teamId'),
        $53de331a2ac308ad$var$extractFromProps('iterationId')
    ], (plannedCapacities, teamId, iterationId)=>(0, parcelRequire("fZhYM")).default([
            teamId,
            iterationId
        ], plannedCapacities));
    const $53de331a2ac308ad$export$60a2c24a37c53cfb = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$1b132ed8629e9cb0,
        $53de331a2ac308ad$export$a116ea7be7faa950
    ], (sprints, externalSprints)=>[
            ...sprints,
            ...externalSprints
        ]);
    const $53de331a2ac308ad$export$9c229a6c0d778e9d = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$60a2c24a37c53cfb
    ], (sprints)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), sprints));
    const $53de331a2ac308ad$export$ebc671a197c89121 = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$1b132ed8629e9cb0,
        $53de331a2ac308ad$export$a116ea7be7faa950,
        $53de331a2ac308ad$export$7672b228993575c9
    ], (sprints, externalSprints, disabledSprints)=>[
            ...sprints,
            ...externalSprints,
            ...disabledSprints
        ]);
    const $53de331a2ac308ad$export$136e69b79f9b3bc6 = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getTeams),
        (0, $bHTqr.getIssueSources),
        $53de331a2ac308ad$export$1b132ed8629e9cb0
    ], (0, $6TEBn.getSprintsForTeamPure));
    const $53de331a2ac308ad$export$d7ad569e206d3043 = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$1b132ed8629e9cb0
    ], (0, $6TEBn.getSprintByIdMapPure));
    const $53de331a2ac308ad$export$664e5a6e15bdf42d = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$60a2c24a37c53cfb
    ], (0, $6TEBn.getSprintByIdMapPure));
    const $53de331a2ac308ad$export$bea5ded2bfc86d51 = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$ebc671a197c89121
    ], (0, $6TEBn.getSprintByIdMapPure));
    const $53de331a2ac308ad$export$254f1dd35d84707c = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$a116ea7be7faa950
    ], (externalSprints)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), externalSprints));
    const $53de331a2ac308ad$export$8eae0da3bf0aa5d4 = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$7672b228993575c9
    ], (disabledSprints)=>(0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), disabledSprints));
    const $53de331a2ac308ad$export$da62f646ce4fc45b = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$a116ea7be7faa950
    ], (externalSprints)=>(0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('id'), externalSprints));
    const $53de331a2ac308ad$export$6c8d31396a9af8fd = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$1b132ed8629e9cb0
    ], (sprints)=>sprints.map((sprint)=>sprint.id));
    const $53de331a2ac308ad$export$5da48e6f568fdf9d = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$60a2c24a37c53cfb
    ], (sprints)=>sprints.map((sprint)=>sprint.id));
    const $53de331a2ac308ad$export$8b47d16a8f839acb = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$1b132ed8629e9cb0
    ], (sprints)=>(0, parcelRequire("1fVsD")).default((acc, sprint)=>acc.concat(sprint.id), [], ({ state: state })=>state, sprints));
    const $53de331a2ac308ad$export$5e2f833fb9b859c6 = (0, $3YtPS.createSelector)([
        (0, $iIikD.getFilters)
    ], (filters)=>{
        const { [(0, $cGbfF.SPRINT_FILTER_ID)]: { value: value } } = filters;
        return new Set(value);
    });
    const $53de331a2ac308ad$export$28ef6e3452a3bed3 = (0, $3YtPS.createSelector)([
        (0, $bHTqr.getIssueSourcesById),
        $53de331a2ac308ad$export$d7ad569e206d3043,
        $53de331a2ac308ad$export$8eae0da3bf0aa5d4
    ], (0, $6TEBn.getSprintsForIssueSourcesPure));
    const $53de331a2ac308ad$export$a3925a094e8f739c = (0, $3YtPS.createSelector)([
        (0, $bHTqr.getIssueSourcesById),
        $53de331a2ac308ad$export$d7ad569e206d3043,
        (0, $dRVQG.getAllExistingTeams),
        $53de331a2ac308ad$export$8eae0da3bf0aa5d4
    ], (0, $6TEBn.getSprintsAndTeamsByIssueSourcesPure));
    const $53de331a2ac308ad$export$14fe519a54423fb3 = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$8b47d16a8f839acb,
        $53de331a2ac308ad$export$da62f646ce4fc45b,
        $53de331a2ac308ad$export$5e2f833fb9b859c6
    ], (0, $6TEBn.getSprintStatesCategoriesPure));
    const $53de331a2ac308ad$export$61afca10f5ef5a98 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssues),
        (0, $1CGdp.getMode)
    ], (0, $6TEBn.getIssuesByKanbanIterationPure));
    const $53de331a2ac308ad$export$77c13d5fe7506b9c = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssues),
        (0, $1CGdp.getMode),
        (0, $cZF7S.getSolution)
    ], (issues, mode, solution)=>mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771) ? (0, $6TEBn.getIssuesBySprintOptimizedPure)(issues, solution) : (0, $6TEBn.getIssuesBySprintPure)(issues));
    const $53de331a2ac308ad$export$ab360203c3db252b = (0, $3YtPS.createStructuredSelector)({
        defaultIterationLength: (0, $iGHBn.getDefaultIterationLength),
        defaultTeamVelocity: (0, $iGHBn.getDefaultTeamVelocity),
        issueStatusById: (0, $7ppNi.getIssueStatusById),
        issuesByKanbanIteration: $53de331a2ac308ad$export$61afca10f5ef5a98,
        issuesBySprint: $53de331a2ac308ad$export$77c13d5fe7506b9c,
        mode: (0, $1CGdp.getMode),
        planningUnit: (0, $bHTqr.getPlanningUnit),
        sprintsForTeam: $53de331a2ac308ad$export$136e69b79f9b3bc6,
        timelineRange: (0, $jAIJh.getScrollableTimelineRange),
        weeklyCapacityByTeam: (0, $dRVQG.getWeeklyCapacityByTeam),
        issueSources: (0, $bHTqr.getIssueSources),
        issues: (0, $gFhwb.getIssues),
        issueTypeById: (0, $kllqP.getIssueTypesById),
        issueLexoRankAdjustments: (0, $6tk1y.getIssueLexoRankAdjustments),
        issuesByTeam: (0, $jLI87.getIssuesByTeam),
        plannedCapacities: $53de331a2ac308ad$export$dfef5308140d2a3b,
        zoomLevel: (0, $jAIJh.getZoomLevel),
        filteredSprints: $53de331a2ac308ad$export$5e2f833fb9b859c6
    });
    const $53de331a2ac308ad$export$9e42c5283bf29884 = (0, $3YtPS.createSelector)([
        (0, $j0XCX.getSprintsAreShown),
        (0, $dRVQG.getExistingTeams),
        $53de331a2ac308ad$export$ab360203c3db252b
    ], (0, $6TEBn.getSprintStreamsForTeamsPure));
    const $53de331a2ac308ad$export$89652c3da48f620d = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$9e42c5283bf29884,
        (0, $jAIJh.getScrollableTimelineRange)
    ], (0, $6TEBn.getSprintStreamsUnitsForTeamsPure));
    const $53de331a2ac308ad$export$ecc04e4ef8bc8d33 = (0, $3YtPS.createSelector)([
        (0, $j0XCX.getSprintsAreShown),
        (0, $dRVQG.getExistingTeams),
        $53de331a2ac308ad$export$ab360203c3db252b
    ], (0, $6TEBn.getSprintsStreamsGetterPure));
    const $53de331a2ac308ad$export$bfc3ff48117f3949 = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$ecc04e4ef8bc8d33,
        (0, $jAIJh.getZoomLevel)
    ], (0, $6TEBn.getSprintStreamsUnitsGetterPure));
    const $53de331a2ac308ad$export$890993119fd2e3d2 = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$136e69b79f9b3bc6,
        (0, $dRVQG.getTeams),
        (0, $bHTqr.getIssueSources),
        $53de331a2ac308ad$export$1b132ed8629e9cb0,
        (0, $iGHBn.getDefaultIterationLength)
    ], (0, $6TEBn.getSprintsWithFutureDatesPure));
    const $53de331a2ac308ad$export$17db666a912c2fcd = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$89652c3da48f620d
    ], (0, $6TEBn.getSprintIdsWithDatesIsInconsistentPure));
    const $53de331a2ac308ad$export$17eff8862a1d335b = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getExistingTeams),
        $53de331a2ac308ad$export$ab360203c3db252b
    ], (0, $6TEBn.getSprintsCapacityOnTimelinePure));
    const $53de331a2ac308ad$export$846232223ccbf4ee = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$dfef5308140d2a3b,
        $53de331a2ac308ad$export$14005bd74601c99d,
        $53de331a2ac308ad$export$890993119fd2e3d2,
        (0, $bHTqr.getPlanningUnit),
        (0, $iGHBn.getDefaultTeamVelocity),
        (0, $dRVQG.getWeeklyCapacityByTeam),
        (0, $dRVQG.getTeamsById),
        $53de331a2ac308ad$export$157720fb6cc88d59
    ], (0, $6TEBn.getPlannedCapacityChangesPure));
    const $53de331a2ac308ad$export$137af5bfd2a1d324 = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$846232223ccbf4ee,
        $53de331a2ac308ad$export$890993119fd2e3d2
    ], (0, $6TEBn.getSprintChangesPure));
    const $53de331a2ac308ad$export$77d969bb56813bf0 = (0, $3YtPS.createSelector)([
        $53de331a2ac308ad$export$137af5bfd2a1d324
    ], (changes)=>changes.length);
});
parcelRegister("eAhNi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebfbae3f26c88e9d$export$2e2bcd8739ae039);
    var $hRxme;
    var $83IGl;
    var $4Rr1a;
    var $5KaGt;
    var $2rMKg;
    var $4R6GH;
    var $g4tDr;
    var $3J2mc;
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fOXM3 = parcelRequire("fOXM3");
    var $cGbfF = parcelRequire("cGbfF");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $d3quy = parcelRequire("d3quy");
    var $dRVQG = parcelRequire("dRVQG");
    var $jAIJh = parcelRequire("jAIJh");
    var $j0XCX = parcelRequire("j0XCX");
    const $ebfbae3f26c88e9d$var$DEFAULT_DEPENDENCY_VIEW_SETTINGS = 'lines';
    const $ebfbae3f26c88e9d$var$makePreset = (params)=>{
        const { groupBy: groupBy, expandedItems: expandedItems, colourBy: colourBy, colourMaps: colourMaps, visibleFields: visibleFields, visibleListFields: visibleListFields, timelineViewport: timelineViewport, filters: filters, calendarFilters: calendarFilters, mode: mode, rollupSettings: rollupSettings, viewMode: viewMode, hierarchyLevels: hierarchyLevels } = params;
        const { start: fromDate, end: toDate } = (0, $jAIJh.get3mthTimeScale)(new Date());
        const maxHierarchyLevel = Math.max(...hierarchyLevels.map((hierarchyLevel)=>hierarchyLevel.level));
        const allLevelsExceptHighestAndSubtasksExpandedByDefault = hierarchyLevels.reduce((acc, { level: level })=>{
            if (level >= (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE) && level !== maxHierarchyLevel) acc[`IssuesWithoutParent-${level}`] = true;
            return acc;
        }, {});
        return {
            dependencySettingsV0: {
                display: $ebfbae3f26c88e9d$var$DEFAULT_DEPENDENCY_VIEW_SETTINGS
            },
            visualisationsV0: {
                sorting: {
                    field: 'lexoRank',
                    type: (0, $TTKUQ.STRING),
                    direction: (0, $TTKUQ.ASCENDING)
                },
                grouping: groupBy,
                expandedItems: (0, parcelRequire("5KaGt")).default({
                    ASSIGNEE: {},
                    COMPONENT: {},
                    LABEL: {},
                    NONE: {},
                    PROJECT: {},
                    RELEASE: {},
                    SPRINT: {},
                    TEAM: {}
                }, expandedItems),
                showSprints: true
            },
            colourByV2: {
                colourByValue: colourBy,
                colourMaps: (0, parcelRequire("5KaGt")).default({
                    none: {},
                    project: {},
                    status: {},
                    team: {}
                }, colourMaps),
                colourComponents: [],
                colourIssueTypes: [],
                colourIssueTypeKeys: [],
                colourLabels: [],
                colourPriorities: [],
                colourSelects: {},
                lastUsed: 4
            },
            filtersV1: {
                [(0, $cGbfF.CUSTOM_FIELD_FILTER_ID)]: {
                    id: (0, $cGbfF.CUSTOM_FIELD_FILTER_ID),
                    value: {}
                },
                ...filters
            },
            calendarFiltersV1: calendarFilters,
            activeFilterViewV0: 'timeline',
            timeScaleV1: {
                selection: timelineViewport,
                customDateRange: {
                    fromDate: fromDate,
                    toDate: toDate
                },
                mode: mode
            },
            issueExpansionsV0: {
                isExpanded: {
                    IssuesWithoutParentHeader: true,
                    ...allLevelsExceptHighestAndSubtasksExpandedByDefault
                }
            },
            fieldColumnsV0: {
                columns: visibleFields.map((field)=>({
                        id: field,
                        isVisible: true
                    }))
            },
            listFieldColumnsV0: {
                columns: visibleListFields.map((field)=>({
                        id: field,
                        isVisible: true
                    }))
            },
            filterOptionsV1: {
                includeAncestors: true,
                includeDescendants: true
            },
            componentGroupsV0: [
                {
                    id: 'all_other_issues',
                    name: '',
                    isExpanded: false,
                    components: []
                }
            ],
            labelGroupsV0: [
                {
                    id: 'all_other_issues',
                    name: '',
                    isExpanded: false,
                    labels: []
                }
            ],
            customFieldValuesGroupsV0: {},
            highlightedVersionsV0: {
                versions: []
            },
            rollupSettingsV0: {
                showingRolledUpDate: true,
                showRolledUpOthers: true,
                ...rollupSettings
            },
            warningSettingsV1: {
                showWarning: false,
                disabledWarnings: []
            },
            dateConstraintsV0: {
                showDateConstraints: false
            },
            viewModeV0: {
                mode: viewMode
            }
        };
    };
    const $ebfbae3f26c88e9d$var$getMinMaxIssuesLevels = (state)=>{
        const { issues: issues, hierarchy: hierarchy } = state.domain;
        if (issues.length) {
            const issuesLevels = (0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('level'))(issues);
            return {
                start: (0, parcelRequire("hRxme")).default(Math.max, issuesLevels),
                end: (0, parcelRequire("hRxme")).default(Math.min, issuesLevels)
            };
        }
        const hierarchyLevels = (0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('level'))(hierarchy.levels);
        return {
            start: (0, parcelRequire("hRxme")).default(Math.max, hierarchyLevels),
            end: (0, parcelRequire("hRxme")).default(Math.min, hierarchyLevels)
        };
    };
    const $ebfbae3f26c88e9d$var$getFutureSprints = (sprints)=>sprints.filter(({ state: state })=>state === (0, $TTKUQ.SPRINT_STATES).FUTURE).map(({ id: id })=>id);
    const $ebfbae3f26c88e9d$var$getProjectExpansions = (projects)=>projects.reduce((acc, { id: id })=>Object.assign(acc, {
                [`project-${id}`]: true
            }), {});
    const $ebfbae3f26c88e9d$var$getPresetsPure = (state, colourMaps, projects, sprints, planType)=>{
        const dateConfiguration = (0, $bHTqr.getDateConfiguration)(state);
        const isCrossTeam = planType === 'CROSS_TEAM';
        const isCrossTeamPlanning = planType === 'CROSS_TEAM_PLANNING';
        const isSamplePlan = (0, $bHTqr.getIsSamplePlan)(state);
        const hierarchyLevels = (0, $6Ayrn.getHierarchyLevels)(state);
        const teamExpansions = (()=>{
            const teams = (0, $dRVQG.getTeams)(state);
            return teams.map(({ id: id })=>id).reduce((acc, id)=>{
                acc[`team-${id}`] = true;
                return acc;
            }, {});
        })();
        const calendarFilters = {
            [(0, $cGbfF.HIERARCHY_FILTER_ID)]: {
                id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                value: {
                    start: $ebfbae3f26c88e9d$var$getMinMaxIssuesLevels(state).start + 1,
                    end: $ebfbae3f26c88e9d$var$getMinMaxIssuesLevels(state).end + 1
                }
            },
            [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: {
                id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                value: $ebfbae3f26c88e9d$var$getMinMaxIssuesLevels(state)
            }
        };
        const getBasicFilters = ()=>{
            return {
                [(0, $cGbfF.HIERARCHY_FILTER_ID)]: {
                    id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                    value: isCrossTeam ? {
                        start: 3,
                        end: 0
                    } : {
                        start: $ebfbae3f26c88e9d$var$getMinMaxIssuesLevels(state).start + 1,
                        end: $ebfbae3f26c88e9d$var$getMinMaxIssuesLevels(state).end + 1
                    }
                },
                [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: {
                    id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                    value: isCrossTeam ? {
                        start: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_INITIATIVE),
                        end: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_SUBTASK)
                    } : $ebfbae3f26c88e9d$var$getMinMaxIssuesLevels(state)
                }
            };
        };
        const basic = $ebfbae3f26c88e9d$var$makePreset({
            groupBy: (0, $TTKUQ.GROUPING).NONE,
            expandedItems: {},
            colourBy: 'status',
            colourMaps: colourMaps,
            visibleFields: [
                'issueStatus'
            ],
            visibleListFields: [
                'priority',
                dateConfiguration.baselineStartField.key,
                dateConfiguration.baselineEndField.key,
                'issueStatus',
                'progressByEstimation',
                'team'
            ],
            timelineViewport: '3mth',
            mode: (0, $TTKUQ.TIMELINE_MODES).MONTHS,
            viewMode: (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST,
            filters: getBasicFilters(),
            calendarFilters: calendarFilters,
            ...isCrossTeam && {
                rollupSettings: {
                    showingRolledUpDate: true,
                    showRolledUpOthers: true
                }
            },
            hierarchyLevels: hierarchyLevels
        });
        const getSprintCapacityManagementFilters = ()=>{
            if (isSamplePlan) return {
                filters: {
                    [(0, $cGbfF.HIERARCHY_FILTER_ID)]: {
                        id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                        value: {
                            start: 2,
                            end: 0
                        }
                    },
                    [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: {
                        id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                        value: {
                            start: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC),
                            end: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_SUBTASK)
                        }
                    }
                },
                calendarFilters: calendarFilters,
                rollupSettings: {
                    showingRolledUpDate: true,
                    showRolledUpOthers: false
                }
            };
            if (isCrossTeamPlanning) return {
                filters: {
                    [(0, $cGbfF.SPRINT_FILTER_ID)]: {
                        id: (0, $cGbfF.SPRINT_FILTER_ID),
                        value: $ebfbae3f26c88e9d$var$getFutureSprints(sprints)
                    },
                    [(0, $cGbfF.HIERARCHY_FILTER_ID)]: {
                        id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                        value: {
                            start: 2,
                            end: 2
                        }
                    },
                    [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: {
                        id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                        value: {
                            start: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC),
                            end: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC)
                        }
                    }
                },
                calendarFilters: calendarFilters
            };
            return {
                filters: {
                    [(0, $cGbfF.SPRINT_FILTER_ID)]: {
                        id: (0, $cGbfF.SPRINT_FILTER_ID),
                        value: $ebfbae3f26c88e9d$var$getFutureSprints(sprints)
                    },
                    [(0, $cGbfF.HIERARCHY_FILTER_ID)]: {
                        id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                        value: {
                            start: 1,
                            end: 1
                        }
                    },
                    [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: {
                        id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                        value: {
                            start: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE),
                            end: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE)
                        }
                    }
                },
                calendarFilters: calendarFilters
            };
        };
        const sprintCapacityManagement = $ebfbae3f26c88e9d$var$makePreset({
            groupBy: (0, $TTKUQ.GROUPING).TEAM,
            expandedItems: {
                TEAM: {
                    UNDEFINED: true,
                    ...teamExpansions
                }
            },
            colourBy: 'status',
            colourMaps: colourMaps,
            visibleFields: [
                'assignee',
                ...(0, (0, parcelRequire("4R6GH")).fg)('sprint_capacity_view_default_refactor') ? [
                    'team'
                ] : []
            ],
            visibleListFields: [
                'priority',
                'sprint',
                'estimate',
                'team',
                'release',
                'assignee'
            ],
            timelineViewport: '3mth',
            mode: (0, $TTKUQ.TIMELINE_MODES).MONTHS,
            viewMode: (0, (0, parcelRequire("4R6GH")).fg)('sprint_capacity_view_default_refactor') ? (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE : (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST,
            hierarchyLevels: hierarchyLevels,
            ...getSprintCapacityManagementFilters()
        });
        const topLevelPlanning = $ebfbae3f26c88e9d$var$makePreset({
            groupBy: (0, $TTKUQ.GROUPING).PROJECT,
            expandedItems: {
                PROJECT: $ebfbae3f26c88e9d$var$getProjectExpansions(projects)
            },
            colourBy: 'team',
            colourMaps: colourMaps,
            visibleFields: [
                'team'
            ],
            visibleListFields: [
                'breakdown',
                'priority',
                dateConfiguration.baselineStartField.key,
                dateConfiguration.baselineEndField.key,
                'team',
                'release',
                'components'
            ],
            timelineViewport: '1yr',
            mode: (0, $TTKUQ.TIMELINE_MODES).QUARTERS,
            viewMode: (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST,
            filters: {
                [(0, $cGbfF.HIERARCHY_FILTER_ID)]: {
                    id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                    value: {
                        start: 9,
                        end: 1
                    }
                },
                [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: {
                    id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                    value: {
                        start: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE) + 8,
                        end: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE)
                    }
                }
            },
            calendarFilters: calendarFilters,
            hierarchyLevels: hierarchyLevels
        });
        const dependencyManagement = $ebfbae3f26c88e9d$var$makePreset({
            groupBy: (0, $TTKUQ.GROUPING).NONE,
            expandedItems: {},
            colourBy: 'status',
            colourMaps: colourMaps,
            visibleFields: [
                'team'
            ],
            visibleListFields: [
                'incomingDependencies',
                'outgoingDependencies',
                'priority',
                dateConfiguration.baselineStartField.key,
                dateConfiguration.baselineEndField.key,
                'team'
            ],
            timelineViewport: '1yr',
            mode: (0, $TTKUQ.TIMELINE_MODES).QUARTERS,
            viewMode: (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST,
            filters: {
                [(0, $cGbfF.DEPENDENCIES_FILTER_ID)]: {
                    id: (0, $cGbfF.DEPENDENCIES_FILTER_ID),
                    value: {
                        type: 'on'
                    }
                },
                [(0, $cGbfF.HIERARCHY_FILTER_ID)]: {
                    id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                    value: {
                        start: 2,
                        end: 0
                    }
                },
                [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: {
                    id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                    value: {
                        start: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC),
                        end: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_SUBTASK)
                    }
                }
            },
            calendarFilters: calendarFilters,
            hierarchyLevels: hierarchyLevels
        });
        const presetNames = (0, $fOXM3.getPresetViewNames)();
        return {
            [presetNames.BASIC]: basic,
            [presetNames.SPRINT_CAPACITY_MANAGEMENT]: sprintCapacityManagement,
            [presetNames.TOP_LEVEL_PLANNING]: topLevelPlanning,
            [presetNames.DEPENDENCY_MANAGEMENT]: dependencyManagement
        };
    };
    const $ebfbae3f26c88e9d$var$getPresets = (0, $3YtPS.createSelector)([
        (0, parcelRequire("83IGl")).default,
        (0, $j0XCX.getColourMaps),
        (0, $jpXKt.getProjects),
        (0, $d3quy.getSprints),
        (0, $bHTqr.getPlanType)
    ], $ebfbae3f26c88e9d$var$getPresetsPure);
    var $ebfbae3f26c88e9d$export$2e2bcd8739ae039 = $ebfbae3f26c88e9d$var$getPresets;
});
parcelRegister("hRxme", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d01143071fb3b398$export$2e2bcd8739ae039);
    var $c9RLn;
    var $d01143071fb3b398$var$apply = (0, (0, parcelRequire("c9RLn")).default)(function apply(fn, args) {
        return fn.apply(this, args);
    });
    var $d01143071fb3b398$export$2e2bcd8739ae039 = $d01143071fb3b398$var$apply;
});
parcelRegister("5KaGt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42e989455f35d3ad$export$2e2bcd8739ae039);
    var $c9RLn;
    var $ejhbF;
    var $42e989455f35d3ad$var$mergeDeepRight = (0, (0, parcelRequire("c9RLn")).default)(function mergeDeepRight(lObj, rObj) {
        return (0, (0, parcelRequire("ejhbF")).default)(function(k, lVal, rVal) {
            return rVal;
        }, lObj, rObj);
    });
    var $42e989455f35d3ad$export$2e2bcd8739ae039 = $42e989455f35d3ad$var$mergeDeepRight;
});
parcelRegister("fOXM3", function(module, exports) {
    $parcel$export(module.exports, "getPresetViewNames", ()=>$26ac94b21a420219$export$4c84de639d306578);
    $parcel$export(module.exports, "getMigratedPresetViewName", ()=>$26ac94b21a420219$export$310b844714cc8795);
    var $4R6GH;
    var $2l86k = parcelRequire("2l86k");
    const $26ac94b21a420219$export$ce22daa42f564de0 = (currentVersions, finalVersion)=>currentVersions.reduce((migrationMap, currentVersion)=>{
            Object.assign(migrationMap, Object.fromEntries(Object.keys(finalVersion).filter((key)=>currentVersion[key]).map((key)=>[
                    currentVersion[key],
                    finalVersion[key]
                ])));
            return migrationMap;
        }, {});
    const $26ac94b21a420219$var$migrationMapOld = $26ac94b21a420219$export$ce22daa42f564de0([
        (0, $2l86k.PRESET_VIEWS_NAMES_V1),
        (0, $2l86k.PRESET_VIEWS_NAMES_V2)
    ], (0, $2l86k.PRESET_VIEWS_NAMES_V3));
    const $26ac94b21a420219$var$migrationMapNew = $26ac94b21a420219$export$ce22daa42f564de0([
        (0, $2l86k.PRESET_VIEWS_NAMES_V1),
        (0, $2l86k.PRESET_VIEWS_NAMES_V2),
        (0, $2l86k.PRESET_VIEWS_NAMES_V3)
    ], (0, $2l86k.PRESET_VIEWS_NAMES_V4));
    const $26ac94b21a420219$export$4c84de639d306578 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('sprint_capacity_view_default_refactor') ? (0, $2l86k.PRESET_VIEWS_NAMES_V4) : (0, $2l86k.PRESET_VIEWS_NAMES_V3);
    const $26ac94b21a420219$export$310b844714cc8795 = (view)=>{
        const isUserDefinedOrModifiedPresetView = view.updatedAt;
        if (isUserDefinedOrModifiedPresetView) return view.name;
        const migrationMap = (0, (0, parcelRequire("4R6GH")).fg)('sprint_capacity_view_default_refactor') ? $26ac94b21a420219$var$migrationMapNew : $26ac94b21a420219$var$migrationMapOld;
        return migrationMap[view.name] || view.name;
    };
});
parcelRegister("2l86k", function(module, exports) {
    $parcel$export(module.exports, "PRESET_VIEWS_NAMES_V1", ()=>$977153c6f5e23263$export$67bf3fbafd21640c);
    $parcel$export(module.exports, "PRESET_VIEWS_NAMES_V2", ()=>$977153c6f5e23263$export$684b31ff3ba50072);
    $parcel$export(module.exports, "PRESET_VIEWS_NAMES_V3", ()=>$977153c6f5e23263$export$62577b1c23812511);
    $parcel$export(module.exports, "PRESET_VIEWS_NAMES_V4", ()=>$977153c6f5e23263$export$7ea2976773d13ff6);
    const $977153c6f5e23263$export$67bf3fbafd21640c = {
        BASIC: 'Basic',
        SPRINT_CAPACITY_MANAGEMENT: 'Sprint capacity management',
        TOP_LEVEL_PLANNING: 'Top-level planning',
        DEPENDENCY_MANAGEMENT: 'Dependency management'
    };
    const $977153c6f5e23263$export$684b31ff3ba50072 = {
        BASIC: 'Basic view',
        SPRINT_CAPACITY_MANAGEMENT: 'Sprint capacity management view',
        TOP_LEVEL_PLANNING: 'Top-level planning view',
        DEPENDENCY_MANAGEMENT: 'Dependency management view'
    };
    const $977153c6f5e23263$export$62577b1c23812511 = {
        BASIC: 'Basic view',
        SPRINT_CAPACITY_MANAGEMENT: 'Sprint capacity view',
        TOP_LEVEL_PLANNING: 'Top-level view',
        DEPENDENCY_MANAGEMENT: 'Dependencies'
    };
    const $977153c6f5e23263$export$7ea2976773d13ff6 = {
        BASIC: 'Basic view',
        SPRINT_CAPACITY_MANAGEMENT: 'Capacity view',
        TOP_LEVEL_PLANNING: 'Top-level view',
        DEPENDENCY_MANAGEMENT: 'Dependencies'
    };
});
parcelRegister("8vuta", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$d4430dcd12214c56$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$d4430dcd12214c56$export$aad8462122ac592b);
    const $d4430dcd12214c56$export$4a991c87e640ef77 = 'state.domain.view-settings.RESET';
    const $d4430dcd12214c56$export$aad8462122ac592b = (payload)=>({
            type: $d4430dcd12214c56$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("3t3Pr", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$9bc481dd8ec73908$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD_VIEW", ()=>$9bc481dd8ec73908$export$d5c7f0043e8499b4);
    $parcel$export(module.exports, "SET_ACTIVE_VIEW", ()=>$9bc481dd8ec73908$export$1dcbb1560f898e17);
    $parcel$export(module.exports, "UPDATE_VIEW", ()=>$9bc481dd8ec73908$export$f72ed78ff6e8d2c1);
    $parcel$export(module.exports, "MODIFY_VIEW", ()=>$9bc481dd8ec73908$export$9924007b7b68c0);
    $parcel$export(module.exports, "DISCARD_CHANGES", ()=>$9bc481dd8ec73908$export$633852209b65bdf8);
    $parcel$export(module.exports, "SAVE_VIEW", ()=>$9bc481dd8ec73908$export$54365030094e4c08);
    $parcel$export(module.exports, "CHANGE_ID", ()=>$9bc481dd8ec73908$export$30d96d366ce76f35);
    $parcel$export(module.exports, "REMOVE_VIEW", ()=>$9bc481dd8ec73908$export$b17ac863c94eaf9d);
    $parcel$export(module.exports, "MARK_AS_DEFAULT_VIEW", ()=>$9bc481dd8ec73908$export$898cd9d1c5ed8268);
    $parcel$export(module.exports, "reset", ()=>$9bc481dd8ec73908$export$aad8462122ac592b);
    $parcel$export(module.exports, "addView", ()=>$9bc481dd8ec73908$export$35410e842afb9251);
    $parcel$export(module.exports, "setActiveView", ()=>$9bc481dd8ec73908$export$72db5c5227066d6d);
    $parcel$export(module.exports, "updateView", ()=>$9bc481dd8ec73908$export$827a6c17a85f6d1a);
    $parcel$export(module.exports, "modifyView", ()=>$9bc481dd8ec73908$export$d47a9f66421ac6ac);
    $parcel$export(module.exports, "discardChanges", ()=>$9bc481dd8ec73908$export$a1371969d487fc2a);
    $parcel$export(module.exports, "saveView", ()=>$9bc481dd8ec73908$export$5c85e4ea5ae8a7f2);
    $parcel$export(module.exports, "changeId", ()=>$9bc481dd8ec73908$export$8573c371c091443a);
    $parcel$export(module.exports, "removeView", ()=>$9bc481dd8ec73908$export$db777a0280058600);
    $parcel$export(module.exports, "markAsDefaultView", ()=>$9bc481dd8ec73908$export$65c8c09b8f8e5243);
    const $9bc481dd8ec73908$export$4a991c87e640ef77 = 'state.domain.views.RESET';
    const $9bc481dd8ec73908$export$d5c7f0043e8499b4 = 'state.domain.views.ADD_VIEW';
    const $9bc481dd8ec73908$export$1dcbb1560f898e17 = 'state.domain.views.SET_ACTIVE_VIEW';
    const $9bc481dd8ec73908$export$f72ed78ff6e8d2c1 = 'state.domain.views.UPDATE_VIEW';
    const $9bc481dd8ec73908$export$9924007b7b68c0 = 'state.domain.views.MODIFY_VIEW';
    const $9bc481dd8ec73908$export$633852209b65bdf8 = 'state.domain.views.DISCARD_CHANGES';
    const $9bc481dd8ec73908$export$54365030094e4c08 = 'state.domain.views.SAVE_VIEW';
    const $9bc481dd8ec73908$export$30d96d366ce76f35 = 'state.domain.views.CHANGE_ID';
    const $9bc481dd8ec73908$export$b17ac863c94eaf9d = 'state.domain.views.REMOVE_VIEW';
    const $9bc481dd8ec73908$export$898cd9d1c5ed8268 = 'state.domain.views.MARK_AS_DEFAULT_VIEW';
    const $9bc481dd8ec73908$export$aad8462122ac592b = (payload)=>({
            type: $9bc481dd8ec73908$export$4a991c87e640ef77,
            payload: payload
        });
    const $9bc481dd8ec73908$export$35410e842afb9251 = (payload)=>({
            type: $9bc481dd8ec73908$export$d5c7f0043e8499b4,
            payload: payload
        });
    const $9bc481dd8ec73908$export$72db5c5227066d6d = (payload)=>({
            type: $9bc481dd8ec73908$export$1dcbb1560f898e17,
            payload: payload
        });
    const $9bc481dd8ec73908$export$827a6c17a85f6d1a = (payload)=>({
            type: $9bc481dd8ec73908$export$f72ed78ff6e8d2c1,
            payload: payload
        });
    const $9bc481dd8ec73908$export$d47a9f66421ac6ac = (payload)=>({
            type: $9bc481dd8ec73908$export$9924007b7b68c0,
            payload: payload
        });
    const $9bc481dd8ec73908$export$a1371969d487fc2a = (id)=>({
            type: $9bc481dd8ec73908$export$633852209b65bdf8,
            payload: {
                id: id
            }
        });
    const $9bc481dd8ec73908$export$5c85e4ea5ae8a7f2 = (id, nextVersion, name)=>({
            type: $9bc481dd8ec73908$export$54365030094e4c08,
            payload: {
                id: id,
                version: nextVersion,
                name: name
            }
        });
    const $9bc481dd8ec73908$export$8573c371c091443a = (previous, next)=>({
            type: $9bc481dd8ec73908$export$30d96d366ce76f35,
            payload: {
                previous: previous,
                next: next
            }
        });
    const $9bc481dd8ec73908$export$db777a0280058600 = (id)=>({
            type: $9bc481dd8ec73908$export$b17ac863c94eaf9d,
            payload: {
                id: id
            }
        });
    const $9bc481dd8ec73908$export$65c8c09b8f8e5243 = (id)=>({
            type: $9bc481dd8ec73908$export$898cd9d1c5ed8268,
            payload: {
                id: id
            }
        });
});
const $2d3f0303b0f7650a$export$bbf45675c6d09c28 = 0;
const $2d3f0303b0f7650a$export$468529e988abe072 = '@@CURRENT_USER';
parcelRegister("edCT0", function(module, exports) {
    $parcel$export(module.exports, "SET_RENAME_SAVING", ()=>$bfc24e3fc273bbb7$export$457cfa1eeaf7e7d0);
    $parcel$export(module.exports, "setRenameSaving", ()=>$bfc24e3fc273bbb7$export$e0b94c76da8c605e);
    var $c5JsS = parcelRequire("c5JsS");
    const $bfc24e3fc273bbb7$export$457cfa1eeaf7e7d0 = 'state.ui.settings.views.row.SET_RENAME_SAVING';
    const $bfc24e3fc273bbb7$export$e0b94c76da8c605e = (saving)=>({
            type: $bfc24e3fc273bbb7$export$457cfa1eeaf7e7d0,
            payload: saving
        });
});
parcelRegister("c5JsS", function(module, exports) {
    $parcel$export(module.exports, "ADD_ERROR", ()=>$4f7261baf9e8a79c$export$3a6b9485726c3ea0);
    $parcel$export(module.exports, "REMOVE_ERROR", ()=>$4f7261baf9e8a79c$export$bb5b23b9a43f9778);
    $parcel$export(module.exports, "SET_SAVE_VIEW_AS_DIALOG_STATUS", ()=>$4f7261baf9e8a79c$export$bd13754248ee35);
    $parcel$export(module.exports, "addError", ()=>$4f7261baf9e8a79c$export$239c33984d9b1367);
    $parcel$export(module.exports, "removeError", ()=>$4f7261baf9e8a79c$export$220bda22c3bcb06f);
    $parcel$export(module.exports, "setSaveViewAsDialogStatus", ()=>$4f7261baf9e8a79c$export$e2e02ce9f0f78490);
    const $4f7261baf9e8a79c$export$3a6b9485726c3ea0 = 'state.ui.top.view-bar.ADD_ERROR';
    const $4f7261baf9e8a79c$export$bb5b23b9a43f9778 = 'state.ui.top.view-bar.REMOVE_ERROR';
    const $4f7261baf9e8a79c$export$bd13754248ee35 = 'state.ui.top.view-bar.SET_SAVE_VIEW_AS_DIALOG_STATUS';
    const $4f7261baf9e8a79c$export$239c33984d9b1367 = (error)=>({
            type: $4f7261baf9e8a79c$export$3a6b9485726c3ea0,
            payload: error
        });
    const $4f7261baf9e8a79c$export$220bda22c3bcb06f = (error)=>({
            type: $4f7261baf9e8a79c$export$bb5b23b9a43f9778,
            payload: error
        });
    const $4f7261baf9e8a79c$export$e2e02ce9f0f78490 = (status)=>({
            type: $4f7261baf9e8a79c$export$bd13754248ee35,
            payload: status
        });
});
parcelRegister("bYhSc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$830ac93f99a8ea6d$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $kfvhW = parcelRequire("kfvhW");
    function* $830ac93f99a8ea6d$export$2e2bcd8739ae039(callback) {
        yield (0, $aNOuE.put)((0, $kfvhW.suspend)());
        try {
            yield (0, $aNOuE.call)(callback);
        } finally{
            yield (0, $aNOuE.put)((0, $kfvhW.resume)());
        }
    }
});
parcelRegister("kfvhW", function(module, exports) {
    $parcel$export(module.exports, "suspend", ()=>$31ef6ddec730d8cb$export$a1428c8f7ba796e8);
    $parcel$export(module.exports, "resume", ()=>$31ef6ddec730d8cb$export$fbb4d68fe60c1629);
    $parcel$export(module.exports, "default", ()=>$31ef6ddec730d8cb$export$2e2bcd8739ae039);
    const $31ef6ddec730d8cb$export$ee1b0a20fd84ab63 = 'state.enhancers.suspender.SUSPEND';
    const $31ef6ddec730d8cb$export$97fb89e237502f12 = 'state.enhancers.suspender.RESUME';
    const $31ef6ddec730d8cb$export$a1428c8f7ba796e8 = ()=>({
            type: $31ef6ddec730d8cb$export$ee1b0a20fd84ab63
        });
    const $31ef6ddec730d8cb$export$fbb4d68fe60c1629 = ()=>({
            type: $31ef6ddec730d8cb$export$97fb89e237502f12
        });
    var $31ef6ddec730d8cb$export$2e2bcd8739ae039 = ()=>{
        let lockCounter = 0;
        let currentListeners = [];
        let nextListeners = currentListeners;
        const ensureCanMutateNextListeners = ()=>{
            if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
        };
        const subscribe = (listener)=>{
            if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
            const entry = nextListeners.find((entry)=>listener === entry[0]);
            if (entry) return entry[1];
            const unsubscribe = ()=>{
                const index = nextListeners.findIndex((entry)=>listener === entry[0]);
                if (index < 0) return;
                ensureCanMutateNextListeners();
                nextListeners.splice(index, 1);
            };
            ensureCanMutateNextListeners();
            nextListeners.push([
                listener,
                unsubscribe
            ]);
            return unsubscribe;
        };
        const notifyListeners = ()=>{
            if (lockCounter > 0) return;
            currentListeners = nextListeners;
            for(let i = 0; i < currentListeners.length; i++)currentListeners[i][0]();
        };
        return (next)=>(...args)=>{
                const store = next(...args);
                const subscribeImmediate = store.subscribe;
                const dispatch = (...dispatchArgs)=>{
                    const [action] = dispatchArgs;
                    switch(action.type){
                        case $31ef6ddec730d8cb$export$97fb89e237502f12:
                            if (lockCounter <= 0) throw new Error(`Unbalanced ${$31ef6ddec730d8cb$export$97fb89e237502f12}`);
                            lockCounter--;
                            notifyListeners();
                            return action;
                        case $31ef6ddec730d8cb$export$ee1b0a20fd84ab63:
                            lockCounter++;
                            return action;
                        default:
                            {
                                const result = store.dispatch(...dispatchArgs);
                                notifyListeners();
                                return result;
                            }
                    }
                };
                return {
                    ...store,
                    dispatch: dispatch,
                    subscribe: subscribe,
                    subscribeImmediate: subscribeImmediate
                };
            };
    };
});
parcelRegister("24CMK", function(module, exports) {
    $parcel$export(module.exports, "genericError", ()=>$7470556dc6b1846e$export$28cd364e99d3d2cb);
    $parcel$export(module.exports, "httpRequestError", ()=>$7470556dc6b1846e$export$90aa3e18a8fea0c3);
    $parcel$export(module.exports, "default", ()=>$7470556dc6b1846e$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $4R6GH;
    var $y9aeT = parcelRequire("y9aeT");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $idmiV = parcelRequire("idmiV");
    var $jpgxP = parcelRequire("jpgxP");
    var $eWre9 = parcelRequire("eWre9");
    var $fgQSN = parcelRequire("fgQSN");
    const $7470556dc6b1846e$export$4b044058fcbf0e64 = 'command.errors.GENERIC_ERROR';
    const $7470556dc6b1846e$export$28cd364e99d3d2cb = (payload)=>({
            type: $7470556dc6b1846e$export$4b044058fcbf0e64,
            payload: payload
        });
    function* $7470556dc6b1846e$export$7bb03edbe2d071a1({ payload: { message: message, stackTrace: stackTrace, requestInfo: requestInfo, shouldReportError: shouldReportError = true, description: description } }) {
        if ((0, $fgQSN.shouldIgnoreError)(message)) {
            console.warn('Not showing JPO error dialog for exception:', message);
            return;
        }
        const error = new Error(message);
        if (stackTrace) error.stack = stackTrace;
        const details = {
            requestInfo: requestInfo,
            clientInfo: {
                userAgent: $idmiV.userAgent,
                localTime: new Date().toString()
            },
            systemInfo: yield (0, $aNOuE.select)((0, $jpgxP.getSystemInfo))
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('plans-generic-error-sentry-logs')) {
            if (shouldReportError) {
                const id = (0, $y9aeT.isEnvironmentError)(error) ? (0, $TTKUQ.ERROR_REPORTING_PACKAGE).ENVIRONMENT : (0, $TTKUQ.ERROR_REPORTING_PACKAGE).REDUX_SAGA;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: id,
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: !(0, $4nDwW.isDefined)(requestInfo)
                });
            }
        } else if (shouldReportError && !(0, $4nDwW.isDefined)(requestInfo)) {
            const id = (0, $y9aeT.isEnvironmentError)(error) ? (0, $TTKUQ.ERROR_REPORTING_PACKAGE).ENVIRONMENT : (0, $TTKUQ.ERROR_REPORTING_PACKAGE).REDUX_SAGA;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: id,
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        yield (0, $aNOuE.put)((0, $eWre9.showError)(message, stackTrace, window?.location.hash, window?.location.pathname, details, description));
    }
    function $7470556dc6b1846e$export$90aa3e18a8fea0c3(response, error, requestObj) {
        return $7470556dc6b1846e$export$28cd364e99d3d2cb({
            ...error,
            requestInfo: {
                url: response.url,
                type: requestObj.method,
                status: response.status,
                body: response.body || {}
            }
        });
    }
    function* $7470556dc6b1846e$export$2e2bcd8739ae039() {
        yield (0, $6u3NN.takeEvery)($7470556dc6b1846e$export$4b044058fcbf0e64, $7470556dc6b1846e$export$7bb03edbe2d071a1);
    }
});
parcelRegister("y9aeT", function(module, exports) {
    $parcel$export(module.exports, "isEnvironmentError", ()=>$a9f585ee2e467606$export$c064455e4b53485b);
    $parcel$export(module.exports, "RESPONSE_ERROR_CODE", ()=>$a9f585ee2e467606$export$c1f417eafe9132b3);
    const $a9f585ee2e467606$var$environmentErrorMessagesRegexes = [
        'Failed to fetch$',
        'Failed to fetch page data for plan',
        "Cannot read property 'claim' of undefined$",
        'NetworkError when attempting to fetch resource.$',
        'cancelled$',
        '^Not enough storage is available to complete this operation.$',
        'The operation was aborted.$',
        "^undefined is not an object \\(evaluating 'window.WRM.data.claim'\\)$",
        'The request timed out.$',
        'The network connection was lost.$'
    ];
    const $a9f585ee2e467606$var$environmentErrorMessagesRegex = new RegExp($a9f585ee2e467606$var$environmentErrorMessagesRegexes.join('|'));
    const $a9f585ee2e467606$export$c064455e4b53485b = (error)=>error.message.match($a9f585ee2e467606$var$environmentErrorMessagesRegex);
    const $a9f585ee2e467606$export$c1f417eafe9132b3 = {
        REQUIRE_STATUS_TRANSITION_SCREEN: 'REQUIRE_STATUS_TRANSITION_SCREEN'
    };
});
parcelRegister("eWre9", function(module, exports) {
    $parcel$export(module.exports, "SHOW_ERROR", ()=>$be19bca10c9e0ce1$export$5973607600a0786d);
    $parcel$export(module.exports, "HIDE_ERROR", ()=>$be19bca10c9e0ce1$export$35787d4a70876f22);
    $parcel$export(module.exports, "HIDE_ALL_ERRORS", ()=>$be19bca10c9e0ce1$export$f926a085912a5839);
    $parcel$export(module.exports, "SHOW_ERROR_LOG_DIALOG", ()=>$be19bca10c9e0ce1$export$e0cd60c420c02c62);
    $parcel$export(module.exports, "HIDE_ERROR_LOG_DIALOG", ()=>$be19bca10c9e0ce1$export$57775ccf5f85090c);
    $parcel$export(module.exports, "SET_IS_PROJECT_LIMIT_EXCEEDED", ()=>$be19bca10c9e0ce1$export$bf07a2a294a1e09);
    $parcel$export(module.exports, "showError", ()=>$be19bca10c9e0ce1$export$3879b24e8245693d);
    $parcel$export(module.exports, "hideError", ()=>$be19bca10c9e0ce1$export$ef18f38624819fc7);
    $parcel$export(module.exports, "hideAllErrors", ()=>$be19bca10c9e0ce1$export$b14e3962385f56b8);
    $parcel$export(module.exports, "showErrorLogDialog", ()=>$be19bca10c9e0ce1$export$5bcf5adcc0c68988);
    $parcel$export(module.exports, "hideErrorLogDialog", ()=>$be19bca10c9e0ce1$export$1f3af5ffc591ab3d);
    $parcel$export(module.exports, "setIsProjectLimitExceeded", ()=>$be19bca10c9e0ce1$export$c952db40d64d2fb1);
    const $be19bca10c9e0ce1$export$5973607600a0786d = 'state.ui.errors.SHOW_ERROR';
    const $be19bca10c9e0ce1$export$35787d4a70876f22 = 'state.ui.errors.HIDE_ERROR';
    const $be19bca10c9e0ce1$export$f926a085912a5839 = 'state.ui.errors.HIDE_ALL_ERRORS';
    const $be19bca10c9e0ce1$export$e0cd60c420c02c62 = 'state.ui.errors.SHOW_ERROR_LOG_DIALOG';
    const $be19bca10c9e0ce1$export$57775ccf5f85090c = 'state.ui.errors.HIDE_ERROR_LOG_DIALOG';
    const $be19bca10c9e0ce1$export$bf07a2a294a1e09 = 'state.ui.errors.SET_IS_PROJECT_LIMIT_EXCEEDED';
    const $be19bca10c9e0ce1$export$3879b24e8245693d = (message, stackTrace, locationHash, locationPath, details, description)=>({
            type: $be19bca10c9e0ce1$export$5973607600a0786d,
            payload: {
                title: '',
                message: message,
                stackTrace: stackTrace,
                locationHash: locationHash,
                locationPath: locationPath,
                details: details,
                description: description
            }
        });
    const $be19bca10c9e0ce1$export$ef18f38624819fc7 = ()=>({
            type: $be19bca10c9e0ce1$export$35787d4a70876f22
        });
    const $be19bca10c9e0ce1$export$b14e3962385f56b8 = ()=>({
            type: $be19bca10c9e0ce1$export$f926a085912a5839
        });
    const $be19bca10c9e0ce1$export$5bcf5adcc0c68988 = ()=>({
            type: $be19bca10c9e0ce1$export$e0cd60c420c02c62
        });
    const $be19bca10c9e0ce1$export$1f3af5ffc591ab3d = ()=>({
            type: $be19bca10c9e0ce1$export$57775ccf5f85090c
        });
    const $be19bca10c9e0ce1$export$c952db40d64d2fb1 = ()=>({
            type: $be19bca10c9e0ce1$export$bf07a2a294a1e09
        });
});
parcelRegister("fgQSN", function(module, exports) {
    $parcel$export(module.exports, "shouldIgnoreError", ()=>$2eed509e2b22cd76$export$a42b2ab4291804cd);
    var $8BDMi;
    var $idmiV = parcelRequire("idmiV");
    const $2eed509e2b22cd76$var$ignoredErrorRegexes = [
        /Uncaught QuotaExceededError: Failed to execute 'setItem' on 'Storage': Setting the value of '.*' exceeded the quota/,
        /NS_ERROR_DOM_QUOTA_REACHED: Persistent storage maximum size reached/,
        /QuotaExceededError: DOM Exception 22: An attempt was made to add something to storage that exceeded the quota/,
        /^QuotaExceededError$/,
        /^common\.fetch\.XHR_UNAUTHORIZED_ERROR/
    ];
    const $2eed509e2b22cd76$export$a42b2ab4291804cd = (errorMessage)=>{
        if ((0, $idmiV.isPageUnloading)()) return true;
        const matchesError = (regex)=>regex.test(errorMessage);
        return (0, parcelRequire("8BDMi")).default(matchesError, $2eed509e2b22cd76$var$ignoredErrorRegexes);
    };
});
parcelRegister("asXbx", function(module, exports) {
    $parcel$export(module.exports, "json", ()=>$045947af1d74102b$export$7b419323e6ed4f31);
    $parcel$export(module.exports, "jsonOrError", ()=>$045947af1d74102b$export$7ae2377f3464eaf5);
    $parcel$export(module.exports, "withErrorTolerated", ()=>$045947af1d74102b$export$d987e8f826d94836);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $a5g6t;
    var $8DSSe = parcelRequire("8DSSe");
    var $77QEM = parcelRequire("77QEM");
    var $24CMK = parcelRequire("24CMK");
    function* $045947af1d74102b$export$7b419323e6ed4f31(request) {
        const { url: url, method: method, body: body, ...options } = request;
        try {
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: method,
                body: body,
                ...options
            });
            if (response.ok) return {
                ok: true,
                data: yield (0, $aNOuE.call)(response.json.bind(response))
            };
            const message = yield (0, $aNOuE.call)(response.text.bind(response));
            return {
                ok: false,
                status: response.status,
                error: (0, (0, parcelRequire("a5g6t")).tryParseJson)(message) || message
            };
        } catch (e) {
            return {
                ok: false,
                status: -1,
                error: e.message
            };
        }
    }
    function* $045947af1d74102b$export$7ae2377f3464eaf5(request) {
        const { url: url, method: method, body: body, profile: profile } = request;
        try {
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: method,
                body: body,
                profile: profile
            });
            if (response.ok) return {
                ok: true,
                data: yield (0, $aNOuE.call)(response.json.bind(response))
            };
            const parsedError = (0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response))));
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...parsedError,
                requestInfo: {
                    url: url,
                    type: 'POST',
                    status: response.status,
                    body: body
                }
            }));
            return {
                ok: false,
                status: response.status,
                error: parsedError
            };
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
            return {
                ok: false,
                status: -1,
                error: e.message
            };
        }
    }
    function* $045947af1d74102b$export$d987e8f826d94836(block) {
        try {
            return yield (0, $aNOuE.call)(block);
        } catch (err) {
            if (err instanceof (0, $8DSSe.AgressiveFetchError)) {
                const { request: request, response: response } = err;
                const requestInfo = {
                    url: request.url,
                    type: request.method,
                    status: response.status,
                    body: request.body ?? undefined
                };
                const errPayload = (err)=>({
                        message: err.message,
                        stackTrace: err.stack
                    });
                const { message: message, stackTrace: stackTrace } = response.bodyUsed ? errPayload(err) : (0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response))));
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    message: message,
                    stackTrace: stackTrace,
                    requestInfo: requestInfo
                }));
            } else throw err;
        }
    }
});
parcelRegister("a5g6t", function(module, exports) {
    $parcel$export(module.exports, "tryParseJson", ()=>$af27b14cc3af2c20$export$798eca59d671408d);
    const $af27b14cc3af2c20$export$798eca59d671408d = (str)=>{
        if (str) try {
            return JSON.parse(str);
        } catch (e) {}
        return undefined;
    };
});
parcelRegister("8DSSe", function(module, exports) {
    $parcel$export(module.exports, "AgressiveFetchError", ()=>$4e5396fa7984e1d2$export$a09f0e985c649de4);
    $parcel$export(module.exports, "aggressiveFetch", ()=>$4e5396fa7984e1d2$export$624e87556f86a679);
    $parcel$export(module.exports, "default", ()=>$4e5396fa7984e1d2$export$2e2bcd8739ae039);
    var $bCilb;
    var $lTdwg;
    var $4ENQh;
    var $eJyeb = parcelRequire("eJyeb");
    var $idmiV = parcelRequire("idmiV");
    const $4e5396fa7984e1d2$export$8467c5933bf19410 = 'common.fetch.XHR_UNAUTHORIZED_ERROR';
    const $4e5396fa7984e1d2$export$b8ec1360093ba0e8 = 'response not ok';
    const $4e5396fa7984e1d2$var$headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    const $4e5396fa7984e1d2$var$defaultOptions = {
        credentials: 'same-origin',
        headers: $4e5396fa7984e1d2$var$headers
    };
    const $4e5396fa7984e1d2$var$castBody = (body)=>{
        const type = (0, parcelRequire("lTdwg")).default(body);
        switch(type){
            case 'String':
                return body;
            case 'Object':
                return JSON.stringify(body);
            case 'Number':
                return `${body}`;
            default:
                throw new Error(`Unsupported body type: ${type}`);
        }
    };
    const $4e5396fa7984e1d2$var$enhanceOptions = (0, parcelRequire("bCilb")).default({
        body: $4e5396fa7984e1d2$var$castBody
    });
    const $4e5396fa7984e1d2$var$checkAuthorized = (response)=>{
        if (!response?.ok && response.status === 401) {
            (0, $idmiV.reload)();
            throw new Error(`${$4e5396fa7984e1d2$export$8467c5933bf19410}:${response.url}`);
        }
        return response;
    };
    function $4e5396fa7984e1d2$var$fetch(url, { isUrlVerbatim: isUrlVerbatim, profile: profile, ...options }) {
        const request = window.fetch(isUrlVerbatim ? url : (0, $eJyeb.proxyContextSafeUrl)(url), $4e5396fa7984e1d2$var$enhanceOptions({
            ...$4e5396fa7984e1d2$var$defaultOptions,
            ...options
        })).then($4e5396fa7984e1d2$var$checkAuthorized);
        if (profile) {
            const finishProfile = (0, (0, parcelRequire("4ENQh")).monitor).startProfileConcurrent(profile);
            return request.then((response)=>{
                finishProfile();
                return response;
            });
        }
        return request;
    }
    class $4e5396fa7984e1d2$export$a09f0e985c649de4 extends Error {
        constructor(message, { request: request, response: response }){
            super(message);
            this.request = request;
            this.response = response;
        }
    }
    async function $4e5396fa7984e1d2$export$624e87556f86a679(url, { profile: profile, ...options }, errMessage = 'aggressiveFetch failed') {
        const request = new Request(url, $4e5396fa7984e1d2$var$enhanceOptions({
            ...$4e5396fa7984e1d2$var$defaultOptions,
            ...options
        }));
        let finishProfile = ()=>{};
        if (profile) finishProfile = (0, (0, parcelRequire("4ENQh")).monitor).startProfileConcurrent(profile);
        const response = await $4e5396fa7984e1d2$var$fetch(url, options);
        finishProfile();
        $4e5396fa7984e1d2$var$checkAuthorized(response);
        if (!response?.ok) throw new $4e5396fa7984e1d2$export$a09f0e985c649de4(`${errMessage}: ${response.status}: ${$4e5396fa7984e1d2$export$b8ec1360093ba0e8}`, {
            request: request,
            response: response
        });
        if (options.json && response.status !== 204) try {
            return await response.json();
        } catch (err) {
            throw new $4e5396fa7984e1d2$export$a09f0e985c649de4(`${errMessage}: ${response.status}: ${err.message}`, {
                request: request,
                response: response
            });
        }
    }
    var $4e5396fa7984e1d2$export$2e2bcd8739ae039 = $4e5396fa7984e1d2$var$fetch;
});
parcelRegister("77QEM", function(module, exports) {
    $parcel$export(module.exports, "GET", ()=>$20acbefd9bbed623$export$1bb358554aac31c1);
    $parcel$export(module.exports, "POST", ()=>$20acbefd9bbed623$export$484f3009c2ee32ad);
    $parcel$export(module.exports, "DELETE", ()=>$20acbefd9bbed623$export$4bd2facc4a3e6aa1);
    $parcel$export(module.exports, "parseError", ()=>$20acbefd9bbed623$export$e80a9284539c1797);
    const $20acbefd9bbed623$export$1bb358554aac31c1 = 'GET';
    const $20acbefd9bbed623$export$484f3009c2ee32ad = 'POST';
    const $20acbefd9bbed623$export$4bd2facc4a3e6aa1 = 'DELETE';
    const $20acbefd9bbed623$export$e80a9284539c1797 = (response, message)=>{
        const contentType = response.headers.get('Content-Type');
        if (typeof contentType === 'string' && contentType.indexOf('application/json') === 0) try {
            const errorObj = JSON.parse(message).exception;
            const stackTrace = errorObj.stackTrace.reduce((accumulator, trace)=>`${accumulator}${trace.className}.${trace.methodName}:${trace.line}\n`, '');
            return {
                message: `Type: ${errorObj.type}`,
                stackTrace: stackTrace
            };
        } catch (e) {
            return {
                message: message,
                stackTrace: ''
            };
        }
        return {
            message: message,
            stackTrace: ''
        };
    };
});
parcelRegister("bkasS", function(module, exports) {
    $parcel$export(module.exports, "expandAllAnalytics", ()=>$87cfd6503473f9b6$export$479ca0fe8309c04b);
    $parcel$export(module.exports, "collapseAllAnalytics", ()=>$87cfd6503473f9b6$export$5ec4bceeee978c7);
    $parcel$export(module.exports, "addIssue", ()=>$87cfd6503473f9b6$export$1102f55b777d8730);
    $parcel$export(module.exports, "updateIssueRaw", ()=>$87cfd6503473f9b6$export$ea59680060060435);
    $parcel$export(module.exports, "updateIssueDatesOptimistic", ()=>$87cfd6503473f9b6$export$b91832b31a227575);
    $parcel$export(module.exports, "updateMultipleIssues", ()=>$87cfd6503473f9b6$export$1b4a9385b5a56903);
    $parcel$export(module.exports, "rankIssue", ()=>$87cfd6503473f9b6$export$dbff149eb80fd116);
    $parcel$export(module.exports, "bulkRankIssue", ()=>$87cfd6503473f9b6$export$b4a658098853486e);
    $parcel$export(module.exports, "moveIssue", ()=>$87cfd6503473f9b6$export$ad9ee5173d066064);
    $parcel$export(module.exports, "fetchHistoricalDoneIssues", ()=>$87cfd6503473f9b6$export$3530e2931cb20bc6);
    $parcel$export(module.exports, "removeSingleIssue", ()=>$87cfd6503473f9b6$export$920ade2c9b3d0aa3);
    $parcel$export(module.exports, "removeSelectedIssues", ()=>$87cfd6503473f9b6$export$790e3b588d2f43de);
    $parcel$export(module.exports, "bulkIssuesUpdate", ()=>$87cfd6503473f9b6$export$e9c4b1a0f7662f95);
    $parcel$export(module.exports, "bulkIssuesCRPUpdate", ()=>$87cfd6503473f9b6$export$5c464cc99540bf04);
    $parcel$export(module.exports, "updateIssueOrInlineCreate", ()=>$87cfd6503473f9b6$export$f4f7259d29fa9aad);
    $parcel$export(module.exports, "doAddIssue", ()=>$87cfd6503473f9b6$export$3de94ba9de434e56);
    $parcel$export(module.exports, "doResetIssueRequest", ()=>$87cfd6503473f9b6$export$e856c719fba649e);
    $parcel$export(module.exports, "handleIssueCommitResponse", ()=>$87cfd6503473f9b6$export$b52851cef8ec2dd1);
    $parcel$export(module.exports, "revertChange", ()=>$87cfd6503473f9b6$export$be623675b8f208ee);
    $parcel$export(module.exports, "getHiddenIssues", ()=>$87cfd6503473f9b6$export$ea11170f6eef9668);
    $parcel$export(module.exports, "getHistoricalDoneIssues", ()=>$87cfd6503473f9b6$export$22cefaeb4a8d245f);
    $parcel$export(module.exports, "default", ()=>$87cfd6503473f9b6$export$2e2bcd8739ae039);
    var $ifg6x = parcelRequire("ifg6x");
    var $2XSIf;
    var $h2uoz;
    var $b1yMp;
    var $cDeeP;
    var $bWXax;
    var $2JlG5;
    var $83IGl;
    var $4S1OS;
    var $3A0dU;
    var $iavfW;
    var $8r8wv;
    var $bQZTk;
    var $icdh8;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $4R6GH;
    var $c12LJ;
    var $5fACX = parcelRequire("5fACX");
    var $y9aeT = parcelRequire("y9aeT");
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $kbGxr = parcelRequire("kbGxr");
    var $8zOmE;
    var $cJ4qU = parcelRequire("cJ4qU");
    var $1CGdp = parcelRequire("1CGdp");
    var $jw86H = parcelRequire("jw86H");
    var $19iju = parcelRequire("19iju");
    var $ekXoi = parcelRequire("ekXoi");
    var $7bnpM = parcelRequire("7bnpM");
    var $abnJk = parcelRequire("abnJk");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $jLI87 = parcelRequire("jLI87");
    var $jpgxP = parcelRequire("jpgxP");
    var $fP57B = parcelRequire("fP57B");
    var $1JzSf = parcelRequire("1JzSf");
    var $jNv9f = parcelRequire("jNv9f");
    var $fwwCN = parcelRequire("fwwCN");
    var $g1lIV = parcelRequire("g1lIV");
    var $96USE = parcelRequire("96USE");
    var $caw8G = parcelRequire("caw8G");
    var $7CxJ7 = parcelRequire("7CxJ7");
    var $bWg8d = parcelRequire("bWg8d");
    var $36p1o = parcelRequire("36p1o");
    var $gpDcx = parcelRequire("gpDcx");
    var $iNyXb = parcelRequire("iNyXb");
    var $42ZEf = parcelRequire("42ZEf");
    var $lTHzT = parcelRequire("lTHzT");
    var $ccCF0 = parcelRequire("ccCF0");
    var $21mdo = parcelRequire("21mdo");
    var $7K8Pq = parcelRequire("7K8Pq");
    var $cy8s7 = parcelRequire("cy8s7");
    var $7haN1 = parcelRequire("7haN1");
    var $3ODbh = parcelRequire("3ODbh");
    var $77QEM = parcelRequire("77QEM");
    var $bYhSc = parcelRequire("bYhSc");
    var $hNEap = parcelRequire("hNEap");
    var $hjabd = parcelRequire("hjabd");
    var $24CMK = parcelRequire("24CMK");
    var $asXbx = parcelRequire("asXbx");
    var $cukx3 = parcelRequire("cukx3");
    var $gaFm9 = parcelRequire("gaFm9");
    var $68rG5 = parcelRequire("68rG5");
    var $6lsuQ = parcelRequire("6lsuQ");
    var $21mdo = parcelRequire("21mdo");
    const $87cfd6503473f9b6$export$57c7dfb729a4eb26 = 'command.issue.UPDATE_INLINE_CREATE_ISSUE';
    function $87cfd6503473f9b6$var$isHandleCommitResponseMethod(res) {
        return typeof res === 'function';
    }
    const $87cfd6503473f9b6$var$handleCommitResponse = (payload)=>({
            type: $74616ed8f6aff060$export$563a5374cb06df7d,
            payload: payload
        });
    const $87cfd6503473f9b6$export$479ca0fe8309c04b = (payload)=>({
            type: $74616ed8f6aff060$export$20130dbd048fc414,
            payload: payload
        });
    const $87cfd6503473f9b6$export$5ec4bceeee978c7 = (payload)=>({
            type: $74616ed8f6aff060$export$39babeb2e7944629,
            payload: payload
        });
    const $87cfd6503473f9b6$export$1102f55b777d8730 = (payload)=>({
            type: $74616ed8f6aff060$export$242fccfb90c57247,
            payload: payload
        });
    const $87cfd6503473f9b6$export$ea59680060060435 = (payload)=>({
            type: $74616ed8f6aff060$export$d46fd8e9a2a59b28,
            payload: payload
        });
    const $87cfd6503473f9b6$export$b91832b31a227575 = (payload)=>({
            type: $74616ed8f6aff060$export$1d31ff157c726e8a,
            payload: payload
        });
    const $87cfd6503473f9b6$export$1b4a9385b5a56903 = (payload)=>({
            type: $74616ed8f6aff060$export$254f30e4f720be90,
            payload: payload
        });
    const $87cfd6503473f9b6$export$dbff149eb80fd116 = (payload)=>({
            type: $74616ed8f6aff060$export$9bbbeac0bf5bf14,
            payload: payload
        });
    const $87cfd6503473f9b6$export$b4a658098853486e = (payload)=>({
            type: $74616ed8f6aff060$export$85b6c4937eed754f,
            payload: payload
        });
    const $87cfd6503473f9b6$export$ad9ee5173d066064 = (payload)=>({
            type: $74616ed8f6aff060$export$269d7b2720ef5d5e,
            payload: payload
        });
    const $87cfd6503473f9b6$export$49eb640c284e8826 = (payload)=>({
            type: $74616ed8f6aff060$export$ce69e6c9d4cdf606,
            payload: payload
        });
    const $87cfd6503473f9b6$export$3530e2931cb20bc6 = ()=>({
            type: $74616ed8f6aff060$export$7dc711c48e3c938f
        });
    const $87cfd6503473f9b6$export$920ade2c9b3d0aa3 = (payload)=>({
            type: $74616ed8f6aff060$export$181f7083eacb425,
            payload: payload
        });
    const $87cfd6503473f9b6$export$790e3b588d2f43de = ()=>({
            type: $74616ed8f6aff060$export$35cae9f1acacb606
        });
    const $87cfd6503473f9b6$export$a974ce4fb1390e8f = (payload)=>({
            type: $74616ed8f6aff060$export$7993a293561fe4a9,
            payload: payload
        });
    const $87cfd6503473f9b6$export$e9c4b1a0f7662f95 = (payload)=>({
            type: $74616ed8f6aff060$export$b6c322dbc4f2f8ac,
            payload: payload
        });
    const $87cfd6503473f9b6$export$5c464cc99540bf04 = (cprId)=>({
            type: $74616ed8f6aff060$export$4c343341eb9052e8,
            cprId: cprId
        });
    const $87cfd6503473f9b6$export$f4f7259d29fa9aad = (payload)=>({
            type: $87cfd6503473f9b6$export$57c7dfb729a4eb26,
            payload: payload
        });
    const $87cfd6503473f9b6$export$2418b445b82e0c8f = (payload)=>({
            type: $74616ed8f6aff060$export$868e118e8d9234f,
            payload: payload
        });
    function* $87cfd6503473f9b6$export$4884fd84d9484e78(block, promise) {
        if (!promise || !promise?.resolve || !promise?.reject) return yield (0, $aNOuE.call)(block);
        try {
            const result = yield (0, $aNOuE.call)(block);
            promise.resolve(result);
        } catch (err) {
            promise.reject(err);
        }
    }
    function* $87cfd6503473f9b6$var$doUpdateIssueOrInlineCreate({ payload: payload }) {
        if (payload.id === (0, $cy8s7.INLINE_CREATE_ID)) {
            const { id: id, lexoRank: lexoRank, level: level, summary: summary, type: type, ...slimPayload } = payload;
            return yield (0, $aNOuE.put)((0, $7K8Pq.updateInlineCreate)({
                ...slimPayload
            }));
        }
        return yield (0, $aNOuE.put)($87cfd6503473f9b6$export$ea59680060060435(payload));
    }
    function* $87cfd6503473f9b6$export$a6f3b2da528d4c39({ payload: payload }) {
        const issueMap = yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById));
        const issue = issueMap[payload.issueId];
        if (!issue) return;
        if (issue.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)) {
            const parent = issue.parent;
            if ((0, $4nDwW.isDefined)(parent) && (0, $4nDwW.isDefined)(issueMap[parent])) {
                const parentIssue = issueMap[parent];
                const updatedValues = {
                    id: issue.id
                };
                let changed = false;
                if (issue.team !== parentIssue.team) {
                    updatedValues.team = parentIssue.team;
                    changed = true;
                }
                if (issue.sprint !== parentIssue.sprint) {
                    updatedValues.sprint = parentIssue.sprint;
                    changed = true;
                }
                if (changed) yield (0, $aNOuE.put)((0, $96USE.update)(updatedValues));
            }
        } else {
            const { team: team, sprint: sprint } = issue;
            const { fields: fields } = payload;
            for (const issueId of Object.keys(issueMap)){
                const curIssue = issueMap[issueId];
                if (curIssue.parent === issue.id && curIssue.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)) {
                    const updatedValues = {
                        id: curIssue.id
                    };
                    if ((0, $4nDwW.isDefined)(fields) && fields.team && curIssue.team !== team) updatedValues.team = team;
                    if ((0, $4nDwW.isDefined)(fields) && fields.sprint && curIssue.sprint !== sprint) updatedValues.sprint = sprint;
                    if ((0, $4nDwW.isDefined)(updatedValues.team) || (0, $4nDwW.isDefined)(updatedValues.sprint)) yield (0, $aNOuE.put)((0, $96USE.update)(updatedValues));
                }
            }
        }
    }
    const $87cfd6503473f9b6$export$60287b88963120b6 = (payload, dateConfiguration)=>[
            'baselineStart',
            'baselineEnd'
        ].reduce((payload, field)=>{
            if (!(0, parcelRequire("2JlG5")).default(field, payload)) return payload;
            const { key: key, type: type } = dateConfiguration[`${field}Field`];
            const path = type === (0, $5fACX.DATEFIELD_TYPES).CUSTOM ? [
                'customFields',
                key
            ] : [
                key
            ];
            const value = payload[field];
            return (0, parcelRequire("b1yMp")).default((0, parcelRequire("bWXax")).default(field), (0, parcelRequire("h2uoz")).default(path, value))(payload);
        }, payload);
    function* $87cfd6503473f9b6$export$d4ec0482ae4b1f56(payload) {
        const dateConfiguration = yield (0, $aNOuE.select)((0, $bHTqr.getDateConfiguration));
        return $87cfd6503473f9b6$export$60287b88963120b6(payload, dateConfiguration);
    }
    function* $87cfd6503473f9b6$export$3de94ba9de434e56({ payload: { issue: newIssue, sibling: sibling, skipRanking: skipRanking = false, batchRanking: batchRanking = false } }) {
        try {
            const issue = yield (0, $aNOuE.call)($87cfd6503473f9b6$export$d4ec0482ae4b1f56, newIssue);
            const url = (0, $68rG5.urls).add;
            const body = (0, $68rG5.addIssueBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), issue);
            yield (0, $aNOuE.put)((0, $7haN1.setIsSaving)(true));
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!response.ok) yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
            else {
                const result = yield (0, $aNOuE.call)(response.json.bind(response));
                const { itemKey: id } = result;
                const apiIssue = {
                    ...issue,
                    id: id
                };
                yield* (0, $bYhSc.default)(function*() {
                    yield (0, $aNOuE.put)((0, $7K8Pq.setSiblingId)(id));
                    yield (0, $aNOuE.put)((0, $96USE.add)(apiIssue));
                    yield (0, $aNOuE.put)($87cfd6503473f9b6$export$49eb640c284e8826({
                        id: id
                    }));
                    const issues = yield (0, $aNOuE.select)((0, $jLI87.getSortedIssues));
                    if (!skipRanking) {
                        if (batchRanking && (0, (0, parcelRequire("4R6GH")).fg)('enable-ai-work-breakdown-in-plans')) yield* (0, $bYhSc.default)(function*() {
                            yield (0, $aNOuE.put)($87cfd6503473f9b6$export$dbff149eb80fd116((0, $6lsuQ.getAddedIssueRankPayload)(apiIssue, issues, sibling)));
                        });
                        else yield (0, $aNOuE.put)($87cfd6503473f9b6$export$dbff149eb80fd116((0, $6lsuQ.getAddedIssueRankPayload)(apiIssue, issues, sibling)));
                    }
                    yield (0, $aNOuE.put)((0, $gaFm9.calculateWarnings)());
                    if (issue.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)) yield (0, $aNOuE.put)($87cfd6503473f9b6$export$2418b445b82e0c8f({
                        issueId: id
                    }));
                });
                if (result) return result;
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        } finally{
            yield (0, $aNOuE.put)((0, $7haN1.setIsSaving)(false));
        }
    }
    function* $87cfd6503473f9b6$export$4c5f4cf5d27c16aa(action) {
        const { payload: { promise: promise, ...payload }, type: type } = action;
        yield (0, $aNOuE.call)($87cfd6503473f9b6$export$4884fd84d9484e78, function*() {
            return yield (0, $aNOuE.call)($87cfd6503473f9b6$export$3de94ba9de434e56, {
                type: type,
                payload: payload
            });
        }, promise);
    }
    function* $87cfd6503473f9b6$export$44a4abb35fa185ab({ payload: payload, issue: issue, originalProperties: originalProperties }) {
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = yield (0, $aNOuE.select)((0, $bHTqr.getDateConfiguration));
        const labelCustomFieldIds = yield (0, $aNOuE.select)((0, $19iju.getCustomLabelFieldIds));
        let issueBaselineEnd = null;
        if (baselineEndField.type === (0, $5fACX.DATEFIELD_TYPES).BUILT_IN) issueBaselineEnd = issue[baselineEndField.key];
        else if ((0, $4nDwW.isDefined)(issue.customFields)) issueBaselineEnd = issue.customFields[baselineEndField.key];
        yield* (0, $bYhSc.default)(function*() {
            yield (0, $aNOuE.put)($87cfd6503473f9b6$export$49eb640c284e8826(issue.issueKey ? originalProperties : {
                id: issue.id
            }));
            const updatedProperties = Object.keys(payload);
            if ((0, $4nDwW.isDefined)(payload.customFields)) updatedProperties.push(...Object.keys(payload.customFields));
            if (updatedProperties.includes(baselineStartField.key) && !(0, $4nDwW.isDefined)(issueBaselineEnd) || updatedProperties.includes(baselineEndField.key) || updatedProperties.includes('fixVersions') || updatedProperties.includes('sprint')) {
                const issueVersions = issue.fixVersions || [];
                const payloadVersions = payload.fixVersions || [];
                for (const version of new Set([
                    ...issueVersions,
                    ...payloadVersions
                ]))yield (0, $aNOuE.put)((0, $cukx3.calculateReleaseStatus)(version));
            }
            const customLabelFieldIds = (0, parcelRequire("4S1OS")).default(updatedProperties, labelCustomFieldIds);
            if (customLabelFieldIds.length > 0) for (const customLabelFieldId of customLabelFieldIds){
                const originalCustomLabels = issue.customFields && issue.customFields[customLabelFieldId] || [];
                const newCustomLabels = payload.customFields && payload.customFields[customLabelFieldId] || [];
                const newAddedLabels = (0, parcelRequire("cDeeP")).default(newCustomLabels, originalCustomLabels);
                yield (0, $aNOuE.put)((0, $1JzSf.add)({
                    customFieldId: Number(customLabelFieldId),
                    labels: newAddedLabels
                }));
            }
            if (updatedProperties.includes('labels')) {
                const issueLabelsInStore = new Set((yield (0, $aNOuE.select)((0, $abnJk.getIssueLabels))));
                const originalIssueLabels = issue.labels || [];
                let newIssueLabels = payload.labels || [];
                if (payload.labels?.fieldAction) newIssueLabels = payload.labels?.value || [];
                const addedLabels = (0, parcelRequire("cDeeP")).default(newIssueLabels, originalIssueLabels);
                for (const addedLabel of addedLabels)if (!issueLabelsInStore.has(addedLabel)) yield (0, $aNOuE.put)($fwwCN.add(addedLabel));
            }
        });
    }
    function* $87cfd6503473f9b6$export$acda8c54b266b88a(body) {
        try {
            const url = (0, $68rG5.urls).update;
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!response.ok) yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
            yield (0, $aNOuE.put)((0, $gaFm9.calculateWarnings)());
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $87cfd6503473f9b6$export$e856c719fba649e(body) {
        try {
            const url = (0, $68rG5.urls).update;
            const resetStatusResponse = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!resetStatusResponse.ok) yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(resetStatusResponse, (yield (0, $aNOuE.call)(resetStatusResponse.text.bind(resetStatusResponse)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: resetStatusResponse.status,
                    body: body
                }
            }));
            else {
                const data = yield (0, $aNOuE.call)(resetStatusResponse.json.bind(resetStatusResponse));
                const { change: { sequence: sequence }, failed: failed } = data;
                if (failed > 0) yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    message: 'Failed to reset issue scenario changes'
                }));
                yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            }
            yield (0, $aNOuE.put)((0, $gaFm9.calculateWarnings)());
            return resetStatusResponse;
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $87cfd6503473f9b6$export$edf4c125212bfd66({ payload: { promise: promise, ...payload } }) {
        const issue = (yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById)))[payload.id];
        let updatedValues = payload;
        if ((0, parcelRequire("2JlG5")).default('baselineStart', payload) || (0, parcelRequire("2JlG5")).default('baselineEnd', payload)) updatedValues = yield (0, $aNOuE.call)($87cfd6503473f9b6$export$d4ec0482ae4b1f56, payload);
        const originalProperties = (0, $6lsuQ.getOriginalProperties)(issue, updatedValues);
        if (!originalProperties) return;
        if ((0, parcelRequire("2JlG5")).default('statusTransition', payload)) {
            const updatedValuesWithoutStatusTransition = (0, parcelRequire("iavfW")).default([
                'statusTransition'
            ], updatedValues);
            yield (0, $aNOuE.put)((0, $96USE.update)(updatedValuesWithoutStatusTransition));
            yield (0, $aNOuE.call)($87cfd6503473f9b6$export$44a4abb35fa185ab, {
                payload: updatedValuesWithoutStatusTransition,
                issue: issue,
                originalProperties: originalProperties
            });
        } else {
            if (updatedValues.goals) {
                const newGoals = updatedValues.goals.map((value)=>value.id);
                const newUpdatedValues = {
                    ...updatedValues
                };
                newUpdatedValues.goals = newGoals;
                yield (0, $aNOuE.put)((0, $96USE.update)(newUpdatedValues));
            } else yield (0, $aNOuE.put)((0, $96USE.update)(updatedValues));
            yield (0, $aNOuE.call)($87cfd6503473f9b6$export$44a4abb35fa185ab, {
                payload: updatedValues,
                issue: issue,
                originalProperties: originalProperties
            });
        }
        const parentUpdatedForSubtask = issue.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL) && ((0, parcelRequire("2JlG5")).default('parent', updatedValues) || (0, parcelRequire("2JlG5")).default('parent', originalProperties));
        const teamUpdatedForStandardIssue = issue.level === (0, (0, parcelRequire("c12LJ")).STORY_LEVEL) && ((0, parcelRequire("2JlG5")).default('team', updatedValues) || (0, parcelRequire("2JlG5")).default('team', originalProperties));
        const sprintUpdatedForStandardIssue = issue.level === (0, (0, parcelRequire("c12LJ")).STORY_LEVEL) && ((0, parcelRequire("2JlG5")).default('sprint', updatedValues) || (0, parcelRequire("2JlG5")).default('sprint', originalProperties));
        if (teamUpdatedForStandardIssue || sprintUpdatedForStandardIssue || parentUpdatedForSubtask) yield (0, $aNOuE.put)($87cfd6503473f9b6$export$2418b445b82e0c8f({
            issueId: issue.id,
            fields: {
                team: teamUpdatedForStandardIssue || parentUpdatedForSubtask,
                sprint: sprintUpdatedForStandardIssue || parentUpdatedForSubtask
            }
        }));
        const body = (0, $68rG5.updateIssueBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), updatedValues);
        yield (0, $aNOuE.call)($87cfd6503473f9b6$export$acda8c54b266b88a, body);
    }
    function* $87cfd6503473f9b6$export$5c6a7a448f6c7ede(action) {
        const { payload: { promise: promise, ...payload }, type: type } = action;
        yield (0, $aNOuE.call)($87cfd6503473f9b6$export$4884fd84d9484e78, function*() {
            yield (0, $aNOuE.call)($87cfd6503473f9b6$export$edf4c125212bfd66, {
                type: type,
                payload: payload
            });
        }, promise);
    }
    function* $87cfd6503473f9b6$export$ddbbabb290cbe428({ payload: { promise: promise, ...payload } }) {
        const issue = (yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById)))[payload.id];
        let updatedValues;
        if ((0, parcelRequire("2JlG5")).default('baselineStart', payload) || (0, parcelRequire("2JlG5")).default('baselineEnd', payload)) updatedValues = yield (0, $aNOuE.call)($87cfd6503473f9b6$export$d4ec0482ae4b1f56, payload);
        const originalProperties = (0, $6lsuQ.getOriginalProperties)(issue, updatedValues);
        if (!originalProperties) return;
        yield (0, $aNOuE.put)((0, $96USE.update)(updatedValues));
        yield (0, $aNOuE.call)($87cfd6503473f9b6$export$44a4abb35fa185ab, {
            payload: updatedValues,
            issue: issue,
            originalProperties: originalProperties
        });
    }
    function* $87cfd6503473f9b6$export$a659eeffaf0169f6({ payload: payload }) {
        for (const issueId of Object.keys(payload))yield (0, $aNOuE.call)($87cfd6503473f9b6$export$edf4c125212bfd66, {
            type: $74616ed8f6aff060$export$d46fd8e9a2a59b28,
            payload: {
                ...payload[issueId],
                id: issueId
            }
        });
    }
    function* $87cfd6503473f9b6$export$960787e2a2dfab5e({ payload: { issueIds: issueIds, ...payload } }) {
        const itemKeys = [];
        let updatedValues = payload;
        if ((0, parcelRequire("2JlG5")).default('baselineStart', payload) || (0, parcelRequire("2JlG5")).default('baselineEnd', payload)) updatedValues = yield (0, $aNOuE.call)($87cfd6503473f9b6$export$d4ec0482ae4b1f56, payload);
        if ((0, parcelRequire("2JlG5")).default('estimate', payload)) {
            const { planningUnit: planningUnit } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
            const workingHours = yield (0, $aNOuE.select)((0, $jpgxP.getJiraHoursPerDay));
            const propName = planningUnit === (0, $TTKUQ.PlanningUnits).storyPoints ? 'storyPoints' : 'timeEstimate';
            const estimate = payload.clearEstimates ? null : (0, $ekXoi.convertEstimate)(planningUnit, payload.estimate, workingHours);
            updatedValues = (0, parcelRequire("bQZTk")).default((0, parcelRequire("bWXax")).default('estimate'), (0, parcelRequire("2XSIf")).default(propName, estimate))(updatedValues);
        }
        yield* (0, $bYhSc.default)(function*() {
            const issueMapById = yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById));
            const selectedIssues = issueIds && issueIds.length ? issueIds.map((issueId)=>issueMapById[issueId]).filter(Boolean) : yield (0, $aNOuE.select)((0, $bI9dZ.getSelectedIssues));
            for (const issue of selectedIssues){
                const originalProperties = (0, $6lsuQ.getOriginalProperties)(issue, {
                    ...updatedValues,
                    id: issue.id
                });
                if (originalProperties) {
                    itemKeys.push(issue.id);
                    yield (0, $aNOuE.call)($87cfd6503473f9b6$export$44a4abb35fa185ab, {
                        payload: updatedValues,
                        issue: issue,
                        originalProperties: originalProperties
                    });
                }
            }
            if (itemKeys.length) {
                const bulkUpdatePayload = selectedIssues.reduce((acc, issue)=>Object.assign(acc, {
                        [issue.id]: {
                            ...updatedValues
                        }
                    }), {});
                if ((0, parcelRequire("2JlG5")).default('labels', updatedValues)) yield (0, $aNOuE.put)((0, $96USE.bulkLabelUpdate)(bulkUpdatePayload));
                else yield (0, $aNOuE.put)((0, $96USE.bulkUpdate)(bulkUpdatePayload));
                if ((0, parcelRequire("2JlG5")).default('parent', updatedValues)) yield (0, $aNOuE.put)((0, $3ODbh.toggleSelectedIssues)({
                    isSelected: false,
                    toggleAll: true,
                    ids: []
                }));
                const teamUpdated = (0, parcelRequire("2JlG5")).default('team', updatedValues);
                const sprintUpdated = (0, parcelRequire("2JlG5")).default('sprint', updatedValues);
                if (teamUpdated || sprintUpdated) yield (0, $aNOuE.all)(itemKeys.map((itemKey)=>(0, $aNOuE.put)($87cfd6503473f9b6$export$2418b445b82e0c8f({
                        issueId: itemKey,
                        fields: {
                            team: teamUpdated,
                            sprint: sprintUpdated
                        }
                    }))));
            }
        });
        if (itemKeys.length) {
            const body = (0, $68rG5.updateIssueBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), updatedValues, itemKeys);
            yield (0, $aNOuE.call)($87cfd6503473f9b6$export$acda8c54b266b88a, body);
        }
    }
    function* $87cfd6503473f9b6$export$cfff686a68dd7df4(action) {
        const { payload: { promise: promise, ...payload }, type: type } = action;
        yield (0, $aNOuE.call)($87cfd6503473f9b6$export$4884fd84d9484e78, function*() {
            yield (0, $aNOuE.call)($87cfd6503473f9b6$export$960787e2a2dfab5e, {
                type: type,
                payload: payload
            });
        }, promise);
    }
    function* $87cfd6503473f9b6$export$5bf0bb972a681b23({ cprId: cprId }) {
        const projectsById = yield (0, $aNOuE.select)((0, $jpXKt.getProjectsById));
        const selectedIssuesByProject = yield (0, $aNOuE.select)((0, $bI9dZ.getSelectedIssuesByProjectId));
        const crossProjectVersionsById = yield (0, $aNOuE.select)((0, $jw86H.getCrossProjectVersionsById));
        const versionsInCPR = crossProjectVersionsById[cprId].versions;
        const releaseToSelectedIssuesMap = Object.keys(selectedIssuesByProject).reduce((data, projectId)=>{
            const releaseInCPR = projectsById[projectId].versions.find((projectVersion)=>versionsInCPR.includes(projectVersion));
            return data.set(releaseInCPR, selectedIssuesByProject[projectId]);
        }, new Map());
        for (const [versionId, selectedIssues] of releaseToSelectedIssuesMap){
            const itemKeys = [];
            const updatedValue = {
                fixVersions: [
                    versionId
                ]
            };
            yield* (0, $bYhSc.default)(function*() {
                for (const issue of selectedIssues){
                    const originalProperties = (0, $6lsuQ.getOriginalProperties)(issue, {
                        ...updatedValue,
                        id: issue.id
                    });
                    if (originalProperties) {
                        itemKeys.push(issue.id);
                        yield (0, $aNOuE.call)($87cfd6503473f9b6$export$44a4abb35fa185ab, {
                            payload: updatedValue,
                            issue: issue,
                            originalProperties: originalProperties
                        });
                    }
                }
                if (itemKeys.length) {
                    const bulkUpdatePayload = selectedIssues.reduce((acc, issue)=>Object.assign(acc, {
                            [issue.id]: updatedValue
                        }), {});
                    yield (0, $aNOuE.put)((0, $96USE.bulkUpdate)(bulkUpdatePayload));
                }
            });
            if (itemKeys.length) {
                const body = (0, $68rG5.updateIssueBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), updatedValue, itemKeys);
                yield (0, $aNOuE.call)($87cfd6503473f9b6$export$acda8c54b266b88a, body);
            }
        }
    }
    function* $87cfd6503473f9b6$export$6ebbd47a62a9e98e(body) {
        const response = yield* $asXbx.jsonOrError({
            url: (0, $68rG5.urls).rank,
            body: body,
            method: 'POST'
        });
        if (!response.ok) return;
        const { change: { sequence: sequence }, failed: failed } = response.data;
        if (failed > 0) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: 'Failed to rank some issues'
            }));
            return;
        }
        yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
    }
    function* $87cfd6503473f9b6$export$c66886d54bda95a1({ payload: payload }) {
        yield* (0, $bYhSc.default)(function*() {
            const { id: id, lexoRank: lexoRank } = (yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById)))[payload.itemKeys[0]];
            yield (0, $aNOuE.put)($87cfd6503473f9b6$export$49eb640c284e8826({
                id: id,
                lexoRank: lexoRank
            }));
            yield (0, $aNOuE.put)((0, $96USE.rank)(payload));
            yield (0, $aNOuE.put)((0, $caw8G.adjustLexoRank)(payload));
        });
        const body = (0, $68rG5.rankIssueBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), payload);
        yield (0, $aNOuE.call)($87cfd6503473f9b6$export$6ebbd47a62a9e98e, body);
    }
    function* $87cfd6503473f9b6$export$bb03c5769232d24c(action) {
        const { payload: { promise: promise, ...payload }, type: type } = action;
        yield (0, $aNOuE.call)($87cfd6503473f9b6$export$4884fd84d9484e78, function*() {
            yield (0, $aNOuE.call)($87cfd6503473f9b6$export$c66886d54bda95a1, {
                type: type,
                payload: payload
            });
        }, promise);
    }
    function* $87cfd6503473f9b6$export$6c983680b0561560({ payload: payload }) {
        const issues = yield (0, $aNOuE.select)((0, $bI9dZ.getAllSortedIssues));
        const issueIndexById = issues.reduce((acc, { id: id }, index)=>{
            acc[id] = index;
            return acc;
        }, {});
        const selectedIssues = (0, parcelRequire("icdh8")).default([
            (a, b)=>issueIndexById[a.id] - issueIndexById[b.id]
        ], (yield (0, $aNOuE.select)((0, $bI9dZ.getSelectedIssues))));
        const bulkPayload = (0, $6lsuQ.getBulkRankPayload)(payload, selectedIssues.map(({ id: id })=>id), issues);
        if (!bulkPayload) return;
        yield* (0, $bYhSc.default)(function*() {
            for (const { id: id, lexoRank: lexoRank } of selectedIssues)yield (0, $aNOuE.put)($87cfd6503473f9b6$export$49eb640c284e8826({
                id: id,
                lexoRank: lexoRank
            }));
            yield (0, $aNOuE.put)((0, $96USE.bulkRank)(bulkPayload));
            yield (0, $aNOuE.put)((0, $caw8G.bulkAdjustLexoRank)(bulkPayload));
        });
        const body = (0, $68rG5.rankIssueBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), bulkPayload);
        yield (0, $aNOuE.call)($87cfd6503473f9b6$export$6ebbd47a62a9e98e, body);
    }
    const $87cfd6503473f9b6$export$9623ca1d58f4559a = (issues, descendantsMap, isExpanded, payload, hierarchy)=>{
        const { anchor: anchor, dragAndDrop: dragAndDrop, group: group, id: id, parentId: parentId, relation: relation } = payload;
        const movedIssue = issues.find((issue)=>issue.id === id);
        if (!movedIssue) throw new Error('Issue is not found. Have you dropped it into the Trash?');
        const actions = [];
        const parentIssue = issues.find((issue)=>issue.id === parentId);
        if (parentIssue) {
            const issueMap = (0, $gFhwb.createIssueMapByIdPure)(issues);
            const parentAncestors = (0, $bI9dZ.getAncestors)(parentIssue, issueMap, Infinity);
            for (const descendantIssueId of descendantsMap[id] || [])if (parentAncestors.find((ancestorIssue)=>descendantIssueId === ancestorIssue.id) || descendantIssueId === parentId) {
                actions.push($87cfd6503473f9b6$export$ea59680060060435({
                    id: descendantIssueId,
                    parent: undefined
                }));
                actions.push((0, $jNv9f.updateParent)({
                    id: descendantIssueId,
                    parent: undefined,
                    isDragAndDrop: dragAndDrop
                }));
                break;
            }
        }
        if (!anchor) {
            if (movedIssue.parent) {
                actions.push($87cfd6503473f9b6$export$ea59680060060435({
                    id: id,
                    parent: undefined
                }));
                actions.push((0, $jNv9f.updateParent)({
                    id: id,
                    parent: undefined,
                    isDragAndDrop: dragAndDrop
                }));
            }
            return actions;
        }
        if (parentId !== movedIssue.parent && hierarchy.value.start !== movedIssue.level) {
            actions.push($87cfd6503473f9b6$export$ea59680060060435({
                id: id,
                parent: parentId
            }));
            actions.push((0, $jNv9f.updateParent)({
                id: id,
                parent: parentId,
                isDragAndDrop: dragAndDrop
            }));
        }
        if (parentId) {
            const parentIdKey = group ? `${parentId}:${group}` : parentId;
            if (!isExpanded[parentIdKey]) {
                actions.push((0, $21mdo.setIsExpanded)({
                    [`${parentIdKey}`]: true
                }));
                const children = issues.filter(({ parent: parent })=>parent === parentId);
                const lastChild = (0, parcelRequire("3A0dU")).default(children);
                if (lastChild) {
                    actions.push($87cfd6503473f9b6$export$dbff149eb80fd116({
                        itemKeys: [
                            id
                        ],
                        anchor: lastChild.id,
                        relation: 'AFTER'
                    }));
                    return actions;
                }
            }
        }
        if (dragAndDrop) actions.push($87cfd6503473f9b6$export$dbff149eb80fd116({
            itemKeys: [
                id
            ],
            anchor: anchor,
            relation: relation,
            dragAndDrop: dragAndDrop
        }));
        else actions.push($87cfd6503473f9b6$export$dbff149eb80fd116({
            itemKeys: [
                id
            ],
            anchor: anchor,
            relation: relation
        }));
        return actions;
    };
    function* $87cfd6503473f9b6$export$26dc99c947cf00be({ payload: payload }) {
        const issues = yield (0, $aNOuE.select)((0, $jLI87.getSortedIssues));
        const descendantsMap = yield (0, $aNOuE.select)((0, $bI9dZ.getDescendantIdsByParent));
        const isExpanded = yield (0, $aNOuE.select)((0, $jLI87.getIsExpanded));
        const hierarhy = yield (0, $aNOuE.select)((0, $7bnpM.getHierarchyFilter));
        const actions = yield (0, $aNOuE.call)($87cfd6503473f9b6$export$9623ca1d58f4559a, issues, descendantsMap, isExpanded, payload, hierarhy);
        yield (0, $aNOuE.all)(actions.map((action)=>(0, $aNOuE.put)(action)));
    }
    function* $87cfd6503473f9b6$export$fc3e038178ab21fa({ payload: payload }) {
        let updatedValues = payload;
        if ((0, parcelRequire("2JlG5")).default('baselineStart', payload) || (0, parcelRequire("2JlG5")).default('baselineEnd', payload)) updatedValues = yield (0, $aNOuE.call)($87cfd6503473f9b6$export$d4ec0482ae4b1f56, payload);
        yield (0, $aNOuE.put)((0, $7CxJ7.update)(updatedValues));
        yield (0, $aNOuE.put)((0, $36p1o.increment)([
            'issues'
        ]));
    }
    function* $87cfd6503473f9b6$var$doCommitRequest(issueId, notifyWatchers, generatedItemId) {
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = (0, $hNEap.commitBody)({
            id: planId,
            currentScenarioId: currentScenarioId
        }, sequence, issueId, generatedItemId, notifyWatchers);
        const response = yield* $asXbx.json({
            url: (0, $68rG5.urls).commitChanges,
            profile: (0, $68rG5.urls).commitChanges,
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence }, error: error, entity: entity = {}, id: id } = response.data;
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            if ($87cfd6503473f9b6$var$isHandleCommitResponseMethod($87cfd6503473f9b6$var$handleCommitResponse)) {
                const finalAction = $87cfd6503473f9b6$var$handleCommitResponse({
                    change: {
                        sequence: sequence
                    },
                    error: error,
                    entity: entity,
                    id: id
                });
                yield (0, $aNOuE.put)(finalAction);
                return finalAction;
            }
        }
        return {
            type: $74616ed8f6aff060$export$15027aa3e935638c,
            payload: response
        };
    }
    function* $87cfd6503473f9b6$var$doShowChangeStatusScreen(issueId, issueKeyInJira, transitionId) {
        if ((0, $4nDwW.isDefined)(issueKeyInJira) && (0, $4nDwW.isDefined)(transitionId)) {
            yield (0, $aNOuE.put)((0, $gpDcx.load)({
                issueKeyInJira: issueKeyInJira,
                transitionId: transitionId,
                issueId: issueId
            }));
            const changeStatusResult = yield (0, $aNOuE.take)([
                (0, $gpDcx.SUCCESS),
                (0, $gpDcx.CANCEL),
                (0, $gpDcx.FAIL)
            ]);
            if (changeStatusResult.type === (0, $gpDcx.SUCCESS)) {
                const { id: planId, currentScenarioId: scenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
                const body = {
                    itemKeys: [
                        issueId
                    ],
                    planId: planId,
                    scenarioId: scenarioId,
                    description: {
                        status: {
                            reset: true
                        },
                        statusTransition: {
                            reset: true
                        }
                    }
                };
                yield (0, $aNOuE.call)($87cfd6503473f9b6$export$e856c719fba649e, body);
            } else if (changeStatusResult.type === (0, $gpDcx.CANCEL)) yield (0, $aNOuE.put)((0, $iNyXb.interrupt)());
            else if (changeStatusResult.type === (0, $gpDcx.FAIL)) {
                yield (0, $aNOuE.put)((0, $iNyXb.interrupt)());
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    message: 'Jira failed to transition the status'
                }));
            }
            return changeStatusResult;
        }
    }
    function* $87cfd6503473f9b6$var$doUpdateIssueKey(issueId, generatedItemId) {
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const id = generatedItemId ? parseInt(generatedItemId, 10) : null;
        if (id == null || Number.isNaN(id)) return {
            type: $74616ed8f6aff060$export$15027aa3e935638c,
            payload: {
                ok: false,
                status: 400,
                error: 'MANUAL_CREATE_ID_INVALID'
            }
        };
        const response = yield* $asXbx.json({
            url: (0, $68rG5.urls).updateIssueKey,
            method: (0, $77QEM.POST),
            body: {
                planId: planId,
                scenarioId: currentScenarioId,
                itemKey: issueId,
                generatedItemId: generatedItemId
            }
        });
        if (response.ok && response.data.success) {
            const { change: change } = response.data;
            yield (0, $aNOuE.put)((0, $36p1o.update)(change.sequence));
            if ($87cfd6503473f9b6$var$isHandleCommitResponseMethod($87cfd6503473f9b6$var$handleCommitResponse)) {
                const finalAction = $87cfd6503473f9b6$var$handleCommitResponse({
                    change: change,
                    entity: {},
                    id: id
                });
                yield (0, $aNOuE.put)(finalAction);
                return finalAction;
            }
        }
        return {
            type: $74616ed8f6aff060$export$15027aa3e935638c,
            payload: response
        };
    }
    function* $87cfd6503473f9b6$var$doManualCreate(issueId, loadError, notifyWatchers) {
        yield (0, $aNOuE.put)((0, $lTHzT.load)({
            issueId: issueId,
            error: loadError
        }));
        const manualCreateResult = yield (0, $aNOuE.take)([
            (0, $lTHzT.SUBMIT),
            (0, $lTHzT.CANCEL),
            (0, $lTHzT.FAIL)
        ]);
        const analyticsEvent = yield (0, $aNOuE.select)((0, $1CGdp.getAnalyticsEvent));
        if (manualCreateResult.type === (0, $lTHzT.SUBMIT)) {
            const { generatedItemId: generatedItemId } = manualCreateResult.payload;
            let commitRetryResponse;
            if (!!generatedItemId && generatedItemId !== issueId) yield (0, $aNOuE.put)($fP57B.updateIssueReferences({
                oldId: issueId,
                newId: generatedItemId
            }));
            if ((0, $cJ4qU.default)()) commitRetryResponse = yield (0, $aNOuE.call)($87cfd6503473f9b6$var$doUpdateIssueKey, issueId, generatedItemId);
            else commitRetryResponse = yield (0, $aNOuE.call)($87cfd6503473f9b6$var$doCommitRequest, issueId, notifyWatchers, generatedItemId);
            if (commitRetryResponse.type === $74616ed8f6aff060$export$563a5374cb06df7d) {
                const { error: error, entity: entity } = commitRetryResponse.payload;
                const internalEntity = entity && entity.entity;
                const warnings = yield (0, $aNOuE.call)((0, $hjabd.inspectForCommitWarnings), internalEntity, error);
                if (warnings.length) {
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'advancedRoadmaps issueCommitManualCreateFailedWithWarnings', {
                        error: loadError?.error
                    });
                    yield (0, $aNOuE.put)((0, $ccCF0.add)({
                        category: (0, $TTKUQ.ENTITY).ISSUE,
                        itemId: issueId,
                        warnings: warnings
                    }));
                } else (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'advancedRoadmaps issueCommitManualCreateSuccess', {
                    error: loadError?.error
                });
            } else if (commitRetryResponse.type === $74616ed8f6aff060$export$15027aa3e935638c) yield (0, $aNOuE.put)((0, $ccCF0.add)({
                category: (0, $TTKUQ.ENTITY).ISSUE,
                itemId: issueId,
                warnings: [
                    (0, $hjabd.defaultWarning)
                ]
            }));
        } else if (manualCreateResult.type === (0, $lTHzT.CANCEL)) {
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'advancedRoadmaps issueCommitManualCreateCancelled', {
                error: loadError?.error
            });
            yield (0, $aNOuE.put)((0, $iNyXb.interrupt)());
        } else if (manualCreateResult.type === (0, $lTHzT.FAIL)) {
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'advancedRoadmaps issueCommitManualCreateFailed', {
                error: loadError?.error
            });
            yield (0, $aNOuE.put)((0, $iNyXb.interrupt)());
            const message = yield (0, $aNOuE.call)(!$87cfd6503473f9b6$var$isHandleCommitResponseMethod($87cfd6503473f9b6$var$handleCommitResponse) && $87cfd6503473f9b6$var$handleCommitResponse.text.bind($87cfd6503473f9b6$var$handleCommitResponse));
            const finalAction = (0, $24CMK.genericError)({
                message: message
            });
            yield (0, $aNOuE.put)(finalAction);
            return finalAction;
        }
        return manualCreateResult;
    }
    function* $87cfd6503473f9b6$export$b52851cef8ec2dd1(entityResponse, notifyWatchers) {
        const issueId = entityResponse.itemKey;
        const internalEntity = entityResponse.entity?.entity;
        const error = entityResponse.error;
        const warnings = yield (0, $aNOuE.call)((0, $hjabd.inspectForCommitWarnings), internalEntity, error);
        const isTransitionStatusDialog = error?.error === (0, $y9aeT.RESPONSE_ERROR_CODE).REQUIRE_STATUS_TRANSITION_SCREEN;
        if (isTransitionStatusDialog) {
            const transitionScreenId = error?.errorMessages && error?.errorMessages[0];
            const projectsById = yield (0, $aNOuE.select)((0, $jpXKt.getProjectsById));
            const issueById = yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById));
            const issue = issueById[issueId];
            const projectKeyOfIssue = issue.project && projectsById[issue.project] && projectsById[issue.project].key;
            const issueKeyInJira = issue.issueKey && projectKeyOfIssue ? `${projectKeyOfIssue}-${issue.issueKey}` : undefined;
            const changeStatusResult = yield (0, $aNOuE.call)($87cfd6503473f9b6$var$doShowChangeStatusScreen, issueId, issueKeyInJira, transitionScreenId);
            if (changeStatusResult.type === (0, $gpDcx.SUCCESS)) return true;
            if (changeStatusResult.type === (0, $gpDcx.CANCEL)) yield (0, $aNOuE.put)((0, $ccCF0.add)({
                category: (0, $TTKUQ.ENTITY).ISSUE,
                itemId: issueId,
                warnings: warnings
            }));
            return false;
        }
        const analyticsEvent = yield (0, $aNOuE.select)((0, $1CGdp.getAnalyticsEvent));
        const isManualCreateRequired = (0, $kbGxr.isScenarioIssue)(issueId) && (()=>{
            switch(String(error?.error)){
                case 'REQUIRED_FIELDS_MISSING':
                case 'WORKFLOW_VALIDATION_FAILURE':
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'advancedRoadmaps issueCommitManualCreateRequired', {
                        error: error?.error
                    });
                    return true;
                default:
                    return false;
            }
        })();
        if (isManualCreateRequired) {
            const manualCreateResult = yield (0, $aNOuE.call)($87cfd6503473f9b6$var$doManualCreate, issueId, error, notifyWatchers);
            if (manualCreateResult.type === (0, $lTHzT.SUBMIT)) return true;
            if (manualCreateResult.type === (0, $lTHzT.CANCEL)) yield (0, $aNOuE.put)((0, $ccCF0.add)({
                category: (0, $TTKUQ.ENTITY).ISSUE,
                itemId: issueId,
                warnings: warnings
            }));
        } else if (warnings.length) yield (0, $aNOuE.put)((0, $ccCF0.add)({
            category: (0, $TTKUQ.ENTITY).ISSUE,
            itemId: issueId,
            warnings: warnings
        }));
        return false;
    }
    function* $87cfd6503473f9b6$export$be623675b8f208ee(id) {
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = (0, $hNEap.revertBody)({
            id: planId,
            currentScenarioId: currentScenarioId
        }, sequence, id);
        const response = yield* $asXbx.json({
            url: (0, $68rG5.urls).revertIssues,
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = response.data;
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
        }
        return response;
    }
    function* $87cfd6503473f9b6$export$ea11170f6eef9668(ids) {
        const jiraIds = ids.map((id)=>Number.parseInt(id, 10)).filter((id)=>!Number.isNaN(id));
        if (jiraIds.length === 0) return;
        const { domain: { plan: { id: id, currentScenarioId: currentScenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = (0, $68rG5.hiddenIssuesBody)({
            id: id,
            currentScenarioId: currentScenarioId
        }, jiraIds);
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $68rG5.urls).getHiddenIssues, {
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const { issues: issues } = yield (0, $aNOuE.call)(response.json.bind(response));
            if (issues.length > 0) {
                yield (0, $aNOuE.put)((0, $42ZEf.reset)(issues));
                yield (0, $aNOuE.put)({
                    type: (0, $0477a90a9bc5200c$export$9d631ffde1befd43)
                });
            }
        }
    }
    function* $87cfd6503473f9b6$export$22cefaeb4a8d245f() {
        const { domain: { plan: { id: id, currentScenarioId: currentScenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        if (id == null || !currentScenarioId) return;
        const url = `${(0, $68rG5.urls).getDoneHistory}?planId=${id}&scenarioId=${currentScenarioId}&includeCompletedSince=0`;
        yield (0, $aNOuE.put)((0, $7haN1.setIsLoadingHistory)(true));
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
            method: (0, $77QEM.GET),
            profile: (0, $68rG5.urls).getDoneHistory
        });
        yield (0, $aNOuE.put)((0, $7haN1.setIsLoadingHistory)(false));
        if (response.ok) {
            const historyIssues = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.put)((0, $jNv9f.reset)(historyIssues.issues));
        }
    }
    function* $87cfd6503473f9b6$export$7800cf83d5a8afbc({ payload: { issueId: issueId } }) {
        try {
            const { id: id, currentScenarioId: currentScenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
            if (!id) throw new Error('Plan id is not available');
            if (!currentScenarioId) throw new Error('Scenario id is not available');
            const issues = yield (0, $aNOuE.select)((0, $gFhwb.getIssues));
            const [selectedIssues, remainingIssues] = (0, ($parcel$interopDefault($ifg6x)))(issues, ({ id: id })=>issueId === id);
            yield (0, $aNOuE.put)((0, $96USE.reset)(remainingIssues));
            yield (0, $aNOuE.put)($bWg8d.add({
                ...selectedIssues?.[0],
                excluded: true
            }));
            const body = {
                itemKeys: [
                    issueId
                ],
                planId: id,
                scenarioId: currentScenarioId
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $68rG5.urls).removeIssues, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const { change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
                const scenarioIssues = [];
                if ((0, $kbGxr.isScenarioIssue)(issueId)) scenarioIssues.push(issueId);
                else yield (0, $aNOuE.put)((0, $7CxJ7.update)({
                    id: issueId,
                    excluded: false
                }));
                if (scenarioIssues.length) yield (0, $aNOuE.put)((0, $7CxJ7.remove)(scenarioIssues));
                yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
                yield (0, $aNOuE.put)((0, $gaFm9.calculateWarnings)());
            } else {
                yield (0, $aNOuE.put)((0, $96USE.reset)(issues));
                yield (0, $aNOuE.put)($bWg8d.remove(issueId));
                const message = yield (0, $aNOuE.call)(response.text.bind(response));
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    message: message
                }));
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $87cfd6503473f9b6$export$870e45ab8f3f6bbc() {
        try {
            const { id: id, currentScenarioId: currentScenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
            if (!id) throw new Error('Plan id is not available');
            if (!currentScenarioId) throw new Error('Scenario id is not available');
            const selectedIssuesIds = yield (0, $aNOuE.select)((0, $bI9dZ.getSelected));
            const issues = yield (0, $aNOuE.select)((0, $gFhwb.getIssues));
            const [selectedIssues, remainingIssues] = (0, parcelRequire("8r8wv")).default(({ id: id })=>selectedIssuesIds.has(id), issues);
            yield (0, $aNOuE.put)((0, $96USE.reset)(remainingIssues));
            yield (0, $aNOuE.put)($bWg8d.bulkAdd(selectedIssues.map((issue)=>({
                    ...issue,
                    excluded: true
                }))));
            const body = {
                itemKeys: Array.from(selectedIssuesIds),
                planId: id,
                scenarioId: currentScenarioId
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $68rG5.urls).removeIssues, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const { change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
                const scenarioIssues = [];
                for (const issueId of selectedIssuesIds)if ((0, $kbGxr.isScenarioIssue)(issueId)) scenarioIssues.push(issueId);
                else yield (0, $aNOuE.put)((0, $7CxJ7.update)({
                    id: issueId,
                    excluded: false
                }));
                if (scenarioIssues.length) yield (0, $aNOuE.put)((0, $7CxJ7.remove)(scenarioIssues));
                yield (0, $aNOuE.put)((0, $3ODbh.toggleSelectedIssues)({
                    isSelected: false,
                    toggleAll: true,
                    ids: []
                }));
                yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
                yield (0, $aNOuE.put)((0, $gaFm9.calculateWarnings)());
            } else {
                yield (0, $aNOuE.put)((0, $96USE.reset)(issues));
                yield (0, $aNOuE.put)($bWg8d.bulkRemove(selectedIssuesIds));
                const message = yield (0, $aNOuE.call)(response.text.bind(response));
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    message: message
                }));
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $87cfd6503473f9b6$export$8bf99c8405e6800a({ payload: { issueId: issueId } }) {
        try {
            const { id: id, currentScenarioId: currentScenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
            if (!id) throw new Error('Plan id is not available');
            if (!currentScenarioId) throw new Error('Scenario id is not available');
            const issues = yield (0, $aNOuE.select)((0, $gFhwb.getIssues));
            const [selectedIssues, remainingIssues] = (0, ($parcel$interopDefault($ifg6x)))(issues, ({ id: id })=>issueId === id);
            yield (0, $aNOuE.put)((0, $96USE.reset)(remainingIssues));
            yield (0, $aNOuE.put)($bWg8d.add(selectedIssues?.[0]));
            const body = {
                itemKeys: [
                    issueId
                ],
                planId: id,
                scenarioId: currentScenarioId
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $68rG5.urls).deleteIssues, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const { change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
                const scenarioIssues = [];
                if ((0, $kbGxr.isScenarioIssue)(issueId)) scenarioIssues.push(issueId);
                else yield (0, $aNOuE.put)((0, $7CxJ7.update)({
                    id: issueId
                }));
                if (scenarioIssues.length) yield (0, $aNOuE.put)((0, $7CxJ7.remove)(scenarioIssues));
                yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
                yield (0, $aNOuE.put)((0, $gaFm9.calculateWarnings)());
            } else {
                yield (0, $aNOuE.put)((0, $96USE.reset)(issues));
                yield (0, $aNOuE.put)($bWg8d.remove(issueId));
                const message = yield (0, $aNOuE.call)(response.text.bind(response));
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    message: message
                }));
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $87cfd6503473f9b6$export$2171d5eda5f9818d({ payload: payload }) {
        if (payload === null) return;
        yield (0, $aNOuE.put)((0, $g1lIV.setLoadingIssueDescription)(true));
        const { domain: { plan: { id: id, currentScenarioId: currentScenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = (0, $68rG5.getDescription)({
            id: id,
            currentScenarioId: currentScenarioId
        }, payload);
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $68rG5.urls).getDescription, {
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const description = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.put)((0, $96USE.update)({
                id: payload,
                description: description.value
            }));
        } else {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: (0, $68rG5.urls).getDescription,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
            yield (0, $aNOuE.put)((0, $96USE.update)({
                id: payload,
                description: (0, $74616ed8f6aff060$export$d8ee766aa26c1e82)
            }));
        }
        yield (0, $aNOuE.put)((0, $g1lIV.setLoadingIssueDescription)(false));
    }
    function* $87cfd6503473f9b6$export$f838fcb0d258d6e4() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$242fccfb90c57247, $87cfd6503473f9b6$export$4c5f4cf5d27c16aa);
    }
    function* $87cfd6503473f9b6$export$302c0d569531ddfe() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$1d31ff157c726e8a, $87cfd6503473f9b6$export$ddbbabb290cbe428);
    }
    function* $87cfd6503473f9b6$export$eeca124c095ce47c() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$d46fd8e9a2a59b28, $87cfd6503473f9b6$export$5c6a7a448f6c7ede);
    }
    function* $87cfd6503473f9b6$export$3a5a00ff802b1115() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$254f30e4f720be90, $87cfd6503473f9b6$export$a659eeffaf0169f6);
    }
    function* $87cfd6503473f9b6$export$b653f0d048b72ee5() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$b6c322dbc4f2f8ac, $87cfd6503473f9b6$export$cfff686a68dd7df4);
    }
    function* $87cfd6503473f9b6$export$f76f5031f6f8e0fc() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$4c343341eb9052e8, $87cfd6503473f9b6$export$5bf0bb972a681b23);
    }
    function* $87cfd6503473f9b6$export$b7a92e3dbab82894() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$85b6c4937eed754f, $87cfd6503473f9b6$export$6c983680b0561560);
    }
    function* $87cfd6503473f9b6$export$526b8f427354c53d() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$9bbbeac0bf5bf14, $87cfd6503473f9b6$export$bb03c5769232d24c);
    }
    function* $87cfd6503473f9b6$export$657a600589fa02a1() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$269d7b2720ef5d5e, $87cfd6503473f9b6$export$26dc99c947cf00be);
    }
    function* $87cfd6503473f9b6$export$f52b10cb9b101e2a() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$ce69e6c9d4cdf606, $87cfd6503473f9b6$export$fc3e038178ab21fa);
    }
    function* $87cfd6503473f9b6$export$7361a3ed146cf32c() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$7dc711c48e3c938f, $87cfd6503473f9b6$export$22cefaeb4a8d245f);
    }
    function* $87cfd6503473f9b6$export$b623118c7718399e() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$181f7083eacb425, $87cfd6503473f9b6$export$7800cf83d5a8afbc);
    }
    function* $87cfd6503473f9b6$export$d67d766377d9d9ce() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$35cae9f1acacb606, $87cfd6503473f9b6$export$870e45ab8f3f6bbc);
    }
    function* $87cfd6503473f9b6$export$b6490ec5754d4499() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$7993a293561fe4a9, $87cfd6503473f9b6$export$8bf99c8405e6800a);
    }
    function* $87cfd6503473f9b6$export$918f78945edad0e6() {
        yield (0, $6u3NN.takeEvery)($87cfd6503473f9b6$export$57c7dfb729a4eb26, $87cfd6503473f9b6$var$doUpdateIssueOrInlineCreate);
    }
    function* $87cfd6503473f9b6$export$f6cefbf53e22d109() {
        yield (0, $6u3NN.takeEvery)($74616ed8f6aff060$export$868e118e8d9234f, $87cfd6503473f9b6$export$a6f3b2da528d4c39);
    }
    function* $87cfd6503473f9b6$export$ee53207dcda05720() {
        yield (0, $6u3NN.takeEvery)((0, $g1lIV.SET_ISSUE_BEING_EDITED), $87cfd6503473f9b6$export$2171d5eda5f9818d);
    }
    function* $87cfd6503473f9b6$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$f838fcb0d258d6e4);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$eeca124c095ce47c);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$302c0d569531ddfe);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$3a5a00ff802b1115);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$b653f0d048b72ee5);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$f76f5031f6f8e0fc);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$b7a92e3dbab82894);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$526b8f427354c53d);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$657a600589fa02a1);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$f52b10cb9b101e2a);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$7361a3ed146cf32c);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$b623118c7718399e);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$d67d766377d9d9ce);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$b6490ec5754d4499);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$918f78945edad0e6);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$f6cefbf53e22d109);
        yield (0, $aNOuE.fork)($87cfd6503473f9b6$export$ee53207dcda05720);
    }
});
parcelRegister("cJ4qU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfe1fa97028e57a9$export$2e2bcd8739ae039);
    var $fdim1;
    const $cfe1fa97028e57a9$var$isArjGicPrefilledDataHandlingEnabled = ()=>(0, (0, parcelRequire("fdim1")).getBooleanFeatureFlag)('arj.gic-pre-filled-data-handling_pkvuc', false);
    var $cfe1fa97028e57a9$export$2e2bcd8739ae039 = $cfe1fa97028e57a9$var$isArjGicPrefilledDataHandlingEnabled;
});
parcelRegister("1JzSf", function(module, exports) {
    $parcel$export(module.exports, "ADD", ()=>$2656acd3dbc47a81$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "RESET", ()=>$2656acd3dbc47a81$export$4a991c87e640ef77);
    $parcel$export(module.exports, "RESET_ALL", ()=>$2656acd3dbc47a81$export$626f5c04a48a9c44);
    $parcel$export(module.exports, "add", ()=>$2656acd3dbc47a81$export$e16d8520af44a096);
    $parcel$export(module.exports, "reset", ()=>$2656acd3dbc47a81$export$aad8462122ac592b);
    $parcel$export(module.exports, "resetAll", ()=>$2656acd3dbc47a81$export$ffe8c06b7e356699);
    const $2656acd3dbc47a81$export$bb6389024b71c2ae = 'state.domain.custom-labels.ADD';
    const $2656acd3dbc47a81$export$4a991c87e640ef77 = 'state.domain.custom-labels.RESET';
    const $2656acd3dbc47a81$export$626f5c04a48a9c44 = 'state.domain.custom-labels.RESET_ALL';
    const $2656acd3dbc47a81$export$e16d8520af44a096 = (payload)=>({
            type: $2656acd3dbc47a81$export$bb6389024b71c2ae,
            payload: payload
        });
    const $2656acd3dbc47a81$export$aad8462122ac592b = (payload)=>({
            type: $2656acd3dbc47a81$export$4a991c87e640ef77,
            payload: payload
        });
    const $2656acd3dbc47a81$export$ffe8c06b7e356699 = (payload)=>({
            type: $2656acd3dbc47a81$export$626f5c04a48a9c44,
            payload: payload
        });
});
parcelRegister("jNv9f", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$b536057816f9bb62$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE_PARENT", ()=>$b536057816f9bb62$export$44bc1fe1c2a61c81);
    $parcel$export(module.exports, "reset", ()=>$b536057816f9bb62$export$aad8462122ac592b);
    $parcel$export(module.exports, "updateParent", ()=>$b536057816f9bb62$export$28a8f5cfab98131e);
    const $b536057816f9bb62$export$4a991c87e640ef77 = 'state.domain.history-issues.RESET';
    const $b536057816f9bb62$export$44bc1fe1c2a61c81 = 'state.domain.history-issues.UPDATE_PARENT';
    const $b536057816f9bb62$export$aad8462122ac592b = (payload)=>({
            type: $b536057816f9bb62$export$4a991c87e640ef77,
            payload: payload
        });
    const $b536057816f9bb62$export$28a8f5cfab98131e = (payload)=>({
            type: $b536057816f9bb62$export$44bc1fe1c2a61c81,
            payload: payload
        });
});
parcelRegister("fwwCN", function(module, exports) {
    $parcel$export(module.exports, "ADD", ()=>$d042dd6dca9f1c0b$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "RESET", ()=>$d042dd6dca9f1c0b$export$4a991c87e640ef77);
    $parcel$export(module.exports, "REMOVE", ()=>$d042dd6dca9f1c0b$export$29d55e1f664a246b);
    $parcel$export(module.exports, "add", ()=>$d042dd6dca9f1c0b$export$e16d8520af44a096);
    $parcel$export(module.exports, "reset", ()=>$d042dd6dca9f1c0b$export$aad8462122ac592b);
    const $d042dd6dca9f1c0b$export$bb6389024b71c2ae = 'state.domain.issue-labels.ADD';
    const $d042dd6dca9f1c0b$export$4a991c87e640ef77 = 'state.domain.issue-labels.RESET';
    const $d042dd6dca9f1c0b$export$29d55e1f664a246b = 'state.domain.issue-labels.REMOVE';
    const $d042dd6dca9f1c0b$export$e16d8520af44a096 = (payload)=>({
            type: $d042dd6dca9f1c0b$export$bb6389024b71c2ae,
            payload: payload
        });
    const $d042dd6dca9f1c0b$export$aad8462122ac592b = (payload)=>({
            type: $d042dd6dca9f1c0b$export$4a991c87e640ef77,
            payload: payload
        });
    const $d042dd6dca9f1c0b$export$cd7f480d6b8286c3 = (payload)=>({
            type: $d042dd6dca9f1c0b$export$29d55e1f664a246b,
            payload: payload
        });
});
parcelRegister("g1lIV", function(module, exports) {
    $parcel$export(module.exports, "SET_LOADING_ISSUE_DESCRIPTION", ()=>$c7e811c8663d4125$export$f8f331eabae6331a);
    $parcel$export(module.exports, "SET_ISSUE_BEING_EDITED", ()=>$c7e811c8663d4125$export$1477427ecc20a98f);
    $parcel$export(module.exports, "setLoadingIssueDescription", ()=>$c7e811c8663d4125$export$c7b33c71f329a906);
    $parcel$export(module.exports, "setIssueBeingEdited", ()=>$c7e811c8663d4125$export$8ab1575ab4b619b6);
    const $c7e811c8663d4125$export$f8f331eabae6331a = 'state.domain.issueModal.SET_LOADING_ISSUE_DESCRIPTION';
    const $c7e811c8663d4125$export$1477427ecc20a98f = 'state.domain.issueModal.SET_ISSUE_BEING_EDITED';
    const $c7e811c8663d4125$export$c7b33c71f329a906 = (payload)=>({
            type: $c7e811c8663d4125$export$f8f331eabae6331a,
            payload: payload
        });
    const $c7e811c8663d4125$export$8ab1575ab4b619b6 = (payload)=>({
            type: $c7e811c8663d4125$export$1477427ecc20a98f,
            payload: payload
        });
});
parcelRegister("96USE", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$3f947f1a55ec3cd2$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$3f947f1a55ec3cd2$export$e271b26eefe41db8);
    $parcel$export(module.exports, "ADD", ()=>$3f947f1a55ec3cd2$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "RANK", ()=>$3f947f1a55ec3cd2$export$c3d7e0f1e63de60e);
    $parcel$export(module.exports, "BULK_RANK", ()=>$3f947f1a55ec3cd2$export$2f0e7af5a9c14709);
    $parcel$export(module.exports, "BULK_UPDATE", ()=>$3f947f1a55ec3cd2$export$193f41a37c2df875);
    $parcel$export(module.exports, "BULK_LABEL_UPDATE", ()=>$3f947f1a55ec3cd2$export$9cfd4599eabb1543);
    $parcel$export(module.exports, "REMOVE_WITHOUT_ISSUE_KEY", ()=>$3f947f1a55ec3cd2$export$dce92373a83d92e6);
    $parcel$export(module.exports, "reset", ()=>$3f947f1a55ec3cd2$export$aad8462122ac592b);
    $parcel$export(module.exports, "update", ()=>$3f947f1a55ec3cd2$export$722fbec263ad908a);
    $parcel$export(module.exports, "bulkUpdate", ()=>$3f947f1a55ec3cd2$export$fc4d5d648b7f7ca2);
    $parcel$export(module.exports, "bulkLabelUpdate", ()=>$3f947f1a55ec3cd2$export$8fb259f4ed407e98);
    $parcel$export(module.exports, "add", ()=>$3f947f1a55ec3cd2$export$e16d8520af44a096);
    $parcel$export(module.exports, "rank", ()=>$3f947f1a55ec3cd2$export$fbc8bcd33b574fbc);
    $parcel$export(module.exports, "bulkRank", ()=>$3f947f1a55ec3cd2$export$18077ecf970eb146);
    $parcel$export(module.exports, "removeWithoutIssueKey", ()=>$3f947f1a55ec3cd2$export$84880db81a8577e8);
    const $3f947f1a55ec3cd2$export$4a991c87e640ef77 = 'state.domain.issues.RESET';
    const $3f947f1a55ec3cd2$export$e271b26eefe41db8 = 'state.domain.issues.UPDATE';
    const $3f947f1a55ec3cd2$export$bb6389024b71c2ae = 'state.domain.issues.ADD';
    const $3f947f1a55ec3cd2$export$c3d7e0f1e63de60e = 'state.domain.issues.RANK';
    const $3f947f1a55ec3cd2$export$2f0e7af5a9c14709 = 'state.domain.issues.BULK_RANK';
    const $3f947f1a55ec3cd2$export$193f41a37c2df875 = 'state.domain.issues.BULK_UPDATE';
    const $3f947f1a55ec3cd2$export$9cfd4599eabb1543 = 'state.domain.issues.BULK_LABEL_UPDATE';
    const $3f947f1a55ec3cd2$export$dce92373a83d92e6 = 'state.domain.issues.REMOVE_WITHOUT_ISSUE_KEY';
    const $3f947f1a55ec3cd2$export$aad8462122ac592b = (payload)=>({
            type: $3f947f1a55ec3cd2$export$4a991c87e640ef77,
            payload: payload
        });
    const $3f947f1a55ec3cd2$export$722fbec263ad908a = (payload)=>({
            type: $3f947f1a55ec3cd2$export$e271b26eefe41db8,
            payload: payload
        });
    const $3f947f1a55ec3cd2$export$fc4d5d648b7f7ca2 = (payload)=>({
            type: $3f947f1a55ec3cd2$export$193f41a37c2df875,
            payload: payload
        });
    const $3f947f1a55ec3cd2$export$8fb259f4ed407e98 = (payload)=>({
            type: $3f947f1a55ec3cd2$export$9cfd4599eabb1543,
            payload: payload
        });
    const $3f947f1a55ec3cd2$export$e16d8520af44a096 = (payload)=>({
            type: $3f947f1a55ec3cd2$export$bb6389024b71c2ae,
            payload: payload
        });
    const $3f947f1a55ec3cd2$export$fbc8bcd33b574fbc = (payload)=>({
            type: $3f947f1a55ec3cd2$export$c3d7e0f1e63de60e,
            payload: payload
        });
    const $3f947f1a55ec3cd2$export$18077ecf970eb146 = (payload)=>({
            type: $3f947f1a55ec3cd2$export$2f0e7af5a9c14709,
            payload: payload
        });
    const $3f947f1a55ec3cd2$export$84880db81a8577e8 = ()=>({
            type: $3f947f1a55ec3cd2$export$dce92373a83d92e6
        });
});
parcelRegister("caw8G", function(module, exports) {
    $parcel$export(module.exports, "RESET_ADJUSTMENTS", ()=>$a31d46c7b0115d7c$export$250cb1b4630283c8);
    $parcel$export(module.exports, "ADJUST_ISSUE_LEXORANK", ()=>$a31d46c7b0115d7c$export$a725da43c169be3f);
    $parcel$export(module.exports, "BULK_ADJUST_ISSUE_LEXORANK", ()=>$a31d46c7b0115d7c$export$e19ad2bc26becca6);
    $parcel$export(module.exports, "ADJUST_VERSION_LEXORANK", ()=>$a31d46c7b0115d7c$export$a37e1778d5918680);
    $parcel$export(module.exports, "UPDATE_VERSION_LEXORANK_ADJUSTMENTS", ()=>$a31d46c7b0115d7c$export$e5a62d196ff7bcf6);
    $parcel$export(module.exports, "resetAdjustments", ()=>$a31d46c7b0115d7c$export$18e2a815bee627c8);
    $parcel$export(module.exports, "adjustLexoRank", ()=>$a31d46c7b0115d7c$export$542c0016967556bc);
    $parcel$export(module.exports, "bulkAdjustLexoRank", ()=>$a31d46c7b0115d7c$export$2390e9f7e5ba0983);
    $parcel$export(module.exports, "adjustVersionLexoRank", ()=>$a31d46c7b0115d7c$export$d39cbec08adbce15);
    $parcel$export(module.exports, "updateVersionLexorankAdjustments", ()=>$a31d46c7b0115d7c$export$49fab6a55c666253);
    const $a31d46c7b0115d7c$export$250cb1b4630283c8 = 'state.domain.lexorank.RESET_ADJUSTMENTS';
    const $a31d46c7b0115d7c$export$a725da43c169be3f = 'state.domain.lexorank.ADJUST_ISSUE_LEXORANK';
    const $a31d46c7b0115d7c$export$e19ad2bc26becca6 = 'state.domain.lexorank.BULK_ADJUST_ISSUE_LEXORANK';
    const $a31d46c7b0115d7c$export$a37e1778d5918680 = 'state.domain.lexorank.ADJUST_VERSION_LEXORANK';
    const $a31d46c7b0115d7c$export$e5a62d196ff7bcf6 = 'state.domain.lexorank.UPDATE_VERSION_LEXORANK_ADJUSTMENTS';
    const $a31d46c7b0115d7c$export$18e2a815bee627c8 = (payload)=>({
            type: $a31d46c7b0115d7c$export$250cb1b4630283c8,
            payload: payload
        });
    const $a31d46c7b0115d7c$export$542c0016967556bc = (payload)=>({
            type: $a31d46c7b0115d7c$export$a725da43c169be3f,
            payload: payload
        });
    const $a31d46c7b0115d7c$export$2390e9f7e5ba0983 = (payload)=>({
            type: $a31d46c7b0115d7c$export$e19ad2bc26becca6,
            payload: payload
        });
    const $a31d46c7b0115d7c$export$d39cbec08adbce15 = (payload)=>({
            type: $a31d46c7b0115d7c$export$a37e1778d5918680,
            payload: payload
        });
    const $a31d46c7b0115d7c$export$49fab6a55c666253 = (payload)=>({
            type: $a31d46c7b0115d7c$export$e5a62d196ff7bcf6,
            payload: payload
        });
});
parcelRegister("7CxJ7", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$226d334dbcaf9d2f$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$226d334dbcaf9d2f$export$e271b26eefe41db8);
    $parcel$export(module.exports, "REVERT_FIELDS", ()=>$226d334dbcaf9d2f$export$f28bd85bcbd8a2dc);
    $parcel$export(module.exports, "REMOVE", ()=>$226d334dbcaf9d2f$export$29d55e1f664a246b);
    $parcel$export(module.exports, "reset", ()=>$226d334dbcaf9d2f$export$aad8462122ac592b);
    $parcel$export(module.exports, "update", ()=>$226d334dbcaf9d2f$export$722fbec263ad908a);
    $parcel$export(module.exports, "revertFields", ()=>$226d334dbcaf9d2f$export$466264e35a72d8ef);
    $parcel$export(module.exports, "remove", ()=>$226d334dbcaf9d2f$export$cd7f480d6b8286c3);
    const $226d334dbcaf9d2f$export$4a991c87e640ef77 = 'state.domain.original-issues.RESET';
    const $226d334dbcaf9d2f$export$e271b26eefe41db8 = 'state.domain.original-issues.UPDATE';
    const $226d334dbcaf9d2f$export$f28bd85bcbd8a2dc = 'state.domain.original-issues.REVERT_FIELDS';
    const $226d334dbcaf9d2f$export$29d55e1f664a246b = 'state.domain.original-issues.REMOVE';
    const $226d334dbcaf9d2f$export$aad8462122ac592b = (payload)=>({
            type: $226d334dbcaf9d2f$export$4a991c87e640ef77,
            payload: payload
        });
    const $226d334dbcaf9d2f$export$722fbec263ad908a = (payload)=>({
            type: $226d334dbcaf9d2f$export$e271b26eefe41db8,
            payload: payload
        });
    const $226d334dbcaf9d2f$export$466264e35a72d8ef = (payload)=>({
            type: $226d334dbcaf9d2f$export$f28bd85bcbd8a2dc,
            payload: payload
        });
    const $226d334dbcaf9d2f$export$cd7f480d6b8286c3 = (payload)=>({
            type: $226d334dbcaf9d2f$export$29d55e1f664a246b,
            payload: payload
        });
});
parcelRegister("bWg8d", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$396f644092983111$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD", ()=>$396f644092983111$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "BULK_ADD", ()=>$396f644092983111$export$6295ee0df406f89c);
    $parcel$export(module.exports, "REMOVE", ()=>$396f644092983111$export$29d55e1f664a246b);
    $parcel$export(module.exports, "BULK_REMOVE", ()=>$396f644092983111$export$2b953021360583c3);
    $parcel$export(module.exports, "reset", ()=>$396f644092983111$export$aad8462122ac592b);
    $parcel$export(module.exports, "add", ()=>$396f644092983111$export$e16d8520af44a096);
    $parcel$export(module.exports, "bulkAdd", ()=>$396f644092983111$export$95c4934f4651c863);
    $parcel$export(module.exports, "remove", ()=>$396f644092983111$export$cd7f480d6b8286c3);
    $parcel$export(module.exports, "bulkRemove", ()=>$396f644092983111$export$18acb55cd937cabd);
    const $396f644092983111$export$4a991c87e640ef77 = 'state.domain.scenario-removed-issues.RESET';
    const $396f644092983111$export$bb6389024b71c2ae = 'state.domain.scenario-removed-issues.ADD';
    const $396f644092983111$export$6295ee0df406f89c = 'state.domain.scenario-removed-issues.BULK_ADD';
    const $396f644092983111$export$29d55e1f664a246b = 'state.domain.scenario-removed-issues.REMOVE';
    const $396f644092983111$export$2b953021360583c3 = 'state.domain.scenario-removed-issues.BULK_REMOVE';
    const $396f644092983111$export$aad8462122ac592b = (payload)=>({
            type: $396f644092983111$export$4a991c87e640ef77,
            payload: payload
        });
    const $396f644092983111$export$e16d8520af44a096 = (payload)=>({
            type: $396f644092983111$export$bb6389024b71c2ae,
            payload: payload
        });
    const $396f644092983111$export$95c4934f4651c863 = (payload)=>({
            type: $396f644092983111$export$6295ee0df406f89c,
            payload: payload
        });
    const $396f644092983111$export$cd7f480d6b8286c3 = (payload)=>({
            type: $396f644092983111$export$29d55e1f664a246b,
            payload: payload
        });
    const $396f644092983111$export$18acb55cd937cabd = (payload)=>({
            type: $396f644092983111$export$2b953021360583c3,
            payload: payload
        });
});
parcelRegister("36p1o", function(module, exports) {
    $parcel$export(module.exports, "INCREMENT", ()=>$e31f5c01ad679429$export$5ef1d926c74c32f2);
    $parcel$export(module.exports, "RESET", ()=>$e31f5c01ad679429$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$e31f5c01ad679429$export$e271b26eefe41db8);
    $parcel$export(module.exports, "increment", ()=>$e31f5c01ad679429$export$a2647aa13413c947);
    $parcel$export(module.exports, "reset", ()=>$e31f5c01ad679429$export$aad8462122ac592b);
    $parcel$export(module.exports, "update", ()=>$e31f5c01ad679429$export$722fbec263ad908a);
    const $e31f5c01ad679429$export$5ef1d926c74c32f2 = 'state.domain.sequence.INCREMENT';
    const $e31f5c01ad679429$export$4a991c87e640ef77 = 'state.domain.sequence.RESET';
    const $e31f5c01ad679429$export$e271b26eefe41db8 = 'state.domain.sequence.UPDATE';
    const $e31f5c01ad679429$export$a2647aa13413c947 = (payload)=>({
            type: $e31f5c01ad679429$export$5ef1d926c74c32f2,
            payload: payload
        });
    const $e31f5c01ad679429$export$aad8462122ac592b = (payload)=>({
            type: $e31f5c01ad679429$export$4a991c87e640ef77,
            payload: payload
        });
    const $e31f5c01ad679429$export$722fbec263ad908a = (payload)=>({
            type: $e31f5c01ad679429$export$e271b26eefe41db8,
            payload: payload
        });
});
parcelRegister("gpDcx", function(module, exports) {
    $parcel$export(module.exports, "LOAD", ()=>$def1b4d016261951$export$50c885a21bfec48c);
    $parcel$export(module.exports, "CANCEL", ()=>$def1b4d016261951$export$2b10f4b30fb65583);
    $parcel$export(module.exports, "SUCCESS", ()=>$def1b4d016261951$export$638cc6e36b2a737a);
    $parcel$export(module.exports, "FAIL", ()=>$def1b4d016261951$export$1c2edf198d818245);
    $parcel$export(module.exports, "load", ()=>$def1b4d016261951$export$11e63f7b0f3d9900);
    $parcel$export(module.exports, "cancel", ()=>$def1b4d016261951$export$70b61ad426ddbe54);
    $parcel$export(module.exports, "success", ()=>$def1b4d016261951$export$fe7c49d056ea1d88);
    $parcel$export(module.exports, "fail", ()=>$def1b4d016261951$export$2b62a06a9fee979c);
    const $def1b4d016261951$export$50c885a21bfec48c = 'state.domain.update-jira.change-status.LOAD';
    const $def1b4d016261951$export$2b10f4b30fb65583 = 'state.domain.update-jira.change-status.CANCEL';
    const $def1b4d016261951$export$638cc6e36b2a737a = 'state.domain.update-jira.change-status.SUCCESS';
    const $def1b4d016261951$export$1c2edf198d818245 = 'state.domain.update-jira.change-status.FAIL';
    const $def1b4d016261951$export$11e63f7b0f3d9900 = (payload)=>({
            type: $def1b4d016261951$export$50c885a21bfec48c,
            payload: payload
        });
    const $def1b4d016261951$export$70b61ad426ddbe54 = ()=>({
            type: $def1b4d016261951$export$2b10f4b30fb65583
        });
    const $def1b4d016261951$export$fe7c49d056ea1d88 = ()=>({
            type: $def1b4d016261951$export$638cc6e36b2a737a
        });
    const $def1b4d016261951$export$2b62a06a9fee979c = ()=>({
            type: $def1b4d016261951$export$1c2edf198d818245
        });
});
parcelRegister("iNyXb", function(module, exports) {
    $parcel$export(module.exports, "START", ()=>$e67b2a75748be9de$export$21c466265830bc3a);
    $parcel$export(module.exports, "INCREMENT_NUMBER_OF_COMMITTED_CHANGES", ()=>$e67b2a75748be9de$export$9c44dbd8f77715ca);
    $parcel$export(module.exports, "INTERRUPT", ()=>$e67b2a75748be9de$export$a9f3c3bb2f676e06);
    $parcel$export(module.exports, "STOP", ()=>$e67b2a75748be9de$export$82b9a23e44460c20);
    $parcel$export(module.exports, "start", ()=>$e67b2a75748be9de$export$b3571188c770cc5a);
    $parcel$export(module.exports, "incrementNumberOfCommittedChanges", ()=>$e67b2a75748be9de$export$687ff1f375e4b25);
    $parcel$export(module.exports, "interrupt", ()=>$e67b2a75748be9de$export$7b7d62677a00f822);
    $parcel$export(module.exports, "stop", ()=>$e67b2a75748be9de$export$fa6813432f753b0d);
    const $e67b2a75748be9de$export$21c466265830bc3a = 'state.domain.update-jira.commit.START';
    const $e67b2a75748be9de$export$9c44dbd8f77715ca = 'state.domain.update-jira.commit.INCREMENT_NUMBER_OF_COMMITTED_CHANGES';
    const $e67b2a75748be9de$export$a9f3c3bb2f676e06 = 'state.domain.update-jira.commit.INTERRUPT';
    const $e67b2a75748be9de$export$82b9a23e44460c20 = 'state.domain.update-jira.commit.STOP';
    const $e67b2a75748be9de$export$b3571188c770cc5a = (totalChanges)=>({
            type: $e67b2a75748be9de$export$21c466265830bc3a,
            payload: totalChanges
        });
    const $e67b2a75748be9de$export$687ff1f375e4b25 = ()=>({
            type: $e67b2a75748be9de$export$9c44dbd8f77715ca
        });
    const $e67b2a75748be9de$export$7b7d62677a00f822 = ()=>({
            type: $e67b2a75748be9de$export$a9f3c3bb2f676e06
        });
    const $e67b2a75748be9de$export$fa6813432f753b0d = ()=>({
            type: $e67b2a75748be9de$export$82b9a23e44460c20
        });
});
parcelRegister("42ZEf", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$d1a70645883a42f2$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$d1a70645883a42f2$export$aad8462122ac592b);
    const $d1a70645883a42f2$export$4a991c87e640ef77 = 'state.domain.update-jira.hidden-issues.RESET';
    const $d1a70645883a42f2$export$aad8462122ac592b = (payload)=>({
            type: $d1a70645883a42f2$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("lTHzT", function(module, exports) {
    $parcel$export(module.exports, "LOAD", ()=>$4d0f99de6c07de9e$export$50c885a21bfec48c);
    $parcel$export(module.exports, "CANCEL", ()=>$4d0f99de6c07de9e$export$2b10f4b30fb65583);
    $parcel$export(module.exports, "SUBMIT", ()=>$4d0f99de6c07de9e$export$324ecb06850cfa68);
    $parcel$export(module.exports, "FAIL", ()=>$4d0f99de6c07de9e$export$1c2edf198d818245);
    $parcel$export(module.exports, "load", ()=>$4d0f99de6c07de9e$export$11e63f7b0f3d9900);
    $parcel$export(module.exports, "cancel", ()=>$4d0f99de6c07de9e$export$70b61ad426ddbe54);
    $parcel$export(module.exports, "submit", ()=>$4d0f99de6c07de9e$export$853c27de4ce0f746);
    $parcel$export(module.exports, "fail", ()=>$4d0f99de6c07de9e$export$2b62a06a9fee979c);
    const $4d0f99de6c07de9e$export$50c885a21bfec48c = 'state.domain.update-jira.required-fields.LOAD';
    const $4d0f99de6c07de9e$export$2b10f4b30fb65583 = 'state.domain.update-jira.required-fields.CANCEL';
    const $4d0f99de6c07de9e$export$324ecb06850cfa68 = 'state.domain.update-jira.required-fields.SUBMIT';
    const $4d0f99de6c07de9e$export$1c2edf198d818245 = 'state.domain.update-jira.required-fields.FAIL';
    const $4d0f99de6c07de9e$export$11e63f7b0f3d9900 = (payload)=>({
            type: $4d0f99de6c07de9e$export$50c885a21bfec48c,
            payload: payload
        });
    const $4d0f99de6c07de9e$export$70b61ad426ddbe54 = ()=>({
            type: $4d0f99de6c07de9e$export$2b10f4b30fb65583
        });
    const $4d0f99de6c07de9e$export$853c27de4ce0f746 = (payload)=>({
            type: $4d0f99de6c07de9e$export$324ecb06850cfa68,
            payload: payload
        });
    const $4d0f99de6c07de9e$export$2b62a06a9fee979c = ()=>({
            type: $4d0f99de6c07de9e$export$1c2edf198d818245
        });
});
parcelRegister("ccCF0", function(module, exports) {
    $parcel$export(module.exports, "ADD", ()=>$3c54fda56d4d5588$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "add", ()=>$3c54fda56d4d5588$export$e16d8520af44a096);
    const $3c54fda56d4d5588$export$bb6389024b71c2ae = 'state.domain.update-jira.warnings.ADD';
    const $3c54fda56d4d5588$export$e16d8520af44a096 = (payload)=>({
            type: $3c54fda56d4d5588$export$bb6389024b71c2ae,
            payload: payload
        });
});
parcelRegister("21mdo", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$2a4a47694f8ddc80$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE_EXPANDED_ISSUE_LINKS", ()=>$2a4a47694f8ddc80$export$d99167e1e5a860b7);
    $parcel$export(module.exports, "SET_IS_EXPANDED", ()=>$2a4a47694f8ddc80$export$9b92e965bf6ba41);
    $parcel$export(module.exports, "setIsExpanded", ()=>$2a4a47694f8ddc80$export$231b1c9d9115ec74);
    $parcel$export(module.exports, "updateExpandedIssueLinks", ()=>$2a4a47694f8ddc80$export$3fe1202ea331fec2);
    const $2a4a47694f8ddc80$export$4a991c87e640ef77 = 'state.domain.view-settings.issue-expansions.RESET';
    const $2a4a47694f8ddc80$export$d99167e1e5a860b7 = 'state.domain.view-settings.issue-expansions.UPDATE_EXPANDED_ISSUE_LINKS';
    const $2a4a47694f8ddc80$export$9b92e965bf6ba41 = 'state.domain.view-settings.issue-expansions.SET_IS_EXPANDED';
    const $2a4a47694f8ddc80$export$231b1c9d9115ec74 = (payload)=>({
            type: $2a4a47694f8ddc80$export$9b92e965bf6ba41,
            payload: payload
        });
    const $2a4a47694f8ddc80$export$3fe1202ea331fec2 = (payload)=>({
            type: $2a4a47694f8ddc80$export$d99167e1e5a860b7,
            payload: payload
        });
    const $2a4a47694f8ddc80$export$aad8462122ac592b = (payload)=>({
            type: $2a4a47694f8ddc80$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("7haN1", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$b0b13c1b5b0ab6ea$export$4a991c87e640ef77);
    $parcel$export(module.exports, "SET_IS_LOADING_HISTORY", ()=>$b0b13c1b5b0ab6ea$export$2386799b95de6beb);
    $parcel$export(module.exports, "SET_IS_LOADING", ()=>$b0b13c1b5b0ab6ea$export$a561b54b6c85b410);
    $parcel$export(module.exports, "SET_IS_SAVING", ()=>$b0b13c1b5b0ab6ea$export$dde78b9273c318ca);
    $parcel$export(module.exports, "setIsLoadingHistory", ()=>$b0b13c1b5b0ab6ea$export$a570139500d60df8);
    $parcel$export(module.exports, "setIsLoading", ()=>$b0b13c1b5b0ab6ea$export$9eaa806651dd33f0);
    $parcel$export(module.exports, "setIsSaving", ()=>$b0b13c1b5b0ab6ea$export$ad10cacbaf4608fe);
    var $3ODbh = parcelRequire("3ODbh");
    const $b0b13c1b5b0ab6ea$export$4a991c87e640ef77 = 'state.ui.main.tabs.roadmap.scope.issues.RESET';
    const $b0b13c1b5b0ab6ea$export$2386799b95de6beb = 'state.ui.main.tabs.roadmap.scope.issues.SET_IS_LOADING_HISTORY';
    const $b0b13c1b5b0ab6ea$export$a561b54b6c85b410 = 'state.ui.main.tabs.roadmap.scope.issues.SET_IS_LOADING';
    const $b0b13c1b5b0ab6ea$export$ef4196109a02d078 = 'state.ui.main.table.roadmap.scope.issues.SET_IS_FULL_ISSUE_SET_LOADING';
    const $b0b13c1b5b0ab6ea$export$dde78b9273c318ca = 'state.ui.main.tabs.roadmap.scope.issues.SET_IS_SAVING';
    const $b0b13c1b5b0ab6ea$export$aad8462122ac592b = (payload)=>({
            type: $b0b13c1b5b0ab6ea$export$4a991c87e640ef77,
            payload: payload
        });
    const $b0b13c1b5b0ab6ea$export$a570139500d60df8 = (payload)=>({
            type: $b0b13c1b5b0ab6ea$export$2386799b95de6beb,
            payload: payload
        });
    const $b0b13c1b5b0ab6ea$export$9eaa806651dd33f0 = (payload)=>({
            type: $b0b13c1b5b0ab6ea$export$a561b54b6c85b410,
            payload: payload
        });
    const $b0b13c1b5b0ab6ea$export$ad10cacbaf4608fe = (payload)=>({
            type: $b0b13c1b5b0ab6ea$export$dde78b9273c318ca,
            payload: payload
        });
});
const $0477a90a9bc5200c$export$9d631ffde1befd43 = 'state.ui.top.title-bar.hidden-issues.OPEN_HIDDEN_ISSUES_DIALOG';
const $0477a90a9bc5200c$export$b1f17581bba10917 = 'state.ui.top.title-bar.hidden-issues.CLOSE_HIDDEN_ISSUES_DIALOG';
parcelRegister("hNEap", function(module, exports) {
    $parcel$export(module.exports, "commitBody", ()=>$1e48718a3618dc05$export$7c9a53d60320f7fe);
    $parcel$export(module.exports, "revertBody", ()=>$1e48718a3618dc05$export$7d51b8ce955d016b);
    var $cBJwN;
    var $ar6WC = parcelRequire("ar6WC");
    const $1e48718a3618dc05$export$7c9a53d60320f7fe = ({ id: planId, currentScenarioId: scenarioId }, sequence, itemKey, generatedItemId, notifyWatchers)=>{
        if (!planId || !scenarioId) throw new Error('Need both plan and scenario to commit or get changes');
        const payload = {
            planId: planId,
            scenarioId: scenarioId,
            sequence: (0, parcelRequire("cBJwN")).default((0, $ar6WC.sequenceKeys).map((key)=>[
                    key,
                    {
                        current: sequence[key]?.current || 0
                    }
                ])),
            itemKey: itemKey,
            generatedItemId: generatedItemId,
            notifyWatchers: notifyWatchers
        };
        return payload;
    };
    const $1e48718a3618dc05$export$7d51b8ce955d016b = ({ id: planId, currentScenarioId: scenarioId }, sequence, itemKey)=>{
        if (!planId || !scenarioId) throw new Error('Need both plan and scenario to revert changes');
        const payload = {
            itemKeys: [
                itemKey
            ],
            planId: planId,
            scenarioId: scenarioId,
            sequence: (0, parcelRequire("cBJwN")).default((0, $ar6WC.sequenceKeys).map((key)=>[
                    key,
                    {
                        current: sequence[key]?.current || 0
                    }
                ]))
        };
        return payload;
    };
});
parcelRegister("cBJwN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92dc41a262600ed5$export$2e2bcd8739ae039);
    var $ccUYa;
    var $92dc41a262600ed5$var$fromPairs = (0, (0, parcelRequire("ccUYa")).default)(function fromPairs(pairs) {
        var result = {};
        var idx = 0;
        while(idx < pairs.length){
            result[pairs[idx][0]] = pairs[idx][1];
            idx += 1;
        }
        return result;
    });
    var $92dc41a262600ed5$export$2e2bcd8739ae039 = $92dc41a262600ed5$var$fromPairs;
});
parcelRegister("ar6WC", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$f082f7924cf73d17$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "sequenceKeys", ()=>$f082f7924cf73d17$export$7c53c6aeef0196af);
    $parcel$export(module.exports, "getChangesMetadataBody", ()=>$f082f7924cf73d17$export$1879f65d67ccff8d);
    var $cBJwN;
    const $f082f7924cf73d17$export$bcae9ba627f604b6 = {
        getScenarioChangesMetadata: '/rest/jpo/1.0/scenario/metadata',
        updateLastCommittedTimestamp: (planId)=>`/rest/jpo/1.0/plans/${planId}/lastcommit`
    };
    const $f082f7924cf73d17$export$7c53c6aeef0196af = [
        'issues',
        'versions',
        'teams',
        'persons',
        'resources',
        'xprojectversions',
        'themes',
        'skills',
        'stages',
        'abilities',
        'issuelinks',
        'plannedcapacity'
    ];
    const $f082f7924cf73d17$export$1879f65d67ccff8d = ({ id: planId, currentScenarioId: scenarioId }, sequence)=>{
        if (!planId || !scenarioId) throw new Error('Need both plan and scenario to commit or get changes');
        const payload = {
            planId: planId,
            scenarioId: scenarioId,
            sequence: (0, parcelRequire("cBJwN")).default($f082f7924cf73d17$export$7c53c6aeef0196af.map((key)=>[
                    key,
                    {
                        current: sequence[key]?.current || 0
                    }
                ]))
        };
        return payload;
    };
});
parcelRegister("hjabd", function(module, exports) {
    $parcel$export(module.exports, "defaultWarning", ()=>$3a903c1cebc1c502$export$deb6050352aafd0b);
    $parcel$export(module.exports, "inspectForCommitWarnings", ()=>$3a903c1cebc1c502$export$1eed481c758d15b7);
    var $5uXOq = parcelRequire("5uXOq");
    var $76p2G;
    var $4Rr1a;
    var $48UFW;
    var $gxOvy;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $cgL5K;
    var $ousew;
    var $8beDH = parcelRequire("8beDH");
    var $19iju = parcelRequire("19iju");
    var $kyH7P = parcelRequire("kyH7P");
    function $3a903c1cebc1c502$export$ac27981c37e52390(entity) {
        const uncommitedKeysWithoutCustomFieldContainer = (0, parcelRequire("gxOvy")).default([
            'customFields'
        ], (0, parcelRequire("76p2G")).default(entity.originals));
        const uncommittedCustomFieldKeys = (0, parcelRequire("4Rr1a")).default((customFieldId)=>`cf-${customFieldId}`, (0, parcelRequire("76p2G")).default(entity.originals.customFields));
        return (0, parcelRequire("48UFW")).default(uncommitedKeysWithoutCustomFieldContainer, uncommittedCustomFieldKeys);
    }
    function $3a903c1cebc1c502$export$74d0da8cf5388cfa(warningKeys, customFields) {
        return warningKeys.map((key)=>{
            if (key.startsWith('cf-')) {
                const customFieldId = key.slice(3);
                const fieldDef = customFields.find((field)=>field.id.toString() === customFieldId);
                if (fieldDef) return {
                    header: (0, $kyH7P.default).customFieldNotSupportedHeader,
                    message: (0, $kyH7P.default).customFieldNotSupportedContent,
                    messageValues: {
                        key: fieldDef.title
                    }
                };
            }
            switch(key){
                case 'storyPoints':
                    return {
                        header: (0, $kyH7P.default).storyPointsWarningHeader,
                        message: (0, $kyH7P.default).storyPointsWarningContent,
                        messageValues: {}
                    };
                case 'assignee':
                    return {
                        header: (0, $kyH7P.default).assigneeWarningHeader,
                        message: (0, $kyH7P.default).assigneeWarningContent,
                        messageValues: {}
                    };
                case 'lexoRank':
                    return {
                        header: (0, $kyH7P.default).lexoRankWarningHeader,
                        message: (0, $kyH7P.default).lexoRankWarningContent,
                        messageValues: {}
                    };
                case 'team':
                    return {
                        header: (0, $kyH7P.default).teamWarningHeader,
                        message: (0, $kyH7P.default).teamWarningContent,
                        messageValues: {}
                    };
                case 'fixVersions':
                    return {
                        header: (0, $kyH7P.default).releaseWarningHeader,
                        message: (0, $kyH7P.default).releaseWarningContent,
                        messageValues: {}
                    };
                case 'originalStoryPoints':
                    return {
                        header: (0, $kyH7P.default).originalStoryPointsHeader,
                        messageValues: {}
                    };
                case 'originalTimeEstimate':
                    return {
                        header: (0, $kyH7P.default).originalTimeEstimateHeader,
                        messageValues: {}
                    };
                case 'timeEstimate':
                    return {
                        header: (0, $kyH7P.default).timeEstimateHeader,
                        messageValues: {}
                    };
                default:
                    return {
                        header: (0, $kyH7P.default).defaultPartialCommitWarningHeader,
                        messageValues: {
                            key: key
                        }
                    };
            }
        });
    }
    const $3a903c1cebc1c502$export$deb6050352aafd0b = {
        header: (0, $kyH7P.default).defaultWarningHeader,
        message: (0, $kyH7P.default).defaultWarningContent,
        messageValues: {}
    };
    function $3a903c1cebc1c502$export$fa8c0c6fcfd0b677({ error: error, errorMessages: errorMessages }) {
        switch(error){
            case 'ENVIRONMENT_ENTITY_NOT_FOUND':
                return {
                    header: (0, $kyH7P.default).notFoundWarningHeader,
                    message: (0, $kyH7P.default).notFoundWarningContent,
                    messageValues: {}
                };
            case 'UNCOMMITTED_PARENT':
                return {
                    header: (0, $kyH7P.default).uncommittedParentHeader,
                    message: (0, $kyH7P.default).uncommittedParentContent,
                    messageValues: {}
                };
            case 'SUBTASK_PARENT_NOT_DEFINED':
                return {
                    header: (0, $kyH7P.default).subTaskParentNotDefinedHeader,
                    message: (0, $kyH7P.default).subTaskParentNotDefinedContent,
                    messageValues: {}
                };
            case 'SUBTASK_IN_WRONG_PROJECT':
                return {
                    header: (0, $kyH7P.default).subTaskInWrongProjectHeader,
                    message: (0, $kyH7P.default).subTaskInWrongProjectContent,
                    messageValues: {}
                };
            case 'REQUIRED_FIELDS_MISSING':
                return {
                    header: (0, $kyH7P.default).requiredFieldsMissingHeader,
                    message: (0, $kyH7P.default).requiredFieldsMissingContent,
                    messageValues: {}
                };
            case 'REQUIRE_STATUS_TRANSITION_SCREEN':
                return {
                    header: (0, $kyH7P.default).requiredTransitionScreenMissingHeader,
                    message: (0, $kyH7P.default).requiredTransitionScreenMissingContent,
                    messageValues: {}
                };
            case 'ISSUE_API_EXCEPTION':
                if (errorMessages.length > 0) return {
                    header: (0, $kyH7P.default).unknownErrorHeader,
                    message: (0, $kyH7P.default).apiExceptionContent,
                    messageValues: {
                        messages: errorMessages.join(' ')
                    }
                };
                return {
                    header: (0, $kyH7P.default).unknownErrorHeader,
                    message: (0, $kyH7P.default).unknownErrorHeader,
                    messageValues: {}
                };
            case 'RANK_FAILURE_SCHEDULE_ISSUES_PERMISSION_MISSING':
                return {
                    header: (0, $kyH7P.default).permissionMissingHeader,
                    message: (0, $kyH7P.default).permissionMissingContent,
                    messageValues: {
                        learnMoreAboutPermissions: (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                            href: (0, $8beDH.default).learnMoreAboutPermissions,
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kyH7P.default).learnMoreAboutPermissions)),
                        permissionName: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                            as: "strong"
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kyH7P.default).scheduleIssuesPermission))
                    }
                };
            default:
                return $3a903c1cebc1c502$export$deb6050352aafd0b;
        }
    }
    function* $3a903c1cebc1c502$export$1eed481c758d15b7(entity, error) {
        const customFields = yield (0, $aNOuE.select)((0, $19iju.getCustomFields));
        let unCommittedPropertyWarnings = [];
        if (entity) unCommittedPropertyWarnings = $3a903c1cebc1c502$export$74d0da8cf5388cfa($3a903c1cebc1c502$export$ac27981c37e52390(entity), customFields);
        let errorWarning = [];
        if (error) errorWarning = [
            $3a903c1cebc1c502$export$fa8c0c6fcfd0b677(error)
        ];
        return [
            ...unCommittedPropertyWarnings,
            ...errorWarning
        ];
    }
});
parcelRegister("gxOvy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0b6e83aafe6d13a$export$2e2bcd8739ae039);
    var $4MZp5;
    var $c9RLn;
    var $gfe9F;
    var $7p8Aa;
    var $c0b6e83aafe6d13a$var$without = (0, (0, parcelRequire("c9RLn")).default)(function(xs, list) {
        return (0, (0, parcelRequire("7p8Aa")).default)((0, (0, parcelRequire("gfe9F")).default)((0, (0, parcelRequire("4MZp5")).default))(xs), list);
    });
    var $c0b6e83aafe6d13a$export$2e2bcd8739ae039 = $c0b6e83aafe6d13a$var$without;
});
parcelRegister("8beDH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98baab65b2ddbb42$export$2e2bcd8739ae039);
    var $98baab65b2ddbb42$export$2e2bcd8739ae039 = {
        home: 'https://support.atlassian.com/jira-software-cloud/resources/',
        followOurProgress: 'https://jira.atlassian.com/browse/JSWCLOUD-20012',
        gettingStarted: 'https://support.atlassian.com/jira-software-cloud/docs/get-started-with-advanced-roadmaps/',
        customFields: 'https://support.atlassian.com/jira-software-cloud/docs/enable-custom-fields-used-in-advanced-roadmaps-in-jira/',
        schedulingIssues: 'https://support.atlassian.com/jira-software-cloud/docs/estimate-and-schedule-issues-in-advanced-roadmaps/',
        schedulingWork: 'https://support.atlassian.com/jira-software-cloud/docs/estimate-and-schedule-issues-in-advanced-roadmaps/',
        embedRoadmapInConfluenceMacro: 'https://support.atlassian.com/jira-software-cloud/docs/embed-your-advanced-roadmap-plan-in-a-confluence-page/',
        viewSwitching: 'https://support.atlassian.com/jira-software-cloud/docs/preconfigured-views-in-advanced-roadmaps/',
        supportLink: 'https://support.atlassian.com/contact/#/',
        exportPng: 'https://support.atlassian.com/jira-software-cloud/docs/create-a-static-image-of-your-plan/',
        committingChangesToJira: 'https://support.atlassian.com/jira-software-cloud/docs/save-changes-made-in-advanced-roadmaps/',
        manageTeamInJira: 'https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-team/',
        learnMoreAboutPermissions: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/#Permissionsoverview-board-usagesprint-related-actionsBoardusage',
        teamsInOpenSites: 'https://support.atlassian.com/jira-software-cloud/docs/limitations-of-teams-in-advanced-roadmaps-open-sites/',
        dependencyReport: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-dependencies-in-advanced-roadmaps/',
        warningsDialog: 'https://support.atlassian.com/jira-software-cloud/docs/view-the-warnings-center-in-advanced-roadmaps/'
    };
});
parcelRegister("kyH7P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$beef6fccc447a640$export$2e2bcd8739ae039);
    var $7VHMR;
    var $beef6fccc447a640$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        storyPointsWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.story-points-warning-header",
            "defaultMessage": "Unable to commit the item's story points."
        },
        storyPointsWarningContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.story-points-warning-content",
            "defaultMessage": "Please check that story points are enabled for this issue type."
        },
        assigneeWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.assignee-warning-header",
            "defaultMessage": "Unable to commit the item's assignee."
        },
        assigneeWarningContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.assignee-warning-content",
            "defaultMessage": "Please check that you have permission to assign issues in this project."
        },
        lexoRankWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.lexo-rank-warning-header",
            "defaultMessage": "Unable to commit the item's LexoRank."
        },
        lexoRankWarningContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.lexo-rank-warning-content",
            "defaultMessage": "Please check that you have permission to rank issues in this project."
        },
        uncommittedParentHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.uncommitted-parent-header",
            "defaultMessage": "Cannot save child issue"
        },
        uncommittedParentContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.uncommitted-parent-content",
            "defaultMessage": "Save the parent issue first, then try again."
        },
        subTaskParentNotDefinedHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.sub-task-parent-not-defined-header",
            "defaultMessage": "Uncommitted parent"
        },
        subTaskParentNotDefinedContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.sub-task-parent-not-defined-content",
            "defaultMessage": "Issue cannot be created as a sub-task of an uncommitted parent. Please commit the parent issue and retry."
        },
        subTaskInWrongProjectHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.sub-task-in-wrong-project-header",
            "defaultMessage": "Sub-task in wrong project"
        },
        subTaskInWrongProjectContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.sub-task-in-wrong-project-content",
            "defaultMessage": "An issue and its sub-task must both belong to the same project."
        },
        defaultWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.default-warning-header",
            "defaultMessage": "Could not be committed for unknown reasons."
        },
        defaultWarningContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.default-warning-content",
            "defaultMessage": "Item could not be committed for unknown reasons. Please contact your administrator."
        },
        defaultPartialCommitWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.default-partial-commit-warning-header",
            "defaultMessage": "Unable to commit the item's {key}"
        },
        scheduleIssuesPermission: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.schedule-issues-permission",
            "defaultMessage": "Schedule Issues"
        },
        permissionMissingHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.permission-missing-header",
            "defaultMessage": "Missing permissions"
        },
        permissionMissingContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.permission-missing-content",
            "defaultMessage": "Your changes could not be saved because you don\u2019t have the {permissionName} permission. An admin needs to grant you this permission. {learnMoreAboutPermissions}"
        },
        learnMoreAboutPermissions: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.learn-more-about-permissions",
            "defaultMessage": "Learn more about these permissions."
        },
        teamWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.team-warning-header",
            "defaultMessage": "Unable to commit the item's team"
        },
        teamWarningContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.team-warning-content",
            "defaultMessage": "Please ensure that the team has been committed."
        },
        originalStoryPointsHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.original-story-points-header",
            "defaultMessage": "Unable to commit the item's original story points"
        },
        originalTimeEstimateHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.original-time-estimate-header",
            "defaultMessage": "Unable to commit the item's original time estimate"
        },
        timeEstimateHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.time-estimate-header",
            "defaultMessage": "Unable to commit the item's time estimate"
        },
        releaseWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.release-warning-header",
            "defaultMessage": "Unable to commit the item's release"
        },
        releaseWarningContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.release-warning-content",
            "defaultMessage": "Please ensure that the release has been committed."
        },
        notFoundWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.not-found-warning-header",
            "defaultMessage": "Issue could not be found"
        },
        notFoundWarningContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.not-found-warning-content",
            "defaultMessage": "Please refresh to update your plan"
        },
        requiredFieldsMissingHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.required-fields-missing-header",
            "defaultMessage": "The issue cannot be updated as required fields are missing"
        },
        requiredFieldsMissingContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.required-fields-missing-content",
            "defaultMessage": "Please define a value or mark the field as optional to resolve the problem"
        },
        requiredTransitionScreenMissingHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.required-transition-screen-missing-header",
            "defaultMessage": "The issue cannot be updated as required transition screen are missing"
        },
        requiredTransitionScreenMissingContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.required-transition-screen-missing-content",
            "defaultMessage": "Please fill the transition screen fields or remove the transition screen when update the issue status to resolve the problem"
        },
        unknownErrorHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.unknown-error-header",
            "defaultMessage": "Issue could not be committed for unknown reasons"
        },
        unknownErrorContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.unknown-error-content",
            "defaultMessage": "Please contact your administrator"
        },
        apiExceptionContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.api-exception-content",
            "defaultMessage": "Please contact your administrator. {messages}"
        },
        customFieldNotSupportedHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.custom-field-not-supported-header",
            "defaultMessage": "Cannot commit {key} for this issue"
        },
        customFieldNotSupportedContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.commit.custom-field-not-supported-content",
            "defaultMessage": "The custom field {key} is not supported. Discard this change, or ask your Jira admin to make sure the issue type and project of the issue are supported."
        }
    });
});
parcelRegister("cukx3", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "ADD_RELEASE", ()=>$ca18c5576a08bbc9$export$2bdfac268df97e49);
    $parcel$export(module.exports, "UPDATE_RELEASE", ()=>$ca18c5576a08bbc9$export$3f90e3abee6e8d70);
    $parcel$export(module.exports, "RANK_RELEASE", ()=>$ca18c5576a08bbc9$export$c2ca61e48c051fa6);
    $parcel$export(module.exports, "DELETE_RELEASE", ()=>$ca18c5576a08bbc9$export$440c54a43c85f449);
    $parcel$export(module.exports, "CALCULATE_RELEASE_STATUS", ()=>$ca18c5576a08bbc9$export$bcf0ce7e9670a9d);
    $parcel$export(module.exports, "CALCULATE_STATUS_OF_ALL_RELEASES", ()=>$ca18c5576a08bbc9$export$114415b2450800d);
    $parcel$export(module.exports, "ADD_RELEASE_TO_CROSS_PROJECT_RELEASE", ()=>$ca18c5576a08bbc9$export$f6d34bff03547a78);
    $parcel$export(module.exports, "VIEW_RELEASE_IN_ROADMAP", ()=>$ca18c5576a08bbc9$export$a54e64fcc2f0026f);
    $parcel$export(module.exports, "GET_RELEASES_FOR_IDS", ()=>$ca18c5576a08bbc9$export$494c2f9413c26e0c);
    $parcel$export(module.exports, "addRelease", ()=>$ca18c5576a08bbc9$export$d7ff8290d1a14fa1);
    $parcel$export(module.exports, "updateRelease", ()=>$ca18c5576a08bbc9$export$a5f005f0031c650d);
    $parcel$export(module.exports, "rankRelease", ()=>$ca18c5576a08bbc9$export$e7abf7191f04bdf9);
    $parcel$export(module.exports, "deleteRelease", ()=>$ca18c5576a08bbc9$export$41b4061737a08cd);
    $parcel$export(module.exports, "calculateReleaseStatus", ()=>$ca18c5576a08bbc9$export$7e4d7a0e6f2ecd97);
    $parcel$export(module.exports, "calculateStatusOfAllReleases", ()=>$ca18c5576a08bbc9$export$814759937e7677ff);
    $parcel$export(module.exports, "addReleaseToCrossProjectRelease", ()=>$ca18c5576a08bbc9$export$bace67d72a0ad73a);
    $parcel$export(module.exports, "viewReleaseInRoadmap", ()=>$ca18c5576a08bbc9$export$4ddde390df08566c);
    $parcel$export(module.exports, "getReleasesForIds", ()=>$ca18c5576a08bbc9$export$63e6b3e46226b547);
    $parcel$export(module.exports, "addVersionInStore", ()=>$ca18c5576a08bbc9$export$5efaacd55cc1612e);
    $parcel$export(module.exports, "removeVersionFromStore", ()=>$ca18c5576a08bbc9$export$bf48c144c9502436);
    $parcel$export(module.exports, "addRemovedVersionToMainVersionsList", ()=>$ca18c5576a08bbc9$export$d375fd666a67b57e);
    $parcel$export(module.exports, "updateDetailsOfNewlyAddedVersion", ()=>$ca18c5576a08bbc9$export$50b15d1407aac14c);
    $parcel$export(module.exports, "handleVersionWarnings", ()=>$ca18c5576a08bbc9$export$ea5c9603aa3d16d4);
    $parcel$export(module.exports, "handleVersionCommitResponse", ()=>$ca18c5576a08bbc9$export$f552fa4bc1966f1e);
    $parcel$export(module.exports, "revertChange", ()=>$ca18c5576a08bbc9$export$be623675b8f208ee);
    $parcel$export(module.exports, "updateReferences", ()=>$ca18c5576a08bbc9$export$387fc7d982d5d3ef);
    $parcel$export(module.exports, "revertReferences", ()=>$ca18c5576a08bbc9$export$21aa7f798a65a8c0);
    $parcel$export(module.exports, "updateStateAfterAddingVersion", ()=>$ca18c5576a08bbc9$export$476de812fbbb6302);
    $parcel$export(module.exports, "doAddVersion", ()=>$ca18c5576a08bbc9$export$89ca6b91461e4dc);
    $parcel$export(module.exports, "updateVersion", ()=>$ca18c5576a08bbc9$export$5652a4ac6807e581);
    $parcel$export(module.exports, "updateStateAfterUpdatingVersion", ()=>$ca18c5576a08bbc9$export$307c978903f505ad);
    $parcel$export(module.exports, "doUpdateVersion", ()=>$ca18c5576a08bbc9$export$740de856a6989843);
    $parcel$export(module.exports, "doRankVersion", ()=>$ca18c5576a08bbc9$export$c3dc37c85d86f10c);
    $parcel$export(module.exports, "unassignVersionInIssues", ()=>$ca18c5576a08bbc9$export$25de5bd053709c0f);
    $parcel$export(module.exports, "updateStateAfterDeletingVersion", ()=>$ca18c5576a08bbc9$export$d88648d01aa45c1d);
    $parcel$export(module.exports, "updateStateAfterRemovingVersion", ()=>$ca18c5576a08bbc9$export$3d30cf8b88f7bb6f);
    $parcel$export(module.exports, "doDeleteVersion", ()=>$ca18c5576a08bbc9$export$c7f0d1a6ee665364);
    $parcel$export(module.exports, "setStatusOfVersion", ()=>$ca18c5576a08bbc9$export$19970962bad2152d);
    $parcel$export(module.exports, "doCalculateVersionStatus", ()=>$ca18c5576a08bbc9$export$4dbc8e12162b81db);
    $parcel$export(module.exports, "doCalculateStatusOfAllVersions", ()=>$ca18c5576a08bbc9$export$7e65e5343d7c672b);
    $parcel$export(module.exports, "doAddReleaseToCrossProjectRelease", ()=>$ca18c5576a08bbc9$export$31d54314ae5480f6);
    $parcel$export(module.exports, "doViewReleaseInRoadmap", ()=>$ca18c5576a08bbc9$export$6305f6649b21cb82);
    $parcel$export(module.exports, "doGetReleasesForIds", ()=>$ca18c5576a08bbc9$export$cb0413722f11fcf5);
    $parcel$export(module.exports, "watchAddVersion", ()=>$ca18c5576a08bbc9$export$7636f00a67e1b930);
    $parcel$export(module.exports, "watchUpdateVersion", ()=>$ca18c5576a08bbc9$export$919e3b6069d2417d);
    $parcel$export(module.exports, "watchRankVersion", ()=>$ca18c5576a08bbc9$export$2075f1cbc6860e11);
    $parcel$export(module.exports, "watchDeleteVersion", ()=>$ca18c5576a08bbc9$export$877c3b6cd35254fd);
    $parcel$export(module.exports, "watchCalculateVersionStatus", ()=>$ca18c5576a08bbc9$export$d72bc7e55e3e1f7a);
    $parcel$export(module.exports, "watchCalculateStatusOfAllVersions", ()=>$ca18c5576a08bbc9$export$db3062cd2a511ac7);
    $parcel$export(module.exports, "watchAddReleaseToCrossProjectRelease", ()=>$ca18c5576a08bbc9$export$3e74af38e36afe10);
    $parcel$export(module.exports, "watchViewReleaseInRoadmap", ()=>$ca18c5576a08bbc9$export$20993805280f607e);
    $parcel$export(module.exports, "watchGetReleasesForIds", ()=>$ca18c5576a08bbc9$export$d211e2e29b5233fc);
    $parcel$export(module.exports, "default", ()=>$ca18c5576a08bbc9$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "setMode", ()=>(parcelRequire("1yVQz")).setMode);
    $parcel$export(module.exports, "openDialog", ()=>(parcelRequire("1yVQz")).openDialog);
    $parcel$export(module.exports, "closeDialog", ()=>(parcelRequire("1yVQz")).closeDialog);
    $parcel$export(module.exports, "CREATE_RELEASE", ()=>$d912598f161dc1cb$export$afecb711a599950a);
    $parcel$export(module.exports, "EDIT_RELEASE", ()=>$d912598f161dc1cb$export$b9385259cf8397cd);
    $parcel$export(module.exports, "setDeleteDialogMode", ()=>(parcelRequire("kcnfF")).setMode);
    $parcel$export(module.exports, "openDeleteDialog", ()=>(parcelRequire("kcnfF")).openDialog);
    $parcel$export(module.exports, "closeDeleteDialog", ()=>(parcelRequire("kcnfF")).closeDialog);
    $parcel$export(module.exports, "DELETE_DIALOG_ACTIONS", ()=>(parcelRequire("kyJxl")).DELETE_DIALOG_ACTIONS);
    $parcel$export(module.exports, "openAddToCprDialog", ()=>(parcelRequire("2Cx2m")).openDialog);
    $parcel$export(module.exports, "closeAddToCprDialog", ()=>(parcelRequire("2Cx2m")).closeDialog);
    var $bWXax;
    var $83IGl;
    var $ik0Qc;
    var $fes2p;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $lz7VR = parcelRequire("lz7VR");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $kqF3Q = parcelRequire("kqF3Q");
    var $bHTqr = parcelRequire("bHTqr");
    var $d3quy = parcelRequire("d3quy");
    var $9FFuD = parcelRequire("9FFuD");
    var $gFvn5 = parcelRequire("gFvn5");
    var $96USE = parcelRequire("96USE");
    var $caw8G = parcelRequire("caw8G");
    var $bt366 = parcelRequire("bt366");
    var $7CxJ7 = parcelRequire("7CxJ7");
    var $75oAU = parcelRequire("75oAU");
    var $lKGSc = parcelRequire("lKGSc");
    var $jgiLJ = parcelRequire("jgiLJ");
    var $bWg8d = parcelRequire("bWg8d");
    var $36p1o = parcelRequire("36p1o");
    var $ccCF0 = parcelRequire("ccCF0");
    var $3VttY = parcelRequire("3VttY");
    var $cGbfF = parcelRequire("cGbfF");
    var $2Cx2m = parcelRequire("2Cx2m");
    var $kcnfF = parcelRequire("kcnfF");
    var $1yVQz = parcelRequire("1yVQz");
    var $gGkgE = parcelRequire("gGkgE");
    var $77QEM = parcelRequire("77QEM");
    var $bYhSc = parcelRequire("bYhSc");
    var $hNEap = parcelRequire("hNEap");
    var $24CMK = parcelRequire("24CMK");
    var $834it = parcelRequire("834it");
    var $asXbx = parcelRequire("asXbx");
    var $iTuEX = parcelRequire("iTuEX");
    var $5oyaD = parcelRequire("5oyaD");
    var $1yVQz = parcelRequire("1yVQz");
    var $kcnfF = parcelRequire("kcnfF");
    var $kyJxl = parcelRequire("kyJxl");
    var $2Cx2m = parcelRequire("2Cx2m");
    let $ca18c5576a08bbc9$var$crossProjectVersionsCommands = {};
    const $ca18c5576a08bbc9$export$2bdfac268df97e49 = 'command.versions.ADD_RELEASE';
    const $ca18c5576a08bbc9$export$3f90e3abee6e8d70 = 'command.versions.UPDATE_RELEASE';
    const $ca18c5576a08bbc9$export$c2ca61e48c051fa6 = 'command.versions.RANK_RELEASE';
    const $ca18c5576a08bbc9$export$440c54a43c85f449 = 'command.versions.DELETE_RELEASE';
    const $ca18c5576a08bbc9$export$bcf0ce7e9670a9d = 'command.versions.CALCULATE_RELEASE_STATUS';
    const $ca18c5576a08bbc9$export$114415b2450800d = 'command.versions.CALCULATE_STATUS_OF_ALL_RELEASES';
    const $ca18c5576a08bbc9$export$f6d34bff03547a78 = 'command.versions.ADD_RELEASE_TO_CROSS_PROJECT_RELEASE';
    const $ca18c5576a08bbc9$export$a54e64fcc2f0026f = 'command.versions.VIEW_RELEASE_IN_ROADMAP';
    const $ca18c5576a08bbc9$export$494c2f9413c26e0c = 'command.versions.GET_RELEASES_FOR_IDS';
    const $ca18c5576a08bbc9$export$d7ff8290d1a14fa1 = (version)=>({
            type: $ca18c5576a08bbc9$export$2bdfac268df97e49,
            payload: version
        });
    const $ca18c5576a08bbc9$export$a5f005f0031c650d = (payload)=>({
            type: $ca18c5576a08bbc9$export$3f90e3abee6e8d70,
            payload: payload
        });
    const $ca18c5576a08bbc9$export$e7abf7191f04bdf9 = (id, anchor, relation)=>({
            type: $ca18c5576a08bbc9$export$c2ca61e48c051fa6,
            payload: {
                id: id,
                anchor: anchor,
                relation: relation
            }
        });
    const $ca18c5576a08bbc9$export$41b4061737a08cd = (versionId)=>({
            type: $ca18c5576a08bbc9$export$440c54a43c85f449,
            versionId: versionId
        });
    const $ca18c5576a08bbc9$export$7e4d7a0e6f2ecd97 = (versionId)=>({
            type: $ca18c5576a08bbc9$export$bcf0ce7e9670a9d,
            versionId: versionId
        });
    const $ca18c5576a08bbc9$export$814759937e7677ff = ()=>({
            type: $ca18c5576a08bbc9$export$114415b2450800d
        });
    const $ca18c5576a08bbc9$export$bace67d72a0ad73a = (versionId, crossProjectVersionId)=>({
            type: $ca18c5576a08bbc9$export$f6d34bff03547a78,
            payload: {
                versionId: versionId,
                crossProjectVersionId: crossProjectVersionId
            }
        });
    const $ca18c5576a08bbc9$export$4ddde390df08566c = (filterValue)=>({
            type: $ca18c5576a08bbc9$export$a54e64fcc2f0026f,
            payload: filterValue
        });
    const $ca18c5576a08bbc9$export$63e6b3e46226b547 = (payload)=>({
            type: $ca18c5576a08bbc9$export$494c2f9413c26e0c,
            payload: payload
        });
    function* $ca18c5576a08bbc9$export$5efaacd55cc1612e(version) {
        const { id: id, projects: projects, crossProjectVersion: crossProjectVersion } = version;
        yield (0, $aNOuE.put)($3VttY.add(version));
        for (const projectId of projects)yield (0, $aNOuE.put)((0, $lKGSc.addVersionInProject)({
            projectId: projectId,
            versionId: id
        }));
        if ((0, $4nDwW.isDefined)(crossProjectVersion)) yield (0, $aNOuE.call)($ca18c5576a08bbc9$var$crossProjectVersionsCommands.addVersionInCrossProjectVersion, id, crossProjectVersion);
    }
    function* $ca18c5576a08bbc9$export$bf48c144c9502436(versionId) {
        const versionbyIdMap = yield (0, $aNOuE.select)((0, $9FFuD.getVersionsById));
        const version = versionbyIdMap[versionId];
        const { id: id, projects: projects, crossProjectVersion: crossProjectVersion } = version;
        for (const projectId of projects)yield (0, $aNOuE.put)((0, $lKGSc.removeVersionFromProject)({
            projectId: projectId,
            versionId: id
        }));
        if ((0, $4nDwW.isDefined)(crossProjectVersion)) yield (0, $aNOuE.call)($ca18c5576a08bbc9$var$crossProjectVersionsCommands.removeVersionFromCrossProjectVersion, id, crossProjectVersion);
        yield (0, $aNOuE.put)($3VttY.remove(id));
    }
    function* $ca18c5576a08bbc9$export$d375fd666a67b57e(removedVersion) {
        const { id: id } = removedVersion;
        yield* (0, $bYhSc.default)(function*() {
            yield (0, $aNOuE.put)($jgiLJ.remove(id));
            yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$5efaacd55cc1612e, removedVersion);
        });
    }
    function* $ca18c5576a08bbc9$export$50b15d1407aac14c(scenarioId, versionId) {
        const versionbyIdMap = yield (0, $aNOuE.select)((0, $9FFuD.getVersionsById));
        const version = versionbyIdMap[scenarioId];
        const releaseFilter = yield (0, $aNOuE.select)((0, $lz7VR.getReleaseFilterPure));
        yield* (0, $bYhSc.default)(function*() {
            yield (0, $aNOuE.put)((0, $lKGSc.removeVersionFromProject)({
                projectId: version.projects[0],
                versionId: scenarioId
            }));
            yield (0, $aNOuE.put)((0, $lKGSc.addVersionInProject)({
                projectId: version.projects[0],
                versionId: versionId
            }));
            yield (0, $aNOuE.put)($3VttY.bulkUpdate({
                [scenarioId]: {
                    id: versionId
                }
            }));
            if (releaseFilter.value && releaseFilter.value.includes(scenarioId)) {
                const rest = releaseFilter.value.filter((versionId)=>versionId !== scenarioId);
                yield (0, $aNOuE.put)((0, $834it.change)({
                    id: (0, $cGbfF.RELEASE_FILTER_ID),
                    value: [
                        ...rest,
                        versionId
                    ]
                }));
            }
            yield (0, $aNOuE.put)($gFvn5.updateReferences({
                versions: [
                    [
                        scenarioId,
                        versionId
                    ]
                ]
            }));
            yield (0, $aNOuE.put)($bt366.updateReferences({
                versions: [
                    [
                        scenarioId,
                        versionId
                    ]
                ]
            }));
            yield (0, $aNOuE.put)((0, $caw8G.updateVersionLexorankAdjustments)({
                [scenarioId]: versionId
            }));
        });
    }
    function* $ca18c5576a08bbc9$export$ea5c9603aa3d16d4(entityResponse) {
        const versionId = entityResponse.generatedId;
        const id = entityResponse.itemKey;
        if ((0, $4nDwW.isDefined)(versionId)) yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$50b15d1407aac14c, id, versionId);
        const warnings = yield (0, $aNOuE.call)((0, $5oyaD.inspectForCommitWarnings), entityResponse.error, id);
        if (warnings.length) yield (0, $aNOuE.put)((0, $ccCF0.add)({
            category: (0, $TTKUQ.ENTITY).RELEASE,
            itemId: id,
            warnings: warnings
        }));
    }
    function* $ca18c5576a08bbc9$export$f552fa4bc1966f1e(entityResponse) {
        yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$ea5c9603aa3d16d4, entityResponse);
        const id = entityResponse.itemKey;
        const warnings = yield (0, $aNOuE.select)((0, $9FFuD.getCommitWarningsForVersions));
        const removedVersionsById = yield (0, $aNOuE.select)((0, $9FFuD.getRemovedVersionsById));
        const removedVersion = removedVersionsById[id];
        if (!(0, $4nDwW.isDefined)(warnings[id])) {
            const originals = yield (0, $aNOuE.select)((0, $9FFuD.getOriginalVersions));
            yield (0, $aNOuE.put)((0, $75oAU.reset)((0, parcelRequire("bWXax")).default(id, originals)));
            if ((0, $4nDwW.isDefined)(removedVersion)) yield (0, $aNOuE.put)($jgiLJ.remove(id));
        }
    }
    function* $ca18c5576a08bbc9$export$be623675b8f208ee(id) {
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = (0, $hNEap.revertBody)({
            id: planId,
            currentScenarioId: currentScenarioId
        }, sequence, id);
        const response = yield* $asXbx.json({
            url: (0, $iTuEX.urls).revertChanges,
            method: 'POST',
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = response.data;
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
        }
        return response;
    }
    function* $ca18c5576a08bbc9$export$387fc7d982d5d3ef(payload) {
        yield (0, $aNOuE.put)($3VttY.updateReferences(payload));
        yield (0, $aNOuE.put)($75oAU.updateReferences(payload));
    }
    function* $ca18c5576a08bbc9$export$21aa7f798a65a8c0(payload) {
        const versions = yield (0, $aNOuE.select)((0, $9FFuD.getVersions));
        let originalVersions = (0, parcelRequire("ik0Qc")).default({}, (yield (0, $aNOuE.select)((0, $9FFuD.getOriginalVersions))));
        const versionPatches = {};
        for (const version of versions){
            const { id: id } = version;
            const originalVersion = originalVersions[id];
            for (const key of Object.keys(payload)){
                for (const ref of payload[key])if (version[key] === ref) {
                    versionPatches[id] = (0, parcelRequire("ik0Qc")).default(versionPatches[id], {
                        [key]: originalVersion[key] || null
                    });
                    delete originalVersion[key];
                    if (Object.keys(originalVersion).length === 0) originalVersions = (0, parcelRequire("bWXax")).default(id, originalVersions);
                }
            }
        }
        yield (0, $aNOuE.put)($3VttY.bulkUpdate(versionPatches));
        yield (0, $aNOuE.put)($75oAU.reset(originalVersions));
    }
    function* $ca18c5576a08bbc9$export$476de812fbbb6302({ projectId: projectId, version: version }, newVersionId, sequence) {
        yield* (0, $bYhSc.default)(function*() {
            const highestRankedVersion = yield (0, $aNOuE.select)((0, $9FFuD.getVersionWithHighestRankInProject), projectId);
            yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$5efaacd55cc1612e, {
                ...version,
                id: newVersionId,
                crossProjectVersion: null,
                releaseStatusId: '0',
                lexoRank: (0, $4nDwW.isDefined)(highestRankedVersion) ? highestRankedVersion.lexoRank : '',
                projects: [
                    projectId
                ]
            });
            if ((0, $4nDwW.isDefined)(highestRankedVersion)) {
                const rankPayload = {
                    id: newVersionId,
                    anchor: highestRankedVersion.id,
                    relation: 'AFTER'
                };
                yield (0, $aNOuE.put)($3VttY.rank(rankPayload));
                yield (0, $aNOuE.put)((0, $caw8G.adjustVersionLexoRank)(rankPayload));
            }
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            yield (0, $aNOuE.put)($75oAU.update({
                id: newVersionId,
                values: {}
            }));
            yield (0, $aNOuE.put)((0, $1yVQz.closeDialog)());
        });
    }
    function* $ca18c5576a08bbc9$export$89ca6b91461e4dc({ payload: payload }) {
        yield (0, $aNOuE.put)((0, $1yVQz.initiateRequest)());
        try {
            const url = (0, $iTuEX.urls).add;
            const body = (0, $iTuEX.addVersionBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), payload);
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body,
                profile: url
            });
            if (!response.ok) yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
            else {
                const { itemKey: itemKey, change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
                yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$476de812fbbb6302, payload, itemKey, sequence);
            }
            yield (0, $aNOuE.put)((0, $1yVQz.resetRequest)());
        } catch (e) {
            yield (0, $aNOuE.put)((0, $1yVQz.resetRequest)());
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $ca18c5576a08bbc9$export$5652a4ac6807e581({ versionId: versionId, patch: patch }) {
        const versionsById = yield (0, $aNOuE.select)((0, $9FFuD.getVersionsById));
        const version = versionsById[versionId];
        const updatedAttributes = Object.keys(patch);
        const originalValues = (0, parcelRequire("fes2p")).default(updatedAttributes, {
            ...version
        });
        yield (0, $aNOuE.put)($3VttY.bulkUpdate({
            [versionId]: patch
        }));
        if (updatedAttributes.includes('start') || updatedAttributes.includes('end')) yield (0, $aNOuE.put)($ca18c5576a08bbc9$export$7e4d7a0e6f2ecd97(versionId));
        if (updatedAttributes.includes('crossProjectVersion')) {
            if ((0, $4nDwW.isDefined)(version.crossProjectVersion)) yield (0, $aNOuE.call)($ca18c5576a08bbc9$var$crossProjectVersionsCommands.removeVersionFromCrossProjectVersion, versionId, version.crossProjectVersion);
            if ((0, $4nDwW.isDefined)(patch.crossProjectVersion)) yield (0, $aNOuE.call)($ca18c5576a08bbc9$var$crossProjectVersionsCommands.addVersionInCrossProjectVersion, versionId, patch.crossProjectVersion);
        }
        yield (0, $aNOuE.put)($75oAU.update({
            id: versionId,
            values: originalValues
        }));
    }
    function* $ca18c5576a08bbc9$export$307c978903f505ad(payload, sequence) {
        yield* (0, $bYhSc.default)(function*() {
            yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$5652a4ac6807e581, payload);
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            yield (0, $aNOuE.put)((0, $1yVQz.closeDialog)());
            yield (0, $aNOuE.put)((0, $2Cx2m.closeDialog)());
        });
    }
    function* $ca18c5576a08bbc9$export$740de856a6989843({ payload: payload }) {
        yield (0, $aNOuE.put)((0, $1yVQz.initiateRequest)());
        try {
            const url = (0, $iTuEX.urls).update;
            const body = (0, $iTuEX.updateVersionBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), payload);
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body,
                profile: url
            });
            if (!response.ok) yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
            else {
                const { change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
                yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$307c978903f505ad, payload, sequence);
            }
            yield (0, $aNOuE.put)((0, $1yVQz.resetRequest)());
        } catch (e) {
            yield (0, $aNOuE.put)((0, $1yVQz.resetRequest)());
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $ca18c5576a08bbc9$export$c3dc37c85d86f10c({ payload: payload }) {
        const isRanking = yield (0, $aNOuE.select)((0, $9FFuD.getReleasesTableRankingStatus));
        try {
            const url = (0, $iTuEX.urls).rank;
            const body = (0, $iTuEX.rankVersionBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), payload);
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!response.ok) {
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                    requestInfo: {
                        url: url,
                        type: (0, $77QEM.POST),
                        status: response.status,
                        body: body
                    }
                }));
                yield (0, $aNOuE.put)((0, $gGkgE.isReleasesRanking)(!isRanking));
                return;
            }
            const { change: { sequence: sequence }, failed: failed } = yield (0, $aNOuE.call)(response.json.bind(response));
            if (failed > 0) {
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    message: 'Failed to rank release'
                }));
                yield (0, $aNOuE.put)((0, $gGkgE.isReleasesRanking)(!isRanking));
                return;
            }
            yield* (0, $bYhSc.default)(function*() {
                const versions = yield (0, $aNOuE.select)((0, $9FFuD.getVersions));
                const { id: id, lexoRank: lexoRank } = versions.find(({ id: id })=>id === payload.id);
                if (!id.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $aNOuE.put)($75oAU.update({
                    id: id,
                    values: {
                        lexoRank: lexoRank
                    }
                }));
                yield (0, $aNOuE.put)($3VttY.rank(payload));
                yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
                yield (0, $aNOuE.put)((0, $caw8G.adjustVersionLexoRank)(payload));
            });
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
            yield (0, $aNOuE.put)((0, $gGkgE.isReleasesRanking)(!isRanking));
        }
    }
    function* $ca18c5576a08bbc9$export$25de5bd053709c0f(versionId) {
        const issuesByVersion = yield (0, $aNOuE.select)((0, $bI9dZ.getIssuesByVersionMap));
        const issuesInCurrentVersion = issuesByVersion[versionId];
        const originalIssues = yield (0, $aNOuE.select)((0, $bI9dZ.getOriginalIssues));
        const bulkUpdatePayload = {};
        for (const { id: id } of issuesInCurrentVersion){
            bulkUpdatePayload[id] = {
                fixVersions: originalIssues[id].fixVersions
            };
            yield (0, $aNOuE.put)($7CxJ7.revertFields({
                id: id,
                fields: [
                    'fixVersions'
                ]
            }));
        }
        yield (0, $aNOuE.put)($96USE.bulkUpdate(bulkUpdatePayload));
    }
    function* $ca18c5576a08bbc9$export$d88648d01aa45c1d(versionId, sequence) {
        yield* (0, $bYhSc.default)(function*() {
            yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$25de5bd053709c0f, versionId);
            yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$bf48c144c9502436, versionId);
            const originals = yield (0, $aNOuE.select)((0, $9FFuD.getOriginalVersions));
            yield (0, $aNOuE.put)($75oAU.reset((0, parcelRequire("bWXax")).default(versionId, originals)));
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            yield (0, $aNOuE.put)((0, $kcnfF.closeDialog)());
        });
    }
    function* $ca18c5576a08bbc9$export$3d30cf8b88f7bb6f(versionId, sequence) {
        const versionsById = yield (0, $aNOuE.select)((0, $9FFuD.getVersionsById));
        const version = versionsById[versionId];
        const issuesByVersionid = yield (0, $aNOuE.select)((0, $bI9dZ.getIssuesByVersionMap));
        yield* (0, $bYhSc.default)(function*() {
            yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$bf48c144c9502436, versionId);
            yield (0, $aNOuE.put)($jgiLJ.add(version));
            yield (0, $aNOuE.put)($bWg8d.bulkAdd(issuesByVersionid[versionId]));
            yield (0, $aNOuE.put)($75oAU.update({
                id: versionId,
                values: {}
            }));
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            yield (0, $aNOuE.put)((0, $kcnfF.closeDialog)());
        });
    }
    function* $ca18c5576a08bbc9$export$c7f0d1a6ee665364({ versionId: versionId }) {
        yield (0, $aNOuE.put)((0, $kcnfF.initiateRequest)());
        try {
            const url = (0, $iTuEX.urls).delete;
            const body = (0, $iTuEX.deleteVersionBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), versionId);
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!response.ok) yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
            else {
                const { change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
                if (versionId.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$d88648d01aa45c1d, versionId, sequence);
                else yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$3d30cf8b88f7bb6f, versionId, sequence);
            }
            yield (0, $aNOuE.put)((0, $kcnfF.resetRequest)());
        } catch (e) {
            yield (0, $aNOuE.put)((0, $kcnfF.resetRequest)());
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $ca18c5576a08bbc9$export$19970962bad2152d(versionId, issueDate, releaseDate) {
        const releaseStatusId = (0, $4nDwW.isDefined)(issueDate) && (0, $4nDwW.isDefined)(releaseDate) && issueDate > releaseDate ? (0, $TTKUQ.RELEASE_STATUSES).OFFTRACK : (0, $TTKUQ.RELEASE_STATUSES).ONTRACK;
        yield (0, $aNOuE.put)($3VttY.bulkUpdate({
            [versionId]: {
                releaseStatusId: releaseStatusId
            }
        }));
    }
    function* $ca18c5576a08bbc9$export$4dbc8e12162b81db({ versionId: versionId }, issuesByVersionCache) {
        const versionbyIdMap = yield (0, $aNOuE.select)((0, $9FFuD.getVersionsById));
        const issuesByVersion = issuesByVersionCache || (yield (0, $aNOuE.select)((0, $bI9dZ.getIssuesByVersionMap)));
        const version = versionbyIdMap[versionId];
        if (!version) return;
        const releaseDate = version.end;
        if (version.releaseStatusId === (0, $TTKUQ.RELEASE_STATUSES).RELEASED) return;
        const issueEndingLastBasedOnBaselineEnd = yield (0, $aNOuE.call)((0, $kqF3Q.getIssueEndingLastBasedOnBaselineEnd), issuesByVersion[versionId]);
        if ((0, $4nDwW.isDefined)(issueEndingLastBasedOnBaselineEnd)) {
            const { baselineEnd: baselineEnd } = issueEndingLastBasedOnBaselineEnd;
            yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$19970962bad2152d, versionId, baselineEnd, releaseDate);
            return;
        }
        const issueStartingLastBasedOnBaselineStart = yield (0, $aNOuE.call)((0, $kqF3Q.getIssueStartingLastBasedOnBaselineStart), issuesByVersion[versionId]);
        if ((0, $4nDwW.isDefined)(issueStartingLastBasedOnBaselineStart)) {
            const { baselineStart: baselineStart } = issueStartingLastBasedOnBaselineStart;
            yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$19970962bad2152d, versionId, baselineStart, releaseDate);
            return;
        }
        const sprints = yield (0, $aNOuE.select)((0, $d3quy.getSprintsWithFutureDates));
        const issueEndingLastBasedOnSprintEndDate = yield (0, $aNOuE.call)((0, $kqF3Q.getIssueEndingLastBasedOnSprintEndDate), issuesByVersion[versionId], sprints);
        if ((0, $4nDwW.isDefined)(issueEndingLastBasedOnSprintEndDate)) {
            const { baselineEnd: baselineEnd } = issueEndingLastBasedOnSprintEndDate;
            yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$19970962bad2152d, versionId, baselineEnd, releaseDate);
            return;
        }
        yield (0, $aNOuE.put)($3VttY.bulkUpdate({
            [versionId]: {
                releaseStatusId: (0, $TTKUQ.RELEASE_STATUSES).ONTRACK
            }
        }));
    }
    function* $ca18c5576a08bbc9$export$7e65e5343d7c672b() {
        const versions = yield (0, $aNOuE.select)((0, $9FFuD.getVersions));
        const issuesByVersion = yield (0, $aNOuE.select)((0, $bI9dZ.getIssuesByVersionMap));
        const unreleasedVersionsWithReleaseDateAndIssues = [];
        const onTrackPayload = {
            releaseStatusId: (0, $TTKUQ.RELEASE_STATUSES).ONTRACK
        };
        const onTrackVersions = {};
        for (const { id: id, releaseStatusId: releaseStatusId, end: end } of versions)if (releaseStatusId !== (0, $TTKUQ.RELEASE_STATUSES).RELEASED) {
            if (!(0, $4nDwW.isDefined)(end) || issuesByVersion[id].length === 0) onTrackVersions[id] = onTrackPayload;
            else unreleasedVersionsWithReleaseDateAndIssues.push(id);
        }
        yield* (0, $bYhSc.default)(function*() {
            yield (0, $aNOuE.put)($3VttY.bulkUpdate(onTrackVersions));
            for (const versionId of unreleasedVersionsWithReleaseDateAndIssues)yield (0, $aNOuE.call)($ca18c5576a08bbc9$export$4dbc8e12162b81db, $ca18c5576a08bbc9$export$7e4d7a0e6f2ecd97(versionId), issuesByVersion);
        });
    }
    function* $ca18c5576a08bbc9$export$31d54314ae5480f6({ payload: { versionId: versionId, crossProjectVersionId: crossProjectVersionId } }) {
        yield (0, $aNOuE.put)($ca18c5576a08bbc9$export$a5f005f0031c650d({
            versionId: versionId,
            patch: {
                crossProjectVersion: crossProjectVersionId
            }
        }));
    }
    function* $ca18c5576a08bbc9$export$6305f6649b21cb82({ payload: payload }) {
        yield (0, $aNOuE.put)((0, $834it.change)({
            id: (0, $cGbfF.RELEASE_FILTER_ID),
            value: payload
        }));
        yield (0, $aNOuE.put)((0, $834it.clear)((0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID)));
    }
    function* $ca18c5576a08bbc9$export$cb0413722f11fcf5({ payload: payload }) {
        const { id: planId, currentScenarioId: scenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const response = yield* $asXbx.json({
            url: (0, $iTuEX.urls).get,
            method: 'POST',
            body: {
                planId: planId,
                scenarioId: scenarioId,
                ids: payload
            }
        });
        if (response.ok) yield* (0, $bYhSc.default)(function*() {
            for (const version of response.data.filter((version)=>version.scenarioType !== (0, $TTKUQ.SCENARIO_TYPE).DELETED)){
                yield (0, $aNOuE.put)($3VttY.add({
                    projects: [
                        version.projectId
                    ],
                    id: version.itemKey,
                    ...version.values
                }));
                yield (0, $aNOuE.put)($ca18c5576a08bbc9$export$7e4d7a0e6f2ecd97(version.values.id));
            }
        });
    }
    function* $ca18c5576a08bbc9$export$7636f00a67e1b930() {
        yield (0, $6u3NN.takeEvery)($ca18c5576a08bbc9$export$2bdfac268df97e49, $ca18c5576a08bbc9$export$89ca6b91461e4dc);
    }
    function* $ca18c5576a08bbc9$export$919e3b6069d2417d() {
        yield (0, $6u3NN.takeEvery)($ca18c5576a08bbc9$export$3f90e3abee6e8d70, $ca18c5576a08bbc9$export$740de856a6989843);
    }
    function* $ca18c5576a08bbc9$export$2075f1cbc6860e11() {
        yield (0, $6u3NN.takeEvery)($ca18c5576a08bbc9$export$c2ca61e48c051fa6, $ca18c5576a08bbc9$export$c3dc37c85d86f10c);
    }
    function* $ca18c5576a08bbc9$export$877c3b6cd35254fd() {
        yield (0, $6u3NN.takeEvery)($ca18c5576a08bbc9$export$440c54a43c85f449, $ca18c5576a08bbc9$export$c7f0d1a6ee665364);
    }
    function* $ca18c5576a08bbc9$export$d72bc7e55e3e1f7a() {
        yield (0, $6u3NN.takeEvery)($ca18c5576a08bbc9$export$bcf0ce7e9670a9d, $ca18c5576a08bbc9$export$4dbc8e12162b81db);
    }
    function* $ca18c5576a08bbc9$export$db3062cd2a511ac7() {
        yield (0, $6u3NN.takeEvery)($ca18c5576a08bbc9$export$114415b2450800d, $ca18c5576a08bbc9$export$7e65e5343d7c672b);
    }
    function* $ca18c5576a08bbc9$export$3e74af38e36afe10() {
        yield (0, $6u3NN.takeEvery)($ca18c5576a08bbc9$export$f6d34bff03547a78, $ca18c5576a08bbc9$export$31d54314ae5480f6);
    }
    function* $ca18c5576a08bbc9$export$20993805280f607e() {
        yield (0, $6u3NN.takeEvery)($ca18c5576a08bbc9$export$a54e64fcc2f0026f, $ca18c5576a08bbc9$export$6305f6649b21cb82);
    }
    function* $ca18c5576a08bbc9$export$d211e2e29b5233fc() {
        yield (0, $6u3NN.takeEvery)($ca18c5576a08bbc9$export$494c2f9413c26e0c, $ca18c5576a08bbc9$export$cb0413722f11fcf5);
    }
    function $ca18c5576a08bbc9$export$2e2bcd8739ae039(crossProjectVersionsCommandsModule) {
        $ca18c5576a08bbc9$var$crossProjectVersionsCommands = crossProjectVersionsCommandsModule;
        return function*() {
            yield (0, $aNOuE.fork)($ca18c5576a08bbc9$export$7636f00a67e1b930);
            yield (0, $aNOuE.fork)($ca18c5576a08bbc9$export$919e3b6069d2417d);
            yield (0, $aNOuE.fork)($ca18c5576a08bbc9$export$2075f1cbc6860e11);
            yield (0, $aNOuE.fork)($ca18c5576a08bbc9$export$877c3b6cd35254fd);
            yield (0, $aNOuE.fork)($ca18c5576a08bbc9$export$d72bc7e55e3e1f7a);
            yield (0, $aNOuE.fork)($ca18c5576a08bbc9$export$db3062cd2a511ac7);
            yield (0, $aNOuE.fork)($ca18c5576a08bbc9$export$3e74af38e36afe10);
            yield (0, $aNOuE.fork)($ca18c5576a08bbc9$export$20993805280f607e);
            yield (0, $aNOuE.fork)($ca18c5576a08bbc9$export$d211e2e29b5233fc);
        };
    }
});
parcelRegister("fes2p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b16de98a1566ee29$export$2e2bcd8739ae039);
    var $c9RLn;
    var $b16de98a1566ee29$var$pick = (0, (0, parcelRequire("c9RLn")).default)(function pick(names, obj) {
        var result = {};
        var idx = 0;
        while(idx < names.length){
            if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
            idx += 1;
        }
        return result;
    });
    var $b16de98a1566ee29$export$2e2bcd8739ae039 = $b16de98a1566ee29$var$pick;
});
parcelRegister("kqF3Q", function(module, exports) {
    $parcel$export(module.exports, "getIssueStartingLastBasedOnBaselineStart", ()=>$0b1a15a95e1695dc$export$82110a2ddafda11a);
    $parcel$export(module.exports, "getIssueEndingLastBasedOnBaselineEnd", ()=>$0b1a15a95e1695dc$export$963e0f9e82d0022d);
    $parcel$export(module.exports, "getIssueEndingLastBasedOnSprintEndDate", ()=>$0b1a15a95e1695dc$export$23baf3eb744c9623);
    $parcel$export(module.exports, "getIssueOption", ()=>$0b1a15a95e1695dc$export$fa4500d3cd97bc66);
    $parcel$export(module.exports, "mergeOptimizedValueToIssue", ()=>$0b1a15a95e1695dc$export$3e9f1ccec23df0b9);
    var $hYfgW = parcelRequire("hYfgW");
    var $erSQG = parcelRequire("erSQG");
    var $7qDUb = parcelRequire("7qDUb");
    var $4nDwW = parcelRequire("4nDwW");
    var $6TEBn = parcelRequire("6TEBn");
    const $0b1a15a95e1695dc$var$getLatestIssueBasedOn = (field)=>(issues)=>{
            const sorted = (0, ($parcel$interopDefault($7qDUb)))(issues.filter((issue)=>!!issue[field]), (0, ($parcel$interopDefault($erSQG)))(field));
            return (0, ($parcel$interopDefault($hYfgW)))(sorted);
        };
    const $0b1a15a95e1695dc$export$82110a2ddafda11a = $0b1a15a95e1695dc$var$getLatestIssueBasedOn('baselineStart');
    const $0b1a15a95e1695dc$export$963e0f9e82d0022d = $0b1a15a95e1695dc$var$getLatestIssueBasedOn('baselineEnd');
    const $0b1a15a95e1695dc$export$23baf3eb744c9623 = (issues, sprintsWithDates)=>{
        const issuesWithTargetEndDate = issues.reduce((results, issue)=>{
            const { rawEndDate: rawEndDate } = (0, $6TEBn.getTargetDatesFromSprints)(issue, (0, $4nDwW.isDefined)(issue.team) ? sprintsWithDates[issue.team] || [] : []);
            if (rawEndDate) results.push({
                ...issue,
                baselineEnd: rawEndDate
            });
            return results;
        }, []);
        if (issuesWithTargetEndDate.length === 0) return;
        return $0b1a15a95e1695dc$export$963e0f9e82d0022d(issuesWithTargetEndDate);
    };
    const $0b1a15a95e1695dc$export$fa4500d3cd97bc66 = (issue, issueTypesById, projectsById)=>{
        const issueProject = issue.project && projectsById[issue.project];
        const issueProjectAndKey = issueProject ? `${issueProject.key}${issue.issueKey ? `-${issue.issueKey} ` : ' '}` : '';
        return {
            value: issue.id,
            label: `${issueProjectAndKey}${issue.summary}`,
            icon: issueTypesById && issueTypesById[issue.type] && issueTypesById[issue.type].iconUrl
        };
    };
    const $0b1a15a95e1695dc$export$3e9f1ccec23df0b9 = (issue, isOptimizationMode)=>{
        if (isOptimizationMode) return {
            ...issue,
            ...issue.optimized
        };
        return issue;
    };
});
parcelRegister("gFvn5", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$c5a5dd30900eecba$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD", ()=>$c5a5dd30900eecba$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "REMOVE", ()=>$c5a5dd30900eecba$export$29d55e1f664a246b);
    $parcel$export(module.exports, "BULK_UPDATE", ()=>$c5a5dd30900eecba$export$193f41a37c2df875);
    $parcel$export(module.exports, "ADD_VERSION_IN_CROSS_PROJECT_VERSION", ()=>$c5a5dd30900eecba$export$5bb382b7a9364fa0);
    $parcel$export(module.exports, "REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION", ()=>$c5a5dd30900eecba$export$cfd29272fccd14f8);
    $parcel$export(module.exports, "UPDATE_REFERENCES", ()=>$c5a5dd30900eecba$export$a6376ffb02379d2a);
    $parcel$export(module.exports, "reset", ()=>$c5a5dd30900eecba$export$aad8462122ac592b);
    $parcel$export(module.exports, "add", ()=>$c5a5dd30900eecba$export$e16d8520af44a096);
    $parcel$export(module.exports, "remove", ()=>$c5a5dd30900eecba$export$cd7f480d6b8286c3);
    $parcel$export(module.exports, "bulkUpdate", ()=>$c5a5dd30900eecba$export$fc4d5d648b7f7ca2);
    $parcel$export(module.exports, "updateReferences", ()=>$c5a5dd30900eecba$export$387fc7d982d5d3ef);
    $parcel$export(module.exports, "addVersionInCrossProjectVersion", ()=>$c5a5dd30900eecba$export$8e127e72248d08);
    $parcel$export(module.exports, "removeVersionFromCrossProjectVersion", ()=>$c5a5dd30900eecba$export$ac89d6cd5251dbf4);
    const $c5a5dd30900eecba$export$4a991c87e640ef77 = 'state.domain.cross-project-versions.RESET';
    const $c5a5dd30900eecba$export$bb6389024b71c2ae = 'state.domain.cross-project-versions.ADD';
    const $c5a5dd30900eecba$export$29d55e1f664a246b = 'state.domain.cross-project-versions.REMOVE';
    const $c5a5dd30900eecba$export$193f41a37c2df875 = 'state.domain.cross-project-versions.BULK_UPDATE';
    const $c5a5dd30900eecba$export$5bb382b7a9364fa0 = 'state.domain.cross-project-versions.ADD_VERSION_IN_CROSS_PROJECT_VERSION';
    const $c5a5dd30900eecba$export$cfd29272fccd14f8 = 'state.domain.cross-project-versions.REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION';
    const $c5a5dd30900eecba$export$a6376ffb02379d2a = 'state.domain.cross-project-versions.UPDATE_REFERENCES';
    const $c5a5dd30900eecba$export$aad8462122ac592b = (payload)=>({
            type: $c5a5dd30900eecba$export$4a991c87e640ef77,
            payload: payload
        });
    const $c5a5dd30900eecba$export$e16d8520af44a096 = (payload)=>({
            type: $c5a5dd30900eecba$export$bb6389024b71c2ae,
            payload: payload
        });
    const $c5a5dd30900eecba$export$cd7f480d6b8286c3 = (payload)=>({
            type: $c5a5dd30900eecba$export$29d55e1f664a246b,
            payload: payload
        });
    const $c5a5dd30900eecba$export$fc4d5d648b7f7ca2 = (payload)=>({
            type: $c5a5dd30900eecba$export$193f41a37c2df875,
            payload: payload
        });
    const $c5a5dd30900eecba$export$387fc7d982d5d3ef = (payload)=>({
            type: $c5a5dd30900eecba$export$a6376ffb02379d2a,
            payload: payload
        });
    const $c5a5dd30900eecba$export$8e127e72248d08 = (payload)=>({
            type: $c5a5dd30900eecba$export$5bb382b7a9364fa0,
            payload: payload
        });
    const $c5a5dd30900eecba$export$ac89d6cd5251dbf4 = (payload)=>({
            type: $c5a5dd30900eecba$export$cfd29272fccd14f8,
            payload: payload
        });
});
parcelRegister("bt366", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$3e54f3d3cb9dcfbc$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$3e54f3d3cb9dcfbc$export$e271b26eefe41db8);
    $parcel$export(module.exports, "UPDATE_REFERENCES", ()=>$3e54f3d3cb9dcfbc$export$a6376ffb02379d2a);
    $parcel$export(module.exports, "reset", ()=>$3e54f3d3cb9dcfbc$export$aad8462122ac592b);
    $parcel$export(module.exports, "update", ()=>$3e54f3d3cb9dcfbc$export$722fbec263ad908a);
    $parcel$export(module.exports, "updateReferences", ()=>$3e54f3d3cb9dcfbc$export$387fc7d982d5d3ef);
    const $3e54f3d3cb9dcfbc$export$4a991c87e640ef77 = 'state.domain.original-cross-project-versions.RESET';
    const $3e54f3d3cb9dcfbc$export$e271b26eefe41db8 = 'state.domain.original-cross-project-versions.UPDATE';
    const $3e54f3d3cb9dcfbc$export$a6376ffb02379d2a = 'state.domain.original-cross-project-versions.UPDATE_REFERENCES';
    const $3e54f3d3cb9dcfbc$export$aad8462122ac592b = (payload)=>({
            type: $3e54f3d3cb9dcfbc$export$4a991c87e640ef77,
            payload: payload
        });
    const $3e54f3d3cb9dcfbc$export$722fbec263ad908a = (payload)=>({
            type: $3e54f3d3cb9dcfbc$export$e271b26eefe41db8,
            payload: payload
        });
    const $3e54f3d3cb9dcfbc$export$387fc7d982d5d3ef = (payload)=>({
            type: $3e54f3d3cb9dcfbc$export$a6376ffb02379d2a,
            payload: payload
        });
});
parcelRegister("75oAU", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$80526528baa9232e$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$80526528baa9232e$export$e271b26eefe41db8);
    $parcel$export(module.exports, "UPDATE_REFERENCES", ()=>$80526528baa9232e$export$a6376ffb02379d2a);
    $parcel$export(module.exports, "reset", ()=>$80526528baa9232e$export$aad8462122ac592b);
    $parcel$export(module.exports, "update", ()=>$80526528baa9232e$export$722fbec263ad908a);
    $parcel$export(module.exports, "updateReferences", ()=>$80526528baa9232e$export$387fc7d982d5d3ef);
    const $80526528baa9232e$export$4a991c87e640ef77 = 'state.domain.original-versions.RESET';
    const $80526528baa9232e$export$e271b26eefe41db8 = 'state.domain.original-versions.UPDATE';
    const $80526528baa9232e$export$a6376ffb02379d2a = 'state.domain.original-versions.UPDATE_REFERENCES';
    const $80526528baa9232e$export$aad8462122ac592b = (payload)=>({
            type: $80526528baa9232e$export$4a991c87e640ef77,
            payload: payload
        });
    const $80526528baa9232e$export$722fbec263ad908a = (payload)=>({
            type: $80526528baa9232e$export$e271b26eefe41db8,
            payload: payload
        });
    const $80526528baa9232e$export$387fc7d982d5d3ef = (payload)=>({
            type: $80526528baa9232e$export$a6376ffb02379d2a,
            payload: payload
        });
});
parcelRegister("lKGSc", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$98844d018697c32e$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD", ()=>$98844d018697c32e$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "ADD_VERSION_IN_PROJECT", ()=>$98844d018697c32e$export$b90941c21e0a8c3a);
    $parcel$export(module.exports, "REMOVE_VERSION_FROM_PROJECT", ()=>$98844d018697c32e$export$30c6ea30d9ec4bc);
    $parcel$export(module.exports, "SET_DEFAULT_PROJECT", ()=>$98844d018697c32e$export$f0f2b3316de0f660);
    $parcel$export(module.exports, "reset", ()=>$98844d018697c32e$export$aad8462122ac592b);
    $parcel$export(module.exports, "add", ()=>$98844d018697c32e$export$e16d8520af44a096);
    $parcel$export(module.exports, "addVersionInProject", ()=>$98844d018697c32e$export$197e16f09b72093e);
    $parcel$export(module.exports, "removeVersionFromProject", ()=>$98844d018697c32e$export$50ab934eee6c251);
    $parcel$export(module.exports, "setDefaultProject", ()=>$98844d018697c32e$export$5fb893a5ca0ba0fa);
    const $98844d018697c32e$export$4a991c87e640ef77 = 'state.domain.projects.RESET';
    const $98844d018697c32e$export$bb6389024b71c2ae = 'state.domain.projects.ADD';
    const $98844d018697c32e$export$b90941c21e0a8c3a = 'state.domain.projects.ADD_VERSION_IN_PROJECT';
    const $98844d018697c32e$export$30c6ea30d9ec4bc = 'state.domain.projects.REMOVE_VERSION_FROM_PROJECT';
    const $98844d018697c32e$export$f0f2b3316de0f660 = 'state.domain.projects.SET_DEFAULT_PROJECT';
    const $98844d018697c32e$export$aad8462122ac592b = (payload)=>({
            type: $98844d018697c32e$export$4a991c87e640ef77,
            payload: payload
        });
    const $98844d018697c32e$export$e16d8520af44a096 = (payload)=>({
            type: $98844d018697c32e$export$bb6389024b71c2ae,
            payload: payload
        });
    const $98844d018697c32e$export$197e16f09b72093e = (payload)=>({
            type: $98844d018697c32e$export$b90941c21e0a8c3a,
            payload: payload
        });
    const $98844d018697c32e$export$50ab934eee6c251 = (payload)=>({
            type: $98844d018697c32e$export$30c6ea30d9ec4bc,
            payload: payload
        });
    const $98844d018697c32e$export$5fb893a5ca0ba0fa = (payload)=>({
            type: $98844d018697c32e$export$f0f2b3316de0f660,
            payload: payload
        });
});
parcelRegister("jgiLJ", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$97d33d742c09b12f$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD", ()=>$97d33d742c09b12f$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "REMOVE", ()=>$97d33d742c09b12f$export$29d55e1f664a246b);
    $parcel$export(module.exports, "reset", ()=>$97d33d742c09b12f$export$aad8462122ac592b);
    $parcel$export(module.exports, "add", ()=>$97d33d742c09b12f$export$e16d8520af44a096);
    $parcel$export(module.exports, "remove", ()=>$97d33d742c09b12f$export$cd7f480d6b8286c3);
    const $97d33d742c09b12f$export$4a991c87e640ef77 = 'state.domain.removed-versions.RESET';
    const $97d33d742c09b12f$export$bb6389024b71c2ae = 'state.domain.removed-versions.ADD';
    const $97d33d742c09b12f$export$29d55e1f664a246b = 'state.domain.removed-versions.REMOVE';
    const $97d33d742c09b12f$export$aad8462122ac592b = (payload)=>({
            type: $97d33d742c09b12f$export$4a991c87e640ef77,
            payload: payload
        });
    const $97d33d742c09b12f$export$e16d8520af44a096 = (payload)=>({
            type: $97d33d742c09b12f$export$bb6389024b71c2ae,
            payload: payload
        });
    const $97d33d742c09b12f$export$cd7f480d6b8286c3 = (versionId)=>({
            type: $97d33d742c09b12f$export$29d55e1f664a246b,
            versionId: versionId
        });
});
parcelRegister("3VttY", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$4374b0ba7fe309f3$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD", ()=>$4374b0ba7fe309f3$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "REMOVE", ()=>$4374b0ba7fe309f3$export$29d55e1f664a246b);
    $parcel$export(module.exports, "RANK", ()=>$4374b0ba7fe309f3$export$c3d7e0f1e63de60e);
    $parcel$export(module.exports, "BULK_UPDATE", ()=>$4374b0ba7fe309f3$export$193f41a37c2df875);
    $parcel$export(module.exports, "UPDATE_REFERENCES", ()=>$4374b0ba7fe309f3$export$a6376ffb02379d2a);
    $parcel$export(module.exports, "reset", ()=>$4374b0ba7fe309f3$export$aad8462122ac592b);
    $parcel$export(module.exports, "rank", ()=>$4374b0ba7fe309f3$export$fbc8bcd33b574fbc);
    $parcel$export(module.exports, "add", ()=>$4374b0ba7fe309f3$export$e16d8520af44a096);
    $parcel$export(module.exports, "remove", ()=>$4374b0ba7fe309f3$export$cd7f480d6b8286c3);
    $parcel$export(module.exports, "bulkUpdate", ()=>$4374b0ba7fe309f3$export$fc4d5d648b7f7ca2);
    $parcel$export(module.exports, "updateReferences", ()=>$4374b0ba7fe309f3$export$387fc7d982d5d3ef);
    const $4374b0ba7fe309f3$export$4a991c87e640ef77 = 'state.domain.versions.RESET';
    const $4374b0ba7fe309f3$export$bb6389024b71c2ae = 'state.domain.versions.ADD';
    const $4374b0ba7fe309f3$export$29d55e1f664a246b = 'state.domain.versions.REMOVE';
    const $4374b0ba7fe309f3$export$c3d7e0f1e63de60e = 'state.domain.versions.RANK';
    const $4374b0ba7fe309f3$export$193f41a37c2df875 = 'state.domain.versions.BULK_UPDATE';
    const $4374b0ba7fe309f3$export$a6376ffb02379d2a = 'state.domain.versions.UPDATE_REFERENCES';
    const $4374b0ba7fe309f3$export$aad8462122ac592b = (payload)=>({
            type: $4374b0ba7fe309f3$export$4a991c87e640ef77,
            payload: payload
        });
    const $4374b0ba7fe309f3$export$fbc8bcd33b574fbc = (payload)=>({
            type: $4374b0ba7fe309f3$export$c3d7e0f1e63de60e,
            payload: payload
        });
    const $4374b0ba7fe309f3$export$e16d8520af44a096 = (payload)=>({
            type: $4374b0ba7fe309f3$export$bb6389024b71c2ae,
            payload: payload
        });
    const $4374b0ba7fe309f3$export$cd7f480d6b8286c3 = (payload)=>({
            type: $4374b0ba7fe309f3$export$29d55e1f664a246b,
            payload: payload
        });
    const $4374b0ba7fe309f3$export$fc4d5d648b7f7ca2 = (payload)=>({
            type: $4374b0ba7fe309f3$export$193f41a37c2df875,
            payload: payload
        });
    const $4374b0ba7fe309f3$export$387fc7d982d5d3ef = (payload)=>({
            type: $4374b0ba7fe309f3$export$a6376ffb02379d2a,
            payload: payload
        });
});
parcelRegister("2Cx2m", function(module, exports) {
    $parcel$export(module.exports, "OPEN_DIALOG", ()=>$b8cc1086144e418b$export$fb283a8049ce78e7);
    $parcel$export(module.exports, "CLOSE_DIALOG", ()=>$b8cc1086144e418b$export$194b247a9d6170da);
    $parcel$export(module.exports, "openDialog", ()=>$b8cc1086144e418b$export$45f11db5513b93db);
    $parcel$export(module.exports, "closeDialog", ()=>$b8cc1086144e418b$export$34bf1befb2fab61a);
    const $b8cc1086144e418b$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.project-releases.add-to-cpr-dialog.OPEN_DIALOG';
    const $b8cc1086144e418b$export$194b247a9d6170da = 'state.ui.main.tabs.releases.project-releases.add-to-cpr-dialog.CLOSE_DIALOG';
    const $b8cc1086144e418b$export$45f11db5513b93db = (versionId)=>({
            type: $b8cc1086144e418b$export$fb283a8049ce78e7,
            versionId: versionId
        });
    const $b8cc1086144e418b$export$34bf1befb2fab61a = ()=>({
            type: $b8cc1086144e418b$export$194b247a9d6170da
        });
});
parcelRegister("kcnfF", function(module, exports) {
    $parcel$export(module.exports, "SET_MODE", ()=>$4235363c544fe336$export$27a86d4a6fd7f204);
    $parcel$export(module.exports, "OPEN_DIALOG", ()=>$4235363c544fe336$export$fb283a8049ce78e7);
    $parcel$export(module.exports, "CLOSE_DIALOG", ()=>$4235363c544fe336$export$194b247a9d6170da);
    $parcel$export(module.exports, "INITIATE_REQUEST", ()=>$4235363c544fe336$export$4580e708995fb75f);
    $parcel$export(module.exports, "RESET_REQUEST", ()=>$4235363c544fe336$export$31889003e5372a7f);
    $parcel$export(module.exports, "setMode", ()=>$4235363c544fe336$export$d4f039427a1beff1);
    $parcel$export(module.exports, "openDialog", ()=>$4235363c544fe336$export$45f11db5513b93db);
    $parcel$export(module.exports, "closeDialog", ()=>$4235363c544fe336$export$34bf1befb2fab61a);
    $parcel$export(module.exports, "initiateRequest", ()=>$4235363c544fe336$export$82f68a404cfea29);
    $parcel$export(module.exports, "resetRequest", ()=>$4235363c544fe336$export$b38f09eddeeb56fb);
    const $4235363c544fe336$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.SET_MODE';
    const $4235363c544fe336$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.OPEN_DIALOG';
    const $4235363c544fe336$export$194b247a9d6170da = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.CLOSE_DIALOG';
    const $4235363c544fe336$export$4580e708995fb75f = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.INITIATE_REQUEST';
    const $4235363c544fe336$export$31889003e5372a7f = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.RESET_REQUEST';
    const $4235363c544fe336$export$d4f039427a1beff1 = (payload)=>({
            type: $4235363c544fe336$export$27a86d4a6fd7f204,
            payload: payload
        });
    const $4235363c544fe336$export$45f11db5513b93db = (versionId)=>({
            type: $4235363c544fe336$export$fb283a8049ce78e7,
            versionId: versionId
        });
    const $4235363c544fe336$export$34bf1befb2fab61a = ()=>({
            type: $4235363c544fe336$export$194b247a9d6170da
        });
    const $4235363c544fe336$export$82f68a404cfea29 = ()=>({
            type: $4235363c544fe336$export$4580e708995fb75f
        });
    const $4235363c544fe336$export$b38f09eddeeb56fb = ()=>({
            type: $4235363c544fe336$export$31889003e5372a7f
        });
});
parcelRegister("1yVQz", function(module, exports) {
    $parcel$export(module.exports, "SET_MODE", ()=>$525ca8bf516c0525$export$27a86d4a6fd7f204);
    $parcel$export(module.exports, "OPEN_DIALOG", ()=>$525ca8bf516c0525$export$fb283a8049ce78e7);
    $parcel$export(module.exports, "CLOSE_DIALOG", ()=>$525ca8bf516c0525$export$194b247a9d6170da);
    $parcel$export(module.exports, "INITIATE_REQUEST", ()=>$525ca8bf516c0525$export$4580e708995fb75f);
    $parcel$export(module.exports, "RESET_REQUEST", ()=>$525ca8bf516c0525$export$31889003e5372a7f);
    $parcel$export(module.exports, "setMode", ()=>$525ca8bf516c0525$export$d4f039427a1beff1);
    $parcel$export(module.exports, "openDialog", ()=>$525ca8bf516c0525$export$45f11db5513b93db);
    $parcel$export(module.exports, "closeDialog", ()=>$525ca8bf516c0525$export$34bf1befb2fab61a);
    $parcel$export(module.exports, "initiateRequest", ()=>$525ca8bf516c0525$export$82f68a404cfea29);
    $parcel$export(module.exports, "resetRequest", ()=>$525ca8bf516c0525$export$b38f09eddeeb56fb);
    const $525ca8bf516c0525$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.releases.project-releases.release-dialog.SET_MODE';
    const $525ca8bf516c0525$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.project-releases.release-dialog.OPEN_DIALOG';
    const $525ca8bf516c0525$export$194b247a9d6170da = 'state.ui.main.tabs.releases.project-releases.release-dialog.CLOSE_DIALOG';
    const $525ca8bf516c0525$export$4580e708995fb75f = 'state.ui.main.tabs.releases.project-releases.release-dialog.INITIATE_REQUEST';
    const $525ca8bf516c0525$export$31889003e5372a7f = 'state.ui.main.tabs.releases.project-releases.release-dialog.RESET_REQUEST';
    const $525ca8bf516c0525$export$d4f039427a1beff1 = (payload)=>({
            type: $525ca8bf516c0525$export$27a86d4a6fd7f204,
            payload: payload
        });
    const $525ca8bf516c0525$export$45f11db5513b93db = (projectId, versionId)=>({
            type: $525ca8bf516c0525$export$fb283a8049ce78e7,
            payload: {
                projectId: projectId,
                versionId: versionId
            }
        });
    const $525ca8bf516c0525$export$34bf1befb2fab61a = ()=>({
            type: $525ca8bf516c0525$export$194b247a9d6170da
        });
    const $525ca8bf516c0525$export$82f68a404cfea29 = ()=>({
            type: $525ca8bf516c0525$export$4580e708995fb75f
        });
    const $525ca8bf516c0525$export$b38f09eddeeb56fb = ()=>({
            type: $525ca8bf516c0525$export$31889003e5372a7f
        });
});
parcelRegister("gGkgE", function(module, exports) {
    $parcel$export(module.exports, "SET_RANKING_STATE", ()=>$f79beb9c900bfd8a$export$1850e3f5cf6a5e30);
    $parcel$export(module.exports, "isReleasesRanking", ()=>$f79beb9c900bfd8a$export$45321decb2561e51);
    const $f79beb9c900bfd8a$export$1850e3f5cf6a5e30 = 'state.ui.main.tabs.releases.project-releases.releases-table.SET_RANKING_STATE';
    const $f79beb9c900bfd8a$export$45321decb2561e51 = (payload)=>({
            type: $f79beb9c900bfd8a$export$1850e3f5cf6a5e30,
            payload: payload
        });
});
parcelRegister("iTuEX", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$f46e96b8c8a1be3a$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "addVersionBody", ()=>$f46e96b8c8a1be3a$export$a19bf42e0b3d7082);
    $parcel$export(module.exports, "updateVersionBody", ()=>$f46e96b8c8a1be3a$export$80a1d0573753ab10);
    $parcel$export(module.exports, "rankVersionBody", ()=>$f46e96b8c8a1be3a$export$b303dc519d35242f);
    $parcel$export(module.exports, "deleteVersionBody", ()=>$f46e96b8c8a1be3a$export$4c6bb7db8f86d168);
    var $4Rr1a;
    var $j0d94;
    var $4nDwW = parcelRequire("4nDwW");
    const $f46e96b8c8a1be3a$export$bcae9ba627f604b6 = {
        add: '/rest/jpo/1.0/versions/add',
        get: '/rest/jpo/1.0/versions/get',
        update: '/rest/jpo/1.0/versions/update',
        rank: '/rest/jpo/1.0/versions/rank',
        delete: '/rest/jpo/1.0/versions/delete',
        revertChanges: '/rest/jpo/1.0/versions/revert'
    };
    const $f46e96b8c8a1be3a$export$a19bf42e0b3d7082 = (plan, { projectId: projectId, version: version })=>{
        const { id: planId, currentScenarioId: scenarioId } = plan;
        const versionAttributes = [
            'name',
            'description',
            'start',
            'delta',
            'end'
        ];
        const versionValues = (0, parcelRequire("j0d94")).default((acc, attr)=>{
            acc[attr] = (0, $4nDwW.isDefined)(version[attr]) ? {
                value: version[attr]
            } : {};
            return acc;
        }, {}, versionAttributes);
        return {
            planId: planId,
            scenarioId: scenarioId,
            projectId: projectId,
            description: {
                ...versionValues,
                crossProjectVersion: {}
            }
        };
    };
    const $f46e96b8c8a1be3a$var$asObject = (value)=>(0, $4nDwW.isDefined)(value) ? {
            value: value
        } : {};
    const $f46e96b8c8a1be3a$export$80a1d0573753ab10 = (plan, { versionId: versionId, patch: patch })=>{
        const { id: planId, currentScenarioId: scenarioId } = plan;
        const copyOfPatch = {
            ...patch
        };
        const versionValues = (0, parcelRequire("4Rr1a")).default($f46e96b8c8a1be3a$var$asObject, copyOfPatch);
        return {
            planId: planId,
            scenarioId: scenarioId,
            itemKeys: [
                versionId
            ],
            description: {
                ...versionValues
            }
        };
    };
    const $f46e96b8c8a1be3a$export$b303dc519d35242f = (plan, payload)=>{
        const { id: planId, currentScenarioId: scenarioId } = plan;
        const { id: id, anchor: anchor, relation: relation } = payload;
        return {
            operations: [
                {
                    anchor: anchor,
                    itemKeys: [
                        id
                    ],
                    operationType: relation
                }
            ],
            planId: planId,
            scenarioId: scenarioId
        };
    };
    const $f46e96b8c8a1be3a$export$4c6bb7db8f86d168 = ({ id: planId, currentScenarioId: scenarioId }, versionId)=>({
            itemKeys: [
                versionId
            ],
            planId: planId,
            scenarioId: scenarioId
        });
});
parcelRegister("5oyaD", function(module, exports) {
    $parcel$export(module.exports, "inspectForCommitWarnings", ()=>$eb68ba81cee435e7$export$1eed481c758d15b7);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $jw86H = parcelRequire("jw86H");
    var $9FFuD = parcelRequire("9FFuD");
    var $dii2h = parcelRequire("dii2h");
    const $eb68ba81cee435e7$export$deb6050352aafd0b = {
        header: (0, $dii2h.default).defaultWarningHeader,
        message: (0, $dii2h.default).defaultWarningContent,
        messageValues: {}
    };
    function $eb68ba81cee435e7$export$bb28f4058acfe78c({ error: error, errorMessages: errorMessages }, crossProjectVersionTitle, versionTitle) {
        switch(error){
            case 'ENVIRONMENT_ENTITY_NOT_FOUND':
                return {
                    header: (0, $dii2h.default).releaseNotFoundHeader,
                    message: (0, $dii2h.default).releaseNotFoundContent,
                    messageValues: {
                        versionTitle: versionTitle
                    }
                };
            case 'ENVIRONMENT_RELATED_ENTITY_NOT_FOUND':
                return {
                    header: (0, $dii2h.default).projectNotFoundHeader,
                    message: (0, $dii2h.default).projectNotFoundContent,
                    messageValues: {}
                };
            case 'UNCOMMITTED_FOREIGN_KEY':
                return {
                    header: (0, $dii2h.default).crossProjectReleaseNotCommittedHeader,
                    message: (0, $dii2h.default).crossProjectReleaseNotCommittedContent,
                    messageValues: {
                        crossProjectVersionTitle: crossProjectVersionTitle
                    }
                };
            case 'VERSION_API_EXCEPTION':
                if (errorMessages.length > 0) return {
                    header: (0, $dii2h.default).apiExceptionHeader,
                    message: (0, $dii2h.default).apiExceptionContent,
                    messageValues: {
                        messages: errorMessages.join(' ')
                    }
                };
                return {
                    header: (0, $dii2h.default).defaultWarningHeader,
                    message: (0, $dii2h.default).defaultWarningContent,
                    messageValues: {}
                };
            default:
                return $eb68ba81cee435e7$export$deb6050352aafd0b;
        }
    }
    function* $eb68ba81cee435e7$export$1eed481c758d15b7(error, versionId) {
        if (error) {
            const versions = yield (0, $aNOuE.select)((0, $9FFuD.getVersions));
            const version = versions.find((version)=>version.id === versionId);
            let crossProjectVersionTitle;
            let versionTitle;
            if (version) {
                versionTitle = version.name;
                const crossProjectVersionId = version.crossProjectVersion;
                const crossProjectVersions = yield (0, $aNOuE.select)((0, $jw86H.getCrossProjectVersions));
                const crossProjectVersion = crossProjectVersions.find((crossProjectVersion)=>crossProjectVersion.id === crossProjectVersionId);
                if (crossProjectVersion) crossProjectVersionTitle = crossProjectVersion.name;
            }
            return [
                $eb68ba81cee435e7$export$bb28f4058acfe78c(error, crossProjectVersionTitle, versionTitle)
            ];
        }
        return [];
    }
});
parcelRegister("dii2h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9675ef81d9cbbb20$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9675ef81d9cbbb20$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releaseNotFoundHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.versions.release-not-found-header",
            "defaultMessage": "Release {versionTitle} no longer exists in this plan"
        },
        releaseNotFoundContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.versions.release-not-found-content",
            "defaultMessage": "Refresh your plan to reflect this change"
        },
        projectNotFoundHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.versions.project-not-found-header",
            "defaultMessage": "Project no longer exists in this plan"
        },
        projectNotFoundContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.versions.project-not-found-content",
            "defaultMessage": "Refresh to update your plan"
        },
        crossProjectReleaseNotCommittedHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.versions.cross-project-release-not-committed-header",
            "defaultMessage": "Changes not saved"
        },
        crossProjectReleaseNotCommittedContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.versions.cross-project-release-not-committed-content",
            "defaultMessage": "This release is linked to {crossProjectVersionTitle}, which is a cross-project release. You need to save {crossProjectVersionTitle} in Jira first, then save this release."
        },
        defaultWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.versions.default-warning-header",
            "defaultMessage": "Version could not be committed for unknown reasons."
        },
        defaultWarningContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.versions.default-warning-content",
            "defaultMessage": "Please contact your administrator."
        },
        apiExceptionContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.versions.api-exception-content",
            "defaultMessage": "{messages}"
        },
        apiExceptionHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.versions.api-exception-header",
            "defaultMessage": "Version could not be committed"
        }
    });
});
const $d912598f161dc1cb$export$afecb711a599950a = 'state.ui.main.tabs.releases.project-releases.release-dialog.CREATE_RELEASE';
const $d912598f161dc1cb$export$b9385259cf8397cd = 'state.ui.main.tabs.releases.project-releases.release-dialog.EDIT_RELEASE';
parcelRegister("kyJxl", function(module, exports) {
    $parcel$export(module.exports, "DELETE_RELEASE", ()=>$86bf3b767c9972d1$export$440c54a43c85f449);
    $parcel$export(module.exports, "DELETE_DIALOG_ACTIONS", ()=>$86bf3b767c9972d1$export$1ec19a32727d8911);
    const $86bf3b767c9972d1$export$440c54a43c85f449 = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.DELETE_RELEASE';
    const $86bf3b767c9972d1$export$653071db1143c98 = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.REMOVE_RELEASE';
    const $86bf3b767c9972d1$export$1ec19a32727d8911 = {
        DELETE_RELEASE: $86bf3b767c9972d1$export$440c54a43c85f449,
        REMOVE_RELEASE: $86bf3b767c9972d1$export$653071db1143c98
    };
});
parcelRegister("gaFm9", function(module, exports) {
    $parcel$export(module.exports, "calculateWarnings", ()=>$d27a93c5eebb50f0$export$3bec30015a8c58aa);
    $parcel$export(module.exports, "misconfiguredChildrenWarning", ()=>$d27a93c5eebb50f0$export$4c7b48c5d99eb207);
    $parcel$export(module.exports, "default", ()=>$d27a93c5eebb50f0$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $1CGdp = parcelRequire("1CGdp");
    var $19iju = parcelRequire("19iju");
    var $7ppNi = parcelRequire("7ppNi");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $cZF7S = parcelRequire("cZF7S");
    var $d3quy = parcelRequire("d3quy");
    var $dRVQG = parcelRequire("dRVQG");
    var $eIyFU = parcelRequire("eIyFU");
    var $lYuBN = parcelRequire("lYuBN");
    var $7vqYD = parcelRequire("7vqYD");
    var $fJ4u7 = parcelRequire("fJ4u7");
    var $5lzYR = parcelRequire("5lzYR");
    var $hfaJb = parcelRequire("hfaJb");
    var $la6bP = parcelRequire("la6bP");
    var $24CMK = parcelRequire("24CMK");
    var $qjIxt = parcelRequire("qjIxt");
    var $l14aI = parcelRequire("l14aI");
    const $d27a93c5eebb50f0$var$CALCULATE_WARNINGS = 'command.warnings.CALCULATE_WARNINGS';
    const $d27a93c5eebb50f0$export$3bec30015a8c58aa = ()=>({
            type: $d27a93c5eebb50f0$var$CALCULATE_WARNINGS
        });
    const $d27a93c5eebb50f0$export$4c7b48c5d99eb207 = ()=>({
            type: (0, $la6bP.MISCONFIGURED_CHILDREN),
            header: (0, $l14aI.headerMessages).misconfiguredChildren,
            message: (0, $l14aI.bodyMessages).misconfiguredChildren,
            messageValues: {}
        });
    function* $d27a93c5eebb50f0$export$4447429ff9b7cd07() {
        const isSolutionValid = yield (0, $aNOuE.select)((0, $cZF7S.getIsSolutionValid));
        const mode = yield (0, $aNOuE.select)((0, $1CGdp.getMode));
        const issues = yield (0, $aNOuE.select)((0, $gFhwb.getIssues));
        const projects = yield (0, $aNOuE.select)((0, $jpXKt.getProjects));
        const sprints = yield (0, $aNOuE.select)((0, $d3quy.getSprints));
        const issueStatuses = yield (0, $aNOuE.select)((0, $7ppNi.getIssueStatuses));
        const customFields = yield (0, $aNOuE.select)((0, $19iju.getCustomFields));
        const sprintsWithFutureDates = yield (0, $aNOuE.select)((0, $d3quy.getSprintsWithFutureDates));
        const plan = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const disabledWarnings = yield (0, $aNOuE.select)((0, $eIyFU.getDisabledWarnings));
        const teamsById = yield (0, $aNOuE.select)((0, $dRVQG.getAllTeamsById));
        try {
            const warnings = yield (0, $aNOuE.call)((0, $qjIxt.calculateAllWarnings), {
                isSolutionValid: isSolutionValid,
                mode: mode,
                issues: issues,
                projects: projects,
                sprints: sprints,
                issueStatuses: issueStatuses,
                customFields: customFields,
                sprintsWithFutureDates: sprintsWithFutureDates,
                plan: plan,
                disabledWarnings: disabledWarnings,
                teamsById: teamsById
            });
            yield (0, $aNOuE.put)((0, $hfaJb.setWarnings)(warnings));
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $d27a93c5eebb50f0$export$f48673270179dc3a() {
        yield (0, $6u3NN.takeLatest)([
            $d27a93c5eebb50f0$var$CALCULATE_WARNINGS,
            (0, $lYuBN.SET_MODE),
            (0, $lYuBN.SET_MODE),
            (0, $7vqYD.SET_VALIDITY),
            (0, $fJ4u7.SET_SHOW_ROLLED_UP_DATE),
            (0, $5lzYR.TOGGLE_WARNING_TYPE)
        ], $d27a93c5eebb50f0$export$4447429ff9b7cd07);
    }
    function* $d27a93c5eebb50f0$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($d27a93c5eebb50f0$export$f48673270179dc3a);
    }
});
parcelRegister("lYuBN", function(module, exports) {
    $parcel$export(module.exports, "SET_MODE", ()=>$ee2c7f1cbdf52dcc$export$27a86d4a6fd7f204);
    $parcel$export(module.exports, "SET_ANALYTICS_EVENT", ()=>$ee2c7f1cbdf52dcc$export$2499970725b3d311);
    $parcel$export(module.exports, "REPORT_INITIAL_LOAD_ANALYTICS", ()=>$ee2c7f1cbdf52dcc$export$ec1035696f159a68);
    $parcel$export(module.exports, "SET_IS_EXPORT_PREVIEW", ()=>$ee2c7f1cbdf52dcc$export$bee450b8c5830be2);
    $parcel$export(module.exports, "SET_BROWSER_HISTORY", ()=>$ee2c7f1cbdf52dcc$export$1d7cc3d04182cd55);
    $parcel$export(module.exports, "setMode", ()=>$ee2c7f1cbdf52dcc$export$d4f039427a1beff1);
    $parcel$export(module.exports, "setAnalyticsEvent", ()=>$ee2c7f1cbdf52dcc$export$e09b03f3b8c97b73);
    $parcel$export(module.exports, "setIsExportPreview", ()=>$ee2c7f1cbdf52dcc$export$313833c4b42ad868);
    const $ee2c7f1cbdf52dcc$export$27a86d4a6fd7f204 = 'state.domain.app.SET_MODE';
    const $ee2c7f1cbdf52dcc$export$2499970725b3d311 = 'state.domain.app.SET_ANALYTICS_EVENT';
    const $ee2c7f1cbdf52dcc$export$ec1035696f159a68 = 'state.domain.app.REPORT_INITIAL_LOAD_ANALYTICS';
    const $ee2c7f1cbdf52dcc$export$bee450b8c5830be2 = 'state.domain.app.SET_IS_EXPORT_PREVIEW';
    const $ee2c7f1cbdf52dcc$export$1d7cc3d04182cd55 = 'state.domain.app.SET_BROWSER_HISTORY';
    const $ee2c7f1cbdf52dcc$export$d4f039427a1beff1 = (payload)=>({
            type: $ee2c7f1cbdf52dcc$export$27a86d4a6fd7f204,
            payload: payload
        });
    const $ee2c7f1cbdf52dcc$export$e09b03f3b8c97b73 = (payload)=>({
            type: $ee2c7f1cbdf52dcc$export$2499970725b3d311,
            payload: payload
        });
    const $ee2c7f1cbdf52dcc$export$6a8af29705a96449 = ()=>({
            type: $ee2c7f1cbdf52dcc$export$ec1035696f159a68
        });
    const $ee2c7f1cbdf52dcc$export$313833c4b42ad868 = (payload)=>({
            type: $ee2c7f1cbdf52dcc$export$bee450b8c5830be2,
            payload: payload
        });
    const $ee2c7f1cbdf52dcc$export$ed028cee82239b37 = (payload)=>({
            type: $ee2c7f1cbdf52dcc$export$1d7cc3d04182cd55,
            payload: payload
        });
});
parcelRegister("7vqYD", function(module, exports) {
    $parcel$export(module.exports, "SET_LATEST", ()=>$c63f558244adc45c$export$e102ab8a610053c9);
    $parcel$export(module.exports, "SET_VALIDITY", ()=>$c63f558244adc45c$export$6e6a82795d265bb3);
    $parcel$export(module.exports, "RESET", ()=>$c63f558244adc45c$export$4a991c87e640ef77);
    $parcel$export(module.exports, "SET_PROGRESS", ()=>$c63f558244adc45c$export$b1d6de4448cfb1e3);
    $parcel$export(module.exports, "setLatest", ()=>$c63f558244adc45c$export$94f0dfbac15ff20c);
    $parcel$export(module.exports, "setValidity", ()=>$c63f558244adc45c$export$aa2e5f48fa69b31d);
    $parcel$export(module.exports, "reset", ()=>$c63f558244adc45c$export$aad8462122ac592b);
    $parcel$export(module.exports, "setProgress", ()=>$c63f558244adc45c$export$e352b740a6841494);
    const $c63f558244adc45c$export$e102ab8a610053c9 = 'state.domain.solution.SET_LATEST';
    const $c63f558244adc45c$export$6e6a82795d265bb3 = 'state.domain.solution.SET_VALIDITY';
    const $c63f558244adc45c$export$4a991c87e640ef77 = 'state.domain.solution.RESET';
    const $c63f558244adc45c$export$b1d6de4448cfb1e3 = 'state.domain.solution.SET_PROGRESS';
    const $c63f558244adc45c$export$94f0dfbac15ff20c = (payload)=>({
            type: $c63f558244adc45c$export$e102ab8a610053c9,
            payload: payload
        });
    const $c63f558244adc45c$export$aa2e5f48fa69b31d = (payload)=>({
            type: $c63f558244adc45c$export$6e6a82795d265bb3,
            payload: payload
        });
    const $c63f558244adc45c$export$aad8462122ac592b = (payload)=>({
            type: $c63f558244adc45c$export$4a991c87e640ef77,
            payload: payload
        });
    const $c63f558244adc45c$export$e352b740a6841494 = (payload)=>({
            type: $c63f558244adc45c$export$b1d6de4448cfb1e3,
            payload: payload
        });
});
parcelRegister("fJ4u7", function(module, exports) {
    $parcel$export(module.exports, "SET_SHOW_ROLLED_UP_DATE", ()=>$83877072d7cf64b9$export$9f7a30c1cb755660);
    $parcel$export(module.exports, "SET_SHOW_ROLLED_UP_OTHERS", ()=>$83877072d7cf64b9$export$948b90af2ac6573c);
    $parcel$export(module.exports, "setShowRolledUpDates", ()=>$83877072d7cf64b9$export$df5b4cee0c3ae1b6);
    $parcel$export(module.exports, "setShowRolledUpOthers", ()=>$83877072d7cf64b9$export$41d403e9b16845fe);
    const $83877072d7cf64b9$export$9f7a30c1cb755660 = 'state.domain.view-settings.rollup-settings.SET_SHOW_ROLLED_UP_DATE';
    const $83877072d7cf64b9$export$948b90af2ac6573c = 'state.domain.view-settings.rollup-settings.SET_SHOW_ROLLED_UP_OTHERS';
    const $83877072d7cf64b9$export$df5b4cee0c3ae1b6 = (payload)=>({
            type: $83877072d7cf64b9$export$9f7a30c1cb755660,
            payload: payload
        });
    const $83877072d7cf64b9$export$41d403e9b16845fe = (payload)=>({
            type: $83877072d7cf64b9$export$948b90af2ac6573c,
            payload: payload
        });
});
parcelRegister("5lzYR", function(module, exports) {
    $parcel$export(module.exports, "TOGGLE_SHOW_WARNING", ()=>$92ce74f61364c340$export$d4ff2af774aef1c0);
    $parcel$export(module.exports, "RESET_SHOW_WARNING", ()=>$92ce74f61364c340$export$f8a9c3527c1ac902);
    $parcel$export(module.exports, "TOGGLE_WARNING_TYPE", ()=>$92ce74f61364c340$export$9907ee878c9466c3);
    $parcel$export(module.exports, "RESET_ENABLED_WARNING_TYPE", ()=>$92ce74f61364c340$export$a82954c4e1a6aa6);
    $parcel$export(module.exports, "toggleShowWarning", ()=>$92ce74f61364c340$export$7c9e001e736a253d);
    $parcel$export(module.exports, "toggleWarningByType", ()=>$92ce74f61364c340$export$1712432632037ce1);
    $parcel$export(module.exports, "resetEnabledWarningType", ()=>$92ce74f61364c340$export$940207be1e4e61ac);
    const $92ce74f61364c340$export$d4ff2af774aef1c0 = 'state.domain.view-settings.warning-settings.TOGGLE_SHOW_WARNING';
    const $92ce74f61364c340$export$f8a9c3527c1ac902 = 'state.domain.view-settings.warning-settings.RESET_SHOW_WARNING';
    const $92ce74f61364c340$export$9907ee878c9466c3 = 'state.domain.view-settings.warning-settings.TOGGLE_WARNING_TYPE';
    const $92ce74f61364c340$export$a82954c4e1a6aa6 = 'state.domain.view-settings.warning-settings.RESET_ENABLED_WARNING_TYPE';
    const $92ce74f61364c340$export$7c9e001e736a253d = ()=>({
            type: $92ce74f61364c340$export$d4ff2af774aef1c0
        });
    const $92ce74f61364c340$export$5403b06d3931daf7 = (payload)=>({
            type: $92ce74f61364c340$export$f8a9c3527c1ac902,
            payload: payload
        });
    const $92ce74f61364c340$export$1712432632037ce1 = (payload)=>({
            type: $92ce74f61364c340$export$9907ee878c9466c3,
            payload: payload
        });
    const $92ce74f61364c340$export$940207be1e4e61ac = (payload)=>({
            type: $92ce74f61364c340$export$a82954c4e1a6aa6,
            payload: payload
        });
});
parcelRegister("hfaJb", function(module, exports) {
    $parcel$export(module.exports, "SET_WARNINGS", ()=>$df2bd099413387e1$export$8078dd99bef6fdf);
    $parcel$export(module.exports, "setWarnings", ()=>$df2bd099413387e1$export$eb05c66a610b38c0);
    const $df2bd099413387e1$export$8078dd99bef6fdf = 'state.domain.warnings.SET_WARNINGS';
    const $df2bd099413387e1$export$eb05c66a610b38c0 = (payload)=>({
            type: $df2bd099413387e1$export$8078dd99bef6fdf,
            payload: payload
        });
});
parcelRegister("la6bP", function(module, exports) {
    $parcel$export(module.exports, "MISCONFIGURED_CHILDREN", ()=>$1e1eb1080def907c$export$54fe5a9205a0315e);
    $parcel$export(module.exports, "ENDS_AFTER_PARENT", ()=>$1e1eb1080def907c$export$4336de3d90bb2c49);
    $parcel$export(module.exports, "STARTS_BEFORE_PARENT", ()=>$1e1eb1080def907c$export$d4a7eb40b2206472);
    $parcel$export(module.exports, "TARGET_DATE_BEYOND_DUE_DATE", ()=>$1e1eb1080def907c$export$c65dfcaa2eb60c77);
    $parcel$export(module.exports, "NOT_CLOSED_BEYOND_TARGET_END_DATE", ()=>$1e1eb1080def907c$export$ee50b99467509c89);
    $parcel$export(module.exports, "IN_PROGRESS_BEYOND_INFERRED_TARGET_END_DATE", ()=>$1e1eb1080def907c$export$3b60c958072be00d);
    $parcel$export(module.exports, "TARGET_DATES_ARE_OUTSIDE_OF_SPRINT", ()=>$1e1eb1080def907c$export$9969a2bca1107f62);
    $parcel$export(module.exports, "ISSUE_ASSIGNED_KANBAN_TEAM_AND_SPRINT", ()=>$1e1eb1080def907c$export$5418cafbad534a1d);
    $parcel$export(module.exports, "START_DATE_AFTER_END_DATE", ()=>$1e1eb1080def907c$export$16447901e6388564);
    $parcel$export(module.exports, "UNKNOWN", ()=>$1e1eb1080def907c$export$78244dbb77cfa6b6);
    $parcel$export(module.exports, "NOT_FULLY_SCHEDULED", ()=>$1e1eb1080def907c$export$180c8c4e5ca7fc64);
    $parcel$export(module.exports, "HORIZON_REACHED", ()=>$1e1eb1080def907c$export$506c0966b2777a1b);
    $parcel$export(module.exports, "RELEASE_CONFLICT", ()=>$1e1eb1080def907c$export$baece8055553e2d7);
    $parcel$export(module.exports, "ASSIGNEE_IGNORED", ()=>$1e1eb1080def907c$export$eed6c64af2fd3b6c);
    $parcel$export(module.exports, "EXTERNAL_TEAM", ()=>$1e1eb1080def907c$export$4b43e7fa9e1cb022);
    $parcel$export(module.exports, "SUBTASK_VIOLATION", ()=>$1e1eb1080def907c$export$c895d8cb2e188887);
    $parcel$export(module.exports, "SUBTASK_ASSIGNMENT_VIOLATION", ()=>$1e1eb1080def907c$export$d29de877c56fd5f3);
    $parcel$export(module.exports, "SPRINT_EXCEEDED", ()=>$1e1eb1080def907c$export$82276ba4a3d599be);
    $parcel$export(module.exports, "INVALID_SPRINT", ()=>$1e1eb1080def907c$export$2903a36058b72b4b);
    $parcel$export(module.exports, "RELEASE_SHIFTED", ()=>$1e1eb1080def907c$export$88cbcab8a50f4112);
    $parcel$export(module.exports, "EARLIEST_START_IGNORED", ()=>$1e1eb1080def907c$export$6d3cb9de6cef8b94);
    $parcel$export(module.exports, "OVERBOOKED", ()=>$1e1eb1080def907c$export$e92bcd88cf28a567);
    $parcel$export(module.exports, "AVAILABILITY_VIOLATION", ()=>$1e1eb1080def907c$export$fdd4c22a8207c89b);
    $parcel$export(module.exports, "VIOLATION_IN_DEPENDENCY", ()=>$1e1eb1080def907c$export$bbb5754bfb57083e);
    $parcel$export(module.exports, "RESOURCE_LIMIT_VIOLATION", ()=>$1e1eb1080def907c$export$8116f921873c497f);
    $parcel$export(module.exports, "DEPENDENCIES_IGNORED_SPRINT", ()=>$1e1eb1080def907c$export$eca19cdcca121312);
    $parcel$export(module.exports, "DEPENDENCIES_IGNORED_RELEASE", ()=>$1e1eb1080def907c$export$9cadba489b70f1e1);
    $parcel$export(module.exports, "CYCLIC_DEPENDENCY", ()=>$1e1eb1080def907c$export$4c94664807496c52);
    $parcel$export(module.exports, "SUBTASK_CYCLIC_DEPENDENCY_IGNORED", ()=>$1e1eb1080def907c$export$dba3e57b5804782c);
    $parcel$export(module.exports, "SUBTASK_NO_SKILLED_RESOURCE", ()=>$1e1eb1080def907c$export$7373594db109755f);
    $parcel$export(module.exports, "MISSING_SKILLS", ()=>$1e1eb1080def907c$export$4e4875e1b4f24a3c);
    $parcel$export(module.exports, "TOO_SMALL_ESTIMATES", ()=>$1e1eb1080def907c$export$fee6d7a90f3c128d);
    $parcel$export(module.exports, "COMPLETED_PARENT", ()=>$1e1eb1080def907c$export$220707e5274a4e55);
    $parcel$export(module.exports, "CALCULATION_COMPLEXITY", ()=>$1e1eb1080def907c$export$a47259b29ac2584a);
    $parcel$export(module.exports, "WARNING_TYPE_NUMBER_MAP", ()=>$1e1eb1080def907c$export$6e3885125caa57e8);
    $parcel$export(module.exports, "WARNING_CENTER_AVAILABLE_TYPES", ()=>$1e1eb1080def907c$export$6a7c7b701dd98e87);
    const $1e1eb1080def907c$export$54fe5a9205a0315e = 'state.warnings.MISCONFIGURED_CHILDREN';
    const $1e1eb1080def907c$export$4336de3d90bb2c49 = 'state.warnings.ENDS_AFTER_PARENT';
    const $1e1eb1080def907c$export$d4a7eb40b2206472 = 'state.warnings.STARTS_BEFORE_PARENT';
    const $1e1eb1080def907c$export$dfdca0491979cec5 = 'state.warnings.IGNORES_DEPENDENCY';
    const $1e1eb1080def907c$export$fe60411ab692631e = 'state.warnings.DEPENDENCIES_SHARE_SPRINT';
    const $1e1eb1080def907c$export$c65dfcaa2eb60c77 = 'state.warnings.TARGET_DATE_BEYOND_DUE_DATE';
    const $1e1eb1080def907c$export$ee50b99467509c89 = 'state.warnings.NOT_CLOSED_BEYOND_TARGET_END_DATE';
    const $1e1eb1080def907c$export$3b60c958072be00d = 'state.warnings.IN_PROGRESS_BEYOND_INFERRED_TARGET_END_DATE';
    const $1e1eb1080def907c$export$9969a2bca1107f62 = 'state.warnings.TARGET_DATES_ARE_OUTSIDE_OF_SPRINT';
    const $1e1eb1080def907c$export$5418cafbad534a1d = 'state.warnings.ISSUE_ASSIGNED_KANBAN_TEAM_AND_SPRINT';
    const $1e1eb1080def907c$export$16447901e6388564 = 'state.warnings.START_DATE_AFTER_END_DATE';
    const $1e1eb1080def907c$export$78244dbb77cfa6b6 = 'state.warnings.UNKNOWN';
    const $1e1eb1080def907c$export$180c8c4e5ca7fc64 = 'state.warnings.NOT_FULLY_SCHEDULED';
    const $1e1eb1080def907c$export$506c0966b2777a1b = 'state.warnings.HORIZON_REACHED';
    const $1e1eb1080def907c$export$baece8055553e2d7 = 'state.warnings.RELEASE_CONFLICT';
    const $1e1eb1080def907c$export$eed6c64af2fd3b6c = 'state.warnings.ASSIGNEE_IGNORED';
    const $1e1eb1080def907c$export$4b43e7fa9e1cb022 = 'state.warnings.EXTERNAL_TEAM';
    const $1e1eb1080def907c$export$c895d8cb2e188887 = 'state.warnings.SUBTASK_VIOLATION';
    const $1e1eb1080def907c$export$d29de877c56fd5f3 = 'state.warnings.SUBTASK_ASSIGNMENT_VIOLATION';
    const $1e1eb1080def907c$export$82276ba4a3d599be = 'state.warnings.SPRINT_EXCEEDED';
    const $1e1eb1080def907c$export$2903a36058b72b4b = 'state.warnings.INVALID_SPRINT';
    const $1e1eb1080def907c$export$88cbcab8a50f4112 = 'state.warnings.RELEASE_SHIFTED';
    const $1e1eb1080def907c$export$6d3cb9de6cef8b94 = 'state.warnings.EARLIEST_START_IGNORED';
    const $1e1eb1080def907c$export$e92bcd88cf28a567 = 'state.warnings.OVERBOOKED';
    const $1e1eb1080def907c$export$fdd4c22a8207c89b = 'state.warnings.AVAILABILITY_VIOLATION';
    const $1e1eb1080def907c$export$bbb5754bfb57083e = 'state.warnings.VIOLATION_IN_DEPENDENCY';
    const $1e1eb1080def907c$export$8116f921873c497f = 'state.warnings.RESOURCE_LIMIT_VIOLATION';
    const $1e1eb1080def907c$export$eca19cdcca121312 = 'state.warnings.DEPENDENCIES_IGNORED_SPRINT';
    const $1e1eb1080def907c$export$9cadba489b70f1e1 = 'state.warnings.DEPENDENCIES_IGNORED_RELEASE';
    const $1e1eb1080def907c$export$4c94664807496c52 = 'state.warnings.CYCLIC_DEPENDENCY';
    const $1e1eb1080def907c$export$dba3e57b5804782c = 'state.warnings.SUBTASK_CYCLIC_DEPENDENCY_IGNORED';
    const $1e1eb1080def907c$export$7373594db109755f = 'state.warnings.SUBTASK_NO_SKILLED_RESOURCE';
    const $1e1eb1080def907c$export$4e4875e1b4f24a3c = 'state.warnings.MISSING_SKILLS';
    const $1e1eb1080def907c$export$fee6d7a90f3c128d = 'state.warnings.TOO_SMALL_ESTIMATES';
    const $1e1eb1080def907c$export$220707e5274a4e55 = 'state.warnings.COMPLETED_PARENT';
    const $1e1eb1080def907c$export$a47259b29ac2584a = 'state.warnings.CALCULATION_COMPLEXITY';
    const $1e1eb1080def907c$export$6e3885125caa57e8 = {
        [$1e1eb1080def907c$export$c65dfcaa2eb60c77]: 1,
        [$1e1eb1080def907c$export$9969a2bca1107f62]: 2,
        [$1e1eb1080def907c$export$ee50b99467509c89]: 3,
        [$1e1eb1080def907c$export$4336de3d90bb2c49]: 5,
        [$1e1eb1080def907c$export$d4a7eb40b2206472]: 6,
        [$1e1eb1080def907c$export$5418cafbad534a1d]: 7
    };
    const $1e1eb1080def907c$export$6a7c7b701dd98e87 = [
        $1e1eb1080def907c$export$54fe5a9205a0315e,
        $1e1eb1080def907c$export$4336de3d90bb2c49,
        $1e1eb1080def907c$export$d4a7eb40b2206472,
        $1e1eb1080def907c$export$dfdca0491979cec5,
        $1e1eb1080def907c$export$fe60411ab692631e,
        $1e1eb1080def907c$export$c65dfcaa2eb60c77,
        $1e1eb1080def907c$export$ee50b99467509c89,
        $1e1eb1080def907c$export$3b60c958072be00d,
        $1e1eb1080def907c$export$9969a2bca1107f62,
        $1e1eb1080def907c$export$5418cafbad534a1d
    ];
});
parcelRegister("qjIxt", function(module, exports) {
    $parcel$export(module.exports, "WarningTypes", ()=>$5849e6d87e4db221$export$b3c1ed7ac13a6caf);
    $parcel$export(module.exports, "calculateAllWarnings", ()=>$5849e6d87e4db221$export$75bc8fa5816784a7);
    var $jVZZA;
    var $76p2G;
    var $fZhYM;
    var $2rMKg;
    var $6nTyZ;
    var $4R6GH;
    var $flnZx;
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ljmcc = parcelRequire("ljmcc");
    var $6TEBn = parcelRequire("6TEBn");
    var $la6bP = parcelRequire("la6bP");
    var $l14aI = parcelRequire("l14aI");
    const $5849e6d87e4db221$export$b3c1ed7ac13a6caf = {
        [(0, $la6bP.TARGET_DATE_BEYOND_DUE_DATE)]: {
            header: (0, $l14aI.headerMessages).dateAfterDueDate,
            description: (0, $l14aI.detailedSummaryMessages).targetDateBeyondDueDate
        },
        [(0, $la6bP.TARGET_DATES_ARE_OUTSIDE_OF_SPRINT)]: {
            header: (0, $l14aI.headerMessages).issueScheduledOutsideOfSprint,
            description: (0, $l14aI.detailedSummaryMessages).targetDateOutsideOfSprint
        },
        [(0, $la6bP.IN_PROGRESS_BEYOND_INFERRED_TARGET_END_DATE)]: {
            header: (0, $l14aI.headerMessages).openIssuePastInferredEndDate,
            description: (0, $l14aI.detailedSummaryMessages).inProgressBeyondInferredTargetEndDate
        },
        [(0, $la6bP.NOT_CLOSED_BEYOND_TARGET_END_DATE)]: {
            header: (0, $l14aI.headerMessages).openIssuePastAssignedEndDate,
            description: (0, $l14aI.detailedSummaryMessages).notClosedBeyondTargetEndDate
        },
        [(0, $la6bP.ENDS_AFTER_PARENT)]: {
            header: (0, $l14aI.headerMessages).childIssueEndsAfterParent,
            description: (0, $l14aI.detailedSummaryMessages).endsAfterParent
        },
        [(0, $la6bP.STARTS_BEFORE_PARENT)]: {
            header: (0, $l14aI.headerMessages).childIssueStartsBeforeParent,
            description: (0, $l14aI.detailedSummaryMessages).startsBeforeParent
        },
        [(0, $la6bP.ISSUE_ASSIGNED_KANBAN_TEAM_AND_SPRINT)]: {
            header: (0, $l14aI.headerMessages).kanbanIssueAssignedToSprint,
            description: (0, $l14aI.detailedSummaryMessages).issueAssignedKanbanTeamAndSprint
        },
        [(0, $la6bP.START_DATE_AFTER_END_DATE)]: {
            header: (0, $l14aI.headerMessages).startDateAfterEndDate,
            description: (0, $l14aI.detailedSummaryMessages).startDateAfterEndDate
        }
    };
    const $5849e6d87e4db221$export$3d3e5150e65ef8c9 = Object.keys($5849e6d87e4db221$export$b3c1ed7ac13a6caf);
    const $5849e6d87e4db221$var$periodBetween = (a, b)=>{
        const lo = Math.min(a, b);
        const hi = Math.max(a, b);
        const millis = hi - lo;
        const days = Math.ceil(millis / (0, (0, parcelRequire("flnZx")).ONE_DAY));
        if (days < 7) return {
            key: (0, $l14aI.shortDateMessages).days,
            days: days
        };
        const weeks = Math.floor(days / 7);
        if (weeks < 4) return {
            key: (0, $l14aI.shortDateMessages).weeks,
            weeks: weeks
        };
        const months = Math.ceil(days / 365 * 12);
        if (months < 12) return {
            key: (0, $l14aI.shortDateMessages).months,
            months: months
        };
        const years = Math.ceil(months / 12);
        return {
            key: (0, $l14aI.shortDateMessages).years,
            years: years
        };
    };
    const $5849e6d87e4db221$export$3162886456acb148 = (issuesById, warningsByIssue)=>{
        const transitiveIssueIds = {};
        for (const [issueId, existingWarnings] of (0, parcelRequire("6nTyZ")).default(warningsByIssue))if (existingWarnings && existingWarnings.length !== 0) {
            const issue = issuesById[issueId];
            const parent = issue && issue.parent && issuesById[issue.parent];
            if (parent) transitiveIssueIds[parent.id] = true;
        }
        for (const id of (0, parcelRequire("76p2G")).default(transitiveIssueIds)){
            let issue = issuesById[id];
            while(issue){
                transitiveIssueIds[issue.id] = true;
                issue = issuesById[issue.parent || ''];
            }
        }
        for (const id of (0, parcelRequire("76p2G")).default(transitiveIssueIds)){
            const warnings = warningsByIssue[id];
            if (warnings && warnings.length !== 0) delete transitiveIssueIds[id];
        }
        return (0, parcelRequire("76p2G")).default(transitiveIssueIds);
    };
    const $5849e6d87e4db221$var$processWarnings = (issuesById, warningsByIssue, allWarningsByIssue)=>({
            byIssue: warningsByIssue,
            transitiveIssueIds: $5849e6d87e4db221$export$3162886456acb148(issuesById, warningsByIssue),
            allWarningsByIssue: allWarningsByIssue
        });
    const $5849e6d87e4db221$var$staticWarning = (type, header, message)=>({
            type: type,
            header: header,
            message: message,
            messageValues: {}
        });
    const $5849e6d87e4db221$var$STATIC_SCHEDULE_WARNINGS = {
        'not-fully-scheduled': $5849e6d87e4db221$var$staticWarning((0, $la6bP.NOT_FULLY_SCHEDULED), (0, $l14aI.headerMessages).notFullyScheduled, (0, $l14aI.bodyMessages).notFullyScheduled),
        'horizon-reached': $5849e6d87e4db221$var$staticWarning((0, $la6bP.HORIZON_REACHED), (0, $l14aI.headerMessages).horizonReached, (0, $l14aI.bodyMessages).horizonReached),
        'release-shifted': $5849e6d87e4db221$var$staticWarning((0, $la6bP.RELEASE_SHIFTED), (0, $l14aI.headerMessages).releaseShifted, (0, $l14aI.bodyMessages).releaseShifted),
        'release-conflict': $5849e6d87e4db221$var$staticWarning((0, $la6bP.RELEASE_CONFLICT), (0, $l14aI.headerMessages).releaseConflict, (0, $l14aI.bodyMessages).releaseConflict),
        'assignee-ignored': $5849e6d87e4db221$var$staticWarning((0, $la6bP.ASSIGNEE_IGNORED), (0, $l14aI.headerMessages).assigneeIgnored, (0, $l14aI.bodyMessages).assigneeIgnored),
        'external-team': $5849e6d87e4db221$var$staticWarning((0, $la6bP.EXTERNAL_TEAM), (0, $l14aI.headerMessages).externalTeam, (0, $l14aI.bodyMessages).externalTeam),
        'subtask-violation': $5849e6d87e4db221$var$staticWarning((0, $la6bP.SUBTASK_VIOLATION), (0, $l14aI.headerMessages).subtaskViolation, (0, $l14aI.bodyMessages).subtaskViolation),
        'subtask-assignment-violation': $5849e6d87e4db221$var$staticWarning((0, $la6bP.SUBTASK_ASSIGNMENT_VIOLATION), (0, $l14aI.headerMessages).subtaskAssignmentViolation, (0, $l14aI.bodyMessages).subtaskAssignmentViolation),
        'sprint-exceeded': $5849e6d87e4db221$var$staticWarning((0, $la6bP.SPRINT_EXCEEDED), (0, $l14aI.headerMessages).sprintExceeded, (0, $l14aI.bodyMessages).sprintExceeded),
        'invalid-sprint': $5849e6d87e4db221$var$staticWarning((0, $la6bP.INVALID_SPRINT), (0, $l14aI.headerMessages).invalidSprint, (0, $l14aI.bodyMessages).invalidSprint),
        'earliest-start-ignored': $5849e6d87e4db221$var$staticWarning((0, $la6bP.EARLIEST_START_IGNORED), (0, $l14aI.headerMessages).earliestStartIgnored, (0, $l14aI.bodyMessages).earliestStartIgnored),
        overbooked: $5849e6d87e4db221$var$staticWarning((0, $la6bP.OVERBOOKED), (0, $l14aI.headerMessages).overbooked, (0, $l14aI.bodyMessages).overbooked),
        'availability-violation': $5849e6d87e4db221$var$staticWarning((0, $la6bP.AVAILABILITY_VIOLATION), (0, $l14aI.headerMessages).availabilityViolation, (0, $l14aI.bodyMessages).availabilityViolation),
        'violation-in-dependency': $5849e6d87e4db221$var$staticWarning((0, $la6bP.VIOLATION_IN_DEPENDENCY), (0, $l14aI.headerMessages).violationInDependency, (0, $l14aI.bodyMessages).violationInDependency),
        'resource-limit-violation': $5849e6d87e4db221$var$staticWarning((0, $la6bP.RESOURCE_LIMIT_VIOLATION), (0, $l14aI.headerMessages).resourceLimitViolation, (0, $l14aI.bodyMessages).resourceLimitViolation),
        'dependencies-ignored-sprint': $5849e6d87e4db221$var$staticWarning((0, $la6bP.DEPENDENCIES_IGNORED_SPRINT), (0, $l14aI.headerMessages).dependenciesIgnoredSprint, (0, $l14aI.bodyMessages).dependenciesIgnoredSprint),
        'dependencies-ignored-release': $5849e6d87e4db221$var$staticWarning((0, $la6bP.DEPENDENCIES_IGNORED_RELEASE), (0, $l14aI.headerMessages).dependenciesIgnoredRelease, (0, $l14aI.bodyMessages).dependenciesIgnoredRelease),
        'cyclic-dependency': $5849e6d87e4db221$var$staticWarning((0, $la6bP.CYCLIC_DEPENDENCY), (0, $l14aI.headerMessages).cyclicDependency, (0, $l14aI.bodyMessages).cyclicDependency),
        'subtask-cyclic-dependency-ignored': $5849e6d87e4db221$var$staticWarning((0, $la6bP.SUBTASK_CYCLIC_DEPENDENCY_IGNORED), (0, $l14aI.headerMessages).subtaskCyclicDependencyIgnored, (0, $l14aI.bodyMessages).subtaskCyclicDependencyIgnored),
        'subtask-no-skilled-resource': $5849e6d87e4db221$var$staticWarning((0, $la6bP.SUBTASK_NO_SKILLED_RESOURCE), (0, $l14aI.headerMessages).subtaskNoSkilledResource, (0, $l14aI.bodyMessages).subtaskNoSkilledResource),
        'missing-skills': $5849e6d87e4db221$var$staticWarning((0, $la6bP.MISSING_SKILLS), (0, $l14aI.headerMessages).missingSkills, (0, $l14aI.bodyMessages).missingSkills),
        'too-small-estimates': $5849e6d87e4db221$var$staticWarning((0, $la6bP.TOO_SMALL_ESTIMATES), (0, $l14aI.headerMessages).tooSmallEstimates, (0, $l14aI.bodyMessages).tooSmallEstimates),
        'completed-parent': $5849e6d87e4db221$var$staticWarning((0, $la6bP.COMPLETED_PARENT), (0, $l14aI.headerMessages).completedParent, (0, $l14aI.bodyMessages).completedParent),
        'calculation-complexity': $5849e6d87e4db221$var$staticWarning((0, $la6bP.CALCULATION_COMPLEXITY), (0, $l14aI.headerMessages).calculationComplexity, (0, $l14aI.bodyMessages).calculationComplexity)
    };
    const $5849e6d87e4db221$var$mapAnnotationToWarning = ({ type: type })=>{
        const warning = $5849e6d87e4db221$var$STATIC_SCHEDULE_WARNINGS[type];
        if (warning) return warning;
        return {
            type: (0, $la6bP.UNKNOWN),
            header: (0, $l14aI.headerMessages).unknown,
            message: (0, $l14aI.bodyMessages).unknown,
            messageValues: {}
        };
    };
    const $5849e6d87e4db221$var$extractSchedulerWarnings = (warningsByIssue, allWarningsByIssue, issues)=>{
        for (const { id: id, annotations: annotations } of issues){
            if (annotations && annotations.length) for (const annotation of annotations || []){
                const warning = $5849e6d87e4db221$var$mapAnnotationToWarning(annotation);
                $5849e6d87e4db221$var$addWarningToHash(warningsByIssue, id, warning);
                $5849e6d87e4db221$var$addWarningToHash(allWarningsByIssue, id, warning);
            }
        }
    };
    const $5849e6d87e4db221$var$addWarningToHash = (warningIssueHash, issueId, warning)=>{
        if (!warningIssueHash[issueId]) warningIssueHash[issueId] = [];
        warningIssueHash[issueId].push(warning);
    };
    const $5849e6d87e4db221$export$75bc8fa5816784a7 = ({ isSolutionValid: isSolutionValid, mode: mode, issues: issues, projects: projects, sprints: sprints, issueStatuses: issueStatuses, sprintsWithFutureDates: sprintsWithFutureDates, plan: plan, disabledWarnings: disabledWarnings, teamsById: teamsById })=>{
        const warningsByIssue = {};
        const allWarningsByIssue = {};
        const idProp = (0, parcelRequire("2rMKg")).default('id');
        const projectsById = (0, $4nDwW.indexBy)(idProp, projects);
        const sprintsById = (0, $4nDwW.indexBy)(idProp, sprints);
        const issueStatusesById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), issueStatuses);
        const isCompletedIssueStatuses = (0, parcelRequire("jVZZA")).default((status)=>status.categoryId === (0, $TTKUQ.ISSUE_STATUS_CATEGORIES).DONE, issueStatusesById);
        const isNotDone = (issue)=>!isCompletedIssueStatuses[issue.status || ''];
        const addWarning = (issueId, type, header, message, messageValues, autoResolvePayload)=>{
            const warning = {
                type: type,
                header: header,
                message: message,
                messageValues: messageValues,
                autoResolvePayload: autoResolvePayload
            };
            $5849e6d87e4db221$var$addWarningToHash(allWarningsByIssue, issueId, warning);
            if (!disabledWarnings.includes(type)) $5849e6d87e4db221$var$addWarningToHash(warningsByIssue, issueId, warning);
        };
        const now = Date.now();
        const undone = (0, parcelRequire("jVZZA")).default(isNotDone, issues);
        const issuesById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), undone);
        if (mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771)) {
            if (isSolutionValid) $5849e6d87e4db221$var$extractSchedulerWarnings(warningsByIssue, allWarningsByIssue, issues);
            return $5849e6d87e4db221$var$processWarnings(issuesById, warningsByIssue, allWarningsByIssue);
        }
        const key = (issue)=>{
            const project = projectsById[issue.project];
            const issueKey = issue.issueKey;
            if (project && project.key && issueKey) return `${project.key}-${issueKey}`;
            return issue.summary;
        };
        for (const issue of undone){
            const id = issue.id;
            const parent = issue.parent && issuesById[issue.parent];
            const issueStatusCategory = (0, parcelRequire("fZhYM")).default([
                issue.status || '',
                'categoryId'
            ], issueStatusesById);
            const sprint = issue.sprint ? sprintsById[issue.sprint] : null;
            if (sprint) {
                if (issue.team && teamsById[issue.team]) {
                    const team = teamsById[issue.team];
                    if (team.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).kanban) addWarning(id, (0, $la6bP.ISSUE_ASSIGNED_KANBAN_TEAM_AND_SPRINT), (0, $l14aI.headerMessages).kanbanIssueAssignedToSprint, (0, $l14aI.bodyMessages).issueAssignedKanbanTeamAndSprint, {});
                }
            }
            if ((0, $4nDwW.isDefined)(issue.dueDate)) {
                const endOfDayDueDate = (0, (0, parcelRequire("flnZx")).endOfUtcDay)(issue.dueDate);
                const isConfiguredAsDueDate = [
                    plan.baselineStartField,
                    plan.baselineEndField
                ].some((field)=>field.key === 'dueDate' && field.type === (0, $5fACX.DATEFIELD_TYPES).BUILT_IN);
                if (!isConfiguredAsDueDate) {
                    if ((0, $4nDwW.isDefined)(issue.baselineEnd) && issue.baselineEnd > endOfDayDueDate || (0, $4nDwW.isDefined)(issue.baselineStart) && issue.baselineStart > endOfDayDueDate) addWarning(id, (0, $la6bP.TARGET_DATE_BEYOND_DUE_DATE), (0, $l14aI.headerMessages).dateAfterDueDate, (0, $l14aI.bodyMessages).dateBeyondDueDate, {});
                }
                if ((0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline')) {
                    const dueDateIsBaselineEndField = plan.baselineEndField.key === 'dueDate' && plan.baselineEndField.type === (0, $5fACX.DATEFIELD_TYPES).BUILT_IN;
                    if (dueDateIsBaselineEndField && (0, $4nDwW.isDefined)(issue.baselineStart) && issue.baselineStart > endOfDayDueDate) addWarning(id, (0, $la6bP.START_DATE_AFTER_END_DATE), (0, $l14aI.headerMessages).startDateAfterEndDate, (0, $l14aI.bodyMessages).startDateAfterEndDate, {});
                }
            }
            if ((0, $4nDwW.isDefined)(issue.targetEnd) && (0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline')) {
                const endOfDayTargetEnd = (0, (0, parcelRequire("flnZx")).endOfUtcDay)(issue.targetEnd);
                const targetEndIsBaselineEndField = plan.baselineEndField.key === 'targetEnd' && plan.baselineEndField.type === (0, $5fACX.DATEFIELD_TYPES).BUILT_IN;
                if (targetEndIsBaselineEndField && (0, $4nDwW.isDefined)(issue.baselineStart) && issue.baselineStart > endOfDayTargetEnd) addWarning(id, (0, $la6bP.START_DATE_AFTER_END_DATE), (0, $l14aI.headerMessages).startDateAfterEndDate, (0, $l14aI.bodyMessages).startDateAfterEndDate, {});
            }
            if ((0, $4nDwW.isDefined)(issue.targetStart) && (0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline')) {
                const endOfDayTargetStart = (0, (0, parcelRequire("flnZx")).endOfUtcDay)(issue.targetStart);
                const targetStartIsBaselineEndField = plan.baselineEndField.key === 'targetStart' && plan.baselineEndField.type === (0, $5fACX.DATEFIELD_TYPES).BUILT_IN;
                if (targetStartIsBaselineEndField && (0, $4nDwW.isDefined)(issue.baselineStart) && issue.baselineStart > endOfDayTargetStart) addWarning(id, (0, $la6bP.START_DATE_AFTER_END_DATE), (0, $l14aI.headerMessages).startDateAfterEndDate, (0, $l14aI.bodyMessages).startDateAfterEndDate, {});
            }
            const sprints = (0, $ljmcc.getFutureSprintsForIssue)(issue, sprintsWithFutureDates);
            if (issue.sprint && sprints.length > 0 && ((0, $4nDwW.isDefined)(issue.baselineStart) || (0, $4nDwW.isDefined)(issue.baselineEnd))) {
                const sprintDates = (0, $6TEBn.getTargetDatesFromSprints)(issue, sprints);
                if ((0, $4nDwW.isDefined)(issue.baselineStart) && sprintDates.rawEndDate && issue.baselineStart > sprintDates.rawEndDate || (0, $4nDwW.isDefined)(issue.baselineEnd) && sprintDates.rawStartDate && issue.baselineEnd < sprintDates.rawStartDate) addWarning(id, (0, $la6bP.TARGET_DATES_ARE_OUTSIDE_OF_SPRINT), (0, $l14aI.headerMessages).issueScheduledOutsideOfSprint, (0, $l14aI.bodyMessages).dateOutsideOfSprint, {});
            }
            const end = issue.baselineEnd;
            if ((0, $4nDwW.isDefined)(end)) {
                const isInferred = issue.inferred && issue.inferred.baselineEnd;
                if (isInferred && now > end && issueStatusCategory === (0, $TTKUQ.ISSUE_STATUS_CATEGORIES).INPROGRESS) addWarning(id, (0, $la6bP.IN_PROGRESS_BEYOND_INFERRED_TARGET_END_DATE), (0, $l14aI.headerMessages).openIssuePastInferredEndDate, (0, $l14aI.bodyMessages).inProgressBeyondInferredEndDate, {
                    issue: key(issue)
                });
                if (!isInferred && now > end && (!issue.status || isNotDone(issue))) addWarning(id, (0, $la6bP.NOT_CLOSED_BEYOND_TARGET_END_DATE), (0, $l14aI.headerMessages).openIssuePastAssignedEndDate, (0, $l14aI.bodyMessages).notClosedBeyondEndDate, {});
            }
            if (parent) {
                const parentStart = parent.baselineStart;
                const parentEnd = parent.baselineEnd;
                const issueStart = issue.baselineStart;
                const issueEnd = issue.baselineEnd;
                if ((0, $4nDwW.isDefined)(parentEnd) && (0, $4nDwW.isDefined)(issueEnd) && parentEnd < issueEnd) addWarning(id, (0, $la6bP.ENDS_AFTER_PARENT), (0, $l14aI.headerMessages).childIssueEndsAfterParent, (0, $l14aI.bodyMessages).endsAfterParent, {
                    issue: key(issue),
                    parent: key(parent),
                    amount: $5849e6d87e4db221$var$periodBetween(parentEnd, issueEnd)
                }, {
                    issueId: parent.id,
                    end: issueEnd
                });
                if (parentStart && issueStart && parentStart > issueStart) addWarning(id, (0, $la6bP.STARTS_BEFORE_PARENT), (0, $l14aI.headerMessages).childIssueStartsBeforeParent, (0, $l14aI.bodyMessages).startsBeforeParent, {
                    issue: key(issue),
                    parent: key(parent),
                    amount: $5849e6d87e4db221$var$periodBetween(issueStart, parentStart)
                }, {
                    issueId: parent.id,
                    start: issueStart
                });
            }
        }
        return $5849e6d87e4db221$var$processWarnings(issuesById, warningsByIssue, allWarningsByIssue);
    };
});
parcelRegister("l14aI", function(module, exports) {
    $parcel$export(module.exports, "shortDateMessages", ()=>$eba0fcee01f2ae5a$export$22643896e174d0a1);
    $parcel$export(module.exports, "headerMessages", ()=>$eba0fcee01f2ae5a$export$266853a8c4c67815);
    $parcel$export(module.exports, "detailedSummaryMessages", ()=>$eba0fcee01f2ae5a$export$d28e0cd4ecb13f93);
    $parcel$export(module.exports, "bodyMessages", ()=>$eba0fcee01f2ae5a$export$daf59e8556d24858);
    var $7VHMR;
    const $eba0fcee01f2ae5a$export$22643896e174d0a1 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        days: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.days",
            "defaultMessage": "{days}d"
        },
        weeks: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.weeks",
            "defaultMessage": "{weeks}w"
        },
        months: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.months",
            "defaultMessage": "{months}m"
        },
        years: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.years",
            "defaultMessage": "{years}y"
        },
        notClosedBeyondTargetEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.not-closed-beyond-target-end-date",
            "defaultMessage": "This issue is still unresolved after the target end date. Check if the status needs updating, or if more time is needed for the issue."
        }
    });
    const $eba0fcee01f2ae5a$export$266853a8c4c67815 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        misconfiguredChildren: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.misconfigured-children",
            "defaultMessage": "Children have warnings"
        },
        childIssueEndsAfterParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.child-issue-ends-after-parent",
            "defaultMessage": "Child issue ends after its parent issue"
        },
        childIssueStartsBeforeParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.child-issue-starts-before-parent",
            "defaultMessage": "Child issue starts before its parent issue"
        },
        dateAfterDueDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.date-after-due-date",
            "defaultMessage": "Issue starts or ends after its due date"
        },
        openIssuePastInferredEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.open-issue-past-inferred-end-date",
            "defaultMessage": "Open issue has passed its inferred end date"
        },
        openIssuePastAssignedEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.open-issue-past-assigned-end-date",
            "defaultMessage": "Open issue has passed its assigned end date"
        },
        issueScheduledOutsideOfSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.issue-scheduled-outside-of-sprint",
            "defaultMessage": "Issue scheduled outside of its assigned sprint"
        },
        kanbanIssueAssignedToSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.kanban-issue-assigned-to-sprint",
            "defaultMessage": "Kanban issue assigned to a sprint"
        },
        startDateAfterEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.start-date-after-end-date",
            "defaultMessage": "Issue start date is after its end date"
        },
        unknown: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.unknown",
            "defaultMessage": "There was an error during scheduling"
        },
        notFullyScheduled: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.not-fully-scheduled",
            "defaultMessage": "This issue is partially scheduled because the assigned people have limited availability"
        },
        horizonReached: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.horizon-reached",
            "defaultMessage": "Your schedule can't be calculated properly because it exceeds the planning horizon"
        },
        releaseConflict: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.release-conflict",
            "defaultMessage": "This issue can't be scheduled because this issue and its sub-tasks are assigned to different releases"
        },
        assigneeIgnored: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.assignee-ignored",
            "defaultMessage": "This issue's assignee is ignored because they aren't part of the plan"
        },
        externalTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.external-team",
            "defaultMessage": "This issue can't be scheduled properly because the assigned team isn't present in your plan"
        },
        subtaskViolation: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.subtask-violation",
            "defaultMessage": "Problem in sub-task"
        },
        subtaskAssignmentViolation: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.subtask-assignment-violation",
            "defaultMessage": "This issue can't be scheduled because this issue and its sub-tasks are assigned to different teams"
        },
        sprintExceeded: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.sprint-exceeded",
            "defaultMessage": "More than one sprint is needed to finish this issue"
        },
        invalidSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.invalid-sprint",
            "defaultMessage": "Item ignored"
        },
        releaseShifted: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.release-shifted",
            "defaultMessage": "Release start date shifted."
        },
        earliestStartIgnored: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.earliest-start-ignored",
            "defaultMessage": "This issue's earliest start date is ignored because of its sprint assignment"
        },
        overbooked: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.overbooked",
            "defaultMessage": "The people working on this issue are overbooked for this sprint"
        },
        availabilityViolation: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.availability-violation",
            "defaultMessage": "This issue can't be scheduled because no one is available"
        },
        resourceLimitViolation: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.resource-limit-violation",
            "defaultMessage": "Resource limit violation"
        },
        violationInDependency: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.violation-in-dependency",
            "defaultMessage": "Violation in dependency."
        },
        dependenciesIgnoredRelease: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.dependencies-ignored-release",
            "defaultMessage": "Dependencies ignored"
        },
        dependenciesIgnoredSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.dependencies-ignored-sprint",
            "defaultMessage": "Dependencies ignored"
        },
        cyclicDependency: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.cyclic-dependency",
            "defaultMessage": "This issue can't be scheduled due to a cyclic dependency"
        },
        subtaskCyclicDependencyIgnored: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.subtask-cyclic-dependency-ignored",
            "defaultMessage": "We can't process dependencies between sub-tasks within a single issue. Remove these dependencies on this issue and then auto-schedule your plan."
        },
        subtaskNoSkilledResource: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.subtask-no-skilled-resource",
            "defaultMessage": "This sub-task can't be scheduled because no available single team member has the required skill set"
        },
        missingSkills: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.missing-skills",
            "defaultMessage": "This issue can't be scheduled because the available team members don't have the required skill set"
        },
        tooSmallEstimates: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.too-small-estimates",
            "defaultMessage": "This issue can't be scheduled because this issue's estimate is too small"
        },
        completedParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.completed-parent",
            "defaultMessage": "Parent item marked as done"
        },
        calculationComplexity: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.calculation-complexity",
            "defaultMessage": "This issue can't be scheduled because the calculation is too complex"
        }
    });
    const $eba0fcee01f2ae5a$export$d28e0cd4ecb13f93 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        targetDateBeyondDueDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.target-date-beyond-due-date",
            "defaultMessage": "One or both of the target dates for this issue are set after the due date. Either update the due date, or set the target dates to on or before the due date."
        },
        targetDateOutsideOfSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.target-date-outside-of-sprint",
            "defaultMessage": "The target dates of the issue fall outside of the assigned sprint"
        },
        notClosedBeyondTargetEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.not-closed-beyond-target-end-date",
            "defaultMessage": "This issue is still unresolved after the target end date. Check if the status needs updating, or if more time is needed for the issue."
        },
        inProgressBeyondInferredTargetEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.in-progress-beyond-inferred-target-end-date",
            "defaultMessage": "This issue is still unresolved after its end date. Consider moving the status back to To do, or adding the issue to a current or future sprint, or rescheduling the issue to a later end date."
        },
        endsAfterParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.ends-after-parent",
            "defaultMessage": "A child issue ends after its parent issue"
        },
        startsBeforeParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.starts-before-parent",
            "defaultMessage": "A child issue starts before its parent issue"
        },
        issueAssignedKanbanTeamAndSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.issue-assigned-kanban-team-and-sprint",
            "defaultMessage": "Sprints should only be associated with Scrum teams."
        },
        startDateAfterEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.start-date-after-end-date",
            "defaultMessage": "The start date for this issue is set after the end date. Either update the end date, or set the start date to on or before the end date."
        }
    });
    const $eba0fcee01f2ae5a$export$daf59e8556d24858 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        misconfiguredChildren: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.misconfigured-children",
            "defaultMessage": "This issue is OK, but it has children with warnings"
        },
        endsAfterParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.ends-after-parent",
            "defaultMessage": "{issue} ends {amount} after its parent {parent}"
        },
        startsBeforeParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.starts-before-parent",
            "defaultMessage": "{issue} starts {amount} before its parent {parent}"
        },
        dateBeyondDueDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.date-beyond-due-date",
            "defaultMessage": "One or both of the start and end dates for this issue are set after the due date. Either update the due date, or set the dates to on or before the due date."
        },
        notClosedBeyondEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.not-closed-beyond-end-date",
            "defaultMessage": "This issue is still unresolved after its end date. Check if the status needs updating, or if more time is needed for the issue."
        },
        inProgressBeyondInferredEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.in-progress-beyond-inferred-end-date",
            "defaultMessage": "This issue is still unresolved after its end date. Consider moving the status back to To do, adding the issue to a current or future sprint, or rescheduling the issue to a later end date."
        },
        dateOutsideOfSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.date-outside-of-sprint",
            "defaultMessage": "The start or end date of the issue fall outside of the assigned sprint"
        },
        issueAssignedKanbanTeamAndSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.issue-assigned-kanban-team-and-sprint",
            "defaultMessage": "Sprints should only be associated with Scrum teams. The capacity of this issue will still be allocated to the Kanban iterations using the assigned dates, but please verify the Sprint assignment."
        },
        startDateAfterEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.start-date-after-end-date",
            "defaultMessage": "The start date for this issue is set after the end date. Either update the end date, or set the start date to on or before the end date."
        },
        unknown: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.unknown",
            "defaultMessage": "There was an error during scheduling"
        },
        notFullyScheduled: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.not-fully-scheduled",
            "defaultMessage": "Check that someone in your team is available to work on this issue at this particular time and then recalculate your plan."
        },
        horizonReached: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.horizon-reached",
            "defaultMessage": "Every plan has a maximum 5 year planning horizon. Decrease the scope of work, add extra people, or increase your team's capacity to reduce the length of your schedule. Then, recalculate your plan."
        },
        releaseConflict: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.release-conflict",
            "defaultMessage": "A story-level issue and its sub-tasks must be assigned to the same release. Check the release assignments are consistent and then recalculate your plan."
        },
        assigneeIgnored: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.assignee-ignored",
            "defaultMessage": "This issue is scheduled for a person other than its assignee, as the assignee is not part of any of the teams in your plan. Check that they are part of a team and that their team can be assigned to this issue. Then, recalculate your plan."
        },
        externalTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.external-team",
            "defaultMessage": "Change the assigned team to one that's in your plan, or add the assigned team to your plan. Then, recalculate your plan."
        },
        subtaskViolation: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.subtask-violation",
            "defaultMessage": "This item could not be scheduled due to a problem with one of its sub-tasks. To schedule this item, alleviate any existing errors on its sub-tasks."
        },
        subtaskAssignmentViolation: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.subtask-assignment-violation",
            "defaultMessage": "A story-level issue and its sub-tasks must be scheduled to the same team. Check the team assignments are consistent and then recalculate your plan."
        },
        sprintExceeded: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.sprint-exceeded",
            "defaultMessage": "Break your story down further so that estimate is reduced, or decrease the scope of the sprint, until this issue fits into the sprint. Then, recalculate your plan."
        },
        invalidSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.invalid-sprint",
            "defaultMessage": "The item is assigned to an invalid sprint."
        },
        releaseShifted: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.release-shifted",
            "defaultMessage": "Because of the sprint assignment of this work item the corresponding release start date is shifted."
        },
        earliestStartIgnored: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.earliest-start-ignored",
            "defaultMessage": "The start date of this issue's manually assigned sprint takes precedence over this issue's earliest start date. To maintain the earliest start date, set the issue's sprint to 'Calculate'. Or, to remove this message, remove the start date from this issue. Then, recalculate your plan."
        },
        overbooked: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.overbooked",
            "defaultMessage": "This issue is manually assigned to a sprint in which the people available to work on it are overbooked. Decrease the scope for those particular people. Or, if there are no people in your team, decrease the scope of the sprint. Then, recalculate your plan."
        },
        availabilityViolation: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.availability-violation",
            "defaultMessage": "Check in the team view that someone in your team is available to work on this issue at this time and then recalculate your plan."
        },
        resourceLimitViolation: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.resource-limit-violation",
            "defaultMessage": "Resource limit violation"
        },
        violationInDependency: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.violation-in-dependency",
            "defaultMessage": "A required work item could not be scheduled."
        },
        dependenciesIgnoredRelease: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.dependencies-ignored-release",
            "defaultMessage": "This work item is assigned to a release which happens earlier than releases that this work item's dependencies are assigned to."
        },
        dependenciesIgnoredSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.dependencies-ignored-sprint",
            "defaultMessage": "This work item is assigned to a fixed sprint which happens earlier than sprints that this work item's dependencies are scheduled in."
        },
        cyclicDependency: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.cyclic-dependency",
            "defaultMessage": "This issue depends on an issue that directly (or indirectly) depends back on this issue. Remove that dependency and recalculate your plan."
        },
        subtaskCyclicDependencyIgnored: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.subtask-cyclic-dependency-ignored",
            "defaultMessage": "We can't process dependencies between sub-tasks within a single issue. Remove these dependencies on this issue and then auto-schedule your plan."
        },
        subtaskNoSkilledResource: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.subtask-no-skilled-resource",
            "defaultMessage": "Sub-tasks must to assigned to a single person and can't be assigned across teams or people. Check a single team member has the required skill set and make sure they are available. Or, remove the skill requirements on this issue by refining its estimates. Then, recalculate your plan."
        },
        missingSkills: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.missing-skills",
            "defaultMessage": "Story-level issues can't be assigned across teams. Check that (a subset of) team members collectively have the required skill set, and that they are available. Then, recalculate your plan."
        },
        tooSmallEstimates: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.too-small-estimates",
            "defaultMessage": "Check all estimates on this issue are at least 0.01. This means the total estimate, as well as the estimate for any stage or skill. Then, recalculate your plan."
        },
        completedParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.completed-parent",
            "defaultMessage": "This work item could not be scheduled because one of its parents has been marked as done. To schedule it, change the parent of this work item or change the status of the parent. Otherwise, to remove this message, mark this item as done as well."
        },
        calculationComplexity: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.calculation-complexity",
            "defaultMessage": "Remove the issue from its assigned sprint, change the required skills, or make the assigned team smaller. Then, recalculate your plan."
        }
    });
});
parcelRegister("68rG5", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$17579f3c817bdff4$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "addIssueBody", ()=>$17579f3c817bdff4$export$6c760d32dba4459f);
    $parcel$export(module.exports, "updateIssueBody", ()=>$17579f3c817bdff4$export$adb5b7fd3b19978e);
    $parcel$export(module.exports, "rankIssueBody", ()=>$17579f3c817bdff4$export$ed4998e39ac15e6e);
    $parcel$export(module.exports, "hiddenIssuesBody", ()=>$17579f3c817bdff4$export$632c3b767f7138e9);
    $parcel$export(module.exports, "getDescription", ()=>$17579f3c817bdff4$export$67580b1c13935958);
    var $5fACX = parcelRequire("5fACX");
    var $bstHg = parcelRequire("bstHg");
    const $17579f3c817bdff4$export$bcae9ba627f604b6 = {
        add: '/rest/jpo/1.0/scenarios/addIssue',
        update: '/rest/jpo/1.0/scenarios/updateIssues',
        removeIssues: '/rest/jpo/1.0/scenarios/removeIssues',
        deleteIssues: '/rest/jpo/1.0/scenarios/deleteIssues',
        rank: '/rest/jpo/1.0/issues/rank',
        commitChanges: '/rest/jpo/1.0/issues/commit',
        updateIssueKey: '/rest/jpo/1.0/scenarios/updateIssueKey',
        revertIssues: '/rest/jpo/1.0/scenarios/revertIssues',
        getHiddenIssues: '/rest/jpo/1.0/backlog/hiddenIssues',
        getDoneHistory: '/rest/jpo/1.0/backlog/history',
        getDescription: '/rest/jpo/1.0/issue/description/get'
    };
    const $17579f3c817bdff4$export$b397e3f558f897d1 = ({ id: id, level: level, ...issue })=>{
        const patch = {};
        for (const key of Object.keys(issue)){
            if (key === 'assignee' && issue.assignee === 'unassigned') patch.assignee = {
                value: null
            };
            else if (key === 'fixVersions' && Array.isArray(issue[key])) patch.versionIds = {
                value: issue[key]
            };
            else if (key === 'customFields') {
                const resultCustomFields = {};
                Object.keys(issue.customFields).forEach((field)=>{
                    resultCustomFields[field] = {
                        value: issue.customFields[field] === null ? undefined : issue.customFields[field]
                    };
                });
                patch.customFields = resultCustomFields;
            } else if (key === (0, $5fACX.TARGET_START_FIELD) || key === (0, $5fACX.TARGET_END_FIELD)) {
                const apiKey = (0, $bstHg.TARGET_DATE_FIELD_TO_API_DATE_FIELD_MAP)[key] || key;
                patch[apiKey] = {
                    value: issue[key]
                };
            } else if (key === 'labels') {
                if (issue[key].fieldAction != null) patch[key] = issue[key];
                else patch[key] = {
                    value: issue[key]
                };
            } else patch[key] = {
                value: issue[key]
            };
        }
        return patch;
    };
    const $17579f3c817bdff4$export$6c760d32dba4459f = (plan, payload)=>{
        const { id: planId, currentScenarioId: scenarioId } = plan;
        return {
            planId: planId,
            scenarioId: scenarioId,
            description: $17579f3c817bdff4$export$b397e3f558f897d1(payload)
        };
    };
    const $17579f3c817bdff4$export$adb5b7fd3b19978e = (plan, payload, itemKeys)=>{
        const { id: planId, currentScenarioId: scenarioId } = plan;
        return {
            itemKeys: itemKeys || [
                payload.id
            ],
            planId: planId,
            scenarioId: scenarioId,
            description: $17579f3c817bdff4$export$b397e3f558f897d1(payload)
        };
    };
    const $17579f3c817bdff4$export$ed4998e39ac15e6e = (plan, payload)=>{
        const { id: planId, currentScenarioId: scenarioId } = plan;
        const { itemKeys: itemKeys, anchor: anchor, relation: relation } = payload;
        return {
            operations: [
                {
                    anchor: anchor,
                    itemKeys: itemKeys,
                    operationType: relation
                }
            ],
            planId: planId,
            scenarioId: scenarioId
        };
    };
    const $17579f3c817bdff4$export$632c3b767f7138e9 = ({ id: planId, currentScenarioId: scenarioId }, issueIds)=>{
        if (!planId || !scenarioId) throw new Error('Need both plan and scenario to get hidden issues');
        const payload = {
            planId: planId,
            scenarioId: scenarioId,
            issueIds: issueIds
        };
        return payload;
    };
    const $17579f3c817bdff4$export$67580b1c13935958 = (plan, itemKey)=>{
        const { id: planId, currentScenarioId: scenarioId } = plan;
        return {
            planId: planId,
            scenarioId: scenarioId,
            itemKey: itemKey,
            renderRaw: true
        };
    };
});
const $74616ed8f6aff060$export$242fccfb90c57247 = 'command.issue.ADD_ISSUE';
const $74616ed8f6aff060$export$d46fd8e9a2a59b28 = 'command.issue.UPDATE_ISSUE';
const $74616ed8f6aff060$export$1d31ff157c726e8a = 'command.issue.UPDATE_ISSUE_DATES_OPTIMISTIC';
const $74616ed8f6aff060$export$254f30e4f720be90 = 'command.issue.UPDATE_MULTIPLE_ISSUES';
const $74616ed8f6aff060$export$9bbbeac0bf5bf14 = 'command.issue.RANK_ISSUE';
const $74616ed8f6aff060$export$269d7b2720ef5d5e = 'command.issue.MOVE_ISSUE';
const $74616ed8f6aff060$export$ce69e6c9d4cdf606 = 'command.issue.UPDATE_ORIGINAL_ISSUE';
const $74616ed8f6aff060$export$7dc711c48e3c938f = 'command.issue.FETCH_HISTORICAL_DONE_ISSUES';
const $74616ed8f6aff060$export$563a5374cb06df7d = 'command.issue.HANDLE_COMMIT_RESPONSE';
const $74616ed8f6aff060$export$181f7083eacb425 = 'command.issue.REMOVE_SINGLE_ISSUE';
const $74616ed8f6aff060$export$35cae9f1acacb606 = 'command.issue.REMOVE_SELECTED_ISSUES';
const $74616ed8f6aff060$export$b6c322dbc4f2f8ac = 'command.issue.BULK_ISSUES_UPDATE';
const $74616ed8f6aff060$export$4c343341eb9052e8 = 'command.issue.BULK_ISSUES_CPR_UPDATE';
const $74616ed8f6aff060$export$85b6c4937eed754f = 'command.issue.BULK_RANK_ISSUES';
const $74616ed8f6aff060$export$20130dbd048fc414 = 'command.issue.EXPAND_ALL_ANALYTICS_ACTION';
const $74616ed8f6aff060$export$39babeb2e7944629 = 'command.issue.COLLAPSE_ALL_ANALYTICS_ACTION';
const $74616ed8f6aff060$export$15027aa3e935638c = 'command.issue.FAIL_COMMIT_REQUEST';
const $74616ed8f6aff060$export$868e118e8d9234f = 'command.issue.REFRESH_SUBTASK';
const $74616ed8f6aff060$export$7993a293561fe4a9 = 'command.issue.DELETE_SINGLE_ISSUE';
const $74616ed8f6aff060$export$d8ee766aa26c1e82 = 'DESCRIPTION_FETCH_ERROR';
parcelRegister("6lsuQ", function(module, exports) {
    $parcel$export(module.exports, "getOriginalProperties", ()=>$3402948918006823$export$c8b74b755988db44);
    $parcel$export(module.exports, "getAddedIssueRankPayload", ()=>$3402948918006823$export$10c4913e94f7c57b);
    $parcel$export(module.exports, "getBulkRankPayload", ()=>$3402948918006823$export$40698dc95abaae0b);
    var $8EB5I;
    var $73eiZ;
    var $4Rr1a;
    var $ik0Qc;
    var $fZhYM;
    var $fes2p;
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    const $3402948918006823$var$pickFieldsFromIssue = (fields, issue)=>(0, parcelRequire("fes2p")).default(fields, issue);
    const $3402948918006823$var$withNullDefaultValue = (partialIssue)=>(0, parcelRequire("4Rr1a")).default((value)=>(0, $4nDwW.isDefined)(value) ? value : null, partialIssue);
    const $3402948918006823$export$c8b74b755988db44 = (issue, payload)=>{
        const originalCustomFields = Object.keys(payload.customFields || {}).reduce((result, key)=>Object.assign(result, {
                [key]: (0, parcelRequire("fZhYM")).default([
                    'customFields',
                    key
                ], issue) || null
            }), {});
        const originalProperties = Object.keys(originalCustomFields).length === 0 ? $3402948918006823$var$withNullDefaultValue($3402948918006823$var$pickFieldsFromIssue(Object.keys(payload), issue)) : (0, parcelRequire("ik0Qc")).default($3402948918006823$var$withNullDefaultValue($3402948918006823$var$pickFieldsFromIssue(Object.keys(payload), issue)), {
            customFields: originalCustomFields
        });
        if (!(0, parcelRequire("8EB5I")).default(payload, originalProperties)) return originalProperties;
    };
    const $3402948918006823$export$10c4913e94f7c57b = ({ id: id, level: level, parent: parent }, issues, sibling)=>{
        const siblings = issues.filter(parent ? (issue)=>issue.parent === parent && issue.id !== id : (issue)=>issue.level === level && issue.id !== id);
        if (!parent && siblings.length === 0) return {
            itemKeys: [
                id
            ],
            relation: (0, $5fACX.RANK_LAST)
        };
        if (sibling) return {
            anchor: sibling,
            itemKeys: [
                id
            ],
            relation: (0, $5fACX.RANK_AFTER)
        };
        return {
            anchor: siblings.length > 0 ? siblings[siblings.length - 1].id : parent,
            itemKeys: [
                id
            ],
            relation: (0, $5fACX.RANK_AFTER)
        };
    };
    const $3402948918006823$export$40698dc95abaae0b = ({ anchor: anchor, operationType: operationType }, itemKeys, allIssues)=>{
        const itemKeysSet = new Set(itemKeys);
        if (operationType === (0, $5fACX.RANK_TOP)) {
            const topIssue = allIssues.find(({ id: id })=>!itemKeysSet.has(id));
            if (!topIssue) return null;
            return {
                anchor: topIssue.id,
                itemKeys: itemKeys,
                relation: (0, $5fACX.RANK_BEFORE)
            };
        }
        if (operationType === (0, $5fACX.RANK_LAST)) {
            const bottomIssue = (0, parcelRequire("73eiZ")).default(({ id: id })=>!itemKeysSet.has(id), allIssues);
            if (!bottomIssue) return null;
            return {
                anchor: bottomIssue.id,
                itemKeys: itemKeys,
                relation: operationType
            };
        }
        return {
            anchor: anchor,
            itemKeys: itemKeys,
            relation: operationType
        };
    };
});
parcelRegister("73eiZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5223e8f07242a46a$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5DTpU;
    var $c2ST6;
    var $5223e8f07242a46a$var$findLast = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("5DTpU")).default)([], (0, (0, parcelRequire("c2ST6")).default), function findLast(fn, list) {
        var idx = list.length - 1;
        while(idx >= 0){
            if (fn(list[idx])) return list[idx];
            idx -= 1;
        }
    }));
    var $5223e8f07242a46a$export$2e2bcd8739ae039 = $5223e8f07242a46a$var$findLast;
});
parcelRegister("c2ST6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c503f80a8886770$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7D5kn;
    var $8c503f80a8886770$var$XFindLast = function() {
        function XFindLast(f, xf) {
            this.xf = xf;
            this.f = f;
        }
        XFindLast.prototype['@@transducer/init'] = (0, (0, parcelRequire("7D5kn")).default).init;
        XFindLast.prototype['@@transducer/result'] = function(result) {
            return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
        };
        XFindLast.prototype['@@transducer/step'] = function(result, input) {
            if (this.f(input)) this.last = input;
            return result;
        };
        return XFindLast;
    }();
    var $8c503f80a8886770$var$_xfindLast = (0, (0, parcelRequire("c9RLn")).default)(function _xfindLast(f, xf) {
        return new $8c503f80a8886770$var$XFindLast(f, xf);
    });
    var $8c503f80a8886770$export$2e2bcd8739ae039 = $8c503f80a8886770$var$_xfindLast;
});
parcelRegister("iXfSG", function(module, exports) {
    $parcel$export(module.exports, "isCrossTeamPlanningTemplateExperimentEnabled", ()=>$04652dfe6553daff$export$5d06510124eb14f8);
    $parcel$export(module.exports, "getCurrentUserInViewFormat", ()=>$04652dfe6553daff$export$1e094021f1ba1c3b);
    $parcel$export(module.exports, "prepareModifiedView", ()=>$04652dfe6553daff$export$982d2d18ebd0a982);
    $parcel$export(module.exports, "pushActiveViewId", ()=>$04652dfe6553daff$export$937c89ad2c912ae5);
    $parcel$export(module.exports, "pushModifiedView", ()=>$04652dfe6553daff$export$a55835a0997c18e6);
    $parcel$export(module.exports, "deleteModifiedView", ()=>$04652dfe6553daff$export$3f3078e2fb5b2249);
    $parcel$export(module.exports, "createView", ()=>$04652dfe6553daff$export$d7febe7b891e79f0);
    $parcel$export(module.exports, "updateView", ()=>$04652dfe6553daff$export$827a6c17a85f6d1a);
    $parcel$export(module.exports, "fetchSavedView", ()=>$04652dfe6553daff$export$bc294d0493f3206);
    $parcel$export(module.exports, "initializeViews", ()=>$04652dfe6553daff$export$6fa92c81825ed985);
    $parcel$export(module.exports, "getReportViewSettings", ()=>$04652dfe6553daff$export$1050f30725ffa53);
    $parcel$export(module.exports, "deleteView", ()=>$04652dfe6553daff$export$443d89549b135c95);
    $parcel$export(module.exports, "markAsDefaultView", ()=>$04652dfe6553daff$export$65c8c09b8f8e5243);
    $parcel$export(module.exports, "replaceURLForViewId", ()=>$04652dfe6553daff$export$c816faf8404f4eb6);
    $parcel$export(module.exports, "replaceURLForSamplePlan", ()=>$04652dfe6553daff$export$ecf701fdb2f69c12);
    $parcel$export(module.exports, "duplicateSectionState", ()=>$04652dfe6553daff$export$8b6fc6f02567edff);
    $parcel$export(module.exports, "UpdateErrorConflicted", ()=>(parcelRequire("CLvmV")).UpdateErrorConflicted);
    $parcel$export(module.exports, "UpdateErrorNotExists", ()=>(parcelRequire("CLvmV")).UpdateErrorNotExists);
    $parcel$export(module.exports, "SaveAsErrorDuplicateView", ()=>(parcelRequire("CLvmV")).SaveAsErrorDuplicateView);
    $parcel$export(module.exports, "DeleteErrorDefaultView", ()=>(parcelRequire("CLvmV")).DeleteErrorDefaultView);
    var $basmW = parcelRequire("basmW");
    var $2XSIf;
    var $7myQy;
    var $lV634;
    var $ik0Qc;
    var $5KaGt;
    var $cXQc6;
    var $8r8wv;
    var $bQZTk;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6s1PB;
    var $4R6GH;
    var $k5pjO;
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fOXM3 = parcelRequire("fOXM3");
    var $idmiV = parcelRequire("idmiV");
    var $1CGdp = parcelRequire("1CGdp");
    var $6WWH1 = parcelRequire("6WWH1");
    var $bHTqr = parcelRequire("bHTqr");
    var $7QGzp = parcelRequire("7QGzp");
    var $eAhNi = parcelRequire("eAhNi");
    var $CLvmV = parcelRequire("CLvmV");
    var $2vmRe = parcelRequire("2vmRe");
    var $kjgFt = parcelRequire("kjgFt");
    var $afKbt = parcelRequire("afKbt");
    var $cfOlJ = parcelRequire("cfOlJ");
    var $CLvmV = parcelRequire("CLvmV");
    const $04652dfe6553daff$export$5d06510124eb14f8 = ()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('second_premium_template_experiment', 'cohort', 'variation');
    const $04652dfe6553daff$export$49517d4b7c5fe443 = (timestamp)=>{
        if ((0, $4nDwW.isDefined)(timestamp) && (0, parcelRequire("7myQy")).default(Number, timestamp)) return new Date(timestamp * 1e3);
        return null;
    };
    function* $04652dfe6553daff$export$1e7ef12a24e81388(view) {
        const colourMaps = view.preferences && view.preferences.colourByV2 && view.preferences.colourByV2.colourMaps;
        if ((0, parcelRequire("lV634")).default(colourMaps)) return view;
        const projectColourMap = yield (0, $aNOuE.call)((0, $2vmRe.updateProjectColorMap), colourMaps.project && (0, parcelRequire("7myQy")).default(Object, colourMaps.project) ? colourMaps : {
            project: {}
        });
        const teamColourMap = yield (0, $aNOuE.call)((0, $2vmRe.updateTeamColorMap), colourMaps.team && (0, parcelRequire("7myQy")).default(Object, colourMaps.team) ? colourMaps : {
            team: {}
        });
        return (0, parcelRequire("5KaGt")).default(view, {
            preferences: {
                colourByV2: {
                    colourMaps: {
                        project: projectColourMap,
                        team: teamColourMap
                    }
                }
            }
        });
    }
    function* $04652dfe6553daff$export$1e094021f1ba1c3b() {
        const { displayName: title, key: jiraUserId, name: jiraUsername = '', email: email = '', avatarUrl: avatarUrl = '' } = yield (0, $aNOuE.select)((0, $6WWH1.getCurrentUser));
        return {
            title: title,
            jiraUserId: jiraUserId,
            jiraUsername: jiraUsername,
            email: email,
            avatarUrl: avatarUrl
        };
    }
    function* $04652dfe6553daff$export$203ed8b65c3b2a28() {
        const { id: planId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        if (!planId) throw new Error('plan not found');
        return planId;
    }
    function* $04652dfe6553daff$var$remoteFetch(key, errMessage = 'Failed to fetch remoteFetch') {
        if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) {
            if (yield (0, $aNOuE.select)((0, $1CGdp.isSmartLink))) return;
        }
        const plan = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        if (!(0, $4nDwW.isDefined)(plan.id)) return undefined;
        const url = (0, $kjgFt.urls).userProperties(plan.id, key);
        const { value: result } = yield (0, $aNOuE.call)((0, $8DSSe.aggressiveFetch), url, {
            method: 'GET',
            profile: (0, $kjgFt.urls).userProperties(0, ':prop'),
            json: true
        }, errMessage);
        return result;
    }
    function* $04652dfe6553daff$export$f36830f6a371f043(key, value, errMessage = 'Failed to fetch remotePush') {
        if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) {
            if (yield (0, $aNOuE.select)((0, $1CGdp.isSmartLink))) return;
        }
        const isKeyExisting = !!(yield (0, $aNOuE.call)($04652dfe6553daff$var$remoteFetch, key));
        const plan = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        if (!(0, $4nDwW.isDefined)(plan.id)) return undefined;
        const url = (0, $kjgFt.urls).userProperties(plan.id, key);
        return yield (0, $aNOuE.call)((0, $8DSSe.aggressiveFetch), url, {
            method: isKeyExisting ? 'PUT' : 'POST',
            body: {
                value: value
            }
        }, errMessage);
    }
    function* $04652dfe6553daff$export$167cc9098fae982c(key, errMessage = 'Failed to fetch remoteDelete') {
        if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) {
            if (yield (0, $aNOuE.select)((0, $1CGdp.isSmartLink))) return;
        }
        const url = (0, $kjgFt.urls).userProperties((yield (0, $aNOuE.call)($04652dfe6553daff$export$203ed8b65c3b2a28, 'remoteDelete')), key);
        return yield (0, $aNOuE.call)((0, $8DSSe.aggressiveFetch), url, {
            method: 'DELETE'
        }, errMessage);
    }
    const $04652dfe6553daff$var$extendFieldColumnsForListView = (preferences)=>{
        const { fieldColumnsV0: fieldColumnsV0, listFieldColumnsV0: listFieldColumnsV0 } = preferences;
        let updatedPrefs = {
            ...preferences
        };
        if (!listFieldColumnsV0) updatedPrefs = (0, parcelRequire("2XSIf")).default('listFieldColumnsV0', fieldColumnsV0, updatedPrefs);
        return updatedPrefs;
    };
    const $04652dfe6553daff$var$customMigrations = (0, ($parcel$interopDefault($basmW)))([
        $04652dfe6553daff$var$extendFieldColumnsForListView
    ]);
    function* $04652dfe6553daff$export$982d2d18ebd0a982(payload) {
        const { id: id, version: version, preferences: preferences } = payload;
        const migratedPrefs = yield (0, $aNOuE.call)((0, $afKbt.migratePrefs), $04652dfe6553daff$var$customMigrations(preferences));
        const migratedView = (0, parcelRequire("2XSIf")).default('preferences', migratedPrefs, payload);
        const { preferences: preferencesWithUpdatedColorMaps } = yield (0, $aNOuE.call)($04652dfe6553daff$export$1e7ef12a24e81388, migratedView);
        return {
            id: id,
            version: version,
            preferences: preferencesWithUpdatedColorMaps
        };
    }
    function* $04652dfe6553daff$export$937c89ad2c912ae5(id) {
        yield (0, $aNOuE.call)($04652dfe6553daff$export$f36830f6a371f043, 'activeView', {
            value: {
                id: id
            }
        }, 'Failed to fetch pushActiveViewId');
    }
    function* $04652dfe6553daff$export$a55835a0997c18e6(view) {
        const { id: id, version: version, preferences: preferences, persisted: persisted } = view;
        yield (0, $aNOuE.call)($04652dfe6553daff$export$f36830f6a371f043, `modifiedView-${id}`, {
            version: version,
            preferences: (0, parcelRequire("cXQc6")).default(persisted.preferences, preferences)
        }, 'Failed to fetch pushModifiedView');
    }
    function* $04652dfe6553daff$export$3f3078e2fb5b2249(id) {
        yield (0, $aNOuE.call)($04652dfe6553daff$export$167cc9098fae982c, `modifiedView-${id}`, 'Failed to fetch deleteModifiedView');
    }
    const $04652dfe6553daff$export$40bfa3442cecdd7b = (payload)=>{
        const { id: id, version: version, name: name, preferences: persistedPrefs, isDefault: isDefault, createdBy: createdBy, lastModifiedBy: lastModifiedBy, lastModifiedTimestamp: lastModifiedTimestamp } = payload;
        let updatedPersistedPrefs = persistedPrefs;
        const preferences = (()=>{
            if (persistedPrefs) {
                updatedPersistedPrefs = $04652dfe6553daff$var$customMigrations(persistedPrefs);
                return (0, $afKbt.migratePrefs)(updatedPersistedPrefs);
            }
            throw new Error(`preferences not available on the view with id ${id}`);
        })();
        return {
            id: id,
            version: version,
            name: name,
            preferences: preferences,
            persisted: {
                preferences: updatedPersistedPrefs || preferences
            },
            isDefault: isDefault,
            active: false,
            modified: false,
            original: null,
            createdBy: createdBy,
            updatedBy: lastModifiedBy,
            updatedAt: $04652dfe6553daff$export$49517d4b7c5fe443(lastModifiedTimestamp)
        };
    };
    function* $04652dfe6553daff$export$d7febe7b891e79f0({ name: name, isDefault: isDefault, preferences: preferences, persisted: persisted, isPredefined: isPredefined = false }) {
        const url = (0, $kjgFt.urls).create((yield (0, $aNOuE.call)($04652dfe6553daff$export$203ed8b65c3b2a28, 'createView')));
        const persistedPrefs = persisted && persisted.preferences;
        const body = (0, $kjgFt.createViewBody)({
            name: name,
            isDefault: isDefault,
            preferences: (0, parcelRequire("cXQc6")).default(persistedPrefs || {}, preferences),
            isPredefined: isPredefined
        });
        const { id: id, version: version, errorCode: errorCode } = yield (0, $aNOuE.call)((0, $8DSSe.aggressiveFetch), url, {
            method: 'POST',
            body: body,
            json: true
        }, 'Failed to fetch createView');
        return {
            id: id,
            version: version,
            errorCode: errorCode
        };
    }
    function* $04652dfe6553daff$export$827a6c17a85f6d1a({ id: id, name: name, version: version, isDefault: isDefault, preferences: preferences, original: original, persisted: persisted, isPredefined: isPredefined }, renameOnly) {
        const url = (0, $kjgFt.urls).view((yield (0, $aNOuE.call)($04652dfe6553daff$export$203ed8b65c3b2a28, 'updateView')), id);
        const currentView = yield (0, $aNOuE.select)((0, $7QGzp.getViewById), id);
        const { name: currentName = name } = currentView || {};
        let updatedPreferences = preferences;
        let body;
        if (!renameOnly) {
            if (!isPredefined) {
                if (!original) throw new Error('original must be defined');
                updatedPreferences = (0, parcelRequire("bQZTk")).default((0, parcelRequire("cXQc6")).default(original.persisted.preferences), (0, parcelRequire("cXQc6")).default(persisted.preferences))(preferences);
            }
            body = (0, $kjgFt.updateViewBody)({
                name: name,
                version: version,
                isDefault: isDefault,
                preferences: updatedPreferences,
                isPredefined: isPredefined
            });
        } else body = (0, $kjgFt.renameViewBody)({
            name: name
        });
        const payload = yield (0, $aNOuE.call)((0, $8DSSe.aggressiveFetch), url, {
            method: 'PUT',
            body: body,
            json: true
        }, 'Failed to fetch updateView');
        if (payload.updateErrorCode === 'VIEW_NOT_FOUND') throw new (0, $CLvmV.UpdateErrorNotExists)({
            viewId: id,
            viewName: currentName
        });
        if (payload.updateErrorCode === 'STALE_VERSION') throw new (0, $CLvmV.UpdateErrorConflicted)({
            viewId: id,
            viewName: currentName,
            modifiedBy: payload.previouslyModifiedBy,
            modifiedAt: new Date(payload.previouslyModifiedTimestamp * 1e3)
        });
        if (payload.updateErrorCode === 'DUPLICATE_VIEW') throw new (0, $CLvmV.SaveAsErrorDuplicateView)({
            viewId: id,
            viewName: currentName,
            newName: name
        });
        return {
            id: payload.id,
            version: payload.newVersion
        };
    }
    function* $04652dfe6553daff$export$5fc739fff44ff01(predefined) {
        const payload = yield (0, $aNOuE.call)($04652dfe6553daff$export$d7febe7b891e79f0, {
            ...predefined,
            isPredefined: true
        });
        return {
            ...predefined,
            ...payload
        };
    }
    function $04652dfe6553daff$export$b24bec42687f32a(predefined, id, version) {
        return {
            ...predefined,
            id: id,
            version: version
        };
    }
    function* $04652dfe6553daff$export$d1f9bed5329ee15(view) {
        try {
            yield (0, $aNOuE.call)($04652dfe6553daff$export$827a6c17a85f6d1a, (0, parcelRequire("ik0Qc")).default(view, {
                isPredefined: true
            }));
            return view;
        } catch (err) {
            if (err instanceof (0, $CLvmV.UpdateErrorNotExists) || err instanceof (0, $CLvmV.UpdateErrorConflicted)) return null;
            throw err;
        }
    }
    function* $04652dfe6553daff$export$925b68815ba4f5c2(payload, options) {
        const predefinedPreferences = yield (0, $aNOuE.select)((0, $eAhNi.default));
        const [payloadUnsavedPredefinedViews, payloadUserCreatedViews] = (0, parcelRequire("8r8wv")).default((view)=>!(0, $4nDwW.isDefined)(view.createdTimestamp) && !(0, $4nDwW.isDefined)(view.preferences) && (0, $4nDwW.isDefined)(predefinedPreferences[view.name]), payload);
        const payloadDefault = payload.filter((view)=>view.isDefault);
        let savedPredefinedViews;
        if (payloadUnsavedPredefinedViews.length > 0) savedPredefinedViews = yield (0, $aNOuE.all)(payloadUnsavedPredefinedViews.map((payloadUnsavedPredefinedView)=>{
            const viewName = payloadUnsavedPredefinedView.name;
            return (0, $aNOuE.call)($04652dfe6553daff$export$d1f9bed5329ee15, {
                ...payloadUnsavedPredefinedView,
                preferences: predefinedPreferences[viewName]
            });
        }));
        else if (payloadUserCreatedViews.length > 0) savedPredefinedViews = [];
        else {
            const isReadOnlyMode = yield (0, $aNOuE.select)((0, $1CGdp.isReadOnly));
            const presetNames = (0, $fOXM3.getPresetViewNames)();
            const defaultDefaultViewName = options?.forSamplePlan || options?.forCrossTeamPlanning ? presetNames.SPRINT_CAPACITY_MANAGEMENT : presetNames.BASIC;
            savedPredefinedViews = yield (0, $aNOuE.all)(Object.keys(predefinedPreferences).map((name, i)=>{
                const newPredefinedView = {
                    name: name,
                    preferences: predefinedPreferences[name],
                    isDefault: payloadDefault.length > 0 ? false : name === defaultDefaultViewName
                };
                if (isReadOnlyMode) return (0, $aNOuE.call)($04652dfe6553daff$export$b24bec42687f32a, newPredefinedView, i + 1, 0);
                return (0, $aNOuE.call)($04652dfe6553daff$export$5fc739fff44ff01, newPredefinedView);
            }));
        }
        const allSavedViews = [
            ...payloadUserCreatedViews,
            ...savedPredefinedViews.filter((predefinedView)=>(0, $4nDwW.isDefined)(predefinedView))
        ].map((view)=>$04652dfe6553daff$export$40bfa3442cecdd7b(view));
        return yield (0, $aNOuE.all)(allSavedViews.map((view)=>(0, $aNOuE.call)($04652dfe6553daff$export$1e7ef12a24e81388, view)));
    }
    function* $04652dfe6553daff$export$ba8fdcb3b5fbb4fe() {
        const url = (0, $kjgFt.urls).create((yield (0, $aNOuE.call)($04652dfe6553daff$export$203ed8b65c3b2a28, 'fetchSavedViews')));
        const payload = yield (0, $aNOuE.call)((0, $8DSSe.aggressiveFetch), url, {
            method: 'GET',
            json: true
        }, 'Failed to fetch fetchSavedViews');
        return yield (0, $aNOuE.call)($04652dfe6553daff$export$925b68815ba4f5c2, payload);
    }
    function* $04652dfe6553daff$export$bc294d0493f3206(id) {
        return (yield (0, $aNOuE.call)($04652dfe6553daff$export$ba8fdcb3b5fbb4fe)).find((one)=>one.id === id);
    }
    function* $04652dfe6553daff$export$8d94958ea8a83ea6(modifiedUntitled) {
        if (!modifiedUntitled) return undefined;
        const currentJiraUser = yield (0, $aNOuE.call)($04652dfe6553daff$export$1e094021f1ba1c3b);
        const result = {
            id: (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28),
            name: 'Untitled',
            version: 0,
            preferences: modifiedUntitled.preferences,
            isDefault: false,
            active: false,
            modified: true,
            original: null,
            persisted: {
                preferences: {}
            },
            createdBy: currentJiraUser,
            updatedBy: currentJiraUser,
            updatedAt: new Date()
        };
        return result;
    }
    function* $04652dfe6553daff$export$6fa92c81825ed985(payload, options) {
        const { savedViews: savedViews, modifiedSavedViews: modifiedSavedViews, activeViewId: remoteActiveViewId } = payload;
        const remoteSaved = yield (0, $aNOuE.call)($04652dfe6553daff$export$925b68815ba4f5c2, savedViews, options);
        const untitleViewModifications = modifiedSavedViews.find(({ id: id })=>id === (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28));
        let remoteUntitled;
        const isEmbedSmartLink = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? yield (0, $aNOuE.select)((0, $1CGdp.isSmartLink)) : false;
        if ((0, $4nDwW.isDefined)(untitleViewModifications) && (!isEmbedSmartLink || !(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans'))) {
            const modifiedUntitled = yield (0, $aNOuE.call)($04652dfe6553daff$export$982d2d18ebd0a982, untitleViewModifications);
            remoteUntitled = yield (0, $aNOuE.call)($04652dfe6553daff$export$8d94958ea8a83ea6, modifiedUntitled);
        }
        const remoteAll = remoteSaved.concat(remoteUntitled || []);
        const remoteActiveView = remoteActiveViewId && remoteAll.find((one)=>one.id === remoteActiveViewId);
        const [activeViewId, result] = (()=>{
            if (remoteActiveView) return [
                remoteActiveView.id,
                remoteAll
            ];
            if (remoteUntitled) return [
                (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28),
                remoteAll
            ];
            try {
                return [
                    remoteSaved.find((one)=>one.isDefault).id,
                    remoteAll
                ];
            } catch  {
                throw new Error('default view not found');
            }
        })();
        if (activeViewId !== remoteActiveViewId) yield (0, $aNOuE.call)($04652dfe6553daff$export$937c89ad2c912ae5, activeViewId);
        const activeViewModifications = modifiedSavedViews.find(({ id: id })=>id === activeViewId);
        let modifiedActiveView;
        if ((0, $4nDwW.isDefined)(activeViewModifications) && (!isEmbedSmartLink || !(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans'))) modifiedActiveView = yield (0, $aNOuE.call)($04652dfe6553daff$export$982d2d18ebd0a982, activeViewModifications);
        return result.map((original)=>{
            const active = original.id === activeViewId;
            if (active && modifiedActiveView && (!isEmbedSmartLink || !(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans'))) {
                const { version: version, preferences: preferences } = modifiedActiveView;
                return (0, parcelRequire("cXQc6")).default(original, {
                    version: version,
                    preferences: preferences,
                    modified: true,
                    persisted: {
                        preferences: preferences
                    },
                    original: original,
                    active: active
                });
            }
            return (0, parcelRequire("ik0Qc")).default(original, {
                active: active
            });
        });
    }
    function* $04652dfe6553daff$export$1050f30725ffa53(blob) {
        const migratableReportBlob = (0, $cfOlJ.getReportMigratableBlob)(blob);
        const reportViewSetting = yield (0, $aNOuE.call)((0, $afKbt.migratePrefs), migratableReportBlob);
        return reportViewSetting;
    }
    function* $04652dfe6553daff$export$443d89549b135c95(id) {
        const url = (0, $kjgFt.urls).view((yield (0, $aNOuE.call)($04652dfe6553daff$export$203ed8b65c3b2a28, 'deleteView')), id);
        return yield (0, $aNOuE.call)((0, $8DSSe.aggressiveFetch), url, {
            method: 'DELETE',
            json: true
        }, 'Failed to fetch deleteView');
    }
    function* $04652dfe6553daff$export$65c8c09b8f8e5243({ id: id, isDefault: isDefault }) {
        const url = (0, $kjgFt.urls).view((yield (0, $aNOuE.call)($04652dfe6553daff$export$203ed8b65c3b2a28, 'markAsDefaultView')), id);
        const body = (0, $kjgFt.markAsDefaultViewBody)({
            isDefault: isDefault
        });
        yield (0, $aNOuE.call)((0, $8DSSe.aggressiveFetch), url, {
            method: 'PUT',
            body: body,
            json: true
        }, 'Failed to fetch markAsDefaultView');
    }
    function $04652dfe6553daff$export$df4b64c21468538d(search, activeViewId) {
        return (0, $idmiV.updateQueryString)(search, {
            vid: activeViewId
        });
    }
    const $04652dfe6553daff$export$c816faf8404f4eb6 = (id)=>{
        const search = $04652dfe6553daff$export$df4b64c21468538d(window.location.search, id);
        const url = `${window.location.origin}${window.location.pathname}${search}${window.location.hash}`;
        window.history.replaceState({}, window.title, url);
    };
    const $04652dfe6553daff$export$ecf701fdb2f69c12 = ()=>{
        const search = (0, $idmiV.updateQueryString)(window.location.search, {
            isSample: undefined
        });
        const url = `${window.location.origin}${window.location.pathname}${search}${window.location.hash}`;
        window.history.replaceState({}, window.title, url);
    };
    function $04652dfe6553daff$export$8b6fc6f02567edff({ sourceViewId: sourceViewId, targetViewId: targetViewId, duplicateSection: duplicateSection }) {
        duplicateSection((0, (0, parcelRequire("k5pjO")).getSectionNamespace)((0, $7QGzp.getNamespaceForView)(sourceViewId), (0, $TTKUQ.SECTION_KEYS).FIELD), (0, (0, parcelRequire("k5pjO")).getSectionNamespace)((0, $7QGzp.getNamespaceForView)(targetViewId), (0, $TTKUQ.SECTION_KEYS).FIELD));
        duplicateSection((0, (0, parcelRequire("k5pjO")).getSectionNamespace)((0, $7QGzp.getNamespaceForView)(sourceViewId), (0, $TTKUQ.SECTION_KEYS).MAIN), (0, (0, parcelRequire("k5pjO")).getSectionNamespace)((0, $7QGzp.getNamespaceForView)(targetViewId), (0, $TTKUQ.SECTION_KEYS).MAIN));
        duplicateSection((0, (0, parcelRequire("k5pjO")).getSectionNamespace)((0, $7QGzp.getNamespaceForView)(sourceViewId), (0, $TTKUQ.SECTION_KEYS).LIST_FIELD), (0, (0, parcelRequire("k5pjO")).getSectionNamespace)((0, $7QGzp.getNamespaceForView)(targetViewId), (0, $TTKUQ.SECTION_KEYS).LIST_FIELD));
        duplicateSection((0, (0, parcelRequire("k5pjO")).getSectionNamespace)((0, $7QGzp.getNamespaceForView)(sourceViewId), (0, $TTKUQ.SECTION_KEYS).LIST_MAIN), (0, (0, parcelRequire("k5pjO")).getSectionNamespace)((0, $7QGzp.getNamespaceForView)(targetViewId), (0, $TTKUQ.SECTION_KEYS).LIST_MAIN));
    }
});
parcelRegister("cXQc6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$026f8a3fa6b59900$export$2e2bcd8739ae039);
    var $kClQu;
    var $c9RLn;
    var $026f8a3fa6b59900$var$mergeRight = (0, (0, parcelRequire("c9RLn")).default)(function mergeRight(l, r) {
        return (0, (0, parcelRequire("kClQu")).default)({}, l, r);
    });
    var $026f8a3fa6b59900$export$2e2bcd8739ae039 = $026f8a3fa6b59900$var$mergeRight;
});
parcelRegister("k5pjO", function(module, exports) {
    $parcel$export(module.exports, "getSectionNamespace", ()=>$fa502c30764ee486$export$92bf67045c5ea0ed);
    $parcel$export(module.exports, "default", ()=>$fa502c30764ee486$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $fa502c30764ee486$export$92bf67045c5ea0ed(namespace, id) {
        return `${namespace}-${id}`;
    }
    function $fa502c30764ee486$export$2e2bcd8739ae039(Component) {
        return ({ namespace: namespace, id: id, linkToParent: linkToParent, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                id: $fa502c30764ee486$export$92bf67045c5ea0ed(namespace, id),
                linkToParent: linkToParent !== null && linkToParent !== undefined && `${namespace}-${linkToParent}`
            });
    }
});
parcelRegister("6WWH1", function(module, exports) {
    $parcel$export(module.exports, "getPlanEditorPermissions", ()=>$63393a09acebd1a3$export$d8c3b0a7b4abef66);
    $parcel$export(module.exports, "getPlanViewerPermissions", ()=>$63393a09acebd1a3$export$c543d2c04370d703);
    $parcel$export(module.exports, "getCurrentUser", ()=>$63393a09acebd1a3$export$e5432d4c8eb97ea7);
    $parcel$export(module.exports, "isFetchPlanPermissionsInProgress", ()=>$63393a09acebd1a3$export$22dfe31f63ec61de);
    $parcel$export(module.exports, "getTeamPermissions", ()=>$63393a09acebd1a3$export$488aee7772181f51);
    const $63393a09acebd1a3$export$1ab970995a1d0ad = (state)=>state.domain.permissions.planPermissions;
    const $63393a09acebd1a3$export$d8c3b0a7b4abef66 = (state)=>state.domain.permissions.planPermissions.filter((permission)=>permission.permissions.includes('EDIT'));
    const $63393a09acebd1a3$export$c543d2c04370d703 = (state)=>state.domain.permissions.planPermissions.filter((permission)=>permission.permissions.includes('VIEW'));
    const $63393a09acebd1a3$export$e5432d4c8eb97ea7 = (state)=>({
            displayName: state.domain.system.systemInfo.userName,
            key: state.domain.system.systemInfo.accountId,
            email: state.domain.system.systemInfo.userEmailAddress,
            avatarUrl: state.domain.system.systemInfo.avatarUrl
        });
    const $63393a09acebd1a3$export$22dfe31f63ec61de = (state)=>state.domain.permissions.isFetchPlanPermissionsInProgress;
    const $63393a09acebd1a3$export$488aee7772181f51 = (state)=>state.domain.permissions.teamPermissions;
});
parcelRegister("CLvmV", function(module, exports) {
    $parcel$export(module.exports, "UpdateErrorNotExists", ()=>$18787dadcf763aba$export$dfc2d89b8d2626c8);
    $parcel$export(module.exports, "UpdateErrorConflicted", ()=>$18787dadcf763aba$export$5e0c174d920f99b6);
    $parcel$export(module.exports, "SaveAsErrorDuplicateView", ()=>$18787dadcf763aba$export$4eb53133637b9bc4);
    $parcel$export(module.exports, "DeleteErrorDefaultView", ()=>$18787dadcf763aba$export$66fda58b1a5e03e9);
    class $18787dadcf763aba$export$dfc2d89b8d2626c8 {
        constructor({ viewId: viewId, viewName: viewName }){
            this.viewId = viewId;
            this.viewName = viewName;
        }
    }
    class $18787dadcf763aba$export$5e0c174d920f99b6 {
        constructor({ viewId: viewId, viewName: viewName, modifiedBy: modifiedBy, modifiedAt: modifiedAt }){
            this.viewId = viewId;
            this.viewName = viewName;
            this.modifiedBy = modifiedBy;
            this.modifiedAt = modifiedAt;
        }
    }
    class $18787dadcf763aba$export$4eb53133637b9bc4 {
        constructor({ viewId: viewId, viewName: viewName, newName: newName }){
            this.viewId = viewId;
            this.viewName = viewName;
            this.newName = newName;
        }
    }
    class $18787dadcf763aba$export$66fda58b1a5e03e9 {
        constructor({ viewId: viewId, viewName: viewName }){
            this.viewId = viewId;
            this.viewName = viewName;
        }
    }
});
parcelRegister("2vmRe", function(module, exports) {
    $parcel$export(module.exports, "updateProjectColorMap", ()=>$1a7d2ee032aa9883$export$783ec83b5bf86e1e);
    $parcel$export(module.exports, "updateTeamColorMap", ()=>$1a7d2ee032aa9883$export$c5d50d9d2efc88a8);
    var $cDeeP;
    var $b8GVJ;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $gITL8 = parcelRequire("gITL8");
    var $jpXKt = parcelRequire("jpXKt");
    var $dRVQG = parcelRequire("dRVQG");
    var $clsih = parcelRequire("clsih");
    function $1a7d2ee032aa9883$var$rebuildColorMap(colorMapOfViewPreference, entityIds, colorByOption) {
        const colorMap = colorMapOfViewPreference[colorByOption];
        const colourOfEntitiesInThisPlan = (0, parcelRequire("b8GVJ")).default(Object.keys(colorMap).filter((p)=>entityIds.includes(Number(p))), colorMap);
        let newColorMap = {};
        for (const id of entityIds)if (colorMap[id]) newColorMap = {
            ...newColorMap,
            [id]: colorMap[id]
        };
        else {
            const freeColors = (0, parcelRequire("cDeeP")).default((0, $gITL8.colourPalette), [
                ...Object.values(newColorMap),
                ...colourOfEntitiesInThisPlan
            ]);
            newColorMap[id] = freeColors[0] || (0, $gITL8.colourPalette)[entityIds.length % (0, $gITL8.colourPalette).length];
        }
        return newColorMap;
    }
    function* $1a7d2ee032aa9883$export$783ec83b5bf86e1e(colorMapOfViewPreference) {
        const projectIds = (yield (0, $aNOuE.select)((0, $jpXKt.getProjects))).map((p)=>p.id);
        return $1a7d2ee032aa9883$var$rebuildColorMap(colorMapOfViewPreference, projectIds, 'project');
    }
    function* $1a7d2ee032aa9883$export$c5d50d9d2efc88a8(colorMapOfViewPreference) {
        const teamIds = (yield (0, $aNOuE.select)((0, $dRVQG.getAllTeams))).map((p)=>p.id);
        return $1a7d2ee032aa9883$var$rebuildColorMap(colorMapOfViewPreference, teamIds, 'team');
    }
});
parcelRegister("clsih", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$06538f246c9627b3$export$4a991c87e640ef77);
    $parcel$export(module.exports, "SET_COLOUR_BY_VALUE", ()=>$06538f246c9627b3$export$3e66ee5150a809d5);
    $parcel$export(module.exports, "SET_COLOUR_MAP", ()=>$06538f246c9627b3$export$1ed2e8cc5af52ec2);
    $parcel$export(module.exports, "UPDATE_TEAM_ID", ()=>$06538f246c9627b3$export$3375e6b8e0671d88);
    $parcel$export(module.exports, "REMOVE_TEAM_ID", ()=>$06538f246c9627b3$export$96d619ae50e035a8);
    $parcel$export(module.exports, "SET_COLOUR_FOR_NEW_TEAM", ()=>$06538f246c9627b3$export$9c3daa8c244ed3c);
    $parcel$export(module.exports, "ADD_ISSUE_TYPE_COLOUR", ()=>$06538f246c9627b3$export$99be6a41dc9f4ab2);
    $parcel$export(module.exports, "UPDATE_ISSUE_TYPE_COLOUR", ()=>$06538f246c9627b3$export$a7aed6f0b1f757ad);
    $parcel$export(module.exports, "REMOVE_ISSUE_TYPE_COLOUR", ()=>$06538f246c9627b3$export$278fc823cb39dabd);
    $parcel$export(module.exports, "ADD_LABEL_COLOUR", ()=>$06538f246c9627b3$export$3b20979dcb1bf726);
    $parcel$export(module.exports, "UPDATE_LABEL_COLOUR", ()=>$06538f246c9627b3$export$30151323c3555d8e);
    $parcel$export(module.exports, "REMOVE_LABEL_COLOUR", ()=>$06538f246c9627b3$export$8a40cd78cd667ee0);
    $parcel$export(module.exports, "ADD_COMPONENT_COLOUR", ()=>$06538f246c9627b3$export$6dab2bbd46f0738);
    $parcel$export(module.exports, "UPDATE_COMPONENT_COLOUR", ()=>$06538f246c9627b3$export$1604157578c815f3);
    $parcel$export(module.exports, "REMOVE_COMPONENT_COLOUR", ()=>$06538f246c9627b3$export$6276b3bbeed8dd7e);
    $parcel$export(module.exports, "ADD_PRIORITY_COLOUR", ()=>$06538f246c9627b3$export$b3764a4f4a360f31);
    $parcel$export(module.exports, "SET_PRIORITY_COLOUR_MAP", ()=>$06538f246c9627b3$export$6f995e7ddc07011d);
    $parcel$export(module.exports, "UPDATE_PRIORITY_COLOUR", ()=>$06538f246c9627b3$export$93b0e1785ade5311);
    $parcel$export(module.exports, "REMOVE_PRIORITY_COLOUR", ()=>$06538f246c9627b3$export$e735a906397ccf0f);
    $parcel$export(module.exports, "ADD_SELECT_COLOUR", ()=>$06538f246c9627b3$export$229431d3c9de9119);
    $parcel$export(module.exports, "UPDATE_SELECT_COLOUR", ()=>$06538f246c9627b3$export$cc2ebe1808de3eaf);
    $parcel$export(module.exports, "REMOVE_SELECT_COLOUR", ()=>$06538f246c9627b3$export$a72e3d03e03081fd);
    $parcel$export(module.exports, "CLEAR_ALL_ISSUE_TYPE_COLOURS", ()=>$06538f246c9627b3$export$528cae8834a7aaba);
    $parcel$export(module.exports, "CLEAR_ALL_LABEL_COLOURS", ()=>$06538f246c9627b3$export$f3d6db75bc058932);
    $parcel$export(module.exports, "CLEAR_ALL_PRIORITY_COLOURS", ()=>$06538f246c9627b3$export$92fd8171426ca27);
    $parcel$export(module.exports, "CLEAR_ALL_SELECT_COLOURS", ()=>$06538f246c9627b3$export$a9f87cf8b48c9f17);
    $parcel$export(module.exports, "CLEAR_ALL_COMPONENT_COLOURS", ()=>$06538f246c9627b3$export$4f3c0a419cae6844);
    $parcel$export(module.exports, "setColourMap", ()=>$06538f246c9627b3$export$c48a172e21f06e14);
    $parcel$export(module.exports, "setColourByValue", ()=>$06538f246c9627b3$export$d5f986a0fd9fff3d);
    $parcel$export(module.exports, "updateTeamId", ()=>$06538f246c9627b3$export$3d88424f2784ccca);
    $parcel$export(module.exports, "removeTeamId", ()=>$06538f246c9627b3$export$d80371939c87a6d7);
    $parcel$export(module.exports, "setColourForNewTeam", ()=>$06538f246c9627b3$export$e5818852970cd077);
    $parcel$export(module.exports, "addIssueTypeColour", ()=>$06538f246c9627b3$export$cf61b392749df3f);
    $parcel$export(module.exports, "updateIssueTypeColour", ()=>$06538f246c9627b3$export$b74745aa4e3de6b6);
    $parcel$export(module.exports, "removeIssueTypeColour", ()=>$06538f246c9627b3$export$45c2d6f3c09898c7);
    $parcel$export(module.exports, "clearAllIssueTypeColours", ()=>$06538f246c9627b3$export$54e5405609708451);
    $parcel$export(module.exports, "addLabelColour", ()=>$06538f246c9627b3$export$5f6974865002dbeb);
    $parcel$export(module.exports, "updateLabelColour", ()=>$06538f246c9627b3$export$d4bc34b40af5964a);
    $parcel$export(module.exports, "removeLabelColour", ()=>$06538f246c9627b3$export$577b6462cf2c190b);
    $parcel$export(module.exports, "clearAllLabelColours", ()=>$06538f246c9627b3$export$6c6fbec7b1246d3b);
    $parcel$export(module.exports, "addPriorityColour", ()=>$06538f246c9627b3$export$c06d80c47bf126b);
    $parcel$export(module.exports, "setPriorityColourMap", ()=>$06538f246c9627b3$export$38c255cf3dd1a29a);
    $parcel$export(module.exports, "updatePriorityColour", ()=>$06538f246c9627b3$export$1460535d1143f247);
    $parcel$export(module.exports, "removePriorityColour", ()=>$06538f246c9627b3$export$e1d85b8f002c3a84);
    $parcel$export(module.exports, "clearAllPriorityColours", ()=>$06538f246c9627b3$export$47367661758240c6);
    $parcel$export(module.exports, "addSelectColour", ()=>$06538f246c9627b3$export$670e2ed2e9b2440f);
    $parcel$export(module.exports, "updateSelectColour", ()=>$06538f246c9627b3$export$ef87fce70c438ed2);
    $parcel$export(module.exports, "removeSelectColour", ()=>$06538f246c9627b3$export$2d31749d1b7ade6);
    $parcel$export(module.exports, "clearAllSelectColours", ()=>$06538f246c9627b3$export$76831fdfcb69dda);
    $parcel$export(module.exports, "addComponentColour", ()=>$06538f246c9627b3$export$3b1279f9abc2a577);
    $parcel$export(module.exports, "updateComponentColour", ()=>$06538f246c9627b3$export$4f3671368b35342e);
    $parcel$export(module.exports, "removeComponentColour", ()=>$06538f246c9627b3$export$fb2d993c8537820a);
    $parcel$export(module.exports, "clearAllComponentColours", ()=>$06538f246c9627b3$export$d36c83e78ef4db76);
    const $06538f246c9627b3$export$4a991c87e640ef77 = 'state.domain.view-settings.colour-by.RESET';
    const $06538f246c9627b3$export$3e66ee5150a809d5 = 'state.domain.view-settings.colour-by.SET_COLOUR_BY_VALUE';
    const $06538f246c9627b3$export$1ed2e8cc5af52ec2 = 'state.domain.view-settings.colour-by.SET_COLOUR_MAP';
    const $06538f246c9627b3$export$3375e6b8e0671d88 = 'state.domain.view-settings.colour-by.UPDATE_TEAM_ID';
    const $06538f246c9627b3$export$96d619ae50e035a8 = 'state.domain.view-settings.colour-by.REMOVE_TEAM_ID';
    const $06538f246c9627b3$export$9c3daa8c244ed3c = 'state.domain.view-settings.colour-by.SET_COLOUR_FOR_NEW_TEAM';
    const $06538f246c9627b3$export$99be6a41dc9f4ab2 = 'state.domain.view-settings.colour-by.ADD_ISSUE_TYPE_COLOUR';
    const $06538f246c9627b3$export$a7aed6f0b1f757ad = 'state.domain.view-settings.colour-by.UPDATE_ISSUE_TYPE_COLOUR';
    const $06538f246c9627b3$export$278fc823cb39dabd = 'state.domain.view-settings.colour-by.REMOVE_ISSUE_TYPE_COLOUR';
    const $06538f246c9627b3$export$3b20979dcb1bf726 = 'state.domain.view-settings.colour-by.ADD_LABEL_COLOUR';
    const $06538f246c9627b3$export$30151323c3555d8e = 'state.domain.view-settings.colour-by.UPDATE_LABEL_COLOUR';
    const $06538f246c9627b3$export$8a40cd78cd667ee0 = 'state.domain.view-settings.colour-by.REMOVE_LABEL_COLOUR';
    const $06538f246c9627b3$export$6dab2bbd46f0738 = 'state.domain.view-settings.colour-by.ADD_COMPONENT_COLOUR';
    const $06538f246c9627b3$export$1604157578c815f3 = 'state.domain.view-settings.colour-by.UPDATE_COMPONENT_COLOUR';
    const $06538f246c9627b3$export$6276b3bbeed8dd7e = 'state.domain.view-settings.colour-by.REMOVE_COMPONENT_COLOUR';
    const $06538f246c9627b3$export$b3764a4f4a360f31 = 'state.domain.view-settings.colour-by.ADD_PRIORITY_COLOUR';
    const $06538f246c9627b3$export$6f995e7ddc07011d = 'state.domain.view-settings.colour-by.SET_PRIORITY_COLOUR_MAP';
    const $06538f246c9627b3$export$93b0e1785ade5311 = 'state.domain.view-settings.colour-by.UPDATE_PRIORITY_COLOUR';
    const $06538f246c9627b3$export$e735a906397ccf0f = 'state.domain.view-settings.colour-by.REMOVE_PRIORITY_COLOUR';
    const $06538f246c9627b3$export$229431d3c9de9119 = 'state.domain.view-settings.colour-by.ADD_SELECT_COLOUR';
    const $06538f246c9627b3$export$cc2ebe1808de3eaf = 'state.domain.view-settings.colour-by.UPDATE_SELECT_COLOUR';
    const $06538f246c9627b3$export$a72e3d03e03081fd = 'state.domain.view-settings.colour-by.REMOVE_SELECT_COLOUR';
    const $06538f246c9627b3$export$528cae8834a7aaba = 'state.domain.view-settings.colour-by.CLEAR_ALL_ISSUE_TYPE_COLOURS';
    const $06538f246c9627b3$export$f3d6db75bc058932 = 'state.domain.view-settings.colour-by.CLEAR_ALL_LABEL_COLOURS';
    const $06538f246c9627b3$export$92fd8171426ca27 = 'state.domain.view-settings.colour-by.CLEAR_ALL_PRIORITY_COLOURS';
    const $06538f246c9627b3$export$a9f87cf8b48c9f17 = 'state.domain.view-settings.colour-by.CLEAR_ALL_SELECT_COLOURS';
    const $06538f246c9627b3$export$4f3c0a419cae6844 = 'state.domain.view-settings.colour-by.CLEAR_ALL_COMPONENT_COLOURS';
    const $06538f246c9627b3$export$aad8462122ac592b = (payload)=>({
            type: $06538f246c9627b3$export$4a991c87e640ef77,
            payload: payload
        });
    const $06538f246c9627b3$export$c48a172e21f06e14 = (payload)=>({
            type: $06538f246c9627b3$export$1ed2e8cc5af52ec2,
            payload: payload
        });
    const $06538f246c9627b3$export$d5f986a0fd9fff3d = (payload)=>({
            type: $06538f246c9627b3$export$3e66ee5150a809d5,
            payload: payload
        });
    const $06538f246c9627b3$export$3d88424f2784ccca = (payload)=>({
            type: $06538f246c9627b3$export$3375e6b8e0671d88,
            payload: payload
        });
    const $06538f246c9627b3$export$d80371939c87a6d7 = (payload)=>({
            type: $06538f246c9627b3$export$96d619ae50e035a8,
            payload: payload
        });
    const $06538f246c9627b3$export$e5818852970cd077 = (payload)=>({
            type: $06538f246c9627b3$export$9c3daa8c244ed3c,
            payload: payload
        });
    const $06538f246c9627b3$export$cf61b392749df3f = ()=>({
            type: $06538f246c9627b3$export$99be6a41dc9f4ab2
        });
    const $06538f246c9627b3$export$b74745aa4e3de6b6 = (payload)=>({
            type: $06538f246c9627b3$export$a7aed6f0b1f757ad,
            payload: payload
        });
    const $06538f246c9627b3$export$45c2d6f3c09898c7 = (payload)=>({
            type: $06538f246c9627b3$export$278fc823cb39dabd,
            payload: payload
        });
    const $06538f246c9627b3$export$54e5405609708451 = ()=>({
            type: $06538f246c9627b3$export$528cae8834a7aaba
        });
    const $06538f246c9627b3$export$5f6974865002dbeb = ()=>({
            type: $06538f246c9627b3$export$3b20979dcb1bf726
        });
    const $06538f246c9627b3$export$d4bc34b40af5964a = (payload)=>({
            type: $06538f246c9627b3$export$30151323c3555d8e,
            payload: payload
        });
    const $06538f246c9627b3$export$577b6462cf2c190b = (payload)=>({
            type: $06538f246c9627b3$export$8a40cd78cd667ee0,
            payload: payload
        });
    const $06538f246c9627b3$export$6c6fbec7b1246d3b = ()=>({
            type: $06538f246c9627b3$export$f3d6db75bc058932
        });
    const $06538f246c9627b3$export$c06d80c47bf126b = ()=>({
            type: $06538f246c9627b3$export$b3764a4f4a360f31
        });
    const $06538f246c9627b3$export$38c255cf3dd1a29a = (payload)=>({
            type: $06538f246c9627b3$export$6f995e7ddc07011d,
            payload: payload
        });
    const $06538f246c9627b3$export$1460535d1143f247 = (payload)=>({
            type: $06538f246c9627b3$export$93b0e1785ade5311,
            payload: payload
        });
    const $06538f246c9627b3$export$e1d85b8f002c3a84 = (payload)=>({
            type: $06538f246c9627b3$export$e735a906397ccf0f,
            payload: payload
        });
    const $06538f246c9627b3$export$47367661758240c6 = ()=>({
            type: $06538f246c9627b3$export$92fd8171426ca27
        });
    const $06538f246c9627b3$export$670e2ed2e9b2440f = ()=>({
            type: $06538f246c9627b3$export$229431d3c9de9119
        });
    const $06538f246c9627b3$export$ef87fce70c438ed2 = (payload)=>({
            type: $06538f246c9627b3$export$cc2ebe1808de3eaf,
            payload: payload
        });
    const $06538f246c9627b3$export$2d31749d1b7ade6 = (payload)=>({
            type: $06538f246c9627b3$export$a72e3d03e03081fd,
            payload: payload
        });
    const $06538f246c9627b3$export$76831fdfcb69dda = ()=>({
            type: $06538f246c9627b3$export$a9f87cf8b48c9f17
        });
    const $06538f246c9627b3$export$3b1279f9abc2a577 = ()=>({
            type: $06538f246c9627b3$export$6dab2bbd46f0738
        });
    const $06538f246c9627b3$export$4f3671368b35342e = (payload)=>({
            type: $06538f246c9627b3$export$1604157578c815f3,
            payload: payload
        });
    const $06538f246c9627b3$export$fb2d993c8537820a = (payload)=>({
            type: $06538f246c9627b3$export$6276b3bbeed8dd7e,
            payload: payload
        });
    const $06538f246c9627b3$export$d36c83e78ef4db76 = ()=>({
            type: $06538f246c9627b3$export$4f3c0a419cae6844
        });
});
parcelRegister("kjgFt", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$865d39221e442843$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "createViewBody", ()=>$865d39221e442843$export$bbc51f09cfcea3dc);
    $parcel$export(module.exports, "updateViewBody", ()=>$865d39221e442843$export$4a0b5be06a9ebee9);
    $parcel$export(module.exports, "markAsDefaultViewBody", ()=>$865d39221e442843$export$12a4fa70d07eeb16);
    $parcel$export(module.exports, "renameViewBody", ()=>$865d39221e442843$export$7ab2dbfec76aec8);
    var $4nDwW = parcelRequire("4nDwW");
    const $865d39221e442843$export$bcae9ba627f604b6 = {
        userProperties: (planId, propName)=>`/rest/jpo/1.0/plans/${planId}/userProperties${(0, $4nDwW.isDefined)(propName) ? `/viewSwitching-${propName}` : ''}`,
        create: (planId)=>`/rest/jpo/1.0/plans/${planId}/savedviews`,
        view: (planId, viewId)=>`/rest/jpo/1.0/plans/${planId}/savedviews/${viewId}`
    };
    const $865d39221e442843$export$bbc51f09cfcea3dc = ({ name: name, isDefault: isDefault, preferences: preferences, isPredefined: isPredefined = false })=>({
            viewName: name,
            viewPreferences: preferences,
            isDefault: isDefault,
            isPredefined: isPredefined
        });
    const $865d39221e442843$export$4a0b5be06a9ebee9 = ({ name: name, version: version, isDefault: isDefault, preferences: preferences, isPredefined: isPredefined = false })=>({
            viewName: name,
            viewVersion: version,
            viewPreferences: preferences,
            markAsDefault: isDefault,
            isPredefined: isPredefined
        });
    const $865d39221e442843$export$12a4fa70d07eeb16 = ({ isDefault: isDefault })=>({
            markAsDefault: isDefault
        });
    const $865d39221e442843$export$7ab2dbfec76aec8 = ({ name: name })=>({
            viewName: name
        });
});
parcelRegister("afKbt", function(module, exports) {
    $parcel$export(module.exports, "migratePrefs", ()=>$2b2ec195f74d8495$export$3cd3a68476baaf89);
    var $bCWbL;
    var $gQJQq = parcelRequire("gQJQq");
    function $2b2ec195f74d8495$export$3cd3a68476baaf89(blob) {
        return (0, $gQJQq.default)(blob);
    }
    function $2b2ec195f74d8495$export$2e2bcd8739ae039(view) {
        const preferences = $2b2ec195f74d8495$export$3cd3a68476baaf89(view.preferences);
        return (0, parcelRequire("bCWbL")).default({
            preferences: preferences,
            original: view.original && $2b2ec195f74d8495$export$2e2bcd8739ae039(view.original)
        })(view);
    }
});
parcelRegister("gQJQq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec2e75b47555bbf6$export$2e2bcd8739ae039);
    var $bQZTk;
    var $8vuta = parcelRequire("8vuta");
    var $lWTEA = parcelRequire("lWTEA");
    var $9hy9Q = parcelRequire("9hy9Q");
    var $bTEyS = parcelRequire("bTEyS");
    var $gapJR = parcelRequire("gapJR");
    var $6nN6w = parcelRequire("6nN6w");
    var $4mUBy = parcelRequire("4mUBy");
    var $iNEqS = parcelRequire("iNEqS");
    var $5VXen = parcelRequire("5VXen");
    var $33Y77 = parcelRequire("33Y77");
    var $829nG = parcelRequire("829nG");
    var $6co0b = parcelRequire("6co0b");
    var $dmIdq = parcelRequire("dmIdq");
    var $20afy = parcelRequire("20afy");
    var $4sZjR = parcelRequire("4sZjR");
    var $01Tsj = parcelRequire("01Tsj");
    const $ec2e75b47555bbf6$var$normalize = (blob)=>(0, $829nG.default)(undefined, (0, $8vuta.reset)(blob));
    const $ec2e75b47555bbf6$var$migrate = [
        (0, $4mUBy.default),
        (0, $4mUBy.migrateCalendarFilters),
        (0, $lWTEA.default),
        (0, $dmIdq.default),
        (0, $5VXen.default),
        (0, $gapJR.default),
        (0, $gapJR.migrateListFieldColumns),
        (0, $20afy.default),
        (0, $6nN6w.default),
        (0, $6co0b.default),
        (0, $iNEqS.default),
        (0, $9hy9Q.default),
        (0, $33Y77.default),
        (0, $01Tsj.default),
        (0, $bTEyS.default),
        (0, $4sZjR.default)
    ].reduce((acc, fn)=>(0, parcelRequire("bQZTk")).default(acc, fn));
    const $ec2e75b47555bbf6$var$fromV0 = (0, parcelRequire("bQZTk")).default($ec2e75b47555bbf6$var$migrate, $ec2e75b47555bbf6$var$normalize);
    var $ec2e75b47555bbf6$export$2e2bcd8739ae039 = $ec2e75b47555bbf6$var$fromV0;
});
parcelRegister("lWTEA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51103472dc0bc164$export$2e2bcd8739ae039);
    var $5KaGt;
    var $gITL8 = parcelRequire("gITL8");
    var $hn71W = parcelRequire("hn71W");
    var $51103472dc0bc164$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return (0, parcelRequire("5KaGt")).default(prevState, {
                colourMaps: {
                    status: (0, $gITL8.statusColourMap)
                }
            });
        },
        V1: function fromV0ToV1(prevState) {
            return {
                ...prevState,
                colourIssueTypes: [],
                colourPriorities: []
            };
        },
        V2: function fromV1ToV2(prevState) {
            return {
                ...prevState,
                colourIssueTypeKeys: []
            };
        }
    }, {
        prefix: 'colourBy',
        from: 'V0'
    }));
});
parcelRegister("hn71W", function(module, exports) {
    $parcel$export(module.exports, "createMigrate", ()=>$2e3419959924071e$export$c1e9a1c26f76dca5);
    $parcel$export(module.exports, "incremental", ()=>$2e3419959924071e$export$4f53b643294ba29);
    var $d89qs;
    var $2XSIf;
    var $cbsWD;
    var $9U6ZH;
    var $2JlG5;
    var $83IGl;
    var $4Rr1a;
    var $iavfW;
    var $bQZTk;
    var $2rMKg;
    var $3JFoT;
    const $2e3419959924071e$export$bf95ba95946b416f = ({ from: from, to: to, migrate: migrate })=>(viewSettings)=>{
            const prevState = viewSettings[from];
            const nextState = migrate(prevState);
            return (0, parcelRequire("bQZTk")).default((0, parcelRequire("iavfW")).default([
                from
            ]), (0, parcelRequire("2XSIf")).default(to, nextState))(viewSettings);
        };
    const $2e3419959924071e$export$c1e9a1c26f76dca5 = (...steps)=>(viewSettings, options)=>{
            const currentVersion = (0, parcelRequire("bQZTk")).default((0, parcelRequire("3JFoT")).default, (0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('to')), steps[0] ? (0, parcelRequire("d89qs")).default(steps[0].from) : (0, parcelRequire("83IGl")).default, (0, parcelRequire("9U6ZH")).default((key)=>(0, parcelRequire("2JlG5")).default(key)(viewSettings)))(steps);
            if (!currentVersion) return viewSettings;
            const { steps: requiredSteps } = steps.reduce(({ steps: steps, started: started, ended: ended }, { from: from, to: to, migrate: migrate })=>{
                if (!started && currentVersion && from !== currentVersion) return {
                    steps: steps,
                    started: started,
                    ended: ended
                };
                if (ended) return {
                    steps: steps,
                    started: started,
                    ended: ended
                };
                const needSkipPrevSteps = from === currentVersion;
                const prevSteps = needSkipPrevSteps ? [] : steps;
                return {
                    steps: [
                        ...prevSteps,
                        {
                            from: from,
                            to: to,
                            migrate: migrate
                        }
                    ],
                    started: true,
                    ended: ended || to === (options && options.to)
                };
            }, {
                steps: [],
                started: false,
                ended: false
            });
            const migrate = requiredSteps.length > 0 ? (0, parcelRequire("cbsWD")).default((0, parcelRequire("bQZTk")).default, ...requiredSteps.map($2e3419959924071e$export$bf95ba95946b416f)) : (0, parcelRequire("83IGl")).default;
            return migrate(viewSettings);
        };
    const $2e3419959924071e$export$4f53b643294ba29 = (migrations, options)=>{
        const { prefix: prefix } = options;
        const getVersionNo = (Vx)=>Number((Vx.match(/^V([0-9]+)$/i) || [])[1]);
        const makeKey = (ver)=>`${prefix}V${ver}`;
        const versionNos = Object.keys(migrations).map(getVersionNo).sort();
        if (versionNos.find(Number.isNaN) !== undefined) throw new Error(`wrong version name in the migrations of ${prefix}`);
        const fromVerNo = getVersionNo(options.from);
        if (Number.isNaN(fromVerNo)) throw new Error('options.from must be correct version name');
        const [steps] = versionNos.reduce(([acc, prevVer], ver)=>{
            const from = makeKey(prevVer);
            const to = makeKey(ver);
            return [
                [
                    ...acc,
                    {
                        from: from,
                        to: to,
                        migrate: migrations[`V${ver}`]
                    }
                ],
                ver
            ];
        }, [
            [],
            fromVerNo
        ]);
        return steps;
    };
});
parcelRegister("d89qs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98f35573869676c6$export$2e2bcd8739ae039);
    var $6VFfk;
    var $c9RLn;
    var $98f35573869676c6$var$append = (0, (0, parcelRequire("c9RLn")).default)(function append(el, list) {
        return (0, (0, parcelRequire("6VFfk")).default)(list, [
            el
        ]);
    });
    var $98f35573869676c6$export$2e2bcd8739ae039 = $98f35573869676c6$var$append;
});
parcelRegister("cbsWD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8decf6f0ed66c5ca$export$2e2bcd8739ae039);
    var $8ibtc;
    var $8decf6f0ed66c5ca$var$call = (0, (0, parcelRequire("8ibtc")).default)(function call(fn) {
        return fn.apply(this, Array.prototype.slice.call(arguments, 1));
    });
    var $8decf6f0ed66c5ca$export$2e2bcd8739ae039 = $8decf6f0ed66c5ca$var$call;
});
parcelRegister("9hy9Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc5a47655559d5fb$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    var $fc5a47655559d5fb$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        }
    }, {
        prefix: 'componentGroups',
        from: 'V0'
    }));
});
parcelRegister("bTEyS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddbcf83770393a4b$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    var $ddbcf83770393a4b$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        }
    }, {
        prefix: 'dateConstraints',
        from: 'V0'
    }));
});
parcelRegister("gapJR", function(module, exports) {
    $parcel$export(module.exports, "migrateListFieldColumns", ()=>$eea9b3ed084fbbda$export$209345f4e458d066);
    $parcel$export(module.exports, "default", ()=>$eea9b3ed084fbbda$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    const $eea9b3ed084fbbda$export$209345f4e458d066 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        }
    }, {
        prefix: 'listFieldColumns',
        from: 'V0'
    }));
    var $eea9b3ed084fbbda$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        }
    }, {
        prefix: 'fieldColumns',
        from: 'V0'
    }));
});
parcelRegister("6nN6w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d78821a1622798c$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    var $2d78821a1622798c$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        },
        V1: function fromV0ToV1(prevState) {
            return {
                includeAncestors: true,
                includeDescendants: prevState.showFullHierarchy
            };
        }
    }, {
        prefix: 'filterOptions',
        from: 'V0'
    }));
});
parcelRegister("4mUBy", function(module, exports) {
    $parcel$export(module.exports, "migrateCalendarFilters", ()=>$6448fa8def738f2a$export$170d4d46a6fbbc5c);
    $parcel$export(module.exports, "default", ()=>$6448fa8def738f2a$export$2e2bcd8739ae039);
    var $hGgHi = parcelRequire("hGgHi");
    var $g4tDr;
    var $hn71W = parcelRequire("hn71W");
    var $cGbfF = parcelRequire("cGbfF");
    function $6448fa8def738f2a$export$2f30dc67536bf671(prevState) {
        return {
            ...prevState,
            [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: {
                id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                value: !(0, ($parcel$interopDefault($hGgHi)))(prevState[0, $cGbfF.HIERARCHY_FILTER_ID]?.value?.start) && !(0, ($parcel$interopDefault($hGgHi)))(prevState[0, $cGbfF.HIERARCHY_FILTER_ID]?.value?.end) ? {
                    start: prevState[0, $cGbfF.HIERARCHY_FILTER_ID].value.start - 1,
                    end: prevState[0, $cGbfF.HIERARCHY_FILTER_ID].value.end - 1
                } : {
                    start: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE),
                    end: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE)
                }
            }
        };
    }
    const $6448fa8def738f2a$export$170d4d46a6fbbc5c = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        },
        V1: $6448fa8def738f2a$export$2f30dc67536bf671
    }, {
        prefix: 'calendarFilters',
        from: 'V0'
    }));
    var $6448fa8def738f2a$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        },
        V1: $6448fa8def738f2a$export$2f30dc67536bf671
    }, {
        prefix: 'filters',
        from: 'V0'
    }));
});
parcelRegister("iNEqS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf2fa4ea1f3c2d13$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    var $bf2fa4ea1f3c2d13$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        }
    }, {
        prefix: 'highlightedVersions',
        from: 'V0'
    }));
});
parcelRegister("5VXen", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b53b3287a0e82d7$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    var $9b53b3287a0e82d7$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        }
    }, {
        prefix: 'issueExpansions',
        from: 'V0'
    }));
});
parcelRegister("33Y77", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2c42a98489755df$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    var $e2c42a98489755df$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        }
    }, {
        prefix: 'labelGroups',
        from: 'V0'
    }));
});
parcelRegister("829nG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ad25af9e1f896b2$export$2e2bcd8739ae039);
    var $dXWaA;
    var $iavfW;
    var $fes2p;
    var $3J2mc;
    var $5AWLh = parcelRequire("5AWLh");
    var $8vuta = parcelRequire("8vuta");
    var $cpNM6 = parcelRequire("cpNM6");
    var $8NMJu = parcelRequire("8NMJu");
    var $95TD9 = parcelRequire("95TD9");
    var $l1ynw = parcelRequire("l1ynw");
    var $9TkDW = parcelRequire("9TkDW");
    var $g71OY = parcelRequire("g71OY");
    var $dLsoG = parcelRequire("dLsoG");
    var $2oMbL = parcelRequire("2oMbL");
    var $8stsm = parcelRequire("8stsm");
    var $jvli8 = parcelRequire("jvli8");
    var $8goh7 = parcelRequire("8goh7");
    var $bgTG2 = parcelRequire("bgTG2");
    var $3vCHD = parcelRequire("3vCHD");
    var $cUSVc = parcelRequire("cUSVc");
    var $5moO9 = parcelRequire("5moO9");
    var $1HJaL = parcelRequire("1HJaL");
    var $gnCZy = parcelRequire("gnCZy");
    const $2ad25af9e1f896b2$var$reducersByKey = {
        filtersV1: (0, $8stsm.default),
        colourByV2: (0, $8NMJu.default),
        timeScaleV1: (0, $cUSVc.default),
        issueExpansionsV0: (0, $8goh7.default),
        fieldColumnsV0: (0, $dLsoG.default),
        filterOptionsV1: (0, $2oMbL.default),
        rollupSettingsV0: (0, $3vCHD.default),
        highlightedVersionsV0: (0, $jvli8.default),
        componentGroupsV0: (0, $95TD9.default),
        labelGroupsV0: (0, $bgTG2.default),
        customFieldValuesGroupsV0: (0, $l1ynw.default),
        warningSettingsV1: (0, $gnCZy.default),
        dateConstraintsV0: (0, $9TkDW.default),
        visualisationsV0: (0, $1HJaL.default),
        dependencySettingsV0: (0, $g71OY.default),
        listFieldColumnsV0: (0, $dLsoG.default),
        viewModeV0: (0, $5moO9.default),
        calendarFiltersV1: (0, $8stsm.default),
        activeFilterViewV0: (0, $cpNM6.default)
    };
    const $2ad25af9e1f896b2$var$FIELD_COLUMNS_KEY = 'fieldColumnsV0';
    const $2ad25af9e1f896b2$var$LIST_FIELD_COLUMNS_KEY = 'listFieldColumnsV0';
    const $2ad25af9e1f896b2$var$FILTERS_KEY = 'filtersV1';
    const $2ad25af9e1f896b2$var$CALENDAR_FILTERS_KEY = 'calendarFiltersV1';
    const $2ad25af9e1f896b2$var$combined = (0, $5AWLh.combineReducers)($2ad25af9e1f896b2$var$reducersByKey);
    const $2ad25af9e1f896b2$var$initialState = $2ad25af9e1f896b2$var$combined(undefined, {
        type: ''
    });
    function $2ad25af9e1f896b2$export$2e2bcd8739ae039(state = $2ad25af9e1f896b2$var$initialState, action) {
        const resetState = $2ad25af9e1f896b2$var$initialState;
        switch(action.type){
            case 0, $8vuta.RESET:
                {
                    const pickExact = (0, parcelRequire("fes2p")).default(Object.keys(resetState).filter((key)=>key !== 'activeFilterViewV0'));
                    return (0, parcelRequire("dXWaA")).default(pickExact(action.payload))(resetState);
                }
            default:
                {
                    const fieldColumnsKey = state.viewModeV0?.mode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST ? $2ad25af9e1f896b2$var$LIST_FIELD_COLUMNS_KEY : $2ad25af9e1f896b2$var$FIELD_COLUMNS_KEY;
                    const filtersKey = state.activeFilterViewV0 === 'calendar' ? $2ad25af9e1f896b2$var$CALENDAR_FILTERS_KEY : $2ad25af9e1f896b2$var$FILTERS_KEY;
                    return {
                        ...state,
                        ...(0, parcelRequire("iavfW")).default([
                            $2ad25af9e1f896b2$var$FIELD_COLUMNS_KEY,
                            $2ad25af9e1f896b2$var$LIST_FIELD_COLUMNS_KEY,
                            $2ad25af9e1f896b2$var$FILTERS_KEY,
                            $2ad25af9e1f896b2$var$CALENDAR_FILTERS_KEY
                        ], $2ad25af9e1f896b2$var$combined(state, action)),
                        [fieldColumnsKey]: (0, $dLsoG.default)(state[fieldColumnsKey], action),
                        [filtersKey]: (0, $8stsm.default)(state[filtersKey], action)
                    };
                }
        }
    }
});
parcelRegister("5AWLh", function(module, exports) {
    $parcel$export(module.exports, "combineReducers", ()=>$3c2e13b1a7ae3665$export$66e4520cdb265d18);
    $parcel$export(module.exports, "errorReporterMiddleware", ()=>$3c2e13b1a7ae3665$export$6aaec9220272ce3d);
    var $3f2cs = parcelRequire("3f2cs");
    var $4PSWi = parcelRequire("4PSWi");
    var $9J1HQ;
    var $jzfDl;
    var $j0d94;
    var $jcw0u;
    var $eWre9 = parcelRequire("eWre9");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $3c2e13b1a7ae3665$var$distance = (0, parcelRequire("9J1HQ")).default(2, (0, ($parcel$interopDefault($4PSWi))).get);
    const $3c2e13b1a7ae3665$var$speller = (suggestions)=>(typo)=>(0, parcelRequire("j0d94")).default((0, parcelRequire("jzfDl")).default($3c2e13b1a7ae3665$var$distance(typo)), '', suggestions);
    function $3c2e13b1a7ae3665$export$66e4520cdb265d18(reducers, composite) {
        const combinedReducers = (0, $3f2cs.combineReducers)(reducers);
        if (!composite) return combinedReducers;
        const getSuggestion = $3c2e13b1a7ae3665$var$speller(Object.keys(reducers));
        return (previousState, action)=>{
            const state = combinedReducers(previousState, action);
            if (!composite) return state;
            const compositeActions = composite(state, action);
            const compositeActionsKeys = Object.keys(compositeActions);
            const nextState = {
                ...state
            };
            let hasChanged = false;
            for (const key of compositeActionsKeys){
                const reducer = reducers[key];
                if (!reducer) throw new Error(`Composite returned missing reducer "${key}", did you mean "${getSuggestion(key)}"?`);
                const stateForKey = state[key];
                const nextStateForKey = (0, parcelRequire("j0d94")).default(reducer, stateForKey, compositeActions[key]);
                hasChanged = hasChanged || nextStateForKey !== stateForKey;
                nextState[key] = nextStateForKey;
            }
            return hasChanged ? nextState : state;
        };
    }
    const $3c2e13b1a7ae3665$export$6aaec9220272ce3d = ()=>(next)=>(action)=>{
                try {
                    return next(action);
                } catch (err) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: (0, $TTKUQ.ERROR_REPORTING_PACKAGE).REDUX,
                            packageName: (0, $TTKUQ.PACKAGE_NAME),
                            teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                        },
                        error: err,
                        attributes: {
                            action: action.type
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    return next((0, $eWre9.showError)(err.message, err.stack, window?.location.hash, window?.location.pathname));
                }
            };
});
parcelRegister("4PSWi", function(module, exports) {
    (function() {
        'use strict';
        var collator;
        try {
            collator = typeof Intl !== "undefined" && typeof Intl.Collator !== "undefined" ? Intl.Collator("generic", {
                sensitivity: "base"
            }) : null;
        } catch (err) {
            console.log("Collator could not be initialized and wouldn't be used");
        }
        var prevRow = [], str2Char = [];
        var Levenshtein = {
            get: function(str1, str2, options) {
                var useCollator = options && collator && options.useCollator;
                var str1Len = str1.length, str2Len = str2.length;
                if (str1Len === 0) return str2Len;
                if (str2Len === 0) return str1Len;
                var curCol, nextCol, i, j, tmp;
                for(i = 0; i < str2Len; ++i){
                    prevRow[i] = i;
                    str2Char[i] = str2.charCodeAt(i);
                }
                prevRow[str2Len] = str2Len;
                var strCmp;
                if (useCollator) for(i = 0; i < str1Len; ++i){
                    nextCol = i + 1;
                    for(j = 0; j < str2Len; ++j){
                        curCol = nextCol;
                        strCmp = 0 === collator.compare(str1.charAt(i), String.fromCharCode(str2Char[j]));
                        nextCol = prevRow[j] + (strCmp ? 0 : 1);
                        tmp = curCol + 1;
                        if (nextCol > tmp) nextCol = tmp;
                        tmp = prevRow[j + 1] + 1;
                        if (nextCol > tmp) nextCol = tmp;
                        prevRow[j] = curCol;
                    }
                    prevRow[j] = nextCol;
                }
                else for(i = 0; i < str1Len; ++i){
                    nextCol = i + 1;
                    for(j = 0; j < str2Len; ++j){
                        curCol = nextCol;
                        strCmp = str1.charCodeAt(i) === str2Char[j];
                        nextCol = prevRow[j] + (strCmp ? 0 : 1);
                        tmp = curCol + 1;
                        if (nextCol > tmp) nextCol = tmp;
                        tmp = prevRow[j + 1] + 1;
                        if (nextCol > tmp) nextCol = tmp;
                        prevRow[j] = curCol;
                    }
                    prevRow[j] = nextCol;
                }
                return nextCol;
            }
        };
        if (typeof define !== "undefined" && define !== null && define.amd) define(function() {
            return Levenshtein;
        });
        else if (module !== null && true && module.exports === exports) module.exports = Levenshtein;
        else if (typeof self !== "undefined" && typeof self.postMessage === 'function' && typeof self.importScripts === 'function') self.Levenshtein = Levenshtein;
        else if (typeof window !== "undefined" && window !== null) window.Levenshtein = Levenshtein;
    })();
});
parcelRegister("jzfDl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3ed69afa12fc1f9$export$2e2bcd8739ae039);
    var $IYMZh;
    var $e3ed69afa12fc1f9$var$minBy = (0, (0, parcelRequire("IYMZh")).default)(function minBy(f, a, b) {
        return f(b) < f(a) ? b : a;
    });
    var $e3ed69afa12fc1f9$export$2e2bcd8739ae039 = $e3ed69afa12fc1f9$var$minBy;
});
parcelRegister("cpNM6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff5d3e6878919a73$export$2e2bcd8739ae039);
    var $hHqKh = parcelRequire("hHqKh");
    const $ff5d3e6878919a73$var$reducer = (state = 'timeline', action)=>{
        switch(action.type){
            case 0, $hHqKh.CHANGE_ACTIVE_FILTER_VIEW:
                return action.payload;
            default:
                return state;
        }
    };
    var $ff5d3e6878919a73$export$2e2bcd8739ae039 = $ff5d3e6878919a73$var$reducer;
});
parcelRegister("hHqKh", function(module, exports) {
    $parcel$export(module.exports, "CHANGE_ACTIVE_FILTER_VIEW", ()=>$350ab8fd06e6b781$export$34894007d3f39391);
    $parcel$export(module.exports, "changeActiveFilterView", ()=>$350ab8fd06e6b781$export$b74a806f82bb5aa7);
    const $350ab8fd06e6b781$export$34894007d3f39391 = 'state.domain.views.SET_ACTIVE_FILTER_VIEW';
    const $350ab8fd06e6b781$export$b74a806f82bb5aa7 = (payload)=>({
            type: $350ab8fd06e6b781$export$34894007d3f39391,
            payload: payload
        });
});
parcelRegister("8NMJu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4b1b9f3e2458a35$export$2e2bcd8739ae039);
    var $02IP9;
    var $bWXax;
    var $bCilb;
    var $cXTmV;
    var $gITL8 = parcelRequire("gITL8");
    var $clsih = parcelRequire("clsih");
    const $e4b1b9f3e2458a35$export$d4c72bab9d6cc13a = {
        colourByValue: (0, $gITL8.colourByOptions).NONE,
        colourComponents: [],
        colourIssueTypes: [],
        colourIssueTypeKeys: [],
        colourLabels: [],
        colourMaps: {
            none: {},
            project: {},
            status: (0, $gITL8.statusColourMap),
            team: {}
        },
        colourPriorities: [],
        colourSelects: {},
        lastUsed: 0
    };
    const $e4b1b9f3e2458a35$export$1650419e431d3ba3 = (state = $e4b1b9f3e2458a35$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $clsih.RESET:
                return {
                    ...action.payload
                };
            case 0, $clsih.SET_COLOUR_BY_VALUE:
                {
                    const { id: id } = action.payload;
                    return {
                        ...state,
                        colourByValue: id
                    };
                }
            case 0, $clsih.SET_COLOUR_MAP:
                {
                    const { id: id, map: map } = action.payload;
                    return {
                        ...state,
                        colourMaps: {
                            ...state.colourMaps,
                            [id]: map
                        }
                    };
                }
            case 0, $clsih.UPDATE_TEAM_ID:
                {
                    const { oldId: oldId, newId: newId } = action.payload;
                    const map = state.colourMaps.team;
                    const colour = map[oldId];
                    return {
                        ...state,
                        colourMaps: {
                            ...state.colourMaps,
                            team: {
                                ...(0, parcelRequire("bWXax")).default(oldId, map),
                                [newId]: colour
                            }
                        }
                    };
                }
            case 0, $clsih.SET_COLOUR_FOR_NEW_TEAM:
                {
                    const { id: id } = action.payload;
                    const { lastUsed: lastUsed, colourMaps: colourMaps } = state;
                    const nextColourIndex = (lastUsed + 1) % (0, $gITL8.colourPalette).length;
                    const colour = (0, $gITL8.colourPalette)[nextColourIndex];
                    return {
                        ...state,
                        colourMaps: {
                            ...state.colourMaps,
                            team: {
                                ...colourMaps.team,
                                [id]: colour
                            }
                        },
                        lastUsed: nextColourIndex
                    };
                }
            case 0, $clsih.REMOVE_TEAM_ID:
                {
                    const { id: id } = action.payload;
                    return {
                        ...state,
                        colourMaps: {
                            ...state.colourMaps,
                            team: (0, parcelRequire("bWXax")).default(id, state.colourMaps.team)
                        }
                    };
                }
            case 0, $clsih.ADD_ISSUE_TYPE_COLOUR:
                return {
                    ...state,
                    colourIssueTypes: [
                        ...state.colourIssueTypes,
                        {
                            issueTypes: []
                        }
                    ]
                };
            case 0, $clsih.UPDATE_ISSUE_TYPE_COLOUR:
                {
                    const { index: index, ...patch } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        colourIssueTypes: (0, parcelRequire("02IP9")).default(index, (item)=>({
                                ...item,
                                ...patch
                            }))
                    }, state);
                }
            case 0, $clsih.REMOVE_ISSUE_TYPE_COLOUR:
                {
                    const { index: index } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        colourIssueTypes: (0, parcelRequire("cXTmV")).default(index, 1)
                    }, state);
                }
            case 0, $clsih.ADD_LABEL_COLOUR:
                return {
                    ...state,
                    colourLabels: [
                        ...state.colourLabels,
                        {
                            labels: []
                        }
                    ]
                };
            case 0, $clsih.UPDATE_LABEL_COLOUR:
                {
                    const { index: index, ...patch } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        colourLabels: (0, parcelRequire("02IP9")).default(index, (item)=>({
                                ...item,
                                ...patch
                            }))
                    }, state);
                }
            case 0, $clsih.REMOVE_LABEL_COLOUR:
                {
                    const { index: index } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        colourLabels: (0, parcelRequire("cXTmV")).default(index, 1)
                    }, state);
                }
            case 0, $clsih.ADD_COMPONENT_COLOUR:
                return {
                    ...state,
                    colourComponents: [
                        ...state.colourComponents,
                        {
                            components: []
                        }
                    ]
                };
            case 0, $clsih.UPDATE_COMPONENT_COLOUR:
                {
                    const { index: index, ...patch } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        colourComponents: (0, parcelRequire("02IP9")).default(index, (item)=>({
                                ...item,
                                ...patch
                            }))
                    }, state);
                }
            case 0, $clsih.REMOVE_COMPONENT_COLOUR:
                {
                    const { index: index } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        colourComponents: (0, parcelRequire("cXTmV")).default(index, 1)
                    }, state);
                }
            case 0, $clsih.ADD_PRIORITY_COLOUR:
                return {
                    ...state,
                    colourPriorities: [
                        ...state.colourPriorities,
                        {
                            priorities: []
                        }
                    ]
                };
            case 0, $clsih.SET_PRIORITY_COLOUR_MAP:
                {
                    const { chunks: chunks, issuePrioritiesIdList: issuePrioritiesIdList } = action.payload;
                    const priorities = [];
                    let start = 0;
                    (0, $gITL8.priorityColourMap).forEach((colour, index)=>{
                        priorities.push({
                            colour: colour,
                            priorities: issuePrioritiesIdList.slice(start, start + chunks[index])
                        });
                        start += chunks[index];
                    });
                    return {
                        ...state,
                        colourPriorities: priorities
                    };
                }
            case 0, $clsih.UPDATE_PRIORITY_COLOUR:
                {
                    const { index: index, ...patch } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        colourPriorities: (0, parcelRequire("02IP9")).default(index, (item)=>({
                                ...item,
                                ...patch
                            }))
                    }, state);
                }
            case 0, $clsih.REMOVE_PRIORITY_COLOUR:
                {
                    const { index: index } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        colourPriorities: (0, parcelRequire("cXTmV")).default(index, 1)
                    }, state);
                }
            case 0, $clsih.ADD_SELECT_COLOUR:
                return {
                    ...state,
                    colourSelects: {
                        ...state.colourSelects,
                        [state.colourByValue]: [
                            ...state.colourSelects[state.colourByValue] || [],
                            {
                                options: []
                            }
                        ]
                    }
                };
            case 0, $clsih.UPDATE_SELECT_COLOUR:
                {
                    const { index: index, ...patch } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        colourSelects: {
                            [state.colourByValue]: (0, parcelRequire("02IP9")).default(index, (item)=>({
                                    ...item,
                                    ...patch
                                }))
                        }
                    }, state);
                }
            case 0, $clsih.REMOVE_SELECT_COLOUR:
                {
                    const { index: index } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        colourSelects: {
                            [state.colourByValue]: (0, parcelRequire("cXTmV")).default(index, 1)
                        }
                    }, state);
                }
            case 0, $clsih.CLEAR_ALL_COMPONENT_COLOURS:
                return {
                    ...state,
                    colourComponents: []
                };
            case 0, $clsih.CLEAR_ALL_ISSUE_TYPE_COLOURS:
                return {
                    ...state,
                    colourIssueTypes: []
                };
            case 0, $clsih.CLEAR_ALL_LABEL_COLOURS:
                return {
                    ...state,
                    colourLabels: []
                };
            case 0, $clsih.CLEAR_ALL_PRIORITY_COLOURS:
                return {
                    ...state,
                    colourPriorities: []
                };
            case 0, $clsih.CLEAR_ALL_SELECT_COLOURS:
                return {
                    ...state,
                    colourSelects: {
                        ...state.colourSelects,
                        [state.colourByValue]: []
                    }
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $e4b1b9f3e2458a35$export$2e2bcd8739ae039 = $e4b1b9f3e2458a35$export$1650419e431d3ba3;
});
parcelRegister("95TD9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6584927b9061005d$export$2e2bcd8739ae039);
    var $02IP9;
    var $ik0Qc;
    var $4nDwW = parcelRequire("4nDwW");
    var $duJmw = parcelRequire("duJmw");
    const $6584927b9061005d$var$initialState = [
        {
            id: (0, $10afd8ee8013ce61$export$526fec6b76d5bc5),
            name: '',
            isExpanded: false,
            components: []
        }
    ];
    const $6584927b9061005d$var$reducer = (state = $6584927b9061005d$var$initialState, action)=>{
        switch(action.type){
            case 0, $duJmw.RESET:
                {
                    const initialGroup = action.payload.find(({ id: id })=>id === (0, $10afd8ee8013ce61$export$526fec6b76d5bc5));
                    if ((0, $4nDwW.isDefined)(initialGroup)) return [
                        ...action.payload
                    ];
                    return [
                        ...$6584927b9061005d$var$initialState,
                        ...action.payload
                    ];
                }
            case 0, $duJmw.CLEAR_ALL:
                return $6584927b9061005d$var$initialState;
            case 0, $duJmw.ADD:
                return [
                    ...state,
                    action.payload
                ];
            case 0, $duJmw.UPDATE:
                {
                    const { payload: payload } = action;
                    const index = state.findIndex(({ id: id })=>id === payload.id);
                    return (0, parcelRequire("02IP9")).default(index, (component)=>(0, parcelRequire("ik0Qc")).default(component, payload.patch), state);
                }
            case 0, $duJmw.REMOVE:
                {
                    const { payload: payload } = action;
                    return state.filter(({ id: id })=>id !== payload);
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $6584927b9061005d$export$2e2bcd8739ae039 = $6584927b9061005d$var$reducer;
});
parcelRegister("duJmw", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$d946c2c8e29e66b8$export$4a991c87e640ef77);
    $parcel$export(module.exports, "CLEAR_ALL", ()=>$d946c2c8e29e66b8$export$a4b3b534f9c4179f);
    $parcel$export(module.exports, "ADD", ()=>$d946c2c8e29e66b8$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "UPDATE", ()=>$d946c2c8e29e66b8$export$e271b26eefe41db8);
    $parcel$export(module.exports, "REMOVE", ()=>$d946c2c8e29e66b8$export$29d55e1f664a246b);
    $parcel$export(module.exports, "clearAll", ()=>$d946c2c8e29e66b8$export$1042faa6df30c26);
    $parcel$export(module.exports, "add", ()=>$d946c2c8e29e66b8$export$e16d8520af44a096);
    $parcel$export(module.exports, "update", ()=>$d946c2c8e29e66b8$export$722fbec263ad908a);
    $parcel$export(module.exports, "remove", ()=>$d946c2c8e29e66b8$export$cd7f480d6b8286c3);
    const $d946c2c8e29e66b8$export$4a991c87e640ef77 = 'state.domain.view-settings.component-groups.RESET';
    const $d946c2c8e29e66b8$export$a4b3b534f9c4179f = 'state.domain.view-settings.component-groups.CLEAR_ALL';
    const $d946c2c8e29e66b8$export$bb6389024b71c2ae = 'state.domain.view-settings.component-groups.ADD';
    const $d946c2c8e29e66b8$export$e271b26eefe41db8 = 'state.domain.view-settings.component-groups.UPDATE';
    const $d946c2c8e29e66b8$export$29d55e1f664a246b = 'state.domain.view-settings.component-groups.REMOVE';
    const $d946c2c8e29e66b8$export$aad8462122ac592b = (payload)=>({
            type: $d946c2c8e29e66b8$export$4a991c87e640ef77,
            payload: payload
        });
    const $d946c2c8e29e66b8$export$1042faa6df30c26 = ()=>({
            type: $d946c2c8e29e66b8$export$a4b3b534f9c4179f
        });
    const $d946c2c8e29e66b8$export$e16d8520af44a096 = (payload)=>({
            type: $d946c2c8e29e66b8$export$bb6389024b71c2ae,
            payload: payload
        });
    const $d946c2c8e29e66b8$export$722fbec263ad908a = (payload)=>({
            type: $d946c2c8e29e66b8$export$e271b26eefe41db8,
            payload: payload
        });
    const $d946c2c8e29e66b8$export$cd7f480d6b8286c3 = (payload)=>({
            type: $d946c2c8e29e66b8$export$29d55e1f664a246b,
            payload: payload
        });
});
parcelRegister("l1ynw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9343d86a3e8fa972$export$2e2bcd8739ae039);
    var $02IP9;
    var $ik0Qc;
    var $aGrEZ = parcelRequire("aGrEZ");
    const $9343d86a3e8fa972$var$initialState = {};
    const $9343d86a3e8fa972$var$getAllOtherIssuesGroup = (grouping)=>({
            id: (0, $36c0257b9da5ad27$export$526fec6b76d5bc5),
            name: '',
            isExpanded: false,
            [grouping]: []
        });
    const $9343d86a3e8fa972$var$reducer = (state = $9343d86a3e8fa972$var$initialState, action)=>{
        switch(action.type){
            case 0, $aGrEZ.RESET:
                return {
                    ...state,
                    [action.payload.grouping]: action.payload.groups
                };
            case 0, $aGrEZ.CLEAR_ALL:
                return {
                    ...state,
                    [action.payload.grouping]: [
                        $9343d86a3e8fa972$var$getAllOtherIssuesGroup(action.payload.grouping)
                    ]
                };
            case 0, $aGrEZ.ADD:
                {
                    const groups = state[action.payload.grouping] || [
                        $9343d86a3e8fa972$var$getAllOtherIssuesGroup(action.payload.grouping)
                    ];
                    return {
                        ...state,
                        [action.payload.grouping]: [
                            ...groups,
                            action.payload.group
                        ]
                    };
                }
            case 0, $aGrEZ.UPDATE:
                {
                    const { payload: payload } = action;
                    const groups = state[payload.grouping] || [];
                    const index = groups.findIndex(({ id: id })=>id === action.payload.id);
                    return {
                        ...state,
                        [payload.grouping]: (0, parcelRequire("02IP9")).default(index, (group)=>(0, parcelRequire("ik0Qc")).default(group, payload.patch), groups)
                    };
                }
            case 0, $aGrEZ.REMOVE:
                {
                    const { payload: payload } = action;
                    const groups = state[payload.grouping] || [];
                    return {
                        ...state,
                        [payload.grouping]: groups.filter(({ id: id })=>id !== payload.id)
                    };
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $9343d86a3e8fa972$export$2e2bcd8739ae039 = $9343d86a3e8fa972$var$reducer;
});
parcelRegister("aGrEZ", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$576690cabd24186d$export$4a991c87e640ef77);
    $parcel$export(module.exports, "CLEAR_ALL", ()=>$576690cabd24186d$export$a4b3b534f9c4179f);
    $parcel$export(module.exports, "ADD", ()=>$576690cabd24186d$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "UPDATE", ()=>$576690cabd24186d$export$e271b26eefe41db8);
    $parcel$export(module.exports, "REMOVE", ()=>$576690cabd24186d$export$29d55e1f664a246b);
    $parcel$export(module.exports, "clearAll", ()=>$576690cabd24186d$export$1042faa6df30c26);
    $parcel$export(module.exports, "add", ()=>$576690cabd24186d$export$e16d8520af44a096);
    $parcel$export(module.exports, "update", ()=>$576690cabd24186d$export$722fbec263ad908a);
    $parcel$export(module.exports, "remove", ()=>$576690cabd24186d$export$cd7f480d6b8286c3);
    const $576690cabd24186d$export$4a991c87e640ef77 = 'state.domain.view-settings.custom-field-values-groups.RESET';
    const $576690cabd24186d$export$a4b3b534f9c4179f = 'state.domain.view-settings.custom-field-values-groups.CLEAR_ALL';
    const $576690cabd24186d$export$bb6389024b71c2ae = 'state.domain.view-settings.custom-field-values-groups.ADD';
    const $576690cabd24186d$export$e271b26eefe41db8 = 'state.domain.view-settings.custom-field-values-groups.UPDATE';
    const $576690cabd24186d$export$29d55e1f664a246b = 'state.domain.view-settings.custom-field-values-groups.REMOVE';
    const $576690cabd24186d$export$aad8462122ac592b = (payload)=>({
            type: $576690cabd24186d$export$4a991c87e640ef77,
            payload: payload
        });
    const $576690cabd24186d$export$1042faa6df30c26 = (payload)=>({
            type: $576690cabd24186d$export$a4b3b534f9c4179f,
            payload: payload
        });
    const $576690cabd24186d$export$e16d8520af44a096 = (payload)=>({
            type: $576690cabd24186d$export$bb6389024b71c2ae,
            payload: payload
        });
    const $576690cabd24186d$export$722fbec263ad908a = (payload)=>({
            type: $576690cabd24186d$export$e271b26eefe41db8,
            payload: payload
        });
    const $576690cabd24186d$export$cd7f480d6b8286c3 = (payload)=>({
            type: $576690cabd24186d$export$29d55e1f664a246b,
            payload: payload
        });
});
parcelRegister("9TkDW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$014afabb128c2df0$export$2e2bcd8739ae039);
    var $4204u = parcelRequire("4204u");
    const $014afabb128c2df0$var$initialState = {
        showDateConstraints: false
    };
    const $014afabb128c2df0$var$reducer = (state = $014afabb128c2df0$var$initialState, action)=>{
        switch(action.type){
            case 0, $4204u.RESET_SHOW_DATE_CONSTRAINTS:
                return {
                    ...state,
                    showDateConstraints: action.payload.showDateConstraints
                };
            case 0, $4204u.TOGGLE_SHOW_DATE_CONSTRAINTS:
                return {
                    ...state,
                    showDateConstraints: !state.showDateConstraints
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $014afabb128c2df0$export$2e2bcd8739ae039 = $014afabb128c2df0$var$reducer;
});
parcelRegister("4204u", function(module, exports) {
    $parcel$export(module.exports, "TOGGLE_SHOW_DATE_CONSTRAINTS", ()=>$f9e564c1f2108a24$export$918e26cf26b9a386);
    $parcel$export(module.exports, "RESET_SHOW_DATE_CONSTRAINTS", ()=>$f9e564c1f2108a24$export$a412b36a73383e70);
    const $f9e564c1f2108a24$export$918e26cf26b9a386 = 'state.domain.view-settings.date-constraints-setting.TOGGLE_SHOW_DATE_CONSTRAINTS';
    const $f9e564c1f2108a24$export$a412b36a73383e70 = 'state.domain.view-settings.date-constraints-setting.RESET_SHOW_DATE_CONSTRAINTS';
    const $f9e564c1f2108a24$export$50afbc86dffb6fd9 = ()=>({
            type: $f9e564c1f2108a24$export$918e26cf26b9a386
        });
    const $f9e564c1f2108a24$export$56eae6b516154c2e = (payload)=>({
            type: $f9e564c1f2108a24$export$a412b36a73383e70,
            payload: payload
        });
});
parcelRegister("g71OY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41eb1de75d92497a$export$2e2bcd8739ae039);
    var $hLj4s = parcelRequire("hLj4s");
    const $41eb1de75d92497a$var$initialState = {
        display: 'default'
    };
    const $41eb1de75d92497a$var$reducer = (state = $41eb1de75d92497a$var$initialState, action)=>{
        switch(action.type){
            case 0, $hLj4s.CHANGE_DISPLAY:
                return {
                    ...state,
                    display: action.payload.display
                };
            default:
                return {
                    ...state,
                    display: state.display || 'default'
                };
        }
    };
    var $41eb1de75d92497a$export$2e2bcd8739ae039 = $41eb1de75d92497a$var$reducer;
});
parcelRegister("hLj4s", function(module, exports) {
    $parcel$export(module.exports, "CHANGE_DISPLAY", ()=>$6a38875a292fc3c6$export$b08c2aa538b0eed6);
    $parcel$export(module.exports, "changeDisplay", ()=>$6a38875a292fc3c6$export$d6a8b85d53ecacd8);
    const $6a38875a292fc3c6$export$b08c2aa538b0eed6 = 'state.domain.view-settings.dependency-settings.DISPLAY';
    const $6a38875a292fc3c6$export$d6a8b85d53ecacd8 = (payload)=>({
            type: $6a38875a292fc3c6$export$b08c2aa538b0eed6,
            payload: payload
        });
});
parcelRegister("dLsoG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f6406adf4ed2e13$export$2e2bcd8739ae039);
    var $4nDwW = parcelRequire("4nDwW");
    var $4ArTT = parcelRequire("4ArTT");
    var $7lpPk = parcelRequire("7lpPk");
    const $9f6406adf4ed2e13$export$d4c72bab9d6cc13a = {
        columns: [
            {
                id: 'targetStart',
                isVisible: true
            },
            {
                id: 'targetEnd',
                isVisible: true
            },
            {
                id: 'issueStatus',
                isVisible: true
            }
        ]
    };
    const $9f6406adf4ed2e13$export$40791e2b75f99dde = (columns, id, isVisible)=>{
        const safeColumns = columns.filter((col)=>col.id !== (0, $7lpPk.ADD_FIELDS_COLUMN_ID));
        return [
            ...safeColumns.filter((col)=>col.id !== id),
            {
                id: id,
                isVisible: isVisible
            }
        ];
    };
    const $9f6406adf4ed2e13$export$d1fbe0eb3fc9219 = (columns, columnToMove, moveToTheIndexOf)=>{
        const indexOfColumnToMove = columns.findIndex((col)=>col.id === columnToMove);
        let indexOfMoveTo = columns.findIndex((col)=>col.id === moveToTheIndexOf);
        if (columnToMove === 'incomingDependencies') {
            const incomingDependencyMoveResults = (0, $4nDwW.move)(indexOfColumnToMove, indexOfMoveTo, columns);
            const outgoingDependencyIndex = incomingDependencyMoveResults.findIndex((col)=>col.id === 'outgoingDependencies');
            const indexOfMoveToForOutgoingDependency = incomingDependencyMoveResults.findIndex((col)=>col.id === 'incomingDependencies');
            const delta = outgoingDependencyIndex > indexOfMoveToForOutgoingDependency ? 1 : 0;
            const result = (0, $4nDwW.move)(outgoingDependencyIndex, indexOfMoveToForOutgoingDependency + delta, incomingDependencyMoveResults);
            return result;
        }
        if (moveToTheIndexOf === 'incomingDependencies') {
            const delta = indexOfMoveTo > indexOfColumnToMove ? 1 : 0;
            indexOfMoveTo += delta;
        }
        return (0, $4nDwW.move)(indexOfColumnToMove, indexOfMoveTo, columns);
    };
    const $9f6406adf4ed2e13$var$reducer = (state = $9f6406adf4ed2e13$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $4ArTT.RESET:
                return {
                    ...action.payload
                };
            case 0, $4ArTT.SHOW_COLUMN:
                return {
                    ...state,
                    columns: $9f6406adf4ed2e13$export$40791e2b75f99dde(state.columns, action.id, true)
                };
            case 0, $4ArTT.HIDE_COLUMN:
                return {
                    ...state,
                    columns: $9f6406adf4ed2e13$export$40791e2b75f99dde(state.columns, action.id, false)
                };
            case 0, $4ArTT.MOVE_COLUMN:
                return {
                    ...state,
                    columns: [
                        ...$9f6406adf4ed2e13$export$d1fbe0eb3fc9219(state.columns, action.payload.columnToMove, action.payload.moveToTheIndexOf)
                    ]
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $9f6406adf4ed2e13$export$2e2bcd8739ae039 = $9f6406adf4ed2e13$var$reducer;
});
parcelRegister("4ArTT", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$29cdebbfaeba41bf$export$4a991c87e640ef77);
    $parcel$export(module.exports, "SHOW_COLUMN", ()=>$29cdebbfaeba41bf$export$4a38807763b7121b);
    $parcel$export(module.exports, "HIDE_COLUMN", ()=>$29cdebbfaeba41bf$export$8aa1aac0877ab14a);
    $parcel$export(module.exports, "MOVE_COLUMN", ()=>$29cdebbfaeba41bf$export$222f4d20cfc4481f);
    $parcel$export(module.exports, "AFM_DRAG_FIELD", ()=>$29cdebbfaeba41bf$export$86c77774077c8b7d);
    $parcel$export(module.exports, "AFM_HIDE_FIELD", ()=>$29cdebbfaeba41bf$export$c1df402034e5bf16);
    $parcel$export(module.exports, "AFM_ADD_FIELD", ()=>$29cdebbfaeba41bf$export$cca45081a5eded43);
    $parcel$export(module.exports, "DRAG_FIELD", ()=>$29cdebbfaeba41bf$export$ef41c818fdc72148);
    $parcel$export(module.exports, "HIDE_FIELD", ()=>$29cdebbfaeba41bf$export$cc2c318d71264470);
    $parcel$export(module.exports, "move", ()=>$29cdebbfaeba41bf$export$d947e5f4f4c48d48);
    const $29cdebbfaeba41bf$export$4a991c87e640ef77 = 'state.domain.view-settings.field-columns.RESET';
    const $29cdebbfaeba41bf$export$4a38807763b7121b = 'state.domain.view-settings.field-columns.SHOW_COLUMN';
    const $29cdebbfaeba41bf$export$8aa1aac0877ab14a = 'state.domain.view-settings.field-columns.HIDE_COLUMN';
    const $29cdebbfaeba41bf$export$222f4d20cfc4481f = 'state.domain.view-settings.field-columns.MOVE_COLUMN';
    const $29cdebbfaeba41bf$export$86c77774077c8b7d = 'afm-drag-field';
    const $29cdebbfaeba41bf$export$c1df402034e5bf16 = 'afm-hide-field';
    const $29cdebbfaeba41bf$export$cca45081a5eded43 = 'afm-add-field';
    const $29cdebbfaeba41bf$export$ef41c818fdc72148 = 'drag-field';
    const $29cdebbfaeba41bf$export$cc2c318d71264470 = 'hide-field';
    const $29cdebbfaeba41bf$export$aad8462122ac592b = (payload)=>({
            type: $29cdebbfaeba41bf$export$4a991c87e640ef77,
            payload: payload
        });
    const $29cdebbfaeba41bf$export$d947e5f4f4c48d48 = (payload, meta)=>({
            type: $29cdebbfaeba41bf$export$222f4d20cfc4481f,
            payload: payload,
            meta: meta
        });
});
parcelRegister("2oMbL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00c2046ff91d3746$export$2e2bcd8739ae039);
    var $8Lnid = parcelRequire("8Lnid");
    const $00c2046ff91d3746$export$d4c72bab9d6cc13a = {
        includeAncestors: true,
        includeDescendants: true
    };
    const $00c2046ff91d3746$var$reducer = (state = $00c2046ff91d3746$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $8Lnid.RESET_FILTER_OPTIONS:
                return {
                    ...action.payload
                };
            case 0, $8Lnid.TOGGLE_SHOW_FULL_HIERARCHY:
                return {
                    ...state,
                    includeDescendants: !state.includeDescendants
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $00c2046ff91d3746$export$2e2bcd8739ae039 = $00c2046ff91d3746$var$reducer;
});
parcelRegister("8Lnid", function(module, exports) {
    $parcel$export(module.exports, "TOGGLE_SHOW_FULL_HIERARCHY", ()=>$7bd85816466a058b$export$2dd3c7fec17f3ab0);
    $parcel$export(module.exports, "RESET_FILTER_OPTIONS", ()=>$7bd85816466a058b$export$a9d7c14600b4285c);
    $parcel$export(module.exports, "toggleShowFullHierarchy", ()=>$7bd85816466a058b$export$8e1f41da5d253fc9);
    const $7bd85816466a058b$export$2dd3c7fec17f3ab0 = 'state.domain.view-settings.filter-options.TOGGLE_SHOW_FULL_HIERARCHY';
    const $7bd85816466a058b$export$6d843f8910970c90 = 'state.domain.view-settings.filter-options.TOGGLE_AUTO_EXPAND_TO_SHOW_ISSUES_MATCHING_FILTER';
    const $7bd85816466a058b$export$a9d7c14600b4285c = 'state.domain.view-settings.filter-options.RESET_FILTER_OPTIONS';
    const $7bd85816466a058b$export$8e1f41da5d253fc9 = ()=>({
            type: $7bd85816466a058b$export$2dd3c7fec17f3ab0
        });
    const $7bd85816466a058b$export$df9c7baa802c70f8 = (payload)=>({
            type: $7bd85816466a058b$export$a9d7c14600b4285c,
            payload: payload
        });
});
parcelRegister("8stsm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0815e6906e567a35$export$2e2bcd8739ae039);
    var $ik0Qc;
    var $lIIFg = parcelRequire("lIIFg");
    var $6YAOO = parcelRequire("6YAOO");
    var $cGbfF = parcelRequire("cGbfF");
    const $0815e6906e567a35$var$initialState = {
        [(0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID)]: {
            id: (0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID),
            value: []
        },
        [(0, $cGbfF.DATE_RANGE_FILTER_ID)]: {
            id: (0, $cGbfF.DATE_RANGE_FILTER_ID),
            value: {}
        }
    };
    const $0815e6906e567a35$var$reducer = (state, action)=>{
        switch(action.type){
            case 0, $lIIFg.RESET:
                return {
                    ...action.payload
                };
            case 0, $lIIFg.CHANGE:
                {
                    const { id: id, value: value } = action.payload;
                    return {
                        ...state,
                        [id]: (0, parcelRequire("ik0Qc")).default(state[id] ?? {}, {
                            value: value
                        })
                    };
                }
            case 0, $lIIFg.CLEAR:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        [id]: (0, parcelRequire("ik0Qc")).default(state[id] ?? {}, {
                            value: $0815e6906e567a35$var$initialState[id]?.value
                        })
                    };
                }
            case 0, $lIIFg.CLEAR_ALL:
                return {
                    ...$0815e6906e567a35$var$initialState,
                    [(0, $cGbfF.HIERARCHY_FILTER_ID)]: state[0, $cGbfF.HIERARCHY_FILTER_ID],
                    [(0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)]: state[0, $cGbfF.HIERARCHY_RANGE_FILTER_ID]
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    const $0815e6906e567a35$var$finalReducer = (state = $0815e6906e567a35$var$initialState, action)=>({
            ...$0815e6906e567a35$var$reducer(state, action),
            [(0, $cGbfF.CUSTOM_FIELD_FILTER_ID)]: (0, $6YAOO.default)(state[0, $cGbfF.CUSTOM_FIELD_FILTER_ID], action)
        });
    var $0815e6906e567a35$export$2e2bcd8739ae039 = $0815e6906e567a35$var$finalReducer;
});
parcelRegister("6YAOO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b64b79d912cc8d82$export$2e2bcd8739ae039);
    var $4R6GH;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cGbfF = parcelRequire("cGbfF");
    var $eiyR0 = parcelRequire("eiyR0");
    function $b64b79d912cc8d82$var$filterValueFor(customField, desirable) {
        switch(customField.type.key){
            case (0, $TTKUQ.CustomFieldTypes).Labels:
            case (0, $TTKUQ.CustomFieldTypes).MultiCheckboxes:
            case (0, $TTKUQ.CustomFieldTypes).AssetObject:
            case (0, $TTKUQ.CustomFieldTypes).MultiSelect:
            case (0, $TTKUQ.CustomFieldTypes).RadioButtons:
            case (0, $TTKUQ.CustomFieldTypes).SingleSelect:
                if (!(0, (0, parcelRequire("4R6GH")).fg)('asset-custom-field-internal-support')) {
                    if (customField.type.key === (0, $TTKUQ.CustomFieldTypes).AssetObject) return [];
                }
                if (!(0, $4nDwW.isDefined)(desirable)) return [];
                if (!Array.isArray(desirable)) return [];
                return desirable;
            default:
                return [];
        }
    }
    function $b64b79d912cc8d82$var$updateFilterValue(state, fieldId, updateFn) {
        return {
            ...state,
            value: {
                ...state.value,
                [fieldId]: updateFn(state.value[fieldId])
            }
        };
    }
    function $b64b79d912cc8d82$export$2e2bcd8739ae039(state = {
        id: (0, $cGbfF.CUSTOM_FIELD_FILTER_ID),
        value: {}
    }, action) {
        const { value: value } = state;
        switch(action.type){
            case 0, $eiyR0.RESET:
                {
                    const { customFields: customFields } = action.payload;
                    const nextValue = customFields.reduce((acc, customField)=>{
                        const id = String(customField.id);
                        if (!customField.filteringAllowed) return acc;
                        return Object.assign(acc, {
                            [id]: $b64b79d912cc8d82$var$filterValueFor(customField, value[id])
                        });
                    }, {});
                    return {
                        ...state,
                        value: nextValue
                    };
                }
            case 0, $eiyR0.UPDATE:
                {
                    const { value: value, customField: customField } = action.payload;
                    const id = String(customField.id);
                    return $b64b79d912cc8d82$var$updateFilterValue(state, id, ()=>$b64b79d912cc8d82$var$filterValueFor(customField, value));
                }
            case 0, $eiyR0.CLEAR:
                {
                    const { customField: customField } = action.payload;
                    const id = String(customField.id);
                    return $b64b79d912cc8d82$var$updateFilterValue(state, id, ()=>$b64b79d912cc8d82$var$filterValueFor(customField, null));
                }
            case 0, $eiyR0.CLEAR_ALL:
                {
                    const { customFields: customFields } = action.payload;
                    return customFields.reduce((acc, customField)=>{
                        const id = String(customField.id);
                        return $b64b79d912cc8d82$var$updateFilterValue(acc, id, ()=>$b64b79d912cc8d82$var$filterValueFor(customField, null));
                    }, state);
                }
            default:
                return state;
        }
    }
});
parcelRegister("jvli8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6681bcf51a8ef1c$export$2e2bcd8739ae039);
    var $73hhy = parcelRequire("73hhy");
    const $b6681bcf51a8ef1c$export$d4c72bab9d6cc13a = {
        versions: []
    };
    const $b6681bcf51a8ef1c$export$1650419e431d3ba3 = (state = $b6681bcf51a8ef1c$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $73hhy.TOGGLE:
                {
                    const { versionId: versionId } = action;
                    const highlightedVersionIds = new Set(state.versions);
                    if (highlightedVersionIds.has(versionId)) highlightedVersionIds.delete(versionId);
                    else highlightedVersionIds.add(versionId);
                    return {
                        versions: [
                            ...highlightedVersionIds
                        ]
                    };
                }
            case 0, $73hhy.RESET:
                return {
                    versions: action.versionIds
                };
            default:
                return state;
        }
    };
    var $b6681bcf51a8ef1c$export$2e2bcd8739ae039 = $b6681bcf51a8ef1c$export$1650419e431d3ba3;
});
parcelRegister("73hhy", function(module, exports) {
    $parcel$export(module.exports, "TOGGLE", ()=>$839a7ccf976265bf$export$60842f1a88feb6ed);
    $parcel$export(module.exports, "RESET", ()=>$839a7ccf976265bf$export$4a991c87e640ef77);
    $parcel$export(module.exports, "toggle", ()=>$839a7ccf976265bf$export$e03c1c3201ee8bb7);
    const $839a7ccf976265bf$export$60842f1a88feb6ed = 'state.domain.view-settings.highlighted-versions.TOGGLE';
    const $839a7ccf976265bf$export$4a991c87e640ef77 = 'state.domain.view-settings.highlighted-versions.RESET';
    const $839a7ccf976265bf$export$e03c1c3201ee8bb7 = (versionId)=>({
            type: $839a7ccf976265bf$export$60842f1a88feb6ed,
            versionId: versionId
        });
    const $839a7ccf976265bf$export$aad8462122ac592b = (versionIds)=>({
            type: $839a7ccf976265bf$export$4a991c87e640ef77,
            versionIds: versionIds
        });
});
parcelRegister("8goh7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$964d59a0bd6ae8bf$export$2e2bcd8739ae039);
    var $21mdo = parcelRequire("21mdo");
    const $964d59a0bd6ae8bf$export$d4c72bab9d6cc13a = {
        isExpanded: {
            IssuesWithoutParentHeader: true
        }
    };
    const $964d59a0bd6ae8bf$var$reducer = (state = $964d59a0bd6ae8bf$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $21mdo.RESET:
                return action.payload;
            case 0, $21mdo.SET_IS_EXPANDED:
                {
                    const { payload: payload } = action;
                    const all = {
                        ...state.isExpanded,
                        ...payload
                    };
                    const prunedIsExpanded = Object.entries(all).reduce((acc, [key, value])=>{
                        if (value === true) acc[key] = value;
                        return acc;
                    }, {});
                    return {
                        ...state,
                        isExpanded: prunedIsExpanded
                    };
                }
            case 0, $21mdo.UPDATE_EXPANDED_ISSUE_LINKS:
                {
                    const { payload: payload } = action;
                    const isExpanded = Object.keys(state.isExpanded).reduce((acc, currentKey)=>{
                        let newKey = currentKey;
                        const keyComponents = currentKey.split(':');
                        if (payload[keyComponents[0]]) {
                            keyComponents[0] = payload[keyComponents[0]];
                            newKey = keyComponents.join(':');
                        }
                        acc[newKey] = state.isExpanded[currentKey];
                        return acc;
                    }, {});
                    return {
                        ...state,
                        isExpanded: isExpanded
                    };
                }
            default:
                return state;
        }
    };
    var $964d59a0bd6ae8bf$export$2e2bcd8739ae039 = $964d59a0bd6ae8bf$var$reducer;
});
parcelRegister("bgTG2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45be825487859e96$export$2e2bcd8739ae039);
    var $02IP9;
    var $ik0Qc;
    var $4nDwW = parcelRequire("4nDwW");
    var $7kNeW = parcelRequire("7kNeW");
    const $45be825487859e96$var$initialState = [
        {
            id: (0, $4b1ceccd370da430$export$526fec6b76d5bc5),
            name: '',
            isExpanded: false,
            labels: []
        }
    ];
    const $45be825487859e96$export$a41c0e365ee7d8b4 = $45be825487859e96$var$initialState;
    const $45be825487859e96$var$reducer = (state = $45be825487859e96$var$initialState, action)=>{
        switch(action.type){
            case 0, $7kNeW.RESET:
                {
                    const initialGroup = action.payload.find(({ id: id })=>id === (0, $4b1ceccd370da430$export$526fec6b76d5bc5));
                    if ((0, $4nDwW.isDefined)(initialGroup)) return [
                        ...action.payload
                    ];
                    return [
                        ...$45be825487859e96$var$initialState,
                        ...action.payload
                    ];
                }
            case 0, $7kNeW.CLEAR_ALL:
                return $45be825487859e96$var$initialState;
            case 0, $7kNeW.ADD:
                return [
                    ...state,
                    action.payload
                ];
            case 0, $7kNeW.UPDATE:
                {
                    const { payload: payload } = action;
                    const index = state.findIndex(({ id: id })=>id === payload.id);
                    return (0, parcelRequire("02IP9")).default(index, (label)=>(0, parcelRequire("ik0Qc")).default(label, payload.patch), state);
                }
            case 0, $7kNeW.REMOVE:
                {
                    const { payload: payload } = action;
                    return state.filter(({ id: id })=>id !== payload);
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $45be825487859e96$export$2e2bcd8739ae039 = $45be825487859e96$var$reducer;
});
parcelRegister("7kNeW", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$ec690e121ab1a4a6$export$4a991c87e640ef77);
    $parcel$export(module.exports, "CLEAR_ALL", ()=>$ec690e121ab1a4a6$export$a4b3b534f9c4179f);
    $parcel$export(module.exports, "ADD", ()=>$ec690e121ab1a4a6$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "UPDATE", ()=>$ec690e121ab1a4a6$export$e271b26eefe41db8);
    $parcel$export(module.exports, "REMOVE", ()=>$ec690e121ab1a4a6$export$29d55e1f664a246b);
    $parcel$export(module.exports, "clearAll", ()=>$ec690e121ab1a4a6$export$1042faa6df30c26);
    $parcel$export(module.exports, "add", ()=>$ec690e121ab1a4a6$export$e16d8520af44a096);
    $parcel$export(module.exports, "update", ()=>$ec690e121ab1a4a6$export$722fbec263ad908a);
    $parcel$export(module.exports, "remove", ()=>$ec690e121ab1a4a6$export$cd7f480d6b8286c3);
    const $ec690e121ab1a4a6$export$4a991c87e640ef77 = 'state.domain.view-settings.label-groups.RESET';
    const $ec690e121ab1a4a6$export$a4b3b534f9c4179f = 'state.domain.view-settings.label-groups.CLEAR_ALL';
    const $ec690e121ab1a4a6$export$bb6389024b71c2ae = 'state.domain.view-settings.label-groups.ADD';
    const $ec690e121ab1a4a6$export$e271b26eefe41db8 = 'state.domain.view-settings.label-groups.UPDATE';
    const $ec690e121ab1a4a6$export$29d55e1f664a246b = 'state.domain.view-settings.label-groups.REMOVE';
    const $ec690e121ab1a4a6$export$aad8462122ac592b = (payload)=>({
            type: $ec690e121ab1a4a6$export$4a991c87e640ef77,
            payload: payload
        });
    const $ec690e121ab1a4a6$export$1042faa6df30c26 = ()=>({
            type: $ec690e121ab1a4a6$export$a4b3b534f9c4179f
        });
    const $ec690e121ab1a4a6$export$e16d8520af44a096 = (payload)=>({
            type: $ec690e121ab1a4a6$export$bb6389024b71c2ae,
            payload: payload
        });
    const $ec690e121ab1a4a6$export$722fbec263ad908a = (payload)=>({
            type: $ec690e121ab1a4a6$export$e271b26eefe41db8,
            payload: payload
        });
    const $ec690e121ab1a4a6$export$cd7f480d6b8286c3 = (payload)=>({
            type: $ec690e121ab1a4a6$export$29d55e1f664a246b,
            payload: payload
        });
});
const $4b1ceccd370da430$export$526fec6b76d5bc5 = 'all_other_issues';
parcelRegister("3vCHD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03b89278b5bd49c9$export$2e2bcd8739ae039);
    var $fJ4u7 = parcelRequire("fJ4u7");
    const $03b89278b5bd49c9$export$d4c72bab9d6cc13a = {
        showingRolledUpDate: true,
        showRolledUpOthers: true
    };
    const $03b89278b5bd49c9$export$1650419e431d3ba3 = (state = $03b89278b5bd49c9$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $fJ4u7.SET_SHOW_ROLLED_UP_DATE:
                return {
                    ...state,
                    showingRolledUpDate: action.payload.shouldShow
                };
            case 0, $fJ4u7.SET_SHOW_ROLLED_UP_OTHERS:
                return {
                    ...state,
                    showRolledUpOthers: action.payload.shouldShow
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $03b89278b5bd49c9$export$2e2bcd8739ae039 = $03b89278b5bd49c9$export$1650419e431d3ba3;
});
parcelRegister("cUSVc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4483b18ad3b24ec$export$2e2bcd8739ae039);
    var $TTKUQ = parcelRequire("TTKUQ");
    var $j33D0 = parcelRequire("j33D0");
    const $d4483b18ad3b24ec$export$d4c72bab9d6cc13a = {
        mode: (0, $TTKUQ.TIMELINE_MODES).MONTHS
    };
    const $d4483b18ad3b24ec$var$reducer = (state = $d4483b18ad3b24ec$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $j33D0.CHANGE_OPTION:
                return {
                    ...state,
                    selection: action.payload
                };
            case 0, $j33D0.CHANGE_MODE:
                return {
                    ...state,
                    mode: action.payload
                };
            case 0, $j33D0.CHANGE_CUSTOM_DATES:
                return {
                    ...state,
                    customDateRange: {
                        ...state.customDateRange,
                        ...action.payload
                    }
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $d4483b18ad3b24ec$export$2e2bcd8739ae039 = $d4483b18ad3b24ec$var$reducer;
});
parcelRegister("j33D0", function(module, exports) {
    $parcel$export(module.exports, "CHANGE_OPTION", ()=>$c7ac17865f2e25b2$export$c2b22857fe21a293);
    $parcel$export(module.exports, "CHANGE_MODE", ()=>$c7ac17865f2e25b2$export$db173bb1aa409c7a);
    $parcel$export(module.exports, "CHANGE_CUSTOM_DATES", ()=>$c7ac17865f2e25b2$export$7cb96b5c6c3151af);
    $parcel$export(module.exports, "timeScaleCustomDatesChange", ()=>$c7ac17865f2e25b2$export$92d52f3066b84deb);
    const $c7ac17865f2e25b2$export$c2b22857fe21a293 = 'state.domain.view-settings.time-scale.CHANGE_OPTION';
    const $c7ac17865f2e25b2$export$db173bb1aa409c7a = 'state.domain.view-settings.time-scale.CHANGE_MODE';
    const $c7ac17865f2e25b2$export$7cb96b5c6c3151af = 'state.domain.view-settings.time-scale.CHANGE_CUSTOM_DATES';
    const $c7ac17865f2e25b2$export$844b1a4452aa5be2 = (payload)=>({
            type: $c7ac17865f2e25b2$export$db173bb1aa409c7a,
            payload: payload
        });
    const $c7ac17865f2e25b2$export$92d52f3066b84deb = (payload)=>({
            type: $c7ac17865f2e25b2$export$7cb96b5c6c3151af,
            payload: payload
        });
});
parcelRegister("5moO9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e90216c9e8f57237$export$2e2bcd8739ae039);
    var $3J2mc;
    var $dQ2Hi = parcelRequire("dQ2Hi");
    const $e90216c9e8f57237$var$initialState = {
        mode: (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST
    };
    const $e90216c9e8f57237$var$reducer = (state = $e90216c9e8f57237$var$initialState, action)=>{
        switch(action.type){
            case 0, $dQ2Hi.CHANGE_VIEW_MODE:
                return {
                    ...state,
                    mode: action.payload.mode
                };
            default:
                return {
                    ...state,
                    mode: state.mode || (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE
                };
        }
    };
    var $e90216c9e8f57237$export$2e2bcd8739ae039 = $e90216c9e8f57237$var$reducer;
});
parcelRegister("dQ2Hi", function(module, exports) {
    $parcel$export(module.exports, "CHANGE_VIEW_MODE", ()=>$6018e39a61c73a87$export$56b6d17900a97f5);
    $parcel$export(module.exports, "changeViewMode", ()=>$6018e39a61c73a87$export$36fa93dbf109f538);
    const $6018e39a61c73a87$export$56b6d17900a97f5 = 'state.domain.views.SET_VIEW_MODE';
    const $6018e39a61c73a87$export$36fa93dbf109f538 = (mode)=>({
            type: $6018e39a61c73a87$export$56b6d17900a97f5,
            payload: {
                mode: mode
            }
        });
});
parcelRegister("1HJaL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7e39801f37ffb5c$export$2e2bcd8739ae039);
    var $TTKUQ = parcelRequire("TTKUQ");
    var $dBbgF = parcelRequire("dBbgF");
    var $8pJHi = parcelRequire("8pJHi");
    const $c7e39801f37ffb5c$export$d4c72bab9d6cc13a = {
        sorting: (0, $8pJHi.defaultSorting),
        grouping: (0, $TTKUQ.GROUPING).NONE,
        expandedItems: Object.keys((0, $TTKUQ.GROUPING)).reduce((result, group)=>Object.assign(result, {
                [group]: {}
            }), {}),
        showSprints: false
    };
    const $c7e39801f37ffb5c$var$reducer = (state = $c7e39801f37ffb5c$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $dBbgF.RESET:
                return {
                    ...action.payload
                };
            case 0, $dBbgF.CHANGE_GROUP:
                return {
                    ...state,
                    grouping: action.payload.grouping
                };
            case 0, $dBbgF.CHANGE_SORT:
                return {
                    ...state,
                    sorting: action.payload.sorting
                };
            case 0, $dBbgF.TOGGLE_EXPAND_GROUP:
                {
                    const { grouping: grouping, groupName: groupName, expand: expand } = action.payload;
                    const { expandedItems: expandedItems } = state;
                    return {
                        ...state,
                        expandedItems: {
                            ...expandedItems,
                            [grouping]: {
                                ...expandedItems[grouping],
                                [groupName]: expand
                            }
                        }
                    };
                }
            case 0, $dBbgF.TOGGLE_SHOW_SPRINTS:
                {
                    const { showSprints: showSprints } = action.payload;
                    return {
                        ...state,
                        showSprints: showSprints
                    };
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $c7e39801f37ffb5c$export$2e2bcd8739ae039 = $c7e39801f37ffb5c$var$reducer;
});
parcelRegister("gnCZy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b724dde4a0ad27db$export$2e2bcd8739ae039);
    var $la6bP = parcelRequire("la6bP");
    var $5lzYR = parcelRequire("5lzYR");
    const $b724dde4a0ad27db$var$initialState = {
        showWarning: false,
        disabledWarnings: []
    };
    const $b724dde4a0ad27db$var$reducer = (stateArg = $b724dde4a0ad27db$var$initialState, action)=>{
        switch(action.type){
            case 0, $5lzYR.RESET_SHOW_WARNING:
                return {
                    ...stateArg,
                    showWarning: action.payload.showWarning
                };
            case 0, $5lzYR.TOGGLE_SHOW_WARNING:
                return {
                    ...stateArg,
                    showWarning: !stateArg.showWarning
                };
            case 0, $5lzYR.TOGGLE_WARNING_TYPE:
                if ((stateArg.disabledWarnings || []).includes(action.payload)) {
                    const warningsWithPayloadItemRemoved = stateArg.disabledWarnings.filter((item)=>item !== action.payload);
                    return {
                        ...stateArg,
                        disabledWarnings: warningsWithPayloadItemRemoved
                    };
                }
                return {
                    ...stateArg,
                    disabledWarnings: [
                        ...stateArg.disabledWarnings,
                        action.payload
                    ]
                };
            case 0, $5lzYR.RESET_ENABLED_WARNING_TYPE:
                return {
                    ...stateArg,
                    disabledWarnings: (0, $la6bP.WARNING_CENTER_AVAILABLE_TYPES).filter((warningType)=>!action.payload.has(warningType))
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return stateArg;
                }
        }
    };
    var $b724dde4a0ad27db$export$2e2bcd8739ae039 = $b724dde4a0ad27db$var$reducer;
});
parcelRegister("6co0b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f95856830515e9d$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    var $2f95856830515e9d$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        }
    }, {
        prefix: 'rollupSetting',
        from: 'V0'
    }));
});
parcelRegister("dmIdq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b7181cf9944ddb5$export$2e2bcd8739ae039);
    var $TTKUQ = parcelRequire("TTKUQ");
    var $hn71W = parcelRequire("hn71W");
    const $0b7181cf9944ddb5$var$mapSelection = (selection)=>{
        switch(selection){
            case '1yr':
                return (0, $TTKUQ.TIMELINE_MODES).QUARTERS;
            case '3mth':
                return (0, $TTKUQ.TIMELINE_MODES).MONTHS;
            case 'custom':
                return selection;
            default:
                return (0, $TTKUQ.TIMELINE_MODES).MONTHS;
        }
    };
    var $0b7181cf9944ddb5$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        },
        V1: function fromV0ToV1(prevState) {
            const mode = $0b7181cf9944ddb5$var$mapSelection(prevState.selection);
            return {
                ...prevState,
                mode: mode
            };
        }
    }, {
        prefix: 'timeScale',
        from: 'V0'
    }));
});
parcelRegister("20afy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f87a2a80c759c3e$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    var $5f87a2a80c759c3e$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return prevState;
        }
    }, {
        prefix: 'viewMode',
        from: 'V0'
    }));
});
parcelRegister("4sZjR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47243d3baf134c85$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    var $47243d3baf134c85$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV0(prevState) {
            return {
                ...prevState
            };
        }
    }, {
        prefix: 'visualisations',
        from: 'V0'
    }));
});
parcelRegister("01Tsj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53622794eb47a9d9$export$2e2bcd8739ae039);
    var $hn71W = parcelRequire("hn71W");
    var $53622794eb47a9d9$export$2e2bcd8739ae039 = (0, $hn71W.createMigrate)(...(0, $hn71W.incremental)({
        V0: function fromV0ToV1(prevState) {
            return {
                ...prevState,
                disabledWarnings: []
            };
        }
    }, {
        prefix: 'warningSettings',
        from: 'V0'
    }));
});
parcelRegister("cfOlJ", function(module, exports) {
    $parcel$export(module.exports, "getReportMigratableBlob", ()=>$ccbd65e071ccf847$export$3994f83f8fd76e58);
    function $ccbd65e071ccf847$export$3994f83f8fd76e58(reportViewSettings) {
        if (!reportViewSettings.filtersConfig) return reportViewSettings;
        return {
            dateConstraintsSetting: undefined,
            releaseBar: reportViewSettings.releaseBarState,
            colorBy: reportViewSettings.colorByConfig,
            groupByLabels: {
                groups: reportViewSettings.groupByLabelGroups
            },
            fieldColumns: reportViewSettings.fieldColumnsConfig,
            groupBy: {
                groups: reportViewSettings.groupByComponentGroups
            },
            filterOptions: reportViewSettings.filterOptionsConfig,
            timeScale: reportViewSettings.timelineConfig,
            warningSetting: reportViewSettings.warningSetting,
            visualisations: reportViewSettings.groupByConfig,
            filters: reportViewSettings.filtersConfig,
            scopeIssues: {
                isExpanded: reportViewSettings.issueExpansionConfig,
                selected: [],
                lastSelected: [],
                isLoading: false,
                isLoadingHistory: false,
                isSavingIssue: false
            },
            rollupSettings: {
                showingRolledUpDate: reportViewSettings.rollupSettings.showingRolledUpDate || false,
                showRolledUpOthers: reportViewSettings.rollupSettings.showRolledUpOthers || false
            },
            estimateRollup: {
                showRolledUpEstimate: reportViewSettings.rollupSettings.showRolledUpEstimate || false
            }
        };
    }
});
parcelRegister("68kaG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4a7b9a288f5073e$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $6L8iB = parcelRequire("6L8iB");
    var $1l6AC = parcelRequire("1l6AC");
    var $kWDpn = parcelRequire("kWDpn");
    var $7QGzp = parcelRequire("7QGzp");
    var $3YtPS = parcelRequire("3YtPS");
    var $c4a7b9a288f5073e$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        rows: (0, $6L8iB.getGridRows),
        rowIds: (0, $6L8iB.getGridRowIds),
        columns: (0, $6L8iB.getGridColumns),
        rowConfigs: (0, $6L8iB.getRowConfigs),
        columnConfigs: (0, $6L8iB.getColumnConfigs),
        mode: (0, $1CGdp.getMode),
        stickyRows: (0, $6L8iB.getRowStickiness),
        viewMode: (0, $kWDpn.getViewMode),
        viewId: (0, $7QGzp.getActiveViewId),
        exportAppWidth: (0, $1l6AC.getExportAppWidth),
        isConfluenceMacro: $1CGdp.isConfluenceMacro,
        isEmbed: $1CGdp.isEmbed,
        isReportMode: $1CGdp.isReportMode
    });
});
parcelRegister("6L8iB", function(module, exports) {
    $parcel$export(module.exports, "getGridRowIds", ()=>$54b890fe2a145dbd$export$3c591976e2dd435);
    $parcel$export(module.exports, "getGridRows", ()=>$54b890fe2a145dbd$export$b531a3ef4fb1113d);
    $parcel$export(module.exports, "getGridColumns", ()=>$54b890fe2a145dbd$export$ab08dbb7cfffe453);
    $parcel$export(module.exports, "getRowStickiness", ()=>$54b890fe2a145dbd$export$e41e433b8c65f966);
    $parcel$export(module.exports, "getRowConfigs", ()=>$54b890fe2a145dbd$export$4918fac776f5200a);
    $parcel$export(module.exports, "getColumnConfigs", ()=>$54b890fe2a145dbd$export$14116e8b59cd31f0);
    $parcel$export(module.exports, "getScrollIntoViewIndex", ()=>$54b890fe2a145dbd$export$fcc1492b8a57487d);
    var $3J2mc;
    var $1CGdp = parcelRequire("1CGdp");
    var $3YtPS = parcelRequire("3YtPS");
    var $7lpPk = parcelRequire("7lpPk");
    var $19iju = parcelRequire("19iju");
    var $jpgxP = parcelRequire("jpgxP");
    var $6iNxz = parcelRequire("6iNxz");
    var $kWDpn = parcelRequire("kWDpn");
    var $19P1y = parcelRequire("19P1y");
    const $54b890fe2a145dbd$export$8e70bc0367277c1f = (tableItems)=>tableItems.map(({ tag: tag })=>tag);
    const $54b890fe2a145dbd$export$24e035b0c9cee763 = (0, $3YtPS.createSelector)([
        (0, $6iNxz.getTableItems)
    ], $54b890fe2a145dbd$export$8e70bc0367277c1f);
    const $54b890fe2a145dbd$export$81af33d594af6b76 = (tableItems)=>[
            (0, $f3f8e80f7954f218$export$526a1e214ba17198),
            (0, $f3f8e80f7954f218$export$a64a0028232151aa),
            ...tableItems.map((0, $19P1y.getGridRowId))
        ];
    const $54b890fe2a145dbd$export$3c591976e2dd435 = (0, $3YtPS.createSelector)([
        (0, $6iNxz.getTableItems)
    ], $54b890fe2a145dbd$export$81af33d594af6b76);
    const $54b890fe2a145dbd$export$a79f133f7fa6b821 = (tags)=>[
            {
                tag: (0, $f3f8e80f7954f218$export$526a1e214ba17198)
            },
            {
                tag: (0, $f3f8e80f7954f218$export$a64a0028232151aa)
            },
            ...tags.map((itemTag, index)=>({
                    tag: (0, $f3f8e80f7954f218$export$867af8e076780d5d),
                    payload: {
                        itemIndex: index,
                        itemTag: itemTag
                    }
                }))
        ];
    const $54b890fe2a145dbd$export$b531a3ef4fb1113d = (0, $3YtPS.createSelector)([
        $54b890fe2a145dbd$export$24e035b0c9cee763
    ], $54b890fe2a145dbd$export$a79f133f7fa6b821);
    const $54b890fe2a145dbd$export$ae4998afe12f8a46 = (viewMode, { columns: columnStates }, customFields, atlasConnectInstalled, isEmbedMode, isConfluenceMacroMode)=>{
        const columns = columnStates.filter((column)=>{
            if (column.id === 'goal' && !atlasConnectInstalled) return false;
            return ((0, $7lpPk.isColumnId)(column.id, isEmbedMode, isConfluenceMacroMode) || customFields.some((field)=>`${field.id}` === column.id)) && column.isVisible;
        }).map((column)=>({
                tag: (0, $f3f8e80f7954f218$export$d6f887e0c1be1b74),
                payload: column
            }));
        return [
            {
                tag: (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12)
            },
            ...columns,
            ...viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST ? [
                {
                    tag: (0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c)
                }
            ] : [],
            ...viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE && columns.length === 0 ? [
                {
                    tag: (0, $f3f8e80f7954f218$export$ccb33e29d92c9a58)
                }
            ] : [],
            ...viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE ? [
                {
                    tag: (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d)
                }
            ] : []
        ];
    };
    const $54b890fe2a145dbd$export$ab08dbb7cfffe453 = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getViewMode),
        (0, $kWDpn.getFieldColumnsViewSettingsByViewMode),
        (0, $19iju.getSupportedCustomFields),
        (0, $jpgxP.isAtlasConnectInstalled),
        (0, $1CGdp.isEmbed),
        (0, $1CGdp.isConfluenceMacro)
    ], $54b890fe2a145dbd$export$ae4998afe12f8a46);
    const $54b890fe2a145dbd$export$bd3dd47bff8a0b52 = (tableItems)=>[
            50,
            40
        ].concat(tableItems.map(({ height: height })=>(height ?? 1) * 40));
    const $54b890fe2a145dbd$export$3e5149a60ac7416b = (0, $3YtPS.createSelector)([
        (0, $6iNxz.getTableItems)
    ], $54b890fe2a145dbd$export$bd3dd47bff8a0b52);
    const $54b890fe2a145dbd$export$31fead638f9b51b8 = (gridRows)=>gridRows.map((row)=>row.tag === (0, $f3f8e80f7954f218$export$526a1e214ba17198) || row.tag === (0, $f3f8e80f7954f218$export$a64a0028232151aa) || row.payload.itemTag === (0, $6iNxz.TABLE_GROUP));
    const $54b890fe2a145dbd$export$e41e433b8c65f966 = (0, $3YtPS.createSelector)([
        $54b890fe2a145dbd$export$b531a3ef4fb1113d
    ], $54b890fe2a145dbd$export$31fead638f9b51b8);
    const $54b890fe2a145dbd$export$12c4e1e8b68e3b99 = (rowsStickiness, rowHeights)=>{
        let currentTop = 0;
        return rowsStickiness.map((sticky, index)=>{
            const height = rowHeights[index];
            const top = currentTop;
            currentTop += height;
            return {
                height: height,
                top: top,
                thead: [
                    0,
                    1
                ].includes(index),
                sticky: sticky
            };
        });
    };
    const $54b890fe2a145dbd$export$4918fac776f5200a = (0, $3YtPS.createSelector)([
        $54b890fe2a145dbd$export$e41e433b8c65f966,
        $54b890fe2a145dbd$export$3e5149a60ac7416b
    ], $54b890fe2a145dbd$export$12c4e1e8b68e3b99);
    const $54b890fe2a145dbd$export$eb6481bf168b8c0b = (viewMode, gridColumns)=>gridColumns.map((column)=>{
            if (column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12)) return {
                id: 'scope',
                sticky: true
            };
            if (column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d)) return {
                id: 'timeline',
                sticky: false
            };
            if (column.tag === (0, $f3f8e80f7954f218$export$ccb33e29d92c9a58)) return {
                id: 'empty',
                sticky: true
            };
            if (column.tag === (0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c) && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE) return {
                id: 'addFields',
                sticky: true
            };
            if (column.tag === (0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c)) return {
                id: 'addFields',
                sticky: false
            };
            return {
                id: column.payload.id,
                sticky: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE
            };
        });
    const $54b890fe2a145dbd$export$14116e8b59cd31f0 = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getViewMode),
        $54b890fe2a145dbd$export$ab08dbb7cfffe453
    ], $54b890fe2a145dbd$export$eb6481bf168b8c0b);
    const $54b890fe2a145dbd$export$8c52e0409988a46a = (index)=>index === undefined ? undefined : index + 2;
    const $54b890fe2a145dbd$export$fcc1492b8a57487d = (0, $3YtPS.createSelector)([
        (0, $6iNxz.getScrollToIndex)
    ], $54b890fe2a145dbd$export$8c52e0409988a46a);
});
parcelRegister("6iNxz", function(module, exports) {
    $parcel$export(module.exports, "TABLE_ISSUE", ()=>$22824087d3f06f6c$export$e028b8352a47c6);
    $parcel$export(module.exports, "TABLE_INLINE_CREATE", ()=>$22824087d3f06f6c$export$749c40244e980b6f);
    $parcel$export(module.exports, "TABLE_HEADER", ()=>$22824087d3f06f6c$export$17dfac22e88883a6);
    $parcel$export(module.exports, "TABLE_GROUP", ()=>$22824087d3f06f6c$export$19b0175d8da45496);
    $parcel$export(module.exports, "TABLE_GROUP_HEADER", ()=>$22824087d3f06f6c$export$1ebe3ab8a09d6fc3);
    $parcel$export(module.exports, "TABLE_BLANK_ROW", ()=>$22824087d3f06f6c$export$f82be50a92182882);
    $parcel$export(module.exports, "getTableItems", ()=>$22824087d3f06f6c$export$4877c3833eef3740);
    $parcel$export(module.exports, "getScopeHeight", ()=>$22824087d3f06f6c$export$b0b02bd9d3cbd02e);
    $parcel$export(module.exports, "getScrollToIndex", ()=>$22824087d3f06f6c$export$56068eb4c4e3a63c);
    $parcel$export(module.exports, "getDisableDnD", ()=>$22824087d3f06f6c$export$d39f95f18e5e5a62);
    var $8EB5I;
    var $64Ty4;
    var $sqeVT;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $1CGdp = parcelRequire("1CGdp");
    var $gk0jw = parcelRequire("gk0jw");
    var $jLI87 = parcelRequire("jLI87");
    var $2QLMT = parcelRequire("2QLMT");
    var $d3quy = parcelRequire("d3quy");
    const $22824087d3f06f6c$export$e028b8352a47c6 = 'app-simple-plans.query.table.ISSUE_TAG';
    const $22824087d3f06f6c$export$749c40244e980b6f = 'app-simple-plans.query.table.INLINE_CREATE_TAG';
    const $22824087d3f06f6c$export$17dfac22e88883a6 = 'app-simple-plans.query.table.HEADER_TAG';
    const $22824087d3f06f6c$export$19b0175d8da45496 = 'app-simple-plans.query.table.GROUP_TAG';
    const $22824087d3f06f6c$export$1ebe3ab8a09d6fc3 = 'app-simple-plans.query.table.GROUP_HEADER_TAG';
    const $22824087d3f06f6c$export$f82be50a92182882 = 'app-simple-plans.query.table.BLANK_ROW_TAG';
    const $22824087d3f06f6c$var$inlineCreateToDummyIssue = (inlineCreate)=>({
            depth: 0,
            id: inlineCreate.id,
            lexoRank: '',
            level: inlineCreate.hierarchyLevel,
            rootIndex: 0,
            summary: '',
            project: inlineCreate.projectId,
            type: inlineCreate.issueTypeId,
            ...inlineCreate.values
        });
    const $22824087d3f06f6c$export$f777fb48da152e7a = (inlineCreateState, result, groupCombination = {})=>{
        const { isOpen: isOpen, parentId: parentId, siblingId: siblingId } = inlineCreateState;
        let inlineCreateDummyIssue;
        return (issue)=>{
            if (!(isOpen && (parentId || siblingId))) return;
            const isSibling = (0, $4nDwW.isDefined)(siblingId);
            const isAnchor = issue && (isSibling ? issue.id === siblingId : issue.id === parentId);
            if (issue && isAnchor && !(inlineCreateState.group && issue.group !== inlineCreateState.group) && (!inlineCreateState.groupCombination || (0, parcelRequire("8EB5I")).default(groupCombination, inlineCreateState.groupCombination))) {
                inlineCreateDummyIssue = {
                    tag: $22824087d3f06f6c$export$749c40244e980b6f,
                    value: {
                        ...$22824087d3f06f6c$var$inlineCreateToDummyIssue(inlineCreateState),
                        level: issue.id === parentId ? issue.level - 1 : issue.level,
                        depth: issue.id === parentId ? issue.depth + 1 : issue.depth,
                        rootIndex: issue.rootIndex
                    }
                };
                return;
            }
            if (inlineCreateDummyIssue && siblingId && !(issue && issue.level < inlineCreateDummyIssue.value.level)) {
                result.push({
                    ...inlineCreateDummyIssue,
                    topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT)
                });
                inlineCreateDummyIssue = null;
            }
            if (inlineCreateDummyIssue && parentId && !(issue && issue.level <= inlineCreateDummyIssue.value.level)) {
                result.push({
                    ...inlineCreateDummyIssue,
                    topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT)
                });
                inlineCreateDummyIssue = null;
            }
        };
    };
    const $22824087d3f06f6c$export$9873ac8fb1dd1178 = (result, { startLevelIssues: startLevelIssues, issuesWithoutParent: issuesWithoutParent }, inlineCreateState, groupName, grouping = (0, $TTKUQ.GROUPING).NONE, groupUrl, isExpanded, group, sprintStreamsForTeams, groupCombination = {}, parentGroup, isParentGroupExpanded, childGroupsByParentMap)=>{
        if ((0, $4nDwW.isDefined)(group) && (0, $4nDwW.isDefined)(groupName)) {
            let height = 1;
            if (grouping === (0, $TTKUQ.GROUPING).TEAM && sprintStreamsForTeams && group) {
                const streams = (0, $4nDwW.isDefined)(groupCombination.team) && sprintStreamsForTeams[groupCombination.team];
                if (streams && streams.length > 0) height = streams.length;
            }
            let topOffset = (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT) * height;
            if (parentGroup) {
                if (!result.find((item)=>item.group === parentGroup)) {
                    result.push({
                        tag: $22824087d3f06f6c$export$19b0175d8da45496,
                        value: '',
                        grouping: grouping,
                        url: groupUrl,
                        isExpanded: !!isParentGroupExpanded,
                        group: parentGroup,
                        parentGroup: undefined,
                        height: height,
                        topOffset: topOffset,
                        groupCombination: {
                            [(0, $jLI87.getGroupAttribute)(grouping)]: parentGroup
                        },
                        childGroups: childGroupsByParentMap && childGroupsByParentMap[parentGroup]
                    });
                    topOffset += (0, $TTKUQ.SCOPE_ROW_HEIGHT);
                }
                if (!isParentGroupExpanded) return;
            }
            result.push({
                tag: $22824087d3f06f6c$export$19b0175d8da45496,
                value: groupName,
                grouping: grouping,
                url: groupUrl,
                isExpanded: isExpanded || false,
                group: group,
                height: height,
                topOffset: topOffset,
                groupCombination: groupCombination,
                parentGroup: parentGroup
            });
        }
        const { parentId: parentId, siblingId: siblingId, hierarchyLevel: hierarchyLevel, isOpen: isOpen } = inlineCreateState;
        const issuesWithoutParentCount = issuesWithoutParent.map(({ rootIssuesCount: rootIssuesCount = 0 })=>rootIssuesCount).reduce((a, x)=>a + x, 0);
        if (startLevelIssues.issues.length + issuesWithoutParentCount === 0) {
            if (isOpen && (!(0, $4nDwW.isDefined)(group) || group === inlineCreateState.group)) {
                result.push({
                    tag: $22824087d3f06f6c$export$749c40244e980b6f,
                    value: $22824087d3f06f6c$var$inlineCreateToDummyIssue(inlineCreateState),
                    group: group,
                    groupCombination: groupCombination,
                    parentGroup: parentGroup,
                    topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT)
                });
                result.push({
                    tag: $22824087d3f06f6c$export$f82be50a92182882,
                    value: undefined,
                    group: group,
                    groupCombination: groupCombination,
                    parentGroup: parentGroup,
                    topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT)
                });
            }
            return;
        }
        const tryToInsertInlineCreate = $22824087d3f06f6c$export$f777fb48da152e7a(inlineCreateState, result, groupCombination);
        for (const issue of startLevelIssues.issues){
            tryToInsertInlineCreate(issue);
            result.push({
                tag: $22824087d3f06f6c$export$e028b8352a47c6,
                value: issue,
                group: group,
                groupCombination: groupCombination,
                parentGroup: parentGroup,
                topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT)
            });
        }
        const isTheSameGroup = !inlineCreateState.groupCombination || (0, $2QLMT.getGroupKey)(inlineCreateState.groupCombination) === group;
        if (isOpen && !(parentId || siblingId) && startLevelIssues.level === hierarchyLevel && isTheSameGroup) result.push({
            tag: $22824087d3f06f6c$export$749c40244e980b6f,
            value: $22824087d3f06f6c$var$inlineCreateToDummyIssue(inlineCreateState),
            group: group,
            groupCombination: groupCombination,
            parentGroup: parentGroup,
            topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT)
        });
        tryToInsertInlineCreate();
        issuesWithoutParent.forEach(({ id: groupId, isExpanded: isGroupExpanded, level: level, issues: issues, rootIssuesCount: rootIssuesCount })=>{
            const shouldRenderInlineCreate = isOpen && !(parentId || siblingId) && level === hierarchyLevel && isTheSameGroup;
            if (issues.length === 0 && !shouldRenderInlineCreate) return;
            result.push({
                tag: $22824087d3f06f6c$export$1ebe3ab8a09d6fc3,
                group: group,
                value: {
                    id: groupId,
                    isExpanded: isGroupExpanded,
                    level: level,
                    rootIssuesCount: rootIssuesCount
                },
                groupCombination: groupCombination,
                parentGroup: parentGroup,
                topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT)
            });
            if (isGroupExpanded) {
                issues.forEach((issue)=>{
                    tryToInsertInlineCreate(issue);
                    result.push({
                        tag: $22824087d3f06f6c$export$e028b8352a47c6,
                        value: issue,
                        group: group,
                        groupCombination: groupCombination,
                        parentGroup: parentGroup,
                        topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT)
                    });
                });
                tryToInsertInlineCreate();
            }
            if (isOpen && !(parentId || siblingId) && level === hierarchyLevel && isTheSameGroup) result.push({
                tag: $22824087d3f06f6c$export$749c40244e980b6f,
                group: group,
                value: $22824087d3f06f6c$var$inlineCreateToDummyIssue(inlineCreateState),
                groupCombination: groupCombination,
                parentGroup: parentGroup,
                topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT)
            });
        });
        result.push({
            tag: $22824087d3f06f6c$export$f82be50a92182882,
            value: undefined,
            group: group,
            groupCombination: groupCombination,
            parentGroup: parentGroup,
            topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $TTKUQ.SCOPE_ROW_HEIGHT)
        });
    };
    const $22824087d3f06f6c$export$b5f7ab67ce89b674 = (scope, inlineCreateState, sprintStreamsForTeams, exportPreview)=>{
        const result = [];
        const { groupCount: groupCount = 0, groups: groups = [] } = scope;
        const childGroupsByParentMap = (0, $4nDwW.groupBy)((group)=>group.parentGroup || 'no_parent_groups', groups);
        if (groupCount === 0) $22824087d3f06f6c$export$9873ac8fb1dd1178(result, scope, inlineCreateState);
        else if (groupCount > 0) groups.forEach((groupedScope)=>{
            const { scope: scope, groupName: groupName, grouping: grouping, groupUrl: groupUrl, isExpanded: isExpanded, group: group, groupCombination: groupCombination, parentGroup: parentGroup, isParentGroupExpanded: isParentGroupExpanded } = groupedScope;
            return $22824087d3f06f6c$export$9873ac8fb1dd1178(result, scope, inlineCreateState, groupName, grouping, groupUrl, isExpanded, group, sprintStreamsForTeams, groupCombination, parentGroup, isParentGroupExpanded, childGroupsByParentMap);
        });
        if (exportPreview) {
            let issuesCounted = 0;
            let indexToSliceAt = (0, $TTKUQ.NUM_ISSUES_IN_EXPORT_PREVIEW);
            for(let i = 0; i < result.length; i++)if (result[i].tag === $22824087d3f06f6c$export$e028b8352a47c6) {
                issuesCounted++;
                if (issuesCounted === (0, $TTKUQ.NUM_ISSUES_IN_EXPORT_PREVIEW)) {
                    indexToSliceAt = i;
                    break;
                }
            }
            return result.slice(0, indexToSliceAt + 1);
        }
        return result;
    };
    const $22824087d3f06f6c$export$4877c3833eef3740 = (0, $3YtPS.createSelector)([
        (0, $jLI87.getScope),
        (0, $gk0jw.getInlineCreateState),
        (0, $d3quy.getSprintStreamsForTeams),
        (0, $1CGdp.isExportPreview)
    ], $22824087d3f06f6c$export$b5f7ab67ce89b674);
    const $22824087d3f06f6c$export$b0b02bd9d3cbd02e = (0, $3YtPS.createSelector)([
        $22824087d3f06f6c$export$4877c3833eef3740
    ], (tableItems)=>tableItems.reduce((scopeHeight, { height: height = 1 })=>scopeHeight + height * (0, $TTKUQ.SCOPE_ROW_HEIGHT), 0));
    const $22824087d3f06f6c$export$1605e4b97a9dcce2 = (items, { isOpen: isOpen }, activeSearchIssue)=>{
        if (isOpen) return (0, parcelRequire("64Ty4")).default((0, parcelRequire("sqeVT")).default('tag', $22824087d3f06f6c$export$749c40244e980b6f))(items);
        if (activeSearchIssue) {
            const index = (0, parcelRequire("64Ty4")).default(({ value: value, group: group = '' })=>{
                if ((0, parcelRequire("sqeVT")).default('tag', $22824087d3f06f6c$export$e028b8352a47c6) && typeof value === 'object') return value.id === activeSearchIssue.id && group === activeSearchIssue.group;
                return false;
            })(items);
            return index > -1 ? index : undefined;
        }
    };
    const $22824087d3f06f6c$export$56068eb4c4e3a63c = (0, $3YtPS.createSelector)([
        $22824087d3f06f6c$export$4877c3833eef3740,
        (0, $gk0jw.getInlineCreateState),
        (0, $jLI87.getActiveSearchIssue)
    ], $22824087d3f06f6c$export$1605e4b97a9dcce2);
    const $22824087d3f06f6c$export$d39f95f18e5e5a62 = (0, $3YtPS.createSelector)([
        (0, $gk0jw.getInlineCreateState)
    ], ({ isOpen: isOpen })=>isOpen);
});
parcelRegister("64Ty4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46ce3499b8bbb248$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5DTpU;
    var $5ukhB;
    var $46ce3499b8bbb248$var$findIndex = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("5DTpU")).default)([], (0, (0, parcelRequire("5ukhB")).default), function findIndex(fn, list) {
        var idx = 0;
        var len = list.length;
        while(idx < len){
            if (fn(list[idx])) return idx;
            idx += 1;
        }
        return -1;
    }));
    var $46ce3499b8bbb248$export$2e2bcd8739ae039 = $46ce3499b8bbb248$var$findIndex;
});
parcelRegister("5ukhB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fef7cd9678eafe2$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7C2oN;
    var $7D5kn;
    var $3fef7cd9678eafe2$var$XFindIndex = function() {
        function XFindIndex(f, xf) {
            this.xf = xf;
            this.f = f;
            this.idx = -1;
            this.found = false;
        }
        XFindIndex.prototype['@@transducer/init'] = (0, (0, parcelRequire("7D5kn")).default).init;
        XFindIndex.prototype['@@transducer/result'] = function(result) {
            if (!this.found) result = this.xf['@@transducer/step'](result, -1);
            return this.xf['@@transducer/result'](result);
        };
        XFindIndex.prototype['@@transducer/step'] = function(result, input) {
            this.idx += 1;
            if (this.f(input)) {
                this.found = true;
                result = (0, (0, parcelRequire("7C2oN")).default)(this.xf['@@transducer/step'](result, this.idx));
            }
            return result;
        };
        return XFindIndex;
    }();
    var $3fef7cd9678eafe2$var$_xfindIndex = (0, (0, parcelRequire("c9RLn")).default)(function _xfindIndex(f, xf) {
        return new $3fef7cd9678eafe2$var$XFindIndex(f, xf);
    });
    var $3fef7cd9678eafe2$export$2e2bcd8739ae039 = $3fef7cd9678eafe2$var$_xfindIndex;
});
const $f3f8e80f7954f218$export$526a1e214ba17198 = 'HEADER';
const $f3f8e80f7954f218$export$a64a0028232151aa = 'SUBHEADER';
const $f3f8e80f7954f218$export$867af8e076780d5d = 'TABLE_ITEM';
const $f3f8e80f7954f218$export$1c5a554c78c0cd12 = 'SCOPE';
const $f3f8e80f7954f218$export$5a619ff7a6fbfc2c = 'ADD_FIELDS';
const $f3f8e80f7954f218$export$ccb33e29d92c9a58 = 'EMPTY';
const $f3f8e80f7954f218$export$d6f887e0c1be1b74 = 'FIELD';
const $f3f8e80f7954f218$export$4f4c16e273d7a49d = 'TIMELINE';
const $f3f8e80f7954f218$export$1c6fd712f054cbca = 24;
const $f3f8e80f7954f218$export$2f0383777c41eca4 = 32;
const $f3f8e80f7954f218$export$7e9bb1a73c1c68af = 300;
parcelRegister("19P1y", function(module, exports) {
    $parcel$export(module.exports, "getGridRowId", ()=>$a33b8353327532c0$export$67ee5e0031f4b495);
    var $3J2mc;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $7lpPk = parcelRequire("7lpPk");
    var $6iNxz = parcelRequire("6iNxz");
    const $a33b8353327532c0$export$ad27d04e3788b5e6 = (id, viewMode)=>{
        const defaultWidthOfColumn = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE ? (0, $7lpPk.defaultWidthOfColumnTimeline) : (0, $7lpPk.defaultWidthOfColumnList);
        const columnId = id ?? 'DEFAULT';
        const columnWidth = defaultWidthOfColumn[columnId];
        return columnWidth ?? defaultWidthOfColumn.DEFAULT;
    };
    const $a33b8353327532c0$export$f556054ce4358701 = (id, isCollapsible, viewMode)=>{
        if (isCollapsible) return 24;
        if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE) return (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM;
        return $a33b8353327532c0$export$ad27d04e3788b5e6(id, viewMode);
    };
    const $a33b8353327532c0$export$67ee5e0031f4b495 = (item, index)=>{
        switch(item.tag){
            case 0, $6iNxz.TABLE_ISSUE:
                return `${item.tag}-${item.group || ''}-${item.value.id}`;
            case 0, $6iNxz.TABLE_INLINE_CREATE:
                return `${item.tag}-${item.group || ''}-${item.value.id}`;
            case 0, $6iNxz.TABLE_HEADER:
            case 0, $6iNxz.TABLE_GROUP_HEADER:
            case 0, $6iNxz.TABLE_BLANK_ROW:
            case 0, $6iNxz.TABLE_GROUP:
                return `${item.tag}-${index}`;
            default:
                return `${index}`;
        }
    };
});
parcelRegister("1l6AC", function(module, exports) {
    $parcel$export(module.exports, "getScopeWidth", ()=>$4e9350fe3801ac70$export$2399fb6b8ed70468);
    $parcel$export(module.exports, "getFieldsWidth", ()=>$4e9350fe3801ac70$export$661aa4dfe4b50072);
    $parcel$export(module.exports, "getTimelineExportWidth", ()=>$4e9350fe3801ac70$export$306be9ad4bb930e1);
    $parcel$export(module.exports, "getExportAppWidth", ()=>$4e9350fe3801ac70$export$1c2ade09f4d8515e);
    var $3J2mc;
    var $3YtPS = parcelRequire("3YtPS");
    var $idmiV = parcelRequire("idmiV");
    var $1CGdp = parcelRequire("1CGdp");
    var $kWDpn = parcelRequire("kWDpn");
    const $4e9350fe3801ac70$export$a84244a60e1e50a0 = (state)=>state.ui.SectionWidths;
    const $4e9350fe3801ac70$export$2399fb6b8ed70468 = (0, $3YtPS.createSelector)([
        $4e9350fe3801ac70$export$a84244a60e1e50a0
    ], (sectionWidths)=>sectionWidths.scope);
    const $4e9350fe3801ac70$export$661aa4dfe4b50072 = (0, $3YtPS.createSelector)([
        $4e9350fe3801ac70$export$a84244a60e1e50a0
    ], (sectionWidths)=>sectionWidths.fields);
    const $4e9350fe3801ac70$export$87113eddf3515c00 = (0, $3YtPS.createSelector)([
        $4e9350fe3801ac70$export$a84244a60e1e50a0
    ], (sectionWidths)=>sectionWidths.timeline);
    const $4e9350fe3801ac70$export$306be9ad4bb930e1 = (0, $3YtPS.createSelector)([
        $4e9350fe3801ac70$export$a84244a60e1e50a0
    ], (sectionWidths)=>sectionWidths.timelineExport);
    const $4e9350fe3801ac70$export$6f0aedaf3448509d = (viewMode, reportMode, timelineExportWidth)=>{
        if (!reportMode) return undefined;
        return (0, $idmiV.getNonTimelineWidth)() + (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE ? timelineExportWidth : 0);
    };
    const $4e9350fe3801ac70$export$1c2ade09f4d8515e = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getViewMode),
        (0, $1CGdp.isReportMode),
        $4e9350fe3801ac70$export$306be9ad4bb930e1
    ], $4e9350fe3801ac70$export$6f0aedaf3448509d);
});
parcelRegister("3vHWp", function(module, exports) {
    $parcel$export(module.exports, "PlanTable", ()=>$1bd059b00d2bdda3$export$361ae292a480e348);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $99gkn;
    var $7cFR3;
    var $8dO33;
    var $2i4sA;
    var $7iJwP;
    var $4R6GH;
    var $ousew;
    var $g7crU;
    var $3HwlS;
    var $3J2mc;
    var $hGiZz;
    var $nXNNJ;
    var $ks7qB;
    var $igD1g;
    var $g295Q;
    var $aPRoZ;
    var $dUk9j;
    var $6iNxz = parcelRequire("6iNxz");
    var $db0fs = parcelRequire("db0fs");
    var $4y9A5 = parcelRequire("4y9A5");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fkq9X = parcelRequire("fkq9X");
    var $lvtWn;
    var $2KkNy;
    var $iXVV6;
    var $isuse;
    var $efvDm;
    var $k9JTq;
    var $l8ruj;
    var $4cSmd = parcelRequire("4cSmd");
    var $bUB9H = parcelRequire("bUB9H");
    var $7CIng = parcelRequire("7CIng");
    var $w2hJE = parcelRequire("w2hJE");
    var $3oPSC = parcelRequire("3oPSC");
    var $fWEk3 = parcelRequire("fWEk3");
    var $l38L3 = parcelRequire("l38L3");
    var $3jIvH = parcelRequire("3jIvH");
    var $grJar = parcelRequire("grJar");
    var $eMIwl = parcelRequire("eMIwl");
    var $3enBw = parcelRequire("3enBw");
    var $gzkx8 = parcelRequire("gzkx8");
    var $jxhnO = parcelRequire("jxhnO");
    var $fVLsa = parcelRequire("fVLsa");
    var $2nwtP = parcelRequire("2nwtP");
    var $iqWh9 = parcelRequire("iqWh9");
    var $jFeQO = parcelRequire("jFeQO");
    var $fXuAE = parcelRequire("fXuAE");
    var $6y7pI = parcelRequire("6y7pI");
    var $cveZJ = parcelRequire("cveZJ");
    var $D3sP2 = parcelRequire("D3sP2");
    var $c0IZ0 = parcelRequire("c0IZ0");
    var $1No5o = parcelRequire("1No5o");
    var $bw5AJ = parcelRequire("bw5AJ");
    var $aXxWj = parcelRequire("aXxWj");
    var $d89F6 = parcelRequire("d89F6");
    var $7qOOt = parcelRequire("7qOOt");
    var $jNsaP = parcelRequire("jNsaP");
    var $9yZvX = parcelRequire("9yZvX");
    var $j9exh = parcelRequire("j9exh");
    var $8G9be = parcelRequire("8G9be");
    var $21TKe = parcelRequire("21TKe");
    var $crwfY = parcelRequire("crwfY");
    var $lpjOV = parcelRequire("lpjOV");
    var $l64uT = parcelRequire("l64uT");
    var $4abst = parcelRequire("4abst");
    var $ehW3P = parcelRequire("ehW3P");
    var $jLmIs = parcelRequire("jLmIs");
    var $dJfym = parcelRequire("dJfym");
    var $jVyaJ = parcelRequire("jVyaJ");
    var $hXzDb = parcelRequire("hXzDb");
    var $4rz0F = parcelRequire("4rz0F");
    var $bQYPY = parcelRequire("bQYPY");
    var $cispL = parcelRequire("cispL");
    var $h3GjG = parcelRequire("h3GjG");
    var $dQp5d = parcelRequire("dQp5d");
    var $74EGL = parcelRequire("74EGL");
    var $cyHFd = parcelRequire("cyHFd");
    var $8nzhj = parcelRequire("8nzhj");
    var $lx3ag = parcelRequire("lx3ag");
    var $2A3Yi = parcelRequire("2A3Yi");
    var $g1rn7 = parcelRequire("g1rn7");
    var $3t5zX = parcelRequire("3t5zX");
    var $ixYfg = parcelRequire("ixYfg");
    var $86PwE = parcelRequire("86PwE");
    var $8Fn01 = parcelRequire("8Fn01");
    var $cte8I = parcelRequire("cte8I");
    var $7s7Sp = parcelRequire("7s7Sp");
    var $2fN10 = parcelRequire("2fN10");
    var $dhREm = parcelRequire("dhREm");
    var $kk57f = parcelRequire("kk57f");
    var $4KvFW = parcelRequire("4KvFW");
    const $1bd059b00d2bdda3$export$361ae292a480e348 = ({ rows: rows, rowIds: rowIds, rowConfigs: rowConfigs, columnConfigs: columnConfigs, stickyRows: stickyRows, columns: columns, mode: mode, viewMode: viewMode, viewId: viewId, isReportMode: isReportMode, isConfluenceMacro: isConfluenceMacro, isEmbed: isEmbed, reportTimeToInteractive: reportTimeToInteractive, onRoadmapView: onRoadmapView, exportAppWidth: exportAppWidth })=>{
        const shouldShowNav4 = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
        const useCurrentSpotlight = shouldShowNav4 ? (0, (0, parcelRequire("aPRoZ")).useCurrentSpotlight) : (0, (0, parcelRequire("aPRoZ")).useCurrentSpotlightOld);
        const { software: edition } = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const columnIds = (0, $5uXOq.useMemo)(()=>(0, $jVyaJ.getColumnIds)(columns), [
            columns
        ]);
        let isFullscreen;
        let setIsFullscreen;
        if (shouldShowNav4) [isFullscreen, { setIsFullscreen: setIsFullscreen }] = (0, (0, parcelRequire("g7crU")).useIsFullscreen)();
        else [isFullscreen, setIsFullscreen] = (0, $5uXOq.useState)(false);
        const numOfRows = rowConfigs.length;
        const hasGroups = rows.some((row)=>row.tag === (0, $f3f8e80f7954f218$export$867af8e076780d5d) && row.payload.itemTag === (0, $6iNxz.TABLE_GROUP));
        const [{ spotlight: onboardingSpotlight }] = useCurrentSpotlight();
        const [cttOnboardingSpotlight] = (0, (0, parcelRequire("igD1g")).useCttSpotlight)();
        const spotlightSelection = onboardingSpotlight === (0, (0, parcelRequire("aPRoZ")).Spotlights).Inactive ? cttOnboardingSpotlight : onboardingSpotlight;
        const rangeExtractor = (0, $5uXOq.useMemo)(()=>(0, $jVyaJ.makeRangeExtractor)(stickyRows), [
            stickyRows
        ]);
        const isExportMode = mode === (0, $ab4be2e1e204af69$export$f79b1fae3e63e441);
        const nativeScrollbarHeight = (0, (0, parcelRequire("hGiZz")).useNativeScrollbarHeight)() ?? 0;
        const hasFields = columns.length > 2;
        const shouldHideScrollbar = !isExportMode && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE;
        const viewportInset = (0, $5uXOq.useMemo)(()=>shouldHideScrollbar ? (0, $jVyaJ.getViewportInset)(nativeScrollbarHeight) : undefined, [
            shouldHideScrollbar,
            nativeScrollbarHeight
        ]);
        const additionalHeightToHideNativeScrollbar = shouldHideScrollbar ? (0, $jVyaJ.getAdditionalHeightToHideNativeScrollbar)(nativeScrollbarHeight) : 0;
        const renderRow = (0, $5uXOq.useCallback)((_row, _columns, index, liteRow)=>{
            const row = rows[index];
            const key = rowIds[index] ?? index;
            if (row.tag === (0, $f3f8e80f7954f218$export$526a1e214ba17198)) return (0, (0, parcelRequire("4R6GH")).fg)('plans_performance_improvements_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement($1bd059b00d2bdda3$var$MemoedHeaderRow, {
                key: key,
                index: index,
                columns: columns,
                mode: mode,
                viewMode: viewMode
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement($1bd059b00d2bdda3$var$HeaderRow, {
                key: key,
                index: index,
                columns: columns,
                mode: mode,
                viewMode: viewMode
            });
            if (row.tag === (0, $f3f8e80f7954f218$export$a64a0028232151aa)) return (0, (0, parcelRequire("4R6GH")).fg)('plans_performance_improvements_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement($1bd059b00d2bdda3$var$MemoedSubheaderRow, {
                key: key,
                index: index,
                columns: columns,
                mode: mode,
                viewMode: viewMode
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement($1bd059b00d2bdda3$var$SubheaderRow, {
                key: key,
                index: index,
                columns: columns,
                mode: mode,
                viewMode: viewMode
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Fn01.ItemProvider), {
                key: key,
                itemIndex: row.payload.itemIndex
            }, (item)=>(0, ($parcel$interopDefault($5uXOq))).createElement($1bd059b00d2bdda3$var$BodyRow, {
                    index: index,
                    item: item
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($1bd059b00d2bdda3$var$BodyRowCells, {
                    isFirst: index === 2,
                    item: item,
                    columns: columns,
                    mode: mode,
                    viewMode: viewMode,
                    hasFields: hasFields,
                    liteRow: liteRow
                })));
        }, [
            rows,
            rowIds,
            columns,
            mode,
            viewMode,
            hasFields
        ]);
        const renderEmpty = (0, $5uXOq.useCallback)((height)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
                index: -1,
                height: height,
                role: "presentation"
            }, columns.map((column, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                    key: index,
                    column: index
                }, column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12) && numOfRows === 2 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $6y7pI.EmptyView), null), column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                    offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fVLsa.TimelineAxis), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWEk3.default), {
                    noMarker: true
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iqWh9.TimelineReleaseBar), {
                    noMarker: true
                }))))), [
            columns,
            numOfRows
        ]);
        const colspan = (0, $5uXOq.useMemo)(()=>(0, $jVyaJ.makeColspan)(viewMode, columns), [
            viewMode,
            columns
        ]);
        const toggleFullscreen = (0, $5uXOq.useCallback)(()=>{
            setIsFullscreen(!isFullscreen);
        }, [
            isFullscreen,
            setIsFullscreen
        ]);
        const ref = (0, $5uXOq.useRef)(null);
        const withSpotlight = spotlightSelection === (0, (0, parcelRequire("aPRoZ")).Spotlights).HeartOfPlan || spotlightSelection === (0, (0, parcelRequire("g295Q")).CttSpotlights).Scope;
        (0, $5uXOq.useLayoutEffect)(()=>{
            reportTimeToInteractive({
                isNewSidebarEnabled: true,
                isTransposed: true
            });
        }, [
            reportTimeToInteractive
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (ref?.current && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST) ref.current.scrollLeft = 0;
        }, [
            viewMode
        ]);
        const ZIndexProvider = (0, (0, parcelRequire("4R6GH")).fg)('plans_performance_improvements') ? (0, $fkq9X.ZIndexProvider) : (0, $fkq9X.ZIndexProviderOld);
        return (0, (0, parcelRequire("4R6GH")).fg)('plans_performance_improvements_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $crwfY.ScrollShadowOverlay), {
            hasGroups: hasGroups
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cispL.ColumnWidthsProvider), {
            columnIds: columnIds,
            columns: columns,
            viewMode: viewMode,
            viewId: viewId
        }, ({ value: columnWidths, defaultValue: defaultColumnWidths, onChange: handleColumnWidthsChange, resizer: resizer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvtWn")).Grid), {
                layout: "fixed",
                columnWidths: columnWidths,
                columnConfigs: columnConfigs,
                colspan: colspan,
                rowConfigs: rowConfigs,
                resizer: resizer,
                row: renderRow,
                empty: renderEmpty,
                overscan: isExportMode ? Infinity : 20,
                stickyOffset: (0, $jVyaJ.getDefaultStickyOffset)(),
                rangeExtractor: rangeExtractor,
                virtualizationScrollThreshold: 400,
                onColumnWidthsChange: handleColumnWidthsChange
            }, (table)=>{
                if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !hasFields && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $21TKe.EmptyList), null), table, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2fN10.ScrollReset), {
                    viewId: viewId,
                    viewMode: viewMode
                }), (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8nzhj.ColumnDragAutoScroll), {
                    containerRef: ref
                }));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aXxWj.AxisFirstTimeUnit), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bw5AJ.Arrows), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jNsaP.DependencyDragPreview), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $d89F6.Blanket), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4rz0F.Collapsible), {
                    columnIds: columnIds,
                    onColumnWidthsChange: handleColumnWidthsChange,
                    defaultColumnWidths: defaultColumnWidths,
                    resizer: resizer
                }, table), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $j9exh.DependencyLinesContainer), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9yZvX.DependencyLineDetail), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $86PwE.HorizontalScrollingSync), {
                    columnWidths: columnWidths,
                    offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bUB9H.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2fN10.ScrollReset), {
                    viewId: viewId,
                    viewMode: viewMode
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lpjOV.ScrollBar), {
                    bottom: viewportInset?.bottom ?? 0
                }), (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dhREm.TimelineDragAutoScroll), {
                    containerRef: ref
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kk57f.TimelineDragAutoScroll), {
                    containerRef: ref
                }));
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $h3GjG.DependencyDragCreate), {
            rows: rows
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "view-advanced-roadmaps-timeline"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2i4sA")).ViewExperienceTrackingProvider), {
            experience: (0, $l38L3.getExperienceName)(isReportMode, isConfluenceMacro, isEmbed),
            analyticsSource: "portfolio3",
            application: (0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO),
            edition: edition,
            additionalAttributes: {
                synthetic: (0, (0, parcelRequire("nXNNJ")).isPollinatorTenant)()
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $db0fs.default), {
            location: "portfolio-3.simple-plans.roadmap.state-or-global-error",
            locationType: "path",
            locationPrefix: "roadmap"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dO33")).SmartCardProvider), {
            client: new (0, (0, parcelRequire("7cFR3")).default)()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: (0, $TTKUQ.ERROR_REPORTING_PACKAGE).ROADMAP,
            attributes: {
                isTransposed: true
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: (0, $TTKUQ.ERROR_REPORTING_PACKAGE).ROADMAP,
            packageName: (0, $TTKUQ.PACKAGE_NAME),
            teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM),
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                isTransposed: 'true'
            }
        }, !isExportMode && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "view-advanced-roadmaps-timeline-overlay"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dJfym.TableToolbar), {
            viewMode: viewMode,
            isCollapsible: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE,
            onToggleFullscreen: toggleFullscreen,
            isFullscreen: isFullscreen
        })), (0, ($parcel$interopDefault($5uXOq))).createElement(ZIndexProvider, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cyHFd.DragAndDropProvider), null, (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lx3ag.ColumnDragManager), null), (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2A3Yi.ColumnDragScrollLock), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dQp5d.AutoScrollObserver), {
            scrollRef: ref
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $74EGL.DragScrollLock), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cSmd.DependenciesFlyoutProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8G9be.default), null, withSpotlight && !shouldShowNav4 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUk9j")).SpotlightTarget), {
            name: (0, (0, parcelRequire("aPRoZ")).Spotlights).HeartOfPlan
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUk9j")).SpotlightTarget), {
            name: (0, (0, parcelRequire("g295Q")).CttSpotlights).Scope
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1bd059b00d2bdda3$var$spotlightPlaceholderStyles
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1bd059b00d2bdda3$var$hiddenOverflowStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3t5zX.EnhancedContainer), {
            xcss: [
                withSpotlight && !shouldShowNav4 && $1bd059b00d2bdda3$var$spotlightContainerStyles,
                isFullscreen && $1bd059b00d2bdda3$var$fullscreenContainerStyles,
                isExportMode && $1bd059b00d2bdda3$var$exportContainerStyles
            ],
            width: exportAppWidth,
            style: {
                bottom: -additionalHeightToHideNativeScrollbar
            },
            viewportInset: viewportInset,
            outerRef: ref,
            "data-scroll": "lockable",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $crwfY.ScrollShadowOverlay), {
            hasGroups: hasGroups
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cispL.ColumnWidthsProvider), {
            columnIds: columnIds,
            columns: columns,
            viewMode: viewMode,
            viewId: viewId
        }, ({ value: columnWidths, defaultValue: defaultColumnWidths, onChange: handleColumnWidthsChange, resizer: resizer })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvtWn")).Grid), {
                layout: "fixed",
                columnWidths: columnWidths,
                columnConfigs: columnConfigs,
                colspan: colspan,
                rowConfigs: rowConfigs,
                resizer: resizer,
                row: renderRow,
                empty: renderEmpty,
                overscan: isExportMode ? Infinity : 20,
                stickyOffset: (0, $jVyaJ.getDefaultStickyOffset)(),
                rangeExtractor: rangeExtractor,
                virtualizationScrollThreshold: 400,
                onColumnWidthsChange: handleColumnWidthsChange
            }, (table)=>{
                if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !hasFields && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $21TKe.EmptyList), null), table, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2fN10.ScrollReset), {
                    viewId: viewId,
                    viewMode: viewMode
                }), (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8nzhj.ColumnDragAutoScroll), {
                    containerRef: ref
                }));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aXxWj.AxisFirstTimeUnit), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bw5AJ.Arrows), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jNsaP.DependencyDragPreview), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $d89F6.Blanket), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4rz0F.Collapsible), {
                    columnIds: columnIds,
                    onColumnWidthsChange: handleColumnWidthsChange,
                    defaultColumnWidths: defaultColumnWidths,
                    resizer: resizer
                }, table), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $j9exh.DependencyLinesContainer), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9yZvX.DependencyLineDetail), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $86PwE.HorizontalScrollingSync), {
                    columnWidths: columnWidths,
                    offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bUB9H.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2fN10.ScrollReset), {
                    viewId: viewId,
                    viewMode: viewMode
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lpjOV.ScrollBar), {
                    bottom: viewportInset?.bottom ?? 0
                }), (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dhREm.TimelineDragAutoScroll), {
                    containerRef: ref
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kk57f.TimelineDragAutoScroll), {
                    containerRef: ref
                }));
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $h3GjG.DependencyDragCreate), {
            rows: rows
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3oPSC.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7s7Sp.ScrollIntoView), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cSmd.DependenciesFlyoutOverlay), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ks7qB")).default), null))))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: onRoadmapView
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4KvFW.ViewExperienceSuccessTracker), null)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
            data: {
                viewMode: viewMode,
                isTransposed: true
            }
        })));
    };
    const $1bd059b00d2bdda3$var$HeaderRow = ({ index: index, columns: columns, mode: mode, viewMode: viewMode })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
            index: index,
            style: {
                '--plan-grid-row-background': `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20A})`
            }
        }, columns.map((column, index)=>{
            if (column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                key: index,
                column: index,
                hasBorderBottom: true,
                resizeHandle: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cte8I.ResizeHandle), null),
                top: 0,
                rowType: "header"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7CIng.default), null, ({ isSelected: isSelected })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $D3sP2.ScopeHeader), {
                    isSelected: isSelected
                })));
            if (column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                key: index,
                column: index,
                hasBorderBottom: true,
                top: 0,
                columnText: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7qOOt.TimelineColumnText), {
                    column: index,
                    hasStripe: mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771),
                    title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $1No5o.default).timeline),
                    icon: null,
                    appearance: "section",
                    useColumnToggle: (0, $bQYPY.useColumnToggle)
                }),
                rowType: "header"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c0IZ0.TimelineHeader), null)));
            if (index === 1) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                key: index,
                column: index,
                hasBorderBottom: true,
                columnText: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7qOOt.ColumnText), {
                    column: index,
                    title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $1No5o.default).fields),
                    icon: null,
                    appearance: "section",
                    hasStripe: mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771),
                    useColumnToggle: (0, $bQYPY.useColumnToggle)
                }),
                resizeHandle: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cte8I.ResizeHandle), null) : undefined,
                clipped: false,
                top: 0,
                rowType: "header"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cveZJ.FieldsHeader), {
                useColumnToggle: (0, $bQYPY.useColumnToggle),
                collapsible: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE
            }));
            return null;
        }));
    const $1bd059b00d2bdda3$var$MemoedHeaderRow = (0, $5uXOq.memo)($1bd059b00d2bdda3$var$HeaderRow);
    const $1bd059b00d2bdda3$var$SubheaderRow = ({ index: index, columns: columns, mode: mode, viewMode: viewMode })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
            index: index
        }, columns.map((column, index)=>{
            if (column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                key: "scope",
                column: index,
                top: 50,
                hasBorderBottom: true,
                hasColumnDropIndicator: true,
                rowType: "subheader"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7CIng.default), null, ({ totalSelected: totalSelected, isSelected: isSelected, isIndeterminate: isIndeterminate, toggleAllSelected: toggleAllSelected })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ehW3P.ScopeSubheader), {
                    totalSelected: totalSelected,
                    isSelected: isSelected,
                    isIndeterminate: isIndeterminate,
                    toggleAllSelected: toggleAllSelected
                })));
            if (column.tag === (0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c) || column.tag === (0, $f3f8e80f7954f218$export$ccb33e29d92c9a58)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                key: "add-fields",
                column: index,
                top: 50,
                hasBorderBottom: true,
                rowType: "subheader"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $l64uT.AddFields), null));
            if (column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                key: index,
                column: index,
                top: 50,
                hasBorderBottom: true,
                rowType: "subheader"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jLmIs.TimelineSubheader), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iqWh9.TimelineReleaseBar), null)));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ixYfg.FieldAccessories), {
                key: column.payload.id,
                columnId: column.payload.id
            }, ({ title: title, icon: icon, column: issueColumn })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                    column: index,
                    columnId: column.payload.id,
                    isDraggableColumn: true,
                    hasColumnDropIndicator: true,
                    top: 50,
                    hasBorderBottom: true,
                    resizeHandle: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cte8I.ResizeHandle), null),
                    columnText: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7qOOt.ColumnText), {
                        column: index,
                        title: title,
                        icon: icon,
                        appearance: "field",
                        hasStripe: mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771),
                        useColumnToggle: (0, $bQYPY.useColumnToggle)
                    }),
                    rowType: "subheader"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4abst.FieldSubheader), {
                    title: title,
                    icon: icon,
                    column: issueColumn,
                    useColumnToggle: (0, $bQYPY.useColumnToggle),
                    collapsible: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE
                })));
        }));
    const $1bd059b00d2bdda3$var$MemoedSubheaderRow = (0, $5uXOq.memo)($1bd059b00d2bdda3$var$SubheaderRow);
    const $1bd059b00d2bdda3$var$BodyRow = (0, $5uXOq.memo)(({ index: rowIndex, children: children, item: item })=>{
        switch(item?.tag){
            case 0, $6iNxz.TABLE_GROUP:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
                    index: rowIndex
                }, children);
            case 0, $6iNxz.TABLE_HEADER:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
                    index: rowIndex
                }, children);
            case 0, $6iNxz.TABLE_INLINE_CREATE:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
                    index: rowIndex
                }, children);
            case 0, $6iNxz.TABLE_GROUP_HEADER:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hXzDb.BackgroundProvider), {
                    index: rowIndex
                }, ({ base: base })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
                        index: rowIndex,
                        style: {
                            '--plan-grid-row-background': base
                        }
                    }, children));
            case 0, $6iNxz.TABLE_ISSUE:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hXzDb.BackgroundProvider), {
                    issue: item.value
                }, ({ base: base, hover: hover })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
                        index: rowIndex,
                        style: {
                            '--plan-grid-row-background-base': base,
                            '--plan-grid-row-background-hover': hover
                        },
                        xcss: $1bd059b00d2bdda3$var$rowHoverStyles
                    }, children));
            case 0, $6iNxz.TABLE_BLANK_ROW:
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hXzDb.BackgroundProvider), {
                    index: rowIndex
                }, ({ base: base })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
                        index: rowIndex,
                        style: {
                            '--plan-grid-row-background': base
                        }
                    }, children));
        }
    });
    const $1bd059b00d2bdda3$var$BodyRowCells = (0, $5uXOq.memo)(({ item: item, viewMode: viewMode, hasFields: hasFields, isFirst: isFirst, columns: columns, mode: mode, liteRow: liteRow })=>{
        const isLite = Boolean(liteRow);
        const isVisibleInLite = (column)=>Boolean(liteRow?.visibleCols && liteRow.visibleCols[column.toString()]);
        switch(item?.tag){
            case 0, $6iNxz.TABLE_GROUP:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, columns.map((column, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                        column: index,
                        key: index,
                        hasDropIndicator: !isLite,
                        top: 90,
                        hasBorderTop: !isFirst,
                        rowType: "group"
                    }, column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.scope"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eMIwl.Group), {
                        item: item
                    })), column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                        offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jFeQO.TimelineTableGroup), {
                        item: item
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWEk3.default), {
                        noMarker: true
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iqWh9.TimelineReleaseBar), {
                        noMarker: true
                    })), column.tag !== (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12) && column.tag !== (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eMIwl.Group), null))));
            case 0, $6iNxz.TABLE_HEADER:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, columns.map((column, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                        column: index,
                        key: index,
                        hasDropIndicator: !isLite
                    }, column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.scope"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fXuAE.WithoutParentHeader), {
                        item: item
                    })), column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                        offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fVLsa.TimelineAxis), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWEk3.default), {
                        noMarker: true
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iqWh9.TimelineReleaseBar), {
                        noMarker: true
                    })))));
            case 0, $6iNxz.TABLE_INLINE_CREATE:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, columns.map((column, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                        column: index,
                        key: index,
                        hasDropIndicator: !isLite
                    }, column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $w2hJE.default), {
                        rootIndex: item.value.rootIndex,
                        isReadOnly: false,
                        fixVersions: item.value.fixVersions?.map((x)=>Number(x)),
                        components: item.value.components?.map((x)=>Number(x)),
                        getContainer: (0, $4y9A5.getBody)
                    }), column.tag === (0, $f3f8e80f7954f218$export$d6f887e0c1be1b74) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3jIvH.Field), {
                        issue: item.value,
                        columnId: column.payload.id,
                        isScrolling: isLite
                    }), column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                        offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fVLsa.TimelineAxis), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWEk3.default), {
                        noMarker: true
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iqWh9.TimelineReleaseBar), {
                        noMarker: true
                    })))));
            case 0, $6iNxz.TABLE_GROUP_HEADER:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, columns.map((column, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                        column: index,
                        key: index,
                        hasDropIndicator: !isLite,
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.group-header"
                    }, column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $grJar.GroupHeader), {
                        item: item,
                        readonly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef)
                    }), column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                        offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fVLsa.TimelineAxis), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWEk3.default), {
                        noMarker: true
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iqWh9.TimelineReleaseBar), {
                        noMarker: true
                    })))));
            case 0, $6iNxz.TABLE_ISSUE:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, columns.map((column, index)=>{
                    if (column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                        column: index,
                        key: index,
                        hasDragIndicator: !isLite,
                        hasDropIndicator: !isLite,
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.scope"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $gzkx8.Scope), {
                        item: item,
                        readonly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
                        isScrolling: isLite
                    }));
                    if (column.tag === (0, $f3f8e80f7954f218$export$d6f887e0c1be1b74)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                        column: index,
                        key: index,
                        hasDragIndicator: !isLite,
                        hasDropIndicator: !isLite,
                        "data-name": `cell-${item.value.id}`,
                        "data-attribute": column.payload.id
                    }, (!isLite || isVisibleInLite(index)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3jIvH.Field), {
                        issue: item.value,
                        columnId: column.payload.id,
                        isScrolling: isLite
                    }));
                    if (column.tag === (0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c) || column.tag === (0, $f3f8e80f7954f218$export$ccb33e29d92c9a58)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                        column: index,
                        key: index,
                        hasDragIndicator: !isLite,
                        hasDropIndicator: !isLite,
                        hasBackground: hasFields || viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE
                    });
                    if (column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                        column: index,
                        key: index,
                        hasDragIndicator: !isLite,
                        hasDropIndicator: !isLite
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                        offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fVLsa.TimelineAxis), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2nwtP.TimelineIssueRow), {
                        issue: item.value
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWEk3.default), {
                        noMarker: true
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iqWh9.TimelineReleaseBar), {
                        noMarker: true
                    })));
                    return null;
                }));
            case 0, $6iNxz.TABLE_BLANK_ROW:
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, columns.map((column, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $g1rn7.EnhancedCell), {
                        column: index,
                        key: index,
                        hasDropIndicator: !isLite,
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.empty"
                    }, column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3enBw.OrphanDropTarget), null), column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                        offset: (0, $2ac30dbb3094ef55$export$168e85cd31f14583)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fVLsa.TimelineAxis), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWEk3.default), {
                        noMarker: true
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iqWh9.TimelineReleaseBar), {
                        noMarker: true
                    })))));
        }
    });
    const $1bd059b00d2bdda3$var$spotlightPlaceholderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        pointerEvents: 'none'
    });
    const $1bd059b00d2bdda3$var$hiddenOverflowStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        position: 'relative',
        width: '100%'
    });
    const $1bd059b00d2bdda3$var$fullscreenContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'fixed',
        background: 'elevation.surface',
        zIndex: 1,
        '::before': {
            content: '""',
            background: 'elevation.surface',
            position: 'absolute',
            zIndex: -1
        }
    });
    const $1bd059b00d2bdda3$var$spotlightContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        pointerEvents: 'none',
        zIndex: (0, $2ac30dbb3094ef55$export$8b2f0f816c634962) + 1
    });
    const $1bd059b00d2bdda3$var$exportContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        zIndex: 1
    });
    const $1bd059b00d2bdda3$var$rowHoverStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        '--plan-grid-row-background': 'var(--plan-grid-row-background-base)',
        ':hover': {
            '--plan-grid-row-background': 'var(--plan-grid-row-background-hover, var(--plan-grid-row-background-base))'
        }
    });
});
parcelRegister("7cFR3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d96ed473518bd99$export$2e2bcd8739ae039);
    var $hhZW9 = parcelRequire("hhZW9");
    var $hj8yn = parcelRequire("hj8yn");
    var $hLXaJ = parcelRequire("hLXaJ");
    var $kDZ6Z;
    var $itO4f;
    var $fiKQs;
    var $dV0Jy;
    var $4Bkrp;
    var $iwKVT = parcelRequire("iwKVT");
    const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
    const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
    const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
    const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
    class $8d96ed473518bd99$export$2e2bcd8739ae039 {
        constructor(envKey, baseUrlOverride){
            this.postBatchResolve = async (resources, resourceType = 'URL')=>{
                const deDuplicatedResources = [
                    ...new Set(resources)
                ];
                let resolvedResources = [];
                const headers = {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                    ...this.product ? {
                        'X-Product': this.product
                    } : {}
                };
                try {
                    if (resourceType === 'URL') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                            resourceUrl: resourceUrl
                        })), headers);
                    if (resourceType === 'ARI') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                            ari: ari
                        })), headers);
                } catch (error) {
                    resolvedResources = resources.map(()=>{
                        const status = (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(error) ? error.status : 500;
                        const errorResponse = {
                            status: status,
                            error: error
                        };
                        return errorResponse;
                    });
                }
                const map = {};
                for(let i = 0; i < deDuplicatedResources.length; ++i){
                    const resource = deDuplicatedResources[i];
                    const data = resolvedResources[i];
                    map[resource] = data;
                }
                return resources.map((originalResource)=>map[originalResource]);
            };
            this.batchResolve = async (urls)=>{
                return this.postBatchResolve(urls, 'URL');
            };
            this.batchResolveAris = async (aris)=>{
                return this.postBatchResolve(aris, 'ARI');
            };
            this.resolverUrl = (0, (0, parcelRequire("itO4f")).getResolverUrl)(envKey, baseUrlOverride);
            this.loadersByDomain = {};
            this.retryConfig = {
                retries: 2
            };
            this.resolvedCache = {};
            this.envKey = envKey;
            this.baseUrlOverride = baseUrlOverride;
        }
        setProduct(product) {
            this.product = product;
        }
        createLoader() {
            const batchResolveThrottler = (0, ($parcel$interopDefault($hLXaJ)))({
                limit: 1,
                interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
            });
            const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
            return new (0, ($parcel$interopDefault($hhZW9)))((urls)=>throttledBatchResolve(urls), {
                maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
                cache: false
            });
        }
        getLoader(hostname) {
            if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
            return this.loadersByDomain[hostname];
        }
        async resolveUrl(url, force = false) {
            const hostname = new URL(url).hostname;
            const loader = this.getLoader(hostname);
            let responsePromise;
            responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
            if (!responsePromise || force) {
                responsePromise = loader.load(url);
                $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
            }
            let response;
            try {
                response = await responsePromise;
            } catch (e) {
                $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
                throw e;
            }
            const isUnresolvedLink = !(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response) || (0, (0, parcelRequire("fiKQs")).getStatus)(response.body) !== 'resolved';
            if (isUnresolvedLink) $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            return response;
        }
        async prefetchData(url) {
            const response = await this.resolveUrl(url, false);
            if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response.body;
            else try {
                const retriedResponse = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                    if (!this.resolvedCache[url]) {
                        const response = await this.resolveUrl(url, false);
                        if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response;
                        else throw new Error('Retry for URL failed');
                    } else throw new Error('Retry unneeded - link has been resolved.');
                }, this.retryConfig);
                return retriedResponse.body;
            } catch (err) {
                return undefined;
            }
        }
        isRateLimitError(response) {
            return (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response) && response.error.status === 429;
        }
        async fetchData(url, force) {
            let response = await this.resolveUrl(url, force);
            if (this.isRateLimitError(response)) response = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                const retryResponse = await this.resolveUrl(url, false);
                if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
                return retryResponse;
            }, this.retryConfig);
            if (!(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
            this.resolvedCache[url] = true;
            return response.body;
        }
        async fetchDataAris(aris) {
            return await this.batchResolveAris(aris);
        }
        async postData(data) {
            const requestData = {
                key: data.key,
                action: data.action,
                context: data.context
            };
            return await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke`, requestData);
        }
        async search(data) {
            const { key: key, action: action } = data;
            const { query: query, context: context } = action;
            const requestData = {
                key: key,
                search: {
                    query: query,
                    context: context
                }
            };
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke/search`, requestData);
            if ((0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response)) throw this.mapErrorResponse(response);
            return response;
        }
        async fetchAvailableSearchProviders() {
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/providers`, {
                type: 'search'
            });
            return response.providers;
        }
        mapErrorResponse(response, hostname = '') {
            if (response?.error) {
                const errorType = response.error.type;
                const errorMessage = response.error.message;
                const extensionKey = response.error.extensionKey;
                if (response.error instanceof (0, (0, parcelRequire("dV0Jy")).NetworkError)) return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType);
                switch(errorType){
                    case 'ResolveBadRequestError':
                    case 'SearchBadRequestError':
                    case 'BadRequestError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveAuthError':
                    case 'SearchAuthError':
                    case 'AuthError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveUnsupportedError':
                    case 'SearchUnsupportedError':
                    case 'UnsupportedError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveFailedError':
                    case 'SearchFailedError':
                    case 'ResolveTimeoutError':
                    case 'SearchTimeoutError':
                    case 'SearchRateLimitError':
                    case 'ResolveRateLimitError':
                    case 'InternalServerError':
                    case 'TimeoutError':
                    case 'RateLimitError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('error', hostname, errorMessage, errorType, extensionKey);
                }
            }
            const { error: error, ...rest } = response || {};
            return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
        }
        stringifyError(err) {
            return JSON.stringify(err, typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
        }
    }
});
parcelRegister("hhZW9", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $c964119340a5ebe3$var$DataLoader = function() {
        function DataLoader(batchLoadFn, options) {
            if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
            this._batchLoadFn = batchLoadFn;
            this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
            this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
            this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
            this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
            this._batch = null;
            this.name = $c964119340a5ebe3$var$getValidName(options);
        }
        var _proto = DataLoader.prototype;
        _proto.load = function load(key) {
            if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
            var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
            var cacheMap = this._cacheMap;
            var cacheKey = this._cacheKeyFn(key);
            if (cacheMap) {
                var cachedPromise = cacheMap.get(cacheKey);
                if (cachedPromise) {
                    var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                    return new Promise(function(resolve) {
                        cacheHits.push(function() {
                            resolve(cachedPromise);
                        });
                    });
                }
            }
            batch.keys.push(key);
            var promise = new Promise(function(resolve, reject) {
                batch.callbacks.push({
                    resolve: resolve,
                    reject: reject
                });
            });
            if (cacheMap) cacheMap.set(cacheKey, promise);
            return promise;
        };
        _proto.loadMany = function loadMany(keys) {
            if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
            var loadPromises = [];
            for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
                return error;
            }));
            return Promise.all(loadPromises);
        };
        _proto.clear = function clear(key) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                cacheMap["delete"](cacheKey);
            }
            return this;
        };
        _proto.clearAll = function clearAll() {
            var cacheMap = this._cacheMap;
            if (cacheMap) cacheMap.clear();
            return this;
        };
        _proto.prime = function prime(key, value) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                if (cacheMap.get(cacheKey) === undefined) {
                    var promise;
                    if (value instanceof Error) {
                        promise = Promise.reject(value);
                        promise["catch"](function() {});
                    } else promise = Promise.resolve(value);
                    cacheMap.set(cacheKey, promise);
                }
            }
            return this;
        };
        return DataLoader;
    }();
    var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
        if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
        $c964119340a5ebe3$var$resolvedPromise.then(function() {
            $6cAn5.nextTick(fn);
        });
    } : typeof setImmediate === 'function' ? function(fn) {
        setImmediate(fn);
    } : function(fn) {
        setTimeout(fn);
    };
    var $c964119340a5ebe3$var$resolvedPromise;
    function $c964119340a5ebe3$var$getCurrentBatch(loader) {
        var existingBatch = loader._batch;
        if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
        var newBatch = {
            hasDispatched: false,
            keys: [],
            callbacks: []
        };
        loader._batch = newBatch;
        loader._batchScheduleFn(function() {
            $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
        });
        return newBatch;
    }
    function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
        batch.hasDispatched = true;
        if (batch.keys.length === 0) {
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            return;
        }
        var batchPromise;
        try {
            batchPromise = loader._batchLoadFn(batch.keys);
        } catch (e) {
            return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
        }
        if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
        batchPromise.then(function(values) {
            if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
            if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            for(var i = 0; i < batch.callbacks.length; i++){
                var value = values[i];
                if (value instanceof Error) batch.callbacks[i].reject(value);
                else batch.callbacks[i].resolve(value);
            }
        })["catch"](function(error) {
            $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
        });
    }
    function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        for(var i = 0; i < batch.keys.length; i++){
            loader.clear(batch.keys[i]);
            batch.callbacks[i].reject(error);
        }
    }
    function $c964119340a5ebe3$var$resolveCacheHits(batch) {
        if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
    }
    function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
        var shouldBatch = !options || options.batch !== false;
        if (!shouldBatch) return 1;
        var maxBatchSize = options && options.maxBatchSize;
        if (maxBatchSize === undefined) return Infinity;
        if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
        return maxBatchSize;
    }
    function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
        var batchScheduleFn = options && options.batchScheduleFn;
        if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
        if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
        return batchScheduleFn;
    }
    function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
        var cacheKeyFn = options && options.cacheKeyFn;
        if (cacheKeyFn === undefined) return function(key) {
            return key;
        };
        if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
        return cacheKeyFn;
    }
    function $c964119340a5ebe3$var$getValidCacheMap(options) {
        var shouldCache = !options || options.cache !== false;
        if (!shouldCache) return null;
        var cacheMap = options && options.cacheMap;
        if (cacheMap === undefined) return new Map();
        if (cacheMap !== null) {
            var cacheFunctions = [
                'get',
                'set',
                'delete',
                'clear'
            ];
            var missingFunctions = cacheFunctions.filter(function(fnName) {
                return cacheMap && typeof cacheMap[fnName] !== 'function';
            });
            if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
        }
        return cacheMap;
    }
    function $c964119340a5ebe3$var$getValidName(options) {
        if (options && options.name) return options.name;
        return null;
    }
    function $c964119340a5ebe3$var$isArrayLike(x) {
        return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
    }
    module.exports = $c964119340a5ebe3$var$DataLoader;
});
parcelRegister("hj8yn", function(module, exports) {
    var $iRstd = parcelRequire("iRstd");
    function $c99ad890679d3578$var$retry(fn, opts) {
        function run(resolve, reject) {
            var options = opts || {};
            if (!('randomize' in options)) options.randomize = true;
            var op = $iRstd.operation(options);
            function bail(err) {
                reject(err || new Error('Aborted'));
            }
            function onError(err, num) {
                if (err.bail) {
                    bail(err);
                    return;
                }
                if (!op.retry(err)) reject(op.mainError());
                else if (options.onRetry) options.onRetry(err, num);
            }
            function runAttempt(num) {
                var val;
                try {
                    val = fn(bail, num);
                } catch (err) {
                    onError(err, num);
                    return;
                }
                Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                    onError(err, num);
                });
            }
            op.attempt(runAttempt);
        }
        return new Promise(run);
    }
    module.exports = $c99ad890679d3578$var$retry;
});
parcelRegister("iRstd", function(module, exports) {
    module.exports = (parcelRequire("fqPwM"));
});
parcelRegister("fqPwM", function(module, exports) {
    var $fvybB = parcelRequire("fvybB");
    exports.operation = function(options) {
        var timeouts = exports.timeouts(options);
        return new $fvybB(timeouts, {
            forever: options && options.forever,
            unref: options && options.unref,
            maxRetryTime: options && options.maxRetryTime
        });
    };
    exports.timeouts = function(options) {
        if (options instanceof Array) return [].concat(options);
        var opts = {
            retries: 10,
            factor: 2,
            minTimeout: 1000,
            maxTimeout: Infinity,
            randomize: false
        };
        for(var key in options)opts[key] = options[key];
        if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
        var timeouts = [];
        for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
        if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
        timeouts.sort(function(a, b) {
            return a - b;
        });
        return timeouts;
    };
    exports.createTimeout = function(attempt, opts) {
        var random = opts.randomize ? Math.random() + 1 : 1;
        var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
        timeout = Math.min(timeout, opts.maxTimeout);
        return timeout;
    };
    exports.wrap = function(obj, options, methods) {
        if (options instanceof Array) {
            methods = options;
            options = null;
        }
        if (!methods) {
            methods = [];
            for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
        }
        for(var i = 0; i < methods.length; i++){
            var method = methods[i];
            var original = obj[method];
            obj[method] = (function retryWrapper(original) {
                var op = exports.operation(options);
                var args = Array.prototype.slice.call(arguments, 1);
                var callback = args.pop();
                args.push(function(err) {
                    if (op.retry(err)) return;
                    if (err) arguments[0] = op.mainError();
                    callback.apply(this, arguments);
                });
                op.attempt(function() {
                    original.apply(obj, args);
                });
            }).bind(obj, original);
            obj[method].options = options;
        }
    };
});
parcelRegister("fvybB", function(module, exports) {
    function $b4a444e76151e114$var$RetryOperation(timeouts, options) {
        if (typeof options === 'boolean') options = {
            forever: options
        };
        this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
        this._timeouts = timeouts;
        this._options = options || {};
        this._maxRetryTime = options && options.maxRetryTime || Infinity;
        this._fn = null;
        this._errors = [];
        this._attempts = 1;
        this._operationTimeout = null;
        this._operationTimeoutCb = null;
        this._timeout = null;
        this._operationStart = null;
        if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
    }
    module.exports = $b4a444e76151e114$var$RetryOperation;
    $b4a444e76151e114$var$RetryOperation.prototype.reset = function() {
        this._attempts = 1;
        this._timeouts = this._originalTimeouts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.stop = function() {
        if (this._timeout) clearTimeout(this._timeout);
        this._timeouts = [];
        this._cachedTimeouts = null;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.retry = function(err) {
        if (this._timeout) clearTimeout(this._timeout);
        if (!err) return false;
        var currentTime = new Date().getTime();
        if (err && currentTime - this._operationStart >= this._maxRetryTime) {
            this._errors.unshift(new Error('RetryOperation timeout occurred'));
            return false;
        }
        this._errors.push(err);
        var timeout = this._timeouts.shift();
        if (timeout === undefined) {
            if (this._cachedTimeouts) {
                this._errors.splice(this._errors.length - 1, this._errors.length);
                this._timeouts = this._cachedTimeouts.slice(0);
                timeout = this._timeouts.shift();
            } else return false;
        }
        var self = this;
        var timer = setTimeout(function() {
            self._attempts++;
            if (self._operationTimeoutCb) {
                self._timeout = setTimeout(function() {
                    self._operationTimeoutCb(self._attempts);
                }, self._operationTimeout);
                if (self._options.unref) self._timeout.unref();
            }
            self._fn(self._attempts);
        }, timeout);
        if (this._options.unref) timer.unref();
        return true;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
        this._fn = fn;
        if (timeoutOps) {
            if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
            if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
        }
        var self = this;
        if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
            self._operationTimeoutCb();
        }, self._operationTimeout);
        this._operationStart = new Date().getTime();
        this._fn(this._attempts);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.try = function(fn) {
        console.log('Using RetryOperation.try() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = function(fn) {
        console.log('Using RetryOperation.start() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = $b4a444e76151e114$var$RetryOperation.prototype.try;
    $b4a444e76151e114$var$RetryOperation.prototype.errors = function() {
        return this._errors;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempts = function() {
        return this._attempts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.mainError = function() {
        if (this._errors.length === 0) return null;
        var counts = {};
        var mainError = null;
        var mainErrorCount = 0;
        for(var i = 0; i < this._errors.length; i++){
            var error = this._errors[i];
            var message = error.message;
            var count = (counts[message] || 0) + 1;
            counts[message] = count;
            if (count >= mainErrorCount) {
                mainError = error;
                mainErrorCount = count;
            }
        }
        return mainError;
    };
});
parcelRegister("hLXaJ", function(module, exports) {
    'use strict';
    class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
        constructor(){
            super('Throttled function aborted');
            this.name = 'AbortError';
        }
    }
    const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
        if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
        if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
        const queue = new Map();
        let currentTick = 0;
        let activeCount = 0;
        function windowedDelay() {
            const now = Date.now();
            if (now - currentTick > interval) {
                activeCount = 1;
                currentTick = now;
                return 0;
            }
            if (activeCount < limit) activeCount++;
            else {
                currentTick += interval;
                activeCount = 1;
            }
            return currentTick - now;
        }
        const strictTicks = [];
        function strictDelay() {
            const now = Date.now();
            if (strictTicks.length < limit) {
                strictTicks.push(now);
                return 0;
            }
            const earliestTime = strictTicks.shift() + interval;
            if (now >= earliestTime) {
                strictTicks.push(now);
                return 0;
            }
            strictTicks.push(earliestTime);
            return earliestTime - now;
        }
        const getDelay = strict ? strictDelay : windowedDelay;
        return (function_)=>{
            const throttled = function(...args) {
                if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
                let timeout;
                return new Promise((resolve, reject)=>{
                    const execute = ()=>{
                        resolve(function_.apply(this, args));
                        queue.delete(timeout);
                    };
                    timeout = setTimeout(execute, getDelay());
                    queue.set(timeout, reject);
                });
            };
            throttled.abort = ()=>{
                for (const timeout of queue.keys()){
                    clearTimeout(timeout);
                    queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
                }
                queue.clear();
                strictTicks.splice(0, strictTicks.length);
            };
            throttled.isEnabled = true;
            return throttled;
        };
    };
    module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
    module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;
});
parcelRegister("kDZ6Z", function(module, exports) {
    $parcel$export(module.exports, "APIError", ()=>$8c263ecf028a2c14$export$3e5b797e39668f84);
    class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
        constructor(kind, hostname, message, type, extensionKey){
            super(`${kind}: ${message}`);
            this.kind = kind;
            this.hostname = hostname;
            this.message = message;
            this.type = type;
            this.extensionKey = extensionKey;
            this.name = 'APIError';
            this.type = type;
            this.kind = kind;
            this.message = message;
            this.hostname = hostname;
            this.extensionKey = extensionKey;
        }
    }
});
parcelRegister("itO4f", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$21a0efece812cd9a$export$f654b28f82155665);
    $parcel$export(module.exports, "getResolverUrl", ()=>$21a0efece812cd9a$export$dc37652c1696f231);
    const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
    const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
    const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
    const $21a0efece812cd9a$export$e2b040f052407032 = {
        dev: $21a0efece812cd9a$var$devBaseUrl,
        development: $21a0efece812cd9a$var$devBaseUrl,
        stg: $21a0efece812cd9a$var$stgBaseUrl,
        staging: $21a0efece812cd9a$var$stgBaseUrl,
        prd: $21a0efece812cd9a$var$prodBaseUrl,
        prod: $21a0efece812cd9a$var$prodBaseUrl,
        production: $21a0efece812cd9a$var$prodBaseUrl
    };
    const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
        if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
        return typeof window.location !== 'undefined' ? window.location.origin : '';
    };
    const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
        if (envKey || baseUrlOverride) {
            const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
            return `${baseUrl}/object-resolver`;
        } else return '/gateway/api/object-resolver';
    };
    var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;
});
parcelRegister("fiKQs", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$5c2f531cb20db568$export$b70265791d2079d4);
    const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
        const accessType = meta.requestAccess?.accessType;
        if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
        return 'forbidden';
    };
    const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
        const { access: access, visibility: visibility } = meta;
        switch(access){
            case 'forbidden':
                if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
                else return 'forbidden';
            case 'unauthorized':
                return 'unauthorized';
            default:
                return 'resolved';
        }
    };
});
parcelRegister("dV0Jy", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$5576d4e9d0a3858d$export$bae979e68e4dc802);
    $parcel$export(module.exports, "request", ()=>$5576d4e9d0a3858d$export$b5fe3f66a567bec0);
    const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
        200,
        401,
        404
    ];
    class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
        constructor(error){
            super(error);
        }
    }
    async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
        const requestConfig = {
            method: method,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
                ...headers
            },
            ...data ? {
                body: JSON.stringify(data)
            } : {}
        };
        try {
            const response = await fetch(url, requestConfig);
            if (response.ok || statuses?.includes(response.status)) {
                if (statuses.includes(204)) {
                    const text = await response.text();
                    return text ? JSON.parse(text) : undefined;
                } else return await response.json();
            }
            throw response;
        } catch (error) {
            if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
            throw error;
        }
    }
});
parcelRegister("4Bkrp", function(module, exports) {
    $parcel$export(module.exports, "isSuccessfulResponse", ()=>$1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
    $parcel$export(module.exports, "isErrorResponse", ()=>$1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
    const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
        if (!response) return false;
        const hasSuccessfulStatus = response.status === 200;
        const hasSuccessBody = 'body' in response;
        return hasSuccessfulStatus && hasSuccessBody;
    };
    const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
        if (!response) return false;
        const hasStatus = 'status' in response && response.status >= 200;
        const hasErrorBody = 'error' in response;
        return hasStatus && hasErrorBody;
    };
});
parcelRegister("iwKVT", function(module, exports) {
    !function(g, c) {
        c(module.exports);
    }(module.exports, function(g) {
        const c = Symbol("newer"), e = Symbol("older");
        class n {
            constructor(a, b){
                typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
            }
            _markEntryAsUsed(a) {
                if (a === this.newest) return;
                a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
            }
            assign(a) {
                let b, d = this.limit || Number.MAX_VALUE;
                this._keymap.clear();
                let m = a[Symbol.iterator]();
                for(let h = m.next(); !h.done; h = m.next()){
                    let f = new l(h.value[0], h.value[1]);
                    this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                    if (d-- == 0) throw new Error("overflow");
                }
                this.newest = b, this.size = this._keymap.size;
            }
            get(a) {
                var b = this._keymap.get(a);
                return b ? (this._markEntryAsUsed(b), b.value) : void 0;
            }
            set(a, b) {
                var d = this._keymap.get(a);
                return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
            }
            shift() {
                var a = this.oldest;
                if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                    a.key,
                    a.value
                ];
            }
            find(a) {
                let b = this._keymap.get(a);
                return b ? b.value : void 0;
            }
            has(a) {
                return this._keymap.has(a);
            }
            delete(a) {
                var b = this._keymap.get(a);
                return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
            }
            clear() {
                this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
            }
            keys() {
                return new j(this.oldest);
            }
            values() {
                return new k(this.oldest);
            }
            entries() {
                return this;
            }
            [Symbol.iterator]() {
                return new i(this.oldest);
            }
            forEach(a, b) {
                typeof b !== "object" && (b = this);
                let d = this.oldest;
                for(; d;)a.call(b, d.value, d.key, this), d = d[c];
            }
            toJSON() {
                for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                    key: d.key,
                    value: d.value
                }, d = d[c];
                return a;
            }
            toString() {
                for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
                return a;
            }
        }
        g.LRUMap = n;
        function l(a, b) {
            this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
        }
        function i(a) {
            this.entry = a;
        }
        i.prototype[Symbol.iterator] = function() {
            return this;
        }, i.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: [
                    a.key,
                    a.value
                ]
            }) : {
                done: !0,
                value: void 0
            };
        };
        function j(a) {
            this.entry = a;
        }
        j.prototype[Symbol.iterator] = function() {
            return this;
        }, j.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.key
            }) : {
                done: !0,
                value: void 0
            };
        };
        function k(a) {
            this.entry = a;
        }
        k.prototype[Symbol.iterator] = function() {
            return this;
        }, k.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.value
            }) : {
                done: !0,
                value: void 0
            };
        };
    });
});
parcelRegister("8dO33", function(module, exports) {
    $parcel$export(module.exports, "SmartCardProvider", ()=>$08b794feb02c83c1$export$497ecb0280204df4);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $cCcdH;
    var $k9B19;
    var $8b7fu;
    var $kECas;
    var $7cFR3;
    function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kECas")).SmartCardContext));
        const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
            return {};
        }, []);
        const { initialState: initialState } = storeOptions || {
            initialState: defaultInitialState
        };
        const store = (0, $5uXOq.useMemo)(()=>{
            return (0, $3f2cs.createStore)((0, (0, parcelRequire("8b7fu")).cardReducer), initialState);
        }, [
            initialState
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>{
            const client = customClient || new (0, (0, parcelRequire("7cFR3")).default)();
            if (product && client.setProduct) client.setProduct(product);
            const authFlow = customAuthFlow || 'oauth2';
            const getPreview = (url, platform)=>{
                const cardState = (0, (0, parcelRequire("cCcdH")).getUrl)(store, url);
                return cardState.details ? (0, (0, parcelRequire("k9B19")).extractPreview)(cardState.details.data, platform) : undefined;
            };
            return {
                renderers: renderers,
                store: store,
                prefetchStore: {},
                connections: {
                    client: client
                },
                config: {
                    authFlow: authFlow
                },
                extractors: {
                    getPreview: getPreview
                },
                featureFlags: featureFlags,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                product: product
            };
        }, [
            customClient,
            customAuthFlow,
            isAdminHubAIEnabled,
            product,
            renderers,
            featureFlags,
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kECas")).SmartCardContext).Provider, {
            value: parentContext || providerValue
        }, children);
    }
    var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;
});
parcelRegister("cCcdH", function(module, exports) {
    $parcel$export(module.exports, "getUrl", ()=>$ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
    const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
        return store.getState()[url] || {
            status: 'pending'
        };
    };
});
parcelRegister("k9B19", function(module, exports) {
    $parcel$export(module.exports, "extractPreview", ()=>$596309a7bcc79771$export$4b0d98b1b7f6d115);
    var $TFljV;
    var $7OmtM;
    const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
        const preview = jsonLd?.preview;
        const isSupported = (0, (0, parcelRequire("TFljV")).extractPlatformIsSupported)(preview, platform);
        if (preview && isSupported) {
            if (typeof preview === 'string') return {
                src: preview
            };
            else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                src: preview.interactiveHref,
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else if (preview['@type'] === 'Link') return {
                src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview),
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else {
                if (preview.url || preview.href) {
                    if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                        src: preview.interactiveHref,
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                    return {
                        src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview.url || preview.href),
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                } else if (preview.content) return {
                    content: preview.content
                };
            }
        }
    };
});
parcelRegister("TFljV", function(module, exports) {
    $parcel$export(module.exports, "extractPlatformIsSupported", ()=>$f8cdc1e628cbc347$export$3e8ad908070b68b2);
    const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
        if (preview) {
            if (typeof preview === 'string') return true;
            else {
                const supportedPlatforms = preview['atlassian:supportedPlatforms'];
                if (supportedPlatforms) {
                    const isWeb = platform === 'web';
                    return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
                }
                return true;
            }
        }
        return false;
    };
});
parcelRegister("7OmtM", function(module, exports) {
    $parcel$export(module.exports, "extractUrlFromLinkJsonLd", ()=>$0784379594099aa0$export$396ba4ef2e37dc65);
    const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
        if (typeof link === 'string') return link;
        else if (Array.isArray(link)) {
            if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
        } else return link.href;
    };
});
parcelRegister("8b7fu", function(module, exports) {
    $parcel$export(module.exports, "cardReducer", ()=>$92a815d7e26b35c0$export$3c7c3113a97b6492);
    var $2yPrN;
    var $fiKQs;
    const $92a815d7e26b35c0$var$isCardAction = (action)=>{
        return [
            (0, (0, parcelRequire("2yPrN")).ACTION_PENDING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED),
            (0, (0, parcelRequire("2yPrN")).ACTION_RELOADING),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK),
            (0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS)
        ].includes(action.type);
    };
    function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
        const nextDetails = payload;
        const nextState = {
            ...state
        };
        if (nextDetails) {
            nextState.status = (0, (0, parcelRequire("fiKQs")).getStatus)(nextDetails);
            nextState.details = nextDetails;
        } else nextState.status = type;
        return nextState;
    }
    function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
        switch(action.type){
            case 0, (0, parcelRequire("2yPrN")).ACTION_PENDING:
                return {
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING:
                return {
                    ...state,
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
            case 0, (0, parcelRequire("2yPrN")).ACTION_RELOADING:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR:
                return {
                    ...state,
                    status: action.type,
                    error: action.error
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK:
                return {
                    ...state,
                    status: action.type,
                    error: action.error,
                    details: action.payload
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS:
                return {
                    ...state,
                    metadataStatus: action.metadataStatus
                };
        }
    }
    const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
        if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
        const cardState = state[action.url];
        const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
        if (hasSameStatus) return state;
        else {
            const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
            return {
                ...state,
                [action.url]: nextState
            };
        }
    };
});
parcelRegister("2yPrN", function(module, exports) {
    $parcel$export(module.exports, "ACTION_PENDING", ()=>$23a1ee9f12bb755d$export$6e470aad5ba8952e);
    $parcel$export(module.exports, "ACTION_RESOLVING", ()=>$23a1ee9f12bb755d$export$9a6a932a0a39498e);
    $parcel$export(module.exports, "ACTION_RESOLVED", ()=>$23a1ee9f12bb755d$export$63ec8bc7a8a75482);
    $parcel$export(module.exports, "ACTION_RELOADING", ()=>$23a1ee9f12bb755d$export$b8cfaa842c9ab487);
    $parcel$export(module.exports, "ACTION_ERROR", ()=>$23a1ee9f12bb755d$export$6d8ed3f9433dd372);
    $parcel$export(module.exports, "ACTION_ERROR_FALLBACK", ()=>$23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
    $parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", ()=>$23a1ee9f12bb755d$export$2c5edb971b673330);
    $parcel$export(module.exports, "cardAction", ()=>$23a1ee9f12bb755d$export$a884a52152489cc3);
    const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
    const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
    const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
    const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
    const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
    const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
    const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
    const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
    const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
            type: type,
            url: url,
            payload: payload,
            error: error,
            metadataStatus: metadataStatus,
            ignoreStatusCheck: ignoreStatusCheck
        });
});
parcelRegister("kECas", function(module, exports) {
    $parcel$export(module.exports, "SmartCardContext", ()=>$b53b46c99cf8fc02$export$156b523e63b4f63a);
    $parcel$export(module.exports, "useSmartLinkContext", ()=>$b53b46c99cf8fc02$export$e1d190b530cf0ee9);
    var $5uXOq = parcelRequire("5uXOq");
    const $b53b46c99cf8fc02$export$156b523e63b4f63a = (0, $5uXOq.createContext)(undefined);
    function $b53b46c99cf8fc02$export$e1d190b530cf0ee9() {
        const context = (0, $5uXOq.useContext)($b53b46c99cf8fc02$export$156b523e63b4f63a);
        if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
        return context;
    }
    var $b53b46c99cf8fc02$export$2e2bcd8739ae039 = $b53b46c99cf8fc02$export$156b523e63b4f63a;
});
parcelRegister("hGiZz", function(module, exports) {
    $parcel$export(module.exports, "getDelta", ()=>$1422aee68340abe2$export$693f861392be013b);
    $parcel$export(module.exports, "useNativeScrollbarHeight", ()=>$1422aee68340abe2$export$14225e9ed50450f8);
    $parcel$export(module.exports, "useResizeObserver", ()=>$1422aee68340abe2$export$683480f191c0e3ea);
    var $5uXOq = parcelRequire("5uXOq");
    const $1422aee68340abe2$export$693f861392be013b = ({ deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey })=>{
        if (shiftKey && deltaY !== 0) return {
            deltaX: deltaY,
            deltaY: deltaX
        };
        return {
            deltaX: deltaX,
            deltaY: deltaY
        };
    };
    const $1422aee68340abe2$export$14225e9ed50450f8 = ()=>{
        const [result, setResult] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            const outerEl = document.createElement('div');
            const innerEl = document.createElement('div');
            Object.assign(outerEl.style, {
                overflowX: 'scroll',
                width: '50px'
            });
            Object.assign(innerEl.style, {
                width: '100px'
            });
            outerEl.appendChild(innerEl);
            document.body?.appendChild(outerEl);
            setResult(outerEl.offsetHeight - outerEl.clientHeight);
            document.body?.removeChild(outerEl);
        }, []);
        return result;
    };
    function $1422aee68340abe2$export$683480f191c0e3ea(elRef, callback) {
        (0, $5uXOq.useLayoutEffect)(()=>{
            const el = elRef.current;
            if (!el) return;
            callback(el);
            const observer = new ResizeObserver(()=>callback(el));
            observer.observe(el);
            return ()=>{
                observer.unobserve(el);
                observer.disconnect();
            };
        }, [
            callback,
            elRef
        ]);
    }
});
parcelRegister("nXNNJ", function(module, exports) {
    $parcel$export(module.exports, "isPollinatorTenant", ()=>$6d3456e2afa119b7$export$f59b7b56b5cada61);
    var $4R6GH;
    var $j8DrX;
    var $fdim1;
    const $6d3456e2afa119b7$export$f59b7b56b5cada61 = ()=>(0, (0, parcelRequire("fdim1")).getBooleanFeatureFlag)('jsw.pollinator.tenants') || (0, (0, parcelRequire("4R6GH")).fg)('is_synthetic_tenant') || (0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
});
parcelRegister("ks7qB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21c94c9010d5352a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $hE4fC;
    const $21c94c9010d5352a$var$HorizontalScrollbarOverlay = ()=>{
        const [{ isScrollingWithScrollBar: isScrollingWithScrollBar }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        if (!isScrollingWithScrollBar) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-horizontal-scrolling.ui.scroll-bar-overlay.scrollbar-overlay"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $21c94c9010d5352a$var$scrollbarOverlayStyles,
            style: {
                zIndex: 'var(--jpo-z-index-horizontal-scrolling-overlay)'
            }
        }));
    };
    var $21c94c9010d5352a$export$2e2bcd8739ae039 = $21c94c9010d5352a$var$HorizontalScrollbarOverlay;
    const $21c94c9010d5352a$var$scrollbarOverlayStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        left: 'space.0',
        right: 'space.0',
        top: 'space.0',
        bottom: 'space.100'
    });
});
parcelRegister("igD1g", function(module, exports) {
    $parcel$export(module.exports, "useCttOnboardingTour", ()=>$7de0b35dce2718f8$export$b78e1ee36b9243d8);
    $parcel$export(module.exports, "useCttSpotlight", ()=>$7de0b35dce2718f8$export$aa62f0dd18431aa7);
    $parcel$export(module.exports, "CttOnboardingProvider", ()=>$7de0b35dce2718f8$export$1de71d05d686e991);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $8HXlE;
    var $4HHzZ;
    var $14ZtX;
    const $7de0b35dce2718f8$var$initialState = {
        _rehydrated: false
    };
    const $7de0b35dce2718f8$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $7de0b35dce2718f8$var$initialState,
        actions: (0, parcelRequire("8HXlE")).actions,
        name: 'portfolio-3/ctt-onboarding'
    });
    const $7de0b35dce2718f8$export$783184fef467e477 = (0, (0, parcelRequire("3sQ5x")).createHook)($7de0b35dce2718f8$var$store, {
        selector: (state)=>state._rehydrated
    });
    const $7de0b35dce2718f8$export$b78e1ee36b9243d8 = (0, (0, parcelRequire("3sQ5x")).createHook)($7de0b35dce2718f8$var$store, {
        selector: (0, (0, parcelRequire("4HHzZ")).selectCttOnboardingTour)
    });
    const $7de0b35dce2718f8$export$aa62f0dd18431aa7 = (0, (0, parcelRequire("3sQ5x")).createHook)($7de0b35dce2718f8$var$store, {
        selector: (0, (0, parcelRequire("4HHzZ")).selectCttSpotlight)
    });
    const $7de0b35dce2718f8$export$1de71d05d686e991 = (0, (0, parcelRequire("gg7kZ")).createContainer)($7de0b35dce2718f8$var$store, {
        onInit: ()=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
                if (getState()._rehydratePromise === undefined) {
                    const promise = dispatch((0, (0, parcelRequire("14ZtX")).rehydrate));
                    setState({
                        _rehydratePromise: promise
                    });
                    await promise;
                }
            }
    });
});
parcelRegister("8HXlE", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$16e9607747d53da2$export$e324594224ef24da);
    var $cgKl3;
    var $14ZtX;
    const $16e9607747d53da2$var$cttOnboardingActions = {
        initCttOnboarding: (planId)=>async ({ getState: getState, setState: setState })=>{
                await getState()._rehydratePromise;
                const { cttOnboarding: cttOnboarding } = getState();
                if (planId === null) return;
                if (!cttOnboarding) {
                    setState({
                        cttOnboarding: {
                            stage: (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CREATE_INITATIVE,
                            planId: planId
                        }
                    });
                    return;
                }
                if (cttOnboarding.planId !== planId && cttOnboarding.stage !== (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CLOSED && cttOnboarding.stage !== (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).FINISH_FLAG) setState({
                    cttOnboarding: {
                        stage: (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CREATE_INITATIVE,
                        planId: planId
                    }
                });
            },
        setCttTakingTour: ()=>({ setState: setState, getState: getState })=>{
                const { cttOnboarding: currentCttOnboarding } = getState();
                if (!currentCttOnboarding) return;
                setState({
                    cttOnboarding: {
                        ...currentCttOnboarding
                    },
                    isTakingOnboardingTour: true
                });
            },
        resetCttTakingTour: ()=>({ setState: setState })=>{
                setState({
                    isTakingOnboardingTour: false
                });
            },
        nextCttStage: (skipTo)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
                const assertUnreachable = (_)=>{
                    throw new Error("Didn't expect to get here");
                };
                const { cttOnboarding: cttOnboarding } = getState();
                if (!cttOnboarding) return;
                const { planId: planId, stage: stage } = cttOnboarding;
                const updateStage = (updateStage, persist = true, ui = true)=>{
                    dispatch((0, (0, parcelRequire("14ZtX")).update)({
                        ui: ui,
                        persist: persist
                    })({
                        cttOnboarding: {
                            stage: updateStage,
                            planId: planId
                        }
                    }));
                };
                if (skipTo) {
                    Object.values((0, (0, parcelRequire("cgKl3")).CttOnboardingStage)).includes(skipTo) && updateStage(skipTo, true);
                    return;
                }
                try {
                    switch(stage){
                        case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CREATE_INITATIVE:
                            updateStage((0, (0, parcelRequire("cgKl3")).CttOnboardingStage).INPUT_TITLE, false);
                            break;
                        case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).INPUT_TITLE:
                            updateStage((0, (0, parcelRequire("cgKl3")).CttOnboardingStage).NAVIGATE_ISSUE_SOURCES, false);
                            break;
                        case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).NAVIGATE_ISSUE_SOURCES:
                            updateStage((0, (0, parcelRequire("cgKl3")).CttOnboardingStage).SHOW_ISSUE_SOURCES, true);
                            break;
                        case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).SHOW_ISSUE_SOURCES:
                            updateStage((0, (0, parcelRequire("cgKl3")).CttOnboardingStage).NAVIGATE_PLAN, false);
                            break;
                        case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).NAVIGATE_PLAN:
                            updateStage((0, (0, parcelRequire("cgKl3")).CttOnboardingStage).EPIC_REPARENT, true);
                            break;
                        case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).EPIC_REPARENT:
                            updateStage((0, (0, parcelRequire("cgKl3")).CttOnboardingStage).INPUT_EPIC_REPARENT, false);
                            break;
                        case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).INPUT_EPIC_REPARENT:
                            updateStage((0, (0, parcelRequire("cgKl3")).CttOnboardingStage).REVIEW_CHANGES, true);
                            break;
                        case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).REVIEW_CHANGES:
                            updateStage((0, (0, parcelRequire("cgKl3")).CttOnboardingStage).FINISH_FLAG, true);
                            updateStage((0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CLOSED, true, false);
                            break;
                        case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).FINISH_FLAG:
                            updateStage((0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CLOSED, true);
                            break;
                        case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CLOSED:
                            break;
                        default:
                            assertUnreachable(stage);
                    }
                } catch (e) {
                    setState({
                        cttOnboarding: {
                            ...cttOnboarding,
                            stage: (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CLOSED
                        }
                    });
                }
            },
        closeCttOnboarding: ({ silent: silent } = {
            silent: true
        })=>({ getState: getState, dispatch: dispatch })=>{
                const planId = getState().cttOnboarding?.planId || -1;
                dispatch((0, (0, parcelRequire("14ZtX")).update)({
                    ui: !silent,
                    persist: true
                })({
                    cttOnboarding: {
                        stage: (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CLOSED,
                        planId: planId
                    },
                    isTakingOnboardingTour: false
                }));
            },
        setSpotlight: (spotlight)=>({ getState: getState, dispatch: dispatch })=>{
                const { cttOnboarding: currentCttOnboarding } = getState();
                if (!currentCttOnboarding) return;
                dispatch((0, (0, parcelRequire("14ZtX")).update)({
                    ui: true,
                    persist: false
                })({
                    spotlight: spotlight
                }));
            },
        resetSpotlight: ()=>({ getState: getState, dispatch: dispatch })=>{
                const { cttOnboarding: currentCttOnboarding } = getState();
                if (!currentCttOnboarding) return;
                dispatch((0, (0, parcelRequire("14ZtX")).update)({
                    ui: true,
                    persist: false
                })({
                    spotlight: undefined
                }));
            }
    };
    const $16e9607747d53da2$export$e324594224ef24da = {
        ...$16e9607747d53da2$var$cttOnboardingActions
    };
});
parcelRegister("cgKl3", function(module, exports) {
    $parcel$export(module.exports, "CttOnboardingStage", ()=>$93bf53fbc3bcb72c$export$883197f7727aad4b);
    $parcel$export(module.exports, "CttOnboardingVariant", ()=>$93bf53fbc3bcb72c$export$394887c171dcc249);
    const $93bf53fbc3bcb72c$export$883197f7727aad4b = {
        CREATE_INITATIVE: 'CREATE_INITATIVE',
        INPUT_TITLE: 'INPUT_TITLE',
        NAVIGATE_ISSUE_SOURCES: 'NAVIGATE_ISSUE_SOURCES',
        SHOW_ISSUE_SOURCES: 'SHOW_ISSUE_SOURCES',
        NAVIGATE_PLAN: 'NAVIGATE_PLAN',
        EPIC_REPARENT: 'EPIC_REPARENT',
        INPUT_EPIC_REPARENT: 'INPUT_EPIC_REPARENT',
        REVIEW_CHANGES: 'REVIEW_CHANGES',
        FINISH_FLAG: 'FINISH_FLAG',
        CLOSED: 'CLOSED'
    };
    const $93bf53fbc3bcb72c$export$394887c171dcc249 = {
        TMP_EPIC: 'TMP_EPIC',
        NO_EPIC: 'NO_EPIC',
        EPIC: 'EPIC',
        NO_INITIATIVE: 'NO_INITIATIVE'
    };
});
parcelRegister("14ZtX", function(module, exports) {
    $parcel$export(module.exports, "rehydrate", ()=>$801c419eb0058a4e$export$27af23fc693b4501);
    $parcel$export(module.exports, "update", ()=>$801c419eb0058a4e$export$722fbec263ad908a);
    var $hjAWb = parcelRequire("hjAWb");
    var $aDvGo;
    var $eusud;
    var $cgKl3;
    const $801c419eb0058a4e$var$PERSIST_KEY = 'jira.user.arj.ctt-onboarding';
    const $801c419eb0058a4e$var$getCttOnboardingUserProperties = async (accountId)=>{
        const fetchResponse = await fetch(`/rest/api/3/user/properties/${$801c419eb0058a4e$var$PERSIST_KEY}?accountId=${accountId}`, (0, (0, parcelRequire("aDvGo")).default));
        if (fetchResponse.ok) {
            const responseObj = await fetchResponse.json();
            return responseObj.value;
        }
        const { status: status } = fetchResponse;
        if (status === 404) return undefined;
        throw new Error(`Fetching ${$801c419eb0058a4e$var$PERSIST_KEY} user property failed. Status code: ${fetchResponse.status}`);
    };
    const $801c419eb0058a4e$export$27af23fc693b4501 = async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
        if (getState()._rehydrated) return;
        let raw = {};
        const response = await $801c419eb0058a4e$var$getCttOnboardingUserProperties(accountId);
        if (response) raw = response;
        else raw = {};
        const cttOnboarding = (()=>{
            const stage = raw.cttOnboarding?.stage;
            if (stage && Object.values((0, (0, parcelRequire("cgKl3")).CttOnboardingStage)).includes(stage)) return {
                stage: stage,
                planId: raw.cttOnboarding?.planId
            };
            return undefined;
        })();
        setState({
            _rehydrated: true,
            cttOnboarding: cttOnboarding
        });
    };
    const $801c419eb0058a4e$export$9a6132153fba2e0 = (update)=>async ({ getState: getState }, { accountId: accountId })=>{
            const serialize = (0, ($parcel$interopDefault($hjAWb)))([
                'cttOnboarding'
            ]);
            await (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/user/properties/${$801c419eb0058a4e$var$PERSIST_KEY}?accountId=${accountId}`, {
                body: JSON.stringify(serialize({
                    ...getState(),
                    ...update
                }))
            });
        };
    const $801c419eb0058a4e$export$722fbec263ad908a = (options = {
        ui: true,
        persist: true
    })=>(partial)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
                const { _rehydrated: _rehydrated, _rehydratePromise: _rehydratePromise } = getState();
                if (!_rehydrated) await _rehydratePromise;
                if (options.ui) setState(partial);
                if (options.persist) dispatch($801c419eb0058a4e$export$9a6132153fba2e0({
                    ...getState(),
                    ...partial
                }));
            };
});
parcelRegister("hjAWb", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $c9b0dcffc2009ee0$var$func = $lVx1a('pick', (parcelRequire("3NMrl")));
    $c9b0dcffc2009ee0$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $c9b0dcffc2009ee0$var$func;
});
parcelRegister("4HHzZ", function(module, exports) {
    $parcel$export(module.exports, "selectCttOnboardingTour", ()=>$df363aa8383b6376$export$7aab0ca2606d6c15);
    $parcel$export(module.exports, "selectCttSpotlight", ()=>$df363aa8383b6376$export$27269b971d238c07);
    var $cgKl3;
    const $df363aa8383b6376$var$assertUnreachable = (_)=>{
        throw new Error("Didn't expect to get here");
    };
    const $df363aa8383b6376$export$7aab0ca2606d6c15 = ({ cttOnboarding: cttOnboarding, isTakingOnboardingTour: isTakingOnboardingTour })=>{
        const getVisibility = ()=>{
            if (!cttOnboarding) return false;
            try {
                switch(cttOnboarding.stage){
                    case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CREATE_INITATIVE:
                    case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).NAVIGATE_ISSUE_SOURCES:
                    case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).SHOW_ISSUE_SOURCES:
                    case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).FINISH_FLAG:
                    case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).NAVIGATE_PLAN:
                    case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).EPIC_REPARENT:
                    case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).REVIEW_CHANGES:
                        return true;
                    case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).INPUT_TITLE:
                    case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).INPUT_EPIC_REPARENT:
                    case (0, (0, parcelRequire("cgKl3")).CttOnboardingStage).CLOSED:
                        return false;
                    default:
                        $df363aa8383b6376$var$assertUnreachable(cttOnboarding.stage);
                        return false;
                }
            } catch (e) {
                return false;
            }
        };
        return {
            stage: cttOnboarding?.stage,
            planId: cttOnboarding?.planId,
            visible: getVisibility(),
            isTakingOnboardingTour: isTakingOnboardingTour ?? false
        };
    };
    const $df363aa8383b6376$export$27269b971d238c07 = ({ spotlight: spotlight })=>spotlight;
});
parcelRegister("g295Q", function(module, exports) {
    $parcel$export(module.exports, "CttSpotlights", ()=>$f81f0ad0752c64b1$export$d87db548b153c65d);
    const $f81f0ad0752c64b1$export$d87db548b153c65d = {
        Inactive: 'INACTIVE',
        CreateIssue: 'portfolio-3/ctt-onboarding/create-issue',
        TitleInput: 'portfolio-3/ctt-onboarding/title-input',
        Settings: 'portfolio-3/ctt-onboarding/settings',
        IssueSources: 'portfolio-3/ctt-onboarding/issue-source',
        BackToPlan: 'portfolio-3/ctt-onboarding/back-to-plan',
        EpicSection: 'portfolio-3/ctt-onboarding/epic-section',
        Scope: 'portfolio-3/ctt-onboarding/scope',
        ReviewChanges: 'portfolio-3/ctt-onboarding/review-changes'
    };
});
parcelRegister("aPRoZ", function(module, exports) {
    $parcel$export(module.exports, "Spotlights", ()=>$ffac7af5fe45e020$export$c7b90ff96148d0e3);
    $parcel$export(module.exports, "useCurrentSpotlightOld", ()=>$ffac7af5fe45e020$export$28754d85fe333691);
    $parcel$export(module.exports, "useCurrentSpotlight", ()=>$ffac7af5fe45e020$export$26b0bb53036d8513);
    $parcel$export(module.exports, "OnboardingHeaderModeUpdater", ()=>$ffac7af5fe45e020$export$e9f9953833722cbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $3HwlS;
    var $3sQ5x;
    var $iXqE5;
    const $ffac7af5fe45e020$export$c7b90ff96148d0e3 = {
        Inactive: 'INACTIVE',
        Views: 'portfolio-3/onboarding/views',
        HeartOfPlan: 'portfolio-3/onboarding/heart-of-plan',
        ShowAndTell: 'portfolio-3/onboarding/show-and-tell',
        ListMode: 'portfolio-3/onboarding/list-mode',
        FindYourLook: 'portfolio-3/onboarding/find-your-look',
        SaveYourChanges: 'portfolio-3/onboarding/save-your-changes'
    };
    const $ffac7af5fe45e020$var$SpotlightStepsOld = [
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.Inactive,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.Views,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.HeartOfPlan,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.ShowAndTell,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.ListMode,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.FindYourLook,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.SaveYourChanges
    ];
    const $ffac7af5fe45e020$var$SpotlightSteps = [
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.Inactive,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.Views,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.ShowAndTell,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.ListMode,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.FindYourLook,
        $ffac7af5fe45e020$export$c7b90ff96148d0e3.SaveYourChanges
    ];
    const $ffac7af5fe45e020$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            current: 0
        },
        actions: {
            reset: ()=>({ setState: setState })=>setState({
                        current: 0
                    }),
            start: ()=>({ setState: setState })=>{
                    setState({
                        current: 1
                    });
                },
            next: ()=>({ getState: getState, setState: setState })=>{
                    setState({
                        current: getState().current + 1
                    });
                }
        },
        name: 'portfolio-3/onboarding/spotlights'
    });
    const $ffac7af5fe45e020$export$28754d85fe333691 = ()=>(0, (0, parcelRequire("3sQ5x")).createHook)($ffac7af5fe45e020$var$store, {
            selector: ({ current: current })=>{
                const totalStepCount = $ffac7af5fe45e020$var$SpotlightStepsOld.length - 1;
                return {
                    spotlight: $ffac7af5fe45e020$var$SpotlightStepsOld[current],
                    currentStepCount: current,
                    totalStepCount: totalStepCount
                };
            }
        })();
    const $ffac7af5fe45e020$export$26b0bb53036d8513 = ()=>(0, (0, parcelRequire("3sQ5x")).createHook)($ffac7af5fe45e020$var$store, {
            selector: ({ current: current })=>{
                const totalStepCount = $ffac7af5fe45e020$var$SpotlightSteps.length - 1;
                return {
                    spotlight: $ffac7af5fe45e020$var$SpotlightSteps[current],
                    currentStepCount: current,
                    totalStepCount: totalStepCount
                };
            }
        })();
    const $ffac7af5fe45e020$export$d52beefead77af4c = (0, (0, parcelRequire("3sQ5x")).createHook)($ffac7af5fe45e020$var$store, {
        selector: null
    });
    const $ffac7af5fe45e020$export$e9f9953833722cbb = ({ headerMode: headerMode, setHeaderMode: setHeaderMode })=>{
        const [{ spotlight: spotlight }] = $ffac7af5fe45e020$export$28754d85fe333691();
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
                if (headerMode !== 'visible' && spotlight === $ffac7af5fe45e020$export$c7b90ff96148d0e3.HeartOfPlan) setHeaderMode('visible');
            }
        }, [
            spotlight,
            headerMode,
            setHeaderMode
        ]);
        return null;
    };
});
parcelRegister("dUk9j", function(module, exports) {
    $parcel$export(module.exports, "SpotlightTarget", ()=>$0033ead13d224938$export$e29577842f211e22);
    $parcel$export(module.exports, "EpicLevelSpotlightTarget", ()=>$0033ead13d224938$export$27903a60ba199e9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Fk4Z;
    var $c12LJ;
    var $g295Q;
    const $0033ead13d224938$export$e29577842f211e22 = ({ children: children, delayOn: delayOn, name: name })=>{
        const [withSpotlight, setWithSpotlight] = (0, $5uXOq.useState)(true);
        (0, $5uXOq.useEffect)(()=>{
            if (delayOn === undefined) return;
            setWithSpotlight(false);
            setTimeout(()=>setWithSpotlight(true), 1000);
        }, [
            delayOn
        ]);
        return withSpotlight ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: name
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $0033ead13d224938$export$27903a60ba199e9f = (children, isGroupByNone, level)=>level === (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL) && isGroupByNone ? (0, ($parcel$interopDefault($5uXOq))).createElement($0033ead13d224938$export$e29577842f211e22, {
            delayOn: true,
            name: (0, (0, parcelRequire("g295Q")).CttSpotlights).EpicSection,
            key: (0, (0, parcelRequire("g295Q")).CttSpotlights).EpicSection
        }, children) : children;
});
parcelRegister("db0fs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc10505306297ef$export$2e2bcd8739ae039);
    var $3YtPS = parcelRequire("3YtPS");
    var $bC2fB;
    var $gQ7rz = parcelRequire("gQ7rz");
    var $1EBsK = parcelRequire("1EBsK");
    const $7cc10505306297ef$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        errors: (0, $gQ7rz.getErrors)
    });
    var $7cc10505306297ef$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($7cc10505306297ef$var$mapStateToProps, {})((0, $1EBsK.default));
});
parcelRegister("gQ7rz", function(module, exports) {
    $parcel$export(module.exports, "getErrors", ()=>$1a207569b1948ba7$export$501239432719417d);
    $parcel$export(module.exports, "getErrorLogDialogState", ()=>$1a207569b1948ba7$export$197d5b7cd31faba3);
    $parcel$export(module.exports, "getIsProjectLimitExceeded", ()=>$1a207569b1948ba7$export$6b889b3c17f5cdcd);
    const $1a207569b1948ba7$export$501239432719417d = (state)=>state.ui.Errors.errors;
    const $1a207569b1948ba7$export$197d5b7cd31faba3 = (state)=>state.ui.Errors.isErrorLogDialogOpen;
    const $1a207569b1948ba7$export$6b889b3c17f5cdcd = (state)=>state.ui.Errors.isProjectLimitExceeded;
});
parcelRegister("1EBsK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35919f17526d3b52$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g0Gtc;
    var $y9aeT = parcelRequire("y9aeT");
    var $9Hqt9 = parcelRequire("9Hqt9");
    var $35919f17526d3b52$export$2e2bcd8739ae039 = ({ errors: errors, location: location, locationType: locationType, locationPrefix: locationPrefix })=>{
        const basePath = (0, $9Hqt9.default)();
        const relevantErrors = errors.filter((error)=>{
            if (locationPrefix === undefined) return true;
            switch(locationType){
                case 'hash':
                    return error.locationHash?.startsWith(locationPrefix);
                case 'path':
                    return error.locationPath?.startsWith(`${basePath}/${locationPrefix}`);
                default:
                    return true;
            }
        });
        if (relevantErrors.length === 0) return null;
        const failureEventAttributes = relevantErrors.every((0, $y9aeT.isEnvironmentError)) ? {
            errorType: 'networkError'
        } : null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0Gtc")).ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: failureEventAttributes
        });
    };
});
parcelRegister("9Hqt9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca68a44bfa6918ff$export$2e2bcd8739ae039);
    var $9VXkC;
    var $doZTA;
    const $ca68a44bfa6918ff$var$useBasePath = ()=>{
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { planId: planId, scenarioId: scenarioId } = match.params;
        if (!planId) return '/jira/plans';
        if (!scenarioId) return (0, (0, parcelRequire("9VXkC")).generatePath)('/jira/plans/:planId', {
            planId: planId
        });
        return (0, (0, parcelRequire("9VXkC")).generatePath)('/jira/plans/:planId/scenarios/:scenarioId', {
            planId: planId,
            scenarioId: scenarioId
        });
    };
    var $ca68a44bfa6918ff$export$2e2bcd8739ae039 = $ca68a44bfa6918ff$var$useBasePath;
});
parcelRegister("fkq9X", function(module, exports) {
    $parcel$export(module.exports, "ZIndexProviderOld", ()=>$031991a41b8bf240$export$351e15fac137d964);
    $parcel$export(module.exports, "ZIndexProvider", ()=>$031991a41b8bf240$export$b2c68a9be9405621);
    var $bC2fB;
    var $6il9S = parcelRequire("6il9S");
    var $9MOwz = parcelRequire("9MOwz");
    var $eHJCm = parcelRequire("eHJCm");
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    const $031991a41b8bf240$export$351e15fac137d964 = (0, (0, parcelRequire("bC2fB")).connect)((0, $9MOwz.mapStateToProps), {})((0, $eHJCm.ZIndexProvider));
    const $031991a41b8bf240$export$b2c68a9be9405621 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6il9S.mapStateToProps), {})((0, $eHJCm.ZIndexProvider));
});
parcelRegister("6il9S", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$a73b5cda7a635edb$export$c31df4bd766f9c35);
    var $3J2mc;
    var $6L8iB = parcelRequire("6L8iB");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $6hYE8 = parcelRequire("6hYE8");
    const $a73b5cda7a635edb$export$a3141f11a33b8412 = (0, $3YtPS.createSelector)([
        (0, $6L8iB.getColumnConfigs)
    ], (columns)=>columns.length);
    const $a73b5cda7a635edb$var$STATIC_LEVEL_SIZE = 4;
    const $a73b5cda7a635edb$var$BUFFER_SIZE = 1;
    const $a73b5cda7a635edb$export$a381c346af83af6b = (numOfColumns, viewMode)=>{
        const Z_INDEX_LEVEL = (0, $6hYE8.Z_INDEX_LEVEL_OLD);
        const lift = (level)=>(input)=>{
                const levelSize = numOfColumns + $a73b5cda7a635edb$var$BUFFER_SIZE * 2;
                const levelsBelow = level * levelSize;
                const offset = input + $a73b5cda7a635edb$var$BUFFER_SIZE;
                return offset + levelsBelow + $a73b5cda7a635edb$var$STATIC_LEVEL_SIZE;
            };
        return (props)=>{
            if ('layer' in props) switch(props.layer){
                case (0, $6hYE8.Z_INDEX_LAYER).DEPENDENCY_LINES:
                    return 1;
                case (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS:
                    return 2;
                case (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS_ARROWS:
                    return 3;
                case (0, $6hYE8.Z_INDEX_LAYER).AXIS_STICKY_TIME_UNIT:
                    return lift(Z_INDEX_LEVEL.HEADER)(1);
                case (0, $6hYE8.Z_INDEX_LAYER).STICKY_HEADER_SCROLL_SHADOW:
                case (0, $6hYE8.Z_INDEX_LAYER).HORIZONTAL_SCROLL_BAR:
                case (0, $6hYE8.Z_INDEX_LAYER).DEPENDENCY_LINE_DRAG_PREVIEW:
                    return lift(Z_INDEX_LEVEL.SUBHEADER)(-1);
                case (0, $6hYE8.Z_INDEX_LAYER).EMPTY_LIST_OVERLAY:
                    return lift(Z_INDEX_LEVEL.SUBHEADER)(-1);
                case (0, $6hYE8.Z_INDEX_LAYER).STICKY_GROUP_SCROLL_SHADOW:
                    return lift(Z_INDEX_LEVEL.STICKY)(-1);
                default:
                    return 0;
            }
            if ('rowType' in props) {
                const { column: column, rowType: rowType, level: level } = props;
                const isTimelineColumn = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE && column === numOfColumns - 1;
                const reversedColumnIndex = numOfColumns - 1 - column;
                if (column === 0) {
                    if (rowType === 'header') return lift(Z_INDEX_LEVEL.HEADER)(reversedColumnIndex);
                    if (rowType === 'subheader') return lift(Z_INDEX_LEVEL.SUBHEADER)(reversedColumnIndex);
                    if (rowType === 'group') return lift(Z_INDEX_LEVEL.STICKY)(reversedColumnIndex);
                    return lift(Z_INDEX_LEVEL.DEFAULT)(reversedColumnIndex);
                }
                if (rowType === 'header') return lift(Z_INDEX_LEVEL.HEADER)(reversedColumnIndex);
                if (rowType === 'subheader') return lift(Z_INDEX_LEVEL.SUBHEADER)(reversedColumnIndex);
                if (rowType === 'group') return lift(Z_INDEX_LEVEL.STICKY)(reversedColumnIndex);
                if (isTimelineColumn) return undefined;
                return lift(level ?? Z_INDEX_LEVEL.DEFAULT)(reversedColumnIndex);
            }
            return 0;
        };
    };
    const $a73b5cda7a635edb$export$9b544f58430fc883 = (0, $3YtPS.createSelector)([
        $a73b5cda7a635edb$export$a3141f11a33b8412,
        (0, $kWDpn.getViewMode)
    ], $a73b5cda7a635edb$export$a381c346af83af6b);
    const $a73b5cda7a635edb$export$c31df4bd766f9c35 = (0, $3YtPS.createSelector)([
        $a73b5cda7a635edb$export$9b544f58430fc883
    ], (zIndex)=>({
            zIndex: zIndex
        }));
});
parcelRegister("9MOwz", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$7c5e2d2e1b78c09e$export$c31df4bd766f9c35);
    var $4R6GH;
    var $32bya;
    var $3J2mc;
    var $6L8iB = parcelRequire("6L8iB");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $6hYE8 = parcelRequire("6hYE8");
    const $7c5e2d2e1b78c09e$export$b3b4bb28e7752964 = (0, $3YtPS.createSelector)([
        (0, $6L8iB.getRowConfigs)
    ], (rows)=>rows.length);
    const $7c5e2d2e1b78c09e$export$a3141f11a33b8412 = (0, $3YtPS.createSelector)([
        (0, $6L8iB.getColumnConfigs)
    ], (columns)=>columns.length);
    const $7c5e2d2e1b78c09e$var$STATIC_LEVEL_SIZE = 4;
    const $7c5e2d2e1b78c09e$var$BUFFER_SIZE = 1;
    const $7c5e2d2e1b78c09e$export$a381c346af83af6b = (numOfColumns, numOfRows, rowSticky, viewMode)=>{
        const Z_INDEX_LEVEL = (0, $6hYE8.Z_INDEX_LEVEL);
        const lift = (level)=>(input)=>{
                const levelSize = numOfColumns + $7c5e2d2e1b78c09e$var$BUFFER_SIZE * 2;
                const levelsBelow = level * levelSize;
                const offset = input + $7c5e2d2e1b78c09e$var$BUFFER_SIZE;
                return offset + levelsBelow + $7c5e2d2e1b78c09e$var$STATIC_LEVEL_SIZE;
            };
        return (props)=>{
            if ('layer' in props) switch(props.layer){
                case (0, $6hYE8.Z_INDEX_LAYER).DEPENDENCY_LINES:
                    return 1;
                case (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS:
                    return 2;
                case (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS_ARROWS:
                    return 3;
                case (0, $6hYE8.Z_INDEX_LAYER).AXIS_STICKY_TIME_UNIT:
                    return lift(Z_INDEX_LEVEL.HEADER)(1);
                case (0, $6hYE8.Z_INDEX_LAYER).STICKY_HEADER_SCROLL_SHADOW:
                    return lift(Z_INDEX_LEVEL.SCOPE_SUBHEADER)(-1);
                case (0, $6hYE8.Z_INDEX_LAYER).HORIZONTAL_SCROLL_BAR:
                case (0, $6hYE8.Z_INDEX_LAYER).DEPENDENCY_LINE_DRAG_PREVIEW:
                    return lift(Z_INDEX_LEVEL.SUBHEADER)(-1);
                case (0, $6hYE8.Z_INDEX_LAYER).EMPTY_LIST_OVERLAY:
                    return lift(Z_INDEX_LEVEL.SUBHEADER)(-1);
                case (0, $6hYE8.Z_INDEX_LAYER).STICKY_GROUP_SCROLL_SHADOW:
                    return lift(Z_INDEX_LEVEL.SCOPE_STICKY)(-1);
                default:
                    return 0;
            }
            if ('row' in props) {
                const { column: column, row: row, level: level } = props;
                const isTimelineColumn = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE && column === numOfColumns - 1;
                const reversedColumnIndex = numOfColumns - 1 - column;
                if (column === 0) {
                    if (row === 0) return lift(Z_INDEX_LEVEL.SCOPE_HEADER)(reversedColumnIndex);
                    if (row === 1) return lift(Z_INDEX_LEVEL.SCOPE_SUBHEADER)(reversedColumnIndex);
                    if (rowSticky[row]) return lift(Z_INDEX_LEVEL.SCOPE_STICKY)(reversedColumnIndex);
                    return lift(Z_INDEX_LEVEL.SCOPE)(reversedColumnIndex);
                }
                if (row === 0) return lift(Z_INDEX_LEVEL.HEADER)(reversedColumnIndex);
                if (row === 1) return lift(Z_INDEX_LEVEL.SUBHEADER)(reversedColumnIndex);
                if (rowSticky[row]) return lift(Z_INDEX_LEVEL.STICKY)(reversedColumnIndex);
                if (isTimelineColumn) return undefined;
                return lift(level ?? Z_INDEX_LEVEL.DEFAULT)(reversedColumnIndex);
            }
            return 0;
        };
    };
    const $7c5e2d2e1b78c09e$export$394d1d02e8c5316e = (numOfColumns, numOfRows, rowSticky, viewMode)=>{
        const Z_INDEX_LEVEL = (0, $6hYE8.Z_INDEX_LEVEL_OLD);
        const lift = (level)=>(input)=>{
                const levelSize = numOfColumns + $7c5e2d2e1b78c09e$var$BUFFER_SIZE * 2;
                const levelsBelow = level * levelSize;
                const offset = input + $7c5e2d2e1b78c09e$var$BUFFER_SIZE;
                return offset + levelsBelow + $7c5e2d2e1b78c09e$var$STATIC_LEVEL_SIZE;
            };
        return (props)=>{
            if ('layer' in props) switch(props.layer){
                case (0, $6hYE8.Z_INDEX_LAYER).DEPENDENCY_LINES:
                    return 1;
                case (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS:
                    return 2;
                case (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS_ARROWS:
                    return 3;
                case (0, $6hYE8.Z_INDEX_LAYER).AXIS_STICKY_TIME_UNIT:
                    return lift(Z_INDEX_LEVEL.HEADER)(1);
                case (0, $6hYE8.Z_INDEX_LAYER).STICKY_HEADER_SCROLL_SHADOW:
                case (0, $6hYE8.Z_INDEX_LAYER).HORIZONTAL_SCROLL_BAR:
                case (0, $6hYE8.Z_INDEX_LAYER).DEPENDENCY_LINE_DRAG_PREVIEW:
                    return lift(Z_INDEX_LEVEL.SUBHEADER)(-1);
                case (0, $6hYE8.Z_INDEX_LAYER).EMPTY_LIST_OVERLAY:
                    return lift(Z_INDEX_LEVEL.SUBHEADER)(-1);
                case (0, $6hYE8.Z_INDEX_LAYER).STICKY_GROUP_SCROLL_SHADOW:
                    return lift(Z_INDEX_LEVEL.STICKY)(-1);
                default:
                    return 0;
            }
            if ('row' in props) {
                const { column: column, row: row, level: level } = props;
                const isTimelineColumn = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE && column === numOfColumns - 1;
                const reversedColumnIndex = numOfColumns - 1 - column;
                if (row === 0) return lift(Z_INDEX_LEVEL.HEADER)(reversedColumnIndex);
                if (row === 1) return lift(Z_INDEX_LEVEL.SUBHEADER)(reversedColumnIndex);
                if (rowSticky[row]) return lift(Z_INDEX_LEVEL.STICKY)(reversedColumnIndex);
                if (isTimelineColumn) return undefined;
                return lift(level ?? Z_INDEX_LEVEL.DEFAULT)(reversedColumnIndex);
            }
            return 0;
        };
    };
    const $7c5e2d2e1b78c09e$export$72516da9e0165071 = (0, $3YtPS.createSelector)([
        $7c5e2d2e1b78c09e$export$a3141f11a33b8412,
        $7c5e2d2e1b78c09e$export$b3b4bb28e7752964,
        (0, $6L8iB.getRowStickiness),
        (0, $kWDpn.getViewMode)
    ], $7c5e2d2e1b78c09e$export$a381c346af83af6b);
    const $7c5e2d2e1b78c09e$export$b2e9b25f109189b4 = (0, $3YtPS.createSelector)([
        $7c5e2d2e1b78c09e$export$a3141f11a33b8412,
        $7c5e2d2e1b78c09e$export$b3b4bb28e7752964,
        (0, $6L8iB.getRowStickiness),
        (0, $kWDpn.getViewMode)
    ], $7c5e2d2e1b78c09e$export$394d1d02e8c5316e);
    const $7c5e2d2e1b78c09e$var$getZIndex = (0, (0, parcelRequire("32bya")).selectorWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns'), $7c5e2d2e1b78c09e$export$72516da9e0165071, $7c5e2d2e1b78c09e$export$b2e9b25f109189b4);
    const $7c5e2d2e1b78c09e$export$c31df4bd766f9c35 = (0, $3YtPS.createSelector)([
        $7c5e2d2e1b78c09e$var$getZIndex
    ], (zIndex)=>({
            zIndex: zIndex
        }));
});
parcelRegister("32bya", function(module, exports) {
    $parcel$export(module.exports, "selectorWithCondition", ()=>$269c1eb4b07b4fa1$export$6be2ebff06b95055);
    const $269c1eb4b07b4fa1$export$6be2ebff06b95055 = (condition, selectorTrue, selectorFalse)=>{
        const selector = (...args)=>{
            if (condition()) return selectorTrue(...args);
            return selectorFalse(...args);
        };
        return selector;
    };
});
parcelRegister("lvtWn", function(module, exports) {
    $parcel$export(module.exports, "Grid", ()=>$d8864031ad854809$export$ef2184bd89960b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $2EwIC;
    var $8LV9S;
    var $3Q86Z;
    var $6zg0h;
    var $aBn5Y;
    var $9AJ3a;
    const $d8864031ad854809$var$Blanket = ()=>{
        const [isScrollingY] = (0, (0, parcelRequire("2EwIC")).useIsScrollingY)();
        if (!isScrollingY) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d8864031ad854809$var$blanketStyles
        });
    };
    const $d8864031ad854809$export$ef2184bd89960b14 = (0, $5uXOq.memo)(({ rowConfigs: rowConfigs, columnConfigs: columnConfigs, colspan: colspan, layout: layout = 'auto', row: renderRow, virtualizationScrollThreshold: virtualizationScrollThreshold, empty: empty, children: children, stickyOffset: stickyOffset, rangeExtractor: rangeExtractor, columnWidths: columnWidths, overscan: overscan = 0, resizer: resizer, onColumnWidthsChange: onColumnWidthsChange, ariaLabel: ariaLabel, role: role, testId: testId, dataName: dataName })=>{
        const layoutStyles = layout === 'fixed' ? [
            $d8864031ad854809$var$fixedTableStyles
        ] : [];
        const table = (top, bottom)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                as: "table",
                xcss: [
                    $d8864031ad854809$var$tableStyles,
                    ...layoutStyles
                ],
                "aria-label": ariaLabel,
                role: role,
                testId: testId,
                "data-name": dataName
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Q86Z")).Colgroup), {
                count: columnConfigs.length
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aBn5Y")).Virtualized), {
                rowConfigs: rowConfigs
            }, ({ head: head, body: body, liteRowIndexes: liteRowIndexes, visibleCols: visibleCols })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($d8864031ad854809$var$Blanket, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "thead"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6zg0h")).Head), {
                    head: head,
                    renderRow: renderRow,
                    columnConfigs: columnConfigs
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "tbody"
                }, empty(top), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6zg0h")).Body), {
                    body: body,
                    renderRow: renderRow,
                    columnConfigs: columnConfigs,
                    liteRowIndexes: liteRowIndexes,
                    visibleCols: visibleCols
                }), empty(bottom))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                role: "presentation",
                xcss: $d8864031ad854809$var$fillWrapperStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                as: "table",
                xcss: [
                    $d8864031ad854809$var$tableStyles,
                    ...layoutStyles,
                    $d8864031ad854809$var$fillParentStyles
                ],
                role: "presentation"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Q86Z")).Colgroup), {
                count: columnConfigs.length
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                as: "tbody"
            }, empty()))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9AJ3a")).Virtualizer), {
            rowConfigs: rowConfigs,
            overscan: overscan,
            rangeExtractor: rangeExtractor,
            scrollThreshold: virtualizationScrollThreshold
        }, ({ top: top, bottom: bottom })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8LV9S")).GridProvider), {
                layout: layout,
                columns: columnConfigs,
                widths: columnWidths,
                onWidthsChange: onColumnWidthsChange,
                rows: rowConfigs,
                colspan: colspan,
                stickyOffset: stickyOffset,
                resizer: resizer
            }, children?.(table(top, bottom))));
    });
    const $d8864031ad854809$var$tableStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.0',
        borderCollapse: 'separate',
        borderSpacing: 0,
        minWidth: '100%'
    });
    const $d8864031ad854809$var$fixedTableStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        tableLayout: 'fixed'
    });
    const $d8864031ad854809$var$fillParentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%'
    });
    const $d8864031ad854809$var$fillWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1,
        position: 'relative'
    });
    const $d8864031ad854809$var$blanketStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.0',
        left: 'space.0',
        width: '100%',
        height: '100%',
        zIndex: 'blanket'
    });
});
parcelRegister("2EwIC", function(module, exports) {
    $parcel$export(module.exports, "useViewport", ()=>$e8f9732a0a27824a$export$297ec8eb77d6211d);
    $parcel$export(module.exports, "useScrollX", ()=>$e8f9732a0a27824a$export$4f7901b64c931616);
    $parcel$export(module.exports, "useScrollY", ()=>$e8f9732a0a27824a$export$7a772f5370e86a14);
    $parcel$export(module.exports, "useScrollYDirection", ()=>$e8f9732a0a27824a$export$495dfdc2dff27c82);
    $parcel$export(module.exports, "useIsScrollingY", ()=>$e8f9732a0a27824a$export$b4e5a0824bff5bca);
    $parcel$export(module.exports, "useContainerActions", ()=>$e8f9732a0a27824a$export$d5ad9ced4a1f0793);
    $parcel$export(module.exports, "ContainerProvider", ()=>$e8f9732a0a27824a$export$a5651d4e87ed3b2d);
    var $j0fbq = parcelRequire("j0fbq");
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $ihopC;
    const $e8f9732a0a27824a$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            top: 0,
            left: 0,
            width: 0,
            height: 0,
            scrollX: 0,
            scrollY: 0,
            scrollTo: (0, ($parcel$interopDefault($j0fbq))),
            isScrollingY: false,
            scrollYDirection: (0, $30e5c5dd40a62965$export$2db1f4b18163a99f),
            scrollEventHandlers: []
        },
        actions: (0, parcelRequire("ihopC")).actions
    });
    const $e8f9732a0a27824a$export$297ec8eb77d6211d = (0, (0, parcelRequire("3sQ5x")).createHook)($e8f9732a0a27824a$var$store, {
        selector: ({ top: top, left: left, width: width, height: height })=>({
                top: top,
                left: left,
                width: width,
                height: height
            })
    });
    const $e8f9732a0a27824a$export$4f7901b64c931616 = (0, (0, parcelRequire("3sQ5x")).createHook)($e8f9732a0a27824a$var$store, {
        selector: ({ scrollX: scrollX })=>scrollX
    });
    const $e8f9732a0a27824a$export$7a772f5370e86a14 = (0, (0, parcelRequire("3sQ5x")).createHook)($e8f9732a0a27824a$var$store, {
        selector: ({ scrollY: scrollY })=>scrollY
    });
    const $e8f9732a0a27824a$export$495dfdc2dff27c82 = (0, (0, parcelRequire("3sQ5x")).createHook)($e8f9732a0a27824a$var$store, {
        selector: ({ scrollYDirection: scrollYDirection })=>scrollYDirection
    });
    const $e8f9732a0a27824a$export$b4e5a0824bff5bca = (0, (0, parcelRequire("3sQ5x")).createHook)($e8f9732a0a27824a$var$store, {
        selector: ({ isScrollingY: isScrollingY })=>isScrollingY
    });
    const $e8f9732a0a27824a$export$d5ad9ced4a1f0793 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($e8f9732a0a27824a$var$store);
    const $e8f9732a0a27824a$export$a5651d4e87ed3b2d = (0, (0, parcelRequire("gg7kZ")).createContainer)($e8f9732a0a27824a$var$store, {
        onInit: ()=>({ setState: setState }, state)=>setState(state),
        onUpdate: ()=>({ setState: setState }, state)=>setState(state)
    });
});
parcelRegister("j0fbq", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $dd59cb79813bd595$var$func = $lVx1a('noop', (parcelRequire("8Rkzz")), (parcelRequire("bUoRH")));
    $dd59cb79813bd595$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $dd59cb79813bd595$var$func;
});
parcelRegister("ihopC", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$923c4b3e7720edc0$export$e324594224ef24da);
    var $hjAWb = parcelRequire("hjAWb");
    const $923c4b3e7720edc0$export$e324594224ef24da = {
        setRect: (rect)=>({ setState: setState })=>setState(rect),
        scrollTo: ({ x: x, y: y, smooth: smooth, passive: passive = false })=>({ setState: setState, getState: getState })=>{
                const { scrollY: scrollY, scrollYDirection: scrollYDirection, scrollTo: scrollTo, scrollEventHandlers: scrollEventHandlers } = getState();
                if (!passive) scrollTo({
                    x: x,
                    y: y,
                    smooth: smooth
                });
                const nextScrollYDirection = (()=>{
                    if (y === undefined) return undefined;
                    if (y > scrollY) return 0, $30e5c5dd40a62965$export$2db1f4b18163a99f;
                    if (y < scrollY) return 0, $30e5c5dd40a62965$export$31a4a1f83d1be1c2;
                    return scrollYDirection;
                })();
                const newState = {
                    ...x !== undefined && {
                        scrollX: x
                    },
                    ...y !== undefined && {
                        scrollY: y
                    },
                    ...nextScrollYDirection !== undefined && {
                        scrollYDirection: nextScrollYDirection
                    }
                };
                setState(newState);
                scrollEventHandlers.forEach((callback)=>callback((0, ($parcel$interopDefault($hjAWb)))([
                        'scrollX',
                        'scrollY'
                    ], {
                        ...getState(),
                        ...newState
                    })));
            },
        addScrollHandler: (callback)=>({ getState: getState, setState: setState })=>{
                setState({
                    scrollEventHandlers: getState().scrollEventHandlers.concat(callback)
                });
            },
        removeScrollHandler: (callback)=>({ getState: getState, setState: setState })=>{
                setState({
                    scrollEventHandlers: getState().scrollEventHandlers.filter((eventHandler)=>eventHandler !== callback)
                });
            },
        updateIsScrollingY: (isScrollingY)=>({ setState: setState })=>setState({
                    isScrollingY: isScrollingY
                })
    };
});
const $30e5c5dd40a62965$export$2db1f4b18163a99f = 'downward';
const $30e5c5dd40a62965$export$31a4a1f83d1be1c2 = 'upward';
parcelRegister("8LV9S", function(module, exports) {
    $parcel$export(module.exports, "useRowConfig", ()=>$bdf980960f2e5800$export$3916b4f063cc8548);
    $parcel$export(module.exports, "useColSpan", ()=>$bdf980960f2e5800$export$76f5c025088d1763);
    $parcel$export(module.exports, "useColumnWidth", ()=>$bdf980960f2e5800$export$31b9262eef3f0be6);
    $parcel$export(module.exports, "useColWidth", ()=>$bdf980960f2e5800$export$527cd28344bdeb1b);
    $parcel$export(module.exports, "useColumnWidths", ()=>$bdf980960f2e5800$export$d598237875812773);
    $parcel$export(module.exports, "useColumnStickyOffset", ()=>$bdf980960f2e5800$export$cd19232ee8dc72ec);
    $parcel$export(module.exports, "useIsResizing", ()=>$bdf980960f2e5800$export$ea2cea7ba1ba54df);
    $parcel$export(module.exports, "useResizerVisible", ()=>$bdf980960f2e5800$export$eb1dc6721405dee);
    $parcel$export(module.exports, "useColumns", ()=>$bdf980960f2e5800$export$c97dded465ef56fb);
    $parcel$export(module.exports, "useGridActions", ()=>$bdf980960f2e5800$export$7964534a86470fa1);
    $parcel$export(module.exports, "GridProvider", ()=>$bdf980960f2e5800$export$c4bf645ed2cecfdd);
    var $j0fbq = parcelRequire("j0fbq");
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $kCsuF;
    var $6WVCJ;
    const $bdf980960f2e5800$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            columns: [],
            widths: [],
            layout: 'auto',
            onWidthsChange: (0, ($parcel$interopDefault($j0fbq))),
            stickyOffset: {
                vertical: 0,
                horizontal: 0
            },
            rows: []
        },
        actions: (0, parcelRequire("kCsuF")).actions
    });
    const $bdf980960f2e5800$export$f6b86a04e5d66d90 = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store);
    const $bdf980960f2e5800$export$55e807591ce8819 = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (state, col)=>state.columns[col]
    });
    const $bdf980960f2e5800$export$3916b4f063cc8548 = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (state, col)=>state.rows[col]
    });
    const $bdf980960f2e5800$export$76f5c025088d1763 = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (0, (0, parcelRequire("6WVCJ")).selectColSpan)
    });
    const $bdf980960f2e5800$export$31b9262eef3f0be6 = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (state, { column: column, preview: preview })=>(0, (0, parcelRequire("6WVCJ")).getColumnWidths)(state, preview).at(column)
    });
    const $bdf980960f2e5800$export$527cd28344bdeb1b = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (state, { column: column, viewportWidth: viewportWidth })=>(0, (0, parcelRequire("6WVCJ")).getColWidth)(state, viewportWidth, column)
    });
    const $bdf980960f2e5800$export$d598237875812773 = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (state, { preview: preview })=>(0, (0, parcelRequire("6WVCJ")).getColumnWidths)(state, preview)
    });
    const $bdf980960f2e5800$export$cd19232ee8dc72ec = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (0, (0, parcelRequire("6WVCJ")).selectColumnStickyOffset)
    });
    const $bdf980960f2e5800$export$3346c37762cb30d3 = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (0, (0, parcelRequire("6WVCJ")).selectRowStickyOffset)
    });
    const $bdf980960f2e5800$export$ea2cea7ba1ba54df = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (state)=>state.preview !== undefined
    });
    const $bdf980960f2e5800$export$eb1dc6721405dee = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (0, (0, parcelRequire("6WVCJ")).selectResizerVisible)
    });
    const $bdf980960f2e5800$export$c97dded465ef56fb = (0, (0, parcelRequire("3sQ5x")).createHook)($bdf980960f2e5800$var$store, {
        selector: (state)=>({
                columns: state.columns,
                widths: state.widths
            })
    });
    const $bdf980960f2e5800$export$7964534a86470fa1 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($bdf980960f2e5800$var$store);
    const $bdf980960f2e5800$export$c4bf645ed2cecfdd = (0, (0, parcelRequire("gg7kZ")).createContainer)($bdf980960f2e5800$var$store, {
        onInit: ()=>({ setState: setState }, state)=>setState(state),
        onUpdate: ()=>({ setState: setState }, state)=>setState(state)
    });
});
parcelRegister("kCsuF", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$f8904ce602e5f294$export$e324594224ef24da);
    const $f8904ce602e5f294$export$e324594224ef24da = {
        resize: (col, delta, commit = false)=>({ setState: setState, getState: getState })=>{
                const { widths: widths, onWidthsChange: onWidthsChange, resizer: resizer } = getState();
                if (!resizer) return;
                const preview = resizer({
                    column: col,
                    delta: delta
                })(widths);
                if (commit) onWidthsChange(preview);
                setState({
                    preview: commit ? undefined : preview
                });
            },
        setWidths: (next)=>({ setState: setState })=>setState({
                    widths: next
                })
    };
});
parcelRegister("6WVCJ", function(module, exports) {
    $parcel$export(module.exports, "getColumnWidths", ()=>$a935b78b4cea9091$export$e54c9225ca52acc);
    $parcel$export(module.exports, "selectColumnStickyOffset", ()=>$a935b78b4cea9091$export$4aa1b9e96792c36);
    $parcel$export(module.exports, "getColWidth", ()=>$a935b78b4cea9091$export$452c9ccc45680e8c);
    $parcel$export(module.exports, "selectRowStickyOffset", ()=>$a935b78b4cea9091$export$561715508089bf3e);
    $parcel$export(module.exports, "selectColSpan", ()=>$a935b78b4cea9091$export$5052f5d8c766348e);
    $parcel$export(module.exports, "selectResizerVisible", ()=>$a935b78b4cea9091$export$85a13408c5391d40);
    var $gAFMM = parcelRequire("gAFMM");
    const $a935b78b4cea9091$export$e54c9225ca52acc = (state, preview)=>(preview ? state.preview : undefined) ?? state.widths;
    const $a935b78b4cea9091$export$4aa1b9e96792c36 = (state, { column: column, preview: preview })=>state.columns[column].sticky ? $a935b78b4cea9091$export$e54c9225ca52acc(state, preview).slice(0, column).reduce((offset = 0, width)=>offset + width, state.stickyOffset.horizontal) : undefined;
    const $a935b78b4cea9091$export$452c9ccc45680e8c = (state, viewportWidth, column)=>{
        const columnWidths = $a935b78b4cea9091$export$e54c9225ca52acc(state, true);
        const columnWidth = columnWidths.at(column) ?? 0;
        const lastIndex = columnWidths.length - 1;
        if (columnWidth === 0) return undefined;
        if (state.layout === 'auto') return columnWidth;
        if (column < lastIndex) return columnWidth;
        const hasHorizontalScrolling = (0, ($parcel$interopDefault($gAFMM)))(columnWidths) > viewportWidth;
        if (hasHorizontalScrolling) return columnWidth;
        return '100%';
    };
    const $a935b78b4cea9091$export$561715508089bf3e = (state, { row: row, virtualized: virtualized })=>{
        const sticky = virtualized.filter((index)=>state.rows[index].sticky);
        if (!sticky.includes(row)) return undefined;
        return sticky.slice(0, sticky.indexOf(row)).map((index)=>state.rows[index]).reduce((acc, { height: height })=>acc + height, state.stickyOffset.vertical);
    };
    const $a935b78b4cea9091$export$5052f5d8c766348e = (state, { row: row, column: column, preview: preview })=>state.colspan?.({
            column: column,
            row: row,
            columnWidths: $a935b78b4cea9091$export$e54c9225ca52acc(state, preview)
        }) ?? 1;
    const $a935b78b4cea9091$export$85a13408c5391d40 = (state, { column: column, scrollX: scrollX, preview: preview })=>{
        const isSticky = (col)=>state.columns[col].sticky;
        if (isSticky(column)) return true;
        return $a935b78b4cea9091$export$e54c9225ca52acc(state, preview).slice(0, column + 1).filter((_, index)=>!isSticky(index)).reduce((visible, width)=>visible + width, -scrollX) > 0;
    };
});
parcelRegister("gAFMM", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $c1406be821baa64c$var$func = $lVx1a('sum', (parcelRequire("iThRn")), (parcelRequire("bUoRH")));
    $c1406be821baa64c$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $c1406be821baa64c$var$func;
});
parcelRegister("iThRn", function(module, exports) {
    var $gBzAF = parcelRequire("gBzAF");
    var $etyzk = parcelRequire("etyzk");
    function $dc0b37ac120f9bb6$var$sum(array) {
        return array && array.length ? $gBzAF(array, $etyzk) : 0;
    }
    module.exports = $dc0b37ac120f9bb6$var$sum;
});
parcelRegister("gBzAF", function(module, exports) {
    function $c16bb58eedefe4cd$var$baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    module.exports = $c16bb58eedefe4cd$var$baseSum;
});
parcelRegister("3Q86Z", function(module, exports) {
    $parcel$export(module.exports, "Colgroup", ()=>$6389082f6b46d14d$export$89efc2d0ceeaa030);
    var $5uXOq = parcelRequire("5uXOq");
    var $2EwIC;
    var $8LV9S;
    const $6389082f6b46d14d$export$89efc2d0ceeaa030 = (0, $5uXOq.memo)(({ count: count })=>(0, ($parcel$interopDefault($5uXOq))).createElement("colgroup", null, Array(count).fill(undefined).map((_, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($6389082f6b46d14d$export$963a4b2511a4b70c, {
                key: index,
                index: index
            }))));
    const $6389082f6b46d14d$export$963a4b2511a4b70c = ({ index: index })=>{
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [width] = (0, (0, parcelRequire("8LV9S")).useColWidth)({
            column: index,
            viewportWidth: viewport.width
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("col", {
            width: width
        });
    };
});
parcelRegister("6zg0h", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$592b4807823913d0$export$e93312b7773dfcac);
    $parcel$export(module.exports, "Body", ()=>$592b4807823913d0$export$4b2c32e08f77ff18);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    const $592b4807823913d0$export$e93312b7773dfcac = (0, $5uXOq.memo)(({ head: head, renderRow: renderRow, columnConfigs: columnConfigs })=>head.map(([row, rowIndex])=>renderRow(row, columnConfigs, rowIndex, undefined)), (0, ($parcel$interopDefault($ajpes))));
    const $592b4807823913d0$export$4b2c32e08f77ff18 = (0, $5uXOq.memo)(({ body: body, renderRow: renderRow, columnConfigs: columnConfigs, liteRowIndexes: liteRowIndexes, visibleCols: visibleCols })=>body.map(([row, rowIndex])=>renderRow(row, columnConfigs, rowIndex, liteRowIndexes.includes(rowIndex) ? {
                visibleCols: visibleCols
            } : undefined)));
});
parcelRegister("aBn5Y", function(module, exports) {
    $parcel$export(module.exports, "Virtualized", ()=>$239de46a16f755e6$export$2a39ec02a11a5d1d);
    var $5uXOq = parcelRequire("5uXOq");
    var $hnQ9l = parcelRequire("hnQ9l");
    var $7d8ky;
    var $2EwIC;
    var $iHAEW;
    const $239de46a16f755e6$var$EMPTY_LIST = [];
    const $239de46a16f755e6$var$EMPTY_COLS = {};
    const $239de46a16f755e6$export$2a39ec02a11a5d1d = ({ rowConfigs: rowConfigs, children: children })=>{
        const virtualized = (0, (0, parcelRequire("iHAEW")).useVirtualized)();
        const [isScrollingY] = (0, (0, parcelRequire("2EwIC")).useIsScrollingY)();
        const columnsVisible = (0, (0, parcelRequire("7d8ky")).useVisibleColumns)();
        const virtualizedRef = (0, $5uXOq.useRef)(undefined);
        const visibleColsRef = (0, $5uXOq.useRef)($239de46a16f755e6$var$EMPTY_COLS);
        const [head, body] = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($hnQ9l)))(([rowConfig])=>rowConfig.thead)(rowConfigs.map((rowConfig, index)=>[
                    rowConfig,
                    index
                ]).filter(([, index])=>virtualized.includes(index))), [
            virtualized,
            rowConfigs
        ]);
        const prevVirtualized = (0, $5uXOq.useMemo)(()=>isScrollingY ? virtualizedRef.current : undefined, [
            isScrollingY
        ]);
        virtualizedRef.current = new Set(virtualized);
        visibleColsRef.current = columnsVisible;
        const liteRowIndexes = (0, $5uXOq.useMemo)(()=>prevVirtualized !== undefined ? virtualized.filter((index)=>!prevVirtualized.has(index)) : $239de46a16f755e6$var$EMPTY_LIST, [
            virtualized,
            prevVirtualized
        ]);
        const visibleCols = (0, $5uXOq.useMemo)(()=>prevVirtualized !== undefined ? visibleColsRef.current : $239de46a16f755e6$var$EMPTY_COLS, [
            prevVirtualized
        ]);
        return children({
            head: head,
            body: body,
            liteRowIndexes: liteRowIndexes,
            visibleCols: visibleCols
        });
    };
});
parcelRegister("hnQ9l", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $ca7d0983ba7a0674$var$func = $lVx1a('partition', (parcelRequire("ifg6x")));
    $ca7d0983ba7a0674$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $ca7d0983ba7a0674$var$func;
});
parcelRegister("7d8ky", function(module, exports) {
    $parcel$export(module.exports, "useVisibleColumns", ()=>$13a14303f08b1d63$export$d9f6d58f0e1787fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $2EwIC;
    var $8LV9S;
    const $13a14303f08b1d63$export$d9f6d58f0e1787fa = ()=>{
        const [{ columns: columns, widths: widths }] = (0, (0, parcelRequire("8LV9S")).useColumns)();
        const [scrollX] = (0, (0, parcelRequire("2EwIC")).useScrollX)();
        const [{ width: width }] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const visibleCols = (0, $5uXOq.useMemo)(()=>{
            const columnsVisibleArr = {};
            let left = 0;
            columns.forEach((col, index)=>{
                const currentWidth = widths[index];
                if (col.sticky || left >= scrollX && left + currentWidth <= scrollX + width) columnsVisibleArr[index.toString()] = true;
                else columnsVisibleArr[index.toString()] = false;
                left += currentWidth;
            });
            return columnsVisibleArr;
        }, [
            scrollX,
            width,
            columns,
            widths
        ]);
        return visibleCols;
    };
});
parcelRegister("iHAEW", function(module, exports) {
    $parcel$export(module.exports, "VirtualizedProvider", ()=>$1b841d0736909a41$export$2bf83f0278652f6);
    $parcel$export(module.exports, "useVirtualized", ()=>$1b841d0736909a41$export$f3792f52cefad05d);
    var $5uXOq = parcelRequire("5uXOq");
    const $1b841d0736909a41$var$context = (0, $5uXOq.createContext)([]);
    const $1b841d0736909a41$export$2bf83f0278652f6 = $1b841d0736909a41$var$context.Provider;
    const $1b841d0736909a41$export$f3792f52cefad05d = ()=>(0, $5uXOq.useContext)($1b841d0736909a41$var$context);
});
parcelRegister("9AJ3a", function(module, exports) {
    $parcel$export(module.exports, "Virtualizer", ()=>$1eacf7e8604cd055$export$89be5a243e59c4b2);
    var $5uXOq = parcelRequire("5uXOq");
    var $2EwIC;
    var $iHAEW;
    var $dtWHT;
    const $1eacf7e8604cd055$export$89be5a243e59c4b2 = ({ rowConfigs: rowConfigs, rangeExtractor: rangeExtractor = ({ above: above, within: within, below: below })=>[
            ...above,
            ...within,
            ...below
        ], scrollThreshold: scrollThreshold, overscan: overscan, children: children })=>{
        const [{ height: height }] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [scrollYDirection] = (0, (0, parcelRequire("2EwIC")).useScrollYDirection)();
        const scrollHeight = (0, $5uXOq.useMemo)(()=>rowConfigs.reduce((acc, { height: height })=>acc + height, 0), [
            rowConfigs
        ]);
        const scrollOffset = (0, (0, parcelRequire("dtWHT")).useScrollOffset)(height, scrollHeight, scrollThreshold);
        const overscanAbove = scrollYDirection === 'upward' ? overscan : 0;
        const overscanBelow = scrollYDirection === 'downward' ? overscan : 0;
        const [above, within, below] = (0, (0, parcelRequire("dtWHT")).getRanges)(height, scrollOffset, (index)=>rowConfigs[index]?.height, overscanAbove, overscanBelow);
        const unextracted = [
            ...above,
            ...within,
            ...below
        ];
        const virtualized = (0, (0, parcelRequire("dtWHT")).getExtractedRanges)(above, within, below, rangeExtractor);
        const additionalSticky = virtualized.slice(0, Math.max(virtualized.indexOf(unextracted[0]?.index ?? 0), 0));
        const placeholder = {
            top: (unextracted.at(0)?.top ?? 0) - additionalSticky.reduce((acc, index)=>acc + (rowConfigs[index]?.height ?? 0), 0),
            bottom: Math.max(height, scrollHeight) - ((unextracted.at(-1)?.top ?? 0) + (unextracted.at(-1)?.height ?? 0))
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iHAEW")).VirtualizedProvider), {
            value: virtualized
        }, children(placeholder));
    };
});
parcelRegister("dtWHT", function(module, exports) {
    $parcel$export(module.exports, "getRanges", ()=>$327e168e79b1ac37$export$876a6466078c921c);
    $parcel$export(module.exports, "getExtractedRanges", ()=>$327e168e79b1ac37$export$1ea34a44b7a952c5);
    $parcel$export(module.exports, "useScrollOffset", ()=>$327e168e79b1ac37$export$c0519b2d959c96bb);
    var $ajpes = parcelRequire("ajpes");
    var $8QpSo;
    var $2EwIC;
    const $327e168e79b1ac37$export$876a6466078c921c = (containerHeight, scrollOffset, getRowHeight, overscanAbove = 20, overscanBelow = 20)=>{
        const above = [];
        const within = [];
        const below = [];
        let lastRow;
        const aboveViewport = (offset)=>offset < scrollOffset;
        const belowViewport = (offset)=>offset > scrollOffset + containerHeight;
        const inViewport = (offset)=>offset >= scrollOffset && offset <= scrollOffset + containerHeight;
        for(let cursor = 0; cursor < Infinity; cursor++){
            const height = getRowHeight(cursor);
            if (height === undefined) break;
            const top = lastRow ? lastRow.top + lastRow.height : 0;
            const row = {
                index: cursor,
                top: top,
                height: height
            };
            if (aboveViewport(row.top + row.height)) {
                above.push(row);
                while(above.length > overscanAbove)above.shift();
            } else if (inViewport(row.top + row.height) || inViewport(row.top)) within.push(row);
            else if (belowViewport(row.top)) {
                if (below.length >= overscanBelow) break;
                below.push(row);
            }
            lastRow = row;
        }
        return [
            above,
            within,
            below
        ];
    };
    const $327e168e79b1ac37$export$1ea34a44b7a952c5 = (0, (0, parcelRequire("8QpSo")).default)((above, within, below, rangeExtractor)=>{
        const getIndexes = (rows)=>rows.map(({ index: index })=>index);
        return rangeExtractor({
            above: getIndexes(above),
            within: getIndexes(within),
            below: getIndexes(below)
        });
    }, (0, ($parcel$interopDefault($ajpes))));
    const $327e168e79b1ac37$export$c0519b2d959c96bb = (containerHeight, scrollHeight, scrollThreshold)=>{
        const [scrollY] = (0, (0, parcelRequire("2EwIC")).useScrollY)();
        const [scrollYDirection] = (0, (0, parcelRequire("2EwIC")).useScrollYDirection)();
        if (scrollThreshold === undefined) return scrollY;
        switch(scrollYDirection){
            case 0, $30e5c5dd40a62965$export$2db1f4b18163a99f:
                return Math.floor(scrollY / scrollThreshold) * scrollThreshold;
            case 0, $30e5c5dd40a62965$export$31a4a1f83d1be1c2:
                {
                    const reverseScrollOffset = (input)=>scrollHeight - (input + containerHeight);
                    return reverseScrollOffset(Math.floor(reverseScrollOffset(scrollY) / scrollThreshold) * scrollThreshold);
                }
            default:
                return scrollY;
        }
    };
});
parcelRegister("2KkNy", function(module, exports) {
    $parcel$export(module.exports, "Row", ()=>$db100b99d787ebd6$export$b59bdbef9ce70de2);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8LV9S;
    var $eT70U;
    const $db100b99d787ebd6$export$b59bdbef9ce70de2 = ({ index: index, height: height, style: style, ...restProps })=>{
        const [rowConfig] = (0, (0, parcelRequire("8LV9S")).useRowConfig)(index);
        const finalHeight = height ?? rowConfig?.height ?? 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eT70U")).RowProvider), {
            row: index,
            height: finalHeight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "tr",
            style: {
                height: finalHeight,
                ...style
            },
            ...restProps
        }));
    };
});
parcelRegister("eT70U", function(module, exports) {
    $parcel$export(module.exports, "RowProvider", ()=>$a025a9fc61444f45$export$329ef9142f16ee64);
    $parcel$export(module.exports, "useRow", ()=>$a025a9fc61444f45$export$223b5cb3e865c05e);
    var $5uXOq = parcelRequire("5uXOq");
    const $a025a9fc61444f45$var$context = (0, $5uXOq.createContext)({
        row: -1,
        height: 0
    });
    const $a025a9fc61444f45$export$329ef9142f16ee64 = ({ row: row, height: height, children: children })=>{
        const value = (0, $5uXOq.useMemo)(()=>({
                row: row,
                height: height
            }), [
            row,
            height
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a025a9fc61444f45$var$context.Provider, {
            value: value
        }, children);
    };
    const $a025a9fc61444f45$export$223b5cb3e865c05e = ()=>(0, $5uXOq.useContext)($a025a9fc61444f45$var$context);
});
parcelRegister("4cSmd", function(module, exports) {
    $parcel$export(module.exports, "DependenciesFlyoutProvider", ()=>$08cc8ad8c1362849$export$769da5814e8289ab);
    $parcel$export(module.exports, "useDependenciesFlyout", ()=>$08cc8ad8c1362849$export$e17d1515ee11256);
    $parcel$export(module.exports, "DependenciesFlyoutOverlay", ()=>$08cc8ad8c1362849$export$53da0ea820617f48);
    var $5uXOq = parcelRequire("5uXOq");
    var $J8W7q;
    var $2dZwa = parcelRequire("2dZwa");
    var $kCUda = parcelRequire("kCUda");
    var $eHjdS = parcelRequire("eHjdS");
    const $08cc8ad8c1362849$var$FLYOUT_MAX_WIDTH = 800;
    const $08cc8ad8c1362849$var$context = (0, $5uXOq.createContext)({
        payload: null,
        triggerRect: null,
        open: ()=>{},
        close: ()=>{}
    });
    const $08cc8ad8c1362849$export$769da5814e8289ab = ({ children: children })=>{
        const [flyoutProps, setFlyoutProps] = (0, $5uXOq.useState)(null);
        const [triggerRect, setTriggerRect] = (0, $5uXOq.useState)(null);
        const open = (payload, triggerEl)=>{
            setFlyoutProps(payload);
            setTriggerRect(triggerEl.getBoundingClientRect());
        };
        const close = ()=>setFlyoutProps(null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($08cc8ad8c1362849$var$context.Provider, {
            value: {
                payload: flyoutProps,
                triggerRect: triggerRect,
                open: open,
                close: close
            }
        }, children);
    };
    const $08cc8ad8c1362849$export$e17d1515ee11256 = ()=>(0, $5uXOq.useContext)($08cc8ad8c1362849$var$context);
    function $08cc8ad8c1362849$var$useDialogLock() {
        const flagsRef = (0, $5uXOq.useRef)(new Set());
        const reset = ()=>{
            flagsRef.current = new Set();
        };
        const isActivated = ()=>flagsRef.current.size > 0;
        const toggle = (lock)=>(on)=>{
                if (on) flagsRef.current.add(lock);
                else flagsRef.current.delete(lock);
            };
        return {
            reset: reset,
            isActivated: isActivated,
            toggle: toggle
        };
    }
    const $08cc8ad8c1362849$export$53da0ea820617f48 = ()=>{
        const ref = (0, $5uXOq.useRef)(null);
        const dialogLock = $08cc8ad8c1362849$var$useDialogLock();
        const [anchorRect, setAnchorRect] = (0, $5uXOq.useState)(null);
        const { payload: payload, close: close, triggerRect: triggerRect } = $08cc8ad8c1362849$export$e17d1515ee11256();
        (0, $5uXOq.useEffect)(()=>{
            const containerEl = ref.current;
            if (containerEl == null) return;
            if (triggerRect == null) return;
            const containerRect = containerEl.getBoundingClientRect();
            const anchorRect = {
                top: triggerRect.top - containerRect.top,
                left: triggerRect.left - containerRect.left,
                width: triggerRect.width,
                height: triggerRect.height
            };
            setAnchorRect(anchorRect);
        }, [
            payload,
            triggerRect
        ]);
        (0, $5uXOq.useEffect)(()=>{
            dialogLock.reset();
        }, [
            payload
        ]);
        function handleRequestClose() {
            if (dialogLock.isActivated()) return;
            close();
        }
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            className: $eHjdS.overlay
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2dZwa.DependenciesDialogContext).Provider, {
            value: {
                isDialogLocked: true,
                toggleDialogLocked: dialogLock.toggle
            }
        }, payload != null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kCUda.default), payload),
            isOpen: "true",
            onClose: handleRequestClose,
            maxWidth: $08cc8ad8c1362849$var$FLYOUT_MAX_WIDTH,
            placement: "bottom-end",
            closeOnScroll: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eHjdS.anchor,
            style: {
                ...anchorRect
            }
        })))));
    };
});
parcelRegister("2dZwa", function(module, exports) {
    $parcel$export(module.exports, "DependenciesDialogContext", ()=>$48cc1360092fbd84$export$9e8fff114122fda5);
    var $5uXOq = parcelRequire("5uXOq");
    const $48cc1360092fbd84$export$9e8fff114122fda5 = (0, $5uXOq.createContext)({
        isDialogLocked: false,
        toggleDialogLocked: ()=>()=>{}
    });
});
parcelRegister("kCUda", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fff4598fe8a60bb2$export$2e2bcd8739ae039);
    var $bC2fB;
    var $8VyVv = parcelRequire("8VyVv");
    var $dAjSY = parcelRequire("dAjSY");
    var $fff4598fe8a60bb2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $8VyVv.default), {})((0, $dAjSY.default));
});
parcelRegister("8VyVv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$972919ce467422df$export$2e2bcd8739ae039);
    var $8QpSo;
    var $iIikD = parcelRequire("iIikD");
    var $ddv1K = parcelRequire("ddv1K");
    var $cGbfF = parcelRequire("cGbfF");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $972919ce467422df$var$externalIncomingLinksList = [];
    const $972919ce467422df$var$externalOutgoingLinksList = [];
    const $972919ce467422df$var$internalIncomingLinksList = [];
    const $972919ce467422df$var$internalIncomingLinksOriginalList = [];
    const $972919ce467422df$var$internalOutgoingLinksList = [];
    const $972919ce467422df$var$internalOutgoingLinksOriginalList = [];
    const $972919ce467422df$var$mapStateToPropsFactory = ()=>{
        const linksFactory = (0, (0, parcelRequire("8QpSo")).default)((direction, externalIncomingLinks, internalIncomingLinks, internalIncomingLinksOriginal, externalOutgoingLinks, internalOutgoingLinks, internalOutgoingLinksOriginal)=>direction === (0, $TTKUQ.ISSUE_LINK_DIRECTION).INWARD ? [
                externalIncomingLinks,
                internalIncomingLinks,
                internalIncomingLinksOriginal
            ] : [
                externalOutgoingLinks,
                internalOutgoingLinks,
                internalOutgoingLinksOriginal
            ]);
        return (state, props)=>{
            const issueId = props.issue.id;
            const externalIncomingLinks = (0, $ddv1K.getExternalIncomingLinks)(state)[issueId] || $972919ce467422df$var$externalIncomingLinksList;
            const externalOutgoingLinks = (0, $ddv1K.getExternalOutgoingLinks)(state)[issueId] || $972919ce467422df$var$externalOutgoingLinksList;
            const internalIncomingLinks = (0, $ddv1K.getInternalIncomingLinks)(state)[issueId] || $972919ce467422df$var$internalIncomingLinksList;
            const internalIncomingLinksOriginal = (0, $ddv1K.getInternalIncomingLinkOriginals)(state)[issueId] || $972919ce467422df$var$internalIncomingLinksOriginalList;
            const internalOutgoingLinks = (0, $ddv1K.getInternalOutgoingLinks)(state)[issueId] || $972919ce467422df$var$internalOutgoingLinksList;
            const internalOutgoingLinksOriginal = (0, $ddv1K.getInternalOutgoingLinkOriginals)(state)[issueId] || $972919ce467422df$var$internalOutgoingLinksOriginalList;
            const filterValue = (0, $iIikD.getFilters)(state)[0, $cGbfF.DEPENDENCIES_FILTER_ID].value;
            const [externalIssueLinks, internalIssueLinks, originalIssueLinks] = linksFactory(props.direction, externalIncomingLinks, internalIncomingLinks, internalIncomingLinksOriginal, externalOutgoingLinks, internalOutgoingLinks, internalOutgoingLinksOriginal);
            return {
                internalIssueLinks: internalIssueLinks,
                externalIssueLinks: externalIssueLinks,
                originalIssueLinks: originalIssueLinks,
                filterValue: filterValue
            };
        };
    };
    const $972919ce467422df$export$c31df4bd766f9c35 = $972919ce467422df$var$mapStateToPropsFactory;
    var $972919ce467422df$export$2e2bcd8739ae039 = $972919ce467422df$export$c31df4bd766f9c35;
});
parcelRegister("dAjSY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d6e94f63e374264$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $diD1j = parcelRequire("diD1j");
    function $2d6e94f63e374264$export$2e2bcd8739ae039({ direction: direction, issue: issue, filterValue: filterValue, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, originalIssueLinks: originalIssueLinks }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $diD1j.default), {
            direction: direction,
            issue: issue,
            externalIssueLinks: externalIssueLinks,
            internalIssueLinks: internalIssueLinks,
            internalOriginalIssueLinks: originalIssueLinks || [],
            context: "badge",
            filterValue: filterValue
        });
    }
});
parcelRegister("diD1j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ccefe5c0e58cb9f2$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hYNSq = parcelRequire("hYNSq");
    var $8DvwL = parcelRequire("8DvwL");
    var $4MXLk = parcelRequire("4MXLk");
    const $ccefe5c0e58cb9f2$var$DependenciesFlyoutComponent = (0, (0, parcelRequire("bC2fB")).connect)((0, $8DvwL.default), (0, $hYNSq.default))((0, $4MXLk.default));
    var $ccefe5c0e58cb9f2$export$2e2bcd8739ae039 = $ccefe5c0e58cb9f2$var$DependenciesFlyoutComponent;
});
parcelRegister("hYNSq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6f03deeb18d0128$export$2e2bcd8739ae039);
    var $ced6B = parcelRequire("ced6B");
    var $eS9xr = parcelRequire("eS9xr");
    var $hLj4s = parcelRequire("hLj4s");
    const $c6f03deeb18d0128$var$mapDispatchToProps = (dispatch)=>({
            addDependency: (payload)=>{
                dispatch((0, $eS9xr.addIssueLink)(payload));
            },
            removeDependency: (payload)=>{
                dispatch((0, $eS9xr.deleteIssueLink)(payload));
            },
            loadExternalIssues: (ids)=>{
                dispatch((0, $ced6B.loadExternalIssues)(ids));
            },
            changeDependencySettingsDisplay: (payload)=>{
                dispatch((0, $hLj4s.changeDisplay)(payload));
            }
        });
    var $c6f03deeb18d0128$export$2e2bcd8739ae039 = $c6f03deeb18d0128$var$mapDispatchToProps;
});
parcelRegister("ced6B", function(module, exports) {
    $parcel$export(module.exports, "loadExternalIssues", ()=>$e3bb755217dfbf49$export$3efe18aba92c530);
    $parcel$export(module.exports, "default", ()=>$e3bb755217dfbf49$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $4R6GH;
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fKdeq = parcelRequire("fKdeq");
    var $gPkyZ = parcelRequire("gPkyZ");
    var $77QEM = parcelRequire("77QEM");
    var $24CMK = parcelRequire("24CMK");
    var $hvOzF = parcelRequire("hvOzF");
    var $IiGOF = parcelRequire("IiGOF");
    const $e3bb755217dfbf49$export$effe480081a88736 = 'command.external-issues.LOAD_EXTERNAL_ISSUES';
    const $e3bb755217dfbf49$export$3efe18aba92c530 = (payload)=>({
            type: $e3bb755217dfbf49$export$effe480081a88736,
            payload: payload
        });
    function* $e3bb755217dfbf49$export$badea75b931890f4({ payload: payload }) {
        const requestedExternalIssues = yield (0, $aNOuE.select)((0, $fKdeq.getExternalIssues));
        const issueIds = payload.filter((id)=>!requestedExternalIssues[id]);
        const result = issueIds.reduce((acc, id)=>{
            acc[id] = null;
            return acc;
        }, {});
        const url = (0, $IiGOF.urls).get;
        const body = {
            issueIds: issueIds
        };
        try {
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: 'POST',
                body: body
            });
            if (response.ok) {
                const { issues: issues } = yield (0, $aNOuE.call)(response.json.bind(response));
                Object.assign(result, (0, $4nDwW.indexBy)((x)=>x.id, issues));
            } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
                const error = new Error(response.text());
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'external-issues-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: 'POST',
                    status: response.status,
                    body: body
                }
            }));
        } finally{
            yield (0, $aNOuE.put)($gPkyZ.add(result));
        }
    }
    function* $e3bb755217dfbf49$export$2c4536cb2d0e7e41() {
        yield (0, $6u3NN.takeEvery)($e3bb755217dfbf49$export$effe480081a88736, $e3bb755217dfbf49$export$badea75b931890f4);
    }
    function* $e3bb755217dfbf49$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($e3bb755217dfbf49$export$2c4536cb2d0e7e41);
    }
});
parcelRegister("fKdeq", function(module, exports) {
    $parcel$export(module.exports, "getExternalIssues", ()=>$d6a4d723345cfc96$export$c284fae2050e87b6);
    const $d6a4d723345cfc96$export$c284fae2050e87b6 = (state)=>state.domain.externalIssues;
});
parcelRegister("gPkyZ", function(module, exports) {
    $parcel$export(module.exports, "ADD", ()=>$89fa71b0466f9cd8$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "add", ()=>$89fa71b0466f9cd8$export$e16d8520af44a096);
    const $89fa71b0466f9cd8$export$bb6389024b71c2ae = 'state.domain.external-issues.ADD';
    const $89fa71b0466f9cd8$export$e16d8520af44a096 = (payload)=>({
            type: $89fa71b0466f9cd8$export$bb6389024b71c2ae,
            payload: payload
        });
});
parcelRegister("hvOzF", function(module, exports) {
    $parcel$export(module.exports, "toErrorID", ()=>$3f66f38473e0535e$export$ebc70850e8cde9f4);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $y9aeT = parcelRequire("y9aeT");
    function* $3f66f38473e0535e$export$4884fd84d9484e78(block, promise, checkResult = false) {
        if (!promise || !promise?.resolve || !promise?.reject) return yield (0, $aNOuE.call)(block);
        try {
            const result = yield (0, $aNOuE.call)(block);
            if (checkResult && result === undefined) promise.reject(new Error('No result returned from the block'));
            else promise.resolve(result);
        } catch (err) {
            promise.reject(err);
        }
    }
    const $3f66f38473e0535e$var$SAGA_ERROR_PREFIX = 'arj-saga';
    const $3f66f38473e0535e$export$ebc70850e8cde9f4 = (error, message)=>{
        if ((0, $y9aeT.isEnvironmentError)(error)) return (0, $TTKUQ.ERROR_REPORTING_PACKAGE).ENVIRONMENT;
        const errorId = message || error?.message || 'plans-no-error-message';
        return `${$3f66f38473e0535e$var$SAGA_ERROR_PREFIX}-${errorId}`;
    };
});
parcelRegister("IiGOF", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$4ee3512159dc0c20$export$bcae9ba627f604b6);
    const $4ee3512159dc0c20$export$bcae9ba627f604b6 = {
        get: '/rest/jpo/1.0/issue/get'
    };
});
parcelRegister("eS9xr", function(module, exports) {
    $parcel$export(module.exports, "addIssueLink", ()=>$bb4d40af207ebd51$export$113196d38d8f6448);
    $parcel$export(module.exports, "deleteIssueLink", ()=>$bb4d40af207ebd51$export$b38a2b924f85419d);
    $parcel$export(module.exports, "handleIssueLinkCommitResponse", ()=>$bb4d40af207ebd51$export$d69a8e11bd4b544f);
    $parcel$export(module.exports, "revertChange", ()=>$bb4d40af207ebd51$export$be623675b8f208ee);
    $parcel$export(module.exports, "default", ()=>$bb4d40af207ebd51$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $dJl1T;
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ddv1K = parcelRequire("ddv1K");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpgxP = parcelRequire("jpgxP");
    var $25viM = parcelRequire("25viM");
    var $djjTM = parcelRequire("djjTM");
    var $36p1o = parcelRequire("36p1o");
    var $ccCF0 = parcelRequire("ccCF0");
    var $77QEM = parcelRequire("77QEM");
    var $hNEap = parcelRequire("hNEap");
    var $hjabd = parcelRequire("hjabd");
    var $24CMK = parcelRequire("24CMK");
    var $asXbx = parcelRequire("asXbx");
    var $72QzS = parcelRequire("72QzS");
    const $bb4d40af207ebd51$export$9ece66d5710b5222 = 'command.issue-links.ADD_ISSUE_LINK';
    const $bb4d40af207ebd51$export$e447be9b24d8f55e = 'command.issue-links.DELETE_ISSUE_LINK';
    const $bb4d40af207ebd51$export$113196d38d8f6448 = (payload)=>({
            type: $bb4d40af207ebd51$export$9ece66d5710b5222,
            payload: payload
        });
    const $bb4d40af207ebd51$export$b38a2b924f85419d = (payload)=>({
            type: $bb4d40af207ebd51$export$e447be9b24d8f55e,
            payload: payload
        });
    function* $bb4d40af207ebd51$export$4884fd84d9484e78(block, promise, checkResult = false) {
        if (!promise || !promise?.resolve || !promise?.reject) return yield (0, $aNOuE.call)(block);
        try {
            const result = yield (0, $aNOuE.call)(block);
            if (checkResult && result === undefined) promise.reject(new Error('No result returned from the block'));
            else promise.resolve(result);
        } catch (err) {
            promise.reject(err);
        }
    }
    function* $bb4d40af207ebd51$export$a357c0495856cd1c({ payload: payload }) {
        const pendingKey = Math.random().toString(36).slice(2);
        try {
            const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey, type: type } = payload;
            const { currentScenarioId: scenarioId, id: planId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
            const { dependencyIssueLinkTypes: dependencyIssueLinkTypes } = yield (0, $aNOuE.select)((0, $jpgxP.getDependencySettingsInfo));
            const outgoingLinks = yield (0, $aNOuE.select)((0, $ddv1K.getOutgoingLinks));
            const dependencyIssueLinkTypeById = (0, $4nDwW.indexBy)((dependencyIssueLinkType)=>dependencyIssueLinkType.issueLinkTypeId, dependencyIssueLinkTypes);
            const dependencyIssueLinkType = dependencyIssueLinkTypeById[type];
            if (dependencyIssueLinkType == null) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('plans.accessing-property-of-undefined', 'doAddIssueLink dependencyIssueLinkTypeById[type] is undefined');
            const isOutward = dependencyIssueLinkType?.isOutward;
            const url = (0, $72QzS.urls).add;
            if (sourceItemKey === targetItemKey) return;
            const outgoingLinksForItem = outgoingLinks[sourceItemKey] || [];
            const existingLinkArray = outgoingLinksForItem.filter((link)=>link.targetItemKey === targetItemKey && link.type === type);
            if (existingLinkArray.length > 0) return;
            const body = {
                description: {
                    type: {
                        value: type
                    }
                },
                sourceItemKey: isOutward ? sourceItemKey : targetItemKey,
                targetItemKey: isOutward ? targetItemKey : sourceItemKey,
                scenarioId: scenarioId,
                planId: planId
            };
            yield (0, $aNOuE.put)($djjTM.add({
                ...payload,
                itemKey: pendingKey
            }));
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: 'POST',
                body: body
            });
            if (response.ok) {
                const result = yield (0, $aNOuE.call)(response.json.bind(response));
                const { itemKey: itemKey, change: { sequence: sequence } } = result;
                yield (0, $aNOuE.put)($djjTM.add({
                    ...payload,
                    itemKey: itemKey,
                    pendingKey: pendingKey
                }));
                yield (0, $aNOuE.put)($36p1o.update(sequence));
                if (result) return result;
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: 'POST',
                    status: response.status,
                    body: body
                }
            }));
        } catch (e) {
            yield (0, $aNOuE.put)($djjTM.remove({
                ...payload,
                itemKey: pendingKey
            }));
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $bb4d40af207ebd51$export$97863425886e3651(action) {
        const { payload: { promise: promise, ...payload }, type: type } = action;
        yield (0, $aNOuE.call)($bb4d40af207ebd51$export$4884fd84d9484e78, function*() {
            return yield (0, $aNOuE.call)($bb4d40af207ebd51$export$a357c0495856cd1c, {
                type: type,
                payload: payload
            });
        }, promise, true);
    }
    function* $bb4d40af207ebd51$export$75cbe85ffa49cddc({ payload: payload }) {
        try {
            yield (0, $aNOuE.put)($djjTM.remove(payload));
            const { itemKey: itemKey } = payload;
            const { currentScenarioId: scenarioId, id: planId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
            const url = (0, $72QzS.urls).delete;
            const body = {
                itemKeys: [
                    itemKey
                ],
                scenarioId: scenarioId,
                planId: planId
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: 'POST',
                body: body
            });
            if (response.ok) {
                const result = yield (0, $aNOuE.call)(response.json.bind(response));
                const { change: { sequence: sequence } } = result;
                yield (0, $aNOuE.put)($36p1o.update(sequence));
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: 'POST',
                    status: response.status,
                    body: body
                }
            }));
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $bb4d40af207ebd51$export$4aae455a2679cf2d(action) {
        const { payload: { promise: promise, ...payload }, type: type } = action;
        yield (0, $aNOuE.call)($bb4d40af207ebd51$export$4884fd84d9484e78, function*() {
            return yield (0, $aNOuE.call)($bb4d40af207ebd51$export$75cbe85ffa49cddc, {
                type: type,
                payload: payload
            });
        }, promise);
    }
    function* $bb4d40af207ebd51$export$d69a8e11bd4b544f(entityResponse, issueId) {
        if (entityResponse.success) {
            const issueId = entityResponse.itemKey;
            const internalEntity = entityResponse.entity?.entity;
            const error = entityResponse.error;
            const warnings = yield (0, $aNOuE.call)((0, $hjabd.inspectForCommitWarnings), internalEntity, error);
            if (warnings.length) yield (0, $aNOuE.put)($ccCF0.add({
                category: (0, $TTKUQ.ENTITY).ISSUE,
                itemId: issueId,
                warnings: warnings
            }));
        } else yield (0, $aNOuE.put)($ccCF0.add({
            category: (0, $TTKUQ.ENTITY).ISSUE,
            itemId: issueId,
            warnings: [
                (0, $hjabd.defaultWarning)
            ]
        }));
    }
    function* $bb4d40af207ebd51$export$be623675b8f208ee(id) {
        const { id: planId, currentScenarioId: currentScenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const sequence = yield (0, $aNOuE.select)((0, $25viM.getSequence));
        const body = (0, $hNEap.revertBody)({
            id: planId,
            currentScenarioId: currentScenarioId
        }, sequence, id);
        const response = yield* $asXbx.json({
            url: (0, $72QzS.urls).revertChanges,
            method: 'POST',
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = response.data;
            yield (0, $aNOuE.put)($36p1o.update(sequence));
        }
        return response;
    }
    function* $bb4d40af207ebd51$export$dc8aa13c514faabe() {
        yield (0, $6u3NN.takeEvery)($bb4d40af207ebd51$export$9ece66d5710b5222, $bb4d40af207ebd51$export$97863425886e3651);
    }
    function* $bb4d40af207ebd51$export$dfe2669f36cf1dde() {
        yield (0, $6u3NN.takeEvery)($bb4d40af207ebd51$export$e447be9b24d8f55e, $bb4d40af207ebd51$export$4aae455a2679cf2d);
    }
    function* $bb4d40af207ebd51$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($bb4d40af207ebd51$export$dc8aa13c514faabe);
        yield (0, $aNOuE.fork)($bb4d40af207ebd51$export$dfe2669f36cf1dde);
    }
});
parcelRegister("25viM", function(module, exports) {
    $parcel$export(module.exports, "getReviewChanges", ()=>$23fece2d17286bae$export$3570f914f5a12111);
    $parcel$export(module.exports, "getReviewChangesCount", ()=>$23fece2d17286bae$export$26f51a34975a7739);
    $parcel$export(module.exports, "getSelectedChanges", ()=>$23fece2d17286bae$export$48659d68af0bee07);
    $parcel$export(module.exports, "getScenarioRemovedIssueChanges", ()=>$23fece2d17286bae$export$e24098b7db7b9ce5);
    $parcel$export(module.exports, "getSortedByHierarchySelectedIssues", ()=>$23fece2d17286bae$export$f47dbfe6ab1c063d);
    $parcel$export(module.exports, "getExpandedChanges", ()=>$23fece2d17286bae$export$bacc19472f5797fe);
    $parcel$export(module.exports, "getSelectedChangesCount", ()=>$23fece2d17286bae$export$422cac0bd217f0d9);
    $parcel$export(module.exports, "getIsLoading", ()=>$23fece2d17286bae$export$439d81b5ff19f64f);
    $parcel$export(module.exports, "getIsOutOfSync", ()=>$23fece2d17286bae$export$17adf6d814ca318e);
    $parcel$export(module.exports, "getIsLoaded", ()=>$23fece2d17286bae$export$c2ab4f36d4c3d60a);
    $parcel$export(module.exports, "getIsSaving", ()=>$23fece2d17286bae$export$88b3f624eba99c6);
    $parcel$export(module.exports, "getIsSavingInterrupted", ()=>$23fece2d17286bae$export$7fc970d8e872228e);
    $parcel$export(module.exports, "getCommitProgressStats", ()=>$23fece2d17286bae$export$237d8ccf3c54fe3c);
    $parcel$export(module.exports, "getIsReverting", ()=>$23fece2d17286bae$export$4bf6de41c813fc9b);
    $parcel$export(module.exports, "getIsRevertingInterrupted", ()=>$23fece2d17286bae$export$bcfae069f16c50d7);
    $parcel$export(module.exports, "getRevertProgressStats", ()=>$23fece2d17286bae$export$95a400011a937d4b);
    $parcel$export(module.exports, "getHiddenIssues", ()=>$23fece2d17286bae$export$ea11170f6eef9668);
    $parcel$export(module.exports, "getIsCommitWarningFlagClosed", ()=>$23fece2d17286bae$export$12589ad7af99a8bb);
    $parcel$export(module.exports, "getCommitWarnings", ()=>$23fece2d17286bae$export$83cd988b46c0ef8e);
    $parcel$export(module.exports, "getChangesWarnings", ()=>$23fece2d17286bae$export$df2560b98034da0f);
    $parcel$export(module.exports, "getCommittedChangesCount", ()=>$23fece2d17286bae$export$626c6d4f2ef28500);
    $parcel$export(module.exports, "getAllChangesMetaData", ()=>$23fece2d17286bae$export$2e200220fb9ff908);
    $parcel$export(module.exports, "getSortBy", ()=>$23fece2d17286bae$export$c7052c2989e7b681);
    $parcel$export(module.exports, "getSortDirection", ()=>$23fece2d17286bae$export$509e2b9937961873);
    $parcel$export(module.exports, "getSequence", ()=>$23fece2d17286bae$export$5c1e203ca018159a);
    $parcel$export(module.exports, "getFilteredReviewChanges", ()=>$23fece2d17286bae$export$246aa7c7321c7a9e);
    $parcel$export(module.exports, "getNotificationPreference", ()=>$23fece2d17286bae$export$3c3771868e06ade1);
    $parcel$export(module.exports, "getCountForStatusCategory", ()=>$23fece2d17286bae$export$d8dd3fdfde69fc2c);
    $parcel$export(module.exports, "getCountForGoals", ()=>$23fece2d17286bae$export$cb42fcdf163e8c7b);
    var $4Rr1a;
    var $fZhYM;
    var $bQZTk;
    var $bjzU8;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $hu7Cn = parcelRequire("hu7Cn");
    var $jw86H = parcelRequire("jw86H");
    var $7ppNi = parcelRequire("7ppNi");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $gFhwb = parcelRequire("gFhwb");
    var $d3quy = parcelRequire("d3quy");
    var $jpgxP = parcelRequire("jpgxP");
    var $60TfX = parcelRequire("60TfX");
    var $9FFuD = parcelRequire("9FFuD");
    var $eSUNk = parcelRequire("eSUNk");
    const $23fece2d17286bae$export$19cde3a2e3bf276a = 'out-of-sync';
    function $23fece2d17286bae$export$c1a95b573a616529(metaData, assigneeMapById = {}, dateFormat) {
        const personId = metaData.lastChangeUser;
        const person = assigneeMapById[personId];
        return {
            date: metaData.lastChangeTimestamp,
            personId: personId,
            dateFormat: dateFormat,
            ...person ? {
                title: person.jiraUser.title,
                avatarUrl: person.jiraUser.avatarUrl
            } : {}
        };
    }
    const $23fece2d17286bae$export$f0d3973db2d9f1b5 = (scenarioType, changeCount)=>{
        if (scenarioType === 'ADDED') return 'ADDED';
        if (scenarioType === 'UPDATED') {
            if (changeCount === 0) return 'NONE';
            if (changeCount === 1) return 'UPDATED';
            return 'MULTIPLE';
        }
        if (scenarioType === 'DELETED') return 'DELETED';
        return 'UNKNOWN';
    };
    const $23fece2d17286bae$export$606c6b01925e3a74 = (issueChanges, versionChanges, crossProjectVersionChanges, teamAndResourceChanges, sprintChanges, dateFormat, assigneeMapById)=>[
            ...issueChanges,
            ...versionChanges,
            ...crossProjectVersionChanges,
            ...teamAndResourceChanges,
            ...sprintChanges
        ].map(({ metaData: metaData, metaData: { scenarioType: scenarioType }, ...rest })=>({
                type: $23fece2d17286bae$export$f0d3973db2d9f1b5(scenarioType, rest.changeCount),
                lastModified: $23fece2d17286bae$export$c1a95b573a616529(metaData, assigneeMapById, dateFormat),
                ...rest
            }));
    const $23fece2d17286bae$export$3570f914f5a12111 = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getIssueChanges),
        (0, $9FFuD.getVersionChanges),
        (0, $jw86H.getCrossProjectVersionChanges),
        (0, $60TfX.getTeamAndResourceChanges),
        (0, $d3quy.getSprintChanges),
        (0, $jpgxP.getDateFormat),
        (0, $hu7Cn.getAssigneesById)
    ], $23fece2d17286bae$export$606c6b01925e3a74);
    const $23fece2d17286bae$export$26f51a34975a7739 = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getIssueChangeCount),
        (0, $9FFuD.getVersionChangeCount),
        (0, $jw86H.getCrossProjectVersionChangeCount),
        (0, $60TfX.getTeamOrResourceChangeCount),
        (0, $d3quy.getSprintChangeCount)
    ], (issueChangeCount, versionChangeCount, crossProjectVersionChangeCount, resourceChangeCount, plannedCapacityChangeCount)=>issueChangeCount + versionChangeCount + crossProjectVersionChangeCount + resourceChangeCount + plannedCapacityChangeCount);
    const $23fece2d17286bae$export$48659d68af0bee07 = (state)=>state.ui.Top.TitleBar.UpdateJira.selectedChanges;
    const $23fece2d17286bae$export$7b4bd5631415c286 = (issues, { ISSUE: selectedIssues })=>{
        const removedIssuesIds = [];
        const sortedIds = selectedIssues.reduce((selectedIssues, selectedIssueId)=>{
            const existingIssue = issues.find((issue)=>selectedIssueId === issue.id);
            if (!existingIssue) {
                removedIssuesIds.push(selectedIssueId);
                return selectedIssues;
            }
            return selectedIssues.concat(existingIssue);
        }, []).sort((issueA, issueB)=>issueB && issueA ? issueB.level - issueA.level : 0).map((issue)=>issue ? issue.id : '');
        return sortedIds.concat(removedIssuesIds);
    };
    const $23fece2d17286bae$export$ede43e961e608007 = (issues)=>issues.reduce((result, issue)=>{
            const isExcluded = issue.values.excluded;
            const issueKey = issue.issueKey;
            if (!isExcluded || !(0, $4nDwW.isDefined)(issueKey) || !(0, $4nDwW.isDefined)(issue.values.project)) return result;
            return result.concat({
                ...issue,
                issueSources: issue.issueSources || [],
                issueKey: issueKey
            });
        }, []);
    const $23fece2d17286bae$export$e24098b7db7b9ce5 = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getIssueChangesData)
    ], $23fece2d17286bae$export$ede43e961e608007);
    const $23fece2d17286bae$export$f47dbfe6ab1c063d = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getAllIssues),
        $23fece2d17286bae$export$48659d68af0bee07
    ], $23fece2d17286bae$export$7b4bd5631415c286);
    const $23fece2d17286bae$export$bacc19472f5797fe = (state)=>state.ui.Top.TitleBar.UpdateJira.expandedChanges;
    const $23fece2d17286bae$export$422cac0bd217f0d9 = (0, $3YtPS.createSelector)([
        $23fece2d17286bae$export$48659d68af0bee07
    ], (0, $4nDwW.valuesLength));
    const $23fece2d17286bae$export$439d81b5ff19f64f = ({ domain: { updateJira: { changes: { status: status } } } })=>status === (0, $230cb0d7945ed3ed$export$16250ffd632e517a) || status === (0, $230cb0d7945ed3ed$export$26d55645375ca9a);
    const $23fece2d17286bae$export$17adf6d814ca318e = ({ domain: { updateJira: { changes: { status: status, error: error } } } })=>status === (0, $230cb0d7945ed3ed$export$103bedf43ba882db) && error && error.message.error === $23fece2d17286bae$export$19cde3a2e3bf276a;
    const $23fece2d17286bae$export$c2ab4f36d4c3d60a = ({ domain: { updateJira: { changes: { status: status } } } })=>status === (0, $230cb0d7945ed3ed$export$638cc6e36b2a737a) || status === (0, $230cb0d7945ed3ed$export$103bedf43ba882db);
    const $23fece2d17286bae$export$88b3f624eba99c6 = (state)=>state.domain.updateJira.commit.inProgress;
    const $23fece2d17286bae$export$7fc970d8e872228e = (state)=>state.domain.updateJira.commit.isInterrupted;
    const $23fece2d17286bae$export$237d8ccf3c54fe3c = (state)=>state.domain.updateJira.commit.progressStats;
    const $23fece2d17286bae$export$4bf6de41c813fc9b = (state)=>state.domain.updateJira.revert.inProgress;
    const $23fece2d17286bae$export$bcfae069f16c50d7 = (state)=>state.domain.updateJira.revert.isInterrupted;
    const $23fece2d17286bae$export$95a400011a937d4b = (state)=>state.domain.updateJira.revert.progressStats;
    const $23fece2d17286bae$export$ea11170f6eef9668 = ({ domain: { updateJira: { hiddenIssues: hiddenIssues } } })=>hiddenIssues;
    const $23fece2d17286bae$export$12589ad7af99a8bb = ({ ui: { Top: { TitleBar: { UpdateJira: { isCommitWarningFlagClosed: isCommitWarningFlagClosed } } } } })=>isCommitWarningFlagClosed;
    const $23fece2d17286bae$export$83cd988b46c0ef8e = ({ domain: { updateJira: { warnings: warnings } } })=>warnings;
    const $23fece2d17286bae$export$df2560b98034da0f = ({ domain: { updateJira: { changesWarnings: changesWarnings } } })=>changesWarnings;
    const $23fece2d17286bae$export$626c6d4f2ef28500 = (state)=>state.domain.updateJira.commit.changesCommitted;
    const $23fece2d17286bae$export$8c863a326abf9497 = ({ domain: { updateJira: { changes: { data: data = {
        metaData: {
            issues: {},
            resources: {},
            teams: {},
            versions: {},
            crossProjectVersions: {},
            plannedcapacity: {},
            issueLinks: {}
        },
        issues: [],
        issueLinks: []
    } } } } })=>data.metaData.issues;
    const $23fece2d17286bae$export$2e200220fb9ff908 = (state)=>{
        const metaDataByType = (0, parcelRequire("fZhYM")).default([
            'domain',
            'updateJira',
            'changes',
            'data',
            'metaData'
        ], state) || {};
        const changes = [];
        const nestedChanges = (0, parcelRequire("bQZTk")).default((0, parcelRequire("bjzU8")).default, (0, parcelRequire("4Rr1a")).default((0, parcelRequire("bjzU8")).default))(metaDataByType);
        return changes.concat(...nestedChanges);
    };
    const $23fece2d17286bae$export$c7052c2989e7b681 = (state)=>state.ui.Top.TitleBar.UpdateJira.sortBy;
    const $23fece2d17286bae$export$509e2b9937961873 = (state)=>state.ui.Top.TitleBar.UpdateJira.sortDirection;
    const $23fece2d17286bae$export$5c1e203ca018159a = (state)=>state.domain.sequence;
    const $23fece2d17286bae$export$69250c46436353be = (changes, filter)=>filter.value.length ? changes.filter((change)=>filter.value.some((el)=>change.lastModified && el === change.lastModified.personId)) : changes;
    const $23fece2d17286bae$export$246aa7c7321c7a9e = (0, $3YtPS.createSelector)([
        $23fece2d17286bae$export$3570f914f5a12111,
        (0, $eSUNk.getUserFilter)
    ], $23fece2d17286bae$export$69250c46436353be);
    const $23fece2d17286bae$export$3c3771868e06ade1 = (state)=>state.ui.Top.TitleBar.UpdateJira.shouldNotifyWatchers;
    const $23fece2d17286bae$var$getCountForStatusCategoryPure = (issueChanges, selectedChanges, statusById)=>{
        const filteredIssues = issueChanges.filter((issue)=>{
            const selectedIssueIds = selectedChanges.ISSUE || [];
            return issue.metaData.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).UPDATED && (0, $4nDwW.isDefined)(issue?.details?.originals?.status) && selectedIssueIds.includes(`${issue.id}`);
        });
        const result = {
            TODO: 0,
            INPROGRESS: 0,
            DONE: 0,
            UNDEFINED: 0
        };
        filteredIssues.forEach((issue)=>{
            const currentStatus = issue?.details?.values?.status;
            const currentStatusCategoryId = statusById[currentStatus]?.categoryId;
            switch(Number(currentStatusCategoryId)){
                case (0, $TTKUQ.ISSUE_STATUS_CATEGORIES).TODO:
                    result.TODO++;
                    break;
                case (0, $TTKUQ.ISSUE_STATUS_CATEGORIES).INPROGRESS:
                    result.INPROGRESS++;
                    break;
                case (0, $TTKUQ.ISSUE_STATUS_CATEGORIES).DONE:
                    result.DONE++;
                    break;
                default:
                    result.UNDEFINED++;
            }
            return result;
        });
        return result;
    };
    const $23fece2d17286bae$export$d8dd3fdfde69fc2c = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getIssueChanges),
        $23fece2d17286bae$export$48659d68af0bee07,
        (0, $7ppNi.getIssueStatusById)
    ], $23fece2d17286bae$var$getCountForStatusCategoryPure);
    const $23fece2d17286bae$var$getCountGoalsPure = (issueChanges, selectedChanges)=>issueChanges.filter((issue)=>{
            const selectedIssueIds = selectedChanges.ISSUE || [];
            return issue.metaData.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).UPDATED && selectedIssueIds.includes(`${issue.id}`);
        }).reduce((goalsCount, issue)=>{
            const currentGoals = issue.details.values.goals || [];
            const previousGoals = issue.details.originals.goals || [];
            const numGoalsRemoved = previousGoals.filter((goal)=>!currentGoals.includes(goal)).length;
            const numGoalsAdded = currentGoals.filter((goal)=>!previousGoals.includes(goal)).length;
            return {
                numGoalsRemoved: goalsCount.numGoalsRemoved + numGoalsRemoved,
                numGoalsAdded: goalsCount.numGoalsAdded + numGoalsAdded
            };
        }, {
            numGoalsRemoved: 0,
            numGoalsAdded: 0
        });
    const $23fece2d17286bae$export$cb42fcdf163e8c7b = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getIssueChanges),
        $23fece2d17286bae$export$48659d68af0bee07
    ], $23fece2d17286bae$var$getCountGoalsPure);
});
const $230cb0d7945ed3ed$export$16250ffd632e517a = 'common.api.request.status.UNSENT';
const $230cb0d7945ed3ed$export$26d55645375ca9a = 'common.api.request.status.LOADING';
const $230cb0d7945ed3ed$export$638cc6e36b2a737a = 'common.api.request.status.SUCCESS';
const $230cb0d7945ed3ed$export$103bedf43ba882db = 'common.api.request.status.ERROR';
parcelRegister("60TfX", function(module, exports) {
    $parcel$export(module.exports, "getTeamOrResourceChangeCount", ()=>$f34038532f608ab0$export$d5389f30d33b6fce);
    $parcel$export(module.exports, "getDetailChange", ()=>$f34038532f608ab0$export$c00ac67fdd84eb31);
    $parcel$export(module.exports, "expandChangesForTeam", ()=>$f34038532f608ab0$export$d1dd496f4579c767);
    $parcel$export(module.exports, "getTeamAndResourceChanges", ()=>$f34038532f608ab0$export$2ae81b83b6cee86a);
    var $lV634;
    var $4Rr1a;
    var $iavfW;
    var $7p8Aa;
    var $7Zjd1;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ageG6 = parcelRequire("ageG6");
    var $bHTqr = parcelRequire("bHTqr");
    var $jeUPY = parcelRequire("jeUPY");
    var $dRVQG = parcelRequire("dRVQG");
    const $f34038532f608ab0$export$d802c22d109d9806 = (values)=>(0, parcelRequire("4Rr1a")).default((value)=>value === null ? undefined : value, values);
    const $f34038532f608ab0$export$b8ff943ec5a93e1e = (id, issueMetadata)=>{
        if (issueMetadata && issueMetadata[id]) return issueMetadata[id].scenarioType;
    };
    const $f34038532f608ab0$export$d5389f30d33b6fce = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getTeams),
        (0, $dRVQG.getOriginalTeams),
        (0, $jeUPY.getOriginalResources)
    ], (teams, originalTeams, originalResources)=>teams.reduce((total, team)=>{
            const hasResourceChange = team.resources.filter((resource)=>originalResources[resource.itemKey]).length > 0;
            const hasTeamChange = originalTeams[team.id];
            if (hasResourceChange || hasTeamChange) return total + 1;
            return total;
        }, 0));
    const $f34038532f608ab0$export$c00ac67fdd84eb31 = (change)=>{
        const teamDetails = change.details;
        const teamChange = change.category === (0, $TTKUQ.ENTITY).RESOURCE ? teamDetails.changes.find((c)=>c.attributeName === change.attributeName && c.resourceId === change.id) : teamDetails.changes.find((c)=>c.attributeName === change.attributeName);
        return teamChange;
    };
    const $f34038532f608ab0$export$505442f9000110e3 = (team)=>{
        const values = (0, parcelRequire("4Rr1a")).default((value)=>value === null ? undefined : value, (0, parcelRequire("iavfW")).default([
            'resources',
            'originals',
            'avatarUrl',
            'id',
            'shareable',
            'scenarioType',
            'externalId',
            'isPlanTeam'
        ], team));
        return values;
    };
    const $f34038532f608ab0$export$1d75af08c1b97078 = (teamValues)=>(0, parcelRequire("7p8Aa")).default((0, parcelRequire("lV634")).default, teamValues);
    const $f34038532f608ab0$export$9e7d3164d16d5531 = (attributeName, attributeValue, issueSources)=>{
        if (attributeName === 'issueSource') {
            const issueSource = (0, $bHTqr.findIssueSourceById)(issueSources, attributeValue);
            if (!issueSource) return attributeValue;
            return issueSource.title;
        }
        return attributeValue;
    };
    const $f34038532f608ab0$var$getOriginals = (originalValues, scenarioType, valueChanges)=>{
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED || scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDEDEXISTING) return (0, parcelRequire("4Rr1a")).default(()=>undefined, $f34038532f608ab0$export$1d75af08c1b97078(valueChanges));
        return $f34038532f608ab0$export$d802c22d109d9806(originalValues);
    };
    const $f34038532f608ab0$var$getScenarioTypeForTeam = (teamId, team, teamsMeta)=>{
        let scenarioType = $f34038532f608ab0$export$b8ff943ec5a93e1e(teamId, teamsMeta) || (0, $TTKUQ.SCENARIO_TYPE).NONE;
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).DELETED) scenarioType = team.shareable ? (0, $TTKUQ.SCENARIO_TYPE).EXCLUDED : scenarioType;
        else if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).UPDATED && Object.keys(team.originals).length === 0 && team.shareable) return (0, $TTKUQ.SCENARIO_TYPE).ADDEDEXISTING;
        return scenarioType;
    };
    const $f34038532f608ab0$export$ca43e2138742c6b0 = (teamsMeta, teams, originalTeams, issueSources, warnings)=>{
        const teamChangeKeys = Object.keys(teamsMeta);
        const changeDetails = {};
        teamChangeKeys.forEach((teamId)=>{
            const team = (0, $dRVQG.findTeamById)(teams, teamId);
            if (!team) return;
            const scenarioType = $f34038532f608ab0$var$getScenarioTypeForTeam(teamId, team, teamsMeta);
            const originalTeamValues = originalTeams[teamId];
            if (!scenarioType || !originalTeamValues) return;
            const valueChanges = $f34038532f608ab0$export$505442f9000110e3(team);
            const originals = $f34038532f608ab0$export$505442f9000110e3($f34038532f608ab0$var$getOriginals(originalTeamValues, scenarioType, valueChanges));
            const change = {
                id: team.id,
                changeCount: 0,
                category: (0, $TTKUQ.ENTITY).TEAM,
                type: scenarioType,
                attributeName: '',
                metaData: teamsMeta[team.id],
                warnings: warnings[teamId] || [],
                details: {
                    changes: [],
                    title: {
                        name: team.title,
                        avatarUrl: team.avatarUrl
                    }
                }
            };
            if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).DELETED || scenarioType === (0, $TTKUQ.SCENARIO_TYPE).EXCLUDED) {
                changeDetails[teamId] = change;
                return changeDetails;
            }
            for (const [originalKey, originalValue] of Object.entries(originals))if ((0, $4nDwW.isDefined)(originalValue) || (0, $4nDwW.isDefined)(valueChanges[originalKey])) change.details.changes.push({
                category: (0, $TTKUQ.ENTITY).TEAM,
                attributeName: originalKey,
                originalValue: $f34038532f608ab0$export$9e7d3164d16d5531(originalKey, originalValue, issueSources),
                currentValue: $f34038532f608ab0$export$9e7d3164d16d5531(originalKey, valueChanges[originalKey], issueSources),
                metaData: teamsMeta[team.id]
            });
            changeDetails[teamId] = change;
        });
        return changeDetails;
    };
    const $f34038532f608ab0$var$isCreated = (change)=>change.type === (0, $TTKUQ.SCENARIO_TYPE).ADDED;
    const $f34038532f608ab0$var$isAdded = (change)=>change.type === (0, $TTKUQ.SCENARIO_TYPE).ADDEDEXISTING;
    const $f34038532f608ab0$var$isDeleted = (change)=>change.type === (0, $TTKUQ.SCENARIO_TYPE).DELETED;
    const $f34038532f608ab0$var$getLatestMetaData = (change)=>{
        if (change.details.changes.length === 0) return change.metaData;
        const sortedChanges = (0, parcelRequire("7Zjd1")).default((first, second)=>(second.metaData.lastChangeTimestamp || 0) - (first.metaData.lastChangeTimestamp || 0), change.details.changes);
        return sortedChanges[0].metaData;
    };
    function $f34038532f608ab0$export$f177941d20463906(teamChangeByTeamId, resourceChangesByTeamId) {
        const mergedTeamAndResourceChanges = teamChangeByTeamId;
        Object.entries(resourceChangesByTeamId).forEach(([teamId, resourceChanges])=>{
            if (teamChangeByTeamId[teamId] && $f34038532f608ab0$var$isDeleted(teamChangeByTeamId[teamId])) return;
            const changesForResource = resourceChangesByTeamId[teamId].reduce((allChanges, current)=>{
                allChanges.push(...current.details.changes);
                return allChanges;
            }, []);
            const warningsForResource = resourceChangesByTeamId[teamId].reduce((allWarnings, current)=>{
                allWarnings.push(...current.warnings);
                return allWarnings;
            }, []);
            if (!mergedTeamAndResourceChanges[teamId]) {
                mergedTeamAndResourceChanges[teamId] = resourceChanges[0];
                mergedTeamAndResourceChanges[teamId].details.changes = changesForResource;
                mergedTeamAndResourceChanges[teamId].warnings = warningsForResource;
            } else {
                mergedTeamAndResourceChanges[teamId].details.changes.push(...changesForResource);
                mergedTeamAndResourceChanges[teamId].warnings.push(...warningsForResource);
            }
        });
        const tranformedMergedTeamAndResourceChanges = {};
        Object.entries(mergedTeamAndResourceChanges).forEach(([teamId, change])=>{
            const newChange = {
                ...change
            };
            const changeCount = newChange.details.changes.length;
            newChange.type = changeCount > 1 && !$f34038532f608ab0$var$isCreated(newChange) && !$f34038532f608ab0$var$isAdded(newChange) ? (0, $TTKUQ.SCENARIO_TYPE).MULTIPLE : newChange.type;
            newChange.attributeName = !$f34038532f608ab0$var$isAdded(newChange) ? newChange.details.changes[0]?.attributeName : undefined;
            newChange.changeCount = changeCount;
            newChange.metaData = $f34038532f608ab0$var$getLatestMetaData(change);
            tranformedMergedTeamAndResourceChanges[teamId] = newChange;
        });
        return Object.values(tranformedMergedTeamAndResourceChanges).reduce((previous, current)=>{
            previous.push(current);
            return previous;
        }, []);
    }
    function $f34038532f608ab0$export$d1dd496f4579c767(change) {
        const { category: category, lastModified: lastModified, ...rest } = change;
        return change.details.changes.map((childChange)=>({
                ...rest,
                id: childChange.category === (0, $TTKUQ.ENTITY).RESOURCE ? childChange.resourceId || '' : change.id,
                type: (0, $TTKUQ.SCENARIO_TYPE).NONE,
                category: childChange.category,
                attributeName: childChange.attributeName
            }));
    }
    const $f34038532f608ab0$export$2ae81b83b6cee86a = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getTeamChangesMetaData),
        (0, $jeUPY.getResourcesChangesMetaData),
        (0, $dRVQG.getTeams),
        (0, $dRVQG.getOriginalTeams),
        (0, $dRVQG.getCommitWarningsForTeams),
        (0, $jeUPY.getCommitWarningsForResources),
        (0, $ageG6.getPersons),
        (0, $bHTqr.getIssueSources)
    ], (teamChangesMeta, resourceChangesMeta, teams, originalTeams, commitWarnings, resourceCommitWarnings, persons, issueSources)=>{
        const teamChanges = teamChangesMeta ? $f34038532f608ab0$export$ca43e2138742c6b0(teamChangesMeta, teams, originalTeams, issueSources, commitWarnings) : {};
        const resourceChanges = resourceChangesMeta ? (0, $jeUPY.getAllChangesForResource)(teams, resourceChangesMeta, persons, resourceCommitWarnings) : {};
        return $f34038532f608ab0$export$f177941d20463906(teamChanges, resourceChanges);
    });
});
parcelRegister("jeUPY", function(module, exports) {
    $parcel$export(module.exports, "getCommitWarningsForResources", ()=>$3c6ed2c20b869620$export$1cdb006c2dfd7712);
    $parcel$export(module.exports, "getOriginalResources", ()=>$3c6ed2c20b869620$export$d894052e3f6edc60);
    $parcel$export(module.exports, "getResourcesChangesMetaData", ()=>$3c6ed2c20b869620$export$9235e6646f134b0e);
    $parcel$export(module.exports, "getAllResources", ()=>$3c6ed2c20b869620$export$5f76b3c51e55718);
    $parcel$export(module.exports, "getAllChangesForResource", ()=>$3c6ed2c20b869620$export$5f311af7e8e2bcf4);
    var $kSwbB;
    var $fZhYM;
    var $j0d94;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ageG6 = parcelRequire("ageG6");
    var $dRVQG = parcelRequire("dRVQG");
    const $3c6ed2c20b869620$export$1cdb006c2dfd7712 = ({ domain: { updateJira: { warnings: warnings } } })=>warnings[(0, $TTKUQ.ENTITY).RESOURCE];
    const $3c6ed2c20b869620$export$d894052e3f6edc60 = (state)=>state.domain.originalResources;
    const $3c6ed2c20b869620$export$9235e6646f134b0e = (state)=>(0, parcelRequire("fZhYM")).default([
            'domain',
            'updateJira',
            'changes',
            'data',
            'metaData',
            'resources'
        ], state) || {};
    const $3c6ed2c20b869620$var$getValuesForNewResource = (values)=>(0, $4nDwW.pickBy)((0, $4nDwW.isDefined), values);
    const $3c6ed2c20b869620$export$a0d4d2a74c7df9f = (teams)=>(0, parcelRequire("j0d94")).default((resources, team)=>(0, parcelRequire("kSwbB")).default(team.resources, resources), [], teams);
    const $3c6ed2c20b869620$export$5f76b3c51e55718 = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getTeams)
    ], $3c6ed2c20b869620$export$a0d4d2a74c7df9f);
    function $3c6ed2c20b869620$export$68ecbd10fca209f9(values) {
        const copiedValues = values;
        if (copiedValues.exceptions) copiedValues.exceptions = true;
        return copiedValues;
    }
    const $3c6ed2c20b869620$export$e8245c687a3091c3 = (resource, resourcesChangeMeta, team, persons, warnings)=>{
        let originals = resource.originals;
        let values = resource.values;
        const resourceId = resource.itemKey;
        const scenarioType = resource.scenarioType;
        const resourceMeta = resourcesChangeMeta[resourceId];
        const person = (0, $ageG6.getPersonByItemKey)(persons, resource.personItemKey);
        const personTitle = person && person.values.title || '';
        const change = {
            id: resourceId,
            changeCount: 0,
            category: (0, $TTKUQ.ENTITY).RESOURCE,
            type: (0, $TTKUQ.SCENARIO_TYPE).UPDATED,
            metaData: resourceMeta,
            warnings: warnings[resourceId] || [],
            details: {
                changes: [],
                title: {
                    name: team.title,
                    avatarUrl: team.avatarUrl
                }
            }
        };
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED || scenarioType === (0, $TTKUQ.SCENARIO_TYPE).DELETED) {
            const attributeName = scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED ? 'addedMember' : 'removedMember';
            const attributeValue = scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED ? personTitle : undefined;
            const attributeOriginal = scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED ? undefined : personTitle;
            values = {
                [attributeName]: attributeValue,
                ...values
            };
            originals = {
                [attributeName]: attributeOriginal,
                ...originals
            };
        }
        values = $3c6ed2c20b869620$export$68ecbd10fca209f9(values);
        let changedAttributes = [];
        if (scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED) {
            originals = {};
            values = $3c6ed2c20b869620$var$getValuesForNewResource(values);
            changedAttributes = Object.keys(values);
        } else {
            originals = $3c6ed2c20b869620$export$68ecbd10fca209f9(originals);
            changedAttributes = Object.keys(originals);
        }
        change.details.changes = changedAttributes.map((attributeName)=>({
                category: (0, $TTKUQ.ENTITY).RESOURCE,
                attributeName: attributeName,
                originalValue: originals[attributeName],
                currentValue: values[attributeName],
                resourceId: resourceId,
                personTitle: personTitle,
                metaData: resourceMeta
            }));
        return change;
    };
    const $3c6ed2c20b869620$export$5f311af7e8e2bcf4 = (teams, resourceChangeMeta, persons, warnings)=>{
        const changes = {};
        Object.entries(resourceChangeMeta).forEach(([resourceKey])=>{
            const team = (0, $dRVQG.findTeamAssociatedWithResource)(teams, resourceKey);
            if (!team) return;
            const resource = (0, $dRVQG.findResourceFromTeam)(team, resourceKey);
            if (!resource) return false;
            const resourceChange = $3c6ed2c20b869620$export$e8245c687a3091c3(resource, resourceChangeMeta, team, persons, warnings);
            const resourceChangesForTeam = changes[team.id];
            if (resourceChangesForTeam) resourceChangesForTeam.push(resourceChange);
            else changes[team.id] = [
                resourceChange
            ];
        });
        return changes;
    };
});
parcelRegister("eSUNk", function(module, exports) {
    $parcel$export(module.exports, "getUserFilter", ()=>$b7ba6236f37cdd67$export$5c99253b524db68f);
    var $ccIrM = parcelRequire("ccIrM");
    const $b7ba6236f37cdd67$export$5c99253b524db68f = (state)=>state.ui.Top.TitleBar.UpdateJira.filters[0, $ccIrM.USER_FILTER_ID];
});
parcelRegister("ccIrM", function(module, exports) {
    $parcel$export(module.exports, "USER_FILTER_ID", ()=>$5a153b61a4c5a46b$export$f3f93134ef6dbcd6);
    $parcel$export(module.exports, "QuickSelectOption", ()=>$5a153b61a4c5a46b$export$72fea0ffa8da318d);
    const $5a153b61a4c5a46b$export$f3f93134ef6dbcd6 = 'USER_FILTER_ID';
    const $5a153b61a4c5a46b$export$72fea0ffa8da318d = {
        MINE: 'MINE',
        TODAY: 'TODAY',
        TIMELINE: 'TIMELINE',
        NONE: 'NONE'
    };
});
parcelRegister("djjTM", function(module, exports) {
    $parcel$export(module.exports, "ADD", ()=>$8447736bf032549a$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "REMOVE", ()=>$8447736bf032549a$export$29d55e1f664a246b);
    $parcel$export(module.exports, "RESET", ()=>$8447736bf032549a$export$4a991c87e640ef77);
    $parcel$export(module.exports, "add", ()=>$8447736bf032549a$export$e16d8520af44a096);
    $parcel$export(module.exports, "remove", ()=>$8447736bf032549a$export$cd7f480d6b8286c3);
    $parcel$export(module.exports, "reset", ()=>$8447736bf032549a$export$aad8462122ac592b);
    const $8447736bf032549a$export$bb6389024b71c2ae = 'state.domain.issue-links.ADD';
    const $8447736bf032549a$export$29d55e1f664a246b = 'state.domain.issue-links.REMOVE';
    const $8447736bf032549a$export$4a991c87e640ef77 = 'state.domain.issue-links.RESET';
    const $8447736bf032549a$export$e16d8520af44a096 = (payload)=>({
            type: $8447736bf032549a$export$bb6389024b71c2ae,
            payload: payload
        });
    const $8447736bf032549a$export$cd7f480d6b8286c3 = (payload)=>({
            type: $8447736bf032549a$export$29d55e1f664a246b,
            payload: payload
        });
    const $8447736bf032549a$export$aad8462122ac592b = (payload)=>({
            type: $8447736bf032549a$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("72QzS", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$43f4cee1c3ef2a74$export$bcae9ba627f604b6);
    const $43f4cee1c3ef2a74$export$bcae9ba627f604b6 = {
        add: '/rest/jpo/1.0/issuelink/add',
        delete: '/rest/jpo/1.0/issuelink/delete',
        revertChanges: '/rest/jpo/1.0/issuelink/revert'
    };
});
parcelRegister("8DvwL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cf6f2ee99a7bfffb$export$2e2bcd8739ae039);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $8QpSo;
    var $2JlG5;
    var $4R6GH;
    var $g4tDr;
    var $1CGdp = parcelRequire("1CGdp");
    var $hu7Cn = parcelRequire("hu7Cn");
    var $fKdeq = parcelRequire("fKdeq");
    var $ddv1K = parcelRequire("ddv1K");
    var $aDKIU = parcelRequire("aDKIU");
    var $7ppNi = parcelRequire("7ppNi");
    var $kllqP = parcelRequire("kllqP");
    var $kqF3Q = parcelRequire("kqF3Q");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $jLI87 = parcelRequire("jLI87");
    var $kWDpn = parcelRequire("kWDpn");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $cf6f2ee99a7bfffb$var$preprocess = (0, $3YtPS.createStructuredSelector)({
        assigneesById: (0, $hu7Cn.getAssigneesById),
        externalIssues: (0, $fKdeq.getExternalIssues),
        issues: (0, $gFhwb.getIssues),
        issueLinkTypes: (0, $ddv1K.getDependencyIssueLinkTypes),
        issueCountByLinkType: (0, $ddv1K.getIssueCountByLinkType),
        issueStatusById: (0, $7ppNi.getIssueStatusById),
        issueTypes: (0, $kllqP.getIssueTypes),
        mode: (0, $1CGdp.getMode),
        projectsById: (0, $jpXKt.getProjectsById),
        isOptimizedMode: $1CGdp.isOptimizedMode,
        issuesWithOptimizedById: (0, $jLI87.getAllIssuesWithOriginalAndOptimizedById),
        syncStartEnabled: (0, $bHTqr.getSyncStartEnabled),
        dependencyViewSettings: (0, $kWDpn.getDependencySettings)
    });
    const $cf6f2ee99a7bfffb$var$preprocessMemoized = ()=>(0, $dGvGJ.createSelector)($cf6f2ee99a7bfffb$var$preprocess, (res)=>res);
    const $cf6f2ee99a7bfffb$var$mapStateToPropsFactory = ()=>{
        const preprocessInstance = $cf6f2ee99a7bfffb$var$preprocessMemoized();
        const missingExternalIssuesFactory = (0, (0, parcelRequire("8QpSo")).default)((externalIssueLinks, otherIssueKey, externalIssues)=>(0, (0, parcelRequire("4R6GH")).fg)('fix_external_issue_link_for_scenario_issue_removal') ? externalIssueLinks.map((link)=>link[otherIssueKey]).filter((issueId)=>!(0, parcelRequire("2JlG5")).default(issueId, externalIssues)).filter((issueId)=>!issueId.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX))) : externalIssueLinks.map((link)=>link[otherIssueKey]).filter((issueId)=>!(0, parcelRequire("2JlG5")).default(issueId, externalIssues)));
        const externalRowsFactory = (0, (0, parcelRequire("8QpSo")).default)((missingExternalIssues, externalIssues, otherIssueKey, externalIssueLinks, issueLinkTypes, direction, issuesWithOptimizedById, originalIssueId, statePropsIsOptimizedMode, issueStatusById, syncStartEnabled)=>missingExternalIssues.length > 0 ? [] : (0, $4nDwW.filterMap)((link)=>!!externalIssues[link[otherIssueKey]], (link)=>{
                let isOverlapping = false;
                const { itemKey: itemKey, type: typeId } = link;
                const type = issueLinkTypes.find(({ id: id })=>id === typeId);
                if (!type) throw new Error('Unknown issue link type!');
                const issue = externalIssues[link[otherIssueKey]];
                if (!issue) throw new Error('Unplanned issue!');
                let leadTime;
                if (direction === (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD) {
                    const sourceIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], statePropsIsOptimizedMode);
                    const targetIssue = externalIssues[issue.id];
                    leadTime = (0, $aDKIU.getIssueLinkLeadTime)(sourceIssue, targetIssue);
                    isOverlapping = (0, $aDKIU.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
                } else {
                    const sourceIssue = externalIssues[issue.id];
                    const targetIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], statePropsIsOptimizedMode);
                    leadTime = (0, $aDKIU.getIssueLinkLeadTime)(sourceIssue, targetIssue);
                    isOverlapping = (0, $aDKIU.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
                }
                return {
                    assignee: {
                        personId: issue.userId,
                        jiraUser: {
                            avatarUrl: issue.userAvatarUrl,
                            title: issue.userTitle,
                            accountId: issue.userId,
                            email: ''
                        }
                    },
                    isOverlapping: isOverlapping,
                    isChanged: false,
                    issue: issue,
                    issueType: {
                        id: issue.typeId,
                        iconUrl: issue.typeIconUrl,
                        name: '',
                        level: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE)
                    },
                    itemKey: itemKey,
                    leadTime: leadTime,
                    projectKey: issue.projectKey,
                    status: {
                        id: issue.statusId,
                        categoryId: issue.statusCategoryId,
                        name: issue.statusName
                    },
                    syncStartEnabled: syncStartEnabled,
                    type: type
                };
            }, externalIssueLinks));
        const internalRowsFactory = (0, (0, parcelRequire("8QpSo")).default)((internalIssueLinks, issueLinkTypes, issuesWithOptimizedById, direction, issueTypes, projectsById, originalIssueId, statePropsIsOptimizedMode, issueStatusById, syncStartEnabled, assigneesById, internalOriginalIssueLinks)=>internalIssueLinks.map(({ itemKey: itemKey, type: typeId, sourceItemKey: sourceItemKey, targetItemKey: targetItemKey })=>{
                const type = issueLinkTypes.find(({ id: id })=>id === typeId);
                if (!type) throw new Error('Unknown issue link type!');
                const issue = issuesWithOptimizedById[direction === 'outward' ? targetItemKey : sourceItemKey];
                if (!issue) throw new Error('Unplanned issue!');
                const issueType = issueTypes.find(({ id: id })=>id === issue.type);
                if (!issueType) throw new Error('Unknown issue type!');
                const project = projectsById[issue.project];
                if (!project) throw new Error('Unknown project!');
                let leadTime;
                let isOverlapping = false;
                if (direction === (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD) {
                    const sourceIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], statePropsIsOptimizedMode);
                    const targetIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], statePropsIsOptimizedMode);
                    leadTime = (0, $aDKIU.getIssueLinkLeadTime)(sourceIssue, targetIssue);
                    isOverlapping = (0, $aDKIU.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
                } else {
                    const sourceIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], statePropsIsOptimizedMode);
                    const targetIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], statePropsIsOptimizedMode);
                    isOverlapping = (0, $aDKIU.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
                    leadTime = (0, $aDKIU.getIssueLinkLeadTime)(sourceIssue, targetIssue);
                }
                return {
                    assignee: assigneesById[issue.assignee],
                    isChanged: !internalOriginalIssueLinks.some((link)=>link.itemKey === itemKey),
                    issue: issue,
                    issueType: issueType,
                    itemKey: itemKey,
                    leadTime: leadTime,
                    projectKey: project.key,
                    status: issueStatusById[issue.status || ''],
                    syncStartEnabled: syncStartEnabled,
                    type: type,
                    isOverlapping: isOverlapping
                };
            }));
        return (state, { direction: direction, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, internalOriginalIssueLinks: internalOriginalIssueLinks, issue: issue })=>{
            const { assigneesById: assigneesById, externalIssues: externalIssues, issues: issues, issueLinkTypes: issueLinkTypes, issueStatusById: issueStatusById, issueTypes: issueTypes, mode: mode, projectsById: projectsById, isOptimizedMode: isOptimizedMode, issuesWithOptimizedById: issuesWithOptimizedById, syncStartEnabled: syncStartEnabled, issueCountByLinkType: issueCountByLinkType, dependencyViewSettings: dependencyViewSettings } = preprocessInstance(state);
            const { id: originalIssueId } = issue;
            const otherIssueKey = direction === 'outward' ? 'targetItemKey' : 'sourceItemKey';
            const missingExternalIssues = missingExternalIssuesFactory(externalIssueLinks, otherIssueKey, externalIssues);
            const externalRows = externalRowsFactory(missingExternalIssues, externalIssues, otherIssueKey, externalIssueLinks, issueLinkTypes, direction, issuesWithOptimizedById, originalIssueId, isOptimizedMode, issueStatusById, syncStartEnabled);
            const internalRows = internalRowsFactory(internalIssueLinks, issueLinkTypes, issuesWithOptimizedById, direction, issueTypes, projectsById, originalIssueId, isOptimizedMode, issueStatusById, syncStartEnabled, assigneesById, internalOriginalIssueLinks);
            return {
                dependencyViewSettings: dependencyViewSettings,
                externalRows: externalRows,
                internalRows: internalRows,
                isReadOnly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
                issues: issues,
                issueLinkTypes: issueLinkTypes,
                issueCountByLinkType: issueCountByLinkType,
                issueTypes: issueTypes,
                missingExternalIssues: missingExternalIssues,
                projectsById: projectsById
            };
        };
    };
    const $cf6f2ee99a7bfffb$var$mapStateToProps = $cf6f2ee99a7bfffb$var$mapStateToPropsFactory;
    var $cf6f2ee99a7bfffb$export$2e2bcd8739ae039 = $cf6f2ee99a7bfffb$var$mapStateToProps;
});
parcelRegister("4MXLk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b74415ad56b5c9b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $j0d94;
    var $994MI;
    var $cb25w;
    var $bTqXB;
    var $4R6GH;
    var $ousew;
    var $aCpcO;
    var $enoTt;
    var $i2qlb = parcelRequire("i2qlb");
    var $cGbfF = parcelRequire("cGbfF");
    var $ixSW4 = parcelRequire("ixSW4");
    var $kC16r = parcelRequire("kC16r");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $8zOmE;
    var $isuse;
    var $cy3yY = parcelRequire("cy3yY");
    var $aULOu = parcelRequire("aULOu");
    var $cXSJc = parcelRequire("cXSJc");
    var $gO02F = parcelRequire("gO02F");
    var $cvcFu = parcelRequire("cvcFu");
    var $eJ0an = parcelRequire("eJ0an");
    var $3fpOS = parcelRequire("3fpOS");
    var $9SU3m = parcelRequire("9SU3m");
    var $a5H4V = parcelRequire("a5H4V");
    class $b74415ad56b5c9b9$var$DependenciesFlyout extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { loadExternalIssues: loadExternalIssues, missingExternalIssues: missingExternalIssues } = this.props;
            if (missingExternalIssues.length > 0) loadExternalIssues(missingExternalIssues);
        }
        render() {
            const { addDependency: addDependency, context: context, direction: direction, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, internalRows: internalRows, isReadOnly: isReadOnly, issue: issue, issueLinkTypes: issueLinkTypes, issueCountByLinkType: issueCountByLinkType, issueTypes: issueTypes, issues: issues, missingExternalIssues: missingExternalIssues, projectsById: projectsById, updatePopup: updatePopup } = this.props;
            const addDependencyProps = {
                addDependency: addDependency,
                context: context,
                issueCountByLinkType: issueCountByLinkType,
                direction: direction,
                isInitiallyAddingNewDependency: this.getRowsCount() === 0 && missingExternalIssues.length === 0,
                issue: issue,
                issueLinkTypes: issueLinkTypes,
                internalIssueLinks: internalIssueLinks,
                issueTypes: issueTypes,
                issues: issues,
                projectsById: projectsById,
                updatePopup: updatePopup
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
                onMount: this.fireViewDependencyFlyOutAnalyticsEvent
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("table", {
                className: $a5H4V.table
            }, this.getRowsCount() > 0 || missingExternalIssues.length > 0 ? this.renderHeader() : null, (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", null, internalRows.map((row)=>this.renderRow(row)), (0, (0, parcelRequire("4R6GH")).fg)('fix_external_issue_link_for_scenario_issue_removal') ? this.renderExternalDependencies() : externalIssueLinks.length > 0 ? this.renderExternalDependencies() : null)), !isReadOnly ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cy3yY.default), addDependencyProps) : null, !addDependencyProps.isInitiallyAddingNewDependency && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $a5H4V.footerActions
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, this.quickFilter(), !isReadOnly && this.renderFilterDependencyGraphFromRoadmapLink()), this.toggleDependencyViewButton()));
        }
        constructor(...args){
            super(...args);
            this.fireViewDependencyFlyOutAnalyticsEvent = (analyticsEvent)=>{
                const { context: context, externalRows: externalRows, internalRows: internalRows } = this.props;
                const conflictCount = (0, parcelRequire("j0d94")).default((acc, row)=>row.leadTime && row.leadTime < 0 ? acc + 1 : acc, 0, internalRows.concat(externalRows));
                let analyticsKey = '';
                if (context === 'dropdown') analyticsKey = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).OPENED_DEPENDENCY_FLYOUT_FROM_DROPDOWN;
                else if (context === 'badge') analyticsKey = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).OPENED_DEPENDENCY_FLYOUT_FROM_BADGE;
                if (analyticsKey) {
                    const [actionSubject, eventAction] = analyticsKey.split(' ');
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                        action: eventAction,
                        actionSubject: actionSubject
                    }), analyticsKey, {
                        conflictCount: conflictCount
                    });
                }
            };
            this.onRemoveDependency = ({ itemKey: itemKey, issue: { id: id }, type: type })=>(e)=>{
                    e.preventDefault();
                    const { removeDependency: removeDependency, issue: issue, direction: direction } = this.props;
                    removeDependency({
                        itemKey: itemKey,
                        sourceItemKey: direction === (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD ? issue.id : id,
                        targetItemKey: direction === (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD ? id : issue.id,
                        type: type.id
                    });
                };
            this.renderRow = (row, isReadOnly = this.props.isReadOnly)=>{
                const { direction: direction } = this.props;
                const { isChanged: isChanged, issue: issue, type: type, projectKey: projectKey } = row;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    key: `${type.id}:${issue.id}`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    className: $a5H4V["change-indicator"]
                }, isChanged && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kC16r.default), {
                    appearance: "bar"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    className: $a5H4V.typeCell
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3fpOS.default), {
                    row: row,
                    direction: direction
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cXSJc.default), {
                    row: row
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eJ0an.default), {
                    row: row
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    className: $a5H4V.assigneeCell
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aULOu.default), {
                    row: row
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $gO02F.default), {
                    row: row
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, !isReadOnly ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cvcFu.default), {
                    issueKey: issue.issueKey,
                    projectKey: projectKey,
                    onClick: this.onRemoveDependency(row),
                    updatePopup: this.props.updatePopup
                }) : null));
            };
            this.renderHeader = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("thead", null, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("th", null), (0, ($parcel$interopDefault($5uXOq))).createElement("th", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9SU3m.default).typeHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement("th", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9SU3m.default).issueHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement("th", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9SU3m.default).statusHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement("th", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).assignee)), (0, ($parcel$interopDefault($5uXOq))).createElement("th", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9SU3m.default).leadTimeHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement("th", null)));
            this.renderExternalDependencies = ()=>{
                const { externalRows: externalRows, missingExternalIssues: missingExternalIssues } = this.props;
                if (missingExternalIssues.length === 0 && externalRows.length === 0 && (0, (0, parcelRequire("4R6GH")).fg)('fix_external_issue_link_for_scenario_issue_removal')) return null;
                const header = (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 6,
                    className: $a5H4V.externalDependenciesHeader
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9SU3m.default).externalDependenciesHeader)));
                let content = null;
                if (missingExternalIssues.length > 0) content = (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 6
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), {
                    size: "small",
                    delay: 0
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    style: {
                        paddingLeft: "var(--ds-space-150, 12px)"
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).loadingIssuesMessage))));
                else content = externalRows.map((row)=>this.renderRow(row, true));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, header, content);
            };
            this.getRowsCount = ()=>this.props.externalRows.length + this.props.internalRows.length;
            this.quickFilter = ()=>{
                const { issue: issue, projectsById: projectsById, QuickFilter: QuickFilter } = this.props;
                const issueKey = issue.issueKey ? `${projectsById[issue.project].key}-${issue.issueKey}` : 'ScenarioIssue';
                return (0, ($parcel$interopDefault($5uXOq))).createElement(QuickFilter, {
                    value: {
                        id: (0, $cGbfF.DEPENDENCIES_FILTER_ID),
                        value: {
                            type: 'specificIssue',
                            issueId: issue.id,
                            includeTransitive: false
                        }
                    },
                    clearable: true,
                    clearText: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $a5H4V["remove-filter"]
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bTqXB"))))), {
                        label: ""
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                        ...(0, $9SU3m.default).removeQuickFilterText,
                        values: {
                            issueKey: issueKey
                        }
                    }))
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, $9SU3m.default).addQuickFilterText,
                    values: {
                        issueKey: issueKey
                    }
                }));
            };
            this.handleToggleDependencyView = (_, analyticsEvent)=>{
                const { changeDependencySettingsDisplay: changeDependencySettingsDisplay, dependencyViewSettings: dependencyViewSettings } = this.props;
                const { display: display } = dependencyViewSettings;
                const nextSetting = display === (0, $TTKUQ.LINES) ? (0, $TTKUQ.DEFAULT) : (0, $TTKUQ.LINES);
                changeDependencySettingsDisplay({
                    display: nextSetting
                });
                const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATED_DEPENDENCY_STYLE.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: eventAction,
                    actionSubject: actionSubject
                }), {
                    dependencyStyle: nextSetting
                });
            };
            this.toggleDependencyViewButton = ()=>{
                const { dependencyViewSettings: dependencyViewSettings } = this.props;
                const { display: display } = dependencyViewSettings;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: this.handleToggleDependencyView
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, $9SU3m.default).toggleDependencyViewButton,
                    values: {
                        value: display
                    }
                }));
            };
            this.renderFilterDependencyGraphFromRoadmapLink = ()=>{
                const { issue: issue, projectsById: projectsById, FilterDependencyGraphFromRoadmap: FilterDependencyGraphFromRoadmap } = this.props;
                const issueKey = issue.issueKey ? `${projectsById[issue.project].key}-${issue.issueKey}` : 'ScenarioIssue';
                return (0, ($parcel$interopDefault($5uXOq))).createElement(FilterDependencyGraphFromRoadmap, {
                    issueId: issue.id
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, $9SU3m.default).visualizeDependencies,
                    values: {
                        issueKey: issueKey
                    }
                }));
            };
        }
    }
    var $b74415ad56b5c9b9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        source: 'dependenciesFlyoutDialog'
    })((0, (0, parcelRequire("cb25w")).default)()((0, $ixSW4.withSlots)({
        FilterDependencyGraphFromRoadmap: (0, $ixSW4.slots).FilterDependencyGraphFromRoadmap,
        QuickFilter: (0, $ixSW4.slots).QuickFilter
    })($b74415ad56b5c9b9$var$DependenciesFlyout)));
});
parcelRegister("enoTt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e115c1fcbd1d39a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fNobW;
    var $eZJjh;
    function $e115c1fcbd1d39a5$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), props));
    }
});
parcelRegister("i2qlb", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_ANALYTICS_EVENT_NAMES", ()=>$611531c2ab5d9a92$export$284d34b1b34fb96d);
    const $611531c2ab5d9a92$export$284d34b1b34fb96d = {
        ISSUE_SEARCH_ICON_CLICK: 'jiraPortfolio3IssueSearch searchIconClick',
        ISSUE_SEARCH_STARTED_SEARCH_RESULT_NAVIGATION: 'jiraPortfolio3IssueSearch startedSearchResultsNavigation',
        REPARENT_ISSUES: 'issues reparented',
        REVERT_SCENARIO: 'scenarioChanges reverted',
        SELECT_TIMELINE_RANGE: 'timelineOption selectTimelineRange',
        SHARE_REPORT: 'report shared',
        UPDATE_ISSUE: 'issue updated',
        UPDATE_ISSUES: 'issues updated',
        UPDATE_FILTER: 'filters updated',
        CLEAR_FILTERS: 'filters cleared',
        UPDATED_DEPENDENCIES_FILTER: 'dependenciesFilter updated',
        UPDATED_ISSUE_PRIORITIES_FILTER: 'issuePrioritiesFilter updated',
        UPDATED_DEPENDENCY_STYLE: 'dependencyStyle updated',
        SET_ACTIVE_VIEW: 'activeView changed',
        SAVE_VIEW: 'view saved',
        ADD_VIEW: 'view added',
        RESET_VIEWS: 'view reset',
        HIDE_COLUMN: 'column hidden',
        SHOW_COLUMN: 'column shown',
        MOVE_COLUMN: 'column moved',
        MARK_AS_DEFAULT_VIEW: 'view defaulted',
        CLICKED_DEPENDENCY_TAB: 'dependencyTab clicked',
        VIEWED_DEPENDENCY_TAB: 'dependencyTab viewed',
        CLICKED_DEPENDENCY_CARD: 'dependencyCard clicked',
        CLICKED_DEPENDENCY_LINE: 'dependencyLink clicked',
        UPDATED_DEPENDENCY_ROLLUP_DROPDOWN: 'dependencyRollupDropDown updated',
        UPDATED_DEPENDENCY_GROUP_DROPDOWN: 'dependencyGroupDropDown updated',
        UPDATED_DEPENDENCY_ISSUE_FILTER: 'dependencyIssueFilter updated',
        UPDATED_DEPENDENCY_PROJECT_FILTER: 'dependencyProjectFilter updated',
        UPDATED_DEPENDENCY_ISSUE_LINK_TYPE_FILTER: 'dependencyIssueLinkTypeFilter updated',
        UPDATED_DEPENDENCY_SPRINT_FILTER: 'dependencySprintFilter updated',
        CLICKED_EXPORT_TO_CSV: 'exportToCsv clicked',
        OPENED_WARNING_CENTER: 'warningCenter opened',
        FILTERED_WARNING_TYPE: 'warningAffectsLink clicked',
        LOCATED_WARNING_ISSUE_ITEM: 'warningIssueItem clicked',
        TOGGLED_WARNING_FILTER: 'warningsFilterSwitch clicked',
        TOGGLED_WARNING_TYPE: 'warningTypeToggle clicked',
        OPENED_DEPENDENCY_FLYOUT_FROM_DROPDOWN: 'dependencyFlyOut openedFromDropdown',
        OPENED_DEPENDENCY_FLYOUT_FROM_BADGE: 'dependencyFlyOut openedFromBadge',
        EXPANDED_ALL_ISSUES: 'expandAllIssues clicked',
        COLLAPSED_ALL_ISSUES: 'collapseAllIssues clicked',
        ADDED_ISSUE_DEPENDENCY_LINK: 'issueDependencyLink added',
        DELETED_ISSUE_DEPENDENCY_LINK: 'issueDependencyLink deleted',
        SWAPPED_ISSUE_DEPENDENCY_LINK: 'issueDependencyLink swapped',
        CREATED_ISSUE_FROM_HEADER: 'createIssueFromHeader clicked',
        CREATED_ISSUE_INLINE: 'createIssueInline clicked',
        OPENED_ISSUE_SUMMARY: 'issueSummary opened',
        UPDATED_ISSUE_SUMMARY: 'issueSummary updated',
        CANCELLED_ISSUE_SUMMARY: 'issueSummary cancelled',
        CLICKED_ISSUE_SUMMARY_BUTTON: 'issueSummaryButton clicked',
        CLICKED_SELECT_ISSUES: 'selectIssues clicked',
        CLICKED_CANCEL_OPTIMIZATION: 'cancelOptimization clicked',
        CLICKED_ACCEPT_OPTIMIZATION: 'acceptOptimization clicked',
        CLICKED_FULL_SCREEN_TIMELINE_BUTTON: 'fullScreenTimelineBtn clicked',
        BULK_ACTIONS_CLICKED: 'bulkActions clicked',
        BULK_ACTIONS_OPTION_SELECTED: 'bulkActions optionSelected',
        BULK_ACTIONS_ACTION_SUCCEEDED: 'bulkActions actionSucceeded',
        OPENED_SPRINT_FLYOUT: 'sprintFlyout opened',
        OPENED_RELEASES_FLYOUT: 'releasesFlyout opened',
        VIEWED_SPRINT_IN_JIRA: 'sprintInJira viewed',
        VIEWED_SPRINT_REPORT_IN_JIRA: 'sprintReportInJira viewed',
        APPLIED_SPRINT_FILER_FROM_FLYOUT: 'sprintFilterFromSprintFlyout applied',
        SPRINT_CAPACITY_EDITED: 'sprintCapacity edited',
        SPRINT_VELOCITY_CHART_VIEWED: 'velocityChartInJira viewed',
        TEAM_IS_SHARED: 'team shared',
        ATLAS_TEAM_CREATED: 'atlasTeam created',
        ATLAS_TEAM_ADDED: 'atlasTeam added',
        PRIVATE_TEAM_CREATED: 'privateTeam created',
        EXPAND_TOOL_BAR: 'expandToolBar clicked',
        COLLAPSE_TOOL_BAR: 'collapseToolBar clicked',
        START_EDIT_DESCRIPTION: 'descriptionEditor activated',
        CANCEL_EDIT_DESCRIPTION: 'descriptionEditor deactivated',
        SAVE_DESCRIPTION: 'descriptionEditor saved',
        ALIGN_RELEASE_DATES_IN_CPR: 'alignDatesOfReleasesInCrossProjectRelease clicked',
        VIEW_RELEASE_IN_ROADMAP: 'viewReleaseInRoadmap clicked',
        ADD_RELEASE_TO_CPR: 'addReleaseToCrossProjectRelease clicked',
        CONFIGURABLE_DATE_CHANGED: 'configurableDate changed',
        CUSTOM_CONFIGURABLE_DATE_USED: 'customConfigurableDate used',
        NO_CUSTOM_CONFIGURABLE_DATES_USED: 'noCustomConfigurableDates used',
        FILTERED_RELEASES_TAB: 'releasesTab filtered',
        INFERRED_DATE_SELECTION_CHANGED: 'inferredDateSelection changed',
        HEADER_HELP_LINK_CLICKED: 'headerHelpLink clicked',
        SAVE_SELECTED_CHANGES_IN_JIRA_CLICKED: 'saveSelectedChangesInJira clicked',
        DISCARD_SELECTED_CHANGES_CLICKED: 'discardSelectedChanges clicked',
        REVIEW_CHANGES_MODAL_CANCEL_CLICKED: 'cancel clicked',
        INLINE_DIALOG_VIEWED: 'inlineDialog viewed',
        REVIEW_CHANGES_MODAL_QUICK_SELECT_CLICKED: 'reviewChangesQuickSelect clicked',
        REVIEW_CHANGES_MODAL_USER_FILTER_CHANGED: 'reviewChangesUserFilter changed',
        EXPAND_SCOPE_GROUP: 'expandScopeGroup clicked',
        COLLAPSE_SCOPE_GROUP: 'collapseScopeGroup clicked',
        EXPAND_SCOPE_ITEM: 'expandScopeItem clicked',
        COLLAPSE_SCOPE_ITEM: 'collapseScopeItem clicked',
        CLOSE_UNSAVED_CHANGES_SPOTLIGHT: 'closeUnsavedChangesSpotlight clicked',
        AI_SUGGEST_CHILD_ISSUES: 'aiSuggestChildIssues clicked',
        TEAM_DIALOG_OPEN: 'teamDialog opened',
        TEAM_DIALOG_CLOSE: 'teamDialog closed',
        TEAM_DIALOG_SUBMIT: 'teamDialog submitted',
        CLICKED_ISSUE_MORE_ACTIONS_MENU: 'issueMoreActionsMenu clicked',
        COLOR_BY_CLICKED: 'dropdownItem clicked colorBy',
        SORT_BY_CLICKED: 'dropdownItem clicked sortBy',
        GROUP_BY_CLICKED: 'dropdownItem clicked groupBy',
        SHOW_CAPACITY_ON_TIMELINE_CHANGED: 'checkbox changed showCapacityOnTimeline',
        DEPENDENCY_TYPE_CLICKED: 'dropdownItem changed dependencyStyle',
        ROLL_UP_DATES_CHANGED: 'checkbox changed rollUpDates',
        ROLL_UP_OTHERS_CHANGED: 'checkbox changed rollUpOthers',
        EXPORT_PNG_CHANGE_TIMELINE_WIDTH: 'button clicked exportPngTimelineWidth',
        EXPORT_PNG_MODAL_CLOSED: 'modal closed exportPng',
        EXPORT_CSV_MODAL_CLOSED: 'modal closed exportCsv',
        CALCULATE_PLAN: 'plan calculated',
        DELETE_PLAN: 'plan deleted',
        STAR_PLAN: 'plan starred',
        UNSTAR_PLAN: 'plan unstarred',
        CREATE_CROSS_PROJECT_RELEASE: 'crossProjectRelease created',
        REPARENT_ISSUE: 'issue reparented',
        UPDATE_JIRA: 'changes updatedInJira',
        ADD_ISSUE: 'issue added',
        RANK_ISSUE: 'issue ranked',
        PLAN_EXPORTED: 'plan exported',
        ADD_LABEL: 'label added',
        RESET_BACKLOG: 'backlog reset',
        COMMIT_MODAL_LOADED_CHANGES: 'commitModal loadedChanges',
        COMMIT_MODAL_SCROLLED: 'commitModal scrolled',
        TIMELINE_VERTICAL_SCROLLED: 'timelineVerticalScrollPerformance measured'
    };
});
parcelRegister("cy3yY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1513a4a5416fd56f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $aCpcO;
    var $i2qlb = parcelRequire("i2qlb");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8zOmE;
    var $lhWbF = parcelRequire("lhWbF");
    var $fQJAe = parcelRequire("fQJAe");
    class $1513a4a5416fd56f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { addDependencyIssue: addDependencyIssue, addDependencyType: addDependencyType, isAddingNewDependency: isAddingNewDependency } = this.state;
            if (!isAddingNewDependency) return this.renderAddDependencyButton();
            const { direction: direction, issue: issue, issueLinkTypes: issueLinkTypes, internalIssueLinks: internalIssueLinks, issueTypes: issueTypes, issues: issues, projectsById: projectsById, isInitiallyAddingNewDependency: isInitiallyAddingNewDependency } = this.props;
            const dependencySelectorProps = {
                addDependencyIssue: addDependencyIssue,
                addDependencyType: addDependencyType,
                direction: direction,
                issue: issue,
                issueLinkTypes: issueLinkTypes,
                internalIssueLinks: internalIssueLinks,
                issueTypes: issueTypes,
                issues: issues,
                onAddDependencyCancel: this.onAddDependencyCancel,
                onAddDependencyConfirm: this.onAddDependencyConfirm,
                onChangeDependencyIssue: this.onChangeDependencyIssue,
                onChangeDependencyType: this.onChangeDependencyType,
                projectsById: projectsById,
                isInitiallyAddingNewDependency: isInitiallyAddingNewDependency
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lhWbF.default), dependencySelectorProps);
        }
        constructor(...args){
            super(...args);
            this.state = {
                isAddingNewDependency: this.props.isInitiallyAddingNewDependency,
                addDependencyIssue: null,
                addDependencyType: null
            };
            this.onAddDependency = (e)=>{
                e.preventDefault();
                this.setState({
                    isAddingNewDependency: true
                });
                this.props.updatePopup?.();
            };
            this.onAddDependencyConfirm = (e, analyticsEvent)=>{
                e.preventDefault();
                const { addDependency: addDependency, direction: direction, issue: issue, issueLinkTypes: issueLinkTypes, context: context, issueCountByLinkType: issueCountByLinkType } = this.props;
                const { addDependencyType: addDependencyType, addDependencyIssue: addDependencyIssue } = this.state;
                if (!addDependencyIssue) throw new Error('Target issue is not selected!');
                const newIssue = addDependencyIssue;
                const type = (addDependencyType || issueLinkTypes[0]).id;
                if (direction === (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD) addDependency({
                    sourceItemKey: issue.id,
                    targetItemKey: newIssue.id,
                    type: type
                });
                else addDependency({
                    sourceItemKey: newIssue.id,
                    targetItemKey: issue.id,
                    type: type
                });
                this.setState({
                    isAddingNewDependency: false
                });
                this.props.updatePopup?.();
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ADDED_ISSUE_DEPENDENCY_LINK.split(' ');
                const analyticsPayload = {
                    source: context,
                    type: type,
                    typeCount: issueCountByLinkType[type] || 0
                };
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: action,
                    actionSubject: actionSubject
                }), analyticsPayload);
            };
            this.onAddDependencyCancel = (e)=>{
                e.preventDefault();
                this.setState({
                    isAddingNewDependency: false
                });
                this.props.updatePopup?.();
            };
            this.onChangeDependencyType = (option)=>{
                if (option?.type === undefined) throw new Error('Make sure that dependency selector items have type injected');
                this.setState({
                    addDependencyType: option.type
                });
            };
            this.onChangeDependencyIssue = (option)=>{
                this.setState({
                    addDependencyIssue: option
                });
                this.props.updatePopup?.();
            };
            this.renderAddDependencyButton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    onClick: this.onAddDependency,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $fQJAe.default).addDependencyLabel));
        }
    }
});
parcelRegister("lhWbF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6abe794b18cd2fd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jB947;
    var $kbxJz;
    var $lLLkM;
    var $dC5iT;
    var $kgoHi;
    var $f5TWP;
    var $8CUq3;
    var $4R6GH;
    var $8RXs9;
    var $aCpcO;
    var $2dZwa = parcelRequire("2dZwa");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $dCm1o;
    var $cwei6 = parcelRequire("cwei6");
    var $54HHk = parcelRequire("54HHk");
    var $jjHFE = parcelRequire("jjHFE");
    var $ki9DC = parcelRequire("ki9DC");
    class $a6abe794b18cd2fd$var$DependencySelector extends (0, $5uXOq.Component) {
        render() {
            const { addDependencyType: addDependencyType, direction: direction, issue: issue, issueLinkTypes: issueLinkTypes, issueTypes: issueTypes, issues: issues, onChangeDependencyIssue: onChangeDependencyIssue, onChangeDependencyType: onChangeDependencyType, projectsById: projectsById, isInitiallyAddingNewDependency: isInitiallyAddingNewDependency } = this.props;
            const typeSelectorProps = {
                addDependencyType: addDependencyType,
                direction: direction,
                issueLinkTypes: issueLinkTypes,
                onChangeDependencyType: onChangeDependencyType
            };
            const issueSelectorProps = {
                issue: issue,
                issueTypes: issueTypes,
                issues: issues,
                onChangeDependencyIssue: onChangeDependencyIssue,
                projectsById: projectsById
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2dZwa.DependenciesDialogContext).Consumer, null, ({ toggleDialogLocked: toggleDialogLocked })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                    xcss: $a6abe794b18cd2fd$var$inlineStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: [
                        $a6abe794b18cd2fd$var$addDependencyTypeStyles,
                        !isInitiallyAddingNewDependency && $a6abe794b18cd2fd$var$addDependencyTypeLeftStyles
                    ]
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ki9DC.default), {
                    ...typeSelectorProps,
                    toggleDialogLocked: toggleDialogLocked('TypeSelector'),
                    ariaLabel: this.props.intl.formatMessage((0, $54HHk.default).dependencyTypeSelectorLabel)
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $a6abe794b18cd2fd$var$addDependencyIssueStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cwei6.default), {
                    ...issueSelectorProps,
                    toggleDialogLocked: toggleDialogLocked('IssueSelector')
                })), (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                    gap: "space.050",
                    xcss: $a6abe794b18cd2fd$var$buttonContainerStyles
                }, this.renderConfirmButton(), this.renderCancelButton()) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.renderConfirmButton(), this.renderCancelButton())));
        }
        constructor(...args){
            super(...args);
            this.renderConfirmButton = ()=>{
                const { addDependencyIssue: addDependencyIssue, addDependencyType: addDependencyType, direction: direction, internalIssueLinks: internalIssueLinks, issueLinkTypes: issueLinkTypes, intl: { formatMessage: formatMessage }, onAddDependencyConfirm: onAddDependencyConfirm } = this.props;
                const type = addDependencyType || (0, parcelRequire("jB947")).default(issueLinkTypes);
                const typeId = type && type.id;
                const otherIssueKey = direction === (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD ? 'targetItemKey' : 'sourceItemKey';
                const isDisabled = !typeId || !addDependencyIssue || !!internalIssueLinks.find(({ type: type, [otherIssueKey]: otherIssueId })=>type === typeId && otherIssueId === addDependencyIssue.id);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    ariaLabel: formatMessage((0, $54HHk.default).dependencyConfirmButtonAriaLabel),
                    className: $jjHFE.addDependencyButton,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kbxJz"))))), {
                        label: "",
                        size: "small"
                    }),
                    isDisabled: isDisabled,
                    onClick: onAddDependencyConfirm,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.dependency-confirm-btn"
                });
            };
            this.renderCancelButton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    ariaLabel: this.props.intl.formatMessage((0, $54HHk.default).dependencyCancelButtonAriaLabel),
                    className: $jjHFE.addDependencyButton,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
                        label: "",
                        size: "small"
                    }),
                    onClick: this.props.onAddDependencyCancel,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.button"
                });
        }
    }
    const $a6abe794b18cd2fd$var$inlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.050',
        paddingBottom: 'space.050'
    });
    const $a6abe794b18cd2fd$var$addDependencyIssueStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '300px',
        flexWrap: 'nowrap',
        flex: '1'
    });
    const $a6abe794b18cd2fd$var$addDependencyTypeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingRight: 'space.100',
        minWidth: '164px'
    });
    const $a6abe794b18cd2fd$var$addDependencyTypeLeftStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.100'
    });
    const $a6abe794b18cd2fd$var$buttonContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
    var $a6abe794b18cd2fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($a6abe794b18cd2fd$var$DependencySelector);
});
parcelRegister("kbxJz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb1f0098e5a023eb$var$CheckIcon = (props)=>$eb1f0098e5a023eb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
        }, props, {
            newIcon: $eb1f0098e5a023eb$var$_checkMark.default
        }));
    $eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
    var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;
});
parcelRegister("bjo8S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83c43234bc70a485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c43234bc70a485$var$CheckMarkIcon = (props)=>$83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;
});
parcelRegister("cwei6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac920cd0e06182d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $8RXs9;
    var $iqIcG;
    var $4y9A5 = parcelRequire("4y9A5");
    var $cSDJf = parcelRequire("cSDJf");
    var $4JIiy = parcelRequire("4JIiy");
    var $1QDQS = parcelRequire("1QDQS");
    class $ac920cd0e06182d5$var$IssueSelector extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.renderDependencyIssue = (issue)=>{
                const { issueTypes: issueTypes } = this.props;
                const issueType = issueTypes.find(({ id: id })=>id === issue.type);
                return (0, (0, parcelRequire("iqIcG")).selectIssueOption)({
                    icon: issueType && issueType.iconUrl,
                    label: this.getDependencyIssueValue(issue)
                });
            };
            this.getDependencyIssueValue = ({ issueKey: issueKey, project: projectId, summary: summary })=>{
                const { projectsById: projectsById } = this.props;
                const project = projectsById[projectId || NaN];
                const key = issueKey ? `${project.key}-${issueKey}` : project.key;
                return `${key} ${summary}`;
            };
            this.loadOptions = (query)=>{
                const { issue: { id: id } } = this.props;
                const q = query.toLowerCase();
                const options = this.props.issues.reduce((options, issue)=>{
                    if (options.length < 50 && this.getDependencyIssueValue(issue).toLowerCase().includes(q) && issue.id !== id) options.push({
                        ...issue,
                        label: this.getDependencyIssueValue(issue)
                    });
                    return options;
                }, []);
                return Promise.resolve(options);
            };
            this.onMenuOpen = ()=>{
                this.props.toggleDialogLocked(true);
            };
            this.onMenuClose = ()=>{
                this.props.toggleDialogLocked(false);
            };
            this.menuContainer = document.createElement('div');
            this.menuContainer.style.pointerEvents = 'none';
            this.menuContainer.classList.add($1QDQS.menuContainer);
            (0, $4y9A5.getBody)().appendChild(this.menuContainer);
        }
        componentWillUnmount() {
            (0, $4y9A5.removeNode)(this.menuContainer);
        }
        render() {
            const { onChangeDependencyIssue: onChangeDependencyIssue, intl: intl } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $ac920cd0e06182d5$var$addDependencyIssueSelectorStyles,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.issue-selector.dependency-flyout-issue-selector"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cSDJf.AsyncSelect), {
                autoFocus: true,
                defaultOptions: true,
                formatOptionLabel: this.renderDependencyIssue,
                getOptionValue: this.getDependencyIssueValue,
                isClearable: true,
                isTransparentBackground: false,
                loadOptions: this.loadOptions,
                menuPlacement: "auto",
                menuPortalTarget: this.menuContainer,
                onChange: onChangeDependencyIssue,
                placeholder: intl.formatMessage((0, $4JIiy.default).issueSelectorPlaceholder),
                styles: {
                    menuPortal: (menuPortalStyles)=>({
                            ...menuPortalStyles,
                            zIndex: 1000,
                            pointerEvents: 'initial'
                        })
                },
                onMenuOpen: this.onMenuOpen,
                onMenuClose: this.onMenuClose,
                "aria-label": intl.formatMessage((0, $4JIiy.default).issueSelectorLabel)
            }));
        }
    }
    const $ac920cd0e06182d5$var$addDependencyIssueSelectorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    var $ac920cd0e06182d5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($ac920cd0e06182d5$var$IssueSelector);
});
parcelRegister("4JIiy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e2ed5fb342569a2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4e2ed5fb342569a2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueSelectorPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.issue-selector.issue-selector-placeholder",
            "defaultMessage": "Choose an issue..."
        },
        issueSelectorLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.issue-selector.issue-selector-label",
            "defaultMessage": "Select an issue"
        }
    });
});
parcelRegister("1QDQS", function(module, exports) {
    $parcel$export(module.exports, "menuContainer", ()=>$15898f808279d68c$export$8ef325e9124f92b2, (v)=>$15898f808279d68c$export$8ef325e9124f92b2 = v);
    var $15898f808279d68c$export$8ef325e9124f92b2;
    $15898f808279d68c$export$8ef325e9124f92b2 = `s9hvAq_menuContainer`;
});
parcelRegister("54HHk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1fedf4cd383b2c79$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1fedf4cd383b2c79$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        dependencyConfirmButtonAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.dependency-confirm-button-aria-label",
            "defaultMessage": "Confirm"
        },
        dependencyCancelButtonAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.dependency-cancel-button-aria-label",
            "defaultMessage": "Clear"
        },
        dependencyTypeSelectorLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.dependency-type-selector-label",
            "defaultMessage": "Issue type"
        }
    });
});
parcelRegister("jjHFE", function(module, exports) {
    $parcel$export(module.exports, "addDependencyButton", ()=>$e101aac316c25862$export$a67007520ef868ed, (v)=>$e101aac316c25862$export$a67007520ef868ed = v);
    var $e101aac316c25862$export$a67007520ef868ed;
    var $e101aac316c25862$export$14c861700ae81b70;
    var $e101aac316c25862$export$8aa27b4fe6bcbcf7;
    $e101aac316c25862$export$a67007520ef868ed = `_3zxRDW_addDependencyButton`;
    $e101aac316c25862$export$14c861700ae81b70 = `_3zxRDW_addDependencyIssue`;
    $e101aac316c25862$export$8aa27b4fe6bcbcf7 = `_3zxRDW_addDependencyType`;
});
parcelRegister("ki9DC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2b6744188a19526$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jB947;
    var $4y9A5 = parcelRequire("4y9A5");
    var $cSDJf = parcelRequire("cSDJf");
    var $64ySJ = parcelRequire("64ySJ");
    var $aEJJS = parcelRequire("aEJJS");
    class $d2b6744188a19526$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.onMenuOpen = ()=>{
                this.props.toggleDialogLocked(true);
            };
            this.onMenuClose = ()=>{
                this.props.toggleDialogLocked(false);
            };
            this.menuContainer = document.createElement('div');
            this.menuContainer.style.pointerEvents = 'none';
            this.menuContainer.classList.add($aEJJS.menuContainer);
            (0, $4y9A5.getBody)().appendChild(this.menuContainer);
        }
        componentWillUnmount() {
            (0, $4y9A5.removeNode)(this.menuContainer);
        }
        render() {
            const { addDependencyType: addDependencyType, issueLinkTypes: issueLinkTypes, direction: direction, onChangeDependencyType: onChangeDependencyType, ariaLabel: ariaLabel } = this.props;
            const options = issueLinkTypes.map((type)=>({
                    label: (0, $64ySJ.titleCase)(type[direction]),
                    value: `${type.id}`,
                    type: type
                }));
            const value = addDependencyType ? options.find(({ type: type })=>type.id === addDependencyType.id) : (0, parcelRequire("jB947")).default(options);
            const select = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cSDJf.default), {
                value: value,
                menuPlacement: "auto",
                menuPortalTarget: this.menuContainer,
                isDisabled: !value,
                isClearable: false,
                isSearchable: false,
                isTransparentBackground: false,
                options: options,
                onChange: onChangeDependencyType,
                styles: {
                    menuPortal: (styles)=>({
                            ...styles,
                            zIndex: 1000,
                            pointerEvents: 'initial'
                        })
                },
                onMenuOpen: this.onMenuOpen,
                onMenuClose: this.onMenuClose,
                "aria-label": ariaLabel
            }));
            return select;
        }
    }
});
parcelRegister("64ySJ", function(module, exports) {
    $parcel$export(module.exports, "titleCase", ()=>$68ad44bf932a017c$export$348afa8c9ff47183);
    const $68ad44bf932a017c$export$348afa8c9ff47183 = (s)=>s[0].toUpperCase() + s.slice(1);
});
parcelRegister("aEJJS", function(module, exports) {
    $parcel$export(module.exports, "menuContainer", ()=>$7c211ea0d359921d$export$8ef325e9124f92b2, (v)=>$7c211ea0d359921d$export$8ef325e9124f92b2 = v);
    var $7c211ea0d359921d$export$8ef325e9124f92b2;
    $7c211ea0d359921d$export$8ef325e9124f92b2 = `wBHyJG_menuContainer`;
});
parcelRegister("fQJAe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cdede515a9748853$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cdede515a9748853$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addDependencyLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.add-dependency-label",
            "defaultMessage": "+ Add dependency"
        }
    });
});
parcelRegister("aULOu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d4a31d0e0201caf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $3bDjY;
    var $8RXs9;
    var $ihPUd = parcelRequire("ihPUd");
    var $2qp5k = parcelRequire("2qp5k");
    function $0d4a31d0e0201caf$var$AssigneeCell(props) {
        const { intl: intl, row: { assignee: assignee } } = props;
        if (!assignee) return null;
        const { jiraUser: { avatarUrl: avatarUrl, title: title, accountId: accountId } } = assignee;
        const name = title || accountId || intl.formatMessage((0, $ihPUd.default).unassigned);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $2qp5k.assignee
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: name
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "small",
            src: avatarUrl ?? undefined,
            name: name
        }))));
    }
    var $0d4a31d0e0201caf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($0d4a31d0e0201caf$var$AssigneeCell);
});
parcelRegister("2qp5k", function(module, exports) {
    $parcel$export(module.exports, "assignee", ()=>$1c4177cd9c49e8d1$export$65bc3e250c89c0e4, (v)=>$1c4177cd9c49e8d1$export$65bc3e250c89c0e4 = v);
    var $1c4177cd9c49e8d1$export$65bc3e250c89c0e4;
    $1c4177cd9c49e8d1$export$65bc3e250c89c0e4 = `F04w9G_assignee`;
});
parcelRegister("cXSJc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29e940a4cacec133$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8CUq3;
    var $2FvnI;
    var $kLLwV = parcelRequire("kLLwV");
    function $29e940a4cacec133$export$2e2bcd8739ae039({ row: { issue: issue, issueType: issueType, projectKey: projectKey } }) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kLLwV.issueTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kLLwV.issueIcon,
            style: {
                backgroundSize: 'contain',
                backgroundImage: issueType && `url(${issueType.iconUrl})`
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kLLwV.issueSummary,
            title: issue.summary,
            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.issue-${issue.id}.summary`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvnI")).default), {
            issueKey: issue.issueKey,
            projectKey: projectKey,
            xcssStyles: $29e940a4cacec133$var$issueLinkStyles
        }), issue.summary)));
    }
    const $29e940a4cacec133$var$issueLinkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        marginRight: 'space.075'
    });
});
parcelRegister("kLLwV", function(module, exports) {
    $parcel$export(module.exports, "issueIcon", ()=>$f1ed10ef1d220b11$export$415983cbc1f2b3fe, (v)=>$f1ed10ef1d220b11$export$415983cbc1f2b3fe = v);
    $parcel$export(module.exports, "issueSummary", ()=>$f1ed10ef1d220b11$export$7c7bc027bbbea103, (v)=>$f1ed10ef1d220b11$export$7c7bc027bbbea103 = v);
    $parcel$export(module.exports, "issueTitle", ()=>$f1ed10ef1d220b11$export$12781bd67c11efd8, (v)=>$f1ed10ef1d220b11$export$12781bd67c11efd8 = v);
    var $f1ed10ef1d220b11$export$415983cbc1f2b3fe;
    var $f1ed10ef1d220b11$export$7c7bc027bbbea103;
    var $f1ed10ef1d220b11$export$12781bd67c11efd8;
    $f1ed10ef1d220b11$export$415983cbc1f2b3fe = `_8vVz8q_issueIcon`;
    $f1ed10ef1d220b11$export$7c7bc027bbbea103 = `_8vVz8q_issueSummary`;
    $f1ed10ef1d220b11$export$12781bd67c11efd8 = `_8vVz8q_issueTitle`;
});
parcelRegister("gO02F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5c39bfa3f0e50ca$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $flnZx;
    var $4nDwW = parcelRequire("4nDwW");
    var $DVljb;
    var $dT8OM = parcelRequire("dT8OM");
    var $kCINZ = parcelRequire("kCINZ");
    function $f5c39bfa3f0e50ca$export$2e2bcd8739ae039({ row: { issue: issue, leadTime: leadTime, isOverlapping: isOverlapping, syncStartEnabled: syncStartEnabled } }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        let leadTimeMessage = '';
        if ((0, $4nDwW.isDefined)(leadTime)) {
            if (leadTime === 1) leadTimeMessage = formatMessage((0, $dT8OM.default).lessThanOneDayLeadTime);
            else if (Math.abs(leadTime) < (0, (0, parcelRequire("flnZx")).ONE_DAY) || leadTime < 0 && !isOverlapping && syncStartEnabled) leadTimeMessage = formatMessage((0, $dT8OM.default).zeroLeadTime);
            else leadTimeMessage = (0, (0, parcelRequire("flnZx")).distanceInWordsToNowWithPolarity)(locale, Date.now() + leadTime);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $4nDwW.isDefined)(leadTime) && leadTime < 0 && !(!isOverlapping && syncStartEnabled) ? $kCINZ.warning : '',
            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.issue-${issue.id}.lead-time`
        }, leadTimeMessage);
    }
});
parcelRegister("dT8OM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a4020d4820e89a8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1a4020d4820e89a8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        lessThanOneDayLeadTime: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.lead-time.less-than-one-day-lead-time",
            "defaultMessage": "+ < 1 day"
        },
        zeroLeadTime: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.lead-time.zero-lead-time",
            "defaultMessage": "0 days"
        }
    });
});
parcelRegister("kCINZ", function(module, exports) {
    $parcel$export(module.exports, "warning", ()=>$f03a1caa986a44ea$export$491112666e282270, (v)=>$f03a1caa986a44ea$export$491112666e282270 = v);
    var $f03a1caa986a44ea$export$491112666e282270;
    $f03a1caa986a44ea$export$491112666e282270 = `Gn7wnW_warning`;
});
parcelRegister("cvcFu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3260bfb72310c209$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hUqzg;
    var $3bDjY;
    var $8RXs9;
    var $aCpcO;
    var $i2qlb = parcelRequire("i2qlb");
    var $gITL8 = parcelRequire("gITL8");
    var $8zOmE;
    var $5GFRC = parcelRequire("5GFRC");
    var $eGi3z = parcelRequire("eGi3z");
    function $3260bfb72310c209$var$RemoveCell(props) {
        const { intl: intl, issueKey: issueKey, projectKey: projectKey } = props;
        const fullIssueKey = issueKey ? `${projectKey}-${issueKey}` : projectKey;
        const onClick = (event, analyticsEvent)=>{
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).DELETED_ISSUE_DEPENDENCY_LINK.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }));
            props.updatePopup?.();
            props.onClick(event);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: intl.formatMessage((0, $5GFRC.default).removeDependency)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eGi3z.trashcan
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            onClick: onClick,
            ariaLabel: `${intl.formatMessage((0, $5GFRC.default).removeDependency)}: ${fullIssueKey}`,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.remove"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hUqzg"))))), {
            label: "",
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)",
            LEGACY_primaryColor: (0, $gITL8.DEFAULT_COLOR)
        }))));
    }
    var $3260bfb72310c209$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($3260bfb72310c209$var$RemoveCell);
});
parcelRegister("hUqzg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d09c4671709f5c19$var$_react = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d09c4671709f5c19$var$_delete = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("4IrpZ")));
    var $d09c4671709f5c19$var$_trash = $d09c4671709f5c19$var$_interopRequireDefault((parcelRequire("3fOYK")));
    function $d09c4671709f5c19$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d09c4671709f5c19$var$DeleteIcon = (props)=>$d09c4671709f5c19$var$_react.default.createElement($d09c4671709f5c19$var$_delete.default, Object.assign({
            LEGACY_fallbackIcon: $d09c4671709f5c19$var$_trash.default
        }, props));
    $d09c4671709f5c19$var$DeleteIcon.Name = 'DeleteIconMigration';
    var $d09c4671709f5c19$var$_default = module.exports.default = $d09c4671709f5c19$var$DeleteIcon;
});
parcelRegister("4IrpZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $36f08a2f957bd6ab$var$_UNSAFE_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>$36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 3.25V14c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25V3.25m9.5 0h1.75m-1.75 0h-2.5m-7 0H1.5m1.75 0h2.5m0 0V.75h4.5v2.5m-4.5 0h4.5M6.5 5.5V13m3-7.5V13"/>`
        }, props));
    $36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
    var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;
});
parcelRegister("3fOYK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25ea512a3c153cf8$var$_react = $25ea512a3c153cf8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25ea512a3c153cf8$var$_delete = $25ea512a3c153cf8$var$_interopRequireDefault((parcelRequire("4IrpZ")));
    function $25ea512a3c153cf8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25ea512a3c153cf8$var$TrashIcon = (props)=>$25ea512a3c153cf8$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5a1 1 0 0 0-1 1v1h16V6a1 1 0 0 0-1-1zm11.15 15h-8.3a1 1 0 0 1-.99-.83L5 8h14l-1.86 11.17a1 1 0 0 1-.99.83M9 4.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5V5H9z"/></svg>`
        }, props, {
            newIcon: $25ea512a3c153cf8$var$_delete.default
        }));
    $25ea512a3c153cf8$var$TrashIcon.displayName = 'TrashIcon';
    var $25ea512a3c153cf8$var$_default = module.exports.default = $25ea512a3c153cf8$var$TrashIcon;
});
parcelRegister("5GFRC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4dc267cedfad56b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a4dc267cedfad56b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeDependency: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.remove.remove-dependency",
            "defaultMessage": "Remove dependency"
        }
    });
});
parcelRegister("eGi3z", function(module, exports) {
    $parcel$export(module.exports, "trashcan", ()=>$ab02fe9814c66a0e$export$4818a3431a1cd86, (v)=>$ab02fe9814c66a0e$export$4818a3431a1cd86 = v);
    var $ab02fe9814c66a0e$export$4818a3431a1cd86;
    $ab02fe9814c66a0e$export$4818a3431a1cd86 = `l-GlJq_trashcan`;
});
parcelRegister("eJ0an", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128f625142946057$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $TTKUQ = parcelRequire("TTKUQ");
    function $128f625142946057$export$2e2bcd8739ae039({ row: { status: status } }) {
        if (!status) return null;
        const { name: name, categoryId: categoryId } = status;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: (0, $TTKUQ.ISSUE_STATUS_APPEARANCE)[categoryId]
        }, name);
    }
});
parcelRegister("3fpOS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4261d5fd23a432df$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $64ySJ = parcelRequire("64ySJ");
    function $4261d5fd23a432df$export$2e2bcd8739ae039({ direction: direction, row: { type: type } }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, $64ySJ.titleCase)(type[direction]));
    }
});
parcelRegister("9SU3m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13b735be0e62f165$export$2e2bcd8739ae039);
    var $7VHMR;
    var $13b735be0e62f165$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        typeHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.type-header",
            "defaultMessage": "Type"
        },
        issueHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.issue-header",
            "defaultMessage": "Issue"
        },
        statusHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.status-header",
            "defaultMessage": "Status"
        },
        leadTimeHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.lead-time-header",
            "defaultMessage": "Lead time"
        },
        externalDependenciesHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.external-dependencies-header",
            "defaultMessage": "Not in this plan"
        },
        addQuickFilterText: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-quick-filter-text",
            "defaultMessage": "Filter by dependencies of {issueKey, select, ScenarioIssue {this issue} other {{issueKey}}}"
        },
        removeQuickFilterText: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.remove-quick-filter-text",
            "defaultMessage": "Clear filter for {issueKey, select, ScenarioIssue {this issue} other {{issueKey}}}"
        },
        toggleDependencyViewButton: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.toggle-dependency-view-button",
            "defaultMessage": "View dependencies as {value, select, lines {badges} other {lines}}"
        },
        visualizeDependencies: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.visualize-dependencies",
            "defaultMessage": "Show dependencies for {issueKey, select, ScenarioIssue {this issue} other {{issueKey}}}"
        }
    });
});
parcelRegister("a5H4V", function(module, exports) {
    $parcel$export(module.exports, "assigneeCell", ()=>$758bc982b512b9fa$export$c777f4b5fa291396, (v)=>$758bc982b512b9fa$export$c777f4b5fa291396 = v);
    $parcel$export(module.exports, "change-indicator", ()=>$758bc982b512b9fa$export$157c8f7811c1bda7, (v)=>$758bc982b512b9fa$export$157c8f7811c1bda7 = v);
    $parcel$export(module.exports, "externalDependenciesHeader", ()=>$758bc982b512b9fa$export$68638848871a3dea, (v)=>$758bc982b512b9fa$export$68638848871a3dea = v);
    $parcel$export(module.exports, "footerActions", ()=>$758bc982b512b9fa$export$dc59c743128f690f, (v)=>$758bc982b512b9fa$export$dc59c743128f690f = v);
    $parcel$export(module.exports, "remove-filter", ()=>$758bc982b512b9fa$export$86450144a1f5cc56, (v)=>$758bc982b512b9fa$export$86450144a1f5cc56 = v);
    $parcel$export(module.exports, "table", ()=>$758bc982b512b9fa$export$9852986a3ec5f6a0, (v)=>$758bc982b512b9fa$export$9852986a3ec5f6a0 = v);
    $parcel$export(module.exports, "typeCell", ()=>$758bc982b512b9fa$export$99e92e4c1acf2763, (v)=>$758bc982b512b9fa$export$99e92e4c1acf2763 = v);
    var $758bc982b512b9fa$export$c777f4b5fa291396;
    var $758bc982b512b9fa$export$157c8f7811c1bda7;
    var $758bc982b512b9fa$export$68638848871a3dea;
    var $758bc982b512b9fa$export$dc59c743128f690f;
    var $758bc982b512b9fa$export$86450144a1f5cc56;
    var $758bc982b512b9fa$export$9852986a3ec5f6a0;
    var $758bc982b512b9fa$export$99e92e4c1acf2763;
    $758bc982b512b9fa$export$c777f4b5fa291396 = `BMlqFq_assigneeCell`;
    $758bc982b512b9fa$export$157c8f7811c1bda7 = `BMlqFq_change-indicator`;
    $758bc982b512b9fa$export$68638848871a3dea = `BMlqFq_externalDependenciesHeader`;
    $758bc982b512b9fa$export$dc59c743128f690f = `BMlqFq_footerActions`;
    $758bc982b512b9fa$export$86450144a1f5cc56 = `BMlqFq_remove-filter`;
    $758bc982b512b9fa$export$9852986a3ec5f6a0 = `BMlqFq_table`;
    $758bc982b512b9fa$export$99e92e4c1acf2763 = `BMlqFq_typeCell`;
});
parcelRegister("eHjdS", function(module, exports) {
    $parcel$export(module.exports, "anchor", ()=>$ab33fe1e2f03326c$export$2e2992790a6f69a8, (v)=>$ab33fe1e2f03326c$export$2e2992790a6f69a8 = v);
    $parcel$export(module.exports, "overlay", ()=>$ab33fe1e2f03326c$export$29dd17c7f3c81c36, (v)=>$ab33fe1e2f03326c$export$29dd17c7f3c81c36 = v);
    var $ab33fe1e2f03326c$export$2e2992790a6f69a8;
    var $ab33fe1e2f03326c$export$29dd17c7f3c81c36;
    $ab33fe1e2f03326c$export$2e2992790a6f69a8 = `VBLPGq_anchor`;
    $ab33fe1e2f03326c$export$29dd17c7f3c81c36 = `VBLPGq_overlay`;
});
parcelRegister("bUB9H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16fb0ba295039e01$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bUAgq = parcelRequire("bUAgq");
    var $lJOSS = parcelRequire("lJOSS");
    var $16fb0ba295039e01$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $bUAgq.default), {})((0, $lJOSS.default));
});
parcelRegister("bUAgq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98fae2c9b239401$export$2e2bcd8739ae039);
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $b98fae2c9b239401$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        timeScale: (0, $kWDpn.getTimeScaleViewSettings)
    });
});
parcelRegister("lJOSS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a2a8382c7d24fc0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $cGv9m;
    var $hE4fC;
    function $2a2a8382c7d24fc0$export$2e2bcd8739ae039({ timeScale: timeScale }) {
        const timeScaleselection = timeScale.mode;
        const zoomLevel = (0, (0, parcelRequire("cGv9m")).getZoomLevel)(timeScaleselection);
        const [{ container: container, viewport: viewport }, { changeZoomLevel: changeZoomLevel, setViewportOffset: setViewportOffset, backToToday: backToToday }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const nextOffsetRef = (0, $5uXOq.useRef)(0);
        const nextContainerDuration = zoomLevel !== undefined ? (0, (0, parcelRequire("cGv9m")).getContainerDuration)(zoomLevel) : 0;
        const nextMsPerPx = nextContainerDuration / container.width;
        const nextViewportDuration = viewport.width * nextMsPerPx;
        nextOffsetRef.current = nextViewportDuration * -0.15;
        const containerHasWidth = container.width > 0;
        (0, $5uXOq.useEffect)(()=>{
            changeZoomLevel(zoomLevel);
            if ((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2')) backToToday();
            else setViewportOffset(nextOffsetRef.current, 'zoomLevelChange');
        }, [
            zoomLevel,
            changeZoomLevel,
            backToToday,
            setViewportOffset,
            containerHasWidth
        ]);
        return null;
    }
});
parcelRegister("7CIng", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e5405f7d68300df$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5wsvd = parcelRequire("5wsvd");
    var $ahbdv = parcelRequire("ahbdv");
    var $2DsmG = parcelRequire("2DsmG");
    var $7e5405f7d68300df$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $ahbdv.default), (0, $5wsvd.default))((0, $2DsmG.default));
});
parcelRegister("5wsvd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7fb29874fe93cd6d$export$2e2bcd8739ae039);
    var $3ODbh = parcelRequire("3ODbh");
    var $7fb29874fe93cd6d$export$2e2bcd8739ae039 = {
        toggleSelectedIssues: $3ODbh.toggleSelectedIssues
    };
});
parcelRegister("ahbdv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7f6394681684046$export$2e2bcd8739ae039);
    var $4Rr1a;
    var $2rMKg;
    var $bI9dZ = parcelRequire("bI9dZ");
    var $gFhwb = parcelRequire("gFhwb");
    var $3YtPS = parcelRequire("3YtPS");
    var $b7f6394681684046$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedIssuesIds: (0, $bI9dZ.getSelected),
        issueMapById: (0, $gFhwb.getIssueMapById),
        issuesInFilterById: (state)=>new Set((0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('id'), (0, $bI9dZ.getFilteredIssuesWithHierarchy)(state)))
    });
});
parcelRegister("2DsmG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43260ae3b956bb1d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $i2qlb = parcelRequire("i2qlb");
    var $3ODbh = parcelRequire("3ODbh");
    var $8zOmE;
    const $43260ae3b956bb1d$export$3afcfcc1f8ba5f0e = 'roadmap.scope.all-issues-select.NONE_SELECTED';
    const $43260ae3b956bb1d$export$8a6f405a3e588fc = 'roadmap.scope.all-issues-select.ALL_SELECTED';
    const $43260ae3b956bb1d$export$1743d6cf71d3e2a = 'roadmap.scope.all-issues-select.SOME_SELECTED';
    class $43260ae3b956bb1d$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        shouldComponentUpdate(nextProps) {
            return !nextProps.isDragging;
        }
        render() {
            const { selectedIssuesIds: selectedIssuesIds } = this.props;
            const checkboxState = this.getCheckboxState();
            const isSelected = checkboxState !== $43260ae3b956bb1d$export$3afcfcc1f8ba5f0e;
            const isIndeterminate = checkboxState === $43260ae3b956bb1d$export$1743d6cf71d3e2a;
            const nextState = checkboxState !== $43260ae3b956bb1d$export$8a6f405a3e588fc ? $43260ae3b956bb1d$export$8a6f405a3e588fc : $43260ae3b956bb1d$export$3afcfcc1f8ba5f0e;
            return this.props.children({
                totalSelected: selectedIssuesIds.size,
                isIndeterminate: isIndeterminate,
                isSelected: isSelected,
                toggleAllSelected: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? this.toggleAllSelected : (_, analyticsEvent)=>{
                    this.toggleAllSelectedOld(nextState === $43260ae3b956bb1d$export$8a6f405a3e588fc);
                    if (nextState === $43260ae3b956bb1d$export$8a6f405a3e588fc) this.triggerAllSelectedAnalytics(analyticsEvent);
                }
            });
        }
        constructor(...args){
            super(...args);
            this.toggleAllSelectedOld = (isSelected)=>{
                const { toggleSelectedIssues: toggleSelectedIssues, issuesInFilterById: issuesInFilterById, selectedIssuesIds: selectedIssuesIds } = this.props;
                return toggleSelectedIssues({
                    ids: isSelected ? Array.from(issuesInFilterById) : Array.from(selectedIssuesIds),
                    isSelected: isSelected,
                    toggleAll: true,
                    targetType: (0, $3ODbh.TargetTypes).all
                });
            };
            this.toggleAllSelected = (_, analyticsEvent)=>{
                const checkboxState = this.getCheckboxState();
                const nextState = checkboxState !== $43260ae3b956bb1d$export$8a6f405a3e588fc ? $43260ae3b956bb1d$export$8a6f405a3e588fc : $43260ae3b956bb1d$export$3afcfcc1f8ba5f0e;
                const { toggleSelectedIssues: toggleSelectedIssues, issuesInFilterById: issuesInFilterById, selectedIssuesIds: selectedIssuesIds } = this.props;
                const isSelected = nextState === $43260ae3b956bb1d$export$8a6f405a3e588fc;
                toggleSelectedIssues({
                    ids: isSelected ? Array.from(issuesInFilterById) : Array.from(selectedIssuesIds),
                    isSelected: isSelected,
                    toggleAll: true,
                    targetType: (0, $3ODbh.TargetTypes).all
                });
                if (nextState === $43260ae3b956bb1d$export$8a6f405a3e588fc) this.triggerAllSelectedAnalytics(analyticsEvent);
            };
            this.triggerAllSelectedAnalytics = (analyticsEvent)=>{
                const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: eventAction,
                    actionSubject: actionSubject
                }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES, {
                    selectOption: (0, $3ODbh.TargetTypes).all
                });
            };
            this.getCheckboxState = ()=>{
                const { selectedIssuesIds: selectedIssuesIds, issuesInFilterById: issuesInFilterById } = this.props;
                let selectedIssuesInFilter = 0;
                for (const id of selectedIssuesIds)if (issuesInFilterById.has(id)) selectedIssuesInFilter += 1;
                if (selectedIssuesInFilter === 0) return $43260ae3b956bb1d$export$3afcfcc1f8ba5f0e;
                if (selectedIssuesInFilter >= issuesInFilterById.size) return $43260ae3b956bb1d$export$8a6f405a3e588fc;
                return $43260ae3b956bb1d$export$1743d6cf71d3e2a;
            };
        }
    }
});
parcelRegister("w2hJE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$717bcb966ba44186$export$2e2bcd8739ae039);
    var $bC2fB;
    var $ecfmd = parcelRequire("ecfmd");
    var $jn1ls = parcelRequire("jn1ls");
    var $7SoOT = parcelRequire("7SoOT");
    var $717bcb966ba44186$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $jn1ls.default), (0, $ecfmd.default))((0, $7SoOT.default));
});
parcelRegister("ecfmd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5e838bb3a57ee2b$export$2e2bcd8739ae039);
    var $jlryX = parcelRequire("jlryX");
    var $lKGSc = parcelRequire("lKGSc");
    var $7K8Pq = parcelRequire("7K8Pq");
    var $b5e838bb3a57ee2b$export$2e2bcd8739ae039 = (dispatch)=>({
            createIssueWithTitle: (title)=>{
                if (title) dispatch((0, $jlryX.inlineCreateIssue)(title));
                else dispatch((0, $7K8Pq.clearInlineCreate)());
            },
            cancelInlineCreate: ()=>dispatch((0, $7K8Pq.clearInlineCreate)()),
            setIssueTypeId: (issueTypeId)=>dispatch((0, $7K8Pq.setIssueTypeId)(issueTypeId)),
            setProjectId: (projectId)=>dispatch((0, $7K8Pq.setProjectId)(projectId)),
            setIssueTypeIdForHierarchy: (hierarchyLevel, issueTypeId)=>{
                dispatch((0, $7K8Pq.setIssueTypeIdForHierarchy)(hierarchyLevel, issueTypeId));
            },
            setDefaultProjectId: (projectId)=>dispatch((0, $lKGSc.setDefaultProject)({
                    projectId: projectId
                }))
        });
});
parcelRegister("jlryX", function(module, exports) {
    $parcel$export(module.exports, "inlineCreateIssue", ()=>$7ba8dae83f03b618$export$6a4019ebc77bfcad);
    $parcel$export(module.exports, "bulkInlineCreateIssues", ()=>$7ba8dae83f03b618$export$f6281a61db8a3a66);
    $parcel$export(module.exports, "startInlineCreate", ()=>$7ba8dae83f03b618$export$3b53adae66ce2b28);
    $parcel$export(module.exports, "default", ()=>$7ba8dae83f03b618$export$2e2bcd8739ae039);
    parcelRequire("dcevF");
    var $hIYGf = parcelRequire("hIYGf");
    var $ik0Qc;
    var $fZhYM;
    var $thm1N;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $iHPnC;
    var $c12LJ;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $5nMRY = parcelRequire("5nMRY");
    var $gk0jw = parcelRequire("gk0jw");
    var $jpXKt = parcelRequire("jpXKt");
    var $jLI87 = parcelRequire("jLI87");
    var $2QLMT = parcelRequire("2QLMT");
    var $kWDpn = parcelRequire("kWDpn");
    var $j0XCX = parcelRequire("j0XCX");
    var $21mdo = parcelRequire("21mdo");
    var $7K8Pq = parcelRequire("7K8Pq");
    var $bYhSc = parcelRequire("bYhSc");
    var $bkasS = parcelRequire("bkasS");
    var $7K8Pq = parcelRequire("7K8Pq");
    const $7ba8dae83f03b618$export$1102f55b777d8730 = (payload)=>({
            type: (0, $74616ed8f6aff060$export$242fccfb90c57247),
            payload: payload
        });
    const $7ba8dae83f03b618$export$bfc524aa95baea45 = (payload)=>({
            type: (0, $74616ed8f6aff060$export$242fccfb90c57247),
            payload: payload
        });
    const $7ba8dae83f03b618$export$bcd650ef032c77dd = 'command.inline-create.INLINE_CREATE_ISSUE';
    const $7ba8dae83f03b618$export$f5779843faf46a9d = 'command.inline-create.BULK_INLINE_CREATE_ISSUES';
    const $7ba8dae83f03b618$export$e4b545016f01a38c = 'command.inline-create.START_INLINE_CREATE';
    const $7ba8dae83f03b618$export$6a4019ebc77bfcad = (title)=>({
            type: $7ba8dae83f03b618$export$bcd650ef032c77dd,
            payload: {
                title: title
            }
        });
    const $7ba8dae83f03b618$export$f6281a61db8a3a66 = (payload)=>({
            type: $7ba8dae83f03b618$export$f5779843faf46a9d,
            payload: payload
        });
    const $7ba8dae83f03b618$export$3b53adae66ce2b28 = (payload)=>({
            type: $7ba8dae83f03b618$export$e4b545016f01a38c,
            payload: payload
        });
    function* $7ba8dae83f03b618$export$97cc3cee1b036b4c(group, groupCombination = {}, projectId) {
        if (group === (0, $jLI87.UNDEFINED_GROUP)) return {};
        const grouping = yield (0, $aNOuE.select)((0, $j0XCX.getVisualisationGrouping));
        switch(grouping){
            case (0, $TTKUQ.GROUPING).ASSIGNEE:
            case (0, $TTKUQ.GROUPING).TEAM:
            case (0, $TTKUQ.GROUPING).SPRINT:
                return groupCombination;
            case (0, $TTKUQ.GROUPING).COMPONENT:
                {
                    const componentGroupsById = yield (0, $aNOuE.select)((0, $kWDpn.getComponentGroupsById));
                    if (!(0, $4nDwW.isDefined)(groupCombination.components)) return {};
                    const componentsByProjectId = yield (0, $aNOuE.select)((0, $5nMRY.getComponentsByProjectId));
                    const componentIdsOfProject = (componentsByProjectId[projectId] || []).map((component)=>component.id);
                    const componentsValues = ((0, parcelRequire("fZhYM")).default([
                        groupCombination.components,
                        'components'
                    ], componentGroupsById) || []).filter((componentId)=>componentIdsOfProject.includes(componentId));
                    return {
                        components: componentsValues
                    };
                }
            case (0, $TTKUQ.GROUPING).LABEL:
                {
                    const labelGroupsById = yield (0, $aNOuE.select)((0, $kWDpn.getLabelGroupsById));
                    if (!(0, $4nDwW.isDefined)(groupCombination.labels)) return {};
                    return {
                        labels: (0, parcelRequire("fZhYM")).default([
                            groupCombination.labels,
                            'labels'
                        ], labelGroupsById)
                    };
                }
            case (0, $TTKUQ.GROUPING).RELEASE:
                return {
                    fixVersions: [
                        groupCombination.release
                    ]
                };
            case (0, $cScrq.isRoadmapGroupedByCustomField)(grouping) && grouping || '':
                {
                    if (!(0, $4nDwW.isDefined)(groupCombination[grouping])) return {};
                    const groupAttribute = (0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping);
                    const groupByMultiValueCustomField = yield (0, $aNOuE.select)((0, $j0XCX.isGroupByMultiValueCustomField));
                    const customFieldValuesGroupsById = yield (0, $aNOuE.select)((0, $j0XCX.getCustomFieldValuesGroupsById));
                    if (groupByMultiValueCustomField) {
                        const groupValues = (0, parcelRequire("fZhYM")).default([
                            groupCombination[grouping] ?? '',
                            grouping
                        ], customFieldValuesGroupsById);
                        return {
                            customFields: {
                                [groupAttribute]: groupValues?.map((value)=>typeof value === 'string' ? value : (0, parcelRequire("thm1N")).default(value))
                            }
                        };
                    }
                    return {
                        customFields: {
                            [groupAttribute]: groupCombination[grouping]
                        }
                    };
                }
            default:
                return {};
        }
    }
    function* $7ba8dae83f03b618$export$18efaeddd34b9c24({ payload: payload }) {
        const { hierarchyLevel: hierarchyLevel, parentId: parentId, group: group, groupCombination: groupCombination, grouping: grouping, projectId: projectId } = payload;
        const defaultProjectId = yield (0, $aNOuE.select)((0, $jpXKt.getDefaultProjectId));
        const { isGlobalCreateIssue: isGlobalCreateIssue } = yield (0, $aNOuE.select)((0, $gk0jw.getInlineCreateState));
        const valuesFromGrouping = yield (0, $aNOuE.call)($7ba8dae83f03b618$export$97cc3cee1b036b4c, group, groupCombination, projectId);
        if (!(0, $4nDwW.isDefined)(parentId)) {
            const groupKey = groupCombination ? `:${(0, $2QLMT.getGroupKey)(groupCombination)}` : '';
            yield (0, $aNOuE.put)((0, $21mdo.setIsExpanded)({
                [`IssuesWithoutParentHeader${groupKey}`]: true
            }));
            yield (0, $aNOuE.put)((0, $21mdo.setIsExpanded)({
                [`IssuesWithoutParent-${hierarchyLevel}${groupKey}`]: true
            }));
            yield (0, $aNOuE.call)((0, $hIYGf.delay), 0);
        }
        if (isGlobalCreateIssue && grouping !== (0, $TTKUQ.GROUPING).PROJECT) yield (0, $aNOuE.put)((0, $7K8Pq.startInlineCreate)({
            ...payload,
            projectId: defaultProjectId,
            valuesFromGrouping: valuesFromGrouping
        }));
        else yield (0, $aNOuE.put)((0, $7K8Pq.startInlineCreate)({
            ...payload,
            valuesFromGrouping: valuesFromGrouping
        }));
    }
    function* $7ba8dae83f03b618$export$ce9cde4cd0f70f8d({ payload: payload }) {
        const { group: group, groupCombination: groupCombination = {}, hierarchyLevel: hierarchyLevel, issueTypeId: issueTypeId, projectId: projectId, parentId: parentId, values: values, siblingId: siblingId } = yield (0, $aNOuE.select)((0, $gk0jw.getInlineCreateState));
        const defaultIssuePriority = (yield (0, $aNOuE.select)((0, $jpXKt.getDefaultIssuePriorityByProjectId)))[projectId];
        const color = hierarchyLevel === (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL) ? {
            color: (0, (0, parcelRequire("iHPnC")).toBackendColor)((0, (0, parcelRequire("iHPnC")).getRandomColor)())
        } : {};
        const issue = (0, parcelRequire("ik0Qc")).default(values, {
            priority: values.priority || defaultIssuePriority,
            level: hierarchyLevel,
            summary: payload.title,
            type: issueTypeId,
            project: projectId,
            ...color
        });
        yield (0, $aNOuE.put)((0, $7K8Pq.startInlineCreate)({
            group: group,
            groupCombination: groupCombination,
            hierarchyLevel: hierarchyLevel,
            issueTypeId: issueTypeId,
            parentId: parentId,
            projectId: projectId,
            siblingId: siblingId,
            valuesFromGrouping: values,
            source: 'INLINE'
        }));
        if (parentId) {
            const expandedKey = group ? `${parentId}:${group}` : parentId;
            issue.parent = parentId;
            yield (0, $aNOuE.put)((0, $21mdo.setIsExpanded)({
                [expandedKey]: true
            }));
        }
        yield (0, $aNOuE.put)($7ba8dae83f03b618$export$1102f55b777d8730({
            issue: issue,
            sibling: siblingId
        }));
    }
    const $7ba8dae83f03b618$export$c79743f09a41500d = (description)=>{
        const issueDescriptionInAdfFormat = {
            version: 1,
            type: 'doc',
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: description
                        }
                    ]
                }
            ]
        };
        return JSON.stringify(issueDescriptionInAdfFormat);
    };
    function* $7ba8dae83f03b618$export$fb21c55c3f034d53({ payload: payload }) {
        try {
            const { resolve: resolve, parentIssue: { group: group, groupCombination: groupCombination, hierarchyLevel: hierarchyLevel, parentId: parentId, projectId: projectId }, suggestedIssues: suggestedIssues } = payload;
            const valuesFromGrouping = yield (0, $aNOuE.call)($7ba8dae83f03b618$export$97cc3cee1b036b4c, group, groupCombination, projectId);
            const childIssueHierarchyLevel = hierarchyLevel - 1;
            const color = childIssueHierarchyLevel === (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL) ? {
                color: (0, (0, parcelRequire("iHPnC")).toBackendColor)((0, (0, parcelRequire("iHPnC")).getRandomColor)())
            } : {};
            const expandedKey = group ? `${parentId}:${group}` : parentId;
            yield (0, $aNOuE.put)((0, $21mdo.setIsExpanded)({
                [expandedKey]: true
            }));
            yield (0, $aNOuE.put)((0, $7K8Pq.setIsCreatingIssues)(true));
            const createdIssueIds = [];
            yield* (0, $bYhSc.default)(function*() {
                for (const suggestIssue of suggestedIssues){
                    const newIssue = {
                        ...valuesFromGrouping,
                        level: childIssueHierarchyLevel,
                        summary: suggestIssue.title,
                        description: $7ba8dae83f03b618$export$c79743f09a41500d(suggestIssue.description || ''),
                        type: suggestIssue.issueTypeId,
                        project: projectId,
                        ...color,
                        parent: parentId
                    };
                    const { itemKey: itemKey } = yield (0, $aNOuE.call)((0, $bkasS.doAddIssue), {
                        payload: {
                            issue: newIssue,
                            skipRanking: false,
                            batchRanking: true
                        },
                        type: (0, $74616ed8f6aff060$export$242fccfb90c57247)
                    });
                    if (itemKey?.length > 0) createdIssueIds.push(suggestIssue.id);
                }
            });
            resolve && resolve(createdIssueIds);
        } finally{
            yield (0, $aNOuE.put)((0, $7K8Pq.setIsCreatingIssues)(false));
        }
    }
    function* $7ba8dae83f03b618$export$57e2d6019587c893() {
        yield (0, $6u3NN.takeEvery)($7ba8dae83f03b618$export$bcd650ef032c77dd, $7ba8dae83f03b618$export$ce9cde4cd0f70f8d);
        yield (0, $6u3NN.takeEvery)($7ba8dae83f03b618$export$e4b545016f01a38c, $7ba8dae83f03b618$export$18efaeddd34b9c24);
        yield (0, $6u3NN.takeEvery)($7ba8dae83f03b618$export$f5779843faf46a9d, $7ba8dae83f03b618$export$fb21c55c3f034d53);
    }
    function* $7ba8dae83f03b618$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($7ba8dae83f03b618$export$57e2d6019587c893);
    }
});
parcelRegister("dcevF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99b7a6a9b72d3759$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "delay", ()=>(parcelRequire("hIYGf")).delay);
    var $6YHla = parcelRequire("6YHla");
    var $9U5ge = parcelRequire("9U5ge");
    var $fk7jx = parcelRequire("fk7jx");
    var $jq2wL = parcelRequire("jq2wL");
    var $kZUFp = parcelRequire("kZUFp");
    var $hIYGf = parcelRequire("hIYGf");
    var $aNOuE = parcelRequire("aNOuE");
    var $kUiRw = parcelRequire("kUiRw");
    var $hQy09 = parcelRequire("hQy09");
    var $99b7a6a9b72d3759$export$2e2bcd8739ae039 = (0, $6YHla.default);
});
parcelRegister("6YHla", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5149f72785b121e6$export$2e2bcd8739ae039);
    var $hIYGf = parcelRequire("hIYGf");
    var $fk7jx = parcelRequire("fk7jx");
    var $9U5ge = parcelRequire("9U5ge");
    function $5149f72785b121e6$var$_objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function $5149f72785b121e6$export$2e2bcd8739ae039() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _ref$context = _ref.context, context = _ref$context === undefined ? {} : _ref$context, options = $5149f72785b121e6$var$_objectWithoutProperties(_ref, [
            'context'
        ]);
        var sagaMonitor = options.sagaMonitor, logger = options.logger, onError = options.onError;
        if ((0, $hIYGf.is).func(options)) throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
        if (logger && !(0, $hIYGf.is).func(logger)) throw new Error('`options.logger` passed to the Saga middleware is not a function!');
        if (onError && !(0, $hIYGf.is).func(onError)) throw new Error('`options.onError` passed to the Saga middleware is not a function!');
        if (options.emitter && !(0, $hIYGf.is).func(options.emitter)) throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
        function sagaMiddleware(_ref2) {
            var getState = _ref2.getState, dispatch = _ref2.dispatch;
            var sagaEmitter = (0, $fk7jx.emitter)();
            sagaEmitter.emit = (options.emitter || (0, $hIYGf.ident))(sagaEmitter.emit);
            sagaMiddleware.run = (0, $9U5ge.runSaga).bind(null, {
                context: context,
                subscribe: sagaEmitter.subscribe,
                dispatch: dispatch,
                getState: getState,
                sagaMonitor: sagaMonitor,
                logger: logger,
                onError: onError
            });
            return function(next) {
                return function(action) {
                    if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                    var result = next(action);
                    sagaEmitter.emit(action);
                    return result;
                };
            };
        }
        sagaMiddleware.run = function() {
            throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
        };
        sagaMiddleware.setContext = function(props) {
            (0, $hIYGf.check)(props, (0, $hIYGf.is).object, (0, $hIYGf.createSetContextWarning)('sagaMiddleware', props));
            (0, $hIYGf.object).assign(context, props);
        };
        return sagaMiddleware;
    }
});
parcelRegister("9U5ge", function(module, exports) {
    $parcel$export(module.exports, "runSaga", ()=>$735d6cb57265f084$export$3d8d44bf0c43bb61);
    var $hIYGf = parcelRequire("hIYGf");
    var $4jG6K = parcelRequire("4jG6K");
    var $735d6cb57265f084$var$RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
    var $735d6cb57265f084$var$NON_GENERATOR_ERR = $735d6cb57265f084$var$RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';
    function $735d6cb57265f084$export$3d8d44bf0c43bb61(storeInterface, saga) {
        for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var iterator = void 0;
        if ((0, $hIYGf.is).iterator(storeInterface)) {
            iterator = storeInterface;
            storeInterface = saga;
        } else {
            (0, $hIYGf.check)(saga, (0, $hIYGf.is).func, $735d6cb57265f084$var$NON_GENERATOR_ERR);
            iterator = saga.apply(undefined, args);
            (0, $hIYGf.check)(iterator, (0, $hIYGf.is).iterator, $735d6cb57265f084$var$NON_GENERATOR_ERR);
        }
        var _storeInterface = storeInterface, subscribe = _storeInterface.subscribe, dispatch = _storeInterface.dispatch, getState = _storeInterface.getState, context = _storeInterface.context, sagaMonitor = _storeInterface.sagaMonitor, logger = _storeInterface.logger, onError = _storeInterface.onError;
        var effectId = (0, $hIYGf.uid)();
        if (sagaMonitor) {
            sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, $hIYGf.noop);
            sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, $hIYGf.noop);
            sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, $hIYGf.noop);
            sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, $hIYGf.noop);
            sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, $hIYGf.noop);
            sagaMonitor.effectTriggered({
                effectId: effectId,
                root: true,
                parentEffectId: 0,
                effect: {
                    root: true,
                    saga: saga,
                    args: args
                }
            });
        }
        var task = (0, $4jG6K.default)(iterator, subscribe, (0, $hIYGf.wrapSagaDispatch)(dispatch), getState, context, {
            sagaMonitor: sagaMonitor,
            logger: logger,
            onError: onError
        }, effectId, saga.name);
        if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
        return task;
    }
});
parcelRegister("4jG6K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$324999842aff98df$export$2e2bcd8739ae039);
    var $hIYGf = parcelRequire("hIYGf");
    var $8Zfai = parcelRequire("8Zfai");
    var $aNOuE = parcelRequire("aNOuE");
    var $fk7jx = parcelRequire("fk7jx");
    var $jq2wL = parcelRequire("jq2wL");
    var $324999842aff98df$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var $324999842aff98df$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    function $324999842aff98df$var$_defineEnumerableProperties(obj, descs) {
        for(var key in descs){
            var desc = descs[key];
            desc.configurable = desc.enumerable = true;
            if ("value" in desc) desc.writable = true;
            Object.defineProperty(obj, key, desc);
        }
        return obj;
    }
    var $324999842aff98df$export$e152ed93e7f2bba6 = 'proc first argument (Saga function result) must be an iterator';
    var $324999842aff98df$export$ad61d2aef9f3734 = {
        toString: function toString() {
            return '@@redux-saga/CHANNEL_END';
        }
    };
    var $324999842aff98df$export$a47f788ef0b36709 = {
        toString: function toString() {
            return '@@redux-saga/TASK_CANCEL';
        }
    };
    var $324999842aff98df$var$matchers = {
        wildcard: function wildcard() {
            return 0, $hIYGf.kTrue;
        },
        default: function _default(pattern) {
            return (typeof pattern === 'undefined' ? 'undefined' : $324999842aff98df$var$_typeof(pattern)) === 'symbol' ? function(input) {
                return input.type === pattern;
            } : function(input) {
                return input.type === String(pattern);
            };
        },
        array: function array(patterns) {
            return function(input) {
                return patterns.some(function(p) {
                    return $324999842aff98df$var$matcher(p)(input);
                });
            };
        },
        predicate: function predicate(_predicate) {
            return function(input) {
                return _predicate(input);
            };
        }
    };
    function $324999842aff98df$var$matcher(pattern) {
        return (pattern === '*' ? $324999842aff98df$var$matchers.wildcard : (0, $hIYGf.is).array(pattern) ? $324999842aff98df$var$matchers.array : (0, $hIYGf.is).stringableFunc(pattern) ? $324999842aff98df$var$matchers.default : (0, $hIYGf.is).func(pattern) ? $324999842aff98df$var$matchers.predicate : $324999842aff98df$var$matchers.default)(pattern);
    }
    function $324999842aff98df$var$forkQueue(name, mainTask, cb) {
        var tasks = [], result = void 0, completed = false;
        addTask(mainTask);
        function abort(err) {
            cancelAll();
            cb(err, true);
        }
        function addTask(task) {
            tasks.push(task);
            task.cont = function(res, isErr) {
                if (completed) return;
                (0, $hIYGf.remove)(tasks, task);
                task.cont = (0, $hIYGf.noop);
                if (isErr) abort(res);
                else {
                    if (task === mainTask) result = res;
                    if (!tasks.length) {
                        completed = true;
                        cb(result);
                    }
                }
            };
        }
        function cancelAll() {
            if (completed) return;
            completed = true;
            tasks.forEach(function(t) {
                t.cont = (0, $hIYGf.noop);
                t.cancel();
            });
            tasks = [];
        }
        return {
            addTask: addTask,
            cancelAll: cancelAll,
            abort: abort,
            getTasks: function getTasks() {
                return tasks;
            },
            taskNames: function taskNames() {
                return tasks.map(function(t) {
                    return t.name;
                });
            }
        };
    }
    function $324999842aff98df$var$createTaskIterator(_ref) {
        var context = _ref.context, fn = _ref.fn, args = _ref.args;
        if ((0, $hIYGf.is).iterator(fn)) return fn;
        var result = void 0, error = void 0;
        try {
            result = fn.apply(context, args);
        } catch (err) {
            error = err;
        }
        if ((0, $hIYGf.is).iterator(result)) return result;
        return error ? (0, $hIYGf.makeIterator)(function() {
            throw error;
        }) : (0, $hIYGf.makeIterator)(function() {
            var pc = void 0;
            var eff = {
                done: false,
                value: result
            };
            var ret = function ret(value) {
                return {
                    done: true,
                    value: value
                };
            };
            return function(arg) {
                if (!pc) {
                    pc = true;
                    return eff;
                } else return ret(arg);
            };
        }());
    }
    var $324999842aff98df$var$wrapHelper = function wrapHelper(helper) {
        return {
            fn: helper
        };
    };
    function $324999842aff98df$export$2e2bcd8739ae039(iterator) {
        var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
            return 0, $hIYGf.noop;
        };
        var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $hIYGf.noop);
        var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, $hIYGf.noop);
        var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
        var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
        var cont = arguments[8];
        (0, $hIYGf.check)(iterator, (0, $hIYGf.is).iterator, $324999842aff98df$export$e152ed93e7f2bba6);
        var effectsString = '[...effects]';
        var runParallelEffect = (0, $hIYGf.deprecate)(runAllEffect, (0, $hIYGf.updateIncentive)(effectsString, 'all(' + effectsString + ')'));
        var sagaMonitor = options.sagaMonitor, logger = options.logger, onError = options.onError;
        var log = logger || (0, $hIYGf.log);
        var logError = function logError(err) {
            var message = err.sagaStack;
            if (!message && err.stack) message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
            log('error', 'uncaught at ' + name, message || err.message || err);
        };
        var stdChannel = (0, $fk7jx.stdChannel)(subscribe);
        var taskContext = Object.create(parentContext);
        next.cancel = (0, $hIYGf.noop);
        var task = newTask(parentEffectId, name, iterator, cont);
        var mainTask = {
            name: name,
            cancel: cancelMain,
            isRunning: true
        };
        var taskQueue = $324999842aff98df$var$forkQueue(name, mainTask, end);
        function cancelMain() {
            if (mainTask.isRunning && !mainTask.isCancelled) {
                mainTask.isCancelled = true;
                next($324999842aff98df$export$a47f788ef0b36709);
            }
        }
        function cancel() {
            if (iterator._isRunning && !iterator._isCancelled) {
                iterator._isCancelled = true;
                taskQueue.cancelAll();
                end($324999842aff98df$export$a47f788ef0b36709);
            }
        }
        cont && (cont.cancel = cancel);
        iterator._isRunning = true;
        next();
        return task;
        function next(arg, isErr) {
            if (!mainTask.isRunning) throw new Error('Trying to resume an already finished generator');
            try {
                var result = void 0;
                if (isErr) result = iterator.throw(arg);
                else if (arg === $324999842aff98df$export$a47f788ef0b36709) {
                    mainTask.isCancelled = true;
                    next.cancel();
                    result = (0, $hIYGf.is).func(iterator.return) ? iterator.return($324999842aff98df$export$a47f788ef0b36709) : {
                        done: true,
                        value: $324999842aff98df$export$a47f788ef0b36709
                    };
                } else if (arg === $324999842aff98df$export$ad61d2aef9f3734) result = (0, $hIYGf.is).func(iterator.return) ? iterator.return() : {
                    done: true
                };
                else result = iterator.next(arg);
                if (!result.done) runEffect(result.value, parentEffectId, '', next);
                else {
                    mainTask.isMainRunning = false;
                    mainTask.cont && mainTask.cont(result.value);
                }
            } catch (error) {
                if (mainTask.isCancelled) logError(error);
                mainTask.isMainRunning = false;
                mainTask.cont(error, true);
            }
        }
        function end(result, isErr) {
            iterator._isRunning = false;
            stdChannel.close();
            if (!isErr) {
                iterator._result = result;
                iterator._deferredEnd && iterator._deferredEnd.resolve(result);
            } else {
                if (result instanceof Error) Object.defineProperty(result, 'sagaStack', {
                    value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
                    configurable: true
                });
                if (!task.cont) {
                    if (result instanceof Error && onError) onError(result);
                    else logError(result);
                }
                iterator._error = result;
                iterator._isAborted = true;
                iterator._deferredEnd && iterator._deferredEnd.reject(result);
            }
            task.cont && task.cont(result, isErr);
            task.joiners.forEach(function(j) {
                return j.cb(result, isErr);
            });
            task.joiners = null;
        }
        function runEffect(effect, parentEffectId) {
            var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var cb = arguments[3];
            var effectId = (0, $hIYGf.uid)();
            sagaMonitor && sagaMonitor.effectTriggered({
                effectId: effectId,
                parentEffectId: parentEffectId,
                label: label,
                effect: effect
            });
            var effectSettled = void 0;
            function currCb(res, isErr) {
                if (effectSettled) return;
                effectSettled = true;
                cb.cancel = (0, $hIYGf.noop);
                if (sagaMonitor) isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
                cb(res, isErr);
            }
            currCb.cancel = (0, $hIYGf.noop);
            cb.cancel = function() {
                if (effectSettled) return;
                effectSettled = true;
                try {
                    currCb.cancel();
                } catch (err) {
                    logError(err);
                }
                currCb.cancel = (0, $hIYGf.noop);
                sagaMonitor && sagaMonitor.effectCancelled(effectId);
            };
            var data = void 0;
            return ((0, $hIYGf.is).promise(effect) ? resolvePromise(effect, currCb) : (0, $hIYGf.is).helper(effect) ? runForkEffect($324999842aff98df$var$wrapHelper(effect), effectId, currCb) : (0, $hIYGf.is).iterator(effect) ? resolveIterator(effect, effectId, name, currCb) : (0, $hIYGf.is).array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = (0, $aNOuE.asEffect).take(effect)) ? runTakeEffect(data, currCb) : (data = (0, $aNOuE.asEffect).put(effect)) ? runPutEffect(data, currCb) : (data = (0, $aNOuE.asEffect).all(effect)) ? runAllEffect(data, effectId, currCb) : (data = (0, $aNOuE.asEffect).race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = (0, $aNOuE.asEffect).call(effect)) ? runCallEffect(data, effectId, currCb) : (data = (0, $aNOuE.asEffect).cps(effect)) ? runCPSEffect(data, currCb) : (data = (0, $aNOuE.asEffect).fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = (0, $aNOuE.asEffect).join(effect)) ? runJoinEffect(data, currCb) : (data = (0, $aNOuE.asEffect).cancel(effect)) ? runCancelEffect(data, currCb) : (data = (0, $aNOuE.asEffect).select(effect)) ? runSelectEffect(data, currCb) : (data = (0, $aNOuE.asEffect).actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = (0, $aNOuE.asEffect).flush(effect)) ? runFlushEffect(data, currCb) : (data = (0, $aNOuE.asEffect).cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = (0, $aNOuE.asEffect).getContext(effect)) ? runGetContextEffect(data, currCb) : (data = (0, $aNOuE.asEffect).setContext(effect)) ? runSetContextEffect(data, currCb) : currCb(effect));
        }
        function resolvePromise(promise, cb) {
            var cancelPromise = promise[0, $hIYGf.CANCEL];
            if ((0, $hIYGf.is).func(cancelPromise)) cb.cancel = cancelPromise;
            else if ((0, $hIYGf.is).func(promise.abort)) cb.cancel = function() {
                return promise.abort();
            };
            promise.then(cb, function(error) {
                return cb(error, true);
            });
        }
        function resolveIterator(iterator, effectId, name, cb) {
            $324999842aff98df$export$2e2bcd8739ae039(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
        }
        function runTakeEffect(_ref2, cb) {
            var channel = _ref2.channel, pattern = _ref2.pattern, maybe = _ref2.maybe;
            channel = channel || stdChannel;
            var takeCb = function takeCb(inp) {
                return inp instanceof Error ? cb(inp, true) : (0, $fk7jx.isEnd)(inp) && !maybe ? cb($324999842aff98df$export$ad61d2aef9f3734) : cb(inp);
            };
            try {
                channel.take(takeCb, $324999842aff98df$var$matcher(pattern));
            } catch (err) {
                return cb(err, true);
            }
            cb.cancel = takeCb.cancel;
        }
        function runPutEffect(_ref3, cb) {
            var channel = _ref3.channel, action = _ref3.action, resolve = _ref3.resolve;
            (0, $8Zfai.asap)(function() {
                var result = void 0;
                try {
                    result = (channel ? channel.put : dispatch)(action);
                } catch (error) {
                    if (channel || resolve) return cb(error, true);
                    logError(error);
                }
                if (resolve && (0, $hIYGf.is).promise(result)) resolvePromise(result, cb);
                else return cb(result);
            });
        }
        function runCallEffect(_ref4, effectId, cb) {
            var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
            var result = void 0;
            try {
                result = fn.apply(context, args);
            } catch (error) {
                return cb(error, true);
            }
            return (0, $hIYGf.is).promise(result) ? resolvePromise(result, cb) : (0, $hIYGf.is).iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
        }
        function runCPSEffect(_ref5, cb) {
            var context = _ref5.context, fn = _ref5.fn, args = _ref5.args;
            try {
                var cpsCb = function cpsCb(err, res) {
                    return (0, $hIYGf.is).undef(err) ? cb(res) : cb(err, true);
                };
                fn.apply(context, args.concat(cpsCb));
                if (cpsCb.cancel) cb.cancel = function() {
                    return cpsCb.cancel();
                };
            } catch (error) {
                return cb(error, true);
            }
        }
        function runForkEffect(_ref6, effectId, cb) {
            var context = _ref6.context, fn = _ref6.fn, args = _ref6.args, detached = _ref6.detached;
            var taskIterator = $324999842aff98df$var$createTaskIterator({
                context: context,
                fn: fn,
                args: args
            });
            try {
                (0, $8Zfai.suspend)();
                var _task = $324999842aff98df$export$2e2bcd8739ae039(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : (0, $hIYGf.noop));
                if (detached) cb(_task);
                else {
                    if (taskIterator._isRunning) {
                        taskQueue.addTask(_task);
                        cb(_task);
                    } else if (taskIterator._error) taskQueue.abort(taskIterator._error);
                    else cb(_task);
                }
            } finally{
                (0, $8Zfai.flush)();
            }
        }
        function runJoinEffect(t, cb) {
            if (t.isRunning()) {
                var joiner = {
                    task: task,
                    cb: cb
                };
                cb.cancel = function() {
                    return (0, $hIYGf.remove)(t.joiners, joiner);
                };
                t.joiners.push(joiner);
            } else t.isAborted() ? cb(t.error(), true) : cb(t.result());
        }
        function runCancelEffect(taskToCancel, cb) {
            if (taskToCancel === (0, $hIYGf.SELF_CANCELLATION)) taskToCancel = task;
            if (taskToCancel.isRunning()) taskToCancel.cancel();
            cb();
        }
        function runAllEffect(effects, effectId, cb) {
            var keys = Object.keys(effects);
            if (!keys.length) return cb((0, $hIYGf.is).array(effects) ? [] : {});
            var completedCount = 0;
            var completed = void 0;
            var results = {};
            var childCbs = {};
            function checkEffectEnd() {
                if (completedCount === keys.length) {
                    completed = true;
                    cb((0, $hIYGf.is).array(effects) ? (0, $hIYGf.array).from($324999842aff98df$var$_extends({}, results, {
                        length: keys.length
                    })) : results);
                }
            }
            keys.forEach(function(key) {
                var chCbAtKey = function chCbAtKey(res, isErr) {
                    if (completed) return;
                    if (isErr || (0, $fk7jx.isEnd)(res) || res === $324999842aff98df$export$ad61d2aef9f3734 || res === $324999842aff98df$export$a47f788ef0b36709) {
                        cb.cancel();
                        cb(res, isErr);
                    } else {
                        results[key] = res;
                        completedCount++;
                        checkEffectEnd();
                    }
                };
                chCbAtKey.cancel = (0, $hIYGf.noop);
                childCbs[key] = chCbAtKey;
            });
            cb.cancel = function() {
                if (!completed) {
                    completed = true;
                    keys.forEach(function(key) {
                        return childCbs[key].cancel();
                    });
                }
            };
            keys.forEach(function(key) {
                return runEffect(effects[key], effectId, key, childCbs[key]);
            });
        }
        function runRaceEffect(effects, effectId, cb) {
            var completed = void 0;
            var keys = Object.keys(effects);
            var childCbs = {};
            keys.forEach(function(key) {
                var chCbAtKey = function chCbAtKey(res, isErr) {
                    if (completed) return;
                    if (isErr) {
                        cb.cancel();
                        cb(res, true);
                    } else if (!(0, $fk7jx.isEnd)(res) && res !== $324999842aff98df$export$ad61d2aef9f3734 && res !== $324999842aff98df$export$a47f788ef0b36709) {
                        var _response;
                        cb.cancel();
                        completed = true;
                        var response = (_response = {}, _response[key] = res, _response);
                        cb((0, $hIYGf.is).array(effects) ? [].slice.call($324999842aff98df$var$_extends({}, response, {
                            length: keys.length
                        })) : response);
                    }
                };
                chCbAtKey.cancel = (0, $hIYGf.noop);
                childCbs[key] = chCbAtKey;
            });
            cb.cancel = function() {
                if (!completed) {
                    completed = true;
                    keys.forEach(function(key) {
                        return childCbs[key].cancel();
                    });
                }
            };
            keys.forEach(function(key) {
                if (completed) return;
                runEffect(effects[key], effectId, key, childCbs[key]);
            });
        }
        function runSelectEffect(_ref7, cb) {
            var selector = _ref7.selector, args = _ref7.args;
            try {
                var state = selector.apply(undefined, [
                    getState()
                ].concat(args));
                cb(state);
            } catch (error) {
                cb(error, true);
            }
        }
        function runChannelEffect(_ref8, cb) {
            var pattern = _ref8.pattern, buffer = _ref8.buffer;
            var match = $324999842aff98df$var$matcher(pattern);
            match.pattern = pattern;
            cb((0, $fk7jx.eventChannel)(subscribe, buffer || (0, $jq2wL.buffers).fixed(), match));
        }
        function runCancelledEffect(data, cb) {
            cb(!!mainTask.isCancelled);
        }
        function runFlushEffect(channel, cb) {
            channel.flush(cb);
        }
        function runGetContextEffect(prop, cb) {
            cb(taskContext[prop]);
        }
        function runSetContextEffect(props, cb) {
            (0, $hIYGf.object).assign(taskContext, props);
            cb();
        }
        function newTask(id, name, iterator, cont) {
            var _done, _ref9, _mutatorMap;
            iterator._deferredEnd = null;
            return _ref9 = {}, _ref9[0, $hIYGf.TASK] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function() {
                if (iterator._deferredEnd) return iterator._deferredEnd.promise;
                else {
                    var def = (0, $hIYGf.deferred)();
                    iterator._deferredEnd = def;
                    if (!iterator._isRunning) iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
                    return def.promise;
                }
            }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
                return iterator._isRunning;
            }, _ref9.isCancelled = function isCancelled() {
                return iterator._isCancelled;
            }, _ref9.isAborted = function isAborted() {
                return iterator._isAborted;
            }, _ref9.result = function result() {
                return iterator._result;
            }, _ref9.error = function error() {
                return iterator._error;
            }, _ref9.setContext = function setContext(props) {
                (0, $hIYGf.check)(props, (0, $hIYGf.is).object, (0, $hIYGf.createSetContextWarning)('task', props));
                (0, $hIYGf.object).assign(taskContext, props);
            }, $324999842aff98df$var$_defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
        }
    }
});
parcelRegister("hQy09", function(module, exports) {
    var $hIYGf = parcelRequire("hIYGf");
    var $aNOuE = parcelRequire("aNOuE");
    var $4jG6K = parcelRequire("4jG6K");
});
parcelRegister("iHPnC", function(module, exports) {
    $parcel$export(module.exports, "asColor", ()=>$e626bf77f0e696c5$export$b74af6529f09947);
    $parcel$export(module.exports, "asServerColor", ()=>$e626bf77f0e696c5$export$442690a499ee9598);
    $parcel$export(module.exports, "asClassicEpicColor", ()=>$e626bf77f0e696c5$export$eb754032c0b9698c);
    $parcel$export(module.exports, "transformColorToTheme", ()=>$e626bf77f0e696c5$export$37c9bd72afe7f286);
    $parcel$export(module.exports, "getValueFromColor", ()=>$e626bf77f0e696c5$export$a00423580059ae28);
    $parcel$export(module.exports, "getColorFromValue", ()=>$e626bf77f0e696c5$export$6d14528e40cbe34b);
    $parcel$export(module.exports, "toFrontendColor", ()=>$e626bf77f0e696c5$export$574e4dbf3c01f0ad);
    $parcel$export(module.exports, "toBackendColor", ()=>$e626bf77f0e696c5$export$47af25386a01de1);
    $parcel$export(module.exports, "classicToFrontendColor", ()=>$e626bf77f0e696c5$export$8f81207f7ac5fb9a);
    $parcel$export(module.exports, "classicToBackendColor", ()=>$e626bf77f0e696c5$export$28fb68bb1de025d5);
    $parcel$export(module.exports, "getDefaultColorPalette", ()=>$e626bf77f0e696c5$export$f6e067d5c418081a);
    $parcel$export(module.exports, "getLozengeThemeByColor", ()=>$e626bf77f0e696c5$export$949dc67535a8ff2);
    $parcel$export(module.exports, "getRandomColor", ()=>$e626bf77f0e696c5$export$e4369cabd7e84cd9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $heWHN;
    var $ehxiD;
    var $kFsv3;
    const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).Colors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color];
        return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
    };
    const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).ServerColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
    };
    const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).ClassicEpicColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).AgileColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
        const newColorSchema = {
            ...(0, (0, parcelRequire("heWHN")).BASE_COLOR_SCHEMA),
            ...colorSchemaExtension
        };
        const extendedColors = (colorSchemaExtension ? Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, (0, parcelRequire("kFsv3")).Colors)));
        return extendedColors.reduce((obj, color)=>({
                ...obj,
                [color]: transformation(newColorSchema[color])
            }), {});
    };
    const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[color] || (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[0, (0, parcelRequire("kFsv3")).PURPLE];
    const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>(0, ($parcel$interopDefault($ggSx2)))((0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE))[value] || (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
    const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
    const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).purpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).blueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).tealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).yellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).orangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREY]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkPurpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkBlueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkTealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkYellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkOrangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREY]
            }
        ];
    const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
            color: colorSchema.text,
            backgroundColor: colorSchema.textBackground
        }));
    const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR))=>$e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR];
    const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
        const colorKeys = Object.keys((0, (0, parcelRequire("kFsv3")).Colors));
        return colorKeys[Math.floor(Math.random() * colorKeys.length)];
    };
});
parcelRegister("heWHN", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_EPIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
    $parcel$export(module.exports, "MAP_COLORS_TO_VALUE", ()=>$3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    $parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", ()=>$3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
    $parcel$export(module.exports, "MAP_VALUE_TO_COLOR", ()=>$3a4ee6f2b0ce40ab$export$a6cb26e106674600);
    $parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$43264b0781f10167);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
    $parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
    $parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$db17671bf37971e7);
    $parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c);
    $parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
    $parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$703aca53c431bb88);
    $parcel$export(module.exports, "BASE_COLOR_SCHEMA", ()=>$3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $kFsv3;
    const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
    const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        [(0, (0, parcelRequire("kFsv3")).GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
        [(0, $829f609a65d26a98$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        [(0, $829f609a65d26a98$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        [(0, $829f609a65d26a98$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        [(0, $829f609a65d26a98$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        [(0, $829f609a65d26a98$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        [(0, $829f609a65d26a98$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        [(0, $829f609a65d26a98$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        [(0, $829f609a65d26a98$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        [(0, $829f609a65d26a98$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        [(0, $829f609a65d26a98$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        [(0, $829f609a65d26a98$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        [(0, $829f609a65d26a98$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        [(0, $829f609a65d26a98$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        [(0, $829f609a65d26a98$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
        [(0, (0, parcelRequire("kFsv3")).SERVER_PURPLE)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_PURPLE)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_BLUE)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_BLUE)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREEN)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREEN)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_TEAL)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_TEAL)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_YELLOW)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_YELLOW)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_ORANGE)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_ORANGE)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREY)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREY)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY)
    };
    const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
    const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)
    };
    const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).GREY)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: {
            primary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
            secondary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P500})`,
            text: `var(--ds-text-accent-purple, ${(0, $829f609a65d26a98$exports).P500})`,
            textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $829f609a65d26a98$exports).P50})`,
            border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P400})`,
            line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $829f609a65d26a98$exports).P75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: {
            primary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
            secondary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B500})`,
            text: `var(--ds-text-accent-blue, ${(0, $829f609a65d26a98$exports).B500})`,
            textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$exports).B50})`,
            border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B400})`,
            line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B300})`,
            primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$exports).B75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: {
            primary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            secondary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G500})`,
            text: `var(--ds-text-accent-green, ${(0, $829f609a65d26a98$exports).G500})`,
            textBackground: `var(--ds-background-accent-green-subtler, ${(0, $829f609a65d26a98$exports).G50})`,
            border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G400})`,
            line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $829f609a65d26a98$exports).G75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: {
            primary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
            secondary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T500})`,
            text: `var(--ds-text-accent-teal, ${(0, $829f609a65d26a98$exports).T500})`,
            textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $829f609a65d26a98$exports).T50})`,
            border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T400})`,
            line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $829f609a65d26a98$exports).T75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: {
            primary: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $829f609a65d26a98$exports).Y500})`,
            text: `var(--ds-text-accent-yellow, ${(0, $829f609a65d26a98$exports).Y500})`,
            textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$exports).Y50})`,
            border: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y400})`,
            line: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$exports).Y75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: {
            primary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
            secondary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R500})`,
            text: `var(--ds-text-accent-red, ${(0, $829f609a65d26a98$exports).R500})`,
            textBackground: `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R50})`,
            border: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R400})`,
            line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREY)]: {
            primary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
            secondary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N500})`,
            text: `var(--ds-text-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
            textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N30})`,
            border: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N700})`,
            line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: {
            primary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
            secondary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
            border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P100})`,
            line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: {
            primary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
            secondary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
            border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B200})`,
            line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B100})`,
            primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: {
            primary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
            secondary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
            border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G200})`,
            line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: {
            primary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
            secondary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
            border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T200})`,
            line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: {
            primary: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
            secondary: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
            border: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            line: `var(--ds-border-accent-orange, ${(0, $829f609a65d26a98$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: {
            primary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
            secondary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
            border: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
            line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: {
            primary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`,
            secondary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N300})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N500})`,
            border: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
            line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
            hasContrastSecondaryGradient: false
        }
    };
});
parcelRegister("ehxiD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50b7e3d933c7b9f7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        purpleLabel: {
            "id": "issue-epic-color.common.purple-label",
            "defaultMessage": "purple"
        },
        blueLabel: {
            "id": "issue-epic-color.common.blue-label",
            "defaultMessage": "blue"
        },
        greenLabel: {
            "id": "issue-epic-color.common.green-label",
            "defaultMessage": "green"
        },
        tealLabel: {
            "id": "issue-epic-color.common.teal-label",
            "defaultMessage": "teal"
        },
        yellowLabel: {
            "id": "issue-epic-color.common.yellow-label",
            "defaultMessage": "yellow"
        },
        orangeLabel: {
            "id": "issue-epic-color.common.orange-label",
            "defaultMessage": "orange"
        },
        greyLabel: {
            "id": "issue-epic-color.common.grey-label",
            "defaultMessage": "grey"
        },
        darkPurpleLabel: {
            "id": "issue-epic-color.common.dark-purple-label",
            "defaultMessage": "dark purple"
        },
        darkBlueLabel: {
            "id": "issue-epic-color.common.dark-blue-label",
            "defaultMessage": "dark blue"
        },
        darkGreenLabel: {
            "id": "issue-epic-color.common.dark-green-label",
            "defaultMessage": "dark green"
        },
        darkTealLabel: {
            "id": "issue-epic-color.common.dark-teal-label",
            "defaultMessage": "dark teal"
        },
        darkYellowLabel: {
            "id": "issue-epic-color.common.dark-yellow-label",
            "defaultMessage": "dark yellow"
        },
        darkOrangeLabel: {
            "id": "issue-epic-color.common.dark-orange-label",
            "defaultMessage": "dark orange"
        },
        darkGreyLabel: {
            "id": "issue-epic-color.common.dark-grey-label",
            "defaultMessage": "dark grey"
        }
    });
});
parcelRegister("jn1ls", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46d892ad8e6fbe69$export$2e2bcd8739ae039);
    var $9U6ZH;
    var $2rMKg;
    var $sqeVT;
    var $6Ayrn = parcelRequire("6Ayrn");
    var $gk0jw = parcelRequire("gk0jw");
    var $kllqP = parcelRequire("kllqP");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $jpXKt = parcelRequire("jpXKt");
    var $cGbfF = parcelRequire("cGbfF");
    var $cy8s7 = parcelRequire("cy8s7");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    const $46d892ad8e6fbe69$export$73a2bcc86faf65db = (hierarchyLevels, state)=>{
        const level = state.hierarchyLevel;
        const enrichedLevel = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('level', level), hierarchyLevels);
        return enrichedLevel ? enrichedLevel.issueTypes : [];
    };
    const $46d892ad8e6fbe69$export$f81ff8353d1b194c = (0, $3YtPS.createSelector)([
        (0, $6Ayrn.getEnrichedHierarchyLevels),
        (0, $gk0jw.getInlineCreateState)
    ], $46d892ad8e6fbe69$export$73a2bcc86faf65db);
    const $46d892ad8e6fbe69$export$d63a65fd452a44f = (0, $3YtPS.createSelector)([
        (0, $gk0jw.getInlineCreateState),
        (0, $bI9dZ.getIssueFilterMatcher)
    ], (state, matchFilter)=>(summary)=>{
            const issue = {
                ...state.values,
                summary: summary
            };
            return matchFilter(issue, {
                exclude: [
                    (0, $cGbfF.HIERARCHY_FILTER_ID),
                    (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID)
                ]
            });
        });
    const $46d892ad8e6fbe69$export$c18ad112f2d834c1 = (issueTypes, projects, state, orderedIssueTypes, matchFilter, isSavingIssue)=>{
        const id = (0, parcelRequire("2rMKg")).default('id');
        const issueTypesById = (0, $4nDwW.indexBy)(id, issueTypes);
        const projectsById = (0, $4nDwW.indexBy)(id, projects);
        return {
            id: (0, $cy8s7.INLINE_CREATE_ID),
            issueTypeId: state.issueTypeId,
            projectId: state.projectId,
            hierarchyLevel: state.hierarchyLevel,
            issueTypes: issueTypesById,
            orderedIssueTypes: orderedIssueTypes,
            projects: projectsById,
            isGlobalCreate: state.isGlobalCreateIssue,
            matchFilter: matchFilter,
            isSavingIssue: isSavingIssue,
            isOpenLocked: Object.values(state.openLockedMap).some((value)=>!!value)
        };
    };
    var $46d892ad8e6fbe69$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $kllqP.getIssueTypes),
        (0, $jpXKt.getProjects),
        (0, $gk0jw.getInlineCreateState),
        $46d892ad8e6fbe69$export$f81ff8353d1b194c,
        $46d892ad8e6fbe69$export$d63a65fd452a44f,
        (0, $bI9dZ.isSavingIssue)
    ], $46d892ad8e6fbe69$export$c18ad112f2d834c1);
});
parcelRegister("7SoOT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5a43fbfdc2d7f16$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $jB947;
    var $4S1OS;
    var $fVnbM;
    var $aRoVz;
    var $6Ingq;
    var $gtreQ;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $eTXmK;
    var $eZJjh;
    var $kY99m;
    var $co1wz;
    var $8RXs9;
    var $gJZ5D;
    var $1iMQ1;
    var $J8W7q;
    var $iAUhA;
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $1Cyfv = parcelRequire("1Cyfv");
    var $dHAMa = parcelRequire("dHAMa");
    var $2OC0W = parcelRequire("2OC0W");
    var $9PBLd = parcelRequire("9PBLd");
    const $a5a43fbfdc2d7f16$var$isInlineCreateRow = (target, id, projectMenu, issueMenu)=>{
        let node = target;
        if (node instanceof Node && projectMenu && projectMenu.contains(node)) return true;
        if (node instanceof Node && issueMenu && issueMenu.contains(node)) return true;
        while(node instanceof Node){
            if (node instanceof HTMLElement && node.dataset.issue === id) return true;
            node = node.parentNode;
        }
        return false;
    };
    class $a5a43fbfdc2d7f16$export$bff74f82b631e3d3 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                getContainer: (0, $4y9A5.getBody),
                setDefaultProjectId: ()=>{},
                isGlobalCreate: false
            };
        }
        componentDidMount() {
            this.props.getContainer().addEventListener('click', this.clickOutsideListener, {
                capture: true
            });
            this.props.getContainer().addEventListener('keydown', this.escapeKeyListener);
            const { isSavingIssue: isSavingIssue } = this.props;
            this.timeoutId = setTimeout(()=>{
                if (this.initialProjectIsDefined && !isSavingIssue && this.issueSummaryInputRef) this.issueSummaryInputRef.focus();
            }, 0);
        }
        componentWillUnmount() {
            this.props.getContainer().removeEventListener('click', this.clickOutsideListener, {
                capture: true
            });
            this.props.getContainer().removeEventListener('keydown', this.escapeKeyListener);
            if (this.timeoutId) clearTimeout(this.timeoutId);
        }
        getFilteredProjects(projectsForCurrentIssueTypeLevel) {
            const { projectId: projectId, fixVersions: fixVersions, components: components } = this.props;
            let filteredProjects = projectsForCurrentIssueTypeLevel;
            if (fixVersions && fixVersions.length) {
                const projectsForCurrentReleaseGroup = filteredProjects.filter((project)=>project.id === projectId || project.versions && (0, parcelRequire("4S1OS")).default(project.versions, fixVersions.map((fixVersion)=>fixVersion.toString())).length > 0);
                filteredProjects = projectsForCurrentReleaseGroup.length > 0 ? projectsForCurrentReleaseGroup : filteredProjects;
            } else if (components && components.length) {
                const projectsForCurrentComponentGroup = filteredProjects.filter((project)=>project.id === projectId || project.components && project.components.find((component)=>components.includes(component.id)));
                filteredProjects = projectsForCurrentComponentGroup.length > 0 ? projectsForCurrentComponentGroup : filteredProjects;
            }
            return filteredProjects;
        }
        render() {
            const { id: id, intl: { formatMessage: formatMessage }, issueTypeId: issueTypeId, hierarchyLevel: hierarchyLevel, projectId: projectId, issueTypes: issueTypes, orderedIssueTypes: orderedIssueTypes, projects: projects, cancelInlineCreate: cancelInlineCreate, setIssueTypeId: setIssueTypeId, rootIndex: rootIndex, isReadOnly: isReadOnly = false, setIssueTypeIdForHierarchy: setIssueTypeIdForHierarchy, isSavingIssue: isSavingIssue, fixVersions: fixVersions, components: components } = this.props;
            const { isProjectMenuOpen: isProjectMenuOpen, key: key } = this.state;
            const issueType = issueTypes[issueTypeId];
            const currentLevelIssueTypes = orderedIssueTypes.map(({ id: id })=>id);
            const projectsForCurrentIssueTypeLevel = (0, $4nDwW.values)(projects).filter((project)=>(0, parcelRequire("4S1OS")).default(project.issueTypeIds, currentLevelIssueTypes).length > 0);
            const filteredProjects = this.getFilteredProjects(projectsForCurrentIssueTypeLevel);
            if ((components && components.length || fixVersions && fixVersions.length) && filteredProjects.length === 1) this.setSelectedProjectId(filteredProjects[0].id, currentLevelIssueTypes);
            const project = projects[projectId] || filteredProjects.length === 1 && filteredProjects[0];
            this.initialProjectIsDefined = !!project;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-name": "issue-inline-create",
                className: `${$dHAMa.container} ${(rootIndex + 1) % 2 === 0 ? $dHAMa.even : $dHAMa.odd}`,
                "data-issue": id
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $9PBLd.dropdown,
                "data-name": "issueTypes"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).default), {
                shouldRenderToParent: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? false : undefined,
                trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                        ref: triggerRef,
                        ...props,
                        isDisabled: isReadOnly || orderedIssueTypes.length < 2 || !this.initialProjectIsDefined,
                        iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                            label: ""
                        }),
                        "aria-label": issueType ? issueType.name : formatMessage((0, $2OC0W.default).selectIssueType)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $9PBLd.icon,
                        style: {
                            backgroundSize: 'contain',
                            backgroundImage: issueType && `url(${issueType.iconUrl})`,
                            marginRight: "var(--ds-space-300, 24px)"
                        },
                        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.issue-type-icon.${issueType && issueType.id}`
                    })),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.issue-types-select"
            }, this.initialProjectIsDefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                ref: (ele)=>{
                    this.issueMenu = ele;
                }
            }, orderedIssueTypes.filter((item)=>project.issueTypeIds.includes(item.id)).map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                    id: item.id,
                    onClick: ()=>{
                        setIssueTypeIdForHierarchy(hierarchyLevel, item.id);
                        setIssueTypeId(item.id);
                    },
                    key: item.id
                }, item.name))) : null)), (0, $4nDwW.values)(projects).length > 1 && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $9PBLd.dropdown,
                "data-name": "projects"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).default), {
                defaultOpen: !this.initialProjectIsDefined,
                shouldRenderToParent: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? false : undefined,
                trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                        ref: triggerRef,
                        ...props,
                        isDisabled: isReadOnly || filteredProjects.length === 1,
                        iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                            label: ""
                        })
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: (0, ($parcel$interopDefault($9ci4W)))({
                            [$9PBLd.projectIcon]: this.initialProjectIsDefined
                        }),
                        style: {
                            ...this.initialProjectIsDefined ? {
                                backgroundImage: `url(${project.avatarUrl})`
                            } : {},
                            marginRight: "var(--ds-space-300, 24px)"
                        }
                    }, this.initialProjectIsDefined ? project.key : formatMessage((0, $2OC0W.default).selectProject))),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.select-project",
                isOpen: isProjectMenuOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                ref: (ele)=>{
                    this.projectMenu = ele;
                }
            }, filteredProjects.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                    id: item.id,
                    onClick: ()=>{
                        this.setSelectedProjectId(item.id, currentLevelIssueTypes);
                        this.focusOnSummaryField();
                    },
                    key: item.id,
                    isSelected: item.id === project.id
                }, item.name))))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $9PBLd.inlineEdit,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.inline-edit-input"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iAUhA")).default), {
                defaultValue: "",
                editView: ({ errorMessage: errorMessage, ...fieldProps })=>(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                        placement: "right",
                        isOpen: errorMessage !== undefined || fieldProps && !fieldProps.isInvalid && !this.doesIssueSummaryMatchFilters(fieldProps.value),
                        autoFocus: false,
                        content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                                xcss: $a5a43fbfdc2d7f16$var$popupContentStyles,
                                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.inline-dialog"
                            }, errorMessage || formatMessage((0, $2OC0W.default).notMatchFilterMessage)),
                        trigger: ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                                ref: ref,
                                className: isSavingIssue ? $9PBLd.container : ''
                            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                                ...fieldProps,
                                elemAfterInput: fieldProps && (fieldProps.isInvalid || !this.doesIssueSummaryMatchFilters(fieldProps.value)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                                    label: "",
                                    primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
                                }),
                                isReadOnly: !this.initialProjectIsDefined || isSavingIssue,
                                maxLength: 256,
                                placeholder: formatMessage(isSavingIssue ? (0, $2OC0W.default).savingIssuePlaceholder : (0, $2OC0W.default).titlePlaceholder),
                                "aria-label": formatMessage((0, $2OC0W.default).ariaLabel),
                                ref: (inputEl)=>{
                                    if (inputEl) this.issueSummaryInputRef = inputEl;
                                }
                            }), isSavingIssue && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                                className: $9PBLd.spinner
                            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.saving-spinner"
                            })))
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                        isOpen: errorMessage || fieldProps && !fieldProps.isInvalid && !this.doesIssueSummaryMatchFilters(fieldProps.value),
                        placement: "right",
                        content: errorMessage || formatMessage((0, $2OC0W.default).notMatchFilterMessage),
                        noHorizontalScroll: true,
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.inline-dialog"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: isSavingIssue ? $9PBLd.container : ''
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                        ...fieldProps,
                        elemAfterInput: fieldProps && (fieldProps.isInvalid || !this.doesIssueSummaryMatchFilters(fieldProps.value)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                            label: "",
                            primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
                        }),
                        isReadOnly: !this.initialProjectIsDefined || isSavingIssue,
                        maxLength: 256,
                        placeholder: formatMessage(isSavingIssue ? (0, $2OC0W.default).savingIssuePlaceholder : (0, $2OC0W.default).titlePlaceholder),
                        "aria-label": formatMessage((0, $2OC0W.default).ariaLabel),
                        ref: (inputEl)=>{
                            if (inputEl) this.issueSummaryInputRef = inputEl;
                        }
                    }), isSavingIssue && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $9PBLd.spinner
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.saving-spinner"
                    })))),
                hideActionButtons: isSavingIssue,
                keepEditViewOpenOnBlur: true,
                key: key,
                onCancel: cancelInlineCreate,
                onConfirm: this.saveIssue,
                readView: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
                startWithEditViewOpen: true,
                validate: this.validateIssueSummary
            })));
        }
        constructor(...args){
            super(...args);
            this.initialProjectIsDefined = false;
            this.state = {
                key: Math.random(),
                isProjectMenuOpen: false
            };
            this.clickOutsideListener = (e)=>{
                if (!$a5a43fbfdc2d7f16$var$isInlineCreateRow(e.target, this.props.id, this.projectMenu, this.issueMenu) && !this.props.isOpenLocked) this.props.cancelInlineCreate();
            };
            this.escapeKeyListener = (e)=>{
                if (e.key === 'Escape') this.props.cancelInlineCreate();
            };
            this.focusOnSummaryField = ()=>{
                this.setState({
                    isProjectMenuOpen: false
                }, ()=>{
                    if (this.issueSummaryInputRef) this.issueSummaryInputRef.focus();
                });
            };
            this.setSelectedProjectId = (id, currentLevelIssueTypes)=>{
                const { setProjectId: setProjectId, projects: projects, issueTypeId: issueTypeId, setIssueTypeId: setIssueTypeId, setDefaultProjectId: setDefaultProjectId, isGlobalCreate: isGlobalCreate } = this.props;
                const project = projects[id];
                if (!project) throw new Error(`Project with id ${id} is not found in plan`);
                setProjectId(id);
                if (isGlobalCreate === true) setDefaultProjectId(id);
                if (!project.issueTypeIds.includes(issueTypeId)) {
                    const newIssueType = (0, parcelRequire("jB947")).default((0, parcelRequire("4S1OS")).default(project.issueTypeIds, currentLevelIssueTypes));
                    if (!(0, $4nDwW.isDefined)(newIssueType)) throw new Error(`Available project with id ${project.id} must contain an issue type of current level (one of ${currentLevelIssueTypes.join(', ')})`);
                    setIssueTypeId(newIssueType);
                }
            };
            this.saveIssue = (title)=>{
                const titleValue = title && title.trim();
                (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).CREATE_ISSUE);
                if ((0, $4nDwW.isDefined)(titleValue) && titleValue.length > 0) this.props.createIssueWithTitle(title);
                this.setState({
                    key: Math.random()
                }, ()=>{
                    if (this.issueSummaryInputRef) this.issueSummaryInputRef.focus();
                });
            };
            this.doesIssueSummaryMatchFilters = (summary)=>summary.length === 0 || this.props.matchFilter(summary);
            this.validateIssueSummary = (summary)=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                if (summary.trim().length === 0) return formatMessage((0, $2OC0W.default).blankInputErrorMessage);
                if (summary.length > 255) return formatMessage((0, $2OC0W.default).tooLongInputErrorMessage);
                return undefined;
            };
        }
    }
    var $a5a43fbfdc2d7f16$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($a5a43fbfdc2d7f16$export$bff74f82b631e3d3);
    const $a5a43fbfdc2d7f16$var$popupContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.200'
    });
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("iAUhA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$838e537b0685c754$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bopR4;
    class $838e537b0685c754$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bopR4")).default), this.props);
        }
    }
});
parcelRegister("bopR4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fb3572edb783a8f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $7O4UO;
    var $efXp3;
    var $VSDnB;
    var $5ILhZ;
    var $jldZL;
    var $1PDuf;
    var $pZGLJ;
    var $6LLMl;
    function $9fb3572edb783a8f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9fb3572edb783a8f$var$fieldStyles = {
        name: "nziz0a",
        styles: "max-width:100%;position:relative"
    };
    const $9fb3572edb783a8f$var$analyticsAttributes = {
        componentName: 'inlineEdit',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $9fb3572edb783a8f$var$InnerInlineEdit = (props)=>{
        const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
        const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
        const isControlled = typeof isEditing === 'undefined';
        const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
        const timerRef = (0, $5uXOq.useRef)();
        const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, (0, parcelRequire("pZGLJ")).default)(isEditing, isEditingState);
        const onCancel = (0, $5uXOq.useCallback)(()=>{
            if (isControlled) setEditingState(false);
            providedOnCancel?.();
        }, [
            isControlled,
            providedOnCancel
        ]);
        const onEditRequested = (0, $5uXOq.useCallback)(()=>{
            if (isControlled) setEditingState(true);
            providedOnEdit?.();
            if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
        }, [
            isControlled,
            shouldBeEditing,
            editViewRef,
            providedOnEdit
        ]);
        const onConfirm = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                if (isControlled) setEditingState(false);
                providedOnConfirm(value, analyticsEvent);
            },
            action: 'confirmed',
            analyticsData: analyticsContext,
            ...$9fb3572edb783a8f$var$analyticsAttributes
        });
        const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            onCancel();
        }, [
            onCancel
        ]);
        const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
            if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
                doNotFocusOnEditButton();
                if (formRef.current.checkValidity()) onSubmit();
            }
        }, [
            doNotFocusOnEditButton
        ]);
        const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
            if (!keepEditViewOpenOnBlur) {
                wasFocusReceivedSinceLastBlurRef.current = false;
                timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
            }
        }, [
            keepEditViewOpenOnBlur,
            tryAutoSubmitWhenBlur
        ]);
        const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
            wasFocusReceivedSinceLastBlurRef.current = true;
        }, []);
        const concatenatedEditButtonLabel = ()=>{
            if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
            return `${editButtonLabel}, ${editLabel}`;
        };
        const renderReadView = ()=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6LLMl")).default), {
                editButtonLabel: concatenatedEditButtonLabel(),
                onEditRequested: onEditRequested,
                postReadViewClick: doNotFocusOnEditButton,
                editButtonRef: editButtonRef,
                readViewFitContainerWidth: readViewFitContainerWidth,
                readView: readView,
                testId: testId
            });
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("efXp3")).default), {
            onSubmit: (data)=>onConfirm(data.inlineEdit)
        }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("form", {
                role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef
            }, shouldBeEditing ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7O4UO")).default), {
                name: "inlineEdit",
                label: label,
                defaultValue: defaultValue,
                validate: validate,
                isRequired: isRequired,
                key: "edit-view"
            }, ({ fieldProps: fieldProps, error: error })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $9fb3572edb783a8f$var$fieldStyles,
                    onBlur: (e)=>{
                        if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                    },
                    onFocus: onEditViewWrapperFocus
                }, editView({
                    ...fieldProps,
                    errorMessage: error
                }, editViewRef), !hideActionButtons ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1PDuf")).default), {
                    testId: testId,
                    cancelButtonLabel: cancelButtonLabel,
                    confirmButtonLabel: confirmButtonLabel,
                    onMouseDown: ()=>{
                        doNotFocusOnEditButton();
                    },
                    onCancelClick: (e)=>{
                        reset();
                        onCancelClick(e);
                    }
                }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
                    hidden: true,
                    type: "submit"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, "Submit")))) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7O4UO")).default), {
                name: "inlineEdit",
                label: label,
                defaultValue: "",
                isRequired: isRequired,
                key: "read-view"
            }, renderReadView)));
    };
    const $9fb3572edb783a8f$var$InlineEdit = (props)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)($9fb3572edb783a8f$var$InnerInlineEdit, props);
    };
    var $9fb3572edb783a8f$export$2e2bcd8739ae039 = $9fb3572edb783a8f$var$InlineEdit;
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("1PDuf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55d92d54fb10d87e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $42CjB;
    var $kbxJz;
    var $lLLkM;
    function $55d92d54fb10d87e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $55d92d54fb10d87e$var$buttonsContainerStyles = {
        name: "ki22df",
        styles: "display:flex;position:absolute;flex-shrink:0;inset-block-start:100%;inset-inline-end:0;margin-block-start:var(--ds-space-075, 6px)"
    };
    const $55d92d54fb10d87e$var$buttonWrapperBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        width: "var(--ds-space-400, 32px)",
        zIndex: 200,
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&:last-child': {
            marginInlineStart: "var(--ds-space-050, 4px)"
        },
        '& > button': {
            backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
        },
        '& > button:hover': {
            backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
        },
        '& > button:active': {
            backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        }
    });
    const $55d92d54fb10d87e$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $55d92d54fb10d87e$var$buttonsContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $55d92d54fb10d87e$var$buttonWrapperBaseStyles,
            tabIndex: -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            type: "submit",
            icon: (iconProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("kbxJz"))))), {
                    ...iconProps,
                    size: "small"
                }),
            onMouseDown: onMouseDown,
            label: confirmButtonLabel,
            testId: testId && `${testId}--confirm`
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $55d92d54fb10d87e$var$buttonWrapperBaseStyles,
            tabIndex: -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            icon: (iconProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
                    ...iconProps,
                    size: "small"
                }),
            label: cancelButtonLabel,
            onClick: onCancelClick,
            onMouseDown: onMouseDown,
            testId: testId && `${testId}--cancel`
        })));
    };
    var $55d92d54fb10d87e$export$2e2bcd8739ae039 = $55d92d54fb10d87e$var$Buttons;
});
parcelRegister("pZGLJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5aa752dd00081f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d5aa752dd00081f6$var$usePrevious = (value)=>{
        const ref = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    const $d5aa752dd00081f6$var$useButtonFocusHook = (isEditing, isEditingState)=>{
        const editButtonRef = (0, $5uXOq.useRef)(null);
        const editViewRef = (0, $5uXOq.useRef)();
        const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
        const isControlled = typeof isEditing === 'undefined';
        const shouldBeEditing = isControlled ? isEditingState : isEditing;
        const prevIsEditing = $d5aa752dd00081f6$var$usePrevious(shouldBeEditing);
        (0, $5uXOq.useEffect)(()=>{
            if (isEditingState && editViewRef.current) editViewRef.current.focus();
        }, [
            editViewRef,
            isEditingState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (prevIsEditing && !shouldBeEditing) {
                if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
                else if (editButtonRef && editButtonRef.current) editButtonRef.current.focus();
            }
        }, [
            prevIsEditing,
            shouldBeEditing
        ]);
        const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
        return {
            editButtonRef: editButtonRef,
            editViewRef: editViewRef,
            shouldBeEditing: shouldBeEditing,
            doNotFocusOnEditButton: doNotFocusOnEditButton
        };
    };
    var $d5aa752dd00081f6$export$2e2bcd8739ae039 = $d5aa752dd00081f6$var$useButtonFocusHook;
});
parcelRegister("6LLMl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ba9adf9a6463766$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5ILhZ;
    var $8CUq3;
    function $1ba9adf9a6463766$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1ba9adf9a6463766$var$readViewContainerStyles = {
        name: "1xe63ku",
        styles: "line-height:1"
    };
    const $1ba9adf9a6463766$var$editButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'block',
        margin: 'space.0',
        padding: 'space.0',
        appearance: 'none',
        background: 'transparent',
        border: 0,
        lineHeight: 1,
        outline: 0,
        ':focus-visible': {
            outline: 0
        },
        ':focus + div': {
            borderColor: 'color.border.focused',
            borderWidth: 'border.width.outline',
            borderStyle: 'solid'
        }
    });
    const $1ba9adf9a6463766$var$readViewWrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        boxSizing: 'border-box',
        width: 'auto',
        maxWidth: '100%',
        border: '2px solid transparent',
        borderRadius: "var(--ds-border-radius, 3px)",
        transition: 'background 0.2s',
        '&:hover': {
            background: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        }
    });
    const $1ba9adf9a6463766$var$readViewFitContainerWidthStyles = {
        name: "1d3w5wq",
        styles: "width:100%"
    };
    const $1ba9adf9a6463766$var$DRAG_THRESHOLD = 5;
    const $1ba9adf9a6463766$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
        const startX = (0, $5uXOq.useRef)(0);
        const startY = (0, $5uXOq.useRef)(0);
        const mouseHasMovedAfterMouseDown = (event)=>{
            return Math.abs(startX.current - event.clientX) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD;
        };
        const onReadViewClick = (event)=>{
            const element = event.target;
            if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
                event.preventDefault();
                onEditRequested();
                postReadViewClick();
            }
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1ba9adf9a6463766$var$readViewContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $1ba9adf9a6463766$var$editButtonStyles,
            onClick: onEditRequested,
            ref: editButtonRef,
            testId: testId && `${testId}--edit-button`,
            "aria-label": editButtonLabel
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $1ba9adf9a6463766$var$readViewWrapperStyles,
                readViewFitContainerWidth && $1ba9adf9a6463766$var$readViewFitContainerWidthStyles
            ],
            role: "presentation",
            onClick: onReadViewClick,
            onMouseDown: (e)=>{
                startX.current = e.clientX;
                startY.current = e.clientY;
            },
            "data-read-view-fit-container-width": readViewFitContainerWidth
        }, readView()));
    };
    var $1ba9adf9a6463766$export$2e2bcd8739ae039 = $1ba9adf9a6463766$var$ReadView;
});
parcelRegister("dHAMa", function(module, exports) {
    $parcel$export(module.exports, "addIcon", ()=>$9f9bd171bd58dfd8$export$3488242433cbedb, (v)=>$9f9bd171bd58dfd8$export$3488242433cbedb = v);
    $parcel$export(module.exports, "container", ()=>$9f9bd171bd58dfd8$export$34e0f9847d4c02dd, (v)=>$9f9bd171bd58dfd8$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "drop-parent", ()=>$9f9bd171bd58dfd8$export$863710ae9975cbf6, (v)=>$9f9bd171bd58dfd8$export$863710ae9975cbf6 = v);
    $parcel$export(module.exports, "ellipsis", ()=>$9f9bd171bd58dfd8$export$a5b94313d6908893, (v)=>$9f9bd171bd58dfd8$export$a5b94313d6908893 = v);
    $parcel$export(module.exports, "even", ()=>$9f9bd171bd58dfd8$export$df5fefc55a4eba3c, (v)=>$9f9bd171bd58dfd8$export$df5fefc55a4eba3c = v);
    $parcel$export(module.exports, "evenOptimized", ()=>$9f9bd171bd58dfd8$export$df20a5f04e27573e, (v)=>$9f9bd171bd58dfd8$export$df20a5f04e27573e = v);
    $parcel$export(module.exports, "flyoutPositioner", ()=>$9f9bd171bd58dfd8$export$c6ee8e29facfa055, (v)=>$9f9bd171bd58dfd8$export$c6ee8e29facfa055 = v);
    $parcel$export(module.exports, "group-indentation", ()=>$9f9bd171bd58dfd8$export$843e51c921ce4d8d, (v)=>$9f9bd171bd58dfd8$export$843e51c921ce4d8d = v);
    $parcel$export(module.exports, "icon", ()=>$9f9bd171bd58dfd8$export$1ca1ec8b29a4ce27, (v)=>$9f9bd171bd58dfd8$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "isDragging", ()=>$9f9bd171bd58dfd8$export$9e9bc3c487fccc00, (v)=>$9f9bd171bd58dfd8$export$9e9bc3c487fccc00 = v);
    $parcel$export(module.exports, "isSelected", ()=>$9f9bd171bd58dfd8$export$e4d153b3e021fb47, (v)=>$9f9bd171bd58dfd8$export$e4d153b3e021fb47 = v);
    $parcel$export(module.exports, "issue-icon", ()=>$9f9bd171bd58dfd8$export$39bed5d6a23c78de, (v)=>$9f9bd171bd58dfd8$export$39bed5d6a23c78de = v);
    $parcel$export(module.exports, "issue-icon-old", ()=>$9f9bd171bd58dfd8$export$655a12e775c013c3, (v)=>$9f9bd171bd58dfd8$export$655a12e775c013c3 = v);
    $parcel$export(module.exports, "issueIconTooltipWrapper", ()=>$9f9bd171bd58dfd8$export$96298c959d38f53e, (v)=>$9f9bd171bd58dfd8$export$96298c959d38f53e = v);
    $parcel$export(module.exports, "odd", ()=>$9f9bd171bd58dfd8$export$74b48c691cc42eb1, (v)=>$9f9bd171bd58dfd8$export$74b48c691cc42eb1 = v);
    $parcel$export(module.exports, "oddOptimized", ()=>$9f9bd171bd58dfd8$export$f1f85ff3be680a56, (v)=>$9f9bd171bd58dfd8$export$f1f85ff3be680a56 = v);
    $parcel$export(module.exports, "parent-match", ()=>$9f9bd171bd58dfd8$export$97878a1315ed5db7, (v)=>$9f9bd171bd58dfd8$export$97878a1315ed5db7 = v);
    $parcel$export(module.exports, "rank", ()=>$9f9bd171bd58dfd8$export$fbc8bcd33b574fbc, (v)=>$9f9bd171bd58dfd8$export$fbc8bcd33b574fbc = v);
    $parcel$export(module.exports, "ranked-gutter", ()=>$9f9bd171bd58dfd8$export$d93565a96911fbba, (v)=>$9f9bd171bd58dfd8$export$d93565a96911fbba = v);
    $parcel$export(module.exports, "select-checkbox", ()=>$9f9bd171bd58dfd8$export$866f1d976e6380d8, (v)=>$9f9bd171bd58dfd8$export$866f1d976e6380d8 = v);
    $parcel$export(module.exports, "summary", ()=>$9f9bd171bd58dfd8$export$9a2dbef7a17e2e58, (v)=>$9f9bd171bd58dfd8$export$9a2dbef7a17e2e58 = v);
    $parcel$export(module.exports, "summaryBtn", ()=>$9f9bd171bd58dfd8$export$d323a95d9c47e84b, (v)=>$9f9bd171bd58dfd8$export$d323a95d9c47e84b = v);
    $parcel$export(module.exports, "summaryReadView", ()=>$9f9bd171bd58dfd8$export$10ac4ca9f19e16f5, (v)=>$9f9bd171bd58dfd8$export$10ac4ca9f19e16f5 = v);
    $parcel$export(module.exports, "toggle", ()=>$9f9bd171bd58dfd8$export$e03c1c3201ee8bb7, (v)=>$9f9bd171bd58dfd8$export$e03c1c3201ee8bb7 = v);
    var $9f9bd171bd58dfd8$export$3488242433cbedb;
    var $9f9bd171bd58dfd8$export$34e0f9847d4c02dd;
    var $9f9bd171bd58dfd8$export$863710ae9975cbf6;
    var $9f9bd171bd58dfd8$export$a5b94313d6908893;
    var $9f9bd171bd58dfd8$export$df5fefc55a4eba3c;
    var $9f9bd171bd58dfd8$export$df20a5f04e27573e;
    var $9f9bd171bd58dfd8$export$c6ee8e29facfa055;
    var $9f9bd171bd58dfd8$export$843e51c921ce4d8d;
    var $9f9bd171bd58dfd8$export$1ca1ec8b29a4ce27;
    var $9f9bd171bd58dfd8$export$9e9bc3c487fccc00;
    var $9f9bd171bd58dfd8$export$e4d153b3e021fb47;
    var $9f9bd171bd58dfd8$export$39bed5d6a23c78de;
    var $9f9bd171bd58dfd8$export$655a12e775c013c3;
    var $9f9bd171bd58dfd8$export$96298c959d38f53e;
    var $9f9bd171bd58dfd8$export$214f72c33ec0736b;
    var $9f9bd171bd58dfd8$export$9c30223ca0a664fb;
    var $9f9bd171bd58dfd8$export$74b48c691cc42eb1;
    var $9f9bd171bd58dfd8$export$f1f85ff3be680a56;
    var $9f9bd171bd58dfd8$export$97878a1315ed5db7;
    var $9f9bd171bd58dfd8$export$fbc8bcd33b574fbc;
    var $9f9bd171bd58dfd8$export$d93565a96911fbba;
    var $9f9bd171bd58dfd8$export$866f1d976e6380d8;
    var $9f9bd171bd58dfd8$export$9a2dbef7a17e2e58;
    var $9f9bd171bd58dfd8$export$d323a95d9c47e84b;
    var $9f9bd171bd58dfd8$export$10ac4ca9f19e16f5;
    var $9f9bd171bd58dfd8$export$e03c1c3201ee8bb7;
    var $9f9bd171bd58dfd8$export$cce7aaa89215f32b;
    var $9f9bd171bd58dfd8$export$8db6fdef835e2b1b;
    $9f9bd171bd58dfd8$export$3488242433cbedb = `ra40ka_addIcon`;
    $9f9bd171bd58dfd8$export$34e0f9847d4c02dd = `ra40ka_container`;
    $9f9bd171bd58dfd8$export$863710ae9975cbf6 = `ra40ka_drop-parent`;
    $9f9bd171bd58dfd8$export$a5b94313d6908893 = `ra40ka_ellipsis`;
    $9f9bd171bd58dfd8$export$df5fefc55a4eba3c = `ra40ka_even`;
    $9f9bd171bd58dfd8$export$df20a5f04e27573e = `ra40ka_evenOptimized`;
    $9f9bd171bd58dfd8$export$c6ee8e29facfa055 = `ra40ka_flyoutPositioner`;
    $9f9bd171bd58dfd8$export$843e51c921ce4d8d = `ra40ka_group-indentation`;
    $9f9bd171bd58dfd8$export$1ca1ec8b29a4ce27 = `ra40ka_icon`;
    $9f9bd171bd58dfd8$export$9e9bc3c487fccc00 = `ra40ka_isDragging`;
    $9f9bd171bd58dfd8$export$e4d153b3e021fb47 = `ra40ka_isSelected`;
    $9f9bd171bd58dfd8$export$39bed5d6a23c78de = `ra40ka_issue-icon`;
    $9f9bd171bd58dfd8$export$655a12e775c013c3 = `ra40ka_issue-icon-old`;
    $9f9bd171bd58dfd8$export$96298c959d38f53e = `ra40ka_issueIconTooltipWrapper`;
    $9f9bd171bd58dfd8$export$214f72c33ec0736b = `ra40ka_light-summary`;
    $9f9bd171bd58dfd8$export$9c30223ca0a664fb = `ra40ka_link`;
    $9f9bd171bd58dfd8$export$74b48c691cc42eb1 = `ra40ka_odd`;
    $9f9bd171bd58dfd8$export$f1f85ff3be680a56 = `ra40ka_oddOptimized`;
    $9f9bd171bd58dfd8$export$97878a1315ed5db7 = `ra40ka_parent-match`;
    $9f9bd171bd58dfd8$export$fbc8bcd33b574fbc = `ra40ka_rank`;
    $9f9bd171bd58dfd8$export$d93565a96911fbba = `ra40ka_ranked-gutter`;
    $9f9bd171bd58dfd8$export$866f1d976e6380d8 = `ra40ka_select-checkbox`;
    $9f9bd171bd58dfd8$export$9a2dbef7a17e2e58 = `ra40ka_summary`;
    $9f9bd171bd58dfd8$export$d323a95d9c47e84b = `ra40ka_summaryBtn`;
    $9f9bd171bd58dfd8$export$10ac4ca9f19e16f5 = `ra40ka_summaryReadView`;
    $9f9bd171bd58dfd8$export$e03c1c3201ee8bb7 = `ra40ka_toggle`;
    $9f9bd171bd58dfd8$export$cce7aaa89215f32b = `ra40ka_warnings`;
    $9f9bd171bd58dfd8$export$8db6fdef835e2b1b = `ra40ka_warningsOptimized`;
});
parcelRegister("2OC0W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$201946f6732a92cd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $201946f6732a92cd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titlePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.title-placeholder",
            "defaultMessage": "Issue summary ..."
        },
        ariaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.aria-label",
            "defaultMessage": "Issue summary"
        },
        savingIssuePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.saving-issue-placeholder",
            "defaultMessage": "Creating issue ..."
        },
        selectProject: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.select-project",
            "defaultMessage": "Choose project"
        },
        selectIssueType: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.select-issue-type",
            "defaultMessage": "Choose issue type"
        },
        blankInputErrorMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.blank-input-error-message",
            "defaultMessage": "You must specify a summary of the issue."
        },
        notMatchFilterMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.not-match-filter-message",
            "defaultMessage": "This issue will be created, but won't be visible due to the applied filters."
        },
        tooLongInputErrorMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.too-long-input-error-message",
            "defaultMessage": "Summary must be less than 256 characters."
        }
    });
});
parcelRegister("9PBLd", function(module, exports) {
    $parcel$export(module.exports, "container", ()=>$72862af22e7df0a1$export$34e0f9847d4c02dd, (v)=>$72862af22e7df0a1$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "dropdown", ()=>$72862af22e7df0a1$export$81207e5cc4186890, (v)=>$72862af22e7df0a1$export$81207e5cc4186890 = v);
    $parcel$export(module.exports, "icon", ()=>$72862af22e7df0a1$export$1ca1ec8b29a4ce27, (v)=>$72862af22e7df0a1$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "inlineEdit", ()=>$72862af22e7df0a1$export$ba770051015ef5e7, (v)=>$72862af22e7df0a1$export$ba770051015ef5e7 = v);
    $parcel$export(module.exports, "projectIcon", ()=>$72862af22e7df0a1$export$e595ab851fd6d370, (v)=>$72862af22e7df0a1$export$e595ab851fd6d370 = v);
    $parcel$export(module.exports, "spinner", ()=>$72862af22e7df0a1$export$641374ffb95bc399, (v)=>$72862af22e7df0a1$export$641374ffb95bc399 = v);
    var $72862af22e7df0a1$export$cdf6733243a3cd26;
    var $72862af22e7df0a1$export$34e0f9847d4c02dd;
    var $72862af22e7df0a1$export$81207e5cc4186890;
    var $72862af22e7df0a1$export$1ca1ec8b29a4ce27;
    var $72862af22e7df0a1$export$ba770051015ef5e7;
    var $72862af22e7df0a1$export$e595ab851fd6d370;
    var $72862af22e7df0a1$export$641374ffb95bc399;
    var $72862af22e7df0a1$export$a6dea3b909d8edf2;
    var $72862af22e7df0a1$export$82d15ec6f07228ea;
    var $72862af22e7df0a1$export$8cc0b96c9ae1fca1;
    $72862af22e7df0a1$export$cdf6733243a3cd26 = `CzkEIW_assertiveIcon`;
    $72862af22e7df0a1$export$34e0f9847d4c02dd = `CzkEIW_container`;
    $72862af22e7df0a1$export$81207e5cc4186890 = `CzkEIW_dropdown`;
    $72862af22e7df0a1$export$1ca1ec8b29a4ce27 = `CzkEIW_icon`;
    $72862af22e7df0a1$export$ba770051015ef5e7 = `CzkEIW_inlineEdit`;
    $72862af22e7df0a1$export$e595ab851fd6d370 = `CzkEIW_projectIcon`;
    $72862af22e7df0a1$export$641374ffb95bc399 = `CzkEIW_spinner`;
    $72862af22e7df0a1$export$a6dea3b909d8edf2 = `CzkEIW_validationIcon`;
    $72862af22e7df0a1$export$82d15ec6f07228ea = `CzkEIW_validationText`;
    $72862af22e7df0a1$export$8cc0b96c9ae1fca1 = `CzkEIW_validationTextMessage`;
});
parcelRegister("3oPSC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bed2eb89dc277cdf$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9hAo9 = parcelRequire("9hAo9");
    var $1Mfcu = parcelRequire("1Mfcu");
    var $6NO9E = parcelRequire("6NO9E");
    var $bed2eb89dc277cdf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $1Mfcu.default), (0, $9hAo9.default))((0, $6NO9E.default));
});
parcelRegister("9hAo9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81bde9a52bcf3e30$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $g1lIV = parcelRequire("g1lIV");
    var $81bde9a52bcf3e30$export$2e2bcd8739ae039 = (dispatch)=>({
            setIssueBeingEdited: (issueId)=>{
                dispatch((0, $g1lIV.setIssueBeingEdited)(issueId));
            },
            setDescription: (issueId, description)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issueId,
                    description: description
                }));
            },
            onChange: (payload)=>{
                dispatch((0, $bkasS.updateIssueRaw)(payload));
            }
        });
});
parcelRegister("1Mfcu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e0cc94264309fcc$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $b2qEg = parcelRequire("b2qEg");
    var $jpXKt = parcelRequire("jpXKt");
    var $jLI87 = parcelRequire("jLI87");
    var $3YtPS = parcelRequire("3YtPS");
    var $2e0cc94264309fcc$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        isLoadingIssueDescription: (0, $b2qEg.getIsLoadingIssueDescription),
        isOptimizedMode: $1CGdp.isOptimizedMode,
        isReadOnly: $1CGdp.isReadOnly,
        issueBeingEdited: (0, $b2qEg.getIssueBeingEdited),
        issuesById: (0, $jLI87.getAllIssuesWithOriginalAndOptimizedById),
        projectsById: (0, $jpXKt.getProjectsById)
    });
});
parcelRegister("b2qEg", function(module, exports) {
    $parcel$export(module.exports, "getIssueBeingEdited", ()=>$f73efbf3f825513b$export$34428deb778432d3);
    $parcel$export(module.exports, "getIsLoadingIssueDescription", ()=>$f73efbf3f825513b$export$f22b627877ebce48);
    const $f73efbf3f825513b$export$34428deb778432d3 = (state)=>state.domain.issueModal.issueBeingEdited;
    const $f73efbf3f825513b$export$f22b627877ebce48 = (state)=>state.domain.issueModal.isLoadingIssueDescription;
});
parcelRegister("6NO9E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ed79f8e7b1e7990$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JlG5;
    var $lLLkM;
    var $gtreQ;
    var $1R1Ge;
    var $7QSqG;
    var $kY99m;
    var $3bDjY;
    var $i0vxP;
    var $9fuVs;
    var $8RXs9;
    var $lfTZh;
    var $aCpcO;
    var $gJZ5D;
    var $J8W7q;
    var $iAUhA;
    var $enoTt;
    var $i2qlb = parcelRequire("i2qlb");
    var $4nDwW = parcelRequire("4nDwW");
    var $kC16r = parcelRequire("kC16r");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $8zOmE;
    var $2NMNM;
    var $g5X3G;
    var $h89Vx = parcelRequire("h89Vx");
    var $itQja = parcelRequire("itQja");
    var $1CWWe = parcelRequire("1CWWe");
    const $5ed79f8e7b1e7990$var$LazyDescriptionEditor = (0, $5uXOq.lazy)(()=>(parcelRequire("47Ijy")));
    function $5ed79f8e7b1e7990$var$IssueModal({ BreadcrumbsComponent: BreadcrumbsComponent = (0, $h89Vx.default), DescriptionEditorComponent: DescriptionEditorComponent = $5ed79f8e7b1e7990$var$LazyDescriptionEditor, issueBeingEdited: issueBeingEdited, issuesById: issuesById, setIssueBeingEdited: setIssueBeingEdited, setDescription: setDescription, projectsById: projectsById, intl: intl, onChange: onChange, isOptimizedMode: isOptimizedMode, isReadOnly: isReadOnly, isLoadingIssueDescription: isLoadingIssueDescription }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isEditingSummary, setIsEditingSummary] = (0, $5uXOq.useState)(false);
        const [isEditingDescription, setIsEditingDescription] = (0, $5uXOq.useState)(false);
        const innerFieldModalIssue = (0, $5uXOq.useRef)(null);
        const { formatMessage: formatMessage } = intl;
        const issue = typeof issueBeingEdited === 'string' ? issuesById[issueBeingEdited] : null;
        const isScenarioIssue = Boolean(issue && (!(0, $4nDwW.isDefined)(issue.issueKey) || issue.id.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX))));
        const issueDescription = isLoadingIssueDescription ? undefined : issue?.description;
        const isSummaryDirty = issue?.originals && (0, parcelRequire("2JlG5")).default('summary', issue.originals);
        const isDescriptionDirty = issue?.originals && (0, parcelRequire("2JlG5")).default('description', issue.originals);
        const validateIssueSummary = (summary)=>{
            if (summary.trim().length === 0) return formatMessage((0, $itQja.default).blankSummaryInputErrorMessage);
            if (summary.length > 255) return formatMessage((0, $itQja.default).invalidSummaryInput);
            return undefined;
        };
        const fireAnalytics = (0, $5uXOq.useCallback)((eventName)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), eventName, 'arjIssueModalIssueSummary', {
                isScenarioIssue: isScenarioIssue
            });
        }, [
            createAnalyticsEvent,
            isScenarioIssue
        ]);
        const handleSummaryEdit = ()=>{
            setIsEditingSummary(true);
            fireAnalytics((0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).OPENED_ISSUE_SUMMARY);
        };
        const handleSummaryChange = (0, $5uXOq.useCallback)((editedSummary)=>{
            if (!issue) return;
            if (!issue.id) throw new Error('Issue must have id!');
            onChange({
                id: issue.id,
                summary: editedSummary && editedSummary.trim() || issue.summary
            });
            setIsEditingSummary(false);
            if (editedSummary !== issue.summary) fireAnalytics((0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATED_ISSUE_SUMMARY);
            else fireAnalytics((0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CANCELLED_ISSUE_SUMMARY);
        }, [
            fireAnalytics,
            issue,
            onChange
        ]);
        const handleSummaryCancel = ()=>{
            setIsEditingSummary(false);
            fireAnalytics((0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CANCELLED_ISSUE_SUMMARY);
        };
        const handleClose = ()=>{
            setIsEditingSummary(false);
            setIsEditingDescription(false);
            setIssueBeingEdited(null);
        };
        const getIssueSummaryReadView = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("h2", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.summary-read-view",
                className: $1CWWe.summaryReadView
            }, issue?.summary, " ", !isOptimizedMode && isSummaryDirty && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kC16r.default), null));
        if (!(0, $4nDwW.isDefined)(issueBeingEdited) || !(0, $4nDwW.isDefined)(issue)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "large",
            autoFocus: false,
            onClose: handleClose,
            shouldCloseOnOverlayClick: isReadOnly
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1CWWe.modalHeader
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1CWWe.breadcrumbs
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(BreadcrumbsComponent, {
            issue: issue
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: isEditingSummary || isEditingDescription ? $1CWWe.hiddenButton : ''
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, $ihPUd.default).close),
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
                label: formatMessage((0, $ihPUd.default).close)
            }),
            onClick: handleClose,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.modal-close-button"
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.summary",
            className: `${$1CWWe.summary} ${!isReadOnly && isEditingSummary ? $1CWWe.summaryBeingEdited : ''}`
        }, isReadOnly ? getIssueSummaryReadView() : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iAUhA")).default), {
            defaultValue: issue.summary,
            editView: ({ errorMessage: errorMessage, ...fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                    content: errorMessage,
                    isOpen: fieldProps.isInvalid,
                    placement: "right"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.edit-summary"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i0vxP")).default), {
                    onEscape: ()=>{}
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                    ...fieldProps,
                    autoFocus: true,
                    elemAfterInput: fieldProps && fieldProps.isInvalid && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                        label: "",
                        primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
                    }),
                    maxLength: 256,
                    placeholder: formatMessage((0, $itQja.default).summaryPlaceholder),
                    ref: innerFieldModalIssue
                })))),
            onCancel: handleSummaryCancel,
            onConfirm: handleSummaryChange,
            onEdit: handleSummaryEdit,
            readView: getIssueSummaryReadView,
            validate: validateIssueSummary
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.description",
            className: $1CWWe.description
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("h5", {
            className: $1CWWe.descriptionLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $1CWWe.descriptionLabelInner
        }, formatMessage((0, $itQja.default).descriptionLabel), !isOptimizedMode && !!isDescriptionDirty && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kC16r.default), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "arj-description-editor",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $1CWWe.descriptionSpinner
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), null))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(DescriptionEditorComponent, {
            editMode: isEditingDescription,
            setEditMode: setIsEditingDescription,
            onSave: (description)=>setDescription(issueBeingEdited, description),
            issueId: issueBeingEdited,
            projectKey: projectsById[issue.project].key,
            issueKey: isScenarioIssue ? null : (0, (0, parcelRequire("g5X3G")).toIssueKey)(`${projectsById[issue.project].key}-${issue.issueKey || 0}`),
            editorContent: issueDescription,
            isReadOnly: isReadOnly,
            isLoadingIssueDescription: isLoadingIssueDescription,
            isScenarioIssue: isScenarioIssue,
            noContentMessage: formatMessage(isReadOnly ? (0, $itQja.default).noDescriptionReadOnlyMode : (0, $itQja.default).noDescription),
            descriptionFailedMessage: formatMessage((0, $itQja.default).descriptionParsingError)
        }))))));
    }
    var $5ed79f8e7b1e7990$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($5ed79f8e7b1e7990$var$IssueModal);
});
parcelRegister("i0vxP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e488d7f69150a6e1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fW62l = parcelRequire("fW62l");
    class $e488d7f69150a6e1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onEscape: null,
                onEnter: null,
                onBlur: null,
                className: undefined
            };
        }
        componentDidMount() {
            if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
        }
        componentWillUnmount() {
            if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
        }
        render() {
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                onBlur: this.props.onBlur,
                ref: this.setRef,
                className: this.props.className
            }, this.props.children));
        }
        constructor(...args){
            super(...args);
            this.setRef = (ref)=>{
                this.ref = ref;
            };
            this.handleKeyDown = (event)=>{
                switch(event.keyCode){
                    case (0, ($parcel$interopDefault($fW62l)))('escape'):
                        if (this.props.onEscape) {
                            this.props.onEscape(event);
                            event.stopPropagation();
                        }
                        break;
                    case (0, ($parcel$interopDefault($fW62l)))('enter'):
                        if (this.props.onEnter) {
                            this.props.onEnter(event);
                            event.stopPropagation();
                        }
                        break;
                    default:
                        break;
                }
            };
        }
    }
});
parcelRegister("fW62l", function(module, exports) {
    function keyCode(searchInput) {
        if (searchInput && 'object' === typeof searchInput) {
            var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
            if (hasKeyCode) searchInput = hasKeyCode;
        }
        if ('number' === typeof searchInput) return names[searchInput];
        var search = String(searchInput);
        var foundNamedKey = codes[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        var foundNamedKey = aliases[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        if (search.length === 1) return search.charCodeAt(0);
        return undefined;
    }
    keyCode.isEventKey = function isEventKey(event, nameOrCode) {
        if (event && 'object' === typeof event) {
            var keyCode = event.which || event.keyCode || event.charCode;
            if (keyCode === null || keyCode === undefined) return false;
            if (typeof nameOrCode === 'string') {
                var foundNamedKey = codes[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
                var foundNamedKey = aliases[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
            } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
            return false;
        }
    };
    exports = module.exports = keyCode;
    var codes = exports.code = exports.codes = {
        'backspace': 8,
        'tab': 9,
        'enter': 13,
        'shift': 16,
        'ctrl': 17,
        'alt': 18,
        'pause/break': 19,
        'caps lock': 20,
        'esc': 27,
        'space': 32,
        'page up': 33,
        'page down': 34,
        'end': 35,
        'home': 36,
        'left': 37,
        'up': 38,
        'right': 39,
        'down': 40,
        'insert': 45,
        'delete': 46,
        'command': 91,
        'left command': 91,
        'right command': 93,
        'numpad *': 106,
        'numpad +': 107,
        'numpad -': 109,
        'numpad .': 110,
        'numpad /': 111,
        'num lock': 144,
        'scroll lock': 145,
        'my computer': 182,
        'my calculator': 183,
        ';': 186,
        '=': 187,
        ',': 188,
        '-': 189,
        '.': 190,
        '/': 191,
        '`': 192,
        '[': 219,
        '\\': 220,
        ']': 221,
        "'": 222
    };
    var aliases = exports.aliases = {
        'windows': 91,
        "\u21E7": 16,
        "\u2325": 18,
        "\u2303": 17,
        "\u2318": 91,
        'ctl': 17,
        'control': 17,
        'option': 18,
        'pause': 19,
        'break': 19,
        'caps': 20,
        'return': 13,
        'escape': 27,
        'spc': 32,
        'spacebar': 32,
        'pgup': 33,
        'pgdn': 34,
        'ins': 45,
        'del': 46,
        'cmd': 91
    };
    for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
    for(var i = 48; i < 58; i++)codes[i - 48] = i;
    for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
    for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
    var names = exports.names = exports.title = {};
    for(i in codes)names[codes[i]] = i;
    for(var alias in aliases)codes[alias] = aliases[alias];
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("h89Vx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd5d434b77f48167$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bAk88 = parcelRequire("bAk88");
    var $jFQze = parcelRequire("jFQze");
    var $fd5d434b77f48167$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $bAk88.default), {})((0, $jFQze.default));
});
parcelRegister("bAk88", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca85ccd79bcf8ef3$export$2e2bcd8739ae039);
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    function $ca85ccd79bcf8ef3$var$mapStateToProps(state) {
        return {
            issuesById: (0, $gFhwb.getIssueMapById)(state),
            issueTypes: (0, $kllqP.getIssueTypes)(state),
            projectsById: (0, $jpXKt.getProjectsById)(state)
        };
    }
    var $ca85ccd79bcf8ef3$export$2e2bcd8739ae039 = $ca85ccd79bcf8ef3$var$mapStateToProps;
});
parcelRegister("jFQze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21b6f580ba496821$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fuUnn;
    var $jbeEq;
    var $3bDjY;
    var $jLI87 = parcelRequire("jLI87");
    var $bREsp = parcelRequire("bREsp");
    var $eJyeb = parcelRequire("eJyeb");
    var $4nDwW = parcelRequire("4nDwW");
    var $lQM8G = parcelRequire("lQM8G");
    const $21b6f580ba496821$var$NoUrlCrumb = (0, $5uXOq.forwardRef)(({ className: className, children: children }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            className: className,
            style: {
                cursor: 'default'
            }
        }, children));
    function $21b6f580ba496821$var$IssueBreadcrumbs({ issue: issue, issuesById: issuesById, projectsById: projectsById, issueTypes: issueTypes }) {
        const issueType = issueTypes.find((type)=>type.id === issue.type) || (0, $bREsp.DEFAULT_SCRATCH_ISSUE_TYPE);
        const getBreadcrumbProps = (issue)=>{
            const projectKey = projectsById[issue.project].key;
            const issueKey = (0, $4nDwW.isDefined)(issue.issueKey) ? `${projectKey}-${issue.issueKey}` : projectKey;
            const hasUrl = issueKey !== projectKey;
            const url = (0, $eJyeb.proxyContextSafeUrl)(`/browse/${issueKey}`);
            const props = {
                href: hasUrl ? url : '',
                target: '_blank',
                text: issueKey
            };
            if (!hasUrl) props.component = $21b6f580ba496821$var$NoUrlCrumb;
            return props;
        };
        const ancestorsOfIssue = (0, $jLI87.getAncestorsOfIssue)(issue, issuesById);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jbeEq")).default), {
            maxItems: 5
        }, ancestorsOfIssue.length > 0 && ancestorsOfIssue.reverse().map((issue)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: `crumb-${projectsById[issue.project].key}-${issue?.issueKey || issue.id}`,
                className: $lQM8G.breadCrumbItem
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: issue?.summary || null,
                position: "top"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuUnn")).default), getBreadcrumbProps(issue))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuUnn")).default), {
            ...getBreadcrumbProps(issue),
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $lQM8G["issue-icon"],
                style: {
                    backgroundImage: `url(${issueType.iconUrl})`
                }
            })
        }));
    }
    var $21b6f580ba496821$export$2e2bcd8739ae039 = $21b6f580ba496821$var$IssueBreadcrumbs;
});
parcelRegister("lQM8G", function(module, exports) {
    $parcel$export(module.exports, "breadCrumbItem", ()=>$fe83cbb29717d88e$export$9478590597717b26, (v)=>$fe83cbb29717d88e$export$9478590597717b26 = v);
    $parcel$export(module.exports, "issue-icon", ()=>$fe83cbb29717d88e$export$39bed5d6a23c78de, (v)=>$fe83cbb29717d88e$export$39bed5d6a23c78de = v);
    var $fe83cbb29717d88e$export$9478590597717b26;
    var $fe83cbb29717d88e$export$39bed5d6a23c78de;
    $fe83cbb29717d88e$export$9478590597717b26 = `dAFjAq_breadCrumbItem`;
    $fe83cbb29717d88e$export$39bed5d6a23c78de = `dAFjAq_issue-icon`;
});
parcelRegister("itQja", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$403a8ed7d8e1a3bc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $403a8ed7d8e1a3bc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        blankSummaryInputErrorMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.blank-summary-input-error-message",
            "defaultMessage": "You must specify a summary of the issue."
        },
        invalidSummaryInput: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.invalid-summary-input",
            "defaultMessage": "Summary must be less than 256 characters."
        },
        summaryPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.summary-placeholder",
            "defaultMessage": "Issue summary ..."
        },
        descriptionLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.description-label",
            "defaultMessage": "Description"
        },
        noDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.no-description",
            "defaultMessage": "Add a description..."
        },
        noDescriptionReadOnlyMode: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.no-description-read-only-mode",
            "defaultMessage": "No description"
        },
        descriptionParsingError: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.description-parsing-error",
            "defaultMessage": "There was an error loading the description for this issue."
        }
    });
});
parcelRegister("1CWWe", function(module, exports) {
    $parcel$export(module.exports, "breadcrumbs", ()=>$12f70ef3d401f6e6$export$515d2155aaad79e4, (v)=>$12f70ef3d401f6e6$export$515d2155aaad79e4 = v);
    $parcel$export(module.exports, "description", ()=>$12f70ef3d401f6e6$export$6d59db4903f20f7d, (v)=>$12f70ef3d401f6e6$export$6d59db4903f20f7d = v);
    $parcel$export(module.exports, "descriptionLabel", ()=>$12f70ef3d401f6e6$export$7de3eff20b335ee9, (v)=>$12f70ef3d401f6e6$export$7de3eff20b335ee9 = v);
    $parcel$export(module.exports, "descriptionLabelInner", ()=>$12f70ef3d401f6e6$export$4ec4cd5bccf215f2, (v)=>$12f70ef3d401f6e6$export$4ec4cd5bccf215f2 = v);
    $parcel$export(module.exports, "descriptionSpinner", ()=>$12f70ef3d401f6e6$export$8fe2c617c69b145c, (v)=>$12f70ef3d401f6e6$export$8fe2c617c69b145c = v);
    $parcel$export(module.exports, "hiddenButton", ()=>$12f70ef3d401f6e6$export$3f4a1c21e2e27d37, (v)=>$12f70ef3d401f6e6$export$3f4a1c21e2e27d37 = v);
    $parcel$export(module.exports, "modalHeader", ()=>$12f70ef3d401f6e6$export$3099d0daead893d3, (v)=>$12f70ef3d401f6e6$export$3099d0daead893d3 = v);
    $parcel$export(module.exports, "summary", ()=>$12f70ef3d401f6e6$export$9a2dbef7a17e2e58, (v)=>$12f70ef3d401f6e6$export$9a2dbef7a17e2e58 = v);
    $parcel$export(module.exports, "summaryBeingEdited", ()=>$12f70ef3d401f6e6$export$1b38869ff17953e6, (v)=>$12f70ef3d401f6e6$export$1b38869ff17953e6 = v);
    $parcel$export(module.exports, "summaryReadView", ()=>$12f70ef3d401f6e6$export$10ac4ca9f19e16f5, (v)=>$12f70ef3d401f6e6$export$10ac4ca9f19e16f5 = v);
    var $12f70ef3d401f6e6$export$515d2155aaad79e4;
    var $12f70ef3d401f6e6$export$6d59db4903f20f7d;
    var $12f70ef3d401f6e6$export$7de3eff20b335ee9;
    var $12f70ef3d401f6e6$export$4ec4cd5bccf215f2;
    var $12f70ef3d401f6e6$export$8fe2c617c69b145c;
    var $12f70ef3d401f6e6$export$3f4a1c21e2e27d37;
    var $12f70ef3d401f6e6$export$3099d0daead893d3;
    var $12f70ef3d401f6e6$export$9a2dbef7a17e2e58;
    var $12f70ef3d401f6e6$export$1b38869ff17953e6;
    var $12f70ef3d401f6e6$export$10ac4ca9f19e16f5;
    $12f70ef3d401f6e6$export$515d2155aaad79e4 = `-8IA7a_breadcrumbs`;
    $12f70ef3d401f6e6$export$6d59db4903f20f7d = `-8IA7a_description`;
    $12f70ef3d401f6e6$export$7de3eff20b335ee9 = `-8IA7a_descriptionLabel`;
    $12f70ef3d401f6e6$export$4ec4cd5bccf215f2 = `-8IA7a_descriptionLabelInner`;
    $12f70ef3d401f6e6$export$8fe2c617c69b145c = `-8IA7a_descriptionSpinner`;
    $12f70ef3d401f6e6$export$3f4a1c21e2e27d37 = `-8IA7a_hiddenButton`;
    $12f70ef3d401f6e6$export$3099d0daead893d3 = `-8IA7a_modalHeader`;
    $12f70ef3d401f6e6$export$9a2dbef7a17e2e58 = `-8IA7a_summary`;
    $12f70ef3d401f6e6$export$1b38869ff17953e6 = `-8IA7a_summaryBeingEdited`;
    $12f70ef3d401f6e6$export$10ac4ca9f19e16f5 = `-8IA7a_summaryReadView`;
});
parcelRegister("47Ijy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("5kgeZ")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8S3bo")
    ]).then(()=>parcelRequire('3ic8z'));
});
parcelRegister("3jIvH", function(module, exports) {
    $parcel$export(module.exports, "Field", ()=>$e5fabc369f98246d$export$a455218a85c89869);
    var $bC2fB;
    var $eqh2j = parcelRequire("eqh2j");
    var $f5q7z = parcelRequire("f5q7z");
    const $e5fabc369f98246d$export$a455218a85c89869 = (0, (0, parcelRequire("bC2fB")).connect)((0, $eqh2j.default), {})((0, $f5q7z.Field));
});
parcelRegister("eqh2j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8385397e001f8a22$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $g7bEf = parcelRequire("g7bEf");
    var $8385397e001f8a22$export$2e2bcd8739ae039 = (state, { columnId: columnId })=>({
            column: (0, $g7bEf.getColumns)(state).find((column)=>column.id === columnId),
            isReadOnly: (0, $1CGdp.getMode)(state) !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
            showOptimizations: (0, $1CGdp.isOptimizedMode)(state)
        });
});
parcelRegister("g7bEf", function(module, exports) {
    $parcel$export(module.exports, "getColumns", ()=>$998f07e338b99dfa$export$978e30a0fb8610d8);
    $parcel$export(module.exports, "default", ()=>$998f07e338b99dfa$export$2e2bcd8739ae039);
    var $9XE6b = parcelRequire("9XE6b");
    var $74ySO = parcelRequire("74ySO");
    var $4Rr1a;
    var $gxOvy;
    var $co1wz;
    var $3J2mc;
    var $1CGdp = parcelRequire("1CGdp");
    var $19iju = parcelRequire("19iju");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpgxP = parcelRequire("jpgxP");
    var $6iNxz = parcelRequire("6iNxz");
    var $kWDpn = parcelRequire("kWDpn");
    var $7lpPk = parcelRequire("7lpPk");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $l38L3 = parcelRequire("l38L3");
    var $6qpX6 = parcelRequire("6qpX6");
    var $cxHuX = parcelRequire("cxHuX");
    var $2Swc7 = parcelRequire("2Swc7");
    var $2L95O = parcelRequire("2L95O");
    var $d3UHJ = parcelRequire("d3UHJ");
    const $998f07e338b99dfa$var$StartDateCell = (0, $2Swc7.createDateCell)((0, $2Swc7.default), (0, $2L95O.DateTypes).Start);
    const $998f07e338b99dfa$var$EndDateCell = (0, $2Swc7.createDateCell)((0, $2Swc7.default), (0, $2L95O.DateTypes).End);
    const $998f07e338b99dfa$export$cdc3020bd8d7e8aa = (customFields, dateConfiguration, viewMode)=>{
        const isCollapsible = viewMode !== (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST;
        return customFields.map((field)=>{
            let cell = (0, $cxHuX.default);
            const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
            const fieldId = `${field.id}`;
            const keyPath = (0, ($parcel$interopDefault($9XE6b)))(field, [
                'type',
                'key'
            ]);
            if (fieldId === baselineStartField.key) cell = (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? $998f07e338b99dfa$var$StartDateCell : (0, $2Swc7.createDateCell)((0, $2Swc7.default), (0, $2L95O.DateTypes).Start);
            if (fieldId === baselineEndField.key) cell = (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? $998f07e338b99dfa$var$EndDateCell : (0, $2Swc7.createDateCell)((0, $2Swc7.default), (0, $2L95O.DateTypes).End);
            const defaultWidth = (0, $d3UHJ.getDefaultWidth)(keyPath, viewMode);
            const minWidth = (0, $d3UHJ.getMinWidth)(keyPath, isCollapsible, viewMode);
            const column = {
                id: fieldId,
                isVisible: false,
                title: field.title,
                attribute: fieldId,
                cell: cell,
                isCustomField: true,
                isLoading: false,
                isReadOnly: (0, ($parcel$interopDefault($74ySO)))((0, $TTKUQ.CustomFields).ReadOnlyFields, (0, ($parcel$interopDefault($9XE6b)))(field, [
                    'type',
                    'key'
                ])),
                isSortable: false,
                defaultWidth: defaultWidth,
                isCollapsible: isCollapsible,
                minWidth: minWidth,
                projectId: field.projectId
            };
            const customProperties = (0, $4nDwW.isDefined)(keyPath) ? (0, $6qpX6.customFieldColumnProperties)(keyPath) : {};
            return {
                ...column,
                ...customProperties
            };
        });
    };
    function $998f07e338b99dfa$var$getCustomColumn(id, customFields) {
        return customFields.find((customColumn)=>customColumn.id.toString() === id.toString());
    }
    const $998f07e338b99dfa$export$ac0c9b0a002d1a9 = (attribute)=>(item)=>{
            if (item.tag !== (0, $6iNxz.TABLE_ISSUE)) return false;
            const { value: issue } = item;
            return (0, $l38L3.hasValueChanged)((0, $l38L3.getCurrentValue)(issue, attribute), (0, $l38L3.getOptimizedValue)(issue, attribute));
        };
    const $998f07e338b99dfa$var$filterGoalColumnIfNotAvailable = (columns, isAtlasConnectInstalled)=>columns.filter((column)=>column.id !== 'goal' || isAtlasConnectInstalled);
    const $998f07e338b99dfa$export$46848d2dbf73aee = ({ columns: columnStates }, dateConfiguration, planningUnit, customFields, isLoadingHistoryIssues, items, showOptimizations, viewMode, isAtlasConnectInstalled, isConfluenceMacroMode, isEmbedMode)=>{
        const customFieldColumns = $998f07e338b99dfa$export$cdc3020bd8d7e8aa(customFields, dateConfiguration, viewMode);
        const availableColumnStatesCheck = ()=>columnStates.filter((column)=>(0, $7lpPk.isColumnId)(column.id, isEmbedMode, isConfluenceMacroMode) || $998f07e338b99dfa$var$getCustomColumn(column.id, customFieldColumns));
        const availableColumnStates = availableColumnStatesCheck();
        const columnPropertiesContext = {
            dateConfiguration: dateConfiguration,
            planningUnit: planningUnit
        };
        const columnsInStore = availableColumnStates.map((columnState)=>{
            const customColumn = $998f07e338b99dfa$var$getCustomColumn(columnState.id, customFieldColumns);
            const defaultColumn = (0, $6qpX6.default)(columnState.id, columnPropertiesContext, viewMode, isConfluenceMacroMode, isEmbedMode);
            const column = customColumn || defaultColumn;
            const defaultWidth = (0, $4nDwW.isDefined)(customColumn) ? customColumn.defaultWidth : (0, $d3UHJ.getDefaultWidth)(columnState.id, viewMode);
            const hasOptimizedValues = showOptimizations && column && !!items.find($998f07e338b99dfa$export$ac0c9b0a002d1a9(column.attribute));
            return {
                ...column,
                ...columnState,
                isLoading: isLoadingHistoryIssues && (columnState.id === 'breakdown' || columnState.id === 'progressByEstimation'),
                defaultWidth: defaultWidth,
                hasOptimizedValues: hasOptimizedValues
            };
        });
        const columnIdsWithCustomFields = [
            ...(0, $7lpPk.getColumnIds)(isEmbedMode, isConfluenceMacroMode),
            ...customFields.map((customField)=>customField.id.toString())
        ];
        const storedColumnIds = availableColumnStates.map((column)=>column.id.toString());
        const notStoredColumnIds = (0, parcelRequire("gxOvy")).default(storedColumnIds, columnIdsWithCustomFields);
        const createHiddenColumn = (id)=>{
            let properties;
            if ((0, $7lpPk.isColumnId)(id, isEmbedMode, isConfluenceMacroMode)) properties = {
                ...(0, $6qpX6.default)(id, columnPropertiesContext, viewMode, isConfluenceMacroMode, isEmbedMode),
                defaultWidth: (0, $d3UHJ.getDefaultWidth)(id, viewMode)
            };
            else properties = $998f07e338b99dfa$var$getCustomColumn(id, customFieldColumns);
            return {
                id: id,
                isVisible: false,
                isLoading: isLoadingHistoryIssues && id === 'breakdown',
                ...properties
            };
        };
        const columnsNotInStore = (0, parcelRequire("4Rr1a")).default(createHiddenColumn, notStoredColumnIds);
        if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST) {
            const addFieldsColumn = {
                id: (0, $7lpPk.ADD_FIELDS_COLUMN_ID),
                isVisible: true,
                defaultWidth: (0, $d3UHJ.getDefaultWidth)((0, $7lpPk.ADD_FIELDS_COLUMN_ID), viewMode),
                ...(0, $6qpX6.default)((0, $7lpPk.ADD_FIELDS_COLUMN_ID), columnPropertiesContext, viewMode, isConfluenceMacroMode, isEmbedMode)
            };
            return $998f07e338b99dfa$var$filterGoalColumnIfNotAvailable([
                ...columnsInStore,
                ...columnsNotInStore,
                addFieldsColumn
            ], isAtlasConnectInstalled);
        }
        return $998f07e338b99dfa$var$filterGoalColumnIfNotAvailable([
            ...columnsInStore,
            ...columnsNotInStore
        ], isAtlasConnectInstalled);
    };
    const $998f07e338b99dfa$export$978e30a0fb8610d8 = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getFieldColumnsViewSettingsByViewMode),
        (0, $bHTqr.getDateConfiguration),
        (0, $bHTqr.getPlanningUnit),
        (0, $19iju.getSupportedCustomFields),
        (0, $bI9dZ.isLoadingHistory),
        (0, $6iNxz.getTableItems),
        (state)=>(0, $1CGdp.getMode)(state) === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771),
        (0, $kWDpn.getViewMode),
        (0, $jpgxP.isAtlasConnectInstalled),
        (0, $1CGdp.isConfluenceMacro),
        (0, $1CGdp.isEmbed)
    ], $998f07e338b99dfa$export$46848d2dbf73aee);
    const $998f07e338b99dfa$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        showWarning: (state)=>(0, $kWDpn.getWarningViewSettings)(state).showWarning,
        items: (0, $6iNxz.getTableItems),
        columns: $998f07e338b99dfa$export$978e30a0fb8610d8,
        isReadOnly: (state)=>(0, $1CGdp.getMode)(state) !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
        showOptimizations: (state)=>(0, $1CGdp.getMode)(state) === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771)
    });
    var $998f07e338b99dfa$export$2e2bcd8739ae039 = $998f07e338b99dfa$var$querySelector;
});
parcelRegister("6qpX6", function(module, exports) {
    $parcel$export(module.exports, "customFieldColumnProperties", ()=>$083f999a3630c2ca$export$82164cfe90d2a476);
    $parcel$export(module.exports, "default", ()=>$083f999a3630c2ca$export$2e2bcd8739ae039);
    var $co1wz;
    var $4R6GH;
    var $3J2mc;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $2CVkr = parcelRequire("2CVkr");
    var $iBM5F = parcelRequire("iBM5F");
    var $q7HKA = parcelRequire("q7HKA");
    var $2Swc7 = parcelRequire("2Swc7");
    var $2L95O = parcelRequire("2L95O");
    var $kexn9 = parcelRequire("kexn9");
    var $pop0c = parcelRequire("pop0c");
    var $iw7xI = parcelRequire("iw7xI");
    var $gXuyB = parcelRequire("gXuyB");
    var $g38cp = parcelRequire("g38cp");
    var $2KP1L = parcelRequire("2KP1L");
    var $76nx6 = parcelRequire("76nx6");
    var $7yJez = parcelRequire("7yJez");
    var $dtNTU = parcelRequire("dtNTU");
    var $106hf = parcelRequire("106hf");
    var $bxUAL = parcelRequire("bxUAL");
    var $9V09i = parcelRequire("9V09i");
    var $iPNKh = parcelRequire("iPNKh");
    var $fAImD = parcelRequire("fAImD");
    var $d3UHJ = parcelRequire("d3UHJ");
    const $083f999a3630c2ca$var$EmptyCell = ()=>null;
    const $083f999a3630c2ca$var$getDateCell = (context, issueAttribute)=>{
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = context.dateConfiguration;
        if (baselineStartField.key === issueAttribute) return (0, $2Swc7.createDateCell)((0, $2Swc7.default), (0, $2L95O.DateTypes).Start);
        if (baselineEndField.key === issueAttribute) return (0, $2Swc7.createDateCell)((0, $2Swc7.default), (0, $2L95O.DateTypes).End);
        return (0, $2Swc7.createDateCell)((0, $2Swc7.default), (0, $2L95O.DateTypes).Other);
    };
    const $083f999a3630c2ca$var$columnProperties = (columnId, context, viewMode, isConfluenceMacro, isEmbed)=>{
        const isCollapsible = viewMode !== (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST;
        const minWidth = (0, $d3UHJ.getMinWidth)(columnId, isCollapsible, viewMode);
        const isEmbedOrMacro = isConfluenceMacro || isEmbed;
        switch(columnId){
            case 'assignee':
                return {
                    title: (0, $ihPUd.default).assignee,
                    attribute: 'assignee',
                    cell: (0, $2CVkr.default),
                    isSortable: true,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'reporter':
                return {
                    title: (0, $ihPUd.default).reporter,
                    attribute: 'reporter',
                    cell: (0, $106hf.default),
                    isSortable: true,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'breakdown':
                return {
                    title: (0, $fAImD.default).breakdownColumnHeader,
                    attribute: 'breakdown',
                    cell: (0, $iBM5F.createBreakdownCell)((0, $iBM5F.default), (0, $TTKUQ.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS),
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'progressByEstimation':
                return {
                    title: (0, $fAImD.getProgressByEstimateColumnTitle)(context.planningUnit),
                    attribute: 'progressByEstimate',
                    cell: (0, $iBM5F.createBreakdownCell)((0, $iBM5F.default), (0, $TTKUQ.BREAKDOWN_SPRINT_CAPACITY_BY).ESTIMATE),
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'estimate':
                return {
                    title: (0, $fAImD.getEstimateColumnTitle)(context.planningUnit),
                    attribute: 'estimate',
                    cell: (0, $pop0c.default),
                    isSortable: true,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'issueStatus':
                return {
                    title: (0, $fAImD.default).issueStatusColumnHeader,
                    attribute: 'status',
                    cell: (0, $g38cp.default),
                    isSortable: true,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'release':
                return {
                    title: (0, $ihPUd.default).releases,
                    attribute: 'fixVersions',
                    cell: (0, $dtNTU.default),
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'sprint':
                return {
                    title: (0, $ihPUd.default).sprint,
                    attribute: (0, $d0091d9e935603a4$export$b549cc58e415d416),
                    cell: (0, $bxUAL.default),
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'targetStart':
                return {
                    title: (0, $fAImD.default).targetStartColumnHeader,
                    attribute: 'targetStart',
                    cell: $083f999a3630c2ca$var$getDateCell(context, 'targetStart'),
                    isSortable: true,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'targetEnd':
                return {
                    title: (0, $fAImD.default).targetEndColumnHeader,
                    attribute: 'targetEnd',
                    cell: $083f999a3630c2ca$var$getDateCell(context, 'targetEnd'),
                    isSortable: true,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'dueDate':
                return {
                    title: (0, $ihPUd.default).dueDate,
                    attribute: 'dueDate',
                    cell: $083f999a3630c2ca$var$getDateCell(context, 'dueDate'),
                    isSortable: true,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'team':
                return {
                    title: (0, $fAImD.default).teamColumnHeader,
                    attribute: 'team',
                    cell: (0, $9V09i.default),
                    isSortable: true,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'incomingDependencies':
                return {
                    title: (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_field_column_adjustments__a2f7') ? (0, $fAImD.default).blockedByColumnHeader : (0, $fAImD.default).incomingDependenciesColumnHeader,
                    attribute: 'incomingDependencies',
                    groupTitle: (0, $fAImD.default).dependenciesColumnsHeader,
                    cell: (0, $kexn9.IncomingDependenciesCell),
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'outgoingDependencies':
                return {
                    title: (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_field_column_adjustments__a2f7') ? (0, $fAImD.default).blocksColumnHeader : (0, $fAImD.default).outgoingDependenciesColumnHeader,
                    attribute: 'outgoingDependencies',
                    groupTitle: (0, $fAImD.default).dependenciesColumnsHeader,
                    cell: (0, $kexn9.OutgoingDependenciesCell),
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'components':
                return {
                    title: (0, $fAImD.default).componentsColumnHeader,
                    attribute: 'components',
                    cell: (0, $q7HKA.default),
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'labels':
                return {
                    title: (0, $fAImD.default).labelsColumnHeader,
                    attribute: 'labels',
                    groupTitle: (0, $fAImD.default).labelsColumnHeader,
                    cell: (0, $2KP1L.default),
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'parent':
                return {
                    title: (0, $fAImD.default).parentColumnHeader,
                    attribute: 'parent',
                    groupTitle: (0, $fAImD.default).parentColumnHeader,
                    cell: (0, $76nx6.default),
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'priority':
                return {
                    title: (0, $fAImD.default).priorityColumnHeader,
                    attribute: 'priority',
                    groupTitle: (0, $fAImD.default).priorityColumnHeader,
                    cell: (0, $7yJez.default),
                    isSortable: true,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                };
            case 'goal':
                return {
                    title: (0, $fAImD.default).goalColumnHeader,
                    attribute: 'goal',
                    groupTitle: (0, $fAImD.default).goalColumnHeader,
                    cell: (0, $iw7xI.default),
                    isSortable: false,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth,
                    HeaderContent: (0, $iPNKh.default)
                };
            case 'ideas':
                return (0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') && !isEmbedOrMacro ? {
                    title: (0, $fAImD.default).ideasColumnHeader,
                    attribute: 'ideas',
                    groupTitle: (0, $fAImD.default).ideasColumnHeader,
                    cell: (0, $gXuyB.default),
                    isSortable: false,
                    isCollapsible: isCollapsible,
                    minWidth: minWidth
                } : null;
            case 'addFields':
                return {
                    title: (0, $fAImD.default).addFieldsColumnHeader,
                    attribute: 'addFields',
                    groupTitle: (0, $fAImD.default).addFieldsColumnHeader,
                    cell: $083f999a3630c2ca$var$EmptyCell,
                    isCollapsible: false,
                    minWidth: minWidth
                };
            default:
                return null;
        }
    };
    const $083f999a3630c2ca$export$82164cfe90d2a476 = (fieldType)=>{
        switch(fieldType){
            case (0, $TTKUQ.CustomFieldTypes).DatePicker:
            case (0, $TTKUQ.CustomFieldTypes).NumberField:
            case (0, $TTKUQ.CustomFieldTypes).SingleSelect:
                return {
                    isSortable: true
                };
            default:
                return {};
        }
    };
    var $083f999a3630c2ca$export$2e2bcd8739ae039 = $083f999a3630c2ca$var$columnProperties;
});
parcelRegister("2CVkr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70d1beafca32e479$export$2e2bcd8739ae039);
    var $bC2fB;
    var $2WACK = parcelRequire("2WACK");
    var $bUurr = parcelRequire("bUurr");
    var $fAILh = parcelRequire("fAILh");
    var $70d1beafca32e479$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $bUurr.default), (0, $2WACK.default))((0, $fAILh.default));
});
parcelRegister("2WACK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0f4a5fef256724e$export$2e2bcd8739ae039);
    var $8qbLi = parcelRequire("8qbLi");
    var $bkasS = parcelRequire("bkasS");
    var $c8uhD = parcelRequire("c8uhD");
    const $a0f4a5fef256724e$var$dispatchMethods = (dispatch)=>({
            onChange: (issue, assignee)=>{
                if (assignee) dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    assignee: assignee.jiraUser.accountId
                }));
                dispatch((0, $c8uhD.updateIssueAssigneeMap)({
                    [issue.id]: assignee
                }));
            },
            fetchAssigneeList: (payload)=>{
                dispatch((0, $8qbLi.fetchAssigneeList)(payload));
            }
        });
    var $a0f4a5fef256724e$export$2e2bcd8739ae039 = $a0f4a5fef256724e$var$dispatchMethods;
});
parcelRegister("8qbLi", function(module, exports) {
    $parcel$export(module.exports, "fetchAssigneeList", ()=>$b1ebe7268d108818$export$697cc0c8abe021c9);
    $parcel$export(module.exports, "fetchAssigneeListForKeys", ()=>$b1ebe7268d108818$export$a149c3b6531d9418);
    $parcel$export(module.exports, "fetchTeamsAssignees", ()=>$b1ebe7268d108818$export$56f56a69078c2d60);
    $parcel$export(module.exports, "getUsers", ()=>$b1ebe7268d108818$export$925a4945a6cd0f3e);
    $parcel$export(module.exports, "populateAssignees", ()=>$b1ebe7268d108818$export$dd4a891b55a6409);
    $parcel$export(module.exports, "populateAssigneesFromProfiles", ()=>$b1ebe7268d108818$export$e3585c4bb68b1b7);
    $parcel$export(module.exports, "default", ()=>$b1ebe7268d108818$export$2e2bcd8739ae039);
    parcelRequire("dcevF");
    var $hIYGf = parcelRequire("hIYGf");
    var $cDeeP;
    var $83IGl;
    var $gCN7c;
    var $bjzU8;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $4R6GH;
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $hu7Cn = parcelRequire("hu7Cn");
    var $ageG6 = parcelRequire("ageG6");
    var $c8uhD = parcelRequire("c8uhD");
    var $g6VWU = parcelRequire("g6VWU");
    var $77QEM = parcelRequire("77QEM");
    var $24CMK = parcelRequire("24CMK");
    var $hvOzF = parcelRequire("hvOzF");
    var $hAVOp = parcelRequire("hAVOp");
    const $b1ebe7268d108818$export$746abeb2a401028e = 'command.assignees.FETCH_ASSIGNEE_LIST_FOR_QUERY';
    const $b1ebe7268d108818$export$7f3e3acfa85504f9 = 'command.assignees.FETCH_ASSIGNEE_LIST_FOR_KEYS';
    const $b1ebe7268d108818$export$39efea07a70e4e7e = 'command.assignees.FETCH_TEAMS_ASSIGNEE_LIST';
    const $b1ebe7268d108818$var$unassignedUser = {
        title: 'Unassigned',
        accountId: 'unassigned',
        email: '',
        avatarUrl: ''
    };
    const $b1ebe7268d108818$export$697cc0c8abe021c9 = (payload)=>({
            type: $b1ebe7268d108818$export$746abeb2a401028e,
            payload: payload
        });
    const $b1ebe7268d108818$export$a149c3b6531d9418 = (payload)=>({
            type: $b1ebe7268d108818$export$7f3e3acfa85504f9,
            payload: payload
        });
    const $b1ebe7268d108818$export$56f56a69078c2d60 = ()=>({
            type: $b1ebe7268d108818$export$39efea07a70e4e7e
        });
    function* $b1ebe7268d108818$export$925a4945a6cd0f3e({ keys: keys } = {
        keys: []
    }) {
        let users = [];
        const url = (0, $hAVOp.urls).users;
        const body = (0, $hAVOp.usersRequestBody)({
            keys: keys.filter((0, $4nDwW.isDefined))
        });
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
            method: (0, $77QEM.POST),
            body: body,
            profile: url
        });
        if (response.ok) {
            const results = yield (0, $aNOuE.call)(response.json.bind(response));
            users = [
                ...results.users
            ];
        } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
            const error = new Error(response.text());
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: (0, $hvOzF.toErrorID)(error, 'get-users-fetch-failed'),
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
            ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $77QEM.POST),
                status: response.status,
                body: body
            }
        }));
        return users;
    }
    function* $b1ebe7268d108818$export$a65219a764b7ed0b(config = {
        query: ''
    }) {
        let results = [];
        const url = (0, $hAVOp.urls).assignees;
        const body = (0, $hAVOp.personsRequestBody)(config);
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const persons = yield (0, $aNOuE.call)(response.json.bind(response));
            results = [
                ...persons.results
            ];
        } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
            const error = new Error(response.text());
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: (0, $hvOzF.toErrorID)(error, 'find-persons-fetch-failed'),
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
            ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $77QEM.POST),
                status: response.status,
                body: body
            }
        }));
        return results;
    }
    function* $b1ebe7268d108818$export$dd4a891b55a6409({ payload: payload } = {
        payload: {},
        type: 'command.assignees.FETCH_ASSIGNEE_LIST_FOR_KEYS'
    }) {
        const keys = payload && payload.keys;
        const { domain: { issues: issues, originalIssues: originalIssues } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const originalIssueAssigneeIds = ((0, parcelRequire("bjzU8")).default(originalIssues) || []).map((issue)=>issue.assignee) || [];
        const issueAssigneeIds = issues.map((issue)=>issue.assignee) || [];
        const fetchAllAssignees = payload && payload.fetchAllAssignees;
        const requestedKeys = keys || [];
        let requiredKeys;
        if (requestedKeys.length === 0 || fetchAllAssignees) {
            const teamsAssigneeKeys = yield (0, $aNOuE.select)((0, $ageG6.getTeamsAssigneeAccountIds));
            requiredKeys = [
                ...requestedKeys,
                ...issueAssigneeIds,
                ...originalIssueAssigneeIds,
                ...teamsAssigneeKeys
            ];
        } else requiredKeys = requestedKeys;
        const assigneeList = yield (0, $aNOuE.select)((0, $hu7Cn.getAssigneeList));
        const availableUserKeys = assigneeList.map((assignee)=>assignee.personId);
        const userIds = (0, parcelRequire("cDeeP")).default(requiredKeys, availableUserKeys).filter((0, $4nDwW.isDefined));
        if ((0, parcelRequire("gCN7c")).default(userIds) === 0) return;
        const users = yield (0, $aNOuE.call)($b1ebe7268d108818$export$925a4945a6cd0f3e, {
            keys: userIds
        });
        users.unshift($b1ebe7268d108818$var$unassignedUser);
        const transformedUsersList = users.map((user)=>({
                personId: user.accountId,
                jiraUser: user
            }));
        yield (0, $aNOuE.put)((0, $c8uhD.updateAssigneeList)({
            people: [
                ...transformedUsersList
            ]
        }));
        const issueAssigneeMap = issues.reduce((acc, issue)=>{
            const assignee = users.find(({ accountId: accountId })=>accountId === issue.assignee);
            if (assignee) acc[issue.id] = {
                personId: assignee.accountId,
                jiraUser: assignee
            };
            return acc;
        }, {});
        yield (0, $aNOuE.put)((0, $c8uhD.updateIssueAssigneeMap)(issueAssigneeMap));
    }
    function* $b1ebe7268d108818$export$e3585c4bb68b1b7(assigneeProfiles) {
        const { domain: { issues: issues } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const teamAssignees = yield (0, $aNOuE.select)((0, $ageG6.getTeamsPersons));
        const allPersonsOrder = [
            $b1ebe7268d108818$var$unassignedUser.accountId
        ];
        const allPersonsMap = {
            [$b1ebe7268d108818$var$unassignedUser.accountId]: {
                personId: $b1ebe7268d108818$var$unassignedUser.accountId,
                jiraUser: $b1ebe7268d108818$var$unassignedUser
            }
        };
        for (const assigneePerson of Object.values(assigneeProfiles)){
            allPersonsOrder.push(assigneePerson.accountId);
            allPersonsMap[assigneePerson.accountId] = {
                personId: assigneePerson.accountId,
                jiraUser: assigneePerson
            };
        }
        for (const apiPerson of teamAssignees)if (apiPerson?.jiraUser?.accountId && !allPersonsMap[apiPerson?.jiraUser?.accountId]) {
            const accountId = apiPerson.jiraUser.accountId;
            allPersonsOrder.push(accountId);
            allPersonsMap[accountId] = {
                personId: accountId,
                jiraUser: {
                    accountId: accountId,
                    title: apiPerson.jiraUser.title,
                    avatarUrl: apiPerson.jiraUser.avatarUrl,
                    email: apiPerson.jiraUser?.email
                }
            };
        }
        yield (0, $aNOuE.put)((0, $c8uhD.updateAssigneeList)({
            people: allPersonsOrder.map((accountId)=>allPersonsMap[accountId])
        }));
        const issueAssigneeMap = {};
        issues.forEach((issue)=>{
            const assigneePerson = allPersonsMap[issue.assignee];
            if (assigneePerson) issueAssigneeMap[issue.id] = assigneePerson;
        });
        yield (0, $aNOuE.put)((0, $c8uhD.updateIssueAssigneeMap)(issueAssigneeMap));
    }
    function* $b1ebe7268d108818$export$144ae522d73a11b8({ payload: { query: query, issueId: issueId } }) {
        yield (0, $aNOuE.put)((0, $g6VWU.startUpdatingAssigneeList)(issueId || ''));
        const assigneeList = yield (0, $aNOuE.call)($b1ebe7268d108818$export$a65219a764b7ed0b, {
            query: query
        });
        assigneeList.unshift({
            personId: $b1ebe7268d108818$var$unassignedUser.accountId,
            jiraUser: {
                ...$b1ebe7268d108818$var$unassignedUser
            }
        });
        yield (0, $aNOuE.put)((0, $c8uhD.updateAssigneeList)({
            people: assigneeList.filter((assignee)=>assignee.jiraUser).map(({ jiraUser: jiraUser })=>({
                    personId: jiraUser.accountId,
                    jiraUser: jiraUser
                }))
        }));
        yield (0, $aNOuE.put)((0, $g6VWU.stopUpdatingAssigneeList)(issueId || ''));
    }
    function* $b1ebe7268d108818$export$919b7611971b07c1(action) {
        yield (0, $aNOuE.call)((0, $hIYGf.delay), 500);
        yield (0, $aNOuE.call)($b1ebe7268d108818$export$144ae522d73a11b8, action);
    }
    function* $b1ebe7268d108818$export$eab844ac5f2070c4() {
        const keys = yield (0, $aNOuE.select)((0, $ageG6.getTeamsAssigneeAccountIds));
        yield (0, $aNOuE.put)($b1ebe7268d108818$export$a149c3b6531d9418({
            keys: keys
        }));
    }
    function* $b1ebe7268d108818$export$7dc46a99f6328d90() {
        yield (0, $6u3NN.takeLatest)($b1ebe7268d108818$export$746abeb2a401028e, $b1ebe7268d108818$export$919b7611971b07c1);
    }
    function* $b1ebe7268d108818$export$a794a84c83401681() {
        yield (0, $6u3NN.takeEvery)($b1ebe7268d108818$export$7f3e3acfa85504f9, $b1ebe7268d108818$export$dd4a891b55a6409);
    }
    function* $b1ebe7268d108818$export$739f5e1b36c4ea3a() {
        yield (0, $6u3NN.takeLatest)($b1ebe7268d108818$export$39efea07a70e4e7e, $b1ebe7268d108818$export$eab844ac5f2070c4);
    }
    function* $b1ebe7268d108818$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($b1ebe7268d108818$export$7dc46a99f6328d90);
        yield (0, $aNOuE.fork)($b1ebe7268d108818$export$a794a84c83401681);
        yield (0, $aNOuE.fork)($b1ebe7268d108818$export$739f5e1b36c4ea3a);
    }
});
parcelRegister("c8uhD", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_ISSUE_ASSIGNEE_MAP", ()=>$ef5ee58fc23c4bd3$export$6861ed0171e1a77e);
    $parcel$export(module.exports, "UPDATE_ASSIGNEES_LIST", ()=>$ef5ee58fc23c4bd3$export$ebcfa10ee460b7cf);
    $parcel$export(module.exports, "updateIssueAssigneeMap", ()=>$ef5ee58fc23c4bd3$export$cb751895c7b66bf2);
    $parcel$export(module.exports, "updateAssigneeList", ()=>$ef5ee58fc23c4bd3$export$fd2cc1da8acc3773);
    const $ef5ee58fc23c4bd3$export$6861ed0171e1a77e = 'state.domain.assignees.UPDATE_ISSUE_ASSIGNEE_MAP';
    const $ef5ee58fc23c4bd3$export$ebcfa10ee460b7cf = 'state.domain.assignees.UPDATE_ASSIGNEES_LIST';
    const $ef5ee58fc23c4bd3$export$cb751895c7b66bf2 = (payload)=>({
            type: $ef5ee58fc23c4bd3$export$6861ed0171e1a77e,
            payload: payload
        });
    const $ef5ee58fc23c4bd3$export$fd2cc1da8acc3773 = (payload)=>({
            type: $ef5ee58fc23c4bd3$export$ebcfa10ee460b7cf,
            payload: payload
        });
});
parcelRegister("g6VWU", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ASSIGNEES_START", ()=>$faec67d07579e9dd$export$5142077b54dce3ef);
    $parcel$export(module.exports, "FETCH_ASSIGNEES_STOP", ()=>$faec67d07579e9dd$export$9c6e6fe248892a25);
    $parcel$export(module.exports, "startUpdatingAssigneeList", ()=>$faec67d07579e9dd$export$c74a51765e09775f);
    $parcel$export(module.exports, "stopUpdatingAssigneeList", ()=>$faec67d07579e9dd$export$c796270210de179d);
    const $faec67d07579e9dd$export$5142077b54dce3ef = 'state.ui.main.tabs.roadmap.fields.assignee.FETCH_ASSIGNEES_START';
    const $faec67d07579e9dd$export$9c6e6fe248892a25 = 'state.ui.main.tabs.roadmap.fields.assignee.FETCH_ASSIGNEES_STOP';
    const $faec67d07579e9dd$export$c74a51765e09775f = (issueId)=>({
            type: $faec67d07579e9dd$export$5142077b54dce3ef,
            payload: {
                issueId: issueId || ''
            }
        });
    const $faec67d07579e9dd$export$c796270210de179d = (issueId)=>({
            type: $faec67d07579e9dd$export$9c6e6fe248892a25,
            payload: {
                issueId: issueId || ''
            }
        });
});
parcelRegister("hAVOp", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$1cc34e8ff035b14d$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "LIMIT_OF_USERS", ()=>$1cc34e8ff035b14d$export$aa33dcd85c6bc170);
    $parcel$export(module.exports, "personsRequestBody", ()=>$1cc34e8ff035b14d$export$9759b32997d3bfe3);
    $parcel$export(module.exports, "usersRequestBody", ()=>$1cc34e8ff035b14d$export$a0d5e607159aec63);
    const $1cc34e8ff035b14d$export$bcae9ba627f604b6 = {
        assignees: '/rest/teams/1.0/persons/find',
        users: '/rest/jpo/1.0/users/get'
    };
    const $1cc34e8ff035b14d$export$aa33dcd85c6bc170 = 50;
    const $1cc34e8ff035b14d$export$9759b32997d3bfe3 = ({ query: query = '', excludedIds: excludedIds = [], maxResults: maxResults = $1cc34e8ff035b14d$export$aa33dcd85c6bc170 })=>({
            query: query,
            excludedIds: excludedIds,
            maxResults: maxResults
        });
    const $1cc34e8ff035b14d$export$a0d5e607159aec63 = ({ keys: keys = [] })=>({
            keys: Array.from(new Set(keys))
        });
});
parcelRegister("bUurr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b72bd9c34e0990a2$export$2e2bcd8739ae039);
    var $hu7Cn = parcelRequire("hu7Cn");
    var $3YtPS = parcelRequire("3YtPS");
    const $b72bd9c34e0990a2$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        assigneeList: (0, $hu7Cn.getAssigneeList),
        assigneeListFetchStatus: (0, $hu7Cn.getAssigneeListFetchStatus),
        currentAssignees: (0, $hu7Cn.getAssigneesOfIssues),
        issueIdForFetchAssigneeListProgress: (0, $hu7Cn.getIssueIdForFetchAssigneeListProgress)
    });
    var $b72bd9c34e0990a2$export$2e2bcd8739ae039 = $b72bd9c34e0990a2$export$c31df4bd766f9c35;
});
parcelRegister("fAILh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$762d2b9f6ba18a8c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $koVbs;
    var $hwwla;
    var $bChGW;
    var $hAVOp = parcelRequire("hAVOp");
    var $9174a = parcelRequire("9174a");
    var $l38L3 = parcelRequire("l38L3");
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $cSDJf = parcelRequire("cSDJf");
    var $3FQWJ = parcelRequire("3FQWJ");
    var $3H1dB = parcelRequire("3H1dB");
    var $mrCKW = parcelRequire("mrCKW");
    const $762d2b9f6ba18a8c$export$8b412adb79c82bc8 = ({ assigneeList: assigneeList, onChange: onChange, issue: issue })=>(userId)=>{
            if ((0, $4nDwW.isDefined)(userId)) {
                const assignee = (0, $mrCKW.findAssigneeItem)(assigneeList, userId);
                onChange(issue, assignee);
            } else {
                const assignee = (0, $mrCKW.findAssigneeItem)(assigneeList, 'unassigned');
                onChange(issue, assignee);
            }
        };
    const $762d2b9f6ba18a8c$export$361f73eba39649ac = ({ fetchAssigneeList: fetchAssigneeList, onChange: onChange, currentAssignees: currentAssignees, isScrolling: isScrolling = false, assigneeList: assigneeList, issue: issue, showOptimizations: showOptimizations = false, issue: { assignee: assignee, summary: summary }, isReadOnly: isReadOnly = false, assigneeListFetchStatus: assigneeListFetchStatus, issueIdForFetchAssigneeListProgress: issueIdForFetchAssigneeListProgress, UserPicker: UserPicker })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (isScrolling || assigneeList.length === 0) {
            const { optimized: optimized } = issue;
            const assignee = showOptimizations === true && optimized && optimized.assignee ? optimized.assignee : issue.assignee;
            const items = (0, $9174a.transformPersons)(assigneeList);
            const selectedItem = items.find((item)=>item.value === assignee);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwwla")).default), {
                content: selectedItem && selectedItem.label,
                isReadOnly: showOptimizations
            });
        }
        const mapUserIdToTitle = (_, value)=>(0, $mrCKW.getUserTitle)(assigneeList, value);
        const attribute = 'assignee';
        let value = assignee;
        if (showOptimizations) value = (0, $l38L3.getOptimizedValue)(issue, attribute);
        const userList = (0, $mrCKW.getGroupedAssignees)({
            assigneeList: assigneeList,
            currentAssignees: currentAssignees
        }).map((option)=>{
            if (option.label && typeof option.label === 'object') return {
                ...option,
                label: formatMessage(option.label)
            };
            return option;
        });
        const user = userList.flatMap(({ options: options })=>options).find((user)=>user.value === value);
        const handleUserChange = $762d2b9f6ba18a8c$export$8b412adb79c82bc8({
            assigneeList: assigneeList,
            onChange: onChange,
            issue: issue
        });
        const onFetchUserList = (query)=>{
            fetchAssigneeList({
                query: query || '',
                issueId: issue.id
            });
        };
        const getTooltipContent = ()=>{
            if (!user) return '';
            return user.value === 'unassigned' ? formatMessage((0, $3H1dB.default).unassignedTooltipMessage) : user.email;
        };
        const getControlComponent = (props)=>{
            const { children: children, selectProps: { menuIsOpen: menuIsOpen } } = props;
            const tooltipContent = menuIsOpen ? '' : getTooltipContent();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: tooltipContent
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Control, props, children));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
            attribute: attribute,
            issue: issue,
            valueMapper: mapUserIdToTitle,
            isScrolling: isScrolling,
            showOptimizations: showOptimizations
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(UserPicker, {
            placeholder: "",
            userList: userList,
            maxOptionsPerGroup: (0, $hAVOp.LIMIT_OF_USERS),
            onUserChange: handleUserChange,
            onFetchUserList: onFetchUserList,
            user: user,
            selectProps: {
                'aria-label': formatMessage({
                    ...(0, $3H1dB.default).assigneeCellLabel
                }, {
                    issue: summary
                }),
                isClearable: value !== 'unassigned',
                isDisabled: isReadOnly,
                minSelectWidth: (0, $cSDJf.MIN_SELECT_WIDTH),
                isLoading: (0, $4nDwW.isDefined)(issueIdForFetchAssigneeListProgress) && issue.id === issueIdForFetchAssigneeListProgress && assigneeListFetchStatus,
                components: {
                    Control: getControlComponent
                }
            },
            issueId: issue.id,
            attribute: attribute
        }));
    };
    var $762d2b9f6ba18a8c$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        UserPicker: (0, $ixSW4.slots).UserPicker
    })($762d2b9f6ba18a8c$export$361f73eba39649ac);
});
parcelRegister("hwwla", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$588d20041aa2b66b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fkC9P;
    var $3NB2D = parcelRequire("3NB2D");
    const $588d20041aa2b66b$export$234c310f1a4fffd6 = (content)=>{
        if (!content) return undefined;
        if (typeof content === 'string') return content;
        if (Array.isArray(content)) return (0, parcelRequire("fkC9P")).default(', ', content);
        return content;
    };
    function $588d20041aa2b66b$export$2e2bcd8739ae039(props) {
        const { isReadOnly: isReadOnly, content: content } = props;
        const classNames = isReadOnly ? $3NB2D.readOnly : '';
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$3NB2D.wireframe} ${classNames}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, $588d20041aa2b66b$export$234c310f1a4fffd6(content))));
    }
    $588d20041aa2b66b$export$2e2bcd8739ae039.defaultProps = {
        isReadOnly: false
    };
});
parcelRegister("3NB2D", function(module, exports) {
    $parcel$export(module.exports, "readOnly", ()=>$2c42ae61eb2b9e43$export$b2cbc93d4da94977, (v)=>$2c42ae61eb2b9e43$export$b2cbc93d4da94977 = v);
    $parcel$export(module.exports, "wireframe", ()=>$2c42ae61eb2b9e43$export$a8fec3cf51c7da20, (v)=>$2c42ae61eb2b9e43$export$a8fec3cf51c7da20 = v);
    var $2c42ae61eb2b9e43$export$b2cbc93d4da94977;
    var $2c42ae61eb2b9e43$export$a8fec3cf51c7da20;
    $2c42ae61eb2b9e43$export$b2cbc93d4da94977 = `TWK4FW_readOnly`;
    $2c42ae61eb2b9e43$export$a8fec3cf51c7da20 = `TWK4FW_wireframe`;
});
parcelRegister("9174a", function(module, exports) {
    $parcel$export(module.exports, "transformPersons", ()=>$d7c2926ef20f85c0$export$ca1d576fde6dcfcc);
    $parcel$export(module.exports, "sort", ()=>$d7c2926ef20f85c0$export$97db5808d8f88186);
    $parcel$export(module.exports, "filter", ()=>$d7c2926ef20f85c0$export$3dea766d36a8935f);
    var $8ibtc;
    var $jVZZA;
    var $3DBzg;
    var $fkC9P;
    var $5XN59;
    var $bQZTk;
    var $2rMKg;
    var $sqeVT;
    var $h35CY;
    var $hpnKp;
    var $4nDwW = parcelRequire("4nDwW");
    const $d7c2926ef20f85c0$export$ca1d576fde6dcfcc = (persons)=>(0, $4nDwW.filterMap)((person)=>(0, $4nDwW.isDefined)(person.jiraUser), (person)=>({
                value: person.jiraUser.accountId,
                label: person.jiraUser.title,
                icon: person.jiraUser.avatarUrl,
                email: person.jiraUser.email
            }), persons);
    const $d7c2926ef20f85c0$var$sortByPersonTitle = (0, parcelRequire("h35CY")).default((el)=>(0, parcelRequire("hpnKp")).default(el.jiraUser.title));
    const $d7c2926ef20f85c0$var$sortByAssigned = (0, parcelRequire("h35CY")).default((0, parcelRequire("bQZTk")).default((0, parcelRequire("sqeVT")).default('personId', 'unassigned'), (0, parcelRequire("5XN59")).default));
    const $d7c2926ef20f85c0$export$97db5808d8f88186 = (0, parcelRequire("bQZTk")).default($d7c2926ef20f85c0$var$sortByPersonTitle, $d7c2926ef20f85c0$var$sortByAssigned);
    const $d7c2926ef20f85c0$var$getFullText = (0, parcelRequire("bQZTk")).default((0, parcelRequire("2rMKg")).default('jiraUser'), (user)=>[
            user?.email ?? '',
            user.title
        ], (0, parcelRequire("fkC9P")).default(' '), (0, parcelRequire("hpnKp")).default);
    const $d7c2926ef20f85c0$var$matchQuery = (0, parcelRequire("8ibtc")).default((query, person)=>(0, parcelRequire("3DBzg")).default((0, parcelRequire("hpnKp")).default(query))($d7c2926ef20f85c0$var$getFullText(person)));
    const $d7c2926ef20f85c0$export$3dea766d36a8935f = (0, parcelRequire("8ibtc")).default((query, people)=>(0, parcelRequire("jVZZA")).default($d7c2926ef20f85c0$var$matchQuery(query))(people));
});
parcelRegister("3H1dB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cbf173e9b70cf47$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5cbf173e9b70cf47$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        assigneeCellLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.assignee.assignee-cell-label",
            "defaultMessage": "Choose an assignee for issue {issue}"
        },
        currentlyAssignedGroupTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.assignee.currently-assigned-group-title",
            "defaultMessage": "Currently assigned"
        },
        allAssigneesGroupTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.assignee.all-assignees-group-title",
            "defaultMessage": "All users"
        },
        unassignedTooltipMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.assignee.unassigned-tooltip-message",
            "defaultMessage": "This issue is not assigned to anyone"
        }
    });
});
parcelRegister("mrCKW", function(module, exports) {
    $parcel$export(module.exports, "findAssigneeItem", ()=>$d58cf2642703207e$export$f96ccaaed6a64e74);
    $parcel$export(module.exports, "getUserTitle", ()=>$d58cf2642703207e$export$5f7a1baecd59f846);
    $parcel$export(module.exports, "getGroupedAssignees", ()=>$d58cf2642703207e$export$23efc4e6e86f4ba4);
    var $78izu;
    var $jVZZA;
    var $9U6ZH;
    var $5XN59;
    var $bQZTk;
    var $sqeVT;
    var $9174a = parcelRequire("9174a");
    var $3H1dB = parcelRequire("3H1dB");
    const $d58cf2642703207e$export$f96ccaaed6a64e74 = (list, name)=>list.find((assignee)=>assignee.jiraUser.accountId === name);
    const $d58cf2642703207e$export$5f7a1baecd59f846 = (persons, userId)=>{
        const targetPerson = persons.find((person)=>person.jiraUser.accountId === userId);
        if (targetPerson) return targetPerson.jiraUser.title;
        return userId;
    };
    const $d58cf2642703207e$export$23efc4e6e86f4ba4 = ({ assigneeList: assigneeList, currentAssignees: currentAssignees })=>{
        const unassigned = (0, parcelRequire("bQZTk")).default((0, parcelRequire("sqeVT")).default('personId', 'unassigned'), (0, parcelRequire("5XN59")).default);
        const allAssigneeOptions = (0, parcelRequire("bQZTk")).default((0, parcelRequire("78izu")).default((p1, p2)=>p1.personId === p2.personId, assigneeList), (0, parcelRequire("jVZZA")).default(unassigned), (0, $9174a.sort), (0, $9174a.transformPersons))(currentAssignees);
        const currentlyAssignedOptions = (0, parcelRequire("bQZTk")).default((0, parcelRequire("jVZZA")).default(unassigned), (0, $9174a.sort), (0, $9174a.transformPersons))(currentAssignees);
        const unassignedUser = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('personId', 'unassigned'), assigneeList);
        return [
            {
                options: unassignedUser && (0, $9174a.transformPersons)([
                    unassignedUser
                ]) || []
            },
            {
                label: (0, $3H1dB.default).currentlyAssignedGroupTitle,
                options: currentlyAssignedOptions
            },
            {
                label: (0, $3H1dB.default).allAssigneesGroupTitle,
                options: allAssigneeOptions
            }
        ];
    };
});
parcelRegister("78izu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5317afa4e37eb3ce$export$2e2bcd8739ae039);
    var $hTO4g;
    var $IYMZh;
    var $5317afa4e37eb3ce$var$differenceWith = (0, (0, parcelRequire("IYMZh")).default)(function differenceWith(pred, first, second) {
        var out = [];
        var idx = 0;
        var firstLen = first.length;
        while(idx < firstLen){
            if (!(0, (0, parcelRequire("hTO4g")).default)(pred, first[idx], second) && !(0, (0, parcelRequire("hTO4g")).default)(pred, first[idx], out)) out.push(first[idx]);
            idx += 1;
        }
        return out;
    });
    var $5317afa4e37eb3ce$export$2e2bcd8739ae039 = $5317afa4e37eb3ce$var$differenceWith;
});
parcelRegister("iBM5F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f788e7860dcc93f$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "createBreakdownCell", ()=>$3f788e7860dcc93f$export$6630e0b49cfb1c29);
    var $5uXOq = parcelRequire("5uXOq");
    var $bC2fB;
    var $cJ4Kn = parcelRequire("cJ4Kn");
    var $1kNdw = parcelRequire("1kNdw");
    var $3f788e7860dcc93f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $cJ4Kn.default), {})((0, $1kNdw.default));
    const $3f788e7860dcc93f$export$6630e0b49cfb1c29 = (EstimateCellComponent, breakdownBy)=>class extends (0, $5uXOq.Component) {
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(EstimateCellComponent, {
                    breakdownBy: breakdownBy,
                    ...this.props
                });
            }
        };
});
parcelRegister("cJ4Kn", function(module, exports) {
    $parcel$export(module.exports, "getBreakdown", ()=>$f454b221953dbc59$export$44e052266c6cb01d);
    $parcel$export(module.exports, "getBreakdownByEstimate", ()=>$f454b221953dbc59$export$abf82cc9ff41d874);
    $parcel$export(module.exports, "default", ()=>$f454b221953dbc59$export$2e2bcd8739ae039);
    var $fZhYM;
    var $4NBVJ = parcelRequire("4NBVJ");
    var $7ppNi = parcelRequire("7ppNi");
    var $kllqP = parcelRequire("kllqP");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $4sJY8 = parcelRequire("4sJY8");
    var $jpgxP = parcelRequire("jpgxP");
    var $fHJiO = parcelRequire("fHJiO");
    var $TTKUQ = parcelRequire("TTKUQ");
    const { TODO: $f454b221953dbc59$var$TODO, INPROGRESS: $f454b221953dbc59$var$INPROGRESS, DONE: $f454b221953dbc59$var$DONE } = (0, $TTKUQ.ISSUE_STATUS_CATEGORIES);
    const $f454b221953dbc59$export$f329467b33724fe7 = (parentIssueId, historyIssues, issueMap)=>historyIssues.filter((historyIssue)=>historyIssue.parent === parentIssueId).filter((historyIssue)=>!issueMap[historyIssue.id]).map((issue)=>issue.id);
    const $f454b221953dbc59$export$994fbe3fc8e99f59 = (issues, issueStatuses)=>issues.filter((issue)=>{
            const categoryId = (0, parcelRequire("fZhYM")).default([
                issue.status || '',
                'categoryId'
            ], issueStatuses);
            return categoryId === $f454b221953dbc59$var$DONE;
        }).map((issue)=>issue.id);
    const $f454b221953dbc59$export$62787c9f03e7328c = (issues, issueStatuses, parentIssueId, historyIssues, issueMap)=>{
        const issuesIdsInDoneStatus = issues.length > 0 ? $f454b221953dbc59$export$994fbe3fc8e99f59(issues, issueStatuses) : [];
        const issueIdsInDoneFromHistory = $f454b221953dbc59$export$f329467b33724fe7(parentIssueId, historyIssues, issueMap);
        const uniqueIssueIdsInDoneStatus = new Set([
            ...issuesIdsInDoneStatus,
            ...issueIdsInDoneFromHistory
        ]);
        return uniqueIssueIdsInDoneStatus.size;
    };
    const $f454b221953dbc59$export$44e052266c6cb01d = (issue, issueIdToChildIssuesMap, issueStatuses, issueMap, historyIssues)=>{
        let todoCount = 0;
        let inProgressCount = 0;
        let doneCount = 0;
        const { id: id } = issue;
        const childIds = issueIdToChildIssuesMap[id];
        let childIssues = [];
        if (childIds) {
            childIssues = childIds.map((id)=>issueMap[id]);
            const breakdown = (0, $fHJiO.getIssuesStatusBreakdown)(childIssues, issueStatuses);
            todoCount += breakdown.byCategoryId[String($f454b221953dbc59$var$TODO)];
            inProgressCount += breakdown.byCategoryId[String($f454b221953dbc59$var$INPROGRESS)];
        }
        doneCount = $f454b221953dbc59$export$62787c9f03e7328c(childIssues, issueStatuses, id, historyIssues, issueMap);
        return {
            byCategoryId: {
                [String($f454b221953dbc59$var$TODO)]: todoCount,
                [String($f454b221953dbc59$var$INPROGRESS)]: inProgressCount,
                [String($f454b221953dbc59$var$DONE)]: doneCount
            },
            total: todoCount + inProgressCount + doneCount
        };
    };
    const $f454b221953dbc59$export$abf82cc9ff41d874 = (issue, issueIdToDescendantsIdsMap, issueStatuses, issueMap, planningUnit, workingHours, estimateFromHistoryIssues)=>{
        const { id: id } = issue;
        const descendantIds = issueIdToDescendantsIdsMap[id] || [];
        const childIssues = descendantIds.map((id)=>issueMap[id]);
        const estimateBreakdown = (0, $fHJiO.getEstimateBreakdown)(issue, childIssues, issueStatuses, planningUnit, workingHours);
        let doneEstimate = 0;
        let noOfDoneIssues = 0;
        let noOfUnestimatedInDone = 0;
        const estimateFromDoneIssues = estimateFromHistoryIssues[id];
        if (estimateFromDoneIssues) {
            doneEstimate = estimateFromDoneIssues.estimate;
            noOfDoneIssues = estimateFromDoneIssues.numberOfIssues;
            noOfUnestimatedInDone = estimateFromDoneIssues.unEstimatedCount;
        }
        return {
            ...estimateBreakdown,
            unestimated: estimateBreakdown.unestimated + noOfUnestimatedInDone,
            byCategoryId: {
                ...estimateBreakdown.byCategoryId,
                [String($f454b221953dbc59$var$DONE)]: estimateBreakdown.byCategoryId[String($f454b221953dbc59$var$DONE)] + doneEstimate
            },
            total: estimateBreakdown.total + doneEstimate,
            issueCount: estimateBreakdown.issueCount + noOfDoneIssues
        };
    };
    const $f454b221953dbc59$export$c31df4bd766f9c35 = (state)=>({
            issueIdToChildIdsMap: (0, $4sJY8.getChildrenIdsByParent)(state),
            issueIdToDescendantsIdMap: (0, $bI9dZ.getDescendantIdsByParent)(state),
            estimateFromHistoryIssues: (0, $4NBVJ.getEstimateFromHistoryIssues)(state),
            issueStatuses: (0, $7ppNi.getIssueStatusById)(state),
            issueMapById: (0, $gFhwb.getIssueMapById)(state),
            historyIssues: (0, $bI9dZ.getHistoryIssues)(state),
            isLoading: (0, $bI9dZ.isLoadingHistory)(state),
            planningUnit: (0, $bHTqr.getPlanningUnit)(state),
            workingHours: (0, $jpgxP.getJiraHoursPerDay)(state),
            projects: (0, $jpXKt.getProjects)(state),
            issueTypes: (0, $kllqP.getIssueTypes)(state)
        });
    var $f454b221953dbc59$export$2e2bcd8739ae039 = $f454b221953dbc59$export$c31df4bd766f9c35;
});
parcelRegister("4NBVJ", function(module, exports) {
    $parcel$export(module.exports, "getEstimateFromHistoryIssues", ()=>$8b31da2da8adcf1f$export$2532420da5bed387);
    var $3YtPS = parcelRequire("3YtPS");
    var $ekXoi = parcelRequire("ekXoi");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $gFhwb = parcelRequire("gFhwb");
    var $jpgxP = parcelRequire("jpgxP");
    const $8b31da2da8adcf1f$export$c6fd3ab3f44300d0 = (issue, issueMap)=>{
        const ancestorsIds = [];
        const ancestors = [];
        let currentIssue = issue;
        while(currentIssue && currentIssue.parent){
            currentIssue = issueMap[currentIssue.parent];
            if (!currentIssue) break;
            if (ancestorsIds.includes(currentIssue.id)) break;
            ancestorsIds.push(currentIssue.id);
            ancestors.push(currentIssue);
        }
        return ancestors;
    };
    const $8b31da2da8adcf1f$export$284f74dfe4a146bf = (issuesById, historyIssues)=>{
        const issueIdToChildIdsMap = {};
        historyIssues.filter((historyIssue)=>!issuesById[historyIssue.id]).forEach((historyIssue)=>{
            const { parent: parent } = historyIssue;
            if (parent && !issueIdToChildIdsMap[parent]) issueIdToChildIdsMap[parent] = [];
            if (parent) {
                issueIdToChildIdsMap[parent].push(historyIssue);
                const ancestors = $8b31da2da8adcf1f$export$c6fd3ab3f44300d0(issuesById[parent], issuesById);
                ancestors.forEach((ancestor)=>{
                    if (!issueIdToChildIdsMap[ancestor.id]) issueIdToChildIdsMap[ancestor.id] = [];
                    issueIdToChildIdsMap[ancestor.id].push(historyIssue);
                });
            }
        });
        return issueIdToChildIdsMap;
    };
    const $8b31da2da8adcf1f$export$76f84947e56e5ca6 = (targetArray, parentId, historyIssuesWithParent)=>{
        const childHistoryIssues = historyIssuesWithParent[parentId] || [];
        childHistoryIssues.forEach((historyIssue)=>{
            targetArray.push(historyIssue);
            $8b31da2da8adcf1f$export$76f84947e56e5ca6(targetArray, historyIssue.id, historyIssuesWithParent);
        });
    };
    const $8b31da2da8adcf1f$export$7014b2b54bb2cfe6 = (issuesById, historyIssues, planningUnit, workingHours)=>{
        const estimateByHistoryIssueParentId = {};
        const historyIssuesWithParent = $8b31da2da8adcf1f$export$284f74dfe4a146bf(issuesById, historyIssues);
        Object.keys(historyIssuesWithParent).forEach((parentId)=>{
            const descendants = [];
            $8b31da2da8adcf1f$export$76f84947e56e5ca6(descendants, parentId, historyIssuesWithParent);
            estimateByHistoryIssueParentId[parentId] = descendants.reduce((acc, item)=>{
                if (!(0, $ekXoi.isEstimated)(planningUnit, item)) acc.unEstimatedCount += 1;
                else {
                    acc.estimate = (0, $ekXoi.getEstimateValue)(planningUnit, item, workingHours) + acc.estimate;
                    acc.numberOfIssues += 1;
                }
                return acc;
            }, {
                estimate: 0,
                numberOfIssues: 0,
                unEstimatedCount: 0
            });
        });
        return estimateByHistoryIssueParentId;
    };
    const $8b31da2da8adcf1f$export$2532420da5bed387 = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssueMapById),
        (0, $bI9dZ.getHistoryIssues),
        (0, $bHTqr.getPlanningUnit),
        (0, $jpgxP.getJiraHoursPerDay)
    ], $8b31da2da8adcf1f$export$7014b2b54bb2cfe6);
});
parcelRegister("1kNdw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a2f27b3f9edc8f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2rMKg;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fyWqy = parcelRequire("fyWqy");
    var $cJ4Kn = parcelRequire("cJ4Kn");
    var $75ZB6 = parcelRequire("75ZB6");
    const $2a2f27b3f9edc8f5$export$a7f376d1bbbf50c8 = ({ breakdownBy: breakdownBy, estimateFromHistoryIssues: estimateFromHistoryIssues, historyIssues: historyIssues, isLoading: isLoading, isScrolling: isScrolling, issue: issue, issueIdToChildIdsMap: issueIdToChildIdsMap, issueIdToDescendantsIdMap: issueIdToDescendantsIdMap, issueMapById: issueMapById, issueStatuses: issueStatuses, issueTypes: issueTypes, planningUnit: planningUnit, projects: projects, workingHours: workingHours })=>{
        if (isLoading) return null;
        const { issueKey: issueKey, id: id, summary: summary, project: project, type: type } = issue;
        const projectsByIdMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), projects);
        const issueTypesByIdMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), issueTypes);
        const projectKey = project ? projectsByIdMap[project]?.key || '' : '';
        const issueType = issueTypesByIdMap[type];
        const issueTitleData = {
            issueKey: issueKey,
            summary: summary,
            id: id,
            issueType: issueType,
            projectKey: projectKey
        };
        const breakdownProps = {
            onlyRenderStatusBar: isScrolling,
            planningUnit: breakdownBy === (0, $TTKUQ.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS ? 'issueCount' : planningUnit,
            breakdownBy: breakdownBy
        };
        const statusBreakdownProps = breakdownBy === (0, $TTKUQ.BREAKDOWN_SPRINT_CAPACITY_BY).ESTIMATE ? {
            ...breakdownProps,
            ...(0, $cJ4Kn.getBreakdownByEstimate)(issue, issueIdToDescendantsIdMap, issueStatuses, issueMapById, planningUnit, workingHours, estimateFromHistoryIssues),
            issueTitleData: issueTitleData
        } : {
            ...breakdownProps,
            ...(0, $cJ4Kn.getBreakdown)(issue, issueIdToChildIdsMap, issueStatuses, issueMapById, historyIssues)
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $75ZB6["breakdown-container"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fyWqy.default), statusBreakdownProps)));
    };
    var $2a2f27b3f9edc8f5$export$2e2bcd8739ae039 = $2a2f27b3f9edc8f5$export$a7f376d1bbbf50c8;
});
parcelRegister("fyWqy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2c48001819747d3$export$2e2bcd8739ae039);
    var $co1wz;
    var $7XYc4;
    var $f2uoR = parcelRequire("f2uoR");
    var $cNvrS = parcelRequire("cNvrS");
    var $a2c48001819747d3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition'), (0, $cNvrS.default), (0, $f2uoR.default));
});
parcelRegister("f2uoR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f802b0080a52a070$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $8RXs9;
    var $J8W7q;
    var $gITL8 = parcelRequire("gITL8");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $geBHG = parcelRequire("geBHG");
    var $1wJkh = parcelRequire("1wJkh");
    var $hBJhn = parcelRequire("hBJhn");
    var $hjPTu = parcelRequire("hjPTu");
    const { TODO: $f802b0080a52a070$var$TODO, INPROGRESS: $f802b0080a52a070$var$INPROGRESS, DONE: $f802b0080a52a070$var$DONE } = (0, $TTKUQ.ISSUE_STATUS_CATEGORIES);
    class $f802b0080a52a070$var$StatusBreakdown extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onlyRenderStatusBar: false,
                breakdownBy: (0, $TTKUQ.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS
            };
        }
        getBreakdown() {
            const { byCategoryId: byCategoryId } = this.props;
            return {
                todo: byCategoryId[String($f802b0080a52a070$var$TODO)],
                inprogress: byCategoryId[String($f802b0080a52a070$var$INPROGRESS)],
                done: byCategoryId[String($f802b0080a52a070$var$DONE)]
            };
        }
        renderStatusBar() {
            const { total: total, breakdownBy: breakdownBy, label: label, showToolTip: showToolTip, planningUnit: planningUnit, intl: intl } = this.props;
            const { todo: todo, inprogress: inprogress, done: done } = this.getBreakdown();
            const remaining = todo + inprogress;
            const todoWidth = todo / total * 100;
            const inProgressWidth = inprogress / total * 100;
            const doneWidth = total === 0 ? 0 : done / total * 100;
            const remainingWidth = total === 0 ? 100 : remaining / total * 100;
            const overBooked = done > total;
            const todoBar = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    width: `${todoWidth}%`,
                    backgroundColor: (0, $gITL8.statusBreakdownColourMap).TODO
                }
            });
            const inprogressBar = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    width: `${inProgressWidth}%`,
                    backgroundColor: (0, $gITL8.statusBreakdownColourMap).INPROGRESS
                }
            });
            const doneBar = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    width: `${doneWidth}%`,
                    backgroundColor: (0, $gITL8.statusBreakdownColourMap).DONE
                }
            });
            let bar = breakdownBy === 'status' ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.bar,
                "data-testid": "portfolio-3-portfolio.common.status-breakdown.status-breakdown-bar"
            }, doneWidth > 0 && doneBar, inProgressWidth > 0 && inprogressBar, todoWidth > 0 && todoBar) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.bar,
                "data-testid": "portfolio-3-portfolio.common.status-breakdown.status-breakdown-bar"
            }, doneWidth > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: overBooked ? `${$hjPTu.completed} ${$hjPTu.overbooked}` : $hjPTu.completed,
                style: {
                    width: `${doneWidth}%`
                }
            }), remainingWidth > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.remaining,
                style: {
                    width: `${remainingWidth}%`
                }
            }));
            if (showToolTip === true && breakdownBy === 'estimate') bar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: intl.formatMessage((0, $hBJhn.default).breakdownByEstimateToolTip, {
                    done: done,
                    donePercent: total ? Math.round(done * 100 / total) : '0',
                    total: total,
                    planningUnit: planningUnit
                }),
                position: "mouse"
            }, bar);
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.breakdown
            }, label, bar));
        }
        render() {
            const { showFlyout: showFlyout } = this.state;
            const { intl: intl, ...flyoutProps } = this.props;
            const { total: total, onlyRenderStatusBar: onlyRenderStatusBar, issueCount: issueCount, breakdownBy: breakdownBy } = this.props;
            if (total === 0 && breakdownBy === 'status') return null;
            if (onlyRenderStatusBar === true) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.container
            }, this.renderStatusBar());
            const flyout = breakdownBy === 'status' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1wJkh.default), flyoutProps) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $geBHG.default), flyoutProps);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.container,
                onMouseEnter: ()=>this.showFlyout(),
                onMouseLeave: ()=>this.hideFlyout()
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                content: flyout,
                isOpen: showFlyout,
                issueCount: issueCount
            }, this.renderStatusBar()));
        }
        constructor(...args){
            super(...args);
            this.state = {
                showFlyout: false
            };
            this.showFlyout = ()=>this.setState({
                    showFlyout: true
                });
            this.hideFlyout = ()=>this.setState({
                    showFlyout: false
                });
        }
    }
    var $f802b0080a52a070$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($f802b0080a52a070$var$StatusBreakdown);
});
parcelRegister("geBHG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3a509cab2a2ff86$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $8CUq3;
    var $co1wz;
    var $ousew;
    var $koVbs;
    var $2FvnI;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8JOG8 = parcelRequire("8JOG8");
    var $kJXoj = parcelRequire("kJXoj");
    var $9i4v6 = parcelRequire("9i4v6");
    var $aLq1X = parcelRequire("aLq1X");
    var $5fRdR = parcelRequire("5fRdR");
    const { TODO: $c3a509cab2a2ff86$var$TODO, INPROGRESS: $c3a509cab2a2ff86$var$INPROGRESS, DONE: $c3a509cab2a2ff86$var$DONE } = (0, $TTKUQ.ISSUE_STATUS_CATEGORIES);
    const $c3a509cab2a2ff86$var$EstimateFlyout = (props)=>{
        const { planningUnit: planningUnit, byCategoryId: byCategoryId, unestimated: unestimated = 0, issueCount: issueCount = 0, issueTitleData: issueTitleData } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getBreakdown = ()=>({
                completed: byCategoryId[String($c3a509cab2a2ff86$var$DONE)],
                remaining: byCategoryId[String($c3a509cab2a2ff86$var$TODO)] + byCategoryId[String($c3a509cab2a2ff86$var$INPROGRESS)]
            });
        const getLabel = (count)=>{
            const countToTwoDigit = (0, $5fRdR.roundToTwoDigit)(count);
            let label = formatMessage((0, $kJXoj.default).issueCountLabel, {
                numberOfIssues: countToTwoDigit
            });
            if (planningUnit === (0, $TTKUQ.PlanningUnits).storyPoints) label = formatMessage((0, $kJXoj.default).storyPointsCountLabel, {
                storyPoints: countToTwoDigit
            });
            else if (planningUnit === (0, $TTKUQ.PlanningUnits).days) label = formatMessage((0, $kJXoj.default).daysCountLabel, {
                days: countToTwoDigit
            });
            else if (planningUnit === (0, $TTKUQ.PlanningUnits).hours) label = formatMessage((0, $kJXoj.default).hoursCountLabel, {
                hours: countToTwoDigit
            });
            return label;
        };
        const getIssueTitle = (issueTitleData)=>{
            const { projectKey: projectKey, issueType: issueType, issueKey: issueKey, id: id, summary: summary } = issueTitleData;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $aLq1X.issueTitle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $aLq1X.issueIcon,
                style: {
                    backgroundSize: 'contain',
                    backgroundImage: issueType && `url(${issueType.iconUrl})`
                }
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvnI")).default), {
                projectKey: projectKey,
                issueKey: issueKey,
                xcssStyles: $c3a509cab2a2ff86$var$issueLinkStyles
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                content: summary,
                id: id
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $aLq1X.issueSummary
            }, summary))));
        };
        const { completed: completed, remaining: remaining } = getBreakdown();
        const total = completed + remaining;
        const hasUnestimatedIssues = unestimated > 0;
        const hasChildIssues = unestimated + issueCount > 1;
        const percent = total > 0 ? (0, $5fRdR.roundToTwoDigit)(completed / total * 100) : 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? $aLq1X.flyout : $aLq1X.flyoutOld,
            "data-testid": "portfolio-3-portfolio.common.status-breakdown.components.estimate-flyout"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("table", null, (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", null, (0, $4nDwW.isDefined)(issueTitleData) && (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            colSpan: 2,
            className: $aLq1X.issueTitleCell
        }, getIssueTitle(issueTitleData))), !hasChildIssues && (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            colSpan: 2
        }, hasUnestimatedIssues ? formatMessage((0, $kJXoj.default).individualIssueUnestimatedLabel) : formatMessage((0, $kJXoj.default).individualIssueBreakdownLabel, {
            percent: percent,
            remaining: (0, $5fRdR.roundToTwoDigit)(remaining),
            total: getLabel(total)
        }))), hasChildIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "success"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).completed))), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9i4v6.default), {
            count: completed,
            total: total,
            label: getLabel(completed)
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "default"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).remaining))), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9i4v6.default), {
            count: remaining,
            total: total,
            label: getLabel(remaining)
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).total)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $aLq1X.countLabel
        }, getLabel(total), hasUnestimatedIssues ? '*' : null))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            colSpan: 2
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("hr", {
            className: $aLq1X.separator
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).estimatedIssuesLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $aLq1X.countLabel
        }, issueCount))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).unestimatedIssuesLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $aLq1X.countLabel
        }, unestimated))), hasUnestimatedIssues && (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            colSpan: 2,
            className: $aLq1X.accuracyWarning
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).notAccurateProgress)))))));
    };
    var $c3a509cab2a2ff86$export$2e2bcd8739ae039 = $c3a509cab2a2ff86$var$EstimateFlyout;
    const $c3a509cab2a2ff86$var$issueLinkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap'
    });
});
parcelRegister("8JOG8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$975c0c8d119a09f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $3vxzY = parcelRequire("3vxzY");
    function $975c0c8d119a09f6$export$2e2bcd8739ae039({ children: children, content: content, id: id, position: position = 'bottom' }) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $3vxzY.ellipsed
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: content,
            position: position,
            tag: "span",
            key: id
        }, children)));
    }
});
parcelRegister("3vxzY", function(module, exports) {
    $parcel$export(module.exports, "ellipsed", ()=>$28de507ce41d1873$export$6ce21b76224237ee, (v)=>$28de507ce41d1873$export$6ce21b76224237ee = v);
    var $28de507ce41d1873$export$6ce21b76224237ee;
    $28de507ce41d1873$export$6ce21b76224237ee = `jh2iBq_ellipsed`;
});
parcelRegister("kJXoj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b70a73af4df0a2b1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b70a73af4df0a2b1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        percentage: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.percentage",
            "defaultMessage": "({percentage}%)"
        },
        todo: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.todo",
            "defaultMessage": "To do"
        },
        inprogress: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.inprogress",
            "defaultMessage": "In progress"
        },
        done: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.done",
            "defaultMessage": "Done"
        },
        completed: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.completed",
            "defaultMessage": "Completed"
        },
        remaining: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.remaining",
            "defaultMessage": "Remaining"
        },
        total: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.total",
            "defaultMessage": "Total"
        },
        estimatedIssuesLabel: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.estimated-issues-label",
            "defaultMessage": "Estimated issues"
        },
        unestimatedIssuesLabel: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.unestimated-issues-label",
            "defaultMessage": "Unestimated issues"
        },
        issueCountLabel: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.issue-count-label",
            "defaultMessage": "{numberOfIssues, plural, one {{numberOfIssues} issue} other {{numberOfIssues} issues}}"
        },
        storyPointsCountLabel: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.story-points-count-label",
            "defaultMessage": "{storyPoints, plural, one {{storyPoints} point} other {{storyPoints} points}}"
        },
        hoursCountLabel: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.hours-count-label",
            "defaultMessage": "{hours, plural, one {{hours} hour} other {{hours} hours}}"
        },
        daysCountLabel: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.days-count-label",
            "defaultMessage": "{days, plural, one {{days} day} other {{days} days}}"
        },
        totalIssuesLabel: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.total-issues-label",
            "defaultMessage": "Total issues"
        },
        notAccurateProgress: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.not-accurate-progress",
            "defaultMessage": "*Progress may not be accurate due to unestimated issues"
        },
        individualIssueBreakdownLabel: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.individual-issue-breakdown-label",
            "defaultMessage": "{percent}% | {remaining} out of {total} remaining"
        },
        individualIssueUnestimatedLabel: {
            "id": "portfolio-3-portfolio.common.status-breakdown.components.individual-issue-unestimated-label",
            "defaultMessage": "Unestimated"
        }
    });
});
parcelRegister("9i4v6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$441e8a637dee80d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $kJXoj = parcelRequire("kJXoj");
    var $aLq1X = parcelRequire("aLq1X");
    function $441e8a637dee80d5$export$2e2bcd8739ae039({ count: count, total: total, label: label }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const percentage = total && Math.round(count / total * 100);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $aLq1X.totalValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $aLq1X.countLabel
        }, label), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $aLq1X.percentage
        }, formatMessage((0, $kJXoj.default).percentage, {
            percentage: percentage
        }))));
    }
});
parcelRegister("aLq1X", function(module, exports) {
    $parcel$export(module.exports, "accuracyWarning", ()=>$7d627c46846c2ccc$export$ca0c5138b6a08a79, (v)=>$7d627c46846c2ccc$export$ca0c5138b6a08a79 = v);
    $parcel$export(module.exports, "countLabel", ()=>$7d627c46846c2ccc$export$19665c9017513a41, (v)=>$7d627c46846c2ccc$export$19665c9017513a41 = v);
    $parcel$export(module.exports, "flyout", ()=>$7d627c46846c2ccc$export$ec4922be16378791, (v)=>$7d627c46846c2ccc$export$ec4922be16378791 = v);
    $parcel$export(module.exports, "flyoutOld", ()=>$7d627c46846c2ccc$export$30b9d66acf28aaf7, (v)=>$7d627c46846c2ccc$export$30b9d66acf28aaf7 = v);
    $parcel$export(module.exports, "issueIcon", ()=>$7d627c46846c2ccc$export$415983cbc1f2b3fe, (v)=>$7d627c46846c2ccc$export$415983cbc1f2b3fe = v);
    $parcel$export(module.exports, "issueSummary", ()=>$7d627c46846c2ccc$export$7c7bc027bbbea103, (v)=>$7d627c46846c2ccc$export$7c7bc027bbbea103 = v);
    $parcel$export(module.exports, "issueTitle", ()=>$7d627c46846c2ccc$export$12781bd67c11efd8, (v)=>$7d627c46846c2ccc$export$12781bd67c11efd8 = v);
    $parcel$export(module.exports, "issueTitleCell", ()=>$7d627c46846c2ccc$export$b338cf20d238f012, (v)=>$7d627c46846c2ccc$export$b338cf20d238f012 = v);
    $parcel$export(module.exports, "percentage", ()=>$7d627c46846c2ccc$export$a3560dfa62c7efe0, (v)=>$7d627c46846c2ccc$export$a3560dfa62c7efe0 = v);
    $parcel$export(module.exports, "separator", ()=>$7d627c46846c2ccc$export$3e523c77c1f23f8c, (v)=>$7d627c46846c2ccc$export$3e523c77c1f23f8c = v);
    $parcel$export(module.exports, "totalValue", ()=>$7d627c46846c2ccc$export$c6e8091564698d96, (v)=>$7d627c46846c2ccc$export$c6e8091564698d96 = v);
    var $7d627c46846c2ccc$export$ca0c5138b6a08a79;
    var $7d627c46846c2ccc$export$85b9a36db797e02b;
    var $7d627c46846c2ccc$export$19665c9017513a41;
    var $7d627c46846c2ccc$export$ec4922be16378791;
    var $7d627c46846c2ccc$export$30b9d66acf28aaf7;
    var $7d627c46846c2ccc$export$415983cbc1f2b3fe;
    var $7d627c46846c2ccc$export$7c7bc027bbbea103;
    var $7d627c46846c2ccc$export$12781bd67c11efd8;
    var $7d627c46846c2ccc$export$b338cf20d238f012;
    var $7d627c46846c2ccc$export$a3560dfa62c7efe0;
    var $7d627c46846c2ccc$export$3e523c77c1f23f8c;
    var $7d627c46846c2ccc$export$c6e8091564698d96;
    $7d627c46846c2ccc$export$ca0c5138b6a08a79 = `qE68GG_accuracyWarning`;
    $7d627c46846c2ccc$export$85b9a36db797e02b = `qE68GG_count`;
    $7d627c46846c2ccc$export$19665c9017513a41 = `qE68GG_countLabel`;
    $7d627c46846c2ccc$export$ec4922be16378791 = `qE68GG_flyout`;
    $7d627c46846c2ccc$export$30b9d66acf28aaf7 = `qE68GG_flyoutOld`;
    $7d627c46846c2ccc$export$415983cbc1f2b3fe = `qE68GG_issueIcon`;
    $7d627c46846c2ccc$export$7c7bc027bbbea103 = `qE68GG_issueSummary`;
    $7d627c46846c2ccc$export$12781bd67c11efd8 = `qE68GG_issueTitle`;
    $7d627c46846c2ccc$export$b338cf20d238f012 = `qE68GG_issueTitleCell`;
    $7d627c46846c2ccc$export$a3560dfa62c7efe0 = `qE68GG_percentage`;
    $7d627c46846c2ccc$export$3e523c77c1f23f8c = `qE68GG_separator`;
    $7d627c46846c2ccc$export$c6e8091564698d96 = `qE68GG_totalValue`;
});
parcelRegister("5fRdR", function(module, exports) {
    $parcel$export(module.exports, "roundToTwoDigit", ()=>$b3e06f5af4c8fae5$export$86ca448670eadcc3);
    const $b3e06f5af4c8fae5$export$86ca448670eadcc3 = (number)=>Math.round(number * 100) / 100;
});
parcelRegister("1wJkh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$767a2e0ae49da99c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $co1wz;
    var $ousew;
    var $koVbs;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $kJXoj = parcelRequire("kJXoj");
    var $9i4v6 = parcelRequire("9i4v6");
    var $aLq1X = parcelRequire("aLq1X");
    var $5fRdR = parcelRequire("5fRdR");
    const { TODO: $767a2e0ae49da99c$var$TODO, INPROGRESS: $767a2e0ae49da99c$var$INPROGRESS, DONE: $767a2e0ae49da99c$var$DONE } = (0, $TTKUQ.ISSUE_STATUS_CATEGORIES);
    const $767a2e0ae49da99c$var$StatusFlyout = (props)=>{
        const { issueCount: issueCount, planningUnit: planningUnit, byCategoryId: byCategoryId } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getBreakdown = ()=>({
                todo: byCategoryId[String($767a2e0ae49da99c$var$TODO)],
                inprogress: byCategoryId[String($767a2e0ae49da99c$var$INPROGRESS)],
                done: byCategoryId[String($767a2e0ae49da99c$var$DONE)]
            });
        const getLabel = (count)=>{
            let label = formatMessage((0, $kJXoj.default).issueCountLabel, {
                numberOfIssues: count
            });
            const countToTwoDigit = (0, $5fRdR.roundToTwoDigit)(count);
            if (planningUnit === (0, $TTKUQ.PLANNING_UNITS).STORY_POINTS) label = formatMessage((0, $kJXoj.default).storyPointsCountLabel, {
                storyPoints: countToTwoDigit
            });
            else if (planningUnit === (0, $TTKUQ.PLANNING_UNITS).DAYS) label = formatMessage((0, $kJXoj.default).daysCountLabel, {
                days: countToTwoDigit
            });
            else if (planningUnit === (0, $TTKUQ.PLANNING_UNITS).HOURS) label = formatMessage((0, $kJXoj.default).hoursCountLabel, {
                hours: countToTwoDigit
            });
            return label;
        };
        const { todo: todo, inprogress: inprogress, done: done } = getBreakdown();
        const total = todo + inprogress + done;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? $aLq1X.flyout : $aLq1X.flyoutOld,
            "data-testid": "portfolio-3-portfolio.common.status-breakdown.components.status-flyout"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("table", null, (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", null, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "success"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).done))), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            "data-testid": "portfolio-3-portfolio.common.status-breakdown.components.done",
            "data-count": done
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9i4v6.default), {
            count: done,
            total: total,
            label: getLabel(done)
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "inprogress"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).inprogress))), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            "data-testid": "portfolio-3-portfolio.common.status-breakdown.components.inprogress",
            "data-count": inprogress
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9i4v6.default), {
            count: inprogress,
            total: total,
            label: getLabel(inprogress)
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "default"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).todo))), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            "data-testid": "portfolio-3-portfolio.common.status-breakdown.components.todo",
            "data-count": todo
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9i4v6.default), {
            count: todo,
            total: total,
            label: getLabel(todo)
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).total)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $aLq1X.countLabel
        }, getLabel(total)))), (0, $4nDwW.isDefined)(issueCount) && (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $kJXoj.default).totalIssuesLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $aLq1X.countLabel
        }, issueCount))))));
    };
    var $767a2e0ae49da99c$export$2e2bcd8739ae039 = $767a2e0ae49da99c$var$StatusFlyout;
});
parcelRegister("hBJhn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d4604b370fd74c3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7d4604b370fd74c3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        breakdownByEstimateToolTip: {
            "id": "portfolio-3-portfolio.common.status-breakdown.breakdown-by-estimate-tool-tip",
            "defaultMessage": "{done} ({donePercent}%) of {total} {planningUnit, select, Hours {hours} StoryPoints {points} Days {days} other {points}}"
        },
        statusBreakdownLabel: {
            "id": "portfolio-3-portfolio.common.status-breakdown.status-breakdown-label",
            "defaultMessage": "Label for Status breakdown"
        }
    });
});
parcelRegister("hjPTu", function(module, exports) {
    $parcel$export(module.exports, "bar", ()=>$c9bc771856d47a95$export$d927737047eb3867, (v)=>$c9bc771856d47a95$export$d927737047eb3867 = v);
    $parcel$export(module.exports, "breakdown", ()=>$c9bc771856d47a95$export$34efeb50ac145768, (v)=>$c9bc771856d47a95$export$34efeb50ac145768 = v);
    $parcel$export(module.exports, "completed", ()=>$c9bc771856d47a95$export$ec6bc36c360d4313, (v)=>$c9bc771856d47a95$export$ec6bc36c360d4313 = v);
    $parcel$export(module.exports, "container", ()=>$c9bc771856d47a95$export$34e0f9847d4c02dd, (v)=>$c9bc771856d47a95$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "overbooked", ()=>$c9bc771856d47a95$export$312c3ba826526246, (v)=>$c9bc771856d47a95$export$312c3ba826526246 = v);
    $parcel$export(module.exports, "remaining", ()=>$c9bc771856d47a95$export$b3be9c438214c6f4, (v)=>$c9bc771856d47a95$export$b3be9c438214c6f4 = v);
    var $c9bc771856d47a95$export$d927737047eb3867;
    var $c9bc771856d47a95$export$34efeb50ac145768;
    var $c9bc771856d47a95$export$ec6bc36c360d4313;
    var $c9bc771856d47a95$export$34e0f9847d4c02dd;
    var $c9bc771856d47a95$export$312c3ba826526246;
    var $c9bc771856d47a95$export$b3be9c438214c6f4;
    $c9bc771856d47a95$export$d927737047eb3867 = `uwXdGW_bar`;
    $c9bc771856d47a95$export$34efeb50ac145768 = `uwXdGW_breakdown`;
    $c9bc771856d47a95$export$ec6bc36c360d4313 = `uwXdGW_completed`;
    $c9bc771856d47a95$export$34e0f9847d4c02dd = `uwXdGW_container`;
    $c9bc771856d47a95$export$312c3ba826526246 = `uwXdGW_overbooked`;
    $c9bc771856d47a95$export$b3be9c438214c6f4 = `uwXdGW_remaining`;
});
parcelRegister("cNvrS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$419f6748e6d8eb75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $3bDjY;
    var $koVbs;
    var $gITL8 = parcelRequire("gITL8");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $geBHG = parcelRequire("geBHG");
    var $1wJkh = parcelRequire("1wJkh");
    var $hBJhn = parcelRequire("hBJhn");
    var $hjPTu = parcelRequire("hjPTu");
    const { TODO: $419f6748e6d8eb75$var$TODO, INPROGRESS: $419f6748e6d8eb75$var$INPROGRESS, DONE: $419f6748e6d8eb75$var$DONE } = (0, $TTKUQ.ISSUE_STATUS_CATEGORIES);
    const $419f6748e6d8eb75$var$StatusBreakdown = (props)=>{
        const { onlyRenderStatusBar: onlyRenderStatusBar = false, breakdownBy: breakdownBy = (0, $TTKUQ.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS, total: total, label: label, showToolTip: showToolTip, planningUnit: planningUnit, byCategoryId: byCategoryId } = props;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onToggle = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(!isOpen);
        }, [
            isOpen
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []);
        const getBreakdown = (0, $5uXOq.useCallback)(()=>({
                todo: byCategoryId[String($419f6748e6d8eb75$var$TODO)],
                inprogress: byCategoryId[String($419f6748e6d8eb75$var$INPROGRESS)],
                done: byCategoryId[String($419f6748e6d8eb75$var$DONE)]
            }), [
            byCategoryId
        ]);
        const renderStatusBar = (0, $5uXOq.useCallback)(()=>{
            const { todo: todo, inprogress: inprogress, done: done } = getBreakdown();
            const remaining = todo + inprogress;
            const todoWidth = todo / total * 100;
            const inProgressWidth = inprogress / total * 100;
            const doneWidth = total === 0 ? 0 : done / total * 100;
            const remainingWidth = total === 0 ? 100 : remaining / total * 100;
            const overBooked = done > total;
            const todoBar = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    width: `${todoWidth}%`,
                    backgroundColor: (0, $gITL8.statusBreakdownColourMap).TODO
                }
            });
            const inprogressBar = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    width: `${inProgressWidth}%`,
                    backgroundColor: (0, $gITL8.statusBreakdownColourMap).INPROGRESS
                }
            });
            const doneBar = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    width: `${doneWidth}%`,
                    backgroundColor: (0, $gITL8.statusBreakdownColourMap).DONE
                }
            });
            let bar = breakdownBy === 'status' ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.bar,
                "data-testid": "portfolio-3-portfolio.common.status-breakdown.status-breakdown-bar"
            }, doneWidth > 0 && doneBar, inProgressWidth > 0 && inprogressBar, todoWidth > 0 && todoBar) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.bar,
                "data-testid": "portfolio-3-portfolio.common.status-breakdown.status-breakdown-bar"
            }, doneWidth > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: overBooked ? `${$hjPTu.completed} ${$hjPTu.overbooked}` : $hjPTu.completed,
                style: {
                    width: `${doneWidth}%`
                }
            }), remainingWidth > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.remaining,
                style: {
                    width: `${remainingWidth}%`
                }
            }));
            if (showToolTip === true && breakdownBy === 'estimate') bar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage((0, $hBJhn.default).breakdownByEstimateToolTip, {
                    done: done,
                    donePercent: total ? Math.round(done * 100 / total) : '0',
                    total: total,
                    planningUnit: planningUnit
                }),
                position: "mouse"
            }, bar);
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.breakdown
            }, label, bar));
        }, [
            breakdownBy,
            formatMessage,
            getBreakdown,
            label,
            planningUnit,
            showToolTip,
            total
        ]);
        const renderTrigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hjPTu.container,
                onClick: onToggle,
                tabIndex: 0,
                role: "button",
                onKeyDown: ()=>{},
                "data-testid": "portfolio-3-portfolio.common.status-breakdown.trigger",
                ...triggerProps,
                "aria-label": formatMessage((0, $hBJhn.default).statusBreakdownLabel)
            }, renderStatusBar()), [
            onToggle,
            renderStatusBar,
            formatMessage
        ]);
        const renderContent = ()=>breakdownBy === (0, $TTKUQ.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1wJkh.default), props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $geBHG.default), props);
        if (total === 0 && breakdownBy === (0, $TTKUQ.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS) return null;
        if (onlyRenderStatusBar) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $hjPTu.container
        }, renderStatusBar());
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: onClose,
            trigger: renderTrigger,
            content: renderContent,
            placement: "bottom-start"
        });
    };
    var $419f6748e6d8eb75$export$2e2bcd8739ae039 = $419f6748e6d8eb75$var$StatusBreakdown;
});
parcelRegister("75ZB6", function(module, exports) {
    $parcel$export(module.exports, "breakdown-container", ()=>$52a8c7fb7607a794$export$c192079175952776, (v)=>$52a8c7fb7607a794$export$c192079175952776 = v);
    var $52a8c7fb7607a794$export$c192079175952776;
    $52a8c7fb7607a794$export$c192079175952776 = `_8rLZ3q_breakdown-container`;
});
parcelRegister("q7HKA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1cd9f1941e1e1027$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6nCiN = parcelRequire("6nCiN");
    var $3z74z = parcelRequire("3z74z");
    var $eeZxb = parcelRequire("eeZxb");
    var $1cd9f1941e1e1027$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $3z74z.default), (0, $6nCiN.default))((0, $eeZxb.default));
});
parcelRegister("6nCiN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f2b38f1b354f62c$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $9f2b38f1b354f62c$var$dispatchMethods = (dispatch)=>({
            onChange: (issue, components)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    components: components.length === 0 ? null : components
                }));
            }
        });
    var $9f2b38f1b354f62c$export$2e2bcd8739ae039 = $9f2b38f1b354f62c$var$dispatchMethods;
});
parcelRegister("3z74z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52b685d01e8bd93d$export$2e2bcd8739ae039);
    var $5nMRY = parcelRequire("5nMRY");
    var $3YtPS = parcelRequire("3YtPS");
    const $52b685d01e8bd93d$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        componentsByProjectId: (0, $5nMRY.getComponentsByProjectId)
    });
    var $52b685d01e8bd93d$export$2e2bcd8739ae039 = $52b685d01e8bd93d$var$querySelector;
});
parcelRegister("eeZxb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abc94ce846317607$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5GrTX = parcelRequire("5GrTX");
    function $abc94ce846317607$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5GrTX.default), props);
    }
});
parcelRegister("5GrTX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67a1abdc080958bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $8eWTv = parcelRequire("8eWTv");
    var $2wUfa = parcelRequire("2wUfa");
    const $67a1abdc080958bc$var$getComponentOption = (component)=>({
            label: component.name,
            value: component.id.toString()
        });
    const $67a1abdc080958bc$export$8d800dbad5a57be1 = ({ issue: issue, componentsByProjectId: componentsByProjectId })=>{
        if (!issue.project) return [];
        return componentsByProjectId[issue.project.toString()] || [];
    };
    const $67a1abdc080958bc$export$77d77034d25f4a4c = ({ issue: issue, componentsByProjectId: componentsByProjectId })=>$67a1abdc080958bc$export$8d800dbad5a57be1({
            issue: issue,
            componentsByProjectId: componentsByProjectId
        }).filter((component)=>(issue.components || []).includes(component.id));
    const $67a1abdc080958bc$export$cdb8a2fe02a819d9 = ({ attribute: attribute, issue: issue, isDisabled: isDisabled, isReadOnly: isReadOnly, componentsByProjectId: componentsByProjectId, onChange: onChange })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const getIssueComponents = ()=>$67a1abdc080958bc$export$8d800dbad5a57be1({
                issue: issue,
                componentsByProjectId: componentsByProjectId
            }).filter((component)=>(issue.components || []).includes(component.id));
        const fetchOptions = (query)=>Promise.resolve($67a1abdc080958bc$export$8d800dbad5a57be1({
                issue: issue,
                componentsByProjectId: componentsByProjectId
            }).map($67a1abdc080958bc$var$getComponentOption).filter((option)=>option.label.toLowerCase().includes(query.toLowerCase())));
        const handleComponentsChange = (issue, options)=>{
            if (!options) return;
            onChange(issue, options.map((item)=>Number(item.value)));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8eWTv.default), {
            attribute: attribute,
            messages: {
                placeholder: intl.formatMessage((0, $2wUfa.default).componentsLabel),
                noLabels: intl.formatMessage((0, $2wUfa.default).noComponents),
                noLabelsLeft: intl.formatMessage((0, $2wUfa.default).noComponentsLeft),
                noMatch: intl.formatMessage((0, $2wUfa.default).noMatch)
            },
            getValues: ()=>getIssueComponents().map($67a1abdc080958bc$var$getComponentOption),
            fetchOptions: fetchOptions,
            isReadOnly: isReadOnly,
            isDisabled: isDisabled,
            issue: issue,
            onChange: handleComponentsChange
        });
    };
    var $67a1abdc080958bc$export$2e2bcd8739ae039 = $67a1abdc080958bc$export$cdb8a2fe02a819d9;
});
parcelRegister("2wUfa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$134370a4dbfe080a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $134370a4dbfe080a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        componentsLabel: {
            "id": "portfolio-3-portfolio.common.cells.components.components-label",
            "defaultMessage": "Choose a component"
        },
        noComponents: {
            "id": "portfolio-3-portfolio.common.cells.components.no-components",
            "defaultMessage": "There are no components in this project"
        },
        noComponentsLeft: {
            "id": "portfolio-3-portfolio.common.cells.components.no-components-left",
            "defaultMessage": "No available components left"
        },
        noMatch: {
            "id": "portfolio-3-portfolio.common.cells.components.no-match",
            "defaultMessage": "No results match your search"
        }
    });
});
parcelRegister("2Swc7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91dff03a65ac2b72$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "createDateCell", ()=>$91dff03a65ac2b72$export$33f3410f8828e1b1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bC2fB;
    var $fbxiK = parcelRequire("fbxiK");
    var $lAbav = parcelRequire("lAbav");
    var $9rfSc = parcelRequire("9rfSc");
    var $91dff03a65ac2b72$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $lAbav.default), (0, $fbxiK.default))((0, $9rfSc.default));
    const $91dff03a65ac2b72$export$33f3410f8828e1b1 = (DateCellComponent, type)=>class extends (0, $5uXOq.Component) {
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(DateCellComponent, {
                    ...this.props,
                    type: type
                });
            }
        };
});
parcelRegister("fbxiK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63bfe886b551afaa$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $63bfe886b551afaa$var$dispatchMethods = (dispatch)=>({
            onChange: ({ issue: issue, field: field, date: date })=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    [field]: date
                }));
            }
        });
    var $63bfe886b551afaa$export$2e2bcd8739ae039 = $63bfe886b551afaa$var$dispatchMethods;
});
parcelRegister("lAbav", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74cf2b2c5aeda86a$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    const $74cf2b2c5aeda86a$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        dateConfiguration: (0, $bHTqr.getDateConfiguration),
        isExportMode: $1CGdp.isExportMode
    });
    var $74cf2b2c5aeda86a$export$2e2bcd8739ae039 = $74cf2b2c5aeda86a$var$querySelector;
});
parcelRegister("9rfSc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db0e2000bffca48a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $2JlG5;
    var $9Qayl;
    var $lj8SI;
    var $3bDjY;
    var $7R4eB;
    var $3KRpp;
    var $koVbs;
    var $gh61P;
    var $aipk9;
    var $iwfmd;
    var $f9Tpd;
    var $l38L3 = parcelRequire("l38L3");
    var $5fACX = parcelRequire("5fACX");
    var $ixSW4 = parcelRequire("ixSW4");
    var $90ldD = parcelRequire("90ldD");
    var $4nDwW = parcelRequire("4nDwW");
    var $DVljb;
    var $3FQWJ = parcelRequire("3FQWJ");
    var $gJlUc = parcelRequire("gJlUc");
    var $gffZE = parcelRequire("gffZE");
    var $1Oqq9 = parcelRequire("1Oqq9");
    var $2L95O = parcelRequire("2L95O");
    var $hx5He = parcelRequire("hx5He");
    const $db0e2000bffca48a$var$DateCell = ({ dateConfiguration: dateConfiguration, attribute: attributeProp, type: type, issue: { summary: summary }, isReadOnly: isReadOnly, isScrolling: isScrolling, issue: issue, showOptimizations: showOptimizations = false, onChange: onChange, DatePicker: DatePicker, isExportMode: isExportMode })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const { formatDate: formatDateIntl, formatTimestamp: formatTimestamp } = (0, (0, parcelRequire("aipk9")).useDateFormatter)();
        const [isActive, setIsActive] = (0, $5uXOq.useState)(false);
        const [flags, setFlags] = (0, $5uXOq.useState)([]);
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const [isValid, setIsValid] = (0, $5uXOq.useState)(true);
        const mapDateToFormattedValue = (_, value)=>{
            if (!value) return '';
            return (0, (0, parcelRequire("aipk9")).formatDateUTC)(value, (0, (0, parcelRequire("gh61P")).DefaultDateFormat));
        };
        const attribute = (0, $hx5He.issueField)[type] ?? attributeProp;
        const date = issue[attribute];
        const label = (0, $hx5He.labels)[type];
        let value = showOptimizations ? (0, $l38L3.getOptimizedValue)(issue, attribute) : date;
        if ((0, $4nDwW.isDefined)(value)) value = (0, (0, parcelRequire("aipk9")).formatDateUTC)(value, (0, (0, parcelRequire("gh61P")).IsoDateFormat));
        else value = '';
        const isCellDirty = ()=>{
            const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
            const startDatePath = baselineStartField.type === (0, $5fACX.DATEFIELD_TYPES).CUSTOM ? [
                'customFields',
                baselineStartField.key
            ] : [
                baselineStartField.key
            ];
            const endDatePath = baselineEndField.type === (0, $5fACX.DATEFIELD_TYPES).CUSTOM ? [
                'customFields',
                baselineEndField.key
            ] : [
                baselineEndField.key
            ];
            if (type === (0, $2L95O.DateTypes).Start) return !!issue.originals && (0, parcelRequire("9Qayl")).default(startDatePath, issue.originals);
            if (type === (0, $2L95O.DateTypes).End) return !!issue.originals && (0, parcelRequire("9Qayl")).default(endDatePath, issue.originals);
            if (type === (0, $2L95O.DateTypes).Other) return !!issue.originals && (0, parcelRequire("2JlG5")).default(attribute, issue.originals);
            return false;
        };
        const handleChange = (changedDate)=>{
            (0, $hx5He.handleChange)(changedDate, {
                onChange: onChange,
                issue: issue,
                type: type,
                attribute: attribute,
                flags: flags,
                setFlags: setFlags,
                intl: intl,
                setIsValid: setIsValid
            });
        };
        const getAlignedDate = (isDatePickerActive, dateType, baseLineStart, baseLineEnd, rawDate)=>{
            if (isDatePickerActive) {
                if (dateType === (0, $2L95O.DateTypes).End && (0, $4nDwW.isDefined)(baseLineStart) && !(0, $4nDwW.isDefined)(baseLineEnd)) return (0, (0, parcelRequire("aipk9")).formatDateUTC)(baseLineStart, (0, (0, parcelRequire("gh61P")).IsoDateFormat));
                if (dateType === (0, $2L95O.DateTypes).Start && (0, $4nDwW.isDefined)(baseLineEnd) && !(0, $4nDwW.isDefined)(baseLineStart)) return (0, (0, parcelRequire("aipk9")).formatDateUTC)(baseLineEnd, (0, (0, parcelRequire("gh61P")).IsoDateFormat));
            }
            return rawDate;
        };
        const renderDatePicker = ({ intl: intl, isReadOnly: isReadOnly, label: label, summary: summary, value: value, type: type })=>{
            const adjustedDate = getAlignedDate(isActive, type, issue.baselineStart, issue.baselineEnd, value);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "aria-label": intl.formatMessage(label, {
                    issue: summary
                }),
                className: (0, ($parcel$interopDefault($9ci4W)))({
                    [$1Oqq9['cell-valid']]: isValid,
                    [$1Oqq9['cell-invalid']]: !isValid,
                    [$1Oqq9.isReadOnly]: isReadOnly
                })
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9Tpd")).default), {
                enabled: isActive
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
                onHoverChanged: setIsHovered
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(DatePicker, {
                autoFocus: isActive && (type === (0, $2L95O.DateTypes).Start || type === (0, $2L95O.DateTypes).End),
                isDisabled: isReadOnly,
                isTransparentBackground: true,
                onChange: handleChange,
                onToggle: setIsActive,
                placeholder: intl.formatMessage((0, $gffZE.default).placeholder),
                showClearIndicator: true,
                styles: {
                    placeholder: (styles)=>({
                            display: !isHovered && 'none',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            width: 'calc(100% - 9px)',
                            ...styles
                        })
                },
                value: adjustedDate,
                label: intl.formatMessage((0, $gffZE.default).placeholder)
            })));
        };
        const formattedDate = (()=>{
            let date = 0;
            if (type === (0, $2L95O.DateTypes).Start) {
                if (!(0, $4nDwW.isDefined)(issue.baselineStart)) return '';
                date = issue.baselineStart;
            } else if (type === (0, $2L95O.DateTypes).End) {
                if (!(0, $4nDwW.isDefined)(issue.baselineEnd)) return '';
                date = issue.baselineEnd;
            }
            return formatTimestamp(date);
        })();
        const renderInferredDate = (tooltip, icon)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                onClick: ()=>setIsActive(true),
                onKeyDown: ()=>setIsActive(true),
                role: "button",
                tabIndex: 0
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $1Oqq9.projectedDate
            }, isExportMode ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $1Oqq9.exportPNGLozenge
            }, icon) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $1Oqq9.rollUpIcon
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: tooltip
            }, icon)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $1Oqq9.projectedDateText
            }, formattedDate)));
        const getContent = ({ intl: intl, isReadOnly: isReadOnly, label: label, showOptimizations: showOptimizations, summary: summary, value: value, type: type })=>{
            const methodOfDateInferrence = (0, $hx5He.getTheMethodOfDateInferrence)(issue, type);
            const tooltipForInferredDateUsingSprint = intl.formatMessage((0, $gffZE.default).projectedDatesUsingSprintTooltip);
            const iconForInferredDateUsingSprint = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, "S");
            const tooltipForInferredDateUsingRelease = intl.formatMessage((0, $gffZE.default).projectedDatesUsingReleasesTooltip);
            const iconForInferredDateUsingRelease = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, "R");
            const tooltipForInferredDateUsingRollUp = intl.formatMessage((0, $gJlUc.default).rolledUpEstimateToolip, {
                value: formattedDate || intl.formatMessage((0, $gffZE.default).noDate)
            });
            const iconForInferredDateUsingRollUp = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $90ldD.default), {
                label: ""
            });
            if (!showOptimizations && (!isActive || isReadOnly)) {
                if (methodOfDateInferrence === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).SPRINT) return renderInferredDate(tooltipForInferredDateUsingSprint, iconForInferredDateUsingSprint);
                if (methodOfDateInferrence === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).RELEASE) return renderInferredDate(tooltipForInferredDateUsingRelease, iconForInferredDateUsingRelease);
                if (methodOfDateInferrence === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP) return renderInferredDate(tooltipForInferredDateUsingRollUp, iconForInferredDateUsingRollUp);
            }
            return renderDatePicker({
                intl: intl,
                isReadOnly: isReadOnly,
                label: label,
                summary: summary,
                value: value,
                type: type
            });
        };
        const getWireFrame = ({ intl: intl, isReadOnly: isReadOnly, label: label, showOptimizations: showOptimizations, summary: summary, value: value })=>{
            const className = (0, ($parcel$interopDefault($9ci4W)))($1Oqq9.wireframe, $1Oqq9[isValid ? 'cell-valid' : 'cell-invalid'], $1Oqq9[showOptimizations ? 'readOnly' : '']);
            function getFormattedValue() {
                return formatDateIntl(value);
            }
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "aria-label": intl.formatMessage(label, {
                    issue: summary
                }),
                className: className
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                className: value ? '' : $1Oqq9.placeholder,
                value: value ? getFormattedValue() : '',
                onChange: ()=>{},
                readOnly: isReadOnly,
                disabled: isReadOnly
            })));
        };
        const dismissFlag = ()=>{
            setFlags(flags.slice(1));
        };
        const warningFlags = ()=>flags.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).FlagGroup), {
                onDismissed: dismissFlag
            }, flags.map(({ ...flag }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7R4eB")).default), {
                    ...flag,
                    key: index
                }))) : null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
            attribute: attribute,
            isCellDirty: isCellDirty,
            issue: issue,
            valueMapper: mapDateToFormattedValue,
            delta: (0, $hx5He.getDateDiff),
            isScrolling: isScrolling,
            showOptimizations: showOptimizations,
            locale: locale
        }, !isScrolling ? getContent({
            intl: intl,
            isReadOnly: isReadOnly,
            label: label,
            showOptimizations: showOptimizations,
            summary: summary,
            value: value,
            type: type
        }) : getWireFrame({
            intl: intl,
            isReadOnly: isReadOnly,
            label: label,
            showOptimizations: showOptimizations,
            summary: summary,
            value: value
        }), warningFlags());
    };
    var $db0e2000bffca48a$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        DatePicker: (0, $ixSW4.slots).FieldDatePicker
    })($db0e2000bffca48a$var$DateCell);
});
parcelRegister("7R4eB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$435170f9f2349b2e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $3KRpp;
    const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            isAutoDismiss: true,
            ...props,
            flagType: "info"
        }));
    var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;
});
parcelRegister("gJlUc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2bec28b71566eb2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b2bec28b71566eb2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rolledUpEstimateToolip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.rolled-up-estimate-toolip",
            "defaultMessage": "Rolled-up value: {value}"
        }
    });
});
parcelRegister("gffZE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d4cf1fe7669ce1c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2d4cf1fe7669ce1c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.placeholder",
            "defaultMessage": "Choose a date"
        },
        startDateLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.start-date-label",
            "defaultMessage": "Choose target start date for issue {issue}"
        },
        endDateLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.end-date-label",
            "defaultMessage": "Choose target end date for issue {issue}"
        },
        dateLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.date-label",
            "defaultMessage": "Choose date field for issue {issue}"
        },
        projectedDatesUsingSprintTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.projected-dates-using-sprint-tooltip",
            "defaultMessage": "This issue has no dates, so it's using the dates of its assigned sprint."
        },
        projectedDatesUsingReleasesTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.projected-dates-using-releases-tooltip",
            "defaultMessage": "This issue has no dates, so it's using the dates of its assigned releases."
        },
        noDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.no-date",
            "defaultMessage": "No date"
        }
    });
});
parcelRegister("1Oqq9", function(module, exports) {
    $parcel$export(module.exports, "cell-invalid", ()=>$151ef492318db17f$export$387981ce241ed7d9, (v)=>$151ef492318db17f$export$387981ce241ed7d9 = v);
    $parcel$export(module.exports, "cell-valid", ()=>$151ef492318db17f$export$5d11244acbce5c4a, (v)=>$151ef492318db17f$export$5d11244acbce5c4a = v);
    $parcel$export(module.exports, "exportPNGLozenge", ()=>$151ef492318db17f$export$1ec0dee322814bb4, (v)=>$151ef492318db17f$export$1ec0dee322814bb4 = v);
    $parcel$export(module.exports, "isReadOnly", ()=>$151ef492318db17f$export$2498094d90b6ac72, (v)=>$151ef492318db17f$export$2498094d90b6ac72 = v);
    $parcel$export(module.exports, "placeholder", ()=>$151ef492318db17f$export$c7187bbd1a7a9244, (v)=>$151ef492318db17f$export$c7187bbd1a7a9244 = v);
    $parcel$export(module.exports, "projectedDate", ()=>$151ef492318db17f$export$4b0386405699aa0a, (v)=>$151ef492318db17f$export$4b0386405699aa0a = v);
    $parcel$export(module.exports, "projectedDateText", ()=>$151ef492318db17f$export$664bf476323cd04d, (v)=>$151ef492318db17f$export$664bf476323cd04d = v);
    $parcel$export(module.exports, "readOnly", ()=>$151ef492318db17f$export$b2cbc93d4da94977, (v)=>$151ef492318db17f$export$b2cbc93d4da94977 = v);
    $parcel$export(module.exports, "rollUpIcon", ()=>$151ef492318db17f$export$894901fa58357dbf, (v)=>$151ef492318db17f$export$894901fa58357dbf = v);
    $parcel$export(module.exports, "wireframe", ()=>$151ef492318db17f$export$a8fec3cf51c7da20, (v)=>$151ef492318db17f$export$a8fec3cf51c7da20 = v);
    var $151ef492318db17f$export$387981ce241ed7d9;
    var $151ef492318db17f$export$5d11244acbce5c4a;
    var $151ef492318db17f$export$1ec0dee322814bb4;
    var $151ef492318db17f$export$2498094d90b6ac72;
    var $151ef492318db17f$export$c7187bbd1a7a9244;
    var $151ef492318db17f$export$4b0386405699aa0a;
    var $151ef492318db17f$export$664bf476323cd04d;
    var $151ef492318db17f$export$b2cbc93d4da94977;
    var $151ef492318db17f$export$894901fa58357dbf;
    var $151ef492318db17f$export$a8fec3cf51c7da20;
    $151ef492318db17f$export$387981ce241ed7d9 = `Tw2-xG_cell-invalid`;
    $151ef492318db17f$export$5d11244acbce5c4a = `Tw2-xG_cell-valid`;
    $151ef492318db17f$export$1ec0dee322814bb4 = `Tw2-xG_exportPNGLozenge`;
    $151ef492318db17f$export$2498094d90b6ac72 = `Tw2-xG_isReadOnly`;
    $151ef492318db17f$export$c7187bbd1a7a9244 = `Tw2-xG_placeholder`;
    $151ef492318db17f$export$4b0386405699aa0a = `Tw2-xG_projectedDate`;
    $151ef492318db17f$export$664bf476323cd04d = `Tw2-xG_projectedDateText`;
    $151ef492318db17f$export$b2cbc93d4da94977 = `Tw2-xG_readOnly`;
    $151ef492318db17f$export$894901fa58357dbf = `Tw2-xG_rollUpIcon`;
    $151ef492318db17f$export$a8fec3cf51c7da20 = `Tw2-xG_wireframe`;
});
parcelRegister("2L95O", function(module, exports) {
    $parcel$export(module.exports, "DateTypes", ()=>$a0d82cd34db83c12$export$7690b1846650bc08);
    const $a0d82cd34db83c12$export$7690b1846650bc08 = {
        Start: 'START',
        End: 'END',
        Other: 'OTHER'
    };
});
parcelRegister("hx5He", function(module, exports) {
    $parcel$export(module.exports, "issueField", ()=>$96b066c0c133da3f$export$453c7585f6587ecc);
    $parcel$export(module.exports, "labels", ()=>$96b066c0c133da3f$export$a238cb463698c900);
    $parcel$export(module.exports, "getDateDiff", ()=>$96b066c0c133da3f$export$9cd30990ce195ccd);
    $parcel$export(module.exports, "getTheMethodOfDateInferrence", ()=>$96b066c0c133da3f$export$e6f648b65089ac1e);
    $parcel$export(module.exports, "handleChange", ()=>$96b066c0c133da3f$export$1ba2cb844e41b315);
    var $5uXOq = parcelRequire("5uXOq");
    var $jNuzB;
    var $jovBr;
    var $fZhYM;
    var $gtreQ;
    var $gJZ5D;
    var $aipk9;
    var $flnZx;
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $gffZE = parcelRequire("gffZE");
    var $2L95O = parcelRequire("2L95O");
    const $96b066c0c133da3f$export$453c7585f6587ecc = {
        [(0, $2L95O.DateTypes).Start]: 'baselineStart',
        [(0, $2L95O.DateTypes).End]: 'baselineEnd',
        [(0, $2L95O.DateTypes).Other]: undefined
    };
    const $96b066c0c133da3f$export$a238cb463698c900 = {
        [(0, $2L95O.DateTypes).Start]: (0, $gffZE.default).startDateLabel,
        [(0, $2L95O.DateTypes).End]: (0, $gffZE.default).endDateLabel,
        [(0, $2L95O.DateTypes).Other]: (0, $gffZE.default).dateLabel
    };
    const $96b066c0c133da3f$export$9cd30990ce195ccd = (stringDate1, stringDate2, locale)=>{
        if (stringDate1 == null || stringDate2 == null) return '';
        const date1 = new Date(stringDate1);
        const date2 = new Date(stringDate2);
        if (!(0, (0, parcelRequire("jovBr")).default)(date1) || !(0, (0, parcelRequire("jovBr")).default)(date2) || (0, (0, parcelRequire("jNuzB")).default)(date1, date2)) return '';
        return `(${(0, (0, parcelRequire("flnZx")).distanceInWordsWithPolarity)(date1.getTime(), date2.getTime(), locale)})`;
    };
    const $96b066c0c133da3f$export$64a5b7a68f1d5081 = (issue, type, date)=>{
        const targetStart = issue[$96b066c0c133da3f$export$453c7585f6587ecc[(0, $2L95O.DateTypes).Start]];
        const targetEnd = issue[$96b066c0c133da3f$export$453c7585f6587ecc[(0, $2L95O.DateTypes).End]];
        if (Number.isNaN(date)) return false;
        if (type === (0, $2L95O.DateTypes).Start && targetEnd != null && date > targetEnd) return false;
        if (type === (0, $2L95O.DateTypes).End && targetStart != null && targetStart > date) return false;
        return true;
    };
    const $96b066c0c133da3f$export$92521769c5df59ad = (issue, type)=>{
        let date = 0;
        if (type === (0, $2L95O.DateTypes).Start) {
            if (!(0, $4nDwW.isDefined)(issue.baselineStart)) return '';
            date = issue.baselineStart;
        } else if (type === (0, $2L95O.DateTypes).End) {
            if (!(0, $4nDwW.isDefined)(issue.baselineEnd)) return '';
            date = issue.baselineEnd;
        }
        return (0, (0, parcelRequire("aipk9")).formatDateUTC)(date, (0, $TTKUQ.DefaultDateFormat));
    };
    const $96b066c0c133da3f$export$e6f648b65089ac1e = (issue, type)=>{
        if (type !== (0, $2L95O.DateTypes).Other) {
            const attribute = $96b066c0c133da3f$export$453c7585f6587ecc[type] || '';
            const inferredFrom = (0, parcelRequire("fZhYM")).default([
                'inferred',
                attribute
            ], issue);
            return inferredFrom || (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).NONE;
        }
        return (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).NONE;
    };
    const $96b066c0c133da3f$var$getFlagData = (index, intl, type)=>{
        const timeOffset = 0;
        const warningIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`,
            size: "medium"
        });
        const description = type === (0, $2L95O.DateTypes).Start ? (0, $ihPUd.default).invalidDateStartBeforeEnd : (0, $ihPUd.default).invalidDateEndAfterStart;
        return {
            created: Date.now() - timeOffset * 1000,
            title: intl.formatMessage((0, $ihPUd.default).invalidDateTitle),
            description: intl.formatMessage(description),
            icon: warningIcon,
            id: index,
            key: index
        };
    };
    const $96b066c0c133da3f$var$addFlag = (flags, setFlags, intl, type)=>{
        const nextFlags = flags.slice();
        nextFlags.unshift($96b066c0c133da3f$var$getFlagData(flags.length + 1, intl, type));
        setFlags(nextFlags);
    };
    const $96b066c0c133da3f$export$1ba2cb844e41b315 = (changedDate, { onChange: onChange, issue: issue, type: type, attribute: attribute, flags: flags, setFlags: setFlags, intl: intl, setIsValid: setIsValid })=>{
        if (changedDate === '' || !(0, (0, parcelRequire("flnZx")).isISOCompatible)(changedDate)) onChange({
            issue: issue,
            field: $96b066c0c133da3f$export$453c7585f6587ecc[type] ?? attribute,
            date: undefined
        });
        else {
            const date = type === (0, $2L95O.DateTypes).Start ? (0, (0, parcelRequire("flnZx")).startOfUtcDay)(changedDate) : (0, (0, parcelRequire("flnZx")).endOfUtcDay)(changedDate);
            const validity = $96b066c0c133da3f$export$64a5b7a68f1d5081(issue, type, date);
            setIsValid(validity);
            if (!validity) $96b066c0c133da3f$var$addFlag(flags, setFlags, intl, type);
            else onChange({
                issue: issue,
                field: $96b066c0c133da3f$export$453c7585f6587ecc[type] ?? attribute,
                date: date
            });
        }
    };
});
parcelRegister("kexn9", function(module, exports) {
    $parcel$export(module.exports, "IncomingDependenciesCell", ()=>$0274abee9efcaf8c$export$a3b08300c887bd44);
    $parcel$export(module.exports, "OutgoingDependenciesCell", ()=>$0274abee9efcaf8c$export$14dbbf44c8220856);
    var $5uXOq = parcelRequire("5uXOq");
    var $iYh8K = parcelRequire("iYh8K");
    var $2dZwa = parcelRequire("2dZwa");
    var $diD1j = parcelRequire("diD1j");
    var $4ituw = parcelRequire("4ituw");
    var $dlAAz = parcelRequire("dlAAz");
    var $5P3xt = parcelRequire("5P3xt");
    class $0274abee9efcaf8c$export$2e2bcd8739ae039 extends (0, $iYh8K.default) {
        render() {
            const { issue: issue, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, internalOriginalIssueLinks: internalOriginalIssueLinks } = this.props;
            const { direction: direction, ...dependenciesProps } = this.props;
            const isDialogLocked = Object.values(this.state.dialogLockingInstances).some((value)=>!!value);
            const renderDialogContent = (update)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $2dZwa.DependenciesDialogContext).Provider, {
                    value: {
                        isDialogLocked: isDialogLocked,
                        toggleDialogLocked: this.toggleDialogLocked
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $diD1j.default), {
                    direction: direction,
                    issue: issue,
                    externalIssueLinks: externalIssueLinks,
                    internalIssueLinks: internalIssueLinks,
                    internalOriginalIssueLinks: internalOriginalIssueLinks,
                    context: "dropdown",
                    updatePopup: update
                }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4ituw.default), {
                ...dependenciesProps,
                renderDialogContent: renderDialogContent,
                isDialogLocked: isDialogLocked
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                dialogLockingInstances: {}
            };
            this.toggleDialogLocked = (instanceName)=>(isLocked)=>{
                    this.setState(({ dialogLockingInstances: dialogLockingInstances })=>({
                            dialogLockingInstances: {
                                ...dialogLockingInstances,
                                [instanceName]: isLocked
                            }
                        }));
                };
        }
    }
    const $0274abee9efcaf8c$export$a3b08300c887bd44 = (0, $dlAAz.default)($0274abee9efcaf8c$export$2e2bcd8739ae039);
    const $0274abee9efcaf8c$export$14dbbf44c8220856 = (0, $5P3xt.default)($0274abee9efcaf8c$export$2e2bcd8739ae039);
});
parcelRegister("iYh8K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07f873835a23f7ca$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3YtPS = parcelRequire("3YtPS");
    const $07f873835a23f7ca$var$EQUALS_DEPTH_LIMIT = 256;
    class $07f873835a23f7ca$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        shouldComponentUpdate(nextProps, nextState) {
            return !(0, $3YtPS.equals)(this.props, nextProps, $07f873835a23f7ca$var$EQUALS_DEPTH_LIMIT) || !(0, $3YtPS.equals)(this.state, nextState, $07f873835a23f7ca$var$EQUALS_DEPTH_LIMIT);
        }
    }
});
parcelRegister("4ituw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e194656c5030f7d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c8Oei;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $ousew;
    var $aCpcO;
    var $iwfmd;
    var $f9Tpd;
    var $kC16r = parcelRequire("kC16r");
    var $dCm1o;
    var $5vFXg = parcelRequire("5vFXg");
    const $0e194656c5030f7d$var$DependenciesCell = (props)=>{
        const { renderDialogContent: renderDialogContent, isChanged: isChanged, isOptimizedMode: isOptimizedMode, messages: messages, isDialogLocked: isDialogLocked, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, isReadOnly: isReadOnly } = props;
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const onToggle = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(!isOpen);
        }, [
            isOpen
        ]);
        const onHoverChanged = (0, $5uXOq.useCallback)((isHovered)=>{
            setIsHovered(isHovered);
        }, []);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            if (isDialogLocked) return;
            setIsOpen(false);
        }, [
            isDialogLocked
        ]);
        const getIssueLinksCount = (0, $5uXOq.useCallback)(()=>externalIssueLinks.length + internalIssueLinks.length, [
            externalIssueLinks.length,
            internalIssueLinks.length
        ]);
        const renderIssueCount = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5vFXg.issuesCount,
                onClick: onToggle,
                tabIndex: 0,
                role: "button",
                onKeyDown: ()=>{},
                ...triggerProps
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5vFXg.issuesLabel
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...messages.issues,
                values: {
                    count: getIssueLinksCount()
                }
            })), (isHovered || isOpen) && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $0e194656c5030f7d$var$iconContainerStyle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
                label: "",
                LEGACY_size: "large",
                color: "var(--ds-icon, #44546F)"
            }))), [
            getIssueLinksCount,
            isHovered,
            isOpen,
            messages.issues,
            onToggle
        ]);
        const renderAddDependency = (0, $5uXOq.useCallback)((triggerProps)=>!isReadOnly && (isHovered || isOpen) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                appearance: "link",
                onClick: onToggle,
                ...triggerProps
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), messages.addDependency)) : null, [
            isHovered,
            isOpen,
            isReadOnly,
            messages.addDependency,
            onToggle
        ]);
        const renderTrigger = (0, $5uXOq.useCallback)(({ ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
                onHoverChanged: onHoverChanged
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                className: $5vFXg.container
            }, getIssueLinksCount() > 0 ? renderIssueCount(triggerProps) : renderAddDependency(triggerProps), isChanged && !isOptimizedMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kC16r.default), null) : null)), [
            getIssueLinksCount,
            isChanged,
            isOptimizedMode,
            onHoverChanged,
            renderAddDependency,
            renderIssueCount
        ]);
        const renderContent = (0, $5uXOq.useCallback)(({ update: update })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $0e194656c5030f7d$var$dialogStyles
            }, renderDialogContent && renderDialogContent(update), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9Tpd")).default), null)), [
            renderDialogContent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            isOpen: isOpen,
            onClose: onClose,
            trigger: renderTrigger,
            content: renderContent,
            placement: "bottom-start",
            shouldUseCaptureOnOutsideClick: true
        });
    };
    const $0e194656c5030f7d$var$dialogStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxWidth: '800px',
        maxHeight: '400px',
        paddingTop: 'space.200',
        paddingBottom: 'space.200',
        paddingLeft: 'space.300',
        paddingRight: 'space.300',
        boxSizing: 'border-box'
    });
    const $0e194656c5030f7d$var$iconContainerStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: '0',
        paddingBottom: '0',
        paddingLeft: 'space.100',
        paddingRight: 'space.100'
    });
    var $0e194656c5030f7d$export$2e2bcd8739ae039 = $0e194656c5030f7d$var$DependenciesCell;
});
parcelRegister("5vFXg", function(module, exports) {
    $parcel$export(module.exports, "container", ()=>$4030645a75252f13$export$34e0f9847d4c02dd, (v)=>$4030645a75252f13$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "issuesCount", ()=>$4030645a75252f13$export$9e11ad065927463a, (v)=>$4030645a75252f13$export$9e11ad065927463a = v);
    $parcel$export(module.exports, "issuesLabel", ()=>$4030645a75252f13$export$491cc3e43ef9a10c, (v)=>$4030645a75252f13$export$491cc3e43ef9a10c = v);
    var $4030645a75252f13$export$34e0f9847d4c02dd;
    var $4030645a75252f13$export$518824cf31321346;
    var $4030645a75252f13$export$9e11ad065927463a;
    var $4030645a75252f13$export$491cc3e43ef9a10c;
    $4030645a75252f13$export$34e0f9847d4c02dd = `_5Hr3oa_container`;
    $4030645a75252f13$export$518824cf31321346 = `_5Hr3oa_dialog`;
    $4030645a75252f13$export$9e11ad065927463a = `_5Hr3oa_issuesCount`;
    $4030645a75252f13$export$491cc3e43ef9a10c = `_5Hr3oa_issuesLabel`;
});
parcelRegister("dlAAz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2576ad46b11a51a3$export$2e2bcd8739ae039);
    var $bC2fB;
    var $iqzUb = parcelRequire("iqzUb");
    function $2576ad46b11a51a3$export$2e2bcd8739ae039(WrappedComponent) {
        return (0, (0, parcelRequire("bC2fB")).connect)((0, $iqzUb.default), {})(WrappedComponent);
    }
});
parcelRegister("iqzUb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c49824a70c8ce878$export$2e2bcd8739ae039);
    var $fpNDQ;
    var $1CGdp = parcelRequire("1CGdp");
    var $iIikD = parcelRequire("iIikD");
    var $ddv1K = parcelRequire("ddv1K");
    var $cGbfF = parcelRequire("cGbfF");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $gLTGb = parcelRequire("gLTGb");
    const $c49824a70c8ce878$var$externalIssueLinksList = [];
    const $c49824a70c8ce878$var$internalIssueLinksList = [];
    const $c49824a70c8ce878$var$internalOriginalIssueLinksList = [];
    const $c49824a70c8ce878$var$issueLinksList = [];
    const $c49824a70c8ce878$var$originalIssueLinksList = [];
    const $c49824a70c8ce878$var$mapStateToPropsNew = (state, { issue: issue })=>{
        const issueId = issue?.id || '';
        const externalIssueLinks = (0, $ddv1K.getExternalIncomingLinks)(state)[issueId] || $c49824a70c8ce878$var$externalIssueLinksList;
        const internalIssueLinks = (0, $ddv1K.getInternalIncomingLinks)(state)[issueId] || $c49824a70c8ce878$var$internalIssueLinksList;
        const internalOriginalIssueLinks = (0, $ddv1K.getInternalIncomingLinkOriginals)(state)[issueId] || $c49824a70c8ce878$var$internalOriginalIssueLinksList;
        const issueLinks = (0, $ddv1K.getIncomingLinks)(state)[issueId] || $c49824a70c8ce878$var$issueLinksList;
        const originalIssueLinks = (0, $ddv1K.getIncomingLinkOriginals)(state)[issueId] || $c49824a70c8ce878$var$originalIssueLinksList;
        const isChanged = (0, parcelRequire("fpNDQ")).default(issueLinks.map(({ itemKey: itemKey })=>itemKey), originalIssueLinks.map(({ itemKey: itemKey })=>itemKey)).length > 0;
        const mode = (0, $1CGdp.getMode)(state);
        return {
            externalIssueLinks: externalIssueLinks,
            isChanged: isChanged,
            isReadOnly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
            isOptimizedMode: mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771),
            internalIssueLinks: internalIssueLinks,
            internalOriginalIssueLinks: internalOriginalIssueLinks,
            filterValue: (0, $iIikD.getFilters)(state)[0, $cGbfF.DEPENDENCIES_FILTER_ID].value,
            messages: $gLTGb.default,
            direction: (0, $TTKUQ.ISSUE_LINK_DIRECTION).INWARD
        };
    };
    const $c49824a70c8ce878$var$mapStateToProps = $c49824a70c8ce878$var$mapStateToPropsNew;
    var $c49824a70c8ce878$export$2e2bcd8739ae039 = $c49824a70c8ce878$var$mapStateToProps;
});
parcelRegister("fpNDQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b38fb299940fe52b$export$2e2bcd8739ae039);
    var $c9RLn;
    var $kSwbB;
    var $cDeeP;
    var $b38fb299940fe52b$var$symmetricDifference = (0, (0, parcelRequire("c9RLn")).default)(function symmetricDifference(list1, list2) {
        return (0, (0, parcelRequire("kSwbB")).default)((0, (0, parcelRequire("cDeeP")).default)(list1, list2), (0, (0, parcelRequire("cDeeP")).default)(list2, list1));
    });
    var $b38fb299940fe52b$export$2e2bcd8739ae039 = $b38fb299940fe52b$var$symmetricDifference;
});
parcelRegister("gLTGb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$696ba1c49bb0658e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $696ba1c49bb0658e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies-cells.incoming-dependencies.issues",
            "defaultMessage": "{count, plural, one {# issue} other {# issues}}"
        },
        addDependency: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies-cells.incoming-dependencies.add-dependency",
            "defaultMessage": "+ Add dependency"
        }
    });
});
parcelRegister("5P3xt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c4f60651600c9f9$export$2e2bcd8739ae039);
    var $bC2fB;
    var $gNIgD = parcelRequire("gNIgD");
    function $1c4f60651600c9f9$export$2e2bcd8739ae039(WrappedComponent) {
        return (0, (0, parcelRequire("bC2fB")).connect)((0, $gNIgD.default), {})(WrappedComponent);
    }
});
parcelRegister("gNIgD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31f4387380926c7c$export$2e2bcd8739ae039);
    var $fpNDQ;
    var $1CGdp = parcelRequire("1CGdp");
    var $iIikD = parcelRequire("iIikD");
    var $ddv1K = parcelRequire("ddv1K");
    var $cGbfF = parcelRequire("cGbfF");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $4dYAc = parcelRequire("4dYAc");
    const $31f4387380926c7c$var$externalIssueLinksList = [];
    const $31f4387380926c7c$var$internalIssueLinksList = [];
    const $31f4387380926c7c$var$internalOriginalIssueLinksList = [];
    const $31f4387380926c7c$var$issueLinksList = [];
    const $31f4387380926c7c$var$originalIssueLinksList = [];
    const $31f4387380926c7c$var$mapStateToProps = (state, { issue: issue })=>{
        const issueId = issue?.id || '';
        const externalIssueLinks = (0, $ddv1K.getExternalOutgoingLinks)(state)[issueId] || $31f4387380926c7c$var$externalIssueLinksList;
        const internalIssueLinks = (0, $ddv1K.getInternalOutgoingLinks)(state)[issueId] || $31f4387380926c7c$var$internalIssueLinksList;
        const internalOriginalIssueLinks = (0, $ddv1K.getInternalOutgoingLinkOriginals)(state)[issueId] || $31f4387380926c7c$var$internalOriginalIssueLinksList;
        const issueLinks = (0, $ddv1K.getOutgoingLinks)(state)[issueId] || $31f4387380926c7c$var$issueLinksList;
        const originalIssueLinks = (0, $ddv1K.getOutgoingLinkOriginals)(state)[issueId] || $31f4387380926c7c$var$originalIssueLinksList;
        const isChanged = (0, parcelRequire("fpNDQ")).default(issueLinks.map(({ itemKey: itemKey })=>itemKey), originalIssueLinks.map(({ itemKey: itemKey })=>itemKey)).length > 0;
        const mode = (0, $1CGdp.getMode)(state);
        return {
            externalIssueLinks: externalIssueLinks,
            isChanged: isChanged,
            isReadOnly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
            isOptimizedMode: mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771),
            internalIssueLinks: internalIssueLinks,
            internalOriginalIssueLinks: internalOriginalIssueLinks,
            filterValue: (0, $iIikD.getFilters)(state)[0, $cGbfF.DEPENDENCIES_FILTER_ID].value,
            messages: $4dYAc.default,
            direction: (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD
        };
    };
    var $31f4387380926c7c$export$2e2bcd8739ae039 = $31f4387380926c7c$var$mapStateToProps;
});
parcelRegister("4dYAc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$397f297e8c9c9a8d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $397f297e8c9c9a8d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies-cells.outgoing-dependencies.issues",
            "defaultMessage": "{count, plural, one {# issue} other {# issues}}"
        },
        addDependency: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies-cells.outgoing-dependencies.add-dependency",
            "defaultMessage": "+ Add dependency"
        }
    });
});
parcelRegister("pop0c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79a1d0e7dbcb1f89$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7za40 = parcelRequire("7za40");
    var $a7Yvc = parcelRequire("a7Yvc");
    var $874L5 = parcelRequire("874L5");
    var $79a1d0e7dbcb1f89$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $a7Yvc.default), (0, $7za40.default))((0, $874L5.default));
});
parcelRegister("7za40", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$77c9177a3450fb18$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $ekXoi = parcelRequire("ekXoi");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $77c9177a3450fb18$var$dispatchMethods = (dispatch)=>({
            updateEstimate: (estimate, planningUnit, issueId, workingHours)=>{
                const propName = planningUnit === (0, $TTKUQ.PlanningUnits).storyPoints ? 'storyPoints' : 'timeEstimate';
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issueId,
                    [propName]: estimate && (0, $ekXoi.convertEstimate)(planningUnit, estimate, workingHours)
                }));
            }
        });
    var $77c9177a3450fb18$export$2e2bcd8739ae039 = $77c9177a3450fb18$var$dispatchMethods;
});
parcelRegister("a7Yvc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b95506dc7578239$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    var $4sJY8 = parcelRequire("4sJY8");
    var $jpgxP = parcelRequire("jpgxP");
    var $kWDpn = parcelRequire("kWDpn");
    var $4nDwW = parcelRequire("4nDwW");
    const $8b95506dc7578239$var$querySelector = (state, props)=>({
            plan: (0, $bHTqr.getPlan)(state),
            estimateRollUpForIssue: (0, $4nDwW.isDefined)((0, $4sJY8.getRollupMap)(state)[props.issue.id]) ? (0, $4sJY8.getRollupMap)(state)[props.issue.id].estimate : null,
            showEstimateRollup: (0, $kWDpn.getShowRolledUpOthers)(state),
            workingHours: (0, $jpgxP.getJiraHoursPerDay)(state)
        });
    var $8b95506dc7578239$export$2e2bcd8739ae039 = $8b95506dc7578239$var$querySelector;
});
parcelRegister("874L5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$04ef9e7dc1c3b411$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lV634;
    var $3bDjY;
    var $koVbs;
    var $ekXoi = parcelRequire("ekXoi");
    var $ixSW4 = parcelRequire("ixSW4");
    var $90ldD = parcelRequire("90ldD");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $3FQWJ = parcelRequire("3FQWJ");
    var $gJlUc = parcelRequire("gJlUc");
    var $8DT2i = parcelRequire("8DT2i");
    var $6MtMh = parcelRequire("6MtMh");
    const $04ef9e7dc1c3b411$var$round = (number)=>Math.round(number * 1000) / 1000;
    const $04ef9e7dc1c3b411$export$943451e6e6e964be = ({ updateEstimate: updateEstimate, planningUnit: planningUnit, issue: issue, workingHours: workingHours })=>(value)=>{
            let numberValue = null;
            if (typeof value === 'number') numberValue = value;
            else if (typeof value === 'string') numberValue = parseFloat(value);
            updateEstimate(Number.isNaN(numberValue) || !Number.isFinite(numberValue) ? null : numberValue, planningUnit, issue.id, workingHours);
        };
    const $04ef9e7dc1c3b411$export$4a24036355e3202b = ({ estimateRollUpForIssue: estimateRollUpForIssue, plan: { planningUnit: planningUnit }, workingHours: workingHours, issue: issue, isScrolling: isScrolling, showOptimizations: showOptimizations, isReadOnly: isReadOnly = false, updateEstimate: updateEstimate, showEstimateRollup: showEstimateRollup, TextField: TextField })=>{
        const inputElement = (0, $5uXOq.useRef)(null);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [inEditMode, setInEditMode] = (0, $5uXOq.useState)(false);
        const handleClickOutside = (event)=>{
            const current = inputElement.current;
            if (current && !current.contains(event.target)) current.blur();
        };
        (0, $5uXOq.useEffect)(()=>{
            window.addEventListener('click', handleClickOutside);
            return ()=>window.removeEventListener('click', handleClickOutside);
        }, []);
        const estimateText = (()=>{
            if (!(0, $ekXoi.isEstimated)(planningUnit, issue)) return '';
            const estimateValue = (0, $ekXoi.getEstimateValue)(planningUnit, issue, workingHours);
            return $04ef9e7dc1c3b411$var$round(estimateValue).toString();
        })();
        const getPlanningUnit = ()=>planningUnit === (0, $TTKUQ.PlanningUnits).storyPoints ? 'storyPoints' : 'timeEstimate';
        const update = $04ef9e7dc1c3b411$export$943451e6e6e964be({
            updateEstimate: updateEstimate,
            planningUnit: planningUnit,
            issue: issue,
            workingHours: workingHours
        });
        const shouldShowRollup = ()=>{
            if (!estimateRollUpForIssue && planningUnit === (0, $TTKUQ.PlanningUnits).storyPoints) return false;
            return showEstimateRollup && !inEditMode && !(0, parcelRequire("lV634")).default(estimateRollUpForIssue);
        };
        const handleClickOnRollup = ()=>{
            setInEditMode(true);
            if (inputElement.current) inputElement.current.focus();
        };
        const getCellContent = (estimateText, issueSummary)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $6MtMh.container
            }, shouldShowRollup() && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $6MtMh.rollUp,
                key: "rollup",
                onClick: handleClickOnRollup,
                onKeyDown: handleClickOnRollup,
                role: "button",
                tabIndex: 0
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $90ldD.default), {
                label: ""
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $6MtMh.rollupValue
            }, (0, $ekXoi.getEstimateRollupValue)(estimateRollUpForIssue, planningUnit, workingHours))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: `${$6MtMh.estimate} ${isReadOnly ? $6MtMh.readOnly : ''}`,
                ref: inputElement
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(TextField, {
                appearance: "subtle",
                isAlignRight: true,
                isReadOnly: isReadOnly,
                isTransparentBackground: true,
                min: 0,
                onBlur: ()=>{
                    setInEditMode(false);
                },
                onDone: update,
                onFocus: ()=>{
                    setInEditMode(true);
                },
                step: "any",
                type: "number",
                value: estimateText,
                "aria-label": formatMessage((0, $8DT2i.default).estimateCellLabel, {
                    issue: issueSummary
                })
            })));
        const attribute = getPlanningUnit();
        const issueEstimateTooltipText = estimateText ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $8DT2i.default).issueEstimateTooltip), estimateText) : '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
            attribute: attribute,
            issue: issue,
            isScrolling: isScrolling,
            showOptimizations: !!showOptimizations
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: shouldShowRollup() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, issueEstimateTooltipText, formatMessage((0, $gJlUc.default).rolledUpEstimateToolip, {
                value: (0, $ekXoi.getEstimateRollupValue)(estimateRollUpForIssue, planningUnit, workingHours)
            })) : null
        }, getCellContent(estimateText, issue.summary)));
    };
    var $04ef9e7dc1c3b411$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        TextField: (0, $ixSW4.slots).CellTextField
    })($04ef9e7dc1c3b411$export$4a24036355e3202b);
});
parcelRegister("8DT2i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7250199fca146825$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7250199fca146825$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueEstimateTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.estimate.issue-estimate-tooltip",
            "defaultMessage": "Estimate of this issue: "
        },
        estimateCellLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.estimate.estimate-cell-label",
            "defaultMessage": "Enter an estimate for issue {issue}"
        }
    });
});
parcelRegister("6MtMh", function(module, exports) {
    $parcel$export(module.exports, "container", ()=>$4efe52fecbd81b31$export$34e0f9847d4c02dd, (v)=>$4efe52fecbd81b31$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "estimate", ()=>$4efe52fecbd81b31$export$9f3a0795ca2cc944, (v)=>$4efe52fecbd81b31$export$9f3a0795ca2cc944 = v);
    $parcel$export(module.exports, "readOnly", ()=>$4efe52fecbd81b31$export$b2cbc93d4da94977, (v)=>$4efe52fecbd81b31$export$b2cbc93d4da94977 = v);
    $parcel$export(module.exports, "rollUp", ()=>$4efe52fecbd81b31$export$e495e138161077ba, (v)=>$4efe52fecbd81b31$export$e495e138161077ba = v);
    $parcel$export(module.exports, "rollupValue", ()=>$4efe52fecbd81b31$export$409b770e9b28d1a3, (v)=>$4efe52fecbd81b31$export$409b770e9b28d1a3 = v);
    var $4efe52fecbd81b31$export$34e0f9847d4c02dd;
    var $4efe52fecbd81b31$export$9f3a0795ca2cc944;
    var $4efe52fecbd81b31$export$b2cbc93d4da94977;
    var $4efe52fecbd81b31$export$e495e138161077ba;
    var $4efe52fecbd81b31$export$409b770e9b28d1a3;
    $4efe52fecbd81b31$export$34e0f9847d4c02dd = `w3jkUG_container`;
    $4efe52fecbd81b31$export$9f3a0795ca2cc944 = `w3jkUG_estimate`;
    $4efe52fecbd81b31$export$b2cbc93d4da94977 = `w3jkUG_readOnly`;
    $4efe52fecbd81b31$export$e495e138161077ba = `w3jkUG_rollUp`;
    $4efe52fecbd81b31$export$409b770e9b28d1a3 = `w3jkUG_rollupValue`;
});
parcelRegister("iw7xI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$169f1aa251e5eb32$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bC2fB;
    var $3zlrN = parcelRequire("3zlrN");
    var $6G5lJ = parcelRequire("6G5lJ");
    const $169f1aa251e5eb32$var$GoalCell = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $3zlrN.AllAtlasGoals), props);
    var $169f1aa251e5eb32$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $6G5lJ.default))($169f1aa251e5eb32$var$GoalCell);
});
parcelRegister("3zlrN", function(module, exports) {
    $parcel$export(module.exports, "AllAtlasGoals", ()=>$96067ec2a963e04d$export$f0602cb4d11ab613);
    var $bC2fB;
    var $6Tmjp = parcelRequire("6Tmjp");
    var $f6kXh = parcelRequire("f6kXh");
    var $5ujDc = parcelRequire("5ujDc");
    const $96067ec2a963e04d$export$f0602cb4d11ab613 = (0, (0, parcelRequire("bC2fB")).connect)((0, $f6kXh.default), (0, $6Tmjp.default))((0, $5ujDc.default));
});
parcelRegister("6Tmjp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82d96fc45813d77b$export$2e2bcd8739ae039);
    var $10aT8 = parcelRequire("10aT8");
    const $82d96fc45813d77b$var$mapDispatchToProps = {
        resetGoals: $10aT8.resetGoals,
        searchGoals: $10aT8.searchGoals
    };
    var $82d96fc45813d77b$export$2e2bcd8739ae039 = $82d96fc45813d77b$var$mapDispatchToProps;
});
parcelRegister("10aT8", function(module, exports) {
    $parcel$export(module.exports, "fetchGoals", ()=>$33f8159eb92119a2$export$6c36c0f8ea6d36ae);
    $parcel$export(module.exports, "searchGoals", ()=>$33f8159eb92119a2$export$af9ad9c51420a7a2);
    $parcel$export(module.exports, "resetGoals", ()=>$33f8159eb92119a2$export$f075a20637a1037e);
    $parcel$export(module.exports, "default", ()=>$33f8159eb92119a2$export$2e2bcd8739ae039);
    var $k8IPx = parcelRequire("k8IPx");
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $96USE = parcelRequire("96USE");
    var $7CxJ7 = parcelRequire("7CxJ7");
    var $bZA5o = parcelRequire("bZA5o");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpgxP = parcelRequire("jpgxP");
    var $fI3Hm = parcelRequire("fI3Hm");
    var $3jjep = parcelRequire("3jjep");
    var $6eSIs = parcelRequire("6eSIs");
    var $bkasS = parcelRequire("bkasS");
    var $i4zj5 = parcelRequire("i4zj5");
    var $9URof = parcelRequire("9URof");
    const $33f8159eb92119a2$export$2b2ca3127f968210 = 'command.issue-goals.FETCH_GOALS';
    const $33f8159eb92119a2$export$9633c21fb57481ad = 'command.issue-goals.SEARCH_GOALS';
    const $33f8159eb92119a2$export$d445e5506e78e43b = 'command.issue-goals.RESET_GOALS';
    const $33f8159eb92119a2$export$6c36c0f8ea6d36ae = (goalARIs)=>({
            type: $33f8159eb92119a2$export$2b2ca3127f968210,
            payload: goalARIs
        });
    const $33f8159eb92119a2$export$af9ad9c51420a7a2 = (payload)=>({
            type: $33f8159eb92119a2$export$9633c21fb57481ad,
            payload: payload
        });
    const $33f8159eb92119a2$export$f075a20637a1037e = (payload)=>({
            type: $33f8159eb92119a2$export$d445e5506e78e43b,
            payload: payload
        });
    function* $33f8159eb92119a2$export$1bea7d894b9f16bd({ payload: { issueId: issueId, goals: goals } }) {
        const { id: planId, currentScenarioId: scenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const body = {
            itemKeys: [
                issueId
            ],
            planId: planId,
            scenarioId: scenarioId,
            description: {
                goals: {
                    reset: true
                }
            }
        };
        const resetStatusResponse = yield (0, $aNOuE.call)((0, $bkasS.doResetIssueRequest), body);
        if (resetStatusResponse?.ok) {
            yield (0, $aNOuE.put)((0, $96USE.update)({
                id: issueId,
                goals: goals
            }));
            yield (0, $aNOuE.put)((0, $7CxJ7.revertFields)({
                id: issueId,
                fields: [
                    'goals'
                ]
            }));
        }
    }
    function* $33f8159eb92119a2$export$ba026b6eba3f8185({ payload: goalARIs }) {
        const isAtlasConnectInstalled = yield (0, $aNOuE.select)((0, $jpgxP.isAtlasConnectInstalled));
        const lazyGoals = yield (0, $aNOuE.select)((0, $bZA5o.getLazyGoalsByARI));
        const existingGoalARIs = Object.keys(lazyGoals);
        const newGoalARIs = (0, ($parcel$interopDefault($k8IPx)))(goalARIs, existingGoalARIs);
        if (isAtlasConnectInstalled && newGoalARIs.length > 0) {
            yield (0, $aNOuE.put)((0, $3jjep.fetchGoalsStart)((0, $9URof.createLazyGoals)(newGoalARIs)));
            const { lazyGoalsByARI: lazyGoalsByARI, isError: isError } = yield (0, $aNOuE.call)((0, $i4zj5.fetchGoalsByARI), newGoalARIs);
            if (!isError) yield (0, $aNOuE.put)((0, $3jjep.fetchGoalsSuccess)(lazyGoalsByARI));
            else {
                yield (0, $aNOuE.put)((0, $3jjep.fetchGoalsFail)({
                    ...(0, $9URof.createLazyGoals)(newGoalARIs, false),
                    ...lazyGoalsByARI
                }));
                yield (0, $aNOuE.put)((0, $fI3Hm.addFlag)({
                    key: (0, $9e169ee721864a4b$export$f21a7cfcdb7aed8e)
                }));
            }
        }
    }
    function* $33f8159eb92119a2$export$6185f47fc71454ac({ payload: query }) {
        yield (0, $aNOuE.put)((0, $3jjep.searchGoalsStart)());
        const cloudId = yield (0, $aNOuE.call)((0, $6eSIs.getCloudId));
        try {
            const { lazyGoalsByARI: lazyGoalsByARI } = yield (0, $aNOuE.call)((0, $i4zj5.searchGoalsByName), query, cloudId);
            yield (0, $aNOuE.put)((0, $3jjep.searchGoalsSuccess)(lazyGoalsByARI));
        } catch (e) {
            yield (0, $aNOuE.put)((0, $3jjep.searchGoalsFail)());
            yield (0, $aNOuE.put)((0, $fI3Hm.addFlag)({
                key: (0, $9e169ee721864a4b$export$f21a7cfcdb7aed8e)
            }));
        }
    }
    function* $33f8159eb92119a2$export$d520389497e43f1e() {
        yield (0, $6u3NN.takeEvery)($33f8159eb92119a2$export$2b2ca3127f968210, $33f8159eb92119a2$export$ba026b6eba3f8185);
    }
    function* $33f8159eb92119a2$export$865fa4357ff1cc35() {
        yield (0, $6u3NN.takeEvery)($33f8159eb92119a2$export$9633c21fb57481ad, $33f8159eb92119a2$export$6185f47fc71454ac);
    }
    function* $33f8159eb92119a2$export$e292a8e40cc92767() {
        yield (0, $6u3NN.takeEvery)($33f8159eb92119a2$export$d445e5506e78e43b, $33f8159eb92119a2$export$1bea7d894b9f16bd);
    }
    function* $33f8159eb92119a2$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($33f8159eb92119a2$export$d520389497e43f1e);
        yield (0, $aNOuE.fork)($33f8159eb92119a2$export$865fa4357ff1cc35);
        yield (0, $aNOuE.fork)($33f8159eb92119a2$export$e292a8e40cc92767);
    }
});
parcelRegister("3jjep", function(module, exports) {
    $parcel$export(module.exports, "FETCH_GOALS_START", ()=>$ca96b9af3b9a55ea$export$11c1a5952856ecff);
    $parcel$export(module.exports, "FETCH_GOALS_SUCCESS", ()=>$ca96b9af3b9a55ea$export$2fe1bf518aa52d7d);
    $parcel$export(module.exports, "FETCH_GOALS_FAIL", ()=>$ca96b9af3b9a55ea$export$b29b48883831f053);
    $parcel$export(module.exports, "SEARCH_GOALS_START", ()=>$ca96b9af3b9a55ea$export$498813d7dcdbf046);
    $parcel$export(module.exports, "SEARCH_GOALS_SUCCESS", ()=>$ca96b9af3b9a55ea$export$c8d78da0028bb5be);
    $parcel$export(module.exports, "SEARCH_GOALS_FAIL", ()=>$ca96b9af3b9a55ea$export$69cda31235dd0647);
    $parcel$export(module.exports, "fetchGoalsStart", ()=>$ca96b9af3b9a55ea$export$d45b44e3629e16ba);
    $parcel$export(module.exports, "fetchGoalsSuccess", ()=>$ca96b9af3b9a55ea$export$4a01790803734c22);
    $parcel$export(module.exports, "fetchGoalsFail", ()=>$ca96b9af3b9a55ea$export$ae470ddf41dbcfc8);
    $parcel$export(module.exports, "searchGoalsStart", ()=>$ca96b9af3b9a55ea$export$3322ae8a249162b4);
    $parcel$export(module.exports, "searchGoalsSuccess", ()=>$ca96b9af3b9a55ea$export$d31aa898f6e071e1);
    $parcel$export(module.exports, "searchGoalsFail", ()=>$ca96b9af3b9a55ea$export$d24c84a12e32be40);
    const $ca96b9af3b9a55ea$export$11c1a5952856ecff = 'state.domain.issue-goals.FETCH_GOALS_START';
    const $ca96b9af3b9a55ea$export$2fe1bf518aa52d7d = 'state.domain.issue-goals.FETCH_GOALS_SUCCESS';
    const $ca96b9af3b9a55ea$export$b29b48883831f053 = 'state.domain.issue-goals.FETCH_GOALS_FAIL';
    const $ca96b9af3b9a55ea$export$498813d7dcdbf046 = 'state.domain.issue-goals.SEARCH_GOALS_START';
    const $ca96b9af3b9a55ea$export$c8d78da0028bb5be = 'state.domain.issue-goals.SEARCH_GOALS_SUCCESS';
    const $ca96b9af3b9a55ea$export$69cda31235dd0647 = 'state.domain.issue-goals.SEARCH_GOALS_FAIL';
    const $ca96b9af3b9a55ea$export$d45b44e3629e16ba = (payload)=>({
            type: $ca96b9af3b9a55ea$export$11c1a5952856ecff,
            payload: payload
        });
    const $ca96b9af3b9a55ea$export$4a01790803734c22 = (payload)=>({
            type: $ca96b9af3b9a55ea$export$2fe1bf518aa52d7d,
            payload: payload
        });
    const $ca96b9af3b9a55ea$export$ae470ddf41dbcfc8 = (payload)=>({
            type: $ca96b9af3b9a55ea$export$b29b48883831f053,
            payload: payload
        });
    const $ca96b9af3b9a55ea$export$3322ae8a249162b4 = ()=>({
            type: $ca96b9af3b9a55ea$export$498813d7dcdbf046
        });
    const $ca96b9af3b9a55ea$export$d31aa898f6e071e1 = (payload)=>({
            type: $ca96b9af3b9a55ea$export$c8d78da0028bb5be,
            payload: payload
        });
    const $ca96b9af3b9a55ea$export$d24c84a12e32be40 = ()=>({
            type: $ca96b9af3b9a55ea$export$69cda31235dd0647
        });
});
parcelRegister("6eSIs", function(module, exports) {
    $parcel$export(module.exports, "getCloudId", ()=>$9ee5a20b75659e2e$export$fdd2c0ba94025c3c);
    var $8QpSo;
    var $j8DrX;
    const $9ee5a20b75659e2e$export$fdd2c0ba94025c3c = (0, (0, parcelRequire("8QpSo")).default)(()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-cloud-id'));
});
parcelRegister("i4zj5", function(module, exports) {
    $parcel$export(module.exports, "fetchGoalsByARI", ()=>$c6f92f1f22eab190$export$99c828a9ced380c2);
    $parcel$export(module.exports, "searchGoalsByName", ()=>$c6f92f1f22eab190$export$ca6432afef400c6b);
    var $8Uumt = parcelRequire("8Uumt");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $jJZqs;
    var $5yJb9;
    var $5a0Nh;
    var $fpFqH;
    var $c35UJ;
    var $5Wobd;
    var $lAwKe = parcelRequire("lAwKe");
    const $c6f92f1f22eab190$var$analyticKey = 'jira.frontend.fe.jpo.fetch-goals';
    const $c6f92f1f22eab190$var$performanceMarkPrefix = 'jpo-fetch-goals';
    const $c6f92f1f22eab190$var$operationName = (0, (0, parcelRequire("c35UJ")).default).params.name;
    const $c6f92f1f22eab190$var$goalsQueryByAriOperationName = (0, (0, parcelRequire("fpFqH")).default).params.name;
    const $c6f92f1f22eab190$var$sloThreshold = 1000;
    const $c6f92f1f22eab190$var$maxPage = 10;
    const $c6f92f1f22eab190$var$lastPerformanceMarkIndexes = [
        0
    ];
    const $c6f92f1f22eab190$var$extractNodesFromQuery = (data)=>(data.townsquare.goalTql?.edges ?? []).filter((edge)=>Boolean(edge)).map(({ node: node })=>node);
    const $c6f92f1f22eab190$var$extractNodes = (data)=>(data.townsquare.goalsByAri ?? []).filter((goal)=>Boolean(goal));
    const $c6f92f1f22eab190$var$getErrorsAndStopCapture = (errorCollector, graphQLOperationName)=>{
        const relevantErrors = (0, $lAwKe.getGraphQLErrorsForOperation)(errorCollector, graphQLOperationName ?? $c6f92f1f22eab190$var$operationName);
        const isError = relevantErrors.length > 0;
        const isPermissionError = isError && relevantErrors.some((relevantError)=>relevantError?.extensions?.statusCode === 403);
        return {
            isError: isError,
            isPermissionError: isPermissionError,
            cause: relevantErrors[0]?.message ?? '',
            statusCode: relevantErrors[0]?.extensions?.statusCode
        };
    };
    const $c6f92f1f22eab190$var$getNextPageCursor = (data, pageCount)=>{
        if (data.townsquare.goalTql?.pageInfo.hasNextPage && pageCount < $c6f92f1f22eab190$var$maxPage) return data.townsquare.goalTql?.pageInfo.endCursor ?? '';
        return '';
    };
    const $c6f92f1f22eab190$var$getTraceIdAndStopCapture = (operationName)=>{
        const traceIds = (0, (0, parcelRequire("5Wobd")).getTraceIds)(operationName);
        const traceId = traceIds.length > 0 ? traceIds[traceIds.length - 1] : '';
        (0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)(operationName);
        return traceId;
    };
    const $c6f92f1f22eab190$var$measureAndClearPerformance = (pageCount, markIndex)=>{
        const performanceMark = `${$c6f92f1f22eab190$var$performanceMarkPrefix}-${pageCount}`;
        const { duration: duration } = performance.measure(`${performanceMark}-measure`, performanceMark);
        if (markIndex === $c6f92f1f22eab190$var$lastPerformanceMarkIndexes[pageCount - 1]) performance.clearMarks(performanceMark);
        return duration;
    };
    const $c6f92f1f22eab190$var$cleanUpPerformanceAndLog = (statusCode, cause, pageCount, group, markIndex, traceId)=>{
        (0, $lAwKe.sendOperationalEvent)({
            analyticKey: $c6f92f1f22eab190$var$analyticKey,
            statusCode: statusCode,
            cause: cause,
            duration: $c6f92f1f22eab190$var$measureAndClearPerformance(pageCount, markIndex),
            sloThreshold: $c6f92f1f22eab190$var$sloThreshold,
            pages: pageCount,
            group: group,
            traceId: traceId
        });
    };
    const $c6f92f1f22eab190$var$cleanUpAndLog = (operationName, statusCode, cause, pageCount, group, markIndex)=>{
        $c6f92f1f22eab190$var$cleanUpPerformanceAndLog(statusCode, cause, pageCount, group, markIndex, $c6f92f1f22eab190$var$getTraceIdAndStopCapture(operationName));
    };
    const $c6f92f1f22eab190$export$eac3c00f6901185c = (goalARIs, chunkSize, maxChunks)=>{
        const createFetchGoalsPromise = (goalARIChunk, pageCount)=>new Promise((resolve, reject)=>{
                const performanceMark = `${$c6f92f1f22eab190$var$performanceMarkPrefix}-${pageCount}`;
                performance.mark(performanceMark);
                $c6f92f1f22eab190$var$lastPerformanceMarkIndexes[pageCount - 1] += 1;
                const currentMarkIndex = $c6f92f1f22eab190$var$lastPerformanceMarkIndexes[pageCount - 1];
                const errorCollector = (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)();
                (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("fpFqH")).default), {
                    goalARIs: goalARIChunk
                }).toPromise().then((data)=>{
                    const { isError: isError, isPermissionError: isPermissionError, cause: cause, statusCode: statusCode } = $c6f92f1f22eab190$var$getErrorsAndStopCapture(errorCollector, $c6f92f1f22eab190$var$goalsQueryByAriOperationName);
                    const traceIds = (0, (0, parcelRequire("5Wobd")).getTraceIds)($c6f92f1f22eab190$var$goalsQueryByAriOperationName);
                    const traceId = traceIds.length > 0 ? traceIds[traceIds.length - 1] : undefined;
                    if (!isError && data?.townsquare.goalsByAri) {
                        $c6f92f1f22eab190$var$cleanUpPerformanceAndLog(200, '', pageCount, 'nogroup', currentMarkIndex, traceId);
                        const goalNodes = $c6f92f1f22eab190$var$extractNodes(data);
                        resolve(goalNodes);
                    } else if (isPermissionError) {
                        $c6f92f1f22eab190$var$cleanUpPerformanceAndLog(403, '', pageCount, 'nogroup', currentMarkIndex, traceId);
                        reject(new (0, (0, parcelRequire("jJZqs")).ValidationError)('Permission', [], 403));
                    } else {
                        $c6f92f1f22eab190$var$cleanUpPerformanceAndLog(statusCode, cause, 1, 'nogroup', currentMarkIndex, traceId);
                        reject(new (0, (0, parcelRequire("jJZqs")).ValidationError)(cause ?? 'Error fetching goals', [], statusCode));
                    }
                }).catch((error)=>{
                    const { statusCode: statusCode, cause: cause } = (0, $lAwKe.getErrorDetails)(error);
                    const traceId = (0, (0, parcelRequire("5Wobd")).getTraceIds)($c6f92f1f22eab190$var$goalsQueryByAriOperationName)[pageCount - 1];
                    $c6f92f1f22eab190$var$cleanUpPerformanceAndLog(statusCode, cause, pageCount, 'nogroup', currentMarkIndex, traceId);
                    reject(error);
                });
            });
        const goalARIChunks = [];
        const maxSize = chunkSize * maxChunks;
        for(let i = 0; i < goalARIs.length && i < maxSize; i += chunkSize)goalARIChunks.push(goalARIs.slice(i, i + chunkSize));
        while($c6f92f1f22eab190$var$lastPerformanceMarkIndexes.length < goalARIChunks.length)$c6f92f1f22eab190$var$lastPerformanceMarkIndexes.push(0);
        (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)($c6f92f1f22eab190$var$goalsQueryByAriOperationName);
        return Promise.allSettled(goalARIChunks.map((chunk, i)=>createFetchGoalsPromise(chunk, i + 1))).finally(()=>(0, (0, parcelRequire("5Wobd")).stopCapturingTraceIds)($c6f92f1f22eab190$var$goalsQueryByAriOperationName));
    };
    const $c6f92f1f22eab190$export$c256767c147d1afa = (query, cloudId, pageCursor = null, pageCount = 1, group = (0, ($parcel$interopDefault($7Jxgt))).v4())=>{
        performance.mark(`${$c6f92f1f22eab190$var$performanceMarkPrefix}-${pageCount}`);
        $c6f92f1f22eab190$var$lastPerformanceMarkIndexes[pageCount - 1] += 1;
        const currentMarkIndex = $c6f92f1f22eab190$var$lastPerformanceMarkIndexes[pageCount - 1];
        (0, (0, parcelRequire("5Wobd")).startCapturingTraceIds)($c6f92f1f22eab190$var$operationName);
        const errorCollector = (0, (0, parcelRequire("5a0Nh")).startCaptureGraphQlErrors)();
        return new Promise((resolve, reject)=>{
            (0, $8Uumt.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("c35UJ")).default), {
                query: query,
                cloudId: cloudId,
                pageCursor: pageCursor
            }).toPromise().then((data)=>{
                const { isError: isError, isPermissionError: isPermissionError, cause: cause, statusCode: statusCode } = $c6f92f1f22eab190$var$getErrorsAndStopCapture(errorCollector);
                if (!isError && data?.townsquare.goalTql) {
                    $c6f92f1f22eab190$var$cleanUpAndLog($c6f92f1f22eab190$var$operationName, 200, '', pageCount, group, currentMarkIndex);
                    const goalNodes = $c6f92f1f22eab190$var$extractNodesFromQuery(data);
                    const nextPageCursor = $c6f92f1f22eab190$var$getNextPageCursor(data, pageCount);
                    if (nextPageCursor) {
                        $c6f92f1f22eab190$var$lastPerformanceMarkIndexes.push(0);
                        return $c6f92f1f22eab190$export$c256767c147d1afa(query, cloudId, nextPageCursor, pageCount + 1, group).then((nextPageNodes)=>{
                            resolve(goalNodes.concat(nextPageNodes));
                        }).catch((error)=>{
                            reject(error);
                        });
                    }
                    resolve(goalNodes);
                } else if (isPermissionError) {
                    $c6f92f1f22eab190$var$cleanUpAndLog($c6f92f1f22eab190$var$operationName, 403, '', pageCount, group, currentMarkIndex);
                    reject(new (0, (0, parcelRequire("jJZqs")).ValidationError)('Permission', [], 403));
                } else {
                    $c6f92f1f22eab190$var$cleanUpAndLog($c6f92f1f22eab190$var$operationName, statusCode, cause, pageCount, group, currentMarkIndex);
                    reject(new (0, (0, parcelRequire("jJZqs")).ValidationError)(cause ?? 'Error fetching goals', [], statusCode));
                }
            }).catch((error)=>{
                const { statusCode: statusCode, cause: cause } = (0, $lAwKe.getErrorDetails)(error);
                $c6f92f1f22eab190$var$cleanUpAndLog($c6f92f1f22eab190$var$operationName, statusCode, cause, pageCount, group, currentMarkIndex);
                reject(error);
            });
        });
    };
    const $c6f92f1f22eab190$export$2bad26f5d4979c25 = ({ id: id, key: key, name: name, state: state, url: url })=>({
            id: id,
            key: key,
            name: name,
            url: url,
            state: {
                ...state,
                score: state.score ?? undefined
            }
        });
    const $c6f92f1f22eab190$export$a1788b5620c73e29 = (goalPromises)=>{
        const isError = goalPromises.some((goalPromise)=>goalPromise.status === 'rejected' && goalPromise.reason instanceof Error && goalPromise.reason.message !== 'Permission');
        const goals = goalPromises.filter((promise)=>promise.status === 'fulfilled').flatMap((promise)=>promise.value).map($c6f92f1f22eab190$export$2bad26f5d4979c25);
        const lazyGoalsByARI = Object.fromEntries(goals.map((goal)=>[
                goal.id,
                {
                    isLoading: false,
                    goal: goal
                }
            ]));
        return {
            lazyGoalsByARI: lazyGoalsByARI,
            isError: isError
        };
    };
    const $c6f92f1f22eab190$export$e958634924031a10 = (nodes)=>{
        const goals = nodes.map($c6f92f1f22eab190$export$2bad26f5d4979c25);
        const lazyGoalsByARI = Object.fromEntries(goals.map((goal)=>[
                goal.id,
                {
                    isLoading: false,
                    goal: goal
                }
            ]));
        return {
            lazyGoalsByARI: lazyGoalsByARI
        };
    };
    const $c6f92f1f22eab190$export$99c828a9ced380c2 = (sourceARIs, chunkSize = 200, maxChunks = 10)=>$c6f92f1f22eab190$export$eac3c00f6901185c(sourceARIs, chunkSize, maxChunks).then($c6f92f1f22eab190$export$a1788b5620c73e29);
    const $c6f92f1f22eab190$export$ca6432afef400c6b = (searchString, cloudId)=>{
        const query = `name like "${searchString}"`;
        return $c6f92f1f22eab190$export$c256767c147d1afa(query, cloudId).then($c6f92f1f22eab190$export$e958634924031a10);
    };
});
parcelRegister("fpFqH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92d7471e62de80ec$export$2e2bcd8739ae039);
    const $92d7471e62de80ec$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "goalARIs"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "aris",
                "variableName": "goalARIs"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "key"
        }, v3 = {
            "kind": "ScalarField",
            "name": "name"
        }, v4 = {
            "kind": "ScalarField",
            "name": "url"
        }, v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = {
            "kind": "ScalarField",
            "name": "label"
        }, v7 = {
            "kind": "ScalarField",
            "name": "score"
        }, v8 = {
            "kind": "ScalarField",
            "name": "value"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "fetchAtlasGoalsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "TownsquareQueryApi",
                            "kind": "LinkedField",
                            "name": "townsquare",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "goalsByAri",
                                    "plural": true,
                                    "selections": [
                                        v2,
                                        v3,
                                        {
                                            "kind": "RequiredField",
                                            "field": v4,
                                            "action": "THROW",
                                            "path": "townsquare.goalsByAri.url"
                                        },
                                        v5,
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "TownsquareGoalState",
                                                "kind": "LinkedField",
                                                "name": "state",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v6,
                                                        "action": "THROW",
                                                        "path": "townsquare.goalsByAri.state.label"
                                                    },
                                                    v7,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v8,
                                                        "action": "THROW",
                                                        "path": "townsquare.goalsByAri.state.value"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "townsquare.goalsByAri.state"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "townsquare"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "fetchAtlasGoalsQuery",
                "selections": [
                    {
                        "concreteType": "TownsquareQueryApi",
                        "kind": "LinkedField",
                        "name": "townsquare",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "goalsByAri",
                                "plural": true,
                                "selections": [
                                    v2,
                                    v3,
                                    v4,
                                    v5,
                                    {
                                        "concreteType": "TownsquareGoalState",
                                        "kind": "LinkedField",
                                        "name": "state",
                                        "plural": false,
                                        "selections": [
                                            v6,
                                            v7,
                                            v8
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "fda43bbb082e0ed3c0d8f3aa102808422464ab3ae968c9859862796e65b5f452",
                "metadata": {},
                "name": "fetchAtlasGoalsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $92d7471e62de80ec$var$node.hash = "fad199abf7afe37c2713cb9a5c0b89ed";
    var $92d7471e62de80ec$export$2e2bcd8739ae039 = $92d7471e62de80ec$var$node;
});
parcelRegister("c35UJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e9a6bfe57227bec$export$2e2bcd8739ae039);
    const $1e9a6bfe57227bec$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageCursor"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        }, v3 = [
            {
                "kind": "Variable",
                "name": "after",
                "variableName": "pageCursor"
            },
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "q",
                "variableName": "query"
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "key"
        }, v5 = {
            "kind": "ScalarField",
            "name": "name"
        }, v6 = {
            "kind": "ScalarField",
            "name": "url"
        }, v7 = {
            "kind": "ScalarField",
            "name": "id"
        }, v8 = {
            "kind": "ScalarField",
            "name": "label"
        }, v9 = {
            "kind": "ScalarField",
            "name": "score"
        }, v10 = {
            "kind": "ScalarField",
            "name": "value"
        }, v11 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "searchAtlasGoalsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "TownsquareQueryApi",
                            "kind": "LinkedField",
                            "name": "townsquare",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3,
                                    "concreteType": "TownsquareGoalConnection",
                                    "kind": "LinkedField",
                                    "name": "goalTql",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "TownsquareGoalEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "TownsquareGoal",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4,
                                                                v5,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v6,
                                                                    "action": "THROW",
                                                                    "path": "townsquare.goalTql.edges.node.url"
                                                                },
                                                                v7,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "TownsquareGoalState",
                                                                        "kind": "LinkedField",
                                                                        "name": "state",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v8,
                                                                                "action": "THROW",
                                                                                "path": "townsquare.goalTql.edges.node.state.label"
                                                                            },
                                                                            v9,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v10,
                                                                                "action": "THROW",
                                                                                "path": "townsquare.goalTql.edges.node.state.value"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "townsquare.goalTql.edges.node.state"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "townsquare.goalTql.edges.node"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "townsquare.goalTql.edges"
                                        },
                                        v11
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "townsquare"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v0,
                    v1
                ],
                "kind": "Operation",
                "name": "searchAtlasGoalsQuery",
                "selections": [
                    {
                        "concreteType": "TownsquareQueryApi",
                        "kind": "LinkedField",
                        "name": "townsquare",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "goalTql",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareGoalEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareGoal",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v5,
                                                    v6,
                                                    v7,
                                                    {
                                                        "concreteType": "TownsquareGoalState",
                                                        "kind": "LinkedField",
                                                        "name": "state",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            v9,
                                                            v10
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v11
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "6fc42a8a59d9e005570fb33ce75889e4d19ff53c1b749ca765baebfde4b0f8a6",
                "metadata": {},
                "name": "searchAtlasGoalsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $1e9a6bfe57227bec$var$node.hash = "7972153b35561bfbcfc8d8ca931a2d4f";
    var $1e9a6bfe57227bec$export$2e2bcd8739ae039 = $1e9a6bfe57227bec$var$node;
});
parcelRegister("lAwKe", function(module, exports) {
    $parcel$export(module.exports, "getGraphQLErrorsForOperation", ()=>$c8f86162a6ab9c71$export$1ae618599d319ba5);
    $parcel$export(module.exports, "getErrorDetails", ()=>$c8f86162a6ab9c71$export$33e83b6fee5d732d);
    $parcel$export(module.exports, "sendOperationalEvent", ()=>$c8f86162a6ab9c71$export$e5f89b51c6d4e36b);
    var $jJZqs;
    var $fjcgS;
    var $5a0Nh;
    const $c8f86162a6ab9c71$export$1ae618599d319ba5 = (errorCollector, operationName)=>{
        const errorsWithMeta = (0, (0, parcelRequire("5a0Nh")).stopCaptureGraphQlErrors)(errorCollector);
        if (Array.isArray(errorsWithMeta)) return errorsWithMeta.filter((errorWithMeta)=>errorWithMeta.meta.operationName === operationName).flatMap((errorWithMeta)=>errorWithMeta.errors);
        return [];
    };
    const $c8f86162a6ab9c71$export$33e83b6fee5d732d = (error)=>{
        if (error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError) || error instanceof (0, (0, parcelRequire("jJZqs")).default)) return {
            cause: error.message ?? 'An unknown error has occurred.',
            statusCode: error.statusCode,
            traceId: error.traceId
        };
        if (error instanceof DOMException && error.name === 'AbortError') return {
            cause: 'Query was aborted.',
            statusCode: 0
        };
        if (error instanceof SyntaxError) return {
            cause: 'Query response payload was invalid and could not be parsed.',
            statusCode: 500
        };
        return {
            cause: 'An unknown error has occurred.',
            statusCode: undefined
        };
    };
    const $c8f86162a6ab9c71$export$e5f89b51c6d4e36b = ({ analyticKey: analyticKey, traceId: traceId, statusCode: statusCode, cause: cause, duration: duration, sloThreshold: sloThreshold, pages: pages, group: group })=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return;
            let statusCodeFamily = 'unknown';
            const statusCodeString = `${statusCode}`;
            if (statusCode === 0 || statusCode === 429) statusCodeFamily = statusCodeString;
            else if (statusCodeString.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeString[0]}xx`;
            analyticsClient.sendOperationalEvent({
                action: 'fetch',
                actionSubject: 'relay operation',
                attributes: {
                    key: analyticKey,
                    traceId: traceId,
                    statusCode: statusCode,
                    statusCodeFamily: statusCodeFamily,
                    cause: cause,
                    duration: duration,
                    slo: duration <= sloThreshold,
                    sloThreshold: sloThreshold,
                    frontendVersion: window.BUILD_KEY,
                    pages: pages,
                    group: group
                },
                source: 'relayOperation'
            });
        });
    };
});
parcelRegister("9URof", function(module, exports) {
    $parcel$export(module.exports, "createLazyGoals", ()=>$d7c918e2b56ec1c0$export$daa6cad20ef1d9ef);
    const $d7c918e2b56ec1c0$export$daa6cad20ef1d9ef = (goalARIs, isLoading = true)=>Object.fromEntries(goalARIs.map((goalARI)=>[
                goalARI,
                {
                    isLoading: isLoading,
                    goal: undefined
                }
            ]));
});
parcelRegister("f6kXh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$481270c822a5fa53$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $bZA5o = parcelRequire("bZA5o");
    var $jpgxP = parcelRequire("jpgxP");
    const $481270c822a5fa53$var$mapStateToProps = (state)=>({
            isExportMode: (0, $1CGdp.isExportMode)(state),
            hasAtlasPermissions: (0, $jpgxP.getHasAtlasPermissions)(state),
            lazyGoalsByARI: (0, $bZA5o.getLazyGoalsByARI)(state),
            searchesInProgress: (0, $bZA5o.getGoalSearchesInProgress)(state),
            allLazyGoals: (0, $bZA5o.getAllLazyGoals)(state)
        });
    var $481270c822a5fa53$export$2e2bcd8739ae039 = $481270c822a5fa53$var$mapStateToProps;
});
parcelRegister("5ujDc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8ad4d294b666014$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k8IPx = parcelRequire("k8IPx");
    var $gccSB = parcelRequire("gccSB");
    var $ajpes = parcelRequire("ajpes");
    var $dC5iT;
    var $6s1PB;
    var $4R6GH;
    var $c12LJ;
    var $hwwla;
    var $cb04i;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $jUy0x = parcelRequire("jUy0x");
    const $f8ad4d294b666014$var$calculateFlexShrink = (lazyGoals)=>{
        const goalNameLengths = lazyGoals.map((lazyGoal)=>lazyGoal.goal === undefined ? 0 : lazyGoal.goal.name.length);
        const shrinkCoefficient = 0.2;
        return goalNameLengths.map((length)=>Math.pow(length, shrinkCoefficient));
    };
    const $f8ad4d294b666014$var$AllAtlasGoals = (0, $5uXOq.memo)(({ hasAtlasPermissions: hasAtlasPermissions, isScrolling: isScrolling = false, issue: issue, onChange: onChangeApiUpdate, isExportMode: isExportMode, lazyGoalsByARI: lazyGoalsByARI, resetGoals: resetGoals, ...props })=>{
        const goals = (0, $5uXOq.useMemo)(()=>issue.goals ?? [], [
            issue
        ]);
        const lazyGoals = (0, $5uXOq.useMemo)(()=>goals.map((goalARI)=>lazyGoalsByARI[goalARI]).filter((lazyGoal)=>lazyGoal !== undefined), [
            goals,
            lazyGoalsByARI
        ]);
        const currentGoals = issue.goals;
        const originalGoals = issue.originals?.goals;
        const [wasChanged, setWasChanged] = (0, $5uXOq.useState)(false);
        const hasBeenChanged = originalGoals && !(0, ($parcel$interopDefault($gccSB)))((0, ($parcel$interopDefault($k8IPx)))(currentGoals, originalGoals)) || currentGoals && !(0, ($parcel$interopDefault($gccSB)))((0, ($parcel$interopDefault($k8IPx)))(originalGoals, currentGoals));
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('plans_goals_revert_changes_on_reset')) return;
            if (!hasBeenChanged && wasChanged) resetGoals({
                issueId: issue.id,
                goals: currentGoals || []
            });
            setWasChanged(hasBeenChanged);
        }, [
            hasBeenChanged,
            resetGoals,
            issue.id,
            currentGoals,
            wasChanged
        ]);
        if (lazyGoals.some(({ isLoading: isLoading })=>isLoading)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cb04i")).CellSkeleton), {
            width: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM
        });
        const filteredLazyGoals = lazyGoals.filter((lazyGoal)=>lazyGoal.goal !== undefined);
        const canEditGoals = hasAtlasPermissions && ((0, (0, parcelRequire("6s1PB")).expVal)('native_goals_on_issue_view', 'isGoalsFieldEnabled', false) || issue.level > (0, (0, parcelRequire("c12LJ")).STORY_LEVEL));
        if (isScrolling) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwwla")).default), null);
        const flexShrinkValues = $f8ad4d294b666014$var$calculateFlexShrink(lazyGoals);
        const onChange = (scopedIssue, scopedGoals)=>{
            if (!(0, ($parcel$interopDefault($ajpes)))(filteredLazyGoals, scopedGoals)) onChangeApiUpdate(scopedIssue, scopedGoals);
        };
        if (canEditGoals) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jUy0x.default), {
            ...props,
            isCellDirty: ()=>hasBeenChanged,
            issue: issue,
            onChange: onChange,
            flexShrinkValues: flexShrinkValues,
            lazyGoals: filteredLazyGoals,
            isExportMode: isExportMode,
            goals: lazyGoals
        }));
        return null;
    });
    var $f8ad4d294b666014$export$2e2bcd8739ae039 = $f8ad4d294b666014$var$AllAtlasGoals;
});
parcelRegister("cb04i", function(module, exports) {
    $parcel$export(module.exports, "CellSkeleton", ()=>$303b35176894bb97$export$17bd75bd7c43e72);
    var $5uXOq = parcelRequire("5uXOq");
    var $jnD30;
    var $7KnaJ;
    const $303b35176894bb97$export$17bd75bd7c43e72 = ({ width: width, height: height = (0, (0, parcelRequire("7KnaJ")).RECT_ROW_HEIGHT) })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnD30")).default), {
            width: `${width}px`,
            height: `${height}px`,
            ...(0, (0, parcelRequire("7KnaJ")).DEFAULT_CONTENT_LOADER_PROPS)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
            width: width,
            height: height
        }));
});
parcelRegister("jnD30", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1be744f2781cfbd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e1be744f2781cfbd$var$__assign = function() {
        $e1be744f2781cfbd$var$__assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $e1be744f2781cfbd$var$__assign.apply(this, arguments);
    };
    function $e1be744f2781cfbd$var$__rest(s, e) {
        var t = {};
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function") {
            for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
        }
        return t;
    }
    var $e1be744f2781cfbd$var$uid = function() {
        return Math.random().toString(36).substring(2);
    };
    var $e1be744f2781cfbd$var$Svg = function(_a) {
        var rtl = _a.rtl, speed = _a.speed, interval = _a.interval, style = _a.style, width = _a.width, height = _a.height, baseUrl = _a.baseUrl, gradientRatio = _a.gradientRatio, animate = _a.animate, ariaLabel = _a.ariaLabel, children = _a.children, className = _a.className, uniquekey = _a.uniquekey, primaryColor = _a.primaryColor, primaryOpacity = _a.primaryOpacity, secondaryColor = _a.secondaryColor, secondaryOpacity = _a.secondaryOpacity, preserveAspectRatio = _a.preserveAspectRatio, props = $e1be744f2781cfbd$var$__rest(_a, [
            "rtl",
            "speed",
            "interval",
            "style",
            "width",
            "height",
            "baseUrl",
            "gradientRatio",
            "animate",
            "ariaLabel",
            "children",
            "className",
            "uniquekey",
            "primaryColor",
            "primaryOpacity",
            "secondaryColor",
            "secondaryOpacity",
            "preserveAspectRatio"
        ]);
        var idClip = uniquekey ? uniquekey + "-idClip" : $e1be744f2781cfbd$var$uid();
        var idGradient = uniquekey ? uniquekey + "-idGradient" : $e1be744f2781cfbd$var$uid();
        var rtlStyle = rtl ? {
            transform: 'scaleX(-1)'
        } : {};
        var keyTimes = "0; " + interval + "; 1";
        var dur = speed + "s";
        return (0, $5uXOq.createElement)("svg", $e1be744f2781cfbd$var$__assign({
            role: "img",
            style: $e1be744f2781cfbd$var$__assign($e1be744f2781cfbd$var$__assign({}, style), rtlStyle),
            className: className,
            "aria-label": ariaLabel ? ariaLabel : null,
            viewBox: "0 0 " + width + " " + height,
            preserveAspectRatio: preserveAspectRatio
        }, props), ariaLabel ? (0, $5uXOq.createElement)("title", null, ariaLabel) : null, (0, $5uXOq.createElement)("rect", {
            x: "0",
            y: "0",
            width: width,
            height: height,
            clipPath: "url(" + baseUrl + "#" + idClip + ")",
            style: {
                fill: "url(" + baseUrl + "#" + idGradient + ")"
            }
        }), (0, $5uXOq.createElement)("defs", null, (0, $5uXOq.createElement)("clipPath", {
            id: idClip
        }, children), (0, $5uXOq.createElement)("linearGradient", {
            id: idGradient
        }, (0, $5uXOq.createElement)("stop", {
            offset: "0%",
            stopColor: primaryColor,
            stopOpacity: primaryOpacity
        }, animate && (0, $5uXOq.createElement)("animate", {
            attributeName: "offset",
            values: -gradientRatio + "; " + -gradientRatio + "; 1",
            keyTimes: keyTimes,
            dur: dur,
            repeatCount: "indefinite"
        })), (0, $5uXOq.createElement)("stop", {
            offset: "50%",
            stopColor: secondaryColor,
            stopOpacity: secondaryOpacity
        }, animate && (0, $5uXOq.createElement)("animate", {
            attributeName: "offset",
            values: -gradientRatio / 2 + "; " + -gradientRatio / 2 + "; " + (1 + gradientRatio / 2),
            keyTimes: keyTimes,
            dur: dur,
            repeatCount: "indefinite"
        })), (0, $5uXOq.createElement)("stop", {
            offset: "100%",
            stopColor: primaryColor,
            stopOpacity: primaryOpacity
        }, animate && (0, $5uXOq.createElement)("animate", {
            attributeName: "offset",
            values: "0; 0; " + (1 + gradientRatio),
            keyTimes: keyTimes,
            dur: dur,
            repeatCount: "indefinite"
        })))));
    };
    var $e1be744f2781cfbd$var$defaultProps = {
        animate: true,
        ariaLabel: 'Loading interface...',
        baseUrl: '',
        gradientRatio: 2,
        height: 130,
        interval: 0.25,
        preserveAspectRatio: 'none',
        primaryColor: '#f0f0f0',
        primaryOpacity: 1,
        rtl: false,
        secondaryColor: '#e0e0e0',
        secondaryOpacity: 1,
        speed: 2,
        style: {},
        width: 400
    };
    var $e1be744f2781cfbd$var$InitialComponent = function(props) {
        return (0, $5uXOq.createElement)("rect", {
            x: "0",
            y: "0",
            rx: "5",
            ry: "5",
            width: props.width,
            height: props.height
        });
    };
    var $e1be744f2781cfbd$var$ContentLoader = function(props) {
        var mergedProps = $e1be744f2781cfbd$var$__assign($e1be744f2781cfbd$var$__assign({}, $e1be744f2781cfbd$var$defaultProps), props);
        return (0, $5uXOq.createElement)($e1be744f2781cfbd$var$Svg, $e1be744f2781cfbd$var$__assign({}, mergedProps), props.children || (0, $5uXOq.createElement)($e1be744f2781cfbd$var$InitialComponent, $e1be744f2781cfbd$var$__assign({}, mergedProps)));
    };
    var $e1be744f2781cfbd$export$a4f57375e50e81d5 = function(props) {
        return (0, $5uXOq.createElement)($e1be744f2781cfbd$var$ContentLoader, $e1be744f2781cfbd$var$__assign({}, props), (0, $5uXOq.createElement)("rect", {
            x: "70",
            y: "15",
            rx: "4",
            ry: "4",
            width: "117",
            height: "6.4"
        }), (0, $5uXOq.createElement)("rect", {
            x: "70",
            y: "35",
            rx: "3",
            ry: "3",
            width: "85",
            height: "6.4"
        }), (0, $5uXOq.createElement)("rect", {
            x: "0",
            y: "80",
            rx: "3",
            ry: "3",
            width: "350",
            height: "6.4"
        }), (0, $5uXOq.createElement)("rect", {
            x: "0",
            y: "100",
            rx: "3",
            ry: "3",
            width: "380",
            height: "6.4"
        }), (0, $5uXOq.createElement)("rect", {
            x: "0",
            y: "120",
            rx: "3",
            ry: "3",
            width: "201",
            height: "6.4"
        }), (0, $5uXOq.createElement)("circle", {
            cx: "30",
            cy: "30",
            r: "30"
        }));
    };
    var $e1be744f2781cfbd$export$6afe72be63c708bc = function(props) {
        return (0, $5uXOq.createElement)($e1be744f2781cfbd$var$ContentLoader, $e1be744f2781cfbd$var$__assign({}, props, {
            height: 480
        }), (0, $5uXOq.createElement)("circle", {
            cx: "30",
            cy: "30",
            r: "30"
        }), (0, $5uXOq.createElement)("rect", {
            x: "75",
            y: "13",
            rx: "4",
            ry: "4",
            width: "100",
            height: "13"
        }), (0, $5uXOq.createElement)("rect", {
            x: "75",
            y: "37",
            rx: "4",
            ry: "4",
            width: "50",
            height: "8"
        }), (0, $5uXOq.createElement)("rect", {
            x: "0",
            y: "70",
            rx: "5",
            ry: "5",
            width: "400",
            height: "400"
        }));
    };
    var $e1be744f2781cfbd$export$52f0f02147b12c03 = function(props) {
        return (0, $5uXOq.createElement)($e1be744f2781cfbd$var$ContentLoader, $e1be744f2781cfbd$var$__assign({}, props), (0, $5uXOq.createElement)("rect", {
            x: "0",
            y: "0",
            rx: "3",
            ry: "3",
            width: "70",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "80",
            y: "0",
            rx: "3",
            ry: "3",
            width: "100",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "190",
            y: "0",
            rx: "3",
            ry: "3",
            width: "10",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "15",
            y: "20",
            rx: "3",
            ry: "3",
            width: "130",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "155",
            y: "20",
            rx: "3",
            ry: "3",
            width: "130",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "15",
            y: "40",
            rx: "3",
            ry: "3",
            width: "90",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "115",
            y: "40",
            rx: "3",
            ry: "3",
            width: "60",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "185",
            y: "40",
            rx: "3",
            ry: "3",
            width: "60",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "0",
            y: "60",
            rx: "3",
            ry: "3",
            width: "30",
            height: "10"
        }));
    };
    var $e1be744f2781cfbd$export$54c2e3dc7acea9f5 = function(props) {
        return (0, $5uXOq.createElement)($e1be744f2781cfbd$var$ContentLoader, $e1be744f2781cfbd$var$__assign({}, props), (0, $5uXOq.createElement)("rect", {
            x: "0",
            y: "0",
            rx: "3",
            ry: "3",
            width: "250",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "20",
            y: "20",
            rx: "3",
            ry: "3",
            width: "220",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "20",
            y: "40",
            rx: "3",
            ry: "3",
            width: "170",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "0",
            y: "60",
            rx: "3",
            ry: "3",
            width: "250",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "20",
            y: "80",
            rx: "3",
            ry: "3",
            width: "200",
            height: "10"
        }), (0, $5uXOq.createElement)("rect", {
            x: "20",
            y: "100",
            rx: "3",
            ry: "3",
            width: "80",
            height: "10"
        }));
    };
    var $e1be744f2781cfbd$export$546f606c73d35982 = function(props) {
        return (0, $5uXOq.createElement)($e1be744f2781cfbd$var$ContentLoader, $e1be744f2781cfbd$var$__assign({}, props), (0, $5uXOq.createElement)("circle", {
            cx: "10",
            cy: "20",
            r: "8"
        }), (0, $5uXOq.createElement)("rect", {
            x: "25",
            y: "15",
            rx: "5",
            ry: "5",
            width: "220",
            height: "10"
        }), (0, $5uXOq.createElement)("circle", {
            cx: "10",
            cy: "50",
            r: "8"
        }), (0, $5uXOq.createElement)("rect", {
            x: "25",
            y: "45",
            rx: "5",
            ry: "5",
            width: "220",
            height: "10"
        }), (0, $5uXOq.createElement)("circle", {
            cx: "10",
            cy: "80",
            r: "8"
        }), (0, $5uXOq.createElement)("rect", {
            x: "25",
            y: "75",
            rx: "5",
            ry: "5",
            width: "220",
            height: "10"
        }), (0, $5uXOq.createElement)("circle", {
            cx: "10",
            cy: "110",
            r: "8"
        }), (0, $5uXOq.createElement)("rect", {
            x: "25",
            y: "105",
            rx: "5",
            ry: "5",
            width: "220",
            height: "10"
        }));
    };
    var $e1be744f2781cfbd$export$2e2bcd8739ae039 = $e1be744f2781cfbd$var$ContentLoader;
});
parcelRegister("7KnaJ", function(module, exports) {
    $parcel$export(module.exports, "RECT_BORDER_RADIUS", ()=>$f9a891836e19928c$export$6e8110f49ab45b16);
    $parcel$export(module.exports, "RECT_ROW_HEIGHT", ()=>$f9a891836e19928c$export$edd1e89b478b8de3);
    $parcel$export(module.exports, "DEFAULT_CONTENT_LOADER_PROPS", ()=>$f9a891836e19928c$export$a04fe6b687553e9b);
    const $f9a891836e19928c$var$BORDER_RADIUS = 2;
    const $f9a891836e19928c$export$6e8110f49ab45b16 = {
        rx: `${$f9a891836e19928c$var$BORDER_RADIUS}`,
        ry: `${$f9a891836e19928c$var$BORDER_RADIUS}`
    };
    const $f9a891836e19928c$export$edd1e89b478b8de3 = 28;
    const $f9a891836e19928c$var$CONTENT_LOADER_COLORS = {
        primaryColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N30})`,
        secondaryColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$exports).N20})`
    };
    const $f9a891836e19928c$var$CONTENT_LOADER_ANIMATION_SPEED = 1;
    const $f9a891836e19928c$export$a04fe6b687553e9b = {
        ...$f9a891836e19928c$var$CONTENT_LOADER_COLORS,
        speed: $f9a891836e19928c$var$CONTENT_LOADER_ANIMATION_SPEED
    };
});
parcelRegister("jUy0x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7958655f14b0ca70$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $gERmC = parcelRequire("gERmC");
    var $gccSB = parcelRequire("gccSB");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $eZJjh;
    var $koVbs;
    var $bChGW;
    var $3FQWJ = parcelRequire("3FQWJ");
    var $ixSW4 = parcelRequire("ixSW4");
    var $gMjXf;
    var $dVxof;
    var $cSDJf = parcelRequire("cSDJf");
    var $jdUkc = parcelRequire("jdUkc");
    var $8w6iz = parcelRequire("8w6iz");
    const $7958655f14b0ca70$var$MultiValueRemove = (props)=>{
        const innerProps = {
            ...props.innerProps,
            'aria-label': `Remove ${props.data.goal?.name ?? 'goal'}`
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, {
            ...props,
            innerProps: innerProps
        });
    };
    const $7958655f14b0ca70$var$Control = (props)=>{
        const { selectProps: { menuIsOpen: menuIsOpen, value: value, onMenuOpen: onMenuOpen, renderMultipleGoals: renderMultipleGoals } } = props;
        const isDefaultControl = menuIsOpen || (0, ($parcel$interopDefault($gccSB)))(value);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Control, {
            ...props,
            isFocused: menuIsOpen
        }, isDefaultControl && props.children, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "button",
            tabIndex: 0,
            onClick: onMenuOpen,
            onKeyDown: (0, ($parcel$interopDefault($8Rkzz))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1yt4h8dc _80omtlke _1bsb1osq _vchhusvi _6ndb11dc",
                menuIsOpen && "_1e0cglyw"
            ])
        }, renderMultipleGoals({
            onMenuOpen: onMenuOpen
        })));
    };
    function $7958655f14b0ca70$export$a46eb59c704d783({ lazyGoals: lazyGoals, onChange: onChange, issue: issue, flexShrinkValues: flexShrinkValues, isDisabled: isDisabled, FieldSelect: FieldSelect, isReadOnly: isReadOnly, isCellDirty: isCellDirty, isExportMode: isExportMode, searchesInProgress: searchesInProgress, goals: goals, allLazyGoals: allLazyGoals, searchGoals: searchGoals }) {
        const [query, setQuery] = (0, $5uXOq.useState)('');
        const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)(goals);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const searchLazyGoalsByARI = allLazyGoals.filter((lazyGoal)=>lazyGoal.goal?.name.toLowerCase().includes(query));
        const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (!menuIsOpen) setSelectedOptions(lazyGoals);
        }, [
            menuIsOpen,
            lazyGoals
        ]);
        const getOptions = (0, $5uXOq.useCallback)(async (query)=>{
            const trimmedQuery = query.trim().toLowerCase();
            setQuery(trimmedQuery);
            if (!(0, ($parcel$interopDefault($gccSB)))(trimmedQuery)) searchGoals(trimmedQuery);
        }, [
            searchGoals
        ]);
        const debounceGetOptions = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(getOptions, 250), [
            getOptions
        ]);
        const handleInputChange = (value, { action: action })=>{
            if (action === 'input-change') debounceGetOptions(value);
        };
        const handleMenuOpen = ()=>{
            setMenuIsOpen(true);
        };
        const handleMenuClose = ()=>{
            setMenuIsOpen(false);
            onChange(issue, selectedOptions);
        };
        const onItemChanged = (options)=>{
            const selectedOptions = Array.isArray(options) ? options : [];
            setSelectedOptions(selectedOptions);
            setQuery('');
        };
        const renderMultipleGoals = (0, $5uXOq.useCallback)(({ onMenuOpen: onMenuOpen })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, selectedOptions.map((lazyGoal, index)=>{
                if (lazyGoal.goal === undefined) return null;
                const { goal: goal } = lazyGoal;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVxof")).GoalHoverCard), {
                    goal: goal,
                    flexShrink: flexShrinkValues[index],
                    key: goal.key,
                    onClick: onMenuOpen,
                    isExportMode: isExportMode
                });
            })), [
            flexShrinkValues,
            isExportMode,
            selectedOptions
        ]);
        const filterOptions = ()=>(0, ($parcel$interopDefault($gERmC)))(allLazyGoals, selectedOptions, (goal)=>goal.goal?.id);
        const getFieldSelect = ()=>isDisabled || isReadOnly ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_11ow1osq _1u6fh8dc"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1tke1ylp _1bsb1osq _1e0c1txw _4cvr1h6o"
                ])
            }, lazyGoals.length > 0 && renderMultipleGoals({
                onMenuOpen: (0, ($parcel$interopDefault($8Rkzz)))
            }))) : (0, ($parcel$interopDefault($5uXOq))).createElement(FieldSelect, {
                isMulti: true,
                isLoading: searchesInProgress > 0 && query.length > 0,
                value: selectedOptions,
                options: searchLazyGoalsByARI,
                formatOptionLabel: (option)=>{
                    if (option.goal) {
                        const { goal: { key: key, name: name, state: { value: value, label: label } = {
                            value: (0, (0, parcelRequire("gMjXf")).GoalStateValues).CANCELLED,
                            label: 'Cancelled'
                        } } } = option;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                            key: key,
                            xcss: $7958655f14b0ca70$var$outerWrapperStyles
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                            space: "space.050",
                            alignBlock: "center",
                            alignInline: "start",
                            xcss: $7958655f14b0ca70$var$goalSelectStyles
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVxof")).BasicGoal), {
                            name: name,
                            value: value,
                            label: label,
                            isExportMode: isExportMode
                        }))));
                    }
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
                },
                onMenuOpen: handleMenuOpen,
                onMenuClose: handleMenuClose,
                onChange: onItemChanged,
                closeMenuOnSelect: false,
                styles: (0, $8w6iz.selectStyles),
                onInputChange: handleInputChange,
                minSelectWidth: (0, $cSDJf.MIN_SELECT_WIDTH),
                placeholder: formatMessage((0, $jdUkc.default).chooseGoal),
                noOptionsMessage: ()=>formatMessage((0, $jdUkc.default).noMatch),
                renderMultipleGoals: renderMultipleGoals,
                issueId: issue.id,
                components: {
                    Control: $7958655f14b0ca70$var$Control,
                    MultiValueRemove: $7958655f14b0ca70$var$MultiValueRemove,
                    LoadingIndicator: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                            size: "small"
                        })
                },
                getOptionLabel: (goal)=>goal.goal?.name,
                getOptionValue: (goal)=>goal.goal?.key,
                filterOption: filterOptions
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
            attribute: "goal",
            issue: issue,
            isScrolling: false,
            isCellDirty: isCellDirty
        }, getFieldSelect());
    }
    const $7958655f14b0ca70$var$goalSelectStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '30px',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    });
    const $7958655f14b0ca70$var$outerWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline',
        minWidth: '38px'
    });
    const $7958655f14b0ca70$var$itemsWrapperStyles = null;
    const $7958655f14b0ca70$var$labelsContainerStyles = null;
    const $7958655f14b0ca70$var$componentContainerStyles = null;
    const $7958655f14b0ca70$var$hiddenContainerStyles = null;
    var $7958655f14b0ca70$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        FieldSelect: (0, $ixSW4.slots).FieldSelect
    })($7958655f14b0ca70$export$a46eb59c704d783);
});
parcelRegister("gERmC", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $ekcP3 = parcelRequire("ekcP3");
    var $bxDef = parcelRequire("bxDef");
    var $g7i7g = parcelRequire("g7i7g");
    var $f3SOL = parcelRequire("f3SOL");
    var $hYfgW = parcelRequire("hYfgW");
    var $c209c6b79c5021c7$var$differenceBy = $g7i7g(function(array, values) {
        var iteratee = $hYfgW(values);
        if ($f3SOL(iteratee)) iteratee = undefined;
        return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true), $bxDef(iteratee, 2)) : [];
    });
    module.exports = $c209c6b79c5021c7$var$differenceBy;
});
parcelRegister("gMjXf", function(module, exports) {
    $parcel$export(module.exports, "GoalStateValues", ()=>$dfdf064faff3a785$export$a05d2a8ae30caf55);
    const $dfdf064faff3a785$export$c936349447a77fe0 = 'archived';
    const $dfdf064faff3a785$export$2163138c803bb209 = 'at_risk';
    const $dfdf064faff3a785$export$6b4658081fcf1aed = 'cancelled';
    const $dfdf064faff3a785$export$71efb3495f6084f2 = 'done';
    const $dfdf064faff3a785$export$fbc51d7b148a92b2 = 'off_track';
    const $dfdf064faff3a785$export$2e8f909ef398bdf4 = 'on_track';
    const $dfdf064faff3a785$export$3ad39751a33c16b8 = 'paused';
    const $dfdf064faff3a785$export$aebb42912407fb2d = 'pending';
    const $dfdf064faff3a785$var$FUTURE_ADDED_VALUE = '%future added value';
    const $dfdf064faff3a785$export$a05d2a8ae30caf55 = {
        ARCHIVED: $dfdf064faff3a785$export$c936349447a77fe0,
        AT_RISK: $dfdf064faff3a785$export$2163138c803bb209,
        CANCELLED: $dfdf064faff3a785$export$6b4658081fcf1aed,
        DONE: $dfdf064faff3a785$export$71efb3495f6084f2,
        OFF_TRACK: $dfdf064faff3a785$export$fbc51d7b148a92b2,
        ON_TRACK: $dfdf064faff3a785$export$2e8f909ef398bdf4,
        PAUSED: $dfdf064faff3a785$export$3ad39751a33c16b8,
        PENDING: $dfdf064faff3a785$export$aebb42912407fb2d
    };
});
parcelRegister("dVxof", function(module, exports) {
    $parcel$export(module.exports, "Goal", ()=>$13d7f5ad9391a94a$export$462e530a9b3886e4);
    $parcel$export(module.exports, "BasicGoal", ()=>$13d7f5ad9391a94a$export$2fc34cb0ccc82804);
    $parcel$export(module.exports, "GoalHoverCard", ()=>$13d7f5ad9391a94a$export$ef57e3709451ec90);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $dn5wJ;
    var $hHEfn;
    var $gMjXf;
    var $6yf6t;
    var $2Ywmz;
    var $3uePO;
    const $13d7f5ad9391a94a$export$462e530a9b3886e4 = ({ name: name, state: { value: value, label: label, score: score } = {
        value: (0, (0, parcelRequire("gMjXf")).GoalStateValues).CANCELLED,
        label: 'Cancelled'
    }, isExportMode: isExportMode })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $13d7f5ad9391a94a$var$goalStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($13d7f5ad9391a94a$export$2fc34cb0ccc82804, {
            name: name,
            value: value,
            isExportMode: isExportMode
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uePO")).GoalTracker), {
            value: value,
            label: label,
            score: score
        }));
    const $13d7f5ad9391a94a$export$2fc34cb0ccc82804 = ({ name: name, value: value, label: label, isExportMode: isExportMode })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Ywmz")).GoalIcon), {
            state: value,
            ariaLabel: label ? (0, (0, parcelRequire("6yf6t")).extractStatusLabelWithoutScore)(label) : undefined
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: !isExportMode ? $13d7f5ad9391a94a$var$goalNameStyles : $13d7f5ad9391a94a$var$exportGoalNameStyles
        }, name));
    const $13d7f5ad9391a94a$export$ef57e3709451ec90 = ({ goal: goal, flexShrink: flexShrink, onClick: onClick, isExportMode: isExportMode })=>{
        const { key: key, name: name, state: state, url: url } = goal;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            key: key,
            xcss: $13d7f5ad9391a94a$var$outerWrapperStyles,
            style: {
                flexShrink: flexShrink
            }
        }, url !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hHEfn")).StandaloneHoverCard), {
            url: url ?? '',
            actionOptions: {
                hide: false,
                exclude: [
                    (0, (0, parcelRequire("dn5wJ")).CardAction).ChangeStatusAction
                ]
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $13d7f5ad9391a94a$var$innerWrapperStyles,
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($13d7f5ad9391a94a$export$462e530a9b3886e4, {
            name: name,
            state: state,
            isExportMode: isExportMode
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $13d7f5ad9391a94a$var$innerWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($13d7f5ad9391a94a$export$462e530a9b3886e4, {
            name: name,
            state: state,
            isExportMode: isExportMode
        }))));
    };
    const $13d7f5ad9391a94a$var$outerWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline',
        minWidth: '38px'
    });
    const $13d7f5ad9391a94a$var$innerWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderWidth: 'border.width',
        borderStyle: 'solid',
        borderColor: 'color.border',
        borderRadius: 'border.radius',
        backgroundColor: 'elevation.surface',
        height: '32px',
        marginLeft: 'space.025',
        marginRight: 'space.025'
    });
    const $13d7f5ad9391a94a$var$goalStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '30px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        padding: 'space.050'
    });
    const $13d7f5ad9391a94a$var$goalNameStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    });
    const $13d7f5ad9391a94a$var$exportGoalNameStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        textOverflow: 'clip',
        overflow: 'hidden'
    });
});
parcelRegister("dn5wJ", function(module, exports) {
    $parcel$export(module.exports, "CardAction", ()=>$b402a0f22139e437$export$f40b7e0b762b928b);
    var $b402a0f22139e437$export$f40b7e0b762b928b;
    (function(CardAction) {
        CardAction["DownloadAction"] = "DownloadAction";
        CardAction["PreviewAction"] = "PreviewAction";
        CardAction["ViewAction"] = "ViewAction";
        CardAction["ChangeStatusAction"] = "ChangeStatusAction";
        CardAction["FollowAction"] = "FollowAction";
        CardAction["CopyLinkAction"] = "CopyLinkAction";
        CardAction["AISummaryAction"] = "AISummaryAction";
        CardAction["AutomationAction"] = "AutomationAction";
    })($b402a0f22139e437$export$f40b7e0b762b928b || ($b402a0f22139e437$export$f40b7e0b762b928b = {}));
});
parcelRegister("hHEfn", function(module, exports) {
    $parcel$export(module.exports, "HoverCard", ()=>$2eeb1383fcc12911$export$57a077cc9fbe653e);
    $parcel$export(module.exports, "StandaloneHoverCard", ()=>$2eeb1383fcc12911$export$f1f63acbe6ed8fb0);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $f4cXA;
    var $gKZoD;
    var $cb25w;
    var $8dVIb;
    var $kXQmf;
    var $7HAq8;
    var $kySOC;
    const $2eeb1383fcc12911$var$HoverCardWithErrorBoundary = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("kySOC")).HoverCardComponent));
        const { url: url, id: id, children: children } = props;
        const analytics = (0, (0, parcelRequire("kXQmf")).useSmartLinkAnalytics)(url, id);
        const onError = (0, $5uXOq.useCallback)((error, info)=>{
            analytics.ui.renderFailedEvent({
                display: (0, (0, parcelRequire("8dVIb")).CardDisplay).HoverCardPreview,
                id: id,
                error: error,
                errorInfo: info
            });
        }, [
            analytics.ui,
            id
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            fallback: children,
            onError: onError
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7HAq8")).SmartLinkModalProvider), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kySOC")).HoverCardComponent), props, children)));
    };
    const $2eeb1383fcc12911$var$HoverCardWithoutAnalyticsContext = (0, (0, parcelRequire("cb25w")).default)()($2eeb1383fcc12911$var$HoverCardWithErrorBoundary);
    const $2eeb1383fcc12911$export$57a077cc9fbe653e = (props)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)($2eeb1383fcc12911$var$HoverCardWithoutAnalyticsContext, props);
    };
    const $2eeb1383fcc12911$export$f1f63acbe6ed8fb0 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($2eeb1383fcc12911$export$57a077cc9fbe653e, props);
});
parcelRegister("8dVIb", function(module, exports) {
    $parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", ()=>$ad6fd5c2f706e309$export$5c881701926acbef);
    $parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", ()=>$ad6fd5c2f706e309$export$93d67ab022d9f8d2);
    $parcel$export(module.exports, "CONTENT_URL_AI", ()=>$ad6fd5c2f706e309$export$70d24f0465ae60f8);
    $parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", ()=>$ad6fd5c2f706e309$export$a3ed5c4e9d9599b7);
    $parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", ()=>$ad6fd5c2f706e309$export$73b198e73554a323);
    $parcel$export(module.exports, "SmartLinkAlignment", ()=>$ad6fd5c2f706e309$export$8910bf86027fe6be);
    $parcel$export(module.exports, "SmartLinkDirection", ()=>$ad6fd5c2f706e309$export$60831686b0574c86);
    $parcel$export(module.exports, "SmartLinkPosition", ()=>$ad6fd5c2f706e309$export$d58e6377644d1dcf);
    $parcel$export(module.exports, "SmartLinkSize", ()=>$ad6fd5c2f706e309$export$51f13ced115cbdae);
    $parcel$export(module.exports, "SmartLinkStatus", ()=>$ad6fd5c2f706e309$export$61cff06be26816f);
    $parcel$export(module.exports, "SmartLinkTheme", ()=>$ad6fd5c2f706e309$export$aed0f1e801ad691f);
    $parcel$export(module.exports, "SmartLinkInternalTheme", ()=>$ad6fd5c2f706e309$export$9aafec380d7005da);
    $parcel$export(module.exports, "SmartLinkWidth", ()=>$ad6fd5c2f706e309$export$19c60054ee783de6);
    $parcel$export(module.exports, "ElementName", ()=>$ad6fd5c2f706e309$export$d65b168331104a46);
    $parcel$export(module.exports, "ActionName", ()=>$ad6fd5c2f706e309$export$9c95d6e1614bad84);
    $parcel$export(module.exports, "InternalActionName", ()=>$ad6fd5c2f706e309$export$4871a84b35cf8eb9);
    $parcel$export(module.exports, "IconType", ()=>$ad6fd5c2f706e309$export$13ff1290a9e22e77);
    $parcel$export(module.exports, "MediaType", ()=>$ad6fd5c2f706e309$export$483c11740a902fcd);
    $parcel$export(module.exports, "MediaPlacement", ()=>$ad6fd5c2f706e309$export$f9f4737e25ab90fa);
    $parcel$export(module.exports, "CardDisplay", ()=>$ad6fd5c2f706e309$export$6ca4ef8b3dc2c804);
    const $ad6fd5c2f706e309$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
    const $ad6fd5c2f706e309$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
    const $ad6fd5c2f706e309$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
    const $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
    const $ad6fd5c2f706e309$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
    var $ad6fd5c2f706e309$export$8910bf86027fe6be;
    (function(SmartLinkAlignment) {
        SmartLinkAlignment["Left"] = "left";
        SmartLinkAlignment["Right"] = "right";
    })($ad6fd5c2f706e309$export$8910bf86027fe6be || ($ad6fd5c2f706e309$export$8910bf86027fe6be = {}));
    var $ad6fd5c2f706e309$export$60831686b0574c86;
    (function(SmartLinkDirection) {
        SmartLinkDirection["Horizontal"] = "horizontal";
        SmartLinkDirection["Vertical"] = "vertical";
    })($ad6fd5c2f706e309$export$60831686b0574c86 || ($ad6fd5c2f706e309$export$60831686b0574c86 = {}));
    var $ad6fd5c2f706e309$export$d58e6377644d1dcf;
    (function(SmartLinkPosition) {
        SmartLinkPosition["Top"] = "top";
        SmartLinkPosition["Center"] = "center";
    })($ad6fd5c2f706e309$export$d58e6377644d1dcf || ($ad6fd5c2f706e309$export$d58e6377644d1dcf = {}));
    var $ad6fd5c2f706e309$export$51f13ced115cbdae;
    (function(SmartLinkSize) {
        SmartLinkSize["XLarge"] = "xlarge";
        SmartLinkSize["Large"] = "large";
        SmartLinkSize["Medium"] = "medium";
        SmartLinkSize["Small"] = "small";
    })($ad6fd5c2f706e309$export$51f13ced115cbdae || ($ad6fd5c2f706e309$export$51f13ced115cbdae = {}));
    var $ad6fd5c2f706e309$export$61cff06be26816f;
    (function(SmartLinkStatus) {
        SmartLinkStatus["Pending"] = "pending";
        SmartLinkStatus["Resolving"] = "resolving";
        SmartLinkStatus["Resolved"] = "resolved";
        SmartLinkStatus["Forbidden"] = "forbidden";
        SmartLinkStatus["Errored"] = "errored";
        SmartLinkStatus["NotFound"] = "not_found";
        SmartLinkStatus["Unauthorized"] = "unauthorized";
        SmartLinkStatus["Fallback"] = "fallback";
    })($ad6fd5c2f706e309$export$61cff06be26816f || ($ad6fd5c2f706e309$export$61cff06be26816f = {}));
    var $ad6fd5c2f706e309$export$aed0f1e801ad691f;
    (function(SmartLinkTheme) {
        SmartLinkTheme["Black"] = "black";
        SmartLinkTheme["Link"] = "link";
    })($ad6fd5c2f706e309$export$aed0f1e801ad691f || ($ad6fd5c2f706e309$export$aed0f1e801ad691f = {}));
    var $ad6fd5c2f706e309$export$9aafec380d7005da;
    (function(SmartLinkInternalTheme) {
        SmartLinkInternalTheme["Grey"] = "grey";
    })($ad6fd5c2f706e309$export$9aafec380d7005da || ($ad6fd5c2f706e309$export$9aafec380d7005da = {}));
    var $ad6fd5c2f706e309$export$19c60054ee783de6;
    (function(SmartLinkWidth) {
        SmartLinkWidth["FitToContent"] = "fit-to-content";
        SmartLinkWidth["Flexible"] = "flexible";
    })($ad6fd5c2f706e309$export$19c60054ee783de6 || ($ad6fd5c2f706e309$export$19c60054ee783de6 = {}));
    var $ad6fd5c2f706e309$export$d65b168331104a46;
    (function(ElementName) {
        ElementName["AssignedTo"] = "AssignedTo";
        ElementName["AssignedToGroup"] = "AssignedToGroup";
        ElementName["AttachmentCount"] = "AttachmentCount";
        ElementName["AuthorGroup"] = "AuthorGroup";
        ElementName["ChecklistProgress"] = "ChecklistProgress";
        ElementName["CollaboratorGroup"] = "CollaboratorGroup";
        ElementName["CommentCount"] = "CommentCount";
        ElementName["CreatedBy"] = "CreatedBy";
        ElementName["CreatedOn"] = "CreatedOn";
        ElementName["DueOn"] = "DueOn";
        ElementName["LatestCommit"] = "LatestCommit";
        ElementName["LinkIcon"] = "LinkIcon";
        ElementName["Location"] = "Location";
        ElementName["ModifiedBy"] = "ModifiedBy";
        ElementName["ModifiedOn"] = "ModifiedOn";
        ElementName["OwnedBy"] = "OwnedBy";
        ElementName["OwnedByGroup"] = "OwnedByGroup";
        ElementName["Preview"] = "Preview";
        ElementName["Priority"] = "Priority";
        ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
        ElementName["Provider"] = "Provider";
        ElementName["ReactCount"] = "ReactCount";
        ElementName["ReadTime"] = "ReadTime";
        ElementName["Snippet"] = "Snippet";
        ElementName["SourceBranch"] = "SourceBranch";
        ElementName["State"] = "State";
        ElementName["SubscriberCount"] = "SubscriberCount";
        ElementName["SubTasksProgress"] = "SubTasksProgress";
        ElementName["StoryPoints"] = "StoryPoints";
        ElementName["TargetBranch"] = "TargetBranch";
        ElementName["Title"] = "Title";
        ElementName["ViewCount"] = "ViewCount";
        ElementName["VoteCount"] = "VoteCount";
        ElementName["SentOn"] = "SentOn";
    })($ad6fd5c2f706e309$export$d65b168331104a46 || ($ad6fd5c2f706e309$export$d65b168331104a46 = {}));
    var $ad6fd5c2f706e309$export$9c95d6e1614bad84;
    (function(ActionName) {
        ActionName["CopyLinkAction"] = "CopyLinkAction";
        ActionName["DeleteAction"] = "DeleteAction";
        ActionName["EditAction"] = "EditAction";
        ActionName["FollowAction"] = "FollowAction";
        ActionName["PreviewAction"] = "PreviewAction";
        ActionName["AutomationAction"] = "AutomationAction";
        ActionName["DownloadAction"] = "DownloadAction";
        ActionName["CustomAction"] = "CustomAction";
    })($ad6fd5c2f706e309$export$9c95d6e1614bad84 || ($ad6fd5c2f706e309$export$9c95d6e1614bad84 = {}));
    var $ad6fd5c2f706e309$export$4871a84b35cf8eb9;
    (function(InternalActionName) {
        InternalActionName["AISummaryAction"] = "AISummaryAction";
        InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    })($ad6fd5c2f706e309$export$4871a84b35cf8eb9 || ($ad6fd5c2f706e309$export$4871a84b35cf8eb9 = {}));
    var $ad6fd5c2f706e309$export$13ff1290a9e22e77;
    (function(IconType) {
        IconType["Archive"] = "FileType:Archive";
        IconType["Audio"] = "FileType:Audio";
        IconType["Blog"] = "FileType:Blog";
        IconType["Code"] = "FileType:Code";
        IconType["Document"] = "FileType:Document";
        IconType["Executable"] = "FileType:Executable";
        IconType["File"] = "FileType:File";
        IconType["Folder"] = "FileType:Folder";
        IconType["Generic"] = "FileType:Generic";
        IconType["GIF"] = "FileType:GIF";
        IconType["GoogleDocs"] = "FileType:GoogleDocs";
        IconType["GoogleForms"] = "FileType:GoogleForms";
        IconType["GoogleSheets"] = "FileType:GoogleSheets";
        IconType["GoogleSlides"] = "FileType:GoogleSlides";
        IconType["Image"] = "FileType.Image";
        IconType["MSExcel"] = "FileType:Excel";
        IconType["MSPowerpoint"] = "FileType:Powerpoint";
        IconType["MSWord"] = "FileType:WordDocument";
        IconType["PDF"] = "FileType:PDF";
        IconType["Presentation"] = "FileType:Presentation";
        IconType["Sketch"] = "FileType:Sketch";
        IconType["Spreadsheet"] = "FileType:Spreadsheet";
        IconType["Template"] = "FileType:Template";
        IconType["Video"] = "FileType:Video";
        IconType["Branch"] = "BitBucket:Branch";
        IconType["Commit"] = "BitBucket:Commit";
        IconType["Project"] = "BitBucket:Project";
        IconType["PullRequest"] = "BitBucket:PullRequest";
        IconType["Repo"] = "BitBucket:Repo";
        IconType["Bug"] = "Jira:Bug";
        IconType["Change"] = "Jira:Change";
        IconType["Epic"] = "Jira:Epic";
        IconType["Incident"] = "Jira:Incident";
        IconType["Problem"] = "Jira:Problem";
        IconType["ServiceRequest"] = "Jira:ServiceRequest";
        IconType["Story"] = "Jira:Story";
        IconType["SubTask"] = "Jira:SubTask";
        IconType["Task"] = "Jira:Task";
        IconType["Confluence"] = "Provider:Confluence";
        IconType["Jira"] = "Provider:Jira";
        IconType["Default"] = "Default";
        IconType["Error"] = "Default:Error";
        IconType["Forbidden"] = "Default:Forbidden";
        IconType["Attachment"] = "Badge:Attachment";
        IconType["CheckItem"] = "Badge:Task";
        IconType["Comment"] = "Badge:Comment";
        IconType["View"] = "Badge:View";
        IconType["React"] = "Badge:React";
        IconType["Vote"] = "Badge:Vote";
        IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
        IconType["PriorityCritical"] = "Badge:PriorityCritical";
        IconType["PriorityHigh"] = "Badge:PriorityHigh";
        IconType["PriorityHighest"] = "Badge:PriorityHighest";
        IconType["PriorityLow"] = "Badge:PriorityLow";
        IconType["PriorityLowest"] = "Badge:PriorityLowest";
        IconType["PriorityMajor"] = "Badge:PriorityMajor";
        IconType["PriorityMedium"] = "Badge:PriorityMedium";
        IconType["PriorityMinor"] = "Badge:PriorityMinor";
        IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
        IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
        IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
        IconType["Subscriber"] = "Badge:Subscriber";
        IconType["SubTasksProgress"] = "Badge:SubTask";
    })($ad6fd5c2f706e309$export$13ff1290a9e22e77 || ($ad6fd5c2f706e309$export$13ff1290a9e22e77 = {}));
    var $ad6fd5c2f706e309$export$483c11740a902fcd;
    (function(MediaType) {
        MediaType["Image"] = "image";
    })($ad6fd5c2f706e309$export$483c11740a902fcd || ($ad6fd5c2f706e309$export$483c11740a902fcd = {}));
    var $ad6fd5c2f706e309$export$f9f4737e25ab90fa;
    (function(MediaPlacement) {
        MediaPlacement["Left"] = "left";
        MediaPlacement["Right"] = "right";
    })($ad6fd5c2f706e309$export$f9f4737e25ab90fa || ($ad6fd5c2f706e309$export$f9f4737e25ab90fa = {}));
    var $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804;
    (function(CardDisplay) {
        CardDisplay["Inline"] = "inline";
        CardDisplay["Block"] = "block";
        CardDisplay["Embed"] = "embed";
        CardDisplay["EmbedPreview"] = "embedPreview";
        CardDisplay["Flexible"] = "flexible";
        CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    })($ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 || ($ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 = {}));
});
parcelRegister("kXQmf", function(module, exports) {
    $parcel$export(module.exports, "useSmartLinkAnalytics", ()=>$6bc8b728824e2d0a$export$57c7fece972c9472);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    var $cCcdH;
    var $fzJZi;
    var $1n7Qj;
    var $fzJZi;
    var $fgpl1;
    var $1VPdD;
    var $kaKBF;
    const $6bc8b728824e2d0a$var$applyCommonAttributes = (event, commonAttributes)=>{
        if (event && event.attributes) {
            for (const [key, value] of Object.entries(commonAttributes))if (event.attributes[key] === undefined) event.attributes[key] = value;
        }
        return event;
    };
    const $6bc8b728824e2d0a$export$57c7fece972c9472 = (url, id, defaultLocation)=>{
        const { dispatchAnalytics: dispatchAnalytics } = (0, (0, parcelRequire("kaKBF")).useDispatchAnalytics)();
        const defaultId = id || 'NULL';
        const { store: store } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const state = store ? (0, (0, parcelRequire("cCcdH")).getUrl)(store, url) : undefined;
        const details = state ? state.details : undefined;
        const extractedDefinitionId = (0, (0, parcelRequire("fgpl1")).getDefinitionId)(details);
        const extractedExtensionKey = (0, (0, parcelRequire("fgpl1")).getExtensionKey)(details);
        const extractedResourceType = (0, (0, parcelRequire("fgpl1")).getResourceType)(details);
        const extractedSubproduct = (0, (0, parcelRequire("fgpl1")).getSubproduct)(details);
        const extractedProduct = (0, (0, parcelRequire("fgpl1")).getProduct)(details);
        const extractedStatusDetails = (0, (0, parcelRequire("fgpl1")).getStatusDetails)(details);
        const commonAttributes = (0, $5uXOq.useMemo)(()=>({
                id: defaultId,
                definitionId: extractedDefinitionId,
                extensionKey: extractedExtensionKey,
                resourceType: extractedResourceType,
                destinationObjectType: extractedResourceType,
                destinationSubproduct: extractedSubproduct,
                destinationProduct: extractedProduct,
                location: defaultLocation,
                statusDetails: extractedStatusDetails
            }), [
            defaultId,
            extractedDefinitionId,
            extractedExtensionKey,
            extractedResourceType,
            extractedSubproduct,
            extractedProduct,
            defaultLocation,
            extractedStatusDetails
        ]);
        const ui = (0, $5uXOq.useMemo)(()=>({
                authEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiAuthEvent)({
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                authAlternateAccountEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiAuthAlternateAccountEvent)({
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                buttonClickedEvent: (data)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: data.actionSubjectId,
                        attributes: {
                            ...(0, (0, parcelRequire("fzJZi")).context),
                            ...data.attributes
                        },
                        eventType: 'ui'
                    }, commonAttributes)),
                cardClickedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiCardClickedEvent)({
                        id: id,
                        display: display,
                        status: status,
                        definitionId: definitionId,
                        extensionKey: extensionKey,
                        isModifierKeyPressed: isModifierKeyPressed,
                        location: location,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        actionSubjectId: actionSubjectId
                    }), commonAttributes)),
                iframeDwelledEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiIframeDwelledEvent)({
                        id: id,
                        display: display,
                        status: status,
                        definitionId: definitionId,
                        extensionKey: extensionKey,
                        location: location,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        dwellTime: dwellTime,
                        dwellPercentVisible: dwellPercentVisible
                    }), commonAttributes)),
                iframeFocusedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiIframeFocusedEvent)({
                        id: id,
                        display: display,
                        status: status,
                        definitionId: definitionId,
                        extensionKey: extensionKey,
                        location: location,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct
                    }), commonAttributes)),
                actionClickedEvent: ({ id: id, actionType: actionType, display: display, extensionKey: overrideExtensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const extensionKey = overrideExtensionKey ?? extractedExtensionKey;
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiActionClickedEvent)({
                        id: id ?? defaultId,
                        actionType: actionType,
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                hoverCardOpenLinkClickedEvent: ({ previewDisplay: previewDisplay, definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiHoverCardOpenLinkClickedEvent)({
                        id: defaultId,
                        previewDisplay: previewDisplay,
                        definitionId: definitionId,
                        extensionKey: extensionKey,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        previewInvokeMethod: previewInvokeMethod
                    }), commonAttributes));
                },
                closedAuthEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiClosedAuthEvent)({
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                modalClosedEvent: (data)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes({
                        action: 'closed',
                        actionSubject: 'modal',
                        actionSubjectId: data.actionSubjectId,
                        attributes: {
                            ...(0, (0, parcelRequire("fzJZi")).context),
                            ...data.attributes
                        },
                        eventType: 'ui'
                    }, commonAttributes)),
                renderSuccessEvent: ({ display: display, status: status, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource = false })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)('smart-link-rendered', experienceId, {
                        extensionKey: extensionKey,
                        display: display
                    });
                    (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)('smart-link-authenticated', experienceId, {
                        display: display
                    });
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiRenderSuccessEvent)({
                        display: display,
                        status: status,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        canBeDatasource: canBeDatasource
                    }), commonAttributes));
                },
                renderFailedEvent: ({ display: display, id: id, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).startUfoExperience)('smart-link-rendered', experienceId);
                    (0, (0, parcelRequire("1VPdD")).failUfoExperience)('smart-link-rendered', experienceId);
                    (0, (0, parcelRequire("1VPdD")).failUfoExperience)('smart-link-authenticated', experienceId);
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiRenderFailedEvent)({
                        display: display,
                        error: error,
                        errorInfo: errorInfo,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                hoverCardViewedEvent: ({ previewDisplay: previewDisplay, previewInvokeMethod: previewInvokeMethod, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiHoverCardViewedEvent)({
                        id: id,
                        previewDisplay: previewDisplay,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        previewInvokeMethod: previewInvokeMethod,
                        status: status
                    }), commonAttributes)),
                hoverCardDismissedEvent: ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, previewInvokeMethod: previewInvokeMethod, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiHoverCardDismissedEvent)({
                        previewDisplay: previewDisplay,
                        id: id,
                        hoverTime: hoverTime,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        previewInvokeMethod: previewInvokeMethod,
                        status: status
                    }), commonAttributes)),
                learnMoreClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiLearnMoreLinkClickedEvent)(), commonAttributes)),
                smartLinkLozengeActionClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiSmartLinkStatusLozengeButtonClicked)(), commonAttributes)),
                smartLinkLozengeActionListItemClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiSmartLinkStatusListItemButtonClicked)(), commonAttributes)),
                smartLinkLozengeActionErrorOpenPreviewClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiSmartLinkStatusOpenPreviewButtonClicked)(), commonAttributes)),
                smartLinkServerActionClickedEvent: (props)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiServerActionClicked)(props), commonAttributes))
            }), [
            dispatchAnalytics,
            commonAttributes,
            defaultId,
            extractedExtensionKey
        ]);
        const operational = (0, $5uXOq.useMemo)(()=>({
                invokeSucceededEvent: ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).invokeSucceededEvent)({
                        id: id ?? defaultId,
                        actionType: actionType,
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                invokeFailedEvent: ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).invokeFailedEvent)({
                        id: id ?? defaultId,
                        actionType: actionType,
                        display: display,
                        reason: reason,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                connectSucceededEvent: ({ id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).startUfoExperience)('smart-link-authenticated', experienceId, {
                        extensionKey: extensionKey,
                        status: 'success'
                    });
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).connectSucceededEvent)({
                        ...commonAttributes,
                        id: experienceId,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                connectFailedEvent: ({ id: id, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).startUfoExperience)('smart-link-authenticated', experienceId, {
                        extensionKey: extensionKey,
                        status: reason
                    });
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).connectFailedEvent)({
                        ...commonAttributes,
                        id: experienceId,
                        reason: reason,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                instrument: ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
                    const event = (0, (0, parcelRequire("1n7Qj")).instrumentEvent)({
                        ...commonAttributes,
                        id: id,
                        status: status,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        error: error
                    });
                    if (event) dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes(event, commonAttributes));
                },
                chunkloadFailedEvent: ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).chunkloadFailedEvent)({
                        display: display,
                        error: error,
                        errorInfo: errorInfo,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                }
            }), [
            defaultId,
            commonAttributes,
            dispatchAnalytics
        ]);
        const track = (0, $5uXOq.useMemo)(()=>({
                appAccountConnected: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).trackAppAccountConnected)({
                        ...commonAttributes,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                appAccountAuthStarted: ({ extensionKey: extensionKey, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).trackAppAccountAuthStarted)({
                        ...commonAttributes,
                        extensionKey: extensionKey,
                        location: location
                    }), commonAttributes)),
                smartLinkQuickActionStarted: (props)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).trackSmartLinkQuickActionStarted)({
                        ...commonAttributes,
                        ...props
                    }), commonAttributes)),
                smartLinkQuickActionSuccess: (props)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).trackSmartLinkQuickActionSuccess)({
                        ...commonAttributes,
                        ...props
                    }), commonAttributes)),
                smartLinkQuickActionFailed: (props)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).trackSmartLinkQuickActionFailed)({
                        ...commonAttributes,
                        ...props
                    }), commonAttributes)),
                hoverCardResolutionStarted: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).trackHoverCardResolutionStarted)({
                        display: 'hoverCardPreview',
                        ...commonAttributes
                    }), commonAttributes))
            }), [
            commonAttributes,
            dispatchAnalytics
        ]);
        const screen = (0, $5uXOq.useMemo)(()=>({
                authPopupEvent: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).screenAuthPopupEvent)({
                        ...commonAttributes,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                modalViewedEvent: (data)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes({
                        action: 'viewed',
                        actionSubject: data.name,
                        attributes: {
                            ...(0, (0, parcelRequire("fzJZi")).context),
                            ...data.attributes
                        },
                        eventType: 'screen',
                        name: data.name
                    }, commonAttributes))
            }), [
            commonAttributes,
            dispatchAnalytics
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                ui: ui,
                operational: operational,
                track: track,
                screen: screen
            }), [
            ui,
            operational,
            track,
            screen
        ]);
    };
});
parcelRegister("fzJZi", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_CHANNEL", ()=>$3b4d25437cc28513$export$85183a312807388d);
    $parcel$export(module.exports, "context", ()=>$3b4d25437cc28513$export$a078c61943f9dbbe);
    $parcel$export(module.exports, "TrackQuickActionType", ()=>$3b4d25437cc28513$export$72af824fa910c33e);
    $parcel$export(module.exports, "TrackQuickActionFailureReason", ()=>$3b4d25437cc28513$export$c89e475f7f7174c2);
    $parcel$export(module.exports, "SmartLinkEvents", ()=>$3b4d25437cc28513$export$b91e0203b928470c);
    $parcel$export(module.exports, "resolvedEvent", ()=>$3b4d25437cc28513$export$e2e1bab8375c3115);
    $parcel$export(module.exports, "unresolvedEvent", ()=>$3b4d25437cc28513$export$331b399cdebbb8d4);
    $parcel$export(module.exports, "invokeSucceededEvent", ()=>$3b4d25437cc28513$export$237caeb1002642ba);
    $parcel$export(module.exports, "invokeFailedEvent", ()=>$3b4d25437cc28513$export$ac488bf3e4c7f93);
    $parcel$export(module.exports, "connectSucceededEvent", ()=>$3b4d25437cc28513$export$5f549b8ba38f19b1);
    $parcel$export(module.exports, "connectFailedEvent", ()=>$3b4d25437cc28513$export$fdfcba182edbb89a);
    $parcel$export(module.exports, "trackAppAccountConnected", ()=>$3b4d25437cc28513$export$27d8deca51e9575c);
    $parcel$export(module.exports, "trackAppAccountAuthStarted", ()=>$3b4d25437cc28513$export$48e92e116e00d94c);
    $parcel$export(module.exports, "trackSmartLinkQuickActionStarted", ()=>$3b4d25437cc28513$export$1c2a74fe02a8031b);
    $parcel$export(module.exports, "trackSmartLinkQuickActionSuccess", ()=>$3b4d25437cc28513$export$afbd6446c1c03a3e);
    $parcel$export(module.exports, "trackSmartLinkQuickActionFailed", ()=>$3b4d25437cc28513$export$2706827739a8c50);
    $parcel$export(module.exports, "trackHoverCardResolutionStarted", ()=>$3b4d25437cc28513$export$daa964b113be9527);
    $parcel$export(module.exports, "uiAuthEvent", ()=>$3b4d25437cc28513$export$5318734335f1d8b8);
    $parcel$export(module.exports, "uiAuthAlternateAccountEvent", ()=>$3b4d25437cc28513$export$14f2ce8523ccb652);
    $parcel$export(module.exports, "uiCardClickedEvent", ()=>$3b4d25437cc28513$export$8b5d1f55370347a1);
    $parcel$export(module.exports, "uiIframeDwelledEvent", ()=>$3b4d25437cc28513$export$6b045396616c2e9f);
    $parcel$export(module.exports, "uiIframeFocusedEvent", ()=>$3b4d25437cc28513$export$93fa3246cf9e3b52);
    $parcel$export(module.exports, "uiActionClickedEvent", ()=>$3b4d25437cc28513$export$e00b9d79d3367530);
    $parcel$export(module.exports, "uiClosedAuthEvent", ()=>$3b4d25437cc28513$export$fe5b1f066ca3365d);
    $parcel$export(module.exports, "screenAuthPopupEvent", ()=>$3b4d25437cc28513$export$69bb595db263d8ef);
    $parcel$export(module.exports, "uiRenderSuccessEvent", ()=>$3b4d25437cc28513$export$bd308326cf1076aa);
    $parcel$export(module.exports, "uiRenderFailedEvent", ()=>$3b4d25437cc28513$export$1543b6391f48a5e2);
    $parcel$export(module.exports, "uiHoverCardViewedEvent", ()=>$3b4d25437cc28513$export$e80a2f97cccab3b1);
    $parcel$export(module.exports, "uiHoverCardDismissedEvent", ()=>$3b4d25437cc28513$export$3d10c6f90bc461d3);
    $parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", ()=>$3b4d25437cc28513$export$ad3275d7dff50d21);
    $parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", ()=>$3b4d25437cc28513$export$925348ae8d2e0bf3);
    $parcel$export(module.exports, "chunkloadFailedEvent", ()=>$3b4d25437cc28513$export$2b6bbed3753f06f9);
    $parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", ()=>$3b4d25437cc28513$export$94c3643533642ab);
    $parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", ()=>$3b4d25437cc28513$export$18dfe458db0b743d);
    $parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", ()=>$3b4d25437cc28513$export$9a352e2e15b3de89);
    $parcel$export(module.exports, "uiServerActionClicked", ()=>$3b4d25437cc28513$export$a66dc699502b5d28);
    var $T540Y;
    var $5vDFA;
    const $3b4d25437cc28513$export$85183a312807388d = 'media';
    const $3b4d25437cc28513$export$a078c61943f9dbbe = {
        componentName: 'smart-cards',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    var $3b4d25437cc28513$export$72af824fa910c33e;
    (function(TrackQuickActionType) {
        TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    })($3b4d25437cc28513$export$72af824fa910c33e || ($3b4d25437cc28513$export$72af824fa910c33e = {}));
    var $3b4d25437cc28513$export$c89e475f7f7174c2;
    (function(TrackQuickActionFailureReason) {
        TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
        TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
        TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    })($3b4d25437cc28513$export$c89e475f7f7174c2 || ($3b4d25437cc28513$export$c89e475f7f7174c2 = {}));
    const $3b4d25437cc28513$export$bbd674aacb40a160 = {
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).FollowEntityAction]: 'Follow',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
    };
    const $3b4d25437cc28513$export$baf70a532f8c6fa6 = {
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
    };
    const $3b4d25437cc28513$var$uiActionSubjectIds = {
        DownloadAction: 'downloadDocument',
        PreviewAction: 'invokePreviewScreen',
        ViewAction: 'shortcutGoToLink',
        StatusAction: 'issueStatusUpdate'
    };
    class $3b4d25437cc28513$export$b91e0203b928470c {
        insertSmartLink(url, type, createAnalyticsEvent) {
            $3b4d25437cc28513$export$2a123f7ee48a122c({
                action: 'inserted',
                actionSubject: 'smartLink',
                eventType: 'track',
                attributes: {
                    type: type
                },
                nonPrivacySafeAttributes: {
                    domainName: url
                }
            }, createAnalyticsEvent);
        }
    }
    const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
        if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
    };
    const $3b4d25437cc28513$export$e2e1bab8375c3115 = (props)=>({
            action: 'resolved',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...props,
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
            action: 'unresolved',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                id: id,
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...definitionId ? {
                    definitionId: definitionId
                } : {},
                ...extensionKey ? {
                    extensionKey: extensionKey
                } : {},
                ...resourceType ? {
                    resourceType: resourceType
                } : {},
                ...destinationSubproduct ? {
                    destinationSubproduct: destinationSubproduct
                } : {},
                ...destinationProduct ? {
                    destinationProduct: destinationProduct
                } : {},
                ...location ? {
                    location: location
                } : {},
                reason: status,
                error: error ? {
                    message: error?.message,
                    kind: error?.kind,
                    type: error?.type
                } : undefined
            }
        });
    const $3b4d25437cc28513$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
        const measure = id ? (0, (0, parcelRequire("5vDFA")).getMeasure)(id, 'resolved') : undefined;
        return {
            action: 'resolved',
            actionSubject: 'smartLinkAction',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                actionType: actionType,
                display: display,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                extensionKey: extensionKey,
                duration: measure?.duration
            }
        };
    };
    const $3b4d25437cc28513$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
        const measure = id ? (0, (0, parcelRequire("5vDFA")).getMeasure)(id, 'errored') : undefined;
        return {
            action: 'unresolved',
            actionSubject: 'smartLinkAction',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                duration: measure?.duration,
                reason: reason
            }
        };
    };
    const $3b4d25437cc28513$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'connectSucceeded',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
            action: 'connectFailed',
            actionSubject: 'smartLink',
            actionSubjectId: reason,
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                reason: reason,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$27d8deca51e9575c = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'connected',
            actionSubject: 'applicationAccount',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$48e92e116e00d94c = ({ extensionKey: extensionKey, location: location })=>({
            action: 'authStarted',
            actionSubject: 'applicationAccount',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                location: location
            }
        });
    const $3b4d25437cc28513$export$1c2a74fe02a8031b = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
            action: 'started',
            actionSubject: 'smartLinkQuickAction',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...attributes,
                smartLinkActionType: $3b4d25437cc28513$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
            }
        });
    const $3b4d25437cc28513$export$afbd6446c1c03a3e = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
            action: 'success',
            actionSubject: 'smartLinkQuickAction',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...attributes,
                smartLinkActionType: $3b4d25437cc28513$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
            }
        });
    const $3b4d25437cc28513$export$2706827739a8c50 = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
            action: 'failed',
            actionSubject: 'smartLinkQuickAction',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...attributes,
                smartLinkActionType: $3b4d25437cc28513$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
            }
        });
    const $3b4d25437cc28513$export$daa964b113be9527 = ({ display: display, ...attributes })=>({
            action: 'resolved',
            actionSubject: 'hoverCard',
            eventType: 'track',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...attributes,
                display: display
            }
        });
    const $3b4d25437cc28513$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connectAccount',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'tryAnotherAccount',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: actionSubjectId,
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                isModifierKeyPressed: isModifierKeyPressed,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct
            }
        });
    const $3b4d25437cc28513$export$6b045396616c2e9f = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>({
            action: 'dwelled',
            actionSubject: 'smartLinkIframe',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                dwellTime: dwellTime,
                dwellPercentVisible: dwellPercentVisible
            }
        });
    const $3b4d25437cc28513$export$93fa3246cf9e3b52 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>({
            action: 'focused',
            actionSubject: 'smartLinkIframe',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct
            }
        });
    const $3b4d25437cc28513$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $3b4d25437cc28513$var$uiActionSubjectIds[actionType],
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                display: display,
                actionType: actionType,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'closed',
            actionSubject: 'consentModal',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$69bb595db263d8ef = ({ extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            actionSubject: 'consentModal',
            eventType: 'screen',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
            action: 'renderSuccess',
            actionSubject: 'smartLink',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                status: status,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display,
                canBeDatasource: canBeDatasource
            }
        });
    const $3b4d25437cc28513$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            actionSubject: 'smartLink',
            action: 'renderFailed',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                error: error,
                errorInfo: errorInfo,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
            action: 'viewed',
            actionSubject: 'hoverCard',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod,
                status: status
            }
        });
    const $3b4d25437cc28513$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
            action: 'dismissed',
            actionSubject: 'hoverCard',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                hoverTime: hoverTime,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod,
                status: status
            }
        });
    const $3b4d25437cc28513$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'shortcutGoToLink',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod
            }
        });
    const $3b4d25437cc28513$export$925348ae8d2e0bf3 = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'chunkLoadFailed',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                error: error,
                errorInfo: errorInfo,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$94c3643533642ab = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusLozenge',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$18dfe458db0b743d = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusListItem',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$9a352e2e15b3de89 = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusOpenPreview',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $3b4d25437cc28513$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
});
parcelRegister("T540Y", function(module, exports) {
    $parcel$export(module.exports, "SmartLinkActionType", ()=>$171ae91e706973ef$export$6324b7946ad663e9);
    $parcel$export(module.exports, "InvokeError", ()=>$171ae91e706973ef$export$d4d72202bff63658);
    var $171ae91e706973ef$export$6324b7946ad663e9;
    (function(SmartLinkActionType) {
        SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
        SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
        SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
        SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    })($171ae91e706973ef$export$6324b7946ad663e9 || ($171ae91e706973ef$export$6324b7946ad663e9 = {}));
    class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
        constructor(message, errorCode){
            super(message);
            this.errorCode = errorCode;
        }
    }
});
parcelRegister("5vDFA", function(module, exports) {
    $parcel$export(module.exports, "clearMarks", ()=>$483ef2a5b4b04745$export$1a717feb4df1a945);
    $parcel$export(module.exports, "clearMeasures", ()=>$483ef2a5b4b04745$export$de42547d395c8271);
    $parcel$export(module.exports, "getMeasure", ()=>$483ef2a5b4b04745$export$d6e97a903ae9a3aa);
    $parcel$export(module.exports, "mark", ()=>$483ef2a5b4b04745$export$bf7f2fce5c1cf636);
    $parcel$export(module.exports, "create", ()=>$483ef2a5b4b04745$export$185802fd694ee1f5);
    const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
        return typeof window !== 'undefined' && 'performance' in window && [
            'measure',
            'clearMeasures',
            'clearMarks',
            'getEntriesByName',
            'getEntriesByType'
        ].every((api)=>!!performance[api]);
    };
    const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
    const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
    const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
    const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
            marks.forEach((mark)=>performance.clearMarks(mark.name));
        }
    };
    const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
            measures.forEach((measure)=>performance.clearMeasures(measure.name));
        }
    };
    const $483ef2a5b4b04745$var$getMark = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
            const marks = performance.getEntriesByName(name);
            if (marks.length > 0) return marks[0];
            return undefined;
        }
    };
    const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
            const measures = performance.getEntriesByName(name);
            if (measures.length > 0) return measures[0];
            return undefined;
        }
    };
    const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
            performance.mark(name);
        }
    };
    const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
            const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
            if (!measure) {
                const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
                const endMark = $483ef2a5b4b04745$var$getMark(id, status);
                if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
            }
        }
    };
});
parcelRegister("1n7Qj", function(module, exports) {
    $parcel$export(module.exports, "instrumentEvent", ()=>$a8cb699408687216$export$860cf9c079ed505);
    var $5vDFA;
    var $fzJZi;
    const $a8cb699408687216$export$860cf9c079ed505 = ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
        const measure = (0, (0, parcelRequire("5vDFA")).getMeasure)(id, status) || {
            duration: undefined
        };
        if (status === 'resolved') {
            const event = (0, (0, parcelRequire("fzJZi")).resolvedEvent)({
                id: id,
                extensionKey: extensionKey,
                definitionId: definitionId,
                resourceType: resourceType,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            });
            return {
                ...event,
                attributes: {
                    ...event.attributes,
                    duration: measure.duration
                }
            };
        } else if (error?.type !== 'ResolveUnsupportedError') {
            const event = (0, (0, parcelRequire("fzJZi")).unresolvedEvent)({
                id: id,
                status: status,
                extensionKey: extensionKey,
                definitionId: definitionId,
                resourceType: resourceType,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                error: error
            });
            return {
                ...event,
                attributes: {
                    ...event.attributes,
                    duration: measure.duration
                }
            };
        }
    };
});
parcelRegister("fgpl1", function(module, exports) {
    $parcel$export(module.exports, "getByDefinitionId", ()=>$8cbc55b0be5f7abb$export$f75b0b690ab4dfb9);
    $parcel$export(module.exports, "getClickUrl", ()=>$8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02);
    $parcel$export(module.exports, "getDefinitionId", ()=>$8cbc55b0be5f7abb$export$46fa3e7718c82e41);
    $parcel$export(module.exports, "getExtensionKey", ()=>$8cbc55b0be5f7abb$export$218d96312e385949);
    $parcel$export(module.exports, "getResourceType", ()=>$8cbc55b0be5f7abb$export$16c0ebb0de9b767b);
    $parcel$export(module.exports, "getProduct", ()=>$8cbc55b0be5f7abb$export$e2005c9600188ac7);
    $parcel$export(module.exports, "getSubproduct", ()=>$8cbc55b0be5f7abb$export$f8fdefc70357968e);
    $parcel$export(module.exports, "getServices", ()=>$8cbc55b0be5f7abb$export$a009e3a1163d46fb);
    $parcel$export(module.exports, "getStatusDetails", ()=>$8cbc55b0be5f7abb$export$a752a116d184ffbd);
    $parcel$export(module.exports, "isFinalState", ()=>$8cbc55b0be5f7abb$export$d590d08942abc17a);
    $parcel$export(module.exports, "getCanBeDatasource", ()=>$8cbc55b0be5f7abb$export$ba6d13ab7b87c55c);
    $parcel$export(module.exports, "hasAuthScopeOverrides", ()=>$8cbc55b0be5f7abb$export$3f9446bb21b945a0);
    var $iCv9y;
    const $8cbc55b0be5f7abb$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
        const urls = Object.keys(store);
        return urls.filter((url)=>{
            const { details: details } = store[url];
            return details && details.meta.definitionId === definitionId;
        });
    };
    const $8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
        if (jsonLd && jsonLd.data) {
            const visitUrl = (0, (0, parcelRequire("iCv9y")).extractVisitUrl)(jsonLd.data);
            if (visitUrl) return visitUrl;
        }
        return url;
    };
    const $8cbc55b0be5f7abb$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
    const $8cbc55b0be5f7abb$export$218d96312e385949 = (details)=>details?.meta?.key;
    const $8cbc55b0be5f7abb$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
    const $8cbc55b0be5f7abb$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
    const $8cbc55b0be5f7abb$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
    const $8cbc55b0be5f7abb$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
    const $8cbc55b0be5f7abb$export$ac5d414b1ebfab5a = (details)=>details && $8cbc55b0be5f7abb$export$cd41ae544cfc2a65(details) && $8cbc55b0be5f7abb$export$795910f5f15a9633(details);
    const $8cbc55b0be5f7abb$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
    const $8cbc55b0be5f7abb$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
    const $8cbc55b0be5f7abb$export$a752a116d184ffbd = (details)=>{
        return details?.meta?.requestAccess?.accessType;
    };
    const $8cbc55b0be5f7abb$export$d590d08942abc17a = (status)=>{
        return [
            'unauthorized',
            'forbidden',
            'errored',
            'resolved',
            'not_found'
        ].indexOf(status) > -1;
    };
    const $8cbc55b0be5f7abb$export$66805b16d2a1da7c = (details)=>details?.datasources;
    const $8cbc55b0be5f7abb$export$ba6d13ab7b87c55c = (details)=>{
        const datasources = $8cbc55b0be5f7abb$export$66805b16d2a1da7c(details);
        return !!datasources && datasources.length > 0;
    };
    const $8cbc55b0be5f7abb$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
});
parcelRegister("iCv9y", function(module, exports) {
    $parcel$export(module.exports, "extractVisitUrl", ()=>$28ad1893a5a5e6d3$export$c81497d3681f24f4);
    const $28ad1893a5a5e6d3$export$c81497d3681f24f4 = (jsonLd)=>{
        return jsonLd['atlassian:visitUrl'];
    };
});
parcelRegister("1VPdD", function(module, exports) {
    $parcel$export(module.exports, "startUfoExperience", ()=>$2308e6f5aae12b86$export$5e9287b6a10f8075);
    $parcel$export(module.exports, "succeedUfoExperience", ()=>$2308e6f5aae12b86$export$c5a5cf072c836c0e);
    $parcel$export(module.exports, "failUfoExperience", ()=>$2308e6f5aae12b86$export$8dda83bafca11b77);
    $parcel$export(module.exports, "addMetadataToExperience", ()=>$2308e6f5aae12b86$export$4084c0df4a03a6af);
    var $cBycP;
    var $7Zbvr;
    const $2308e6f5aae12b86$var$inlineExperience = {
        platform: {
            component: 'smart-links'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
    };
    const $2308e6f5aae12b86$var$renderExperience = {
        platform: {
            component: 'smart-links'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
    };
    const $2308e6f5aae12b86$var$aiExperience = {
        platform: {
            component: 'smart-links'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
    };
    const $2308e6f5aae12b86$var$ufoExperiences = {
        'smart-link-rendered': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-rendered', $2308e6f5aae12b86$var$renderExperience),
        'smart-link-authenticated': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-authenticated', $2308e6f5aae12b86$var$inlineExperience),
        'smart-link-action-invocation': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-action-invocation', $2308e6f5aae12b86$var$inlineExperience),
        'smart-link-ai-summary': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-ai-summary', $2308e6f5aae12b86$var$aiExperience)
    };
    const $2308e6f5aae12b86$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
        const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
        experience.start();
        if (properties) experience.addMetadata(properties);
    };
    const $2308e6f5aae12b86$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
        const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
        experience.success({
            metadata: properties
        });
    };
    const $2308e6f5aae12b86$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
        const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
        experience.failure({
            metadata: properties
        });
    };
    const $2308e6f5aae12b86$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
        $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
    };
});
parcelRegister("cBycP", function(module, exports) {
    $parcel$export(module.exports, "ConcurrentExperience", ()=>$d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);
    var $dCAsn;
    var $boHLC;
    class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
        constructor(experienceId, config){
            this.instances = {};
            this.experienceId = experienceId;
            this.config = config;
        }
        getInstance(instanceId) {
            if (!this.instances[instanceId]) this.instances[instanceId] = new (0, (0, parcelRequire("boHLC")).UFOExperience)(this.experienceId, this.config, instanceId);
            return this.instances[instanceId];
        }
        release(instanceId) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('instanceId', instanceId);
            if (this.instances[instanceId]) this.instances[instanceId].abort();
            delete this.instances[instanceId];
        }
    }
});
parcelRegister("dCAsn", function(module, exports) {
    $parcel$export(module.exports, "ufolog", ()=>$c8856379f9e2d7e8$export$b4958caff08a0960);
    $parcel$export(module.exports, "ufowarn", ()=>$c8856379f9e2d7e8$export$d53d07b6034c4560);
    class $c8856379f9e2d7e8$var$UFOLogger {
        static{
            this.UFOprefix = "[ufo\uD83D\uDEF8]";
        }
        log(...args) {
            this.enabled && console.log($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
        }
        warn(...args) {
            this.enabled && console.warn($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
        }
        enable() {
            this.enabled = true;
        }
        disable() {
            this.enabled = false;
        }
        constructor(){
            this.enabled = false;
        }
    }
    const $c8856379f9e2d7e8$export$4ab84f6f04f6566d = new $c8856379f9e2d7e8$var$UFOLogger();
    const $c8856379f9e2d7e8$export$b4958caff08a0960 = (...args)=>{
        $c8856379f9e2d7e8$export$4ab84f6f04f6566d.log(...args);
    };
    const $c8856379f9e2d7e8$export$d53d07b6034c4560 = (...args)=>{
        $c8856379f9e2d7e8$export$4ab84f6f04f6566d.warn(...args);
    };
});
parcelRegister("boHLC", function(module, exports) {
    $parcel$export(module.exports, "UFOExperience", ()=>$69d53cdb5241e240$export$c00d22927c60484a);
    var $iLwDN;
    class $69d53cdb5241e240$export$c00d22927c60484a extends (0, (0, parcelRequire("iLwDN")).UFOAbstractExperience) {
    }
});
parcelRegister("iLwDN", function(module, exports) {
    $parcel$export(module.exports, "UFOAbstractExperience", ()=>$cc70575b2203e361$export$d31c89db257648c);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $1vlV8;
    var $dCAsn;
    var $dlucd;
    var $blQsS;
    var $9tjMO;
    var $1CRHx;
    var $jZA09;
    var $hM2B6;
    var $7Zbvr;
    const $cc70575b2203e361$var$getPageVisibleState = ()=>{
        return !(0, (0, parcelRequire("1CRHx")).isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, (0, parcelRequire("blQsS")).PageVisibleState).VISIBLE : (0, (0, parcelRequire("blQsS")).PageVisibleState).HIDDEN;
    };
    const $cc70575b2203e361$export$c753e8669d30c8ad = (timestamp)=>{
        if (timestamp !== undefined) return ~~timestamp;
        return (0, (0, parcelRequire("9tjMO")).roundPerfNow)();
    };
    class $cc70575b2203e361$export$d31c89db257648c {
        constructor(id, config, instanceId = null){
            this.state = (0, (0, parcelRequire("jZA09")).UFOExperienceState).NOT_STARTED;
            this.instanceId = null;
            this.parent = null;
            this.category = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.explicitTimings = {};
            this.isSSROutputAsFMP = false;
            this.uuid = null;
            this._until = null;
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this.performanceConfig = {};
            this.setPageVisibleStateToMixed = ()=>{
                this.pageVisibleState = (0, (0, parcelRequire("blQsS")).PageVisibleState).MIXED;
                (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            };
            this.id = id;
            this.category = config?.category || null;
            this.until = config?.until || null;
            this.instanceId = instanceId;
            this.handleDoneBind = this._handleDoneExperience.bind(this);
            this.type = config.type;
            this.performanceType = config.performanceType;
            this.performanceConfig = config.performanceConfig || {};
            this.config = config;
            this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
            this.featureFlags = config.featureFlags || [];
            this.timings = config.timings || [];
            if (config.performanceType === (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
        }
        async transition(newState, timestamp) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('async transition', this.id, this.state.id, newState.id);
            if ((0, (0, parcelRequire("hM2B6")).canTransition)(this.state, newState)) {
                (0, (0, parcelRequire("dCAsn")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
                if (newState === (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED) this._reset();
                if (this.state.final && !newState.final) {
                    this.metrics.startTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                    this.uuid = (0, $7Jxgt.v4)();
                }
                this.state = newState;
                if (newState.final) {
                    this.metrics.endTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                    if (!this._isManualStateEnabled()) (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).unsubscribeEvent)((0, (0, parcelRequire("blQsS")).SUBSCRIBE_ALL), this.handleDoneBind));
                    const data = await this.exportData();
                    (0, (0, parcelRequire("dCAsn")).ufolog)('this.parent', this.parent);
                    (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).experiencePayloadEvent)(data));
                }
                return true;
            }
            (0, (0, parcelRequire("dCAsn")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
            (0, (0, parcelRequire("dCAsn")).ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
            return false;
        }
        async start(startTime) {
            const transitionSuccessful = await this.transition((0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED, startTime);
            if (transitionSuccessful) {
                this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
                (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                if (!this._isManualStateEnabled()) {
                    (0, (0, parcelRequire("dCAsn")).ufolog)('subscribed', this.id);
                    (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).subscribeEvent)((0, (0, parcelRequire("blQsS")).SUBSCRIBE_ALL), this.handleDoneBind));
                }
            }
        }
        mark(name, timestamp) {
            if (name !== (0, (0, parcelRequire("blQsS")).FMP_MARK) && name !== (0, (0, parcelRequire("blQsS")).INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
            else (0, (0, parcelRequire("dCAsn")).ufowarn)('please use markFMP or markInlineResponse for specialised marks');
        }
        _mark(name, timestamp) {
            this.metrics.marks.push({
                name: name,
                time: $cc70575b2203e361$export$c753e8669d30c8ad(timestamp)
            });
            this.transition((0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS);
        }
        markFMP(timestamp) {
            this._mark((0, (0, parcelRequire("blQsS")).FMP_MARK), timestamp);
        }
        markInlineResponse(timestamp) {
            this._mark((0, (0, parcelRequire("blQsS")).INLINE_RESPONSE_MARK), timestamp);
        }
        _isManualStateEnabled() {
            return this.until === null;
        }
        _validateManualState() {
            if (!this._isManualStateEnabled()) {
                (0, (0, parcelRequire("dCAsn")).ufowarn)('manual change of state not allowed as "until" is defined');
                return false;
            }
            return true;
        }
        switchToEndState(state, config) {
            if (!config?.force && !this._validateManualState()) return null;
            if (config?.metadata) this.addMetadata(config.metadata);
            (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            return this.transition(state);
        }
        async success(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED, config);
        }
        async failure(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED, config);
        }
        async abort(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED, config);
        }
        addMetadata(data) {
            Object.assign(this.metadata, data);
        }
        _handleDoneExperience(data) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
            if (data.state.final) {
                if (this._until !== null) {
                    const { done: done, state: state } = this._until(data);
                    if (done && !this.state.final) this.transition(state);
                }
            }
        }
        async getId() {
            return this.id;
        }
        async exportData() {
            return {
                id: await this.getId(),
                uuid: this.uuid,
                type: this.type,
                schemaVersion: (0, $bbbd8b5766b053fb$export$2295b861f318254a) || 'unknown',
                performanceType: this.performanceType,
                category: this.category,
                state: this.state,
                metadata: {
                    ...this.metadata
                },
                metrics: {
                    ...this.metrics
                },
                children: [
                    ...this.childExperiences
                ],
                result: {
                    success: !!this.state.success,
                    startTime: this.metrics.startTime,
                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                },
                platform: this.config.platform || null,
                pageVisibleState: this.pageVisibleState,
                featureFlags: this.featureFlags,
                isSSROutputAsFMP: this.isSSROutputAsFMP,
                timings: this.timings,
                explicitTimings: this.explicitTimings,
                performanceConfig: this.performanceConfig
            };
        }
        _reset() {
            this.parent = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this._until = this.until ? this.until() : null;
        }
    }
});
const $bbbd8b5766b053fb$export$2295b861f318254a = '0.1.5';
parcelRegister("1vlV8", function(module, exports) {
    $parcel$export(module.exports, "getGlobalEventStream", ()=>$d117cb8be5e8747a$export$6123a44dc2384540);
    $parcel$export(module.exports, "subscribeEvent", ()=>$d117cb8be5e8747a$export$37863216db4b714d);
    $parcel$export(module.exports, "unsubscribeEvent", ()=>$d117cb8be5e8747a$export$ee1a7bd1fc9ea85e);
    $parcel$export(module.exports, "experiencePayloadEvent", ()=>$d117cb8be5e8747a$export$7c957416596ca127);
    var $dCAsn;
    var $blQsS;
    const $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH = 250;
    const $d117cb8be5e8747a$export$6123a44dc2384540 = ()=>{
        if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
            const earlyStream = (()=>{
                const stream = [];
                return {
                    __buffer_only__: true,
                    push: (event)=>{
                        if (stream.length < $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                    },
                    getStream: ()=>stream
                };
            })();
            globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
        }
        return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
    };
    const $d117cb8be5e8747a$export$c1522520b417b066 = (eventStream)=>{
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
            (0, (0, parcelRequire("dCAsn")).ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
            return;
        }
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
    };
    const $d117cb8be5e8747a$export$37863216db4b714d = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).SUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).UNSUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $d117cb8be5e8747a$export$7c957416596ca127 = (data)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
            payload: data
        };
    };
});
parcelRegister("blQsS", function(module, exports) {
    $parcel$export(module.exports, "UFOGlobalEventStreamEventType", ()=>$2d245cff606eb60d$export$96253c35c37cf96b);
    $parcel$export(module.exports, "PageVisibleState", ()=>$2d245cff606eb60d$export$a12c67b37a306b13);
    $parcel$export(module.exports, "SUBSCRIBE_ALL", ()=>$2d245cff606eb60d$export$79bf131685ad41d7);
    $parcel$export(module.exports, "FMP_MARK", ()=>$2d245cff606eb60d$export$9f2bf58999404c75);
    $parcel$export(module.exports, "INLINE_RESPONSE_MARK", ()=>$2d245cff606eb60d$export$837e0f79a8056912);
    var $2d245cff606eb60d$export$96253c35c37cf96b;
    (function(UFOGlobalEventStreamEventType) {
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    })($2d245cff606eb60d$export$96253c35c37cf96b || ($2d245cff606eb60d$export$96253c35c37cf96b = {}));
    var $2d245cff606eb60d$export$a12c67b37a306b13;
    (function(PageVisibleState) {
        PageVisibleState["VISIBLE"] = "visible";
        PageVisibleState["HIDDEN"] = "hidden";
        PageVisibleState["MIXED"] = "mixed";
    })($2d245cff606eb60d$export$a12c67b37a306b13 || ($2d245cff606eb60d$export$a12c67b37a306b13 = {}));
    var $2d245cff606eb60d$export$66b33c055cbb625e;
    (function(PageLoadMetrics) {
        PageLoadMetrics["fmp"] = "fmp";
        PageLoadMetrics["tti"] = "tti";
    })($2d245cff606eb60d$export$66b33c055cbb625e || ($2d245cff606eb60d$export$66b33c055cbb625e = {}));
    var $2d245cff606eb60d$export$3ce489cbe02dc21b;
    (function(PageSegmentLoadMetrics) {
        PageSegmentLoadMetrics["fmp"] = "fmp";
        PageSegmentLoadMetrics["tti"] = "tti";
    })($2d245cff606eb60d$export$3ce489cbe02dc21b || ($2d245cff606eb60d$export$3ce489cbe02dc21b = {}));
    var $2d245cff606eb60d$export$341b330828bd3906;
    (function(InteractionMetrics) {
        InteractionMetrics["response"] = "response";
        InteractionMetrics["result"] = "result";
    })($2d245cff606eb60d$export$341b330828bd3906 || ($2d245cff606eb60d$export$341b330828bd3906 = {}));
    var $2d245cff606eb60d$export$b9b20160f581e4f8;
    (function(CustomMetrics) {
        CustomMetrics["duration"] = "duration";
    })($2d245cff606eb60d$export$b9b20160f581e4f8 || ($2d245cff606eb60d$export$b9b20160f581e4f8 = {}));
    const $2d245cff606eb60d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
    const $2d245cff606eb60d$export$9f2bf58999404c75 = 'fmp';
    const $2d245cff606eb60d$export$837e0f79a8056912 = 'inline-response';
});
parcelRegister("dlucd", function(module, exports) {
    $parcel$export(module.exports, "visibilityChangeObserver", ()=>$46b8336a04974a29$export$13e680397ec8f3eb);
    var $1CRHx;
    class $46b8336a04974a29$var$VisibilityChangeObserver {
        start() {
            if (this.started) return;
            this.started = true;
            document.addEventListener('visibilitychange', this.broadcast);
            if ((0, (0, parcelRequire("1CRHx")).isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
        }
        subscribe(callback) {
            this.observers.push(callback);
        }
        unsubscribe(callback) {
            this.observers = this.observers.filter((fn)=>fn !== callback);
        }
        constructor(){
            this.started = false;
            this.observers = [];
            this.broadcast = ()=>{
                this.observers.forEach((fn)=>fn());
                this.observers = [];
            };
        }
    }
    const $46b8336a04974a29$export$13e680397ec8f3eb = new $46b8336a04974a29$var$VisibilityChangeObserver();
});
parcelRegister("1CRHx", function(module, exports) {
    $parcel$export(module.exports, "isWindowObjectAvailable", ()=>$5d24ea5e24f61a4f$export$15e172712955e18f);
    const $5d24ea5e24f61a4f$export$15e172712955e18f = ()=>{
        return typeof window !== 'undefined';
    };
});
parcelRegister("9tjMO", function(module, exports) {
    $parcel$export(module.exports, "roundPerfNow", ()=>$29608d3bcf65c265$export$5f490af6b2b115cf);
    const $29608d3bcf65c265$export$5f490af6b2b115cf = ()=>~~performance.now();
});
parcelRegister("jZA09", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceState", ()=>$175f7a63840c5fab$export$81b70111112841a0);
    const $175f7a63840c5fab$export$81b70111112841a0 = {
        NOT_STARTED: {
            id: 'NOT_STARTED',
            final: true
        },
        STARTED: {
            id: 'STARTED'
        },
        IN_PROGRESS: {
            id: 'IN_PROGRESS'
        },
        BLOCKED: {
            id: 'BLOCKED'
        },
        RECOVERED: {
            id: 'RECOVERED'
        },
        SUCCEEDED: {
            id: 'SUCCEEDED',
            final: true,
            success: true
        },
        SUCCEEDED_WAITING_FOR_DEPS: {
            id: 'SUCCEEDED_WAITING_FOR_DEPS'
        },
        FAILED: {
            id: 'FAILED',
            final: true
        },
        ABORTED: {
            id: 'ABORTED',
            final: true
        }
    };
});
parcelRegister("hM2B6", function(module, exports) {
    $parcel$export(module.exports, "canTransition", ()=>$6edf4365ea9733d4$export$178881f329fdb81f);
    var $jZA09;
    const $6edf4365ea9733d4$var$UFOStateAvailableTransitions = {
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).NOT_STARTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).RECOVERED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).RECOVERED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ]
    };
    const $6edf4365ea9733d4$export$178881f329fdb81f = (state1, state2)=>{
        return $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id] && $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
    };
});
parcelRegister("7Zbvr", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTypes", ()=>$e40e68027603de60$export$994164cf3ae1cc9a);
    $parcel$export(module.exports, "ExperiencePerformanceTypes", ()=>$e40e68027603de60$export$cc26007c03242fff);
    var $e40e68027603de60$export$994164cf3ae1cc9a;
    (function(ExperienceTypes) {
        ExperienceTypes["Load"] = "load";
        ExperienceTypes["Experience"] = "experience";
        ExperienceTypes["Operation"] = "operation";
    })($e40e68027603de60$export$994164cf3ae1cc9a || ($e40e68027603de60$export$994164cf3ae1cc9a = {}));
    var $e40e68027603de60$export$cc26007c03242fff;
    (function(ExperiencePerformanceTypes) {
        ExperiencePerformanceTypes["PageLoad"] = "page-load";
        ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
        ExperiencePerformanceTypes["InlineResult"] = "inline-result";
        ExperiencePerformanceTypes["Custom"] = "custom";
    })($e40e68027603de60$export$cc26007c03242fff || ($e40e68027603de60$export$cc26007c03242fff = {}));
});
parcelRegister("kaKBF", function(module, exports) {
    $parcel$export(module.exports, "useDispatchAnalytics", ()=>$bbdf588730868cbb$export$5f37699fba0ba807);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $fzJZi;
    const $bbdf588730868cbb$export$5f37699fba0ba807 = (handler)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return {
            dispatchAnalytics: (0, $5uXOq.useMemo)(()=>{
                if (handler) return handler;
                return (payload)=>{
                    createAnalyticsEvent(payload).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
                };
            }, [
                handler,
                createAnalyticsEvent
            ])
        };
    };
});
parcelRegister("7HAq8", function(module, exports) {
    $parcel$export(module.exports, "SmartLinkModalProvider", ()=>$bc735e1cde43eb76$export$bb4eb02a83e1a0f8);
    $parcel$export(module.exports, "useSmartLinkModal", ()=>$bc735e1cde43eb76$export$1fd7f5f21a6d6cb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $lnPiq;
    const $bc735e1cde43eb76$var$FALLBACK_API = {
        open: ()=>{},
        close: ()=>{}
    };
    const $bc735e1cde43eb76$export$f4c0a0f23ba57f8c = (0, ($parcel$interopDefault($5uXOq))).createContext($bc735e1cde43eb76$var$FALLBACK_API);
    const $bc735e1cde43eb76$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
        const [element, setElement] = (0, $5uXOq.useState)(null);
        const api = (0, $5uXOq.useMemo)(()=>({
                open: (modal)=>setElement((0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                        fallback: null
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnPiq")).StopPropagation), null, modal))),
                close: ()=>setElement(null)
            }), []);
        const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
            resetErrorBoundary();
            return null;
        }, []);
        const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($bc735e1cde43eb76$export$f4c0a0f23ba57f8c.Provider, {
            value: api
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            fallbackRender: fallbackRender,
            onReset: onReset
        }, element));
    };
    const $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c);
});
parcelRegister("lnPiq", function(module, exports) {
    $parcel$export(module.exports, "StopPropagation", ()=>$a203465a8c9e0684$export$3e100bc08448f36c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $a203465a8c9e0684$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a203465a8c9e0684$var$styles = {
        name: "g32yti",
        styles: "max-height:0;max-width:0;position:absolute"
    };
    const $a203465a8c9e0684$export$3e100bc08448f36c = ({ children: children })=>{
        const onClick = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
        }, []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $a203465a8c9e0684$var$styles,
            onClick: onClick
        }, children);
    };
});
parcelRegister("kySOC", function(module, exports) {
    $parcel$export(module.exports, "HoverCardComponent", ()=>$3e0a0fbe111efeba$export$e2173dafa6a751bb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $1I7E8;
    var $8dVIb;
    var $3CATS;
    var $kXQmf;
    var $khbkQ;
    var $hjhAz;
    var $5igsJ;
    var $jpjv9;
    var $fqj3r;
    var $hZqF4;
    const $3e0a0fbe111efeba$var$HOVER_CARD_SOURCE = 'smartLinkPreviewHoverCard';
    const $3e0a0fbe111efeba$var$FADE_IN_DELAY = 500;
    const $3e0a0fbe111efeba$var$FADE_OUT_DELAY = 300;
    const $3e0a0fbe111efeba$var$RESOLVE_DELAY = 100;
    const $3e0a0fbe111efeba$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, (0, parcelRequire("hZqF4")).HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions })=>{
        const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $3e0a0fbe111efeba$var$FADE_IN_DELAY;
        const [isOpen, setIsOpen] = (0, ($parcel$interopDefault($5uXOq))).useState(false);
        const fadeOutTimeoutId = (0, $5uXOq.useRef)();
        const fadeInTimeoutId = (0, $5uXOq.useRef)();
        const resolveTimeOutId = (0, $5uXOq.useRef)();
        const mousePos = (0, $5uXOq.useRef)();
        const popupOffset = (0, $5uXOq.useRef)();
        const parentSpan = (0, $5uXOq.useRef)(null);
        const renderers = (0, (0, parcelRequire("khbkQ")).useSmartLinkRenderers)();
        const linkState = (0, (0, parcelRequire("hjhAz")).useSmartCardState)(url);
        const analytics = (0, (0, parcelRequire("kXQmf")).useSmartLinkAnalytics)(url, id);
        const { loadMetadata: loadMetadata } = (0, (0, parcelRequire("3CATS")).useSmartCardActions)(id, url, analytics);
        const setMousePosition = (0, $5uXOq.useCallback)((event)=>{
            if (isOpen && canOpen) return;
            mousePos.current = {
                x: event.clientX,
                y: event.clientY
            };
            if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
                const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
                popupOffset.current = [
                    mousePos.current.x - left + (0, (0, parcelRequire("hZqF4")).CARD_GAP_PX),
                    mousePos.current.y - bottom + (0, (0, parcelRequire("hZqF4")).CARD_GAP_PX)
                ];
            }
        }, [
            canOpen,
            isOpen
        ]);
        const hideCard = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []);
        const initHideCard = (0, $5uXOq.useCallback)(()=>{
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                resolveTimeOutId.current = undefined;
            }
            if (noFadeDelay) hideCard();
            else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $3e0a0fbe111efeba$var$FADE_OUT_DELAY);
        }, [
            hideCard,
            noFadeDelay
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
                if (fadeInTimeoutId.current) {
                    clearTimeout(fadeInTimeoutId.current);
                    fadeInTimeoutId.current = undefined;
                }
                if (resolveTimeOutId.current) {
                    clearTimeout(resolveTimeOutId.current);
                    resolveTimeOutId.current = undefined;
                }
            };
        }, []);
        const initResolve = (0, $5uXOq.useCallback)(()=>{
            const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
            if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
                loadMetadata();
            }, $3e0a0fbe111efeba$var$RESOLVE_DELAY);
        }, [
            linkState.metadataStatus,
            linkState.status,
            loadMetadata
        ]);
        const initShowCard = (0, $5uXOq.useCallback)((event)=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            initResolve();
            setMousePosition(event);
            if (!isOpen && !fadeInTimeoutId.current) {
                if (noFadeDelay) setIsOpen(true);
                else fadeInTimeoutId.current = setTimeout(()=>{
                    setIsOpen(true);
                }, fadeInDelay);
            }
        }, [
            initResolve,
            isOpen,
            setMousePosition,
            noFadeDelay,
            fadeInDelay
        ]);
        const onActionClick = (0, $5uXOq.useCallback)((actionId)=>{
            if (actionId === (0, (0, parcelRequire("8dVIb")).ActionName).PreviewAction || actionId === (0, (0, parcelRequire("8dVIb")).ActionName).AutomationAction) hideCard();
        }, [
            hideCard
        ]);
        const handleChildClick = (0, $5uXOq.useCallback)((e, closeOnClick)=>{
            if (!allowEventPropagation) e.stopPropagation();
            if (closeOnClick) hideCard();
        }, [
            allowEventPropagation,
            hideCard
        ]);
        const onContextMenuClick = (0, $5uXOq.useCallback)((e)=>handleChildClick(e, true), [
            handleChildClick
        ]);
        const onChildClick = (0, $5uXOq.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
            closeOnChildClick,
            handleChildClick
        ]);
        const content = (0, $5uXOq.useCallback)(({ update: update })=>{
            const hoverCardContentProps = {
                onMouseEnter: initShowCard,
                onMouseLeave: initHideCard,
                cardState: linkState,
                onActionClick: onActionClick,
                onResolve: update,
                renderers: renderers,
                actionOptions: actionOptions,
                url: url,
                id: id
            };
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5igsJ")).SmartLinkAnalyticsContext), {
                url: url,
                display: (0, (0, parcelRequire("8dVIb")).CardDisplay).HoverCardPreview,
                id: id,
                source: $3e0a0fbe111efeba$var$HOVER_CARD_SOURCE
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fqj3r")).default), hoverCardContentProps));
        }, [
            initShowCard,
            initHideCard,
            linkState,
            onActionClick,
            renderers,
            actionOptions,
            url,
            id
        ]);
        const trigger = (0, $5uXOq.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                ref: parentSpan
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                ...triggerProps,
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": "hover-card-trigger-wrapper"
            }, children)), [
            children,
            initHideCard,
            initShowCard,
            onChildClick,
            onContextMenuClick,
            setMousePosition
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1I7E8")).default), {
            testId: "hover-card",
            isOpen: isOpen && canOpen,
            onClose: hideCard,
            placement: "bottom-start",
            offset: popupOffset.current,
            autoFocus: false,
            content: content,
            trigger: trigger,
            zIndex: zIndex,
            popupComponent: (0, (0, parcelRequire("jpjv9")).default)
        });
    };
});
parcelRegister("3CATS", function(module, exports) {
    $parcel$export(module.exports, "useSmartCardActions", ()=>$36916caf65c178ae$export$f7c340395f31e832);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    var $2yPrN;
    var $fmdet = parcelRequire("fmdet");
    var $8dVIb;
    var $fgpl1;
    var $iPVbQ;
    var $f22ja;
    const $36916caf65c178ae$export$f7c340395f31e832 = (id, url, analytics)=>{
        const resolveUrl = (0, (0, parcelRequire("f22ja")).default)();
        const invokeClientAction = (0, (0, parcelRequire("iPVbQ")).default)({
            analytics: analytics
        });
        const { store: store } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const { getState: getState, dispatch: dispatch } = store;
        const getSmartLinkState = (0, $5uXOq.useCallback)(()=>{
            const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
                status: (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending
            };
            return {
                details: details,
                status: status,
                metadataStatus: metadataStatus
            };
        }, [
            getState,
            url
        ]);
        const setMetadataStatus = (0, $5uXOq.useCallback)((metadataStatus)=>{
            dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS), {
                url: url
            }, undefined, undefined, metadataStatus));
        }, [
            dispatch,
            url
        ]);
        const resolve = (0, $5uXOq.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
            id,
            resolveUrl,
            url
        ]);
        const register = (0, $5uXOq.useCallback)(()=>{
            const { details: details } = getSmartLinkState();
            if (!details) {
                dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING), {
                    url: url
                }));
                setMetadataStatus('pending');
            }
            return resolve();
        }, [
            getSmartLinkState,
            resolve,
            dispatch,
            url,
            setMetadataStatus
        ]);
        const reload = (0, $5uXOq.useCallback)(()=>{
            const { details: details } = getSmartLinkState();
            const definitionId = (0, (0, parcelRequire("fgpl1")).getDefinitionId)(details);
            if (definitionId) (0, (0, parcelRequire("fgpl1")).getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
            else resolve(url, true);
        }, [
            getSmartLinkState,
            url,
            getState,
            resolve
        ]);
        const loadMetadata = (0, $5uXOq.useCallback)(()=>{
            const { metadataStatus: metadataStatus } = getSmartLinkState();
            if (metadataStatus === undefined) {
                setMetadataStatus('pending');
                return resolve(url, false, true);
            }
        }, [
            getSmartLinkState,
            resolve,
            setMetadataStatus,
            url
        ]);
        const authorize = (0, $5uXOq.useCallback)((appearance)=>{
            const { details: details, status: status } = getSmartLinkState();
            const definitionId = (0, (0, parcelRequire("fgpl1")).getDefinitionId)(details);
            const extensionKey = (0, (0, parcelRequire("fgpl1")).getExtensionKey)(details);
            const services = (0, (0, parcelRequire("fgpl1")).getServices)(details);
            if (status === 'unauthorized') analytics.ui.authEvent({
                display: appearance,
                definitionId: definitionId,
                extensionKey: extensionKey
            });
            if (status === 'forbidden') analytics.ui.authAlternateAccountEvent({
                display: appearance,
                definitionId: definitionId,
                extensionKey: extensionKey
            });
            if (services.length > 0) {
                analytics.screen.authPopupEvent({
                    definitionId: definitionId,
                    extensionKey: extensionKey
                });
                (0, $fmdet.auth)(services[0].url).then(()=>{
                    analytics.track.appAccountConnected({
                        definitionId: definitionId,
                        extensionKey: extensionKey
                    });
                    analytics.operational.connectSucceededEvent({
                        id: id,
                        definitionId: definitionId,
                        extensionKey: extensionKey
                    });
                    reload();
                }, (err)=>{
                    analytics.operational.connectFailedEvent({
                        id: id,
                        definitionId: definitionId,
                        extensionKey: extensionKey,
                        reason: err.type
                    });
                    if (err.type === 'auth_window_closed') analytics.ui.closedAuthEvent({
                        display: appearance,
                        definitionId: definitionId,
                        extensionKey: extensionKey
                    });
                    reload();
                });
            }
        }, [
            getSmartLinkState,
            analytics.ui,
            analytics.screen,
            analytics.track,
            analytics.operational,
            id,
            reload
        ]);
        const invoke = (0, $5uXOq.useCallback)(async (opts, appearance)=>{
            const { key: key, action: action } = opts;
            const source = opts.source || appearance;
            if (opts.type === 'client') return await invokeClientAction({
                actionFn: opts.action.promise,
                actionType: action.type,
                display: source,
                extensionKey: key
            });
        }, [
            invokeClientAction
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                register: register,
                reload: reload,
                authorize: authorize,
                invoke: invoke,
                loadMetadata: loadMetadata
            }), [
            register,
            reload,
            authorize,
            invoke,
            loadMetadata
        ]);
    };
});
parcelRegister("fmdet", function(module, exports) {
    $parcel$export(module.exports, "auth", ()=>$5f3c60ac520535bf$export$73693bad9f5880b0);
    $parcel$export(module.exports, "AuthError", ()=>(parcelRequire("fHui9")).AuthError);
    var $fHui9 = parcelRequire("fHui9");
    var $2sGCH = parcelRequire("2sGCH");
    function $5f3c60ac520535bf$export$73693bad9f5880b0(startUrl, windowFeatures) {
        return new Promise((resolve, reject)=>{
            let authWindow = null;
            let authWindowInterval;
            const handleAuthWindowMessage = (event)=>{
                if (event.source !== authWindow) return;
                const { data: data } = event;
                if (typeof data !== 'object') return;
                switch(data.type){
                    case 'outbound-auth:success':
                        finish();
                        resolve();
                        break;
                    case 'outbound-auth:failure':
                        finish();
                        const errorType = data.errorType.toLowerCase();
                        if ((0, $2sGCH.isOfTypeAuthError)(errorType)) reject(new (0, $fHui9.AuthError)(data.message, errorType));
                        else reject(new (0, $fHui9.AuthError)(data.message));
                        break;
                }
            };
            const handleAuthWindowInterval = ()=>{
                if (authWindow && authWindow.closed) {
                    finish();
                    reject(new (0, $fHui9.AuthError)('The auth window was closed', 'auth_window_closed'));
                }
            };
            const start = ()=>{
                window.addEventListener('message', handleAuthWindowMessage);
                authWindow = window.open(startUrl, startUrl, windowFeatures);
                authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
            };
            const finish = ()=>{
                clearInterval(authWindowInterval);
                window.removeEventListener('message', handleAuthWindowMessage);
                if (authWindow) {
                    authWindow.close();
                    authWindow = null;
                }
            };
            start();
        });
    }
});
parcelRegister("fHui9", function(module, exports) {
    $parcel$export(module.exports, "AuthError", ()=>$39436ca0ebc2906b$export$145273558d58e0ac);
    class $39436ca0ebc2906b$export$145273558d58e0ac extends Error {
        constructor(message, type){
            super(message);
            this.message = message;
            this.type = type;
            this.name = 'AuthError';
            this.type = type;
            this.message = message;
        }
    }
});
parcelRegister("2sGCH", function(module, exports) {
    $parcel$export(module.exports, "isOfTypeAuthError", ()=>$4689bea2fc57183c$export$400e64c8451aa84f);
    const $4689bea2fc57183c$export$400e64c8451aa84f = (inputString)=>{
        return [
            'auth_window_closed',
            'invalid_request',
            'unauthorized_client',
            'access_denied',
            'unsupported_response_type',
            'invalid_scope',
            'server_error',
            'temporarily_unavailable',
            'authclientoauth2.autherror'
        ].includes(inputString);
    };
});
parcelRegister("iPVbQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a560b45251b869c0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $5vDFA;
    var $1VPdD;
    const $a560b45251b869c0$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
    const $a560b45251b869c0$var$useInvokeClientAction = ({ analytics: analytics })=>(0, $5uXOq.useCallback)(async ({ actionType: actionType, actionFn: actionFn, extensionKey: extensionKey, display: display })=>{
            const experienceId = (0, ($parcel$interopDefault($7Jxgt)))();
            const markName = `${experienceId}-${actionType}`;
            (0, parcelRequire("5vDFA")).mark(markName, 'pending');
            try {
                (0, (0, parcelRequire("1VPdD")).startUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId, {
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    invokeType: 'client'
                });
                analytics?.ui.actionClickedEvent({
                    actionType: actionType,
                    display: display
                });
                const result = await actionFn();
                (0, parcelRequire("5vDFA")).mark(markName, 'resolved');
                (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
                analytics?.operational.invokeSucceededEvent({
                    actionType: actionType,
                    display: display
                });
                return result;
            } catch (err) {
                (0, parcelRequire("5vDFA")).mark(markName, 'errored');
                (0, (0, parcelRequire("1VPdD")).failUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
                const reason = typeof err === 'string' ? err : err?.message;
                analytics?.operational.invokeFailedEvent({
                    actionType: actionType,
                    display: display,
                    reason: reason
                });
            }
        }, [
            analytics?.operational,
            analytics?.ui
        ]);
    var $a560b45251b869c0$export$2e2bcd8739ae039 = $a560b45251b869c0$var$useInvokeClientAction;
});
parcelRegister("f22ja", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f48b36e6e5cada34$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    var $8dVIb;
    var $1VPdD;
    var $nb8r1;
    const $f48b36e6e5cada34$var$useResolve = ()=>{
        const { store: store, connections: connections } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const { getState: getState } = store;
        const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, (0, parcelRequire("nb8r1")).default)();
        return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
            const { details: details } = getState()[url] || {
                status: (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending,
                details: undefined
            };
            const hasData = !!(details && details.data);
            if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
            else (0, (0, parcelRequire("1VPdD")).addMetadataToExperience)('smart-link-rendered', id, {
                cached: true
            });
        }, [
            connections.client,
            getState,
            handleResolvedLinkError,
            handleResolvedLinkResponse
        ]);
    };
    var $f48b36e6e5cada34$export$2e2bcd8739ae039 = $f48b36e6e5cada34$var$useResolve;
});
parcelRegister("nb8r1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09545a48e55da9e9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $kECas;
    var $2yPrN;
    var $kDZ6Z;
    var $fiKQs;
    var $8dVIb;
    var $aOsut;
    const $09545a48e55da9e9$var$useResponse = ()=>{
        const { store: store, config: config } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const { getState: getState, dispatch: dispatch } = store;
        const hasAuthFlowSupported = config.authFlow !== 'disabled';
        const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
            dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS), {
                url: url
            }, undefined, undefined, metadataStatus));
        }, [
            dispatch
        ]);
        const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
            const newState = {
                status: (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending,
                details: undefined
            };
            const { details: details } = getState()[url] || newState;
            const hasData = !!(details && details.data);
            if (isMetadataRequest) {
                setMetadataStatus(url, 'errored');
                return;
            }
            if (error.kind === 'fatal') {
                if (hasData) dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED), {
                    url: url
                }, details));
                else {
                    dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_ERROR), {
                        url: url
                    }, details, error));
                    throw error;
                }
            } else if (error.kind === 'auth') dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED), {
                url: url
            }, (0, (0, parcelRequire("aOsut")).getUnauthorizedJsonLd)()));
            else if (error.kind === 'fallback') dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK), {
                url: url
            }, response, error));
            else dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_ERROR), {
                url: url
            }, undefined, error));
        }, [
            getState,
            setMetadataStatus,
            dispatch
        ]);
        const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
            setMetadataStatus(resourceUrl, 'resolved');
            if (isReloading) dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RELOADING), {
                url: resourceUrl
            }, response));
            else dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED), {
                url: resourceUrl
            }, response, undefined, undefined, isMetadataRequest));
        }, [
            setMetadataStatus,
            dispatch
        ]);
        const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
            const hostname = new URL(resourceUrl).hostname;
            const nextStatus = response ? (0, (0, parcelRequire("fiKQs")).getStatus)(response) : 'fatal';
            if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
                handleResolvedLinkError(resourceUrl, new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, (0, $cc6a74b99a201fc4$export$3e81ce851ffda0ad)), response, isMetadataRequest);
                return;
            }
            if (!response || nextStatus === 'fatal') {
                handleResolvedLinkError(resourceUrl, new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, (0, $cc6a74b99a201fc4$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
                return;
            }
            if (isMetadataRequest && nextStatus !== 'resolved') {
                handleResolvedLinkError(resourceUrl, new (0, (0, parcelRequire("kDZ6Z")).APIError)('error', hostname, (0, $cc6a74b99a201fc4$export$338f7d9ccca1975d)), response, isMetadataRequest);
                return;
            }
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
            });
        }, [
            handleResolvedLinkError,
            handleResolvedLinkSuccess,
            hasAuthFlowSupported
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                handleResolvedLinkError: handleResolvedLinkError,
                handleResolvedLinkResponse: handleResolvedLinkResponse
            }), [
            handleResolvedLinkError,
            handleResolvedLinkResponse
        ]);
    };
    var $09545a48e55da9e9$export$2e2bcd8739ae039 = $09545a48e55da9e9$var$useResponse;
});
parcelRegister("aOsut", function(module, exports) {
    $parcel$export(module.exports, "getEmptyJsonLd", ()=>$5dc57cbabb8840da$export$2796a804c6e44f63);
    $parcel$export(module.exports, "getUnauthorizedJsonLd", ()=>$5dc57cbabb8840da$export$b9482e0f6d365cc7);
    $parcel$export(module.exports, "getForbiddenJsonLd", ()=>$5dc57cbabb8840da$export$e32193033a594efb);
    const $5dc57cbabb8840da$var$emptyData = {
        '@context': {
            '@vocab': 'https://www.w3.org/ns/activitystreams#',
            atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
            schema: 'http://schema.org/'
        },
        '@type': 'Object'
    };
    const $5dc57cbabb8840da$export$2796a804c6e44f63 = ()=>$5dc57cbabb8840da$var$emptyData;
    const $5dc57cbabb8840da$export$b9482e0f6d365cc7 = ()=>({
            meta: {
                visibility: 'restricted',
                access: 'unauthorized',
                auth: [],
                definitionId: 'provider-not-found'
            },
            data: {
                ...$5dc57cbabb8840da$var$emptyData
            }
        });
    const $5dc57cbabb8840da$export$e32193033a594efb = ()=>({
            meta: {
                visibility: 'restricted',
                access: 'forbidden',
                auth: [],
                definitionId: 'provider-not-found'
            },
            data: {
                ...$5dc57cbabb8840da$var$emptyData
            }
        });
});
const $cc6a74b99a201fc4$export$297c39c8b9bfca0 = 'resolving';
const $cc6a74b99a201fc4$export$b64a888338c24e0e = 'errored';
const $cc6a74b99a201fc4$export$677b6edfa0002c70 = 'fallback';
const $cc6a74b99a201fc4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cc6a74b99a201fc4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cc6a74b99a201fc4$export$338f7d9ccca1975d = 'Error resolving metadata.';
parcelRegister("khbkQ", function(module, exports) {
    $parcel$export(module.exports, "useSmartLinkRenderers", ()=>$53b108afa53560ee$export$c3514c024fefef57);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    const $53b108afa53560ee$export$c3514c024fefef57 = ()=>{
        const context = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        let renderers = context?.renderers;
        renderers = (0, $5uXOq.useMemo)(()=>renderers, [
            renderers
        ]);
        return renderers;
    };
});
parcelRegister("hjhAz", function(module, exports) {
    $parcel$export(module.exports, "useSmartCardState", ()=>$7fb324870ee27912$export$b0444d00ba7313c6);
    var $bDWQ3 = parcelRequire("bDWQ3");
    var $kECas;
    const $7fb324870ee27912$var$PENDING_STATE = {
        status: 'pending'
    };
    function $7fb324870ee27912$export$b0444d00ba7313c6(url) {
        const { store: store } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
        return cardState ?? $7fb324870ee27912$var$PENDING_STATE;
    }
});
parcelRegister("5igsJ", function(module, exports) {
    $parcel$export(module.exports, "SmartLinkAnalyticsContext", ()=>$31931ec4ffeaf53a$export$eaff10f7ec59c455);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $ffYTp;
    var $hjhAz;
    var $66xOO;
    const $31931ec4ffeaf53a$export$eaff10f7ec59c455 = (props)=>{
        const { children: children, url: url, display: display } = props;
        const { details: details, status: status } = (0, (0, parcelRequire("hjhAz")).useSmartCardState)(url);
        const attributes = (0, (0, parcelRequire("ffYTp")).getResolvedAttributes)({
            url: url
        }, details, status);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("66xOO")).LinkAnalyticsContext), {
            ...props,
            display: display
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                attributes: attributes
            }
        }, children));
    };
});
parcelRegister("ffYTp", function(module, exports) {
    $parcel$export(module.exports, "getResolvedAttributes", ()=>$842bbc6d3f3b5d59$export$7243431f5325a7b);
    var $fiKQs;
    var $iHcpV;
    const $842bbc6d3f3b5d59$export$7243431f5325a7b = (linkDetails, details, linkStatus)=>{
        const status = linkStatus ?? (details && (0, (0, parcelRequire("fiKQs")).getStatus)(details));
        const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, (0, parcelRequire("iHcpV")).getDisplayCategory)(status);
        return {
            status: status ?? null,
            statusDetails: details?.meta?.requestAccess?.accessType ?? null,
            displayCategory: displayCategory,
            extensionKey: details?.meta?.key ?? null,
            destinationTenantId: details?.meta?.tenantId ?? null,
            destinationContainerId: details?.meta?.containerId ?? null,
            destinationCategory: details?.meta?.category ?? null,
            destinationProduct: details?.meta?.product ?? null,
            destinationSubproduct: details?.meta?.subproduct ?? null,
            destinationObjectId: details?.meta?.objectId ?? null,
            destinationObjectType: details?.meta?.resourceType ?? null,
            canBeDatasource: (details?.datasources || []).length > 0
        };
    };
});
parcelRegister("iHcpV", function(module, exports) {
    $parcel$export(module.exports, "getDisplayCategory", ()=>$1a9daeca9ad503b7$export$28ddbae335bd80b5);
    const $1a9daeca9ad503b7$export$28ddbae335bd80b5 = (status)=>{
        return !status || status !== 'not_found' ? 'smartLink' : 'link';
    };
});
parcelRegister("66xOO", function(module, exports) {
    $parcel$export(module.exports, "LinkAnalyticsContext", ()=>$a51765c35bf0b052$export$9458cdec663b9ff1);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    const $a51765c35bf0b052$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
        const displayCategory = display === 'url' ? 'link' : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                source: source,
                attributes: {
                    displayCategory: displayCategory,
                    display: display,
                    id: id
                }
            }
        }, children);
    };
});
parcelRegister("jpjv9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f3866955ba7de81$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    const $0f3866955ba7de81$var$CustomPopupContainer = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...props,
            ref: ref
        }, children));
    var $0f3866955ba7de81$export$2e2bcd8739ae039 = $0f3866955ba7de81$var$CustomPopupContainer;
});
parcelRegister("fqj3r", function(module, exports) {
    $parcel$export(module.exports, "hoverCardClassName", ()=>$d84d865bf5e6c05a$export$34883cbaea18402d);
    $parcel$export(module.exports, "default", ()=>$d84d865bf5e6c05a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2NMNM;
    var $kECas;
    var $8dVIb;
    var $kXQmf;
    var $fgpl1;
    var $hjhAz;
    var $kxcRq;
    var $cnaAy;
    var $g2eZ6;
    var $hZqF4;
    var $8RJLv;
    var $fF5L8;
    var $KTqu4;
    var $6klQO;
    var $g3aqq;
    var $f6jZ5;
    const $d84d865bf5e6c05a$export$34883cbaea18402d = 'smart-links-hover-preview';
    const $d84d865bf5e6c05a$var$HoverCardContent = ({ id: id = '', analytics: _analytics, cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const defaultAnalytics = (0, (0, parcelRequire("kXQmf")).useSmartLinkAnalytics)(url, id);
        const analytics = _analytics ?? defaultAnalytics;
        const extensionKey = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("fgpl1")).getExtensionKey)(cardState.details), [
            cardState.details
        ]);
        const linkState = (0, (0, parcelRequire("hjhAz")).useSmartCardState)(url);
        const linkStatus = linkState.status ?? 'pending';
        const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const isAISummaryEnabled = (0, (0, parcelRequire("cnaAy")).getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
        const services = (0, (0, parcelRequire("fgpl1")).getServices)(linkState.details);
        const statusRef = (0, $5uXOq.useRef)(linkStatus);
        const analyticsRef = (0, $5uXOq.useRef)(analytics);
        (0, $5uXOq.useEffect)(()=>{
            if (analyticsRef.current !== analytics) analyticsRef.current = analytics;
            if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        }, [
            analytics,
            linkStatus
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const previewDisplay = 'card';
            const previewInvokeMethod = 'mouse_hover';
            const cardOpenTime = Date.now();
            analyticsRef.current.ui.hoverCardViewedEvent({
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                status: statusRef.current
            });
            return ()=>{
                const hoverTime = Date.now() - cardOpenTime;
                analyticsRef.current.ui.hoverCardDismissedEvent({
                    previewDisplay: previewDisplay,
                    previewInvokeMethod: previewInvokeMethod,
                    hoverTime: hoverTime,
                    status: statusRef.current
                });
            };
        }, []);
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            const isModifierKeyPressed = (0, (0, parcelRequire("kxcRq")).isSpecialEvent)(event);
            analytics.ui.cardClickedEvent({
                id: id,
                display: (0, (0, parcelRequire("8dVIb")).CardDisplay).HoverCardPreview,
                status: cardState.status,
                isModifierKeyPressed: isModifierKeyPressed,
                actionSubjectId: 'titleGoToLink'
            });
            (0, (0, parcelRequire("g2eZ6")).fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }, [
            createAnalyticsEvent,
            cardState.status,
            analytics.ui,
            id
        ]);
        const data = cardState.details?.data;
        const { subtitle: subtitle } = (0, (0, parcelRequire("8RJLv")).getMetadata)(extensionKey, data);
        const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
        const titleBlockProps = {
            maxLines: titleMaxLines,
            overrideCss: (0, (0, parcelRequire("hZqF4")).titleBlockCss),
            size: (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large,
            position: (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Center,
            subtitle: subtitle
        };
        const flexibleCardProps = {
            appearance: (0, (0, parcelRequire("8dVIb")).CardDisplay).HoverCardPreview,
            cardState: cardState,
            onClick: onClick,
            onResolve: onResolve,
            renderers: renderers,
            actionOptions: actionOptions,
            ui: (0, (0, parcelRequire("hZqF4")).flexibleUiOptions),
            url: url,
            children: null,
            analytics: analytics
        };
        const onClickStopPropagation = (0, $5uXOq.useCallback)((e)=>e.stopPropagation(), []);
        const getCardView = (cardState)=>{
            if (cardState.metadataStatus === 'pending') return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("g3aqq")).default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (cardState.status === 'unauthorized' && services?.length) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f6jZ5")).default), {
                analytics: analytics,
                extensionKey: extensionKey,
                id: id,
                flexibleCardProps: flexibleCardProps,
                url: url
            });
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("KTqu4")).default), {
                flexibleCardProps: flexibleCardProps
            });
            if (cardState.status === 'resolved') return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6klQO")).default), {
                analytics: analytics,
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps,
                url: url
            });
            return null;
        };
        const cardView = getCardView(cardState);
        return cardView ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fF5L8")).default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    };
    var $d84d865bf5e6c05a$export$2e2bcd8739ae039 = $d84d865bf5e6c05a$var$HoverCardContent;
});
parcelRegister("kxcRq", function(module, exports) {
    $parcel$export(module.exports, "isSpecialEvent", ()=>$c53851cced73411d$export$efca2c4705678489);
    $parcel$export(module.exports, "getIconForFileType", ()=>$c53851cced73411d$export$4d685c85ebc7a1e3);
    $parcel$export(module.exports, "getIframeSandboxAttribute", ()=>$c53851cced73411d$export$9b7e6a102056a387);
    $parcel$export(module.exports, "handleOnClick", ()=>$c53851cced73411d$export$ffccab2ae3d093ef);
    $parcel$export(module.exports, "isIntersectionObserverSupported", ()=>$c53851cced73411d$export$6c837641a9ab03cb);
    $parcel$export(module.exports, "importWithRetry", ()=>$c53851cced73411d$export$aacbf48ace518c5a);
    $parcel$export(module.exports, "downloadUrl", ()=>$c53851cced73411d$export$8a96edb1c96563f4);
    $parcel$export(module.exports, "openUrl", ()=>$c53851cced73411d$export$a238cfe4a10e6279);
    $parcel$export(module.exports, "getPreviewUrlWithTheme", ()=>$c53851cced73411d$export$4470f298c61a79da);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $imVhc;
    const $c53851cced73411d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($c53851cced73411d$export$e6c5ffa684aac4d7() || $c53851cced73411d$export$d8de0cd37d316fdf(evt) || $c53851cced73411d$export$5b1771037ab7c451(evt));
    const $c53851cced73411d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
    const $c53851cced73411d$export$d8de0cd37d316fdf = (event)=>event.metaKey || event.ctrlKey;
    const $c53851cced73411d$export$5b1771037ab7c451 = (event)=>event.button === 1;
    const $c53851cced73411d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
        if (!fileMimeType) return;
        let icon = $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
        if (!icon) return;
        const [label, importCb] = icon;
        if (!importCb) return;
        const Icon = (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>importCb().then((module)=>module.default),
            loading: ()=>null
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: label,
            testId: "document-file-format-icon"
        });
    };
    const $c53851cced73411d$export$371bef29a3733127 = (fileMimeType)=>{
        let icon = $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
        if (!icon) return;
        const [label] = icon;
        return label;
    };
    const $c53851cced73411d$var$typeToIcon = {
        'text/plain': [
            'Document',
            ()=>Promise.resolve((parcelRequire("duwKf")))
        ],
        'application/vnd.oasis.opendocument.text': [
            'Document',
            ()=>Promise.resolve((parcelRequire("duwKf")))
        ],
        'application/vnd.apple.pages': [
            'Document',
            ()=>Promise.resolve((parcelRequire("duwKf")))
        ],
        'application/vnd.google-apps.document': [
            'Google Doc',
            ()=>(parcelRequire("jXySI"))
        ],
        'application/msword': [
            'Word document',
            ()=>(parcelRequire("1HfN1"))
        ],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
            'Word document',
            ()=>(parcelRequire("1HfN1"))
        ],
        'application/pdf': [
            'PDF document',
            ()=>(parcelRequire("5GIkh"))
        ],
        'application/vnd.oasis.opendocument.spreadsheet': [
            'Spreadsheet',
            ()=>(parcelRequire("dcnwM"))
        ],
        'application/vnd.apple.numbers': [
            'Spreadsheet',
            ()=>(parcelRequire("dcnwM"))
        ],
        'application/vnd.google-apps.spreadsheet': [
            'Google Sheet',
            ()=>(parcelRequire("5bX2p"))
        ],
        'application/vnd.ms-excel': [
            'Excel spreadsheet',
            ()=>(parcelRequire("asJlG"))
        ],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
            'Excel spreadsheet',
            ()=>(parcelRequire("asJlG"))
        ],
        'application/vnd.oasis.opendocument.presentation': [
            'Presentation',
            ()=>(parcelRequire("dzrUL"))
        ],
        'application/vnd.apple.keynote': [
            'Presentation',
            ()=>(parcelRequire("dzrUL"))
        ],
        'application/vnd.google-apps.presentation': [
            'Google Slide',
            ()=>(parcelRequire("fZksg"))
        ],
        'application/vnd.ms-powerpoint': [
            'PowerPoint presentation',
            ()=>(parcelRequire("jHQ8I"))
        ],
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
            'PowerPoint presentation',
            ()=>(parcelRequire("jHQ8I"))
        ],
        'application/vnd.google-apps.form': [
            'Google Form',
            ()=>(parcelRequire("k7KGr"))
        ],
        'image/png': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/jpeg': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/bmp': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/webp': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/svg+xml': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/gif': [
            'GIF',
            ()=>(parcelRequire("gBOzU"))
        ],
        'audio/midi': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/mpeg': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/webm': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/ogg': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/wav': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'video/mp4': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/quicktime': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/mov': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/webm': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/ogg': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/x-ms-wmv': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/x-msvideo': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'application/zip': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-tar': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-gtar': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-7z-compressed': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-apple-diskimage': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/vnd.rar': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/dmg': [
            'Executable',
            ()=>(parcelRequire("ayRxW"))
        ],
        'text/css': [
            'Source Code',
            ()=>(parcelRequire("boS7Q"))
        ],
        'text/html': [
            'Source Code',
            ()=>(parcelRequire("boS7Q"))
        ],
        'application/javascript': [
            'Source Code',
            ()=>(parcelRequire("boS7Q"))
        ],
        'application/octet-stream': [
            'Binary file',
            ()=>(parcelRequire("5GE4g"))
        ],
        'application/invision.prototype': [
            'Prototype',
            ()=>(parcelRequire("5GE4g"))
        ],
        'application/sketch': [
            'Sketch',
            ()=>(parcelRequire("ktas1"))
        ],
        folder: [
            'Folder',
            ()=>(parcelRequire("2KgZP"))
        ]
    };
    const $c53851cced73411d$export$9b7e6a102056a387 = (isTrusted)=>{
        if (isTrusted) return undefined;
        const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
        return sandboxPermissions;
    };
    const $c53851cced73411d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
            e.preventDefault();
            e.stopPropagation();
            handler();
        };
    const $c53851cced73411d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
    const $c53851cced73411d$export$e772c8ff12451969 = (ms)=>{
        return new Promise((resolve)=>setTimeout(resolve, ms));
    };
    const $c53851cced73411d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
        try {
            return await importFn();
        } catch (error) {
            if (error.name === 'ChunkLoadError' && retries > 0) {
                await $c53851cced73411d$export$e772c8ff12451969(interval);
                return $c53851cced73411d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
            } else throw error;
        }
    };
    const $c53851cced73411d$export$8a96edb1c96563f4 = async (url)=>{
        if (!url) return;
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const iframeName = 'media-download-iframe';
        const link = document.createElement('a');
        let iframe = document.getElementById(iframeName);
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.id = iframeName;
            iframe.name = iframeName;
            document.body.appendChild(iframe);
        }
        link.href = url;
        link.download = url;
        link.target = isIE11 || isSafari ? '_blank' : iframeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const $c53851cced73411d$export$a238cfe4a10e6279 = async (url)=>{
        if (!url) return;
        window.open(url, '_blank', 'noopener=yes');
    };
    const $c53851cced73411d$export$4470f298c61a79da = (previewUrl, themeState)=>{
        try {
            const url = new URL(previewUrl);
            url.searchParams.append('themeState', (0, (0, parcelRequire("imVhc")).themeObjectToString)(themeState));
            return url.href;
        } catch  {
            return previewUrl;
        }
    };
});
parcelRegister("duwKf", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9d277a30a5a98acd$var$Document16Icon = (props)=>$9d277a30a5a98acd$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
        }, props, {
            size: 'small'
        }));
    $9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
    var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;
});
parcelRegister("jXySI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7EgS6").then(()=>parcelRequire('3KifV'));
});
parcelRegister("1HfN1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("erQ4S").then(()=>parcelRequire('im5Hg'));
});
parcelRegister("5GIkh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d767x").then(()=>parcelRequire('5m93C'));
});
parcelRegister("dcnwM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lQ9xE").then(()=>parcelRequire('2Bgv8'));
});
parcelRegister("5bX2p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("izomc").then(()=>parcelRequire('iByEQ'));
});
parcelRegister("asJlG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5I4RC").then(()=>parcelRequire('eABwY'));
});
parcelRegister("dzrUL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iV5W6").then(()=>parcelRequire('h7zk4'));
});
parcelRegister("fZksg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jepjM").then(()=>parcelRequire('F35X1'));
});
parcelRegister("jHQ8I", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3YI2r").then(()=>parcelRequire('kKp2J'));
});
parcelRegister("k7KGr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cwkUf").then(()=>parcelRequire('j8IiS'));
});
parcelRegister("17GQp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hVGrh").then(()=>parcelRequire('daL8e'));
});
parcelRegister("gBOzU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aAton").then(()=>parcelRequire('96Idm'));
});
parcelRegister("2P3xs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iDnD4").then(()=>parcelRequire('dOkKo'));
});
parcelRegister("8Cn4N", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dhQt8").then(()=>parcelRequire('lDRqn'));
});
parcelRegister("1u9rQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7QDLp").then(()=>parcelRequire('8njZH'));
});
parcelRegister("ayRxW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b2yZA").then(()=>parcelRequire('lp0fk'));
});
parcelRegister("boS7Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5khw4").then(()=>parcelRequire('6cEsd'));
});
parcelRegister("5GE4g", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c1Yqk").then(()=>parcelRequire('7BHMh'));
});
parcelRegister("ktas1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a5lMy").then(()=>parcelRequire('lE6mu'));
});
parcelRegister("2KgZP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gaqBx").then(()=>parcelRequire('bBHpS'));
});
parcelRegister("cnaAy", function(module, exports) {
    $parcel$export(module.exports, "getIsAISummaryEnabled", ()=>$3339f41fc1b0dac1$export$d439c74cb206ff29);
    $parcel$export(module.exports, "getAISummaryErrorMessage", ()=>$3339f41fc1b0dac1$export$cd2e891d7f87074d);
    var $8dVIb;
    var $7zaVw;
    const $3339f41fc1b0dac1$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
    const $3339f41fc1b0dac1$export$cd2e891d7f87074d = (error)=>{
        switch(error){
            case 'ACCEPTABLE_USE_VIOLATIONS':
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_acceptable_use_violation,
                    url: (0, (0, parcelRequire("8dVIb")).CONTENT_URL_ACCEPTABLE_USE_POLICY)
                };
            case 'HIPAA_CONTENT_DETECTED':
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_hipaa_content_detected
                };
            case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_exceeding_context_length_error
                };
            default:
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_generic,
                    url: (0, (0, parcelRequire("8dVIb")).CONTENT_URL_AI_TROUBLESHOOTING)
                };
        }
    };
});
parcelRegister("7zaVw", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a298b78183f16654$export$defe85febe8b728c);
    var $7VHMR;
    const $a298b78183f16654$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        actions: {
            id: 'fabric.linking.actions',
            defaultMessage: 'Actions',
            description: ''
        },
        add_account: {
            id: 'fabric.linking.add_account',
            defaultMessage: 'Add account',
            description: 'Allows to add a new account'
        },
        ai_summarize: {
            id: 'fabric.linking.ai_summarize',
            defaultMessage: 'Summarize',
            description: 'Action to summarize link resource content with AI'
        },
        ai_summarized: {
            id: 'fabric.linking.ai_summarized',
            defaultMessage: 'Summarized by Atlassian Intelligence',
            description: 'Shown with the content summarised by AI.'
        },
        ai_summarized_abbreviation: {
            id: 'fabric.linking.ai_summarized_abbreviation',
            defaultMessage: 'Summarized by AI',
            description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
        },
        ai_summarized_info: {
            id: 'fabric.linking.ai_summarized_info',
            defaultMessage: 'Information quality may vary. <a>Learn more</a>',
            description: 'Additional info about the content summarised by AI.'
        },
        ai_summarized_info_short: {
            id: 'fabric.linking.ai_summarized_info_short',
            defaultMessage: 'Content quality may vary',
            description: 'Additional info about the content summarised by AI.'
        },
        ai_summarizing: {
            id: 'fabric.linking.ai_summarizing',
            defaultMessage: 'Atlassian Intelligence is working...',
            description: 'Shown when AI summary is summarising the link resource content.'
        },
        ai_summary_error_generic: {
            id: 'fabric.linking.ai_summary_error_generic',
            defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
            description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
        },
        ai_summary_error_acceptable_use_violation: {
            id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
            defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
            description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
        },
        ai_summary_error_hipaa_content_detected: {
            id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
            defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
            description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
        },
        ai_summary_error_exceeding_context_length_error: {
            id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
            defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
            description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
        },
        assigned_to: {
            id: 'fabric.linking.assigned_to',
            defaultMessage: 'Assigned to {context}',
            description: 'Indicates the person or entity that the resource is assigned to.'
        },
        automation_action_title: {
            id: 'fabric.linking.automation-action.title',
            defaultMessage: 'View automation rules...',
            description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
        },
        automation_action_icon_label: {
            id: 'fabric.linking.automation-action.icon.label',
            defaultMessage: 'Automation icon',
            description: 'The label for the automation icon inside of the button opening the automation menu.'
        },
        automation_action_tooltip: {
            id: 'fabric.linking.automation-action.tooltip',
            defaultMessage: 'Select an automation rule to run',
            description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
        },
        automation_action_confluence_page_modal_title: {
            id: 'fabric.linking.automation-action.confluence.page.modal.title',
            defaultMessage: 'Page automations',
            description: 'The title of the automation modal when the SmartLink is a Confluence page'
        },
        automation_action_confluence_page_modal_description: {
            id: 'fabric.linking.automation-action.confluence.page.modal.description',
            defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
            description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
        },
        cancel: {
            id: 'fabric.linking.cancel',
            defaultMessage: 'Cancel',
            description: 'cancel'
        },
        beta: {
            id: 'fabric.linking.beta',
            defaultMessage: 'Beta',
            description: 'Indicates a beta phase of the feature.'
        },
        cannot_connect: {
            id: 'fabric.linking.cannot_connect',
            defaultMessage: "Can't connect, try again",
            description: 'Error for when a provided link is not found.'
        },
        cannot_find_link: {
            id: 'fabric.linking.cannot_find_link',
            defaultMessage: "Can't find link",
            description: 'Error for when a provided link is not found.'
        },
        click_to_join: {
            id: 'fabric.linking.click_to_join',
            defaultMessage: 'Join {context}',
            description: 'Allows the user join the product or service immediately'
        },
        click_to_join_description: {
            id: 'fabric.linking.click_to_join_description',
            defaultMessage: "You've been approved, so you can join {context} right away.",
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        close: {
            id: 'fabric.linking.close',
            defaultMessage: 'Close',
            description: ''
        },
        check_this_link: {
            id: 'fabric.linking.check_this_link',
            defaultMessage: 'Check this link',
            description: 'Link safety warning modal header'
        },
        connect_to: {
            id: 'fabric.linking.connect_to',
            defaultMessage: 'Connect to {name}',
            description: 'Allows the user to connect with different types of external services'
        },
        connect_account_description: {
            id: 'fabric.linking.connect_account_description',
            defaultMessage: "We'll open a new page to help you connect your {name} account",
            description: 'Explains what will happen when the users connects to a new account'
        },
        connect_link_account: {
            id: 'fabric.linking.connect_link_account',
            defaultMessage: 'Connect to preview',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
        },
        connect_link_account_card: {
            id: 'fabric.linking.connect_link_account_card_view',
            defaultMessage: 'Connect',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
        },
        connect_link_account_card_name: {
            id: 'fabric.linking.connect_link_account_card_view_name',
            defaultMessage: 'Connect your {context} account',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
        },
        connect_link_account_card_description: {
            id: 'fabric.linking.connect_link_account_card_view_description',
            defaultMessage: 'To show a preview of this link, connect your {context} account.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
        },
        connect_unauthorised_account_action: {
            id: 'fabric.linking.connect_unauthorised_account_action',
            defaultMessage: 'Connect to {context}',
            description: 'Shown on a button to connect user external account to their Atlassian account.'
        },
        connect_unauthorised_account_description: {
            id: 'fabric.linking.connect_unauthorised_account_description',
            defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
        },
        connect_unauthorised_account_description_no_provider: {
            id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
            defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
        },
        continue: {
            id: 'fabric.linking.continue',
            defaultMessage: 'Continue',
            description: 'continue'
        },
        copy_url_to_clipboard: {
            id: 'fabric.linking.copy_url_to_clipboard',
            defaultMessage: 'Copy link',
            description: ''
        },
        copied_url_to_clipboard: {
            id: 'fabric.linking.copied_url_to_clipboard',
            defaultMessage: 'Copied!',
            description: 'Url has been copied to the clipboard'
        },
        could_not_load_link: {
            id: 'fabric.linking.couldnt_load_link',
            defaultMessage: "We couldn't load this link for an unknown reason.",
            description: 'Error case for card view - link could not be loaded.'
        },
        created_by: {
            id: 'fabric.linking.created_by',
            defaultMessage: 'Created by {context}',
            description: 'Indicates the person or entity that created the resource.'
        },
        created_on_relative: {
            id: 'fabric.linking.create_on_relative',
            defaultMessage: 'Created {context}',
            description: 'Indicated when entity was created (relative form)'
        },
        created_on_absolute: {
            id: 'fabric.linking.create_on_absolute',
            defaultMessage: 'Created on {context}',
            description: 'Indicated when entity was created (absolute form)'
        },
        delete: {
            id: 'fabric.linking.delete',
            defaultMessage: 'Delete',
            description: 'Allow a user to delete a link'
        },
        download: {
            id: 'fabric.linking.download',
            defaultMessage: 'Download',
            description: ''
        },
        download_description: {
            id: 'fabric.linking.download_description',
            defaultMessage: 'Download this file into your local storage',
            description: 'Description on what Download does'
        },
        download_file: {
            id: 'fabric.linking.download_file',
            defaultMessage: 'Download file',
            description: 'Allow a user to download a file'
        },
        ai_summary_action: {
            id: 'fabric.linking.ai_summary_action',
            defaultMessage: 'Summarize with AI',
            description: 'Allow a user to summarize a link'
        },
        ai_summary_action_description: {
            id: 'fabric.linking.ai_summary_action_description',
            defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
            description: 'Description of what the summarize link with AI action does'
        },
        copy_summary_action: {
            id: 'fabric.linking.copy_summary_action',
            defaultMessage: 'Copy summary',
            description: 'Allow a user to copy a generated summary'
        },
        copy_summary_action_description: {
            id: 'fabric.linking.copy_summary_action_description',
            defaultMessage: 'Copy summary',
            description: 'Description of what the copy summary AI action does'
        },
        copied_summary_action_description: {
            id: 'fabric.linking.copied_summary_action_description',
            defaultMessage: 'Copied summary to clipboard',
            description: 'Confirmation to the user that the summry has been copied'
        },
        edit: {
            id: 'fabric.linking.edit',
            defaultMessage: 'Edit',
            description: 'Allow a user to edit a link'
        },
        follow: {
            id: 'fabric.linking.follow',
            defaultMessage: 'Follow',
            description: 'Click to follow a project.'
        },
        follow_project_description: {
            id: 'fabric.linking.follow_project_description',
            defaultMessage: 'Follow to get notifications on this project',
            description: 'Description on what Follow does'
        },
        follow_project: {
            id: 'fabric.linking.follow_project',
            defaultMessage: 'Follow project',
            description: 'Click to follow a project.'
        },
        follow_project_error: {
            id: 'fabric.linking.follow_project_error',
            defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when following an Atlas project'
        },
        follow_goal_description: {
            id: 'fabric.linking.follow_goal_description',
            defaultMessage: 'Follow this goal to get notifications on updates',
            description: 'Description on what Follow does'
        },
        follow_goal: {
            id: 'fabric.linking.follow_goal',
            defaultMessage: 'Follow goal',
            description: 'Click to follow a project.'
        },
        follow_goal_error: {
            id: 'fabric.linking.follow_goal_error',
            defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when following an Atlas goal'
        },
        go_back: {
            id: 'fabric.linking.go_back',
            defaultMessage: 'Go back',
            description: 'go back'
        },
        invalid_permissions: {
            id: 'fabric.linking.invalid_permissions',
            defaultMessage: 'Restricted content',
            description: 'Message shown when a user does not have permissions to view an item'
        },
        invalid_permissions_description: {
            id: 'fabric.linking.invalid_permissions_description',
            defaultMessage: "You'll need to request access or try a different account to view this preview.",
            description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
        },
        join_to_view: {
            id: 'fabric.linking.join_to_view',
            defaultMessage: 'Join {context} to view this issue',
            description: 'Allows the user join the product or service immediately'
        },
        learn_more_about_smart_links: {
            id: 'fabric.linking.learn_more_about_smart_links',
            defaultMessage: 'Learn more about Smart Links.',
            description: 'An anchor link to redirect user to a page about Smart Links.'
        },
        learn_more_about_connecting_account: {
            id: 'fabric.linking.learn_more_about_connecting_account',
            defaultMessage: 'Learn more about connecting your account to Atlassian products.',
            description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
        },
        loading: {
            id: 'fabric.linking.loading',
            defaultMessage: 'Loading...',
            description: 'Indicates an element on a page is loading.'
        },
        modified_by: {
            id: 'fabric.linking.updated_by',
            defaultMessage: 'Modified by {context}',
            description: 'Indicates the person or entity that modified the resource.'
        },
        modified_on_relative: {
            id: 'fabric.linking.modified_on_relative',
            defaultMessage: 'Updated {context}',
            description: 'Indicated when entity was modified (relative form)'
        },
        modified_on_absolute: {
            id: 'fabric.linking.modified_on_absolute',
            defaultMessage: 'Updated on {context}',
            description: 'Indicated when entity was modified (absolute form)'
        },
        more_actions: {
            id: 'fabric.linking.more_actions',
            defaultMessage: 'More actions',
            description: 'Allows the users to see more link actions'
        },
        open_issue_in_jira: {
            id: 'fabric.linking.open_issue_in_jira',
            defaultMessage: 'Open issue in Jira',
            description: 'Click to open link in Jira'
        },
        open_link_in_a_new_tab: {
            id: 'fabric.linking.open_link_in_a_new_tab',
            defaultMessage: 'Open link in a new tab',
            description: 'Click to open link in a new tab'
        },
        owned_by: {
            id: 'fabric.linking.owned_by',
            defaultMessage: 'Owned by {context}',
            description: 'Indicates the person or entity that owns or maintains the resource.'
        },
        preview_description: {
            id: 'fabric.linking.preview_description',
            defaultMessage: 'Open a full screen preview of this link',
            description: 'Description on what Preview does'
        },
        preview_improved: {
            id: 'fabric.linking.preview_improved',
            defaultMessage: 'Open preview',
            description: 'Click to view a richer view of your content, without needing to navigate to it.'
        },
        preview_close: {
            id: 'fabric.linking.preview_close',
            defaultMessage: 'Close preview',
            description: 'Click to close embed preview modal.'
        },
        preview_max_size: {
            id: 'fabric.linking.preview_max_size',
            defaultMessage: 'View full screen',
            description: 'Click to increase embed preview modal size to a maximum viewing size.'
        },
        preview_min_size: {
            id: 'fabric.linking.preview_min_size',
            defaultMessage: 'Close full screen',
            description: 'Click to decrease embed preview modal size to a minimum viewing size.'
        },
        priority_blocker: {
            id: 'fabric.linking.priority_blocker',
            defaultMessage: 'Blocker',
            description: 'Indicated priority as blocker'
        },
        priority_critical: {
            id: 'fabric.linking.priority_critical',
            defaultMessage: 'Critical',
            description: 'Indicated priority as critical'
        },
        priority_high: {
            id: 'fabric.linking.priority_high',
            defaultMessage: 'High',
            description: 'Indicated priority as high'
        },
        priority_highest: {
            id: 'fabric.linking.priority_highest',
            defaultMessage: 'Highest',
            description: 'Indicated priority as highest'
        },
        priority_low: {
            id: 'fabric.linking.priority_low',
            defaultMessage: 'Low',
            description: 'Indicated priority as low'
        },
        priority_lowest: {
            id: 'fabric.linking.priority_lowest',
            defaultMessage: 'Lowest',
            description: 'Indicated priority as lowest'
        },
        priority_major: {
            id: 'fabric.linking.priority_major',
            defaultMessage: 'Major',
            description: 'Indicated priority as major'
        },
        priority_medium: {
            id: 'fabric.linking.priority_medium',
            defaultMessage: 'Medium',
            description: 'Indicated priority as medium'
        },
        priority_minor: {
            id: 'fabric.linking.priority_minor',
            defaultMessage: 'Minor',
            description: 'Indicated priority as minor'
        },
        priority_trivial: {
            id: 'fabric.linking.priority_trivial',
            defaultMessage: 'Trivial',
            description: 'Indicated priority as trivial'
        },
        priority_undefined: {
            id: 'fabric.linking.priority_undefined',
            defaultMessage: 'Undefined',
            description: 'Indicated priority as unknown'
        },
        forbidden_access: {
            id: 'fabric.linking.forbidden_access',
            defaultMessage: 'Your access is forbidden',
            description: 'Shown when a user does not have access to a resource behind the link.'
        },
        pending_request: {
            id: 'fabric.linking.pending_request',
            defaultMessage: 'Your access request is pending',
            description: 'Shown when a user has requested an access but status is pending.'
        },
        read_time: {
            id: 'fabric.linking.read_time',
            defaultMessage: '{context} min read',
            description: 'Estimated time to read this resource'
        },
        restricted_link: {
            id: 'fabric.linking.restricted_link',
            defaultMessage: 'Restricted link, try another account',
            description: 'Message shown when a user does not have permissions to view an item'
        },
        request_access_to_view: {
            id: 'fabric.linking.request_access_to_view',
            defaultMessage: 'Request access to {context} to view this issue',
            description: 'Allows the user to request access to a product or service'
        },
        request_denied: {
            id: 'fabric.linking.request_denied',
            defaultMessage: 'Your access request was denied',
            description: 'The user had request access but the request was denied by a product or service'
        },
        retry: {
            id: 'fabric.linking.retry',
            defaultMessage: 'Retry',
            description: 'Allows user to perform an action again'
        },
        save: {
            id: 'fabric.linking.save',
            defaultMessage: 'Save',
            description: 'Just the "save" word'
        },
        sent_on_relative: {
            id: 'fabric.linking.sent_on_relative',
            defaultMessage: 'Sent {context}',
            description: 'Indicated when entity was sent (relative form)'
        },
        sent_on_absolute: {
            id: 'fabric.linking.sent_on_absolute',
            defaultMessage: 'Sent on {context}',
            description: 'Indicated when entity was sent (absolute form)'
        },
        status_change_load_error: {
            id: 'fabric.linking.status_change_load_error',
            defaultMessage: "We couldn\u2019t load the statuses and transitions",
            description: 'Informs the user that the loading of status transitions failed'
        },
        status_change_permission_error: {
            id: 'fabric.linking.status_change_permission_error',
            defaultMessage: "You don\u2019t have permission to transition this issue. ",
            description: 'Informs the user that they do not have enough permissions to update a status'
        },
        status_change_update_error: {
            id: 'fabric.linking.status_change_update_error',
            defaultMessage: "We couldn\u2019t update the status",
            description: "Occurs when a user tries to update an issue's status but fails to do so"
        },
        try_again: {
            id: 'fabric.linking.try_again',
            defaultMessage: 'Try again',
            description: 'Allow the user to try an action again'
        },
        try_another_account: {
            id: 'fabric.linking.try_another_account',
            defaultMessage: 'Try another account',
            description: 'Allows the user to try an action again with a different account'
        },
        link_safety_warning_message: {
            id: 'fabric.linking.link_safety_warning_message',
            defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
            description: 'Link safety check warning message'
        },
        unauthorised_account_description: {
            id: 'fabric.linking.unauthorised_account_description',
            defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
            description: 'Explains that user does not have access to a link.'
        },
        unauthorised_account_description_no_provider: {
            id: 'fabric.linking.unauthorised_account_description_no_provider',
            defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
            description: 'Explains that user does not have access to a link.'
        },
        unauthorised_account_name: {
            id: 'fabric.linking.unauthorised_account_name',
            defaultMessage: "We can't display private pages from {context}",
            description: 'Shown when a user does not have access to a link.'
        },
        unauthorised_account_name_no_provider: {
            id: 'fabric.linking.unauthorised_account_name_no_provider',
            defaultMessage: "We can't display private pages",
            description: 'Shown when a user does not have access to a link.'
        },
        unassigned: {
            id: 'fabric.linking.unassigned',
            defaultMessage: 'Unassigned',
            description: 'Shown as a tooltip text for a default unassigned fallback avatar'
        },
        unfollow: {
            id: 'fabric.linking.unfollow',
            defaultMessage: 'Unfollow',
            description: 'Click to unfollow a project.'
        },
        unfollow_project_description: {
            id: 'fabric.linking.unfollow_project_description',
            defaultMessage: 'Unfollow to stop receiving project notifications',
            description: 'Description on what Unfollow does'
        },
        unfollow_project: {
            id: 'fabric.linking.unfollow_project',
            defaultMessage: 'Unfollow project',
            description: 'Click to unfollow a project.'
        },
        unfollow_project_error: {
            id: 'fabric.linking.unfollow_project_error',
            defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
        },
        unfollow_goal_description: {
            id: 'fabric.linking.unfollow_goal_description',
            defaultMessage: 'Unfollow to stop receiving notifications for this goal',
            description: 'Description on what Unfollow does'
        },
        unfollow_goal: {
            id: 'fabric.linking.unfollow_goal',
            defaultMessage: 'Unfollow goal',
            description: 'Click to unfollow a project.'
        },
        unfollow_goal_error: {
            id: 'fabric.linking.unfollow_goal_error',
            defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
        },
        unlink_account: {
            id: 'fabric.linking.unlink_account',
            defaultMessage: 'Unlink Account',
            description: 'Allows to remove a connected account from the user'
        },
        view: {
            id: 'fabric.linking.view',
            defaultMessage: 'View',
            description: 'Go through to a piece of content to view it in its original context.'
        },
        viewIn: {
            id: 'fabric.linking.srclink',
            defaultMessage: 'View in',
            description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
        },
        viewOriginal: {
            id: 'fabric.linking.srclinkunknown',
            defaultMessage: 'View Original',
            description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
        },
        default_no_access_title: {
            id: 'fabric.linking.no_access_title',
            defaultMessage: 'Join {product} to view this content',
            description: 'Informs the user that they dont have access to certain content'
        },
        direct_access_title: {
            id: 'fabric.linking.direct_access_title',
            defaultMessage: 'Join {product} to view this content',
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        direct_access_description: {
            id: 'fabric.linking.direct_access_description',
            defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        direct_access: {
            id: 'fabric.linking.direct_access',
            defaultMessage: 'Join now',
            description: 'Allows the user join the product or service immediately'
        },
        request_access_description: {
            id: 'fabric.linking.request_access_description',
            defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
            description: 'Informs the user to request access to a product by talking to the website administrator'
        },
        request_access: {
            id: 'fabric.linking.request_access',
            defaultMessage: 'Request access',
            description: 'Allows the user to request access to a product or service'
        },
        request_access_pending_title: {
            id: 'fabric.linking.request_access_pending_title',
            defaultMessage: 'Access to {product} is pending',
            description: 'Informs the user that their request to view this content is pending'
        },
        request_access_pending_description: {
            id: 'fabric.linking.request_access_pending_description',
            defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
            description: 'Informs the user that their request to view this content is pending website administrator approval'
        },
        request_access_pending: {
            id: 'fabric.linking.request_access_pending',
            defaultMessage: 'Pending approval',
            description: 'Informs the user that their request to view this content is pending'
        },
        request_denied_description: {
            id: 'fabric.linking.request_denied_description',
            defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
            description: 'Informs the user that their request to view this content was denied'
        },
        access_exists_description: {
            id: 'fabric.linking.access_exists_description',
            defaultMessage: 'Request access to view this content from {hostname}.',
            description: 'Informs the user to contact the website administrator to request access to a product'
        },
        not_found_description: {
            id: 'fabric.linking.not_found_description',
            defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
            description: 'Error case for when a provided item is not found within the list of items'
        },
        not_found_title: {
            id: 'fabric.linking.not_found_title',
            defaultMessage: "We can't show you this {product} page",
            description: 'Error case for when a provided link is not found'
        },
        forbidden_title: {
            id: 'fabric.linking.forbidden_title',
            defaultMessage: "You don't have access to this content",
            description: 'Informs the user that they do not have access to the linked content.'
        },
        forbidden_description: {
            id: 'fabric.linking.forbidden_description',
            defaultMessage: 'Contact your admin to request access to {hostname}.',
            description: 'Informs the user that they must contact the site administrator for access.'
        },
        related_work_items_not_found: {
            id: 'fabric.linking.related_work_items_not_found',
            defaultMessage: 'This link is not mentioned anywhere else.',
            description: 'Informs the user that there are no related resources for a given url'
        },
        last_mentioned_in: {
            id: 'fabric.linking.last_mentioned_in',
            defaultMessage: 'Last mentioned in',
            description: 'Informs the user about where the resource was last mentioned in'
        },
        related: {
            id: 'fabric.linking.related',
            defaultMessage: 'Related',
            description: 'Informs the user about related resources'
        },
        generic_error_message: {
            id: 'fabric.linking.generic_error_message',
            defaultMessage: 'An error occurred',
            description: 'A generic error message to the user'
        },
        related_links_modal_title: {
            id: 'fabric.linking.related_links_modal_title',
            defaultMessage: 'Recent links',
            description: 'Shown as the title for the related links modal'
        },
        related_links_view_related_urls: {
            id: 'fabric.linking.related_links_view_related_urls.nonfinal',
            defaultMessage: 'View recent links...',
            description: 'Action to view related links to the given resource'
        },
        related_links_found_in: {
            id: 'fabric.linking.related_links_found_in',
            defaultMessage: 'Found In',
            description: 'Informs the user of the resources are found in the given url'
        },
        related_links_not_found: {
            id: 'fabric.linking.related_links_not_found',
            defaultMessage: "We didn't find any links to show here.",
            description: 'Informs the user that there are no related resources for the given url'
        },
        related_links_includes_links_to: {
            id: 'fabric.linking.related_links_includes_links_to',
            defaultMessage: 'Includes Links To',
            description: 'Informs the user of the resources the url links to'
        },
        related_links_modal_error_header: {
            id: 'fabric.linking.related_links_modal_error_header',
            defaultMessage: 'Something went wrong',
            description: 'Title for related links error'
        },
        related_links_modal_error_message: {
            id: 'fabric.linking.related_links_modal_error_message',
            defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
            description: 'Informs the user that there was a problem loading related links'
        },
        related_links_modal_unavailable_header: {
            id: 'fabric.linking.related_links_modal_unavailable_header',
            defaultMessage: 'No recent links',
            description: 'Title for related links being unavailable'
        },
        related_links_modal_unavailable_message: {
            id: 'fabric.linking.related_links_modal_unavailable_message',
            defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
            description: 'Informs the user that related links were not found but may be available in the future'
        }
    });
});
parcelRegister("g2eZ6", function(module, exports) {
    $parcel$export(module.exports, "fireLinkClickedEvent", ()=>$473b45d487f9fd1b$export$7987de3055fbdcb0);
    $parcel$export(module.exports, "withLinkClickedEvent", ()=>$473b45d487f9fd1b$export$263352d59c0c5966);
    var $5uXOq = parcelRequire("5uXOq");
    var $b6uPu;
    var $4URMI;
    var $fzJZi;
    const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
        [
            undefined,
            'none'
        ],
        [
            0,
            'left'
        ],
        [
            1,
            'middle'
        ],
        [
            2,
            'right'
        ]
    ]);
    const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
        return [
            'alt',
            'ctrl',
            'meta',
            'shift'
        ].filter((key)=>e[`${key}Key`] === true);
    };
    const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
        return el instanceof HTMLElement && el.isContentEditable;
    };
    function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
        const { mac: mac, safari: safari } = (0, (0, parcelRequire("b6uPu")).browser)();
        if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
            'left',
            'middle'
        ].includes(clickType)) return 'contentEditable';
        switch(clickType){
            case 'left':
            case 'keyboard':
                {
                    if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                    if (e.shiftKey) {
                        if (safari) return 'alt';
                        return 'clickThroughNewTabOrWindow';
                    }
                    if (e.ctrlKey) {
                        if (mac) return 'clickThrough';
                        return 'clickThroughNewTabOrWindow';
                    }
                    if (e.altKey) return 'alt';
                    const target = e.currentTarget.getAttribute('target');
                    if (target === '_blank') return 'clickThroughNewTabOrWindow';
                    return 'clickThrough';
                }
            case 'middle':
                return 'clickThroughNewTabOrWindow';
            case 'right':
                return 'contextMenu';
        }
        return 'unknown';
    }
    const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
            action: 'clicked',
            actionSubject: 'link',
            eventType: 'ui',
            attributes: {
                clickType: clickType,
                clickOutcome: clickOutcome,
                keysHeld: keysHeld,
                defaultPrevented: defaultPrevented
            }
        });
    const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
        const isKeyboard = event.nativeEvent.detail === 0;
        const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
        if (!clickType) return;
        const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
        const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
        const defaultPrevented = event.defaultPrevented;
        return $473b45d487f9fd1b$var$linkClickedEvent({
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        });
    };
    const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
            const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
            if (payload) createAnalyticsEvent({
                ...payload,
                ...overrides,
                attributes: {
                    ...payload.attributes,
                    ...overrides?.attributes
                }
            }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
        };
    const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
        if (typeof WrappedComponent === 'string') return WrappedComponent;
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    };
    function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
        const Component = (props)=>{
            const onClick = (0, (0, parcelRequire("4URMI")).useLinkClicked)(props.onClick);
            const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)(props.onMouseDown);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                onClick: onClick,
                onMouseDown: onMouseDown
            });
        };
        Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
        return Component;
    }
});
parcelRegister("b6uPu", function(module, exports) {
    $parcel$export(module.exports, "browser", ()=>$7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
    const $7f7209ce5c1e8d08$var$result = {
        mac: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    if (typeof navigator !== 'undefined') {
        const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
        const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
        const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
        let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
        $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
        $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
        $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
        $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
        $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
    }
    function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
        return $7f7209ce5c1e8d08$var$result;
    }
});
parcelRegister("4URMI", function(module, exports) {
    $parcel$export(module.exports, "useLinkClicked", ()=>$0d5ea96be37e2b5d$export$5993d3ca6c85f774);
    $parcel$export(module.exports, "useMouseDownEvent", ()=>$0d5ea96be37e2b5d$export$df67f318ded0283c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $g2eZ6;
    var $0d5ea96be37e2b5d$export$81a5b494baf0f17c;
    (function(ClickButton) {
        ClickButton[ClickButton["Left"] = 0] = "Left";
        ClickButton[ClickButton["Middle"] = 1] = "Middle";
        ClickButton[ClickButton["Right"] = 2] = "Right";
    })($0d5ea96be37e2b5d$export$81a5b494baf0f17c || ($0d5ea96be37e2b5d$export$81a5b494baf0f17c = {}));
    const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (handler, predicate)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)((...args)=>{
            const [event] = args;
            handler?.apply(null, args);
            if (!predicate || predicate?.(event)) (0, (0, parcelRequire("g2eZ6")).fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }, [
            handler,
            predicate,
            createAnalyticsEvent
        ]);
    };
    const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
    const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
        return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
    };
});
parcelRegister("hZqF4", function(module, exports) {
    $parcel$export(module.exports, "HOVER_CARD_Z_INDEX", ()=>$c1c4917a58eea345$export$8245b0eaabf3440c);
    $parcel$export(module.exports, "flexibleUiOptions", ()=>$c1c4917a58eea345$export$8e022b7269e8199a);
    $parcel$export(module.exports, "CARD_WIDTH_REM", ()=>$c1c4917a58eea345$export$a0a37c997fbcd678);
    $parcel$export(module.exports, "CARD_GAP_PX", ()=>$c1c4917a58eea345$export$e7cae8c75d768024);
    $parcel$export(module.exports, "separatorCss", ()=>$c1c4917a58eea345$export$a967860c7ee2c3e1);
    $parcel$export(module.exports, "HoverCardContainer", ()=>$c1c4917a58eea345$export$f57be4bd7a4d32ec);
    $parcel$export(module.exports, "titleBlockCss", ()=>$c1c4917a58eea345$export$ec02d9e26e1aed66);
    $parcel$export(module.exports, "getTransitionStyles", ()=>$c1c4917a58eea345$export$cfbcd9a4c0ed32ac);
    $parcel$export(module.exports, "popupContainerStyles", ()=>$c1c4917a58eea345$export$40ef6bd85f8ebb71);
    $parcel$export(module.exports, "getPreviewBlockStyles", ()=>$c1c4917a58eea345$export$190eda52f0eac4c);
    var $f8Sb3;
    var $k5uoT;
    var $8dVIb;
    function $c1c4917a58eea345$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c1c4917a58eea345$export$8245b0eaabf3440c = (0, (0, parcelRequire("k5uoT")).layers).modal();
    const $c1c4917a58eea345$export$8e022b7269e8199a = {
        hideBackground: true,
        hideElevation: true,
        size: (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium,
        zIndex: $c1c4917a58eea345$export$8245b0eaabf3440c + 1
    };
    const $c1c4917a58eea345$export$a0a37c997fbcd678 = 24;
    const $c1c4917a58eea345$export$337e78d5d001376e = 25;
    const $c1c4917a58eea345$export$e7cae8c75d768024 = 10;
    const $c1c4917a58eea345$var$blockGap = '0.5rem';
    const $c1c4917a58eea345$var$elementGap = '0.5rem';
    const $c1c4917a58eea345$export$a967860c7ee2c3e1 = (0, (0, parcelRequire("f8Sb3")).css)({
        '[data-separator] + [data-separator]:before': {
            marginRight: $c1c4917a58eea345$var$elementGap
        }
    });
    const $c1c4917a58eea345$export$f57be4bd7a4d32ec = (0, (0, parcelRequire("f8Sb3")).css)("background:none;border-width:0;box-sizing:border-box;width:", $c1c4917a58eea345$export$337e78d5d001376e, "rem;.", (0, $b18b5009ce608fe8$export$4b2b7d155f69aed4), "{display:none;}");
    const $c1c4917a58eea345$export$ec02d9e26e1aed66 = (0, (0, parcelRequire("f8Sb3")).css)("gap:", $c1c4917a58eea345$var$blockGap, ";", $c1c4917a58eea345$export$a967860c7ee2c3e1, "[data-smart-element-group]{gap:0.06rem;display:flex;>[data-smart-element-group]{>span{margin-right:", $c1c4917a58eea345$var$elementGap, ";}}}[data-smart-element='Title']{font-weight:600;}");
    const $c1c4917a58eea345$export$cfbcd9a4c0ed32ac = (snippetHeight)=>(0, (0, parcelRequire("f8Sb3")).css)({
            transition: 'height 300ms ease-in-out',
            height: `${snippetHeight}px`
        });
    const $c1c4917a58eea345$export$40ef6bd85f8ebb71 = {
        name: "kq493r",
        styles: "border-radius:var(--ds-border-radius-200, 8px);background-color:var(--ds-surface-overlay, white);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31))"
    };
    const $c1c4917a58eea345$export$190eda52f0eac4c = (previewHeight)=>(0, (0, parcelRequire("f8Sb3")).css)(previewHeight ? `height: ${previewHeight}px;` : '', {
            borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
            borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
            marginBottom: $c1c4917a58eea345$var$blockGap
        });
});
const $b18b5009ce608fe8$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';
parcelRegister("8RJLv", function(module, exports) {
    $parcel$export(module.exports, "getMetadata", ()=>$575ef03a4633fd6f$export$8548546c0aa631e6);
    var $FcDCF;
    var $8dVIb;
    var $6N2TY;
    const $575ef03a4633fd6f$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
        const types = data ? (0, (0, parcelRequire("FcDCF")).extractType)(data) : undefined;
        const defaultMetadata = {
            primary: [
                (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup,
                (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn
            ]
        };
        switch(extensionKey){
            case 'bitbucket-object-provider':
            case 'native-bitbucket-object-provider':
                if (types?.includes('atlassian:SourceCodePullRequest')) return {
                    primary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup,
                        (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn,
                        (0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount,
                        (0, (0, parcelRequire("8dVIb")).ElementName).State
                    ],
                    subtitle: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch,
                        (0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch
                    ]
                };
                if (types?.includes('schema:DigitalDocument')) return {
                    primary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit,
                        (0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup,
                        (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn
                    ]
                };
                return {
                    primary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup,
                        (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn
                    ]
                };
            case 'confluence-object-provider':
                const primaryAttribution = data && (0, (0, parcelRequire("6N2TY")).extractOwnedBy)(data) ? (0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup : (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup;
                return {
                    primary: [
                        primaryAttribution,
                        (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn
                    ],
                    tertiary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).ReactCount,
                        (0, (0, parcelRequire("8dVIb")).ElementName).CommentCount,
                        (0, (0, parcelRequire("8dVIb")).ElementName).ViewCount
                    ]
                };
            case 'jira-object-provider':
                const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
                return {
                    ...defaultMetadata,
                    ...isJiraTask && {
                        primary: [
                            (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup,
                            (0, (0, parcelRequire("8dVIb")).ElementName).State,
                            (0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints,
                            (0, (0, parcelRequire("8dVIb")).ElementName).Priority
                        ]
                    }
                };
            case 'trello-object-provider':
                return {
                    primary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup,
                        (0, (0, parcelRequire("8dVIb")).ElementName).State,
                        (0, (0, parcelRequire("8dVIb")).ElementName).DueOn
                    ],
                    secondary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).ReactCount,
                        (0, (0, parcelRequire("8dVIb")).ElementName).CommentCount,
                        (0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount,
                        (0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress
                    ],
                    subtitle: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).Location
                    ]
                };
            case 'watermelon-object-provider':
                if (types?.includes('atlassian:Project')) return {
                    primary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup,
                        (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn,
                        (0, (0, parcelRequire("8dVIb")).ElementName).State,
                        (0, (0, parcelRequire("8dVIb")).ElementName).DueOn
                    ]
                };
                return {
                    primary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup,
                        (0, (0, parcelRequire("8dVIb")).ElementName).State,
                        (0, (0, parcelRequire("8dVIb")).ElementName).DueOn
                    ]
                };
            case 'slack-object-provider':
                return {
                    primary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup,
                        (0, (0, parcelRequire("8dVIb")).ElementName).SentOn
                    ],
                    tertiary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).ReactCount,
                        (0, (0, parcelRequire("8dVIb")).ElementName).CommentCount
                    ]
                };
            case 'google-object-provider':
            case 'figma-object-provider':
                return {
                    primary: [
                        (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup,
                        (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn
                    ]
                };
            default:
                return defaultMetadata;
        }
    };
    const $575ef03a4633fd6f$var$AvatarGroupsWithNamePrefix = [
        (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup,
        (0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup,
        (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup
    ];
    const $575ef03a4633fd6f$var$toElementItem = (name)=>{
        const showNamePrefix = $575ef03a4633fd6f$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
        const testId = `${name.toLowerCase()}-metadata-element`;
        return {
            name: name,
            showNamePrefix: showNamePrefix,
            testId: testId
        };
    };
    const $575ef03a4633fd6f$var$toElementItems = (elementNames)=>{
        if (!elementNames?.length) return;
        return elementNames.filter((name)=>name in (0, (0, parcelRequire("8dVIb")).ElementName)).map($575ef03a4633fd6f$var$toElementItem);
    };
    const $575ef03a4633fd6f$export$8548546c0aa631e6 = (extensionKey, data)=>{
        const metadata = $575ef03a4633fd6f$var$getSimulatedBetterMetadata(extensionKey, data);
        const primary = [].concat(metadata.primary, metadata.tertiary);
        return {
            subtitle: $575ef03a4633fd6f$var$toElementItems(metadata.subtitle),
            primary: $575ef03a4633fd6f$var$toElementItems(primary),
            secondary: $575ef03a4633fd6f$var$toElementItems(metadata.secondary)
        };
    };
});
parcelRegister("FcDCF", function(module, exports) {
    $parcel$export(module.exports, "extractType", ()=>$c2480e088a98b125$export$2e9ae379995d99e3);
    const $c2480e088a98b125$export$2e9ae379995d99e3 = (jsonLd)=>{
        const type = jsonLd['@type'];
        if (type) {
            if (Array.isArray(jsonLd['@type'])) return type;
            else return [
                type
            ];
        }
    };
});
parcelRegister("6N2TY", function(module, exports) {
    $parcel$export(module.exports, "extractCommentCount", ()=>$e8afc48bfc3821d9$export$b68822b76d5d51d5);
    $parcel$export(module.exports, "extractDueOn", ()=>$e8afc48bfc3821d9$export$ac56bd7a37249b48);
    $parcel$export(module.exports, "extractViewCount", ()=>$e8afc48bfc3821d9$export$e57334ce4738e29d);
    $parcel$export(module.exports, "extractReactCount", ()=>$e8afc48bfc3821d9$export$44130aa92252501);
    $parcel$export(module.exports, "extractVoteCount", ()=>$e8afc48bfc3821d9$export$c8bef3d5e550a3a);
    $parcel$export(module.exports, "extractOwnedBy", ()=>$e8afc48bfc3821d9$export$75b4b5a156f48ff3);
    $parcel$export(module.exports, "extractAssignedTo", ()=>$e8afc48bfc3821d9$export$5546969a505305);
    $parcel$export(module.exports, "extractPersonAssignedToAsArray", ()=>$e8afc48bfc3821d9$export$edb8a7a44b91274e);
    $parcel$export(module.exports, "extractCreatedBy", ()=>$e8afc48bfc3821d9$export$69b10d653f96288b);
    $parcel$export(module.exports, "extractModifiedBy", ()=>$e8afc48bfc3821d9$export$bcb193c84c865ec9);
    $parcel$export(module.exports, "extractProgrammingLanguage", ()=>$e8afc48bfc3821d9$export$43e54589935a1ff);
    $parcel$export(module.exports, "extractSourceBranch", ()=>$e8afc48bfc3821d9$export$949ac6a8325b3fdb);
    $parcel$export(module.exports, "extractSubscriberCount", ()=>$e8afc48bfc3821d9$export$8bd03a7beb5badf1);
    $parcel$export(module.exports, "extractAttachmentCount", ()=>$e8afc48bfc3821d9$export$65362ff78a97fd8);
    $parcel$export(module.exports, "extractTargetBranch", ()=>$e8afc48bfc3821d9$export$29b0ac5d2f9890cf);
    $parcel$export(module.exports, "extractChecklistProgress", ()=>$e8afc48bfc3821d9$export$dd980f9881b65d9c);
    $parcel$export(module.exports, "extractLocation", ()=>$e8afc48bfc3821d9$export$9df94c77b0746c3c);
    $parcel$export(module.exports, "extractSubTasksProgress", ()=>$e8afc48bfc3821d9$export$744e3a2674114c1d);
    $parcel$export(module.exports, "extractReadTime", ()=>$e8afc48bfc3821d9$export$cc4028b2878d0675);
    $parcel$export(module.exports, "extractSentOn", ()=>$e8afc48bfc3821d9$export$b592ddecae70b61d);
    $parcel$export(module.exports, "extractStoryPoints", ()=>$e8afc48bfc3821d9$export$bdcea84d1550eb9d);
    var $lnY7t;
    var $4MmCl;
    var $eV8m9;
    var $g9Blp;
    const $e8afc48bfc3821d9$var$extractLinkName = (link)=>{
        if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
    };
    const $e8afc48bfc3821d9$var$extractValue = (data, key)=>{
        return data?.[key];
    };
    const $e8afc48bfc3821d9$export$b68822b76d5d51d5 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'schema:commentCount');
    const $e8afc48bfc3821d9$export$ac56bd7a37249b48 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'endTime');
    const $e8afc48bfc3821d9$export$e57334ce4738e29d = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:viewCount');
    const $e8afc48bfc3821d9$export$44130aa92252501 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:reactCount');
    const $e8afc48bfc3821d9$export$c8bef3d5e550a3a = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:voteCount');
    const $e8afc48bfc3821d9$export$75b4b5a156f48ff3 = (data)=>{
        const persons = (0, (0, parcelRequire("eV8m9")).extractPersonOwnedBy)(data);
        if (persons && persons.length) return persons[0].name;
    };
    const $e8afc48bfc3821d9$export$5546969a505305 = (data)=>{
        const person = (0, (0, parcelRequire("lnY7t")).extractPersonAssignedTo)(data);
        if (person) return person.name;
    };
    const $e8afc48bfc3821d9$export$edb8a7a44b91274e = (data)=>{
        const person = (0, (0, parcelRequire("lnY7t")).extractPersonAssignedTo)(data);
        return person ? [
            person
        ] : undefined;
    };
    const $e8afc48bfc3821d9$export$69b10d653f96288b = (data)=>{
        const persons = (0, (0, parcelRequire("4MmCl")).extractPersonCreatedBy)(data);
        if (persons && persons.length) return persons[0].name;
    };
    const $e8afc48bfc3821d9$export$bcb193c84c865ec9 = (data)=>{
        const person = (0, (0, parcelRequire("g9Blp")).extractPersonUpdatedBy)(data);
        if (person) return person.name;
    };
    const $e8afc48bfc3821d9$export$43e54589935a1ff = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'schema:programmingLanguage');
    const $e8afc48bfc3821d9$export$949ac6a8325b3fdb = (data)=>$e8afc48bfc3821d9$var$extractLinkName(data['atlassian:mergeSource']);
    const $e8afc48bfc3821d9$export$8bd03a7beb5badf1 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:subscriberCount');
    const $e8afc48bfc3821d9$export$65362ff78a97fd8 = (data)=>$e8afc48bfc3821d9$var$extractValue(data, 'atlassian:attachmentCount');
    const $e8afc48bfc3821d9$export$29b0ac5d2f9890cf = (data)=>$e8afc48bfc3821d9$var$extractLinkName(data['atlassian:mergeDestination']);
    const $e8afc48bfc3821d9$export$dd980f9881b65d9c = (data)=>{
        const checkItemsObj = $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:checkItems');
        return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
    };
    const $e8afc48bfc3821d9$export$9df94c77b0746c3c = (data)=>{
        const { url: url, name: name } = $e8afc48bfc3821d9$var$extractValue(data, 'location') || {};
        if (url && name && typeof url === 'string') return {
            text: name,
            url: url
        };
    };
    const $e8afc48bfc3821d9$export$744e3a2674114c1d = (data)=>{
        const subTasksObject = $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:subTasks');
        return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
    };
    const $e8afc48bfc3821d9$export$cc4028b2878d0675 = (data)=>{
        return $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:readTimeInMinutes');
    };
    const $e8afc48bfc3821d9$export$b592ddecae70b61d = (data)=>{
        return $e8afc48bfc3821d9$var$extractValue(data, 'dateSent');
    };
    const $e8afc48bfc3821d9$export$bdcea84d1550eb9d = (data)=>{
        return $e8afc48bfc3821d9$var$extractValue(data, 'atlassian:storyPoints');
    };
});
parcelRegister("lnY7t", function(module, exports) {
    $parcel$export(module.exports, "extractPersonAssignedTo", ()=>$0ac42ccaa7f6f983$export$38a0979ebf273662);
    var $aj6Xc;
    const $0ac42ccaa7f6f983$export$38a0979ebf273662 = (jsonLd)=>{
        const assignedTo = jsonLd['atlassian:assignedTo'];
        if (assignedTo) return (0, (0, parcelRequire("aj6Xc")).extractPersonFromJsonLd)(assignedTo);
    };
});
parcelRegister("aj6Xc", function(module, exports) {
    $parcel$export(module.exports, "extractPersonFromJsonLd", ()=>$39e0e436026dd560$export$c471ae5fddcf1392);
    var $cuw1y;
    const $39e0e436026dd560$export$c471ae5fddcf1392 = (person)=>{
        if (typeof person === 'string') throw Error('Link.person needs to be an object.');
        else if (person['@type'] === 'Link') {
            if (person.name) return {
                name: person.name
            };
        } else {
            if (person.name) return {
                name: person.name,
                src: person.icon && (0, (0, parcelRequire("cuw1y")).extractUrlFromIconJsonLd)(person.icon)
            };
        }
    };
});
parcelRegister("cuw1y", function(module, exports) {
    $parcel$export(module.exports, "extractUrlFromIconJsonLd", ()=>$17919ed1c60776d3$export$67f3d92c824fd850);
    var $7OmtM;
    const $17919ed1c60776d3$export$67f3d92c824fd850 = (icon)=>{
        if (typeof icon === 'string') return icon;
        else if (icon['@type'] === 'Link') return (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(icon);
        else {
            if (icon.url) return (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(icon.url);
        }
    };
});
parcelRegister("4MmCl", function(module, exports) {
    $parcel$export(module.exports, "extractPersonCreatedBy", ()=>$b5a77ee228b8b40a$export$a66235cba0c9d11a);
    var $aj6Xc;
    const $b5a77ee228b8b40a$export$a66235cba0c9d11a = (jsonLd)=>{
        const attributedTo = jsonLd.attributedTo;
        if (attributedTo) {
            if (Array.isArray(attributedTo)) return attributedTo.map((0, (0, parcelRequire("aj6Xc")).extractPersonFromJsonLd)).filter((item)=>!!item);
            else {
                const item = (0, (0, parcelRequire("aj6Xc")).extractPersonFromJsonLd)(attributedTo);
                if (item) return [
                    item
                ];
            }
        }
    };
});
parcelRegister("eV8m9", function(module, exports) {
    $parcel$export(module.exports, "extractPersonOwnedBy", ()=>$2d658438ec8722e8$export$19ee667f3f7a6ec3);
    var $aj6Xc;
    const $2d658438ec8722e8$export$19ee667f3f7a6ec3 = (jsonLd)=>{
        const ownedBy = jsonLd['atlassian:ownedBy'];
        if (ownedBy) {
            if (Array.isArray(ownedBy)) return ownedBy.map((0, (0, parcelRequire("aj6Xc")).extractPersonFromJsonLd)).filter((item)=>!!item);
            else {
                const item = (0, (0, parcelRequire("aj6Xc")).extractPersonFromJsonLd)(ownedBy);
                if (item) return [
                    item
                ];
            }
        }
    };
});
parcelRegister("g9Blp", function(module, exports) {
    $parcel$export(module.exports, "extractPersonUpdatedBy", ()=>$e35651e7203a8f3a$export$8a2d1ed7e6f336f0);
    var $aj6Xc;
    const $e35651e7203a8f3a$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
        const updatedBy = jsonLd['atlassian:updatedBy'];
        if (updatedBy) return (0, (0, parcelRequire("aj6Xc")).extractPersonFromJsonLd)(updatedBy);
    };
});
parcelRegister("fF5L8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35ba3ed6dc9291b3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKZoD;
    var $1MeuC;
    var $67sXJ;
    var $hZqF4;
    var $fqj3r;
    const $35ba3ed6dc9291b3$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("1MeuC")).default), (0, (0, parcelRequire("67sXJ")).default));
        const { state: { status: status } } = (0, (0, parcelRequire("1MeuC")).default)(url);
        const [showPrism, setShowPrism] = (0, $5uXOq.useState)(status === 'loading');
        (0, $5uXOq.useEffect)(()=>{
            setShowPrism(status === 'loading');
        }, [
            status
        ]);
        const container = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("fqj3r")).hoverCardClassName),
            css: [
                (0, (0, parcelRequire("hZqF4")).HoverCardContainer),
                !isAIEnabled ? (0, (0, parcelRequire("hZqF4")).popupContainerStyles) : undefined
            ],
            "data-testid": testId,
            ...props
        }, children);
        return isAIEnabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("67sXJ")).default), {
            isVisible: showPrism,
            testId: `${testId}-prism`
        }, container) : container;
    };
    const $35ba3ed6dc9291b3$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)($35ba3ed6dc9291b3$var$ConnectedAIPrismContainer, {
            isAIEnabled: isAIEnabled,
            url: url,
            testId: testId,
            ...props
        }, children);
    var $35ba3ed6dc9291b3$export$2e2bcd8739ae039 = $35ba3ed6dc9291b3$var$ContentContainer;
});
parcelRegister("1MeuC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27e30e18347ce2a0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hWyvy;
    var $8UXrm;
    var $a1vqi;
    var $1VPdD;
    var $hjhAz;
    var $kR87P;
    var $anB5s;
    const $27e30e18347ce2a0$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
    const $27e30e18347ce2a0$var$useAISummaryAction = (url)=>{
        const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, (0, parcelRequire("anB5s")).useAISummaryConfig)();
        const cardState = (0, (0, parcelRequire("hjhAz")).useSmartCardState)(url);
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const data = cardState.details?.data;
        const ari = data && (0, (0, parcelRequire("hWyvy")).extractAri)(data);
        const dataUrl = data && (0, (0, parcelRequire("8UXrm")).extractLink)(data) || '';
        const onStart = (0, $5uXOq.useCallback)((id)=>{
            (0, (0, parcelRequire("1VPdD")).startUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
        }, []);
        const onSuccess = (0, $5uXOq.useCallback)((id)=>{
            fireEvent('operational.summary.success', {});
            (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
        }, [
            fireEvent
        ]);
        const onError = (0, $5uXOq.useCallback)((id, reason)=>{
            const isSloError = reason === undefined ? true : ![
                'ACCEPTABLE_USE_VIOLATIONS',
                'HIPAA_CONTENT_DETECTED',
                'EXCEEDING_CONTEXT_LENGTH_ERROR'
            ].includes(reason);
            fireEvent('operational.summary.failed', {
                reason: reason || null,
                isSloError: isSloError
            });
            (0, (0, parcelRequire("1VPdD")).failUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
        }, [
            fireEvent
        ]);
        return (0, (0, parcelRequire("kR87P")).useAISummary)({
            url: dataUrl,
            ari: ari,
            product: product,
            envKey: envKey,
            baseUrl: baseUrl,
            onStart: onStart,
            onSuccess: onSuccess,
            onError: onError
        });
    };
    var $27e30e18347ce2a0$export$2e2bcd8739ae039 = $27e30e18347ce2a0$var$useAISummaryAction;
});
parcelRegister("hWyvy", function(module, exports) {
    $parcel$export(module.exports, "extractAri", ()=>$e72cc95d6d37b739$export$be18a6294fd426ec);
    const $e72cc95d6d37b739$export$be18a6294fd426ec = (jsonLd)=>{
        if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    };
});
parcelRegister("8UXrm", function(module, exports) {
    $parcel$export(module.exports, "extractLink", ()=>$c7ac01b191c63203$export$63f54cf4c5883620);
    var $7OmtM;
    const $c7ac01b191c63203$export$63f54cf4c5883620 = (jsonLd)=>{
        const url = jsonLd.url;
        if (url) {
            if (typeof url === 'string') return url;
            else return (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(url);
        }
    };
});
parcelRegister("a1vqi", function(module, exports) {
    $parcel$export(module.exports, "useAnalyticsEvents", ()=>$91130a451fd4887d$export$5bf35293e545f20c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $1PQcU;
    const $91130a451fd4887d$export$5bf35293e545f20c = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
            const event = createAnalyticsEvent((0, (0, parcelRequire("1PQcU")).default)(...params));
            event.fire((0, $37b399a913bad22b$export$3f072f06b90c3985));
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireEvent: fireEvent
        };
    };
});
const $37b399a913bad22b$export$3f072f06b90c3985 = 'media';
parcelRegister("1PQcU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$539e70e97f68df84$export$2e2bcd8739ae039);
    const $539e70e97f68df84$var$createEventPayload = (eventKey, ...[attributes])=>{
        const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
        if (eventType === 'screen') return {
            eventType: eventType,
            name: actionSubject,
            action: 'viewed',
            attributes: attributes
        };
        return {
            eventType: eventType,
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        };
    };
    var $539e70e97f68df84$export$2e2bcd8739ae039 = $539e70e97f68df84$var$createEventPayload;
});
parcelRegister("kR87P", function(module, exports) {
    $parcel$export(module.exports, "useAISummary", ()=>$c5395471ca862cc2$export$becd8f2eba1bbd96);
    var $5uXOq = parcelRequire("5uXOq");
    var $SrCME;
    var $561ku;
    const $c5395471ca862cc2$export$becd8f2eba1bbd96 = (props)=>{
        const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
        const [state, setState] = (0, $5uXOq.useState)((0, (0, parcelRequire("561ku")).AISummariesStore).get(url)?.state || {
            status: 'ready',
            content: ''
        });
        (0, $5uXOq.useEffect)(()=>{
            if (url && !(0, (0, parcelRequire("561ku")).AISummariesStore).get(url)) (0, (0, parcelRequire("561ku")).AISummariesStore).set(url, new (0, (0, parcelRequire("SrCME")).AISummaryService)({
                url: url,
                ari: ari,
                baseUrl: baseUrl,
                product: product,
                envKey: envKey,
                onError: onError,
                onStart: onStart,
                onSuccess: onSuccess
            }));
            return (0, (0, parcelRequire("561ku")).AISummariesStore).get(url)?.subscribe(setState);
        }, [
            url,
            baseUrl,
            onError,
            onStart,
            onSuccess,
            product,
            ari,
            envKey
        ]);
        const summariseUrl = ()=>{
            return (0, (0, parcelRequire("561ku")).AISummariesStore).get(url)?.summariseUrl();
        };
        return {
            summariseUrl: summariseUrl,
            state: state
        };
    };
});
parcelRegister("SrCME", function(module, exports) {
    $parcel$export(module.exports, "AISummaryService", ()=>$ad05438f1e08870b$export$73e4b807d5bd74b6);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $itO4f;
    var $VSDnB;
    var $9AA7J;
    var $c0Zwh;
    var $ghXNq;
    class $ad05438f1e08870b$export$73e4b807d5bd74b6 {
        constructor(props){
            this.state = {
                content: '',
                status: 'ready'
            };
            this.subscribedStateSetters = new Set();
            this.getRequestUrl = (envKey, baseUrlOverride)=>{
                const path = 'assist/chat/v1/invoke_agent/stream';
                if (baseUrlOverride || envKey) {
                    const baseUrl = baseUrlOverride || (0, (0, parcelRequire("itO4f")).getBaseUrl)(envKey);
                    return (0, (0, parcelRequire("ghXNq")).addPath)(baseUrl, path);
                }
                return (0, (0, parcelRequire("ghXNq")).addPath)('/gateway/api/', path);
            };
            this.fetchStream = async ()=>{
                const payload = {
                    recipient_agent_named_id: (0, (0, parcelRequire("VSDnB")).fg)('platform-smart-card-use-ai-smartlink-summary-agent') ? 'smartlink_summary_agent' : 'summary_agent',
                    agent_input_context: {
                        content_url: this.url,
                        content_ari: this.ari,
                        prompt_id: 'smart_links',
                        summary_output_mimetype: 'text/markdown'
                    }
                };
                const options = {
                    method: 'POST',
                    headers: this.config.headers,
                    body: JSON.stringify(payload),
                    credentials: 'include'
                };
                const response = await fetch(this.config.requestUrl, options);
                if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
                else return (0, (0, parcelRequire("9AA7J")).readStream)(response);
            };
            this.config = {
                requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'x-experience-id': 'smart-link',
                    'x-product': (0, (0, parcelRequire("ghXNq")).getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
                }
            };
            this.url = props.url;
            this.ari = props.ari;
            this.onStart = props.onStart;
            this.onSuccess = props.onSuccess;
            this.onError = props.onError;
        }
        async summariseUrl() {
            this.state = {
                status: 'loading',
                content: ''
            };
            for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
            const id = (0, ($parcel$interopDefault($7Jxgt)))();
            try {
                this.onStart?.(id);
                const stream = await this.fetchStream();
                let bufferContent = '';
                for await (const chunk of stream){
                    if (chunk.type === 'ANSWER_PART') {
                        bufferContent += chunk.message.content;
                        for (const subscriber of this.subscribedStateSetters)subscriber({
                            ...this.state,
                            content: bufferContent
                        });
                    }
                    if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                    if (chunk.type === 'ERROR') throw new (0, (0, parcelRequire("c0Zwh")).ChunkProcessingError)(chunk?.message?.message_template);
                }
                this.onSuccess?.(id);
                this.state = {
                    status: 'done',
                    content: bufferContent
                };
            } catch (err) {
                let message = err instanceof (0, (0, parcelRequire("c0Zwh")).ChunkProcessingError) ? err.message : 'UNEXPECTED';
                this.onError?.(id, message);
                this.state = {
                    status: 'error',
                    content: '',
                    error: message
                };
            }
            for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
            return this.state;
        }
        subscribe(stateSetter) {
            this.subscribedStateSetters.add(stateSetter);
            return ()=>{
                this.subscribedStateSetters.delete(stateSetter);
            };
        }
    }
});
parcelRegister("9AA7J", function(module, exports) {
    $parcel$export(module.exports, "readStream", ()=>$27dc203987154036$export$e45226161c660403);
    var $ghXNq;
    async function* $27dc203987154036$export$e45226161c660403(response) {
        const reader = (0, (0, parcelRequire("ghXNq")).getBufferReader)(response);
        let doneStreaming = false;
        let chunkBuffer = '';
        do try {
            const { value: value, done: done } = await reader.read();
            doneStreaming = done;
            if (value) {
                const processedChunks = `${chunkBuffer}${value}`.split('\n');
                chunkBuffer = '';
                for (let chunk of processedChunks)try {
                    const jsonChunk = JSON.parse(chunk);
                    if (jsonChunk.type === 'ERROR') reader.cancel();
                    yield jsonChunk;
                } catch (e) {
                    chunkBuffer = chunk;
                }
            }
        } catch (e) {
            if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
            else {
                reader.cancel();
                throw e;
            }
        }
        while (!doneStreaming)
        if (chunkBuffer) {
            const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
            throw error;
        }
    }
});
parcelRegister("ghXNq", function(module, exports) {
    $parcel$export(module.exports, "getBufferReader", ()=>$6c9c387ba5dd9d5b$export$f6383c3ea1307da9);
    $parcel$export(module.exports, "addPath", ()=>$6c9c387ba5dd9d5b$export$4c25481b843feb0b);
    $parcel$export(module.exports, "getXProductHeaderValue", ()=>$6c9c387ba5dd9d5b$export$ff2962de2b2c930f);
    const $6c9c387ba5dd9d5b$export$f6383c3ea1307da9 = (response)=>{
        if (!response.body) throw new Error('Response body is empty');
        return response.body.pipeThrough(new TextDecoderStream()).getReader();
    };
    const $6c9c387ba5dd9d5b$export$4c25481b843feb0b = (baseUrl, path)=>{
        const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
        const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
        const url = [
            urlWithTrailingSlash,
            pathWithoutLeadingSlash
        ].join('');
        return url;
    };
    const $6c9c387ba5dd9d5b$var$AiMateJiraXProduct = {
        JSM: 'JSM',
        JSW: 'JIRA-SOFTWARE',
        JWM: 'JIRA-CORE',
        JPD: 'JPD'
    };
    const $6c9c387ba5dd9d5b$var$isJiraProduct = (product)=>{
        const JIRA_PRODUCTS = [
            'JPD',
            'JSM',
            'JSW',
            'JWM'
        ];
        return product !== undefined && JIRA_PRODUCTS.includes(product);
    };
    const $6c9c387ba5dd9d5b$export$ff2962de2b2c930f = (product)=>{
        if ($6c9c387ba5dd9d5b$var$isJiraProduct(product)) return $6c9c387ba5dd9d5b$var$AiMateJiraXProduct[product];
        return product;
    };
});
parcelRegister("c0Zwh", function(module, exports) {
    $parcel$export(module.exports, "ChunkProcessingError", ()=>$0e5f8d5a8019ed33$export$fcec967a4b7ebd84);
    class $0e5f8d5a8019ed33$export$fcec967a4b7ebd84 extends Error {
        constructor(error){
            super(error);
        }
    }
    const $0e5f8d5a8019ed33$export$d8bd0967cb58683 = [
        'NETWORK_ERROR',
        'NO_ANSWER',
        'RATE_LIMIT',
        'NO_AGENT',
        'PLUGIN_ERRORED',
        'OPENAI_RATE_LIMIT_USER_ABUSE',
        'ACCEPTABLE_USE_VIOLATIONS',
        'AI_DISABLED',
        'UNEXPECTED',
        'HIPAA_CONTENT_DETECTED',
        'EXCEEDING_CONTEXT_LENGTH_ERROR'
    ];
});
parcelRegister("561ku", function(module, exports) {
    $parcel$export(module.exports, "AISummariesStore", ()=>$cc472589618fd980$export$6979339b6d41707e);
    var $iwKVT = parcelRequire("iwKVT");
    const $cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE = 100;
    const $cc472589618fd980$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE);
});
parcelRegister("anB5s", function(module, exports) {
    $parcel$export(module.exports, "useAISummaryConfig", ()=>$cd0a62b074a064ce$export$4480af2c00aa7ebe);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    const $cd0a62b074a064ce$export$4480af2c00aa7ebe = ()=>{
        const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        return (0, $5uXOq.useMemo)(()=>({
                baseUrl: connections.client.baseUrlOverride,
                envKey: connections.client.envKey,
                product: product,
                isAdminHubAIEnabled: isAdminHubAIEnabled
            }), [
            connections.client.baseUrlOverride,
            connections.client.envKey,
            product,
            isAdminHubAIEnabled
        ]);
    };
});
parcelRegister("67sXJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c1d831891587499$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $hxoiH;
    var $hZqF4;
    var $c1bPW;
    var $DuPPR;
    function $8c1d831891587499$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8c1d831891587499$var$contentStyles = {
        name: "1u4p2uv",
        styles: "transition:box-shadow 0.5s ease"
    };
    const $8c1d831891587499$var$contentStylesPrismVisible = {
        name: "egtvy2",
        styles: "box-shadow:0px 8px 12px rgba(9, 30, 66, 0),0px 0px 1px rgba(9, 30, 66, 0)"
    };
    const $8c1d831891587499$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
        const { colorMode: colorMode = 'light' } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("c1bPW")).default), {
            additionalCss: {
                animatedSvgContainer: (0, (0, parcelRequire("f8Sb3")).css)({
                    opacity: isVisible ? 1 : 0,
                    transition: 'opacity 0.5s ease'
                })
            },
            palette: (0, (0, parcelRequire("DuPPR")).AI_BORDER_PALETTE)[colorMode] ?? (0, (0, parcelRequire("DuPPR")).AI_BORDER_PALETTE).light,
            isGlowing: isGlowing,
            isMoving: isMoving,
            testId: testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (0, (0, parcelRequire("hZqF4")).popupContainerStyles),
                $8c1d831891587499$var$contentStyles,
                isVisible ? $8c1d831891587499$var$contentStylesPrismVisible : undefined
            ]
        }, children));
    };
    var $8c1d831891587499$export$2e2bcd8739ae039 = $8c1d831891587499$var$AIPrism;
});
parcelRegister("c1bPW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1652d4d52e4f5cc8$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $DuPPR;
    var $iI2az;
    function $1652d4d52e4f5cc8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1652d4d52e4f5cc8$var$borderContainerStyles = {
        name: "hjc7l6",
        styles: "display:flex;position:relative;padding:var(--ds-space-025, 2px);width:fit-content"
    };
    const $1652d4d52e4f5cc8$export$a16b2e78d6201b80 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: (0, (0, parcelRequire("DuPPR")).INNER_BORDER_RADIUS),
        flexGrow: 1,
        zIndex: 1
    });
    const $1652d4d52e4f5cc8$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, additionalCss: additionalCss })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $1652d4d52e4f5cc8$var$borderContainerStyles,
                additionalCss?.container
            ],
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iI2az")).default), {
            palette: palette,
            isMoving: isMoving,
            additionalCss: additionalCss?.animatedSvgContainer
        }), isGlowing && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iI2az")).default), {
            palette: palette,
            isMoving: isMoving,
            isGlowing: true,
            additionalCss: additionalCss?.animatedSvgContainer
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1652d4d52e4f5cc8$export$a16b2e78d6201b80
        }, children, " "));
    var $1652d4d52e4f5cc8$export$2e2bcd8739ae039 = $1652d4d52e4f5cc8$var$AIGlowingBorder;
});
parcelRegister("DuPPR", function(module, exports) {
    $parcel$export(module.exports, "INNER_BORDER_RADIUS", ()=>$82894915d9bf39bf$export$e9d9825cf6898271);
    $parcel$export(module.exports, "OUTER_BORDER_RADIUS", ()=>$82894915d9bf39bf$export$2a2ad00ed1dae540);
    $parcel$export(module.exports, "AI_BORDER_PALETTE", ()=>$82894915d9bf39bf$export$23b7b83c7063ccfe);
    const $82894915d9bf39bf$export$e9d9825cf6898271 = 8;
    const $82894915d9bf39bf$export$2a2ad00ed1dae540 = 10;
    const $82894915d9bf39bf$export$3088ed82e2905d1e = {
        blueUniqueGradientLight: '#00ACF8',
        blueUniqueGradientDark: '#008BD2',
        blue1000: '#092957',
        blue800: '#0055CC',
        blue700: '#0C66E4',
        blue600: '#1D7AFC',
        blue500: '#388BFF',
        blue300: '#85B8FF',
        blue200: '#CCE0FF',
        blue100: '#E9F2FF',
        teal500: '#37B4C3',
        teal300: '#8BDBE5',
        yellow500: '#CF9F02',
        yellow200: '#F8E6A0',
        red800: '#AE2A19',
        red600: '#E34935',
        orange500: '#F18D13',
        orange300: '#FEC57B'
    };
    const $82894915d9bf39bf$export$23b7b83c7063ccfe = {
        dark: {
            blue: $82894915d9bf39bf$export$3088ed82e2905d1e.blue800,
            teal: $82894915d9bf39bf$export$3088ed82e2905d1e.teal500,
            yellow: $82894915d9bf39bf$export$3088ed82e2905d1e.yellow500
        },
        light: {
            blue: $82894915d9bf39bf$export$3088ed82e2905d1e.blue600,
            teal: $82894915d9bf39bf$export$3088ed82e2905d1e.teal300,
            yellow: $82894915d9bf39bf$export$3088ed82e2905d1e.yellow200
        }
    };
});
parcelRegister("iI2az", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2f1273dcfb74565$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $DuPPR;
    function $e2f1273dcfb74565$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    let $e2f1273dcfb74565$var$namespaceUUID = 0;
    const $e2f1273dcfb74565$var$svgStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'absolute',
        borderRadius: (0, (0, parcelRequire("DuPPR")).OUTER_BORDER_RADIUS)
    });
    const $e2f1273dcfb74565$var$blurredStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
        height: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
        top: "var(--ds-space-050, 4px)",
        left: "var(--ds-space-050, 4px)",
        filter: `blur(${"var(--ds-space-100, 8px)"})`,
        backfaceVisibility: 'hidden',
        transform: 'translate3d(0, 0, 0)'
    });
    const $e2f1273dcfb74565$var$notBlurredStyles = {
        name: "1nir64p",
        styles: "left:0;top:0;width:100%;height:100%"
    };
    const $e2f1273dcfb74565$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, additionalCss: additionalCss })=>{
        const svgRef = (0, $5uXOq.useRef)(null);
        const namespaceId = (0, $5uXOq.useRef)();
        if (namespaceId.current === undefined) {
            namespaceId.current = $e2f1273dcfb74565$var$namespaceUUID;
            $e2f1273dcfb74565$var$namespaceUUID += 1;
        }
        (0, $5uXOq.useEffect)(()=>{
            if (isMoving) {
                const svg = svgRef.current;
                const beginReq = requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
                });
                return ()=>{
                    cancelAnimationFrame(beginReq);
                    requestAnimationFrame(()=>{
                        svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                    });
                };
            }
            return undefined;
        }, [
            isMoving
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            css: [
                $e2f1273dcfb74565$var$svgStyles,
                isGlowing ? $e2f1273dcfb74565$var$blurredStyles : $e2f1273dcfb74565$var$notBlurredStyles,
                additionalCss
            ],
            ref: svgRef,
            viewBox: "0 0 24 24",
            preserveAspectRatio: "none"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("defs", null, (0, (0, parcelRequire("f8Sb3")).jsx)("linearGradient", {
            id: `${namespaceId.current}_lg1`,
            gradientUnits: "userSpaceOnUse",
            x1: "0%",
            y1: "0",
            x2: "400%",
            y2: "0",
            spreadMethod: "reflect"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("animate", {
            begin: "indefinite",
            attributeName: "x1",
            from: "0%",
            to: "400%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("animate", {
            begin: "indefinite",
            attributeName: "x2",
            from: "400%",
            to: "800%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0",
            stopColor: palette.blue
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.25",
            stopColor: palette.teal
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.5",
            stopColor: palette.yellow
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.75",
            stopColor: palette.teal
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "1",
            stopColor: palette.blue
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("linearGradient", {
            id: `${namespaceId.current}_lg2`,
            gradientUnits: "userSpaceOnUse",
            x1: "0",
            y1: "-100%",
            x2: "0",
            y2: "300%",
            spreadMethod: "reflect"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("animate", {
            begin: "indefinite",
            attributeName: "y1",
            from: "-100%",
            to: "300%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("animate", {
            begin: "indefinite",
            attributeName: "y2",
            from: "300%",
            to: "700%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0",
            stopColor: palette.blue
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.25",
            stopColor: palette.teal
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.5",
            stopColor: palette.yellow
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.75",
            stopColor: palette.teal
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "1",
            stopColor: palette.blue
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("linearGradient", {
            id: `${namespaceId.current}_lg3`,
            gradientUnits: "userSpaceOnUse",
            x1: "300%",
            y1: "0",
            x2: "700%",
            y2: "0",
            spreadMethod: "reflect"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("animate", {
            begin: "indefinite",
            attributeName: "x1",
            from: "300%",
            to: "-100%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("animate", {
            begin: "indefinite",
            attributeName: "x2",
            from: "700%",
            to: "300%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0",
            stopColor: palette.blue
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.25",
            stopColor: palette.teal
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.5",
            stopColor: palette.yellow
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.75",
            stopColor: palette.teal
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "1",
            stopColor: palette.blue
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("linearGradient", {
            id: `${namespaceId.current}_lg4`,
            gradientUnits: "userSpaceOnUse",
            x1: "0",
            y1: "0",
            x2: "0",
            y2: "400%",
            spreadMethod: "reflect"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("animate", {
            begin: "indefinite",
            attributeName: "y1",
            from: "0%",
            to: "-400%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("animate", {
            begin: "indefinite",
            attributeName: "y2",
            from: "400%",
            to: "0%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0",
            stopColor: palette.blue
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.25",
            stopColor: palette.teal
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.5",
            stopColor: palette.yellow
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "0.75",
            stopColor: palette.teal
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "1",
            stopColor: palette.blue
        }))), (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            strokeWidth: "8"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            stroke: `url(#${namespaceId.current}_lg1)`,
            d: "M0 0h24",
            vectorEffect: "non-scaling-stroke"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            stroke: `url(#${namespaceId.current}_lg2)`,
            d: "M24 0v24",
            vectorEffect: "non-scaling-stroke"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            stroke: `url(#${namespaceId.current}_lg3)`,
            d: "M24 24H0",
            vectorEffect: "non-scaling-stroke"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            stroke: `url(#${namespaceId.current}_lg4)`,
            d: "M0 24V0",
            vectorEffect: "non-scaling-stroke"
        })));
    };
    var $e2f1273dcfb74565$export$2e2bcd8739ae039 = $e2f1273dcfb74565$var$AnimatedSvgContainer;
});
parcelRegister("KTqu4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73fc988205a4fd73$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $2NMNM;
    var $fVnbM;
    var $f24gj;
    var $8PVtF;
    var $eCNt3;
    var $7zaVw;
    var $9fYWd;
    var $dghu0;
    var $hYQw7;
    var $hZqF4;
    var $kFJz4;
    const $73fc988205a4fd73$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { cardState: cardState, url: url } = flexibleCardProps;
        const data = cardState.details?.data;
        const meta = cardState.details?.meta;
        const product = (0, (0, parcelRequire("f24gj")).extractProvider)(data)?.text ?? '';
        const hostname = (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, (0, (0, parcelRequire("eCNt3")).default)(url));
        const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, (0, parcelRequire("8PVtF")).extractRequestAccessContextImproved)({
            jsonLd: meta,
            url: url,
            product: product,
            createAnalyticsEvent: createAnalyticsEvent
        }) ?? {};
        if (!titleMessageKey || !descriptiveMessageKey) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fYWd")).default), {
            ...flexibleCardProps,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hYQw7")).default), {
            ignoreContainerPadding: true,
            overrideCss: (0, (0, parcelRequire("hZqF4")).getPreviewBlockStyles)(),
            testId: testId
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            overrideCss: (0, (0, parcelRequire("kFJz4")).titleBlockStyles),
            testId: `${testId}-title`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("7zaVw")).messages)[titleMessageKey],
            values: {
                product: product
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            overrideCss: (0, (0, parcelRequire("kFJz4")).mainTextStyles),
            testId: `${testId}-content`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("7zaVw")).messages)[descriptiveMessageKey],
            values: {
                product: product,
                hostname: hostname
            }
        })), action && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            overrideCss: (0, (0, parcelRequire("kFJz4")).connectButtonStyles)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: `${testId}-button`,
            onClick: action?.promise,
            appearance: "primary",
            isDisabled: buttonDisabled
        }, action?.text)));
    };
    var $73fc988205a4fd73$export$2e2bcd8739ae039 = $73fc988205a4fd73$var$HoverCardForbiddenView;
});
parcelRegister("f24gj", function(module, exports) {
    $parcel$export(module.exports, "extractProvider", ()=>$e8bec3b6f1f5b80a$export$a832871718466647);
    $parcel$export(module.exports, "extractProviderIcon", ()=>$e8bec3b6f1f5b80a$export$6fb636a2ac885215);
    var $5uXOq = parcelRequire("5uXOq");
    var $7anl7;
    var $29YN9;
    var $cuw1y;
    var $7OmtM;
    const $e8bec3b6f1f5b80a$export$a832871718466647 = (jsonLd)=>{
        const generator = jsonLd.generator;
        if (generator) {
            if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
            else if (generator['@type'] === 'Link') {
                if (generator.name) return {
                    text: generator.name
                };
            } else if (generator.name) {
                const id = generator['@id'];
                return {
                    text: generator.name,
                    icon: $e8bec3b6f1f5b80a$export$6fb636a2ac885215(generator.icon, id),
                    id: id,
                    image: $e8bec3b6f1f5b80a$var$extractProviderImage(generator.image)
                };
            }
        }
    };
    const $e8bec3b6f1f5b80a$export$6fb636a2ac885215 = (icon, id)=>{
        if (id) {
            if (id === (0, $0b0a34f2504ca78c$export$cee224b5de4d6d66)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7anl7")).ConfluenceIcon), {
                appearance: "brand",
                size: "xsmall"
            });
            else if (id === (0, $0b0a34f2504ca78c$export$f654d825189934a7)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29YN9")).JiraIcon), {
                appearance: "brand",
                size: "xsmall"
            });
        }
        if (icon) return (0, (0, parcelRequire("cuw1y")).extractUrlFromIconJsonLd)(icon);
    };
    const $e8bec3b6f1f5b80a$var$extractProviderImage = (image)=>{
        if (image) {
            if (typeof image === 'string') return image;
            else if (image['@type'] === 'Link') return (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(image);
            else if (image['@type'] === 'Image') {
                if (image.url) return (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(image.url);
            }
        }
    };
});
parcelRegister("7anl7", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceIcon", ()=>$1c9c2365ff37a453$export$68f3db7f6af48bcb);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $1c9c2365ff37a453$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
    };
    const $1c9c2365ff37a453$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $1c9c2365ff37a453$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
const $0b0a34f2504ca78c$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $0b0a34f2504ca78c$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $0b0a34f2504ca78c$export$84a73a0383f58180 = 'JiraTask';
const $0b0a34f2504ca78c$export$c6c83963a9378a67 = 'JiraSubTask';
const $0b0a34f2504ca78c$export$58af3c426c111a6d = 'JiraStory';
const $0b0a34f2504ca78c$export$ac9898a63417219e = 'JiraBug';
const $0b0a34f2504ca78c$export$54db5e3fb12e39cd = 'JiraEpic';
const $0b0a34f2504ca78c$export$2f54a5a217202c85 = 'JiraIncident';
const $0b0a34f2504ca78c$export$d097371052bfc411 = 'JiraServiceRequest';
const $0b0a34f2504ca78c$export$efd9452ad16c6676 = 'JiraChange';
const $0b0a34f2504ca78c$export$2e7e70abb5d81f67 = 'JiraProblem';
const $0b0a34f2504ca78c$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
parcelRegister("8PVtF", function(module, exports) {
    $parcel$export(module.exports, "extractRequestAccessContextImproved", ()=>$be4c51ebaefcf3e8$export$846c1540a86749e6);
    var $7zaVw;
    var $fzJZi;
    var $jgxl3;
    var $eCNt3;
    const $be4c51ebaefcf3e8$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
        const requestAccess = jsonLd?.requestAccess ? {
            ...jsonLd?.requestAccess,
            hostname: (0, (0, parcelRequire("eCNt3")).default)(url)
        } : undefined;
        switch(jsonLd?.requestAccess?.accessType){
            case 'DIRECT_ACCESS':
                return {
                    ...requestAccess,
                    titleMessageKey: 'direct_access_title',
                    descriptiveMessageKey: 'direct_access_description',
                    callToActionMessageKey: 'direct_access',
                    action: (0, (0, parcelRequire("jgxl3")).ForbiddenAction)(()=>{
                        if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'crossJoin',
                            eventType: 'ui'
                        }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
                        window.open(url);
                    }, 'direct_access', (0, (0, parcelRequire("7zaVw")).messages).direct_access, {
                        product: product
                    })
                };
            case 'REQUEST_ACCESS':
                return {
                    ...requestAccess,
                    titleMessageKey: 'default_no_access_title',
                    descriptiveMessageKey: 'request_access_description',
                    callToActionMessageKey: 'request_access',
                    action: (0, (0, parcelRequire("jgxl3")).ForbiddenAction)(()=>{
                        if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'requestAccess',
                            eventType: 'ui'
                        }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
                        window.open(url);
                    }, 'request_access', (0, (0, parcelRequire("7zaVw")).messages).request_access)
                };
            case 'PENDING_REQUEST_EXISTS':
                return {
                    ...requestAccess,
                    titleMessageKey: 'request_access_pending_title',
                    descriptiveMessageKey: 'request_access_pending_description',
                    callToActionMessageKey: 'request_access_pending',
                    action: (0, (0, parcelRequire("jgxl3")).ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, (0, parcelRequire("7zaVw")).messages).request_access_pending),
                    buttonDisabled: true
                };
            case 'DENIED_REQUEST_EXISTS':
                return {
                    ...requestAccess,
                    titleMessageKey: 'forbidden_title',
                    descriptiveMessageKey: 'request_denied_description'
                };
            case 'ACCESS_EXISTS':
                if (jsonLd?.visibility === 'not_found') return {
                    ...requestAccess,
                    titleMessageKey: 'not_found_title',
                    descriptiveMessageKey: 'not_found_description'
                };
                return {
                    ...requestAccess,
                    titleMessageKey: 'forbidden_title',
                    descriptiveMessageKey: 'access_exists_description',
                    callToActionMessageKey: 'request_access',
                    action: (0, (0, parcelRequire("jgxl3")).ForbiddenAction)(()=>{
                        if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'requestAccess',
                            eventType: 'ui'
                        }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
                        window.open(url);
                    }, 'access_exists', (0, (0, parcelRequire("7zaVw")).messages).request_access)
                };
            case 'FORBIDDEN':
                return {
                    ...requestAccess,
                    titleMessageKey: 'forbidden_title',
                    descriptiveMessageKey: 'forbidden_description'
                };
            default:
                return requestAccess;
        }
    };
});
parcelRegister("jgxl3", function(module, exports) {
    $parcel$export(module.exports, "ForbiddenAction", ()=>$4f0bf32284a5caf2$export$59f8830fb5467e35);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $7zaVw;
    const $4f0bf32284a5caf2$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, (0, parcelRequire("7zaVw")).messages).try_another_account, values = {})=>({
            id: id,
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...message,
                values: values
            }),
            promise: ()=>new Promise((resolve)=>resolve(handler())),
            buttonAppearance: 'default'
        });
});
parcelRegister("eCNt3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4aafc83cfd7b46ae$export$2e2bcd8739ae039);
    const $4aafc83cfd7b46ae$var$extractHostname = (url)=>{
        try {
            return new URL(url).hostname;
        } catch  {
            return url;
        }
    };
    var $4aafc83cfd7b46ae$export$2e2bcd8739ae039 = $4aafc83cfd7b46ae$var$extractHostname;
});
parcelRegister("9fYWd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$063c59fdd9d80513$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $anB5s;
    var $lJP2b;
    var $1Vuck;
    const $063c59fdd9d80513$var$FlexibleCard = ({ analytics: analytics, appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, renderers: renderers, showAuthTooltip: showAuthTooltip, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
        const aiSummaryConfig = (0, (0, parcelRequire("anB5s")).useAISummaryConfig)();
        const { status: cardType, details: details } = cardState;
        const status = cardType;
        const context = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1Vuck")).getContextByStatus)({
                aiSummaryConfig: aiSummaryConfig,
                response: details,
                id: id,
                renderers: renderers,
                actionOptions: actionOptions,
                status: status,
                url: url
            }), [
            aiSummaryConfig,
            details,
            id,
            renderers,
            actionOptions,
            status,
            url
        ]);
        const retry = (0, (0, parcelRequire("1Vuck")).getRetryOptions)(url, status, details, onAuthorize);
        const { title: title } = context || {};
        const analyticsContext = (0, $5uXOq.useMemo)(()=>analytics ? {
                ...analytics,
                display: appearance,
                extensionKey: details?.meta?.key
            } : undefined, [
            analytics,
            appearance,
            details?.meta?.key
        ]);
        (0, $5uXOq.useEffect)(()=>{
            switch(status){
                case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved:
                    if (onResolve) onResolve({
                        title: title,
                        url: url
                    });
                    break;
                case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Errored:
                case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback:
                case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Forbidden:
                case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).NotFound:
                case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Unauthorized:
                    if (onError) onError({
                        status: status,
                        url: url
                    });
                    break;
            }
        }, [
            onError,
            onResolve,
            status,
            title,
            url
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Nh1XU")).FlexibleUiAnalyticsContext).Provider, {
            value: analyticsContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Nh1XU")).FlexibleUiOptionContext).Provider, {
            value: ui
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext).Provider, {
            value: context
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJP2b")).default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            retry: retry,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            showAuthTooltip: showAuthTooltip,
            status: status
        }, children))));
    };
    var $063c59fdd9d80513$export$2e2bcd8739ae039 = $063c59fdd9d80513$var$FlexibleCard;
});
parcelRegister("Nh1XU", function(module, exports) {
    $parcel$export(module.exports, "FlexibleUiContext", ()=>$79a38154bf117346$export$ca70b164b615de47);
    $parcel$export(module.exports, "useFlexibleUiContext", ()=>$79a38154bf117346$export$61d7957a243df7aa);
    $parcel$export(module.exports, "FlexibleUiAnalyticsContext", ()=>$79a38154bf117346$export$9296fed6018ca95b);
    $parcel$export(module.exports, "useFlexibleUiAnalyticsContext", ()=>$79a38154bf117346$export$80b8dfec38d1d85c);
    $parcel$export(module.exports, "FlexibleUiOptionContext", ()=>$79a38154bf117346$export$f7433dbd6c50e26a);
    $parcel$export(module.exports, "useFlexibleUiOptionContext", ()=>$79a38154bf117346$export$e6b5ad18b56e8f51);
    var $5uXOq = parcelRequire("5uXOq");
    const $79a38154bf117346$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
    const $79a38154bf117346$export$61d7957a243df7aa = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$ca70b164b615de47);
    const $79a38154bf117346$export$9296fed6018ca95b = (0, $5uXOq.createContext)(undefined);
    const $79a38154bf117346$export$80b8dfec38d1d85c = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$9296fed6018ca95b);
    const $79a38154bf117346$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
    const $79a38154bf117346$export$e6b5ad18b56e8f51 = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$f7433dbd6c50e26a);
});
parcelRegister("lJP2b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$399db9c8fe523a70$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKZoD;
    var $8dVIb;
    var $Nh1XU;
    var $7ZRiH;
    var $91tw3;
    var $jwrXN;
    var $4mRkk;
    function $399db9c8fe523a70$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $399db9c8fe523a70$var$elevationStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`}`,
        borderRadius: "var(--ds-border-radius-200, 8px)",
        margin: "var(--ds-space-025, 2px)"
    });
    const $399db9c8fe523a70$var$getGap = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return '1.25rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return '1rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return '.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '.25rem';
        }
    };
    const $399db9c8fe523a70$var$getPadding = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return '1.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return '1.25rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return '1rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '.5rem';
        }
    };
    const $399db9c8fe523a70$var$clickableContainerStyles = {
        name: "1ubcigm",
        styles: "a, button, .has-action{position:relative;z-index:1;}"
    };
    const $399db9c8fe523a70$var$getContainerPaddingStyles = (size, hidePadding, childrenOptions)=>{
        const padding = hidePadding ? '0rem' : $399db9c8fe523a70$var$getPadding(size);
        const gap = $399db9c8fe523a70$var$getGap(size);
        const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = childrenOptions;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '--container-padding': padding,
            '--container-gap-left': previewOnLeft ? gap : padding,
            '--container-gap-right': previewOnRight ? gap : padding,
            '--preview-block-width': '30%',
            padding: padding
        }, previewOnLeft ? `padding-left: calc(var(--preview-block-width) + ${gap});` : '', previewOnRight ? `padding-right: calc(var(--preview-block-width) + ${gap});` : '');
    };
    const $399db9c8fe523a70$var$getChildrenOptions = (children, context)=>{
        let options = {};
        if ((0, (0, parcelRequire("7ZRiH")).isFlexUiPreviewPresent)(context)) (0, ($parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
            if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) {
                if ((0, (0, parcelRequire("91tw3")).isFlexibleUiPreviewBlock)(child)) {
                    const { placement: placement } = child.props;
                    if (placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Left) options.previewOnLeft = true;
                    if (placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Right) options.previewOnRight = true;
                }
            }
        });
        return options;
    };
    const $399db9c8fe523a70$export$8947b11ec08f5f9d = (size, hideBackground, hideElevation, hidePadding, clickableContainer, childrenOptions)=>{
        const paddingCss = $399db9c8fe523a70$var$getContainerPaddingStyles(size, hidePadding, childrenOptions);
        return (0, (0, parcelRequire("f8Sb3")).css)("display:flex;gap:", $399db9c8fe523a70$var$getGap(size), " 0;flex-direction:column;min-width:0;overflow-x:hidden;position:relative;", hideBackground ? '' : `background-color: ${"var(--ds-surface-raised, #FFFFFF)"};`, " ", paddingCss, " ", hideElevation ? '' : $399db9c8fe523a70$var$elevationStyles, " ", clickableContainer ? $399db9c8fe523a70$var$clickableContainerStyles : '', " &:hover~.actions-button-group{opacity:1;}a:focus,.has-action:focus{outline-offset:-2px;}");
    };
    const $399db9c8fe523a70$var$renderChildren = (children, containerSize, containerTheme, status, retry, onClick)=>(0, ($parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
            if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(child) && (0, (0, parcelRequire("91tw3")).isFlexibleUiBlock)(child)) {
                const { size: blockSize } = child.props;
                const size = blockSize || containerSize;
                if ((0, (0, parcelRequire("91tw3")).isFlexibleUiTitleBlock)(child)) return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                    onClick: onClick,
                    retry: retry,
                    size: size,
                    status: status,
                    theme: containerTheme
                });
                return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                    size: size,
                    status: status
                });
            }
        });
    const $399db9c8fe523a70$var$getTitleBlockProps = (children)=>{
        const block = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).find((child)=>(0, (0, parcelRequire("91tw3")).isFlexibleUiTitleBlock)(child));
        if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(block)) return block.props;
    };
    const $399db9c8fe523a70$var$getLayeredLink = (testId, context, children, onClick)=>{
        const { title: title, url: url = '' } = context || {};
        const { anchorTarget: target, text: text } = $399db9c8fe523a70$var$getTitleBlockProps(children) || {};
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4mRkk")).default), {
            onClick: onClick,
            target: target,
            testId: testId,
            text: text || title,
            url: url
        });
    };
    const $399db9c8fe523a70$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showAuthTooltip: showAuthTooltip = false, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', theme: theme = (0, (0, parcelRequire("8dVIb")).SmartLinkTheme).Link })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("jwrXN")).default));
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext));
        const childrenOptions = $399db9c8fe523a70$var$getChildrenOptions(children, context);
        const canShowHoverPreview = showHoverPreview && status === 'resolved';
        const canShowAuthTooltip = showAuthTooltip && status === 'unauthorized' && retry !== undefined;
        const container = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $399db9c8fe523a70$export$8947b11ec08f5f9d(size, hideBackground, hideElevation, hidePadding, clickableContainer, childrenOptions),
            "data-smart-link-container": true,
            "data-testid": testId
        }, clickableContainer ? $399db9c8fe523a70$var$getLayeredLink(testId, context, children, onClick) : null, $399db9c8fe523a70$var$renderChildren(children, size, theme, status, retry, onClick));
        if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jwrXN")).default), {
            isHoverPreview: canShowHoverPreview,
            isAuthTooltip: canShowAuthTooltip,
            actionOptions: actionOptions,
            testId: testId,
            url: context.url,
            hoverPreviewOptions: hoverPreviewOptions
        }, container);
        return container;
    };
    var $399db9c8fe523a70$export$2e2bcd8739ae039 = $399db9c8fe523a70$var$Container;
});
parcelRegister("7ZRiH", function(module, exports) {
    $parcel$export(module.exports, "isFlexUiPreviewPresent", ()=>$767677c9fc81205d$export$783c1bf8fee63f80);
    const $767677c9fc81205d$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);
});
parcelRegister("91tw3", function(module, exports) {
    $parcel$export(module.exports, "isFlexibleUiCard", ()=>$f30ba994fabdf720$export$3c94e0f4719f5c2a);
    $parcel$export(module.exports, "isFlexibleUiTitleBlock", ()=>$f30ba994fabdf720$export$df0092b19156b140);
    $parcel$export(module.exports, "isFlexibleUiBlock", ()=>$f30ba994fabdf720$export$b56fc89cf6e7d1e9);
    $parcel$export(module.exports, "isFlexibleUiElement", ()=>$f30ba994fabdf720$export$d7fc505bb0bd5756);
    $parcel$export(module.exports, "isFlexibleUiPreviewBlock", ()=>$f30ba994fabdf720$export$c0547b4405cae584);
    var $5uXOq = parcelRequire("5uXOq");
    var $66ZRy;
    var $buvhv;
    var $hYQw7;
    var $ietxm;
    var $eqoQu;
    const $f30ba994fabdf720$export$3c94e0f4719f5c2a = (children)=>{
        if (children && (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$f30ba994fabdf720$export$df0092b19156b140(child))) return true;
        return false;
    };
    const $f30ba994fabdf720$export$b56fc89cf6e7d1e9 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && Object.values((0, parcelRequire("66ZRy"))).some((type)=>type === node.type);
    const $f30ba994fabdf720$export$d7fc505bb0bd5756 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && Object.values((0, parcelRequire("eqoQu"))).some((type)=>type === node.type);
    const $f30ba994fabdf720$export$df0092b19156b140 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("buvhv")).default);
    const $f30ba994fabdf720$export$c0547b4405cae584 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("hYQw7")).default);
    const $f30ba994fabdf720$export$43edae7b55c79927 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("ietxm")).default);
});
parcelRegister("66ZRy", function(module, exports) {
    $parcel$export(module.exports, "FooterBlock", ()=>(parcelRequire("ietxm")).default);
    $parcel$export(module.exports, "MetadataBlock", ()=>(parcelRequire("gg6Qm")).default);
    $parcel$export(module.exports, "PreviewBlock", ()=>(parcelRequire("hYQw7")).default);
    $parcel$export(module.exports, "SnippetBlock", ()=>(parcelRequire("1JaZ4")).default);
    $parcel$export(module.exports, "TitleBlock", ()=>(parcelRequire("buvhv")).default);
    $parcel$export(module.exports, "CustomBlock", ()=>(parcelRequire("dghu0")).default);
    $parcel$export(module.exports, "InternalFooterBlock", ()=>(parcelRequire("5HrTg")).default);
    $parcel$export(module.exports, "RelatedUrlsBlock", ()=>(parcelRequire("31Qmi")).default);
    $parcel$export(module.exports, "AISummaryBlock", ()=>(parcelRequire("1qDIM")).default);
    $parcel$export(module.exports, "AIFooterBlock", ()=>(parcelRequire("85ffk")).default);
    $parcel$export(module.exports, "ActionBlock", ()=>(parcelRequire("fh9qw")).default);
    var $ietxm;
    var $gg6Qm;
    var $hYQw7;
    var $1JaZ4;
    var $buvhv;
    var $dghu0;
    var $5HrTg;
    var $31Qmi;
    var $1qDIM;
    var $85ffk;
    var $fh9qw;
});
parcelRegister("ietxm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fcebb5ad9978d90$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $5HrTg;
    const $3fcebb5ad9978d90$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved && !alwaysShow) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HrTg")).default), {
            ...props,
            testId: testId
        });
    };
    var $3fcebb5ad9978d90$export$2e2bcd8739ae039 = $3fcebb5ad9978d90$var$FooterBlock;
});
parcelRegister("5HrTg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8eaafd3e75b73f4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $eqoQu;
    var $bubxq;
    var $dghu0;
    var $1BfaB;
    var $akF1x;
    const $b8eaafd3e75b73f4$var$FooterBlockResolvedView = (props)=>{
        const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, hideProvider: hideProvider } = props;
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const hasActions = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("akF1x")).filterActionItems)(actions, context)?.length > 0, [
            actions,
            context
        ]);
        const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
            if (onActionMenuOpenChange) onActionMenuOpenChange({
                isOpen: isOpen
            });
        }, [
            onActionMenuOpenChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...props,
            testId: `${testId}-resolved-view`
        }, !hideProvider && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).Provider), {
            testId: `${testId}-provider`
        }), actions && hasActions ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            testId: "smart-element-group-actions",
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            overrideCss: (0, (0, parcelRequire("akF1x")).getActionGroupStyles)(size),
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bubxq")).default), {
            onDropdownOpenChange: onDropdownOpenChange,
            items: actions,
            appearance: "default"
        })) : null);
    };
    var $b8eaafd3e75b73f4$export$2e2bcd8739ae039 = $b8eaafd3e75b73f4$var$FooterBlockResolvedView;
});
parcelRegister("eqoQu", function(module, exports) {
    $parcel$export(module.exports, "AssignedTo", ()=>$ec376f2b71614cc0$export$d3af56c23f9e459b);
    $parcel$export(module.exports, "AssignedToGroup", ()=>$ec376f2b71614cc0$export$fbd18f11bf3a3444);
    $parcel$export(module.exports, "AttachmentCount", ()=>$ec376f2b71614cc0$export$3bc3c9693a40aa);
    $parcel$export(module.exports, "AuthorGroup", ()=>$ec376f2b71614cc0$export$2ae2af4435dd6144);
    $parcel$export(module.exports, "ChecklistProgress", ()=>$ec376f2b71614cc0$export$5742b38fd5cfe410);
    $parcel$export(module.exports, "CollaboratorGroup", ()=>$ec376f2b71614cc0$export$a1e647014985ddb9);
    $parcel$export(module.exports, "CommentCount", ()=>$ec376f2b71614cc0$export$f4c1466e6fdd07b);
    $parcel$export(module.exports, "CreatedOn", ()=>$ec376f2b71614cc0$export$53ced9403d373871);
    $parcel$export(module.exports, "CreatedBy", ()=>$ec376f2b71614cc0$export$db468caedefbb630);
    $parcel$export(module.exports, "DueOn", ()=>$ec376f2b71614cc0$export$fea59459cfa1625b);
    $parcel$export(module.exports, "LatestCommit", ()=>$ec376f2b71614cc0$export$2aa8c58ab6c8ae64);
    $parcel$export(module.exports, "LinkIcon", ()=>$ec376f2b71614cc0$export$69387b41dfc808f7);
    $parcel$export(module.exports, "Location", ()=>$ec376f2b71614cc0$export$18a2be9195644f38);
    $parcel$export(module.exports, "ModifiedBy", ()=>$ec376f2b71614cc0$export$ebbbdcc68d717b7b);
    $parcel$export(module.exports, "ModifiedOn", ()=>$ec376f2b71614cc0$export$a6db3f4240728b58);
    $parcel$export(module.exports, "OwnedBy", ()=>$ec376f2b71614cc0$export$fa04b1f8d953704f);
    $parcel$export(module.exports, "OwnedByGroup", ()=>$ec376f2b71614cc0$export$90e81c873cca1e90);
    $parcel$export(module.exports, "Priority", ()=>$ec376f2b71614cc0$export$300334f671c43555);
    $parcel$export(module.exports, "ProgrammingLanguage", ()=>$ec376f2b71614cc0$export$7904b5485bf997ea);
    $parcel$export(module.exports, "Provider", ()=>$ec376f2b71614cc0$export$2881499e37b75b9a);
    $parcel$export(module.exports, "ReactCount", ()=>$ec376f2b71614cc0$export$f69df2decd5f729e);
    $parcel$export(module.exports, "ReadTime", ()=>$ec376f2b71614cc0$export$77dedcd16f070a20);
    $parcel$export(module.exports, "SentOn", ()=>$ec376f2b71614cc0$export$897b145a1ed39fe5);
    $parcel$export(module.exports, "SourceBranch", ()=>$ec376f2b71614cc0$export$387c3264a8f67d61);
    $parcel$export(module.exports, "State", ()=>$ec376f2b71614cc0$export$7254cc27399e90bd);
    $parcel$export(module.exports, "SubscriberCount", ()=>$ec376f2b71614cc0$export$cfafe90bba8a54db);
    $parcel$export(module.exports, "SubTasksProgress", ()=>$ec376f2b71614cc0$export$d441f34e4c8dd9e7);
    $parcel$export(module.exports, "StoryPoints", ()=>$ec376f2b71614cc0$export$634eef04d1a9a575);
    $parcel$export(module.exports, "TargetBranch", ()=>$ec376f2b71614cc0$export$b5e4199e062b8f44);
    $parcel$export(module.exports, "Title", ()=>$ec376f2b71614cc0$export$f99233281efd08a0);
    $parcel$export(module.exports, "ViewCount", ()=>$ec376f2b71614cc0$export$ae2d8be089b6cfe0);
    $parcel$export(module.exports, "VoteCount", ()=>$ec376f2b71614cc0$export$b080bef6ed7fa75a);
    $parcel$export(module.exports, "Preview", ()=>(parcelRequire("kDhrr")).default);
    $parcel$export(module.exports, "Snippet", ()=>(parcelRequire("kp8aU")).default);
    var $8dVIb;
    var $eCsaJ;
    var $kDhrr;
    var $kp8aU;
    const $ec376f2b71614cc0$export$d3af56c23f9e459b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo);
    const $ec376f2b71614cc0$export$fbd18f11bf3a3444 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup);
    const $ec376f2b71614cc0$export$3bc3c9693a40aa = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount);
    const $ec376f2b71614cc0$export$2ae2af4435dd6144 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup);
    const $ec376f2b71614cc0$export$5742b38fd5cfe410 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress);
    const $ec376f2b71614cc0$export$a1e647014985ddb9 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup);
    const $ec376f2b71614cc0$export$f4c1466e6fdd07b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CommentCount);
    const $ec376f2b71614cc0$export$53ced9403d373871 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn);
    const $ec376f2b71614cc0$export$db468caedefbb630 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy);
    const $ec376f2b71614cc0$export$fea59459cfa1625b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).DueOn);
    const $ec376f2b71614cc0$export$2aa8c58ab6c8ae64 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit);
    const $ec376f2b71614cc0$export$69387b41dfc808f7 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).LinkIcon);
    const $ec376f2b71614cc0$export$18a2be9195644f38 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Location);
    const $ec376f2b71614cc0$export$ebbbdcc68d717b7b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy);
    const $ec376f2b71614cc0$export$a6db3f4240728b58 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn);
    const $ec376f2b71614cc0$export$fa04b1f8d953704f = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy);
    const $ec376f2b71614cc0$export$90e81c873cca1e90 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup);
    const $ec376f2b71614cc0$export$300334f671c43555 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Priority);
    const $ec376f2b71614cc0$export$7904b5485bf997ea = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage);
    const $ec376f2b71614cc0$export$2881499e37b75b9a = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Provider);
    const $ec376f2b71614cc0$export$f69df2decd5f729e = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ReactCount);
    const $ec376f2b71614cc0$export$77dedcd16f070a20 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ReadTime);
    const $ec376f2b71614cc0$export$897b145a1ed39fe5 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SentOn);
    const $ec376f2b71614cc0$export$387c3264a8f67d61 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch);
    const $ec376f2b71614cc0$export$7254cc27399e90bd = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).State);
    const $ec376f2b71614cc0$export$cfafe90bba8a54db = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount);
    const $ec376f2b71614cc0$export$d441f34e4c8dd9e7 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress);
    const $ec376f2b71614cc0$export$634eef04d1a9a575 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints);
    const $ec376f2b71614cc0$export$b5e4199e062b8f44 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch);
    const $ec376f2b71614cc0$export$f99233281efd08a0 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Title);
    const $ec376f2b71614cc0$export$ae2d8be089b6cfe0 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ViewCount);
    const $ec376f2b71614cc0$export$b080bef6ed7fa75a = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).VoteCount);
});
parcelRegister("eCsaJ", function(module, exports) {
    $parcel$export(module.exports, "createElement", ()=>$3c92d860530d8c8b$export$c8a8987d4410bf2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $9tslm;
    var $4ZXUA;
    var $7IZqM;
    var $bWpL0;
    var $aWyvu;
    var $3dV67;
    var $cJxXG;
    var $77cM6;
    var $k39kU;
    const $3c92d860530d8c8b$var$elementMappings = {
        [(0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Attachment
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).CheckItem
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CommentCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Comment
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ViewCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).View
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReactCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).React
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).VoteCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Vote
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn]: {
            component: (0, (0, parcelRequire("bWpL0")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).DueOn]: {
            component: (0, (0, parcelRequire("cJxXG")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Commit
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).LinkIcon]: {
            component: (0, (0, parcelRequire("aWyvu")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn]: {
            component: (0, (0, parcelRequire("bWpL0")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Preview]: {
            component: (0, (0, parcelRequire("77cM6")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Priority]: {
            component: (0, (0, parcelRequire("7IZqM")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).ProgrammingLanguage
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Provider]: {
            component: (0, (0, parcelRequire("7IZqM")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReadTime]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SentOn]: {
            component: (0, (0, parcelRequire("bWpL0")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).State]: {
            component: (0, (0, parcelRequire("cJxXG")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Subscriber
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).SubTasksProgress
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints]: {
            component: (0, (0, parcelRequire("9tslm")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Title]: {
            component: (0, (0, parcelRequire("3dV67")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Location]: {
            component: (0, (0, parcelRequire("3dV67")).default),
            props: {
                theme: (0, (0, parcelRequire("8dVIb")).SmartLinkInternalTheme).Grey
            }
        }
    };
    const $3c92d860530d8c8b$var$getContextKey = (name)=>{
        return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
    };
    const $3c92d860530d8c8b$var$getData = (elementName, contextKey, context)=>{
        if (!context) return undefined;
        const data = context[contextKey];
        switch(elementName){
            case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup:
            case (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup:
            case (0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup:
            case (0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup:
                const AvatarGroupsWithFallback = [
                    (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup
                ];
                const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
                return $3c92d860530d8c8b$var$toAvatarGroupProps(data, showFallbackAvatar);
            case (0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress:
            case (0, (0, parcelRequire("8dVIb")).ElementName).CommentCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ViewCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ReactCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).VoteCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage:
            case (0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit:
            case (0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress:
                return $3c92d860530d8c8b$var$toBadgeProps(data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints:
                return $3c92d860530d8c8b$var$toAtlaskitBadgeProps(data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).created_by, context.createdBy);
            case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).assigned_to, context.assignedTo);
            case (0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).owned_by, context.ownedBy);
            case (0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn:
                return $3c92d860530d8c8b$var$toDateTimeProps('created', context.createdOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).DueOn:
                return $3c92d860530d8c8b$var$toDateLozengeProps(context.dueOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).modified_by, context.modifiedBy);
            case (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn:
                return $3c92d860530d8c8b$var$toDateTimeProps('modified', context.modifiedOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).SentOn:
                return $3c92d860530d8c8b$var$toDateTimeProps('sent', context.sentOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).ReadTime:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).read_time, data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch:
            case (0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch:
                return $3c92d860530d8c8b$var$toTextProps(data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).Title:
                return $3c92d860530d8c8b$var$toLinkProps(context.title, context.url);
            default:
                return typeof data === 'object' ? data : undefined;
        }
    };
    const $3c92d860530d8c8b$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
        return items ? {
            items: items
        } : showFallbackAvatar ? {
            items: []
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toBadgeProps = (label)=>{
        return label ? {
            label: label
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toAtlaskitBadgeProps = (value)=>{
        return value ? {
            value: value
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toDateLozengeProps = (dateString)=>{
        if (dateString) {
            const text = Date.parse(dateString) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VHMR")).FormattedDate), {
                value: new Date(dateString),
                year: "numeric",
                month: "short",
                day: "numeric",
                formatMatcher: "best fit"
            }) : dateString;
            return {
                text: text
            };
        }
    };
    const $3c92d860530d8c8b$var$toDateTimeProps = (type, dateString)=>{
        return dateString ? {
            date: new Date(dateString),
            type: type
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toFormattedTextProps = (descriptor, context)=>{
        return context ? {
            message: {
                descriptor: descriptor,
                values: {
                    context: context
                }
            }
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toLinkProps = (text, url)=>{
        return text ? {
            text: text,
            url: url
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toTextProps = (content)=>{
        return content ? {
            content: content
        } : undefined;
    };
    const $3c92d860530d8c8b$export$c8a8987d4410bf2d = (name)=>{
        const { component: BaseElement, props: props } = $3c92d860530d8c8b$var$elementMappings[name] || {};
        const contextKey = $3c92d860530d8c8b$var$getContextKey(name);
        if (!BaseElement) throw Error(`Element ${name} does not exist.`);
        return (overrides)=>{
            const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext));
            const data = $3c92d860530d8c8b$var$getData(name, contextKey, context);
            return data ? (0, ($parcel$interopDefault($5uXOq))).createElement(BaseElement, {
                ...props,
                ...data,
                ...overrides,
                name: name
            }) : null;
        };
    };
});
parcelRegister("9tslm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf2a1e857857107e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $16T6Y;
    function $bf2a1e857857107e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bf2a1e857857107e$var$badgeStyles = {
        name: "qowjig",
        styles: "align-items:center;display:inline-flex"
    };
    const $bf2a1e857857107e$var$AtlaskitBadge = ({ value: value, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-atlaskit-badge' })=>{
        if (!value) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $bf2a1e857857107e$var$badgeStyles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-atlaskit-badge": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("16T6Y")).default), null, value));
    };
    var $bf2a1e857857107e$export$2e2bcd8739ae039 = $bf2a1e857857107e$var$AtlaskitBadge;
});
parcelRegister("16T6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe7856b71523badd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $ehtcU;
    function $fe7856b71523badd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fe7856b71523badd$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        display: 'inline-flex',
        blockSize: 'min-content',
        flexShrink: 0
    });
    const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
    const $fe7856b71523badd$var$red300 = '#FD9891';
    const $fe7856b71523badd$var$blue300 = '#8FB8F6';
    const $fe7856b71523badd$var$neutral1000 = '#292A2E';
    const $fe7856b71523badd$var$styles = {
        root: {
            name: "85bcg3",
            styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
        },
        added: {
            name: "4x7cmh",
            styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
        },
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$neutral300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        important: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$red300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primary: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$blue300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primaryInverted: {
            name: "1425qmy",
            styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
        },
        removed: {
            name: "10hiq01",
            styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
        }
    };
    const $fe7856b71523badd$var$Badge = (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId,
            css: [
                $fe7856b71523badd$var$styles.root,
                $fe7856b71523badd$var$styles[appearance]
            ],
            style: {
                background: style?.backgroundColor,
                color: style?.color
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            as: "span",
            backgroundColor: $fe7856b71523badd$var$backgroundColors[appearance],
            xcss: $fe7856b71523badd$var$boxStyles,
            style: {
                background: style?.backgroundColor,
                color: style?.color
            },
            paddingInline: "space.075"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance]
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
    });
    $fe7856b71523badd$var$Badge.displayName = 'Badge';
    var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
    const $fe7856b71523badd$var$backgroundColors = {
        added: 'color.background.success',
        default: 'color.background.neutral',
        important: 'color.background.danger.bold',
        primary: 'color.background.brand.bold',
        primaryInverted: 'elevation.surface',
        removed: 'color.background.danger'
    };
    const $fe7856b71523badd$var$textColors = {
        added: 'color.text.success',
        default: 'color.text',
        important: 'color.text.inverse',
        primary: 'color.text.inverse',
        primaryInverted: 'color.text.brand',
        removed: 'color.text.danger'
    };
});
parcelRegister("ehtcU", function(module, exports) {
    $parcel$export(module.exports, "formatValue", ()=>$24d41a560822020b$export$7c4d25c0c3217d8c);
    function $24d41a560822020b$var$getSafeValue(value = 0) {
        const numericValue = +value;
        if (numericValue < 0) return 0;
        return value;
    }
    function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
        const safeValue = $24d41a560822020b$var$getSafeValue(value);
        const safeMax = $24d41a560822020b$var$getSafeValue(max);
        if (safeMax && safeMax < safeValue) return `${safeMax}+`;
        if (safeValue === Infinity) return "\u221E";
        return safeValue.toString();
    }
});
parcelRegister("4ZXUA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e655d051c837701$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $jnhNB;
    var $8dVIb;
    var $7zaVw;
    var $fpDmE;
    function $1e655d051c837701$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1e655d051c837701$var$MAX_COUNT = 4;
    var $1e655d051c837701$var$_ref = {
        name: "1brfzli",
        styles: "display:inline-flex;ul{margin-right:var(--ds-space-100, 0.5rem);margin-top:0;}"
    };
    const $1e655d051c837701$var$getStyles = (size)=>{
        const styles = $1e655d051c837701$var$_ref;
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return styles;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return (0, (0, parcelRequire("f8Sb3")).css)(styles, " li{span,svg{max-height:1.25rem;max-width:1.25rem;}}");
        }
    };
    const $1e655d051c837701$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
        switch(elementName){
            case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup:
                return (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).assigned_to, personName);
            case (0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup:
                return (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).owned_by, personName);
            case (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup:
                return (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).created_by, personName);
            default:
                return personName;
        }
    };
    const $1e655d051c837701$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $1e655d051c837701$var$MAX_COUNT, name: name, overrideCss: overrideCss, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const data = (0, $5uXOq.useMemo)(()=>{
            if (!items.length && showFallbackAvatar) switch(name){
                case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup:
                    return [
                        {
                            name: (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).unassigned)
                        }
                    ];
                default:
                    return [];
            }
            if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
                return {
                    ...person,
                    name: $1e655d051c837701$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
                };
            });
            return items;
        }, [
            name,
            items,
            showNamePrefix,
            showFallbackAvatar,
            intl
        ]);
        if (!data.length) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $1e655d051c837701$var$getStyles(size),
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-avatar-group": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jnhNB")).default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        }));
    };
    var $1e655d051c837701$export$2e2bcd8739ae039 = $1e655d051c837701$var$AvatarGroup;
});
parcelRegister("fpDmE", function(module, exports) {
    $parcel$export(module.exports, "sizeToButtonSpacing", ()=>$3ebf94f205ad0182$export$9d642f65a919fb93);
    $parcel$export(module.exports, "getFormattedMessage", ()=>$3ebf94f205ad0182$export$f1aa79f2218fb713);
    $parcel$export(module.exports, "getFormattedMessageAsString", ()=>$3ebf94f205ad0182$export$66ecb50a9dd1768);
    $parcel$export(module.exports, "getIconSizeStyles", ()=>$3ebf94f205ad0182$export$a5dfadfde90ee066);
    $parcel$export(module.exports, "getIconWidth", ()=>$3ebf94f205ad0182$export$fb10bc5609c6347e);
    $parcel$export(module.exports, "importIcon", ()=>$3ebf94f205ad0182$export$6dc831e1a0a7a851);
    $parcel$export(module.exports, "getLinkLineHeight", ()=>$3ebf94f205ad0182$export$1826e889cc97649);
    $parcel$export(module.exports, "getLinkSizeStyles", ()=>$3ebf94f205ad0182$export$7c3a25542ae9da0e);
    $parcel$export(module.exports, "getMaxLineHeight", ()=>$3ebf94f205ad0182$export$a681bd062fee88a5);
    $parcel$export(module.exports, "getMaxLines", ()=>$3ebf94f205ad0182$export$c2293adf1794c09);
    $parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", ()=>$3ebf94f205ad0182$export$475c391af8171fec);
    $parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", ()=>$3ebf94f205ad0182$export$1af10e3728e3a644);
    $parcel$export(module.exports, "getTruncateStyles", ()=>$3ebf94f205ad0182$export$8847c5561c06da49);
    $parcel$export(module.exports, "hasWhiteSpace", ()=>$3ebf94f205ad0182$export$619e376a425cb759);
    $parcel$export(module.exports, "openEmbedModalWithFlexibleUiIcon", ()=>$3ebf94f205ad0182$export$7207d5a516d3bfa8);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $4qBtX = parcelRequire("4qBtX");
    var $8dVIb;
    var $2Fcti;
    var $aWyvu;
    const $3ebf94f205ad0182$export$9d642f65a919fb93 = {
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small]: 'none',
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium]: 'compact',
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large]: 'compact',
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge]: 'default'
    };
    const $3ebf94f205ad0182$export$f1aa79f2218fb713 = (message)=>{
        if (message) {
            const { descriptor: descriptor, values: values } = message;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...descriptor,
                values: values
            });
        }
    };
    const $3ebf94f205ad0182$export$66ecb50a9dd1768 = (intl, message, context)=>{
        const { formatMessage: formatMessage } = intl;
        return message ? formatMessage(message, {
            context: context
        }) : '';
    };
    const $3ebf94f205ad0182$var$getIconDimensionStyles = (value)=>(0, (0, parcelRequire("f8Sb3")).css)({
            height: value,
            minHeight: value,
            maxHeight: value,
            width: value,
            minWidth: value,
            maxWidth: value
        });
    const $3ebf94f205ad0182$export$a5dfadfde90ee066 = (width)=>{
        const sizeStyles = $3ebf94f205ad0182$var$getIconDimensionStyles(width);
        return (0, (0, parcelRequire("f8Sb3")).css)("flex:0 0 auto;", sizeStyles, " span,svg,img{", sizeStyles, ";}svg{padding:0;}");
    };
    const $3ebf94f205ad0182$export$fb10bc5609c6347e = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return '2rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return '1.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return '1rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '.75rem';
        }
    };
    const $3ebf94f205ad0182$export$6dc831e1a0a7a851 = (importFn)=>{
        return (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>importFn().then((module)=>module.default),
            loading: ()=>null
        });
    };
    const $3ebf94f205ad0182$export$1826e889cc97649 = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return '1.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '1rem';
        }
    };
    const $3ebf94f205ad0182$export$7c3a25542ae9da0e = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '1.25rem',
                    fontWeight: 400,
                    letterSpacing: '-0.008em',
                    lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
                });
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '0.875rem',
                    fontWeight: 400,
                    letterSpacing: '-0.003em',
                    lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
                });
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '0.75rem',
                    fontWeight: 400,
                    letterSpacing: '0em',
                    lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
                });
        }
    };
    const $3ebf94f205ad0182$export$a681bd062fee88a5 = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 1.75;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 1.5;
        }
    };
    const $3ebf94f205ad0182$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
        if (value > max) return defaultValue;
        if (value < min) return min;
        return value;
    };
    const $3ebf94f205ad0182$export$475c391af8171fec = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return 'space.250';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 'space.200';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return 'space.100';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 'space.050';
        }
    };
    const $3ebf94f205ad0182$export$1af10e3728e3a644 = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return 'space.300';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 'space.250';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return 'space.200';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 'space.100';
        }
    };
    const $3ebf94f205ad0182$export$8847c5561c06da49 = (maxLines, lineHeight = '1rem', wordBreak = 'break-word')=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: '-webkit-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            wordBreak: wordBreak,
            WebkitLineClamp: maxLines,
            WebkitBoxOrient: 'vertical',
            '@supports not (-webkit-line-clamp: 1)': {
                maxHeight: `calc(${maxLines} * ${lineHeight})`
            }
        });
    const $3ebf94f205ad0182$export$619e376a425cb759 = (str)=>{
        return str.search(/\s/) >= 0;
    };
    const $3ebf94f205ad0182$export$7207d5a516d3bfa8 = ({ linkIcon: linkIcon, ...props })=>{
        const icon = {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWyvu")).default), {
                ...linkIcon,
                size: (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large
            }),
            isFlexibleUi: true
        };
        return (0, (0, parcelRequire("2Fcti")).openEmbedModal)({
            ...props,
            icon: icon,
            origin: 'smartLinkCard'
        });
    };
});
parcelRegister("2Fcti", function(module, exports) {
    $parcel$export(module.exports, "openEmbedModal", ()=>$2555d47e7922f4ad$export$7859f96cd8cff034);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $i5FdW;
    const $2555d47e7922f4ad$var$IFRAME_NAME = 'twp-editor-preview-iframe';
    const $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';
    async function $2555d47e7922f4ad$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
        let popupMountPoint;
        popupMountPoint = document.getElementById($2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID);
        if (!popupMountPoint) {
            popupMountPoint = document.createElement('div');
            popupMountPoint.id = $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID;
            popupMountPoint.setAttribute('data-testid', 'preview-modal');
            document.body.appendChild(popupMountPoint);
        }
        let Modal = await (parcelRequire("1khRa"));
        (0, ($parcel$interopDefault($7nsd3))).render((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: "en"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Modal.default, {
            ...props,
            iframeName: $2555d47e7922f4ad$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, ($parcel$interopDefault($7nsd3))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })), popupMountPoint);
    }
});
parcelRegister("1khRa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9ytm6")
    ]).then(()=>parcelRequire('amcti'));
});
parcelRegister("aWyvu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6c193b1fc074556$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jOyH3;
    var $8dVIb;
    var $9Hdrc;
    var $l5Xsv;
    var $fpDmE;
    function $d6c193b1fc074556$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $d6c193b1fc074556$var$_ref = {
        name: "1xpq7g4",
        styles: "align-self:flex-start;margin:0"
    };
    var $d6c193b1fc074556$var$_ref2 = {
        name: "qbt5ty",
        styles: "align-self:center"
    };
    const $d6c193b1fc074556$var$getPositionStyles = (position)=>{
        switch(position){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Center:
                return $d6c193b1fc074556$var$_ref2;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Top:
            default:
                return $d6c193b1fc074556$var$_ref;
        }
    };
    const $d6c193b1fc074556$var$getIconStyles = (position, width)=>(0, (0, parcelRequire("f8Sb3")).css)($d6c193b1fc074556$var$getPositionStyles(position), (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)(width));
    const $d6c193b1fc074556$var$getCustomRenderStyles = (value)=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1, value), {
            lineHeight: value,
            fontSize: value,
            textAlign: 'center',
            textOverflow: 'clip',
            WebkitBoxOrient: 'unset',
            span: {
                margin: 0,
                padding: 0,
                verticalAlign: 'baseline'
            }
        });
    const $d6c193b1fc074556$var$renderAtlaskitIcon = (icon, testId)=>{
        if (icon) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Hdrc")).default), {
            icon: icon,
            testId: `${testId}-icon`
        });
    };
    const $d6c193b1fc074556$var$renderDefaultIcon = (label, testId)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("jOyH3"))))), {
            label: label,
            testId: `${testId}-default`,
            color: "currentColor"
        });
    const $d6c193b1fc074556$var$renderImageIcon = (defaultIcon, url, testId)=>{
        if (url) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l5Xsv")).default), {
            defaultIcon: defaultIcon,
            testId: testId,
            url: url
        });
    };
    const $d6c193b1fc074556$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Top, overrideCss: overrideCss, render: render, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
        const element = (0, $5uXOq.useMemo)(()=>{
            const defaultIcon = $d6c193b1fc074556$var$renderDefaultIcon(label, testId);
            return overrideIcon || render?.() || $d6c193b1fc074556$var$renderImageIcon(defaultIcon, url, testId) || $d6c193b1fc074556$var$renderAtlaskitIcon(icon, testId) || defaultIcon;
        }, [
            overrideIcon,
            icon,
            label,
            render,
            testId,
            url
        ]);
        const width = (0, (0, parcelRequire("fpDmE")).getIconWidth)(size);
        const styles = $d6c193b1fc074556$var$getIconStyles(position, width);
        const renderStyles = render ? $d6c193b1fc074556$var$getCustomRenderStyles(width) : undefined;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                styles,
                renderStyles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-icon": true,
            "data-testid": testId
        }, element);
    };
    var $d6c193b1fc074556$export$2e2bcd8739ae039 = $d6c193b1fc074556$var$Icon;
});
parcelRegister("jOyH3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));
    var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
    function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e6cd993777d46e1b$var$LinkIcon = (props)=>$e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
            LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
        }, props));
    $e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
    var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;
});
parcelRegister("1f9bV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0e7e525cdad15340$var$_UNSAFE_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0e7e525cdad15340$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0e7e525cdad15340$var$LinkIcon = (props)=>$0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
        }, props));
    $0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
    var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;
});
parcelRegister("458iJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2f8e117d74b4de46$var$LinkIcon = (props)=>$2f8e117d74b4de46$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
        }, props, {
            newIcon: $2f8e117d74b4de46$var$_link.default
        }));
    $2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
    var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;
});
parcelRegister("9Hdrc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1647af7fe5459c6c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $duwKf;
    var $61uoP;
    var $7anl7;
    var $29YN9;
    var $8dVIb;
    const $1647af7fe5459c6c$var$importIconMapper = {
        [(0, (0, parcelRequire("8dVIb")).IconType).Archive]: ()=>(parcelRequire("1u9rQ")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Audio]: ()=>(parcelRequire("2P3xs")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Code]: ()=>(parcelRequire("boS7Q")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Executable]: ()=>(parcelRequire("ayRxW")),
        [(0, (0, parcelRequire("8dVIb")).IconType).File]: ()=>(parcelRequire("5GE4g")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Folder]: ()=>(parcelRequire("2KgZP")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Generic]: ()=>(parcelRequire("5GE4g")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GIF]: ()=>(parcelRequire("gBOzU")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleDocs]: ()=>(parcelRequire("jXySI")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleForms]: ()=>(parcelRequire("k7KGr")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleSheets]: ()=>(parcelRequire("5bX2p")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleSlides]: ()=>(parcelRequire("fZksg")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Image]: ()=>(parcelRequire("17GQp")),
        [(0, (0, parcelRequire("8dVIb")).IconType).MSExcel]: ()=>(parcelRequire("asJlG")),
        [(0, (0, parcelRequire("8dVIb")).IconType).MSPowerpoint]: ()=>(parcelRequire("jHQ8I")),
        [(0, (0, parcelRequire("8dVIb")).IconType).MSWord]: ()=>(parcelRequire("1HfN1")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PDF]: ()=>(parcelRequire("5GIkh")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Presentation]: ()=>(parcelRequire("dzrUL")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Sketch]: ()=>(parcelRequire("ktas1")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Spreadsheet]: ()=>(parcelRequire("dcnwM")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Template]: ()=>(parcelRequire("kLx2P")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Video]: ()=>(parcelRequire("8Cn4N")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Branch]: ()=>(parcelRequire("8OYab")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Commit]: ()=>(parcelRequire("9Ls0O")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Project]: ()=>Promise.resolve((parcelRequire("kFO36"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).PullRequest]: ()=>(parcelRequire("bLx4v")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Repo]: ()=>(parcelRequire("g7B05")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Bug]: ()=>(parcelRequire("jcfjn")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Change]: ()=>(parcelRequire("hvvgH")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Epic]: ()=>(parcelRequire("i5w36")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Incident]: ()=>(parcelRequire("jCmVW")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Problem]: ()=>(parcelRequire("jWILw")),
        [(0, (0, parcelRequire("8dVIb")).IconType).ServiceRequest]: ()=>(parcelRequire("2A66E")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Story]: ()=>(parcelRequire("50cEq")),
        [(0, (0, parcelRequire("8dVIb")).IconType).SubTask]: ()=>(parcelRequire("4pfB7")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Task]: ()=>(parcelRequire("d15m6")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Confluence]: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                    default: ConfluenceIcon
                })),
        [(0, (0, parcelRequire("8dVIb")).IconType).Jira]: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                    default: JiraIcon
                })),
        [(0, (0, parcelRequire("8dVIb")).IconType).Default]: ()=>Promise.resolve((parcelRequire("458iJ"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Error]: ()=>Promise.resolve((parcelRequire("7nnPp"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Forbidden]: ()=>(parcelRequire("9xScK")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Attachment]: ()=>(parcelRequire("4zmmA")),
        [(0, (0, parcelRequire("8dVIb")).IconType).CheckItem]: ()=>Promise.resolve((parcelRequire("imUQY"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Comment]: ()=>(parcelRequire("kCKH6")),
        [(0, (0, parcelRequire("8dVIb")).IconType).View]: ()=>(parcelRequire("bUKCR")),
        [(0, (0, parcelRequire("8dVIb")).IconType).React]: ()=>(parcelRequire("gmFhf")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Vote]: ()=>Promise.resolve((parcelRequire("kAObg"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityBlocker]: ()=>(parcelRequire("L5NMF")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityCritical]: ()=>(parcelRequire("dBeMd")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHigh]: ()=>(parcelRequire("1drkv")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHighest]: ()=>(parcelRequire("ivKwz")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLow]: ()=>(parcelRequire("8XsoF")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLowest]: ()=>(parcelRequire("a3VWM")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMajor]: ()=>(parcelRequire("2Kdus")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMedium]: ()=>(parcelRequire("6UcdR")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMinor]: ()=>(parcelRequire("8eqKo")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityTrivial]: ()=>(parcelRequire("hHzrM")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityUndefined]: ()=>(parcelRequire("fzaCl")),
        [(0, (0, parcelRequire("8dVIb")).IconType).ProgrammingLanguage]: ()=>(parcelRequire("6Hg82")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Subscriber]: ()=>Promise.resolve((parcelRequire("h8cgU"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).SubTasksProgress]: ()=>(parcelRequire("8B9kt"))
    };
    const $1647af7fe5459c6c$var$getIconImportFn = (icon)=>$1647af7fe5459c6c$var$importIconMapper[icon];
    const $1647af7fe5459c6c$var$importIcon = (importFn)=>{
        return (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>importFn().then((module)=>module.default),
            loading: ()=>null
        });
    };
    const $1647af7fe5459c6c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId })=>{
        switch(icon){
            case (0, (0, parcelRequire("8dVIb")).IconType).Document:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("duwKf"))))), {
                    label: label || 'document',
                    testId: testId
                });
            case (0, (0, parcelRequire("8dVIb")).IconType).Blog:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("61uoP"))))), {
                    label: label || 'blog',
                    testId: testId
                });
        }
        const importFn = $1647af7fe5459c6c$var$getIconImportFn(icon);
        if (!importFn) return null;
        const ImportedIcon = $1647af7fe5459c6c$var$importIcon(importFn);
        switch(icon){
            case (0, (0, parcelRequire("8dVIb")).IconType).Confluence:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7anl7")).ConfluenceIcon), {
                    appearance: "brand",
                    testId: testId
                });
            case (0, (0, parcelRequire("8dVIb")).IconType).Jira:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29YN9")).JiraIcon), {
                    appearance: "brand",
                    testId: testId
                });
            case (0, (0, parcelRequire("8dVIb")).IconType).Error:
            case (0, (0, parcelRequire("8dVIb")).IconType).Forbidden:
                return (0, ($parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                });
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId
                });
        }
    };
    var $1647af7fe5459c6c$export$2e2bcd8739ae039 = $1647af7fe5459c6c$var$AtlaskitIcon;
});
parcelRegister("61uoP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $462a6acb8358e55a$var$_react = $462a6acb8358e55a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $462a6acb8358e55a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $462a6acb8358e55a$var$Blog16Icon = (props)=>$462a6acb8358e55a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`
        }, props, {
            size: "small"
        }));
    $462a6acb8358e55a$var$Blog16Icon.displayName = 'Blog16Icon';
    var $462a6acb8358e55a$var$_default = module.exports.default = $462a6acb8358e55a$var$Blog16Icon;
});
parcelRegister("kLx2P", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dtoNN").then(()=>parcelRequire('53J27'));
});
parcelRegister("8OYab", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a8V9r").then(()=>parcelRequire('36B8O'));
});
parcelRegister("9Ls0O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OCkL").then(()=>parcelRequire('gSpCs'));
});
parcelRegister("bLx4v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lVi2f").then(()=>parcelRequire('jXbwR'));
});
parcelRegister("g7B05", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("keZKc").then(()=>parcelRequire('9wmko'));
});
parcelRegister("jcfjn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lyRQ2").then(()=>parcelRequire('cQpjg'));
});
parcelRegister("hvvgH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aFtbU").then(()=>parcelRequire('lThgm'));
});
parcelRegister("i5w36", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6i1Ed").then(()=>parcelRequire('lxe7t'));
});
parcelRegister("jCmVW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("huO2I").then(()=>parcelRequire('kiHC6'));
});
parcelRegister("jWILw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7GK64").then(()=>parcelRequire('eNbic'));
});
parcelRegister("2A66E", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6XIJ0").then(()=>parcelRequire('lLgcu'));
});
parcelRegister("50cEq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Gz5Y").then(()=>parcelRequire('g2bjw'));
});
parcelRegister("4pfB7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("laRGo").then(()=>parcelRequire('ePeTp'));
});
parcelRegister("d15m6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6GAo3").then(()=>parcelRequire('eUrLn'));
});
parcelRegister("9xScK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j1srk").then(()=>parcelRequire('gs7PQ'));
});
parcelRegister("4zmmA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gWXGh").then(()=>parcelRequire('j3Vfq'));
});
parcelRegister("kCKH6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a5nLi").then(()=>parcelRequire('DBbS0'));
});
parcelRegister("bUKCR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("97YHa").then(()=>parcelRequire('bH0nF'));
});
parcelRegister("gmFhf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cj5mx").then(()=>parcelRequire('kxkv9'));
});
parcelRegister("L5NMF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2JrEQ").then(()=>parcelRequire('jJL9z'));
});
parcelRegister("dBeMd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("czPXX").then(()=>parcelRequire('3pKEh'));
});
parcelRegister("1drkv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bW2Ht").then(()=>parcelRequire('k7gBp'));
});
parcelRegister("ivKwz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jlDVs").then(()=>parcelRequire('Le10t'));
});
parcelRegister("8XsoF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9n8Rc").then(()=>parcelRequire('kc1MS'));
});
parcelRegister("a3VWM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a0ALI").then(()=>parcelRequire('hfn9j'));
});
parcelRegister("2Kdus", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kFjg9").then(()=>parcelRequire('4zl0K'));
});
parcelRegister("6UcdR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("50gXn").then(()=>parcelRequire('cfbO3'));
});
parcelRegister("8eqKo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Bya1").then(()=>parcelRequire('jyFo7'));
});
parcelRegister("hHzrM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6xK7c").then(()=>parcelRequire('eJNZM'));
});
parcelRegister("fzaCl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8YLm9")
    ]).then(()=>parcelRequire('7QGmb'));
});
parcelRegister("6Hg82", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iY2wN").then(()=>parcelRequire('c2JK5'));
});
parcelRegister("8B9kt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("10dT8").then(()=>parcelRequire('gKopa'));
});
parcelRegister("l5Xsv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$951590e808a48e01$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $bmnhy = parcelRequire("bmnhy");
    var $gU02S;
    const $951590e808a48e01$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, onError: onError, onLoad: onLoad })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($bmnhy))), {
            src: url,
            loading: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), {
                testId: `${testId}-loading`
            }),
            loaded: (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: defaultIcon,
            onError: onError,
            onLoad: onLoad
        });
    var $951590e808a48e01$export$2e2bcd8739ae039 = $951590e808a48e01$var$ImageIcon;
});
parcelRegister("bmnhy", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8453cf1ee7ef4644$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var $5uXOq = parcelRequire("5uXOq");
    var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
    function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function $8453cf1ee7ef4644$var$loading(image) {
        return {
            image: image,
            isLoaded: false,
            isErrored: false
        };
    }
    function $8453cf1ee7ef4644$var$loaded() {
        return {
            isLoaded: true
        };
    }
    function $8453cf1ee7ef4644$var$errored() {
        return {
            isErrored: true
        };
    }
    function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
        var prevSrc = prevProps.src;
        var nextSrc = nextProps.src;
        return prevSrc !== nextSrc;
    }
    var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
        $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
        function ImageRenderer() {
            var _ref;
            var _temp, _this, _ret;
            $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                isLoaded: false,
                isErrored: false
            }, _this.handleLoad = function() {
                var onLoad = _this.props.onLoad;
                _this.unload();
                _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                    if (onLoad) onLoad();
                });
            }, _this.handleError = function() {
                var onError = _this.props.onError;
                _this.unload();
                _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                    if (onError) onError();
                });
            }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
        }
        $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
            {
                key: 'load',
                value: function load() {
                    var src = this.props.src;
                    var image = this.state.image;
                    if (image) {
                        image.onload = this.handleLoad;
                        image.onerror = this.handleError;
                        image.src = src;
                    }
                }
            },
            {
                key: 'unload',
                value: function unload() {
                    var image = this.state.image;
                    if (image) {
                        image.onload = undefined;
                        image.onerror = undefined;
                    }
                }
            },
            {
                key: 'componentWillMount',
                value: function componentWillMount() {
                    if (typeof window === 'undefined') return;
                    this.setState($8453cf1ee7ef4644$var$loading(new Image()));
                }
            },
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.load();
                }
            },
            {
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
                }
            },
            {
                key: 'componentDidUpdate',
                value: function componentDidUpdate(prevProps) {
                    if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                        this.unload();
                        this.load();
                    }
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.unload();
                }
            },
            {
                key: 'render',
                value: function render() {
                    var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                    var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                    if (isLoaded && loaded) return loaded;
                    if (isErrored && errored) return errored;
                    if (!isLoaded && !isErrored && loading) return loading;
                    if (children) return children({
                        image: isLoaded ? image : undefined,
                        loaded: isLoaded,
                        errored: isErrored
                    });
                    return null;
                }
            }
        ]);
        return ImageRenderer;
    }($8453cf1ee7ef4644$var$React.Component);
    module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;
});
parcelRegister("gU02S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$880176eb12ae8419$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $880176eb12ae8419$var$LoadingSkeleton = ({ testId: testId, width: width, height: height })=>{
        const animationNameStyles = (0, (0, parcelRequire("f8Sb3")).keyframes)({
            '0%': {
                backgroundPosition: '50% 0'
            },
            '100%': {
                backgroundPosition: '-50% 0'
            }
        });
        const styles = (0, (0, parcelRequire("f8Sb3")).css)({
            width: `${width}rem`,
            height: `${height}rem`,
            borderRadius: '2px',
            userSelect: 'none',
            background: "var(--ds-skeleton-subtle, #f6f7f8)",
            backgroundImage: `linear-gradient( to right, transparent 0%, ${"var(--ds-skeleton, #edeef1)"} 20%, transparent 40%, transparent 100% )`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '280% 100%',
            display: 'inline-block',
            animationDuration: '1s',
            animationFillMode: 'forwards',
            animationIterationCount: 'infinite',
            animationName: animationNameStyles,
            animationTimingFunction: 'linear'
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: styles,
            "data-testid": testId
        });
    };
    var $880176eb12ae8419$export$2e2bcd8739ae039 = $880176eb12ae8419$var$LoadingSkeleton;
});
parcelRegister("7IZqM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aab9f19acb0d3ec1$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $7zaVw;
    var $9Hdrc;
    var $l5Xsv;
    var $fpDmE;
    function $aab9f19acb0d3ec1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $aab9f19acb0d3ec1$var$badgeStyles = {
        name: "9qxyko",
        styles: "align-items:center;display:inline-flex;min-width:fit-content"
    };
    const $aab9f19acb0d3ec1$var$iconStyles = (0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-icon-subtle, #626F86);line-height:0;vertical-align:middle;", (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)('1rem'), " img,span,svg{line-height:0;vertical-align:middle;}");
    const $aab9f19acb0d3ec1$var$labelStyles = {
        name: "8loelm",
        styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;padding-left:var(--ds-space-025, 0.125rem);vertical-align:middle"
    };
    const $aab9f19acb0d3ec1$var$messageMapper = {
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityBlocker]: (0, (0, parcelRequire("7zaVw")).messages).priority_blocker,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityCritical]: (0, (0, parcelRequire("7zaVw")).messages).priority_critical,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHigh]: (0, (0, parcelRequire("7zaVw")).messages).priority_high,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHighest]: (0, (0, parcelRequire("7zaVw")).messages).priority_highest,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLow]: (0, (0, parcelRequire("7zaVw")).messages).priority_low,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLowest]: (0, (0, parcelRequire("7zaVw")).messages).priority_lowest,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMajor]: (0, (0, parcelRequire("7zaVw")).messages).priority_major,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMedium]: (0, (0, parcelRequire("7zaVw")).messages).priority_medium,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMinor]: (0, (0, parcelRequire("7zaVw")).messages).priority_minor,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityTrivial]: (0, (0, parcelRequire("7zaVw")).messages).priority_trivial,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityUndefined]: (0, (0, parcelRequire("7zaVw")).messages).priority_undefined
    };
    const $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon = (icon)=>{
        if (icon) {
            const descriptor = $aab9f19acb0d3ec1$var$messageMapper[icon];
            if (descriptor) return (0, (0, parcelRequire("fpDmE")).getFormattedMessage)({
                descriptor: descriptor
            });
        }
    };
    const $aab9f19acb0d3ec1$var$renderAtlaskitIcon = (icon, testId)=>{
        if (icon) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Hdrc")).default), {
            icon: icon,
            label: icon,
            testId: `${testId}-icon`
        });
    };
    const $aab9f19acb0d3ec1$var$renderImageIcon = (url, testId)=>{
        if (url) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l5Xsv")).default), {
            testId: testId,
            url: url
        });
    };
    const $aab9f19acb0d3ec1$var$Badge = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-badge', url: url })=>{
        const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
        const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
        if (!formattedMessageOrLabel || !badgeIcon) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $aab9f19acb0d3ec1$var$badgeStyles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-badge": true,
            "data-testid": testId
        }, !hideIcon && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $aab9f19acb0d3ec1$var$iconStyles
        }, badgeIcon), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $aab9f19acb0d3ec1$var$labelStyles,
            "data-testid": `${testId}-label`
        }, formattedMessageOrLabel));
    };
    var $aab9f19acb0d3ec1$export$2e2bcd8739ae039 = $aab9f19acb0d3ec1$var$Badge;
});
parcelRegister("bWpL0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66a4f7878d6976fe$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $j7anB;
    var $ousew;
    var $koVbs;
    var $7zaVw;
    var $fpDmE;
    const $66a4f7878d6976fe$var$styles = (0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1));
    const $66a4f7878d6976fe$var$typeToDescriptorMap = {
        created: {
            relative: (0, (0, parcelRequire("7zaVw")).messages).created_on_relative,
            absolute: (0, (0, parcelRequire("7zaVw")).messages).created_on_absolute
        },
        modified: {
            relative: (0, (0, parcelRequire("7zaVw")).messages).modified_on_relative,
            absolute: (0, (0, parcelRequire("7zaVw")).messages).modified_on_absolute
        },
        sent: {
            relative: (0, (0, parcelRequire("7zaVw")).messages).sent_on_relative,
            absolute: (0, (0, parcelRequire("7zaVw")).messages).sent_on_absolute
        }
    };
    const $66a4f7878d6976fe$var$DateTime = ({ date: date, name: name, overrideCss: overrideCss, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
        const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        if (!type || !date) return null;
        const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
        let context;
        let typeVariant;
        if (isLongerThenWeek) {
            typeVariant = 'absolute';
            context = formatDate(date, {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        } else {
            const { value: value, unit: unit } = (0, (0, parcelRequire("j7anB")).selectUnit)(date, Date.now());
            typeVariant = 'relative';
            context = formatRelativeTime(value, unit, {
                numeric: 'auto'
            });
        }
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $66a4f7878d6976fe$var$styles,
                overrideCss
            ],
            "data-separator": true,
            "data-smart-element": name,
            "data-smart-element-date-time": true,
            "data-testid": testId
        }, text ? `${text} ${context}` : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            ...$66a4f7878d6976fe$var$typeToDescriptorMap[type][typeVariant],
            values: {
                context: context
            }
        }));
    };
    var $66a4f7878d6976fe$export$2e2bcd8739ae039 = $66a4f7878d6976fe$var$DateTime;
});
parcelRegister("3dV67", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b60bb11df77d728a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3bDjY;
    var $8dVIb;
    var $4URMI;
    var $fpDmE;
    function $b60bb11df77d728a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b60bb11df77d728a$var$DEFAULT_MAX_LINES = 2;
    const $b60bb11df77d728a$var$MAXIMUM_MAX_LINES = 2;
    const $b60bb11df77d728a$var$MINIMUM_MAX_LINES = 1;
    const $b60bb11df77d728a$var$containerStyles = {
        name: "mkkf9p",
        styles: "flex:1 1 auto"
    };
    var $b60bb11df77d728a$var$_ref = {
        name: "16ucc2m",
        styles: "color:var(--ds-link, #0C66E4);:active{color:var(--ds-link-pressed, #0055CC);}:hover{color:var(--ds-link, #0C66E4);text-decoration:underline;}"
    };
    var $b60bb11df77d728a$var$_ref2 = {
        name: "1glvof",
        styles: "color:var(--ds-text-subtle, #44546F);:active{color:var(--ds-text, #172B4D);}:hover{color:var(--ds-text-subtle, #44546F);text-decoration:underline;}"
    };
    var $b60bb11df77d728a$var$_ref3 = {
        name: "rllj93",
        styles: "a&{color:var(--ds-text-subtlest, #626F86);&:active, &:visited, &:focus, &:hover{color:var(--ds-text-subtlest, #626F86);text-decoration:underline;}font-size:12px;}"
    };
    const $b60bb11df77d728a$var$getThemeStyles = (theme)=>{
        switch(theme){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkInternalTheme).Grey:
                return $b60bb11df77d728a$var$_ref3;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkTheme).Black:
                return $b60bb11df77d728a$var$_ref2;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkTheme).Link:
            default:
                return $b60bb11df77d728a$var$_ref;
        }
    };
    const $b60bb11df77d728a$var$getAnchorStyles = (size, theme, maxLines, hasSpace)=>{
        const sizeStyles = (0, (0, parcelRequire("fpDmE")).getLinkSizeStyles)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)("flex:1 1 auto;", sizeStyles, (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines, (0, (0, parcelRequire("fpDmE")).getLinkLineHeight)(size), hasSpace ? 'break-word' : 'break-all'), $b60bb11df77d728a$var$getThemeStyles(theme));
    };
    const $b60bb11df77d728a$var$getMaxLines = (maxLines)=>{
        if (maxLines > $b60bb11df77d728a$var$MAXIMUM_MAX_LINES) return $b60bb11df77d728a$var$DEFAULT_MAX_LINES;
        if (maxLines < $b60bb11df77d728a$var$MINIMUM_MAX_LINES) return $b60bb11df77d728a$var$MINIMUM_MAX_LINES;
        return maxLines;
    };
    const $b60bb11df77d728a$var$withTooltip = (trigger, content, testId)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: content,
            testId: `${testId}-tooltip`,
            tag: "span"
        }, trigger);
    const $b60bb11df77d728a$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $b60bb11df77d728a$var$DEFAULT_MAX_LINES, name: name, overrideCss: overrideCss, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, (0, parcelRequire("8dVIb")).SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
        const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)();
        const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, (0, parcelRequire("fpDmE")).hasWhiteSpace)(text) : false, [
            text
        ]);
        const anchor = (0, (0, parcelRequire("f8Sb3")).jsx)("a", {
            css: [
                $b60bb11df77d728a$var$getAnchorStyles(size, theme, $b60bb11df77d728a$var$getMaxLines(maxLines), hasSpace),
                overrideCss
            ],
            "data-smart-element": name,
            "data-smart-element-link": true,
            "data-testid": testId,
            onClick: onClick,
            onMouseDown: onMouseDown,
            href: url,
            ...target !== '_self' && {
                target: target
            }
        }, text);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $b60bb11df77d728a$var$containerStyles
        }, hideTooltip || text === undefined ? anchor : $b60bb11df77d728a$var$withTooltip(anchor, text, testId));
    };
    var $b60bb11df77d728a$export$2e2bcd8739ae039 = $b60bb11df77d728a$var$Link;
});
parcelRegister("cJxXG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af9c30eaf441ad65$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $lj8SI;
    var $Nh1XU;
    var $a4DH1;
    function $af9c30eaf441ad65$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $af9c30eaf441ad65$var$styles = {
        name: "cvfhjc",
        styles: "display:inline-flex;line-height:inherit"
    };
    const $af9c30eaf441ad65$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, overrideCss: overrideCss, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
        const ui = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiOptionContext)();
        if (!text) return null;
        const lozenge = action ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a4DH1")).default), {
            action: action,
            appearance: appearance,
            testId: testId,
            text: text,
            zIndex: ui?.zIndex
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), {
            appearance: appearance,
            style: style,
            testId: `${testId}-lozenge`
        }, text);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $af9c30eaf441ad65$var$styles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-lozenge": true,
            "data-testid": testId
        }, lozenge);
    };
    var $af9c30eaf441ad65$export$2e2bcd8739ae039 = $af9c30eaf441ad65$var$Lozenge;
});
parcelRegister("a4DH1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27ceba18caf6f022$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $BLPHT;
    var $dlJZx;
    var $Nh1XU;
    var $3q2sI;
    var $euMlu;
    var $f22ja;
    var $gDUps;
    var $fzJZi;
    var $cLKee;
    var $dMzTJ;
    var $j6VJk;
    var $1s0lY;
    var $kf01E;
    var $4Dg4o;
    const $27ceba18caf6f022$var$validateItems = (items = [], text)=>{
        return items.filter((item)=>item.text !== text);
    };
    const $27ceba18caf6f022$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
        const [selected, setSelected] = (0, $5uXOq.useState)({
            appearance: appearance,
            text: text
        });
        const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [items, setItems] = (0, $5uXOq.useState)();
        const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
        const reload = (0, (0, parcelRequire("f22ja")).default)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("3q2sI")).default)();
        (0, $5uXOq.useEffect)(()=>{
            setSelected({
                text: text,
                appearance: appearance
            });
        }, [
            text,
            appearance
        ]);
        const { url: url, id: linkId, previewData: previewData } = action?.update?.details || {};
        const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
            setIsOpen(args.isOpen);
            if (args.isOpen) {
                analytics?.ui.smartLinkLozengeActionClickedEvent();
                analytics?.track.smartLinkQuickActionStarted({
                    smartLinkActionType: (0, (0, parcelRequire("fzJZi")).TrackQuickActionType).StatusUpdate
                });
                if (!isLoaded && action?.read) try {
                    setIsLoading(true);
                    const responseItems = await invoke(action.read, (0, (0, parcelRequire("dlJZx")).default));
                    const validItems = typeof text === 'string' ? $27ceba18caf6f022$var$validateItems(responseItems, text) : responseItems;
                    setItems(validItems);
                    setIsLoaded(true);
                    if (validItems?.length === 0) {
                        analytics?.track.smartLinkQuickActionFailed((0, (0, parcelRequire("dMzTJ")).permissionLoadErrorAnalyticsPayload));
                        setErrorMessage((0, (0, parcelRequire("1s0lY")).LozengeActionErrorMessages).noData);
                        setIsLoaded(false);
                    }
                } catch (err) {
                    setErrorMessage((0, (0, parcelRequire("1s0lY")).LozengeActionErrorMessages).unknown);
                    setIsLoaded(false);
                    analytics?.track.smartLinkQuickActionFailed((0, (0, parcelRequire("dMzTJ")).unknownLoadErrorAnalyticsPayload));
                } finally{
                    setIsLoading(false);
                }
            }
            if (!args.isOpen) setErrorMessage(undefined);
        }, [
            action.read,
            analytics,
            invoke,
            isLoaded,
            text
        ]);
        const trigger = (0, $5uXOq.useCallback)((props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4Dg4o")).default), {
                ...props,
                appearance: selected.appearance,
                isOpen: isOpen,
                testId: testId,
                text: selected.text
            }), [
            selected.appearance,
            selected.text,
            isOpen,
            testId
        ]);
        const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
            try {
                analytics?.ui.smartLinkLozengeActionListItemClickedEvent();
                const updateAction = action?.update;
                if (updateAction && id) {
                    setIsLoading(true);
                    const request = (0, (0, parcelRequire("gDUps")).default)(updateAction, id);
                    await invoke(request);
                    setSelected({
                        appearance: appearance,
                        text: text
                    });
                    setIsLoading(false);
                    setIsLoaded(false);
                    setIsOpen(false);
                    setItems([]);
                    analytics?.track.smartLinkQuickActionSuccess({
                        smartLinkActionType: (0, (0, parcelRequire("fzJZi")).TrackQuickActionType).StatusUpdate
                    });
                    if (url) await reload(url, true, undefined, linkId);
                }
            } catch (err) {
                setIsLoading(false);
                if ((0, (0, parcelRequire("euMlu")).isInvokeCustomError)(err)) {
                    setErrorMessage(err.message);
                    analytics?.track.smartLinkQuickActionFailed((0, (0, parcelRequire("dMzTJ")).validationUpdateErrorAnalyticsPayload));
                } else {
                    setErrorMessage((0, (0, parcelRequire("1s0lY")).LozengeActionErrorMessages).updateFailed);
                    analytics?.track.smartLinkQuickActionFailed((0, (0, parcelRequire("dMzTJ")).unknownUpdateErrorAnalyticsPayload));
                }
            }
        }, [
            action?.update,
            analytics,
            invoke,
            linkId,
            reload,
            url
        ]);
        const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
            if (errorMessage) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j6VJk")).default), {
                errorMessage: errorMessage,
                testId: testId,
                url: url,
                previewData: previewData
            });
            if (items && items.length > 0) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kf01E")).default), {
                testId: testId,
                items: items,
                onClick: handleItemClick
            });
        }, [
            errorMessage,
            handleItemClick,
            items,
            previewData,
            testId,
            url
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("BLPHT")).default), {
            isLoading: isLoading,
            isOpen: isOpen,
            onOpenChange: handleOpenChange,
            testId: testId,
            trigger: trigger,
            zIndex: zIndex
        }, dropdownItemGroup);
    };
    var $27ceba18caf6f022$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cLKee")).default)($27ceba18caf6f022$var$LozengeAction);
});
parcelRegister("dlJZx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6eaacaffc693a3ec$export$2e2bcd8739ae039);
    const $6eaacaffc693a3ec$var$extractLozengeActionItems = (response)=>{
        const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
                appearance: appearance ?? 'default',
                id: id,
                text: name
            })) ?? [];
        return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
    };
    var $6eaacaffc693a3ec$export$2e2bcd8739ae039 = $6eaacaffc693a3ec$var$extractLozengeActionItems;
});
parcelRegister("3q2sI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5a60e7c58b54588$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iiAnG;
    var $kECas;
    const $f5a60e7c58b54588$var$useInvoke = ()=>{
        const { connections: connections } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const clientExt = (0, (0, parcelRequire("iiAnG")).useSmartLinkClientExtension)(connections.client);
        return (0, $5uXOq.useCallback)(async (req, cb)=>{
            const response = await clientExt.invoke(req);
            return cb ? cb(response) : response;
        }, [
            clientExt
        ]);
    };
    var $f5a60e7c58b54588$export$2e2bcd8739ae039 = $f5a60e7c58b54588$var$useInvoke;
});
parcelRegister("iiAnG", function(module, exports) {
    $parcel$export(module.exports, "useSmartLinkClientExtension", ()=>$ffb669da1b6b71e8$export$303ede4eed148855);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV0Jy;
    var $T540Y;
    var $3b94d;
    const $ffb669da1b6b71e8$export$303ede4eed148855 = (cardClient)=>{
        const resolverUrl = (0, (0, parcelRequire("3b94d")).useResolverUrl)(cardClient);
        const invoke = (0, $5uXOq.useCallback)(async (data)=>{
            try {
                return await (0, (0, parcelRequire("dV0Jy")).request)('post', `${resolverUrl}/invoke`, data, undefined, [
                    200,
                    201,
                    202,
                    203,
                    204
                ]);
            } catch (err) {
                if (err && err.json && typeof err.json === 'function') {
                    const errorBody = await err.json();
                    if (errorBody) throw new (0, (0, parcelRequire("T540Y")).InvokeError)(errorBody?.error.message, errorBody?.error.status);
                }
                throw err;
            }
        }, [
            resolverUrl
        ]);
        const relatedUrls = (0, $5uXOq.useCallback)(async (url)=>{
            return await (0, (0, parcelRequire("dV0Jy")).request)('get', `${resolverUrl}/related-urls?url=${encodeURIComponent(url)}`, undefined, {
                'Cache-Control': 'private'
            }, [
                200
            ]);
        }, [
            resolverUrl
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                invoke: invoke,
                relatedUrls: relatedUrls
            }), [
            invoke,
            relatedUrls
        ]);
    };
});
parcelRegister("3b94d", function(module, exports) {
    $parcel$export(module.exports, "useResolverUrl", ()=>$eebf021c5f687360$export$d08617a365fbe694);
    var $5uXOq = parcelRequire("5uXOq");
    var $itO4f;
    const $eebf021c5f687360$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("itO4f")).getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
            cardClient?.baseUrlOverride,
            cardClient?.envKey
        ]);
});
parcelRegister("euMlu", function(module, exports) {
    $parcel$export(module.exports, "getInvokeFailureReason", ()=>$0ad6fedaface02c5$export$65b3f792dff0bd60);
    $parcel$export(module.exports, "isInvokeCustomError", ()=>$0ad6fedaface02c5$export$1694272377fa07d8);
    var $fzJZi;
    const $0ad6fedaface02c5$export$65b3f792dff0bd60 = (err)=>{
        if (!$0ad6fedaface02c5$export$1694272377fa07d8(err)) return (0, (0, parcelRequire("fzJZi")).TrackQuickActionFailureReason).UnknownError;
        switch(err?.errorCode){
            case 403:
                return (0, (0, parcelRequire("fzJZi")).TrackQuickActionFailureReason).PermissionError;
            default:
                return (0, (0, parcelRequire("fzJZi")).TrackQuickActionFailureReason).UnknownError;
        }
    };
    const $0ad6fedaface02c5$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;
});
parcelRegister("gDUps", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66cd4b0a305f86bf$export$2e2bcd8739ae039);
    const $66cd4b0a305f86bf$var$createStatusUpdateRequest = (request, id)=>({
            providerKey: request.providerKey,
            action: {
                ...request.action,
                payload: {
                    newStatusId: id
                }
            }
        });
    var $66cd4b0a305f86bf$export$2e2bcd8739ae039 = $66cd4b0a305f86bf$var$createStatusUpdateRequest;
});
parcelRegister("cLKee", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$061d6f2e0c766414$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $lj8SI;
    const $061d6f2e0c766414$var$withErrorBoundary = (Component)=>(props)=>{
            const fallback = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                    appearance: props?.appearance,
                    testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`
                }, props?.text), [
                props?.appearance,
                props?.testId,
                props?.text
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
                fallback: fallback
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props));
        };
    var $061d6f2e0c766414$export$2e2bcd8739ae039 = $061d6f2e0c766414$var$withErrorBoundary;
});
parcelRegister("dMzTJ", function(module, exports) {
    $parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$2a568ff99500df53);
    $parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$2de2d0ccc17b915f);
    $parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$c1c05f9d51f7c467);
    $parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$618660b8f2aa87e2);
    const $bd6f9a689b54b40e$export$2a568ff99500df53 = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'UnknownError',
        step: 'load'
    };
    const $bd6f9a689b54b40e$export$2de2d0ccc17b915f = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'PermissionError',
        step: 'load'
    };
    const $bd6f9a689b54b40e$export$c1c05f9d51f7c467 = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'UnknownError',
        step: 'update'
    };
    const $bd6f9a689b54b40e$export$618660b8f2aa87e2 = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'ValidationError',
        step: 'update'
    };
});
parcelRegister("j6VJk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee1a9d5bb42f1de9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $6B7KL;
    var $aRoVz;
    var $dD7Zc;
    var $7zaVw;
    var $Nh1XU;
    var $f22ja;
    var $fpDmE;
    var $ljnlf;
    const $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER = 8;
    const $ee1a9d5bb42f1de9$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER, url: url, previewData: previewData })=>{
        const reload = (0, (0, parcelRequire("f22ja")).default)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const isPreviewAvailable = previewData && previewData.src !== undefined;
        const handlePreviewClose = (0, $5uXOq.useCallback)(()=>{
            if (url) reload(url, true);
        }, [
            reload,
            url
        ]);
        const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
            if (isPreviewAvailable) {
                analytics?.ui.smartLinkLozengeActionErrorOpenPreviewClickedEvent();
                return (0, (0, parcelRequire("fpDmE")).openEmbedModalWithFlexibleUiIcon)({
                    ...previewData,
                    analytics: analytics,
                    onClose: handlePreviewClose
                });
            }
        }, [
            analytics,
            handlePreviewClose,
            isPreviewAvailable,
            previewData
        ]);
        const content = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("ljnlf")).contentStyles)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
                testId: `${testId}-icon`,
                LEGACY_size: "medium",
                color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
                LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
                label: 'error',
                spacing: "spacious"
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("ljnlf")).textStyles)(maxLineNumber),
                "data-testid": `${testId}-error-message`
            }, typeof errorMessage === 'string' ? errorMessage : (0, (0, parcelRequire("fpDmE")).getFormattedMessage)(errorMessage))), isPreviewAvailable ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("ljnlf")).linkStyles)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("a", {
                target: "_blank",
                "data-testid": `${testId}-open-embed`,
                onClick: handlePreviewOpen
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).open_issue_in_jira))) : null);
        }, [
            errorMessage,
            handlePreviewOpen,
            isPreviewAvailable,
            maxLineNumber,
            testId
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("ljnlf")).dropdownItemGroupStyles),
            "data-testid": `${testId}-error-item-group`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aRoVz")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6B7KL")).default), {
            testId: `${testId}-error`
        }, content))));
    };
    var $ee1a9d5bb42f1de9$export$2e2bcd8739ae039 = $ee1a9d5bb42f1de9$var$LozengeActionError;
});
parcelRegister("ljnlf", function(module, exports) {
    $parcel$export(module.exports, "dropdownItemGroupStyles", ()=>$83fdad0d8ffe5982$export$2c40d814aeff5db);
    $parcel$export(module.exports, "contentStyles", ()=>$83fdad0d8ffe5982$export$a38ecc1ac2e6fba);
    $parcel$export(module.exports, "linkStyles", ()=>$83fdad0d8ffe5982$export$4ea5976125a01ffa);
    $parcel$export(module.exports, "textStyles", ()=>$83fdad0d8ffe5982$export$6a54c24d15b0f6ba);
    var $f8Sb3;
    var $fpDmE;
    function $83fdad0d8ffe5982$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $83fdad0d8ffe5982$export$2c40d814aeff5db = {
        name: "a7m7l8",
        styles: "button{width:220px;&:hover{background-color:inherit;cursor:default;}}"
    };
    const $83fdad0d8ffe5982$var$sharedBlockStyles = {
        name: "gx0rja",
        styles: "display:flex;gap:var(--ds-space-100, 0.5rem);line-height:1rem;min-width:0;overflow:hidden;flex-direction:row;align-items:center"
    };
    const $83fdad0d8ffe5982$export$a38ecc1ac2e6fba = (0, (0, parcelRequire("f8Sb3")).css)($83fdad0d8ffe5982$var$sharedBlockStyles, {
        marginTop: "var(--ds-space-025, 2px)",
        alignItems: 'flex-start',
        '> span, > div': {
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
        }
    });
    const $83fdad0d8ffe5982$export$4ea5976125a01ffa = (0, (0, parcelRequire("f8Sb3")).css)($83fdad0d8ffe5982$var$sharedBlockStyles, "cursor:pointer;font-size:0.875rem;margin-top:var(--ds-space-100, 8px);margin-left:var(--ds-space-400, 32px);margin-bottom:var(--ds-space-025, 2px);");
    const $83fdad0d8ffe5982$export$6a54c24d15b0f6ba = (maxLines)=>(0, (0, parcelRequire("f8Sb3")).css)("line-height:1rem;white-space:normal;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines));
});
parcelRegister("1s0lY", function(module, exports) {
    $parcel$export(module.exports, "LozengeActionErrorMessages", ()=>$47c640bee30204cc$export$4f2e371a667ad688);
    var $7zaVw;
    const $47c640bee30204cc$export$4f2e371a667ad688 = {
        noData: {
            descriptor: (0, (0, parcelRequire("7zaVw")).messages)['status_change_permission_error']
        },
        unknown: {
            descriptor: (0, (0, parcelRequire("7zaVw")).messages)['status_change_load_error']
        },
        updateFailed: {
            descriptor: (0, (0, parcelRequire("7zaVw")).messages)['status_change_update_error']
        }
    };
});
parcelRegister("kf01E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a0af43cfe2e114d$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $aRoVz;
    var $hgsSZ;
    var $3UpeD;
    const $9a0af43cfe2e114d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("3UpeD")).dropdownItemGroupStyles),
            "data-testid": `${testId}-item-group`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aRoVz")).default), null, items.map((item, idx)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hgsSZ")).default), {
                ...item,
                key: idx,
                onClick: onClick,
                testId: `${testId}-item-${idx}`
            }))));
    var $9a0af43cfe2e114d$export$2e2bcd8739ae039 = $9a0af43cfe2e114d$var$LozengeActionItemsGroup;
});
parcelRegister("hgsSZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$419e60cbfb62c454$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $lj8SI;
    const $419e60cbfb62c454$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
        const handleClick = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            if (onClick) onClick(id, text, appearance);
        }, [
            appearance,
            id,
            onClick,
            text
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
            e.currentTarget?.firstElementChild?.focus();
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            onMouseEnter: handleMouseEnter
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: handleClick,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: appearance
        }, text)));
    };
    var $419e60cbfb62c454$export$2e2bcd8739ae039 = $419e60cbfb62c454$var$LozengeActionItem;
});
parcelRegister("3UpeD", function(module, exports) {
    $parcel$export(module.exports, "triggerButtonStyles", ()=>$c3acfc8ed6aa38b4$export$ae858546f0bfd05c);
    $parcel$export(module.exports, "triggerLozengeStyles", ()=>$c3acfc8ed6aa38b4$export$5717c7336384f3a6);
    $parcel$export(module.exports, "dropdownItemGroupStyles", ()=>$c3acfc8ed6aa38b4$export$2c40d814aeff5db);
    var $f8Sb3;
    function $c3acfc8ed6aa38b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c3acfc8ed6aa38b4$export$ae858546f0bfd05c = (0, (0, parcelRequire("f8Sb3")).css)({
        all: 'unset',
        backgroundColor: 'transparent',
        color: 'unset',
        cursor: 'pointer',
        fontFamily: 'unset',
        fontSize: 'unset',
        fontStyle: 'unset',
        fontWeight: 'unset',
        fontVariant: 'unset',
        lineHeight: 0,
        padding: 0,
        textTransform: 'unset',
        border: '2px solid transparent',
        margin: "var(--ds-space-025, 2px)",
        "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
            outline: 'none',
            boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
            borderRadius: '5px'
        }
    });
    const $c3acfc8ed6aa38b4$export$5717c7336384f3a6 = {
        name: "1vr7vmn",
        styles: "align-items:center;display:flex"
    };
    const $c3acfc8ed6aa38b4$export$2c40d814aeff5db = (0, (0, parcelRequire("f8Sb3")).css)({
        maxHeight: '300px',
        overflowY: 'auto',
        button: {
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
            minHeight: '28px',
            width: '220px',
            '&:hover': {
                backgroundColor: 'inherit'
            },
            '&:focus, &:focus-visible': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
                boxSizing: 'border-box',
                boxShadow: `inset 2px 0 0 ${"var(--ds-border-selected, #0C66E4)"}`,
                outline: 'none'
            }
        }
    });
});
parcelRegister("4Dg4o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afa61527cd4f792e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $c8Oei;
    var $lj8SI;
    var $dC5iT;
    var $8CUq3;
    var $3UpeD;
    const $afa61527cd4f792e$var$chevronDownStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075',
        display: 'flex'
    });
    const $afa61527cd4f792e$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
        const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
        const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
        const lozenge = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), {
                appearance: appearance,
                isBold: isBold
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("3UpeD")).triggerLozengeStyles)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, text), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                as: "span",
                xcss: $afa61527cd4f792e$var$chevronDownStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
                color: "currentColor",
                label: "options",
                LEGACY_size: "medium",
                LEGACY_margin: "-4px -8px -4px -7px"
            })))), [
            appearance,
            isBold,
            text
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            type: "button",
            ...props,
            css: (0, (0, parcelRequire("3UpeD")).triggerButtonStyles),
            "data-action-open": isOpen,
            "data-testid": `${testId}--trigger`,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ref: triggerRef
        }, lozenge);
    };
    var $afa61527cd4f792e$export$2e2bcd8739ae039 = $afa61527cd4f792e$var$LozengeActionTrigger;
});
parcelRegister("77cM6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a723b9f793426daa$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $l5Xsv;
    function $a723b9f793426daa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a723b9f793426daa$var$styles = {
        name: "a50hvv",
        styles: "aspect-ratio:16 / 9;display:flex;width:100%;height:fit-content;@supports not (aspect-ratio: auto){padding-top:56.25%;height:0;position:relative;overflow:hidden;}> img, > span{min-height:100%;min-width:100%;max-height:100%;max-width:100%;object-fit:cover;object-position:center center;@supports not (aspect-ratio: auto){position:absolute;transform:translate(-50%, -50%);left:50%;top:50%;width:auto;height:auto;}}"
    };
    const $a723b9f793426daa$var$Media = ({ name: name, overrideCss: overrideCss, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
        if (!type || !url) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $a723b9f793426daa$var$styles,
                overrideCss
            ],
            "data-smart-element": name,
            "data-smart-element-media": type,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l5Xsv")).default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        }));
    };
    var $a723b9f793426daa$export$2e2bcd8739ae039 = $a723b9f793426daa$var$Media;
});
parcelRegister("k39kU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af078338fe34f0f5$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $fpDmE;
    const $af078338fe34f0f5$var$getStyles = (maxLines)=>(0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;white-space:normal;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines));
    const $af078338fe34f0f5$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-text' })=>{
        if (!message && !content) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $af078338fe34f0f5$var$getStyles(maxLines),
                overrideCss
            ],
            "data-separator": true,
            "data-smart-element": name,
            "data-smart-element-text": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("fpDmE")).getFormattedMessage)(message) || content);
    };
    var $af078338fe34f0f5$export$2e2bcd8739ae039 = $af078338fe34f0f5$var$Text;
});
parcelRegister("kDhrr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5972a7cc25546c87$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $Nh1XU;
    var $77cM6;
    const $5972a7cc25546c87$var$Preview = (props)=>{
        const { overrideUrl: overrideUrl, ...rest } = props ?? {};
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext));
        const data = overrideUrl ? {
            url: overrideUrl,
            type: (0, (0, parcelRequire("8dVIb")).MediaType).Image
        } : context?.preview;
        if (!data) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("77cM6")).default), {
            ...rest,
            ...data
        });
    };
    var $5972a7cc25546c87$export$2e2bcd8739ae039 = $5972a7cc25546c87$var$Preview;
});
parcelRegister("kp8aU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$673e9555bded0d05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $Nh1XU;
    var $k39kU;
    const $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES = 3;
    const $673e9555bded0d05$var$getSnippetStyles = (overrideCss)=>(0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-text, #172B4D);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;", overrideCss);
    const $673e9555bded0d05$var$SnippetElement = ({ content: overrideContent, maxLines: maxLines = $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES, overrideCss: overrideCss, ...props } = {})=>{
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k39kU")).default), {
            content: overrideContent ?? context?.snippet,
            maxLines: maxLines,
            overrideCss: $673e9555bded0d05$var$getSnippetStyles(overrideCss),
            ...props
        });
    };
    var $673e9555bded0d05$export$2e2bcd8739ae039 = $673e9555bded0d05$var$SnippetElement;
});
parcelRegister("bubxq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66554651c27d9387$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $gKZoD;
    var $ldJSL;
    var $fVnbM;
    var $BLPHT;
    var $bJeNF;
    var $3bDjY;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $fpDmE;
    var $akF1x;
    var $3Zm9O;
    function $66554651c27d9387$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $66554651c27d9387$var$styles = {
        name: "inf63k",
        styles: "display:inline-flex;line-height:1rem;> div{align-items:center;button:focus-visible{outline-offset:var(--ds-space-negative-025, -2px);}}"
    };
    const $66554651c27d9387$var$renderActionItems = (items = [], size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3Zm9O")).default), {
                item: item,
                key: idx,
                size: size,
                appearance: appearance,
                asDropDownItems: asDropDownItems,
                onActionItemClick: onActionItemClick
            }));
    const $66554651c27d9387$var$ActionGroup = ({ items: items = [], size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("BLPHT")).default));
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const ui = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiOptionContext)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("akF1x")).filterActionItems)(items, context), [
            context,
            items
        ]);
        const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
        const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
            setIsOpen(attrs.isOpen);
            if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
        }, [
            onDropdownOpenChange
        ]);
        const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
            if (isOpen) onOpenChange({
                isOpen: false
            });
        }, [
            isOpen,
            onOpenChange
        ]);
        const actionButtons = (0, $5uXOq.useMemo)(()=>{
            const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
            return $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
        }, [
            appearance,
            isMoreThenTwoItems,
            onActionItemClick,
            renderableActionItems,
            size,
            visibleButtonsNum
        ]);
        const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
            const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
            if (actionItems.length > 0) {
                const spacing = (0, (0, parcelRequire("fpDmE")).sizeToButtonSpacing)[size];
                const moreIcon = (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                    label: "more",
                    color: "currentColor"
                });
                const formatMessage = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).more_actions);
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("BLPHT")).default), {
                    isOpen: isOpen,
                    onOpenChange: onOpenChange,
                    trigger: ({ triggerRef: triggerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                            content: formatMessage,
                            hideTooltipOnClick: true,
                            testId: "action-group-more-button-tooltip",
                            tag: "span"
                        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })),
                    testId: "action-group-dropdown",
                    zIndex: ui?.zIndex
                }, $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
            }
            return null;
        }, [
            appearance,
            isMoreThenTwoItems,
            isOpen,
            onActionItemClick,
            onOpenChange,
            renderableActionItems,
            size,
            ui?.zIndex,
            visibleButtonsNum
        ]);
        return renderableActionItems.length > 0 ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $66554651c27d9387$var$styles,
            className: "actions-button-group",
            "data-action-open": isOpen
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ldJSL")).default), null, actionButtons, moreActionDropdown)) : null;
    };
    var $66554651c27d9387$export$2e2bcd8739ae039 = $66554651c27d9387$var$ActionGroup;
});
parcelRegister("bJeNF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $889f60aca54b55ef$var$_react = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $889f60aca54b55ef$var$_showMoreHorizontal = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("8U6zd")));
    var $889f60aca54b55ef$var$_more = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("3oUqw")));
    function $889f60aca54b55ef$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $889f60aca54b55ef$var$ShowMoreHorizontalIcon = (props)=>$889f60aca54b55ef$var$_react.default.createElement($889f60aca54b55ef$var$_showMoreHorizontal.default, Object.assign({
            LEGACY_fallbackIcon: $889f60aca54b55ef$var$_more.default
        }, props));
    $889f60aca54b55ef$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
    var $889f60aca54b55ef$var$_default = module.exports.default = $889f60aca54b55ef$var$ShowMoreHorizontalIcon;
});
parcelRegister("akF1x", function(module, exports) {
    $parcel$export(module.exports, "getGapSize", ()=>$8ba323b39584fd77$export$ff20be09ae01c52e);
    $parcel$export(module.exports, "getBaseStyles", ()=>$8ba323b39584fd77$export$bff8031d86bb089);
    $parcel$export(module.exports, "highlightRemoveStyles", ()=>$8ba323b39584fd77$export$1928241a6f267c0d);
    $parcel$export(module.exports, "getActionGroupStyles", ()=>$8ba323b39584fd77$export$393b0054595c3748);
    $parcel$export(module.exports, "filterActionItems", ()=>$8ba323b39584fd77$export$adbd04236f07a7d8);
    $parcel$export(module.exports, "renderChildren", ()=>$8ba323b39584fd77$export$cd762ccf1a583d69);
    $parcel$export(module.exports, "renderElementItems", ()=>$8ba323b39584fd77$export$9678d3ca18bd7526);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $91tw3;
    var $eqoQu;
    var $bubxq;
    var $1BfaB;
    function $8ba323b39584fd77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8ba323b39584fd77$export$f942619ce67b1a41 = {
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CommentCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).DueOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).LinkIcon]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Location]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Preview]: [
            'block'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Priority]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Provider]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReactCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReadTime]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Snippet]: [
            'block'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SentOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).State]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Title]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ViewCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).VoteCount]: [
            'inline'
        ]
    };
    var $8ba323b39584fd77$var$_ref2 = {
        name: "2rtvke",
        styles: "flex-direction:row;align-items:center"
    };
    var $8ba323b39584fd77$var$_ref3 = {
        name: "1ejri1g",
        styles: "flex-direction:column;align-items:flex-start"
    };
    const $8ba323b39584fd77$var$getDirectionStyles = (direction)=>{
        switch(direction){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Vertical:
                return $8ba323b39584fd77$var$_ref3;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal:
            default:
                return $8ba323b39584fd77$var$_ref2;
        }
    };
    const $8ba323b39584fd77$export$ff20be09ae01c52e = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return 1.25;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 1;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return 0.5;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 0.25;
        }
    };
    const $8ba323b39584fd77$export$bff8031d86bb089 = (direction, size)=>(0, (0, parcelRequire("f8Sb3")).css)({
            alignItems: 'center',
            display: 'flex',
            gap: `${$8ba323b39584fd77$export$ff20be09ae01c52e(size)}rem`,
            lineHeight: '1rem',
            minWidth: 0,
            overflow: 'hidden'
        }, $8ba323b39584fd77$var$getDirectionStyles(direction), "&:empty{display:none;}& > *{min-width:0;}& > [data-fit-to-content]{min-width:fit-content;}");
    const $8ba323b39584fd77$export$1928241a6f267c0d = {
        name: "1klm9nt",
        styles: "outline:none!important;outline-color:inherit;color:inherit;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none"
    };
    const $8ba323b39584fd77$var$isActionGroup = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("bubxq")).default);
    const $8ba323b39584fd77$var$isElementDisplayValid = (name, display)=>{
        return $8ba323b39584fd77$export$f942619ce67b1a41[name]?.includes(display) ?? false;
    };
    const $8ba323b39584fd77$export$f2c7ad0961800b16 = (children)=>{
        return Boolean(children.type() === null);
    };
    const $8ba323b39584fd77$var$isElementOrElementGroup = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, (0, parcelRequire("91tw3")).isFlexibleUiElement)(node) || node.type === (0, (0, parcelRequire("1BfaB")).default));
    var $8ba323b39584fd77$var$_ref = {
        name: "bceqwf",
        styles: "max-height:2rem"
    };
    const $8ba323b39584fd77$export$393b0054595c3748 = (size)=>{
        if (size === (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge) return $8ba323b39584fd77$var$_ref;
    };
    const $8ba323b39584fd77$export$adbd04236f07a7d8 = (items = [], context)=>{
        return items.filter((item)=>{
            switch(item.name){
                case (0, (0, parcelRequire("8dVIb")).ActionName).DeleteAction:
                case (0, (0, parcelRequire("8dVIb")).ActionName).EditAction:
                case (0, (0, parcelRequire("8dVIb")).ActionName).CustomAction:
                    return Boolean((0, (0, parcelRequire("8dVIb")).ActionName)[item.name]);
                default:
                    if (context?.actions === undefined) return false;
                    return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
            }
        });
    };
    const $8ba323b39584fd77$export$cd762ccf1a583d69 = (children, size)=>(0, ($parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
            if ($8ba323b39584fd77$var$isElementOrElementGroup(child) || $8ba323b39584fd77$var$isActionGroup(child)) {
                const node = child;
                const { size: childSize } = node.props;
                return (0, ($parcel$interopDefault($5uXOq))).cloneElement(node, {
                    size: childSize || size
                });
            }
            return child;
        });
    const $8ba323b39584fd77$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
        const elements = items.reduce((acc, curr, idx)=>{
            const { name: name, ...props } = curr;
            const Element = (0, parcelRequire("eqoQu"))[name];
            const typedProps = props;
            if (Element && $8ba323b39584fd77$var$isElementDisplayValid(name, display)) {
                const element = (0, ($parcel$interopDefault($5uXOq))).createElement(Element, {
                    key: idx,
                    ...typedProps
                });
                if (!$8ba323b39584fd77$export$f2c7ad0961800b16(element)) return [
                    ...acc,
                    element
                ];
            }
            return acc;
        }, []);
        if (elements.length) return elements;
    };
});
parcelRegister("1BfaB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed56962f49dee3a8$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $fpDmE;
    var $akF1x;
    function $ed56962f49dee3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $ed56962f49dee3a8$var$_ref = {
        name: "3l7cjm",
        styles: "-webkit-box-align:start;-ms-flex-align:start;justify-content:flex-start;text-align:left"
    };
    var $ed56962f49dee3a8$var$_ref2 = {
        name: "1ofqdyp",
        styles: "-webkit-box-align:end;-ms-flex-align:end;justify-content:flex-end;text-align:right"
    };
    const $ed56962f49dee3a8$var$getAlignmentStyles = (align)=>{
        switch(align){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right:
                return $ed56962f49dee3a8$var$_ref2;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Left:
            default:
                return $ed56962f49dee3a8$var$_ref;
        }
    };
    const $ed56962f49dee3a8$var$getGapStyles = (size, align)=>{
        const gap = (0, (0, parcelRequire("akF1x")).getGapSize)(size);
        if (align === (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right) return (0, (0, parcelRequire("f8Sb3")).css)({
            '> span': {
                marginLeft: `${gap}rem`
            },
            '> span:first-child': {
                marginLeft: 'initial'
            }
        });
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '> span': {
                marginRight: `${gap}rem`,
                '&:last-child': {
                    marginRight: 'initial'
                }
            }
        });
    };
    const $ed56962f49dee3a8$var$getHorizontalDirectionStyles = (size, align)=>{
        const lineHeight = (0, (0, parcelRequire("fpDmE")).getMaxLineHeight)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)("display:block;vertical-align:middle;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1, lineHeight + 'rem'), ">span,>div{vertical-align:middle;&[data-smart-element-date-time],&[data-smart-element-text]{display:inline;}}", $ed56962f49dee3a8$var$getGapStyles(size, align), ";");
    };
    const $ed56962f49dee3a8$export$91d118d179d992a4 = (direction, size, align, width, position)=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("akF1x")).getBaseStyles)(direction, size), $ed56962f49dee3a8$var$getAlignmentStyles(align), "min-width:10%;", width === (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible ? `flex: 1 3;` : '', direction === (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal ? $ed56962f49dee3a8$var$getHorizontalDirectionStyles(size, align) : '', position === (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Top ? 'align-self: flex-start;' : '');
    const $ed56962f49dee3a8$var$ElementGroup = ({ align: align = (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Left, children: children, overrideCss: overrideCss, direction: direction = (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).FitToContent, position: position = (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Center })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $ed56962f49dee3a8$export$91d118d179d992a4(direction, size, align, width, position),
                overrideCss
            ],
            "data-smart-element-group": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("akF1x")).renderChildren)(children, size));
    var $ed56962f49dee3a8$export$2e2bcd8739ae039 = $ed56962f49dee3a8$var$ElementGroup;
});
parcelRegister("3Zm9O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70338cdeec0a99e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jRHKj;
    const $70338cdeec0a99e7$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
        const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
        const handleOnClick = (0, $5uXOq.useCallback)(()=>{
            if (onActionItemClick) onActionItemClick();
            if (onClick) onClick();
        }, [
            onActionItemClick,
            onClick
        ]);
        const Action = name in (0, parcelRequire("jRHKj")) ? (0, parcelRequire("jRHKj"))[name] : undefined;
        if (!Action) return null;
        const actionProps = {
            ...props
        };
        if (hideContent && !asDropDownItems) actionProps.content = '';
        if (hideIcon) actionProps.icon = undefined;
        if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Action, {
            asDropDownItem: asDropDownItems,
            size: size,
            appearance: appearance,
            onClick: handleOnClick,
            isDisabled: isDisabled,
            ...actionProps
        });
    };
    var $70338cdeec0a99e7$export$2e2bcd8739ae039 = $70338cdeec0a99e7$var$ActionGroupItem;
});
parcelRegister("jRHKj", function(module, exports) {
    $parcel$export(module.exports, "CustomAction", ()=>(parcelRequire("23vM5")).default);
    $parcel$export(module.exports, "DeleteAction", ()=>(parcelRequire("96Kdz")).default);
    $parcel$export(module.exports, "EditAction", ()=>(parcelRequire("fEhHT")).default);
    $parcel$export(module.exports, "DownloadAction", ()=>(parcelRequire("g9G65")).default);
    $parcel$export(module.exports, "FollowAction", ()=>(parcelRequire("b6Mes")).default);
    $parcel$export(module.exports, "PreviewAction", ()=>(parcelRequire("9mTP8")).default);
    $parcel$export(module.exports, "CopyLinkAction", ()=>(parcelRequire("jep3X")).default);
    $parcel$export(module.exports, "AISummaryAction", ()=>(parcelRequire("ziZLe")).default);
    $parcel$export(module.exports, "AutomationAction", ()=>(parcelRequire("5OUwn")).default);
    $parcel$export(module.exports, "ViewRelatedLinksAction", ()=>(parcelRequire("faTeC")).default);
    var $23vM5;
    var $96Kdz;
    var $fEhHT;
    var $g9G65;
    var $b6Mes;
    var $9mTP8;
    var $jep3X;
    var $ziZLe;
    var $5OUwn;
    var $faTeC;
});
parcelRegister("23vM5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bf7d27623ce3bf9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $f6kZQ;
    var $kuVc8;
    var $bhB72;
    var $1wpdl;
    const $1bf7d27623ce3bf9$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, overrideCss: overrideCss, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
        if (!onClick) return null;
        const isStackItem = as === 'stack-item';
        const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
        const actionIcon = icon && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bhB72")).default), {
            asStackItemIcon: isStackItem,
            isDisabled: isDisabled,
            icon: icon,
            size: size,
            testId: testId
        });
        const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
        const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
        if (isStackItem) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1wpdl")).default), {
            content: content,
            icon: actionIcon,
            space: spaceInline,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onClick,
            size: size,
            testId: testId,
            tooltipMessage: tooltipMessage || content,
            xcss: xcss,
            tooltipOnHide: tooltipOnHide,
            hideTooltipOnMouseDown: hideTooltipOnMouseDown,
            hideTooltip: hideTooltip
        });
        if (isDropdownItem) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kuVc8")).default), {
            content: content,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isLoading: isLoading,
            onClick: onClick,
            testId: testId
        });
        const button = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f6kZQ")).default), {
            appearance: appearance,
            content: content,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isLoading: isLoading,
            onClick: onClick,
            overrideCss: overrideCss,
            size: size,
            testId: testId,
            tooltipMessage: tooltipMessage || content,
            isDisabled: isDisabled,
            href: href,
            ariaLabel: ariaLabel
        });
        return Wrapper !== undefined ? (0, (0, parcelRequire("f8Sb3")).jsx)(Wrapper, null, button) : button;
    };
    var $1bf7d27623ce3bf9$export$2e2bcd8739ae039 = $1bf7d27623ce3bf9$var$Action;
});
parcelRegister("f6kZQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3ee32ab04698fad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2rqOp;
    var $3bDjY;
    var $8dVIb;
    var $fpDmE;
    function $b3ee32ab04698fad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $b3ee32ab04698fad$var$_ref = {
        name: "kaj2cp",
        styles: "button, button:hover, button:focus, button:active{padding:0;> span{margin:0;}}"
    };
    const $b3ee32ab04698fad$var$getButtonStyle = (size, iconOnly)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return iconOnly ? $b3ee32ab04698fad$var$_ref : '';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    lineHeight: '1rem',
                    'button, button:hover, button:focus, button:active': [
                        {
                            lineHeight: '1rem'
                        },
                        iconOnly ? `
            padding: 0.125rem;
          ` : `
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          `
                    ]
                });
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            default:
                return '';
        }
    };
    const $b3ee32ab04698fad$var$ActionButton = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, overrideCss: overrideCss, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel })=>{
        const iconOnly = !content;
        const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
                e.preventDefault();
                handler();
            }, []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b3ee32ab04698fad$var$getButtonStyle(size, iconOnly),
                overrideCss
            ],
            "data-testid": `${testId}-button-wrapper`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2rqOp")).default), {
            appearance: appearance,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onButtonClick(onClick),
            spacing: (0, (0, parcelRequire("fpDmE")).sizeToButtonSpacing)[size],
            testId: testId,
            href: href,
            "aria-label": ariaLabel
        }, content)));
    };
    var $b3ee32ab04698fad$export$2e2bcd8739ae039 = $b3ee32ab04698fad$var$ActionButton;
});
parcelRegister("kuVc8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e656bda53d041540$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $kxcRq;
    const $e656bda53d041540$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            elemAfter: iconAfter,
            elemBefore: iconBefore,
            isDisabled: isLoading,
            onClick: (0, (0, parcelRequire("kxcRq")).handleOnClick)(onClick),
            testId: testId
        }, content);
    var $e656bda53d041540$export$2e2bcd8739ae039 = $e656bda53d041540$var$ActionDropdownItem;
});
parcelRegister("bhB72", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$345d01659b23eb38$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $8dVIb;
    var $fpDmE;
    function $345d01659b23eb38$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $345d01659b23eb38$var$getIconWidth = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return '1.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '1rem';
        }
    };
    const $345d01659b23eb38$var$getIconStyles = (isDisabled)=>(0, (0, parcelRequire("f8Sb3")).css)({
            color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
        });
    const $345d01659b23eb38$var$stackItemIconSizeStyles = (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)('20px');
    const $345d01659b23eb38$var$stackItemIconStyles = (0, (0, parcelRequire("f8Sb3")).css)($345d01659b23eb38$var$stackItemIconSizeStyles, "display:inline-block;line-height:0;padding:var(--ds-space-025, 2px);span,svg,img{line-height:0;}");
    const $345d01659b23eb38$var$newStackItemIconStyles = {
        name: "1pelf5a",
        styles: "display:inline-block;line-height:0"
    };
    const $345d01659b23eb38$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $345d01659b23eb38$var$getIconStyles(isDisabled),
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') ? asStackItemIcon ? $345d01659b23eb38$var$stackItemIconStyles : (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)($345d01659b23eb38$var$getIconWidth(size)) : $345d01659b23eb38$var$newStackItemIconStyles
            ],
            "data-testid": `${testId}-icon`
        }, icon);
    var $345d01659b23eb38$export$2e2bcd8739ae039 = $345d01659b23eb38$var$ActionIcon;
});
parcelRegister("1wpdl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $5PILj;
    const $c6ef8f3a6ac7d3ff$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5PILj")).default), {
            ...props,
            content: content
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipMessage || content,
            onHide: tooltipOnHide,
            hideTooltipOnMouseDown: hideTooltipOnMouseDown
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5PILj")).default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            }));
    var $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039 = $c6ef8f3a6ac7d3ff$var$ActionStackItem;
});
parcelRegister("5PILj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$222d00bebc6cbf68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $eZJjh;
    var $fpDmE;
    var $bhB72;
    const $222d00bebc6cbf68$var$buttonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        padding: 'space.050',
        width: '100%',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $222d00bebc6cbf68$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '20px'
    });
    const $222d00bebc6cbf68$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, xcss: xcss })=>{
        const space = spaceOption ?? (0, (0, parcelRequire("fpDmE")).getPrimitivesInlineSpaceBySize)(size);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
        }, [
            isDisabled,
            isLoading,
            onClickCallback
        ]);
        const icon = iconOption && isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bhB72")).default), {
            asStackItemIcon: true,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                testId: `${testId}-loading`
            }),
            size: size
        }) : iconOption;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: [
                $222d00bebc6cbf68$var$buttonStyles,
                xcss
            ],
            ...tooltipProps,
            onClick: onClick,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            grow: "fill",
            space: space
        }, icon, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $222d00bebc6cbf68$var$contentStyles
        }, content))));
    };
    var $222d00bebc6cbf68$export$2e2bcd8739ae039 = $222d00bebc6cbf68$var$ActionButton;
});
parcelRegister("96Kdz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddac835e19e975e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $84THj;
    var $7zaVw;
    var $23vM5;
    const $ddac835e19e975e0$var$DeleteAction = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).delete),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Delete"
            }),
            testId: "smart-action-delete-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).delete),
            ...props
        });
    var $ddac835e19e975e0$export$2e2bcd8739ae039 = $ddac835e19e975e0$var$DeleteAction;
});
parcelRegister("fEhHT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23e1c92ea69f35be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $4ChK1;
    var $7zaVw;
    var $23vM5;
    const $23e1c92ea69f35be$var$EditAction = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).edit),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4ChK1"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Edit"
            }),
            testId: "smart-action-edit-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).edit),
            ...props
        });
    var $23e1c92ea69f35be$export$2e2bcd8739ae039 = $23e1c92ea69f35be$var$EditAction;
});
parcelRegister("4ChK1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));
    var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
    function $35c87913ec905242$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $35c87913ec905242$var$EditIcon = (props)=>$35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
            LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
        }, props));
    $35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
    var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;
});
parcelRegister("5nRKm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3eb8cab3ab465b93$var$_UNSAFE_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3eb8cab3ab465b93$var$EditIcon = (props)=>$3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
        }, props));
    $3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
    var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;
});
parcelRegister("gsEeL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
    function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bfbe7921991bc4cb$var$EditIcon = (props)=>$bfbe7921991bc4cb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
        }, props, {
            newIcon: $bfbe7921991bc4cb$var$_edit.default
        }));
    $bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
    var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;
});
parcelRegister("g9G65", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fb79986052b65c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $d4dv2;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $iPVbQ;
    var $kxcRq;
    var $23vM5;
    const $4fb79986052b65c1$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("iPVbQ")).default)({
            analytics: analytics
        });
        const data = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).DownloadAction];
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (data?.downloadUrl) {
                invoke({
                    actionType: (0, (0, parcelRequire("8dVIb")).ActionName).DownloadAction,
                    actionFn: async ()=>(0, (0, parcelRequire("kxcRq")).downloadUrl)(data?.downloadUrl),
                    display: analytics?.display,
                    extensionKey: analytics?.extensionKey
                });
                if (onClickCallback) onClickCallback();
            }
        }, [
            analytics,
            data?.downloadUrl,
            invoke,
            onClickCallback
        ]);
        const isStackItem = props.as === 'stack-item';
        const label = isStackItem ? (0, (0, parcelRequire("7zaVw")).messages).download_file : (0, (0, parcelRequire("7zaVw")).messages).download;
        const tooltipMessage = isStackItem ? (0, (0, parcelRequire("7zaVw")).messages).download_description : (0, (0, parcelRequire("7zaVw")).messages).download;
        return data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), label),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d4dv2"))))), {
                spacing: "spacious",
                color: "currentColor",
                label: "Download"
            }),
            onClick: onClick,
            testId: "smart-action-download-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            ...data,
            ...props
        }) : null;
    };
    var $4fb79986052b65c1$export$2e2bcd8739ae039 = $4fb79986052b65c1$var$DownloadAction;
});
parcelRegister("d4dv2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));
    var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
    function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $98361ed174bfbb2b$var$DownloadIcon = (props)=>$98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
            LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
        }, props));
    $98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
    var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;
});
parcelRegister("EOGIN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $07ab0e2228a1635e$var$_UNSAFE_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $07ab0e2228a1635e$var$DownloadIcon = (props)=>$07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
        }, props));
    $07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
    var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;
});
parcelRegister("5krT5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
    function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3e1473e49ea22b68$var$DownloadIcon = (props)=>$3e1473e49ea22b68$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
        }, props, {
            newIcon: $3e1473e49ea22b68$var$_download.default
        }));
    $3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
    var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;
});
parcelRegister("b6Mes", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$879133cabfb6e190$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $fpDmE;
    var $3xnBw;
    var $itef5;
    const $879133cabfb6e190$var$importIconMapper = {
        goal: ()=>(parcelRequire("7p0py")).then(({ GoalIcon: GoalIcon })=>({
                    default: GoalIcon
                })),
        projects: ()=>(parcelRequire("96BFr")).then(({ ProjectsIcon: ProjectsIcon })=>({
                    default: ProjectsIcon
                }))
    };
    const $879133cabfb6e190$var$getIcon = (stackIconType)=>{
        const importFn = $879133cabfb6e190$var$importIconMapper[stackIconType];
        if (!importFn) return null;
        return (0, (0, parcelRequire("fpDmE")).importIcon)(importFn);
    };
    const $879133cabfb6e190$var$FollowAction = (props)=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).FollowAction];
        if (!context || !actionData) return null;
        const { value: value, isProject: isProject, ...data } = actionData;
        const isStackItem = props.as === 'stack-item';
        const message = value ? (0, (0, parcelRequire("7zaVw")).messages).follow : (0, (0, parcelRequire("7zaVw")).messages).unfollow;
        const projectMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_project : (0, (0, parcelRequire("7zaVw")).messages).unfollow_project;
        const goalMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_goal : (0, (0, parcelRequire("7zaVw")).messages).unfollow_goal;
        const stackMessage = isProject ? projectMessage : goalMessage;
        const label = isStackItem ? stackMessage : message;
        const projectTooltipMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_project_description : (0, (0, parcelRequire("7zaVw")).messages).unfollow_project_description;
        const goalTooltipMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_goal_description : (0, (0, parcelRequire("7zaVw")).messages).unfollow_goal_description;
        const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
        const tooltipMessage = isStackItem ? stackTooltipMessage : message;
        const stackIconType = isProject ? 'projects' : 'goal';
        const ImportedIcon = $879133cabfb6e190$var$getIcon(stackIconType);
        const followIcon = (0, ($parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
            label: "Follow",
            testId: `smart-action-follow-action-${stackIconType}-icon`
        });
        const handleError = ()=>{
            const { onError: onErrorCallback } = props;
            const errorMessage = (0, (0, parcelRequire("itef5")).getFollowActionErrorMessage)(isProject, value);
            onErrorCallback?.({
                title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), errorMessage),
                appearance: 'error'
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3xnBw")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), label),
            icon: followIcon,
            testId: "smart-action-follow-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            ...data,
            ...props,
            onError: handleError
        });
    };
    var $879133cabfb6e190$export$2e2bcd8739ae039 = $879133cabfb6e190$var$FollowAction;
});
parcelRegister("3xnBw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35d557ed1ef6412d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $Nh1XU;
    var $3q2sI;
    var $euMlu;
    var $f22ja;
    var $69hr0;
    var $23vM5;
    const $35d557ed1ef6412d$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("3q2sI")).default)();
        const reload = (0, (0, parcelRequire("f22ja")).default)();
        const handleClick = (0, $5uXOq.useCallback)(async ()=>{
            if (action) {
                const smartLinkActionType = action.action?.actionType;
                try {
                    setIsLoading(true);
                    analytics?.ui.smartLinkServerActionClickedEvent({
                        smartLinkActionType: smartLinkActionType
                    });
                    analytics?.track.smartLinkQuickActionStarted({
                        smartLinkActionType: smartLinkActionType
                    });
                    const request = (0, (0, parcelRequire("69hr0")).default)(action);
                    await invoke(request);
                    analytics?.track.smartLinkQuickActionSuccess({
                        smartLinkActionType: smartLinkActionType
                    });
                    if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                    setIsLoading(false);
                    if (onClick) onClick();
                } catch (err) {
                    setIsLoading(false);
                    analytics?.track.smartLinkQuickActionFailed({
                        smartLinkActionType: smartLinkActionType,
                        reason: (0, (0, parcelRequire("euMlu")).getInvokeFailureReason)(err)
                    });
                    onErrorCallback?.();
                }
            }
        }, [
            action,
            analytics?.track,
            analytics?.ui,
            invoke,
            onClick,
            onErrorCallback,
            reload
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            ...props,
            isLoading: isLoading,
            onClick: handleClick
        });
    };
    var $35d557ed1ef6412d$export$2e2bcd8739ae039 = $35d557ed1ef6412d$var$ServerAction;
});
parcelRegister("69hr0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22d791805237a266$export$2e2bcd8739ae039);
    const $22d791805237a266$var$createInvokeRequest = (request, payload)=>({
            action: {
                ...request.action,
                payload: payload
            },
            providerKey: request.providerKey
        });
    var $22d791805237a266$export$2e2bcd8739ae039 = $22d791805237a266$var$createInvokeRequest;
});
parcelRegister("itef5", function(module, exports) {
    $parcel$export(module.exports, "getFollowActionErrorMessage", ()=>$d31a392ae92ce299$export$49248678d3914625);
    var $7zaVw;
    const $d31a392ae92ce299$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
        if (isProject && isFollow) return (0, (0, parcelRequire("7zaVw")).messages).follow_project_error;
        if (isProject && !isFollow) return (0, (0, parcelRequire("7zaVw")).messages).unfollow_project_error;
        if (!isProject && isFollow) return (0, (0, parcelRequire("7zaVw")).messages).follow_goal_error;
        if (!isProject && !isFollow) return (0, (0, parcelRequire("7zaVw")).messages).unfollow_goal_error;
        return (0, (0, parcelRequire("7zaVw")).messages).generic_error_message;
    };
});
parcelRegister("7p0py", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ftS7u").then(()=>parcelRequire('5UxRR'));
});
parcelRegister("96BFr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3uQsu")
    ]).then(()=>parcelRequire('gsEJ1'));
});
parcelRegister("9mTP8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ea9170f77974c10$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $5JpK2;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $iPVbQ;
    var $fpDmE;
    var $23vM5;
    const $3ea9170f77974c10$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("iPVbQ")).default)({
            analytics: analytics
        });
        const data = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).PreviewAction];
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (data) invoke({
                actionType: (0, (0, parcelRequire("8dVIb")).ActionName).PreviewAction,
                actionFn: async ()=>(0, (0, parcelRequire("fpDmE")).openEmbedModalWithFlexibleUiIcon)({
                        download: data?.downloadUrl,
                        extensionKey: analytics?.extensionKey,
                        analytics: analytics,
                        ...data
                    }),
                display: analytics?.display,
                extensionKey: analytics?.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }, [
            analytics,
            data,
            invoke,
            onClickCallback
        ]);
        const isStackItem = props.as === 'stack-item';
        const tooltipMessage = isStackItem ? (0, (0, parcelRequire("7zaVw")).messages).preview_description : (0, (0, parcelRequire("7zaVw")).messages).preview_improved;
        return data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).preview_improved),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5JpK2"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Open preview"
            }),
            onClick: onClick,
            testId: "smart-action-preview-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            hideTooltipOnMouseDown: true,
            ...data,
            ...props
        }) : null;
    };
    var $3ea9170f77974c10$export$2e2bcd8739ae039 = $3ea9170f77974c10$var$PreviewAction;
});
parcelRegister("5JpK2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));
    var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
    function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>$42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
            LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
        }, props));
    $42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
    var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;
});
parcelRegister("l14Zy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f4cd903aabaa4c53$var$_react = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f4cd903aabaa4c53$var$_UNSAFE_baseNew = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $f4cd903aabaa4c53$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f4cd903aabaa4c53$var$GrowDiagonalIcon = (props)=>$f4cd903aabaa4c53$var$_react.default.createElement($f4cd903aabaa4c53$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
        }, props));
    $f4cd903aabaa4c53$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
    var $f4cd903aabaa4c53$var$_default = module.exports.default = $f4cd903aabaa4c53$var$GrowDiagonalIcon;
});
parcelRegister("6LXPU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4ee58c13163bfe09$var$_react = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4ee58c13163bfe09$var$_growDiagonal = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("l14Zy")));
    function $4ee58c13163bfe09$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4ee58c13163bfe09$var$MediaServicesActualSizeIcon = (props)=>$4ee58c13163bfe09$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
        }, props, {
            newIcon: $4ee58c13163bfe09$var$_growDiagonal.default
        }));
    $4ee58c13163bfe09$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
    var $4ee58c13163bfe09$var$_default = module.exports.default = $4ee58c13163bfe09$var$MediaServicesActualSizeIcon;
});
parcelRegister("jep3X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d1e0763b6a84021$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $jOyH3;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $iPVbQ;
    var $23vM5;
    const $0d1e0763b6a84021$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("iPVbQ")).default)({
            analytics: analytics
        });
        const data = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).CopyLinkAction];
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, (0, parcelRequire("7zaVw")).messages).copy_url_to_clipboard);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (data && data.url) invoke({
                actionType: (0, (0, parcelRequire("8dVIb")).ActionName).CopyLinkAction,
                actionFn: async ()=>{
                    await navigator.clipboard.writeText(data.url ?? '');
                    setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copied_url_to_clipboard);
                },
                display: analytics?.display,
                extensionKey: analytics?.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }, [
            analytics,
            data,
            invoke,
            onClickCallback
        ]);
        return data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).copy_url_to_clipboard),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jOyH3"))))), {
                color: "currentColor",
                label: "copy url",
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            onClick: onClick,
            testId: "smart-action-copy-link-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            tooltipOnHide: ()=>setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copy_url_to_clipboard),
            ...data,
            ...props
        }) : null;
    };
    var $0d1e0763b6a84021$export$2e2bcd8739ae039 = $0d1e0763b6a84021$var$CopyLinkAction;
});
parcelRegister("ziZLe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b53b1e1aa704061$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $dgRei;
    const $8b53b1e1aa704061$var$AISummaryAction = (props)=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).InternalActionName).AISummaryAction];
        return actionData ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dgRei")).AISummaryActionComponent), {
            ...actionData,
            ...props
        }) : null;
    };
    var $8b53b1e1aa704061$export$2e2bcd8739ae039 = $8b53b1e1aa704061$var$AISummaryAction;
});
parcelRegister("dgRei", function(module, exports) {
    $parcel$export(module.exports, "AISummaryActionComponent", ()=>$a6e4dbdfe418b2c1$export$8eed96bc6d982595);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $1MeuC;
    var $8UCLX;
    var $jdA9V;
    const $a6e4dbdfe418b2c1$export$8eed96bc6d982595 = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("1MeuC")).default));
        const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
        const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, (0, parcelRequire("1MeuC")).default)(url);
        (0, $5uXOq.useEffect)(()=>{
            onLoadingChange?.(status === 'loading');
        }, [
            onLoadingChange,
            status
        ]);
        return status === 'done' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdA9V")).CopySummaryAction), {
            ...props,
            testId: testId,
            content: content
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8UCLX")).AISummariseAction), {
            ...props,
            testId: testId,
            summariseUrl: summariseUrl,
            status: status
        });
    };
});
parcelRegister("8UCLX", function(module, exports) {
    $parcel$export(module.exports, "AISummariseAction", ()=>$a2971ac1720627ee$export$75a19de44af58722);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $jps85;
    var $a1vqi;
    var $7zaVw;
    var $8z1HA;
    var $23vM5;
    var $blyr7;
    function $a2971ac1720627ee$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const onCompleted = (0, $5uXOq.useCallback)((state)=>{
            if (state?.status === 'error') onErrorCallback?.((0, (0, parcelRequire("blyr7")).getErrorMessage)(state.error));
        }, [
            onErrorCallback
        ]);
        const handleActionClick = (0, $5uXOq.useCallback)(()=>{
            fireEvent('ui.button.clicked.aiSummary', {});
            fireEvent('track.aiInteraction.initiated', {
                aiFeatureName: 'Smart Links Summary',
                proactiveAIGenerated: 0,
                userGeneratedAI: 1
            });
            summariseUrl()?.then(onCompleted, onCompleted);
            onClickCallback?.();
        }, [
            fireEvent,
            onClickCallback,
            onCompleted,
            summariseUrl
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).ai_summary_action),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jps85"))))), {
                spacing: "spacious",
                color: "currentColor",
                label: "Summarise with AI",
                LEGACY_fallbackIcon: (0, (0, parcelRequire("8z1HA")).default)
            }),
            onClick: handleActionClick,
            testId: `${testId}-summarise-action`,
            isLoading: status === 'loading',
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).ai_summary_action_description),
            ...props
        });
    }
});
parcelRegister("jps85", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e2162c0618e136c6$var$_UNSAFE_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e2162c0618e136c6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>$e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
        }, props));
    $e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
    var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;
});
parcelRegister("8z1HA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f8c2f1acb4b6b88$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV6Te;
    const $7f8c2f1acb4b6b88$var$AiIcon = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dV6Te")).default), props, (0, ($parcel$interopDefault($5uXOq))).createElement("g", null, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
            fill: "var(--ds-icon, #44546F)"
        })));
    var $7f8c2f1acb4b6b88$export$2e2bcd8739ae039 = $7f8c2f1acb4b6b88$var$AiIcon;
});
parcelRegister("blyr7", function(module, exports) {
    $parcel$export(module.exports, "getErrorMessage", ()=>$2b1346f84062e88d$export$82f46aa4e6535a45);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $cnaAy;
    var $RbANO;
    var $1r4gF;
    const $2b1346f84062e88d$export$82f46aa4e6535a45 = (error)=>{
        const { message: message, url: url } = (0, (0, parcelRequire("cnaAy")).getAISummaryErrorMessage)(error);
        return {
            appearance: 'error',
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("RbANO")).default), {
                reason: error
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...message,
                values: {
                    a: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1r4gF")).default), {
                            href: url
                        }, chunks)
                }
            }))
        };
    };
});
parcelRegister("RbANO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$402c39c7523f0dd1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1vqi;
    const $402c39c7523f0dd1$var$AIEventErrorViewed = ({ reason: reason })=>{
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            fireEvent('ui.error.viewed.aiSummary', {
                reason: reason
            });
        }, [
            fireEvent,
            reason
        ]);
        return null;
    };
    var $402c39c7523f0dd1$export$2e2bcd8739ae039 = $402c39c7523f0dd1$var$AIEventErrorViewed;
});
parcelRegister("1r4gF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff8f369a3b340dfb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    const $ff8f369a3b340dfb$var$AILearnMoreAnchor = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: (0, (0, parcelRequire("8dVIb")).CONTENT_URL_AI),
            target: "_blank",
            rel: "noopener noreferrer",
            ...props
        }, children);
    var $ff8f369a3b340dfb$export$2e2bcd8739ae039 = $ff8f369a3b340dfb$var$AILearnMoreAnchor;
});
parcelRegister("jdA9V", function(module, exports) {
    $parcel$export(module.exports, "CopySummaryAction", ()=>$2e1357a85e616794$export$cfa1d3eed9a61059);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $3Fq5M;
    var $a1vqi;
    var $7zaVw;
    var $23vM5;
    function $2e1357a85e616794$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, (0, parcelRequire("7zaVw")).messages).copy_summary_action_description);
        const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
            fireEvent('ui.button.clicked.copySummary', {});
            await navigator.clipboard.writeText(content ?? '');
            setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copied_summary_action_description);
            onClickCallback?.();
        }, [
            fireEvent,
            onClickCallback,
            content
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).copy_summary_action),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Copy Summary"
            }),
            onClick: handleCopySummaryClick,
            testId: `${testId}-copy-summary-action`,
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            tooltipOnHide: ()=>setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copy_summary_action_description),
            ...props
        });
    }
});
parcelRegister("3Fq5M", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));
    var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
    function $2ab970d264bef26f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ab970d264bef26f$var$CopyIcon = (props)=>$2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
        }, props));
    $2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
    var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;
});
parcelRegister("8w53e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63353af41c1756be$var$_UNSAFE_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $63353af41c1756be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63353af41c1756be$var$CopyIcon = (props)=>$63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
    var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;
});
parcelRegister("eE13R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
    function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aa959fe1f5a86e24$var$CopyIcon = (props)=>$aa959fe1f5a86e24$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $aa959fe1f5a86e24$var$_copy.default
        }));
    $aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
    var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;
});
parcelRegister("5OUwn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fd2a7343c5a2622$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $4ldhu;
    var $a1vqi;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $7HAq8;
    var $23vM5;
    var $jhUB5;
    var $3Lbo8;
    const $9fd2a7343c5a2622$var$AutomationModal = (0, $5uXOq.lazy)(()=>(parcelRequire("75mQu")));
    const $9fd2a7343c5a2622$var$AutomationAction = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const modal = (0, (0, parcelRequire("7HAq8")).useSmartLinkModal)();
        const { onClick: onClickCallback } = props;
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const automationActionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).AutomationAction];
        const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
            const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
            fireEvent('ui.button.clicked.automationAction', {});
            const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, (0, parcelRequire("3Lbo8")).getModalContent)(product, resourceType) || {};
            const automationModalTitle = modalTitle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), modalTitle) : undefined;
            const automationModalDescription = modalDescription ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...modalDescription,
                values: {
                    name: objectName,
                    b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("strong", null, chunks),
                    br: (0, ($parcel$interopDefault($5uXOq))).createElement("br", null)
                }
            }) : undefined;
            modal.open((0, ($parcel$interopDefault($5uXOq))).createElement($9fd2a7343c5a2622$var$AutomationModal, {
                baseAutomationUrl: baseAutomationUrl,
                objectAri: objectAri,
                siteAri: siteAri,
                canManageAutomation: canManageAutomation,
                analyticsSource: analyticsSource,
                modalTitle: automationModalTitle,
                modalDescription: automationModalDescription,
                onClose: ()=>modal.close()
            }));
            onClickCallback?.();
        }, [
            modal,
            onClickCallback,
            fireEvent
        ]);
        if (!automationActionData) return null;
        const automationActionTitle = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).automation_action_title);
        const automationActionTooltip = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).automation_action_tooltip);
        const automationActionIconLabel = formatMessage((0, (0, parcelRequire("7zaVw")).messages).automation_action_icon_label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: automationActionTitle,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4ldhu"))))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, (0, parcelRequire("jhUB5")).default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        }));
    };
    var $9fd2a7343c5a2622$export$2e2bcd8739ae039 = $9fd2a7343c5a2622$var$AutomationAction;
});
parcelRegister("4ldhu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $32936cf628dec798$var$_UNSAFE_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $32936cf628dec798$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $32936cf628dec798$var$AutomationIcon = (props)=>$32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m6 15.25-.723-.2a.75.75 0 0 0 1.253.73zM13.25 8l.53.53a.75.75 0 0 0-.53-1.28zM10 .75l.723.2A.75.75 0 0 0 9.47.22zM2.75 8l-.53-.53a.75.75 0 0 0 .53 1.28zm3.78 7.78 7.25-7.25-1.06-1.06-7.25 7.25zm6.72-8.53H8v1.5h5.25zm-4.527.95 2-7.25-1.446-.4-2 7.25zM9.47.22 2.22 7.47l1.06 1.06 7.25-7.25zM2.75 8.75H8v-1.5H2.75zm4.527-.95-2 7.25 1.446.4 2-7.25z"/>`
        }, props));
    $32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
    var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;
});
parcelRegister("jhUB5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01cb97a67e76ec42$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $01cb97a67e76ec42$var$AutomationManualTriggersGlyph = ({ label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            "aria-label": label,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L7 12H17L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }));
    var $01cb97a67e76ec42$export$2e2bcd8739ae039 = $01cb97a67e76ec42$var$AutomationManualTriggersGlyph;
});
parcelRegister("3Lbo8", function(module, exports) {
    $parcel$export(module.exports, "getModalContent", ()=>$6b74a4060fa13021$export$93e707b363eaf5c8);
    var $7zaVw;
    const $6b74a4060fa13021$export$93e707b363eaf5c8 = (product, resourceType)=>{
        const modalContentMap = {
            confluence: {
                page: {
                    modalTitle: (0, (0, parcelRequire("7zaVw")).messages).automation_action_confluence_page_modal_title,
                    modalDescription: (0, (0, parcelRequire("7zaVw")).messages).automation_action_confluence_page_modal_description
                }
            }
        };
        return modalContentMap?.[product]?.[resourceType];
    };
});
parcelRegister("75mQu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lchYl")
    ]).then(()=>parcelRequire('1Rjyb'));
});
parcelRegister("faTeC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b95acafe5e8a7ba5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $a1vqi;
    var $7zaVw;
    var $Nh1XU;
    var $7HAq8;
    var $23vM5;
    var $k98Kd;
    const $b95acafe5e8a7ba5$var$RelatedLinksModal = (0, $5uXOq.lazy)(()=>(parcelRequire("eOjGT")));
    const $b95acafe5e8a7ba5$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
        const modal = (0, (0, parcelRequire("7HAq8")).useSmartLinkModal)();
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.ViewRelatedLinksAction;
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            const ari = actionData?.ari;
            if (ari) modal.open((0, (0, parcelRequire("f8Sb3")).jsx)($b95acafe5e8a7ba5$var$RelatedLinksModal, {
                ari: ari,
                showModal: true,
                onClose: ()=>modal.close()
            }));
            fireEvent('ui.button.clicked.relatedLinks', {});
            onClickCallback?.();
        }, [
            actionData?.ari,
            fireEvent,
            modal,
            onClickCallback
        ]);
        return actionData ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("23vM5")).default), {
            content: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).related_links_view_related_urls),
            icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k98Kd")).default), null),
            onClick: onClick,
            testId: "smart-action-view-related-links-action",
            ariaLabel: "View most recent pages or content types coming from or found on this link",
            ...props
        }) : null;
    };
    var $b95acafe5e8a7ba5$export$2e2bcd8739ae039 = $b95acafe5e8a7ba5$var$ViewRelatedLinksAction;
});
parcelRegister("k98Kd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c9aac1bc71ae3e1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ehOs2;
    function $7c9aac1bc71ae3e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7c9aac1bc71ae3e1$var$rotateSvg = {
        name: "9v7l5f",
        styles: "transform:rotate(180deg);display:inline-block"
    };
    const $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7c9aac1bc71ae3e1$var$rotateSvg
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("ehOs2"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        }));
    var $7c9aac1bc71ae3e1$export$2e2bcd8739ae039 = $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon;
});
parcelRegister("ehOs2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));
    var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
    function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>$a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
            LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
        }, props));
    $a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
    var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;
});
parcelRegister("a5U1O", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7595d510a7cf11ee$var$_UNSAFE_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>$7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
        }, props));
    $7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
    var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;
});
parcelRegister("hxodJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
    function $cc484e6d94653edf$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>$cc484e6d94653edf$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
        }, props, {
            newIcon: $cc484e6d94653edf$var$_childIssues.default
        }));
    $cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
    var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;
});
parcelRegister("eOjGT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dXU8n")
    ]).then(()=>parcelRequire('14MtF'));
});
parcelRegister("dghu0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96a6d91fb5d77548$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $akF1x;
    const $96a6d91fb5d77548$var$getBlockStyles = (direction, size)=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("akF1x")).getBaseStyles)(direction, size), " ", (0, (0, parcelRequire("akF1x")).highlightRemoveStyles), " justify-content:flex-start;[data-separator]+[data-separator]:before{content:'\u2022';margin-right:", (0, (0, parcelRequire("akF1x")).getGapSize)(size), "rem;}[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch, "']+[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch, "']:before{content:'\u2192';}[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch, "']+[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch, "']:before{content:'\u2190';}");
    const $96a6d91fb5d77548$var$Block = ({ children: children, direction: direction = (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-block', overrideCss: overrideCss, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd })=>{
        (0, $5uXOq.useEffect)(()=>{
            onRender && onRender();
        }, [
            onRender
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $96a6d91fb5d77548$var$getBlockStyles(direction, size),
                overrideCss
            ],
            "data-smart-block": true,
            "data-testid": testId,
            onTransitionEnd: onTransitionEnd,
            ref: blockRef
        }, (0, (0, parcelRequire("akF1x")).renderChildren)(children, size));
    };
    var $96a6d91fb5d77548$export$2e2bcd8739ae039 = $96a6d91fb5d77548$var$Block;
});
parcelRegister("gg6Qm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61dcf60a0013442f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $fpDmE;
    var $dghu0;
    var $1BfaB;
    var $akF1x;
    const $61dcf60a0013442f$var$DEFAULT_MAX_LINES = 2;
    const $61dcf60a0013442f$var$MAXIMUM_MAX_LINES = 2;
    const $61dcf60a0013442f$var$MINIMUM_MAX_LINES = 1;
    const $61dcf60a0013442f$var$getElementGroupStyles = (size, maxLines)=>{
        const lineHeight = (0, (0, parcelRequire("fpDmE")).getMaxLineHeight)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)({
            lineHeight: `${lineHeight}rem`
        }, (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines, lineHeight + 'rem'));
    };
    const $61dcf60a0013442f$var$getMaxLines = (maxLines)=>{
        if (maxLines > $61dcf60a0013442f$var$MAXIMUM_MAX_LINES) return $61dcf60a0013442f$var$DEFAULT_MAX_LINES;
        if (maxLines < $61dcf60a0013442f$var$MINIMUM_MAX_LINES) return $61dcf60a0013442f$var$MINIMUM_MAX_LINES;
        return maxLines;
    };
    const $61dcf60a0013442f$var$MetadataBlock = ({ maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES, status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
        if (primary.length === 0 && secondary.length === 0 || status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved) return null;
        const primaryElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(primary);
        const secondaryElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(secondary);
        const { size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium } = blockProps;
        const elementGroupStyles = $61dcf60a0013442f$var$getElementGroupStyles(size, $61dcf60a0013442f$var$getMaxLines(maxLines));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-resolved-view`
        }, primaryElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Left,
            overrideCss: elementGroupStyles,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible
        }, primaryElements), secondaryElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right,
            overrideCss: elementGroupStyles,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible
        }, secondaryElements));
    };
    var $61dcf60a0013442f$export$2e2bcd8739ae039 = $61dcf60a0013442f$var$MetadataBlock;
});
parcelRegister("hYQw7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61b44b31e2da1312$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $cElbi;
    const $61b44b31e2da1312$var$PreviewBlock = ({ status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cElbi")).default), {
            ...blockProps,
            testId: testId,
            overrideUrl: overrideUrl
        });
    };
    var $61b44b31e2da1312$export$2e2bcd8739ae039 = $61b44b31e2da1312$var$PreviewBlock;
});
parcelRegister("cElbi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64981f7edc74268b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $kDhrr;
    var $dghu0;
    function $64981f7edc74268b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $64981f7edc74268b$var$_ref = {
        name: "ooh6hm",
        styles: "margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1);&:first-of-type{margin-top:calc(var(--container-padding) * -1);}&:last-of-type{margin-bottom:calc(var(--container-padding) * -1);}"
    };
    const $64981f7edc74268b$var$getPreviewBlockStyles = (placement, ignoreContainerPadding)=>{
        if (placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Left || placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
            return (0, (0, parcelRequire("f8Sb3")).css)("position:absolute;top:", containerPadding, ";bottom:", containerPadding, ";width:calc(var(--preview-block-width) - ", containerPadding, ");", placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Left ? `left: ${containerPadding};` : '', " ", placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Right ? `right: ${containerPadding};` : '', " [data-smart-element-media='image']{aspect-ratio:unset;padding-top:unset;width:100%;height:100%;object-fit:cover;}");
        }
        if (ignoreContainerPadding) return $64981f7edc74268b$var$_ref;
    };
    const $64981f7edc74268b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, overrideCss: overrideCss, placement: placement, testId: testId, overrideUrl: overrideUrl, ...blockProps })=>{
        const [styles, setStyles] = (0, $5uXOq.useState)(overrideCss);
        const updateStyles = (0, $5uXOq.useCallback)(()=>{
            setStyles((0, (0, parcelRequire("f8Sb3")).css)($64981f7edc74268b$var$getPreviewBlockStyles(placement, ignoreContainerPadding), overrideCss));
        }, [
            ignoreContainerPadding,
            overrideCss,
            placement
        ]);
        (0, $5uXOq.useEffect)(()=>{
            updateStyles();
        }, [
            ignoreContainerPadding,
            overrideCss,
            placement,
            updateStyles
        ]);
        const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
            updateStyles();
        }, [
            updateStyles
        ]);
        const handleOnError = (0, $5uXOq.useCallback)(()=>{
            if (onError) onError();
        }, [
            onError
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            overrideCss: styles,
            testId: `${testId}-resolved-view`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kDhrr")).default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        }));
    };
    var $64981f7edc74268b$export$2e2bcd8739ae039 = $64981f7edc74268b$var$PreviewBlockResolvedView;
});
parcelRegister("1JaZ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c880264dd5ccb40b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $kp8aU;
    var $fpDmE;
    var $dghu0;
    const $c880264dd5ccb40b$var$DEFAULT_MAX_LINES = 3;
    const $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES = 6;
    const $c880264dd5ccb40b$var$MINIMUM_MAX_LINES = 1;
    const $c880264dd5ccb40b$var$SnippetBlock = ({ maxLines: maxLines = $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved && !text) return null;
        const snippetMaxLines = (0, (0, parcelRequire("fpDmE")).getMaxLines)(maxLines, $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES, $c880264dd5ccb40b$var$MINIMUM_MAX_LINES);
        const statusTestId = !text ? 'resolved' : 'non-resolved';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-${statusTestId}-view`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kp8aU")).default), {
            maxLines: snippetMaxLines,
            content: text
        }));
    };
    var $c880264dd5ccb40b$export$2e2bcd8739ae039 = $c880264dd5ccb40b$var$SnippetBlock;
});
parcelRegister("buvhv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93b66054384f48ec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $4URMI;
    var $eqoQu;
    var $bubxq;
    var $fkxMX;
    var $bXy5i;
    var $jHa2h;
    function $93b66054384f48ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $93b66054384f48ec$var$_ref = {
        name: "11eaz",
        styles: ".actions-button-group{opacity:0;}&:hover .actions-button-group, .actions-button-group:focus-within{opacity:1;}"
    };
    const $93b66054384f48ec$var$getActionStyles = (showOnHover, isOpen)=>{
        if (showOnHover && !isOpen) return $93b66054384f48ec$var$_ref;
    };
    const $93b66054384f48ec$var$getTitleBlockViewComponent = (status)=>{
        switch(status){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolving:
                return 0, (0, parcelRequire("jHa2h")).default;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved:
                return 0, (0, parcelRequire("bXy5i")).default;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Unauthorized:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Forbidden:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).NotFound:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Errored:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback:
            default:
                return 0, (0, parcelRequire("fkxMX")).default;
        }
    };
    const $93b66054384f48ec$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, overrideCss: overrideCss, status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, ...props })=>{
        if (hideRetry && props.retry) delete props.retry;
        const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
        const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
            setActionDropdownOpen(isOpen);
            if (onActionMenuOpenChange) onActionMenuOpenChange({
                isOpen: isOpen
            });
        }, [
            onActionMenuOpenChange
        ]);
        const actionGroup = actions.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bubxq")).default), {
            items: actions,
            visibleButtonsNum: showActionOnHover ? 1 : 2,
            onDropdownOpenChange: onDropdownOpenChange
        });
        const actionStyles = $93b66054384f48ec$var$getActionStyles(showActionOnHover, actionDropdownOpen);
        const combinedCss = (0, (0, parcelRequire("f8Sb3")).css)(actionStyles, overrideCss);
        const overrideText = !!text ? {
            text: text
        } : {};
        const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)();
        const title = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).Title), {
            hideTooltip: hideTitleTooltip,
            maxLines: maxLines,
            onClick: onClick,
            onMouseDown: onMouseDown,
            target: anchorTarget,
            theme: theme,
            ...overrideText
        });
        const Component = $93b66054384f48ec$var$getTitleBlockViewComponent(status);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            actionGroup: actionGroup,
            overrideCss: combinedCss,
            testId: testId,
            title: title,
            metadataPosition: metadataPosition,
            hideIcon: hideIcon,
            icon: icon
        });
    };
    var $93b66054384f48ec$export$2e2bcd8739ae039 = $93b66054384f48ec$var$TitleBlock;
});
parcelRegister("fkxMX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcbea6814ca213c7$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ousew;
    var $8dVIb;
    var $eqoQu;
    var $fpDmE;
    var $dghu0;
    var $1BfaB;
    function $dcbea6814ca213c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $dcbea6814ca213c7$var$actionStyles = {
        name: "r982j0",
        styles: "cursor:pointer;:hover{color:var(--ds-text-subtle, #8993A4);text-decoration:underline;}"
    };
    const $dcbea6814ca213c7$var$getMessageStyles = (size, hasAction)=>{
        const sizeStyles = (0, (0, parcelRequire("fpDmE")).getLinkSizeStyles)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)("flex:1 1 auto;justify-content:flex-end;", hasAction ? $dcbea6814ca213c7$var$actionStyles : '', sizeStyles, (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1, (0, (0, parcelRequire("fpDmE")).getLinkLineHeight)(size)), {
            color: "var(--ds-text-disabled, #6B778C)",
            ':focus': {
                outline: `${"var(--ds-border-focused, #388BFF)"} solid 2px`
            }
        });
    };
    const $dcbea6814ca213c7$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
        const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
        const { size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium } = blockProps;
        const hasAction = onClick !== undefined;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-errored-view`
        }, !hideIcon && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eqoQu")).LinkIcon), {
            overrideIcon: icon,
            position: position
        }), title, descriptor && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            className: hasAction ? 'has-action' : '',
            css: $dcbea6814ca213c7$var$getMessageStyles(size, hasAction),
            onClick: onClick,
            "data-testid": `${testId}-errored-view-message`,
            tabIndex: hasAction ? 0 : -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            ...descriptor,
            values: values
        }))), actionGroup);
    };
    var $dcbea6814ca213c7$export$2e2bcd8739ae039 = $dcbea6814ca213c7$var$TitleBlockErroredView;
});
parcelRegister("bXy5i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2967317da51f9f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $eqoQu;
    var $dghu0;
    var $1BfaB;
    var $akF1x;
    function $e2967317da51f9f7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $e2967317da51f9f7$var$_ref = {
        name: "v43pxc",
        styles: "gap:var(--ds-space-050, 0.25rem)"
    };
    const $e2967317da51f9f7$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
        const metadataElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(metadata);
        const subtitleElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(subtitle);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-resolved-view`
        }, !hideIcon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).LinkIcon), {
            overrideIcon: icon,
            position: position
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Vertical,
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible,
            overrideCss: $e2967317da51f9f7$var$_ref
        }, title, subtitleElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal
        }, subtitleElements)), metadataElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right,
            position: metadataPosition ?? (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Center
        }, metadataElements), actionGroup);
    };
    var $e2967317da51f9f7$export$2e2bcd8739ae039 = $e2967317da51f9f7$var$TitleBlockResolvedView;
});
parcelRegister("jHa2h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$045d1b1e49cae759$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $gU02S;
    var $fpDmE;
    var $dghu0;
    const $045d1b1e49cae759$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
        const { size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium } = blockProps;
        const iconWidth = (0, (0, parcelRequire("fpDmE")).getIconWidth)(size);
        const iconStyles = (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)(iconWidth);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-resolving-view`
        }, !hideIcon && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: iconStyles,
            "data-testid": `${testId}-icon`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), {
            testId: `${testId}-icon-loading`
        })), title, actionGroup);
    };
    var $045d1b1e49cae759$export$2e2bcd8739ae039 = $045d1b1e49cae759$var$TitleBlockResolvingView;
});
parcelRegister("31Qmi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c054be88d64fd564$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $2NMNM;
    var $dA1Ga;
    var $9GcVK;
    var $iOWVN;
    var $lEJh4;
    var $MHZ3k;
    function $c054be88d64fd564$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $c054be88d64fd564$var$_ref = {
        name: "1ftjnda",
        styles: "min-height:1.55rem"
    };
    const $c054be88d64fd564$var$RelatedUrlsBlock = ({ testId: testId = 'smart-block-related-urls', url: url, renderers: renderers, ...blockProps })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("dA1Ga")).default));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [loadingRelatedUrls, setLoadingRelatedUrls] = (0, $5uXOq.useState)(true);
        const [err, setErr] = (0, $5uXOq.useState)();
        const [relatedUrls, setRelatedUrls] = (0, $5uXOq.useState)();
        const getRelatedUrls = (0, (0, parcelRequire("dA1Ga")).default)();
        (0, $5uXOq.useEffect)(()=>{
            const fetchRelatedUrls = async ()=>{
                try {
                    const relUrls = await getRelatedUrls(url);
                    setRelatedUrls(relUrls);
                    (0, (0, parcelRequire("9GcVK")).fireRelatedLinksLoadedEvent)(createAnalyticsEvent)({
                        relatedLinksCount: relUrls.resolvedResults?.length ?? 0
                    });
                } catch (error) {
                    setErr(error);
                }
                setLoadingRelatedUrls(false);
            };
            fetchRelatedUrls();
        }, [
            createAnalyticsEvent,
            getRelatedUrls,
            url
        ]);
        if (loadingRelatedUrls) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("MHZ3k")).RelatedUrlsBlockResolvingView), {
            testId: `${testId}-resolving-view`,
            ...blockProps
        });
        if (relatedUrls) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lEJh4")).RelatedUrlsResolvedView), {
            renderers: renderers,
            overrideCss: $c054be88d64fd564$var$_ref,
            testId: `${testId}-resolved-view`,
            relatedUrlsResponse: relatedUrls,
            ...blockProps
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iOWVN")).RelatedUrlsBlockErroredView), {
            err: err,
            testId: `${testId}-errored-view`,
            ...blockProps
        });
    };
    var $c054be88d64fd564$export$2e2bcd8739ae039 = $c054be88d64fd564$var$RelatedUrlsBlock;
});
parcelRegister("dA1Ga", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd54e48ed3cc8421$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iiAnG;
    var $kECas;
    const $cd54e48ed3cc8421$var$useRelatedUrls = ()=>{
        const { connections: connections } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const clientExt = (0, (0, parcelRequire("iiAnG")).useSmartLinkClientExtension)(connections.client);
        return (0, $5uXOq.useCallback)(async (url)=>{
            return await clientExt.relatedUrls(url);
        }, [
            clientExt
        ]);
    };
    var $cd54e48ed3cc8421$export$2e2bcd8739ae039 = $cd54e48ed3cc8421$var$useRelatedUrls;
});
parcelRegister("9GcVK", function(module, exports) {
    $parcel$export(module.exports, "fireRelatedLinksLoadedEvent", ()=>$7f14f20f2a22ce70$export$d2852f8792c380fa);
    var $fzJZi;
    const $7f14f20f2a22ce70$var$createTrackRelatedLinksLoadedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
            action: 'loaded',
            actionSubject: 'relatedLinks',
            eventType: 'track',
            attributes: {
                relatedLinksCount: relatedLinksCount
            }
        });
    const $7f14f20f2a22ce70$export$d2852f8792c380fa = (createAnalyticsEvent)=>(attributes)=>{
            const payload = $7f14f20f2a22ce70$var$createTrackRelatedLinksLoadedEventPayload(attributes);
            if (payload) createAnalyticsEvent({
                ...payload
            }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
        };
});
parcelRegister("iOWVN", function(module, exports) {
    $parcel$export(module.exports, "RelatedUrlsBlockErroredView", ()=>$1710f29585bd0dbe$export$35d9a5df27ecfbf0);
    var $5uXOq = parcelRequire("5uXOq");
    var $7zaVw;
    var $k39kU;
    var $dghu0;
    const $1710f29585bd0dbe$export$35d9a5df27ecfbf0 = ({ testId: testId, ...blockProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k39kU")).default), {
            message: {
                descriptor: (0, (0, parcelRequire("7zaVw")).messages).generic_error_message
            }
        }));
});
parcelRegister("lEJh4", function(module, exports) {
    $parcel$export(module.exports, "RelatedUrlsResolvedView", ()=>$b145165c065b0ab2$export$743935ead2c9d445);
    var $5uXOq = parcelRequire("5uXOq");
    var $7zaVw;
    var $dghu0;
    var $aLZx9;
    const $b145165c065b0ab2$export$743935ead2c9d445 = ({ relatedUrlsResponse: { resolvedResults: resolvedResults }, renderers: renderers, testId: testId, initializeOpened: initializeOpened, ...blockProps })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: testId
        }, resolvedResults && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aLZx9")).default), {
            testId: `${testId}-list`,
            renderers: renderers,
            initializeOpened: initializeOpened,
            title: (0, (0, parcelRequire("7zaVw")).messages).last_mentioned_in,
            resolvedResults: resolvedResults
        }));
    };
});
parcelRegister("aLZx9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa4176d3b1c696d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $c8Oei;
    var $cEqbp;
    var $f5TWP;
    var $5ILhZ;
    var $luBm6;
    var $8CUq3;
    var $7zaVw;
    var $fpDmE;
    var $k39kU;
    var $UvY9p;
    function $aa4176d3b1c696d0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $aa4176d3b1c696d0$var$_ref = {
        name: "rbkjwc",
        styles: "font-weight:var(--ds-font-weight-medium, 500)"
    };
    const $aa4176d3b1c696d0$var$RelatedUrlList = ({ resolvedResults: resolvedResults, title: title, renderers: renderers, testId: testId, initializeOpened: initializeOpened })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(initializeOpened);
        const chevronClickHandler = (0, $5uXOq.useCallback)(()=>setIsOpen(!isOpen), [
            isOpen
        ]);
        const ChevronComponent = isOpen ? (0, ($parcel$interopDefault((0, parcelRequire("cEqbp"))))) : (0, ($parcel$interopDefault((0, parcelRequire("c8Oei")))));
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return resolvedResults.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            testId: testId,
            xcss: (0, (0, parcelRequire("8CUq3")).xcss)({
                width: '100%'
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            onClick: chevronClickHandler,
            testId: `${testId}-expand-title`,
            backgroundColor: "color.background.neutral.subtle",
            "aria-expanded": !!isOpen,
            padding: "space.0",
            paddingInlineEnd: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            space: "space.050",
            spread: "space-between"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k39kU")).default), {
            overrideCss: $aa4176d3b1c696d0$var$_ref,
            message: {
                descriptor: title
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(ChevronComponent, {
            LEGACY_margin: "0 -4px",
            label: (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, title),
            color: "currentColor"
        }))), isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("UvY9p")).default), {
            resolvedResults: resolvedResults,
            testId: testId,
            renderers: renderers
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k39kU")).default), {
            testId: testId,
            message: {
                descriptor: (0, (0, parcelRequire("7zaVw")).messages).related_work_items_not_found
            }
        });
    };
    var $aa4176d3b1c696d0$export$2e2bcd8739ae039 = $aa4176d3b1c696d0$var$RelatedUrlList;
});
parcelRegister("cEqbp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $935d87e1572638ec$var$_react = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $935d87e1572638ec$var$_chevronUp = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("jj3Gi")));
    var $935d87e1572638ec$var$_chevronUp2 = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("6Pmud")));
    function $935d87e1572638ec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $935d87e1572638ec$var$ChevronUpIcon = (props)=>$935d87e1572638ec$var$_react.default.createElement($935d87e1572638ec$var$_chevronUp.default, Object.assign({
            LEGACY_fallbackIcon: $935d87e1572638ec$var$_chevronUp2.default
        }, props));
    $935d87e1572638ec$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
    var $935d87e1572638ec$var$_default = module.exports.default = $935d87e1572638ec$var$ChevronUpIcon;
});
parcelRegister("6Pmud", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4f88f2d3e506ed12$var$_react = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4f88f2d3e506ed12$var$_chevronUp = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("jj3Gi")));
    function $4f88f2d3e506ed12$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4f88f2d3e506ed12$var$ChevronUpIcon = (props)=>$4f88f2d3e506ed12$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
        }, props, {
            newIcon: $4f88f2d3e506ed12$var$_chevronUp.default,
            iconType: "utility"
        }));
    $4f88f2d3e506ed12$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
    var $4f88f2d3e506ed12$var$_default = module.exports.default = $4f88f2d3e506ed12$var$ChevronUpIcon;
});
parcelRegister("UvY9p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e029f1686d44a7d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $2NMNM;
    var $luBm6;
    var $8CUq3;
    var $g4nSx;
    var $cDuhk;
    const $6e029f1686d44a7d$var$ResolvedResultsStack = ({ resolvedResults: resolvedResults, testId: testId, renderers: renderers })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("cDuhk")).fireRelatedLinksViewedEvent)(createAnalyticsEvent)({
                relatedLinksCount: resolvedResults.length
            });
        }, [
            resolvedResults.length,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050",
            testId: `${testId}-items-wrapper`,
            as: "ul",
            xcss: (0, (0, parcelRequire("8CUq3")).xcss)({
                paddingLeft: 'space.0',
                marginTop: 'space.0'
            })
        }, resolvedResults.map((resolvedResults, idx)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cDuhk")).RelatedUrlItemAnalyticsContext), {
                details: resolvedResults,
                key: idx
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g4nSx")).default), {
                testId: `${testId}-item`,
                results: resolvedResults,
                renderers: renderers
            }))));
    };
    const $6e029f1686d44a7d$var$ResolvedResultsStackWithAnalytics = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                component: 'relatedLinksSection'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6e029f1686d44a7d$var$ResolvedResultsStack, props));
    };
    var $6e029f1686d44a7d$export$2e2bcd8739ae039 = $6e029f1686d44a7d$var$ResolvedResultsStackWithAnalytics;
});
parcelRegister("g4nSx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2bb04da31a2f1b93$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $f5TWP;
    var $8dVIb;
    var $2zcFi;
    var $g2eZ6;
    var $aWyvu;
    var $3dV67;
    const $2bb04da31a2f1b93$var$RelatedUrlItem = ({ results: results, renderers: renderers, testId: testId })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const flexibleDataContext = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("2zcFi")).default)({
                response: results,
                renderers: renderers
            }), [
            renderers,
            results
        ]);
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("g2eZ6")).fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            space: "space.050",
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWyvu")).default), {
            ...flexibleDataContext?.linkIcon,
            testId: `${testId}-icon`,
            size: (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3dV67")).default), {
            testId: `${testId}-link`,
            text: flexibleDataContext?.title,
            url: flexibleDataContext?.url,
            size: (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small,
            maxLines: 1,
            onClick: onClick
        }));
    };
    var $2bb04da31a2f1b93$export$2e2bcd8739ae039 = $2bb04da31a2f1b93$var$RelatedUrlItem;
});
parcelRegister("2zcFi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da041debbb7991f6$export$2e2bcd8739ae039);
    var $hWyvy;
    var $8Tcl1;
    var $ccpJ1;
    var $8UXrm;
    var $4MmCl;
    var $eV8m9;
    var $iPUv2;
    var $jnrSW;
    var $d4sEp;
    var $h8Dpb;
    var $9LwFA;
    var $jELGn;
    var $bWsp1;
    var $djFaY;
    var $dybmx;
    var $jq5Nf;
    var $iGAv4;
    var $6N2TY;
    const $da041debbb7991f6$var$extractFlexibleUiContext = ({ id: id, renderers: renderers, actionOptions: actionOptions, response: response, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
        if (!response) return undefined;
        const data = response.data;
        const url = (0, (0, parcelRequire("8UXrm")).extractLink)(data);
        return {
            actions: (0, (0, parcelRequire("d4sEp")).default)(response, props.url, actionOptions, id, aiSummaryConfig),
            assignedToGroup: (0, (0, parcelRequire("6N2TY")).extractPersonAssignedToAsArray)(data),
            attachmentCount: (0, (0, parcelRequire("6N2TY")).extractAttachmentCount)(data),
            authorGroup: (0, (0, parcelRequire("4MmCl")).extractPersonCreatedBy)(data),
            ownedByGroup: (0, (0, parcelRequire("eV8m9")).extractPersonOwnedBy)(data),
            collaboratorGroup: (0, (0, parcelRequire("9LwFA")).extractPersonsUpdatedBy)(data),
            commentCount: (0, (0, parcelRequire("6N2TY")).extractCommentCount)(data),
            viewCount: (0, (0, parcelRequire("6N2TY")).extractViewCount)(data),
            reactCount: (0, (0, parcelRequire("6N2TY")).extractReactCount)(data),
            voteCount: (0, (0, parcelRequire("6N2TY")).extractVoteCount)(data),
            checklistProgress: (0, (0, parcelRequire("6N2TY")).extractChecklistProgress)(data),
            createdBy: (0, (0, parcelRequire("6N2TY")).extractCreatedBy)(data),
            ownedBy: (0, (0, parcelRequire("6N2TY")).extractOwnedBy)(data),
            assignedTo: (0, (0, parcelRequire("6N2TY")).extractAssignedTo)(data),
            createdOn: (0, (0, parcelRequire("8Tcl1")).extractDateCreated)(data),
            dueOn: (0, (0, parcelRequire("6N2TY")).extractDueOn)(data),
            viewAction: (0, (0, parcelRequire("h8Dpb")).extractViewAction)(data, actionOptions),
            latestCommit: (0, (0, parcelRequire("iGAv4")).extractLatestCommit)(data),
            linkIcon: (0, (0, parcelRequire("dybmx")).extractLinkIcon)(response, renderers),
            location: (0, (0, parcelRequire("6N2TY")).extractLocation)(data),
            modifiedBy: (0, (0, parcelRequire("6N2TY")).extractModifiedBy)(data),
            modifiedOn: (0, (0, parcelRequire("ccpJ1")).extractDateUpdated)(data),
            preview: (0, (0, parcelRequire("jELGn")).default)(data),
            priority: (0, (0, parcelRequire("bWsp1")).default)(data),
            provider: (0, (0, parcelRequire("jq5Nf")).default)(data),
            programmingLanguage: (0, (0, parcelRequire("6N2TY")).extractProgrammingLanguage)(data),
            readTime: (0, (0, parcelRequire("6N2TY")).extractReadTime)(data),
            sentOn: (0, (0, parcelRequire("6N2TY")).extractSentOn)(data),
            snippet: (0, (0, parcelRequire("jnrSW")).extractSummary)(data) || undefined,
            sourceBranch: (0, (0, parcelRequire("6N2TY")).extractSourceBranch)(data),
            state: (0, (0, parcelRequire("djFaY")).default)(response, actionOptions, id),
            subscriberCount: (0, (0, parcelRequire("6N2TY")).extractSubscriberCount)(data),
            subTasksProgress: (0, (0, parcelRequire("6N2TY")).extractSubTasksProgress)(data),
            storyPoints: (0, (0, parcelRequire("6N2TY")).extractStoryPoints)(data),
            targetBranch: (0, (0, parcelRequire("6N2TY")).extractTargetBranch)(data),
            title: (0, (0, parcelRequire("iPUv2")).extractTitle)(data) || url,
            url: url,
            ari: (0, (0, parcelRequire("hWyvy")).extractAri)(data)
        };
    };
    var $da041debbb7991f6$export$2e2bcd8739ae039 = $da041debbb7991f6$var$extractFlexibleUiContext;
});
parcelRegister("8Tcl1", function(module, exports) {
    $parcel$export(module.exports, "extractDateCreated", ()=>$ff639713cdfddc0e$export$e1226a5e0bbbf862);
    const $ff639713cdfddc0e$export$e1226a5e0bbbf862 = (jsonLd)=>{
        if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    };
});
parcelRegister("ccpJ1", function(module, exports) {
    $parcel$export(module.exports, "extractDateUpdated", ()=>$2985c9016975498b$export$7fc2f5e6f9d22ae7);
    const $2985c9016975498b$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
        if (jsonLd.updated) return jsonLd.updated;
    };
});
parcelRegister("iPUv2", function(module, exports) {
    $parcel$export(module.exports, "extractTitle", ()=>$3d37e098183ec9ac$export$b05803156e5015b6);
    var $a8kxN;
    var $FcDCF;
    const $3d37e098183ec9ac$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
        const name = jsonLd.name?.replace(/[\r\n]+/g, '');
        const id = jsonLd['@id'] || '';
        const context = (0, (0, parcelRequire("a8kxN")).extractContext)(jsonLd);
        const type = (0, (0, parcelRequire("FcDCF")).extractType)(jsonLd);
        const hasContextType = context && context.type;
        const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
        if (hasContextRepo && type) {
            const contextName = context.name && `${context.name}: ` || '';
            if (type.includes('atlassian:SourceCodeCommit')) {
                const [, hashContent] = id.split(':');
                const hash = hashContent && `${hashContent.substring(0, 8)} `;
                return contextName + (hash || '') + name;
            }
            if (type.includes('atlassian:SourceCodePullRequest')) {
                const pullRequest = jsonLd;
                const internalId = pullRequest['atlassian:internalId'];
                const internalIdRef = internalId && `#${internalId} `;
                return contextName + (internalIdRef || '') + name;
            }
            if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
            if (type.includes('schema:DigitalDocument')) return contextName + name;
        }
        if (removeTextHighlightingFromTitle) {
            const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
            const truncated = name?.replace(textFragmentRegex, '');
            return truncated;
        }
        return name;
    };
});
parcelRegister("a8kxN", function(module, exports) {
    $parcel$export(module.exports, "extractContext", ()=>$1d582ee88fc2111b$export$efdbd45f3e77a161);
    var $FcDCF;
    var $cuw1y;
    const $1d582ee88fc2111b$export$efdbd45f3e77a161 = (jsonLd)=>{
        const context = jsonLd.context;
        if (context) {
            if (typeof context === 'string') return {
                name: context
            };
            else if (context['@type'] === 'Link') {
                if (context.name) return {
                    name: context.name
                };
            } else {
                if (context.name) return {
                    name: context.name,
                    icon: context.icon && (0, (0, parcelRequire("cuw1y")).extractUrlFromIconJsonLd)(context.icon),
                    type: (0, (0, parcelRequire("FcDCF")).extractType)(context)
                };
            }
        }
    };
});
parcelRegister("jnrSW", function(module, exports) {
    $parcel$export(module.exports, "extractSummary", ()=>$82a2487542e3dcba$export$db5a8500f6b6286e);
    const $82a2487542e3dcba$export$db5a8500f6b6286e = (jsonLd)=>{
        if (typeof jsonLd?.summary === 'string') {
            const summary = jsonLd.summary.trim();
            return Boolean(summary) ? summary : undefined;
        }
    };
});
parcelRegister("d4sEp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3cafd9d828d6c09$export$2e2bcd8739ae039);
    var $VSDnB;
    var $8dVIb;
    var $4ma4m;
    var $f5eJz;
    var $kh3Vl;
    var $gIJxe;
    var $4DFf8;
    var $joFPX;
    var $ljBcB;
    const $c3cafd9d828d6c09$var$extractActions = (response, url, actionOptions, id, aiSummaryConfig)=>{
        const data = response.data;
        const action = {
            [(0, (0, parcelRequire("8dVIb")).ActionName).CopyLinkAction]: (0, (0, parcelRequire("kh3Vl")).extractCopyLinkAction)(data, actionOptions),
            [(0, (0, parcelRequire("8dVIb")).ActionName).DownloadAction]: (0, (0, parcelRequire("gIJxe")).extractDownloadAction)(data, actionOptions),
            [(0, (0, parcelRequire("8dVIb")).ActionName).FollowAction]: (0, (0, parcelRequire("4DFf8")).default)(response, actionOptions, id),
            [(0, (0, parcelRequire("8dVIb")).ActionName).PreviewAction]: (0, (0, parcelRequire("joFPX")).extractPreviewAction)(response, actionOptions),
            [(0, (0, parcelRequire("8dVIb")).ActionName).AutomationAction]: (0, (0, parcelRequire("f5eJz")).extractAutomationAction)(response),
            [(0, (0, parcelRequire("8dVIb")).InternalActionName).AISummaryAction]: (0, (0, parcelRequire("4ma4m")).extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-smart-card-view-related-urls-action') ? {
                [(0, (0, parcelRequire("8dVIb")).InternalActionName).ViewRelatedLinksAction]: (0, (0, parcelRequire("ljBcB")).extractViewRelatedLinksAction)(response)
            } : {}
        };
        return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
    };
    var $c3cafd9d828d6c09$export$2e2bcd8739ae039 = $c3cafd9d828d6c09$var$extractActions;
});
parcelRegister("4ma4m", function(module, exports) {
    $parcel$export(module.exports, "extractAISummaryAction", ()=>$8cdc7ca64eb62313$export$e7f7a50a8b8932df);
    var $evnkj;
    var $cnaAy;
    var $dn5wJ;
    const $8cdc7ca64eb62313$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
        if (!(0, (0, parcelRequire("evnkj")).canShowAction)((0, (0, parcelRequire("dn5wJ")).CardAction).AISummaryAction, actionOptions) || !(0, (0, parcelRequire("cnaAy")).getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
        return {
            url: url
        };
    };
});
parcelRegister("evnkj", function(module, exports) {
    $parcel$export(module.exports, "canShowAction", ()=>$6626d2f2bee6ec27$export$2487b058456cca75);
    const $6626d2f2bee6ec27$export$2487b058456cca75 = (action, actionOptions)=>{
        if (typeof actionOptions === 'undefined') return true;
        if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
        return true;
    };
});
parcelRegister("f5eJz", function(module, exports) {
    $parcel$export(module.exports, "extractAutomationAction", ()=>$ca59c43d6a564063$export$f913cc6abf3ec084);
    var $8dVIb;
    const $ca59c43d6a564063$export$f913cc6abf3ec084 = (response)=>{
        if (!response.data) return undefined;
        if (!response?.meta?.supportedFeature?.includes((0, (0, parcelRequire("8dVIb")).ActionName).AutomationAction)) return undefined;
        const data = response.data;
        const meta = response.meta;
        const { name: name, 'atlassian:ari': objectAri } = data;
        const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
        return {
            product: product,
            resourceType: resourceType,
            siteAri: `ari:cloud:${product}::site/${tenantId}`,
            objectName: name,
            objectAri: objectAri,
            canManageAutomation: false,
            baseAutomationUrl: '',
            analyticsSource: 'smartCardAutomationAction'
        };
    };
});
parcelRegister("kh3Vl", function(module, exports) {
    $parcel$export(module.exports, "extractCopyLinkAction", ()=>$156b119eb968da41$export$5b7ae1fa8fdb83ba);
    var $8UXrm;
    var $evnkj;
    var $dn5wJ;
    const $156b119eb968da41$export$5b7ae1fa8fdb83ba = (data, actionOptions)=>{
        if (!(0, (0, parcelRequire("evnkj")).canShowAction)((0, (0, parcelRequire("dn5wJ")).CardAction).CopyLinkAction, actionOptions)) return;
        const url = (0, (0, parcelRequire("8UXrm")).extractLink)(data);
        if (!url) return;
        return {
            url: url
        };
    };
});
parcelRegister("gIJxe", function(module, exports) {
    $parcel$export(module.exports, "extractDownloadAction", ()=>$02d459bef4b0b3b6$export$e2076b2e4a490ac5);
    var $evnkj;
    var $dn5wJ;
    var $5U430;
    var $dluvH;
    const $02d459bef4b0b3b6$export$e2076b2e4a490ac5 = (data, actionOptions)=>{
        if (!(0, (0, parcelRequire("evnkj")).canShowAction)((0, (0, parcelRequire("dn5wJ")).CardAction).DownloadAction, actionOptions)) return;
        const downloadActionExists = (0, (0, parcelRequire("5U430")).getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
        if (downloadActionExists) return {
            downloadUrl: (0, (0, parcelRequire("dluvH")).extractDownloadUrl)(data)
        };
        return;
    };
});
parcelRegister("5U430", function(module, exports) {
    $parcel$export(module.exports, "getActionsFromJsonLd", ()=>$76a260c3f7e7678d$export$8f031784a3a03b23);
    $parcel$export(module.exports, "extractClientActions", ()=>$76a260c3f7e7678d$export$75be35b463ab3fda);
    var $evnkj;
    var $8FQjl;
    var $7jk6k;
    var $dn5wJ;
    const $76a260c3f7e7678d$var$isClientAction = (action)=>[
            'ViewAction',
            'DownloadAction'
        ].indexOf(action['@type']) > -1;
    const $76a260c3f7e7678d$var$getClientAction = (jsonLd, action)=>{
        switch(action['@type']){
            case 'ViewAction':
                return (0, (0, parcelRequire("7jk6k")).ViewAction)({
                    url: jsonLd.url
                });
            case 'DownloadAction':
                return (0, (0, parcelRequire("8FQjl")).DownloadAction)({
                    url: jsonLd['atlassian:downloadUrl']
                });
        }
    };
    const $76a260c3f7e7678d$var$isActionEnabled = (action, actionOptions)=>{
        switch(action['@type']){
            case 'ViewAction':
                return (0, (0, parcelRequire("evnkj")).canShowAction)((0, (0, parcelRequire("dn5wJ")).CardAction).ViewAction, actionOptions);
            case 'DownloadAction':
                return (0, (0, parcelRequire("evnkj")).canShowAction)((0, (0, parcelRequire("dn5wJ")).CardAction).DownloadAction, actionOptions);
        }
        return true;
    };
    const $76a260c3f7e7678d$var$getClientActionProps = (jsonLd, action, handler)=>{
        const clientAction = $76a260c3f7e7678d$var$getClientAction(jsonLd, action);
        const clientActionInvokeOpts = {
            type: 'client',
            key: action.identifier,
            action: {
                type: action['@type'],
                promise: clientAction.promise
            }
        };
        return {
            ...clientAction,
            promise: ()=>handler(clientActionInvokeOpts)
        };
    };
    const $76a260c3f7e7678d$export$8f031784a3a03b23 = (jsonLd)=>{
        let actions = jsonLd && jsonLd['schema:potentialAction'];
        if (!actions) return [];
        if (actions && !Array.isArray(actions)) actions = [
            actions
        ];
        return actions;
    };
    function $76a260c3f7e7678d$export$75be35b463ab3fda(jsonLd, handler, actionOptions) {
        const actions = $76a260c3f7e7678d$export$8f031784a3a03b23(jsonLd);
        const clientActions = actions.filter((action)=>$76a260c3f7e7678d$var$isClientAction(action) && $76a260c3f7e7678d$var$isActionEnabled(action, actionOptions));
        const clientActionImpls = clientActions.map((action)=>$76a260c3f7e7678d$var$getClientActionProps(jsonLd, action, handler));
        return clientActionImpls;
    }
});
parcelRegister("8FQjl", function(module, exports) {
    $parcel$export(module.exports, "DownloadAction", ()=>$0967dfceab481039$export$7a2b423858a679ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $7zaVw;
    var $kxcRq;
    const $0967dfceab481039$export$7a2b423858a679ca = ({ url: url })=>({
            id: 'download-content',
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).download),
            promise: ()=>(0, (0, parcelRequire("kxcRq")).downloadUrl)(url)
        });
});
parcelRegister("7jk6k", function(module, exports) {
    $parcel$export(module.exports, "ViewAction", ()=>$33f0679f9c7241cb$export$a96f88e1928d92fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $7zaVw;
    var $kxcRq;
    const $33f0679f9c7241cb$export$a96f88e1928d92fa = ({ url: url })=>({
            id: 'view-content',
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).view),
            promise: ()=>(0, (0, parcelRequire("kxcRq")).openUrl)(url)
        });
});
parcelRegister("dluvH", function(module, exports) {
    $parcel$export(module.exports, "extractDownloadUrl", ()=>$17ef0f29f88ef1d2$export$9682e3ac9d184e95);
    const $17ef0f29f88ef1d2$export$9682e3ac9d184e95 = (jsonLd)=>{
        if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
    };
});
parcelRegister("4DFf8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a99662467a25c4e$export$2e2bcd8739ae039);
    var $8UXrm;
    var $FcDCF;
    var $T540Y;
    var $fgpl1;
    var $evnkj;
    var $dn5wJ;
    var $j4IjY;
    const $5a99662467a25c4e$var$extractFollowAction = (response, actionOptions, id)=>{
        if (!(0, (0, parcelRequire("evnkj")).canShowAction)((0, (0, parcelRequire("dn5wJ")).CardAction).FollowAction, actionOptions)) return;
        const extensionKey = (0, (0, parcelRequire("fgpl1")).getExtensionKey)(response);
        const data = response?.data;
        const actions = (0, (0, parcelRequire("j4IjY")).default)(data);
        const type = (0, (0, parcelRequire("FcDCF")).extractType)(data);
        const isProject = type?.includes('atlassian:Project');
        if (!extensionKey || actions.length === 0) return;
        const action = actions.find((item)=>{
            if (item?.name === 'UpdateAction') {
                const actionName = item?.dataUpdateAction?.name;
                return actionName === (0, (0, parcelRequire("T540Y")).SmartLinkActionType).FollowEntityAction || actionName === (0, (0, parcelRequire("T540Y")).SmartLinkActionType).UnfollowEntityAction;
            }
            return false;
        });
        if (!action || !action.resourceIdentifiers) return;
        const url = (0, (0, parcelRequire("8UXrm")).extractLink)(data);
        const reload = url ? {
            id: id,
            url: url
        } : undefined;
        const actionType = action.dataUpdateAction?.name;
        return {
            action: {
                action: {
                    actionType: actionType,
                    resourceIdentifiers: action.resourceIdentifiers
                },
                providerKey: extensionKey,
                reload: reload
            },
            value: actionType === (0, (0, parcelRequire("T540Y")).SmartLinkActionType).FollowEntityAction,
            isProject: isProject
        };
    };
    var $5a99662467a25c4e$export$2e2bcd8739ae039 = $5a99662467a25c4e$var$extractFollowAction;
});
parcelRegister("j4IjY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$491a605bed171307$export$2e2bcd8739ae039);
    const $491a605bed171307$var$extractServerAction = (data)=>{
        const actions = data?.['atlassian:serverAction'];
        if (!actions) return [];
        if (actions && !Array.isArray(actions)) return [
            actions
        ];
        return actions;
    };
    var $491a605bed171307$export$2e2bcd8739ae039 = $491a605bed171307$var$extractServerAction;
});
parcelRegister("joFPX", function(module, exports) {
    $parcel$export(module.exports, "extractPreviewAction", ()=>$67a9503b149a9ddf$export$eba2f3246148e526);
    var $8UXrm;
    var $k9B19;
    var $f24gj;
    var $iPUv2;
    var $evnkj;
    var $dn5wJ;
    var $dluvH;
    var $hYF5d;
    var $dybmx;
    const $67a9503b149a9ddf$export$eba2f3246148e526 = (response, actionOptions)=>{
        if (!(0, (0, parcelRequire("evnkj")).canShowAction)((0, (0, parcelRequire("dn5wJ")).CardAction).PreviewAction, actionOptions)) return;
        const data = response.data;
        const meta = response.meta;
        const src = (0, (0, parcelRequire("k9B19")).extractPreview)(data, 'web')?.src;
        if (src) return {
            downloadUrl: (0, (0, parcelRequire("dluvH")).extractDownloadUrl)(data),
            providerName: (0, (0, parcelRequire("f24gj")).extractProvider)(data)?.text,
            src: src,
            title: (0, (0, parcelRequire("iPUv2")).extractTitle)(data),
            linkIcon: (0, (0, parcelRequire("dybmx")).extractLinkIcon)(response),
            url: (0, (0, parcelRequire("8UXrm")).extractLink)(data),
            isSupportTheming: (0, (0, parcelRequire("hYF5d")).extractIsSupportTheming)(meta)
        };
    };
});
parcelRegister("hYF5d", function(module, exports) {
    $parcel$export(module.exports, "extractIsSupportTheming", ()=>$693566d688a51b19$export$38d755f52cdf4acb);
    var $dvNbb;
    const $693566d688a51b19$export$38d755f52cdf4acb = (meta)=>{
        return Boolean(meta?.key && (0, (0, parcelRequire("dvNbb")).PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
    };
});
parcelRegister("dvNbb", function(module, exports) {
    $parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", ()=>$9b14bed6babdc545$export$cee224b5de4d6d66);
    $parcel$export(module.exports, "JIRA_GENERATOR_ID", ()=>$9b14bed6babdc545$export$f654d825189934a7);
    $parcel$export(module.exports, "JIRA_TASK", ()=>$9b14bed6babdc545$export$84a73a0383f58180);
    $parcel$export(module.exports, "JIRA_SUB_TASK", ()=>$9b14bed6babdc545$export$c6c83963a9378a67);
    $parcel$export(module.exports, "JIRA_STORY", ()=>$9b14bed6babdc545$export$58af3c426c111a6d);
    $parcel$export(module.exports, "JIRA_BUG", ()=>$9b14bed6babdc545$export$ac9898a63417219e);
    $parcel$export(module.exports, "JIRA_EPIC", ()=>$9b14bed6babdc545$export$54db5e3fb12e39cd);
    $parcel$export(module.exports, "JIRA_INCIDENT", ()=>$9b14bed6babdc545$export$2f54a5a217202c85);
    $parcel$export(module.exports, "JIRA_SERVICE_REQUEST", ()=>$9b14bed6babdc545$export$d097371052bfc411);
    $parcel$export(module.exports, "JIRA_CHANGE", ()=>$9b14bed6babdc545$export$efd9452ad16c6676);
    $parcel$export(module.exports, "JIRA_PROBLEM", ()=>$9b14bed6babdc545$export$2e7e70abb5d81f67);
    $parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", ()=>$9b14bed6babdc545$export$ce25cfc40b280dbc);
    $parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", ()=>$9b14bed6babdc545$export$fe44ce30fd8d131b);
    const $9b14bed6babdc545$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
    const $9b14bed6babdc545$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
    const $9b14bed6babdc545$export$84a73a0383f58180 = 'JiraTask';
    const $9b14bed6babdc545$export$c6c83963a9378a67 = 'JiraSubTask';
    const $9b14bed6babdc545$export$58af3c426c111a6d = 'JiraStory';
    const $9b14bed6babdc545$export$ac9898a63417219e = 'JiraBug';
    const $9b14bed6babdc545$export$54db5e3fb12e39cd = 'JiraEpic';
    const $9b14bed6babdc545$export$2f54a5a217202c85 = 'JiraIncident';
    const $9b14bed6babdc545$export$d097371052bfc411 = 'JiraServiceRequest';
    const $9b14bed6babdc545$export$efd9452ad16c6676 = 'JiraChange';
    const $9b14bed6babdc545$export$2e7e70abb5d81f67 = 'JiraProblem';
    const $9b14bed6babdc545$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
    const $9b14bed6babdc545$export$fe44ce30fd8d131b = [
        'jira-object-provider',
        'confluence-object-provider',
        'watermelon-object-provider'
    ];
});
parcelRegister("dybmx", function(module, exports) {
    $parcel$export(module.exports, "extractLinkIcon", ()=>$d7af83be96aed150$export$43612bed147eae48);
    $parcel$export(module.exports, "extractErrorIcon", ()=>$d7af83be96aed150$export$bdd29be9b0395931);
    var $8dVIb;
    var $9fbCf;
    var $5ZCMp;
    var $jq5Nf;
    const $d7af83be96aed150$export$43612bed147eae48 = (response, renderers)=>{
        const data = response.data;
        const render = (0, (0, parcelRequire("9fbCf")).default)(data, renderers);
        return {
            ...(0, (0, parcelRequire("5ZCMp")).default)(data),
            render: render
        };
    };
    const $d7af83be96aed150$export$bdd29be9b0395931 = (response, status)=>{
        if (response) {
            const data = response.data;
            const { icon: icon, url: url } = (0, (0, parcelRequire("jq5Nf")).default)(data) || {};
            if (icon || url) return {
                icon: icon,
                url: url
            };
        }
        switch(status){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Forbidden:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Unauthorized:
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Forbidden
                };
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).NotFound:
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Error
                };
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Errored:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback:
            default:
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Default
                };
        }
    };
});
parcelRegister("9fbCf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3cc79bd445a96437$export$2e2bcd8739ae039);
    const $3cc79bd445a96437$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
    const $3cc79bd445a96437$var$extractIconRenderer = (data, renderers)=>{
        const prefix = data['atlassian:titlePrefix'];
        if (prefix?.['@type'] === 'atlassian:Emoji') {
            const emojiId = $3cc79bd445a96437$var$sanitizeEmojiValue(prefix['text']);
            const emojiRenderer = renderers?.emoji;
            if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
        }
    };
    var $3cc79bd445a96437$export$2e2bcd8739ae039 = $3cc79bd445a96437$var$extractIconRenderer;
});
parcelRegister("5ZCMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f6ae1c2ef653082$export$2e2bcd8739ae039);
    var $iPUv2;
    var $8dVIb;
    var $3TBiE;
    var $4DoyP;
    var $a4RsY;
    var $dvNbb;
    var $1gwFB;
    var $liAf6;
    var $cKwAC;
    var $jq5Nf;
    var $iWNKM;
    const $4f6ae1c2ef653082$var$extractTask = (data, label)=>{
        const { id: id, icon: url } = (0, (0, parcelRequire("a4RsY")).extractTaskType)(data) || {};
        const taskType = id?.split('#').pop();
        const taskIcon = url ? {
            label: label,
            url: url
        } : undefined;
        return {
            taskType: taskType,
            taskIcon: taskIcon
        };
    };
    const $4f6ae1c2ef653082$var$extractType = (jsonLd)=>{
        const type = jsonLd['@type'];
        return Array.isArray(type) ? type.sort((a, b)=>(0, (0, parcelRequire("4DoyP")).extractorPriorityMap)[b] - (0, (0, parcelRequire("4DoyP")).extractorPriorityMap)[a])[0] : type;
    };
    const $4f6ae1c2ef653082$var$isJiraProvider = (provider)=>provider === (0, (0, parcelRequire("dvNbb")).JIRA_GENERATOR_ID);
    function $4f6ae1c2ef653082$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
        const providerId = data.generator?.['@id'];
        const fileFormat = data?.['schema:fileFormat'];
        const fileFormatIcon = (0, (0, parcelRequire("liAf6")).default)(fileFormat);
        const documentTypeIcon = $4f6ae1c2ef653082$var$typeToIconDescriptor({
            type: type,
            label: label,
            providerId: providerId,
            data: data
        }) || (0, (0, parcelRequire("1gwFB")).default)(type, label);
        return (0, (0, parcelRequire("3TBiE")).prioritiseIcon)({
            fileFormatIcon: fileFormatIcon,
            documentTypeIcon: documentTypeIcon,
            urlIcon: urlIcon,
            providerIcon: providerIcon
        });
    }
    function $4f6ae1c2ef653082$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
        switch(type){
            case 'atlassian:Goal':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Task,
                    label: label || 'Goal'
                };
            case 'atlassian:Project':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Project,
                    label: label || 'Project'
                };
            case 'atlassian:SourceCodeCommit':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Commit,
                    label: label || 'Commit'
                };
            case 'atlassian:SourceCodePullRequest':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).PullRequest,
                    label: label || 'Pull request'
                };
            case 'atlassian:SourceCodeReference':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Branch,
                    label: label || 'Reference'
                };
            case 'atlassian:SourceCodeRepository':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Repo,
                    label: label || 'Repository'
                };
            case 'atlassian:Task':
                const taskLabel = label || 'Task';
                const taskIconDescriptor = {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Task,
                    label: taskLabel
                };
                if ($4f6ae1c2ef653082$var$isJiraProvider(providerId)) {
                    const { taskType: taskType, taskIcon: taskIcon } = $4f6ae1c2ef653082$var$extractTask(data);
                    return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, (0, parcelRequire("cKwAC")).default)(taskType, taskLabel);
                }
                return taskIconDescriptor;
            default:
                return undefined;
        }
    }
    const $4f6ae1c2ef653082$var$extractJsonldDataIcon = (data)=>{
        const label = (0, (0, parcelRequire("iPUv2")).extractTitle)(data);
        const type = $4f6ae1c2ef653082$var$extractType(data);
        const urlIcon = (0, (0, parcelRequire("iWNKM")).default)(data.icon, label);
        const providerIcon = (0, (0, parcelRequire("jq5Nf")).default)(data);
        return $4f6ae1c2ef653082$var$chooseIcon({
            urlIcon: urlIcon,
            providerIcon: providerIcon,
            type: type,
            label: label,
            data: data
        });
    };
    var $4f6ae1c2ef653082$export$2e2bcd8739ae039 = $4f6ae1c2ef653082$var$extractJsonldDataIcon;
});
parcelRegister("3TBiE", function(module, exports) {
    $parcel$export(module.exports, "prioritiseIcon", ()=>$99be71cd5a3b0274$export$65e47eb22a387a86);
    function $99be71cd5a3b0274$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
        return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
    }
});
parcelRegister("4DoyP", function(module, exports) {
    $parcel$export(module.exports, "extractorPriorityMap", ()=>$bf343580a3de2dcf$export$e0deaeb4a2dfe2b4);
    const $bf343580a3de2dcf$export$e0deaeb4a2dfe2b4 = {
        Object: 0,
        Document: 5,
        'schema:TextDigitalDocument': 10,
        'schema:DigitalDocument': 10,
        'schema:BlogPosting': 10,
        'schema:SpreadsheetDigitalDocument': 10,
        'schema:PresentationDigitalDocument': 10,
        'atlassian:Goal': 10,
        'atlassian:Task': 10,
        'atlassian:Project': 10,
        'atlassian:Template': 10,
        'atlassian:SourceCodeCommit': 10,
        'atlassian:SourceCodeRepository': 10,
        'atlassian:SourceCodePullRequest': 10,
        'atlassian:SourceCodeReference': 10,
        'atlassian:UndefinedLink': 10
    };
});
parcelRegister("a4RsY", function(module, exports) {
    $parcel$export(module.exports, "extractTaskType", ()=>$81dd8ddf907a1532$export$ed3fd59180514d27);
    var $cuw1y;
    const $81dd8ddf907a1532$export$ed3fd59180514d27 = (jsonLd)=>{
        const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
        if (taskType) {
            if (typeof taskType === 'string') return {
                id: taskType
            };
            else if (taskType['@type'] === 'Link') return {
                id: taskType.href
            };
            else return {
                id: taskType['@id'],
                name: taskType.name,
                icon: taskType.icon && (0, (0, parcelRequire("cuw1y")).extractUrlFromIconJsonLd)(taskType.icon)
            };
        }
    };
});
parcelRegister("1gwFB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f8e24b11256d3ae$export$2e2bcd8739ae039);
    var $8dVIb;
    const $2f8e24b11256d3ae$var$extractDocumentTypeIcon = (documentType, label)=>{
        switch(documentType){
            case 'schema:BlogPosting':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Blog,
                    label: label || 'Blog'
                };
            case 'schema:DigitalDocument':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).File,
                    label: label || 'File'
                };
            case 'schema:TextDigitalDocument':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Document,
                    label: label || 'Document'
                };
            case 'schema:PresentationDigitalDocument':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Presentation,
                    label: label || 'Presentation'
                };
            case 'schema:SpreadsheetDigitalDocument':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Spreadsheet,
                    label: label || 'Spreadsheet'
                };
            case 'atlassian:Template':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Template,
                    label: label || 'Template'
                };
            case 'atlassian:UndefinedLink':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Document,
                    label: label || 'Undefined link'
                };
            default:
                return undefined;
        }
    };
    var $2f8e24b11256d3ae$export$2e2bcd8739ae039 = $2f8e24b11256d3ae$var$extractDocumentTypeIcon;
});
parcelRegister("liAf6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d67e22f2f57cb4a6$export$2e2bcd8739ae039);
    var $8dVIb;
    const $d67e22f2f57cb4a6$var$extractFileFormatIcon = (fileFormat)=>{
        switch(fileFormat){
            case 'folder':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Folder,
                    label: 'Folder'
                };
            case 'text/plain':
            case 'application/vnd.oasis.opendocument.text':
            case 'application/vnd.apple.pages':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Document,
                    label: 'Document'
                };
            case 'application/pdf':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).PDF,
                    label: 'PDF document'
                };
            case 'application/vnd.oasis.opendocument.presentation':
            case 'application/vnd.apple.keynote':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Presentation,
                    label: 'Presentation'
                };
            case 'application/vnd.oasis.opendocument.spreadsheet':
            case 'application/vnd.apple.numbers':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Spreadsheet,
                    label: 'Spreadsheet'
                };
            case 'application/vnd.google-apps.document':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).GoogleDocs,
                    label: 'Google Docs'
                };
            case 'application/vnd.google-apps.form':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).GoogleForms,
                    label: 'Google Form'
                };
            case 'application/vnd.google-apps.spreadsheet':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).GoogleSheets,
                    label: 'Google Sheets'
                };
            case 'application/vnd.google-apps.presentation':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).GoogleSlides,
                    label: 'Google Slides'
                };
            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).MSExcel,
                    label: 'Excel spreadsheet'
                };
            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).MSPowerpoint,
                    label: 'PowerPoint presentation'
                };
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).MSWord,
                    label: 'Word document'
                };
            case 'image/png':
            case 'image/jpeg':
            case 'image/bmp':
            case 'image/webp':
            case 'image/svg+xml':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Image,
                    label: 'Image'
                };
            case 'image/gif':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).GIF,
                    label: 'GIF'
                };
            case 'audio/midi':
            case 'audio/mpeg':
            case 'audio/webm':
            case 'audio/ogg':
            case 'audio/wav':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Audio,
                    label: 'Audio'
                };
            case 'video/mp4':
            case 'video/quicktime':
            case 'video/mov':
            case 'video/webm':
            case 'video/ogg':
            case 'video/x-ms-wmv':
            case 'video/x-msvideo':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Video,
                    label: 'Video'
                };
            case 'text/css':
            case 'text/html':
            case 'application/javascript':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Code,
                    label: 'Source Code'
                };
            case 'application/zip':
            case 'application/x-tar':
            case 'application/x-gtar':
            case 'application/x-7z-compressed':
            case 'application/x-apple-diskimage':
            case 'application/vnd.rar':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Archive,
                    label: 'Archive'
                };
            case 'application/dmg':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Executable,
                    label: 'Executable'
                };
            case 'application/sketch':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Sketch,
                    label: 'Sketch'
                };
            case 'application/octet-stream':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Generic,
                    label: 'Binary file'
                };
            case 'application/invision.prototype':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Generic,
                    label: 'Prototype'
                };
            default:
                return undefined;
        }
    };
    var $d67e22f2f57cb4a6$export$2e2bcd8739ae039 = $d67e22f2f57cb4a6$var$extractFileFormatIcon;
});
parcelRegister("cKwAC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97a727b28b60947e$export$2e2bcd8739ae039);
    var $8dVIb;
    const $97a727b28b60947e$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
        switch(taskType){
            case 'JiraBug':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Bug,
                    label: label
                };
            case 'JiraChange':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Change,
                    label: label
                };
            case 'JiraEpic':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Epic,
                    label: label
                };
            case 'JiraIncident':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Incident,
                    label: label
                };
            case 'JiraProblem':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Problem,
                    label: label
                };
            case 'JiraServiceRequest':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).ServiceRequest,
                    label: label
                };
            case 'JiraStory':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Story,
                    label: label
                };
            case 'JiraSubTask':
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).SubTask,
                    label: label
                };
            case 'JiraTask':
            default:
                return {
                    icon: (0, (0, parcelRequire("8dVIb")).IconType).Task,
                    label: label
                };
        }
    };
    var $97a727b28b60947e$export$2e2bcd8739ae039 = $97a727b28b60947e$var$extractJiraTaskIcon;
});
parcelRegister("jq5Nf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87e0775b3750bf70$export$2e2bcd8739ae039);
    var $iPUv2;
    var $8dVIb;
    var $dvNbb;
    var $iWNKM;
    const $87e0775b3750bf70$var$extractProviderIcon = (data)=>{
        if (!data) return undefined;
        const generator = data.generator;
        const provider = generator?.['@id'];
        const icon = generator?.icon;
        const label = generator?.name || (0, (0, parcelRequire("iPUv2")).extractTitle)(data);
        if (provider === (0, (0, parcelRequire("dvNbb")).CONFLUENCE_GENERATOR_ID)) return {
            icon: (0, (0, parcelRequire("8dVIb")).IconType).Confluence,
            label: label || 'Confluence'
        };
        if (provider === (0, (0, parcelRequire("dvNbb")).JIRA_GENERATOR_ID)) return {
            icon: (0, (0, parcelRequire("8dVIb")).IconType).Jira,
            label: label || 'Jira'
        };
        return (0, (0, parcelRequire("iWNKM")).default)(icon, label);
    };
    var $87e0775b3750bf70$export$2e2bcd8739ae039 = $87e0775b3750bf70$var$extractProviderIcon;
});
parcelRegister("iWNKM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8418e6f5863288f0$export$2e2bcd8739ae039);
    var $cuw1y;
    const $8418e6f5863288f0$var$extractUrlIcon = (icon, label)=>{
        const url = icon && (0, (0, parcelRequire("cuw1y")).extractUrlFromIconJsonLd)(icon);
        return url ? {
            label: label,
            url: url
        } : undefined;
    };
    var $8418e6f5863288f0$export$2e2bcd8739ae039 = $8418e6f5863288f0$var$extractUrlIcon;
});
parcelRegister("ljBcB", function(module, exports) {
    $parcel$export(module.exports, "extractViewRelatedLinksAction", ()=>$a600a657ec97b3e1$export$debae7424a0231b9);
    var $hWyvy;
    const $a600a657ec97b3e1$export$debae7424a0231b9 = (response)=>{
        if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
        const ari = (0, (0, parcelRequire("hWyvy")).extractAri)(response.data);
        if (!ari) return;
        return {
            ari: ari
        };
    };
});
parcelRegister("h8Dpb", function(module, exports) {
    $parcel$export(module.exports, "extractViewAction", ()=>$c9e3786bafc813a4$export$96c7e3a7e9c64e85);
    var $8UXrm;
    var $evnkj;
    var $dn5wJ;
    var $5U430;
    const $c9e3786bafc813a4$export$96c7e3a7e9c64e85 = (data, actionOptions)=>{
        if (!(0, (0, parcelRequire("evnkj")).canShowAction)((0, (0, parcelRequire("dn5wJ")).CardAction).ViewAction, actionOptions)) return;
        const viewActionExists = (0, (0, parcelRequire("5U430")).getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
        if (viewActionExists) return {
            viewUrl: (0, (0, parcelRequire("8UXrm")).extractLink)(data)
        };
        return undefined;
    };
});
parcelRegister("9LwFA", function(module, exports) {
    $parcel$export(module.exports, "extractPersonsUpdatedBy", ()=>$4c9ea88664552b6e$export$216e4f6aa7c169b8);
    var $o6TQ1;
    var $aj6Xc;
    const $4c9ea88664552b6e$export$216e4f6aa7c169b8 = (jsonLd)=>{
        if (jsonLd['@type'] === 'atlassian:Project') {
            const members = (0, (0, parcelRequire("o6TQ1")).extractMembers)(jsonLd);
            if (members && members.length !== 0) return members;
        }
        const updatedBy = jsonLd['atlassian:updatedBy'];
        if (updatedBy) {
            const extractedPersons = (0, (0, parcelRequire("aj6Xc")).extractPersonFromJsonLd)(updatedBy);
            return extractedPersons ? [
                extractedPersons
            ] : undefined;
        }
    };
});
parcelRegister("o6TQ1", function(module, exports) {
    $parcel$export(module.exports, "extractMembers", ()=>$e9d0787cbe8b8bff$export$6281d080d62a0719);
    var $aj6Xc;
    const $e9d0787cbe8b8bff$export$6281d080d62a0719 = (jsonLd)=>{
        const members = jsonLd['atlassian:member'];
        if (members) {
            if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
            else if (members.hasOwnProperty('totalItems')) {
                const collection = members;
                if (collection.items) return collection.items.map((member)=>(0, (0, parcelRequire("aj6Xc")).extractPersonFromJsonLd)(member)).filter((member)=>!!member);
            } else {
                const memberItem = members;
                const memberItemForLink = (0, (0, parcelRequire("aj6Xc")).extractPersonFromJsonLd)(memberItem);
                if (memberItemForLink) return [
                    memberItemForLink
                ];
            }
        }
    };
});
parcelRegister("jELGn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3b57ea7b1c4bc68$export$2e2bcd8739ae039);
    var $5nDnb;
    var $8dVIb;
    const $c3b57ea7b1c4bc68$var$extractPreview = (data)=>{
        if (!data) return undefined;
        const url = (0, (0, parcelRequire("5nDnb")).extractImage)(data);
        return url ? {
            type: (0, (0, parcelRequire("8dVIb")).MediaType).Image,
            url: url
        } : undefined;
    };
    var $c3b57ea7b1c4bc68$export$2e2bcd8739ae039 = $c3b57ea7b1c4bc68$var$extractPreview;
});
parcelRegister("5nDnb", function(module, exports) {
    $parcel$export(module.exports, "extractImage", ()=>$bf7a10bb5159fbbd$export$4c753a1297cb9805);
    var $7OmtM;
    const $bf7a10bb5159fbbd$export$4c753a1297cb9805 = (jsonLd)=>{
        const image = jsonLd.image;
        if (image) {
            if (typeof image === 'string') return image;
            else if (image['@type'] === 'Link') return (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(image);
            else if (image['@type'] === 'Image') {
                if (image.url) return (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(image.url);
            }
        }
    };
});
parcelRegister("bWsp1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92024e0264c50850$export$2e2bcd8739ae039);
    var $cuw1y;
    var $8dVIb;
    const $92024e0264c50850$var$priorityMapper = {
        blocker: (0, (0, parcelRequire("8dVIb")).IconType).PriorityBlocker,
        critical: (0, (0, parcelRequire("8dVIb")).IconType).PriorityCritical,
        high: (0, (0, parcelRequire("8dVIb")).IconType).PriorityHigh,
        highest: (0, (0, parcelRequire("8dVIb")).IconType).PriorityHighest,
        low: (0, (0, parcelRequire("8dVIb")).IconType).PriorityLow,
        lowest: (0, (0, parcelRequire("8dVIb")).IconType).PriorityLowest,
        major: (0, (0, parcelRequire("8dVIb")).IconType).PriorityMajor,
        medium: (0, (0, parcelRequire("8dVIb")).IconType).PriorityMedium,
        minor: (0, (0, parcelRequire("8dVIb")).IconType).PriorityMinor,
        trivial: (0, (0, parcelRequire("8dVIb")).IconType).PriorityTrivial,
        undefined: (0, (0, parcelRequire("8dVIb")).IconType).PriorityUndefined
    };
    const $92024e0264c50850$var$extractPriority = (data)=>{
        const priority = data['atlassian:priority'];
        if (priority) {
            if (typeof priority === 'string') {
                const icon = $92024e0264c50850$var$priorityMapper[priority.toLowerCase()];
                if (icon) return {
                    icon: icon,
                    label: priority
                };
            } else if (priority['@type'] === 'Object') return {
                label: priority.name,
                url: priority.icon && (0, (0, parcelRequire("cuw1y")).extractUrlFromIconJsonLd)(priority.icon)
            };
        }
    };
    var $92024e0264c50850$export$2e2bcd8739ae039 = $92024e0264c50850$var$extractPriority;
});
parcelRegister("djFaY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c680025bc04d725$export$2e2bcd8739ae039);
    var $8UXrm;
    var $fgpl1;
    var $evnkj;
    var $dn5wJ;
    var $eL1Oa;
    var $joFPX;
    var $j4IjY;
    const $9c680025bc04d725$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
        if (!actionType) return;
        return {
            action: {
                actionType: actionType,
                resourceIdentifiers: resourceIdentifiers
            },
            providerKey: extensionKey,
            details: details
        };
    };
    const $9c680025bc04d725$var$extractAction = (response, id)=>{
        const extensionKey = (0, (0, parcelRequire("fgpl1")).getExtensionKey)(response);
        const data = response?.data;
        const actions = (0, (0, parcelRequire("j4IjY")).default)(data);
        if (!extensionKey || actions.length === 0) return;
        const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
        if (!action || !action.resourceIdentifiers) return;
        const read = $9c680025bc04d725$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
        const url = (0, (0, parcelRequire("8UXrm")).extractLink)(data);
        const previewData = response ? (0, (0, parcelRequire("joFPX")).extractPreviewAction)(response) : null;
        const details = {
            id: id,
            url: url,
            previewData: previewData
        };
        const update = $9c680025bc04d725$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
        return read || update ? {
            read: read,
            update: update
        } : undefined;
    };
    const $9c680025bc04d725$var$extractState = (response, actionOptions, id)=>{
        if (!response || !response.data) return;
        const lozenge = (0, (0, parcelRequire("eL1Oa")).extractLozenge)(response?.data);
        if (!lozenge) return;
        if (!(0, (0, parcelRequire("evnkj")).canShowAction)((0, (0, parcelRequire("dn5wJ")).CardAction).ChangeStatusAction, actionOptions)) return lozenge;
        const action = $9c680025bc04d725$var$extractAction(response, id);
        return {
            ...lozenge,
            action: action
        };
    };
    var $9c680025bc04d725$export$2e2bcd8739ae039 = $9c680025bc04d725$var$extractState;
});
parcelRegister("eL1Oa", function(module, exports) {
    $parcel$export(module.exports, "extractLozenge", ()=>$00b49e71ec2a1469$export$e5da155556a77bca);
    var $FcDCF;
    var $hJJo2;
    var $8KYrd;
    var $1fxuS;
    var $a4RsY;
    const $00b49e71ec2a1469$var$DOC_TYPES = [
        'schema:BlogPosting',
        'schema:TextDigitalDocument',
        'schema:DigitalDocument',
        'schema:PresentationDigitalDocument',
        'schema:SpreadsheetDigitalDocument'
    ];
    const $00b49e71ec2a1469$export$e5da155556a77bca = (jsonLd)=>{
        const type = (0, (0, parcelRequire("FcDCF")).extractType)(jsonLd);
        if (type) {
            if (type.includes('atlassian:SourceCodePullRequest')) return (0, (0, parcelRequire("hJJo2")).extractState)(jsonLd);
            else if (type.includes('atlassian:Task')) {
                const jsonLdTask = jsonLd;
                const lozengeFromTag = (0, (0, parcelRequire("8KYrd")).extractTag)(jsonLdTask);
                const lozengeFromStatus = (0, (0, parcelRequire("1fxuS")).extractTaskStatus)(jsonLdTask);
                const lozengeFromTaskType = $00b49e71ec2a1469$var$extractLozengeFromTaskType(jsonLdTask);
                return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
            } else if (type.some((types)=>$00b49e71ec2a1469$var$DOC_TYPES.includes(types))) {
                const jsonLdDocument = jsonLd;
                const lozengeFromState = (0, (0, parcelRequire("hJJo2")).extractState)(jsonLdDocument);
                return lozengeFromState;
            } else if (type.includes('atlassian:Goal')) {
                const jsonLdProject = jsonLd;
                const lozengeFromState = (0, (0, parcelRequire("hJJo2")).extractState)(jsonLdProject);
                return lozengeFromState;
            } else if (type.includes('atlassian:Project')) {
                const jsonLdProject = jsonLd;
                const lozengeFromState = (0, (0, parcelRequire("hJJo2")).extractState)(jsonLdProject);
                return lozengeFromState;
            } else if (type.includes('atlassian:UndefinedLink')) return {
                text: 'UNDEFINED',
                appearance: 'inprogress'
            };
        }
    };
    const $00b49e71ec2a1469$var$extractLozengeFromTaskType = (jsonLdTask)=>{
        const taskType = (0, (0, parcelRequire("a4RsY")).extractTaskType)(jsonLdTask);
        if (taskType && taskType.name) return {
            text: taskType.name,
            appearance: 'success'
        };
    };
});
parcelRegister("hJJo2", function(module, exports) {
    $parcel$export(module.exports, "extractState", ()=>$23353713d30390cb$export$5e4074cbce6574c7);
    var $5Sb4A;
    const $23353713d30390cb$var$lozengeAccentStyles = {
        blue: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            color: "var(--ds-text-accent-blue, #0055CC)"
        },
        gray: {
            backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
            color: "var(--ds-text-accent-gray, #44546F)"
        },
        green: {
            backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            color: "var(--ds-text-accent-green, #216E4E)"
        },
        lime: {
            backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
            color: "var(--ds-text-accent-lime, #4C6B1F)"
        },
        magenta: {
            backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            color: "var(--ds-text-accent-magenta, #943D73)"
        },
        orange: {
            backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
            color: "var(--ds-text-accent-orange, #A54800)"
        },
        purple: {
            backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            color: "var(--ds-text-accent-purple, #5E4DB2)"
        },
        red: {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            color: "var(--ds-text-accent-red, #AE2E24)"
        },
        teal: {
            backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            color: "var(--ds-text-accent-teal, #206A83)"
        },
        yellow: {
            backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            color: "var(--ds-text-accent-yellow, #7F5F01)"
        }
    };
    const $23353713d30390cb$export$5e4074cbce6574c7 = (jsonLd)=>{
        const state = jsonLd['atlassian:state'];
        if (state) {
            if (typeof state === 'string') {
                const linkState = state.toLowerCase();
                if (!(0, (0, parcelRequire("5Sb4A")).OMIT_STATES).includes(linkState)) return {
                    text: linkState,
                    appearance: (0, (0, parcelRequire("5Sb4A")).VALID_STATES)[linkState] || 'default'
                };
            } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
                if (state.name) {
                    const accent = state.accent;
                    return {
                        text: state.name,
                        appearance: state.appearance || 'default',
                        style: accent ? $23353713d30390cb$var$lozengeAccentStyles[accent] : undefined
                    };
                }
            }
        }
    };
});
parcelRegister("5Sb4A", function(module, exports) {
    $parcel$export(module.exports, "isValidAppearance", ()=>$0823e05e6f9f26fe$export$ce6b5b303f8e3c99);
    $parcel$export(module.exports, "VALID_STATES", ()=>$0823e05e6f9f26fe$export$7b1deaaad25d1dc1);
    $parcel$export(module.exports, "OMIT_STATES", ()=>$0823e05e6f9f26fe$export$772610da74ddbc07);
    const $0823e05e6f9f26fe$var$VALID_APPEARANCES = [
        'default',
        'success',
        'removed',
        'inprogress',
        'new',
        'moved'
    ];
    const $0823e05e6f9f26fe$export$ce6b5b303f8e3c99 = (appearance)=>{
        return $0823e05e6f9f26fe$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
    };
    const $0823e05e6f9f26fe$export$7b1deaaad25d1dc1 = {
        open: 'inprogress',
        merged: 'success',
        declined: 'removed',
        closed: 'success',
        draft: 'inprogress',
        archived: 'default'
    };
    const $0823e05e6f9f26fe$export$772610da74ddbc07 = [
        'current'
    ];
});
parcelRegister("8KYrd", function(module, exports) {
    $parcel$export(module.exports, "extractTag", ()=>$6e0524caff97ae26$export$962a8da34cf78a4f);
    var $5Sb4A;
    const $6e0524caff97ae26$export$962a8da34cf78a4f = (jsonLd)=>{
        const tag = jsonLd.tag;
        if (tag) {
            if (typeof tag === 'string') return {
                text: tag,
                appearance: 'default'
            };
            else if (Array.isArray(tag)) {
                const tags = tag.map($6e0524caff97ae26$var$extractTagItem).filter((item)=>!!item);
                if (tags.length > 0) return tags.shift();
            } else return $6e0524caff97ae26$var$extractTagItem(tag);
        }
    };
    const $6e0524caff97ae26$var$extractTagItem = (tag)=>{
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (tag['@type'] === 'Link') {
            if (tag.name) return {
                text: tag.name,
                appearance: 'default'
            };
        } else if (tag.name) {
            const appearance = tag.appearance;
            return {
                text: tag.name,
                appearance: (0, (0, parcelRequire("5Sb4A")).isValidAppearance)(appearance) && appearance || 'default'
            };
        }
    };
});
parcelRegister("1fxuS", function(module, exports) {
    $parcel$export(module.exports, "extractTaskStatus", ()=>$4b88cdff9f070a4a$export$7698df1946deda72);
    const $4b88cdff9f070a4a$export$7698df1946deda72 = (jsonLd)=>{
        const taskStatus = jsonLd['atlassian:taskStatus'];
        if (taskStatus && taskStatus.name) return {
            text: taskStatus.name,
            appearance: 'success'
        };
    };
});
parcelRegister("iGAv4", function(module, exports) {
    $parcel$export(module.exports, "extractLatestCommit", ()=>$0e72a17e0fb58d4d$export$f222392162cff0d8);
    const $0e72a17e0fb58d4d$export$f222392162cff0d8 = (jsonLd)=>{
        const latestCommit = jsonLd['atlassian:latestCommit'];
        if (typeof latestCommit === 'string') return latestCommit;
        if (latestCommit) return latestCommit ? latestCommit.name : undefined;
    };
});
parcelRegister("cDuhk", function(module, exports) {
    $parcel$export(module.exports, "fireRelatedLinksViewedEvent", ()=>$80648c8e7baf054f$export$b33ea4a8393685d8);
    $parcel$export(module.exports, "RelatedUrlItemAnalyticsContext", ()=>$80648c8e7baf054f$export$e88153cb3e6fc3fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $ffYTp;
    var $fzJZi;
    const $80648c8e7baf054f$var$createUiRelatedLinksViewedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
            action: 'viewed',
            actionSubject: 'relatedLinks',
            eventType: 'ui',
            attributes: {
                relatedLinksCount: relatedLinksCount
            }
        });
    const $80648c8e7baf054f$export$b33ea4a8393685d8 = (createAnalyticsEvent)=>(attributes)=>{
            const payload = $80648c8e7baf054f$var$createUiRelatedLinksViewedEventPayload(attributes);
            if (payload) createAnalyticsEvent({
                ...payload
            }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
        };
    const $80648c8e7baf054f$export$e88153cb3e6fc3fc = (props)=>{
        const { children: children, details: details } = props;
        const attributes = (0, (0, parcelRequire("ffYTp")).getResolvedAttributes)({
            url: ''
        }, details);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                attributes: attributes,
                component: 'relatedLink'
            }
        }, children);
    };
});
parcelRegister("MHZ3k", function(module, exports) {
    $parcel$export(module.exports, "RelatedUrlsBlockResolvingView", ()=>$10bf60a909a72bf0$export$50a43430722f62f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $gU02S;
    var $dghu0;
    const $10bf60a909a72bf0$export$50a43430722f62f8 = ({ testId: testId, ...blockProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gU02S")).default), {
            height: 1.55,
            width: 22
        }));
});
parcelRegister("1qDIM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dff75b4d7cc06d3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $4tgi5;
    const $5dff75b4d7cc06d3$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).InternalActionName).AISummaryAction];
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved) return null;
        if (!actionData?.url) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4tgi5")).default), {
            ...props,
            testId: testId,
            url: actionData.url
        });
    };
    var $5dff75b4d7cc06d3$export$2e2bcd8739ae039 = $5dff75b4d7cc06d3$var$AISummaryBlock;
});
parcelRegister("4tgi5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$413bb2fab5c71807$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKZoD;
    var $8dVIb;
    var $1MeuC;
    var $bHeMs;
    var $aBTst;
    var $dghu0;
    var $adeuB;
    const $413bb2fab5c71807$var$AISummaryBlockResolvedView = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("1MeuC")).default), (0, (0, parcelRequire("bHeMs")).default));
        const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
        const { state: { content: content, status: status } } = (0, (0, parcelRequire("1MeuC")).default)(url);
        const showAISummary = status === 'done' || status === 'loading' && !!content;
        const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
        const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
        if (!showAISummary) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, placeholder);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...props,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Vertical,
            testId: `${testId}-resolved-view`,
            overrideCss: (0, (0, parcelRequire("f8Sb3")).css)("overflow:visible;", props.overrideCss)
        }, status === 'done' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adeuB")).default), {
            fromCache: isSummarisedOnMountRef.current
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aBTst")).default), {
            minHeight: minHeight,
            show: showAISummary,
            showTransition: !isSummarisedOnMountRef.current
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bHeMs")).default), {
            testId: `${testId}-ai-summary`,
            minHeight: minHeight,
            content: content
        })));
    };
    var $413bb2fab5c71807$export$2e2bcd8739ae039 = $413bb2fab5c71807$var$AISummaryBlockResolvedView;
});
parcelRegister("bHeMs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea67ef8b17402f34$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $flpap;
    var $aRS1S;
    function $ea67ef8b17402f34$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ea67ef8b17402f34$var$AISummaryCSSStyles = {
        name: "178flxl",
        styles: "font-size:0.75rem;line-height:1rem;word-wrap:break-word;word-break:break-word;white-space:normal;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text"
    };
    const $ea67ef8b17402f34$var$AISummary = ({ content: content = '', overrideCss: overrideCss, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
        if (!content && minHeight === 0) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("flpap")).default), {
            "data-testid": testId,
            css: [
                $ea67ef8b17402f34$var$AISummaryCSSStyles,
                overrideCss
            ],
            children: content,
            options: {
                forceWrapper: true,
                overrides: {
                    ul: (0, (0, parcelRequire("aRS1S")).default)
                }
            },
            style: {
                minHeight: minHeight
            }
        });
    };
    var $ea67ef8b17402f34$export$2e2bcd8739ae039 = $ea67ef8b17402f34$var$AISummary;
});
parcelRegister("flpap", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2bc56c6c0b4e02e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $b2bc56c6c0b4e02e$var$n() {
        return $b2bc56c6c0b4e02e$var$n = Object.assign ? Object.assign.bind() : function(e) {
            for(var n = 1; n < arguments.length; n++){
                var t = arguments[n];
                for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
            }
            return e;
        }, $b2bc56c6c0b4e02e$var$n.apply(this, arguments);
    }
    const $b2bc56c6c0b4e02e$var$t = [
        "children",
        "options"
    ];
    var $b2bc56c6c0b4e02e$export$e0aa44767d8750d5, $b2bc56c6c0b4e02e$var$i;
    !function(e) {
        e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
    }($b2bc56c6c0b4e02e$export$e0aa44767d8750d5 || ($b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {})), function(e) {
        e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
    }($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
    const $b2bc56c6c0b4e02e$var$l = [
        "allowFullScreen",
        "allowTransparency",
        "autoComplete",
        "autoFocus",
        "autoPlay",
        "cellPadding",
        "cellSpacing",
        "charSet",
        "className",
        "classId",
        "colSpan",
        "contentEditable",
        "contextMenu",
        "crossOrigin",
        "encType",
        "formAction",
        "formEncType",
        "formMethod",
        "formNoValidate",
        "formTarget",
        "frameBorder",
        "hrefLang",
        "inputMode",
        "keyParams",
        "keyType",
        "marginHeight",
        "marginWidth",
        "maxLength",
        "mediaGroup",
        "minLength",
        "noValidate",
        "radioGroup",
        "readOnly",
        "rowSpan",
        "spellCheck",
        "srcDoc",
        "srcLang",
        "srcSet",
        "tabIndex",
        "useMap"
    ].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
        for: "htmlFor"
    }), $b2bc56c6c0b4e02e$var$o = {
        amp: "&",
        apos: "'",
        gt: ">",
        lt: "<",
        nbsp: "\xa0",
        quot: "\u201C"
    }, $b2bc56c6c0b4e02e$var$c = [
        "style",
        "script"
    ], $b2bc56c6c0b4e02e$var$a = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$u = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/, $b2bc56c6c0b4e02e$var$p = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)](:.*)\n/, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$$ = /\f/g, $b2bc56c6c0b4e02e$var$S = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$w = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$E = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i, $b2bc56c6c0b4e02e$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$L = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$z = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$M = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$I = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$j = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$B = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, $b2bc56c6c0b4e02e$var$H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$_ = /(\[|\])/g, $b2bc56c6c0b4e02e$var$F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$W = /\t/g, $b2bc56c6c0b4e02e$var$G = /^ *\| */, $b2bc56c6c0b4e02e$var$Z = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$q = / *$/, $b2bc56c6c0b4e02e$var$V = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$X = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$Q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$J = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/, $b2bc56c6c0b4e02e$var$K = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/, $b2bc56c6c0b4e02e$var$Y = /^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/, $b2bc56c6c0b4e02e$var$ee = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/, $b2bc56c6c0b4e02e$var$ne = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$re = /^\n+/, $b2bc56c6c0b4e02e$var$ie = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$le = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$oe = / *\n+$/, $b2bc56c6c0b4e02e$var$ce = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$se = "(?:[*+-])";
    function $b2bc56c6c0b4e02e$var$de(e) {
        return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$se) + ") +";
    }
    const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$de(1), $b2bc56c6c0b4e02e$var$pe = $b2bc56c6c0b4e02e$var$de(2);
    function $b2bc56c6c0b4e02e$var$fe(e) {
        return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$pe));
    }
    const $b2bc56c6c0b4e02e$var$he = $b2bc56c6c0b4e02e$var$fe(1), $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$fe(2);
    function $b2bc56c6c0b4e02e$var$ge(e) {
        return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$pe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$se) + " )[^\\n]*)*(\\n|$)", "gm");
    }
    const $b2bc56c6c0b4e02e$var$ye = $b2bc56c6c0b4e02e$var$ge(1), $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ge(2);
    function $b2bc56c6c0b4e02e$var$xe(e) {
        const n = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$se;
        return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
    }
    const $b2bc56c6c0b4e02e$var$ve = $b2bc56c6c0b4e02e$var$xe(1), $b2bc56c6c0b4e02e$var$be = $b2bc56c6c0b4e02e$var$xe(2);
    function $b2bc56c6c0b4e02e$var$$e(e, n) {
        const t = 1 === n, r = t ? $b2bc56c6c0b4e02e$var$ve : $b2bc56c6c0b4e02e$var$be, i = t ? $b2bc56c6c0b4e02e$var$ye : $b2bc56c6c0b4e02e$var$ke, l = t ? $b2bc56c6c0b4e02e$var$he : $b2bc56c6c0b4e02e$var$me;
        return {
            match (e, n, t) {
                const i = $b2bc56c6c0b4e02e$var$ce.exec(t);
                return i && (n.list || !n.inline && !n.simple) ? r.exec(e = i[1] + e) : null;
            },
            order: 1,
            parse (e, n, r) {
                const o = t ? +e[2] : void 0, c = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(i);
                let a = !1;
                return {
                    items: c.map(function(e, t) {
                        const i = l.exec(e)[0].length, o = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(o, "").replace(l, ""), d = t === c.length - 1, u = -1 !== s.indexOf("\n\n") || d && a;
                        a = u;
                        const p = r.inline, f = r.list;
                        let h;
                        r.list = !0, u ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$oe, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$oe, ""));
                        const m = n(h, r);
                        return r.inline = p, r.list = f, m;
                    }),
                    ordered: t,
                    start: o
                };
            },
            render: (n, t, r)=>e(n.ordered ? "ol" : "ul", {
                    key: r.key,
                    start: "20" === n.type ? n.start : void 0
                }, n.items.map(function(n, i) {
                    return e("li", {
                        key: i
                    }, t(n, r));
                }))
        };
    }
    const $b2bc56c6c0b4e02e$var$Se = /^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$we = /^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ce = [
        $b2bc56c6c0b4e02e$var$u,
        $b2bc56c6c0b4e02e$var$m,
        $b2bc56c6c0b4e02e$var$g,
        $b2bc56c6c0b4e02e$var$C,
        $b2bc56c6c0b4e02e$var$A,
        $b2bc56c6c0b4e02e$var$E,
        $b2bc56c6c0b4e02e$var$L,
        $b2bc56c6c0b4e02e$var$N,
        $b2bc56c6c0b4e02e$var$ye,
        $b2bc56c6c0b4e02e$var$ve,
        $b2bc56c6c0b4e02e$var$ke,
        $b2bc56c6c0b4e02e$var$be
    ], $b2bc56c6c0b4e02e$var$Ee = [
        ...$b2bc56c6c0b4e02e$var$Ce,
        /^[^\n]+(?:  \n|\n{2,})/,
        $b2bc56c6c0b4e02e$var$O,
        $b2bc56c6c0b4e02e$var$M
    ];
    function $b2bc56c6c0b4e02e$var$Ae(e) {
        return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
    }
    function $b2bc56c6c0b4e02e$var$Oe(e) {
        return $b2bc56c6c0b4e02e$var$Q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$V.test(e) ? "center" : $b2bc56c6c0b4e02e$var$X.test(e) ? "left" : null;
    }
    function $b2bc56c6c0b4e02e$var$Te(e, n, t) {
        const r = t.inTable;
        t.inTable = !0;
        const i = n(e.trim(), t);
        t.inTable = r;
        let l = [
            []
        ];
        return i.forEach(function(e, n) {
            "26" === e.type ? 0 !== n && n !== i.length - 1 && l.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace($b2bc56c6c0b4e02e$var$q, "")), l[l.length - 1].push(e));
        }), l;
    }
    function $b2bc56c6c0b4e02e$var$Le(e, n, t) {
        t.inline = !0;
        const r = $b2bc56c6c0b4e02e$var$Te(e[1], n, t), i = e[2].replace($b2bc56c6c0b4e02e$var$Z, "").split("|").map($b2bc56c6c0b4e02e$var$Oe), l = function(e, n, t) {
            return e.trim().split("\n").map(function(e) {
                return $b2bc56c6c0b4e02e$var$Te(e, n, t);
            });
        }(e[3], n, t);
        return t.inline = !1, {
            align: i,
            cells: l,
            header: r,
            type: "25"
        };
    }
    function $b2bc56c6c0b4e02e$var$ze(e, n) {
        return null == e.align[n] ? {} : {
            textAlign: e.align[n]
        };
    }
    function $b2bc56c6c0b4e02e$var$Me(e) {
        return function(n, t) {
            return t.inline ? e.exec(n) : null;
        };
    }
    function $b2bc56c6c0b4e02e$var$Ie(e) {
        return function(n, t) {
            return t.inline || t.simple ? e.exec(n) : null;
        };
    }
    function $b2bc56c6c0b4e02e$var$Re(e) {
        return function(n, t) {
            return t.inline || t.simple ? null : e.exec(n);
        };
    }
    function $b2bc56c6c0b4e02e$var$Ue(e) {
        return function(n) {
            return e.exec(n);
        };
    }
    function $b2bc56c6c0b4e02e$var$je(e, n, t) {
        if (n.inline || n.simple) return null;
        if (t && !t.endsWith("\n")) return null;
        let r = "";
        e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ce.some((n)=>n.test(e)) && (r += e + "\n", e.trim()));
        const i = r.trimEnd();
        return "" == i ? null : [
            r,
            i
        ];
    }
    function $b2bc56c6c0b4e02e$var$Be(e) {
        try {
            if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
        } catch (e) {
            return null;
        }
        return e;
    }
    function $b2bc56c6c0b4e02e$var$Ne(e) {
        return e.replace($b2bc56c6c0b4e02e$var$le, "$1");
    }
    function $b2bc56c6c0b4e02e$var$He(e, n, t) {
        const r = t.inline || !1, i = t.simple || !1;
        t.inline = !0, t.simple = !0;
        const l = e(n, t);
        return t.inline = r, t.simple = i, l;
    }
    function $b2bc56c6c0b4e02e$var$De(e, n, t) {
        const r = t.inline || !1, i = t.simple || !1;
        t.inline = !1, t.simple = !0;
        const l = e(n, t);
        return t.inline = r, t.simple = i, l;
    }
    function $b2bc56c6c0b4e02e$var$Pe(e, n, t) {
        return t.inline = !1, e(n, t);
    }
    const $b2bc56c6c0b4e02e$var$_e = (e, n, t)=>({
            children: $b2bc56c6c0b4e02e$var$He(n, e[1], t)
        });
    function $b2bc56c6c0b4e02e$var$Fe() {
        return {};
    }
    function $b2bc56c6c0b4e02e$var$We() {
        return null;
    }
    function $b2bc56c6c0b4e02e$var$Ge(...e) {
        return e.filter(Boolean).join(" ");
    }
    function $b2bc56c6c0b4e02e$var$Ze(e, n, t) {
        let r = e;
        const i = n.split(".");
        for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
        return r || t;
    }
    function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(t, r = {}) {
        r.overrides = r.overrides || {}, r.slugify = r.slugify || $b2bc56c6c0b4e02e$var$Ae, r.namedCodesToUnicode = r.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$n({}, $b2bc56c6c0b4e02e$var$o, r.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$o;
        const i = r.createElement || $5uXOq.createElement;
        function d(e, t, ...l) {
            const o = $b2bc56c6c0b4e02e$var$Ze(r.overrides, `${e}.props`, {});
            return i(function(e, n) {
                const t = $b2bc56c6c0b4e02e$var$Ze(n, e);
                return t ? "function" == typeof t || "object" == typeof t && "render" in t ? t : $b2bc56c6c0b4e02e$var$Ze(n, `${e}.component`, e) : e;
            }(e, r.overrides), $b2bc56c6c0b4e02e$var$n({}, t, o, {
                className: $b2bc56c6c0b4e02e$var$Ge(null == t ? void 0 : t.className, o.className) || void 0
            }), ...l);
        }
        function Z(n) {
            n = n.replace($b2bc56c6c0b4e02e$var$S, "");
            let t = !1;
            r.forceInline ? t = !0 : r.forceBlock || (t = !1 === $b2bc56c6c0b4e02e$var$F.test(n));
            const i = oe(le(t ? n : `${n.trimEnd().replace($b2bc56c6c0b4e02e$var$re, "")}\n\n`, {
                inline: t
            }));
            for(; "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
            if (null === r.wrapper) return i;
            const l = r.wrapper || (t ? "span" : "div");
            let o;
            if (i.length > 1 || r.forceWrapper) o = i;
            else {
                if (1 === i.length) return o = i[0], "string" == typeof o ? d("span", {
                    key: "outer"
                }, o) : o;
                o = null;
            }
            return $5uXOq.createElement(l, {
                key: "outer"
            }, o);
        }
        function q(n) {
            const t = n.match($b2bc56c6c0b4e02e$var$a);
            return t ? t.reduce(function(n, t, r) {
                const i = t.indexOf("=");
                if (-1 !== i) {
                    const o = (function(e) {
                        return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$z) && (e = e.replace($b2bc56c6c0b4e02e$var$B, function(e, n) {
                            return n.toUpperCase();
                        })), e;
                    })(t.slice(0, i)).trim(), c = function(e) {
                        const n = e[0];
                        return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                    }(t.slice(i + 1).trim()), a = $b2bc56c6c0b4e02e$var$l[o] || o, s = n[a] = function(e, n) {
                        return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                            const t = n.slice(0, n.indexOf(":"));
                            return e[t.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = n.slice(t.length + 1).trim(), e;
                        }, {}) : "href" === e || "src" === e ? $b2bc56c6c0b4e02e$var$Be(n) : (n.match($b2bc56c6c0b4e02e$var$I) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                    }(o, c);
                    "string" == typeof s && ($b2bc56c6c0b4e02e$var$O.test(s) || $b2bc56c6c0b4e02e$var$M.test(s)) && (n[a] = $5uXOq.cloneElement(Z(s.trim()), {
                        key: r
                    }));
                } else "style" !== t && (n[$b2bc56c6c0b4e02e$var$l[t] || t] = !0);
                return n;
            }, {}) : null;
        }
        const V = [], X = {}, Q = {
            0: {
                match: $b2bc56c6c0b4e02e$var$Re($b2bc56c6c0b4e02e$var$u),
                order: 1,
                parse: (e, n, t)=>({
                        children: n(e[0].replace($b2bc56c6c0b4e02e$var$p, ""), t)
                    }),
                render: (e, n, t)=>d("blockquote", {
                        key: t.key
                    }, n(e.children, t))
            },
            1: {
                match: $b2bc56c6c0b4e02e$var$Ue($b2bc56c6c0b4e02e$var$f),
                order: 1,
                parse: $b2bc56c6c0b4e02e$var$Fe,
                render: (e, n, t)=>d("br", {
                        key: t.key
                    })
            },
            2: {
                match: $b2bc56c6c0b4e02e$var$Re($b2bc56c6c0b4e02e$var$h),
                order: 1,
                parse: $b2bc56c6c0b4e02e$var$Fe,
                render: (e, n, t)=>d("hr", {
                        key: t.key
                    })
            },
            3: {
                match: $b2bc56c6c0b4e02e$var$Re($b2bc56c6c0b4e02e$var$g),
                order: 0,
                parse: (e)=>({
                        lang: void 0,
                        text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                    }),
                render: (e, t, r)=>d("pre", {
                        key: r.key
                    }, d("code", $b2bc56c6c0b4e02e$var$n({}, e.attrs, {
                        className: e.lang ? `lang-${e.lang}` : ""
                    }), e.text))
            },
            4: {
                match: $b2bc56c6c0b4e02e$var$Re($b2bc56c6c0b4e02e$var$m),
                order: 0,
                parse: (e)=>({
                        attrs: q(e[3] || ""),
                        lang: e[2] || void 0,
                        text: e[4],
                        type: "3"
                    })
            },
            5: {
                match: $b2bc56c6c0b4e02e$var$Ie($b2bc56c6c0b4e02e$var$y),
                order: 3,
                parse: (e)=>({
                        text: e[2]
                    }),
                render: (e, n, t)=>d("code", {
                        key: t.key
                    }, e.text)
            },
            6: {
                match: $b2bc56c6c0b4e02e$var$Re($b2bc56c6c0b4e02e$var$v),
                order: 0,
                parse: (e)=>(V.push({
                        footnote: e[2],
                        identifier: e[1]
                    }), {}),
                render: $b2bc56c6c0b4e02e$var$We
            },
            7: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$b),
                order: 1,
                parse: (e)=>({
                        target: `#${r.slugify(e[1])}`,
                        text: e[1]
                    }),
                render: (e, n, t)=>d("a", {
                        key: t.key,
                        href: $b2bc56c6c0b4e02e$var$Be(e.target)
                    }, d("sup", {
                        key: t.key
                    }, e.text))
            },
            8: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$w),
                order: 1,
                parse: (e)=>({
                        completed: "x" === e[1].toLowerCase()
                    }),
                render: (e, n, t)=>d("input", {
                        checked: e.completed,
                        key: t.key,
                        readOnly: !0,
                        type: "checkbox"
                    })
            },
            9: {
                match: $b2bc56c6c0b4e02e$var$Re(r.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$E : $b2bc56c6c0b4e02e$var$C),
                order: 1,
                parse: (e, n, t)=>({
                        children: $b2bc56c6c0b4e02e$var$He(n, e[2], t),
                        id: r.slugify(e[2]),
                        level: e[1].length
                    }),
                render: (e, n, t)=>d(`h${e.level}`, {
                        id: e.id,
                        key: t.key
                    }, n(e.children, t))
            },
            10: {
                match: $b2bc56c6c0b4e02e$var$Re($b2bc56c6c0b4e02e$var$A),
                order: 0,
                parse: (e, n, t)=>({
                        children: $b2bc56c6c0b4e02e$var$He(n, e[1], t),
                        level: "=" === e[2] ? 1 : 2,
                        type: "9"
                    })
            },
            11: {
                match: $b2bc56c6c0b4e02e$var$Ue($b2bc56c6c0b4e02e$var$O),
                order: 1,
                parse (e, n, t) {
                    const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ie), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), o = (a = l, $b2bc56c6c0b4e02e$var$Ee.some((e)=>e.test(a)) ? $b2bc56c6c0b4e02e$var$Pe : $b2bc56c6c0b4e02e$var$He);
                    var a;
                    const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$c.indexOf(s), u = {
                        attrs: q(e[2]),
                        noInnerParse: d,
                        tag: d ? s : e[1]
                    };
                    return t.inAnchor = t.inAnchor || "a" === s, d ? u.text = e[3] : u.children = o(n, l, t), t.inAnchor = !1, u;
                },
                render: (e, t, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$n({
                        key: r.key
                    }, e.attrs), e.text || t(e.children, r))
            },
            13: {
                match: $b2bc56c6c0b4e02e$var$Ue($b2bc56c6c0b4e02e$var$M),
                order: 1,
                parse: (e)=>({
                        attrs: q(e[2] || ""),
                        tag: e[1]
                    }),
                render: (e, t, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$n({}, e.attrs, {
                        key: r.key
                    }))
            },
            12: {
                match: $b2bc56c6c0b4e02e$var$Ue($b2bc56c6c0b4e02e$var$L),
                order: 1,
                parse: ()=>({}),
                render: $b2bc56c6c0b4e02e$var$We
            },
            14: {
                match: $b2bc56c6c0b4e02e$var$Ie($b2bc56c6c0b4e02e$var$we),
                order: 1,
                parse: (e)=>({
                        alt: e[1],
                        target: $b2bc56c6c0b4e02e$var$Ne(e[2]),
                        title: e[3]
                    }),
                render: (e, n, t)=>d("img", {
                        key: t.key,
                        alt: e.alt || void 0,
                        title: e.title || void 0,
                        src: $b2bc56c6c0b4e02e$var$Be(e.target)
                    })
            },
            15: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$Se),
                order: 3,
                parse: (e, n, t)=>({
                        children: $b2bc56c6c0b4e02e$var$De(n, e[1], t),
                        target: $b2bc56c6c0b4e02e$var$Ne(e[2]),
                        title: e[3]
                    }),
                render: (e, n, t)=>d("a", {
                        key: t.key,
                        href: $b2bc56c6c0b4e02e$var$Be(e.target),
                        title: e.title
                    }, n(e.children, t))
            },
            16: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$j),
                order: 0,
                parse: (e)=>({
                        children: [
                            {
                                text: e[1],
                                type: "27"
                            }
                        ],
                        target: e[1],
                        type: "15"
                    })
            },
            17: {
                match: (e, n)=>n.inAnchor ? null : $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$R)(e, n),
                order: 0,
                parse: (e)=>({
                        children: [
                            {
                                text: e[1],
                                type: "27"
                            }
                        ],
                        target: e[1],
                        title: void 0,
                        type: "15"
                    })
            },
            18: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$U),
                order: 0,
                parse (e) {
                    let n = e[1], t = e[1];
                    return $b2bc56c6c0b4e02e$var$s.test(t) || (t = "mailto:" + t), {
                        children: [
                            {
                                text: n.replace("mailto:", ""),
                                type: "27"
                            }
                        ],
                        target: t,
                        type: "15"
                    };
                }
            },
            20: $b2bc56c6c0b4e02e$var$$e(d, 1),
            33: $b2bc56c6c0b4e02e$var$$e(d, 2),
            19: {
                match: $b2bc56c6c0b4e02e$var$Re($b2bc56c6c0b4e02e$var$k),
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$Fe,
                render: ()=>"\n"
            },
            21: {
                match: $b2bc56c6c0b4e02e$var$je,
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$_e,
                render: (e, n, t)=>d("p", {
                        key: t.key
                    }, n(e.children, t))
            },
            22: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$H),
                order: 0,
                parse: (e)=>(X[e[1]] = {
                        target: e[2],
                        title: e[4]
                    }, {}),
                render: $b2bc56c6c0b4e02e$var$We
            },
            23: {
                match: $b2bc56c6c0b4e02e$var$Ie($b2bc56c6c0b4e02e$var$D),
                order: 0,
                parse: (e)=>({
                        alt: e[1] || void 0,
                        ref: e[2]
                    }),
                render: (e, n, t)=>d("img", {
                        key: t.key,
                        alt: e.alt,
                        src: $b2bc56c6c0b4e02e$var$Be(X[e.ref].target),
                        title: X[e.ref].title
                    })
            },
            24: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$P),
                order: 0,
                parse: (e, n, t)=>({
                        children: n(e[1], t),
                        fallbackChildren: n(e[0].replace($b2bc56c6c0b4e02e$var$_, "\\$1"), t),
                        ref: e[2]
                    }),
                render: (e, n, t)=>X[e.ref] ? d("a", {
                        key: t.key,
                        href: $b2bc56c6c0b4e02e$var$Be(X[e.ref].target),
                        title: X[e.ref].title
                    }, n(e.children, t)) : d("span", {
                        key: t.key
                    }, n(e.fallbackChildren, t))
            },
            25: {
                match: $b2bc56c6c0b4e02e$var$Re($b2bc56c6c0b4e02e$var$N),
                order: 1,
                parse: $b2bc56c6c0b4e02e$var$Le,
                render: (e, n, t)=>d("table", {
                        key: t.key
                    }, d("thead", null, d("tr", null, e.header.map(function(r, i) {
                        return d("th", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$ze(e, i)
                        }, n(r, t));
                    }))), d("tbody", null, e.cells.map(function(r, i) {
                        return d("tr", {
                            key: i
                        }, r.map(function(r, i) {
                            return d("td", {
                                key: i,
                                style: $b2bc56c6c0b4e02e$var$ze(e, i)
                            }, n(r, t));
                        }));
                    })))
            },
            26: {
                match: function(e, n) {
                    return n.inTable ? (n.inline = !0, $b2bc56c6c0b4e02e$var$G.exec(e)) : null;
                },
                order: 1,
                parse: function() {
                    return {
                        type: "26"
                    };
                },
                render: ()=>" | "
            },
            27: {
                match: $b2bc56c6c0b4e02e$var$Ue($b2bc56c6c0b4e02e$var$te),
                order: 4,
                parse: (e)=>({
                        text: e[0].replace($b2bc56c6c0b4e02e$var$T, (e, n)=>r.namedCodesToUnicode[n] ? r.namedCodesToUnicode[n] : e)
                    }),
                render: (e)=>e.text
            },
            28: {
                match: $b2bc56c6c0b4e02e$var$Ie($b2bc56c6c0b4e02e$var$J),
                order: 2,
                parse: (e, n, t)=>({
                        children: n(e[2], t)
                    }),
                render: (e, n, t)=>d("strong", {
                        key: t.key
                    }, n(e.children, t))
            },
            29: {
                match: $b2bc56c6c0b4e02e$var$Ie($b2bc56c6c0b4e02e$var$K),
                order: 3,
                parse: (e, n, t)=>({
                        children: n(e[2], t)
                    }),
                render: (e, n, t)=>d("em", {
                        key: t.key
                    }, n(e.children, t))
            },
            30: {
                match: $b2bc56c6c0b4e02e$var$Ie($b2bc56c6c0b4e02e$var$ne),
                order: 1,
                parse: (e)=>({
                        text: e[1],
                        type: "27"
                    })
            },
            31: {
                match: $b2bc56c6c0b4e02e$var$Ie($b2bc56c6c0b4e02e$var$Y),
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$_e,
                render: (e, n, t)=>d("mark", {
                        key: t.key
                    }, n(e.children, t))
            },
            32: {
                match: $b2bc56c6c0b4e02e$var$Ie($b2bc56c6c0b4e02e$var$ee),
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$_e,
                render: (e, n, t)=>d("del", {
                        key: t.key
                    }, n(e.children, t))
            }
        };
        !0 === r.disableParsingRawHTML && (delete Q[11], delete Q[13]);
        const le = function(e) {
            let n = Object.keys(e);
            function t(r, i) {
                let l = [], o = "";
                for(; r;){
                    let c = 0;
                    for(; c < n.length;){
                        const a = n[c], s = e[a], d = s.match(r, i, o);
                        if (d) {
                            const e = d[0];
                            r = r.substring(e.length);
                            const n = s.parse(d, t, i);
                            null == n.type && (n.type = a), l.push(n), o = e;
                            break;
                        }
                        c++;
                    }
                }
                return l;
            }
            return n.sort(function(n, t) {
                let r = e[n].order, i = e[t].order;
                return r !== i ? r - i : 1;
            }), function(e, n) {
                return t(function(e) {
                    return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$$, "").replace($b2bc56c6c0b4e02e$var$W, "    ");
                }(e), n);
            };
        }(Q), oe = (ce = function(e, n) {
            return function(t, r, i) {
                const l = e[t.type].render;
                return n ? n(()=>l(t, r, i), t, r, i) : l(t, r, i);
            };
        }(Q, r.renderRule), function e(n, t = {}) {
            if (Array.isArray(n)) {
                const r = t.key, i = [];
                let l = !1;
                for(let r = 0; r < n.length; r++){
                    t.key = r;
                    const o = e(n[r], t), c = "string" == typeof o;
                    c && l ? i[i.length - 1] += o : null !== o && i.push(o), l = c;
                }
                return t.key = r, i;
            }
            return ce(n, e, t);
        });
        var ce;
        const ae = Z(t);
        return V.length ? d("div", null, ae, d("footer", {
            key: "footer"
        }, V.map(function(e) {
            return d("div", {
                id: r.slugify(e.identifier),
                key: e.identifier
            }, e.identifier, oe(le(e.footnote, {
                inline: !0
            })));
        }))) : ae;
    }
    var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (n)=>{
        let { children: r, options: i } = n, l = function(e, n) {
            if (null == e) return {};
            var t, r, i = {}, l = Object.keys(e);
            for(r = 0; r < l.length; r++)n.indexOf(t = l[r]) >= 0 || (i[t] = e[t]);
            return i;
        }(n, $b2bc56c6c0b4e02e$var$t);
        return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
    };
});
parcelRegister("aRS1S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$270fc2c4bbd80c91$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    function $270fc2c4bbd80c91$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $270fc2c4bbd80c91$var$listStyles = {
        name: "k4jzwf",
        styles: "padding-left:var(--ds-space-250, 20px);padding-inline-start:var(--ds-space-250, 20px)"
    };
    const $270fc2c4bbd80c91$var$UList = ({ children: children, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("ul", {
            css: $270fc2c4bbd80c91$var$listStyles,
            ...props
        }, children);
    var $270fc2c4bbd80c91$export$2e2bcd8739ae039 = $270fc2c4bbd80c91$var$UList;
});
parcelRegister("aBTst", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8d8f80d50d9d1e4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    const $a8d8f80d50d9d1e4$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
        const [height, setHeight] = (0, $5uXOq.useState)(0);
        const ref = (0, $5uXOq.useRef)(null);
        const transition = isFadeIn ? 'height, opacity' : 'height';
        (0, $5uXOq.useEffect)(()=>{
            if (show && ref.current) setHeight(ref.current.scrollHeight);
            else setHeight(0);
        }, [
            children,
            show
        ]);
        return show ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            style: {
                height: height,
                minHeight: minHeight,
                lineHeight: 0,
                overflow: 'hidden',
                opacity: height > 0 ? 1 : 0,
                transitionProperty: showTransition ? transition : 'none',
                transitionDuration: '0.3s'
            },
            ref: ref
        }, children) : null;
    };
    var $a8d8f80d50d9d1e4$export$2e2bcd8739ae039 = $a8d8f80d50d9d1e4$export$6118ed0013927eb2;
});
parcelRegister("adeuB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$749bb6d43c83bff0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1vqi;
    const $749bb6d43c83bff0$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            fireEvent('ui.summary.viewed', {
                fromCache: fromCache
            });
            if (fromCache) fireEvent('track.aiInteraction.initiated', {
                aiFeatureName: 'Smart Links Summary',
                proactiveAIGenerated: 1,
                userGeneratedAI: 0
            });
        }, [
            fireEvent,
            fromCache
        ]);
        return null;
    };
    var $749bb6d43c83bff0$export$2e2bcd8739ae039 = $749bb6d43c83bff0$var$AIEventSummaryViewed;
});
parcelRegister("85ffk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5cb2203e6787402$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $obtkX;
    const $d5cb2203e6787402$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("obtkX")).default), {
            ...props,
            testId: testId
        });
    };
    var $d5cb2203e6787402$export$2e2bcd8739ae039 = $d5cb2203e6787402$var$AIFooterBlock;
});
parcelRegister("obtkX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6b56bbc6d143050$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $eqoQu;
    var $dghu0;
    var $kBKwT;
    const $f6b56bbc6d143050$var$AIFooterBlockResolvedView = (props)=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).InternalActionName).AISummaryAction];
        const { testId: testId } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...props,
            testId: `${testId}-resolved-view`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).Provider), {
            testId: `${testId}-provider`
        }), actionData ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kBKwT")).AIFooterMetadata), {
            ...actionData,
            testId: `${testId}-ai-metadata`
        }) : null);
    };
    var $f6b56bbc6d143050$export$2e2bcd8739ae039 = $f6b56bbc6d143050$var$AIFooterBlockResolvedView;
});
parcelRegister("kBKwT", function(module, exports) {
    $parcel$export(module.exports, "AIFooterMetadata", ()=>$84dc366e320e5880$export$175228cc2c92b3b6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $gKZoD;
    var $jps85;
    var $dC5iT;
    var $f5TWP;
    var $3bDjY;
    var $7zaVw;
    var $1MeuC;
    var $8z1HA;
    var $c8Sqt;
    const $84dc366e320e5880$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("1MeuC")).default));
        const { state: { status: status } } = (0, (0, parcelRequire("1MeuC")).default)(url);
        if (status !== 'done') return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100",
            testId: testId,
            alignInline: "end",
            grow: "fill"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).ai_summarized_info_short),
            position: "bottom"
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), tooltipProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8Sqt")).InfoIcon), {
                label: "Information",
                size: "small",
                primaryColor: "var(--ds-icon-subtle, #626F86)"
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jps85"))))), {
            label: "AI",
            LEGACY_size: "small",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("8z1HA")).default),
            color: "var(--ds-icon-subtle, #626F86)"
        }));
    };
});
parcelRegister("c8Sqt", function(module, exports) {
    $parcel$export(module.exports, "InfoIcon", ()=>$a035773c38c242b5$export$2957fc44b3d2481);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $a035773c38c242b5$var$CustomGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
            fill: "currentColor"
        }));
    const $a035773c38c242b5$export$2957fc44b3d2481 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            ...props,
            glyph: $a035773c38c242b5$var$CustomGlyph
        });
});
parcelRegister("fh9qw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b695424587865b74$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKZoD;
    var $8CUq3;
    var $8dVIb;
    var $Nh1XU;
    var $jRHKj;
    var $fpDmE;
    var $s2ak7;
    function $b695424587865b74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b695424587865b74$var$ignoreContainerPaddingStyles = {
        name: "19m4cma",
        styles: "display:flex;flex-direction:column;box-sizing:border-box;flex-grow:1;width:100%;margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1)"
    };
    const $b695424587865b74$var$DEFAULT_SORT_ORDER = [
        'PreviewAction',
        'CopyLinkAction',
        'AISummaryAction'
    ];
    const $b695424587865b74$var$sort = (a, b)=>{
        let idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(a);
        let idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(b);
        if (idxA === -1) idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
        if (idxB === -1) idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
        return idxA - idxB;
    };
    const $b695424587865b74$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("s2ak7")).ActionFooter));
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const ui = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiOptionContext)();
        const [message, setMessage] = (0, $5uXOq.useState)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
            setIsLoading(isLoading);
        }, [
            setIsLoading
        ]);
        const padding = !ui?.hidePadding ? (0, (0, parcelRequire("fpDmE")).getPrimitivesPaddingSpaceBySize)(ui?.size || (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium) : undefined;
        const onClick = (0, $5uXOq.useCallback)((name)=>{
            setMessage(undefined);
            onClickCallback?.(name);
        }, [
            onClickCallback
        ]);
        const onError = (0, $5uXOq.useCallback)((error)=>{
            setMessage(error);
        }, []);
        const actions = (0, $5uXOq.useMemo)(()=>{
            if (!context?.actions) return;
            const arr = Object.keys(context.actions);
            arr.sort($b695424587865b74$var$sort);
            return arr.map((name)=>{
                const Action = name in (0, parcelRequire("jRHKj")) ? (0, parcelRequire("jRHKj"))[name] : undefined;
                return Action ? (0, (0, parcelRequire("f8Sb3")).jsx)(Action, {
                    as: "stack-item",
                    spaceInline: spaceInline,
                    key: name,
                    onClick: ()=>onClick(name),
                    onError: onError,
                    onLoadingChange: onLoadingChange,
                    size: size,
                    xcss: (0, (0, parcelRequire("8CUq3")).xcss)({
                        paddingInline: padding
                    }),
                    hideTooltip: isLoading
                }) : null;
            });
        }, [
            context?.actions,
            onClick,
            onError,
            padding,
            size,
            spaceInline,
            isLoading,
            onLoadingChange
        ]);
        return actions ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b695424587865b74$var$ignoreContainerPaddingStyles,
            ref: blockRef,
            "data-testid": testId
        }, actions, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("s2ak7")).ActionFooter), {
            message: message,
            paddingInline: padding,
            testId: testId
        })) : null;
    };
    var $b695424587865b74$export$2e2bcd8739ae039 = $b695424587865b74$var$ActionBlock;
});
parcelRegister("s2ak7", function(module, exports) {
    $parcel$export(module.exports, "ActionFooter", ()=>$e384e6334b5a98a7$export$2d2b754ac238f9aa);
    var $5uXOq = parcelRequire("5uXOq");
    var $059q9;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $aBTst;
    const $e384e6334b5a98a7$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        borderRadius: 'border.radius',
        margin: 'space.100',
        marginBottom: 'space.0',
        lineHeight: '20px',
        padding: 'space.075',
        paddingInline: 'space.100',
        width: '100%',
        ':empty': {
            display: 'none'
        }
    });
    const $e384e6334b5a98a7$var$errorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.danger'
    });
    const $e384e6334b5a98a7$var$errorContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineStart: 'space.025'
    });
    const $e384e6334b5a98a7$var$titleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtle',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '16px'
    });
    const $e384e6334b5a98a7$var$getIcon = (appearance)=>{
        switch(appearance){
            case 'error':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "compact",
                    label: "Error",
                    LEGACY_size: "small",
                    testId: "action-error-icon",
                    LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
                });
            default:
                return null;
        }
    };
    const $e384e6334b5a98a7$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
        if (!message) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: `${testId}-footer`,
            xcss: [
                $e384e6334b5a98a7$var$containerStyles,
                message.appearance === 'error' && $e384e6334b5a98a7$var$errorStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aBTst")).default), {
            isFadeIn: true,
            show: true,
            showTransition: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "start",
            grow: "fill",
            space: "space.075",
            xcss: $e384e6334b5a98a7$var$errorContentStyles
        }, message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e384e6334b5a98a7$var$titleStyles
        }, message.title))));
    };
});
parcelRegister("059q9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));
    var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
    function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>$00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
        }, props));
    $00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;
});
parcelRegister("hAZqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ccf572dfbabebdf7$var$_UNSAFE_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>$ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
    var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;
});
parcelRegister("jwrXN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93868de8e0c8126a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $hHEfn;
    const $93868de8e0c8126a$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
    const $93868de8e0c8126a$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $93868de8e0c8126a$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
        const [canOpen, setCanOpen] = (0, $5uXOq.useState)(true);
        const mouseStopTimer = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
            };
        }, []);
        const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        }, []);
        const onMouseMove = (0, $5uXOq.useCallback)((e)=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
            const action = e.target.closest('.actions-button-group') || e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
            const canOpenOnElement = isAuthTooltip && !action || isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, (0, parcelRequire("8dVIb")).ElementName).Title}"])`);
            mouseStopTimer.current = setTimeout(()=>{
                if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
            }, delay);
        }, [
            isAuthTooltip,
            isHoverPreview,
            canOpen,
            delay
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hHEfn")).HoverCard), {
            allowEventPropagation: true,
            canOpen: canOpen,
            closeOnChildClick: true,
            actionOptions: actionOptions,
            url: url,
            hoverPreviewOptions: hoverPreviewOptions
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`
        }, children));
    };
    var $93868de8e0c8126a$export$2e2bcd8739ae039 = $93868de8e0c8126a$var$HoverCardControl;
});
parcelRegister("4mRkk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22aaf352da1fa338$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $4URMI;
    function $22aaf352da1fa338$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $22aaf352da1fa338$var$styles = {
        name: "1mlo8gi",
        styles: "top:0;right:0;bottom:0;left:0;overflow:hidden;text-indent:100%;white-space:nowrap;a&.layered-link{position:absolute;z-index:0;}&:hover ~ *{.actions-button-group{opacity:1;}}"
    };
    const $22aaf352da1fa338$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
        const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("a", {
            className: "layered-link",
            css: $22aaf352da1fa338$var$styles,
            "data-testid": `${testId}-layered-link`,
            href: url,
            onClick: onClick,
            onMouseDown: onMouseDown,
            target: target,
            tabIndex: -1
        }, text);
    };
    var $22aaf352da1fa338$export$2e2bcd8739ae039 = $22aaf352da1fa338$var$LayeredLink;
});
parcelRegister("1Vuck", function(module, exports) {
    $parcel$export(module.exports, "getContextByStatus", ()=>$567a4b851e4bc65e$export$e68aec76e359e401);
    $parcel$export(module.exports, "getRetryOptions", ()=>$567a4b851e4bc65e$export$f3d3482baaff4bf6);
    var $f24gj;
    var $8dVIb;
    var $8PVtF;
    var $2zcFi;
    var $jELGn;
    var $dybmx;
    var $jq5Nf;
    var $7zaVw;
    var $kxcRq;
    var $aOsut;
    const $567a4b851e4bc65e$export$e68aec76e359e401 = (params)=>{
        const { response: response, status: status, url: url } = params ?? {};
        switch(status){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolving:
                return {
                    title: url,
                    url: url
                };
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved:
                return (0, (0, parcelRequire("2zcFi")).default)(params);
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Unauthorized:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Forbidden:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).NotFound:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Errored:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback:
            default:
                const preview = (0, (0, parcelRequire("jELGn")).default)(response?.data);
                const linkIcon = (0, (0, parcelRequire("dybmx")).extractErrorIcon)(response, status);
                const provider = (0, (0, parcelRequire("jq5Nf")).default)(response?.data);
                return {
                    linkIcon: linkIcon,
                    title: url,
                    url: url,
                    provider: provider,
                    preview: preview
                };
        }
    };
    const $567a4b851e4bc65e$var$getForbiddenMessageKey = (meta)=>{
        const accessType = meta?.requestAccess?.accessType;
        switch(accessType){
            case 'DIRECT_ACCESS':
                return 'join_to_view';
            case 'REQUEST_ACCESS':
                return 'request_access_to_view';
            case 'PENDING_REQUEST_EXISTS':
                return 'pending_request';
            case 'FORBIDDEN':
                return 'forbidden_access';
            case 'DENIED_REQUEST_EXISTS':
                return 'request_denied';
            default:
                return 'restricted_link';
        }
    };
    const $567a4b851e4bc65e$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
        const data = response && response.data || (0, (0, parcelRequire("aOsut")).getEmptyJsonLd)();
        const provider = (0, (0, parcelRequire("f24gj")).extractProvider)(data);
        const context = provider?.text;
        const values = context ? {
            context: context
        } : undefined;
        switch(status){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Forbidden:
                const meta = response?.meta ?? (0, (0, parcelRequire("aOsut")).getForbiddenJsonLd)().meta;
                const access = (0, (0, parcelRequire("8PVtF")).extractRequestAccessContextImproved)({
                    jsonLd: meta,
                    url: url,
                    product: context ?? ''
                });
                const messageKey = $567a4b851e4bc65e$var$getForbiddenMessageKey(meta);
                const descriptor = (0, (0, parcelRequire("7zaVw")).messages)[messageKey];
                const retry = onAuthorize || access?.action?.promise;
                const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, (0, parcelRequire("kxcRq")).handleOnClick)(retry) : undefined;
                return {
                    descriptor: descriptor,
                    onClick: onClick,
                    values: values
                };
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Unauthorized:
                return onAuthorize ? {
                    descriptor: (0, (0, parcelRequire("7zaVw")).messages).connect_link_account_card_name,
                    onClick: (0, (0, parcelRequire("kxcRq")).handleOnClick)(onAuthorize),
                    values: values
                } : undefined;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).NotFound:
                return {
                    descriptor: (0, (0, parcelRequire("7zaVw")).messages).cannot_find_link
                };
        }
    };
});
parcelRegister("kFJz4", function(module, exports) {
    $parcel$export(module.exports, "titleBlockStyles", ()=>$ccc0d6a8fbe6fbdd$export$38125fa6916f5dab);
    $parcel$export(module.exports, "mainTextStyles", ()=>$ccc0d6a8fbe6fbdd$export$a8a26925e3db0ef6);
    $parcel$export(module.exports, "connectButtonStyles", ()=>$ccc0d6a8fbe6fbdd$export$e63cb455d3692ef0);
    var $f8Sb3;
    function $ccc0d6a8fbe6fbdd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ccc0d6a8fbe6fbdd$var$titleFontWeight = '600';
    const $ccc0d6a8fbe6fbdd$export$38125fa6916f5dab = (0, (0, parcelRequire("f8Sb3")).css)({
        justifyContent: 'center',
        fontWeight: $ccc0d6a8fbe6fbdd$var$titleFontWeight,
        marginTop: "var(--ds-space-100, 8px)"
    });
    const $ccc0d6a8fbe6fbdd$export$a8a26925e3db0ef6 = {
        name: "9ceufl",
        styles: "display:inline;justify-content:center;margin-top:var(--ds-space-0, 0px);font-size:0.75rem;text-align:center"
    };
    const $ccc0d6a8fbe6fbdd$export$e63cb455d3692ef0 = {
        name: "198gd5p",
        styles: "justify-content:center;margin-top:var(--ds-space-100, 8px)"
    };
});
parcelRegister("6klQO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$338ebad02f36b2c8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $fgpl1;
    var $9fYWd;
    var $fh9qw;
    var $85ffk;
    var $1qDIM;
    var $gg6Qm;
    var $1JaZ4;
    var $buvhv;
    var $8RJLv;
    var $k9g4I;
    var $5tPHF;
    const $338ebad02f36b2c8$var$HoverCardResolvedView = ({ analytics: analytics, cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps })=>{
        const canBeDatasource = (0, (0, parcelRequire("fgpl1")).getCanBeDatasource)(cardState.details);
        (0, $5uXOq.useEffect)(()=>{
            analytics.ui.renderSuccessEvent({
                display: (0, (0, parcelRequire("8dVIb")).CardDisplay).HoverCardPreview,
                status: cardState.status,
                canBeDatasource: canBeDatasource
            });
        }, [
            analytics.ui,
            cardState.status,
            canBeDatasource
        ]);
        const data = cardState.details?.data;
        const { primary: primary, secondary: secondary } = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("8RJLv")).getMetadata)(extensionKey, data);
        }, [
            data,
            extensionKey
        ]);
        const snippetHeight = (0, ($parcel$interopDefault($5uXOq))).useRef(0);
        const snippetBlockRef = (0, $5uXOq.useRef)(null);
        const onSnippetRender = (0, $5uXOq.useCallback)(()=>{
            snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
        }, []);
        const imagePreview = (0, (0, parcelRequire("k9g4I")).default)({
            data: data,
            fallbackElementHeight: snippetHeight.current
        });
        const snippet = imagePreview ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1JaZ4")).default), {
            status: (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved
        });
        const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fYWd")).default), flexibleCardProps, imagePreview, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("buvhv")).default), {
            ...titleBlockProps,
            metadataPosition: (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Top
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gg6Qm")).default), {
            primary: primary,
            secondary: secondary,
            overrideCss: (0, (0, parcelRequire("5tPHF")).metadataBlockCss),
            maxLines: 1,
            size: (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium
        }), isAISummaryEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qDIM")).default), {
            aiSummaryMinHeight: aiSummaryMinHeight,
            placeholder: snippet,
            status: (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved
        }) : snippet, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1JaZ4")).default), {
            testId: "hidden-snippet",
            onRender: onSnippetRender,
            blockRef: snippetBlockRef,
            overrideCss: (0, (0, parcelRequire("5tPHF")).hiddenSnippetStyles)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fh9qw")).default), {
            onClick: onActionClick,
            spaceInline: "space.100"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("85ffk")).default), null));
    };
    var $338ebad02f36b2c8$export$2e2bcd8739ae039 = $338ebad02f36b2c8$var$HoverCardResolvedView;
});
parcelRegister("k9g4I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb0493145b01898e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jELGn;
    var $hYQw7;
    var $hZqF4;
    const $eb0493145b01898e$var$ImagePreview = ({ data: data, fallbackElementHeight: fallbackElementHeight })=>{
        const transitionStarted = (0, $5uXOq.useRef)(false);
        const previewBlockRef = (0, $5uXOq.useRef)(null);
        const [showPreview, setShowPreview] = (0, $5uXOq.useState)(true);
        const [previewCss, setPreviewCss] = (0, $5uXOq.useState)();
        const onPreviewRender = (0, $5uXOq.useCallback)(()=>{
            previewBlockRef.current && setPreviewCss((0, (0, parcelRequire("hZqF4")).getPreviewBlockStyles)(previewBlockRef.current?.getBoundingClientRect().height));
        }, []);
        const onPreviewError = (0, $5uXOq.useCallback)(()=>{
            if (transitionStarted.current === false) {
                setPreviewCss((0, (0, parcelRequire("hZqF4")).getTransitionStyles)(fallbackElementHeight));
                transitionStarted.current = true;
            }
        }, [
            fallbackElementHeight
        ]);
        const onPreviewTransitionEnd = (0, $5uXOq.useCallback)(()=>{
            setShowPreview(false);
        }, []);
        return showPreview && data && (0, (0, parcelRequire("jELGn")).default)(data) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hYQw7")).default), {
            onError: onPreviewError,
            ignoreContainerPadding: true,
            overrideCss: previewCss,
            onTransitionEnd: onPreviewTransitionEnd,
            blockRef: previewBlockRef,
            onRender: onPreviewRender
        }) : null;
    };
    var $eb0493145b01898e$export$2e2bcd8739ae039 = $eb0493145b01898e$var$ImagePreview;
});
parcelRegister("5tPHF", function(module, exports) {
    $parcel$export(module.exports, "metadataBlockCss", ()=>$2a96dc4f59e7238f$export$6d2a8e6ec8eaf792);
    $parcel$export(module.exports, "hiddenSnippetStyles", ()=>$2a96dc4f59e7238f$export$a0cfecf316f11fd2);
    var $f8Sb3;
    var $hZqF4;
    function $2a96dc4f59e7238f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2a96dc4f59e7238f$var$elementGap = '0.5rem';
    const $2a96dc4f59e7238f$export$6d2a8e6ec8eaf792 = (0, (0, parcelRequire("f8Sb3")).css)("gap:0px;[data-smart-element-group]:nth-of-type(1){flex-grow:7;", (0, (0, parcelRequire("hZqF4")).separatorCss), ">span{margin-right:", $2a96dc4f59e7238f$var$elementGap, ";}}[data-smart-element-group]:nth-of-type(2){flex-grow:3;>span{margin-left:", $2a96dc4f59e7238f$var$elementGap, ";}}[data-smart-element-group]{line-height:1rem;}");
    const $2a96dc4f59e7238f$export$1ede44d22c218cc4 = {
        name: "eqx0xi",
        styles: "height:1.5rem"
    };
    const $2a96dc4f59e7238f$export$a0cfecf316f11fd2 = {
        name: "546l7a",
        styles: "visibility:hidden;position:absolute"
    };
});
parcelRegister("g3aqq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9278993db7419c13$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $dghu0;
    var $bubxq;
    var $gU02S;
    var $aWyvu;
    var $hZqF4;
    var $4xU7G;
    const $9278993db7419c13$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
        const testId = 'hover-card-loading-view';
        const lineHeightRem = 1.25;
        const skeletonWidth = (0, (0, parcelRequire("hZqF4")).CARD_WIDTH_REM) - 2;
        const { size: size, actions: actions } = titleBlockProps;
        const actionGroup = actions?.length && actions?.length > 0 && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bubxq")).default), {
            items: actions,
            visibleButtonsNum: 2
        });
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("4xU7G")).loadingViewContainer),
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("4xU7G")).skeletonContainer)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dghu0")).default), {
            ...titleBlockProps,
            overrideCss: (0, (0, parcelRequire("4xU7G")).titleBlockStyles),
            testId: `${testId}-title-block`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aWyvu")).default), {
            render: ()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), null),
            size: size
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("4xU7G")).getTitleStyles)(lineHeightRem),
            "data-testid": `${testId}-title`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), {
            height: lineHeightRem
        })), actionGroup), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), {
            width: skeletonWidth,
            height: lineHeightRem
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), {
            width: skeletonWidth,
            height: lineHeightRem * 3
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), {
            width: skeletonWidth,
            height: lineHeightRem
        }))));
    };
    var $9278993db7419c13$export$2e2bcd8739ae039 = $9278993db7419c13$var$HoverCardLoadingView;
});
parcelRegister("4xU7G", function(module, exports) {
    $parcel$export(module.exports, "loadingViewContainer", ()=>$79b7a60b47823f5e$export$a470e5777446b28);
    $parcel$export(module.exports, "skeletonContainer", ()=>$79b7a60b47823f5e$export$e39e8873928166f5);
    $parcel$export(module.exports, "getTitleStyles", ()=>$79b7a60b47823f5e$export$83146cf7d1bec659);
    $parcel$export(module.exports, "titleBlockStyles", ()=>$79b7a60b47823f5e$export$38125fa6916f5dab);
    var $f8Sb3;
    function $79b7a60b47823f5e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $79b7a60b47823f5e$export$a470e5777446b28 = {
        name: "vl4r61",
        styles: "display:flex;flex-direction:column;padding:var(--ds-space-200, 1rem)"
    };
    const $79b7a60b47823f5e$export$e39e8873928166f5 = {
        name: "m407pt",
        styles: "display:flex;flex-direction:column;gap:0.625rem;align-items:center"
    };
    const $79b7a60b47823f5e$export$83146cf7d1bec659 = (height)=>{
        return (0, (0, parcelRequire("f8Sb3")).css)({
            flex: '1 0 auto',
            height: `${height}rem`,
            span: {
                width: '100%'
            }
        });
    };
    const $79b7a60b47823f5e$export$38125fa6916f5dab = {
        name: "168etio",
        styles: "width:100%;gap:var(--ds-space-100, 0.5rem)"
    };
});
parcelRegister("f6jZ5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7ebd359d5a8e698$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $f24gj;
    var $8dVIb;
    var $7zaVw;
    var $3CATS;
    var $fgpl1;
    var $3PAn6;
    var $9fYWd;
    var $dghu0;
    var $bubxq;
    var $eqoQu;
    var $6ik63;
    const $e7ebd359d5a8e698$var$HoverCardUnauthorisedView = ({ analytics: analytics, extensionKey: extensionKey, id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
        const { cardState: cardState } = flexibleCardProps;
        const data = cardState.details?.data;
        const providerName = (0, (0, parcelRequire("f24gj")).extractProvider)(data)?.text;
        const isProductIntegrationSupported = (0, (0, parcelRequire("fgpl1")).hasAuthScopeOverrides)(cardState.details);
        const { authorize: authorize } = (0, (0, parcelRequire("3CATS")).useSmartCardActions)(id, url, analytics);
        const handleAuthorize = (0, $5uXOq.useCallback)(()=>{
            if (authorize) {
                analytics.track.appAccountAuthStarted({
                    extensionKey: extensionKey
                });
                authorize((0, (0, parcelRequire("8dVIb")).CardDisplay).HoverCardPreview);
            }
        }, [
            authorize,
            extensionKey,
            analytics.track
        ]);
        const actions = (0, $5uXOq.useMemo)(()=>[
                {
                    name: (0, (0, parcelRequire("8dVIb")).ActionName).CustomAction,
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                        ...(0, (0, parcelRequire("7zaVw")).messages).connect_unauthorised_account_action,
                        values: {
                            context: providerName
                        }
                    }),
                    onClick: handleAuthorize
                }
            ], [
            handleAuthorize,
            providerName
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fYWd")).default), {
            ...flexibleCardProps,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            overrideCss: (0, (0, parcelRequire("6ik63")).titleBlockStyles),
            testId: `${testId}-title`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).LinkIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("7zaVw")).messages).connect_link_account_card_name,
            values: {
                context: providerName
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            overrideCss: (0, (0, parcelRequire("6ik63")).mainTextStyles),
            testId: `${testId}-content`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3PAn6")).default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            analytics: analytics
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            overrideCss: (0, (0, parcelRequire("6ik63")).connectButtonStyles),
            testId: `${testId}-button`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bubxq")).default), {
            items: actions,
            appearance: "primary"
        })));
    };
    var $e7ebd359d5a8e698$export$2e2bcd8739ae039 = $e7ebd359d5a8e698$var$HoverCardUnauthorisedView;
});
parcelRegister("3PAn6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8897e3cb423b2de$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8dVIb;
    var $7zaVw;
    const $a8897e3cb423b2de$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content', analytics: analytics })=>{
        const handleLearnMoreClick = (0, $5uXOq.useCallback)(()=>{
            analytics?.ui.learnMoreClickedEvent();
        }, [
            analytics?.ui
        ]);
        const learnMoreMessage = isProductIntegrationSupported ? (0, (0, parcelRequire("7zaVw")).messages).learn_more_about_connecting_account : (0, (0, parcelRequire("7zaVw")).messages).learn_more_about_smart_links;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, providerName ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("7zaVw")).messages).connect_unauthorised_account_description,
            values: {
                context: providerName
            }
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).connect_unauthorised_account_description_no_provider), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: isProductIntegrationSupported ? (0, (0, parcelRequire("8dVIb")).CONTENT_URL_3P_ACCOUNT_AUTH) : (0, (0, parcelRequire("8dVIb")).CONTENT_URL_SECURITY_AND_PERMISSIONS),
            target: "_blank",
            "data-testid": `${testId}-learn-more`,
            onClick: handleLearnMoreClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), learnMoreMessage)));
    };
    var $a8897e3cb423b2de$export$2e2bcd8739ae039 = $a8897e3cb423b2de$var$UnauthorisedViewContent;
});
parcelRegister("6ik63", function(module, exports) {
    $parcel$export(module.exports, "connectButtonStyles", ()=>$6b1fcda1ff8b0c8f$export$e63cb455d3692ef0);
    $parcel$export(module.exports, "titleBlockStyles", ()=>$6b1fcda1ff8b0c8f$export$38125fa6916f5dab);
    $parcel$export(module.exports, "mainTextStyles", ()=>$6b1fcda1ff8b0c8f$export$a8a26925e3db0ef6);
    var $f8Sb3;
    const $6b1fcda1ff8b0c8f$var$blockGap = '0.5rem';
    const $6b1fcda1ff8b0c8f$var$iconGap = '0.5rem';
    const $6b1fcda1ff8b0c8f$var$titleFontWeight = '500';
    const $6b1fcda1ff8b0c8f$export$e63cb455d3692ef0 = (0, (0, parcelRequire("f8Sb3")).css)({
        justifyContent: 'flex-end',
        marginTop: $6b1fcda1ff8b0c8f$var$blockGap
    });
    const $6b1fcda1ff8b0c8f$export$38125fa6916f5dab = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${$6b1fcda1ff8b0c8f$var$blockGap} ${$6b1fcda1ff8b0c8f$var$iconGap}`,
        a: {
            fontWeight: $6b1fcda1ff8b0c8f$var$titleFontWeight
        }
    });
    const $6b1fcda1ff8b0c8f$export$a8a26925e3db0ef6 = (0, (0, parcelRequire("f8Sb3")).css)({
        marginTop: $6b1fcda1ff8b0c8f$var$blockGap,
        fontSize: '0.75rem'
    });
});
parcelRegister("6yf6t", function(module, exports) {
    $parcel$export(module.exports, "mapStateToBgColor", ()=>$6a435c3af325b8dc$export$931dac3fa53640b1);
    $parcel$export(module.exports, "mapStateToColor", ()=>$6a435c3af325b8dc$export$163d1ee1b3b2aead);
    $parcel$export(module.exports, "mapScoreToBgColor", ()=>$6a435c3af325b8dc$export$525ec0d5be9572a4);
    $parcel$export(module.exports, "extractStatusLabelWithoutScore", ()=>$6a435c3af325b8dc$export$88bbcb3741dee92d);
    const $6a435c3af325b8dc$export$931dac3fa53640b1 = (state)=>{
        switch(state){
            case 'off_track':
                return `var(--ds-background-accent-red-subtlest, ${(0, $829f609a65d26a98$exports).R50})`;
            case 'at_risk':
                return `var(--ds-background-accent-yellow-subtlest, ${(0, $829f609a65d26a98$exports).Y50})`;
            case 'on_track':
                return `var(--ds-background-accent-green-subtlest, ${(0, $829f609a65d26a98$exports).G50})`;
            case 'archived':
            case 'cancelled':
            case 'done':
            case 'paused':
            case 'pending':
            default:
                return `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$exports).N20})`;
        }
    };
    const $6a435c3af325b8dc$export$163d1ee1b3b2aead = (state)=>{
        switch(state){
            case 'off_track':
                return `var(--ds-text-accent-red, ${(0, $829f609a65d26a98$exports).R500})`;
            case 'at_risk':
                return `var(--ds-text-accent-orange, ${(0, $829f609a65d26a98$exports).Y500})`;
            case 'on_track':
                return `var(--ds-text-accent-green, ${(0, $829f609a65d26a98$exports).G500})`;
            case 'archived':
            case 'cancelled':
            case 'done':
            case 'paused':
            case 'pending':
            default:
                return `var(--ds-text-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`;
        }
    };
    const $6a435c3af325b8dc$export$525ec0d5be9572a4 = (score)=>{
        if (score < 0.4) return `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$exports).R500})`;
        if (score < 0.7) return `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y500})`;
        return `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$exports).G500})`;
    };
    const $6a435c3af325b8dc$export$88bbcb3741dee92d = (fullLabel)=>fullLabel.split(' - ')[0];
});
parcelRegister("2Ywmz", function(module, exports) {
    $parcel$export(module.exports, "GoalIcon", ()=>$7be6a95607230c54$export$134cbcd70c6693b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $6yf6t;
    var $4UrMe;
    const $7be6a95607230c54$var$GoalGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fill: "currentColor",
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
            fillRule: "evenodd"
        })));
    const $7be6a95607230c54$export$134cbcd70c6693b8 = ({ state: state, ariaLabel: ariaLabel })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $7be6a95607230c54$var$iconContainerStyles,
            style: {
                backgroundColor: (0, (0, parcelRequire("6yf6t")).mapStateToBgColor)(state)
            },
            "aria-label": ariaLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $7be6a95607230c54$var$GoalGlyph,
            label: formatMessage((0, (0, parcelRequire("4UrMe")).default).goalIconLabel),
            primaryColor: (0, (0, parcelRequire("6yf6t")).mapStateToColor)(state)
        }));
    };
    const $7be6a95607230c54$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        minWidth: '24px',
        height: '24px',
        borderRadius: 'border.radius',
        marginRight: 'space.025'
    });
});
parcelRegister("4UrMe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ec31bd513378ade$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2ec31bd513378ade$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        goalIconLabel: {
            "id": "software-goals.goal.icon.goal-icon-label",
            "defaultMessage": "Goal"
        }
    });
});
parcelRegister("3uePO", function(module, exports) {
    $parcel$export(module.exports, "GoalTracker", ()=>$ec22661ff8271891$export$c0fdf469f92e8578);
    var $5uXOq = parcelRequire("5uXOq");
    var $6yf6t;
    var $aabh6;
    var $e0NSW;
    const $ec22661ff8271891$export$c0fdf469f92e8578 = ({ value: value, label: label, score: score })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0NSW")).Tracker), {
            backgroundColor: (0, (0, parcelRequire("6yf6t")).mapStateToBgColor)(value),
            color: (0, (0, parcelRequire("6yf6t")).mapStateToColor)(value)
        }, (0, (0, parcelRequire("6yf6t")).extractStatusLabelWithoutScore)(label), score !== undefined && score !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aabh6")).Score), {
            score: score
        }));
});
parcelRegister("aabh6", function(module, exports) {
    $parcel$export(module.exports, "Score", ()=>$08dbd54fe256bc26$export$6735cf84ecd2736);
    var $5uXOq = parcelRequire("5uXOq");
    var $6yf6t;
    var $3b4jf;
    const $08dbd54fe256bc26$export$6735cf84ecd2736 = ({ score: score })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3b4jf")).ScoreContainer), {
            backgroundColor: (0, (0, parcelRequire("6yf6t")).mapScoreToBgColor)(score)
        }, score);
});
parcelRegister("3b4jf", function(module, exports) {
    $parcel$export(module.exports, "ScoreContainer", ()=>$c781656d37adaa64$export$32466e20de52fc97);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $c781656d37adaa64$export$32466e20de52fc97 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1hphqkz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _bfhk3qkl _syaz15cr _2rko1l7b _18u01b66 _1yt4otz2 _4t3i7vkz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("e0NSW", function(module, exports) {
    $parcel$export(module.exports, "Tracker", ()=>$5a7c474ebf7da8e1$export$254d9747e34ddc90);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $5a7c474ebf7da8e1$export$254d9747e34ddc90 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1hphqkz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor),
                "--_xexnhp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk3qkl _2rko1l7b _1yt41b66 _11c81vlj _k48pmoej _syaz1cj8 _1p1dangw _3fcw1q9c _1e0c1ule _4t3i7vkz _vwz47vkz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jdUkc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b2e3d161f7529ca$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7b2e3d161f7529ca$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chooseGoal: {
            "id": "portfolio-3-portfolio.common.goal.goal-cell-select.choose-goal",
            "defaultMessage": "Choose a Goal"
        },
        noGoals: {
            "id": "portfolio-3-portfolio.common.goal.goal-cell-select.no-goals",
            "defaultMessage": "There are no goals in this plan"
        },
        noMatch: {
            "id": "portfolio-3-portfolio.common.goal.goal-cell-select.no-match",
            "defaultMessage": "No results match your search"
        }
    });
});
parcelRegister("8w6iz", function(module, exports) {
    $parcel$export(module.exports, "selectStyles", ()=>$7ae52d6126b32928$export$70a9ea0b017c448a);
    const $7ae52d6126b32928$export$70a9ea0b017c448a = {
        container: (styles, { selectProps: { menuIsOpen: menuIsOpen } })=>({
                ...styles,
                ...menuIsOpen ? {
                    zIndex: 1
                } : {}
            }),
        control: (styles, { hasValue: hasValue, selectProps: { menuIsOpen: menuIsOpen } })=>menuIsOpen ? {
                ...styles
            } : {
                ...styles,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                [':hover']: {
                    ...styles[':hover'],
                    background: 'none',
                    ...hasValue ? {
                        borderColor: 'transparent'
                    } : {}
                }
            },
        valueContainer: (styles)=>({
                ...styles,
                maxHeight: 150,
                overflow: 'auto',
                flex: '1'
            }),
        multiValue: (styles)=>({
                ...styles,
                borderWidth: "var(--ds-border-width, 1px)",
                borderStyle: 'solid',
                borderColor: "var(--ds-border, #091e4221)",
                borderRadius: "var(--ds-border-radius, 3px)",
                backgroundColor: "var(--ds-surface, #FFFFFF)"
            })
    };
});
parcelRegister("6G5lJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a616757968e5cf9$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $6a616757968e5cf9$var$mapDispatchToProps = (dispatch)=>({
            onChange: (issue, goals)=>{
                const newGoals = goals.map((goal)=>({
                        id: goal.goal?.id,
                        key: goal.goal?.key
                    }));
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    goals: newGoals
                }));
            }
        });
    var $6a616757968e5cf9$export$2e2bcd8739ae039 = $6a616757968e5cf9$var$mapDispatchToProps;
});
parcelRegister("gXuyB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8b2fab49dd1af5a$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7bTRh = parcelRequire("7bTRh");
    var $edGLb = parcelRequire("edGLb");
    var $5qBiK = parcelRequire("5qBiK");
    var $c8b2fab49dd1af5a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $edGLb.default), (0, $7bTRh.default))((0, $5qBiK.default));
});
parcelRegister("7bTRh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93f4221bfa71cfe0$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $93f4221bfa71cfe0$var$mapDispatchToProps = (dispatch)=>({
            onChange: (issue, associatedIssuesIds)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    associatedIssues: associatedIssuesIds,
                    associatedIssueIds: associatedIssuesIds
                }));
            }
        });
    var $93f4221bfa71cfe0$export$2e2bcd8739ae039 = $93f4221bfa71cfe0$var$mapDispatchToProps;
});
parcelRegister("edGLb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8091271da9bde9f9$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $bzvH1 = parcelRequire("bzvH1");
    var $3YtPS = parcelRequire("3YtPS");
    const $8091271da9bde9f9$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        associatedIssueIds: (0, $bzvH1.getAssociatedIssueIds),
        isReadOnly: (state)=>(0, $1CGdp.getMode)(state) !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
        isExportMode: $1CGdp.isExportMode
    });
    var $8091271da9bde9f9$export$2e2bcd8739ae039 = $8091271da9bde9f9$var$querySelector;
});
parcelRegister("5qBiK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$071ae126427388da$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $apXzN;
    var $cb04i;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $duPZ8 = parcelRequire("duPZ8");
    var $5Lk1T = parcelRequire("5Lk1T");
    var $ls6Ec = parcelRequire("ls6Ec");
    const $071ae126427388da$var$View = ({ issue: issue, isReadOnly: isReadOnly, isExportMode: isExportMode, onChange: onChange })=>{
        const [associatedIssues] = (0, (0, parcelRequire("apXzN")).useAssociatedIssues)();
        const [isInitialized] = (0, (0, parcelRequire("apXzN")).useAssociatedIssuesInitialized)();
        if ((0, (0, parcelRequire("co1wz")).ff)('polaris.possibility-of-updating-ideas-in-plans')) {
            if (!isInitialized) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cb04i")).CellSkeleton), {
                width: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM
            });
            const showEmpty = !associatedIssues || !issue.associatedIssueIds;
            if (showEmpty) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $duPZ8.IdeasCell), {
                isExportMode: isExportMode,
                isDisabled: isReadOnly,
                isReadOnly: isReadOnly,
                associatedIssues: (0, $5Lk1T.filterOnlyExistedAssociatedIssues)(issue, associatedIssues),
                originalIssues: (0, $5Lk1T.filterOnlyExistedOriginalAssociatedIssues)(issue, associatedIssues),
                issue: issue,
                onChange: onChange
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ls6Ec.default), {
            issue: issue
        });
    };
    var $071ae126427388da$export$2e2bcd8739ae039 = $071ae126427388da$var$View;
});
parcelRegister("duPZ8", function(module, exports) {
    $parcel$export(module.exports, "IdeasCell", ()=>$ccc59e09d418fe87$export$751de96031028294);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $3FQWJ = parcelRequire("3FQWJ");
    var $9YntY = parcelRequire("9YntY");
    var $3DZON = parcelRequire("3DZON");
    var $2OhTK = parcelRequire("2OhTK");
    const $ccc59e09d418fe87$var$renderMultipleIdeas = (ideas)=>{
        const names = ideas.map((el)=>el.summary);
        const values = (0, $2OhTK.calculateFlexShrink)(names);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, ideas.map((associatedIssue, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $9YntY.default), {
                key: associatedIssue.key,
                data: associatedIssue,
                flexShrink: values[index]
            })));
    };
    const $ccc59e09d418fe87$export$751de96031028294 = ({ associatedIssues: associatedIssues, isDisabled: isDisabled, isReadOnly: isReadOnly, isExportMode: isExportMode, issue: issue, onChange: onChange, originalIssues: originalIssues })=>{
        const handleChangeIdeas = (changedAssociatedIssues)=>{
            const associatedIssuesUpdate = (0, $2OhTK.getAssociatedIssuesUpdate)(changedAssociatedIssues.map(({ id: id })=>id), issue.associatedIssueIds || [], associatedIssues.map(({ id: id })=>id));
            if (!associatedIssuesUpdate) return;
            onChange(issue, associatedIssuesUpdate);
        };
        const isReadonlyMode = isDisabled || isReadOnly || isExportMode;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, isReadonlyMode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), null, $ccc59e09d418fe87$var$renderMultipleIdeas(associatedIssues)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
            attribute: "ideas",
            issue: issue,
            isScrolling: false,
            isCellDirty: ()=>(0, $2OhTK.isCellDirty)(originalIssues, associatedIssues)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3DZON.default), {
            renderMultipleIdeas: $ccc59e09d418fe87$var$renderMultipleIdeas,
            currentAssociatedIssues: associatedIssues,
            onUpdateIdeas: handleChangeIdeas,
            issue: issue
        })));
    };
});
parcelRegister("9YntY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$894aecbdb156b96f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    var $1dJ6S;
    var $jhmo0;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $btzsC;
    const $894aecbdb156b96f$var$IssueCardContent = ({ data: data })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $894aecbdb156b96f$var$ideaContentCardTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $894aecbdb156b96f$var$ideaContentCardAvatar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            src: data.iconUrl,
            size: "xsmall"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            href: `/browse/${data.key}`,
            target: "_blank",
            xcss: $894aecbdb156b96f$var$anchorStyles
        }, data.key)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "div",
            size: "xsmall"
        }, data.summary));
    const $894aecbdb156b96f$var$IdeaIssue = ({ data: data, flexShrink: flexShrink })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $894aecbdb156b96f$var$container,
            style: {
                flexShrink: flexShrink
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($894aecbdb156b96f$var$IssueCardContent, {
                    data: data
                }),
            component: $894aecbdb156b96f$var$TooltipLikeInlineDialog
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                ...tooltipProps,
                xcss: $894aecbdb156b96f$var$contentWrapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $894aecbdb156b96f$var$avatar
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                src: data.iconUrl,
                size: "xsmall"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $894aecbdb156b96f$var$summary
            }, data.summary))));
    var $894aecbdb156b96f$export$2e2bcd8739ae039 = $894aecbdb156b96f$var$IdeaIssue;
    const $894aecbdb156b96f$var$container = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        minWidth: 'size.300',
        height: '100%',
        flexBasis: 'content'
    });
    const $894aecbdb156b96f$var$avatar = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.050',
        flexShrink: 0
    });
    const $894aecbdb156b96f$var$summary = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    });
    const $894aecbdb156b96f$var$contentWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        width: '100%'
    });
    const $894aecbdb156b96f$var$ideaContentCardTitle = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginBottom: 'space.150'
    });
    const $894aecbdb156b96f$var$ideaContentCardAvatar = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.100'
    });
    const $894aecbdb156b96f$var$TooltipLikeInlineDialog = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("btzsC")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhku67f _2rkoglpi _16qsjdvv _vchh18uv _1yt41bs6 _1bsb52fy",
                __cmplp.className
            ])
        });
    });
    const $894aecbdb156b96f$var$anchorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textDecoration: 'none',
        ':hover': {
            textDecoration: 'underline'
        }
    });
});
parcelRegister("3DZON", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92894028338ba3d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $eZJjh;
    var $koVbs;
    var $bChGW;
    var $ixSW4 = parcelRequire("ixSW4");
    var $koeKL;
    var $kJUM9 = parcelRequire("kJUM9");
    var $hRgeK = parcelRequire("hRgeK");
    var $hd6RY = parcelRequire("hd6RY");
    var $ezveQ = parcelRequire("ezveQ");
    const $92894028338ba3d0$var$DEBOUNCE_TIME_MS = 250;
    const $92894028338ba3d0$var$MIN_SELECT_WIDTH = 300;
    const $92894028338ba3d0$var$MultiValueRemove = (props)=>{
        const innerProps = {
            ...props.innerProps,
            'aria-label': `Remove ${props.data?.summary ?? 'idea'}`
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, {
            ...props,
            innerProps: innerProps
        });
    };
    const $92894028338ba3d0$export$15167d5bbfa57eed = ({ FieldSelect: FieldSelect, renderMultipleIdeas: renderMultipleIdeas, onUpdateIdeas: onUpdateIdeas, currentAssociatedIssues: currentAssociatedIssues, issue: issue })=>{
        const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)(currentAssociatedIssues);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isSearchInProgress, setIsSearchInProgress] = (0, $5uXOq.useState)(false);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [allAssociatedIssuesToRender, setAllAssociatedIssuesToRender] = (0, $5uXOq.useState)([]);
        const fetchData = (0, $ezveQ.createFetchAssociatedIssuesForSelectOptions)(cloudId, setIsSearchInProgress, setAllAssociatedIssuesToRender);
        const debounceGetOptions = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($lFKmC)))(fetchData, $92894028338ba3d0$var$DEBOUNCE_TIME_MS)).current;
        (0, $5uXOq.useEffect)(()=>{
            setSelectedOptions(currentAssociatedIssues);
        }, [
            currentAssociatedIssues
        ]);
        const reloadOptions = (0, $5uXOq.useCallback)(()=>{
            setIsSearchInProgress(true);
            debounceGetOptions('');
        }, [
            debounceGetOptions
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            reloadOptions();
        }, [
            reloadOptions
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            onUpdateIdeas(selectedOptions);
        }, [
            onUpdateIdeas,
            selectedOptions
        ]);
        const handleInputChange = (0, $5uXOq.useCallback)((query, { action: action })=>{
            if (action === 'input-change') debounceGetOptions(query);
        }, [
            debounceGetOptions
        ]);
        const onItemChanged = (0, $5uXOq.useCallback)((options)=>{
            const currentSelectedOptions = Array.isArray(options) ? options : [];
            setSelectedOptions(currentSelectedOptions);
            reloadOptions();
        }, [
            reloadOptions
        ]);
        const ControlComponentWrapper = (0, $5uXOq.useCallback)((props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $kJUM9.default), {
                ...props,
                renderMultipleIdeas: ()=>renderMultipleIdeas(selectedOptions)
            }), [
            renderMultipleIdeas,
            selectedOptions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(FieldSelect, {
            isMulti: true,
            isLoading: isSearchInProgress,
            value: selectedOptions,
            options: allAssociatedIssuesToRender,
            formatOptionLabel: (option)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $hd6RY.default), {
                    option: option,
                    key: option?.key
                }),
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            onChange: onItemChanged,
            closeMenuOnSelect: false,
            styles: $92894028338ba3d0$var$selectStyles,
            onInputChange: handleInputChange,
            minSelectWidth: $92894028338ba3d0$var$MIN_SELECT_WIDTH,
            placeholder: formatMessage((0, $hRgeK.default).chooseIdea),
            noOptionsMessage: ()=>formatMessage((0, $hRgeK.default).noIdeas),
            components: {
                Control: ControlComponentWrapper,
                MultiValueRemove: $92894028338ba3d0$var$MultiValueRemove,
                LoadingIndicator: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                        size: "small"
                    })
            },
            getOptionValue: (idea)=>idea.key,
            filterOption: (option)=>option.data.id !== issue.id
        });
    };
    const $92894028338ba3d0$var$selectStyles = {
        container: (styles, { selectProps: { menuIsOpen: menuIsOpen } })=>({
                ...styles,
                ...menuIsOpen ? {
                    zIndex: 1
                } : {}
            }),
        control: (styles, { hasValue: hasValue, selectProps: { menuIsOpen: menuIsOpen } })=>menuIsOpen ? styles : {
                ...styles,
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                ':hover': {
                    ...styles[':hover'],
                    background: 'none',
                    ...hasValue ? {
                        borderColor: 'transparent'
                    } : {}
                }
            },
        valueContainer: (styles)=>({
                ...styles,
                maxHeight: 150,
                overflow: 'auto',
                flex: '1'
            }),
        multiValue: (styles)=>({
                ...styles,
                borderWidth: "var(--ds-border-width, 1px)",
                borderStyle: 'solid',
                borderColor: "var(--ds-border, #091e4221)",
                borderRadius: "var(--ds-border-radius, 3px)",
                backgroundColor: "var(--ds-surface, #FFFFFF)"
            })
    };
    var $92894028338ba3d0$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        FieldSelect: (0, $ixSW4.slots).FieldSelect
    })($92894028338ba3d0$export$15167d5bbfa57eed);
});
parcelRegister("kJUM9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f72114ca11b7a2c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dC5iT;
    var $8CUq3;
    var $bChGW;
    const $9f72114ca11b7a2c$var$ControlComponent = ({ isDisabled: isDisabled, renderMultipleIdeas: renderMultipleIdeas, ...props })=>{
        const { selectProps: { menuIsOpen: menuIsOpen, value: value, onMenuOpen: onMenuOpen } } = props;
        const isDefaultControl = menuIsOpen || (0, ($parcel$interopDefault($gccSB)))(value) && !isDisabled;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Control, {
            ...props,
            isFocused: menuIsOpen,
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isDefaultControl && props.children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $9f72114ca11b7a2c$var$componentContainerStyles,
                isDisabled && $9f72114ca11b7a2c$var$componentsContainerDisabledStyles,
                menuIsOpen && $9f72114ca11b7a2c$var$hiddenContainerStyles
            ],
            role: "button",
            tabIndex: 0,
            onClick: onMenuOpen,
            onKeyDown: (0, ($parcel$interopDefault($8Rkzz)))
        }, renderMultipleIdeas())));
    };
    var $9f72114ca11b7a2c$export$2e2bcd8739ae039 = $9f72114ca11b7a2c$var$ControlComponent;
    const $9f72114ca11b7a2c$var$componentContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexDirection: 'row',
        paddingTop: 'space.0',
        paddingBottom: 'space.0',
        paddingLeft: 'space.100',
        paddingRight: 'space.100',
        cursor: 'pointer',
        width: '100%',
        boxSizing: 'border-box'
    });
    const $9f72114ca11b7a2c$var$componentsContainerDisabledStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'default',
        ':active': {
            outline: 'none'
        },
        ':focus': {
            outline: 'none'
        }
    });
    const $9f72114ca11b7a2c$var$hiddenContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'none'
    });
});
parcelRegister("hRgeK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f6a9104ae48122c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7f6a9104ae48122c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chooseIdea: {
            "id": "portfolio-3-portfolio.common.ideas-cell.ideas-cell-select.choose-idea",
            "defaultMessage": "Link ideas"
        },
        noIdeas: {
            "id": "portfolio-3-portfolio.common.ideas-cell.ideas-cell-select.no-ideas",
            "defaultMessage": "There are no ideas"
        },
        noMatch: {
            "id": "portfolio-3-portfolio.common.ideas-cell.ideas-cell-select.no-match",
            "defaultMessage": "No results match your search"
        }
    });
});
parcelRegister("hd6RY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03933ee06f62ebe1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    const $03933ee06f62ebe1$var$Option = ({ option: option })=>{
        if (!option) return null;
        return $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $03933ee06f62ebe1$var$outerWrapperStyles
        }, $5uXOq.createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start"
        }, $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $03933ee06f62ebe1$var$avatar
        }, $5uXOq.createElement((0, (0, parcelRequire("ujWmd")).default), {
            src: option.iconUrl,
            size: "xsmall"
        })), $5uXOq.createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $03933ee06f62ebe1$var$summary
        }, option.summary)));
    };
    const $03933ee06f62ebe1$var$outerWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline',
        minWidth: '38px'
    });
    const $03933ee06f62ebe1$var$avatar = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.050',
        flexShrink: 0
    });
    const $03933ee06f62ebe1$var$summary = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    });
    var $03933ee06f62ebe1$export$2e2bcd8739ae039 = $03933ee06f62ebe1$var$Option;
});
parcelRegister("ezveQ", function(module, exports) {
    $parcel$export(module.exports, "createFetchAssociatedIssuesForSelectOptions", ()=>$d1570d5467dd567f$export$e8006aed5ce78682);
    var $jcw0u;
    var $3f570;
    var $TTKUQ = parcelRequire("TTKUQ");
    const $d1570d5467dd567f$export$e8006aed5ce78682 = (cloudId, setIsSearchInProgress, setAllAssociatedIssuesToRender)=>async (query)=>{
            try {
                setIsSearchInProgress(true);
                const fetchedIssues = await (0, (0, parcelRequire("3f570")).fetchAssociatedIssuesForSelectOptions)(cloudId, query);
                const currentSelectOptions = Object.keys(fetchedIssues).map((id)=>fetchedIssues[id]);
                setAllAssociatedIssuesToRender(currentSelectOptions);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        id: 'fetchAssociatedIssuesForSelectOptions',
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: false
                });
            } finally{
                setIsSearchInProgress(false);
            }
        };
});
parcelRegister("2OhTK", function(module, exports) {
    $parcel$export(module.exports, "calculateFlexShrink", ()=>$bcaca87dafd55dd5$export$1325c97e2a5509a6);
    $parcel$export(module.exports, "isCellDirty", ()=>$bcaca87dafd55dd5$export$29e4500bdd9d4ac);
    $parcel$export(module.exports, "getAssociatedIssuesUpdate", ()=>$bcaca87dafd55dd5$export$3aec6cdbefa34ac2);
    var $k8IPx = parcelRequire("k8IPx");
    var $ajpes = parcelRequire("ajpes");
    const $bcaca87dafd55dd5$export$1325c97e2a5509a6 = (names)=>{
        const nameLengths = names.map((name)=>name === undefined ? 0 : name.length);
        const shrinkCoefficient = 0.2;
        return nameLengths.map((length)=>Math.pow(length, shrinkCoefficient));
    };
    const $bcaca87dafd55dd5$export$29e4500bdd9d4ac = (originals, associatedIssues)=>{
        if (!originals) return false;
        const associatedIssuesWithPermissionsIds = associatedIssues.map((el)=>el.id);
        return !!((0, ($parcel$interopDefault($k8IPx)))(originals, associatedIssuesWithPermissionsIds).length || (0, ($parcel$interopDefault($k8IPx)))(associatedIssuesWithPermissionsIds, originals).length);
    };
    const $bcaca87dafd55dd5$var$arrayValuesEqual = (updated, associatedIssuesOnIssue)=>{
        if (updated.length !== associatedIssuesOnIssue.length) return false;
        return (0, ($parcel$interopDefault($ajpes)))(updated.sort(), associatedIssuesOnIssue.sort());
    };
    const $bcaca87dafd55dd5$var$extendAssociatedIssueUpdateWithNotLoaded = (changedAssociatedIssues, associatedIssuesOnIssue, loadedAssociatedIssues)=>{
        const associatedIssuesWithoutPermissions = (0, ($parcel$interopDefault($k8IPx)))(associatedIssuesOnIssue, loadedAssociatedIssues);
        return [
            ...changedAssociatedIssues,
            ...associatedIssuesWithoutPermissions
        ];
    };
    const $bcaca87dafd55dd5$export$3aec6cdbefa34ac2 = (changedAssociatedIssues, associatedIssuesOnIssue, loadedAssociatedIssues)=>{
        const updated = $bcaca87dafd55dd5$var$extendAssociatedIssueUpdateWithNotLoaded(changedAssociatedIssues, associatedIssuesOnIssue, loadedAssociatedIssues);
        return $bcaca87dafd55dd5$var$arrayValuesEqual(updated, associatedIssuesOnIssue) ? undefined : updated;
    };
});
parcelRegister("5Lk1T", function(module, exports) {
    $parcel$export(module.exports, "filterOnlyExistedAssociatedIssues", ()=>$7c80518da6b170f7$export$c5dabde14225f4da);
    $parcel$export(module.exports, "filterOnlyExistedOriginalAssociatedIssues", ()=>$7c80518da6b170f7$export$a1c97565550a99c2);
    const $7c80518da6b170f7$export$c5dabde14225f4da = (issue, associatedIssues)=>{
        if (!associatedIssues || !issue.associatedIssueIds) return [];
        return issue.associatedIssueIds.map((issueId)=>associatedIssues[issueId]).filter((currentIssue)=>!!currentIssue);
    };
    const $7c80518da6b170f7$export$a1c97565550a99c2 = (issue, associatedIssues)=>{
        if (!issue?.originals?.associatedIssueIds) return undefined;
        if (!associatedIssues) return [];
        const originalsAssociatedIssueIds = issue.originals.associatedIssueIds;
        return originalsAssociatedIssueIds.map((issueId)=>associatedIssues[issueId]).filter((currentIssue)=>!!currentIssue).map((el)=>el.id);
    };
});
parcelRegister("ls6Ec", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33d996869b591c55$export$2e2bcd8739ae039);
    var $bC2fB;
    var $fFmkt = parcelRequire("fFmkt");
    var $6aj5N = parcelRequire("6aj5N");
    var $33d996869b591c55$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $fFmkt.default), {})((0, $6aj5N.default));
});
parcelRegister("fFmkt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$860656b69684c531$export$2e2bcd8739ae039);
    var $bzvH1 = parcelRequire("bzvH1");
    var $3YtPS = parcelRequire("3YtPS");
    const $860656b69684c531$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        associatedIssueIds: (0, $bzvH1.getAssociatedIssueIds)
    });
    var $860656b69684c531$export$2e2bcd8739ae039 = $860656b69684c531$var$querySelector;
});
parcelRegister("6aj5N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce9971ddddf3149a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    var $1dJ6S;
    var $jhmo0;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $btzsC;
    var $apXzN;
    var $cb04i;
    var $TTKUQ = parcelRequire("TTKUQ");
    const $ce9971ddddf3149a$var$calculateFlexShrink = (names)=>{
        const nameLengths = names.map((name)=>name === undefined ? 0 : name.length);
        const shrinkCoefficient = 0.2;
        return nameLengths.map((length)=>Math.pow(length, shrinkCoefficient));
    };
    const $ce9971ddddf3149a$var$IssueCardContent = ({ data: data })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ce9971ddddf3149a$var$ideaContentCardTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ce9971ddddf3149a$var$ideaContentCardAvatar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            src: data.iconUrl,
            size: "xsmall"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            href: `/browse/${data.key}`,
            target: "_blank",
            xcss: $ce9971ddddf3149a$var$anchorStyles
        }, data.key)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "div",
            size: "xsmall"
        }, data.summary));
    const $ce9971ddddf3149a$var$Issue = ({ data: data, flexShrink: flexShrink })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ce9971ddddf3149a$var$container,
            style: {
                flexShrink: flexShrink
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($ce9971ddddf3149a$var$IssueCardContent, {
                    data: data
                }),
            component: $ce9971ddddf3149a$var$TooltipLikeInlineDialog
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                ...tooltipProps,
                xcss: $ce9971ddddf3149a$var$contentWrapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $ce9971ddddf3149a$var$avatar
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                src: data.iconUrl,
                size: "xsmall"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $ce9971ddddf3149a$var$summary
            }, data.summary))));
    const $ce9971ddddf3149a$var$IdeasCell = ({ associatedIssues: associatedIssues })=>{
        const names = associatedIssues.map((el)=>el.summary);
        const values = $ce9971ddddf3149a$var$calculateFlexShrink(names);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ce9971ddddf3149a$var$ideasCellWrapper
        }, associatedIssues.map((associatedIssue, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ce9971ddddf3149a$var$Issue, {
                key: associatedIssue.key,
                data: associatedIssue,
                flexShrink: values[index]
            })));
    };
    const $ce9971ddddf3149a$var$View = (props)=>{
        const [associatedIssues] = (0, (0, parcelRequire("apXzN")).useAssociatedIssues)();
        const [isInitialized] = (0, (0, parcelRequire("apXzN")).useAssociatedIssuesInitialized)();
        if (!isInitialized) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cb04i")).CellSkeleton), {
            width: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM
        });
        if (!associatedIssues || !props.issue.associatedIssueIds) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ce9971ddddf3149a$var$IdeasCell, {
            associatedIssues: props.issue.associatedIssueIds?.map((issueId)=>associatedIssues[issueId]).filter((issue)=>!!issue)
        });
    };
    var $ce9971ddddf3149a$export$2e2bcd8739ae039 = $ce9971ddddf3149a$var$View;
    const $ce9971ddddf3149a$var$container = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        paddingLeft: 'space.100',
        minWidth: 'size.300',
        height: '100%',
        flexBasis: 'content'
    });
    const $ce9971ddddf3149a$var$avatar = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.050',
        flexShrink: 0
    });
    const $ce9971ddddf3149a$var$summary = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    });
    const $ce9971ddddf3149a$var$ideasCellWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex'
    });
    const $ce9971ddddf3149a$var$contentWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        width: '100%'
    });
    const $ce9971ddddf3149a$var$ideaContentCardTitle = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginBottom: 'space.150'
    });
    const $ce9971ddddf3149a$var$ideaContentCardAvatar = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.100'
    });
    const $ce9971ddddf3149a$var$TooltipLikeInlineDialog = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("btzsC")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhku67f _2rkoglpi _16qsjdvv _vchh18uv _1yt41bs6 _1bsb52fy",
                __cmplp.className
            ])
        });
    });
    const $ce9971ddddf3149a$var$anchorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textDecoration: 'none',
        ':hover': {
            textDecoration: 'underline'
        }
    });
});
parcelRegister("g38cp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12748e2796fdee76$export$2e2bcd8739ae039);
    var $bC2fB;
    var $fY1DN = parcelRequire("fY1DN");
    var $lLweI = parcelRequire("lLweI");
    var $6fczH = parcelRequire("6fczH");
    var $12748e2796fdee76$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $lLweI.default), (0, $fY1DN.default))((0, $6fczH.default));
});
parcelRegister("fY1DN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c97ccc2358b9059$export$2e2bcd8739ae039);
    var $5tChd = parcelRequire("5tChd");
    const $9c97ccc2358b9059$var$dispatchMethods = (dispatch)=>({
            onChange: (issue, transition)=>{
                dispatch((0, $5tChd.updateIssueStatus)({
                    issue: issue,
                    transition: transition
                }));
            }
        });
    var $9c97ccc2358b9059$export$2e2bcd8739ae039 = $9c97ccc2358b9059$var$dispatchMethods;
});
parcelRegister("5tChd", function(module, exports) {
    $parcel$export(module.exports, "updateIssueStatus", ()=>$8bada8b7a340dacb$export$a76d559af9096b60);
    $parcel$export(module.exports, "default", ()=>$8bada8b7a340dacb$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $bHTqr = parcelRequire("bHTqr");
    var $96USE = parcelRequire("96USE");
    var $7CxJ7 = parcelRequire("7CxJ7");
    var $bkasS = parcelRequire("bkasS");
    const $8bada8b7a340dacb$var$UPDATE_ISSUE_STATUS = 'command.issue-status.UPDATE_ISSUE_STATUS';
    const $8bada8b7a340dacb$export$a76d559af9096b60 = (payload)=>({
            type: $8bada8b7a340dacb$var$UPDATE_ISSUE_STATUS,
            payload: payload
        });
    function* $8bada8b7a340dacb$var$resetIssueStatus(issueId, originalIssueStatusId) {
        const { id: planId, currentScenarioId: scenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const body = {
            itemKeys: [
                issueId
            ],
            planId: planId,
            scenarioId: scenarioId,
            description: {
                status: {
                    reset: true
                }
            }
        };
        const resetStatusResponse = yield (0, $aNOuE.call)((0, $bkasS.doResetIssueRequest), body);
        if (resetStatusResponse?.ok) {
            yield (0, $aNOuE.put)((0, $96USE.update)({
                id: issueId,
                status: originalIssueStatusId
            }));
            yield (0, $aNOuE.put)($7CxJ7.revertFields({
                id: issueId,
                fields: [
                    'status'
                ]
            }));
        }
    }
    function* $8bada8b7a340dacb$export$35b7403928519ea({ payload: { issue: issue, transition: transition } }) {
        const originalIssueStatusId = issue?.originals?.status;
        const newStatus = transition.to;
        if (transition.id === (0, $TTKUQ.ORIGINAL_STATUS_TRANSITION).id) yield (0, $aNOuE.call)($8bada8b7a340dacb$var$resetIssueStatus, issue.id, originalIssueStatusId);
        else yield (0, $aNOuE.put)((0, $bkasS.updateIssueOrInlineCreate)({
            id: issue.id,
            status: newStatus.id,
            statusTransition: transition.id
        }));
    }
    function* $8bada8b7a340dacb$var$watchUpdateIssueStatus() {
        yield (0, $6u3NN.takeEvery)($8bada8b7a340dacb$var$UPDATE_ISSUE_STATUS, $8bada8b7a340dacb$export$35b7403928519ea);
    }
    function* $8bada8b7a340dacb$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($8bada8b7a340dacb$var$watchUpdateIssueStatus);
    }
});
parcelRegister("lLweI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1d1fa892962e83ba$export$2e2bcd8739ae039);
    var $7ppNi = parcelRequire("7ppNi");
    var $jpXKt = parcelRequire("jpXKt");
    var $3YtPS = parcelRequire("3YtPS");
    const $1d1fa892962e83ba$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        issueStatuses: (0, $7ppNi.getIssueStatusById),
        projectsById: (0, $jpXKt.getProjectsById)
    });
    var $1d1fa892962e83ba$export$2e2bcd8739ae039 = $1d1fa892962e83ba$var$querySelector;
});
parcelRegister("6fczH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd8e2a620dbb03ea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fQeLt;
    var $4nDwW = parcelRequire("4nDwW");
    var $kbGxr = parcelRequire("kbGxr");
    var $g5X3G;
    var $3FQWJ = parcelRequire("3FQWJ");
    var $buaCg = parcelRequire("buaCg");
    var $3oJ9g = parcelRequire("3oJ9g");
    const $cd8e2a620dbb03ea$export$58e0df5bb69dbb83 = ({ issue: issue, issueStatuses: issueStatuses, projectsById: projectsById, onChange: onChange, isScrolling: isScrolling, showOptimizations: showOptimizations, isReadOnly: isReadOnly })=>{
        const handleChange = (transition)=>{
            onChange(issue, transition);
        };
        if ((0, $4nDwW.isDefined)(issue.status) && (0, $4nDwW.isDefined)(issueStatuses[issue.status])) {
            const status = issueStatuses[issue.status];
            if (!status) return null;
            const issueProject = issue.project && projectsById[issue.project];
            if (!issueProject) return null;
            const issueProjectAndKey = `${issueProject.key}-${issue.issueKey}`;
            const { id: id, name: name, categoryId: categoryId } = status;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
                attribute: "status",
                issue: issue,
                isScrolling: isScrolling,
                showOptimizations: !!showOptimizations
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $3oJ9g.issueStatus
            }, (0, $kbGxr.isScenarioIssue)(issue.id) || isScrolling || isReadOnly ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fQeLt")).StatusLozenge), {
                value: {
                    id: id,
                    name: name,
                    statusCategory: {
                        id: categoryId
                    }
                }
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $buaCg.default), {
                issue: issue,
                issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(issueProjectAndKey),
                value: {
                    id: id,
                    name: name,
                    statusCategory: {
                        id: categoryId
                    }
                },
                onChange: handleChange,
                projectId: issueProject.id,
                issueStatuses: issueStatuses
            })));
        }
        return null;
    };
    var $cd8e2a620dbb03ea$export$2e2bcd8739ae039 = $cd8e2a620dbb03ea$export$58e0df5bb69dbb83;
});
parcelRegister("fQeLt", function(module, exports) {
    $parcel$export(module.exports, "StatusLozenge", ()=>$e065d549cea5a7d0$export$f72db4ad1e9b3e6d);
    $parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", ()=>$e065d549cea5a7d0$export$9f5070a985b0679b);
    var $5uXOq = parcelRequire("5uXOq");
    var $17mYr;
    const $e065d549cea5a7d0$export$f72db4ad1e9b3e6d = (props)=>{
        const status = props.value || props.initialValue;
        if (!status) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17mYr")).WrappedStatusLozenge), {
            status: status,
            isEditable: false,
            hasHoverState: false,
            focused: false
        });
    };
    const $e065d549cea5a7d0$export$9f5070a985b0679b = (props)=>{
        const status = props.value || props.initialValue;
        if (!status) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17mYr")).WrappedStatusLozenge), {
            status: status,
            isEditable: false,
            hasHoverState: false,
            focused: false,
            shouldShowDropdownIndication: true
        });
    };
});
parcelRegister("17mYr", function(module, exports) {
    $parcel$export(module.exports, "TEST_ID_PREFIX", ()=>$390c5e7bc7d9c77b$export$9cbc201c09a37b3f);
    $parcel$export(module.exports, "StatusLozenge", ()=>$390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d);
    $parcel$export(module.exports, "WrappedStatusLozenge", ()=>$390c5e7bc7d9c77b$export$69ea4907eefa8e7b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $9yOBd;
    var $5LWLA;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $aQhlk;
    var $7XYc4;
    var $4R6GH;
    var $dCm1o;
    var $kGDYq;
    var $5Ax7l;
    var $4YeLF;
    const $390c5e7bc7d9c77b$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
    const $390c5e7bc7d9c77b$var$CustomChevronDownGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            width: 12,
            height: 12,
            viewBox: "5 5 13 13"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
            fill: "currentColor",
            fillRule: "evenodd"
        }));
    const $390c5e7bc7d9c77b$var$StatusLozengeNew = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
            "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
        }, isEditable === true || shouldShowDropdownIndication === true ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Ax7l")).Lozenge), {
            statusCategoryId: statusCategory.id,
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, name, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
            label: ""
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Ax7l")).Lozenge), {
            statusCategoryId: statusCategory.id,
            isDisabled: isDisabled
        }, name)), hasHoverState && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $390c5e7bc7d9c77b$var$hoverOverlayStyles
        }));
    const $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew = (props)=>{
        const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...others } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? $390c5e7bc7d9c77b$var$pressableStyles : $390c5e7bc7d9c77b$var$pressableStylesOld,
            ref: targetRef,
            "aria-label": ariaLabel,
            "aria-expanded": isOpen,
            isDisabled: !isEditable,
            ...(0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-18579-status-field-interaction-name') ? {
                interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
            } : {}
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeNew, {
            ...others,
            isEditable: isEditable
        }));
    };
    const $390c5e7bc7d9c77b$var$EditableLozenge = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YeLF")).LozengeOld), null, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
            label: ""
        })));
    const $390c5e7bc7d9c77b$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozenge, {
            hasHoverState: hasHoverState,
            statusCategoryId: statusCategory.id,
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
            ref: targetRef,
            "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
        }, isEditable === true || shouldShowDropdownIndication === true ? (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$EditableLozenge, null, name) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YeLF")).LozengeOld), null, name)));
    const $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld = (props)=>{
        const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            ref: targetRef,
            appearance: "subtle",
            "aria-label": ariaLabel,
            "aria-expanded": isOpen,
            isDisabled: !isEditable,
            theme: (currentTheme, themeProps)=>{
                const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
                return {
                    buttonStyles: {
                        ...buttonStyles,
                        backgroundColor: 'transparent',
                        margin: 0,
                        width: 'auto',
                        height: 'auto',
                        padding: 0,
                        border: `2px solid ${error ? `var(--ds-border-danger, ${(0, $829f609a65d26a98$exports).R300})` : 'transparent'}`,
                        borderRadius: '5px',
                        ...isEditable === true ? undefined : {
                            cursor: 'auto'
                        },
                        outline: 0,
                        boxShadow: `0 0 0 2px ${isOpen === true ? `var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})` : 'transparent'}`,
                        '& > span': {
                            margin: 0
                        },
                        '&:focus, &:focus-within': {
                            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`}`
                        }
                    },
                    spinnerStyles: spinnerStyles
                };
            },
            ...(0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-18579-status-field-interaction-name') ? {
                interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
            } : {
                interactionName: 'auto-generated.jira-issue-field-status.common.ui.status-lozenge.button'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeOld, {
            ...other,
            isEditable: isEditable
        }));
    };
    const $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$StatusLozengeNew, $390c5e7bc7d9c77b$var$StatusLozengeOld);
    const $390c5e7bc7d9c77b$export$69ea4907eefa8e7b = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew, $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld);
    const $390c5e7bc7d9c77b$var$StyledLozenge = (0, $47bDC.default).span.withConfig({
        componentId: "wv585u-0"
    })`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>props.isDisabled ? (0, (0, parcelRequire("aQhlk")).disabledColor).text : !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual_refresh-status-text-color-changed') ? (0, (0, parcelRequire("aQhlk")).textColor)[(0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[props.statusCategoryId]] : (0, (0, parcelRequire("aQhlk")).textColorOld)[(0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, (0, parcelRequire("aQhlk")).disabledColor).bg : (0, (0, parcelRequire("aQhlk")).bgColor)[(0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, (0, parcelRequire("aQhlk")).disabledColor).text : (0, (0, parcelRequire("aQhlk")).textHoverColor)[(0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, (0, parcelRequire("aQhlk")).disabledColor).bg : (0, (0, parcelRequire("aQhlk")).bgHoverColor)[(0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $47bDC.css)({
            pointerEvents: 'none'
        })}}}`;
    const $390c5e7bc7d9c77b$var$StyledLozengeContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1h6o",
                (0, (0, parcelRequire("kGDYq")).isTabularGridFieldsEnabled)() ? "_1e0c1bgi" : "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $390c5e7bc7d9c77b$var$StatusContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                (0, (0, parcelRequire("kGDYq")).isTabularGridFieldsEnabled)() ? "_1bsb1osq" : "_1bsb1wug",
                __cmplp.className
            ])
        });
    });
    const $390c5e7bc7d9c77b$var$pressableStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        border: 'none',
        padding: 'space.0',
        borderRadius: '3px',
        background: 'transparent',
        position: 'relative',
        width: '100%'
    });
    const $390c5e7bc7d9c77b$var$pressableStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        border: 'none',
        padding: 'space.0',
        borderRadius: '3px',
        background: 'transparent',
        position: 'relative',
        maxWidth: '100%'
    });
    const $390c5e7bc7d9c77b$var$hoverOverlayStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: '0',
        borderRadius: '3px',
        marginRight: 'space.025',
        ':hover': {
            opacity: 0.3,
            backgroundColor: 'color.background.inverse.subtle'
        }
    });
});
parcelRegister("aQhlk", function(module, exports) {
    $parcel$export(module.exports, "statusCategoryToThemeMap", ()=>$58bc751e3aa4b554$export$d9e35f42afe1e488);
    $parcel$export(module.exports, "bgColor", ()=>$58bc751e3aa4b554$export$7dcbec377a25efc6);
    $parcel$export(module.exports, "textColor", ()=>$58bc751e3aa4b554$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "textColorOld", ()=>$58bc751e3aa4b554$export$26ac04004fa4ead4);
    $parcel$export(module.exports, "bgHoverColor", ()=>$58bc751e3aa4b554$export$69fdf3ba928b4c77);
    $parcel$export(module.exports, "textHoverColor", ()=>$58bc751e3aa4b554$export$99ec0cf2cf1b2082);
    $parcel$export(module.exports, "disabledColor", ()=>$58bc751e3aa4b554$export$b70f10fc4a6ba453);
    const $58bc751e3aa4b554$export$61137dce61763ec3 = 'default';
    const $58bc751e3aa4b554$export$132676d06d92ad48 = 'success';
    const $58bc751e3aa4b554$export$5c1f3b72419aa125 = 'inprogress';
    const $58bc751e3aa4b554$export$d9e35f42afe1e488 = {
        '1': $58bc751e3aa4b554$export$61137dce61763ec3,
        '2': $58bc751e3aa4b554$export$61137dce61763ec3,
        '3': $58bc751e3aa4b554$export$132676d06d92ad48,
        '4': $58bc751e3aa4b554$export$5c1f3b72419aa125
    };
    const $58bc751e3aa4b554$export$7dcbec377a25efc6 = {
        [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`
    };
    const $58bc751e3aa4b554$export$32f78bffcd82ff28 = {
        [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
        [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    };
    const $58bc751e3aa4b554$export$26ac04004fa4ead4 = {
        [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
        [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    };
    const $58bc751e3aa4b554$export$69fdf3ba928b4c77 = {
        [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-background-success-hovered, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
        [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-background-information-hovered, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    };
    const $58bc751e3aa4b554$export$99ec0cf2cf1b2082 = {
        [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    };
    const $58bc751e3aa4b554$export$b70f10fc4a6ba453 = {
        bg: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        text: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
    };
});
parcelRegister("kGDYq", function(module, exports) {
    $parcel$export(module.exports, "isTabularGridFieldsEnabled", ()=>$4b98d8a4e0ed63d5$export$9605b1d5fe0c238b);
    var $co1wz;
    const $4b98d8a4e0ed63d5$export$455240e4be839479 = 'jsw.uif.tmp.card.tabular.grid';
    const $4b98d8a4e0ed63d5$export$9605b1d5fe0c238b = ()=>(0, (0, parcelRequire("co1wz")).ff)($4b98d8a4e0ed63d5$export$455240e4be839479, false);
});
parcelRegister("5Ax7l", function(module, exports) {
    $parcel$export(module.exports, "Lozenge", ()=>$bcba81c28add5d02$export$a31cbe1bf5463979);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $aQhlk;
    const $bcba81c28add5d02$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: (0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[statusCategoryId],
            isBold: true,
            ...isDisabled ? {
                style: {
                    color: (0, (0, parcelRequire("aQhlk")).disabledColor).text,
                    backgroundColor: (0, (0, parcelRequire("aQhlk")).disabledColor).bg
                }
            } : {}
        }, children);
});
parcelRegister("4YeLF", function(module, exports) {
    $parcel$export(module.exports, "LozengeOld", ()=>$bbacf745a667099a$export$26089816624d22fc);
    var $5uXOq = parcelRequire("5uXOq");
    const $bbacf745a667099a$var$containerStyles = {
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-block',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        maxWidth: '100%',
        padding: 0,
        textTransform: 'uppercase',
        verticalAlign: 'top'
    };
    const $bbacf745a667099a$var$contentStyles = {
        boxSizing: 'border-box',
        display: 'inline-block',
        maxWidth: 200,
        overflow: 'hidden',
        padding: `0 ${"var(--ds-space-050, 4px)"}`,
        textOverflow: 'ellipsis',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        width: '100%'
    };
    const $bbacf745a667099a$export$26089816624d22fc = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: $bbacf745a667099a$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: $bbacf745a667099a$var$contentStyles
        }, children));
    $bbacf745a667099a$export$26089816624d22fc.displayName = 'Lozenge';
});
parcelRegister("buaCg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90d962e48fee1c38$export$2e2bcd8739ae039);
    var $bC2fB;
    var $8JW43 = parcelRequire("8JW43");
    var $7wwhE = parcelRequire("7wwhE");
    var $90d962e48fee1c38$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $8JW43.default))((0, $7wwhE.default));
});
parcelRegister("8JW43", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8244cb8c5fdda506$export$2e2bcd8739ae039);
    var $24CMK = parcelRequire("24CMK");
    var $8244cb8c5fdda506$export$2e2bcd8739ae039 = (dispatch)=>({
            genericError: (payload)=>{
                dispatch((0, $24CMK.genericError)(payload));
            }
        });
});
parcelRegister("7wwhE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02f6d0883691d0df$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Xmbv;
    var $hmK1M;
    var $an47R;
    var $2brZf;
    var $lUJY8;
    var $9OXo1;
    var $cVt3t = parcelRequire("cVt3t");
    const $02f6d0883691d0df$export$28769ce7cf4b59f9 = ({ issue: issue, onChange: onChange, issueKey: issueKey, value: value, projectId: projectId, transitions: transitions, loading: loading, fetchTransitions: fetchTransitions, isMenuDefaultOpen: isMenuDefaultOpen })=>{
        const [isWorkflowModalOpen, setIsWorkflowModalOpen] = (0, $5uXOq.useState)(false);
        const [isWorkflowModalMounted, setIsWorkflowModalMounted] = (0, $5uXOq.useState)(false);
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const handleChange = (0, $5uXOq.useCallback)((transition)=>{
            onChange(transition);
        }, [
            onChange
        ]);
        const onOpenModal = (0, $5uXOq.useCallback)(()=>{
            setIsWorkflowModalOpen(true);
        }, []);
        const onCloseModal = (0, $5uXOq.useCallback)(()=>{
            setIsWorkflowModalOpen(false);
        }, []);
        const onModalMounted = (0, $5uXOq.useCallback)(()=>{
            setIsWorkflowModalMounted(true);
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Xmbv")).default), {
            baseUrl: tenantContext.baseUrl,
            issueKey: issueKey
        }, (workflowServiceApi)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hmK1M")).default), {
                appearance: "lozenge",
                ...isMenuDefaultOpen === true ? {
                    defaultOpen: true
                } : {},
                value: value,
                transitions: transitions,
                onChange: handleChange,
                isLoading: loading,
                popperProps: {
                    strategy: 'absolute'
                },
                onOpen: ()=>{
                    fetchTransitions();
                    const hasFetchedWorkflowService = workflowServiceApi.data && workflowServiceApi.data.hasPermission !== undefined;
                    if (hasFetchedWorkflowService !== true) workflowServiceApi.fetch();
                },
                footer: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("an47R")).default), {
                    baseUrl: tenantContext.baseUrl,
                    issueKey: issueKey,
                    workflowServiceApi: workflowServiceApi,
                    onOpenModal: onOpenModal,
                    isModalMounted: isWorkflowModalMounted
                })
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2brZf")).default), {
                onModalMounted: onModalMounted,
                issueKey: issueKey,
                issueTypeId: `${issue.type}`,
                baseUrl: tenantContext.baseUrl,
                locale: tenantContext.locale,
                cloudId: tenantContext.cloudId,
                projectId: `${projectId}`,
                isOpen: isWorkflowModalOpen,
                onClose: onCloseModal,
                scope: workflowServiceApi.data?.isSimplified === true ? (0, (0, parcelRequire("lUJY8")).SCOPE_PROJECT) : (0, (0, parcelRequire("lUJY8")).SCOPE_GLOBAL)
            })));
    };
    var $02f6d0883691d0df$export$2e2bcd8739ae039 = (0, $cVt3t.transitionsProvider)($02f6d0883691d0df$export$28769ce7cf4b59f9);
});
parcelRegister("7Xmbv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22d0becb667fb17a$export$2e2bcd8739ae039);
    var $aNP7s;
    const $22d0becb667fb17a$export$d1183e28fea9e49c = {
        data: undefined,
        loading: false,
        error: undefined,
        fetch: ()=>Promise.resolve()
    };
    const $22d0becb667fb17a$var$ViewWorkflowContextService = (props)=>{
        const { baseUrl: baseUrl, issueKey: issueKey, children: children } = props;
        return children((0, (0, parcelRequire("aNP7s")).useProjectViewWorkflowService)(baseUrl, issueKey));
    };
    var $22d0becb667fb17a$export$2e2bcd8739ae039 = $22d0becb667fb17a$var$ViewWorkflowContextService;
});
parcelRegister("aNP7s", function(module, exports) {
    $parcel$export(module.exports, "useProjectViewWorkflowService", ()=>$ff9732a099884487$export$aa23574b54bd5f5e);
    var $2vSU6;
    var $k3PbQ;
    var $lpwtK;
    var $g5X3G;
    var $koeKL;
    var $kBWC0;
    const $ff9732a099884487$export$d1183e28fea9e49c = {
        data: undefined,
        loading: false,
        error: undefined,
        fetch: ()=>Promise.resolve()
    };
    const $ff9732a099884487$var$getIssueProjectDataFromContext = (useProjectData, issueProjectKey)=>{
        if (!useProjectData || !useProjectData.data) return undefined;
        const hasIssueProjectDataInContext = useProjectData.data.key === issueProjectKey;
        if (!hasIssueProjectDataInContext) return undefined;
        return {
            projectId: (0, (0, parcelRequire("g5X3G")).toProjectId)(useProjectData.data.id.toString()),
            projectType: (0, (0, parcelRequire("2vSU6")).toProjectType)(useProjectData.data.type),
            isSimplified: useProjectData.data.isSimplified
        };
    };
    const $ff9732a099884487$export$aa23574b54bd5f5e = (baseUrl, issueKey)=>{
        const issueProjectKey = issueKey ? (0, (0, parcelRequire("k3PbQ")).extractProjectKey)(issueKey) : null;
        const useProjectData = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectContextData = $ff9732a099884487$var$getIssueProjectDataFromContext(useProjectData, issueProjectKey);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const issueContextData = (0, (0, parcelRequire("kBWC0")).useViewWorkflowData)({
            baseUrl: baseUrl,
            projectKey: projectContextData ? undefined : issueProjectKey || undefined,
            issueKey: issueKey,
            isSimplified: projectContextData && projectContextData.isSimplified,
            cloudId: cloudId
        });
        if (!issueKey || !issueProjectKey) return {
            ...$ff9732a099884487$export$d1183e28fea9e49c
        };
        const combinedData = projectContextData || issueContextData.data ? {
            ...projectContextData,
            ...issueContextData.data
        } : undefined;
        return {
            ...issueContextData,
            data: combinedData
        };
    };
});
parcelRegister("kBWC0", function(module, exports) {
    $parcel$export(module.exports, "useViewWorkflowData", ()=>$f867d69fec793925$export$d60b63dd0a193e30);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $co1wz;
    var $7f4tk;
    var $gRDj0;
    var $iaa7u;
    const $f867d69fec793925$export$7a2d7e5adacde085 = ()=>'/rest/gira/latest/?operation=nextGenViewWorkflowQuery';
    const $f867d69fec793925$var$optionsGraphQlQuery = (issueKey, cloudId, projectKey)=>`
    query nextGenViewWorkflowQuery {
        permissions(issueKey:"${issueKey}", keys:["${0, $878fbedb9c4ca329$export$136fc24ec1bfcefd}", "${0, $878fbedb9c4ca329$export$624e7abc8d9cada5}"]) {
            key
            havePermission
        }
        ${projectKey ? `project(projectKey: "${projectKey}") {
            projectId
            simplified
            type
        }` : ''}
        jira {
            issueByKey(key: "${issueKey}", cloudId: "${cloudId}") {
                fieldsById(ids: ["issuetype"]) {
                    edges {
                        node {
                            ... on JiraIssueTypeField {
                                fieldId
                                issueType {
                                issueTypeId
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
    const $f867d69fec793925$export$7fe04353ef301d96 = (baseUrl, issueKey, cloudId, projectKey, isSimplified)=>(0, (0, parcelRequire("7f4tk")).default)($f867d69fec793925$export$7a2d7e5adacde085(), {
            method: 'POST',
            body: JSON.stringify({
                query: $f867d69fec793925$var$optionsGraphQlQuery(issueKey, cloudId, projectKey)
            })
        }).then((data)=>(0, (0, parcelRequire("iaa7u")).transform)(data, isSimplified));
    const $f867d69fec793925$export$d60b63dd0a193e30 = ({ baseUrl: baseUrl, projectKey: projectKey, issueKey: issueKey, isSimplified: isSimplified, cloudId: cloudId })=>{
        const [dataState, setDataState] = (0, $5uXOq.useState)(undefined);
        const [errorState, setErrorState] = (0, $5uXOq.useState)(undefined);
        const [loadingState, setLoadingState] = (0, $5uXOq.useState)(false);
        const { fetchWorkflowServiceData: fetchWorkflowServiceData } = (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c') ? (0, (0, parcelRequire("gRDj0")).useFetchWorkflowServiceData)({
            issueKey: issueKey
        }) : {
            fetchWorkflowServiceData: ()=>undefined
        };
        const fetch = async ()=>{
            request();
            try {
                let dataRes;
                if ((0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c')) dataRes = await fetchWorkflowServiceData();
                else dataRes = await $f867d69fec793925$export$7fe04353ef301d96(baseUrl, issueKey, cloudId, projectKey, isSimplified);
                success(dataRes);
            } catch (ex) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $878fbedb9c4ca329$export$4bf6353caa97e8e7), ex);
                failure(ex);
            }
        };
        const request = ()=>{
            setDataState(undefined);
            setErrorState(undefined);
            setLoadingState(true);
        };
        const success = (data)=>{
            setDataState(data);
            setErrorState(undefined);
            setLoadingState(false);
        };
        const failure = (error)=>{
            setDataState(undefined);
            setErrorState(error);
            setLoadingState(false);
        };
        return {
            data: dataState,
            error: errorState,
            loading: loadingState,
            fetch: fetch
        };
    };
});
const $878fbedb9c4ca329$export$71a8e2ae8cfade56 = 'issue-field.status.fetch-transitions';
const $878fbedb9c4ca329$export$25529a3376b831fd = 'issue-field.status.post-transition';
const $878fbedb9c4ca329$export$4bf6353caa97e8e7 = 'issue-field.status.fetch-view-workflow';
const $878fbedb9c4ca329$export$136fc24ec1bfcefd = 'VIEW_READONLY_WORKFLOW';
const $878fbedb9c4ca329$export$624e7abc8d9cada5 = 'ADMINISTER';
parcelRegister("gRDj0", function(module, exports) {
    $parcel$export(module.exports, "useFetchWorkflowServiceData", ()=>$6d25929ebf7a2276$export$5625d50611791f51);
    var $capbT;
    var $5uXOq = parcelRequire("5uXOq");
    var $eiowN = parcelRequire("eiowN");
    var $2vSU6;
    var $5yJb9;
    var $g5X3G;
    var $koeKL;
    const $6d25929ebf7a2276$export$5625d50611791f51 = ({ issueKey: issueKey })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const fetchWorkflowServiceData = (0, $5uXOq.useCallback)(async ()=>{
            const data = await (0, $eiowN.fetchQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("capbT")).default), {
                issueKey: issueKey,
                cloudId: cloudId
            }).toPromise();
            return {
                hasPermission: (data?.jira?.issueByKey?.projectField?.project?.projectStyle === 'TEAM_MANAGED_PROJECT' ? data?.jira?.issueByKey?.canReadWorkflow || data?.jira?.issueByKey?.canEditWorkflow : data?.jira?.issueByKey?.canReadWorkflow) ?? false,
                projectId: (0, (0, parcelRequire("g5X3G")).toProjectId)(data?.jira?.issueByKey?.projectField?.project?.projectId ?? ''),
                projectType: (0, (0, parcelRequire("2vSU6")).toProjectType)(data?.jira?.issueByKey?.projectField?.project?.projectType ?? ''),
                isSimplified: data?.jira?.issueByKey?.projectField?.project?.projectStyle === 'TEAM_MANAGED_PROJECT',
                issueTypeId: (0, (0, parcelRequire("g5X3G")).toIssueTypeId)(data?.jira?.issueByKey?.issueTypeField?.issueType?.issueTypeId ?? '')
            };
        }, [
            cloudId,
            issueKey
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                fetchWorkflowServiceData: fetchWorkflowServiceData
            }), [
            fetchWorkflowServiceData
        ]);
    };
});
parcelRegister("capbT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c34c99b9dba4fa50$export$2e2bcd8739ae039);
    const $c34c99b9dba4fa50$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "issueKey"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "issueKey"
            }
        ], v2 = {
            "alias": "canReadWorkflow",
            "args": [
                {
                    "kind": "Literal",
                    "name": "permission",
                    "value": "VIEW_READONLY_WORKFLOW"
                }
            ],
            "kind": "ScalarField",
            "name": "hasProjectPermission",
            "storageKey": "hasProjectPermission(permission:\"VIEW_READONLY_WORKFLOW\")"
        }, v3 = {
            "alias": "canEditWorkflow",
            "args": [
                {
                    "kind": "Literal",
                    "name": "permission",
                    "value": "EDIT_WORKFLOW"
                }
            ],
            "kind": "ScalarField",
            "name": "hasProjectPermission",
            "storageKey": "hasProjectPermission(permission:\"EDIT_WORKFLOW\")"
        }, v4 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v5 = {
            "kind": "ScalarField",
            "name": "projectType"
        }, v6 = {
            "kind": "ScalarField",
            "name": "projectStyle"
        }, v7 = {
            "kind": "ScalarField",
            "name": "issueTypeId"
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useWorkflowRelayQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraProjectField",
                                        "kind": "LinkedField",
                                        "name": "projectField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v5,
                                                    v6
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeField",
                                        "kind": "LinkedField",
                                        "name": "issueTypeField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                    v7
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useWorkflowRelayQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issueByKey",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraProjectField",
                                        "kind": "LinkedField",
                                        "name": "projectField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v5,
                                                    v6,
                                                    v8
                                                ]
                                            },
                                            v8
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeField",
                                        "kind": "LinkedField",
                                        "name": "issueTypeField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                    v7,
                                                    v8
                                                ]
                                            },
                                            v8
                                        ]
                                    },
                                    v8
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "04a89f473a7a99d1e53af734bfdc49e7266fc4803ed427ccf54421609fb93a8a",
                "metadata": {},
                "name": "useWorkflowRelayQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $c34c99b9dba4fa50$var$node.hash = "ebdee6e1f1db415100c81dcb27198ff2";
    var $c34c99b9dba4fa50$export$2e2bcd8739ae039 = $c34c99b9dba4fa50$var$node;
});
parcelRegister("iaa7u", function(module, exports) {
    $parcel$export(module.exports, "transform", ()=>$36fc98ea47fc7430$export$51186ad6e864892a);
    var $2vSU6;
    var $g5X3G;
    const $36fc98ea47fc7430$var$simplifiedPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $878fbedb9c4ca329$export$136fc24ec1bfcefd) && havePermission || key === (0, $878fbedb9c4ca329$export$624e7abc8d9cada5) && havePermission;
    const $36fc98ea47fc7430$var$classicPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $878fbedb9c4ca329$export$136fc24ec1bfcefd) && havePermission;
    const $36fc98ea47fc7430$export$51186ad6e864892a = ({ data: data }, isSimplifiedCached)=>{
        if (!data || !data.permissions || !data.jira) return undefined;
        const { permissions: permissions, project: project, jira: jira } = data;
        const isSimplified = project && project.simplified || isSimplifiedCached;
        const permissionPredicate = isSimplified === true ? $36fc98ea47fc7430$var$simplifiedPermissionPredicate : $36fc98ea47fc7430$var$classicPermissionPredicate;
        const issueTypeField = jira.issueByKey?.fieldsById?.edges?.find((edge)=>edge.node?.fieldId === 'issuetype');
        const result = {
            hasPermission: permissions.some(permissionPredicate),
            issueTypeId: (0, (0, parcelRequire("g5X3G")).toIssueTypeId)(issueTypeField?.node?.issueType?.issueTypeId ? issueTypeField.node.issueType.issueTypeId : '')
        };
        if (project) {
            result.projectId = (0, (0, parcelRequire("g5X3G")).toProjectId)(String(project.projectId));
            result.projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(project.type);
            result.isSimplified = project.simplified;
        }
        return result;
    };
});
parcelRegister("hmK1M", function(module, exports) {
    $parcel$export(module.exports, "StatusView", ()=>$f4607509f8535f3b$export$a11134e1462e763);
    $parcel$export(module.exports, "default", ()=>$f4607509f8535f3b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $7K5PP;
    var $b9dFI;
    var $6sO8n;
    var $i0vxP;
    var $koVbs;
    var $1XJ20;
    var $2OMDV;
    var $8zOmE;
    var $17mYr;
    var $44VbI;
    var $kTnV4;
    var $5uNOo;
    var $k92cH;
    var $coyc6;
    var $rNSQs;
    var $1khYv;
    const $f4607509f8535f3b$var$defaultPopperProps = {
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document'
                }
            }
        ],
        strategy: 'fixed'
    };
    const $f4607509f8535f3b$export$d5aa018254c8c065 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('statusField', {
        onOpen: 'openDropdown',
        onChange: 'transitionSelected'
    })((0, (0, parcelRequire("b9dFI")).default));
    const $f4607509f8535f3b$export$f35c79a5a21cbec1 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('statusField', {
        onOpen: 'openDropdown',
        onChange: 'transitionSelected'
    })((0, (0, parcelRequire("7K5PP")).default));
    const $f4607509f8535f3b$var$isOptionDisabled = (option)=>option.transition.isDisabled;
    const $f4607509f8535f3b$export$a11134e1462e763 = ({ forceNoLabels: forceNoLabels = false, isEditable: isEditable = true, isSaving: isSaving = false, isLoading: isLoading, error: error, value: value, transitions: transitions, appearance: appearance, footer: footer, isDefaultSelect: isDefaultSelect = false, selectedTransition: selectedTransition, onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), onOpen: onOpen = (0, ($parcel$interopDefault($8Rkzz))), onClose: onClose = (0, ($parcel$interopDefault($8Rkzz))), onSuccess: onSuccess, customNoOptionsMessage: customNoOptionsMessage, statusButtonRef: statusButtonRef, popperProps: popperProps, registerInCommandPalette: registerInCommandPalette, onFetch: onFetch, fieldId: fieldId, showConfigureStatusButtons: showConfigureStatusButtons, defaultOpen: defaultOpen = false, shouldFitContainer: shouldFitContainer = true, onUpdateStatusMutation: onUpdateStatusMutation })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const childWrapperRef = (0, $5uXOq.useRef)(null);
        const wasChanged = (0, $5uXOq.useRef)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const previousIsSaving = (0, (0, parcelRequire("1XJ20")).usePrevious)(isSaving);
        const previousTransitions = (0, (0, parcelRequire("1XJ20")).usePrevious)(transitions);
        const previousIsOpen = (0, (0, parcelRequire("1XJ20")).usePrevious)(isOpen);
        const wasFetchSuccessful = transitions != null;
        const filteredAndOrderedTransitions = (0, (0, parcelRequire("44VbI")).getFilteredOrderedTransitions)(transitions, value.id);
        const isGlobalOnly = (0, (0, parcelRequire("44VbI")).isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
        const showLabel = !(forceNoLabels || isGlobalOnly);
        const formatTransitionOptionLabel = (0, $5uXOq.useCallback)((option, transitionProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "issue-field-status.ui.status-view.transition"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1khYv")).Transition), {
                transition: option.transition,
                hasLabel: showLabel,
                addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing,
                contentAfter: showConfigureStatusButtons ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5uNOo")).EditStatusButton), {
                    statusName: option.transition.name
                }) : null
            })), [
            showLabel,
            showConfigureStatusButtons
        ]);
        const getTransitionOptionLabel = (option)=>option.transition.isGlobal ? formatMessage((0, (0, parcelRequire("k92cH")).default).transitionTo, {
                statusName: option.label
            }) : `${option.transition.name} \u{2192} ${option.transition.to.name}`;
        const mergedPopperProps = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($1UikQ)))($f4607509f8535f3b$var$defaultPopperProps, popperProps), [
            popperProps
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (previousIsSaving === true && isSaving === false) childWrapperRef.current && childWrapperRef.current.children.length > 0 && childWrapperRef.current.children[0].focus();
        }, [
            isOpen,
            isSaving,
            previousIsOpen,
            previousIsSaving,
            previousTransitions,
            transitions
        ]);
        const handleChangeStatus = (0, $5uXOq.useCallback)((transition, analyticsEvent)=>{
            const { hasScreen: hasScreen } = transition;
            wasChanged.current = true;
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'transitionSelectedStatusField', {
                hasScreen: hasScreen
            });
            onChange?.(transition, analyticsEvent);
        }, [
            onChange
        ]);
        const handleChange = (0, $5uXOq.useCallback)((option, action, analyticsEvent)=>{
            handleChangeStatus(option.transition, analyticsEvent);
        }, [
            handleChangeStatus
        ]);
        const handleOpen = (0, $5uXOq.useCallback)((analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'openDropdownStatusField');
            onOpen?.(analyticsEvent);
            setIsOpen(true);
        }, [
            onOpen
        ]);
        const handleClose = (0, $5uXOq.useCallback)(()=>{
            wasChanged.current = false;
            onClose?.();
            setIsOpen(false);
        }, [
            onClose
        ]);
        const renderLozenge = (0, $5uXOq.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
            if (saving) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6sO8n")).default), {
                border: false
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17mYr")).WrappedStatusLozenge), {
                targetRef: targetRef,
                status: value,
                error: error
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17mYr")).WrappedStatusLozenge), {
                ariaLabel: `${value.name} - ${formatMessage((0, (0, parcelRequire("k92cH")).default).changeStatus)}`,
                error: err,
                hasHoverState: true,
                isEditable: editable,
                isOpen: isOpen,
                status: value,
                targetRef: targetRef
            });
        }, [
            error,
            formatMessage,
            isOpen,
            value
        ]);
        const renderButton = (0, $5uXOq.useCallback)(({ isEditable: editable, isSaving: saving, targetRef: targetRef })=>{
            const statusButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("rNSQs")).StatusButton), {
                ariaLabel: `${value.name} - ${formatMessage((0, (0, parcelRequire("k92cH")).default).changeStatus)}`,
                isEditable: editable,
                isOpen: isOpen,
                status: value,
                targetRef: targetRef,
                statusButtonRef: statusButtonRef,
                shouldFitContainer: shouldFitContainer
            });
            return saving ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6sO8n")).default), null, statusButton) : statusButton;
        }, [
            formatMessage,
            isOpen,
            shouldFitContainer,
            statusButtonRef,
            value
        ]);
        const renderCommandPalette = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTnV4")).CommandPaletteStatusView), {
                transitions: filteredAndOrderedTransitions,
                currentStatus: value,
                onSuccess: onSuccess,
                wasFetchSuccessful: wasFetchSuccessful,
                renderTransition: formatTransitionOptionLabel,
                onFetch: onFetch,
                isLoading: isLoading,
                onUpdateStatusMutation: onUpdateStatusMutation
            }), [
            filteredAndOrderedTransitions,
            value,
            onSuccess,
            wasFetchSuccessful,
            formatTransitionOptionLabel,
            onFetch,
            isLoading,
            onUpdateStatusMutation
        ]);
        const renderWithFocusWrapper = (0, $5uXOq.useCallback)((children)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: childWrapperRef
            }, children), []);
        const renderTarget = (0, $5uXOq.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
            if (value) {
                if (appearance === 'lozenge') return renderWithFocusWrapper(renderLozenge({
                    isEditable: editable,
                    isSaving: saving,
                    error: err,
                    targetRef: targetRef
                }));
                if (appearance === 'button') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderWithFocusWrapper(renderButton({
                    isEditable: editable,
                    isSaving: saving,
                    targetRef: targetRef
                })), registerInCommandPalette && renderCommandPalette());
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null);
        }, [
            appearance,
            registerInCommandPalette,
            renderButton,
            renderCommandPalette,
            renderLozenge,
            renderWithFocusWrapper,
            value
        ]);
        if (isSaving || !isEditable) return renderTarget({
            isSaving: isSaving,
            isEditable: isEditable,
            error: error
        });
        const getNoOptionsMessage = ()=>{
            if (customNoOptionsMessage) return customNoOptionsMessage;
            return formatMessage(wasFetchSuccessful ? (0, (0, parcelRequire("k92cH")).default).noPermission : (0, (0, parcelRequire("k92cH")).default).cannotLoadTransitions);
        };
        const statusPopup = isDefaultSelect && selectedTransition ? (0, ($parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$export$f35c79a5a21cbec1, {
            label: formatMessage((0, (0, parcelRequire("k92cH")).default).selectStatus),
            inputId: fieldId,
            noOptionsMessage: getNoOptionsMessage,
            formatOptionLabel: formatTransitionOptionLabel,
            getOptionLabel: getTransitionOptionLabel,
            options: (0, (0, parcelRequire("44VbI")).transformOptions)(filteredAndOrderedTransitions || []),
            isLoading: isLoading,
            isDisabled: !isEditable,
            isOptionDisabled: $f4607509f8535f3b$var$isOptionDisabled,
            onChange: handleChange,
            value: (0, (0, parcelRequire("44VbI")).transformOptions)([
                selectedTransition
            ])[0],
            isSearchable: false,
            onOpen: handleOpen,
            onClose: handleClose,
            closeMenuOnSelect: true,
            components: {
                LoadingMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("coyc6")).LoadingSpinner), null)
            },
            popperProps: mergedPopperProps,
            footer: footer
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$export$d5aa018254c8c065, {
            inputId: fieldId,
            noOptionsMessage: getNoOptionsMessage,
            formatOptionLabel: formatTransitionOptionLabel,
            getOptionLabel: getTransitionOptionLabel,
            options: (0, (0, parcelRequire("44VbI")).transformOptions)(filteredAndOrderedTransitions || []),
            target: ({ ref: ref })=>renderTarget({
                    isEditable: isEditable,
                    isSaving: isSaving,
                    error: error,
                    targetRef: ref
                }),
            isLoading: isLoading,
            isDisabled: !isEditable,
            isOptionDisabled: $f4607509f8535f3b$var$isOptionDisabled,
            searchThreshold: 99999,
            onChange: handleChange,
            onOpen: handleOpen,
            onClose: handleClose,
            closeMenuOnSelect: true,
            components: {
                LoadingMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("coyc6")).LoadingSpinner), null)
            },
            popperProps: mergedPopperProps,
            footer: footer,
            defaultIsOpen: defaultOpen,
            label: formatMessage((0, (0, parcelRequire("k92cH")).default).selectStatus)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i0vxP")).default), {
            onEscape: (0, ($parcel$interopDefault($8Rkzz)))
        }, statusPopup);
    };
    var $f4607509f8535f3b$export$2e2bcd8739ae039 = $f4607509f8535f3b$export$a11134e1462e763;
});
parcelRegister("6sO8n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d332aa7c19a695ac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    function $d332aa7c19a695ac$export$2e2bcd8739ae039(props) {
        const { border: border, children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$BlanketContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$BackgroundContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$Background, {
            border: border
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$ComponentContainer, null, children), (0, ($parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$SpinnerContainer, {
            role: "status",
            "aria-label": "Loading"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null)));
    }
    $d332aa7c19a695ac$export$2e2bcd8739ae039.defaultProps = {
        border: true
    };
    const $d332aa7c19a695ac$var$BlanketContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
                __cmplp.className
            ])
        });
    });
    const $d332aa7c19a695ac$var$SpinnerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
                __cmplp.className
            ])
        });
    });
    const $d332aa7c19a695ac$var$BackgroundContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _1yt483op _1reo1wug _18m91wug",
                __cmplp.className
            ])
        });
    });
    const $d332aa7c19a695ac$var$Background = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { border: border, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk14n2 _2rko1l7b",
                __cmplp.border ? "_19it1qih" : "_19itglyw",
                __cmplp.className
            ])
        });
    });
    const $d332aa7c19a695ac$var$ComponentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_tzy4sxj9 _16jlkb7n _1o9zkb7n _i0dl1wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("44VbI", function(module, exports) {
    $parcel$export(module.exports, "isOnlyGlobalTransitions", ()=>$d665573e03a66c7e$export$10992041bf7e444a);
    $parcel$export(module.exports, "getFilteredOrderedTransitions", ()=>$d665573e03a66c7e$export$707115549202b9e4);
    $parcel$export(module.exports, "getLoopedTransitionsForStatus", ()=>$d665573e03a66c7e$export$38146914a8d06579);
    $parcel$export(module.exports, "transformOptions", ()=>$d665573e03a66c7e$export$8f4ed8ef83bcbf04);
    $parcel$export(module.exports, "getStatusShape", ()=>$d665573e03a66c7e$export$e2dafe47b17b2cfc);
    var $8QpSo;
    var $gULOk;
    const $d665573e03a66c7e$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
    const $d665573e03a66c7e$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
    const $d665573e03a66c7e$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
    const $d665573e03a66c7e$var$filterLoopedTransitionsToSelf = (0, (0, parcelRequire("8QpSo")).default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$d665573e03a66c7e$var$isGlobalSelfTransition(transition, currentStatusId) && !$d665573e03a66c7e$var$isInitialSelfTransition(transition, currentStatusId)));
    const $d665573e03a66c7e$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
    const $d665573e03a66c7e$export$707115549202b9e4 = (transitions, currentStatusId)=>$d665573e03a66c7e$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
    const $d665573e03a66c7e$export$38146914a8d06579 = (0, (0, parcelRequire("8QpSo")).default)((transitions, currentStatusId)=>(transitions || []).filter((transition)=>$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId)));
    const $d665573e03a66c7e$var$formatOptions = (options)=>options.map((t)=>({
                label: t.to.name,
                value: t.id,
                transition: t
            }));
    const $d665573e03a66c7e$var$memoizedTranformOptions = (0, (0, parcelRequire("8QpSo")).default)($d665573e03a66c7e$var$formatOptions);
    const $d665573e03a66c7e$export$8f4ed8ef83bcbf04 = (options)=>$d665573e03a66c7e$var$memoizedTranformOptions(options);
    const $d665573e03a66c7e$export$e2dafe47b17b2cfc = (id, name, category)=>{
        const statusCategoryId = (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[category] || (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).UNDEFINED];
        return {
            id: id,
            name: name,
            statusCategory: {
                id: statusCategoryId,
                name: name
            }
        };
    };
});
parcelRegister("kTnV4", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteStatusView", ()=>$95d268cd8622d793$export$d907a4132fe8618c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2NMNM;
    var $imUQY;
    var $lj8SI;
    var $5p1kJ;
    var $7C5Su;
    var $e34gT;
    var $eG9rp;
    var $6NI23;
    var $1Kt4o;
    var $fVMIs;
    var $jh7L9;
    var $jiSaf;
    var $d8lE2;
    var $cSD7y;
    var $koVbs;
    var $2gCtH;
    var $c6XT1;
    var $8zOmE;
    var $iokLh;
    var $99Vn3;
    var $fBoWB;
    const $95d268cd8622d793$export$3b70c533639eedc2 = ({ childrenProps: childrenProps, statusViewProps: statusViewProps })=>{
        const { setLoading: setLoading, setChildResult: setChildResult } = childrenProps;
        const { wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, isLoading: isLoading, renderTransition: renderTransition, onSuccess: onSuccess, onUpdateStatusMutation: onUpdateStatusMutation } = statusViewProps;
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const issueId = (0, (0, parcelRequire("c6XT1")).useIssueAri)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { saveStatusField: saveStatusField } = (0, (0, parcelRequire("99Vn3")).useSaveStatusField)(issueKey, issueId, onUpdateStatusMutation);
        const loadTransitions = (0, $5uXOq.useCallback)(()=>{
            if (!wasFetchSuccessful) return {
                commands: []
            };
            const transitionCommands = transitions.map((transition)=>({
                    id: `${0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774}-${transition.id}`,
                    name: transition.name,
                    components: {
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, renderTransition({
                                transition: transition
                            }, {
                                addTransitionArrowSpacing: true
                            }))
                    },
                    keywords: (0, (0, parcelRequire("fBoWB")).getTransitionKeywords)(transition),
                    primaryAction: {
                        type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                        perform: ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                                oldValId: currentStatus.id,
                                oldStatusCategoryId: currentStatus.statusCategory.id,
                                newValId: transition.to.id,
                                newStatusCategoryId: transition.to.statusCategory.id,
                                hasScreen: transition.hasScreen,
                                isConditional: transition.isConditional
                            });
                            saveStatusField(transition, ()=>{
                                onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                            });
                        }
                    },
                    analytics: {
                        action: 'changeStatus',
                        actionCategory: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_ISSUE_ACTIONS)
                    }
                }));
            const commands = [
                {
                    id: `${(0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                    name: currentStatus.name,
                    components: {
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$SelectedStatusContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                                isBold: true
                            }, currentStatus.name)), (0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$CurrentStatusContainer, null, formatMessage((0, (0, parcelRequire("iokLh")).messages).current)))
                    },
                    primaryAction: {
                        type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                        perform: (0, ($parcel$interopDefault($8Rkzz)))
                    }
                },
                ...transitionCommands
            ];
            return {
                commands: commands
            };
        }, [
            createAnalyticsEvent,
            currentStatus.id,
            currentStatus.name,
            currentStatus.statusCategory.id,
            formatMessage,
            onSuccess,
            renderTransition,
            saveStatusField,
            transitions,
            wasFetchSuccessful
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setLoading(isLoading);
        }, [
            isLoading,
            setLoading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setChildResult(loadTransitions());
        }, [
            loadTransitions,
            setChildResult
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jiSaf")).components).Body, childrenProps);
    };
    const $95d268cd8622d793$export$3d254fd4c446ee4 = (props)=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getKeywords: getKeywords } = (0, (0, parcelRequire("eG9rp")).useCommandKeywords)();
        const subscribeCommands = (0, (0, parcelRequire("fVMIs")).useSubscribeCommands)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ expandedCommand: expandedCommand, isOpen: isOpen }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteExpandedCommand)();
        const { onFetch: onFetch } = props;
        const renderChildren = (0, $5uXOq.useCallback)((childrenProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$export$3b70c533639eedc2, {
                childrenProps: childrenProps,
                statusViewProps: props
            }), [
            props
        ]);
        const renderHeader = (0, $5uXOq.useCallback)((base)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6NI23")).CommandFieldHeader), {
                ...base,
                issueKey: issueKey
            }), [
            issueKey
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const statusCommand = {
                id: (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774),
                name: formatMessage((0, (0, parcelRequire("iokLh")).messages).editStatus),
                shortcut: 'd',
                placeholder: formatMessage((0, (0, parcelRequire("iokLh")).messages).searchTransition),
                keywords: getKeywords('changeStatusSynonyms'),
                section: (0, (0, parcelRequire("e34gT")).getCommandPaletteIssueActionsHeader)(issueKey),
                priority: (0, (0, parcelRequire("7C5Su")).getCommandPaletteIssueActionsPriority)('STATUS'),
                components: {
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("imUQY"))))), {
                            label: ""
                        })
                },
                primaryAction: {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST,
                    fallback: {
                        onNoResults: {
                            label: formatMessage((0, (0, parcelRequire("iokLh")).messages).fallbackNoResults)
                        }
                    },
                    components: {
                        Body: renderChildren,
                        Header: renderHeader
                    }
                },
                analytics: {
                    action: 'changeStatusMenu'
                }
            };
            const unsubscribe = subscribeCommands((0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
                statusCommand
            ]);
            return ()=>unsubscribe();
        }, [
            formatMessage,
            getKeywords,
            issueKey,
            renderChildren,
            renderHeader,
            subscribeCommands
        ]);
        const expandedCommandId = expandedCommand?.id;
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && expandedCommandId === (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774) && onFetch) onFetch(createAnalyticsEvent({}));
        }, [
            expandedCommandId,
            isOpen,
            onFetch,
            createAnalyticsEvent
        ]);
        return null;
    };
    const $95d268cd8622d793$export$679497264cbfbf73 = ({ onFetch: onFetch, wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, renderTransition: renderTransition, onSuccess: onSuccess, onUpdateStatusMutation: onUpdateStatusMutation })=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getKeywords: getKeywords } = (0, (0, parcelRequire("eG9rp")).useCommandKeywords)();
        const subscribeCommands = (0, (0, parcelRequire("fVMIs")).useSubscribeCommands)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ expandedCommand: expandedCommand, isOpen: isOpen }, { setChildCommands: setChildCommands }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteExpandedCommand)();
        const renderHeader = (0, $5uXOq.useCallback)((base)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6NI23")).CommandFieldHeader), {
                ...base,
                issueKey: issueKey
            }), [
            issueKey
        ]);
        const issueId = (0, (0, parcelRequire("c6XT1")).useIssueAri)();
        const { saveStatusField: saveStatusField } = (0, (0, parcelRequire("99Vn3")).useSaveStatusField)(issueKey, issueId, onUpdateStatusMutation);
        const expandedCommandId = expandedCommand?.id;
        const loadTransitions = (0, $5uXOq.useCallback)(()=>{
            if (!wasFetchSuccessful) return {
                commands: []
            };
            const transitionCommands = transitions.map((transition)=>({
                    id: `${0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774}-${transition.id}`,
                    name: transition.name,
                    components: {
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, renderTransition({
                                transition: transition
                            }, {
                                addTransitionArrowSpacing: true
                            })),
                        LeftIcon: !expandedCommandId ? ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("imUQY"))))), {
                                label: ""
                            }) : undefined
                    },
                    keywords: (0, (0, parcelRequire("fBoWB")).getTransitionKeywords)(transition),
                    primaryAction: {
                        type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                        perform: ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                                oldValId: currentStatus.id,
                                oldStatusCategoryId: currentStatus.statusCategory.id,
                                newValId: transition.to.id,
                                newStatusCategoryId: transition.to.statusCategory.id,
                                hasScreen: transition.hasScreen,
                                isConditional: transition.isConditional
                            });
                            saveStatusField(transition, ()=>{
                                onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                            });
                        }
                    },
                    analytics: {
                        action: 'changeStatus',
                        actionCategory: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_ISSUE_ACTIONS)
                    }
                }));
            const currentCommand = expandedCommandId ? [
                {
                    id: `${(0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                    name: currentStatus.name,
                    components: {
                        LeftIcon: !expandedCommandId ? ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("imUQY"))))), {
                                label: formatMessage((0, (0, parcelRequire("iokLh")).messages).editStatus)
                            }) : undefined,
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$SelectedStatusContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                                isBold: true
                            }, currentStatus.name)), (0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$CurrentStatusContainer, null, formatMessage((0, (0, parcelRequire("iokLh")).messages).current)))
                    },
                    primaryAction: {
                        type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                        perform: (0, ($parcel$interopDefault($8Rkzz)))
                    }
                }
            ] : [];
            const commands = [
                ...currentCommand,
                ...transitionCommands
            ];
            return {
                commands: commands
            };
        }, [
            createAnalyticsEvent,
            currentStatus.id,
            currentStatus.name,
            currentStatus.statusCategory.id,
            formatMessage,
            onSuccess,
            renderTransition,
            saveStatusField,
            transitions,
            wasFetchSuccessful,
            expandedCommandId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const { commands: commands } = loadTransitions();
            const statusCommand = {
                id: (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774),
                name: formatMessage((0, (0, parcelRequire("iokLh")).messages).editStatus),
                shortcut: 'd',
                placeholder: formatMessage((0, (0, parcelRequire("iokLh")).messages).searchTransition),
                keywords: getKeywords('changeStatusSynonyms'),
                section: (0, (0, parcelRequire("e34gT")).getCommandPaletteIssueActionsHeader)(issueKey),
                priority: (0, (0, parcelRequire("7C5Su")).getCommandPaletteIssueActionsPriority)('STATUS'),
                components: {
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("imUQY"))))), {
                            label: ""
                        })
                },
                primaryAction: {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST,
                    fallback: {
                        onNoResults: {
                            label: formatMessage((0, (0, parcelRequire("iokLh")).messages).fallbackNoResults)
                        }
                    },
                    components: {
                        Header: renderHeader
                    },
                    commands: commands
                },
                analytics: {
                    action: 'changeStatusMenu'
                }
            };
            const unsubscribe = subscribeCommands((0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
                statusCommand
            ]);
            return ()=>unsubscribe();
        }, [
            formatMessage,
            getKeywords,
            issueKey,
            loadTransitions,
            renderHeader,
            subscribeCommands,
            expandedCommand?.id
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && onFetch) onFetch(createAnalyticsEvent({}));
        }, [
            isOpen,
            onFetch,
            createAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && expandedCommandId === (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774)) setChildCommands(loadTransitions());
        }, [
            expandedCommandId,
            isOpen,
            loadTransitions,
            setChildCommands
        ]);
        return null;
    };
    const $95d268cd8622d793$export$d907a4132fe8618c = (0, (0, parcelRequire("cSD7y")).componentWithFG)('command_palette_improve_status', $95d268cd8622d793$export$679497264cbfbf73, $95d268cd8622d793$export$3d254fd4c446ee4);
    const $95d268cd8622d793$var$TransitionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _18u01b66 _4t3i1tcg _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $95d268cd8622d793$var$SelectedStatusContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $95d268cd8622d793$var$CurrentStatusContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1a45",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("imUQY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d5f661f66d7a7026$var$_react = $d5f661f66d7a7026$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d5f661f66d7a7026$var$_task = $d5f661f66d7a7026$var$_interopRequireDefault((parcelRequire("4xPlE")));
    function $d5f661f66d7a7026$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d5f661f66d7a7026$var$TaskIcon = (props)=>$d5f661f66d7a7026$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 20.007zM5 5v14h14V5z"/><path fill-rule="nonzero" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $d5f661f66d7a7026$var$_task.default
        }));
    $d5f661f66d7a7026$var$TaskIcon.displayName = 'TaskIcon';
    var $d5f661f66d7a7026$var$_default = module.exports.default = $d5f661f66d7a7026$var$TaskIcon;
});
parcelRegister("4xPlE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $34f2132ab88342e6$var$_react = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $34f2132ab88342e6$var$_UNSAFE_baseNew = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $34f2132ab88342e6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $34f2132ab88342e6$var$TaskIcon = (props)=>$34f2132ab88342e6$var$_react.default.createElement($34f2132ab88342e6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M3 14.25h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $34f2132ab88342e6$var$TaskIcon.displayName = 'TaskIcon';
    var $34f2132ab88342e6$var$_default = module.exports.default = $34f2132ab88342e6$var$TaskIcon;
});
parcelRegister("5p1kJ", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", ()=>$7691773a5eed3db6$export$16b06d29ef8f802b);
    $parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", ()=>$7691773a5eed3db6$export$156ebd2354e25466);
    $parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", ()=>$7691773a5eed3db6$export$7fe859528e87e623);
    $parcel$export(module.exports, "COMMAND_PALETTE_ID", ()=>$7691773a5eed3db6$export$9f646ab88e1d2b14);
    $parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", ()=>$7691773a5eed3db6$export$abf26cc5daebd2c8);
    $parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", ()=>$7691773a5eed3db6$export$12514ca8899b0521);
    $parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", ()=>$7691773a5eed3db6$export$5fa0bcf59f933c21);
    $parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", ()=>$7691773a5eed3db6$export$7d9743be0b7d862f);
    $parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", ()=>$7691773a5eed3db6$export$b4e1633c86db2b70);
    $parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", ()=>$7691773a5eed3db6$export$5e5a87aac5d9771f);
    var $7691773a5eed3db6$export$16b06d29ef8f802b;
    (function(COMMAND_PALETTE_SECTIONS) {
        COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
        COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
        COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
        COMMAND_PALETTE_SECTIONS["help"] = "help";
        COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
        COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
        COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
        COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    })($7691773a5eed3db6$export$16b06d29ef8f802b || ($7691773a5eed3db6$export$16b06d29ef8f802b = {}));
    const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
    const $7691773a5eed3db6$export$7fe859528e87e623 = {
        action: 'pressed',
        actionSubject: 'commandPaletteKeyboardShortcut'
    };
    const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
    var $7691773a5eed3db6$export$abf26cc5daebd2c8;
    (function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
        COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    })($7691773a5eed3db6$export$abf26cc5daebd2c8 || ($7691773a5eed3db6$export$abf26cc5daebd2c8 = {}));
    var $7691773a5eed3db6$export$12514ca8899b0521;
    (function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
        COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    })($7691773a5eed3db6$export$12514ca8899b0521 || ($7691773a5eed3db6$export$12514ca8899b0521 = {}));
    var $7691773a5eed3db6$export$5fa0bcf59f933c21;
    (function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
        COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
        COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    })($7691773a5eed3db6$export$5fa0bcf59f933c21 || ($7691773a5eed3db6$export$5fa0bcf59f933c21 = {}));
    var $7691773a5eed3db6$export$7d9743be0b7d862f;
    (function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
        COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    })($7691773a5eed3db6$export$7d9743be0b7d862f || ($7691773a5eed3db6$export$7d9743be0b7d862f = {}));
    var $7691773a5eed3db6$export$b4e1633c86db2b70;
    (function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
        COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    })($7691773a5eed3db6$export$b4e1633c86db2b70 || ($7691773a5eed3db6$export$b4e1633c86db2b70 = {}));
    var $7691773a5eed3db6$export$5e5a87aac5d9771f;
    (function(COMMAND_PALETTE_HELP_PRIORITY) {
        COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
        COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    })($7691773a5eed3db6$export$5e5a87aac5d9771f || ($7691773a5eed3db6$export$5e5a87aac5d9771f = {}));
});
parcelRegister("7C5Su", function(module, exports) {
    $parcel$export(module.exports, "getCommandPaletteIssueActionsPriority", ()=>$235d212bb3595e05$export$5164bb42fa883371);
    const $235d212bb3595e05$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY = {
        STATUS: 10,
        SUMMARY: 20,
        PARENT: 30,
        LINK_ISSUE: 40,
        CONTENT_FIRST_TAB: 50,
        PINNED_FIELDS: 60,
        DETAILS: 70,
        CONTENT_OTHER_TABS: 80,
        MORE_FIELDS: 90,
        OLD_ISSUE_FIELDS: 95,
        ADD_COMMENT: 100,
        GQL_FIELDS: 105,
        SUB_HEADER_ITEMS: 110,
        ISSUE_HEADER_ITEMS: 120
    };
    const $235d212bb3595e05$export$5164bb42fa883371 = (key)=>$235d212bb3595e05$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY[key];
});
parcelRegister("e34gT", function(module, exports) {
    $parcel$export(module.exports, "getCommandPaletteIssueActionsHeader", ()=>$4ea99408c4a58cd0$export$cd9931655a8cfb04);
    var $5p1kJ;
    const $4ea99408c4a58cd0$export$cd9931655a8cfb04 = (issueKey)=>`${0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;
});
parcelRegister("eG9rp", function(module, exports) {
    $parcel$export(module.exports, "useCommandKeywords", ()=>$61ebfb9239c4f8e5$export$4d8fe3ef6385358);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dYWZb;
    const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, (0, parcelRequire("dYWZb")).messages)[keywordGroup] ? formatMessage((0, (0, parcelRequire("dYWZb")).messages)[keywordGroup]) : undefined, [
            formatMessage
        ]);
        return {
            getKeywords: getKeywords
        };
    };
});
parcelRegister("dYWZb", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$df7d7dd7b88156b7$export$defe85febe8b728c);
    var $7VHMR;
    const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchYourIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
            "defaultMessage": "Find my ideas tickets requests tasks work"
        },
        changeStatusSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
            "defaultMessage": "Move through workflow  Progress Done Complete transition"
        },
        assignToMeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
            "defaultMessage": "self"
        },
        assignIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
            "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
        },
        startWatchingIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
            "defaultMessage": "Follow work Track Unwatch Unfollow"
        },
        backlogSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
            "defaultMessage": "Inventory Go"
        },
        boardSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
            "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
        },
        reportsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
            "defaultMessage": "Summary Insights Burndown Go"
        },
        timelineSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
            "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
        },
        quickSearchSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
            "defaultMessage": "Search products across Atlassian Go to"
        },
        pageSearchSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
            "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
        },
        createIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
            "defaultMessage": "work Start idea New ticket task"
        },
        switchDarkThemeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
            "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
        },
        matchSystemThemeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
            "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
        },
        copyCurrentPageUrlSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
            "defaultMessage": "link website address"
        },
        getHelpSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
            "defaultMessage": "In-product Support Documentation Questions Answers"
        },
        viewKeyboardShortcutsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
            "defaultMessage": "Hotkeys Show See"
        },
        editDescriptionSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
            "defaultMessage": "Completion criteria Info Information Details Add Write"
        },
        addAttachmentSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
            "defaultMessage": "Attach Upload Document Media"
        },
        addCommentSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
            "defaultMessage": "Write Message"
        },
        logWorkSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
            "defaultMessage": "Track Record hours Time spent"
        },
        addRemoveFlagSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
            "defaultMessage": "Unflag Mark Unmark Star Unstar"
        },
        cloneIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
            "defaultMessage": "Copy Duplicate Task Idea Request"
        },
        linkConfluencePageSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
            "defaultMessage": "Relate Add Connect"
        },
        addAUrlSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
            "defaultMessage": "Connect Weblink Link Website Domain"
        },
        goToIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
            "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
        },
        goToPersonalSettingsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
            "defaultMessage": "Preferences Notifications Theme Jira labs"
        },
        goToAccountSettingsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
            "defaultMessage": "Preferences Privacy Profile Your details Personal information"
        },
        viewAllIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
            "defaultMessage": "Site issues JQL View all"
        },
        viewAllProjectsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllPlansSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllBoardsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllFiltersSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllDashboardsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
            "defaultMessage": "List Go"
        },
        checkNotificationsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
            "defaultMessage": "window See Updates"
        },
        goToUserManagementSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
            "defaultMessage": "Permissions"
        }
    });
});
parcelRegister("6NI23", function(module, exports) {
    $parcel$export(module.exports, "CommandFieldHeader", ()=>$aaa7a329c29139ae$export$c6444eb1c6f44b2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $luBm6;
    var $jiSaf;
    var $2w83X;
    const $aaa7a329c29139ae$export$c6444eb1c6f44b2d = ({ children: children, issueKey: issueKey })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jiSaf")).components).Header, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2w83X")).IssueTag), {
            issueKey: issueKey
        }), children));
});
parcelRegister("jiSaf", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$44cb4d9bf5d8b8a6$export$9b5ac10f59f76296);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $dOktC;
    var $haBRL;
    var $dE25F;
    var $d4iCz;
    const $44cb4d9bf5d8b8a6$var$NameComponent = ({ children: children, ...rest })=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('fix_compal_name_wrapper')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), rest, children);
    };
    const $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296 = {
        CommandRow: (0, parcelRequire("haBRL")).CommandRow,
        Name: $44cb4d9bf5d8b8a6$var$NameComponent,
        LeftIcon: (0, $5uXOq.Fragment),
        Wrapper: (0, $5uXOq.Fragment),
        Footer: (0, parcelRequire("dE25F")).Footer,
        Body: (0, (0, parcelRequire("dOktC")).CommandPaletteBody),
        Header: (0, parcelRequire("d4iCz")).Header
    };
});
parcelRegister("dOktC", function(module, exports) {
    $parcel$export(module.exports, "NoResultsContainer", ()=>$2bc4c9970ded9a96$export$2ab569a6937cb4e4);
    $parcel$export(module.exports, "CommandPaletteBody", ()=>$2bc4c9970ded9a96$export$b1023de69a8756e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $2NMNM;
    var $4R6GH;
    var $d8lE2;
    var $gM5ou;
    var $bYCTm;
    var $38IFv;
    var $cLshs;
    var $4nfzy;
    var $eKTyH;
    var $5aF2z;
    var $64ZBB;
    const $2bc4c9970ded9a96$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const onHoverCommand = (index)=>{
            if (index === undefined) return;
            setActiveIndex(index);
        };
        const onMouseDownCommand = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const onClickCommand = (0, $5uXOq.useCallback)((event, result)=>{
            executeCommand(result.command, {
                method: 'mouse',
                createAnalyticsEvent: createAnalyticsEvent,
                attributes: {
                    ...(0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromResult)(result),
                    ...(0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, result?.command.id)
                }
            }, (0, (0, parcelRequire("gM5ou")).isSecondaryTrigger)(event));
        }, [
            activeRegistry,
            createAnalyticsEvent,
            executeCommand,
            registry
        ]);
        const localResultRefs = resultsRefs.current;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !loadingList && noResultsFallback && (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$export$2ab569a6937cb4e4, {
            "data-testid": (0, (0, parcelRequire("5aF2z")).NO_RESULTS_TEST_ID)
        }, noResultsFallback), results.map((result, index)=>{
            if (result.isGroup) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bYCTm")).CommandPaletteSearchResultGroupItem), {
                ref: (commandRef)=>{
                    if (commandRef) localResultRefs[index] = commandRef;
                },
                group: result.group,
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$GroupContainerComponent, {
                "data-testid": (0, (0, parcelRequire("5aF2z")).GROUP_TEST_ID),
                isFirstResult: index === 0
            }, result.renderGroup ? result.renderGroup() : result.group));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4nfzy")).CommandRowErrorBoundary), {
                key: index,
                teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
                onError: ()=>removeCommandsById([
                        result.command.id
                    ]),
                attributes: (0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, result?.command.id)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38IFv")).CommandPaletteSearchResultListItem), {
                ref: (commandRef)=>{
                    if (commandRef) localResultRefs[index] = commandRef;
                },
                id: result.command.id,
                active: result.active,
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eKTyH")).CommandRow), {
                index: index,
                isSearchFieldFocused: isSearchFieldFocused,
                result: result,
                onHoverCommand: (ev)=>{
                    if (ev.movementX === 0 && ev.movementY === 0) return;
                    onHoverCommand(result.index);
                },
                onClickCommand: (event)=>onClickCommand(event, result),
                onMouseDownCommand: onMouseDownCommand
            })));
        }), renderAfterCommands?.({}));
    };
    const $2bc4c9970ded9a96$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
        const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const [prevActiveIndex, setPrevActiveIndex] = (0, $5uXOq.useState)(activeIndex);
        const resultsRefs = (0, $5uXOq.useRef)([]);
        const modalBodyRef = (0, $5uXOq.useRef)(null);
        const onArrowScroll = (0, $5uXOq.useCallback)((newActiveIndex)=>{
            setActiveIndex(newActiveIndex);
        }, [
            setActiveIndex
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
            setPrevActiveIndex(activeIndex);
            const scrollTo = activeIndex > prevActiveIndex ? (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END : (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).START;
            const scrollToIndex = (0, (0, parcelRequire("64ZBB")).getScrollToIndex)(results, activeIndex, scrollTo);
            const scrolledToResult = resultsRefs.current[scrollToIndex];
            if (scrolledToResult && !(0, (0, parcelRequire("64ZBB")).isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
                const lastIndex = results.length - 1;
                const firstIndex = results.findIndex((result)=>!result.isGroup);
                if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
                else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
                else {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('compal_smooth_transition_on_size_change')) {
                        (0, (0, parcelRequire("64ZBB")).scrollResultIntoView)({
                            target: scrolledToResult,
                            direction: scrollTo,
                            scrollContainer: modalBodyRef.current
                        });
                        return;
                    }
                    (0, (0, parcelRequire("64ZBB")).scrollResultIntoViewOld)(scrolledToResult, scrollTo);
                }
            }
        }, [
            activeIndex,
            prevActiveIndex,
            results
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!modalBodyRef.current?.scrollTo) return;
            modalBodyRef.current.scrollTo(0, 0);
        }, [
            expandedCommand,
            search
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isSearchFieldFocused) return ()=>{};
            const handleArrowScroll = (ev)=>{
                if (ev.key === 'ArrowUp') {
                    ev.preventDefault();
                    activeIndex > 0 && onArrowScroll(activeIndex - 1);
                }
                if (ev.key === 'ArrowDown') {
                    ev.preventDefault();
                    activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
                }
            };
            window.addEventListener('keydown', handleArrowScroll);
            return ()=>{
                window.removeEventListener('keydown', handleArrowScroll);
            };
        }, [
            isSearchFieldFocused,
            total,
            activeIndex,
            setActiveIndex,
            onArrowScroll
        ]);
        const noResultsFallback = (0, $5uXOq.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
            fallback
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cLshs")).CommandPaletteSearchResultListWrapper), {
            ref: modalBodyRef,
            ...(0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes') && {
                noResultsFallback: noResultsFallback
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$CommandPaletteChildren, {
            results: results,
            noResultsFallback: noResultsFallback,
            renderAfterCommands: renderAfterCommands,
            resultsRefs: resultsRefs
        }));
    };
    const $2bc4c9970ded9a96$var$GroupContainerComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_h2xaw7": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _vwz41kw7 _syaz1wmz _1yt41f6d",
                __cmplp.className
            ])
        });
    });
    const $2bc4c9970ded9a96$export$2ab569a6937cb4e4 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1h6o _syaz1e9r _1yt4wd81",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("d8lE2", function(module, exports) {
    $parcel$export(module.exports, "useCommandPalette", ()=>$f75514d959bfcca8$export$6b58f9610017fbb7);
    $parcel$export(module.exports, "useActionsCommandPalette", ()=>$f75514d959bfcca8$export$72aa7bc7c6a83c36);
    $parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", ()=>$f75514d959bfcca8$export$1f90c8f89f98110e);
    $parcel$export(module.exports, "useCommandPaletteIsOpen", ()=>$f75514d959bfcca8$export$cc979be9b69236df);
    $parcel$export(module.exports, "useCommandPaletteHasChildPopup", ()=>$f75514d959bfcca8$export$a18633b655403b12);
    $parcel$export(module.exports, "useCommandPaletteIsLoaded", ()=>$f75514d959bfcca8$export$af8fd8cd4b048315);
    $parcel$export(module.exports, "useCommandPaletteSessionId", ()=>$f75514d959bfcca8$export$7422170a403e909);
    $parcel$export(module.exports, "useCommandPaletteExpandedCommand", ()=>$f75514d959bfcca8$export$282aa48e4a3afada);
    $parcel$export(module.exports, "useCommandPaletteSearch", ()=>$f75514d959bfcca8$export$96819dfb22ad05d3);
    $parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", ()=>$f75514d959bfcca8$export$f893891deedab3c6);
    $parcel$export(module.exports, "useCommandPaletteUsePerformModeState", ()=>$f75514d959bfcca8$export$bbc05723eb144e03);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $gM5ou;
    var $2sRNe;
    const $f75514d959bfcca8$var$initialState = {
        commandPaletteSessionId: '',
        isOpen: false,
        isLoaded: false,
        search: '',
        activeIndex: 0,
        isSearchFieldFocused: false,
        commands: [],
        parentCommand: [],
        sections: [],
        isDisabled: false,
        registry: {},
        activeRegistry: {
            commandRegistry: {},
            registryIds: []
        },
        onClosePendingCommandAction: undefined,
        isLoadChildrenError: false
    };
    const $f75514d959bfcca8$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $f75514d959bfcca8$var$initialState,
        actions: (0, parcelRequire("2sRNe")).actions,
        name: 'commandPalette'
    });
    const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store);
    const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($f75514d959bfcca8$var$store);
    const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
            const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
                ...props,
                commandPalette: commandPalette
            });
        };
    const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
            wordCount: (0, (0, parcelRequire("gM5ou")).getWordCount)(search),
            queryLength: search.length,
            queryHash: (0, (0, parcelRequire("gM5ou")).getQueryHash)(search),
            commandPaletteSessionId: commandPaletteSessionId,
            cpMenu: expandedCommand?.id || 'rootMenu',
            ...(0, (0, parcelRequire("gM5ou")).getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
            activeRegistryIds: activeRegistry.registryIds,
            activeRegistryIdsLength: activeRegistry.registryIds.length,
            activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
            relevancyModel: 'v2-string-similarity'
        });
    const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: $f75514d959bfcca8$export$56f06313122d0aac
    });
    const $f75514d959bfcca8$export$cc979be9b69236df = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isOpen: isOpen })=>({
                isOpen: isOpen
            })
    });
    const $f75514d959bfcca8$export$a18633b655403b12 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($f75514d959bfcca8$var$store, {
        selector: (state)=>state.hasPopupOverlay
    });
    const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isLoaded: isLoaded })=>({
                isLoaded: isLoaded
            })
    });
    const $f75514d959bfcca8$export$4372697329bd9cbe = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ isDisabled: isDisabled })=>({
                isDisabled: isDisabled
            })
    });
    const $f75514d959bfcca8$export$7422170a403e909 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
                commandPaletteSessionId: commandPaletteSessionId
            })
    });
    const $f75514d959bfcca8$export$282aa48e4a3afada = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
                expandedCommand: expandedCommand,
                isOpen: isOpen
            })
    });
    const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ search: search })=>({
                search: search
            })
    });
    const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, (0, parcelRequire("6dDSs")).createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
            registry: registry,
            activeRegistry: activeRegistry,
            expandedCommand: expandedCommand
        }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
        if (!expandedCommand) return undefined;
        const registryData = (0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, expandedCommand.id);
        return {
            registryData: registryData,
            analyticsAttributes: registryData
        };
    });
    const $f75514d959bfcca8$export$f893891deedab3c6 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
    });
    const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, (0, parcelRequire("3sQ5x")).createHook)($f75514d959bfcca8$var$store, {
        selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
                commands: commands,
                search: search,
                expandedCommand: expandedCommand,
                childResult: childResult,
                registry: registry,
                activeRegistry: activeRegistry
            })
    });
});
parcelRegister("gM5ou", function(module, exports) {
    $parcel$export(module.exports, "getRegistryData", ()=>$cf289af0c139712c$export$6a1ed481c04a3ae6);
    $parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", ()=>$cf289af0c139712c$export$eb055284806da6e5);
    $parcel$export(module.exports, "getShortcutSpecialCharacters", ()=>$cf289af0c139712c$export$e6994b845b967732);
    $parcel$export(module.exports, "removeShortcutSpecialCharacters", ()=>$cf289af0c139712c$export$cd2a5827eae5f4cf);
    $parcel$export(module.exports, "mergeSections", ()=>$cf289af0c139712c$export$389b0273703d5c48);
    $parcel$export(module.exports, "mergeChildResults", ()=>$cf289af0c139712c$export$60a91e1b94ab4fef);
    $parcel$export(module.exports, "getAnalyticsAttributesFromState", ()=>$cf289af0c139712c$export$4023cd53e5e5fcb8);
    $parcel$export(module.exports, "isSecondaryTrigger", ()=>$cf289af0c139712c$export$daa5beabdf8d9fc3);
    $parcel$export(module.exports, "hasChildren", ()=>$cf289af0c139712c$export$bd5ff50f0e53d41c);
    $parcel$export(module.exports, "getAnalyticsAttributesFromResult", ()=>$cf289af0c139712c$export$bc9cd28438b3ea4b);
    $parcel$export(module.exports, "getQueryHash", ()=>$cf289af0c139712c$export$fa1c95a5ffa92036);
    $parcel$export(module.exports, "getWordCount", ()=>$cf289af0c139712c$export$dba3e2bcdbd49da4);
    $parcel$export(module.exports, "getCommandAction", ()=>$cf289af0c139712c$export$fb6dafa07e60c21a);
    $parcel$export(module.exports, "hasAction", ()=>$cf289af0c139712c$export$e217e69099d082f5);
    $parcel$export(module.exports, "useSetTimeoutAutoClear", ()=>$cf289af0c139712c$export$c3d20e8c1e93a572);
    var $5uXOq = parcelRequire("5uXOq");
    var $bdDiz = parcelRequire("bdDiz");
    var $2f2jJ;
    var $bcTvL;
    var $jh7L9;
    const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
        if (!commandId) return undefined;
        const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
        const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
        return registryData;
    };
    const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
    const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
        const parentCommandIds = parentCommands?.map((command)=>command.id);
        while(parentCommandIds?.length){
            const nextParentCommandId = parentCommandIds?.pop();
            const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
            if (registryData) return registryData;
        }
        return undefined;
    };
    const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
            {
                char: ' ',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN
            },
            {
                char: '+',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).PLUS
            },
            {
                char: '|',
                replacement: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR
            }
        ];
    const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
        const specialChars = $cf289af0c139712c$export$e6994b845b967732();
        let strippedShortcut = shortcut;
        specialChars.forEach(({ char: char })=>{
            strippedShortcut = strippedShortcut.split(char).join('');
        });
        return strippedShortcut.toLowerCase();
    };
    const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
            Object.entries(curr).forEach(([key, entry])=>{
                acc[key] = entry;
            });
            return acc;
        }, {});
    const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
        const commands = [];
        const sections = [];
        childResults.forEach((childResult)=>{
            commands.push(...childResult.commands);
            if (childResult.sections) sections.push(childResult.sections);
        });
        return {
            commands: commands,
            sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
        };
    };
    const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
        const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
        const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
        const regex = new RegExp(regexString, 'g');
        return text.replace(/[.,]/g, '').replace(regex, '').replace(/\s{2,}/g, ' ').trim();
    };
    const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
        const analyticsAttributes = {
            commandPaletteId: command.id,
            commandPaletteSessionId: state.commandPaletteSessionId,
            searchTaken: !!state.search,
            method: method,
            cpMenu: 'rootMenu',
            action: command.id,
            actionCategory: 'none',
            wasSecondaryTriggered: wasSecondaryTriggered,
            ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
            ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
            ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
            ...attributes,
            ...!!command.analytics && command.analytics
        };
        if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
        else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
        const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
            ...state.sections,
            state.childResult?.sections
        ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
        const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
        const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
        analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
        return analyticsAttributes;
    };
    const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, (0, parcelRequire("2f2jJ")).isMacOs)() ? event.metaKey : event.ctrlKey;
    const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
        if (command?.wasSecondaryTriggered) {
            if (command?.secondaryAction?.type) {
                const hasSecondaryChildren = (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
                return hasSecondaryChildren;
            }
            return (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
        }
        return (0, (0, parcelRequire("jh7L9")).COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    };
    const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
        if (result) return {
            globalIndex: result.index,
            sectionIndex: result.sectionIndex,
            indexWithinSection: result.indexWithinSection,
            sectionId: result.sectionId
        };
        return {};
    };
    const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
    const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
    const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
        if (!command) return null;
        const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
        if (!primaryAction) return null;
        const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
        return {
            ...commandAction
        };
    };
    const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
    const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
        const timeoutRef = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>()=>{
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
            }, []);
        const setTimeoutAutoClear = (...args)=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(...args);
        };
        return {
            setTimeoutAutoClear: setTimeoutAutoClear
        };
    };
});
parcelRegister("2f2jJ", function(module, exports) {
    $parcel$export(module.exports, "isMacOs", ()=>$6846128323867ebd$export$c5e71f489eb3970b);
    $parcel$export(module.exports, "getShortcutModifierKey", ()=>$6846128323867ebd$export$fe66dae91c68619b);
    const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
    const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';
});
parcelRegister("bcTvL", function(module, exports) {
    $parcel$export(module.exports, "UI_EVENT_TYPE", ()=>$3996a4302dca83b1$export$a1562d08625f5d7e);
    $parcel$export(module.exports, "TRACK_EVENT_TYPE", ()=>$3996a4302dca83b1$export$947dac6c72b26f81);
    $parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", ()=>$3996a4302dca83b1$export$1ee9d153576afd13);
    $parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", ()=>$3996a4302dca83b1$export$894e19fc96687503);
    const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
    const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
    const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
    const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
    var $3996a4302dca83b1$export$1ee9d153576afd13;
    (function(SHORTCUT_ELEMENT_TYPES) {
        SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
        SHORTCUT_ELEMENT_TYPES["OR"] = "or";
        SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
        SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    })($3996a4302dca83b1$export$1ee9d153576afd13 || ($3996a4302dca83b1$export$1ee9d153576afd13 = {}));
    const $3996a4302dca83b1$export$894e19fc96687503 = 250;
});
parcelRegister("jh7L9", function(module, exports) {
    $parcel$export(module.exports, "CommandActionType", ()=>$b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
    $parcel$export(module.exports, "COMMAND_WITH_CHILDREN", ()=>$b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
    var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f;
    (function(CommandActionType) {
        CommandActionType["PERFORM"] = "perform";
        CommandActionType["COMMAND_LIST"] = "command-list";
    })($b1e48ebd4c8d5e4e$export$f041b1b117ab382f || ($b1e48ebd4c8d5e4e$export$f041b1b117ab382f = {}));
    const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
    const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
        "command-list"
    ];
});
parcelRegister("2sRNe", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$4f4c9e92d50d4f24$export$e324594224ef24da);
    var $kGsr8 = parcelRequire("kGsr8");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $e7WVN;
    var $eTXmK;
    var $2f2jJ;
    var $jcw0u;
    var $bcTvL;
    var $jh7L9;
    var $gM5ou;
    var $4DwnT;
    var $h3eZO;
    const $4f4c9e92d50d4f24$var$rootCommands = {
        parentCommand: [],
        expandedCommand: undefined,
        childCommands: undefined,
        childResult: undefined
    };
    const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
            if (getState().isDisabled) return;
            setState({
                commandPaletteSessionId: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                isOpen: true,
                activeIndex: 0,
                search: ''
            });
        };
    const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
            setState({
                isOpen: false,
                commandPaletteSessionId: '',
                search: '',
                ...$4f4c9e92d50d4f24$var$rootCommands
            });
        };
    const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
            const isOpen = !getState().isOpen;
            setState({
                isOpen: isOpen,
                activeIndex: 0,
                search: '',
                commandPaletteSessionId: isOpen ? (0, ($parcel$interopDefault($7Jxgt))).v4() : '',
                ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
            });
        };
    const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newCommands = currentState.commands.concat(commands);
            const newState = {
                commands: newCommands
            };
            if (currentState.expandedCommand) {
                const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
                if (matchedExpandedCommand.length === 1) {
                    const [updatedExpandedCommand] = matchedExpandedCommand;
                    newState.expandedCommand = updatedExpandedCommand;
                }
            }
            setState(newState);
        };
    const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
            const newCommands = getState().commands.filter((command)=>!commands.includes(command));
            setState({
                commands: newCommands
            });
        };
    const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
            const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
            setState({
                commands: newCommands
            });
        };
    const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
            setState({
                search: search,
                activeIndex: 0
            });
        };
    const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
            setState({
                search: search,
                shouldForceSearchValue: true
            });
        };
    const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
            setState({
                shouldForceSearchValue: false
            });
        };
    const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (!currentState.expandedCommand) return;
            const newState = {
                search: '',
                activeIndex: 0,
                childResult: undefined,
                forceSearchFocus: true
            };
            if (currentState.parentCommand.length && !goToRoot) {
                newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
                newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
                if (newState.expandedCommand?.primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                    commands: newState.expandedCommand?.primaryAction?.commands,
                    sections: newState.expandedCommand?.primaryAction?.sections
                };
            } else {
                newState.loadingList = false;
                newState.parentCommand = [];
                newState.expandedCommand = undefined;
                newState.childResult = undefined;
            }
            if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            }), (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                attributes: {
                    cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                    searchSessionId: currentState.commandPaletteSessionId,
                    action: goToRoot ? 'backToRoot' : 'backToParent',
                    actionCategory: 'back',
                    method: analytics?.method
                }
            });
            setState(newState);
        };
    const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
            setState({
                forceSearchFocus: forceSearchFocus
            });
        };
    const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
            const { isSearchFieldFocused: isSearchFieldFocused } = getState();
            setState({
                activeIndex: index,
                ...!isSearchFieldFocused ? {
                    forceSearchFocus: true
                } : {}
            });
        };
    const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
    const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
            setTimeout(()=>{
                const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
                if (onClosePendingCommandAction !== undefined) {
                    try {
                        (0, (0, parcelRequire("eTXmK")).default)('command-palette-executed');
                        onClosePendingCommandAction.perform();
                        if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                            const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                                action: 'taskSucceeded',
                                actionSubject: 'commandPalette'
                            });
                            onAnalytics(performAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                                attributes: onClosePendingCommandAction?.analyticsArgs
                            });
                        }
                    } catch (err) {
                        const error = err instanceof Error ? err : new Error('Command palette perform error');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: 'compal.performDialogCloseCommand',
                                packageName: 'jiraCommandPalette',
                                teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                            },
                            attributes: onClosePendingCommandAction.analyticsArgs
                        });
                        (0, (0, parcelRequire("e7WVN")).setInteractionError)('command-palette-executed', {
                            errorMessage: error.message,
                            name: 'performDialogCloseCommandPerformError'
                        });
                    }
                    setState({
                        onClosePendingCommandAction: undefined
                    });
                }
            }, 0);
        };
    const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newState = {
                ...!(0, (0, parcelRequire("4DwnT")).getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                    search: ''
                },
                activeIndex: 0
            };
            const analyticsAttributes = (0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
            const currentCommandAction = (0, (0, parcelRequire("gM5ou")).getCommandAction)(command, wasSecondaryTriggered);
            if (!currentCommandAction) return;
            if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
                const analyticsEvent = analytics.createAnalyticsEvent({
                    action: 'navigation',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(analyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                    attributes: analyticsAttributes
                });
            }
            const shouldLoadChildren = (0, (0, parcelRequire("gM5ou")).hasChildren)({
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            });
            const shouldExecutePerform = currentCommandAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM;
            if (shouldLoadChildren) {
                (0, (0, parcelRequire("eTXmK")).default)('command-palette-load-child-command-list');
                if (currentState.expandedCommand) newState.parentCommand = [
                    ...currentState.parentCommand,
                    currentState.expandedCommand
                ];
                newState.expandedCommand = {
                    ...command,
                    wasSecondaryTriggered: wasSecondaryTriggered
                };
                newState.childResult = undefined;
                newState.forceSearchFocus = true;
                if ((0, (0, parcelRequire("h3eZO")).isSearchableChildrenAction)(currentCommandAction)) {
                    newState.childResult = {
                        commands: currentCommandAction.commands,
                        sections: currentCommandAction.sections
                    };
                    if (command.parentCommands?.length) newState.parentCommand = [
                        ...newState.parentCommand || [],
                        ...command.parentCommands
                    ];
                } else newState.childResult = undefined;
                setState(newState);
                if (currentCommandAction.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
            } else if (shouldExecutePerform) {
                if (!currentCommandAction.preventModalClose) {
                    newState.commandPaletteSessionId = '';
                    newState.isOpen = false;
                    newState.expandedCommand = undefined;
                    newState.parentCommand = [];
                    newState.childResult = undefined;
                    setState(newState);
                    if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                        const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                            action: 'closed',
                            actionSubject: 'commandPalette'
                        });
                        currentState.onAnalytics(closeAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).UI_EVENT_TYPE), {
                            attributes: analyticsAttributes
                        });
                    }
                }
                if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'secondaryAction',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                        attributes: {
                            ...analyticsAttributes,
                            keyPressed: (0, (0, parcelRequire("2f2jJ")).isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                            ...currentCommandAction.analyticsArgs
                        }
                    });
                }
                if (currentCommandAction.preventModalClose) try {
                    (0, (0, parcelRequire("eTXmK")).default)('command-palette-executed');
                    currentCommandAction.perform();
                    if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                        const performAnalyticsEvent = analytics.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        currentState.onAnalytics(performAnalyticsEvent, (0, (0, parcelRequire("bcTvL")).TRACK_EVENT_TYPE), {
                            attributes: analyticsAttributes
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'compal.executeCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                        },
                        attributes: analytics?.attributes
                    });
                    (0, (0, parcelRequire("e7WVN")).setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'executeCommandPerformError'
                    });
                }
                else setState({
                    onClosePendingCommandAction: {
                        ...currentCommandAction,
                        analyticsArgs: analyticsAttributes,
                        createAnalyticsEvent: analytics?.createAnalyticsEvent
                    }
                });
            }
        };
    const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
            setState({
                childResult: childResult
            });
        };
    const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
            setState({
                loadingList: loadingList
            });
        };
    const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
                isSearchFieldFocused: isSearchFieldFocused
            });
    const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const sections = currentState.sections.slice(0);
            sections.push(newSections);
            setState({
                sections: sections
            });
        };
    const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const sections = currentState.sections.filter((section)=>section !== newSections);
            setState({
                sections: sections
            });
        };
    const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
            setState({
                isLoaded: true
            });
        };
    const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
            setState({
                isDisabled: isDisabled,
                ...isDisabled ? {
                    isOpen: false
                } : {}
            });
        };
    const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
            setState({
                registry: registry
            });
        };
    const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
            const currentActiveRegistry = getState().activeRegistry;
            const activeRegistry = {
                commandRegistry: {
                    ...currentActiveRegistry.commandRegistry,
                    ...commands.reduce((acc, command)=>{
                        acc[command.id] = {
                            registryId: registryId
                        };
                        return acc;
                    }, {})
                },
                registryIds: (0, ($parcel$interopDefault($kGsr8)))([
                    ...currentActiveRegistry.registryIds,
                    registryId
                ])
            };
            setState({
                activeRegistry: activeRegistry
            });
        };
    const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
            const currentActiveRegistry = getState().activeRegistry;
            const commandRegistry = {
                ...currentActiveRegistry.commandRegistry
            };
            commands.forEach((command)=>{
                delete commandRegistry[command.id];
            });
            setState({
                activeRegistry: {
                    commandRegistry: commandRegistry,
                    registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
                }
            });
        };
    const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
            setState({
                onAnalytics: onAnalytics,
                onErrorAnalytics: onErrorAnalytics
            });
        };
    const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
            setState({
                fallbackOverride: fallbackOverride
            });
        };
    const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
            setState({
                hasPopupOverlay: hasPopupOverlay
            });
        };
    const $4f4c9e92d50d4f24$export$e324594224ef24da = {
        open: $4f4c9e92d50d4f24$var$open,
        toggle: $4f4c9e92d50d4f24$var$toggle,
        close: $4f4c9e92d50d4f24$var$close,
        addCommands: $4f4c9e92d50d4f24$var$addCommands,
        removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
        handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
        forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
        setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
        executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
        goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
        setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
        setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
        setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
        registerSections: $4f4c9e92d50d4f24$var$registerSections,
        unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
        markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
        getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
        setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
        setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
        updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
        removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
        removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
        performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
        setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
        setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
        setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
        forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
        resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
    };
});
parcelRegister("4DwnT", function(module, exports) {
    $parcel$export(module.exports, "getActiveCommandList", ()=>$b4088022dc3f5c54$export$639b7f41b0b47a01);
    var $jh7L9;
    const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
        if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
        if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
        return null;
    };
});
parcelRegister("h3eZO", function(module, exports) {
    $parcel$export(module.exports, "isSearchableChildrenAction", ()=>$dd5db8363c7eeda7$export$d75616d77443fe4e);
    var $jh7L9;
    const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST && action.commands !== undefined;
});
parcelRegister("bYCTm", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", ()=>$85a6ab23a77e1ea6$export$591c26128e5fd757);
    var $5uXOq = parcelRequire("5uXOq");
    const $85a6ab23a77e1ea6$export$591c26128e5fd757 = (0, $5uXOq.forwardRef)(({ group: group, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
            id: group ? `${0, $2350562822a34d03$export$9ed1834ff36a8f29}-${group}` : undefined,
            ...rest
        }));
});
const $2350562822a34d03$export$9ffb4923f81813d9 = 'compal-menu';
const $2350562822a34d03$export$b28d6b416aaf953a = `${$2350562822a34d03$export$9ffb4923f81813d9}-item`;
const $2350562822a34d03$export$9ed1834ff36a8f29 = `${$2350562822a34d03$export$9ffb4923f81813d9}-group`;
const $2350562822a34d03$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $2350562822a34d03$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $2350562822a34d03$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $2350562822a34d03$export$9e40a0642460a944 = 'compal-menu-screen-reader';
parcelRegister("38IFv", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultListItem", ()=>$9082b0edc4f10018$export$1f8fa9d1eef77b32);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    const $9082b0edc4f10018$export$1f8fa9d1eef77b32 = (0, $5uXOq.forwardRef)(({ id: id, active: active, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
            ...(0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? {
                'aria-current': active,
                role: 'menuitem'
            } : {
                'aria-selected': active,
                role: 'option'
            },
            id: `${(0, $2350562822a34d03$export$b28d6b416aaf953a)}-${id}`,
            ...rest
        }));
});
parcelRegister("cLshs", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", ()=>$42c35fc284860d36$export$95554f6fb39a83c2);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $cSD7y;
    var $4R6GH;
    var $koVbs;
    var $zfug2;
    var $6LGvc;
    const $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperNew = (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, as: as, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const resizerRef = (0, $5uXOq.useRef)(null);
        const height = (0, (0, parcelRequire("6LGvc")).useSmoothExpand)(resizerRef);
        (0, $5uXOq.useEffect)(()=>{
            if (ref && 'current' in ref && ref.current) {
                const currentRef = ref.current;
                currentRef.style.height = `${height}px`;
            }
        }, [
            height,
            ref
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $42c35fc284860d36$var$wrapperStyles,
            testId: (0, $2350562822a34d03$export$85eefac753ab5bdb),
            id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
            role: noResultsFallback && (0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes') ? 'group' : (0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? 'menu' : 'listbox',
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("zfug2")).messages).commandPaletteSearchResultListBoxLabel),
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            ref: resizerRef,
            direction: "column",
            gap: "space.050"
        }, children));
    });
    const $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperOld = (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($42c35fc284860d36$var$Wrapper, {
            "data-testid": (0, $2350562822a34d03$export$85eefac753ab5bdb),
            id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
            role: noResultsFallback && (0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes') ? 'group' : (0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? 'menu' : 'listbox',
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("zfug2")).messages).commandPaletteSearchResultListBoxLabel),
            ...props
        });
    });
    const $42c35fc284860d36$export$95554f6fb39a83c2 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('compal_smooth_transition_on_size_change', $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperNew, $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperOld);
    const $42c35fc284860d36$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_c71l4u42 _18m91wug _vchhusvi _1yt41bpf _1e0c1txw _2lx21bp4 _zulp1b66 _1tke8vuz",
                __cmplp.className
            ])
        });
    });
    const $42c35fc284860d36$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: '0',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        transition: 'height 0.15s ease-out',
        overflowY: 'auto',
        maxHeight: '376px'
    });
});
parcelRegister("zfug2", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2745ea1cb0c1a200$export$defe85febe8b728c);
    var $7VHMR;
    const $2745ea1cb0c1a200$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        commandPaletteSearchResultListBoxLabel: {
            "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
            "defaultMessage": "List of commands"
        }
    });
});
parcelRegister("6LGvc", function(module, exports) {
    $parcel$export(module.exports, "useSmoothExpand", ()=>$38452c6bcba6455a$export$674ba8b02d2bfe86);
    var $5uXOq = parcelRequire("5uXOq");
    const $38452c6bcba6455a$var$MAX_HEIGHT = 376;
    const $38452c6bcba6455a$var$STARTING_HEIGHT = 56;
    const $38452c6bcba6455a$var$ADDITIONAL_HEIGHT = 16;
    const $38452c6bcba6455a$export$674ba8b02d2bfe86 = (content)=>{
        const [height, setHeight] = (0, $5uXOq.useState)($38452c6bcba6455a$var$STARTING_HEIGHT);
        const callback = (0, $5uXOq.useCallback)(()=>{
            const contentClientHeight = content.current?.clientHeight;
            if (!contentClientHeight) return;
            if (contentClientHeight > $38452c6bcba6455a$var$MAX_HEIGHT) setHeight($38452c6bcba6455a$var$MAX_HEIGHT);
            else setHeight(contentClientHeight + $38452c6bcba6455a$var$ADDITIONAL_HEIGHT);
        }, [
            content
        ]);
        (0, $5uXOq.useEffect)(()=>{
            let resizeObserver;
            if (content.current && typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(callback);
                resizeObserver.observe(content.current);
            }
            return ()=>{
                if (resizeObserver) resizeObserver.disconnect();
            };
        }, [
            callback,
            content
        ]);
        return height;
    };
});
parcelRegister("4nfzy", function(module, exports) {
    $parcel$export(module.exports, "CommandRowErrorBoundary", ()=>$53a0c321a39d3b85$export$223f3c3c93a14a83);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    const $53a0c321a39d3b85$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "command-palette-row",
            packageName: "jiraCommandPalette",
            fallback: "unmount",
            teamName: teamName,
            onError: onError,
            attributes: attributes
        }, children);
});
parcelRegister("eKTyH", function(module, exports) {
    $parcel$export(module.exports, "CommandRow", ()=>$9e51067b4d29f53f$export$3ef5d254c3c573e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    var $haBRL;
    const $9e51067b4d29f53f$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
        const { command: command } = result;
        const isActive = !!(result.active && isSearchFieldFocused);
        const isFirstCommand = result.index === 0;
        const rowProps = {
            index: index,
            isActive: isActive,
            command: command,
            isFirstCommand: isFirstCommand,
            onMouseMove: onHoverCommand,
            onClick: onClickCommand,
            onMouseDown: onMouseDownCommand,
            analyticsAttributes: (0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromResult)(result)
        };
        if (command.components?.CommandRow) return (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.CommandRow, rowProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("haBRL")).CommandRow), rowProps);
    };
});
parcelRegister("haBRL", function(module, exports) {
    $parcel$export(module.exports, "CommandRow", ()=>$04586313afa284d7$export$3ef5d254c3c573e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kgoHi;
    var $8CUq3;
    var $dCm1o;
    var $dzeHJ;
    var $3m7XM;
    var $3sBlN;
    const $04586313afa284d7$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
        const InnerContainer = $04586313afa284d7$var$CommandContainerInner;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainerWrapper, {
            "data-testid": command.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainer, {
            index: index,
            active: isActive,
            "data-active": isActive,
            "data-testid": (0, $593123af132e266c$export$b0017db5728101cc)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(InnerContainer, {
            "data-testid": (0, $593123af132e266c$export$47c379a40b00a339),
            ...rest
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconAndNameContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandIconsContainer, {
            "data-testid": (0, $593123af132e266c$export$d6dd1cf63aae711c)
        }, command.components?.LeftIcon && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            testId: (0, $593123af132e266c$export$7b41978523c7dd4a),
            alignItems: "center",
            justifyContent: "center",
            xcss: [
                $04586313afa284d7$var$iconStyles,
                isActive && $04586313afa284d7$var$iconActiveStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconContainer, {
            "data-testid": (0, $593123af132e266c$export$7b41978523c7dd4a),
            active: isActive
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null))), command.mode && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), {
            "data-testid": (0, $593123af132e266c$export$72c5368f559dd523)
        }, command.mode)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3m7XM")).RenderCommandName), {
            command: command,
            isActive: isActive
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sBlN")).RightContent), {
            command: command,
            isFirstCommand: isFirstCommand,
            isActive: isActive
        }))));
    };
    const $04586313afa284d7$var$CommandContainerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _syazjjyb _1yt4swc3",
                !!__cmplp.active && "_syazaj1x _bfhk29zg _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus194a",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandContainerInner = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt467l7 _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandIconsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwx1b66 _zulp1b66 _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '24px',
        height: '24px',
        color: 'color.icon.subtle'
    });
    const $04586313afa284d7$var$iconActiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.icon'
    });
    const $04586313afa284d7$var$CommandLeftIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
                __cmplp.active ? "_syaz2zfp" : "_syazbkuv",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandLeftIconAndNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz41tcg _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dzeHJ", function(module, exports) {
    $parcel$export(module.exports, "OutlinedLozenge", ()=>$0f9445e21ac061f1$export$224f9ad7f31e0de6);
    $parcel$export(module.exports, "FilledLozenge", ()=>$0f9445e21ac061f1$export$586a428fe10f5ae0);
    $parcel$export(module.exports, "SearchLozenge", ()=>$0f9445e21ac061f1$export$2ccc7861eeb7b337);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $0f9445e21ac061f1$var$Lozenge = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _2rko1l7b _1o9zidpf _4t3igktf _1bsbgktf _11c8qk37 _vwz41crf _syaz1aqp",
                __cmplp.className
            ])
        });
    });
    const $0f9445e21ac061f1$export$224f9ad7f31e0de6 = (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81u0j _k48p1pd9 _1p1dangw _bfhk1j9a _19it1x8r _syazuxqy _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $0f9445e21ac061f1$export$586a428fe10f5ae0 = (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _11c81u0j _1p1dangw _1pbykb7n _1cs8stnw _1kt9b3bt _1s6k1d2d _154psxj9 _rfx31l7b _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
                __cmplp.className
            ])
        });
    });
    const $0f9445e21ac061f1$export$2ccc7861eeb7b337 = (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4otz2 _1bsb1ris _11c81oud _vwz4dlk8 _bfhk1yrq",
                __cmplp.className
            ])
        });
    });
});
const $593123af132e266c$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $593123af132e266c$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $593123af132e266c$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $593123af132e266c$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $593123af132e266c$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';
parcelRegister("3m7XM", function(module, exports) {
    $parcel$export(module.exports, "RenderCommandName", ()=>$c1bc24527d77cdc3$export$931d3f1d35f6c058);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $hWZau;
    var $kgoHi;
    var $8CUq3;
    var $dCm1o;
    var $gGkxR;
    const $c1bc24527d77cdc3$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
        const renderCommandName = (0, $5uXOq.useCallback)(()=>{
            if (command.components?.Name) return (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.Name, {
                isActive: isActive
            }, command.name);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gGkxR")).TruncateWithTooltipOnActive), {
                isActive: isActive
            }, command.name);
        }, [
            command,
            isActive
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandNameContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$1858c2a91b8b53ba),
            active: isActive
        }, command.breadcrumb?.length ? (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3)
        }, command.breadcrumb.map((BreadCrumb, index, arr)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbItem, {
                isParent: index !== arr.length - 1,
                "data-testid": (0, $c5fb72cffbe58dfe$export$fb5462105b23e3e5),
                active: isActive
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(BreadCrumb, {
                isActive: isActive
            })), index !== arr.length - 1 && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                justifyContent: "center",
                xcss: $c1bc24527d77cdc3$var$iconWrapperStyles,
                alignItems: "center",
                testId: (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                color: "currentColor",
                label: "separator"
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandChevronContainer, {
                "data-testid": (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                color: "currentColor",
                label: "separator"
            })))))) : renderCommandName());
    };
    const $c1bc24527d77cdc3$var$CommandNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _vwz41tcg",
                __cmplp.active ? "_syaz1qfn" : "_syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandBreadcrumbContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandBreadcrumbItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_zek046": (0, (0, parcelRequire("lD23V")).default)(__cmplp.active ? `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N400})` : `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                !!__cmplp.isParent && "_syaz1bu1",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandChevronContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz4kb7n _syazjwct",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '24px',
        width: '24px'
    });
});
parcelRegister("gGkxR", function(module, exports) {
    $parcel$export(module.exports, "TruncateWithTooltipOnActive", ()=>$e999625ec19f201d$export$4495aca3d261add0);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $k5uoT;
    var $jgArx;
    var $k7xca;
    const $e999625ec19f201d$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: !!shouldShowTooltip,
            autoFocus: false,
            placement: "bottom-end",
            popupComponent: (0, (0, parcelRequire("jgArx")).PopupComponent),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TooltipContent), {
                    "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
                }, children),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TriggerComponent), {
                    "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                    ...triggerProps
                }),
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).tooltip()
        });
    const $e999625ec19f201d$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
    const $e999625ec19f201d$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
        const containerRef = $e999625ec19f201d$export$70f47de153e915ed();
        const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, (0, parcelRequire("k7xca")).useTruncatedTooltip)({
            containerRef: containerRef,
            tooltipDelay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: containerRef,
            xcss: [
                $e999625ec19f201d$var$tooltipContainerStyles,
                !preventTruncate && $e999625ec19f201d$var$truncateTooltipStyles
            ]
        }, children), isActive && (0, ($parcel$interopDefault($5uXOq))).createElement($e999625ec19f201d$var$TooltipRenderer, {
            shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
        }, showTooltip && customTooltip ? customTooltip : children));
    };
    const $e999625ec19f201d$var$tooltipContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        flexGrow: 1,
        textTransform: 'none'
    });
    const $e999625ec19f201d$var$truncateTooltipStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
});
parcelRegister("jgArx", function(module, exports) {
    $parcel$export(module.exports, "TooltipComponent", ()=>$3c6ba86682bb18eb$export$e18e2f8e82cdc428);
    $parcel$export(module.exports, "TriggerComponent", ()=>$3c6ba86682bb18eb$export$534fc570264a52a4);
    $parcel$export(module.exports, "TooltipTrigger", ()=>$3c6ba86682bb18eb$export$8c610744efcf8a1d);
    $parcel$export(module.exports, "PopupComponent", ()=>$3c6ba86682bb18eb$export$9fac2d040f3ed438);
    $parcel$export(module.exports, "TruncateWithTooltipContainer", ()=>$3c6ba86682bb18eb$export$8cae238d61c8405a);
    $parcel$export(module.exports, "TooltipContent", ()=>$3c6ba86682bb18eb$export$e9003e2be37ec060);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $btzsC;
    var $koVbs;
    var $6nFD4;
    const $3c6ba86682bb18eb$export$e18e2f8e82cdc428 = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledTooltipPrimitive, {
            ...props,
            ref: ref
        }));
    const $3c6ba86682bb18eb$export$534fc570264a52a4 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$export$8c610744efcf8a1d, {
            ...props,
            role: "button",
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("6nFD4")).messages).tooltipTriggerAriaLabel)
        });
    });
    const $3c6ba86682bb18eb$export$9fac2d040f3ed438 = (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledPopupPrimitive, {
            ...props,
            ref: ref
        }, children));
    const $3c6ba86682bb18eb$var$StyledTooltipPrimitive = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("btzsC")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$var$StyledPopupPrimitive = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$8cae238d61c8405a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1p1dglyw",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$e9003e2be37ec060 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1jfi _11c8qk37",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$8c610744efcf8a1d = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6nFD4", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$87d1d47436abe24f$export$defe85febe8b728c);
    var $7VHMR;
    const $87d1d47436abe24f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltipTriggerAriaLabel: {
            "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
            "defaultMessage": "Command palette tool tip"
        }
    });
});
const $40fe2afec35c84b7$export$f9e3e7ede9ba929d = 400;
parcelRegister("k7xca", function(module, exports) {
    $parcel$export(module.exports, "useTruncatedTooltip", ()=>$ad951546dfa9fa2c$export$94b118b3187f12c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    const $ad951546dfa9fa2c$export$22c0312879c61300 = ()=>(0, $5uXOq.useState)(false);
    const $ad951546dfa9fa2c$export$1ac6e474a0163418 = ()=>(0, $5uXOq.useState)(false);
    const $ad951546dfa9fa2c$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
        const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $ad951546dfa9fa2c$export$22c0312879c61300();
        const [isTruncated, setIsTruncated] = $ad951546dfa9fa2c$export$1ac6e474a0163418();
        const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, (0, parcelRequire("gM5ou")).useSetTimeoutAutoClear)();
        const setTimeoutFunc = setTimeoutAutoClear;
        (0, $5uXOq.useEffect)(()=>{
            const container = containerRef.current;
            if (!container) return;
            if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
            else setIsTruncated(false);
        }, [
            setIsTruncated,
            containerRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isTruncated && tooltipDelay === 0) {
                setShouldShowTruncatedTooltip(true);
                return ()=>{};
            }
            if (isTruncated && tooltipDelay > 0) {
                setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
                return ()=>{};
            }
            setShouldShowTruncatedTooltip(false);
            return ()=>{};
        }, [
            isTruncated,
            setShouldShowTruncatedTooltip,
            tooltipDelay,
            setTimeoutFunc
        ]);
        return {
            shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
        };
    };
});
const $c5fb72cffbe58dfe$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $c5fb72cffbe58dfe$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $c5fb72cffbe58dfe$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';
parcelRegister("3sBlN", function(module, exports) {
    $parcel$export(module.exports, "RightContent", ()=>$a83ca30f957fd273$export$11dbab4b39f15d6b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $h1toL;
    var $koVbs;
    var $gM5ou;
    var $iLhkq;
    var $dSJBv;
    var $kbnU6;
    var $lHtdH;
    const $a83ca30f957fd273$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const transitionStep = (0, (0, parcelRequire("lHtdH")).useHoverTransitionStep)(command, isActive, isFirstCommand);
        const commandHasChildren = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("gM5ou")).hasChildren)(command), [
            command
        ]);
        const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
        if (!shouldRenderRightContent) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$RightContentWrapper, null, commandHasChildren && (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$CommandRightChevronContainer, {
            "data-testid": (0, $0296d551a7f83620$export$e3e144c17be58a44),
            transitionStep: transitionStep
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h1toL"))))), {
            label: formatMessage((0, (0, parcelRequire("iLhkq")).messages).rightChevronLabel)
        })), !!command.shortcut && (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$ShortcutContainer, {
            "data-testid": (0, $0296d551a7f83620$export$f3036e9d26f81cd9),
            shouldHaveTransition: commandHasChildren,
            transitionStep: transitionStep
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dSJBv")).Shortcuts), {
            shortcut: command.shortcut
        })));
    };
    const $a83ca30f957fd273$var$animationFadeIn = null;
    const $a83ca30f957fd273$var$animationFadeOut = null;
    const $a83ca30f957fd273$var$RightContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $a83ca30f957fd273$var$CommandRightChevronContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _vwz41tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syazbkuv",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
                (__cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
                __cmplp.className
            ])
        });
    });
    const $a83ca30f957fd273$var$ShortcutContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
                (__cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
                __cmplp.className
            ])
        });
    });
});
const $0296d551a7f83620$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $0296d551a7f83620$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';
const $0296d551a7f83620$export$e792b5b2b6c9ee7 = 'command-palette.ui.modal.body.command-right-icon-container';
parcelRegister("iLhkq", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bf35cee6e1d1204b$export$defe85febe8b728c);
    var $7VHMR;
    const $bf35cee6e1d1204b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rightChevronLabel: {
            "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
            "defaultMessage": "Command with children icon"
        }
    });
});
parcelRegister("dSJBv", function(module, exports) {
    $parcel$export(module.exports, "Shortcuts", ()=>$57e6d30b2626ce39$export$b326d77e4b8b7664);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $bcTvL;
    var $gM5ou;
    var $dzeHJ;
    var $esPgL;
    const $57e6d30b2626ce39$var$KeyElement = ({ shortcut: shortcut })=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$export$cde89099db64abe3, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzeHJ")).FilledLozenge), {
            "data-testid": (0, $5ecbf01f9da59a15$export$cd62afa4691c297)
        }, shortcut));
    const $57e6d30b2626ce39$var$DivisorElement = ({ divisor: divisor })=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutDivider, {
            "data-testid": (0, $5ecbf01f9da59a15$export$e06ad7c09a29974b)
        }, divisor);
    const $57e6d30b2626ce39$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
        const replacer = replacers.shift();
        if (!replacer) {
            acc.push({
                type: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY,
                key: shortcut
            });
            types.push((0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY);
            return [
                acc,
                types
            ];
        }
        shortcut.split(replacer.char).forEach((str, index, self)=>{
            $57e6d30b2626ce39$var$parseShortcut(str, replacers.slice(0), acc, types);
            if (index < self.length - 1) {
                acc.push({
                    type: replacer.replacement
                });
                types.push(replacer.replacement);
            }
        });
        return [
            acc,
            types
        ];
    };
    const $57e6d30b2626ce39$export$cfaeb054b183bb20 = ()=>(0, (0, parcelRequire("koVbs")).default)();
    const $57e6d30b2626ce39$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
        const { formatMessage: formatMessage } = $57e6d30b2626ce39$export$cfaeb054b183bb20();
        const [shortcuts, types] = (0, $5uXOq.useMemo)(()=>$57e6d30b2626ce39$var$parseShortcut(shortcut, (0, (0, parcelRequire("gM5ou")).getShortcutSpecialCharacters)()), [
            shortcut
        ]);
        const basicShortcutMessage = (0, $5uXOq.useMemo)(()=>{
            if (types.length === 3) {
                if (types[0] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY) {
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN) return (0, (0, parcelRequire("esPgL")).messages).shortcutThen;
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR) return (0, (0, parcelRequire("esPgL")).messages).shortcutOr;
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).PLUS) return (0, (0, parcelRequire("esPgL")).messages).shortcutPlus;
                }
            }
            return null;
        }, [
            types
        ]);
        const formatTypeToMessage = (0, $5uXOq.useCallback)((type)=>{
            switch(type){
                case (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorThen);
                case (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorOr);
                default:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorPlus);
            }
        }, [
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutContainer, {
            "data-testid": (0, $5ecbf01f9da59a15$export$ec8260df4f23714c),
            "aria-hidden": true
        }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
            shortcutA: (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                shortcut: shortcuts[0].key
            }),
            shortcutB: (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                shortcut: shortcuts[2].key
            }),
            divisor: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                    divisor: chunk
                })
        }) : shortcuts.map((obj, index)=>{
            if (obj.type === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY) return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                key: index,
                shortcut: obj.key
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                key: index,
                divisor: formatTypeToMessage(obj.type)
            });
        }));
    };
    const $57e6d30b2626ce39$var$ShortcutDivider = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8otz2",
                __cmplp.className
            ])
        });
    });
    const $57e6d30b2626ce39$var$ShortcutContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $57e6d30b2626ce39$export$cde89099db64abe3 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
const $5ecbf01f9da59a15$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $5ecbf01f9da59a15$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $5ecbf01f9da59a15$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';
parcelRegister("esPgL", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4f430d579edd6c91$export$defe85febe8b728c);
    var $7VHMR;
    const $4f430d579edd6c91$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shortcutThen: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
            "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
        },
        shortcutOr: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
            "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
        },
        shortcutPlus: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
            "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
        },
        divisorThen: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
            "defaultMessage": "then"
        },
        divisorOr: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
            "defaultMessage": "or"
        },
        divisorPlus: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
            "defaultMessage": "+"
        }
    });
});
parcelRegister("kbnU6", function(module, exports) {
    $parcel$export(module.exports, "TRANSITION_STEP", ()=>$d865f5b0afeb3acd$export$42d8d7c94c5a11e9);
    $parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", ()=>$d865f5b0afeb3acd$export$82cfc253a6c33f59);
    $parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", ()=>$d865f5b0afeb3acd$export$e092796a9af3633b);
    $parcel$export(module.exports, "TRANSITION_DURATION_MS", ()=>$d865f5b0afeb3acd$export$1cad4f611a1c0229);
    var $d865f5b0afeb3acd$export$42d8d7c94c5a11e9;
    (function(TRANSITION_STEP) {
        TRANSITION_STEP["INITIAL"] = "initial";
        TRANSITION_STEP["DELAYING"] = "delaying";
        TRANSITION_STEP["TRANSITIONING"] = "transitioning";
        TRANSITION_STEP["FINISHED"] = "finished";
        TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
        TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    })($d865f5b0afeb3acd$export$42d8d7c94c5a11e9 || ($d865f5b0afeb3acd$export$42d8d7c94c5a11e9 = {}));
    const $d865f5b0afeb3acd$export$82cfc253a6c33f59 = 600;
    const $d865f5b0afeb3acd$export$e092796a9af3633b = 300;
    const $d865f5b0afeb3acd$export$1cad4f611a1c0229 = 350;
});
parcelRegister("lHtdH", function(module, exports) {
    $parcel$export(module.exports, "useHoverTransitionStep", ()=>$9c0e762a7fdf0cdc$export$eefd045a02bab4c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $dWt6p;
    var $jcw0u;
    var $gM5ou;
    var $kbnU6;
    const $9c0e762a7fdf0cdc$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
        const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $5uXOq.useState)(false);
        const [transitionStep, setTransitionStep] = (0, $5uXOq.useState)((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
        const timerRef = (0, $5uXOq.useRef)(null);
        const isReducedMotion = (0, (0, parcelRequire("dWt6p")).useIsReducedMotion)();
        const commandHasChildren = (0, (0, parcelRequire("gM5ou")).hasChildren)(command);
        (0, $5uXOq.useEffect)(()=>{
            setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
            if (timerRef.current) clearTimeout(timerRef.current);
        }, [
            command
        ]);
        const startTimerForNextStep = (nextStep, durationMs)=>{
            timerRef.current = setTimeout(()=>{
                setTransitionStep(nextStep);
                timerRef.current = null;
            }, durationMs);
        };
        const handleReducedMotionTransition = (0, $5uXOq.useCallback)(()=>{
            if (isActive) setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED);
            else setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
        }, [
            isActive
        ]);
        const handleWithMotionTransition = (0, $5uXOq.useCallback)(()=>{
            switch(transitionStep){
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL:
                    if (isActive) {
                        setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING);
                        startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, (0, parcelRequire("kbnU6")).TRANSITION_INITIAL_DELAY_TIME_MS) : (0, (0, parcelRequire("kbnU6")).TRANSITION_HOVER_DELAY_TIME_MS));
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING:
                    if (!isActive) {
                        timerRef.current && clearTimeout(timerRef.current);
                        timerRef.current = null;
                        setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING:
                    if (isActive) {
                        if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                        if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED, (0, (0, parcelRequire("kbnU6")).TRANSITION_DURATION_MS));
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED:
                    if (!isActive) setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT);
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT:
                    if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, (0, parcelRequire("kbnU6")).TRANSITION_HOVER_DELAY_TIME_MS));
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                    if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL, (0, (0, parcelRequire("kbnU6")).TRANSITION_DURATION_MS));
                    break;
                default:
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: new Error('Invalid transition step for command'),
                        meta: {
                            id: 'useTransitionStep',
                            packageName: 'jiraCommandPalette',
                            teamName: 'deliveroo'
                        }
                    });
            }
        }, [
            command.shortcut,
            hasTransitionedFirstCommand,
            isActive,
            isFirstCommand,
            transitionStep
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (commandHasChildren) {
                if (isReducedMotion) handleReducedMotionTransition();
                else handleWithMotionTransition();
            }
        }, [
            commandHasChildren,
            isReducedMotion,
            handleReducedMotionTransition,
            handleWithMotionTransition
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isFirstCommand) setHasTransitionedFirstCommand(false);
        }, [
            isFirstCommand
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            }, []);
        return transitionStep;
    };
});
parcelRegister("5aF2z", function(module, exports) {
    $parcel$export(module.exports, "GROUP_TEST_ID", ()=>$7ecce3582144481d$export$d83f892940e54128);
    $parcel$export(module.exports, "NO_RESULTS_TEST_ID", ()=>$7ecce3582144481d$export$bf182a53106ca02e);
    $parcel$export(module.exports, "SCROLL_DIRECTION", ()=>$7ecce3582144481d$export$a6d65a8fb7b912d6);
    const $7ecce3582144481d$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
    const $7ecce3582144481d$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
    const $7ecce3582144481d$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
    const $7ecce3582144481d$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
    const $7ecce3582144481d$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
    var $7ecce3582144481d$export$a6d65a8fb7b912d6;
    (function(SCROLL_DIRECTION) {
        SCROLL_DIRECTION["START"] = "start";
        SCROLL_DIRECTION["END"] = "end";
    })($7ecce3582144481d$export$a6d65a8fb7b912d6 || ($7ecce3582144481d$export$a6d65a8fb7b912d6 = {}));
});
parcelRegister("64ZBB", function(module, exports) {
    $parcel$export(module.exports, "isElementVisibleInContainer", ()=>$6b9215d3fa38a855$export$b9dc8b6556026098);
    $parcel$export(module.exports, "getScrollToIndex", ()=>$6b9215d3fa38a855$export$56068eb4c4e3a63c);
    $parcel$export(module.exports, "scrollResultIntoView", ()=>$6b9215d3fa38a855$export$6be8a7238febd54f);
    $parcel$export(module.exports, "scrollResultIntoViewOld", ()=>$6b9215d3fa38a855$export$5ebacb7632dd32c7);
    var $gM5ou;
    var $5aF2z;
    const $6b9215d3fa38a855$export$b9dc8b6556026098 = (element, container)=>{
        const modalBodyRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
    };
    const $6b9215d3fa38a855$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
        const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).START && commandResultIndex > 0) {
            const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, (0, parcelRequire("gM5ou")).hasAction)(result.command));
            if (prevActiveCommandIndex === -1) return 0;
        }
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, (0, parcelRequire("gM5ou")).hasAction)(result.command));
            if (afterActiveCommandIndex === -1) return results.length - 1;
            return commandResultIndex;
        }
        const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
        return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
    };
    const $6b9215d3fa38a855$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
        const targetRect = target.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        const gapScroll = 4;
        if (direction === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const commandPosition = targetRect.bottom - containerRect.top;
            const amountToScroll = commandPosition - containerRect.height;
            const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
            scrollContainer.scrollTo({
                top: pos
            });
        } else {
            const commandPosition = containerRect.top - targetRect.top;
            const amountToScroll = scrollContainer.scrollTop - commandPosition;
            const pos = amountToScroll - gapScroll;
            scrollContainer.scrollTo({
                top: pos
            });
        }
    };
    const $6b9215d3fa38a855$export$5ebacb7632dd32c7 = (scrollToResult, scrollTo)=>{
        if (!scrollToResult?.parentElement) return;
        const parent = scrollToResult.parentElement;
        const elemRect = scrollToResult.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        const gapScroll = 4;
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const commandPosition = elemRect.bottom - parentRect.top;
            const amountToScroll = commandPosition - parentRect.height;
            const pos = amountToScroll + gapScroll + parent.scrollTop;
            scrollToResult.parentElement.scrollTo({
                top: pos
            });
        } else {
            const commandPosition = parentRect.top - elemRect.top;
            const amountToScroll = parent.scrollTop - commandPosition;
            const pos = amountToScroll - gapScroll;
            scrollToResult.parentElement.scrollTo({
                top: pos
            });
        }
    };
});
parcelRegister("dE25F", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$842574a5e4b1a419$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $842574a5e4b1a419$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
        const footerChildren = children || defaultFooterContent;
        if (!footerChildren) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($842574a5e4b1a419$var$ModalFooter, {
            "data-testid": (0, $8289a08a5c530859$export$aca3e1b45b29f2bb)
        }, footerChildren);
    };
    const $842574a5e4b1a419$var$ModalFooter = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_mrkb1kw7 _1o0z1kw7 _1yt49l6b _x3doh6cr",
                __cmplp.className
            ])
        });
    });
});
const $8289a08a5c530859$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';
parcelRegister("d4iCz", function(module, exports) {
    $parcel$export(module.exports, "Header", ()=>$82822f3e363fec07$export$8b251419efc915eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $82822f3e363fec07$export$8b251419efc915eb = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $82822f3e363fec07$var$headerStyles,
            testId: (0, $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf)
        }, children);
    const $82822f3e363fec07$var$headerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        padding: 'space.200',
        borderBottom: `solid 1px ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`
    });
});
const $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';
parcelRegister("2w83X", function(module, exports) {
    $parcel$export(module.exports, "IssueTag", ()=>$2ba2b027b9044740$export$a342a0ad2c552031);
    var $5uXOq = parcelRequire("5uXOq");
    var $f5TWP;
    var $8CUq3;
    var $eMpK2;
    var $jIHzq;
    var $co1wz;
    var $2gCtH;
    var $7wNl6;
    var $80wkc;
    const $2ba2b027b9044740$export$a342a0ad2c552031 = ({ issueKey: issueKey })=>{
        const issueId = (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-summary_eog1v') ? (0, (0, parcelRequire("2gCtH")).useIssueId)() : undefined;
        const [{ value: summary }] = (0, (0, parcelRequire("80wkc")).useSummaryField)({
            issueKey: issueKey,
            issueId: issueId
        });
        const [{ value: issueType }] = (0, (0, parcelRequire("7wNl6")).useIssueTypeField)({
            issueKey: issueKey
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $2ba2b027b9044740$var$issueTagContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $2ba2b027b9044740$var$issueTagStyles,
            space: "space.050",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMpK2")).IssueLeftIcon), {
            issueTypeName: issueType?.name,
            iconUrl: issueType?.iconUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jIHzq")).TruncateWithTooltipOnHover), null, `${issueKey} ${summary}`)));
    };
    const $2ba2b027b9044740$var$issueTagContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        minWidth: '0'
    });
    const $2ba2b027b9044740$var$issueTagStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxWidth: '100%',
        padding: 'space.050',
        backgroundColor: 'color.background.neutral',
        borderRadius: 'border.radius.100',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: 'color.text.subtle',
        lineHeight: 1
    });
});
parcelRegister("eMpK2", function(module, exports) {
    $parcel$export(module.exports, "IssueLeftIcon", ()=>$f381ae85157eafc9$export$b1b562672a76ad84);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dXXlv;
    const $f381ae85157eafc9$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: iconUrl,
            alt: formatMessage((0, (0, parcelRequire("dXXlv")).messages).issueIconAltText, {
                issueTypeName: issueTypeName
            }),
            height: "16"
        });
    };
});
parcelRegister("dXXlv", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$91c46772185cf0df$export$defe85febe8b728c);
    var $7VHMR;
    const $91c46772185cf0df$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueIconAltText: {
            "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
            "defaultMessage": "Icon for the issue type {issueTypeName}"
        }
    });
});
parcelRegister("jIHzq", function(module, exports) {
    $parcel$export(module.exports, "TruncateWithTooltipOnHover", ()=>$386c5138d16516b4$export$b2323503daaefa);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $jgArx;
    var $k7xca;
    const $386c5138d16516b4$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
    const $386c5138d16516b4$export$b2323503daaefa = ({ children: children })=>{
        const containerRef = $386c5138d16516b4$export$70f47de153e915ed();
        const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, (0, parcelRequire("k7xca")).useTruncatedTooltip)({
            containerRef: containerRef,
            tooltipDelay: 0
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: shouldShowTruncatedTooltip ? ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TooltipContent), {
                    "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-content"
                }, children) : '',
            component: (0, (0, parcelRequire("jgArx")).TooltipComponent),
            position: "bottom-end",
            delay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TooltipTrigger), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-trigger",
                ...tooltipProps
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TruncateWithTooltipContainer), {
                ref: containerRef
            }, children)));
    };
});
parcelRegister("7wNl6", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypeField", ()=>$6016ffb039edefae$export$3da96c4009e089ca);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    var $5fc53;
    const $6016ffb039edefae$export$3da96c4009e089ca = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, (0, (0, parcelRequire("5fc53")).ISSUE_TYPE));
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, (0, parcelRequire("5fc53")).ISSUE_TYPE));
        const [{ value: value, error: error, loading: loading }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: null,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig,
                loading: loading
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("lQE94", function(module, exports) {
    $parcel$export(module.exports, "useEditField", ()=>$c31e2d123e024ddc$export$343e962d356c0af1);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $3BIWb;
    var $3BIWb;
    var $dJl1T;
    var $co1wz;
    var $jJZqs;
    var $fZneA;
    var $2gCtH;
    var $6Ou5i;
    var $afs7f;
    var $15WDX;
    var $biQrn;
    var $8zOmE;
    var $3fAi8;
    var $99cgx;
    const $c31e2d123e024ddc$var$getFieldValue = (response, fieldKey)=>{
        if (!response) return null;
        if (response.fields) {
            if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
            return null;
        }
        return response;
    };
    const $c31e2d123e024ddc$var$shouldCallSetFieldValue = (response, fieldKey)=>{
        if (!response) return false;
        if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
        return true;
    };
    const $c31e2d123e024ddc$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
        const baseUrl = '';
        const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $c31e2d123e024ddc$var$getFieldValue, saveField: saveField = (0, (0, parcelRequire("99cgx")).defaultSaveField), saveFieldById: saveFieldById = (0, (0, parcelRequire("99cgx")).defaultSaveFieldById), addValuesToField: addValuesToField = (0, (0, parcelRequire("99cgx")).defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, (0, parcelRequire("99cgx")).defaultRemoveValuesFromField), onSubmit: onSubmit = (0, ($parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, ($parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, ($parcel$interopDefault($8Rkzz))) } = fieldOptions;
        const isMounted = (0, (0, parcelRequire("biQrn")).useIsMounted)();
        const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, (0, parcelRequire("3fAi8")).useFieldValue)({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const resetError = (0, $5uXOq.useCallback)(()=>{
            if (isMounted.current) setError(null);
        }, [
            setError,
            isMounted
        ]);
        const editFieldValue = (0, $5uXOq.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
            isOptimistic: true
        })=>{
            let result;
            const analyticsData = {
                editOperationType: editOperationType,
                issueId: issueId,
                fieldKey: analyticsFieldKeyAlias ?? fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType
            };
            if (isMounted.current) {
                setLoading(true);
                setError(null);
            }
            try {
                onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
                if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
                result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
                const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
                $c31e2d123e024ddc$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
                onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
            } catch (ex) {
                result = Promise.reject(ex);
                onFailure(ex, valuesForOperation);
                setFieldValue(issueKey, fieldKey, fieldValue);
                if (isMounted.current) setError(ex);
                const isValidationError = ex instanceof (0, (0, parcelRequire("jJZqs")).ValidationError);
                if (!isValidationError) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
                if (fieldKey === 'timetracking' && (0, (0, parcelRequire("co1wz")).ff)('jiv-18751-investigate-time-tracking-update-errors_ng38s')) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'timetracking updateFailed', {
                    fieldKey: fieldKey,
                    fieldType: fieldType,
                    isValidationError: isValidationError,
                    isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(ex),
                    exceptionName: ex.name,
                    exceptionMessage: ex.message,
                    exceptionStack: ex.stack
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                    fieldKey: fieldKey,
                    fieldType: analyticsFieldTypeAlias ?? fieldType,
                    isValidationError: isValidationError,
                    isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(ex)
                });
            }
            if (isMounted.current) setLoading(false);
            return result;
        }, [
            issueId,
            analyticsFieldKeyAlias,
            fieldKey,
            analyticsFieldTypeAlias,
            fieldType,
            isMounted,
            onSubmit,
            fieldValue,
            setFieldValue,
            issueKey,
            onSuccess,
            onFailure,
            mapNonOptimisticResponse
        ]);
        const saveValue = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
            editFieldValue,
            saveField
        ]);
        const saveById = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
                isOptimistic: false
            }), [
            editFieldValue,
            saveFieldById
        ]);
        const addValues = (0, $5uXOq.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
            editFieldValue,
            addValuesToField
        ]);
        const removeValues = (0, $5uXOq.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
            editFieldValue,
            removeValuesFromField
        ]);
        return [
            {
                value: fieldValue,
                loading: loading,
                error: error
            },
            {
                saveById: saveById,
                saveValue: saveValue,
                addValues: addValues,
                removeValues: removeValues,
                resetError: resetError
            }
        ];
    };
    const $c31e2d123e024ddc$export$76d937477b5f784a = (issueKey)=>{
        const contextualIssueId = (0, (0, parcelRequire("2gCtH")).useIssueId)();
        const contextualIssueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        return contextualIssueKey === issueKey ? contextualIssueId : null;
    };
    const $c31e2d123e024ddc$export$343e962d356c0af1 = (fieldOptions)=>{
        const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, ($parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, ($parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, ($parcel$interopDefault($8Rkzz))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
        const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, (0, parcelRequire("15WDX")).useIssueViewFieldUpdateEvents)();
        const contextualIssueId = $c31e2d123e024ddc$export$76d937477b5f784a(issueKey);
        const issueId = issueIdFromFieldOptions ?? contextualIssueId;
        const isEditFromIssueView = (0, (0, parcelRequire("6Ou5i")).useIsEditFromIssueView);
        const onSubmitFn = (0, $5uXOq.useCallback)((oldValue, newValue, meta, event)=>{
            onSubmit(oldValue, newValue, meta, event);
            issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
        }, [
            fieldChangeRequested,
            fieldKey,
            issueId,
            onSubmit
        ]);
        const onSuccessFn = (0, $5uXOq.useCallback)(async (fieldValue, event, meta)=>{
            onSuccess(fieldValue);
            issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, meta);
            if (!shouldPreventIssueViewSoftRefresh && !isEditFromIssueView(event)) try {
                const reason = (0, (0, parcelRequire("afs7f")).Reason).SoftRefresh;
                (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-soft-refresh-ld') ? await (0, (0, parcelRequire("3BIWb")).default).refreshIssuePageThrowable(issueKey, reason) : await (0, (0, parcelRequire("3BIWb")).default).refreshIssuePageThrowable(issueKey, reason);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
            }
        }, [
            fieldChanged,
            fieldKey,
            shouldPreventIssueViewSoftRefresh,
            isEditFromIssueView,
            issueId,
            issueKey,
            onSuccess
        ]);
        const onFailureFn = (0, $5uXOq.useCallback)((error, failedValue)=>{
            onFailure(error, failedValue);
            issueId && fieldChangeFailed(issueId, fieldKey);
        }, [
            fieldChangeFailed,
            fieldKey,
            issueId,
            onFailure
        ]);
        return $c31e2d123e024ddc$export$3796d3fdbc2e6b54({
            ...fieldOptions,
            onSubmit: onSubmitFn,
            onSuccess: onSuccessFn,
            onFailure: onFailureFn
        });
    };
});
parcelRegister("3BIWb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b65e83eb4ced9ce9$export$2e2bcd8739ae039);
    var $afs7f;
    const $b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
    const $b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
    const $b65e83eb4ced9ce9$var$addEventListener = (event, callback)=>{
        document.addEventListener(event, callback);
    };
    const $b65e83eb4ced9ce9$var$removeEventListener = (event, callback)=>{
        document.removeEventListener(event, callback);
    };
    const $b65e83eb4ced9ce9$var$addRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$removeRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$refreshIssuePageThrowable = (issueKey, reason = (0, (0, parcelRequire("afs7f")).Reason).OnDemand)=>{
        try {
            document.dispatchEvent(new CustomEvent($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, {
                detail: [
                    issueKey,
                    {
                        mergeIntoCurrent: false,
                        reason: reason
                    }
                ]
            }));
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    };
    const $b65e83eb4ced9ce9$var$refreshIssuePage = (issueKey)=>$b65e83eb4ced9ce9$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
    var $b65e83eb4ced9ce9$export$2e2bcd8739ae039 = {
        addRefreshIssueListener: $b65e83eb4ced9ce9$var$addRefreshIssueListener,
        removeRefreshIssueListener: $b65e83eb4ced9ce9$var$removeRefreshIssueListener,
        addUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener,
        removeUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener,
        refreshIssuePageThrowable: $b65e83eb4ced9ce9$var$refreshIssuePageThrowable,
        refreshIssuePage: $b65e83eb4ced9ce9$var$refreshIssuePage
    };
});
parcelRegister("afs7f", function(module, exports) {
    $parcel$export(module.exports, "Reason", ()=>$90b3aba4b3cc23bb$export$fe867595c4640fb1);
    const $90b3aba4b3cc23bb$export$fe867595c4640fb1 = {
        OnDemand: 'ON_DEMAND',
        SoftRefresh: 'SOFT_REFRESH',
        Realtime: 'REALTIME'
    };
});
parcelRegister("6Ou5i", function(module, exports) {
    $parcel$export(module.exports, "useIsEditFromIssueView", ()=>$b57bb78db332aa99$export$870b996a6c1c7896);
    var $4R6GH;
    var $hBuqR;
    var $lhVtI;
    const $b57bb78db332aa99$export$870b996a6c1c7896 = (event)=>{
        const ISSUE_VIEW_SOURCES = [
            'fullIssueScreen',
            'boardIssueViewScreen',
            ...!(0, (0, parcelRequire("4R6GH")).fg)('fix_issue_hook_from_backlog') ? [
                'backlogScreen'
            ] : [],
            'agility-backlogScreen',
            'issueNavigatorEmbeddedIssueViewScreen',
            'globalIssueNavigatorIssueScreen',
            'mobileIssueScreen',
            'classicRoadmapScreen',
            'roadmapScreen',
            'versionDetailsIssueScreen',
            'bitbucketIssueScreen',
            'jsmQueueAgentViewSidebarScreen',
            'viewQueueIssueScreen',
            'jswModalIssueAppScreen',
            'jwmModalIssueAppScreen',
            'jswSidebarIssueAppScreen',
            'jwmSidebarIssueAppScreen'
        ];
        const { payload: { source: source } } = (0, (0, parcelRequire("lhVtI")).getEvent)(event);
        if (!source) return false;
        if (ISSUE_VIEW_SOURCES.includes(source)) return true;
        if (source.startsWith((0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3))) return true;
        return false;
    };
});
parcelRegister("15WDX", function(module, exports) {
    $parcel$export(module.exports, "useIssueViewFieldUpdateEvents", ()=>$947bdf396d8056bc$export$444af741f6d8f512);
    $parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", ()=>$947bdf396d8056bc$export$f9eb49cc2f0e28ce);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $5YMLs;
    var $3z81P;
    const $947bdf396d8056bc$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
            if (typeof eventHandler !== 'function') return ()=>{};
            const { eventHandlers: eventHandlers } = getState();
            const typeEventHandlers = eventHandlers[type];
            setState({
                eventHandlers: {
                    ...eventHandlers,
                    [type]: typeEventHandlers.concat([
                        eventHandler
                    ])
                }
            });
            return ()=>{
                const { eventHandlers: eventHandlersForUnregister } = getState();
                const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
                const newTypeEventHandlers = typeEventHandlersForUnregister.filter((handler)=>handler !== eventHandler);
                setState({
                    eventHandlers: {
                        ...eventHandlersForUnregister,
                        [type]: newTypeEventHandlers
                    }
                });
            };
        };
    const $947bdf396d8056bc$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
            let value = fieldValue;
            if (aggFieldChangeProps) value = (0, (0, parcelRequire("5YMLs")).transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
            const eventHandlers = getState().eventHandlers.onChange;
            eventHandlers.forEach((eventHandler)=>{
                eventHandler({
                    issueId: issueId,
                    fieldId: fieldId,
                    meta: {
                        fieldId: fieldId,
                        fieldValue: value,
                        additionalProperties: additionalProperties
                    },
                    type: (0, (0, parcelRequire("3z81P")).ChangeEventTypes).FIELD_CHANGED
                });
            });
        };
    const $947bdf396d8056bc$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
            const eventHandlers = getState().eventHandlers.onChange;
            eventHandlers.forEach((eventHandler)=>{
                eventHandler({
                    issueId: issueId,
                    meta: {
                        fieldId: fieldId
                    },
                    type: (0, (0, parcelRequire("3z81P")).ChangeEventTypes).FIELD_CHANGE_FAILED
                });
            });
        };
    const $947bdf396d8056bc$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
            let value = fieldValue;
            if (aggFieldChangeProps) value = (0, (0, parcelRequire("5YMLs")).transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
            const eventHandlers = getState().eventHandlers.onChange;
            eventHandlers.forEach((eventHandler)=>{
                eventHandler({
                    issueId: issueId,
                    meta: {
                        fieldId: fieldId,
                        fieldValue: value,
                        additionalProperties: additionalProperties
                    },
                    type: (0, (0, parcelRequire("3z81P")).ChangeEventTypes).FIELD_CHANGE_REQUESTED
                });
            });
        };
    const $947bdf396d8056bc$var$actions = {
        fieldChanged: $947bdf396d8056bc$var$fieldChanged,
        fieldChangeFailed: $947bdf396d8056bc$var$fieldChangeFailed,
        fieldChangeRequested: $947bdf396d8056bc$var$fieldChangeRequested,
        registerEventHandler: $947bdf396d8056bc$var$registerEventHandler
    };
    const $947bdf396d8056bc$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-view-field-update-events',
        initialState: {
            eventHandlers: {
                onChange: []
            }
        },
        actions: $947bdf396d8056bc$var$actions
    });
    const $947bdf396d8056bc$export$444af741f6d8f512 = (0, (0, parcelRequire("3sQ5x")).createHook)($947bdf396d8056bc$var$store, {
        selector: null
    });
    const $947bdf396d8056bc$export$f9eb49cc2f0e28ce = (0, (0, parcelRequire("gg7kZ")).createContainer)($947bdf396d8056bc$var$store);
});
parcelRegister("5YMLs", function(module, exports) {
    $parcel$export(module.exports, "transformAggToLegacy", ()=>$1da8cbd2b672325c$export$d951e3c38e10736d);
    var $bMD69;
    var $5fc53;
    var $1pF6B;
    var $lTnWS;
    const $1da8cbd2b672325c$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
        if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
        switch(aggFieldChangeProps.__typename){
            case 0, (0, parcelRequire("5fc53")).RADIO_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).TEAM_VIEW_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).MULTI_GROUP_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).SINGLE_GROUP_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).SECURITY_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).NUMBER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).USER_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).PRIORITY_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).URL_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).DATE_TIME_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).COLOR_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).ORIGINAL_ESTIMATE_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).VOTES_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).WATCHES_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).RESOLUTION_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).STATUS_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    [$1da8cbd2b672325c$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type
                })?.value;
            case 0, (0, parcelRequire("5fc53")).RICH_TEXT_GQL_FIELD:
                return (0, (0, parcelRequire("lTnWS")).transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
            case 0, (0, parcelRequire("5fc53")).PARENT_GQL_FIELD:
                return (0, (0, parcelRequire("1pF6B")).transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
            case 0, (0, parcelRequire("5fc53")).SPRINT_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    ...fieldValue
                })?.value;
            case 0, (0, parcelRequire("5fc53")).TIME_TRACKING_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    originalEstimate: fieldValue.originalEstimate,
                    remainingEstimate: fieldValue.remainingEstimate,
                    timeSpent: fieldValue.timeSpent
                })?.value;
            case 0, (0, parcelRequire("5fc53")).CHECKBOX_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    selectedOptions: fieldValue.selectedOptions,
                    checkboxesFieldOptions: fieldValue.fieldOptions
                })?.value;
            case 0, (0, parcelRequire("5fc53")).COMPONENTS_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    components: fieldValue.components,
                    selectedComponentsConnection: fieldValue.selectedComponentsConnection
                })?.value;
            default:
                throw new Error('__typename not implemented');
        }
    };
    const $1da8cbd2b672325c$var$getValueKey = (__typename)=>{
        const VALUE_KEYS = {
            [(0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD)]: 'text',
            [(0, (0, parcelRequire("5fc53")).NUMBER_GQL_FIELD)]: 'number',
            [(0, (0, parcelRequire("5fc53")).PRIORITY_GQL_FIELD)]: 'priority',
            [(0, (0, parcelRequire("5fc53")).USER_PICKER_GQL_FIELD)]: 'user',
            [(0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD)]: 'date',
            [(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)]: 'project',
            [(0, (0, parcelRequire("5fc53")).DATE_TIME_GQL_FIELD)]: 'dateTime',
            [(0, (0, parcelRequire("5fc53")).ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
            [(0, (0, parcelRequire("5fc53")).URL_GQL_FIELD)]: 'uri',
            [(0, (0, parcelRequire("5fc53")).SECURITY_GQL_FIELD)]: 'securityLevel',
            [(0, (0, parcelRequire("5fc53")).PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
            [(0, (0, parcelRequire("5fc53")).WATCHES_GQL_FIELD)]: 'watch',
            [(0, (0, parcelRequire("5fc53")).VOTES_GQL_FIELD)]: 'vote',
            [(0, (0, parcelRequire("5fc53")).COLOR_GQL_FIELD)]: 'color',
            [(0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
            [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)]: 'issueType',
            [(0, (0, parcelRequire("5fc53")).RESOLUTION_GQL_FIELD)]: 'resolution',
            [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
            [(0, (0, parcelRequire("5fc53")).SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
            [(0, (0, parcelRequire("5fc53")).TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
            [(0, (0, parcelRequire("5fc53")).STATUS_GQL_FIELD)]: 'status',
            [(0, (0, parcelRequire("5fc53")).RADIO_GQL_FIELD)]: 'selectedOption',
            [(0, (0, parcelRequire("5fc53")).RICH_TEXT_GQL_FIELD)]: 'richText'
        };
        const value = VALUE_KEYS[__typename];
        if (value) return value;
        throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
    };
});
parcelRegister("bMD69", function(module, exports) {
    $parcel$export(module.exports, "transformAggFieldToLegacyField", ()=>$af5e8bab0defb9c8$export$586ba15cbf3d3031);
    $parcel$export(module.exports, "transformAggFieldsToLegacyFields", ()=>$af5e8bab0defb9c8$export$ba106ff8c087e6b1);
    var $8QpSo;
    var $5fc53;
    var $9bgym;
    var $6iJEF;
    var $9UrtF;
    var $hsEaK;
    var $2qu1N;
    var $16Zia;
    var $iv8Rf;
    var $hDlc2;
    var $c3LW9;
    var $h92P3;
    var $aeO9V;
    var $6Tnq8;
    var $6mbsj;
    var $d3nG3;
    var $1xW6n;
    var $fW9XR;
    var $bKMMB;
    var $7JL37;
    var $dulCG;
    var $6vno6;
    var $as0vY;
    var $6dPLd;
    var $gKccZ;
    var $jnUrZ;
    var $iJtmd;
    var $iPyq0;
    var $384lj;
    var $axTS6;
    var $lfJ6H;
    var $9UXU7;
    var $b6BoU;
    var $gak3n;
    var $i47fO;
    var $gvljZ;
    var $6XFn2;
    var $6e1Ya;
    var $hBEiJ;
    var $1XNj2;
    var $f6zXW;
    var $fB4wX;
    var $cXBkk;
    var $iDKu3;
    var $aGv90;
    var $19DRh;
    var $lkW3a;
    var $lQAwK;
    var $8qOI6;
    var $cbd7V;
    var $6hj44;
    var $4nh4C;
    var $hA3EZ;
    var $2z4xE;
    var $cO2KQ;
    var $5sETx;
    var $f454b;
    var $aafIf;
    var $2yWre;
    var $lUeQj;
    var $6SWOK;
    var $cMc7B;
    var $38GNL;
    var $avV20;
    var $cbXvu;
    var $aSXJi;
    var $8uxcU;
    var $arKlm;
    var $hCKV6;
    var $d8wC0;
    const $af5e8bab0defb9c8$var$getTransformersNonMemoised = ()=>({
            [(0, (0, parcelRequire("5fc53")).AFFECTED_SERVICES_GQL_FIELD)]: (0, (0, parcelRequire("9bgym")).transformAggAffectedServicesToLegacyField),
            [(0, (0, parcelRequire("5fc53")).BOOLEAN_GQL_FIELD)]: (0, (0, parcelRequire("9UrtF")).transformAggBooleanToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("hsEaK")).transformAggCascadingSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CHECKBOX_GQL_FIELD)]: (0, (0, parcelRequire("2qu1N")).transformAggCheckboxToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CMDB_GQL_FIELD)]: (0, (0, parcelRequire("16Zia")).transformAggCMDBToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("19DRh")).transformAggMultipleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).COMPONENTS_GQL_FIELD)]: (0, (0, parcelRequire("hDlc2")).transformAggComponentsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_DATE_TIME_GQL_FIELD)]: (0, (0, parcelRequire("c3LW9")).transformAggConnectDateTimeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("h92P3")).transformAggConnectMultipleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_NUMBER_GQL_FIELD)]: (0, (0, parcelRequire("aeO9V")).transformAggConnectNumberToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_RICH_TEXT_GQL_FIELD)]: (0, (0, parcelRequire("6Tnq8")).transformAggConnectRichTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("6mbsj")).transformAggConnectSingleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_TEXT_GQL_FIELD)]: (0, (0, parcelRequire("d3nG3")).transformAggConnectTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).COLOR_GQL_FIELD)]: (0, (0, parcelRequire("iv8Rf")).transformAggColorToLegacyField),
            [(0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("fW9XR")).transformAggDatePickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).DATE_TIME_GQL_FIELD)]: (0, (0, parcelRequire("bKMMB")).transformAggDateTimePickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).EPIC_LINK_GQL_FIELD)]: (0, (0, parcelRequire("7JL37")).transformAggEpicLinkToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FLAG_GQL_FIELD)]: (0, (0, parcelRequire("dulCG")).transformAggFlagToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_DATETIME_GQL_FIELD)]: (0, (0, parcelRequire("as0vY")).transformAggForgeDateTimeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_DATE_GQL_FIELD)]: (0, (0, parcelRequire("6vno6")).transformAggForgeDateToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_GROUP_GQL_FIELD)]: (0, (0, parcelRequire("6dPLd")).transformAggForgeGroupToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_GROUPS_GQL_FIELD)]: (0, (0, parcelRequire("gKccZ")).transformAggForgeGroupsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_NUMBER_GQL_FIELD)]: (0, (0, parcelRequire("jnUrZ")).transformAggForgeNumberToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_OBJECT_GQL_FIELD)]: (0, (0, parcelRequire("iJtmd")).transformAggForgeObjectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_STRING_GQL_FIELD)]: (0, (0, parcelRequire("iPyq0")).transformAggForgeStringToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_STRINGS_GQL_FIELD)]: (0, (0, parcelRequire("384lj")).transformAggForgeStringsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_USER_GQL_FIELD)]: (0, (0, parcelRequire("axTS6")).transformAggForgeUserToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_USERS_GQL_FIELD)]: (0, (0, parcelRequire("lfJ6H")).transformAggForgeUsersToLegacyField),
            [(0, (0, parcelRequire("5fc53")).ISSUE_RESTRICTION_GQL_FIELD)]: (0, (0, parcelRequire("b6BoU")).transformAggIssueRestrictionToLegacyField),
            [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)]: (0, (0, parcelRequire("gak3n")).transformAggIssueTypeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_APPROVAL_GQL_FIELD)]: (0, (0, parcelRequire("i47fO")).transformAggJSMApprovalsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_ASSETS_GQL_FIELD)]: (0, (0, parcelRequire("6iJEF")).transformAggAssetToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_MAJOR_INCIDENT_FIELD)]: (0, (0, parcelRequire("6XFn2")).transformAggJSMMajorIncidentToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_ORGANIZATION_GQL_FIELD)]: (0, (0, parcelRequire("6e1Ya")).transformAggJSMOrganizationToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_ENTITLEMENTS_GQL_FIELD)]: (0, (0, parcelRequire("gvljZ")).transformAggJSMEntitlementsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_SENTIMENT_GQL_FIELD)]: (0, (0, parcelRequire("cXBkk")).transformAggJSMSentimentToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_PEOPLE_GQL_FIELD)]: (0, (0, parcelRequire("lkW3a")).transformAggMultipleUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, (0, parcelRequire("hBEiJ")).transformAggJSMRequestFeedbackToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, (0, parcelRequire("1XNj2")).transformAggJSMRequestLanguageToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_REQUEST_TYPE_GQL_FIELD)]: (0, (0, parcelRequire("f6zXW")).transformAggJSMRequestTypeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_RESPONDERS_GQL_FIELD)]: (0, (0, parcelRequire("fB4wX")).transformAggJSMRespondersToLegacyField),
            [(0, (0, parcelRequire("5fc53")).LABEL_GQL_FIELD)]: (0, (0, parcelRequire("iDKu3")).transformAggLabelsNodeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PRIORITY_GQL_FIELD)]: (0, (0, parcelRequire("6hj44")).transformAggPriorityToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("aGv90")).transformAggMultiGroupPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("lkW3a")).transformAggMultipleUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).NUMBER_GQL_FIELD)]: (0, (0, parcelRequire("8qOI6")).transformAggNumberToLegacyField),
            [(0, (0, parcelRequire("5fc53")).ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, (0, parcelRequire("cbd7V")).transformAggOriginalEstimateToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PEOPLE_GQL_FIELD)]: (0, (0, parcelRequire("lkW3a")).transformAggMultipleUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PROFORMA_FORMS_GQL_FIELD)]: (0, (0, parcelRequire("4nh4C")).transformAggProformaFormsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)]: (0, (0, parcelRequire("hA3EZ")).transformAggProjectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_GQL_FIELD)]: (0, (0, parcelRequire("lQAwK")).transformAggMultipleVersionPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).RADIO_GQL_FIELD)]: (0, (0, parcelRequire("2z4xE")).transformAggRadioSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).RICH_TEXT_GQL_FIELD)]: (0, (0, parcelRequire("5sETx")).transformAggRichTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).RESOLUTION_GQL_FIELD)]: (0, (0, parcelRequire("cO2KQ")).transformAggResolutionToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SECURITY_GQL_FIELD)]: (0, (0, parcelRequire("f454b")).transformAggSecurityLevelToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SPRINT_GQL_FIELD)]: (0, (0, parcelRequire("38GNL")).transformAggSprintToLegacyField),
            [(0, (0, parcelRequire("5fc53")).STATUS_GQL_FIELD)]: (0, (0, parcelRequire("avV20")).transformAggStatusToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("aafIf")).transformAggSingleGroupPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SINGLE_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("lUeQj")).transformAggSingleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TEAM_GQL_FIELD)]: (0, (0, parcelRequire("cbXvu")).transformAggTeamToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TEAM_VIEW_GQL_FIELD)]: (0, (0, parcelRequire("aSXJi")).transformAggTeamViewToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD)]: (0, (0, parcelRequire("2yWre")).transformAggSingleLineTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TIME_TRACKING_GQL_FIELD)]: (0, (0, parcelRequire("8uxcU")).transformAggTimeTrackingToLegacyField),
            [(0, (0, parcelRequire("5fc53")).USER_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("6SWOK")).transformAggSingleSelectUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).URL_GQL_FIELD)]: (0, (0, parcelRequire("arKlm")).transformAggUrlToLegacyField),
            [(0, (0, parcelRequire("5fc53")).VERSION_GQL_FIELD)]: (0, (0, parcelRequire("cMc7B")).transformAggSingleVersionPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).VOTES_GQL_FIELD)]: (0, (0, parcelRequire("hCKV6")).transformAggVotesToLegacyField),
            [(0, (0, parcelRequire("5fc53")).WATCHES_GQL_FIELD)]: (0, (0, parcelRequire("d8wC0")).transformAggWatchesToLegacyField),
            [(0, (0, parcelRequire("5fc53")).DATA_CLASSIFICATION_FIELD)]: (0, (0, parcelRequire("1xW6n")).transformAggDataClassificationToLegacyField),
            [(0, (0, parcelRequire("5fc53")).GOALS_GQL_FIELD)]: (0, (0, parcelRequire("9UXU7")).transformAggGoalsToLegacyField)
        });
    const $af5e8bab0defb9c8$var$getTransformers = (0, (0, parcelRequire("8QpSo")).default)($af5e8bab0defb9c8$var$getTransformersNonMemoised);
    const $af5e8bab0defb9c8$export$586ba15cbf3d3031 = (node, context)=>{
        const typename = node.__typename;
        const transformer = $af5e8bab0defb9c8$var$getTransformers()[typename];
        return transformer ? transformer(node, context) : undefined;
    };
    const $af5e8bab0defb9c8$export$ba106ff8c087e6b1 = (fields)=>{
        if (fields == null) return {};
        return fields.reduce((fieldsState, fieldEdge)=>{
            if (fieldEdge?.node != null) {
                const transformedField = $af5e8bab0defb9c8$export$586ba15cbf3d3031(fieldEdge.node, fields);
                if (transformedField != null) {
                    const fieldData = 'key' in transformedField ? {
                        [transformedField.key]: transformedField
                    } : transformedField;
                    Object.assign(fieldsState, fieldData);
                }
            }
            return fieldsState;
        }, {});
    };
});
parcelRegister("9bgym", function(module, exports) {
    $parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", ()=>$0bce5d1c363f27e8$export$231e0419515441d4);
    var $5fc53;
    var $o7K5u;
    const $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
            id: serviceId,
            name: name ?? undefined
        });
    const $0bce5d1c363f27e8$export$231e0419515441d4 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE)) return undefined;
        const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
        const value = hasValue ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedAffectedServicesConnection, $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
            value: value,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE),
                items: 'service-entity-field',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';
parcelRegister("o7K5u", function(module, exports) {
    $parcel$export(module.exports, "transformAggNodeToLegacyField", ()=>$cfa10031dfb7ad46$export$e7ea61856a169c36);
    $parcel$export(module.exports, "transformAggConnection", ()=>$cfa10031dfb7ad46$export$daf92cda81d86cdc);
    $parcel$export(module.exports, "toLegacyConnectOption", ()=>$cfa10031dfb7ad46$export$b5de5f3d2de73afc);
    const $cfa10031dfb7ad46$export$e7ea61856a169c36 = (node)=>({
            ari: 'id' in node ? node.id : undefined,
            key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
            title: 'name' in node ? node.name : '',
            editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
            required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
            autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
            allowedValues: [],
            value: null,
            schema: {
                type: 'type' in node ? node.type : '',
                custom: null,
                system: null
            },
            description: 'description' in node && node.description ? node.description : undefined
        });
    const $cfa10031dfb7ad46$export$daf92cda81d86cdc = (connection, transformCallback)=>{
        const edges = connection?.edges ?? [];
        if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
        return edges.map((edge)=>edge?.node).filter(Boolean);
    };
    const $cfa10031dfb7ad46$export$b5de5f3d2de73afc = (node)=>{
        if (!node) return null;
        return {
            value: node.value ?? null,
            id: parseInt(node.optionId, 10)
        };
    };
});
parcelRegister("6iJEF", function(module, exports) {
    $parcel$export(module.exports, "transformAggAssetToLegacyField", ()=>$b9f6b8590a60f3b3$export$2136dcd78a2ef18f);
    var $5fc53;
    var $o7K5u;
    const $b9f6b8590a60f3b3$export$2136dcd78a2ef18f = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).ASSETS_CF_TYPE:
                {
                    const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                    const assetValue = hasValue ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                            appKey: appKey,
                            originId: originId,
                            serializedOrigin: serializedOrigin,
                            value: value
                        })) : null;
                    return {
                        ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                        autoCompleteUrl: node.searchUrl,
                        value: assetValue,
                        schema: {
                            custom: node.type,
                            system: null,
                            items: 'sd-asset',
                            type: 'array',
                            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                            configuration: null
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("9UrtF", function(module, exports) {
    $parcel$export(module.exports, "transformAggBooleanToLegacyField", ()=>$474331244347ccdb$export$4bd89b95f0d10de9);
    var $5fc53;
    var $o7K5u;
    const $474331244347ccdb$export$4bd89b95f0d10de9 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: {
                        alertLinking: {
                            enabled: node.value
                        }
                    },
                    schema: {
                        configuration: null,
                        items: null,
                        renderer: null,
                        custom: null,
                        system: (0, (0, parcelRequire("5fc53")).SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                        type: (0, (0, parcelRequire("5fc53")).SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("hsEaK", function(module, exports) {
    $parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", ()=>$afb6a8576bf8d731$export$a8778af5ceb1017c);
    var $co1wz;
    var $o7K5u;
    const $afb6a8576bf8d731$export$a8778af5ceb1017c = (node)=>{
        let value = null;
        if (node.cascadingOption) {
            const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
            const child = childOptionValue ? {
                child: {
                    id: childOptionValue.optionId,
                    value: childOptionValue.value
                }
            } : {};
            value = {
                id: parentOptionValue?.optionId,
                value: parentOptionValue?.value,
                ...child
            };
        }
        const allowedValues = (0, (0, parcelRequire("co1wz")).ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration') ? [] : (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.cascadingOptions, (cascadingOption)=>{
            if (!cascadingOption.parentOptionValue) return null;
            const { parentOptionValue: parentOptionValue, childOptionValues: childOptionValues } = cascadingOption;
            const childrenObj = childOptionValues?.length ? {
                children: childOptionValues.filter(Boolean).map((option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }))
            } : {};
            return {
                value: parentOptionValue.value,
                id: parentOptionValue.optionId,
                ...childrenObj
            };
        });
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: allowedValues,
            schema: {
                type: 'option-with-child',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("2qu1N", function(module, exports) {
    $parcel$export(module.exports, "transformAggCheckboxToLegacyField", ()=>$3efe07b8b545ea99$export$baa5afdbd8fd12d3);
    var $5fc53;
    var $o7K5u;
    const $3efe07b8b545ea99$export$baa5afdbd8fd12d3 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                {
                    const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOptions, (option)=>({
                            id: option.optionId,
                            value: option.value ?? null,
                            ari: option.id
                        }));
                    const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                            id: option.optionId,
                            value: option.value ?? null,
                            ari: option.id
                        }));
                    return {
                        ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                        value: value.length ? value : null,
                        allowedValues: allowedValues,
                        schema: {
                            type: 'array',
                            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                            custom: node.type,
                            system: null,
                            items: 'option',
                            configuration: null
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("16Zia", function(module, exports) {
    $parcel$export(module.exports, "transformAggCMDBToLegacyField", ()=>$4d2c21f2e394ef74$export$93506453d9bb56ae);
    var $5fc53;
    var $o7K5u;
    const $4d2c21f2e394ef74$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
            workspaceId: workspaceId,
            id: `${workspaceId}:${attribute.objectTypeId}`,
            name: attribute.name,
            objectSchemaId: attribute.objectSchemaId,
            objectTypeId: attribute.objectTypeId,
            icon: {
                id: attribute.icon.id,
                name: attribute.icon.name,
                url16: attribute.icon.url16,
                url48: attribute.icon.url48
            }
        });
    const $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
        if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
            isInsightAvailable: node.isInsightAvailable
        } : {};
        return {
            cmdbFieldConfig: {
                multiple: node.cmdbFieldConfig.multiple,
                objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
                attributesDisplayedOnIssue: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
                attributesIncludedInAutoCompleteSearch: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
            },
            isInsightAvailable: node.isInsightAvailable,
            wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
        };
    };
    const $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy = (type)=>{
        switch(type){
            case 'REFERENCED_OBJECT':
                return 1;
            case 'USER':
                return 2;
            case 'GROUP':
                return 4;
            case 'PROJECT':
                return 6;
            case 'STATUS':
                return 7;
            case 'BITBUCKET_REPO':
                return 8;
            case 'OPSGENIE_TEAM':
                return 9;
            case 'DEFAULT':
                return 0;
            default:
                console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
                return -1;
        }
    };
    const $4d2c21f2e394ef74$var$transformReferencedObject = (node)=>({
            id: node.objectGlobalId,
            workspaceId: node.workspaceId,
            objectKey: node.objectKey,
            label: node.label,
            avatar: node.avatar,
            objectId: node.objectId
        });
    const $4d2c21f2e394ef74$var$transformCmdbUser = (node)=>({
            avatarUrl: node.picture,
            displayName: node.name,
            name: node.name,
            key: node.accountId
        });
    const $4d2c21f2e394ef74$var$transformCmdbGroup = (node)=>({
            name: node.name
        });
    const $4d2c21f2e394ef74$var$transformCmdbProject = (node)=>({
            avatarUrl: node.avatar?.large,
            id: Number(node.id),
            key: node.key,
            name: node.name
        });
    const $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo = (node)=>({
            uuid: node.uuid,
            name: node.name,
            url: node.url,
            avatarUrl: node.avatarUrl
        });
    const $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam = (node)=>({
            id: node.id,
            name: node.name,
            url: node.url
        });
    const $4d2c21f2e394ef74$var$transformCmdbStatus = (node)=>({
            id: node.id,
            name: node.name,
            category: node.category
        });
    const $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy = (node)=>{
        if (!node) return null;
        const defaultObjectValue = {
            displayValue: node.displayValue,
            searchValue: node.searchValue,
            ...node.value != null ? {
                value: node.value
            } : {}
        };
        if (node.referencedObject) return {
            ...defaultObjectValue,
            referencedObject: $4d2c21f2e394ef74$var$transformReferencedObject(node.referencedObject)
        };
        if (node.user) return {
            ...defaultObjectValue,
            user: $4d2c21f2e394ef74$var$transformCmdbUser(node.user)
        };
        if (node.group) return {
            ...defaultObjectValue,
            group: $4d2c21f2e394ef74$var$transformCmdbGroup(node.group)
        };
        if (node.project) return {
            ...defaultObjectValue,
            project: $4d2c21f2e394ef74$var$transformCmdbProject(node.project)
        };
        if (node.bitbucketRepo) return {
            ...defaultObjectValue,
            bitbucketRepo: $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
        };
        if (node.opsgenieTeam) return {
            ...defaultObjectValue,
            opsgenieTeam: $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
        };
        if (node.status) return {
            ...defaultObjectValue,
            status: $4d2c21f2e394ef74$var$transformCmdbStatus(node.status)
        };
        return defaultObjectValue;
    };
    const $4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
        if (!node) return null;
        const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
        return {
            objectTypeAttributeId: objectTypeAttributeId,
            workspaceId: workspaceId,
            objectAttributeValues: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.objectAttributeValues, $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy),
            objectTypeAttribute: {
                id: objectTypeAttributeId,
                label: objectTypeAttribute.label,
                name: objectTypeAttribute.name,
                workspaceId: workspaceId,
                type: $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
                ...objectTypeAttribute.defaultType ? {
                    defaultType: {
                        id: objectTypeAttribute.defaultType.id,
                        name: objectTypeAttribute.defaultType.name
                    }
                } : {}
            }
        };
    };
    const $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB = (node)=>{
        if (!node) return null;
        const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
        return {
            attributes: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.attributes, (nodeAttribute)=>$4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
            avatar: avatar,
            label: label,
            id: objectGlobalId,
            objectId: objectId,
            objectKey: objectKey,
            workspaceId: workspaceId,
            links: {
                self: webUrl
            },
            objectType: $4d2c21f2e394ef74$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
        };
    };
    const $4d2c21f2e394ef74$export$93506453d9bb56ae = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).CMDB_OBJECT_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
            configuration: $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration(node),
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedCmdbObjectsConnection, $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).CMDB_OBJECT_CF_TYPE),
                items: 'cmdb-object-field',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("iv8Rf", function(module, exports) {
    $parcel$export(module.exports, "transformAggColorToLegacyField", ()=>$b83a62ddd17b4586$export$587c178f1b45e5e9);
    var $5fc53;
    var $o7K5u;
    const $b83a62ddd17b4586$export$587c178f1b45e5e9 = (node)=>{
        const value = node.color?.colorKey ?? null;
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).EPIC_COLOR_TYPE:
            case 0, (0, parcelRequire("5fc53")).COLOR_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: value,
                    schema: {
                        configuration: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("hDlc2", function(module, exports) {
    $parcel$export(module.exports, "transformAggComponentsToLegacyField", ()=>$315456e18e2330f5$export$97a9275777684b77);
    var $co1wz;
    var $5fc53;
    var $o7K5u;
    const $315456e18e2330f5$var$transformJiraComponentToLegacyComponent = (component)=>{
        if (component == null) return null;
        return {
            id: component.componentId,
            name: component.name,
            ...(0, (0, parcelRequire("co1wz")).ff)('compass-components-in-jira-components_xw42u', false) ? {
                ari: component.ari,
                metadata: component.metadata
            } : {}
        };
    };
    const $315456e18e2330f5$export$97a9275777684b77 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)) return undefined;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.components, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedComponentsConnection, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: allowedValues,
            value: value,
            schema: {
                configuration: null,
                items: 'component',
                renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)
            }
        };
    };
});
parcelRegister("c3LW9", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", ()=>$e80217ec1ee321d5$export$e6d015aa746cbdaf);
    var $5fc53;
    var $o7K5u;
    const $e80217ec1ee321d5$export$e6d015aa746cbdaf = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.dateTime ?? null,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                custom: node.type,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE)
            }
        });
});
parcelRegister("h92P3", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", ()=>$1bb7cdf99e93ff64$export$edf5c98d20696686);
    var $5fc53;
    var $o7K5u;
    const $1bb7cdf99e93ff64$export$edf5c98d20696686 = (node)=>{
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOptions, (0, (0, parcelRequire("o7K5u")).toLegacyConnectOption));
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.connectMultiSelectFieldOptions, (0, (0, parcelRequire("o7K5u")).toLegacyConnectOption));
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value.length ? value : null,
            allowedValues: allowedValues,
            schema: {
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
                configuration: null
            }
        };
    };
});
parcelRegister("aeO9V", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectNumberToLegacyField", ()=>$b8a5823753f7873f$export$4638a5dd3285d8f2);
    var $5fc53;
    var $o7K5u;
    const $b8a5823753f7873f$export$4638a5dd3285d8f2 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.number ?? null,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                custom: node.type,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE)
            }
        });
});
parcelRegister("6Tnq8", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", ()=>$f9558299012f1c2e$export$11063e1f9210f191);
    var $kz2lw;
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $f9558299012f1c2e$var$emptyAdfObject = (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
    const $f9558299012f1c2e$var$getPlainTextValue = (node)=>{
        if (!node.richText) return null;
        if (node.richText.plainText == null) return '';
        return node.richText.plainText;
    };
    const $f9558299012f1c2e$export$11063e1f9210f191 = (node)=>{
        const { renderer: renderer } = node;
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const isPlainTextRenderer = renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
        const values = isPlainTextRenderer ? {
            value: $f9558299012f1c2e$var$getPlainTextValue(node)
        } : {
            adfValue: node.richText?.adfValue?.json || $f9558299012f1c2e$var$emptyAdfObject
        };
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            ...values,
            schema: {
                custom: (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
                renderer: renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            }
        };
    };
});
parcelRegister("kz2lw", function(module, exports) {
    $parcel$export(module.exports, "getEmptyADF", ()=>$06167b6274ea84aa$export$d109ab46c9575565);
    var $ebjue;
    const $06167b6274ea84aa$export$d109ab46c9575565 = ()=>({
            type: 'doc',
            version: 1,
            content: []
        });
});
parcelRegister("ebjue", function(module, exports) {
    $parcel$export(module.exports, "isEmpty", ()=>$9e55b7d6fded4629$export$dd1bc94b04021eeb);
    const $9e55b7d6fded4629$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;
});
parcelRegister("dMYPq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4fed9edf4c76e19$export$2e2bcd8739ae039);
    var $dJl1T;
    const $f4fed9edf4c76e19$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
    const $f4fed9edf4c76e19$var$isFieldMissingRenderer = (field)=>{
        try {
            if (!('renderer' in field)) return false;
            if (field?.renderer) return false;
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($f4fed9edf4c76e19$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
            return true;
        } catch  {
            return false;
        }
    };
    var $f4fed9edf4c76e19$export$2e2bcd8739ae039 = $f4fed9edf4c76e19$var$isFieldMissingRenderer;
});
parcelRegister("6mbsj", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", ()=>$ceb0872dd5eafe49$export$e44db7cf61369a28);
    var $5fc53;
    var $o7K5u;
    const $ceb0872dd5eafe49$export$e44db7cf61369a28 = (node)=>{
        let value = null;
        if (node.fieldOption != null) value = {
            id: parseInt(node.fieldOption?.optionId, 10),
            value: node.fieldOption?.value
        };
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.connectSingleSelectFieldOptions, (0, (0, parcelRequire("o7K5u")).toLegacyConnectOption)),
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                custom: node.type,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("d3nG3", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectTextToLegacyField", ()=>$145b645a3d2e801e$export$dd05277f5aa90657);
    var $5fc53;
    var $o7K5u;
    const $145b645a3d2e801e$export$dd05277f5aa90657 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.text,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        });
});
parcelRegister("1xW6n", function(module, exports) {
    $parcel$export(module.exports, "transformAggDataClassificationToLegacyField", ()=>$1a8d4561538d1d2b$export$b5edfdc89a7a2932);
    var $5fc53;
    var $o7K5u;
    const $1a8d4561538d1d2b$export$b5edfdc89a7a2932 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            key: (0, (0, parcelRequire("5fc53")).DATA_CLASSIFICATION_TYPE),
            value: node,
            schema: {
                configuration: null,
                items: null,
                renderer: null,
                custom: null,
                system: null,
                type: (0, (0, parcelRequire("5fc53")).DATA_CLASSIFICATION_TYPE)
            }
        });
});
parcelRegister("fW9XR", function(module, exports) {
    $parcel$export(module.exports, "transformAggDatePickerToLegacyField", ()=>$c44a652aaa9bff90$export$3d6e51d37c0454a9);
    var $5fc53;
    var $o7K5u;
    const $c44a652aaa9bff90$export$3d6e51d37c0454a9 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: typeof node.date === 'string' ? node.date : null,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATE_CF_TYPE),
                        configuration: null,
                        system: node.type,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: null,
                        items: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).DATE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).BASELINE_START_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).BASELINE_END_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: typeof node.date === 'string' ? node.date : null,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATE_CF_TYPE),
                        custom: node.type,
                        configuration: null,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        system: null,
                        items: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("bKMMB", function(module, exports) {
    $parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", ()=>$fb29b1af2f1467e0$export$3de22f1277f0c239);
    var $5fc53;
    var $o7K5u;
    const $fb29b1af2f1467e0$var$defaultSchema = {
        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE),
        custom: null,
        system: null,
        configuration: null,
        items: null,
        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
    };
    const $fb29b1af2f1467e0$export$3de22f1277f0c239 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).CREATED:
            case 0, (0, parcelRequire("5fc53")).UPDATED:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.dateTime || '',
                    schema: {
                        ...$fb29b1af2f1467e0$var$defaultSchema,
                        system: node.type,
                        renderer: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).RESOLUTION_DATE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.dateTime ?? null,
                    schema: {
                        ...$fb29b1af2f1467e0$var$defaultSchema,
                        system: node.type,
                        renderer: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).FIRST_RESPONSE_DATE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_DATE_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.dateTime ?? null,
                    schema: {
                        ...$fb29b1af2f1467e0$var$defaultSchema,
                        custom: node.type
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("7JL37", function(module, exports) {
    $parcel$export(module.exports, "transformAggEpicLinkToLegacyField", ()=>$3279d658ea1a4982$export$1311f30c94840aa2);
    var $kFsv3;
    var $5fc53;
    var $o7K5u;
    const $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
        if (epic == null) return null;
        return {
            id: Number(epic.issueId),
            key: epic.key || '',
            done: !!epic.done,
            name: epic.name || '',
            summary: epic.summary || '',
            color: {
                key: epic.color ?? (0, (0, parcelRequire("kFsv3")).AgileColors).AGILE_COLOR_1
            },
            fromCache: false
        };
    };
    const $3279d658ea1a4982$export$1311f30c94840aa2 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).EPIC_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl,
            value: $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink(node.epic),
            schema: {
                configuration: null,
                items: null,
                renderer: 'jira-text-renderer',
                type: 'any',
                custom: (0, (0, parcelRequire("5fc53")).EPIC_TYPE),
                system: null
            }
        };
    };
});
parcelRegister("dulCG", function(module, exports) {
    $parcel$export(module.exports, "transformAggFlagToLegacyField", ()=>$f31e97d89b497c1c$export$31555b6ea19f4c2);
    var $5fc53;
    var $o7K5u;
    const $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag = (flag)=>{
        if (flag == null || flag.isFlagged == null) return null;
        return [
            {
                value: flag.isFlagged
            }
        ];
    };
    const $f31e97d89b497c1c$export$31555b6ea19f4c2 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag(node.flag),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).FLAGGED_CF_TYPE),
                items: 'option',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("6vno6", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeDateToLegacyField", ()=>$f5e60b2709763004$export$30fccfce22948120);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $f5e60b2709763004$export$30fccfce22948120 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.date,
            autoCompleteUrl: null,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATE_CF_TYPE)
            }
        };
    };
});
parcelRegister("as0vY", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", ()=>$3520698819975afe$export$61b1f0cbd04c7b9c);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $3520698819975afe$export$61b1f0cbd04c7b9c = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.dateTime,
            autoCompleteUrl: null,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE)
            }
        };
    };
});
parcelRegister("6dPLd", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeGroupToLegacyField", ()=>$ce6b58a5b1f45912$export$60b03d63015cbb9f);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $ce6b58a5b1f45912$export$60b03d63015cbb9f = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.selectedGroup ? {
                name: node.selectedGroup.name
            } : null,
            autoCompleteUrl: null,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
            }
        };
    };
});
parcelRegister("gKccZ", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", ()=>$256d8054300c3cdf$export$2dfa4944fba5d1f5);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $256d8054300c3cdf$export$2dfa4944fba5d1f5 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const value = node.selectedGroupsConnection?.edges?.length ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
                name: name
            })) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("jnUrZ", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeNumberToLegacyField", ()=>$c68528ed0dfd109c$export$5dab8986dc45db07);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $c68528ed0dfd109c$export$5dab8986dc45db07 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.number,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE)
            }
        };
    };
});
parcelRegister("iJtmd", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeObjectToLegacyField", ()=>$c814454c00552e79$export$fbdabdbae2a203b9);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $c814454c00552e79$export$fbdabdbae2a203b9 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const value = (()=>{
            if (node.object == null) return null;
            try {
                return JSON.parse(node.object);
            } catch (e) {
                throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
            }
        })();
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_OBJECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("iPyq0", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeStringToLegacyField", ()=>$29f719811f573640$export$3a581fb4b3e578bd);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $29f719811f573640$export$3a581fb4b3e578bd = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.text,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        };
    };
});
parcelRegister("384lj", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeStringsToLegacyField", ()=>$0d30cb879c19e1ba$export$418a06cb5dc6aba5);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $0d30cb879c19e1ba$export$418a06cb5dc6aba5 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
        const value = hasValue ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            autoCompleteUrl: node.searchUrl,
            schema: {
                configuration: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("axTS6", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeUserToLegacyField", ()=>$0669940239efeaff$export$bc73c7a747f907e5);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    var $iob0v;
    const $0669940239efeaff$export$bc73c7a747f907e5 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.user ? (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)(node.user) : null,
            autoCompleteUrl: node.searchUrl,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE)
            }
        };
    };
});
parcelRegister("iob0v", function(module, exports) {
    $parcel$export(module.exports, "transformJiraUserToLegacyServerUser", ()=>$42550039db1edc00$export$d7b231260a016eaf);
    const $42550039db1edc00$var$getAccountType = (objectType)=>{
        switch(objectType){
            case 'AtlassianAccountUser':
                return 0, $145004f7a92e2423$export$981400c14dd99bc0;
            case 'CustomerUser':
                return 0, $145004f7a92e2423$export$2823897fb92cd040;
            case 'AppUser':
                return 0, $145004f7a92e2423$export$1973ca62b6c5abfe;
            default:
                return 0, $145004f7a92e2423$export$d1f5101c0939e3fe;
        }
    };
    const $42550039db1edc00$var$generateAvatarUrls = (url)=>({
            '16x16': url,
            '24x24': url,
            '32x32': url,
            '48x48': url
        });
    const $42550039db1edc00$export$d7b231260a016eaf = (user)=>{
        if (!user) return null;
        const userOptionalKeysMap = {
            emailAddress: 'email',
            locale: 'locale',
            timeZone: 'zoneinfo'
        };
        const optionalValues = {};
        Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
            const aggValue = user[aggKey];
            if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
        });
        const avatars = user.picture != null ? {
            avatarUrl: user.picture,
            avatarUrls: $42550039db1edc00$var$generateAvatarUrls(user.picture)
        } : {};
        return {
            ...avatars,
            ...optionalValues,
            accountId: user.accountId,
            accountType: $42550039db1edc00$var$getAccountType(user.__typename),
            active: user.accountStatus === 'active',
            displayName: user.name
        };
    };
});
const $145004f7a92e2423$export$981400c14dd99bc0 = 'atlassian';
const $145004f7a92e2423$export$2823897fb92cd040 = 'customer';
const $145004f7a92e2423$export$1973ca62b6c5abfe = 'app';
const $145004f7a92e2423$export$d1f5101c0939e3fe = 'unknown';
parcelRegister("lfJ6H", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeUsersToLegacyField", ()=>$eb3ddd1fb571c94a$export$bbfea2e2f2c853b8);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    var $iob0v;
    const $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const value = node.selectedUsersConnection?.edges?.length ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedUsersConnection, (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE),
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("9UXU7", function(module, exports) {
    $parcel$export(module.exports, "transformAggGoalsToLegacyField", ()=>$a8d444f432651533$export$158301a02ae4cbe7);
    var $5fc53;
    var $o7K5u;
    const $a8d444f432651533$export$158301a02ae4cbe7 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)) return undefined;
        const value = node.selectedGoals ? {
            goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                    id: edge?.node?.id || '',
                    name: edge?.node?.name || '',
                    status: edge?.node?.status || null
                })) || [],
            totalCount: node.selectedGoals?.totalCount || 0
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
                items: null,
                renderer: null,
                system: null,
                type: (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)
            }
        };
    };
});
parcelRegister("b6BoU", function(module, exports) {
    $parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", ()=>$d0a0e03637cc83cd$export$62db794d5816e28e);
    var $5fc53;
    var $o7K5u;
    var $hA3EZ;
    const $d0a0e03637cc83cd$var$transformJiraRoleToRestriction = (role)=>{
        if (role == null) return null;
        return {
            restrictionValue: role.roleId
        };
    };
    const $d0a0e03637cc83cd$export$62db794d5816e28e = (node, context)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ISSUE_RESTRICTION_TYPE)) return undefined;
        const roles = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedRolesConnection, $d0a0e03637cc83cd$var$transformJiraRoleToRestriction);
        const restrictions = roles.length > 0 ? {
            projectrole: roles
        } : {};
        const project = (0, (0, parcelRequire("hA3EZ")).getSystemAggJiraProject)(context);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                shouldDisplay: project.canSetIssueRestriction === true,
                issuerestrictions: restrictions
            },
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_RESTRICTION_TYPE),
                custom: null,
                system: node.type
            }
        };
    };
});
parcelRegister("hA3EZ", function(module, exports) {
    $parcel$export(module.exports, "getProjectType", ()=>$e3d5807b112803bd$export$3dd0da95519c1a33);
    $parcel$export(module.exports, "getSystemAggJiraProject", ()=>$e3d5807b112803bd$export$d100105d56da4a0a);
    $parcel$export(module.exports, "isAggJiraProjectClassic", ()=>$e3d5807b112803bd$export$3502ed01c034e451);
    $parcel$export(module.exports, "transformAggProjectToProjectContext", ()=>$e3d5807b112803bd$export$275f121d4e6f5165);
    $parcel$export(module.exports, "transformAggProjectToLegacyField", ()=>$e3d5807b112803bd$export$30c14b802399f417);
    var $2vSU6;
    var $5fc53;
    var $g5X3G;
    var $k5x3N;
    var $o7K5u;
    const $e3d5807b112803bd$var$getProjectStatus = (status)=>{
        switch(status){
            case 'ACTIVE':
                return 0, $cd476f3ecebdab63$export$62113557945f790a;
            case 'ARCHIVED':
                return 0, $cd476f3ecebdab63$export$4ccc35479ba9ad1;
            case 'DELETED':
                return 0, $cd476f3ecebdab63$export$a95d71e582b8bc0;
            default:
                return 0, $cd476f3ecebdab63$export$62113557945f790a;
        }
    };
    const $e3d5807b112803bd$export$3dd0da95519c1a33 = (projectType)=>{
        switch(projectType){
            case 'SERVICE_DESK':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'BUSINESS':
                return 0, (0, parcelRequire("2vSU6")).CORE_PROJECT;
            case 'SOFTWARE':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'PRODUCT_DISCOVERY':
                return 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT;
            default:
                return null;
        }
    };
    const $e3d5807b112803bd$export$d100105d56da4a0a = (fields)=>{
        const projectField = fields?.find((edge)=>edge?.node?.__typename === (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, (0, parcelRequire("5fc53")).PROJECT_TYPE))?.node;
        if (projectField == null || projectField.__typename !== (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
        if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
        return projectField.project;
    };
    const $e3d5807b112803bd$export$f7d5cb97957d02e3 = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
    const $e3d5807b112803bd$export$3502ed01c034e451 = (project)=>!$e3d5807b112803bd$export$f7d5cb97957d02e3(project);
    const $e3d5807b112803bd$var$transformAggProjectToServerProjectOption = (project)=>{
        if (project == null) return null;
        const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
        return {
            name: name,
            id: projectId ?? undefined,
            key: (0, (0, parcelRequire("g5X3G")).toProjectKey)(key),
            avatarUrls: {
                '48x48': avatar.large
            }
        };
    };
    const $e3d5807b112803bd$export$275f121d4e6f5165 = (fields)=>{
        const project = $e3d5807b112803bd$export$d100105d56da4a0a(fields);
        const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
        const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
        if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
        return {
            projectId: projectId,
            projectType: projectType,
            projectName: name,
            projectKey: key,
            projectStatus: $e3d5807b112803bd$var$getProjectStatus(status),
            avatarUrl: avatar.medium,
            isSimplified: $e3d5807b112803bd$export$f7d5cb97957d02e3(project),
            boardId: navigationMetadata?.boardId
        };
    };
    const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: [],
            value: $e3d5807b112803bd$var$transformAggProjectToServerProjectOption(node.project),
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                type: (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
                custom: (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE),
                system: null
            }
        });
    const $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
        if ($e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType) !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            key: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE),
            title: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE),
            value: node.project?.similarIssues?.featureEnabled === true,
            schema: {
                configuration: null,
                items: null,
                renderer: null,
                type: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE)
            }
        };
    };
    const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField = (node)=>{
        if (node?.__typename !== (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, (0, parcelRequire("5fc53")).PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
        const projectField = node;
        if (projectField == null || projectField.__typename !== (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
        if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
        const project = projectField.project;
        const { projectType: type } = project;
        const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
        if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                projectType: projectType
            }
        };
    };
    const $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType = (node)=>{
        const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType);
        if (projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField(node);
        return undefined;
    };
    const $e3d5807b112803bd$export$30c14b802399f417 = (node)=>{
        if ((0, (0, parcelRequire("k5x3N")).isJPDDeliveryLinkTypeFilteringEnabled)()) switch(node.type){
            case 0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
            case 0, (0, parcelRequire("5fc53")).PROJECT_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType(node);
            default:
                return undefined;
        }
        else switch(node.type){
            case 0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
            case 0, (0, parcelRequire("5fc53")).PROJECT_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
            default:
                return undefined;
        }
    };
});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';
parcelRegister("k5x3N", function(module, exports) {
    $parcel$export(module.exports, "isJPDDeliveryLinkTypeFilteringEnabled", ()=>$9be9ea07d5dfc538$export$8fac1563227555f2);
    var $co1wz;
    const $9be9ea07d5dfc538$export$8fac1563227555f2 = ()=>(0, (0, parcelRequire("co1wz")).ff)('polaris.jpd-panel-filter-by-delivery-link-type', false);
});
parcelRegister("gak3n", function(module, exports) {
    $parcel$export(module.exports, "getSystemAggJiraIssueType", ()=>$4f9b530de681b60e$export$b4644a0cc2f2935e);
    $parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", ()=>$4f9b530de681b60e$export$2356062173546155);
    $parcel$export(module.exports, "transformAggIssueTypeToLegacyField", ()=>$4f9b530de681b60e$export$de2eb3b47c7c887b);
    var $imYFg;
    var $5fc53;
    var $o7K5u;
    const $4f9b530de681b60e$export$d95e76b2d065f98d = {
        avatarId: 0,
        self: ''
    };
    const $4f9b530de681b60e$export$b4644a0cc2f2935e = (fields)=>{
        const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE))?.node;
        if (issueTypeField == null || issueTypeField.__typename !== (0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
        if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
        return issueTypeField.issueType;
    };
    const $4f9b530de681b60e$export$2356062173546155 = (issueType)=>({
            ...$4f9b530de681b60e$export$d95e76b2d065f98d,
            id: issueType.issueTypeId,
            iconUrl: issueType.avatar?.medium ?? '',
            name: issueType.name,
            description: 'description' in issueType && issueType.description != null ? issueType.description : '',
            hierarchyLevel: issueType.hierarchy.level,
            subtask: issueType.hierarchy.level === (0, (0, parcelRequire("imYFg")).ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
        });
    const $4f9b530de681b60e$export$de2eb3b47c7c887b = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $4f9b530de681b60e$export$2356062173546155(node.issueType),
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)
            }
        };
    };
});
parcelRegister("imYFg", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", ()=>$ccb1a8095461a82a$export$2fe6880f0073407c);
    var $g4tDr;
    const $ccb1a8095461a82a$export$2fe6880f0073407c = {
        SUBTASK_LEVEL: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_SUBTASK),
        BASE_LEVEL: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE),
        LEVEL_ONE: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC),
        LEVEL_TWO: 2
    };
});
parcelRegister("i47fO", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", ()=>$448e6754d8bf50d1$export$b14d30f2a9e4c343);
    var $9ar3z;
    var $5fc53;
    var $g5X3G;
    var $o7K5u;
    var $iob0v;
    const $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
        if (!approverPrincipal) return undefined;
        switch(approverPrincipal.__typename){
            case 0, (0, parcelRequire("5fc53")).JSM_USER_APPROVER_PRINCIPAL_FIELD:
                return {
                    id: (0, (0, parcelRequire("g5X3G")).toAccountId)(approverPrincipal.user.accountId),
                    name: approverPrincipal.user.name,
                    meta: {
                        jiraRest: approverPrincipal.jiraRest
                    },
                    type: 'user',
                    avatarUrl: approverPrincipal.user.picture
                };
            case 0, (0, parcelRequire("5fc53")).JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
                return {
                    id: (0, (0, parcelRequire("9ar3z")).toGroupId)(approverPrincipal.groupId),
                    meta: {
                        memberCount: approverPrincipal.memberCount,
                        approvedCount: approverPrincipal.approvedCount
                    },
                    name: approverPrincipal.name,
                    type: 'group'
                };
            default:
                return undefined;
        }
    };
    const $448e6754d8bf50d1$var$getApproverDecision = (decision)=>{
        switch(decision){
            case 0, (0, parcelRequire("9ar3z")).APPROVER_APPROVED:
                return 0, (0, parcelRequire("9ar3z")).APPROVER_APPROVED;
            case 0, (0, parcelRequire("9ar3z")).APPROVER_DECLINED:
                return 0, (0, parcelRequire("9ar3z")).APPROVER_DECLINED;
            case 0, (0, parcelRequire("9ar3z")).APPROVER_PENDING:
            default:
                return 0, (0, parcelRequire("9ar3z")).APPROVER_PENDING;
        }
    };
    const $448e6754d8bf50d1$var$transformApproverToLegacy = (approvalNode)=>{
        if (!approvalNode) return undefined;
        const approver = (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)(approvalNode.approver);
        if (!approver) return undefined;
        return {
            approverDecision: $448e6754d8bf50d1$var$getApproverDecision(approvalNode.approverDecision),
            approver: approver
        };
    };
    const $448e6754d8bf50d1$var$transformConfigurationToLegacy = (configurations)=>{
        const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
        const approverConfiguration = approversConfigurations[0];
        return {
            approvers: {
                type: approverConfiguration?.type ?? '',
                customFieldName: approverConfiguration?.fieldName ?? '',
                customFieldId: approverConfiguration?.fieldId ?? ''
            },
            condition: {
                type: condition?.type ?? '',
                value: condition?.value ?? ''
            }
        };
    };
    const $448e6754d8bf50d1$var$transformDateToLegacy = (date)=>({
            epochMillis: new Date(date).valueOf()
        });
    const $448e6754d8bf50d1$var$transformStatusToLegacy = (status)=>({
            name: status.name || '',
            category: Number(status.categoryId)
        });
    const $448e6754d8bf50d1$var$transformActiveApprovalToLegacy = (activeApproval)=>{
        const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
        return {
            id: id,
            approvalState: approvalState,
            approvedStatus: approvedStatus,
            finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
            name: name,
            pendingApprovalCount: pendingApprovalCount,
            canAnswerApproval: canAnswerApproval,
            approverPrincipals: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.approverPrincipals, $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy),
            approvers: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy),
            configuration: $448e6754d8bf50d1$var$transformConfigurationToLegacy(configurations),
            createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
            decisions: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.decisions, $448e6754d8bf50d1$var$transformApproverToLegacy),
            excludedApprovers: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.excludedApprovers, (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)),
            status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null
        };
    };
    const $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
        if (!completedApproval) return undefined;
        const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
        return {
            id: id,
            name: name,
            finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
            createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
            completedDate: $448e6754d8bf50d1$var$transformDateToLegacy(completedDate),
            status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null,
            approvers: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(completedApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy)
        };
    };
    const $448e6754d8bf50d1$export$b14d30f2a9e4c343 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SERVICEDESK_APPROVAL_TYPE)) return undefined;
        const activeApproval = node.activeApproval ? {
            activeApproval: $448e6754d8bf50d1$var$transformActiveApprovalToLegacy(node.activeApproval)
        } : {};
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                ...activeApproval,
                completedApprovals: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.completedApprovalsConnection, $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy)
            },
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: null,
                system: (0, (0, parcelRequire("5fc53")).SERVICEDESK_APPROVAL_TYPE),
                type: (0, (0, parcelRequire("5fc53")).SERVICEDESK_APPROVAL_TYPE)
            }
        };
    };
});
parcelRegister("9ar3z", function(module, exports) {
    $parcel$export(module.exports, "toGroupId", ()=>$4a7fc5eda3865b0e$export$779c261480444a4d);
    $parcel$export(module.exports, "APPROVER_PENDING", ()=>$4a7fc5eda3865b0e$export$3b59c4db06f5829b);
    $parcel$export(module.exports, "APPROVER_APPROVED", ()=>$4a7fc5eda3865b0e$export$e17ae8ca1010e2a4);
    $parcel$export(module.exports, "APPROVER_DECLINED", ()=>$4a7fc5eda3865b0e$export$b5a0d270c9cd7435);
    $parcel$export(module.exports, "APPROVAL_OK", ()=>$4a7fc5eda3865b0e$export$2e6187b6a4348938);
    const $4a7fc5eda3865b0e$export$779c261480444a4d = (x)=>x;
    const $4a7fc5eda3865b0e$export$3b59c4db06f5829b = 'pending';
    const $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4 = 'approved';
    const $4a7fc5eda3865b0e$export$b5a0d270c9cd7435 = 'declined';
    const $4a7fc5eda3865b0e$export$2e6187b6a4348938 = 'OK';
    const $4a7fc5eda3865b0e$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';
});
parcelRegister("gvljZ", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", ()=>$b281bef34e07e20f$export$850fadda8a5e6f27);
    var $5fc53;
    var $o7K5u;
    const $b281bef34e07e20f$export$850fadda8a5e6f27 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ENTITLEMENT_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.selectedEntitlement,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).ENTITLEMENT_CF_TYPE),
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("6XFn2", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", ()=>$926c732f6621d9fd$export$d4e0b2288fb31144);
    var $5fc53;
    var $o7K5u;
    const $926c732f6621d9fd$export$d4e0b2288fb31144 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.majorIncident,
            renderedValue: null,
            configuration: {},
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).MAJOR_INCIDENT_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        });
});
parcelRegister("6e1Ya", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", ()=>$0e4eebb31cef7087$export$7bd14951253a7c5f);
    var $5fc53;
    var $o7K5u;
    const $0e4eebb31cef7087$export$7bd14951253a7c5f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                    id: selectedNode.organizationId,
                    name: selectedNode.organizationName
                })),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE),
                items: 'sd-customerorganization',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("hBEiJ", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", ()=>$841fa8e5b9308ced$export$c52c6988b335096);
    var $5fc53;
    var $o7K5u;
    const $841fa8e5b9308ced$export$c52c6988b335096 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.feedback,
            schema: {
                type: 'sd-feedback',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: (0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_CF_TYPE),
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("1XNj2", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", ()=>$1edf1c9b37cdb462$export$6a53240e225f742);
    var $5fc53;
    var $o7K5u;
    const $1edf1c9b37cdb462$export$6a53240e225f742 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).REQUEST_LANGUAGE_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.language,
            allowedValues: [
                ...node.languages ?? []
            ],
            schema: {
                type: 'sd-request-lang',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: (0, (0, parcelRequire("5fc53")).REQUEST_LANGUAGE_CF_TYPE),
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("f6zXW", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", ()=>$8030de3237296d5c$export$5ffaab1383177efa);
    var $5fc53;
    var $o7K5u;
    const $8030de3237296d5c$var$transformRequestTypeToLegacy = (requestType)=>{
        if (!requestType) return null;
        return {
            requestType: {
                id: parseInt(requestType.requestTypeId, 10),
                issueTypeId: requestType.issueType?.issueTypeId || '',
                name: requestType.name || '',
                icon: {
                    _links: {
                        iconUrls: {
                            '48x48': requestType.avatar?.large || ''
                        }
                    }
                }
            }
        };
    };
    const $8030de3237296d5c$export$5ffaab1383177efa = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).REQUEST_TYPE_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $8030de3237296d5c$var$transformRequestTypeToLegacy(node.requestType),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).REQUEST_TYPE_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'sd-customerrequesttype'
            }
        };
    };
});
parcelRegister("fB4wX", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", ()=>$0ea07ade045943f7$export$5171c4d1ae5bcde5);
    var $5fc53;
    var $o7K5u;
    const $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder = (responder)=>{
        if (responder == null) return undefined;
        switch(responder.__typename){
            case 0, (0, parcelRequire("5fc53")).JSM_USER_RESPONDER_GQL_FIELD:
                if (responder.user === null) return undefined;
                return {
                    ari: responder.user.canonicalAccountId,
                    avatarUrl: responder.user.picture,
                    name: responder.user.name,
                    type: 'user'
                };
            case 0, (0, parcelRequire("5fc53")).JSM_TEAM_RESPONDER_FIELD:
                return {
                    ari: responder.teamId,
                    name: responder.teamName,
                    type: 'team'
                };
            default:
                return undefined;
        }
    };
    const $0ea07ade045943f7$export$5171c4d1ae5bcde5 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).RESPONDERS_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.respondersConnection, $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).RESPONDERS_CF_TYPE),
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("cXBkk", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", ()=>$5dcf9f49c6a1536d$export$702d3754a4c7d90a);
    var $5fc53;
    var $o7K5u;
    const $5dcf9f49c6a1536d$export$702d3754a4c7d90a = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SENTIMENT_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.sentiment,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).SENTIMENT_CF_TYPE),
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("iDKu3", function(module, exports) {
    $parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", ()=>$5345161012c71e28$export$98e4f56e2e6c44fe);
    var $5fc53;
    var $o7K5u;
    const $5345161012c71e28$var$defaultSchema = {
        configuration: null,
        items: 'string',
        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
    };
    const $5345161012c71e28$export$98e4f56e2e6c44fe = (node)=>{
        const selectedLabels = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: selectedLabels,
                    schema: {
                        ...$5345161012c71e28$var$defaultSchema,
                        custom: null,
                        system: node.type
                    }
                };
            case 0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: selectedLabels.length === 0 ? null : selectedLabels,
                    schema: {
                        ...$5345161012c71e28$var$defaultSchema,
                        custom: node.type,
                        system: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("aGv90", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", ()=>$ee565846dd4aef42$export$f968da580693597d);
    var $o7K5u;
    const $ee565846dd4aef42$export$f968da580693597d = (node)=>{
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
                groupId: groupNode.groupId,
                name: groupNode.name
            }));
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value.length > 0 ? value : null,
            schema: {
                type: 'array',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: 'group',
                configuration: null
            }
        };
    };
});
parcelRegister("19DRh", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", ()=>$d83d25c034b1d99f$export$869fb8fbcb97e0ee);
    var $5fc53;
    var $o7K5u;
    const $d83d25c034b1d99f$export$869fb8fbcb97e0ee = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
                {
                    const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOptions, (option)=>({
                            id: option.optionId,
                            value: option.value ?? null,
                            ari: option.id
                        }));
                    return {
                        ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                        value: value.length ? value : null,
                        allowedValues: [],
                        schema: {
                            type: 'array',
                            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                            custom: node.type,
                            system: null,
                            items: 'option',
                            configuration: null
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("lkW3a", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", ()=>$9b1f1d40e628c968$export$cdd9991119eb040e);
    var $2vSU6;
    var $co1wz;
    var $5fc53;
    var $o7K5u;
    var $hA3EZ;
    var $iob0v;
    const $9b1f1d40e628c968$export$cdd9991119eb040e = (node, context)=>{
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedUsersConnection, (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser));
        const legacyFieldValues = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value.length > 0 ? value : null,
            schema: {
                configuration: null,
                custom: node.type,
                items: 'user',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).REQUEST_PARTICIPANTS_CF_TYPE:
                {
                    if ((0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-request-participants_itocm') && node.__typename === (0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD)) return {
                        ...legacyFieldValues,
                        value: value
                    };
                    const project = (0, (0, parcelRequire("hA3EZ")).getSystemAggJiraProject)(context);
                    if ((0, (0, parcelRequire("hA3EZ")).getProjectType)(project.projectType) !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return undefined;
                    return {
                        ...legacyFieldValues,
                        value: value
                    };
                }
            case 0, (0, parcelRequire("5fc53")).PARTICIPANTS_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE:
                return legacyFieldValues;
            case 0, (0, parcelRequire("5fc53")).APPROVERS_LIST_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                {
                    const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                        {
                            key: 'isMulti',
                            value: String(node.isMulti)
                        }
                    ] : null;
                    return {
                        ...legacyFieldValues,
                        autoCompleteUrl: node.searchUrl,
                        schema: {
                            ...legacyFieldValues.schema,
                            configuration: schemaConfig
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("lQAwK", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", ()=>$dc0acfee4cadcdcd$export$6207ea60703068d8);
    var $5fc53;
    var $o7K5u;
    var $149sa;
    const $dc0acfee4cadcdcd$var$defaultSchema = {
        configuration: null,
        custom: null,
        items: 'version',
        renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
        system: null,
        type: 'array'
    };
    const $dc0acfee4cadcdcd$export$6207ea60703068d8 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE) && node.type !== (0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE) && node.type !== (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)) return undefined;
        const legacyFieldValues = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: [],
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedVersionsConnection, (0, (0, parcelRequire("149sa")).transformAggVersionToLegacyVersion))
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE:
                return {
                    ...legacyFieldValues,
                    value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                    schema: {
                        ...$dc0acfee4cadcdcd$var$defaultSchema,
                        custom: (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)
                    }
                };
            case 0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE:
            case 0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE:
                return {
                    ...legacyFieldValues,
                    schema: {
                        ...$dc0acfee4cadcdcd$var$defaultSchema,
                        system: node.type
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("149sa", function(module, exports) {
    $parcel$export(module.exports, "transformAggVersionToLegacyVersion", ()=>$4617842fe98d5759$export$becef8d087e8b62b);
    var $jPhQo;
    const $4617842fe98d5759$export$becef8d087e8b62b = (version)=>({
            id: version.versionId ?? '',
            name: version.name ?? '',
            description: version.description ?? '',
            archived: version.status === (0, (0, parcelRequire("jPhQo")).VersionStatus).ARCHIVED,
            released: version.status === (0, (0, parcelRequire("jPhQo")).VersionStatus).RELEASED,
            ari: version.id
        });
});
parcelRegister("jPhQo", function(module, exports) {
    $parcel$export(module.exports, "VersionStatus", ()=>$b5bd69c03cab3461$export$8c6e0f93bfb5c6a4);
    var $imYFg;
    const $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4 = {
        ARCHIVED: 'ARCHIVED',
        RELEASED: 'RELEASED',
        UNRELEASED: 'UNRELEASED'
    };
});
parcelRegister("8qOI6", function(module, exports) {
    $parcel$export(module.exports, "transformAggNumberToLegacyField", ()=>$b542e2b397d83c88$export$d754a24ed0096d2f);
    var $5fc53;
    var $o7K5u;
    const $b542e2b397d83c88$export$d754a24ed0096d2f = (node)=>{
        const fieldType = node.isStoryPointField === true ? (0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE) : node.type;
        switch(fieldType){
            case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.number ?? null,
                    schema: {
                        configuration: null,
                        items: null,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: fieldType,
                        system: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE)
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("cbd7V", function(module, exports) {
    $parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", ()=>$47597066e94f8347$export$f08d02fdc74f920e);
    var $5fc53;
    var $o7K5u;
    const $47597066e94f8347$export$f08d02fdc74f920e = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.originalEstimate?.timeInSeconds ?? null,
            schema: {
                configuration: null,
                custom: null,
                system: node.type,
                items: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE),
                renderer: null
            }
        };
    };
});
parcelRegister("6hj44", function(module, exports) {
    $parcel$export(module.exports, "transformAggPriorityToLegacyField", ()=>$47c25f6616be0140$export$9e966ce605f800d2);
    var $5fc53;
    var $o7K5u;
    const $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority = (priority)=>{
        if (priority == null) return null;
        return {
            id: priority.priorityId,
            iconUrl: String(priority.iconUrl || ''),
            name: priority.name || '',
            sequence: priority.sequence || undefined
        };
    };
    const $47c25f6616be0140$export$9e966ce605f800d2 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)) return undefined;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)('priorities' in node ? node.priorities : null, $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: allowedValues,
            value: $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority(node.priority),
            schema: {
                type: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
            }
        };
    };
});
parcelRegister("4nh4C", function(module, exports) {
    $parcel$export(module.exports, "transformAggProformaFormsToLegacyField", ()=>$27d464e5749e1114$export$fdcdbf17b0d4e36f);
    var $5fc53;
    var $o7K5u;
    const $27d464e5749e1114$export$fdcdbf17b0d4e36f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).PROFORMA_FORMS)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.proformaForms,
            schema: {
                configuration: null,
                items: null,
                system: (0, (0, parcelRequire("5fc53")).PROFORMA_FORMS),
                custom: null,
                renderer: null,
                type: (0, (0, parcelRequire("5fc53")).PROFORMA_FORMS)
            }
        };
    };
});
parcelRegister("2z4xE", function(module, exports) {
    $parcel$export(module.exports, "transformAggRadioSelectToLegacyField", ()=>$b545e68fef1c7c25$export$f147f1eb3a15ccfc);
    var $5fc53;
    var $o7K5u;
    const $b545e68fef1c7c25$export$f147f1eb3a15ccfc = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)) return undefined;
        const value = node.selectedOption ? {
            id: node.selectedOption?.optionId,
            value: node.selectedOption?.value,
            isDisabled: node.selectedOption?.isDisabled
        } : null;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
                id: option.optionId,
                value: option.value ?? null,
                ari: option.id
            }));
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: allowedValues,
            schema: {
                type: 'option',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("cO2KQ", function(module, exports) {
    $parcel$export(module.exports, "transformAggResolutionToLegacyField", ()=>$b13d1a2c3ca9d3cb$export$179f600c7e1d0230);
    var $5fc53;
    var $o7K5u;
    const $b13d1a2c3ca9d3cb$var$resolutionTransformer = (resolution)=>{
        if (resolution == null) return null;
        return {
            id: resolution.resolutionId,
            name: resolution.name || ''
        };
    };
    const $b13d1a2c3ca9d3cb$export$179f600c7e1d0230 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)) return undefined;
        const value = $b13d1a2c3ca9d3cb$var$resolutionTransformer(node.resolution);
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.resolutions, $b13d1a2c3ca9d3cb$var$resolutionTransformer);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: allowedValues,
            schema: {
                type: (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE),
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("5sETx", function(module, exports) {
    $parcel$export(module.exports, "transformAggRichTextToLegacyField", ()=>$181b5722dae42ee4$export$e65ff2ce94be106e);
    var $kz2lw;
    var $5fc53;
    var $fCo6Y;
    var $o7K5u;
    var $dMYPq;
    const $181b5722dae42ee4$var$emptyAdfObject = (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
    const $181b5722dae42ee4$var$getSchema = (aggType, renderer)=>{
        switch(aggType){
            case 0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE:
                return {
                    custom: aggType,
                    renderer: renderer,
                    type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                    system: null,
                    configuration: null,
                    items: null
                };
            case 0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE:
            case 0, (0, parcelRequire("5fc53")).ENVIRONMENT_TYPE:
            default:
                return {
                    system: aggType,
                    renderer: renderer,
                    type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    configuration: null,
                    items: null
                };
        }
    };
    const $181b5722dae42ee4$var$getPlainTextValue = (node)=>{
        if (!node.richText) return null;
        if (node.richText?.plainText == null) return '';
        return node.richText?.plainText;
    };
    const $181b5722dae42ee4$export$e65ff2ce94be106e = (node)=>{
        const { renderer: renderer } = node;
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const isPlainTextRenderer = node.type !== (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE) && renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
        if (isPlainTextRenderer) return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $181b5722dae42ee4$var$getPlainTextValue(node),
            schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
        };
        const adfValueJson = node.richText?.adfValue?.json ?? null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            adfValue: adfValueJson ? (0, (0, parcelRequire("fCo6Y")).removeCollectionFromAdf)(adfValueJson) : $181b5722dae42ee4$var$emptyAdfObject,
            value: null,
            schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
        };
    };
});
parcelRegister("fCo6Y", function(module, exports) {
    $parcel$export(module.exports, "emptyAdfObject", ()=>$79bd166f69131b05$export$202742e99f678c60);
    $parcel$export(module.exports, "removeCollectionFromAdf", ()=>$79bd166f69131b05$export$9e9311e676291037);
    $parcel$export(module.exports, "convertAdfStringToObject", ()=>$79bd166f69131b05$export$ee70d4eb14697455);
    $parcel$export(module.exports, "isOnlyWhitespaceAdf", ()=>$79bd166f69131b05$export$cf4bde415465976c);
    $parcel$export(module.exports, "removeNewLineCharactersFromAdf", ()=>$79bd166f69131b05$export$d6ce0667c33b94ff);
    $parcel$export(module.exports, "removeTrailingNewLineCharacters", ()=>$79bd166f69131b05$export$3688e35a300432d6);
    $parcel$export(module.exports, "simplifyAdf", ()=>$79bd166f69131b05$export$def86d25f0c7f0bc);
    $parcel$export(module.exports, "hasMediaFileNodes", ()=>$79bd166f69131b05$export$9a632b58fb9b287c);
    $parcel$export(module.exports, "hasMediaFileNodesUpdated", ()=>$79bd166f69131b05$export$80a6e90c7b29d88c);
    var $lmhF9;
    var $l1C1k;
    var $dJl1T;
    const $79bd166f69131b05$export$202742e99f678c60 = {
        type: 'doc',
        version: 1,
        content: []
    };
    const $79bd166f69131b05$export$9e9311e676291037 = (adf)=>{
        if (adf === null || adf === undefined) return null;
        if (adf.type === 'media' && adf.attrs) return {
            ...adf,
            attrs: {
                ...adf.attrs,
                collection: ''
            }
        };
        if (adf.type === 'mediaInline' && adf.attrs) return {
            ...adf,
            attrs: {
                ...adf.attrs,
                collection: ''
            }
        };
        if (adf.content) return {
            ...adf,
            content: adf.content.map($79bd166f69131b05$export$9e9311e676291037)
        };
        return adf;
    };
    const $79bd166f69131b05$export$ee70d4eb14697455 = (adf)=>{
        if (typeof adf === 'string') try {
            return $79bd166f69131b05$export$9e9311e676291037(JSON.parse(adf));
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
            return null;
        }
        return $79bd166f69131b05$export$9e9311e676291037(adf);
    };
    const $79bd166f69131b05$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
            if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
            return false;
        }) : false;
    const $79bd166f69131b05$export$d6ce0667c33b94ff = (adf)=>{
        if (!adf || !adf.content) return $79bd166f69131b05$export$202742e99f678c60;
        let len;
        for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
            if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
        }
        return {
            ...adf,
            content: adf.content.slice(0, len + 1)
        };
    };
    const $79bd166f69131b05$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
    const $79bd166f69131b05$export$def86d25f0c7f0bc = (adf)=>$79bd166f69131b05$export$cf4bde415465976c(adf) ? $79bd166f69131b05$export$202742e99f678c60 : adf;
    const $79bd166f69131b05$export$9a632b58fb9b287c = (doc)=>{
        const mediaNodes = new Map();
        (0, (0, parcelRequire("l1C1k")).traverse)(doc, {
            media: (node)=>{
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                mediaNodes.set(mediaNode.attrs.id, node);
            },
            mediaInline: (node)=>{
                const mediaInlineNode = node;
                mediaNodes.set(mediaInlineNode.attrs.id, node);
            }
        });
        return mediaNodes.size > 0;
    };
    const $79bd166f69131b05$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
        const currentMediaNodes = new Set();
        const newMediaNodes = new Set();
        const updatedMediaNodes = new Set();
        if (newDoc) (0, (0, parcelRequire("l1C1k")).traverse)(newDoc, {
            media: (node)=>{
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                newMediaNodes.add(mediaNode.attrs.id);
            },
            mediaInline: (node)=>{
                const mediaInlineNode = node;
                newMediaNodes.add(mediaInlineNode.attrs.id);
            }
        });
        if (currentDoc) (0, (0, parcelRequire("l1C1k")).traverse)(currentDoc, {
            media: (node)=>{
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                currentMediaNodes.add(mediaNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
                }
            },
            mediaInline: (node)=>{
                const mediaInlineNode = node;
                currentMediaNodes.add(mediaInlineNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
                }
            }
        });
        return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
    };
    const $79bd166f69131b05$export$ddf077301434502d = (doc)=>{
        if (doc === null || doc === undefined) return false;
        const nonSimpleTextNodes = (0, (0, parcelRequire("lmhF9")).filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
        return nonSimpleTextNodes.length === 0;
    };
    const $79bd166f69131b05$export$2277e89f0b6d4ed = async (node)=>{
        const { defaultSchema: defaultSchema } = await (parcelRequire("j87Vo"));
        const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("h2XnI"));
        const { JSONTransformer: JSONTransformer } = await (parcelRequire("hgt9V"));
        const jsonTransformer = new JSONTransformer();
        const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
        if (node === null || node === undefined) return '';
        const pmNode = jsonTransformer.parse(node);
        return wikiMarkupTransformer.encode(pmNode);
    };
});
parcelRegister("lmhF9", function(module, exports) {
    $parcel$export(module.exports, "filter", ()=>$cb7d90be6f5f5975$export$3dea766d36a8935f);
    var $l1C1k;
    function $cb7d90be6f5f5975$export$3dea766d36a8935f(adf, callback) {
        const result = [];
        (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            any: (node)=>{
                if (callback(node)) result.push(node);
            }
        });
        return result;
    }
});
parcelRegister("l1C1k", function(module, exports) {
    $parcel$export(module.exports, "traverse", ()=>$b903aab814d8ed47$export$df3f009e3d155b20);
    function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
        return true;
    }
    function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
        if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
        return $b903aab814d8ed47$var$traverseNode(adf, {
            node: undefined
        }, visitors, 0, 0);
    }
    function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
        const visitor = visitors[adfNode.type] || visitors['any'];
        let newNode = {
            ...adfNode
        };
        if (visitor) {
            const processedNode = visitor({
                ...newNode
            }, parent, index, depth);
            if (processedNode === false) return false;
            newNode = processedNode || adfNode;
        }
        if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
            if (!node) return acc;
            const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
                node: newNode,
                parent: parent
            }, visitors, idx, depth + 1);
            if (processedNode !== false) acc.push(processedNode);
            return acc;
        }, []);
        return newNode;
    }
});
parcelRegister("j87Vo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8Q4nN").then(()=>parcelRequire('kOFhM'));
});
parcelRegister("h2XnI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ikOjy").then(()=>parcelRequire('dN5CS'));
});
parcelRegister("hgt9V", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("akgCU").then(()=>parcelRequire('hYNZx'));
});
parcelRegister("f454b", function(module, exports) {
    $parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", ()=>$811c3c0495fb451c$export$45e25e2a6750ea5a);
    var $5fc53;
    var $o7K5u;
    const $811c3c0495fb451c$var$transformJiraSecurityLevel = (securityLevel)=>{
        if (securityLevel == null) return null;
        return {
            id: securityLevel.securityId,
            description: securityLevel.description || '',
            name: securityLevel.name || ''
        };
    };
    const $811c3c0495fb451c$export$45e25e2a6750ea5a = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $811c3c0495fb451c$var$transformJiraSecurityLevel(node.securityLevel),
            allowedValues: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.securityLevels, $811c3c0495fb451c$var$transformJiraSecurityLevel),
            schema: {
                configuration: null,
                type: (0, (0, parcelRequire("5fc53")).SECURITY_LEVEL_TYPE_OVERRIDE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).SECURITY_LEVEL_TYPE),
                items: null
            }
        });
});
parcelRegister("aafIf", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", ()=>$950a9b8297396bb3$export$e6697ec5bdac9ec0);
    var $o7K5u;
    const $950a9b8297396bb3$export$e6697ec5bdac9ec0 = (node)=>{
        const value = node.selectedGroup != null ? {
            groupId: node.selectedGroup.groupId,
            name: node.selectedGroup.name
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                type: 'group',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("2yWre", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", ()=>$f5309f9bc8791ddf$export$31f32b3fd9e5ab6);
    var $5fc53;
    var $o7K5u;
    const $f5309f9bc8791ddf$var$defaultSchema = {
        configuration: null,
        items: null,
        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
    };
    const $f5309f9bc8791ddf$export$31f32b3fd9e5ab6 = (node)=>{
        const defaultTransformedField = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.text
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).EPIC_NAME_TYPE:
            case 0, (0, parcelRequire("5fc53")).MESSAGE_EDIT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MESSAGE_VIEW_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).READ_ONLY_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_PROPERTY_CF_TYPE:
                return {
                    ...defaultTransformedField,
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        custom: node.type,
                        system: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
                    }
                };
            case 0, (0, parcelRequire("5fc53")).RANK_CF_TYPE:
                return {
                    ...defaultTransformedField,
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        custom: node.type,
                        system: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_ANY_CF_TYPE)
                    }
                };
            case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                return {
                    ...defaultTransformedField,
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                        custom: null,
                        system: node.type
                    }
                };
            case 0, (0, parcelRequire("5fc53")).SERVICEDESK_PRACTICES_TYPE:
                return node.text != null ? {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: [
                        node.text
                    ],
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        renderer: null,
                        custom: null,
                        system: node.type,
                        type: (0, (0, parcelRequire("5fc53")).SERVICEDESK_PRACTICES_TYPE)
                    }
                } : undefined;
            default:
                return undefined;
        }
    };
});
parcelRegister("lUeQj", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleSelectToLegacyField", ()=>$9513f3f43c691d67$export$4e113f935e09d226);
    var $5fc53;
    var $o7K5u;
    const $9513f3f43c691d67$var$getField = (node, customType)=>{
        const value = node.fieldOption != null ? {
            ari: node.fieldOption.id,
            id: node.fieldOption.optionId,
            value: node.fieldOption.value
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                type: 'option',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: customType || node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
    const $9513f3f43c691d67$export$4e113f935e09d226 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).EPIC_STATUS_TYPE:
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
                return $9513f3f43c691d67$var$getField(node);
            case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                return $9513f3f43c691d67$var$getField(node, (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE));
            default:
                return undefined;
        }
    };
});
parcelRegister("6SWOK", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", ()=>$7348765074cf60a5$export$7bf73fc06c6d71be);
    var $5fc53;
    var $o7K5u;
    var $iob0v;
    const $7348765074cf60a5$export$7bf73fc06c6d71be = (node)=>{
        const legacyField = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.user ? (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)(node.user) : null
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
                return {
                    ...legacyField,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE),
                        custom: null,
                        system: node.type,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null,
                        items: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).LAST_UPDATER_OR_COMMENTER_CF_TYPE:
                return {
                    ...legacyField,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE),
                        custom: node.type,
                        system: null,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null,
                        items: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("cMc7B", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", ()=>$1c34fc6a70d0e0b4$export$d03f622577260442);
    var $5fc53;
    var $o7K5u;
    var $149sa;
    const $1c34fc6a70d0e0b4$export$d03f622577260442 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)) return undefined;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.singlePickerVersions, (0, (0, parcelRequire("149sa")).transformAggVersionToLegacyVersion));
        const value = node.version ? (0, (0, parcelRequire("149sa")).transformAggVersionToLegacyVersion)(node.version) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: allowedValues,
            value: value,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_VERSION_CF_TYPE),
                custom: (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE),
                system: null
            }
        };
    };
});
parcelRegister("38GNL", function(module, exports) {
    $parcel$export(module.exports, "transformAggSprintToLegacyField", ()=>$05e0b9d6b707c3a6$export$9b5bb05d50970021);
    var $5fc53;
    var $o7K5u;
    const $05e0b9d6b707c3a6$var$SprintOptionalKeyMap = {
        goal: 'goal',
        completeDate: 'completionDate',
        startDate: 'startDate',
        endDate: 'endDate'
    };
    const $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint = (sprint)=>{
        const optionalValues = {};
        Object.keys($05e0b9d6b707c3a6$var$SprintOptionalKeyMap).forEach((key)=>{
            const aggKey = $05e0b9d6b707c3a6$var$SprintOptionalKeyMap[key];
            const aggValue = sprint[aggKey];
            if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
        });
        return {
            id: Number(sprint.sprintId),
            name: sprint.name,
            state: sprint.state?.toLowerCase(),
            boardId: Number(sprint.boardName) || 0,
            ...optionalValues
        };
    };
    const $05e0b9d6b707c3a6$export$9b5bb05d50970021 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SPRINT_TYPE)) return undefined;
        const sprints = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedSprintsConnection, $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: sprints,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
                items: 'json',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("avV20", function(module, exports) {
    $parcel$export(module.exports, "getStatusesDeprecatedValue", ()=>$e8b60f3bf3251c5a$export$b80ec59d806c2f94);
    $parcel$export(module.exports, "transformAggStatusToLegacyField", ()=>$e8b60f3bf3251c5a$export$c80e5acb1c882c48);
    var $gULOk;
    var $5fc53;
    var $o7K5u;
    const $e8b60f3bf3251c5a$export$b80ec59d806c2f94 = (fields)=>{
        const { status: status } = fields;
        if (!status || status.value == null) return {};
        const { value: value } = status;
        return {
            [value.id]: {
                id: value.id,
                name: value.name,
                statusCategory: (0, (0, parcelRequire("gULOk")).statusCategoryForId)(value.statusCategory?.id)
            }
        };
    };
    const $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus = (status)=>{
        if (status == null) return null;
        const { statusCategory: statusCategory } = status;
        return {
            id: status.statusId,
            name: status.name || '',
            statusCategory: {
                id: Number(statusCategory.statusCategoryId)
            }
        };
    };
    const $e8b60f3bf3251c5a$export$c80e5acb1c882c48 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).STATUS_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus(node.status),
            schema: {
                configuration: null,
                items: null,
                renderer: null,
                type: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).STATUS_TYPE)
            }
        };
    };
});
parcelRegister("cbXvu", function(module, exports) {
    $parcel$export(module.exports, "transformAggTeamToLegacyField", ()=>$2c8c4053c45e92fb$export$fb1b80497e96456f);
    var $5fc53;
    var $o7K5u;
    const $2c8c4053c45e92fb$export$fb1b80497e96456f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE)) return undefined;
        const value = node.selectedTeam ? {
            id: node.selectedTeam.teamId,
            title: node.selectedTeam.name,
            isShared: node.selectedTeam.isShared,
            avatarUrl: node.selectedTeam.avatar?.medium
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_ANY_CF_TYPE)
            }
        };
    };
});
parcelRegister("aSXJi", function(module, exports) {
    $parcel$export(module.exports, "transformAggTeamViewToLegacyField", ()=>$b1861ddba2f2c1e6$export$6f6aaafb49bd4769);
    var $5fc53;
    var $o7K5u;
    const $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam = (team)=>{
        if (team == null) return null;
        return {
            id: team.jiraSuppliedTeamId,
            name: team.jiraSuppliedName || '',
            isVisible: team.jiraSuppliedVisibility || false,
            avatarUrl: team.jiraSuppliedAvatar?.xsmall || ''
        };
    };
    const $b1861ddba2f2c1e6$export$6f6aaafb49bd4769 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'team'
            }
        };
    };
});
parcelRegister("8uxcU", function(module, exports) {
    $parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", ()=>$63b0d60fa2cc1a3e$export$874d9bd14269ec6f);
    var $5fc53;
    var $o7K5u;
    const $63b0d60fa2cc1a3e$var$getEstimateValues = (estimate, key)=>{
        if (estimate) return {
            [key]: estimate.timeInSeconds || 0
        };
        return {};
    };
    const $63b0d60fa2cc1a3e$export$874d9bd14269ec6f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE)) return undefined;
        const originalEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
        const remainingEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
        const timeSpent = $63b0d60fa2cc1a3e$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                ...originalEstimate,
                ...remainingEstimate,
                ...timeSpent
            },
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE),
                type: (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE)
            }
        };
    };
});
parcelRegister("arKlm", function(module, exports) {
    $parcel$export(module.exports, "transformAggUrlToLegacyField", ()=>$86ba2c1106803d01$export$6e950e0ec9801f6c);
    var $5fc53;
    var $o7K5u;
    const $86ba2c1106803d01$export$6e950e0ec9801f6c = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).URL_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.uri ?? null,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        };
    };
});
parcelRegister("hCKV6", function(module, exports) {
    $parcel$export(module.exports, "transformAggVotesToLegacyField", ()=>$78b4a5963398330d$export$8966614b8594736);
    var $5fc53;
    var $o7K5u;
    const $78b4a5963398330d$var$transformAggVoteToLegacyVote = (vote)=>({
            votes: vote.count != null ? Number(vote.count) : 0,
            hasVoted: vote.hasVoted ?? false
        });
    const $78b4a5963398330d$export$8966614b8594736 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).VOTES_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.vote ? $78b4a5963398330d$var$transformAggVoteToLegacyVote(node.vote) : null,
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: null,
                system: (0, (0, parcelRequire("5fc53")).VOTES_TYPE),
                type: (0, (0, parcelRequire("5fc53")).VOTES_TYPE)
            }
        };
    };
});
parcelRegister("d8wC0", function(module, exports) {
    $parcel$export(module.exports, "transformAggWatchesToLegacyField", ()=>$a83bab4858993b2f$export$6730cb17d10d6156);
    var $5fc53;
    var $o7K5u;
    const $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches = (watch)=>({
            watchCount: watch.count != null ? Number(watch.count) : 0,
            isWatching: watch.isWatching ?? false
        });
    const $a83bab4858993b2f$export$6730cb17d10d6156 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).WATCHES_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.watch ? $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches(node.watch) : null,
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: null,
                system: (0, (0, parcelRequire("5fc53")).WATCHES_TYPE),
                type: (0, (0, parcelRequire("5fc53")).WATCHES_TYPE)
            }
        };
    };
});
parcelRegister("1pF6B", function(module, exports) {
    $parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", ()=>$f8196a61a82995ed$export$d8a5feb2bb0425b4);
    const $f8196a61a82995ed$export$d8a5feb2bb0425b4 = (parentIssue)=>{
        if (!parentIssue) return null;
        return {
            id: parentIssue.issueId,
            ari: parentIssue.id,
            key: parentIssue.key,
            self: parentIssue.webUrl,
            color: parentIssue.issueColorField?.color?.colorKey,
            fields: {
                summary: parentIssue.summaryField?.text,
                issuetype: {
                    name: parentIssue.issueTypeField?.issueType?.name,
                    iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                    id: '',
                    self: '',
                    description: '',
                    subtask: false,
                    avatarId: 0,
                    hierarchyLevel: 0
                }
            }
        };
    };
});
parcelRegister("lTnWS", function(module, exports) {
    $parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", ()=>$51ceecc021979aad$export$b3a2c3992977726e);
    var $kz2lw;
    var $fCo6Y;
    const $51ceecc021979aad$var$emptyAdfObject = (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
    const $51ceecc021979aad$export$b3a2c3992977726e = (richText, renderer)=>{
        if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
        if (renderer === (0, $650578330a102f55$export$a4a240cb4053b29f)) {
            if (richText.plainText !== undefined) return richText.plainText;
            return richText?.adfValue?.convertedPlainText?.plainText;
        }
        return richText?.adfValue?.json ? (0, (0, parcelRequire("fCo6Y")).removeCollectionFromAdf)(richText?.adfValue?.json) : $51ceecc021979aad$var$emptyAdfObject;
    };
});
parcelRegister("3z81P", function(module, exports) {
    $parcel$export(module.exports, "ChangeEventTypes", ()=>$c6ffe75554a4bac3$export$8db21fc94823e1cc);
    const $c6ffe75554a4bac3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
    const $c6ffe75554a4bac3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
    const $c6ffe75554a4bac3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
    const $c6ffe75554a4bac3$export$8db21fc94823e1cc = {
        [$c6ffe75554a4bac3$export$8b9b8ed7fbac313c]: $c6ffe75554a4bac3$export$8b9b8ed7fbac313c,
        [$c6ffe75554a4bac3$export$7c15aaba9a26f469]: $c6ffe75554a4bac3$export$7c15aaba9a26f469,
        [$c6ffe75554a4bac3$export$f567ac9d3526e5ce]: $c6ffe75554a4bac3$export$f567ac9d3526e5ce
    };
});
parcelRegister("biQrn", function(module, exports) {
    $parcel$export(module.exports, "useIsMounted", ()=>$c6adaed2787020bf$export$80c2a3957bcb42ea);
    var $5uXOq = parcelRequire("5uXOq");
    const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        }, [
            isMounted
        ]);
        return isMounted;
    };
});
parcelRegister("3fAi8", function(module, exports) {
    $parcel$export(module.exports, "useFieldValue", ()=>$ddbc380ab4ee430c$export$b79fae7fbe3ac392);
    $parcel$export(module.exports, "useFieldsValues", ()=>$ddbc380ab4ee430c$export$25b73e671fe7a8fa);
    $parcel$export(module.exports, "useFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$ac289b84121829df);
    $parcel$export(module.exports, "useMultiFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$915cdeec521b54f7);
    $parcel$export(module.exports, "FieldValueSubscriber", ()=>$ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
    $parcel$export(module.exports, "useFieldsValuesActions", ()=>$ddbc380ab4ee430c$export$612d9bcb0c9d8976);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
            setState({
                [issueKey]: fields
            });
        };
    const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState(newIssues);
        };
    const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    [fieldKey]: value
                }
            });
        };
    const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
            const issueFieldValues = getState()[issueKey];
            return issueFieldValues && issueFieldValues[fieldKey];
        };
    const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: (0, ($parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
            });
        };
    const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
            if (issues.length === 0) return;
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState((0, ($parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
        };
    const $ddbc380ab4ee430c$var$actions = {
        setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
        getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
        setIssue: $ddbc380ab4ee430c$var$setIssue,
        mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
        setIssues: $ddbc380ab4ee430c$var$setIssues,
        mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
    };
    const $ddbc380ab4ee430c$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-fields',
        initialState: {},
        actions: $ddbc380ab4ee430c$var$actions
    });
    const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
        const issueFieldValues = state[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
    const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            }));
    const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
            if (!state[issueKey]) return accumulator;
            const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
                acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                    fieldKey: fieldKey,
                    issueKey: issueKey
                });
                return acc;
            }, {});
            accumulator[issueKey] = fieldValue;
            return accumulator;
        }, {});
    const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
    const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getAllFields
    });
    const $ddbc380ab4ee430c$export$ac289b84121829df = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, (0, parcelRequire("51nlc")).createSubscriber)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: null
    });
    const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
        const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
        const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
            const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
            const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
            const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
            const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
            const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
            const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
            return {
                setIssue: setIssueAction,
                setFieldValue: setFieldValueAction,
                getFieldValue: getFieldValueAction,
                mergeIssue: mergeIssueAction,
                setIssues: setIssuesAction,
                mergeIssues: mergeIssuesAction
            };
        }, [
            fieldValueStoreActions
        ]);
        return [
            null,
            fieldsValuesActions
        ];
    };
});
parcelRegister("99cgx", function(module, exports) {
    $parcel$export(module.exports, "defaultSaveField", ()=>$2a246664763defba$export$b74e6b7f831f1cb2);
    $parcel$export(module.exports, "defaultSaveFieldById", ()=>$2a246664763defba$export$b2c49aae5d84cced);
    $parcel$export(module.exports, "defaultAddValuesToField", ()=>$2a246664763defba$export$c46c7284cd9c5d3);
    $parcel$export(module.exports, "defaultRemoveValuesFromField", ()=>$2a246664763defba$export$33b78476f5d734b3);
    var $eusud;
    const $2a246664763defba$var$getFieldUpdate = (fieldKey, value)=>({
            fields: {
                [fieldKey]: value
            }
        });
    const $2a246664763defba$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
        });
    const $2a246664763defba$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
            body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
        });
    const $2a246664763defba$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
        const updateParam = {
            update: {
                [fieldKey]: [
                    {
                        operation: 'add',
                        value: valuesToAdd
                    }
                ]
            }
        };
        return (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify(updateParam)
        });
    };
    const $2a246664763defba$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
        const updateParam = {
            update: {
                [fieldKey]: [
                    {
                        operation: 'remove',
                        value: valuesToRemove
                    }
                ]
            }
        };
        return (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify(updateParam)
        });
    };
});
parcelRegister("54wEF", function(module, exports) {
    $parcel$export(module.exports, "useIssueFieldConfig", ()=>$a5085d8f4019d625$export$5406c21e0d275680);
    $parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", ()=>$a5085d8f4019d625$export$217a0e2f2962f4ae);
    $parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", ()=>$a5085d8f4019d625$export$5f641a998c6dfa06);
    $parcel$export(module.exports, "useFieldConfig", ()=>$a5085d8f4019d625$export$70da50df1be2dbe1);
    $parcel$export(module.exports, "useFieldConfigWithoutRefetch", ()=>$a5085d8f4019d625$export$1eed575f8f3334eb);
    $parcel$export(module.exports, "useFieldConfigActions", ()=>$a5085d8f4019d625$export$28a22fd0dedf31b7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $e5wyW;
    var $4R6GH;
    var $jJZqs;
    var $eusud;
    var $iZIvy;
    var $eDXka;
    var $gXz4p;
    var $biQrn;
    var $2N3tQ;
    const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
    const $a5085d8f4019d625$var$fetchDataOld = async (issueKey)=>{
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, (0, parcelRequire("iZIvy")).getGraphQlUrl)('', (0, (0, parcelRequire("eDXka")).IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce((result, field)=>({
                ...result,
                [field.key]: {
                    autoCompleteUrl: field.autoCompleteUrl,
                    allowedValues: field.allowedValues,
                    isEditable: field.editable,
                    isRequired: field.required,
                    schema: field.schema,
                    title: field.title,
                    ...field.description ? {
                        description: field.description
                    } : {}
                }
            }), {});
        return null;
    };
    const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
        const errorMessageItem = errorMessage != null ? {
            errorMessage: errorMessage
        } : {};
        const traceIdItem = traceId != null ? {
            traceId: traceId
        } : {};
        return {
            experience: (0, (0, parcelRequire("eDXka")).IssueViewFetchOperations).FIELD_CONFIGURATION,
            wasExperienceSuccesful: wasExperienceSuccessful,
            analyticsSource: 'Issue View Field Configuration Query',
            additionalAttributes: {
                method: 'GET',
                ...errorMessageItem,
                ...traceIdItem
            },
            application: null,
            edition: null
        };
    };
    const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
        (0, (0, parcelRequire("gXz4p")).sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
            wasExperienceSuccessful: wasExperienceSuccessful,
            ...error?.message != null ? {
                errorMessage: error.message
            } : {},
            ...error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.traceId != null ? {
                traceId: error.traceId
            } : {}
        }));
    };
    const $a5085d8f4019d625$var$fetchDataWithExperienceTracking = async (issueKey)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, (0, parcelRequire("iZIvy")).getGraphQlUrl)('', (0, (0, parcelRequire("eDXka")).IssueViewFetchOperations).FIELD_CONFIGURATION), {
                body: JSON.stringify({
                    query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                    variables: {
                        issueKey: issueKey
                    }
                })
            });
            if (response?.data?.issue?.fields) {
                const fieldConfigData = response.data.issue.fields.reduce((result, field)=>({
                        ...result,
                        [field.key]: {
                            autoCompleteUrl: field.autoCompleteUrl,
                            allowedValues: field.allowedValues,
                            isEditable: field.editable,
                            isRequired: field.required,
                            schema: field.schema,
                            title: field.title,
                            ...field.description ? {
                                description: field.description
                            } : {}
                        }
                    }), {});
                $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                    wasExperienceSuccessful: true
                });
                return fieldConfigData;
            }
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: false,
                error: new Error('Unexpected field configuration response')
            });
            return null;
        } catch (error) {
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: false,
                error: error instanceof (0, (0, parcelRequire("jJZqs")).default) ? error : undefined
            });
            return null;
        }
    };
    const $a5085d8f4019d625$var$fetchData = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jiv-18890-field-configuration-query-exp-tracking'), $a5085d8f4019d625$var$fetchDataWithExperienceTracking, $a5085d8f4019d625$var$fetchDataOld);
    const $a5085d8f4019d625$var$requestSet = new Set();
    const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
        skipRefresh: false
    };
    const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
        const isMounted = (0, (0, parcelRequire("biQrn")).useIsMounted)();
        const [, { setIssueConfig: setIssueConfig }] = (0, (0, parcelRequire("2N3tQ")).useFieldConfigStoreActions)();
        const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
        const getData = (0, $5uXOq.useCallback)(async ()=>{
            setLoading(true);
            $a5085d8f4019d625$var$requestSet.add(issueKey);
            const result = await $a5085d8f4019d625$var$fetchData(issueKey);
            setIssueConfig(issueKey, result);
            $a5085d8f4019d625$var$requestSet.delete(issueKey);
            if (isMounted.current) setLoading(false);
        }, [
            isMounted,
            issueKey,
            setIssueConfig
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const shouldGetData = !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
            if (shouldGetData) getData();
        }, [
            issueKey,
            value,
            getData,
            skipRefresh
        ]);
        return [
            {
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
        const [value] = (0, (0, parcelRequire("2N3tQ")).useIssueFieldConfigStore)({
            issueKey: issueKey
        });
        const [overrides] = (0, (0, parcelRequire("2N3tQ")).useIssueOverridesStore)({
            issueKey: issueKey
        });
        return (0, $5uXOq.useMemo)(()=>{
            if (!(0, ($parcel$interopDefault($hGgHi)))(value) && overrides !== undefined) {
                const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                    acc[fieldKey] = {
                        ...fieldValues,
                        ...overrides[fieldKey]
                    };
                    return acc;
                }, {});
                return [
                    issueWithOverrides
                ];
            }
            return [
                value
            ];
        }, [
            value,
            overrides
        ]);
    };
    const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
        const [value] = (0, (0, parcelRequire("2N3tQ")).useFieldConfigStore)({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        const [overrides] = (0, (0, parcelRequire("2N3tQ")).useFieldOverridesStore)({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        if (!(0, ($parcel$interopDefault($hGgHi)))(value) && overrides !== undefined) return [
            {
                ...value,
                ...overrides
            }
        ];
        return [
            value
        ];
    };
    const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
        const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
            issueKey: issueKey
        });
        const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
        return [
            {
                value: value,
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
        const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
            issueKey: issueKey
        });
        return [
            {
                value: value
            }
        ];
    };
    const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
        const [value] = (0, (0, parcelRequire("2N3tQ")).useIssueFieldConfigStore)({
            issueKey: issueKey
        });
        const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
        return [
            {
                value: value,
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
        const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
        return [
            {
                value: value,
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
        const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        return [
            {
                value: value
            }
        ];
    };
    const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
        const [, setIssueConfigActions] = (0, (0, parcelRequire("2N3tQ")).useFieldConfigStoreActions)();
        const actions = (0, $5uXOq.useMemo)(()=>{
            const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
            const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
            const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
            const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
            const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
            return {
                setIssueConfig: setIssueConfig,
                setIssuesConfig: setIssuesConfig,
                mergeIssueConfig: mergeIssueConfig,
                mergeIssuesConfig: mergeIssuesConfig,
                setFieldConfigValue: setFieldConfigValue
            };
        }, [
            setIssueConfigActions
        ]);
        return [
            null,
            actions
        ];
    };
});
parcelRegister("iZIvy", function(module, exports) {
    $parcel$export(module.exports, "getGraphQlUrl", ()=>$ef2130f553e5234b$export$5647e6bbf2b3526f);
    $parcel$export(module.exports, "getFieldDataOptions", ()=>$ef2130f553e5234b$export$f2fec0cacdfabaaf);
    var $96nmc;
    var $chLKn;
    const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, (0, parcelRequire("96nmc")).appendOperationQuery)(operation)}`;
    const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
            method: 'POST',
            body: JSON.stringify({
                query: (0, (0, parcelRequire("chLKn")).default)(issueKey, projectKey)
            })
        });
});
parcelRegister("chLKn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
    const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
        let result = '';
        substitutions.forEach((key, i)=>{
            result += literals[i];
            result += key.toString();
        });
        result += literals[literals.length - 1];
        return result;
    };
    const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
    const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
    const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
    const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
    const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
    var $2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;
});
parcelRegister("eDXka", function(module, exports) {
    $parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", ()=>$9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
    $parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", ()=>$9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
    $parcel$export(module.exports, "IssueViewFetchOperations", ()=>$9f0f96bc04f1e77a$export$b38f30d67f730bc4);
    const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
    const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
    const $9f0f96bc04f1e77a$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
    const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
        EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
        INITIAL_GRAPHQL: 'issueDataQuery',
        EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
        INITIAL_GIRA: 'issueViewInteractiveQuery',
        EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
        INITIAL_AGG: 'mainIssueAggQuery',
        EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
        NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
        VIEW_SCREEN_ID: 'viewScreenIdQuery',
        FIELD_CONFIGURATION: 'fieldConfigurationQuery',
        FIELD_DESCRIPTION: 'fieldDescriptionQuery',
        ATTACHMENT: 'attachmentsQuery'
    };
});
parcelRegister("2N3tQ", function(module, exports) {
    $parcel$export(module.exports, "useIssueFieldConfigStore", ()=>$0471f3f4df57179c$export$52f51db4e2b3da57);
    $parcel$export(module.exports, "useFieldConfigStore", ()=>$0471f3f4df57179c$export$f9beb98c7488fd61);
    $parcel$export(module.exports, "useFieldConfigStoreActions", ()=>$0471f3f4df57179c$export$314199caf05d245);
    $parcel$export(module.exports, "useIssueOverridesStore", ()=>$0471f3f4df57179c$export$ff357cf5a96ec0c6);
    $parcel$export(module.exports, "useFieldOverridesStore", ()=>$0471f3f4df57179c$export$6e41e9c34587d557);
    $parcel$export(module.exports, "useFieldOverridesStoreWithLabel", ()=>$0471f3f4df57179c$export$e704d739927bd1d6);
    $parcel$export(module.exports, "useOverridesStoreActions", ()=>$0471f3f4df57179c$export$d94ae842140da412);
    $parcel$export(module.exports, "useFieldOptionsOverrides", ()=>$0471f3f4df57179c$export$bfea9bb9bad7bc8f);
    $parcel$export(module.exports, "useIsFieldBusy", ()=>$0471f3f4df57179c$export$982ff1008c2e2780);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $1UikQ = parcelRequire("1UikQ");
    var $3sQ5x;
    var $iXqE5;
    const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
            setState({
                [issueKey]: issueConfiguration
            });
        };
    const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: (0, ($parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
            });
        };
    const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
            const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                    ...acc,
                    ...issue
                }), {});
            setState(newIssues);
        };
    const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
            if (issuesWithConfigurations.length === 0) return;
            const newIssues = {};
            issuesWithConfigurations.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState((0, ($parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
        };
    const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
            const issueKeyFieldConfiguration = getState()[issueKey];
            if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    [fieldKey]: {
                        ...getState()[issueKey][fieldKey],
                        ...fieldConfiguration
                    }
                }
            });
        };
    const $0471f3f4df57179c$var$actions = {
        setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
        setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
        mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
        mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
        setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
    };
    const $0471f3f4df57179c$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-field-config',
        initialState: {},
        actions: $0471f3f4df57179c$var$actions
    });
    const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
    const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$store, {
        selector: $0471f3f4df57179c$var$getIssueFieldConfig
    });
    const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
        if (issue == null) return issue;
        return issue[fieldKey] ? issue[fieldKey] : null;
    });
    const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
        if (fieldConfig?.title === undefined) return fieldConfig;
        return {
            ...fieldConfig,
            label: fieldConfig.title
        };
    });
    const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
        if (issue == null) return issue;
        return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
    });
    const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$store, {
        selector: $0471f3f4df57179c$var$getFieldConfig
    });
    const $0471f3f4df57179c$export$314199caf05d245 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$store, {
        selector: null
    });
    const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
            const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
            setState({
                [issueKey]: {
                    ...issueKeyFieldConfigurationWithOverrides,
                    [fieldKey]: {
                        ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                        ...fieldConfigOverrides
                    }
                }
            });
        };
    const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
            setState({
                [issueKey]: undefined
            });
        };
    const $0471f3f4df57179c$var$overridesActions = {
        setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
        resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
    };
    const $0471f3f4df57179c$var$overridesStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-field-overrides',
        initialState: {},
        actions: $0471f3f4df57179c$var$overridesActions
    });
    const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getIssueFieldConfig
    });
    const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getFieldConfig
    });
    const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
    });
    const $0471f3f4df57179c$export$d94ae842140da412 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0471f3f4df57179c$var$overridesStore);
    const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
    });
    const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
        const { fieldId: fieldId, issueKey: issueKey } = args;
        return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
    };
    const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getIsFieldBusySelector
    });
});
parcelRegister("80wkc", function(module, exports) {
    $parcel$export(module.exports, "useSummaryField", ()=>$3937341f26b89a45$export$a01f0885983ceff0);
    var $9XE6b = parcelRequire("9XE6b");
    var $co1wz;
    var $lQE94;
    var $54wEF;
    var $5fc53;
    var $lcPD8;
    const $3937341f26b89a45$export$a01f0885983ceff0 = ({ issueId: issueId, issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
        const [fieldConfig] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE));
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'string');
        const saveField = (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-summary_eog1v') ? (0, (0, parcelRequire("lcPD8")).useSaveSummaryField)(issueId) : undefined;
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            onFailure: onFailure,
            ...(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-summary_eog1v') && {
                saveField: saveField
            },
            ...onSaveField && {
                saveField: onSaveField
            }
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("lcPD8", function(module, exports) {
    $parcel$export(module.exports, "useSaveSummaryField", ()=>$296ba0222c720503$export$2429979662d1fc23);
    var $883fO;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $etMBv;
    var $jJZqs;
    var $koeKL;
    const $296ba0222c720503$export$2429979662d1fc23 = (issueId)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [commit] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("883fO")).default));
        return (0, $5uXOq.useCallback)(async (_issueKey, fieldId, newValue)=>new Promise((resolve, reject)=>{
                commit({
                    variables: {
                        input: {
                            id: (0, (0, parcelRequire("etMBv")).JiraIssuefieldvalueAri).create({
                                siteId: cloudId,
                                issueId: issueId || '',
                                fieldId: fieldId
                            }).toString(),
                            operation: {
                                operation: 'SET',
                                text: newValue
                            }
                        }
                    },
                    onCompleted (response) {
                        if (response.jira?.updateSingleLineTextField) {
                            const { success: success, errors: responseErrors } = response.jira?.updateSingleLineTextField;
                            if (success) {
                                resolve();
                                return;
                            }
                            if (responseErrors?.length) reject(responseErrors[0].message ? new (0, (0, parcelRequire("jJZqs")).ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating summary'));
                        } else reject(new Error('Unknown error when mutating summary'));
                    },
                    onError (error) {
                        reject(error);
                    }
                });
            }), [
            cloudId,
            commit,
            issueId
        ]);
    };
});
parcelRegister("883fO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d80cb93aeec4c927$export$2e2bcd8739ae039);
    const $d80cb93aeec4c927$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useSaveSummaryFieldMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraSingleLineTextFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateSingleLineTextField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraSingleLineTextField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useSaveSummaryFieldMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraSingleLineTextFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateSingleLineTextField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraSingleLineTextField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "text"
                                            },
                                            {
                                                "concreteType": "JiraFieldConfig",
                                                "kind": "LinkedField",
                                                "name": "fieldConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isEditable"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isRequired"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "8b02759e10438a127aac20f64c8486592f4fd2cd831c3688a79bab526279fedf",
                "metadata": {},
                "name": "useSaveSummaryFieldMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $d80cb93aeec4c927$var$node.hash = "d7d58a3dc9f48f40fffb61682948b25d";
    var $d80cb93aeec4c927$export$2e2bcd8739ae039 = $d80cb93aeec4c927$var$node;
});
parcelRegister("etMBv", function(module, exports) {
    $parcel$export(module.exports, "JiraIssuefieldvalueAri", ()=>$a8a979df7e6262d7$export$828c4931ae562af7);
    var $gB07r;
    var $fe7YR;
    var $224I1;
    var $a8a979df7e6262d7$var$jiraIssuefieldvalueAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
        resourceOwner: (0, (0, parcelRequire("gB07r")).JiraIssuefieldvalueAriResourceOwner),
        resourceType: (0, (0, parcelRequire("gB07r")).JiraIssuefieldvalueAriResourceType),
        resourceIdSlug: "{issueId}/{fieldId}",
        resourceIdSegmentFormats: {
            issueId: /[0-9]+/,
            fieldId: /[a-zA-Z0-9_\-]+/
        }
    };
    var $a8a979df7e6262d7$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, (0, parcelRequire("fe7YR")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
        }
        get siteId() {
            return this._siteId;
        }
        get issueId() {
            return this._issueId;
        }
        get fieldId() {
            return this._fieldId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $a8a979df7e6262d7$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
                platformQualifier: $a8a979df7e6262d7$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $a8a979df7e6262d7$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
                resourceType: $a8a979df7e6262d7$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
                resourceId: `${opts.issueId}/${opts.fieldId}`,
                resourceIdSegmentValues: {
                    issueId: opts.issueId,
                    fieldId: opts.fieldId
                }
            }, ariOpts = (0, (0, parcelRequire("224I1")).AriParser).fromOpts(derivedOpts, $a8a979df7e6262d7$var$jiraIssuefieldvalueAriStaticOpts);
            return new _JiraIssuefieldvalueAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("224I1")).AriParser).fromString(maybeAri, $a8a979df7e6262d7$var$jiraIssuefieldvalueAriStaticOpts);
            return new _JiraIssuefieldvalueAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                issueId: this.issueId,
                fieldId: this.fieldId
            };
        }
    };
});
parcelRegister("gB07r", function(module, exports) {
    $parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", ()=>$c15031ac9edfd973$export$39e9358142fbbc64);
    $parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", ()=>$c15031ac9edfd973$export$f9e57427271adc95);
    var $c15031ac9edfd973$export$39e9358142fbbc64 = "jira", $c15031ac9edfd973$export$f9e57427271adc95 = "issuefieldvalue";
});
parcelRegister("1Kt4o", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", ()=>$3add01bee0e3b846$export$689de18177335e39);
    $parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", ()=>$3add01bee0e3b846$export$96f61eb1261e42c3);
    const $3add01bee0e3b846$export$689de18177335e39 = {
        ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
        ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
        CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
        COPY_URL: 'COPY_URL',
        DESCRIPTION: 'DESCRIPTION',
        ISSUE_ACTIONS: 'ISSUE_ACTIONS',
        ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
        ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
        ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
        LOG_WORK: 'LOG_WORK',
        NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
        PARENT: 'PARENT',
        PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
        QUICK_ADD: 'QUICK_ADD',
        QUICK_SEARCH: 'QUICK_SEARCH',
        SHORTCUTS: 'SHORTCUTS',
        STATUS: 'STATUS',
        STORY_POINTS: 'STORY_POINTS',
        TEST: 'TEST',
        THEME_MODE: 'THEME_MODE'
    };
    const $3add01bee0e3b846$var$teams = {
        Deliveroo: 'Deliveroo'
    };
    const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
        ADMIN_NAVIGATION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        CHECK_NOTIFICATIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        COPY_URL: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        DESCRIPTION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_FIELD_ASSIGN: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_HEADER_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_SUB_HEADER_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        LOG_WORK: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        NAVIGATION_COMMANDS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        PARENT: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        PROJECT_NAVIGATION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        QUICK_ADD: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        QUICK_SEARCH: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        SHORTCUTS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        STATUS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        STORY_POINTS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        THEME_MODE: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        }
    };
});
parcelRegister("fVMIs", function(module, exports) {
    $parcel$export(module.exports, "useSubscribeCommands", ()=>$05800ad334e2646e$export$c13b008422be19c7);
    var $fIZf0;
    const $05800ad334e2646e$export$c13b008422be19c7 = (0, (0, parcelRequire("fIZf0")).useSubscribeCommandsWithRegistry);
});
parcelRegister("fIZf0", function(module, exports) {
    $parcel$export(module.exports, "useSubscribeCommandsWithRegistry", ()=>$72118e9f2599bc72$export$880fc01e31710b27);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    function $72118e9f2599bc72$export$880fc01e31710b27() {
        const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
            updateActiveRegistry(registrationId, commands);
            addCommands(commands);
            return ()=>{
                removeCommands(commands);
                removeFromActiveRegistry(registrationId, commands);
            };
        }, [
            addCommands,
            removeCommands,
            removeFromActiveRegistry,
            updateActiveRegistry
        ]);
        return subscribe;
    }
});
parcelRegister("c6XT1", function(module, exports) {
    $parcel$export(module.exports, "useIssueAri", ()=>$be8be2fff6370f04$export$f56776f1b409b56d);
    var $2gCtH;
    var $dXq4S;
    var $koeKL;
    const $be8be2fff6370f04$export$f56776f1b409b56d = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const issueId = (0, (0, parcelRequire("2gCtH")).useIssueId)();
        return (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: issueId ?? ''
        });
    };
});
const $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774 = 'issue-field-status.ui.status-view.command-palette.issue-status';
parcelRegister("iokLh", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$7312d5cd39eb83d5$export$defe85febe8b728c);
    var $7VHMR;
    const $7312d5cd39eb83d5$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editStatus: {
            "id": "issue-field-status.status-view.command-palette.edit-status",
            "defaultMessage": "Edit status"
        },
        searchTransition: {
            "id": "issue-field-status.status-view.command-palette.search-transition",
            "defaultMessage": "Search a status or transition"
        },
        current: {
            "id": "issue-field-status.status-view.command-palette.current",
            "defaultMessage": "Current"
        },
        fallbackNoResults: {
            "id": "issue-field-status.status-view.command-palette.fallback-no-results",
            "defaultMessage": "No results match your search."
        },
        fallbackError: {
            "id": "issue-field-status.status-view.command-palette.fallback-error",
            "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
        }
    });
});
parcelRegister("99Vn3", function(module, exports) {
    $parcel$export(module.exports, "useSaveStatusField", ()=>$6b5b0ceb4c7d618c$export$c6a3d42f97df89c9);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $eusud;
    var $pa9q9;
    var $koVbs;
    var $3fAi8;
    var $jpZIw;
    var $dTUtq;
    var $8zOmE;
    var $2NMNM;
    var $luzUm;
    const $6b5b0ceb4c7d618c$export$c6a3d42f97df89c9 = (issueKey, issueId, onUpdateStatusMutation)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ commandPaletteSessionId: commandPaletteSessionId }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteSessionId)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setFieldValue: setFieldValue }] = (0, (0, parcelRequire("3fAi8")).useFieldValue)({
            issueKey: issueKey,
            fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692)
        });
        const onSaveSuccessfully = (0, $5uXOq.useCallback)((transition, callback)=>{
            const action = 'commandPalette';
            const actionSubject = 'changeStatus';
            const eventActionAndSubject = `${actionSubject} ${action}`;
            const event = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            setFieldValue(issueKey, (0, $e9be48d6d2c01760$export$4420b7468f889692), transition.to);
            callback?.();
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, eventActionAndSubject, {
                transitionId: transition.id,
                commandPaletteSessionId: commandPaletteSessionId
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'statusField transitioned', 'statusField');
            !(0, (0, parcelRequire("4R6GH")).fg)('show-modernised-issue-transition-success-flag') && showFlag({
                type: 'success',
                title: formatMessage((0, (0, parcelRequire("luzUm")).messages).successFlagMessage)
            });
        }, [
            commandPaletteSessionId,
            createAnalyticsEvent,
            formatMessage,
            issueKey,
            setFieldValue,
            showFlag
        ]);
        const onFailSave = (0, $5uXOq.useCallback)((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'commandPaletteIssueStatus',
                    packageName: 'jiraIssueFieldStatus',
                    teamName: 'deliveroo'
                }
            });
            showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("luzUm")).messages).errorFlagTitle),
                description: formatMessage((0, (0, parcelRequire("luzUm")).messages).errorFlagDescription)
            });
        }, [
            formatMessage,
            showFlag
        ]);
        const openIssueTransitionModal = (0, (0, parcelRequire("jpZIw")).useOpenIssueTransitionModal)();
        const { showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag } = (0, (0, parcelRequire("dTUtq")).useShowFlag)();
        const saveStatusField = (0, $5uXOq.useCallback)(async (transition, callback)=>{
            try {
                if (transition.hasScreen) {
                    const handleDialogSuccess = ()=>{
                        (0, (0, parcelRequire("4R6GH")).fg)('show-modernised-issue-transition-success-flag') && showIssueTransitionSuccessFlag(issueKey, transition.to.name);
                        return onSaveSuccessfully(transition, callback);
                    };
                    const handleDialogError = (err)=>onFailSave(err instanceof Error ? err : new Error('Something went wrong trying to update the status with screen using the command palette'));
                    const transitionId = transition.id;
                    openIssueTransitionModal({
                        payload: {
                            issueId: issueId,
                            issueKey: issueKey,
                            transitionId: transitionId
                        },
                        triggerPointKey: 'issue-transition-command-palette-status-field-transition',
                        onDialogSuccess: handleDialogSuccess,
                        onDialogError: handleDialogError
                    });
                } else {
                    if ((0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c') && onUpdateStatusMutation) await onUpdateStatusMutation?.({
                        transitionId: transition.id,
                        newStatus: transition.to
                    });
                    else await (0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/api/3/issue/${issueKey}/transitions`, {
                        body: JSON.stringify({
                            transition: transition
                        })
                    });
                    onSaveSuccessfully(transition, callback);
                    (0, (0, parcelRequire("4R6GH")).fg)('show-modernised-issue-transition-success-flag') && showIssueTransitionSuccessFlag(issueKey, transition.to.name);
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Something went wrong trying to update the status using the command palette');
                onFailSave(error);
            }
        }, [
            issueId,
            issueKey,
            onFailSave,
            onSaveSuccessfully,
            onUpdateStatusMutation,
            openIssueTransitionModal,
            showIssueTransitionSuccessFlag
        ]);
        return {
            saveStatusField: saveStatusField
        };
    };
});
parcelRegister("jpZIw", function(module, exports) {
    $parcel$export(module.exports, "useOpenIssueTransitionModal", ()=>$f41d32ebe3d90af0$export$736bd10472c63b49);
    $parcel$export(module.exports, "useCloseIssueTransitionModal", ()=>$f41d32ebe3d90af0$export$4629f18d511ad32e);
    $parcel$export(module.exports, "useTriggerIssueTransitionModal", ()=>$f41d32ebe3d90af0$export$95a1e9702d78f223);
    $parcel$export(module.exports, "default", ()=>$f41d32ebe3d90af0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $4R6GH;
    var $6ikhl;
    var $2gCtH;
    var $ct2PA;
    var $3NlyR;
    var $8zOmE;
    var $2NMNM;
    var $9MiT2;
    var $fNOVA;
    var $1btwe;
    var $gjoNn;
    var $ipUU1;
    const $f41d32ebe3d90af0$export$736bd10472c63b49 = ()=>{
        const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalActions)();
        const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, (0, parcelRequire("fNOVA")).useIssueTransitionLabsOptIn)();
        const publish = (0, (0, parcelRequire("1btwe")).usePublishOpenIssueTransitionModalPubSub)();
        const source = (0, (0, parcelRequire("2gCtH")).useAnalyticsSource)();
        const { fireUIEvent: fireUIEvent } = (0, (0, parcelRequire("3NlyR")).useIssueTransitionUIAnalyticsEvent)();
        const { stateGet: { state: state } } = (0, (0, parcelRequire("9MiT2")).useIssueTransitionChangeboardingPreferences)();
        const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, (0, parcelRequire("ct2PA")).useIssueTransitionsOperationalAnalyticsEvent)();
        const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
        const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
        return (0, $5uXOq.useCallback)((nextState)=>{
            try {
                if ((0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal')) {
                    fireOperationalAnalyticsTransitionScreenOpened({
                        actionSubject: 'issueTransition triggered',
                        isBenefitsModalFGEneabled: (0, (0, parcelRequire("4R6GH")).fg)('modern_issue_transition_enable_benefits_modal'),
                        preferNewIssueTransitionScreen: isEnabled,
                        issueViewAnalyticsSource: source,
                        isBenefitsModalDisabled: isDisabled,
                        dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
                    });
                    openIssueTransitionModalNew({
                        nextState: nextState,
                        preferNewIssueTransitionScreen: isEnabled,
                        issueViewAnalyticsSource: source,
                        publishTriggerToOpenTransitions: publish,
                        isBenefitsModalDisabled: isDisabled,
                        dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                        fireUIEvent: fireUIEvent
                    });
                    return;
                }
                if (source === 'connect-issue') {
                    fireUIEvent({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    publish(nextState, isEnabled);
                } else openIssueTransitionModalAction(nextState, isEnabled);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'transitionIssueTrigger',
                        packageName: 'jiraIssueTransitionTrigger',
                        teamName: 'gryffindor'
                    },
                    attributes: {
                        transitionModalVersion: 'NEW'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }, [
            fireOperationalAnalyticsTransitionScreenOpened,
            isEnabled,
            source,
            isDisabled,
            nextDateToShowBenefitsModal,
            openIssueTransitionModalNew,
            publish,
            fireUIEvent,
            openIssueTransitionModalAction
        ]);
    };
    const $f41d32ebe3d90af0$export$4629f18d511ad32e = ()=>{
        const [, { resetState: resetState }] = (0, (0, parcelRequire("6ikhl")).useInlineFieldsActions)();
        const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalActions)();
        const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)((shouldOpenLegacyModal = false)=>{
            closeIssueTransitionModalAction();
            (0, (0, parcelRequire("4R6GH")).fg)('ditto-fcf-transition-view-forge-rendering') && resetState();
            if (shouldOpenLegacyModal) {
                const onOpenDialog = ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'switch to legacy transition screen');
                };
                (0, (0, parcelRequire("ipUU1")).openLegacyIssueTransitionModal)({
                    issueKey: issueKey,
                    isReopenScenario: true,
                    transitionId: transitionId,
                    onDialogCancel: onDialogCancel,
                    onDialogError: onDialogError,
                    onDialogSuccess: onDialogSuccess,
                    onOpenDialog: onOpenDialog
                });
            }
        }, [
            closeIssueTransitionModalAction,
            createAnalyticsEvent,
            issueKey,
            onDialogCancel,
            onDialogError,
            onDialogSuccess,
            transitionId,
            resetState
        ]);
    };
    const $f41d32ebe3d90af0$export$95a1e9702d78f223 = ()=>{
        const state = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalState)();
        const actions = (0, (0, parcelRequire("gjoNn")).useTriggerIssueTransitionModalActions)();
        const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
        const openIssueTransitionModal = $f41d32ebe3d90af0$export$736bd10472c63b49();
        return [
            state,
            {
                ...restActions,
                openIssueTransitionModal: openIssueTransitionModal
            }
        ];
    };
    var $f41d32ebe3d90af0$export$2e2bcd8739ae039 = $f41d32ebe3d90af0$export$95a1e9702d78f223;
});
parcelRegister("6ikhl", function(module, exports) {
    $parcel$export(module.exports, "useInlineFields", ()=>$d56dd4f138add558$export$71d5b5acb7d7f5ce);
    $parcel$export(module.exports, "useInlineField", ()=>$d56dd4f138add558$export$14c9655e9d9e873c);
    $parcel$export(module.exports, "useInlineFieldsActions", ()=>$d56dd4f138add558$export$cdb4b503c6154b35);
    var $3sQ5x;
    var $iXqE5;
    var $5rCpD;
    const $d56dd4f138add558$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'forge.inline-fields-state',
        initialState: {},
        actions: (0, parcelRequire("5rCpD")).default
    });
    const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store);
    const $d56dd4f138add558$export$14c9655e9d9e873c = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store, {
        selector: (state, fieldId)=>state[fieldId]
    });
    const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store, {
        selector: null
    });
});
parcelRegister("5rCpD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02373df28193ad93$export$2e2bcd8739ae039);
    var $hPhpd;
    const $02373df28193ad93$var$actions = {
        setFieldState: (0, parcelRequire("hPhpd")).setFieldState,
        resetState: (0, parcelRequire("hPhpd")).resetState,
        dispatchRetryFunction: (0, parcelRequire("hPhpd")).dispatchRetryFunction,
        dispatchFormSubmits: (0, parcelRequire("hPhpd")).dispatchFormSubmits
    };
    var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;
});
parcelRegister("hPhpd", function(module, exports) {
    $parcel$export(module.exports, "setFieldState", ()=>$9eca433be421af07$export$80fd62d9217dd703);
    $parcel$export(module.exports, "resetState", ()=>$9eca433be421af07$export$8e84bad0b35de9e8);
    $parcel$export(module.exports, "dispatchRetryFunction", ()=>$9eca433be421af07$export$27c59f06a7c1fe26);
    $parcel$export(module.exports, "dispatchFormSubmits", ()=>$9eca433be421af07$export$42fd5e650971333b);
    var $9J85a;
    const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const stateObject = {
                status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
                formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
                retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction
            };
            setState({
                ...getState(),
                [data.fieldId]: stateObject
            });
        };
    const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
            const stateToOverride = {};
            Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
                stateToOverride[fieldId] = {
                    status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
                };
            });
            setState(stateToOverride);
        };
    const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
            const currentState = getState();
            const fieldData = currentState[fieldId];
            const retryFunction = fieldData?.retryFunction;
            retryFunction && retryFunction();
        };
    const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
            const currentState = getState();
            Object.keys(currentState).forEach((fieldId)=>{
                if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                    const formRef = currentState[fieldId]?.formRef;
                    (0, (0, parcelRequire("9J85a")).dispatchFormSubmitAndBlurElements)(formRef);
                }
            });
        };
});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';
parcelRegister("9J85a", function(module, exports) {
    $parcel$export(module.exports, "submitForgeFormField", ()=>$b1c36799aab2b39a$export$7e50fee868362aa2);
    $parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", ()=>$b1c36799aab2b39a$export$4d639a8e0790daf2);
    $parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", ()=>$b1c36799aab2b39a$export$ee23412a8bea9333);
    const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
        formRef?.current?.requestSubmit();
    };
    const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
        $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
        if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
            if ('blur' in element && typeof element.blur === 'function') element?.blur();
        });
    };
    const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);
});
parcelRegister("ct2PA", function(module, exports) {
    $parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", ()=>$539a3126b0b48d6d$export$4d10663856b750d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $539a3126b0b48d6d$export$4d10663856b750d0 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireOperationalEventIssueTransitionFieldsCount = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
                fieldCount: fieldCount
            });
        }, [
            createAnalyticsEvent
        ]);
        const fireOperationalAnalyticsPermissionsUnAvailable = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
        }, [
            createAnalyticsEvent
        ]);
        const fireOperationalAnalyticsTransitionScreenOpened = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
                isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
                preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
                issueViewAnalyticsSource: issueViewAnalyticsSource,
                isBenefitsModalDisabled: isBenefitsModalDisabled,
                dateToShowBenefitsModal: dateToShowBenefitsModal
            });
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
            fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
            fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
        };
    };
});
parcelRegister("3NlyR", function(module, exports) {
    $parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", ()=>$5656c248adec15f1$export$d0823e3d2e087672);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $5656c248adec15f1$export$d0823e3d2e087672 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireUIEvent = (0, $5uXOq.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
            if (analyticsEvent !== undefined) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
            else {
                const createdAnalyticsEvent = createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
            }
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireUIEvent: fireUIEvent
        };
    };
});
parcelRegister("1btwe", function(module, exports) {
    $parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", ()=>$9796b79be99bbec0$export$76b6328962c9935f);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXy8e;
    const $9796b79be99bbec0$export$76b6328962c9935f = ()=>(0, $5uXOq.useCallback)((payload, isEnabled)=>{
            (0, (0, parcelRequire("iXy8e")).ITSPubSub).publish((0, $10a759732c3f1985$export$283bfc4a4b25707a), {
                payload: payload,
                isEnabled: isEnabled
            });
        }, []);
});
const $10a759732c3f1985$export$283bfc4a4b25707a = 'open-issue-transition-modal';
parcelRegister("iXy8e", function(module, exports) {
    $parcel$export(module.exports, "ITSPubSub", ()=>$c6c4e897a3edd1a2$export$a3877931259d622e);
    var $da7iT;
    const $c6c4e897a3edd1a2$export$a3877931259d622e = new (0, (0, parcelRequire("da7iT")).PubSubHub)();
    const $c6c4e897a3edd1a2$export$58b86c4766378620 = ()=>({
            ...$c6c4e897a3edd1a2$export$a3877931259d622e
        });
});
parcelRegister("da7iT", function(module, exports) {
    $parcel$export(module.exports, "PubSubHub", ()=>$4d1dbccbbe967a62$export$e3607828f8f2c01e);
    class $4d1dbccbbe967a62$export$e3607828f8f2c01e {
        constructor(){
            this.subscribers = {};
            this.subscribe = (event, subscriber)=>{
                let subs = this.subscribers[event];
                if (!subs) {
                    subs = [];
                    this.subscribers[event] = subs;
                }
                subs?.push(subscriber);
                return ()=>this.unsubscribe(event, subscriber);
            };
            this.unsubscribe = (event, subscriber)=>{
                const subs = this.subscribers[event];
                if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
            };
            this.publish = (event, data)=>{
                const subs = this.subscribers[event];
                if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
            };
            this.clearAll = ()=>{
                this.subscribers = {};
            };
        }
    }
});
parcelRegister("gjoNn", function(module, exports) {
    $parcel$export(module.exports, "TriggerIssueTransitionModalContainer", ()=>$18f6c8628e84d111$export$8ad65e459a406a8a);
    $parcel$export(module.exports, "useTriggerIssueTransitionModalActions", ()=>$18f6c8628e84d111$export$68de001c738e4145);
    $parcel$export(module.exports, "useTriggerIssueTransitionModalState", ()=>$18f6c8628e84d111$export$d3aceeec551eaab5);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $QnL9H;
    var $bpOxh;
    const $18f6c8628e84d111$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
        initialState: (0, parcelRequire("QnL9H")).initialState,
        actions: (0, parcelRequire("bpOxh"))
    });
    const $18f6c8628e84d111$export$8ad65e459a406a8a = (0, (0, parcelRequire("gg7kZ")).createContainer)($18f6c8628e84d111$var$store);
    const $18f6c8628e84d111$export$68de001c738e4145 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($18f6c8628e84d111$var$store);
    const $18f6c8628e84d111$export$d3aceeec551eaab5 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($18f6c8628e84d111$var$store);
});
parcelRegister("QnL9H", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$b1651ed43432db50$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", ()=>$b1651ed43432db50$export$7320afd6d2c7276d);
    $parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", ()=>$b1651ed43432db50$export$8ed7400ca8e89de2);
    var $7Jxgt = parcelRequire("7Jxgt");
    const $b1651ed43432db50$export$d4c72bab9d6cc13a = {
        inProgressTransitionID: (0, ($parcel$interopDefault($7Jxgt))).v4(),
        isModalOpen: false,
        isBenefitsModalOpen: false,
        isSubsequentLoad: false,
        payload: {
            issueId: '',
            issueKey: '',
            transitionId: ''
        },
        id: 'issue-transition-dialog',
        title: null,
        fetchedIssueId: '',
        triggerPointKey: (0, $b09837015a6d4fc3$export$8d987f6e80b74000),
        openLegacyTransitionsDialog: null,
        onDialogSuccess: null,
        onDialogCancel: null,
        onDialogError: null
    };
    const $b1651ed43432db50$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
    const $b1651ed43432db50$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';
});
const $b09837015a6d4fc3$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $b09837015a6d4fc3$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $b09837015a6d4fc3$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $b09837015a6d4fc3$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $b09837015a6d4fc3$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $b09837015a6d4fc3$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $b09837015a6d4fc3$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $b09837015a6d4fc3$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $b09837015a6d4fc3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $b09837015a6d4fc3$export$2bf0e335b815a90b = 'comment';
const $b09837015a6d4fc3$export$1b8cc53b37a62399 = 'worklog';
const $b09837015a6d4fc3$export$d624b8367eb730df = 'issuelinks';
parcelRegister("bpOxh", function(module, exports) {
    $parcel$export(module.exports, "closeIssueTransitionModal", ()=>(parcelRequire("3KYVT")).default);
    $parcel$export(module.exports, "openIssueTransitionModal", ()=>(parcelRequire("3cIaS")).default);
    $parcel$export(module.exports, "restoreState", ()=>(parcelRequire("keQtD")).default);
    $parcel$export(module.exports, "setFetchedIssueId", ()=>(parcelRequire("fb5Xn")).default);
    $parcel$export(module.exports, "hideBenefitsModal", ()=>(parcelRequire("bemkp")).default);
    $parcel$export(module.exports, "openIssueTransitionModalNew", ()=>(parcelRequire("bnv5t")).default);
    var $3KYVT;
    var $3cIaS;
    var $keQtD;
    var $fb5Xn;
    var $bemkp;
    var $bnv5t;
});
parcelRegister("3KYVT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09ddf425c332ed49$export$2e2bcd8739ae039);
    var $QnL9H;
    const $09ddf425c332ed49$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
            setState({
                ...(0, (0, parcelRequire("QnL9H")).initialState),
                isModalOpen: false,
                isSubsequentLoad: true
            });
        };
    var $09ddf425c332ed49$export$2e2bcd8739ae039 = $09ddf425c332ed49$var$closeIssueTransitionModal;
});
parcelRegister("3cIaS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc7e957c004b1c31$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eVcDT;
    var $emTT1;
    var $jcw0u;
    var $jtjyW;
    var $jHYHS;
    const $cc7e957c004b1c31$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
                payload: {}
            };
            let transitionModalVersion = '';
            const isNewITSEnabled = (0, (0, parcelRequire("jHYHS")).isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
            try {
                if (isNewITSEnabled) {
                    transitionModalVersion = 'NEW';
                    (0, (0, parcelRequire("jtjyW")).startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...currentState,
                        isModalOpen: true,
                        fetchedIssueId: '',
                        ...nextState
                    });
                } else {
                    transitionModalVersion = 'OLD';
                    (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
                    new (0, (0, parcelRequire("eVcDT")).default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'transitionIssueTrigger',
                        packageName: 'jiraIssueTransitionTrigger',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        transitionModalVersion: transitionModalVersion
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };
    var $cc7e957c004b1c31$export$2e2bcd8739ae039 = $cc7e957c004b1c31$var$openIssueTransitionModal;
});
parcelRegister("eVcDT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25bfe0b90f22578e$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $6BZYo;
    var $4tcSU;
    var $emTT1;
    class $25bfe0b90f22578e$export$2e2bcd8739ae039 {
        constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
            this.onDialogSuccessCallback = (0, ($parcel$interopDefault($8Rkzz)));
            this.onDialogErrorCallback = (0, ($parcel$interopDefault($8Rkzz)));
            this.onDialogCancelCallback = (0, ($parcel$interopDefault($8Rkzz)));
            this.issueId = issueId;
            this.transitionId = transitionId;
            this.issueKey = issueKey;
            this.issueKeys = issueKeys;
        }
        static{
            this.onDialogContentReady = ()=>{
                setTimeout(()=>{
                    (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).stop();
                });
            };
        }
        onDialogSuccess(onDialogSuccessCallback) {
            this.onDialogSuccessCallback = onDialogSuccessCallback;
            return this;
        }
        onDialogError(onDialogErrorCallback) {
            this.onDialogErrorCallback = onDialogErrorCallback;
            return this;
        }
        onDialogCancel(onDialogCancelCallback) {
            this.onDialogCancelCallback = onDialogCancelCallback;
            return this;
        }
        getIssueParam() {
            if (this.issueId != null) return `id=${this.issueId}`;
            if (this.issueKey != null) return `key=${this.issueKey}`;
            return '';
        }
        getUrl() {
            const { issueKeys: issueKeys } = this;
            if (issueKeys != null) return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, (0, parcelRequire("4tcSU")).default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
            return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, (0, parcelRequire("4tcSU")).default)() || ''}&returnUrl=`;
        }
        async show() {
            document.addEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
            const FormDialog = await (0, (0, parcelRequire("6BZYo")).loadBridge)({
                name: 'jira/dialog/form-dialog',
                wrmKeys: 'wrc!jira.webresources:dialogs'
            });
            const dialog = new FormDialog({
                id: 'edit-issue-dialog',
                ajaxOptions: {
                    url: this.getUrl(),
                    dataType: 'json'
                },
                autoClose: true,
                widthClass: 'large',
                onDialogFinished: this.onDialogSuccessCallback,
                onUnSuccessfulSubmit: this.onDialogErrorCallback,
                shouldLoadHeritageFormDialogContext: true
            });
            const cancelNativeHandler = (event)=>{
                if (!(event instanceof CustomEvent)) return;
                const dialogElement = event.detail.popup;
                const { reason: reason } = event.detail;
                if (dialogElement.is(dialog.get$popup())) {
                    if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                    document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                    document.removeEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
                }
            };
            document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
            dialog.show();
        }
    }
});
parcelRegister("emTT1", function(module, exports) {
    $parcel$export(module.exports, "timeToRenderTransitionModal", ()=>$4a78c80c71ff3414$export$9d20a86383e90d09);
    var $dGrdR;
    const $4a78c80c71ff3414$export$9d20a86383e90d09 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue.time-to.render-issue-transition-screen',
        histogram: {
            result: '500_1000_2500_4000_7000_10000'
        }
    });
});
parcelRegister("jtjyW", function(module, exports) {
    $parcel$export(module.exports, "startIssueTransitionMetrics", ()=>$1832266ecf87e128$export$3fc439100e136a52);
    var $eTXmK;
    var $4R6GH;
    var $lL2Jl;
    var $lP1Jn;
    var $fc6nm;
    const $1832266ecf87e128$export$3fc439100e136a52 = (isSubsequentLoad)=>{
        (0, (0, parcelRequire("lL2Jl")).IssueTransitionLoadUFOExperience).start();
        (0, (0, parcelRequire("lL2Jl")).IssueTransitionUFOExperience).start();
        const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, (0, parcelRequire("lP1Jn")).issueTransittionModalLoadSubsequent) : (0, (0, parcelRequire("lP1Jn")).issueTransitionModalLoad);
        if (isSubsequentLoad) (0, (0, parcelRequire("eTXmK")).default)('issue-transition.transition-modal-subsequent');
        else (0, (0, parcelRequire("eTXmK")).default)('issue-transition.transition-modal');
        issueTransitionModalLoadMetric.start();
        if ((0, (0, parcelRequire("4R6GH")).fg)('ui-modifications-on-issue-transition-view_7z1g0')) (0, (0, parcelRequire("fc6nm")).startUimTTI)();
    };
});
parcelRegister("lL2Jl", function(module, exports) {
    $parcel$export(module.exports, "IssueTransitionLoadUFOExperience", ()=>$f07939f1a4892f29$export$8fb308d8abecd81a);
    $parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", ()=>$f07939f1a4892f29$export$bd3bf8b90a131c50);
    $parcel$export(module.exports, "IssueTransitionUFOExperience", ()=>$f07939f1a4892f29$export$2f3b26e8acf79182);
    var $atdLB;
    var $duUGa;
    const $f07939f1a4892f29$export$8fb308d8abecd81a = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-transition-screen.transition-load', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'issue-transition-screen.transition-load'
    });
    const $f07939f1a4892f29$export$bd3bf8b90a131c50 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-transition-screen.transition-submit', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'issue-transition-screen.transition-sumbit'
    });
    const $f07939f1a4892f29$export$2f3b26e8acf79182 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-transition-screen.transition-issue', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'issue-transition-screen.transition-issue'
    });
});
parcelRegister("lP1Jn", function(module, exports) {
    $parcel$export(module.exports, "issueTransitionModalLoad", ()=>$e48205cb6c384272$export$772fb4a8bd181fd6);
    $parcel$export(module.exports, "issueTransittionModalLoadSubsequent", ()=>$e48205cb6c384272$export$afa89f024c56a00a);
    var $dGrdR;
    const $e48205cb6c384272$export$772fb4a8bd181fd6 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue-transition-modal'
    });
    const $e48205cb6c384272$export$afa89f024c56a00a = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'issue-transition-modal-subsequent'
    });
});
parcelRegister("fc6nm", function(module, exports) {
    $parcel$export(module.exports, "startUimTTI", ()=>$50f6a9f98192a4eb$export$ae34c17d9cd2c876);
    $parcel$export(module.exports, "markIssueTransitionLoaded", ()=>$50f6a9f98192a4eb$export$7cc1bb35860c7c25);
    $parcel$export(module.exports, "stopTTI", ()=>$50f6a9f98192a4eb$export$30ca4c461fab486c);
    $parcel$export(module.exports, "cancelTTI", ()=>$50f6a9f98192a4eb$export$27f2445288b528c);
    $parcel$export(module.exports, "markIframeLoad", ()=>$50f6a9f98192a4eb$export$7a2709fc1e33401a);
    $parcel$export(module.exports, "markFieldsRegistered", ()=>$50f6a9f98192a4eb$export$cf3893335c93e33b);
    $parcel$export(module.exports, "markOnInitResolved", ()=>$50f6a9f98192a4eb$export$d86f4868694f2aa7);
    var $dGrdR;
    var $a1HyB;
    const $50f6a9f98192a4eb$var$uimInIssueTransitionTTI = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'ui-modifications-in-issue-transition',
        timings: [
            {
                key: 'issue-transition-tti-delta',
                startMark: 'issue-transition-tti'
            },
            {
                key: 'script-execution',
                startMark: 'iframe-load'
            },
            {
                key: 'loading-indicators-visibility',
                startMark: 'fields-registered'
            },
            {
                key: 'time-until-oninit-resolved',
                endMark: 'oninit-resolved'
            }
        ],
        featureFlags: (0, (0, parcelRequire("a1HyB")).TTIFFs)
    });
    const $50f6a9f98192a4eb$export$ae34c17d9cd2c876 = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.start();
    };
    const $50f6a9f98192a4eb$export$7cc1bb35860c7c25 = ()=>$50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
    const $50f6a9f98192a4eb$export$30ca4c461fab486c = (customData)=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.stop({
            customData: customData
        });
    };
    const $50f6a9f98192a4eb$export$27f2445288b528c = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.cancel();
    };
    const $50f6a9f98192a4eb$export$7a2709fc1e33401a = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('iframe-load');
    };
    const $50f6a9f98192a4eb$export$cf3893335c93e33b = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('fields-registered');
    };
    const $50f6a9f98192a4eb$export$d86f4868694f2aa7 = ()=>{
        $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('oninit-resolved');
    };
});
parcelRegister("a1HyB", function(module, exports) {
    $parcel$export(module.exports, "TTIFFs", ()=>$aec371b77b607203$export$c396ba1504d97f3f);
    const $aec371b77b607203$export$c396ba1504d97f3f = [];
});
parcelRegister("jHYHS", function(module, exports) {
    $parcel$export(module.exports, "isNewTransitionScreenEnabled", ()=>$5f3a7dc1f1182e00$export$1f5b72e7dbe0548d);
    var $aIZdc;
    var $co1wz;
    var $4R6GH;
    const $5f3a7dc1f1182e00$export$3e9c47f2b27760a = (triggerPointKey)=>{
        const triggerPointsFlags = {
            'issue-transition-issue-view': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-issue-view'),
            'issue-transition-issue-view-shortcut-dialog': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-issue-view-shortcut'),
            'issue-transition-board-card-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-board-card-transition'),
            'issue-transition-advanced-roadmaps-jira-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-advanced-roadmaps-jira-transition'),
            'issue-transition-command-palette-status-field-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-command-palette-status'),
            'issue-transition-issue-results-shortcut-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-issue-results-shortcut-transition'),
            'issue-transition-backlog-inline-transition': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-backlog-inline-transition'),
            'issue-transition-status-field-trigger': (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-status-field-trigger'),
            'trigger-point-key-not-defined': (0, (0, parcelRequire("4R6GH")).fg)('trigger-point-key-not-defined')
        };
        return triggerPointsFlags[triggerPointKey];
    };
    const $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return true;
        if (!(0, (0, parcelRequire("co1wz")).ff)('render-modern-issue-transition_cxt0z')) return false;
        if (!triggerPointKey || !$5f3a7dc1f1182e00$export$3e9c47f2b27760a(triggerPointKey)) return false;
        return preferNewIssueTransitionScreen || (0, (0, parcelRequire("4R6GH")).fg)('issue-transition-customisation-for-srb');
    };
});
parcelRegister("keQtD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9984214aecd9b0cd$export$2e2bcd8739ae039);
    const $9984214aecd9b0cd$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
            setState(stateToRestore);
        };
    var $9984214aecd9b0cd$export$2e2bcd8739ae039 = $9984214aecd9b0cd$var$restoreState;
});
parcelRegister("fb5Xn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58f04f71b4951234$export$2e2bcd8739ae039);
    const $58f04f71b4951234$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const { fetchedIssueId: fetchedIssueId } = currentState;
            if (issueId !== fetchedIssueId) setState({
                ...currentState,
                fetchedIssueId: issueId
            });
        };
    var $58f04f71b4951234$export$2e2bcd8739ae039 = $58f04f71b4951234$var$setFetchedIssueId;
});
parcelRegister("bemkp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66c42f9cd1814e06$export$2e2bcd8739ae039);
    var $QnL9H;
    var $jtjyW;
    const $66c42f9cd1814e06$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (nextAction === (0, (0, parcelRequire("QnL9H")).OPEN_MODERN_TRANSITION_MODAL)) {
                (0, (0, parcelRequire("jtjyW")).startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isBenefitsModalOpen: false,
                    isModalOpen: true
                });
            } else if (nextAction === (0, (0, parcelRequire("QnL9H")).OPEN_LEGACY_TRANSITION_MODAL)) {
                const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
                setState({
                    ...currentState,
                    isBenefitsModalOpen: false,
                    isModalOpen: false
                });
                openLegacyTransitionsDialog?.();
            }
        };
    var $66c42f9cd1814e06$export$2e2bcd8739ae039 = $66c42f9cd1814e06$var$hideBenefitsModal;
});
parcelRegister("bnv5t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0522276a96c69778$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eVcDT;
    var $emTT1;
    var $jcw0u;
    var $co1wz;
    var $jtjyW;
    var $jHYHS;
    const $0522276a96c69778$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
                payload: {}
            };
            let transitionModalVersion = '';
            const isNewITSEnabled = (0, (0, parcelRequire("jHYHS")).isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
            try {
                if (isNewITSEnabled) {
                    if (issueViewAnalyticsSource === 'connect-issue') {
                        publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                        fireUIEvent?.({
                            actionSubject: 'issueTransition',
                            actionSubjectId: 'connectIssue',
                            action: 'opened'
                        });
                        return;
                    }
                    transitionModalVersion = 'NEW';
                    (0, (0, parcelRequire("jtjyW")).startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...currentState,
                        isModalOpen: true,
                        fetchedIssueId: '',
                        ...nextState
                    });
                    return;
                }
                const currentDate = new Date();
                const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
                const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
                if ((0, (0, parcelRequire("co1wz")).ff)('render-modern-issue-transition_cxt0z') && !isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate) {
                    transitionModalVersion = 'NEW';
                    const callback = ()=>{
                        (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
                        new (0, (0, parcelRequire("eVcDT")).default)({
                            issueKey: issueKey,
                            transitionId: transitionId
                        }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
                    };
                    setState({
                        ...currentState,
                        isBenefitsModalOpen: true,
                        fetchedIssueId: '',
                        ...nextState,
                        openLegacyTransitionsDialog: callback
                    });
                } else {
                    transitionModalVersion = 'OLD';
                    (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
                    new (0, (0, parcelRequire("eVcDT")).default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'transitionIssueTrigger',
                        packageName: 'jiraIssueTransitionTrigger',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        transitionModalVersion: transitionModalVersion
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };
    var $0522276a96c69778$export$2e2bcd8739ae039 = $0522276a96c69778$var$openIssueTransitionModalNew;
});
parcelRegister("ipUU1", function(module, exports) {
    $parcel$export(module.exports, "openLegacyIssueTransitionModal", ()=>$f258fa9a0604f29b$export$6bfef2005bd55204);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eVcDT;
    var $emTT1;
    var $jcw0u;
    const $f258fa9a0604f29b$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
        try {
            (0, (0, parcelRequire("emTT1")).timeToRenderTransitionModal).start();
            new (0, (0, parcelRequire("eVcDT")).default)({
                issueKey: issueKey,
                transitionId: transitionId
            }).onDialogSuccess(onDialogSuccess || (0, ($parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, ($parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, ($parcel$interopDefault($8Rkzz)))).show();
            onOpenDialog?.();
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: 'OLD',
                    isReopenScenario: isReopenScenario
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("dTUtq", function(module, exports) {
    $parcel$export(module.exports, "useShowFlag", ()=>$4e3d7d0cd8105532$export$46b5557ad4264ef7);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $6OtcO;
    const $4e3d7d0cd8105532$export$46b5557ad4264ef7 = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const showIssueTransitionSuccessFlag = (0, $5uXOq.useCallback)((issueKey, status)=>{
            try {
                showFlag((0, (0, parcelRequire("6OtcO")).getTransitionSuccessFlag)(issueKey, status, formatMessage));
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'showSuccessFlag',
                        packageName: 'jiraIssueTransitionUseShowFlag',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            formatMessage,
            showFlag
        ]);
        const showIssueTransitionFailureFlag = (0, $5uXOq.useCallback)((issueKey)=>showFlag((0, (0, parcelRequire("6OtcO")).getTransitionFailureFlag)(issueKey, formatMessage)), [
            formatMessage,
            showFlag
        ]);
        return {
            showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
            showIssueTransitionFailureFlag: showIssueTransitionFailureFlag
        };
    };
});
parcelRegister("6OtcO", function(module, exports) {
    $parcel$export(module.exports, "getTransitionSuccessFlag", ()=>$12ec3642dfb43880$export$8cfa71b43d733669);
    $parcel$export(module.exports, "getTransitionFailureFlag", ()=>$12ec3642dfb43880$export$d9438db72c9548f1);
    var $6s1PB;
    var $7HGHK;
    var $4O0IR;
    const $12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID = 'issueTransitionSuccessful';
    const $12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID = 'issueTransitionFailure';
    const $12ec3642dfb43880$export$8cfa71b43d733669 = (issueKey, status, formatMessage)=>{
        const showLinkToIssue = Boolean(issueKey && status);
        if (showLinkToIssue) return {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
            type: 'success',
            title: formatMessage((0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessfulWithIssueKeyAndStatus, {
                issueKey: issueKey,
                status: status
            }),
            description: (0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessfulFlagDescription
        };
        return {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
            type: 'success',
            title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessfulIssueTermRefresh : (0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessful)
        };
    };
    const $12ec3642dfb43880$export$d9438db72c9548f1 = (issueKey, formatMessage)=>({
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID),
            type: 'error',
            title: issueKey ? formatMessage((0, (0, parcelRequire("4O0IR")).default).issueTransitionFailureWithKey, {
                issueKey: issueKey
            }) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4O0IR")).default).issueTransitionFailureIssueTermRefresh : (0, (0, parcelRequire("4O0IR")).default).issueTransitionFailure)
        });
});
parcelRegister("4O0IR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d201576bd998790a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d201576bd998790a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTransitionSuccessful: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
            "defaultMessage": "Issue has been updated."
        },
        issueTransitionSuccessfulWithIssueKeyAndStatus: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
            "defaultMessage": "{issueKey} moved to {status}."
        },
        issueTransitionSuccessfulFlagDescription: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
            "defaultMessage": "Kudos for keeping things up-to-date!"
        },
        issueTransitionFailure: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
            "defaultMessage": "Issue could not be updated."
        },
        issueTransitionFailureWithKey: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
            "defaultMessage": "We couldn't update {issueKey}."
        },
        viewIssue: {
            "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
            "defaultMessage": "View issue"
        },
        issueTransitionSuccessfulIssueTermRefresh: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-term-refresh",
            "defaultMessage": "Work item has been updated."
        },
        issueTransitionFailureIssueTermRefresh: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-term-refresh",
            "defaultMessage": "Work item could not be updated."
        },
        viewIssueIssueTermRefresh: {
            "id": "issue-transition-use-show-flag.use-show-flag.view-issue-issue-term-refresh",
            "defaultMessage": "View work item"
        }
    });
});
const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
parcelRegister("luzUm", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bd890bb183837c1d$export$defe85febe8b728c);
    var $7VHMR;
    const $bd890bb183837c1d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        successFlagMessage: {
            "id": "issue-field-status.status-view.command-palette.use-save-status-field.success-flag-message",
            "defaultMessage": "Status updated"
        },
        errorFlagTitle: {
            "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-title",
            "defaultMessage": "We're unable to edit status"
        },
        errorFlagDescription: {
            "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-description",
            "defaultMessage": "Wait a few moments, then try again."
        }
    });
});
parcelRegister("fBoWB", function(module, exports) {
    $parcel$export(module.exports, "getTransitionKeywords", ()=>$b56280b3569df29a$export$258538e0d3d46460);
    const $b56280b3569df29a$export$258538e0d3d46460 = (transition)=>{
        if (transition.name !== transition.to.name) return `${transition.name} ${transition.to.name}`;
        return transition.name;
    };
});
parcelRegister("5uNOo", function(module, exports) {
    $parcel$export(module.exports, "EditStatusButton", ()=>$4d1ec0a4b4de57d9$export$bc1c056aa3d67f87);
    var $5uXOq = parcelRequire("5uXOq");
    var $5nRKm;
    var $gsEeL;
    var $5ILhZ;
    var $8CUq3;
    var $3bDjY;
    var $koVbs;
    var $4zzYB;
    const $4d1ec0a4b4de57d9$export$bc1c056aa3d67f87 = ({ statusName: statusName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClick = (event)=>{
            event.stopPropagation();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            tabIndex: 0,
            xcss: $4d1ec0a4b4de57d9$var$iconButtonStyles,
            onClick: onClick,
            "aria-label": formatMessage((0, (0, parcelRequire("4zzYB")).messages).statusNameButtonLabel, {
                statusName: statusName
            }),
            "data-show-on-hover": true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("4zzYB")).messages).statusEditNameTooltip),
            position: "bottom"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5nRKm"))))), {
            label: "",
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("gsEeL"))))),
            LEGACY_size: "small",
            color: "var(--ds-icon, #44546F)"
        })));
    };
    const $4d1ec0a4b4de57d9$var$iconButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        outlineOffset: 'space.0',
        padding: 'space.025',
        marginInline: 'space.100',
        opacity: 0,
        transition: 'opacity 0.3s ease',
        ':focus': {
            boxShadow: 'elevation.shadow.overflow',
            opacity: 1
        },
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered',
            opacity: 1
        }
    });
});
parcelRegister("4zzYB", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$229b8164a902ee55$export$defe85febe8b728c);
    var $7VHMR;
    const $229b8164a902ee55$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        statusNameButtonLabel: {
            "id": "issue-field-status.status-view.transition.configure-status.status-name-button-label",
            "defaultMessage": "Edit {statusName} status"
        },
        statusEditNameTooltip: {
            "id": "issue-field-status.status-view.transition.configure-status.status-edit-name-tooltip",
            "defaultMessage": "Edit name"
        }
    });
});
parcelRegister("k92cH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d361f761a404638a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d361f761a404638a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noPermission: {
            "id": "issue-field-status.status-view.no-permission",
            "defaultMessage": "You don't have permission to transition this issue"
        },
        cannotLoadTransitions: {
            "id": "issue-field-status.status-view.cannot-load-transitions",
            "defaultMessage": "We couldn't load the statuses and transitions"
        },
        changeStatus: {
            "id": "issue-field-status.status-view.change-status",
            "defaultMessage": "Change status"
        },
        selectStatus: {
            "id": "issue-field-status.status-view.select-status",
            "defaultMessage": "Select status"
        },
        transitionTo: {
            "id": "issue-field-status.status-view.transition-to",
            "defaultMessage": "Transition to {statusName}"
        }
    });
});
parcelRegister("coyc6", function(module, exports) {
    $parcel$export(module.exports, "LoadingSpinner", ()=>$75fbb15d605c0a9c$export$b08b517936747730);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    const $75fbb15d605c0a9c$export$b08b517936747730 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($75fbb15d605c0a9c$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            interactionName: "issue.fields.status.options.loading"
        }));
    const $75fbb15d605c0a9c$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4u2gc _y3gn1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("rNSQs", function(module, exports) {
    $parcel$export(module.exports, "StatusButton", ()=>$acb4d573ba7a4450$export$517b7ecb2da8e76d);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ingq;
    var $3bDjY;
    var $4R6GH;
    var $9wjvq;
    var $2Z7Z6;
    const $acb4d573ba7a4450$var$getButton = (categoryId)=>{
        switch(categoryId){
            case 2:
                return 0, (0, parcelRequire("2Z7Z6")).ToDoButton;
            case 3:
                return 0, (0, parcelRequire("2Z7Z6")).DoneButton;
            case 4:
                return 0, (0, parcelRequire("2Z7Z6")).InProgressButton;
            default:
                return 0, (0, parcelRequire("2Z7Z6")).DefaultButton;
        }
    };
    const $acb4d573ba7a4450$export$517b7ecb2da8e76d = (props)=>{
        const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, status: status, targetRef: targetRef, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true } = props;
        const Button = $acb4d573ba7a4450$var$getButton(status.statusCategory.id);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: targetRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: status.name
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9wjvq")).default), {
            status: status
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Button, {
            id: "issue.fields.status-view.status-button",
            ref: statusButtonRef,
            "aria-label": ariaLabel,
            "aria-expanded": isOpen,
            isDisabled: !isEditable,
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                label: ""
            }),
            testId: "issue-field-status.ui.status-view.status-button.status-button",
            shouldFitContainer: shouldFitContainer,
            ...(0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-18579-status-field-interaction-name') ? {
                interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
            } : {}
        }, status.name))));
    };
});
parcelRegister("9wjvq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1216c2da1b38029$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $47bDC = parcelRequire("47bDC");
    const $b1216c2da1b38029$var$DONE_ID = 3;
    class $b1216c2da1b38029$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidUpdate(prevProps) {
            if (prevProps.status.statusCategory.id !== this.props.status.statusCategory.id) this.setState({
                shouldShow: this.props.status.statusCategory.id === $b1216c2da1b38029$var$DONE_ID
            });
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($b1216c2da1b38029$var$PulseContainer, {
                shouldShow: this.state.shouldShow
            }, this.props.children);
        }
        constructor(...args){
            super(...args);
            this.state = {
                shouldShow: false
            };
        }
    }
    const $b1216c2da1b38029$var$PulseAnimation = (0, $47bDC.keyframes)({
        to: {
            boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)'
        }
    });
    const $b1216c2da1b38029$var$PulseContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldShow: shouldShow, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1qbqnkm": (0, (0, parcelRequire("lD23V")).default)($b1216c2da1b38029$var$PulseAnimation)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _1bsb1osq _2rko1l7b _16qs13jn",
                __cmplp.shouldShow ? "_y44v1upg" : "_y44vglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2Z7Z6", function(module, exports) {
    $parcel$export(module.exports, "DefaultButton", ()=>$bb0c7ad61f4c3610$export$b7c3a2f69225ecf);
    $parcel$export(module.exports, "ToDoButton", ()=>$bb0c7ad61f4c3610$export$97f73b7c6e2328e5);
    $parcel$export(module.exports, "InProgressButton", ()=>$bb0c7ad61f4c3610$export$8c94aeefd701630d);
    $parcel$export(module.exports, "DoneButton", ()=>$bb0c7ad61f4c3610$export$e6559310cd173125);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $7XYc4;
    var $4R6GH;
    var $dCm1o;
    const $bb0c7ad61f4c3610$var$getButtonStyles = ()=>{
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return {
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            '::after': {
                border: 'none'
            }
        };
        return {
            fontWeight: "var(--ds-font-weight-semibold, 600)"
        };
    };
    const $bb0c7ad61f4c3610$export$b7c3a2f69225ecf = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193g10pm _11a410pm _dntbyv3a _cp4gyv3a _5xmd8ldq _11smyv3a",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$export$97f73b7c6e2328e5 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193guicy _11a4uicy _dntb16l4 _cp4g16l4 _5xmd1psz _11sm16l4",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$var$InProgressComponentVisualRefresh = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193gp2jz _11a4p2jz _dntb4viv _cp4g4viv _5xmd1185 _11sm4viv",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$var$InProgressComponentCurrent = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193gsxa6 _11a4sxa6 _dntb1gfe _cp4g1gfe _5xmdi36s _11sm1gfe",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$export$8c94aeefd701630d = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1'), $bb0c7ad61f4c3610$var$InProgressComponentVisualRefresh, $bb0c7ad61f4c3610$var$InProgressComponentCurrent);
    const $bb0c7ad61f4c3610$export$5392037c0e6ad119 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193g1jjx _11a41jjx _dntb4viv _cp4g4viv _5xmdqnrl _11sm4viv",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$export$5445f55445c67248 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193g147y _11a4147y _dntb1gfe _cp4g1gfe _5xmdihng _11sm1gfe",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$export$e6559310cd173125 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1'), $bb0c7ad61f4c3610$export$5392037c0e6ad119, $bb0c7ad61f4c3610$export$5445f55445c67248);
});
parcelRegister("1khYv", function(module, exports) {
    $parcel$export(module.exports, "Transition", ()=>$548d8ec8e7bf977f$export$be58926105124dd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kkuz9;
    var $3bDjY;
    var $5f2o3;
    var $cPJPi;
    const $548d8ec8e7bf977f$export$be58926105124dd4 = ({ hasLabel: hasLabel, transition: transition, addTransitionArrowSpacing: addTransitionArrowSpacing, contentAfter: contentAfter })=>{
        if (transition.isDisabled === true) return (0, ($parcel$interopDefault($5uXOq))).createElement($548d8ec8e7bf977f$var$DisabledTransition, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cPJPi")).TransitionWithoutLabel), {
            transition: transition,
            isDisabled: true
        }), transition.unavailableReasonText != null && transition.unavailableReasonText !== '' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: transition.unavailableReasonText
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($548d8ec8e7bf977f$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kkuz9"))))), {
            label: "",
            primaryColor: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$exports).N200})`
        }))));
        const transitionComponent = hasLabel ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5f2o3")).TransitionWithLabel), {
            transition: transition,
            addTransitionArrowSpacing: addTransitionArrowSpacing
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cPJPi")).TransitionWithoutLabel), {
            transition: transition
        });
        return contentAfter ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1yb4 _wjvokb7n"
            ])
        }, transitionComponent, contentAfter) : transitionComponent;
    };
    const $548d8ec8e7bf977f$var$DisabledTransition = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1bah1yb4",
                __cmplp.className
            ])
        });
    });
    const $548d8ec8e7bf977f$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3io7ao _1reoewfl _18m9ewfl _19pkr5cr",
                __cmplp.className
            ])
        });
    });
    const $548d8ec8e7bf977f$export$7ed12d2a5241e393 = {
        IconWrapper: $548d8ec8e7bf977f$var$IconWrapper
    };
    const $548d8ec8e7bf977f$var$transitionWrapperStyles = null;
});
parcelRegister("5f2o3", function(module, exports) {
    $parcel$export(module.exports, "TransitionWithLabel", ()=>$ce0d296e0359021c$export$20d2722b94f01359);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8RBk4;
    var $kgoHi;
    var $4R6GH;
    var $aWse0;
    var $dCm1o;
    var $17mYr;
    var $cnQeu;
    const $ce0d296e0359021c$var$getLabel = (transition, intl)=>{
        if (transition.isGlobal) {
            if (transition.name !== transition.to.name) return transition.name;
            return intl.formatMessage((0, (0, parcelRequire("cnQeu")).default).globalTransition);
        }
        return transition.name;
    };
    const $ce0d296e0359021c$export$20d2722b94f01359 = (props)=>{
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$export$147422f7450ccfac, null, $ce0d296e0359021c$var$getLabel(props.transition, intl)), (0, ($parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$export$da4545fe0ca096cf, {
            visualRefresh: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$var$VerticalCenter, {
            addTransitionArrowSpacing: props.addTransitionArrowSpacing
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
            label: "",
            size: "small"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17mYr")).StatusLozenge), {
            status: props.transition.to,
            isDisabled: props.isDisabled
        })));
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100"
        }, content);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$var$Wrapper, null, content);
    };
    const $ce0d296e0359021c$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $ce0d296e0359021c$export$147422f7450ccfac = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $ce0d296e0359021c$export$da4545fe0ca096cf = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf _1e0c1txw",
                __cmplp.visualRefresh && "_4cvr1h6o _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $ce0d296e0359021c$var$VerticalCenter = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { addTransitionArrowSpacing: addTransitionArrowSpacing, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o",
                __cmplp.addTransitionArrowSpacing ? "_18s8s8vo" : "_19pk1kw7 _2hwx1kw7 _otyr1kw7 _18u01kw7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cnQeu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1c9e2137350f319$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a1c9e2137350f319$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        globalTransition: {
            "id": "issue-field-status.status-view.transition.with-label.global-transition",
            "defaultMessage": "Transition to"
        }
    });
});
parcelRegister("cPJPi", function(module, exports) {
    $parcel$export(module.exports, "TransitionWithoutLabel", ()=>$35e7b9f215fedcad$export$4cf2c7e5a408120e);
    var $5uXOq = parcelRequire("5uXOq");
    var $17mYr;
    const $35e7b9f215fedcad$export$4cf2c7e5a408120e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17mYr")).StatusLozenge), {
            status: props.transition.to,
            isDisabled: props.isDisabled
        });
});
parcelRegister("an47R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1031d96eb0ec849$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $4R6GH;
    var $egJPW;
    var $FEqQ9;
    var $2Fn8l;
    var $fs8Mw;
    class $a1031d96eb0ec849$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { baseUrl: baseUrl, issueKey: issueKey, isModalMounted: isModalMounted, onOpenModal: onOpenModal, workflowServiceApi: workflowServiceApi, onCloseModal: onCloseModal } = this.props;
            const { isWorkflowServiceRefetching: isWorkflowServiceRefetching } = this.state;
            const { data: data, loading: loading, error: error, fetch: fetch } = workflowServiceApi;
            if (error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("egJPW")).default), {
                onRetry: (e)=>{
                    this.onWorkflowServiceRefetch(e, fetch);
                }
            });
            if (!data) return null;
            const { isSimplified: isSimplified, projectId: projectId, issueTypeId: issueTypeId, hasPermission: hasPermission } = data;
            if ((0, (0, parcelRequire("4R6GH")).fg)('cmp_support_for_readonly_workflow_modal')) {
                if (!projectId) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue-field-status.view-workflow.no-project-id', 'WorkflowServiceApi finished loading but there was no projectId');
                    return null;
                }
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Fn8l")).ViewWorkflowModalDropDownTrigger), {
                    issueKey: issueKey,
                    projectId: projectId,
                    issueTypeId: issueTypeId,
                    isSimplifiedProject: isSimplified,
                    hasPermission: hasPermission,
                    isServiceLoading: loading,
                    isServiceRefetching: isWorkflowServiceRefetching,
                    onClose: onCloseModal
                });
            }
            if (isSimplified === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fs8Mw")).default), {
                projectId: projectId,
                issueTypeId: issueTypeId,
                isModalMounted: isModalMounted,
                hasPermission: hasPermission,
                isServiceLoading: loading,
                isServiceRefetching: isWorkflowServiceRefetching,
                onOpenModal: onOpenModal
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("FEqQ9")).default), {
                baseUrl: baseUrl,
                issueKey: issueKey,
                hasPermission: hasPermission,
                isServiceLoading: loading,
                isServiceRefetching: isWorkflowServiceRefetching
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isWorkflowServiceRefetching: false
            };
            this.onWorkflowServiceRefetch = async (e, retry)=>{
                e.stopPropagation();
                this.setState({
                    isWorkflowServiceRefetching: true
                });
                await retry();
                this.setState({
                    isWorkflowServiceRefetching: false
                });
            };
        }
    }
});
parcelRegister("egJPW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcc9251c728cc690$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9yOBd;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $jlBA8;
    const $dcc9251c728cc690$export$edf27be85e5f6da0 = ({ onRetry: onRetry })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onRetryClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'retryViewWorkflowButton');
            onRetry(e);
        }, [
            onRetry
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "viewWorkflowError",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($dcc9251c728cc690$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $dcc9251c728cc690$var$errorMessageWrapperStyles
        }, formatMessage((0, (0, parcelRequire("jlBA8")).default).errorMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement($dcc9251c728cc690$var$ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            appearance: "link",
            spacing: "none",
            onClick: onRetryClick,
            theme: (currentTheme, theme)=>{
                const buttonTheme = currentTheme(theme);
                return {
                    ...buttonTheme,
                    buttonStyles: {
                        ...buttonTheme.buttonStyles,
                        alignItems: 'center'
                    }
                };
            },
            interactionName: "auto-generated.jira-issue-field-status.common.ui.view-workflow.error.button"
        }, formatMessage((0, (0, parcelRequire("jlBA8")).default).tryAgain))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null)));
    };
    var $dcc9251c728cc690$export$2e2bcd8739ae039 = $dcc9251c728cc690$export$edf27be85e5f6da0;
    const $dcc9251c728cc690$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ickbl _x3do1on0 _1e0c1txw _4cvr1h6o _1yt4s8vo _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $dcc9251c728cc690$var$ButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $dcc9251c728cc690$var$errorMessageWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.100'
    });
});
parcelRegister("jlBA8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cf306506fde1ae6b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cf306506fde1ae6b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorMessage: {
            "id": "issue-field-status.common.view-workflow.error.error-message",
            "defaultMessage": "Couldn\u2019t find the workflow."
        },
        tryAgain: {
            "id": "issue-field-status.common.view-workflow.error.try-again",
            "defaultMessage": "Try again"
        }
    });
});
parcelRegister("FEqQ9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97c96869b4d190e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6BZYo;
    var $c9CKH;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $4su49;
    var $fg6rA;
    var $egJPW;
    var $8QPwp;
    var $hjkQi;
    var $hmnrA;
    const $97c96869b4d190e3$export$b5e9eef0cad95164 = ({ isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, issueKey: issueKey, hasPermission: hasPermission, baseUrl: baseUrl, ClassicViewWorkflowService: ClassicViewWorkflowService = (0, (0, parcelRequire("hjkQi")).ClassicViewWorkflowServiceWithAnalytics) })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isModalMounted, setIsModalMounted] = (0, $5uXOq.useState)(false);
        const [isLoadingModal, setIsLoadingModal] = (0, $5uXOq.useState)(false);
        const [isRefetching, setIsRefetching] = (0, $5uXOq.useState)(false);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const isModalMounting = isLoadingModal && !isModalMounted;
        const isDisabled = !hasPermission || isModalMounting;
        const isLoading = isModalMounting || isServiceRefetching || isRefetching;
        let modalApi;
        (0, $5uXOq.useEffect)(()=>{
            const modalModuleName = 'workflow-designer/view-classic-project-workflow';
            modalApi = (0, (0, parcelRequire("6BZYo")).loadBridge)({
                name: modalModuleName,
                tentatives: 0,
                shouldLogError: false
            }).catch(()=>{
                (0, (0, parcelRequire("4su49")).asyncWrmRequire)([
                    'wr!com.atlassian.jira.plugins.jira-workflow-designer:view-issue-page-workflow-designer'
                ]);
                return (0, (0, parcelRequire("6BZYo")).loadBridge)({
                    name: modalModuleName
                });
            });
        }, []);
        const onClick = (0, $5uXOq.useCallback)((analyticsEvent, pShowFlag, workflowName, currentStepId)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'viewWorkflowTrigger', {
                isSimplifiedProject: false
            });
            if (!modalApi || !workflowName || !currentStepId) return;
            setIsLoadingModal(true);
            setIsRefetching(false);
            modalApi.then((api)=>{
                api.showDialog(workflowName, currentStepId);
                window.dispatchEvent((0, (0, parcelRequire("c9CKH")).default)('resize'));
                setIsModalMounted({
                    isModalMounted: true
                });
            }).catch(()=>{
                pShowFlag && pShowFlag((0, (0, parcelRequire("hmnrA")).default).loadModalError());
                setIsLoadingModal(false);
            });
        }, [
            modalApi,
            setIsModalMounted,
            setIsRefetching,
            setIsLoadingModal
        ]);
        const onRetry = (0, $5uXOq.useCallback)((event, retry)=>{
            event.stopPropagation();
            setIsRefetching(true);
            return retry().then(()=>setIsRefetching(false));
        }, [
            setIsRefetching
        ]);
        const onMount = (0, $5uXOq.useCallback)((analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'viewWorkflowTrigger mounted', {
                hasViewWorkflowPermission: hasPermission,
                isSimplifiedProject: false
            });
        }, [
            hasPermission
        ]);
        const getTooltipMessage = (0, $5uXOq.useCallback)((isClassicServiceLoading)=>{
            if (isServiceRefetching || isClassicServiceLoading) return formatMessage((0, (0, parcelRequire("8QPwp")).default).loading);
            if (!hasPermission) return formatMessage((0, (0, parcelRequire("8QPwp")).default).noPermission);
            return '';
        }, [
            formatMessage,
            hasPermission,
            isServiceRefetching
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ClassicViewWorkflowService, {
            issueKey: issueKey,
            baseUrl: baseUrl,
            shouldLoadOnMount: hasPermission
        }, ({ data: data, error: error, loading: isClassicServiceLoading, retry: retry })=>{
            if (error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("egJPW")).default), {
                onRetry: (event)=>{
                    onRetry(event, retry);
                }
            });
            const workflowName = data ? data.workflowName : null;
            const currentStepId = data ? data.currentStepId : null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fg6rA")).default), {
                onMount: onMount,
                tooltipContent: getTooltipMessage(isServiceLoading || isClassicServiceLoading),
                isDisabled: isDisabled || isClassicServiceLoading,
                isLoading: isLoading,
                isInitialLoading: isServiceLoading || isClassicServiceLoading,
                onClick: (_, analyticsEvent)=>onClick(analyticsEvent, showFlag, workflowName, currentStepId)
            });
        });
    };
    var $97c96869b4d190e3$export$2e2bcd8739ae039 = $97c96869b4d190e3$export$b5e9eef0cad95164;
});
parcelRegister("c9CKH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb779c21ddd2b986$export$2e2bcd8739ae039);
    var $cb779c21ddd2b986$export$2e2bcd8739ae039 = (eventType, eventConstructor = 'Event', bubbles = true, cancelable = true)=>{
        const event = document.createEvent(eventConstructor);
        event.initEvent(eventType, bubbles, cancelable);
        return event;
    };
});
parcelRegister("fg6rA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$677a05abc6bdd063$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9yOBd;
    var $3bDjY;
    var $4R6GH;
    var $aWse0;
    var $isuse;
    var $iQO8Y;
    const $677a05abc6bdd063$var$WithTooltip = ({ content: content, children: children })=>{
        if (content) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            tag: "span",
            content: content
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $677a05abc6bdd063$var$ViewWorkflowButton = ({ forwardRef: forwardRef, isDisabled: isDisabled, isLoading: isLoading, isInitialLoading: isInitialLoading, onClick: onClick, onMount: onMount, tooltipContent: tooltipContent })=>{
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const isDisabledColor = isDisabled === true && !isInitialLoading;
        const ConditionalWrapper = (0, (0, parcelRequire("4R6GH")).fg)('jira_issue_view_inline_status_creation_prereqs') ? $677a05abc6bdd063$var$WrapperWithoutBorder : $677a05abc6bdd063$export$e6dfd72ab29f8598;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ConditionalWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: onMount
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($677a05abc6bdd063$var$WithTooltip, {
            content: tooltipContent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($677a05abc6bdd063$export$d53c836cccbb0d90, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            testId: "issue-field-status.common.ui.view-workflow.button.view-workflow",
            shouldFitContainer: true,
            appearance: "subtle",
            spacing: "none",
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onClick,
            theme: (currentTheme, theme)=>{
                const buttonTheme = currentTheme(theme);
                return {
                    ...buttonTheme,
                    buttonStyles: {
                        ...buttonTheme.buttonStyles,
                        alignItems: 'center',
                        textAlign: 'left',
                        color: isDisabledColor ? `var(--ds-text-disabled, ${(0, $829f609a65d26a98$exports).N70})` : `var(--ds-text, ${(0, $829f609a65d26a98$exports).N900})`,
                        padding: `0 ${"var(--ds-space-150, 12px)"}`
                    }
                };
            },
            interactionName: "auto-generated.issue-field-status.common.ui.view-workflow.button.view-workflow.button",
            ref: forwardRef
        }, intl.formatMessage((0, (0, parcelRequire("iQO8Y")).default).viewWorkflow)))));
    };
    var $677a05abc6bdd063$export$2e2bcd8739ae039 = $677a05abc6bdd063$var$ViewWorkflowButton;
    const $677a05abc6bdd063$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ickbl _x3do1on0",
                __cmplp.className
            ])
        });
    });
    const $677a05abc6bdd063$var$WrapperWithoutBorder = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1jfw",
                __cmplp.className
            ])
        });
    });
    const $677a05abc6bdd063$export$d53c836cccbb0d90 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _4t3i1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iQO8Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35c1321d84301d6b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $35c1321d84301d6b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewWorkflow: {
            "id": "issue-field-status.common.view-workflow.button.view-workflow",
            "defaultMessage": "View workflow"
        }
    });
});
parcelRegister("8QPwp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abf08e7db398f42f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $abf08e7db398f42f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noPermission: {
            "id": "issue-field-status.common.view-workflow.no-permission",
            "defaultMessage": "You don't have permission to view this workflow."
        },
        loading: {
            "id": "issue-field-status.common.view-workflow.loading",
            "defaultMessage": "Looks like your connection is slow. We\u2019re still finding this workflow."
        }
    });
});
parcelRegister("hjkQi", function(module, exports) {
    $parcel$export(module.exports, "ClassicViewWorkflowServiceWithAnalytics", ()=>$70f45b887ec8707a$export$1a80ddaaeea6341b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $dJl1T;
    var $8zOmE;
    var $3cBFD;
    class $70f45b887ec8707a$var$ClassicViewWorkflowService extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                shouldLoadOnMount: true
            };
        }
        componentDidMount() {
            if (this.props.shouldLoadOnMount === true) this.load();
        }
        onLoading() {
            this.setState({
                data: undefined,
                error: undefined,
                loading: true
            });
        }
        onLoadSucceeded(data) {
            this.setState({
                data: data,
                error: undefined,
                loading: false
            });
        }
        onLoadFailed(error) {
            this.setState({
                data: undefined,
                error: error,
                loading: false
            });
        }
        fireAnalytics() {
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'requested'
            });
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'classicViewWorkflowData requested');
        }
        render() {
            return this.props.children({
                ...this.state,
                retry: this.load
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                data: undefined,
                error: undefined,
                loading: false
            };
            this.load = async ()=>{
                this.onLoading();
                const { baseUrl: baseUrl, issueKey: issueKey } = this.props;
                try {
                    this.fireAnalytics();
                    const data = await (0, (0, parcelRequire("3cBFD")).getViewWorkflowData)(baseUrl, issueKey);
                    this.onLoadSucceeded(data);
                } catch (error) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue-field.status.classic-view-workflow-service.fetch', 'Failed to fetch classic view workflow data.', {
                        errorReason: error.message && error.message === 'TransformError' ? 'transform' : 'fetch'
                    });
                    this.onLoadFailed(error);
                }
            };
        }
    }
    const $70f45b887ec8707a$export$1a80ddaaeea6341b = (0, (0, parcelRequire("cb25w")).default)()($70f45b887ec8707a$var$ClassicViewWorkflowService);
});
parcelRegister("3cBFD", function(module, exports) {
    $parcel$export(module.exports, "getViewWorkflowData", ()=>$5ed8320c2b2d6086$export$fa1a6ac9833b0597);
    var $eusud;
    const $5ed8320c2b2d6086$var$query = `
query classicViewWorkflowQuery($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        workflow {
            name
            step {
                id
            }
        }
    }
}
`;
    const $5ed8320c2b2d6086$export$3361e9be8093ddcc = (response)=>{
        if (response.data && response.data.viewIssue && response.data.viewIssue.workflow) return {
            workflowName: response.data.viewIssue.workflow.name,
            currentStepId: response.data.viewIssue.workflow.step.id
        };
        throw new Error('TransformError');
    };
    const $5ed8320c2b2d6086$export$fa1a6ac9833b0597 = (_baseUrl, issueKey)=>(0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $5ed8320c2b2d6086$var$query,
                variables: {
                    issueKey: issueKey
                }
            })
        }).then($5ed8320c2b2d6086$export$3361e9be8093ddcc);
});
parcelRegister("hmnrA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48a9f2e4a5356e03$export$2e2bcd8739ae039);
    var $01p0t;
    var $48a9f2e4a5356e03$export$2e2bcd8739ae039 = {
        loadModalError: (0, parcelRequire("01p0t")).default
    };
});
parcelRegister("01p0t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5eb36f16aa3374eb$export$2e2bcd8739ae039);
    var $7VHMR;
    const $5eb36f16aa3374eb$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "issue-field-status.view-workflow.classic.flags.errors.load-modal-error.title",
            "defaultMessage": "We couldn't load the workflow"
        },
        description: {
            "id": "issue-field-status.view-workflow.classic.flags.errors.load-modal-error.description",
            "defaultMessage": "Check your connection, then try reloading the page."
        }
    });
    var $5eb36f16aa3374eb$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $5eb36f16aa3374eb$var$messages.title,
            description: $5eb36f16aa3374eb$var$messages.description
        });
});
parcelRegister("2Fn8l", function(module, exports) {
    $parcel$export(module.exports, "ViewWorkflowModalDropDownTrigger", ()=>$5a46620a956691e0$export$1c337688ee874e1d);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $koVbs;
    var $2KAtx;
    var $8zOmE;
    var $2NMNM;
    var $lDsR4;
    var $fg6rA;
    var $8QPwp;
    const $5a46620a956691e0$export$1c337688ee874e1d = ({ hasPermission: hasPermission, isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, ...selfProps })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isSimplifiedProject = selfProps.isSimplifiedProject;
        const onMount = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewWorkflowTrigger mounted', {
                hasViewWorkflowPermission: hasPermission,
                isSimplifiedProject: isSimplifiedProject
            });
        }, [
            createAnalyticsEvent,
            hasPermission,
            isSimplifiedProject
        ]);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'viewWorkflowTrigger',
                action: 'clicked'
            }), {
                isSimplifiedProject: isSimplifiedProject
            });
        }, [
            createAnalyticsEvent,
            isSimplifiedProject
        ]);
        const { tooltip: tooltip, isDisabled: isDisabled, isLoading: isLoading } = (0, $5uXOq.useMemo)(()=>{
            if (isServiceLoading || isServiceRefetching) return {
                tooltip: formatMessage((0, (0, parcelRequire("8QPwp")).default).loading),
                isDisabled: true,
                isLoading: isServiceRefetching
            };
            if (hasPermission !== true) return {
                tooltip: formatMessage((0, (0, parcelRequire("8QPwp")).default).noPermission),
                isDisabled: true,
                isLoading: false
            };
            return {
                tooltip: '',
                isDisabled: false
            };
        }, [
            isServiceLoading,
            isServiceRefetching,
            hasPermission,
            formatMessage
        ]);
        const modalProps = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('cmp-read-view-modal-fix-focus-flash')) return {
                autoFocus: false,
                width: '100%',
                testId: 'issue-field-status.ui.view-workflow.read-view-modal'
            };
            return {
                width: '100%',
                testId: 'issue-line-card.ui.remove-button.confirmation-modal.delete'
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
            entryPoint: (0, (0, parcelRequire("lDsR4")).entryPoint),
            entryPointProps: selfProps,
            interactionName: "open-read-view-workflow-modal",
            modalProps: modalProps,
            useInternalModal: true
        }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fg6rA")).default), {
                forwardRef: ref,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isInitialLoading: !!isServiceLoading,
                onMount: onMount,
                onClick: onClick,
                tooltipContent: tooltip
            }));
    };
});
parcelRegister("2KAtx", function(module, exports) {
    $parcel$export(module.exports, "ModalEntryPointPressableTrigger", ()=>$a17c22dd70443cfd$export$defad645fcc21c0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $iwwXK;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $luBm6;
    var $kMSay;
    var $9fuVs;
    var $4R6GH;
    var $c5vfY;
    var $7mPT9;
    var $gJdig;
    var $fiv1r;
    var $dWBzX;
    const $a17c22dd70443cfd$var$emptyObject = {};
    const $a17c22dd70443cfd$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef })=>{
        const { openModal: openModal } = (0, $5uXOq.useContext)((0, (0, parcelRequire("gJdig")).ModalContext));
        const environmentProvider = (0, (0, parcelRequire("fiv1r")).useJiraRelayEnvironmentProvider)();
        const pressTracing = (0, (0, parcelRequire("kMSay")).default)(interactionName ?? '');
        const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $a17c22dd70443cfd$var$emptyObject), [
            entryPoint,
            entryPointParams,
            environmentProvider
        ]);
        const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
            if (interactionName) pressTracing();
        }, [
            interactionName,
            pressTracing
        ]);
        const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
            openModal(({ onClose: closeModal })=>{
                const onClose = ()=>{
                    entryPointProps?.onClose?.();
                    closeModal();
                    dispose();
                };
                const defaultFallbackInner = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, title ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, title) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                    grow: "fill"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null));
                const defaultFallback = useInternalModal ? defaultFallbackInner : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                    onClose: closeModal,
                    width: modalProps?.width,
                    height: modalProps?.height
                }, defaultFallbackInner);
                const container = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
                    entryPointReference: entryPointReference,
                    errorAttributes: errorAttributes,
                    errorFallback: "flag",
                    fallback: Fallback ? (0, ($parcel$interopDefault($5uXOq))).createElement(Fallback, {
                        onClose: closeModal
                    }) : defaultFallback,
                    id: entryPoint.root.getModuleName?.() ?? 'unknown',
                    placeholderName: "modal-entry-point-pressable-trigger-container",
                    runtimeProps: {
                        ...entryPointProps ?? $a17c22dd70443cfd$var$emptyObject,
                        onClose: onClose
                    }
                });
                return useInternalModal ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                    ...modalProps,
                    onClose: onClose
                }, container)) : container;
            });
        }, [
            entryPoint,
            entryPointProps,
            errorAttributes,
            Fallback,
            openModal,
            title,
            modalProps,
            useInternalModal
        ]);
        const triggerRef = (0, (0, parcelRequire("dWBzX")).usePressablePreloadRef)({
            load: load,
            onBeforeLoad: onBeforeLoad,
            onLoad: onLoad
        });
        if (forwardedRef != null && (0, (0, parcelRequire("4R6GH")).fg)('forward_ref_modalentrypointdropdownitemtrigger')) {
            const ref = (0, (0, parcelRequire("7mPT9")).default)(triggerRef, forwardedRef);
            return children({
                ref: ref
            });
        }
        return children({
            ref: triggerRef
        });
    };
});
parcelRegister("7mPT9", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$d1da29f25d5b5e0a$export$c9058316764c140e);
    $parcel$export(module.exports, "default", ()=>$d1da29f25d5b5e0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    }
    function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
        return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), refs);
    }
});
parcelRegister("dWBzX", function(module, exports) {
    $parcel$export(module.exports, "usePressablePreloadRef", ()=>$01294bc664dce1e5$export$1ff47f24e06a5d2d);
    var $5uXOq = parcelRequire("5uXOq");
    const $01294bc664dce1e5$var$PRELOAD_MAX_AGE = 2000;
    const $01294bc664dce1e5$var$TIME_TO_INTENT = 200;
    function $01294bc664dce1e5$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const el = ref.current;
            if (!el) return;
            const request = {};
            const clearPreloadTimeouts = ()=>{
                if (typeof request.preloadIntentTimeout === 'number') {
                    clearTimeout(request.preloadIntentTimeout);
                    delete request.preloadIntentTimeout;
                }
                if (typeof request.preloadMaxAgeTimeout === 'number') {
                    clearTimeout(request.preloadMaxAgeTimeout);
                    delete request.preloadMaxAgeTimeout;
                }
            };
            const cancelPreload = ()=>{
                clearPreloadTimeouts();
                request.preload?.dispose();
            };
            const loadReference = ()=>{
                if (request.load) return request.load;
                const reference = request.preload?.reference ?? load();
                if (request.preload) delete request.preload;
                request.load = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.load;
                    }
                };
                return request.load;
            };
            const clickListener = ()=>{
                clearPreloadTimeouts();
                onBeforeLoad();
                onLoad(loadReference());
            };
            const mouseDownListener = ()=>{
                clearPreloadTimeouts();
                loadReference();
            };
            const preloadReference = ()=>{
                if (request.preloadIntentTimeout || request.preload) return;
                request.preloadIntentTimeout = setTimeout(()=>{
                    delete request.preloadIntentTimeout;
                    const reference = load();
                    request.preload = {
                        reference: reference,
                        dispose () {
                            reference.dispose();
                            delete request.preload;
                        }
                    };
                    request.preloadMaxAgeTimeout = setTimeout(()=>{
                        delete request.preloadMaxAgeTimeout;
                        request.preload?.dispose();
                    }, $01294bc664dce1e5$var$PRELOAD_MAX_AGE);
                }, $01294bc664dce1e5$var$TIME_TO_INTENT);
            };
            el.addEventListener('click', clickListener);
            el.addEventListener('mousedown', mouseDownListener);
            el.addEventListener('mouseenter', preloadReference);
            el.addEventListener('mouseleave', cancelPreload);
            return ()=>{
                cancelPreload();
                el.removeEventListener('click', clickListener);
                el.removeEventListener('mousedown', mouseDownListener);
                el.removeEventListener('mouseenter', preloadReference);
                el.removeEventListener('mouseleave', cancelPreload);
            };
        }, [
            load,
            onBeforeLoad,
            onLoad
        ]);
        return ref;
    }
});
parcelRegister("lDsR4", function(module, exports) {
    $parcel$export(module.exports, "entryPoint", ()=>$3b8f29a56db722f3$export$6333901e831d7af0);
    var $eufEc;
    var $fEDBv;
    const $3b8f29a56db722f3$export$6333901e831d7af0 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("d4ZMX")), {
            moduleId: "16c65716"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("d4ZMX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("34HZt")
    ]).then(()=>parcelRequire('jhZ7l'));
});
parcelRegister("fs8Mw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ac5fbf25b060715$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $az4zD;
    var $8zOmE;
    var $g5X3G;
    var $fg6rA;
    var $8QPwp;
    class $3ac5fbf25b060715$var$ViewWorkflowSimplified extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                hasPermission: false
            };
        }
        getTooltipMessage() {
            const { isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, hasPermission: hasPermission, intl: intl } = this.props;
            if (isServiceLoading || isServiceRefetching) return intl.formatMessage((0, (0, parcelRequire("8QPwp")).default).loading);
            if (hasPermission !== true) return intl.formatMessage((0, (0, parcelRequire("8QPwp")).default).noPermission);
            return '';
        }
        render() {
            const { isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, hasPermission: hasPermission, isModalMounted: isModalMounted } = this.props;
            const { isLoadingModal: isLoadingModal } = this.state;
            const isModalMounting = isLoadingModal && !isModalMounted;
            const isDisabled = hasPermission !== true || isModalMounting;
            const isLoading = isServiceRefetching || isModalMounting;
            const tooltipContent = this.getTooltipMessage();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fg6rA")).default), {
                onMount: this.onMount,
                tooltipContent: tooltipContent,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isInitialLoading: isServiceLoading,
                onClick: this.onClick
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isLoadingModal: false
            };
            this.onMount = (analyticsEvent)=>{
                const { hasPermission: hasPermission } = this.props;
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'viewWorkflowTrigger mounted', {
                    hasViewWorkflowPermission: hasPermission,
                    isSimplifiedProject: true
                });
            };
            this.onClick = (event, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'viewWorkflowTrigger', {
                    isSimplifiedProject: true
                });
                this.setState({
                    isLoadingModal: true
                });
                const { issueTypeId: issueTypeId = (0, (0, parcelRequire("g5X3G")).toIssueTypeId)(''), projectId: projectId = (0, (0, parcelRequire("g5X3G")).toProjectId)(''), onOpenModal: onOpenModal } = this.props;
                onOpenModal(issueTypeId, projectId);
            };
        }
    }
    var $3ac5fbf25b060715$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($3ac5fbf25b060715$var$ViewWorkflowSimplified);
});
parcelRegister("2brZf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de90987dda80794f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $l0sjw;
    var $hgJxR;
    var $kxZPA;
    var $6Lg6A;
    const $de90987dda80794f$export$de1fcbea0facb135 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("awynQ")), {
        moduleId: "./src/packages/issue/workflow-readonly-modal/src/index.tsx"
    });
    class $de90987dda80794f$export$3d7b4a64bc1f330f extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            return {
                shouldMountWorkflow: state.shouldMountWorkflow || props.isOpen
            };
        }
        render() {
            const { issueKey: issueKey, issueTypeId: issueTypeId, baseUrl: baseUrl, locale: locale, cloudId: cloudId, projectId: projectId, isOpen: isOpen, onModalMounted: onModalMounted, onClose: onClose, scope: scope } = this.props;
            const { shouldMountWorkflow: shouldMountWorkflow } = this.state;
            return shouldMountWorkflow && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hgJxR")).WorkflowReadonlyModalBoundary), {
                packageName: "issue"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l0sjw")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Lg6A")).LazyWait), {
                until: isOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($de90987dda80794f$export$de1fcbea0facb135, {
                onMounted: onModalMounted,
                issueKey: issueKey,
                issueTypeId: issueTypeId,
                baseUrl: baseUrl,
                locale: locale,
                isOpen: isOpen,
                cloudId: cloudId,
                projectId: projectId,
                onClose: onClose,
                scope: scope
            }))));
        }
        constructor(...args){
            super(...args);
            this.state = {
                shouldMountWorkflow: false
            };
        }
    }
    var $de90987dda80794f$export$2e2bcd8739ae039 = $de90987dda80794f$export$3d7b4a64bc1f330f;
});
parcelRegister("l0sjw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f5b4df3c1787ede$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4eKbI;
    var $cEm1b;
    function $3f5b4df3c1787ede$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
        const parentProfilerContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("cEm1b")).ProfilerContext));
        const ignoredRLLProfilerContext = (0, $5uXOq.useMemo)(()=>({
                ...parentProfilerContext,
                placeholderFallBackMounted () {},
                placeholderFallBackUnmounted () {}
            }), [
            parentProfilerContext
        ]);
        const kids = children != null ? children : null;
        if (!ignore) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, kids);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4eKbI")).default), {
            ignore: ignore
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEm1b")).ProfilerContext).Provider, {
            value: ignoredRLLProfilerContext
        }, kids));
    }
});
parcelRegister("4eKbI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd3e682addb0cb4a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6wxJn;
    function $fd3e682addb0cb4a$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("6wxJn")).default));
        const ignoredInteractionContext = (0, $5uXOq.useMemo)(()=>{
            if (!parentContext) return null;
            return {
                ...parentContext,
                hold (...args) {
                    if (!ignore) return parentContext.hold(...args);
                }
            };
        }, [
            parentContext,
            ignore
        ]);
        const kids = children != null ? children : null;
        if (!ignoredInteractionContext) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, kids);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6wxJn")).default).Provider, {
            value: ignoredInteractionContext
        }, kids);
    }
});
parcelRegister("hgJxR", function(module, exports) {
    $parcel$export(module.exports, "WorkflowReadonlyModalBoundary", ()=>$d71a221e31d14d82$export$62f00f305552896d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gjEtj;
    var $lzG9C;
    const $d71a221e31d14d82$export$62f00f305552896d = ({ children: children, packageName: packageName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjEtj")).ModalBoundary), {
            id: "workflow-readonly-modal",
            metricKey: (0, (0, parcelRequire("lzG9C")).LOAD_START_MARK_KEY),
            packageName: packageName
        }, children);
});
parcelRegister("gjEtj", function(module, exports) {
    $parcel$export(module.exports, "ModalBoundary", ()=>$c322f875acea1654$export$c3f500e812fb1bb3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $iqr2y;
    var $heNNl;
    var $lfTZh;
    const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
        const ErrorState = (0, $5uXOq.useCallback)((args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                id: id,
                error: args.error
            }), [
            id
        ]);
        const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: metricKey
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: id,
            packageName: packageName,
            render: ErrorState,
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: id,
            fallback: fallback
        }, children));
    };
});
parcelRegister("lzG9C", function(module, exports) {
    $parcel$export(module.exports, "LOAD_START_MARK_KEY", ()=>$02ae2fc96a3ed3bf$export$37312a67c3e314c6);
    $parcel$export(module.exports, "LOAD_END_MARK_KEY", ()=>$02ae2fc96a3ed3bf$export$45d73db12b3f4402);
    $parcel$export(module.exports, "DIAGRAM_RENDERING_START_MARK_KEY", ()=>$02ae2fc96a3ed3bf$export$b251f321d9285754);
    $parcel$export(module.exports, "READY_MARK_KEY", ()=>$02ae2fc96a3ed3bf$export$9ec2b1585f998431);
    $parcel$export(module.exports, "ERROR_LOGGER_PATTERN", ()=>$02ae2fc96a3ed3bf$export$63291eb9eb8d2af2);
    $parcel$export(module.exports, "APP_NAME", ()=>$02ae2fc96a3ed3bf$export$5b6c28c7dca07ad7);
    $parcel$export(module.exports, "transitionType", ()=>$02ae2fc96a3ed3bf$export$331d6399b2e33350);
    $parcel$export(module.exports, "WORKFLOW_EXPERIENCE_IDENTIFIER", ()=>$02ae2fc96a3ed3bf$export$4c39956c777a6352);
    $parcel$export(module.exports, "EXPERIENCE_OPENED_START_EVENT", ()=>$02ae2fc96a3ed3bf$export$ded295b2866c666f);
    $parcel$export(module.exports, "EXPERIENCE_OPENED_SUCCESS_EVENT", ()=>$02ae2fc96a3ed3bf$export$375ec45005c7d160);
    const $02ae2fc96a3ed3bf$export$37312a67c3e314c6 = 'WORKFLOW_READONLY_MODAL_LOAD_START_MARK_KEY';
    const $02ae2fc96a3ed3bf$export$45d73db12b3f4402 = 'WORKFLOW_READONLY_MODAL_LOAD_END_MARK_KEY';
    const $02ae2fc96a3ed3bf$export$b251f321d9285754 = 'DIAGRAM_RENDERING_START_MARK_KEY';
    const $02ae2fc96a3ed3bf$export$9ec2b1585f998431 = 'WORKFLOW_READONLY_MODAL_READY_MARK_KEY';
    const $02ae2fc96a3ed3bf$export$63291eb9eb8d2af2 = '#workflow-readonly-modal#';
    const $02ae2fc96a3ed3bf$export$5b6c28c7dca07ad7 = 'jira.fe.spa.transition.workflow-readonly-modal';
    const $02ae2fc96a3ed3bf$export$e117396b0784c7cc = 'START';
    const $02ae2fc96a3ed3bf$export$331d6399b2e33350 = {
        INITIAL: 'INITIAL',
        GLOBAL: 'GLOBAL',
        DIRECTED: 'DIRECTED'
    };
    const $02ae2fc96a3ed3bf$export$54227ee7dff570d1 = {
        CHANGE_ASSIGNEE: 'system:change-assignee',
        UPDATE_FIELD: 'system:update-field'
    };
    const $02ae2fc96a3ed3bf$export$4c39956c777a6352 = 'workflowBentoModal';
    const $02ae2fc96a3ed3bf$export$ded295b2866c666f = 'openedStart';
    const $02ae2fc96a3ed3bf$export$375ec45005c7d160 = 'openedSuccess';
});
parcelRegister("awynQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("8Ni3O")
    ]).then(()=>parcelRequire('fpGoV'));
});
parcelRegister("lUJY8", function(module, exports) {
    $parcel$export(module.exports, "START_NODE_ID", ()=>$9b2ad0bd1b0ec248$export$e117396b0784c7cc);
    $parcel$export(module.exports, "transitionType", ()=>$9b2ad0bd1b0ec248$export$331d6399b2e33350);
    $parcel$export(module.exports, "SCOPE_GLOBAL", ()=>$9b2ad0bd1b0ec248$export$9bb188cec3fcc43d);
    $parcel$export(module.exports, "SCOPE_PROJECT", ()=>$9b2ad0bd1b0ec248$export$54c3a1cc8eb1bc43);
    $parcel$export(module.exports, "ALL_OPERATION", ()=>$9b2ad0bd1b0ec248$export$d3dc8e33b7258fc5);
    $parcel$export(module.exports, "STATUS_CATEGORY_WEIGHTS", ()=>$9b2ad0bd1b0ec248$export$8fc40e3c53b7f30e);
    $parcel$export(module.exports, "ANY_OPERATION", ()=>$9b2ad0bd1b0ec248$export$804f62993e553350);
    $parcel$export(module.exports, "errorSeverity", ()=>$9b2ad0bd1b0ec248$export$927c560a42a52ce0);
    var $gULOk;
    const $9b2ad0bd1b0ec248$export$e117396b0784c7cc = 'START';
    const $9b2ad0bd1b0ec248$export$331d6399b2e33350 = {
        INITIAL: 'INITIAL',
        GLOBAL: 'GLOBAL',
        DIRECTED: 'DIRECTED'
    };
    const $9b2ad0bd1b0ec248$export$bb55b5bf71d8edff = {
        BOLT: 'bolt',
        ERROR: 'error',
        CHECK: 'check',
        CHECK_INACTIVE: 'check_inactive',
        CROSS: 'cross',
        CROSS_INACTIVE: 'cross_inactive'
    };
    const $9b2ad0bd1b0ec248$export$9bb188cec3fcc43d = 'GLOBAL';
    const $9b2ad0bd1b0ec248$export$54c3a1cc8eb1bc43 = 'PROJECT';
    const $9b2ad0bd1b0ec248$export$d3dc8e33b7258fc5 = 'ALL';
    const $9b2ad0bd1b0ec248$export$8fc40e3c53b7f30e = {
        [(0, (0, parcelRequire("gULOk")).TODO)]: 1,
        [(0, (0, parcelRequire("gULOk")).IN_PROGRESS)]: 2,
        [(0, (0, parcelRequire("gULOk")).DONE)]: 3,
        [(0, (0, parcelRequire("gULOk")).UNDEFINED)]: 4
    };
    const $9b2ad0bd1b0ec248$export$804f62993e553350 = 'ANY';
    const $9b2ad0bd1b0ec248$export$927c560a42a52ce0 = {
        WARNING: 'WARNING',
        ERROR: 'ERROR'
    };
});
parcelRegister("cVt3t", function(module, exports) {
    $parcel$export(module.exports, "transitionsProvider", ()=>$fce65771ffb3f382$export$2f81aa12f4ac86b3);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $4R6GH;
    var $koVbs;
    var $hvOzF = parcelRequire("hvOzF");
    var $8DSSe = parcelRequire("8DSSe");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $iimFA = parcelRequire("iimFA");
    var $8iV5n = parcelRequire("8iV5n");
    const $fce65771ffb3f382$export$2f81aa12f4ac86b3 = (ComposedComponent)=>function(props) {
            const { genericError: genericError, issueKey: issueKey, issueStatuses: issueStatuses, issue: issue } = props;
            const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
            const [loading, setLoading] = (0, $5uXOq.useState)(false);
            const [transitions, setTransitions] = (0, $5uXOq.useState)(null);
            const fetchTransitions = (0, $5uXOq.useCallback)(()=>{
                if (loading) return;
                setLoading(true);
                setTransitions(null);
                (0, $8DSSe.default)(`/rest/api/2/issue/${issueKey}/transitions?sortByOpsBarAndStatus=true`, {
                    method: 'GET'
                }).then((response)=>{
                    setLoading(false);
                    if (response.ok) return response.json();
                    throw new Error(`Response not ok. Statuscode: ${response.status}`);
                }).then((result)=>{
                    const transitionsFromServer = (0, $8iV5n.getFilteredOrderedTransitions)(result.transitions || [], issue.status);
                    setTransitions((0, $8iV5n.addOriginalTransitions)(issue, (0, $8iV5n.removeTransitionsToCurrentAndOriginalStatus)(issue, transitionsFromServer, issueStatuses), issueStatuses, formatMessage((0, $iimFA.default).originalTransitionStatusName)));
                }).catch((err)=>{
                    setLoading(false);
                    if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) (0, (0, parcelRequire("jcw0u")).default)({
                        error: err,
                        meta: {
                            id: (0, $hvOzF.toErrorID)(err, 'transitions-fetch-failed'),
                            packageName: (0, $TTKUQ.PACKAGE_NAME),
                            teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    else genericError({
                        message: err.message,
                        stackTrace: err.stack
                    });
                    setTransitions(null);
                });
            }, [
                issueKey,
                issue,
                issueStatuses,
                loading,
                genericError,
                formatMessage
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ComposedComponent, {
                ...props,
                transitions: transitions,
                loading: loading,
                fetchTransitions: fetchTransitions
            });
        };
});
parcelRegister("iimFA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff2f9fb06df0af49$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ff2f9fb06df0af49$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        cannotLoadTransitions: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.issue-status.issue-status-field.cannot-load-transitions",
            "defaultMessage": "We couldn't load the statuses and transitions"
        },
        changeStatus: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.issue-status.issue-status-field.change-status",
            "defaultMessage": "Change status"
        },
        originalTransitionStatusName: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.issue-status.issue-status-field.original-transition-status-name",
            "defaultMessage": "Transition to"
        }
    });
});
parcelRegister("8iV5n", function(module, exports) {
    $parcel$export(module.exports, "getFilteredOrderedTransitions", ()=>$f92cf9a03ceeed14$export$707115549202b9e4);
    $parcel$export(module.exports, "removeTransitionsToCurrentAndOriginalStatus", ()=>$f92cf9a03ceeed14$export$91fa646e6c6bbddf);
    $parcel$export(module.exports, "addOriginalTransitions", ()=>$f92cf9a03ceeed14$export$bfbef01cd993b505);
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $f92cf9a03ceeed14$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
    const $f92cf9a03ceeed14$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
    const $f92cf9a03ceeed14$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
    const $f92cf9a03ceeed14$var$filterLoopedTransitionsToSelf = (transitions, currentStatusId)=>transitions.filter((transition)=>!$f92cf9a03ceeed14$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$f92cf9a03ceeed14$var$isGlobalSelfTransition(transition, currentStatusId) && !$f92cf9a03ceeed14$var$isInitialSelfTransition(transition, currentStatusId));
    const $f92cf9a03ceeed14$export$707115549202b9e4 = (transitions = [], currentStatusId)=>{
        if (currentStatusId) return $f92cf9a03ceeed14$var$filterLoopedTransitionsToSelf(transitions.filter((transition)=>!!transition.to && !!transition.to.statusCategory) || [], currentStatusId);
        return transitions || [];
    };
    const $f92cf9a03ceeed14$export$91fa646e6c6bbddf = (issue, serverTransitions, issueStatusesById)=>{
        const isCurrentIssueStatusExisted = (0, $4nDwW.isDefined)(issue.status) && (0, $4nDwW.isDefined)(issueStatusesById[issue.status]);
        const isOriginalIssueStatusExisted = (0, $4nDwW.isDefined)(issue?.originals?.status) && (0, $4nDwW.isDefined)(issueStatusesById[issue?.originals?.status]);
        if (isOriginalIssueStatusExisted || isCurrentIssueStatusExisted) return serverTransitions.filter((transition)=>transition.to.id !== issue.status && transition.to.id !== issue?.originals?.status);
        return serverTransitions;
    };
    const $f92cf9a03ceeed14$export$bfbef01cd993b505 = (issue, serverTransitions, issueStatusesById, originalTransitionName)=>{
        const originalIssueStatusId = issue?.originals?.status;
        if ((0, $4nDwW.isDefined)(originalIssueStatusId) && (0, $4nDwW.isDefined)(issueStatusesById[originalIssueStatusId])) {
            const originalTransition = {
                id: (0, $TTKUQ.ORIGINAL_STATUS_TRANSITION).id,
                isConditional: false,
                isGlobal: true,
                isInitial: false,
                hasScreen: false,
                name: originalTransitionName,
                to: {
                    id: originalIssueStatusId,
                    name: issueStatusesById[originalIssueStatusId].name,
                    statusCategory: {
                        id: issueStatusesById[originalIssueStatusId].categoryId
                    }
                }
            };
            return serverTransitions.concat(originalTransition);
        }
        return serverTransitions;
    };
});
parcelRegister("3oJ9g", function(module, exports) {
    $parcel$export(module.exports, "issueStatus", ()=>$2796a28a0ef3d0d7$export$428254b960a31b64, (v)=>$2796a28a0ef3d0d7$export$428254b960a31b64 = v);
    var $2796a28a0ef3d0d7$export$428254b960a31b64;
    $2796a28a0ef3d0d7$export$428254b960a31b64 = `LOCrTW_issueStatus`;
});
parcelRegister("2KP1L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$970a673095fbad10$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6bFiI = parcelRequire("6bFiI");
    var $6cBuI = parcelRequire("6cBuI");
    var $e8LNI = parcelRequire("e8LNI");
    var $970a673095fbad10$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6cBuI.default), (0, $6bFiI.default))((0, $e8LNI.default));
});
parcelRegister("6bFiI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4a59a8b37e299ed$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $e4a59a8b37e299ed$var$dispatchMethods = (dispatch)=>({
            onChange: (issue, labels)=>{
                const labelsValue = labels.map((label)=>label.value);
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    labels: labelsValue
                }));
            }
        });
    var $e4a59a8b37e299ed$export$2e2bcd8739ae039 = $e4a59a8b37e299ed$var$dispatchMethods;
});
parcelRegister("6cBuI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f6aee465f52f7b1$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    const $3f6aee465f52f7b1$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        plan: (0, $bHTqr.getPlan)
    });
    var $3f6aee465f52f7b1$export$2e2bcd8739ae039 = $3f6aee465f52f7b1$var$querySelector;
});
parcelRegister("e8LNI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5e60e52b146c80a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ixSW4 = parcelRequire("ixSW4");
    var $ahAj9 = parcelRequire("ahAj9");
    var $b4Mjg = parcelRequire("b4Mjg");
    const $d5e60e52b146c80a$export$a36612af82a12ac0 = (props)=>{
        const getValues = (issue, attribute)=>{
            if (!issue[attribute] || !Array.isArray(issue[attribute])) return [];
            return issue[attribute].map((label)=>({
                    label: label,
                    value: label
                }));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ahAj9.default), {
            ...props,
            getValues: getValues
        });
    };
    var $d5e60e52b146c80a$export$2e2bcd8739ae039 = (0, $b4Mjg.default)((0, $ixSW4.withSlots)({
        MultiSelectCell: (0, $ixSW4.slots).FieldMultiSelectCell
    })($d5e60e52b146c80a$export$a36612af82a12ac0));
});
parcelRegister("ahAj9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f0defc861013d3d2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $i2qlb = parcelRequire("i2qlb");
    var $8zOmE;
    var $2NMNM;
    var $d3xBA = parcelRequire("d3xBA");
    const $f0defc861013d3d2$var$LabelsComponent = ({ attribute: attribute, fetchOptions: fetchOptions, isReadOnly: isReadOnly, issue: issue, onChange: onChange, MultiSelectCell: MultiSelectCell, getValues: getValues, menuIsOpen: menuIsOpen })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const customNoOptionsMessage = (inputValue)=>{
            if (inputValue.includes(' ')) return formatMessage((0, $d3xBA.default).invalidInputWithSpace);
            if (inputValue.trim().length > 255) return formatMessage((0, $d3xBA.default).invalidInputWithMaxLength);
        };
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiSelectCell, {
            menuIsOpen: menuIsOpen,
            attribute: attribute,
            messages: {
                placeholder: formatMessage((0, $d3xBA.default).chooseLabel),
                noLabels: formatMessage((0, $d3xBA.default).noLabels),
                noLabelsLeft: formatMessage((0, $d3xBA.default).noLabelsLeft),
                noMatch: formatMessage((0, $d3xBA.default).noMatch)
            },
            getValues: getValues,
            fetchOptions: fetchOptions,
            isReadOnly: isReadOnly,
            issue: issue,
            onChange: onChange,
            isCreatable: true,
            customNoOptionsMessage: customNoOptionsMessage,
            onCreateOption: ()=>{
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_LABEL.split(' ');
                const analyticsEvent = createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_LABEL);
            },
            formatCreateLabel: (label)=>`${label} (${formatMessage((0, $d3xBA.default).newLabel)})`,
            convertCreatedLabelToOption: (inputValue)=>({
                    label: inputValue,
                    value: inputValue
                }),
            validateInputForCreation: (inputValue)=>{
                if (inputValue.includes(' ') || inputValue.trim().length > 255 || inputValue.trim().length === 0) return false;
                return true;
            }
        });
    };
    var $f0defc861013d3d2$export$2e2bcd8739ae039 = $f0defc861013d3d2$var$LabelsComponent;
});
parcelRegister("d3xBA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$617e3627fe0ee1a3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $617e3627fe0ee1a3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chooseLabel: {
            "id": "portfolio-3-portfolio.common.label.choose-label",
            "defaultMessage": "Choose a label"
        },
        noLabels: {
            "id": "portfolio-3-portfolio.common.label.no-labels",
            "defaultMessage": "There are no labels in this project"
        },
        noLabelsLeft: {
            "id": "portfolio-3-portfolio.common.label.no-labels-left",
            "defaultMessage": "No available labels left"
        },
        noMatch: {
            "id": "portfolio-3-portfolio.common.label.no-match",
            "defaultMessage": "No results match your search"
        },
        invalidInputWithSpace: {
            "id": "portfolio-3-portfolio.common.label.invalid-input-with-space",
            "defaultMessage": "Invalid input, labels can't contain spaces"
        },
        invalidInputWithMaxLength: {
            "id": "portfolio-3-portfolio.common.label.invalid-input-with-max-length",
            "defaultMessage": "Invalid input, labels can't have more than 255 characters"
        },
        newLabel: {
            "id": "portfolio-3-portfolio.common.label.new-label",
            "defaultMessage": "New label"
        }
    });
});
parcelRegister("b4Mjg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8f6b27e470e8e5b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8DSSe = parcelRequire("8DSSe");
    var $e8f6b27e470e8e5b$export$2e2bcd8739ae039 = (ComposedComponent)=>class extends (0, $5uXOq.Component) {
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(ComposedComponent, {
                    ...this.props,
                    fetchOptions: this.getLabelOptions
                });
            }
            constructor(...args){
                super(...args);
                this.getLabelOptions = (query)=>(0, $8DSSe.default)('/rest/jpo/1.0/scenarios/labels', {
                        method: 'POST',
                        body: {
                            limit: 50,
                            planId: this.props.plan.id,
                            scenarioId: this.props.plan.currentScenarioId,
                            query: query || null
                        }
                    }).then((response)=>response.json()).then((data)=>data?.items?.map((item)=>({
                                value: item,
                                label: item
                            })) || []);
            }
        };
});
parcelRegister("76nx6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f9e255ac84d335b$export$2e2bcd8739ae039);
    var $bC2fB;
    var $caTjv = parcelRequire("caTjv");
    var $hTELX = parcelRequire("hTELX");
    var $6qllo = parcelRequire("6qllo");
    var $0f9e255ac84d335b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hTELX.default), (0, $caTjv.default))((0, $6qllo.default));
});
parcelRegister("caTjv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d01aae5eee4ed25b$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $d01aae5eee4ed25b$var$dispatchMethods = (dispatch)=>({
            onChange: (issue, parentId)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    parent: parentId
                }));
            }
        });
    var $d01aae5eee4ed25b$export$2e2bcd8739ae039 = $d01aae5eee4ed25b$var$dispatchMethods;
});
parcelRegister("hTELX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fee839030c52da8f$export$2e2bcd8739ae039);
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $3YtPS = parcelRequire("3YtPS");
    var $fee839030c52da8f$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        issues: (0, $gFhwb.getIssues),
        issueTypesById: (0, $kllqP.getIssueTypesById),
        projectsById: (0, $jpXKt.getProjectsById)
    });
});
parcelRegister("6qllo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f366dab0c86bb85$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $koVbs;
    var $hwwla;
    var $iqIcG;
    var $kqF3Q = parcelRequire("kqF3Q");
    var $fHJiO = parcelRequire("fHJiO");
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $3FQWJ = parcelRequire("3FQWJ");
    var $5hwjI = parcelRequire("5hwjI");
    const $0f366dab0c86bb85$export$409850a8a9c79192 = ({ onChange: onChange, issue: issue })=>(selection)=>{
            if (selection && typeof selection.value === 'string') onChange(issue, selection.value);
            else onChange(issue, null);
        };
    const $0f366dab0c86bb85$export$d5a4cc78f8c5a2cd = ({ issue: issue, issues: issues, issueTypesById: issueTypesById, projectsById: projectsById, onChange: onChange, isScrolling: isScrolling = false, isReadOnly: isReadOnly = false, FieldSelect: FieldSelect })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleSelection = $0f366dab0c86bb85$export$409850a8a9c79192({
            onChange: onChange,
            issue: issue
        });
        const getParentSelectOptions = ()=>(0, $fHJiO.getPossibleParentIssues)({
                issue: issue,
                issues: issues,
                issueTypesById: issueTypesById,
                projectsById: projectsById
            }).map((issue)=>(0, $kqF3Q.getIssueOption)(issue, issueTypesById, projectsById));
        const select = ()=>{
            const { parent: parent, summary: summary } = issue;
            const items = getParentSelectOptions();
            const valueItem = items.find((option)=>option.value === parent);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
                attribute: "parent",
                issue: issue,
                isScrolling: isScrolling
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: valueItem ? valueItem.label : null
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(FieldSelect, {
                "aria-label": formatMessage({
                    ...(0, $5hwjI.default).parentCellLabel
                }, {
                    issue: summary
                }),
                attribute: "parent",
                formatOptionLabel: (0, (0, parcelRequire("iqIcG")).selectIssueOption),
                isClearable: (0, $4nDwW.isDefined)(parent) && !(0, $fHJiO.isIssueSubTaskType)({
                    issue: issue,
                    issueTypesById: issueTypesById
                }),
                isDisabled: isReadOnly,
                issueId: issue.id,
                onChange: handleSelection,
                options: items,
                placeholder: formatMessage((0, $5hwjI.default).placeholder),
                value: valueItem || null
            })));
        };
        const wireframe = ()=>{
            const parent = issue.parent;
            const items = getParentSelectOptions();
            const selectedItem = items.find((item)=>item.value === parent);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwwla")).default), {
                content: selectedItem && (0, (0, parcelRequire("iqIcG")).selectIssueOption)(selectedItem)
            });
        };
        let cell = null;
        cell = isScrolling ? wireframe() : select();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, cell);
    };
    var $0f366dab0c86bb85$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        FieldSelect: (0, $ixSW4.slots).FieldSelect
    })($0f366dab0c86bb85$export$d5a4cc78f8c5a2cd);
});
parcelRegister("5hwjI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95e410bd92ea0e2a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $95e410bd92ea0e2a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.parent.placeholder",
            "defaultMessage": "Choose a parent"
        },
        parentCellLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.parent.parent-cell-label",
            "defaultMessage": "Choose a parent for issue {issue}"
        }
    });
});
parcelRegister("7yJez", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$744d838456902e92$export$2e2bcd8739ae039);
    var $bC2fB;
    var $d5j8l = parcelRequire("d5j8l");
    var $7QNrP = parcelRequire("7QNrP");
    var $PwG0b = parcelRequire("PwG0b");
    var $744d838456902e92$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7QNrP.default), (0, $d5j8l.default))((0, $PwG0b.default));
});
parcelRegister("d5j8l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d92cb901ef15e3ff$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $d92cb901ef15e3ff$var$dispatchMethods = (dispatch)=>({
            onChange: (issue, priorityId)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    priority: priorityId
                }));
            }
        });
    var $d92cb901ef15e3ff$export$2e2bcd8739ae039 = $d92cb901ef15e3ff$var$dispatchMethods;
});
parcelRegister("7QNrP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$467b6730f3f893c9$export$2e2bcd8739ae039);
    var $io4Ja = parcelRequire("io4Ja");
    var $jpXKt = parcelRequire("jpXKt");
    var $3YtPS = parcelRequire("3YtPS");
    var $467b6730f3f893c9$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        prioritiesByIdMap: (0, $io4Ja.getIssuePriorities),
        priorityIdsForProject: (state, ownProps)=>(0, $jpXKt.getIssuePriorityIdsByProjectId)(state)[ownProps.issue.project] || [],
        defaultIssuePriority: (state, ownProps)=>(0, $jpXKt.getDefaultIssuePriorityByProjectId)(state)[ownProps.issue.project]
    });
});
parcelRegister("PwG0b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4bb17cb80522c87$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $4Rr1a;
    var $3bDjY;
    var $koVbs;
    var $hwwla;
    var $iqIcG;
    var $eJyeb = parcelRequire("eJyeb");
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $3FQWJ = parcelRequire("3FQWJ");
    var $fcSD7 = parcelRequire("fcSD7");
    var $eDuN0 = parcelRequire("eDuN0");
    const $e4bb17cb80522c87$var$notInPlan = {
        id: '',
        iconUrl: '',
        name: '',
        sequence: 0
    };
    const $e4bb17cb80522c87$var$formatOptionLabel = (intl)=>({ icon: icon, label: label, notInPlan: notInPlan })=>{
            if (notInPlan) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: intl.formatMessage((0, $fcSD7.default).tooltipText)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: `${$eDuN0["not-in-plan"]} ${$eDuN0.truncated}`
            }, label));
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $eDuN0["select-option"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $eDuN0["icon-wrapper"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $eDuN0.icon,
                style: {
                    backgroundSize: 'contain',
                    backgroundImage: `url(${icon})`
                }
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $eDuN0.label
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $eDuN0.truncated
            }, label))));
        };
    const $e4bb17cb80522c87$var$initialSelectFilter = (0, (0, parcelRequire("iqIcG")).selectUtils).createFilter(null);
    const $e4bb17cb80522c87$export$b526cf238a0a0ab3 = ({ isScrolling: isScrolling = false, issue: issue, priorityIdsForProject: priorityIdsForProject, defaultIssuePriority: defaultIssuePriority, prioritiesByIdMap: prioritiesByIdMap, onChange: onChange, isReadOnly: isReadOnly = false, FieldPrioritySelect: FieldPrioritySelect })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { formatMessage: formatMessage } = intl;
        const getSelectedIssuePriority = ()=>{
            const { priority: priority, project: project } = issue;
            if (!priority) {
                if (!project) return $e4bb17cb80522c87$var$notInPlan;
                if (!defaultIssuePriority) return null;
                if (!(0, $4nDwW.isDefined)(prioritiesByIdMap) || (0, parcelRequire("3nPAF")).default(prioritiesByIdMap)) return null;
                return prioritiesByIdMap[defaultIssuePriority];
            }
            if (!(0, $4nDwW.isDefined)(priorityIdsForProject)) return null;
            if (!priorityIdsForProject.includes(priority)) return null;
            if (!(0, $4nDwW.isDefined)(prioritiesByIdMap) || (0, parcelRequire("3nPAF")).default(prioritiesByIdMap)) return null;
            return prioritiesByIdMap[priority];
        };
        const handleSelectChange = (selectedOption)=>{
            if (!(0, $4nDwW.isDefined)(selectedOption)) return onChange(issue, null);
            if (typeof selectedOption.value === 'string') return onChange(issue, selectedOption.value);
        };
        const priorityToOption = (issuePriority)=>{
            const { name: name, iconUrl: iconUrl, id: id } = issuePriority;
            return {
                value: id,
                label: name,
                icon: (0, $eJyeb.proxyContextSafeUrl)(iconUrl)
            };
        };
        const filterOption = (option, query)=>{
            if (!$e4bb17cb80522c87$var$initialSelectFilter(option, query)) return false;
            const selectedIssuePriority = getSelectedIssuePriority();
            if (selectedIssuePriority === $e4bb17cb80522c87$var$notInPlan) return false;
            if ((0, $4nDwW.isDefined)(selectedIssuePriority) && option.value === selectedIssuePriority.id) return false;
            return true;
        };
        const getSelectedOption = ()=>{
            const selectedIssuePriority = getSelectedIssuePriority();
            if (!(0, $4nDwW.isDefined)(selectedIssuePriority)) return null;
            if (selectedIssuePriority === $e4bb17cb80522c87$var$notInPlan) return {
                label: formatMessage((0, $fcSD7.default).notInPlan),
                notInPlan: true
            };
            return priorityToOption(selectedIssuePriority);
        };
        const select = ()=>{
            const { summary: summary } = issue;
            const priorities = priorityIdsForProject.map((id)=>prioritiesByIdMap[id]);
            const items = (0, parcelRequire("4Rr1a")).default(priorityToOption, priorities);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
                attribute: "priority",
                issue: issue,
                isScrolling: isScrolling
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(FieldPrioritySelect, {
                "aria-label": formatMessage((0, $fcSD7.default).priorityCellLabel, {
                    issue: summary
                }),
                attribute: "priority",
                filterOption: filterOption,
                formatOptionLabel: $e4bb17cb80522c87$var$formatOptionLabel(intl),
                isDisabled: isReadOnly,
                issueId: issue.id,
                onChange: handleSelectChange,
                options: items,
                placeholder: formatMessage((0, $fcSD7.default).placeholder),
                value: getSelectedOption()
            }));
        };
        const wireframe = ()=>{
            const selectedOption = getSelectedOption();
            const content = selectedOption ? selectedOption.label : '';
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwwla")).default), {
                content: content
            });
        };
        const cell = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isScrolling ? wireframe() : select());
        return cell;
    };
    var $e4bb17cb80522c87$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        FieldPrioritySelect: (0, $ixSW4.slots).FieldPrioritySelect
    })($e4bb17cb80522c87$export$b526cf238a0a0ab3);
});
parcelRegister("fcSD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f93f28d735aa8fdf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f93f28d735aa8fdf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        priorityCellLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.priority.priority-cell-label",
            "defaultMessage": "Choose a priority for issue {issue}"
        },
        notInPlan: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.priority.not-in-plan",
            "defaultMessage": "Not in plan"
        },
        tooltipText: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.priority.tooltip-text",
            "defaultMessage": "This priority is no longer available"
        },
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.priority.placeholder",
            "defaultMessage": "Choose a priority"
        }
    });
});
parcelRegister("eDuN0", function(module, exports) {
    $parcel$export(module.exports, "icon", ()=>$aa7c975740d4719a$export$1ca1ec8b29a4ce27, (v)=>$aa7c975740d4719a$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "icon-wrapper", ()=>$aa7c975740d4719a$export$d5b71a90834fa638, (v)=>$aa7c975740d4719a$export$d5b71a90834fa638 = v);
    $parcel$export(module.exports, "label", ()=>$aa7c975740d4719a$export$1237798dc640739a, (v)=>$aa7c975740d4719a$export$1237798dc640739a = v);
    $parcel$export(module.exports, "not-in-plan", ()=>$aa7c975740d4719a$export$5687e044f2e8382a, (v)=>$aa7c975740d4719a$export$5687e044f2e8382a = v);
    $parcel$export(module.exports, "select-option", ()=>$aa7c975740d4719a$export$25439fa9d099d50b, (v)=>$aa7c975740d4719a$export$25439fa9d099d50b = v);
    $parcel$export(module.exports, "truncated", ()=>$aa7c975740d4719a$export$23ef198012fb7186, (v)=>$aa7c975740d4719a$export$23ef198012fb7186 = v);
    var $aa7c975740d4719a$export$1ca1ec8b29a4ce27;
    var $aa7c975740d4719a$export$d5b71a90834fa638;
    var $aa7c975740d4719a$export$1237798dc640739a;
    var $aa7c975740d4719a$export$5687e044f2e8382a;
    var $aa7c975740d4719a$export$25439fa9d099d50b;
    var $aa7c975740d4719a$export$23ef198012fb7186;
    $aa7c975740d4719a$export$1ca1ec8b29a4ce27 = `JN-0Kq_icon`;
    $aa7c975740d4719a$export$d5b71a90834fa638 = `JN-0Kq_icon-wrapper`;
    $aa7c975740d4719a$export$1237798dc640739a = `JN-0Kq_label`;
    $aa7c975740d4719a$export$5687e044f2e8382a = `JN-0Kq_not-in-plan`;
    $aa7c975740d4719a$export$25439fa9d099d50b = `JN-0Kq_select-option`;
    $aa7c975740d4719a$export$23ef198012fb7186 = `JN-0Kq_truncated`;
});
parcelRegister("dtNTU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bbd9f3c90347da09$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3ngQj = parcelRequire("3ngQj");
    var $9njTD = parcelRequire("9njTD");
    var $a2enW = parcelRequire("a2enW");
    var $bbd9f3c90347da09$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $9njTD.default), (0, $3ngQj.default))((0, $a2enW.default));
});
parcelRegister("3ngQj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcec896848f4a182$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $bcec896848f4a182$var$dispatchMethods = (dispatch)=>({
            onChange: (issue, fixVersions)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    fixVersions: fixVersions
                }));
            }
        });
    var $bcec896848f4a182$export$2e2bcd8739ae039 = $bcec896848f4a182$var$dispatchMethods;
});
parcelRegister("9njTD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94421993772d1634$export$2e2bcd8739ae039);
    var $lV634;
    var $j0d94;
    var $jw86H = parcelRequire("jw86H");
    var $jpXKt = parcelRequire("jpXKt");
    var $4sJY8 = parcelRequire("4sJY8");
    var $9FFuD = parcelRequire("9FFuD");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    function $94421993772d1634$export$7e57356575dea18e(versions) {
        return (0, parcelRequire("j0d94")).default((acc, version)=>{
            for (const projectId of version.projects)if ((0, parcelRequire("lV634")).default(acc[projectId])) acc[projectId] = [
                version
            ];
            else acc[projectId].push(version);
            return acc;
        }, {}, versions);
    }
    const $94421993772d1634$var$getReleaseRollUpValueForIssue = (state, props)=>(0, $4nDwW.isDefined)((0, $4sJY8.getRollupMap)(state)[props.issue.id]) ? (0, $4sJY8.getRollupMap)(state)[props.issue.id].release : null;
    const $94421993772d1634$var$collectVersionsByProjectId = (0, $3YtPS.createSelector)([
        (0, $9FFuD.getVersions)
    ], $94421993772d1634$export$7e57356575dea18e);
    const $94421993772d1634$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        crossProjectVersionsById: (0, $jw86H.getCrossProjectVersionsById),
        versionsById: (0, $9FFuD.getVersionsById),
        projectsById: (0, $jpXKt.getProjectsById),
        releaseRollUpForIssue: $94421993772d1634$var$getReleaseRollUpValueForIssue,
        versionsByProjectId: $94421993772d1634$var$collectVersionsByProjectId,
        sortVersionsByHighestRank: (0, $9FFuD.getSortByHighestRank),
        sortVersionsByLowestRank: (0, $9FFuD.getSortByLowestRank)
    });
    var $94421993772d1634$export$2e2bcd8739ae039 = $94421993772d1634$var$mapStateToProps;
});
parcelRegister("a2enW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c1ba17bfc43b38d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b1yMp;
    var $cTYeP;
    var $jVZZA;
    var $2JlG5;
    var $3nPAF;
    var $lV634;
    var $fkC9P;
    var $4Rr1a;
    var $7Zjd1;
    var $4kLGT;
    var $cgL5K;
    var $3bDjY;
    var $koVbs;
    var $hwwla;
    var $itpgN;
    var $l38L3 = parcelRequire("l38L3");
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fFMsx = parcelRequire("fFMsx");
    var $3FQWJ = parcelRequire("3FQWJ");
    var $bKx3H = parcelRequire("bKx3H");
    var $3UPlM = parcelRequire("3UPlM");
    const $4c1ba17bfc43b38d$export$6e53d26b0341455b = (issue, version)=>(0, parcelRequire("cTYeP")).default(issue.project, version.projects);
    const $4c1ba17bfc43b38d$export$8dcfdc6f758d6599 = ({ versionsById: versionsById, formatMessage: formatMessage })=>(id)=>{
            const version = versionsById[id];
            if ((0, parcelRequire("lV634")).default(version)) return formatMessage((0, $bKx3H.default).unknownVersion, {
                id: id
            });
            return version.name;
        };
    const $4c1ba17bfc43b38d$export$998fbd4086f40b5a = ({ versionsById: versionsById, formatMessage: formatMessage })=>(_, fixVersions)=>(0, parcelRequire("b1yMp")).default((0, parcelRequire("fkC9P")).default(', '), (0, parcelRequire("4Rr1a")).default($4c1ba17bfc43b38d$export$8dcfdc6f758d6599({
                versionsById: versionsById,
                formatMessage: formatMessage
            })))(fixVersions || []);
    const $4c1ba17bfc43b38d$export$4edff4fd0399ce6e = ({ onChange: onChange, issue: issue })=>(selection)=>{
            const selectionArray = Array.isArray(selection) ? selection.filter(({ value: value })=>typeof value === 'string') : [];
            onChange(issue, selectionArray.map(({ value: value })=>value));
        };
    const $4c1ba17bfc43b38d$export$8d15756cdedd050b = ({ issue: issue, isScrolling: isScrolling, crossProjectVersionsById: crossProjectVersionsById, versionsById: versionsById, showOptimizations: showOptimizations, versionsByProjectId: versionsByProjectId, sortVersionsByLowestRank: sortVersionsByLowestRank, sortVersionsByHighestRank: sortVersionsByHighestRank, onChange: onChange, isReadOnly: isReadOnly = false, releaseRollUpForIssue: releaseRollUpForIssue, CellSelectWithRollup: CellSelectWithRollup, projectsById: projectsById })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const versionsMapToOptions = (version)=>(0, $fFMsx.createVersionOption)(version, crossProjectVersionsById);
        const optimizedValueMapper = $4c1ba17bfc43b38d$export$998fbd4086f40b5a({
            versionsById: versionsById,
            formatMessage: formatMessage
        });
        const getRelevantReleases = ()=>(0, parcelRequire("jVZZA")).default((version)=>$4c1ba17bfc43b38d$export$6e53d26b0341455b(issue, version), (0, parcelRequire("4kLGT")).default(versionsById));
        const getAssignedReleases = ()=>{
            let fixVersions = Array.isArray(issue.fixVersions) ? [
                ...issue.fixVersions
            ] : undefined;
            if (showOptimizations) fixVersions = (0, $l38L3.getOptimizedValue)(issue, 'fixVersions');
            if (!fixVersions) return [];
            const knownVersions = (0, parcelRequire("jVZZA")).default((versionId)=>(0, parcelRequire("2JlG5")).default(versionId, versionsById), fixVersions);
            return (0, parcelRequire("4Rr1a")).default((versionId)=>versionsById[versionId], knownVersions);
        };
        const getUnreleasedOptionsGroup = (projectIds)=>{
            const unreleasedOptionGroups = (0, parcelRequire("4Rr1a")).default((projectId)=>{
                const versions = (0, parcelRequire("jVZZA")).default((version)=>version.releaseStatusId !== (0, $TTKUQ.RELEASE_STATUSES).RELEASED, sortVersionsByLowestRank(versionsByProjectId[projectId]));
                return {
                    label: formatMessage((0, $bKx3H.default).unreleased),
                    options: (0, parcelRequire("4Rr1a")).default(versionsMapToOptions, versions)
                };
            }, projectIds);
            return unreleasedOptionGroups;
        };
        const getReleasedOptionsGroup = (projectIds)=>{
            const releasedOptionGroups = (0, parcelRequire("4Rr1a")).default((projectId)=>{
                const versions = (0, parcelRequire("jVZZA")).default((version)=>version.releaseStatusId === (0, $TTKUQ.RELEASE_STATUSES).RELEASED, sortVersionsByHighestRank(versionsByProjectId[projectId]));
                return {
                    label: formatMessage((0, $bKx3H.default).released),
                    options: (0, parcelRequire("4Rr1a")).default(versionsMapToOptions, versions)
                };
            }, projectIds);
            return releasedOptionGroups;
        };
        const getOptions = ()=>{
            const versions = getRelevantReleases();
            const projectIds = Array.from(versions.reduce((acc, version)=>{
                version.projects.forEach(acc.add, acc);
                return acc;
            }, new Set()));
            return getUnreleasedOptionsGroup(projectIds).concat(getReleasedOptionsGroup(projectIds));
        };
        const filterOptions = (option, query)=>{
            const { label: versionName, data: data } = option;
            const { crossProjectVersionName: crossProjectVersionName = '' } = data;
            return versionName.toLowerCase().includes(query.toLowerCase()) || crossProjectVersionName.toLowerCase().includes(query.toLowerCase());
        };
        const getSelections = ()=>(0, parcelRequire("4Rr1a")).default(versionsMapToOptions, getAssignedReleases());
        const handleOnChange = $4c1ba17bfc43b38d$export$4edff4fd0399ce6e({
            onChange: onChange,
            issue: issue
        });
        const wireframe = ()=>{
            const selections = getSelections();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwwla")).default), {
                content: !(0, parcelRequire("3nPAF")).default(selections) ? selections.map((s)=>s.label) || '' : '',
                isReadOnly: showOptimizations
            });
        };
        const select = ()=>{
            const options = getOptions();
            const selections = getSelections();
            const rollupLabels = (0, parcelRequire("7Zjd1")).default((a, b)=>a.localeCompare(b), (releaseRollUpForIssue || []).map((releaseId)=>(0, $4nDwW.isDefined)(versionsById[releaseId]) ? versionsById[releaseId].name : ''));
            if (projectsById[issue.project]?.isReleasesEnabled === false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage((0, $bKx3H.default).notAvailableTooltip, {
                    projectName: projectsById[issue.project].name,
                    strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                            as: "strong"
                        }, chunks)
                })
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $3UPlM.disabledContainer
            }, formatMessage((0, $bKx3H.default).disabledReleaseField)));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
                attribute: "fixVersions",
                isScrolling: isScrolling,
                issue: issue,
                showOptimizations: showOptimizations,
                valueMapper: optimizedValueMapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $3UPlM.release
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(CellSelectWithRollup, {
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.release-cell",
                "aria-label": formatMessage((0, $bKx3H.default).releaseSelectorLabel, {
                    issue: issue.summary
                }),
                attribute: "release",
                filterOption: filterOptions,
                formatOptionLabel: (0, $fFMsx.formatReleaseOptionLabel),
                isClearable: true,
                isDisabled: isReadOnly,
                issueId: issue.id,
                hideSelectedOptions: false,
                closeMenuOnSelect: false,
                isMulti: true,
                components: {
                    Option: (0, (0, parcelRequire("itpgN")).CheckboxOption)
                },
                onChange: (option)=>handleOnChange(option),
                options: options,
                placeholder: formatMessage((0, $bKx3H.default).placeholder),
                rolledUpValues: rollupLabels,
                value: selections
            })));
        };
        return isScrolling ? wireframe() : select();
    };
    var $4c1ba17bfc43b38d$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        CellSelectWithRollup: (0, $ixSW4.slots).CellSelectWithRollup
    })($4c1ba17bfc43b38d$export$8d15756cdedd050b);
});
parcelRegister("4kLGT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$327e0610285e4ed2$export$2e2bcd8739ae039);
    var $ccUYa;
    var $327e0610285e4ed2$var$valuesIn = (0, (0, parcelRequire("ccUYa")).default)(function valuesIn(obj) {
        var prop;
        var vs = [];
        for(prop in obj)vs[vs.length] = obj[prop];
        return vs;
    });
    var $327e0610285e4ed2$export$2e2bcd8739ae039 = $327e0610285e4ed2$var$valuesIn;
});
parcelRegister("fFMsx", function(module, exports) {
    $parcel$export(module.exports, "createVersionOption", ()=>$94d715660fdc2505$export$94603e60741921d6);
    $parcel$export(module.exports, "formatReleaseOptionLabel", ()=>$94d715660fdc2505$export$6a85bd1a027302d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $4nDwW = parcelRequire("4nDwW");
    var $d9zcj = parcelRequire("d9zcj");
    const $94d715660fdc2505$export$94603e60741921d6 = ({ id: id, name: name, crossProjectVersion: crossProjectVersion }, crossProjectVersionsById)=>{
        if ((0, $4nDwW.isDefined)(crossProjectVersion) && crossProjectVersionsById[crossProjectVersion]) return {
            value: id,
            label: name,
            crossProjectVersionName: crossProjectVersionsById[crossProjectVersion].name
        };
        return {
            value: id,
            label: name
        };
    };
    const $94d715660fdc2505$export$6a85bd1a027302d9 = (option, meta)=>{
        const { label: versionName, crossProjectVersionName: crossProjectVersionName } = option;
        const { context: context } = meta;
        if (context === 'menu') return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d9zcj.crossProjectReleaseOption
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d9zcj.crossProjectReleaseName,
            title: versionName
        }, versionName), (0, $4nDwW.isDefined)(crossProjectVersionName) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d9zcj.crossProjectReleaseLozenge,
            title: crossProjectVersionName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, crossProjectVersionName))));
        return versionName;
    };
});
parcelRegister("d9zcj", function(module, exports) {
    $parcel$export(module.exports, "crossProjectReleaseLozenge", ()=>$99376b21f08db749$export$be8ecdd1dde7847a, (v)=>$99376b21f08db749$export$be8ecdd1dde7847a = v);
    $parcel$export(module.exports, "crossProjectReleaseName", ()=>$99376b21f08db749$export$ad543e317dba39b7, (v)=>$99376b21f08db749$export$ad543e317dba39b7 = v);
    $parcel$export(module.exports, "crossProjectReleaseOption", ()=>$99376b21f08db749$export$dd5faf32de3b1cad, (v)=>$99376b21f08db749$export$dd5faf32de3b1cad = v);
    var $99376b21f08db749$export$be8ecdd1dde7847a;
    var $99376b21f08db749$export$ad543e317dba39b7;
    var $99376b21f08db749$export$dd5faf32de3b1cad;
    var $99376b21f08db749$export$69379c888580b1e2;
    $99376b21f08db749$export$be8ecdd1dde7847a = `hC7mga_crossProjectReleaseLozenge`;
    $99376b21f08db749$export$ad543e317dba39b7 = `hC7mga_crossProjectReleaseName`;
    $99376b21f08db749$export$dd5faf32de3b1cad = `hC7mga_crossProjectReleaseOption`;
    $99376b21f08db749$export$69379c888580b1e2 = `hC7mga_moreReleases`;
});
parcelRegister("bKx3H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e23d3e57cba615bc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e23d3e57cba615bc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.placeholder",
            "defaultMessage": "Choose a release"
        },
        releaseSelectorLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.release-selector-label",
            "defaultMessage": "Choose a release for issue {issue}"
        },
        unknownVersion: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.unknown-version",
            "defaultMessage": "Unknown version {id}"
        },
        released: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.released",
            "defaultMessage": "Released"
        },
        unreleased: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.unreleased",
            "defaultMessage": "Unreleased"
        },
        notAvailable: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.not-available",
            "defaultMessage": "Not enabled"
        },
        notAvailableTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.not-available-tooltip",
            "defaultMessage": "To enable releases for <strong>{projectName}</strong>, go to Project settings > Features"
        },
        disabledReleaseField: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.disabled-release-field",
            "defaultMessage": "N/A"
        }
    });
});
parcelRegister("3UPlM", function(module, exports) {
    $parcel$export(module.exports, "disabledContainer", ()=>$2d9e6f283a207060$export$9405ab27dc5f5d53, (v)=>$2d9e6f283a207060$export$9405ab27dc5f5d53 = v);
    $parcel$export(module.exports, "release", ()=>$2d9e6f283a207060$export$23d3fad09dc44362, (v)=>$2d9e6f283a207060$export$23d3fad09dc44362 = v);
    var $2d9e6f283a207060$export$34e0f9847d4c02dd;
    var $2d9e6f283a207060$export$be8ecdd1dde7847a;
    var $2d9e6f283a207060$export$ad543e317dba39b7;
    var $2d9e6f283a207060$export$dd5faf32de3b1cad;
    var $2d9e6f283a207060$export$9405ab27dc5f5d53;
    var $2d9e6f283a207060$export$c0d9370d587dcb77;
    var $2d9e6f283a207060$export$23d3fad09dc44362;
    var $2d9e6f283a207060$export$3f3ea63501e8c591;
    $2d9e6f283a207060$export$34e0f9847d4c02dd = `CDefyW_container`;
    $2d9e6f283a207060$export$be8ecdd1dde7847a = `CDefyW_crossProjectReleaseLozenge`;
    $2d9e6f283a207060$export$ad543e317dba39b7 = `CDefyW_crossProjectReleaseName`;
    $2d9e6f283a207060$export$dd5faf32de3b1cad = `CDefyW_crossProjectReleaseOption`;
    $2d9e6f283a207060$export$9405ab27dc5f5d53 = `CDefyW_disabledContainer`;
    $2d9e6f283a207060$export$c0d9370d587dcb77 = `CDefyW_infoIcon`;
    $2d9e6f283a207060$export$23d3fad09dc44362 = `CDefyW_release`;
    $2d9e6f283a207060$export$3f3ea63501e8c591 = `CDefyW_releaseDisabled`;
});
parcelRegister("106hf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61aeaec1e47ac14a$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5of1u = parcelRequire("5of1u");
    var $bmVTi = parcelRequire("bmVTi");
    var $61aeaec1e47ac14a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $5of1u.default), {})((0, $bmVTi.default));
});
parcelRegister("5of1u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c5ea9839acbb520$export$2e2bcd8739ae039);
    var $bzDof = parcelRequire("bzDof");
    const $5c5ea9839acbb520$var$querySelector = (state)=>({
            issueReporterMap: (0, $bzDof.getIssueReporterMap)(state)
        });
    var $5c5ea9839acbb520$export$2e2bcd8739ae039 = $5c5ea9839acbb520$var$querySelector;
});
parcelRegister("bmVTi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3bb4a174b878b59b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    const $3bb4a174b878b59b$export$d0966422cba54096 = ({ issue: issue, issueReporterMap: issueReporterMap, FieldUserAvatarCell: FieldUserAvatarCell })=>{
        if ((0, $4nDwW.isDefined)(issue.reporter) && (0, $4nDwW.isDefined)(issueReporterMap[issue.id])) {
            const reporter = issueReporterMap[issue.id];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(FieldUserAvatarCell, {
                title: reporter.jiraUser.title,
                avatarUrl: reporter.jiraUser.avatarUrl
            });
        }
        return null;
    };
    var $3bb4a174b878b59b$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        FieldUserAvatarCell: (0, $ixSW4.slots).FieldUserAvatarCell
    })($3bb4a174b878b59b$export$d0966422cba54096);
});
parcelRegister("bxUAL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f686daea90a59c42$export$2e2bcd8739ae039);
    var $bC2fB;
    var $k6LsP = parcelRequire("k6LsP");
    var $dv8ev = parcelRequire("dv8ev");
    var $apDrx = parcelRequire("apDrx");
    var $f686daea90a59c42$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $dv8ev.mapStateToProps), (0, $k6LsP.mapDispatchToProps))((0, $apDrx.default));
});
parcelRegister("k6LsP", function(module, exports) {
    $parcel$export(module.exports, "mapDispatchToProps", ()=>$2ffc44eeccd89ca0$export$9e6a17cf56877796);
    var $bkasS = parcelRequire("bkasS");
    var $bIaKQ = parcelRequire("bIaKQ");
    const $2ffc44eeccd89ca0$export$9e6a17cf56877796 = (dispatch)=>({
            onChangeOld: (issue, sprint)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    sprint: sprint
                }));
            },
            onChange: (issue, value, sprint)=>{
                dispatch((0, $bIaKQ.updateIssueSprint)({
                    id: issue.id,
                    value: value,
                    sprint: sprint
                }));
            }
        });
});
parcelRegister("bIaKQ", function(module, exports) {
    $parcel$export(module.exports, "getSprintsForIds", ()=>$1b944ee7de65fa88$export$82e35078e5524b74);
    $parcel$export(module.exports, "updateIssueSprint", ()=>$1b944ee7de65fa88$export$282da5f4d0fe4573);
    $parcel$export(module.exports, "doSprintSearchWithEmptySearchCache", ()=>$1b944ee7de65fa88$export$21d57a0976d4b86);
    $parcel$export(module.exports, "populateExternalSprints", ()=>$1b944ee7de65fa88$export$93c7e9eb4104792d);
    $parcel$export(module.exports, "default", ()=>$1b944ee7de65fa88$export$2e2bcd8739ae039);
    var $gJBT6 = parcelRequire("gJBT6");
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $8DSSe = parcelRequire("8DSSe");
    var $bHTqr = parcelRequire("bHTqr");
    var $d3quy = parcelRequire("d3quy");
    var $8RuCQ = parcelRequire("8RuCQ");
    var $3W33Z = parcelRequire("3W33Z");
    var $77QEM = parcelRequire("77QEM");
    var $asXbx = parcelRequire("asXbx");
    var $bkasS = parcelRequire("bkasS");
    var $3HNHT = parcelRequire("3HNHT");
    const $1b944ee7de65fa88$export$d5302947a411ffb1 = 'command.sprint.GET_SPRINTS_FOR_IDS';
    const $1b944ee7de65fa88$export$82e35078e5524b74 = (payload)=>({
            type: $1b944ee7de65fa88$export$d5302947a411ffb1,
            payload: payload
        });
    const $1b944ee7de65fa88$var$UPDATE_ISSUE_SPRINT = 'command.issue-status.UPDATE_ISSUE_SPRINT';
    const $1b944ee7de65fa88$export$282da5f4d0fe4573 = (payload)=>({
            type: $1b944ee7de65fa88$var$UPDATE_ISSUE_SPRINT,
            payload: payload
        });
    function* $1b944ee7de65fa88$export$a67699f3a6f6bdde(allExternalSprints) {
        const disabledSprints = [];
        const externalSprints = [];
        allExternalSprints.forEach((sprint)=>{
            if (sprint.isDisabled === true) disabledSprints.push(sprint);
            else externalSprints.push(sprint);
        });
        yield (0, $aNOuE.put)($3W33Z.add(externalSprints));
        yield (0, $aNOuE.put)($8RuCQ.add(disabledSprints));
    }
    const $1b944ee7de65fa88$var$memoizedEmptySprintSearch = (0, ($parcel$interopDefault($gJBT6)))(()=>$1b944ee7de65fa88$export$f8c0d39660113c94(''));
    async function $1b944ee7de65fa88$export$21d57a0976d4b86(query) {
        if (query === '') try {
            return await $1b944ee7de65fa88$var$memoizedEmptySprintSearch();
        } catch (e) {
            $1b944ee7de65fa88$var$memoizedEmptySprintSearch.cache.clear && $1b944ee7de65fa88$var$memoizedEmptySprintSearch.cache.clear();
            throw e;
        }
        return $1b944ee7de65fa88$export$f8c0d39660113c94(query);
    }
    async function $1b944ee7de65fa88$export$f8c0d39660113c94(query) {
        const url = (0, $3HNHT.urls).sprintSearch(query);
        const response = await (0, $8DSSe.default)(url, {
            method: (0, $77QEM.GET)
        });
        if (!response.ok) throw Error('Failed to do sprint search');
        return response.json();
    }
    function* $1b944ee7de65fa88$export$6d66b37be32f516a({ payload: payload }) {
        const { id: planId, currentScenarioId: scenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const response = yield* (0, $asXbx.jsonOrError)({
            url: (0, $3HNHT.urls).sprintsForIds,
            method: 'POST',
            body: {
                planId: planId,
                scenarioId: scenarioId,
                itemKeys: payload
            }
        });
        if (response.ok) {
            const externalSprints = response.data;
            yield (0, $aNOuE.call)($1b944ee7de65fa88$export$a67699f3a6f6bdde, externalSprints);
        }
    }
    function* $1b944ee7de65fa88$export$c324c5af3aee70ec({ payload: { id: id, value: value, sprint: sprint } }) {
        if (value != null) {
            const sprintIds = yield (0, $aNOuE.select)((0, $d3quy.getAllSprintIds));
            if (!sprintIds.includes(value)) {
                if (sprint) yield (0, $aNOuE.call)($1b944ee7de65fa88$export$a67699f3a6f6bdde, [
                    sprint
                ]);
                else yield (0, $aNOuE.put)($1b944ee7de65fa88$export$82e35078e5524b74([
                    value
                ]));
            }
        }
        yield (0, $aNOuE.put)((0, $bkasS.updateIssueOrInlineCreate)({
            id: id,
            sprint: value
        }));
    }
    function* $1b944ee7de65fa88$export$93c7e9eb4104792d(allSprints, planSprints) {
        const planSprintIds = new Set(planSprints.map((it)=>it.id));
        const externalSprints = allSprints.filter((it)=>!planSprintIds.has(it.id));
        yield (0, $aNOuE.call)($1b944ee7de65fa88$export$a67699f3a6f6bdde, externalSprints);
    }
    function* $1b944ee7de65fa88$export$1de6a952da77a9b1() {
        yield (0, $6u3NN.takeEvery)($1b944ee7de65fa88$var$UPDATE_ISSUE_SPRINT, $1b944ee7de65fa88$export$c324c5af3aee70ec);
    }
    function* $1b944ee7de65fa88$export$e2949ba7d39c1662() {
        yield (0, $6u3NN.takeEvery)($1b944ee7de65fa88$export$d5302947a411ffb1, $1b944ee7de65fa88$export$6d66b37be32f516a);
    }
    function* $1b944ee7de65fa88$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($1b944ee7de65fa88$export$e2949ba7d39c1662);
        yield (0, $aNOuE.fork)($1b944ee7de65fa88$export$1de6a952da77a9b1);
    }
});
parcelRegister("8RuCQ", function(module, exports) {
    $parcel$export(module.exports, "ADD", ()=>$54110615b33ef569$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "RESET", ()=>$54110615b33ef569$export$4a991c87e640ef77);
    $parcel$export(module.exports, "add", ()=>$54110615b33ef569$export$e16d8520af44a096);
    $parcel$export(module.exports, "reset", ()=>$54110615b33ef569$export$aad8462122ac592b);
    const $54110615b33ef569$export$bb6389024b71c2ae = 'state.domain.disabled-sprints.ADD';
    const $54110615b33ef569$export$4a991c87e640ef77 = 'state.domain.disabled-sprints.RESET';
    const $54110615b33ef569$export$e16d8520af44a096 = (payload)=>({
            type: $54110615b33ef569$export$bb6389024b71c2ae,
            payload: payload
        });
    const $54110615b33ef569$export$aad8462122ac592b = (payload)=>({
            type: $54110615b33ef569$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("3W33Z", function(module, exports) {
    $parcel$export(module.exports, "ADD", ()=>$27cdf9799afab080$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "RESET", ()=>$27cdf9799afab080$export$4a991c87e640ef77);
    $parcel$export(module.exports, "add", ()=>$27cdf9799afab080$export$e16d8520af44a096);
    const $27cdf9799afab080$export$bb6389024b71c2ae = 'state.domain.external-sprints.ADD';
    const $27cdf9799afab080$export$4a991c87e640ef77 = 'state.domain.external-sprints.RESET';
    const $27cdf9799afab080$export$e16d8520af44a096 = (payload)=>({
            type: $27cdf9799afab080$export$bb6389024b71c2ae,
            payload: payload
        });
    const $27cdf9799afab080$export$aad8462122ac592b = (payload)=>({
            type: $27cdf9799afab080$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("3HNHT", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$ce656a4088bdb5a6$export$bcae9ba627f604b6);
    const $ce656a4088bdb5a6$export$bcae9ba627f604b6 = {
        sprintsForIds: '/rest/jpo/1.0/sprint/get',
        sprintSearch: (query)=>`/rest/jpo/1.0/sprint/search?query=${query}&maxResults=10`
    };
});
parcelRegister("dv8ev", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$3b8e4c5ddfbe577a$export$c31df4bd766f9c35);
    var $7ppNi = parcelRequire("7ppNi");
    var $4sJY8 = parcelRequire("4sJY8");
    var $d3quy = parcelRequire("d3quy");
    var $dRVQG = parcelRequire("dRVQG");
    const $3b8e4c5ddfbe577a$export$c31df4bd766f9c35 = (state)=>({
            sprints: (0, $d3quy.getSprints)(state),
            sprintsByTeam: (0, $d3quy.getSprintsForTeam)(state),
            teamsById: (0, $dRVQG.getTeamsById)(state),
            issueStatuses: (0, $7ppNi.getIssueStatusById)(state),
            teams: (0, $dRVQG.getTeams)(state),
            sprintsByIssueSources: (0, $d3quy.getSprintsForIssueSources)(state),
            additionalTeamsById: (0, $dRVQG.getAdditionalTeamsById)(state),
            externalSprintsById: (0, $d3quy.getExternalSprintsById)(state),
            internalSprintIds: (0, $d3quy.getInternalSprintIds)(state),
            allSprints: (0, $d3quy.getAllSprints)(state),
            rollupValues: (0, $4sJY8.getRollupMap)(state)
        });
});
parcelRegister("apDrx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfb7f14f2f178f17$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $koVbs;
    var $c12LJ;
    var $4nDwW = parcelRequire("4nDwW");
    var $boYVS = parcelRequire("boYVS");
    var $i0EOE = parcelRequire("i0EOE");
    var $a6ikO = parcelRequire("a6ikO");
    const $bfb7f14f2f178f17$export$639018492a4c835c = (isIssueASubtask, intl)=>{
        if (isIssueASubtask) return {
            header: intl.formatMessage((0, $boYVS.default).issueIsSubtaskHeader),
            content: intl.formatMessage((0, $boYVS.default).issueIsSubtaskContent)
        };
    };
    const $bfb7f14f2f178f17$export$c6e588a37841f69d = ({ isScrolling: isScrolling, isReadOnly: isReadOnly = false, issue: issue, issue: { team: teamId, level: level, id: issueId }, showOptimizations: showOptimizations, sprints: sprints, sprintsByTeam: sprintsByTeam, teamsById: teamsById, additionalTeamsById: additionalTeamsById, issueStatuses: issueStatuses, teams: teams, sprintsByIssueSources: sprintsByIssueSources, externalSprintsById: externalSprintsById, allSprints: allSprints, rollupValues: rollupValues, SprintSelectComponent: SprintSelectComponent = (0, $i0EOE.default), onChangeOld: onChangeOld })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { formatMessage: formatMessage } = intl;
        const sprintRollUpForIssue = (0, $4nDwW.isDefined)(rollupValues[issueId]) ? rollupValues[issueId].sprint : null;
        const handleSelection = (selection)=>{
            if (selection && typeof selection.value === 'string') onChangeOld(issue, selection.value);
            else onChangeOld(issue, undefined);
        };
        const isIssueASubtask = level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL);
        const team = teamId ? teamsById[teamId] || null : null;
        let sprintsForTeam = sprints;
        if ((0, $4nDwW.isDefined)(team)) sprintsForTeam = sprintsByTeam[team.id] || [];
        const isSelectReadOnly = isIssueASubtask || isReadOnly;
        const sprintSelectProps = {
            sprintRollUpForIssue: sprintRollUpForIssue,
            handleSelection: handleSelection,
            isScrolling: isScrolling,
            isReadOnly: isSelectReadOnly,
            issue: issue,
            showOptimizations: showOptimizations,
            sprints: sprints,
            issueStatuses: issueStatuses,
            sprintsByTeam: sprintsByTeam,
            teams: teams,
            sprintsByIssueSources: sprintsByIssueSources,
            additionalTeamsById: additionalTeamsById,
            teamsById: teamsById,
            allSprints: allSprints,
            externalSprintsById: externalSprintsById,
            externalSprintLabel: formatMessage((0, $boYVS.default).externalSprint),
            message: !showOptimizations ? $bfb7f14f2f178f17$export$639018492a4c835c(isIssueASubtask, intl) : undefined
        };
        return isScrolling ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a6ikO.default), {
            issue: issue,
            showOptimizations: showOptimizations,
            sprints: sprintsForTeam
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement(SprintSelectComponent, sprintSelectProps);
    };
    const $bfb7f14f2f178f17$export$a092d4418bd765b8 = ({ isScrolling: isScrolling, isReadOnly: isReadOnly = false, issue: issue, issue: { team: teamId, level: level, id: issueId }, showOptimizations: showOptimizations, sprints: sprints, sprintsByTeam: sprintsByTeam, teamsById: teamsById, additionalTeamsById: additionalTeamsById, issueStatuses: issueStatuses, teams: teams, sprintsByIssueSources: sprintsByIssueSources, internalSprintIds: internalSprintIds, externalSprintsById: externalSprintsById, allSprints: allSprints, rollupValues: rollupValues, SprintSelectComponent: SprintSelectComponent = (0, $i0EOE.SprintSelect), onChange: onChange })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { formatMessage: formatMessage } = intl;
        const sprintRollUpForIssue = (0, $4nDwW.isDefined)(rollupValues[issueId]) ? rollupValues[issueId].sprint : null;
        const handleSelection = (selection)=>{
            if (selection) onChange(issue, selection.value, selection.sprint ?? undefined);
            else onChange(issue, undefined, undefined);
        };
        const isIssueASubtask = level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL);
        const team = teamId ? teamsById[teamId] || null : null;
        let sprintsForTeam = sprints;
        if ((0, $4nDwW.isDefined)(team)) sprintsForTeam = sprintsByTeam[team.id] || [];
        const sprintSelectProps = {
            sprintRollUpForIssue: sprintRollUpForIssue,
            handleSelection: handleSelection,
            isScrolling: isScrolling,
            isReadOnly: isIssueASubtask || isReadOnly,
            issue: issue,
            showOptimizations: showOptimizations,
            sprints: sprints,
            issueStatuses: issueStatuses,
            sprintsByTeam: sprintsByTeam,
            teams: teams,
            sprintsByIssueSources: sprintsByIssueSources,
            additionalTeamsById: additionalTeamsById,
            teamsById: teamsById,
            allSprints: allSprints,
            internalSprintIds: internalSprintIds,
            externalSprintsById: externalSprintsById,
            externalSprintLabel: formatMessage((0, $boYVS.default).externalSprint),
            message: !showOptimizations ? $bfb7f14f2f178f17$export$639018492a4c835c(isIssueASubtask, intl) : undefined
        };
        return isScrolling ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a6ikO.default), {
            issue: issue,
            showOptimizations: showOptimizations,
            sprints: sprintsForTeam
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement(SprintSelectComponent, sprintSelectProps);
    };
    var $bfb7f14f2f178f17$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('use_sprint_search_in_plan_dropdown', $bfb7f14f2f178f17$export$a092d4418bd765b8, $bfb7f14f2f178f17$export$c6e588a37841f69d);
});
parcelRegister("boYVS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8e0855e35748039$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e8e0855e35748039$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.placeholder",
            "defaultMessage": "Choose a sprint"
        },
        sprintSelectorLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.sprint-selector-label",
            "defaultMessage": "Select sprint for issue {issue}"
        },
        issueIsSubtaskHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.issue-is-subtask-header",
            "defaultMessage": "Cannot change the sprint of sub-tasks."
        },
        issueIsSubtaskContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.issue-is-subtask-content",
            "defaultMessage": "A sub-task is assigned to the same sprint as its parent story. To change this sprint, change the sprint of the parent story instead."
        },
        noTeamHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-team-header",
            "defaultMessage": "No team has been selected."
        },
        noTeamContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-team-content",
            "defaultMessage": "Choose a Scrum team first, and make sure the board for that team has sprints in it."
        },
        externalTeamHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-team-header",
            "defaultMessage": "Team not in plan."
        },
        externalTeamContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-team-content",
            "defaultMessage": "Add the team to the plan first, then try setting the sprint again."
        },
        teamIsNotAScrumTeamHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.team-is-not-a-scrum-team-header",
            "defaultMessage": "The associated team is not a Scrum team."
        },
        teamIsNotAScrumTeamContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.team-is-not-a-scrum-team-content",
            "defaultMessage": "Since Scrum teams work in sprints, choose a Scrum team first."
        },
        noIssueSourceDefinedHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-issue-source-defined-header",
            "defaultMessage": "There are no Scrum boards for the associated team."
        },
        noIssueSourceDefinedContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-issue-source-defined-content",
            "defaultMessage": "Make sure this team is associated with a Scrum board, to use the sprints of that board."
        },
        noSprintsInTeamHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-sprints-in-team-header",
            "defaultMessage": "There are no sprints in the associated board."
        },
        noSprintsInTeamContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-sprints-in-team-content",
            "defaultMessage": "Create a sprint for this board in Jira first."
        },
        numCompletedSprints: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.num-completed-sprints",
            "defaultMessage": "{numCompletedSprints} completed"
        },
        completedSprintsHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.completed-sprints-header",
            "defaultMessage": "This issue was in"
        },
        completedSprintsLozenge: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.completed-sprints-lozenge",
            "defaultMessage": "Completed"
        },
        futureSprints: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.future-sprints",
            "defaultMessage": "Future"
        },
        futureAndCompletedSprints: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.future-and-completed-sprints",
            "defaultMessage": "{sprint} <span>+ {numCompletedSprints} completed</span>"
        },
        notInPlanAndCompletedSprints: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.not-in-plan-and-completed-sprints",
            "defaultMessage": "<span>{sprint}</span> <span>+ {numCompletedSprints} completed</span>"
        },
        otherSprints: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.other-sprints",
            "defaultMessage": "Other sprints"
        },
        externalSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-sprint",
            "defaultMessage": "External sprint"
        },
        externalSprintTooltipTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-sprint-tooltip-title",
            "defaultMessage": "Sprint currently not in this plan"
        },
        externalSprintTooltipContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-sprint-tooltip-content",
            "defaultMessage": "While this sprint isn't in this plan, it's appearing because it's assigned to issues in the plan."
        },
        externalCompletedSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-completed-sprint",
            "defaultMessage": "completed (external)"
        }
    });
});
parcelRegister("i0EOE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4bfdf9899f5538a0$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "SprintSelect", ()=>$4bfdf9899f5538a0$export$b381aa2d0aaee6b6);
    var $5uXOq = parcelRequire("5uXOq");
    var $cTYeP;
    var $jVZZA;
    var $3DBzg;
    var $bQZTk;
    var $2rMKg;
    var $3JFoT;
    var $7Zjd1;
    var $h35CY;
    var $1dJ6S;
    var $dC5iT;
    var $kgoHi;
    var $3bDjY;
    var $koVbs;
    var $bIaKQ = parcelRequire("bIaKQ");
    var $6TEBn = parcelRequire("6TEBn");
    var $3FQWJ = parcelRequire("3FQWJ");
    var $l38L3 = parcelRequire("l38L3");
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $lJdz7 = parcelRequire("lJdz7");
    var $cSDJf = parcelRequire("cSDJf");
    var $8zOmE;
    var $2NMNM;
    var $boYVS = parcelRequire("boYVS");
    var $2nRLW = parcelRequire("2nRLW");
    var $i5Ozt = parcelRequire("i5Ozt");
    var $bqtft = parcelRequire("bqtft");
    const $4bfdf9899f5538a0$var$sprintOfIssueIsCompleted = (issue)=>(0, $4nDwW.isDefined)(issue.sprint) && Array.isArray(issue.completedSprints) && (0, parcelRequire("cTYeP")).default(issue.sprint, issue.completedSprints);
    const $4bfdf9899f5538a0$var$getOptionLabel = ({ issue: issue, issueStatuses: issueStatuses, sprints: sprints, showOptimizations: showOptimizations, newStyle: newStyle })=>{
        const issueIsDone = Boolean(issueStatuses && issue.status && issueStatuses[issue.status] && issueStatuses[issue.status].categoryId === 3);
        const issueIsCompleted = issueIsDone && $4bfdf9899f5538a0$var$sprintOfIssueIsCompleted(issue);
        const completedSprintIds = issue.completedSprints || [];
        const completedSprints = (0, parcelRequire("bQZTk")).default((0, parcelRequire("jVZZA")).default((sprint)=>(0, parcelRequire("3DBzg")).default(sprint.id, completedSprintIds)), (0, parcelRequire("h35CY")).default((0, parcelRequire("2rMKg")).default('completeDate')), (0, parcelRequire("3JFoT")).default)(sprints);
        const sprintIsOptimized = !!showOptimizations && (0, $l38L3.hasValueChanged)(issue.sprint, (0, $l38L3.getOptimizedValue)(issue, (0, $d0091d9e935603a4$export$b549cc58e415d416)));
        return (opt, { context: context })=>{
            const sprintNotSet = !(0, $4nDwW.isDefined)(issue.sprint);
            if (context === 'menu') {
                const sprintIsCompleted = opt.isDisabled;
                if (newStyle) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $i5Ozt.MenuLabel), {
                    sprintIsExternal: opt.isExternal,
                    sprintIsCompleted: sprintIsCompleted,
                    label: opt.label,
                    boardName: opt.boardName
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $i5Ozt.MenuLabelOld), {
                    sprintIsExternal: opt.isExternal,
                    sprintIsCompleted: sprintIsCompleted
                }, opt.label);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $i5Ozt.DisplayLabel), {
                issueIsCompleted: issueIsCompleted,
                issueCompletedSprints: completedSprints,
                sprintIsOptimized: sprintIsOptimized,
                sprintIsExternal: opt.isExternal,
                sprintNotSet: sprintNotSet
            }, opt.label);
        };
    };
    const $4bfdf9899f5538a0$export$68421dac91f49311 = (props)=>{
        const { handleSelection: handleSelection, isScrolling: isScrolling, isReadOnly: isReadOnly, issue: issue, issue: { sprint: sprintOfIssue, team: teamOfIssue }, showOptimizations: showOptimizations, sprints: sprints, message: message, issueStatuses: issueStatuses, sprintsByTeam: sprintsByTeam, teams: teams, sprintsByIssueSources: sprintsByIssueSources, additionalTeamsById: additionalTeamsById, teamsById: teamsById, allSprints: allSprints, externalSprintsById: externalSprintsById, externalSprintLabel: externalSprintLabel, sprintRollUpForIssue: sprintRollUpForIssue, SelectForColumnCell: SelectForColumnCell } = props;
        const completedSprints = issue.completedSprints || [];
        const completedSprintsForIssue = allSprints.filter((sprint)=>sprint.state === (0, $TTKUQ.SPRINT_STATES).CLOSED && (0, parcelRequire("cTYeP")).default(sprint.id, completedSprints));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const otherSprintsLabel = formatMessage((0, $boYVS.default).otherSprints);
        const futureSprintsGroupByTeam = (0, $6TEBn.getFutureSprintGroups)(teamOfIssue, sprintOfIssue, sprintsByIssueSources, sprintsByTeam, additionalTeamsById, teams, teamsById, otherSprintsLabel);
        const completedSprintOptions = completedSprintsForIssue.map((sprint)=>({
                value: sprint.id,
                label: sprint.title,
                isDisabled: true,
                isExternal: (0, $4nDwW.isDefined)(externalSprintsById[sprint.id])
            }));
        const groupedOptions = [
            {
                label: formatMessage((0, $boYVS.default).completedSprintsHeader),
                options: completedSprintOptions
            }
        ];
        futureSprintsGroupByTeam.forEach((sprints, label)=>{
            groupedOptions.push({
                label: label,
                options: sprints.map((s)=>({
                        value: s.id,
                        label: s.title
                    }))
            });
        });
        const mapIdToTitle = (_, value)=>externalSprintsById[value] && externalSprintsById[value].title || (0, $2nRLW.getSprintName)(value, sprints);
        let value = showOptimizations ? (0, $l38L3.getOptimizedValue)(issue, (0, $d0091d9e935603a4$export$b549cc58e415d416)) : sprintOfIssue;
        let isClearable = true;
        if (!(0, $4nDwW.isDefined)(value) && completedSprints.length > 0) {
            value = completedSprints[0];
            isClearable = false;
        }
        if ($4bfdf9899f5538a0$var$sprintOfIssueIsCompleted(issue)) isClearable = false;
        const currentSprint = sprints.find((sprint)=>sprint.id === value);
        let sprintValue;
        if (currentSprint) sprintValue = {
            label: currentSprint.title,
            value: currentSprint.id
        };
        if (!(0, $4nDwW.isDefined)(sprintValue) && (0, $4nDwW.isDefined)(value)) {
            const externalSprintOption = externalSprintsById[value];
            if (externalSprintOption) {
                sprintValue = {
                    value: externalSprintOption.id,
                    label: externalSprintOption.title,
                    isExternal: true
                };
                if (externalSprintOption.state !== (0, $TTKUQ.SPRINT_STATES).CLOSED) groupedOptions.push({
                    label: externalSprintLabel,
                    options: [
                        {
                            value: externalSprintOption.id,
                            label: externalSprintOption.title,
                            isExternal: true
                        }
                    ]
                });
            }
        }
        let selectValue = null;
        if ((0, $4nDwW.isDefined)(sprintValue)) selectValue = sprintValue;
        else if (!(0, $4nDwW.isDefined)(sprintValue) && completedSprints.length > 0) selectValue = {
            value: null,
            label: null
        };
        const formatOptionLabel = $4bfdf9899f5538a0$var$getOptionLabel({
            issue: issue,
            issueStatuses: issueStatuses,
            sprints: allSprints,
            showOptimizations: showOptimizations,
            newStyle: false
        });
        const withRollup = ()=>{
            const rolledUpValues = (0, parcelRequire("7Zjd1")).default((a, b)=>a.localeCompare(b), (sprintRollUpForIssue || []).map((sprintId)=>{
                const externalSprint = externalSprintsById[sprintId];
                if (externalSprint) return externalSprint.title;
                return (0, $2nRLW.getSprintName)(sprintId, sprints) || formatMessage((0, $boYVS.default).externalCompletedSprint);
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectForColumnCell, {
                "aria-label": formatMessage({
                    ...(0, $boYVS.default).sprintSelectorLabel
                }, {
                    issue: issue.summary
                }),
                attribute: "sprint",
                formatOptionLabel: formatOptionLabel,
                isClearable: isClearable,
                isDisabled: isReadOnly,
                issueId: issue.id,
                minSelectWidth: (0, $cSDJf.MIN_SELECT_WIDTH),
                onChange: handleSelection,
                options: groupedOptions,
                placeholder: formatMessage((0, $boYVS.default).placeholder),
                rolledUpValues: rolledUpValues,
                value: selectValue
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
            attribute: (0, $d0091d9e935603a4$export$b549cc58e415d416),
            issue: issue,
            valueMapper: mapIdToTitle,
            isScrolling: isScrolling,
            showOptimizations: showOptimizations
        }, (0, $4nDwW.isDefined)(message) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $bqtft.tooltip
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                as: "h4",
                size: "small"
            }, message.header), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, message.content))
        }, withRollup()) : withRollup());
    };
    var $4bfdf9899f5538a0$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        SelectForColumnCell: (0, $ixSW4.slots).CellSelectWithRollup
    })($4bfdf9899f5538a0$export$68421dac91f49311);
    const $4bfdf9899f5538a0$var$filterInternalOptions = (query, options)=>{
        const filteredOptions = [];
        options.forEach((group)=>{
            const filteredGroupOptions = group.options.filter((option)=>$4bfdf9899f5538a0$var$optionsFilter(option.label, query));
            if (filteredGroupOptions.length > 0) filteredOptions.push({
                label: group.label,
                options: filteredGroupOptions
            });
        });
        return filteredOptions;
    };
    const $4bfdf9899f5538a0$var$optionsFilter = (label, query)=>label.toLowerCase().includes(query.toLowerCase());
    const $4bfdf9899f5538a0$export$b381aa2d0aaee6b6 = (props)=>{
        const { handleSelection: handleSelection, isScrolling: isScrolling, isReadOnly: isReadOnly, issue: issue, issue: { sprint: sprintOfIssue, team: teamOfIssue }, showOptimizations: showOptimizations, sprints: sprints, message: message, issueStatuses: issueStatuses, sprintsByTeam: sprintsByTeam, teams: teams, sprintsByIssueSources: sprintsByIssueSources, additionalTeamsById: additionalTeamsById, teamsById: teamsById, allSprints: allSprints, externalSprintsById: externalSprintsById, externalSprintLabel: externalSprintLabel, sprintRollUpForIssue: sprintRollUpForIssue, internalSprintIds: internalSprintIds } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const completedSprints = (0, $5uXOq.useMemo)(()=>issue.completedSprints || [], [
            issue.completedSprints
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleSelectionWithAnalytics = (newValue, actionMeta)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'selected',
                actionSubject: 'sprint'
            }), {
                isExternal: newValue?.isExternal ?? false
            });
            handleSelection(newValue, actionMeta);
        };
        const mapIdToTitle = (_, value)=>externalSprintsById[value] && externalSprintsById[value].title || (0, $2nRLW.getSprintName)(value, sprints);
        let value = showOptimizations ? (0, $l38L3.getOptimizedValue)(issue, (0, $d0091d9e935603a4$export$b549cc58e415d416)) : sprintOfIssue;
        let isClearable = true;
        if (!(0, $4nDwW.isDefined)(value) && completedSprints.length > 0) {
            value = completedSprints[0];
            isClearable = false;
        }
        if ($4bfdf9899f5538a0$var$sprintOfIssueIsCompleted(issue)) isClearable = false;
        const currentSprint = sprints.find((sprint)=>sprint.id === value);
        let sprintValue;
        if (currentSprint) sprintValue = {
            label: currentSprint.title,
            value: currentSprint.id
        };
        if (!(0, $4nDwW.isDefined)(sprintValue) && (0, $4nDwW.isDefined)(value)) {
            const externalSprintOption = externalSprintsById[value];
            if (externalSprintOption) sprintValue = {
                value: externalSprintOption.id,
                label: externalSprintOption.title,
                isExternal: true
            };
        }
        let selectValue = null;
        if ((0, $4nDwW.isDefined)(sprintValue)) selectValue = sprintValue;
        else if (!(0, $4nDwW.isDefined)(sprintValue) && completedSprints.length > 0) selectValue = {
            value: null,
            label: null
        };
        const groupedInternalOptions = (0, $5uXOq.useMemo)(()=>{
            const otherSprintsLabel = formatMessage((0, $boYVS.default).otherSprints);
            const futureSprintsGroupByTeam = (0, $6TEBn.getFutureSprintGroups)(teamOfIssue, sprintOfIssue, sprintsByIssueSources, sprintsByTeam, additionalTeamsById, teams, teamsById, otherSprintsLabel);
            const completedSprintsForIssue = allSprints.filter((sprint)=>sprint.state === (0, $TTKUQ.SPRINT_STATES).CLOSED && (0, parcelRequire("cTYeP")).default(sprint.id, completedSprints));
            const completedSprintOptions = completedSprintsForIssue.map((sprint)=>({
                    value: sprint.id,
                    label: sprint.title,
                    isDisabled: true,
                    isExternal: (0, $4nDwW.isDefined)(externalSprintsById[sprint.id])
                }));
            const internalOptions = [
                {
                    label: formatMessage((0, $boYVS.default).completedSprintsHeader),
                    options: completedSprintOptions
                }
            ];
            futureSprintsGroupByTeam.forEach((futureSprints, label)=>{
                internalOptions.push({
                    label: label,
                    options: futureSprints.map((s)=>({
                            value: s.id,
                            label: s.title
                        }))
                });
            });
            return internalOptions;
        }, [
            additionalTeamsById,
            allSprints,
            externalSprintsById,
            formatMessage,
            completedSprints,
            sprintOfIssue,
            sprintsByIssueSources,
            sprintsByTeam,
            teamOfIssue,
            teams,
            teamsById
        ]);
        const getOptions = (0, $5uXOq.useCallback)(async (query)=>{
            const externalOptions = [];
            if ((0, $4nDwW.isDefined)(value)) {
                const externalSprintOption = externalSprintsById[value];
                if (externalSprintOption && $4bfdf9899f5538a0$var$optionsFilter(externalSprintOption.title, query)) externalOptions.push({
                    value: externalSprintOption.id,
                    label: externalSprintOption.title,
                    isExternal: true
                });
            }
            const searchData = await (0, $bIaKQ.doSprintSearchWithEmptySearchCache)(query.trim().toLowerCase());
            searchData.forEach((sprint)=>{
                const id = sprint.id.toString();
                if (!internalSprintIds.includes(id) && id !== value) externalOptions.push({
                    value: id,
                    label: sprint.title,
                    isExternal: true,
                    sprint: sprint,
                    boardName: sprint.boardName
                });
            });
            const filteredInternalOptions = $4bfdf9899f5538a0$var$filterInternalOptions(query, groupedInternalOptions);
            return filteredInternalOptions.concat({
                label: externalSprintLabel,
                options: externalOptions
            });
        }, [
            value,
            internalSprintIds,
            externalSprintsById,
            groupedInternalOptions,
            externalSprintLabel
        ]);
        const getOptionsWithCallback = (0, $5uXOq.useCallback)((query, callback)=>{
            getOptions(query).then(callback);
        }, [
            getOptions
        ]);
        const formatOptionLabel = (0, $5uXOq.useMemo)(()=>$4bfdf9899f5538a0$var$getOptionLabel({
                issue: issue,
                issueStatuses: issueStatuses,
                sprints: allSprints,
                showOptimizations: showOptimizations,
                newStyle: true
            }), [
            allSprints,
            issue,
            issueStatuses,
            showOptimizations
        ]);
        const rolledUpValues = (0, $5uXOq.useMemo)(()=>(0, parcelRequire("7Zjd1")).default((a, b)=>a.localeCompare(b), (sprintRollUpForIssue || []).map((sprintId)=>{
                const externalSprint = externalSprintsById[sprintId];
                if (externalSprint) return externalSprint.title;
                return (0, $2nRLW.getSprintName)(sprintId, sprints) || formatMessage((0, $boYVS.default).externalCompletedSprint);
            })), [
            externalSprintsById,
            formatMessage,
            sprintRollUpForIssue,
            sprints
        ]);
        const withRollup = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $lJdz7.AsyncCellSelectWithRollup), {
                "aria-label": formatMessage({
                    ...(0, $boYVS.default).sprintSelectorLabel
                }, {
                    issue: issue.summary
                }),
                attribute: "sprint",
                formatOptionLabel: formatOptionLabel,
                isClearable: isClearable,
                isDisabled: isReadOnly,
                issueId: issue.id,
                minSelectWidth: (0, $cSDJf.MIN_SELECT_WIDTH),
                onChange: handleSelectionWithAnalytics,
                placeholder: formatMessage((0, $boYVS.default).placeholder),
                rolledUpValues: rolledUpValues,
                value: selectValue,
                loadOptions: getOptionsWithCallback
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
            attribute: (0, $d0091d9e935603a4$export$b549cc58e415d416),
            issue: issue,
            valueMapper: mapIdToTitle,
            isScrolling: isScrolling,
            showOptimizations: showOptimizations
        }, (0, $4nDwW.isDefined)(message) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                padding: "space.100"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                alignItems: "center"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                size: "small",
                color: "color.text.inverse"
            }, message.header), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, message.content)))
        }, withRollup()) : withRollup());
    };
});
parcelRegister("2nRLW", function(module, exports) {
    $parcel$export(module.exports, "getSprintName", ()=>$a7d271950f2c5b6b$export$3df6198cde5435f9);
    var $4nDwW = parcelRequire("4nDwW");
    const $a7d271950f2c5b6b$export$3df6198cde5435f9 = (sprintId, sprints)=>{
        const sprint = sprints.find(({ id: id })=>id === sprintId);
        return (0, $4nDwW.isDefined)(sprint) ? sprint.title : '';
    };
});
parcelRegister("i5Ozt", function(module, exports) {
    $parcel$export(module.exports, "DisplayLabel", ()=>$b336ae86f2ed4261$export$d6cff160a9173fab);
    $parcel$export(module.exports, "MenuLabelOld", ()=>$b336ae86f2ed4261$export$80dd06d58b9ee66e);
    $parcel$export(module.exports, "MenuLabel", ()=>$b336ae86f2ed4261$export$dd37bec0e8a99143);
    var $5uXOq = parcelRequire("5uXOq");
    var $jB947;
    var $3nPAF;
    var $blU6m;
    var $1dJ6S;
    var $lj8SI;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $3bDjY;
    var $ousew;
    var $8RXs9;
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    var $boYVS = parcelRequire("boYVS");
    var $7xoq8 = parcelRequire("7xoq8");
    const $b336ae86f2ed4261$var$getTestId = (sprintName)=>typeof sprintName === 'string' ? `sprint-select-option-${sprintName.replace(/\s/g, '-')}` : undefined;
    const $b336ae86f2ed4261$var$ExternalSprint = (0, (0, parcelRequire("8RXs9")).default)(({ children: children, intl: intl, isCompleted: isCompleted })=>{
        const tooltipContent = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $7xoq8.tooltip
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "h4",
            size: "small"
        }, intl.formatMessage((0, $boYVS.default).externalSprintTooltipTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, intl.formatMessage((0, $boYVS.default).externalSprintTooltipContent)));
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $7xoq8.externalSprint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $7xoq8.externalSprintText
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $7xoq8.externalSprintLozenge,
            onFocus: ()=>{},
            onMouseOver: (e)=>e.stopPropagation()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).externalLozenge))), isCompleted === true && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $boYVS.default).completedSprintsLozenge)))));
    });
    function $b336ae86f2ed4261$var$UncompletedSprint({ children: children, sprintIsExternal: sprintIsExternal }) {
        return sprintIsExternal ? (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$ExternalSprint, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $7xoq8.sprintTitle
        }, children);
    }
    function $b336ae86f2ed4261$var$CompletedSprints({ peak: peak = false, prefix: prefix, sprints: sprints, sprintIsExternal: sprintIsExternal }) {
        if ((0, parcelRequire("3nPAF")).default(sprints)) return null;
        if ((0, $4nDwW.isDefined)(prefix)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: `${$7xoq8.completedSprintsChunk} ${$7xoq8.sprintTitlePrefix}`
        }, prefix), (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$CompletedSprints, {
            sprintIsExternal: sprintIsExternal,
            sprints: sprints
        }));
        if (peak) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$CompletedSprints, {
            sprintIsExternal: sprintIsExternal,
            sprints: (0, parcelRequire("blU6m")).default(0, 1)(sprints)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$CompletedSprints, {
            sprintIsExternal: sprintIsExternal,
            sprints: (0, parcelRequire("blU6m")).default(1, Infinity)(sprints),
            prefix: "+"
        }));
        if (sprints.length === 1) {
            const sprint = (0, parcelRequire("jB947")).default(sprints);
            if (!(0, $4nDwW.isDefined)(sprint)) return null;
            return sprintIsExternal === true ? (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$ExternalSprint, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: `${$7xoq8.completedSprintsChunk} ${$7xoq8.sprintTitle}`
            }, sprint.title)) : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: `${$7xoq8.completedSprintsChunk} ${$7xoq8.sprintTitle}`
            }, sprint.title);
        }
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: `${$7xoq8.completedSprintsChunk} ${$7xoq8.sprintTitle}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $boYVS.default).numCompletedSprints,
            values: {
                numCompletedSprints: sprints.length
            }
        })));
    }
    const $b336ae86f2ed4261$export$d6cff160a9173fab = function DisplayLabel({ issueIsCompleted: issueIsCompleted, issueCompletedSprints: issueCompletedSprints, sprintIsExternal: sprintIsExternal, sprintNotSet: sprintNotSet, sprintIsOptimized: sprintIsOptimized, children: children }) {
        if (issueIsCompleted) return (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$CompletedSprints, {
            sprintIsExternal: sprintIsExternal,
            peak: true,
            sprints: issueCompletedSprints
        });
        if (sprintNotSet && !sprintIsOptimized) return (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$CompletedSprints, {
            sprintIsExternal: sprintIsExternal,
            peak: true,
            sprints: issueCompletedSprints
        });
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $7xoq8.completedAndUncompletedSprints
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$UncompletedSprint, {
            sprintIsExternal: sprintIsExternal
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$CompletedSprints, {
            sprints: issueCompletedSprints,
            prefix: "+"
        })));
    };
    const $b336ae86f2ed4261$export$80dd06d58b9ee66e = function DisplayLabel({ sprintIsExternal: sprintIsExternal, sprintIsCompleted: sprintIsCompleted, children: children }) {
        if (sprintIsExternal) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $7xoq8.menuLabelDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$ExternalSprint, {
            isCompleted: sprintIsCompleted
        }, children)));
        if (sprintIsCompleted) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $7xoq8.menuLabelDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $boYVS.default).completedSprintsLozenge))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": $b336ae86f2ed4261$var$getTestId(children)
        }, children);
    };
    const $b336ae86f2ed4261$export$dd37bec0e8a99143 = ({ sprintIsExternal: sprintIsExternal, sprintIsCompleted: sprintIsCompleted, label: label, boardName: boardName })=>{
        if (sprintIsExternal) return (0, ($parcel$interopDefault($5uXOq))).createElement($b336ae86f2ed4261$var$ExternalSprintInMenu, {
            isCompleted: sprintIsCompleted,
            boardName: boardName
        }, label);
        if (sprintIsCompleted) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            spread: "space-between",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtlest"
        }, label), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $boYVS.default).completedSprintsLozenge)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": $b336ae86f2ed4261$var$getTestId(label)
        }, label);
    };
    const $b336ae86f2ed4261$var$ExternalSprintInMenu = ({ children: children, isCompleted: isCompleted, boardName: boardName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b336ae86f2ed4261$var$completedLozengeStyles
        }, isCompleted === true && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $boYVS.default).completedSprintsLozenge)))), boardName && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            color: "color.text.subtlest"
        }, boardName));
    const $b336ae86f2ed4261$var$completedLozengeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
});
parcelRegister("7xoq8", function(module, exports) {
    $parcel$export(module.exports, "completedAndUncompletedSprints", ()=>$57ce8ee7cae991b6$export$2f132e32b175f6e6, (v)=>$57ce8ee7cae991b6$export$2f132e32b175f6e6 = v);
    $parcel$export(module.exports, "completedSprintsChunk", ()=>$57ce8ee7cae991b6$export$e509d521b99dedde, (v)=>$57ce8ee7cae991b6$export$e509d521b99dedde = v);
    $parcel$export(module.exports, "externalSprint", ()=>$57ce8ee7cae991b6$export$82eb6504f7db5235, (v)=>$57ce8ee7cae991b6$export$82eb6504f7db5235 = v);
    $parcel$export(module.exports, "externalSprintLozenge", ()=>$57ce8ee7cae991b6$export$657f3f84e37b3aed, (v)=>$57ce8ee7cae991b6$export$657f3f84e37b3aed = v);
    $parcel$export(module.exports, "externalSprintText", ()=>$57ce8ee7cae991b6$export$536a5153d9b87a6b, (v)=>$57ce8ee7cae991b6$export$536a5153d9b87a6b = v);
    $parcel$export(module.exports, "menuLabelDisabled", ()=>$57ce8ee7cae991b6$export$28dc72f63d69649d, (v)=>$57ce8ee7cae991b6$export$28dc72f63d69649d = v);
    $parcel$export(module.exports, "sprintTitle", ()=>$57ce8ee7cae991b6$export$d36673c13d5182d, (v)=>$57ce8ee7cae991b6$export$d36673c13d5182d = v);
    $parcel$export(module.exports, "sprintTitlePrefix", ()=>$57ce8ee7cae991b6$export$c96e006c7c6ab3bd, (v)=>$57ce8ee7cae991b6$export$c96e006c7c6ab3bd = v);
    $parcel$export(module.exports, "tooltip", ()=>$57ce8ee7cae991b6$export$4e6f96734dfe12f4, (v)=>$57ce8ee7cae991b6$export$4e6f96734dfe12f4 = v);
    var $57ce8ee7cae991b6$export$2f132e32b175f6e6;
    var $57ce8ee7cae991b6$export$e509d521b99dedde;
    var $57ce8ee7cae991b6$export$82eb6504f7db5235;
    var $57ce8ee7cae991b6$export$657f3f84e37b3aed;
    var $57ce8ee7cae991b6$export$536a5153d9b87a6b;
    var $57ce8ee7cae991b6$export$28dc72f63d69649d;
    var $57ce8ee7cae991b6$export$d36673c13d5182d;
    var $57ce8ee7cae991b6$export$c96e006c7c6ab3bd;
    var $57ce8ee7cae991b6$export$4e6f96734dfe12f4;
    $57ce8ee7cae991b6$export$2f132e32b175f6e6 = `wtLFHW_completedAndUncompletedSprints`;
    $57ce8ee7cae991b6$export$e509d521b99dedde = `wtLFHW_completedSprintsChunk`;
    $57ce8ee7cae991b6$export$82eb6504f7db5235 = `wtLFHW_externalSprint`;
    $57ce8ee7cae991b6$export$657f3f84e37b3aed = `wtLFHW_externalSprintLozenge`;
    $57ce8ee7cae991b6$export$536a5153d9b87a6b = `wtLFHW_externalSprintText`;
    $57ce8ee7cae991b6$export$28dc72f63d69649d = `wtLFHW_menuLabelDisabled`;
    $57ce8ee7cae991b6$export$d36673c13d5182d = `wtLFHW_sprintTitle`;
    $57ce8ee7cae991b6$export$c96e006c7c6ab3bd = `wtLFHW_sprintTitlePrefix`;
    $57ce8ee7cae991b6$export$4e6f96734dfe12f4 = `wtLFHW_tooltip`;
});
parcelRegister("bqtft", function(module, exports) {
    $parcel$export(module.exports, "tooltip", ()=>$8518cf8d679fc8fe$export$4e6f96734dfe12f4, (v)=>$8518cf8d679fc8fe$export$4e6f96734dfe12f4 = v);
    var $8518cf8d679fc8fe$export$4e6f96734dfe12f4;
    $8518cf8d679fc8fe$export$4e6f96734dfe12f4 = `qWxvNa_tooltip`;
});
const $d0091d9e935603a4$export$b549cc58e415d416 = 'sprint';
parcelRegister("a6ikO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70e67d44ed0567ac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hwwla;
    var $2nRLW = parcelRequire("2nRLW");
    const $70e67d44ed0567ac$var$SprintWireframe = (props)=>{
        const { issue: { optimized: optimized, sprint: sprint }, showOptimizations: showOptimizations, sprints: sprints } = props;
        const sprintId = showOptimizations === true && optimized && optimized.sprint ? optimized.sprint : sprint;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwwla")).default), {
            content: (0, $2nRLW.getSprintName)(sprintId, sprints)
        });
    };
    var $70e67d44ed0567ac$export$2e2bcd8739ae039 = $70e67d44ed0567ac$var$SprintWireframe;
});
parcelRegister("9V09i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9f617bb26a49abb$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6HewK = parcelRequire("6HewK");
    var $30oZV = parcelRequire("30oZV");
    var $7b298 = parcelRequire("7b298");
    var $a9f617bb26a49abb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $30oZV.default), (0, $6HewK.default))((0, $7b298.default));
});
parcelRegister("6HewK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0b3108d3391778c$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $e0b3108d3391778c$export$2e2bcd8739ae039 = (dispatch)=>({
            onChange: (issue, team)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    team: team
                }));
            }
        });
});
parcelRegister("30oZV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5853f5863f855ea4$export$2e2bcd8739ae039);
    var $4sJY8 = parcelRequire("4sJY8");
    var $d3quy = parcelRequire("d3quy");
    var $dRVQG = parcelRequire("dRVQG");
    var $4nDwW = parcelRequire("4nDwW");
    var $5853f5863f855ea4$export$2e2bcd8739ae039 = (state, props)=>({
            teams: (0, $dRVQG.getExistingTeams)(state),
            allTeams: (0, $dRVQG.getAllExistingTeams)(state),
            scenarioRemovedAtlassianTeams: (0, $dRVQG.getScenarioRemovedAtlassianTeams)(state),
            additionalTeamsById: (0, $dRVQG.getAdditionalTeamsById)(state),
            sprintsForTeam: (0, $d3quy.getSprintsForTeam)(state),
            teamRollUpForIssue: (0, $4nDwW.isDefined)((0, $4sJY8.getRollupMap)(state)[props.issue.id]) ? (0, $4sJY8.getRollupMap)(state)[props.issue.id].team : null
        });
});
parcelRegister("7b298", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c738261f9d1bff3b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fWqG2 = parcelRequire("fWqG2");
    var $ujWmd;
    var $1dJ6S;
    var $h8cgU;
    var $lj8SI;
    var $3bDjY;
    var $koVbs;
    var $gJZ5D;
    var $c12LJ;
    var $hwwla;
    var $bChGW;
    var $1FeOe;
    var $l38L3 = parcelRequire("l38L3");
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $3FQWJ = parcelRequire("3FQWJ");
    var $1W6Lb = parcelRequire("1W6Lb");
    var $gn8Pm = parcelRequire("gn8Pm");
    const $c738261f9d1bff3b$var$getTeamName = (teamId, teams)=>{
        if (!(0, $4nDwW.isDefined)(teamId) || !(0, $4nDwW.isDefined)(teams)) return '';
        const team = teams.find((team)=>team.id === teamId);
        if (team !== undefined && team !== null) return team.title;
        return '';
    };
    const $c738261f9d1bff3b$var$getNoTeamAvatar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gn8Pm.defaultTeamAvatarOption
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))), {
            label: "",
            primaryColor: `var(--ds-icon, ${(0, (0, parcelRequire("gJZ5D")).default).N800})`,
            size: "small"
        }));
    const $c738261f9d1bff3b$var$getTeamAvatar = (teamId, teams)=>{
        if (!(0, $4nDwW.isDefined)(teamId) || !(0, $4nDwW.isDefined)(teams)) return $c738261f9d1bff3b$var$getNoTeamAvatar();
        const team = teams.find((team)=>team.id === teamId);
        if (team !== undefined && team !== null && team.avatarUrl) return team.avatarUrl;
        return $c738261f9d1bff3b$var$getNoTeamAvatar();
    };
    const $c738261f9d1bff3b$var$isPlanOnlyTeam = (teamId, teams)=>{
        const team = teams.find((team)=>team.id === teamId);
        if (team !== undefined && team !== null) return !team.shareable;
        return true;
    };
    const $c738261f9d1bff3b$export$409850a8a9c79192 = ({ onChange: onChange, issue: issue })=>(selection)=>{
            if (selection && typeof selection.value === 'string') {
                const newTeamId = selection.value;
                onChange(issue, newTeamId);
            } else onChange(issue, undefined);
        };
    const $c738261f9d1bff3b$export$2ea8e60ef5e5f6ad = ({ showOptimizations: showOptimizations = false, issue: issue, onChange: onChange, CellSelectWithRollup: CellSelectWithRollup, isScrolling: isScrolling, teams: teams, allTeams: allTeams, scenarioRemovedAtlassianTeams: scenarioRemovedAtlassianTeams, teamRollUpForIssue: teamRollUpForIssue, isReadOnly: isReadOnly = false, additionalTeamsById: additionalTeamsById })=>{
        const attribute = 'team';
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleSelection = $c738261f9d1bff3b$export$409850a8a9c79192({
            onChange: onChange,
            issue: issue
        });
        const isAdditionalTeam = (teamId)=>!(0, ($parcel$interopDefault($fWqG2)))((additionalTeamsById || {})[teamId]) || scenarioRemovedAtlassianTeams.filter((team)=>team.id === teamId).length > 0;
        const getSingleValue = ({ children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).SingleValue, rest, children);
        const getTeamOptionLabelWithLozenge = (label, icon, teamType)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: !icon ? $gn8Pm.optionNoAvatarWrapper : $gn8Pm.optionWrapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: !icon ? '' : $gn8Pm.externalValueWrapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gn8Pm.teamAvatarItem
            }, !icon ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gn8Pm.defaultTeamAvatarValue
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))), {
                label: "",
                primaryColor: `var(--ds-icon, ${(0, (0, parcelRequire("gJZ5D")).default).N800})`,
                size: "small"
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "small",
                src: icon
            }), label)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gn8Pm.externalLozenge,
                onFocus: ()=>{},
                onMouseOver: (e)=>e.stopPropagation()
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $gn8Pm.tooltip
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                    as: "h4",
                    size: "small"
                }, formatMessage(teamType === 'external' ? (0, (0, parcelRequire("1FeOe")).default).externalTeamTooltipTitle : (0, (0, parcelRequire("1FeOe")).default).planOnlyTeamTooltipTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage(teamType === 'external' ? (0, (0, parcelRequire("1FeOe")).default).externalTeamTooltipContent : (0, (0, parcelRequire("1FeOe")).default).planOnlyTeamTooltipContent)))
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, formatMessage(teamType === 'external' ? (0, (0, parcelRequire("1FeOe")).default).externalLozengeShort : (0, (0, parcelRequire("1FeOe")).default).planOnlyLozenge)))));
        const formatOptionLabel = (opt, { context: context })=>{
            if (context === 'value') {
                if (opt.isExternalTeam) return getTeamOptionLabelWithLozenge(opt.label, opt.icon, 'external');
                if (opt.isPlanOnlyTeam) return getTeamOptionLabelWithLozenge(opt.label, opt.icon, 'planOnly');
                if (!opt.icon) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $gn8Pm.teamAvatarItem
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $gn8Pm.defaultTeamAvatarValue
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))), {
                    label: "",
                    primaryColor: `var(--ds-icon, ${(0, (0, parcelRequire("gJZ5D")).default).N800})`,
                    size: "small"
                })), opt.label));
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $gn8Pm.teamAvatarItem
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    size: "small",
                    src: opt.icon
                }), opt.label));
            }
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gn8Pm.selectOption
            }, !opt.icon ? $c738261f9d1bff3b$var$getNoTeamAvatar() : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gn8Pm.avatar
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "small",
                src: opt.icon
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gn8Pm.label
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $gn8Pm.truncated
            }, opt.label))));
        };
        const select = ()=>{
            const { level: level, summary: summary, team: team } = issue;
            const options = teams.map(({ id: id, title: title, avatarUrl: avatarUrl })=>({
                    value: id,
                    label: title,
                    icon: avatarUrl,
                    isPlanOnlyTeam: $c738261f9d1bff3b$var$isPlanOnlyTeam(id, allTeams)
                }));
            let id = team;
            if (showOptimizations === true) id = (0, $l38L3.getOptimizedValue)(issue, attribute);
            let value = options.find((option)=>option.value === id);
            if (!value && id !== null && id !== undefined) value = {
                icon: $c738261f9d1bff3b$var$getTeamAvatar(id, allTeams.concat(scenarioRemovedAtlassianTeams)),
                label: $c738261f9d1bff3b$var$getTeamName(id, allTeams.concat(scenarioRemovedAtlassianTeams)),
                value: id,
                isExternalTeam: isAdditionalTeam(id || '')
            };
            const isIssueASubtask = level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL);
            const isSelectReadOnly = isIssueASubtask || isReadOnly;
            const allTeamsById = Object.fromEntries(allTeams.concat(scenarioRemovedAtlassianTeams).map((t)=>[
                    t.id,
                    t
                ]));
            const rolledUpValues = (teamRollUpForIssue || []).reduce((values, t)=>{
                if (allTeamsById[t]) values.push(allTeamsById[t].title);
                return values;
            }, []).sort((a, b)=>a.localeCompare(b));
            return (0, ($parcel$interopDefault($5uXOq))).createElement(CellSelectWithRollup, {
                "aria-label": formatMessage({
                    ...(0, $1W6Lb.default).teamSelectorLabel
                }, {
                    issue: summary
                }),
                attribute: attribute,
                components: {
                    SingleValue: getSingleValue
                },
                formatOptionLabel: (opt, value)=>formatOptionLabel(opt, value),
                isClearable: true,
                isDisabled: isSelectReadOnly,
                issueId: issue.id,
                onChange: (selection)=>handleSelection(selection),
                options: options,
                placeholder: formatMessage((0, $1W6Lb.default).placeholder),
                rolledUpValues: rolledUpValues,
                value: value === undefined ? null : value
            });
        };
        const selectWithTooltip = ()=>{
            const tooltipContent = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gn8Pm.tooltip
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                as: "h4",
                size: "small"
            }, formatMessage((0, $1W6Lb.default).issueIsSubtaskHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $1W6Lb.default).issueIsSubtaskContent)));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: tooltipContent
            }, select());
        };
        const component = ()=>{
            const { level: level } = issue;
            const mapTeamIdToTitle = (_, value)=>$c738261f9d1bff3b$var$getTeamName(value, allTeams.concat(scenarioRemovedAtlassianTeams));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
                attribute: attribute,
                issue: issue,
                valueMapper: mapTeamIdToTitle,
                isScrolling: isScrolling,
                showOptimizations: showOptimizations
            }, level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL) ? selectWithTooltip() : select());
        };
        const wireframe = ()=>{
            const { optimized: optimized } = issue;
            const team = showOptimizations === true && optimized && optimized.team ? optimized.team : issue.team;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwwla")).default), {
                content: $c738261f9d1bff3b$var$getTeamName(team, allTeams.concat(scenarioRemovedAtlassianTeams)),
                isReadOnly: showOptimizations
            });
        };
        return isScrolling ? wireframe() : component();
    };
    var $c738261f9d1bff3b$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        CellSelectWithRollup: (0, $ixSW4.slots).CellSelectWithRollup
    })($c738261f9d1bff3b$export$2ea8e60ef5e5f6ad);
});
parcelRegister("fWqG2", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $b9b0f74db222943d$var$func = $lVx1a('isNil', (parcelRequire("hGgHi")), (parcelRequire("bUoRH")));
    $b9b0f74db222943d$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $b9b0f74db222943d$var$func;
});
parcelRegister("h8cgU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
    function $c78cb3eb85357720$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c78cb3eb85357720$var$PeopleIcon = (props)=>$c78cb3eb85357720$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
        }, props, {
            newIcon: $c78cb3eb85357720$var$_peopleGroup.default
        }));
    $c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
    var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;
});
parcelRegister("1FeOe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c55bd7875b5fafe8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c55bd7875b5fafe8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        externalLozengeShort: {
            "id": "portfolio-3-plan-increment-common.external-lozenge-short",
            "defaultMessage": "EXT"
        },
        externalLozenge: {
            "id": "portfolio-3-plan-increment-common.external-lozenge",
            "defaultMessage": "EXTERNAL"
        },
        externalTeamTooltipTitle: {
            "id": "portfolio-3-plan-increment-common.external-team-tooltip-title",
            "defaultMessage": "Team currently not in this plan"
        },
        externalTeamTooltipContent: {
            "id": "portfolio-3-plan-increment-common.external-team-tooltip-content",
            "defaultMessage": "This team isn't included in your plan, but has issues assigned to it."
        },
        planOnlyLozenge: {
            "id": "portfolio-3-plan-increment-common.plan-only-lozenge",
            "defaultMessage": "PLAN-ONLY"
        },
        planOnlyTeamTooltipTitle: {
            "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-title",
            "defaultMessage": "Plan-only team"
        },
        planOnlyTeamTooltipContent: {
            "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-content",
            "defaultMessage": "A plan-only team can only be used within this plan. It won't appear in JQL filters or on your issue screens."
        },
        kanbanLozenge: {
            "id": "portfolio-3-plan-increment-common.kanban-lozenge",
            "defaultMessage": "KANBAN"
        },
        weeksOption: {
            "id": "portfolio-3-plan-increment-common.weeks-option",
            "defaultMessage": "{count} {count, plural, one {week} other {weeks}}"
        },
        externalTeamTooltipContentIssueTermRefresh: {
            "id": "portfolio-3-plan-increment-common.external-team-tooltip-content-issue-term-refresh",
            "defaultMessage": "This team isn't included in your plan, but has issues assigned to it."
        },
        planOnlyTeamTooltipContentIssueTermRefresh: {
            "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-content-issue-term-refresh",
            "defaultMessage": "A plan-only team can only be used within this plan. It won't appear in JQL filters or on your issue screens."
        }
    });
});
parcelRegister("1W6Lb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80479d4abc649c6f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $80479d4abc649c6f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.placeholder",
            "defaultMessage": "Choose a team"
        },
        teamSelectorLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.team-selector-label",
            "defaultMessage": "Choose team for issue {issue}"
        },
        issueIsSubtaskHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.issue-is-subtask-header",
            "defaultMessage": "Cannot change the team of sub-tasks"
        },
        issueIsSubtaskContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.issue-is-subtask-content",
            "defaultMessage": "A sub-task is assigned to the same team as its parent story. To change this team, reassign the parent story instead."
        },
        externalTeamTooltipTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.external-team-tooltip-title",
            "defaultMessage": "Team currently not in this plan"
        },
        externalTeamTooltipContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.external-team-tooltip-content",
            "defaultMessage": "While this team isn't in this plan, it's appearing because it's assigned to issues in the plan."
        }
    });
});
parcelRegister("gn8Pm", function(module, exports) {
    $parcel$export(module.exports, "avatar", ()=>$beb5a4424095aaca$export$345c5736c8054f22, (v)=>$beb5a4424095aaca$export$345c5736c8054f22 = v);
    $parcel$export(module.exports, "defaultTeamAvatarOption", ()=>$beb5a4424095aaca$export$18910258f760a2fd, (v)=>$beb5a4424095aaca$export$18910258f760a2fd = v);
    $parcel$export(module.exports, "defaultTeamAvatarValue", ()=>$beb5a4424095aaca$export$ca1b754e4b55ac4c, (v)=>$beb5a4424095aaca$export$ca1b754e4b55ac4c = v);
    $parcel$export(module.exports, "externalLozenge", ()=>$beb5a4424095aaca$export$b23bb0784f4cf7e6, (v)=>$beb5a4424095aaca$export$b23bb0784f4cf7e6 = v);
    $parcel$export(module.exports, "externalValueWrapper", ()=>$beb5a4424095aaca$export$5c84e7cc2d29d1d1, (v)=>$beb5a4424095aaca$export$5c84e7cc2d29d1d1 = v);
    $parcel$export(module.exports, "label", ()=>$beb5a4424095aaca$export$1237798dc640739a, (v)=>$beb5a4424095aaca$export$1237798dc640739a = v);
    $parcel$export(module.exports, "optionNoAvatarWrapper", ()=>$beb5a4424095aaca$export$f0d4e5c24c029a5d, (v)=>$beb5a4424095aaca$export$f0d4e5c24c029a5d = v);
    $parcel$export(module.exports, "optionWrapper", ()=>$beb5a4424095aaca$export$9651f3c45da8432f, (v)=>$beb5a4424095aaca$export$9651f3c45da8432f = v);
    $parcel$export(module.exports, "selectOption", ()=>$beb5a4424095aaca$export$f6a817e077493ad8, (v)=>$beb5a4424095aaca$export$f6a817e077493ad8 = v);
    $parcel$export(module.exports, "teamAvatarItem", ()=>$beb5a4424095aaca$export$a15af679b64a13e5, (v)=>$beb5a4424095aaca$export$a15af679b64a13e5 = v);
    $parcel$export(module.exports, "tooltip", ()=>$beb5a4424095aaca$export$4e6f96734dfe12f4, (v)=>$beb5a4424095aaca$export$4e6f96734dfe12f4 = v);
    $parcel$export(module.exports, "truncated", ()=>$beb5a4424095aaca$export$23ef198012fb7186, (v)=>$beb5a4424095aaca$export$23ef198012fb7186 = v);
    var $beb5a4424095aaca$export$345c5736c8054f22;
    var $beb5a4424095aaca$export$18910258f760a2fd;
    var $beb5a4424095aaca$export$ca1b754e4b55ac4c;
    var $beb5a4424095aaca$export$5f60c64a1fd5f53e;
    var $beb5a4424095aaca$export$b23bb0784f4cf7e6;
    var $beb5a4424095aaca$export$5c84e7cc2d29d1d1;
    var $beb5a4424095aaca$export$1237798dc640739a;
    var $beb5a4424095aaca$export$f0d4e5c24c029a5d;
    var $beb5a4424095aaca$export$9651f3c45da8432f;
    var $beb5a4424095aaca$export$f6a817e077493ad8;
    var $beb5a4424095aaca$export$a15af679b64a13e5;
    var $beb5a4424095aaca$export$d21dcf0dd9430234;
    var $beb5a4424095aaca$export$9f98a8d796affec6;
    var $beb5a4424095aaca$export$4e6f96734dfe12f4;
    var $beb5a4424095aaca$export$23ef198012fb7186;
    $beb5a4424095aaca$export$345c5736c8054f22 = `sMSUOa_avatar`;
    $beb5a4424095aaca$export$18910258f760a2fd = `sMSUOa_defaultTeamAvatarOption`;
    $beb5a4424095aaca$export$ca1b754e4b55ac4c = `sMSUOa_defaultTeamAvatarValue`;
    $beb5a4424095aaca$export$5f60c64a1fd5f53e = `sMSUOa_dropdownArrow`;
    $beb5a4424095aaca$export$b23bb0784f4cf7e6 = `sMSUOa_externalLozenge`;
    $beb5a4424095aaca$export$5c84e7cc2d29d1d1 = `sMSUOa_externalValueWrapper`;
    $beb5a4424095aaca$export$1237798dc640739a = `sMSUOa_label`;
    $beb5a4424095aaca$export$f0d4e5c24c029a5d = `sMSUOa_optionNoAvatarWrapper`;
    $beb5a4424095aaca$export$9651f3c45da8432f = `sMSUOa_optionWrapper`;
    $beb5a4424095aaca$export$f6a817e077493ad8 = `sMSUOa_selectOption`;
    $beb5a4424095aaca$export$a15af679b64a13e5 = `sMSUOa_teamAvatarItem`;
    $beb5a4424095aaca$export$d21dcf0dd9430234 = `sMSUOa_teamDropdown`;
    $beb5a4424095aaca$export$9f98a8d796affec6 = `sMSUOa_teamName`;
    $beb5a4424095aaca$export$4e6f96734dfe12f4 = `sMSUOa_tooltip`;
    $beb5a4424095aaca$export$23ef198012fb7186 = `sMSUOa_truncated`;
});
parcelRegister("iPNKh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cdc58ee5a2d9758$export$2e2bcd8739ae039);
    var $bC2fB;
    var $23iAg = parcelRequire("23iAg");
    var $6BRON = parcelRequire("6BRON");
    var $5cdc58ee5a2d9758$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $23iAg.default), {})((0, $6BRON.default));
});
parcelRegister("23iAg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb7c2211206474fb$export$2e2bcd8739ae039);
    var $jpgxP = parcelRequire("jpgxP");
    const $fb7c2211206474fb$var$mapStateToProps = (state)=>({
            hasAtlasPermissions: (0, $jpgxP.getHasAtlasPermissions)(state)
        });
    var $fb7c2211206474fb$export$2e2bcd8739ae039 = $fb7c2211206474fb$var$mapStateToProps;
});
parcelRegister("6BRON", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eec8043a4349aa8f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $42CjB;
    var $2Yv61;
    var $6yUsV;
    var $e4yMr;
    var $1I7E8;
    var $dC5iT;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $kTK0a;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $14XJw;
    var $koeKL;
    var $cNd4s;
    var $eaMwL;
    var $lVJAU;
    var $16Pc7 = parcelRequire("16Pc7");
    const $eec8043a4349aa8f$export$e59ed38172d21b64 = ({ isOrgAdmin: isOrgAdmin = false, orgId: orgId, defaultCloudId: defaultCloudId })=>{
        const adminHubUrl = (0, (0, parcelRequire("kTK0a")).getATLContextDomain)('admin');
        const jiraConnectExpandUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('team')}/your-work?startTrialProduct=townsquare&edition=free&sourceContext=atlas-jira-connect&targetTab=same`;
        const nonAdminRedirect = `${jiraConnectExpandUrl}&startTrialCloudId=${defaultCloudId}`;
        return isOrgAdmin && orgId && defaultCloudId ? `${adminHubUrl}/o/${orgId}/townsquare?cloudId=${defaultCloudId}&isSignup=true` : nonAdminRedirect;
    };
    const $eec8043a4349aa8f$var$GoalHeaderPermissionCheck = ({ hasAtlasPermissions: hasAtlasPermissions, isDefaultOpen: isDefaultOpen = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const atlasURL = `${(0, (0, parcelRequire("eaMwL")).useTeamCentralBaseUrl)()}?cloudId=${(0, (0, parcelRequire("koeKL")).useCloudId)()}`;
        const onClickStopPropagation = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
        }, []);
        const redirectionLink = (0, $5uXOq.useMemo)(()=>$eec8043a4349aa8f$export$e59ed38172d21b64({
                isOrgAdmin: isOrgAdmin,
                orgId: orgId,
                defaultCloudId: cloudId
            }), [
            cloudId,
            isOrgAdmin,
            orgId
        ]);
        const onClickLink = (0, $5uXOq.useCallback)((_event, analyticEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticEvent, 'jpo-request-atlas');
            if (!(0, (0, parcelRequire("4R6GH")).fg)('plans_fields_header_goals_404')) push(atlasURL);
        }, [
            atlasURL,
            push
        ]);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isDefaultOpen);
        if (!hasAtlasPermissions) return (0, (0, parcelRequire("4R6GH")).fg)('plans_fields_header_goals_404') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $eec8043a4349aa8f$var$boxStyles,
            onClick: onClickStopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-start",
            label: formatMessage((0, $16Pc7.default).permissionCheckPlatformGoalsTooltip),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                    space: "space.050",
                    xcss: $eec8043a4349aa8f$var$contentStyles
                }, formatMessage((0, $16Pc7.default).permissionCheckPlatformGoalsLink, {
                    link: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                            href: redirectionLink,
                            onClick: onClickLink
                        }, chunks),
                    p: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, chunks)
                })),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    label: formatMessage((0, $16Pc7.default).permissionCheckPlatformGoalsTooltip),
                    icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2Yv61"))))), {
                            ...iconProps,
                            color: "var(--ds-icon-discovery, #8270DB)"
                        }),
                    appearance: "subtle",
                    spacing: "compact",
                    isSelected: isOpen,
                    isTooltipDisabled: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    ...triggerProps
                })
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $eec8043a4349aa8f$var$boxStylesLegacy,
            onClick: onClickStopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6yUsV")).default), {
            appearance: "info"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            spacing: "none",
            onClick: onClickLink
        }, formatMessage((0, $16Pc7.default).permissionCheckLink))));
        return null;
    };
    const $eec8043a4349aa8f$var$boxStylesLegacy = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
    const $eec8043a4349aa8f$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.050'
    });
    const $eec8043a4349aa8f$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.200'
    });
    var $eec8043a4349aa8f$export$2e2bcd8739ae039 = $eec8043a4349aa8f$var$GoalHeaderPermissionCheck;
});
parcelRegister("6yUsV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2c43b93305034f0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fVnbM;
    var $ctg8C;
    var $f5TWP;
    var $cgL5K;
    var $60LNO;
    function $e2c43b93305034f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e2c43b93305034f0$var$rootStyles = {
        name: "ssyr0c",
        styles: "display:inline-block;max-width:100%;&:focus{outline:1px solid;}&:hover{[data-ds--inline-message--icon]{color:var(--icon-accent-color);}[data-ds--inline-message--button]{text-decoration:underline;}}"
    };
    const $e2c43b93305034f0$var$iconColor = (appearance)=>{
        switch(appearance){
            case 'connectivity':
                return `var(--ds-icon-brand, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
            case 'confirmation':
                return `var(--ds-icon-success, ${0, $829f609a65d26a98$export$747d86715d4175de})`;
            case 'info':
                return `var(--ds-icon-discovery, ${0, $829f609a65d26a98$export$a7175d4e9206bc80})`;
            case 'warning':
                return `var(--ds-icon-warning, ${0, $829f609a65d26a98$export$5aae31392d72caaa})`;
            case 'error':
                return `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$4a7404f376229999})`;
        }
    };
    const $e2c43b93305034f0$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const toggleDialog = (0, $5uXOq.useCallback)(()=>{
            setIsOpen((oldState)=>!oldState);
        }, [
            setIsOpen
        ]);
        const onCloseDialog = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
            setIsOpen
        ]);
        if (!appearance) appearance = type;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $e2c43b93305034f0$var$rootStyles,
            style: {
                '--icon-accent-color': $e2c43b93305034f0$var$iconColor(appearance)
            },
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ctg8C")).default), {
            onClose: onCloseDialog,
            content: children,
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--inline-dialog`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            "data-ds--inline-message--button": true,
            appearance: "subtle-link",
            onClick: toggleDialog,
            spacing: "none",
            testId: testId && `${testId}--button`,
            "aria-expanded": isOpen
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("60LNO")).default), {
            isOpen: isOpen,
            appearance: appearance,
            label: iconLabel
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100"
        }, title && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            testId: testId && `${testId}--title`
        }, title), secondaryText && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            color: "color.text.subtlest",
            maxLines: 1,
            testId: testId && `${testId}--text`
        }, secondaryText))))));
    };
    var $e2c43b93305034f0$export$2e2bcd8739ae039 = $e2c43b93305034f0$var$InlineMessage;
});
parcelRegister("60LNO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$474777c4d72d6c07$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $jfSgx;
    function $474777c4d72d6c07$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $474777c4d72d6c07$var$iconColor = (appearance)=>{
        switch(appearance){
            case 'connectivity':
                return `var(--ds-icon-brand, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
            case 'confirmation':
                return `var(--ds-icon-success, ${0, $829f609a65d26a98$export$940e1f69e873f202})`;
            case 'info':
                return `var(--ds-icon-discovery, ${0, $829f609a65d26a98$export$b48405b95304b5a1})`;
            case 'warning':
                return `var(--ds-icon-warning, ${0, $829f609a65d26a98$export$c6930421db9fa514})`;
            case 'error':
                return `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
        }
    };
    const $474777c4d72d6c07$var$iconWrapperStyles = {
        name: "kw6wgo",
        styles: "display:flex;align-items:center;flex:0 0 auto;color:var(--icon-color)"
    };
    const $474777c4d72d6c07$var$iconColorStyles = {
        name: "1iy94md",
        styles: "color:var(--icon-accent-color)"
    };
    const $474777c4d72d6c07$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
        const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, (0, parcelRequire("jfSgx")).typesMapping);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-ds--inline-message--icon": true,
            style: {
                '--icon-color': $474777c4d72d6c07$var$iconColor(appearance)
            },
            css: [
                $474777c4d72d6c07$var$iconWrapperStyles,
                isOpen && $474777c4d72d6c07$var$iconColorStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious"
        }));
    };
    var $474777c4d72d6c07$export$2e2bcd8739ae039 = $474777c4d72d6c07$var$SelectedIcon;
});
parcelRegister("jfSgx", function(module, exports) {
    $parcel$export(module.exports, "typesMapping", ()=>$e3da74fa628ddd87$export$4d111645c0b39d5d);
    var $dD7Zc;
    var $1jWct;
    var $c2i4s;
    var $bU3PY;
    const $e3da74fa628ddd87$export$4d111645c0b39d5d = {
        connectivity: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))),
            defaultLabel: 'connectivity inline message'
        },
        confirmation: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("c2i4s"))))),
            defaultLabel: 'confirmation inline message'
        },
        info: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("1jWct"))))),
            defaultLabel: 'info inline message'
        },
        warning: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))),
            defaultLabel: 'warning inline message'
        },
        error: {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))),
            defaultLabel: 'error inline message'
        }
    };
});
parcelRegister("1jWct", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));
    var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
    function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0f64b62884a9bedb$var$InformationIcon = (props)=>$0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
            LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
        }, props));
    $0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
    var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;
});
parcelRegister("c2i4s", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));
    var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
    function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8c33b074f80a91d5$var$SuccessIcon = (props)=>$8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
        }, props));
    $8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;
});
parcelRegister("b0JGA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8043220a46fa3485$var$_react = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8043220a46fa3485$var$_UNSAFE_baseNew = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8043220a46fa3485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8043220a46fa3485$var$SuccessIcon = (props)=>$8043220a46fa3485$var$_react.default.createElement($8043220a46fa3485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $8043220a46fa3485$var$SuccessIcon.displayName = 'SuccessIcon';
    var $8043220a46fa3485$var$_default = module.exports.default = $8043220a46fa3485$var$SuccessIcon;
});
parcelRegister("eaMwL", function(module, exports) {
    $parcel$export(module.exports, "useTeamCentralUrl", ()=>$e409b0391be08f30$export$12bf0987a96bab08);
    $parcel$export(module.exports, "useTeamCentralBaseUrl", ()=>$e409b0391be08f30$export$b49e0105c58cb761);
    var $2tT7R;
    const $e409b0391be08f30$export$12bf0987a96bab08 = ()=>'/gateway/api/watermelon/graphql';
    const $e409b0391be08f30$export$b49e0105c58cb761 = ()=>{
        const env = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        if (env === 'staging' || env === 'dev' || env === 'local') return 'https://team.stg.atlassian.com';
        return 'https://team.atlassian.com';
    };
});
parcelRegister("16Pc7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$697bdaedd9f7c13f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $697bdaedd9f7c13f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        permissionCheckLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.goals.permission-check-link",
            "defaultMessage": "Request or confirm Atlas access."
        },
        permissionCheckPlatformGoalsTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.goals.permission-check-platform-goals-tooltip",
            "defaultMessage": "Request or confirm goals access"
        },
        permissionCheckPlatformGoalsLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.goals.permission-check-platform-goals-link",
            "defaultMessage": "<p>Looks like you don't have access to goals.</p> <p>You can request access by visiting <link>this link</link></p>"
        }
    });
});
parcelRegister("d3UHJ", function(module, exports) {
    $parcel$export(module.exports, "getMatchingConfiguredDate", ()=>$708e87ece59316a5$export$66903243edd3e113);
    $parcel$export(module.exports, "getDefaultWidth", ()=>$708e87ece59316a5$export$ad27d04e3788b5e6);
    $parcel$export(module.exports, "getMinWidth", ()=>$708e87ece59316a5$export$f556054ce4358701);
    var $3J2mc;
    var $edp6D;
    var $7lpPk = parcelRequire("7lpPk");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $708e87ece59316a5$export$66903243edd3e113 = ({ baselineStartField: baselineStartField, baselineEndField: baselineEndField })=>(id)=>{
            if (!id) return;
            if (baselineStartField && baselineStartField.key === id) return (0, (0, parcelRequire("edp6D")).ConfigurableDateTypes).start;
            if (baselineEndField && baselineEndField.key === id) return (0, (0, parcelRequire("edp6D")).ConfigurableDateTypes).end;
        };
    const $708e87ece59316a5$export$ad27d04e3788b5e6 = (id, viewMode)=>{
        const defaultWidthOfColumn = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE ? (0, $7lpPk.defaultWidthOfColumnTimeline) : (0, $7lpPk.defaultWidthOfColumnList);
        const columnId = id ?? 'DEFAULT';
        const columnWidth = defaultWidthOfColumn[columnId];
        return columnWidth ?? defaultWidthOfColumn.DEFAULT;
    };
    const $708e87ece59316a5$export$f556054ce4358701 = (id, isCollapsible, viewMode)=>{
        if (isCollapsible) return 24;
        if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE) return (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM;
        return $708e87ece59316a5$export$ad27d04e3788b5e6(id, viewMode);
    };
});
parcelRegister("cxHuX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9bae38794c9ea546$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hFSJA = parcelRequire("hFSJA");
    var $3ihLV = parcelRequire("3ihLV");
    var $9bae38794c9ea546$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hFSJA.default), {})((0, $3ihLV.default));
});
parcelRegister("hFSJA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6a084f5fa12794c$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $3YtPS = parcelRequire("3YtPS");
    const $c6a084f5fa12794c$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        customFieldValue: (state, props)=>(0, $19iju.getSupportedCustomFields)(state).find((field)=>field.id.toString() === props.attribute)
    });
    var $c6a084f5fa12794c$export$2e2bcd8739ae039 = $c6a084f5fa12794c$var$querySelector;
});
parcelRegister("3ihLV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba6adc1490b883fb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JlG5;
    var $4R6GH;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $3FQWJ = parcelRequire("3FQWJ");
    var $fxHdf = parcelRequire("fxHdf");
    var $8YVmh = parcelRequire("8YVmh");
    var $afDaB = parcelRequire("afDaB");
    var $bwQtB = parcelRequire("bwQtB");
    var $gIKc3 = parcelRequire("gIKc3");
    var $5SoGZ = parcelRequire("5SoGZ");
    var $l8Et2 = parcelRequire("l8Et2");
    var $jOQ7g = parcelRequire("jOQ7g");
    var $jOodz = parcelRequire("jOodz");
    const $ba6adc1490b883fb$export$9639a5943929d469 = (props)=>{
        const { attribute: attribute, customFieldValue: customFieldValue, isReadOnly: isReadOnly, isScrolling: isScrolling, issue: issue, showOptimizations: showOptimizations = false, TextRenderer: TextRenderer = (0, $5SoGZ.default) } = props;
        if (!customFieldValue) return null;
        if ((0, $jOodz.shouldCustomFieldBeDisabledForScopedIssue)(customFieldValue, issue.type, issue.project)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8YVmh.default), {
            customField: customFieldValue,
            ...props
        });
        const customFieldType = customFieldValue.type.key;
        const content = (()=>{
            switch(customFieldType){
                case (0, $TTKUQ.CustomFieldTypes).TextField:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(TextRenderer, {
                        attribute: attribute,
                        issue: issue,
                        isReadOnly: isReadOnly
                    });
                case (0, $TTKUQ.CustomFieldTypes).SingleSelect:
                case (0, $TTKUQ.CustomFieldTypes).RadioButtons:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $gIKc3.default), props);
                case (0, $TTKUQ.CustomFieldTypes).Labels:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $afDaB.LabelRenderer), {
                        ...props,
                        useValueAsLabel: true
                    });
                case (0, $TTKUQ.CustomFieldTypes).MultiSelect:
                case (0, $TTKUQ.CustomFieldTypes).MultiCheckboxes:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $afDaB.default), props);
                case (0, $TTKUQ.CustomFieldTypes).NumberField:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bwQtB.default), {
                        attribute: attribute,
                        issue: issue,
                        isReadOnly: isReadOnly
                    });
                case (0, $TTKUQ.CustomFieldTypes).DatePicker:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fxHdf.default), props);
                case (0, $TTKUQ.CustomFieldTypes).UserPicker:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jOQ7g.default), {
                        attribute: attribute,
                        isReadOnly: isReadOnly,
                        issue: issue,
                        isScrolling: isScrolling
                    });
                case (0, $TTKUQ.CustomFieldTypes).Url:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $l8Et2.default), props);
                case (0, $TTKUQ.CustomFieldTypes).AssetObject:
                    if ((0, (0, parcelRequire("4R6GH")).fg)('asset-custom-field-internal-support')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $afDaB.default), props);
                    return null;
                default:
                    return null;
            }
        })();
        const isCellDirty = ()=>{
            const fieldId = attribute;
            if (issue.originals && issue.originals.customFields) return issue.originals.customFields && (0, parcelRequire("2JlG5")).default(fieldId, issue.originals.customFields);
            return false;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3FQWJ.default), {
            attribute: "customFields",
            issue: issue,
            isScrolling: false,
            showOptimizations: showOptimizations,
            isCellDirty: isCellDirty
        }, content);
    };
    var $ba6adc1490b883fb$export$2e2bcd8739ae039 = $ba6adc1490b883fb$export$9639a5943929d469;
});
parcelRegister("fxHdf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98bb65f2d1ea32fc$export$2e2bcd8739ae039);
    var $bC2fB;
    var $19YGy = parcelRequire("19YGy");
    var $gzRsD = parcelRequire("gzRsD");
    var $98bb65f2d1ea32fc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $19YGy.default))((0, $gzRsD.default));
});
parcelRegister("19YGy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2bf5d398851bed7e$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $2bf5d398851bed7e$var$dispatchMethods = (dispatch)=>({
            onChange: (issue, customFieldId, customFieldValue)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    customFields: {
                        [customFieldId]: customFieldValue
                    }
                }));
            }
        });
    var $2bf5d398851bed7e$export$2e2bcd8739ae039 = $2bf5d398851bed7e$var$dispatchMethods;
});
parcelRegister("gzRsD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2da449060585a4e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gh61P;
    var $aipk9;
    var $flnZx;
    var $iwfmd;
    var $ixSW4 = parcelRequire("ixSW4");
    var $1kwGc = parcelRequire("1kwGc");
    var $FQev6 = parcelRequire("FQev6");
    const $a2da449060585a4e$export$4edff4fd0399ce6e = ({ attribute: attribute, onChange: onChange, issue: issue })=>(date)=>{
            if (date === '') return onChange(issue, attribute, undefined);
            if (!(0, (0, parcelRequire("flnZx")).isISOCompatible)(date)) return;
            const dateUTC = new Date(date).getTime();
            onChange(issue, attribute, dateUTC || undefined);
        };
    const $a2da449060585a4e$export$5109c6dd95d8fb00 = ({ attribute: attribute, isReadOnly: isReadOnly, issue: issue, DatePicker: DatePicker, onChange: onChange })=>{
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const value = issue.customFields && issue.customFields[attribute];
        const dateValue = value ? (0, (0, parcelRequire("aipk9")).formatDateUTC)(parseFloat(value), (0, (0, parcelRequire("gh61P")).IsoDateFormat)) : '';
        const handleOnChange = $a2da449060585a4e$export$4edff4fd0399ce6e({
            attribute: attribute,
            issue: issue,
            onChange: onChange
        });
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: isReadOnly ? $FQev6.isReadOnly : ''
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
            onHoverChanged: setIsHovered
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(DatePicker, {
            isDisabled: isReadOnly,
            onChange: handleOnChange,
            placeholder: formatMessage((0, $1kwGc.default).placeholder),
            styles: {
                placeholder: (styles)=>({
                        display: !isHovered && 'none',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        width: 'calc(100% - 9px)',
                        ...styles
                    })
            },
            showClearIndicator: true,
            value: dateValue
        }))));
    };
    var $a2da449060585a4e$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        DatePicker: (0, $ixSW4.slots).FieldDatePicker
    })($a2da449060585a4e$export$5109c6dd95d8fb00);
});
parcelRegister("1kwGc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3cf38daed6905457$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3cf38daed6905457$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.date-picker.placeholder",
            "defaultMessage": "Choose a date"
        }
    });
});
parcelRegister("FQev6", function(module, exports) {
    $parcel$export(module.exports, "isReadOnly", ()=>$07dc58cffa173b57$export$2498094d90b6ac72, (v)=>$07dc58cffa173b57$export$2498094d90b6ac72 = v);
    var $07dc58cffa173b57$export$2498094d90b6ac72;
    $07dc58cffa173b57$export$2498094d90b6ac72 = `_8h9bCa_isReadOnly`;
});
parcelRegister("8YVmh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$799f0b99dbb20472$export$2e2bcd8739ae039);
    var $bC2fB;
    var $i1rTb = parcelRequire("i1rTb");
    var $iM67L = parcelRequire("iM67L");
    var $799f0b99dbb20472$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $i1rTb.default), {})((0, $iM67L.default));
});
parcelRegister("i1rTb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ea4426a8c68d444$export$2e2bcd8739ae039);
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $4nDwW = parcelRequire("4nDwW");
    const $3ea4426a8c68d444$export$6919d4cc2fba73b0 = (customField, issueTypesMapById)=>customField.issueTypeIds ? customField.issueTypeIds.map((id)=>issueTypesMapById[id]?.name).filter((name)=>(0, $4nDwW.isDefined)(name)).join(', ').replace(/,([^,]*)$/, ' &$1') : '';
    const $3ea4426a8c68d444$export$2cd058184eb75757 = (customField, projectMapById)=>{
        if (customField.projectId && projectMapById[customField.projectId]) return projectMapById[customField.projectId].name;
        return '';
    };
    const $3ea4426a8c68d444$var$mapStateToProps = (state, { customField: customField })=>({
            projectName: $3ea4426a8c68d444$export$2cd058184eb75757(customField, (0, $jpXKt.getProjectsById)(state)),
            issueTypeNames: $3ea4426a8c68d444$export$6919d4cc2fba73b0(customField, (0, $kllqP.getIssueTypesById)(state))
        });
    var $3ea4426a8c68d444$export$2e2bcd8739ae039 = $3ea4426a8c68d444$var$mapStateToProps;
});
parcelRegister("iM67L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a8465c313c96b3e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $koVbs;
    var $jjxfN = parcelRequire("jjxfN");
    var $l173H = parcelRequire("l173H");
    const $2a8465c313c96b3e$export$efad39e5eb7ff7a3 = ({ customField: { title: title }, projectName: projectName, issueTypeNames: issueTypeNames })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $jjxfN.default).disabledScopedFieldTooltip, {
                customFieldName: title,
                projectName: projectName,
                issueTypeNames: issueTypeNames
            }))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $l173H.container
        }, formatMessage((0, $jjxfN.default).disabledScopedFieldNa)));
    };
    var $2a8465c313c96b3e$export$2e2bcd8739ae039 = $2a8465c313c96b3e$export$efad39e5eb7ff7a3;
});
parcelRegister("jjxfN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72abfc39408c5818$export$2e2bcd8739ae039);
    var $7VHMR;
    var $72abfc39408c5818$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        disabledScopedFieldTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.disabled-custom-field.disabled-scoped-field-tooltip",
            "defaultMessage": "You can only apply the {customFieldName} custom field from project {projectName} to issue types: {issueTypeNames} in that project."
        },
        disabledScopedFieldNa: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.disabled-custom-field.disabled-scoped-field-na",
            "defaultMessage": "N/A"
        }
    });
});
parcelRegister("l173H", function(module, exports) {
    $parcel$export(module.exports, "container", ()=>$f4cf2aa74e480f7c$export$34e0f9847d4c02dd, (v)=>$f4cf2aa74e480f7c$export$34e0f9847d4c02dd = v);
    var $f4cf2aa74e480f7c$export$34e0f9847d4c02dd;
    $f4cf2aa74e480f7c$export$34e0f9847d4c02dd = `OMlRpG_container`;
});
parcelRegister("afDaB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3347a256255171cd$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "LabelRenderer", ()=>$3347a256255171cd$export$a36612af82a12ac0);
    var $bC2fB;
    var $esaQy = parcelRequire("esaQy");
    var $7b6jY = parcelRequire("7b6jY");
    var $2yRBJ = parcelRequire("2yRBJ");
    var $3347a256255171cd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7b6jY.default), (0, $esaQy.default))((0, $2yRBJ.MultiSelect));
    const $3347a256255171cd$export$a36612af82a12ac0 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7b6jY.default), (0, $esaQy.default))((0, $2yRBJ.Label));
});
parcelRegister("esaQy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$271bfb28abc71de4$export$2e2bcd8739ae039);
    var $24CMK = parcelRequire("24CMK");
    var $bkasS = parcelRequire("bkasS");
    var $271bfb28abc71de4$export$2e2bcd8739ae039 = (dispatch)=>({
            onChange: (issue, customFieldId, options)=>{
                const values = (()=>{
                    if (Array.isArray(options)) return options.map((option)=>option.value);
                    return [];
                })();
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    customFields: {
                        [customFieldId]: values
                    }
                }));
            },
            genericError: (payload)=>{
                dispatch((0, $24CMK.genericError)(payload));
            }
        });
});
parcelRegister("7b6jY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$793293db8fdb33bf$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    const $793293db8fdb33bf$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        selectOptions: (0, $19iju.getSelectOptions),
        plan: (0, $bHTqr.getPlan)
    });
    var $793293db8fdb33bf$export$2e2bcd8739ae039 = $793293db8fdb33bf$var$querySelector;
});
parcelRegister("2yRBJ", function(module, exports) {
    $parcel$export(module.exports, "MultiSelect", ()=>$3700a356e595c41b$export$1e7dfd31545b5809);
    $parcel$export(module.exports, "Label", ()=>$3700a356e595c41b$export$b04be29aa201d4f5);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $ahAj9 = parcelRequire("ahAj9");
    var $1MRtL = parcelRequire("1MRtL");
    var $5yQuY = parcelRequire("5yQuY");
    const $3700a356e595c41b$export$70d2bb9b72984635 = ({ issue: issue, messages: messages, attribute: attribute, isReadOnly: isReadOnly, onChange: onChange, fetchOptions: fetchOptions, useValueAsLabel: useValueAsLabel, selectOptions: selectOptions, MultiSelectCell: MultiSelectCell, menuIsOpen: menuIsOpen })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getDisplayValue = (id)=>{
            if (useValueAsLabel === true) return id;
            const displayValue = selectOptions.find((field)=>field.id.toString() === (id && id.toString()));
            return displayValue?.value || '';
        };
        const getValues = ()=>{
            const values = issue.customFields && issue.customFields[attribute] || [];
            return values.map((value)=>({
                    label: getDisplayValue(value),
                    value: value
                }));
        };
        const formattedMessages = (0, $5uXOq.useMemo)(()=>{
            const result = {};
            for (const [key, v] of Object.entries(messages)){
                const formattedMessage = formatMessage(v);
                result[key] = formattedMessage;
            }
            return result;
        }, [
            messages,
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiSelectCell, {
            menuIsOpen: menuIsOpen,
            attribute: attribute,
            issue: issue,
            isReadOnly: isReadOnly,
            messages: formattedMessages,
            getValues: getValues,
            fetchOptions: (query)=>(0, $4nDwW.isDefined)(fetchOptions) && fetchOptions(attribute, issue.project, issue.type.toString(), query),
            isDisabled: false,
            onChange: (issue, options)=>onChange(issue, attribute, options)
        });
    };
    const $3700a356e595c41b$export$1e7dfd31545b5809 = (0, $5yQuY.OptionsProvider)((0, $ixSW4.withSlots)({
        MultiSelectCell: (0, $ixSW4.slots).FieldMultiSelectCell
    })($3700a356e595c41b$export$70d2bb9b72984635));
    const $3700a356e595c41b$export$a36612af82a12ac0 = (props)=>{
        const { attribute: attribute, issue: issue, fetchOptions: fetchOptions, onChange: onChange } = props;
        const getValues = (issue, attribute)=>{
            const values = issue.customFields && issue.customFields[attribute] || [];
            return values.map((value)=>({
                    label: value,
                    value: value
                }));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ahAj9.default), {
            ...props,
            getValues: getValues,
            fetchOptions: (query)=>{
                if (fetchOptions !== undefined) return fetchOptions(attribute, issue.project, issue.type.toString(), query);
            },
            onChange: (issue, labels)=>onChange(issue, attribute, labels)
        });
    };
    const $3700a356e595c41b$var$LabelComponent = (0, $1MRtL.default)((0, $ixSW4.withSlots)({
        MultiSelectCell: (0, $ixSW4.slots).FieldMultiSelectCell
    })($3700a356e595c41b$export$a36612af82a12ac0));
    const $3700a356e595c41b$export$b04be29aa201d4f5 = $3700a356e595c41b$var$LabelComponent;
});
parcelRegister("1MRtL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b97fd0304bd0dccf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $4R6GH;
    var $hvOzF = parcelRequire("hvOzF");
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $d3xBA = parcelRequire("d3xBA");
    const $b97fd0304bd0dccf$var$messageDescriptors = {
        placeholder: (0, $d3xBA.default).chooseLabel,
        noLabels: (0, $d3xBA.default).noLabels,
        noLabelsLeft: (0, $d3xBA.default).noLabelsLeft,
        noMatch: (0, $d3xBA.default).noMatch
    };
    var $b97fd0304bd0dccf$export$2e2bcd8739ae039 = (ComposedComponent)=>function(props) {
            const fetchOptions = (0, $5uXOq.useCallback)((customFieldId, _, _2, query = '')=>{
                const { plan: plan, genericError: genericError } = props;
                if (!(0, $4nDwW.isDefined)(plan.id)) {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
                        const error = new Error('Plan id is not available in the options provider label');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: (0, $hvOzF.toErrorID)(error, 'Plan id is not available in the options provider label'),
                                packageName: (0, $TTKUQ.PACKAGE_NAME),
                                teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                            },
                            sendToPrivacyUnsafeSplunk: true
                        });
                    } else genericError({
                        message: 'Plan id is not available in the options provider label'
                    });
                    return Promise.reject('Plan id is not available');
                }
                if (!(0, $4nDwW.isDefined)(plan.currentScenarioId)) {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
                        const error = new Error('Scenario id is not available in the options provider label');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: (0, $hvOzF.toErrorID)(error, 'Scenario id is not available in the options provider label'),
                                packageName: (0, $TTKUQ.PACKAGE_NAME),
                                teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                            },
                            sendToPrivacyUnsafeSplunk: true
                        });
                    } else genericError({
                        message: 'Scenario id is not available in the options provider label'
                    });
                    return Promise.reject('Scenario id is not available');
                }
                const body = {
                    planId: plan.id,
                    customFieldId: customFieldId,
                    query: query,
                    scenarioId: plan.currentScenarioId
                };
                return (0, $8DSSe.default)('/rest/jpo/1.0/labels', {
                    method: 'POST',
                    body: body
                }).then((response)=>{
                    if (response.ok) return response.json();
                    throw new Error(`Response not ok. Statuscode: ${response.status}`);
                }).then((data)=>data.items.map((value)=>({
                            label: value,
                            value: value
                        }))).catch((err)=>{
                    if (!(0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) genericError({
                        message: err.message,
                        stackTrace: err.stack
                    });
                    else (0, (0, parcelRequire("jcw0u")).default)({
                        error: err,
                        meta: {
                            id: (0, $hvOzF.toErrorID)(err, 'labels-fetch-failed'),
                            packageName: (0, $TTKUQ.PACKAGE_NAME),
                            teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                });
            }, [
                props
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ComposedComponent, {
                ...props,
                fetchOptions: fetchOptions,
                messages: $b97fd0304bd0dccf$var$messageDescriptors
            });
        };
});
parcelRegister("5yQuY", function(module, exports) {
    $parcel$export(module.exports, "OptionsProvider", ()=>$35b96164c555f478$export$1238f6fc6d9e005a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7ENDR = parcelRequire("7ENDR");
    var $8DSSe = parcelRequire("8DSSe");
    var $jbEQ7 = parcelRequire("jbEQ7");
    const $35b96164c555f478$export$abbf91d37f1b4230 = {
        placeholder: (0, $jbEQ7.default).componentsLabel,
        noLabels: (0, $jbEQ7.default).noLabels,
        noLabelsLeft: (0, $jbEQ7.default).noLabelsLeft,
        noMatch: (0, $jbEQ7.default).noMatch
    };
    const $35b96164c555f478$export$1238f6fc6d9e005a = (ComposedComponent)=>function(props) {
            const fetchOptions = (0, $5uXOq.useCallback)((customFieldId, projectId, issueTypeId)=>(0, $8DSSe.default)((0, $7ENDR.urls).getCustomFieldSettableOptions, {
                    method: 'POST',
                    body: {
                        customFieldId: customFieldId,
                        projectId: projectId,
                        issueTypeId: issueTypeId
                    }
                }).then((response)=>response.json()).then((data)=>data.map(({ id: id, value: value })=>({
                            value: String(id),
                            label: value
                        }))), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ComposedComponent, {
                ...props,
                fetchOptions: fetchOptions,
                messages: $35b96164c555f478$export$abbf91d37f1b4230
            });
        };
});
parcelRegister("7ENDR", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$2b0bcda3d46dd2ff$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "getAddCustomFieldsBody", ()=>$2b0bcda3d46dd2ff$export$8a6e7a2ddfd84e7f);
    $parcel$export(module.exports, "getUpdateCustomFieldsBody", ()=>$2b0bcda3d46dd2ff$export$4eb083e76e90dd2);
    $parcel$export(module.exports, "getLabelForFieldBody", ()=>$2b0bcda3d46dd2ff$export$53875b0a840a0df2);
    $parcel$export(module.exports, "getRemoveCustomFieldBody", ()=>$2b0bcda3d46dd2ff$export$ac79055f4767d6df);
    $parcel$export(module.exports, "getCustomFieldVisibleOptionsBody", ()=>$2b0bcda3d46dd2ff$export$56d9dae1feb647fe);
    $parcel$export(module.exports, "getUserPickerCustomFieldOptionsBody", ()=>$2b0bcda3d46dd2ff$export$6f822a48b243bbd);
    const $2b0bcda3d46dd2ff$export$bcae9ba627f604b6 = {
        addCustomFields: '/rest/jpo/1.0/customfield/add',
        removeCustomField: '/rest/jpo/1.0/customfield/delete',
        getCustomFieldSettableOptions: '/rest/jpo/1.0/customfield/getSettableOptions',
        getCustomFieldVisibleOptions: '/rest/jpo/1.0/customfield/getVisibleOptions',
        getUserPickerCustomFieldOptions: '/rest/teams/1.0/persons/find',
        getDateFields: Object.assign((planId)=>`/rest/jpo/1.0/plans/${planId}/datefields`, {
            endpoint: '/rest/jpo/1.0/plans/:id/datefields'
        }),
        updateCustomField: '/rest/jpo/1.0/customfield/update',
        labels: '/rest/jpo/1.0/labels'
    };
    const $2b0bcda3d46dd2ff$export$8a6e7a2ddfd84e7f = (planId, planCustomFields)=>({
            planId: planId,
            planCustomFields: planCustomFields
        });
    const $2b0bcda3d46dd2ff$export$4eb083e76e90dd2 = $2b0bcda3d46dd2ff$export$8a6e7a2ddfd84e7f;
    const $2b0bcda3d46dd2ff$export$53875b0a840a0df2 = (planId, customFieldId, scenarioId)=>({
            planId: planId,
            customFieldId: `${customFieldId}`,
            ...scenarioId && {
                scenarioId: scenarioId
            }
        });
    const $2b0bcda3d46dd2ff$export$ac79055f4767d6df = (planId, scenarioId, customFieldId)=>({
            planId: planId,
            scenarioId: scenarioId,
            customFieldIds: [
                customFieldId
            ]
        });
    const $2b0bcda3d46dd2ff$export$56d9dae1feb647fe = (customFieldIds, projectIds)=>({
            customFieldIds: customFieldIds,
            projectIds: projectIds
        });
    const $2b0bcda3d46dd2ff$export$6f822a48b243bbd = ({ query: query = '', excludedIds: excludedIds = [], maxResults: maxResults = 50 })=>({
            query: query,
            excludedIds: excludedIds,
            maxResults: maxResults
        });
});
parcelRegister("jbEQ7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df4d786470bd7a5a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $df4d786470bd7a5a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        componentsLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.multi-select.components-label",
            "defaultMessage": "Choose an\xA0option"
        },
        noLabels: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.multi-select.no-labels",
            "defaultMessage": "There are no options for this custom field"
        },
        noLabelsLeft: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.multi-select.no-labels-left",
            "defaultMessage": "No available options left"
        },
        noMatch: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.multi-select.no-match",
            "defaultMessage": "No results match your search"
        }
    });
});
parcelRegister("bwQtB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c08a72d34168c3c3$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5zhqg = parcelRequire("5zhqg");
    var $3EnWn = parcelRequire("3EnWn");
    var $c08a72d34168c3c3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $5zhqg.default))((0, $3EnWn.default));
});
parcelRegister("5zhqg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2eb8a73ac4c66938$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $4nDwW = parcelRequire("4nDwW");
    var $2eb8a73ac4c66938$export$2e2bcd8739ae039 = (dispatch)=>({
            onChange: (issue, customFieldId, value)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    customFields: {
                        [customFieldId]: (0, $4nDwW.isDefined)(value) ? value : undefined
                    }
                }));
            }
        });
});
parcelRegister("3EnWn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3beb6d07dbb9b4b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $2mwnS = parcelRequire("2mwnS");
    const $3beb6d07dbb9b4b4$export$a303e10ced124537 = ({ isReadOnly: isReadOnly, attribute: attribute, onChange: onChange, issue: issue })=>(value)=>{
            if (isReadOnly) return;
            const numberValue = Number(value);
            onChange(issue, attribute, Number.isNaN(numberValue) || !Number.isFinite(numberValue) ? null : numberValue);
        };
    const $3beb6d07dbb9b4b4$export$db41933ce0e4f8c3 = ({ attribute: attribute, issue: issue, onChange: onChange, isReadOnly: isReadOnly, TextField: TextField })=>{
        const [textValue, setTextValue] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (attribute && issue && textValue == null) {
                const customerFieldValue = issue.customFields && issue.customFields[attribute];
                setTextValue({
                    textValue: (0, $4nDwW.isDefined)(customerFieldValue) ? customerFieldValue : ''
                });
            } else setTextValue(null);
        }, [
            attribute,
            issue
        ]);
        const saveValue = $3beb6d07dbb9b4b4$export$a303e10ced124537({
            isReadOnly: isReadOnly,
            attribute: attribute,
            issue: issue,
            onChange: onChange
        });
        const getValue = ()=>{
            const customerFieldValue = issue.customFields && issue.customFields[attribute];
            return (0, $4nDwW.isDefined)(customerFieldValue) ? customerFieldValue : '';
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$2mwnS.textFieldWrapper} ${isReadOnly ? $2mwnS.readOnly : ''}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(TextField, {
            isAlignRight: true,
            isReadOnly: isReadOnly,
            isTransparentBackground: true,
            onDone: saveValue,
            type: "number",
            value: getValue()
        })));
    };
    var $3beb6d07dbb9b4b4$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        TextField: (0, $ixSW4.slots).CellTextField
    })($3beb6d07dbb9b4b4$export$db41933ce0e4f8c3);
});
parcelRegister("2mwnS", function(module, exports) {
    $parcel$export(module.exports, "readOnly", ()=>$1b86c1a2ef309129$export$b2cbc93d4da94977, (v)=>$1b86c1a2ef309129$export$b2cbc93d4da94977 = v);
    $parcel$export(module.exports, "textFieldWrapper", ()=>$1b86c1a2ef309129$export$7910eaff0a3df2fc, (v)=>$1b86c1a2ef309129$export$7910eaff0a3df2fc = v);
    var $1b86c1a2ef309129$export$b2cbc93d4da94977;
    var $1b86c1a2ef309129$export$7910eaff0a3df2fc;
    $1b86c1a2ef309129$export$b2cbc93d4da94977 = `lBMG-a_readOnly`;
    $1b86c1a2ef309129$export$7910eaff0a3df2fc = `lBMG-a_textFieldWrapper`;
});
parcelRegister("gIKc3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f2f725c0cad28a93$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3uZvs = parcelRequire("3uZvs");
    var $km9O6 = parcelRequire("km9O6");
    var $hsbYJ = parcelRequire("hsbYJ");
    var $f2f725c0cad28a93$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $km9O6.default), (0, $3uZvs.default))((0, $hsbYJ.default));
});
parcelRegister("3uZvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97e9b8f3b3d002a6$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $97e9b8f3b3d002a6$var$dispatchMethods = (dispatch)=>({
            onChange: (issue, customFieldId, option)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    customFields: {
                        [customFieldId]: option ? option.value : undefined
                    }
                }));
            }
        });
    var $97e9b8f3b3d002a6$export$2e2bcd8739ae039 = $97e9b8f3b3d002a6$var$dispatchMethods;
});
parcelRegister("km9O6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10f0a59e1438f175$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    const $10f0a59e1438f175$var$mapStateToProps = (state, { issue: issue, attribute: attribute })=>{
        const customFieldId = Number(attribute);
        const attrValue = issue.customFields && issue.customFields[attribute] && Number(issue.customFields[attribute]);
        const selectedOption = (0, $19iju.getSelectOptions)(state).find((option)=>option.fieldId === customFieldId && Number(option.id) === attrValue);
        return {
            selectedOption: selectedOption
        };
    };
    var $10f0a59e1438f175$export$2e2bcd8739ae039 = $10f0a59e1438f175$var$mapStateToProps;
});
parcelRegister("hsbYJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fabdff435d10726$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $ixSW4 = parcelRequire("ixSW4");
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $cSDJf = parcelRequire("cSDJf");
    var $3fGnD = parcelRequire("3fGnD");
    var $9ncen = parcelRequire("9ncen");
    var $gQ6GK = parcelRequire("gQ6GK");
    const $0fabdff435d10726$var$toOption = (data)=>({
            value: String(data.id),
            label: data.value
        });
    const $0fabdff435d10726$export$2cc36d93c89f0c53 = ({ FieldSelect: FieldSelect, isReadOnly: isReadOnly, selectedOption: selectedOption, issue: issue, attribute: attribute, onChange: onChange, fetchOptions: fetchOptions })=>{
        const [options, setOptions] = (0, $5uXOq.useState)([]);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const value = selectedOption && $0fabdff435d10726$var$toOption(selectedOption);
        const handleFetchOptions = ()=>{
            setIsLoading(true);
            fetchOptions(attribute, issue.project, issue.type.toString()).then((data)=>data.map($0fabdff435d10726$var$toOption)).then((options)=>{
                setOptions(options);
                setIsLoading(false);
            });
        };
        const handleSelectionChange = (option)=>{
            onChange(issue, attribute, option);
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: isReadOnly ? $gQ6GK.readOnly : ''
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(FieldSelect, {
            isLoading: isLoading,
            isClearable: (0, $4nDwW.isDefined)(value),
            isDisabled: isReadOnly,
            isSearchable: true,
            isTransparentBackground: true,
            menuPlacement: "auto",
            menuPortalTarget: (0, $4y9A5.getBody)(),
            minSelectWidth: (0, $cSDJf.MIN_SELECT_WIDTH),
            onChange: handleSelectionChange,
            onMenuOpen: handleFetchOptions,
            options: options,
            placeholder: formatMessage((0, $3fGnD.default).placeholder),
            scrollLock: true,
            value: value,
            issueId: issue.id,
            attribute: attribute
        })));
    };
    const $0fabdff435d10726$export$5a85d25d3071ae48 = (0, $9ncen.default)($0fabdff435d10726$export$2cc36d93c89f0c53);
    var $0fabdff435d10726$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        FieldSelect: (0, $ixSW4.slots).FieldSelect
    })($0fabdff435d10726$export$5a85d25d3071ae48);
});
parcelRegister("3fGnD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$668ffd0de0a723b9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $668ffd0de0a723b9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.single-select.placeholder",
            "defaultMessage": "Choose an option"
        }
    });
});
parcelRegister("9ncen", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14d8ef2d496d5c03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7ENDR = parcelRequire("7ENDR");
    var $8DSSe = parcelRequire("8DSSe");
    var $14d8ef2d496d5c03$export$2e2bcd8739ae039 = (ComposedComponent)=>class extends (0, $5uXOq.Component) {
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(ComposedComponent, {
                    ...this.props,
                    fetchOptions: this.fetchOptions
                });
            }
            constructor(...args){
                super(...args);
                this.fetchOptions = (customFieldId, projectId, issueTypeId)=>(0, $8DSSe.default)((0, $7ENDR.urls).getCustomFieldSettableOptions, {
                        method: 'POST',
                        body: {
                            customFieldId: customFieldId,
                            projectId: projectId,
                            issueTypeId: issueTypeId
                        }
                    }).then((response)=>response.json());
            }
        };
});
parcelRegister("gQ6GK", function(module, exports) {
    $parcel$export(module.exports, "readOnly", ()=>$c426b0e24c986ad3$export$b2cbc93d4da94977, (v)=>$c426b0e24c986ad3$export$b2cbc93d4da94977 = v);
    var $c426b0e24c986ad3$export$b2cbc93d4da94977;
    $c426b0e24c986ad3$export$b2cbc93d4da94977 = `Z1ySdG_readOnly`;
});
parcelRegister("5SoGZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$968014d6822d048a$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9CcOi = parcelRequire("9CcOi");
    var $2kwfH = parcelRequire("2kwfH");
    var $968014d6822d048a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $9CcOi.default))((0, $2kwfH.default));
});
parcelRegister("9CcOi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7518d5e5a34686d$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $e7518d5e5a34686d$export$2e2bcd8739ae039 = (dispatch)=>({
            onChange: (issue, customFieldId, customFieldValue)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    customFields: {
                        [customFieldId]: customFieldValue
                    }
                }));
            }
        });
});
parcelRegister("2kwfH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1d0427f345ea52d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ixSW4 = parcelRequire("ixSW4");
    var $7021B = parcelRequire("7021B");
    const $a1d0427f345ea52d$export$cc29b30a97a1a24b = ({ attribute: attribute, isReadOnly: isReadOnly, issue: issue, TextField: TextField, onChange: onChange })=>{
        const handleBlur = (event)=>{
            if (isReadOnly) return;
            if (event.target instanceof HTMLInputElement) onChange(issue, attribute, event.target.value);
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$7021B.textFieldWrapper} ${isReadOnly ? $7021B.readOnly : ''}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(TextField, {
            isReadOnly: isReadOnly,
            isTransparentBackground: true,
            maxLength: 255,
            onBlur: handleBlur,
            type: "text",
            value: issue.customFields && issue.customFields[attribute]
        })));
    };
    var $a1d0427f345ea52d$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        TextField: (0, $ixSW4.slots).CellTextField
    })($a1d0427f345ea52d$export$cc29b30a97a1a24b);
});
parcelRegister("7021B", function(module, exports) {
    $parcel$export(module.exports, "readOnly", ()=>$518a1a958f965b80$export$b2cbc93d4da94977, (v)=>$518a1a958f965b80$export$b2cbc93d4da94977 = v);
    $parcel$export(module.exports, "textFieldWrapper", ()=>$518a1a958f965b80$export$7910eaff0a3df2fc, (v)=>$518a1a958f965b80$export$7910eaff0a3df2fc = v);
    var $518a1a958f965b80$export$b2cbc93d4da94977;
    var $518a1a958f965b80$export$7910eaff0a3df2fc;
    $518a1a958f965b80$export$b2cbc93d4da94977 = `GgqE6a_readOnly`;
    $518a1a958f965b80$export$7910eaff0a3df2fc = `GgqE6a_textFieldWrapper`;
});
parcelRegister("l8Et2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$936a57ac271cc605$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $cUeJS = parcelRequire("cUeJS");
    const $936a57ac271cc605$export$a540001a865aece7 = ({ issue: issue, attribute: attribute })=>{
        const value = issue.customFields && issue.customFields[attribute];
        if (!value) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, value)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $cUeJS.container
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: value,
            target: "_blank",
            rel: "noopener noreferrer"
        }, value)));
    };
    var $936a57ac271cc605$export$2e2bcd8739ae039 = $936a57ac271cc605$export$a540001a865aece7;
});
parcelRegister("cUeJS", function(module, exports) {
    $parcel$export(module.exports, "container", ()=>$965625d8c1832c51$export$34e0f9847d4c02dd, (v)=>$965625d8c1832c51$export$34e0f9847d4c02dd = v);
    var $965625d8c1832c51$export$34e0f9847d4c02dd;
    $965625d8c1832c51$export$34e0f9847d4c02dd = `WjFy1q_container`;
});
parcelRegister("jOQ7g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9d2743f8be040b2$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4mEAn = parcelRequire("4mEAn");
    var $dCXkr = parcelRequire("dCXkr");
    var $b5DuP = parcelRequire("b5DuP");
    var $b9d2743f8be040b2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $dCXkr.default), (0, $4mEAn.default))((0, $b5DuP.default));
});
parcelRegister("4mEAn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af4005f587d91462$export$2e2bcd8739ae039);
    var $bNKh8 = parcelRequire("bNKh8");
    var $bkasS = parcelRequire("bkasS");
    var $4nDwW = parcelRequire("4nDwW");
    var $af4005f587d91462$export$2e2bcd8739ae039 = (dispatch)=>({
            fetchUserList: (query, issueId)=>{
                dispatch((0, $bNKh8.fetchUserPickerOptions)(query || '', issueId || ''));
            },
            onChange: (issue, customFieldId, userId)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)({
                    id: issue.id,
                    customFields: {
                        [customFieldId]: (0, $4nDwW.isDefined)(userId) ? userId : undefined
                    }
                }));
            }
        });
});
parcelRegister("bNKh8", function(module, exports) {
    $parcel$export(module.exports, "addCustomFields", ()=>$541cc792981526ce$export$d0e2ef714a0db3b4);
    $parcel$export(module.exports, "removeCustomField", ()=>$541cc792981526ce$export$4519a1d548472c6f);
    $parcel$export(module.exports, "populateUserPickerOptions", ()=>$541cc792981526ce$export$7004d9a21bcdbd07);
    $parcel$export(module.exports, "fetchUserPickerOptions", ()=>$541cc792981526ce$export$7e0de8c99d98518f);
    $parcel$export(module.exports, "toggleCustomFieldFilterability", ()=>$541cc792981526ce$export$795f830258bd4ea7);
    $parcel$export(module.exports, "doPopulateUserPickerOptions", ()=>$541cc792981526ce$export$4c65256e5a964137);
    $parcel$export(module.exports, "default", ()=>$541cc792981526ce$export$2e2bcd8739ae039);
    parcelRequire("dcevF");
    var $hIYGf = parcelRequire("hIYGf");
    var $2XSIf;
    var $SZGT2;
    var $83IGl;
    var $76p2G;
    var $4Rr1a;
    var $ik0Qc;
    var $fes2p;
    var $2rMKg;
    var $bjzU8;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $4R6GH;
    var $8DSSe = parcelRequire("8DSSe");
    var $gITL8 = parcelRequire("gITL8");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $9174a = parcelRequire("9174a");
    var $19iju = parcelRequire("19iju");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $gFhwb = parcelRequire("gFhwb");
    var $j0XCX = parcelRequire("j0XCX");
    var $waHpx = parcelRequire("waHpx");
    var $1JzSf = parcelRequire("1JzSf");
    var $f7tuF = parcelRequire("f7tuF");
    var $2J7k2 = parcelRequire("2J7k2");
    var $clsih = parcelRequire("clsih");
    var $eiyR0 = parcelRequire("eiyR0");
    var $dBbgF = parcelRequire("dBbgF");
    var $8pJHi = parcelRequire("8pJHi");
    var $3Ujui = parcelRequire("3Ujui");
    var $77QEM = parcelRequire("77QEM");
    var $8qbLi = parcelRequire("8qbLi");
    var $goTVH = parcelRequire("goTVH");
    var $24CMK = parcelRequire("24CMK");
    var $asXbx = parcelRequire("asXbx");
    var $hvOzF = parcelRequire("hvOzF");
    var $7ENDR = parcelRequire("7ENDR");
    const $541cc792981526ce$export$22550c63d1d2e6de = 'command.custom-fields.ADD_CUSTOM_FIELDS';
    const $541cc792981526ce$export$aebce24c838569e9 = 'command.custom-fields.REMOVE_CUSTOM_FIELD';
    const $541cc792981526ce$export$837a9b121c89f72c = 'command.custom-fields.FETCH_SELECT_OPTIONS';
    const $541cc792981526ce$export$26ce9bf8b551812b = 'command.custom-fields.FETCH_USER_PICKER_OPTIONS';
    const $541cc792981526ce$export$2c810c4aa49c0a3b = 'command.custom-fields.FETCH_USER_PICKER_OPTIONS_BY_IDS';
    const $541cc792981526ce$export$97d3a70653e68b71 = 'command.custom-fields.POPULATE_USER_PICKER_OPTIONS';
    const $541cc792981526ce$export$692688de415f3085 = 'command.custom-fields.TOGGLE_CUSTOM_FIELD_FILTERABILITY';
    const $541cc792981526ce$export$d0e2ef714a0db3b4 = (fields, options = {
        skipBackendRequest: false
    })=>({
            type: $541cc792981526ce$export$22550c63d1d2e6de,
            options: options,
            payload: {
                fields: fields
            }
        });
    const $541cc792981526ce$export$4519a1d548472c6f = (id)=>({
            type: $541cc792981526ce$export$aebce24c838569e9,
            payload: {
                id: id
            }
        });
    const $541cc792981526ce$export$8187784a31a97290 = ()=>({
            type: $541cc792981526ce$export$837a9b121c89f72c
        });
    const $541cc792981526ce$export$7004d9a21bcdbd07 = ()=>({
            type: $541cc792981526ce$export$97d3a70653e68b71
        });
    const $541cc792981526ce$export$7e0de8c99d98518f = (query, issueId)=>({
            type: $541cc792981526ce$export$26ce9bf8b551812b,
            payload: {
                query: query,
                issueId: issueId
            }
        });
    const $541cc792981526ce$export$795f830258bd4ea7 = (payload)=>({
            type: $541cc792981526ce$export$692688de415f3085,
            payload: payload
        });
    function $541cc792981526ce$var$getCustomFieldValuesFromIssues(fields, issues) {
        return issues.filter(({ customFields: customFields = {} })=>(0, parcelRequire("76p2G")).default((0, parcelRequire("fes2p")).default(fields.map((field)=>field.id.toString()), customFields)).length > 0).flatMap(({ customFields: customFields = {} })=>(0, parcelRequire("bjzU8")).default((0, parcelRequire("fes2p")).default(fields.map((field)=>field.id.toString()), customFields)));
    }
    const $541cc792981526ce$var$getValuesOfCustomField = (type, customFields, originalIssues, issues)=>{
        const customFieldsWithType = (0, $19iju.getCustomFieldsByKey)(type, customFields);
        const originalIssueOptionIds = $541cc792981526ce$var$getCustomFieldValuesFromIssues(customFieldsWithType, (0, parcelRequire("bjzU8")).default(originalIssues));
        const optionIds = $541cc792981526ce$var$getCustomFieldValuesFromIssues(customFieldsWithType, issues);
        return (0, parcelRequire("SZGT2")).default([
            ...originalIssueOptionIds,
            ...optionIds
        ]);
    };
    function* $541cc792981526ce$export$ef6c57c5ffb83c06({ payload: { ids: ids } }) {
        const users = yield (0, $aNOuE.call)((0, $8qbLi.getUsers), {
            keys: ids || []
        });
        yield (0, $aNOuE.put)((0, $2J7k2.reset)((users || []).map((user)=>({
                value: user.accountId,
                label: user.title,
                icon: user.avatarUrl,
                email: user.email
            }))));
    }
    function* $541cc792981526ce$export$4c65256e5a964137() {
        const customFields = yield (0, $aNOuE.select)((0, $19iju.getCustomFields));
        const originalIssues = yield (0, $aNOuE.select)((0, $bI9dZ.getOriginalIssues));
        const issues = yield (0, $aNOuE.select)((0, $gFhwb.getIssues));
        const userPickerOptions = $541cc792981526ce$var$getValuesOfCustomField((0, $TTKUQ.CustomFieldTypes).UserPicker, customFields, originalIssues, issues);
        if (userPickerOptions.length === 0) return;
        const users = yield (0, $aNOuE.call)((0, $8qbLi.getUsers), {
            keys: userPickerOptions || []
        });
        yield (0, $aNOuE.put)((0, $2J7k2.reset)((users || []).map((user)=>({
                value: user.accountId,
                label: user.title,
                icon: user.avatarUrl,
                email: user.email
            }))));
    }
    function* $541cc792981526ce$export$3cd7dad83cedca62({ payload: { fields: fields }, options: { skipBackendRequest: skipBackendRequest } }) {
        try {
            const state = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
            const { domain: { plan: { id: planId } } } = state;
            if (!planId) return;
            const withFilteringAllowed = fields.map((field)=>({
                    ...field,
                    filteringAllowed: (0, $TTKUQ.CustomFields).FilterableFields.includes(field.type?.key)
                }));
            const wrapCustomFields = (field)=>({
                    customFieldId: field.id,
                    filteringAllowed: field.filteringAllowed
                });
            const body = (0, $7ENDR.getAddCustomFieldsBody)(planId, withFilteringAllowed.map((field)=>wrapCustomFields(field || {})));
            if (!skipBackendRequest) {
                const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $7ENDR.urls).addCustomFields, {
                    method: (0, $77QEM.POST),
                    body: body
                });
                if (!response.ok) {
                    if (!(0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) return yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                        ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                        requestInfo: {
                            url: (0, $7ENDR.urls).addCustomFields,
                            type: (0, $77QEM.POST),
                            status: response.status,
                            body: body
                        }
                    }));
                    const error = new Error(response.text());
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: (0, $hvOzF.toErrorID)(error, 'add-custom-field-fetch-failed'),
                            packageName: (0, $TTKUQ.PACKAGE_NAME),
                            teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
            if (typeof withFilteringAllowed !== 'undefined') yield (0, $aNOuE.put)((0, $waHpx.add)(withFilteringAllowed));
            yield (0, $aNOuE.call)((0, $goTVH.getBacklog));
            yield (0, $aNOuE.put)($541cc792981526ce$export$8187784a31a97290());
            yield (0, $aNOuE.put)($541cc792981526ce$export$7004d9a21bcdbd07());
        } finally{
            yield (0, $aNOuE.put)((0, $eiyR0.reset)({
                customFields: yield (0, $aNOuE.select)((0, $19iju.getCustomFields))
            }));
        }
    }
    function* $541cc792981526ce$export$2f12d93ffddc65e0({ payload: { id: id } }) {
        const state = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId } } } = state;
        if (!planId || !currentScenarioId) return;
        const body = (0, $7ENDR.getRemoveCustomFieldBody)(planId, currentScenarioId, id);
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $7ENDR.urls).removeCustomField, {
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            yield (0, $aNOuE.put)((0, $waHpx.remove)(id));
            const colorByValue = yield (0, $aNOuE.select)((0, $j0XCX.getColorByValue));
            const sorting = yield (0, $aNOuE.select)((0, $j0XCX.getVisualisationSorting));
            if (colorByValue === id.toString()) yield (0, $aNOuE.put)((0, $clsih.setColourByValue)({
                id: (0, $gITL8.colourByOptions).NONE
            }));
            if (sorting.field === id.toString()) yield (0, $aNOuE.put)((0, $dBbgF.changeSort)({
                sorting: (0, $8pJHi.defaultSorting)
            }));
            const grouping = yield (0, $aNOuE.select)((0, $j0XCX.getVisualisationGrouping));
            if ((0, $cScrq.isRoadmapGroupedByCustomField)(grouping) && (0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping) === id.toString()) yield (0, $aNOuE.put)((0, $dBbgF.changeGroup)({
                grouping: (0, $TTKUQ.GROUPING).NONE
            }));
        } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
            const error = new Error(response.text());
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: (0, $hvOzF.toErrorID)(error, 'delete-custom-field-fetch-failed'),
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
            ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
            requestInfo: {
                url: (0, $7ENDR.urls).removeCustomField,
                type: (0, $77QEM.POST),
                status: response.status,
                body: body
            }
        }));
        yield (0, $aNOuE.put)((0, $eiyR0.reset)({
            customFields: yield (0, $aNOuE.select)((0, $19iju.getCustomFields))
        }));
    }
    function* $541cc792981526ce$export$3fd454a1f9fecf74({ payload: { fieldId: fieldId, filteringAllowed: filteringAllowed } }) {
        const state = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const customField = (yield (0, $aNOuE.select)((0, $19iju.getCustomFields))).find((field)=>field.id === fieldId);
        const { domain: { plan: { id: planId } } } = state;
        if (planId) {
            const body = (0, $7ENDR.getUpdateCustomFieldsBody)(planId, [
                {
                    customFieldId: fieldId,
                    filteringAllowed: filteringAllowed
                }
            ]);
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $7ENDR.urls).updateCustomField, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                yield (0, $aNOuE.put)((0, $waHpx.update)((0, parcelRequire("ik0Qc")).default(customField, {
                    filteringAllowed: filteringAllowed
                })));
                yield (0, $aNOuE.put)((0, $eiyR0.reset)({
                    customFields: yield (0, $aNOuE.select)((0, $19iju.getCustomFields))
                }));
            } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
                const error = new Error(response.text());
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'update-custom-field-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: (0, $7ENDR.urls).updateCustomField,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
        }
    }
    function* $541cc792981526ce$export$bfa91ca8fa407ad() {
        const state = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, projects: projects } } = state;
        const projectIds = projects.map((project)=>project.id);
        if (!planId || !currentScenarioId) return;
        const allowedTypes = new Set([
            ...(0, (0, parcelRequire("4R6GH")).fg)('asset-custom-field-internal-support') ? [
                (0, $TTKUQ.CustomFieldTypes).AssetObject
            ] : [],
            (0, $TTKUQ.CustomFieldTypes).SingleSelect,
            (0, $TTKUQ.CustomFieldTypes).MultiSelect,
            (0, $TTKUQ.CustomFieldTypes).MultiCheckboxes,
            (0, $TTKUQ.CustomFieldTypes).RadioButtons
        ]);
        const allowedCustomFields = (yield (0, $aNOuE.select)((0, $19iju.getCustomFields))).filter((field)=>allowedTypes.has(field.type.key));
        if (allowedCustomFields.length === 0) {
            yield (0, $aNOuE.put)((0, $f7tuF.reset)([]));
            return;
        }
        const url = (0, $7ENDR.urls).getCustomFieldVisibleOptions;
        const response = yield* (0, $asXbx.jsonOrError)({
            url: url,
            method: (0, $77QEM.POST),
            body: (0, $7ENDR.getCustomFieldVisibleOptionsBody)((0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('id'))(allowedCustomFields), projectIds),
            profile: url
        });
        if (response.ok) {
            const selectOptions = response.data.map(({ customFieldId: fieldId, options: options })=>options.map((option)=>(0, parcelRequire("2XSIf")).default('fieldId', fieldId, option))).reduce((a, b)=>a.concat(b), []);
            yield (0, $aNOuE.put)((0, $f7tuF.reset)(selectOptions));
        }
    }
    function* $541cc792981526ce$export$a71c9ae971ca1414({ planId: planId, customFieldId: customFieldId, scenarioId: scenarioId }) {
        const body = (0, $7ENDR.getLabelForFieldBody)(planId, customFieldId, scenarioId);
        const url = (0, $7ENDR.urls).labels;
        const { items: items } = yield (0, $aNOuE.call)((0, $8DSSe.aggressiveFetch), url, {
            method: (0, $77QEM.POST),
            body: body,
            json: true,
            profile: url
        }, 'Failed to fetch doFetchLabelForField');
        yield (0, $aNOuE.put)((0, $1JzSf.reset)({
            customFieldId: customFieldId,
            labels: items
        }));
    }
    function* $541cc792981526ce$export$595181c7146606e7(action = {
        type: $541cc792981526ce$export$26ce9bf8b551812b,
        payload: {
            query: '',
            issueId: ''
        }
    }) {
        const issueId = action && action.payload && action.payload.issueId;
        const query = action ? action.payload && action.payload.query : '';
        const url = (0, $7ENDR.urls).getUserPickerCustomFieldOptions;
        const method = 'POST';
        const body = (0, $7ENDR.getUserPickerCustomFieldOptionsBody)({
            query: query
        });
        yield (0, $aNOuE.put)((0, $3Ujui.fetchUserStart)(issueId));
        const response = yield* (0, $asXbx.jsonOrError)({
            url: url,
            method: method,
            body: body
        });
        if (response.ok) yield (0, $aNOuE.put)((0, $2J7k2.reset)((0, $9174a.transformPersons)(response.data && response.data.results || [])));
        yield (0, $aNOuE.put)((0, $3Ujui.fetchUserStop)(issueId));
    }
    function* $541cc792981526ce$export$90e3800be4ee03a0(action) {
        yield (0, $aNOuE.call)((0, $hIYGf.delay), 500);
        yield (0, $aNOuE.call)($541cc792981526ce$export$595181c7146606e7, action);
    }
    function* $541cc792981526ce$export$94874ce07393af5e() {
        yield (0, $6u3NN.takeLatest)($541cc792981526ce$export$26ce9bf8b551812b, $541cc792981526ce$export$90e3800be4ee03a0);
        yield (0, $6u3NN.takeLatest)($541cc792981526ce$export$2c810c4aa49c0a3b, $541cc792981526ce$export$ef6c57c5ffb83c06);
        yield (0, $6u3NN.takeLatest)($541cc792981526ce$export$97d3a70653e68b71, $541cc792981526ce$export$4c65256e5a964137);
    }
    function* $541cc792981526ce$export$3559fa8b9a088433() {
        yield (0, $6u3NN.takeLatest)($541cc792981526ce$export$22550c63d1d2e6de, $541cc792981526ce$export$3cd7dad83cedca62);
    }
    function* $541cc792981526ce$export$3edd59f42a0ea08d() {
        yield (0, $6u3NN.takeLatest)($541cc792981526ce$export$aebce24c838569e9, $541cc792981526ce$export$2f12d93ffddc65e0);
    }
    function* $541cc792981526ce$export$50b4fa5c99cd5c86() {
        yield (0, $6u3NN.takeEvery)($541cc792981526ce$export$692688de415f3085, $541cc792981526ce$export$3fd454a1f9fecf74);
    }
    function* $541cc792981526ce$export$f80141107633cc64() {
        yield (0, $6u3NN.takeLatest)($541cc792981526ce$export$837a9b121c89f72c, $541cc792981526ce$export$bfa91ca8fa407ad);
    }
    function* $541cc792981526ce$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($541cc792981526ce$export$3559fa8b9a088433);
        yield (0, $aNOuE.fork)($541cc792981526ce$export$3edd59f42a0ea08d);
        yield (0, $aNOuE.fork)($541cc792981526ce$export$f80141107633cc64);
        yield (0, $aNOuE.fork)($541cc792981526ce$export$94874ce07393af5e);
        yield (0, $aNOuE.fork)($541cc792981526ce$export$50b4fa5c99cd5c86);
    }
});
parcelRegister("waHpx", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$fbf1d51c42a4de04$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD", ()=>$fbf1d51c42a4de04$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "UPDATE", ()=>$fbf1d51c42a4de04$export$e271b26eefe41db8);
    $parcel$export(module.exports, "REMOVE", ()=>$fbf1d51c42a4de04$export$29d55e1f664a246b);
    $parcel$export(module.exports, "reset", ()=>$fbf1d51c42a4de04$export$aad8462122ac592b);
    $parcel$export(module.exports, "add", ()=>$fbf1d51c42a4de04$export$e16d8520af44a096);
    $parcel$export(module.exports, "update", ()=>$fbf1d51c42a4de04$export$722fbec263ad908a);
    $parcel$export(module.exports, "remove", ()=>$fbf1d51c42a4de04$export$cd7f480d6b8286c3);
    const $fbf1d51c42a4de04$export$4a991c87e640ef77 = 'state.domain.custom-fields.RESET';
    const $fbf1d51c42a4de04$export$bb6389024b71c2ae = 'state.domain.custom-fields.ADD';
    const $fbf1d51c42a4de04$export$e271b26eefe41db8 = 'state.domain.custom-fields.UPDATE';
    const $fbf1d51c42a4de04$export$29d55e1f664a246b = 'state.domain.custom-fields.REMOVE';
    const $fbf1d51c42a4de04$export$aad8462122ac592b = (payload)=>({
            type: $fbf1d51c42a4de04$export$4a991c87e640ef77,
            payload: payload
        });
    const $fbf1d51c42a4de04$export$e16d8520af44a096 = (payload)=>({
            type: $fbf1d51c42a4de04$export$bb6389024b71c2ae,
            payload: payload
        });
    const $fbf1d51c42a4de04$export$722fbec263ad908a = (payload)=>({
            type: $fbf1d51c42a4de04$export$e271b26eefe41db8,
            payload: payload
        });
    const $fbf1d51c42a4de04$export$cd7f480d6b8286c3 = (payload)=>({
            type: $fbf1d51c42a4de04$export$29d55e1f664a246b,
            payload: payload
        });
});
parcelRegister("f7tuF", function(module, exports) {
    $parcel$export(module.exports, "ADD", ()=>$187839172d1ea5aa$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "RESET", ()=>$187839172d1ea5aa$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$187839172d1ea5aa$export$aad8462122ac592b);
    const $187839172d1ea5aa$export$bb6389024b71c2ae = 'state.domain.select-options.ADD';
    const $187839172d1ea5aa$export$4a991c87e640ef77 = 'state.domain.select-options.RESET';
    const $187839172d1ea5aa$export$e16d8520af44a096 = (payload)=>({
            type: $187839172d1ea5aa$export$bb6389024b71c2ae,
            payload: payload
        });
    const $187839172d1ea5aa$export$aad8462122ac592b = (payload)=>({
            type: $187839172d1ea5aa$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("2J7k2", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$a342c630331f17db$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$a342c630331f17db$export$aad8462122ac592b);
    const $a342c630331f17db$export$4a991c87e640ef77 = 'state.domain.user-picker-options.RESET';
    const $a342c630331f17db$export$aad8462122ac592b = (payload)=>({
            type: $a342c630331f17db$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("3Ujui", function(module, exports) {
    $parcel$export(module.exports, "FETCH_USER_START", ()=>$d78ba267f3120337$export$447013e0880a2fa);
    $parcel$export(module.exports, "FETCH_USER_STOP", ()=>$d78ba267f3120337$export$9a15cd003e3d43b);
    $parcel$export(module.exports, "fetchUserStart", ()=>$d78ba267f3120337$export$82dc48650f95fc3d);
    $parcel$export(module.exports, "fetchUserStop", ()=>$d78ba267f3120337$export$c75227b929d0c88c);
    const $d78ba267f3120337$export$447013e0880a2fa = 'state.ui.main.tabs.roadmap.fields.custom-fields.user-picker.FETCH_USER_START';
    const $d78ba267f3120337$export$9a15cd003e3d43b = 'state.ui.main.tabs.roadmap.fields.custom-fields.user-picker.FETCH_USER_STOP';
    const $d78ba267f3120337$export$82dc48650f95fc3d = (issueId)=>({
            type: $d78ba267f3120337$export$447013e0880a2fa,
            payload: {
                issueId: issueId
            }
        });
    const $d78ba267f3120337$export$c75227b929d0c88c = (issueId)=>({
            type: $d78ba267f3120337$export$9a15cd003e3d43b,
            payload: {
                issueId: issueId
            }
        });
});
parcelRegister("goTVH", function(module, exports) {
    $parcel$export(module.exports, "getBacklog", ()=>$8971592616df51e1$export$78352065150b1467);
    $parcel$export(module.exports, "fetchBacklog", ()=>$8971592616df51e1$export$ea50bb28c5c1891c);
    var $83IGl;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $jcw0u;
    var $4R6GH;
    var $4ENQh;
    var $6NgSc;
    var $8DSSe = parcelRequire("8DSSe");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fP57B = parcelRequire("fP57B");
    var $atabv = parcelRequire("atabv");
    var $bREsp = parcelRequire("bREsp");
    var $77QEM = parcelRequire("77QEM");
    var $bYhSc = parcelRequire("bYhSc");
    var $24CMK = parcelRequire("24CMK");
    var $hvOzF = parcelRequire("hvOzF");
    var $cukx3 = parcelRequire("cukx3");
    var $gaFm9 = parcelRequire("gaFm9");
    var $3JxKh = parcelRequire("3JxKh");
    const $8971592616df51e1$var$defaultHeaders = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    function* $8971592616df51e1$export$78352065150b1467(isInitialLoad = false) {
        const { domain: { plan: { id: id, currentScenarioId: currentScenarioId, includeCompletedIssuesFor: includeCompletedIssuesFor } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const url = (0, $3JxKh.urls).backlog;
        let response;
        let body;
        const preloadedRequest = window.jpoPreloadedRequests && window.jpoPreloadedRequests.backlog;
        if (isInitialLoad && preloadedRequest) {
            body = preloadedRequest.request.body;
            response = yield preloadedRequest.request;
            delete window.jpoPreloadedRequests.backlog;
        } else {
            body = yield (0, $aNOuE.call)((0, $3JxKh.backlogBody), {
                id: id,
                currentScenarioId: currentScenarioId,
                includeCompletedIssuesFor: includeCompletedIssuesFor
            });
            response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body,
                profile: url
            });
        }
        if (response.ok) yield* (0, $bYhSc.default)(function*() {
            const backlog = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.put)((0, $fP57B.resetBacklog)(backlog));
            const teams = backlog.teams?.map((0, $bREsp.prepareTeam)) ?? [];
            yield (0, $aNOuE.put)((0, $atabv.setAdditionalTeams)(teams));
            yield (0, $aNOuE.put)((0, $fP57B.afterResetBacklog)());
            yield (0, $aNOuE.put)((0, $gaFm9.calculateWarnings)());
            yield (0, $aNOuE.put)((0, $cukx3.calculateStatusOfAllReleases)());
        });
        else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
            const error = new Error((yield (0, $aNOuE.call)(response.text.bind(response))));
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: (0, $hvOzF.toErrorID)(error, 'backlog-fetch-failed'),
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
            ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $77QEM.POST),
                status: response.status,
                body: body
            }
        }));
    }
    function* $8971592616df51e1$var$fetchBacklogUrl(url, planId, scenarioId, isInitialLoad, marks, headers = $8971592616df51e1$var$defaultHeaders) {
        const earlyPreloadBacklogPromise = window.__ARJ_BACKLOG_PROMISE__;
        delete window.__ARJ_BACKLOG_PROMISE__;
        if (isInitialLoad && earlyPreloadBacklogPromise) {
            const response = yield earlyPreloadBacklogPromise;
            const start = Math.floor((0, (0, parcelRequire("6NgSc")).extractStartTime)(marks.startMark));
            const end = Math.ceil((0, (0, parcelRequire("6NgSc")).extractStartTime)(marks.endMark));
            (0, (0, parcelRequire("4ENQh")).monitor).recordCustomProfile(url, {
                start: start,
                end: end
            });
            return response;
        }
        const body = yield (0, $aNOuE.call)((0, $3JxKh.backlogBody), {
            id: planId,
            currentScenarioId: scenarioId
        });
        return yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
            method: (0, $77QEM.POST),
            body: body,
            profile: url,
            headers: headers
        });
    }
    function* $8971592616df51e1$export$ea50bb28c5c1891c(isInitialLoad = false, planId, scenarioId) {
        return yield* $8971592616df51e1$var$fetchBacklogUrl((0, $3JxKh.urls).backlog, planId, scenarioId, isInitialLoad, {
            startMark: `${(0, (0, parcelRequire("4ENQh")).ARJ_EARLY_PRELOAD_PREFIX)}.backlog:start`,
            endMark: `${(0, (0, parcelRequire("4ENQh")).ARJ_EARLY_PRELOAD_PREFIX)}.backlog:end`
        });
    }
});
parcelRegister("atabv", function(module, exports) {
    $parcel$export(module.exports, "SET", ()=>$26977ec054f83091$export$5e8f180ef0142226);
    $parcel$export(module.exports, "setAdditionalTeams", ()=>$26977ec054f83091$export$eb6986b461047d6c);
    const $26977ec054f83091$export$5e8f180ef0142226 = 'state.domain.teams-additional.SET';
    const $26977ec054f83091$export$eb6986b461047d6c = (payload)=>({
            type: $26977ec054f83091$export$5e8f180ef0142226,
            payload: payload
        });
});
parcelRegister("3JxKh", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$da8ee6b4c306928f$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "backlogBody", ()=>$da8ee6b4c306928f$export$a77ab082423ea66d);
    var $pyK8a;
    var $4nDwW = parcelRequire("4nDwW");
    const $da8ee6b4c306928f$export$bcae9ba627f604b6 = {
        backlog: '/rest/jpo/1.0/backlog'
    };
    const $da8ee6b4c306928f$export$a77ab082423ea66d = ({ id: planId, currentScenarioId: scenarioId, includeCompletedIssuesFor: includeCompletedIssuesFor })=>({
            planId: planId,
            scenarioId: scenarioId,
            filter: {
                includeCompleted: includeCompletedIssuesFor !== 0,
                includeCompletedSince: (0, (0, parcelRequire("pyK8a")).default)(Date.now(), (0, $4nDwW.isDefined)(includeCompletedIssuesFor) ? includeCompletedIssuesFor : (0, $08d1cd363c5f7148$export$6afdd25b4da87159)).getTime(),
                includeIssueLinks: true
            },
            supportingDataOptions: {
                assignees: true,
                reporters: true,
                externalTeams: true,
                sprints: true
            }
        });
});
const $08d1cd363c5f7148$export$b8b9d90f9e5bd72b = 'jiraPortfolio3CreateNewPlanWizardDrawer';
const $08d1cd363c5f7148$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $08d1cd363c5f7148$export$f27a837467ec20e5 = 'planWizard';
const $08d1cd363c5f7148$export$6afdd25b4da87159 = 30;
const $08d1cd363c5f7148$export$9a977208af30ffae = 'create-plan-wizard.load-time';
const $08d1cd363c5f7148$export$a8e537ef0c1e2586 = 'Days';
const $08d1cd363c5f7148$export$2a59d0fbc784e5c1 = '1';
const $08d1cd363c5f7148$export$7288711b5316ff78 = 'YYYY-MM-DD';
const $08d1cd363c5f7148$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
parcelRegister("dCXkr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e28e0533d91947fb$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $3YtPS = parcelRequire("3YtPS");
    var $e28e0533d91947fb$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        userList: (0, $19iju.getUserPickerOptionsUserList),
        userListById: (0, $19iju.getUserPickerOptionsUserListById),
        userPickerUIState: (0, $19iju.getUserPickerUIState)
    });
});
parcelRegister("b5DuP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db0fb6e3bef702e2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fZhYM;
    var $ujWmd;
    var $koVbs;
    var $hwwla;
    var $ixSW4 = parcelRequire("ixSW4");
    var $4nDwW = parcelRequire("4nDwW");
    var $1ldID = parcelRequire("1ldID");
    var $8T8Op = parcelRequire("8T8Op");
    const $db0fb6e3bef702e2$export$8b412adb79c82bc8 = ({ issue: issue, attribute: attribute, onChange: onChange })=>(userId)=>{
            onChange(issue, attribute, userId);
        };
    const $db0fb6e3bef702e2$export$6341682f20d2dbb4 = ({ attribute: attribute, issue: issue, userListById: userListById })=>{
        const userPickerValue = (0, parcelRequire("fZhYM")).default([
            'customFields',
            attribute
        ], issue);
        if (userPickerValue && userListById[userPickerValue]) return userListById[userPickerValue];
        return null;
    };
    const $db0fb6e3bef702e2$export$1a4c3eec4d27c15d = ({ attribute: attribute, issue: issue, userListById: userListById, isScrolling: isScrolling, isReadOnly: isReadOnly = false, userList: userList = [], UserPicker: UserPicker, userPickerUIState: userPickerUIState, onChange: onChange, fetchUserList: fetchUserList })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const selectedUser = $db0fb6e3bef702e2$export$6341682f20d2dbb4({
            attribute: attribute,
            issue: issue,
            userListById: userListById
        });
        const handleUserChange = $db0fb6e3bef702e2$export$8b412adb79c82bc8({
            issue: issue,
            attribute: attribute,
            onChange: onChange
        });
        const onFetchUserList = (query = '')=>{
            fetchUserList(query, issue.id);
        };
        if (isScrolling) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hwwla")).default), {
            content: selectedUser ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $8T8Op.wireframeWrapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "xsmall",
                src: selectedUser.icon
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $8T8Op.wireframeTitle
            }, selectedUser.label)) : '',
            isReadOnly: isReadOnly
        });
        const { issueId: issueId, isFetchUserListInProgress: isFetchUserListInProgress } = userPickerUIState;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(UserPicker, {
            attribute: attribute,
            issueId: issue.id,
            onFetchUserList: onFetchUserList,
            onUserChange: handleUserChange,
            placeholder: formatMessage((0, $1ldID.default).placeholder),
            selectProps: {
                isClearable: true,
                isDisabled: isReadOnly,
                isLoading: (0, $4nDwW.isDefined)(issueId) && issue.id === issueId && isFetchUserListInProgress
            },
            user: selectedUser,
            userList: userList
        });
    };
    const $db0fb6e3bef702e2$export$98f196004df7adbd = (0, $ixSW4.withSlots)({
        UserPicker: (0, $ixSW4.slots).UserPicker
    })($db0fb6e3bef702e2$export$1a4c3eec4d27c15d);
    var $db0fb6e3bef702e2$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        UserPicker: (0, $ixSW4.slots).UserPicker
    })($db0fb6e3bef702e2$export$1a4c3eec4d27c15d);
});
parcelRegister("1ldID", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37d9834a60064848$export$2e2bcd8739ae039);
    var $7VHMR;
    var $37d9834a60064848$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.user-picker.placeholder",
            "defaultMessage": "Choose a user"
        }
    });
});
parcelRegister("8T8Op", function(module, exports) {
    $parcel$export(module.exports, "wireframeTitle", ()=>$678a4bb08aead3a1$export$5b70723b6181a633, (v)=>$678a4bb08aead3a1$export$5b70723b6181a633 = v);
    $parcel$export(module.exports, "wireframeWrapper", ()=>$678a4bb08aead3a1$export$fc8552436656bc6, (v)=>$678a4bb08aead3a1$export$fc8552436656bc6 = v);
    var $678a4bb08aead3a1$export$5b70723b6181a633;
    var $678a4bb08aead3a1$export$fc8552436656bc6;
    $678a4bb08aead3a1$export$5b70723b6181a633 = `HckXpG_wireframeTitle`;
    $678a4bb08aead3a1$export$fc8552436656bc6 = `HckXpG_wireframeWrapper`;
});
parcelRegister("jOodz", function(module, exports) {
    $parcel$export(module.exports, "shouldCustomFieldBeDisabledForScopedIssue", ()=>$4b358e798efe2558$export$45e0204534f8a44e);
    const $4b358e798efe2558$export$92eaadfffff71863 = (customField)=>customField.projectId !== undefined;
    const $4b358e798efe2558$export$45e0204534f8a44e = (customField, issueTypeId, issueProjectId)=>{
        if ($4b358e798efe2558$export$92eaadfffff71863(customField)) {
            if (customField.projectId !== issueProjectId || !(customField.issueTypeIds && customField.issueTypeIds.includes(issueTypeId))) return true;
        }
        return false;
    };
});
parcelRegister("f5q7z", function(module, exports) {
    $parcel$export(module.exports, "Field", ()=>$f3ea72b6562369f2$export$a455218a85c89869);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $aI0i7;
    var $8LV9S;
    const $f3ea72b6562369f2$export$a455218a85c89869 = ({ issue: issue, column: column, isReadOnly: isReadOnly, isScrolling: isScrolling, showOptimizations: showOptimizations })=>{
        const { cell: Cell } = column;
        const [{ column: colIndex }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const [width] = (0, (0, parcelRequire("8LV9S")).useColumnWidth)({
            column: colIndex,
            preview: false
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f3ea72b6562369f2$var$containerStyles,
            "data-issue": issue.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Cell, {
            issue: issue,
            attribute: column.attribute,
            isReadOnly: (isReadOnly || column.isReadOnly) ?? false,
            showOptimizations: showOptimizations,
            isScrolling: isScrolling,
            width: width
        }));
    };
    const $f3ea72b6562369f2$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: 'space.500'
    });
});
parcelRegister("aI0i7", function(module, exports) {
    $parcel$export(module.exports, "CellProvider", ()=>$6fc363955bf9cbb4$export$e2f5665ccc36e4b4);
    $parcel$export(module.exports, "useCell", ()=>$6fc363955bf9cbb4$export$42b866d2c5dc25d7);
    $parcel$export(module.exports, "useCellColumn", ()=>$6fc363955bf9cbb4$export$12f8a5642c4422c);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $6fc363955bf9cbb4$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            row: -1,
            column: -1,
            colSpan: 1
        },
        actions: {}
    });
    const $6fc363955bf9cbb4$export$e2f5665ccc36e4b4 = (0, (0, parcelRequire("gg7kZ")).createContainer)($6fc363955bf9cbb4$var$store, {
        onInit: ()=>({ setState: setState }, state)=>setState(state),
        onUpdate: ()=>({ setState: setState }, state)=>setState(state)
    });
    const $6fc363955bf9cbb4$export$42b866d2c5dc25d7 = (0, (0, parcelRequire("3sQ5x")).createHook)($6fc363955bf9cbb4$var$store, {
        selector: ({ row: row, column: column, colSpan: colSpan })=>({
                row: row,
                column: column,
                colSpan: colSpan
            })
    });
    const $6fc363955bf9cbb4$export$12f8a5642c4422c = (0, (0, parcelRequire("3sQ5x")).createHook)($6fc363955bf9cbb4$var$store, {
        selector: ({ column: column, colSpan: colSpan })=>({
                column: column,
                colSpan: colSpan
            })
    });
});
parcelRegister("grJar", function(module, exports) {
    $parcel$export(module.exports, "GroupHeader", ()=>$ad469ccf79a47e83$export$58d63a2875c58fc8);
    var $bC2fB;
    var $1Ns26 = parcelRequire("1Ns26");
    var $jaD6T = parcelRequire("jaD6T");
    var $fKqDq = parcelRequire("fKqDq");
    const $ad469ccf79a47e83$export$58d63a2875c58fc8 = (0, (0, parcelRequire("bC2fB")).connect)((0, $jaD6T.default), (0, $1Ns26.default))((0, $fKqDq.GroupHeader));
});
parcelRegister("1Ns26", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f2cc2976a29f1af$export$2e2bcd8739ae039);
    var $21mdo = parcelRequire("21mdo");
    var $3f2cc2976a29f1af$export$2e2bcd8739ae039 = (dispatch)=>({
            onToggle: (payload)=>dispatch((0, $21mdo.setIsExpanded)(payload))
        });
});
parcelRegister("jaD6T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e24528ac4c8095a1$export$2e2bcd8739ae039);
    var $6Ayrn = parcelRequire("6Ayrn");
    var $jLI87 = parcelRequire("jLI87");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    const $e24528ac4c8095a1$var$getRankDigits = (0, $3YtPS.createSelector)([
        (0, $jLI87.getScope)
    ], (scope)=>scope.startLevelIssues.rootIssuesCount.toString().length);
    const $e24528ac4c8095a1$var$getGrouping = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getVisualisationViewSettings)
    ], ({ grouping: grouping })=>grouping);
    var $e24528ac4c8095a1$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $6Ayrn.getHierarchyLevelsByLevel),
        $e24528ac4c8095a1$var$getRankDigits,
        $e24528ac4c8095a1$var$getGrouping
    ], (hierarchyLevelsByLevel, rankDigits, grouping)=>({
            hierarchyLevelsByLevel: hierarchyLevelsByLevel,
            rankDigits: rankDigits,
            grouping: grouping
        }));
});
parcelRegister("fKqDq", function(module, exports) {
    $parcel$export(module.exports, "GroupHeader", ()=>$ebda45ce7ab493f7$export$58d63a2875c58fc8);
    var $5uXOq = parcelRequire("5uXOq");
    var $6mYSR;
    var $dUk9j;
    var $5OG52 = parcelRequire("5OG52");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $aI0i7;
    const $ebda45ce7ab493f7$export$58d63a2875c58fc8 = ({ hierarchyLevelsByLevel: hierarchyLevelsByLevel, item: item, onToggle: onToggle, rankDigits: rankDigits, grouping: grouping })=>{
        const level = hierarchyLevelsByLevel[item.value.level];
        const id = item.value.id ?? level?.title ?? '';
        const ref = (0, $5uXOq.useRef)(null);
        const [{ row: row }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        (0, (0, parcelRequire("6mYSR")).useDropTarget)(ref, row);
        return (0, (0, parcelRequire("dUk9j")).EpicLevelSpotlightTarget)((0, ($parcel$interopDefault($5uXOq))).createElement((0, $5OG52.default), {
            outerRef: ref,
            level: level,
            rootIssuesCount: item.value.rootIssuesCount,
            isExpanded: item.value.isExpanded,
            id: id,
            rankDigits: rankDigits,
            onToggle: onToggle
        }), grouping === (0, $TTKUQ.GROUPING).NONE, level?.level);
    };
});
parcelRegister("6mYSR", function(module, exports) {
    $parcel$export(module.exports, "useDragTarget", ()=>$873b010fbf44be94$export$37ec04ca8378ed1a);
    $parcel$export(module.exports, "useDropTarget", ()=>$873b010fbf44be94$export$5967d4bb72ce3c0);
    $parcel$export(module.exports, "useDragAndDropMonitor", ()=>$873b010fbf44be94$export$f6b083f1ec659860);
    $parcel$export(module.exports, "useDragAndDropAutoScroll", ()=>$873b010fbf44be94$export$24b348a08276c9fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $3KYe6;
    var $biEfA;
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    var $3Mh6R;
    var $avpM4;
    const $873b010fbf44be94$export$37ec04ca8378ed1a = (ref, index)=>{
        const instance = (0, (0, parcelRequire("3Mh6R")).useDragAndDropInstance)();
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (!ref.current) return;
            const element = ref.current;
            const data = {
                index: index,
                instance: instance
            };
            return (0, $7gWdR.draggable)({
                element: element,
                getInitialData () {
                    return data;
                },
                onGenerateDragPreview () {
                    setIsDragging(true);
                },
                onDrop () {
                    setIsDragging(false);
                }
            });
        }, [
            index,
            instance,
            ref
        ]);
        return {
            isDragging: isDragging
        };
    };
    const $873b010fbf44be94$export$5967d4bb72ce3c0 = (ref, index)=>{
        const instance = (0, (0, parcelRequire("3Mh6R")).useDragAndDropInstance)();
        (0, $5uXOq.useEffect)(()=>{
            if (!ref.current) return;
            const element = ref.current;
            const data = {
                index: index,
                instance: instance
            };
            return (0, $7gWdR.dropTargetForElements)({
                element: element,
                canDrop ({ source: source }) {
                    return source.data.instance === instance;
                },
                getData ({ input: input }) {
                    return (0, (0, parcelRequire("biEfA")).attachClosestEdge)(data, {
                        element: element,
                        input: input,
                        allowedEdges: [
                            'top',
                            'bottom'
                        ]
                    });
                }
            });
        }, [
            index,
            instance,
            ref
        ]);
    };
    const $873b010fbf44be94$export$f6b083f1ec659860 = ({ onDragStart: onDragStart, onDrag: onDrag, onDrop: onDrop, getIndicators: getIndicators })=>{
        const [{ instance: instance }, { initialize: initialize, onDragStart: onDragStartInternal, onDrag: onDragInternal, onDropTargetChange: onDropTargetChangeInternal, onDrop: onDropInternal }] = (0, (0, parcelRequire("3Mh6R")).useDragAndDropController)();
        (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)({
                canMonitor ({ source: source }) {
                    return source.data.instance === instance;
                },
                onDragStart ({ source: source }) {
                    const dragTarget = (0, (0, parcelRequire("avpM4")).getDragTarget)(source);
                    onDragStartInternal(dragTarget);
                },
                onDrag ({ location: location }) {
                    const target = location.current.dropTargets[0];
                    const dropTarget = (0, (0, parcelRequire("avpM4")).getDropTarget)(target);
                    onDragInternal(dropTarget);
                },
                onDropTargetChange ({ location: location }) {
                    const target = location.current.dropTargets[0];
                    const dropTarget = (0, (0, parcelRequire("avpM4")).getDropTarget)(target);
                    onDropTargetChangeInternal(dropTarget);
                },
                onDrop ({ source: source, location: location }) {
                    const target = location.current.dropTargets[0];
                    const dragTarget = (0, (0, parcelRequire("avpM4")).getDragTarget)(source);
                    const dropTarget = (0, (0, parcelRequire("avpM4")).getDropTarget)(target);
                    onDropInternal(dragTarget, dropTarget);
                }
            }), [
            instance,
            onDragInternal,
            onDragStartInternal,
            onDropInternal,
            onDropTargetChangeInternal
        ]);
        (0, $5uXOq.useEffect)(()=>{
            initialize({
                onDragStart: onDragStart,
                onDrag: onDrag,
                onDrop: onDrop,
                getIndicators: getIndicators
            });
        }, [
            initialize,
            onDragStart,
            onDrag,
            onDrop,
            getIndicators
        ]);
    };
    const $873b010fbf44be94$export$24b348a08276c9fb = (ref, allowedAxis = 'all')=>{
        const instance = (0, (0, parcelRequire("3Mh6R")).useDragAndDropInstance)();
        (0, $5uXOq.useEffect)(()=>{
            if (!ref.current) return;
            const element = ref.current;
            return (0, $4hDdm.combine)((0, (0, parcelRequire("3KYe6")).autoScrollForElements)({
                element: element,
                canScroll ({ source: source }) {
                    return source.data.instance === instance;
                },
                getAllowedAxis () {
                    return allowedAxis;
                }
            }));
        }, [
            instance,
            ref,
            allowedAxis
        ]);
    };
});
parcelRegister("3KYe6", function(module, exports) {
    $parcel$export(module.exports, "autoScrollForElements", ()=>$5ea44a3a02963798$export$4b66ee8317094cdb);
    var $7gWdR = parcelRequire("7gWdR");
    var $1XBB4;
    const $5ea44a3a02963798$var$api = (0, (0, parcelRequire("1XBB4")).makeApi)({
        monitor: (0, $7gWdR.monitorForElements)
    });
    const $5ea44a3a02963798$export$4b66ee8317094cdb = $5ea44a3a02963798$var$api.autoScroll;
    const $5ea44a3a02963798$export$c9168f41de61f525 = $5ea44a3a02963798$var$api.autoScrollWindow;
});
parcelRegister("1XBB4", function(module, exports) {
    $parcel$export(module.exports, "makeApi", ()=>$7c9f5b9e5aad06df$export$b8fa21320a811083);
    var $4hDdm = parcelRequire("4hDdm");
    var $4HETl;
    var $5DMYW;
    var $dN2fr;
    function $7c9f5b9e5aad06df$export$b8fa21320a811083({ monitor: monitor }) {
        const elementRegistry = new Map();
        const windowRegistry = new Set();
        function autoScroll(args) {
            elementRegistry.set(args.element, args);
            return (0, $4hDdm.combine)((0, (0, parcelRequire("5DMYW")).addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        }
        function autoScrollWindow(args = {}) {
            const unique = {
                ...args
            };
            windowRegistry.add(unique);
            return ()=>windowRegistry.delete(unique);
        }
        function findEntry(element) {
            return elementRegistry.get(element) ?? null;
        }
        function getWindowScrollEntries() {
            return Array.from(windowRegistry);
        }
        function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
            (0, (0, parcelRequire("dN2fr")).tryScroll)({
                input: latestArgs.location.current.input,
                source: latestArgs.source,
                findEntry: findEntry,
                underUsersPointer: underUsersPointer,
                timeSinceLastFrame: timeSinceLastFrame,
                getWindowScrollEntries: getWindowScrollEntries
            });
        }
        (0, (0, parcelRequire("4HETl")).getScheduler)(monitor).onFrame(onFrame);
        return {
            autoScroll: autoScroll,
            autoScrollWindow: autoScrollWindow
        };
    }
});
parcelRegister("4HETl", function(module, exports) {
    $parcel$export(module.exports, "getScheduler", ()=>$76249ae4e9f30f38$export$5cff7ac265db316a);
    parcelRequire("i6e0j");
    var $kKgsQ = parcelRequire("kKgsQ");
    var $3d4ga;
    const $76249ae4e9f30f38$var$schedulers = new Map();
    function $76249ae4e9f30f38$export$5cff7ac265db316a(monitor) {
        const scheduler = $76249ae4e9f30f38$var$schedulers.get(monitor);
        if (scheduler) return scheduler;
        const created = $76249ae4e9f30f38$var$makeScheduler(monitor);
        $76249ae4e9f30f38$var$schedulers.set(monitor, created);
        return created;
    }
    function $76249ae4e9f30f38$var$makeScheduler(monitor) {
        let state = {
            type: 'idle'
        };
        const callbacks = [];
        function loop(timeLastFrameFinished) {
            if (state.type !== 'running') return;
            const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
            const { latestArgs: latestArgs } = state;
            const underUsersPointer = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
                x: latestArgs.location.current.input.clientX,
                y: latestArgs.location.current.input.clientY
            });
            (0, (0, parcelRequire("3d4ga")).clearUnusedEngagements)(()=>{
                callbacks.forEach((onFrame)=>onFrame({
                        underUsersPointer: underUsersPointer,
                        latestArgs: latestArgs,
                        timeSinceLastFrame: timeSinceLastFrame
                    }));
            });
            state.timeLastFrameFinished = timeLastFrameFinished;
            state.frameId = requestAnimationFrame(loop);
        }
        function reset() {
            if (state.type === 'idle') return;
            cancelAnimationFrame(state.frameId);
            (0, (0, parcelRequire("3d4ga")).clearEngagementHistory)();
            state = {
                type: 'idle'
            };
        }
        function start(args) {
            if (state.type !== 'idle') return;
            state = {
                type: 'initializing',
                latestArgs: args,
                frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                    if (state.type !== 'initializing') return;
                    state = {
                        type: 'running',
                        timeLastFrameFinished: timeLastFrameFinished,
                        latestArgs: state.latestArgs,
                        frameId: requestAnimationFrame(loop)
                    };
                })
            };
        }
        function update(args) {
            if (state.type === 'idle') {
                start(args);
                return;
            }
            state.latestArgs = args;
        }
        monitor({
            onDragStart: start,
            onDropTargetChange: update,
            onDrag: update,
            onDrop: reset
        });
        const api = {
            onFrame (fn) {
                callbacks.push(fn);
            }
        };
        return api;
    }
});
parcelRegister("i6e0j", function(module, exports) {
    $parcel$export(module.exports, "getElementFromPointWithoutHoneypot", ()=>(parcelRequire("kKgsQ")).getElementFromPointWithoutHoneypot);
    var $kKgsQ = parcelRequire("kKgsQ");
});
parcelRegister("3d4ga", function(module, exports) {
    $parcel$export(module.exports, "markAndGetEngagement", ()=>$cdcee60ad04716da$export$8c764c3f2fc3d2d2);
    $parcel$export(module.exports, "clearUnusedEngagements", ()=>$cdcee60ad04716da$export$991e77dd347f3df1);
    $parcel$export(module.exports, "clearEngagementHistory", ()=>$cdcee60ad04716da$export$13ae770ed39b71ea);
    const $cdcee60ad04716da$var$ledger = new Map();
    const $cdcee60ad04716da$var$requested = new Set();
    function $cdcee60ad04716da$export$8c764c3f2fc3d2d2(element) {
        $cdcee60ad04716da$export$1cb7cbb266b6f6fa(element);
        const entry = $cdcee60ad04716da$var$ledger.get(element);
        if (entry) return entry;
        const fresh = {
            timeOfEngagementStart: Date.now()
        };
        $cdcee60ad04716da$var$ledger.set(element, fresh);
        return fresh;
    }
    function $cdcee60ad04716da$export$1cb7cbb266b6f6fa(element) {
        $cdcee60ad04716da$var$requested.add(element);
    }
    function $cdcee60ad04716da$export$991e77dd347f3df1(fn) {
        $cdcee60ad04716da$var$requested.clear();
        fn();
        $cdcee60ad04716da$var$ledger.forEach((_, element)=>{
            if (!$cdcee60ad04716da$var$requested.has(element)) $cdcee60ad04716da$var$ledger.delete(element);
        });
        $cdcee60ad04716da$var$requested.clear();
    }
    function $cdcee60ad04716da$export$13ae770ed39b71ea() {
        $cdcee60ad04716da$var$ledger.clear();
    }
});
parcelRegister("5DMYW", function(module, exports) {
    $parcel$export(module.exports, "selector", ()=>$05e8460564c70d18$export$aea217a45095ce11);
    $parcel$export(module.exports, "addScrollableAttribute", ()=>$05e8460564c70d18$export$4ec12fb57dfebd53);
    const $05e8460564c70d18$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
    const $05e8460564c70d18$export$aea217a45095ce11 = `[${$05e8460564c70d18$export$4b152ab55cad4fd6}="true"]`;
    function $05e8460564c70d18$export$4ec12fb57dfebd53(element) {
        element.setAttribute($05e8460564c70d18$export$4b152ab55cad4fd6, 'true');
        return ()=>element.removeAttribute($05e8460564c70d18$export$4b152ab55cad4fd6);
    }
});
parcelRegister("dN2fr", function(module, exports) {
    $parcel$export(module.exports, "tryScroll", ()=>$95daf559d8aa786a$export$233199807749476d);
    var $kjAuM;
    var $3d4ga;
    var $5DMYW;
    var $i4SSA;
    function $95daf559d8aa786a$var$isScrollingAvailable(value) {
        return Boolean(value.top || value.left);
    }
    function $95daf559d8aa786a$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
        top: true,
        left: true
    } }) {
        if (!$95daf559d8aa786a$var$isScrollingAvailable(available)) return available;
        if (!target) return available;
        const element = target.closest((0, (0, parcelRequire("5DMYW")).selector));
        if (!element) return available;
        const container = findEntry(element);
        if (!container) return available;
        function continueSearchUp() {
            return $95daf559d8aa786a$var$tryScrollElements({
                target: element?.parentElement ?? null,
                findEntry: findEntry,
                source: source,
                timeSinceLastFrame: timeSinceLastFrame,
                input: input,
                available: available
            });
        }
        const feedback = {
            input: input,
            source: source,
            element: element
        };
        if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
        const engagement = (0, (0, parcelRequire("3d4ga")).markAndGetEngagement)(element);
        const config = (0, (0, parcelRequire("kjAuM")).getInternalConfig)(container.getConfiguration?.(feedback));
        const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, (0, parcelRequire("i4SSA")).getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            timeSinceLastFrame: timeSinceLastFrame,
            allowedAxis: allowedAxis,
            config: config
        });
        const scroll = {
            top: 0,
            left: 0
        };
        if (available.top && scrollBy.top !== 0) {
            scroll.top = scrollBy.top;
            available.top = false;
        }
        if (available.left && scrollBy.left !== 0) {
            scroll.left = scrollBy.left;
            available.left = false;
        }
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        return continueSearchUp();
    }
    function $95daf559d8aa786a$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
        const element = document.documentElement;
        const feedback = {
            input: input,
            source: source,
            element: element
        };
        for (const entry of entries){
            if (entry.canScroll && !entry.canScroll(feedback)) continue;
            const engagement = (0, (0, parcelRequire("3d4ga")).markAndGetEngagement)(element);
            const config = (0, (0, parcelRequire("kjAuM")).getInternalConfig)(entry.getConfiguration?.(feedback));
            const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
            const scrollBy = (0, (0, parcelRequire("i4SSA")).getScrollBy)({
                element: element,
                engagement: engagement,
                input: input,
                config: config,
                allowedAxis: allowedAxis,
                getRect: (element)=>DOMRect.fromRect({
                        y: 0,
                        x: 0,
                        width: element.clientWidth,
                        height: element.clientHeight
                    }),
                timeSinceLastFrame: timeSinceLastFrame
            });
            const scroll = {
                top: available.top ? scrollBy.top : 0,
                left: available.left ? scrollBy.left : 0
            };
            if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
            break;
        }
    }
    function $95daf559d8aa786a$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
        const remainder = $95daf559d8aa786a$var$tryScrollElements({
            target: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            source: source,
            findEntry: findEntry
        });
        if (!$95daf559d8aa786a$var$isScrollingAvailable(remainder)) return;
        $95daf559d8aa786a$var$tryScrollWindow({
            input: input,
            source: source,
            entries: getWindowScrollEntries(),
            timeSinceLastFrame: timeSinceLastFrame,
            available: remainder
        });
    }
});
parcelRegister("kjAuM", function(module, exports) {
    $parcel$export(module.exports, "getInternalConfig", ()=>$8aedd24a4f7bb643$export$e96028ec7ff9d079);
    const $8aedd24a4f7bb643$var$baseConfig = {
        startHitboxAtPercentageRemainingOfElement: {
            top: 0.25,
            right: 0.25,
            bottom: 0.25,
            left: 0.25
        },
        maxScrollAtPercentageRemainingOfHitbox: {
            top: 0.5,
            right: 0.5,
            bottom: 0.5,
            left: 0.5
        },
        timeDampeningDurationMs: 300,
        maxMainAxisHitboxSize: 180
    };
    const $8aedd24a4f7bb643$var$maxPixelScrollPerSecond = {
        standard: 900,
        fast: 1500
    };
    function $8aedd24a4f7bb643$export$e96028ec7ff9d079(provided) {
        return {
            ...$8aedd24a4f7bb643$var$baseConfig,
            maxPixelScrollPerSecond: $8aedd24a4f7bb643$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
        };
    }
});
parcelRegister("i4SSA", function(module, exports) {
    $parcel$export(module.exports, "getScrollBy", ()=>$f221acff344cd122$export$6cfa6dfe6898b98f);
    var $iduok;
    var $ffSUw;
    var $c3M8M;
    var $gfxd2;
    var $hTDOm;
    var $2dwAb;
    function $f221acff344cd122$var$getRectDefault(element) {
        return element.getBoundingClientRect();
    }
    function $f221acff344cd122$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $f221acff344cd122$var$getRectDefault }) {
        const client = {
            x: input.clientX,
            y: input.clientY
        };
        const clientRect = getRect(element);
        const scrollableEdges = (0, (0, parcelRequire("ffSUw")).edges).reduce((map, edge)=>{
            const hitbox = (0, (0, parcelRequire("c3M8M")).getOverElementHitbox)[edge]({
                clientRect: clientRect,
                config: config
            });
            const axis = (0, (0, parcelRequire("ffSUw")).edgeAxisLookup)[edge];
            if (!(0, (0, parcelRequire("hTDOm")).isAxisAllowed)(axis, allowedAxis)) return map;
            if (!(0, (0, parcelRequire("2dwAb")).isWithin)({
                client: client,
                clientRect: hitbox
            })) return map;
            if (!(0, (0, parcelRequire("iduok")).canScrollOnEdge)[edge](element)) return map;
            map.set(edge, {
                edge: edge,
                hitbox: hitbox
            });
            return map;
        }, new Map());
        const left = (()=>{
            const axis = 'horizontal';
            const leftEdge = scrollableEdges.get('left');
            if (leftEdge) return (0, (0, parcelRequire("gfxd2")).getScrollChange)({
                client: client,
                edge: leftEdge.edge,
                hitbox: leftEdge.hitbox,
                axis: axis,
                timeSinceLastFrame: timeSinceLastFrame,
                engagement: engagement,
                isDistanceDampeningEnabled: true,
                config: config
            });
            const rightEdge = scrollableEdges.get('right');
            if (rightEdge) return (0, (0, parcelRequire("gfxd2")).getScrollChange)({
                client: client,
                edge: rightEdge.edge,
                hitbox: rightEdge.hitbox,
                axis: axis,
                timeSinceLastFrame: timeSinceLastFrame,
                engagement: engagement,
                isDistanceDampeningEnabled: true,
                config: config
            });
            return 0;
        })();
        const top = (()=>{
            const axis = 'vertical';
            const bottomEdge = scrollableEdges.get('bottom');
            if (bottomEdge) return (0, (0, parcelRequire("gfxd2")).getScrollChange)({
                client: client,
                edge: bottomEdge.edge,
                hitbox: bottomEdge.hitbox,
                axis: axis,
                timeSinceLastFrame: timeSinceLastFrame,
                engagement: engagement,
                isDistanceDampeningEnabled: true,
                config: config
            });
            const topEdge = scrollableEdges.get('top');
            if (topEdge) return (0, (0, parcelRequire("gfxd2")).getScrollChange)({
                client: client,
                edge: topEdge.edge,
                hitbox: topEdge.hitbox,
                axis: axis,
                timeSinceLastFrame: timeSinceLastFrame,
                engagement: engagement,
                isDistanceDampeningEnabled: true,
                config: config
            });
            return 0;
        })();
        return {
            left: left,
            top: top
        };
    }
});
parcelRegister("iduok", function(module, exports) {
    $parcel$export(module.exports, "canScrollOnEdge", ()=>$dc24cd2fd79e74bd$export$ccd6d9407403fcad);
    const $dc24cd2fd79e74bd$export$ccd6d9407403fcad = {
        top: (element)=>element.scrollTop > 0,
        right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
        bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
        left: (element)=>element.scrollLeft > 0
    };
});
parcelRegister("ffSUw", function(module, exports) {
    $parcel$export(module.exports, "edges", ()=>$77e5ecf85ecb98dd$export$4544a00f8eb65eb2);
    $parcel$export(module.exports, "edgeAxisLookup", ()=>$77e5ecf85ecb98dd$export$7fc144124ccf8292);
    const $77e5ecf85ecb98dd$export$4544a00f8eb65eb2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $77e5ecf85ecb98dd$export$7fc144124ccf8292 = {
        top: 'vertical',
        right: 'horizontal',
        bottom: 'vertical',
        left: 'horizontal'
    };
});
parcelRegister("c3M8M", function(module, exports) {
    $parcel$export(module.exports, "getOverElementHitbox", ()=>$4e0c1489e6f6f1ed$export$b9a449c20abb0e9);
    var $9w8nT;
    var $aHtK2;
    function $4e0c1489e6f6f1ed$var$makeGetHitbox({ edge: edge, axis: axis }) {
        return function hitbox({ clientRect: clientRect, config: config }) {
            const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, (0, parcelRequire("9w8nT")).axisLookup)[axis];
            const side = (0, (0, parcelRequire("aHtK2")).mainAxisSideLookup)[edge];
            const mainAxisHitboxSize = Math.min(config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], config.maxMainAxisHitboxSize);
            return DOMRect.fromRect({
                [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
                [crossAxis.point]: clientRect[crossAxis.point],
                [mainAxis.size]: mainAxisHitboxSize,
                [crossAxis.size]: clientRect[crossAxis.size]
            });
        };
    }
    const $4e0c1489e6f6f1ed$export$b9a449c20abb0e9 = {
        top: $4e0c1489e6f6f1ed$var$makeGetHitbox({
            axis: 'vertical',
            edge: 'top'
        }),
        right: $4e0c1489e6f6f1ed$var$makeGetHitbox({
            axis: 'horizontal',
            edge: 'right'
        }),
        bottom: $4e0c1489e6f6f1ed$var$makeGetHitbox({
            axis: 'vertical',
            edge: 'bottom'
        }),
        left: $4e0c1489e6f6f1ed$var$makeGetHitbox({
            axis: 'horizontal',
            edge: 'left'
        })
    };
});
parcelRegister("9w8nT", function(module, exports) {
    $parcel$export(module.exports, "axisLookup", ()=>$4007ed2af13415f1$export$42e42cdab35a2b96);
    const $4007ed2af13415f1$var$vertical = {
        start: 'top',
        end: 'bottom',
        point: 'y',
        size: 'height'
    };
    const $4007ed2af13415f1$var$horizontal = {
        start: 'left',
        end: 'right',
        point: 'x',
        size: 'width'
    };
    const $4007ed2af13415f1$export$42e42cdab35a2b96 = {
        vertical: {
            mainAxis: $4007ed2af13415f1$var$vertical,
            crossAxis: $4007ed2af13415f1$var$horizontal
        },
        horizontal: {
            mainAxis: $4007ed2af13415f1$var$horizontal,
            crossAxis: $4007ed2af13415f1$var$vertical
        }
    };
});
parcelRegister("aHtK2", function(module, exports) {
    $parcel$export(module.exports, "mainAxisSideLookup", ()=>$4b97aced6f7f08e4$export$a45c0cd714a4dbaa);
    const $4b97aced6f7f08e4$export$a45c0cd714a4dbaa = {
        top: 'start',
        right: 'end',
        bottom: 'end',
        left: 'start'
    };
});
parcelRegister("gfxd2", function(module, exports) {
    $parcel$export(module.exports, "getScrollChange", ()=>$b3ae2158089b2ceb$export$470a2ff46db8cee8);
    var $9w8nT;
    var $lUX3m;
    var $aHtK2;
    function $b3ae2158089b2ceb$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
        const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
        const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
        const maximum = config.maxPixelScrollPerSecond / 60;
        return Math.min(proposed, maximum);
    }
    function $b3ae2158089b2ceb$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
        const { mainAxis: mainAxis } = (0, (0, parcelRequire("9w8nT")).axisLookup)[axis];
        const side = (0, (0, parcelRequire("aHtK2")).mainAxisSideLookup)[edge];
        const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
        if (side === 'end') return (0, (0, parcelRequire("lUX3m")).getPercentageInRange)({
            startOfRange: hitbox[mainAxis.start],
            endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
            value: client[mainAxis.point]
        });
        const raw = (0, (0, parcelRequire("lUX3m")).getPercentageInRange)({
            startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
            endOfRange: hitbox[mainAxis.end],
            value: client[mainAxis.point]
        });
        return 1 - raw;
    }
    function $b3ae2158089b2ceb$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
        const maxScroll = $b3ae2158089b2ceb$var$getMaxScrollChange({
            timeSinceLastFrame: timeSinceLastFrame,
            config: config
        });
        const percentageDistanceDampening = isDistanceDampeningEnabled ? $b3ae2158089b2ceb$var$getDistanceDampening({
            client: client,
            edge: edge,
            hitbox: hitbox,
            axis: axis,
            config: config
        }) : 1;
        const percentageThroughTimeDampening = (0, (0, parcelRequire("lUX3m")).getPercentageInRange)({
            startOfRange: engagement.timeOfEngagementStart,
            endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
            value: Date.now()
        });
        const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
        const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
        const side = (0, (0, parcelRequire("aHtK2")).mainAxisSideLookup)[edge];
        return side === 'end' ? scroll : -1 * scroll;
    }
});
parcelRegister("lUX3m", function(module, exports) {
    $parcel$export(module.exports, "getPercentageInRange", ()=>$15bc8d2c21c8e1e4$export$1a29de000a332d74);
    function $15bc8d2c21c8e1e4$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
        const isValid = startOfRange < endOfRange;
        if (!isValid) return 0;
        if (value < startOfRange) return 0;
        if (value > endOfRange) return 1;
        const range = endOfRange - startOfRange;
        return (value - startOfRange) / range;
    }
});
parcelRegister("hTDOm", function(module, exports) {
    $parcel$export(module.exports, "isAxisAllowed", ()=>$9d9969f3e7f53880$export$7120fdbd90bd1292);
    function $9d9969f3e7f53880$export$7120fdbd90bd1292(axis, allowedAxis) {
        return allowedAxis === 'all' || axis === allowedAxis;
    }
});
parcelRegister("2dwAb", function(module, exports) {
    $parcel$export(module.exports, "isWithin", ()=>$df40d0415a8c41aa$export$cda7a9d4399bf2e3);
    function $df40d0415a8c41aa$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
        return (client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
    }
});
parcelRegister("biEfA", function(module, exports) {
    $parcel$export(module.exports, "attachClosestEdge", ()=>$934cfe81468fb31a$export$f0cafff222395e89);
    $parcel$export(module.exports, "extractClosestEdge", ()=>$934cfe81468fb31a$export$945a571f3b658bf);
    const $934cfe81468fb31a$var$getDistanceToEdge = {
        top: (rect, client)=>Math.abs(client.y - rect.top),
        right: (rect, client)=>Math.abs(rect.right - client.x),
        bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
        left: (rect, client)=>Math.abs(client.x - rect.left)
    };
    const $934cfe81468fb31a$var$uniqueKey = Symbol('closestEdge');
    function $934cfe81468fb31a$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
        const client = {
            x: input.clientX,
            y: input.clientY
        };
        const rect = element.getBoundingClientRect();
        const entries = allowedEdges.map((edge)=>{
            return {
                edge: edge,
                value: $934cfe81468fb31a$var$getDistanceToEdge[edge](rect, client)
            };
        });
        const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
        return {
            ...userData,
            [$934cfe81468fb31a$var$uniqueKey]: addClosestEdge
        };
    }
    function $934cfe81468fb31a$export$945a571f3b658bf(userData) {
        return userData[$934cfe81468fb31a$var$uniqueKey] ?? null;
    }
});
parcelRegister("3Mh6R", function(module, exports) {
    $parcel$export(module.exports, "useDragAndDropController", ()=>$035422623e37f36e$export$14bdd803fc89a806);
    $parcel$export(module.exports, "useDragAndDropInstance", ()=>$035422623e37f36e$export$eed049f57b5e5e46);
    $parcel$export(module.exports, "useIsDragging", ()=>$035422623e37f36e$export$db01cee314a3998b);
    $parcel$export(module.exports, "useDragIndicator", ()=>$035422623e37f36e$export$adeee9d12d225d8c);
    $parcel$export(module.exports, "useDropIndicator", ()=>$035422623e37f36e$export$8d0e41d2815afac5);
    $parcel$export(module.exports, "useParentIndicator", ()=>$035422623e37f36e$export$2abbcbcd9f8f2785);
    var $3sQ5x;
    var $hQn2A;
    const $035422623e37f36e$export$14bdd803fc89a806 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("hQn2A")).store));
    const $035422623e37f36e$export$eed049f57b5e5e46 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("hQn2A")).store), {
        selector: (state)=>state.instance
    });
    const $035422623e37f36e$export$db01cee314a3998b = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("hQn2A")).store), {
        selector: (state)=>!!state.dragTarget
    });
    const $035422623e37f36e$export$adeee9d12d225d8c = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("hQn2A")).store), {
        selector: (state, index)=>{
            const indicator = state.indicators?.find((indicator)=>indicator.type === (0, $f4bc18652544ec5d$export$ac420e079415a2e4) && indicator.index === index);
            if (indicator?.type === (0, $f4bc18652544ec5d$export$ac420e079415a2e4)) return indicator;
        }
    });
    const $035422623e37f36e$export$8d0e41d2815afac5 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("hQn2A")).store), {
        selector: (state, index)=>{
            const indicator = state.indicators?.find((indicator)=>indicator.type === (0, $f4bc18652544ec5d$export$1ac9dafc96a1c957) && indicator.index === index);
            if (indicator?.type === (0, $f4bc18652544ec5d$export$1ac9dafc96a1c957)) return indicator;
        }
    });
    const $035422623e37f36e$export$2abbcbcd9f8f2785 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("hQn2A")).store), {
        selector: (state, { id: id, index: index })=>{
            const indicator = state.indicators?.find((indicator)=>indicator.type === (0, $f4bc18652544ec5d$export$ce952aa7163824ef) && (index && indicator.index === index || id && indicator.id === id));
            if (indicator?.type === (0, $f4bc18652544ec5d$export$ce952aa7163824ef)) return indicator;
        }
    });
});
const $f4bc18652544ec5d$export$1ac9dafc96a1c957 = 'DROP_INDICATOR';
const $f4bc18652544ec5d$export$ac420e079415a2e4 = 'DRAG_INDICATOR';
const $f4bc18652544ec5d$export$ce952aa7163824ef = 'PARENT_INDICATOR';
parcelRegister("hQn2A", function(module, exports) {
    $parcel$export(module.exports, "DragAndDropContainer", ()=>$951d49a127c2250b$export$8a9522c34145d106);
    $parcel$export(module.exports, "store", ()=>$951d49a127c2250b$export$6f57813fe9f31bf9);
    var $gg7kZ;
    var $iXqE5;
    var $kLuxr;
    const $951d49a127c2250b$export$8a9522c34145d106 = (0, (0, parcelRequire("gg7kZ")).createContainer)();
    const $951d49a127c2250b$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        containedBy: $951d49a127c2250b$export$8a9522c34145d106,
        initialState: {
            instance: Symbol('drag-and-drop-store-instance-id')
        },
        actions: (0, parcelRequire("kLuxr")).actions
    });
});
parcelRegister("kLuxr", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$a719bcb591327f81$export$e324594224ef24da);
    const $a719bcb591327f81$export$e324594224ef24da = {
        initialize: (callbacks)=>({ setState: setState })=>{
                setState({
                    ...callbacks
                });
            },
        onDragStart: (dragTarget)=>({ getState: getState, setState: setState })=>{
                const { onDragStart: onDragStart } = getState();
                setState({
                    dragTarget: dragTarget
                });
                onDragStart?.(dragTarget);
            },
        onDrag: (dropTarget)=>({ getState: getState, setState: setState })=>{
                const { dragTarget: dragTarget, onDrag: onDrag, getIndicators: getIndicators } = getState();
                setState({
                    dropTarget: dropTarget
                });
                if (!dragTarget) throw Error('No drag target found.');
                onDrag?.(dragTarget, dropTarget);
                setState({
                    indicators: getIndicators?.(dragTarget, dropTarget)
                });
            },
        onDropTargetChange: (dropTarget)=>({ getState: getState, setState: setState })=>{
                const { dragTarget: dragTarget, getIndicators: getIndicators } = getState();
                setState({
                    dropTarget: dropTarget
                });
                if (!dragTarget) throw Error('No drag target found.');
                setState({
                    indicators: getIndicators?.(dragTarget, dropTarget)
                });
            },
        onDrop: (dragTarget, dropTarget)=>({ getState: getState, setState: setState })=>{
                const { onDrop: onDrop } = getState();
                setState({
                    dragTarget: undefined,
                    dropTarget: undefined,
                    indicators: undefined
                });
                if (!dropTarget) return;
                onDrop?.(dragTarget, dropTarget);
            }
    };
});
parcelRegister("avpM4", function(module, exports) {
    $parcel$export(module.exports, "getDragTarget", ()=>$ceebb67379fbac45$export$29b4da8694ef9d7a);
    $parcel$export(module.exports, "getDropTarget", ()=>$ceebb67379fbac45$export$9b669f4b54bc51b9);
    var $biEfA;
    const $ceebb67379fbac45$export$29b4da8694ef9d7a = (target)=>{
        const { index: index, instance: instance } = target.data;
        if (typeof index !== 'number' || typeof instance !== 'symbol') throw Error('Invalid field in drag target');
        return {
            index: index,
            instance: instance
        };
    };
    const $ceebb67379fbac45$export$9b669f4b54bc51b9 = (target)=>{
        if (target === undefined) return undefined;
        const { index: index, instance: instance } = target.data;
        const closestEdge = (0, (0, parcelRequire("biEfA")).extractClosestEdge)(target.data);
        if (typeof index !== 'number' || typeof instance !== 'symbol') throw Error('Invalid field in drop target');
        return {
            index: index,
            instance: instance,
            closestEdge: closestEdge
        };
    };
});
parcelRegister("5OG52", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fca1e8465b94ab49$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ingq;
    var $ebd3R;
    var $99gkn;
    var $eTXmK;
    var $co1wz;
    var $ousew;
    var $1Cyfv = parcelRequire("1Cyfv");
    var $9V5En = parcelRequire("9V5En");
    var $g0ekm = parcelRequire("g0ekm");
    var $h6q34 = parcelRequire("h6q34");
    function $fca1e8465b94ab49$var$IssuesWithoutParent({ id: id, isExpanded: isExpanded = false, level: { title: title }, onToggle: onToggle, rankDigits: rankDigits, rootIssuesCount: rootIssuesCount, outerRef: outerRef }) {
        const handleOnToggle = (event)=>{
            if (isExpanded !== null) {
                if (isExpanded) (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).COLLAPSE_ISSUE_WITHOUT_PARENT, event.timeStamp);
                else (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).EXPAND_ISSUE_WITHOUT_PARENT, event.timeStamp);
                (0, (0, parcelRequire("99gkn")).addUFOCustomData)({
                    scalingFactors: {
                        rootIssuesCount: rootIssuesCount
                    }
                });
            }
            onToggle({
                [id]: !isExpanded
            });
        };
        const getContentIcon = ()=>{
            if (rootIssuesCount > 0) return isExpanded === true ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                label: ""
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))), {
                label: ""
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $h6q34.icon
            });
        };
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: outerRef,
            className: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? $h6q34.container : $h6q34.containerOld
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $h6q34.rank,
            style: {
                width: 10 * rankDigits,
                minWidth: 10 * rankDigits
            }
        }), getContentIcon(), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $h6q34.summary
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $g0ekm.default).level,
            values: {
                levelTitle: title,
                issuesCount: rootIssuesCount
            }
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9V5En.default), {
            onClick: handleOnToggle,
            className: $h6q34.toggleButton,
            "data-name": "toggleIssueWithoutParent",
            ariaExpanded: isExpanded
        }, content);
    }
    var $fca1e8465b94ab49$export$2e2bcd8739ae039 = $fca1e8465b94ab49$var$IssuesWithoutParent;
});
parcelRegister("9V5En", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6640bdabedbcf6ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aCpcO;
    var $eICWj = parcelRequire("eICWj");
    function $6640bdabedbcf6ad$export$2e2bcd8739ae039({ className: className, style: style, ariaExpanded: ariaExpanded, ...restProps }) {
        const styleObject = style ?? {};
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            className: `${className ?? ''} ${$eICWj.cellButton}`,
            style: {
                width: '100%',
                textAlign: 'left',
                height: 'calc(100% - 4px)',
                padding: '0px',
                ...styleObject
            },
            "aria-expanded": ariaExpanded,
            ...restProps
        });
    }
});
parcelRegister("eICWj", function(module, exports) {
    $parcel$export(module.exports, "cellButton", ()=>$ab736153f40912a4$export$dd94d7ecfe010714, (v)=>$ab736153f40912a4$export$dd94d7ecfe010714 = v);
    var $ab736153f40912a4$export$dd94d7ecfe010714;
    $ab736153f40912a4$export$dd94d7ecfe010714 = `Wh34OW_cellButton`;
});
parcelRegister("g0ekm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca420c586c9b4343$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ca420c586c9b4343$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        level: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issues-without-parent.level",
            "defaultMessage": "{levelTitle} \u2013 {issuesCount, plural, one {# issue} other {# issues}}"
        }
    });
});
parcelRegister("h6q34", function(module, exports) {
    $parcel$export(module.exports, "container", ()=>$c73733ec133052c7$export$34e0f9847d4c02dd, (v)=>$c73733ec133052c7$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "containerOld", ()=>$c73733ec133052c7$export$4e6d0512d9a636b9, (v)=>$c73733ec133052c7$export$4e6d0512d9a636b9 = v);
    $parcel$export(module.exports, "icon", ()=>$c73733ec133052c7$export$1ca1ec8b29a4ce27, (v)=>$c73733ec133052c7$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "rank", ()=>$c73733ec133052c7$export$fbc8bcd33b574fbc, (v)=>$c73733ec133052c7$export$fbc8bcd33b574fbc = v);
    $parcel$export(module.exports, "summary", ()=>$c73733ec133052c7$export$9a2dbef7a17e2e58, (v)=>$c73733ec133052c7$export$9a2dbef7a17e2e58 = v);
    $parcel$export(module.exports, "toggleButton", ()=>$c73733ec133052c7$export$c3f9788a1ddcf2d9, (v)=>$c73733ec133052c7$export$c3f9788a1ddcf2d9 = v);
    var $c73733ec133052c7$export$34e0f9847d4c02dd;
    var $c73733ec133052c7$export$4e6d0512d9a636b9;
    var $c73733ec133052c7$export$1ca1ec8b29a4ce27;
    var $c73733ec133052c7$export$fbc8bcd33b574fbc;
    var $c73733ec133052c7$export$9a2dbef7a17e2e58;
    var $c73733ec133052c7$export$c3f9788a1ddcf2d9;
    $c73733ec133052c7$export$34e0f9847d4c02dd = `iawNsq_container`;
    $c73733ec133052c7$export$4e6d0512d9a636b9 = `iawNsq_containerOld`;
    $c73733ec133052c7$export$1ca1ec8b29a4ce27 = `iawNsq_icon`;
    $c73733ec133052c7$export$fbc8bcd33b574fbc = `iawNsq_rank`;
    $c73733ec133052c7$export$9a2dbef7a17e2e58 = `iawNsq_summary`;
    $c73733ec133052c7$export$c3f9788a1ddcf2d9 = `iawNsq_toggleButton`;
});
parcelRegister("eMIwl", function(module, exports) {
    $parcel$export(module.exports, "Group", ()=>$25b1870ee56a9ab1$export$eb2fcfdbd7ba97d4);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $7EeBN = parcelRequire("7EeBN");
    const $25b1870ee56a9ab1$export$eb2fcfdbd7ba97d4 = ({ item: item })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $25b1870ee56a9ab1$var$containerStyles
        }, item && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7EeBN.default), {
            isStickyGroupHeader: true,
            item: item
        }));
    const $25b1870ee56a9ab1$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative'
    });
});
parcelRegister("7EeBN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99c83d36a5debf78$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9GQOf = parcelRequire("9GQOf");
    var $71nKI = parcelRequire("71nKI");
    var $hGKkg = parcelRequire("hGKkg");
    var $99c83d36a5debf78$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $71nKI.default), (0, $9GQOf.default))((0, $hGKkg.default));
});
parcelRegister("9GQOf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d38240ec23c9704$export$2e2bcd8739ae039);
    var $dBbgF = parcelRequire("dBbgF");
    var $3d38240ec23c9704$export$2e2bcd8739ae039 = (dispatch)=>({
            toggleExpandGroup: (payload)=>dispatch((0, $dBbgF.toggleExpandGroup)(payload))
        });
});
parcelRegister("71nKI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3b1720dfa2921c6$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $5nMRY = parcelRequire("5nMRY");
    var $jw86H = parcelRequire("jw86H");
    var $19iju = parcelRequire("19iju");
    var $bZA5o = parcelRequire("bZA5o");
    var $jpXKt = parcelRequire("jpXKt");
    var $d3quy = parcelRequire("d3quy");
    var $dRVQG = parcelRequire("dRVQG");
    var $9FFuD = parcelRequire("9FFuD");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $b3b1720dfa2921c6$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        additionalTeamsById: (0, $dRVQG.getAdditionalTeamsById),
        allTeams: (0, $dRVQG.getAllTeams),
        componentGroupsById: (0, $kWDpn.getComponentGroupsById),
        componentsById: (0, $5nMRY.getComponentsById),
        crossProjectVersionsById: (0, $jw86H.getCrossProjectVersionsById),
        customFieldsById: (0, $19iju.getCustomFieldsById),
        enrichedVersionsById: (0, $9FFuD.getEnrichedVersionsById),
        isExportMode: $1CGdp.isExportMode,
        projectsById: (0, $jpXKt.getProjectsById),
        sprints: (0, $d3quy.getSprints),
        viewMode: (0, $kWDpn.getViewMode),
        lazyGoalsByARI: (0, $bZA5o.getLazyGoalsByARI)
    });
});
parcelRegister("hGKkg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80c3ee5d63375708$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $fn8B5 = parcelRequire("fn8B5");
    var $hGgHi = parcelRequire("hGgHi");
    var $9PTGo = parcelRequire("9PTGo");
    var $ujWmd;
    var $1dJ6S;
    var $bP37O;
    var $h8cgU;
    var $jUUuf;
    var $c8Oei;
    var $hWZau;
    var $lj8SI;
    var $3bDjY;
    var $co1wz;
    var $koVbs;
    var $apXzN;
    var $4T9Cd;
    var $6NSIr;
    var $3J2mc;
    var $cb04i;
    var $1FeOe;
    var $jLI87 = parcelRequire("jLI87");
    var $6iNxz = parcelRequire("6iNxz");
    var $jHacM = parcelRequire("jHacM");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $ihPUd = parcelRequire("ihPUd");
    var $dVxof;
    var $gyPMD = parcelRequire("gyPMD");
    var $9sbn4 = parcelRequire("9sbn4");
    const $80c3ee5d63375708$var$groupIcons = {
        [(0, $TTKUQ.GROUPING).ASSIGNEE]: undefined,
        [(0, $TTKUQ.GROUPING).REPORTER]: undefined,
        [(0, $TTKUQ.GROUPING).COMPONENT]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bP37O"))))), {
            key: "component",
            label: "Folder icon"
        }),
        [(0, $TTKUQ.GROUPING).LABEL]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bP37O"))))), {
            key: "label",
            label: "Folder icon"
        }),
        [(0, $TTKUQ.GROUPING).NONE]: undefined,
        [(0, $TTKUQ.GROUPING).PROJECT]: undefined,
        [(0, $TTKUQ.GROUPING).RELEASE]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jUUuf"))))), {
            key: "release",
            label: "Ship icon"
        }),
        [(0, $TTKUQ.GROUPING).SPRINT]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jHacM.default), {
            key: "sprint",
            label: "Sprint icon"
        }),
        [(0, $TTKUQ.GROUPING).TEAM]: undefined,
        [(0, $TTKUQ.GROUPING).GOALS]: undefined,
        [(0, $TTKUQ.GROUPING).IDEAS]: undefined
    };
    const $80c3ee5d63375708$var$UNASSIGNED_GOALS_GROUP = 'goals-UNDEFINED';
    const $80c3ee5d63375708$var$UNASSIGNED_IDEAS_GROUP = 'ideas-UNDEFINED';
    const $80c3ee5d63375708$export$97eeb400c5f33310 = ({ grouping: grouping, isExportMode: isExportMode, url: url = '', hasChildGroups: hasChildGroups = false, groupName: groupName, customFieldsById: customFieldsById })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (hasChildGroups) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bP37O"))))), {
            label: formatMessage((0, $gyPMD.default).folderIconLabel)
        });
        if (grouping === (0, $TTKUQ.GROUPING).TEAM) {
            if (url && !isExportMode) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "small",
                src: url
            });
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $9sbn4.defaultTeamAvatar
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))), {
                label: formatMessage((0, $gyPMD.default).peopleIconLabel),
                size: "small"
            })));
        }
        if ((0, $cScrq.isRoadmapGroupedByCustomField)(grouping)) {
            const fieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
            if (!(0, ($parcel$interopDefault($hGgHi)))(customFieldsById) && !(0, ($parcel$interopDefault($hGgHi)))(customFieldsById[fieldId]) && customFieldsById[fieldId].type.key === (0, $TTKUQ.CustomFieldTypes).UserPicker) {
                if (isExportMode) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6NSIr")).default), {
                    size: 24,
                    name: groupName
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    size: "small",
                    src: url
                });
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bP37O"))))), {
                key: grouping,
                label: formatMessage((0, $gyPMD.default).folderIconLabel)
            });
        }
        if (typeof $80c3ee5d63375708$var$groupIcons[grouping] !== 'undefined') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, $80c3ee5d63375708$var$groupIcons[grouping]);
        if (isExportMode) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6NSIr")).default), {
            size: 24,
            name: groupName
        });
        if (grouping === (0, $TTKUQ.GROUPING).ASSIGNEE || !!url) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "small",
            src: url
        });
        return null;
    };
    const $80c3ee5d63375708$var$getTeamName = (id, allTeams)=>{
        const team = allTeams.find((team)=>team.id === id);
        return team ? team.title : null;
    };
    const $80c3ee5d63375708$var$getGroupName = ({ item: item, allTeams: allTeams, sprints: sprints, formatMessage: formatMessage })=>{
        if (item.tag !== (0, $6iNxz.TABLE_GROUP)) throw new Error(`renderGroup must be called only for TABLE_GROUP item, but ${item.tag} was provided.`);
        let { value: groupName } = item;
        const { grouping: grouping, group: group, childGroups: childGroups } = item;
        if (group === (0, $jLI87.UNDEFINED_GROUP)) groupName = formatMessage((0, $ihPUd.default).unassigned);
        else if (!groupName) switch(grouping){
            case (0, $TTKUQ.GROUPING).COMPONENT:
                groupName = formatMessage((0, $ihPUd.default).allOtherIssues);
                break;
            case (0, $TTKUQ.GROUPING).LABEL:
                groupName = formatMessage((0, $ihPUd.default).allOtherIssues);
                break;
            case (0, $TTKUQ.GROUPING).GOALS:
                groupName = formatMessage((0, $ihPUd.default).allOtherIssues);
                break;
            case (0, $TTKUQ.GROUPING).IDEAS:
                groupName = formatMessage((0, $ihPUd.default).allOtherIssues);
                break;
            case (0, $TTKUQ.GROUPING).TEAM:
                {
                    const teamId = (0, ($parcel$interopDefault($9XE6b)))(item, [
                        'groupCombination',
                        'team'
                    ]);
                    const teamName = $80c3ee5d63375708$var$getTeamName(teamId, allTeams);
                    groupName = !(0, ($parcel$interopDefault($hGgHi)))(teamName) ? teamName : formatMessage((0, $gyPMD.default).unknownTeam);
                    break;
                }
            case (0, $TTKUQ.GROUPING).RELEASE:
                if (item.groupCombination.release === (0, $TTKUQ.COMPLETED_RELEASES_GROUP)) groupName = formatMessage((0, $gyPMD.default).completedReleasesGroup, {
                    count: childGroups ? childGroups.length : ''
                });
                break;
            case (0, $TTKUQ.GROUPING).PROJECT:
                groupName = formatMessage((0, $ihPUd.default).unassigned);
                break;
            case (0, $cScrq.isRoadmapGroupedByCustomField)(grouping) && grouping:
                groupName = formatMessage((0, $ihPUd.default).allOtherIssues);
                break;
            default:
                groupName = formatMessage((0, $ihPUd.default).unassigned);
                break;
        }
        if (grouping === (0, $TTKUQ.GROUPING).SPRINT) {
            if (item.groupCombination.sprint === (0, $TTKUQ.COMPLETED_SPRINTS_GROUP)) groupName = formatMessage((0, $gyPMD.default).completedSprintsGroup, {
                count: childGroups ? Object.keys((0, ($parcel$interopDefault($fn8B5)))(childGroups, (group)=>group.groupCombination && group.groupCombination.sprint || '')).length : ''
            });
            else {
                const sprint = sprints.find((sprint)=>{
                    const sprintId = (0, ($parcel$interopDefault($9XE6b)))(item, [
                        'groupCombination',
                        'sprint'
                    ]);
                    return sprint.id === sprintId;
                });
                groupName = sprint && sprint.title ? sprint.title : formatMessage((0, $ihPUd.default).unassigned);
            }
        }
        return groupName;
    };
    const $80c3ee5d63375708$var$getSecondaryGroupName = (item, enrichedVersionsById, allTeams)=>{
        if (item.tag !== (0, $6iNxz.TABLE_GROUP)) throw new Error(`renderGroup must be called only for TABLE_GROUP item, but ${item.tag} was provided.`);
        let secondaryGroupName;
        const { grouping: grouping } = item;
        if (grouping === (0, $TTKUQ.GROUPING).RELEASE) {
            const versionId = (0, ($parcel$interopDefault($9XE6b)))(item, [
                'groupCombination',
                'release'
            ]);
            const release = !(0, ($parcel$interopDefault($hGgHi)))(versionId) ? enrichedVersionsById[versionId] : undefined;
            secondaryGroupName = release && (release.projects.filter(Boolean).map((project)=>typeof project !== 'number' ? project.name : null).join(', ') || null);
        }
        if (grouping === (0, $TTKUQ.GROUPING).SPRINT && item.groupCombination.sprint !== (0, $TTKUQ.COMPLETED_SPRINTS_GROUP)) secondaryGroupName = $80c3ee5d63375708$var$getTeamName(item.groupCombination.team, allTeams);
        return secondaryGroupName;
    };
    const $80c3ee5d63375708$var$getLozengeTextForGroupByRelease = (item, enrichedVersionsById, crossProjectVersionsById)=>{
        if (item.tag !== (0, $6iNxz.TABLE_GROUP)) throw new Error(`renderGroup must be called only for TABLE_GROUP item, but ${item.tag} was provided.`);
        const versionId = (0, ($parcel$interopDefault($9XE6b)))(item, [
            'groupCombination',
            'release'
        ]);
        const release = !(0, ($parcel$interopDefault($hGgHi)))(versionId) ? enrichedVersionsById[versionId] : undefined;
        return release?.crossProjectVersion && (0, ($parcel$interopDefault($9XE6b)))(crossProjectVersionsById, [
            release.crossProjectVersion,
            'name'
        ]);
    };
    const $80c3ee5d63375708$export$1929c04eb57bfb36 = ({ id: id })=>{
        const [associatedIssues] = (0, (0, parcelRequire("apXzN")).useAssociatedIssues)();
        if (!associatedIssues || !associatedIssues[id]) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4T9Cd")).AssociatedIssuesView), {
            associatedIssues: [
                associatedIssues[id]
            ]
        });
    };
    function $80c3ee5d63375708$var$GroupHeaderComponent({ item: item, toggleExpandGroup: toggleExpandGroup, allTeams: allTeams, additionalTeamsById: additionalTeamsById, isExportMode: isExportMode, componentGroupsById: componentGroupsById, componentsById: componentsById, projectsById: projectsById, enrichedVersionsById: enrichedVersionsById, crossProjectVersionsById: crossProjectVersionsById, groupName: groupName, customFieldsById: customFieldsById, lazyGoalsByARI: lazyGoalsByARI, associatedIssues: associatedIssues, viewMode: viewMode }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (item.tag !== (0, $6iNxz.TABLE_GROUP)) throw new Error(`renderGroup must be called only for TABLE_GROUP item, but ${item.tag} was provided.`);
        const secondaryGroupName = $80c3ee5d63375708$var$getSecondaryGroupName(item, enrichedVersionsById, allTeams);
        const lozengeText = $80c3ee5d63375708$var$getLozengeTextForGroupByRelease(item, enrichedVersionsById, crossProjectVersionsById);
        let componentNames = [];
        const { grouping: grouping, parentGroup: parentGroup, childGroups: childGroups } = item;
        if (grouping === (0, $TTKUQ.GROUPING).COMPONENT) {
            const componentGroup = componentGroupsById[item.groupCombination.components || ''];
            const { components: components = [] } = componentGroup;
            componentNames = components.map((componentId)=>componentsById[componentId]).filter((component)=>!(0, ($parcel$interopDefault($hGgHi)))(component)).map(({ name: name, projectId: projectId })=>`${name} (${projectsById[projectId].key})`);
        }
        const isExternalTeam = !(0, ($parcel$interopDefault($hGgHi)))(item.groupCombination.team) && !(0, ($parcel$interopDefault($hGgHi)))(additionalTeamsById[item.groupCombination.team]);
        const toggle = ()=>toggleExpandGroup({
                grouping: item.grouping,
                groupName: item.group,
                expand: !item.isExpanded
            });
        const onKeyDownHandler = (e)=>{
            if (e.keyCode === 13 || e.keyCode === 32) toggle();
        };
        const renderTooltipForExternalTeam = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9sbn4['tooltip-wrapper']
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
                    className: $9sbn4['tooltip-title']
                }, formatMessage((0, (0, parcelRequire("1FeOe")).default).externalTeamTooltipTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("1FeOe")).default).externalTeamTooltipContent)))
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: isExportMode ? $9sbn4.exportPNGLozenge : $9sbn4['external-lozenge-wrapper']
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, formatMessage((0, (0, parcelRequire("1FeOe")).default).externalLozenge))));
        const isShareableTeamFromGroupItem = ()=>{
            if (!(0, ($parcel$interopDefault($hGgHi)))(item.groupCombination.team)) {
                const teamId = item.groupCombination.team;
                const team = allTeams.find((team)=>team.id === teamId);
                return team ? team.shareable : false;
            }
            return false;
        };
        const renderTooltipForPlanOnlyTeam = ()=>{
            const isShareableTeam = isShareableTeamFromGroupItem();
            const { grouping: grouping, value: value } = item;
            if (grouping !== (0, $TTKUQ.GROUPING).TEAM || value === '') return null;
            if (isExternalTeam || isShareableTeam) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9sbn4['tooltip-wrapper']
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
                    className: $9sbn4['tooltip-title']
                }, formatMessage((0, (0, parcelRequire("1FeOe")).default).planOnlyTeamTooltipTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("1FeOe")).default).planOnlyTeamTooltipContent)))
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: isExportMode ? $9sbn4.exportPNGLozenge : $9sbn4['external-lozenge-wrapper']
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, formatMessage((0, (0, parcelRequire("1FeOe")).default).planOnlyLozenge))));
        };
        const hasParentGroup = !!parentGroup;
        const hasChildGroups = !!childGroups;
        const renderGroupName = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, groupName || ''), !(0, ($parcel$interopDefault($hGgHi)))(secondaryGroupName) && (0, ($parcel$interopDefault($5uXOq))).createElement("small", null, " (", secondaryGroupName, ")"));
        const renderGroupNameContent = ()=>{
            const { group: group } = item;
            if (grouping === (0, $TTKUQ.GROUPING).GOALS && group !== $80c3ee5d63375708$var$UNASSIGNED_GOALS_GROUP) {
                const goalARI = group.replace('goals-', '');
                const { isLoading: isLoading, goal: goal } = lazyGoalsByARI[goalARI] || {};
                if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cb04i")).CellSkeleton), {
                    width: (0, $TTKUQ.DEFAULT_FIELD_WIDTH).MEDIUM
                });
                if (goal) {
                    const { name: name, state: state } = goal;
                    if (name && state) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVxof")).Goal), {
                        name: name,
                        state: state,
                        isExportMode: isExportMode
                    });
                }
                return null;
            }
            if (grouping === (0, $TTKUQ.GROUPING).IDEAS && group !== $80c3ee5d63375708$var$UNASSIGNED_IDEAS_GROUP) {
                if ((0, (0, parcelRequire("co1wz")).ff)('polaris.possibility-of-updating-ideas-in-plans')) {
                    const ideaId = group.replace('ideas-', '');
                    return (0, ($parcel$interopDefault($5uXOq))).createElement($80c3ee5d63375708$export$1929c04eb57bfb36, {
                        id: ideaId
                    });
                }
                return (0, ($parcel$interopDefault($5uXOq))).createElement($80c3ee5d63375708$export$1929c04eb57bfb36, {
                    id: groupName
                });
            }
            return renderGroupName();
        };
        const getTooltipContent = ()=>{
            if (grouping === (0, $TTKUQ.GROUPING).GOALS) return lazyGoalsByARI[groupName]?.goal?.name || groupName;
            if (grouping === (0, $TTKUQ.GROUPING).IDEAS && associatedIssues) return associatedIssues[groupName]?.summary || groupName;
            return groupName;
        };
        const isTransposed = (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') && (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST || (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2'));
        const className = isTransposed ? 'group-details-transposed' : 'group-details';
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $9sbn4[className],
            role: "button",
            tabIndex: 0,
            onClick: toggle,
            onKeyDown: onKeyDownHandler,
            "data-role": "header",
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.group-header",
            "aria-expanded": item.isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: `${$9sbn4['group-chevron']} ${hasParentGroup ? $9sbn4.hasParentGroup : ''}`
        }, item.isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            label: "",
            LEGACY_size: "large",
            color: "currentColor"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
            label: "",
            LEGACY_size: "large",
            color: "currentColor"
        })), grouping !== (0, $TTKUQ.GROUPING).GOALS && grouping !== (0, $TTKUQ.GROUPING).IDEAS && (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $9sbn4.groupingAvatar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($80c3ee5d63375708$export$97eeb400c5f33310, {
            customFieldsById: customFieldsById,
            grouping: item.grouping,
            url: item.url,
            isExportMode: isExportMode,
            hasChildGroups: hasChildGroups,
            groupName: groupName || ''
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $9sbn4['group-title']
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "mouse",
            content: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $9sbn4.tooltip
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                as: "h6",
                size: "xxsmall"
            }, getTooltipContent() || ''), componentNames.length !== 0 && (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, componentNames.join(', ')), !(0, ($parcel$interopDefault($hGgHi)))(secondaryGroupName) && (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, "(", secondaryGroupName, ")"))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `group-name ${$9sbn4.groupName}`,
            id: `group-name-${item.group.replace(/\s/g, '')}`
        }, renderGroupNameContent()))), isExternalTeam ? renderTooltipForExternalTeam() : null, renderTooltipForPlanOnlyTeam(), lozengeText && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: isExportMode ? $9sbn4.exportPNGLozenge : $9sbn4['external-lozenge-wrapper']
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, lozengeText)));
    }
    const $80c3ee5d63375708$var$SortableGroupHeaderComponent = (0, $9PTGo.SortableElement)($80c3ee5d63375708$var$GroupHeaderComponent);
    const $80c3ee5d63375708$var$Group = ({ item: item, allTeams: allTeams, sprints: sprints, isStickyGroupHeader: isStickyGroupHeader = false, style: style, key: key = '', index: index, lazyGoalsByARI: lazyGoalsByARI, ...props })=>{
        const { group: group } = item;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (item.tag !== (0, $6iNxz.TABLE_GROUP)) throw new Error(`renderGroup must be called only for TABLE_GROUP item, but ${item.tag} was provided.`);
        const [associatedIssues] = (0, (0, parcelRequire("apXzN")).useAssociatedIssues)();
        const groupName = $80c3ee5d63375708$var$getGroupName({
            item: item,
            allTeams: allTeams,
            sprints: sprints,
            formatMessage: formatMessage
        }) ?? '';
        const elementKey = `${item.tag}-${group || ''}-${groupName || key || ''}`;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            key: elementKey,
            ...style && {
                style: style
            },
            className: $9sbn4.groupRow
        }, isStickyGroupHeader ? (0, ($parcel$interopDefault($5uXOq))).createElement($80c3ee5d63375708$var$GroupHeaderComponent, {
            item: item,
            groupName: groupName,
            allTeams: allTeams,
            lazyGoalsByARI: lazyGoalsByARI,
            associatedIssues: associatedIssues,
            ...props
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($80c3ee5d63375708$var$SortableGroupHeaderComponent, {
            index: index,
            item: item,
            groupName: groupName,
            allTeams: allTeams,
            lazyGoalsByARI: lazyGoalsByARI,
            associatedIssues: associatedIssues,
            ...props
        })));
    };
    var $80c3ee5d63375708$export$2e2bcd8739ae039 = $80c3ee5d63375708$var$Group;
});
parcelRegister("9PTGo", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.arrayMove = module.exports.sortableHandle = module.exports.sortableElement = module.exports.sortableContainer = module.exports.SortableHandle = module.exports.SortableElement = module.exports.SortableContainer = undefined;
    var $9zFOa = parcelRequire("9zFOa");
    Object.defineProperty(module.exports, 'arrayMove', {
        enumerable: true,
        get: function get() {
            return $9zFOa.arrayMove;
        }
    });
    var $UyoS5 = parcelRequire("UyoS5");
    var $729411e637a9142c$var$_SortableContainer3 = $729411e637a9142c$var$_interopRequireDefault($UyoS5);
    var $59AUM = parcelRequire("59AUM");
    var $729411e637a9142c$var$_SortableElement3 = $729411e637a9142c$var$_interopRequireDefault($59AUM);
    var $j20nQ = parcelRequire("j20nQ");
    var $729411e637a9142c$var$_SortableHandle3 = $729411e637a9142c$var$_interopRequireDefault($j20nQ);
    function $729411e637a9142c$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    module.exports.SortableContainer = $729411e637a9142c$var$_SortableContainer3.default;
    module.exports.SortableElement = $729411e637a9142c$var$_SortableElement3.default;
    module.exports.SortableHandle = $729411e637a9142c$var$_SortableHandle3.default;
    module.exports.sortableContainer = $729411e637a9142c$var$_SortableContainer3.default;
    module.exports.sortableElement = $729411e637a9142c$var$_SortableElement3.default;
    module.exports.sortableHandle = $729411e637a9142c$var$_SortableHandle3.default;
});
parcelRegister("9zFOa", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.vendorPrefix = module.exports.events = undefined;
    module.exports.arrayMove = $6f87d02722f19cb3$var$arrayMove;
    module.exports.omit = $6f87d02722f19cb3$var$omit;
    module.exports.closest = $6f87d02722f19cb3$var$closest;
    module.exports.limit = $6f87d02722f19cb3$var$limit;
    module.exports.getElementMargin = $6f87d02722f19cb3$var$getElementMargin;
    module.exports.provideDisplayName = $6f87d02722f19cb3$var$provideDisplayName;
    module.exports.getPosition = $6f87d02722f19cb3$var$getPosition;
    module.exports.isTouchEvent = $6f87d02722f19cb3$var$isTouchEvent;
    module.exports.getEdgeOffset = $6f87d02722f19cb3$var$getEdgeOffset;
    module.exports.getLockPixelOffset = $6f87d02722f19cb3$var$getLockPixelOffset;
    var $aE1Lc = parcelRequire("aE1Lc");
    var $6f87d02722f19cb3$var$_invariant2 = $6f87d02722f19cb3$var$_interopRequireDefault($aE1Lc);
    function $6f87d02722f19cb3$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $6f87d02722f19cb3$var$arrayMove(arr, previousIndex, newIndex) {
        var array = arr.slice(0);
        if (newIndex >= array.length) {
            var k = newIndex - array.length;
            while(k-- + 1)array.push(undefined);
        }
        array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
        return array;
    }
    function $6f87d02722f19cb3$var$omit(obj) {
        for(var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)keysToOmit[_key - 1] = arguments[_key];
        return Object.keys(obj).reduce(function(acc, key) {
            if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
            return acc;
        }, {});
    }
    var $6f87d02722f19cb3$var$events = module.exports.events = {
        start: [
            'touchstart',
            'mousedown'
        ],
        move: [
            'touchmove',
            'mousemove'
        ],
        end: [
            'touchend',
            'touchcancel',
            'mouseup'
        ]
    };
    var $6f87d02722f19cb3$var$vendorPrefix = module.exports.vendorPrefix = function() {
        if (typeof window === 'undefined' || typeof document === 'undefined') return '';
        var styles = window.getComputedStyle(document.documentElement, '') || [
            '-moz-hidden-iframe'
        ];
        var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && [
            '',
            'o'
        ])[1];
        switch(pre){
            case 'ms':
                return 'ms';
            default:
                return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
        }
    }();
    function $6f87d02722f19cb3$var$closest(el, fn) {
        while(el){
            if (fn(el)) return el;
            el = el.parentNode;
        }
    }
    function $6f87d02722f19cb3$var$limit(min, max, value) {
        if (value < min) return min;
        if (value > max) return max;
        return value;
    }
    function $6f87d02722f19cb3$var$getCSSPixelValue(stringValue) {
        if (stringValue.substr(-2) === 'px') return parseFloat(stringValue);
        return 0;
    }
    function $6f87d02722f19cb3$var$getElementMargin(element) {
        var style = window.getComputedStyle(element);
        return {
            top: $6f87d02722f19cb3$var$getCSSPixelValue(style.marginTop),
            right: $6f87d02722f19cb3$var$getCSSPixelValue(style.marginRight),
            bottom: $6f87d02722f19cb3$var$getCSSPixelValue(style.marginBottom),
            left: $6f87d02722f19cb3$var$getCSSPixelValue(style.marginLeft)
        };
    }
    function $6f87d02722f19cb3$var$provideDisplayName(prefix, Component) {
        var componentName = Component.displayName || Component.name;
        return componentName ? prefix + '(' + componentName + ')' : prefix;
    }
    function $6f87d02722f19cb3$var$getPosition(event) {
        if (event.touches && event.touches.length) return {
            x: event.touches[0].pageX,
            y: event.touches[0].pageY
        };
        else if (event.changedTouches && event.changedTouches.length) return {
            x: event.changedTouches[0].pageX,
            y: event.changedTouches[0].pageY
        };
        else return {
            x: event.pageX,
            y: event.pageY
        };
    }
    function $6f87d02722f19cb3$var$isTouchEvent(event) {
        return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
    }
    function $6f87d02722f19cb3$var$getEdgeOffset(node, parent) {
        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            top: 0,
            left: 0
        };
        if (node) {
            var nodeOffset = {
                top: offset.top + node.offsetTop,
                left: offset.left + node.offsetLeft
            };
            if (node.parentNode !== parent) return $6f87d02722f19cb3$var$getEdgeOffset(node.parentNode, parent, nodeOffset);
            else return nodeOffset;
        }
    }
    function $6f87d02722f19cb3$var$getLockPixelOffset(_ref) {
        var lockOffset = _ref.lockOffset, width = _ref.width, height = _ref.height;
        var offsetX = lockOffset;
        var offsetY = lockOffset;
        var unit = 'px';
        if (typeof lockOffset === 'string') {
            var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
            (0, $6f87d02722f19cb3$var$_invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a number followed by "px" or "%". Given %s', lockOffset);
            offsetX = offsetY = parseFloat(lockOffset);
            unit = match[1];
        }
        (0, $6f87d02722f19cb3$var$_invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);
        if (unit === '%') {
            offsetX = offsetX * width / 100;
            offsetY = offsetY * height / 100;
        }
        return {
            x: offsetX,
            y: offsetY
        };
    }
});
parcelRegister("UyoS5", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $0a9fea3b2dd23f3e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var $0a9fea3b2dd23f3e$var$_slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var $0a9fea3b2dd23f3e$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    module.exports.default = $0a9fea3b2dd23f3e$var$sortableContainer;
    var $5uXOq = parcelRequire("5uXOq");
    var $0a9fea3b2dd23f3e$var$_react2 = $0a9fea3b2dd23f3e$var$_interopRequireDefault($5uXOq);
    var $8rCP3;
    var $0a9fea3b2dd23f3e$var$_propTypes2 = $0a9fea3b2dd23f3e$var$_interopRequireDefault((0, parcelRequire("8rCP3")));
    var $7nsd3 = parcelRequire("7nsd3");
    var $aE1Lc = parcelRequire("aE1Lc");
    var $0a9fea3b2dd23f3e$var$_invariant2 = $0a9fea3b2dd23f3e$var$_interopRequireDefault($aE1Lc);
    var $bh2xz = parcelRequire("bh2xz");
    var $0a9fea3b2dd23f3e$var$_Manager2 = $0a9fea3b2dd23f3e$var$_interopRequireDefault($bh2xz);
    var $9zFOa = parcelRequire("9zFOa");
    function $0a9fea3b2dd23f3e$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $0a9fea3b2dd23f3e$var$_toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    }
    function $0a9fea3b2dd23f3e$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $0a9fea3b2dd23f3e$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $0a9fea3b2dd23f3e$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function $0a9fea3b2dd23f3e$var$sortableContainer(WrappedComponent) {
        var _class, _temp;
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            withRef: false
        };
        return _temp = _class = function(_Component) {
            $0a9fea3b2dd23f3e$var$_inherits(_class, _Component);
            function _class(props) {
                $0a9fea3b2dd23f3e$var$_classCallCheck(this, _class);
                var _this = $0a9fea3b2dd23f3e$var$_possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
                _this.handleStart = function(event) {
                    var _this$props = _this.props, distance = _this$props.distance, shouldCancelStart = _this$props.shouldCancelStart;
                    if (event.button === 2 || shouldCancelStart(event)) return false;
                    _this._touched = true;
                    _this._pos = (0, $9zFOa.getPosition)(event);
                    var node = (0, $9zFOa.closest)(event.target, function(el) {
                        return el.sortableInfo != null;
                    });
                    if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
                        var useDragHandle = _this.props.useDragHandle;
                        var _node$sortableInfo = node.sortableInfo, index = _node$sortableInfo.index, collection = _node$sortableInfo.collection;
                        if (useDragHandle && !(0, $9zFOa.closest)(event.target, function(el) {
                            return el.sortableHandle != null;
                        })) return;
                        _this.manager.active = {
                            index: index,
                            collection: collection
                        };
                        if (!(0, $9zFOa.isTouchEvent)(event) && event.target.tagName.toLowerCase() === 'a') event.preventDefault();
                        if (!distance) {
                            if (_this.props.pressDelay === 0) _this.handlePress(event);
                            else _this.pressTimer = setTimeout(function() {
                                return _this.handlePress(event);
                            }, _this.props.pressDelay);
                        }
                    }
                };
                _this.nodeIsChild = function(node) {
                    return node.sortableInfo.manager === _this.manager;
                };
                _this.handleMove = function(event) {
                    var _this$props2 = _this.props, distance = _this$props2.distance, pressThreshold = _this$props2.pressThreshold;
                    if (!_this.state.sorting && _this._touched) {
                        var position = (0, $9zFOa.getPosition)(event);
                        var delta = _this._delta = {
                            x: _this._pos.x - position.x,
                            y: _this._pos.y - position.y
                        };
                        var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
                        if (!distance && (!pressThreshold || pressThreshold && combinedDelta >= pressThreshold)) {
                            clearTimeout(_this.cancelTimer);
                            _this.cancelTimer = setTimeout(_this.cancel, 0);
                        } else if (distance && combinedDelta >= distance && _this.manager.isActive()) _this.handlePress(event);
                    }
                };
                _this.handleEnd = function() {
                    _this._touched = false;
                    _this.cancel();
                };
                _this.cancel = function() {
                    var distance = _this.props.distance;
                    var sorting = _this.state.sorting;
                    if (!sorting) {
                        if (!distance) clearTimeout(_this.pressTimer);
                        _this.manager.active = null;
                    }
                };
                _this.handlePress = function(event) {
                    var active = _this.manager.getActive();
                    if (active) {
                        var _this$props3 = _this.props, axis = _this$props3.axis, getHelperDimensions = _this$props3.getHelperDimensions, helperClass = _this$props3.helperClass, hideSortableGhost = _this$props3.hideSortableGhost, onSortStart = _this$props3.onSortStart, useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
                        var node = active.node, collection = active.collection;
                        var index = node.sortableInfo.index;
                        var margin = (0, $9zFOa.getElementMargin)(node);
                        var containerBoundingRect = _this.container.getBoundingClientRect();
                        var dimensions = getHelperDimensions({
                            index: index,
                            node: node,
                            collection: collection
                        });
                        _this.node = node;
                        _this.margin = margin;
                        _this.width = dimensions.width;
                        _this.height = dimensions.height;
                        _this.marginOffset = {
                            x: _this.margin.left + _this.margin.right,
                            y: Math.max(_this.margin.top, _this.margin.bottom)
                        };
                        _this.boundingClientRect = node.getBoundingClientRect();
                        _this.containerBoundingRect = containerBoundingRect;
                        _this.index = index;
                        _this.newIndex = index;
                        _this.axis = {
                            x: axis.indexOf('x') >= 0,
                            y: axis.indexOf('y') >= 0
                        };
                        _this.offsetEdge = (0, $9zFOa.getEdgeOffset)(node, _this.container);
                        _this.initialOffset = (0, $9zFOa.getPosition)(event);
                        _this.initialScroll = {
                            top: _this.container.scrollTop,
                            left: _this.container.scrollLeft
                        };
                        _this.initialWindowScroll = {
                            top: window.pageYOffset,
                            left: window.pageXOffset
                        };
                        var fields = node.querySelectorAll('input, textarea, select');
                        var clonedNode = node.cloneNode(true);
                        var clonedFields = [].concat($0a9fea3b2dd23f3e$var$_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select')));
                        clonedFields.forEach(function(field, index) {
                            if (field.type !== 'file' && fields[index]) field.value = fields[index].value;
                        });
                        _this.helper = _this.document.body.appendChild(clonedNode);
                        _this.helper.style.position = 'fixed';
                        _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
                        _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
                        _this.helper.style.width = _this.width + 'px';
                        _this.helper.style.height = _this.height + 'px';
                        _this.helper.style.boxSizing = 'border-box';
                        _this.helper.style.pointerEvents = 'none';
                        if (hideSortableGhost) {
                            _this.sortableGhost = node;
                            node.style.visibility = 'hidden';
                            node.style.opacity = 0;
                        }
                        _this.minTranslate = {};
                        _this.maxTranslate = {};
                        if (_this.axis.x) {
                            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                        }
                        if (_this.axis.y) {
                            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                        }
                        if (helperClass) {
                            var _this$helper$classLis;
                            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, $0a9fea3b2dd23f3e$var$_toConsumableArray(helperClass.split(' ')));
                        }
                        _this.listenerNode = event.touches ? node : _this.contentWindow;
                        $9zFOa.events.move.forEach(function(eventName) {
                            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                        });
                        $9zFOa.events.end.forEach(function(eventName) {
                            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                        });
                        _this.setState({
                            sorting: true,
                            sortingIndex: index
                        });
                        if (onSortStart) onSortStart({
                            node: node,
                            index: index,
                            collection: collection
                        }, event);
                    }
                };
                _this.handleSortMove = function(event) {
                    var onSortMove = _this.props.onSortMove;
                    event.preventDefault();
                    _this.updatePosition(event);
                    _this.animateNodes();
                    _this.autoscroll();
                    if (onSortMove) onSortMove(event);
                };
                _this.handleSortEnd = function(event) {
                    var _this$props4 = _this.props, hideSortableGhost = _this$props4.hideSortableGhost, onSortEnd = _this$props4.onSortEnd;
                    var collection = _this.manager.active.collection;
                    if (_this.listenerNode) {
                        $9zFOa.events.move.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
                        });
                        $9zFOa.events.end.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
                        });
                    }
                    _this.helper.parentNode.removeChild(_this.helper);
                    if (hideSortableGhost && _this.sortableGhost) {
                        _this.sortableGhost.style.visibility = '';
                        _this.sortableGhost.style.opacity = '';
                    }
                    var nodes = _this.manager.refs[collection];
                    for(var i = 0, len = nodes.length; i < len; i++){
                        var node = nodes[i];
                        var el = node.node;
                        node.edgeOffset = null;
                        el.style[$9zFOa.vendorPrefix + 'Transform'] = '';
                        el.style[$9zFOa.vendorPrefix + 'TransitionDuration'] = '';
                    }
                    clearInterval(_this.autoscrollInterval);
                    _this.autoscrollInterval = null;
                    _this.manager.active = null;
                    _this.setState({
                        sorting: false,
                        sortingIndex: null
                    });
                    if (typeof onSortEnd === 'function') onSortEnd({
                        oldIndex: _this.index,
                        newIndex: _this.newIndex,
                        collection: collection
                    }, event);
                    _this._touched = false;
                };
                _this.autoscroll = function() {
                    var translate = _this.translate;
                    var direction = {
                        x: 0,
                        y: 0
                    };
                    var speed = {
                        x: 1,
                        y: 1
                    };
                    var acceleration = {
                        x: 10,
                        y: 10
                    };
                    if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
                        direction.y = 1;
                        speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
                    } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
                        direction.x = 1;
                        speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
                    } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
                        direction.y = -1;
                        speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
                    } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
                        direction.x = -1;
                        speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
                    }
                    if (_this.autoscrollInterval) {
                        clearInterval(_this.autoscrollInterval);
                        _this.autoscrollInterval = null;
                        _this.isAutoScrolling = false;
                    }
                    if (direction.x !== 0 || direction.y !== 0) _this.autoscrollInterval = setInterval(function() {
                        _this.isAutoScrolling = true;
                        var offset = {
                            left: 1 * speed.x * direction.x,
                            top: 1 * speed.y * direction.y
                        };
                        _this.scrollContainer.scrollTop += offset.top;
                        _this.scrollContainer.scrollLeft += offset.left;
                        _this.translate.x += offset.left;
                        _this.translate.y += offset.top;
                        _this.animateNodes();
                    }, 5);
                };
                _this.manager = new $0a9fea3b2dd23f3e$var$_Manager2.default();
                _this.events = {
                    start: _this.handleStart,
                    move: _this.handleMove,
                    end: _this.handleEnd
                };
                (0, $0a9fea3b2dd23f3e$var$_invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
                _this.state = {};
                return _this;
            }
            $0a9fea3b2dd23f3e$var$_createClass(_class, [
                {
                    key: 'getChildContext',
                    value: function getChildContext() {
                        return {
                            manager: this.manager
                        };
                    }
                },
                {
                    key: 'componentDidMount',
                    value: function componentDidMount() {
                        var _this2 = this;
                        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                        var container = this.getContainer();
                        Promise.resolve(container).then(function(containerNode) {
                            _this2.container = containerNode;
                            _this2.document = _this2.container.ownerDocument || document;
                            var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
                            _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
                            _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : _this2.container;
                            var _loop = function _loop(key) {
                                if (_this2.events.hasOwnProperty(key)) $9zFOa.events[key].forEach(function(eventName) {
                                    return _this2.container.addEventListener(eventName, _this2.events[key], false);
                                });
                            };
                            for(var key in _this2.events)_loop(key);
                        });
                    }
                },
                {
                    key: 'componentWillUnmount',
                    value: function componentWillUnmount() {
                        var _this3 = this;
                        if (this.container) {
                            var _loop2 = function _loop2(key) {
                                if (_this3.events.hasOwnProperty(key)) $9zFOa.events[key].forEach(function(eventName) {
                                    return _this3.container.removeEventListener(eventName, _this3.events[key]);
                                });
                            };
                            for(var key in this.events)_loop2(key);
                        }
                    }
                },
                {
                    key: 'getLockPixelOffsets',
                    value: function getLockPixelOffsets() {
                        var width = this.width, height = this.height;
                        var lockOffset = this.props.lockOffset;
                        var offsets = Array.isArray(lockOffset) ? lockOffset : [
                            lockOffset,
                            lockOffset
                        ];
                        (0, $0a9fea3b2dd23f3e$var$_invariant2.default)(offsets.length === 2, "lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given %s", lockOffset);
                        var _offsets = $0a9fea3b2dd23f3e$var$_slicedToArray(offsets, 2), minLockOffset = _offsets[0], maxLockOffset = _offsets[1];
                        return [
                            (0, $9zFOa.getLockPixelOffset)({
                                lockOffset: minLockOffset,
                                width: width,
                                height: height
                            }),
                            (0, $9zFOa.getLockPixelOffset)({
                                lockOffset: maxLockOffset,
                                width: width,
                                height: height
                            })
                        ];
                    }
                },
                {
                    key: 'updatePosition',
                    value: function updatePosition(event) {
                        var _props = this.props, lockAxis = _props.lockAxis, lockToContainerEdges = _props.lockToContainerEdges;
                        var offset = (0, $9zFOa.getPosition)(event);
                        var translate = {
                            x: offset.x - this.initialOffset.x,
                            y: offset.y - this.initialOffset.y
                        };
                        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
                        translate.x -= window.pageXOffset - this.initialWindowScroll.left;
                        this.translate = translate;
                        if (lockToContainerEdges) {
                            var _getLockPixelOffsets = this.getLockPixelOffsets(), _getLockPixelOffsets2 = $0a9fea3b2dd23f3e$var$_slicedToArray(_getLockPixelOffsets, 2), minLockOffset = _getLockPixelOffsets2[0], maxLockOffset = _getLockPixelOffsets2[1];
                            var minOffset = {
                                x: this.width / 2 - minLockOffset.x,
                                y: this.height / 2 - minLockOffset.y
                            };
                            var maxOffset = {
                                x: this.width / 2 - maxLockOffset.x,
                                y: this.height / 2 - maxLockOffset.y
                            };
                            translate.x = (0, $9zFOa.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
                            translate.y = (0, $9zFOa.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
                        }
                        if (lockAxis === 'x') translate.y = 0;
                        else if (lockAxis === 'y') translate.x = 0;
                        this.helper.style[$9zFOa.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
                    }
                },
                {
                    key: 'animateNodes',
                    value: function animateNodes() {
                        var _props2 = this.props, transitionDuration = _props2.transitionDuration, hideSortableGhost = _props2.hideSortableGhost, onSortOver = _props2.onSortOver;
                        var nodes = this.manager.getOrderedRefs();
                        var containerScrollDelta = {
                            left: this.container.scrollLeft - this.initialScroll.left,
                            top: this.container.scrollTop - this.initialScroll.top
                        };
                        var sortingOffset = {
                            left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
                            top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
                        };
                        var windowScrollDelta = {
                            top: window.pageYOffset - this.initialWindowScroll.top,
                            left: window.pageXOffset - this.initialWindowScroll.left
                        };
                        var prevIndex = this.newIndex;
                        this.newIndex = null;
                        for(var i = 0, len = nodes.length; i < len; i++){
                            var node = nodes[i].node;
                            var index = node.sortableInfo.index;
                            var width = node.offsetWidth;
                            var height = node.offsetHeight;
                            var offset = {
                                width: this.width > width ? width / 2 : this.width / 2,
                                height: this.height > height ? height / 2 : this.height / 2
                            };
                            var translate = {
                                x: 0,
                                y: 0
                            };
                            var edgeOffset = nodes[i].edgeOffset;
                            if (!edgeOffset) nodes[i].edgeOffset = edgeOffset = (0, $9zFOa.getEdgeOffset)(node, this.container);
                            var nextNode = i < nodes.length - 1 && nodes[i + 1];
                            var prevNode = i > 0 && nodes[i - 1];
                            if (nextNode && !nextNode.edgeOffset) nextNode.edgeOffset = (0, $9zFOa.getEdgeOffset)(nextNode.node, this.container);
                            if (index === this.index) {
                                if (hideSortableGhost) {
                                    this.sortableGhost = node;
                                    node.style.visibility = 'hidden';
                                    node.style.opacity = 0;
                                }
                                continue;
                            }
                            if (transitionDuration) node.style[$9zFOa.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
                            if (this.axis.x) {
                                if (this.axis.y) {
                                    if (index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                                        translate.x = this.width + this.marginOffset.x;
                                        if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                                            translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                                        }
                                        if (this.newIndex === null) this.newIndex = index;
                                    } else if (index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                                        translate.x = -(this.width + this.marginOffset.x);
                                        if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                                            translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                                        }
                                        this.newIndex = index;
                                    }
                                } else {
                                    if (index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                                        translate.x = -(this.width + this.marginOffset.x);
                                        this.newIndex = index;
                                    } else if (index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                                        translate.x = this.width + this.marginOffset.x;
                                        if (this.newIndex == null) this.newIndex = index;
                                    }
                                }
                            } else if (this.axis.y) {
                                if (index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
                                    translate.y = -(this.height + this.marginOffset.y);
                                    this.newIndex = index;
                                } else if (index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
                                    translate.y = this.height + this.marginOffset.y;
                                    if (this.newIndex == null) this.newIndex = index;
                                }
                            }
                            node.style[$9zFOa.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
                        }
                        if (this.newIndex == null) this.newIndex = this.index;
                        if (onSortOver && this.newIndex !== prevIndex) onSortOver({
                            newIndex: this.newIndex,
                            oldIndex: prevIndex,
                            index: this.index,
                            collection: this.manager.active.collection
                        });
                    }
                },
                {
                    key: 'getWrappedInstance',
                    value: function getWrappedInstance() {
                        (0, $0a9fea3b2dd23f3e$var$_invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
                        return this.refs.wrappedInstance;
                    }
                },
                {
                    key: 'getContainer',
                    value: function getContainer() {
                        var getContainer = this.props.getContainer;
                        if (typeof getContainer !== 'function') return (0, $7nsd3.findDOMNode)(this);
                        return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
                    }
                },
                {
                    key: 'render',
                    value: function render() {
                        var ref = config.withRef ? 'wrappedInstance' : null;
                        return $0a9fea3b2dd23f3e$var$_react2.default.createElement(WrappedComponent, $0a9fea3b2dd23f3e$var$_extends({
                            ref: ref
                        }, (0, $9zFOa.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
                    }
                }
            ]);
            return _class;
        }($5uXOq.Component), _class.displayName = (0, $9zFOa.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
            axis: 'y',
            transitionDuration: 300,
            pressDelay: 0,
            pressThreshold: 5,
            distance: 0,
            useWindowAsScrollContainer: false,
            hideSortableGhost: true,
            shouldCancelStart: function shouldCancelStart(e) {
                var disabledElements = [
                    'input',
                    'textarea',
                    'select',
                    'option',
                    'button'
                ];
                if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) return true;
            },
            lockToContainerEdges: false,
            lockOffset: '50%',
            getHelperDimensions: function getHelperDimensions(_ref) {
                var node = _ref.node;
                return {
                    width: node.offsetWidth,
                    height: node.offsetHeight
                };
            }
        }, _class.propTypes = {
            axis: $0a9fea3b2dd23f3e$var$_propTypes2.default.oneOf([
                'x',
                'y',
                'xy'
            ]),
            distance: $0a9fea3b2dd23f3e$var$_propTypes2.default.number,
            lockAxis: $0a9fea3b2dd23f3e$var$_propTypes2.default.string,
            helperClass: $0a9fea3b2dd23f3e$var$_propTypes2.default.string,
            transitionDuration: $0a9fea3b2dd23f3e$var$_propTypes2.default.number,
            contentWindow: $0a9fea3b2dd23f3e$var$_propTypes2.default.any,
            onSortStart: $0a9fea3b2dd23f3e$var$_propTypes2.default.func,
            onSortMove: $0a9fea3b2dd23f3e$var$_propTypes2.default.func,
            onSortOver: $0a9fea3b2dd23f3e$var$_propTypes2.default.func,
            onSortEnd: $0a9fea3b2dd23f3e$var$_propTypes2.default.func,
            shouldCancelStart: $0a9fea3b2dd23f3e$var$_propTypes2.default.func,
            pressDelay: $0a9fea3b2dd23f3e$var$_propTypes2.default.number,
            useDragHandle: $0a9fea3b2dd23f3e$var$_propTypes2.default.bool,
            useWindowAsScrollContainer: $0a9fea3b2dd23f3e$var$_propTypes2.default.bool,
            hideSortableGhost: $0a9fea3b2dd23f3e$var$_propTypes2.default.bool,
            lockToContainerEdges: $0a9fea3b2dd23f3e$var$_propTypes2.default.bool,
            lockOffset: $0a9fea3b2dd23f3e$var$_propTypes2.default.oneOfType([
                $0a9fea3b2dd23f3e$var$_propTypes2.default.number,
                $0a9fea3b2dd23f3e$var$_propTypes2.default.string,
                $0a9fea3b2dd23f3e$var$_propTypes2.default.arrayOf($0a9fea3b2dd23f3e$var$_propTypes2.default.oneOfType([
                    $0a9fea3b2dd23f3e$var$_propTypes2.default.number,
                    $0a9fea3b2dd23f3e$var$_propTypes2.default.string
                ]))
            ]),
            getContainer: $0a9fea3b2dd23f3e$var$_propTypes2.default.func,
            getHelperDimensions: $0a9fea3b2dd23f3e$var$_propTypes2.default.func
        }, _class.childContextTypes = {
            manager: $0a9fea3b2dd23f3e$var$_propTypes2.default.object.isRequired
        }, _temp;
    }
});
parcelRegister("bh2xz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $835340ba4050c58d$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function $835340ba4050c58d$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var $835340ba4050c58d$var$Manager = function() {
        function Manager() {
            $835340ba4050c58d$var$_classCallCheck(this, Manager);
            this.refs = {};
        }
        $835340ba4050c58d$var$_createClass(Manager, [
            {
                key: "add",
                value: function add(collection, ref) {
                    if (!this.refs[collection]) this.refs[collection] = [];
                    this.refs[collection].push(ref);
                }
            },
            {
                key: "remove",
                value: function remove(collection, ref) {
                    var index = this.getIndex(collection, ref);
                    if (index !== -1) this.refs[collection].splice(index, 1);
                }
            },
            {
                key: "isActive",
                value: function isActive() {
                    return this.active;
                }
            },
            {
                key: "getActive",
                value: function getActive() {
                    var _this = this;
                    return this.refs[this.active.collection].find(function(_ref) {
                        var node = _ref.node;
                        return node.sortableInfo.index == _this.active.index;
                    });
                }
            },
            {
                key: "getIndex",
                value: function getIndex(collection, ref) {
                    return this.refs[collection].indexOf(ref);
                }
            },
            {
                key: "getOrderedRefs",
                value: function getOrderedRefs() {
                    var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
                    return this.refs[collection].sort($835340ba4050c58d$var$sortByIndex);
                }
            }
        ]);
        return Manager;
    }();
    module.exports.default = $835340ba4050c58d$var$Manager;
    function $835340ba4050c58d$var$sortByIndex(_ref2, _ref3) {
        var index1 = _ref2.node.sortableInfo.index;
        var index2 = _ref3.node.sortableInfo.index;
        return index1 - index2;
    }
});
parcelRegister("59AUM", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3c0a6d84648e3641$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var $3c0a6d84648e3641$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    module.exports.default = $3c0a6d84648e3641$var$sortableElement;
    var $5uXOq = parcelRequire("5uXOq");
    var $3c0a6d84648e3641$var$_react2 = $3c0a6d84648e3641$var$_interopRequireDefault($5uXOq);
    var $8rCP3;
    var $3c0a6d84648e3641$var$_propTypes2 = $3c0a6d84648e3641$var$_interopRequireDefault((0, parcelRequire("8rCP3")));
    var $7nsd3 = parcelRequire("7nsd3");
    var $aE1Lc = parcelRequire("aE1Lc");
    var $3c0a6d84648e3641$var$_invariant2 = $3c0a6d84648e3641$var$_interopRequireDefault($aE1Lc);
    var $9zFOa = parcelRequire("9zFOa");
    function $3c0a6d84648e3641$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $3c0a6d84648e3641$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $3c0a6d84648e3641$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $3c0a6d84648e3641$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function $3c0a6d84648e3641$var$sortableElement(WrappedComponent) {
        var _class, _temp;
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            withRef: false
        };
        return _temp = _class = function(_Component) {
            $3c0a6d84648e3641$var$_inherits(_class, _Component);
            function _class() {
                $3c0a6d84648e3641$var$_classCallCheck(this, _class);
                return $3c0a6d84648e3641$var$_possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }
            $3c0a6d84648e3641$var$_createClass(_class, [
                {
                    key: 'componentDidMount',
                    value: function componentDidMount() {
                        var _props = this.props, collection = _props.collection, disabled = _props.disabled, index = _props.index;
                        if (!disabled) this.setDraggable(collection, index);
                    }
                },
                {
                    key: 'componentWillReceiveProps',
                    value: function componentWillReceiveProps(nextProps) {
                        if (this.props.index !== nextProps.index && this.node) this.node.sortableInfo.index = nextProps.index;
                        if (this.props.disabled !== nextProps.disabled) {
                            var collection = nextProps.collection, disabled = nextProps.disabled, index = nextProps.index;
                            if (disabled) this.removeDraggable(collection);
                            else this.setDraggable(collection, index);
                        } else if (this.props.collection !== nextProps.collection) {
                            this.removeDraggable(this.props.collection);
                            this.setDraggable(nextProps.collection, nextProps.index);
                        }
                    }
                },
                {
                    key: 'componentWillUnmount',
                    value: function componentWillUnmount() {
                        var _props2 = this.props, collection = _props2.collection, disabled = _props2.disabled;
                        if (!disabled) this.removeDraggable(collection);
                    }
                },
                {
                    key: 'setDraggable',
                    value: function setDraggable(collection, index) {
                        var node = this.node = (0, $7nsd3.findDOMNode)(this);
                        node.sortableInfo = {
                            index: index,
                            collection: collection,
                            manager: this.context.manager
                        };
                        this.ref = {
                            node: node
                        };
                        this.context.manager.add(collection, this.ref);
                    }
                },
                {
                    key: 'removeDraggable',
                    value: function removeDraggable(collection) {
                        this.context.manager.remove(collection, this.ref);
                    }
                },
                {
                    key: 'getWrappedInstance',
                    value: function getWrappedInstance() {
                        (0, $3c0a6d84648e3641$var$_invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
                        return this.refs.wrappedInstance;
                    }
                },
                {
                    key: 'render',
                    value: function render() {
                        var ref = config.withRef ? 'wrappedInstance' : null;
                        return $3c0a6d84648e3641$var$_react2.default.createElement(WrappedComponent, $3c0a6d84648e3641$var$_extends({
                            ref: ref
                        }, (0, $9zFOa.omit)(this.props, 'collection', 'disabled', 'index')));
                    }
                }
            ]);
            return _class;
        }($5uXOq.Component), _class.displayName = (0, $9zFOa.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
            manager: $3c0a6d84648e3641$var$_propTypes2.default.object.isRequired
        }, _class.propTypes = {
            index: $3c0a6d84648e3641$var$_propTypes2.default.number.isRequired,
            collection: $3c0a6d84648e3641$var$_propTypes2.default.oneOfType([
                $3c0a6d84648e3641$var$_propTypes2.default.number,
                $3c0a6d84648e3641$var$_propTypes2.default.string
            ]),
            disabled: $3c0a6d84648e3641$var$_propTypes2.default.bool
        }, _class.defaultProps = {
            collection: 0
        }, _temp;
    }
});
parcelRegister("j20nQ", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $ddae80680bbbb646$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var $ddae80680bbbb646$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    module.exports.default = $ddae80680bbbb646$var$sortableHandle;
    var $5uXOq = parcelRequire("5uXOq");
    var $ddae80680bbbb646$var$_react2 = $ddae80680bbbb646$var$_interopRequireDefault($5uXOq);
    var $7nsd3 = parcelRequire("7nsd3");
    var $aE1Lc = parcelRequire("aE1Lc");
    var $ddae80680bbbb646$var$_invariant2 = $ddae80680bbbb646$var$_interopRequireDefault($aE1Lc);
    var $9zFOa = parcelRequire("9zFOa");
    function $ddae80680bbbb646$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $ddae80680bbbb646$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $ddae80680bbbb646$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $ddae80680bbbb646$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function $ddae80680bbbb646$var$sortableHandle(WrappedComponent) {
        var _class, _temp;
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            withRef: false
        };
        return _temp = _class = function(_Component) {
            $ddae80680bbbb646$var$_inherits(_class, _Component);
            function _class() {
                $ddae80680bbbb646$var$_classCallCheck(this, _class);
                return $ddae80680bbbb646$var$_possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }
            $ddae80680bbbb646$var$_createClass(_class, [
                {
                    key: 'componentDidMount',
                    value: function componentDidMount() {
                        var node = (0, $7nsd3.findDOMNode)(this);
                        node.sortableHandle = true;
                    }
                },
                {
                    key: 'getWrappedInstance',
                    value: function getWrappedInstance() {
                        (0, $ddae80680bbbb646$var$_invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
                        return this.refs.wrappedInstance;
                    }
                },
                {
                    key: 'render',
                    value: function render() {
                        var ref = config.withRef ? 'wrappedInstance' : null;
                        return $ddae80680bbbb646$var$_react2.default.createElement(WrappedComponent, $ddae80680bbbb646$var$_extends({
                            ref: ref
                        }, this.props));
                    }
                }
            ]);
            return _class;
        }($5uXOq.Component), _class.displayName = (0, $9zFOa.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
    }
});
parcelRegister("4T9Cd", function(module, exports) {
    $parcel$export(module.exports, "AssociatedIssuesView", ()=>$235ffba8bc268a8c$export$93fe1358fa69465a);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $dC5iT;
    var $8CUq3;
    const $235ffba8bc268a8c$var$Issue = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $235ffba8bc268a8c$var$container
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $235ffba8bc268a8c$var$avatar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            src: props.data.iconUrl,
            size: "xsmall"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $235ffba8bc268a8c$var$summary
        }, props.data.summary));
    const $235ffba8bc268a8c$export$93fe1358fa69465a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", null, props.associatedIssues.map((associatedIssue)=>(0, ($parcel$interopDefault($5uXOq))).createElement($235ffba8bc268a8c$var$Issue, {
                key: associatedIssue.key,
                data: associatedIssue
            })));
    const $235ffba8bc268a8c$var$container = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        paddingInlineEnd: 'space.100',
        height: '100%'
    });
    const $235ffba8bc268a8c$var$avatar = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineEnd: 'space.050',
        flexShrink: 0
    });
    const $235ffba8bc268a8c$var$summary = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        flexBasis: 'content',
        flexShrink: 1
    });
});
parcelRegister("6NSIr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30ae90a28f096730$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ivIKM = parcelRequire("ivIKM");
    function $30ae90a28f096730$export$2e2bcd8739ae039({ name: name, size: size = 24 }) {
        if (!name) return null;
        const names = name.split(' ');
        if (names.length === 0) return null;
        const displayText = `${names[0][0]}${names.length > 1 ? names[names.length - 1][0] : ''}`;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $ivIKM.wrapper,
            style: {
                width: size,
                height: size
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $ivIKM.initials,
            style: {
                fontSize: size * 0.525
            }
        }, displayText)));
    }
});
parcelRegister("ivIKM", function(module, exports) {
    $parcel$export(module.exports, "initials", ()=>$d79dd659052e0c56$export$82a129a7016c8ea8, (v)=>$d79dd659052e0c56$export$82a129a7016c8ea8 = v);
    $parcel$export(module.exports, "wrapper", ()=>$d79dd659052e0c56$export$cc74dcc53cfce4eb, (v)=>$d79dd659052e0c56$export$cc74dcc53cfce4eb = v);
    var $d79dd659052e0c56$export$82a129a7016c8ea8;
    var $d79dd659052e0c56$export$cc74dcc53cfce4eb;
    $d79dd659052e0c56$export$82a129a7016c8ea8 = `wnXJHq_initials`;
    $d79dd659052e0c56$export$cc74dcc53cfce4eb = `wnXJHq_wrapper`;
});
parcelRegister("jHacM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$712a181c51ae76fa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $eMBuA = parcelRequire("eMBuA");
    function $712a181c51ae76fa$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: "",
            dangerouslySetGlyph: (0, ($parcel$interopDefault($eMBuA))),
            ...props
        });
    }
});
parcelRegister("eMBuA", function(module, exports) {
    module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n<svg width=\"24px\" height=\"24px\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <defs>\n        <path d=\"M0 0h24v24H0V0zm13 14v7h10v-6l-5-5-5 4z\" id=\"a\"></path>\n    </defs>\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(0 1)\">\n            <mask id=\"b\" fill=\"#fff\">\n                <use xlink:href=\"#a\"></use>\n            </mask>\n            <g mask=\"url(#b)\" stroke=\"#42526E\" stroke-width=\"2\">\n                <circle cx=\"8.5\" cy=\"8.5\" r=\"7.5\" transform=\"translate(5 1)\"></circle>\n            </g>\n        </g>\n        <path fill=\"#42526E\" d=\"M13 17h7v2h-7z\"></path>\n        <path d=\"M17.293 15.707a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L19.586 18l-2.293-2.293z\" fill=\"#42526E\" fill-rule=\"nonzero\"></path>\n        <path d=\"M5.253 17a10.561 10.561 0 0 0 2.081 2H3a1 1 0 0 1 0-2h2.253z\" fill=\"#42526E\"></path>\n    </g>\n</svg>";
});
parcelRegister("gyPMD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af5741836fca83cf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $af5741836fca83cf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        externalTeamLozenge: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.external-team-lozenge",
            "defaultMessage": "EXTERNAL"
        },
        externalTeamTooltipTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.external-team-tooltip-title",
            "defaultMessage": "Team currently not in this plan"
        },
        externalTeamTooltipContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.external-team-tooltip-content",
            "defaultMessage": "While this team isn't in this plan, it's appearing because it's assigned to issues in the plan."
        },
        unknownTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.unknown-team",
            "defaultMessage": "Unknown team (not included in plan)"
        },
        completedSprintsGroup: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.completed-sprints-group",
            "defaultMessage": "{count} completed {count, plural, one {sprint} other {sprints}}"
        },
        completedReleasesGroup: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.completed-releases-group",
            "defaultMessage": "{count} completed {count, plural, one {release} other {releases}}"
        },
        folderIconLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.folder-icon-label",
            "defaultMessage": "Folder icon"
        },
        peopleIconLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.people-icon-label",
            "defaultMessage": "People icon"
        },
        avatarLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.avatar-label",
            "defaultMessage": "Team avatar"
        }
    });
});
parcelRegister("9sbn4", function(module, exports) {
    $parcel$export(module.exports, "defaultTeamAvatar", ()=>$6e1f8ca8b5656017$export$aa80651379a69724, (v)=>$6e1f8ca8b5656017$export$aa80651379a69724 = v);
    $parcel$export(module.exports, "exportPNGLozenge", ()=>$6e1f8ca8b5656017$export$1ec0dee322814bb4, (v)=>$6e1f8ca8b5656017$export$1ec0dee322814bb4 = v);
    $parcel$export(module.exports, "external-lozenge-wrapper", ()=>$6e1f8ca8b5656017$export$33826dff95c4e59c, (v)=>$6e1f8ca8b5656017$export$33826dff95c4e59c = v);
    $parcel$export(module.exports, "group-chevron", ()=>$6e1f8ca8b5656017$export$477d29495b2764b8, (v)=>$6e1f8ca8b5656017$export$477d29495b2764b8 = v);
    $parcel$export(module.exports, "group-details", ()=>$6e1f8ca8b5656017$export$b38e392ce84ba127, (v)=>$6e1f8ca8b5656017$export$b38e392ce84ba127 = v);
    $parcel$export(module.exports, "group-details-transposed", ()=>$6e1f8ca8b5656017$export$c62c7b536b587bce, (v)=>$6e1f8ca8b5656017$export$c62c7b536b587bce = v);
    $parcel$export(module.exports, "group-title", ()=>$6e1f8ca8b5656017$export$afaad7582e91f5f, (v)=>$6e1f8ca8b5656017$export$afaad7582e91f5f = v);
    $parcel$export(module.exports, "groupName", ()=>$6e1f8ca8b5656017$export$f1f4ce1df2235f79, (v)=>$6e1f8ca8b5656017$export$f1f4ce1df2235f79 = v);
    $parcel$export(module.exports, "groupRow", ()=>$6e1f8ca8b5656017$export$26ba1761329d3a7b, (v)=>$6e1f8ca8b5656017$export$26ba1761329d3a7b = v);
    $parcel$export(module.exports, "groupingAvatar", ()=>$6e1f8ca8b5656017$export$7c7a81be5cf6d06a, (v)=>$6e1f8ca8b5656017$export$7c7a81be5cf6d06a = v);
    $parcel$export(module.exports, "hasParentGroup", ()=>$6e1f8ca8b5656017$export$45a1bf0ec5c659ef, (v)=>$6e1f8ca8b5656017$export$45a1bf0ec5c659ef = v);
    $parcel$export(module.exports, "tooltip", ()=>$6e1f8ca8b5656017$export$4e6f96734dfe12f4, (v)=>$6e1f8ca8b5656017$export$4e6f96734dfe12f4 = v);
    $parcel$export(module.exports, "tooltip-title", ()=>$6e1f8ca8b5656017$export$dc125fc2d6481f0d, (v)=>$6e1f8ca8b5656017$export$dc125fc2d6481f0d = v);
    $parcel$export(module.exports, "tooltip-wrapper", ()=>$6e1f8ca8b5656017$export$78aadbba80938a00, (v)=>$6e1f8ca8b5656017$export$78aadbba80938a00 = v);
    var $6e1f8ca8b5656017$export$aa80651379a69724;
    var $6e1f8ca8b5656017$export$1ec0dee322814bb4;
    var $6e1f8ca8b5656017$export$33826dff95c4e59c;
    var $6e1f8ca8b5656017$export$477d29495b2764b8;
    var $6e1f8ca8b5656017$export$b38e392ce84ba127;
    var $6e1f8ca8b5656017$export$c62c7b536b587bce;
    var $6e1f8ca8b5656017$export$afaad7582e91f5f;
    var $6e1f8ca8b5656017$export$f1f4ce1df2235f79;
    var $6e1f8ca8b5656017$export$26ba1761329d3a7b;
    var $6e1f8ca8b5656017$export$7c7a81be5cf6d06a;
    var $6e1f8ca8b5656017$export$45a1bf0ec5c659ef;
    var $6e1f8ca8b5656017$export$4e6f96734dfe12f4;
    var $6e1f8ca8b5656017$export$dc125fc2d6481f0d;
    var $6e1f8ca8b5656017$export$78aadbba80938a00;
    $6e1f8ca8b5656017$export$aa80651379a69724 = `dMdMgW_defaultTeamAvatar`;
    $6e1f8ca8b5656017$export$1ec0dee322814bb4 = `dMdMgW_exportPNGLozenge`;
    $6e1f8ca8b5656017$export$33826dff95c4e59c = `dMdMgW_external-lozenge-wrapper`;
    $6e1f8ca8b5656017$export$477d29495b2764b8 = `dMdMgW_group-chevron`;
    $6e1f8ca8b5656017$export$b38e392ce84ba127 = `dMdMgW_group-details`;
    $6e1f8ca8b5656017$export$c62c7b536b587bce = `dMdMgW_group-details-transposed`;
    $6e1f8ca8b5656017$export$afaad7582e91f5f = `dMdMgW_group-title`;
    $6e1f8ca8b5656017$export$f1f4ce1df2235f79 = `dMdMgW_groupName`;
    $6e1f8ca8b5656017$export$26ba1761329d3a7b = `dMdMgW_groupRow`;
    $6e1f8ca8b5656017$export$7c7a81be5cf6d06a = `dMdMgW_groupingAvatar`;
    $6e1f8ca8b5656017$export$45a1bf0ec5c659ef = `dMdMgW_hasParentGroup`;
    $6e1f8ca8b5656017$export$4e6f96734dfe12f4 = `dMdMgW_tooltip`;
    $6e1f8ca8b5656017$export$dc125fc2d6481f0d = `dMdMgW_tooltip-title`;
    $6e1f8ca8b5656017$export$78aadbba80938a00 = `dMdMgW_tooltip-wrapper`;
});
parcelRegister("3enBw", function(module, exports) {
    $parcel$export(module.exports, "OrphanDropTarget", ()=>$7734f70b1092e1e6$export$5154925d95da4364);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $6mYSR;
    var $aI0i7;
    const $7734f70b1092e1e6$export$5154925d95da4364 = (0, $5uXOq.memo)(()=>{
        const ref = (0, $5uXOq.useRef)(null);
        const [{ row: row }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        (0, (0, parcelRequire("6mYSR")).useDropTarget)(ref, row);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: ref,
            xcss: $7734f70b1092e1e6$var$containerStyles,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.body.orphan-drop-target"
        });
    });
    const $7734f70b1092e1e6$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%'
    });
});
parcelRegister("gzkx8", function(module, exports) {
    $parcel$export(module.exports, "Scope", ()=>$9153cd9a1bde3d2c$export$775b6bb06e53a214);
    var $bC2fB;
    var $kcRcN = parcelRequire("kcRcN");
    var $ch16L = parcelRequire("ch16L");
    var $f38Fv = parcelRequire("f38Fv");
    const $9153cd9a1bde3d2c$export$775b6bb06e53a214 = (0, (0, parcelRequire("bC2fB")).connect)((0, $ch16L.default), (0, $kcRcN.default))((0, $f38Fv.Scope));
});
parcelRegister("kcRcN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96a8a56fd0c78096$export$2e2bcd8739ae039);
    var $21mdo = parcelRequire("21mdo");
    var $96a8a56fd0c78096$export$2e2bcd8739ae039 = (dispatch)=>({
            onToggle: (payload)=>dispatch((0, $21mdo.setIsExpanded)(payload))
        });
});
parcelRegister("ch16L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16e6b6388078dce3$export$2e2bcd8739ae039);
    var $eDjFz = parcelRequire("eDjFz");
    var $1CGdp = parcelRequire("1CGdp");
    var $19iju = parcelRequire("19iju");
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $jLI87 = parcelRequire("jLI87");
    var $kWDpn = parcelRequire("kWDpn");
    var $eIyFU = parcelRequire("eIyFU");
    var $bREsp = parcelRequire("bREsp");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $cScrq = parcelRequire("cScrq");
    const $16e6b6388078dce3$export$74a7083d7abc94c3 = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getVisualisationViewSettings),
        (0, $19iju.getCustomFieldsById)
    ], (viewSetting, customFieldsById)=>{
        const grouping = viewSetting.grouping;
        const customFieldId = (0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping);
        if (customFieldId.length > 0) {
            const fieldType = customFieldsById[Number(customFieldId)]?.type?.key;
            return (0, $cScrq.isMultiSelectCustomField)(fieldType);
        }
        return false;
    });
    const $16e6b6388078dce3$export$fd7f2c7ba5e2fdf8 = (0, $3YtPS.createSelector)([
        (0, $kllqP.getIssueTypes),
        (0, $jpXKt.getProjects)
    ], (issueTypes, projects)=>{
        const id = (0, ($parcel$interopDefault($eDjFz)))('id');
        const issueTypesById = (0, $4nDwW.indexBy)(id, issueTypes);
        const projectsById = (0, $4nDwW.indexBy)(id, projects);
        const enhance = (issue)=>({
                ...issue,
                type: issueTypesById[issue.type] ?? (0, $bREsp.DEFAULT_SCRATCH_ISSUE_TYPE),
                project: projectsById[issue.project]
            });
        return enhance;
    });
    const $16e6b6388078dce3$var$getRankDigits = (0, $3YtPS.createSelector)([
        (0, $jLI87.getScope)
    ], (scope)=>scope.startLevelIssues.rootIssuesCount.toString().length);
    const $16e6b6388078dce3$var$getStartLevel = (0, $3YtPS.createSelector)([
        (0, $jLI87.getScope)
    ], (scope)=>scope.startLevelIssues.level);
    var $16e6b6388078dce3$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        $16e6b6388078dce3$export$fd7f2c7ba5e2fdf8,
        (0, $eIyFU.getWarnings),
        $16e6b6388078dce3$export$74a7083d7abc94c3,
        $16e6b6388078dce3$var$getRankDigits,
        $16e6b6388078dce3$var$getStartLevel,
        (0, $1CGdp.isOptimizedMode)
    ], (enhancer, warnings, isGroupingByMultiSelectCustomField, rankDigits, startLevel, isOptimizedMode)=>({
            enhancer: enhancer,
            warnings: warnings,
            isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField,
            rankDigits: rankDigits,
            startLevel: startLevel,
            isOptimizedMode: isOptimizedMode
        }));
});
parcelRegister("eDjFz", function(module, exports) {
    module.exports = (parcelRequire("juvKU"));
});
parcelRegister("juvKU", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $03a971597a8a2af9$var$func = $lVx1a('get', (parcelRequire("9XE6b")));
    $03a971597a8a2af9$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $03a971597a8a2af9$var$func;
});
parcelRegister("f38Fv", function(module, exports) {
    $parcel$export(module.exports, "Scope", ()=>$dea999df95f1027b$export$775b6bb06e53a214);
    var $5uXOq = parcelRequire("5uXOq");
    var $fWqG2 = parcelRequire("fWqG2");
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $h0P1o;
    var $c12LJ;
    var $2BIZv = parcelRequire("2BIZv");
    var $6D4Es = parcelRequire("6D4Es");
    var $l38L3 = parcelRequire("l38L3");
    var $4nDwW = parcelRequire("4nDwW");
    var $9H7nN = parcelRequire("9H7nN");
    const $dea999df95f1027b$export$775b6bb06e53a214 = (0, $5uXOq.memo)(({ enhancer: enhancer, item: item, warnings: warnings, readonly: readonly, onToggle: onToggle, isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField, rankDigits: rankDigits, startLevel: startLevel, isOptimizedMode: isOptimizedMode, isScrolling: isScrolling })=>{
        const noopRef = (0, $5uXOq.useRef)(null);
        const issue = (0, $5uXOq.useMemo)(()=>enhancer(item.value), [
            enhancer,
            item.value
        ]);
        const hasIndentation = !!item.parentGroup;
        const isOptimizedItem = (0, $5uXOq.useMemo)(()=>{
            let isOptimized = false;
            if (isOptimizedMode && (0, $4nDwW.isDefined)(issue.optimized)) {
                for (const [optimizedKey, optimizedValue] of Object.entries(issue.optimized))if ((0, $l38L3.hasValueChanged)((0, $l38L3.getCurrentValue)(issue, optimizedKey), optimizedValue)) {
                    isOptimized = true;
                    break;
                }
            }
            return isOptimized;
        }, [
            isOptimizedMode,
            issue
        ]);
        const shouldHideIssueRank = ()=>{
            if ((0, ($parcel$interopDefault($fWqG2)))(issue.level)) return (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL) < startLevel;
            return issue.level < startLevel;
        };
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                isOptimizedItem && $dea999df95f1027b$var$optimizedContainerStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $6D4Es.default), {
            issueId: issue.id,
            group: issue.group ?? '',
            toggleSelectedIssues: ()=>null
        }, ({ isSelected: isSelected, hasChildSelected: hasChildSelected, toggleSelected: toggleSelected })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $9H7nN.default), null, (draggableRef, isDragging)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $2BIZv.default), {
                    outerRef: readonly ? noopRef : draggableRef,
                    disabled: readonly,
                    onToggle: onToggle,
                    hideRank: shouldHideIssueRank(),
                    issue: issue,
                    isReadOnly: readonly,
                    isDragging: isDragging,
                    isScrolling: isScrolling,
                    rankDigits: rankDigits,
                    isSelected: isSelected,
                    hasChildSelected: hasChildSelected,
                    toggleSelected: toggleSelected,
                    warnings: warnings,
                    hasIndentation: hasIndentation,
                    groupCombination: item.groupCombination,
                    isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField
                }))));
        if ((0, (0, parcelRequire("4R6GH")).fg)('enable-ai-work-breakdown-in-plans')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h0P1o")).IssueBreakdownEntryPointContextProvider), null, content);
        return content;
    });
    const $dea999df95f1027b$var$stripesLayer = `repeating-linear-gradient(
    135deg,
    transparent,
    ${"var(--ds-background-neutral, rgba(101, 84, 192, 0.1))"} 1px,
    ${"var(--ds-background-neutral, rgba(101, 84, 192, 0.1))"} 16px,
    transparent 17px,
    transparent 28px
)`;
    const $dea999df95f1027b$var$optimizedContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: 'elevation.surface',
        backgroundImage: $dea999df95f1027b$var$stripesLayer
    });
});
parcelRegister("h0P1o", function(module, exports) {
    $parcel$export(module.exports, "IssueBreakdownEntryPointContext", ()=>$f3e4d5ae54c81594$export$97c39e25bbb3a718);
    $parcel$export(module.exports, "IssueBreakdownEntryPointContextProvider", ()=>$f3e4d5ae54c81594$export$d7a035ec61bcc3fd);
    var $5uXOq = parcelRequire("5uXOq");
    var $4mO32;
    var $l37qh;
    var $hisyY;
    const $f3e4d5ae54c81594$export$97c39e25bbb3a718 = (0, (0, parcelRequire("l37qh")).createUseEntryPointContext)();
    const $f3e4d5ae54c81594$export$d7a035ec61bcc3fd = ({ children: children })=>{
        const entryPointResult = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("hisyY")).issueBreakdownDraftList), {});
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f3e4d5ae54c81594$export$97c39e25bbb3a718.Provider, {
            value: entryPointResult
        }, children);
    };
});
parcelRegister("l37qh", function(module, exports) {
    $parcel$export(module.exports, "createUseEntryPointContext", ()=>$6e7e19c2d291c94c$export$41bce2223126846b);
    var $5uXOq = parcelRequire("5uXOq");
    const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>(0, $5uXOq.createContext)({
            entryPointActions: {
                cancelPreload () {},
                load () {},
                preload () {},
                unload () {}
            },
            entryPointReferenceSubject: {
                getValue: ()=>null,
                subscribe: ()=>()=>{}
            },
            stopMetric () {}
        });
});
parcelRegister("hisyY", function(module, exports) {
    $parcel$export(module.exports, "issueBreakdownDraftList", ()=>$080a2ca1f322c445$export$b397ce0f94d9fcab);
    var $eufEc;
    var $fEDBv;
    const $080a2ca1f322c445$export$b397ce0f94d9fcab = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("1NcBG")).then((module)=>module.AsyncIssueBreakdownDraftList), {
            moduleId: "69dd6517"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("1NcBG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hWyRr").then(()=>parcelRequire('auVio'));
});
parcelRegister("2BIZv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66a17c0e948f35c5$export$2e2bcd8739ae039);
    var $3YtPS = parcelRequire("3YtPS");
    var $bC2fB;
    var $kAwek = parcelRequire("kAwek");
    var $eRWcT = parcelRequire("eRWcT");
    var $fGZ3P = parcelRequire("fGZ3P");
    const $66a17c0e948f35c5$var$arePropsEqual = (a, b)=>(0, $3YtPS.equals)(a, b, 256);
    const $66a17c0e948f35c5$export$c175600e334513b4 = (0, (0, parcelRequire("bC2fB")).connect)((0, $eRWcT.default), (0, $kAwek.default), null, {
        areOwnPropsEqual: $66a17c0e948f35c5$var$arePropsEqual,
        areStatePropsEqual: $66a17c0e948f35c5$var$arePropsEqual
    })((0, $fGZ3P.default));
    var $66a17c0e948f35c5$export$2e2bcd8739ae039 = $66a17c0e948f35c5$export$c175600e334513b4;
});
parcelRegister("kAwek", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$847646db1166d9b4$export$2e2bcd8739ae039);
    var $jlryX = parcelRequire("jlryX");
    var $g1lIV = parcelRequire("g1lIV");
    var $847646db1166d9b4$export$2e2bcd8739ae039 = (dispatch)=>({
            startInlineCreate: (payload)=>{
                dispatch((0, $jlryX.startInlineCreate)(payload));
            },
            setIssueBeingEdited: (issueId)=>{
                dispatch((0, $g1lIV.setIssueBeingEdited)(issueId));
            }
        });
});
parcelRegister("eRWcT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1272148d43796cef$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $7bnpM = parcelRequire("7bnpM");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $jpXKt = parcelRequire("jpXKt");
    var $jLI87 = parcelRequire("jLI87");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    const $1272148d43796cef$export$c488400972c3259 = (hierarchyLevels, hierarchyFilter, typeToLevel)=>(issueType)=>{
            const { value: value } = hierarchyFilter;
            const start = Math.min(value.start, typeToLevel(issueType) - 1);
            const end = value.end;
            return hierarchyLevels.filter(({ level: level })=>level <= start && level >= end);
        };
    const $1272148d43796cef$var$getFilteredHierarchyForType = (0, $3YtPS.createSelector)([
        (0, $6Ayrn.getHierarchyLevels),
        (0, $7bnpM.getHierarchyFilter),
        (0, $6Ayrn.getTypeToLevel)
    ], $1272148d43796cef$export$c488400972c3259);
    var $1272148d43796cef$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        activeSearchResultIndex: (0, $jLI87.getActiveSearchResultIndex),
        hasSelectedIssues: (state)=>(0, $bI9dZ.getSelected)(state).size > 0,
        hierarchyLevelsForType: $1272148d43796cef$var$getFilteredHierarchyForType,
        isExportMode: $1CGdp.isExportMode,
        isOptimizedMode: $1CGdp.isOptimizedMode,
        issueSearchResults: (0, $jLI87.searchForIssues),
        projects: (0, $jpXKt.getProjects),
        searchQuery: (0, $jLI87.getSearchQuery),
        showWarning: (state)=>(0, $kWDpn.getWarningViewSettings)(state).showWarning,
        typeToLevel: (0, $6Ayrn.getTypeToLevel),
        viewMode: (0, $kWDpn.getViewMode)
    });
});
parcelRegister("fGZ3P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8d16c076a202ef8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $cTYeP;
    var $2JlG5;
    var $l7aHc;
    var $cb25w;
    var $6Ingq;
    var $ebd3R;
    var $dC5iT;
    var $cgL5K;
    var $eTXmK;
    var $3bDjY;
    var $co1wz;
    var $4R6GH;
    var $7mPT9;
    var $aCpcO;
    var $fAGMJ;
    var $3J2mc;
    var $iwfmd;
    var $J8W7q;
    var $f9Tpd;
    var $i2qlb = parcelRequire("i2qlb");
    var $gaFm9 = parcelRequire("gaFm9");
    var $jLI87 = parcelRequire("jLI87");
    var $2QLMT = parcelRequire("2QLMT");
    var $3ODbh = parcelRequire("3ODbh");
    var $32aSm = parcelRequire("32aSm");
    var $l38L3 = parcelRequire("l38L3");
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $kC16r = parcelRequire("kC16r");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $1Cyfv = parcelRequire("1Cyfv");
    var $bFINk = parcelRequire("bFINk");
    var $8zOmE;
    var $9UraL = parcelRequire("9UraL");
    var $4bZgR = parcelRequire("4bZgR");
    var $lwTdM = parcelRequire("lwTdM");
    var $9OkbL = parcelRequire("9OkbL");
    var $bjso1 = parcelRequire("bjso1");
    var $9J2rn = parcelRequire("9J2rn");
    var $4lFm3 = parcelRequire("4lFm3");
    var $lRZWT = parcelRequire("lRZWT");
    var $l5aiG = parcelRequire("l5aiG");
    var $ldEmK = parcelRequire("ldEmK");
    var $dHAMa = parcelRequire("dHAMa");
    const $a8d16c076a202ef8$var$DIGIT_WIDTH = 8;
    const $a8d16c076a202ef8$var$WARNING_WIDTH = 16;
    const $a8d16c076a202ef8$export$843b17c2f6c72837 = ({ isDragging: isDragging, isOptimized: isOptimized, rootIndex: rootIndex, isSelected: isSelected, isDropParent: isDropParent, isListMode: isListMode = false })=>{
        const isEven = rootIndex === undefined ? false : rootIndex % 2 === 0;
        const isTransposed = (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') && (isListMode || (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2'));
        let classes = '';
        if (isDragging && !isTransposed) classes = $dHAMa.isDragging;
        else if (isOptimized) classes = isEven ? $dHAMa.evenOptimized : $dHAMa.oddOptimized;
        else if (!isTransposed) classes = isEven ? $dHAMa.even : $dHAMa.odd;
        if (isSelected) classes = $dHAMa.isSelected;
        if (isDropParent) classes += ` ${$dHAMa["drop-parent"]}`;
        return classes;
    };
    const $a8d16c076a202ef8$export$c175600e334513b4 = ({ issue: issue, issue: { id: issueId = '', summary: summary, depth: depth, isExpandable: isExpandable, isExpanded: isExpanded, issueKey: issueKey, project: project = {}, rootIndex: rootIndex, type: issueType, group: group = '', originals: originals }, isDropParent: isDropParent, isReadOnly: isReadOnly, isDragging: isDragging, isOptimizedMode: isOptimizedMode, isScrolling: isScrolling, groupCombination: groupCombination = {}, onToggle: onToggle, isSelected: isSelected = false, hasChildSelected: hasChildSelected, rankDigits: rankDigits, hideRank: hideRank, warnings: warnings, showWarning: showWarning, hasIndentation: hasIndentation, issueSearchResults: issueSearchResults, activeSearchResultIndex: activeSearchResultIndex, searchQuery: searchQuery, showTooltip: showTooltip = true, setIssueBeingEdited: setIssueBeingEdited, isExportMode: isExportMode, hierarchyLevelsForType: hierarchyLevelsForType, projects: projects, typeToLevel: typeToLevel, startInlineCreate: startInlineCreate, toggleSelected: toggleSelected, hasSelectedIssues: hasSelectedIssues, isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField, viewMode: viewMode, outerRef: outerRef })=>{
        const [showMeatballButton, setShowMeatballButton] = (0, $5uXOq.useState)(false);
        const [dropMenuIsOpen, setDropMenuIsOpen] = (0, $5uXOq.useState)(false);
        const [isMouseOverIssue, setIsMouseOverIssue] = (0, $5uXOq.useState)(false);
        const [isAiSuggestIssuesPopupOpen, setIsAiSuggestIssuesPopupOpen] = (0, $5uXOq.useState)(false);
        const [optimizeFlyoutTopPosition, setOptimizeFlyoutTopPosition] = (0, $5uXOq.useState)(0);
        const [modalAction, setModalAction] = (0, $5uXOq.useState)(null);
        const innerRef = (0, $5uXOq.useRef)(null);
        const ref = (0, (0, parcelRequire("7mPT9")).default)(innerRef, outerRef);
        const handleToggle = (event)=>{
            if (!issueId) throw new Error('Issue must have id!');
            const idSuffix = Object.keys(groupCombination).length ? `:${(0, $2QLMT.getGroupKey)(groupCombination)}` : '';
            if (isExpanded) (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).COLLAPSE_ISSUE, event.timeStamp);
            else (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).EXPAND_ISSUE, event.timeStamp);
            onToggle({
                [`${issueId}${idSuffix}`]: !isExpanded
            });
        };
        const summaryWithMatchHighlighting = (issueLinkChunks)=>{
            const { searchMatches: searchMatches } = issueSearchResults;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $l5aiG.HighlightSummary), {
                group: group,
                numberOfIssueLinkChunks: issueLinkChunks.length,
                searchMatches: searchMatches,
                summary: summary,
                searchQuery: searchQuery,
                id: issueId,
                activeSearchResultIndex: activeSearchResultIndex
            });
        };
        const isSummaryDirty = ()=>originals && (0, parcelRequire("2JlG5")).default('summary', originals);
        const isDescriptionDirty = ()=>originals && (0, parcelRequire("2JlG5")).default('description', originals);
        const shouldShowSummaryChangeIndicator = ()=>!isOptimizedMode && (isSummaryDirty() || isDescriptionDirty());
        const isRankDirty = ()=>!issueKey || originals && originals.lexoRank;
        const shouldShowRankChangeIndicator = ()=>!isOptimizedMode && isRankDirty();
        const triggerOpenIssueDescriptionDialogAnalytics = (analyticsEvent)=>{
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_ISSUE_SUMMARY_BUTTON.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_ISSUE_SUMMARY_BUTTON, 'arjScopeIssueSummaryBtn', {
                isReadOnly: isReadOnly,
                isScenarioIssue: issue.id.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX)),
                issueTypeId: issue.type.id
            });
        };
        const getIssueSummary = (issueLinkChunks)=>{
            if (isExportMode) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dHAMa.summaryReadView
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $dHAMa.ellipsis
            }, issue.summary ?? ' ')));
            if (!(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition')) {
                const wrappedNode = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    className: $dHAMa.summaryBtn,
                    onClick: (_e, analyticsEvent)=>{
                        setIssueBeingEdited(issue.id);
                        triggerOpenIssueDescriptionDialogAnalytics(analyticsEvent);
                    },
                    appearance: "subtle"
                }, summaryWithMatchHighlighting(issueLinkChunks));
                if (showTooltip) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: issue.summary || ''
                }, wrappedNode);
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $dHAMa.summaryReadView
                }, wrappedNode);
            }
            const wrappedNode = isDragging ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                padding: "space.075"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                weight: "medium"
            }, summaryWithMatchHighlighting(issueLinkChunks))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4bZgR.DraggableButton), {
                onClick: (_e, analyticsEvent)=>{
                    setIssueBeingEdited(issue.id);
                    triggerOpenIssueDescriptionDialogAnalytics(analyticsEvent);
                },
                appearance: "subtle"
            }, summaryWithMatchHighlighting(issueLinkChunks));
            if (showTooltip) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: issue.summary || ''
            }, wrappedNode);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dHAMa.summaryReadView
            }, wrappedNode);
        };
        const shouldShowDropMenu = ()=>!isReadOnly && !isScrolling && !isDragging && (showMeatballButton || dropMenuIsOpen);
        const hoverOut = (fn)=>(...args)=>{
                setShowMeatballButton(false);
                fn(...args);
            };
        const handleDropMenuToggle = ({ isOpen: isOpen })=>setDropMenuIsOpen(isOpen);
        const triggerInlineCreateIssueAnalytics = (analyticsEvent, issueTypeId)=>{
            const analyticsKey = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CREATED_ISSUE_INLINE;
            const [actionSubject, eventAction] = analyticsKey.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), analyticsKey, {
                issueType: issueTypeId
            });
        };
        const handleMeatBallButtonBlurEvent = ()=>{
            setShowMeatballButton(false);
        };
        const toggleAiWorkBreakdownPopup = ({ isOpen: isOpen })=>setIsAiSuggestIssuesPopupOpen(isOpen);
        const dropMenu = ()=>{
            const issueDropMenuOptions = [
                (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_issue_type_create_inline') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lwTdM.default), {
                    key: "create-issue-type-dropdown-menu-item",
                    issue: issue,
                    projects: projects,
                    groupCombination: groupCombination,
                    startInlineCreate: hoverOut(startInlineCreate),
                    isDisabled: isGroupingByMultiSelectCustomField,
                    toggleAiWorkBreakdownPopup: toggleAiWorkBreakdownPopup
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9OkbL.default), {
                    key: "create-issue-dropdown-menu-item",
                    issue: issue,
                    hierarchyLevelsForType: hierarchyLevelsForType,
                    projects: projects,
                    typeToLevel: typeToLevel,
                    startInlineCreate: hoverOut(startInlineCreate),
                    triggerClassName: $dHAMa.addIcon,
                    groupCombination: groupCombination,
                    triggerInlineCreateIssueAnalytics: triggerInlineCreateIssueAnalytics,
                    isDisabled: isGroupingByMultiSelectCustomField,
                    toggleAiWorkBreakdownPopup: toggleAiWorkBreakdownPopup
                }),
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4lFm3.default), {
                    key: "select-issue-dropdown-menu-item",
                    onRequestSelect: hoverOut(toggleSelected)
                }),
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9J2rn.default), {
                    key: "remove-issue-dropdown-menu-item",
                    issue: issue,
                    isDisabled: isGroupingByMultiSelectCustomField,
                    setModalAction: setModalAction
                })
            ];
            if (hasSelectedIssues) issueDropMenuOptions.push((0, ($parcel$interopDefault($5uXOq))).createElement((0, $bjso1.default), {
                key: "rank-issue-dropdown-menu-item",
                issueId: issue.id,
                isSelected: isSelected
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lRZWT.default), {
                onOpenChange: handleDropMenuToggle,
                ariaLabel: issue?.summary,
                handleBlurEvent: handleMeatBallButtonBlurEvent,
                hierarchyLevel: issue.level
            }, issueDropMenuOptions);
        };
        const renderDialog = (0, $5uXOq.useCallback)(()=>{
            if (modalAction === (0, $813368d82e314d52$export$dfe0d1d38e6d3bc8)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ldEmK.default), {
                issueId: issueId,
                issueKey: issueKey,
                projectKey: project.key,
                onClose: ()=>setModalAction(null)
            });
            return null;
        }, [
            modalAction,
            issueId,
            issueKey,
            project.key
        ]);
        const isOptimized = (()=>{
            let isOptimized = false;
            if (isOptimizedMode && (0, $4nDwW.isDefined)(issue.optimized)) {
                for (const [optimizedKey, optimizedValue] of Object.entries(issue.optimized))if ((0, $l38L3.hasValueChanged)((0, $l38L3.getCurrentValue)(issue, optimizedKey), optimizedValue)) {
                    isOptimized = true;
                    break;
                }
            }
            return isOptimized;
        })();
        const onHoverChanged = (hovered)=>{
            let rect = {};
            if (isOptimized) {
                if (innerRef.current) rect = innerRef.current.getBoundingClientRect();
            }
            setShowMeatballButton(hovered);
            setIsMouseOverIssue(hovered);
            setOptimizeFlyoutTopPosition(rect.top);
        };
        const triggerCheckboxChangeAnalytics = (analyticsEvent)=>{
            const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES, {
                selectOption: (0, $3ODbh.TargetTypes).single
            });
        };
        const handleCheckboxChange = (e, analyticsEvent)=>{
            const on = !isSelected;
            const extending = e.nativeEvent instanceof MouseEvent && e.nativeEvent.shiftKey;
            toggleSelected(on, {
                extending: extending,
                targetType: (0, $3ODbh.TargetTypes).single
            });
            if (on) triggerCheckboxChangeAnalytics(analyticsEvent);
        };
        const { searchMatches: searchMatches, hasNestedMatches: hasNestedMatches } = issueSearchResults;
        const issueWarnings = warnings.byIssue[issueId] || [];
        const hasWarnings = !!issueWarnings.length && showWarning;
        const rankWidth = $a8d16c076a202ef8$var$DIGIT_WIDTH * rankDigits;
        const issueLink = issueKey && project.key ? `${project.key}-${issueKey}` : project.key || '';
        const issueLinkChunks = searchQuery.trim() ? (0, $jLI87.splitString)(searchQuery, issueLink) : [];
        const backgroundClassName = $a8d16c076a202ef8$export$843b17c2f6c72837({
            isDragging: isDragging,
            isOptimized: isOptimized,
            rootIndex: rootIndex,
            isSelected: isSelected,
            isDropParent: isDropParent,
            isListMode: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST
        });
        const withNestedMatches = hasNestedMatches[group] && hasNestedMatches[group][issueId];
        const rankContent = ()=>{
            if (hasWarnings) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bFINk.default), {
                warnings: issueWarnings
            });
            if ((0, parcelRequire("cTYeP")).default(issueId, warnings.transitiveIssueIds) && showWarning) {
                const transitiveWarnings = [
                    (0, $gaFm9.misconfiguredChildrenWarning)()
                ];
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bFINk.default), {
                    warnings: transitiveWarnings
                });
            }
            if (!hideRank && depth === 0) return rootIndex + 1;
            return null;
        };
        const getIssueTypeIcon = (issueId, issueType)=>{
            const issueTypeIcon = (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                alt: issueType && issueType.name,
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.issue-icon-${issueId}`,
                src: issueType && issueType.iconUrl,
                className: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? $dHAMa["issue-icon"] : $dHAMa["issue-icon-old"]
            });
            if (isExportMode) return issueTypeIcon;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dHAMa.issueIconTooltipWrapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: issueType ? issueType.name : ''
            }, (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, issueTypeIcon) : issueTypeIcon)));
        };
        const cursorStyle = {
            cursor: isOptimized || isReadOnly ? 'default' : 'pointer'
        };
        const shouldShowFlyout = isOptimized && isMouseOverIssue;
        const shouldLockScroll = shouldShowFlyout || dropMenuIsOpen;
        const onFocusChanged = (event)=>{
            if (event.target === event.currentTarget) setShowMeatballButton(true);
        };
        const onKeyDown = (event)=>{
            if (event.key === 'Tab' && event.shiftKey && event.target === event.currentTarget) setShowMeatballButton(false);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
            onHoverChanged: onHoverChanged
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: cursorStyle,
            className: `${$dHAMa.container} ${backgroundClassName}`,
            "data-issue": issueId,
            "data-name": `scope-issue-${issueId}`,
            "data-group": group,
            ref: ref,
            onFocus: onFocusChanged,
            onKeyDown: onKeyDown,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.row",
            tabIndex: 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9Tpd")).default), {
            enabled: shouldLockScroll
        }), shouldShowFlyout && (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $dHAMa.flyoutPositioner,
            style: {
                top: optimizeFlyoutTopPosition
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $32aSm.default), {
                issue: issue
            }),
            isOpen: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $dHAMa.container
        }))), (0, $4y9A5.getBody)()), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $dHAMa["ranked-gutter"]
        }, shouldShowRankChangeIndicator() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kC16r.default), {
            appearance: "bar"
        })), !isReadOnly && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $dHAMa["select-checkbox"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            isChecked: isSelected || hasChildSelected,
            isIndeterminate: hasChildSelected && !isSelected,
            onChange: handleCheckboxChange,
            testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-${issueId}`,
            "aria-labelledby": `issue-link-${issueId}`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $dHAMa.rank,
            style: {
                width: rankWidth,
                minWidth: $a8d16c076a202ef8$var$WARNING_WIDTH
            },
            "data-name": "rank"
        }, rankContent()), hasIndentation && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $dHAMa["group-indentation"]
        }), (0, parcelRequire("l7aHc")).default((n)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: n,
                className: $dHAMa.icon,
                style: cursorStyle,
                "data-name": "spacer"
            }), depth || 0), isExpandable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            className: `${$dHAMa.icon} ${$dHAMa.toggle} ${withNestedMatches ? $dHAMa["parent-match"] : ''}`,
            onClick: handleToggle,
            "aria-expanded": isExpanded,
            "aria-controls": `issue-link-${issueId}`,
            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.button-${issueId}`,
            "aria-labelledby": `issue-link-${issueId}`
        }, isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
            label: "",
            size: "medium"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))), {
            label: "",
            size: "medium"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $dHAMa.icon,
            style: cursorStyle
        }), getIssueTypeIcon(issueId, issueType), !!project.key && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $l5aiG.HighlightIssueLink), {
            issueKey: issueKey,
            projectKey: project.key,
            issueLinkChunks: issueLinkChunks,
            searchQuery: searchQuery,
            activeMatch: searchMatches[activeSearchResultIndex],
            issueId: issueId,
            group: group
        }), (0, (0, parcelRequire("4R6GH")).fg)('enable-ai-work-breakdown-in-plans') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9UraL.default), {
            groupCombination: groupCombination,
            isOpen: isAiSuggestIssuesPopupOpen,
            issue: issue,
            renderIssueSummary: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $dHAMa.summary,
                    ...triggerProps
                }, getIssueSummary(issueLinkChunks), shouldShowSummaryChangeIndicator() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kC16r.default), null)),
            toggleAiWorkBreakdownPopup: toggleAiWorkBreakdownPopup
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $dHAMa.summary
        }, getIssueSummary(issueLinkChunks), shouldShowSummaryChangeIndicator() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kC16r.default), null)), shouldShowDropMenu() && dropMenu(), renderDialog()));
    };
    $a8d16c076a202ef8$export$c175600e334513b4.displayName = 'Issue';
    $a8d16c076a202ef8$export$c175600e334513b4.whyDidYouRender = true;
    var $a8d16c076a202ef8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()((0, $5uXOq.memo)($a8d16c076a202ef8$export$c175600e334513b4));
});
parcelRegister("fAGMJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0031978bfe7d48d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kkJfY;
    var $a0031978bfe7d48d$export$2e2bcd8739ae039 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { defaultChecked: defaultChecked = false, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            defaultChecked: defaultChecked,
            ref: ref,
            ...rest
        });
    });
});
parcelRegister("kkJfY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3106eb14f9b0a593$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $5JjdN;
    var $kag1C;
    var $7xteU;
    var $hsLv2;
    var $e62YQ;
    const $3106eb14f9b0a593$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $3106eb14f9b0a593$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("5JjdN")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7xteU")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $3106eb14f9b0a593$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kag1C")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hsLv2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e62YQ")).default), null)));
    }));
    $3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
    var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;
});
parcelRegister("kag1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0746a27410bc168$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dV6Te;
    function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
        if (isChecked) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
        return null;
    }
    const $a0746a27410bc168$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;
});
parcelRegister("7xteU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b368d644c230660$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $7b368d644c230660$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $7b368d644c230660$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $7b368d644c230660$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $7b368d644c230660$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $7b368d644c230660$var$baseStyles,
                label && $7b368d644c230660$var$textLabelLayoutStyles,
                isDisabled && $7b368d644c230660$var$disabledStyles,
                $7b368d644c230660$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("hsLv2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce636d67b4ff1120$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ce636d67b4ff1120$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $ce636d67b4ff1120$var$labelTextStyles
        }, children);
    }
});
parcelRegister("e62YQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2156c28a3894cac$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d2156c28a3894cac$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d2156c28a3894cac$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d2156c28a3894cac$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("32aSm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e258925581aa44b$export$2e2bcd8739ae039);
    var $bC2fB;
    var $lkdON = parcelRequire("lkdON");
    var $Dbv4l = parcelRequire("Dbv4l");
    var $5e258925581aa44b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $lkdON.default), {})((0, $Dbv4l.default));
});
parcelRegister("lkdON", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd3f2775e843feaf$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $bHTqr = parcelRequire("bHTqr");
    var $d3quy = parcelRequire("d3quy");
    var $dRVQG = parcelRequire("dRVQG");
    var $9FFuD = parcelRequire("9FFuD");
    var $3YtPS = parcelRequire("3YtPS");
    const $bd3f2775e843feaf$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        customFields: (0, $19iju.getCustomFields),
        dateConfiguration: (0, $bHTqr.getDateConfiguration),
        teams: (0, $dRVQG.getTeams),
        sprints: (0, $d3quy.getAllSprints),
        versions: (0, $9FFuD.getVersions)
    });
    var $bd3f2775e843feaf$export$2e2bcd8739ae039 = $bd3f2775e843feaf$export$c31df4bd766f9c35;
});
parcelRegister("Dbv4l", function(module, exports) {
    $parcel$export(module.exports, "FLYOUT_CONTENT_WIDTH", ()=>$aee1aaae639cb4d9$export$a3c5c8ce6ae3cded);
    $parcel$export(module.exports, "default", ()=>$aee1aaae639cb4d9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RBk4;
    var $lj8SI;
    var $koVbs;
    var $gJZ5D;
    var $5fACX = parcelRequire("5fACX");
    var $90ldD = parcelRequire("90ldD");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $exyTY = parcelRequire("exyTY");
    var $4SUWW = parcelRequire("4SUWW");
    var $b0d40 = parcelRequire("b0d40");
    const $aee1aaae639cb4d9$export$a3c5c8ce6ae3cded = 400;
    const { SPRINT: $aee1aaae639cb4d9$var$SPRINT, ROLL_UP: $aee1aaae639cb4d9$var$ROLL_UP } = (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION);
    const $aee1aaae639cb4d9$var$None = ()=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $4SUWW.none,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.row-flyout-none"
        }, intl.formatMessage({
            ...(0, $exyTY.default).none
        }));
    };
    const $aee1aaae639cb4d9$var$valueOrNone = (value)=>(0, $4nDwW.isDefined)(value) ? value : (0, ($parcel$interopDefault($5uXOq))).createElement($aee1aaae639cb4d9$var$None, null);
    const $aee1aaae639cb4d9$var$currentValueCell = (inferred, key, currentValue)=>{
        if (inferred && key && inferred[key] === $aee1aaae639cb4d9$var$ROLL_UP) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4SUWW.valueWithIcon
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4SUWW.rollUpIcon
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $90ldD.default), {
            primaryColor: `var(--ds-icon-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N200})`,
            size: "medium",
            label: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4SUWW.inferredText
        }, $aee1aaae639cb4d9$var$valueOrNone(currentValue))));
        if (inferred && key && inferred[key] === $aee1aaae639cb4d9$var$SPRINT) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4SUWW.valueWithIcon
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4SUWW.sprintIcon
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            maxWidth: 15
        }, "S")), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4SUWW.inferredText
        }, $aee1aaae639cb4d9$var$valueOrNone(currentValue))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4SUWW.valueWithIcon
        }, $aee1aaae639cb4d9$var$valueOrNone(currentValue));
    };
    const $aee1aaae639cb4d9$var$BarFlyout = ({ issue: issue, teams: teams, sprints: sprints, versions: versions, dateFormat: dateFormat = (0, $TTKUQ.DefaultDateFormat), dateConfiguration: dateConfiguration, customFields: customFields })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const optimizedFields = (0, $b0d40.getOptimizedFields)(issue, teams, sprints, versions, dateFormat, dateConfiguration, customFields, intl);
        const optimizedFieldsCount = optimizedFields.length;
        const style = {
            width: $aee1aaae639cb4d9$export$a3c5c8ce6ae3cded
        };
        const getFieldRow = ({ label: label, currentValue: currentValue, optimizedValue: optimizedValue, delta: delta, inferred: inferred, key: key })=>(0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                key: label
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                className: $4SUWW.label
            }, label), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, $aee1aaae639cb4d9$var$currentValueCell(inferred, key, currentValue)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                label: "",
                primaryColor: `var(--ds-icon-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N200})`,
                size: "small"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, $aee1aaae639cb4d9$var$valueOrNone(optimizedValue), delta && (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $4SUWW.delta
            }, "(", delta, ")"))));
        const rows = optimizedFields.map(getFieldRow);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4SUWW.barFlyout,
            style: style,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.bar-flyout"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, intl.formatMessage({
            ...(0, $exyTY.default).header
        }, {
            optimizedFieldsCount: optimizedFieldsCount
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("table", null, (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", null, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            className: $4SUWW.label
        }, intl.formatMessage({
            ...(0, $exyTY.default).before
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            className: $4SUWW.label
        }, intl.formatMessage({
            ...(0, $exyTY.default).after
        }))), rows)));
    };
    var $aee1aaae639cb4d9$export$2e2bcd8739ae039 = $aee1aaae639cb4d9$var$BarFlyout;
});
parcelRegister("exyTY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3b26add5d42f6b8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c3b26add5d42f6b8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.header",
            "defaultMessage": "{optimizedFieldsCount, plural, one {# value} other {# values}} will be updated:"
        },
        targetDates: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.target-dates",
            "defaultMessage": "{dateFieldTitle}"
        },
        team: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.team",
            "defaultMessage": "Team"
        },
        releases: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.releases",
            "defaultMessage": "{releaseCount, plural, one {Release} other {Releases}}"
        },
        unknownTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.unknown-team",
            "defaultMessage": "Unknown team {id}"
        },
        unknownSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.unknown-sprint",
            "defaultMessage": "Unknown sprint {id}"
        },
        unknownVersion: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.unknown-version",
            "defaultMessage": "Unknown version {id}"
        },
        before: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.before",
            "defaultMessage": "Before"
        },
        after: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.after",
            "defaultMessage": "After"
        },
        none: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.none",
            "defaultMessage": "None"
        }
    });
});
parcelRegister("4SUWW", function(module, exports) {
    $parcel$export(module.exports, "barFlyout", ()=>$38e861921724823d$export$1fa710d2293f25bc, (v)=>$38e861921724823d$export$1fa710d2293f25bc = v);
    $parcel$export(module.exports, "delta", ()=>$38e861921724823d$export$eabbe41f409ce55b, (v)=>$38e861921724823d$export$eabbe41f409ce55b = v);
    $parcel$export(module.exports, "inferredText", ()=>$38e861921724823d$export$e9b0ff3b5f703425, (v)=>$38e861921724823d$export$e9b0ff3b5f703425 = v);
    $parcel$export(module.exports, "label", ()=>$38e861921724823d$export$1237798dc640739a, (v)=>$38e861921724823d$export$1237798dc640739a = v);
    $parcel$export(module.exports, "none", ()=>$38e861921724823d$export$f883a24d5edde77c, (v)=>$38e861921724823d$export$f883a24d5edde77c = v);
    $parcel$export(module.exports, "rollUpIcon", ()=>$38e861921724823d$export$894901fa58357dbf, (v)=>$38e861921724823d$export$894901fa58357dbf = v);
    $parcel$export(module.exports, "sprintIcon", ()=>$38e861921724823d$export$f465bc73cc7bf2e2, (v)=>$38e861921724823d$export$f465bc73cc7bf2e2 = v);
    $parcel$export(module.exports, "valueWithIcon", ()=>$38e861921724823d$export$357cff3c53bd3721, (v)=>$38e861921724823d$export$357cff3c53bd3721 = v);
    var $38e861921724823d$export$1fa710d2293f25bc;
    var $38e861921724823d$export$eabbe41f409ce55b;
    var $38e861921724823d$export$e9b0ff3b5f703425;
    var $38e861921724823d$export$1237798dc640739a;
    var $38e861921724823d$export$f883a24d5edde77c;
    var $38e861921724823d$export$894901fa58357dbf;
    var $38e861921724823d$export$f465bc73cc7bf2e2;
    var $38e861921724823d$export$357cff3c53bd3721;
    $38e861921724823d$export$1fa710d2293f25bc = `xGwiYW_barFlyout`;
    $38e861921724823d$export$eabbe41f409ce55b = `xGwiYW_delta`;
    $38e861921724823d$export$e9b0ff3b5f703425 = `xGwiYW_inferredText`;
    $38e861921724823d$export$1237798dc640739a = `xGwiYW_label`;
    $38e861921724823d$export$f883a24d5edde77c = `xGwiYW_none`;
    $38e861921724823d$export$894901fa58357dbf = `xGwiYW_rollUpIcon`;
    $38e861921724823d$export$f465bc73cc7bf2e2 = `xGwiYW_sprintIcon`;
    $38e861921724823d$export$357cff3c53bd3721 = `xGwiYW_valueWithIcon`;
});
parcelRegister("b0d40", function(module, exports) {
    $parcel$export(module.exports, "getOptimizedFields", ()=>$51b90e42ec482d7f$export$b15f3a64b1de090d);
    var $4Rr1a;
    var $2rMKg;
    var $sqeVT;
    var $aipk9;
    var $flnZx;
    var $l38L3 = parcelRequire("l38L3");
    var $e7HS5 = parcelRequire("e7HS5");
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    var $exyTY = parcelRequire("exyTY");
    const $51b90e42ec482d7f$var$updateJiraWhatChangedMessages = {
        ...(0, $e7HS5.default),
        dueDate: (0, $ihPUd.default).dueDate
    };
    const $51b90e42ec482d7f$var$getTitleOfConfiguredDateField = (field, customFields)=>{
        const customFieldsById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), customFields);
        if (field.type === (0, $5fACX.DATEFIELD_TYPES).CUSTOM) return customFieldsById[field.key] ? customFieldsById[field.key].title : '';
        return $51b90e42ec482d7f$var$updateJiraWhatChangedMessages[field.key].defaultMessage;
    };
    const $51b90e42ec482d7f$var$dateFieldGenerator = (current, optimized, { dateConfiguration: { baselineStartField: baselineStartField, baselineEndField: baselineEndField }, customFields: customFields, key: key, dateFormat: dateFormat, intl: intl }, inferred)=>{
        const formatDateOrUndefined = (date)=>(0, $4nDwW.isDefined)(date) ? (0, (0, parcelRequire("aipk9")).formatDateUTC)(date, dateFormat) : undefined;
        let message = '';
        if (key === 'baselineStart') message = $51b90e42ec482d7f$var$getTitleOfConfiguredDateField(baselineStartField, customFields);
        else if (key === 'baselineEnd') message = $51b90e42ec482d7f$var$getTitleOfConfiguredDateField(baselineEndField, customFields);
        let delta;
        if ((0, $4nDwW.isDefined)(current) && (0, $4nDwW.isDefined)(optimized)) {
            if ((0, (0, parcelRequire("flnZx")).startOfUtcDay)(current) !== (0, (0, parcelRequire("flnZx")).startOfUtcDay)(optimized)) delta = (0, (0, parcelRequire("flnZx")).distanceInWordsWithPolarity)(current, optimized);
        }
        return {
            label: intl.formatMessage((0, $exyTY.default).targetDates, {
                dateFieldTitle: message
            }),
            currentValue: formatDateOrUndefined(current),
            optimizedValue: formatDateOrUndefined(optimized),
            delta: delta,
            inferred: inferred,
            key: key
        };
    };
    const $51b90e42ec482d7f$var$teamFieldGenerator = (current, optimized, { teams: teams, intl: intl })=>{
        const getTeamTitleFromId = (id)=>{
            if (id) {
                const team = teams.find((t)=>t.id === id);
                if (team) return team.title;
                return intl.formatMessage((0, $exyTY.default).unknownTeam, {
                    id: id
                });
            }
        };
        const currentTeamTitle = getTeamTitleFromId(current);
        const optimizedTeamTitle = getTeamTitleFromId(optimized);
        return {
            label: intl.formatMessage((0, $exyTY.default).team),
            currentValue: currentTeamTitle,
            optimizedValue: optimizedTeamTitle
        };
    };
    const $51b90e42ec482d7f$var$sprintFieldGenerator = (current, optimized, { sprints: sprints, intl: intl })=>{
        const getSprintTitleFromId = (id)=>{
            if (id) {
                const sprint = sprints.find((s)=>s.id === id);
                if (sprint) return sprint.title;
                return intl.formatMessage((0, $exyTY.default).unknownSprint, {
                    id: id
                });
            }
        };
        const currentSprintTitle = getSprintTitleFromId(current);
        const optimizedSprintTitle = getSprintTitleFromId(optimized);
        return {
            label: intl.formatMessage((0, $ihPUd.default).sprint),
            currentValue: currentSprintTitle,
            optimizedValue: optimizedSprintTitle
        };
    };
    const $51b90e42ec482d7f$var$versionsFieldGenerator = (currentMaybe, optimizedMaybe, { versions: versions, intl: intl })=>{
        const current = currentMaybe || [];
        const optimized = optimizedMaybe || [];
        const unknownVersionMessage = (id)=>intl.formatMessage((0, $exyTY.default).unknownVersion, {
                id: id
            });
        const getTitlesOfVersionsWithIds = (0, parcelRequire("4Rr1a")).default((id)=>{
            const version = versions.find((0, parcelRequire("sqeVT")).default('id', id));
            return version ? version.name : unknownVersionMessage(id);
        });
        const maxNumReleases = Math.max(current.length, optimized.length);
        const currentVersions = getTitlesOfVersionsWithIds(current);
        const optimizedVersions = getTitlesOfVersionsWithIds(optimized);
        const currentVersionsCsv = currentVersions.join(', ');
        const optimizedVersionsCsv = optimizedVersions.join(', ');
        return {
            label: intl.formatMessage((0, $exyTY.default).releases, {
                releaseCount: maxNumReleases
            }),
            currentValue: currentVersionsCsv || undefined,
            optimizedValue: optimizedVersionsCsv || undefined
        };
    };
    const $51b90e42ec482d7f$var$fieldGenerators = {
        baselineStart: $51b90e42ec482d7f$var$dateFieldGenerator,
        baselineEnd: $51b90e42ec482d7f$var$dateFieldGenerator,
        team: $51b90e42ec482d7f$var$teamFieldGenerator,
        sprint: $51b90e42ec482d7f$var$sprintFieldGenerator,
        fixVersions: $51b90e42ec482d7f$var$versionsFieldGenerator
    };
    const $51b90e42ec482d7f$var$getOptimizedFieldEntry = (key, current, optimized, context, inferred)=>{
        const generator = $51b90e42ec482d7f$var$fieldGenerators[key];
        if (generator) return generator(current, optimized, {
            ...context,
            key: key
        }, inferred);
        console.warn(`No generator for optimized field: ${key}`);
    };
    const $51b90e42ec482d7f$export$b15f3a64b1de090d = (issue, teams, sprints, versions, dateFormat, dateConfiguration, customFields, intl)=>{
        if (issue.optimized) {
            const changedKeys = [];
            for (const [optimizedKey, optimizedValue] of Object.entries(issue.optimized))if ((0, $l38L3.hasValueChanged)((0, $l38L3.getCurrentValue)(issue, optimizedKey), optimizedValue)) changedKeys.push(optimizedKey);
            const context = {
                teams: teams,
                sprints: sprints,
                versions: versions,
                dateFormat: dateFormat,
                dateConfiguration: dateConfiguration,
                customFields: customFields,
                intl: intl
            };
            const optimizedFields = (0, parcelRequire("4Rr1a")).default((key)=>$51b90e42ec482d7f$var$getOptimizedFieldEntry(key, issue[key], (issue.optimized || {})[key], context, issue.inferred), changedKeys);
            const definedOptimizedFields = (0, $4nDwW.filterDefined)(optimizedFields);
            return definedOptimizedFields;
        }
        return [];
    };
});
parcelRegister("e7HS5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1962096e12d67aa5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1962096e12d67aa5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createdLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.created-label",
            "defaultMessage": "CREATED"
        },
        deletedLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.deleted-label",
            "defaultMessage": "DELETED"
        },
        updatedLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.updated-label",
            "defaultMessage": "UPDATED"
        },
        excludedLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.excluded-label",
            "defaultMessage": "REMOVED"
        },
        addedLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.added-label",
            "defaultMessage": "ADDED"
        },
        changeCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.change-count",
            "defaultMessage": "{count, plural, one {{count} field} other {{count} fields}}"
        },
        description: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.description",
            "defaultMessage": "Description"
        },
        end: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.end",
            "defaultMessage": "Release date"
        },
        fixVersions: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.fix-versions",
            "defaultMessage": "Release"
        },
        lexoRank: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.lexo-rank",
            "defaultMessage": "Rank"
        },
        parent: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.parent",
            "defaultMessage": "Parent"
        },
        priority: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.priority",
            "defaultMessage": "Priority"
        },
        project: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.project",
            "defaultMessage": "Project"
        },
        sprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.sprint",
            "defaultMessage": "Sprint"
        },
        start: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.start",
            "defaultMessage": "Start date"
        },
        storyPoints: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.story-points",
            "defaultMessage": "Story points"
        },
        summary: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.summary",
            "defaultMessage": "Summary"
        },
        targetEnd: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.target-end",
            "defaultMessage": "Target end"
        },
        targetStart: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.target-start",
            "defaultMessage": "Target start"
        },
        timeEstimateDays: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.time-estimate-days",
            "defaultMessage": "Estimate (d)"
        },
        timeEstimateHours: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.time-estimate-hours",
            "defaultMessage": "Estimate (h)"
        },
        team: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.team",
            "defaultMessage": "Team"
        },
        velocity: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.velocity",
            "defaultMessage": "Velocity"
        },
        plannedCapacity: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.planned-capacity",
            "defaultMessage": "Sprint velocity"
        },
        iterationVelocity: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.iteration-velocity",
            "defaultMessage": "Iteration velocity"
        },
        iterationLength: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.iteration-length",
            "defaultMessage": "Iteration length"
        },
        issueSource: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.issue-source",
            "defaultMessage": "Issue source"
        },
        removedMember: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.removed-member",
            "defaultMessage": "Removed member"
        },
        addedMember: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.added-member",
            "defaultMessage": "Added member"
        },
        weeklyHours: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.weekly-hours",
            "defaultMessage": "Weekly hours"
        },
        schedulingMode: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.scheduling-mode",
            "defaultMessage": "Scheduling mode"
        },
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.title",
            "defaultMessage": "Title"
        },
        exceptions: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.exceptions",
            "defaultMessage": "Exceptions"
        },
        issueLinkCreated: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.issue-link-created",
            "defaultMessage": "Dependency created"
        },
        issueLinkRemoved: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.issue-link-removed",
            "defaultMessage": "Dependency removed"
        },
        ideasChanged: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.ideas-changed",
            "defaultMessage": "Ideas"
        },
        components: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.components",
            "defaultMessage": "Components"
        },
        addedComponents: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.added-components",
            "defaultMessage": "Components added"
        },
        removedComponents: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.removed-components",
            "defaultMessage": "Components removed"
        },
        addedLabels: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.added-labels",
            "defaultMessage": "Labels added"
        },
        removedLabels: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.removed-labels",
            "defaultMessage": "Labels removed"
        },
        labels: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.labels",
            "defaultMessage": "Labels"
        },
        customFieldAdded: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.custom-field-added",
            "defaultMessage": "{field} added"
        },
        customFieldRemoved: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.custom-field-removed",
            "defaultMessage": "{field} removed"
        },
        goals: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.goals",
            "defaultMessage": "Goals"
        }
    });
});
parcelRegister("bFINk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f36952714ea3d78b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gtreQ;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $ousew;
    var $koVbs;
    var $gJZ5D;
    var $iwfmd;
    const $f36952714ea3d78b$var$WarningDetails = (props)=>{
        const { warnings: warnings, opacity: opacity, isOpen: defaultIsOpen, zIndex: zIndex } = props;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(!!defaultIsOpen);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClose = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []);
        const onHoverChanged = (0, $5uXOq.useCallback)((isHovered)=>{
            setIsOpen(isHovered);
        }, []);
        const renderTrigger = (0, $5uXOq.useCallback)(({ ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
                onHoverChanged: onHoverChanged
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    opacity: opacity
                },
                ref: ref,
                "data-testid": "portfolio-3-portfolio.common.warning-details.warning-icon",
                ...triggerProps
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                label: "",
                primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`,
                size: "small"
            }))), [
            onHoverChanged,
            opacity
        ]);
        const internationaliseNestedMessages = (values)=>{
            const amount = values.amount ? formatMessage(values.amount.key, values.amount) : null;
            return {
                ...values,
                amount: amount
            };
        };
        const renderContent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, warnings && warnings.map((warning, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    key: index,
                    xcss: $f36952714ea3d78b$var$entryStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $f36952714ea3d78b$var$headingStyles
                }, warnings.length > 1 && `${index + 1}. `, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...warning.header,
                    values: internationaliseNestedMessages(warning.messageValues)
                })), warning.message && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...warning.message,
                    values: internationaliseNestedMessages(warning.messageValues)
                }))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            zIndex: zIndex,
            isOpen: isOpen,
            onClose: onClose,
            trigger: renderTrigger,
            content: renderContent,
            placement: "bottom-start",
            shouldUseCaptureOnOutsideClick: true
        });
    };
    var $f36952714ea3d78b$export$2e2bcd8739ae039 = $f36952714ea3d78b$var$WarningDetails;
    const $f36952714ea3d78b$var$entryStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.200',
        paddingBottom: 'space.200',
        paddingLeft: 'space.300',
        paddingRight: 'space.300',
        minWidth: '300px',
        maxWidth: '448px'
    });
    const $f36952714ea3d78b$var$headingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        fontWeight: 'bold',
        marginBottom: 'space.100'
    });
});
parcelRegister("9UraL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7f2f163eab566b7$export$2e2bcd8739ae039);
    var $bC2fB;
    var $50ym7 = parcelRequire("50ym7");
    var $8d4eZ = parcelRequire("8d4eZ");
    var $8EoGC = parcelRequire("8EoGC");
    var $e7f2f163eab566b7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $8d4eZ.default), (0, $50ym7.default))((0, $8EoGC.default));
});
parcelRegister("50ym7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcbc8b2174e16f26$export$2e2bcd8739ae039);
    var $jlryX = parcelRequire("jlryX");
    const $dcbc8b2174e16f26$var$mapDispatchToProps = (dispatch)=>({
            bulkInlineCreateIssues: (payload)=>{
                dispatch((0, $jlryX.bulkInlineCreateIssues)(payload));
            }
        });
    var $dcbc8b2174e16f26$export$2e2bcd8739ae039 = $dcbc8b2174e16f26$var$mapDispatchToProps;
});
parcelRegister("8d4eZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0149db300f032ab2$export$2e2bcd8739ae039);
    var $gk0jw = parcelRequire("gk0jw");
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $3YtPS = parcelRequire("3YtPS");
    var $0149db300f032ab2$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        issueTypes: (0, $kllqP.getIssueTypes),
        isCreatingIssues: (state)=>!!(0, $gk0jw.getInlineCreateState)(state).isCreatingIssues,
        issueTypesFromProject: (state, props)=>(0, $jpXKt.getIssueTypesByProjectId)(state)(props.issue?.project?.id)
    });
});
parcelRegister("8EoGC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff3585dc24bad431$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $7XluA;
    var $koVbs;
    var $8eYxw;
    var $iVXGR;
    var $7uAvV;
    var $h0P1o;
    var $ihPUd = parcelRequire("ihPUd");
    const $ff3585dc24bad431$var$CustomPopupContainer = (0, $5uXOq.forwardRef)(({ children: children, 'data-testid': testId, xcss: _xcss, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ff3585dc24bad431$var$customPopupContainerStyles,
            testId: testId,
            ...props,
            ref: ref
        }, children));
    const $ff3585dc24bad431$var$AiWorkBreakdownDialog = ({ groupCombination: groupCombination, isOpen: isOpen, issue: issue, issueTypes: issueTypes, renderIssueSummary: renderIssueSummary, toggleAiWorkBreakdownPopup: toggleAiWorkBreakdownPopup, bulkInlineCreateIssues: bulkInlineCreateIssues, isCreatingIssues: isCreatingIssues, issueTypesFromProject: issueTypesFromProject })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [{ channelId: channelId, currentStep: currentStep, isStreaming: isStreaming, promptValue: promptValue }, { clearError: clearError, resetIssueBreakdownState: resetIssueBreakdownState, setHeaderPromptValue: setHeaderPromptValue, setIssueBreakdownStep: setIssueBreakdownStep, setPromptValue: setPromptValue, updateStreamingStatus: updateStreamingStatus, removeSuggestedIssue: removeSuggestedIssue }] = (0, (0, parcelRequire("7uAvV")).useIssueBreakdown)();
        const { fireTrack: fireTrack } = (0, (0, parcelRequire("iVXGR")).useAiWorkBreakDownAnalytics)({
            channelId: channelId
        });
        const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $5uXOq.useContext)((0, (0, parcelRequire("h0P1o")).IssueBreakdownEntryPointContext));
        const onFetchSuggestedIssuesSuccess = (0, $5uXOq.useCallback)(()=>{
            setIssueBreakdownStep((0, (0, parcelRequire("7uAvV")).steps).draftListStep);
            setPromptValue('');
        }, [
            setIssueBreakdownStep,
            setPromptValue
        ]);
        const onFetchSuggestedIssuesFailure = (0, $5uXOq.useCallback)(()=>{
            setIssueBreakdownStep((0, (0, parcelRequire("7uAvV")).steps).errorStep);
        }, [
            setIssueBreakdownStep
        ]);
        const { isFetchingSuggestedChildIssues: isFetchingSuggestedChildIssues } = (0, (0, parcelRequire("8eYxw")).useFetchSuggestedChildIssues)(onFetchSuggestedIssuesSuccess, onFetchSuggestedIssuesFailure);
        const cancelIssueBreakdown = (0, $5uXOq.useCallback)(()=>{
            fireTrack('aiInteraction dismissed', 'cancelIssueBreakdown', {
                isStreaming: isStreaming
            });
            resetIssueBreakdownState();
            toggleAiWorkBreakdownPopup({
                isOpen: false
            });
        }, [
            fireTrack,
            isStreaming,
            toggleAiWorkBreakdownPopup,
            resetIssueBreakdownState
        ]);
        const handleCloseAiWorkBreakdownPopup = ()=>{
            fireTrack('aiInteraction dismissed', 'closeIssueBreakdownPopup', {
                isStreaming: isStreaming
            });
            resetIssueBreakdownState();
            toggleAiWorkBreakdownPopup({
                isOpen: false
            });
        };
        const onSubmitFetchSuggestedChildIssues = (0, $5uXOq.useCallback)(()=>{
            if (isFetchingSuggestedChildIssues) return;
            if (promptValue) {
                fireTrack('aiResult actioned', 'promptValueChanged', {
                    aiResultAction: 'promptRefined'
                });
                setHeaderPromptValue(promptValue);
            }
            updateStreamingStatus(true);
            clearError();
            currentStep !== (0, (0, parcelRequire("7uAvV")).steps).draftListStep && setIssueBreakdownStep((0, (0, parcelRequire("7uAvV")).steps).draftListStep);
        }, [
            clearError,
            currentStep,
            fireTrack,
            isFetchingSuggestedChildIssues,
            promptValue,
            setHeaderPromptValue,
            setIssueBreakdownStep,
            updateStreamingStatus
        ]);
        const onCreateSuggestedChildIssues = (0, $5uXOq.useCallback)((issues)=>{
            let resolveCallback;
            new Promise((resolve)=>{
                resolveCallback = resolve;
            }).then((createdIssueIds)=>{
                removeSuggestedIssue(createdIssueIds, (0, (0, parcelRequire("7uAvV")).reasons).accept);
            });
            bulkInlineCreateIssues({
                resolve: resolveCallback,
                parentIssue: {
                    group: issue.group,
                    groupCombination: groupCombination,
                    hierarchyLevel: issue.level,
                    parentId: issue.id,
                    projectId: issue.project.id
                },
                suggestedIssues: issues.map((i)=>({
                        title: i.summary,
                        description: i.description,
                        issueTypeId: Number(i.issueTypeId),
                        id: i.id
                    }))
            });
        }, [
            bulkInlineCreateIssues,
            groupCombination,
            issue.group,
            issue.id,
            issue.level,
            issue.project.id,
            removeSuggestedIssue
        ]);
        const childIssueTypes = issueTypes.filter(({ id: id, level: level })=>level === issue.level - 1 && issueTypesFromProject.includes(id)).map(({ id: id, iconUrl: iconUrl, name: name })=>({
                description: '',
                hasEpicLinkField: false,
                hasRequiredField: false,
                hasWorkflowValidators: false,
                iconUrl: iconUrl,
                id: String(id),
                name: name,
                requiredFields: []
            }));
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                childIssueTypes: childIssueTypes,
                onChangePrompt: setPromptValue,
                onCreate: onCreateSuggestedChildIssues,
                onDiscard: cancelIssueBreakdown,
                onRetry: onSubmitFetchSuggestedChildIssues,
                onSubmit: onSubmitFetchSuggestedChildIssues,
                parentIssueDetails: {
                    id: issue.id,
                    issueKey: issue.issueKey,
                    level: issue.level,
                    projectKey: issue.project.key
                },
                isCreatingIssues: isCreatingIssues
            }), [
            cancelIssueBreakdown,
            childIssueTypes,
            issue.id,
            issue.issueKey,
            issue.level,
            issue.project.key,
            onCreateSuggestedChildIssues,
            onSubmitFetchSuggestedChildIssues,
            setPromptValue,
            isCreatingIssues
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            autoFocus: false,
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    id: "jira-plan-ai-work-breakdown",
                    packageName: "jiraPlanAiWorkBreakdown",
                    runtimeProps: runtimeProps,
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                        isLoading: true
                    }, intl.formatMessage((0, $ihPUd.default).loading))
                }),
            isOpen: isOpen,
            onClose: handleCloseAiWorkBreakdownPopup,
            placement: "bottom-end",
            popupComponent: $ff3585dc24bad431$var$CustomPopupContainer,
            trigger: renderIssueSummary
        });
    };
    var $ff3585dc24bad431$export$2e2bcd8739ae039 = $ff3585dc24bad431$var$AiWorkBreakdownDialog;
    const $ff3585dc24bad431$var$customPopupContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: "var(--ds-border-radius, 6px)"
    });
});
parcelRegister("8eYxw", function(module, exports) {
    $parcel$export(module.exports, "useFetchSuggestedChildIssues", ()=>$f106911e964d421b$export$5038739d1a550c87);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $49u5R;
    var $koeKL;
    const $f106911e964d421b$export$5038739d1a550c87 = (onSuccess, onFailure)=>{
        const requestSignal = (0, $5uXOq.useRef)(null);
        const [isFetchingSuggestedChildIssues, setIsFetchingSuggestedChildIssue] = (0, $5uXOq.useState)(false);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const cancelFetchSuggestedChildIssues = (0, $5uXOq.useCallback)(()=>{
            if (requestSignal.current && isFetchingSuggestedChildIssues) {
                requestSignal.current.abort();
                setIsFetchingSuggestedChildIssue(false);
            }
        }, [
            isFetchingSuggestedChildIssues
        ]);
        const triggerFetchSuggestedChildIssues = (0, $5uXOq.useCallback)(async (params)=>{
            if (!params.parentIssueId) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.issue-view-services.src.child-issues.use-fetched-suggested-child-issuses', 'Error fetching suggested child issues');
                onFailure?.();
                return;
            }
            if (requestSignal.current) requestSignal.current.abort();
            try {
                requestSignal.current = new AbortController();
                setIsFetchingSuggestedChildIssue(true);
                const response = await (0, (0, parcelRequire("49u5R")).fetchSuggestedChildIssuesData)(cloudId, params, requestSignal.current.signal);
                onSuccess?.(response);
            } catch (error) {
                if (error.name === 'AbortError') return;
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.issue-view-services.src.child-issues.use-fetched-suggested-child-issuses', 'Error fetching suggested child issues', error instanceof Error ? error : undefined);
                onFailure?.();
            } finally{
                setIsFetchingSuggestedChildIssue(false);
            }
        }, [
            cloudId,
            onFailure,
            onSuccess
        ]);
        return {
            triggerFetchSuggestedChildIssues: triggerFetchSuggestedChildIssues,
            cancelFetchSuggestedChildIssues: cancelFetchSuggestedChildIssues,
            isFetchingSuggestedChildIssues: isFetchingSuggestedChildIssues
        };
    };
});
parcelRegister("49u5R", function(module, exports) {
    $parcel$export(module.exports, "fetchSuggestedChildIssuesData", ()=>$8367156c86de976a$export$d0caf56f20fdafa2);
    var $dXq4S;
    var $iBOrg;
    const $8367156c86de976a$export$6a075df0541b0173 = ()=>`
    query IssueBreakdownDataFetcher($issueTypeIds:[ID!], $parentIssueIdAri: ID!, $channelId: String, $additionalContext: String, $acceptedChildIssues: [JiraSuggestedIssueInput], $rejectedChildIssues: [JiraSuggestedIssueInput]) {
        jira  { 
            issueById(id: $parentIssueIdAri) {
                suggestedChildIssues(issueTypeIds:$issueTypeIds, channelId:$channelId, additionalContext: $additionalContext, acceptedChildIssues: $acceptedChildIssues, rejectedChildIssues: $rejectedChildIssues) {
                    channelId,
                    error,
                    suggestedChildIssues {
                        summary
                        description
                        issueTypeId
                    }
                }
            }
        }
    }
`;
    const $8367156c86de976a$export$d0caf56f20fdafa2 = async (cloudId, { channelId: channelId, parentIssueId: parentIssueId, additionalContext: additionalContext, acceptedChildIssues: acceptedChildIssues, rejectedChildIssues: rejectedChildIssues, issueTypeIds: issueTypeIds }, signal)=>{
        const parentIssueIdAri = (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            resourceType: 'issue',
            resourceId: parentIssueId,
            cloudId: cloudId
        });
        const { data: data, errors: errors } = await (0, (0, parcelRequire("iBOrg")).getClient)('').query({
            operationName: 'IssueBreakdownDataFetcher',
            query: $8367156c86de976a$export$6a075df0541b0173(),
            variables: {
                parentIssueIdAri: parentIssueIdAri,
                issueTypeIds: issueTypeIds,
                channelId: channelId,
                additionalContext: additionalContext,
                acceptedChildIssues: acceptedChildIssues,
                rejectedChildIssues: rejectedChildIssues
            },
            signal: signal
        });
        const dataError = data?.jira?.issueById?.suggestedChildIssues?.error;
        if (errors != null && errors.length > 0) {
            const [{ message: message }] = errors;
            throw new Error(message);
        }
        if (dataError) throw new Error(dataError);
        return {
            error: null,
            suggestedChildIssues: data?.jira?.issueById?.suggestedChildIssues?.suggestedChildIssues || [],
            channelId: data?.jira?.issueById?.suggestedChildIssues?.channelId || ''
        };
    };
});
parcelRegister("iVXGR", function(module, exports) {
    $parcel$export(module.exports, "useAiWorkBreakDownAnalytics", ()=>$ad0cb2a6e408d602$export$3c4dd75db697822b);
    $parcel$export(module.exports, "useAiWorkBreakDownExperienceAnalytics", ()=>$ad0cb2a6e408d602$export$46d75378ef38a892);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $8zOmE;
    var $93Yeu;
    const $ad0cb2a6e408d602$export$c7401f58fc60a2ec = {
        aiFeatureName: 'plansAiIssueBreakdown',
        isAIFeature: 1,
        proactiveAIGenerated: 0,
        userGeneratedAI: 1
    };
    const $ad0cb2a6e408d602$export$3c4dd75db697822b = (params = {})=>{
        const { channelId: channelId } = params;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const actions = (0, $5uXOq.useMemo)(()=>{
            const analyticsEvent = createAnalyticsEvent({});
            const defaultAttrs = {
                ...$ad0cb2a6e408d602$export$c7401f58fc60a2ec,
                singleInstrumentationID: channelId
            };
            return {
                analyticsEvent: analyticsEvent,
                fireTrack: (name, id, attrs)=>(0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, name, id, {
                        ...defaultAttrs,
                        ...attrs
                    })
            };
        }, [
            channelId,
            createAnalyticsEvent
        ]);
        return actions;
    };
    const $ad0cb2a6e408d602$export$46d75378ef38a892 = (issueKey)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const application = (0, (0, parcelRequire("93Yeu")).useApplication)(projectKey, true);
        const edition = (0, (0, parcelRequire("93Yeu")).useEdition)(projectKey, true);
        const analyticsSource = 'jiraPortfolio3AiWorkBreakdown';
        const experience = 'plansAiIssueBreakdown';
        const sendSuccessEvent = (0, $5uXOq.useCallback)((validError)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'plansAiIssueBreakdownSuccessEvent sent', {
                analyticsSource: analyticsSource,
                experience: experience,
                wasExperienceSuccesful: true,
                application: application ?? null,
                edition: edition ?? null,
                additionalAttributes: {
                    validError: validError
                }
            });
        }, [
            application,
            createAnalyticsEvent,
            edition
        ]);
        const sendFailedEvent = (0, $5uXOq.useCallback)((error)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'plansAiIssueBreakdownFailedEvent sent', {
                experience: experience,
                wasExperienceSuccesful: false,
                analyticsSource: analyticsSource,
                application: application ?? null,
                edition: edition ?? null,
                additionalAttributes: {
                    error: error
                }
            });
        }, [
            application,
            createAnalyticsEvent,
            edition
        ]);
        return {
            sendSuccessEvent: sendSuccessEvent,
            sendFailedEvent: sendFailedEvent
        };
    };
});
parcelRegister("7uAvV", function(module, exports) {
    $parcel$export(module.exports, "steps", ()=>$41a646bf624dab4f$export$be3f796aed065412);
    $parcel$export(module.exports, "reasons", ()=>$41a646bf624dab4f$export$653523807df144ac);
    $parcel$export(module.exports, "useIssueBreakdown", ()=>$41a646bf624dab4f$export$2d0761b6b6ddada);
    var $hGgHi = parcelRequire("hGgHi");
    var $3sQ5x;
    var $iXqE5;
    const $41a646bf624dab4f$export$be3f796aed065412 = {
        defaultStep: 'defaultStep',
        draftListStep: 'draftListStep',
        errorStep: 'errorStep'
    };
    const $41a646bf624dab4f$export$653523807df144ac = {
        accept: 'accept',
        reject: 'reject'
    };
    const $41a646bf624dab4f$var$initialState = {
        currentStep: $41a646bf624dab4f$export$be3f796aed065412.defaultStep,
        retryAttempts: 0,
        suggestedChildIssues: [],
        promptValue: '',
        headerPromptValue: '',
        selectedIssueId: null,
        channelId: null,
        acceptedChildIssues: [],
        rejectedChildIssues: [],
        isStreaming: false,
        clearListWhenAddSuggestion: false,
        status: null,
        streamingError: null,
        aiOptInEnabledByProject: {}
    };
    const $41a646bf624dab4f$var$setIssueBreakdownStep = (step)=>({ setState: setState })=>{
            setState({
                currentStep: step
            });
        };
    const $41a646bf624dab4f$var$setAiOptInEnabled = (projectKey, isEnabled)=>({ getState: getState, setState: setState })=>{
            const { aiOptInEnabledByProject: aiOptInEnabledByProject } = getState();
            setState({
                aiOptInEnabledByProject: {
                    ...aiOptInEnabledByProject,
                    [projectKey]: isEnabled
                }
            });
        };
    const $41a646bf624dab4f$var$setSuggestedChildIssues = (suggestedChildIssues)=>({ setState: setState })=>{
            setState({
                suggestedChildIssues: suggestedChildIssues
            });
        };
    const $41a646bf624dab4f$var$setSelectedIssueId = (selectedIssueId)=>({ setState: setState })=>{
            setState({
                selectedIssueId: selectedIssueId
            });
        };
    const $41a646bf624dab4f$var$unselectCurrentId = ()=>({ setState: setState })=>{
            setState({
                selectedIssueId: null
            });
        };
    const $41a646bf624dab4f$var$setChannelId = (channelId)=>({ setState: setState })=>{
            setState({
                channelId: channelId
            });
        };
    const $41a646bf624dab4f$var$resetIssueBreakdownState = ()=>({ setState: setState })=>{
            setState($41a646bf624dab4f$var$initialState);
        };
    const $41a646bf624dab4f$var$setPromptValue = (promptValue)=>({ setState: setState })=>{
            setState({
                promptValue: promptValue
            });
        };
    const $41a646bf624dab4f$var$setHeaderPromptValue = (headerPromptValue)=>({ setState: setState })=>{
            setState({
                headerPromptValue: headerPromptValue
            });
        };
    const $41a646bf624dab4f$var$isIssueBreakdownOpen = ()=>({ getState: getState })=>{
            const { currentStep: currentStep } = getState();
            return currentStep !== $41a646bf624dab4f$export$be3f796aed065412.defaultStep;
        };
    const $41a646bf624dab4f$var$getSuggestedLength = ()=>({ getState: getState })=>{
            const { suggestedChildIssues: suggestedChildIssues } = getState();
            return suggestedChildIssues.length;
        };
    const $41a646bf624dab4f$var$getAiOptInEnabled = (projectKey)=>({ getState: getState })=>{
            const { aiOptInEnabledByProject: aiOptInEnabledByProject } = getState();
            if (!(0, ($parcel$interopDefault($hGgHi)))(aiOptInEnabledByProject[projectKey])) return aiOptInEnabledByProject[projectKey];
            return true;
        };
    const $41a646bf624dab4f$var$updateSuggestedResult = ({ channelId: channelId, suggestedChildIssues: suggestedChildIssues })=>({ setState: setState })=>{
            setState({
                channelId: channelId,
                suggestedChildIssues: suggestedChildIssues
            });
        };
    const $41a646bf624dab4f$var$addSuggestedIssue = (newSuggestedIssue)=>({ getState: getState, setState: setState })=>{
            const { suggestedChildIssues: oldIssues, status: status, clearListWhenAddSuggestion: clearListWhenAddSuggestion } = getState();
            const suggestedChildIssues = clearListWhenAddSuggestion ? [
                newSuggestedIssue
            ] : oldIssues.concat(newSuggestedIssue);
            if (status) setState({
                suggestedChildIssues: suggestedChildIssues,
                status: null,
                clearListWhenAddSuggestion: false
            });
            else setState({
                suggestedChildIssues: suggestedChildIssues,
                clearListWhenAddSuggestion: false
            });
        };
    const $41a646bf624dab4f$var$removeSuggestedIssue = (id, reason)=>({ getState: getState, setState: setState })=>{
            const { suggestedChildIssues: suggestedChildIssues, acceptedChildIssues: acceptedChildIssues, rejectedChildIssues: rejectedChildIssues } = getState();
            const removeIdSet = new Set(Array.isArray(id) ? id : [
                id
            ]);
            const initialValue = {
                issues: [],
                removed: []
            };
            const { issues: issues, removed: removed } = suggestedChildIssues.reduce((result, current)=>{
                if (removeIdSet.has(current.id)) {
                    const { summary: summary, description: description } = current;
                    return Object.assign(result, {
                        removed: result.removed.concat({
                            summary: summary,
                            description: description
                        })
                    });
                }
                return Object.assign(result, {
                    issues: result.issues.concat(current)
                });
            }, initialValue);
            if (reason === $41a646bf624dab4f$export$653523807df144ac.accept) setState({
                suggestedChildIssues: issues,
                acceptedChildIssues: acceptedChildIssues.concat(removed)
            });
            else setState({
                suggestedChildIssues: issues,
                rejectedChildIssues: rejectedChildIssues.concat(removed)
            });
        };
    const $41a646bf624dab4f$var$removeAcceptedSuggestedIssue = (id)=>({ getState: getState, setState: setState })=>{
            const { suggestedChildIssues: suggestedChildIssues, acceptedChildIssues: acceptedChildIssues } = getState();
            const removedIssue = suggestedChildIssues.find((item)=>item.id === id);
            if (!removedIssue) return;
            const { summary: summary, description: description } = removedIssue;
            const newAcceptedIssues = acceptedChildIssues.concat({
                summary: summary,
                description: description
            });
            const newIssues = suggestedChildIssues.filter((item)=>item.id !== id);
            setState({
                suggestedChildIssues: newIssues,
                acceptedChildIssues: newAcceptedIssues
            });
        };
    const $41a646bf624dab4f$var$updateStreamingStatus = (isStreaming, status = null)=>({ setState: setState })=>{
            setState({
                isStreaming: isStreaming,
                clearListWhenAddSuggestion: isStreaming,
                status: status
            });
        };
    const $41a646bf624dab4f$var$setStreamingError = (error)=>({ setState: setState, getState: getState })=>{
            const { suggestedChildIssues: suggestedChildIssues, promptValue: promptValue } = getState();
            if (suggestedChildIssues.length > 0 || promptValue) setState({
                streamingError: error
            });
            else setState({
                channelId: null,
                streamingError: error
            });
        };
    const $41a646bf624dab4f$var$clearError = ()=>({ setState: setState })=>{
            setState({
                streamingError: null
            });
        };
    const $41a646bf624dab4f$var$incrementRetryCount = ()=>({ getState: getState, setState: setState })=>{
            const { retryAttempts: retryAttempts } = getState();
            setState({
                retryAttempts: retryAttempts + 1
            });
        };
    const $41a646bf624dab4f$export$e324594224ef24da = {
        addSuggestedIssue: $41a646bf624dab4f$var$addSuggestedIssue,
        clearError: $41a646bf624dab4f$var$clearError,
        getAiOptInEnabled: $41a646bf624dab4f$var$getAiOptInEnabled,
        getSuggestedLength: $41a646bf624dab4f$var$getSuggestedLength,
        incrementRetryCount: $41a646bf624dab4f$var$incrementRetryCount,
        isIssueBreakdownOpen: $41a646bf624dab4f$var$isIssueBreakdownOpen,
        removeAcceptedSuggestedIssue: $41a646bf624dab4f$var$removeAcceptedSuggestedIssue,
        removeSuggestedIssue: $41a646bf624dab4f$var$removeSuggestedIssue,
        resetIssueBreakdownState: $41a646bf624dab4f$var$resetIssueBreakdownState,
        setAiOptInEnabled: $41a646bf624dab4f$var$setAiOptInEnabled,
        setChannelId: $41a646bf624dab4f$var$setChannelId,
        setHeaderPromptValue: $41a646bf624dab4f$var$setHeaderPromptValue,
        setIssueBreakdownStep: $41a646bf624dab4f$var$setIssueBreakdownStep,
        setPromptValue: $41a646bf624dab4f$var$setPromptValue,
        setSelectedIssueId: $41a646bf624dab4f$var$setSelectedIssueId,
        setStreamingError: $41a646bf624dab4f$var$setStreamingError,
        setSuggestedChildIssues: $41a646bf624dab4f$var$setSuggestedChildIssues,
        unselectCurrentId: $41a646bf624dab4f$var$unselectCurrentId,
        updateStreamingStatus: $41a646bf624dab4f$var$updateStreamingStatus,
        updateSuggestedResult: $41a646bf624dab4f$var$updateSuggestedResult
    };
    const $41a646bf624dab4f$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $41a646bf624dab4f$var$initialState,
        actions: $41a646bf624dab4f$export$e324594224ef24da,
        name: 'portfolio-3-ai-issue-breakdown'
    });
    const $41a646bf624dab4f$export$2d0761b6b6ddada = (0, (0, parcelRequire("3sQ5x")).createHook)($41a646bf624dab4f$var$Store);
});
const $813368d82e314d52$export$dfe0d1d38e6d3bc8 = 'REMOVE_ISSUE';
parcelRegister("4bZgR", function(module, exports) {
    $parcel$export(module.exports, "DraggableButton", ()=>$f5dded0a2f5ab541$export$127ce26e08facc24);
    $parcel$export(module.exports, "DraggableIconButton", ()=>$f5dded0a2f5ab541$export$d70443e33513c77);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $42CjB;
    const $f5dded0a2f5ab541$export$127ce26e08facc24 = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f5dded0a2f5ab541$var$CompactWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            ref: ref,
            ...props
        }, children))));
    const $f5dded0a2f5ab541$export$d70443e33513c77 = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f5dded0a2f5ab541$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            ref: ref,
            ...props
        }))));
    const $f5dded0a2f5ab541$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _p12f1osq _16nw1r31 _r2ecglyw _71fd1o36",
                __cmplp.className
            ])
        });
    });
    const $f5dded0a2f5ab541$var$CompactWrapper = (0, $5uXOq.forwardRef)(({ as: C = $f5dded0a2f5ab541$var$Wrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_iq9ttpi8",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lwTdM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f17b946b13aa3dc$export$2e2bcd8739ae039);
    var $bC2fB;
    var $fyEmm = parcelRequire("fyEmm");
    var $hWrMF = parcelRequire("hWrMF");
    var $cAfqc = parcelRequire("cAfqc");
    var $9f17b946b13aa3dc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hWrMF.default), (0, $fyEmm.default))((0, $cAfqc.default));
});
parcelRegister("fyEmm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$180fcc3c645976c5$export$2e2bcd8739ae039);
    var $7K8Pq = parcelRequire("7K8Pq");
    const $180fcc3c645976c5$var$mapDispatchToProps = (dispatch)=>({
            setIssueTypeIdForHierarchy: (hierarchyLevel, issueTypeId)=>{
                dispatch((0, $7K8Pq.setIssueTypeIdForHierarchy)(hierarchyLevel, issueTypeId));
            },
            setGlobalCreateIssue: ()=>{
                dispatch((0, $7K8Pq.setGlobalCreateIssue)(false));
            }
        });
    var $180fcc3c645976c5$export$2e2bcd8739ae039 = $180fcc3c645976c5$var$mapDispatchToProps;
});
parcelRegister("hWrMF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$71abd8060530e471$export$2e2bcd8739ae039);
    var $7bnpM = parcelRequire("7bnpM");
    var $kllqP = parcelRequire("kllqP");
    var $3YtPS = parcelRequire("3YtPS");
    var $71abd8060530e471$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        issueTypesByProjectId: (0, $kllqP.getIssueTypesByProjectId),
        hierarchyRangeFilter: (0, $7bnpM.getHierarchyFilter)
    });
});
parcelRegister("cAfqc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63625c2643b1d3a2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fn8B5 = parcelRequire("fn8B5");
    var $hGgHi = parcelRequire("hGgHi");
    var $3JOCw = parcelRequire("3JOCw");
    var $aRoVz;
    var $eZUJu;
    var $4R6GH;
    var $koVbs;
    var $i2qlb = parcelRequire("i2qlb");
    var $2QLMT = parcelRequire("2QLMT");
    var $8zOmE;
    var $2NMNM;
    var $azl5T = parcelRequire("azl5T");
    var $c4U8L = parcelRequire("c4U8L");
    var $63IHV = parcelRequire("63IHV");
    var $6Rc1s = parcelRequire("6Rc1s");
    const $63625c2643b1d3a2$var$CreateIssue = ({ issue: issue, projects: projects, startInlineCreate: startInlineCreate, issueTypesByProjectId: issueTypesByProjectId, hierarchyRangeFilter: hierarchyRangeFilter, groupCombination: groupCombination, isDisabled: isDisabled = false, setGlobalCreateIssue: setGlobalCreateIssue, setIssueTypeIdForHierarchy: setIssueTypeIdForHierarchy, toggleAiWorkBreakdownPopup: toggleAiWorkBreakdownPopup })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const triggerInlineCreateIssueAnalytics = (0, $5uXOq.useCallback)((issueTypeId)=>{
            const analyticsKey = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CREATED_ISSUE_INLINE;
            const [actionSubject, action] = analyticsKey.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            }), analyticsKey, {
                issueType: issueTypeId
            });
        }, [
            createAnalyticsEvent
        ]);
        const getGroup = (0, $5uXOq.useCallback)(()=>groupCombination && Object.keys(groupCombination).length ? (0, $2QLMT.getGroupKey)(groupCombination) : issue.group, [
            groupCombination,
            issue.group
        ]);
        const isLevelWithinHierarchyRangeFilter = (0, $5uXOq.useCallback)((level)=>level >= hierarchyRangeFilter.value.end && level <= hierarchyRangeFilter.value.start, [
            hierarchyRangeFilter
        ]);
        const onItemClick = (0, $5uXOq.useCallback)((issueType, relation)=>{
            const issueTypeId = issueType.id;
            const hierarchyLevel = issueType.level;
            const parentId = relation === 'parent' ? issue.parent : issue.id;
            const siblingId = relation === 'parent' ? issue.id : null;
            const projectId = issueType.projectId;
            const group = getGroup();
            setIssueTypeIdForHierarchy(hierarchyLevel, issueTypeId);
            setGlobalCreateIssue();
            triggerInlineCreateIssueAnalytics(issueTypeId);
            return startInlineCreate({
                parentId: parentId,
                siblingId: siblingId,
                projectId: projectId,
                hierarchyLevel: hierarchyLevel,
                issueTypeId: issueTypeId,
                group: group,
                groupCombination: groupCombination,
                source: 'INLINE'
            });
        }, [
            issue,
            startInlineCreate,
            groupCombination,
            setIssueTypeIdForHierarchy,
            setGlobalCreateIssue,
            triggerInlineCreateIssueAnalytics,
            getGroup
        ]);
        const issueTypeComparator = (0, $5uXOq.useCallback)((a, b)=>a.name.localeCompare(b.name), []);
        const issueTypesByLevel = (0, $5uXOq.useMemo)(()=>{
            let issueTypes = [];
            projects.forEach(({ id: projectId })=>{
                const projectIssueTypes = (issueTypesByProjectId[projectId] || []).map((issueType)=>({
                        ...issueType,
                        projectId: projectId
                    }));
                if (projectIssueTypes?.length) issueTypes = issueTypes.concat(projectIssueTypes);
            });
            issueTypes = (0, ($parcel$interopDefault($3JOCw)))(issueTypes, ({ level: level, name: name })=>`${level}${name}`);
            return (0, ($parcel$interopDefault($fn8B5)))(issueTypes, (issueType)=>issueType.level);
        }, [
            issueTypesByProjectId,
            projects
        ]);
        const { type: type } = issue;
        const childLevel = type.level - 1;
        const currentIssueType = {
            ...type,
            projectId: issue.project.id
        };
        const childLevelIssueTypes = (0, $5uXOq.useMemo)(()=>issueTypesByLevel[childLevel] && issueTypesByLevel[childLevel].sort(issueTypeComparator), [
            issueTypesByLevel,
            childLevel,
            issueTypeComparator
        ]);
        const suggestChildIssuesComponent = ()=>{
            return isLevelWithinHierarchyRangeFilter(childLevel) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $azl5T.default), {
                key: "suggest-child-issues-dropdown-menu-item",
                issue: issue,
                toggleAiWorkBreakdownPopup: toggleAiWorkBreakdownPopup
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
            maxHeight: 350
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            isScrollable: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $63IHV.default), {
            onItemClick: onItemClick,
            issueType: currentIssueType,
            relation: "parent",
            isDisabled: isDisabled
        }, formatMessage((0, $6Rc1s.default).createIssue, {
            issueType: currentIssueType.name
        })), !(0, ($parcel$interopDefault($hGgHi)))(childLevelIssueTypes) && isLevelWithinHierarchyRangeFilter(childLevel) && childLevelIssueTypes.map((issueType)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $63IHV.default), {
                key: issueType.id,
                onItemClick: onItemClick,
                issueType: issueType,
                relation: "child",
                isDisabled: isDisabled,
                elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c4U8L.default), {
                    label: formatMessage((0, $6Rc1s.default).childIconLabel)
                })
            }, formatMessage((0, $6Rc1s.default).createIssue, {
                issueType: issueType.name
            })))), (0, (0, parcelRequire("4R6GH")).fg)('enable-ai-work-breakdown-in-plans') && suggestChildIssuesComponent());
    };
    var $63625c2643b1d3a2$export$2e2bcd8739ae039 = $63625c2643b1d3a2$var$CreateIssue;
});
parcelRegister("azl5T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4e541f761fe07ec$export$2e2bcd8739ae039);
    var $bC2fB;
    var $20jbx = parcelRequire("20jbx");
    var $dtyQn = parcelRequire("dtyQn");
    var $a4e541f761fe07ec$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $20jbx.default), {})((0, $dtyQn.default));
});
parcelRegister("20jbx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76b4b4bd5e6da933$export$2e2bcd8739ae039);
    var $jpXKt = parcelRequire("jpXKt");
    var $4sJY8 = parcelRequire("4sJY8");
    const $76b4b4bd5e6da933$var$mapStateToProps = (state)=>({
            childrenIdsByParent: (0, $4sJY8.getChildrenIdsByParent)(state),
            projectsById: (0, $jpXKt.getProjectsById)(state)
        });
    var $76b4b4bd5e6da933$export$2e2bcd8739ae039 = $76b4b4bd5e6da933$var$mapStateToProps;
});
parcelRegister("dtyQn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$153cd160b47b8180$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $8Uumt = parcelRequire("8Uumt");
    var $42CjB;
    var $aRoVz;
    var $6tRzQ;
    var $lj8SI;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $3bDjY;
    var $37XBA;
    var $2vSU6;
    var $dJl1T;
    var $ousew;
    var $koVbs;
    var $bXcRr;
    var $g4tDr;
    var $7uAvV;
    var $h0P1o;
    var $1iMQ1;
    var $i2qlb = parcelRequire("i2qlb");
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    var $kbGxr = parcelRequire("kbGxr");
    var $8zOmE;
    var $koeKL;
    var $3BsVK = parcelRequire("3BsVK");
    const $153cd160b47b8180$var$SuggestChildIssues = ({ issue: issue, childrenIdsByParent: childrenIdsByParent, projectsById: projectsById, toggleAiWorkBreakdownPopup: toggleAiWorkBreakdownPopup })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const [{ aiOptInEnabledByProject: aiOptInEnabledByProject }, { getAiOptInEnabled: getAiOptInEnabled, setAiOptInEnabled: setAiOptInEnabled, setIssueBreakdownStep: setIssueBreakdownStep, updateStreamingStatus: updateStreamingStatus }] = (0, (0, parcelRequire("7uAvV")).useIssueBreakdown)();
        const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, (0, parcelRequire("h0P1o")).IssueBreakdownEntryPointContext));
        const { key: projectKey, projectTypeKey: projectType } = projectsById[issue.project.id];
        (0, $5uXOq.useEffect)(()=>{
            const fetchAiOptInEnablement = async ()=>{
                try {
                    const isAiOptInEnabled = await (0, (0, parcelRequire("bXcRr")).fetchAiOptInData)((0, (0, parcelRequire("2vSU6")).convertToJiraProjectType)(projectType), cloudId, environment);
                    setAiOptInEnabled(projectKey, isAiOptInEnabled);
                } catch (error) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.fetch.services.ai.optin.service', 'Error fetching ai opt in value', error instanceof Error ? error : undefined);
                    setAiOptInEnabled(projectKey, false);
                }
            };
            if ((0, ($parcel$interopDefault($hGgHi)))(aiOptInEnabledByProject[projectKey])) fetchAiOptInEnablement();
        }, [
            aiOptInEnabledByProject,
            cloudId,
            environment,
            projectKey,
            projectType,
            setAiOptInEnabled
        ]);
        const triggerAnalytics = (analyticsEvent)=>{
            const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).AI_SUGGEST_CHILD_ISSUES.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).AI_SUGGEST_CHILD_ISSUES, {
                hierarchyLevel: issue.level,
                hasChildIssues: !!childrenIdsByParent[issue.id]
            });
        };
        const isAiOptInEnabled = getAiOptInEnabled(projectKey);
        const isDisabled = (0, $kbGxr.isScenarioIssue)(issue.id) || (0, $4nDwW.isDefined)(issue.originals) || !isAiOptInEnabled;
        const storyLevel = issue.level === (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE);
        const getTooltipContent = ()=>{
            if (!isAiOptInEnabled) return formatMessage((0, $3BsVK.default).tooltipForAiOptInDisabled);
            if (isDisabled) return formatMessage((0, $3BsVK.default).tooltipForDisabledSuggestChildIssues);
            if (storyLevel) return formatMessage((0, $3BsVK.default).tooltipSuggestSubtasks);
            return formatMessage((0, $3BsVK.default).tooltipSuggestChildIssues);
        };
        const renderDisabledInfoIconTooltip = ()=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: getTooltipContent(),
                position: "top"
            }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...tooltipProps,
                    appearance: "subtle",
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("6tRzQ"))))),
                    label: formatMessage((0, $ihPUd.default).moreInformation),
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.ai-suggest-child-issues.icon-button"
                }));
        };
        if (issue.level === (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_SUBTASK)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: isDisabled ? null : getTooltipContent(),
            position: "right"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            id: `suggest-child-issues-${issue.level}`,
            key: `suggest-child-issues-${issue.level}`,
            isDisabled: isDisabled,
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("37XBA")).AiIcon), {
                size: "medium",
                label: "",
                isDisabled: isDisabled
            }),
            elemAfter: isDisabled ? renderDisabledInfoIconTooltip() : null,
            onClick: (_, analyticsEvent)=>{
                entryPointActions.load();
                toggleAiWorkBreakdownPopup && toggleAiWorkBreakdownPopup({
                    isOpen: true
                });
                setIssueBreakdownStep((0, (0, parcelRequire("7uAvV")).steps).defaultStep);
                updateStreamingStatus(true);
                if (analyticsEvent) triggerAnalytics(analyticsEvent);
            },
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.ai-suggest-child-issues.button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), storyLevel ? (0, $3BsVK.default).suggestSubtasks : (0, $3BsVK.default).suggestChildIssues), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $153cd160b47b8180$var$lozengeStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "new"
        }, formatMessage((0, $3BsVK.default).betaLozenge)))))));
    };
    var $153cd160b47b8180$export$2e2bcd8739ae039 = $153cd160b47b8180$var$SuggestChildIssues;
    const $153cd160b47b8180$var$lozengeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignSelf: 'center',
        marginLeft: 'space.100'
    });
});
parcelRegister("6tRzQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b7f02ca64f03771$var$_react = $4b7f02ca64f03771$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b7f02ca64f03771$var$_information = $4b7f02ca64f03771$var$_interopRequireDefault((parcelRequire("2Yv61")));
    var $4b7f02ca64f03771$var$_panel = $4b7f02ca64f03771$var$_interopRequireDefault((parcelRequire("kkuz9")));
    function $4b7f02ca64f03771$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b7f02ca64f03771$var$InformationIcon = (props)=>$4b7f02ca64f03771$var$_react.default.createElement($4b7f02ca64f03771$var$_information.default, Object.assign({
            LEGACY_fallbackIcon: $4b7f02ca64f03771$var$_panel.default
        }, props));
    $4b7f02ca64f03771$var$InformationIcon.Name = 'InformationIconMigration';
    var $4b7f02ca64f03771$var$_default = module.exports.default = $4b7f02ca64f03771$var$InformationIcon;
});
parcelRegister("37XBA", function(module, exports) {
    $parcel$export(module.exports, "AiIcon", ()=>$1a27254ae9bfd82b$export$762da6f7f5ace732);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV6Te;
    const $1a27254ae9bfd82b$export$762da6f7f5ace732 = (props)=>{
        let iconAccentBlueB200;
        let textAccentBlueB400;
        if (props.isDisabled) {
            iconAccentBlueB200 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})`;
            textAccentBlueB400 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})`;
        } else if (props.isDisabled) {
            iconAccentBlueB200 = `var(--ds-icon-accent-gray, ${(0, $829f609a65d26a98$exports).N300})`;
            textAccentBlueB400 = `var(--ds-text-accent-gray, ${(0, $829f609a65d26a98$exports).N300})`;
        } else {
            iconAccentBlueB200 = `var(--ds-icon-accent-blue, ${(0, $829f609a65d26a98$exports).B200})`;
            textAccentBlueB400 = `var(--ds-text-accent-blue, ${(0, $829f609a65d26a98$exports).B400})`;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dV6Te")).default), {
            ...props,
            testId: "atlassian-intelligence.common.ui.ai-icon.svg-icon"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "ai_icon_lg0",
            x1: "21",
            y1: "12",
            x2: "17.5",
            y2: "12",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.270833",
            stopColor: iconAccentBlueB200,
            color: iconAccentBlueB200
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: textAccentBlueB400,
            color: textAccentBlueB400
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "ai_icon_lg1",
            x1: "12.5",
            y1: "3",
            x2: "12.5",
            y2: "6.5",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.1875",
            stopColor: iconAccentBlueB200,
            color: iconAccentBlueB200
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: textAccentBlueB400,
            color: textAccentBlueB400
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "ai_icon_lg2",
            x1: "6.82996",
            y1: "12",
            x2: "3.32996",
            y2: "12",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: textAccentBlueB400,
            color: textAccentBlueB400
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.791667",
            stopColor: iconAccentBlueB200,
            color: iconAccentBlueB200
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "ai_icon_lg3",
            x1: "12.5",
            y1: "17",
            x2: "12.5",
            y2: "21",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: textAccentBlueB400,
            color: textAccentBlueB400
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.802083",
            stopColor: iconAccentBlueB200,
            color: iconAccentBlueB200
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("g", null, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
            fill: props.isDisabled ? `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})` : 'url(#ai_icon_lg0)'
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
            fill: props.isDisabled ? `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})` : 'url(#ai_icon_lg1)'
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
            fill: props.isDisabled ? `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})` : 'url(#ai_icon_lg2)'
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
            fill: props.isDisabled ? `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})` : 'url(#ai_icon_lg3)'
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
            fill: iconAccentBlueB200
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
            fill: iconAccentBlueB200
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
            fill: iconAccentBlueB200
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
            fill: iconAccentBlueB200
        })));
    };
});
parcelRegister("bXcRr", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectTypeEnum", ()=>$93efec74987c40af$export$5dea9644eb4ef00a);
    $parcel$export(module.exports, "fetchAiOptInData", ()=>$93efec74987c40af$export$fb89b1bb2a07ced0);
    var $eAHUO;
    var $8Uumt = parcelRequire("8Uumt");
    const $93efec74987c40af$export$5dea9644eb4ef00a = {
        SOFTWARE: 'SOFTWARE',
        SERVICE_DESK: 'SERVICE_DESK',
        BUSINESS: 'BUSINESS',
        PRODUCT_DISCOVERY: 'PRODUCT_DISCOVERY'
    };
    const $93efec74987c40af$export$fb89b1bb2a07ced0 = async (projectType, cloudId, environment)=>{
        if (!projectType) return false;
        const data = await (0, $8Uumt.fetchQuery)(environment, (0, (0, parcelRequire("eAHUO")).default), {
            projectType: projectType,
            cloudId: cloudId
        }).toPromise().catch((err)=>{
            throw err;
        });
        return data?.jira?.isIssueViewEditorAiEnabled || false;
    };
});
parcelRegister("eAHUO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68cc7c211cebe348$export$2e2bcd8739ae039);
    const $68cc7c211cebe348$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        }, v2 = [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Variable",
                                "name": "jiraProjectType",
                                "variableName": "projectType"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "isIssueViewEditorAiEnabled"
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "aiOptinDataQuery",
                "selections": v2,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "aiOptinDataQuery",
                "selections": v2
            },
            "params": {
                "id": "6cff0bff184dc8f1a073b553a9ba32cbb75ba7299e1ab00005f3c40a5bffd4db",
                "metadata": {},
                "name": "aiOptinDataQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $68cc7c211cebe348$var$node.hash = "4c56f4213bd1abff6264c36450debe12";
    var $68cc7c211cebe348$export$2e2bcd8739ae039 = $68cc7c211cebe348$var$node;
});
parcelRegister("3BsVK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce0281e652983ae8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ce0281e652983ae8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        betaLozenge: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.ai-suggest-child-issues.beta-lozenge",
            "defaultMessage": "Beta"
        },
        suggestChildIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.ai-suggest-child-issues.suggest-child-issues",
            "defaultMessage": "Suggest child issues"
        },
        suggestSubtasks: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.ai-suggest-child-issues.suggest-subtasks",
            "defaultMessage": "Suggest subtasks"
        },
        tooltipSuggestChildIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.ai-suggest-child-issues.tooltip-suggest-child-issues",
            "defaultMessage": "Ask Atlassian Intelligence to suggest child issues for you"
        },
        tooltipSuggestSubtasks: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.ai-suggest-child-issues.tooltip-suggest-subtasks",
            "defaultMessage": "Ask Atlassian Intelligence to suggest subtasks for you"
        },
        tooltipForDisabledSuggestChildIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.ai-suggest-child-issues.tooltip-for-disabled-suggest-child-issues",
            "defaultMessage": "Please save the changes of this issue to Jira"
        },
        tooltipForAiOptInDisabled: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.ai-suggest-child-issues.tooltip-for-ai-opt-in-disabled",
            "defaultMessage": "To use Atlassian Intelligence, activate it from Atlassian Administration"
        }
    });
});
parcelRegister("c4U8L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40cbff9587fe5711$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $40cbff9587fe5711$var$getIconContents = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "m14.586 14.988-2.293 2.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 0 0-1.414 1.414l2.293 2.293H10a1 1 0 0 1-1-1v-7a1 1 0 0 0-2 0v7a3 3 0 0 0 3 3h4.586Z",
            fill: "currentColor"
        }));
    const $40cbff9587fe5711$var$ChildIcon = ({ label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $40cbff9587fe5711$var$getIconContents,
            size: "medium",
            label: label
        });
    var $40cbff9587fe5711$export$2e2bcd8739ae039 = $40cbff9587fe5711$var$ChildIcon;
});
parcelRegister("63IHV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0364c82899625553$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $koVbs;
    var $c4U8L = parcelRequire("c4U8L");
    var $Kd9Be = parcelRequire("Kd9Be");
    const $0364c82899625553$var$IssueTypeItem = (0, $5uXOq.memo)(({ issueType: issueType, relation: relation, onItemClick: onItemClick, children: children, ...props })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            onItemClick(issueType, relation);
        }, [
            issueType,
            onItemClick,
            relation
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.create-issue-type.issue-type-item.${issueType.id}`,
            onClick: handleClick,
            elemBefore: relation === 'child' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c4U8L.default), {
                label: formatMessage((0, $Kd9Be.default).childIconLabel)
            }) : undefined,
            ...props
        }, children);
    });
    var $0364c82899625553$export$2e2bcd8739ae039 = $0364c82899625553$var$IssueTypeItem;
});
parcelRegister("Kd9Be", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa39f485e0b596d0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $aa39f485e0b596d0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        childIconLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.create-issue-type.issue-type-item.child-icon-label",
            "defaultMessage": "Child"
        }
    });
});
parcelRegister("6Rc1s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c1d78919d33dd88$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4c1d78919d33dd88$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        childIconLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.create-issue-type.child-icon-label",
            "defaultMessage": "Child"
        },
        createIssue: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.create-issue-type.create-issue",
            "defaultMessage": "Create {issueType}"
        }
    });
});
parcelRegister("9OkbL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e55cec3adc35bc9$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4oR7Q = parcelRequire("4oR7Q");
    var $2f68o = parcelRequire("2f68o");
    var $ldQb2 = parcelRequire("ldQb2");
    var $7e55cec3adc35bc9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $2f68o.default), (0, $4oR7Q.default))((0, $ldQb2.default));
});
parcelRegister("4oR7Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ef461a1be4ce80a$export$2e2bcd8739ae039);
    var $7K8Pq = parcelRequire("7K8Pq");
    const $7ef461a1be4ce80a$var$mapDispatchToProps = (dispatch)=>({
            setIssueTypeIdForHierarchy: (hierarchyLevel, issueTypeId)=>{
                dispatch((0, $7K8Pq.setIssueTypeIdForHierarchy)(hierarchyLevel, issueTypeId));
            },
            setGlobalCreateIssue: ()=>{
                dispatch((0, $7K8Pq.setGlobalCreateIssue)(false));
            }
        });
    var $7ef461a1be4ce80a$export$2e2bcd8739ae039 = $7ef461a1be4ce80a$var$mapDispatchToProps;
});
parcelRegister("2f68o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed214aea797fb769$export$2e2bcd8739ae039);
    var $6Ayrn = parcelRequire("6Ayrn");
    var $gk0jw = parcelRequire("gk0jw");
    var $3YtPS = parcelRequire("3YtPS");
    var $ed214aea797fb769$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $gk0jw.getInlineCreateState),
        (0, $6Ayrn.getHierarchy)
    ], ({ issueTypeId: issueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy }, hierarchy)=>({
            issueTypeId: issueTypeId,
            IssueTypeIdForHierarchy: IssueTypeIdForHierarchy,
            hierarchy: hierarchy
        }));
});
parcelRegister("ldQb2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09344745d2987bf9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jB947;
    var $aRoVz;
    var $4R6GH;
    var $ousew;
    var $1iMQ1;
    var $2QLMT = parcelRequire("2QLMT");
    var $l38L3 = parcelRequire("l38L3");
    var $4nDwW = parcelRequire("4nDwW");
    var $azl5T = parcelRequire("azl5T");
    var $049o5 = parcelRequire("049o5");
    var $ksMKp = parcelRequire("ksMKp");
    function $09344745d2987bf9$var$CreateIssue(props) {
        const { groupCombination: groupCombination, hierarchy: hierarchy, hierarchyLevelsForType: hierarchyLevelsForType, isDisabled: isDisabled = false, issue: issue, projects: projects, setGlobalCreateIssue: setGlobalCreateIssue, setIssueTypeIdForHierarchy: setIssueTypeIdForHierarchy, startInlineCreate: startInlineCreate, triggerInlineCreateIssueAnalytics: triggerInlineCreateIssueAnalytics, typeToLevel: typeToLevel, toggleAiWorkBreakdownPopup: toggleAiWorkBreakdownPopup } = props;
        const { group: group, id: id, level: level, parent: parent, project: project, type: type } = issue;
        const currentLevel = hierarchy.find((hierarchyLevel)=>level === hierarchyLevel.level);
        if (!(0, $4nDwW.isDefined)(currentLevel)) return null;
        const hierarchyLevelTitle = (hierarchyLevel)=>hierarchyLevel.title.toLowerCase();
        const getInlineCreateProject = (level)=>{
            const projectsForLevel = projects.filter((project)=>project.issueTypeIds.some((id)=>typeToLevel(id) === level));
            return projectsForLevel.some(({ id: id })=>id === project.id) ? project : projectsForLevel[0];
        };
        const hierarchyLevels = hierarchyLevelsForType(type.id);
        const childLevel = (0, parcelRequire("jB947")).default(hierarchyLevels);
        let childInlineCreateProject;
        if ((0, $4nDwW.isDefined)(childLevel)) childInlineCreateProject = getInlineCreateProject(childLevel.level);
        const groupKey = groupCombination && Object.keys(groupCombination).length ? (0, $2QLMT.getGroupKey)(groupCombination) : group;
        const suggestChildIssuesComponent = ()=>{
            return (0, $4nDwW.isDefined)(childLevel) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $azl5T.default), {
                key: "suggest-child-issues-dropdown-menu-item",
                issue: issue,
                toggleAiWorkBreakdownPopup: toggleAiWorkBreakdownPopup
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            id: level,
            onClick: (_, analyticsEvent)=>{
                const inlineCreateProject = getInlineCreateProject(currentLevel.level);
                if (!(0, $4nDwW.isDefined)(inlineCreateProject)) return;
                const issueTypeId = type.id;
                if ((0, $4nDwW.isDefined)(issueTypeId)) {
                    setIssueTypeIdForHierarchy(currentLevel.level, issueTypeId);
                    setGlobalCreateIssue();
                    triggerInlineCreateIssueAnalytics(analyticsEvent, issueTypeId);
                    return startInlineCreate({
                        parentId: parent,
                        hierarchyLevel: currentLevel.level,
                        issueTypeId: issueTypeId,
                        projectId: inlineCreateProject.id,
                        siblingId: id,
                        group: groupKey,
                        groupCombination: groupCombination,
                        source: 'INLINE'
                    });
                }
            },
            key: level,
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $ksMKp.issueTypeLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $049o5.default).createIssue,
            values: {
                issueType: hierarchyLevelTitle(currentLevel)
            }
        }))), (0, $4nDwW.isDefined)(childInlineCreateProject) && (0, $4nDwW.isDefined)(childLevel) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            id: childLevel.level,
            isDisabled: isDisabled,
            onClick: (_, analyticsEvent)=>{
                const issueTypeId = (0, $l38L3.getInlineCreateIssueTypeId)(childLevel.level, childInlineCreateProject, props);
                setIssueTypeIdForHierarchy(childLevel.level, issueTypeId);
                setGlobalCreateIssue();
                triggerInlineCreateIssueAnalytics(analyticsEvent, issueTypeId);
                return startInlineCreate({
                    parentId: id,
                    hierarchyLevel: childLevel.level,
                    issueTypeId: issueTypeId,
                    projectId: childInlineCreateProject.id,
                    siblingId: null,
                    group: groupKey,
                    groupCombination: groupCombination,
                    source: 'INLINE'
                });
            },
            key: childLevel.level
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $ksMKp.issueTypeLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $049o5.default).createIssue,
            values: {
                issueType: hierarchyLevelTitle(childLevel)
            }
        }))), (0, (0, parcelRequire("4R6GH")).fg)('enable-ai-work-breakdown-in-plans') && suggestChildIssuesComponent());
    }
    var $09344745d2987bf9$export$2e2bcd8739ae039 = $09344745d2987bf9$var$CreateIssue;
});
parcelRegister("049o5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e95e445389795f5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9e95e445389795f5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createIssue: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.create-issue.create-issue",
            "defaultMessage": "Create {issueType}"
        }
    });
});
parcelRegister("ksMKp", function(module, exports) {
    $parcel$export(module.exports, "issueTypeLabel", ()=>$ee5c3c6c90a34e31$export$60d430d701944532, (v)=>$ee5c3c6c90a34e31$export$60d430d701944532 = v);
    var $ee5c3c6c90a34e31$export$60d430d701944532;
    $ee5c3c6c90a34e31$export$60d430d701944532 = `_0kirEG_issueTypeLabel`;
});
parcelRegister("bjso1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d8b7eeb0fbd8fd0$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5Vd2U = parcelRequire("5Vd2U");
    var $aFXZF = parcelRequire("aFXZF");
    var $6d8b7eeb0fbd8fd0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $5Vd2U.default))((0, $aFXZF.default));
});
parcelRegister("5Vd2U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5ca43234d2ecf5f$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $f5ca43234d2ecf5f$export$2e2bcd8739ae039 = (dispatch)=>({
            bulkUpdateRank: (payload)=>{
                dispatch((0, $bkasS.bulkRankIssue)(payload));
            }
        });
});
parcelRegister("aFXZF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d06fb3161a0adf08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aRoVz;
    var $dC5iT;
    var $3bDjY;
    var $cSD7y;
    var $ousew;
    var $8RXs9;
    var $koVbs;
    var $1iMQ1;
    var $5fACX = parcelRequire("5fACX");
    var $cGkDF = parcelRequire("cGkDF");
    const $d06fb3161a0adf08$var$RankIssueMenuGroup = ({ bulkUpdateRank: bulkUpdateRank, issueId: issueId, isSelected: isSelected })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const rankAboveMenuItem = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            onClick: ()=>{
                bulkUpdateRank({
                    operationType: (0, $5fACX.RANK_BEFORE),
                    anchor: issueId
                });
            },
            isDisabled: isSelected
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.rank-above-option"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cGkDF.default).rankAllSelectedIssuesAbove)));
        const rankBelowMenuItem = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            onClick: ()=>{
                bulkUpdateRank({
                    operationType: (0, $5fACX.RANK_AFTER),
                    anchor: issueId
                });
            },
            isDisabled: isSelected
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.rank-below-option"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cGkDF.default).rankAllSelectedIssuesBelow)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, isSelected ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, $cGkDF.default).noRankItself)
        }, rankAboveMenuItem) : rankAboveMenuItem, isSelected ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, $cGkDF.default).noRankItself)
        }, rankBelowMenuItem) : rankBelowMenuItem);
    };
    function $d06fb3161a0adf08$var$RankIssueMenuGroupOld({ intl: intl, bulkUpdateRank: bulkUpdateRank, issueId: issueId, isSelected: isSelected }) {
        const rankAboveEl = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.rank-above-option"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cGkDF.default).rankAllSelectedIssuesAbove));
        const rankBelowEl = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.rank-below-option"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cGkDF.default).rankAllSelectedIssuesBelow));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            onClick: ()=>{
                bulkUpdateRank({
                    operationType: (0, $5fACX.RANK_BEFORE),
                    anchor: issueId
                });
            },
            isDisabled: isSelected
        }, isSelected ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: intl.formatMessage((0, $cGkDF.default).noRankItself)
        }, rankAboveEl) : rankAboveEl), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            onClick: ()=>{
                bulkUpdateRank({
                    operationType: (0, $5fACX.RANK_AFTER),
                    anchor: issueId
                });
            },
            isDisabled: isSelected
        }, isSelected ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: intl.formatMessage((0, $cGkDF.default).noRankItself)
        }, rankBelowEl) : rankBelowEl));
    }
    var $d06fb3161a0adf08$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('fix_tooltip_positioning_plans_meatball', $d06fb3161a0adf08$var$RankIssueMenuGroup, (0, (0, parcelRequire("8RXs9")).default)($d06fb3161a0adf08$var$RankIssueMenuGroupOld));
});
parcelRegister("cGkDF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5b55bc1631d2c5e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b5b55bc1631d2c5e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rankAllSelectedIssuesBelow: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.rank-all-selected-issues-below",
            "defaultMessage": "Rank selected issues below"
        },
        rankAllSelectedIssuesAbove: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.rank-all-selected-issues-above",
            "defaultMessage": "Rank selected issues above"
        },
        noRankItself: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.no-rank-itself",
            "defaultMessage": "Only unselected issues can be a reference for ranking."
        }
    });
});
parcelRegister("9J2rn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$417b22f74a897771$export$2e2bcd8739ae039);
    var $bC2fB;
    var $anl7S = parcelRequire("anl7S");
    var $gs5BU = parcelRequire("gs5BU");
    var $417b22f74a897771$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $anl7S.default), undefined)((0, $gs5BU.default));
});
parcelRegister("anl7S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aff02dbcb02c0b00$export$2e2bcd8739ae039);
    var $6Ayrn = parcelRequire("6Ayrn");
    var $3YtPS = parcelRequire("3YtPS");
    var $aff02dbcb02c0b00$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $6Ayrn.getHierarchy)
    ], (hierarchy)=>({
            hierarchy: hierarchy
        }));
});
parcelRegister("gs5BU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00f22cae65137dd0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aRoVz;
    var $f5TWP;
    var $8CUq3;
    var $ousew;
    var $1iMQ1;
    var $4nDwW = parcelRequire("4nDwW");
    var $kbGxr = parcelRequire("kbGxr");
    var $aYgcR = parcelRequire("aYgcR");
    const $00f22cae65137dd0$var$RemoveIssue = ({ hierarchy: hierarchy, isDisabled: isDisabled = false, issue: { level: level, id: issueId }, setModalAction: setModalAction })=>{
        const currentLevel = hierarchy.find((hierarchyLevel)=>level === hierarchyLevel.level);
        if (!(0, $4nDwW.isDefined)(currentLevel)) return null;
        const isScenarioIssue = (0, $kbGxr.isScenarioIssue)(issueId);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            id: `remove-${level}`,
            onClick: ()=>setModalAction((0, $813368d82e314d52$export$dfe0d1d38e6d3bc8)),
            key: `remove-${level}`,
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $00f22cae65137dd0$var$menuItemLabelStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), isScenarioIssue ? (0, $aYgcR.default).removeScenarioIssue : (0, $aYgcR.default).removeSavedIssue))));
    };
    var $00f22cae65137dd0$export$2e2bcd8739ae039 = $00f22cae65137dd0$var$RemoveIssue;
    const $00f22cae65137dd0$var$menuItemLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxWidth: '215px',
        display: 'inline-block'
    });
});
parcelRegister("aYgcR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a03c058b2fee0a72$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a03c058b2fee0a72$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeSavedIssue: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.remove-issue.remove-saved-issue",
            "defaultMessage": "Remove from plan"
        },
        removeScenarioIssue: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.remove-issue.remove-scenario-issue",
            "defaultMessage": "Delete draft issue"
        },
        deleteIssueNonFinal: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.remove-issue.delete-issue-non-final",
            "defaultMessage": "Delete {issueType}"
        }
    });
});
parcelRegister("4lFm3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$089c7d11a1c85b35$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aRoVz;
    var $ousew;
    var $1iMQ1;
    var $i2qlb = parcelRequire("i2qlb");
    var $3ODbh = parcelRequire("3ODbh");
    var $8zOmE;
    var $jvXsA = parcelRequire("jvXsA");
    function $089c7d11a1c85b35$export$2e2bcd8739ae039({ onRequestSelect: onRequestSelect }) {
        const handleRequestSelect = (targetType)=>{
            onRequestSelect(true, {
                targetType: targetType
            });
        };
        const triggerAnalytics = (analyticsEvent, targetType)=>{
            const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES, {
                selectOption: targetType
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            onClick: (_, analyticsEvent)=>{
                handleRequestSelect((0, $3ODbh.TargetTypes).singleAndDescendants);
                if (analyticsEvent) triggerAnalytics(analyticsEvent, (0, $3ODbh.TargetTypes).singleAndDescendants);
            },
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.select-issue.select-issue-and-descendants"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $jvXsA.default).selectSingleAndDescendants)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            onClick: (_, analyticsEvent)=>{
                handleRequestSelect((0, $3ODbh.TargetTypes).descendants);
                if (analyticsEvent) triggerAnalytics(analyticsEvent, (0, $3ODbh.TargetTypes).descendants);
            },
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.select-issue.select-only-descendant-issues"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $jvXsA.default).selectDescendants)));
    }
});
parcelRegister("jvXsA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eff5b8e33a1e592a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $eff5b8e33a1e592a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        selectSingleAndDescendants: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.select-issue.select-single-and-descendants",
            "defaultMessage": "Select this and all descendant issues"
        },
        selectDescendants: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.select-issue.select-descendants",
            "defaultMessage": "Select only descendant issues"
        }
    });
});
parcelRegister("lRZWT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4f933789805c4ea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bJeNF;
    var $co1wz;
    var $1iMQ1;
    var $i2qlb = parcelRequire("i2qlb");
    var $8zOmE;
    var $2NMNM;
    var $4bZgR = parcelRequire("4bZgR");
    var $eZ8eo = parcelRequire("eZ8eo");
    function $e4f933789805c4ea$var$Divider() {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eZ8eo.divider
        });
    }
    function $e4f933789805c4ea$var$withDivider(children) {
        if (!Array.isArray(children)) return children;
        const result = children.reduce((result, elem, idx)=>{
            const child = (0, $5uXOq.cloneElement)(elem, {
                ...elem.props,
                key: idx
            });
            const divider = (0, ($parcel$interopDefault($5uXOq))).createElement($e4f933789805c4ea$var$Divider, {
                key: `divider-${idx}`
            });
            if (idx === 0) return [
                child
            ];
            return result.concat([
                divider,
                child
            ]);
        }, []);
        return result;
    }
    function $e4f933789805c4ea$export$2e2bcd8739ae039({ ariaLabel: ariaLabel = '', handleBlurEvent: handleBlurEvent, onOpenChange: onOpenChange, children: children, hierarchyLevel: hierarchyLevel }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleOnOpenChange = ({ isOpen: isOpen })=>{
            if (isOpen) {
                const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_ISSUE_MORE_ACTIONS_MENU.split(' ');
                const analyticsEvent = createAnalyticsEvent({
                    action: eventAction,
                    actionSubject: actionSubject
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'plansScopeIssueMoreActionsButton', {
                    hierarchyLevel: hierarchyLevel
                });
            }
            onOpenChange({
                isOpen: isOpen
            });
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eZ8eo.root
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4bZgR.DraggableIconButton), {
                    ...props,
                    ref: triggerRef,
                    appearance: "subtle",
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))),
                    label: ariaLabel,
                    onBlur: handleBlurEvent
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...props,
                    ref: triggerRef,
                    appearance: "subtle",
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement("span", null),
                    spacing: "none",
                    onBlur: handleBlurEvent
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $eZ8eo.moreIconWrapper
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                    label: ariaLabel,
                    color: "currentColor"
                }))),
            shouldRenderToParent: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? false : undefined,
            onOpenChange: handleOnOpenChange,
            placement: "bottom-end",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.more-meatball"
        }, $e4f933789805c4ea$var$withDivider(children))));
    }
});
parcelRegister("eZ8eo", function(module, exports) {
    $parcel$export(module.exports, "divider", ()=>$ae8d25bd886b7c88$export$e8c9778bf415dd08, (v)=>$ae8d25bd886b7c88$export$e8c9778bf415dd08 = v);
    $parcel$export(module.exports, "moreIconWrapper", ()=>$ae8d25bd886b7c88$export$c62a2b850ddc74e1, (v)=>$ae8d25bd886b7c88$export$c62a2b850ddc74e1 = v);
    $parcel$export(module.exports, "root", ()=>$ae8d25bd886b7c88$export$e8e78c978b129247, (v)=>$ae8d25bd886b7c88$export$e8e78c978b129247 = v);
    var $ae8d25bd886b7c88$export$e8c9778bf415dd08;
    var $ae8d25bd886b7c88$export$c62a2b850ddc74e1;
    var $ae8d25bd886b7c88$export$e8e78c978b129247;
    $ae8d25bd886b7c88$export$e8c9778bf415dd08 = `wrZGAG_divider`;
    $ae8d25bd886b7c88$export$c62a2b850ddc74e1 = `wrZGAG_moreIconWrapper`;
    $ae8d25bd886b7c88$export$e8e78c978b129247 = `wrZGAG_root`;
});
parcelRegister("l5aiG", function(module, exports) {
    $parcel$export(module.exports, "HighlightSummary", ()=>$29cba1623503dc45$export$596cc1018cfcd53a);
    $parcel$export(module.exports, "HighlightIssueLink", ()=>$29cba1623503dc45$export$2e8997f2a171b7ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $8CUq3;
    var $1XJ20;
    var $2FvnI;
    var $jLI87 = parcelRequire("jLI87");
    var $4nDwW = parcelRequire("4nDwW");
    var $hMMDD = parcelRequire("hMMDD");
    function $29cba1623503dc45$export$596cc1018cfcd53a({ numberOfIssueLinkChunks: numberOfIssueLinkChunks, summary: summary, searchQuery: searchQuery, id: id, activeSearchResultIndex: activeSearchResultIndex, searchMatches: searchMatches, group: group }) {
        const activeElRef = (0, $5uXOq.createRef)();
        const [ellipsisInfo, setEllipsisInfo] = (0, $5uXOq.useState)({
            chunks: (0, $jLI87.splitString)(searchQuery, summary),
            offsetLeft: 0
        });
        const [prevQuery, setPrevQuery] = (0, $5uXOq.useState)('');
        const activeMatch = searchMatches[activeSearchResultIndex] || {};
        const isIssueWithActiveElement = activeMatch.id === id;
        const getInternalIndex = (index)=>index > 0 ? index - numberOfIssueLinkChunks : index;
        const prevActiveSearchResultIndex = (0, (0, parcelRequire("1XJ20")).usePrevious)(activeSearchResultIndex);
        const prevIsIssueWithActiveElement = (0, (0, parcelRequire("1XJ20")).usePrevious)(isIssueWithActiveElement);
        const prevActiveMatchId = (0, (0, parcelRequire("1XJ20")).usePrevious)(activeMatch.id);
        const prevSummary = (0, (0, parcelRequire("1XJ20")).usePrevious)(summary);
        const isActiveElVisible = (ref)=>{
            if (ref && ref.current && ref.current.parentElement instanceof HTMLElement) return (ref.current.offsetLeft + ref.current.offsetWidth - 1 <= ref.current.parentElement.offsetLeft + ref.current.parentElement.offsetWidth);
        };
        (0, $5uXOq.useEffect)(()=>{
            const isNavigationBackAtTheSameEl = (0, $4nDwW.isDefined)(prevActiveSearchResultIndex) && prevActiveSearchResultIndex > activeSearchResultIndex && prevActiveMatchId === activeMatch.id;
            if (searchQuery && searchQuery !== prevQuery || !isIssueWithActiveElement && !!prevIsIssueWithActiveElement || isNavigationBackAtTheSameEl || prevSummary !== summary) {
                setPrevQuery(searchQuery);
                setEllipsisInfo({
                    chunks: (0, $jLI87.splitString)(searchQuery, summary),
                    offsetLeft: 0
                });
            }
        }, [
            activeElRef,
            activeMatch.id,
            activeSearchResultIndex,
            isIssueWithActiveElement,
            prevActiveMatchId,
            prevActiveSearchResultIndex,
            prevIsIssueWithActiveElement,
            prevQuery,
            prevSummary,
            searchQuery,
            summary
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const getWordStart = (restArray)=>{
                const lastEl = restArray[restArray.length - 1];
                const index = lastEl.lastIndexOf(' ');
                if (index > 0) return lastEl.substring(index + 1);
            };
            const matchIndex = activeMatch.internalIndex - numberOfIssueLinkChunks;
            if (isActiveElVisible(activeElRef) === false && matchIndex > 0) {
                const chunksArray = (0, $jLI87.splitString)(searchQuery, summary);
                let chunks = chunksArray.splice(matchIndex);
                const wordStart = getWordStart(chunksArray) || '';
                if (wordStart) chunks = [
                    '...',
                    wordStart
                ].concat(chunks);
                else chunks = [
                    '...'
                ].concat(chunks);
                setEllipsisInfo({
                    chunks: chunks,
                    offsetLeft: !wordStart ? matchIndex - 1 : matchIndex - 2
                });
            }
        }, [
            activeElRef,
            activeMatch.internalIndex,
            numberOfIssueLinkChunks,
            searchQuery,
            summary
        ]);
        if (!searchQuery.trim() || !searchMatches.length) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $hMMDD.ellipsis
        }, summary);
        const highlightedParts = ellipsisInfo.chunks.map((chunk, i)=>{
            if ((0, $jLI87.equalsIgnoreCase)(chunk, searchQuery)) {
                const matchIndex = getInternalIndex(activeMatch.internalIndex);
                if (!activeMatch.linkMatch && activeMatch.group === group && isIssueWithActiveElement && i === matchIndex - ellipsisInfo.offsetLeft) return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    ref: activeElRef,
                    className: `${$hMMDD.textMatch} ${$hMMDD.isActive}`,
                    key: "active"
                }, chunk));
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    className: $hMMDD.textMatch,
                    key: `${chunk}-${i}`
                }, chunk));
            }
            return chunk;
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $hMMDD.ellipsis
        }, highlightedParts);
    }
    function $29cba1623503dc45$export$2e8997f2a171b7ea({ issueKey: issueKey, projectKey: projectKey, activeMatch: { internalIndex: internalIndex, id: id, group: activeGroup } = {}, searchQuery: searchQuery, issueLinkChunks: issueLinkChunks, issueId: issueId, group: group }) {
        const getLinkText = ()=>{
            if (issueLinkChunks.length) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, issueLinkChunks.map((chunk, i)=>{
                if ((0, $jLI87.equalsIgnoreCase)(chunk, searchQuery)) return activeGroup === group && issueId === id && i === internalIndex ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    className: `${$hMMDD.textMatch} ${$hMMDD.isActive}`,
                    key: "active"
                }, chunk) : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    className: $hMMDD.textMatch,
                    key: `${chunk}-${i}`
                }, chunk);
                return chunk;
            }));
            return '';
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvnI")).default), {
            issueKey: issueKey,
            projectKey: projectKey,
            xcssStyles: $29cba1623503dc45$var$issueLinkStyles,
            issueId: issueId
        }, getLinkText());
    }
    const $29cba1623503dc45$var$issueLinkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        whiteSpace: 'nowrap',
        marginRight: 'space.050'
    });
});
parcelRegister("hMMDD", function(module, exports) {
    $parcel$export(module.exports, "ellipsis", ()=>$cf2ca5ec6f7766a7$export$a5b94313d6908893, (v)=>$cf2ca5ec6f7766a7$export$a5b94313d6908893 = v);
    $parcel$export(module.exports, "isActive", ()=>$cf2ca5ec6f7766a7$export$39e04e72f972b885, (v)=>$cf2ca5ec6f7766a7$export$39e04e72f972b885 = v);
    $parcel$export(module.exports, "textMatch", ()=>$cf2ca5ec6f7766a7$export$e1215fdc5282ac0e, (v)=>$cf2ca5ec6f7766a7$export$e1215fdc5282ac0e = v);
    var $cf2ca5ec6f7766a7$export$a5b94313d6908893;
    var $cf2ca5ec6f7766a7$export$39e04e72f972b885;
    var $cf2ca5ec6f7766a7$export$e1215fdc5282ac0e;
    $cf2ca5ec6f7766a7$export$a5b94313d6908893 = `_5eHewW_ellipsis`;
    $cf2ca5ec6f7766a7$export$39e04e72f972b885 = `_5eHewW_isActive`;
    $cf2ca5ec6f7766a7$export$e1215fdc5282ac0e = `_5eHewW_textMatch`;
});
parcelRegister("ldEmK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e8b7d29e65f8373$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5fhme = parcelRequire("5fhme");
    var $lBxLS = parcelRequire("lBxLS");
    var $9e8b7d29e65f8373$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $5fhme.mapDispatchToProps))((0, $lBxLS.default));
});
parcelRegister("5fhme", function(module, exports) {
    $parcel$export(module.exports, "mapDispatchToProps", ()=>$a4fbf537ac4983d8$export$9e6a17cf56877796);
    var $bkasS = parcelRequire("bkasS");
    const $a4fbf537ac4983d8$export$9e6a17cf56877796 = {
        removeFromPlan: (0, $bkasS.removeSingleIssue)
    };
});
parcelRegister("lBxLS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fccd20883242c204$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $cgL5K;
    var $9fuVs;
    var $ousew;
    var $koVbs;
    var $ihPUd = parcelRequire("ihPUd");
    var $kbGxr = parcelRequire("kbGxr");
    var $8zOmE;
    var $Samd0 = parcelRequire("Samd0");
    const $fccd20883242c204$var$RemoveIssueDialog = ({ issueId: issueId, issueKey: issueKey, projectKey: projectKey, onClose: onClose, removeFromPlan: removeFromPlan })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isScenarioIssue = (0, $kbGxr.isScenarioIssue)(issueId);
        const issueIdentifier = projectKey && issueKey ? `${projectKey}-${issueKey}` : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            shouldScrollInViewport: true,
            onClose: onClose,
            autoFocus: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "danger"
        }, formatMessage(isScenarioIssue ? (0, $Samd0.default).removeScenarioIssueTitle : (0, $Samd0.default).removeSavedIssueTitle))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...isScenarioIssue ? (0, $Samd0.default).removeScenarioIssueMessage : (0, $Samd0.default).removeSavedIssueMessage,
            values: {
                issueIdentifier: issueIdentifier,
                b: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunk)
            }
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "primary",
            onClick: (_, analyticsEvent)=>{
                removeFromPlan({
                    issueId: issueId
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'confirmInlineRemoveIssue', {
                    isScenarioIssue: isScenarioIssue
                });
                onClose();
            }
        }, formatMessage(isScenarioIssue ? (0, $Samd0.default).removeScenarioIssueActionButton : (0, $Samd0.default).removeSavedIssueActionButton)))));
    };
    var $fccd20883242c204$export$2e2bcd8739ae039 = $fccd20883242c204$var$RemoveIssueDialog;
});
parcelRegister("Samd0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f99316610a8806c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8f99316610a8806c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeScenarioIssueTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.remove-issue-dialog.remove-scenario-issue-title",
            "defaultMessage": "Delete draft issue"
        },
        removeSavedIssueTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.remove-issue-dialog.remove-saved-issue-title",
            "defaultMessage": "Remove issue from plan"
        },
        removeScenarioIssueMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.remove-issue-dialog.remove-scenario-issue-message",
            "defaultMessage": "This issue will be permanently deleted from the plan."
        },
        removeSavedIssueMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.remove-issue-dialog.remove-saved-issue-message",
            "defaultMessage": "{issueIdentifier, select,\n\t\t\tundefined {This issue will no longer appear in the plan but will be stored in <b>Removed issues</b> within <b>Plan settings</b>.}\n\t\t\tother {{issueIdentifier} will no longer appear in the plan but will be stored in <b>Removed issues</b> within <b>Plan settings</b>.}}"
        },
        removeScenarioIssueActionButton: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.remove-issue-dialog.remove-scenario-issue-action-button",
            "defaultMessage": "Delete"
        },
        removeSavedIssueActionButton: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.remove-issue-dialog.remove-saved-issue-action-button",
            "defaultMessage": "Remove"
        }
    });
});
parcelRegister("6D4Es", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25fcbd3f2702a629$export$2e2bcd8739ae039);
    var $bC2fB;
    var $aCpd6 = parcelRequire("aCpd6");
    var $9C8At = parcelRequire("9C8At");
    var $clGGr = parcelRequire("clGGr");
    var $3ODbh = parcelRequire("3ODbh");
    var $25fcbd3f2702a629$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $9C8At.default), (0, $aCpd6.default))((0, $clGGr.default));
});
parcelRegister("aCpd6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$650832c260c05d50$export$2e2bcd8739ae039);
    var $3ODbh = parcelRequire("3ODbh");
    var $650832c260c05d50$export$2e2bcd8739ae039 = {
        toggleSelectedIssues: $3ODbh.toggleSelectedIssues
    };
});
parcelRegister("9C8At", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$719c7447ee1b59ca$export$2e2bcd8739ae039);
    var $bI9dZ = parcelRequire("bI9dZ");
    var $4sJY8 = parcelRequire("4sJY8");
    var $6iNxz = parcelRequire("6iNxz");
    var $3YtPS = parcelRequire("3YtPS");
    var $jK6Qc = parcelRequire("jK6Qc");
    const $719c7447ee1b59ca$var$lastSelected = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Issues.lastSelected;
    const $719c7447ee1b59ca$var$getIssueIdFromProps = (_, props)=>props.issueId;
    const $719c7447ee1b59ca$var$getIssues = (0, $3YtPS.createSelector)([
        (0, $jK6Qc.getEnhancedIssues)
    ], (enhancedIssues)=>enhancedIssues.filter((item)=>item.tag === (0, $6iNxz.TABLE_ISSUE)));
    const $719c7447ee1b59ca$var$isSelected = (state, props)=>!!(0, $bI9dZ.getSelected)(state).has(props.issueId);
    const $719c7447ee1b59ca$export$9b7fd1d370baca28 = (descendantIds, selected, issueId)=>!!(descendantIds[issueId] && descendantIds[issueId].some((id)=>selected.has(id)));
    const $719c7447ee1b59ca$export$b8b0369ffb6a709c = (state, props)=>(0, $bI9dZ.getDescendantIdsByParent)(state)[props.issueId] || [];
    const $719c7447ee1b59ca$var$hasChildSelected = (0, $3YtPS.createSelector)([
        (0, $4sJY8.getChildrenIdsByParent),
        (0, $bI9dZ.getSelected),
        $719c7447ee1b59ca$var$getIssueIdFromProps
    ], $719c7447ee1b59ca$export$9b7fd1d370baca28);
    const $719c7447ee1b59ca$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        isSelected: $719c7447ee1b59ca$var$isSelected,
        hasChildSelected: $719c7447ee1b59ca$var$hasChildSelected,
        lastSelected: $719c7447ee1b59ca$var$lastSelected,
        descendantIds: $719c7447ee1b59ca$export$b8b0369ffb6a709c,
        issues: $719c7447ee1b59ca$var$getIssues
    });
    var $719c7447ee1b59ca$export$2e2bcd8739ae039 = $719c7447ee1b59ca$var$querySelector;
});
parcelRegister("jK6Qc", function(module, exports) {
    $parcel$export(module.exports, "getEnhancedIssues", ()=>$ac5a9810bc43944c$export$39b2928f3df68999);
    $parcel$export(module.exports, "getTagTableItems", ()=>$ac5a9810bc43944c$export$86385f4dbe276904);
    $parcel$export(module.exports, "default", ()=>$ac5a9810bc43944c$export$2e2bcd8739ae039);
    var $2rMKg;
    var $4ENQh;
    var $1CGdp = parcelRequire("1CGdp");
    var $19iju = parcelRequire("19iju");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $kllqP = parcelRequire("kllqP");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $jLI87 = parcelRequire("jLI87");
    var $6iNxz = parcelRequire("6iNxz");
    var $kWDpn = parcelRequire("kWDpn");
    var $j0XCX = parcelRequire("j0XCX");
    var $eIyFU = parcelRequire("eIyFU");
    var $bREsp = parcelRequire("bREsp");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $cScrq = parcelRequire("cScrq");
    const $ac5a9810bc43944c$export$74a7083d7abc94c3 = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getVisualisationViewSettings),
        (0, $19iju.getCustomFieldsById)
    ], (viewSetting, customFieldsById)=>{
        const grouping = viewSetting.grouping;
        const customFieldId = (0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping);
        if (customFieldId.length > 0) {
            const fieldType = customFieldsById[Number(customFieldId)]?.type?.key;
            return (0, $cScrq.isMultiSelectCustomField)(fieldType);
        }
        return false;
    });
    const $ac5a9810bc43944c$export$8448badc5d8eb2d6 = (tableItems, issueTypes, projects, hierarchyLevelsByLevel)=>{
        const id = (0, parcelRequire("2rMKg")).default('id');
        const issueTypesById = (0, $4nDwW.indexBy)(id, issueTypes);
        const projectsById = (0, $4nDwW.indexBy)(id, projects);
        const enhance = (issue)=>{
            const result = {};
            for (const key of Object.keys(issue))result[key] = issue[key];
            result.type = issueTypesById[issue.type] || (0, $bREsp.DEFAULT_SCRATCH_ISSUE_TYPE);
            result.project = projectsById[issue.project];
            return result;
        };
        return tableItems.map((item)=>{
            switch(item.tag){
                case 0, $6iNxz.TABLE_ISSUE:
                    {
                        const { tag: tag, value: issue, group: group, parentGroup: parentGroup, groupCombination: groupCombination } = item;
                        const enhancedIssue = {
                            tag: tag,
                            value: enhance(issue),
                            group: group,
                            parentGroup: parentGroup,
                            groupCombination: groupCombination
                        };
                        return enhancedIssue;
                    }
                case 0, $6iNxz.TABLE_GROUP_HEADER:
                    {
                        const { tag: tag, value: { id: id, isExpanded: isExpanded, level: level, rootIssuesCount: rootIssuesCount }, group: group, parentGroup: parentGroup } = item;
                        const enhancedHeader = {
                            tag: tag,
                            value: {
                                id: id,
                                isExpanded: isExpanded,
                                level: hierarchyLevelsByLevel[level],
                                rootIssuesCount: rootIssuesCount
                            },
                            group: group,
                            parentGroup: parentGroup
                        };
                        return enhancedHeader;
                    }
                default:
                    return item;
            }
        });
    };
    const $ac5a9810bc43944c$export$1e3085667260a419 = (0, (0, parcelRequire("4ENQh")).monitor).timeFunction($ac5a9810bc43944c$export$8448badc5d8eb2d6, 'roadmap_scope_issues_query_getEnhancedIssuesPure');
    const $ac5a9810bc43944c$export$39b2928f3df68999 = (0, $3YtPS.createSelector)([
        (0, $6iNxz.getTableItems),
        (0, $kllqP.getIssueTypes),
        (0, $jpXKt.getProjects),
        (0, $6Ayrn.getHierarchyLevelsByLevel)
    ], $ac5a9810bc43944c$export$1e3085667260a419);
    const $ac5a9810bc43944c$export$ee51405ad885730a = (issues)=>issues.filter((item)=>item.tag === (0, $6iNxz.TABLE_GROUP));
    const $ac5a9810bc43944c$export$86385f4dbe276904 = (0, $3YtPS.createSelector)([
        $ac5a9810bc43944c$export$39b2928f3df68999
    ], $ac5a9810bc43944c$export$ee51405ad885730a);
    const $ac5a9810bc43944c$var$getGroupBySetting = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getVisualisationViewSettings)
    ], (viewSetting)=>viewSetting.grouping);
    var $ac5a9810bc43944c$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        $ac5a9810bc43944c$export$39b2928f3df68999,
        (0, $6iNxz.getScrollToIndex),
        (0, $6iNxz.getDisableDnD),
        (0, $1CGdp.getMode),
        (0, $gFhwb.getIssues),
        (0, $jLI87.getScope),
        (0, $bI9dZ.getIsIssuesLoading),
        (0, $eIyFU.getWarnings),
        (0, $kWDpn.getWarningViewSettings),
        (0, $j0XCX.getVisualisationSorting),
        $ac5a9810bc43944c$export$74a7083d7abc94c3,
        $ac5a9810bc43944c$var$getGroupBySetting
    ], (issues, scrollToIndex, disableDnD, mode, issuesInPlan, scope, isLoading, warnings, warningSetting, sorting, isGroupingByMultiSelectCustomField, getGroupBySetting)=>({
            isLoading: isLoading,
            scrollToIndex: scrollToIndex,
            disableDnD: disableDnD,
            isReadOnly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
            issues: issues,
            noIssuesInPlan: issuesInPlan.length === 0,
            rankDigits: scope.startLevelIssues.rootIssuesCount.toString().length,
            startLevel: scope.startLevelIssues.level,
            warnings: warnings,
            showWarning: warningSetting.showWarning,
            sorting: sorting,
            isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField,
            grouping: getGroupBySetting
        }));
});
parcelRegister("clGGr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ac891f512fad00e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3ODbh = parcelRequire("3ODbh");
    var $bDiPh = parcelRequire("bDiPh");
    const $9ac891f512fad00e$export$d411c0d423bc94e0 = ({ issues: issues, lastSelected: lastSelected, descendantIds: descendantIds, toggleSelectedIssues: toggleSelectedIssues, issueId: issueId, group: group, isSelected: isSelected, hasChildSelected: hasChildSelected, children: children })=>{
        const toggleSingle = (0, $5uXOq.useCallback)((on, { targetType: targetType })=>toggleSelectedIssues({
                ids: [
                    issueId
                ],
                isSelected: on,
                group: group,
                targetType: targetType
            }), [
            group,
            issueId,
            toggleSelectedIssues
        ]);
        const toggleExtending = (0, $5uXOq.useCallback)((on, { targetType: targetType })=>{
            const issuesInBetween = (0, $bDiPh.getIssuesInRange)({
                issues: issues,
                lastSelected: lastSelected,
                issueId: issueId,
                group: group
            });
            const ids = issuesInBetween.map((issue)=>(0, $bDiPh.getId)(issue) || '');
            return toggleSelectedIssues({
                ids: ids,
                isSelected: on,
                group: group,
                targetType: targetType
            });
        }, [
            group,
            issueId,
            issues,
            lastSelected,
            toggleSelectedIssues
        ]);
        const toggleDescendants = (0, $5uXOq.useCallback)((on, { targetType: targetType })=>{
            toggleSelectedIssues({
                ids: descendantIds,
                currentIssueId: issueId,
                isSelected: on,
                group: group,
                targetType: targetType
            });
        }, [
            descendantIds,
            group,
            issueId,
            toggleSelectedIssues
        ]);
        const toggleSingleAndDescendants = (0, $5uXOq.useCallback)((on, { targetType: targetType })=>toggleSelectedIssues({
                ids: [
                    issueId
                ].concat(descendantIds),
                isSelected: on,
                group: group,
                targetType: targetType
            }), [
            descendantIds,
            group,
            issueId,
            toggleSelectedIssues
        ]);
        const toggle = (0, $5uXOq.useCallback)((on, toggleParams)=>{
            const { extending: extending, targetType: targetType } = toggleParams;
            if (extending && lastSelected.id) return toggleExtending(on, toggleParams);
            switch(targetType){
                case (0, $3ODbh.TargetTypes).single:
                    return toggleSingle(on, toggleParams);
                case (0, $3ODbh.TargetTypes).singleAndDescendants:
                    return toggleSingleAndDescendants(true, toggleParams);
                case (0, $3ODbh.TargetTypes).descendants:
                    return toggleDescendants(true, toggleParams);
                default:
                    throw new TypeError('unexpected targetType');
            }
        }, [
            lastSelected?.id,
            toggleDescendants,
            toggleExtending,
            toggleSingle,
            toggleSingleAndDescendants
        ]);
        return children({
            isSelected: isSelected,
            hasChildSelected: hasChildSelected,
            toggleSelected: toggle
        });
    };
    var $9ac891f512fad00e$export$2e2bcd8739ae039 = $9ac891f512fad00e$export$d411c0d423bc94e0;
});
parcelRegister("bDiPh", function(module, exports) {
    $parcel$export(module.exports, "getId", ()=>$887390f105211430$export$218c8c3169c024d2);
    $parcel$export(module.exports, "getIssuesInRange", ()=>$887390f105211430$export$ee4b94b8b7f020aa);
    var $6iNxz = parcelRequire("6iNxz");
    function $887390f105211430$export$218c8c3169c024d2(item) {
        if (item.tag !== (0, $6iNxz.TABLE_ISSUE)) return null;
        return item.value.id;
    }
    const $887390f105211430$var$getGroup = (item)=>item.group;
    function $887390f105211430$export$ee4b94b8b7f020aa({ issues: issues, lastSelected: lastSelected, issueId: issueId, group: group }) {
        const lastSelectedIndex = issues.findIndex((issue)=>!$887390f105211430$var$getGroup(issue) ? $887390f105211430$export$218c8c3169c024d2(issue) === lastSelected.id : lastSelected.group === $887390f105211430$var$getGroup(issue) && $887390f105211430$export$218c8c3169c024d2(issue) === lastSelected.id);
        const thisSelectedIndex = issues.findIndex((issue)=>!$887390f105211430$var$getGroup(issue) ? $887390f105211430$export$218c8c3169c024d2(issue) === issueId : group === $887390f105211430$var$getGroup(issue) && $887390f105211430$export$218c8c3169c024d2(issue) === issueId);
        const isSelectingForwards = thisSelectedIndex > lastSelectedIndex;
        const start = isSelectingForwards ? lastSelectedIndex : thisSelectedIndex;
        const end = isSelectingForwards ? thisSelectedIndex : lastSelectedIndex;
        const inBetween = issues.slice(start, end + 1);
        if (!isSelectingForwards) inBetween.reverse();
        return inBetween;
    }
});
parcelRegister("9H7nN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d77e9ed1bbf21e50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6mYSR;
    var $aI0i7;
    const $d77e9ed1bbf21e50$var$DraggableIssue = ({ children: children })=>{
        const ref = (0, $5uXOq.useRef)(null);
        const [{ row: row }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const { isDragging: isDragging } = (0, (0, parcelRequire("6mYSR")).useDragTarget)(ref, row);
        (0, (0, parcelRequire("6mYSR")).useDropTarget)(ref, row);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children(ref, isDragging));
    };
    var $d77e9ed1bbf21e50$export$2e2bcd8739ae039 = $d77e9ed1bbf21e50$var$DraggableIssue;
});
parcelRegister("jxhnO", function(module, exports) {
    $parcel$export(module.exports, "TimelineAligned", ()=>$87648cf084718f83$export$45008eb87cd660c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $8CUq3;
    var $jQzGV;
    const $87648cf084718f83$export$45008eb87cd660c1 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jQzGV")).default), {
            ...props,
            xcss: $87648cf084718f83$var$containerStyles
        });
    const $87648cf084718f83$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%'
    });
});
parcelRegister("jQzGV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31d14f6f15cd9d72$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $hE4fC;
    const $31d14f6f15cd9d72$var$HorizontalScrollingContainer = ({ xcss: xcss, offset: offset, children: children })=>{
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const [{ width: width }] = (0, (0, parcelRequire("hE4fC")).useContainer)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                xcss,
                $31d14f6f15cd9d72$var$containerStyles
            ],
            style: zoomLevel ? {
                marginLeft: offset,
                width: width
            } : undefined
        }, children);
    };
    const $31d14f6f15cd9d72$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative'
    });
    var $31d14f6f15cd9d72$export$2e2bcd8739ae039 = $31d14f6f15cd9d72$var$HorizontalScrollingContainer;
});
parcelRegister("fVLsa", function(module, exports) {
    $parcel$export(module.exports, "TimelineAxis", ()=>$afc06a92f74f225d$export$623d9e4255d0e2be);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE4fC;
    var $8ZtEx = parcelRequire("8ZtEx");
    var $2oGCG = parcelRequire("2oGCG");
    const $afc06a92f74f225d$export$623d9e4255d0e2be = ()=>{
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        return zoomLevel === undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8ZtEx.default), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2oGCG.default), null);
    };
});
parcelRegister("8ZtEx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128d1a5b070b7ea2$export$2e2bcd8739ae039);
    var $bC2fB;
    var $03hpB = parcelRequire("03hpB");
    var $ghBcZ = parcelRequire("ghBcZ");
    var $128d1a5b070b7ea2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $03hpB.default), {})((0, $ghBcZ.default));
});
parcelRegister("03hpB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3626acb272a913e$export$2e2bcd8739ae039);
    var $jpgxP = parcelRequire("jpgxP");
    var $jAIJh = parcelRequire("jAIJh");
    var $3YtPS = parcelRequire("3YtPS");
    var $d3626acb272a913e$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        timelineRange: (0, $jAIJh.getTimelineRange),
        fiscalMonth: (0, $jpgxP.getFiscalMonth)
    });
});
parcelRegister("ghBcZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26fb33f8d65569c6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $flnZx;
    var $jAIJh = parcelRequire("jAIJh");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $3gNHY = parcelRequire("3gNHY");
    class $26fb33f8d65569c6$var$TimelineAxis extends (0, $5uXOq.Component) {
        render() {
            const { timelineRange: { start: timelineRangeStart, end: timelineRangeEnd }, fiscalMonth: fiscalMonth } = this.props;
            const daysInRange = (timelineRangeEnd - timelineRangeStart) / (0, (0, parcelRequire("flnZx")).ONE_DAY);
            const dayUnits = (0, $jAIJh.getDayUnits)(timelineRangeStart, daysInRange);
            let timeline = [];
            if (dayUnits.length <= (0, $TTKUQ.CUSTOM_DATE_RANGES).SMALL) timeline = this.getWeeksTimeline(dayUnits);
            else if (dayUnits.length <= (0, $TTKUQ.CUSTOM_DATE_RANGES).MEDIUM) timeline = this.getMonthsTimeline(dayUnits);
            else if (dayUnits.length <= (0, $TTKUQ.CUSTOM_DATE_RANGES).LARGE) {
                const quarterUnits = (0, $jAIJh.getQuarterUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
                timeline = this.getQuartersTimeline(quarterUnits);
            } else {
                const yearUnits = (0, $jAIJh.getYearUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
                timeline = this.getYearsTimeline(yearUnits);
            }
            if (timeline.length) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $3gNHY.main
            }, timeline);
            return null;
        }
        constructor(...args){
            super(...args);
            this.getWeeksTimeline = (dayUnits)=>dayUnits.map(({ widthPercentage: widthPercentage }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                        key: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                        className: $3gNHY.withRightBorder,
                        style: {
                            boxSizing: 'border-box',
                            width: `${widthPercentage}%`
                        }
                    }));
            this.getMonthsTimeline = (dayUnits)=>dayUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
                    const nextDate = new Date(startTime + (0, (0, parcelRequire("flnZx")).ONE_DAY));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                        key: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                        className: nextDate.getUTCDate() === 1 ? $3gNHY.withRightBorder : '',
                        style: {
                            boxSizing: 'border-box',
                            width: `${widthPercentage}%`
                        }
                    });
                });
            this.getQuartersTimeline = (quarterUnits)=>quarterUnits.map(({ widthPercentage: widthPercentage }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                        key: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                        className: $3gNHY.withRightBorder,
                        style: {
                            width: `${widthPercentage}%`
                        }
                    }));
            this.getYearsTimeline = (yearUnits)=>yearUnits.map(({ widthPercentage: widthPercentage }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                        key: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                        className: $3gNHY.withRightBorder,
                        style: {
                            width: `${widthPercentage}%`
                        }
                    }));
        }
    }
    var $26fb33f8d65569c6$export$2e2bcd8739ae039 = $26fb33f8d65569c6$var$TimelineAxis;
});
parcelRegister("3gNHY", function(module, exports) {
    $parcel$export(module.exports, "main", ()=>$26196cbe1d7254b2$export$f22da7240b7add18, (v)=>$26196cbe1d7254b2$export$f22da7240b7add18 = v);
    $parcel$export(module.exports, "withRightBorder", ()=>$26196cbe1d7254b2$export$2396557442884da8, (v)=>$26196cbe1d7254b2$export$2396557442884da8 = v);
    var $26196cbe1d7254b2$export$f22da7240b7add18;
    var $26196cbe1d7254b2$export$2396557442884da8;
    $26196cbe1d7254b2$export$f22da7240b7add18 = `cVvj2G_main`;
    $26196cbe1d7254b2$export$2396557442884da8 = `cVvj2G_withRightBorder`;
});
parcelRegister("2oGCG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73d87132b2b0747a$export$2e2bcd8739ae039);
    var $bC2fB;
    var $f6hsy = parcelRequire("f6hsy");
    var $deqzS = parcelRequire("deqzS");
    var $73d87132b2b0747a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $f6hsy.default), {})((0, $deqzS.default));
});
parcelRegister("f6hsy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$789d6f0a3c8246b9$export$2e2bcd8739ae039);
    var $jpgxP = parcelRequire("jpgxP");
    const $789d6f0a3c8246b9$var$mapStateToProps = (state)=>({
            fiscalMonth: (0, $jpgxP.getFiscalMonth)(state)
        });
    var $789d6f0a3c8246b9$export$2e2bcd8739ae039 = $789d6f0a3c8246b9$var$mapStateToProps;
});
parcelRegister("deqzS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$038940b24625e165$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE4fC;
    var $Mo0VV = parcelRequire("Mo0VV");
    var $hoGLp = parcelRequire("hoGLp");
    var $kK0FL = parcelRequire("kK0FL");
    var $lKm5E = parcelRequire("lKm5E");
    function $038940b24625e165$export$2e2bcd8739ae039({ fiscalMonth: fiscalMonth }) {
        const [{ getPercentageOffset: getPercentageOffset }] = (0, (0, parcelRequire("hE4fC")).useHorizontalPercentageOffset)();
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const [{ today: today, from: from, to: to }] = (0, (0, parcelRequire("hE4fC")).useRenderingWindow)();
        if (!zoomLevel) return null;
        let units = [];
        const timeUnits = (0, $lKm5E.getUnits)({
            from: from,
            to: to
        }, zoomLevel, fiscalMonth);
        const todayColumnIndex = (0, $Mo0VV.getTodayColumnIndex)(timeUnits);
        units = timeUnits.map((unit, index)=>{
            const date = new Date(today + unit.from);
            const offset = getPercentageOffset(unit.from);
            const width = getPercentageOffset(unit.to) - offset;
            const isTodayColumn = index === todayColumnIndex;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kK0FL.default), {
                key: date.getTime(),
                left: `${offset}%`,
                width: `${width}%`,
                isHighlighted: isTodayColumn
            });
        });
        if (units.length) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $hoGLp.infiniteAxisTimeline
        }, units);
        return null;
    }
});
parcelRegister("Mo0VV", function(module, exports) {
    $parcel$export(module.exports, "getTodayColumnIndex", ()=>$50262d51b5c5b477$export$ce237023318dfe05);
    const $50262d51b5c5b477$export$ce237023318dfe05 = (ranges)=>ranges.findIndex(({ from: from, to: to })=>from <= 0 && to > 0);
});
parcelRegister("hoGLp", function(module, exports) {
    $parcel$export(module.exports, "infiniteAxisTimeline", ()=>$caa5d9894329d11c$export$ccad1b38568d5a6b, (v)=>$caa5d9894329d11c$export$ccad1b38568d5a6b = v);
    var $caa5d9894329d11c$export$ccad1b38568d5a6b;
    $caa5d9894329d11c$export$ccad1b38568d5a6b = `W3EHoW_infiniteAxisTimeline`;
});
parcelRegister("kK0FL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c78665cb3cbf9b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $jrKew = parcelRequire("jrKew");
    const $4c78665cb3cbf9b0$var$InfiniteAxisUnit = ({ left: left, width: width, isHighlighted: isHighlighted })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, ($parcel$interopDefault($9ci4W)))($jrKew.unit, {
                [$jrKew.highlighted]: isHighlighted
            }),
            style: {
                left: left,
                width: width
            }
        });
    var $4c78665cb3cbf9b0$export$2e2bcd8739ae039 = $4c78665cb3cbf9b0$var$InfiniteAxisUnit;
});
parcelRegister("jrKew", function(module, exports) {
    $parcel$export(module.exports, "highlighted", ()=>$e28466e44283b2c5$export$ba6acb6e4dfd83c2, (v)=>$e28466e44283b2c5$export$ba6acb6e4dfd83c2 = v);
    $parcel$export(module.exports, "unit", ()=>$e28466e44283b2c5$export$523c0b569236b342, (v)=>$e28466e44283b2c5$export$523c0b569236b342 = v);
    var $e28466e44283b2c5$export$ba6acb6e4dfd83c2;
    var $e28466e44283b2c5$export$523c0b569236b342;
    $e28466e44283b2c5$export$ba6acb6e4dfd83c2 = `Z6eima_highlighted`;
    $e28466e44283b2c5$export$523c0b569236b342 = `Z6eima_unit`;
});
parcelRegister("lKm5E", function(module, exports) {
    $parcel$export(module.exports, "getDayUnits", ()=>$c2500f7cea6c7bab$export$bc6ab2cf11089d43);
    $parcel$export(module.exports, "getUnits", ()=>$c2500f7cea6c7bab$export$94a11c5658544737);
    var $flnZx;
    const $c2500f7cea6c7bab$var$makeUnits = ({ from: from, to: to }, type, initialize, next)=>{
        const today = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(Date.now());
        const fromTs = today + from;
        const toTs = today + to;
        let dateCursor = new Date(fromTs);
        dateCursor.setUTCHours(0, 0, 0, 0);
        dateCursor = initialize(dateCursor);
        const units = [];
        while(dateCursor.getTime() < toTs){
            const from = dateCursor.getTime() - today;
            dateCursor = next(dateCursor);
            const to = dateCursor.getTime() - today;
            units.push({
                from: from,
                to: to,
                type: type
            });
        }
        return units;
    };
    const $c2500f7cea6c7bab$export$bc6ab2cf11089d43 = ({ from: from, to: to })=>{
        const initialize = (date)=>new Date(date.getTime() - (date.getUTCDay() - 1) * (0, (0, parcelRequire("flnZx")).ONE_DAY));
        const next = (date)=>new Date(date.getTime() + (0, (0, parcelRequire("flnZx")).ONE_DAY));
        return $c2500f7cea6c7bab$var$makeUnits({
            from: from,
            to: to
        }, 'week', initialize, next);
    };
    const $c2500f7cea6c7bab$var$getWeekUnits = ({ from: from, to: to })=>{
        const initialize = (date)=>new Date(date.getTime() - (date.getUTCDay() - 1) * (0, (0, parcelRequire("flnZx")).ONE_DAY));
        const next = (date)=>new Date(date.getTime() + (0, (0, parcelRequire("flnZx")).ONE_WEEK));
        return $c2500f7cea6c7bab$var$makeUnits({
            from: from,
            to: to
        }, 'week', initialize, next);
    };
    const $c2500f7cea6c7bab$var$getMonthUnits = ({ from: from, to: to })=>{
        const initialize = (date)=>{
            date.setUTCDate(1);
            return date;
        };
        const next = (date)=>{
            date.setUTCMonth(date.getUTCMonth() + 1, 1);
            return date;
        };
        return $c2500f7cea6c7bab$var$makeUnits({
            from: from,
            to: to
        }, 'month', initialize, next);
    };
    const $c2500f7cea6c7bab$var$getQuarterUnits = ({ from: from, to: to }, fiscalMonth)=>{
        const offset = fiscalMonth - 1;
        const initialize = (date)=>{
            const dateMonth = date.getUTCMonth();
            date.setUTCMonth(dateMonth - dateMonth % 3 + offset, 1);
            if (fiscalMonth > 1) {
                const dateYear = date.getUTCFullYear();
                date.setUTCFullYear(dateYear - 1);
            }
            return date;
        };
        const next = (date)=>{
            date.setUTCMonth(date.getUTCMonth() + 3, 1);
            return date;
        };
        return $c2500f7cea6c7bab$var$makeUnits({
            from: from,
            to: to
        }, 'quarter', initialize, next);
    };
    const $c2500f7cea6c7bab$var$getYearUnits = ({ from: from, to: to }, fiscalMonth)=>{
        const initialize = (date)=>{
            date.setUTCMonth(fiscalMonth - 1, 1);
            if (fiscalMonth > 1) {
                const dateYear = date.getUTCFullYear();
                date.setUTCFullYear(dateYear - 1);
            }
            return date;
        };
        const next = (date)=>{
            date.setUTCFullYear(date.getUTCFullYear() + 1);
            return date;
        };
        return $c2500f7cea6c7bab$var$makeUnits({
            from: from,
            to: to
        }, 'year', initialize, next);
    };
    const $c2500f7cea6c7bab$export$94a11c5658544737 = ({ from: from, to: to }, zoomLevel, fiscalMonth = 1)=>{
        switch(zoomLevel){
            case 'weeks':
                return $c2500f7cea6c7bab$var$getWeekUnits({
                    from: from,
                    to: to
                });
            case 'months':
                return $c2500f7cea6c7bab$var$getMonthUnits({
                    from: from,
                    to: to
                });
            case 'quarters':
                return $c2500f7cea6c7bab$var$getQuarterUnits({
                    from: from,
                    to: to
                }, fiscalMonth);
            case 'years':
                return $c2500f7cea6c7bab$var$getYearUnits({
                    from: from,
                    to: to
                }, fiscalMonth);
            default:
                return zoomLevel;
        }
    };
});
parcelRegister("2nwtP", function(module, exports) {
    $parcel$export(module.exports, "TimelineIssueRow", ()=>$3f1403da1439f44c$export$f7f4432f7a5b69e3);
    var $bC2fB;
    var $hqkd8 = parcelRequire("hqkd8");
    var $6UhFA = parcelRequire("6UhFA");
    var $3YreC = parcelRequire("3YreC");
    const $3f1403da1439f44c$export$f7f4432f7a5b69e3 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6UhFA.default), (0, $hqkd8.mapDispatchToProps))((0, $3YreC.TimelineIssueRow));
});
parcelRegister("hqkd8", function(module, exports) {
    $parcel$export(module.exports, "mapDispatchToProps", ()=>$012395948ff3e82c$export$9e6a17cf56877796);
    var $62dg4 = parcelRequire("62dg4");
    const $012395948ff3e82c$export$9e6a17cf56877796 = {
        enableOnlyIssueId: $62dg4.enableOnlyIssueId
    };
});
parcelRegister("62dg4", function(module, exports) {
    $parcel$export(module.exports, "ENABLE_ONLY_ISSUE_ID", ()=>$fdd8ca5ee21a55bd$export$f0e4fb5c8932c441);
    $parcel$export(module.exports, "enableOnlyIssueId", ()=>$fdd8ca5ee21a55bd$export$e4830edec3ecb2da);
    const $fdd8ca5ee21a55bd$export$f0e4fb5c8932c441 = 'state.ui.main.tabs.roadmap.timeline.schedule.ENABLE_ONLY_ISSUE_ID';
    const $fdd8ca5ee21a55bd$export$e4830edec3ecb2da = (payload)=>({
            type: $fdd8ca5ee21a55bd$export$f0e4fb5c8932c441,
            payload: payload
        });
});
parcelRegister("6UhFA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4683655845cabad1$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $jAIJh = parcelRequire("jAIJh");
    var $eIyFU = parcelRequire("eIyFU");
    var $3YtPS = parcelRequire("3YtPS");
    var $4683655845cabad1$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        isReadOnly: $1CGdp.isReadOnly,
        warnings: (0, $eIyFU.getWarnings),
        showOptimizations: (0, $1CGdp.isOptimizedMode),
        onlyEnabledIssueId: (0, $jAIJh.getOnlyEnabledIssueId)
    });
});
parcelRegister("3YreC", function(module, exports) {
    $parcel$export(module.exports, "TimelineIssueRow", ()=>$b34740007c90af5d$export$f7f4432f7a5b69e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $8vyMo;
    var $cGv9m;
    var $hE4fC;
    var $a7eN5 = parcelRequire("a7eN5");
    var $aI0i7;
    var $8LV9S;
    const $b34740007c90af5d$export$f7f4432f7a5b69e3 = ({ issue: issue, warnings: warnings, onlyEnabledIssueId: onlyEnabledIssueId, enableOnlyIssueId: enableOnlyIssueId })=>{
        const [{ row: row, column: column }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const dragSourceData = (0, (0, parcelRequire("8vyMo")).useDependencyCreateDragSourceData)();
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const [columnWidth = 0] = (0, (0, parcelRequire("8LV9S")).useColumnWidth)({
            column: column,
            preview: true
        });
        const width = zoomLevel ? (0, (0, parcelRequire("cGv9m")).getContainerWidth)(zoomLevel) : columnWidth;
        const issueWarnings = warnings.byIssue[issue.id];
        const isReadOnly = onlyEnabledIssueId != null && issue.id !== onlyEnabledIssueId;
        const barStartDragging = (0, $5uXOq.useCallback)(()=>{
            enableOnlyIssueId(issue.id);
        }, [
            enableOnlyIssueId,
            issue.id
        ]);
        const barStopDragging = (0, $5uXOq.useCallback)(()=>{
            enableOnlyIssueId();
        }, [
            enableOnlyIssueId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a7eN5.default), {
            backgroundColor: 'transparent',
            hasDependencyLineDragPreview: dragSourceData?.row === row,
            disableOtherRows: barStartDragging,
            isReadOnly: isReadOnly,
            issue: issue,
            issueWarnings: issueWarnings,
            key: issue.id,
            reEnableOtherRows: barStopDragging,
            topOffset: 0,
            width: width
        });
    };
});
parcelRegister("8vyMo", function(module, exports) {
    $parcel$export(module.exports, "dropTargetForDependencyCreate", ()=>$a6154f24f77b795b$export$b493dfb9f5b687ab);
    $parcel$export(module.exports, "draggableForDependencyCreate", ()=>$a6154f24f77b795b$export$af6b708c718872b7);
    $parcel$export(module.exports, "monitorForDependencyCreate", ()=>$a6154f24f77b795b$export$35c0c4389177f68f);
    $parcel$export(module.exports, "useDependencyCreateDragSourceData", ()=>$a6154f24f77b795b$export$6cac64d8cbde5780);
    var $5uXOq = parcelRequire("5uXOq");
    var $7gWdR = parcelRequire("7gWdR");
    const $a6154f24f77b795b$var$instance = Symbol('dependency-line-drag-create');
    const $a6154f24f77b795b$export$b493dfb9f5b687ab = (opts)=>(0, $7gWdR.dropTargetForElements)({
            ...opts,
            canDrop: (...args)=>args[0].source.data.instance === $a6154f24f77b795b$var$instance && (opts.canDrop ? opts.canDrop(...args) : true),
            getData: (...args)=>({
                    ...opts.getData?.(...args),
                    instance: $a6154f24f77b795b$var$instance
                })
        });
    const $a6154f24f77b795b$export$af6b708c718872b7 = (opts)=>(0, $7gWdR.draggable)({
            ...opts,
            getInitialData: (...args)=>({
                    ...opts.getInitialData?.(...args),
                    instance: $a6154f24f77b795b$var$instance
                })
        });
    const $a6154f24f77b795b$export$35c0c4389177f68f = (opts)=>(0, $7gWdR.monitorForElements)({
            ...opts,
            canMonitor: (...args)=>args[0].source.data.instance === $a6154f24f77b795b$var$instance && (opts.canMonitor ? opts.canMonitor(...args) : true)
        });
    const $a6154f24f77b795b$export$6cac64d8cbde5780 = ()=>{
        const [source, setSource] = (0, $5uXOq.useState)();
        const ref = (0, $5uXOq.useRef)(source);
        ref.current = source;
        (0, $5uXOq.useEffect)(()=>{
            $a6154f24f77b795b$export$35c0c4389177f68f({
                onDrag: ({ source: source })=>{
                    if (source !== ref.current) setSource(source);
                },
                onDrop: ()=>setSource(undefined)
            });
        }, []);
        return source?.data;
    };
});
parcelRegister("a7eN5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ed4a17e182de732$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4gr7M = parcelRequire("4gr7M");
    var $15lHw = parcelRequire("15lHw");
    var $e79al = parcelRequire("e79al");
    var $g08t1 = parcelRequire("g08t1");
    var $1ed4a17e182de732$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $4gr7M.default), {})((0, $15lHw.default));
});
parcelRegister("4gr7M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5fbd9acb9ecec576$export$2e2bcd8739ae039);
    var $ajpes = parcelRequire("ajpes");
    var $8QpSo;
    var $iHPnC;
    var $c12LJ;
    var $1CGdp = parcelRequire("1CGdp");
    var $ddv1K = parcelRequire("ddv1K");
    var $7ppNi = parcelRequire("7ppNi");
    var $iGHBn = parcelRequire("iGHBn");
    var $gFhwb = parcelRequire("gFhwb");
    var $4sJY8 = parcelRequire("4sJY8");
    var $lJNM1 = parcelRequire("lJNM1");
    var $jAIJh = parcelRequire("jAIJh");
    var $kWDpn = parcelRequire("kWDpn");
    var $j0XCX = parcelRequire("j0XCX");
    var $4nDwW = parcelRequire("4nDwW");
    var $gITL8 = parcelRequire("gITL8");
    const $5fbd9acb9ecec576$export$d5c85a9b712b84e5 = (colours)=>{
        const ratio = 1 / colours.size;
        return [
            ...colours
        ].map((colour)=>({
                colour: colour,
                ratio: ratio
            }));
    };
    const $5fbd9acb9ecec576$var$externalIncomingLinksList = [];
    const $5fbd9acb9ecec576$var$externalOutgoingLinksList = [];
    const $5fbd9acb9ecec576$var$internalIncomingLinksList = [];
    const $5fbd9acb9ecec576$var$internalIncomingLinksOriginalList = [];
    const $5fbd9acb9ecec576$var$internalOutgoingLinksList = [];
    const $5fbd9acb9ecec576$var$internalOutgoingLinksOriginalList = [];
    const $5fbd9acb9ecec576$var$issueChildrenList = [];
    const $5fbd9acb9ecec576$var$mapStateToPropsFactory = ()=>{
        const getColoursWithRatioFactory = (0, (0, parcelRequire("8QpSo")).default)($5fbd9acb9ecec576$export$d5c85a9b712b84e5, (0, ($parcel$interopDefault($ajpes))));
        return (state, props)=>{
            const timelineRange = (0, $jAIJh.getTimelineRange)(state);
            const timelinePreview = (0, $lJNM1.getTimelineState)(state);
            const mode = (0, $1CGdp.getMode)(state);
            const colourByValue = (0, $j0XCX.getColorByValue)(state);
            const issueStatuses = (0, $7ppNi.getIssueStatusById)(state);
            const colourMap = (0, $j0XCX.getColourMaps)(state);
            const issueId = props.issue.id;
            const externalIncomingLinks = (0, $ddv1K.getExternalIncomingLinks)(state)[issueId] || $5fbd9acb9ecec576$var$externalIncomingLinksList;
            const externalOutgoingLinks = (0, $ddv1K.getExternalOutgoingLinks)(state)[issueId] || $5fbd9acb9ecec576$var$externalOutgoingLinksList;
            const internalIncomingLinks = (0, $ddv1K.getInternalIncomingLinks)(state)[issueId] || $5fbd9acb9ecec576$var$internalIncomingLinksList;
            const internalIncomingLinksOriginal = (0, $ddv1K.getInternalIncomingLinkOriginals)(state)[issueId] || $5fbd9acb9ecec576$var$internalIncomingLinksOriginalList;
            const internalOutgoingLinks = (0, $ddv1K.getInternalOutgoingLinks)(state)[issueId] || $5fbd9acb9ecec576$var$internalOutgoingLinksList;
            const internalOutgoingLinksOriginal = (0, $ddv1K.getInternalOutgoingLinkOriginals)(state)[issueId] || $5fbd9acb9ecec576$var$internalOutgoingLinksOriginalList;
            const defaultIterationLength = (0, $iGHBn.getDefaultIterationLength)(state);
            const showWarning = (0, $kWDpn.getWarningViewSettings)(state).showWarning;
            let preview;
            let isBeingInteractedWith;
            let epicColor;
            if (timelinePreview) {
                preview = timelinePreview.previews[issueId];
                isBeingInteractedWith = timelinePreview.activeIssueId === issueId;
            }
            let barColors;
            if (colourByValue === (0, $gITL8.colourByOptions).ISSUE_TYPE) {
                const { issue: { type: issueType } } = props;
                const colourByIssueTypeColourMap = (0, $j0XCX.getColourByIssueTypeColourMap)(state);
                const colour = colourByIssueTypeColourMap[issueType.toString()];
                if ((0, $4nDwW.isDefined)(colour)) barColors = getColoursWithRatioFactory(new Set([
                    colour
                ]));
            } else if (colourByValue === (0, $gITL8.colourByOptions).LABEL) {
                const { issue: { labels: labels } } = props;
                const colourByLabelColourMap = (0, $j0XCX.getColourByLabelColourMap)(state);
                const colours = new Set((labels || []).map((label)=>colourByLabelColourMap[label]).filter((x)=>!!x));
                if (colours.size > 0) barColors = getColoursWithRatioFactory(colours);
            } else if (colourByValue === (0, $gITL8.colourByOptions).COMPONENT) {
                const components = props.issue?.components ?? [];
                const colourByComponentColourMap = (0, $j0XCX.getColourByComponentColourMap)(state);
                const colours = new Set((components || []).map((component)=>colourByComponentColourMap[component.toString()]).filter((x)=>!!x));
                if (colours.size > 0) barColors = getColoursWithRatioFactory(colours);
            } else if (colourByValue === (0, $gITL8.colourByOptions).PRIORITY) {
                const { issue: { priority: priority } } = props;
                if ((0, $4nDwW.isDefined)(priority)) {
                    const colourByPriorityColourMap = (0, $j0XCX.getColourByPriorityColourMap)(state);
                    const colour = colourByPriorityColourMap[priority];
                    if ((0, $4nDwW.isDefined)(colour)) barColors = getColoursWithRatioFactory(new Set([
                        colour
                    ]));
                }
            } else if (colourByValue === (0, $gITL8.colourByOptions).EPIC) {
                const issueMapById = (0, $gFhwb.getIssueMapById)(state);
                const issue = issueMapById[issueId];
                if (issue?.level === (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL)) epicColor = (0, (0, parcelRequire("iHPnC")).asColor)(issue.color);
                else if (issue?.level < (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL)) {
                    let issueParentId = issue?.parent;
                    while(!epicColor && issueParentId && issueMapById[issueParentId]){
                        const parent = issueMapById[issueParentId];
                        const parentLevel = parent.level;
                        if (parentLevel > (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL)) break;
                        if (parentLevel === (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL)) {
                            epicColor = (0, (0, parcelRequire("iHPnC")).asColor)(parent?.color);
                            break;
                        }
                        issueParentId = parent?.parent;
                    }
                }
                if ((0, $4nDwW.isDefined)(epicColor) && (0, $gITL8.epicColorToARJColor)[epicColor]) barColors = getColoursWithRatioFactory(new Set([
                    (0, $gITL8.epicColorToARJColor)[epicColor]
                ]));
            } else if ((0, $j0XCX.isColorByCustomFieldOption)(colourByValue)) {
                const { issue: { customFields: customFields = {} } } = props;
                const colourBySelectColourMap = (0, $j0XCX.getColourBySelectColourMap)(state);
                const value = customFields[colourByValue];
                const values = Array.isArray(value) ? value : [
                    value
                ];
                const colours = new Set((values || []).map((value)=>colourBySelectColourMap[value]).filter((x)=>!!x));
                if (colours.size > 0) barColors = getColoursWithRatioFactory(colours);
            }
            const issueChildren = (0, $4sJY8.getChildrenByParent)(state)[props.issue.id] ?? $5fbd9acb9ecec576$var$issueChildrenList;
            return {
                barColors: barColors,
                issueChildren: issueChildren,
                colourByValue: colourByValue,
                colourMap: colourMap,
                defaultIterationLength: defaultIterationLength,
                epicColor: epicColor,
                externalIncomingLinks: externalIncomingLinks,
                externalOutgoingLinks: externalOutgoingLinks,
                internalIncomingLinks: internalIncomingLinks,
                internalIncomingLinksOriginal: internalIncomingLinksOriginal,
                internalOutgoingLinks: internalOutgoingLinks,
                internalOutgoingLinksOriginal: internalOutgoingLinksOriginal,
                isBeingInteractedWith: isBeingInteractedWith,
                isReadOnly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef) || props.isReadOnly,
                issueStatuses: issueStatuses,
                preview: preview,
                showOptimizations: mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771),
                timelineRange: timelineRange,
                showWarning: showWarning
            };
        };
    };
    const $5fbd9acb9ecec576$var$mapStateToProps = $5fbd9acb9ecec576$var$mapStateToPropsFactory;
    var $5fbd9acb9ecec576$export$2e2bcd8739ae039 = $5fbd9acb9ecec576$var$mapStateToProps;
});
parcelRegister("lJNM1", function(module, exports) {
    $parcel$export(module.exports, "getTimelineState", ()=>$0c2942ae5430696d$export$2b24ae6422c2e50e);
    $parcel$export(module.exports, "getAncestors", ()=>$0c2942ae5430696d$export$c6fd3ab3f44300d0);
    $parcel$export(module.exports, "getDescendents", ()=>$0c2942ae5430696d$export$ec0cf3dcee1d735c);
    var $c12LJ;
    var $3YtPS = parcelRequire("3YtPS");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $4sJY8 = parcelRequire("4sJY8");
    var $gFhwb = parcelRequire("gFhwb");
    const $0c2942ae5430696d$export$2b24ae6422c2e50e = (state)=>state.ui.Main.Tabs.Roadmap.TimelinePreview;
    const $0c2942ae5430696d$export$88c9ddb45cea7241 = (string)=>(_, props)=>props[string];
    const $0c2942ae5430696d$export$2e28083b1261790a = (issueMap, issueId)=>[
            issueMap[issueId]
        ].concat($bI9dZ.getAncestors(issueMap[issueId], issueMap, Infinity));
    const $0c2942ae5430696d$export$3506fa4ebbe17d84 = (issueMap, descendantsMap, issueId, isStrict)=>{
        const descendants = $4sJY8.getDescendants(issueMap[issueId], issueMap, descendantsMap, (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL));
        return isStrict ? descendants : [
            issueMap[issueId]
        ].concat(descendants);
    };
    const $0c2942ae5430696d$export$c6fd3ab3f44300d0 = (0, $3YtPS.createSelector)([
        $gFhwb.getIssueMapById,
        $0c2942ae5430696d$export$88c9ddb45cea7241('issueId')
    ], $0c2942ae5430696d$export$2e28083b1261790a);
    const $0c2942ae5430696d$export$ec0cf3dcee1d735c = (0, $3YtPS.createSelector)([
        $gFhwb.getIssueMapById,
        $4sJY8.getChildrenIdsByParent,
        $0c2942ae5430696d$export$88c9ddb45cea7241('issueId'),
        $0c2942ae5430696d$export$88c9ddb45cea7241('isStrict')
    ], $0c2942ae5430696d$export$3506fa4ebbe17d84);
});
parcelRegister("15lHw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc37bf5a6bdb2182$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $3pSjV;
    var $3nPAF;
    var $4R6GH;
    var $gJZ5D;
    var $l38L3 = parcelRequire("l38L3");
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $iYh8K = parcelRequire("iYh8K");
    var $gITL8 = parcelRequire("gITL8");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $3NZPp = parcelRequire("3NZPp");
    var $e79al = parcelRequire("e79al");
    var $32aSm = parcelRequire("32aSm");
    var $1JiMc = parcelRequire("1JiMc");
    var $9XOR0 = parcelRequire("9XOR0");
    var $bUOUf = parcelRequire("bUOUf");
    var $f8JvR = parcelRequire("f8JvR");
    const $cc37bf5a6bdb2182$export$5e7466f07ec9ce6a = (issue, issueStatuses, colourMap)=>{
        const issueCategoryId = (0, $4nDwW.isDefined)(issue) && (0, $4nDwW.isDefined)(issue.status) && (0, $4nDwW.isDefined)(issueStatuses) && !(0, parcelRequire("3nPAF")).default(issueStatuses) && (0, $4nDwW.isDefined)(issueStatuses[issue.status]) && issueStatuses[issue.status].categoryId;
        const issueStatusColour = (0, $4nDwW.isDefined)(colourMap) && !(0, parcelRequire("3nPAF")).default(colourMap) && (0, $4nDwW.isDefined)(colourMap.status) && !(0, parcelRequire("3nPAF")).default(colourMap.status) && issueCategoryId && colourMap.status[issueCategoryId.toString()];
        return issueStatusColour || (0, (0, parcelRequire("gJZ5D")).default).N500;
    };
    const $cc37bf5a6bdb2182$var$getColour = (issue, colourByValue, issueStatuses, colourMap, epicColor)=>{
        switch(colourByValue){
            case (0, $gITL8.colourByOptions).PROJECT:
                if (issue.project) return colourMap.project[issue.project.toString()];
                break;
            case (0, $gITL8.colourByOptions).STATUS:
                return $cc37bf5a6bdb2182$export$5e7466f07ec9ce6a(issue, issueStatuses, colourMap);
            case (0, $gITL8.colourByOptions).TEAM:
                if (issue.team) return colourMap.team[issue.team];
                break;
            case (0, $gITL8.colourByOptions).EPIC:
                if (epicColor) return epicColor;
                break;
            default:
                return 0, $gITL8.DEFAULT_COLOR;
        }
    };
    class $cc37bf5a6bdb2182$export$2e2bcd8739ae039 extends (0, $iYh8K.default) {
        static{
            this.defaultProps = {
                isReadOnly: false,
                showOptimizations: false,
                isBeingInteractedWith: false,
                issueWarnings: [],
                disableOtherRows: (0, ($parcel$interopDefault($8Rkzz))),
                reEnableOtherRows: (0, ($parcel$interopDefault($8Rkzz))),
                BothDatesRow: $3NZPp.default,
                PartialDatesRow: $9XOR0.default,
                NoDatesRow: $1JiMc.default
            };
        }
        render() {
            const { issue: issue, issueChildren: issueChildren, timelineRange: timelineRange, backgroundColor: backgroundColor, preview: preview, showOptimizations: showOptimizations, disableOtherRows: disableOtherRows, reEnableOtherRows: reEnableOtherRows, isBeingInteractedWith: isBeingInteractedWith, isReadOnly: isReadOnly, issueWarnings: issueWarnings, externalIncomingLinks: externalIncomingLinks, externalOutgoingLinks: externalOutgoingLinks, internalIncomingLinks: internalIncomingLinks, internalIncomingLinksOriginal: internalIncomingLinksOriginal, internalOutgoingLinks: internalOutgoingLinks, internalOutgoingLinksOriginal: internalOutgoingLinksOriginal, width: width, colourByValue: colourByValue, issueStatuses: issueStatuses, colourMap: colourMap, barColors: barColors, showWarning: showWarning, topOffset: topOffset, epicColor: epicColor, hasDependencyLineDragPreview: hasDependencyLineDragPreview } = this.props;
            const hasWarnings = issueWarnings.length > 0 && showWarning;
            let hasOptimizedChanges = false;
            if (showOptimizations && issue.optimized) {
                for (const [optimizedKey, optimizedValue] of Object.entries(issue.optimized))if ((0, $l38L3.hasValueChanged)((0, $l38L3.getCurrentValue)(issue, optimizedKey), optimizedValue)) {
                    hasOptimizedChanges = true;
                    break;
                }
            }
            let barColor = (0, $gITL8.DEFAULT_COLOR);
            let adjustedBarColors;
            const showStripesInBar = {
                left: false,
                right: false
            };
            if (!showOptimizations) {
                barColor = $cc37bf5a6bdb2182$var$getColour(issue, colourByValue, issueStatuses, colourMap, epicColor) ?? (0, $gITL8.DEFAULT_COLOR);
                adjustedBarColors = barColors;
            }
            if (hasWarnings && colourByValue === (0, $gITL8.colourByOptions).NONE) {
                barColor = (0, (0, parcelRequire("gJZ5D")).default).Y300;
                adjustedBarColors = null;
                if (showOptimizations && hasOptimizedChanges) {
                    showStripesInBar.left = true;
                    showStripesInBar.right = true;
                }
                if (issue.inferred) {
                    showStripesInBar.left = issue.inferred.baselineStart === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
                    showStripesInBar.right = issue.inferred.baselineEnd === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
                }
            } else if (hasOptimizedChanges) {
                barColor = (0, $gITL8.OPTIMIZED_COLOR);
                adjustedBarColors = null;
                showStripesInBar.left = true;
                showStripesInBar.right = true;
            } else if (issue.inferred) {
                showStripesInBar.left = issue.inferred.baselineStart === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
                showStripesInBar.right = issue.inferred.baselineEnd === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
            }
            const hasOptimizedDates = showOptimizations && ((0, $4nDwW.isDefined)(issue.optimized && issue.optimized.baselineStart) || (0, $4nDwW.isDefined)(issue.optimized && issue.optimized.baselineEnd));
            const { baselineStart: baselineStart, baselineEnd: baselineEnd } = hasOptimizedDates && issue.optimized ? issue.optimized : issue;
            const showActiveSprintOnTooltip = Boolean(issue.inferred && (issue.inferred.baselineStart === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).SPRINT || issue.inferred.baselineEnd === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).SPRINT));
            let renderFlyout;
            if (hasOptimizedChanges) renderFlyout = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $32aSm.default), {
                    issue: issue
                });
            const opacity = preview ? (0, $TTKUQ.PREVIEW_OPACITY) : 1;
            const innerViewProps = {
                issue: issue,
                issueChildren: issueChildren,
                baselineStart: baselineStart,
                baselineEnd: baselineEnd,
                timelineRange: timelineRange,
                barColor: barColor,
                barColors: adjustedBarColors,
                showStripesInBar: showStripesInBar,
                preview: preview,
                renderFlyout: renderFlyout,
                disableOtherRows: disableOtherRows,
                reEnableOtherRows: reEnableOtherRows,
                isBeingInteractedWith: isBeingInteractedWith,
                isReadOnly: isReadOnly,
                externalIncomingLinks: externalIncomingLinks,
                externalOutgoingLinks: externalOutgoingLinks,
                internalIncomingLinks: internalIncomingLinks,
                internalIncomingLinksOriginal: internalIncomingLinksOriginal,
                internalOutgoingLinks: internalOutgoingLinks,
                internalOutgoingLinksOriginal: internalOutgoingLinksOriginal,
                width: width,
                opacity: opacity,
                showActiveSprintOnTooltip: showActiveSprintOnTooltip,
                topOffset: topOffset,
                hasDependencyLineDragPreview: hasDependencyLineDragPreview
            };
            const innerView = this.areDatesInferredFromRollUp() ? this.getRollUpInnerView(innerViewProps) : this.getInnerView(innerViewProps);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $bUOUf.row,
                "data-issue": issue.id,
                "data-group": issue.group,
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.${issue.id}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $e79al.default), {
                bgColor: backgroundColor
            }, innerView));
        }
        constructor(...args){
            super(...args);
            this.areDatesInferredFromRollUp = ()=>{
                const { issue: { inferred: { baselineStart: baselineStart, baselineEnd: baselineEnd } = {} } } = this.props;
                return baselineStart === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP || baselineEnd === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
            };
            this.getInnerView = (innerViewProps)=>{
                const { BothDatesRow: BothDatesRow, PartialDatesRow: PartialDatesRow, NoDatesRow: NoDatesRow } = this.props;
                const { baselineStart: baselineStart, baselineEnd: baselineEnd, showActiveSprintOnTooltip: showActiveSprintOnTooltip } = innerViewProps;
                if ((0, $4nDwW.isDefined)(baselineStart) && (0, $4nDwW.isDefined)(baselineEnd) && (0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline')) {
                    const minBaselineStart = Math.min(baselineStart, baselineEnd);
                    const maxBaselineEnd = Math.max(baselineStart, baselineEnd);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(BothDatesRow, {
                        ...innerViewProps,
                        showActiveSprintOnTooltip: showActiveSprintOnTooltip,
                        baselineStart: minBaselineStart,
                        baselineEnd: maxBaselineEnd
                    });
                }
                if ((0, $4nDwW.isDefined)(baselineStart) && (0, $4nDwW.isDefined)(baselineEnd) && baselineStart <= baselineEnd && !(0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline')) return (0, ($parcel$interopDefault($5uXOq))).createElement(BothDatesRow, {
                    ...innerViewProps,
                    showActiveSprintOnTooltip: showActiveSprintOnTooltip
                });
                if ((0, $4nDwW.isDefined)(baselineStart) || (0, $4nDwW.isDefined)(baselineEnd)) return (0, ($parcel$interopDefault($5uXOq))).createElement(PartialDatesRow, innerViewProps);
                return (0, ($parcel$interopDefault($5uXOq))).createElement(NoDatesRow, innerViewProps);
            };
            this.getRollUpInnerView = (innerViewProps)=>{
                const { issue: issue, BothDatesRow: BothDatesRow } = this.props;
                const { baselineStart: baselineStart, baselineEnd: baselineEnd, issueChildren: issueChildren, showActiveSprintOnTooltip: showActiveSprintOnTooltip } = innerViewProps;
                const forcedGradients = (0, $f8JvR.getForcedGradients)({
                    baselineStart: baselineStart,
                    baselineEnd: baselineEnd
                }, issueChildren);
                const start = (0, parcelRequire("3pSjV")).default(forcedGradients.earliestStart, baselineStart);
                const end = (0, parcelRequire("3pSjV")).default(forcedGradients.latestEnd, baselineEnd);
                if (start <= end) return (0, ($parcel$interopDefault($5uXOq))).createElement(BothDatesRow, {
                    ...innerViewProps,
                    baselineStart: start,
                    baselineEnd: end,
                    forcedGradients: forcedGradients,
                    showActiveSprintOnTooltip: showActiveSprintOnTooltip,
                    datesInferredFrom: issue.inferred
                });
                return null;
            };
        }
    }
});
parcelRegister("3NZPp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f3ddbc3c248dead$export$2e2bcd8739ae039);
    var $bC2fB;
    var $alFTO = parcelRequire("alFTO");
    var $kRvyG = parcelRequire("kRvyG");
    var $6l5jf = parcelRequire("6l5jf");
    var $4f3ddbc3c248dead$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $kRvyG.default), (0, $alFTO.default))((0, $6l5jf.default));
});
parcelRegister("alFTO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30c4d3eb4a498dfa$export$2e2bcd8739ae039);
    var $4K5PQ = parcelRequire("4K5PQ");
    var $kfvhW = parcelRequire("kfvhW");
    const $30c4d3eb4a498dfa$var$mapDispatchToProps = (dispatch, ownProps)=>({
            commitTimelinePreview: ()=>{
                dispatch((0, $4K5PQ.commitTimelinePreview)());
            },
            moveTimelineIssue: (delta, targetStart, targetEnd)=>{
                dispatch((0, $kfvhW.suspend)());
                dispatch((0, $4K5PQ.hoverTimelineIssue)(ownProps.issue.id, targetStart, targetEnd));
                dispatch((0, $4K5PQ.moveTimelineIssue)(delta, targetStart, targetEnd));
                dispatch((0, $kfvhW.resume)());
            },
            resizeTimelineIssue: (baselineStart, baselineEnd)=>{
                dispatch((0, $kfvhW.suspend)());
                dispatch((0, $4K5PQ.hoverTimelineIssue)(ownProps.issue.id, baselineStart, baselineEnd));
                dispatch((0, $4K5PQ.resizeTimelineIssue)(baselineStart, baselineEnd));
                dispatch((0, $kfvhW.resume)());
            }
        });
    var $30c4d3eb4a498dfa$export$2e2bcd8739ae039 = $30c4d3eb4a498dfa$var$mapDispatchToProps;
});
parcelRegister("4K5PQ", function(module, exports) {
    $parcel$export(module.exports, "hoverTimelineIssue", ()=>$566ab5dbafb11caf$export$bd084625a2308db4);
    $parcel$export(module.exports, "moveTimelineIssue", ()=>$566ab5dbafb11caf$export$75d7727d186ac0aa);
    $parcel$export(module.exports, "resizeTimelineIssue", ()=>$566ab5dbafb11caf$export$e6337a28fb489262);
    $parcel$export(module.exports, "commitTimelinePreview", ()=>$566ab5dbafb11caf$export$4e0f49671c452c61);
    $parcel$export(module.exports, "cancelTimelinePreview", ()=>$566ab5dbafb11caf$export$c13f756c23f6a090);
    $parcel$export(module.exports, "default", ()=>$566ab5dbafb11caf$export$2e2bcd8739ae039);
    parcelRequire("dcevF");
    var $hIYGf = parcelRequire("hIYGf");
    var $jVZZA;
    var $3A0dU;
    var $4Rr1a;
    var $fZhYM;
    var $bvxTs;
    var $fes2p;
    var $2rMKg;
    var $5sZkx;
    var $h35CY;
    var $6nTyZ;
    var $bjzU8;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $gFhwb = parcelRequire("gFhwb");
    var $lJNM1 = parcelRequire("lJNM1");
    var $kWDpn = parcelRequire("kWDpn");
    var $k49aW = parcelRequire("k49aW");
    var $bYhSc = parcelRequire("bYhSc");
    var $24CMK = parcelRequire("24CMK");
    var $bkasS = parcelRequire("bkasS");
    const $566ab5dbafb11caf$export$bd084625a2308db4 = (issueId, defaultStart, defaultEnd)=>({
            type: (0, $048e9f12a4e86172$export$cac9106b1c7f24fc),
            payload: {
                issueId: issueId,
                defaultStart: defaultStart,
                defaultEnd: defaultEnd
            }
        });
    const $566ab5dbafb11caf$export$75d7727d186ac0aa = (delta, targetStart, targetEnd)=>({
            type: (0, $048e9f12a4e86172$export$eb5a7568e1c3d408),
            payload: {
                delta: delta,
                targetStart: targetStart,
                targetEnd: targetEnd
            }
        });
    const $566ab5dbafb11caf$export$e6337a28fb489262 = (baselineStart, baselineEnd)=>({
            type: (0, $048e9f12a4e86172$export$f5393940db5375),
            payload: {
                baselineStart: baselineStart,
                baselineEnd: baselineEnd
            }
        });
    const $566ab5dbafb11caf$export$4e0f49671c452c61 = ()=>({
            type: (0, $048e9f12a4e86172$export$328d95132417a337)
        });
    const $566ab5dbafb11caf$export$c13f756c23f6a090 = ()=>({
            type: (0, $048e9f12a4e86172$export$c926e344ad34027e)
        });
    const { ROLL_UP: $566ab5dbafb11caf$var$ROLL_UP, SPRINT: $566ab5dbafb11caf$var$SPRINT } = (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION);
    const $566ab5dbafb11caf$export$6d7b0751be84e7bc = (type)=>(0, parcelRequire("bvxTs")).default([
            'inferred',
            type
        ], $566ab5dbafb11caf$var$ROLL_UP);
    const $566ab5dbafb11caf$export$b1f4a493aaefef29 = (type)=>(0, parcelRequire("bvxTs")).default([
            'inferred',
            type
        ], $566ab5dbafb11caf$var$SPRINT);
    function* $566ab5dbafb11caf$export$3f9bf2fcabbab63e({ payload: { issueId: issueId, defaultStart: defaultStart, defaultEnd: defaultEnd } }) {
        try {
            const issueMapById = yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById));
            const activeIssue = issueMapById[issueId];
            if (!activeIssue) return;
            const timeline = yield (0, $aNOuE.select)((0, $lJNM1.getTimelineState));
            const baselineStart = timeline && (0, $4nDwW.isDefined)(activeIssue.baselineStart) ? (0, parcelRequire("fZhYM")).default([
                'previews',
                activeIssue.id,
                'baselineStart'
            ], timeline) : defaultStart;
            const baselineEnd = timeline && (0, $4nDwW.isDefined)(activeIssue.baselineEnd) ? (0, parcelRequire("fZhYM")).default([
                'previews',
                activeIssue.id,
                'baselineEnd'
            ], timeline) : defaultEnd;
            const strictDescendents = yield (0, $aNOuE.select)((0, $lJNM1.getDescendents), {
                issueId: issueId,
                isStrict: true
            });
            const definedDescendentsWithoutSprintInferred = (0, parcelRequire("jVZZA")).default((i)=>((0, $4nDwW.isDefined)(i.baselineStart) || (0, $4nDwW.isDefined)(i.baselineEnd)) && !$566ab5dbafb11caf$export$b1f4a493aaefef29('baselineStart')(i), strictDescendents);
            const indexedDescendentIssues = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), definedDescendentsWithoutSprintInferred);
            const strictDescendentsPreviews = (0, parcelRequire("4Rr1a")).default((issue)=>({
                    inferred: issue.inferred,
                    baselineStart: issue.baselineStart,
                    baselineEnd: issue.baselineEnd,
                    shouldSync: true
                }), indexedDescendentIssues);
            const showRolledUpDates = yield (0, $aNOuE.select)((0, $kWDpn.getShowRolledUpDates));
            if (!showRolledUpDates) {
                yield (0, $aNOuE.put)((0, $k49aW.setPreviewIssues)({
                    activeIssueId: issueId,
                    issueAndAncestors: {
                        [issueId]: {
                            baselineStart: baselineStart,
                            baselineEnd: baselineEnd,
                            shouldSync: true,
                            inferred: activeIssue.inferred
                        }
                    },
                    strictDescendents: strictDescendentsPreviews
                }));
                return;
            }
            const issueAncestors = (0, $bI9dZ.getAncestors)(activeIssue, issueMapById, Infinity);
            const activeAndAncestors = [
                activeIssue
            ].concat(issueAncestors);
            const issuesSortedByLevelFromLowerToHigher = (0, parcelRequire("h35CY")).default((0, parcelRequire("2rMKg")).default('level'), activeAndAncestors);
            const highestLevelParent = (0, parcelRequire("3A0dU")).default(issuesSortedByLevelFromLowerToHigher);
            const siblingsDescendants = yield (0, $aNOuE.select)((0, $lJNM1.getDescendents), {
                issueId: highestLevelParent && highestLevelParent.id,
                isStrict: true
            });
            const realDatesOnly = activeAndAncestors.concat(siblingsDescendants).map((issue)=>{
                const result = {
                    ...issue
                };
                const isStartInferred = (0, parcelRequire("fZhYM")).default([
                    'inferred',
                    'baselineStart'
                ], issue) === -1;
                const isEndInferred = (0, parcelRequire("fZhYM")).default([
                    'inferred',
                    'baselineEnd'
                ], issue) === -1;
                if (isStartInferred) result.baselineStart = undefined;
                if (isEndInferred) result.baselineEnd = undefined;
                if (issue.id !== issueId) return result;
                return {
                    ...result,
                    baselineStart: baselineStart,
                    baselineEnd: baselineEnd
                };
            });
            const rolledUpIssues = (0, $gFhwb.getIssuesWithRolledUpDates)(realDatesOnly).filter((issue)=>(0, $4nDwW.isDefined)(issue.baselineStart) || (0, $4nDwW.isDefined)(issue.baselineEnd));
            const rolledUpIssuesMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), rolledUpIssues);
            const newPreviews = (0, parcelRequire("4Rr1a")).default(({ baselineStart: baselineStart, baselineEnd: baselineEnd, id: id, inferred: inferred })=>({
                    inferred: inferred,
                    baselineStart: baselineStart,
                    baselineEnd: baselineEnd,
                    shouldSync: id === issueId
                }), rolledUpIssuesMap);
            yield (0, $aNOuE.put)((0, $k49aW.setPreviewIssues)({
                activeIssueId: issueId,
                issueAndAncestors: newPreviews,
                strictDescendents: strictDescendentsPreviews
            }));
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $566ab5dbafb11caf$export$37f14865afe5c37f({ payload: { delta: delta, targetStart: targetStart, targetEnd: targetEnd } }) {
        try {
            yield (0, $aNOuE.put)((0, $k49aW.moveIssueAndDescendents)({
                delta: delta,
                targetStart: targetStart,
                targetEnd: targetEnd
            }));
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $566ab5dbafb11caf$export$ddbfe1d172b0734c({ payload: { baselineStart: baselineStart, baselineEnd: baselineEnd } }) {
        try {
            const timeline = yield (0, $aNOuE.select)((0, $lJNM1.getTimelineState));
            if (!timeline) return;
            const { activeIssueId: activeIssueId, previews: previews, strictDescendentIds: strictDescendentIds } = timeline;
            if (!activeIssueId || !previews) return;
            const strictDescendentPreviews = (0, parcelRequire("fes2p")).default(strictDescendentIds, previews);
            if ((0, $4nDwW.isDefined)(baselineStart)) {
                const listOfBaselineStarts = (0, parcelRequire("4Rr1a")).default((0, parcelRequire("5sZkx")).default(Infinity, 'baselineStart'), (0, parcelRequire("bjzU8")).default(strictDescendentPreviews));
                yield (0, $aNOuE.put)((0, $k49aW.setIssuesStart)({
                    issueIds: [
                        activeIssueId
                    ],
                    baselineStart: Math.min(...listOfBaselineStarts, baselineStart)
                }));
            }
            if ((0, $4nDwW.isDefined)(baselineEnd)) {
                const listOfBaselineEnds = (0, parcelRequire("4Rr1a")).default((0, parcelRequire("5sZkx")).default(-Infinity, 'baselineEnd'), (0, parcelRequire("bjzU8")).default(strictDescendentPreviews));
                yield (0, $aNOuE.put)((0, $k49aW.setIssuesEnd)({
                    issueIds: [
                        activeIssueId
                    ],
                    baselineEnd: Math.max(...listOfBaselineEnds, baselineEnd)
                }));
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $566ab5dbafb11caf$var$syncIssueBaselines(payload) {
        yield (0, $aNOuE.put)((0, $bkasS.updateIssueRaw)(payload));
    }
    function* $566ab5dbafb11caf$export$8af26ab715337da7() {
        try {
            const state = yield (0, $aNOuE.select)((0, $lJNM1.getTimelineState));
            if (!state) return;
            const listOfPreviews = (0, parcelRequire("6nTyZ")).default(state.previews);
            yield* (0, $bYhSc.default)(function*() {
                for (const [id, preview] of listOfPreviews){
                    const { baselineStart: baselineStart, baselineEnd: baselineEnd, shouldSync: shouldSync, inferred: inferred } = preview;
                    if (shouldSync) {
                        const isInferredStart = inferred && !!inferred.baselineStart;
                        const isInferredEnd = inferred && !!inferred.baselineEnd;
                        yield* $566ab5dbafb11caf$var$syncIssueBaselines({
                            id: id,
                            baselineStart: isInferredStart ? undefined : baselineStart,
                            baselineEnd: isInferredEnd ? undefined : baselineEnd
                        });
                    }
                }
                yield (0, $aNOuE.call)((0, $hIYGf.delay), 0);
                yield (0, $aNOuE.put)((0, $k49aW.clearPreview)());
            });
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $566ab5dbafb11caf$export$adf2e216f69c6b27() {
        try {
            yield (0, $aNOuE.put)((0, $k49aW.clearPreview)());
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $566ab5dbafb11caf$export$d6dd54078da4bb63() {
        yield (0, $6u3NN.takeEvery)((0, $048e9f12a4e86172$export$cac9106b1c7f24fc), $566ab5dbafb11caf$export$3f9bf2fcabbab63e);
    }
    function* $566ab5dbafb11caf$export$c695a14ab796349b() {
        yield (0, $6u3NN.takeEvery)((0, $048e9f12a4e86172$export$eb5a7568e1c3d408), $566ab5dbafb11caf$export$37f14865afe5c37f);
    }
    function* $566ab5dbafb11caf$export$da137b069b1cdf64() {
        yield (0, $6u3NN.takeEvery)((0, $048e9f12a4e86172$export$f5393940db5375), $566ab5dbafb11caf$export$ddbfe1d172b0734c);
    }
    function* $566ab5dbafb11caf$export$c9b1825986d71014() {
        yield (0, $6u3NN.takeEvery)((0, $048e9f12a4e86172$export$328d95132417a337), $566ab5dbafb11caf$export$8af26ab715337da7);
    }
    function* $566ab5dbafb11caf$export$bd06ebe2b531e4ef() {
        yield (0, $6u3NN.takeEvery)((0, $048e9f12a4e86172$export$c926e344ad34027e), $566ab5dbafb11caf$export$adf2e216f69c6b27);
    }
    function* $566ab5dbafb11caf$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($566ab5dbafb11caf$export$c695a14ab796349b);
        yield (0, $aNOuE.fork)($566ab5dbafb11caf$export$d6dd54078da4bb63);
        yield (0, $aNOuE.fork)($566ab5dbafb11caf$export$da137b069b1cdf64);
        yield (0, $aNOuE.fork)($566ab5dbafb11caf$export$c9b1825986d71014);
        yield (0, $aNOuE.fork)($566ab5dbafb11caf$export$bd06ebe2b531e4ef);
    }
});
parcelRegister("5sZkx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3faf242d7911d71e$export$2e2bcd8739ae039);
    var $IYMZh;
    var $7Mt7i;
    var $3faf242d7911d71e$var$propOr = (0, (0, parcelRequire("IYMZh")).default)(function propOr(val, p, obj) {
        return (0, (0, parcelRequire("7Mt7i")).default)(val, [
            p
        ], obj);
    });
    var $3faf242d7911d71e$export$2e2bcd8739ae039 = $3faf242d7911d71e$var$propOr;
});
parcelRegister("k49aW", function(module, exports) {
    $parcel$export(module.exports, "SET_PREVIEW_ISSUES", ()=>$4f72e8292f6431a4$export$80637663a1a05fe9);
    $parcel$export(module.exports, "MOVE_ISSUE_AND_DESCENDENTS", ()=>$4f72e8292f6431a4$export$8075320e8cff4d3a);
    $parcel$export(module.exports, "SET_ISSUES_START", ()=>$4f72e8292f6431a4$export$6fa9cc43099b89d3);
    $parcel$export(module.exports, "SET_ISSUES_END", ()=>$4f72e8292f6431a4$export$c2d0f2930212a9b6);
    $parcel$export(module.exports, "CLEAR_PREVIEW", ()=>$4f72e8292f6431a4$export$be1c5abe616607a6);
    $parcel$export(module.exports, "setPreviewIssues", ()=>$4f72e8292f6431a4$export$9f97114098874fdb);
    $parcel$export(module.exports, "moveIssueAndDescendents", ()=>$4f72e8292f6431a4$export$e4e09806b1513aec);
    $parcel$export(module.exports, "setIssuesStart", ()=>$4f72e8292f6431a4$export$cd118d4d32fb971);
    $parcel$export(module.exports, "setIssuesEnd", ()=>$4f72e8292f6431a4$export$993d450aa040cdf3);
    $parcel$export(module.exports, "clearPreview", ()=>$4f72e8292f6431a4$export$6b29cdc60786cec3);
    const $4f72e8292f6431a4$export$80637663a1a05fe9 = 'state.ui.main.tabs.roadmap.timeline-preview.SET_PREVIEW_ISSUES';
    const $4f72e8292f6431a4$export$8075320e8cff4d3a = 'state.ui.main.tabs.roadmap.timeline-preview.MOVE_ISSUE_AND_DESCENDENTS';
    const $4f72e8292f6431a4$export$6fa9cc43099b89d3 = 'state.ui.main.tabs.roadmap.timeline-preview.SET_ISSUES_START';
    const $4f72e8292f6431a4$export$c2d0f2930212a9b6 = 'state.ui.main.tabs.roadmap.timeline-preview.SET_ISSUES_END';
    const $4f72e8292f6431a4$export$be1c5abe616607a6 = 'state.ui.main.tabs.roadmap.timeline-preview.CLEAR_PREVIEW';
    const $4f72e8292f6431a4$export$9f97114098874fdb = (payload)=>({
            type: $4f72e8292f6431a4$export$80637663a1a05fe9,
            payload: payload
        });
    const $4f72e8292f6431a4$export$e4e09806b1513aec = (payload)=>({
            type: $4f72e8292f6431a4$export$8075320e8cff4d3a,
            payload: payload
        });
    const $4f72e8292f6431a4$export$cd118d4d32fb971 = (payload)=>({
            type: $4f72e8292f6431a4$export$6fa9cc43099b89d3,
            payload: payload
        });
    const $4f72e8292f6431a4$export$993d450aa040cdf3 = (payload)=>({
            type: $4f72e8292f6431a4$export$c2d0f2930212a9b6,
            payload: payload
        });
    const $4f72e8292f6431a4$export$6b29cdc60786cec3 = ()=>({
            type: $4f72e8292f6431a4$export$be1c5abe616607a6
        });
});
const $048e9f12a4e86172$export$cac9106b1c7f24fc = 'command.timeline-preview.HOVER_TIMELINE_ISSUE';
const $048e9f12a4e86172$export$eb5a7568e1c3d408 = 'command.timeline-preview.MOVE_TIMELINE_ISSUE';
const $048e9f12a4e86172$export$f5393940db5375 = 'command.timeline-preview.RESIZE_TIMELINE_ISSUE';
const $048e9f12a4e86172$export$328d95132417a337 = 'command.timeline-preview.COMMIT_TIMELINE_PREVIEW';
const $048e9f12a4e86172$export$c926e344ad34027e = 'command.timeline-preview.CANCEL_TIMELINE_PREVIEW';
parcelRegister("kRvyG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a9463f6c2c78c96$export$2e2bcd8739ae039);
    var $d3quy = parcelRequire("d3quy");
    var $lJNM1 = parcelRequire("lJNM1");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $f8JvR = parcelRequire("f8JvR");
    const $1a9463f6c2c78c96$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        sprints: (0, $d3quy.getSprints),
        previewForcedGradients: (state, props)=>{
            const { preview: preview, issueChildren: issueChildren } = props;
            if (!preview) return;
            const { previews: previews } = (0, $lJNM1.getTimelineState)(state) || {};
            const childrenPreviews = previews && issueChildren?.map((issue)=>previews[issue.id]).filter((0, $4nDwW.isDefined));
            return (0, $f8JvR.getForcedGradients)(preview, childrenPreviews);
        }
    });
    var $1a9463f6c2c78c96$export$2e2bcd8739ae039 = $1a9463f6c2c78c96$var$mapStateToProps;
});
parcelRegister("f8JvR", function(module, exports) {
    $parcel$export(module.exports, "getForcedGradients", ()=>$cfb952df272ad994$export$b5c256602dd8c06c);
    var $3pSjV;
    var $bCilb;
    var $j0d94;
    var $4nDwW = parcelRequire("4nDwW");
    const $cfb952df272ad994$export$b5c256602dd8c06c = ({ baselineStart: baselineStart, baselineEnd: baselineEnd }, children)=>(0, parcelRequire("j0d94")).default((acc, { baselineStart: baselineStart, baselineEnd: baselineEnd })=>(0, parcelRequire("bCilb")).default({
                earliestStart: (earliestStart)=>Math.min(earliestStart, (0, parcelRequire("3pSjV")).default(Infinity, baselineStart), (0, parcelRequire("3pSjV")).default(Infinity, baselineEnd)),
                earliestEnd: (earliestEnd)=>(0, $4nDwW.isDefined)(baselineStart) ? earliestEnd : Math.min(earliestEnd, (0, parcelRequire("3pSjV")).default(Infinity, baselineEnd)),
                latestStart: (latestStart)=>(0, $4nDwW.isDefined)(baselineEnd) ? latestStart : Math.max(latestStart, (0, parcelRequire("3pSjV")).default(-Infinity, baselineStart)),
                latestEnd: (latestEnd)=>Math.max(latestEnd, (0, parcelRequire("3pSjV")).default(-Infinity, baselineStart), (0, parcelRequire("3pSjV")).default(-Infinity, baselineEnd))
            }, acc), {
            earliestStart: (0, parcelRequire("3pSjV")).default(Infinity, baselineStart),
            earliestEnd: (0, parcelRequire("3pSjV")).default(Infinity, baselineStart),
            latestStart: (0, parcelRequire("3pSjV")).default(-Infinity, baselineEnd),
            latestEnd: (0, parcelRequire("3pSjV")).default(-Infinity, baselineEnd),
            left: !(0, $4nDwW.isDefined)(baselineStart),
            right: !(0, $4nDwW.isDefined)(baselineEnd)
        }, children || []);
});
parcelRegister("6l5jf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3020b9682f476f5a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $flnZx;
    var $iwfmd;
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $2t3gs = parcelRequire("2t3gs");
    var $fHOdZ = parcelRequire("fHOdZ");
    var $5XfGu = parcelRequire("5XfGu");
    var $isUDB = parcelRequire("isUDB");
    var $c3ZJn = parcelRequire("c3ZJn");
    var $6RRsR = parcelRequire("6RRsR");
    var $g08t1 = parcelRequire("g08t1");
    var $8u2gm = parcelRequire("8u2gm");
    const { ROLL_UP: $3020b9682f476f5a$var$ROLL_UP } = (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION);
    const $3020b9682f476f5a$var$snapWithRound = (val, snap)=>Math.round(val / snap) * snap;
    class $3020b9682f476f5a$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                DependencyMarker: $c3ZJn.default,
                Bar: $fHOdZ.default,
                isReadOnly: false,
                showStripesInBar: {
                    left: false,
                    right: false
                },
                isBeingInteractedWith: false,
                commitTimelinePreview: (0, ($parcel$interopDefault($8Rkzz))),
                moveTimelineIssue: (0, ($parcel$interopDefault($8Rkzz))),
                resizeTimelineIssue: (0, ($parcel$interopDefault($8Rkzz))),
                disableOtherRows: (0, ($parcel$interopDefault($8Rkzz))),
                reEnableOtherRows: (0, ($parcel$interopDefault($8Rkzz))),
                renderFlyout: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        render() {
            const { issue: issue, baselineStart: baselineStart, baselineEnd: baselineEnd, forcedGradients: forcedGradients, previewForcedGradients: previewForcedGradients, timelineRange: timelineRange, barColor: barColor, barColors: barColors, showStripesInBar: showStripesInBar, preview: preview, hasDependencyLineDragPreview: hasDependencyLineDragPreview, renderFlyout: renderFlyout, isReadOnly: isReadOnly, isBeingInteractedWith: isBeingInteractedWith, externalIncomingLinks: externalIncomingLinks, externalOutgoingLinks: externalOutgoingLinks, internalIncomingLinks: internalIncomingLinks, internalIncomingLinksOriginal: internalIncomingLinksOriginal, internalOutgoingLinks: internalOutgoingLinks, internalOutgoingLinksOriginal: internalOutgoingLinksOriginal, width: width, DependencyMarker: DependencyMarker, Bar: Bar, opacity: opacity, sprints: sprints, showActiveSprintOnTooltip: showActiveSprintOnTooltip, datesInferredFrom: datesInferredFrom, topOffset: topOffset } = this.props;
            const { hovered: hovered } = this.state;
            if (!(0, $4nDwW.isDefined)(baselineStart) || !(0, $4nDwW.isDefined)(baselineEnd)) throw Error('Issue must have both target dates specified to use this component');
            const barPositions = (0, $2t3gs.getPositionsForBar)({
                baselineStart: baselineStart,
                baselineEnd: baselineEnd
            }, timelineRange, forcedGradients);
            const isInferredStart = datesInferredFrom && datesInferredFrom.baselineStart === $3020b9682f476f5a$var$ROLL_UP;
            const isInferredEnd = datesInferredFrom && datesInferredFrom.baselineEnd === $3020b9682f476f5a$var$ROLL_UP;
            const isFadingStart = barPositions.leftAnchorPercentage !== 0;
            const isFadingEnd = barPositions.rightAnchorPercentage !== 100;
            const canDragMove = !isFadingStart && !isFadingEnd;
            const effectiveBaselineStart = barPositions.leftAnchorPercentage === 0 ? baselineStart : null;
            const startDate = preview && (0, $4nDwW.isDefined)(preview.baselineStart) ? preview.baselineStart : effectiveBaselineStart;
            const effectiveBaselineEnd = barPositions.rightAnchorPercentage === 100 ? baselineEnd : null;
            const endDate = preview && (0, $4nDwW.isDefined)(preview.baselineEnd) ? preview.baselineEnd : effectiveBaselineEnd;
            const barAdditionalStyles = {};
            if (!isReadOnly && canDragMove) barAdditionalStyles.cursor = 'move';
            let barDragHandler;
            let leftHandleDragHandler;
            let rightHandleDragHandler;
            if (!isReadOnly) {
                const baseDragHandler = {
                    onDragStart: ()=>{
                        this.props.disableOtherRows(issue.id);
                    },
                    onDragEnd: ()=>{
                        this.props.commitTimelinePreview();
                        this.props.reEnableOtherRows();
                    }
                };
                leftHandleDragHandler = {
                    ...baseDragHandler,
                    onDrag: (_, to, start)=>{
                        if (!baselineStart || !baselineEnd) throw Error('baseline dates must be set');
                        const timelineWidth = timelineRange.end - timelineRange.start;
                        const deltaRatio = (to.x - start.x) / width;
                        const delta = $3020b9682f476f5a$var$snapWithRound(deltaRatio * timelineWidth, (0, (0, parcelRequire("flnZx")).ONE_DAY));
                        const newBaselineStart = (0, (0, parcelRequire("flnZx")).startOfUtcDay)(Math.min(baselineStart + delta, baselineEnd || 0));
                        this.props.resizeTimelineIssue(newBaselineStart, isFadingEnd || isInferredEnd === true ? undefined : baselineEnd);
                    }
                };
                rightHandleDragHandler = {
                    ...baseDragHandler,
                    onDrag: (_, to, start)=>{
                        if (!baselineStart || !baselineEnd) throw Error('baseline dates must be set');
                        const timelineWidth = timelineRange.end - timelineRange.start;
                        const deltaRatio = (to.x - start.x) / width;
                        const delta = $3020b9682f476f5a$var$snapWithRound(deltaRatio * timelineWidth, (0, (0, parcelRequire("flnZx")).ONE_DAY));
                        const newBaselineEnd = (0, (0, parcelRequire("flnZx")).endOfUtcDay)(Math.max(baselineEnd + delta, baselineStart || 0));
                        this.props.resizeTimelineIssue(isFadingStart || isInferredStart === true ? undefined : baselineStart, newBaselineEnd);
                    }
                };
                if (canDragMove) barDragHandler = {
                    ...baseDragHandler,
                    onDrag: (from, to, start)=>{
                        const timelineWidth = timelineRange.end - timelineRange.start;
                        const deltaRatio = (to.x - start.x) / width;
                        const delta = $3020b9682f476f5a$var$snapWithRound(deltaRatio * timelineWidth, (0, (0, parcelRequire("flnZx")).ONE_DAY));
                        if (isInferredStart === isInferredEnd) this.props.moveTimelineIssue(delta, baselineStart, baselineEnd);
                        else if (isInferredStart === true) rightHandleDragHandler.onDrag(from, to, start);
                        else if (isInferredEnd === true) leftHandleDragHandler.onDrag(from, to, start);
                    }
                };
            }
            const bar = (0, ($parcel$interopDefault($5uXOq))).createElement(Bar, {
                ...barPositions,
                color: barColor,
                colors: barColors,
                showStripes: showStripesInBar,
                opacity: opacity,
                additionalStyles: barAdditionalStyles,
                showHandles: !isReadOnly && hovered && !isBeingInteractedWith,
                barDragHandler: barDragHandler,
                leftHandleDragHandler: leftHandleDragHandler,
                rightHandleDragHandler: rightHandleDragHandler,
                renderFlyout: renderFlyout,
                id: issue.id,
                topOffset: topOffset
            });
            let previewBar;
            let previewPositions;
            if (preview) {
                previewPositions = (0, $2t3gs.getPositionsForBar)(preview, timelineRange, previewForcedGradients);
                previewBar = (0, ($parcel$interopDefault($5uXOq))).createElement(Bar, {
                    ...previewPositions,
                    showStripes: showStripesInBar,
                    color: barColor,
                    colors: barColors,
                    opacity: 0.8,
                    id: issue.id,
                    topOffset: topOffset
                });
            }
            const datePosition = previewPositions || barPositions;
            let startDateField;
            let endDateField;
            let numDays;
            let dates;
            const incomingDependencies = !hasDependencyLineDragPreview && (0, ($parcel$interopDefault($5uXOq))).createElement(DependencyMarker, {
                externalIncomingLinks: externalIncomingLinks,
                internalIncomingLinks: internalIncomingLinks,
                originalIssueLinks: internalIncomingLinksOriginal,
                startOrEnd: "start",
                direction: (0, $TTKUQ.ISSUE_LINK_DIRECTION).INWARD,
                datePosition: datePosition,
                width: width,
                issue: issue,
                isHovered: hovered,
                barColor: barColor,
                barColors: barColors
            });
            const outgoingDependencies = !hasDependencyLineDragPreview && (0, ($parcel$interopDefault($5uXOq))).createElement(DependencyMarker, {
                externalOutgoingLinks: externalOutgoingLinks,
                internalOutgoingLinks: internalOutgoingLinks,
                originalIssueLinks: internalOutgoingLinksOriginal,
                startOrEnd: "end",
                direction: (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD,
                datePosition: datePosition,
                width: width,
                issue: issue,
                isHovered: hovered,
                barColor: barColor,
                barColors: barColors
            });
            if ((hovered || isBeingInteractedWith) && !hasDependencyLineDragPreview) {
                const completedSprints = issue.completedSprints || [];
                const activeSprint = sprints.find((sprint)=>sprint.id === issue.sprint);
                startDateField = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5XfGu.default), {
                    startOrEnd: "start",
                    date: startDate,
                    isRolledUpValue: isInferredStart
                });
                endDateField = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5XfGu.default), {
                    startOrEnd: "end",
                    date: endDate,
                    isRolledUpValue: isInferredEnd
                });
                numDays = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $6RRsR.default), {
                    startDate: startDate,
                    endDate: endDate,
                    activeSprint: activeSprint,
                    completedSprintCount: completedSprints.length,
                    showActiveSprintOnTooltip: showActiveSprintOnTooltip
                });
                dates = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $isUDB.default), {
                    datePosition: datePosition,
                    width: width
                }, startDateField, numDays, endDateField);
            }
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
                onHoverChanged: (hovered)=>this.setState({
                        hovered: hovered
                    })
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $8u2gm.spaBothDatesRow
            }, bar, previewBar, incomingDependencies, outgoingDependencies, dates, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g08t1.default), null))));
        }
        constructor(...args){
            super(...args);
            this.state = {
                hovered: false
            };
        }
    }
});
parcelRegister("2t3gs", function(module, exports) {
    $parcel$export(module.exports, "HORIZONTAL_HIT_TARGET_THRESHOLD", ()=>$2e4cd44758604e2b$export$dd128398eba49a1c);
    $parcel$export(module.exports, "getPositionsForBar", ()=>$2e4cd44758604e2b$export$32e9788ba7124f57);
    $parcel$export(module.exports, "colorsToGradient", ()=>$2e4cd44758604e2b$export$a421baa06a50c2d7);
    $parcel$export(module.exports, "getStripesStyle", ()=>$2e4cd44758604e2b$export$9550c86d8d33e2af);
    $parcel$export(module.exports, "useDropTarget", ()=>$2e4cd44758604e2b$export$5967d4bb72ce3c0);
    var $5uXOq = parcelRequire("5uXOq");
    var $flnZx;
    var $8vyMo;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $eT70U;
    const $2e4cd44758604e2b$var$GRADIENT_LENGTH_PERCENTAGE = 30;
    const $2e4cd44758604e2b$var$MINIMUM_LEFT_FORCED_GRADIENT_PERCENTAGE = 12;
    const $2e4cd44758604e2b$var$MAXIMUM_RIGHT_FORCED_GRADIENT_PERCENTAGE = 100 - $2e4cd44758604e2b$var$MINIMUM_LEFT_FORCED_GRADIENT_PERCENTAGE;
    const $2e4cd44758604e2b$export$dd128398eba49a1c = (0, $TTKUQ.SCOPE_ROW_HEIGHT) / 4;
    const $2e4cd44758604e2b$export$32e9788ba7124f57 = ({ baselineStart: baselineStart, baselineEnd: baselineEnd }, timelineRange, forcedGradients)=>{
        const timelineSize = timelineRange.end - timelineRange.start;
        const timestampToTimelineLeftPercentage = (time)=>((0, (0, parcelRequire("flnZx")).startOfUtcDay)(time) - timelineRange.start) / timelineSize * 100;
        const timestampToTimelineRightPercentage = (time)=>((0, (0, parcelRequire("flnZx")).endOfUtcDay)(time) - timelineRange.start) / timelineSize * 100;
        let leftPositionPercentage = 0;
        let rightPositionPercentage = 0;
        let leftAnchorPercentage = 0;
        let rightAnchorPercentage = 100;
        if ((0, $4nDwW.isDefined)(baselineStart) && (0, $4nDwW.isDefined)(baselineEnd)) {
            leftPositionPercentage = timestampToTimelineLeftPercentage(baselineStart);
            rightPositionPercentage = 100 - timestampToTimelineRightPercentage(baselineEnd);
        } else if ((0, $4nDwW.isDefined)(baselineStart)) {
            leftPositionPercentage = timestampToTimelineLeftPercentage(baselineStart);
            rightPositionPercentage = 100 - (leftPositionPercentage + $2e4cd44758604e2b$var$GRADIENT_LENGTH_PERCENTAGE);
            rightAnchorPercentage = 0;
        } else if ((0, $4nDwW.isDefined)(baselineEnd)) {
            rightPositionPercentage = 100 - timestampToTimelineRightPercentage(baselineEnd);
            leftPositionPercentage = 100 - (rightPositionPercentage + $2e4cd44758604e2b$var$GRADIENT_LENGTH_PERCENTAGE);
            leftAnchorPercentage = 100;
        }
        if (forcedGradients) {
            const earliestStartPercentage = timestampToTimelineLeftPercentage(forcedGradients.earliestStart);
            const latestEndPercentage = timestampToTimelineRightPercentage(forcedGradients.latestEnd);
            if (forcedGradients.left) leftPositionPercentage = Math.min(timestampToTimelineRightPercentage(forcedGradients.earliestEnd) - $2e4cd44758604e2b$var$GRADIENT_LENGTH_PERCENTAGE, earliestStartPercentage);
            if (forcedGradients.right) rightPositionPercentage = 100 - Math.max(timestampToTimelineLeftPercentage(forcedGradients.latestStart) + $2e4cd44758604e2b$var$GRADIENT_LENGTH_PERCENTAGE, latestEndPercentage);
            const totalPercentage = 100 - (leftPositionPercentage + rightPositionPercentage);
            if (forcedGradients.left) leftAnchorPercentage = Math.max($2e4cd44758604e2b$var$MINIMUM_LEFT_FORCED_GRADIENT_PERCENTAGE, 100 * (earliestStartPercentage - leftPositionPercentage) / totalPercentage);
            if (forcedGradients.right) rightAnchorPercentage = Math.min($2e4cd44758604e2b$var$MAXIMUM_RIGHT_FORCED_GRADIENT_PERCENTAGE, 100 * (latestEndPercentage - leftPositionPercentage) / totalPercentage);
        }
        return {
            leftPositionPercentage: leftPositionPercentage,
            rightPositionPercentage: rightPositionPercentage,
            leftAnchorPercentage: leftAnchorPercentage,
            rightAnchorPercentage: rightAnchorPercentage
        };
    };
    const $2e4cd44758604e2b$var$ratioToCSS = (x)=>Math.round(x * 1e6) / 1e4;
    const $2e4cd44758604e2b$var$colorToFadeColor = (x)=>{
        const opacity = 0.1;
        const r = parseInt(x.slice(1, 3), 16);
        const g = parseInt(x.slice(3, 5), 16);
        const b = parseInt(x.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    };
    const $2e4cd44758604e2b$export$a421baa06a50c2d7 = ({ colors: colors, leftAnchorPercentage: leftAnchorPercentage, rightAnchorPercentage: rightAnchorPercentage, fadeSolidPercentage: fadeSolidPercentage })=>{
        const antiGapFactor = 1.005;
        const layers = [];
        let progress = 0;
        for (const { colour: colour, ratio: ratio } of colors){
            const top = $2e4cd44758604e2b$var$ratioToCSS(progress);
            const height = $2e4cd44758604e2b$var$ratioToCSS(ratio / (1 - progress));
            if (leftAnchorPercentage > 0) {
                const image = `linear-gradient(to left, ${colour}${fadeSolidPercentage ? `, ${colour} ${fadeSolidPercentage}%` : ''}, ${$2e4cd44758604e2b$var$colorToFadeColor(colour)})`;
                const position = `0% ${top}% / ${leftAnchorPercentage * antiGapFactor}% ${height}% no-repeat`;
                layers.push(`${image} ${position}`);
            }
            const solidPercentage = rightAnchorPercentage - leftAnchorPercentage;
            if (solidPercentage > 0) {
                const image = `linear-gradient(${colour}, ${colour})`;
                const position = `${solidPercentage < 100 ? $2e4cd44758604e2b$var$ratioToCSS(leftAnchorPercentage / (100 - solidPercentage)) : 100}% ${top}% / ${solidPercentage * antiGapFactor}% ${height}% no-repeat`;
                layers.push(`${image} ${position}`);
            }
            if (rightAnchorPercentage < 100) {
                const image = `linear-gradient(to right, ${colour}${fadeSolidPercentage ? `, ${colour} ${fadeSolidPercentage}%` : ''}, ${$2e4cd44758604e2b$var$colorToFadeColor(colour)})`;
                const position = `100% ${top}% / ${(100 - rightAnchorPercentage) * antiGapFactor}% ${height}% no-repeat`;
                layers.push(`${image} ${position}`);
            }
            progress += ratio;
        }
        return layers.join(', ');
    };
    const $2e4cd44758604e2b$export$9550c86d8d33e2af = (stripes, colors)=>{
        const stripesLayer = `repeating-linear-gradient(
        120deg,
        transparent,
        transparent 15px,
        ${"var(--ds-background-inverse-subtle-pressed, rgba(255, 255, 255, 0.3))"} 15px,
        ${"var(--ds-background-inverse-subtle-pressed, rgba(255, 255, 255, 0.3))"} 30px,
        transparent 30px
    )`;
        const { left: left, right: right } = stripes;
        if (!(left || right)) return {};
        if (left && right) return {
            background: stripesLayer
        };
        const coverLayers = $2e4cd44758604e2b$export$a421baa06a50c2d7({
            colors: colors,
            leftAnchorPercentage: left ? 100 : 0,
            rightAnchorPercentage: right ? 0 : 100,
            fadeSolidPercentage: 25
        });
        return {
            background: `${coverLayers}, ${stripesLayer}`
        };
    };
    const $2e4cd44758604e2b$export$5967d4bb72ce3c0 = (ref)=>{
        const { row: row } = (0, (0, parcelRequire("eT70U")).useRow)();
        const [isDraggedOver, setIsDraggedOver] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!ref.current) return;
            return (0, (0, parcelRequire("8vyMo")).dropTargetForDependencyCreate)({
                element: ref.current,
                onDragEnter: ()=>setIsDraggedOver(true),
                onDragLeave: ()=>setIsDraggedOver(false),
                onDrop: ()=>setIsDraggedOver(false),
                getData: ()=>({
                        row: row
                    })
            });
        }, [
            ref,
            row
        ]);
        return isDraggedOver;
    };
});
parcelRegister("fHOdZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10120ace2f336037$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dTOUt = parcelRequire("dTOUt");
    var $3pSjV;
    var $co1wz;
    var $4R6GH;
    var $J8W7q;
    var $gITL8 = parcelRequire("gITL8");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $dCm1o;
    var $b4Lge = parcelRequire("b4Lge");
    var $mtNJ0 = parcelRequire("mtNJ0");
    var $UiNuu = parcelRequire("UiNuu");
    var $Dbv4l = parcelRequire("Dbv4l");
    var $8aPbW = parcelRequire("8aPbW");
    var $2t3gs = parcelRequire("2t3gs");
    function $10120ace2f336037$export$2e2bcd8739ae039({ additionalStyles: additionalStyles, alwaysShowFlyout: alwaysShowFlyout = false, barDragHandler: barDragHandler, children: children, color: color = (0, $gITL8.DEFAULT_COLOR), colors: colors, id: id, leftAnchorPercentage: leftAnchorPercentage, leftHandleDragHandler: leftHandleDragHandler, leftPositionPercentage: leftPositionPercentage, opacity: opacity = 1, renderFlyout: renderFlyout, rightAnchorPercentage: rightAnchorPercentage, rightHandleDragHandler: rightHandleDragHandler, rightPositionPercentage: rightPositionPercentage, showHandles: showHandles = false, showStripes: showStripes, topOffset: topOffset }) {
        const ref = (0, $5uXOq.useRef)(null);
        const { dragHovered: dragHovered, dragSource: dragSource, removeIssueRect: removeIssueRect, updateIssueRect: updateIssueRect, width: viewportWidth } = (0, $mtNJ0.useDepLinesDrag)();
        const { id: dndItemId } = (0, $b4Lge.useDndItem)();
        const isBeingDragHovered = (0, ($parcel$interopDefault($dTOUt)))(dndItemId, dragHovered);
        const isSourceOfDragPreview = (0, ($parcel$interopDefault($dTOUt)))(dndItemId, dragSource?.rowId);
        (0, $5uXOq.useEffect)(()=>{
            if (opacity === (0, $TTKUQ.PREVIEW_OPACITY)) return;
            const widthPercentage = 100 - rightPositionPercentage - leftPositionPercentage;
            const rect = {
                top: topOffset - (0, $TTKUQ.SCOPE_ROW_HEIGHT),
                left: leftPositionPercentage / 100 * viewportWidth - (0, $2t3gs.HORIZONTAL_HIT_TARGET_THRESHOLD) + (0, $TTKUQ.HORIZONTAL_SCROLL_OFFSET),
                width: widthPercentage / 100 * viewportWidth + 2 * (0, $2t3gs.HORIZONTAL_HIT_TARGET_THRESHOLD),
                height: (0, $TTKUQ.SCOPE_ROW_HEIGHT)
            };
            updateIssueRect(dndItemId, rect);
            return ()=>removeIssueRect(dndItemId);
        }, [
            dndItemId,
            leftPositionPercentage,
            opacity,
            removeIssueRect,
            rightPositionPercentage,
            topOffset,
            updateIssueRect,
            viewportWidth
        ]);
        const isDraggedOver = (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2') && (0, $2t3gs.useDropTarget)(ref);
        const normalizedColors = (0, parcelRequire("3pSjV")).default([
            {
                colour: color,
                ratio: 1
            }
        ], colors);
        const stripes = showStripes && (showStripes.left || showStripes.right) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8aPbW.stripes,
            style: (0, $2t3gs.getStripesStyle)(showStripes, normalizedColors),
            "data-testid": `issue-bar-stripes-${id}`
        });
        const handleStyle = {
            display: showHandles ? 'block' : 'none'
        };
        const leftHandle = leftAnchorPercentage === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $UiNuu.default), {
            dragHandler: leftHandleDragHandler || {},
            flag: "LEFT-HANDLE"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? $8aPbW.leftHandle : $8aPbW.leftHandleOld,
            style: handleStyle
        }));
        const rightHandle = rightAnchorPercentage === 100 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $UiNuu.default), {
            dragHandler: rightHandleDragHandler || {},
            flag: "RIGHT-HANDLE"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? $8aPbW.rightHandle : $8aPbW.rightHandleOld,
            style: handleStyle
        }));
        const flyoutContent = alwaysShowFlyout && renderFlyout();
        const withZIndexOverride = (children)=>{
            if (!(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2')) return children(undefined);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
                layer: (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS
            }, (zIndex)=>children(zIndex ?? 'initial'));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8aPbW.flyoutPositioner,
            style: {
                left: `calc(${leftPositionPercentage}% + ${((0, $Dbv4l.FLYOUT_CONTENT_WIDTH) + 50) / 2}px)`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            content: flyoutContent,
            isOpen: alwaysShowFlyout && flyoutContent !== undefined,
            placement: "bottom"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8aPbW.flyoutContent
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $UiNuu.default), {
            dragHandler: barDragHandler || {},
            flag: "BAR"
        }, withZIndexOverride((zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $8aPbW.spaBar,
                "data-name": `issue-bar-${id}`,
                "data-testid": `issue-bar-${id}`,
                ref: ref,
                style: {
                    background: (0, $2t3gs.colorsToGradient)({
                        colors: normalizedColors,
                        leftAnchorPercentage: leftAnchorPercentage,
                        rightAnchorPercentage: rightAnchorPercentage
                    }),
                    border: isBeingDragHovered === true || isSourceOfDragPreview === true ? `solid 1.5px ${"var(--ds-background-neutral-bold, #000000)"}` : '',
                    boxShadow: isDraggedOver ? `0 0 0 1.5px ${"var(--ds-background-neutral-bold, #000000)"}` : undefined,
                    left: `${leftPositionPercentage}%`,
                    opacity: opacity,
                    right: `${rightPositionPercentage}%`,
                    zIndex: zIndex,
                    ...additionalStyles
                }
            }, stripes, leftHandle, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $8aPbW.content
            }, children), rightHandle))));
    }
});
parcelRegister("dTOUt", function(module, exports) {
    module.exports = (parcelRequire("eex53"));
});
parcelRegister("eex53", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $a5cc089264689093$var$func = $lVx1a('isEqual', (parcelRequire("ajpes")));
    $a5cc089264689093$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $a5cc089264689093$var$func;
});
parcelRegister("b4Lge", function(module, exports) {
    $parcel$export(module.exports, "useDndItem", ()=>$02ee77c4206a3776$export$79384f8998c974df);
    var $5uXOq = parcelRequire("5uXOq");
    var $LBJrQ = parcelRequire("LBJrQ");
    var $6pfVY = parcelRequire("6pfVY");
    function $02ee77c4206a3776$export$79384f8998c974df() {
        return (0, $5uXOq.useContext)((0, $LBJrQ.context));
    }
});
parcelRegister("LBJrQ", function(module, exports) {
    $parcel$export(module.exports, "context", ()=>$9238a2e4e0fa5015$export$a078c61943f9dbbe);
    var $5uXOq = parcelRequire("5uXOq");
    const $9238a2e4e0fa5015$export$a078c61943f9dbbe = (0, $5uXOq.createContext)({
        id: {
            scopeIndex: -1,
            issueId: ''
        }
    });
});
parcelRegister("6pfVY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$061c0005aad58392$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $LBJrQ = parcelRequire("LBJrQ");
    function $061c0005aad58392$export$2e2bcd8739ae039({ scopeIndex: scopeIndex, issueId: issueId, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $LBJrQ.context).Provider, {
            value: {
                id: {
                    scopeIndex: scopeIndex,
                    issueId: issueId
                }
            }
        }, children);
    }
});
parcelRegister("mtNJ0", function(module, exports) {
    $parcel$export(module.exports, "useDepLinesDrag", ()=>$e4e57b06f779b001$export$f709ac5ddcd09471);
    $parcel$export(module.exports, "default", ()=>$e4e57b06f779b001$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ddv1K = parcelRequire("ddv1K");
    var $jpgxP = parcelRequire("jpgxP");
    var $3YtPS = parcelRequire("3YtPS");
    var $bC2fB;
    var $iUEm4 = parcelRequire("iUEm4");
    var $aOWtR = parcelRequire("aOWtR");
    var $YcHMX = parcelRequire("YcHMX");
    const $e4e57b06f779b001$export$f709ac5ddcd09471 = ()=>(0, $5uXOq.useContext)((0, $aOWtR.context));
    const $e4e57b06f779b001$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        outgoingLinks: (0, $ddv1K.getOutgoingLinks),
        dependencySettings: (0, $jpgxP.getDependencySettingsInfo)
    });
    var $e4e57b06f779b001$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($e4e57b06f779b001$var$mapStateToProps, (0, $iUEm4.default))((0, $YcHMX.default));
});
parcelRegister("iUEm4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30fa28e08addcf94$export$2e2bcd8739ae039);
    var $eS9xr = parcelRequire("eS9xr");
    var $30fa28e08addcf94$export$2e2bcd8739ae039 = {
        addIssueLink: $eS9xr.addIssueLink
    };
});
parcelRegister("aOWtR", function(module, exports) {
    $parcel$export(module.exports, "context", ()=>$d2371f17035906b7$export$a078c61943f9dbbe);
    $parcel$export(module.exports, "useHoverableIssueRect", ()=>$d2371f17035906b7$export$6408dacfbde0dd53);
    $parcel$export(module.exports, "useDropHandling", ()=>$d2371f17035906b7$export$5048b513d451ea75);
    var $5uXOq = parcelRequire("5uXOq");
    var $dTOUt = parcelRequire("dTOUt");
    var $pa9q9;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $5pcBc = parcelRequire("5pcBc");
    const $d2371f17035906b7$var$DEPENDENCY_CREATION_ERROR_FLAG_ID = 'dragPreviewDependencyCreationErrorFlag';
    const $d2371f17035906b7$export$a078c61943f9dbbe = (0, $5uXOq.createContext)({
        width: 0,
        dragSource: null,
        setDragSource: ()=>{},
        dragHovered: null,
        updateIssueRect: ()=>{},
        removeIssueRect: ()=>{},
        handleDragMove: ()=>{},
        handleDrop: ()=>false
    });
    const $d2371f17035906b7$export$6408dacfbde0dd53 = ()=>{
        const [hovered, setHovered] = (0, $5uXOq.useState)(null);
        const issueRectsRef = (0, $5uXOq.useRef)([]);
        const removeIssueRect = (0, $5uXOq.useCallback)((rowId)=>{
            issueRectsRef.current = issueRectsRef.current.filter((issueRect)=>!(0, ($parcel$interopDefault($dTOUt)))(issueRect.rowId, rowId));
        }, []);
        const updateIssueRect = (0, $5uXOq.useCallback)((rowId, rect)=>{
            issueRectsRef.current = issueRectsRef.current.filter((issueRect)=>!(0, ($parcel$interopDefault($dTOUt)))(issueRect.rowId, rowId)).concat([
                {
                    rowId: rowId,
                    rect: rect
                }
            ]);
        }, []);
        const handleDragMove = (0, $5uXOq.useCallback)((offsetX, offsetY)=>{
            const issueRects = issueRectsRef.current;
            for(let i = 0; i < issueRects.length; i++){
                const { rowId: rowId, rect: rect } = issueRects[i];
                const { top: top, left: left, width: width, height: height } = rect;
                if (offsetX >= left && offsetX <= left + width && offsetY >= top && offsetY <= top + height) {
                    if (!(0, ($parcel$interopDefault($dTOUt)))(hovered, rowId)) setHovered(rowId);
                    return;
                }
            }
            if (offsetX >= 0 && offsetY >= 0) setHovered(null);
        }, [
            hovered
        ]);
        const handleDragEnd = (0, $5uXOq.useCallback)(()=>setHovered(null), []);
        return {
            hovered: hovered,
            removeIssueRect: removeIssueRect,
            updateIssueRect: updateIssueRect,
            handleDragMove: handleDragMove,
            handleDragEnd: handleDragEnd
        };
    };
    const $d2371f17035906b7$export$5048b513d451ea75 = (hovered, dragSource, addIssueLink, outgoingLinks, dependencySettings)=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const dragSourceRef = (0, $5uXOq.useRef)(dragSource);
        const hoveredRef = (0, $5uXOq.useRef)(hovered?.issueId);
        dragSourceRef.current = dragSource;
        hoveredRef.current = hovered?.issueId;
        return (0, $5uXOq.useCallback)(({ issueLinkType: issueLinkType })=>{
            const hovered = hoveredRef.current;
            const dragSource = dragSourceRef.current;
            if (hovered == null || dragSource == null) return false;
            const [source, target] = dragSource.direction === (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD ? [
                dragSource.rowId.issueId,
                hovered
            ] : [
                hovered,
                dragSource.rowId.issueId
            ];
            if (source === target) return false;
            const outgoingLinksForItem = outgoingLinks[source] || [];
            const existingLinkArray = outgoingLinksForItem.filter((link)=>link.targetItemKey === target && link.type === issueLinkType);
            if (existingLinkArray.length > 0) return false;
            const dependencyIssueLinkTypes = dependencySettings.dependencyIssueLinkTypes ?? [];
            const hasIssueLinkTypeConfigured = dependencyIssueLinkTypes.find((linkType)=>linkType.issueLinkTypeId === issueLinkType);
            if (!hasIssueLinkTypeConfigured) {
                showFlag({
                    id: $d2371f17035906b7$var$DEPENDENCY_CREATION_ERROR_FLAG_ID,
                    title: (0, $5pcBc.default).noLinkTypeFlagTitle,
                    type: 'error',
                    description: (0, $5pcBc.default).noLinkTypeFlagDescription,
                    isAutoDismiss: true,
                    actions: [
                        {
                            content: (0, $5pcBc.default).noLinkTypeFlagLink,
                            href: 'https://support.atlassian.com/jira-software-cloud/docs/configure-dependencies-in-jira-for-advanced-roadmaps/',
                            target: '_blank'
                        }
                    ]
                });
                return false;
            }
            addIssueLink({
                sourceItemKey: source,
                targetItemKey: target,
                type: issueLinkType
            });
            return true;
        }, [
            addIssueLink,
            outgoingLinks,
            showFlag,
            dependencySettings?.dependencyIssueLinkTypes
        ]);
    };
});
parcelRegister("5pcBc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bc47c43294b824f$export$2e2bcd8739ae039);
    var $7VHMR;
    const $1bc47c43294b824f$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noLinkTypeFlagTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.dependency-lines.drag-preview.provider.no-link-type-flag-title",
            "defaultMessage": "We couldn't create a dependency"
        },
        noLinkTypeFlagDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.dependency-lines.drag-preview.provider.no-link-type-flag-description",
            "defaultMessage": "Check your issue link Jira Setting or contact your Jira Administrator for help."
        },
        noLinkTypeFlagLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.dependency-lines.drag-preview.provider.no-link-type-flag-link",
            "defaultMessage": "Configure dependencies for your plan"
        }
    });
    var $1bc47c43294b824f$export$2e2bcd8739ae039 = $1bc47c43294b824f$var$messages;
});
parcelRegister("YcHMX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09412a5f069df600$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aOWtR = parcelRequire("aOWtR");
    function $09412a5f069df600$var$DragPreviewDepLineProvider({ addIssueLink: addIssueLink, width: width, children: children, outgoingLinks: outgoingLinks, dependencySettings: dependencySettings }) {
        const { hovered: hovered, removeIssueRect: removeIssueRect, updateIssueRect: updateIssueRect, handleDragMove: handleDragMove, handleDragEnd: handleDragEnd } = (0, $aOWtR.useHoverableIssueRect)();
        const [dragSource, setDragSource] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            if (dragSource == null) handleDragEnd();
        }, [
            dragSource,
            handleDragEnd
        ]);
        const handleDrop = (0, $aOWtR.useDropHandling)(hovered, dragSource, addIssueLink, outgoingLinks, dependencySettings);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aOWtR.context).Provider, {
            value: {
                width: width,
                dragSource: dragSource,
                setDragSource: setDragSource,
                dragHovered: hovered,
                updateIssueRect: updateIssueRect,
                removeIssueRect: removeIssueRect,
                handleDragMove: handleDragMove,
                handleDrop: handleDrop
            }
        }, children);
    }
    var $09412a5f069df600$export$2e2bcd8739ae039 = $09412a5f069df600$var$DragPreviewDepLineProvider;
});
parcelRegister("UiNuu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ea39513f576cc10$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $fJbaP;
    var $hE4fC;
    var $8KRRD = parcelRequire("8KRRD");
    var $4Vcrr = parcelRequire("4Vcrr");
    const $6ea39513f576cc10$var$useScrollingDelta = ()=>{
        const offsetInPxRef = (0, $5uXOq.useRef)(0);
        const startOffsetInPxRef = (0, $5uXOq.useRef)(0);
        const callbackRef = (0, $5uXOq.useRef)(()=>{});
        const deltaRef = (0, $5uXOq.useRef)(0);
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = (0, (0, parcelRequire("hE4fC")).subscribeHorizontalScrolling)(({ viewport: viewport, container: container })=>{
                const offsetInPx = viewport.offset * container.width / container.duration || 0;
                offsetInPxRef.current = offsetInPx;
                deltaRef.current = offsetInPxRef.current - startOffsetInPxRef.current;
                callbackRef.current();
            });
            return unsubscribe;
        }, [
            deltaRef
        ]);
        const dragReset = (0, $5uXOq.useCallback)(()=>{
            startOffsetInPxRef.current = offsetInPxRef.current;
            deltaRef.current = 0;
        }, []);
        const register = (0, $5uXOq.useCallback)((callback)=>{
            callbackRef.current = callback;
        }, []);
        const deregister = (0, $5uXOq.useCallback)(()=>{
            callbackRef.current = ()=>{};
        }, []);
        return [
            deltaRef,
            {
                dragReset: dragReset,
                register: register,
                deregister: deregister
            }
        ];
    };
    function $6ea39513f576cc10$export$2e2bcd8739ae039({ dragHandler: dragHandler, flag: flag, children: children }) {
        const [, { register: registerDndScrolling, deregister: deregisterDndScrolling }] = (0, $4Vcrr.useDndScrolling)();
        const dragPayloadRef = (0, $5uXOq.useRef)(null);
        const dragHandlerRef = (0, $5uXOq.useRef)(dragHandler);
        (0, $5uXOq.useEffect)(()=>{
            dragHandlerRef.current = dragHandler;
        }, [
            dragHandler
        ]);
        const [deltaRef, { dragReset: dragReset, register: registerDragScrolling, deregister: deregisterDragScrolling }] = $6ea39513f576cc10$var$useScrollingDelta();
        const drag = (0, $5uXOq.useCallback)(()=>{
            const { onDrag: onDrag } = dragHandlerRef.current;
            const dragPayload = dragPayloadRef.current;
            if (onDrag == null || dragPayload == null) return;
            onDrag(dragPayload.from, {
                ...dragPayload.to,
                x: dragPayload.to.x + deltaRef.current
            }, dragPayload.start);
        }, [
            deltaRef
        ]);
        const handleDragStart = (0, $5uXOq.useCallback)((start)=>{
            const { onDragStart: onDragStart } = dragHandlerRef.current;
            if ((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition')) (0, $8KRRD.default).emit('dragstart', {
                pageX: start.x,
                pageY: start.y
            });
            if (onDragStart == null) return;
            dragReset();
            registerDragScrolling(drag);
            registerDndScrolling(flag);
            onDragStart(start);
        }, [
            dragReset,
            registerDragScrolling,
            drag,
            registerDndScrolling,
            flag
        ]);
        const handleDrag = (0, $5uXOq.useCallback)((from, to, start)=>{
            const { onDrag: onDrag } = dragHandlerRef.current;
            if ((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition')) (0, $8KRRD.default).emit('drag', {
                pageX: to.x,
                pageY: to.y
            });
            if (onDrag == null) return;
            dragPayloadRef.current = {
                from: from,
                to: to,
                start: start
            };
            drag();
        }, [
            drag
        ]);
        const handleDragEnd = (0, $5uXOq.useCallback)((start, end)=>{
            const { onDragEnd: onDragEnd } = dragHandlerRef.current;
            if ((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition')) (0, $8KRRD.default).emit('dragend', {
                pageX: end.x,
                pageY: end.y
            });
            if (onDragEnd == null) return;
            dragPayloadRef.current = null;
            deregisterDragScrolling();
            deregisterDndScrolling(flag);
            onDragEnd(start, end);
        }, [
            deregisterDndScrolling,
            deregisterDragScrolling,
            flag
        ]);
        const { onClick: handleClick, onMouseDown: handleMouseDown } = dragHandler;
        const newHandler = (0, $5uXOq.useMemo)(()=>({
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onDragStart: handleDragStart,
                onDrag: handleDrag,
                onDragEnd: handleDragEnd
            }), [
            handleClick,
            handleDrag,
            handleDragEnd,
            handleDragStart,
            handleMouseDown
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fJbaP")).default), {
            dragHandler: newHandler
        }, children);
    }
});
parcelRegister("fJbaP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78ac30dcc167d92c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    const $78ac30dcc167d92c$export$25e31b3f7c2a34fa = 3;
    class $78ac30dcc167d92c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                dragHandler: {}
            };
        }
        componentDidMount() {
            this.node = this.getDomNode();
            this.mounted = true;
            this.node.addEventListener('mousedown', this.onChildMouseDown);
        }
        componentWillUnmount() {
            window.removeEventListener('mousemove', this.onWindowMouseMove);
            window.removeEventListener('mouseup', this.onWindowMouseUp);
            if (this.node) this.node.removeEventListener('mousedown', this.onChildMouseDown);
            this.mounted = false;
        }
        getDomNode() {
            const node = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(this);
            if (!(node instanceof Element)) throw new Error('Only plain DOM elements could be observed');
            return node;
        }
        render() {
            const { dragging: dragging } = this.state;
            const { children: children } = this.props;
            const childProps = dragging ? {
                dragging: dragging
            } : {};
            return (0, $5uXOq.cloneElement)((0, $5uXOq.Children).only(children), {
                ...childProps
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                dragging: false
            };
            this.mounted = false;
            this.node = null;
            this.onChildMouseDown = (e)=>{
                if (Object.keys(this.props.dragHandler).length === 0) return;
                e.preventDefault();
                e.stopPropagation();
                window.addEventListener('mousemove', this.onWindowMouseMove);
                window.addEventListener('mouseup', this.onWindowMouseUp);
                const dragStart = this.getMousePosition(e);
                this.setState({
                    dragging: false,
                    dragStart: dragStart,
                    previousDragPosition: dragStart
                });
                this.onMouseDown(e);
            };
            this.onWindowMouseMove = (e)=>{
                e.preventDefault();
                const mouse = this.getMousePosition(e);
                const { dragging: dragging, dragStart: dragStart, previousDragPosition: previousDragPosition } = this.state;
                if (!dragStart || !previousDragPosition) throw Error('dragStart and previousDragPosition should be set');
                if (!dragging) {
                    if (Math.abs(mouse.x - dragStart.x) > $78ac30dcc167d92c$export$25e31b3f7c2a34fa || Math.abs(mouse.y - dragStart.y) > $78ac30dcc167d92c$export$25e31b3f7c2a34fa) {
                        this.setState({
                            dragging: true
                        });
                        this.onDragStart(dragStart);
                    }
                }
                if (dragging) {
                    const from = previousDragPosition;
                    const to = mouse;
                    this.setState({
                        previousDragPosition: mouse
                    });
                    this.onDrag(from, to, dragStart);
                }
            };
            this.onWindowMouseUp = (e)=>{
                const { dragging: dragging, dragStart: dragStart } = this.state;
                if (!dragStart) throw Error('Illegal state: dragStart must be set here');
                if (dragging) {
                    const mouse = this.getMousePosition(e);
                    const start = dragStart;
                    const end = mouse;
                    if (this.mounted) this.setState({
                        dragging: false
                    });
                    this.onDragEnd(start, end);
                } else this.onClick(e);
                window.removeEventListener('mousemove', this.onWindowMouseMove);
                window.removeEventListener('mouseup', this.onWindowMouseUp);
            };
            this.onMouseDown = (e)=>{
                if (this.props.dragHandler.onMouseDown) this.props.dragHandler.onMouseDown(e);
            };
            this.onDragStart = (from)=>{
                if (this.props.dragHandler.onDragStart) this.props.dragHandler.onDragStart(from);
            };
            this.onDrag = (from, to, start)=>{
                if (this.props.dragHandler.onDrag) this.props.dragHandler.onDrag(from, to, start);
            };
            this.onDragEnd = (from, to)=>{
                if (this.props.dragHandler.onDragEnd) this.props.dragHandler.onDragEnd(from, to);
            };
            this.onClick = (e)=>{
                if (this.props.dragHandler.onClick) this.props.dragHandler.onClick(e);
            };
            this.getMousePosition = (e)=>({
                    x: e.pageX,
                    y: e.pageY
                });
        }
    }
});
parcelRegister("8KRRD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$701e4728de8925d9$export$2e2bcd8739ae039);
    var $6Oghe = parcelRequire("6Oghe");
    class $701e4728de8925d9$export$3bf8c370d1280dc0 {
        addEventListener(name, callback) {
            this.emitter.on(name, callback);
        }
        removeEventListener(name, callback) {
            this.emitter.off(name, callback);
        }
        emit(name, payload) {
            this.emitter.emit(name, payload);
        }
        constructor(){
            this.emitter = new (0, ($parcel$interopDefault($6Oghe)))();
        }
    }
    const $701e4728de8925d9$var$issueBarDragEmitter = new $701e4728de8925d9$export$3bf8c370d1280dc0();
    var $701e4728de8925d9$export$2e2bcd8739ae039 = $701e4728de8925d9$var$issueBarDragEmitter;
});
parcelRegister("6Oghe", function(module, exports) {
    'use strict';
    var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
    var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
    var $4f5409da028b4771$var$ReflectOwnKeys;
    if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
    else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
    };
    else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target);
    };
    function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
    }
    var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
        return value !== value;
    };
    function $4f5409da028b4771$var$EventEmitter() {
        $4f5409da028b4771$var$EventEmitter.init.call(this);
    }
    module.exports = $4f5409da028b4771$var$EventEmitter;
    module.exports.once = $4f5409da028b4771$var$once;
    $4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
    $4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
    $4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
    $4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
    var $4f5409da028b4771$var$defaultMaxListeners = 10;
    function $4f5409da028b4771$var$checkListener(listener) {
        if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
    Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
        enumerable: true,
        get: function() {
            return $4f5409da028b4771$var$defaultMaxListeners;
        },
        set: function(arg) {
            if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
            $4f5409da028b4771$var$defaultMaxListeners = arg;
        }
    });
    $4f5409da028b4771$var$EventEmitter.init = function() {
        if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
        this._maxListeners = n;
        return this;
    };
    function $4f5409da028b4771$var$_getMaxListeners(that) {
        if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return $4f5409da028b4771$var$_getMaxListeners(this);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        var doError = type === 'error';
        var events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) throw er;
            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err;
        }
        var handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
        else {
            var len = handler.length;
            var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
            for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
        }
        return true;
    };
    function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        $4f5409da028b4771$var$checkListener(listener);
        events = target._events;
        if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
        } else {
            if (events.newListener !== undefined) {
                target.emit('newListener', type, listener.listener ? listener.listener : listener);
                events = target._events;
            }
            existing = events[type];
        }
        if (existing === undefined) {
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === 'function') existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else if (prepend) existing.unshift(listener);
            else existing.push(listener);
            m = $4f5409da028b4771$var$_getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true;
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                $4f5409da028b4771$var$ProcessEmitWarning(w);
            }
        }
        return target;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
        return $4f5409da028b4771$var$_addListener(this, type, listener, false);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
    $4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return $4f5409da028b4771$var$_addListener(this, type, listener, true);
    };
    function $4f5409da028b4771$var$onceWrapper() {
        if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
        }
    }
    function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
        var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
        };
        var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
        $4f5409da028b4771$var$checkListener(listener);
        this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        $4f5409da028b4771$var$checkListener(listener);
        this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        $4f5409da028b4771$var$checkListener(listener);
        events = this._events;
        if (events === undefined) return this;
        list = events[type];
        if (list === undefined) return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
                delete events[type];
                if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
        } else if (typeof list !== 'function') {
            position = -1;
            for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (position === 0) list.shift();
            else $4f5409da028b4771$var$spliceOne(list, position);
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
        }
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
    $4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined) return this;
        if (events.removeListener === undefined) {
            if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
            } else if (events[type] !== undefined) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else delete events[type];
            }
            return this;
        }
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for(i = 0; i < keys.length; ++i){
                key = keys[i];
                if (key === 'removeListener') continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === 'function') this.removeListener(type, listeners);
        else if (listeners !== undefined) for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
        return this;
    };
    function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
        var events = target._events;
        if (events === undefined) return [];
        var evlistener = events[type];
        if (evlistener === undefined) return [];
        if (typeof evlistener === 'function') return unwrap ? [
            evlistener.listener || evlistener
        ] : [
            evlistener
        ];
        return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
    }
    $4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
        return $4f5409da028b4771$var$_listeners(this, type, true);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return $4f5409da028b4771$var$_listeners(this, type, false);
    };
    $4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
        else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
    function $4f5409da028b4771$var$listenerCount(type) {
        var events = this._events;
        if (events !== undefined) {
            var evlistener = events[type];
            if (typeof evlistener === 'function') return 1;
            else if (evlistener !== undefined) return evlistener.length;
        }
        return 0;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
    };
    function $4f5409da028b4771$var$arrayClone(arr, n) {
        var copy = new Array(n);
        for(var i = 0; i < n; ++i)copy[i] = arr[i];
        return copy;
    }
    function $4f5409da028b4771$var$spliceOne(list, index) {
        for(; index + 1 < list.length; index++)list[index] = list[index + 1];
        list.pop();
    }
    function $4f5409da028b4771$var$unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    function $4f5409da028b4771$var$once(emitter, name) {
        return new Promise(function(resolve, reject) {
            function errorListener(err) {
                emitter.removeListener(name, resolver);
                reject(err);
            }
            function resolver() {
                if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
                resolve([].slice.call(arguments));
            }
            $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
                once: true
            });
            if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
                once: true
            });
        });
    }
    function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
    }
    function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === 'function') {
            if (flags.once) emitter.once(name, listener);
            else emitter.on(name, listener);
        } else if (typeof emitter.addEventListener === 'function') emitter.addEventListener(name, function wrapListener(arg) {
            if (flags.once) emitter.removeEventListener(name, wrapListener);
            listener(arg);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
    }
});
parcelRegister("4Vcrr", function(module, exports) {
    $parcel$export(module.exports, "useDndScrolling", ()=>$732f795c98aa5910$export$f24f5a2d62841521);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    const $732f795c98aa5910$var$actions = {
        register: (flag)=>({ setState: setState })=>{
                setState({
                    flag: flag
                });
            },
        deregister: (flag)=>({ getState: getState, setState: setState })=>{
                const { flag: currFlag } = getState();
                setState({
                    flag: currFlag === flag ? null : currFlag
                });
            }
    };
    const $732f795c98aa5910$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            flag: null,
            register: (0, ($parcel$interopDefault($8Rkzz))),
            deregister: (0, ($parcel$interopDefault($8Rkzz)))
        },
        actions: $732f795c98aa5910$var$actions,
        name: 'arj-dnd-scrolling'
    });
    const $732f795c98aa5910$export$55bcce90b5832550 = (0, (0, parcelRequire("3sQ5x")).createHook)($732f795c98aa5910$var$Store, {
        selector: (state)=>!!state.flag
    });
    const $732f795c98aa5910$var$getUseDndScrolling = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.flag, (state)=>!!state.flag, (flag, dragging)=>({
            flag: flag,
            dragging: dragging
        }));
    const $732f795c98aa5910$export$f24f5a2d62841521 = (0, (0, parcelRequire("3sQ5x")).createHook)($732f795c98aa5910$var$Store, {
        selector: $732f795c98aa5910$var$getUseDndScrolling
    });
});
parcelRegister("8aPbW", function(module, exports) {
    $parcel$export(module.exports, "content", ()=>$5f36f77feef63580$export$a7db06668cad9adb, (v)=>$5f36f77feef63580$export$a7db06668cad9adb = v);
    $parcel$export(module.exports, "flyoutContent", ()=>$5f36f77feef63580$export$a31680278bdf02a2, (v)=>$5f36f77feef63580$export$a31680278bdf02a2 = v);
    $parcel$export(module.exports, "flyoutPositioner", ()=>$5f36f77feef63580$export$c6ee8e29facfa055, (v)=>$5f36f77feef63580$export$c6ee8e29facfa055 = v);
    $parcel$export(module.exports, "leftHandle", ()=>$5f36f77feef63580$export$498fa52a5bc0ec18, (v)=>$5f36f77feef63580$export$498fa52a5bc0ec18 = v);
    $parcel$export(module.exports, "leftHandleOld", ()=>$5f36f77feef63580$export$459c8ce0b141f7c2, (v)=>$5f36f77feef63580$export$459c8ce0b141f7c2 = v);
    $parcel$export(module.exports, "rightHandle", ()=>$5f36f77feef63580$export$7246006e672c1d3e, (v)=>$5f36f77feef63580$export$7246006e672c1d3e = v);
    $parcel$export(module.exports, "rightHandleOld", ()=>$5f36f77feef63580$export$f2830205eb42d5c, (v)=>$5f36f77feef63580$export$f2830205eb42d5c = v);
    $parcel$export(module.exports, "spaBar", ()=>$5f36f77feef63580$export$4323fff098116d3, (v)=>$5f36f77feef63580$export$4323fff098116d3 = v);
    $parcel$export(module.exports, "stripes", ()=>$5f36f77feef63580$export$4921342e9e13259b, (v)=>$5f36f77feef63580$export$4921342e9e13259b = v);
    var $5f36f77feef63580$export$a7db06668cad9adb;
    var $5f36f77feef63580$export$a31680278bdf02a2;
    var $5f36f77feef63580$export$c6ee8e29facfa055;
    var $5f36f77feef63580$export$498fa52a5bc0ec18;
    var $5f36f77feef63580$export$459c8ce0b141f7c2;
    var $5f36f77feef63580$export$7246006e672c1d3e;
    var $5f36f77feef63580$export$f2830205eb42d5c;
    var $5f36f77feef63580$export$4323fff098116d3;
    var $5f36f77feef63580$export$4921342e9e13259b;
    $5f36f77feef63580$export$a7db06668cad9adb = `X8NtBq_content`;
    $5f36f77feef63580$export$a31680278bdf02a2 = `X8NtBq_flyoutContent`;
    $5f36f77feef63580$export$c6ee8e29facfa055 = `X8NtBq_flyoutPositioner`;
    $5f36f77feef63580$export$498fa52a5bc0ec18 = `X8NtBq_leftHandle`;
    $5f36f77feef63580$export$459c8ce0b141f7c2 = `X8NtBq_leftHandleOld`;
    $5f36f77feef63580$export$7246006e672c1d3e = `X8NtBq_rightHandle`;
    $5f36f77feef63580$export$f2830205eb42d5c = `X8NtBq_rightHandleOld`;
    $5f36f77feef63580$export$4323fff098116d3 = `X8NtBq_spaBar`;
    $5f36f77feef63580$export$4921342e9e13259b = `X8NtBq_stripes`;
});
parcelRegister("5XfGu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a920d8e6e6d90e23$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8RXs9;
    var $gh61P;
    var $aipk9;
    var $4nDwW = parcelRequire("4nDwW");
    var $ibTCY = parcelRequire("ibTCY");
    var $atgyI = parcelRequire("atgyI");
    class $a920d8e6e6d90e23$var$DateFieldView extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {};
        }
        render() {
            const { startOrEnd: startOrEnd, date: date, isRolledUpValue: isRolledUpValue, intl: intl } = this.props;
            let formattedDate;
            if (!(0, $4nDwW.isDefined)(date)) {
                if (startOrEnd === 'start') formattedDate = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ibTCY.default).noStartDate);
                else formattedDate = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ibTCY.default).noEndDate);
            } else formattedDate = (0, (0, parcelRequire("aipk9")).formatTimestampWithIntl)(intl, date, (0, (0, parcelRequire("gh61P")).weekdayFormat));
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $atgyI.dateField,
                "data-testId": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.date-field.date-field"
            }, isRolledUpValue === true && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ibTCY.default).rolledUpLabel), formattedDate);
        }
    }
    var $a920d8e6e6d90e23$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($a920d8e6e6d90e23$var$DateFieldView);
});
parcelRegister("ibTCY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56c1ae54454a2c96$export$2e2bcd8739ae039);
    var $7VHMR;
    const $56c1ae54454a2c96$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noStartDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.date-field.no-start-date",
            "defaultMessage": "No start date"
        },
        noEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.date-field.no-end-date",
            "defaultMessage": "No end date"
        },
        rolledUpLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.date-field.rolled-up-label",
            "defaultMessage": "Rolled up: "
        }
    });
    var $56c1ae54454a2c96$export$2e2bcd8739ae039 = $56c1ae54454a2c96$var$messages;
});
parcelRegister("atgyI", function(module, exports) {
    $parcel$export(module.exports, "dateField", ()=>$79f9751606964eda$export$9bbb5c84017f041b, (v)=>$79f9751606964eda$export$9bbb5c84017f041b = v);
    var $79f9751606964eda$export$9bbb5c84017f041b;
    $79f9751606964eda$export$9bbb5c84017f041b = `Kx8ltq_dateField`;
});
parcelRegister("isUDB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d86da1eef7a8839$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $co1wz;
    var $7mPT9;
    var $hE4fC;
    var $6muhj = parcelRequire("6muhj");
    var $ghuWo = parcelRequire("ghuWo");
    function $8d86da1eef7a8839$var$DateTooltip({ children: children, datePosition: datePosition, width: width }) {
        const [containerWidth, setContainerWidth] = (0, $5uXOq.useState)(0);
        const [{ viewport: viewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [{ pxToMs: pxToMs }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        const visible = (0, $ghuWo.useTooltipVisibility)();
        const elementRef = (0, $5uXOq.useRef)(null);
        const { leftPositionPercentage: leftPositionPercentage, rightPositionPercentage: rightPositionPercentage } = datePosition;
        const [{ getPercentageOffset: getPercentageOffset }] = (0, (0, parcelRequire("hE4fC")).useHorizontalPercentageOffset)();
        const viewportLeftPercentageOffset = getPercentageOffset(viewport.offset);
        const viewportRightPercentageOffset = getPercentageOffset(viewport.offset + pxToMs(viewport.width));
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const isScrollableTimeline = zoomLevel !== undefined;
        const style = (0, $ghuWo.getTooltipStyle)(leftPositionPercentage, rightPositionPercentage, width, containerWidth, viewportLeftPercentageOffset, viewportRightPercentageOffset, isScrollableTimeline);
        (0, $5uXOq.useEffect)(()=>{
            const el = elementRef.current;
            if (!el) return;
            const children = el.children;
            let width = 0;
            Array.from(children).forEach((child)=>{
                if (child instanceof HTMLElement) width += child.offsetWidth;
            });
            setContainerWidth(width);
        }, []);
        if (!visible) return null;
        if ((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            placement: "bottom",
            isOpen: true,
            autoFocus: false,
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $6muhj.dateTooltipContent
                }, children),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    key: style.left,
                    ...triggerProps,
                    ref: (0, (0, parcelRequire("7mPT9")).default)(triggerProps.ref, elementRef),
                    className: $6muhj.dateTooltipTrigger,
                    style: style
                }, children)
        });
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: elementRef,
            className: $6muhj.dateTooltip,
            style: style
        }, children));
    }
    var $8d86da1eef7a8839$export$2e2bcd8739ae039 = $8d86da1eef7a8839$var$DateTooltip;
});
parcelRegister("6muhj", function(module, exports) {
    $parcel$export(module.exports, "dateTooltip", ()=>$4a1c48c3ac7e7a10$export$a944350923249b5b, (v)=>$4a1c48c3ac7e7a10$export$a944350923249b5b = v);
    $parcel$export(module.exports, "dateTooltipContent", ()=>$4a1c48c3ac7e7a10$export$1d63f0c789a74b03, (v)=>$4a1c48c3ac7e7a10$export$1d63f0c789a74b03 = v);
    $parcel$export(module.exports, "dateTooltipTrigger", ()=>$4a1c48c3ac7e7a10$export$6e652c6edd54ebb7, (v)=>$4a1c48c3ac7e7a10$export$6e652c6edd54ebb7 = v);
    var $4a1c48c3ac7e7a10$export$a944350923249b5b;
    var $4a1c48c3ac7e7a10$export$1d63f0c789a74b03;
    var $4a1c48c3ac7e7a10$export$6e652c6edd54ebb7;
    $4a1c48c3ac7e7a10$export$a944350923249b5b = `NRG5Ra_dateTooltip`;
    $4a1c48c3ac7e7a10$export$1d63f0c789a74b03 = `NRG5Ra_dateTooltipContent`;
    $4a1c48c3ac7e7a10$export$6e652c6edd54ebb7 = `NRG5Ra_dateTooltipTrigger`;
});
parcelRegister("ghuWo", function(module, exports) {
    $parcel$export(module.exports, "getTooltipStyle", ()=>$5c761c50af2beba1$export$931b35c41e37e48f);
    $parcel$export(module.exports, "useTooltipVisibility", ()=>$5c761c50af2beba1$export$d047e971555191a);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $co1wz;
    var $hE4fC;
    var $2EwIC;
    const $5c761c50af2beba1$export$931b35c41e37e48f = (leftPercentage, rightPercentage, width, tooltipWidth, minimumPercentageOffset, maximumPercentageOffset, isScrollableTimeline)=>{
        const leftPositionPercentage = !isScrollableTimeline ? Math.max(leftPercentage, 0) : Math.max(leftPercentage, minimumPercentageOffset);
        const rightPositionPercentage = !isScrollableTimeline ? Math.max(rightPercentage, 0) : Math.max(rightPercentage, 100 - maximumPercentageOffset);
        const barWidthPercentage = 100 - (leftPositionPercentage + rightPositionPercentage);
        const containerWidthPercentage = Math.max(tooltipWidth / width * 100, barWidthPercentage);
        const middlePositionPercentage = leftPositionPercentage + barWidthPercentage / 2;
        const containerLeftPositionPercentage = !isScrollableTimeline ? Math.max(0, middlePositionPercentage - containerWidthPercentage / 2) : Math.max(minimumPercentageOffset, middlePositionPercentage - containerWidthPercentage / 2);
        let left;
        let right;
        if (!isScrollableTimeline && containerLeftPositionPercentage + containerWidthPercentage > 100) right = 0;
        else if (isScrollableTimeline && containerLeftPositionPercentage + containerWidthPercentage > maximumPercentageOffset) left = `calc(${maximumPercentageOffset - containerWidthPercentage}%)`;
        else left = `calc(${containerLeftPositionPercentage}%)`;
        return {
            left: left,
            right: right,
            minWidth: `calc(${containerWidthPercentage}%)`
        };
    };
    const $5c761c50af2beba1$export$5599038246f6e670 = ()=>{
        const [{ viewport: viewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [visible, setVisible] = (0, $5uXOq.useState)(true);
        const lastOffsetRef = (0, $5uXOq.useRef)(viewport.offset);
        const show = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($lFKmC)))(()=>{
            setVisible(true);
        }, 100)).current;
        (0, $5uXOq.useEffect)(()=>{
            if (viewport.offset !== lastOffsetRef.current) {
                setVisible(false);
                show();
                lastOffsetRef.current = viewport.offset;
            }
        }, [
            viewport.offset,
            show
        ]);
        return visible;
    };
    const $5c761c50af2beba1$export$c4704fb58bd24b23 = ()=>{
        const [isScrollingX, setIsScrollingX] = (0, $5uXOq.useState)(false);
        const [scrollX] = (0, (0, parcelRequire("2EwIC")).useScrollX)();
        const [isScrollingY] = (0, (0, parcelRequire("2EwIC")).useIsScrollingY)();
        const lastScrollXRef = (0, $5uXOq.useRef)(scrollX);
        const show = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(()=>{
                setIsScrollingX(false);
            }, 100), []);
        (0, $5uXOq.useEffect)(()=>{
            if (scrollX !== lastScrollXRef.current) {
                setIsScrollingX(true);
                show();
                lastScrollXRef.current = scrollX;
            }
        }, [
            scrollX,
            show
        ]);
        return !isScrollingX && !isScrollingY;
    };
    const $5c761c50af2beba1$export$d047e971555191a = (...args)=>(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? $5c761c50af2beba1$export$c4704fb58bd24b23(...args) : $5c761c50af2beba1$export$5599038246f6e670(...args);
});
parcelRegister("c3ZJn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d86079b8f75f6c9$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hcGy1 = parcelRequire("hcGy1");
    var $6s5e8 = parcelRequire("6s5e8");
    var $5d86079b8f75f6c9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hcGy1.default), {})((0, $6s5e8.default));
});
parcelRegister("hcGy1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69d1984d9e434182$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $fKdeq = parcelRequire("fKdeq");
    var $iIikD = parcelRequire("iIikD");
    var $ddv1K = parcelRequire("ddv1K");
    var $7ppNi = parcelRequire("7ppNi");
    var $bHTqr = parcelRequire("bHTqr");
    var $jLI87 = parcelRequire("jLI87");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $69d1984d9e434182$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        externalIssues: (0, $fKdeq.getExternalIssues),
        issueStatusById: (0, $7ppNi.getIssueStatusById),
        isEditMode: $1CGdp.isEditMode,
        isExportMode: $1CGdp.isExportMode,
        isOptimizedMode: $1CGdp.isOptimizedMode,
        issuesWithOptimizedById: (0, $jLI87.getAllIssuesWithOriginalAndOptimizedById),
        filterValue: (state)=>(0, $iIikD.getFilters)(state)[0, $cGbfF.DEPENDENCIES_FILTER_ID].value,
        syncStartEnabled: (0, $bHTqr.getSyncStartEnabled),
        issueLinkTypes: (0, $ddv1K.getDependencyIssueLinkTypes),
        issueCountByLinkType: (0, $ddv1K.getIssueCountByLinkType)
    });
});
parcelRegister("6s5e8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8711a48ca9cefb98$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9lMrf;
    var $7WxSP;
    var $koVbs;
    var $gJZ5D;
    var $1zlQp;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $bss4T = parcelRequire("bss4T");
    var $hN99O = parcelRequire("hN99O");
    var $bxoJu = parcelRequire("bxoJu");
    var $j76lX = parcelRequire("j76lX");
    const $8711a48ca9cefb98$var$BADGE_WIDTH = 16;
    const $8711a48ca9cefb98$var$MINIMUM_BAR_FREE_SPACE = 2;
    const $8711a48ca9cefb98$var$BADGE_MAX = 99;
    const $8711a48ca9cefb98$var$getBadgeColouring = (barColor, barColors, badgeAppearance)=>{
        let badgeColor = barColor || `var(--ds-icon-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N100})`;
        if (barColors && barColors.length === 1) badgeColor = barColors[0].colour;
        else if (barColors && barColors.length > 1) badgeColor = 'transparent';
        let textColor = `var(--ds-text-inverse, ${(0, (0, parcelRequire("gJZ5D")).default).N0})`;
        if (badgeAppearance === 'offtrack') {
            badgeColor = `var(--ds-background-danger, ${(0, (0, parcelRequire("gJZ5D")).default).R50})`;
            textColor = `var(--ds-text-danger, ${(0, (0, parcelRequire("gJZ5D")).default).R500})`;
        }
        return {
            badgeColor: badgeColor,
            textColor: textColor
        };
    };
    const $8711a48ca9cefb98$export$fa91929c07a03360 = (externalIssues, issue, issuesWithOptimizedById, issueStatusById, isOptimizedMode, startOrEnd, syncStartEnabled, internalIssueLinks, externalIssueLinks)=>{
        let badgeAppearance = 'none';
        if (internalIssueLinks.length + externalIssueLinks.length) badgeAppearance = (0, $bss4T.isDependencyOverlapping)(startOrEnd, issue, internalIssueLinks, issuesWithOptimizedById, issueStatusById, isOptimizedMode, syncStartEnabled) || (0, $bss4T.isExternalDependencyOverlapping)(startOrEnd, issue, issueStatusById, externalIssueLinks, externalIssues, issuesWithOptimizedById, isOptimizedMode, syncStartEnabled) ? 'offtrack' : 'default';
        return badgeAppearance;
    };
    const $8711a48ca9cefb98$var$getLinkCount = (startOrEnd, internalIncomingLinks, externalIncomingLinks, internalOutgoingLinks, externalOutgoingLinks)=>{
        let linkCount = 0;
        if (startOrEnd === 'start') {
            linkCount += internalIncomingLinks ? internalIncomingLinks.length : 0;
            linkCount += externalIncomingLinks ? externalIncomingLinks.length : 0;
        } else {
            linkCount += internalOutgoingLinks ? internalOutgoingLinks.length : 0;
            linkCount += externalOutgoingLinks ? externalOutgoingLinks.length : 0;
        }
        return linkCount;
    };
    const $8711a48ca9cefb98$var$getBarWideEnough = (hasHiddenIncomingDependency, hasHiddenOutgoingDependency, barWidth)=>{
        let barWideEnoughForVisibleBadge = true;
        if (hasHiddenIncomingDependency && hasHiddenOutgoingDependency && barWidth < ($8711a48ca9cefb98$var$BADGE_WIDTH + $8711a48ca9cefb98$var$MINIMUM_BAR_FREE_SPACE) * 2) barWideEnoughForVisibleBadge = false;
        else if ((hasHiddenIncomingDependency || hasHiddenOutgoingDependency) && barWidth < $8711a48ca9cefb98$var$BADGE_WIDTH + $8711a48ca9cefb98$var$MINIMUM_BAR_FREE_SPACE) barWideEnoughForVisibleBadge = false;
        return barWideEnoughForVisibleBadge;
    };
    function $8711a48ca9cefb98$export$2e2bcd8739ae039({ startOrEnd: startOrEnd, datePosition: datePosition, width: width, issue: issue, externalIssues: externalIssues, externalOutgoingLinks: externalOutgoingLinks, externalIncomingLinks: externalIncomingLinks, internalOutgoingLinks: internalOutgoingLinks, internalIncomingLinks: internalIncomingLinks, direction: direction, issuesWithOptimizedById: issuesWithOptimizedById, issueStatusById: issueStatusById, isHovered: isHovered, isEditMode: isEditMode, isExportMode: isExportMode, isOptimizedMode: isOptimizedMode, syncStartEnabled: syncStartEnabled, issueCountByLinkType: issueCountByLinkType, issueLinkTypes: issueLinkTypes, barColors: barColors, barColor: barColor }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [dependencyLines] = (0, (0, parcelRequire("1zlQp")).useDependencyLines)();
        const [{ display: display }] = (0, (0, parcelRequire("1zlQp")).useDependencySettings)();
        const externalIssueLinks = externalOutgoingLinks || externalIncomingLinks || [];
        const internalIssueLinks = internalOutgoingLinks || internalIncomingLinks || [];
        const addIconShowing = internalIssueLinks.length + externalIssueLinks.length === 0;
        const canAddDependency = isEditMode;
        const defaultIssueLinkType = (0, $j76lX.getDefaultIssueLinkTypeId)(issueLinkTypes);
        if (addIconShowing && !canAddDependency) return null;
        const badgeAppearance = $8711a48ca9cefb98$export$fa91929c07a03360(externalIssues, issue, issuesWithOptimizedById, issueStatusById, isOptimizedMode, startOrEnd, syncStartEnabled, internalIssueLinks, externalIssueLinks);
        const linkCount = $8711a48ca9cefb98$var$getLinkCount(startOrEnd, internalIncomingLinks, externalIncomingLinks, internalOutgoingLinks, externalOutgoingLinks);
        const isLinked = linkCount > 0;
        const hasHiddenOutgoingDependency = dependencyLines !== null && dependencyLines.filter(({ fromIssue: fromIssue, drawable: drawable })=>fromIssue.id === issue.id && drawable).length < linkCount;
        const hasHiddenIncomingDependency = dependencyLines !== null && dependencyLines.filter(({ toIssue: toIssue, drawable: drawable })=>toIssue.id === issue.id && drawable).length < linkCount;
        const { leftPositionPercentage: leftPositionPercentage, rightPositionPercentage: rightPositionPercentage } = datePosition;
        const rightPositionPercentageFromLeftPerspective = rightPositionPercentage * -1 + 100;
        const barWidth = Math.abs(rightPositionPercentageFromLeftPerspective - leftPositionPercentage) * width / 100;
        const barWideEnoughForVisibleBadge = $8711a48ca9cefb98$var$getBarWideEnough(hasHiddenIncomingDependency, hasHiddenOutgoingDependency, barWidth);
        const hasHiddenDependency = startOrEnd === 'start' && hasHiddenIncomingDependency || startOrEnd === 'end' && hasHiddenOutgoingDependency;
        const visibleWhenInactive = isLinked && barWideEnoughForVisibleBadge && (externalIssueLinks.length > 0 || hasHiddenDependency || display !== (0, $TTKUQ.LINES));
        const { badgeColor: badgeColor, textColor: textColor } = $8711a48ca9cefb98$var$getBadgeColouring(barColor, barColors, badgeAppearance);
        const badgeContent = (()=>{
            if (!isLinked) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: "",
                size: "small"
            });
            if (display === (0, $TTKUQ.COUNT)) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $bxoJu["badge-count"],
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.dependency-marker.badge-count"
            }, linkCount > $8711a48ca9cefb98$var$BADGE_MAX ? `${$8711a48ca9cefb98$var$BADGE_MAX}+` : linkCount);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7WxSP"))))), {
                label: (0, $j76lX.getDependencyLabel)(startOrEnd, formatMessage),
                size: "small"
            });
        })();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hN99O.default), {
            containerWidth: width,
            direction: direction,
            issue: issue,
            issueBarPosition: datePosition,
            appearance: badgeAppearance,
            position: startOrEnd,
            visibleWhenInactive: visibleWhenInactive,
            active: isHovered,
            badgeColor: badgeColor,
            textColor: textColor,
            issueCountByLinkType: issueCountByLinkType,
            iconType: !isLinked ? 'add-icon' : 'link-icon',
            issueLinkType: defaultIssueLinkType,
            isEditMode: isEditMode,
            isExportMode: isExportMode
        }, badgeContent);
    }
});
parcelRegister("7WxSP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5c883bb6fff27f31$var$_react = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5c883bb6fff27f31$var$_link = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $5c883bb6fff27f31$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5c883bb6fff27f31$var$EditorLinkIcon = (props)=>$5c883bb6fff27f31$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
        }, props, {
            newIcon: $5c883bb6fff27f31$var$_link.default
        }));
    $5c883bb6fff27f31$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
    var $5c883bb6fff27f31$var$_default = module.exports.default = $5c883bb6fff27f31$var$EditorLinkIcon;
});
parcelRegister("1zlQp", function(module, exports) {
    $parcel$export(module.exports, "DependencyLineContainer", ()=>$445ed8c2e8fb1813$export$cf2792569d5a5a20);
    $parcel$export(module.exports, "useDependencyLines", ()=>$445ed8c2e8fb1813$export$17dd40a5d02411f0);
    $parcel$export(module.exports, "useActiveLine", ()=>$445ed8c2e8fb1813$export$d49c1f035142bd61);
    $parcel$export(module.exports, "useDependencySettings", ()=>$445ed8c2e8fb1813$export$1ec9eab8919ada08);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $cu7KL;
    const $445ed8c2e8fb1813$var$actions = {
        setActiveLine: (activeLine)=>({ setState: setState })=>{
                setState({
                    activeLine: activeLine
                });
            }
    };
    const $445ed8c2e8fb1813$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            dependencyLines: [],
            dependencySettings: {
                display: (0, (0, parcelRequire("cu7KL")).DEPENDENCY_SETTINGS).DEFAULT
            },
            activeLine: null
        },
        actions: $445ed8c2e8fb1813$var$actions,
        name: 'arj-dependency-lines'
    });
    const $445ed8c2e8fb1813$var$hydrateContainer = ()=>({ setState: setState }, { dependencyLines: dependencyLines, dependencySettings: dependencySettings })=>{
            setState({
                dependencyLines: dependencyLines,
                dependencySettings: dependencySettings
            });
        };
    const $445ed8c2e8fb1813$export$cf2792569d5a5a20 = (0, (0, parcelRequire("gg7kZ")).createContainer)($445ed8c2e8fb1813$var$Store, {
        onInit: $445ed8c2e8fb1813$var$hydrateContainer,
        onUpdate: $445ed8c2e8fb1813$var$hydrateContainer
    });
    const $445ed8c2e8fb1813$export$17dd40a5d02411f0 = (0, (0, parcelRequire("3sQ5x")).createHook)($445ed8c2e8fb1813$var$Store, {
        selector: (state)=>state.dependencyLines
    });
    const $445ed8c2e8fb1813$export$d49c1f035142bd61 = (0, (0, parcelRequire("3sQ5x")).createHook)($445ed8c2e8fb1813$var$Store, {
        selector: (state)=>state.activeLine
    });
    const $445ed8c2e8fb1813$export$1ec9eab8919ada08 = (0, (0, parcelRequire("3sQ5x")).createHook)($445ed8c2e8fb1813$var$Store, {
        selector: (state)=>state.dependencySettings
    });
});
parcelRegister("cu7KL", function(module, exports) {
    $parcel$export(module.exports, "DEPENDENCY_SETTINGS", ()=>$d66aaf4ffd2dfbdc$export$37e30ab04b9b1705);
    const $d66aaf4ffd2dfbdc$export$e6952b12ade67489 = 'default';
    const $d66aaf4ffd2dfbdc$export$e0de529f548a9140 = 'lines';
    const $d66aaf4ffd2dfbdc$export$d61684373eacdf61 = 'count';
    const $d66aaf4ffd2dfbdc$export$37e30ab04b9b1705 = {
        DEFAULT: $d66aaf4ffd2dfbdc$export$e6952b12ade67489,
        LINES: $d66aaf4ffd2dfbdc$export$e0de529f548a9140,
        COUNT: $d66aaf4ffd2dfbdc$export$d61684373eacdf61
    };
});
parcelRegister("bss4T", function(module, exports) {
    $parcel$export(module.exports, "isDependencyOverlapping", ()=>$4b33d3306e18c6c5$export$7a673214530cb93d);
    $parcel$export(module.exports, "isExternalDependencyOverlapping", ()=>$4b33d3306e18c6c5$export$f005db951de8e262);
    var $aDKIU = parcelRequire("aDKIU");
    var $kqF3Q = parcelRequire("kqF3Q");
    const $4b33d3306e18c6c5$export$7a673214530cb93d = (position, issue, internalIssueLinks, issuesWithOptimizedById, issueStatusById, isOptimizedMode, syncStartEnabled)=>{
        if (position === 'start') return internalIssueLinks.some(({ sourceItemKey: sourceItemKey })=>{
            const sourceIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[sourceItemKey], isOptimizedMode);
            const targetIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], isOptimizedMode);
            return (0, $aDKIU.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
        });
        return internalIssueLinks.some(({ targetItemKey: targetItemKey })=>{
            const sourceIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], isOptimizedMode);
            const targetIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[targetItemKey], isOptimizedMode);
            return (0, $aDKIU.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
        });
    };
    const $4b33d3306e18c6c5$export$f005db951de8e262 = (position, issue, issueStatusById, externalIssueLinks, externalIssues, issuesWithOptimizedById, isOptimizedMode, syncStartEnabled)=>{
        if (position === 'start') return externalIssueLinks.some(({ sourceItemKey: sourceItemKey })=>{
            const targetIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], isOptimizedMode);
            const sourceIssue = externalIssues[sourceItemKey];
            return (0, $aDKIU.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
        });
        return externalIssueLinks.some(({ targetItemKey: targetItemKey })=>{
            const sourceIssue = (0, $kqF3Q.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], isOptimizedMode);
            const targetIssue = externalIssues[targetItemKey];
            return (0, $aDKIU.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
        });
    };
});
parcelRegister("hN99O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2283f6953d600480$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $co1wz;
    var $4R6GH;
    var $gJZ5D;
    var $4cSmd = parcelRequire("4cSmd");
    var $mtNJ0 = parcelRequire("mtNJ0");
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $dCm1o;
    var $doa6b = parcelRequire("doa6b");
    var $2rAjB = parcelRequire("2rAjB");
    var $agny7 = parcelRequire("agny7");
    function $2283f6953d600480$export$2e2bcd8739ae039({ containerWidth: containerWidth, active: active, visibleWhenInactive: visibleWhenInactive, issue: issue, issueBarPosition: issueBarPosition, direction: direction, appearance: appearance, position: position, badgeColor: badgeColor, textColor: textColor, children: children, iconType: iconType, issueLinkType: issueLinkType, issueCountByLinkType: issueCountByLinkType, isEditMode: isEditMode, isExportMode: isExportMode }) {
        const hitboxRef = (0, $5uXOq.useRef)(null);
        const domRef = (0, $5uXOq.useRef)(null);
        const { open: openFlyout } = (0, $4cSmd.useDependenciesFlyout)();
        const { dragSource: dragSource } = (0, $mtNJ0.useDepLinesDrag)();
        const handleDrop = (0, $agny7.useDropHandling)({
            issueCountByLinkType: issueCountByLinkType,
            issueLinkType: issueLinkType
        });
        const { handleMouseDown: handleMouseDown } = (0, $agny7.useDragHandling)({
            direction: direction,
            onDrop: handleDrop,
            isEditMode: isEditMode
        });
        const isActive = (0, $agny7.useIsActive)({
            issue: issue,
            direction: direction,
            force: active
        });
        const handleClick = ()=>{
            const triggerEl = domRef.current;
            if (triggerEl == null) return;
            openFlyout({
                direction: direction,
                issue: issue
            }, triggerEl);
        };
        const backgroundColor = badgeColor === 'transparent' && active ? `var(--ds-icon-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N100})` : badgeColor;
        const pointerEvents = isActive ? 'inherit' : 'none';
        const opacity = isActive || visibleWhenInactive ? 1 : 0;
        const cursor = 'pointer';
        const withZIndexOverride = (children)=>{
            if (!(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2')) return children(undefined);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
                layer: (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS
            }, (zIndex)=>children(zIndex ?? 'initial'));
        };
        if ((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2')) {
            const dragPreview = (0, $agny7.useDragPreview)(hitboxRef.current, containerWidth, position, issueBarPosition, issueLinkType, isEditMode);
            if (dragPreview) return null;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $doa6b.default), {
            containerWidth: containerWidth ?? 0,
            startOrEnd: position,
            issueBarPosition: issueBarPosition,
            active: isActive
        }, ({ translateX: translateX, left: left })=>withZIndexOverride((zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: hitboxRef,
                    className: (0, ($parcel$interopDefault($9ci4W)))({
                        [$2rAjB['hitbox-left']]: position === 'start',
                        [$2rAjB['hitbox-right']]: position === 'end'
                    }),
                    style: {
                        opacity: opacity,
                        transform: translateX !== null ? `translateX(${translateX}px)` : undefined,
                        transition: translateX !== null ? '0.2s' : undefined,
                        transitionProperty: 'opacity, transform',
                        position: 'absolute',
                        left: left,
                        marginTop: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? undefined : "var(--ds-space-025, 2px)",
                        zIndex: zIndex ?? (isExportMode ? 4 : 3)
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: domRef,
                    className: (0, ($parcel$interopDefault($9ci4W)))((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? $2rAjB.marker : $2rAjB.markerOld, $2rAjB[`marker-${appearance}`], {
                        [$2rAjB['marker-dragging']]: !!dragSource
                    }),
                    style: {
                        pointerEvents: pointerEvents,
                        backgroundColor: backgroundColor,
                        cursor: cursor,
                        color: textColor
                    },
                    onMouseDown: handleMouseDown,
                    onClick: handleClick,
                    role: "button",
                    onKeyDown: ()=>{},
                    tabIndex: 0,
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.dependency-marker.marker-badge.${issue.id}-${position}-${iconType}`
                }, children))));
    }
});
parcelRegister("doa6b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb426fc377f59ff8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $dCm1o;
    var $5zZA7 = parcelRequire("5zZA7");
    function $bb426fc377f59ff8$export$2e2bcd8739ae039({ containerWidth: containerWidth, startOrEnd: startOrEnd, issueBarPosition: issueBarPosition, active: active, children: children }) {
        const offsets = (0, $5zZA7.useOffsets)({
            containerWidth: containerWidth ?? 0,
            width: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? 24 : 16,
            startOrEnd: startOrEnd,
            issueBar: issueBarPosition
        });
        if (offsets == null) return null;
        const { offsetActive: offsetActive, offsetInactive: offsetInactive } = offsets;
        const translateX = active ? offsetActive - offsetInactive : 0;
        const left = offsetInactive;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children({
            left: left,
            translateX: translateX
        }));
    }
});
parcelRegister("5zZA7", function(module, exports) {
    $parcel$export(module.exports, "useOffsets", ()=>$f264a3ed7bb8fb5b$export$139bcd1caa46c880);
    var $hE4fC;
    var $6dDSs;
    const $f264a3ed7bb8fb5b$var$SCROLLBAR_WIDTH = 18;
    const $f264a3ed7bb8fb5b$var$SPACING = 4;
    const $f264a3ed7bb8fb5b$var$ARROW_WIDTH = 24;
    const $f264a3ed7bb8fb5b$var$useViewportWidth = (0, (0, parcelRequire("hE4fC")).createHorizontalScrollingHook)((0, (0, parcelRequire("6dDSs")).createSelector)((_, fallback)=>fallback, (state)=>state.zoomLevel, (state)=>state.viewport.width, (fallback, zoomLevel, viewportWidth)=>zoomLevel === undefined ? fallback : viewportWidth));
    const $f264a3ed7bb8fb5b$var$useViewportOffset = (0, (0, parcelRequire("hE4fC")).createHorizontalScrollingHook)((0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.zoomLevel, (state)=>state.viewport.offset, (zoomLevel, viewportOffset)=>zoomLevel === undefined ? 0 : viewportOffset));
    function $f264a3ed7bb8fb5b$var$flip(position) {
        return {
            left: position.right,
            right: position.left
        };
    }
    function $f264a3ed7bb8fb5b$var$useIssueBarPosition({ viewportWidth: viewportWidth, issueBarPercentagePosition: { leftPositionPercentage: leftPositionPercentage, rightPositionPercentage: rightPositionPercentage } }) {
        const [{ zoomLevel: zoomLevel, viewport: viewport, container: container }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [{ msToPx: msToPx }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        if (zoomLevel === undefined) {
            const left = leftPositionPercentage / 100 * viewportWidth;
            const right = rightPositionPercentage / 100 * viewportWidth;
            return {
                left: left,
                right: right
            };
        }
        const viewportOffsetInPx = msToPx(viewport.offset);
        const distanceToContainerStart = leftPositionPercentage / 100 * container.width;
        const distanceToContainerEnd = rightPositionPercentage / 100 * container.width;
        const width = container.width - (distanceToContainerEnd + distanceToContainerStart);
        const left = distanceToContainerStart - viewportOffsetInPx;
        const right = viewportWidth - (left + width);
        return {
            left: left,
            right: right
        };
    }
    function $f264a3ed7bb8fb5b$var$getLeftBadgeActivePosition({ viewportWidth: viewportWidth, badgeWidth: badgeWidth, issueBar: issueBar, constraints: constraints }) {
        if (issueBar.left === undefined || issueBar.right === undefined) throw new Error('illegal state of issue bar position');
        const hasRightArrow = issueBar.right < 0;
        const maxBarMarginLeft = viewportWidth - ((hasRightArrow ? $f264a3ed7bb8fb5b$var$ARROW_WIDTH : 0) + constraints.right);
        if (issueBar.left >= viewportWidth) return null;
        if (issueBar.left >= badgeWidth + $f264a3ed7bb8fb5b$var$SPACING + constraints.left) return {
            left: Math.min(issueBar.left, maxBarMarginLeft) + -badgeWidth + -$f264a3ed7bb8fb5b$var$SPACING,
            right: NaN
        };
        const issueBarInnerSpace = viewportWidth + -(Math.max(issueBar.left, constraints.left) + Math.max(issueBar.right, constraints.right));
        if (issueBar.left >= constraints.left && issueBarInnerSpace >= badgeWidth + $f264a3ed7bb8fb5b$var$SPACING) return {
            left: issueBar.left + $f264a3ed7bb8fb5b$var$SPACING,
            right: NaN
        };
        if (issueBarInnerSpace >= $f264a3ed7bb8fb5b$var$ARROW_WIDTH + badgeWidth + $f264a3ed7bb8fb5b$var$SPACING) return {
            left: $f264a3ed7bb8fb5b$var$ARROW_WIDTH + $f264a3ed7bb8fb5b$var$SPACING + constraints.left,
            right: NaN
        };
        return null;
    }
    const $f264a3ed7bb8fb5b$var$getRightBadgeActivePosition = (params)=>{
        const result = $f264a3ed7bb8fb5b$var$getLeftBadgeActivePosition({
            ...params,
            issueBar: $f264a3ed7bb8fb5b$var$flip(params.issueBar),
            constraints: $f264a3ed7bb8fb5b$var$flip(params.constraints)
        });
        if (result === null) return null;
        return $f264a3ed7bb8fb5b$var$flip(result);
    };
    const $f264a3ed7bb8fb5b$var$getLeftBadgeInactivePosition = ({ issueBar: issueBar, badgeActive: badgeActive })=>{
        if (badgeActive.left > issueBar.left) return badgeActive;
        return {
            left: issueBar.left + $f264a3ed7bb8fb5b$var$SPACING,
            right: NaN
        };
    };
    const $f264a3ed7bb8fb5b$var$getRightBadgeInactivePosition = (params)=>$f264a3ed7bb8fb5b$var$flip($f264a3ed7bb8fb5b$var$getLeftBadgeInactivePosition({
            ...params,
            issueBar: $f264a3ed7bb8fb5b$var$flip(params.issueBar),
            badgeActive: $f264a3ed7bb8fb5b$var$flip(params.badgeActive)
        }));
    function $f264a3ed7bb8fb5b$var$getOffset(viewportWidth, badgeWidth, { left: left, right: right }) {
        if (Number.isNaN(left) && !Number.isNaN(right)) return viewportWidth - (badgeWidth + right);
        return left;
    }
    const $f264a3ed7bb8fb5b$export$139bcd1caa46c880 = ({ containerWidth: containerWidth, width: badgeWidth, startOrEnd: startOrEnd, issueBar: issueBarPercentagePosition })=>{
        const [viewportWidth] = $f264a3ed7bb8fb5b$var$useViewportWidth(containerWidth);
        const [viewportOffset] = $f264a3ed7bb8fb5b$var$useViewportOffset();
        const [{ msToPx: msToPx }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        const issueBarPosition = $f264a3ed7bb8fb5b$var$useIssueBarPosition({
            viewportWidth: viewportWidth,
            issueBarPercentagePosition: issueBarPercentagePosition
        });
        const getBadgePosition = startOrEnd === 'start' ? $f264a3ed7bb8fb5b$var$getLeftBadgeActivePosition : $f264a3ed7bb8fb5b$var$getRightBadgeActivePosition;
        const badgeActivePosition = getBadgePosition({
            viewportWidth: viewportWidth,
            badgeWidth: badgeWidth,
            issueBar: issueBarPosition,
            constraints: {
                left: 0,
                right: $f264a3ed7bb8fb5b$var$SCROLLBAR_WIDTH
            }
        });
        if (badgeActivePosition === null) return null;
        const getBadgeInactivePosition = startOrEnd === 'start' ? $f264a3ed7bb8fb5b$var$getLeftBadgeInactivePosition : $f264a3ed7bb8fb5b$var$getRightBadgeInactivePosition;
        const badgeInactivePosition = getBadgeInactivePosition({
            issueBar: issueBarPosition,
            badgeActive: badgeActivePosition
        });
        const offsetInactive = msToPx(viewportOffset) + $f264a3ed7bb8fb5b$var$getOffset(viewportWidth, badgeWidth, badgeInactivePosition);
        const offsetActive = msToPx(viewportOffset) + $f264a3ed7bb8fb5b$var$getOffset(viewportWidth, badgeWidth, badgeActivePosition);
        return {
            offsetInactive: offsetInactive,
            offsetActive: offsetActive
        };
    };
});
parcelRegister("2rAjB", function(module, exports) {
    $parcel$export(module.exports, "hitbox-left", ()=>$1c7a45cd539d53af$export$ca87f3b373972501, (v)=>$1c7a45cd539d53af$export$ca87f3b373972501 = v);
    $parcel$export(module.exports, "hitbox-right", ()=>$1c7a45cd539d53af$export$6223214bdaa46a4, (v)=>$1c7a45cd539d53af$export$6223214bdaa46a4 = v);
    $parcel$export(module.exports, "marker", ()=>$1c7a45cd539d53af$export$ffc4d0086f1a4c9, (v)=>$1c7a45cd539d53af$export$ffc4d0086f1a4c9 = v);
    $parcel$export(module.exports, "marker-default", ()=>$1c7a45cd539d53af$export$330307b44ea6a975, (v)=>$1c7a45cd539d53af$export$330307b44ea6a975 = v);
    $parcel$export(module.exports, "marker-dragging", ()=>$1c7a45cd539d53af$export$bc7092cbbc04e7ce, (v)=>$1c7a45cd539d53af$export$bc7092cbbc04e7ce = v);
    $parcel$export(module.exports, "marker-none", ()=>$1c7a45cd539d53af$export$fedc624f91f41bcd, (v)=>$1c7a45cd539d53af$export$fedc624f91f41bcd = v);
    $parcel$export(module.exports, "marker-offtrack", ()=>$1c7a45cd539d53af$export$ffecd4407c0aa5d4, (v)=>$1c7a45cd539d53af$export$ffecd4407c0aa5d4 = v);
    $parcel$export(module.exports, "markerOld", ()=>$1c7a45cd539d53af$export$9275b771bcc84142, (v)=>$1c7a45cd539d53af$export$9275b771bcc84142 = v);
    var $1c7a45cd539d53af$export$ca87f3b373972501;
    var $1c7a45cd539d53af$export$6223214bdaa46a4;
    var $1c7a45cd539d53af$export$ffc4d0086f1a4c9;
    var $1c7a45cd539d53af$export$330307b44ea6a975;
    var $1c7a45cd539d53af$export$bc7092cbbc04e7ce;
    var $1c7a45cd539d53af$export$fedc624f91f41bcd;
    var $1c7a45cd539d53af$export$ffecd4407c0aa5d4;
    var $1c7a45cd539d53af$export$9275b771bcc84142;
    $1c7a45cd539d53af$export$ca87f3b373972501 = `LcPLja_hitbox-left`;
    $1c7a45cd539d53af$export$6223214bdaa46a4 = `LcPLja_hitbox-right`;
    $1c7a45cd539d53af$export$ffc4d0086f1a4c9 = `LcPLja_marker`;
    $1c7a45cd539d53af$export$330307b44ea6a975 = `LcPLja_marker-default`;
    $1c7a45cd539d53af$export$bc7092cbbc04e7ce = `LcPLja_marker-dragging`;
    $1c7a45cd539d53af$export$fedc624f91f41bcd = `LcPLja_marker-none`;
    $1c7a45cd539d53af$export$ffecd4407c0aa5d4 = `LcPLja_marker-offtrack`;
    $1c7a45cd539d53af$export$9275b771bcc84142 = `LcPLja_markerOld`;
});
parcelRegister("agny7", function(module, exports) {
    $parcel$export(module.exports, "useDragHandling", ()=>$148ec5ca016bde07$export$4ce792279e065294);
    $parcel$export(module.exports, "useDropHandling", ()=>$148ec5ca016bde07$export$5048b513d451ea75);
    $parcel$export(module.exports, "useDragPreview", ()=>$148ec5ca016bde07$export$d29bab26291a5c45);
    $parcel$export(module.exports, "useIsActive", ()=>$148ec5ca016bde07$export$3a05005085a96193);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $8vyMo;
    var $i2qlb = parcelRequire("i2qlb");
    var $4cSmd = parcelRequire("4cSmd");
    var $b4Lge = parcelRequire("b4Lge");
    var $mtNJ0 = parcelRequire("mtNJ0");
    var $4Vcrr = parcelRequire("4Vcrr");
    var $4nDwW = parcelRequire("4nDwW");
    var $eT70U;
    var $8zOmE;
    var $2NMNM;
    parcelRequire("2rAjB");
    const $148ec5ca016bde07$var$DND_FLAG = 'DEPENDENCY_MARKER';
    const $148ec5ca016bde07$var$MIN_DRAG_DISTANCE = 2;
    const $148ec5ca016bde07$export$4ce792279e065294 = ({ direction: direction, isEditMode: isEditMode, onDrop: onDrop })=>{
        const [, { register: registerDndScrolling, deregister: deregisterDndScrolling }] = (0, $4Vcrr.useDndScrolling)();
        const { setDragSource: setDragSource } = (0, $mtNJ0.useDepLinesDrag)();
        const { id: dndItemId } = (0, $b4Lge.useDndItem)();
        const handleMouseDown = (0, $5uXOq.useCallback)((e)=>{
            if (!isEditMode) return;
            let dragStarted = false;
            const mousedownOffset = {
                x: e.clientX,
                y: e.clientY
            };
            const handleMouseMove = (e)=>{
                if (!dragStarted && (0, $4nDwW.isDefined)(e.clientX) && (0, $4nDwW.isDefined)(e.clientY) && (Math.abs(e.clientX - mousedownOffset.x) > $148ec5ca016bde07$var$MIN_DRAG_DISTANCE || Math.abs(e.clientY - mousedownOffset.y) > $148ec5ca016bde07$var$MIN_DRAG_DISTANCE)) {
                    setDragSource({
                        rowId: dndItemId,
                        direction: direction
                    });
                    registerDndScrolling($148ec5ca016bde07$var$DND_FLAG);
                    dragStarted = true;
                }
                const event = new CustomEvent('customized.dragmove', {
                    detail: {
                        clientX: e.clientX,
                        clientY: e.clientY
                    }
                });
                window.dispatchEvent(event);
            };
            const handleMouseUp = ()=>{
                onDrop();
                if (dragStarted) {
                    setDragSource(undefined);
                    deregisterDndScrolling($148ec5ca016bde07$var$DND_FLAG);
                    dragStarted = false;
                }
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                document.removeEventListener('keydown', handleEscapeKey);
            };
            const handleEscapeKey = (e)=>{
                if (e.key === 'Escape') handleMouseUp();
            };
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            document.addEventListener('keydown', handleEscapeKey);
        }, [
            isEditMode,
            setDragSource,
            dndItemId,
            direction,
            registerDndScrolling,
            onDrop,
            deregisterDndScrolling
        ]);
        return {
            handleMouseDown: handleMouseDown
        };
    };
    const $148ec5ca016bde07$export$5048b513d451ea75 = ({ issueCountByLinkType: issueCountByLinkType, issueLinkType: issueLinkType })=>{
        const { handleDrop: handleDrop } = (0, $mtNJ0.useDepLinesDrag)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)(()=>{
            const issueLinkAdded = handleDrop({
                issueLinkType: issueLinkType
            });
            if (issueLinkAdded) {
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ADDED_ISSUE_DEPENDENCY_LINK.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                }), {
                    source: 'dnd',
                    type: issueLinkType,
                    typeCount: issueCountByLinkType[issueLinkType] || 0
                });
            }
        }, [
            createAnalyticsEvent,
            handleDrop,
            issueCountByLinkType,
            issueLinkType
        ]);
    };
    const $148ec5ca016bde07$export$d29bab26291a5c45 = (element, containerWidth, position, issueBarPosition, issueLinkType, isEditMode)=>{
        const { row: row } = (0, (0, parcelRequire("eT70U")).useRow)();
        const [hasDragPreview, setHasDragPreview] = (0, $5uXOq.useState)(false);
        const hasDragPreviewRef = (0, $5uXOq.useRef)(false);
        hasDragPreviewRef.current = hasDragPreview;
        (0, $5uXOq.useEffect)(()=>{
            if (!isEditMode && (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) return;
            return (0, (0, parcelRequire("8vyMo")).monitorForDependencyCreate)({
                onDrag: ()=>{
                    if (!hasDragPreviewRef.current) setHasDragPreview(true);
                },
                onDrop: ()=>setHasDragPreview(false)
            });
        }, [
            isEditMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!element || !isEditMode && (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) return;
            return (0, (0, parcelRequire("8vyMo")).draggableForDependencyCreate)({
                element: element,
                getInitialData: ()=>({
                        row: row,
                        position: position,
                        issueLinkType: issueLinkType,
                        horizontalScrollingContainerX: containerWidth * (position === 'start' ? issueBarPosition.leftPositionPercentage / 100 : 1 - issueBarPosition.rightPositionPercentage / 100)
                    })
            });
        }, [
            element,
            containerWidth,
            row,
            position,
            issueLinkType,
            issueBarPosition.leftPositionPercentage,
            issueBarPosition.rightPositionPercentage,
            isEditMode
        ]);
        return hasDragPreview;
    };
    const $148ec5ca016bde07$export$3a05005085a96193 = ({ issue: issue, direction: direction, force: force })=>{
        const { payload: payload } = (0, $4cSmd.useDependenciesFlyout)();
        if (force) return true;
        return payload?.issue.id === issue.id && payload?.direction === direction;
    };
});
parcelRegister("bxoJu", function(module, exports) {
    $parcel$export(module.exports, "badge-count", ()=>$8665f62b3f73a2d3$export$6c2b63e0110f9881, (v)=>$8665f62b3f73a2d3$export$6c2b63e0110f9881 = v);
    var $8665f62b3f73a2d3$export$6c2b63e0110f9881;
    var $8665f62b3f73a2d3$export$b74ff737e0e298b5;
    var $8665f62b3f73a2d3$export$e5ef4f853dad983a;
    var $8665f62b3f73a2d3$export$b3571188c770cc5a;
    var $8665f62b3f73a2d3$export$81e49c35a901b51c;
    $8665f62b3f73a2d3$export$6c2b63e0110f9881 = `_3OyI6W_badge-count`;
    $8665f62b3f73a2d3$export$b74ff737e0e298b5 = `_3OyI6W_dependencies`;
    $8665f62b3f73a2d3$export$e5ef4f853dad983a = `_3OyI6W_hovered`;
    $8665f62b3f73a2d3$export$b3571188c770cc5a = `_3OyI6W_start`;
    $8665f62b3f73a2d3$export$81e49c35a901b51c = `_3OyI6W_unhovered`;
});
parcelRegister("j76lX", function(module, exports) {
    $parcel$export(module.exports, "getDefaultIssueLinkTypeId", ()=>$fb38a0dd5412ec88$export$e7c0c9614deed0c);
    $parcel$export(module.exports, "getDependencyLabel", ()=>$fb38a0dd5412ec88$export$9d7e3ea957ff570a);
    var $dMvUa = parcelRequire("dMvUa");
    const $fb38a0dd5412ec88$var$DEFAULT_ISSUE_LINK_TYPE = 10000;
    const $fb38a0dd5412ec88$export$e7c0c9614deed0c = (issueLinkTypes)=>issueLinkTypes.length > 0 ? issueLinkTypes[0].id : $fb38a0dd5412ec88$var$DEFAULT_ISSUE_LINK_TYPE;
    const $fb38a0dd5412ec88$export$9d7e3ea957ff570a = (startOrEnd, formatMessage)=>startOrEnd === 'start' ? formatMessage((0, $dMvUa.default).startDependency) : formatMessage((0, $dMvUa.default).endDependency);
});
parcelRegister("dMvUa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6968e87058a3eac9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6968e87058a3eac9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        startDependency: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.dependency-marker.start-dependency",
            "defaultMessage": "Start dependency"
        },
        endDependency: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.dependency-marker.end-dependency",
            "defaultMessage": "End dependency"
        }
    });
});
parcelRegister("6RRsR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1edff5857dbe6b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $flnZx;
    var $4nDwW = parcelRequire("4nDwW");
    var $6HH4J = parcelRequire("6HH4J");
    var $kUHMV = parcelRequire("kUHMV");
    function $c1edff5857dbe6b8$export$2e2bcd8739ae039(props) {
        const { startDate: startDate, endDate: endDate, activeSprint: activeSprint, completedSprintCount: completedSprintCount = 0, showActiveSprintOnTooltip: showActiveSprintOnTooltip } = props;
        if (!((0, $4nDwW.isDefined)(startDate) && (0, $4nDwW.isDefined)(endDate))) return null;
        const numDays = Math.floor((endDate - startDate) / (0, (0, parcelRequire("flnZx")).ONE_DAY)) + 1;
        const text = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUHMV.withSprint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $6HH4J.default).issueLength,
            values: {
                numDays: numDays
            }
        }), showActiveSprintOnTooltip === true && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUHMV.sprintDetails
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUHMV.separator
        }), activeSprint && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $6HH4J.default).sprint,
            values: {
                activeSprint: activeSprint.title
            }
        }), completedSprintCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $6HH4J.default).completeSprints,
            values: {
                count: completedSprintCount
            }
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUHMV.issueLength
        }, text);
    }
});
parcelRegister("6HH4J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$066b09b4b6224353$export$2e2bcd8739ae039);
    var $7VHMR;
    const $066b09b4b6224353$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueLength: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.issue-length.issue-length",
            "defaultMessage": "{numDays, plural, one {# day} other {# days}}"
        },
        sprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.issue-length.sprint",
            "defaultMessage": "Sprint: {activeSprint}"
        },
        completeSprints: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.issue-length.complete-sprints",
            "defaultMessage": ", +{count} Completed"
        }
    });
    var $066b09b4b6224353$export$2e2bcd8739ae039 = $066b09b4b6224353$var$messages;
});
parcelRegister("kUHMV", function(module, exports) {
    $parcel$export(module.exports, "issueLength", ()=>$f39b0108e0b1bfd8$export$cdb67a89cc823080, (v)=>$f39b0108e0b1bfd8$export$cdb67a89cc823080 = v);
    $parcel$export(module.exports, "separator", ()=>$f39b0108e0b1bfd8$export$3e523c77c1f23f8c, (v)=>$f39b0108e0b1bfd8$export$3e523c77c1f23f8c = v);
    $parcel$export(module.exports, "sprintDetails", ()=>$f39b0108e0b1bfd8$export$5a0c66c0f22bdbdc, (v)=>$f39b0108e0b1bfd8$export$5a0c66c0f22bdbdc = v);
    $parcel$export(module.exports, "withSprint", ()=>$f39b0108e0b1bfd8$export$e77aea3576038e88, (v)=>$f39b0108e0b1bfd8$export$e77aea3576038e88 = v);
    var $f39b0108e0b1bfd8$export$cdb67a89cc823080;
    var $f39b0108e0b1bfd8$export$3e523c77c1f23f8c;
    var $f39b0108e0b1bfd8$export$5a0c66c0f22bdbdc;
    var $f39b0108e0b1bfd8$export$e77aea3576038e88;
    $f39b0108e0b1bfd8$export$cdb67a89cc823080 = `O2em4q_issueLength`;
    $f39b0108e0b1bfd8$export$3e523c77c1f23f8c = `O2em4q_separator`;
    $f39b0108e0b1bfd8$export$5a0c66c0f22bdbdc = `O2em4q_sprintDetails`;
    $f39b0108e0b1bfd8$export$e77aea3576038e88 = `O2em4q_withSprint`;
});
parcelRegister("g08t1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f30be9594de21127$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $TTKUQ = parcelRequire("TTKUQ");
    function $f30be9594de21127$export$2e2bcd8739ae039({ style: style, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testId": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.overflowed.overflowed",
            style: {
                ...style,
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: -(0, $TTKUQ.HORIZONTAL_SCROLL_OFFSET),
                right: -(0, $TTKUQ.HORIZONTAL_SCROLL_OFFSET)
            }
        }, children);
    }
    $f30be9594de21127$export$2e2bcd8739ae039.Restore = function RestoredOverflowed({ style: style, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                ...style,
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: (0, $TTKUQ.HORIZONTAL_SCROLL_OFFSET),
                right: (0, $TTKUQ.HORIZONTAL_SCROLL_OFFSET)
            }
        }, children);
    };
});
parcelRegister("8u2gm", function(module, exports) {
    $parcel$export(module.exports, "spaBothDatesRow", ()=>$62d2e1698a314230$export$64d4ada7a07015f5, (v)=>$62d2e1698a314230$export$64d4ada7a07015f5 = v);
    var $62d2e1698a314230$export$64d4ada7a07015f5;
    $62d2e1698a314230$export$64d4ada7a07015f5 = `Avp6xa_spaBothDatesRow`;
});
parcelRegister("e79al", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38bc0d8bcd3f2bff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4nDwW = parcelRequire("4nDwW");
    var $g08t1 = parcelRequire("g08t1");
    function $38bc0d8bcd3f2bff$var$RowContainer({ bgColor: bgColor, highlighter: highlighter, children: children, style: style = {}, testId: testId }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                position: 'relative',
                height: '100%'
            },
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g08t1.default), {
            style: {
                ...(0, $4nDwW.isDefined)(bgColor) && {
                    backgroundColor: bgColor
                },
                pointerEvents: 'none',
                ...style
            }
        }, highlighter), children);
    }
    $38bc0d8bcd3f2bff$var$RowContainer.whyDidYouRender = true;
    $38bc0d8bcd3f2bff$var$RowContainer.displayName = 'RowContainer';
    var $38bc0d8bcd3f2bff$export$2e2bcd8739ae039 = $38bc0d8bcd3f2bff$var$RowContainer;
});
parcelRegister("1JiMc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$253842914e067d08$export$2e2bcd8739ae039);
    var $bC2fB;
    var $lESgS = parcelRequire("lESgS");
    var $jSac7 = parcelRequire("jSac7");
    var $b6GXM = parcelRequire("b6GXM");
    var $253842914e067d08$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $jSac7.default), (0, $lESgS.default))((0, $b6GXM.default));
});
parcelRegister("lESgS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b48324d71fb0b699$export$2e2bcd8739ae039);
    var $4K5PQ = parcelRequire("4K5PQ");
    const $b48324d71fb0b699$var$mapDispatchToProps = (dispatch, ownProps)=>({
            commitTimelinePreview: ()=>{
                dispatch((0, $4K5PQ.commitTimelinePreview)());
            },
            cancelTimelinePreview: ()=>{
                dispatch((0, $4K5PQ.cancelTimelinePreview)());
            },
            hoverTimelineIssue: (defaultStart, defaultEnd)=>{
                dispatch((0, $4K5PQ.hoverTimelineIssue)(ownProps.issue.id, defaultStart, defaultEnd));
            }
        });
    var $b48324d71fb0b699$export$2e2bcd8739ae039 = $b48324d71fb0b699$var$mapDispatchToProps;
});
parcelRegister("jSac7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66465028f9f6ab3f$export$2e2bcd8739ae039);
    var $jAIJh = parcelRequire("jAIJh");
    var $3YtPS = parcelRequire("3YtPS");
    var $66465028f9f6ab3f$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        timelineUnits: (0, $jAIJh.getTimelineUnits),
        zoomLevel: (0, $jAIJh.getZoomLevel)
    });
});
parcelRegister("b6GXM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cf035d1e7f20a60c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $flnZx;
    var $hE4fC;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $9TpML = parcelRequire("9TpML");
    var $cpEF0 = parcelRequire("cpEF0");
    const $cf035d1e7f20a60c$var$usePreviewSizeInMs = ()=>{
        const [{ zoomLevel: zoomLevel, viewport: viewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [{ pxToMs: pxToMs, msToPx: msToPx }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        const getCursorOffsetFromToday = (relativeMouseX)=>{
            const viewportOffsetInPx = msToPx(Math.abs(viewport.offset));
            let cursorOffset;
            if (relativeMouseX > viewport.width) cursorOffset = relativeMouseX - viewportOffsetInPx;
            else cursorOffset = relativeMouseX + viewportOffsetInPx;
            const offset = viewport.offset + pxToMs(cursorOffset);
            return offset;
        };
        const getMousedOverDate = (relativeMouseX)=>{
            const today = Date.now();
            const cursorOffsetInMs = getCursorOffsetFromToday(relativeMouseX);
            const ms = today + cursorOffsetInMs;
            const date = new Date(ms);
            return date;
        };
        const getPreviewSize = (relativeMouseX)=>{
            const relativeAccountForPadding = zoomLevel === (0, $TTKUQ.ZOOM_LEVELS).MONTHS ? relativeMouseX - 5 : relativeMouseX - 1;
            const mousedOverDate = getMousedOverDate(relativeAccountForPadding);
            return (0, $9TpML.getDaysInTimelineView)(mousedOverDate, zoomLevel) * (0, (0, parcelRequire("flnZx")).ONE_DAY) - 1;
        };
        return getPreviewSize;
    };
    function $cf035d1e7f20a60c$export$2e2bcd8739ae039(props) {
        const getPreviewSize = $cf035d1e7f20a60c$var$usePreviewSizeInMs();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cpEF0.default), {
            ...props,
            getPreviewSizeInMs: getPreviewSize
        });
    }
});
parcelRegister("9TpML", function(module, exports) {
    $parcel$export(module.exports, "getDaysInTimelineView", ()=>$6b785efb56671f7b$export$8b361b34637253ef);
    var $f2fy0;
    var $6D6zP;
    var $8ohi6;
    var $c9FOp;
    var $flnZx;
    var $TTKUQ = parcelRequire("TTKUQ");
    const $6b785efb56671f7b$export$a67f6b7c5b24aabc = (date)=>{
        const startDate = (0, (0, parcelRequire("c9FOp")).default)(date);
        const endDate = (0, (0, parcelRequire("f2fy0")).default)(date);
        return Math.round((endDate.getTime() + 1 - startDate.getTime()) / (0, (0, parcelRequire("flnZx")).ONE_DAY));
    };
    const $6b785efb56671f7b$export$8b361b34637253ef = (date, zoomLevel)=>{
        const normalizedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        switch(zoomLevel){
            case (0, $TTKUQ.ZOOM_LEVELS).WEEKS:
                return 7;
            case (0, $TTKUQ.ZOOM_LEVELS).MONTHS:
                return (0, (0, parcelRequire("6D6zP")).default)(normalizedDate);
            case (0, $TTKUQ.ZOOM_LEVELS).QUARTERS:
                return $6b785efb56671f7b$export$a67f6b7c5b24aabc(normalizedDate);
            case (0, $TTKUQ.ZOOM_LEVELS).YEARS:
                return (0, (0, parcelRequire("8ohi6")).default)(normalizedDate);
            default:
                return 30;
        }
    };
});
parcelRegister("cpEF0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0410ea8afe7f2664$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $cwmS5;
    var $lJcaU;
    var $gJZ5D;
    var $flnZx;
    var $fJbaP;
    var $iwfmd;
    var $dCm1o;
    var $2t3gs = parcelRequire("2t3gs");
    var $fHOdZ = parcelRequire("fHOdZ");
    var $5XfGu = parcelRequire("5XfGu");
    var $isUDB = parcelRequire("isUDB");
    var $6RRsR = parcelRequire("6RRsR");
    var $g08t1 = parcelRequire("g08t1");
    var $bRkAQ = parcelRequire("bRkAQ");
    const $0410ea8afe7f2664$var$snapWithFloor = (val, snap)=>Math.floor(val / snap) * snap;
    const $0410ea8afe7f2664$var$HOVER_PREVIEW_CURSOR_OFFSET_RATIO = 0;
    const $0410ea8afe7f2664$export$17fb3b47afd39747 = (unit, timelineSize, timelineRange)=>unit * timelineSize + timelineRange.start;
    const $0410ea8afe7f2664$export$d8a0b4b7b3e0ece6 = (relativeMouseX, viewWidth, timelineSize, timelineUnits)=>{
        const fromXPercentage = relativeMouseX / viewWidth * 100;
        let accumulatedUnitPercentage = 0;
        let previewUnit = timelineUnits[0];
        for(let i = 0; i < timelineUnits.length; i++){
            accumulatedUnitPercentage += timelineUnits[i].widthPercentage;
            if (accumulatedUnitPercentage > fromXPercentage || i === timelineUnits.length - 1) {
                previewUnit = timelineUnits[i];
                break;
            }
        }
        const widthPercentage = previewUnit ? previewUnit.widthPercentage : 100;
        const previewSize = $0410ea8afe7f2664$var$snapWithFloor(widthPercentage / 100 * timelineSize, (0, (0, parcelRequire("flnZx")).ONE_DAY));
        return previewSize;
    };
    const $0410ea8afe7f2664$export$48715bb6a00f5260 = (fromX, toX, timelineRange, timelineUnits, rect, calculateBaselineEnd)=>{
        const relativeStartX = fromX - rect.left;
        const relativeToX = toX - rect.left;
        const timelineSize = timelineRange.end - timelineRange.start;
        const previewSize = $0410ea8afe7f2664$export$d8a0b4b7b3e0ece6(relativeStartX, rect.width, timelineSize, timelineUnits);
        const startUnit = relativeStartX / rect.width;
        const baselineStart = $0410ea8afe7f2664$var$snapWithFloor($0410ea8afe7f2664$export$17fb3b47afd39747(startUnit, timelineSize, timelineRange) - previewSize * $0410ea8afe7f2664$var$HOVER_PREVIEW_CURSOR_OFFSET_RATIO, (0, (0, parcelRequire("flnZx")).ONE_DAY));
        const endUnit = relativeToX / rect.width;
        const unroundedBaselineEnd = $0410ea8afe7f2664$export$17fb3b47afd39747(endUnit, timelineSize, timelineRange);
        const baselineEnd = calculateBaselineEnd(unroundedBaselineEnd, previewSize, baselineStart);
        return {
            baselineStart: (0, (0, parcelRequire("flnZx")).startOfUtcDay)(baselineStart),
            baselineEnd: (0, (0, parcelRequire("flnZx")).endOfUtcDay)(baselineEnd)
        };
    };
    const $0410ea8afe7f2664$export$3a1ccf511224c1d9 = (fromX, timelineRange, rect, getPreview)=>{
        const relativeStartX = fromX - rect.left;
        const timelineSize = timelineRange.end - timelineRange.start;
        const previewSize = getPreview(relativeStartX);
        const startUnit = relativeStartX / rect.width;
        const baselineStart = $0410ea8afe7f2664$var$snapWithFloor($0410ea8afe7f2664$export$17fb3b47afd39747(startUnit, timelineSize, timelineRange) - previewSize * $0410ea8afe7f2664$var$HOVER_PREVIEW_CURSOR_OFFSET_RATIO, (0, (0, parcelRequire("flnZx")).ONE_DAY));
        const baselineEnd = baselineStart + previewSize;
        return {
            baselineStart: (0, (0, parcelRequire("flnZx")).startOfUtcDay)(baselineStart),
            baselineEnd: (0, (0, parcelRequire("flnZx")).startOfUtcDay)(baselineEnd)
        };
    };
    const $0410ea8afe7f2664$export$fa41d78174d0c825 = (unroundedBaselineEnd, _, baselineStart)=>{
        let baselineEnd = $0410ea8afe7f2664$var$snapWithFloor(unroundedBaselineEnd, (0, (0, parcelRequire("flnZx")).ONE_DAY));
        baselineEnd = Math.max(baselineStart, baselineEnd);
        return baselineEnd;
    };
    const $0410ea8afe7f2664$export$1e6156e0ceeece5a = (unroundedBaselineEnd, previewSize)=>{
        const baselineEnd = $0410ea8afe7f2664$var$snapWithFloor(unroundedBaselineEnd + previewSize * (1 - $0410ea8afe7f2664$var$HOVER_PREVIEW_CURSOR_OFFSET_RATIO), (0, (0, parcelRequire("flnZx")).ONE_DAY));
        return baselineEnd;
    };
    class $0410ea8afe7f2664$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isReadOnly: false,
                Bar: $fHOdZ.default
            };
        }
        render() {
            const { barColor: barColor, barColors: barColors, timelineRange: timelineRange, preview: preview, issue: issue, Bar: Bar, topOffset: topOffset } = this.props;
            let bar;
            let startDate;
            let endDate;
            let dates;
            let numDays;
            if (preview) {
                const { leftPositionPercentage: leftPositionPercentage, rightPositionPercentage: rightPositionPercentage } = (0, $2t3gs.getPositionsForBar)(preview, timelineRange);
                bar = (0, ($parcel$interopDefault($5uXOq))).createElement(Bar, {
                    leftPositionPercentage: leftPositionPercentage,
                    rightPositionPercentage: rightPositionPercentage,
                    leftAnchorPercentage: 0,
                    rightAnchorPercentage: 100,
                    color: barColor,
                    colors: barColors,
                    opacity: 0.5,
                    id: issue.id,
                    additionalStyles: {
                        zIndex: 0
                    },
                    topOffset: topOffset
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $bRkAQ.spaBarContent
                }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                    label: "",
                    size: "16",
                    appearance: "gray",
                    shape: "circle",
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("lJcaU")))))
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lJcaU"))))), {
                    color: "var(--ds-icon-inverse, #FFFFFF)",
                    label: "",
                    LEGACY_size: "small",
                    LEGACY_primaryColor: "var(--ds-surface-raised, rgba(255, 255, 255, 0.8))",
                    LEGACY_secondaryColor: barColor || `var(--ds-text-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N500})`
                })));
                if (this.state.hovered || this.state.dragging) {
                    startDate = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5XfGu.default), {
                        startOrEnd: "start",
                        date: preview.baselineStart
                    });
                    endDate = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5XfGu.default), {
                        startOrEnd: "end",
                        date: preview.baselineEnd
                    });
                    numDays = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $6RRsR.default), {
                        startDate: preview.baselineStart,
                        endDate: preview.baselineEnd
                    });
                }
                if (this.ref instanceof Element) {
                    const rect = this.ref.getBoundingClientRect();
                    dates = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $isUDB.default), {
                        datePosition: {
                            leftPositionPercentage: leftPositionPercentage,
                            rightPositionPercentage: rightPositionPercentage
                        },
                        width: rect.width
                    }, startDate, numDays, endDate);
                }
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
                onHoverChanged: this.onHoverChanged
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fJbaP")).default), {
                dragHandler: {
                    onMouseDown: this.onMouseDown,
                    onDrag: this.onDrag,
                    onDragEnd: this.onDragEnd,
                    onClick: this.onClick
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.no-dates.row-${issue.id}`,
                className: (0, ($parcel$interopDefault($9ci4W)))($bRkAQ.spaNoDatesRow, {
                    [$bRkAQ.readOnly]: this.props.isReadOnly
                }),
                onMouseMove: this.onMouseMove,
                ref: (ref)=>{
                    if (ref) this.ref = ref;
                }
            }, bar, dates, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g08t1.default), null))));
        }
        constructor(...args){
            super(...args);
            this.state = {
                dragging: false,
                hovered: false
            };
            this.onMouseMove = (e)=>{
                if (this.props.isReadOnly) return;
                if (this.state.dragging) return;
                if (!(this.ref instanceof Element)) return;
                const { timelineRange: timelineRange, timelineUnits: timelineUnits, zoomLevel: zoomLevel, getPreviewSizeInMs: getPreviewSizeInMs } = this.props;
                if (zoomLevel === undefined || !getPreviewSizeInMs) {
                    const { baselineStart: baselineStart, baselineEnd: baselineEnd } = $0410ea8afe7f2664$export$48715bb6a00f5260(e.pageX, e.pageX, timelineRange, timelineUnits, this.ref.getBoundingClientRect(), $0410ea8afe7f2664$export$1e6156e0ceeece5a);
                    this.updatePreview(baselineStart, baselineEnd);
                } else {
                    const { baselineStart: baselineStart, baselineEnd: baselineEnd } = $0410ea8afe7f2664$export$3a1ccf511224c1d9(e.pageX, timelineRange, this.ref.getBoundingClientRect(), getPreviewSizeInMs);
                    this.updatePreview(baselineStart, baselineEnd);
                }
            };
            this.onMouseDown = ()=>{
                if (this.props.isReadOnly) return;
                this.setState({
                    dragging: true
                });
                this.props.disableOtherRows(this.props.issue.id);
            };
            this.onDrag = (_, to, start)=>{
                if (this.props.isReadOnly) return;
                if (!(this.ref instanceof Element)) return;
                const startX = to.x - start.x < 0 ? to.x : start.x;
                const toX = to.x - start.x < 0 ? start.x : to.x;
                const { timelineRange: timelineRange } = this.props;
                const { baselineStart: baselineStart, baselineEnd: baselineEnd } = $0410ea8afe7f2664$export$48715bb6a00f5260(startX, toX, timelineRange, this.props.timelineUnits, this.ref.getBoundingClientRect(), $0410ea8afe7f2664$export$fa41d78174d0c825);
                this.updatePreview(baselineStart, baselineEnd);
            };
            this.onDragEnd = ()=>{
                if (this.props.isReadOnly) return;
                this.props.commitTimelinePreview();
                this.props.reEnableOtherRows();
            };
            this.onClick = ()=>{
                if (this.props.isReadOnly) return;
                this.props.commitTimelinePreview();
                this.props.reEnableOtherRows();
            };
            this.updatePreview = (baselineStart, baselineEnd)=>{
                this.props.hoverTimelineIssue(baselineStart, baselineEnd);
            };
            this.onHoverChanged = (hover)=>{
                if (this.props.isReadOnly) return;
                this.setState({
                    hovered: hover
                });
                if (!hover) this.props.cancelTimelinePreview();
            };
        }
    }
});
parcelRegister("cwmS5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a921419639fe8f6f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    function $a921419639fe8f6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a921419639fe8f6f$var$sizeMap = {
        '16': {
            name: "157xhr7",
            styles: "width:16px;height:16px"
        },
        '24': {
            name: "rrel8y",
            styles: "width:24px;height:24px"
        },
        '32': {
            name: "68x97p",
            styles: "width:32px;height:32px"
        },
        '40': {
            name: "1mfsro6",
            styles: "width:40px;height:40px"
        },
        '48': {
            name: "18jhpep",
            styles: "width:48px;height:48px"
        }
    };
    const $a921419639fe8f6f$var$appearanceMap = {
        grayBold: {
            name: "algye9",
            styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        limeBold: {
            name: "a86nvv",
            styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        greenBold: {
            name: "13e2qqr",
            styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        blueBold: {
            name: "jpsdma",
            styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        redBold: {
            name: "1bg8y7a",
            styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        purpleBold: {
            name: "19bo3lb",
            styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        magentaBold: {
            name: "1l16rgo",
            styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        tealBold: {
            name: "7kw5zl",
            styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        orangeBold: {
            name: "h77eay",
            styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        yellowBold: {
            name: "sbe4w3",
            styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        gray: {
            name: "yxgei8",
            styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
        },
        lime: {
            name: "o9c6oh",
            styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
        },
        orange: {
            name: "szqzk5",
            styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
        },
        magenta: {
            name: "o6ptuw",
            styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
        },
        green: {
            name: "157dg7e",
            styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
        },
        blue: {
            name: "x3nujl",
            styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
        },
        red: {
            name: "zqoyws",
            styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
        },
        purple: {
            name: "fitjkd",
            styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
        },
        teal: {
            name: "b3m1ww",
            styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
        },
        yellow: {
            name: "1j18jub",
            styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
        }
    };
    const $a921419639fe8f6f$var$shapeMap = {
        square: {
            name: "vwdoqr",
            styles: "border-radius:var(--ds-border-radius-100, 4px)"
        },
        circle: {
            name: "i2ucdk",
            styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
        }
    };
    const $a921419639fe8f6f$var$iconTileStyles = {
        name: "ykimcl",
        styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center"
    };
    function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
        const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent } = props;
        const ExpandedIcon = Icon;
        if (LEGACY_fallbackComponent && !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
        else return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $a921419639fe8f6f$var$iconTileStyles,
                $a921419639fe8f6f$var$appearanceMap[appearance],
                $a921419639fe8f6f$var$sizeMap[size],
                $a921419639fe8f6f$var$shapeMap[shape]
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        }));
    }
});
parcelRegister("lJcaU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fd173ea3fb7b31ff$var$_react = $fd173ea3fb7b31ff$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fd173ea3fb7b31ff$var$_add = $fd173ea3fb7b31ff$var$_interopRequireDefault((parcelRequire("dZbEw")));
    var $fd173ea3fb7b31ff$var$_addCircle = $fd173ea3fb7b31ff$var$_interopRequireDefault((parcelRequire("bCjxO")));
    function $fd173ea3fb7b31ff$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fd173ea3fb7b31ff$var$AddIcon = (props)=>$fd173ea3fb7b31ff$var$_react.default.createElement($fd173ea3fb7b31ff$var$_add.default, Object.assign({
            LEGACY_fallbackIcon: $fd173ea3fb7b31ff$var$_addCircle.default
        }, props));
    $fd173ea3fb7b31ff$var$AddIcon.Name = 'AddIconMigration';
    var $fd173ea3fb7b31ff$var$_default = module.exports.default = $fd173ea3fb7b31ff$var$AddIcon;
});
parcelRegister("bCjxO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8752676d88a02e6d$var$_react = $8752676d88a02e6d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $8752676d88a02e6d$var$_add = $8752676d88a02e6d$var$_interopRequireDefault((parcelRequire("dZbEw")));
    function $8752676d88a02e6d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8752676d88a02e6d$var$AddCircleIcon = (props)=>$8752676d88a02e6d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11.046 7.958v3.088H7.958a.954.954 0 1 0 0 1.908h3.088v3.088a.954.954 0 1 0 1.908 0v-3.088h3.088a.954.954 0 1 0 0-1.908h-3.088V7.958a.954.954 0 1 0-1.908 0"/></g></svg>`
        }, props, {
            newIcon: $8752676d88a02e6d$var$_add.default
        }));
    $8752676d88a02e6d$var$AddCircleIcon.displayName = 'AddCircleIcon';
    var $8752676d88a02e6d$var$_default = module.exports.default = $8752676d88a02e6d$var$AddCircleIcon;
});
parcelRegister("bRkAQ", function(module, exports) {
    $parcel$export(module.exports, "readOnly", ()=>$8a249e551cd94995$export$b2cbc93d4da94977, (v)=>$8a249e551cd94995$export$b2cbc93d4da94977 = v);
    $parcel$export(module.exports, "spaBarContent", ()=>$8a249e551cd94995$export$94c4bac2cffc23c6, (v)=>$8a249e551cd94995$export$94c4bac2cffc23c6 = v);
    $parcel$export(module.exports, "spaNoDatesRow", ()=>$8a249e551cd94995$export$3d1c6a55f6d665b0, (v)=>$8a249e551cd94995$export$3d1c6a55f6d665b0 = v);
    var $8a249e551cd94995$export$b2cbc93d4da94977;
    var $8a249e551cd94995$export$94c4bac2cffc23c6;
    var $8a249e551cd94995$export$3d1c6a55f6d665b0;
    $8a249e551cd94995$export$b2cbc93d4da94977 = `fUXzxa_readOnly`;
    $8a249e551cd94995$export$94c4bac2cffc23c6 = `fUXzxa_spaBarContent`;
    $8a249e551cd94995$export$3d1c6a55f6d665b0 = `fUXzxa_spaNoDatesRow`;
});
parcelRegister("9XOR0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23f570954bf55352$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bxKc3 = parcelRequire("bxKc3");
    var $frK5K = parcelRequire("frK5K");
    var $23f570954bf55352$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $bxKc3.default))((0, $frK5K.default));
});
parcelRegister("bxKc3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$940a0a74b4d35f98$export$2e2bcd8739ae039);
    var $4K5PQ = parcelRequire("4K5PQ");
    var $kfvhW = parcelRequire("kfvhW");
    const $940a0a74b4d35f98$var$mapDispatchToProps = (dispatch, ownProps)=>({
            commitTimelinePreview: ()=>{
                dispatch((0, $4K5PQ.commitTimelinePreview)());
            },
            cancelTimelinePreview: ()=>{
                dispatch((0, $4K5PQ.cancelTimelinePreview)());
            },
            resizeTimelineIssue: (baselineStart, baselineEnd)=>{
                dispatch((0, $kfvhW.suspend)());
                dispatch((0, $4K5PQ.hoverTimelineIssue)(ownProps.issue.id, baselineStart, baselineEnd));
                dispatch((0, $4K5PQ.resizeTimelineIssue)(baselineStart, baselineEnd));
                dispatch((0, $kfvhW.resume)());
            }
        });
    var $940a0a74b4d35f98$export$2e2bcd8739ae039 = $940a0a74b4d35f98$var$mapDispatchToProps;
});
parcelRegister("frK5K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ea49154c286a619$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $flnZx;
    var $iwfmd;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $2t3gs = parcelRequire("2t3gs");
    var $fHOdZ = parcelRequire("fHOdZ");
    var $5XfGu = parcelRequire("5XfGu");
    var $isUDB = parcelRequire("isUDB");
    var $c3ZJn = parcelRequire("c3ZJn");
    var $6RRsR = parcelRequire("6RRsR");
    var $g08t1 = parcelRequire("g08t1");
    var $ey2Ir = parcelRequire("ey2Ir");
    const $5ea49154c286a619$var$snapWithRound = (val, snap)=>Math.round(val / snap) * snap;
    class $5ea49154c286a619$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                DependencyMarker: $c3ZJn.default,
                Bar: $fHOdZ.default,
                isReadOnly: false,
                showStripesInBar: {
                    left: false,
                    right: false
                },
                isBeingInteractedWith: false,
                cancelTimelinePreview: (0, ($parcel$interopDefault($8Rkzz))),
                commitTimelinePreview: (0, ($parcel$interopDefault($8Rkzz))),
                resizeTimelineIssue: (0, ($parcel$interopDefault($8Rkzz))),
                disableOtherRows: (0, ($parcel$interopDefault($8Rkzz))),
                reEnableOtherRows: (0, ($parcel$interopDefault($8Rkzz))),
                renderFlyout: ()=>null
            };
        }
        render() {
            const { issue: issue, baselineStart: baselineStart, baselineEnd: baselineEnd, timelineRange: timelineRange, barColor: barColor, barColors: barColors, showStripesInBar: showStripesInBar, preview: preview, hasDependencyLineDragPreview: hasDependencyLineDragPreview, renderFlyout: renderFlyout, isBeingInteractedWith: isBeingInteractedWith, isReadOnly: isReadOnly, externalIncomingLinks: externalIncomingLinks, externalOutgoingLinks: externalOutgoingLinks, internalIncomingLinks: internalIncomingLinks, internalIncomingLinksOriginal: internalIncomingLinksOriginal, internalOutgoingLinks: internalOutgoingLinks, internalOutgoingLinksOriginal: internalOutgoingLinksOriginal, opacity: opacity, width: width, DependencyMarker: DependencyMarker, Bar: Bar, topOffset: topOffset } = this.props;
            const { hovered: hovered } = this.state;
            const createBar = (dates, props)=>{
                const position = (0, $2t3gs.getPositionsForBar)(dates, timelineRange);
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Bar, {
                    ...position,
                    color: barColor,
                    colors: barColors,
                    showStripes: showStripesInBar,
                    id: issue.id,
                    ...props,
                    opacity: opacity,
                    topOffset: topOffset
                });
            };
            let leftHandleDragHandler;
            let rightHandleDragHandler;
            if (!isReadOnly) {
                const baseDragHandler = {
                    onDragStart: ()=>{
                        this.props.disableOtherRows(issue.id);
                    },
                    onDragEnd: ()=>{
                        this.props.commitTimelinePreview();
                        this.props.reEnableOtherRows();
                    }
                };
                if (baselineStart !== undefined) leftHandleDragHandler = {
                    ...baseDragHandler,
                    onDrag: (_, to, start)=>{
                        const timelineWidth = timelineRange.end - timelineRange.start;
                        const deltaRatio = (to.x - start.x) / width;
                        const delta = $5ea49154c286a619$var$snapWithRound(deltaRatio * timelineWidth, (0, (0, parcelRequire("flnZx")).ONE_DAY));
                        const newBaselineStart = baselineStart + delta;
                        this.props.resizeTimelineIssue(newBaselineStart, undefined);
                    }
                };
                if (baselineEnd !== undefined) rightHandleDragHandler = {
                    ...baseDragHandler,
                    onDrag: (_, to, start)=>{
                        const timelineWidth = timelineRange.end - timelineRange.start;
                        const deltaRatio = (to.x - start.x) / width;
                        const delta = $5ea49154c286a619$var$snapWithRound(deltaRatio * timelineWidth, (0, (0, parcelRequire("flnZx")).ONE_DAY));
                        const newBaselineEnd = baselineEnd + delta;
                        this.props.resizeTimelineIssue(undefined, newBaselineEnd);
                    }
                };
            }
            const barOpacity = preview ? 0.5 : 1;
            const bar = createBar({
                baselineStart: baselineStart,
                baselineEnd: baselineEnd
            }, {
                opacity: barOpacity,
                leftHandleDragHandler: leftHandleDragHandler,
                rightHandleDragHandler: rightHandleDragHandler,
                showHandles: !isReadOnly && hovered && !isBeingInteractedWith,
                renderFlyout: renderFlyout
            });
            let previewBar;
            if (preview) previewBar = createBar(preview, {
                opacity: 0.8
            });
            const datePosition = (0, $2t3gs.getPositionsForBar)({
                baselineStart: baselineStart,
                baselineEnd: baselineEnd
            }, timelineRange);
            const incomingDependencies = (0, ($parcel$interopDefault($5uXOq))).createElement(DependencyMarker, {
                externalIncomingLinks: externalIncomingLinks,
                internalIncomingLinks: internalIncomingLinks,
                originalIssueLinks: internalIncomingLinksOriginal,
                startOrEnd: "start",
                direction: (0, $TTKUQ.ISSUE_LINK_DIRECTION).INWARD,
                datePosition: datePosition,
                width: width,
                issue: issue,
                isHovered: hovered,
                barColor: barColor,
                barColors: barColors
            });
            const outgoingDependencies = (0, ($parcel$interopDefault($5uXOq))).createElement(DependencyMarker, {
                externalOutgoingLinks: externalOutgoingLinks,
                internalOutgoingLinks: internalOutgoingLinks,
                internalOriginalIssueLinks: internalOutgoingLinksOriginal,
                startOrEnd: "end",
                direction: (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD,
                datePosition: datePosition,
                width: width,
                issue: issue,
                isHovered: hovered,
                barColor: barColor,
                barColors: barColors
            });
            let startDate;
            let endDate;
            let dates;
            let numDays;
            if (hovered && !hasDependencyLineDragPreview) {
                startDate = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5XfGu.default), {
                    startOrEnd: "start",
                    date: baselineStart
                });
                endDate = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5XfGu.default), {
                    startOrEnd: "end",
                    date: baselineEnd
                });
                numDays = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $6RRsR.default), {
                    startDate: baselineStart,
                    endDate: baselineEnd
                });
                dates = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $isUDB.default), {
                    datePosition: datePosition,
                    width: width
                }, startDate, numDays, endDate);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
                onHoverChanged: (hover)=>this.setState({
                        hovered: hover
                    })
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ey2Ir.spaPartialDatesRow
            }, bar, previewBar, dates, incomingDependencies, outgoingDependencies, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g08t1.default), null)));
        }
        constructor(...args){
            super(...args);
            this.state = {
                hovered: false
            };
        }
    }
});
parcelRegister("ey2Ir", function(module, exports) {
    $parcel$export(module.exports, "spaPartialDatesRow", ()=>$a97658f1c2e02c8d$export$18bc6d25fe9a31b3, (v)=>$a97658f1c2e02c8d$export$18bc6d25fe9a31b3 = v);
    var $a97658f1c2e02c8d$export$18bc6d25fe9a31b3;
    $a97658f1c2e02c8d$export$18bc6d25fe9a31b3 = `NZ8FpW_spaPartialDatesRow`;
});
parcelRegister("bUOUf", function(module, exports) {
    $parcel$export(module.exports, "row", ()=>$8acc69937a4900e0$export$120ff0929b202a6d, (v)=>$8acc69937a4900e0$export$120ff0929b202a6d = v);
    var $8acc69937a4900e0$export$120ff0929b202a6d;
    $8acc69937a4900e0$export$120ff0929b202a6d = `n2DYDa_row`;
});
parcelRegister("iqWh9", function(module, exports) {
    $parcel$export(module.exports, "TimelineReleaseBar", ()=>$f3ce310dc105eb76$export$555556cdc08a8e78);
    var $5uXOq = parcelRequire("5uXOq");
    var $cGv9m;
    var $hE4fC;
    var $1vJdq = parcelRequire("1vJdq");
    var $ecV7B = parcelRequire("ecV7B");
    var $aI0i7;
    var $8LV9S;
    const $f3ce310dc105eb76$export$555556cdc08a8e78 = ({ noMarker: noMarker })=>{
        const [{ column: column }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const [columnWidth = 0] = (0, (0, parcelRequire("8LV9S")).useColumnWidth)({
            column: column,
            preview: true
        });
        const width = zoomLevel ? (0, (0, parcelRequire("cGv9m")).getContainerWidth)(zoomLevel) : columnWidth;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1vJdq.default), {
            width: width,
            renderMarker: noMarker ? ({ date: date, mode: mode, versionIdsMapByDate: versionIdsMapByDate })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ecV7B.default), {
                    key: date,
                    endDate: date,
                    mode: mode,
                    versionIdsMapByDate: versionIdsMapByDate
                }) : undefined
        });
    };
});
parcelRegister("1vJdq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$613e4fe8d33d186d$export$2e2bcd8739ae039);
    var $bC2fB;
    var $iuPSB = parcelRequire("iuPSB");
    var $iiZCm = parcelRequire("iiZCm");
    var $dtUdK = parcelRequire("dtUdK");
    var $613e4fe8d33d186d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $iiZCm.default), (0, $iuPSB.default))((0, $dtUdK.default));
});
parcelRegister("iuPSB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bebf2742b477954e$export$2e2bcd8739ae039);
    var $5BBQV = parcelRequire("5BBQV");
    var $5BBQV = parcelRequire("5BBQV");
    const $bebf2742b477954e$var$mapDispatchToProps = (dispatch)=>({
            openFlyout: (versionIds, type)=>{
                dispatch((0, $5BBQV.openFlyout)(versionIds, type));
            },
            closeFlyout: ()=>{
                dispatch((0, $5BBQV.closeFlyout)());
            }
        });
    var $bebf2742b477954e$export$2e2bcd8739ae039 = $bebf2742b477954e$var$mapDispatchToProps;
});
parcelRegister("5BBQV", function(module, exports) {
    $parcel$export(module.exports, "SET_MODE", ()=>$163131e8f776efef$export$27a86d4a6fd7f204);
    $parcel$export(module.exports, "OPEN_FLYOUT", ()=>$163131e8f776efef$export$aece46899d04da75);
    $parcel$export(module.exports, "UPDATE_FLYOUT", ()=>$163131e8f776efef$export$a2b5fcbeee378108);
    $parcel$export(module.exports, "CLOSE_FLYOUT", ()=>$163131e8f776efef$export$818850ad86c540b1);
    $parcel$export(module.exports, "TOGGLE_RELEASE_HIGHLIGHT", ()=>$163131e8f776efef$export$b573db5d1292985d);
    $parcel$export(module.exports, "RESET_RELEASE_HIGHLIGHTS", ()=>$163131e8f776efef$export$a019f587f6127c6e);
    $parcel$export(module.exports, "openFlyout", ()=>$163131e8f776efef$export$a297e31c5d8808a1);
    $parcel$export(module.exports, "updateFlyout", ()=>$163131e8f776efef$export$fcd7b1e2a5376d43);
    $parcel$export(module.exports, "closeFlyout", ()=>$163131e8f776efef$export$7670f8956d89067d);
    const $163131e8f776efef$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.roadmap.timeline.release-bar.SET_MODE';
    const $163131e8f776efef$export$aece46899d04da75 = 'state.ui.main.tabs.roadmap.timeline.release-bar.OPEN_FLYOUT';
    const $163131e8f776efef$export$a2b5fcbeee378108 = 'state.ui.main.tabs.roadmap.timeline.release-bar.UPDATE_FLYOUT';
    const $163131e8f776efef$export$818850ad86c540b1 = 'state.ui.main.tabs.roadmap.timeline.release-bar.CLOSE_FLYOUT';
    const $163131e8f776efef$export$b573db5d1292985d = 'state.ui.main.tabs.roadmap.timeline.release-bar.TOGGLE_RELEASE_HIGHLIGHT';
    const $163131e8f776efef$export$a019f587f6127c6e = 'state.ui.main.tabs.roadmap.timeline.release-bar.RESET_RELEASE_HIGHLIGHTS';
    const $163131e8f776efef$export$d4f039427a1beff1 = (payload)=>({
            type: $163131e8f776efef$export$27a86d4a6fd7f204,
            payload: payload
        });
    const $163131e8f776efef$export$a297e31c5d8808a1 = (versionIds, type)=>({
            type: $163131e8f776efef$export$aece46899d04da75,
            payload: {
                mode: type,
                versionIds: versionIds
            }
        });
    const $163131e8f776efef$export$fcd7b1e2a5376d43 = (versionIds, type, prevVersionIds)=>({
            type: $163131e8f776efef$export$a2b5fcbeee378108,
            payload: {
                mode: type,
                versionIds: versionIds,
                prevVersionIds: prevVersionIds
            }
        });
    const $163131e8f776efef$export$7670f8956d89067d = ()=>({
            type: $163131e8f776efef$export$818850ad86c540b1
        });
    const $163131e8f776efef$export$97c25c5d2300edd8 = (versionId)=>({
            type: $163131e8f776efef$export$b573db5d1292985d,
            versionId: versionId
        });
    const $163131e8f776efef$export$f63ec690ad2eb4fe = (versionIds)=>({
            type: $163131e8f776efef$export$a019f587f6127c6e,
            versionIds: versionIds
        });
});
parcelRegister("iiZCm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fe3bde92a041e9c$export$2e2bcd8739ae039);
    var $cTYeP;
    var $SZGT2;
    var $4Rr1a;
    var $2rMKg;
    var $4R6GH;
    var $1CGdp = parcelRequire("1CGdp");
    var $jw86H = parcelRequire("jw86H");
    var $1dvM4 = parcelRequire("1dvM4");
    var $1LpPL = parcelRequire("1LpPL");
    var $lz7VR = parcelRequire("lz7VR");
    var $85IPo = parcelRequire("85IPo");
    var $9FFuD = parcelRequire("9FFuD");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $55MBr = parcelRequire("55MBr");
    const $9fe3bde92a041e9c$export$64851af5160151f6 = (enrichedVersions, versionFilter, projectFilter)=>{
        const { value: value, versionsFromCrossProjectReleaseFilterValue: versionsFromCrossProjectReleaseFilterValue } = versionFilter;
        const { value: projectValue } = projectFilter;
        const filterValue = (0, $4nDwW.isDefined)(versionsFromCrossProjectReleaseFilterValue) ? [
            ...value,
            ...versionsFromCrossProjectReleaseFilterValue
        ] : value;
        return enrichedVersions.filter(({ id: id, projects: projects })=>(filterValue.length === 0 || (0, parcelRequire("cTYeP")).default(id, filterValue)) && (projectValue.length === 0 || projects.some((0, (0, parcelRequire("4R6GH")).fg)('plans-proj-undefined-fix') ? (project)=>{
                if (!(0, $55MBr.isProject)(project)) return false;
                return projectValue.includes(project.id);
            } : (project)=>{
                if ((0, $55MBr.isProject)(project) && project.id === null) return false;
                return (0, $55MBr.isProject)(project) && projectValue.includes(project.id);
            })));
    };
    const $9fe3bde92a041e9c$export$10cb46f34fc9b7a8 = (enrichedCrossProjectVersions, versionFilter, crossProjectVersionFilter, filteredProjects)=>{
        const { value: value, versionsFromCrossProjectReleaseFilterValue: versionsFromCrossProjectReleaseFilterValue } = versionFilter;
        const versionFilterValue = (0, $4nDwW.isDefined)(versionsFromCrossProjectReleaseFilterValue) ? [
            ...value,
            ...versionsFromCrossProjectReleaseFilterValue
        ] : value;
        const filteredByProjectVersionsSet = new Set((0, parcelRequire("SZGT2")).default((0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('versions'), filteredProjects)));
        const filterByProject = (versions)=>versions.some(({ id: id })=>filteredByProjectVersionsSet.has(id));
        return enrichedCrossProjectVersions.filter(({ id: id, versions: versions })=>{
            if (crossProjectVersionFilter.value.length > 0 || versionFilterValue.length > 0) return (0, parcelRequire("cTYeP")).default(id, crossProjectVersionFilter.value) && filterByProject(versions);
            return filterByProject(versions);
        });
    };
    const $9fe3bde92a041e9c$var$getCrossProjectVersions = (0, $3YtPS.createSelector)([
        (0, $jw86H.getEnrichedCrossProjectVersions),
        (0, $lz7VR.getReleaseFilter),
        (0, $1dvM4.getCrossProjectReleaseFilter),
        (0, $1LpPL.getFilteredProjects)
    ], $9fe3bde92a041e9c$export$10cb46f34fc9b7a8);
    const $9fe3bde92a041e9c$var$getVersions = (0, $3YtPS.createSelector)([
        (0, $9FFuD.getEnrichedVersions),
        (0, $lz7VR.getReleaseFilter),
        (0, $1LpPL.getProjectFilter)
    ], $9fe3bde92a041e9c$export$64851af5160151f6);
    var $9fe3bde92a041e9c$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        mode: (0, $1CGdp.getMode),
        versions: $9fe3bde92a041e9c$var$getVersions,
        crossProjectVersions: $9fe3bde92a041e9c$var$getCrossProjectVersions,
        releaseBarState: (0, $85IPo.getReleaseBarState),
        solutionVersionsById: (0, $9FFuD.getSolutionVersionsById)
    });
});
parcelRegister("85IPo", function(module, exports) {
    $parcel$export(module.exports, "getReleaseBarState", ()=>$1bfa138bcc01051f$export$18bbac4a693d9a63);
    const $1bfa138bcc01051f$export$18bbac4a693d9a63 = (state)=>state.ui.Main.Tabs.Roadmap.Timeline.ReleaseBar;
});
parcelRegister("55MBr", function(module, exports) {
    $parcel$export(module.exports, "isProject", ()=>$c12c0ded97cfb47f$export$7ca3f0de95b9253e);
    $parcel$export(module.exports, "isVersionCrossProject", ()=>$c12c0ded97cfb47f$export$e0ae1be48cdf8e5d);
    $parcel$export(module.exports, "calculateLeftPositionPercentage", ()=>$c12c0ded97cfb47f$export$1201dff46564a4e5);
    $parcel$export(module.exports, "calculateSlippage", ()=>$c12c0ded97cfb47f$export$125238b07db25e1f);
    $parcel$export(module.exports, "calculateNewTimelineRange", ()=>$c12c0ded97cfb47f$export$c18c64cb490ad928);
    $parcel$export(module.exports, "calculateEndVersionsDate", ()=>$c12c0ded97cfb47f$export$8bdabc349efccfa0);
    $parcel$export(module.exports, "getMarkerTypeIcon", ()=>$c12c0ded97cfb47f$export$e028bd08ccb2e98c);
    $parcel$export(module.exports, "getVersionFlyoutType", ()=>$c12c0ded97cfb47f$export$5b2d0df9616efd9e);
    var $7kydq = parcelRequire("7kydq");
    var $ltEPm;
    var $8BDMi;
    var $8EB5I;
    var $4R6GH;
    var $diHKK = parcelRequire("diHKK");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $Dkbao = parcelRequire("Dkbao");
    var $Dkbao = parcelRequire("Dkbao");
    const $c12c0ded97cfb47f$var$releaseStatusToIconType = {
        [(0, $TTKUQ.RELEASE_STATUSES).UNRELEASED]: (0, $Dkbao.ICON_TYPES).UNRELEASED,
        [(0, $TTKUQ.RELEASE_STATUSES).RELEASED]: (0, $Dkbao.ICON_TYPES).RELEASED,
        [(0, $TTKUQ.RELEASE_STATUSES).OFFTRACK]: (0, $Dkbao.ICON_TYPES).OFFTRACK,
        [(0, $TTKUQ.RELEASE_STATUSES).ONTRACK]: (0, $Dkbao.ICON_TYPES).ONTRACK
    };
    function $c12c0ded97cfb47f$export$7ca3f0de95b9253e(proj) {
        if ((0, (0, parcelRequire("4R6GH")).fg)('plans-proj-undefined-fix')) return !(0, ($parcel$interopDefault($7kydq)))(proj) && typeof proj !== 'number' && proj.id != null;
        return typeof proj !== 'number';
    }
    function $c12c0ded97cfb47f$export$e0ae1be48cdf8e5d(version) {
        return 'versions' in version;
    }
    const $c12c0ded97cfb47f$export$dfea42d7af3bd8f6 = (mode, versionEndDate, solutionEndDate)=>{
        if ((0, $4nDwW.isDefined)(versionEndDate)) return versionEndDate;
        if (mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771)) return solutionEndDate || versionEndDate;
        return versionEndDate;
    };
    const $c12c0ded97cfb47f$export$fade81963e3410a4 = (mode, versions, solutionVersionsById)=>{
        const versionEndDates = versions.reduce((result, { id: id, end: versionEnd })=>{
            const solutionVersion = solutionVersionsById[id];
            let solutionEnd = null;
            if ((0, $4nDwW.isDefined)(solutionVersion)) solutionEnd = solutionVersion.end;
            const versionEndDate = $c12c0ded97cfb47f$export$dfea42d7af3bd8f6(mode, versionEnd, solutionEnd);
            if ((0, $4nDwW.isDefined)(versionEndDate)) result.push(versionEndDate);
            return result;
        }, []);
        if (versionEndDates.length === 0) return null;
        return versionEndDates.reduce((result, end)=>Math.max(result, end));
    };
    const $c12c0ded97cfb47f$export$1201dff46564a4e5 = (endDate, { start: timelineStart, end: timelineEnd })=>(endDate - timelineStart) / (timelineEnd - timelineStart) * 100;
    const $c12c0ded97cfb47f$export$125238b07db25e1f = (solutionEndDate, versionEndDate)=>{
        if ((0, $4nDwW.isDefined)(solutionEndDate)) return solutionEndDate - versionEndDate;
        return 0;
    };
    const $c12c0ded97cfb47f$export$c18c64cb490ad928 = (nextDate, { start: start, end: end })=>{
        const medianTimeLineDate = (end + start) / 2;
        const releasesDatesDiff = Math.abs(nextDate - medianTimeLineDate);
        if (nextDate < start) return {
            fromDate: start - releasesDatesDiff,
            toDate: end - releasesDatesDiff
        };
        return {
            fromDate: start + releasesDatesDiff,
            toDate: end + releasesDatesDiff
        };
    };
    const $c12c0ded97cfb47f$export$8bdabc349efccfa0 = (version, solutionVersionsById, mode)=>{
        const solutionVersion = solutionVersionsById && solutionVersionsById[version.id];
        let solutionEnd = null;
        if ((0, $4nDwW.isDefined)(solutionVersion)) solutionEnd = solutionVersion.end;
        let versionEndDate;
        if (!$c12c0ded97cfb47f$export$e0ae1be48cdf8e5d(version)) versionEndDate = $c12c0ded97cfb47f$export$dfea42d7af3bd8f6(mode, version.end, solutionEnd);
        else versionEndDate = $c12c0ded97cfb47f$export$fade81963e3410a4(mode, version.versions, solutionVersionsById);
        return versionEndDate;
    };
    const $c12c0ded97cfb47f$export$944dcaca26f5a09a = ({ crossProjectVersions: crossProjectVersions, versions: versions })=>{
        const crossProjectVersionStatuses = crossProjectVersions.map((crossProjectVersion)=>(0, $diHKK.getReleaseStatus)(crossProjectVersion));
        const versionStatuses = versions.map(({ releaseStatusId: releaseStatusId })=>releaseStatusId);
        const joinedVersions = [
            ...crossProjectVersionStatuses,
            ...versionStatuses
        ];
        if ((0, parcelRequire("ltEPm")).default((0, parcelRequire("8EB5I")).default((0, $TTKUQ.RELEASE_STATUSES).RELEASED))(joinedVersions)) return (0, $TTKUQ.RELEASE_STATUSES).RELEASED;
        if ((0, parcelRequire("8BDMi")).default((0, parcelRequire("8EB5I")).default((0, $TTKUQ.RELEASE_STATUSES).OFFTRACK))(joinedVersions)) return (0, $TTKUQ.RELEASE_STATUSES).OFFTRACK;
        return (0, $TTKUQ.RELEASE_STATUSES).ONTRACK;
    };
    const $c12c0ded97cfb47f$export$e028bd08ccb2e98c = (mappedVersions, mode, flyoutType, solutionVersionsById)=>{
        let releaseStatusId;
        const { versions: versions, crossProjectVersions: crossProjectVersions } = mappedVersions;
        switch(flyoutType){
            case 0, $TTKUQ.RELEASE:
                releaseStatusId = versions[0] && versions[0].releaseStatusId;
                break;
            case 0, $TTKUQ.CROSS_PROJECT_RELEASE:
                releaseStatusId = (0, $diHKK.getReleaseStatus)(crossProjectVersions[0]);
                break;
            default:
                releaseStatusId = $c12c0ded97cfb47f$export$944dcaca26f5a09a(mappedVersions);
                break;
        }
        let iconType = $c12c0ded97cfb47f$var$releaseStatusToIconType[releaseStatusId];
        let slippage = null;
        if (flyoutType === (0, $TTKUQ.RELEASE) && mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771)) {
            const { id: id, end: versionEnd } = versions[0];
            const solutionVersion = solutionVersionsById[id];
            const solutionEnd = (0, $4nDwW.isDefined)(solutionVersion) ? solutionVersion.end : null;
            slippage = versionEnd ? $c12c0ded97cfb47f$export$125238b07db25e1f(solutionEnd, versionEnd) : 0;
            if (releaseStatusId !== (0, $TTKUQ.RELEASE_STATUSES).RELEASED) {
                if (slippage > 0) iconType = (0, $Dkbao.ICON_TYPES).OFFTRACK;
                else iconType = (0, $Dkbao.ICON_TYPES).ONTRACK;
            }
        }
        return iconType;
    };
    const $c12c0ded97cfb47f$export$5b2d0df9616efd9e = (versions)=>{
        if (versions.length > 1) return 0, $5801241b035f970c$export$8342016558eba865;
        if (versions[0] && $c12c0ded97cfb47f$export$e0ae1be48cdf8e5d(versions[0]) && versions[0].versions) return 0, $TTKUQ.CROSS_PROJECT_RELEASE;
        return 0, $TTKUQ.RELEASE;
    };
});
parcelRegister("7kydq", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $5564f1276f406891$var$func = $lVx1a('isUndefined', (parcelRequire("cjFoH")), (parcelRequire("bUoRH")));
    $5564f1276f406891$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $5564f1276f406891$var$func;
});
parcelRegister("ltEPm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa2bf9da9f431bb1$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5DTpU;
    var $iyWFC;
    var $fa2bf9da9f431bb1$var$all = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("5DTpU")).default)([
        'all'
    ], (0, (0, parcelRequire("iyWFC")).default), function all(fn, list) {
        var idx = 0;
        while(idx < list.length){
            if (!fn(list[idx])) return false;
            idx += 1;
        }
        return true;
    }));
    var $fa2bf9da9f431bb1$export$2e2bcd8739ae039 = $fa2bf9da9f431bb1$var$all;
});
parcelRegister("iyWFC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d838e9a96f7129ff$export$2e2bcd8739ae039);
    var $c9RLn;
    var $7C2oN;
    var $7D5kn;
    var $d838e9a96f7129ff$var$XAll = function() {
        function XAll(f, xf) {
            this.xf = xf;
            this.f = f;
            this.all = true;
        }
        XAll.prototype['@@transducer/init'] = (0, (0, parcelRequire("7D5kn")).default).init;
        XAll.prototype['@@transducer/result'] = function(result) {
            if (this.all) result = this.xf['@@transducer/step'](result, true);
            return this.xf['@@transducer/result'](result);
        };
        XAll.prototype['@@transducer/step'] = function(result, input) {
            if (!this.f(input)) {
                this.all = false;
                result = (0, (0, parcelRequire("7C2oN")).default)(this.xf['@@transducer/step'](result, false));
            }
            return result;
        };
        return XAll;
    }();
    var $d838e9a96f7129ff$var$_xall = (0, (0, parcelRequire("c9RLn")).default)(function _xall(f, xf) {
        return new $d838e9a96f7129ff$var$XAll(f, xf);
    });
    var $d838e9a96f7129ff$export$2e2bcd8739ae039 = $d838e9a96f7129ff$var$_xall;
});
parcelRegister("diHKK", function(module, exports) {
    $parcel$export(module.exports, "getReleaseStatus", ()=>$4308cdacd6bc4648$export$4f01710575377834);
    var $ltEPm;
    var $8BDMi;
    var $sqeVT;
    var $TTKUQ = parcelRequire("TTKUQ");
    const $4308cdacd6bc4648$export$4f01710575377834 = ({ versions: versions })=>{
        if ((0, parcelRequire("ltEPm")).default((0, parcelRequire("sqeVT")).default('releaseStatusId', (0, $TTKUQ.RELEASE_STATUSES).RELEASED))(versions)) return (0, $TTKUQ.RELEASE_STATUSES).RELEASED;
        if ((0, parcelRequire("8BDMi")).default((0, parcelRequire("sqeVT")).default('releaseStatusId', (0, $TTKUQ.RELEASE_STATUSES).OFFTRACK))(versions)) return (0, $TTKUQ.RELEASE_STATUSES).OFFTRACK;
        return (0, $TTKUQ.RELEASE_STATUSES).ONTRACK;
    };
});
const $5801241b035f970c$export$8342016558eba865 = 'OVERVIEW_RELEASES';
parcelRegister("Dkbao", function(module, exports) {
    $parcel$export(module.exports, "ICON_TYPES", ()=>$a4ef69e801760962$export$67e1fb76bc6def93);
    const $a4ef69e801760962$var$UNRELEASED = 'UNRELEASED';
    const $a4ef69e801760962$var$RELEASED = 'RELEASED';
    const $a4ef69e801760962$var$ONTRACK = 'ONTRACK';
    const $a4ef69e801760962$var$OFFTRACK = 'OFFTRACK';
    const $a4ef69e801760962$export$67e1fb76bc6def93 = {
        UNRELEASED: $a4ef69e801760962$var$UNRELEASED,
        RELEASED: $a4ef69e801760962$var$RELEASED,
        ONTRACK: $a4ef69e801760962$var$ONTRACK,
        OFFTRACK: $a4ef69e801760962$var$OFFTRACK
    };
});
parcelRegister("dtUdK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d24b9734d480f2e1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $4wiYB;
    var $4Rr1a;
    var $iavfW;
    var $bQZTk;
    var $2rMKg;
    var $co1wz;
    var $hE4fC;
    var $8KPOJ = parcelRequire("8KPOJ");
    var $fdrlM = parcelRequire("fdrlM");
    var $94s1F = parcelRequire("94s1F");
    var $55MBr = parcelRequire("55MBr");
    function $d24b9734d480f2e1$export$2e2bcd8739ae039({ openFlyout: openFlyout, closeFlyout: closeFlyout, releaseBarState: releaseBarState, crossProjectVersions: crossProjectVersions, mode: mode, solutionVersionsById: solutionVersionsById, versions: versions, renderMarker: renderMarker, width: width }) {
        const [zoomLevel, { scrollToView: scrollToView }] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const { isFlyoutOpen: isFlyoutOpen, versionIds: versionIds } = releaseBarState;
        const toggleFlyout = (0, $5uXOq.useCallback)((versionIds, type)=>{
            if (isFlyoutOpen) closeFlyout();
            else if (type !== undefined) openFlyout(versionIds, type);
        }, [
            openFlyout,
            closeFlyout,
            isFlyoutOpen
        ]);
        const handleScrollToViewRelease = (0, $5uXOq.useCallback)(({ timestamp: timestamp })=>{
            if (zoomLevel === undefined) return;
            scrollToView({
                timestamp: timestamp
            }, 'releaseNavButton');
        }, [
            zoomLevel,
            scrollToView
        ]);
        const finalRenderMarker = renderMarker ?? (({ mode: mode, date: date, versionIdsMapByDate: versionIdsMapByDate }, index = 0)=>{
            const showFlyout = isFlyoutOpen && versionIdsMapByDate[date].some((id)=>versionIds.includes(id));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fdrlM.default), {
                key: date,
                mode: mode,
                endDate: date,
                scrollToViewRelease: handleScrollToViewRelease,
                totalDays: Object.keys(versionIdsMapByDate).length,
                currentDayIndex: index + 1,
                versionIdsMapByDate: versionIdsMapByDate,
                showFlyout: showFlyout,
                toggleFlyout: toggleFlyout,
                width: width
            });
        });
        const getVersionIdsMapByDate = (timelineRange)=>(0, parcelRequire("bQZTk")).default((0, parcelRequire("4wiYB")).default((version)=>{
                const end = (0, $55MBr.calculateEndVersionsDate)(version, solutionVersionsById, mode);
                if (end && end >= timelineRange.start && end <= timelineRange.end) return end.toString();
                return 'undefined';
            }), (0, parcelRequire("iavfW")).default([
                'undefined'
            ]), (0, parcelRequire("4Rr1a")).default((0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('id'))))([
                ...versions,
                ...crossProjectVersions
            ]);
        const wrap = renderMarker ? (children)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (children)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.release-bar.div",
                className: (0, ($parcel$interopDefault($9ci4W)))([
                    $94s1F.main,
                    (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2') && $94s1F.transposed
                ])
            }, children);
        return wrap((0, ($parcel$interopDefault($5uXOq))).createElement((0, $8KPOJ.default), null, (timelineRange)=>{
            const withinRange = getVersionIdsMapByDate(timelineRange);
            const all = zoomLevel === undefined ? withinRange : getVersionIdsMapByDate({
                start: -Infinity,
                end: Infinity
            });
            const nodes = Object.keys(all).sort((a, b)=>Number(a) - Number(b)).reduce((acc, date, index)=>{
                if (!(date in withinRange)) return acc;
                const markerEl = finalRenderMarker({
                    mode: mode,
                    date: date,
                    versionIdsMapByDate: all
                }, index);
                acc.push(markerEl);
                return acc;
            }, []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, nodes);
        }));
    }
});
parcelRegister("8KPOJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8428b0207685bf3c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hxU6E = parcelRequire("hxU6E");
    var $5x84v = parcelRequire("5x84v");
    var $8428b0207685bf3c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hxU6E.default), {})((0, $5x84v.default));
});
parcelRegister("hxU6E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2bfd205a502b523c$export$2e2bcd8739ae039);
    var $jAIJh = parcelRequire("jAIJh");
    var $3YtPS = parcelRequire("3YtPS");
    var $2bfd205a502b523c$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        timelineRange: (0, $jAIJh.getTimelineRange)
    });
});
parcelRegister("5x84v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dd21eebfbef599d$export$2e2bcd8739ae039);
    var $hE4fC;
    function $2dd21eebfbef599d$export$2e2bcd8739ae039({ children: children, timelineRange: containerTimelineRange }) {
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const [{ timelineRange: renderingWindowTimelineRange }] = (0, (0, parcelRequire("hE4fC")).useRenderingWindow)();
        if (!zoomLevel) return children(containerTimelineRange);
        return children(renderingWindowTimelineRange);
    }
});
parcelRegister("fdrlM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d36819826c3dfc27$export$2e2bcd8739ae039);
    var $bC2fB;
    var $10ZNA = parcelRequire("10ZNA");
    var $4EYAF = parcelRequire("4EYAF");
    var $kiwBL = parcelRequire("kiwBL");
    var $d36819826c3dfc27$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $4EYAF.default), (0, $10ZNA.default))((0, $kiwBL.default));
});
parcelRegister("10ZNA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e940a89379d12297$export$2e2bcd8739ae039);
    var $j33D0 = parcelRequire("j33D0");
    var $5BBQV = parcelRequire("5BBQV");
    const $e940a89379d12297$var$mapDispatchToProps = (dispatch)=>({
            updateFlyout: (versionIds, type, prevVersionIds, dateRange)=>{
                dispatch((0, $5BBQV.updateFlyout)(versionIds, type, prevVersionIds));
                if (dateRange) {
                    dispatch((0, $j33D0.timeScaleCustomDatesChange)(dateRange));
                    dispatch({
                        type: (0, $j33D0.CHANGE_OPTION),
                        payload: 'custom'
                    });
                }
            }
        });
    var $e940a89379d12297$export$2e2bcd8739ae039 = $e940a89379d12297$var$mapDispatchToProps;
});
parcelRegister("4EYAF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$300ec92cc1066de9$export$2e2bcd8739ae039);
    var $jw86H = parcelRequire("jw86H");
    var $85IPo = parcelRequire("85IPo");
    var $jAIJh = parcelRequire("jAIJh");
    var $9FFuD = parcelRequire("9FFuD");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $300ec92cc1066de9$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        solutionVersionsById: (0, $9FFuD.getSolutionVersionsById),
        timelineRange: (0, $jAIJh.getTimelineRange),
        releaseBarState: (0, $85IPo.getReleaseBarState),
        crossProjectVersionsById: (0, $jw86H.getEnrichedCrossProjectVersionsById),
        versionsById: (0, $9FFuD.getEnrichedVersionsById),
        highlightedVersionIds: (state)=>(0, $kWDpn.getHighlightedVersionsViewSettings)(state).versions
    });
});
parcelRegister("kiwBL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db8a9fc8a9be284d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jB947;
    var $co1wz;
    var $jDMsd;
    var $J8W7q;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $g090u = parcelRequire("g090u");
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $55MBr = parcelRequire("55MBr");
    var $gT48d = parcelRequire("gT48d");
    var $7aKFO = parcelRequire("7aKFO");
    var $4ypdi = parcelRequire("4ypdi");
    const $db8a9fc8a9be284d$var$DIALOG_MIN_WIDTH = 480;
    class $db8a9fc8a9be284d$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                ReleaseFlyout: $gT48d.ProjectRelease,
                CrossProjectReleaseFlyout: $gT48d.CrossProjectRelease,
                OverviewReleasesFlyout: $gT48d.OverviewReleases,
                ZIndex: $eHJCm.ZIndex
            };
        }
        render() {
            const { mode: mode, endDate: endDate, versionIdsMapByDate: versionIdsMapByDate, timelineRange: timelineRange, width: timelineWidth, showFlyout: showFlyout, toggleFlyout: toggleFlyout, solutionVersionsById: solutionVersionsById, highlightedVersionIds: highlightedVersionIds, ZIndex: ZIndex } = this.props;
            if (!(0, $4nDwW.isDefined)(endDate)) return null;
            const mappedVersions = this.mapVersionsById(versionIdsMapByDate[endDate]);
            const releaseId = (0, parcelRequire("jB947")).default(versionIdsMapByDate[endDate]);
            const { versions: versions, crossProjectVersions: crossProjectVersions } = mappedVersions;
            const versionFlyoutType = (0, $55MBr.getVersionFlyoutType)([
                ...versions,
                ...crossProjectVersions
            ]);
            const leftPositionPercentage = (0, $55MBr.calculateLeftPositionPercentage)(Number(endDate), timelineRange);
            const isHighlighted = !!versionIdsMapByDate[endDate].find((versionId)=>highlightedVersionIds.some((version)=>version === versionId));
            const withZIndexOverride = (children)=>{
                if (!(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2')) return children(undefined);
                return ZIndex ? (0, ($parcel$interopDefault($5uXOq))).createElement(ZIndex, {
                    layer: (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS
                }, (zIndex)=>children(zIndex ?? 'initial')) : null;
            };
            return withZIndexOverride((zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: (node)=>{
                        if (node) this.ref = node;
                    },
                    tabIndex: -1,
                    className: $4ypdi.main,
                    style: {
                        left: `calc(${leftPositionPercentage}% - ${"var(--ds-space-150, 12px)"})`,
                        zIndex: zIndex
                    },
                    onKeyDown: this.onKeyDown,
                    role: "button",
                    "data-name": releaseId && `release-marker-${releaseId}`,
                    "data-testid": releaseId && `release-marker-${releaseId}`,
                    onMouseEnter: (0, $gT48d.preload)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDMsd")).default), {
                    isOpen: showFlyout,
                    minLeft: 0,
                    renderDialog: (element)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                            content: this.renderFlyout(),
                            isOpen: true,
                            placement: (0, $g090u.getFlyoutPosition)(timelineWidth, leftPositionPercentage, this.state.flyoutWidth),
                            onClose: this.handleFlyoutRequestClose,
                            noPaddings: true,
                            noHorizontalScroll: true,
                            closeOnScroll: true,
                            minWidth: $db8a9fc8a9be284d$var$DIALOG_MIN_WIDTH,
                            testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.release-bar.marker.inline-dialog.${releaseId}`
                        }, element),
                    renderTrigger: (ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $7aKFO.default), {
                            endDate: endDate,
                            innerRef: ref,
                            isHighlighted: isHighlighted,
                            onClick: ()=>{
                                this.getFlyoutWidth();
                                toggleFlyout(versionIdsMapByDate[endDate], versionFlyoutType);
                            },
                            release: this.props.versionsById[versionIdsMapByDate[endDate][0]],
                            totalCount: versionIdsMapByDate[endDate].length,
                            showTooltip: true,
                            type: (0, $55MBr.getMarkerTypeIcon)(mappedVersions, mode, versionFlyoutType, solutionVersionsById)
                        })
                })));
        }
        constructor(...args){
            super(...args);
            this.state = {
                flyoutWidth: $db8a9fc8a9be284d$var$DIALOG_MIN_WIDTH
            };
            this.flyoutRef = (0, $5uXOq.createRef)();
            this.isKeyboardEventEnter = (event)=>{
                const { key: key } = event;
                return !event.nativeEvent.isComposing && key.trim().toLowerCase() === 'enter';
            };
            this.isKeyboardEventSpace = (event)=>{
                const { key: key = '' } = event;
                return !event.nativeEvent.isComposing && (key === ' ' || key.trim().toLowerCase() === 'space');
            };
            this.onKeyDown = (event)=>{
                const { toggleFlyout: toggleFlyout, versionIdsMapByDate: versionIdsMapByDate, endDate: endDate, type: type } = this.props;
                if (this.isKeyboardEventEnter(event) || this.isKeyboardEventSpace(event)) toggleFlyout(versionIdsMapByDate[endDate], type);
            };
            this.handleBack = (prevVersionIds)=>{
                const { updateFlyout: updateFlyout } = this.props;
                this.getFlyoutWidth();
                updateFlyout(prevVersionIds, (0, $5801241b035f970c$export$8342016558eba865), []);
            };
            this.navigateTo = (date, direction)=>{
                const { versionIdsMapByDate: versionIdsMapByDate, updateFlyout: updateFlyout, timelineRange: timelineRange, scrollToViewRelease: scrollToViewRelease } = this.props;
                const dates = Object.keys(versionIdsMapByDate).sort((a, b)=>Number(a) - Number(b));
                const nextDate = direction === 'next' ? dates[dates.indexOf(date) + 1] : dates[dates.indexOf(date) - 1];
                const { versions: versions, crossProjectVersions: crossProjectVersions } = this.mapVersionsById(versionIdsMapByDate[nextDate]);
                const nextTimelineRange = Number(nextDate) < timelineRange.start || Number(nextDate) > timelineRange.end ? (0, $55MBr.calculateNewTimelineRange)(Number(nextDate), timelineRange) : undefined;
                this.getFlyoutWidth();
                scrollToViewRelease?.call(null, {
                    timestamp: parseInt(nextDate, 10)
                });
                setTimeout(()=>updateFlyout(versionIdsMapByDate[nextDate], (0, $55MBr.getVersionFlyoutType)([
                        ...versions,
                        ...crossProjectVersions
                    ]), [], nextTimelineRange), 1);
            };
            this.getReleaseFlyout = (version)=>{
                if (!version) return null;
                const { solutionVersionsById: solutionVersionsById, CrossProjectReleaseFlyout: CrossProjectReleaseFlyout, ReleaseFlyout: ReleaseFlyout, mode: mode } = this.props;
                const versionType = (0, $55MBr.isVersionCrossProject)(version) && version.versions ? (0, $TTKUQ.CROSS_PROJECT_RELEASE) : (0, $TTKUQ.RELEASE);
                if (versionType === (0, $TTKUQ.RELEASE) && version.end) {
                    const { id: id, end: end } = version;
                    const solutionVersion = solutionVersionsById[id];
                    const solutionEnd = (0, $4nDwW.isDefined)(solutionVersion) ? solutionVersion.end : null;
                    const slippage = versionType === (0, $TTKUQ.RELEASE) && mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771) ? (0, $55MBr.calculateSlippage)(solutionEnd, end) : null;
                    return ReleaseFlyout ? (0, ($parcel$interopDefault($5uXOq))).createElement(ReleaseFlyout, {
                        version: version,
                        solutionVersion: solutionVersion,
                        slippage: slippage,
                        onBackHandler: this.handleBack
                    }) : null;
                }
                return CrossProjectReleaseFlyout ? (0, ($parcel$interopDefault($5uXOq))).createElement(CrossProjectReleaseFlyout, {
                    crossProjectVersion: version,
                    onBackHandler: this.handleBack
                }) : null;
            };
            this.handleFlyoutRequestClose = ()=>{
                const { toggleFlyout: toggleFlyout, versionIdsMapByDate: versionIdsMapByDate, endDate: endDate, type: type } = this.props;
                toggleFlyout(versionIdsMapByDate[endDate], type);
            };
            this.renderFlyout = ()=>{
                const { endDate: endDate, currentDayIndex: currentDayIndex, totalDays: totalDays, releaseBarState: { mode: flyoutType, versionIds: versionIds }, OverviewReleasesFlyout: OverviewReleasesFlyout } = this.props;
                const { versions: versions, crossProjectVersions: crossProjectVersions } = this.mapVersionsById(versionIds);
                const allVersions = [
                    ...versions,
                    ...crossProjectVersions
                ];
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: this.flyoutRef
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $gT48d.Navigation), {
                    onPrev: ()=>{
                        this.navigateTo(endDate, 'prev');
                    },
                    onNext: ()=>{
                        this.navigateTo(endDate, 'next');
                    },
                    currentDayIndex: currentDayIndex,
                    totalDays: totalDays,
                    markerRef: this.ref
                }), flyoutType === (0, $5801241b035f970c$export$8342016558eba865) && OverviewReleasesFlyout ? (0, ($parcel$interopDefault($5uXOq))).createElement(OverviewReleasesFlyout, {
                    versions: allVersions,
                    date: Number(endDate),
                    onPreviewRelease: (id, versionType)=>{
                        this.props.updateFlyout([
                            id
                        ], versionType, versionIds);
                    }
                }) : this.getReleaseFlyout(allVersions[0]));
            };
            this.mapVersionsById = (ids)=>{
                const { crossProjectVersionsById: crossProjectVersionsById, versionsById: versionsById, solutionVersionsById: solutionVersionsById, mode: mode } = this.props;
                const crossProjectVersions = [];
                const versions = [];
                ids.forEach((id)=>{
                    const version = versionsById[id];
                    if (version) {
                        const end = version.end || (0, $55MBr.calculateEndVersionsDate)(version, solutionVersionsById, mode);
                        versions.push({
                            ...version,
                            end: end
                        });
                    } else crossProjectVersions.push(crossProjectVersionsById[id]);
                });
                return {
                    versions: versions,
                    crossProjectVersions: crossProjectVersions
                };
            };
            this.getFlyoutWidth = ()=>{
                const { width: flyoutWidth = $db8a9fc8a9be284d$var$DIALOG_MIN_WIDTH } = this.flyoutRef.current ? this.flyoutRef.current.getBoundingClientRect() : {};
                this.setState(()=>({
                        flyoutWidth: flyoutWidth
                    }));
            };
        }
    }
});
parcelRegister("jDMsd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bce190c56949edf2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    function $bce190c56949edf2$export$2e2bcd8739ae039({ isOpen: isOpen, renderDialog: renderDialog, renderTrigger: renderTrigger, minLeft: minLeft }) {
        const ref = (0, $5uXOq.useRef)(null);
        const [rect, setRect] = (0, $5uXOq.useState)(null);
        const fakeTriggerStyle = {
            position: 'absolute',
            ...rect,
            pointerEvents: 'none'
        };
        const containerElement = document.body;
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && ref.current != null) {
                const { top: top, left: left, width: width, height: height } = ref.current.getBoundingClientRect();
                const maxLeft = window.innerWidth;
                const finalLeft = Math.min(Math.max(left, minLeft), maxLeft);
                const maxWidth = window.innerWidth - finalLeft;
                const finalWidth = Math.min(width, maxWidth);
                setRect({
                    top: top,
                    height: height,
                    left: finalLeft,
                    width: finalWidth
                });
            }
        }, [
            isOpen,
            minLeft
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderTrigger(ref), isOpen && containerElement != null && (0, $7nsd3.createPortal)(renderDialog((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: fakeTriggerStyle
        })), containerElement));
    }
});
parcelRegister("g090u", function(module, exports) {
    $parcel$export(module.exports, "getFlyoutPosition", ()=>$7b84219dd5c7a318$export$42128c7073828e83);
    const $7b84219dd5c7a318$export$42128c7073828e83 = (timelineWidth, leftPositionPercentage, flyoutWidth)=>{
        if (timelineWidth && timelineWidth - timelineWidth * leftPositionPercentage / 100 <= flyoutWidth) return 'bottom-end';
        return 'bottom-start';
    };
});
parcelRegister("gT48d", function(module, exports) {
    $parcel$export(module.exports, "CrossProjectRelease", ()=>$87f5da9a9953f68f$export$4d045b8f9015a10);
    $parcel$export(module.exports, "Navigation", ()=>$87f5da9a9953f68f$export$b8a61e5c71402559);
    $parcel$export(module.exports, "OverviewReleases", ()=>$87f5da9a9953f68f$export$781433a82c4e6ed2);
    $parcel$export(module.exports, "ProjectRelease", ()=>$87f5da9a9953f68f$export$172e15254bd94e8c);
    $parcel$export(module.exports, "preload", ()=>$87f5da9a9953f68f$export$513ccb98c53b8039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $87f5da9a9953f68f$var$async = ()=>(parcelRequire("3wvdZ"));
    const $87f5da9a9953f68f$var$AsyncCrossProjectRelease = (0, (0, parcelRequire("kxZPA")).lazy)(()=>$87f5da9a9953f68f$var$async().then(({ CrossProjectRelease: CrossProjectRelease })=>CrossProjectRelease), {});
    const $87f5da9a9953f68f$export$4d045b8f9015a10 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "cross-project-release",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87f5da9a9953f68f$var$AsyncCrossProjectRelease, props));
    const $87f5da9a9953f68f$var$AsyncNavigation = (0, (0, parcelRequire("kxZPA")).lazy)(()=>$87f5da9a9953f68f$var$async().then(({ Navigation: Navigation })=>Navigation), {});
    const $87f5da9a9953f68f$export$b8a61e5c71402559 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "navigation",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87f5da9a9953f68f$var$AsyncNavigation, props));
    const $87f5da9a9953f68f$var$AsyncOverviewReleases = (0, (0, parcelRequire("kxZPA")).lazy)(()=>$87f5da9a9953f68f$var$async().then(({ OverviewReleases: OverviewReleases })=>OverviewReleases), {});
    const $87f5da9a9953f68f$export$781433a82c4e6ed2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "overview-releases",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87f5da9a9953f68f$var$AsyncOverviewReleases, props));
    const $87f5da9a9953f68f$var$AsyncProjectRelease = (0, (0, parcelRequire("kxZPA")).lazy)(()=>$87f5da9a9953f68f$var$async().then(({ ProjectRelease: ProjectRelease })=>ProjectRelease), {});
    const $87f5da9a9953f68f$export$172e15254bd94e8c = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-release",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87f5da9a9953f68f$var$AsyncProjectRelease, props));
    const $87f5da9a9953f68f$var$AsyncQuickFilterByRelease = (0, (0, parcelRequire("kxZPA")).lazy)(()=>$87f5da9a9953f68f$var$async().then(({ QuickFilterByRelease: QuickFilterByRelease })=>QuickFilterByRelease), {});
    const $87f5da9a9953f68f$export$a7703d8b0600b572 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "quick-filter-by-release",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87f5da9a9953f68f$var$AsyncQuickFilterByRelease, props));
    const $87f5da9a9953f68f$var$AsyncReleaseDates = (0, (0, parcelRequire("kxZPA")).lazy)(()=>$87f5da9a9953f68f$var$async().then(({ ReleaseDates: ReleaseDates })=>ReleaseDates), {});
    const $87f5da9a9953f68f$export$6fbb35d9a76cc6f0 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "release-dates",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($87f5da9a9953f68f$var$AsyncReleaseDates, props));
    const $87f5da9a9953f68f$export$513ccb98c53b8039 = ()=>{
        $87f5da9a9953f68f$var$AsyncCrossProjectRelease.preload();
        $87f5da9a9953f68f$var$AsyncNavigation.preload();
        $87f5da9a9953f68f$var$AsyncOverviewReleases.preload();
        $87f5da9a9953f68f$var$AsyncProjectRelease.preload();
        $87f5da9a9953f68f$var$AsyncQuickFilterByRelease.preload();
        $87f5da9a9953f68f$var$AsyncReleaseDates.preload();
    };
});
parcelRegister("3wvdZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("cKp1B")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cB59n")
    ]).then(()=>parcelRequire('4RYv6'));
});
parcelRegister("7aKFO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd19612d38c6d546$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jUUuf;
    var $3bDjY;
    var $8RXs9;
    var $gh61P;
    var $aipk9;
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    var $97VQ6 = parcelRequire("97VQ6");
    var $iHXO3 = parcelRequire("iHXO3");
    var $lTPty = parcelRequire("lTPty");
    var $i1KaW = parcelRequire("i1KaW");
    var $6bzMU = parcelRequire("6bzMU");
    var $cu02P = parcelRequire("cu02P");
    var $cu02P = parcelRequire("cu02P");
    const $cd19612d38c6d546$var$typeToClassName = {
        [(0, $cu02P.ICON_TYPES).UNRELEASED]: $6bzMU.unreleasedSpa,
        [(0, $cu02P.ICON_TYPES).RELEASED]: $6bzMU.releasedSpa,
        [(0, $cu02P.ICON_TYPES).ONTRACK]: $6bzMU.onTrackSpa,
        [(0, $cu02P.ICON_TYPES).OFFTRACK]: $6bzMU.offTrackSpa
    };
    class $cd19612d38c6d546$var$ReleaseMarkerIcon extends (0, $5uXOq.Component) {
        render() {
            const { innerRef: innerRef, intl: intl, isHighlighted: isHighlighted, onClick: onClick, release: release, showTooltip: showTooltip = false, totalCount: totalCount, type: type } = this.props;
            const styleName = $cd19612d38c6d546$var$typeToClassName[type];
            const releaseName = totalCount === 1 && (0, $4nDwW.isDefined)(release) ? release.name : null;
            const icon = (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                className: $6bzMU.button,
                onClick: ()=>onClick(),
                "aria-labelledby": type?.toLowerCase()
            }, this.getIcon());
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.release-bar.marker.icon",
                ref: innerRef,
                className: $6bzMU.marker
            }, totalCount > 1 && (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $6bzMU.number
            }, Math.min(totalCount, 99)), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $6bzMU.icon
            }, showTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $6bzMU.releaseTooltip
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jUUuf"))))), {
                    label: intl.formatMessage((0, $ihPUd.default).release),
                    size: "small"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    className: $6bzMU.releaseTooltipName
                }, totalCount > 1 ? intl.formatMessage((0, $97VQ6.default).releases, {
                    numberOfReleases: totalCount
                }) : releaseName), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    className: $6bzMU.releaseTooltipDate
                }, `(${(0, (0, parcelRequire("aipk9")).formatTimestampWithIntl)(intl, Number(this.props.endDate), (0, (0, parcelRequire("gh61P")).shortDateFormat))})`)),
                truncate: true
            }, icon) : icon), isHighlighted === true && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: `${$6bzMU["timeline-highlight"]} ${styleName}`
            }));
        }
        constructor(...args){
            super(...args);
            this.getIcon = ()=>{
                const { totalCount: totalCount, type: type } = this.props;
                switch(type){
                    case (0, $cu02P.ICON_TYPES).UNRELEASED:
                    case (0, $cu02P.ICON_TYPES).ONTRACK:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lTPty.OnTrackIcon), null);
                    case (0, $cu02P.ICON_TYPES).RELEASED:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $i1KaW.ReleasedIcon), {
                            totalCount: totalCount
                        });
                    case (0, $cu02P.ICON_TYPES).OFFTRACK:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iHXO3.OffTrackIcon), {
                            totalCount: totalCount
                        });
                    default:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lTPty.OnTrackIcon), null);
                }
            };
        }
    }
    var $cd19612d38c6d546$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($cd19612d38c6d546$var$ReleaseMarkerIcon);
});
parcelRegister("97VQ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d449ff59e5844b88$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d449ff59e5844b88$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releases: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.release-bar.marker.icon.releases",
            "defaultMessage": "{numberOfReleases, plural, one {{numberOfReleases} release} other {{numberOfReleases} releases}}"
        }
    });
});
parcelRegister("iHXO3", function(module, exports) {
    $parcel$export(module.exports, "OffTrackIcon", ()=>$b1eea08d3e8bd596$export$9e19a5a781ddb256);
    var $5uXOq = parcelRequire("5uXOq");
    const $b1eea08d3e8bd596$export$9e19a5a781ddb256 = ({ totalCount: totalCount })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 24,
            height: 24
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fill: "none",
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
            cx: 12,
            cy: 12,
            r: 7
        }), totalCount === 1 && (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        })));
});
parcelRegister("lTPty", function(module, exports) {
    $parcel$export(module.exports, "OnTrackIcon", ()=>$67834487b6285694$export$bc19b352e3a970e3);
    var $5uXOq = parcelRequire("5uXOq");
    const $67834487b6285694$export$bc19b352e3a970e3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 24,
            height: 24
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fill: "none",
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            fill: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            cx: 12,
            cy: 12,
            r: 7
        })));
});
parcelRegister("i1KaW", function(module, exports) {
    $parcel$export(module.exports, "ReleasedIcon", ()=>$5e63cfcee5f42bbe$export$b7ea68e2486fd486);
    var $5uXOq = parcelRequire("5uXOq");
    const $5e63cfcee5f42bbe$export$b7ea68e2486fd486 = ({ totalCount: totalCount })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: 24,
            height: 24
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fill: "none",
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
            cx: 12,
            cy: 12,
            r: 7
        }), totalCount === 1 && (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M10.28 11.91a.698.698 0 0 0-1.06 0 .9.9 0 0 0 0 1.18l1.5 1.666a.698.698 0 0 0 1.06 0l3-3.333a.9.9 0 0 0 0-1.179.698.698 0 0 0-1.06 0l-2.47 2.744-.97-1.077z",
            fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
        })));
});
parcelRegister("6bzMU", function(module, exports) {
    $parcel$export(module.exports, "button", ()=>$480f87df86823742$export$2ba01fb71ed41cb6, (v)=>$480f87df86823742$export$2ba01fb71ed41cb6 = v);
    $parcel$export(module.exports, "icon", ()=>$480f87df86823742$export$1ca1ec8b29a4ce27, (v)=>$480f87df86823742$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "marker", ()=>$480f87df86823742$export$ffc4d0086f1a4c9, (v)=>$480f87df86823742$export$ffc4d0086f1a4c9 = v);
    $parcel$export(module.exports, "number", ()=>$480f87df86823742$export$98e628dec113755e, (v)=>$480f87df86823742$export$98e628dec113755e = v);
    $parcel$export(module.exports, "offTrackSpa", ()=>$480f87df86823742$export$52dc3309278578d6, (v)=>$480f87df86823742$export$52dc3309278578d6 = v);
    $parcel$export(module.exports, "onTrackSpa", ()=>$480f87df86823742$export$a464d72f81a24b05, (v)=>$480f87df86823742$export$a464d72f81a24b05 = v);
    $parcel$export(module.exports, "releaseTooltip", ()=>$480f87df86823742$export$829d3d179a7c0145, (v)=>$480f87df86823742$export$829d3d179a7c0145 = v);
    $parcel$export(module.exports, "releaseTooltipDate", ()=>$480f87df86823742$export$ac3c726209525cbe, (v)=>$480f87df86823742$export$ac3c726209525cbe = v);
    $parcel$export(module.exports, "releaseTooltipName", ()=>$480f87df86823742$export$113aec36574c607c, (v)=>$480f87df86823742$export$113aec36574c607c = v);
    $parcel$export(module.exports, "releasedSpa", ()=>$480f87df86823742$export$3ade0ee46fc07220, (v)=>$480f87df86823742$export$3ade0ee46fc07220 = v);
    $parcel$export(module.exports, "timeline-highlight", ()=>$480f87df86823742$export$29dd82e5678ebfaa, (v)=>$480f87df86823742$export$29dd82e5678ebfaa = v);
    $parcel$export(module.exports, "unreleasedSpa", ()=>$480f87df86823742$export$9ea42929461af5b, (v)=>$480f87df86823742$export$9ea42929461af5b = v);
    var $480f87df86823742$export$2ba01fb71ed41cb6;
    var $480f87df86823742$export$1ca1ec8b29a4ce27;
    var $480f87df86823742$export$ffc4d0086f1a4c9;
    var $480f87df86823742$export$98e628dec113755e;
    var $480f87df86823742$export$cd48b0013ee54170;
    var $480f87df86823742$export$52dc3309278578d6;
    var $480f87df86823742$export$8e8c195be1d237dd;
    var $480f87df86823742$export$a464d72f81a24b05;
    var $480f87df86823742$export$829d3d179a7c0145;
    var $480f87df86823742$export$ac3c726209525cbe;
    var $480f87df86823742$export$113aec36574c607c;
    var $480f87df86823742$export$20319b0a6bbbd02c;
    var $480f87df86823742$export$3ade0ee46fc07220;
    var $480f87df86823742$export$29dd82e5678ebfaa;
    var $480f87df86823742$export$975896b31953f2ae;
    var $480f87df86823742$export$9ea42929461af5b;
    $480f87df86823742$export$2ba01fb71ed41cb6 = `N8JWya_button`;
    $480f87df86823742$export$1ca1ec8b29a4ce27 = `N8JWya_icon`;
    $480f87df86823742$export$ffc4d0086f1a4c9 = `N8JWya_marker`;
    $480f87df86823742$export$98e628dec113755e = `N8JWya_number`;
    $480f87df86823742$export$cd48b0013ee54170 = `N8JWya_offTrack`;
    $480f87df86823742$export$52dc3309278578d6 = `N8JWya_offTrackSpa`;
    $480f87df86823742$export$8e8c195be1d237dd = `N8JWya_onTrack`;
    $480f87df86823742$export$a464d72f81a24b05 = `N8JWya_onTrackSpa`;
    $480f87df86823742$export$829d3d179a7c0145 = `N8JWya_releaseTooltip`;
    $480f87df86823742$export$ac3c726209525cbe = `N8JWya_releaseTooltipDate`;
    $480f87df86823742$export$113aec36574c607c = `N8JWya_releaseTooltipName`;
    $480f87df86823742$export$20319b0a6bbbd02c = `N8JWya_released`;
    $480f87df86823742$export$3ade0ee46fc07220 = `N8JWya_releasedSpa`;
    $480f87df86823742$export$29dd82e5678ebfaa = `N8JWya_timeline-highlight`;
    $480f87df86823742$export$975896b31953f2ae = `N8JWya_unreleased`;
    $480f87df86823742$export$9ea42929461af5b = `N8JWya_unreleasedSpa`;
});
parcelRegister("cu02P", function(module, exports) {
    $parcel$export(module.exports, "ICON_TYPES", ()=>$935cdb3f5f507cf8$export$67e1fb76bc6def93);
    const $935cdb3f5f507cf8$var$UNRELEASED = 'UNRELEASED';
    const $935cdb3f5f507cf8$var$RELEASED = 'RELEASED';
    const $935cdb3f5f507cf8$var$ONTRACK = 'ONTRACK';
    const $935cdb3f5f507cf8$var$OFFTRACK = 'OFFTRACK';
    const $935cdb3f5f507cf8$export$67e1fb76bc6def93 = {
        UNRELEASED: $935cdb3f5f507cf8$var$UNRELEASED,
        RELEASED: $935cdb3f5f507cf8$var$RELEASED,
        ONTRACK: $935cdb3f5f507cf8$var$ONTRACK,
        OFFTRACK: $935cdb3f5f507cf8$var$OFFTRACK
    };
});
parcelRegister("4ypdi", function(module, exports) {
    $parcel$export(module.exports, "main", ()=>$350de542601bf045$export$f22da7240b7add18, (v)=>$350de542601bf045$export$f22da7240b7add18 = v);
    var $350de542601bf045$export$f22da7240b7add18;
    $350de542601bf045$export$f22da7240b7add18 = `h7JH4W_main`;
});
parcelRegister("94s1F", function(module, exports) {
    $parcel$export(module.exports, "main", ()=>$69aa3a1ec047d0b6$export$f22da7240b7add18, (v)=>$69aa3a1ec047d0b6$export$f22da7240b7add18 = v);
    $parcel$export(module.exports, "transposed", ()=>$69aa3a1ec047d0b6$export$6220fe35ddf63109, (v)=>$69aa3a1ec047d0b6$export$6220fe35ddf63109 = v);
    var $69aa3a1ec047d0b6$export$f22da7240b7add18;
    var $69aa3a1ec047d0b6$export$6220fe35ddf63109;
    $69aa3a1ec047d0b6$export$f22da7240b7add18 = `jzvgOW_main`;
    $69aa3a1ec047d0b6$export$6220fe35ddf63109 = `jzvgOW_transposed`;
});
parcelRegister("ecV7B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50c93474ee2b9cba$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7fRZ6 = parcelRequire("7fRZ6");
    var $jLNYt = parcelRequire("jLNYt");
    var $50c93474ee2b9cba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7fRZ6.default), {})((0, $jLNYt.default));
});
parcelRegister("7fRZ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db3ad5dc80ee0e64$export$2e2bcd8739ae039);
    var $jw86H = parcelRequire("jw86H");
    var $jAIJh = parcelRequire("jAIJh");
    var $9FFuD = parcelRequire("9FFuD");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $db3ad5dc80ee0e64$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        solutionVersionsById: (0, $9FFuD.getSolutionVersionsById),
        timelineRange: (0, $jAIJh.getTimelineRange),
        crossProjectVersionsById: (0, $jw86H.getEnrichedCrossProjectVersionsById),
        versionsById: (0, $9FFuD.getEnrichedVersionsById),
        highlightedVersionIds: (state)=>(0, $kWDpn.getHighlightedVersionsViewSettings)(state).versions
    });
});
parcelRegister("jLNYt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06697d3b1e5dda3e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $co1wz;
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $Dkbao = parcelRequire("Dkbao");
    var $55MBr = parcelRequire("55MBr");
    var $6iEC2 = parcelRequire("6iEC2");
    const $06697d3b1e5dda3e$var$typeToClassNameSpa = {
        [(0, $Dkbao.ICON_TYPES).UNRELEASED]: $6iEC2.unreleasedSpa,
        [(0, $Dkbao.ICON_TYPES).RELEASED]: $6iEC2.releasedSpa,
        [(0, $Dkbao.ICON_TYPES).ONTRACK]: $6iEC2.onTrackSpa,
        [(0, $Dkbao.ICON_TYPES).OFFTRACK]: $6iEC2.offTrackSpa
    };
    class $06697d3b1e5dda3e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { endDate: endDate, mode: mode, solutionVersionsById: solutionVersionsById, timelineRange: timelineRange, versionIdsMapByDate: versionIdsMapByDate, highlightedVersionIds: highlightedVersionIds } = this.props;
            const isHighlighted = versionIdsMapByDate[endDate] && versionIdsMapByDate[endDate].find((versionId)=>highlightedVersionIds.some((vid)=>vid === versionId));
            if (!isHighlighted) return null;
            const leftPositionPercentage = (0, $55MBr.calculateLeftPositionPercentage)(Number(endDate), timelineRange);
            const mappedVersions = this.mapVersionsById(versionIdsMapByDate[endDate]);
            const { versions: versions, crossProjectVersions: crossProjectVersions } = mappedVersions;
            const versionFlyoutType = (0, $55MBr.getVersionFlyoutType)([
                ...versions,
                ...crossProjectVersions
            ]);
            const type = (0, $55MBr.getMarkerTypeIcon)(mappedVersions, mode, versionFlyoutType, solutionVersionsById);
            const withZIndexOverride = (children)=>{
                if (!(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2')) return children(undefined);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
                    layer: (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS
                }, (zIndex)=>children(zIndex ?? 'initial'));
            };
            return withZIndexOverride((zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: (0, ($parcel$interopDefault($9ci4W)))($6iEC2.marker, (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2') && $6iEC2.transposed, $06697d3b1e5dda3e$var$typeToClassNameSpa[type]),
                    style: {
                        left: `calc(${leftPositionPercentage}% - 1px)`,
                        zIndex: zIndex
                    }
                }));
        }
        constructor(...args){
            super(...args);
            this.mapVersionsById = (ids)=>{
                const { crossProjectVersionsById: crossProjectVersionsById, versionsById: versionsById } = this.props;
                const crossProjectVersions = [];
                const versions = [];
                ids.forEach((id)=>{
                    const version = versionsById[id];
                    if (version) versions.push(version);
                    else crossProjectVersions.push(crossProjectVersionsById[id]);
                });
                return {
                    versions: versions,
                    crossProjectVersions: crossProjectVersions
                };
            };
        }
    }
});
parcelRegister("6iEC2", function(module, exports) {
    $parcel$export(module.exports, "marker", ()=>$4963ed4f32432384$export$ffc4d0086f1a4c9, (v)=>$4963ed4f32432384$export$ffc4d0086f1a4c9 = v);
    $parcel$export(module.exports, "offTrackSpa", ()=>$4963ed4f32432384$export$52dc3309278578d6, (v)=>$4963ed4f32432384$export$52dc3309278578d6 = v);
    $parcel$export(module.exports, "onTrackSpa", ()=>$4963ed4f32432384$export$a464d72f81a24b05, (v)=>$4963ed4f32432384$export$a464d72f81a24b05 = v);
    $parcel$export(module.exports, "releasedSpa", ()=>$4963ed4f32432384$export$3ade0ee46fc07220, (v)=>$4963ed4f32432384$export$3ade0ee46fc07220 = v);
    $parcel$export(module.exports, "transposed", ()=>$4963ed4f32432384$export$6220fe35ddf63109, (v)=>$4963ed4f32432384$export$6220fe35ddf63109 = v);
    $parcel$export(module.exports, "unreleasedSpa", ()=>$4963ed4f32432384$export$9ea42929461af5b, (v)=>$4963ed4f32432384$export$9ea42929461af5b = v);
    var $4963ed4f32432384$export$ffc4d0086f1a4c9;
    var $4963ed4f32432384$export$52dc3309278578d6;
    var $4963ed4f32432384$export$a464d72f81a24b05;
    var $4963ed4f32432384$export$3ade0ee46fc07220;
    var $4963ed4f32432384$export$6220fe35ddf63109;
    var $4963ed4f32432384$export$9ea42929461af5b;
    $4963ed4f32432384$export$ffc4d0086f1a4c9 = `VTbVHG_marker`;
    $4963ed4f32432384$export$52dc3309278578d6 = `VTbVHG_offTrackSpa`;
    $4963ed4f32432384$export$a464d72f81a24b05 = `VTbVHG_onTrackSpa`;
    $4963ed4f32432384$export$3ade0ee46fc07220 = `VTbVHG_releasedSpa`;
    $4963ed4f32432384$export$6220fe35ddf63109 = `VTbVHG_transposed`;
    $4963ed4f32432384$export$9ea42929461af5b = `VTbVHG_unreleasedSpa`;
});
parcelRegister("jFeQO", function(module, exports) {
    $parcel$export(module.exports, "TimelineTableGroup", ()=>$6ac8aa70e265a0a1$export$95e6c264a93af093);
    var $bC2fB;
    var $kxzHm = parcelRequire("kxzHm");
    var $anMOQ = parcelRequire("anMOQ");
    const $6ac8aa70e265a0a1$export$95e6c264a93af093 = (0, (0, parcelRequire("bC2fB")).connect)((0, $kxzHm.default), {})((0, $anMOQ.TimelineTableGroup));
});
parcelRegister("kxzHm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df180a13718d36dc$export$2e2bcd8739ae039);
    var $jAIJh = parcelRequire("jAIJh");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $df180a13718d36dc$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        showCapacity: (0, $j0XCX.getShowSprints),
        timelineRange: (0, $jAIJh.getTimelineRange)
    });
});
parcelRegister("anMOQ", function(module, exports) {
    $parcel$export(module.exports, "TimelineTableGroup", ()=>$7635324ef449d16b$export$95e6c264a93af093);
    var $5uXOq = parcelRequire("5uXOq");
    var $6iNxz = parcelRequire("6iNxz");
    var $kyrvN = parcelRequire("kyrvN");
    var $2GpCn = parcelRequire("2GpCn");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    function $7635324ef449d16b$export$95e6c264a93af093({ item: item, showCapacity: showCapacity, timelineRange: timelineRange }) {
        if (item.tag !== (0, $6iNxz.TABLE_GROUP)) throw new Error(`renderGroup could only render ${(0, $6iNxz.TABLE_GROUP)} items, but got ${item.tag}`);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, showCapacity && item.grouping === (0, $TTKUQ.GROUPING).TEAM && (0, $4nDwW.isDefined)(item.groupCombination.team) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2GpCn.default), {
            team: item.groupCombination.team,
            timelineRange: timelineRange
        }), showCapacity && item.grouping === (0, $TTKUQ.GROUPING).SPRINT && (0, $4nDwW.isDefined)(item.groupCombination.team) && (0, $4nDwW.isDefined)(item.groupCombination.sprint) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kyrvN.default), {
            team: item.groupCombination.team,
            sprint: item.groupCombination.sprint,
            timelineRange: timelineRange
        }));
    }
});
parcelRegister("kyrvN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1aedd82a1803813e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gJZ5D;
    var $hE4fC;
    var $bC2fB;
    var $e79al = parcelRequire("e79al");
    var $7ucaE = parcelRequire("7ucaE");
    var $gm87o = parcelRequire("gm87o");
    const $1aedd82a1803813e$var$Capacities = (0, (0, parcelRequire("bC2fB")).connect)((0, $7ucaE.default), {})((0, $gm87o.default));
    const $1aedd82a1803813e$export$ba50afc461737701 = ({ timelineRange: timelineRangeFromProps, ...rest })=>{
        const [{ getPercentageOffsetFromToday: getPercentageOffsetFromToday }] = (0, (0, parcelRequire("hE4fC")).useHorizontalPercentageOffset)();
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const [{ timelineRange: timelineRange }] = (0, (0, parcelRequire("hE4fC")).useRenderingWindow)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $e79al.default), {
            bgColor: `var(--ds-surface, ${(0, (0, parcelRequire("gJZ5D")).default).N0})`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1aedd82a1803813e$var$Capacities, {
            ...rest,
            timelineRange: zoomLevel ? timelineRange : timelineRangeFromProps,
            zoomLevel: zoomLevel,
            getPercentageOffsetFromToday: getPercentageOffsetFromToday
        }));
    };
    var $1aedd82a1803813e$export$2e2bcd8739ae039 = $1aedd82a1803813e$export$ba50afc461737701;
});
parcelRegister("7ucaE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85c2f63ac302a6f0$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    var $d3quy = parcelRequire("d3quy");
    var $jpgxP = parcelRequire("jpgxP");
    var $dRVQG = parcelRequire("dRVQG");
    var $jAIJh = parcelRequire("jAIJh");
    const $85c2f63ac302a6f0$var$getPlannedCapacity = (state, { sprint: sprint, team: team })=>(0, $d3quy.getCapacityForTeamAndIteration)(state, {
            teamId: team,
            iterationId: sprint
        });
    const $85c2f63ac302a6f0$var$getOriginalPlannedCapacity = (state, { sprint: sprint, team: team })=>(0, $d3quy.getOriginalCapacityForTeamAndIteration)(state, {
            teamId: team,
            iterationId: sprint
        });
    const $85c2f63ac302a6f0$var$mapStateToProps = (state, ownProps)=>({
            teamObject: (0, $dRVQG.getTeamsById)(state)[ownProps.team],
            plan: (0, $bHTqr.getPlan)(state),
            sprintsCapacityOnTimeline: (0, $d3quy.getSprintsCapacityOnTimeline)(state),
            workingHours: (0, $jpgxP.getJiraHoursPerDay)(state),
            isUpdated: !!$85c2f63ac302a6f0$var$getOriginalPlannedCapacity(state, ownProps),
            plannedCapacity: $85c2f63ac302a6f0$var$getPlannedCapacity(state, ownProps),
            zoomLevel: (0, $jAIJh.getZoomLevel)(state)
        });
    var $85c2f63ac302a6f0$export$2e2bcd8739ae039 = $85c2f63ac302a6f0$var$mapStateToProps;
});
parcelRegister("gm87o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21f1302d96cf3b18$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fZhYM;
    var $koVbs;
    var $flnZx;
    var $ekXoi = parcelRequire("ekXoi");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $3RVrv = parcelRequire("3RVrv");
    var $kSmOS = parcelRequire("kSmOS");
    var $2ZQye = parcelRequire("2ZQye");
    var $dt3xX = parcelRequire("dt3xX");
    var $lgxHJ = parcelRequire("lgxHJ");
    const $21f1302d96cf3b18$var$roundEstimate = (x)=>Math.round(10 * x) / 10;
    const $21f1302d96cf3b18$var$Capacities = function({ plan: plan, teamObject: teamObject, plannedCapacity: plannedCapacity, workingHours: workingHours, isUpdated: isUpdated, zoomLevel: zoomLevel, getPercentageOffsetFromToday: getPercentageOffsetFromToday, sprintsCapacityOnTimeline: sprintsCapacityOnTimeline, sprint: selectedSprint, team: team }) {
        const [open, setOpen] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const toggleFlyout = (0, $5uXOq.useCallback)(()=>setOpen((open)=>!open), []);
        if (!(0, $4nDwW.isDefined)(teamObject)) return null;
        const { issueSource: issueSource } = teamObject;
        if (issueSource === undefined || issueSource === null) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lgxHJ.message
        }, formatMessage((0, $dt3xX.default).noIssueSources));
        const capacity = (0, parcelRequire("fZhYM")).default([
            team,
            selectedSprint
        ], sprintsCapacityOnTimeline);
        if (!capacity) return null;
        const { planningUnit: planningUnit } = plan;
        const timeline = capacity.map((sprint, index)=>{
            const { usedCapacity: usedCapacity = 0 } = sprint;
            const availableCapacity = plannedCapacity ? plannedCapacity.capacity || 0 : sprint.availableCapacity || 0;
            let display;
            switch(planningUnit){
                case (0, $TTKUQ.PLANNING_UNITS).DAYS:
                    display = formatMessage((0, $dt3xX.default).daysUnit, {
                        count: $21f1302d96cf3b18$var$roundEstimate((0, $ekXoi.convertSecondsToDays)(usedCapacity, workingHours))
                    });
                    break;
                case (0, $TTKUQ.PLANNING_UNITS).HOURS:
                    display = formatMessage((0, $dt3xX.default).hoursUnit, {
                        count: $21f1302d96cf3b18$var$roundEstimate((0, $ekXoi.convertSecondsToHours)(usedCapacity))
                    });
                    break;
                case (0, $TTKUQ.PLANNING_UNITS).STORY_POINTS:
                    display = `${$21f1302d96cf3b18$var$roundEstimate(usedCapacity)} / ${availableCapacity}`;
                    break;
                default:
                    throw new Error(`Unexpected planningUnit: ${planningUnit}`);
            }
            const content = sprint.id === 'GAP' ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kSmOS.default), {
                isOpen: open,
                onToggle: toggleFlyout,
                sprint: sprint,
                teamObject: teamObject,
                plannedCapacity: plannedCapacity,
                plan: plan
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3RVrv.default), {
                content: display
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: `${$lgxHJ.sprintBox} ${usedCapacity > availableCapacity ? $lgxHJ.overbooked : ''}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $lgxHJ.bar
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: `${usedCapacity > availableCapacity ? $lgxHJ.overbooked : $lgxHJ.okay}`,
                style: {
                    height: `${Math.min(100, 100 * usedCapacity / availableCapacity)}%`
                }
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $lgxHJ.sprintName
            }, display))));
            const style = zoomLevel && getPercentageOffsetFromToday ? {
                width: `${getPercentageOffsetFromToday((0, (0, parcelRequire("flnZx")).endOfUtcDay)(sprint.rawEndDate || sprint.endDate)) - getPercentageOffsetFromToday((0, (0, parcelRequire("flnZx")).startOfUtcDay)(sprint.rawStartDate || sprint.startDate))}%`,
                left: `${getPercentageOffsetFromToday((0, (0, parcelRequire("flnZx")).startOfUtcDay)(sprint.rawStartDate || sprint.startDate))}%`,
                position: 'absolute',
                transition: 'width 0.1s ease-in-out 0s',
                animation: '0.2s ease-in-out'
            } : {
                width: `${sprint.widthPercentage}%`,
                position: 'absolute',
                left: `${sprint.offset}%`,
                transition: 'width 0.1s ease-in-out 0s',
                animation: '0.2s ease-in-out'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2ZQye.default), {
                key: index,
                sprintId: sprint.id,
                content: content,
                style: style,
                isUpdated: isUpdated
            });
        });
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lgxHJ.sprintLabels,
            key: 0
        }, timeline));
    };
    var $21f1302d96cf3b18$export$2e2bcd8739ae039 = $21f1302d96cf3b18$var$Capacities;
});
parcelRegister("3RVrv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d863252bef1e7ce$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4ZBKw = parcelRequire("4ZBKw");
    var $9GoQM = parcelRequire("9GoQM");
    var $2d863252bef1e7ce$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $4ZBKw.default), {})((0, $9GoQM.default));
});
parcelRegister("4ZBKw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16a0da892986bd3e$export$2e2bcd8739ae039);
    var $kWDpn = parcelRequire("kWDpn");
    const $16a0da892986bd3e$var$mapStateToProps = (state)=>({
            timelineSettings: (0, $kWDpn.getTimeScaleViewSettings)(state)
        });
    var $16a0da892986bd3e$export$2e2bcd8739ae039 = $16a0da892986bd3e$var$mapStateToProps;
});
parcelRegister("9GoQM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$415c3b7edabd257d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $btzsC;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $643oM = parcelRequire("643oM");
    const $415c3b7edabd257d$var$CustomTooltipComponent = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("btzsC")).default), {
            ...rest,
            ref: ref
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $643oM.sprintTooltip
        }, children));
    });
    const $415c3b7edabd257d$var$TimelineSprintTooltip = ({ content: content, children: children, timelineSettings: timelineSettings })=>{
        if ((0, $4nDwW.isDefined)(timelineSettings) && timelineSettings.mode === (0, $TTKUQ.ZOOM_LEVELS).WEEKS) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.sprint-tooltip",
            position: "mouse",
            component: $415c3b7edabd257d$var$CustomTooltipComponent,
            content: content,
            hideTooltipOnMouseDown: true
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "bottom",
            content: content,
            hideTooltipOnMouseDown: true
        }, children);
    };
    var $415c3b7edabd257d$export$2e2bcd8739ae039 = $415c3b7edabd257d$var$TimelineSprintTooltip;
});
parcelRegister("643oM", function(module, exports) {
    $parcel$export(module.exports, "sprintTooltip", ()=>$46a5c0ba368546fe$export$e68357c14d268b6, (v)=>$46a5c0ba368546fe$export$e68357c14d268b6 = v);
    var $46a5c0ba368546fe$export$e68357c14d268b6;
    $46a5c0ba368546fe$export$e68357c14d268b6 = `BCIj2a_sprintTooltip`;
});
parcelRegister("kSmOS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4aaf9459adf0342a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jDMsd;
    var $J8W7q;
    var $hE4fC;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $em7vy = parcelRequire("em7vy");
    var $8ZVMf = parcelRequire("8ZVMf");
    const $4aaf9459adf0342a$var$DIALOG_MIN_WIDTH = 530;
    function $4aaf9459adf0342a$var$SprintFlyout({ isOpen: isOpen, onToggle: onToggle, sprint: sprint, plannedCapacity: plannedCapacity, plan: plan, KanbanFlyout: KanbanFlyout, ScrumFlyout: ScrumFlyout, children: children, teamObject: teamObject, isShowTimerangeInconsistent: isShowTimerangeInconsistent = false }) {
        const isScrum = sprint.schedulingMode !== (0, $TTKUQ.SCHEDULE_MODE).kanban;
        const [{ viewport: viewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const flyoutProps = {
            sprint: sprint,
            plannedCapacity: plannedCapacity,
            teamObject: teamObject,
            plan: plan,
            onCloseIconClick: onToggle
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDMsd")).default), {
            minLeft: viewport.position.left,
            isOpen: isOpen,
            renderDialog: (element)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                    overflow: "visible",
                    isOpen: true,
                    onClose: onToggle,
                    placement: "bottom-start",
                    shouldFlip: true,
                    closeOnScroll: true,
                    minWidth: $4aaf9459adf0342a$var$DIALOG_MIN_WIDTH,
                    content: isScrum ? (0, ($parcel$interopDefault($5uXOq))).createElement(ScrumFlyout, {
                        ...flyoutProps,
                        isShowTimerangeInconsistent: isShowTimerangeInconsistent
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement(KanbanFlyout, flyoutProps)
                }, element),
            renderTrigger: (ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    className: $8ZVMf.toggle,
                    tabIndex: 0,
                    onClick: onToggle,
                    onKeyDown: (e)=>e.key === 'Escape' && onToggle(),
                    onMouseEnter: (0, $em7vy.preloadFlyouts),
                    role: "button",
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprint-flyout.sprint-flyout-trigger.${teamObject && teamObject.id || ''}-${isScrum ? sprint.id || '' : sprint.startDate}`
                }, children)
        });
    }
    $4aaf9459adf0342a$var$SprintFlyout.defaultProps = {
        KanbanFlyout: (0, $em7vy.AsyncKanbanFlyout),
        ScrumFlyout: (0, $em7vy.AsyncScrumFlyout),
        onToggle: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $4aaf9459adf0342a$export$2e2bcd8739ae039 = $4aaf9459adf0342a$var$SprintFlyout;
});
parcelRegister("em7vy", function(module, exports) {
    $parcel$export(module.exports, "AsyncScrumFlyout", ()=>$c670dd4639de8fdd$export$6ec4eeb54fe4bbee);
    $parcel$export(module.exports, "AsyncKanbanFlyout", ()=>$c670dd4639de8fdd$export$f552c0d4ef25b739);
    $parcel$export(module.exports, "preloadFlyouts", ()=>$c670dd4639de8fdd$export$c07fd8539d12f6a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $kxZPA;
    const $c670dd4639de8fdd$var$lazyFlyout = ()=>(parcelRequire("b14Rg"));
    const $c670dd4639de8fdd$var$LazyScrumFlyout = (0, (0, parcelRequire("kxZPA")).lazy)(()=>$c670dd4639de8fdd$var$lazyFlyout().then(({ ScrumFlyout: ScrumFlyout })=>ScrumFlyout), {
        ssr: false
    });
    const $c670dd4639de8fdd$var$LazyKanbanFlyout = (0, (0, parcelRequire("kxZPA")).lazy)(()=>$c670dd4639de8fdd$var$lazyFlyout().then(({ KanbanFlyout: KanbanFlyout })=>KanbanFlyout), {
        ssr: false
    });
    const $c670dd4639de8fdd$export$6ec4eeb54fe4bbee = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "scrum-flyout",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c670dd4639de8fdd$var$LazyScrumFlyout, props));
    const $c670dd4639de8fdd$export$f552c0d4ef25b739 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "kanban-flyout",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c670dd4639de8fdd$var$LazyKanbanFlyout, props));
    const $c670dd4639de8fdd$export$c07fd8539d12f6a7 = ()=>{
        $c670dd4639de8fdd$var$LazyScrumFlyout.preload();
        $c670dd4639de8fdd$var$LazyKanbanFlyout.preload();
    };
});
parcelRegister("b14Rg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("8tLjI")),
        $6fhBS("kCTvy")
    ]).then(()=>parcelRequire('fv4ph'));
});
parcelRegister("8ZVMf", function(module, exports) {
    $parcel$export(module.exports, "toggle", ()=>$68d0d6958b5cbe83$export$e03c1c3201ee8bb7, (v)=>$68d0d6958b5cbe83$export$e03c1c3201ee8bb7 = v);
    var $68d0d6958b5cbe83$export$e03c1c3201ee8bb7;
    $68d0d6958b5cbe83$export$e03c1c3201ee8bb7 = `VhGm0W_toggle`;
});
parcelRegister("2ZQye", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f9f9a18bb5fb5c7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kC16r = parcelRequire("kC16r");
    var $6scmB = parcelRequire("6scmB");
    function $1f9f9a18bb5fb5c7$var$Capacity(props) {
        const { sprintId: sprintId, style: style, content: content, isUpdated: isUpdated } = props;
        return content && sprintId !== 'GAP' && sprintId !== 'PAST' ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: style
        }, isUpdated && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $6scmB.changeIndicator
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kC16r.default), {
            appearance: "triangle"
        })), content) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: style
        });
    }
    var $1f9f9a18bb5fb5c7$export$2e2bcd8739ae039 = $1f9f9a18bb5fb5c7$var$Capacity;
});
parcelRegister("6scmB", function(module, exports) {
    $parcel$export(module.exports, "changeIndicator", ()=>$4b2ef2bd33b562ab$export$deafeb91a574091c, (v)=>$4b2ef2bd33b562ab$export$deafeb91a574091c = v);
    var $4b2ef2bd33b562ab$export$deafeb91a574091c;
    $4b2ef2bd33b562ab$export$deafeb91a574091c = `WZML7W_changeIndicator`;
});
parcelRegister("dt3xX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c590ddcaa0a1a1f8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c590ddcaa0a1a1f8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noIssueSources: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.capacities.no-issue-sources",
            "defaultMessage": "Associate this team with an issue source to view sprints"
        },
        daysUnit: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.capacities.days-unit",
            "defaultMessage": "{count, plural, other {# d}}"
        },
        hoursUnit: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.capacities.hours-unit",
            "defaultMessage": "{count, plural, other {# h}}"
        }
    });
});
parcelRegister("lgxHJ", function(module, exports) {
    $parcel$export(module.exports, "bar", ()=>$f7b53c99b0b23eef$export$d927737047eb3867, (v)=>$f7b53c99b0b23eef$export$d927737047eb3867 = v);
    $parcel$export(module.exports, "message", ()=>$f7b53c99b0b23eef$export$a8ecead220dd38a6, (v)=>$f7b53c99b0b23eef$export$a8ecead220dd38a6 = v);
    $parcel$export(module.exports, "okay", ()=>$f7b53c99b0b23eef$export$4ff774198978dac4, (v)=>$f7b53c99b0b23eef$export$4ff774198978dac4 = v);
    $parcel$export(module.exports, "overbooked", ()=>$f7b53c99b0b23eef$export$312c3ba826526246, (v)=>$f7b53c99b0b23eef$export$312c3ba826526246 = v);
    $parcel$export(module.exports, "sprintBox", ()=>$f7b53c99b0b23eef$export$f182c2c4b027a866, (v)=>$f7b53c99b0b23eef$export$f182c2c4b027a866 = v);
    $parcel$export(module.exports, "sprintLabels", ()=>$f7b53c99b0b23eef$export$23d7aa3ce101edc3, (v)=>$f7b53c99b0b23eef$export$23d7aa3ce101edc3 = v);
    $parcel$export(module.exports, "sprintName", ()=>$f7b53c99b0b23eef$export$2780111908128a1b, (v)=>$f7b53c99b0b23eef$export$2780111908128a1b = v);
    var $f7b53c99b0b23eef$export$c891bbacdf93fd6e;
    var $f7b53c99b0b23eef$export$d927737047eb3867;
    var $f7b53c99b0b23eef$export$70b46a68a5b6a9e0;
    var $f7b53c99b0b23eef$export$38e6368cd28c04af;
    var $f7b53c99b0b23eef$export$a8ecead220dd38a6;
    var $f7b53c99b0b23eef$export$4ff774198978dac4;
    var $f7b53c99b0b23eef$export$312c3ba826526246;
    var $f7b53c99b0b23eef$export$196f532ad83e375c;
    var $f7b53c99b0b23eef$export$f182c2c4b027a866;
    var $f7b53c99b0b23eef$export$23d7aa3ce101edc3;
    var $f7b53c99b0b23eef$export$2780111908128a1b;
    $f7b53c99b0b23eef$export$c891bbacdf93fd6e = `_6YIzVa_activeSprint`;
    $f7b53c99b0b23eef$export$d927737047eb3867 = `_6YIzVa_bar`;
    $f7b53c99b0b23eef$export$70b46a68a5b6a9e0 = `_6YIzVa_closedSprint`;
    $f7b53c99b0b23eef$export$38e6368cd28c04af = `_6YIzVa_inconsistent`;
    $f7b53c99b0b23eef$export$a8ecead220dd38a6 = `_6YIzVa_message`;
    $f7b53c99b0b23eef$export$4ff774198978dac4 = `_6YIzVa_okay`;
    $f7b53c99b0b23eef$export$312c3ba826526246 = `_6YIzVa_overbooked`;
    $f7b53c99b0b23eef$export$196f532ad83e375c = `_6YIzVa_pastSprint`;
    $f7b53c99b0b23eef$export$f182c2c4b027a866 = `_6YIzVa_sprintBox`;
    $f7b53c99b0b23eef$export$23d7aa3ce101edc3 = `_6YIzVa_sprintLabels`;
    $f7b53c99b0b23eef$export$2780111908128a1b = `_6YIzVa_sprintName`;
});
parcelRegister("2GpCn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82eb321477ef1496$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gJZ5D;
    var $hE4fC;
    var $bC2fB;
    var $e79al = parcelRequire("e79al");
    var $3GEvH = parcelRequire("3GEvH");
    var $fhghA = parcelRequire("fhghA");
    function $82eb321477ef1496$var$mergeProps(stateProps, dispatchProps, ownProps) {
        return {
            ...ownProps,
            ...stateProps,
            ...dispatchProps
        };
    }
    const $82eb321477ef1496$var$mapDispatchToProps = {};
    const $82eb321477ef1496$var$Sprints = (0, (0, parcelRequire("bC2fB")).connect)((0, $3GEvH.default), $82eb321477ef1496$var$mapDispatchToProps, $82eb321477ef1496$var$mergeProps)((0, $fhghA.default));
    const $82eb321477ef1496$export$577a66ab76a07096 = ({ timelineRange: containerTimelineRange, ...rest })=>{
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const [{ timelineRange: viewportTimelineRange }] = (0, (0, parcelRequire("hE4fC")).useRenderingWindow)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $e79al.default), {
            bgColor: `var(--ds-surface, ${(0, (0, parcelRequire("gJZ5D")).default).N0})`,
            style: {
                boxShadow: `0 -2px ${`var(--ds-shadow-raised, ${(0, (0, parcelRequire("gJZ5D")).default).N40})`}`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($82eb321477ef1496$var$Sprints, {
            ...rest,
            timelineRange: zoomLevel ? viewportTimelineRange : containerTimelineRange,
            zoomLevel: zoomLevel
        }));
    };
    var $82eb321477ef1496$export$2e2bcd8739ae039 = $82eb321477ef1496$export$577a66ab76a07096;
});
parcelRegister("3GEvH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8cbea000425e0ec$export$2e2bcd8739ae039);
    var $eqNmi = parcelRequire("eqNmi");
    var $bHTqr = parcelRequire("bHTqr");
    var $gFhwb = parcelRequire("gFhwb");
    var $d3quy = parcelRequire("d3quy");
    var $dRVQG = parcelRequire("dRVQG");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $e8cbea000425e0ec$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        filteredIds: (state)=>(0, $eqNmi.getSprintFilter)(state).value,
        getStreamsUnits: (0, $d3quy.getSprintStreamsUnitsGetter),
        plan: (0, $bHTqr.getPlan),
        showWarning: (state)=>(0, $kWDpn.getWarningViewSettings)(state).showWarning,
        sprintIdsWithDatesIsInconsistent: (0, $d3quy.getSprintIdsWithDatesIsInconsistent),
        streams: (state, props)=>(0, $d3quy.getSprintStreamsUnitsForTeams)(state)[props.team],
        teamObject: (state, props)=>(0, $dRVQG.getTeamsById)(state)[props.team],
        teamsWithSprints: (state)=>(0, $gFhwb.getTeamsWorkingWithSprints)(state)
    });
});
parcelRegister("fhghA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$979ab854fc2f5cea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f1uil;
    var $4R6GH;
    var $koVbs;
    var $flnZx;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $e79al = parcelRequire("e79al");
    var $9qcBe = parcelRequire("9qcBe");
    var $lNsBz = parcelRequire("lNsBz");
    var $9Np1h = parcelRequire("9Np1h");
    var $4Rgcy = parcelRequire("4Rgcy");
    var $5igXV = parcelRequire("5igXV");
    const $979ab854fc2f5cea$var$Sprints = ({ plan: plan, sprintIdsWithDatesIsInconsistent: sprintIdsWithDatesIsInconsistent = [], filteredIds: filteredIds, showWarning: showWarning, teamObject: teamObject, team: team, streams: streams, timelineRange: timelineRange, getStreamsUnits: getStreamsUnits, zoomLevel: zoomLevel, teamsWithSprints: teamsWithSprints })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const hasSprints = teamsWithSprints && teamsWithSprints.has(team);
        if (!(0, $4nDwW.isDefined)(teamObject)) return (0, (0, parcelRequire("4R6GH")).fg)('eou_open_team_dialog_in_timeline') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9Np1h.default), {
            teamId: team,
            plan: plan,
            hasSprints: hasSprints
        }) : null;
        const { issueSource: issueSource, schedulingMode: schedulingMode, id: id } = teamObject;
        if (!(0, $4nDwW.isDefined)(issueSource)) return (0, (0, parcelRequire("4R6GH")).fg)('eou_open_team_dialog_in_timeline') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9Np1h.default), {
            team: teamObject,
            teamId: team,
            plan: plan,
            hasSprints: hasSprints
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lNsBz.default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $5igXV.message
        }, formatMessage((0, $TTKUQ.SCHEDULE_MODE).scrum === schedulingMode ? (0, $9qcBe.default).noIssueSourcesScrumTeam : (0, $9qcBe.default).noIssueSourcesKanbanTeam)));
        const isSprintFiltered = (sprint)=>!!filteredIds.length && !filteredIds.includes(sprint.id);
        const isSprintContiguousWithNextSprint = (sprint, index, stream)=>index < stream.length - 1 && stream[index + 1].id !== 'GAP' && !isSprintFiltered(stream[index + 1]) && (0, (0, parcelRequire("f1uil")).default)((0, (0, parcelRequire("flnZx")).startOfUtcDay)(sprint.rawEndDate || sprint.endDate), (0, (0, parcelRequire("flnZx")).startOfUtcDay)(stream[index + 1].rawStartDate || stream[index + 1].startDate));
        const renderStream = (stream, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-name": `team-${teamObject && teamObject.id || ''}-sprint-stream-${index}`,
                key: index,
                className: $5igXV.sprintLabels
            }, stream.map((sprint, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $4Rgcy.default), {
                    isContiguousWithNextSprint: isSprintContiguousWithNextSprint(sprint, index, stream),
                    isFiltered: isSprintFiltered(sprint),
                    isInconsistent: sprintIdsWithDatesIsInconsistent.indexOf(sprint.id) > -1,
                    key: `${sprint.startDate}-${sprint.endDate}`,
                    plan: plan,
                    showWarning: showWarning,
                    sprint: sprint,
                    teamObject: teamObject,
                    zoomLevel: zoomLevel
                })));
        const sprintTableRow = (getStreamsUnits ? getStreamsUnits(timelineRange, teamObject) : streams).map(renderStream);
        return zoomLevel ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $e79al.default), {
            testId: `team-${id}-sprint-header-row`
        }, sprintTableRow) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, sprintTableRow);
    };
    var $979ab854fc2f5cea$export$2e2bcd8739ae039 = $979ab854fc2f5cea$var$Sprints;
});
parcelRegister("9qcBe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$356976763a326af6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $356976763a326af6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noIssueSourcesScrumTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.no-issue-sources-scrum-team",
            "defaultMessage": "Associate this team with an issue source to view its sprints"
        },
        noIssueSourcesKanbanTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.no-issue-sources-kanban-team",
            "defaultMessage": "Associate this team with an issue source to view its iterations"
        },
        kanbanNoTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.kanban-no-team",
            "defaultMessage": "<modal>To use capacity planning, add a team to this plan and link it to an issue source.</modal>"
        },
        kanbanTeamNotLinked: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.kanban-team-not-linked",
            "defaultMessage": "<modal>To use capacity planning, link this team to an issue source.</modal>"
        },
        scrumNoBoardNoTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.scrum-no-board-no-team",
            "defaultMessage": "<modal>To use capacity planning, add a scrum board, then link it to a team.</modal>"
        },
        scrumNoBoardTeamAdded: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.scrum-no-board-team-added",
            "defaultMessage": "<link>To use capacity planning, add a scrum board issue source to this plan and link it to this team.</link>"
        },
        scrumBoardNoTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.scrum-board-no-team",
            "defaultMessage": "<modal>To use capacity planning, link a team to the scrum board issue source of this plan.</modal>"
        },
        associateTeamToIssueSource: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.associate-team-to-issue-source",
            "defaultMessage": "<modal>Associate this team to an issue source to view its capacity planning.</modal>"
        }
    });
});
parcelRegister("lNsBz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14b4030848f95a9f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE4fC;
    var $8m9if = parcelRequire("8m9if");
    function $14b4030848f95a9f$var$useFixedContainer() {
        const elRef = (0, $5uXOq.useRef)(null);
        const { sticky: sticky } = (0, $5uXOq.useContext)((0, $8m9if.context));
        const [{ zoomLevel: zoomLevel, viewport: viewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [{ msToPx: msToPx }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        (0, $5uXOq.useEffect)(()=>{
            const el = elRef.current;
            if (el == null) return;
            el.style.left = `${msToPx(viewport.offset)}px`;
        }, [
            sticky,
            zoomLevel,
            msToPx,
            viewport.offset
        ]);
        return elRef;
    }
    function $14b4030848f95a9f$export$2e2bcd8739ae039({ children: children }) {
        const containerRef = $14b4030848f95a9f$var$useFixedContainer();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                position: 'absolute'
            },
            ref: containerRef
        }, children));
    }
});
parcelRegister("8m9if", function(module, exports) {
    $parcel$export(module.exports, "context", ()=>$608bcb32b62b8e08$export$a078c61943f9dbbe);
    $parcel$export(module.exports, "default", ()=>$608bcb32b62b8e08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $9ci4W = parcelRequire("9ci4W");
    var $7JFlO = parcelRequire("7JFlO");
    const $608bcb32b62b8e08$export$a078c61943f9dbbe = (0, $5uXOq.createContext)({
        sticky: false
    });
    function $608bcb32b62b8e08$export$2e2bcd8739ae039({ sectionId: sectionId = '', containerId: containerId, stickyHeader: stickyHeader, children: children }) {
        if (!stickyHeader) return null;
        const classes = (0, ($parcel$interopDefault($9ci4W)))($7JFlO.columnHeaderWrapper, {
            [$7JFlO[`${sectionId}ColumnHeaderWrapper`]]: sectionId.length > 0
        });
        return (0, ($parcel$interopDefault($7nsd3))).createPortal((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $7JFlO.stickHeaderLayout,
            style: {
                heigth: stickyHeader.height,
                width: '100%'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: classes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($608bcb32b62b8e08$export$a078c61943f9dbbe.Provider, {
            value: {
                sticky: true
            }
        }, children))), document.getElementById(containerId) || document.createElement('div'));
    }
});
parcelRegister("7JFlO", function(module, exports) {
    $parcel$export(module.exports, "columnHeaderSection", ()=>$5a1ccfce1727d085$export$f80cc4deee2042b3, (v)=>$5a1ccfce1727d085$export$f80cc4deee2042b3 = v);
    $parcel$export(module.exports, "columnHeaderWrapper", ()=>$5a1ccfce1727d085$export$9a2e0d37cd9f78a8, (v)=>$5a1ccfce1727d085$export$9a2e0d37cd9f78a8 = v);
    $parcel$export(module.exports, "fieldColumnHeaderWrapper", ()=>$5a1ccfce1727d085$export$967a2568e65827b1, (v)=>$5a1ccfce1727d085$export$967a2568e65827b1 = v);
    $parcel$export(module.exports, "portalContainer", ()=>$5a1ccfce1727d085$export$ad0ac4a84a807d3d, (v)=>$5a1ccfce1727d085$export$ad0ac4a84a807d3d = v);
    $parcel$export(module.exports, "scopeColumnHeaderWrapper", ()=>$5a1ccfce1727d085$export$b34ff16ecaf83ff0, (v)=>$5a1ccfce1727d085$export$b34ff16ecaf83ff0 = v);
    $parcel$export(module.exports, "stickHeaderLayout", ()=>$5a1ccfce1727d085$export$e1c875bb407fe8a3, (v)=>$5a1ccfce1727d085$export$e1c875bb407fe8a3 = v);
    var $5a1ccfce1727d085$export$f80cc4deee2042b3;
    var $5a1ccfce1727d085$export$9a2e0d37cd9f78a8;
    var $5a1ccfce1727d085$export$967a2568e65827b1;
    var $5a1ccfce1727d085$export$ad0ac4a84a807d3d;
    var $5a1ccfce1727d085$export$b34ff16ecaf83ff0;
    var $5a1ccfce1727d085$export$e1c875bb407fe8a3;
    $5a1ccfce1727d085$export$f80cc4deee2042b3 = `-_Hfnq_columnHeaderSection`;
    $5a1ccfce1727d085$export$9a2e0d37cd9f78a8 = `-_Hfnq_columnHeaderWrapper`;
    $5a1ccfce1727d085$export$967a2568e65827b1 = `-_Hfnq_fieldColumnHeaderWrapper`;
    $5a1ccfce1727d085$export$ad0ac4a84a807d3d = `-_Hfnq_portalContainer`;
    $5a1ccfce1727d085$export$b34ff16ecaf83ff0 = `-_Hfnq_scopeColumnHeaderWrapper`;
    $5a1ccfce1727d085$export$e1c875bb407fe8a3 = `-_Hfnq_stickHeaderLayout`;
});
parcelRegister("9Np1h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9cad54366edffb50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kgoHi;
    var $8CUq3;
    var $hE4fC;
    var $8m9if = parcelRequire("8m9if");
    var $kdfjT = parcelRequire("kdfjT");
    var $f9axZ = parcelRequire("f9axZ");
    function $9cad54366edffb50$var$useFixedContainer() {
        const elRef = (0, $5uXOq.useRef)(null);
        const { sticky: sticky } = (0, $5uXOq.useContext)((0, $8m9if.context));
        const [{ zoomLevel: zoomLevel, viewport: viewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [{ msToPx: msToPx }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        (0, $5uXOq.useEffect)(()=>{
            const el = elRef.current;
            if (el == null) return;
            el.style.left = `${msToPx(viewport.offset)}px`;
        }, [
            sticky,
            zoomLevel,
            msToPx,
            viewport.offset
        ]);
        return elRef;
    }
    function $9cad54366edffb50$var$SprintsPlaceholder({ team: team, teamId: teamId, plan: plan, hasSprints: hasSprints }) {
        const containerRef = $9cad54366edffb50$var$useFixedContainer();
        const { planningUnit: planningUnit, issueSources: issueSources } = plan ?? {};
        const { issueSource: issueSource } = team ?? {};
        const assumedMode = (()=>{
            if (planningUnit === 'StoryPoints') return 'Scrum';
            if (hasSprints) return 'Scrum';
            return 'Kanban';
        })();
        const message = (0, $f9axZ.getCapacityPlanningMessage)({
            projectType: assumedMode,
            teamAdded: !!team?.id,
            teamHasIssueSource: !!issueSource,
            planHasBoards: issueSources.some(({ sprintIds: sprintIds })=>sprintIds && sprintIds.length > 0)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.placeholder.sprint-placeholder",
            xcss: $9cad54366edffb50$var$SprintsPlaceholderStyles,
            ref: containerRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kdfjT.default), {
            team: team,
            teamId: teamId,
            mode: assumedMode,
            trigger: message
        }));
    }
    const $9cad54366edffb50$var$SprintsPlaceholderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        height: '100%'
    });
    var $9cad54366edffb50$export$2e2bcd8739ae039 = $9cad54366edffb50$var$SprintsPlaceholder;
});
parcelRegister("kdfjT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f9ec77332860097$export$2e2bcd8739ae039);
    var $gEcei = parcelRequire("gEcei");
    var $bC2fB;
    var $74Gkp = parcelRequire("74Gkp");
    var $bX3WS = parcelRequire("bX3WS");
    var $9ViyR = parcelRequire("9ViyR");
    var $1f9ec77332860097$export$2e2bcd8739ae039 = (0, $gEcei.default)((0, (0, parcelRequire("bC2fB")).connect)((0, $bX3WS.default), (0, $74Gkp.default))((0, $9ViyR.default)), 'portfolio-3.simple-plans.sprints.edit-team-modal');
});
parcelRegister("gEcei", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61e1032ffc97afa2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aD4Nm;
    const $61e1032ffc97afa2$var$withViewExperienceTracker = (WrappedComponent, location)=>{
        function WithViewExperienceTracker(props) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aD4Nm")).ExperienceTracker), {
                location: location
            }, ({ onExperienceSuccess: onExperienceSuccess })=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...props,
                    onExperienceSuccess: onExperienceSuccess
                }));
        }
        return WithViewExperienceTracker;
    };
    var $61e1032ffc97afa2$export$2e2bcd8739ae039 = $61e1032ffc97afa2$var$withViewExperienceTracker;
});
parcelRegister("74Gkp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a304cc6e49f6d22$export$2e2bcd8739ae039);
    var $gIlW4 = parcelRequire("gIlW4");
    var $6Qf3i = parcelRequire("6Qf3i");
    const $0a304cc6e49f6d22$var$mapDispatchToProps = (dispatch)=>({
            openTeamsDialog: (team)=>{
                dispatch((0, $6Qf3i.openTeamsDialog)(team));
                if (team) dispatch((0, $6Qf3i.setMode)((0, $6Qf3i.EDIT_MODE)));
                else dispatch((0, $6Qf3i.setMode)((0, $6Qf3i.CREATE_MODE)));
            },
            createTeam: (payload)=>{
                dispatch((0, $gIlW4.createTeam)(payload));
            },
            onAddAtlassianTeam: (payload)=>{
                dispatch((0, $gIlW4.addAtlassianTeam)(payload));
            },
            closeTeamsDialog: ()=>{
                dispatch((0, $6Qf3i.closeTeamsDialog)());
            },
            deleteTeam: (payload)=>{
                dispatch((0, $gIlW4.deleteTeam)(payload));
            }
        });
    var $0a304cc6e49f6d22$export$2e2bcd8739ae039 = $0a304cc6e49f6d22$var$mapDispatchToProps;
});
parcelRegister("gIlW4", function(module, exports) {
    $parcel$export(module.exports, "CREATE_TEAM", ()=>$1f24984fd775c3ef$export$e51fd07f4cff4dd9);
    $parcel$export(module.exports, "SHARE_TEAM", ()=>$1f24984fd775c3ef$export$12f7bd68200c8cf6);
    $parcel$export(module.exports, "createTeam", ()=>$1f24984fd775c3ef$export$dadd67f86cf9b534);
    $parcel$export(module.exports, "editTeam", ()=>$1f24984fd775c3ef$export$3120cad1fc5da91e);
    $parcel$export(module.exports, "addAtlassianTeam", ()=>$1f24984fd775c3ef$export$7ee5b11e737d7de2);
    $parcel$export(module.exports, "deleteTeam", ()=>$1f24984fd775c3ef$export$400f94bac8630c0e);
    $parcel$export(module.exports, "shareTeam", ()=>$1f24984fd775c3ef$export$473ac9847ab8d834);
    $parcel$export(module.exports, "addMembersAndShareTeam", ()=>$1f24984fd775c3ef$export$7718371a65b500a9);
    $parcel$export(module.exports, "handleTeamBulkCommitResponse", ()=>$1f24984fd775c3ef$export$2a51e8f87b180e63);
    $parcel$export(module.exports, "handleResourceBulkCommitResponse", ()=>$1f24984fd775c3ef$export$ec920820200d647a);
    $parcel$export(module.exports, "revertTeamChange", ()=>$1f24984fd775c3ef$export$4576c7b725f993c0);
    $parcel$export(module.exports, "revertResourceChange", ()=>$1f24984fd775c3ef$export$adfa94f7c5619c0a);
    $parcel$export(module.exports, "default", ()=>$1f24984fd775c3ef$export$2e2bcd8739ae039);
    var $h2uoz;
    var $cTYeP;
    var $bWXax;
    var $8EB5I;
    var $83IGl;
    var $3nPAF;
    var $fes2p;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $4R6GH;
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $l3m9K = parcelRequire("l3m9K");
    var $bHTqr = parcelRequire("bHTqr");
    var $jeUPY = parcelRequire("jeUPY");
    var $dRVQG = parcelRequire("dRVQG");
    var $5bPxr = parcelRequire("5bPxr");
    var $flUdG = parcelRequire("flUdG");
    var $1Gv61 = parcelRequire("1Gv61");
    var $jxA5Y = parcelRequire("jxA5Y");
    var $7IEdi = parcelRequire("7IEdi");
    var $36p1o = parcelRequire("36p1o");
    var $k0NEx = parcelRequire("k0NEx");
    var $ccCF0 = parcelRequire("ccCF0");
    var $bREsp = parcelRequire("bREsp");
    var $clsih = parcelRequire("clsih");
    var $cGbfF = parcelRequire("cGbfF");
    var $duqH3 = parcelRequire("duqH3");
    var $6Qf3i = parcelRequire("6Qf3i");
    var $77QEM = parcelRequire("77QEM");
    var $8qbLi = parcelRequire("8qbLi");
    var $goTVH = parcelRequire("goTVH");
    var $bYhSc = parcelRequire("bYhSc");
    var $hNEap = parcelRequire("hNEap");
    var $24CMK = parcelRequire("24CMK");
    var $834it = parcelRequire("834it");
    var $asXbx = parcelRequire("asXbx");
    var $hvOzF = parcelRequire("hvOzF");
    var $15VA4 = parcelRequire("15VA4");
    var $OmuMh = parcelRequire("OmuMh");
    var $6Qf3i = parcelRequire("6Qf3i");
    const $1f24984fd775c3ef$export$e51fd07f4cff4dd9 = 'command.teams.CREATE_TEAM';
    const $1f24984fd775c3ef$export$3a18867c511c1a09 = 'command.teams.ADD_ATLASSIAN_TEAM';
    const $1f24984fd775c3ef$export$16af3175a6f522a7 = 'command.teams.UPDATE_TEAM';
    const $1f24984fd775c3ef$export$9835fe396f18bdff = 'command.teams.DELETE_TEAM';
    const $1f24984fd775c3ef$export$c8251868ca64bcab = 'command.teams.ADD_TEAM_MEMBER';
    const $1f24984fd775c3ef$export$9afb46849dcfc3d8 = 'command.teams.DELETE_TEAM_MEMBER';
    const $1f24984fd775c3ef$export$4c45575b665b09d6 = 'command.teams.FETCH_ADDITIONAL_TEAMS';
    const $1f24984fd775c3ef$export$12f7bd68200c8cf6 = 'command.teams.SHARE_TEAM';
    const $1f24984fd775c3ef$export$8fa1d931bc8a441c = 'command.teams.ADD_MEMBERS_AND_SHARE_TEAM';
    const $1f24984fd775c3ef$export$dadd67f86cf9b534 = (payload)=>({
            type: $1f24984fd775c3ef$export$e51fd07f4cff4dd9,
            payload: payload
        });
    const $1f24984fd775c3ef$export$3120cad1fc5da91e = (payload)=>({
            type: $1f24984fd775c3ef$export$16af3175a6f522a7,
            payload: payload
        });
    const $1f24984fd775c3ef$export$7ee5b11e737d7de2 = (payload)=>({
            type: $1f24984fd775c3ef$export$3a18867c511c1a09,
            payload: payload
        });
    const $1f24984fd775c3ef$export$400f94bac8630c0e = (payload)=>({
            type: $1f24984fd775c3ef$export$9835fe396f18bdff,
            payload: payload
        });
    const $1f24984fd775c3ef$export$473ac9847ab8d834 = (teamId)=>({
            type: $1f24984fd775c3ef$export$12f7bd68200c8cf6,
            teamId: teamId
        });
    const $1f24984fd775c3ef$export$7718371a65b500a9 = (payload)=>({
            type: $1f24984fd775c3ef$export$8fa1d931bc8a441c,
            payload: payload
        });
    function* $1f24984fd775c3ef$export$3d88424f2784ccca(oldId, newId) {
        yield* (0, $bYhSc.default)(function*() {
            if (newId) {
                yield (0, $aNOuE.put)((0, $k0NEx.update)({
                    teamId: oldId,
                    patch: {
                        id: newId
                    }
                }));
                yield (0, $aNOuE.put)((0, $clsih.updateTeamId)({
                    oldId: oldId,
                    newId: newId
                }));
                yield (0, $aNOuE.put)((0, $7IEdi.updateTeamId)({
                    oldId: oldId,
                    newId: newId
                }));
                yield (0, $aNOuE.put)((0, $5bPxr.updateTeamId)({
                    oldId: oldId,
                    newId: newId
                }));
            }
            const { value: value } = yield (0, $aNOuE.select)((0, $l3m9K.getTeamsFilterPure));
            if ((0, $4nDwW.isDefined)(value) && (0, parcelRequire("cTYeP")).default(oldId, value)) {
                const newValue = value.filter((team)=>team !== oldId);
                if (newId) newValue.push(newId);
                yield (0, $aNOuE.put)((0, $834it.change)({
                    id: (0, $cGbfF.TEAM_FILTER_ID),
                    value: newValue
                }));
            }
        });
    }
    const $1f24984fd775c3ef$export$1d57c8a8fd4b49d1 = (payload)=>({
            type: $1f24984fd775c3ef$export$c8251868ca64bcab,
            payload: payload
        });
    const $1f24984fd775c3ef$export$84f34219307d9860 = (payload)=>({
            type: $1f24984fd775c3ef$export$9afb46849dcfc3d8,
            payload: payload
        });
    function* $1f24984fd775c3ef$export$2a51e8f87b180e63(entityResponse) {
        const teamId = entityResponse.itemKey;
        const generatedId = entityResponse.generatedId;
        const error = entityResponse.error;
        const team = yield (0, $aNOuE.select)((0, $dRVQG.getTeamById), teamId);
        if (team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).DELETED) {
            yield (0, $aNOuE.put)((0, $k0NEx.remove)({
                id: teamId,
                action: 'COMMIT'
            }));
            yield (0, $aNOuE.put)((0, $clsih.removeTeamId)({
                id: teamId
            }));
        } else {
            yield (0, $aNOuE.put)((0, $k0NEx.update)({
                teamId: teamId,
                patch: {
                    scenarioType: (0, $TTKUQ.SCENARIO_TYPE).NONE
                }
            }));
            yield (0, $aNOuE.call)($1f24984fd775c3ef$export$3d88424f2784ccca, teamId, generatedId);
        }
        const warnings = (0, $OmuMh.inspectForCommitWarnings)(error);
        if (warnings.length) yield (0, $aNOuE.put)((0, $ccCF0.add)({
            category: (0, $TTKUQ.ENTITY).TEAM,
            itemId: teamId,
            warnings: warnings
        }));
        const originals = yield (0, $aNOuE.select)((0, $dRVQG.getOriginalTeams));
        yield (0, $aNOuE.put)((0, $1Gv61.reset)((0, parcelRequire("bWXax")).default(teamId, originals)));
    }
    function* $1f24984fd775c3ef$export$ec920820200d647a(entityResponse) {
        const resourceId = entityResponse.itemKey;
        const newResourceId = entityResponse.generatedId;
        const teams = yield (0, $aNOuE.select)((0, $dRVQG.getTeams));
        const team = (0, $dRVQG.findTeamAssociatedWithResource)(teams, resourceId);
        if (team && newResourceId) yield (0, $aNOuE.put)((0, $k0NEx.updateResource)({
            teamId: team.id,
            resourceId: resourceId,
            itemKey: newResourceId
        }));
        const warnings = yield (0, $aNOuE.call)((0, $OmuMh.inspectForResourceCommitWarnings), entityResponse.error, newResourceId ?? resourceId);
        if (warnings.length) yield (0, $aNOuE.put)((0, $ccCF0.add)({
            category: (0, $TTKUQ.ENTITY).RESOURCE,
            itemId: newResourceId ?? resourceId,
            warnings: warnings
        }));
        const originals = yield (0, $aNOuE.select)((0, $jeUPY.getOriginalResources));
        yield (0, $aNOuE.put)((0, $flUdG.reset)((0, parcelRequire("bWXax")).default(resourceId, originals)));
    }
    function* $1f24984fd775c3ef$export$4576c7b725f993c0(teamId) {
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = (0, $hNEap.revertBody)({
            id: planId,
            currentScenarioId: currentScenarioId
        }, sequence, teamId);
        const response = yield* $asXbx.json({
            url: (0, $15VA4.urls).revertTeamChanges,
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence }, scenarioType: scenarioType } = response.data;
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            const team = yield (0, $aNOuE.select)((0, $dRVQG.getTeamById), teamId);
            if (team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED) {
                yield (0, $aNOuE.put)((0, $k0NEx.remove)({
                    id: teamId,
                    action: 'REVERT'
                }));
                yield (0, $aNOuE.put)((0, $clsih.removeTeamId)({
                    id: teamId
                }));
            } else {
                const originalTeams = yield (0, $aNOuE.select)((0, $dRVQG.getOriginalTeams));
                const originalValues = originalTeams[teamId];
                yield (0, $aNOuE.put)((0, $k0NEx.update)({
                    teamId: teamId,
                    patch: {
                        ...team.originals,
                        scenarioType: scenarioType,
                        originals: {},
                        ...originalValues
                    }
                }));
            }
        }
        return response;
    }
    function* $1f24984fd775c3ef$export$adfa94f7c5619c0a(resourceId) {
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = (0, $hNEap.revertBody)({
            id: planId,
            currentScenarioId: currentScenarioId
        }, sequence, resourceId);
        const response = yield* $asXbx.json({
            url: (0, $15VA4.urls).revertResourceChanges,
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = response.data;
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            const teams = yield (0, $aNOuE.select)((0, $dRVQG.getTeams));
            const team = (0, $dRVQG.findTeamAssociatedWithResource)(teams, resourceId);
            if (team) {
                const resource = (0, $dRVQG.findResourceFromTeam)(team, resourceId);
                if (resource && resource.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED) yield (0, $aNOuE.put)((0, $k0NEx.update)({
                    teamId: team.id,
                    patch: {
                        resources: team.resources.filter((resource)=>resource.itemKey !== resourceId)
                    }
                }));
                else yield (0, $aNOuE.put)((0, $k0NEx.updateResource)({
                    itemKey: resourceId,
                    resourceId: resourceId,
                    teamId: team.id
                }));
            }
        }
        return response;
    }
    function* $1f24984fd775c3ef$export$29c583b936b0d944({ payload: teamMemberPayload }) {
        const { weeklyHours: weeklyHours, personItemKey: personItemKey, teamItemKey: teamItemKey } = teamMemberPayload;
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = {
            planId: planId,
            scenarioId: currentScenarioId,
            description: {
                weeklyHours: (0, $4nDwW.isDefined)(weeklyHours) ? {
                    value: weeklyHours
                } : {}
            },
            personItemKey: personItemKey,
            teamItemKey: teamItemKey
        };
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $15VA4.urls).addTeamMember, {
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence }, person: person, resourceItemKey: resourceItemKey } = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            yield (0, $aNOuE.put)((0, $jxA5Y.add)(person));
            yield (0, $aNOuE.put)((0, $8qbLi.fetchTeamsAssignees)());
            const resource = {
                itemKey: resourceItemKey,
                scenarioType: (0, $TTKUQ.SCENARIO_TYPE).ADDED,
                originals: person.originals,
                personItemKey: person.itemKey,
                values: {
                    weeklyHours: (0, $4nDwW.isDefined)(weeklyHours) ? weeklyHours : null
                }
            };
            yield (0, $aNOuE.put)((0, $k0NEx.addMember)({
                teamId: teamItemKey,
                resource: resource
            }));
            yield (0, $aNOuE.put)((0, $flUdG.update)({
                itemKey: resourceItemKey
            }));
        } else {
            const message = yield (0, $aNOuE.call)(response.text.bind(response));
            if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                const error = new Error(message);
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'do-add-member-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: message
            }));
        }
    }
    function* $1f24984fd775c3ef$export$f8cc5277460b8c48({ payload: { removedResources: removedResources, teamId: teamId } }) {
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = {
            planId: planId,
            scenarioId: currentScenarioId,
            itemKeys: removedResources.map((el)=>el.itemKey)
        };
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $15VA4.urls).deleteTeamMember, {
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            for (const resource of removedResources){
                if (resource.scenarioType !== (0, $TTKUQ.SCENARIO_TYPE).ADDED) yield (0, $aNOuE.put)((0, $flUdG.update)({
                    itemKey: resource.itemKey
                }));
                yield (0, $aNOuE.put)((0, $k0NEx.removeMember)({
                    teamId: teamId,
                    resource: resource
                }));
            }
            const originalResources = yield (0, $aNOuE.select)((0, $jeUPY.getOriginalResources));
            const resets = (0, $4nDwW.filterMap)(({ scenarioType: scenarioType })=>scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED, (resource)=>resource.itemKey, removedResources);
            if (resets.length) {
                const resetOriginals = Object.keys(originalResources).reduce((acc, key)=>{
                    if (!resets.includes(key)) acc[key] = originalResources[key];
                    return acc;
                }, {});
                yield (0, $aNOuE.put)((0, $flUdG.reset)(resetOriginals));
            }
            const { change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
        } else {
            const message = yield (0, $aNOuE.call)(response.text.bind(response));
            if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                const error = new Error(message);
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'do-delete-member-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: message
            }));
        }
    }
    function* $1f24984fd775c3ef$export$ea9bd73fd9ebed1({ members: members, team: team }) {
        const { resources: resources } = team;
        const addedResources = members.filter((el)=>!resources.some((res)=>res.scenarioType !== (0, $TTKUQ.SCENARIO_TYPE).DELETED && res.personItemKey === el.value.toString()));
        const removedResources = resources.filter((el)=>el.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).DELETED || !members.some((member)=>member.value.toString() === el.personItemKey));
        for (const teamMember of addedResources)yield (0, $aNOuE.call)($1f24984fd775c3ef$export$29c583b936b0d944, $1f24984fd775c3ef$export$1d57c8a8fd4b49d1({
            personItemKey: teamMember.value.toString(),
            teamItemKey: team.id
        }));
        if (removedResources.length) yield (0, $aNOuE.call)($1f24984fd775c3ef$export$f8cc5277460b8c48, $1f24984fd775c3ef$export$84f34219307d9860({
            removedResources: removedResources,
            teamId: team.id
        }));
    }
    function* $1f24984fd775c3ef$export$a27e6496b19f1ec5(team) {
        const newTeam = (0, $bREsp.prepareTeam)(team);
        yield (0, $aNOuE.put)((0, $k0NEx.add)(newTeam));
        yield (0, $aNOuE.put)((0, $1Gv61.update)({
            id: newTeam.id
        }));
        yield (0, $aNOuE.put)((0, $k0NEx.update)({
            teamId: newTeam.id,
            patch: {
                scenarioType: (0, $TTKUQ.SCENARIO_TYPE).ADDED
            }
        }));
        yield (0, $aNOuE.put)((0, $clsih.setColourForNewTeam)({
            id: team.itemKey
        }));
    }
    function* $1f24984fd775c3ef$export$6b49b838ae174911({ payload: teamPayload }) {
        yield (0, $aNOuE.put)((0, $6Qf3i.initiateRequest)());
        const { domain: { plan: { id: planId, currentScenarioId: scenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = {
            planId: planId,
            scenarioId: scenarioId,
            description: (0, $15VA4.getTeamDescriptionPayload)(teamPayload)
        };
        const { members: members = [] } = teamPayload;
        try {
            const url = (0, $15VA4.urls).addNewTeam;
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body,
                profile: url
            });
            if (response.ok) {
                const { change: { sequence: sequence }, team: team } = yield (0, $aNOuE.call)(response.json.bind(response));
                yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
                yield (0, $aNOuE.call)($1f24984fd775c3ef$export$a27e6496b19f1ec5, team);
                for (const teamMember of members)yield (0, $aNOuE.call)($1f24984fd775c3ef$export$29c583b936b0d944, $1f24984fd775c3ef$export$1d57c8a8fd4b49d1({
                    personItemKey: teamMember.value.toString(),
                    teamItemKey: team.itemKey
                }));
                yield (0, $aNOuE.put)((0, $6Qf3i.closeTeamsDialog)());
            } else {
                const message = yield (0, $aNOuE.call)(response.text.bind(response));
                if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                    const error = new Error(message);
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: (0, $hvOzF.toErrorID)(error, 'do-create-team-fetch-failed'),
                            packageName: (0, $TTKUQ.PACKAGE_NAME),
                            teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    message: message
                }));
            }
        } finally{
            yield (0, $aNOuE.put)((0, $6Qf3i.resetRequest)());
        }
    }
    function* $1f24984fd775c3ef$export$94ab737c3e9c6723({ payload: atlassianTeamPayload }) {
        yield (0, $aNOuE.put)((0, $6Qf3i.initiateRequest)());
        yield (0, $aNOuE.put)((0, $duqH3.resetAddedTwpTeam)());
        const { domain: { plan: { id: planId, currentScenarioId: scenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = {
            planId: planId,
            scenarioId: scenarioId,
            teamId: atlassianTeamPayload.id,
            members: atlassianTeamPayload.members
        };
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $15VA4.urls).addAtlassianTeam, {
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence }, team: team, people: people } = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            const teamToAdd = atlassianTeamPayload.title ? (0, parcelRequire("h2uoz")).default([
                'values',
                'title'
            ], atlassianTeamPayload.title, team) : team;
            teamToAdd.values.issueSource = null;
            teamToAdd.values.iterationLength = null;
            teamToAdd.values.schedulingMode = (0, $TTKUQ.SCHEDULE_MODE).scrum;
            teamToAdd.values.velocity = null;
            teamToAdd.values.weeklyHours = null;
            yield (0, $aNOuE.call)($1f24984fd775c3ef$export$a27e6496b19f1ec5, teamToAdd);
            for (const person of people)yield (0, $aNOuE.put)((0, $jxA5Y.add)(person));
            yield (0, $aNOuE.put)((0, $duqH3.storeAddedTwpTeam)({
                teamTitle: teamToAdd.values.title,
                teamId: teamToAdd.itemKey
            }));
        } else {
            const message = yield (0, $aNOuE.call)(response.text.bind(response));
            if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                const error = new Error(message);
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'do-add-atlassian-team-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: message
            }));
        }
        yield (0, $aNOuE.put)((0, $6Qf3i.resetRequest)());
    }
    function* $1f24984fd775c3ef$export$8c5eeb39ea12a165({ payload: { enhancedTeam: enhancedTeam, formFields: formFields, teamId: teamId } }) {
        yield (0, $aNOuE.put)((0, $6Qf3i.initiateRequest)());
        const { domain: { plan: { id: planId, currentScenarioId: scenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const { members: members = [], ...rest } = formFields;
        const { members: enhancedMembers = [], ...enhancedRest } = enhancedTeam;
        const patch = (0, $4nDwW.pickBy)((el, key)=>!(0, parcelRequire("8EB5I")).default(el, enhancedRest[key]), rest);
        const isEqualMembers = members.length === enhancedMembers.length && members.every((member)=>enhancedMembers.some((enhancedMember)=>member.value.toString() === enhancedMember.value.toString()));
        if ((0, parcelRequire("3nPAF")).default(patch) && isEqualMembers) {
            yield (0, $aNOuE.put)((0, $6Qf3i.resetRequest)());
            yield (0, $aNOuE.put)((0, $6Qf3i.closeTeamsDialog)());
            return;
        }
        const body = {
            planId: planId,
            scenarioId: scenarioId,
            itemKeys: [
                teamId
            ],
            description: (0, $15VA4.getTeamDescriptionPayload)(patch)
        };
        try {
            const url = (0, $15VA4.urls).updateTeam;
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body,
                profile: url
            });
            if (response.ok) {
                const { change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
                yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
                const team = yield (0, $aNOuE.select)((0, $dRVQG.getTeamById), teamId);
                const originals = (0, parcelRequire("fes2p")).default(Object.keys(patch).filter((key)=>patch[key] !== team[key]), team);
                if (!isEqualMembers) yield (0, $aNOuE.call)($1f24984fd775c3ef$export$ea9bd73fd9ebed1, {
                    members: members,
                    team: team
                });
                const scenarioType = team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED ? (0, $TTKUQ.SCENARIO_TYPE).ADDED : (0, $TTKUQ.SCENARIO_TYPE).UPDATED;
                yield (0, $aNOuE.put)((0, $1Gv61.update)({
                    ...originals,
                    id: teamId
                }));
                yield (0, $aNOuE.put)((0, $k0NEx.update)({
                    teamId: teamId,
                    patch: {
                        scenarioType: scenarioType,
                        ...scenarioType === (0, $TTKUQ.SCENARIO_TYPE).UPDATED ? {
                            originals: originals
                        } : {},
                        ...patch
                    }
                }));
                yield (0, $aNOuE.put)((0, $6Qf3i.closeTeamsDialog)());
            } else {
                const message = yield (0, $aNOuE.call)(response.text.bind(response));
                if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                    const error = new Error(message);
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: (0, $hvOzF.toErrorID)(error, 'do-update-team-fetch-failed'),
                            packageName: (0, $TTKUQ.PACKAGE_NAME),
                            teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    message: message
                }));
            }
        } finally{
            yield (0, $aNOuE.put)((0, $6Qf3i.resetRequest)());
        }
    }
    function* $1f24984fd775c3ef$export$555554d803cdd4c6({ payload: payload }) {
        const { currentScenarioId: scenarioId, id: planId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const body = {
            itemKeys: [
                payload.id
            ],
            planId: planId,
            scenarioId: scenarioId
        };
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $15VA4.urls).deleteTeam, {
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            const team = yield (0, $aNOuE.select)((0, $dRVQG.getTeamById), payload.id);
            if (team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED) {
                yield (0, $aNOuE.put)((0, $k0NEx.remove)({
                    id: payload.id,
                    action: 'DELETE'
                }));
                yield (0, $aNOuE.put)((0, $clsih.removeTeamId)({
                    id: payload.id
                }));
                const originals = yield (0, $aNOuE.select)((0, $dRVQG.getOriginalTeams));
                yield (0, $aNOuE.put)((0, $1Gv61.reset)((0, parcelRequire("bWXax")).default(payload.id, originals)));
            } else {
                yield (0, $aNOuE.put)((0, $1Gv61.update)({
                    ...payload
                }));
                yield (0, $aNOuE.put)((0, $k0NEx.update)({
                    teamId: payload.id,
                    patch: {
                        scenarioType: (0, $TTKUQ.SCENARIO_TYPE).DELETED
                    }
                }));
            }
            yield (0, $aNOuE.call)($1f24984fd775c3ef$export$3d88424f2784ccca, payload.id);
            yield (0, $aNOuE.call)((0, $goTVH.getBacklog));
        }
    }
    function* $1f24984fd775c3ef$export$e8872698abd4b9a({ teamId: teamId }) {
        const { id: planId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $15VA4.urls).setSharedNew, {
            method: (0, $77QEM.POST),
            body: {
                planId: planId,
                teamId: teamId
            }
        });
        if (response.ok) {
            const { externalId: externalId } = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.put)((0, $k0NEx.setShared)(teamId, externalId));
        } else {
            const message = yield (0, $aNOuE.call)(response.text.bind(response));
            if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                const error = new Error(message);
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'do-share-team-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: message
            }));
        }
    }
    function* $1f24984fd775c3ef$export$b02ba2781d0ccd18({ payload: { teamId: teamId, personIds: personIds } }) {
        const { id: planId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $15VA4.urls).addTeamMemberWithoutScenarioChange, {
            method: (0, $77QEM.POST),
            body: {
                planId: planId,
                teamId: teamId,
                persons: personIds.map((aId)=>({
                        personId: aId
                    }))
            }
        });
        if (response.ok) {
            const { resources: resources } = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.all)(resources.map(function*({ person: person, resourceItemKey: resourceItemKey }) {
                yield (0, $aNOuE.put)((0, $jxA5Y.add)(person));
                const resource = {
                    itemKey: resourceItemKey,
                    scenarioType: (0, $TTKUQ.SCENARIO_TYPE).ADDED,
                    originals: person.originals,
                    personItemKey: person.itemKey,
                    values: {
                        weeklyHours: null
                    }
                };
                yield (0, $aNOuE.put)((0, $k0NEx.addMember)({
                    teamId: teamId,
                    resource: resource
                }));
            }));
            yield (0, $aNOuE.put)((0, $8qbLi.fetchTeamsAssignees)());
            yield (0, $aNOuE.put)($1f24984fd775c3ef$export$473ac9847ab8d834(teamId));
        } else {
            const message = yield (0, $aNOuE.call)(response.text.bind(response));
            if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                const error = new Error(message);
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'do-add-member-and-share-team-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: message
            }));
        }
    }
    function* $1f24984fd775c3ef$export$4b409c03c7ab2245() {
        yield (0, $6u3NN.takeEvery)($1f24984fd775c3ef$export$e51fd07f4cff4dd9, $1f24984fd775c3ef$export$6b49b838ae174911);
    }
    function* $1f24984fd775c3ef$export$2d80cf2dc32820d2() {
        yield (0, $6u3NN.takeEvery)($1f24984fd775c3ef$export$3a18867c511c1a09, $1f24984fd775c3ef$export$94ab737c3e9c6723);
    }
    function* $1f24984fd775c3ef$export$e4e4d710dba71d61() {
        yield (0, $6u3NN.takeEvery)($1f24984fd775c3ef$export$16af3175a6f522a7, $1f24984fd775c3ef$export$8c5eeb39ea12a165);
    }
    function* $1f24984fd775c3ef$export$f555f148b310eebf() {
        yield (0, $6u3NN.takeEvery)($1f24984fd775c3ef$export$9835fe396f18bdff, $1f24984fd775c3ef$export$555554d803cdd4c6);
    }
    function* $1f24984fd775c3ef$export$8ec20e797f5e6408() {
        yield (0, $6u3NN.takeEvery)($1f24984fd775c3ef$export$c8251868ca64bcab, $1f24984fd775c3ef$export$29c583b936b0d944);
    }
    function* $1f24984fd775c3ef$export$510a706ed03de615() {
        yield (0, $6u3NN.takeEvery)($1f24984fd775c3ef$export$9afb46849dcfc3d8, $1f24984fd775c3ef$export$f8cc5277460b8c48);
    }
    function* $1f24984fd775c3ef$export$925e67f5cb8cc50c() {
        yield (0, $6u3NN.takeEvery)($1f24984fd775c3ef$export$12f7bd68200c8cf6, $1f24984fd775c3ef$export$e8872698abd4b9a);
    }
    function* $1f24984fd775c3ef$export$581612e0e6e99ed1() {
        yield (0, $6u3NN.takeEvery)($1f24984fd775c3ef$export$8fa1d931bc8a441c, $1f24984fd775c3ef$export$b02ba2781d0ccd18);
    }
    function* $1f24984fd775c3ef$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($1f24984fd775c3ef$export$4b409c03c7ab2245);
        yield (0, $aNOuE.fork)($1f24984fd775c3ef$export$2d80cf2dc32820d2);
        yield (0, $aNOuE.fork)($1f24984fd775c3ef$export$e4e4d710dba71d61);
        yield (0, $aNOuE.fork)($1f24984fd775c3ef$export$f555f148b310eebf);
        yield (0, $aNOuE.fork)($1f24984fd775c3ef$export$8ec20e797f5e6408);
        yield (0, $aNOuE.fork)($1f24984fd775c3ef$export$510a706ed03de615);
        yield (0, $aNOuE.fork)($1f24984fd775c3ef$export$925e67f5cb8cc50c);
        yield (0, $aNOuE.fork)($1f24984fd775c3ef$export$581612e0e6e99ed1);
    }
});
parcelRegister("5bPxr", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$77de25f9a59e4b37$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$77de25f9a59e4b37$export$e271b26eefe41db8);
    $parcel$export(module.exports, "REMOVE", ()=>$77de25f9a59e4b37$export$29d55e1f664a246b);
    $parcel$export(module.exports, "UPDATE_TEAM_ID", ()=>$77de25f9a59e4b37$export$3375e6b8e0671d88);
    $parcel$export(module.exports, "reset", ()=>$77de25f9a59e4b37$export$aad8462122ac592b);
    $parcel$export(module.exports, "update", ()=>$77de25f9a59e4b37$export$722fbec263ad908a);
    $parcel$export(module.exports, "remove", ()=>$77de25f9a59e4b37$export$cd7f480d6b8286c3);
    $parcel$export(module.exports, "updateTeamId", ()=>$77de25f9a59e4b37$export$3d88424f2784ccca);
    const $77de25f9a59e4b37$export$4a991c87e640ef77 = 'state.domain.original-planned-capacities.RESET';
    const $77de25f9a59e4b37$export$e271b26eefe41db8 = 'state.domain.original-planned-capacities.UPDATE';
    const $77de25f9a59e4b37$export$29d55e1f664a246b = 'state.domain.original-planned-capacities.REMOVE';
    const $77de25f9a59e4b37$export$3375e6b8e0671d88 = 'state.domain.original-planned-capacities.UPDATE_TEAM_ID';
    const $77de25f9a59e4b37$export$aad8462122ac592b = (payload)=>({
            type: $77de25f9a59e4b37$export$4a991c87e640ef77,
            payload: payload
        });
    const $77de25f9a59e4b37$export$722fbec263ad908a = (payload)=>({
            type: $77de25f9a59e4b37$export$e271b26eefe41db8,
            payload: payload
        });
    const $77de25f9a59e4b37$export$cd7f480d6b8286c3 = (payload)=>({
            type: $77de25f9a59e4b37$export$29d55e1f664a246b,
            payload: payload
        });
    const $77de25f9a59e4b37$export$3d88424f2784ccca = (payload)=>({
            type: $77de25f9a59e4b37$export$3375e6b8e0671d88,
            payload: payload
        });
});
parcelRegister("flUdG", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$8ba53d6a16e345d6$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$8ba53d6a16e345d6$export$e271b26eefe41db8);
    $parcel$export(module.exports, "update", ()=>$8ba53d6a16e345d6$export$722fbec263ad908a);
    $parcel$export(module.exports, "reset", ()=>$8ba53d6a16e345d6$export$aad8462122ac592b);
    const $8ba53d6a16e345d6$export$4a991c87e640ef77 = 'state.domain.original-resources.RESET';
    const $8ba53d6a16e345d6$export$e271b26eefe41db8 = 'state.domain.original-resources.UPDATE';
    const $8ba53d6a16e345d6$export$722fbec263ad908a = (payload)=>({
            type: $8ba53d6a16e345d6$export$e271b26eefe41db8,
            payload: payload
        });
    const $8ba53d6a16e345d6$export$aad8462122ac592b = (payload)=>({
            type: $8ba53d6a16e345d6$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("1Gv61", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$f70cffba58842c98$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$f70cffba58842c98$export$e271b26eefe41db8);
    $parcel$export(module.exports, "update", ()=>$f70cffba58842c98$export$722fbec263ad908a);
    $parcel$export(module.exports, "reset", ()=>$f70cffba58842c98$export$aad8462122ac592b);
    const $f70cffba58842c98$export$4a991c87e640ef77 = 'state.domain.original-teams.RESET';
    const $f70cffba58842c98$export$e271b26eefe41db8 = 'state.domain.original-teams.UPDATE';
    const $f70cffba58842c98$export$722fbec263ad908a = (payload)=>({
            type: $f70cffba58842c98$export$e271b26eefe41db8,
            payload: payload
        });
    const $f70cffba58842c98$export$aad8462122ac592b = (payload)=>({
            type: $f70cffba58842c98$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("jxA5Y", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$6e934d5210aa298c$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD", ()=>$6e934d5210aa298c$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "reset", ()=>$6e934d5210aa298c$export$aad8462122ac592b);
    $parcel$export(module.exports, "add", ()=>$6e934d5210aa298c$export$e16d8520af44a096);
    const $6e934d5210aa298c$export$4a991c87e640ef77 = 'state.domain.persons.RESET';
    const $6e934d5210aa298c$export$bb6389024b71c2ae = 'state.domain.persons.ADD';
    const $6e934d5210aa298c$export$aad8462122ac592b = (payload)=>({
            type: $6e934d5210aa298c$export$4a991c87e640ef77,
            payload: payload
        });
    const $6e934d5210aa298c$export$e16d8520af44a096 = (payload)=>({
            type: $6e934d5210aa298c$export$bb6389024b71c2ae,
            payload: payload
        });
});
parcelRegister("7IEdi", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$4008db6cba20471e$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$4008db6cba20471e$export$e271b26eefe41db8);
    $parcel$export(module.exports, "REMOVE", ()=>$4008db6cba20471e$export$29d55e1f664a246b);
    $parcel$export(module.exports, "UPDATE_TEAM_ID", ()=>$4008db6cba20471e$export$3375e6b8e0671d88);
    $parcel$export(module.exports, "reset", ()=>$4008db6cba20471e$export$aad8462122ac592b);
    $parcel$export(module.exports, "update", ()=>$4008db6cba20471e$export$722fbec263ad908a);
    $parcel$export(module.exports, "remove", ()=>$4008db6cba20471e$export$cd7f480d6b8286c3);
    $parcel$export(module.exports, "updateTeamId", ()=>$4008db6cba20471e$export$3d88424f2784ccca);
    const $4008db6cba20471e$export$4a991c87e640ef77 = 'state.domain.planned-capacities.RESET';
    const $4008db6cba20471e$export$e271b26eefe41db8 = 'state.domain.planned-capacities.UPDATE';
    const $4008db6cba20471e$export$29d55e1f664a246b = 'state.domain.planned-capacities.REMOVE';
    const $4008db6cba20471e$export$3375e6b8e0671d88 = 'state.domain.planned-capacities.UPDATE_TEAM_ID';
    const $4008db6cba20471e$export$aad8462122ac592b = (payload)=>({
            type: $4008db6cba20471e$export$4a991c87e640ef77,
            payload: payload
        });
    const $4008db6cba20471e$export$722fbec263ad908a = (payload)=>({
            type: $4008db6cba20471e$export$e271b26eefe41db8,
            payload: payload
        });
    const $4008db6cba20471e$export$cd7f480d6b8286c3 = (payload)=>({
            type: $4008db6cba20471e$export$29d55e1f664a246b,
            payload: payload
        });
    const $4008db6cba20471e$export$3d88424f2784ccca = (payload)=>({
            type: $4008db6cba20471e$export$3375e6b8e0671d88,
            payload: payload
        });
});
parcelRegister("k0NEx", function(module, exports) {
    $parcel$export(module.exports, "ADD", ()=>$b13be38d51175fc5$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "RESET", ()=>$b13be38d51175fc5$export$4a991c87e640ef77);
    $parcel$export(module.exports, "REMOVE", ()=>$b13be38d51175fc5$export$29d55e1f664a246b);
    $parcel$export(module.exports, "UPDATE", ()=>$b13be38d51175fc5$export$e271b26eefe41db8);
    $parcel$export(module.exports, "UPDATE_RESOURCE", ()=>$b13be38d51175fc5$export$14d087c009633b99);
    $parcel$export(module.exports, "ADD_MEMBER", ()=>$b13be38d51175fc5$export$fd02c2a24df725bc);
    $parcel$export(module.exports, "REMOVE_MEMBER", ()=>$b13be38d51175fc5$export$70ddd0b194796257);
    $parcel$export(module.exports, "SET_SHARED", ()=>$b13be38d51175fc5$export$bf0c919e7ee37f3f);
    $parcel$export(module.exports, "add", ()=>$b13be38d51175fc5$export$e16d8520af44a096);
    $parcel$export(module.exports, "reset", ()=>$b13be38d51175fc5$export$aad8462122ac592b);
    $parcel$export(module.exports, "remove", ()=>$b13be38d51175fc5$export$cd7f480d6b8286c3);
    $parcel$export(module.exports, "update", ()=>$b13be38d51175fc5$export$722fbec263ad908a);
    $parcel$export(module.exports, "updateResource", ()=>$b13be38d51175fc5$export$1301c313b2890e2d);
    $parcel$export(module.exports, "addMember", ()=>$b13be38d51175fc5$export$d199869810608d4e);
    $parcel$export(module.exports, "removeMember", ()=>$b13be38d51175fc5$export$57b1164dbe7b642f);
    $parcel$export(module.exports, "setShared", ()=>$b13be38d51175fc5$export$72030e9b32b3f1bb);
    const $b13be38d51175fc5$export$bb6389024b71c2ae = 'state.domain.teams.ADD';
    const $b13be38d51175fc5$export$4a991c87e640ef77 = 'state.domain.teams.RESET';
    const $b13be38d51175fc5$export$29d55e1f664a246b = 'state.domain.teams.REMOVE';
    const $b13be38d51175fc5$export$e271b26eefe41db8 = 'state.domain.teams.UPDATE';
    const $b13be38d51175fc5$export$14d087c009633b99 = 'state.domain.teams.UPDATE_RESOURCE';
    const $b13be38d51175fc5$export$fd02c2a24df725bc = 'state.domain.teams.ADD_MEMBER';
    const $b13be38d51175fc5$export$70ddd0b194796257 = 'state.domain.teams.REMOVE_MEMBER';
    const $b13be38d51175fc5$export$bf0c919e7ee37f3f = 'state.domain.teams.SET_SHARED';
    const $b13be38d51175fc5$export$e16d8520af44a096 = (payload)=>({
            type: $b13be38d51175fc5$export$bb6389024b71c2ae,
            payload: payload
        });
    const $b13be38d51175fc5$export$aad8462122ac592b = (payload)=>({
            type: $b13be38d51175fc5$export$4a991c87e640ef77,
            payload: payload
        });
    const $b13be38d51175fc5$export$cd7f480d6b8286c3 = (payload)=>({
            type: $b13be38d51175fc5$export$29d55e1f664a246b,
            payload: payload
        });
    const $b13be38d51175fc5$export$722fbec263ad908a = (payload)=>({
            type: $b13be38d51175fc5$export$e271b26eefe41db8,
            payload: payload
        });
    const $b13be38d51175fc5$export$1301c313b2890e2d = (payload)=>({
            type: $b13be38d51175fc5$export$14d087c009633b99,
            payload: payload
        });
    const $b13be38d51175fc5$export$d199869810608d4e = (payload)=>({
            type: $b13be38d51175fc5$export$fd02c2a24df725bc,
            payload: payload
        });
    const $b13be38d51175fc5$export$57b1164dbe7b642f = (payload)=>({
            type: $b13be38d51175fc5$export$70ddd0b194796257,
            payload: payload
        });
    const $b13be38d51175fc5$export$72030e9b32b3f1bb = (teamId, externalId)=>({
            type: $b13be38d51175fc5$export$bf0c919e7ee37f3f,
            teamId: teamId,
            externalId: externalId
        });
});
parcelRegister("duqH3", function(module, exports) {
    $parcel$export(module.exports, "STORE_ADDED_TWP_TEAM", ()=>$c4a1b7efff7e9070$export$1b569f318992fe0f);
    $parcel$export(module.exports, "RESET_ADDED_TWP_TEAM", ()=>$c4a1b7efff7e9070$export$c574386b3f59ba7d);
    $parcel$export(module.exports, "LOAD_CREATE_TWP_FORM", ()=>$c4a1b7efff7e9070$export$27399c91b45e0c1f);
    $parcel$export(module.exports, "RESET_CREATE_TWP_FORM", ()=>$c4a1b7efff7e9070$export$74df48b967e3300b);
    $parcel$export(module.exports, "storeAddedTwpTeam", ()=>$c4a1b7efff7e9070$export$53e229d16867e049);
    $parcel$export(module.exports, "resetAddedTwpTeam", ()=>$c4a1b7efff7e9070$export$bfeaad00c5b059a4);
    $parcel$export(module.exports, "loadCreateTwpForm", ()=>$c4a1b7efff7e9070$export$5daa826ee6e9d368);
    $parcel$export(module.exports, "resetCreateTwpForm", ()=>$c4a1b7efff7e9070$export$51dd78b7d08a90e);
    const $c4a1b7efff7e9070$export$1b569f318992fe0f = 'state.ui.main.tabs.teams.create-team.STORE_ADDED_TWP_TEAM';
    const $c4a1b7efff7e9070$export$c574386b3f59ba7d = 'state.ui.main.tabs.teams.create-team.RESET_ADDED_TWP_TEAM';
    const $c4a1b7efff7e9070$export$27399c91b45e0c1f = 'state.ui.main.tabs.teams.create-team.LOAD_CREATE_TWP_FORM';
    const $c4a1b7efff7e9070$export$74df48b967e3300b = 'state.ui.main.tabs.teams.create-team.RESET_CREATE_TWP_FORM';
    const $c4a1b7efff7e9070$export$53e229d16867e049 = (payload)=>({
            type: $c4a1b7efff7e9070$export$1b569f318992fe0f,
            payload: payload
        });
    const $c4a1b7efff7e9070$export$bfeaad00c5b059a4 = ()=>({
            type: $c4a1b7efff7e9070$export$c574386b3f59ba7d
        });
    const $c4a1b7efff7e9070$export$5daa826ee6e9d368 = ()=>({
            type: $c4a1b7efff7e9070$export$27399c91b45e0c1f
        });
    const $c4a1b7efff7e9070$export$51dd78b7d08a90e = ()=>({
            type: $c4a1b7efff7e9070$export$74df48b967e3300b
        });
});
parcelRegister("6Qf3i", function(module, exports) {
    $parcel$export(module.exports, "OPEN_TEAMS_DIALOG", ()=>$cf62282f77ec055e$export$df5fbe9561f83371);
    $parcel$export(module.exports, "CLOSE_TEAMS_DIALOG", ()=>$cf62282f77ec055e$export$12dd9a899aa0aa58);
    $parcel$export(module.exports, "INITIATE_REQUEST", ()=>$cf62282f77ec055e$export$4580e708995fb75f);
    $parcel$export(module.exports, "RESET_REQUEST", ()=>$cf62282f77ec055e$export$31889003e5372a7f);
    $parcel$export(module.exports, "SET_MODE", ()=>$cf62282f77ec055e$export$27a86d4a6fd7f204);
    $parcel$export(module.exports, "CREATE_MODE", ()=>$cf62282f77ec055e$export$a356edc8fe7e437f);
    $parcel$export(module.exports, "EDIT_MODE", ()=>$cf62282f77ec055e$export$7925fddf359eacb);
    $parcel$export(module.exports, "SHOW_SHARED_TEAM_SUCCESS_FLAG", ()=>$cf62282f77ec055e$export$772bc10fe934e1e0);
    $parcel$export(module.exports, "setMode", ()=>$cf62282f77ec055e$export$d4f039427a1beff1);
    $parcel$export(module.exports, "openTeamsDialog", ()=>$cf62282f77ec055e$export$136a9c6639c07b52);
    $parcel$export(module.exports, "closeTeamsDialog", ()=>$cf62282f77ec055e$export$f0505160fc7e9491);
    $parcel$export(module.exports, "showSharedTeamSuccessFlag", ()=>$cf62282f77ec055e$export$a1428575f9757458);
    $parcel$export(module.exports, "initiateRequest", ()=>$cf62282f77ec055e$export$82f68a404cfea29);
    $parcel$export(module.exports, "resetRequest", ()=>$cf62282f77ec055e$export$b38f09eddeeb56fb);
    const $cf62282f77ec055e$export$df5fbe9561f83371 = 'state.ui.main.tabs.teams.list.OPEN_TEAMS_DIALOG';
    const $cf62282f77ec055e$export$12dd9a899aa0aa58 = 'state.ui.main.tabs.teams.list.CLOSE_TEAMS_DIALOG';
    const $cf62282f77ec055e$export$4580e708995fb75f = 'state.ui.main.tabs.teams.list.INITIATE_REQUEST';
    const $cf62282f77ec055e$export$31889003e5372a7f = 'state.ui.main.tabs.teams.list.RESET_REQUEST';
    const $cf62282f77ec055e$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.teams.list.SET_MODE';
    const $cf62282f77ec055e$export$a356edc8fe7e437f = 'state.ui.main.tabs.teams.list.CREATE_MODE';
    const $cf62282f77ec055e$export$7925fddf359eacb = 'state.ui.main.tabs.teams.list.EDIT_MODE';
    const $cf62282f77ec055e$export$772bc10fe934e1e0 = 'state.ui.main.tabs.teams.list.SHOW_SHARED_TEAM_SUCCESS_FLAG';
    const $cf62282f77ec055e$export$d4f039427a1beff1 = (payload)=>({
            type: $cf62282f77ec055e$export$27a86d4a6fd7f204,
            payload: payload
        });
    const $cf62282f77ec055e$export$136a9c6639c07b52 = (editedTeam)=>({
            type: $cf62282f77ec055e$export$df5fbe9561f83371,
            payload: {
                editedTeam: editedTeam
            }
        });
    const $cf62282f77ec055e$export$f0505160fc7e9491 = ()=>({
            type: $cf62282f77ec055e$export$12dd9a899aa0aa58
        });
    const $cf62282f77ec055e$export$a1428575f9757458 = (showSharedTeamSuccessFlag)=>({
            type: $cf62282f77ec055e$export$772bc10fe934e1e0,
            payload: {
                showSharedTeamSuccessFlag: showSharedTeamSuccessFlag
            }
        });
    const $cf62282f77ec055e$export$82f68a404cfea29 = ()=>({
            type: $cf62282f77ec055e$export$4580e708995fb75f
        });
    const $cf62282f77ec055e$export$b38f09eddeeb56fb = ()=>({
            type: $cf62282f77ec055e$export$31889003e5372a7f
        });
});
parcelRegister("15VA4", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$faf718014e7ea2d5$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "getTeamDescriptionPayload", ()=>$faf718014e7ea2d5$export$a31038b7085fc230);
    var $lV634;
    const $faf718014e7ea2d5$export$bcae9ba627f604b6 = {
        addNewTeam: '/rest/jpo/1.0/team/addNew',
        addAtlassianTeam: ' /rest/jpo/1.0/team/addExternal',
        updateTeam: '/rest/jpo/1.0/team/update',
        revertTeamChanges: '/rest/jpo/1.0/team/revert',
        deleteTeam: '/rest/jpo/1.0/team/delete',
        revertResourceChanges: '/rest/jpo/1.0/resource/revertMember',
        addTeamMember: '/rest/jpo/1.0/resource/addMember',
        deleteTeamMember: '/rest/jpo/1.0/resource/deleteMember',
        setShared: (id)=>`/rest/teams/1.0/teams/${id}/setShared`,
        setSharedNew: '/rest/jpo/1.0/team/setShared',
        addTeamMemberWithoutScenarioChange: '/rest/jpo/1.0/team/addResources',
        getTWPTeam: (id)=>`/gateway/api/v3/teams/${id}`,
        getTWPTeamV4: (id, siteId)=>`/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`
    };
    const $faf718014e7ea2d5$export$a31038b7085fc230 = (teamData)=>{
        const description = {};
        for (const key of Object.keys(teamData)){
            const value = teamData[key];
            description[key] = (0, parcelRequire("lV634")).default(value) ? {} : {
                value: value
            };
        }
        return description;
    };
});
parcelRegister("OmuMh", function(module, exports) {
    $parcel$export(module.exports, "inspectForCommitWarnings", ()=>$9cd8f0e30db5e04f$export$1eed481c758d15b7);
    $parcel$export(module.exports, "inspectForResourceCommitWarnings", ()=>$9cd8f0e30db5e04f$export$360bb984af0cb967);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $ageG6 = parcelRequire("ageG6");
    var $jeUPY = parcelRequire("jeUPY");
    var $dR3KA = parcelRequire("dR3KA");
    const $9cd8f0e30db5e04f$export$deb6050352aafd0b = {
        header: (0, $dR3KA.default).defaultWarningHeader,
        message: (0, $dR3KA.default).defaultWarningContent,
        messageValues: {}
    };
    function $9cd8f0e30db5e04f$export$40c68b739c0cfa3f({ error: error }) {
        switch(error){
            case 'ENVIRONMENT_ENTITY_NOT_FOUND':
                return {
                    header: (0, $dR3KA.default).teamNotFoundHeader,
                    message: (0, $dR3KA.default).teamNotFoundContent,
                    messageValues: {}
                };
            default:
                return $9cd8f0e30db5e04f$export$deb6050352aafd0b;
        }
    }
    function $9cd8f0e30db5e04f$export$4d5511f367ca5f2({ error: error }, personTitle) {
        switch(error){
            case 'ENVIRONMENT_ENTITY_NOT_FOUND':
                return {
                    header: (0, $dR3KA.default).memberNotFoundHeader,
                    message: (0, $dR3KA.default).memberNotFoundContent,
                    messageValues: {
                        personTitle: personTitle
                    }
                };
            case 'ENVIRONMENT_RELATED_ENTITY_NOT_FOUND':
                return {
                    header: (0, $dR3KA.default).memberOrTeamNotFoundHeader,
                    message: (0, $dR3KA.default).memberOrTeamNotFoundContent,
                    messageValues: {
                        personTitle: personTitle
                    }
                };
            default:
                return $9cd8f0e30db5e04f$export$deb6050352aafd0b;
        }
    }
    function $9cd8f0e30db5e04f$export$1eed481c758d15b7(error) {
        if (error) return [
            $9cd8f0e30db5e04f$export$40c68b739c0cfa3f(error)
        ];
        return [];
    }
    function* $9cd8f0e30db5e04f$export$360bb984af0cb967(error, resourceId) {
        if (error) {
            const resources = yield (0, $aNOuE.select)((0, $jeUPY.getAllResources));
            const resource = resources.find((resource)=>resource.itemKey === resourceId);
            if (resource) {
                const persons = yield (0, $aNOuE.select)((0, $ageG6.getPersons));
                const person = (0, $ageG6.getPersonByItemKey)(persons, resource.personItemKey);
                const personTitle = person && person.values.title || '';
                return [
                    $9cd8f0e30db5e04f$export$4d5511f367ca5f2(error, personTitle)
                ];
            }
            return [
                $9cd8f0e30db5e04f$export$4d5511f367ca5f2(error, '')
            ];
        }
        return [];
    }
});
parcelRegister("dR3KA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$200887f26af6650f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $200887f26af6650f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        teamNotFoundHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.teams.team-not-found-header",
            "defaultMessage": "This team no longer exists in the plan"
        },
        teamNotFoundContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.teams.team-not-found-content",
            "defaultMessage": "Refresh your plan to reflect this change"
        },
        memberNotFoundHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.teams.member-not-found-header",
            "defaultMessage": "Member {personTitle} could not be found"
        },
        memberNotFoundContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.teams.member-not-found-content",
            "defaultMessage": "Refresh to update your plan"
        },
        memberOrTeamNotFoundHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.teams.member-or-team-not-found-header",
            "defaultMessage": "Member {personTitle} or team could not be found"
        },
        memberOrTeamNotFoundContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.teams.member-or-team-not-found-content",
            "defaultMessage": "Refresh to update your plan"
        },
        defaultWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.teams.default-warning-header",
            "defaultMessage": "Could not be committed for unknown reasons."
        },
        defaultWarningContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.teams.default-warning-content",
            "defaultMessage": "Team could not be committed for unknown reasons. Please contact your administrator."
        }
    });
});
parcelRegister("bX3WS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18caacc53aaee6bc$export$2e2bcd8739ae039);
    var $dRVQG = parcelRequire("dRVQG");
    const $18caacc53aaee6bc$var$isDialogOpen = (state)=>state.ui.Main.Tabs.Teams.TeamsList.isDialogOpen;
    const $18caacc53aaee6bc$var$mapStateToProps = (state)=>({
            isDialogOpen: $18caacc53aaee6bc$var$isDialogOpen(state),
            editedTeam: (0, $dRVQG.getEditedTeam)(state),
            additionalTeamsById: (0, $dRVQG.getAdditionalTeamsById)(state)
        });
    var $18caacc53aaee6bc$export$2e2bcd8739ae039 = $18caacc53aaee6bc$var$mapStateToProps;
});
parcelRegister("9ViyR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$799b7b0964282cca$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $kgoHi;
    var $koVbs;
    var $g7G9N = parcelRequire("g7G9N");
    var $foHm8 = parcelRequire("foHm8");
    var $lVJAU;
    var $aaTT0 = parcelRequire("aaTT0");
    const $799b7b0964282cca$var$MODAL_COPY = {
        Kanban: {
            teamDialogHeading: (0, $aaTT0.default).kanbanHeader,
            teamDialogSubheading: (0, $aaTT0.default).kanbanSubheading,
            teamDialogBody: (0, $aaTT0.default).kanbanBodyCopy
        },
        Scrum: {
            teamDialogHeading: (0, $aaTT0.default).scrumHeader,
            teamDialogSubheading: (0, $aaTT0.default).scrumSubheading,
            teamDialogBody: (0, $aaTT0.default).scrumBodyCopy
        }
    };
    function $799b7b0964282cca$export$2e2bcd8739ae039({ openTeamsDialog: openTeamsDialog, onAddAtlassianTeam: onAddAtlassianTeam, closeTeamsDialog: closeTeamsDialog, deleteTeam: deleteTeam, isDialogOpen: isDialogOpen, additionalTeamsById: additionalTeamsById, team: team, teamId: teamId, trigger: trigger, editedTeam: editedTeam, mode: mode }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const additionalTeam = (0, $5uXOq.useMemo)(()=>additionalTeamsById[teamId], [
            additionalTeamsById,
            teamId
        ]);
        const [cancellable, setCancellable] = (0, $5uXOq.useState)(false);
        const openModal = (0, $5uXOq.useCallback)(()=>{
            if (!team) return;
            openTeamsDialog({
                teamId: team.id,
                title: team.title,
                recommendedSchedulingMode: mode
            });
        }, [
            mode,
            openTeamsDialog,
            team
        ]);
        const addTeam = (0, $5uXOq.useCallback)(async ()=>{
            const { externalId: externalId, title: title } = additionalTeam;
            setCancellable(true);
            if (externalId) {
                onAddAtlassianTeam({
                    id: externalId,
                    title: title
                });
                openTeamsDialog({
                    teamId: teamId,
                    title: title,
                    recommendedSchedulingMode: mode
                });
            }
        }, [
            additionalTeam,
            mode,
            onAddAtlassianTeam,
            openTeamsDialog,
            teamId
        ]);
        const handleClickModal = (0, $5uXOq.useCallback)(()=>{
            if (team) openModal();
            else addTeam();
        }, [
            addTeam,
            openModal,
            team
        ]);
        const onCancel = (0, $5uXOq.useCallback)(()=>{
            closeTeamsDialog();
            if (cancellable) {
                deleteTeam({
                    id: teamId
                });
                setCancellable(false);
            }
        }, [
            cancellable,
            closeTeamsDialog,
            deleteTeam,
            teamId
        ]);
        const shouldRenderModal = (0, $5uXOq.useMemo)(()=>isDialogOpen && teamId === editedTeam?.teamId, [
            editedTeam?.teamId,
            isDialogOpen,
            teamId
        ]);
        const redirectToIssueSources = (0, $5uXOq.useCallback)(()=>{
            const url = `/jira/plans/${(0, $g7G9N.getPlanId)()}/scenarios/${(0, $g7G9N.getScenarioId)()}/settings/issue-sources`;
            push(url);
        }, [
            push
        ]);
        const isExternalPlanOnlyTeam = !team && !additionalTeam?.externalId;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center"
        }, !isExternalPlanOnlyTeam ? formatMessage(trigger, {
            modal: (chunks)=>$799b7b0964282cca$export$350ef6ba50280480(chunks, handleClickModal),
            link: (chunks)=>$799b7b0964282cca$export$d43f0d7892afdfe3(chunks, redirectToIssueSources)
        }) : null, shouldRenderModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $foHm8.default), {
            onClose: onCancel,
            ...mode && $799b7b0964282cca$var$MODAL_COPY[mode],
            recommendedSchedulingMode: mode
        }));
    }
    const $799b7b0964282cca$export$350ef6ba50280480 = (chunks, handleClickModal)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-haspopup": "dialog",
            appearance: "link",
            spacing: "compact",
            onClick: handleClickModal
        }, chunks);
    const $799b7b0964282cca$export$d43f0d7892afdfe3 = (chunks, redirectToIssueSources)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            as: "a",
            appearance: "link",
            onClick: redirectToIssueSources,
            href: `/jira/plans/${(0, $g7G9N.getPlanId)()}/scenarios/${(0, $g7G9N.getScenarioId)()}/settings/issue-sources`
        }, chunks);
});
parcelRegister("foHm8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1401310117cfe845$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9LlxN = parcelRequire("9LlxN");
    var $TRSc6 = parcelRequire("TRSc6");
    var $8Snn1 = parcelRequire("8Snn1");
    var $1401310117cfe845$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $TRSc6.default), (0, $9LlxN.default))((0, $8Snn1.default));
});
parcelRegister("9LlxN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$084b9ea149eb39df$export$2e2bcd8739ae039);
    var $gIlW4 = parcelRequire("gIlW4");
    var $6Qf3i = parcelRequire("6Qf3i");
    var $084b9ea149eb39df$export$2e2bcd8739ae039 = (dispatch)=>({
            createTeam: (payload)=>{
                dispatch((0, $gIlW4.createTeam)(payload));
            },
            editTeam: (payload)=>{
                dispatch((0, $gIlW4.editTeam)(payload));
            },
            onAddAtlassianTeam: (payload)=>{
                dispatch((0, $gIlW4.addAtlassianTeam)(payload));
            },
            setEditMode: (team)=>{
                dispatch((0, $6Qf3i.openTeamsDialog)(team));
                dispatch((0, $6Qf3i.setMode)((0, $6Qf3i.EDIT_MODE)));
            }
        });
});
parcelRegister("TRSc6", function(module, exports) {
    $parcel$export(module.exports, "getRequestStatus", ()=>$d5b98c86d5b4cda2$export$ff1c47eee91e9cd0);
    $parcel$export(module.exports, "default", ()=>$d5b98c86d5b4cda2$export$2e2bcd8739ae039);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $8QpSo;
    var $6WWH1 = parcelRequire("6WWH1");
    var $dRVQG = parcelRequire("dRVQG");
    const $d5b98c86d5b4cda2$export$ff1c47eee91e9cd0 = (state)=>state.ui.Main.Tabs.Teams.TeamsList.isProcessingRequest;
    const $d5b98c86d5b4cda2$var$isCreateTwpFormLoading = (state)=>state.ui.Main.Tabs.Teams.CreateTeam.isCreateTwpFormLoading;
    const $d5b98c86d5b4cda2$var$getAddedTWPInfoMemoized = ()=>(0, $dGvGJ.createSelector)((0, $dRVQG.getAddedTWPInfo), (res)=>res);
    const $d5b98c86d5b4cda2$var$mapStateToPropsFactory = ()=>{
        const getTeamByIdFactory = (0, (0, parcelRequire("8QpSo")).default)((state)=>(teamId)=>(0, $dRVQG.getTeamById)(state, teamId));
        const getAddedTWPInfoInstance = $d5b98c86d5b4cda2$var$getAddedTWPInfoMemoized();
        return (state)=>({
                dialogMode: (0, $dRVQG.getDialogMode)(state),
                editedTeam: (0, $dRVQG.getEditedTeam)(state),
                getTeamById: getTeamByIdFactory(state),
                isProcessingRequest: $d5b98c86d5b4cda2$export$ff1c47eee91e9cd0(state),
                teams: (0, $dRVQG.getTeams)(state),
                addedTWPInfo: getAddedTWPInfoInstance(state),
                isCreateTwpFormLoading: $d5b98c86d5b4cda2$var$isCreateTwpFormLoading(state),
                teamPermissions: (0, $6WWH1.getTeamPermissions)(state)
            });
    };
    const $d5b98c86d5b4cda2$var$mapStateToProps = $d5b98c86d5b4cda2$var$mapStateToPropsFactory;
    var $d5b98c86d5b4cda2$export$2e2bcd8739ae039 = $d5b98c86d5b4cda2$var$mapStateToProps;
});
parcelRegister("8Snn1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7561836efeac102b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ldJSL;
    var $7O4UO;
    var $2x3Cb;
    var $e8Dhe;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $jouoW;
    var $eTXmK;
    var $4R6GH;
    var $koVbs;
    var $aCpcO;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $j1xGF;
    var $i2qlb = parcelRequire("i2qlb");
    var $6Qf3i = parcelRequire("6Qf3i");
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $1Cyfv = parcelRequire("1Cyfv");
    var $ihPUd = parcelRequire("ihPUd");
    var $8zOmE;
    var $2NMNM;
    var $14XJw;
    var $1ppIJ;
    var $koeKL;
    var $42TSH = parcelRequire("42TSH");
    var $SeIn8 = parcelRequire("SeIn8");
    var $hwi8c = parcelRequire("hwi8c");
    var $O7quA = parcelRequire("O7quA");
    var $itNBH = parcelRequire("itNBH");
    var $1OeDK = parcelRequire("1OeDK");
    var $22dvl = parcelRequire("22dvl");
    const $7561836efeac102b$export$40484b82c70932f7 = (existingTeams)=>(atlassianTeamOptions)=>atlassianTeamOptions.filter((atlassianTeam)=>!existingTeams.some((existingTeam)=>existingTeam.externalId === atlassianTeam.id));
    const $7561836efeac102b$export$a0a81dc3380ce7d3 = (value)=>{
        if (value === '') return null;
        if (typeof value === 'string') return +value;
        return value;
    };
    const $7561836efeac102b$var$PlansIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            height: 32,
            width: 32,
            fill: "none",
            viewBox: "0 0 32 32"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "currentColor",
            d: "M10 8a1 1 0 000 2h4a1 1 0 100-2h-4zM10 12a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM10 14a1 1 0 100 2h2a1 1 0 100-2h-2z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8 4a2 2 0 012-2h4a2 2 0 012 2h1a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h1zm6 3a2 2 0 001.732-1H17v12H7V6h1.268A2 2 0 0010 7h4zm0-3h-4v1h4V4z",
            clipRule: "evenodd"
        }));
    class $7561836efeac102b$export$3c0d2c056fd75208 extends (0, $5uXOq.Component) {
        componentDidMount() {
            if (!this.isCreatingMode()) this.setState({
                teamFormStep: (0, $22dvl.TEAM_SETTINGS)
            });
            else if ((0, $4nDwW.isDefined)(this.props.teamPermissions.canCreateTeams) && !this.props.teamPermissions.canCreateTeams) this.setState({
                selectedTeamScope: 'planOnly',
                teamFormStep: (0, $22dvl.TEAM_SETTINGS)
            });
        }
        componentDidUpdate(prevProps) {
            if (this.modalFooterPortalRef && this.modalFooterPortalRef.current && !this.state.modalFooterDivElement) this.setState({
                modalFooterDivElement: this.modalFooterPortalRef.current
            });
            const isProcessingRequestChanged = (0, $4nDwW.isDefined)(this.props.isProcessingRequest) && !this.props.isProcessingRequest && (0, $4nDwW.isDefined)(prevProps.isProcessingRequest) && prevProps.isProcessingRequest;
            const steps = [
                (0, $22dvl.LANDING_STEP),
                (0, $22dvl.CREATE_COMPANY_SCOPED_TEAM)
            ];
            if (steps.includes(this.state.teamFormStep) && isProcessingRequestChanged && this.props.addedTWPInfo && this.props.addedTWPInfo.teamId && this.props.addedTWPInfo.teamTitle) {
                this.props.setEditMode({
                    teamId: this.props.addedTWPInfo.teamId,
                    title: this.props.addedTWPInfo.teamTitle
                });
                this.goToNextStep();
            }
        }
        goToNextStep() {
            const { selectedTeamScope: selectedTeamScope, selectedAtlassianTeam: selectedAtlassianTeam, teamFormStep: teamFormStep, formSelected: formSelected } = this.state;
            const createNewTeamNextStep = selectedTeamScope === 'availableAcrossOrganisation' ? (0, $22dvl.CREATE_COMPANY_SCOPED_TEAM) : (0, $22dvl.TEAM_SETTINGS);
            switch(teamFormStep){
                case 0, $22dvl.LANDING_STEP:
                    return this.setState({
                        teamFormStep: formSelected === (0, $22dvl.EXISTING_TEAM) && selectedAtlassianTeam ? (0, $22dvl.SUCCESS_CONFIRMATION) : createNewTeamNextStep
                    });
                case 0, $22dvl.CREATE_COMPANY_SCOPED_TEAM:
                    return this.setState({
                        teamFormStep: (0, $22dvl.SUCCESS_CONFIRMATION)
                    });
                case 0, $22dvl.SUCCESS_CONFIRMATION:
                    return this.setState({
                        teamFormStep: (0, $22dvl.TEAM_SETTINGS)
                    });
                default:
                    break;
            }
        }
        isCreateTwpFormLoaded() {
            const { teamFormStep: teamFormStep } = this.state;
            const { isCreateTwpFormLoading: isCreateTwpFormLoading } = this.props;
            return teamFormStep === (0, $22dvl.CREATE_COMPANY_SCOPED_TEAM) && !isCreateTwpFormLoading;
        }
        render() {
            const { isProcessingRequest: isProcessingRequest, onClose: onClose } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1ppIJ")).ModalDialog), {
                autoFocus: true,
                onClose: onClose,
                shouldCloseOnEscapePress: !isProcessingRequest,
                shouldCloseOnOverlayClick: false,
                width: this.getFormWidth(),
                height: this.getFormHeight(),
                shouldScrollInViewport: true
            }, this.getFormHeading(), this.getFormContent(), this.getFormFooter());
        }
        constructor(...args){
            super(...args);
            this.modalFooterPortalRef = (0, $5uXOq.createRef)();
            this.state = {
                formSelected: (0, $22dvl.EXISTING_TEAM),
                selectedAtlassianTeam: null,
                selectedTeamScope: 'availableAcrossOrganisation',
                teamFormStep: (0, $22dvl.LANDING_STEP),
                modalFooterDivElement: null
            };
            this.submitCreation = ({ iterationLength: iterationLength, weeklyHours: weeklyHours, velocity: velocity, ...fields })=>{
                (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).CREATE_TEAM);
                this.props.createTeam({
                    ...fields,
                    iterationLength: $7561836efeac102b$export$a0a81dc3380ce7d3(iterationLength),
                    weeklyHours: $7561836efeac102b$export$a0a81dc3380ce7d3(weeklyHours),
                    velocity: $7561836efeac102b$export$a0a81dc3380ce7d3(velocity)
                });
            };
            this.submitEdition = ({ iterationLength: iterationLength, weeklyHours: weeklyHours, velocity: velocity, ...payload }, enhancedTeam)=>{
                const { editTeam: editTeam, editedTeam: editedTeam } = this.props;
                if ((0, $4nDwW.isDefined)(editedTeam) && (0, $4nDwW.isDefined)(editedTeam.teamId)) {
                    const formFields = {
                        iterationLength: $7561836efeac102b$export$a0a81dc3380ce7d3(iterationLength),
                        weeklyHours: $7561836efeac102b$export$a0a81dc3380ce7d3(weeklyHours),
                        velocity: $7561836efeac102b$export$a0a81dc3380ce7d3(velocity),
                        ...payload
                    };
                    (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).UPDATE_TEAM);
                    editTeam({
                        formFields: formFields,
                        enhancedTeam: enhancedTeam,
                        teamId: editedTeam.teamId
                    });
                }
            };
            this.handleChange = (selectedForm, form)=>{
                if (selectedForm !== form) this.setState({
                    formSelected: form
                });
            };
            this.renderRadioSelect = (selectedForm, form)=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                const radioLabel = form === (0, $22dvl.NEW_TEAM) ? 'createANewTeamRadioLabel' : 'addExistingTeamRadioLabel';
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $O7quA.radioSelect
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                    isChecked: selectedForm === form,
                    label: formatMessage((0, $hwi8c.default)[radioLabel]),
                    name: "standalone",
                    onChange: ()=>{
                        this.handleChange(selectedForm, form);
                    },
                    testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.${form === (0, $22dvl.NEW_TEAM) ? 'create-new-team' : 'add-existing-team'}`,
                    value: "single-radio"
                })));
            };
            this.isCreatingMode = ()=>this.props.dialogMode === (0, $6Qf3i.CREATE_MODE);
            this.getCreateANewTeamSelectOptions = ()=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                return [
                    {
                        description: formatMessage((0, $hwi8c.default).planOnlyLimitedTeamHelpText),
                        icon: (0, ($parcel$interopDefault($5uXOq))).createElement($7561836efeac102b$var$PlansIcon, null),
                        label: formatMessage((0, $hwi8c.default).planOnlyTeam),
                        value: 'planOnly'
                    },
                    {
                        description: formatMessage((0, $hwi8c.default).availableAcrossOrgTeamHelpText),
                        icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("e8Dhe"))))), {
                            label: formatMessage((0, $hwi8c.default).availableAcrossOrgTeam)
                        }),
                        label: formatMessage((0, $hwi8c.default).availableAcrossOrgTeam),
                        value: 'availableAcrossOrganisation'
                    }
                ];
            };
            this.renderTeamTypeOption = ({ description: description, icon: icon, label: label }, { context: context })=>{
                if (context === 'menu') return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $O7quA.teamTypeOption
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $O7quA.teamTypeOptionIcon
                }, icon), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $O7quA.teamTypeOptionTitle
                }, label), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $O7quA.teamTypeOptionDescription
                }, description))));
                return label;
            };
            this.renderAddFormLandingStep = ()=>{
                const { cloudId: cloudId, intl: { formatMessage: formatMessage }, orgId: orgId, teams: teams } = this.props;
                const { formSelected: formSelected, selectedAtlassianTeam: selectedAtlassianTeam } = this.state;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $O7quA.addTeamDialogBody
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $O7quA.imageIllustrationPanel
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                    src: (0, ($parcel$interopDefault($42TSH))),
                    alt: ""
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $O7quA.teamSelectionPanel
                }, formatMessage((0, $hwi8c.default).addTeamToPlanDescription), this.renderRadioSelect(formSelected, (0, $22dvl.EXISTING_TEAM)), formSelected === (0, $22dvl.EXISTING_TEAM) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $O7quA.teamField,
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.twp-team-picker-field"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    name: "atlassianTeam"
                }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
                        htmlFor: "portfolio-3-portfolio_app-simple-plans_main_tabs_teams_list_team-add-existing-team-select-field"
                    }, formatMessage((0, $hwi8c.default).selectAnExistingTeamLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j1xGF")).default), {
                        ...fieldProps,
                        debounceTime: 400,
                        fieldId: "team",
                        filterOptions: $7561836efeac102b$export$40484b82c70932f7(teams),
                        includeGroups: false,
                        includeTeams: true,
                        includeUsers: false,
                        menuPlacement: "auto",
                        menuPortalTarget: (0, $4y9A5.getBody)(),
                        onChange: (atlassianTeam)=>{
                            this.setState({
                                selectedAtlassianTeam: (0, $4nDwW.isDefined)(atlassianTeam) ? atlassianTeam : null
                            });
                        },
                        placeholder: formatMessage((0, $hwi8c.default).selectOrEnterTeamNamePlaceholder),
                        productKey: "jira",
                        siteId: cloudId,
                        orgId: orgId,
                        styles: {
                            menuPortal: (base)=>({
                                    ...base,
                                    zIndex: 9999
                                }),
                            placeholder: (base)=>({
                                    ...base,
                                    position: 'unset',
                                    top: '',
                                    left: '',
                                    transform: ''
                                }),
                            valueContainer: (base)=>({
                                    ...base,
                                    display: 'grid'
                                })
                        },
                        value: selectedAtlassianTeam,
                        inputId: "portfolio-3-portfolio_app-simple-plans_main_tabs_teams_list_team-add-existing-team-select-field"
                    })))), this.renderRadioSelect(formSelected, (0, $22dvl.NEW_TEAM)), formSelected === (0, $22dvl.NEW_TEAM) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $O7quA.teamField
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    name: "teamScope"
                }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
                        htmlFor: "portfolio-3-portfolio_app-simple-plans_main_tabs_teams_list_team-create-a-new-team-select-field"
                    }, formatMessage((0, $hwi8c.default).selectNewTeamType)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        ...fieldProps,
                        classNamePrefix: "portfolio-3-portfolio_app-simple-plans_main_tabs_teams_list_team-dialog_team-scope",
                        defaultValue: this.getCreateANewTeamSelectOptions()[1],
                        formatOptionLabel: this.renderTeamTypeOption,
                        isSearchable: false,
                        menuPlacement: "auto",
                        menuPortalTarget: (0, $4y9A5.getBody)(),
                        onChange: (selectedTeamScope)=>{
                            this.setState({
                                selectedTeamScope: selectedTeamScope.value
                            });
                        },
                        options: this.getCreateANewTeamSelectOptions(),
                        styles: {
                            control: (styles)=>({
                                    ...styles,
                                    width: '350px'
                                }),
                            menuPortal: (base)=>({
                                    ...base,
                                    zIndex: 9999
                                })
                        },
                        inputId: "portfolio-3-portfolio_app-simple-plans_main_tabs_teams_list_team-create-a-new-team-select-field"
                    })))))));
            };
            this.renderLandingStepFooter = ()=>{
                const { intl: { formatMessage: formatMessage }, isProcessingRequest: isProcessingRequest, onAddAtlassianTeam: onAddAtlassianTeam, onClose: onClose, isCreateTwpFormLoading: isCreateTwpFormLoading } = this.props;
                const { formSelected: formSelected, selectedAtlassianTeam: selectedAtlassianTeam, selectedTeamScope: selectedTeamScope } = this.state;
                const isLoading = (0, $4nDwW.isDefined)(isProcessingRequest) ? isProcessingRequest : false;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "subtle",
                    onClick: onClose
                }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "primary",
                    isDisabled: formSelected === (0, $22dvl.EXISTING_TEAM) && !(0, $4nDwW.isDefined)(selectedAtlassianTeam) || formSelected === (0, $22dvl.NEW_TEAM) && selectedTeamScope === '',
                    isLoading: isLoading || isCreateTwpFormLoading,
                    onClick: (e, analyticsEvent)=>{
                        if (formSelected === (0, $22dvl.EXISTING_TEAM) && (0, $4nDwW.isDefined)(selectedAtlassianTeam)) {
                            onAddAtlassianTeam({
                                id: selectedAtlassianTeam.id
                            });
                            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ATLAS_TEAM_ADDED.split(' ');
                            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                                action: action,
                                actionSubject: actionSubject
                            }));
                        } else if (formSelected === (0, $22dvl.NEW_TEAM)) this.goToNextStep();
                    },
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.next"
                }, formatMessage(formSelected === (0, $22dvl.EXISTING_TEAM) ? (0, $hwi8c.default).addTeamButton : (0, $ihPUd.default).next)));
            };
            this.getFormFooter = ()=>{
                const { intl: { formatMessage: formatMessage }, onClose: onClose } = this.props;
                const { teamFormStep: teamFormStep } = this.state;
                switch(teamFormStep){
                    case 0, $22dvl.TEAM_SETTINGS:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            id: "modalFooterPortal",
                            ref: this.modalFooterPortalRef
                        }));
                    case 0, $22dvl.SUCCESS_CONFIRMATION:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                            appearance: "subtle",
                            onClick: onClose
                        }, formatMessage((0, $hwi8c.default).labelForViewPlanBtn)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                            appearance: "primary",
                            onClick: ()=>{
                                this.goToNextStep();
                            }
                        }, formatMessage((0, $hwi8c.default).labelForConfigTeamBtn))));
                    case 0, $22dvl.LANDING_STEP:
                    case 0, $22dvl.CREATE_COMPANY_SCOPED_TEAM:
                    default:
                        return !this.isCreateTwpFormLoaded() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, this.renderLandingStepFooter(), " ");
                }
            };
            this.getTeam = ()=>{
                const { editedTeam: editedTeam, getTeamById: getTeamById, addedTWPInfo: addedTWPInfo } = this.props;
                const twpTeamId = addedTWPInfo ? addedTWPInfo.teamId : null;
                const teamId = editedTeam ? editedTeam.teamId : twpTeamId;
                return (0, $4nDwW.isDefined)(teamId) ? getTeamById(teamId) : null;
            };
            this.getFormHeading = ()=>{
                const { intl: { formatMessage: formatMessage }, teamDialogHeading: teamDialogHeading } = this.props;
                const { teamFormStep: teamFormStep } = this.state;
                let heading = null;
                switch(teamFormStep){
                    case 0, $22dvl.TEAM_SETTINGS:
                        heading = formatMessage(this.isCreatingMode() ? (0, $hwi8c.default).createPlanOnlyTeam : (0, $ihPUd.default).teamSettings);
                        break;
                    case 0, $22dvl.SUCCESS_CONFIRMATION:
                        heading = '';
                        break;
                    case 0, $22dvl.LANDING_STEP:
                    case 0, $22dvl.CREATE_COMPANY_SCOPED_TEAM:
                    default:
                        heading = this.isCreateTwpFormLoaded() ? null : formatMessage((0, $hwi8c.default).addTeamToPlanHeading);
                        break;
                }
                if (teamDialogHeading && (0, (0, parcelRequire("4R6GH")).fg)('eou_open_team_dialog_in_timeline')) heading = formatMessage(teamDialogHeading);
                if ((0, $4nDwW.isDefined)(heading)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, heading));
            };
            this.getFormWidth = ()=>{
                const { teamFormStep: teamFormStep } = this.state;
                switch(teamFormStep){
                    case 0, $22dvl.TEAM_SETTINGS:
                        return 'medium';
                    default:
                        return 'large';
                }
            };
            this.getFormHeight = ()=>{
                const { teamFormStep: teamFormStep } = this.state;
                switch(teamFormStep){
                    case 0, $22dvl.SUCCESS_CONFIRMATION:
                        return 455;
                    default:
                        return undefined;
                }
            };
            this.getFormContent = ()=>{
                const { dialogMode: dialogMode, onClose: onClose, addedTWPInfo: addedTWPInfo, teamDialogSubheading: teamDialogSubheading, teamDialogBody: teamDialogBody } = this.props;
                const { teamFormStep: teamFormStep, modalFooterDivElement: modalFooterDivElement } = this.state;
                const team = this.getTeam();
                const landingPage = this.renderAddFormLandingStep();
                switch(teamFormStep){
                    case 0, $22dvl.TEAM_SETTINGS:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $itNBH.default), {
                            ...(0, (0, parcelRequire("4R6GH")).fg)('eou_open_team_dialog_in_timeline') && {
                                formBody: teamDialogBody,
                                formHeading: teamDialogSubheading
                            },
                            dialogMode: dialogMode,
                            onCloseForm: onClose,
                            onSubmitForm: this.isCreatingMode() ? this.submitCreation : this.submitEdition,
                            team: this.isCreatingMode() ? null : team,
                            modalFooterDivElement: modalFooterDivElement
                        }));
                    case 0, $22dvl.SUCCESS_CONFIRMATION:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1OeDK.default), {
                            teamTitle: addedTWPInfo.teamTitle || ''
                        }));
                    case 0, $22dvl.LANDING_STEP:
                    case 0, $22dvl.CREATE_COMPANY_SCOPED_TEAM:
                    default:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !this.isCreateTwpFormLoaded() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, landingPage), teamFormStep === (0, $22dvl.CREATE_COMPANY_SCOPED_TEAM) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $SeIn8.default), {
                            onClose: onClose
                        }));
                }
            };
        }
    }
    const $7561836efeac102b$var$TeamDialogWithOrgId = (props)=>{
        const { data: data } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { editedTeam: editedTeam } = props;
        (0, $5uXOq.useEffect)(()=>{
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).TEAM_DIALOG_OPEN.split(' ');
            const attributes = {
                recommendedSchedulingMode: editedTeam?.recommendedSchedulingMode
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            }), attributes);
            return ()=>{
                const [actionSubjectClose, actionClose] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).TEAM_DIALOG_CLOSE.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: actionClose,
                    actionSubject: actionSubjectClose
                }), attributes);
            };
        }, [
            createAnalyticsEvent,
            editedTeam?.recommendedSchedulingMode
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7561836efeac102b$export$3c0d2c056fd75208, {
            ...props,
            cloudId: cloudId,
            orgId: data,
            intl: intl
        });
    };
    var $7561836efeac102b$export$2e2bcd8739ae039 = $7561836efeac102b$var$TeamDialogWithOrgId;
});
parcelRegister("e8Dhe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a4b0479e3879f3a8$var$_react = $a4b0479e3879f3a8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $a4b0479e3879f3a8$var$_officeBuilding = $a4b0479e3879f3a8$var$_interopRequireDefault((parcelRequire("4bTdk")));
    function $a4b0479e3879f3a8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a4b0479e3879f3a8$var$OfficeBuildingFilledIcon = (props)=>$a4b0479e3879f3a8$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8z"/><path fill="inherit" d="M6 10h2v2H6zm0 3h2v2H6z"/><path fill="currentcolor" d="M9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/><path fill="inherit" d="M12 7h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/></g></svg>`
        }, props, {
            newIcon: $a4b0479e3879f3a8$var$_officeBuilding.default
        }));
    $a4b0479e3879f3a8$var$OfficeBuildingFilledIcon.displayName = 'OfficeBuildingFilledIcon';
    var $a4b0479e3879f3a8$var$_default = module.exports.default = $a4b0479e3879f3a8$var$OfficeBuildingFilledIcon;
});
parcelRegister("4bTdk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $30d304d6d8375db3$var$_react = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $30d304d6d8375db3$var$_UNSAFE_baseNew = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $30d304d6d8375db3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $30d304d6d8375db3$var$OfficeBuildingIcon = (props)=>$30d304d6d8375db3$var$_react.default.createElement($30d304d6d8375db3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15.25V2c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v13.25m10.5 0h-3.5m3.5 0H15m-12.25 0h3.5m-3.5 0H1m4-11.5h2m2 0h2m0 3H9m-2 0H5m1.25 8.5v-4.5h3.5v4.5m-3.5 0h3.5"/>`
        }, props));
    $30d304d6d8375db3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
    var $30d304d6d8375db3$var$_default = module.exports.default = $30d304d6d8375db3$var$OfficeBuildingIcon;
});
parcelRegister("jouoW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d22fafff331be84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    const $5d22fafff331be84$var$packageName = "platform-pkg";
    const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
    const $5d22fafff331be84$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $5d22fafff331be84$var$labelPaddingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $5d22fafff331be84$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        position: 'relative',
        alignItems: 'flex-start',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
            cursor: 'not-allowed'
        }
    });
    const $5d22fafff331be84$var$radioStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '24px',
        height: '24px',
        margin: "var(--ds-space-0, 0px)",
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        backgroundColor: 'var(--radio-background-color)',
        border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        MozAppearance: 'none',
        outline: 'none',
        '--radio-background-color': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-dot-opacity': 0,
        transform: 'scale(calc(7 / 12))',
        transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
        verticalAlign: 'top',
        WebkitAppearance: 'none',
        '&::after': {
            width: 'calc(4px * 12 / 7)',
            height: 'calc(4px * 12 / 7)',
            position: 'absolute',
            background: 'var(--radio-dot-color)',
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: "''",
            opacity: 'var(--radio-dot-opacity)',
            transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
        },
        '&:hover': {
            '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
        },
        '&:active': {
            '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        },
        '&:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&:checked': {
            '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-dot-opacity': 1
        },
        '&:checked:hover': {
            '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`
        },
        '&:checked:active': {
            '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
            '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        '&:checked:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&[data-invalid], &:checked[data-invalid]': {
            '--radio-border-color': `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        },
        '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
            cursor: 'not-allowed',
            '--radio-background-color': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-border-color': `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
        }
    });
    const $5d22fafff331be84$var$InnerRadio = (0, $5uXOq.forwardRef)(function Radio(props, ref) {
        const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, ...rest } = props;
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'radio',
            packageName: $5d22fafff331be84$var$packageName,
            packageVersion: $5d22fafff331be84$var$packageVersion
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            "data-testid": testId && `${testId}--radio-label`,
            "data-disabled": isDisabled ? 'true' : undefined,
            css: $5d22fafff331be84$var$labelStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...rest,
            tabIndex: 0,
            "aria-label": ariaLabel,
            checked: isChecked,
            disabled: isDisabled,
            name: name,
            onChange: onChangeAnalytics,
            required: isRequired,
            type: "radio",
            value: value,
            "data-testid": testId && `${testId}--radio-input`,
            "data-invalid": isInvalid ? 'true' : undefined,
            css: $5d22fafff331be84$var$radioStyles,
            ref: ref
        }), label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $5d22fafff331be84$var$labelPaddingStyles
        }, label) : null);
    });
    const $5d22fafff331be84$var$Radio = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Radio(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($5d22fafff331be84$var$InnerRadio, {
            ...props,
            ref: ref
        });
    }));
    var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;
});
parcelRegister("j1xGF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f944e1b2d830480$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $8f944e1b2d830480$var$AsyncUserPicker = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("k4ap2")), {
        moduleId: "./src/packages/portfolio-3/common/src/user-picker/index.tsx"
    });
    var $8f944e1b2d830480$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "advanced-roadmaps-user-picker",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8f944e1b2d830480$var$AsyncUserPicker, props));
});
parcelRegister("k4ap2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("206dx").then(()=>parcelRequire('bvOgH'));
});
parcelRegister("1ppIJ", function(module, exports) {
    $parcel$export(module.exports, "ModalDialog", ()=>$8fbdebf88f199b98$export$1fa217be60c2f188);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $lu5k0;
    const $8fbdebf88f199b98$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
        const returnFocusTarget = (0, (0, parcelRequire("lu5k0")).useReturnFocusTo)();
        const { setReturnFocusTo: setReturnFocusTo } = (0, (0, parcelRequire("lu5k0")).useModalDialogActions)();
        (0, $5uXOq.useEffect)(()=>()=>{
                if (returnFocusTarget?.current) {
                    !shouldReturnFocus && returnFocusTarget.current.focus();
                    setReturnFocusTo(null);
                }
            }, [
            returnFocusTarget,
            setReturnFocusTo,
            shouldReturnFocus
        ]);
        const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            shouldReturnFocus: returnFocus,
            ...rest
        });
    };
});
parcelRegister("lu5k0", function(module, exports) {
    $parcel$export(module.exports, "useModalDialogActions", ()=>$5f429bdcb9dbbc95$export$3cf2e4b6d3541465);
    $parcel$export(module.exports, "useReturnFocusTo", ()=>$5f429bdcb9dbbc95$export$217308a4ece853b2);
    var $3sQ5x;
    var $iXqE5;
    var $49R2H;
    var $a3Qjd;
    var $kIxMH;
    const $5f429bdcb9dbbc95$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'JiraSoftwareModalDialog',
        initialState: (0, parcelRequire("49R2H")).initialState,
        actions: (0, parcelRequire("a3Qjd")).actions
    });
    const $5f429bdcb9dbbc95$export$3cf2e4b6d3541465 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($5f429bdcb9dbbc95$var$Store);
    const $5f429bdcb9dbbc95$export$217308a4ece853b2 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($5f429bdcb9dbbc95$var$Store, {
        selector: (0, (0, parcelRequire("kIxMH")).getReturnFocusTo)
    });
});
parcelRegister("49R2H", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$1a3a816977643252$export$d4c72bab9d6cc13a);
    const $1a3a816977643252$export$d4c72bab9d6cc13a = {
        returnFocusTo: null
    };
});
parcelRegister("a3Qjd", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$1886bc9c17d47b9b$export$e324594224ef24da);
    const $1886bc9c17d47b9b$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
            setState({
                returnFocusTo: returnFocusTo
            });
        };
    const $1886bc9c17d47b9b$export$e324594224ef24da = {
        setReturnFocusTo: $1886bc9c17d47b9b$export$b263d1e638b131c2
    };
});
parcelRegister("kIxMH", function(module, exports) {
    $parcel$export(module.exports, "getReturnFocusTo", ()=>$cd4eb273a1fc9e15$export$d5f8692765ccd209);
    const $cd4eb273a1fc9e15$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;
});
parcelRegister("42TSH", function(module, exports) {
    module.exports = new URL("atlassian-home.dd2e289b.svg", import.meta.url).toString();
});
parcelRegister("SeIn8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd6e5c1b89f6ab53$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5RGZd = parcelRequire("5RGZd");
    var $arXcM = parcelRequire("arXcM");
    var $a7UaZ = parcelRequire("a7UaZ");
    var $cd6e5c1b89f6ab53$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $arXcM.default), (0, $5RGZd.default))((0, $a7UaZ.default));
});
parcelRegister("5RGZd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c237c89306a4dd0$export$2e2bcd8739ae039);
    var $gIlW4 = parcelRequire("gIlW4");
    var $duqH3 = parcelRequire("duqH3");
    var $9c237c89306a4dd0$export$2e2bcd8739ae039 = (dispatch)=>({
            addAtlassianTeam: (payload)=>{
                dispatch((0, $gIlW4.addAtlassianTeam)(payload));
            },
            initiateRequest: ()=>{
                dispatch((0, $duqH3.loadCreateTwpForm)());
            },
            resetRequest: ()=>{
                dispatch((0, $duqH3.resetCreateTwpForm)());
            }
        });
});
parcelRegister("arXcM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$826c5f085ffca4da$export$2e2bcd8739ae039);
    const $826c5f085ffca4da$export$ff1c47eee91e9cd0 = (state)=>state.ui.Main.Tabs.Teams.TeamsList.isProcessingRequest;
    const $826c5f085ffca4da$var$mapStateToProps = (state)=>({
            isProcessingRequest: $826c5f085ffca4da$export$ff1c47eee91e9cd0(state)
        });
    var $826c5f085ffca4da$export$2e2bcd8739ae039 = $826c5f085ffca4da$var$mapStateToProps;
});
parcelRegister("a7UaZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a97e3eb36505ad76$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $euiLX;
    var $ousew;
    var $koVbs;
    var $lfTZh;
    var $cYlk7;
    var $5SXBk;
    var $i2qlb = parcelRequire("i2qlb");
    var $4cwkM = parcelRequire("4cwkM");
    var $8zOmE;
    var $2NMNM;
    var $14XJw;
    var $koeKL;
    var $0Wtmq;
    var $kxZPA;
    var $dfQWF = parcelRequire("dfQWF");
    var $9Y9FP = parcelRequire("9Y9FP");
    function $a97e3eb36505ad76$export$2e2bcd8739ae039({ addAtlassianTeam: addAtlassianTeam, isProcessingRequest: isProcessingRequest, onClose: onClose, initiateRequest: initiateRequest, resetRequest: resetRequest }) {
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const AsyncAkTeamCreateContent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("gg5KR")).then(({ TwpTeamCreationContent: TwpTeamCreationContent })=>{
                resetRequest();
                return TwpTeamCreationContent;
            }), {
            ssr: false,
            moduleId: "./src/packages/portfolio-3/portfolio/src/app-simple-plans/view/main/tabs/teams/list/team-dialog/create-twp-team-form/twp-create-content.tsx"
        });
        const { data: { user: user } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        initiateRequest();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "create-twp-team-dialog",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("0Wtmq")).PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, (0, parcelRequire("euiLX")).default)(locale)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncAkTeamCreateContent, {
            cloudId: cloudId,
            orgId: orgId || undefined,
            currentUser: {
                id: user.accountId || '',
                fullName: user.userFullname,
                avatarUrl: (0, (0, parcelRequire("5SXBk")).isDataExtra)(user) ? user.avatarUrls['48x48'] : undefined
            },
            principalId: user.accountId || '',
            product: "jira",
            onClose: ()=>{
                if (!isProcessingRequest) onClose();
            },
            onCreateTeamSuccess: (team, members)=>{
                const teamMembers = (members || []).map((member)=>member.id);
                addAtlassianTeam({
                    id: team.id,
                    title: team.displayName,
                    members: teamMembers
                });
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ATLAS_TEAM_CREATED.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                }));
            },
            customMessages: {
                modalTitle: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dfQWF.default).title),
                submitButtonLabel: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dfQWF.default).createTeam),
                descriptionContent: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9Y9FP["description-paragraphs"]
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "p"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dfQWF.default).descriptionParagraph1)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "p"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dfQWF.default).descriptionParagraph2), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cwkM.default), {
                    href: (0, $4cwkM.default).URLs.manageTeamInJira
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dfQWF.default).docLink)))))
            }
        })));
    }
});
parcelRegister("5SXBk", function(module, exports) {
    $parcel$export(module.exports, "isDataExtra", ()=>$eb54de1036bc7a2d$export$ba78a24d4b61cf6b);
    function $eb54de1036bc7a2d$export$ba78a24d4b61cf6b(data) {
        return data ? 'avatarUrls' in data : false;
    }
});
parcelRegister("4cwkM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$249975ba47f7a3c9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhmo0;
    var $8beDH = parcelRequire("8beDH");
    function $249975ba47f7a3c9$var$DocLink({ href: href, ariaLabel: ariaLabel, children: children, tagRef: tagRef }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            href: href,
            ref: tagRef,
            target: "_blank",
            "aria-label": ariaLabel
        }, children);
    }
    $249975ba47f7a3c9$var$DocLink.URLs = (0, $8beDH.default);
    var $249975ba47f7a3c9$export$2e2bcd8739ae039 = $249975ba47f7a3c9$var$DocLink;
});
parcelRegister("dfQWF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7cf277e3a303ae1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c7cf277e3a303ae1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.create-twp-team-form.title",
            "defaultMessage": "Create a new team"
        },
        descriptionParagraph1: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.create-twp-team-form.description-paragraph-1",
            "defaultMessage": "Stay connected with @mentions, collaborate on work, and efficiently manage everything in one place."
        },
        descriptionParagraph2: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.create-twp-team-form.description-paragraph-2",
            "defaultMessage": "Once created, you can manage this team from the Teams homepage."
        },
        docLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.create-twp-team-form.doc-link",
            "defaultMessage": "What can Teams do?"
        },
        createTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.create-twp-team-form.create-team",
            "defaultMessage": "Create team"
        }
    });
});
parcelRegister("9Y9FP", function(module, exports) {
    $parcel$export(module.exports, "description-paragraphs", ()=>$742138a7ad75fbc4$export$e0fc2b88c3977416, (v)=>$742138a7ad75fbc4$export$e0fc2b88c3977416 = v);
    var $742138a7ad75fbc4$export$e0fc2b88c3977416;
    var $742138a7ad75fbc4$export$e6de95c3f9060252;
    $742138a7ad75fbc4$export$e0fc2b88c3977416 = `_5PsE7a_description-paragraphs`;
    $742138a7ad75fbc4$export$e6de95c3f9060252 = `_5PsE7a_spinner-container`;
});
parcelRegister("gg5KR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5J6ZH")
    ]).then(()=>parcelRequire('euoeq'));
});
parcelRegister("hwi8c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83fce1c5e23e91a7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $83fce1c5e23e91a7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addTeamButton: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.add-team-button",
            "defaultMessage": "Add team"
        },
        addTeamToPlanHeading: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.add-team-to-plan-heading",
            "defaultMessage": "Add a team to your plan"
        },
        addTeamToPlanDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.add-team-to-plan-description",
            "defaultMessage": "Teams in your plan help you balance and distribute work evenly and efficiently."
        },
        addExistingTeamRadioLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.add-existing-team-radio-label",
            "defaultMessage": "Add existing team"
        },
        createANewTeamRadioLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.create-a-new-team-radio-label",
            "defaultMessage": "Create a new team"
        },
        selectAnExistingTeamLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.select-an-existing-team-label",
            "defaultMessage": "Select an existing team"
        },
        selectOrEnterTeamNamePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.select-or-enter-team-name-placeholder",
            "defaultMessage": "Select or enter team name"
        },
        selectNewTeamType: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.select-new-team-type",
            "defaultMessage": "Select new team type"
        },
        availableAcrossOrgTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.available-across-org-team",
            "defaultMessage": "Available across organization"
        },
        availableAcrossOrgTeamHelpText: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.available-across-org-team-help-text",
            "defaultMessage": "View and reference this team in other linked Atlassian products."
        },
        planOnlyTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.plan-only-team",
            "defaultMessage": "Plan-only"
        },
        planOnlyLimitedTeamHelpText: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.plan-only-limited-team-help-text",
            "defaultMessage": "This team only lives within your plan."
        },
        createPlanOnlyTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.create-plan-only-team",
            "defaultMessage": "Create a plan-only team"
        },
        labelForViewPlanBtn: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.label-for-view-plan-btn",
            "defaultMessage": "View your plan"
        },
        labelForConfigTeamBtn: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.label-for-config-team-btn",
            "defaultMessage": "Configure team"
        }
    });
});
parcelRegister("O7quA", function(module, exports) {
    $parcel$export(module.exports, "addTeamDialogBody", ()=>$096a6e5577123d46$export$80cba1fffa9c34bb, (v)=>$096a6e5577123d46$export$80cba1fffa9c34bb = v);
    $parcel$export(module.exports, "imageIllustrationPanel", ()=>$096a6e5577123d46$export$b3299b5cacc6bee0, (v)=>$096a6e5577123d46$export$b3299b5cacc6bee0 = v);
    $parcel$export(module.exports, "radioSelect", ()=>$096a6e5577123d46$export$1f16869ebf33fdbf, (v)=>$096a6e5577123d46$export$1f16869ebf33fdbf = v);
    $parcel$export(module.exports, "teamField", ()=>$096a6e5577123d46$export$40cf12116a545391, (v)=>$096a6e5577123d46$export$40cf12116a545391 = v);
    $parcel$export(module.exports, "teamSelectionPanel", ()=>$096a6e5577123d46$export$cc17166ae48dbdeb, (v)=>$096a6e5577123d46$export$cc17166ae48dbdeb = v);
    $parcel$export(module.exports, "teamTypeOption", ()=>$096a6e5577123d46$export$de8e9215edab2de4, (v)=>$096a6e5577123d46$export$de8e9215edab2de4 = v);
    $parcel$export(module.exports, "teamTypeOptionDescription", ()=>$096a6e5577123d46$export$e7c5a0f773cfee9d, (v)=>$096a6e5577123d46$export$e7c5a0f773cfee9d = v);
    $parcel$export(module.exports, "teamTypeOptionIcon", ()=>$096a6e5577123d46$export$4598acfe49fdecb2, (v)=>$096a6e5577123d46$export$4598acfe49fdecb2 = v);
    $parcel$export(module.exports, "teamTypeOptionTitle", ()=>$096a6e5577123d46$export$b2ad52b5e02f795, (v)=>$096a6e5577123d46$export$b2ad52b5e02f795 = v);
    var $096a6e5577123d46$export$80cba1fffa9c34bb;
    var $096a6e5577123d46$export$b3299b5cacc6bee0;
    var $096a6e5577123d46$export$1f16869ebf33fdbf;
    var $096a6e5577123d46$export$40cf12116a545391;
    var $096a6e5577123d46$export$cc17166ae48dbdeb;
    var $096a6e5577123d46$export$de8e9215edab2de4;
    var $096a6e5577123d46$export$e7c5a0f773cfee9d;
    var $096a6e5577123d46$export$4598acfe49fdecb2;
    var $096a6e5577123d46$export$b2ad52b5e02f795;
    $096a6e5577123d46$export$80cba1fffa9c34bb = `G8DJra_addTeamDialogBody`;
    $096a6e5577123d46$export$b3299b5cacc6bee0 = `G8DJra_imageIllustrationPanel`;
    $096a6e5577123d46$export$1f16869ebf33fdbf = `G8DJra_radioSelect`;
    $096a6e5577123d46$export$40cf12116a545391 = `G8DJra_teamField`;
    $096a6e5577123d46$export$cc17166ae48dbdeb = `G8DJra_teamSelectionPanel`;
    $096a6e5577123d46$export$de8e9215edab2de4 = `G8DJra_teamTypeOption`;
    $096a6e5577123d46$export$e7c5a0f773cfee9d = `G8DJra_teamTypeOptionDescription`;
    $096a6e5577123d46$export$4598acfe49fdecb2 = `G8DJra_teamTypeOptionIcon`;
    $096a6e5577123d46$export$b2ad52b5e02f795 = `G8DJra_teamTypeOptionTitle`;
});
parcelRegister("itNBH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1073dcf658f843d0$export$2e2bcd8739ae039);
    var $bC2fB;
    var $iomAc = parcelRequire("iomAc");
    var $eDXop = parcelRequire("eDXop");
    var $1073dcf658f843d0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $iomAc.default), {})((0, $eDXop.default));
});
parcelRegister("iomAc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a4237942e2e1fc7$export$2e2bcd8739ae039);
    var $ageG6 = parcelRequire("ageG6");
    var $iGHBn = parcelRequire("iGHBn");
    var $bHTqr = parcelRequire("bHTqr");
    var $dRVQG = parcelRequire("dRVQG");
    var $TRSc6 = parcelRequire("TRSc6");
    const $8a4237942e2e1fc7$var$mapStateToProps = (state)=>({
            isProcessingRequest: (0, $TRSc6.getRequestStatus)(state),
            issueSources: (0, $bHTqr.getIssueSources)(state),
            persons: (0, $ageG6.getPersons)(state),
            planDefaults: (0, $iGHBn.getPlanDefaults)(state),
            planningUnit: (0, $bHTqr.getPlanningUnit)(state),
            editedTeam: (0, $dRVQG.getEditedTeam)(state)
        });
    var $8a4237942e2e1fc7$export$2e2bcd8739ae039 = $8a4237942e2e1fc7$var$mapStateToProps;
});
parcelRegister("eDXop", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9d9f9b67f88827c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $1AkQu = parcelRequire("1AkQu");
    var $3JOCw = parcelRequire("3JOCw");
    var $3nPAF;
    var $d8iBX;
    var $ldJSL;
    var $efXp3;
    var $qfj8c;
    var $7O4UO;
    var $kxqHl;
    var $1dJ6S;
    var $6tRzQ;
    var $lj8SI;
    var $dC5iT;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $kY99m;
    var $3bDjY;
    var $4R6GH;
    var $8RXs9;
    var $aCpcO;
    var $gJZ5D;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $1FeOe;
    var $6Qf3i = parcelRequire("6Qf3i");
    var $ljqzs = parcelRequire("ljqzs");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $juPoF = parcelRequire("juPoF");
    var $2vyxt = parcelRequire("2vyxt");
    var $ieSqZ = parcelRequire("ieSqZ");
    class $e9d9f9b67f88827c$var$TeamForm extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                dialogMode: (0, $6Qf3i.CREATE_MODE),
                TeamProfileComponent: (0, $ieSqZ.default)
            };
        }
        constructor(props){
            super(props);
            this.buttonRef = (0, $5uXOq.createRef)();
            this.setTeamNameFieldValidity = (isValid)=>{
                this.setState({
                    isTeamNameFieldValid: isValid
                });
            };
            this.setEstimateFieldValidity = (isValid)=>{
                this.setState({
                    isEstimateFieldValid: isValid
                });
            };
            this.setIterationLengthFieldValidity = (isValid)=>{
                this.setState({
                    isIterationLengthFieldValid: isValid
                });
            };
            this.isCreateMode = ()=>this.props.dialogMode === (0, $6Qf3i.CREATE_MODE);
            this.mapTeamMembers = (resources)=>{
                const { persons: persons } = this.props;
                return resources.filter((res)=>res.scenarioType !== (0, $TTKUQ.SCENARIO_TYPE).DELETED).map((el)=>{
                    const person = persons.find((person)=>person.itemKey === el.personItemKey);
                    return person ? {
                        value: person.itemKey,
                        label: person.values.title,
                        icon: person.values.avatarUrl,
                        accountId: person.jiraUser?.accountId
                    } : undefined;
                }).filter((el)=>el);
            };
            this.getEnhancedTeamData = ()=>{
                const { team: team } = this.props;
                if (!this.isCreateMode() && team) {
                    const members = this.mapTeamMembers(team.resources);
                    return {
                        ...team,
                        members: members
                    };
                }
                return null;
            };
            this.isTWPTeam = ()=>{
                const teamFields = this.getEnhancedTeamData();
                return (0, $4nDwW.isDefined)(teamFields) && !!teamFields.externalId;
            };
            this.submitForm = (fieldValues)=>{
                const { onSubmitForm: onSubmitForm } = this.props;
                const enhancedTeam = this.getEnhancedTeamData();
                const payload = {
                    ...fieldValues,
                    issueSource: fieldValues.issueSource && fieldValues.issueSource.value,
                    schedulingMode: fieldValues.schedulingMode && fieldValues.schedulingMode.value,
                    ...this.isTWPTeam() ? {
                        title: (0, $4nDwW.isDefined)(enhancedTeam) ? enhancedTeam.title : '',
                        members: (0, $4nDwW.isDefined)(enhancedTeam) ? enhancedTeam.members : []
                    } : {
                        title: fieldValues.title.trim()
                    }
                };
                if (!this.isCreateMode() && enhancedTeam) onSubmitForm(payload, enhancedTeam);
                else onSubmitForm(payload);
            };
            this.getIssueSourceHelperMessage = (formValues)=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                if ((0, $4nDwW.isDefined)(formValues) && !(0, parcelRequire("3nPAF")).default(formValues) && (!(0, $4nDwW.isDefined)(formValues.issueSource) || (0, $4nDwW.isDefined)(formValues.issueSource) && formValues.issueSource.value !== null) && (0, $4nDwW.isDefined)(formValues.schedulingMode) && !(0, parcelRequire("3nPAF")).default(formValues.schedulingMode) && formValues.schedulingMode.value === (0, $TTKUQ.SCHEDULE_MODE).scrum) return formatMessage((0, $juPoF.default).issueSourceTooltipScrumNew);
                if ((0, $4nDwW.isDefined)(formValues) && !(0, parcelRequire("3nPAF")).default(formValues) && (0, $4nDwW.isDefined)(formValues.issueSource) && formValues.issueSource.value === null) return null;
                return formatMessage((0, $juPoF.default).issueSourceTooltipNotScrum);
            };
            this.validateTeamNameLength = (teamName)=>teamName.length <= 80;
            this.validateTeamName = (teamName)=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                if (!(0, $4nDwW.isDefined)(teamName)) return;
                if (teamName.trim() === '') {
                    this.setTeamNameFieldValidity(false);
                    return formatMessage((0, $juPoF.default).teamNameEmpty);
                }
                const isTeamNameLengthValid = this.validateTeamNameLength(teamName);
                this.setTeamNameFieldValidity(isTeamNameLengthValid);
                if (!isTeamNameLengthValid) return formatMessage((0, $juPoF.default).teamNameMaxLength);
            };
            this.validateEstimate = (estimate)=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                if (!(0, $4nDwW.isDefined)(estimate) || estimate === '') {
                    this.setEstimateFieldValidity(false);
                    return formatMessage((0, $juPoF.default).capacityEmptyValidation);
                }
                if (!estimate.toString().match(/^$|^\d+(\.\d+)?$/)) {
                    this.setEstimateFieldValidity(false);
                    return formatMessage((0, $juPoF.default).capacityValidation);
                }
                if (estimate < 0 || estimate > 9999) {
                    this.setEstimateFieldValidity(false);
                    return formatMessage((0, $juPoF.default).capacityValueValidation);
                }
                this.setEstimateFieldValidity(true);
            };
            this.validateIterationLength = (iterationLength)=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                if (!(0, $4nDwW.isDefined)(iterationLength) || iterationLength === '') {
                    this.setIterationLengthFieldValidity(false);
                    return formatMessage((0, $juPoF.default).iterationEmptyValidation);
                }
                if (!iterationLength.toString().match('^([\\d]*)$')) {
                    this.setIterationLengthFieldValidity(false);
                    return formatMessage((0, $juPoF.default).iterationLengthValidation);
                }
                if (iterationLength < 1 || iterationLength > 99) {
                    this.setIterationLengthFieldValidity(false);
                    return formatMessage((0, $juPoF.default).iterationLengthValueValidation);
                }
                this.setIterationLengthFieldValidity(true);
            };
            this.getIssueSourceOptions = ()=>{
                const { intl: { formatMessage: formatMessage }, issueSources: issueSources = [] } = this.props;
                return [
                    {
                        label: formatMessage((0, $ihPUd.default).none),
                        value: null
                    },
                    ...(0, parcelRequire("d8iBX")).default(issueSources.map(({ title: title, id: id })=>({
                            label: (0, $4nDwW.isDefined)(title) ? title : formatMessage((0, $juPoF.default).noAccess),
                            value: id
                        }))).sort((a, b)=>a.label.localeCompare(b.label))
                ];
            };
            this.getIssueSourceOptionsGrouped = ()=>{
                const { intl: { formatMessage: formatMessage }, issueSources: issueSources } = this.props;
                const customSortOrder = [
                    'Board',
                    'Project',
                    'Filter'
                ];
                const getTypeLabel = (type)=>{
                    switch(type){
                        case 'Board':
                            return formatMessage((0, $juPoF.default).issueSourceTypeBoards);
                        case 'Project':
                            return formatMessage((0, $juPoF.default).issueSourceTypeProjects);
                        case 'Filter':
                            return formatMessage((0, $juPoF.default).issueSourceTypeFilters);
                        default:
                            return '';
                    }
                };
                const issueSourcesTypes = (0, ($parcel$interopDefault($1AkQu)))(Array.from(new Set(issueSources.map(({ type: type })=>type))), (type)=>customSortOrder.indexOf(type));
                const groupedOptions = issueSourcesTypes.map((type)=>({
                        label: getTypeLabel(type),
                        options: (0, ($parcel$interopDefault($3JOCw)))(issueSources.filter(({ type: issueType })=>issueType === type).map(({ title: title, id: id })=>({
                                label: title || formatMessage((0, $juPoF.default).noAccess),
                                value: id
                            })), 'value')
                    }));
                return [
                    {
                        label: formatMessage((0, $ihPUd.default).none),
                        value: null
                    },
                    ...groupedOptions
                ];
            };
            this.getIssueSourceDefaultValue = (teamFields)=>{
                if (!(0, $4nDwW.isDefined)(teamFields)) return undefined;
                return this.getIssueSourceOptions().find((issueSource)=>issueSource.value === teamFields.issueSource);
            };
            this.getPlanningStyleOptions = ()=>{
                const { planningUnit: planningUnit } = this.props;
                return [
                    {
                        isDisabled: false,
                        label: (0, $TTKUQ.SCHEDULE_MODE).scrum,
                        value: (0, $TTKUQ.SCHEDULE_MODE).scrum
                    },
                    {
                        isDisabled: planningUnit === (0, $TTKUQ.PLANNING_UNITS).STORY_POINTS,
                        label: (0, $TTKUQ.SCHEDULE_MODE).kanban,
                        value: (0, $TTKUQ.SCHEDULE_MODE).kanban
                    }
                ];
            };
            this.getSchedulingModeDefaultValue = (teamFields)=>{
                if ((0, $4nDwW.isDefined)(teamFields) && (0, $4nDwW.isDefined)(teamFields.schedulingMode)) return {
                    label: teamFields.schedulingMode,
                    value: teamFields.schedulingMode
                };
                return {
                    label: (0, $TTKUQ.SCHEDULE_MODE).scrum,
                    value: (0, $TTKUQ.SCHEDULE_MODE).scrum
                };
            };
            this.isFormInvalid = ()=>{
                const { isTeamNameFieldValid: isTeamNameFieldValid, isEstimateFieldValid: isEstimateFieldValid, isIterationLengthFieldValid: isIterationLengthFieldValid } = this.state;
                return this.isTWPTeam() ? !(isEstimateFieldValid && isIterationLengthFieldValid) : !(isTeamNameFieldValid && isEstimateFieldValid && isIterationLengthFieldValid);
            };
            this.formatPlanningStyleOptionLabel = (option, { context: context })=>{
                if (context === 'menu') {
                    const { intl: { formatMessage: formatMessage }, planningUnit: planningUnit } = this.props;
                    if (option.value === (0, $TTKUQ.SCHEDULE_MODE).kanban && planningUnit === (0, $TTKUQ.PLANNING_UNITS).STORY_POINTS) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $2vyxt.planningStyleOption
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, option.label), (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                        content: formatMessage((0, $juPoF.default).planningStyleDisabledOptionTooltip),
                        position: "top"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6tRzQ"))))), {
                        label: formatMessage((0, $juPoF.default).planningStyleDisabledOptionTooltip),
                        LEGACY_primaryColor: `var(--ds-blanket, ${(0, (0, parcelRequire("gJZ5D")).default).N500})`,
                        color: "var(--ds-icon-subtlest, undefined)"
                    })))));
                    return option.label;
                }
                return option.label;
            };
            this.getTeamFormContent = ()=>{
                const { intl: { formatMessage: formatMessage }, isProcessingRequest: isProcessingRequest, planDefaults: planDefaults, issueSources: issueSources, planningUnit: planningUnit, team: team, modalFooterDivElement: modalFooterDivElement, onCloseForm: onCloseForm, TeamProfileComponent: TeamProfileComponent, formHeading: formHeading, formBody: formBody } = this.props;
                const teamFields = this.getEnhancedTeamData();
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("efXp3")).default), {
                    onSubmit: this.submitForm
                }, ({ formProps: formProps, getState: getState, setFieldValue: setFieldValue })=>(0, ($parcel$interopDefault($5uXOq))).createElement("form", formProps, this.isTWPTeam() && TeamProfileComponent ? (0, ($parcel$interopDefault($5uXOq))).createElement(TeamProfileComponent, {
                        teamId: (0, $4nDwW.isDefined)(teamFields) ? teamFields.externalId : undefined,
                        members: (0, $4nDwW.isDefined)(teamFields) ? teamFields.members : []
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
                        className: $2vyxt.explainRequiredFields
                    }, formatMessage((0, $juPoF.default).requiredFields), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kxqHl")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $2vyxt.teamInfoHeadingCont
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                        size: "xsmall",
                        as: "h2"
                    }, formatMessage((0, $juPoF.default).teamInfoHeading)), (this.isCreateMode() || (0, $4nDwW.isDefined)(team) && !team.shareable) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.plan-only-lozenge"
                    }, formatMessage((0, (0, parcelRequire("1FeOe")).default).planOnlyLozenge))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                        "aria-required": true,
                        defaultValue: (0, $4nDwW.isDefined)(teamFields) ? teamFields.title : undefined,
                        isDisabled: isProcessingRequest,
                        isRequired: true,
                        label: formatMessage((0, $juPoF.default).teamNameLabel),
                        name: "title",
                        validate: this.validateTeamName
                    }, ({ fieldProps: fieldProps, meta: meta })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                            ...fieldProps,
                            autoFocus: true,
                            onBlur: fieldProps.onChange,
                            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.team-title"
                        }), (0, $4nDwW.isDefined)(meta.error) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, meta.error))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                        defaultValue: (0, $4nDwW.isDefined)(teamFields) ? teamFields.members : undefined,
                        isDisabled: isProcessingRequest,
                        label: formatMessage((0, $juPoF.default).teamMembersLabel),
                        name: "members"
                    }, ({ fieldProps: fieldProps, meta: meta })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ljqzs.default), {
                            id: fieldProps.id,
                            menuPortalTarget: document.body,
                            onChange: fieldProps.onChange,
                            onFocus: fieldProps.onFocus,
                            placeholder: formatMessage((0, $juPoF.default).startTyping),
                            styles: {
                                menuPortal: (base)=>({
                                        ...base,
                                        zIndex: 9999
                                    })
                            },
                            value: fieldProps.value,
                            validationState: (0, $4nDwW.isDefined)(meta.error) ? 'error' : 'default'
                        }), (0, $4nDwW.isDefined)(meta.error) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, meta.error)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                        xcss: $e9d9f9b67f88827c$var$planningHeadingStyles
                    }, (0, (0, parcelRequire("4R6GH")).fg)('eou_open_team_dialog_in_timeline') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                        space: "space.050"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                        size: "xsmall",
                        as: "h2"
                    }, formatMessage(formHeading || (0, $juPoF.default).planningHeading)), formBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage(formBody))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                        size: "xsmall",
                        as: "h2"
                    }, formatMessage((0, $juPoF.default).planningHeading))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                        defaultValue: this.getIssueSourceDefaultValue(teamFields),
                        isDisabled: isProcessingRequest,
                        label: formatMessage((0, $ihPUd.default).issueSource),
                        name: "issueSource"
                    }, ({ fieldProps: fieldProps })=>{
                        const value = fieldProps?.value?.value;
                        (0, $5uXOq.useEffect)(()=>{
                            if (!(0, $4nDwW.isDefined)(value)) return;
                            const issueSource = issueSources.find((issue)=>issue.id === value);
                            const schedulingModes = {
                                Project: {
                                    label: (0, $TTKUQ.SCHEDULE_MODE).kanban,
                                    value: (0, $TTKUQ.SCHEDULE_MODE).kanban
                                },
                                Board: {
                                    label: (0, $TTKUQ.SCHEDULE_MODE).scrum,
                                    value: (0, $TTKUQ.SCHEDULE_MODE).scrum
                                },
                                Filter: false
                            };
                            const schedulingMode = issueSource?.type && schedulingModes[issueSource?.type];
                            if (schedulingMode) setFieldValue('schedulingMode', schedulingMode);
                        }, [
                            value
                        ]);
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                            ...fieldProps,
                            classNamePrefix: "portfolio-3-portfolio_app-simple-plans_main_tabs_teams_list_team-dialog_team-form_issue-source",
                            options: this.getIssueSourceOptionsGrouped(),
                            placeholder: formatMessage((0, $juPoF.default).issueSourceFieldPlaceholderNew),
                            menuPortalTarget: document.body,
                            styles: {
                                menuPortal: (base)=>({
                                        ...base,
                                        zIndex: 9999
                                    })
                            }
                        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, this.getIssueSourceHelperMessage(getState().values)));
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                        defaultValue: this.getSchedulingModeDefaultValue(teamFields),
                        isDisabled: isProcessingRequest,
                        label: formatMessage((0, $juPoF.default).planningStyleLabel),
                        name: "schedulingMode"
                    }, ({ fieldProps: fieldProps, meta: meta })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                            ...fieldProps,
                            classNamePrefix: "portfolio-3-portfolio_app-simple-plans_main_tabs_teams_list_team-dialog_team-form_scheduling-mode",
                            formatOptionLabel: this.formatPlanningStyleOptionLabel,
                            isOptionDisabled: (option)=>option.isDisabled,
                            menuPortalTarget: document.body,
                            options: this.getPlanningStyleOptions(),
                            styles: {
                                menuPortal: (base)=>({
                                        ...base,
                                        zIndex: 510
                                    })
                            },
                            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.scheduling-mode"
                        }), (0, $4nDwW.isDefined)(meta.error) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, meta.error))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $2vyxt.planningFields
                    }, !(0, parcelRequire("3nPAF")).default(getState().values) && getState().values.schedulingMode.value === (0, $TTKUQ.SCHEDULE_MODE).scrum && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                        defaultValue: (0, $4nDwW.isDefined)(teamFields) && (0, $4nDwW.isDefined)(teamFields.iterationLength) ? teamFields.iterationLength : planDefaults?.defaultIterationLength,
                        isDisabled: isProcessingRequest,
                        label: formatMessage((0, $juPoF.default).sprintLengthLabel),
                        name: "iterationLength",
                        validate: this.validateIterationLength
                    }, ({ fieldProps: fieldProps, meta: meta })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                            ...fieldProps,
                            placeholder: formatMessage((0, $juPoF.default).teamFormPlaceholder, {
                                default: planDefaults?.defaultIterationLength
                            }),
                            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.iteration-length"
                        }), (0, $4nDwW.isDefined)(meta.error) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, meta.error))), planningUnit !== (0, $TTKUQ.PLANNING_UNITS).STORY_POINTS ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                        defaultValue: (0, $4nDwW.isDefined)(teamFields) && (0, $4nDwW.isDefined)(teamFields.weeklyHours) ? teamFields.weeklyHours : planDefaults?.defaultTeamWeeklyHours,
                        isDisabled: isProcessingRequest,
                        label: formatMessage((0, $juPoF.default).weeklyHoursLabel),
                        name: "weeklyHours",
                        validate: this.validateEstimate
                    }, ({ fieldProps: fieldProps, meta: meta })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                            ...fieldProps,
                            placeholder: formatMessage((0, $juPoF.default).teamFormPlaceholder, {
                                default: planDefaults?.defaultTeamWeeklyHours
                            }),
                            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.weekly-hours"
                        }), (0, $4nDwW.isDefined)(meta.error) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, meta.error))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                        defaultValue: (0, $4nDwW.isDefined)(teamFields) && (0, $4nDwW.isDefined)(teamFields.velocity) ? teamFields.velocity : planDefaults?.defaultTeamVelocity,
                        isDisabled: isProcessingRequest,
                        label: formatMessage((0, $juPoF.default).capacityPointsLabel),
                        name: "velocity",
                        validate: this.validateEstimate
                    }, ({ fieldProps: fieldProps, meta: meta })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                            ...fieldProps,
                            placeholder: formatMessage((0, $juPoF.default).teamFormPlaceholder, {
                                default: planDefaults?.defaultTeamVelocity
                            }),
                            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.velocity"
                        }), (0, $4nDwW.isDefined)(meta.error) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, meta.error)))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $2vyxt.hiddenSubmitButton
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                        type: "submit",
                        ref: this.buttonRef,
                        "aria-hidden": true
                    })))), modalFooterDivElement && (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "subtle",
                    isDisabled: isProcessingRequest,
                    onClick: onCloseForm
                }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "primary",
                    isDisabled: this.isFormInvalid(),
                    isLoading: isProcessingRequest,
                    onClick: ()=>{
                        if (this.buttonRef.current) this.buttonRef.current.click();
                    },
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.save"
                }, formatMessage(this.isCreateMode() ? (0, $ihPUd.default).create : (0, $ihPUd.default).done))), modalFooterDivElement));
            };
            this.state = {
                isEstimateFieldValid: true,
                isIterationLengthFieldValid: true,
                isTeamNameFieldValid: false
            };
        }
        render() {
            return this.getTeamFormContent();
        }
    }
    var $e9d9f9b67f88827c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($e9d9f9b67f88827c$var$TeamForm);
    const $e9d9f9b67f88827c$var$planningHeadingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.300',
        marginBottom: 'space.100'
    });
});
parcelRegister("1AkQu", function(module, exports) {
    var $kE90z = parcelRequire("kE90z");
    var $8LQ84 = parcelRequire("8LQ84");
    function $127952ba7d4c15a6$var$orderBy(collection, iteratees, orders, guard) {
        if (collection == null) return [];
        if (!$8LQ84(iteratees)) iteratees = iteratees == null ? [] : [
            iteratees
        ];
        orders = guard ? undefined : orders;
        if (!$8LQ84(orders)) orders = orders == null ? [] : [
            orders
        ];
        return $kE90z(collection, iteratees, orders);
    }
    module.exports = $127952ba7d4c15a6$var$orderBy;
});
parcelRegister("qfj8c", function(module, exports) {
    $parcel$export(module.exports, "HelperMessage", ()=>$b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
    $parcel$export(module.exports, "ErrorMessage", ()=>$b2d5b368fed948c9$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "ValidMessage", ()=>$b2d5b368fed948c9$export$5505afb209a532c8);
    $parcel$export(module.exports, "MessageWrapper", ()=>$b2d5b368fed948c9$export$ec445f12f63100a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $059q9;
    var $g4M8x;
    var $dRN65;
    function $b2d5b368fed948c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b2d5b368fed948c9$var$messageStyles = {
        name: "drnq1s",
        styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
    };
    const $b2d5b368fed948c9$var$messageAppearanceStyles = {
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
        }),
        error: {
            name: "g75jq6",
            styles: "color:var(--ds-text-danger, #AE2A19)"
        },
        valid: {
            name: "118r6eb",
            styles: "color:var(--ds-text-success, #216E4E)"
        }
    };
    const $b2d5b368fed948c9$var$iconWrapperStyles = {
        name: "x5c876",
        styles: "display:flex;height:16px;align-items:center"
    };
    const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $b2d5b368fed948c9$var$iconWrapperStyles
        }, children);
    };
    const $b2d5b368fed948c9$var$messageIcons = {
        error: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }),
        valid: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("g4M8x"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        })
    };
    const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
        const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
        const messageRef = (0, $5uXOq.useRef)(null);
        const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
        const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$export$579aef2c392a54d4);
        (0, $5uXOq.useEffect)(()=>{
            if (messageRef.current) setHasMessageWrapper(isWrapper);
        }, [
            isWrapper
        ]);
        const content = typeof children === 'string' ? children : (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b2d5b368fed948c9$var$messageStyles,
                $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
            ],
            "data-testid": testId,
            id: fieldId,
            ref: messageRef,
            "aria-live": !hasMessageWrapper ? 'polite' : undefined
        }, icon && (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$IconWrapper, null, icon), content);
    };
    const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$579aef2c392a54d4 = (0, $5uXOq.createContext)({
        isWrapper: false
    });
    const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
        const contextValue = {
            isWrapper: true
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$export$579aef2c392a54d4.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper"
        }, children));
    };
});
parcelRegister("g4M8x", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));
    var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
    function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bb425bfe72dc5677$var$SuccessIcon = (props)=>$bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
        }, props));
    $bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;
});
parcelRegister("hs3k8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0347594f5084a834$var$_UNSAFE_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0347594f5084a834$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0347594f5084a834$var$SuccessIcon = (props)=>$0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
    var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;
});
parcelRegister("kJ541", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $f16bf031974cd311$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>$f16bf031974cd311$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
        }, props, {
            newIcon: $f16bf031974cd311$var$_success.default
        }));
    $f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
    var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;
});
parcelRegister("ljqzs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$932bd8cca1f2b11f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $cgL5K;
    var $8RXs9;
    parcelRequire("iqIcG");
    var $d7FF4;
    var $bChGW;
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $8QHq4 = parcelRequire("8QHq4");
    var $cNpv9 = parcelRequire("cNpv9");
    var $96Vob = parcelRequire("96Vob");
    const $932bd8cca1f2b11f$export$20682a240140e615 = ({ label: label, icon: icon })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $96Vob["members-option"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "xsmall",
            src: icon
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $96Vob.title
        }, label));
    const $932bd8cca1f2b11f$export$419cdf50db8b579 = (props)=>{
        const { data: data, components: components } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MultiValue, {
            ...props,
            styles: {
                borderRadius: '10px'
            },
            components: {
                ...components,
                Label: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($932bd8cca1f2b11f$export$20682a240140e615, data)
            }
        });
    };
    const $932bd8cca1f2b11f$export$ec98719d3db7f2e4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, "\xa0");
    const $932bd8cca1f2b11f$export$c53525738a6bfd72 = (query)=>(0, $8DSSe.default)('/rest/teams/1.0/persons/find', {
            method: 'POST',
            body: {
                query: query,
                maxResults: 50,
                excludedIds: []
            }
        }).then((response)=>response.json()).then((data)=>data.results ? (0, $4nDwW.filterMap)((result)=>(0, $4nDwW.isDefined)(result.jiraUser), (result)=>({
                    label: result.jiraUser.title,
                    value: result.personId,
                    icon: result.jiraUser.avatarUrl,
                    email: result.jiraUser.email
                }), data.results) : []);
    const $932bd8cca1f2b11f$export$322216d90ffb8d0e = (option, { context: context })=>{
        if (context === 'menu') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8QHq4.UserSelectItem), option);
        return option.value;
    };
    class $932bd8cca1f2b11f$var$MembersSelect extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                findPersons: $932bd8cca1f2b11f$export$c53525738a6bfd72
            };
        }
        render() {
            const { intl: intl, findPersons: findPersons, onChange: onChange, onFocus: onFocus, id: id, value: value, ariaLabel: ariaLabel, ...restProps } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
                hideSelectedOptions: true,
                isMulti: true,
                isTransparentBackground: false,
                loadOptions: findPersons,
                onChange: onChange,
                onFocus: onFocus,
                inputId: id,
                value: value,
                formatOptionLabel: $932bd8cca1f2b11f$export$322216d90ffb8d0e,
                components: {
                    MultiValue: $932bd8cca1f2b11f$export$419cdf50db8b579,
                    DropdownIndicator: $932bd8cca1f2b11f$export$ec98719d3db7f2e4
                },
                cacheOptions: true,
                defaultOptions: true,
                isOptionSelected: this.isOptionSelected,
                styles: {
                    multiValue: (styles)=>({
                            ...styles,
                            borderRadius: '10px'
                        })
                },
                noOptionsMessage: ()=>intl.formatMessage((0, $cNpv9.default).noMatches),
                ...restProps,
                "aria-label": ariaLabel
            });
        }
        constructor(...args){
            super(...args);
            this.isOptionSelected = (option, values)=>values.some((val)=>val.value.toString() === option.value.toString());
        }
    }
    var $932bd8cca1f2b11f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($932bd8cca1f2b11f$var$MembersSelect);
});
parcelRegister("cNpv9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c830fe5ce1d8285b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c830fe5ce1d8285b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noMatches: {
            "id": "portfolio-3-portfolio.common.form-renderer.members-select.no-matches",
            "defaultMessage": "No matches"
        }
    });
});
parcelRegister("96Vob", function(module, exports) {
    $parcel$export(module.exports, "members-option", ()=>$6a2130dca9ed42b9$export$af3eb52ce3477eed, (v)=>$6a2130dca9ed42b9$export$af3eb52ce3477eed = v);
    $parcel$export(module.exports, "title", ()=>$6a2130dca9ed42b9$export$fb184b623420d9be, (v)=>$6a2130dca9ed42b9$export$fb184b623420d9be = v);
    var $6a2130dca9ed42b9$export$af3eb52ce3477eed;
    var $6a2130dca9ed42b9$export$fb184b623420d9be;
    $6a2130dca9ed42b9$export$af3eb52ce3477eed = `kVkJFG_members-option`;
    $6a2130dca9ed42b9$export$fb184b623420d9be = `kVkJFG_title`;
});
parcelRegister("juPoF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$593910174677df45$export$2e2bcd8739ae039);
    var $7VHMR;
    var $593910174677df45$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        teamNameLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.team-name-label",
            "defaultMessage": "Team name"
        },
        teamNameMaxLength: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.team-name-max-length",
            "defaultMessage": "Team names can be a maximum of 80 characters in length"
        },
        teamNameEmpty: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.team-name-empty",
            "defaultMessage": "Please enter a team name"
        },
        issueSourceFieldPlaceholderNew: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.issue-source-field-placeholder-new",
            "defaultMessage": "Link the team to an issue source"
        },
        noAccess: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.no-access",
            "defaultMessage": "No permission to view issue source"
        },
        issueSourceTooltipNotScrum: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.issue-source-tooltip-not-scrum",
            "defaultMessage": "When auto-scheduling a plan, the issues of the selected source will be prioritized for this team."
        },
        issueSourceTooltipScrumNew: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.issue-source-tooltip-scrum-new",
            "defaultMessage": "The sprints of the board will be associated with this team"
        },
        teamMembersLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.team-members-label",
            "defaultMessage": "Team members"
        },
        planningStyleLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.planning-style-label",
            "defaultMessage": "Planning style"
        },
        planningStyleDisabledOptionTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.planning-style-disabled-option-tooltip",
            "defaultMessage": "Your plan uses story points, which can only be used with Scrum teams."
        },
        velocityValueValidation: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.velocity-value-validation",
            "defaultMessage": "Velocity cannot be less than 0 or greater than 9999"
        },
        capacityPointsLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.capacity-points-label",
            "defaultMessage": "Capacity (points)"
        },
        capacityValidation: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.capacity-validation",
            "defaultMessage": "Capacity can only be numbers"
        },
        capacityValueValidation: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.capacity-value-validation",
            "defaultMessage": "Capacity cannot be less than 0 or greater than 9999"
        },
        capacityEmptyValidation: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.capacity-empty-validation",
            "defaultMessage": "Please enter a capacity value"
        },
        weeklyHoursLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.weekly-hours-label",
            "defaultMessage": "Capacity (weekly hours)"
        },
        sprintLengthLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.sprint-length-label",
            "defaultMessage": "Sprint length (weeks)"
        },
        iterationLengthValidation: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.iteration-length-validation",
            "defaultMessage": "Iteration length can only be in whole numbers"
        },
        iterationLengthValueValidation: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.iteration-length-value-validation",
            "defaultMessage": "Iteration length cannot be less than 1 or greater than 99"
        },
        iterationEmptyValidation: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.iteration-empty-validation",
            "defaultMessage": "Please enter a sprint length value"
        },
        startTyping: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.start-typing",
            "defaultMessage": "Start typing for users"
        },
        teamInfoHeading: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.team-info-heading",
            "defaultMessage": "Team info"
        },
        planningHeading: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.planning-heading",
            "defaultMessage": "Planning"
        },
        teamFormPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.team-form-placeholder",
            "defaultMessage": "e.g. {default}"
        },
        requiredFields: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.required-fields",
            "defaultMessage": "Required fields are marked with an asterisk"
        },
        issueSourceTypeProjects: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.issue-source-type-projects",
            "defaultMessage": "Projects"
        },
        issueSourceTypeFilters: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.issue-source-type-filters",
            "defaultMessage": "Filters"
        },
        issueSourceTypeBoards: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.issue-source-type-boards",
            "defaultMessage": "Boards"
        },
        issueSourceLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.team-form.issue-source-link",
            "defaultMessage": "If you can\u2019t find the board you\u2019re looking for, you may need to link it to this plan <link>here</link>."
        }
    });
});
parcelRegister("2vyxt", function(module, exports) {
    $parcel$export(module.exports, "explainRequiredFields", ()=>$1d3944bc6edf9618$export$349f228ebfac71c8, (v)=>$1d3944bc6edf9618$export$349f228ebfac71c8 = v);
    $parcel$export(module.exports, "hiddenSubmitButton", ()=>$1d3944bc6edf9618$export$925df3919f606a09, (v)=>$1d3944bc6edf9618$export$925df3919f606a09 = v);
    $parcel$export(module.exports, "planningFields", ()=>$1d3944bc6edf9618$export$d3f346919c6a526b, (v)=>$1d3944bc6edf9618$export$d3f346919c6a526b = v);
    $parcel$export(module.exports, "planningStyleOption", ()=>$1d3944bc6edf9618$export$5872d3b68f116e07, (v)=>$1d3944bc6edf9618$export$5872d3b68f116e07 = v);
    $parcel$export(module.exports, "teamInfoHeadingCont", ()=>$1d3944bc6edf9618$export$bc41d7cc9d97e6cb, (v)=>$1d3944bc6edf9618$export$bc41d7cc9d97e6cb = v);
    var $1d3944bc6edf9618$export$349f228ebfac71c8;
    var $1d3944bc6edf9618$export$925df3919f606a09;
    var $1d3944bc6edf9618$export$d3f346919c6a526b;
    var $1d3944bc6edf9618$export$5872d3b68f116e07;
    var $1d3944bc6edf9618$export$6aca76bbada1cd55;
    var $1d3944bc6edf9618$export$bc41d7cc9d97e6cb;
    $1d3944bc6edf9618$export$349f228ebfac71c8 = `H73rza_explainRequiredFields`;
    $1d3944bc6edf9618$export$925df3919f606a09 = `H73rza_hiddenSubmitButton`;
    $1d3944bc6edf9618$export$d3f346919c6a526b = `H73rza_planningFields`;
    $1d3944bc6edf9618$export$5872d3b68f116e07 = `H73rza_planningStyleOption`;
    $1d3944bc6edf9618$export$6aca76bbada1cd55 = `H73rza_teamFormHeading`;
    $1d3944bc6edf9618$export$bc41d7cc9d97e6cb = `H73rza_teamInfoHeadingCont`;
});
parcelRegister("ieSqZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ed08f045fa49747$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $77QEM = parcelRequire("77QEM");
    var $24CMK = parcelRequire("24CMK");
    var $15VA4 = parcelRequire("15VA4");
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $flyUF = parcelRequire("flyUF");
    var $bC2fB;
    var $koeKL;
    const $3ed08f045fa49747$export$4642ea85ad979a7 = ({ teamId: teamId, members: members, genericError: genericError })=>{
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [team, setTeam] = (0, $5uXOq.useState)(null);
        const [hasError, setHasError] = (0, $5uXOq.useState)(false);
        const siteId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        (0, $5uXOq.useEffect)(()=>{
            const handleError = (error)=>{
                genericError(error);
                setHasError(true);
                setLoading(false);
            };
            if (!(0, $4nDwW.isDefined)(teamId)) return handleError({
                message: 'Team ID is undefined',
                stackTrace: new Error().stack
            });
            const loadTWPTeam = async ()=>{
                try {
                    const response = await (0, $8DSSe.default)((0, $15VA4.urls).getTWPTeamV4(teamId, siteId ?? 'None'), {
                        method: (0, $77QEM.GET)
                    });
                    if (response.ok) {
                        const team = await response.json();
                        const formattedMembers = members.map(({ label: label, icon: icon, accountId: accountId })=>({
                                fullName: label,
                                avatarUrl: icon,
                                accountId: accountId
                            }));
                        const teamAndMembers = {
                            ...team,
                            members: formattedMembers
                        };
                        setTeam(teamAndMembers);
                        setLoading(false);
                    } else throw Error('Failed to retrieve team info');
                } catch (e) {
                    handleError({
                        message: e.message,
                        stackTrace: e.stack
                    });
                }
            };
            loadTWPTeam();
        }, [
            teamId,
            siteId,
            members,
            genericError
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $flyUF.default), {
            team: team,
            isLoading: loading,
            hasError: hasError
        });
    };
    function $3ed08f045fa49747$var$areEqual(prevProps, nextProps) {
        return (0, (0, parcelRequire("4R6GH")).fg)('eou_open_team_dialog_in_timeline') ? prevProps.teamId === nextProps.teamId && prevProps?.members?.length === nextProps?.members?.length : prevProps.teamId === nextProps.teamId;
    }
    const $3ed08f045fa49747$var$memoizedLoadTeamProfileFromId = (0, $5uXOq.memo)($3ed08f045fa49747$export$4642ea85ad979a7, $3ed08f045fa49747$var$areEqual);
    var $3ed08f045fa49747$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, {
        genericError: $24CMK.genericError
    })($3ed08f045fa49747$var$memoizedLoadTeamProfileFromId);
});
parcelRegister("flyUF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7de983ae26245d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jnhNB;
    var $eZJjh;
    var $koVbs;
    var $aCpcO;
    var $90yGq;
    var $4nDwW = parcelRequire("4nDwW");
    var $idmiV = parcelRequire("idmiV");
    var $aJrie = parcelRequire("aJrie");
    var $8tgmO = parcelRequire("8tgmO");
    var $9XBY0 = parcelRequire("9XBY0");
    const $e7de983ae26245d0$var$TeamProfileContent = ({ team: team })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const atlassianAccountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const { displayName: displayName, largeHeaderImageUrl: largeHeaderImageUrl, id: id } = team;
        const avatarsData = (team.members || []).map((member)=>({
                name: member.fullName,
                src: member.avatarUrl
            }));
        const includingYou = team.members?.some((member)=>member.accountId === atlassianAccountId);
        const headerImage = (0, $4nDwW.isDefined)(largeHeaderImageUrl) ? largeHeaderImageUrl : '';
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $9XBY0.card
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $9XBY0.cardHeader,
            style: {
                backgroundImage: `url("${headerImage}")`
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $9XBY0.cardContent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $9XBY0.teamInfo
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("h4", {
            className: $9XBY0.heading
        }, displayName), (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
            className: $9XBY0.subheading
        }, formatMessage((0, $8tgmO.teamProfileMessages).members, {
            members: avatarsData.length,
            includingYou: includingYou
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            data: avatarsData
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $9XBY0.button
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            onClick: ()=>{
                (0, $idmiV.openInNewTab)(`/jira/people/team/${id}`);
            }
        }, formatMessage((0, $8tgmO.teamProfileMessages).teamProfile))))));
    };
    const $e7de983ae26245d0$var$TeamProfileLoadingState = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$9XBY0.card} ${$9XBY0.loadingOrError}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            label: formatMessage((0, $8tgmO.teamProfileMessages).loadingLabel)
        })));
    };
    const $e7de983ae26245d0$var$TeamProfileErrorState = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$9XBY0.card} ${$9XBY0.loadingOrError}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $9XBY0.errorContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aJrie.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement("h5", null, formatMessage((0, $8tgmO.teamProfileMessages).teamErrorTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $8tgmO.teamProfileMessages).teamErrorText)))));
    };
    const $e7de983ae26245d0$var$TeamProfile = ({ team: team, isLoading: isLoading, hasError: hasError })=>{
        if (isLoading === true) return (0, ($parcel$interopDefault($5uXOq))).createElement($e7de983ae26245d0$var$TeamProfileLoadingState, null);
        if ((!(0, $4nDwW.isDefined)(hasError) || hasError === false) && team) return (0, ($parcel$interopDefault($5uXOq))).createElement($e7de983ae26245d0$var$TeamProfileContent, {
            team: team
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e7de983ae26245d0$var$TeamProfileErrorState, null);
    };
    var $e7de983ae26245d0$export$2e2bcd8739ae039 = $e7de983ae26245d0$var$TeamProfile;
});
parcelRegister("aJrie", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a636a77619b2161$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $9a636a77619b2161$export$e0319f52fc2380b1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "42",
            height: "53",
            viewBox: "0 0 164 212",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "var(--ds-surface-overlay, white)",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
            fill: "url(#paint0_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
            fill: "#C1C7D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
            fill: "#C1C7D0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
            fill: "#B3BAC5"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
            fill: "#B3BAC5"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
            fill: "#B3BAC5"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "paint0_linear",
            x1: "26.1692",
            y1: "228.621",
            x2: "138.408",
            y2: "116.382",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#C1C7D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.297",
            stopColor: "#C6CBD4",
            stopOpacity: "0.8812"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.6301",
            stopColor: "#D3D7DE",
            stopOpacity: "0.748"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.9795",
            stopColor: "#E9EBEF",
            stopOpacity: "0.6082"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#EBECF0",
            stopOpacity: "0.6"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "white"
        }))));
    var $9a636a77619b2161$export$2e2bcd8739ae039 = $9a636a77619b2161$export$e0319f52fc2380b1;
});
parcelRegister("8tgmO", function(module, exports) {
    $parcel$export(module.exports, "teamProfileMessages", ()=>$afde86ed5654171a$export$b18aa215656f8557);
    var $7VHMR;
    const $afde86ed5654171a$export$b18aa215656f8557 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        members: {
            "id": "portfolio-3-portfolio.common.team-profile.members",
            "defaultMessage": "Team \u2022 {members, plural, one {{members} member} other {{members} members}}{includingYou, select, true {, including you} other {}}"
        },
        teamProfile: {
            "id": "portfolio-3-portfolio.common.team-profile.team-profile",
            "defaultMessage": "View profile"
        },
        teamErrorTitle: {
            "id": "portfolio-3-portfolio.common.team-profile.team-error-title",
            "defaultMessage": "We\u2019re having trouble retrieving this teams information"
        },
        teamErrorText: {
            "id": "portfolio-3-portfolio.common.team-profile.team-error-text",
            "defaultMessage": "Wait a few moments, then try again."
        },
        loadingLabel: {
            "id": "portfolio-3-portfolio.common.team-profile.loading-label",
            "defaultMessage": "Loading team profile"
        }
    });
});
parcelRegister("9XBY0", function(module, exports) {
    $parcel$export(module.exports, "button", ()=>$74071328817b8c68$export$2ba01fb71ed41cb6, (v)=>$74071328817b8c68$export$2ba01fb71ed41cb6 = v);
    $parcel$export(module.exports, "card", ()=>$74071328817b8c68$export$aa3e815946b80764, (v)=>$74071328817b8c68$export$aa3e815946b80764 = v);
    $parcel$export(module.exports, "cardContent", ()=>$74071328817b8c68$export$54df52f2b9f10b68, (v)=>$74071328817b8c68$export$54df52f2b9f10b68 = v);
    $parcel$export(module.exports, "cardHeader", ()=>$74071328817b8c68$export$b8bf98e4d70f4134, (v)=>$74071328817b8c68$export$b8bf98e4d70f4134 = v);
    $parcel$export(module.exports, "errorContainer", ()=>$74071328817b8c68$export$9d33ba969f9b84f1, (v)=>$74071328817b8c68$export$9d33ba969f9b84f1 = v);
    $parcel$export(module.exports, "heading", ()=>$74071328817b8c68$export$46e4a324ac90507f, (v)=>$74071328817b8c68$export$46e4a324ac90507f = v);
    $parcel$export(module.exports, "loadingOrError", ()=>$74071328817b8c68$export$f30a7571dc7c9daa, (v)=>$74071328817b8c68$export$f30a7571dc7c9daa = v);
    $parcel$export(module.exports, "subheading", ()=>$74071328817b8c68$export$eeb03afd9378c335, (v)=>$74071328817b8c68$export$eeb03afd9378c335 = v);
    $parcel$export(module.exports, "teamInfo", ()=>$74071328817b8c68$export$a5f4688122f56e0f, (v)=>$74071328817b8c68$export$a5f4688122f56e0f = v);
    var $74071328817b8c68$export$2ba01fb71ed41cb6;
    var $74071328817b8c68$export$aa3e815946b80764;
    var $74071328817b8c68$export$54df52f2b9f10b68;
    var $74071328817b8c68$export$b8bf98e4d70f4134;
    var $74071328817b8c68$export$9d33ba969f9b84f1;
    var $74071328817b8c68$export$46e4a324ac90507f;
    var $74071328817b8c68$export$f30a7571dc7c9daa;
    var $74071328817b8c68$export$eeb03afd9378c335;
    var $74071328817b8c68$export$a5f4688122f56e0f;
    $74071328817b8c68$export$2ba01fb71ed41cb6 = `weF-QW_button`;
    $74071328817b8c68$export$aa3e815946b80764 = `weF-QW_card`;
    $74071328817b8c68$export$54df52f2b9f10b68 = `weF-QW_cardContent`;
    $74071328817b8c68$export$b8bf98e4d70f4134 = `weF-QW_cardHeader`;
    $74071328817b8c68$export$9d33ba969f9b84f1 = `weF-QW_errorContainer`;
    $74071328817b8c68$export$46e4a324ac90507f = `weF-QW_heading`;
    $74071328817b8c68$export$f30a7571dc7c9daa = `weF-QW_loadingOrError`;
    $74071328817b8c68$export$eeb03afd9378c335 = `weF-QW_subheading`;
    $74071328817b8c68$export$a5f4688122f56e0f = `weF-QW_teamInfo`;
});
parcelRegister("1OeDK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbf2fc61d74174bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $koVbs;
    var $4cwkM = parcelRequire("4cwkM");
    var $kZFV2 = parcelRequire("kZFV2");
    var $jxIc3 = parcelRequire("jxIc3");
    var $eWfTS = parcelRequire("eWfTS");
    function $cbf2fc61d74174bc$export$2e2bcd8739ae039(props) {
        const { teamTitle: teamTitle } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $jxIc3.dialogWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $jxIc3.imageIllustrationPanel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($eWfTS))),
            alt: formatMessage((0, $kZFV2.default).illustrationAlt)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $jxIc3.messagePanel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "h2",
            size: "large"
        }, formatMessage((0, $kZFV2.default).successMessageTitle, {
            teamTitle: teamTitle
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
            className: $jxIc3.prompt
        }, formatMessage((0, $kZFV2.default).plansSuccessMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cwkM.default), {
            href: (0, $4cwkM.default).URLs.committingChangesToJira
        }, formatMessage((0, $kZFV2.default).planLinksToSavingChanges))))));
    }
});
parcelRegister("kZFV2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f87d970b9ed9cefc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f87d970b9ed9cefc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        illustrationAlt: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.twp-success-message.illustration-alt",
            "defaultMessage": "Illustration"
        },
        successMessageTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.twp-success-message.success-message-title",
            "defaultMessage": "You can now plan work for {teamTitle}"
        },
        plansSuccessMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.twp-success-message.plans-success-message",
            "defaultMessage": "Remember: Plans is a sandbox environment. Any changes you make won\u2019t be reflected in the rest of Jira until you save your changes."
        },
        planLinksToSavingChanges: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.teams.list.team-dialog.twp-success-message.plan-links-to-saving-changes",
            "defaultMessage": "How do I save my changes in Plans?"
        }
    });
});
parcelRegister("jxIc3", function(module, exports) {
    $parcel$export(module.exports, "dialogWrapper", ()=>$e3a3614bbafc4917$export$3f49dfbd592f407a, (v)=>$e3a3614bbafc4917$export$3f49dfbd592f407a = v);
    $parcel$export(module.exports, "imageIllustrationPanel", ()=>$e3a3614bbafc4917$export$b3299b5cacc6bee0, (v)=>$e3a3614bbafc4917$export$b3299b5cacc6bee0 = v);
    $parcel$export(module.exports, "messagePanel", ()=>$e3a3614bbafc4917$export$cab0306982ebe319, (v)=>$e3a3614bbafc4917$export$cab0306982ebe319 = v);
    $parcel$export(module.exports, "prompt", ()=>$e3a3614bbafc4917$export$195ba6d62321b933, (v)=>$e3a3614bbafc4917$export$195ba6d62321b933 = v);
    var $e3a3614bbafc4917$export$3f49dfbd592f407a;
    var $e3a3614bbafc4917$export$b3299b5cacc6bee0;
    var $e3a3614bbafc4917$export$cab0306982ebe319;
    var $e3a3614bbafc4917$export$195ba6d62321b933;
    $e3a3614bbafc4917$export$3f49dfbd592f407a = `D7tXFa_dialogWrapper`;
    $e3a3614bbafc4917$export$b3299b5cacc6bee0 = `D7tXFa_imageIllustrationPanel`;
    $e3a3614bbafc4917$export$cab0306982ebe319 = `D7tXFa_messagePanel`;
    $e3a3614bbafc4917$export$195ba6d62321b933 = `D7tXFa_prompt`;
});
parcelRegister("eWfTS", function(module, exports) {
    module.exports = new URL("team-creation-success.2bd0a646.svg", import.meta.url).toString();
});
parcelRegister("22dvl", function(module, exports) {
    $parcel$export(module.exports, "EXISTING_TEAM", ()=>$028758e9111bc5a7$export$818dc13bd127991a);
    $parcel$export(module.exports, "NEW_TEAM", ()=>$028758e9111bc5a7$export$506e176ae2273629);
    $parcel$export(module.exports, "LANDING_STEP", ()=>$028758e9111bc5a7$export$c930a0c3d83204c5);
    $parcel$export(module.exports, "CREATE_COMPANY_SCOPED_TEAM", ()=>$028758e9111bc5a7$export$1d0687a3d094ed05);
    $parcel$export(module.exports, "SUCCESS_CONFIRMATION", ()=>$028758e9111bc5a7$export$2c842ba555dffbdd);
    $parcel$export(module.exports, "TEAM_SETTINGS", ()=>$028758e9111bc5a7$export$46c672e4c76f051d);
    const $028758e9111bc5a7$export$818dc13bd127991a = 'ExistingTeam';
    const $028758e9111bc5a7$export$506e176ae2273629 = 'NewTeam';
    const $028758e9111bc5a7$export$c930a0c3d83204c5 = 'LandingStep';
    const $028758e9111bc5a7$export$1d0687a3d094ed05 = 'CreateCompanyScopedTeam';
    const $028758e9111bc5a7$export$2c842ba555dffbdd = 'SuccessConfirmation';
    const $028758e9111bc5a7$export$46c672e4c76f051d = 'TeamSettings';
});
parcelRegister("aaTT0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$792da029bf994cd2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $792da029bf994cd2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        scrumHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.edit-team-modal.scrum-header",
            "defaultMessage": "Set up sprint capacity planning"
        },
        scrumSubheading: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.edit-team-modal.scrum-subheading",
            "defaultMessage": "Connect a team to a scrum board"
        },
        scrumBodyCopy: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.edit-team-modal.scrum-body-copy",
            "defaultMessage": "Select a scrum board issue source to link to the team."
        },
        kanbanHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.edit-team-modal.kanban-header",
            "defaultMessage": "Set up capacity planning"
        },
        kanbanSubheading: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.edit-team-modal.kanban-subheading",
            "defaultMessage": "Connect the team to an issue source"
        },
        kanbanBodyCopy: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.edit-team-modal.kanban-body-copy",
            "defaultMessage": "Select an issue source to link to the team."
        }
    });
});
parcelRegister("f9axZ", function(module, exports) {
    $parcel$export(module.exports, "getCapacityPlanningMessage", ()=>$5d5a401c880892cc$export$332cf11341c7b14f);
    var $9qcBe = parcelRequire("9qcBe");
    function $5d5a401c880892cc$export$332cf11341c7b14f(settings) {
        const { projectType: projectType, teamAdded: teamAdded, teamHasIssueSource: teamHasIssueSource, planHasBoards: planHasBoards } = settings;
        if (projectType === 'Kanban') {
            if (!teamAdded) return (0, $9qcBe.default).kanbanNoTeam;
            if (!teamHasIssueSource) return (0, $9qcBe.default).kanbanTeamNotLinked;
        } else if (projectType === 'Scrum') {
            if (!planHasBoards) return (0, $9qcBe.default).scrumNoBoardTeamAdded;
            if (!teamAdded) return (0, $9qcBe.default).scrumNoBoardNoTeam;
            if (!teamHasIssueSource) return (0, $9qcBe.default).scrumBoardNoTeam;
        }
        return (0, $9qcBe.default).associateTeamToIssueSource;
    }
});
parcelRegister("4Rgcy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6a01c3dea9f8499$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE4fC;
    var $bC2fB;
    var $8Hjgm = parcelRequire("8Hjgm");
    var $25k5h = parcelRequire("25k5h");
    var $7HNGy = parcelRequire("7HNGy");
    const $c6a01c3dea9f8499$var$Sprint = (0, (0, parcelRequire("bC2fB")).connect)((0, $8Hjgm.default), {})((0, $7HNGy.default));
    const $c6a01c3dea9f8499$var$SprintWithHorizontalScrolling = ({ sprint: sprint, ...rest })=>{
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const [extraProps] = (0, (0, parcelRequire("hE4fC")).useHorizontalPercentageOffset)();
        const memoedSprint = (0, $25k5h.useMemoedSprint)(sprint, zoomLevel);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c6a01c3dea9f8499$var$Sprint, {
            ...rest,
            ...extraProps,
            zoomLevel: zoomLevel,
            sprint: memoedSprint
        });
    };
    var $c6a01c3dea9f8499$export$2e2bcd8739ae039 = $c6a01c3dea9f8499$var$SprintWithHorizontalScrolling;
});
parcelRegister("8Hjgm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c852bff8037d2bea$export$2e2bcd8739ae039);
    var $d3quy = parcelRequire("d3quy");
    var $jpgxP = parcelRequire("jpgxP");
    var $jAIJh = parcelRequire("jAIJh");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $c852bff8037d2bea$var$getPlannedCapacity = (state, { sprint: sprint, teamObject: teamObject })=>{
        if (!teamObject) return undefined;
        return (0, $d3quy.getCapacityForTeamAndIteration)(state, {
            teamId: teamObject.id,
            iterationId: teamObject.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).scrum ? sprint.id : `${sprint.startDate}`
        });
    };
    const $c852bff8037d2bea$var$getOriginalPlannedCapacity = (state, { sprint: sprint, teamObject: teamObject })=>{
        if (!teamObject) return undefined;
        return (0, $d3quy.getOriginalCapacityForTeamAndIteration)(state, {
            teamId: teamObject.id,
            iterationId: teamObject.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).scrum ? sprint.id : `${sprint.startDate}`
        });
    };
    const $c852bff8037d2bea$export$346d4c5769125fa2 = (scenarioPlannedCapacity, originalPlannedCapacity, timelineRange, workingHours)=>({
            isUpdated: !!originalPlannedCapacity,
            plannedCapacity: scenarioPlannedCapacity,
            timelineRange: timelineRange,
            workingHours: workingHours
        });
    var $c852bff8037d2bea$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        $c852bff8037d2bea$var$getPlannedCapacity,
        $c852bff8037d2bea$var$getOriginalPlannedCapacity,
        (0, $jAIJh.getTimelineRange),
        (0, $jpgxP.getJiraHoursPerDay)
    ], $c852bff8037d2bea$export$346d4c5769125fa2);
});
parcelRegister("25k5h", function(module, exports) {
    $parcel$export(module.exports, "useMemoedSprint", ()=>$f7a3a678857321fd$export$a8dedf5af7d6dbf3);
    var $5uXOq = parcelRequire("5uXOq");
    var $eex53 = parcelRequire("eex53");
    var $caqUf = parcelRequire("caqUf");
    const $f7a3a678857321fd$var$omitWidth = (0, ($parcel$interopDefault($caqUf)))([
        'widthPercentage'
    ]);
    function $f7a3a678857321fd$export$a8dedf5af7d6dbf3(sprint, zoomLevel) {
        const sprintRef = (0, $5uXOq.useRef)(sprint);
        if (!(0, ($parcel$interopDefault($eex53)))($f7a3a678857321fd$var$omitWidth(sprintRef.current), $f7a3a678857321fd$var$omitWidth(sprint)) || !zoomLevel) sprintRef.current = sprint;
        return sprintRef.current;
    }
});
parcelRegister("caqUf", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $8dbb4a32eb337ebe$var$func = $lVx1a('omit', (parcelRequire("fr1K2")));
    $8dbb4a32eb337ebe$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $8dbb4a32eb337ebe$var$func;
});
parcelRegister("7HNGy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a655de66d33bef43$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $gtreQ;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $koVbs;
    var $gJZ5D;
    var $flnZx;
    var $iwfmd;
    var $6TEBn = parcelRequire("6TEBn");
    var $gkmEE = parcelRequire("gkmEE");
    var $kC16r = parcelRequire("kC16r");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $kSmOS = parcelRequire("kSmOS");
    var $75RgF = parcelRequire("75RgF");
    var $ji90z = parcelRequire("ji90z");
    const $a655de66d33bef43$var$Sprint = ({ getPercentageOffsetFromToday: getPercentageOffsetFromToday, isContiguousWithNextSprint: isContiguousWithNextSprint = false, isFiltered: isFiltered, isInconsistent: isInconsistent, isUpdated: isUpdated, plan: plan, plannedCapacity: plannedCapacity, showWarning: showWarning, sprint: sprint, teamObject: teamObject, timelineRange: timelineRange, workingHours: workingHours, zoomLevel: zoomLevel })=>{
        const isHorizontalScrolling = zoomLevel;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [state, setState] = (0, $5uXOq.useState)({
            open: false,
            isBarHovered: false
        });
        if (isFiltered === true) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $ji90z.filtered,
            style: {
                width: `${sprint.widthPercentage}%`
            }
        });
        const toggleFlyout = ()=>setState((state)=>({
                    ...state,
                    open: !state.open
                }));
        const isKanban = sprint.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).kanban;
        const getLabel = (label)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $gkmEE.default), {
                key: `sprint_unit_index_${sprint.startDate}`,
                gap: sprint.id === 'GAP',
                label: label,
                noMarker: false,
                widthPercentage: 100
            });
        const getDashedSprintName = ()=>sprint.label.display.replace(/\s/g, '-');
        const getFlyoutLabelAndContent = ()=>{
            const { planningUnit: planningUnit } = plan;
            const { usedCapacity: usedCapacity = 0, schedulingMode: schedulingMode } = sprint;
            const availableCapacity = plannedCapacity ? plannedCapacity.capacity || 0 : sprint.availableCapacity || 0;
            const isPast = sprint.id === 'PAST';
            const isScrum = schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).scrum;
            let displayUsedCapacity = usedCapacity;
            let displayAvailableCapacity = availableCapacity;
            if (usedCapacity > 0 && availableCapacity === 0) {
                displayUsedCapacity = 1;
                displayAvailableCapacity = 1;
            } else if (usedCapacity === 0 && availableCapacity === 0) {
                displayUsedCapacity = 0;
                displayAvailableCapacity = 1;
            }
            const convertedUsedCapacity = (0, $6TEBn.convertCapacityByPlanningUnit)({
                capacity: usedCapacity || 0,
                planningUnit: planningUnit,
                workingHours: workingHours
            });
            const convertedAvailableCapacity = (0, $6TEBn.convertCapacityByPlanningUnit)({
                capacity: availableCapacity || 0,
                planningUnit: planningUnit,
                workingHours: workingHours
            });
            const displayTitle = (()=>{
                let displayTitle = sprint.label.display;
                if (isKanban) switch(planningUnit){
                    case (0, $TTKUQ.PLANNING_UNITS).DAYS:
                    case (0, $TTKUQ.PLANNING_UNITS).HOURS:
                        displayTitle = `${convertedUsedCapacity || 0}/${convertedAvailableCapacity || 0}`;
                        break;
                    default:
                }
                else if (isPast) displayTitle = intl.formatMessage((0, $75RgF.default).pastSprint);
                else if (sprint.id === 'FUTURE') displayTitle = intl.formatMessage((0, $75RgF.default).futureProjectedSprint);
                else displayTitle = sprint.label.display;
                return displayTitle;
            })();
            const display = (()=>{
                let capacity;
                switch(planningUnit){
                    case (0, $TTKUQ.PLANNING_UNITS).DAYS:
                    case (0, $TTKUQ.PLANNING_UNITS).HOURS:
                        capacity = intl.formatMessage((0, $75RgF.default).activeUnitSprint, {
                            unit: intl.formatMessage((0, $75RgF.default)[planningUnit.toLowerCase()], {
                                used: convertedUsedCapacity,
                                available: convertedAvailableCapacity
                            })
                        });
                        break;
                    default:
                        capacity = intl.formatMessage((0, $75RgF.default).activePointsSprint, {
                            used: usedCapacity,
                            available: availableCapacity
                        });
                }
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                    space: "space.075",
                    alignInline: "center",
                    xcss: $a655de66d33bef43$var$stackStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    color: "inherit",
                    size: "UNSAFE_small"
                }, !isKanban && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    weight: "bold",
                    color: "inherit",
                    size: "UNSAFE_small"
                }, displayTitle), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null)), (0, $6TEBn.formatDateRange)(intl, sprint.rawStartDate || sprint.startDate || 0, sprint.rawEndDate || sprint.endDate || 0)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    size: "UNSAFE_small",
                    color: "inherit"
                }, capacity));
            })();
            const labelClasses = (0, ($parcel$interopDefault($9ci4W)))($ji90z.sprintBox, {
                [$ji90z.overbooked]: usedCapacity > availableCapacity,
                [$ji90z.inconsistent]: isInconsistent && showWarning,
                [$ji90z.pastSprint]: isScrum && isPast,
                [$ji90z.closedSprint]: sprint.state === (0, $TTKUQ.SPRINT_STATES).CLOSED,
                [$ji90z.activeSprint]: !(usedCapacity > availableCapacity) && sprint.state === (0, $TTKUQ.SPRINT_STATES).ACTIVE,
                [$ji90z.isContiguousWithNextSprint]: !state.isBarHovered && isContiguousWithNextSprint
            });
            const content = (()=>{
                if (sprint.id === 'GAP') return null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
                    onHoverChanged: (hover)=>setState({
                            ...state,
                            isBarHovered: hover
                        })
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $ji90z.sprintBoxWrapper
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: labelClasses
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $ji90z.bar
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "data-testid": `sprint-capacity-bar-${getDashedSprintName()}`,
                    className: usedCapacity > availableCapacity ? $ji90z.overbooked : $ji90z.okay,
                    style: {
                        height: `${Math.min(100, 100 * displayUsedCapacity / displayAvailableCapacity)}%`
                    }
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $ji90z.sprintName
                }, displayTitle), isInconsistent && showWarning ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                    label: "",
                    primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
                }) : null)));
            })();
            return {
                content: content,
                display: display
            };
        };
        const label = getFlyoutLabelAndContent();
        const ifShowScrumFlyout = sprint.schedulingMode !== (0, $TTKUQ.SCHEDULE_MODE).kanban && sprint.id !== 'GAP' && sprint.id !== 'PAST';
        const ifShowKanbanFlyout = isKanban && sprint.id !== 'GAP';
        const calcWidthPercentage = (start, end, timeline)=>{
            const unitLength = Math.min(timeline.end, end) - Math.max(timeline.start, start);
            const rangeLength = timeline.end - timeline.start;
            return 100 * unitLength / rangeLength;
        };
        const style = isHorizontalScrolling && getPercentageOffsetFromToday ? {
            width: `${getPercentageOffsetFromToday((0, (0, parcelRequire("flnZx")).endOfUtcDay)(sprint.rawEndDate || sprint.endDate) - (!state.isBarHovered && isContiguousWithNextSprint ? (0, (0, parcelRequire("flnZx")).ONE_DAY) : 0)) - getPercentageOffsetFromToday((0, (0, parcelRequire("flnZx")).startOfUtcDay)(sprint.rawStartDate || sprint.startDate))}%`,
            left: `${getPercentageOffsetFromToday((0, (0, parcelRequire("flnZx")).startOfUtcDay)(sprint.rawStartDate || sprint.startDate))}%`,
            position: 'absolute',
            transition: 'width 0.1s ease-in-out 0s',
            animation: '0.2s ease-in-out',
            ...state.isBarHovered && {
                zIndex: '1'
            }
        } : {
            width: `${calcWidthPercentage((0, (0, parcelRequire("flnZx")).startOfUtcDay)(sprint.rawStartDate || sprint.startDate), (0, (0, parcelRequire("flnZx")).endOfUtcDay)(sprint.rawEndDate || sprint.endDate) - (!state.isBarHovered && isContiguousWithNextSprint ? (0, (0, parcelRequire("flnZx")).ONE_DAY) : 0), timelineRange)}%`,
            position: 'absolute',
            left: `${sprint.offset}%`,
            transition: 'width 0.1s ease-in-out 0s',
            animation: '0.2s ease-in-out',
            ...state.isBarHovered && {
                zIndex: '1'
            }
        };
        const sprintLabel = getLabel(label);
        if (ifShowScrumFlyout || ifShowKanbanFlyout) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: style,
            "data-name": `sprint-header-${getDashedSprintName()}`,
            "data-testid": `sprint-header-${sprint.state}-${sprint.schedulingMode || ''}-${sprint.startDate}`
        }, isUpdated && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $ji90z.changeIndicator,
            style: {
                right: "var(--ds-space-025, 2px)"
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kC16r.default), {
            appearance: "triangle"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kSmOS.default), {
            isOpen: state.open,
            onToggle: toggleFlyout,
            sprint: sprint,
            plannedCapacity: plannedCapacity,
            teamObject: teamObject,
            plan: plan,
            isShowTimerangeInconsistent: isInconsistent && showWarning
        }, sprintLabel));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-name": `sprint-header-${getDashedSprintName()}`,
            "data-testid": `sprint-header-${sprint.state}-${sprint.schedulingMode || ''}-${sprint.startDate}`,
            style: style
        }, sprintLabel);
    };
    var $a655de66d33bef43$export$2e2bcd8739ae039 = $a655de66d33bef43$var$Sprint;
    const $a655de66d33bef43$var$stackStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textAlign: 'center'
    });
});
parcelRegister("gkmEE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27586d459b5dc335$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $3RVrv = parcelRequire("3RVrv");
    var $eNBft = parcelRequire("eNBft");
    function $27586d459b5dc335$export$2e2bcd8739ae039(props) {
        const { widthPercentage: widthPercentage, label: label, noMarker: noMarker, gap: gap } = props;
        let { content: content, display: display } = label;
        if (gap === true) display = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, "\xa0");
        content = content || (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eNBft.innerContent
        }, noMarker === true ? null : display);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.unit",
            className: $eNBft.unit,
            style: {
                width: `${widthPercentage}%`
            }
        }, gap === true ? content : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3RVrv.default), {
            content: display
        }, content));
    }
});
parcelRegister("eNBft", function(module, exports) {
    $parcel$export(module.exports, "innerContent", ()=>$ac62891a0e3fbd51$export$dc0b7d7489259dc8, (v)=>$ac62891a0e3fbd51$export$dc0b7d7489259dc8 = v);
    $parcel$export(module.exports, "unit", ()=>$ac62891a0e3fbd51$export$523c0b569236b342, (v)=>$ac62891a0e3fbd51$export$523c0b569236b342 = v);
    var $ac62891a0e3fbd51$export$dc0b7d7489259dc8;
    var $ac62891a0e3fbd51$export$523c0b569236b342;
    $ac62891a0e3fbd51$export$dc0b7d7489259dc8 = `FP9-Ka_innerContent`;
    $ac62891a0e3fbd51$export$523c0b569236b342 = `FP9-Ka_unit`;
});
parcelRegister("75RgF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$221ac6d515f58143$export$2e2bcd8739ae039);
    var $7VHMR;
    var $221ac6d515f58143$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        activePointsSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.active-points-sprint",
            "defaultMessage": "{used}/{available} points allocated"
        },
        activeUnitSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.active-unit-sprint",
            "defaultMessage": "{unit} allocated"
        },
        days: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.days",
            "defaultMessage": "{available, plural, one {{used}/{available} day} other {{used}/{available} days}}"
        },
        daysTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.days-title",
            "defaultMessage": "{displayTitle} days of estimated work"
        },
        futureProjectedSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.future-projected-sprint",
            "defaultMessage": "Projected sprint"
        },
        hours: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.hours",
            "defaultMessage": "{available, plural, one {{used}/{available} hour} other {{used}/{available} hours}}"
        },
        hoursTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.hours-title",
            "defaultMessage": "{displayTitle} hours of estimated work"
        },
        pastSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.past-sprint",
            "defaultMessage": "Past sprint"
        }
    });
});
parcelRegister("ji90z", function(module, exports) {
    $parcel$export(module.exports, "activeSprint", ()=>$e0b6af97e379b028$export$c891bbacdf93fd6e, (v)=>$e0b6af97e379b028$export$c891bbacdf93fd6e = v);
    $parcel$export(module.exports, "bar", ()=>$e0b6af97e379b028$export$d927737047eb3867, (v)=>$e0b6af97e379b028$export$d927737047eb3867 = v);
    $parcel$export(module.exports, "changeIndicator", ()=>$e0b6af97e379b028$export$deafeb91a574091c, (v)=>$e0b6af97e379b028$export$deafeb91a574091c = v);
    $parcel$export(module.exports, "closedSprint", ()=>$e0b6af97e379b028$export$70b46a68a5b6a9e0, (v)=>$e0b6af97e379b028$export$70b46a68a5b6a9e0 = v);
    $parcel$export(module.exports, "filtered", ()=>$e0b6af97e379b028$export$8082fa36f85e6b63, (v)=>$e0b6af97e379b028$export$8082fa36f85e6b63 = v);
    $parcel$export(module.exports, "inconsistent", ()=>$e0b6af97e379b028$export$38e6368cd28c04af, (v)=>$e0b6af97e379b028$export$38e6368cd28c04af = v);
    $parcel$export(module.exports, "isContiguousWithNextSprint", ()=>$e0b6af97e379b028$export$b5b9fc739036f130, (v)=>$e0b6af97e379b028$export$b5b9fc739036f130 = v);
    $parcel$export(module.exports, "okay", ()=>$e0b6af97e379b028$export$4ff774198978dac4, (v)=>$e0b6af97e379b028$export$4ff774198978dac4 = v);
    $parcel$export(module.exports, "overbooked", ()=>$e0b6af97e379b028$export$312c3ba826526246, (v)=>$e0b6af97e379b028$export$312c3ba826526246 = v);
    $parcel$export(module.exports, "pastSprint", ()=>$e0b6af97e379b028$export$196f532ad83e375c, (v)=>$e0b6af97e379b028$export$196f532ad83e375c = v);
    $parcel$export(module.exports, "sprintBox", ()=>$e0b6af97e379b028$export$f182c2c4b027a866, (v)=>$e0b6af97e379b028$export$f182c2c4b027a866 = v);
    $parcel$export(module.exports, "sprintBoxWrapper", ()=>$e0b6af97e379b028$export$ad1793f393406837, (v)=>$e0b6af97e379b028$export$ad1793f393406837 = v);
    $parcel$export(module.exports, "sprintName", ()=>$e0b6af97e379b028$export$2780111908128a1b, (v)=>$e0b6af97e379b028$export$2780111908128a1b = v);
    var $e0b6af97e379b028$export$c891bbacdf93fd6e;
    var $e0b6af97e379b028$export$d927737047eb3867;
    var $e0b6af97e379b028$export$deafeb91a574091c;
    var $e0b6af97e379b028$export$70b46a68a5b6a9e0;
    var $e0b6af97e379b028$export$8082fa36f85e6b63;
    var $e0b6af97e379b028$export$38e6368cd28c04af;
    var $e0b6af97e379b028$export$b5b9fc739036f130;
    var $e0b6af97e379b028$export$4ff774198978dac4;
    var $e0b6af97e379b028$export$312c3ba826526246;
    var $e0b6af97e379b028$export$196f532ad83e375c;
    var $e0b6af97e379b028$export$4ecafa351f5a3ad3;
    var $e0b6af97e379b028$export$f182c2c4b027a866;
    var $e0b6af97e379b028$export$ad1793f393406837;
    var $e0b6af97e379b028$export$2780111908128a1b;
    var $e0b6af97e379b028$export$e68357c14d268b6;
    $e0b6af97e379b028$export$c891bbacdf93fd6e = `wHWzja_activeSprint`;
    $e0b6af97e379b028$export$d927737047eb3867 = `wHWzja_bar`;
    $e0b6af97e379b028$export$deafeb91a574091c = `wHWzja_changeIndicator`;
    $e0b6af97e379b028$export$70b46a68a5b6a9e0 = `wHWzja_closedSprint`;
    $e0b6af97e379b028$export$8082fa36f85e6b63 = `wHWzja_filtered`;
    $e0b6af97e379b028$export$38e6368cd28c04af = `wHWzja_inconsistent`;
    $e0b6af97e379b028$export$b5b9fc739036f130 = `wHWzja_isContiguousWithNextSprint`;
    $e0b6af97e379b028$export$4ff774198978dac4 = `wHWzja_okay`;
    $e0b6af97e379b028$export$312c3ba826526246 = `wHWzja_overbooked`;
    $e0b6af97e379b028$export$196f532ad83e375c = `wHWzja_pastSprint`;
    $e0b6af97e379b028$export$4ecafa351f5a3ad3 = `wHWzja_sprint`;
    $e0b6af97e379b028$export$f182c2c4b027a866 = `wHWzja_sprintBox`;
    $e0b6af97e379b028$export$ad1793f393406837 = `wHWzja_sprintBoxWrapper`;
    $e0b6af97e379b028$export$2780111908128a1b = `wHWzja_sprintName`;
    $e0b6af97e379b028$export$e68357c14d268b6 = `wHWzja_sprintTooltip`;
});
parcelRegister("5igXV", function(module, exports) {
    $parcel$export(module.exports, "message", ()=>$3dabcb2b9ea6ac56$export$a8ecead220dd38a6, (v)=>$3dabcb2b9ea6ac56$export$a8ecead220dd38a6 = v);
    $parcel$export(module.exports, "sprintLabels", ()=>$3dabcb2b9ea6ac56$export$23d7aa3ce101edc3, (v)=>$3dabcb2b9ea6ac56$export$23d7aa3ce101edc3 = v);
    var $3dabcb2b9ea6ac56$export$a8ecead220dd38a6;
    var $3dabcb2b9ea6ac56$export$23d7aa3ce101edc3;
    $3dabcb2b9ea6ac56$export$a8ecead220dd38a6 = `gT7APG_message`;
    $3dabcb2b9ea6ac56$export$23d7aa3ce101edc3 = `gT7APG_sprintLabels`;
});
parcelRegister("fXuAE", function(module, exports) {
    $parcel$export(module.exports, "WithoutParentHeader", ()=>$09f14a171e9c525b$export$26bc07146056b1e7);
    var $bC2fB;
    var $3zeVL = parcelRequire("3zeVL");
    var $kJ7pq = parcelRequire("kJ7pq");
    const $09f14a171e9c525b$export$26bc07146056b1e7 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $3zeVL.default))((0, $kJ7pq.WithoutParentHeader));
});
parcelRegister("3zeVL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69ee5bb2edd0cce6$export$2e2bcd8739ae039);
    var $21mdo = parcelRequire("21mdo");
    var $69ee5bb2edd0cce6$export$2e2bcd8739ae039 = (dispatch)=>({
            onToggle: (payload)=>dispatch((0, $21mdo.setIsExpanded)(payload))
        });
});
parcelRegister("kJ7pq", function(module, exports) {
    $parcel$export(module.exports, "WithoutParentHeader", ()=>$3534a54477559106$export$26bc07146056b1e7);
    var $5uXOq = parcelRequire("5uXOq");
    var $ivX7Y = parcelRequire("ivX7Y");
    const $3534a54477559106$export$26bc07146056b1e7 = ({ item: item, onToggle: onToggle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ivX7Y.default), {
            issuesCount: item.value.issueCount,
            isExpanded: item.value.isExpanded,
            id: item.value.id,
            onToggle: onToggle
        });
});
parcelRegister("ivX7Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33548b2ebf79bee5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $6Ingq;
    var $ebd3R;
    var $ousew;
    var $9V5En = parcelRequire("9V5En");
    var $lRKoW = parcelRequire("lRKoW");
    var $9JfMy = parcelRequire("9JfMy");
    function $33548b2ebf79bee5$var$IssuesWithoutParentHeader({ id: id, isExpanded: isExpanded = false, issuesCount: issuesCount, onToggle: onToggle }) {
        const handleToggle = ()=>{
            onToggle({
                [id]: !isExpanded
            });
        };
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall",
            as: "h2",
            "data-role": "header"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $9JfMy.issuesWithoutParentText
        }, isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
            label: ""
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))), {
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $lRKoW.default).issuesWithoutParent,
            values: {
                issuesCount: issuesCount
            }
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9V5En.default), {
            onClick: handleToggle,
            className: $9JfMy.toggleButton,
            "data-name": "toggleIssuesWithoutParentHeader",
            ariaExpanded: isExpanded
        }, content);
    }
    var $33548b2ebf79bee5$export$2e2bcd8739ae039 = $33548b2ebf79bee5$var$IssuesWithoutParentHeader;
});
parcelRegister("lRKoW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1b753e9285be224$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d1b753e9285be224$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issuesWithoutParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issues-without-parent-header.issues-without-parent",
            "defaultMessage": "{issuesCount, plural, one {# issue} other {# issues}} without parent"
        }
    });
});
parcelRegister("9JfMy", function(module, exports) {
    $parcel$export(module.exports, "issuesWithoutParentText", ()=>$71548f07eae92519$export$2ebe39de57ad3ebf, (v)=>$71548f07eae92519$export$2ebe39de57ad3ebf = v);
    $parcel$export(module.exports, "toggleButton", ()=>$71548f07eae92519$export$c3f9788a1ddcf2d9, (v)=>$71548f07eae92519$export$c3f9788a1ddcf2d9 = v);
    var $71548f07eae92519$export$b18e054cadb4b0e3;
    var $71548f07eae92519$export$2ebe39de57ad3ebf;
    var $71548f07eae92519$export$c3f9788a1ddcf2d9;
    $71548f07eae92519$export$b18e054cadb4b0e3 = `rIGP-q_issuesWithoutParentHeader`;
    $71548f07eae92519$export$2ebe39de57ad3ebf = `rIGP-q_issuesWithoutParentText`;
    $71548f07eae92519$export$c3f9788a1ddcf2d9 = `rIGP-q_toggleButton`;
});
const $2ac30dbb3094ef55$export$168e85cd31f14583 = 2e6;
const $2ac30dbb3094ef55$export$8b2f0f816c634962 = 701;
parcelRegister("6y7pI", function(module, exports) {
    $parcel$export(module.exports, "EmptyView", ()=>$8ac2f1372a229456$export$f716ac8971c5316e);
    var $bC2fB;
    var $dfGxv = parcelRequire("dfGxv");
    var $h0NNs = parcelRequire("h0NNs");
    const $8ac2f1372a229456$export$f716ac8971c5316e = (0, (0, parcelRequire("bC2fB")).connect)((0, $dfGxv.default), {})((0, $h0NNs.EmptyView));
});
parcelRegister("dfGxv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98af2c8d81de5328$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $gFhwb = parcelRequire("gFhwb");
    var $3YtPS = parcelRequire("3YtPS");
    var $jK6Qc = parcelRequire("jK6Qc");
    var $98af2c8d81de5328$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $jK6Qc.getEnhancedIssues),
        (0, $1CGdp.getMode),
        (0, $gFhwb.getIssues)
    ], (issues, mode, issuesInPlan)=>({
            isReadOnly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
            issues: issues,
            noIssuesInPlan: issuesInPlan.length === 0
        }));
});
parcelRegister("h0NNs", function(module, exports) {
    $parcel$export(module.exports, "EmptyView", ()=>$42c718cd320303c6$export$f716ac8971c5316e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bEY29 = parcelRequire("bEY29");
    var $4mDVk = parcelRequire("4mDVk");
    const $42c718cd320303c6$export$f716ac8971c5316e = ({ issues: issues, noIssuesInPlan: noIssuesInPlan, isReadOnly: isReadOnly })=>{
        if (issues.length === 0) {
            if (noIssuesInPlan) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bEY29.default), {
                isReadOnly: isReadOnly
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4mDVk.default), null);
        }
    };
});
parcelRegister("bEY29", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e89d869b586d422$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $aCpcO;
    var $4hkqI = parcelRequire("4hkqI");
    var $5D6fg = parcelRequire("5D6fg");
    var $8OcsK = parcelRequire("8OcsK");
    function $4e89d869b586d422$export$2e2bcd8739ae039(_props) {
        const redirectToSpaPlanPage = (0, $4hkqI.useRedirectToSpaPlanPage)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            redirectToSpaPlanPage('/settings/issue-sources');
        }, [
            redirectToSpaPlanPage
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8OcsK.emptyView
        }, _props.isReadOnly ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $5D6fg.default).emptyViewMessageReadOnly) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $5D6fg.default).emptyViewMessage,
            values: {
                button: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                        target: "_blank",
                        appearance: "link",
                        onClick: onClick,
                        spacing: "none"
                    }, chunks)
            }
        })));
    }
});
parcelRegister("5D6fg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad33bc8eb2606420$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ad33bc8eb2606420$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyViewMessageReadOnly: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.no-issues-empty-state.empty-view-message-read-only",
            "defaultMessage": "There aren't any issues in this plan yet."
        },
        emptyViewMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.no-issues-empty-state.empty-view-message",
            "defaultMessage": "There aren't any issues in your plan yet. Add <button>issue sources</button> to form the scope of your plan."
        }
    });
});
parcelRegister("8OcsK", function(module, exports) {
    $parcel$export(module.exports, "emptyView", ()=>$669ca9173b39c808$export$a1ea9495c5c524bc, (v)=>$669ca9173b39c808$export$a1ea9495c5c524bc = v);
    var $669ca9173b39c808$export$a1ea9495c5c524bc;
    $669ca9173b39c808$export$a1ea9495c5c524bc = `SM_IKW_emptyView`;
});
parcelRegister("4mDVk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b63c71e5437ab950$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $avLqY = parcelRequire("avLqY");
    var $eZZLX = parcelRequire("eZZLX");
    const $b63c71e5437ab950$export$1dbca41e84744512 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eZZLX.emptyView
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $avLqY.default).noMatchingIssues)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $eZZLX.line2
        }, formatMessage((0, $avLqY.default).adjustFilter))));
    };
    var $b63c71e5437ab950$export$2e2bcd8739ae039 = $b63c71e5437ab950$export$1dbca41e84744512;
});
parcelRegister("avLqY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa9f2fb605c9326d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $aa9f2fb605c9326d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noMatchingIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.no-issues-in-filter-empty-view.no-matching-issues",
            "defaultMessage": "No matching issues found."
        },
        adjustFilter: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.no-issues-in-filter-empty-view.adjust-filter",
            "defaultMessage": "Adjust your filters and try again."
        }
    });
});
parcelRegister("eZZLX", function(module, exports) {
    $parcel$export(module.exports, "emptyView", ()=>$aeb6adf21733b949$export$a1ea9495c5c524bc, (v)=>$aeb6adf21733b949$export$a1ea9495c5c524bc = v);
    $parcel$export(module.exports, "line2", ()=>$aeb6adf21733b949$export$4afbf2decdd805ec, (v)=>$aeb6adf21733b949$export$4afbf2decdd805ec = v);
    var $aeb6adf21733b949$export$a1ea9495c5c524bc;
    var $aeb6adf21733b949$export$4afbf2decdd805ec;
    $aeb6adf21733b949$export$a1ea9495c5c524bc = `jn3g7W_emptyView`;
    $aeb6adf21733b949$export$4afbf2decdd805ec = `jn3g7W_line2`;
});
parcelRegister("cveZJ", function(module, exports) {
    $parcel$export(module.exports, "FieldsHeader", ()=>$5eeacf3d892d9907$export$24f33b2bf0872efd);
    var $bC2fB;
    var $2v5mE = parcelRequire("2v5mE");
    var $hiX7T = parcelRequire("hiX7T");
    var $6wX1k = parcelRequire("6wX1k");
    const $5eeacf3d892d9907$export$24f33b2bf0872efd = (0, (0, parcelRequire("bC2fB")).connect)((0, $hiX7T.mapStateToProps), (0, $2v5mE.default))((0, $6wX1k.FieldsHeader));
});
parcelRegister("2v5mE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0b95b378cbc4fe9$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $4ArTT = parcelRequire("4ArTT");
    var $dBbgF = parcelRequire("dBbgF");
    const $e0b95b378cbc4fe9$var$dispatchMethods = (dispatch)=>({
            hideColumn: (id)=>{
                dispatch({
                    type: (0, $4ArTT.HIDE_COLUMN),
                    id: id,
                    meta: {
                        source: (0, $4ArTT.AFM_HIDE_FIELD)
                    }
                });
            },
            showColumn: (id)=>{
                dispatch({
                    type: (0, $4ArTT.SHOW_COLUMN),
                    id: id,
                    meta: {
                        source: (0, $4ArTT.AFM_ADD_FIELD)
                    }
                });
                if (id === 'breakdown' || id === 'progressByEstimation') dispatch((0, $bkasS.fetchHistoricalDoneIssues)());
            },
            moveColumn: (columnToMove, moveToTheIndexOf)=>{
                dispatch((0, $4ArTT.move)({
                    columnToMove: columnToMove,
                    moveToTheIndexOf: moveToTheIndexOf
                }, {
                    source: (0, $4ArTT.AFM_DRAG_FIELD)
                }));
            },
            changeSort: (sorting)=>{
                dispatch((0, $dBbgF.changeSort)({
                    sorting: sorting
                }));
            }
        });
    var $e0b95b378cbc4fe9$export$2e2bcd8739ae039 = $e0b95b378cbc4fe9$var$dispatchMethods;
});
parcelRegister("hiX7T", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$0225bd9ced997604$export$c31df4bd766f9c35);
    var $bHTqr = parcelRequire("bHTqr");
    var $j0XCX = parcelRequire("j0XCX");
    var $g7bEf = parcelRequire("g7bEf");
    var $3YtPS = parcelRequire("3YtPS");
    const $0225bd9ced997604$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        columns: (0, $g7bEf.getColumns),
        dateConfiguration: (0, $bHTqr.getDateConfiguration),
        sorting: (0, $j0XCX.getVisualisationSorting)
    });
});
parcelRegister("6wX1k", function(module, exports) {
    $parcel$export(module.exports, "FieldsHeader", ()=>$8a748edc8d6687fa$export$24f33b2bf0872efd);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $8pJHi = parcelRequire("8pJHi");
    var $l9sxf = parcelRequire("l9sxf");
    var $743tJ = parcelRequire("743tJ");
    var $d3UHJ = parcelRequire("d3UHJ");
    var $8LV9S;
    var $b6CZs = parcelRequire("b6CZs");
    const $8a748edc8d6687fa$export$24f33b2bf0872efd = ({ columns: columns, hideColumn: hideColumn, showColumn: showColumn, moveColumn: moveColumn, changeSort: changeSort, dateConfiguration: dateConfiguration, sorting: sorting, collapsible: collapsible, useColumnToggle: useColumnToggle })=>{
        const [scopeColumnWidth] = (0, (0, parcelRequire("8LV9S")).useColumnWidth)({
            column: 0,
            preview: true
        });
        const resetSort = ()=>{
            changeSort((0, $8pJHi.defaultSorting));
        };
        const toggle = useColumnToggle();
        const collapse = (0, $5uXOq.useCallback)(()=>toggle(false), [
            toggle
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a748edc8d6687fa$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a748edc8d6687fa$var$stickyContainerStyles,
            style: {
                left: scopeColumnWidth
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $l9sxf.default), {
            id: "fields-top-section",
            columns: columns,
            hideColumn: hideColumn,
            showColumn: showColumn,
            moveColumn: moveColumn,
            getMatchingConfiguredDate: (0, $d3UHJ.getMatchingConfiguredDate)(dateConfiguration)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8a748edc8d6687fa$var$resetContainerStyles
        }, sorting.field !== (0, $8pJHi.defaultSorting).field && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b6CZs.default), {
            onClick: resetSort
        }), collapsible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $743tJ.default), {
            onClick: collapse
        })));
    };
    const $8a748edc8d6687fa$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        justifyContent: 'space-between'
    });
    const $8a748edc8d6687fa$var$stickyContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky',
        right: 'space.100',
        marginRight: 'space.100',
        overflow: 'hidden'
    });
    const $8a748edc8d6687fa$var$resetContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky',
        right: 'space.0',
        marginRight: 'space.100',
        minWidth: 'space.200',
        flex: '0 1 auto',
        display: 'flex'
    });
});
parcelRegister("743tJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2bc6779cdc94169$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $eAzs8;
    var $8sVBM;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $aCpcO;
    var $8zOmE;
    var $dCm1o;
    var $blyPu = parcelRequire("blyPu");
    const $c2bc6779cdc94169$var$CollapseButton = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onHandleClick = (_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'collapseFields');
            onClick();
        };
        const collapseFieldsFormatted = formatMessage((0, $blyPu.default).advancedFieldsMenuCollapseFields);
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: collapseFieldsFormatted
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("eAzs8"))))),
            appearance: "subtle",
            onClick: onHandleClick,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.collapse-button",
            label: collapseFieldsFormatted,
            "aria-expanded": true
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            spacing: "none",
            onClick: onHandleClick,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.collapse-button",
            ariaLabel: collapseFieldsFormatted,
            "aria-expanded": true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: collapseFieldsFormatted
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8sVBM"))))), {
            label: ""
        })));
    };
    var $c2bc6779cdc94169$export$2e2bcd8739ae039 = $c2bc6779cdc94169$var$CollapseButton;
});
parcelRegister("eAzs8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a9efedb00769b9b5$var$_react = $a9efedb00769b9b5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a9efedb00769b9b5$var$_UNSAFE_baseNew = $a9efedb00769b9b5$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a9efedb00769b9b5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a9efedb00769b9b5$var$CollapseHorizontalIcon = (props)=>$a9efedb00769b9b5$var$_react.default.createElement($a9efedb00769b9b5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 5.5 10.75 8l2.5 2.5M16 8h-4.75m-8.5-2.5L5.25 8l-2.5 2.5M0 8h4.75M8 1v14"/>`
        }, props));
    $a9efedb00769b9b5$var$CollapseHorizontalIcon.displayName = 'CollapseHorizontalIcon';
    var $a9efedb00769b9b5$var$_default = module.exports.default = $a9efedb00769b9b5$var$CollapseHorizontalIcon;
});
parcelRegister("8sVBM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $629da0128daed98a$var$_react = $629da0128daed98a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $629da0128daed98a$var$_shrinkHorizontal = $629da0128daed98a$var$_interopRequireDefault((parcelRequire("hocXQ")));
    function $629da0128daed98a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $629da0128daed98a$var$EditorCollapseIcon = (props)=>$629da0128daed98a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.062 11 6.5 9.914A1 1 0 0 1 7.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 1 1 6.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0 1 17.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 0 1-1.414 1.414z"/></svg>`
        }, props, {
            newIcon: $629da0128daed98a$var$_shrinkHorizontal.default
        }));
    $629da0128daed98a$var$EditorCollapseIcon.displayName = 'EditorCollapseIcon';
    var $629da0128daed98a$var$_default = module.exports.default = $629da0128daed98a$var$EditorCollapseIcon;
});
parcelRegister("hocXQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ca8ebbfe28d077b2$var$_react = $ca8ebbfe28d077b2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ca8ebbfe28d077b2$var$_UNSAFE_baseNew = $ca8ebbfe28d077b2$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ca8ebbfe28d077b2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ca8ebbfe28d077b2$var$ShrinkHorizontalIcon = (props)=>$ca8ebbfe28d077b2$var$_react.default.createElement($ca8ebbfe28d077b2$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M0 8h6.25m3.5 0H16M2.75 4.5 6.25 8l-3.5 3.5m10.5-7L9.75 8l3.5 3.5"/>`
        }, props));
    $ca8ebbfe28d077b2$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
    var $ca8ebbfe28d077b2$var$_default = module.exports.default = $ca8ebbfe28d077b2$var$ShrinkHorizontalIcon;
});
parcelRegister("blyPu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a9ba9b00adeff5e$export$2e2bcd8739ae039);
    var $7VHMR;
    const $9a9ba9b00adeff5e$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        advancedFieldsMenuCollapseFields: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.collapse-button.advanced-fields-menu-collapse-fields",
            "defaultMessage": "Collapse fields"
        }
    });
    var $9a9ba9b00adeff5e$export$2e2bcd8739ae039 = $9a9ba9b00adeff5e$var$messages;
});
parcelRegister("b6CZs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5722fa4c5593bdc2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kNGlC;
    var $3bDjY;
    var $koVbs;
    var $aCpcO;
    var $8zOmE;
    var $fMiGU = parcelRequire("fMiGU");
    const $5722fa4c5593bdc2$var$ResetSortingOrder = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onHandleClick = (_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'resetSortingOrder');
            onClick();
        };
        const resetSortingOrderFormatted = formatMessage((0, $fMiGU.default).resetSortingOrder);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: resetSortingOrderFormatted
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            spacing: "none",
            onClick: onHandleClick,
            ariaLabel: resetSortingOrderFormatted
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kNGlC"))))), {
            label: ""
        })));
    };
    var $5722fa4c5593bdc2$export$2e2bcd8739ae039 = $5722fa4c5593bdc2$var$ResetSortingOrder;
});
parcelRegister("kNGlC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f2493ba1e2db6b78$var$_react = $f2493ba1e2db6b78$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f2493ba1e2db6b78$var$_retry = $f2493ba1e2db6b78$var$_interopRequireDefault((parcelRequire("lzNDe")));
    function $f2493ba1e2db6b78$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f2493ba1e2db6b78$var$RetryIcon = (props)=>$f2493ba1e2db6b78$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 10h2.954a1 1 0 0 1 0 2H5.099A1.1 1.1 0 0 1 4 10.9V7a1 1 0 1 1 2 0z"/><path fill-rule="nonzero" d="M7.39 10.09H5.3a8 8 0 1 1 .818 6H7.84v-1.02a6 6 0 1 0-.45-4.98"/><circle cx="7" cy="15.61" r="1"/></g></svg>`
        }, props, {
            newIcon: $f2493ba1e2db6b78$var$_retry.default
        }));
    $f2493ba1e2db6b78$var$RetryIcon.displayName = 'RetryIcon';
    var $f2493ba1e2db6b78$var$_default = module.exports.default = $f2493ba1e2db6b78$var$RetryIcon;
});
parcelRegister("lzNDe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fb535dae8e778b64$var$_react = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fb535dae8e778b64$var$_UNSAFE_baseNew = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fb535dae8e778b64$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fb535dae8e778b64$var$RetryIcon = (props)=>$fb535dae8e778b64$var$_react.default.createElement($fb535dae8e778b64$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 14a6 6 0 1 1 6-6v2.5m2.625-2.125L12.75 11l-2.625-2.625"/>`
        }, props));
    $fb535dae8e778b64$var$RetryIcon.displayName = 'RetryIcon';
    var $fb535dae8e778b64$var$_default = module.exports.default = $fb535dae8e778b64$var$RetryIcon;
});
parcelRegister("fMiGU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98c5127165cfb0b9$export$2e2bcd8739ae039);
    var $7VHMR;
    const $98c5127165cfb0b9$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        resetSortingOrder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.header.fields.reset-sorting-order.reset-sorting-order",
            "defaultMessage": "Reset sorting order"
        }
    });
    var $98c5127165cfb0b9$export$2e2bcd8739ae039 = $98c5127165cfb0b9$var$messages;
});
parcelRegister("D3sP2", function(module, exports) {
    $parcel$export(module.exports, "ScopeHeader", ()=>$16e7419f85d01e3c$export$7581f1eaad4855e);
    var $bC2fB;
    var $hG2ss = parcelRequire("hG2ss");
    var $bt2XW = parcelRequire("bt2XW");
    const $16e7419f85d01e3c$export$7581f1eaad4855e = (0, (0, parcelRequire("bC2fB")).connect)((0, $hG2ss.default), {})((0, $bt2XW.default));
});
parcelRegister("hG2ss", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea4d11e15b0a5535$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $7bnpM = parcelRequire("7bnpM");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $3YtPS = parcelRequire("3YtPS");
    var $ea4d11e15b0a5535$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $6Ayrn.getHierarchyLevels),
        (0, $7bnpM.getHierarchyFilter),
        (0, $1CGdp.isExportMode),
        (0, $1CGdp.getMode)
    ], (hierarchy, { value: { start: start, end: end } }, exportMode, mode)=>({
            hierarchy: hierarchy,
            start: start,
            end: end,
            isReadOnly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
            isExportMode: exportMode
        }));
});
parcelRegister("bt2XW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$187e656e3424dd7f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $c12LJ;
    var $hdWDJ = parcelRequire("hdWDJ");
    var $dDVpf = parcelRequire("dDVpf");
    var $k1b3w = parcelRequire("k1b3w");
    var $41xwO = parcelRequire("41xwO");
    var $aQZDz = parcelRequire("aQZDz");
    var $esnSm = parcelRequire("esnSm");
    function $187e656e3424dd7f$var$ScopeHeader({ end: end, hierarchy: hierarchy, isExportMode: isExportMode, isReadOnly: isReadOnly, isSelected: isSelected, start: start }) {
        const currentHierarchyLevels = hierarchy.reduce((acc, { level: level, title: title })=>{
            if (level >= (0, (0, parcelRequire("c12LJ")).STORY_LEVEL)) acc.push({
                id: level,
                title: title,
                value: level,
                visible: level <= start && level >= Math.max((0, (0, parcelRequire("c12LJ")).STORY_LEVEL), end)
            });
            return acc;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $187e656e3424dd7f$var$containerStyles
        }, !isExportMode && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aQZDz.default), null), !isReadOnly && !isSelected && currentHierarchyLevels.length > 0 && ((0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_issue_type_create_dropdown') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $esnSm.default), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hdWDJ.default), {
            currentHierarchyLevels: currentHierarchyLevels,
            isDefaultOpen: false,
            MenuItem: (0, $dDVpf.default),
            NestedMenu: (0, $k1b3w.default)
        })), isSelected && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $41xwO.default), null));
    }
    var $187e656e3424dd7f$export$2e2bcd8739ae039 = $187e656e3424dd7f$var$ScopeHeader;
    const $187e656e3424dd7f$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: 'space.100',
        paddingRight: 'space.100',
        boxSizing: 'border-box'
    });
});
parcelRegister("hdWDJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc74a90ff82f20eb$export$2e2bcd8739ae039);
    var $bC2fB;
    var $eWbId = parcelRequire("eWbId");
    var $7U9Yt = parcelRequire("7U9Yt");
    var $9GwDB = parcelRequire("9GwDB");
    var $dc74a90ff82f20eb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7U9Yt.default), (0, $eWbId.default))((0, $9GwDB.default));
});
parcelRegister("eWbId", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de39e63a82af4288$export$2e2bcd8739ae039);
    var $jlryX = parcelRequire("jlryX");
    var $lKGSc = parcelRequire("lKGSc");
    var $dBbgF = parcelRequire("dBbgF");
    var $7K8Pq = parcelRequire("7K8Pq");
    const $de39e63a82af4288$var$mapDispatchToProps = (dispatch)=>({
            startInlineCreate: (payload)=>{
                dispatch((0, $jlryX.startInlineCreate)(payload));
            },
            setIssueTypeIdForHierarchy: (hierarchyLevel, issueTypeId)=>{
                dispatch((0, $7K8Pq.setIssueTypeIdForHierarchy)(hierarchyLevel, issueTypeId));
            },
            setGlobalCreateIssue: ()=>{
                dispatch((0, $7K8Pq.setGlobalCreateIssue)(true));
            },
            setDefaultProject: (projectId)=>dispatch((0, $lKGSc.setDefaultProject)({
                    projectId: projectId
                })),
            toggleExpandGroup: (payload)=>dispatch((0, $dBbgF.toggleExpandGroup)(payload))
        });
    var $de39e63a82af4288$export$2e2bcd8739ae039 = $de39e63a82af4288$var$mapDispatchToProps;
});
parcelRegister("7U9Yt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d94a34c37cbf217$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $gk0jw = parcelRequire("gk0jw");
    var $jpXKt = parcelRequire("jpXKt");
    var $jLI87 = parcelRequire("jLI87");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $4d94a34c37cbf217$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $6Ayrn.getTypeToLevel),
        (0, $jpXKt.getProjects),
        (0, $gk0jw.getInlineCreateState),
        (0, $jpXKt.getDefaultProjectId),
        (0, $6Ayrn.getEnrichedHierarchyLevels),
        (0, $jLI87.getScope),
        (0, $j0XCX.getVisualisationGrouping),
        (0, $19iju.getCustomFieldsById)
    ], (typeToLevel, projects, { issueTypeId: issueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy }, defaultProjectId, enrichedHierarchyLevels, { groups: groups }, visualisationGrouping, customFieldsById)=>({
            typeToLevel: typeToLevel,
            projects: projects,
            issueTypeId: issueTypeId,
            IssueTypeIdForHierarchy: IssueTypeIdForHierarchy,
            defaultProjectId: defaultProjectId,
            enrichedHierarchyLevels: enrichedHierarchyLevels,
            groups: groups,
            visualisationGrouping: visualisationGrouping,
            customFieldsById: customFieldsById
        }));
});
parcelRegister("9GwDB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65aa587f10254513$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1sWm7 = parcelRequire("1sWm7");
    var $9U6ZH;
    var $4S1OS;
    var $sqeVT;
    var $aRoVz;
    var $9lMrf;
    var $5Fk4Z;
    var $3bDjY;
    var $ousew;
    var $8RXs9;
    var $aCpcO;
    var $J8W7q;
    var $9S2q6;
    var $g295Q;
    var $i2qlb = parcelRequire("i2qlb");
    var $l38L3 = parcelRequire("l38L3");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $30sno = parcelRequire("30sno");
    var $8zOmE;
    var $dDVpf = parcelRequire("dDVpf");
    var $i9HVr = parcelRequire("i9HVr");
    var $k1b3w = parcelRequire("k1b3w");
    var $h48KB = parcelRequire("h48KB");
    var $3lZay = parcelRequire("3lZay");
    class $65aa587f10254513$export$9231831ea16dc281 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isDefaultOpen: false,
                NestedMenu: $k1b3w.default,
                MenuItem: $dDVpf.default
            };
        }
        render() {
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { isMenuOpen: isMenuOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                content: this.renderMenu(),
                isOpen: isMenuOpen,
                placement: "bottom-start",
                onClose: ()=>this.toggleMenu(),
                noPaddings: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: !this.allowGlobalAddIssueForGroups() ? formatMessage((0, $i9HVr.default).addIssueDisabledTooltip) : ''
            }, (0, $3lZay.isCrossTeamPlanningTemplateExperimentEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
                name: (0, (0, parcelRequire("g295Q")).CttSpotlights).CreateIssue
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
                name: (0, (0, parcelRequire("9S2q6")).CtpSpotlights).CreateIssue
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                    label: ""
                }),
                isSelected: isMenuOpen,
                appearance: "link",
                onClick: ()=>this.toggleMenu(),
                isDisabled: !this.allowGlobalAddIssueForGroups(),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $i9HVr.default).createIssue)))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
                name: (0, (0, parcelRequire("g295Q")).CttSpotlights).CreateIssue
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                    label: ""
                }),
                isSelected: isMenuOpen,
                appearance: "link",
                onClick: ()=>this.toggleMenu(),
                isDisabled: !this.allowGlobalAddIssueForGroups(),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $i9HVr.default).createIssue)))));
        }
        constructor(...args){
            super(...args);
            this.state = {
                isMenuOpen: this.props.isDefaultOpen
            };
            this.isPlanGroupedBySingleValueCustomField = ()=>{
                const { customFieldsById: customFieldsById, visualisationGrouping: visualisationGrouping = (0, $TTKUQ.GROUPING).NONE } = this.props;
                if ((0, $cScrq.isRoadmapGroupedByCustomField)(visualisationGrouping)) {
                    const fieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(visualisationGrouping), 10);
                    const customField = customFieldsById[fieldId];
                    if (customField) return (0, $TTKUQ.CustomFields).GroupableSingleValueFields.includes(customField.type.key);
                    return false;
                }
                return false;
            };
            this.allowGlobalAddIssueForGroups = ()=>this.props.visualisationGrouping !== undefined && (0, $h48KB.ISSUE_CREATE_SUPPORTED_GROUPS).includes(this.props.visualisationGrouping) || this.isPlanGroupedBySingleValueCustomField();
            this.getProjectsForCurrentIssueTypeLevel = (level)=>{
                const { projects: projects, enrichedHierarchyLevels: enrichedHierarchyLevels } = this.props;
                const enrichedLevel = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('level', level), enrichedHierarchyLevels);
                const orderedIssueTypes = enrichedLevel ? enrichedLevel.issueTypes : [];
                const currentLevelIssueTypes = orderedIssueTypes.map(({ id: id })=>id);
                return projects.filter((project)=>(0, parcelRequire("4S1OS")).default(project.issueTypeIds, currentLevelIssueTypes).length > 0);
            };
            this.triggerInlineCreateIssueAnalytics = (analyticsEvent, issueTypeId, visualisationGrouping)=>{
                const { customFieldsById: customFieldsById } = this.props;
                const analyticsKey = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CREATED_ISSUE_FROM_HEADER;
                const [actionSubject, eventAction] = analyticsKey.split(' ');
                const grouping = (0, $30sno.getGroupForAnalyticEvent)(visualisationGrouping || '', Object.values(customFieldsById));
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: eventAction,
                    actionSubject: actionSubject
                }), analyticsKey, {
                    issueType: issueTypeId,
                    grouping: grouping
                });
            };
            this.handleCreateClick = (hierarchyLevel, project, clickedGroup, analyticsEvent)=>{
                const { issueTypeId: currentIssueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy, startInlineCreate: startInlineCreate, setIssueTypeIdForHierarchy: setIssueTypeIdForHierarchy, setGlobalCreateIssue: setGlobalCreateIssue, setDefaultProject: setDefaultProject, toggleExpandGroup: toggleExpandGroup, typeToLevel: typeToLevel, visualisationGrouping: visualisationGrouping } = this.props;
                const issueTypeId = (0, $l38L3.getInlineCreateIssueTypeId)(hierarchyLevel.value, project, {
                    issueTypeId: currentIssueTypeId,
                    IssueTypeIdForHierarchy: IssueTypeIdForHierarchy,
                    typeToLevel: typeToLevel
                });
                setIssueTypeIdForHierarchy(hierarchyLevel.value, issueTypeId);
                setGlobalCreateIssue();
                const projectsForCurrentIssueTypeLevel = this.getProjectsForCurrentIssueTypeLevel(hierarchyLevel.value);
                if (clickedGroup) {
                    const { groupCombination: groupCombination, grouping: grouping, group: group, startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup, parentGroup: parentGroup } = clickedGroup;
                    const projectId = grouping === (0, $TTKUQ.PROJECT) && groupCombination && Number(groupCombination.project) || project.id;
                    if (projectsForCurrentIssueTypeLevel.length === 1) setDefaultProject(projectId);
                    if (grouping === (0, $TTKUQ.RELEASE) && parentGroup === (0, $TTKUQ.COMPLETED_RELEASES_GROUP)) toggleExpandGroup({
                        expand: true,
                        groupName: (0, $TTKUQ.COMPLETED_RELEASES_GROUP),
                        grouping: grouping
                    });
                    toggleExpandGroup({
                        expand: true,
                        groupName: group,
                        grouping: grouping
                    });
                    this.triggerInlineCreateIssueAnalytics(analyticsEvent, issueTypeId, visualisationGrouping);
                    startInlineCreate({
                        parentId: null,
                        siblingId: null,
                        hierarchyLevel: hierarchyLevel.value,
                        issueTypeId: issueTypeId,
                        projectId: projectId,
                        source: 'HEADER',
                        groupCombination: groupCombination,
                        grouping: grouping,
                        group: group,
                        startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup
                    });
                } else {
                    if (projectsForCurrentIssueTypeLevel.length === 1) setDefaultProject(project.id);
                    this.triggerInlineCreateIssueAnalytics(analyticsEvent, issueTypeId, visualisationGrouping);
                    startInlineCreate({
                        parentId: null,
                        siblingId: null,
                        hierarchyLevel: hierarchyLevel.value,
                        issueTypeId: issueTypeId,
                        projectId: project.id,
                        source: 'HEADER'
                    });
                }
            };
            this.handleHierarchyItemClick = (item, isDisabled, projectsForLevel, group, analyticsEvent)=>{
                if (!isDisabled) {
                    let project = (0, ($parcel$interopDefault($1sWm7)))(projectsForLevel, [
                        'id',
                        this.props.defaultProjectId
                    ]) || projectsForLevel[0];
                    if (group && group.grouping === (0, $TTKUQ.PROJECT)) project = projectsForLevel.find((p)=>p.id === group.groupCombination?.project);
                    if (!(0, $4nDwW.isDefined)(project)) throw new Error('No project available for this level of hierarchy. It should be disabled in this menu.');
                    else {
                        this.handleCreateClick(item, project, group, analyticsEvent);
                        this.toggleMenu(false);
                    }
                }
            };
            this.renderMenu = ()=>{
                const { intl: intl, projects: projects, typeToLevel: typeToLevel, currentHierarchyLevels: currentHierarchyLevels, visualisationGrouping: visualisationGrouping, groups: groups, MenuItem: MenuItem, NestedMenu: NestedMenu } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.issue-types"
                }, currentHierarchyLevels.map((item)=>{
                    const projectsForLevel = projects.filter((project)=>project.issueTypeIds.some((id)=>typeToLevel(id) === item.value));
                    const isDisabled = projectsForLevel.length === 0 || !item.visible;
                    let tooltipContent = projectsForLevel.length > 0 ? (0, $i9HVr.default).createIssueHiddenEntryTooltip : (0, $i9HVr.default).createIssueTypeDisabledTooltip;
                    if (projectsForLevel.length === 0 && !projects.some((project)=>project.isSimplified === false)) tooltipContent = (0, $i9HVr.default).createIssueTypeDisabledTmpTooltip;
                    return visualisationGrouping === (0, $TTKUQ.GROUPING).NONE ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
                        key: item.id,
                        menuItem: item,
                        isDisabled: isDisabled,
                        tooltip: intl.formatMessage(tooltipContent, {
                            hierarchy: item.title
                        }),
                        onMenuItemClick: (analyticsEvent)=>{
                            this.handleHierarchyItemClick(item, isDisabled, projectsForLevel, undefined, analyticsEvent);
                        }
                    }, item.title) : (0, ($parcel$interopDefault($5uXOq))).createElement(NestedMenu, {
                        key: item.id,
                        hierarchyItem: item,
                        onGroupClick: (group, analyticsEvent)=>{
                            this.handleHierarchyItemClick(item, isDisabled, projectsForLevel, group, analyticsEvent);
                        },
                        isDisabled: isDisabled,
                        groups: groups,
                        projectsForLevel: projectsForLevel,
                        triggerTooltip: intl.formatMessage(tooltipContent, {
                            hierarchy: item.title
                        })
                    });
                }));
            };
            this.toggleMenu = (isOpen)=>{
                if ((0, $4nDwW.isDefined)(isOpen)) this.setState(()=>({
                        isMenuOpen: isOpen
                    }));
                else this.setState((prevState)=>({
                        isMenuOpen: !prevState.isMenuOpen
                    }));
            };
        }
    }
    var $65aa587f10254513$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($65aa587f10254513$export$9231831ea16dc281);
});
parcelRegister("9S2q6", function(module, exports) {
    $parcel$export(module.exports, "CtpSpotlights", ()=>$377b15b17e43b5a6$export$79ec23ebaf903d75);
    const $377b15b17e43b5a6$export$79ec23ebaf903d75 = {
        Inactive: 'INACTIVE',
        Timeline: 'portfolio-3/ctp-onboarding/timeline',
        CreateIssue: 'portfolio-3/ctp-onboarding/create-issue',
        Teams: 'portfolio-3/ctp-onboarding/teams',
        Boards: 'portfolio-3/ctp-onboarding/boards'
    };
});
parcelRegister("30sno", function(module, exports) {
    $parcel$export(module.exports, "standardFieldsGroupings", ()=>$add6e75f7bfaecf5$export$d25b72cbdc75beae);
    $parcel$export(module.exports, "getGroupingCustomFields", ()=>$add6e75f7bfaecf5$export$b0132bc93caced5f);
    $parcel$export(module.exports, "getGroupByStandardFieldLabel", ()=>$add6e75f7bfaecf5$export$a9f5afa48954b6e0);
    $parcel$export(module.exports, "getGroupByCustomFieldLabel", ()=>$add6e75f7bfaecf5$export$89a8e6a87e875167);
    $parcel$export(module.exports, "getGroupForAnalyticEvent", ()=>$add6e75f7bfaecf5$export$5cfef184a69f5b2e);
    var $co1wz;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $ihPUd = parcelRequire("ihPUd");
    const $add6e75f7bfaecf5$var$isGroupableField = (customFieldKey)=>(0, $TTKUQ.CustomFields).GroupableSingleValueFields.includes(customFieldKey) || (0, $TTKUQ.CustomFields).GroupableMultiValueFields.includes(customFieldKey);
    const $add6e75f7bfaecf5$export$d25b72cbdc75beae = (isAtlasConnectInstalled, isEmbedOrMacro)=>({
            [(0, $TTKUQ.GROUPING).NONE]: (0, $ihPUd.default).none,
            [(0, $TTKUQ.GROUPING).ASSIGNEE]: (0, $ihPUd.default).assignee,
            [(0, $TTKUQ.GROUPING).REPORTER]: (0, $ihPUd.default).reporter,
            [(0, $TTKUQ.GROUPING).COMPONENT]: (0, $ihPUd.default).component,
            ...isAtlasConnectInstalled && {
                [(0, $TTKUQ.GROUPING).GOALS]: (0, $ihPUd.default).goals
            },
            ...(0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') && !isEmbedOrMacro && {
                [(0, $TTKUQ.GROUPING).IDEAS]: (0, $ihPUd.default).ideas
            },
            [(0, $TTKUQ.GROUPING).LABEL]: (0, $ihPUd.default).label,
            [(0, $TTKUQ.GROUPING).PROJECT]: (0, $ihPUd.default).project,
            [(0, $TTKUQ.GROUPING).RELEASE]: (0, $ihPUd.default).releases,
            [(0, $TTKUQ.GROUPING).SPRINT]: (0, $ihPUd.default).sprint,
            [(0, $TTKUQ.GROUPING).TEAM]: (0, $ihPUd.default).team
        });
    const $add6e75f7bfaecf5$export$b0132bc93caced5f = (customFields)=>customFields.reduce((acc, customField)=>{
            if ($add6e75f7bfaecf5$var$isGroupableField(customField.type.key)) acc[`customfield_${customField.id}`] = {
                title: customField.title,
                type: customField.type.key
            };
            return acc;
        }, {});
    const $add6e75f7bfaecf5$export$a9f5afa48954b6e0 = (grouping, isEmbedOrMacro)=>$add6e75f7bfaecf5$export$d25b72cbdc75beae(true, isEmbedOrMacro)[grouping];
    const $add6e75f7bfaecf5$export$89a8e6a87e875167 = (grouping, customFields)=>$add6e75f7bfaecf5$export$b0132bc93caced5f(customFields)[grouping]?.title;
    const $add6e75f7bfaecf5$export$5cfef184a69f5b2e = (grouping, customFields)=>{
        if ((0, $cScrq.isRoadmapGroupedByCustomField)(grouping)) return $add6e75f7bfaecf5$export$b0132bc93caced5f(customFields)[grouping]?.type;
        return grouping;
    };
});
parcelRegister("dDVpf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f527611f41db9fd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $1iMQ1;
    var $jaHFv = parcelRequire("jaHFv");
    const $4f527611f41db9fd$var$MenuItem = ({ menuItem: menuItem, isDisabled: isDisabled, isSelected: isSelected, tooltip: tooltip, onMenuItemClick: onMenuItemClick, children: children })=>{
        const innerContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            id: menuItem.id,
            onClick: (_, analyticsEvent)=>{
                onMenuItemClick(analyticsEvent);
            },
            key: menuItem.id,
            isDisabled: isDisabled,
            className: `${$jaHFv["menu-item"]} ${isSelected === true ? $jaHFv.selected : ''}`
        }, children);
        return isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltip || '',
            position: "right"
        }, innerContent) : innerContent;
    };
    var $4f527611f41db9fd$export$2e2bcd8739ae039 = $4f527611f41db9fd$var$MenuItem;
});
parcelRegister("jaHFv", function(module, exports) {
    $parcel$export(module.exports, "menu-item", ()=>$df50d323725a9ac3$export$9aa3f5850e4e7780, (v)=>$df50d323725a9ac3$export$9aa3f5850e4e7780 = v);
    $parcel$export(module.exports, "selected", ()=>$df50d323725a9ac3$export$d90250155de6d7e7, (v)=>$df50d323725a9ac3$export$d90250155de6d7e7 = v);
    var $df50d323725a9ac3$export$9aa3f5850e4e7780;
    var $df50d323725a9ac3$export$d90250155de6d7e7;
    $df50d323725a9ac3$export$9aa3f5850e4e7780 = `lZPKBG_menu-item`;
    $df50d323725a9ac3$export$d90250155de6d7e7 = `lZPKBG_selected`;
});
parcelRegister("i9HVr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5f59c07a09d8890$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a5f59c07a09d8890$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createIssue: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.create-issue",
            "defaultMessage": "Create issue"
        },
        addIssueDisabledTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.add-issue-disabled-tooltip",
            "defaultMessage": "You can create issues for issue groupings where only single values can be set."
        },
        createIssueTypeDisabledTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.create-issue-type-disabled-tooltip",
            "defaultMessage": "This hierarchy level isn\u2019t available for the projects used in this plan. Project admins can add issue types at this hierarchy level in the project settings."
        },
        createIssueTypeDisabledTmpTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.create-issue-type-disabled-tmp-tooltip",
            "defaultMessage": "Add a company-managed project to your plan to use hierarchy levels above epic."
        },
        createIssueHiddenEntryTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.create-issue-hidden-entry-tooltip",
            "defaultMessage": "This level is currently hidden. To create {hierarchy} issues, include this level in the hierarchy range."
        }
    });
});
parcelRegister("k1b3w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b399e8dc419612af$export$2e2bcd8739ae039);
    var $bC2fB;
    var $fZ9p0 = parcelRequire("fZ9p0");
    var $3I7H2 = parcelRequire("3I7H2");
    var $b399e8dc419612af$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $fZ9p0.default), {})((0, $3I7H2.default));
});
parcelRegister("fZ9p0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7b6ab5b8ac5a238$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $e7b6ab5b8ac5a238$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        customFieldsById: (0, $19iju.getCustomFieldsById),
        grouping: (0, $j0XCX.getVisualisationGrouping)
    });
});
parcelRegister("3I7H2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b20170079dcd47e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $J8W7q;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $dDVpf = parcelRequire("dDVpf");
    var $aDYNn = parcelRequire("aDYNn");
    var $huc4B = parcelRequire("huc4B");
    var $3PBtF = parcelRequire("3PBtF");
    var $cjatM = parcelRequire("cjatM");
    var $e3z0h = parcelRequire("e3z0h");
    var $ehRQ2 = parcelRequire("ehRQ2");
    var $bXNgc = parcelRequire("bXNgc");
    class $6b20170079dcd47e$var$NestedMenu extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isDefaultOpen: false,
                AssigneeOptions: $aDYNn.default,
                CustomFieldOptions: $huc4B.default,
                CustomUserPickerOptions: $3PBtF.default,
                MenuItem: $dDVpf.default,
                ProjectOptions: $cjatM.default,
                TeamOptions: $bXNgc.default
            };
        }
        render() {
            const { hierarchyItem: hierarchyItem, isDisabled: isDisabled, triggerTooltip: triggerTooltip, MenuItem: MenuItem } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                key: `${hierarchyItem.id}-nested-dialog`,
                content: this.renderMenuContent(),
                isOpen: this.state.isMenuOpen,
                placement: "right-start",
                onClose: ()=>this.toggleMenu(),
                noPaddings: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
                menuItem: hierarchyItem,
                key: hierarchyItem.id,
                isDisabled: isDisabled,
                tooltip: triggerTooltip,
                isSelected: this.state.isMenuOpen,
                onMenuItemClick: ()=>this.toggleMenu()
            }, hierarchyItem.title));
        }
        constructor(...args){
            super(...args);
            this.state = {
                isMenuOpen: this.props.isDefaultOpen
            };
            this.renderMenuContent = ()=>{
                const { AssigneeOptions: AssigneeOptions, CustomFieldOptions: CustomFieldOptions, CustomUserPickerOptions: CustomUserPickerOptions, grouping: grouping, groups: groups, hierarchyItem: hierarchyItem, onGroupClick: onGroupClick, ProjectOptions: ProjectOptions, projectsForLevel: projectsForLevel, TeamOptions: TeamOptions } = this.props;
                switch(grouping){
                    case (0, $TTKUQ.GROUPING).TEAM:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(TeamOptions, {
                            groups: groups,
                            hierarchyItem: hierarchyItem,
                            onGroupClick: onGroupClick
                        });
                    case (0, $TTKUQ.GROUPING).PROJECT:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(ProjectOptions, {
                            groups: groups,
                            hierarchyItem: hierarchyItem,
                            onGroupClick: onGroupClick,
                            projectsForLevel: projectsForLevel
                        });
                    case (0, $TTKUQ.GROUPING).SPRINT:
                        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, $ehRQ2.default), {
                            groups: groups,
                            hierarchyItem: hierarchyItem,
                            onGroupClick: onGroupClick
                        }));
                    case (0, $TTKUQ.GROUPING).RELEASE:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $e3z0h.default), {
                            groups: groups,
                            hierarchyItem: hierarchyItem,
                            onGroupClick: onGroupClick
                        });
                    case (0, $cScrq.isRoadmapGroupedByCustomField)(grouping) && grouping || '':
                        {
                            const fieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
                            if ((0, $4nDwW.isDefined)(this.props.customFieldsById) && (0, $4nDwW.isDefined)(this.props.customFieldsById[fieldId]) && this.props.customFieldsById[fieldId].type.key === (0, $TTKUQ.CustomFieldTypes).UserPicker) return (0, ($parcel$interopDefault($5uXOq))).createElement(CustomUserPickerOptions, {
                                grouping: grouping,
                                groups: groups,
                                hierarchyItem: hierarchyItem,
                                onGroupClick: onGroupClick
                            });
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(CustomFieldOptions, {
                                grouping: grouping,
                                groups: groups,
                                hierarchyItem: hierarchyItem,
                                onGroupClick: onGroupClick
                            });
                        }
                    default:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(AssigneeOptions, {
                            groups: groups,
                            hierarchyItem: hierarchyItem,
                            onGroupClick: onGroupClick
                        });
                }
            };
            this.toggleMenu = ()=>{
                this.setState((prevState)=>({
                        isMenuOpen: !prevState.isMenuOpen
                    }));
            };
        }
    }
    var $6b20170079dcd47e$export$2e2bcd8739ae039 = $6b20170079dcd47e$var$NestedMenu;
});
parcelRegister("aDYNn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f59279f55cd65644$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5eLTk = parcelRequire("5eLTk");
    var $hplh8 = parcelRequire("hplh8");
    var $g3Een = parcelRequire("g3Een");
    var $f59279f55cd65644$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hplh8.default), (0, $5eLTk.default))((0, $g3Een.default));
});
parcelRegister("5eLTk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$221a94b236fd8aff$export$2e2bcd8739ae039);
    var $8qbLi = parcelRequire("8qbLi");
    const $221a94b236fd8aff$var$mapDispatchToProps = {
        fetchAssigneeList: $8qbLi.fetchAssigneeList
    };
    var $221a94b236fd8aff$export$2e2bcd8739ae039 = $221a94b236fd8aff$var$mapDispatchToProps;
});
parcelRegister("hplh8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80925459ac7f9f5b$export$2e2bcd8739ae039);
    var $hu7Cn = parcelRequire("hu7Cn");
    var $3YtPS = parcelRequire("3YtPS");
    var $80925459ac7f9f5b$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        assigneeListFetchStatus: (0, $hu7Cn.getAssigneeListFetchStatus),
        assignees: (0, $hu7Cn.getAssigneeList)
    });
});
parcelRegister("g3Een", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aea3a624c363d0a2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $1XJ20;
    var $jLI87 = parcelRequire("jLI87");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8QHq4 = parcelRequire("8QHq4");
    var $cn2sU = parcelRequire("cn2sU");
    var $gXGnj = parcelRequire("gXGnj");
    const $aea3a624c363d0a2$export$a21d144588fbaf9d = (assignee, groups)=>{
        const getGroupName = (person)=>{
            const jiraUser = person.jiraUser;
            if (jiraUser.title.toLowerCase() === (0, $jLI87.UNASSIGNED_GROUP)) return 0, $jLI87.UNASSIGNED_GROUP;
            return [
                jiraUser.title,
                jiraUser.email
            ].join(' ');
        };
        const startInlineCreateInEmptyGroup = !groups.some(({ groupCombination: groupCombination })=>groupCombination && groupCombination.assignee === assignee.personId);
        const { title: title, email: email, avatarUrl: avatarUrl } = assignee.jiraUser;
        return {
            group: `assignee-${assignee.personId}`,
            groupCombination: {
                assignee: assignee.personId
            },
            groupName: getGroupName(assignee),
            formattedTitle: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8QHq4.UserSelectItem), {
                email: email,
                label: title,
                icon: avatarUrl
            }),
            grouping: (0, $TTKUQ.GROUPING).ASSIGNEE,
            startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup
        };
    };
    const $aea3a624c363d0a2$export$c2479859c77a8b12 = (assignees, groups)=>assignees.map((person)=>$aea3a624c363d0a2$export$a21d144588fbaf9d(person, groups)).sort((0, $jLI87.groupSortComparator));
    const $aea3a624c363d0a2$var$AssigneeOptions = ({ groups: groups, assignees: assignees, onGroupClick: onGroupClick, hierarchyItem: hierarchyItem, assigneeListFetchStatus: assigneeListFetchStatus, fetchAssigneeList: fetchAssigneeList, defaultLoadingState: defaultLoadingState = true })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(defaultLoadingState);
        (0, $5uXOq.useEffect)(()=>{
            fetchAssigneeList({
                query: ''
            });
        }, [
            fetchAssigneeList
        ]);
        const previousAssigneeListFetchStatus = (0, (0, parcelRequire("1XJ20")).usePrevious)(assigneeListFetchStatus);
        (0, $5uXOq.useEffect)(()=>{
            if (previousAssigneeListFetchStatus === true && assigneeListFetchStatus === false) setIsLoading(false);
        }, [
            assigneeListFetchStatus,
            previousAssigneeListFetchStatus
        ]);
        const queryChange = (query)=>{
            setIsLoading(true);
            fetchAssigneeList({
                query: query
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cn2sU.default), {
            groupOptions: $aea3a624c363d0a2$export$c2479859c77a8b12(assignees, groups),
            hierarchyItem: hierarchyItem,
            searchPlaceholder: formatMessage((0, $gXGnj.default).assigneeSearchPlaceholder),
            onGroupClick: onGroupClick,
            onQueryChange: queryChange,
            isLoading: isLoading
        });
    };
    var $aea3a624c363d0a2$export$2e2bcd8739ae039 = $aea3a624c363d0a2$var$AssigneeOptions;
});
parcelRegister("cn2sU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59c441e85f4f6ca1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $aRoVz;
    var $ousew;
    var $8RXs9;
    var $6SblS;
    var $enoTt;
    var $jLI87 = parcelRequire("jLI87");
    var $4nDwW = parcelRequire("4nDwW");
    var $aIMtT = parcelRequire("aIMtT");
    var $dDVpf = parcelRequire("dDVpf");
    var $klDO7 = parcelRequire("klDO7");
    var $5gMsF = parcelRequire("5gMsF");
    class $59c441e85f4f6ca1$export$b6d9565de1e068cf extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                MenuItem: $dDVpf.default,
                SearchField: $aIMtT.default
            };
        }
        render() {
            const { intl: intl, groupOptions: groupOptions, onGroupClick: onGroupClick, hierarchyItem: hierarchyItem, searchPlaceholder: searchPlaceholder, isLoading: isLoading } = this.props;
            const groupsToDisplay = groupOptions.filter(this.filterGroupsWithSearchQuery);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                placeholder: searchPlaceholder,
                searchQuery: this.state.searchQuery,
                onQueryChange: this.searchOptions
            }), isLoading === true ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5gMsF.spinner
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), {
                size: "medium"
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5gMsF["inline-dialog-child"]
            }, groupsToDisplay.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                title: intl.formatMessage((0, $klDO7.default).where)
            }, groupsToDisplay.map((group, i)=>{
                const { groupName: groupName, groupUrl: groupUrl, isDisabled: isDisabled, formattedTitle: formattedTitle, group: groupKey, groupTooltip: groupTooltip } = group;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dDVpf.default), {
                    menuItem: hierarchyItem,
                    key: `${hierarchyItem.id}-${groupKey}-${i}`,
                    isDisabled: isDisabled,
                    onMenuItemClick: (analyticsEvent)=>onGroupClick(group, analyticsEvent),
                    tooltip: isDisabled === true ? groupTooltip : ''
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5gMsF.option,
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.dialog-content.${groupKey}`
                }, (0, $4nDwW.isDefined)(groupUrl) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5gMsF.avatar
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    size: "xsmall",
                    src: groupUrl
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5gMsF.label
                }, formattedTitle || groupName)));
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5gMsF["no-matches"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $klDO7.default).noMatchFoundText))));
        }
        constructor(...args){
            super(...args);
            this.state = {
                searchQuery: ''
            };
            this.filterGroupsWithSearchQuery = (group)=>{
                const groupName = group.groupName.length ? group.groupName : (0, $jLI87.UNASSIGNED_GROUP);
                return groupName.toLowerCase().includes(this.state.searchQuery.toLowerCase());
            };
            this.searchOptions = (searchQuery)=>{
                const { onQueryChange: onQueryChange } = this.props;
                this.setState(()=>({
                        searchQuery: searchQuery
                    }));
                if (onQueryChange) onQueryChange(searchQuery);
            };
        }
    }
    var $59c441e85f4f6ca1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($59c441e85f4f6ca1$export$b6d9565de1e068cf);
});
parcelRegister("6SblS", function(module, exports) {
    $parcel$export(module.exports, "DialogMenuContainer", ()=>$20e8c05ab3113635$export$be9c07659ee2411d);
    $parcel$export(module.exports, "DialogMenuItem", ()=>$20e8c05ab3113635$export$e0dd179023805e1);
    $parcel$export(module.exports, "DialogMenuGroup", ()=>$20e8c05ab3113635$export$9e580fe6153e8759);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $2veZ9 = parcelRequire("2veZ9");
    function $20e8c05ab3113635$export$be9c07659ee2411d({ children: children, style: style, className: className }) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: style || {},
            className: (0, ($parcel$interopDefault($9ci4W)))($2veZ9.container, className)
        }, children));
    }
    function $20e8c05ab3113635$export$e0dd179023805e1({ children: children, style: style, className: className }) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: style || {},
            className: (0, ($parcel$interopDefault($9ci4W)))($2veZ9.item, className)
        }, children));
    }
    function $20e8c05ab3113635$export$9e580fe6153e8759({ children: children, heading: heading, style: style }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, heading && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $2veZ9["group-heading"],
            style: style || {}
        }, heading), children);
    }
});
parcelRegister("2veZ9", function(module, exports) {
    $parcel$export(module.exports, "container", ()=>$1d2a19cf4bd73bbb$export$34e0f9847d4c02dd, (v)=>$1d2a19cf4bd73bbb$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "group-heading", ()=>$1d2a19cf4bd73bbb$export$5c3275e478379e7c, (v)=>$1d2a19cf4bd73bbb$export$5c3275e478379e7c = v);
    $parcel$export(module.exports, "item", ()=>$1d2a19cf4bd73bbb$export$7061c75fc5af8b7e, (v)=>$1d2a19cf4bd73bbb$export$7061c75fc5af8b7e = v);
    var $1d2a19cf4bd73bbb$export$34e0f9847d4c02dd;
    var $1d2a19cf4bd73bbb$export$5c3275e478379e7c;
    var $1d2a19cf4bd73bbb$export$7061c75fc5af8b7e;
    $1d2a19cf4bd73bbb$export$34e0f9847d4c02dd = `qqZ2EW_container`;
    $1d2a19cf4bd73bbb$export$5c3275e478379e7c = `qqZ2EW_group-heading`;
    $1d2a19cf4bd73bbb$export$7061c75fc5af8b7e = `qqZ2EW_item`;
});
parcelRegister("aIMtT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d83c83b4d82b5159$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $d5Zn3;
    var $47etd;
    var $dC5iT;
    var $kY99m;
    var $cSD7y;
    var $8RXs9;
    var $koVbs;
    var $gJZ5D;
    var $1gQ7U;
    var $6SblS;
    var $grB76 = parcelRequire("grB76");
    var $bZxKO = parcelRequire("bZxKO");
    class $d83c83b4d82b5159$var$SearchFieldOld extends (0, $5uXOq.Component) {
        render() {
            const { placeholder: placeholder, searchQuery: searchQuery, autoFocus: autoFocus = true, ariaLabel: ariaLabel, intl: intl } = this.props;
            const hasInput = searchQuery.length > 0;
            const styleName = (0, ($parcel$interopDefault($9ci4W)))({
                [$bZxKO.hasInput]: hasInput
            });
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                style: {
                    position: 'relative'
                },
                className: styleName
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                autoFocus: autoFocus,
                onChange: this.onChange,
                placeholder: placeholder,
                value: searchQuery,
                "aria-label": ariaLabel
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $bZxKO.clearSearchField,
                style: {
                    display: hasInput ? 'block' : 'none'
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gQ7U")).IconButton), {
                onClick: this.onClear,
                tabIndex: -1,
                ariaLabel: intl.formatMessage((0, $grB76.default).clearButtonLabel)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d5Zn3"))))), {
                label: "",
                size: "small",
                primaryColor: `var(--ds-icon-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N40})`
            })))));
        }
        constructor(...args){
            super(...args);
            this.onChange = (e)=>{
                this.props.onQueryChange(e.target.value);
            };
            this.onClear = ()=>{
                this.props.onQueryChange('');
            };
        }
    }
    const $d83c83b4d82b5159$var$SearchField = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const inputRef = (0, $5uXOq.useRef)(null);
        const { onQueryChange: onQueryChange, placeholder: placeholder, searchQuery: searchQuery, autoFocus: autoFocus = true, ariaLabel: ariaLabel, setInitialFocusRef: setInitialFocusRef } = props;
        (0, $5uXOq.useEffect)(()=>{
            if (setInitialFocusRef) setInitialFocusRef(inputRef.current);
        }, [
            setInitialFocusRef
        ]);
        const onChange = (0, $5uXOq.useCallback)((e)=>{
            onQueryChange(e.target.value);
        }, [
            onQueryChange
        ]);
        const onClear = (0, $5uXOq.useCallback)(()=>{
            onQueryChange('');
        }, [
            onQueryChange
        ]);
        const hasInput = searchQuery.length > 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingInline: "space.200",
            paddingBlock: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            autoFocus: autoFocus,
            onChange: onChange,
            placeholder: placeholder,
            value: searchQuery,
            "aria-label": ariaLabel,
            ref: inputRef,
            elemAfterInput: hasInput ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                padding: "space.100"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gQ7U")).IconButton), {
                onClick: onClear,
                tabIndex: -1,
                ariaLabel: intl.formatMessage((0, $grB76.default).clearButtonLabel)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("47etd"))))), {
                color: `var(--ds-icon-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N40})`,
                label: ""
            }))) : null
        }));
    };
    var $d83c83b4d82b5159$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('migrate_plan_filter_to_popup', $d83c83b4d82b5159$var$SearchField, (0, (0, parcelRequire("8RXs9")).default)($d83c83b4d82b5159$var$SearchFieldOld));
});
parcelRegister("d5Zn3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $988b58f36f60a149$var$_react = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $988b58f36f60a149$var$_crossCircle = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $988b58f36f60a149$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $988b58f36f60a149$var$CrossCircleIcon = (props)=>$988b58f36f60a149$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
        }, props, {
            newIcon: $988b58f36f60a149$var$_crossCircle.default
        }));
    $988b58f36f60a149$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $988b58f36f60a149$var$_default = module.exports.default = $988b58f36f60a149$var$CrossCircleIcon;
});
parcelRegister("1gQ7U", function(module, exports) {
    $parcel$export(module.exports, "IconButton", ()=>$fbf6cc8e79de0577$export$c25acd513dcc8062);
    var $5uXOq = parcelRequire("5uXOq");
    var $aA2jH = parcelRequire("aA2jH");
    const $fbf6cc8e79de0577$export$f173127635a15d2 = {
        small: 16,
        medium: 24,
        large: 32,
        xlarge: 48
    };
    const $fbf6cc8e79de0577$export$c25acd513dcc8062 = ({ children: children, onClick: onClick, ariaLabel: ariaLabel, style: style, tabIndex: tabIndex })=>(0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            onClick: onClick,
            className: $aA2jH.button,
            "aria-label": ariaLabel,
            style: style,
            tabIndex: tabIndex
        }, children);
    $fbf6cc8e79de0577$export$c25acd513dcc8062.displayName = 'IconButton';
});
parcelRegister("aA2jH", function(module, exports) {
    $parcel$export(module.exports, "button", ()=>$7b3f104004304d6c$export$2ba01fb71ed41cb6, (v)=>$7b3f104004304d6c$export$2ba01fb71ed41cb6 = v);
    var $7b3f104004304d6c$export$2ba01fb71ed41cb6;
    $7b3f104004304d6c$export$2ba01fb71ed41cb6 = `WWOkVG_button`;
});
parcelRegister("grB76", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe7b4dd039fdcb8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $afe7b4dd039fdcb8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clearButtonLabel: {
            "id": "portfolio-3-portfolio.common.search-field.clear-button-label",
            "defaultMessage": "clear"
        }
    });
});
parcelRegister("bZxKO", function(module, exports) {
    $parcel$export(module.exports, "clearSearchField", ()=>$8baf930bbe3a77d8$export$b80a961de74058b, (v)=>$8baf930bbe3a77d8$export$b80a961de74058b = v);
    $parcel$export(module.exports, "hasInput", ()=>$8baf930bbe3a77d8$export$303c88434854a784, (v)=>$8baf930bbe3a77d8$export$303c88434854a784 = v);
    var $8baf930bbe3a77d8$export$b80a961de74058b;
    var $8baf930bbe3a77d8$export$303c88434854a784;
    $8baf930bbe3a77d8$export$b80a961de74058b = `_1P5dNa_clearSearchField`;
    $8baf930bbe3a77d8$export$303c88434854a784 = `_1P5dNa_hasInput`;
});
parcelRegister("klDO7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42e968a38943a098$export$2e2bcd8739ae039);
    var $7VHMR;
    var $42e968a38943a098$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        where: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.dialog-content.where",
            "defaultMessage": "Where"
        },
        noMatchFoundText: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.dialog-content.no-match-found-text",
            "defaultMessage": "No matches"
        }
    });
});
parcelRegister("5gMsF", function(module, exports) {
    $parcel$export(module.exports, "avatar", ()=>$3d6409d0fe4ff502$export$345c5736c8054f22, (v)=>$3d6409d0fe4ff502$export$345c5736c8054f22 = v);
    $parcel$export(module.exports, "inline-dialog-child", ()=>$3d6409d0fe4ff502$export$870e10843577b165, (v)=>$3d6409d0fe4ff502$export$870e10843577b165 = v);
    $parcel$export(module.exports, "label", ()=>$3d6409d0fe4ff502$export$1237798dc640739a, (v)=>$3d6409d0fe4ff502$export$1237798dc640739a = v);
    $parcel$export(module.exports, "no-matches", ()=>$3d6409d0fe4ff502$export$9c6a6c8c8d3c5bfb, (v)=>$3d6409d0fe4ff502$export$9c6a6c8c8d3c5bfb = v);
    $parcel$export(module.exports, "option", ()=>$3d6409d0fe4ff502$export$a75d1723e6bda2ec, (v)=>$3d6409d0fe4ff502$export$a75d1723e6bda2ec = v);
    $parcel$export(module.exports, "spinner", ()=>$3d6409d0fe4ff502$export$641374ffb95bc399, (v)=>$3d6409d0fe4ff502$export$641374ffb95bc399 = v);
    var $3d6409d0fe4ff502$export$345c5736c8054f22;
    var $3d6409d0fe4ff502$export$870e10843577b165;
    var $3d6409d0fe4ff502$export$1237798dc640739a;
    var $3d6409d0fe4ff502$export$9c6a6c8c8d3c5bfb;
    var $3d6409d0fe4ff502$export$a75d1723e6bda2ec;
    var $3d6409d0fe4ff502$export$641374ffb95bc399;
    $3d6409d0fe4ff502$export$345c5736c8054f22 = `SOS43G_avatar`;
    $3d6409d0fe4ff502$export$870e10843577b165 = `SOS43G_inline-dialog-child`;
    $3d6409d0fe4ff502$export$1237798dc640739a = `SOS43G_label`;
    $3d6409d0fe4ff502$export$9c6a6c8c8d3c5bfb = `SOS43G_no-matches`;
    $3d6409d0fe4ff502$export$a75d1723e6bda2ec = `SOS43G_option`;
    $3d6409d0fe4ff502$export$641374ffb95bc399 = `SOS43G_spinner`;
});
parcelRegister("gXGnj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$739638af3f9ce153$export$2e2bcd8739ae039);
    var $7VHMR;
    var $739638af3f9ce153$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        assigneeSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.assignee-options.assignee-search-placeholder",
            "defaultMessage": "Find assignees..."
        }
    });
});
parcelRegister("huc4B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d10919457a0dedd$export$2e2bcd8739ae039);
    var $bC2fB;
    var $h1Oyn = parcelRequire("h1Oyn");
    var $i1taF = parcelRequire("i1taF");
    var $5d10919457a0dedd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $h1Oyn.default), {})((0, $i1taF.default));
});
parcelRegister("h1Oyn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$477e4a68202ec0f8$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $3YtPS = parcelRequire("3YtPS");
    var $477e4a68202ec0f8$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectOptions: (0, $19iju.getSelectOptions)
    });
});
parcelRegister("i1taF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aac88e92fa64eaba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jLI87 = parcelRequire("jLI87");
    var $cScrq = parcelRequire("cScrq");
    var $ihPUd = parcelRequire("ihPUd");
    var $cn2sU = parcelRequire("cn2sU");
    var $9o52a = parcelRequire("9o52a");
    var $dGDzg = parcelRequire("dGDzg");
    function $aac88e92fa64eaba$export$2e2bcd8739ae039({ grouping: grouping, groups: groups, hierarchyItem: hierarchyItem, onGroupClick: onGroupClick, selectOptions: selectOptions }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const customFieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
        const groupOptions = (0, $dGDzg.getGroupOptionsFromCustomField)(grouping, groups, selectOptions, customFieldId);
        const unassigned = {
            group: (0, $jLI87.UNDEFINED_GROUP),
            groupCombination: {
                [grouping]: null
            },
            grouping: grouping,
            groupName: formatMessage((0, $ihPUd.default).unassigned),
            isExpanded: true,
            startInlineCreateInEmptyGroup: !groups.some((group)=>group.groupCombination?.[grouping] === null)
        };
        const groupOptionsWithUnassigned = [
            ...groupOptions,
            unassigned
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cn2sU.default), {
            groupOptions: groupOptionsWithUnassigned,
            hierarchyItem: hierarchyItem,
            onGroupClick: onGroupClick,
            searchPlaceholder: formatMessage((0, $9o52a.default).customFieldSearchPlaceholder)
        });
    }
});
parcelRegister("9o52a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4cf9fa4fc864b4a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b4cf9fa4fc864b4a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        customFieldSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.custom-field-options.custom-field-search-placeholder",
            "defaultMessage": "Find options..."
        }
    });
});
parcelRegister("dGDzg", function(module, exports) {
    $parcel$export(module.exports, "getGroupOptionsFromCustomField", ()=>$4a16818ff3bbd548$export$80f35aa6e83126f4);
    var $jLI87 = parcelRequire("jLI87");
    const $4a16818ff3bbd548$var$createGroupOptionFromCustomField = (grouping, groups, selectOption)=>({
            group: `${grouping}-${selectOption.id}`,
            groupCombination: {
                [grouping]: selectOption.id
            },
            grouping: grouping,
            groupName: selectOption.value,
            startInlineCreateInEmptyGroup: !groups.some((group)=>group.groupCombination && group.groupCombination[grouping] === selectOption.id)
        });
    const $4a16818ff3bbd548$export$80f35aa6e83126f4 = (grouping, groups, selectOptions, customFieldId)=>{
        const filteredOptions = selectOptions.filter((selectOption)=>selectOption.fieldId === customFieldId).map((option)=>({
                ...option,
                id: String(option.id)
            }));
        const groupOptions = filteredOptions.map((option)=>$4a16818ff3bbd548$var$createGroupOptionFromCustomField(grouping, groups, option));
        return [
            ...groupOptions.values()
        ].sort((0, $jLI87.groupSortComparator));
    };
});
parcelRegister("3PBtF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0546b3ff6a8080cb$export$2e2bcd8739ae039);
    var $bC2fB;
    var $lTnE3 = parcelRequire("lTnE3");
    var $aHdHi = parcelRequire("aHdHi");
    var $4oTke = parcelRequire("4oTke");
    var $0546b3ff6a8080cb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $aHdHi.default), (0, $lTnE3.default))((0, $4oTke.default));
});
parcelRegister("lTnE3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7f5c996d6b15127$export$2e2bcd8739ae039);
    var $bNKh8 = parcelRequire("bNKh8");
    const $e7f5c996d6b15127$var$mapDispatchToProps = (dispatch)=>({
            fetchUserList: (query)=>{
                dispatch((0, $bNKh8.fetchUserPickerOptions)(query || '', ''));
            }
        });
    var $e7f5c996d6b15127$export$2e2bcd8739ae039 = $e7f5c996d6b15127$var$mapDispatchToProps;
});
parcelRegister("aHdHi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbfc58e17af3dde1$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $3YtPS = parcelRequire("3YtPS");
    var $cbfc58e17af3dde1$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        userList: (0, $19iju.getUserPickerOptionsUserList),
        userPickerUIState: (0, $19iju.getUserPickerUIState)
    });
});
parcelRegister("4oTke", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a180b6cc6b022ea0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $1XJ20;
    var $cn2sU = parcelRequire("cn2sU");
    var $i6VKs = parcelRequire("i6VKs");
    var $2Oc3d = parcelRequire("2Oc3d");
    function $a180b6cc6b022ea0$export$2e2bcd8739ae039({ fetchUserList: fetchUserList, groups: groups, grouping: grouping, hierarchyItem: hierarchyItem, onGroupClick: onGroupClick, userList: userList, userPickerUIState: userPickerUIState }) {
        const { issueId: issueId, isFetchUserListInProgress: isFetchUserListInProgress } = userPickerUIState;
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(isFetchUserListInProgress);
        (0, $5uXOq.useEffect)(()=>{
            fetchUserList('', issueId);
        }, [
            fetchUserList,
            issueId
        ]);
        const previousFetchUserListInProgress = (0, (0, parcelRequire("1XJ20")).usePrevious)(isFetchUserListInProgress);
        (0, $5uXOq.useEffect)(()=>{
            if (previousFetchUserListInProgress === true && isFetchUserListInProgress === false) setIsLoading(false);
        }, [
            isFetchUserListInProgress,
            previousFetchUserListInProgress
        ]);
        const queryChange = (query)=>{
            setIsLoading(true);
            fetchUserList(query, issueId);
        };
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cn2sU.default), {
            groupOptions: (0, $2Oc3d.getGroupOptionsFromUsers)(grouping, groups, userList),
            hierarchyItem: hierarchyItem,
            isLoading: isLoading,
            onGroupClick: onGroupClick,
            onQueryChange: queryChange,
            searchPlaceholder: formatMessage((0, $i6VKs.default).userSearchPlaceholder)
        });
    }
});
parcelRegister("i6VKs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a999d1d0ed46d6e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9a999d1d0ed46d6e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        userSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.custom-user-picker-options.user-search-placeholder",
            "defaultMessage": "Find users..."
        }
    });
});
parcelRegister("2Oc3d", function(module, exports) {
    $parcel$export(module.exports, "getGroupOptionsFromUsers", ()=>$3d5b5852b3a3cf31$export$42081cca51fee3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $hpnKp;
    var $jLI87 = parcelRequire("jLI87");
    var $8QHq4 = parcelRequire("8QHq4");
    const $3d5b5852b3a3cf31$var$createGroupOptionFromUser = (grouping, groups, user)=>{
        const { email: email, icon: icon, label: label, value: value } = user;
        const isUnassigned = (0, parcelRequire("hpnKp")).default(label) === (0, $jLI87.UNASSIGNED_GROUP);
        return {
            formattedTitle: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8QHq4.UserSelectItem), {
                email: email,
                label: label,
                icon: icon
            }),
            group: `${grouping}-${value}`,
            groupCombination: {
                [grouping]: value
            },
            grouping: grouping,
            groupName: isUnassigned ? (0, $jLI87.UNASSIGNED_GROUP) : [
                label,
                email
            ].join(' '),
            startInlineCreateInEmptyGroup: !groups.some((group)=>group.groupCombination && group.groupCombination[grouping] === value)
        };
    };
    const $3d5b5852b3a3cf31$export$42081cca51fee3c = (grouping, groups, userList)=>userList.map((user)=>$3d5b5852b3a3cf31$var$createGroupOptionFromUser(grouping, groups, user)).sort((0, $jLI87.groupSortComparator));
    const $3d5b5852b3a3cf31$export$e2882820f72b6fb0 = ({ jiraUser: { email: email, title: title, avatarUrl: avatarUrl, accountId: accountId } })=>({
            email: email,
            value: accountId,
            label: title,
            icon: avatarUrl
        });
});
parcelRegister("cjatM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$657eb859d9b2026f$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7YpjI = parcelRequire("7YpjI");
    var $dIxyI = parcelRequire("dIxyI");
    var $657eb859d9b2026f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7YpjI.default), {})((0, $dIxyI.default));
});
parcelRegister("7YpjI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b73dd0d92915212$export$2e2bcd8739ae039);
    var $jpXKt = parcelRequire("jpXKt");
    var $3YtPS = parcelRequire("3YtPS");
    var $8b73dd0d92915212$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        projects: (0, $jpXKt.getProjects)
    });
});
parcelRegister("dIxyI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8e6f72f2dfd782e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $jLI87 = parcelRequire("jLI87");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cn2sU = parcelRequire("cn2sU");
    var $cw766 = parcelRequire("cw766");
    class $f8e6f72f2dfd782e$export$10d585c345dfa553 extends (0, $5uXOq.Component) {
        render() {
            const { intl: intl, onGroupClick: onGroupClick, hierarchyItem: hierarchyItem } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cn2sU.default), {
                groupOptions: this.getGroupOptionsFromProjects(),
                hierarchyItem: hierarchyItem,
                searchPlaceholder: intl.formatMessage((0, $cw766.default).projectSearchPlaceholder),
                onGroupClick: onGroupClick
            });
        }
        constructor(...args){
            super(...args);
            this.isProjectDisabled = (projecId)=>this.props.projectsForLevel.every(({ id: id })=>id !== projecId);
            this.createGroupOptionFromProjects = (project)=>{
                const { groups: groups, intl: intl } = this.props;
                const startInlineCreateInEmptyGroup = !groups.some(({ groupCombination: groupCombination })=>groupCombination && groupCombination.project === project.id);
                return {
                    group: `project-${project.id}`,
                    groupCombination: {
                        project: project.id
                    },
                    groupName: project.name,
                    groupUrl: project.avatarUrl || '',
                    grouping: (0, $TTKUQ.GROUPING).PROJECT,
                    startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup,
                    isDisabled: this.isProjectDisabled(project.id),
                    groupTooltip: project.isSimplified ? intl.formatMessage((0, $cw766.default).projectTooltipTmp) : intl.formatMessage((0, $cw766.default).projectTooltip)
                };
            };
            this.getGroupOptionsFromProjects = ()=>{
                const { projects: projects } = this.props;
                return projects.map(this.createGroupOptionFromProjects).sort((0, $jLI87.groupSortComparator));
            };
        }
    }
    var $f8e6f72f2dfd782e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($f8e6f72f2dfd782e$export$10d585c345dfa553);
});
parcelRegister("cw766", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a3c5d6951d61dae$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9a3c5d6951d61dae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.project-options.project-tooltip",
            "defaultMessage": "This issue type doesn\u2019t exist in this project. Ask your project admin to create this issue type for the project."
        },
        projectTooltipTmp: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.project-options.project-tooltip-tmp",
            "defaultMessage": "This hierarchy level can\u2019t be created in a team-managed project."
        },
        projectSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.project-options.project-search-placeholder",
            "defaultMessage": "Find projects..."
        }
    });
});
parcelRegister("e3z0h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6344408001ae1b60$export$2e2bcd8739ae039);
    var $bC2fB;
    var $gPeGw = parcelRequire("gPeGw");
    var $5wzS3 = parcelRequire("5wzS3");
    var $6344408001ae1b60$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $gPeGw.default), {})((0, $5wzS3.default));
});
parcelRegister("gPeGw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a91eca2469f4289$export$2e2bcd8739ae039);
    var $9FFuD = parcelRequire("9FFuD");
    var $3YtPS = parcelRequire("3YtPS");
    var $8a91eca2469f4289$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        enrichedVersions: (0, $9FFuD.getEnrichedVersions),
        enrichedVersionsById: (0, $9FFuD.getEnrichedVersionsById),
        completeVersionsById: (0, $9FFuD.getCompletedVersionsById)
    });
});
parcelRegister("5wzS3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$75ea6f16d121fc48$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jLI87 = parcelRequire("jLI87");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $9JcB7 = parcelRequire("9JcB7");
    var $fYZO2 = parcelRequire("fYZO2");
    function $75ea6f16d121fc48$export$2e2bcd8739ae039({ groups: groups, hierarchyItem: hierarchyItem, onGroupClick: onGroupClick, enrichedVersions: enrichedVersions, enrichedVersionsById: enrichedVersionsById, completeVersionsById: completeVersionsById, ReleaseDialogContent: ReleaseDialogContent = (0, $9JcB7.default) }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const groupOptionsFromReleasesByProject = (0, $fYZO2.getGroupOptionsFromReleasesByProject)({
            groups: groups,
            enrichedVersions: enrichedVersions,
            enrichedVersionsById: enrichedVersionsById,
            completeVersionsById: completeVersionsById
        });
        const unassigned = {
            groupName: formatMessage((0, $ihPUd.default).unassigned),
            grouping: (0, $TTKUQ.GROUPING).RELEASE,
            isExpanded: true,
            group: (0, $jLI87.UNDEFINED_GROUP),
            groupCombination: {
                release: null
            },
            startInlineCreateInEmptyGroup: !groups.some(({ group: group })=>group === (0, $jLI87.UNDEFINED_GROUP))
        };
        const groupOptionsWithUnassigned = [
            ...groupOptionsFromReleasesByProject,
            [
                null,
                [
                    unassigned
                ]
            ]
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ReleaseDialogContent, {
            groupOptions: groupOptionsWithUnassigned,
            hierarchyItem: hierarchyItem,
            onGroupClick: onGroupClick
        });
    }
});
parcelRegister("9JcB7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44ff313e14f7c37c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7iRDZ = parcelRequire("7iRDZ");
    var $cYIQb = parcelRequire("cYIQb");
    var $44ff313e14f7c37c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7iRDZ.default), {})((0, $cYIQb.default));
});
parcelRegister("7iRDZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51392eb2febb8e08$export$2e2bcd8739ae039);
    var $jpXKt = parcelRequire("jpXKt");
    var $3YtPS = parcelRequire("3YtPS");
    var $51392eb2febb8e08$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        projectsById: (0, $jpXKt.getProjectsById)
    });
});
parcelRegister("cYIQb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4574bbe4e95561c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aRoVz;
    var $ousew;
    var $koVbs;
    var $6SblS;
    var $jLI87 = parcelRequire("jLI87");
    var $dDVpf = parcelRequire("dDVpf");
    var $ihPUd = parcelRequire("ihPUd");
    var $aIMtT = parcelRequire("aIMtT");
    var $1H0kh = parcelRequire("1H0kh");
    var $efEfI = parcelRequire("efEfI");
    var $gPWcZ = parcelRequire("gPWcZ");
    function $4574bbe4e95561c4$export$2e2bcd8739ae039({ groupOptions: groupOptions, onGroupClick: onGroupClick, onQueryChange: onQueryChange, hierarchyItem: hierarchyItem, projectsById: projectsById }) {
        const [searchQuery, setSearchQuery] = (0, $5uXOq.useState)('');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const filterGroupsWithSearchQuery = (group)=>{
            const groupName = group.groupName.length ? group.groupName : (0, $jLI87.UNASSIGNED_GROUP);
            return groupName.toLowerCase().includes(searchQuery.toLowerCase());
        };
        const searchOptions = (searchQuery)=>{
            setSearchQuery(searchQuery);
            if (onQueryChange) onQueryChange(searchQuery);
        };
        const groupOptionsEntries = groupOptions.sort((0, $gPWcZ.projectToGroupMapComparator));
        const renderGroupOptions = ()=>{
            const groupOptions = groupOptionsEntries.map(([projectId, groups])=>{
                const groupsToDisplay = groups.filter(filterGroupsWithSearchQuery).sort((0, $jLI87.groupSortComparator));
                if (groupsToDisplay.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                    key: projectId,
                    title: projectId !== null ? projectsById[projectId.toString()].name : formatMessage((0, $ihPUd.default).unassigned)
                }, groupsToDisplay.map((group, i)=>{
                    const { groupName: groupName, isDisabled: isDisabled, formattedTitle: formattedTitle, group: groupKey } = group;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dDVpf.default), {
                        menuItem: hierarchyItem,
                        key: `${hierarchyItem.id}-${groupKey}-${i}`,
                        isDisabled: isDisabled,
                        onMenuItemClick: (analyticsEvent)=>onGroupClick(group, analyticsEvent)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.dialog-content.${groupKey}`
                    }, formattedTitle || groupName));
                }));
                return null;
            });
            if (groupOptions.every((el)=>el === null)) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $efEfI["no-matches"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).noMatchFoundText)));
            return groupOptions;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
            placeholder: formatMessage((0, $1H0kh.default).releaseSearchPlaceholder),
            searchQuery: searchQuery,
            onQueryChange: searchOptions
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $efEfI["inline-dialog-child"]
        }, renderGroupOptions()));
    }
});
parcelRegister("1H0kh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51300d8e8ae9a66d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $51300d8e8ae9a66d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releaseSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.release-options.release-dialog-content.release-search-placeholder",
            "defaultMessage": "Find releases..."
        }
    });
});
parcelRegister("efEfI", function(module, exports) {
    $parcel$export(module.exports, "inline-dialog-child", ()=>$a601b0b1f4e38864$export$870e10843577b165, (v)=>$a601b0b1f4e38864$export$870e10843577b165 = v);
    $parcel$export(module.exports, "no-matches", ()=>$a601b0b1f4e38864$export$9c6a6c8c8d3c5bfb, (v)=>$a601b0b1f4e38864$export$9c6a6c8c8d3c5bfb = v);
    var $a601b0b1f4e38864$export$870e10843577b165;
    var $a601b0b1f4e38864$export$9c6a6c8c8d3c5bfb;
    $a601b0b1f4e38864$export$870e10843577b165 = `pqcCAG_inline-dialog-child`;
    $a601b0b1f4e38864$export$9c6a6c8c8d3c5bfb = `pqcCAG_no-matches`;
});
parcelRegister("gPWcZ", function(module, exports) {
    $parcel$export(module.exports, "projectToGroupMapComparator", ()=>$a7dbb9c8b1d40820$export$82790021fe06eb0b);
    const $a7dbb9c8b1d40820$export$82790021fe06eb0b = (a, b)=>{
        if (a[0] === null) return -1;
        if (b[0] === null) return 1;
        if (a[0] < b[0]) return -1;
        if (a[0] > b[0]) return 1;
        return 0;
    };
});
parcelRegister("fYZO2", function(module, exports) {
    $parcel$export(module.exports, "getGroupOptionsFromReleasesByProject", ()=>$46ccfdb010eea687$export$1bc27696314dd171);
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $46ccfdb010eea687$export$1bc27696314dd171 = ({ groups: groups, enrichedVersionsById: enrichedVersionsById, enrichedVersions: enrichedVersions, completeVersionsById: completeVersionsById })=>{
        const createGroupOptionFromRelease = (release)=>({
                group: `release-${release.id}`,
                groupCombination: {
                    release: release.id
                },
                groupName: release.name,
                grouping: (0, $TTKUQ.GROUPING).RELEASE,
                startInlineCreateInEmptyGroup: true,
                parentGroup: (0, $4nDwW.isDefined)(completeVersionsById[release.id]) ? (0, $TTKUQ.COMPLETED_RELEASES_GROUP) : undefined
            });
        const projectToGroupOptionsMap = new Map();
        const processedReleaseIds = new Set();
        for (const group of groups){
            const { scope: scope, ...groupOption } = group;
            if ((0, $4nDwW.isDefined)(groupOption.groupCombination) && (0, $4nDwW.isDefined)(groupOption.groupCombination.release)) {
                const enrichedVersion = enrichedVersionsById[groupOption.groupCombination.release];
                processedReleaseIds.add(groupOption.groupCombination.release);
                if (enrichedVersion !== undefined) {
                    const projectId = enrichedVersion.projects[0].id;
                    const [, releasesArray] = projectToGroupOptionsMap.get(projectId) ?? [
                        undefined,
                        []
                    ];
                    projectToGroupOptionsMap.set(projectId, [
                        projectId,
                        [
                            ...releasesArray,
                            groupOption
                        ]
                    ]);
                }
            }
        }
        for (const release of enrichedVersions)if (!processedReleaseIds.has(release.id)) {
            const option = createGroupOptionFromRelease(release);
            const projectId = release.projects[0].id;
            const [, releasesArray] = projectToGroupOptionsMap.get(projectId) ?? [
                undefined,
                []
            ];
            projectToGroupOptionsMap.set(projectId, [
                projectId,
                [
                    ...releasesArray,
                    option
                ]
            ]);
        }
        return [
            ...projectToGroupOptionsMap.values()
        ];
    };
});
parcelRegister("ehRQ2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85505df77cf98bb5$export$2e2bcd8739ae039);
    var $bC2fB;
    var $k0zpl = parcelRequire("k0zpl");
    var $dZX1t = parcelRequire("dZX1t");
    var $85505df77cf98bb5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $k0zpl.default), {})((0, $dZX1t.default));
});
parcelRegister("k0zpl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64c5882249cb51b2$export$2e2bcd8739ae039);
    var $d3quy = parcelRequire("d3quy");
    var $3YtPS = parcelRequire("3YtPS");
    var $64c5882249cb51b2$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        sprints: (0, $d3quy.getAllSprints),
        sprintsByIdMap: (0, $d3quy.getAllSprintsByIdMap),
        externalSprintsById: (0, $d3quy.getExternalSprintsById)
    });
});
parcelRegister("dZX1t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f73c8df69987ffa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $jLI87 = parcelRequire("jLI87");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $eQMm4 = parcelRequire("eQMm4");
    var $3RsgK = parcelRequire("3RsgK");
    function $6f73c8df69987ffa$export$2e2bcd8739ae039({ onGroupClick: onGroupClick, hierarchyItem: hierarchyItem, groups: groups, sprints: sprints, sprintsByIdMap: sprintsByIdMap, externalSprintsById: externalSprintsById, SprintDialogContent: SprintDialogContent = (0, $eQMm4.default) }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const unassigned = {
            groupName: formatMessage((0, $ihPUd.default).unassigned),
            grouping: (0, $TTKUQ.GROUPING).SPRINT,
            isExpanded: true,
            group: (0, $jLI87.UNDEFINED_GROUP),
            groupCombination: {
                sprint: null
            },
            startInlineCreateInEmptyGroup: !groups.some(({ group: group })=>group === (0, $jLI87.UNDEFINED_GROUP))
        };
        const groupOptions = (0, $3RsgK.getGroupOptionsFromSprints)({
            groups: groups,
            sprints: sprints,
            sprintsByIdMap: sprintsByIdMap,
            externalSprintsById: externalSprintsById
        });
        const groupOptionsWithUnassigned = [
            ...groupOptions,
            [
                null,
                [
                    unassigned
                ]
            ]
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement(SprintDialogContent, {
            groupOptions: groupOptionsWithUnassigned,
            hierarchyItem: hierarchyItem,
            onGroupClick: onGroupClick
        });
    }
});
parcelRegister("eQMm4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fcbff9a52c85a79d$export$2e2bcd8739ae039);
    var $bC2fB;
    var $inax0 = parcelRequire("inax0");
    var $d1yvP = parcelRequire("d1yvP");
    var $fcbff9a52c85a79d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $inax0.default), {})((0, $d1yvP.default));
});
parcelRegister("inax0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b6b794f31225e54$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    var $4b6b794f31225e54$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        issueSourcesById: (0, $bHTqr.getIssueSourcesById)
    });
});
parcelRegister("d1yvP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e66b9855603a6afe$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aRoVz;
    var $ousew;
    var $koVbs;
    var $6SblS;
    var $jLI87 = parcelRequire("jLI87");
    var $dDVpf = parcelRequire("dDVpf");
    var $ihPUd = parcelRequire("ihPUd");
    var $aIMtT = parcelRequire("aIMtT");
    var $3xzQd = parcelRequire("3xzQd");
    var $5rn3y = parcelRequire("5rn3y");
    var $iOkoR = parcelRequire("iOkoR");
    function $e66b9855603a6afe$export$2e2bcd8739ae039({ issueSourcesById: issueSourcesById, groupOptions: groupOptions, onGroupClick: onGroupClick, onQueryChange: onQueryChange, hierarchyItem: hierarchyItem, MenuItem: MenuItem = (0, $dDVpf.default) }) {
        const [searchQuery, setSearchQuery] = (0, $5uXOq.useState)('');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const filterGroupsWithSearchQuery = (group)=>{
            const groupName = group.groupName.length ? group.groupName : (0, $jLI87.UNASSIGNED_GROUP);
            return groupName.toLowerCase().includes(searchQuery.toLowerCase());
        };
        const searchOptions = (searchQuery)=>{
            setSearchQuery(searchQuery);
            if (onQueryChange) onQueryChange(searchQuery);
        };
        const groupOptionsEntries = groupOptions.sort((0, $iOkoR.projectToGroupMapComparator));
        const renderGroupOptions = ()=>{
            const groupOptions = groupOptionsEntries.map(([issueSourceId, groups])=>{
                const groupsToDisplay = groups.filter(filterGroupsWithSearchQuery).sort((0, $jLI87.groupSortComparator));
                if (groupsToDisplay.length > 0) {
                    let title = '';
                    if (issueSourceId !== null && issueSourceId !== undefined) title = issueSourcesById[issueSourceId].title;
                    else if (issueSourceId === null) title = formatMessage((0, $ihPUd.default).unassigned);
                    else if (issueSourceId === undefined) title = formatMessage((0, $3xzQd.default).externalSource);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                        key: issueSourceId,
                        title: title
                    }, groupsToDisplay.map((group, i)=>{
                        const { groupName: groupName, isDisabled: isDisabled, formattedTitle: formattedTitle, group: groupKey } = group;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
                            menuItem: hierarchyItem,
                            key: `${hierarchyItem.id}-${groupKey}-${i}`,
                            isDisabled: isDisabled,
                            onMenuItemClick: (analyticsEvent)=>onGroupClick(group, analyticsEvent),
                            tooltip: isDisabled === true ? formatMessage((0, $3xzQd.default).sprintTooltip) : ''
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.dialog-content.${groupKey}`
                        }, formattedTitle || groupName));
                    }));
                }
                return null;
            });
            if (groupOptions.every((el)=>el === null)) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5rn3y["no-matches"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).noMatchFoundText)));
            return groupOptions;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
            placeholder: formatMessage((0, $3xzQd.default).sprintSearchPlaceholder),
            searchQuery: searchQuery,
            onQueryChange: searchOptions
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $5rn3y["inline-dialog-child"]
        }, renderGroupOptions()));
    }
});
parcelRegister("3xzQd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d23e27fb92d5b3a4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d23e27fb92d5b3a4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        externalSource: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.sprint-options.sprint-dialog-content.external-source",
            "defaultMessage": "External"
        },
        sprintSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.sprint-options.sprint-dialog-content.sprint-search-placeholder",
            "defaultMessage": "Find sprints..."
        },
        sprintTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.sprint-options.sprint-dialog-content.sprint-tooltip",
            "defaultMessage": "You can't create issues for external and completed sprints."
        }
    });
});
parcelRegister("5rn3y", function(module, exports) {
    $parcel$export(module.exports, "inline-dialog-child", ()=>$3f615bd9cac1b9b1$export$870e10843577b165, (v)=>$3f615bd9cac1b9b1$export$870e10843577b165 = v);
    $parcel$export(module.exports, "no-matches", ()=>$3f615bd9cac1b9b1$export$9c6a6c8c8d3c5bfb, (v)=>$3f615bd9cac1b9b1$export$9c6a6c8c8d3c5bfb = v);
    var $3f615bd9cac1b9b1$export$870e10843577b165;
    var $3f615bd9cac1b9b1$export$9c6a6c8c8d3c5bfb;
    $3f615bd9cac1b9b1$export$870e10843577b165 = `cuQn0G_inline-dialog-child`;
    $3f615bd9cac1b9b1$export$9c6a6c8c8d3c5bfb = `cuQn0G_no-matches`;
});
parcelRegister("iOkoR", function(module, exports) {
    $parcel$export(module.exports, "projectToGroupMapComparator", ()=>$43b7e7a27e907b7a$export$82790021fe06eb0b);
    const $43b7e7a27e907b7a$export$82790021fe06eb0b = (a, b)=>{
        if (a[0] === null || b[0] === undefined) return -1;
        if (b[0] === null || a[0] === undefined) return 1;
        if (a[0] < b[0]) return -1;
        if (a[0] > b[0]) return 1;
        return 0;
    };
});
parcelRegister("3RsgK", function(module, exports) {
    $parcel$export(module.exports, "getGroupOptionsFromSprints", ()=>$2586b3d51ff41702$export$89bc41e026c5e43a);
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $2586b3d51ff41702$export$89bc41e026c5e43a = ({ groups: groups, sprints: sprints, sprintsByIdMap: sprintsByIdMap, externalSprintsById: externalSprintsById })=>{
        const isSprintExternal = (sprintId)=>(0, $4nDwW.isDefined)(externalSprintsById[sprintId]);
        const createGroupOptionFromSprint = (sprint)=>({
                group: `sprint-${sprint.id}`,
                groupCombination: {
                    sprint: sprint.id
                },
                groupName: sprint.title,
                grouping: (0, $TTKUQ.GROUPING).SPRINT,
                startInlineCreateInEmptyGroup: true,
                isDisabled: isSprintExternal(sprint.id)
            });
        const sourceIdToGroupOptionsMap = new Map();
        const processedSprintIds = new Set();
        for (const group of groups){
            const { scope: scope, ...groupOption } = group;
            if ((0, $4nDwW.isDefined)(groupOption.groupCombination) && (0, $4nDwW.isDefined)(groupOption.groupCombination.sprint) && !processedSprintIds.has(groupOption.groupCombination.sprint) && sprintsByIdMap[groupOption.groupCombination.sprint].state !== (0, $TTKUQ.SPRINT_STATES).CLOSED) {
                const sprintId = groupOption.groupCombination.sprint;
                processedSprintIds.add(groupOption.groupCombination.sprint);
                const sprint = sprintsByIdMap[sprintId];
                if (sprint === undefined) throw Error('Illegal state - sprint was not found in map of ids to sprints');
                const issueSourceId = sprint.issueSources[0] !== undefined ? sprint.issueSources[0] : undefined;
                const [, sprintOptions] = sourceIdToGroupOptionsMap.get(issueSourceId) ?? [
                    undefined,
                    []
                ];
                const sprintOption = {
                    ...groupOption,
                    isDisabled: !!((0, $4nDwW.isDefined)(groupOption.groupCombination) && (0, $4nDwW.isDefined)(groupOption.groupCombination.sprint) && isSprintExternal(groupOption.groupCombination.sprint))
                };
                sourceIdToGroupOptionsMap.set(issueSourceId, [
                    issueSourceId,
                    [
                        ...sprintOptions,
                        sprintOption
                    ]
                ]);
            }
        }
        for (const sprint of sprints)if (!processedSprintIds.has(sprint.id) && sprint.state !== (0, $TTKUQ.SPRINT_STATES).CLOSED) {
            const option = createGroupOptionFromSprint(sprint);
            const issueSourceId = sprint.issueSources !== undefined ? sprint.issueSources[0] : undefined;
            const [, sprintOptions] = sourceIdToGroupOptionsMap.get(issueSourceId) ?? [
                undefined,
                []
            ];
            const sprintOption = {
                ...option,
                isDisabled: !!isSprintExternal(sprint.id)
            };
            sourceIdToGroupOptionsMap.set(issueSourceId, [
                issueSourceId,
                [
                    ...sprintOptions,
                    sprintOption
                ]
            ]);
        }
        return [
            ...sourceIdToGroupOptionsMap.values()
        ];
    };
});
parcelRegister("bXNgc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4e0d8e1f0e86f71$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4QeJA = parcelRequire("4QeJA");
    var $S3kcE = parcelRequire("S3kcE");
    var $f4e0d8e1f0e86f71$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $4QeJA.default), {})((0, $S3kcE.default));
});
parcelRegister("4QeJA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95fea3f17ff31aaa$export$2e2bcd8739ae039);
    var $dRVQG = parcelRequire("dRVQG");
    var $3YtPS = parcelRequire("3YtPS");
    var $95fea3f17ff31aaa$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        additionalTeamsById: (0, $dRVQG.getAdditionalTeamsById),
        teams: (0, $dRVQG.getTeams)
    });
});
parcelRegister("S3kcE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9df7f2e47fed49a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $jLI87 = parcelRequire("jLI87");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $cn2sU = parcelRequire("cn2sU");
    var $foCGR = parcelRequire("foCGR");
    class $d9df7f2e47fed49a$export$fb0ff90f6708321 extends (0, $5uXOq.Component) {
        render() {
            const { intl: intl, onGroupClick: onGroupClick, hierarchyItem: hierarchyItem } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cn2sU.default), {
                groupOptions: this.getGroupOptionsFromTeams(),
                hierarchyItem: hierarchyItem,
                searchPlaceholder: intl.formatMessage((0, $foCGR.default).teamSearchPlaceholder),
                onGroupClick: onGroupClick
            });
        }
        constructor(...args){
            super(...args);
            this.isTeamDisabled = (teamId)=>(0, $4nDwW.isDefined)(this.props.additionalTeamsById[teamId]);
            this.createGroupOptionFromTeam = (tooltipMessage, team)=>({
                    group: `team-${team.id}`,
                    groupCombination: {
                        team: team.id
                    },
                    groupName: team.title,
                    groupUrl: team.avatarUrl || '',
                    grouping: (0, $TTKUQ.GROUPING).TEAM,
                    startInlineCreateInEmptyGroup: true,
                    groupTooltip: tooltipMessage,
                    isDisabled: this.isTeamDisabled(team.id)
                });
            this.getGroupOptionsFromTeams = ()=>{
                const { groups: groups, teams: teams, intl: intl } = this.props;
                const tooltipMessage = intl.formatMessage((0, $foCGR.default).teamTooltip);
                const unassigned = {
                    groupName: intl.formatMessage((0, $ihPUd.default).unassigned),
                    grouping: 'TEAM',
                    isExpanded: true,
                    group: (0, $jLI87.UNDEFINED_GROUP),
                    groupCombination: {
                        team: null
                    },
                    startInlineCreateInEmptyGroup: !groups.some(({ group: group })=>group === (0, $jLI87.UNDEFINED_GROUP)),
                    groupUrl: '',
                    groupTooltip: tooltipMessage
                };
                const groupOptions = new Map();
                for (const group of groups){
                    const { scope: scope, ...groupOption } = group;
                    if (groupOption.groupCombination) groupOptions.set(groupOption.groupCombination.team, {
                        ...groupOption,
                        groupTooltip: tooltipMessage,
                        isDisabled: !!(groupOption.groupCombination && groupOption.groupCombination.team && this.isTeamDisabled(groupOption.groupCombination.team))
                    });
                }
                for (const team of teams)if (!groupOptions.has(team.id)) {
                    const option = this.createGroupOptionFromTeam(tooltipMessage, team);
                    groupOptions.set(team.id, option);
                }
                groupOptions.set(null, unassigned);
                return [
                    ...groupOptions.values()
                ].sort((0, $jLI87.groupSortComparator));
            };
        }
    }
    var $d9df7f2e47fed49a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($d9df7f2e47fed49a$export$fb0ff90f6708321);
});
parcelRegister("foCGR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$674a6d5d63ffcdb3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $674a6d5d63ffcdb3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        teamTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.team-options.team-tooltip",
            "defaultMessage": "You can't create issues for external teams."
        },
        teamSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.team-options.team-search-placeholder",
            "defaultMessage": "Find teams..."
        }
    });
});
parcelRegister("h48KB", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_CREATE_SUPPORTED_GROUPS", ()=>$d1171294f733842f$export$68650f863e35e955);
    var $TTKUQ = parcelRequire("TTKUQ");
    const $d1171294f733842f$export$68650f863e35e955 = [
        (0, $TTKUQ.GROUPING).NONE,
        (0, $TTKUQ.GROUPING).ASSIGNEE,
        (0, $TTKUQ.GROUPING).REPORTER,
        (0, $TTKUQ.GROUPING).PROJECT,
        (0, $TTKUQ.GROUPING).RELEASE,
        (0, $TTKUQ.GROUPING).SPRINT,
        (0, $TTKUQ.GROUPING).TEAM
    ];
});
parcelRegister("3lZay", function(module, exports) {
    $parcel$export(module.exports, "isCrossTeamPlanningTemplateExperimentEnabled", ()=>$6716abe3bf1b2bd2$export$5d06510124eb14f8);
    var $6s1PB;
    const $6716abe3bf1b2bd2$export$5d06510124eb14f8 = ()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('second_premium_template_experiment', 'cohort', 'variation');
});
parcelRegister("41xwO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79311a2122d3c8bc$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7S4n0 = parcelRequire("7S4n0");
    var $ez2c6 = parcelRequire("ez2c6");
    var $79311a2122d3c8bc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7S4n0.default), {})((0, $ez2c6.default));
});
parcelRegister("7S4n0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab579de02ad61f79$export$2e2bcd8739ae039);
    var $6Ayrn = parcelRequire("6Ayrn");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $jpXKt = parcelRequire("jpXKt");
    var $3YtPS = parcelRequire("3YtPS");
    var $ab579de02ad61f79$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        cpVersionsForSelectedIssues: (0, $bI9dZ.getCPRsForSelectedIssues),
        hierarchyRange: (0, $6Ayrn.getHierarchyRange),
        projectsById: (0, $jpXKt.getProjectsById),
        selectedIssues: (0, $bI9dZ.getSelectedIssues)
    });
});
parcelRegister("ez2c6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b63457579a6d79e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $80afZ = parcelRequire("80afZ");
    var $fVnbM;
    var $6Ingq;
    var $3bDjY;
    var $co1wz;
    var $koVbs;
    var $1iMQ1;
    var $i2qlb = parcelRequire("i2qlb");
    var $eJyeb = parcelRequire("eJyeb");
    var $4nDwW = parcelRequire("4nDwW");
    var $idmiV = parcelRequire("idmiV");
    var $8zOmE;
    var $4zfGl = parcelRequire("4zfGl");
    var $7Ijuo = parcelRequire("7Ijuo");
    var $9FYuw = parcelRequire("9FYuw");
    var $lX5Hj = parcelRequire("lX5Hj");
    var $eT8Ym = parcelRequire("eT8Ym");
    const $1b63457579a6d79e$var$DROPMENU_ITEMS = [
        'setAssignee',
        'dates',
        'setEstimate',
        'setLabel',
        'setParent',
        'setRank',
        'setReleases',
        'setSprint',
        'setTeam'
    ].map((key)=>(0, $eT8Ym.DROPMENU_MAP)[key]);
    const $1b63457579a6d79e$var$MORE_DROPMENU_ITEMS = [
        'bulkChange',
        'removeFromPlanTitle'
    ].map((key)=>(0, $eT8Ym.DROPMENU_MAP)[key]);
    const $1b63457579a6d79e$export$9cf433a293bbef79 = (0, $5uXOq.memo)(({ selectedIssues: selectedIssues, projectsById: projectsById, ...props })=>{
        const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
        const [isDialogOpen, setIsDialogOpen] = (0, $5uXOq.useState)(false);
        const [optionSelected, setOptionSelected] = (0, $5uXOq.useState)(null);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const toggleModalDialog = (0, $5uXOq.useCallback)((isDialogOpen)=>{
            setIsDialogOpen(isDialogOpen);
        }, []);
        const buildUrl = (0, $5uXOq.useCallback)(()=>{
            const issueKeys = (0, ($parcel$interopDefault($80afZ)))(selectedIssues, ({ project: projectId, issueKey: issueKey })=>{
                const project = projectsById[projectId];
                if (!issueKey) return undefined;
                return `${project.key}-${issueKey}`;
            });
            const encodedIds = encodeURIComponent(issueKeys.filter((key)=>key).toString());
            return (0, $eJyeb.proxyContextSafeUrl)(`/secure/GHBulkChange.jspa?issueKeys=${encodedIds}`);
        }, [
            projectsById,
            selectedIssues
        ]);
        const sendIDtoJira = (0, $5uXOq.useCallback)(()=>{
            (0, $idmiV.openInNewTab)(buildUrl());
            setIsMenuOpen((isMenuOpen)=>!isMenuOpen);
        }, [
            buildUrl
        ]);
        const selectOption = (0, $5uXOq.useCallback)((dropOption, analyticsEvent)=>{
            if (analyticsEvent) {
                const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_OPTION_SELECTED.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: eventAction,
                    actionSubject: actionSubject
                }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_OPTION_SELECTED, {
                    selectedOption: dropOption.analyticsId
                });
            }
            if (dropOption.type === (0, $lX5Hj.BULK_CHANGE)) {
                sendIDtoJira();
                return;
            }
            setIsMenuOpen(false);
            setIsDialogOpen(true);
            setOptionSelected(dropOption);
        }, [
            sendIDtoJira
        ]);
        const renderOneItem = (0, $5uXOq.useCallback)((getDropOption)=>{
            const option = getDropOption({
                selectedIssues: selectedIssues,
                projectsById: projectsById,
                ...props
            });
            const { label: label, disabled: disabled, analyticsId: analyticsId, disabledTooltip: disabledTooltip } = option;
            const title = formatMessage(label);
            const tooltip = (0, $4nDwW.isDefined)(disabled) && disabled && disabledTooltip ? formatMessage(disabledTooltip) : '';
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: tooltip,
                key: title,
                position: "bottom"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.drop-menu-item.${analyticsId}`,
                onClick: (_, analyticsEvent)=>selectOption(option, analyticsEvent),
                isDisabled: disabled
            }, title));
        }, [
            formatMessage,
            projectsById,
            selectedIssues,
            selectOption,
            props
        ]);
        const toggleMenu = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            if (analyticsEvent) {
                const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_CLICKED.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: eventAction,
                    actionSubject: actionSubject
                }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_CLICKED, {
                    selectedIssues: selectedIssues.length,
                    isMenuOpen: !isMenuOpen
                });
            }
            setIsMenuOpen((isMenuOpen)=>!isMenuOpen);
        }, [
            selectedIssues,
            isMenuOpen
        ]);
        const fireBulkActionSuccessAnalytics = (0, $5uXOq.useCallback)((analyticsEvent, selectedOption)=>{
            if (analyticsEvent) {
                const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_ACTION_SUCCEEDED.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: eventAction,
                    actionSubject: actionSubject
                }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_ACTION_SUCCEEDED, {
                    selectedOption: selectedOption,
                    selectedIssues: selectedIssues.length
                });
            }
        }, [
            selectedIssues.length
        ]);
        const renderDialog = (0, $5uXOq.useCallback)(()=>{
            const Dialog = optionSelected && optionSelected.dialog;
            if (!isDialogOpen || !optionSelected || !Dialog) return null;
            switch(optionSelected.type){
                case 0, $lX5Hj.SET_DATES:
                case 0, $lX5Hj.REMOVE_FROM_PLAN:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(Dialog, {
                        toggleModalDialog: ()=>toggleModalDialog(!isDialogOpen),
                        bulkActionSuccess: (analyticsEvent)=>fireBulkActionSuccessAnalytics(analyticsEvent, optionSelected.analyticsId)
                    });
                default:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(Dialog, {
                        toggleModalDialog: ()=>toggleModalDialog(!isDialogOpen),
                        UpdateAttributeForm: (0, $7Ijuo.default),
                        bulkActionSuccess: (analyticsEvent)=>fireBulkActionSuccessAnalytics(analyticsEvent, optionSelected.analyticsId)
                    });
            }
        }, [
            fireBulkActionSuccessAnalytics,
            isDialogOpen,
            optionSelected,
            toggleModalDialog
        ]);
        const onOpenChange = ({ isOpen: isOpen })=>{
            if (!isOpen) setIsMenuOpen(false);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).default), {
            isOpen: isMenuOpen,
            onOpenChange: onOpenChange,
            placement: "bottom-end",
            shouldRenderToParent: (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? false : undefined,
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...props,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: ""
                    }),
                    onClick: toggleMenu,
                    ref: triggerRef,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions"
                }, formatMessage((0, $9FYuw.default).bulkActions))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4zfGl.default), {
            dropMenuItems: $1b63457579a6d79e$var$DROPMENU_ITEMS.map(renderOneItem),
            moreDropMenuItems: $1b63457579a6d79e$var$MORE_DROPMENU_ITEMS.map(renderOneItem)
        })), renderDialog());
    });
    var $1b63457579a6d79e$export$2e2bcd8739ae039 = $1b63457579a6d79e$export$9cf433a293bbef79;
});
parcelRegister("4zfGl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$391e9bfe44bb1ad7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aRoVz;
    var $koVbs;
    var $99IIr = parcelRequire("99IIr");
    const $391e9bfe44bb1ad7$var$BulkActionsMenu = (0, $5uXOq.memo)(({ dropMenuItems: dropMenuItems, moreDropMenuItems: moreDropMenuItems })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-actions-menu.menu-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            title: formatMessage((0, $99IIr.default).setFieldGroupTitle)
        }, dropMenuItems), moreDropMenuItems && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            title: formatMessage((0, $99IIr.default).moreActionsGroupTitle)
        }, moreDropMenuItems));
    });
    var $391e9bfe44bb1ad7$export$2e2bcd8739ae039 = $391e9bfe44bb1ad7$var$BulkActionsMenu;
});
parcelRegister("99IIr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e31aa0b94a09fd4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6e31aa0b94a09fd4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setFieldGroupTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-actions-menu.set-field-group-title",
            "defaultMessage": "Update"
        },
        moreActionsGroupTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-actions-menu.more-actions-group-title",
            "defaultMessage": "More actions"
        }
    });
});
parcelRegister("7Ijuo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5636ae6af0e2e7ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $ujWmd;
    var $7O4UO;
    var $qfj8c;
    var $8RBk4;
    var $3bDjY;
    var $ousew;
    var $8RXs9;
    var $aCpcO;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $iqIcG;
    var $lX5Hj = parcelRequire("lX5Hj");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $fFMsx = parcelRequire("fFMsx");
    var $2P2Xq = parcelRequire("2P2Xq");
    var $6vp59 = parcelRequire("6vp59");
    var $5mXps = parcelRequire("5mXps");
    class $5636ae6af0e2e7ba$export$3f0525cbd1b0a680 extends (0, $5uXOq.Component) {
        render() {
            const { onCancel: onCancel, currentValue: currentValue, currentIssueTypeIcon: currentIssueTypeIcon, avatarIcon: avatarIcon, shouldFitContainerWidth: shouldFitContainerWidth } = this.props;
            const currentContent = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5mXps["value-placeholder"]
            }, currentIssueTypeIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5mXps["issue-type-icon"],
                style: {
                    backgroundSize: 'contain',
                    backgroundImage: `url(${currentIssueTypeIcon})`
                }
            }) : null, avatarIcon && (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $5mXps.avatar
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "xsmall",
                src: avatarIcon
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5mXps["current-value-title"]
            }, currentValue));
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { fieldValue: fieldValue } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
                className: `${$5mXps["form-group"]} ${shouldFitContainerWidth ? $5mXps["should-fit-full-width"] : ''}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5mXps["current-value"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5mXps["value-label"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).current)), currentValue ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: currentValue
            }, currentContent) : currentContent), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5mXps.icon
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                label: ""
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $5mXps["new-value"]
            }, this.getFormField())), (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
                className: $5mXps["form-footer"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                appearance: "subtle",
                onClick: onCancel
            }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                appearance: "primary",
                isDisabled: (0, parcelRequire("3nPAF")).default(fieldValue),
                onClick: (_, analyticsEvent)=>{
                    this.submitForm(analyticsEvent);
                }
            }, formatMessage((0, $ihPUd.default).apply))));
        }
        constructor(...args){
            super(...args);
            this.state = {
                fieldValue: {}
            };
            this.submitForm = (analyticsEvent)=>{
                const { onSubmit: onSubmit } = this.props;
                const { fieldValue: fieldValue } = this.state;
                const normalizedData = Object.keys(fieldValue).reduce((acc, curr)=>{
                    if (curr === 'fixVersions') return Object.assign(acc, {
                        [curr]: fieldValue[curr] && fieldValue[curr] !== (0, $TTKUQ.NONE) ? [
                            fieldValue[curr]
                        ] : []
                    });
                    return Object.assign(acc, {
                        [curr]: fieldValue[curr] === (0, $TTKUQ.NONE) ? null : fieldValue[curr]
                    });
                }, {});
                onSubmit(normalizedData, analyticsEvent);
            };
            this.handleOnChange = (fieldId, fieldValue)=>{
                this.setState({
                    fieldValue: {
                        [fieldId]: fieldValue
                    }
                });
            };
            this.getFormField = ()=>{
                const { intl: { formatMessage: formatMessage }, options: options = [], updatedAttributeType: updatedAttributeType, warningMessage: warningMessage } = this.props;
                const noneOption = {
                    label: formatMessage((0, $ihPUd.default).none),
                    value: (0, $TTKUQ.NONE)
                };
                switch(updatedAttributeType){
                    case 0, $lX5Hj.SET_ASSIGNEE:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2P2Xq.default), {
                            autofocus: true,
                            defaultValue: undefined,
                            id: "assignee",
                            label: formatMessage((0, $ihPUd.default).new),
                            name: "assignee",
                            onChange: (id, value)=>{
                                this.handleOnChange(id, value);
                            },
                            placeholder: formatMessage((0, $6vp59.default).chooseAssigneePlaceholder)
                        });
                    case 0, $lX5Hj.MOVE_ISSUES:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                            isRequired: true,
                            label: formatMessage((0, $ihPUd.default).new),
                            name: "parent",
                            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.common.update-attribute-form.move-issues-field"
                        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                                defaultValue: undefined,
                                formatOptionLabel: (0, (0, parcelRequire("iqIcG")).selectIssueOption),
                                "aria-label": formatMessage((0, $6vp59.default).chooseParentPlaceholder),
                                classNamePrefix: "move_issues_field",
                                onChange: (option)=>{
                                    this.handleOnChange('parent', option?.value);
                                },
                                options: options,
                                placeholder: formatMessage((0, $6vp59.default).chooseParentPlaceholder),
                                styles: {
                                    menu: (base)=>({
                                            ...base,
                                            minWidth: '300px',
                                            maxWidth: '560px',
                                            width: 'auto'
                                        }),
                                    option: (base)=>({
                                            ...base,
                                            width: 'auto'
                                        }),
                                    singleValue: (styles)=>({
                                            ...styles,
                                            width: '100%'
                                        })
                                }
                            }), warningMessage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, warningMessage)));
                    case 0, $lX5Hj.SET_RELEASE:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                            isRequired: true,
                            label: formatMessage((0, $ihPUd.default).new),
                            name: "fixVersions",
                            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.common.update-attribute-form.set-release-field"
                        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                                autoFocus: true,
                                defaultValue: undefined,
                                formatOptionLabel: (0, $fFMsx.formatReleaseOptionLabel),
                                classNamePrefix: "set_release_field",
                                "aria-label": formatMessage((0, $6vp59.default).chooseReleasePlaceholder),
                                onChange: (option)=>{
                                    this.handleOnChange('fixVersions', option?.value);
                                },
                                options: [
                                    {
                                        options: [
                                            noneOption
                                        ]
                                    },
                                    ...options
                                ],
                                placeholder: formatMessage((0, $6vp59.default).chooseReleasePlaceholder)
                            }));
                    case 0, $lX5Hj.SET_CP_RELEASE:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                            isRequired: true,
                            label: formatMessage((0, $ihPUd.default).new),
                            name: "crossProjectVersion",
                            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.common.update-attribute-form.set-cp-release-field"
                        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                                autoFocus: true,
                                defaultValue: undefined,
                                "aria-label": formatMessage((0, $6vp59.default).chooseCrossProjectReleasePlaceholder),
                                classNamePrefix: "cp_release_field",
                                onChange: (option)=>{
                                    this.handleOnChange('crossProjectVersion', option?.value);
                                },
                                options: [
                                    noneOption,
                                    ...options
                                ],
                                placeholder: formatMessage((0, $6vp59.default).chooseCrossProjectReleasePlaceholder)
                            }));
                    case 0, $lX5Hj.SET_SPRINT:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                            isRequired: true,
                            label: formatMessage((0, $ihPUd.default).new),
                            name: "sprint",
                            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.common.update-attribute-form.set-sprint-field"
                        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                                autoFocus: true,
                                defaultValue: undefined,
                                "aria-label": formatMessage((0, $6vp59.default).chooseSprintPlaceholder),
                                classNamePrefix: "set_sprint_field",
                                onChange: (option)=>{
                                    this.handleOnChange('sprint', option?.value);
                                },
                                options: options,
                                placeholder: formatMessage((0, $6vp59.default).chooseSprintPlaceholder)
                            }));
                    case 0, $lX5Hj.SET_TEAM:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                            isRequired: true,
                            label: formatMessage((0, $ihPUd.default).new),
                            name: "team",
                            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.common.update-attribute-form.set-team-field"
                        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                                autoFocus: true,
                                defaultValue: undefined,
                                "aria-label": formatMessage((0, $6vp59.default).chooseTeamPlaceholder),
                                classNamePrefix: "set_team_field",
                                onChange: (option)=>{
                                    this.handleOnChange('team', option?.value);
                                },
                                options: [
                                    noneOption,
                                    ...options
                                ],
                                placeholder: formatMessage((0, $6vp59.default).chooseTeamPlaceholder)
                            }));
                    default:
                        return undefined;
                }
            };
        }
    }
    var $5636ae6af0e2e7ba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($5636ae6af0e2e7ba$export$3f0525cbd1b0a680);
});
parcelRegister("lX5Hj", function(module, exports) {
    $parcel$export(module.exports, "MODAL_DIALOG_WIDTH", ()=>$e33101d2d691a699$export$ba66d00f212e494);
    $parcel$export(module.exports, "SET_ASSIGNEE", ()=>$e33101d2d691a699$export$6814b7b3aea6ee01);
    $parcel$export(module.exports, "SET_ESTIMATE", ()=>$e33101d2d691a699$export$c2ccd34996aa2a3);
    $parcel$export(module.exports, "SET_LABEL", ()=>$e33101d2d691a699$export$8b170d320d746e17);
    $parcel$export(module.exports, "REMOVE_FROM_PLAN", ()=>$e33101d2d691a699$export$2a334e9fa63b0d35);
    $parcel$export(module.exports, "SET_RELEASE", ()=>$e33101d2d691a699$export$807382b6c265578e);
    $parcel$export(module.exports, "SET_CP_RELEASE", ()=>$e33101d2d691a699$export$572de3870cb71834);
    $parcel$export(module.exports, "SET_TEAM", ()=>$e33101d2d691a699$export$e470dd4ae2dbd706);
    $parcel$export(module.exports, "SET_DATES", ()=>$e33101d2d691a699$export$de056ff7f72d62f8);
    $parcel$export(module.exports, "SET_RANK", ()=>$e33101d2d691a699$export$6f51da72f6b60191);
    $parcel$export(module.exports, "SET_SPRINT", ()=>$e33101d2d691a699$export$26f77f93871b8908);
    $parcel$export(module.exports, "MOVE_ISSUES", ()=>$e33101d2d691a699$export$5a7b1cdb33fc8269);
    $parcel$export(module.exports, "BULK_CHANGE", ()=>$e33101d2d691a699$export$66cb530046350ea5);
    const $e33101d2d691a699$export$ba66d00f212e494 = 640;
    const $e33101d2d691a699$export$6814b7b3aea6ee01 = 'roadmap.scope.header.bulk-actions.SET_ASSIGNEE';
    const $e33101d2d691a699$export$c2ccd34996aa2a3 = 'roadmap.scope.header.bulk-actions.SET_ESTIMATE';
    const $e33101d2d691a699$export$8b170d320d746e17 = 'roadmap.scope.header.bulk-actions.SET_LABEL';
    const $e33101d2d691a699$export$2a334e9fa63b0d35 = 'roadmap.scope.header.bulk-actions.REMOVE_FROM_PLAN';
    const $e33101d2d691a699$export$807382b6c265578e = 'roadmap.scope.header.bulk-actions.SET_RELEASE';
    const $e33101d2d691a699$export$572de3870cb71834 = 'roadmap.scope.header.bulk-actions.SET_CP_RELEASE';
    const $e33101d2d691a699$export$e470dd4ae2dbd706 = 'roadmap.scope.header.bulk-actions.SET_TEAM';
    const $e33101d2d691a699$export$de056ff7f72d62f8 = 'roadmap.scope.header.bulk-actions.SET_DATES';
    const $e33101d2d691a699$export$6f51da72f6b60191 = 'roadmap.scope.header.bulk-actions.SET_RANK';
    const $e33101d2d691a699$export$26f77f93871b8908 = 'roadmap.scope.header.bulk-actions.SET_SPRINT';
    const $e33101d2d691a699$export$5a7b1cdb33fc8269 = 'roadmap.scope.header.bulk-actions.MOVE_ISSUES';
    const $e33101d2d691a699$export$66cb530046350ea5 = 'roadmap.scope.header.bulk-actions.BULK_CHANGE';
});
parcelRegister("2P2Xq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fb92d7ea4744afd$export$2e2bcd8739ae039);
    var $8qbLi = parcelRequire("8qbLi");
    var $bC2fB;
    var $lOlvm = parcelRequire("lOlvm");
    var $9IMpE = parcelRequire("9IMpE");
    const $0fb92d7ea4744afd$var$mapDispatchToProps = {
        fetchAssigneeList: $8qbLi.fetchAssigneeList
    };
    var $0fb92d7ea4744afd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $lOlvm.default), $0fb92d7ea4744afd$var$mapDispatchToProps)((0, $9IMpE.default));
});
parcelRegister("lOlvm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63532a9022683bd2$export$2e2bcd8739ae039);
    var $hu7Cn = parcelRequire("hu7Cn");
    var $3YtPS = parcelRequire("3YtPS");
    var $63532a9022683bd2$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        assigneeListFetchStatus: (0, $hu7Cn.getAssigneeListFetchStatus),
        assignees: (0, $hu7Cn.getAssigneeList)
    });
});
parcelRegister("9IMpE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be843b2f24b56b18$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7O4UO;
    var $9174a = parcelRequire("9174a");
    var $4nDwW = parcelRequire("4nDwW");
    var $cSDJf = parcelRequire("cSDJf");
    var $8QHq4 = parcelRequire("8QHq4");
    class $be843b2f24b56b18$var$AssigneeSelectField extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { fetchAssigneeList: fetchAssigneeList } = this.props;
            fetchAssigneeList({
                query: ''
            });
        }
        render() {
            const { assigneeListFetchStatus: assigneeListFetchStatus, assignees: assignees, autofocus: autofocus, defaultValue: defaultValue, id: id, label: label, name: name, placeholder: placeholder, required: required, value: value } = this.props;
            const options = (0, $9174a.transformPersons)((0, $9174a.sort)(assignees));
            const selectedValue = options.find(({ value: optValue })=>optValue === value);
            const defaultSelectedValue = options.find(({ value: optValue })=>optValue === defaultValue);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                isRequired: required,
                key: `${id}-field`,
                label: label,
                name: name
            }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $cSDJf.default), {
                    ...fieldProps,
                    autoFocus: autofocus,
                    defaultValue: defaultSelectedValue,
                    formatOptionLabel: (0, $8QHq4.formatOptionLabel),
                    isLoading: assigneeListFetchStatus,
                    isTransparentBackground: false,
                    key: id,
                    menuPlacement: "auto",
                    onChange: this.onUserChange,
                    onInputChange: this.onInputChange,
                    options: options,
                    placeholder: placeholder,
                    value: selectedValue
                }));
        }
        constructor(...args){
            super(...args);
            this.onUserChange = (value)=>{
                const { onChange: onChange, id: id } = this.props;
                const update = (0, $4nDwW.isDefined)(value) && value.value || value;
                onChange(id, update);
            };
            this.onInputChange = (currentFilter, { action: action })=>{
                if (action === 'input-change') {
                    const { fetchAssigneeList: fetchAssigneeList } = this.props;
                    fetchAssigneeList({
                        query: currentFilter
                    });
                }
            };
        }
    }
    var $be843b2f24b56b18$export$2e2bcd8739ae039 = $be843b2f24b56b18$var$AssigneeSelectField;
});
parcelRegister("6vp59", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37f39fcf52d67788$export$2e2bcd8739ae039);
    var $37f39fcf52d67788$export$2e2bcd8739ae039 = {
        chooseAssigneePlaceholder: {
            id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-assignee-placeholder',
            defaultMessage: 'Choose an assignee',
            description: 'Placeholder for assignee picklist'
        },
        chooseParentPlaceholder: {
            id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-parent-placeholder',
            defaultMessage: 'Choose a parent',
            description: 'Placeholder for parent picklist'
        },
        chooseReleasePlaceholder: {
            id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-release-placeholder',
            defaultMessage: 'Choose a release',
            description: 'Placeholder for release picklist'
        },
        chooseCrossProjectReleasePlaceholder: {
            id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-cross-project-release-placeholder',
            defaultMessage: 'Choose a cross-project release',
            description: 'Placeholder for cross-project release picklist'
        },
        chooseSprintPlaceholder: {
            id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-sprint-placeholder',
            defaultMessage: 'Choose a sprint',
            description: 'Placeholder for sprint picklist'
        },
        chooseTeamPlaceholder: {
            id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-team-placeholder',
            defaultMessage: 'Choose a team',
            description: 'Placeholder for team picklist'
        }
    };
});
parcelRegister("5mXps", function(module, exports) {
    $parcel$export(module.exports, "avatar", ()=>$3e8d175a6706eed8$export$345c5736c8054f22, (v)=>$3e8d175a6706eed8$export$345c5736c8054f22 = v);
    $parcel$export(module.exports, "current-value", ()=>$3e8d175a6706eed8$export$bd70860eb87e972b, (v)=>$3e8d175a6706eed8$export$bd70860eb87e972b = v);
    $parcel$export(module.exports, "current-value-title", ()=>$3e8d175a6706eed8$export$2c19fd1221dd0b06, (v)=>$3e8d175a6706eed8$export$2c19fd1221dd0b06 = v);
    $parcel$export(module.exports, "form-footer", ()=>$3e8d175a6706eed8$export$536347ba10a26096, (v)=>$3e8d175a6706eed8$export$536347ba10a26096 = v);
    $parcel$export(module.exports, "form-group", ()=>$3e8d175a6706eed8$export$55a1f87a143fb302, (v)=>$3e8d175a6706eed8$export$55a1f87a143fb302 = v);
    $parcel$export(module.exports, "icon", ()=>$3e8d175a6706eed8$export$1ca1ec8b29a4ce27, (v)=>$3e8d175a6706eed8$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "issue-type-icon", ()=>$3e8d175a6706eed8$export$175e354db6e532ed, (v)=>$3e8d175a6706eed8$export$175e354db6e532ed = v);
    $parcel$export(module.exports, "new-value", ()=>$3e8d175a6706eed8$export$18786265e3bc6811, (v)=>$3e8d175a6706eed8$export$18786265e3bc6811 = v);
    $parcel$export(module.exports, "should-fit-full-width", ()=>$3e8d175a6706eed8$export$1ba12f97147feb87, (v)=>$3e8d175a6706eed8$export$1ba12f97147feb87 = v);
    $parcel$export(module.exports, "value-label", ()=>$3e8d175a6706eed8$export$f2febdad47edd01a, (v)=>$3e8d175a6706eed8$export$f2febdad47edd01a = v);
    $parcel$export(module.exports, "value-placeholder", ()=>$3e8d175a6706eed8$export$16d768213d218756, (v)=>$3e8d175a6706eed8$export$16d768213d218756 = v);
    var $3e8d175a6706eed8$export$345c5736c8054f22;
    var $3e8d175a6706eed8$export$bd70860eb87e972b;
    var $3e8d175a6706eed8$export$2c19fd1221dd0b06;
    var $3e8d175a6706eed8$export$536347ba10a26096;
    var $3e8d175a6706eed8$export$55a1f87a143fb302;
    var $3e8d175a6706eed8$export$1ca1ec8b29a4ce27;
    var $3e8d175a6706eed8$export$175e354db6e532ed;
    var $3e8d175a6706eed8$export$18786265e3bc6811;
    var $3e8d175a6706eed8$export$1ba12f97147feb87;
    var $3e8d175a6706eed8$export$f2febdad47edd01a;
    var $3e8d175a6706eed8$export$16d768213d218756;
    $3e8d175a6706eed8$export$345c5736c8054f22 = `OU0D_a_avatar`;
    $3e8d175a6706eed8$export$bd70860eb87e972b = `OU0D_a_current-value`;
    $3e8d175a6706eed8$export$2c19fd1221dd0b06 = `OU0D_a_current-value-title`;
    $3e8d175a6706eed8$export$536347ba10a26096 = `OU0D_a_form-footer`;
    $3e8d175a6706eed8$export$55a1f87a143fb302 = `OU0D_a_form-group`;
    $3e8d175a6706eed8$export$1ca1ec8b29a4ce27 = `OU0D_a_icon`;
    $3e8d175a6706eed8$export$175e354db6e532ed = `OU0D_a_issue-type-icon`;
    $3e8d175a6706eed8$export$18786265e3bc6811 = `OU0D_a_new-value`;
    $3e8d175a6706eed8$export$1ba12f97147feb87 = `OU0D_a_should-fit-full-width`;
    $3e8d175a6706eed8$export$f2febdad47edd01a = `OU0D_a_value-label`;
    $3e8d175a6706eed8$export$16d768213d218756 = `OU0D_a_value-placeholder`;
});
parcelRegister("9FYuw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34305fa6ddafc0c4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $34305fa6ddafc0c4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        bulkActions: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-actions",
            "defaultMessage": "Bulk actions"
        },
        bulkChange: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-change",
            "defaultMessage": "Bulk change in Jira"
        },
        bulkChangeInJiraTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-change-in-jira-tooltip",
            "defaultMessage": "All selected issues must already be saved in Jira"
        },
        issueLimitExceededTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.issue-limit-exceeded-tooltip",
            "defaultMessage": "Maximum 100 issues"
        },
        setFieldGroupTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-field-group-title",
            "defaultMessage": "Update"
        },
        setParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-parent",
            "defaultMessage": "Parent"
        },
        setRank: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-rank",
            "defaultMessage": "Rank"
        },
        setTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-team",
            "defaultMessage": "Team"
        },
        setSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-sprint",
            "defaultMessage": "Sprint"
        },
        labels: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.labels",
            "defaultMessage": "Labels"
        },
        moreActionsGroupTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.more-actions-group-title",
            "defaultMessage": "More actions"
        },
        removeFromPlanTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.remove-from-plan-title",
            "defaultMessage": "Remove from plan"
        },
        releaseMenuItemTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.release-menu-item-tooltip",
            "defaultMessage": "To set the release, the selected issues must belong to the same project, or there must be a cross-project release that has releases from all associated projects."
        },
        releaseDisabledMenuItemTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.release-disabled-menu-item-tooltip",
            "defaultMessage": "To set the release, the selected issues must belong to project that has releases enabled."
        },
        issuesSameLevelTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.issues-same-level-tooltip",
            "defaultMessage": "To move multiple issues to another parent issue, the issues must be of the same hierarchy level"
        },
        issuesTopLevelTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.issues-top-level-tooltip",
            "defaultMessage": "One of the selected issues is already of the topmost hierarchy level, so it's not possible to move this any higher"
        },
        teamMenuItemTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.team-menu-item-tooltip",
            "defaultMessage": "A sub-task is assigned to the same team as its parent story. To change this team, reassign the parent story instead."
        },
        sprintMenuItemTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.sprint-menu-item-tooltip",
            "defaultMessage": "A sub-task is assigned to the same sprint as its parent story. To change its sprint, change the sprint of the parent story instead"
        }
    });
});
parcelRegister("eT8Ym", function(module, exports) {
    $parcel$export(module.exports, "DROPMENU_MAP", ()=>$fe4b88a6b2273e11$export$c00c4ecb0f3e16f2);
    var $3nPAF;
    var $c12LJ;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $b6bIB = parcelRequire("b6bIB");
    var $jIMle = parcelRequire("jIMle");
    var $8yYHR = parcelRequire("8yYHR");
    var $BMPYY = parcelRequire("BMPYY");
    var $euy7m = parcelRequire("euy7m");
    var $bI6DQ = parcelRequire("bI6DQ");
    var $jr6pW = parcelRequire("jr6pW");
    var $iUDPw = parcelRequire("iUDPw");
    var $7FPZL = parcelRequire("7FPZL");
    var $bnORa = parcelRequire("bnORa");
    var $eTADi = parcelRequire("eTADi");
    var $9FYuw = parcelRequire("9FYuw");
    var $lX5Hj = parcelRequire("lX5Hj");
    const $fe4b88a6b2273e11$export$71f5d920f9b29ebb = (selectedIssues)=>{
        if (selectedIssues && selectedIssues.length) return !selectedIssues.some((issue)=>issue.level !== selectedIssues[0].level);
        return false;
    };
    const $fe4b88a6b2273e11$export$559c788e8799af86 = (selectedIssues, hierarchyRange)=>{
        if (selectedIssues && selectedIssues.length) return selectedIssues.some((issue)=>issue.level === hierarchyRange.max);
        return false;
    };
    const $fe4b88a6b2273e11$export$f9c983cc2430c4f3 = (selectedIssues)=>{
        if (selectedIssues && selectedIssues.length) return selectedIssues.some((issue)=>issue.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL));
        return false;
    };
    const $fe4b88a6b2273e11$export$53f3d8e656ab0334 = (selectedIssues)=>{
        if (selectedIssues && selectedIssues.length) return selectedIssues.some(({ id: id })=>id.includes((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX)));
        return false;
    };
    const $fe4b88a6b2273e11$export$e8b24162d7fa01b5 = (selectedIssues)=>{
        if (selectedIssues && selectedIssues.length) return selectedIssues.length > (0, $TTKUQ.MAX_BULK_CHANGE_ISSUES);
        return false;
    };
    const $fe4b88a6b2273e11$export$8ac58c2734f0faf8 = (selectedIssues)=>{
        if (selectedIssues && selectedIssues.length) return !selectedIssues.some((issue)=>issue.project !== selectedIssues[0].project);
        return false;
    };
    const $fe4b88a6b2273e11$export$d285b37749fb1894 = (selectedIssues, projectsById)=>{
        if (selectedIssues && selectedIssues.length) return selectedIssues.some((issue)=>projectsById[issue.project]?.isReleasesEnabled !== true);
        return false;
    };
    const $fe4b88a6b2273e11$export$c00c4ecb0f3e16f2 = {
        setAssignee: ()=>({
                type: (0, $lX5Hj.SET_ASSIGNEE),
                label: (0, $ihPUd.default).assignee,
                dialog: (0, $jIMle.default),
                analyticsId: 'Assignee'
            }),
        dates: ()=>({
                type: (0, $lX5Hj.SET_DATES),
                label: (0, $ihPUd.default).dates,
                dialog: (0, $BMPYY.default),
                analyticsId: 'Dates'
            }),
        setEstimate: ()=>({
                type: (0, $lX5Hj.SET_ESTIMATE),
                label: (0, $ihPUd.default).estimate,
                dialog: (0, $euy7m.default),
                analyticsId: 'Estimate'
            }),
        setLabel: ()=>({
                type: (0, $lX5Hj.SET_LABEL),
                label: (0, $9FYuw.default).labels,
                dialog: (0, $bI6DQ.default),
                analyticsId: 'Labels'
            }),
        setParent: ({ selectedIssues: selectedIssues, hierarchyRange: hierarchyRange })=>{
            const isSameLevel = $fe4b88a6b2273e11$export$71f5d920f9b29ebb(selectedIssues);
            const isTopLevel = $fe4b88a6b2273e11$export$559c788e8799af86(selectedIssues, hierarchyRange);
            const disabled = !isSameLevel && isTopLevel;
            const disabledTooltip = isSameLevel ? (0, $9FYuw.default).issuesTopLevelTooltip : (0, $9FYuw.default).issuesSameLevelTooltip;
            return {
                type: (0, $lX5Hj.MOVE_ISSUES),
                label: (0, $9FYuw.default).setParent,
                disabled: disabled,
                disabledTooltip: disabledTooltip,
                dialog: (0, $jr6pW.default),
                analyticsId: 'Parent'
            };
        },
        setRank: ()=>({
                type: (0, $lX5Hj.SET_RANK),
                label: (0, $9FYuw.default).setRank,
                dialog: (0, $iUDPw.default),
                analyticsId: 'Rank'
            }),
        setReleases: ({ selectedIssues: selectedIssues, cpVersionsForSelectedIssues: cpVersionsForSelectedIssues, projectsById: projectsById })=>{
            const isSameProject = $fe4b88a6b2273e11$export$8ac58c2734f0faf8(selectedIssues);
            const hasReleasesDisabled = $fe4b88a6b2273e11$export$d285b37749fb1894(selectedIssues, projectsById);
            const hasCPRs = !(0, parcelRequire("3nPAF")).default(cpVersionsForSelectedIssues);
            const disabled = hasReleasesDisabled || !hasCPRs && !isSameProject;
            const action = hasCPRs && !isSameProject ? (0, $lX5Hj.SET_CP_RELEASE) : (0, $lX5Hj.SET_RELEASE);
            const dialog = hasCPRs && !isSameProject ? (0, $8yYHR.default) : (0, $eTADi.default);
            return {
                type: action,
                label: (0, $ihPUd.default).releases,
                disabled: disabled,
                disabledTooltip: hasReleasesDisabled ? (0, $9FYuw.default).releaseDisabledMenuItemTooltip : (0, $9FYuw.default).releaseMenuItemTooltip,
                dialog: dialog,
                analyticsId: 'Release'
            };
        },
        setSprint: ({ selectedIssues: selectedIssues })=>{
            const disabled = $fe4b88a6b2273e11$export$f9c983cc2430c4f3(selectedIssues);
            return {
                type: (0, $lX5Hj.SET_SPRINT),
                label: (0, $9FYuw.default).setSprint,
                disabled: disabled,
                disabledTooltip: (0, $9FYuw.default).sprintMenuItemTooltip,
                dialog: (0, $7FPZL.default),
                analyticsId: 'Sprint'
            };
        },
        setTeam: ({ selectedIssues: selectedIssues })=>{
            const disabled = $fe4b88a6b2273e11$export$f9c983cc2430c4f3(selectedIssues);
            return {
                type: (0, $lX5Hj.SET_TEAM),
                label: (0, $9FYuw.default).setTeam,
                disabled: disabled,
                disabledTooltip: (0, $9FYuw.default).teamMenuItemTooltip,
                dialog: (0, $bnORa.default),
                analyticsId: 'Team'
            };
        },
        bulkChange: ({ selectedIssues: selectedIssues })=>{
            const disabled = $fe4b88a6b2273e11$export$e8b24162d7fa01b5(selectedIssues) || $fe4b88a6b2273e11$export$53f3d8e656ab0334(selectedIssues);
            const disabledTooltip = $fe4b88a6b2273e11$export$e8b24162d7fa01b5(selectedIssues) ? (0, $9FYuw.default).issueLimitExceededTooltip : (0, $9FYuw.default).bulkChangeInJiraTooltip;
            return {
                type: (0, $lX5Hj.BULK_CHANGE),
                label: (0, $9FYuw.default).bulkChange,
                disabled: disabled,
                disabledTooltip: disabledTooltip,
                analyticsId: 'Bulk-change-in-Jira'
            };
        },
        removeFromPlanTitle: ()=>({
                type: (0, $lX5Hj.REMOVE_FROM_PLAN),
                label: (0, $9FYuw.default).removeFromPlanTitle,
                dialog: (0, $b6bIB.default),
                analyticsId: 'Remove-from-plan'
            })
    };
});
parcelRegister("b6bIB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e21a751bae4868e9$export$2e2bcd8739ae039);
    var $bC2fB;
    var $602sf = parcelRequire("602sf");
    var $6AWeb = parcelRequire("6AWeb");
    var $e21a751bae4868e9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $602sf.mapDispatchToProps))((0, $6AWeb.default));
});
parcelRegister("602sf", function(module, exports) {
    $parcel$export(module.exports, "mapDispatchToProps", ()=>$bf209f5dc60667d7$export$9e6a17cf56877796);
    var $bkasS = parcelRequire("bkasS");
    const $bf209f5dc60667d7$export$9e6a17cf56877796 = {
        removeFromPlan: (0, $bkasS.removeSelectedIssues)
    };
});
parcelRegister("6AWeb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d938fde7ae84f591$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $cgL5K;
    var $9fuVs;
    var $ousew;
    var $koVbs;
    var $ihPUd = parcelRequire("ihPUd");
    var $CDD1q = parcelRequire("CDD1q");
    const $d938fde7ae84f591$var$RemoveIssuesDialog = ({ toggleModalDialog: toggleModalDialog, bulkActionSuccess: bulkActionSuccess, removeFromPlan: removeFromPlan })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            shouldScrollInViewport: true,
            onClose: toggleModalDialog,
            autoFocus: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "danger"
        }, formatMessage((0, $CDD1q.default).removeFromPlanTitle))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $CDD1q.default).removeIssueFromPlanMessage,
            values: {
                b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
            }
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: toggleModalDialog
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            onClick: (_, analyticsEvent)=>{
                removeFromPlan();
                bulkActionSuccess(analyticsEvent);
            }
        }, formatMessage((0, $CDD1q.default).removeFromPlanActionButton)))));
    };
    var $d938fde7ae84f591$export$2e2bcd8739ae039 = $d938fde7ae84f591$var$RemoveIssuesDialog;
});
parcelRegister("CDD1q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f81ea68d1eb2b04$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6f81ea68d1eb2b04$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeFromPlanTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.remove-issues.remove-from-plan-title",
            "defaultMessage": "Remove issues"
        },
        removeFromPlanActionButton: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.remove-issues.remove-from-plan-action-button",
            "defaultMessage": "Remove"
        },
        removeIssueFromPlanMessageOld: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.remove-issues.remove-issue-from-plan-message-old",
            "defaultMessage": "Issues saved in Jira will be removed from the plan, but can be re-included on {removedIssuesPageLink}. Unsaved issues will be permanently deleted."
        },
        removeIssueFromPlanMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.remove-issues.remove-issue-from-plan-message",
            "defaultMessage": "Draft issues will be permanently deleted from the plan. Issues from your project will be stored in <b>Removed issues</b> within <b>Plan settings</b>."
        }
    });
});
parcelRegister("jIMle", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3f122909ea9280f$export$2e2bcd8739ae039);
    var $bC2fB;
    var $biNeM = parcelRequire("biNeM");
    var $38hXY = parcelRequire("38hXY");
    var $4Jhrm = parcelRequire("4Jhrm");
    var $b3f122909ea9280f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $38hXY.default), (0, $biNeM.default))((0, $4Jhrm.default));
});
parcelRegister("biNeM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ab5572cf9b0703c$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $8ab5572cf9b0703c$export$2e2bcd8739ae039 = {
        bulkUpdateAttribute: (0, $bkasS.bulkIssuesUpdate)
    };
});
parcelRegister("38hXY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92372172451339d5$export$2e2bcd8739ae039);
    var $hu7Cn = parcelRequire("hu7Cn");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $3YtPS = parcelRequire("3YtPS");
    var $92372172451339d5$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedIssues: (0, $bI9dZ.getSelectedIssues),
        assignees: (0, $hu7Cn.getAssigneeList),
        assigneesById: (0, $hu7Cn.getAssigneesById)
    });
});
parcelRegister("4Jhrm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe7d2349f6cdbf2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8EB5I;
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $8RXs9;
    var $ihPUd = parcelRequire("ihPUd");
    var $lX5Hj = parcelRequire("lX5Hj");
    var $gwRiL = parcelRequire("gwRiL");
    class $afe7d2349f6cdbf2$var$SetAssigneeDialog extends (0, $5uXOq.Component) {
        render() {
            const { intl: { formatMessage: formatMessage }, toggleModalDialog: toggleModalDialog, bulkUpdateAttribute: bulkUpdateAttribute, UpdateAttributeForm: UpdateAttributeForm, bulkActionSuccess: bulkActionSuccess } = this.props;
            const { currentValue: currentValue, avatarIcon: avatarIcon } = this.getCurrentValue();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                shouldScrollInViewport: true,
                onClose: toggleModalDialog,
                width: (0, $lX5Hj.MODAL_DIALOG_WIDTH),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-assignee"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $gwRiL.default).setHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(UpdateAttributeForm, {
                updatedAttributeType: (0, $lX5Hj.SET_ASSIGNEE),
                currentValue: currentValue,
                avatarIcon: avatarIcon,
                onCancel: toggleModalDialog,
                onSubmit: (formData, analyticsEvent)=>{
                    bulkUpdateAttribute(formData);
                    toggleModalDialog();
                    bulkActionSuccess(analyticsEvent);
                }
            }))));
        }
        constructor(...args){
            super(...args);
            this.getCurrentValue = ()=>{
                const { selectedIssues: selectedIssues, assigneesById: assigneesById, intl: { formatMessage: formatMessage } } = this.props;
                const firstValue = selectedIssues[0].assignee;
                const isSameValue = !selectedIssues.some((issue)=>!(0, parcelRequire("8EB5I")).default(issue.assignee, firstValue));
                if (isSameValue && !firstValue) return {
                    currentValue: formatMessage((0, $ihPUd.default).none)
                };
                if (isSameValue && firstValue) {
                    const person = assigneesById[firstValue];
                    return {
                        currentValue: person.jiraUser.title,
                        avatarIcon: person.jiraUser.avatarUrl
                    };
                }
                return {
                    currentValue: formatMessage((0, $gwRiL.default).variousValues)
                };
            };
        }
    }
    var $afe7d2349f6cdbf2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($afe7d2349f6cdbf2$var$SetAssigneeDialog);
});
parcelRegister("gwRiL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d682972324197b93$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d682972324197b93$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-assignee.set-header",
            "defaultMessage": "Update assignee"
        },
        variousValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-assignee.various-values",
            "defaultMessage": "Various assignees"
        }
    });
});
parcelRegister("8yYHR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4767b088a10ea80e$export$2e2bcd8739ae039);
    var $bC2fB;
    var $cGqDl = parcelRequire("cGqDl");
    var $g6omy = parcelRequire("g6omy");
    var $6TuZl = parcelRequire("6TuZl");
    var $4767b088a10ea80e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $g6omy.default), (0, $cGqDl.default))((0, $6TuZl.default));
});
parcelRegister("cGqDl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91954f06b1144f75$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    const $91954f06b1144f75$var$mapDispatchToProps = (dispatch)=>({
            bulkIssuesCRPUpdate: (cprId)=>{
                dispatch((0, $bkasS.bulkIssuesCRPUpdate)(cprId));
            },
            bulkUnsetVersion: ()=>{
                dispatch((0, $bkasS.bulkIssuesUpdate)({
                    fixVersions: []
                }));
            }
        });
    var $91954f06b1144f75$export$2e2bcd8739ae039 = $91954f06b1144f75$var$mapDispatchToProps;
});
parcelRegister("g6omy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$117fc6bd6a32cc60$export$2e2bcd8739ae039);
    var $jw86H = parcelRequire("jw86H");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $3YtPS = parcelRequire("3YtPS");
    var $117fc6bd6a32cc60$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedIssues: (0, $bI9dZ.getSelectedIssues),
        crossProjectVersionsById: (0, $jw86H.getCrossProjectVersionsById),
        cpVersionsForSelectedIssues: (0, $bI9dZ.getCPRsForSelectedIssues)
    });
});
parcelRegister("6TuZl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1414e182db61aa24$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $8RXs9;
    var $ihPUd = parcelRequire("ihPUd");
    var $lX5Hj = parcelRequire("lX5Hj");
    var $bkzmf = parcelRequire("bkzmf");
    class $1414e182db61aa24$export$be01101e4e6c427c extends (0, $5uXOq.Component) {
        render() {
            const { intl: { formatMessage: formatMessage }, toggleModalDialog: toggleModalDialog, bulkIssuesCRPUpdate: bulkIssuesCRPUpdate, bulkUnsetVersion: bulkUnsetVersion, UpdateAttributeForm: UpdateAttributeForm, bulkActionSuccess: bulkActionSuccess } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                shouldScrollInViewport: true,
                onClose: toggleModalDialog,
                width: (0, $lX5Hj.MODAL_DIALOG_WIDTH)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $bkzmf.default).setReleaseHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(UpdateAttributeForm, {
                updatedAttributeType: (0, $lX5Hj.SET_CP_RELEASE),
                options: this.getOptions(),
                currentValue: this.getCurrentValue(),
                onCancel: toggleModalDialog,
                onSubmit: ({ crossProjectVersion: crossProjectVersion }, analyticsEvent)=>{
                    if (crossProjectVersion) bulkIssuesCRPUpdate(crossProjectVersion);
                    else bulkUnsetVersion();
                    toggleModalDialog();
                    bulkActionSuccess(analyticsEvent);
                }
            }))));
        }
        constructor(...args){
            super(...args);
            this.getCurrentValue = ()=>{
                const { selectedIssues: selectedIssues, intl: { formatMessage: formatMessage } } = this.props;
                const isNoneValue = selectedIssues.every((issue)=>!issue.fixVersions || !issue.fixVersions.length);
                if (isNoneValue) return formatMessage((0, $ihPUd.default).none);
                return formatMessage((0, $bkzmf.default).variousValues);
            };
            this.getOptions = ()=>{
                const { cpVersionsForSelectedIssues: cpVersionsForSelectedIssues, crossProjectVersionsById: crossProjectVersionsById } = this.props;
                return cpVersionsForSelectedIssues.map((cprId)=>{
                    const { id: id, name: name } = crossProjectVersionsById[cprId];
                    return {
                        label: name,
                        value: id
                    };
                });
            };
        }
    }
    var $1414e182db61aa24$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($1414e182db61aa24$export$be01101e4e6c427c);
});
parcelRegister("bkzmf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6195ac41d7c1433$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e6195ac41d7c1433$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setReleaseHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-cross-project-versions.set-release-header",
            "defaultMessage": "Update release"
        },
        variousValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-cross-project-versions.various-values",
            "defaultMessage": "Various releases"
        }
    });
});
parcelRegister("BMPYY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd4ec2620668ee72$export$2e2bcd8739ae039);
    var $bC2fB;
    var $8ZVfp = parcelRequire("8ZVfp");
    var $dRjFm = parcelRequire("dRjFm");
    var $8Xpv8 = parcelRequire("8Xpv8");
    var $fd4ec2620668ee72$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $dRjFm.default), (0, $8ZVfp.default))((0, $8Xpv8.default));
});
parcelRegister("8ZVfp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$514019db7ccb04e1$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $514019db7ccb04e1$export$2e2bcd8739ae039 = {
        bulkUpdateAttribute: (0, $bkasS.bulkIssuesUpdate),
        updateMultipleIssues: $bkasS.updateMultipleIssues
    };
});
parcelRegister("dRjFm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$daa27f73d0fa7e7c$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $kllqP = parcelRequire("kllqP");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $4sJY8 = parcelRequire("4sJY8");
    var $3YtPS = parcelRequire("3YtPS");
    var $daa27f73d0fa7e7c$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        childrenByParent: (0, $4sJY8.getChildrenByParent),
        customFieldsById: (0, $19iju.getCustomFieldsById),
        dateConfiguration: (0, $bHTqr.getDateConfiguration),
        issueTypesById: (0, $kllqP.getIssueTypesById),
        projectsById: (0, $jpXKt.getProjectsById),
        selectedIssues: (0, $bI9dZ.getSelectedIssues)
    });
});
parcelRegister("8Xpv8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82d9b477dc58e0ca$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8EB5I;
    var $4Rr1a;
    var $ik0Qc;
    var $2Zv6d;
    var $qfj8c;
    var $7O4UO;
    var $eGdV2;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $dC5iT;
    var $8CUq3;
    var $3rLiX;
    var $9fuVs;
    var $koVbs;
    var $aCpcO;
    var $gh61P;
    var $aipk9;
    var $flnZx;
    var $hjUAf;
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    var $dCm1o;
    var $dwYTn = parcelRequire("dwYTn");
    var $axTco = parcelRequire("axTco");
    var $dSSZT = parcelRequire("dSSZT");
    var $90UUg = parcelRequire("90UUg");
    var $33CYq = parcelRequire("33CYq");
    function $82d9b477dc58e0ca$export$2e2bcd8739ae039({ bulkActionSuccess: bulkActionSuccess, bulkUpdateAttribute: bulkUpdateAttribute, childrenByParent: childrenByParent, customFieldsById: customFieldsById, dateConfiguration: dateConfiguration, issueTypesById: issueTypesById, projectsById: projectsById, selectedIssues: selectedIssues, toggleModalDialog: toggleModalDialog, updateMultipleIssues: updateMultipleIssues }) {
        const [startDateMethod, setStartDateMethod] = (0, $5uXOq.useState)((0, $90UUg.KEEP_EXISTING));
        const [endDateMethod, setEndDateMethod] = (0, $5uXOq.useState)((0, $90UUg.KEEP_EXISTING));
        const [fixedStartDate, setFixedStartDate] = (0, $5uXOq.useState)(undefined);
        const [fixedEndDate, setFixedEndDate] = (0, $5uXOq.useState)(undefined);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { formatTimestamp: formatTimestamp } = (0, (0, parcelRequire("aipk9")).useDateFormatter)();
        const getPatchForSelectedIssues = ()=>[
                (0, $90UUg.START_DATE),
                (0, $90UUg.END_DATE)
            ].reduce((result, type)=>{
                const attribute = type === (0, $90UUg.START_DATE) ? 'baselineStart' : 'baselineEnd';
                const updateDateMethod = type === (0, $90UUg.START_DATE) ? startDateMethod : endDateMethod;
                switch(updateDateMethod){
                    case 0, $90UUg.CLEAR_DATE:
                        return Object.assign(result, {
                            [attribute]: null
                        });
                    case 0, $90UUg.SET_CUSTOM_DATE:
                        return Object.assign(result, {
                            [attribute]: type === (0, $90UUg.START_DATE) ? fixedStartDate : fixedEndDate
                        });
                    default:
                        return result;
                }
            }, {});
        const onSubmit = (_, analyticsEvent)=>{
            let modifiedIssues = selectedIssues;
            const payload = getPatchForSelectedIssues();
            if (Object.keys(payload).length > 0) {
                bulkUpdateAttribute(payload);
                modifiedIssues = selectedIssues.map((issue)=>(0, parcelRequire("ik0Qc")).default(issue, payload));
            }
            const rollUpDatesForSelectedIssues = (0, $33CYq.getRollUpDatesForSelectedIssues)(modifiedIssues, childrenByParent);
            const shouldPickTheDate = (_, key)=>key === 'baselineStart' && startDateMethod === (0, $90UUg.SET_BY_CHILD_DATES) || key === 'baselineEnd' && endDateMethod === (0, $90UUg.SET_BY_CHILD_DATES);
            updateMultipleIssues((0, parcelRequire("4Rr1a")).default((0, parcelRequire("2Zv6d")).default(shouldPickTheDate), rollUpDatesForSelectedIssues));
            toggleModalDialog();
            bulkActionSuccess(analyticsEvent);
        };
        const getCurrentValue = (type)=>{
            const attribute = type === (0, $90UUg.START_DATE) ? 'baselineStart' : 'baselineEnd';
            const firstValue = selectedIssues[0][attribute];
            const isSameValue = selectedIssues.every((issue)=>(0, parcelRequire("8EB5I")).default(issue[attribute], firstValue));
            if (isSameValue && !firstValue) return formatMessage((0, $ihPUd.default).none);
            if (isSameValue && firstValue) return (0, (0, parcelRequire("aipk9")).formatDateUTC)(firstValue, (0, (0, parcelRequire("gh61P")).DefaultDateFormat));
            return formatMessage((0, $axTco.default).variousValues);
        };
        const getDateFieldTitle = (type)=>{
            const dateField = type === (0, $90UUg.START_DATE) ? dateConfiguration.baselineStartField : dateConfiguration.baselineEndField;
            if (dateField.type === (0, $5fACX.DATEFIELD_TYPES).CUSTOM) {
                const customField = customFieldsById[dateField.key];
                if (customField) return customField.title;
                return '';
            }
            switch(dateField.key){
                case 0, $5fACX.DUE_DATE:
                    return formatMessage((0, $ihPUd.default).dueDate);
                case 0, $5fACX.TARGET_START_FIELD:
                    return formatMessage((0, $ihPUd.default).targetStart);
                case 0, $5fACX.TARGET_END_FIELD:
                    return formatMessage((0, $ihPUd.default).targetEnd);
                default:
                    return '';
            }
        };
        const updateDateOptions = (0, $90UUg.UPDATE_DATE_OPTIONS).map((option)=>({
                isDisabled: false,
                label: formatMessage((0, $axTco.default)[option]),
                name: option,
                value: option
            }));
        const formatDatePickerValue = (date)=>{
            if (date) return (0, (0, parcelRequire("aipk9")).formatDateUTC)(date, (0, (0, parcelRequire("gh61P")).IsoDateFormat));
            return undefined;
        };
        const lastEndDate = (0, $33CYq.getDateForValidation)(selectedIssues, true);
        const isInvalidDateStartBeforeEnd = endDateMethod !== (0, $90UUg.SET_CUSTOM_DATE) && (0, $4nDwW.isDefined)(fixedStartDate) && (0, $4nDwW.isDefined)(lastEndDate) && fixedStartDate > lastEndDate || endDateMethod === (0, $90UUg.SET_CUSTOM_DATE) && (0, $4nDwW.isDefined)(fixedStartDate) && (0, $4nDwW.isDefined)(fixedEndDate) && fixedStartDate > fixedEndDate;
        const earliestStartDate = (0, $33CYq.getDateForValidation)(selectedIssues, false);
        const isInvalidDateEndAfterStart = startDateMethod !== (0, $90UUg.SET_CUSTOM_DATE) && (0, $4nDwW.isDefined)(earliestStartDate) && (0, $4nDwW.isDefined)(fixedEndDate) && fixedEndDate < earliestStartDate || startDateMethod === (0, $90UUg.SET_CUSTOM_DATE) && (0, $4nDwW.isDefined)(fixedStartDate) && (0, $4nDwW.isDefined)(fixedEndDate) && fixedEndDate < fixedStartDate;
        const renderCustomDateFieldErrorMessage = (dateType)=>{
            if (dateType === (0, $90UUg.START_DATE) && isInvalidDateStartBeforeEnd) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, formatMessage((0, $ihPUd.default).invalidDateStartBeforeEnd));
            if (dateType === (0, $90UUg.END_DATE) && isInvalidDateEndAfterStart) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, formatMessage((0, $ihPUd.default).invalidDateEndAfterStart));
            return null;
        };
        const renderDateSection = (dateType)=>{
            const dateFieldTitles = {
                baselineStartField: getDateFieldTitle((0, $90UUg.START_DATE)),
                baselineEndField: getDateFieldTitle((0, $90UUg.END_DATE))
            };
            const currentDatesValues = {
                baselineStartField: getCurrentValue((0, $90UUg.START_DATE)),
                baselineEndField: getCurrentValue((0, $90UUg.END_DATE))
            };
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: dateType === (0, $90UUg.START_DATE) ? $dSSZT.startDate : $dSSZT.endDate,
                key: dateType
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dSSZT.dateTitle,
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.date-title-${dateType}`
            }, dateFieldTitles[dateType]), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dSSZT.values
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dSSZT.currentValue
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dSSZT.valueTitle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dSSZT.title
            }, formatMessage((0, $ihPUd.default).current)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dSSZT.arrow
            }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $82d9b477dc58e0ca$var$iconWrapperStyle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eGdV2"))))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eGdV2"))))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.current-value-${dateType}`
            }, currentDatesValues[dateType])), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dSSZT.newValue
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dSSZT.valueTitle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dSSZT.title
            }, formatMessage((0, $ihPUd.default).new))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $dSSZT.newValueForm
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                name: `${dateType}Method`
            }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3rLiX")).default), {
                    ...fieldProps,
                    defaultValue: (0, $90UUg.KEEP_EXISTING),
                    onChange: (evt)=>{
                        if (dateType === (0, $90UUg.START_DATE)) setStartDateMethod(evt.target.value);
                        else setEndDateMethod(evt.target.value);
                    },
                    options: updateDateOptions,
                    value: dateType === (0, $90UUg.START_DATE) ? startDateMethod : endDateMethod
                })), (dateType === (0, $90UUg.START_DATE) && startDateMethod === (0, $90UUg.SET_CUSTOM_DATE) || dateType === (0, $90UUg.END_DATE) && endDateMethod === (0, $90UUg.SET_CUSTOM_DATE)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                name: `fixed${dateType}`
            }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hjUAf")).default), {
                    ...fieldProps,
                    isInvalid: dateType === (0, $90UUg.START_DATE) ? isInvalidDateStartBeforeEnd : isInvalidDateEndAfterStart,
                    isTransparentBackground: false,
                    onChange: (date)=>{
                        if (dateType === (0, $90UUg.START_DATE)) setFixedStartDate(date ? (0, (0, parcelRequire("flnZx")).startOfUtcDay)(date) : undefined);
                        else setFixedEndDate(date ? (0, (0, parcelRequire("flnZx")).endOfUtcDay)(date) : undefined);
                    },
                    placeholder: formatMessage((0, $axTco.default).datePlaceholder, {
                        date: formatTimestamp(Date.now())
                    }),
                    showClearIndicator: true,
                    value: formatDatePickerValue(dateType === (0, $90UUg.START_DATE) ? fixedStartDate : fixedEndDate)
                })), renderCustomDateFieldErrorMessage(dateType)))))));
        };
        const renderInfoMessage = ()=>{
            if (startDateMethod === (0, $90UUg.SET_BY_CHILD_DATES) || endDateMethod === (0, $90UUg.SET_BY_CHILD_DATES)) {
                let modifiedIssues = selectedIssues;
                const payload = getPatchForSelectedIssues();
                if (Object.keys(payload).length > 0) modifiedIssues = selectedIssues.map((issue)=>(0, parcelRequire("ik0Qc")).default(issue, payload));
                const rollUpDatesForSelectedIssues = (0, $33CYq.getRollUpDatesForSelectedIssues)(modifiedIssues, childrenByParent);
                const issuesWithoutDates = selectedIssues.filter(({ id: id })=>(0, $4nDwW.isDefined)(rollUpDatesForSelectedIssues[id]) && (startDateMethod === (0, $90UUg.SET_BY_CHILD_DATES) && !(0, $4nDwW.isDefined)(rollUpDatesForSelectedIssues[id].baselineStart) || endDateMethod === (0, $90UUg.SET_BY_CHILD_DATES) && !(0, $4nDwW.isDefined)(rollUpDatesForSelectedIssues[id].baselineEnd)));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dwYTn.default), {
                    issuesWithoutDates: issuesWithoutDates,
                    issueTypesById: issueTypesById,
                    projectsById: projectsById,
                    isDefaultFlyoutOpen: false
                });
            }
            return null;
        };
        const isFormInValid = ()=>{
            if (startDateMethod === (0, $90UUg.KEEP_EXISTING) && endDateMethod === (0, $90UUg.KEEP_EXISTING)) return true;
            if (startDateMethod === (0, $90UUg.SET_CUSTOM_DATE) && (!(0, $4nDwW.isDefined)(fixedStartDate) || isInvalidDateStartBeforeEnd)) return true;
            if (endDateMethod === (0, $90UUg.SET_CUSTOM_DATE) && (!(0, $4nDwW.isDefined)(fixedEndDate) || isInvalidDateEndAfterStart)) return true;
            return false;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: false,
            onClose: toggleModalDialog,
            shouldScrollInViewport: true,
            width: "large",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.modal-dialog"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $axTco.default).header))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $dSSZT.content
        }, [
            (0, $90UUg.START_DATE),
            (0, $90UUg.END_DATE)
        ].map((type)=>renderDateSection(type))), renderInfoMessage()), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            onClick: toggleModalDialog
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "primary",
            isDisabled: isFormInValid(),
            onClick: onSubmit
        }, formatMessage((0, $ihPUd.default).apply)))));
    }
    const $82d9b477dc58e0ca$var$iconWrapperStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.075',
        paddingBottom: 'space.050'
    });
});
parcelRegister("2Zv6d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22d966f6c995eba3$export$2e2bcd8739ae039);
    var $c9RLn;
    var $22d966f6c995eba3$var$pickBy = (0, (0, parcelRequire("c9RLn")).default)(function pickBy(test, obj) {
        var result = {};
        for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
        return result;
    });
    var $22d966f6c995eba3$export$2e2bcd8739ae039 = $22d966f6c995eba3$var$pickBy;
});
parcelRegister("3rLiX", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$ca8b717dad009c8c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $jouoW;
    const $ca8b717dad009c8c$var$noOptions = [];
    function $ca8b717dad009c8c$export$2e2bcd8739ae039(props) {
        const { onChange: onChange, options: options = $ca8b717dad009c8c$var$noOptions, value: propValue, defaultValue: defaultValue, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, (0, parcelRequire("eGmKJ")).default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
        const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)(propValue !== undefined ? propValue : defaultValue);
        const onRadioChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setSelectedValue(e.currentTarget.value);
            if (onChange) onChange(e, analyticsEvent);
        }, [
            onChange
        ]);
        const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "radiogroup",
            "aria-labelledby": ariaLabelledBy,
            "data-testid": testId
        }, options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        }));
    }
});
parcelRegister("dwYTn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01b4fc541b469934$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $2C7j9;
    var $bjGSs;
    var $c8oLN;
    var $dC5iT;
    var $8CUq3;
    var $92Z2l;
    var $4R6GH;
    var $ousew;
    var $8RXs9;
    var $aCpcO;
    var $gJZ5D;
    var $J8W7q;
    var $2FvnI;
    var $ihPUd = parcelRequire("ihPUd");
    var $hpW0w = parcelRequire("hpW0w");
    var $5Kah1 = parcelRequire("5Kah1");
    class $01b4fc541b469934$var$InfoMessage extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isDefaultFlyoutOpen: false
            };
        }
        render() {
            const { issuesWithoutDates: issuesWithoutDates } = this.props;
            return issuesWithoutDates.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
                appearance: "information",
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.info-message"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $hpW0w.default).infoMessageBeforeLink), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $hpW0w.default).infoMessageAfterLink,
                values: {
                    issuesWithoutDates: this.renderInlineDialog()
                }
            })) : null;
        }
        constructor(...args){
            super(...args);
            this.state = {
                isFlyoutOpen: this.props.isDefaultFlyoutOpen
            };
            this.toggleFlyout = ()=>{
                this.setState((state)=>({
                        isFlyoutOpen: !state.isFlyoutOpen
                    }));
            };
            this.closeFlyout = ()=>{
                this.setState(()=>({
                        isFlyoutOpen: false
                    }));
            };
            this.issueOptionRenderer = (issue, i)=>{
                const { projectsById: projectsById, issueTypesById: issueTypesById } = this.props;
                const projectKey = issue.project && projectsById[issue.project] && projectsById[issue.project].key || '';
                const issueTypeIconUrl = issueTypesById[issue.type] && issueTypesById[issue.type].iconUrl;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5Kah1["issue-option-wrapper"],
                    key: `${i}-option`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5Kah1["issue-type-icon"],
                    style: {
                        backgroundSize: 'contain',
                        backgroundImage: `url(${issueTypeIconUrl})`
                    }
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5Kah1.link
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvnI")).default), {
                    issueKey: issue.issueKey,
                    projectKey: projectKey
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5Kah1["issue-label"],
                    title: issue.summary
                }, issue.summary)));
            };
            this.renderFlyout = (issues)=>{
                const { intl: intl } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $01b4fc541b469934$var$flyoutStyles,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.div"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8oLN")).default), {
                    block: "space.100",
                    inline: "space.200",
                    xcss: $01b4fc541b469934$var$closeFlyoutStyles
                }, (0, (0, parcelRequire("4R6GH")).fg)('jira-portfolio-bulk-actions-button-name-a11y-fix') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "subtle-link",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                        label: ""
                    }),
                    onClick: ()=>this.closeFlyout(),
                    "aria-label": intl.formatMessage((0, $ihPUd.default).close)
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "subtle-link",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2C7j9"))))), {
                        label: "",
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.editor-close-icon",
                        primaryColor: `var(--ds-text-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N200})`
                    }),
                    onClick: ()=>this.closeFlyout(),
                    spacing: "none",
                    "aria-label": intl.formatMessage((0, $ihPUd.default).close)
                })), issues.map(this.issueOptionRenderer));
            };
            this.renderInlineDialog = ()=>{
                const { intl: intl, issuesWithoutDates: issuesWithoutDates } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5Kah1["inline-dialog-container"]
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                    content: this.renderFlyout(issuesWithoutDates),
                    isOpen: this.state.isFlyoutOpen,
                    placement: "bottom",
                    noHorizontalScroll: true,
                    classNames: "inline-dialog"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: ()=>this.toggleFlyout(),
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.button"
                }, intl.formatMessage((0, $hpW0w.default).linkLabel, {
                    issueCount: issuesWithoutDates.length
                })))));
            };
        }
    }
    var $01b4fc541b469934$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($01b4fc541b469934$var$InfoMessage);
    const $01b4fc541b469934$var$flyoutStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxWidth: '480px',
        position: 'relative',
        paddingTop: 'space.100',
        paddingRight: 'space.150',
        paddingBottom: 'space.050',
        paddingLeft: '0'
    });
    const $01b4fc541b469934$var$closeFlyoutStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: '0',
        right: '0'
    });
});
parcelRegister("c8oLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e401c8401021557f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8CUq3;
    function $e401c8401021557f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e401c8401021557f$var$baseStyles = {
        name: "1khn195",
        styles: "box-sizing:border-box"
    };
    const $e401c8401021557f$var$blockBleedMap = {
        'space.025': {
            name: "9w2fxh",
            styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "1qhe0y6",
            styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "s0o2nz",
            styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "151e4o3",
            styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "16sn062",
            styles: "margin-block:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $e401c8401021557f$var$inlineBleedMap = {
        'space.025': {
            name: "16oxh68",
            styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "tdc6fz",
            styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "crujrn",
            styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "y28d58",
            styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "1vfkteg",
            styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $e401c8401021557f$var$Bleed = (0, ($parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
        const resolvedStyles = (0, (0, parcelRequire("8CUq3")).parseXcss)(xcss);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: resolvedStyles.static,
            css: [
                $e401c8401021557f$var$baseStyles,
                (inline || all) && $e401c8401021557f$var$inlineBleedMap[inline || all],
                (block || all) && $e401c8401021557f$var$blockBleedMap[block || all],
                resolvedStyles.emotion
            ],
            "data-testid": testId
        }, children);
    });
    $e401c8401021557f$var$Bleed.displayName = 'Bleed';
    var $e401c8401021557f$export$2e2bcd8739ae039 = $e401c8401021557f$var$Bleed;
});
parcelRegister("hpW0w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0485d22a70bcbd5a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0485d22a70bcbd5a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        infoMessageBeforeLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.info-message-before-link",
            "defaultMessage": "To best represent child issues without start or end dates, "
        },
        linkLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.link-label",
            "defaultMessage": "{issueCount, plural, one {# parent issue} other {# parent issues}}"
        },
        infoMessageAfterLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.info-message-after-link",
            "defaultMessage": "{issuesWithoutDates} will have their start or end dates removed."
        }
    });
});
parcelRegister("5Kah1", function(module, exports) {
    $parcel$export(module.exports, "inline-dialog-container", ()=>$42e937b95c0e7b4e$export$ac9bfbba4987a017, (v)=>$42e937b95c0e7b4e$export$ac9bfbba4987a017 = v);
    $parcel$export(module.exports, "issue-label", ()=>$42e937b95c0e7b4e$export$8dbc59d0fe020d7e, (v)=>$42e937b95c0e7b4e$export$8dbc59d0fe020d7e = v);
    $parcel$export(module.exports, "issue-option-wrapper", ()=>$42e937b95c0e7b4e$export$2916d4d56de3dd7, (v)=>$42e937b95c0e7b4e$export$2916d4d56de3dd7 = v);
    $parcel$export(module.exports, "issue-type-icon", ()=>$42e937b95c0e7b4e$export$175e354db6e532ed, (v)=>$42e937b95c0e7b4e$export$175e354db6e532ed = v);
    $parcel$export(module.exports, "link", ()=>$42e937b95c0e7b4e$export$9c30223ca0a664fb, (v)=>$42e937b95c0e7b4e$export$9c30223ca0a664fb = v);
    var $42e937b95c0e7b4e$export$ac9bfbba4987a017;
    var $42e937b95c0e7b4e$export$8dbc59d0fe020d7e;
    var $42e937b95c0e7b4e$export$2916d4d56de3dd7;
    var $42e937b95c0e7b4e$export$175e354db6e532ed;
    var $42e937b95c0e7b4e$export$9c30223ca0a664fb;
    $42e937b95c0e7b4e$export$ac9bfbba4987a017 = `_3aDJ6G_inline-dialog-container`;
    $42e937b95c0e7b4e$export$8dbc59d0fe020d7e = `_3aDJ6G_issue-label`;
    $42e937b95c0e7b4e$export$2916d4d56de3dd7 = `_3aDJ6G_issue-option-wrapper`;
    $42e937b95c0e7b4e$export$175e354db6e532ed = `_3aDJ6G_issue-type-icon`;
    $42e937b95c0e7b4e$export$9c30223ca0a664fb = `_3aDJ6G_link`;
});
parcelRegister("axTco", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad7f8e7fa2e801e1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ad7f8e7fa2e801e1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.header",
            "defaultMessage": "Update dates"
        },
        variousValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.various-values",
            "defaultMessage": "Various dates"
        },
        datePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.date-placeholder",
            "defaultMessage": "e.g. {date}"
        },
        KEEP_EXISTING: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-date-dialog.keep-existing",
            "defaultMessage": "Keep existing"
        },
        CLEAR_DATE: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-date-dialog.clear-date",
            "defaultMessage": "Clear date"
        },
        SET_BY_CHILD_DATES: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-date-dialog.set-by-child-dates",
            "defaultMessage": "Set by child issue dates"
        },
        SET_CUSTOM_DATE: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-date-dialog.set-custom-date",
            "defaultMessage": "Set custom date"
        }
    });
});
parcelRegister("dSSZT", function(module, exports) {
    $parcel$export(module.exports, "arrow", ()=>$a1bafad571cc2b6f$export$f2120bbfa5450bd2, (v)=>$a1bafad571cc2b6f$export$f2120bbfa5450bd2 = v);
    $parcel$export(module.exports, "content", ()=>$a1bafad571cc2b6f$export$a7db06668cad9adb, (v)=>$a1bafad571cc2b6f$export$a7db06668cad9adb = v);
    $parcel$export(module.exports, "currentValue", ()=>$a1bafad571cc2b6f$export$6cd4326f683953cc, (v)=>$a1bafad571cc2b6f$export$6cd4326f683953cc = v);
    $parcel$export(module.exports, "dateTitle", ()=>$a1bafad571cc2b6f$export$758b62fe1adf6ec5, (v)=>$a1bafad571cc2b6f$export$758b62fe1adf6ec5 = v);
    $parcel$export(module.exports, "endDate", ()=>$a1bafad571cc2b6f$export$910e497d4a89534b, (v)=>$a1bafad571cc2b6f$export$910e497d4a89534b = v);
    $parcel$export(module.exports, "newValue", ()=>$a1bafad571cc2b6f$export$3531a5b004bf3835, (v)=>$a1bafad571cc2b6f$export$3531a5b004bf3835 = v);
    $parcel$export(module.exports, "newValueForm", ()=>$a1bafad571cc2b6f$export$c87aa84947c653c7, (v)=>$a1bafad571cc2b6f$export$c87aa84947c653c7 = v);
    $parcel$export(module.exports, "startDate", ()=>$a1bafad571cc2b6f$export$9ffe627750d78daf, (v)=>$a1bafad571cc2b6f$export$9ffe627750d78daf = v);
    $parcel$export(module.exports, "title", ()=>$a1bafad571cc2b6f$export$fb184b623420d9be, (v)=>$a1bafad571cc2b6f$export$fb184b623420d9be = v);
    $parcel$export(module.exports, "valueTitle", ()=>$a1bafad571cc2b6f$export$9a3ba09e6b9fd40c, (v)=>$a1bafad571cc2b6f$export$9a3ba09e6b9fd40c = v);
    $parcel$export(module.exports, "values", ()=>$a1bafad571cc2b6f$export$68c286be0e7e55b7, (v)=>$a1bafad571cc2b6f$export$68c286be0e7e55b7 = v);
    var $a1bafad571cc2b6f$export$f2120bbfa5450bd2;
    var $a1bafad571cc2b6f$export$a7db06668cad9adb;
    var $a1bafad571cc2b6f$export$6cd4326f683953cc;
    var $a1bafad571cc2b6f$export$758b62fe1adf6ec5;
    var $a1bafad571cc2b6f$export$910e497d4a89534b;
    var $a1bafad571cc2b6f$export$3531a5b004bf3835;
    var $a1bafad571cc2b6f$export$c87aa84947c653c7;
    var $a1bafad571cc2b6f$export$9ffe627750d78daf;
    var $a1bafad571cc2b6f$export$fb184b623420d9be;
    var $a1bafad571cc2b6f$export$9a3ba09e6b9fd40c;
    var $a1bafad571cc2b6f$export$68c286be0e7e55b7;
    $a1bafad571cc2b6f$export$f2120bbfa5450bd2 = `seqU5a_arrow`;
    $a1bafad571cc2b6f$export$a7db06668cad9adb = `seqU5a_content`;
    $a1bafad571cc2b6f$export$6cd4326f683953cc = `seqU5a_currentValue`;
    $a1bafad571cc2b6f$export$758b62fe1adf6ec5 = `seqU5a_dateTitle`;
    $a1bafad571cc2b6f$export$910e497d4a89534b = `seqU5a_endDate`;
    $a1bafad571cc2b6f$export$3531a5b004bf3835 = `seqU5a_newValue`;
    $a1bafad571cc2b6f$export$c87aa84947c653c7 = `seqU5a_newValueForm`;
    $a1bafad571cc2b6f$export$9ffe627750d78daf = `seqU5a_startDate`;
    $a1bafad571cc2b6f$export$fb184b623420d9be = `seqU5a_title`;
    $a1bafad571cc2b6f$export$9a3ba09e6b9fd40c = `seqU5a_valueTitle`;
    $a1bafad571cc2b6f$export$68c286be0e7e55b7 = `seqU5a_values`;
});
parcelRegister("90UUg", function(module, exports) {
    $parcel$export(module.exports, "START_DATE", ()=>$e648799eff87c450$export$99a467bcc22b8df9);
    $parcel$export(module.exports, "END_DATE", ()=>$e648799eff87c450$export$1113b91e67d28ba7);
    $parcel$export(module.exports, "KEEP_EXISTING", ()=>$e648799eff87c450$export$25010883706272c4);
    $parcel$export(module.exports, "CLEAR_DATE", ()=>$e648799eff87c450$export$a8b9780b032af666);
    $parcel$export(module.exports, "SET_BY_CHILD_DATES", ()=>$e648799eff87c450$export$cd232fea22992ba9);
    $parcel$export(module.exports, "SET_CUSTOM_DATE", ()=>$e648799eff87c450$export$20b490592af2cd4d);
    $parcel$export(module.exports, "UPDATE_DATE_OPTIONS", ()=>$e648799eff87c450$export$1b5bd757c52df144);
    const $e648799eff87c450$export$99a467bcc22b8df9 = 'baselineStartField';
    const $e648799eff87c450$export$1113b91e67d28ba7 = 'baselineEndField';
    const $e648799eff87c450$export$25010883706272c4 = 'KEEP_EXISTING';
    const $e648799eff87c450$export$a8b9780b032af666 = 'CLEAR_DATE';
    const $e648799eff87c450$export$cd232fea22992ba9 = 'SET_BY_CHILD_DATES';
    const $e648799eff87c450$export$20b490592af2cd4d = 'SET_CUSTOM_DATE';
    const $e648799eff87c450$export$1b5bd757c52df144 = [
        $e648799eff87c450$export$25010883706272c4,
        $e648799eff87c450$export$a8b9780b032af666,
        $e648799eff87c450$export$cd232fea22992ba9,
        $e648799eff87c450$export$20b490592af2cd4d
    ];
});
parcelRegister("33CYq", function(module, exports) {
    $parcel$export(module.exports, "getRollUpDatesForSelectedIssues", ()=>$34700819a4713070$export$d9d5735e1ab2729d);
    $parcel$export(module.exports, "getDateForValidation", ()=>$34700819a4713070$export$bfe614e9974574bf);
    var $79nXx;
    var $3pSjV;
    var $fZhYM;
    var $2rMKg;
    var $4nDwW = parcelRequire("4nDwW");
    const $34700819a4713070$export$d9d5735e1ab2729d = (selectedIssues, childrenByParent)=>{
        const selectedIssuesById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), selectedIssues);
        const childrenOfSelectedIssues = selectedIssues.flatMap(({ id: id })=>childrenByParent[id] || []);
        const result = {};
        childrenOfSelectedIssues.forEach(({ id: id, parent: parent, baselineStart: issueBaselineStart, baselineEnd: issueBaselineEnd })=>{
            const child = selectedIssuesById[id];
            const dates = {
                baselineStart: (0, $4nDwW.isDefined)(child) ? child.baselineStart : issueBaselineStart,
                baselineEnd: (0, $4nDwW.isDefined)(child) ? child.baselineEnd : issueBaselineEnd
            };
            if (!(0, $4nDwW.isDefined)(dates.baselineStart) && !(0, $4nDwW.isDefined)(dates.baselineEnd)) return result;
            if (parent) {
                if (!(0, $4nDwW.isDefined)(result[parent])) {
                    result[parent] = {
                        baselineStart: (0, parcelRequire("3pSjV")).default(null, dates.baselineStart),
                        baselineEnd: (0, parcelRequire("3pSjV")).default(null, dates.baselineEnd)
                    };
                    return result;
                }
                [
                    'baselineStart',
                    'baselineEnd'
                ].forEach((dateType)=>{
                    if ((0, $4nDwW.isDefined)((0, parcelRequire("fZhYM")).default([
                        parent,
                        dateType
                    ], result))) {
                        if (!(0, $4nDwW.isDefined)(dates[dateType])) result[parent][dateType] = null;
                        else {
                            const fn = dateType === 'baselineStart' ? Math.min : Math.max;
                            result[parent][dateType] = fn(result[parent][dateType], dates[dateType]);
                        }
                    }
                });
            }
            return result;
        });
        return result;
    };
    const $34700819a4713070$export$bfe614e9974574bf = (selectedIssues, isTargetStart)=>{
        let dateForValidation = null;
        if (isTargetStart) selectedIssues.forEach(({ baselineEnd: baselineEnd })=>{
            if (!(0, $4nDwW.isDefined)(dateForValidation) && (0, $4nDwW.isDefined)(baselineEnd)) dateForValidation = baselineEnd;
            else if ((0, $4nDwW.isDefined)(dateForValidation) && (0, $4nDwW.isDefined)(baselineEnd) && (0, (0, parcelRequire("79nXx")).default)(dateForValidation, baselineEnd)) dateForValidation = baselineEnd;
        });
        else selectedIssues.forEach(({ baselineStart: baselineStart })=>{
            if (!(0, $4nDwW.isDefined)(dateForValidation) && (0, $4nDwW.isDefined)(baselineStart)) dateForValidation = baselineStart;
            else if ((0, $4nDwW.isDefined)(dateForValidation) && (0, $4nDwW.isDefined)(baselineStart) && (0, (0, parcelRequire("79nXx")).default)(baselineStart, dateForValidation)) dateForValidation = baselineStart;
        });
        return dateForValidation;
    };
});
parcelRegister("euy7m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0470c7bdcac8a607$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bJxGQ = parcelRequire("bJxGQ");
    var $24eaP = parcelRequire("24eaP");
    var $dcIee = parcelRequire("dcIee");
    var $0470c7bdcac8a607$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $24eaP.default), (0, $bJxGQ.default))((0, $dcIee.default));
});
parcelRegister("bJxGQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3959f2fd8c00b1e1$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $3959f2fd8c00b1e1$export$2e2bcd8739ae039 = {
        bulkUpdateAttribute: (0, $bkasS.bulkIssuesUpdate)
    };
});
parcelRegister("24eaP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfb2c0e868520c35$export$2e2bcd8739ae039);
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpgxP = parcelRequire("jpgxP");
    var $3YtPS = parcelRequire("3YtPS");
    var $cfb2c0e868520c35$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedIssues: (0, $bI9dZ.getSelectedIssues),
        plan: (0, $bHTqr.getPlan),
        workingHours: (0, $jpgxP.getJiraHoursPerDay)
    });
});
parcelRegister("dcIee", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22224c7171378d17$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $qfj8c;
    var $7O4UO;
    var $8RBk4;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $kY99m;
    var $3bDjY;
    var $9fuVs;
    var $koVbs;
    var $aCpcO;
    var $fAGMJ;
    var $ekXoi = parcelRequire("ekXoi");
    var $ihPUd = parcelRequire("ihPUd");
    var $lX5Hj = parcelRequire("lX5Hj");
    var $5kIBR = parcelRequire("5kIBR");
    var $kUnC2 = parcelRequire("kUnC2");
    const $22224c7171378d17$var$useCurrentValue = ({ selectedIssues: selectedIssues, planningUnit: planningUnit, workingHours: workingHours })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const firstValue = (0, $ekXoi.getEstimateValue)(planningUnit, selectedIssues[0], workingHours);
        const isSameValue = selectedIssues.every((issue)=>(0, $ekXoi.getEstimateValue)(planningUnit, issue, workingHours) === firstValue);
        return isSameValue ? firstValue?.toString(10) ?? formatMessage((0, $ihPUd.default).none) : formatMessage((0, $5kIBR.default).variousValues);
    };
    const $22224c7171378d17$var$withTooltip = (component, tooltip)=>tooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltip
        }, component) : component;
    function $22224c7171378d17$var$SetEstimateDialog({ bulkActionSuccess: bulkActionSuccess, bulkUpdateAttribute: bulkUpdateAttribute, plan: { planningUnit: planningUnit }, selectedIssues: selectedIssues, toggleModalDialog: toggleModalDialog, workingHours: workingHours }) {
        const [estimate, setEstimate] = (0, $5uXOq.useState)('');
        const [showEstimateError, setShowEstimateError] = (0, $5uXOq.useState)(false);
        const [clearEstimates, setClearEstimates] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const currentValue = $22224c7171378d17$var$useCurrentValue({
            planningUnit: planningUnit,
            selectedIssues: selectedIssues,
            workingHours: workingHours
        });
        const currentContent = $22224c7171378d17$var$withTooltip((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUnC2["value-placeholder"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUnC2["current-value-title"]
        }, currentValue)), currentValue);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            onClose: toggleModalDialog,
            shouldScrollInViewport: true,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate",
            width: (0, $lX5Hj.MODAL_DIALOG_WIDTH)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $5kIBR.default).setHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            className: $kUnC2["form-group"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUnC2["current-value"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUnC2["value-label"]
        }, formatMessage((0, $ihPUd.default).current)), currentContent), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUnC2.icon
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
            label: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUnC2["new-value"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            isRequired: true,
            label: formatMessage((0, $5kIBR.default).newEstimate, {
                planningUnit: formatMessage((0, $5kIBR.default)[planningUnit])
            }),
            name: "estimate"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                ...fieldProps,
                autoFocus: true,
                isDisabled: clearEstimates,
                min: 0,
                onChange: (e)=>{
                    const newValue = e.target.value;
                    setShowEstimateError(Number(newValue) < 0);
                    setEstimate(newValue);
                },
                type: "number",
                value: estimate
            }), showEstimateError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, formatMessage((0, $5kIBR.default).outOfRange)))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $kUnC2.checkbox
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            label: formatMessage((0, $5kIBR.default).clearEstimates),
            onChange: (event)=>{
                setClearEstimates(event.target.checked);
            }
        }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            onClick: toggleModalDialog
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "primary",
            isDisabled: clearEstimates ? false : estimate === '' || Number(estimate) < 0,
            onClick: (_, analyticsEvent)=>{
                bulkUpdateAttribute({
                    estimate: estimate,
                    clearEstimates: clearEstimates
                });
                toggleModalDialog();
                bulkActionSuccess(analyticsEvent);
            }
        }, formatMessage((0, $ihPUd.default).apply)))));
    }
    var $22224c7171378d17$export$2e2bcd8739ae039 = $22224c7171378d17$var$SetEstimateDialog;
});
parcelRegister("5kIBR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49e629ae20b925e2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $49e629ae20b925e2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate.set-header",
            "defaultMessage": "Update estimate"
        },
        variousValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate.various-values",
            "defaultMessage": "Various estimates"
        },
        newEstimate: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate.new-estimate",
            "defaultMessage": "New estimate ({planningUnit})"
        },
        [(0, $TTKUQ.PlanningUnits).storyPoints]: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-estimate-dialog.story-points",
            "defaultMessage": "story points"
        },
        [(0, $TTKUQ.PlanningUnits).days]: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-estimate-dialog.days",
            "defaultMessage": "days"
        },
        [(0, $TTKUQ.PlanningUnits).hours]: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-estimate-dialog.hours",
            "defaultMessage": "hours"
        },
        outOfRange: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate.out-of-range",
            "defaultMessage": "The estimate must be a positive number."
        },
        clearEstimates: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate.clear-estimates",
            "defaultMessage": "Clear estimates"
        }
    });
});
parcelRegister("kUnC2", function(module, exports) {
    $parcel$export(module.exports, "checkbox", ()=>$f38b5a907c88ff8b$export$b07e517d22efa1ca, (v)=>$f38b5a907c88ff8b$export$b07e517d22efa1ca = v);
    $parcel$export(module.exports, "current-value", ()=>$f38b5a907c88ff8b$export$bd70860eb87e972b, (v)=>$f38b5a907c88ff8b$export$bd70860eb87e972b = v);
    $parcel$export(module.exports, "current-value-title", ()=>$f38b5a907c88ff8b$export$2c19fd1221dd0b06, (v)=>$f38b5a907c88ff8b$export$2c19fd1221dd0b06 = v);
    $parcel$export(module.exports, "form-group", ()=>$f38b5a907c88ff8b$export$55a1f87a143fb302, (v)=>$f38b5a907c88ff8b$export$55a1f87a143fb302 = v);
    $parcel$export(module.exports, "icon", ()=>$f38b5a907c88ff8b$export$1ca1ec8b29a4ce27, (v)=>$f38b5a907c88ff8b$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "new-value", ()=>$f38b5a907c88ff8b$export$18786265e3bc6811, (v)=>$f38b5a907c88ff8b$export$18786265e3bc6811 = v);
    $parcel$export(module.exports, "value-label", ()=>$f38b5a907c88ff8b$export$f2febdad47edd01a, (v)=>$f38b5a907c88ff8b$export$f2febdad47edd01a = v);
    $parcel$export(module.exports, "value-placeholder", ()=>$f38b5a907c88ff8b$export$16d768213d218756, (v)=>$f38b5a907c88ff8b$export$16d768213d218756 = v);
    var $f38b5a907c88ff8b$export$b07e517d22efa1ca;
    var $f38b5a907c88ff8b$export$bd70860eb87e972b;
    var $f38b5a907c88ff8b$export$2c19fd1221dd0b06;
    var $f38b5a907c88ff8b$export$55a1f87a143fb302;
    var $f38b5a907c88ff8b$export$1ca1ec8b29a4ce27;
    var $f38b5a907c88ff8b$export$18786265e3bc6811;
    var $f38b5a907c88ff8b$export$f2febdad47edd01a;
    var $f38b5a907c88ff8b$export$16d768213d218756;
    $f38b5a907c88ff8b$export$b07e517d22efa1ca = `YXOtZW_checkbox`;
    $f38b5a907c88ff8b$export$bd70860eb87e972b = `YXOtZW_current-value`;
    $f38b5a907c88ff8b$export$2c19fd1221dd0b06 = `YXOtZW_current-value-title`;
    $f38b5a907c88ff8b$export$55a1f87a143fb302 = `YXOtZW_form-group`;
    $f38b5a907c88ff8b$export$1ca1ec8b29a4ce27 = `YXOtZW_icon`;
    $f38b5a907c88ff8b$export$18786265e3bc6811 = `YXOtZW_new-value`;
    $f38b5a907c88ff8b$export$f2febdad47edd01a = `YXOtZW_value-label`;
    $f38b5a907c88ff8b$export$16d768213d218756 = `YXOtZW_value-placeholder`;
});
parcelRegister("bI6DQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f585fbb3f8698441$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bya0s = parcelRequire("bya0s");
    var $xaRZl = parcelRequire("xaRZl");
    var $kuTGS = parcelRequire("kuTGS");
    var $f585fbb3f8698441$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $xaRZl.default), (0, $bya0s.default))((0, $kuTGS.default));
});
parcelRegister("bya0s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$398ce754bb767168$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $398ce754bb767168$export$2e2bcd8739ae039 = {
        bulkUpdateAttribute: (0, $bkasS.bulkIssuesUpdate)
    };
});
parcelRegister("xaRZl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82fd7688b31cf5b7$export$2e2bcd8739ae039);
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    var $82fd7688b31cf5b7$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        plan: (0, $bHTqr.getPlan),
        selectedIssues: (0, $bI9dZ.getSelectedIssues)
    });
});
parcelRegister("kuTGS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a666a7968e3b711$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8EB5I;
    var $8RBk4;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $d9xxV;
    var $9fuVs;
    var $koVbs;
    var $aCpcO;
    var $i2qlb = parcelRequire("i2qlb");
    var $ihPUd = parcelRequire("ihPUd");
    var $8zOmE;
    var $lX5Hj = parcelRequire("lX5Hj");
    var $kKgTE = parcelRequire("kKgTE");
    var $7QCxV = parcelRequire("7QCxV");
    var $5IHhZ = parcelRequire("5IHhZ");
    var $e0e2I = parcelRequire("e0e2I");
    var $2vokC = parcelRequire("2vokC");
    const $8a666a7968e3b711$var$SetLabelDialog = ({ plan: plan, selectedIssues: selectedIssues, bulkUpdateAttribute: bulkUpdateAttribute, toggleModalDialog: toggleModalDialog })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [fieldAction, setFieldAction] = (0, $5uXOq.useState)((0, $2vokC.FieldAction).ADD);
        const [editedLabels, setEditedLabels] = (0, $5uXOq.useState)([]);
        const getCurrentValue = ()=>{
            const firstValue = selectedIssues[0].labels;
            const isSameValue = !selectedIssues.some((issue)=>!(0, parcelRequire("8EB5I")).default(issue.labels?.sort(), firstValue?.sort()));
            if (isSameValue && !firstValue?.length) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $5IHhZ.default).noValues));
            if (isSameValue && firstValue) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $e0e2I["current-container"]
            }, firstValue.map((label, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
                    key: i,
                    text: label
                }))));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $5IHhZ.default).variousValues));
        };
        const currentContent = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $e0e2I["value-placeholder"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $e0e2I["current-value-title"]
        }, getCurrentValue()));
        const onLabelChange = (option)=>{
            setEditedLabels(option);
        };
        const onSubmit = (_, analyticsEvent)=>{
            const labelsArray = editedLabels.map((editedLabel)=>editedLabel.value);
            bulkUpdateAttribute({
                labels: {
                    value: fieldAction !== (0, $2vokC.FieldAction).CLEAR ? labelsArray : [],
                    fieldAction: fieldAction
                }
            });
            const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_ACTION_SUCCEEDED.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_ACTION_SUCCEEDED, {
                selectedOption: 'Labels',
                fieldAction: fieldAction
            });
            toggleModalDialog();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: toggleModalDialog,
            width: (0, $lX5Hj.MODAL_DIALOG_WIDTH)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $5IHhZ.default).setHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $e0e2I["form-group"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $e0e2I["value-label"]
        }, formatMessage((0, $ihPUd.default).current)), currentContent), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $e0e2I.icon
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
            label: formatMessage((0, $5IHhZ.default).arrowRightLabel)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $e0e2I["new-value"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $e0e2I["value-label"]
        }, formatMessage((0, $ihPUd.default).new)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kKgTE.default), {
            fieldAction: fieldAction,
            setFieldAction: setFieldAction
        }), fieldAction !== (0, $2vokC.FieldAction).CLEAR && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7QCxV.default), {
            plan: plan,
            editedLabels: editedLabels,
            onLabelChange: onLabelChange
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            onClick: toggleModalDialog
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "primary",
            onClick: onSubmit,
            isDisabled: editedLabels.length <= 0 && fieldAction !== (0, $2vokC.FieldAction).CLEAR
        }, formatMessage((0, $ihPUd.default).apply)))));
    };
    var $8a666a7968e3b711$export$2e2bcd8739ae039 = $8a666a7968e3b711$var$SetLabelDialog;
});
parcelRegister("kKgTE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88d57053db3a2e2c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $koVbs;
    var $cSDJf = parcelRequire("cSDJf");
    var $bHWCy = parcelRequire("bHWCy");
    var $gLyV0 = parcelRequire("gLyV0");
    const $88d57053db3a2e2c$var$FieldActionSelect = ({ fieldAction: fieldAction, setFieldAction: setFieldAction })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleChange = (selectedOption)=>{
            setFieldAction(selectedOption.value);
        };
        const fieldActionOptions = [
            {
                label: formatMessage((0, $bHWCy.default).add),
                value: 'ADD'
            },
            {
                label: formatMessage((0, $bHWCy.default).remove),
                value: 'REMOVE'
            },
            {
                label: formatMessage((0, $bHWCy.default).replace),
                value: 'SET'
            },
            {
                label: formatMessage((0, $bHWCy.default).clear),
                value: 'CLEAR'
            }
        ];
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gLyV0["field-action-container"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cSDJf.default), {
            id: "field-action-select",
            options: fieldActionOptions,
            onChange: handleChange,
            value: fieldActionOptions.filter((option)=>option.value === fieldAction)[0],
            isTransparentBackground: false,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jira-portfolio-bulk-actions-button-name-a11y-fix') && {
                'aria-label': formatMessage((0, $bHWCy.default).fieldActionSelectLabel)
            }
        })));
    };
    var $88d57053db3a2e2c$export$2e2bcd8739ae039 = $88d57053db3a2e2c$var$FieldActionSelect;
});
parcelRegister("bHWCy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88f801e80f3f26f9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $88f801e80f3f26f9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        add: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.field-action-select.add",
            "defaultMessage": "Add labels"
        },
        replace: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.field-action-select.replace",
            "defaultMessage": "Replace all labels"
        },
        clear: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.field-action-select.clear",
            "defaultMessage": "Clear all labels"
        },
        remove: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.field-action-select.remove",
            "defaultMessage": "Remove labels"
        },
        fieldActionSelectLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.field-action-select.label",
            "defaultMessage": "Select field action"
        }
    });
});
parcelRegister("gLyV0", function(module, exports) {
    $parcel$export(module.exports, "field-action-container", ()=>$c34c1f2e311647f2$export$6a6f2caaea6b52f9, (v)=>$c34c1f2e311647f2$export$6a6f2caaea6b52f9 = v);
    var $c34c1f2e311647f2$export$6a6f2caaea6b52f9;
    $c34c1f2e311647f2$export$6a6f2caaea6b52f9 = `gE_UFq_field-action-container`;
});
parcelRegister("7QCxV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2d904f87c741e20$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $4R6GH;
    var $koVbs;
    var $i2qlb = parcelRequire("i2qlb");
    var $cSDJf = parcelRequire("cSDJf");
    var $8zOmE;
    var $2NMNM;
    var $4etIt = parcelRequire("4etIt");
    const $d2d904f87c741e20$var$MAX_FIELD_LENGTH = 255;
    const $d2d904f87c741e20$export$f18317131e3a9f2c = (planId, scenarioId, query)=>fetch('/rest/jpo/1.0/scenarios/labels', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                limit: 50,
                planId: planId,
                scenarioId: scenarioId,
                query: (0, (0, parcelRequire("4R6GH")).fg)('refetch_bulk_labels') ? query || null : null
            })
        });
    const $d2d904f87c741e20$var$useLabelsDebounced = (planId, scenarioId, query)=>{
        const [labels, setLabels] = (0, $5uXOq.useState)([]);
        const debouncedGetLabels = (0, $5uXOq.useMemo)(()=>{
            const getLabels = async (searchText)=>{
                if (planId == null || scenarioId == null) throw Error('No planId or scenarioId from useLabels');
                try {
                    const raw = await $d2d904f87c741e20$export$f18317131e3a9f2c(planId, scenarioId, searchText);
                    if (raw.ok) {
                        const response = await raw.json();
                        const formattedResponse = response?.items?.map((item)=>({
                                value: item,
                                label: item
                            })) || [];
                        setLabels(formattedResponse);
                    } else throw Error('Failed to retrieve labels');
                } catch (e) {
                    throw Error('Failed to retrieve labels');
                }
            };
            return (0, ($parcel$interopDefault($lFKmC)))(getLabels, 500);
        }, [
            planId,
            scenarioId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            debouncedGetLabels(query);
        }, [
            debouncedGetLabels,
            query
        ]);
        return labels;
    };
    const $d2d904f87c741e20$var$useLabels = (planId, scenarioId)=>{
        const [labels, setLabels] = (0, $5uXOq.useState)([]);
        (0, $5uXOq.useEffect)(()=>{
            const getLabels = async ()=>{
                if (planId == null || scenarioId == null) throw Error('No planId or scenarioId from useLabels');
                try {
                    const raw = await $d2d904f87c741e20$export$f18317131e3a9f2c(planId, scenarioId);
                    if (raw.ok) {
                        const response = await raw.json();
                        const formattedResponse = response?.items?.map((item)=>({
                                value: item,
                                label: item
                            })) || [];
                        setLabels(formattedResponse);
                    } else throw Error('Failed to retrieve labels');
                } catch (e) {
                    throw Error('Failed to retrieve labels');
                }
            };
            getLabels();
        }, [
            planId,
            scenarioId
        ]);
        return labels;
    };
    const $d2d904f87c741e20$var$LabelSelect = ({ plan: plan, editedLabels: editedLabels, onLabelChange: onLabelChange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [currentTypedInput, setCurrentTypedInput] = (0, $5uXOq.useState)('');
        const [currentValue, setCurrentValue] = (0, $5uXOq.useState)(editedLabels);
        const planLabels = (0, (0, parcelRequire("4R6GH")).fg)('refetch_bulk_labels') ? $d2d904f87c741e20$var$useLabelsDebounced(plan.id, plan.currentScenarioId, currentTypedInput) : $d2d904f87c741e20$var$useLabels(plan.id, plan.currentScenarioId);
        const [options, setOptions] = (0, $5uXOq.useState)(planLabels);
        (0, $5uXOq.useEffect)(()=>{
            setOptions(planLabels.sort((a, b)=>a.label.localeCompare(b.label)));
        }, [
            planLabels
        ]);
        const handleChange = (newOption)=>{
            setCurrentValue(newOption);
            onLabelChange(newOption);
        };
        const handleCreate = (inputValue)=>{
            const newOption = {
                label: inputValue,
                value: inputValue
            };
            setOptions([
                ...options,
                newOption
            ].sort((a, b)=>a.label.localeCompare(b.label)));
            setCurrentValue([
                ...currentValue,
                newOption
            ]);
            onLabelChange([
                ...currentValue,
                newOption
            ]);
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_LABEL.split(' ');
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_LABEL);
        };
        const noOptionsMessage = (obj)=>{
            if (obj.inputValue.includes(' ')) return formatMessage((0, $4etIt.default).invalidInputWithSpace);
            if (obj.inputValue.trim().length > 255) return formatMessage((0, $4etIt.default).invalidInputWithMaxLength);
            return null;
        };
        const handleInputChange = (input)=>{
            setCurrentTypedInput(input);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cSDJf.default), {
            id: "label-select",
            placeholder: formatMessage((0, $4etIt.default).labelPlaceholder),
            isMulti: true,
            isSearchable: true,
            isClearable: true,
            isCreatable: true,
            closeMenuOnSelect: false,
            noOptionsMessage: noOptionsMessage,
            isValidNewOption: (newValue)=>newValue !== undefined && newValue.length > 0 && newValue.length <= $d2d904f87c741e20$var$MAX_FIELD_LENGTH && !newValue.includes(' '),
            value: currentValue,
            onChange: handleChange,
            onCreateOption: (x)=>handleCreate(x),
            onInputChange: handleInputChange,
            options: options,
            formatCreateLabel: (newValue)=>`${newValue} (${formatMessage((0, $4etIt.default).newLabel)})`,
            isTransparentBackground: false,
            styles: {
                input: (styles)=>({
                        ...styles,
                        width: currentTypedInput ? '100px' : '1px'
                    })
            },
            ...(0, (0, parcelRequire("4R6GH")).fg)('jira-portfolio-bulk-actions-button-name-a11y-fix') && {
                'aria-label': formatMessage((0, $4etIt.default).labelPlaceholder)
            }
        });
    };
    var $d2d904f87c741e20$export$2e2bcd8739ae039 = $d2d904f87c741e20$var$LabelSelect;
});
parcelRegister("4etIt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb54003458ab8c8c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cb54003458ab8c8c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        labelPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.label-select.label-placeholder",
            "defaultMessage": "Choose a label"
        },
        newLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.label-select.new-label",
            "defaultMessage": "New label"
        },
        invalidInputWithSpace: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.label-select.invalid-input-with-space",
            "defaultMessage": "Invalid input, labels can't contain spaces"
        },
        invalidInputWithMaxLength: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.label-select.invalid-input-with-max-length",
            "defaultMessage": "Invalid input, labels can't have more than 255 characters"
        }
    });
});
parcelRegister("5IHhZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$072a202f6c5bab93$export$2e2bcd8739ae039);
    var $7VHMR;
    var $072a202f6c5bab93$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        arrowRightLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.arrow-right-label",
            "defaultMessage": "Arrow right icon"
        },
        setHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.set-header",
            "defaultMessage": "Update labels"
        },
        variousValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.various-values",
            "defaultMessage": "Various labels"
        },
        noValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.no-values",
            "defaultMessage": "No labels"
        }
    });
});
parcelRegister("e0e2I", function(module, exports) {
    $parcel$export(module.exports, "current-container", ()=>$a31bf55bb573ccdb$export$88030eb8e5e39322, (v)=>$a31bf55bb573ccdb$export$88030eb8e5e39322 = v);
    $parcel$export(module.exports, "current-value-title", ()=>$a31bf55bb573ccdb$export$2c19fd1221dd0b06, (v)=>$a31bf55bb573ccdb$export$2c19fd1221dd0b06 = v);
    $parcel$export(module.exports, "form-group", ()=>$a31bf55bb573ccdb$export$55a1f87a143fb302, (v)=>$a31bf55bb573ccdb$export$55a1f87a143fb302 = v);
    $parcel$export(module.exports, "icon", ()=>$a31bf55bb573ccdb$export$1ca1ec8b29a4ce27, (v)=>$a31bf55bb573ccdb$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "new-value", ()=>$a31bf55bb573ccdb$export$18786265e3bc6811, (v)=>$a31bf55bb573ccdb$export$18786265e3bc6811 = v);
    $parcel$export(module.exports, "value-label", ()=>$a31bf55bb573ccdb$export$f2febdad47edd01a, (v)=>$a31bf55bb573ccdb$export$f2febdad47edd01a = v);
    $parcel$export(module.exports, "value-placeholder", ()=>$a31bf55bb573ccdb$export$16d768213d218756, (v)=>$a31bf55bb573ccdb$export$16d768213d218756 = v);
    var $a31bf55bb573ccdb$export$88030eb8e5e39322;
    var $a31bf55bb573ccdb$export$2c19fd1221dd0b06;
    var $a31bf55bb573ccdb$export$55a1f87a143fb302;
    var $a31bf55bb573ccdb$export$1ca1ec8b29a4ce27;
    var $a31bf55bb573ccdb$export$18786265e3bc6811;
    var $a31bf55bb573ccdb$export$f2febdad47edd01a;
    var $a31bf55bb573ccdb$export$16d768213d218756;
    $a31bf55bb573ccdb$export$88030eb8e5e39322 = `_8sj1zG_current-container`;
    $a31bf55bb573ccdb$export$2c19fd1221dd0b06 = `_8sj1zG_current-value-title`;
    $a31bf55bb573ccdb$export$55a1f87a143fb302 = `_8sj1zG_form-group`;
    $a31bf55bb573ccdb$export$1ca1ec8b29a4ce27 = `_8sj1zG_icon`;
    $a31bf55bb573ccdb$export$18786265e3bc6811 = `_8sj1zG_new-value`;
    $a31bf55bb573ccdb$export$f2febdad47edd01a = `_8sj1zG_value-label`;
    $a31bf55bb573ccdb$export$16d768213d218756 = `_8sj1zG_value-placeholder`;
});
parcelRegister("2vokC", function(module, exports) {
    $parcel$export(module.exports, "FieldAction", ()=>$54c0b1123a4256d0$export$4664dfdcfd25e124);
    const $54c0b1123a4256d0$export$4664dfdcfd25e124 = {
        SET: 'SET',
        ADD: 'ADD',
        REMOVE: 'REMOVE',
        CLEAR: 'CLEAR'
    };
});
parcelRegister("jr6pW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f2788077809e1c98$export$2e2bcd8739ae039);
    var $bC2fB;
    var $geeY6 = parcelRequire("geeY6");
    var $3VGSR = parcelRequire("3VGSR");
    var $jr2X0 = parcelRequire("jr2X0");
    var $f2788077809e1c98$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $3VGSR.default), (0, $geeY6.default))((0, $jr2X0.default));
});
parcelRegister("geeY6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$118b13faec5bf38f$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $118b13faec5bf38f$export$2e2bcd8739ae039 = {
        bulkUpdateAttribute: (0, $bkasS.bulkIssuesUpdate)
    };
});
parcelRegister("3VGSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0cb457282b4c4f39$export$2e2bcd8739ae039);
    var $kllqP = parcelRequire("kllqP");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $3YtPS = parcelRequire("3YtPS");
    var $iiS5F = parcelRequire("iiS5F");
    const $0cb457282b4c4f39$var$getIssueIdToProject = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getSelectedIssues),
        (0, $jpXKt.getProjectsById)
    ], (0, $iiS5F.getIssueIdToProjectPure));
    const $0cb457282b4c4f39$var$getIsSomeSelectedIssuesFromTMP = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getSelectedIssues),
        $0cb457282b4c4f39$var$getIssueIdToProject
    ], (0, $iiS5F.getIsSomeSelectedIssuesFromTMPPure));
    const $0cb457282b4c4f39$var$getIsSelectedIssuesFromMultipleProjects = (0, $3YtPS.createSelector)([
        (0, $bI9dZ.getSelectedIssues)
    ], (0, $iiS5F.getIsSelectedIssuesFromMultipleProjectsPure));
    var $0cb457282b4c4f39$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        issues: (0, $gFhwb.getIssues),
        issueTypesById: (0, $kllqP.getIssueTypesById),
        projectsById: (0, $jpXKt.getProjectsById),
        selectedIssues: (0, $bI9dZ.getSelectedIssues),
        isSomeSelectedIssuesFromTMP: $0cb457282b4c4f39$var$getIsSomeSelectedIssuesFromTMP,
        isSelectedIssuesFromMultipleProjects: $0cb457282b4c4f39$var$getIsSelectedIssuesFromMultipleProjects
    });
});
parcelRegister("iiS5F", function(module, exports) {
    $parcel$export(module.exports, "getIssueIdToProjectPure", ()=>$9927f70c4e5e480c$export$a5cafa90ff4074f6);
    $parcel$export(module.exports, "getIsSomeSelectedIssuesFromTMPPure", ()=>$9927f70c4e5e480c$export$bcc20fb54d62215a);
    $parcel$export(module.exports, "getIsSelectedIssuesFromMultipleProjectsPure", ()=>$9927f70c4e5e480c$export$2f25656bdb74fbc5);
    const $9927f70c4e5e480c$export$a5cafa90ff4074f6 = (issues, projectById)=>issues.reduce((acc, { id: id, project: projectId })=>{
            const project = projectById[projectId];
            if (project !== undefined) acc[id] = project;
            return acc;
        }, {});
    const $9927f70c4e5e480c$export$bcc20fb54d62215a = (selectedIssues, issueIdToProject)=>selectedIssues.some(({ id: id })=>issueIdToProject[id]?.isSimplified === true);
    const $9927f70c4e5e480c$export$2f25656bdb74fbc5 = (selectedIssues)=>new Set(selectedIssues.map(({ project: project })=>project)).size > 1;
});
parcelRegister("jr2X0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe6888cec3b2ffa8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $8RXs9;
    var $kqF3Q = parcelRequire("kqF3Q");
    var $ihPUd = parcelRequire("ihPUd");
    var $lX5Hj = parcelRequire("lX5Hj");
    var $3rTkf = parcelRequire("3rTkf");
    var $8LApf = parcelRequire("8LApf");
    class $fe6888cec3b2ffa8$var$SetParentDialog extends (0, $5uXOq.Component) {
        render() {
            const { bulkActionSuccess: bulkActionSuccess, bulkUpdateAttribute: bulkUpdateAttribute, intl: intl, issueTypesById: issueTypesById, toggleModalDialog: toggleModalDialog, selectedIssues: selectedIssues, UpdateAttributeForm: UpdateAttributeForm, isSomeSelectedIssuesFromTMP: isSomeSelectedIssuesFromTMP, projectsById: projectsById, issues: issues, isSelectedIssuesFromMultipleProjects: isSelectedIssuesFromMultipleProjects } = this.props;
            const { formatMessage: formatMessage } = intl;
            const { currentValue: currentValue, currentIssueTypeIcon: currentIssueTypeIcon } = this.getCurrentValue();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                shouldScrollInViewport: true,
                onClose: toggleModalDialog,
                width: (0, $lX5Hj.MODAL_DIALOG_WIDTH),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-parent"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $3rTkf.default).header))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(UpdateAttributeForm, {
                updatedAttributeType: (0, $lX5Hj.MOVE_ISSUES),
                options: (0, $8LApf.getParentSelectOptions)(intl, issueTypesById, selectedIssues, issues, projectsById, isSomeSelectedIssuesFromTMP, isSelectedIssuesFromMultipleProjects),
                currentValue: currentValue,
                currentIssueTypeIcon: currentIssueTypeIcon,
                warningMessage: isSomeSelectedIssuesFromTMP && isSelectedIssuesFromMultipleProjects ? formatMessage((0, $3rTkf.default).crossProjectReparentingWarning) : undefined,
                onCancel: toggleModalDialog,
                onSubmit: (formData, analyticsEvent)=>{
                    bulkUpdateAttribute(formData);
                    toggleModalDialog();
                    bulkActionSuccess(analyticsEvent);
                }
            }))));
        }
        constructor(...args){
            super(...args);
            this.getCurrentValue = ()=>{
                const { intl: { formatMessage: formatMessage }, selectedIssues: selectedIssues, issues: issues, issueTypesById: issueTypesById, projectsById: projectsById } = this.props;
                const firstValue = selectedIssues[0].parent || '';
                const isSameValue = !selectedIssues.some((issue)=>(issue.parent || '') !== firstValue);
                if (isSameValue && !firstValue) return {
                    currentValue: formatMessage((0, $ihPUd.default).none)
                };
                const parentIssue = issues.find((issue)=>issue.id === firstValue);
                if (isSameValue && parentIssue) {
                    const issue = (0, $kqF3Q.getIssueOption)(parentIssue, issueTypesById, projectsById);
                    return {
                        currentValue: issue.label,
                        currentIssueTypeIcon: issue.icon
                    };
                }
                return {
                    currentValue: formatMessage((0, $3rTkf.default).variousParents)
                };
            };
        }
    }
    var $fe6888cec3b2ffa8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($fe6888cec3b2ffa8$var$SetParentDialog);
});
parcelRegister("3rTkf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03b56a9e67c766ab$export$2e2bcd8739ae039);
    var $7VHMR;
    var $03b56a9e67c766ab$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-parent.header",
            "defaultMessage": "Move"
        },
        variousParents: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-parent.various-parents",
            "defaultMessage": "Various parents"
        },
        crossProjectReparentingWarning: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-parent.cross-project-reparenting-warning",
            "defaultMessage": "Issues from team-managed projects can't be moved to another project."
        }
    });
});
parcelRegister("8LApf", function(module, exports) {
    $parcel$export(module.exports, "getParentSelectOptions", ()=>$2c972a03eaf0f81f$export$cc0b71cd5db9ab68);
    var $kqF3Q = parcelRequire("kqF3Q");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    const $2c972a03eaf0f81f$export$7d9c45e8a7d2f39c = (issueTypesById, selectedIssues)=>{
        const { type: type } = selectedIssues[0];
        const selectedType = issueTypesById[type];
        return selectedType && selectedType.subTask;
    };
    const $2c972a03eaf0f81f$export$ab64a2584557c8a1 = (selectedIssues, issues, projectsById, isSomeSelectedIssuesFromTMP, isSelectedIssuesFromMultipleProjects)=>{
        if (selectedIssues.length === 0) return [];
        const { level: selectedLevel, project: selectedProject } = selectedIssues[0];
        for(let i = 0; i < selectedIssues.length; i++){
            if (selectedIssues[i].level !== selectedLevel) return [];
        }
        if (isSomeSelectedIssuesFromTMP && isSelectedIssuesFromMultipleProjects) return [];
        if (isSomeSelectedIssuesFromTMP) return issues.filter((issue)=>issue.level === selectedLevel + 1 && issue.project === selectedProject);
        return issues.filter((issue)=>issue.level === selectedLevel + 1 && projectsById[issue.project]?.isSimplified !== true);
    };
    const $2c972a03eaf0f81f$export$cc0b71cd5db9ab68 = (intl, issueTypesById, selectedIssues, issues, projectsById, isSomeSelectedIssuesFromTMP, isSelectedIssuesFromMultipleProjects)=>{
        const { formatMessage: formatMessage } = intl;
        const possibleParentOptions = $2c972a03eaf0f81f$export$ab64a2584557c8a1(selectedIssues, issues, projectsById, isSomeSelectedIssuesFromTMP, isSelectedIssuesFromMultipleProjects).map((issue)=>(0, $kqF3Q.getIssueOption)(issue, issueTypesById, projectsById));
        if (!$2c972a03eaf0f81f$export$7d9c45e8a7d2f39c(issueTypesById, selectedIssues)) possibleParentOptions.unshift({
            label: formatMessage((0, $ihPUd.default).none),
            value: (0, $TTKUQ.NONE)
        });
        return possibleParentOptions;
    };
});
parcelRegister("iUDPw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22f1e929592040a8$export$2e2bcd8739ae039);
    var $bC2fB;
    var $8eDEl = parcelRequire("8eDEl");
    var $6Kx5K = parcelRequire("6Kx5K");
    var $22f1e929592040a8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $8eDEl.default))((0, $6Kx5K.default));
});
parcelRegister("8eDEl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05bb7f06790dd1fd$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $05bb7f06790dd1fd$export$2e2bcd8739ae039 = {
        bulkUpdateRank: (0, $bkasS.bulkRankIssue)
    };
});
parcelRegister("6Kx5K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f24b06702b6442c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $8RXs9;
    var $lX5Hj = parcelRequire("lX5Hj");
    var $icLag = parcelRequire("icLag");
    var $l5CSs = parcelRequire("l5CSs");
    class $6f24b06702b6442c$var$SetRankDialog extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                SetRankForm: $l5CSs.default
            };
        }
        render() {
            const { intl: intl, toggleModalDialog: toggleModalDialog, SetRankForm: SetRankForm } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                shouldScrollInViewport: true,
                onClose: toggleModalDialog,
                width: (0, $lX5Hj.MODAL_DIALOG_WIDTH),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, intl.formatMessage((0, $icLag.default).setHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(SetRankForm, {
                onCancel: toggleModalDialog,
                onSubmit: this.submitForm
            }))));
        }
        constructor(...args){
            super(...args);
            this.submitForm = (formData, analyticsEvent)=>{
                const { bulkUpdateRank: bulkUpdateRank, toggleModalDialog: toggleModalDialog, bulkActionSuccess: bulkActionSuccess } = this.props;
                bulkUpdateRank(formData);
                toggleModalDialog();
                bulkActionSuccess(analyticsEvent);
            };
        }
    }
    var $6f24b06702b6442c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($6f24b06702b6442c$var$SetRankDialog);
});
parcelRegister("icLag", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc792007d7fdcf8a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cc792007d7fdcf8a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-header",
            "defaultMessage": "Update rank"
        }
    });
});
parcelRegister("l5CSs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13cd6bc937371b36$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7buhq = parcelRequire("7buhq");
    var $iw9nm = parcelRequire("iw9nm");
    var $13cd6bc937371b36$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7buhq.default), {})((0, $iw9nm.default));
});
parcelRegister("7buhq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$daba8bdb38927740$export$2e2bcd8739ae039);
    var $8QpSo;
    var $kllqP = parcelRequire("kllqP");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $jpXKt = parcelRequire("jpXKt");
    var $lJNM1 = parcelRequire("lJNM1");
    const $daba8bdb38927740$var$mapStateToPropsFactory = ()=>{
        const getAncestorsFactory = (0, (0, parcelRequire("8QpSo")).default)((state)=>(issueId)=>(0, $lJNM1.getAncestors)(state, {
                    issueId: issueId
                }));
        return (state)=>({
                allSortedIssues: (0, $bI9dZ.getAllSortedIssues)(state),
                getAncestors: getAncestorsFactory(state),
                issueTypesById: (0, $kllqP.getIssueTypesById)(state),
                projectsById: (0, $jpXKt.getProjectsById)(state),
                selectedIssues: (0, $bI9dZ.getSelectedIssues)(state)
            });
    };
    const $daba8bdb38927740$var$mapStateToProps = $daba8bdb38927740$var$mapStateToPropsFactory;
    var $daba8bdb38927740$export$2e2bcd8739ae039 = $daba8bdb38927740$var$mapStateToProps;
});
parcelRegister("iw9nm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$610b45360dde81c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ldJSL;
    var $7O4UO;
    var $qfj8c;
    var $8RBk4;
    var $koVbs;
    var $aCpcO;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $iqIcG;
    var $kqF3Q = parcelRequire("kqF3Q");
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    var $bdoQ6 = parcelRequire("bdoQ6");
    var $gFMcF = parcelRequire("gFMcF");
    var $h11nd = parcelRequire("h11nd");
    var $btkeP = parcelRequire("btkeP");
    function $610b45360dde81c1$export$2e2bcd8739ae039({ allSortedIssues: allSortedIssues, getAncestors: getAncestors, issueTypesById: issueTypesById, onCancel: onCancel, onSubmit: onSubmit, projectsById: projectsById, selectedIssues: selectedIssues = [] }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [operationTypeFieldValue, setOperationTypeFieldValue] = (0, $5uXOq.useState)((0, $5fACX.RANK_TOP));
        const [anchorFieldValue, setAnchorFieldValue] = (0, $5uXOq.useState)();
        const handleSubmit = (_, analyticsEvent)=>{
            const formData = {
                operationType: operationTypeFieldValue
            };
            if (anchorFieldValue) formData.anchor = anchorFieldValue;
            onSubmit(formData, analyticsEvent);
        };
        const getCurrentValue = ()=>{
            if (selectedIssues.length === 1) {
                const index = allSortedIssues.findIndex(({ id: id })=>id === selectedIssues[0].id);
                return formatMessage((0, $gFMcF.default).currentValue, {
                    currentValue: index + 1
                });
            }
            return formatMessage((0, $gFMcF.default).variousValues);
        };
        const getUniqueSelectedIssuesIds = ()=>new Set(selectedIssues.map(({ id: id })=>id));
        const getPossibleIssues = ()=>{
            const selectedIssuesIds = getUniqueSelectedIssuesIds();
            return allSortedIssues.filter(({ id: id })=>!selectedIssuesIds.has(id));
        };
        const getSelectIssueOptions = ()=>getPossibleIssues().map((issue)=>(0, $kqF3Q.getIssueOption)(issue, issueTypesById, projectsById));
        const renderOptionRank = ()=>{
            const rankMapOptions = allSortedIssues.reduce((acc, { id: id }, i)=>{
                acc[id] = i + 1;
                return acc;
            }, {});
            if (anchorFieldValue && rankMapOptions[anchorFieldValue]) return formatMessage((0, $gFMcF.default).optionRankLabel, {
                currentIndex: rankMapOptions[anchorFieldValue]
            });
            return null;
        };
        const renderInfoMessage = ()=>{
            const { issuesWithLowerPosition: issuesWithLowerPosition, issuesWithHigherPosition: issuesWithHigherPosition } = (0, $btkeP.findSelectedIssuesWithLowerPosition)({
                allSortedIssues: allSortedIssues,
                anchorFieldValue: anchorFieldValue,
                getAncestors: getAncestors,
                issues: getPossibleIssues(),
                operationTypeFieldValue: operationTypeFieldValue,
                selectedIdsSet: getUniqueSelectedIssuesIds(),
                selectedIssues: selectedIssues
            });
            return issuesWithLowerPosition.length || issuesWithHigherPosition.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bdoQ6.default), {
                issueTypesById: issueTypesById,
                issuesWithHigherPosition: issuesWithHigherPosition,
                issuesWithLowerPosition: issuesWithLowerPosition,
                projectsById: projectsById,
                isDefaultFlyoutOpen: false
            }) : null;
        };
        const rankPositions = [
            {
                label: formatMessage((0, $gFMcF.default).rankTop),
                value: (0, $5fACX.RANK_TOP)
            },
            {
                label: formatMessage((0, $gFMcF.default).rankLast),
                value: (0, $5fACX.RANK_LAST)
            },
            {
                label: formatMessage((0, $gFMcF.default).rankBefore),
                value: (0, $5fACX.RANK_BEFORE)
            },
            {
                label: formatMessage((0, $gFMcF.default).rankAfter),
                value: (0, $5fACX.RANK_AFTER)
            }
        ];
        const issueOptions = getSelectIssueOptions();
        const isFormInvalid = ()=>{
            if (operationTypeFieldValue === (0, $5fACX.RANK_TOP) || operationTypeFieldValue === (0, $5fACX.RANK_LAST)) return false;
            if ((operationTypeFieldValue === (0, $5fACX.RANK_BEFORE) || operationTypeFieldValue === (0, $5fACX.RANK_AFTER)) && !(0, $4nDwW.isDefined)(anchorFieldValue)) return true;
            return false;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            className: $h11nd["form-group"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $h11nd["current-value"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $h11nd["value-label"]
        }, formatMessage((0, $ihPUd.default).current)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $h11nd["value-placeholder"]
        }, getCurrentValue())), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $h11nd.icon
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
            label: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $h11nd["operation-type"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            isRequired: true,
            label: formatMessage((0, $ihPUd.default).new),
            name: "operationTypeFieldValue"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                ...fieldProps,
                defaultValue: rankPositions[0],
                onChange: (option)=>{
                    option && setOperationTypeFieldValue(option.value);
                },
                options: rankPositions,
                value: rankPositions.find((v)=>v.value === operationTypeFieldValue),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.ak-select"
            }))), (operationTypeFieldValue === (0, $5fACX.RANK_BEFORE) || operationTypeFieldValue === (0, $5fACX.RANK_AFTER)) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $h11nd.anchor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            isRequired: true,
            name: "anchorFieldValue"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                ...fieldProps,
                defaultValue: undefined,
                formatOptionLabel: (0, (0, parcelRequire("iqIcG")).selectIssueOption),
                onChange: (option)=>{
                    option && setAnchorFieldValue(option.value);
                },
                options: issueOptions,
                placeholder: formatMessage((0, $gFMcF.default).chooseValuePlaceholder),
                value: issueOptions.find((v)=>v.value === anchorFieldValue)
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, renderOptionRank()))), renderInfoMessage(), (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            className: $h11nd["form-footer"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            onClick: onCancel
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "primary",
            isDisabled: isFormInvalid(),
            onClick: handleSubmit
        }, formatMessage((0, $ihPUd.default).apply)))));
    }
});
parcelRegister("bdoQ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c8fc88c33d87173$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $2C7j9;
    var $bjGSs;
    var $c8oLN;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $92Z2l;
    var $4R6GH;
    var $ousew;
    var $8RXs9;
    var $aCpcO;
    var $gJZ5D;
    var $J8W7q;
    var $2FvnI;
    var $ihPUd = parcelRequire("ihPUd");
    var $fOa0Q = parcelRequire("fOa0Q");
    var $hkWN4 = parcelRequire("hkWN4");
    class $4c8fc88c33d87173$var$InfoMessage extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isDefaultFlyoutOpen: false
            };
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
                className: $hkWN4["section-message"]
            }, this.sectionMessageRenderer());
        }
        constructor(...args){
            super(...args);
            this.state = {
                lowerIssuesFlyout: this.props.isDefaultFlyoutOpen,
                higherIssuesFlyout: false
            };
            this.toggleFlyout = (flyoutType)=>{
                if (flyoutType === 'lowerIssuesFlyout' && !this.state.lowerIssuesFlyout) this.setState(()=>({
                        lowerIssuesFlyout: true,
                        higherIssuesFlyout: false
                    }));
                else if (flyoutType === 'higherIssuesFlyout' && !this.state.higherIssuesFlyout) this.setState(()=>({
                        higherIssuesFlyout: true,
                        lowerIssuesFlyout: false
                    }));
                else this.closeFlyout();
            };
            this.closeFlyout = ()=>{
                this.setState(()=>({
                        lowerIssuesFlyout: false,
                        higherIssuesFlyout: false
                    }));
            };
            this.issueOptionRenderer = (issue, i)=>{
                const { projectsById: projectsById, issueTypesById: issueTypesById } = this.props;
                const projectKey = issue.project && projectsById[issue.project] && projectsById[issue.project].key || '';
                const issueTypeIconUrl = issueTypesById[issue.type] && issueTypesById[issue.type].iconUrl;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $hkWN4["issue-option-wrapper"],
                    key: `${i}-option`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $hkWN4["issue-type-icon"],
                    style: {
                        backgroundSize: 'contain',
                        backgroundImage: `url(${issueTypeIconUrl})`
                    }
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $hkWN4.link
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvnI")).default), {
                    issueKey: issue.issueKey,
                    projectKey: projectKey
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $hkWN4["issue-label"],
                    title: issue.summary
                }, issue.summary)));
            };
            this.renderFlyout = (issues)=>{
                const { intl: intl } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $4c8fc88c33d87173$var$flyoutStyles,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.div"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8oLN")).default), {
                    block: "space.100",
                    inline: "space.200",
                    xcss: $4c8fc88c33d87173$var$closeFlyoutStyles
                }, (0, (0, parcelRequire("4R6GH")).fg)('jira-portfolio-bulk-actions-button-name-a11y-fix') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "subtle-link",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                        label: ""
                    }),
                    onClick: ()=>this.closeFlyout(),
                    "aria-label": intl.formatMessage((0, $ihPUd.default).close)
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "subtle-link",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2C7j9"))))), {
                        label: "",
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.editor-close-icon",
                        primaryColor: `var(--ds-text-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N200})`
                    }),
                    onClick: ()=>this.closeFlyout(),
                    spacing: "none",
                    "aria-label": intl.formatMessage((0, $ihPUd.default).close)
                })), issues.map(this.issueOptionRenderer));
            };
            this.renderInlineDialog = (issues, flyoutType)=>{
                const { intl: intl } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $hkWN4["inline-dialog-container"]
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                    content: this.renderFlyout(issues),
                    isOpen: this.state[flyoutType],
                    placement: "bottom",
                    noHorizontalScroll: true,
                    classNames: "inline-dialog",
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.inline-dialog"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.button",
                    appearance: "link",
                    spacing: "none",
                    onClick: ()=>this.toggleFlyout(flyoutType)
                }, intl.formatMessage((0, $fOa0Q.default).linkLabel, {
                    issueCount: issues.length
                })))));
            };
            this.sectionMessageRenderer = ()=>{
                const { issuesWithLowerPosition: issuesWithLowerPosition, issuesWithHigherPosition: issuesWithHigherPosition } = this.props;
                if (!issuesWithLowerPosition.length && !issuesWithHigherPosition.length) return null;
                if (issuesWithLowerPosition.length && issuesWithHigherPosition.length) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
                    appearance: "information"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "span"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $fOa0Q.default).flagMessageTitlePart)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "ul"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "li"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, $fOa0Q.default).flagMessageLowerPositionPart,
                    values: {
                        issuesWithLowerPosition: this.renderInlineDialog(issuesWithLowerPosition, 'lowerIssuesFlyout')
                    }
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "li"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, $fOa0Q.default).flagMessageHigherPositionPart,
                    values: {
                        issuesWithHigherPosition: this.renderInlineDialog(issuesWithHigherPosition, 'higherIssuesFlyout')
                    }
                })))));
                if (issuesWithLowerPosition.length) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
                    appearance: "information"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $fOa0Q.default).flagMessageTitlePart), ', ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, $fOa0Q.default).flagMessageLowerPositionPart,
                    values: {
                        issuesWithLowerPosition: this.renderInlineDialog(issuesWithLowerPosition, 'lowerIssuesFlyout')
                    }
                }));
                if (issuesWithHigherPosition.length) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
                    appearance: "information"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $fOa0Q.default).flagMessageTitlePart), ', ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, $fOa0Q.default).flagMessageHigherPositionPart,
                    values: {
                        issuesWithHigherPosition: this.renderInlineDialog(issuesWithHigherPosition, 'higherIssuesFlyout')
                    }
                }));
            };
        }
    }
    var $4c8fc88c33d87173$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($4c8fc88c33d87173$var$InfoMessage);
    const $4c8fc88c33d87173$var$flyoutStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxWidth: '480px',
        position: 'relative',
        paddingTop: 'space.100',
        paddingRight: 'space.150',
        paddingBottom: 'space.050',
        paddingLeft: '0'
    });
    const $4c8fc88c33d87173$var$closeFlyoutStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: '0',
        right: '0'
    });
});
parcelRegister("fOa0Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f00c5a3bebe08a9f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f00c5a3bebe08a9f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        flagMessageTitlePart: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.flag-message-title-part",
            "defaultMessage": "When viewed in a hierarchy"
        },
        flagMessageLowerPositionPart: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.flag-message-lower-position-part",
            "defaultMessage": "{issuesWithLowerPosition} will appear to be ranked lower than their actual rank."
        },
        flagMessageHigherPositionPart: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.flag-message-higher-position-part",
            "defaultMessage": "{issuesWithHigherPosition} will appear to be ranked higher than their actual rank."
        },
        linkLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.link-label",
            "defaultMessage": "{issueCount, plural, one {# issue} other {# issues}}"
        },
        setRankInfoMessageCloseIconLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.close-icon-label",
            "defaultMessage": "Set rank info message close icon"
        }
    });
});
parcelRegister("hkWN4", function(module, exports) {
    $parcel$export(module.exports, "inline-dialog-container", ()=>$c9f1e87de9d90738$export$ac9bfbba4987a017, (v)=>$c9f1e87de9d90738$export$ac9bfbba4987a017 = v);
    $parcel$export(module.exports, "issue-label", ()=>$c9f1e87de9d90738$export$8dbc59d0fe020d7e, (v)=>$c9f1e87de9d90738$export$8dbc59d0fe020d7e = v);
    $parcel$export(module.exports, "issue-option-wrapper", ()=>$c9f1e87de9d90738$export$2916d4d56de3dd7, (v)=>$c9f1e87de9d90738$export$2916d4d56de3dd7 = v);
    $parcel$export(module.exports, "issue-type-icon", ()=>$c9f1e87de9d90738$export$175e354db6e532ed, (v)=>$c9f1e87de9d90738$export$175e354db6e532ed = v);
    $parcel$export(module.exports, "link", ()=>$c9f1e87de9d90738$export$9c30223ca0a664fb, (v)=>$c9f1e87de9d90738$export$9c30223ca0a664fb = v);
    $parcel$export(module.exports, "section-message", ()=>$c9f1e87de9d90738$export$b103f4e356fcb334, (v)=>$c9f1e87de9d90738$export$b103f4e356fcb334 = v);
    var $c9f1e87de9d90738$export$2e29e128697799d1;
    var $c9f1e87de9d90738$export$ac9bfbba4987a017;
    var $c9f1e87de9d90738$export$8dbc59d0fe020d7e;
    var $c9f1e87de9d90738$export$2916d4d56de3dd7;
    var $c9f1e87de9d90738$export$175e354db6e532ed;
    var $c9f1e87de9d90738$export$9c30223ca0a664fb;
    var $c9f1e87de9d90738$export$b103f4e356fcb334;
    $c9f1e87de9d90738$export$2e29e128697799d1 = `HoAo0W_close-icon`;
    $c9f1e87de9d90738$export$ac9bfbba4987a017 = `HoAo0W_inline-dialog-container`;
    $c9f1e87de9d90738$export$8dbc59d0fe020d7e = `HoAo0W_issue-label`;
    $c9f1e87de9d90738$export$2916d4d56de3dd7 = `HoAo0W_issue-option-wrapper`;
    $c9f1e87de9d90738$export$175e354db6e532ed = `HoAo0W_issue-type-icon`;
    $c9f1e87de9d90738$export$9c30223ca0a664fb = `HoAo0W_link`;
    $c9f1e87de9d90738$export$b103f4e356fcb334 = `HoAo0W_section-message`;
});
parcelRegister("gFMcF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52343692b64d8416$export$2e2bcd8739ae039);
    var $7VHMR;
    var $52343692b64d8416$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        currentValuePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.current-value-placeholder",
            "defaultMessage": "Various ranks"
        },
        chooseValuePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.choose-value-placeholder",
            "defaultMessage": "Choose an issue"
        },
        rankTop: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.rank-top",
            "defaultMessage": "Top of plan"
        },
        rankLast: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.rank-last",
            "defaultMessage": "Bottom of plan"
        },
        rankBefore: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.rank-before",
            "defaultMessage": "Above issue"
        },
        rankAfter: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.rank-after",
            "defaultMessage": "Below issue"
        },
        currentValue: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.current-value",
            "defaultMessage": "{currentValue, selectordinal, one {#st} two {#nd} few {#rd} other{#th}}"
        },
        variousValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.various-values",
            "defaultMessage": "Various ranks"
        },
        optionRankLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.option-rank-label",
            "defaultMessage": "Rank {currentIndex, selectordinal, one {#st} two {#nd} few {#rd} other{#th}} in plan"
        }
    });
});
parcelRegister("h11nd", function(module, exports) {
    $parcel$export(module.exports, "anchor", ()=>$c6339868d3f72aa6$export$2e2992790a6f69a8, (v)=>$c6339868d3f72aa6$export$2e2992790a6f69a8 = v);
    $parcel$export(module.exports, "current-value", ()=>$c6339868d3f72aa6$export$bd70860eb87e972b, (v)=>$c6339868d3f72aa6$export$bd70860eb87e972b = v);
    $parcel$export(module.exports, "form-footer", ()=>$c6339868d3f72aa6$export$536347ba10a26096, (v)=>$c6339868d3f72aa6$export$536347ba10a26096 = v);
    $parcel$export(module.exports, "form-group", ()=>$c6339868d3f72aa6$export$55a1f87a143fb302, (v)=>$c6339868d3f72aa6$export$55a1f87a143fb302 = v);
    $parcel$export(module.exports, "icon", ()=>$c6339868d3f72aa6$export$1ca1ec8b29a4ce27, (v)=>$c6339868d3f72aa6$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "operation-type", ()=>$c6339868d3f72aa6$export$a5810537250b846d, (v)=>$c6339868d3f72aa6$export$a5810537250b846d = v);
    $parcel$export(module.exports, "value-label", ()=>$c6339868d3f72aa6$export$f2febdad47edd01a, (v)=>$c6339868d3f72aa6$export$f2febdad47edd01a = v);
    $parcel$export(module.exports, "value-placeholder", ()=>$c6339868d3f72aa6$export$16d768213d218756, (v)=>$c6339868d3f72aa6$export$16d768213d218756 = v);
    var $c6339868d3f72aa6$export$2e2992790a6f69a8;
    var $c6339868d3f72aa6$export$bd70860eb87e972b;
    var $c6339868d3f72aa6$export$536347ba10a26096;
    var $c6339868d3f72aa6$export$55a1f87a143fb302;
    var $c6339868d3f72aa6$export$1ca1ec8b29a4ce27;
    var $c6339868d3f72aa6$export$a5810537250b846d;
    var $c6339868d3f72aa6$export$f2febdad47edd01a;
    var $c6339868d3f72aa6$export$16d768213d218756;
    $c6339868d3f72aa6$export$2e2992790a6f69a8 = `_1B3yza_anchor`;
    $c6339868d3f72aa6$export$bd70860eb87e972b = `_1B3yza_current-value`;
    $c6339868d3f72aa6$export$536347ba10a26096 = `_1B3yza_form-footer`;
    $c6339868d3f72aa6$export$55a1f87a143fb302 = `_1B3yza_form-group`;
    $c6339868d3f72aa6$export$1ca1ec8b29a4ce27 = `_1B3yza_icon`;
    $c6339868d3f72aa6$export$a5810537250b846d = `_1B3yza_operation-type`;
    $c6339868d3f72aa6$export$f2febdad47edd01a = `_1B3yza_value-label`;
    $c6339868d3f72aa6$export$16d768213d218756 = `_1B3yza_value-placeholder`;
});
parcelRegister("btkeP", function(module, exports) {
    $parcel$export(module.exports, "findSelectedIssuesWithLowerPosition", ()=>$b8aa71daaa14a9ba$export$7b9e63090edd886b);
    var $78izu;
    var $73eiZ;
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    const $b8aa71daaa14a9ba$export$ad9e6c0d0da0679b = (anchor, issues, selectedIdsSet)=>{
        const allSortedIssuesWithNewRank = issues.map((issue)=>{
            if (selectedIdsSet.has(issue.id)) return {
                ...issue,
                lexoRank: anchor.lexoRank
            };
            return issue;
        });
        return (0, $4nDwW.indexBy)((issue)=>issue.id, allSortedIssuesWithNewRank);
    };
    const $b8aa71daaa14a9ba$export$7b9e63090edd886b = ({ allSortedIssues: allSortedIssues, anchorFieldValue: anchorFieldValue, getAncestors: getAncestors, issues: issues, operationTypeFieldValue: operationTypeFieldValue, selectedIdsSet: selectedIdsSet, selectedIssues: selectedIssues })=>{
        switch(operationTypeFieldValue){
            case 0, $5fACX.RANK_TOP:
                {
                    const issuesWithLowerPosition = selectedIssues.filter(({ id: id })=>{
                        const ancestors = getAncestors(id);
                        return (0, parcelRequire("78izu")).default((x, y)=>x.id === y.id, ancestors, selectedIssues).length;
                    });
                    return {
                        issuesWithLowerPosition: issuesWithLowerPosition,
                        issuesWithHigherPosition: []
                    };
                }
            case 0, $5fACX.RANK_LAST:
                {
                    const anchor = (0, parcelRequire("73eiZ")).default(({ id: id })=>!selectedIdsSet.has(id), allSortedIssues);
                    if (!anchor) return {
                        issuesWithLowerPosition: [],
                        issuesWithHigherPosition: []
                    };
                    const issuesMapByIdWithNewRank = $b8aa71daaa14a9ba$export$ad9e6c0d0da0679b(anchor, issues, selectedIdsSet);
                    const issuesWithHigherPosition = selectedIssues.filter(({ id: id })=>{
                        const ancestors = getAncestors(id).map(({ id: id })=>issuesMapByIdWithNewRank[id]).filter((el)=>!!el);
                        return ancestors.length ? ancestors.some(({ lexoRank: ancestorLexoRank, id: ancestorId })=>issues.some(({ lexoRank: lexoRank, id: id })=>lexoRank >= ancestorLexoRank && ancestorId !== id)) : [];
                    });
                    return {
                        issuesWithLowerPosition: [],
                        issuesWithHigherPosition: issuesWithHigherPosition
                    };
                }
            default:
                {
                    const anchor = anchorFieldValue && allSortedIssues.find(({ id: id })=>id === anchorFieldValue);
                    if (!anchor) return {
                        issuesWithLowerPosition: [],
                        issuesWithHigherPosition: []
                    };
                    const issuesMapByIdWithNewRank = $b8aa71daaa14a9ba$export$ad9e6c0d0da0679b(anchor, issues, selectedIdsSet);
                    const issuesWithLowerPosition = [];
                    const issuesWithHigherPosition = [];
                    for (const issue of selectedIssues){
                        const { id: id, lexoRank: selectedLexoRank } = selectedIdsSet.has(issue.id) ? {
                            ...issue,
                            lexoRank: anchor.lexoRank
                        } : issue;
                        const ancestors = getAncestors(id).map((el)=>issuesMapByIdWithNewRank[el.id]).filter((el)=>!!el);
                        if (!ancestors.length) return {
                            issuesWithLowerPosition: issuesWithLowerPosition,
                            issuesWithHigherPosition: issuesWithHigherPosition
                        };
                        if (ancestors.some(({ lexoRank: lexoRank })=>operationTypeFieldValue === (0, $5fACX.RANK_AFTER) ? selectedLexoRank < lexoRank : selectedLexoRank <= lexoRank)) issuesWithLowerPosition.push(issue);
                        else if (ancestors.some(({ lexoRank: ancestorLexoRank, id: ancestorId })=>issues.some(({ lexoRank: lexoRank, id: id })=>lexoRank >= ancestorLexoRank && ancestorId !== id))) issuesWithHigherPosition.push(issue);
                    }
                    return {
                        issuesWithLowerPosition: issuesWithLowerPosition,
                        issuesWithHigherPosition: issuesWithHigherPosition
                    };
                }
        }
    };
});
parcelRegister("7FPZL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b00e35c063480e21$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3Ugob = parcelRequire("3Ugob");
    var $6BOzY = parcelRequire("6BOzY");
    var $37sOK = parcelRequire("37sOK");
    var $b00e35c063480e21$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6BOzY.default), (0, $3Ugob.default))((0, $37sOK.default));
});
parcelRegister("3Ugob", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d8d25791a9efe52$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $3d8d25791a9efe52$export$2e2bcd8739ae039 = {
        bulkUpdateAttribute: (0, $bkasS.bulkIssuesUpdate)
    };
});
parcelRegister("6BOzY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68ed729205a75b88$export$2e2bcd8739ae039);
    var $bI9dZ = parcelRequire("bI9dZ");
    var $gFhwb = parcelRequire("gFhwb");
    var $d3quy = parcelRequire("d3quy");
    var $dRVQG = parcelRequire("dRVQG");
    var $3YtPS = parcelRequire("3YtPS");
    var $68ed729205a75b88$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedIssues: (0, $bI9dZ.getSelectedIssues),
        issues: (0, $gFhwb.getIssues),
        sprints: (0, $d3quy.getSprints),
        sprintsByTeam: (0, $d3quy.getSprintsForTeam),
        teamsById: (0, $dRVQG.getTeamsById),
        teams: (0, $dRVQG.getTeams),
        sprintsByIssueSources: (0, $d3quy.getSprintsForIssueSources),
        additionalTeamsById: (0, $dRVQG.getAdditionalTeamsById)
    });
});
parcelRegister("37sOK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66ddac2a912cdc07$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8EB5I;
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $8RXs9;
    var $6TEBn = parcelRequire("6TEBn");
    var $ihPUd = parcelRequire("ihPUd");
    var $lX5Hj = parcelRequire("lX5Hj");
    var $3dCGd = parcelRequire("3dCGd");
    class $66ddac2a912cdc07$var$SetSprintDialog extends (0, $5uXOq.Component) {
        render() {
            const { intl: { formatMessage: formatMessage }, toggleModalDialog: toggleModalDialog, bulkUpdateAttribute: bulkUpdateAttribute, UpdateAttributeForm: UpdateAttributeForm, bulkActionSuccess: bulkActionSuccess } = this.props;
            const groupedOptions = this.getGroupedOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                shouldScrollInViewport: true,
                onClose: toggleModalDialog,
                width: (0, $lX5Hj.MODAL_DIALOG_WIDTH),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-sprint"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $3dCGd.default).setHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(UpdateAttributeForm, {
                updatedAttributeType: (0, $lX5Hj.SET_SPRINT),
                currentValue: this.getCurrentValue(),
                options: groupedOptions,
                onCancel: toggleModalDialog,
                onSubmit: (formData, analyticsEvent)=>{
                    bulkUpdateAttribute(formData);
                    toggleModalDialog();
                    bulkActionSuccess(analyticsEvent);
                }
            }))));
        }
        constructor(...args){
            super(...args);
            this.getCurrentValue = ()=>{
                const { intl: { formatMessage: formatMessage }, selectedIssues: selectedIssues, sprints: sprints } = this.props;
                const firstValue = selectedIssues[0].sprint;
                const isSameValue = !selectedIssues.some((issue)=>!(0, parcelRequire("8EB5I")).default(issue.sprint, firstValue));
                if (isSameValue && !firstValue) return formatMessage((0, $ihPUd.default).none);
                const sprint = sprints.find((el)=>el.id === firstValue);
                if (isSameValue && firstValue && sprint) return sprint.title;
                return formatMessage((0, $3dCGd.default).variousValues);
            };
            this.getGroupedOptions = ()=>{
                const { additionalTeamsById: additionalTeamsById, intl: { formatMessage: formatMessage }, selectedIssues: selectedIssues, sprintsByTeam: sprintsByTeam, sprintsByIssueSources: sprintsByIssueSources, teams: teams, teamsById: teamsById } = this.props;
                const { sprint: sprintOfIssue, team: teamOfIssue } = selectedIssues[0];
                const otherSprintsLabel = formatMessage((0, $3dCGd.default).otherSprints);
                const futureSprintsGroupByTeam = (0, $6TEBn.getFutureSprintGroups)(teamOfIssue, sprintOfIssue, sprintsByIssueSources, sprintsByTeam, additionalTeamsById, teams, teamsById, otherSprintsLabel);
                const groupedOptions = [
                    {
                        options: [
                            {
                                label: formatMessage((0, $ihPUd.default).none),
                                value: 'NONE'
                            }
                        ]
                    }
                ];
                futureSprintsGroupByTeam.forEach((sprints, label)=>{
                    groupedOptions.push({
                        label: label,
                        options: sprints.map((s)=>({
                                value: s.id,
                                label: s.title
                            }))
                    });
                });
                return groupedOptions;
            };
        }
    }
    var $66ddac2a912cdc07$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($66ddac2a912cdc07$var$SetSprintDialog);
});
parcelRegister("3dCGd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cebe1238f9b029dd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cebe1238f9b029dd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-sprint.set-header",
            "defaultMessage": "Update sprint"
        },
        variousValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-sprint.various-values",
            "defaultMessage": "Various sprints"
        },
        otherSprints: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-sprint.other-sprints",
            "defaultMessage": "Other sprints"
        }
    });
});
parcelRegister("bnORa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4ddcf2c916ac32a$export$2e2bcd8739ae039);
    var $bC2fB;
    var $iEX1C = parcelRequire("iEX1C");
    var $7L5WC = parcelRequire("7L5WC");
    var $4GcSs = parcelRequire("4GcSs");
    var $f4ddcf2c916ac32a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7L5WC.default), (0, $iEX1C.default))((0, $4GcSs.default));
});
parcelRegister("iEX1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee0af63726e0e7ea$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $ee0af63726e0e7ea$export$2e2bcd8739ae039 = {
        bulkUpdateAttribute: (0, $bkasS.bulkIssuesUpdate)
    };
});
parcelRegister("7L5WC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd9e480ef7474c63$export$2e2bcd8739ae039);
    var $bI9dZ = parcelRequire("bI9dZ");
    var $dRVQG = parcelRequire("dRVQG");
    var $3YtPS = parcelRequire("3YtPS");
    var $fd9e480ef7474c63$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedIssues: (0, $bI9dZ.getSelectedIssues),
        teams: (0, $dRVQG.getTeams),
        teamsById: (0, $dRVQG.getAllTeamsById)
    });
});
parcelRegister("4GcSs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2c747e7eb3094a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8EB5I;
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $8RXs9;
    var $ihPUd = parcelRequire("ihPUd");
    var $lX5Hj = parcelRequire("lX5Hj");
    var $gho4a = parcelRequire("gho4a");
    class $d2c747e7eb3094a5$var$SetTeamsDialog extends (0, $5uXOq.Component) {
        render() {
            const { intl: { formatMessage: formatMessage }, toggleModalDialog: toggleModalDialog, bulkUpdateAttribute: bulkUpdateAttribute, teams: teams, UpdateAttributeForm: UpdateAttributeForm, bulkActionSuccess: bulkActionSuccess } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                shouldScrollInViewport: true,
                onClose: toggleModalDialog,
                width: (0, $lX5Hj.MODAL_DIALOG_WIDTH),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-teams"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $gho4a.default).setTeamHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(UpdateAttributeForm, {
                updatedAttributeType: (0, $lX5Hj.SET_TEAM),
                options: teams.map((el)=>({
                        value: el.id,
                        label: el.title
                    })),
                currentValue: this.getCurrentValue(),
                onCancel: toggleModalDialog,
                onSubmit: (formData, analyticsEvent)=>{
                    bulkUpdateAttribute(formData);
                    toggleModalDialog();
                    bulkActionSuccess(analyticsEvent);
                }
            }))));
        }
        constructor(...args){
            super(...args);
            this.getCurrentValue = ()=>{
                const { intl: { formatMessage: formatMessage }, selectedIssues: selectedIssues, teamsById: teamsById } = this.props;
                const firstValue = selectedIssues[0].team;
                const isSameValue = !selectedIssues.some((issue)=>!(0, parcelRequire("8EB5I")).default(issue.team, firstValue));
                if (isSameValue && !firstValue) return formatMessage((0, $ihPUd.default).none);
                if (isSameValue && firstValue) return teamsById[firstValue].title;
                return formatMessage((0, $gho4a.default).variousValues);
            };
        }
    }
    var $d2c747e7eb3094a5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($d2c747e7eb3094a5$var$SetTeamsDialog);
});
parcelRegister("gho4a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1535db8b3e6172d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c1535db8b3e6172d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setTeamHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-teams.set-team-header",
            "defaultMessage": "Update team"
        },
        variousValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-teams.various-values",
            "defaultMessage": "Various teams"
        }
    });
});
parcelRegister("eTADi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$081fa16907968ccb$export$2e2bcd8739ae039);
    var $bC2fB;
    var $22lmA = parcelRequire("22lmA");
    var $ffI6Z = parcelRequire("ffI6Z");
    var $gUzpE = parcelRequire("gUzpE");
    var $081fa16907968ccb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $ffI6Z.default), (0, $22lmA.default))((0, $gUzpE.default));
});
parcelRegister("22lmA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ef114c596e950b4$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $3ef114c596e950b4$export$2e2bcd8739ae039 = {
        bulkUpdateAttribute: (0, $bkasS.bulkIssuesUpdate)
    };
});
parcelRegister("ffI6Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a8197848b136638$export$2e2bcd8739ae039);
    var $jw86H = parcelRequire("jw86H");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $9FFuD = parcelRequire("9FFuD");
    var $3YtPS = parcelRequire("3YtPS");
    var $7a8197848b136638$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedIssues: (0, $bI9dZ.getSelectedIssues),
        versions: (0, $9FFuD.getVersions),
        versionsById: (0, $9FFuD.getVersionsById),
        crossProjectVersionsById: (0, $jw86H.getCrossProjectVersionsById),
        sortVersionsByHighestRank: (0, $9FFuD.getSortByHighestRank),
        sortVersionsByLowestRank: (0, $9FFuD.getSortByLowestRank)
    });
});
parcelRegister("gUzpE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dff99ffcebbb03b6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8EB5I;
    var $jVZZA;
    var $4Rr1a;
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $8RXs9;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $fFMsx = parcelRequire("fFMsx");
    var $lX5Hj = parcelRequire("lX5Hj");
    var $hEFep = parcelRequire("hEFep");
    class $dff99ffcebbb03b6$var$SetVersionsDialog extends (0, $5uXOq.Component) {
        getUnreleasedOptionsGroup(versions) {
            const { intl: { formatMessage: formatMessage }, crossProjectVersionsById: crossProjectVersionsById, sortVersionsByLowestRank: sortVersionsByLowestRank } = this.props;
            const unreleasedVersions = (0, parcelRequire("jVZZA")).default((version)=>version.releaseStatusId !== (0, $TTKUQ.RELEASE_STATUSES).RELEASED, versions);
            return {
                label: formatMessage((0, $hEFep.default).unreleased),
                options: (0, parcelRequire("4Rr1a")).default((version)=>(0, $fFMsx.createVersionOption)(version, crossProjectVersionsById), sortVersionsByLowestRank(unreleasedVersions))
            };
        }
        getReleasedOptionsGroup(versions) {
            const { intl: { formatMessage: formatMessage }, crossProjectVersionsById: crossProjectVersionsById, sortVersionsByHighestRank: sortVersionsByHighestRank } = this.props;
            const ReleasedVersions = (0, parcelRequire("jVZZA")).default((version)=>version.releaseStatusId === (0, $TTKUQ.RELEASE_STATUSES).RELEASED, versions);
            return {
                label: formatMessage((0, $hEFep.default).released),
                options: (0, parcelRequire("4Rr1a")).default((version)=>(0, $fFMsx.createVersionOption)(version, crossProjectVersionsById), sortVersionsByHighestRank(ReleasedVersions))
            };
        }
        render() {
            const { intl: { formatMessage: formatMessage }, toggleModalDialog: toggleModalDialog, bulkUpdateAttribute: bulkUpdateAttribute, UpdateAttributeForm: UpdateAttributeForm, bulkActionSuccess: bulkActionSuccess } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                shouldScrollInViewport: true,
                onClose: toggleModalDialog,
                width: (0, $lX5Hj.MODAL_DIALOG_WIDTH),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-versions"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $hEFep.default).setReleaseHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(UpdateAttributeForm, {
                updatedAttributeType: (0, $lX5Hj.SET_RELEASE),
                options: this.getOptions(),
                currentValue: this.getCurrentValue(),
                onCancel: toggleModalDialog,
                onSubmit: (formData, analyticsEvent)=>{
                    bulkUpdateAttribute(formData);
                    toggleModalDialog();
                    bulkActionSuccess(analyticsEvent);
                }
            }))));
        }
        constructor(...args){
            super(...args);
            this.getCurrentValue = ()=>{
                const { intl: { formatMessage: formatMessage }, selectedIssues: selectedIssues, versionsById: versionsById } = this.props;
                const firstValue = selectedIssues[0].fixVersions || [];
                const isSameValue = !selectedIssues.some((issue)=>!(0, parcelRequire("8EB5I")).default(issue.fixVersions || [], firstValue));
                if (isSameValue && !firstValue.length) return formatMessage((0, $ihPUd.default).none);
                if (isSameValue && firstValue.length) return firstValue.map((versionId)=>versionsById[versionId].name).join(', ');
                return formatMessage((0, $hEFep.default).variousValues);
            };
            this.getOptions = ()=>{
                const { versions: versions, selectedIssues: selectedIssues } = this.props;
                const projectOfIssues = selectedIssues[0].project;
                const versionsInProject = versions.filter((version)=>version.projects.includes(projectOfIssues));
                return [
                    this.getReleasedOptionsGroup(versionsInProject),
                    this.getUnreleasedOptionsGroup(versionsInProject)
                ];
            };
        }
    }
    var $dff99ffcebbb03b6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($dff99ffcebbb03b6$var$SetVersionsDialog);
});
parcelRegister("hEFep", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30596994f2480522$export$2e2bcd8739ae039);
    var $7VHMR;
    var $30596994f2480522$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setReleaseHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-versions.set-release-header",
            "defaultMessage": "Update release"
        },
        variousValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-versions.various-values",
            "defaultMessage": "Various releases"
        },
        released: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-versions.released",
            "defaultMessage": "Released"
        },
        unreleased: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-versions.unreleased",
            "defaultMessage": "Unreleased"
        }
    });
});
parcelRegister("aQZDz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e92c8420c897cbd$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bewLH = parcelRequire("bewLH");
    var $gnfqQ = parcelRequire("gnfqQ");
    var $0e92c8420c897cbd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $bewLH.default))((0, $gnfqQ.default));
});
parcelRegister("bewLH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f786a041fdddf12$export$2e2bcd8739ae039);
    var $5APQl = parcelRequire("5APQl");
    const $1f786a041fdddf12$var$mapDispatchToProps = (dispatch)=>({
            toggleExpansionIssuesInHierarchy: (isExpanded)=>{
                dispatch((0, $5APQl.toggleExpansionInHierarchy)({
                    isExpanded: isExpanded
                }));
            }
        });
    var $1f786a041fdddf12$export$2e2bcd8739ae039 = $1f786a041fdddf12$var$mapDispatchToProps;
});
parcelRegister("5APQl", function(module, exports) {
    $parcel$export(module.exports, "toggleExpansionInHierarchy", ()=>$1626a61d8eff8d06$export$40b195b9736bc1c1);
    $parcel$export(module.exports, "expandIssueWithAncestors", ()=>$1626a61d8eff8d06$export$bc4b62590296b977);
    $parcel$export(module.exports, "default", ()=>$1626a61d8eff8d06$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $7bnpM = parcelRequire("7bnpM");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $gFhwb = parcelRequire("gFhwb");
    var $4sJY8 = parcelRequire("4sJY8");
    var $jLI87 = parcelRequire("jLI87");
    var $2QLMT = parcelRequire("2QLMT");
    var $j0XCX = parcelRequire("j0XCX");
    var $21mdo = parcelRequire("21mdo");
    var $dBbgF = parcelRequire("dBbgF");
    var $bYhSc = parcelRequire("bYhSc");
    var $bkasS = parcelRequire("bkasS");
    const $1626a61d8eff8d06$export$b561bc689aa98a92 = 'command.scope.TOGGLE_EXPANSION_IN_HIERARCHY';
    const $1626a61d8eff8d06$export$9b3d94732c38bcaf = 'command.scope.EXPAND_ISSUE_WITH_ANCESTORS';
    const $1626a61d8eff8d06$export$40b195b9736bc1c1 = (payload)=>({
            type: $1626a61d8eff8d06$export$b561bc689aa98a92,
            payload: payload
        });
    function* $1626a61d8eff8d06$export$52581e97dce9708a({ payload: { isExpanded: isExpanded } }) {
        const filteredIssuesWithHierarchy = yield (0, $aNOuE.select)((0, $bI9dZ.getFilteredIssuesWithHierarchy));
        const visualisationGrouping = (yield (0, $aNOuE.select)((0, $j0XCX.getVisualisationGrouping))) || (0, $TTKUQ.GROUPING).NONE;
        const hierarchyFilter = yield (0, $aNOuE.select)((0, $7bnpM.getHierarchyFilter));
        const descendantsByParent = yield (0, $aNOuE.select)((0, $4sJY8.getDescendantsByParent));
        yield* (0, $bYhSc.default)(function*() {
            const collapseIssues = {};
            const headerIds = [
                'IssuesWithoutParentHeader'
            ];
            for(let i = hierarchyFilter.value.end; i <= hierarchyFilter.value.start; i++)headerIds.push(`IssuesWithoutParent-${i}`);
            if (visualisationGrouping === (0, $TTKUQ.GROUPING).NONE) {
                for (const issue of filteredIssuesWithHierarchy)if ((descendantsByParent[issue.id] || []).length > 0) collapseIssues[issue.id] = isExpanded;
                for (const header of headerIds)collapseIssues[header] = isExpanded;
            } else {
                const issuesByGroup = yield (0, $aNOuE.select)((0, $jLI87.getIssuesByGroup));
                const parentGroups = new Set();
                const filteredIssueIds = new Set(filteredIssuesWithHierarchy.map((x)=>x.id));
                for (const group of Object.values(issuesByGroup)){
                    const { issues: issues = new Set(), parentGroup: parentGroup, ...groupCombination } = group;
                    for (const issue of issues)if (filteredIssueIds.has(issue.id) && (descendantsByParent[issue.id] || []).length > 0) collapseIssues[`${issue.id}:${(0, $2QLMT.getGroupKey)(groupCombination) || (0, $TTKUQ.UNDEFINED_KEY)}`] = isExpanded;
                    for (const header of headerIds)collapseIssues[`${header}:${(0, $2QLMT.getGroupKey)(groupCombination) || (0, $TTKUQ.UNDEFINED_KEY)}`] = isExpanded;
                    yield (0, $aNOuE.put)((0, $dBbgF.toggleExpandGroup)({
                        grouping: visualisationGrouping,
                        groupName: (0, $2QLMT.getGroupKey)(groupCombination),
                        expand: isExpanded
                    }));
                    if (group.parentGroup) parentGroups.add(group.parentGroup);
                }
                for (const parentGroup of parentGroups)yield (0, $aNOuE.put)((0, $dBbgF.toggleExpandGroup)({
                    grouping: visualisationGrouping,
                    groupName: parentGroup,
                    expand: isExpanded
                }));
            }
            yield (0, $aNOuE.put)((0, $21mdo.setIsExpanded)(collapseIssues));
        });
        const hierarchyRange = hierarchyFilter.value.start - hierarchyFilter.value.end;
        if (isExpanded) yield (0, $aNOuE.put)((0, $bkasS.expandAllAnalytics)({
            hierarchyLevels: hierarchyRange
        }));
        else yield (0, $aNOuE.put)((0, $bkasS.collapseAllAnalytics)({
            hierarchyLevels: hierarchyRange
        }));
    }
    function* $1626a61d8eff8d06$export$1d9abc122ce2894a() {
        yield (0, $6u3NN.takeEvery)($1626a61d8eff8d06$export$b561bc689aa98a92, $1626a61d8eff8d06$export$52581e97dce9708a);
    }
    const $1626a61d8eff8d06$export$bc4b62590296b977 = ()=>({
            type: $1626a61d8eff8d06$export$9b3d94732c38bcaf
        });
    const $1626a61d8eff8d06$export$2679bca2f6357853 = (issueLevel, hierarchyStart)=>{
        const headerIds = issueLevel < hierarchyStart ? [
            'IssuesWithoutParentHeader'
        ] : [];
        for(let i = issueLevel; i < hierarchyStart; i++)headerIds.push(`IssuesWithoutParent-${i}`);
        return headerIds;
    };
    function* $1626a61d8eff8d06$export$2ac8e3b8f7b93709() {
        const activeSearch = yield (0, $aNOuE.select)((0, $jLI87.getActiveSearchIssue));
        if (!activeSearch) return;
        const { id: issueId, group: activeGroupName } = activeSearch;
        const { ancestors: ancestors = [] } = (yield (0, $aNOuE.select)((0, $bI9dZ.getParentAndDescendant)))[issueId] || {};
        const issueMapById = yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById));
        const issue = issueMapById[issueId];
        if (ancestors.length === 0) {
            let issueParentId = issue?.parent;
            while(issueParentId && issueMapById[issueParentId]){
                ancestors.push(issueMapById[issueParentId]);
                issueParentId = issueMapById[issueParentId].parent;
            }
        }
        const maxHierarchy = Math.max(...[
            ...ancestors,
            issue
        ].map(({ level: level })=>level));
        const { value: hierarchyValue } = yield (0, $aNOuE.select)((0, $7bnpM.getHierarchyFilter));
        const headerKeys = yield (0, $aNOuE.call)($1626a61d8eff8d06$export$2679bca2f6357853, maxHierarchy, hierarchyValue.start);
        let expandPayload;
        const visualisationGrouping = (yield (0, $aNOuE.select)((0, $j0XCX.getVisualisationGrouping))) || (0, $TTKUQ.GROUPING).NONE;
        if (visualisationGrouping === (0, $TTKUQ.GROUPING).NONE) {
            expandPayload = ancestors.reduce((acc, { id: id })=>Object.assign(acc, {
                    [id]: true
                }), {});
            for (const header of headerKeys)expandPayload[header] = true;
        } else {
            const groupCombinationByIssue = yield (0, $aNOuE.select)((0, $jLI87.getGroupCombinationByIssueId));
            const parentGroups = new Set();
            for (const { groupCombination: groupCombination, parentGroup: parentGroup } of groupCombinationByIssue[issueId]){
                const groupName = (0, $2QLMT.getGroupKey)(groupCombination);
                if (groupName === activeGroupName) {
                    if (parentGroup) parentGroups.add(parentGroup);
                    expandPayload = (ancestors || []).reduce((acc, { id: id })=>Object.assign(acc, {
                            [`${id}:${groupName || (0, $TTKUQ.UNDEFINED_KEY)}`]: true
                        }), {});
                    for (const header of headerKeys)expandPayload[`${header}:${groupName || (0, $TTKUQ.UNDEFINED_KEY)}`] = true;
                    for (const group of parentGroups)yield (0, $aNOuE.put)((0, $dBbgF.toggleExpandGroup)({
                        grouping: visualisationGrouping,
                        groupName: group,
                        expand: true
                    }));
                    yield (0, $aNOuE.put)((0, $dBbgF.toggleExpandGroup)({
                        grouping: visualisationGrouping,
                        groupName: groupName,
                        expand: true
                    }));
                }
            }
        }
        if (expandPayload) yield (0, $aNOuE.put)((0, $21mdo.setIsExpanded)(expandPayload));
    }
    function* $1626a61d8eff8d06$export$3fe79bd01779fcb5() {
        yield (0, $6u3NN.takeLatest)($1626a61d8eff8d06$export$9b3d94732c38bcaf, $1626a61d8eff8d06$export$2ac8e3b8f7b93709);
    }
    function* $1626a61d8eff8d06$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($1626a61d8eff8d06$export$1d9abc122ce2894a);
        yield (0, $aNOuE.fork)($1626a61d8eff8d06$export$3fe79bd01779fcb5);
    }
});
parcelRegister("gnfqQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3de18a80050e990e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $aRoVz;
    var $6Ingq;
    var $eTXmK;
    var $ousew;
    var $1iMQ1;
    var $1Cyfv = parcelRequire("1Cyfv");
    var $htUPi = parcelRequire("htUPi");
    function $3de18a80050e990e$var$CollapseMenu({ toggleExpansionIssuesInHierarchy: toggleExpansionIssuesInHierarchy }) {
        const renderMenu = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                onClick: (event)=>{
                    (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).EXPAND_ALL_ISSUES, event.timeStamp);
                    toggleExpansionIssuesInHierarchy(true);
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $htUPi.default).expandHierarchy)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                onClick: (event)=>{
                    (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).COLLAPSE_ALL_ISSUES, event.timeStamp);
                    toggleExpansionIssuesInHierarchy(false);
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $htUPi.default).collapseHierarchy)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...props,
                    ref: triggerRef,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.collapse-menu.trigger-btn",
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: ""
                    }),
                    appearance: "subtle"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $htUPi.default).buttonTitle))
        }, renderMenu());
    }
    var $3de18a80050e990e$export$2e2bcd8739ae039 = $3de18a80050e990e$var$CollapseMenu;
});
parcelRegister("htUPi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffa833fa8261f8a6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ffa833fa8261f8a6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        buttonTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.collapse-menu.button-title",
            "defaultMessage": "Issue"
        },
        collapseHierarchy: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.collapse-menu.collapse-hierarchy",
            "defaultMessage": "Collapse all"
        },
        expandHierarchy: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.collapse-menu.expand-hierarchy",
            "defaultMessage": "Expand all"
        }
    });
});
parcelRegister("esnSm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$265d412118d0cadc$export$2e2bcd8739ae039);
    var $bC2fB;
    var $85DEX = parcelRequire("85DEX");
    var $lySFc = parcelRequire("lySFc");
    var $iIVBW = parcelRequire("iIVBW");
    var $265d412118d0cadc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $lySFc.default), (0, $85DEX.default))((0, $iIVBW.default));
});
parcelRegister("85DEX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c16005808c5cfdce$export$2e2bcd8739ae039);
    var $jlryX = parcelRequire("jlryX");
    var $lKGSc = parcelRequire("lKGSc");
    var $dBbgF = parcelRequire("dBbgF");
    var $7K8Pq = parcelRequire("7K8Pq");
    const $c16005808c5cfdce$var$mapDispatchToProps = (dispatch)=>({
            startInlineCreate: (payload)=>{
                dispatch((0, $jlryX.startInlineCreate)(payload));
            },
            setIssueTypeIdForHierarchy: (hierarchyLevel, issueTypeId)=>{
                dispatch((0, $7K8Pq.setIssueTypeIdForHierarchy)(hierarchyLevel, issueTypeId));
            },
            setGlobalCreateIssue: ()=>{
                dispatch((0, $7K8Pq.setGlobalCreateIssue)(true));
            },
            setDefaultProject: (projectId)=>dispatch((0, $lKGSc.setDefaultProject)({
                    projectId: projectId
                })),
            toggleExpandGroup: (payload)=>dispatch((0, $dBbgF.toggleExpandGroup)(payload))
        });
    var $c16005808c5cfdce$export$2e2bcd8739ae039 = $c16005808c5cfdce$var$mapDispatchToProps;
});
parcelRegister("lySFc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$20475ec82d783566$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $jLI87 = parcelRequire("jLI87");
    var $9FFuD = parcelRequire("9FFuD");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $20475ec82d783566$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        enrichedVersions: (0, $9FFuD.getEnrichedVersions),
        groups: (0, $jLI87.getGroupOptions),
        grouping: (0, $j0XCX.getVisualisationGrouping),
        customFieldsById: (0, $19iju.getCustomFieldsById)
    });
});
parcelRegister("iIVBW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$176d6d83d16b84d1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $42CjB;
    var $9lMrf;
    var $5Fk4Z;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $aCpcO;
    var $9S2q6;
    var $g295Q;
    var $i2qlb = parcelRequire("i2qlb");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $30sno = parcelRequire("30sno");
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $dNy0k = parcelRequire("dNy0k");
    var $gkBgJ = parcelRequire("gkBgJ");
    var $6se4i = parcelRequire("6se4i");
    var $94mWM = parcelRequire("94mWM");
    var $6mTC5 = parcelRequire("6mTC5");
    var $iOb8Y = parcelRequire("iOb8Y");
    var $kOO7N = parcelRequire("kOO7N");
    var $lIIuy = parcelRequire("lIIuy");
    const $176d6d83d16b84d1$var$Spotlights = ({ children: children })=>(0, (0, parcelRequire("6s1PB")).expValEquals)('second_premium_template_experiment', 'cohort', 'variation') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: (0, (0, parcelRequire("g295Q")).CttSpotlights).CreateIssue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: (0, (0, parcelRequire("9S2q6")).CtpSpotlights).CreateIssue
        }, children)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: (0, (0, parcelRequire("g295Q")).CttSpotlights).CreateIssue
        }, children);
    const $176d6d83d16b84d1$var$CreateIssue = ({ customFieldsById: customFieldsById, groups: groups, grouping: grouping = (0, $TTKUQ.GROUPING).NONE, enrichedVersions: enrichedVersions, startInlineCreate: startInlineCreate, setGlobalCreateIssue: setGlobalCreateIssue, setIssueTypeIdForHierarchy: setIssueTypeIdForHierarchy, setDefaultProject: setDefaultProject, toggleExpandGroup: toggleExpandGroup })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isPlanGroupedBySingleValueCustomField = ()=>{
            if (!(0, $cScrq.isRoadmapGroupedByCustomField)(grouping)) return false;
            const fieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
            const customField = customFieldsById[fieldId];
            if (!customField) return false;
            return (0, $TTKUQ.CustomFields).GroupableSingleValueFields.includes(customField.type.key);
        };
        const allowCreateIssue = ()=>!(0, ($parcel$interopDefault($hGgHi)))(grouping) && (0, $kOO7N.ISSUE_CREATE_SUPPORTED_GROUPS).includes(grouping) || isPlanGroupedBySingleValueCustomField();
        const triggerInlineCreateIssueAnalytics = (group, projectId, issueTypeId)=>{
            const analyticsKey = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CREATED_ISSUE_FROM_HEADER;
            const [actionSubject, action] = analyticsKey.split(' ');
            const analyticGrouping = (0, $30sno.getGroupForAnalyticEvent)(grouping, Object.values(customFieldsById));
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            }), analyticsKey, {
                group: group,
                project: projectId,
                issueType: issueTypeId,
                grouping: analyticGrouping
            });
        };
        const onSelectOptions = (selectedOptions)=>{
            const projectId = (0, $lIIuy.getProjectId)(selectedOptions, enrichedVersions);
            const issueTypeOption = selectedOptions.issueType;
            const issueTypeId = issueTypeOption?.value?.id;
            const hierarchyLevel = issueTypeOption?.value?.level;
            if ((0, ($parcel$interopDefault($hGgHi)))(projectId) || (0, ($parcel$interopDefault($hGgHi)))(issueTypeId) || (0, ($parcel$interopDefault($hGgHi)))(hierarchyLevel)) throw new Error('Project, issue type or level is missing');
            setIssueTypeIdForHierarchy(hierarchyLevel, issueTypeId);
            setGlobalCreateIssue();
            setDefaultProject(projectId);
            if (grouping === (0, $TTKUQ.GROUPING).NONE) {
                startInlineCreate({
                    parentId: null,
                    siblingId: null,
                    hierarchyLevel: hierarchyLevel,
                    issueTypeId: issueTypeId,
                    projectId: projectId,
                    source: 'HEADER'
                });
                return;
            }
            const groupOption = grouping === (0, $TTKUQ.GROUPING).PROJECT ? selectedOptions.project : selectedOptions.group;
            if ((0, ($parcel$interopDefault($hGgHi)))(groupOption)) throw new Error('Group is missing');
            const group = groupOption.id;
            const groupCombination = groupOption.value;
            const startInlineCreateInEmptyGroup = !groups?.some(({ group: id })=>id === group);
            const parentGroup = groups?.find(({ group: id })=>id === group)?.parentGroup;
            if (parentGroup) toggleExpandGroup({
                expand: true,
                groupName: parentGroup,
                grouping: grouping
            });
            toggleExpandGroup({
                expand: true,
                groupName: group,
                grouping: grouping
            });
            triggerInlineCreateIssueAnalytics(group, projectId, issueTypeId);
            startInlineCreate({
                parentId: null,
                siblingId: null,
                hierarchyLevel: hierarchyLevel,
                issueTypeId: issueTypeId,
                projectId: projectId,
                group: group,
                grouping: grouping,
                groupCombination: groupCombination,
                startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup,
                source: 'HEADER'
            });
        };
        const renderTrigger = ({ triggerRef: triggerRef, ...triggerProps })=>{
            const isDisabled = !allowCreateIssue();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dNy0k.default), {
                shouldRender: isDisabled,
                content: formatMessage((0, $94mWM.default).addIssueDisabledTooltip)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($176d6d83d16b84d1$var$Spotlights, null, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                appearance: "subtle",
                ref: triggerRef,
                isDisabled: isDisabled,
                label: formatMessage((0, $94mWM.default).createIssue),
                ...triggerProps,
                icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                        label: ""
                    }),
                isTooltipDisabled: isDisabled,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.button"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                    label: ""
                }),
                appearance: "link",
                ref: triggerRef,
                isDisabled: isDisabled,
                ...triggerProps,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.button"
            }, formatMessage((0, $94mWM.default).createIssue))));
        };
        const getMenu = (selectedOptions)=>{
            if (grouping === (0, $TTKUQ.GROUPING).NONE || grouping === (0, $TTKUQ.GROUPING).PROJECT) {
                if ((0, ($parcel$interopDefault($hGgHi)))(selectedOptions.project)) return 0, $kOO7N.PROJECT;
                if ((0, ($parcel$interopDefault($hGgHi)))(selectedOptions.issueType)) return 0, $kOO7N.ISSUE_TYPE;
                return undefined;
            }
            if (grouping === (0, $TTKUQ.GROUPING).RELEASE) {
                if ((0, ($parcel$interopDefault($hGgHi)))(selectedOptions.group)) return 0, $kOO7N.GROUP;
                if ((0, ($parcel$interopDefault($hGgHi)))((0, $lIIuy.getProjectId)(selectedOptions, enrichedVersions))) return 0, $kOO7N.PROJECT;
                if ((0, ($parcel$interopDefault($hGgHi)))(selectedOptions.issueType)) return 0, $kOO7N.ISSUE_TYPE;
                return undefined;
            }
            if ((0, ($parcel$interopDefault($hGgHi)))(selectedOptions.group)) return 0, $kOO7N.GROUP;
            if ((0, ($parcel$interopDefault($hGgHi)))(selectedOptions.project)) return 0, $kOO7N.PROJECT;
            if ((0, ($parcel$interopDefault($hGgHi)))(selectedOptions.issueType)) return 0, $kOO7N.ISSUE_TYPE;
            return undefined;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $6mTC5.default), {
            onSelectOptions: onSelectOptions,
            trigger: renderTrigger,
            menus: {
                [(0, $kOO7N.GROUP)]: (0, $gkBgJ.default),
                [(0, $kOO7N.PROJECT)]: (0, $iOb8Y.default),
                [(0, $kOO7N.ISSUE_TYPE)]: (0, $6se4i.default)
            },
            getMenu: getMenu
        });
    };
    var $176d6d83d16b84d1$export$2e2bcd8739ae039 = $176d6d83d16b84d1$var$CreateIssue;
});
parcelRegister("dNy0k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$142831c0c69c89ae$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    const $142831c0c69c89ae$var$ConditionalTooltip = ({ shouldRender: shouldRender, children: children, ...props })=>shouldRender ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), props, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    var $142831c0c69c89ae$export$2e2bcd8739ae039 = $142831c0c69c89ae$var$ConditionalTooltip;
});
parcelRegister("gkBgJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$996fc2d3ccfa8b82$export$2e2bcd8739ae039);
    var $bC2fB;
    var $lKU2U = parcelRequire("lKU2U");
    var $2YzpK = parcelRequire("2YzpK");
    var $996fc2d3ccfa8b82$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $lKU2U.default), {})((0, $2YzpK.default));
});
parcelRegister("lKU2U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35f36de0afac7abd$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $35f36de0afac7abd$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        customFieldsById: (0, $19iju.getCustomFieldsById),
        grouping: (0, $j0XCX.getVisualisationGrouping)
    });
});
parcelRegister("2YzpK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d4b70cd3ebc9b94$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    var $6lAum = parcelRequire("6lAum");
    var $aoxbZ = parcelRequire("aoxbZ");
    var $k9EQG = parcelRequire("k9EQG");
    var $7JVV1 = parcelRequire("7JVV1");
    var $8AcyK = parcelRequire("8AcyK");
    var $uggx5 = parcelRequire("uggx5");
    var $jNnbE = parcelRequire("jNnbE");
    var $kiRys = parcelRequire("kiRys");
    const $3d4b70cd3ebc9b94$var$getOptionsProvider = (grouping, customFieldsById)=>{
        if ((0, $cScrq.isRoadmapGroupedByCustomField)(grouping)) {
            const fieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
            const fieldType = customFieldsById[fieldId].type.key;
            switch(fieldType){
                case (0, $TTKUQ.CustomFieldTypes).UserPicker:
                    return 0, $7JVV1.default;
                default:
                    return 0, $k9EQG.default;
            }
        }
        switch(grouping){
            case (0, $TTKUQ.GROUPING).TEAM:
                return 0, $kiRys.default;
            case (0, $TTKUQ.GROUPING).PROJECT:
                return 0, $8AcyK.default;
            case (0, $TTKUQ.GROUPING).SPRINT:
                return 0, $jNnbE.default;
            case (0, $TTKUQ.GROUPING).RELEASE:
                return 0, $uggx5.default;
            case (0, $TTKUQ.GROUPING).ASSIGNEE:
            default:
                return 0, $aoxbZ.default;
        }
    };
    const $3d4b70cd3ebc9b94$var$GroupMenu = ({ renderOption: renderOption, grouping: grouping, customFieldsById: customFieldsById })=>{
        const OptionsProvider = $3d4b70cd3ebc9b94$var$getOptionsProvider(grouping, customFieldsById);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(OptionsProvider, null, (result)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $6lAum.default), {
                renderOption: renderOption,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.group-menu",
                ...result
            }));
    };
    var $3d4b70cd3ebc9b94$export$2e2bcd8739ae039 = $3d4b70cd3ebc9b94$var$GroupMenu;
});
parcelRegister("6lAum", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$04f4650e32b5ed5d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aRoVz;
    var $eZUJu;
    var $dC5iT;
    var $f5TWP;
    var $koVbs;
    var $enoTt;
    var $jLI87 = parcelRequire("jLI87");
    var $2xSAL;
    var $2RYZ0 = parcelRequire("2RYZ0");
    var $kAgWh = parcelRequire("kAgWh");
    var $1SmL8 = parcelRequire("1SmL8");
    const $04f4650e32b5ed5d$var$ContentWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            padding: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            alignInline: "center",
            grow: "fill"
        }, children));
    const $04f4650e32b5ed5d$var$filterGroupOptionsWithSearchQuery = (option, searchQuery)=>{
        const optionName = option.name ?? (0, $jLI87.UNASSIGNED_GROUP);
        return optionName.toLowerCase().includes(searchQuery.toLowerCase());
    };
    const $04f4650e32b5ed5d$var$getOptionsToDisplay = (options, searchQuery)=>options.filter((option)=>$04f4650e32b5ed5d$var$filterGroupOptionsWithSearchQuery(option, searchQuery));
    const $04f4650e32b5ed5d$var$getGroupsToDisplay = (optionGroups, searchQuery)=>optionGroups.map(({ id: id, name: name, options: options })=>({
                id: id,
                name: name,
                options: $04f4650e32b5ed5d$var$getOptionsToDisplay(options, searchQuery)
            })).filter(({ options: options })=>options.length > 0);
    const $04f4650e32b5ed5d$var$MenuContent = ({ renderOption: renderOption, testId: testId, options: options, menuTitle: menuTitle, searchPlaceholder: searchPlaceholder, isLoading: isLoading, onQueryChange: onQueryChange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [searchQuery, setSearchQuery] = (0, $5uXOq.useState)('');
        (0, $kAgWh.useScrollLock)(true);
        const handleQueryChange = (newSearchQuery)=>{
            setSearchQuery(newSearchQuery);
            onQueryChange?.(newSearchQuery);
        };
        const renderOptions = ()=>{
            if (options.type === (0, $677974980f6adf58$export$74e371755c4019f7)) {
                const groupOptionsToDisplay = $04f4650e32b5ed5d$var$getOptionsToDisplay(options.options, searchQuery);
                if (groupOptionsToDisplay.length === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement($04f4650e32b5ed5d$var$ContentWrapper, null, formatMessage((0, $1SmL8.default).noMatchFoundText));
                return groupOptionsToDisplay.map((option)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                        key: option.id
                    }, renderOption(option, ({ triggerRef: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $2RYZ0.OptionItem), {
                            option: option,
                            ref: triggerRef,
                            ...triggerProps,
                            testId: `${testId}.option-item.${option.id}`
                        }))));
            }
            const groupsToDisplay = $04f4650e32b5ed5d$var$getGroupsToDisplay(options.groups, searchQuery);
            if (groupsToDisplay.length === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement($04f4650e32b5ed5d$var$ContentWrapper, null, formatMessage((0, $1SmL8.default).noMatchFoundText));
            return groupsToDisplay.map(({ id: id, name: name, options: groupOptions }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                    key: id,
                    id: id,
                    title: name,
                    hasSeparator: index > 0
                }, groupOptions.map((option)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                        key: option.id
                    }, renderOption(option, ({ triggerRef: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $2RYZ0.OptionItem), {
                            option: option,
                            ref: triggerRef,
                            ...triggerProps,
                            testId: `${testId}.option-item.${option.id}`
                        }))))));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
            maxHeight: 600,
            minWidth: 250,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            title: menuTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlock: "space.100",
            paddingInline: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2xSAL")).SearchField), {
            value: searchQuery,
            onChange: handleQueryChange,
            placeholder: searchPlaceholder,
            searchIconVisible: false,
            placeholderAlwaysVisible: true,
            shouldFitContainerWidth: true,
            isAutocompleteDisabled: true,
            isAlwaysExpanded: true,
            autoFocus: true,
            describedById: undefined,
            testId: `${testId}.search-field`
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kAgWh.ScrollContainer), null, (ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                isScrollable: true,
                hasSeparator: true,
                ref: ref
            }, isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement($04f4650e32b5ed5d$var$ContentWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), {
                size: "medium"
            })) : renderOptions())));
    };
    var $04f4650e32b5ed5d$export$2e2bcd8739ae039 = $04f4650e32b5ed5d$var$MenuContent;
});
parcelRegister("2xSAL", function(module, exports) {
    $parcel$export(module.exports, "SearchField", ()=>$f115db1c327fbbaa$export$b94867ecbd698f21);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $fW62l = parcelRequire("fW62l");
    var $2NMNM;
    var $kY99m;
    var $koVbs;
    var $dCm1o;
    var $cBssJ;
    var $hJBhl;
    var $5yLnO;
    const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
    const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
        const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const textInput = (0, $5uXOq.useRef)(null);
        const previousValueRef = (0, $5uXOq.useRef)();
        const previousValue = previousValueRef.current;
        if (externalValue !== previousValue && externalValue !== value) setValue(externalValue);
        previousValueRef.current = externalValue;
        const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
            setIsFocused(true);
            onFocus && onFocus(event);
        }, [
            onFocus
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur && onBlur(event);
            setIsFocused(false);
        }, [
            onBlur
        ]);
        const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
            const { value: val } = currentTarget;
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue(val);
            onChange(val, analyticsEvent);
        }, [
            createAnalyticsEvent,
            onChange
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            if (event.key === 'Escape') {
                setValue('');
                onChange('', analyticsEvent);
            }
            if (onEnter && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('enter')) {
                event.preventDefault();
                onEnter(event.currentTarget && event.currentTarget.value);
            }
        }, [
            createAnalyticsEvent,
            onChange,
            onEnter
        ]);
        const handleOnClear = (0, $5uXOq.useCallback)(()=>{
            if (value !== '') {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed'
                });
                setValue('');
                onChange('', analyticsEvent);
            }
            if (inputRef && inputRef.current !== null) inputRef.current.blur();
            if (textInput.current !== null) textInput.current.blur();
        }, [
            createAnalyticsEvent,
            inputRef,
            onChange,
            value
        ]);
        const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
        const textFieldProps = {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, (0, parcelRequire("cBssJ")).messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $f115db1c327fbbaa$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
        const searchIconDynamic = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIconDynamic), {
            onClear: handleOnClear,
            hasValue: value !== '',
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear),
            searchIconVisible: searchIconVisible,
            primaryColor: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
            onlyIconSpacing: isResponsive && !isExpanded
        });
        const searchIcon = showIconBeforeInput ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIcon), {
            searchIconVisible: searchIconVisible,
            onlyIconSpacing: isResponsive && !isExpanded
        }) : undefined;
        const clearIcon = showIconBeforeInput && value !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJBhl")).ClearFieldIcon), {
            onClear: handleOnClear,
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear)
        }) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
            shouldFitContainerWidth: shouldFitContainerWidth
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            increasedWidth: increasedWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ...textFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {}
        })));
    };
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
    const $f115db1c327fbbaa$export$b94867ecbd698f21 = (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
    $f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search';
    const $f115db1c327fbbaa$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.shouldFitContainerWidth && "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $f115db1c327fbbaa$var$InputWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1et2rhb": (0, (0, parcelRequire("lD23V")).default)(__cmplp.maxWidth, "px"),
                "--_47juog": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
                "--_5cv8rq": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : '32px'),
                "--_jy5l88": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
                "--_1skyi4s": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : 0),
                "--_1qenfck": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 1 : 0),
                "--_1b7586u": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
                "--_1b72lxu": (0, (0, parcelRequire("lD23V")).default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
                __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
                __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cBssJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$08273d4fc2a6d6da$export$defe85febe8b728c);
    var $7VHMR;
    const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clear: {
            "id": "searchfield.clear",
            "defaultMessage": "Clear"
        },
        search: {
            "id": "searchfield.search",
            "defaultMessage": "Search"
        }
    });
});
parcelRegister("hJBhl", function(module, exports) {
    $parcel$export(module.exports, "ClearFieldIcon", ()=>$99940a7c159b00c0$export$84038b503874befa);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $i28qQ;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $99940a7c159b00c0$var$wrapperStylesCloseIcon
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            testId: "searchfield.ui.clearfield-icon.clear-button",
            onClick: onClear,
            label: clearIconLabel,
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ")))))
        }));
    const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.025',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.050'
        }
    });
});
parcelRegister("5yLnO", function(module, exports) {
    $parcel$export(module.exports, "SearchFieldIconDynamic", ()=>$71cc18983db63a0d$export$9eef03e91cdeba14);
    $parcel$export(module.exports, "SearchFieldIcon", ()=>$71cc18983db63a0d$export$8a82bff895521bd9);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $84THj;
    var $26g7Y;
    var $hyOJh;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
        const akSearchIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            LEGACY_size: "small",
            label: "",
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        });
        const searchIcon = searchIconVisible ? akSearchIcon : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStyles,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
            ]
        }, hasValue ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
            testId: "searchfield.ui.searchfield-icon.clear-button",
            onClick: onClear,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                LEGACY_size: "small",
                label: clearIconLabel,
                LEGACY_primaryColor: primaryColor,
                color: "currentColor"
            })
        }) : searchIcon);
    };
    const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStylesBefore,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
            ]
        }, searchIconVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyOJh"))))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon, #44546F)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null));
    const $71cc18983db63a0d$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.accent.gray',
        marginTop: 'space.0',
        marginRight: 'space.100',
        marginBottom: 'space.0',
        marginLeft: 'space.0',
        height: '16px',
        display: 'flex'
    });
    const $71cc18983db63a0d$var$spacingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$wrapperStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.0',
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$spacingStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
});
parcelRegister("2RYZ0", function(module, exports) {
    $parcel$export(module.exports, "OptionItem", ()=>$0616fd39fd13da6d$export$94ddb30c8c53bcb9);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $ujWmd;
    var $6B7KL;
    var $jjlQu;
    var $dNy0k = parcelRequire("dNy0k");
    const $0616fd39fd13da6d$export$94ddb30c8c53bcb9 = (0, $5uXOq.forwardRef)(({ option: option, ...rest }, ref)=>{
        const { name: name, description: description, url: url, urlType: urlType, isDisabled: isDisabled, disabledTooltip: disabledTooltip } = option;
        const getElemBefore = ()=>{
            if ((0, ($parcel$interopDefault($hGgHi)))(url)) return;
            if (urlType === 'avatar') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "small",
                src: url
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjlQu")).default), {
                url: url,
                width: 24,
                height: 24
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dNy0k.default), {
            shouldRender: !!disabledTooltip && isDisabled,
            content: disabledTooltip
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            elemBefore: getElemBefore(),
            description: description,
            isDisabled: isDisabled,
            ...rest,
            ref: ref
        }, name));
    });
});
parcelRegister("jjlQu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7f7206d8a029d15$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $dC5iT;
    var $8CUq3;
    var $gwIPs;
    var $4R6GH;
    const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                url: undefined,
                title: undefined,
                alt: undefined,
                width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
                height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
                fallback: undefined
            };
        }
        render() {
            const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
            const width = this.convertSize(this.props.width);
            const height = this.convertSize(this.props.height);
            if (this.state.isBroken && fallback) return fallback();
            if (url) return (0, ($parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
                src: url,
                width: width,
                height: height,
                title: title ?? undefined,
                alt: alt ?? '',
                onError: this.onError,
                draggable: false
            });
            return (0, (0, parcelRequire("4R6GH")).fg)('jfp-1020-use-compiled') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $e7f7206d8a029d15$var$placeholderStyles,
                style: {
                    height: height,
                    width: width
                },
                backgroundColor: "color.background.input.hovered",
                testId: "common-components-async-icon.placeholder"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$ImagePlaceholder, {
                width: width,
                height: height,
                "data-testid": "common-components-async-icon.placeholder"
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isBroken: false
            };
            this.onError = ()=>{
                this.setState({
                    isBroken: true
                });
            };
            this.convertSize = (size)=>size ? `${size}px` : '0';
        }
    }
    const $e7f7206d8a029d15$var$ImagePlaceholder = (0, $47bDC.default).span.withConfig({
        componentId: "owe24v-0"
    })((props)=>({
            height: props.height,
            width: props.width,
            backgroundColor: (0, $829f609a65d26a98$exports).N30,
            borderRadius: '3px',
            display: 'flex',
            flex: 'none'
        }));
    const $e7f7206d8a029d15$var$placeholderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    });
    const $e7f7206d8a029d15$var$Image = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
});
const $677974980f6adf58$export$3e9b5c83c6ff2586 = 'GROUPED';
const $677974980f6adf58$export$74e371755c4019f7 = 'UNGROUPED';
parcelRegister("kAgWh", function(module, exports) {
    $parcel$export(module.exports, "ScrollContainer", ()=>$a9087b66015a0c5d$export$2631a3ab3cdd158d);
    $parcel$export(module.exports, "useScrollLock", ()=>$a9087b66015a0c5d$export$e47ba1b900da5d3b);
    var $5uXOq = parcelRequire("5uXOq");
    const $a9087b66015a0c5d$export$c0ab07dc32c9d892 = (0, $5uXOq.createContext)({
        setScrollLock: ()=>undefined
    });
    const $a9087b66015a0c5d$export$2631a3ab3cdd158d = ({ children: children })=>{
        const lockCount = (0, $5uXOq.useRef)(0);
        const ref = (0, $5uXOq.useRef)(null);
        const setScrollLock = (0, $5uXOq.useCallback)((locked)=>{
            if (locked) lockCount.current += 1;
            else lockCount.current -= 1;
            if (lockCount.current < 0) lockCount.current = 0;
            if (ref.current) ref.current.style.overflow = lockCount.current > 0 ? 'hidden' : '';
        }, [
            lockCount
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a9087b66015a0c5d$export$c0ab07dc32c9d892.Provider, {
            value: {
                setScrollLock: setScrollLock
            }
        }, children(ref));
    };
    const $a9087b66015a0c5d$export$e47ba1b900da5d3b = (locked)=>{
        const { setScrollLock: setScrollLock } = (0, $5uXOq.useContext)($a9087b66015a0c5d$export$c0ab07dc32c9d892);
        (0, $5uXOq.useEffect)(()=>{
            setScrollLock(locked);
            return ()=>setScrollLock(false);
        }, [
            locked,
            setScrollLock
        ]);
    };
});
parcelRegister("1SmL8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2256d492c21ef4c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d2256d492c21ef4c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noMatchFoundText: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.menu-content.no-match-found-text",
            "defaultMessage": "No matches"
        }
    });
});
parcelRegister("aoxbZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82bbd556effa7d94$export$2e2bcd8739ae039);
    var $bC2fB;
    var $d37mK = parcelRequire("d37mK");
    var $6xEc0 = parcelRequire("6xEc0");
    var $hx2ut = parcelRequire("hx2ut");
    var $82bbd556effa7d94$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6xEc0.default), (0, $d37mK.default))((0, $hx2ut.default));
});
parcelRegister("d37mK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48177f95bcc22ab3$export$2e2bcd8739ae039);
    var $8qbLi = parcelRequire("8qbLi");
    const $48177f95bcc22ab3$var$mapDispatchToProps = {
        fetchAssigneeList: $8qbLi.fetchAssigneeList
    };
    var $48177f95bcc22ab3$export$2e2bcd8739ae039 = $48177f95bcc22ab3$var$mapDispatchToProps;
});
parcelRegister("6xEc0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68116204fc3b180c$export$2e2bcd8739ae039);
    var $hu7Cn = parcelRequire("hu7Cn");
    var $3YtPS = parcelRequire("3YtPS");
    var $68116204fc3b180c$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        assigneeListFetchStatus: (0, $hu7Cn.getAssigneeListFetchStatus),
        assignees: (0, $hu7Cn.getAssigneeList)
    });
});
parcelRegister("hx2ut", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$334fd108201521f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $1XJ20;
    var $NTvsc = parcelRequire("NTvsc");
    var $k9lgi = parcelRequire("k9lgi");
    const $334fd108201521f6$var$AssigneeOptionsProvider = ({ assignees: assignees, assigneeListFetchStatus: assigneeListFetchStatus, fetchAssigneeList: fetchAssigneeList, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(assigneeListFetchStatus);
        (0, $5uXOq.useEffect)(()=>{
            setIsLoading(true);
            fetchAssigneeList({
                query: ''
            });
        }, [
            fetchAssigneeList
        ]);
        const previousAssigneeListFetchStatus = (0, (0, parcelRequire("1XJ20")).usePrevious)(assigneeListFetchStatus);
        (0, $5uXOq.useEffect)(()=>{
            if (previousAssigneeListFetchStatus && !assigneeListFetchStatus) setIsLoading(false);
        }, [
            assigneeListFetchStatus,
            previousAssigneeListFetchStatus
        ]);
        const handleQueryChange = (query)=>{
            setIsLoading(true);
            fetchAssigneeList({
                query: query
            });
        };
        const createGroupOptionFromAssignee = (assignee)=>{
            const { title: title, email: email, avatarUrl: avatarUrl } = assignee.jiraUser;
            return {
                id: `assignee-${assignee.personId}`,
                name: title,
                value: {
                    assignee: assignee.personId
                },
                description: email,
                url: avatarUrl ?? '',
                urlType: 'avatar'
            };
        };
        const getGroupOptionsFromAssignees = ()=>assignees.map(createGroupOptionFromAssignee).sort((0, $NTvsc.optionSortComparator));
        return children({
            options: {
                type: (0, $677974980f6adf58$export$74e371755c4019f7),
                options: getGroupOptionsFromAssignees()
            },
            menuTitle: formatMessage((0, $k9lgi.default).assigneeMenuTitle),
            searchPlaceholder: formatMessage((0, $k9lgi.default).assigneeSearchPlaceholder),
            onQueryChange: handleQueryChange,
            isLoading: isLoading
        });
    };
    var $334fd108201521f6$export$2e2bcd8739ae039 = $334fd108201521f6$var$AssigneeOptionsProvider;
});
parcelRegister("NTvsc", function(module, exports) {
    $parcel$export(module.exports, "optionSortComparator", ()=>$27933eec96495692$export$fc44e4616250e6a);
    $parcel$export(module.exports, "optionGroupSortComparator", ()=>$27933eec96495692$export$97376334cc7df103);
    var $hGgHi = parcelRequire("hGgHi");
    var $jLI87 = parcelRequire("jLI87");
    const $27933eec96495692$var$nameComparator = (a, b)=>{
        if (a === b) return 0;
        if ((0, ($parcel$interopDefault($hGgHi)))(a)) return 1;
        if ((0, ($parcel$interopDefault($hGgHi)))(b)) return -1;
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (aLower === (0, $jLI87.UNASSIGNED_GROUP)) return 1;
        if (bLower === (0, $jLI87.UNASSIGNED_GROUP)) return -1;
        if (aLower === bLower) return 0;
        return aLower > bLower ? 1 : -1;
    };
    const $27933eec96495692$export$fc44e4616250e6a = (option1, option2)=>$27933eec96495692$var$nameComparator(option1.name, option2.name);
    const $27933eec96495692$export$97376334cc7df103 = (optionGroup1, optionGroup2)=>{
        const sortValue1 = optionGroup1.sortValue || 0;
        const sortValue2 = optionGroup2.sortValue || 0;
        if (sortValue1 === sortValue2) return $27933eec96495692$var$nameComparator(optionGroup1.name, optionGroup2.name);
        return sortValue2 - sortValue1;
    };
});
parcelRegister("k9lgi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$436c1eba77b48494$export$2e2bcd8739ae039);
    var $7VHMR;
    var $436c1eba77b48494$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        assigneeMenuTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.assignee.assignee-menu-title",
            "defaultMessage": "Choose assignee"
        },
        assigneeSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.assignee.assignee-search-placeholder",
            "defaultMessage": "Find assignees..."
        }
    });
});
parcelRegister("k9EQG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e831d05c9da9f091$export$2e2bcd8739ae039);
    var $bC2fB;
    var $eBk1x = parcelRequire("eBk1x");
    var $gQc0y = parcelRequire("gQc0y");
    var $e831d05c9da9f091$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $eBk1x.default), {})((0, $gQc0y.default));
});
parcelRegister("eBk1x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ceb4770e12fc62d$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $8ceb4770e12fc62d$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        grouping: (0, $j0XCX.getVisualisationGrouping),
        selectOptions: (0, $19iju.getSelectOptions)
    });
});
parcelRegister("gQc0y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0cae04aaf3b5dda$export$2e2bcd8739ae039);
    var $koVbs;
    var $jLI87 = parcelRequire("jLI87");
    var $cScrq = parcelRequire("cScrq");
    var $ihPUd = parcelRequire("ihPUd");
    var $NTvsc = parcelRequire("NTvsc");
    var $awowC = parcelRequire("awowC");
    const $e0cae04aaf3b5dda$var$CustomFieldOptionsProvider = ({ grouping: grouping, selectOptions: selectOptions, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const customFieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
        const createOptionFromCustomField = (selectOption)=>({
                id: `${grouping}-${selectOption.id}`,
                name: selectOption.value,
                value: {
                    [grouping]: selectOption.id
                }
            });
        const getOptionsFromCustomField = ()=>{
            const filteredOptions = selectOptions.filter((selectOption)=>selectOption.fieldId === customFieldId).map((option)=>({
                    ...option,
                    id: String(option.id)
                }));
            const options = filteredOptions.map((option)=>createOptionFromCustomField(option));
            return options.sort((0, $NTvsc.optionSortComparator));
        };
        const unassigned = {
            id: (0, $jLI87.UNDEFINED_GROUP),
            name: formatMessage((0, $ihPUd.default).unassigned),
            value: {
                [grouping]: null
            }
        };
        const optionsWithUnassigned = [
            ...getOptionsFromCustomField(),
            unassigned
        ];
        return children({
            options: {
                type: (0, $677974980f6adf58$export$74e371755c4019f7),
                options: optionsWithUnassigned
            },
            menuTitle: formatMessage((0, $awowC.default).customFieldMenuTitle),
            searchPlaceholder: formatMessage((0, $awowC.default).customFieldSearchPlaceholder)
        });
    };
    var $e0cae04aaf3b5dda$export$2e2bcd8739ae039 = $e0cae04aaf3b5dda$var$CustomFieldOptionsProvider;
});
parcelRegister("awowC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ef769e64919c808$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3ef769e64919c808$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        customFieldMenuTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.custom-field.custom-field-menu-title",
            "defaultMessage": "Choose option"
        },
        customFieldSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.custom-field.custom-field-search-placeholder",
            "defaultMessage": "Find options..."
        }
    });
});
parcelRegister("7JVV1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb6ee7c8ab553170$export$2e2bcd8739ae039);
    var $bC2fB;
    var $cEo7L = parcelRequire("cEo7L");
    var $euQ78 = parcelRequire("euQ78");
    var $dlkYU = parcelRequire("dlkYU");
    var $bb6ee7c8ab553170$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $euQ78.default), (0, $cEo7L.default))((0, $dlkYU.default));
});
parcelRegister("cEo7L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99efa4f43dff21a2$export$2e2bcd8739ae039);
    var $bNKh8 = parcelRequire("bNKh8");
    const $99efa4f43dff21a2$var$mapDispatchToProps = {
        fetchUserPickerOptions: $bNKh8.fetchUserPickerOptions
    };
    var $99efa4f43dff21a2$export$2e2bcd8739ae039 = $99efa4f43dff21a2$var$mapDispatchToProps;
});
parcelRegister("euQ78", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21208eb1c2dc9c8e$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $21208eb1c2dc9c8e$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        grouping: (0, $j0XCX.getVisualisationGrouping),
        userList: (0, $19iju.getUserPickerOptionsUserList),
        userPickerUIState: (0, $19iju.getUserPickerUIState)
    });
});
parcelRegister("dlkYU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$326b0d90387eb87a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $1XJ20;
    var $jLI87 = parcelRequire("jLI87");
    var $NTvsc = parcelRequire("NTvsc");
    var $30dQx = parcelRequire("30dQx");
    const $326b0d90387eb87a$var$CustomUserPickerOptionsProvider = ({ grouping: grouping, userList: userList, fetchUserPickerOptions: fetchUserPickerOptions, userPickerUIState: userPickerUIState, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { issueId: issueId, isFetchUserListInProgress: isFetchUserListInProgress } = userPickerUIState;
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(isFetchUserListInProgress);
        (0, $5uXOq.useEffect)(()=>{
            setIsLoading(true);
            fetchUserPickerOptions('', issueId);
        }, [
            fetchUserPickerOptions,
            issueId
        ]);
        const previousFetchUserListInProgress = (0, (0, parcelRequire("1XJ20")).usePrevious)(isFetchUserListInProgress);
        (0, $5uXOq.useEffect)(()=>{
            if (previousFetchUserListInProgress && !isFetchUserListInProgress) setIsLoading(false);
        }, [
            isFetchUserListInProgress,
            previousFetchUserListInProgress
        ]);
        const handleQueryChange = (query)=>{
            setIsLoading(true);
            fetchUserPickerOptions(query, issueId);
        };
        const createOptionFromUser = (user)=>{
            const { email: email, icon: icon, label: label, value: value } = user;
            const isUnassigned = label.toLowerCase() === (0, $jLI87.UNASSIGNED_GROUP);
            return {
                id: `${grouping}-${value}`,
                name: isUnassigned ? (0, $jLI87.UNASSIGNED_GROUP) : [
                    label,
                    email
                ].join(' '),
                value: {
                    [grouping]: value
                },
                description: email,
                url: icon,
                urlType: 'avatar'
            };
        };
        const getOptionsFromUsers = ()=>userList.map(createOptionFromUser).sort((0, $NTvsc.optionSortComparator));
        return children({
            options: {
                type: (0, $677974980f6adf58$export$74e371755c4019f7),
                options: getOptionsFromUsers()
            },
            menuTitle: formatMessage((0, $30dQx.default).userMenuTitle),
            searchPlaceholder: formatMessage((0, $30dQx.default).userSearchPlaceholder),
            onQueryChange: handleQueryChange,
            isLoading: isLoading
        });
    };
    var $326b0d90387eb87a$export$2e2bcd8739ae039 = $326b0d90387eb87a$var$CustomUserPickerOptionsProvider;
});
parcelRegister("30dQx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33b9efc89bac6e75$export$2e2bcd8739ae039);
    var $7VHMR;
    var $33b9efc89bac6e75$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        userMenuTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.custom-user-picker.user-menu-title",
            "defaultMessage": "Choose user"
        },
        userSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.custom-user-picker.user-search-placeholder",
            "defaultMessage": "Find users..."
        }
    });
});
parcelRegister("8AcyK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d2abb5abbfb973b$export$2e2bcd8739ae039);
    var $bC2fB;
    var $awff1 = parcelRequire("awff1");
    var $erZnJ = parcelRequire("erZnJ");
    var $4d2abb5abbfb973b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $awff1.default), {})((0, $erZnJ.default));
});
parcelRegister("awff1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f43e8026325ac3a6$export$2e2bcd8739ae039);
    var $jpXKt = parcelRequire("jpXKt");
    var $3YtPS = parcelRequire("3YtPS");
    var $f43e8026325ac3a6$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        projects: (0, $jpXKt.getProjects)
    });
});
parcelRegister("erZnJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44b286e8a3e773b6$export$2e2bcd8739ae039);
    var $koVbs;
    var $NTvsc = parcelRequire("NTvsc");
    var $7FMPf = parcelRequire("7FMPf");
    const $44b286e8a3e773b6$var$ProjectOptionsProvider = ({ projects: projects, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const createOptionFromProjects = (project)=>({
                id: `project-${project.id}`,
                name: project.name,
                value: {
                    project: project.id
                },
                url: project.avatarUrl,
                urlType: 'avatar'
            });
        const getOptionsFromProjects = ()=>projects.map(createOptionFromProjects).sort((0, $NTvsc.optionSortComparator));
        return children({
            options: {
                type: (0, $677974980f6adf58$export$74e371755c4019f7),
                options: getOptionsFromProjects()
            },
            menuTitle: formatMessage((0, $7FMPf.default).projectMenuTitle),
            searchPlaceholder: formatMessage((0, $7FMPf.default).projectSearchPlaceholder)
        });
    };
    var $44b286e8a3e773b6$export$2e2bcd8739ae039 = $44b286e8a3e773b6$var$ProjectOptionsProvider;
});
parcelRegister("7FMPf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e32990e2deec4fd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8e32990e2deec4fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectMenuTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.project.project-menu-title",
            "defaultMessage": "Choose project"
        },
        projectSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.project.project-search-placeholder",
            "defaultMessage": "Find projects..."
        }
    });
});
parcelRegister("uggx5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e0737ac050df0b6$export$2e2bcd8739ae039);
    var $bC2fB;
    var $adL3W = parcelRequire("adL3W");
    var $gP4He = parcelRequire("gP4He");
    var $3e0737ac050df0b6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $adL3W.default), {})((0, $gP4He.default));
});
parcelRegister("adL3W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16b6f5fc09d91c18$export$2e2bcd8739ae039);
    var $jLI87 = parcelRequire("jLI87");
    var $9FFuD = parcelRequire("9FFuD");
    var $3YtPS = parcelRequire("3YtPS");
    var $16b6f5fc09d91c18$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        groups: (0, $jLI87.getGroupOptions),
        enrichedVersions: (0, $9FFuD.getEnrichedVersions),
        enrichedVersionsById: (0, $9FFuD.getEnrichedVersionsById)
    });
});
parcelRegister("gP4He", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$255a063d1705e18e$export$2e2bcd8739ae039);
    var $hGgHi = parcelRequire("hGgHi");
    var $koVbs;
    var $jLI87 = parcelRequire("jLI87");
    var $ihPUd = parcelRequire("ihPUd");
    var $NTvsc = parcelRequire("NTvsc");
    var $aalNV = parcelRequire("aalNV");
    const $255a063d1705e18e$var$ReleaseOptionsProvider = ({ groups: groups, enrichedVersions: enrichedVersions, enrichedVersionsById: enrichedVersionsById, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const createOptionFromGroup = (group)=>({
                id: group.group,
                name: group.groupName,
                value: {
                    release: group.groupCombination?.release
                }
            });
        const createOptionFromRelease = (release)=>({
                id: `release-${release.id}`,
                name: release.name,
                value: {
                    release: release.id
                }
            });
        const getOptionsFromReleasesByProject = ()=>{
            const projectToOptionsMap = {
                [(0, $jLI87.UNASSIGNED_GROUP)]: {
                    id: (0, $jLI87.UNASSIGNED_GROUP),
                    name: formatMessage((0, $ihPUd.default).unassigned),
                    sortValue: -1,
                    options: [
                        {
                            id: (0, $jLI87.UNASSIGNED_GROUP),
                            name: formatMessage((0, $ihPUd.default).unassigned),
                            value: {
                                release: null
                            }
                        }
                    ]
                }
            };
            const processedReleaseIds = new Set();
            groups.forEach((group)=>{
                if ((0, ($parcel$interopDefault($hGgHi)))(group.groupCombination) || (0, ($parcel$interopDefault($hGgHi)))(group.groupCombination.release)) return;
                const enrichedVersion = enrichedVersionsById[group.groupCombination.release];
                processedReleaseIds.add(group.groupCombination.release);
                const option = createOptionFromGroup(group);
                if (enrichedVersion === undefined) return;
                const project = enrichedVersion.projects[0];
                if (typeof project === 'number') return;
                const projectId = project.id;
                const projectName = project.name;
                const existingGroup = projectToOptionsMap[projectId] ?? {
                    id: `project-${projectId}`,
                    name: projectName,
                    options: []
                };
                existingGroup.options.push(option);
                projectToOptionsMap[projectId] = existingGroup;
            });
            enrichedVersions.forEach((release)=>{
                if (processedReleaseIds.has(release.id)) return;
                const option = createOptionFromRelease(release);
                const project = release.projects[0];
                if (typeof project === 'number') return;
                const projectId = project.id;
                const projectName = project.name;
                const existingGroup = projectToOptionsMap[projectId] ?? {
                    id: `project-${projectId}`,
                    name: projectName,
                    options: []
                };
                existingGroup.options.push(option);
                projectToOptionsMap[projectId] = existingGroup;
            });
            const optionGroups = Object.values(projectToOptionsMap);
            optionGroups.forEach((group)=>group.options.sort((0, $NTvsc.optionSortComparator)));
            optionGroups.sort((0, $NTvsc.optionGroupSortComparator));
            return optionGroups;
        };
        return children({
            options: {
                type: (0, $677974980f6adf58$export$3e9b5c83c6ff2586),
                groups: getOptionsFromReleasesByProject()
            },
            menuTitle: formatMessage((0, $aalNV.default).releaseMenuTitle),
            searchPlaceholder: formatMessage((0, $aalNV.default).releaseSearchPlaceholder)
        });
    };
    var $255a063d1705e18e$export$2e2bcd8739ae039 = $255a063d1705e18e$var$ReleaseOptionsProvider;
});
parcelRegister("aalNV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$312436de4965e367$export$2e2bcd8739ae039);
    var $7VHMR;
    var $312436de4965e367$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releaseMenuTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.release.release-menu-title",
            "defaultMessage": "Choose release"
        },
        releaseSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.release.release-search-placeholder",
            "defaultMessage": "Find releases..."
        }
    });
});
parcelRegister("jNnbE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30001c8b5858709b$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9IbX0 = parcelRequire("9IbX0");
    var $3Vpkr = parcelRequire("3Vpkr");
    var $30001c8b5858709b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $9IbX0.default), {})((0, $3Vpkr.default));
});
parcelRegister("9IbX0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f71aad2601798ea8$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    var $jLI87 = parcelRequire("jLI87");
    var $d3quy = parcelRequire("d3quy");
    var $3YtPS = parcelRequire("3YtPS");
    var $f71aad2601798ea8$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        groups: (0, $jLI87.getGroupOptions),
        sprints: (0, $d3quy.getAllSprints),
        sprintsByIdMap: (0, $d3quy.getAllSprintsByIdMap),
        externalSprintsById: (0, $d3quy.getExternalSprintsById),
        issueSourcesById: (0, $bHTqr.getIssueSourcesById)
    });
});
parcelRegister("3Vpkr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9f09409e974016c$export$2e2bcd8739ae039);
    var $hGgHi = parcelRequire("hGgHi");
    var $dJl1T;
    var $koVbs;
    var $jLI87 = parcelRequire("jLI87");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $NTvsc = parcelRequire("NTvsc");
    var $bdH0B = parcelRequire("bdH0B");
    const $f9f09409e974016c$var$SprintOptionsProvider = ({ groups: groups, sprints: sprints, sprintsByIdMap: sprintsByIdMap, externalSprintsById: externalSprintsById, issueSourcesById: issueSourcesById, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isSprintClosed = (sprintId)=>sprintsByIdMap[sprintId].state === (0, $TTKUQ.SPRINT_STATES).CLOSED;
        const isSprintExternal = (sprintId)=>!(0, ($parcel$interopDefault($hGgHi)))(externalSprintsById[sprintId]);
        const createOptionFromGroup = (group)=>({
                id: group.group,
                name: group.groupName,
                value: {
                    sprint: group.groupCombination?.sprint
                },
                isDisabled: !(0, ($parcel$interopDefault($hGgHi)))(group.groupCombination?.sprint) && isSprintExternal(group.groupCombination.sprint),
                disabledTooltip: formatMessage((0, $bdH0B.default).sprintTooltip)
            });
        const createOptionFromSprint = (sprint)=>({
                id: `sprint-${sprint.id}`,
                name: sprint.title,
                value: {
                    sprint: sprint.id
                },
                isDisabled: isSprintExternal(sprint.id),
                disabledTooltip: formatMessage((0, $bdH0B.default).sprintTooltip)
            });
        const getOptionsFromSprints = ()=>{
            const sourceIdToOptionsMap = {
                [(0, $27bfbf6c1ec5bff4$export$da755b4ffe65117b)]: {
                    id: (0, $27bfbf6c1ec5bff4$export$da755b4ffe65117b),
                    name: formatMessage((0, $bdH0B.default).externalSource),
                    sortValue: -1,
                    options: []
                },
                [(0, $jLI87.UNASSIGNED_GROUP)]: {
                    id: (0, $jLI87.UNASSIGNED_GROUP),
                    name: formatMessage((0, $ihPUd.default).unassigned),
                    sortValue: -2,
                    options: [
                        {
                            id: (0, $jLI87.UNASSIGNED_GROUP),
                            name: formatMessage((0, $ihPUd.default).unassigned),
                            value: {
                                sprint: null
                            }
                        }
                    ]
                }
            };
            const processedSprintIds = new Set();
            groups.forEach((group)=>{
                if ((0, ($parcel$interopDefault($hGgHi)))(group.groupCombination) || (0, ($parcel$interopDefault($hGgHi)))(group.groupCombination.sprint) || isSprintClosed(group.groupCombination.sprint)) return;
                const option = createOptionFromGroup(group);
                const sprint = sprintsByIdMap[group.groupCombination.sprint];
                processedSprintIds.add(group.groupCombination.sprint);
                if (sprint === undefined) return;
                const issueSourceId = sprint.issueSources?.[0] ?? (0, $27bfbf6c1ec5bff4$export$da755b4ffe65117b);
                if (!sprint.issueSources) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('app-simple-plans.view.main.tabs.roadmap.scope.header.create-issue.options-providers.sprint.view.getOptionsFromSprints', 'Error reading data from sprint.issueSources in groups.forEach');
                const issueSource = issueSourcesById[issueSourceId];
                const issueSourceTitle = issueSource?.title ?? formatMessage((0, $bdH0B.default).externalSource);
                const existingGroup = sourceIdToOptionsMap[issueSourceId] ?? {
                    id: `source-${issueSourceId}`,
                    name: issueSourceTitle,
                    options: []
                };
                existingGroup.options.push(option);
                sourceIdToOptionsMap[issueSourceId] = existingGroup;
            });
            sprints.forEach((sprint)=>{
                if (processedSprintIds.has(sprint.id) || isSprintClosed(sprint.id)) return;
                const option = createOptionFromSprint(sprint);
                const issueSourceId = sprint?.issueSources?.[0] ?? (0, $27bfbf6c1ec5bff4$export$da755b4ffe65117b);
                if (!sprint?.issueSources) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('app-simple-plans.view.main.tabs.roadmap.scope.header.create-issue.options-providers.sprint.view.getOptionsFromSprints', 'Error reading data from sprint.issueSources in sprints.forEach');
                const issueSource = issueSourcesById[issueSourceId];
                const issueSourceTitle = issueSource?.title ?? formatMessage((0, $bdH0B.default).externalSource);
                const existingGroup = sourceIdToOptionsMap[issueSourceId] ?? {
                    id: `source-${issueSourceId}`,
                    name: issueSourceTitle,
                    options: []
                };
                existingGroup.options.push(option);
                sourceIdToOptionsMap[issueSourceId] = existingGroup;
            });
            const optionGroups = Object.values(sourceIdToOptionsMap);
            optionGroups.forEach((group)=>group.options.sort((0, $NTvsc.optionSortComparator)));
            optionGroups.sort((0, $NTvsc.optionGroupSortComparator));
            return optionGroups;
        };
        return children({
            options: {
                type: (0, $677974980f6adf58$export$3e9b5c83c6ff2586),
                groups: getOptionsFromSprints()
            },
            menuTitle: formatMessage((0, $bdH0B.default).sprintMenuTitle),
            searchPlaceholder: formatMessage((0, $bdH0B.default).sprintSearchPlaceholder)
        });
    };
    var $f9f09409e974016c$export$2e2bcd8739ae039 = $f9f09409e974016c$var$SprintOptionsProvider;
});
parcelRegister("bdH0B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7848b2def71f134$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a7848b2def71f134$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sprintMenuTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.sprint.sprint-menu-title",
            "defaultMessage": "Choose sprint"
        },
        externalSource: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.sprint.external-source",
            "defaultMessage": "External"
        },
        sprintSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.sprint.sprint-search-placeholder",
            "defaultMessage": "Find sprints..."
        },
        sprintTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.sprint.sprint-tooltip",
            "defaultMessage": "You can't create issues for external and completed sprints."
        }
    });
});
const $27bfbf6c1ec5bff4$export$da755b4ffe65117b = 'external';
parcelRegister("kiRys", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31cf335cd629c287$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bBnRt = parcelRequire("bBnRt");
    var $eyKRV = parcelRequire("eyKRV");
    var $31cf335cd629c287$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $bBnRt.default), {})((0, $eyKRV.default));
});
parcelRegister("bBnRt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25a86d948b410f2f$export$2e2bcd8739ae039);
    var $jLI87 = parcelRequire("jLI87");
    var $dRVQG = parcelRequire("dRVQG");
    var $3YtPS = parcelRequire("3YtPS");
    var $25a86d948b410f2f$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        groups: (0, $jLI87.getGroupOptions),
        teams: (0, $dRVQG.getTeams),
        additionalTeamsById: (0, $dRVQG.getAdditionalTeamsById)
    });
});
parcelRegister("eyKRV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$407a913f541ba757$export$2e2bcd8739ae039);
    var $hGgHi = parcelRequire("hGgHi");
    var $koVbs;
    var $jLI87 = parcelRequire("jLI87");
    var $ihPUd = parcelRequire("ihPUd");
    var $NTvsc = parcelRequire("NTvsc");
    var $6MD8O = parcelRequire("6MD8O");
    const $407a913f541ba757$var$TeamOptionsProvider = ({ additionalTeamsById: additionalTeamsById, groups: groups, teams: teams, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isTeamDisabled = (teamId)=>!(0, ($parcel$interopDefault($hGgHi)))(additionalTeamsById[teamId]);
        const createOptionFromGroup = (group)=>({
                id: group.group,
                name: group.groupName,
                value: {
                    team: group.groupCombination?.team
                },
                url: group.groupUrl || '',
                urlType: 'avatar',
                isDisabled: !(0, ($parcel$interopDefault($hGgHi)))(group.groupCombination?.team) && isTeamDisabled(group.groupCombination.team),
                disabledTooltip: formatMessage((0, $6MD8O.default).teamTooltip)
            });
        const createOptionFromTeam = (team)=>({
                id: `team-${team.id}`,
                name: team.title,
                value: {
                    team: team.id
                },
                url: team.avatarUrl || '',
                urlType: 'avatar',
                isDisabled: isTeamDisabled(team.id),
                disabledTooltip: formatMessage((0, $6MD8O.default).teamTooltip)
            });
        const getOptionsFromTeams = ()=>{
            const unassigned = {
                name: formatMessage((0, $ihPUd.default).unassigned),
                id: (0, $jLI87.UNDEFINED_GROUP),
                url: '',
                urlType: 'avatar',
                value: {
                    team: null
                }
            };
            const teamGroups = new Set();
            const options = [];
            groups.forEach((group)=>{
                if ((0, ($parcel$interopDefault($hGgHi)))(group.groupCombination) || (0, ($parcel$interopDefault($hGgHi)))(group.groupCombination.team)) return;
                teamGroups.add(group.groupCombination.team);
                const option = createOptionFromGroup(group);
                options.push(option);
            });
            teams.forEach((team)=>{
                if (teamGroups.has(team.id)) return;
                const option = createOptionFromTeam(team);
                options.push(option);
            });
            options.push(unassigned);
            return options.sort((0, $NTvsc.optionSortComparator));
        };
        return children({
            options: {
                type: (0, $677974980f6adf58$export$74e371755c4019f7),
                options: getOptionsFromTeams()
            },
            menuTitle: formatMessage((0, $6MD8O.default).teamMenuTitle),
            searchPlaceholder: formatMessage((0, $6MD8O.default).teamSearchPlaceholder)
        });
    };
    var $407a913f541ba757$export$2e2bcd8739ae039 = $407a913f541ba757$var$TeamOptionsProvider;
});
parcelRegister("6MD8O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0e1ed3a102d48e0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e0e1ed3a102d48e0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        teamMenuTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.team.team-menu-title",
            "defaultMessage": "Choose team"
        },
        teamTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.team.team-tooltip",
            "defaultMessage": "You can't create issues for external teams."
        },
        teamSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.team.team-search-placeholder",
            "defaultMessage": "Find teams..."
        }
    });
});
parcelRegister("6se4i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9cbb68b769b82d6a$export$2e2bcd8739ae039);
    var $bC2fB;
    var $b1Buk = parcelRequire("b1Buk");
    var $83vWd = parcelRequire("83vWd");
    var $9cbb68b769b82d6a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $b1Buk.default), {})((0, $83vWd.default));
});
parcelRegister("b1Buk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16d623771ad7b455$export$2e2bcd8739ae039);
    var $9FFuD = parcelRequire("9FFuD");
    var $3YtPS = parcelRequire("3YtPS");
    var $16d623771ad7b455$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        enrichedVersions: (0, $9FFuD.getEnrichedVersions)
    });
});
parcelRegister("83vWd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6d4d078fcd38c83$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6lAum = parcelRequire("6lAum");
    var $hU25j = parcelRequire("hU25j");
    var $lIIuy = parcelRequire("lIIuy");
    const $b6d4d078fcd38c83$var$IssueTypeMenu = ({ renderOption: renderOption, enrichedVersions: enrichedVersions, selectedOptions: selectedOptions })=>{
        const projectId = (0, $lIIuy.getProjectId)(selectedOptions, enrichedVersions);
        if (!projectId) throw Error('Project value is required');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hU25j.default), {
            projectId: projectId
        }, (result)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $6lAum.default), {
                renderOption: renderOption,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.issue-type-menu",
                ...result
            }));
    };
    var $b6d4d078fcd38c83$export$2e2bcd8739ae039 = $b6d4d078fcd38c83$var$IssueTypeMenu;
});
parcelRegister("hU25j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9dacef1d26e71777$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3kkMq = parcelRequire("3kkMq");
    var $frYif = parcelRequire("frYif");
    var $9dacef1d26e71777$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $3kkMq.default), {})((0, $frYif.default));
});
parcelRegister("3kkMq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b26d7831b2f1e416$export$2e2bcd8739ae039);
    var $7bnpM = parcelRequire("7bnpM");
    var $kllqP = parcelRequire("kllqP");
    var $3YtPS = parcelRequire("3YtPS");
    var $b26d7831b2f1e416$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        issueTypesByProjectId: (0, $kllqP.getIssueTypesByProjectId),
        hierarchyRangeFilter: (0, $7bnpM.getHierarchyFilter)
    });
});
parcelRegister("frYif", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2a398348567f4a1$export$2e2bcd8739ae039);
    var $fn8B5 = parcelRequire("fn8B5");
    var $koVbs;
    var $NTvsc = parcelRequire("NTvsc");
    var $dQw48 = parcelRequire("dQw48");
    const $e2a398348567f4a1$var$IssueTypeOptionsProvider = ({ issueTypesByProjectId: issueTypesByProjectId, hierarchyRangeFilter: hierarchyRangeFilter, projectId: projectId, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isLevelWithinHierarchyRangeFilter = (level)=>level >= hierarchyRangeFilter.value.end && level <= hierarchyRangeFilter.value.start;
        const createOptionFromIssueType = (issueType)=>({
                id: `issue-type-${issueType.id}`,
                name: issueType.name,
                value: issueType,
                url: issueType.iconUrl,
                urlType: 'icon'
            });
        const getOptionsFromIssueTypes = (issueTypes)=>issueTypes.map(createOptionFromIssueType).sort((0, $NTvsc.optionSortComparator));
        const getOptionGroupsFromIssueTypes = ()=>{
            const issueTypes = issueTypesByProjectId[projectId];
            const issueTypesByLevel = (0, ($parcel$interopDefault($fn8B5)))(issueTypes, (issueType)=>issueType.level);
            return Object.entries(issueTypesByLevel).filter(([hierarchyLevel])=>isLevelWithinHierarchyRangeFilter(parseInt(hierarchyLevel, 10))).map(([hierarchyLevel, hierarchyIssueTypes])=>({
                    id: `issue-type-group-${hierarchyLevel}`,
                    sortValue: parseInt(hierarchyLevel, 10),
                    options: getOptionsFromIssueTypes(hierarchyIssueTypes)
                })).sort((0, $NTvsc.optionGroupSortComparator));
        };
        return children({
            options: {
                type: (0, $677974980f6adf58$export$3e9b5c83c6ff2586),
                groups: getOptionGroupsFromIssueTypes()
            },
            menuTitle: formatMessage((0, $dQw48.default).issueTypeMenuTitle),
            searchPlaceholder: formatMessage((0, $dQw48.default).issueTypeSearchPlaceholder)
        });
    };
    var $e2a398348567f4a1$export$2e2bcd8739ae039 = $e2a398348567f4a1$var$IssueTypeOptionsProvider;
});
parcelRegister("dQw48", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0303256067f8c07$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b0303256067f8c07$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTypeMenuTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.issue-type.issue-type-menu-title",
            "defaultMessage": "Choose issue type"
        },
        issueTypeSearchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.options-providers.issue-type.issue-type-search-placeholder",
            "defaultMessage": "Find issue types..."
        }
    });
});
parcelRegister("lIIuy", function(module, exports) {
    $parcel$export(module.exports, "getProjectId", ()=>$03fad3b1735f8781$export$89040d072f281f85);
    const $03fad3b1735f8781$var$getReleaseProjectId = (releaseId, enrichedVersions)=>{
        const release = enrichedVersions.find((version)=>version.id === releaseId);
        if (!release) return;
        const project = release.projects[0];
        return typeof project === 'number' ? project : project.id;
    };
    const $03fad3b1735f8781$export$89040d072f281f85 = (selectedOptions, enrichedVersions)=>{
        const projectOption = selectedOptions.project;
        const projectId = projectOption?.value?.project;
        if (!projectId) {
            const groupOption = selectedOptions.group;
            const releaseId = groupOption?.value?.release;
            if (!releaseId) return undefined;
            return $03fad3b1735f8781$var$getReleaseProjectId(releaseId, enrichedVersions);
        }
        return projectId;
    };
});
parcelRegister("94mWM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7faff4c86e74eff6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7faff4c86e74eff6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createIssue: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.create-issue",
            "defaultMessage": "Create issue"
        },
        addIssueDisabledTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.add-issue-disabled-tooltip",
            "defaultMessage": "You can create issues for issue groupings where only single values can be set."
        },
        createIssueTypeDisabledTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.create-issue-type-disabled-tooltip",
            "defaultMessage": "This hierarchy level isn\u2019t available for the projects used in this plan. Project admins can add issue types at this hierarchy level in the project settings."
        },
        createIssueTypeDisabledTmpTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.create-issue-type-disabled-tmp-tooltip",
            "defaultMessage": "Add a company-managed project to your plan to use hierarchy levels above epic."
        },
        createIssueHiddenEntryTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.create-issue-hidden-entry-tooltip",
            "defaultMessage": "This level is currently hidden. To create {hierarchy} issues, include this level in the hierarchy range."
        }
    });
});
parcelRegister("6mTC5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a6d3d54f82602c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $BLPHT;
    const $3a6d3d54f82602c4$var$NestedMenu = ({ trigger: trigger, menus: menus, currentMenu: currentMenu, getMenu: getMenu, onSelectOptions: onSelectOptions, selectedOptions: selectedOptions = {} })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const menu = currentMenu ?? getMenu(selectedOptions);
        if ((0, ($parcel$interopDefault($hGgHi)))(menu)) throw Error('Menu could not be determined.');
        const CurrentMenuComponent = menus[menu];
        const handleSelectOptions = (newSelectedOptions)=>{
            onSelectOptions(newSelectedOptions);
            setIsOpen(false);
        };
        const renderOption = (option, optionTrigger)=>{
            const newSelectedOptions = {
                ...selectedOptions,
                [menu]: option
            };
            const nextMenu = getMenu(newSelectedOptions);
            if ((0, ($parcel$interopDefault($hGgHi)))(nextMenu)) return optionTrigger({
                onClick: ()=>handleSelectOptions(newSelectedOptions)
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($3a6d3d54f82602c4$var$NestedMenu, {
                trigger: optionTrigger,
                menus: menus,
                currentMenu: nextMenu,
                getMenu: getMenu,
                onSelectOptions: handleSelectOptions,
                selectedOptions: newSelectedOptions
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: trigger,
            isOpen: isOpen,
            onOpenChange: (attrs)=>setIsOpen(attrs.isOpen),
            placement: (0, ($parcel$interopDefault($hGgHi)))(currentMenu) ? 'bottom-start' : 'right-start',
            shouldRenderToParent: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(CurrentMenuComponent, {
            selectedOptions: selectedOptions,
            renderOption: renderOption
        }));
    };
    var $3a6d3d54f82602c4$export$2e2bcd8739ae039 = $3a6d3d54f82602c4$var$NestedMenu;
});
parcelRegister("iOb8Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d629fb7d8d357a7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6lAum = parcelRequire("6lAum");
    var $8AcyK = parcelRequire("8AcyK");
    const $2d629fb7d8d357a7$var$ProjectMenu = ({ renderOption: renderOption })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $8AcyK.default), null, (result)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $6lAum.default), {
                renderOption: renderOption,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.create-issue.project-menu",
                ...result
            }));
    var $2d629fb7d8d357a7$export$2e2bcd8739ae039 = $2d629fb7d8d357a7$var$ProjectMenu;
});
parcelRegister("kOO7N", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_CREATE_SUPPORTED_GROUPS", ()=>$14653875178f183f$export$68650f863e35e955);
    $parcel$export(module.exports, "GROUP", ()=>$14653875178f183f$export$2b9b886dddb4ba32);
    $parcel$export(module.exports, "PROJECT", ()=>$14653875178f183f$export$fe791c4fa892e400);
    $parcel$export(module.exports, "ISSUE_TYPE", ()=>$14653875178f183f$export$ebb48b08205007c5);
    var $TTKUQ = parcelRequire("TTKUQ");
    const $14653875178f183f$export$68650f863e35e955 = [
        (0, $TTKUQ.GROUPING).NONE,
        (0, $TTKUQ.GROUPING).ASSIGNEE,
        (0, $TTKUQ.GROUPING).REPORTER,
        (0, $TTKUQ.GROUPING).PROJECT,
        (0, $TTKUQ.GROUPING).RELEASE,
        (0, $TTKUQ.GROUPING).SPRINT,
        (0, $TTKUQ.GROUPING).TEAM
    ];
    const $14653875178f183f$export$2b9b886dddb4ba32 = 'group';
    const $14653875178f183f$export$fe791c4fa892e400 = 'project';
    const $14653875178f183f$export$ebb48b08205007c5 = 'issueType';
});
parcelRegister("c0IZ0", function(module, exports) {
    $parcel$export(module.exports, "TimelineHeader", ()=>$df1319d77f7e45d1$export$c067d86a81dc4cf2);
    var $bC2fB;
    var $4069N = parcelRequire("4069N");
    var $8nRkp = parcelRequire("8nRkp");
    const $df1319d77f7e45d1$export$c067d86a81dc4cf2 = (0, (0, parcelRequire("bC2fB")).connect)((0, $4069N.default), {})((0, $8nRkp.TimelineHeader));
});
parcelRegister("4069N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b63b3bb6a9f1622f$export$2e2bcd8739ae039);
    var $jpgxP = parcelRequire("jpgxP");
    var $3YtPS = parcelRequire("3YtPS");
    const $b63b3bb6a9f1622f$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        fiscalMonth: (0, $jpgxP.getFiscalMonth)
    });
    var $b63b3bb6a9f1622f$export$2e2bcd8739ae039 = $b63b3bb6a9f1622f$var$mapStateToProps;
});
parcelRegister("8nRkp", function(module, exports) {
    $parcel$export(module.exports, "TimelineHeader", ()=>$588cbe6f86bd5f02$export$c067d86a81dc4cf2);
    var $5uXOq = parcelRequire("5uXOq");
    var $8F086 = parcelRequire("8F086");
    const $588cbe6f86bd5f02$export$c067d86a81dc4cf2 = ({ fiscalMonth: fiscalMonth })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $8F086.default), {
            fiscalMonth: fiscalMonth
        });
});
parcelRegister("8F086", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$980a0a98d9659b37$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE4fC;
    var $hKcx5 = parcelRequire("hKcx5");
    var $Ok2Zw = parcelRequire("Ok2Zw");
    function $980a0a98d9659b37$export$2e2bcd8739ae039({ fiscalMonth: fiscalMonth }) {
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        if (zoomLevel) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hKcx5.default), {
            fiscalMonth: fiscalMonth
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $Ok2Zw.default), null);
    }
});
parcelRegister("hKcx5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c481aa54ee529abc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gwejS;
    var $2BeVB;
    var $f1uil;
    var $koVbs;
    var $gh61P;
    var $aipk9;
    var $flnZx;
    var $hE4fC;
    var $jAIJh = parcelRequire("jAIJh");
    var $gz7eu = parcelRequire("gz7eu");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $lKm5E = parcelRequire("lKm5E");
    var $2LOsh = parcelRequire("2LOsh");
    var $6OFOZ = parcelRequire("6OFOZ");
    var $4yFXA = parcelRequire("4yFXA");
    function $c481aa54ee529abc$export$2e2bcd8739ae039({ fiscalMonth: fiscalMonth }) {
        const [{ getPercentageOffset: getPercentageOffset }] = (0, (0, parcelRequire("hE4fC")).useHorizontalPercentageOffset)();
        const [{ viewport: viewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [{ today: today, from: from, to: to }] = (0, (0, parcelRequire("hE4fC")).useRenderingWindow)();
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const { formatTimestamp: formatTimestamp } = (0, (0, parcelRequire("aipk9")).useDateFormatter)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        let topBar;
        let bottomBar;
        const calculateTopBarFirstUnitOffset = (overlap)=>`${getPercentageOffset(viewport.offset - overlap)}%`;
        if (zoomLevel === (0, $TTKUQ.ZOOM_LEVELS).WEEKS) {
            const monthUnits = (0, $lKm5E.getUnits)({
                from: from,
                to: to
            }, (0, $TTKUQ.ZOOM_LEVELS).MONTHS);
            topBar = monthUnits.map((unit, index)=>{
                const isCurrentYear = new Date().getUTCFullYear() === new Date(today + unit.from).getUTCFullYear();
                const monthLabel = formatTimestamp(today + unit.from, {
                    month: 'short',
                    timeZone: 'UTC'
                });
                const yearLabel = formatTimestamp(today + unit.from, {
                    year: '2-digit',
                    timeZone: 'UTC'
                });
                const label = `${monthLabel}${isCurrentYear ? '' : ` \u{2019}${yearLabel}`}`;
                let offset = `${getPercentageOffset(unit.from)}%`;
                if (viewport.offset >= unit.from && viewport.offset <= unit.to) {
                    const overlap = (0, (0, parcelRequire("flnZx")).ONE_DAY) * 2.25 - (unit.to - viewport.offset);
                    if (overlap > 0) offset = calculateTopBarFirstUnitOffset(overlap);
                    else return (0, $4yFXA.getTimeUnitsBarTopUnitPortal)({
                        index: index,
                        label: label
                    });
                }
                return (0, $4yFXA.getTimeUnitsBarTopUnit)({
                    index: index,
                    label: label,
                    offset: offset,
                    width: 0,
                    zoomLevel: zoomLevel
                });
            });
            const dayUnits = (0, $lKm5E.getDayUnits)({
                from: from,
                to: to
            });
            bottomBar = dayUnits.map((unit, index)=>{
                const offset = getPercentageOffset(unit.from);
                const width = getPercentageOffset(unit.to) - offset;
                const date = new Date(today + unit.from);
                const isToday = (0, (0, parcelRequire("f1uil")).default)((0, (0, parcelRequire("flnZx")).startOfUtcDay)(date.getTime()), (0, (0, parcelRequire("flnZx")).startOfUtcDay)((0, $jAIJh.getTodayDate)().getTime() + (0, (0, parcelRequire("flnZx")).dateDiffFromUTC)() * (0, (0, parcelRequire("flnZx")).ONE_DAY)));
                const tooltipContent = `${formatTimestamp(date.getTime(), (0, (0, parcelRequire("gh61P")).weekdayFormatLong))}`;
                return (0, $4yFXA.getTimeUnitsBarBottomUnit)({
                    index: index,
                    isToday: isToday,
                    isWeekendDay: (0, $4yFXA.isWeekendDay)(date),
                    label: formatTimestamp(date.getTime(), {
                        day: 'numeric',
                        timeZone: 'UTC'
                    }),
                    offset: offset,
                    showRightBorder: date.getUTCDay() === 0,
                    showLeftBorder: date.getUTCDay() === 1,
                    width: width,
                    zoomLevel: zoomLevel,
                    tooltipContent: tooltipContent
                });
            });
        } else if (zoomLevel === (0, $TTKUQ.ZOOM_LEVELS).MONTHS) {
            const monthUnits = (0, $lKm5E.getUnits)({
                from: from,
                to: to
            }, (0, $TTKUQ.ZOOM_LEVELS).MONTHS);
            topBar = monthUnits.map((unit, index)=>{
                const isCurrentYear = new Date().getUTCFullYear() === new Date(today + unit.from).getUTCFullYear();
                const monthLabel = formatTimestamp(today + unit.from, {
                    month: 'short',
                    timeZone: 'UTC'
                });
                const yearLabel = formatTimestamp(today + unit.from, {
                    year: '2-digit',
                    timeZone: 'UTC'
                });
                const label = `${monthLabel}${isCurrentYear ? '' : ` \u{2019}${yearLabel}`}`;
                let offset = `${getPercentageOffset(unit.from)}%`;
                if (viewport.offset >= unit.from && viewport.offset <= unit.to) {
                    const overlap = (0, (0, parcelRequire("flnZx")).ONE_WEEK) * 1.4 - (unit.to - viewport.offset);
                    if (overlap > 0) offset = calculateTopBarFirstUnitOffset(overlap);
                    else return (0, $4yFXA.getTimeUnitsBarTopUnitPortal)({
                        index: index,
                        label: label
                    });
                }
                return (0, $4yFXA.getTimeUnitsBarTopUnit)({
                    index: index,
                    label: label,
                    offset: offset,
                    width: 0,
                    zoomLevel: zoomLevel
                });
            });
            const weekUnits = (0, $lKm5E.getUnits)({
                from: from,
                to: to
            }, (0, $TTKUQ.ZOOM_LEVELS).WEEKS);
            bottomBar = weekUnits.map(({ from: from, to: to }, index)=>{
                const offset = getPercentageOffset(from);
                const width = getPercentageOffset(to) - offset;
                const date = new Date(today + from);
                const isToday = (0, (0, parcelRequire("f1uil")).default)((0, (0, parcelRequire("flnZx")).startOfUtcDay)(date.getTime()), (0, (0, parcelRequire("flnZx")).startOfUtcDay)((0, $jAIJh.getTodayDate)().getTime() + (0, (0, parcelRequire("flnZx")).dateDiffFromUTC)() * (0, (0, parcelRequire("flnZx")).ONE_DAY)));
                const tooltipContent = formatMessage((0, $2LOsh.default).week, {
                    weekNumber: (0, (0, parcelRequire("2BeVB")).default)(date.getTime()),
                    firstDay: formatTimestamp(date.getTime(), (0, (0, parcelRequire("gh61P")).shortDateFormat)),
                    lastDay: formatTimestamp((0, (0, parcelRequire("gwejS")).default)(date, 6).getTime(), (0, (0, parcelRequire("gh61P")).shortDateFormat))
                });
                return (0, $4yFXA.getTimeUnitsBarBottomUnit)({
                    alignTextToLeft: true,
                    index: index,
                    isToday: isToday,
                    label: date.getUTCDate(),
                    offset: offset,
                    showLeftPadding: false,
                    showRightBorder: false,
                    width: width,
                    zoomLevel: zoomLevel,
                    tooltipContent: tooltipContent
                });
            });
        } else if (zoomLevel === (0, $TTKUQ.ZOOM_LEVELS).QUARTERS) {
            const topYearUnits = (0, $lKm5E.getUnits)({
                from: from,
                to: to
            }, (0, $TTKUQ.ZOOM_LEVELS).YEARS, fiscalMonth);
            topBar = topYearUnits.map((unit, index)=>{
                const date = new Date(today + unit.from);
                const label = fiscalMonth !== 1 ? formatMessage((0, $2LOsh.default).financialYearPrefix, {
                    financialYear: (0, $gz7eu.formatFY)((0, $gz7eu.calculateFinancialYear)(date.getTime(), fiscalMonth))
                }) : date.getUTCFullYear();
                let offset = `${getPercentageOffset(unit.from)}%`;
                if (viewport.offset >= unit.from && viewport.offset <= unit.to) {
                    const overlap = (0, (0, parcelRequire("flnZx")).ONE_WEEK) * 4 - (unit.to - viewport.offset);
                    if (overlap > 0) offset = calculateTopBarFirstUnitOffset(overlap);
                    else return (0, $4yFXA.getTimeUnitsBarTopUnitPortal)({
                        index: index,
                        label: label
                    });
                }
                return (0, $4yFXA.getTimeUnitsBarTopUnit)({
                    index: index,
                    label: label,
                    offset: offset,
                    width: 0,
                    zoomLevel: zoomLevel
                });
            });
            const bottomQuarterUnits = (0, $lKm5E.getUnits)({
                from: from,
                to: to
            }, (0, $TTKUQ.ZOOM_LEVELS).QUARTERS, fiscalMonth);
            bottomBar = bottomQuarterUnits.map((unit, index)=>{
                const offset = getPercentageOffset(unit.from);
                const width = getPercentageOffset(unit.to) - offset;
                const startDate = new Date(today + unit.from);
                const startTime = startDate.getTime();
                const endTime = new Date(today + unit.to - (0, (0, parcelRequire("flnZx")).ONE_DAY)).getTime();
                const thisMonth = startDate.getUTCMonth();
                const quarterNumber = (0, $jAIJh.getQuarterLabel)(thisMonth, fiscalMonth);
                const quarterStartMonthShortString = formatTimestamp(today + unit.from, {
                    month: 'short',
                    timeZone: 'UTC'
                });
                const quarterEndMonthShortString = formatTimestamp(today + unit.to - (0, (0, parcelRequire("flnZx")).ONE_DAY), {
                    month: 'short',
                    timeZone: 'UTC'
                });
                const tooltipContent = fiscalMonth !== 1 ? formatMessage((0, $2LOsh.default).financialYearQuarter, {
                    quarterNumber: quarterNumber,
                    firstDay: formatTimestamp(startTime, (0, (0, parcelRequire("gh61P")).shortDateFormat)),
                    lastDay: formatTimestamp(endTime, (0, (0, parcelRequire("gh61P")).shortDateFormat)),
                    financialYear: (0, $gz7eu.calculateFinancialYear)(startTime, fiscalMonth)
                }) : formatMessage((0, $2LOsh.default).calendarYearQuarter, {
                    quarterNumber: quarterNumber,
                    firstDay: formatTimestamp(startTime, (0, (0, parcelRequire("gh61P")).shortDateFormat)),
                    lastDay: formatTimestamp(endTime, (0, (0, parcelRequire("gh61P")).shortDateFormat))
                });
                return (0, $4yFXA.getTimeUnitsBarBottomUnit)({
                    index: index,
                    label: formatMessage((0, $2LOsh.default).quarterDescriptorLong, {
                        quarterNumber: quarterNumber,
                        quarterStartMonthShortString: quarterStartMonthShortString,
                        quarterEndMonthShortString: quarterEndMonthShortString
                    }),
                    offset: offset,
                    showRightBorder: false,
                    showLeftBorder: true,
                    width: width,
                    zoomLevel: (0, $TTKUQ.ZOOM_LEVELS).QUARTERS,
                    tooltipContent: tooltipContent
                });
            });
        } else if (zoomLevel === (0, $TTKUQ.ZOOM_LEVELS).YEARS) {
            const yearUnits = (0, $lKm5E.getUnits)({
                from: from,
                to: to
            }, (0, $TTKUQ.ZOOM_LEVELS).YEARS, fiscalMonth);
            topBar = yearUnits.map((unit, index)=>{
                const date = new Date(today + unit.from);
                const label = fiscalMonth !== 1 ? formatMessage((0, $2LOsh.default).financialYearPrefix, {
                    financialYear: (0, $gz7eu.formatFY)((0, $gz7eu.calculateFinancialYear)(date.getTime(), fiscalMonth))
                }) : date.getUTCFullYear();
                let offset = `${getPercentageOffset(unit.from)}%`;
                if (viewport.offset >= unit.from && viewport.offset <= unit.to) {
                    const overlap = (0, (0, parcelRequire("flnZx")).ONE_WEEK) * 10 - (unit.to - viewport.offset);
                    if (overlap > 0) offset = calculateTopBarFirstUnitOffset(overlap);
                    else return (0, $4yFXA.getTimeUnitsBarTopUnitPortal)({
                        index: index,
                        label: label
                    });
                }
                return (0, $4yFXA.getTimeUnitsBarTopUnit)({
                    index: index,
                    label: label,
                    offset: offset,
                    width: 0,
                    zoomLevel: zoomLevel
                });
            });
            const quarterUnits = (0, $lKm5E.getUnits)({
                from: from,
                to: to
            }, (0, $TTKUQ.ZOOM_LEVELS).QUARTERS, fiscalMonth);
            bottomBar = quarterUnits.map((unit, index)=>{
                const offset = getPercentageOffset(unit.from);
                const width = getPercentageOffset(unit.to) - offset;
                const date = new Date(today + unit.from);
                const startTime = date.getTime();
                const endTime = new Date(today + unit.to - (0, (0, parcelRequire("flnZx")).ONE_DAY)).getTime();
                const quarterNumber = (0, $jAIJh.getQuarterLabel)(date.getUTCMonth(), fiscalMonth);
                const tooltipContent = fiscalMonth !== 1 ? formatMessage((0, $2LOsh.default).financialYearQuarter, {
                    quarterNumber: quarterNumber,
                    firstDay: formatTimestamp(startTime, (0, (0, parcelRequire("gh61P")).shortDateFormat)),
                    lastDay: formatTimestamp(endTime, (0, (0, parcelRequire("gh61P")).shortDateFormat)),
                    financialYear: (0, $gz7eu.calculateFinancialYear)(startTime, fiscalMonth)
                }) : formatMessage((0, $2LOsh.default).calendarYearQuarter, {
                    quarterNumber: quarterNumber,
                    firstDay: formatTimestamp(startTime, (0, (0, parcelRequire("gh61P")).shortDateFormat)),
                    lastDay: formatTimestamp(endTime, (0, (0, parcelRequire("gh61P")).shortDateFormat))
                });
                return (0, $4yFXA.getTimeUnitsBarBottomUnit)({
                    index: index,
                    label: formatMessage((0, $2LOsh.default).quarterDescriptorShort, {
                        quarterNumber: quarterNumber
                    }),
                    offset: offset,
                    showRightBorder: false,
                    showLeftBorder: quarterNumber === '1',
                    width: width,
                    zoomLevel: zoomLevel,
                    tooltipContent: tooltipContent
                });
            });
        }
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $6OFOZ.timeUnitsBar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": `${(0, $4yFXA.testId)}.top`,
            className: $6OFOZ.timeUnitsBarTop
        }, topBar), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": `${(0, $4yFXA.testId)}.bottom`,
            className: $6OFOZ.timeUnitsBarBottom
        }, bottomBar)));
    }
});
parcelRegister("gz7eu", function(module, exports) {
    $parcel$export(module.exports, "calculateFinancialYear", ()=>$11c0123e5300a5a1$export$ecfb8a99ff85ea57);
    $parcel$export(module.exports, "formatFY", ()=>$11c0123e5300a5a1$export$663a8e9ea7479005);
    const $11c0123e5300a5a1$export$ecfb8a99ff85ea57 = (time, fyStartMonth = 1)=>{
        const date = new Date(time);
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth() + 1;
        if (fyStartMonth > 1 && month >= fyStartMonth) return year + 1;
        return year;
    };
    const $11c0123e5300a5a1$export$663a8e9ea7479005 = (year)=>`${year}`.slice(-2);
});
parcelRegister("2LOsh", function(module, exports) {
    $parcel$export(module.exports, "quarters", ()=>$0d6dd08317679428$export$e0e5e1b96f56de29);
    $parcel$export(module.exports, "default", ()=>$0d6dd08317679428$export$2e2bcd8739ae039);
    var $7VHMR;
    const $0d6dd08317679428$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        january: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.january",
            "defaultMessage": "Jan"
        },
        february: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.february",
            "defaultMessage": "Feb"
        },
        march: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.march",
            "defaultMessage": "Mar"
        },
        april: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.april",
            "defaultMessage": "Apr"
        },
        may: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.may",
            "defaultMessage": "May"
        },
        june: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.june",
            "defaultMessage": "Jun"
        },
        july: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.july",
            "defaultMessage": "Jul"
        },
        august: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.august",
            "defaultMessage": "Aug"
        },
        september: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.september",
            "defaultMessage": "Sep"
        },
        october: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.october",
            "defaultMessage": "Oct"
        },
        november: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.november",
            "defaultMessage": "Nov"
        },
        december: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.december",
            "defaultMessage": "Dec"
        },
        week: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.week",
            "defaultMessage": "Week {weekNumber} {firstDay} to {lastDay}"
        },
        financialYearQuarter: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.financial-year-quarter",
            "defaultMessage": "Quarter {quarterNumber} {firstDay} to {lastDay}, Financial Year {financialYear}"
        },
        calendarYearQuarter: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.calendar-year-quarter",
            "defaultMessage": "Quarter {quarterNumber} {firstDay} to {lastDay}"
        },
        financialYearPrefix: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.financial-year-prefix",
            "defaultMessage": "FY{financialYear}"
        },
        quarterDescriptorShort: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.quarter-descriptor-short",
            "defaultMessage": "Q{quarterNumber}"
        },
        quarterDescriptorLong: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.quarter-descriptor-long",
            "defaultMessage": "Q{quarterNumber} {quarterStartMonthShortString} - {quarterEndMonthShortString}"
        }
    });
    const $0d6dd08317679428$export$62f5e462247f69c8 = [
        {
            startMonth: $0d6dd08317679428$var$messages.january,
            endMonth: $0d6dd08317679428$var$messages.march
        },
        {
            startMonth: $0d6dd08317679428$var$messages.april,
            endMonth: $0d6dd08317679428$var$messages.june
        },
        {
            startMonth: $0d6dd08317679428$var$messages.july,
            endMonth: $0d6dd08317679428$var$messages.september
        },
        {
            startMonth: $0d6dd08317679428$var$messages.october,
            endMonth: $0d6dd08317679428$var$messages.december
        }
    ];
    const $0d6dd08317679428$export$e0e5e1b96f56de29 = [
        $0d6dd08317679428$var$messages.january,
        $0d6dd08317679428$var$messages.april,
        $0d6dd08317679428$var$messages.july,
        $0d6dd08317679428$var$messages.october
    ];
    var $0d6dd08317679428$export$2e2bcd8739ae039 = $0d6dd08317679428$var$messages;
});
parcelRegister("6OFOZ", function(module, exports) {
    $parcel$export(module.exports, "dateLozenge", ()=>$4f67da70a3053b4b$export$7bf2e051a0a913e, (v)=>$4f67da70a3053b4b$export$7bf2e051a0a913e = v);
    $parcel$export(module.exports, "infiniteAxis", ()=>$4f67da70a3053b4b$export$802b59a58cf5b17f, (v)=>$4f67da70a3053b4b$export$802b59a58cf5b17f = v);
    $parcel$export(module.exports, "newOverride", ()=>$4f67da70a3053b4b$export$c4e875003ce9ab52, (v)=>$4f67da70a3053b4b$export$c4e875003ce9ab52 = v);
    $parcel$export(module.exports, "staticAxis", ()=>$4f67da70a3053b4b$export$f485c5d219611ae4, (v)=>$4f67da70a3053b4b$export$f485c5d219611ae4 = v);
    $parcel$export(module.exports, "timeUnitsBar", ()=>$4f67da70a3053b4b$export$b1ce12b9a87363e9, (v)=>$4f67da70a3053b4b$export$b1ce12b9a87363e9 = v);
    $parcel$export(module.exports, "timeUnitsBarBottom", ()=>$4f67da70a3053b4b$export$ce30c66e03cd2823, (v)=>$4f67da70a3053b4b$export$ce30c66e03cd2823 = v);
    $parcel$export(module.exports, "timeUnitsBarBottomUnit", ()=>$4f67da70a3053b4b$export$4740305de9c60fe0, (v)=>$4f67da70a3053b4b$export$4740305de9c60fe0 = v);
    $parcel$export(module.exports, "timeUnitsBarBottomUnitContent", ()=>$4f67da70a3053b4b$export$b60b4c343bef999, (v)=>$4f67da70a3053b4b$export$b60b4c343bef999 = v);
    $parcel$export(module.exports, "timeUnitsBarContent", ()=>$4f67da70a3053b4b$export$d74887457c89c52, (v)=>$4f67da70a3053b4b$export$d74887457c89c52 = v);
    $parcel$export(module.exports, "timeUnitsBarTop", ()=>$4f67da70a3053b4b$export$1c5daac66ea01541, (v)=>$4f67da70a3053b4b$export$1c5daac66ea01541 = v);
    $parcel$export(module.exports, "timeUnitsBarTopUnit", ()=>$4f67da70a3053b4b$export$c442a59fddbcaac9, (v)=>$4f67da70a3053b4b$export$c442a59fddbcaac9 = v);
    $parcel$export(module.exports, "timeUnitsBarTopUnitContent", ()=>$4f67da70a3053b4b$export$c99d17876c31b812, (v)=>$4f67da70a3053b4b$export$c99d17876c31b812 = v);
    $parcel$export(module.exports, "withLeftBorder", ()=>$4f67da70a3053b4b$export$406c9f761699d0ee, (v)=>$4f67da70a3053b4b$export$406c9f761699d0ee = v);
    $parcel$export(module.exports, "yearWrapper", ()=>$4f67da70a3053b4b$export$f5a2c8e73b53d4db, (v)=>$4f67da70a3053b4b$export$f5a2c8e73b53d4db = v);
    var $4f67da70a3053b4b$export$7bf2e051a0a913e;
    var $4f67da70a3053b4b$export$802b59a58cf5b17f;
    var $4f67da70a3053b4b$export$c4e875003ce9ab52;
    var $4f67da70a3053b4b$export$f485c5d219611ae4;
    var $4f67da70a3053b4b$export$b1ce12b9a87363e9;
    var $4f67da70a3053b4b$export$ce30c66e03cd2823;
    var $4f67da70a3053b4b$export$4740305de9c60fe0;
    var $4f67da70a3053b4b$export$b60b4c343bef999;
    var $4f67da70a3053b4b$export$d74887457c89c52;
    var $4f67da70a3053b4b$export$1c5daac66ea01541;
    var $4f67da70a3053b4b$export$c442a59fddbcaac9;
    var $4f67da70a3053b4b$export$c99d17876c31b812;
    var $4f67da70a3053b4b$export$406c9f761699d0ee;
    var $4f67da70a3053b4b$export$f5a2c8e73b53d4db;
    $4f67da70a3053b4b$export$7bf2e051a0a913e = `esbLaW_dateLozenge`;
    $4f67da70a3053b4b$export$802b59a58cf5b17f = `esbLaW_infiniteAxis`;
    $4f67da70a3053b4b$export$c4e875003ce9ab52 = `esbLaW_newOverride`;
    $4f67da70a3053b4b$export$f485c5d219611ae4 = `esbLaW_staticAxis`;
    $4f67da70a3053b4b$export$b1ce12b9a87363e9 = `esbLaW_timeUnitsBar`;
    $4f67da70a3053b4b$export$ce30c66e03cd2823 = `esbLaW_timeUnitsBarBottom`;
    $4f67da70a3053b4b$export$4740305de9c60fe0 = `esbLaW_timeUnitsBarBottomUnit`;
    $4f67da70a3053b4b$export$b60b4c343bef999 = `esbLaW_timeUnitsBarBottomUnitContent`;
    $4f67da70a3053b4b$export$d74887457c89c52 = `esbLaW_timeUnitsBarContent`;
    $4f67da70a3053b4b$export$1c5daac66ea01541 = `esbLaW_timeUnitsBarTop`;
    $4f67da70a3053b4b$export$c442a59fddbcaac9 = `esbLaW_timeUnitsBarTopUnit`;
    $4f67da70a3053b4b$export$c99d17876c31b812 = `esbLaW_timeUnitsBarTopUnitContent`;
    $4f67da70a3053b4b$export$406c9f761699d0ee = `esbLaW_withLeftBorder`;
    $4f67da70a3053b4b$export$f5a2c8e73b53d4db = `esbLaW_yearWrapper`;
});
parcelRegister("4yFXA", function(module, exports) {
    $parcel$export(module.exports, "testId", ()=>$d23920fc523a514c$export$d428cfd0d6a2b2ec);
    $parcel$export(module.exports, "getTimeUnitsBarTopUnit", ()=>$d23920fc523a514c$export$faca2e900e659899);
    $parcel$export(module.exports, "getTimeUnitsBarTopUnitPortal", ()=>$d23920fc523a514c$export$50ab3995cbf498f9);
    $parcel$export(module.exports, "getTimeUnitsBarBottomUnit", ()=>$d23920fc523a514c$export$fd3a8da674cde14d);
    $parcel$export(module.exports, "isWeekendDay", ()=>$d23920fc523a514c$export$41da6887b3b8f593);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $38Gym;
    var $f2fy0;
    var $c9FOp;
    var $2B09c;
    var $lj8SI;
    var $3bDjY;
    var $co1wz;
    var $ousew;
    var $4y9A5 = parcelRequire("4y9A5");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $2LOsh = parcelRequire("2LOsh");
    var $6OFOZ = parcelRequire("6OFOZ");
    const $d23920fc523a514c$export$d428cfd0d6a2b2ec = 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar';
    const $d23920fc523a514c$export$faca2e900e659899 = ({ index: index, label: label, offset: offset, width: width, zoomLevel: zoomLevel })=>{
        if (zoomLevel) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": `${$d23920fc523a514c$export$d428cfd0d6a2b2ec}.top-unit-${index}`,
            key: `timeUnitsBarTopUnit${index}`,
            className: `${$6OFOZ.timeUnitsBarTopUnit} ${$6OFOZ.infiniteAxis} ${$6OFOZ.newOverride}`,
            style: {
                left: offset
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$6OFOZ.timeUnitsBarTopUnitContent} ${$6OFOZ.infiniteAxis} ${$6OFOZ.withLeftBorder}`
        }, label));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": `${$d23920fc523a514c$export$d428cfd0d6a2b2ec}.top-unit-${index}`,
            key: `timeUnitsBarTopUnit${index}`,
            className: `${$6OFOZ.timeUnitsBarTopUnit} ${$6OFOZ.newOverride}`,
            style: {
                left: offset,
                width: `${width}%`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$6OFOZ.timeUnitsBarTopUnitContent} ${$6OFOZ.staticAxis} ${index > 0 ? $6OFOZ.withLeftBorder : ''}`
        }, label));
    };
    const $d23920fc523a514c$export$50ab3995cbf498f9 = ({ index: index, label: label })=>{
        const container = document.getElementById((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2') ? 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.overlay.axis-first-time-unit.sticky-date' : `portfolio-3-common.sections.item.${(0, $TTKUQ.SECTION_ITEM_KEYS).TIMELINE}`);
        if (container) return (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": `${$d23920fc523a514c$export$d428cfd0d6a2b2ec}.top-unit-${index}`,
            key: `timeUnitsBarTopUnit${index}`,
            className: `${$6OFOZ.timeUnitsBarTopUnit} ${$6OFOZ.infiniteAxis} ${$6OFOZ.newOverride}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$6OFOZ.timeUnitsBarTopUnitContent} ${$6OFOZ.staticAxis}`
        }, label)), container || (0, $4y9A5.getBody)());
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            key: `timeUnitsBarTopUnit${index}`
        });
    };
    const $d23920fc523a514c$export$d337baad096e3dd2 = (isToday, isWeekendDay, label)=>{
        if (isToday) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "inprogress"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $6OFOZ.dateLozenge
        }, label));
        if (isWeekendDay) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "default"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $6OFOZ.dateLozenge
        }, label));
        return label;
    };
    const $d23920fc523a514c$export$fd3a8da674cde14d = ({ alignTextToLeft: alignTextToLeft = false, index: index, isToday: isToday = false, isWeekendDay: isWeekendDay = false, label: label, offset: offset, showLeftPadding: showLeftPadding = false, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder = false, width: width, zoomLevel: zoomLevel, tooltipContent: tooltipContent })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            key: `timeUnitsBarBottomUnit${index}`,
            content: tooltipContent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": `${$d23920fc523a514c$export$d428cfd0d6a2b2ec}.bottom-unit-${index}`,
            className: $6OFOZ.timeUnitsBarBottomUnit,
            style: {
                left: `${offset}%`,
                width: `${width}%`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$6OFOZ.timeUnitsBarBottomUnitContent} ${$6OFOZ.newOverride} ${zoomLevel ? '' : $6OFOZ.staticAxis} ${showRightBorder} ${showLeftBorder && $6OFOZ.withLeftBorder} ${$6OFOZ.newOverride}`,
            style: {
                textAlign: alignTextToLeft ? 'left' : 'center',
                paddingLeft: showLeftPadding ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)"
            }
        }, $d23920fc523a514c$export$d337baad096e3dd2(isToday, isWeekendDay, label))));
    const $d23920fc523a514c$export$dd1ec7b2c7c7352b = (timeUnit)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$6OFOZ.timeUnitsBarContent} ${$6OFOZ.infiniteAxis} ${$6OFOZ.withLeftBorder}`
        }, timeUnit);
    const $d23920fc523a514c$export$a7f0d2a9ddb86918 = (startTime, timelineRangeStart, timelineRangeEnd)=>{
        let quarterStart = (0, (0, parcelRequire("2B09c")).default)(startTime);
        const timelineEndDate = new Date(timelineRangeEnd);
        const timelineStartDate = new Date(timelineRangeStart);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $6OFOZ.yearWrapper
        }, (0, $2LOsh.quarters).map((quarter, index)=>{
            quarterStart = (0, (0, parcelRequire("c9FOp")).default)(quarterStart);
            const quarterEnd = (0, (0, parcelRequire("f2fy0")).default)(quarterStart);
            quarterStart = (0, (0, parcelRequire("38Gym")).default)(quarterStart, 1);
            if (quarterStart > timelineStartDate && quarterEnd < timelineEndDate) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), quarter));
            return null;
        })));
    };
    const $d23920fc523a514c$export$41da6887b3b8f593 = (date)=>date.getUTCDay() % 6 === 0;
});
parcelRegister("Ok2Zw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$013f4411299b1a24$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5VA05 = parcelRequire("5VA05");
    var $bEHR9 = parcelRequire("bEHR9");
    var $013f4411299b1a24$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $5VA05.default), {})((0, $bEHR9.default));
});
parcelRegister("5VA05", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2163844fd07255c5$export$2e2bcd8739ae039);
    var $jpgxP = parcelRequire("jpgxP");
    var $jAIJh = parcelRequire("jAIJh");
    var $3YtPS = parcelRequire("3YtPS");
    var $2163844fd07255c5$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        timelineRange: (0, $jAIJh.getTimelineRange),
        fiscalMonth: (0, $jpgxP.getFiscalMonth)
    });
});
parcelRegister("bEHR9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e876f7ec4711268$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gwejS;
    var $2BeVB;
    var $f1uil;
    var $it1wb;
    var $bjzU8;
    var $koVbs;
    var $gh61P;
    var $aipk9;
    var $flnZx;
    var $jAIJh = parcelRequire("jAIJh");
    var $82Qle = parcelRequire("82Qle");
    var $gz7eu = parcelRequire("gz7eu");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $2LOsh = parcelRequire("2LOsh");
    var $6OFOZ = parcelRequire("6OFOZ");
    var $4yFXA = parcelRequire("4yFXA");
    function $9e876f7ec4711268$export$2e2bcd8739ae039({ timelineRange: timelineRange, fiscalMonth: fiscalMonth }) {
        const { formatTimestamp: formatTimestamp } = (0, (0, parcelRequire("aipk9")).useDateFormatter)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { start: timelineRangeStart, end: timelineRangeEnd } = timelineRange;
        const daysInRange = (timelineRangeEnd - timelineRangeStart) / (0, (0, parcelRequire("flnZx")).ONE_DAY);
        const dayUnits = (0, $jAIJh.getDayUnits)(timelineRangeStart, daysInRange);
        let topBar;
        let bottomBar;
        if (dayUnits.length <= (0, $TTKUQ.CUSTOM_DATE_RANGES).SMALL) {
            const monthUnits = (0, $jAIJh.getMonthUnits)(timelineRangeStart, timelineRangeEnd);
            topBar = monthUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
                const isCurrentYear = new Date().getUTCFullYear() === new Date(startTime).getUTCFullYear();
                const monthLabel = formatTimestamp(startTime, {
                    month: 'short',
                    timeZone: 'UTC'
                });
                const yearLabel = formatTimestamp(startTime, {
                    year: '2-digit',
                    timeZone: 'UTC'
                });
                return (0, $4yFXA.getTimeUnitsBarTopUnit)({
                    index: index,
                    label: `${monthLabel}${isCurrentYear ? '' : ` \u{2019}${yearLabel}`}`,
                    offset: 0,
                    width: widthPercentage
                });
            });
            let width = 0;
            bottomBar = dayUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
                const startDate = new Date(startTime);
                const isToday = (0, (0, parcelRequire("f1uil")).default)((0, (0, parcelRequire("it1wb")).default)(startDate), (0, (0, parcelRequire("it1wb")).default)((0, $jAIJh.getTodayDate)().getTime() - (0, (0, parcelRequire("flnZx")).dateDiffFromUTC)() * (0, (0, parcelRequire("flnZx")).ONE_DAY)));
                const tooltipContent = `${formatTimestamp(startDate.getTime(), (0, (0, parcelRequire("gh61P")).weekdayFormatLong))}`;
                const unit = (0, $4yFXA.getTimeUnitsBarBottomUnit)({
                    index: index,
                    isToday: isToday,
                    isWeekendDay: (0, $4yFXA.isWeekendDay)(startDate),
                    label: formatTimestamp(startTime, {
                        day: 'numeric',
                        timeZone: 'UTC'
                    }),
                    offset: width,
                    showRightBorder: false,
                    showLeftBorder: index > 0 && startDate.getUTCDay() === 1,
                    width: widthPercentage,
                    tooltipContent: tooltipContent
                });
                width += widthPercentage;
                return unit;
            });
        } else if (dayUnits.length <= (0, $TTKUQ.CUSTOM_DATE_RANGES).MEDIUM) {
            const monthUnits = (0, $jAIJh.getMonthUnits)(timelineRangeStart, timelineRangeEnd);
            topBar = monthUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
                const isCurrentYear = new Date().getUTCFullYear() === new Date(startTime).getUTCFullYear();
                const monthLabel = formatTimestamp(startTime, {
                    month: 'short',
                    timeZone: 'UTC'
                });
                const yearLabel = formatTimestamp(startTime, {
                    year: '2-digit',
                    timeZone: 'UTC'
                });
                return (0, $4yFXA.getTimeUnitsBarTopUnit)({
                    index: index,
                    label: `${monthLabel}${isCurrentYear ? '' : ` \u{2019}${yearLabel}`}`,
                    offset: 0,
                    width: widthPercentage
                });
            });
            let dateCursor;
            const bottomUnits = dayUnits.reduce((acc, { startTime: startTime, widthPercentage: widthPercentage }, index)=>{
                const startDate = new Date(startTime);
                if (index > 0 && startDate.getUTCDay() !== 1) acc[dateCursor].widthPercentage += widthPercentage;
                else {
                    dateCursor = startTime;
                    acc[dateCursor] = {
                        startTime: startTime,
                        widthPercentage: widthPercentage
                    };
                }
                return acc;
            }, {});
            let width = 0;
            bottomBar = (0, parcelRequire("bjzU8")).default(bottomUnits).map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
                const startDate = new Date(startTime);
                const isMonday = startDate.getUTCDay() === 1;
                const tooltipContent = formatMessage((0, $2LOsh.default).week, {
                    weekNumber: (0, (0, parcelRequire("2BeVB")).default)(startDate.getTime()),
                    firstDay: formatTimestamp(startDate.getTime(), (0, (0, parcelRequire("gh61P")).shortDateFormat)),
                    lastDay: formatTimestamp((0, (0, parcelRequire("gwejS")).default)(startDate, 6).getTime(), (0, (0, parcelRequire("gh61P")).shortDateFormat))
                });
                const unit = (0, $4yFXA.getTimeUnitsBarBottomUnit)({
                    alignTextToLeft: true,
                    index: index,
                    isToday: isMonday && (0, (0, parcelRequire("f1uil")).default)((0, (0, parcelRequire("flnZx")).startOfUtcDay)(startDate.getTime()), (0, (0, parcelRequire("flnZx")).startOfUtcDay)((0, $jAIJh.getTodayDate)().getTime())),
                    label: isMonday ? startDate.getUTCDate() : '',
                    offset: width,
                    showLeftPadding: false,
                    showRightBorder: false,
                    width: widthPercentage,
                    tooltipContent: tooltipContent
                });
                width += widthPercentage;
                return unit;
            });
        } else if (dayUnits.length <= (0, $TTKUQ.CUSTOM_DATE_RANGES).LARGE) {
            const yearUnits = (0, $jAIJh.getYearUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
            topBar = yearUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
                const startDate = new Date(startTime);
                return (0, $4yFXA.getTimeUnitsBarTopUnit)({
                    index: index,
                    label: fiscalMonth !== 1 ? formatMessage((0, $2LOsh.default).financialYearPrefix, {
                        financialYear: (0, $gz7eu.formatFY)((0, $gz7eu.calculateFinancialYear)(startTime, fiscalMonth))
                    }) : startDate.getUTCFullYear(),
                    offset: 0,
                    width: widthPercentage
                });
            });
            const quarterUnits = (0, $jAIJh.getQuarterUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
            let width = 0;
            bottomBar = quarterUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
                const startDate = new Date(startTime);
                const quarterNumber = (0, $82Qle.calculateQuarter)(startDate.getUTCMonth() + 1, fiscalMonth);
                let quarterStartMonth = fiscalMonth + (quarterNumber - 1) * 3;
                let quarterEndYear = startDate.getUTCFullYear();
                if (quarterStartMonth > 12) quarterStartMonth %= 12;
                if (quarterStartMonth > 10) quarterEndYear++;
                const quarterEndMonth = quarterStartMonth <= 10 ? quarterStartMonth + 2 : (quarterStartMonth + 2) % 12;
                const quarterStartTime = new Date(`${startDate.getUTCFullYear()}-${`0${quarterStartMonth}`.slice(-2)}-01T00:00:00Z`);
                const quarterEndTime = new Date(`${quarterEndYear}-${`0${quarterEndMonth}`.slice(-2)}-01T00:00:00Z`);
                const quarterStartMonthShortString = formatTimestamp(quarterStartTime.getTime(), {
                    month: 'short',
                    timeZone: 'UTC'
                });
                const quarterEndMonthShortString = formatTimestamp(quarterEndTime.getTime(), {
                    month: 'short',
                    timeZone: 'UTC'
                });
                const firstDay = formatTimestamp(startDate.getTime(), (0, (0, parcelRequire("gh61P")).shortDateFormat));
                const nextQuarterStartMonth = quarterStartMonth <= 9 ? quarterStartMonth + 3 : (quarterStartMonth + 3) % 12;
                const lastDay = formatTimestamp(new Date(`${quarterEndYear}-${`0${nextQuarterStartMonth}`.slice(-2)}-01T00:00:00Z`).getTime() - (0, (0, parcelRequire("flnZx")).ONE_DAY), (0, (0, parcelRequire("gh61P")).shortDateFormat));
                const tooltipContent = fiscalMonth !== 1 ? formatMessage((0, $2LOsh.default).financialYearQuarter, {
                    quarterNumber: quarterNumber,
                    firstDay: firstDay,
                    lastDay: lastDay,
                    financialYear: (0, $gz7eu.calculateFinancialYear)(startTime, fiscalMonth)
                }) : formatMessage((0, $2LOsh.default).calendarYearQuarter, {
                    quarterNumber: quarterNumber,
                    firstDay: firstDay,
                    lastDay: lastDay
                });
                const unit = (0, $4yFXA.getTimeUnitsBarBottomUnit)({
                    index: index,
                    label: formatMessage((0, $2LOsh.default).quarterDescriptorLong, {
                        quarterNumber: quarterNumber,
                        quarterStartMonthShortString: quarterStartMonthShortString,
                        quarterEndMonthShortString: quarterEndMonthShortString
                    }),
                    offset: width,
                    showRightBorder: false,
                    showLeftBorder: index !== 0,
                    width: widthPercentage,
                    tooltipContent: tooltipContent
                });
                width += widthPercentage;
                return unit;
            });
        } else {
            const yearUnits = (0, $jAIJh.getYearUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
            topBar = yearUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>(0, $4yFXA.getTimeUnitsBarTopUnit)({
                    index: index,
                    label: fiscalMonth !== 1 ? (0, $gz7eu.formatFY)((0, $gz7eu.calculateFinancialYear)(startTime, fiscalMonth)) : new Date(startTime).getUTCFullYear(),
                    offset: 0,
                    width: widthPercentage
                }));
            const quarterUnits = (0, $jAIJh.getQuarterUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
            let width = 0;
            bottomBar = quarterUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
                const startDate = new Date(startTime);
                const firstDay = formatTimestamp(startDate.getTime(), (0, (0, parcelRequire("gh61P")).shortDateFormat));
                const quarterNumber = (0, $82Qle.calculateQuarter)(startDate.getUTCMonth() + 1, fiscalMonth);
                let quarterStartMonth = fiscalMonth + (quarterNumber - 1) * 3;
                let quarterEndYear = startDate.getUTCFullYear();
                if (quarterStartMonth > 12) quarterStartMonth %= 12;
                if (quarterStartMonth > 10) quarterEndYear++;
                const nextQuarterStartMonth = quarterStartMonth <= 9 ? quarterStartMonth + 3 : (quarterStartMonth + 3) % 12;
                const lastDay = formatTimestamp(new Date(`${quarterEndYear}-${`0${nextQuarterStartMonth}`.slice(-2)}-01T00:00:00Z`).getTime() - (0, (0, parcelRequire("flnZx")).ONE_DAY), (0, (0, parcelRequire("gh61P")).shortDateFormat));
                const tooltipContent = fiscalMonth !== 1 ? formatMessage((0, $2LOsh.default).financialYearQuarter, {
                    quarterNumber: quarterNumber,
                    firstDay: firstDay,
                    lastDay: lastDay,
                    financialYear: (0, $gz7eu.calculateFinancialYear)(startTime, fiscalMonth)
                }) : formatMessage((0, $2LOsh.default).calendarYearQuarter, {
                    quarterNumber: quarterNumber,
                    firstDay: firstDay,
                    lastDay: lastDay
                });
                const unit = (0, $4yFXA.getTimeUnitsBarBottomUnit)({
                    index: index,
                    label: formatMessage((0, $2LOsh.default).quarterDescriptorShort, {
                        quarterNumber: quarterNumber
                    }),
                    offset: width,
                    showRightBorder: false,
                    showLeftBorder: index > 0 && quarterNumber === 1,
                    width: widthPercentage,
                    tooltipContent: tooltipContent
                });
                width += widthPercentage;
                return unit;
            });
        }
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $6OFOZ.timeUnitsBar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": `${(0, $4yFXA.testId)}.top`,
            className: $6OFOZ.timeUnitsBarTop
        }, topBar), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": `${(0, $4yFXA.testId)}.bottom`,
            className: $6OFOZ.timeUnitsBarBottom
        }, bottomBar)));
    }
});
parcelRegister("1No5o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf5b44aeb326d21a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bf5b44aeb326d21a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fields: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.fields",
            "defaultMessage": "Fields"
        },
        timeline: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.timeline",
            "defaultMessage": "Timeline"
        }
    });
});
parcelRegister("bw5AJ", function(module, exports) {
    $parcel$export(module.exports, "Arrows", ()=>$d81d1f2667a89e79$export$b6e350ab9915297a);
    var $bC2fB;
    var $beTXk = parcelRequire("beTXk");
    var $aZoQr = parcelRequire("aZoQr");
    const $d81d1f2667a89e79$export$b6e350ab9915297a = (0, (0, parcelRequire("bC2fB")).connect)((0, $beTXk.default), {})((0, $aZoQr.ArrowsContainer));
});
parcelRegister("beTXk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fcabb9be9c9b889a$export$2e2bcd8739ae039);
    var $6iNxz = parcelRequire("6iNxz");
    var $3YtPS = parcelRequire("3YtPS");
    var $fcabb9be9c9b889a$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        scope: (0, $6iNxz.getTableItems)
    });
});
parcelRegister("aZoQr", function(module, exports) {
    $parcel$export(module.exports, "ArrowsContainer", ()=>$b4b1463a62153916$export$597cb947ef69a2c9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $cGv9m;
    var $hE4fC;
    var $kjiiE = parcelRequire("kjiiE");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $2EwIC;
    var $8LV9S;
    var $iHAEW;
    const $b4b1463a62153916$export$597cb947ef69a2c9 = ({ scope: scope })=>{
        const [columnWidths] = (0, (0, parcelRequire("8LV9S")).useColumnWidths)({
            preview: true
        });
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const containerWidth = zoomLevel ? (0, (0, parcelRequire("cGv9m")).getContainerWidth)(zoomLevel) : columnWidths.at(-1) ?? 0;
        const virtualizedRows = (0, (0, parcelRequire("iHAEW")).useVirtualized)();
        const marginLeft = columnWidths.reduce((totalWidth, curWidth, index)=>index < columnWidths.length - 1 ? totalWidth + curWidth : totalWidth, 0);
        const width = viewport.width - marginLeft;
        const rowHeight = (index)=>(scope[index]?.height ?? 1) * (0, $TTKUQ.SCOPE_ROW_HEIGHT);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
            layer: (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS_ARROWS
        }, (zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: zoomLevel ? $b4b1463a62153916$var$containerStyles : $b4b1463a62153916$var$containerStylesFixed,
                style: {
                    zIndex: zIndex,
                    left: marginLeft
                },
                tabIndex: -1
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $b4b1463a62153916$var$layerAlignedStyles,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.overlay.arrows.arrows",
                style: {
                    width: width
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kjiiE.default), {
                containerWidth: containerWidth,
                scope: scope,
                rowHeight: rowHeight,
                verticalRenderingWindow: {
                    overscanStartIndex: 0,
                    overscanStopIndex: 999
                },
                virtualizedRows: virtualizedRows
            }))));
    };
    const $b4b1463a62153916$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky',
        left: 'space.0',
        right: 'space.0',
        pointerEvents: 'none',
        height: 'space.0'
    });
    const $b4b1463a62153916$var$containerStylesFixed = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        left: 'space.0',
        right: 'space.0',
        pointerEvents: 'none',
        height: 'space.0'
    });
    const $b4b1463a62153916$var$layerAlignedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky',
        height: '100%'
    });
});
parcelRegister("kjiiE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b93a59336358fbe$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5eLXY = parcelRequire("5eLXY");
    var $308HO = parcelRequire("308HO");
    var $g0dV0 = parcelRequire("g0dV0");
    var $1b93a59336358fbe$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $308HO.default), (0, $5eLXY.default))((0, $g0dV0.default));
});
parcelRegister("5eLXY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3575cf463efe1175$export$2e2bcd8739ae039);
    var $gh61P;
    var $j33D0 = parcelRequire("j33D0");
    const $3575cf463efe1175$var$mapDispatchToProps = (dispatch)=>({
            onTimeScaleOptionChange: (payload)=>dispatch({
                    type: (0, $j33D0.CHANGE_OPTION),
                    payload: payload
                }),
            onTimeScaleCustomDatesChange: (payload)=>dispatch({
                    type: (0, $j33D0.CHANGE_CUSTOM_DATES),
                    payload: {
                        ...payload,
                        typeOfCustomDateRange: (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).FIXED
                    }
                })
        });
    var $3575cf463efe1175$export$2e2bcd8739ae039 = $3575cf463efe1175$var$mapDispatchToProps;
});
parcelRegister("308HO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e51fe3403c65ea2$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $jAIJh = parcelRequire("jAIJh");
    var $3YtPS = parcelRequire("3YtPS");
    var $6e51fe3403c65ea2$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        mode: (0, $1CGdp.getMode),
        timelineRange: (0, $jAIJh.getTimelineRange)
    });
});
parcelRegister("g0dV0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51a621ff5ab79936$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $4R6GH;
    var $6iNxz = parcelRequire("6iNxz");
    var $fHJiO = parcelRequire("fHJiO");
    var $l38L3 = parcelRequire("l38L3");
    var $gITL8 = parcelRequire("gITL8");
    var $dCm1o;
    var $6bYns = parcelRequire("6bYns");
    var $e5MSG = parcelRequire("e5MSG");
    var $ipLzF = parcelRequire("ipLzF");
    const $51a621ff5ab79936$var$SCROLLBAR_WIDTH = 18;
    const $51a621ff5ab79936$var$ARROW_WIDTH = 24;
    const $51a621ff5ab79936$var$DEPENDENCY_MARKER_PADDING_OLD = 24;
    const $51a621ff5ab79936$var$DEPENDENCY_MARKER_PADDING = 32;
    const $51a621ff5ab79936$var$margin = {
        left: 0,
        right: $51a621ff5ab79936$var$SCROLLBAR_WIDTH
    };
    const $51a621ff5ab79936$var$getRowOffset = (index, rowHeight)=>{
        let result = (0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2') ? 90 : 0;
        for(let i = 0; i < index; i++)result += rowHeight(i);
        return result;
    };
    function $51a621ff5ab79936$export$2e2bcd8739ae039({ rowHeight: rowHeight, containerWidth: containerWidthFromProps, scope: scope, timelineRange: timelineRange, onTimeScaleCustomDatesChange: onTimeScaleCustomDatesChange, onTimeScaleOptionChange: onTimeScaleOptionChange, verticalRenderingWindow: verticalRenderingWindow, mode: mode, virtualizedRows: virtualizedRows }) {
        const containerWidth = (0, $ipLzF.useContainerWidth)(containerWidthFromProps);
        const viewportWidth = (0, $ipLzF.useViewportWidth)(containerWidth);
        const viewportTimelineRange = (0, $ipLzF.useViewportTimelineRange)(timelineRange);
        const isOptimized = mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771);
        const onArrowClick = (0, $ipLzF.useArrowClickHandler)({
            changeTimeScaleCustomDates: onTimeScaleCustomDatesChange,
            changeTimeScaleOption: onTimeScaleOptionChange,
            viewportWidth: viewportWidth,
            containerWidth: containerWidth,
            viewport: viewportTimelineRange
        });
        const msPerPx = (viewportTimelineRange.end - viewportTimelineRange.start) / viewportWidth;
        const start = viewportTimelineRange.start;
        const end = viewportTimelineRange.end - $51a621ff5ab79936$var$SCROLLBAR_WIDTH * msPerPx;
        const innerRange = {
            start: start,
            end: end
        };
        const isArrowOnTheBar = (direction, baselineStart, baselineEnd)=>{
            switch(direction){
                case 'left':
                    return baselineEnd != null && baselineEnd > innerRange.start + $51a621ff5ab79936$var$ARROW_WIDTH * msPerPx;
                case 'right':
                    return baselineStart != null && baselineStart < innerRange.end - $51a621ff5ab79936$var$ARROW_WIDTH * msPerPx;
                default:
                    return direction;
            }
        };
        const renderArrow = ({ offsetY: offsetY, color: color, baselineStart: baselineStart, baselineEnd: baselineEnd, issueKey: issueKey })=>(direction)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $e5MSG.default), {
                    direction: direction,
                    baselineStart: baselineStart,
                    baselineEnd: baselineEnd,
                    timelineRange: innerRange
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $6bYns.default), {
                    color: color,
                    issueKey: issueKey,
                    transparent: isArrowOnTheBar(direction, baselineStart, baselineEnd),
                    direction: direction,
                    width: $51a621ff5ab79936$var$ARROW_WIDTH,
                    offsetY: offsetY,
                    onClick: ()=>onArrowClick(direction, {
                            start: baselineStart,
                            end: baselineEnd
                        }, $51a621ff5ab79936$var$margin[direction] + ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? $51a621ff5ab79936$var$DEPENDENCY_MARKER_PADDING : $51a621ff5ab79936$var$DEPENDENCY_MARKER_PADDING_OLD)),
                    margin: $51a621ff5ab79936$var$margin
                }));
        const renderRow = (index, { offsetY: offsetY })=>{
            const issue = scope[index];
            if (issue == null) return null;
            switch(issue.tag){
                case 0, $6iNxz.TABLE_ISSUE:
                    {
                        const { baselineStart: baselineStart, baselineEnd: baselineEnd, issueKey: issueKey, optimized: optimized } = (0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline') ? (0, $fHJiO.swapIssueBaselineDatesIfInverted)(issue.value) : issue.value;
                        let hasOptimizedChanges = false;
                        if (isOptimized && optimized) {
                            for (const [optimizedKey, optimizedValue] of Object.entries(optimized))if ((0, $l38L3.hasValueChanged)((0, $l38L3.getCurrentValue)(issue.value, optimizedKey), optimizedValue)) {
                                hasOptimizedChanges = true;
                                break;
                            }
                        }
                        const minDate = baselineStart ?? baselineEnd;
                        const maxDate = baselineEnd ?? baselineStart;
                        const hasLeftArrow = minDate != null && minDate < innerRange.start;
                        const hasRightArrow = maxDate != null && maxDate > innerRange.end;
                        const arrow = renderArrow({
                            offsetY: offsetY,
                            color: hasOptimizedChanges ? (0, $gITL8.OPTIMIZED_COLOR) : undefined,
                            baselineStart: baselineStart,
                            baselineEnd: baselineEnd,
                            issueKey: issueKey
                        });
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                            key: index
                        }, hasLeftArrow && arrow('left'), hasRightArrow && arrow('right'));
                    }
                default:
                    return null;
            }
        };
        if (!Number.isFinite(verticalRenderingWindow.overscanStopIndex)) return null;
        const rows = [];
        if ((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2')) virtualizedRows?.forEach((rowIndex)=>{
            rows.push(renderRow(rowIndex, {
                offsetY: $51a621ff5ab79936$var$getRowOffset(rowIndex, rowHeight)
            }));
        });
        else for(let i = verticalRenderingWindow.overscanStartIndex; i <= verticalRenderingWindow.overscanStopIndex; i++)rows.push(renderRow(i, {
            offsetY: $51a621ff5ab79936$var$getRowOffset(i, rowHeight)
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, rows);
    }
});
parcelRegister("6bYns", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e95fe53470d1b68a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cwmS5;
    var $ctqwA;
    var $h1TKi;
    var $d2gYe;
    var $bh9nY;
    var $1gQ7U;
    var $dCm1o;
    var $28EDw = parcelRequire("28EDw");
    function $e95fe53470d1b68a$var$useLazyClickHandler(onClick) {
        const cachedClickHandlerRef = (0, $5uXOq.useRef)(onClick);
        (0, $5uXOq.useEffect)(()=>{
            cachedClickHandlerRef.current = onClick;
        }, [
            onClick
        ]);
        return (0, $5uXOq.useCallback)(()=>cachedClickHandlerRef.current(), []);
    }
    function $e95fe53470d1b68a$export$2e2bcd8739ae039({ direction: direction, transparent: transparent, color: color, issueKey: issueKey = 0, width: width, offsetY: offsetY, margin: margin, onClick: onClick }) {
        const iconColor = transparent === true ? 'transparent' : color;
        const handleClick = $e95fe53470d1b68a$var$useLazyClickHandler(onClick);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $28EDw.root,
            style: {
                width: width,
                top: offsetY,
                marginTop: "var(--ds-space-100, 8px)",
                left: direction === 'left' ? margin.left : undefined,
                right: direction === 'right' ? margin.right : undefined
            },
            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.arrows.${direction}.${issueKey}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e95fe53470d1b68a$var$Inner, {
            direction: direction,
            iconColor: iconColor,
            onClick: handleClick
        }));
    }
    const $e95fe53470d1b68a$var$Inner = (0, $5uXOq.memo)(({ direction: direction, iconColor: iconColor, onClick: onClick })=>{
        const ArrowIcon = direction === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("d2gYe"))))) : (0, ($parcel$interopDefault((0, parcelRequire("bh9nY")))));
        const iconTileAppearance = iconColor === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771) ? 'purple' : 'grayBold';
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && iconColor === 'transparent') return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gQ7U")).IconButton), {
            onClick: onClick
        }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            label: "",
            size: "24",
            icon: direction === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("ctqwA"))))) : (0, ($parcel$interopDefault((0, parcelRequire("h1TKi"))))),
            shape: "circle",
            appearance: iconTileAppearance
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ArrowIcon, {
            label: "",
            LEGACY_primaryColor: iconColor
        }));
    });
});
parcelRegister("28EDw", function(module, exports) {
    $parcel$export(module.exports, "root", ()=>$18ebd9b270432659$export$e8e78c978b129247, (v)=>$18ebd9b270432659$export$e8e78c978b129247 = v);
    var $18ebd9b270432659$export$e8e78c978b129247;
    $18ebd9b270432659$export$e8e78c978b129247 = `zWKwda_root`;
});
parcelRegister("e5MSG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5710009ced669eed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kKnKS;
    var $3bDjY;
    var $koVbs;
    var $1p96B;
    var $gh61P;
    var $aipk9;
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    var $DVljb;
    var $gN71h = parcelRequire("gN71h");
    function $5710009ced669eed$var$useTooltip({ direction: direction, baselineStart: baselineStart, baselineEnd: baselineEnd, timelineRange: timelineRange }) {
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const formatDate = (value)=>(0, (0, parcelRequire("aipk9")).formatTimestampWithIntl)(intl, value, (0, (0, parcelRequire("gh61P")).weekdayFormat));
        const localeOptions = {
            locale: (0, (0, parcelRequire("1p96B")).getLocale)(locale)
        };
        switch(direction){
            case 'left':
                if ((0, $4nDwW.isDefined)(baselineStart) && baselineStart < timelineRange.start && (0, $4nDwW.isDefined)(baselineEnd) && baselineEnd < timelineRange.start) return intl.formatMessage((0, $ihPUd.default).datesOutsideRange);
                if ((0, $4nDwW.isDefined)(baselineStart) && baselineStart < timelineRange.start) return intl.formatMessage((0, $gN71h.default).startDateAgo, {
                    date: formatDate(baselineStart),
                    dateDistance: (0, (0, parcelRequire("kKnKS")).default)(baselineStart, localeOptions)
                });
                if ((0, $4nDwW.isDefined)(baselineEnd) && baselineEnd < timelineRange.start) return intl.formatMessage((0, $gN71h.default).endDateAgo, {
                    date: formatDate(baselineEnd),
                    dateDistance: (0, (0, parcelRequire("kKnKS")).default)(baselineEnd, localeOptions)
                });
                return '';
            case 'right':
                if ((0, $4nDwW.isDefined)(baselineStart) && baselineStart > timelineRange.end && (0, $4nDwW.isDefined)(baselineEnd) && baselineEnd > timelineRange.end) return intl.formatMessage((0, $ihPUd.default).datesOutsideRange);
                if ((0, $4nDwW.isDefined)(baselineStart) && baselineStart > timelineRange.end) return intl.formatMessage((0, $gN71h.default).startDateFromNow, {
                    date: formatDate(baselineStart),
                    dateDistance: (0, (0, parcelRequire("kKnKS")).default)(baselineStart, localeOptions)
                });
                if ((0, $4nDwW.isDefined)(baselineEnd) && baselineEnd > timelineRange.end) return intl.formatMessage((0, $gN71h.default).endDateFromNow, {
                    date: formatDate(baselineEnd),
                    dateDistance: (0, (0, parcelRequire("kKnKS")).default)(baselineEnd, localeOptions)
                });
                return '';
            default:
                return direction;
        }
    }
    function $5710009ced669eed$export$2e2bcd8739ae039(props) {
        const { direction: direction, children: children } = props;
        const tooltip = $5710009ced669eed$var$useTooltip(props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltip,
            position: direction
        }, children);
    }
});
parcelRegister("gN71h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$36b1f3c2d505d8d2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $36b1f3c2d505d8d2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        startDateAgo: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.arrows.tooltip.start-date-ago",
            "defaultMessage": "Start: {date} ({dateDistance} ago)"
        },
        endDateAgo: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.arrows.tooltip.end-date-ago",
            "defaultMessage": "End: {date} ({dateDistance} ago)"
        },
        startDateFromNow: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.arrows.tooltip.start-date-from-now",
            "defaultMessage": "Start: {date} ({dateDistance} from now)"
        },
        endDateFromNow: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.arrows.tooltip.end-date-from-now",
            "defaultMessage": "End: {date} ({dateDistance} from now)"
        }
    });
});
parcelRegister("ipLzF", function(module, exports) {
    $parcel$export(module.exports, "useViewportTimelineRange", ()=>$9e3c1760df36a542$export$bdcb02269305b088);
    $parcel$export(module.exports, "useViewportWidth", ()=>$9e3c1760df36a542$export$3ce37a513c68c53);
    $parcel$export(module.exports, "useContainerWidth", ()=>$9e3c1760df36a542$export$7ed924c3d8496d63);
    $parcel$export(module.exports, "useArrowClickHandler", ()=>$9e3c1760df36a542$export$37ceb294125f662e);
    var $flnZx;
    var $hE4fC;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $9e3c1760df36a542$var$getDestinationForLeftArrow = ({ issue: issue, viewport: viewport, viewportWidth: viewportWidth, containerWidth: containerWidth, paddingSize: paddingSize, shouldTimelineRangeExpand: shouldTimelineRangeExpand = false })=>{
        const { start: issueStart, end: issueEnd } = issue;
        const { start: viewportStart, end: viewportEnd } = viewport;
        const msPerPx = (()=>{
            if (shouldTimelineRangeExpand) {
                if ((0, $4nDwW.isDefined)(issueStart)) return (viewportEnd - issueStart) / (viewportWidth - paddingSize);
                if ((0, $4nDwW.isDefined)(issueEnd)) {
                    const issueBarWidth = containerWidth * 0.3;
                    return (viewportEnd - issueEnd) / (viewportWidth - paddingSize - issueBarWidth);
                }
                return viewport.start;
            }
            return (viewportEnd - viewportStart) / viewportWidth;
        })();
        const paddingSizeInMs = paddingSize * msPerPx;
        if ((0, $4nDwW.isDefined)(issueStart)) return issueStart - paddingSizeInMs;
        if ((0, $4nDwW.isDefined)(issueEnd)) {
            const issueBarWidth = containerWidth * 0.3;
            const issueBarWidthInMs = issueBarWidth * msPerPx;
            return issueEnd - issueBarWidthInMs - paddingSizeInMs;
        }
        return viewport.start;
    };
    const $9e3c1760df36a542$var$getDestinationForRightArrow = ({ issue: issue, viewport: viewport, viewportWidth: viewportWidth, containerWidth: containerWidth, paddingSize: paddingSize, shouldTimelineRangeExpand: shouldTimelineRangeExpand = false })=>0 - $9e3c1760df36a542$var$getDestinationForLeftArrow({
            issue: {
                start: issue.end == null ? issue.end : -issue.end,
                end: issue.start == null ? issue.start : -issue.start
            },
            viewport: {
                start: -viewport.end,
                end: -viewport.start
            },
            viewportWidth: viewportWidth,
            containerWidth: containerWidth,
            paddingSize: paddingSize,
            shouldTimelineRangeExpand: shouldTimelineRangeExpand
        });
    const $9e3c1760df36a542$var$getDestination = (direction)=>{
        switch(direction){
            case 'left':
                return $9e3c1760df36a542$var$getDestinationForLeftArrow;
            case 'right':
                return $9e3c1760df36a542$var$getDestinationForRightArrow;
            default:
                return direction;
        }
    };
    function $9e3c1760df36a542$export$bdcb02269305b088(fallback) {
        const [{ zoomLevel: zoomLevel, viewport: viewport, today: today }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [{ pxToMs: pxToMs }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        return zoomLevel ? {
            start: today + viewport.offset,
            end: today + viewport.offset + pxToMs(viewport.width)
        } : fallback;
    }
    function $9e3c1760df36a542$export$3ce37a513c68c53(fallback) {
        const [{ zoomLevel: zoomLevel, viewport: viewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        if (zoomLevel === undefined) return fallback;
        return viewport.width;
    }
    function $9e3c1760df36a542$export$7ed924c3d8496d63(fallback) {
        const [{ zoomLevel: zoomLevel, container: container }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        if (zoomLevel === undefined) return fallback;
        return container.width;
    }
    function $9e3c1760df36a542$export$37ceb294125f662e({ changeTimeScaleCustomDates: changeTimeScaleCustomDates, changeTimeScaleOption: changeTimeScaleOption, viewportWidth: viewportWidth, containerWidth: containerWidth, viewport: viewport }) {
        const [{ zoomLevel: zoomLevel }, { setViewportOffset: setViewportOffset }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const isHorizontalScrollable = zoomLevel !== undefined;
        return (direction, issue, paddingSize)=>{
            const destination = $9e3c1760df36a542$var$getDestination(direction)({
                issue: issue,
                viewport: viewport,
                viewportWidth: viewportWidth,
                containerWidth: containerWidth,
                paddingSize: paddingSize,
                shouldTimelineRangeExpand: !isHorizontalScrollable
            });
            if (!isHorizontalScrollable) {
                changeTimeScaleOption((0, $TTKUQ.TIMELINE_MODES).CUSTOM);
                switch(direction){
                    case 'left':
                        changeTimeScaleCustomDates({
                            fromDate: (0, (0, parcelRequire("flnZx")).startOfUtcDay)(destination),
                            toDate: viewport.end
                        });
                        break;
                    case 'right':
                        changeTimeScaleCustomDates({
                            fromDate: viewport.start,
                            toDate: (0, (0, parcelRequire("flnZx")).endOfUtcDay)(destination) + 1
                        });
                        break;
                    default:
                        return direction;
                }
            } else switch(direction){
                case 'left':
                    return setViewportOffset((offset)=>offset + destination - viewport.start, 'arrow');
                case 'right':
                    return setViewportOffset((offset)=>offset + destination - viewport.end, 'arrow');
                default:
                    return direction;
            }
        };
    }
});
parcelRegister("aXxWj", function(module, exports) {
    $parcel$export(module.exports, "AxisFirstTimeUnit", ()=>$6b354ef0b05eb1c2$export$a0258718b3ce7062);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $hE4fC;
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $8LV9S;
    const $6b354ef0b05eb1c2$export$a0258718b3ce7062 = ()=>{
        const [columnWidths] = (0, (0, parcelRequire("8LV9S")).useColumnWidths)({
            preview: true
        });
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const marginLeft = columnWidths.reduce((totalWidth, curWidth, index)=>index < columnWidths.length - 1 ? totalWidth + curWidth : totalWidth, 0);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
            layer: (0, $6hYE8.Z_INDEX_LAYER).AXIS_STICKY_TIME_UNIT
        }, (zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: zoomLevel ? $6b354ef0b05eb1c2$var$containerStyles : $6b354ef0b05eb1c2$var$containerStylesFixed,
                style: {
                    zIndex: zIndex,
                    left: marginLeft
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $6b354ef0b05eb1c2$var$layerAlignedStyles,
                id: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.overlay.axis-first-time-unit.sticky-date"
            })));
    };
    const $6b354ef0b05eb1c2$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky',
        top: 'space.0',
        pointerEvents: 'none',
        height: 'space.0'
    });
    const $6b354ef0b05eb1c2$var$containerStylesFixed = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        left: 'space.0',
        top: 'space.0',
        pointerEvents: 'none',
        height: 'space.0'
    });
    const $6b354ef0b05eb1c2$var$layerAlignedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        height: '100%'
    });
});
parcelRegister("d89F6", function(module, exports) {
    $parcel$export(module.exports, "Blanket", ()=>$db3e834f0d8e9cba$export$5b927fc1ef8c468b);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $hE4fC;
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $2EwIC;
    const $db3e834f0d8e9cba$export$5b927fc1ef8c468b = ()=>{
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [{ isScrollingWithScrollBar: isScrollingWithScrollBar, zoomLevel: zoomLevel }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        if (!zoomLevel || !isScrollingWithScrollBar) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
            layer: (0, $6hYE8.Z_INDEX_LAYER).HORIZONTAL_SCROLL_BAR
        }, (zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $db3e834f0d8e9cba$var$wrapperStickyStyles,
                style: {
                    zIndex: zIndex
                },
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.overlay.blanket"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $db3e834f0d8e9cba$var$wrapperAbsoluteStyles,
                style: {
                    width: viewport.width,
                    height: viewport.height
                }
            })));
    };
    const $db3e834f0d8e9cba$var$wrapperStickyStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky',
        top: 'space.0',
        left: 'space.0'
    });
    const $db3e834f0d8e9cba$var$wrapperAbsoluteStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute'
    });
});
parcelRegister("7qOOt", function(module, exports) {
    $parcel$export(module.exports, "ColumnText", ()=>$82fd4d13c1432894$export$908db227afc60a53);
    $parcel$export(module.exports, "TimelineColumnText", ()=>$82fd4d13c1432894$export$390d847aede44ba4);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $aI0i7;
    var $2EwIC;
    var $8LV9S;
    var $3gMD8 = parcelRequire("3gMD8");
    const $82fd4d13c1432894$var$COLUMN_BORDER_WIDTH = 1;
    const $82fd4d13c1432894$export$908db227afc60a53 = ({ title: title, column: column, icon: icon, useColumnToggle: useColumnToggle, appearance: appearance = 'field', hasStripe: hasStripe })=>{
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [columnWidth = 0] = (0, (0, parcelRequire("8LV9S")).useColumnWidth)({
            column: column,
            preview: true
        });
        const [hovered, setHovered] = (0, $5uXOq.useState)(false);
        const [focused, setFocused] = (0, $5uXOq.useState)(false);
        const handleHoverIn = (0, $5uXOq.useCallback)(()=>setHovered(true), []);
        const handleHoverOut = (0, $5uXOq.useCallback)(()=>setHovered(false), []);
        const handleFocus = (0, $5uXOq.useCallback)(()=>setFocused(true), []);
        const handleBlur = (0, $5uXOq.useCallback)(()=>setFocused(false), []);
        const toggle = useColumnToggle();
        const expand = (0, $5uXOq.useCallback)(()=>toggle(true), [
            toggle
        ]);
        const [top, containerWidth, textHeight, paddingTop] = (()=>{
            switch(appearance){
                case 'section':
                    return [
                        0,
                        (0, $f3f8e80f7954f218$export$2f0383777c41eca4),
                        (0, $f3f8e80f7954f218$export$2f0383777c41eca4),
                        0
                    ];
                case 'field':
                default:
                    return [
                        '100%',
                        columnWidth,
                        (0, $f3f8e80f7954f218$export$1c6fd712f054cbca),
                        90
                    ];
            }
        })();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            role: "button",
            xcss: $82fd4d13c1432894$var$wrapperStyles,
            onMouseMove: handleHoverIn,
            onMouseLeave: handleHoverOut,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onClick: expand,
            tabIndex: 0,
            style: {
                top: top,
                height: containerWidth - $82fd4d13c1432894$var$COLUMN_BORDER_WIDTH,
                width: viewport.height - paddingTop,
                transform: `rotate(90deg) translateX(${-(containerWidth - $82fd4d13c1432894$var$COLUMN_BORDER_WIDTH)}px)`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $82fd4d13c1432894$var$blanketStyles,
            style: {
                height: textHeight - $82fd4d13c1432894$var$COLUMN_BORDER_WIDTH
            }
        }), hasStripe && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3gMD8.Stripe), {
            top: paddingTop
        }), (hovered || focused) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $82fd4d13c1432894$var$hoveredStyles
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $82fd4d13c1432894$var$innerStyles,
            style: {
                height: textHeight - $82fd4d13c1432894$var$COLUMN_BORDER_WIDTH
            }
        }, title, icon));
    };
    const $82fd4d13c1432894$export$390d847aede44ba4 = (props)=>{
        const [{ column: column }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const [leftColumnOffset = 0] = (0, (0, parcelRequire("8LV9S")).useColumnStickyOffset)({
            column: column - 1,
            preview: true
        });
        const [leftColumnWidth = 0] = (0, (0, parcelRequire("8LV9S")).useColumnWidth)({
            column: column - 1,
            preview: true
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $82fd4d13c1432894$var$timelineWrapperStyles,
            style: {
                left: leftColumnOffset + leftColumnWidth
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($82fd4d13c1432894$export$908db227afc60a53, props));
    };
    const $82fd4d13c1432894$var$timelineWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky',
        width: '32px'
    });
    const $82fd4d13c1432894$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        overflow: 'hidden',
        transformOrigin: 'bottom left',
        cursor: 'pointer',
        outline: 'none',
        backgroundColor: 'elevation.surface'
    });
    const $82fd4d13c1432894$var$hoveredStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    });
    const $82fd4d13c1432894$var$blanketStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        left: 'space.200',
        right: 'space.0',
        bottom: 'space.0',
        display: 'flex',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        backgroundColor: 'elevation.surface'
    });
    const $82fd4d13c1432894$var$innerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        left: 'space.200',
        right: 'space.0',
        bottom: 'space.0',
        display: 'flex',
        alignItems: 'center',
        textTransform: 'uppercase',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: 'bold',
        color: 'color.text.subtle',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
});
parcelRegister("3gMD8", function(module, exports) {
    $parcel$export(module.exports, "Stripe", ()=>$d3f2ba2db5f1acf6$export$3c7919ca4c48cda4);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $aI0i7;
    var $8LV9S;
    const $d3f2ba2db5f1acf6$export$3c7919ca4c48cda4 = ({ top: top })=>{
        const [{ column: column }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const [leftColumnOffset = 0] = (0, (0, parcelRequire("8LV9S")).useColumnStickyOffset)({
            column: column - 1,
            preview: true
        });
        const [leftColumnWidth = 0] = (0, (0, parcelRequire("8LV9S")).useColumnWidth)({
            column: column - 1,
            preview: true
        });
        const backgroundOffset = -(leftColumnOffset + leftColumnWidth + top) % 40;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d3f2ba2db5f1acf6$var$containerStyles,
            style: {
                left: `${backgroundOffset}px`,
                backgroundImage: `repeating-linear-gradient(
    45deg,
    transparent,
    ${"var(--ds-background-neutral, rgba(101, 84, 192, 0.1))"} 1px,
    ${"var(--ds-background-neutral, rgba(101, 84, 192, 0.1))"} 16px,
    transparent 17px,
    transparent 28px
)`
            }
        });
    };
    const $d3f2ba2db5f1acf6$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        backgroundColor: 'elevation.surface'
    });
});
parcelRegister("jNsaP", function(module, exports) {
    $parcel$export(module.exports, "DependencyDragPreview", ()=>$11bed4f83bb6ccf2$export$a6e5fbf11d922b16);
    var $5uXOq = parcelRequire("5uXOq");
    var $9lMrf;
    var $hjhoK = parcelRequire("hjhoK");
    var $fmZmH = parcelRequire("fmZmH");
    var $dC5iT;
    var $8CUq3;
    var $gJZ5D;
    var $8vyMo;
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $2EwIC;
    var $8LV9S;
    var $jxhnO = parcelRequire("jxhnO");
    const $11bed4f83bb6ccf2$var$SCROLL_PADDING = 2e6;
    const $11bed4f83bb6ccf2$export$a6e5fbf11d922b16 = ()=>{
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [scrollX] = (0, (0, parcelRequire("2EwIC")).useScrollX)();
        const [scrollY] = (0, (0, parcelRequire("2EwIC")).useScrollY)();
        const [columnWidths] = (0, (0, parcelRequire("8LV9S")).useColumnWidths)({
            preview: false
        });
        const [active, drag] = (0, $5uXOq.useState)();
        const [anchor, setAnchor] = (0, $5uXOq.useState)();
        const [mouseOffset, setMouseOffset] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>(0, (0, parcelRequire("8vyMo")).monitorForDependencyCreate)({
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $hjhoK.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $fmZmH.preventUnhandled).start();
                },
                onDragStart: ({ source: source })=>{
                    try {
                        const { row: row, position: position } = source.data;
                        if (typeof row !== 'number') throw new TypeError();
                        if (position !== 'start' && position !== 'end') throw new TypeError('position is not "start" or "end"');
                        drag({
                            row: row,
                            position: position
                        });
                    } catch  {}
                },
                onDrop: ()=>{
                    drag(undefined);
                    setMouseOffset(undefined);
                    setAnchor(undefined);
                },
                onDrag: ({ location: location, source: source })=>{
                    try {
                        const { horizontalScrollingContainerX: horizontalScrollingContainerX, row: row } = source.data;
                        if (typeof horizontalScrollingContainerX !== 'number' || typeof row !== 'number') throw new TypeError();
                        const horizontalScrollingContainerY = row * 40 + 10 + 20;
                        setAnchor({
                            horizontalScrollingContainerX: horizontalScrollingContainerX,
                            horizontalScrollingContainerY: horizontalScrollingContainerY
                        });
                    } catch  {}
                    setMouseOffset({
                        pageX: location.current.input.pageX,
                        pageY: location.current.input.pageY
                    });
                }
            }), [
            drag,
            viewport.left,
            viewport.top
        ]);
        const marginLeft = columnWidths.reduce((totalWidth, curWidth, index)=>index < columnWidths.length - 1 ? totalWidth + curWidth : totalWidth, 0);
        const target = active && mouseOffset && {
            horizontalScrollingContainerY: mouseOffset.pageY - viewport.top + scrollY,
            horizontalScrollingContainerX: mouseOffset.pageX - viewport.left - marginLeft + scrollX - $11bed4f83bb6ccf2$var$SCROLL_PADDING
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
            layer: (0, $6hYE8.Z_INDEX_LAYER).DEPENDENCY_LINE_DRAG_PREVIEW
        }, (zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $11bed4f83bb6ccf2$var$containerStyles,
                style: {
                    zIndex: zIndex
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                offset: $11bed4f83bb6ccf2$var$SCROLL_PADDING
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $11bed4f83bb6ccf2$var$layerAlignedStyles,
                style: {
                    marginLeft: marginLeft
                }
            }, anchor && target && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $11bed4f83bb6ccf2$var$markerStyles,
                style: {
                    top: (target.horizontalScrollingContainerY ?? 0) - 8,
                    left: (target.horizontalScrollingContainerX ?? 0) - 8,
                    backgroundColor: `var(--ds-border-bold, ${(0, (0, parcelRequire("gJZ5D")).default).N100})`
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: "",
                size: "small"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.overlay.dependency-drag-preview.svg",
                width: 80,
                height: 80,
                style: {
                    overflow: 'visible'
                }
            }, anchor && target && (0, ($parcel$interopDefault($5uXOq))).createElement("line", {
                x1: anchor.horizontalScrollingContainerX,
                y1: anchor.horizontalScrollingContainerY,
                x2: target.horizontalScrollingContainerX,
                y2: target.horizontalScrollingContainerY,
                stroke: `var(--ds-border-bold, ${(0, (0, parcelRequire("gJZ5D")).default).N100})`,
                strokeWidth: "2px",
                strokeLinecap: "round"
            }))))));
    };
    const $11bed4f83bb6ccf2$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        pointerEvents: 'none'
    });
    const $11bed4f83bb6ccf2$var$layerAlignedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative'
    });
    const $11bed4f83bb6ccf2$var$markerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        display: 'flex',
        width: 'size.100',
        height: 'size.100',
        borderRadius: 'border.radius.circle',
        color: 'color.text.inverse'
    });
});
parcelRegister("9yZvX", function(module, exports) {
    $parcel$export(module.exports, "DependencyLineDetail", ()=>$688dcc8a13239b0f$export$ad186fc2ddf9077);
    var $bC2fB;
    var $aBgaQ = parcelRequire("aBgaQ");
    var $l4oCU = parcelRequire("l4oCU");
    const $688dcc8a13239b0f$export$ad186fc2ddf9077 = (0, (0, parcelRequire("bC2fB")).connect)((0, $aBgaQ.default), {})((0, $l4oCU.DependencyLineDetail));
});
parcelRegister("aBgaQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e105ef759794ff8$export$2e2bcd8739ae039);
    var $6iNxz = parcelRequire("6iNxz");
    var $3YtPS = parcelRequire("3YtPS");
    var $9e105ef759794ff8$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        scope: (0, $6iNxz.getTableItems)
    });
});
parcelRegister("l4oCU", function(module, exports) {
    $parcel$export(module.exports, "DependencyLineDetail", ()=>$8810f1af357740e3$export$ad186fc2ddf9077);
    var $5uXOq = parcelRequire("5uXOq");
    var $1zlQp;
    var $2b4ct = parcelRequire("2b4ct");
    var $2EwIC;
    const $8810f1af357740e3$export$ad186fc2ddf9077 = ({ scope: scope })=>{
        const [activeLine, { setActiveLine: setActiveLine }] = (0, (0, parcelRequire("1zlQp")).useActiveLine)();
        const [scrollX] = (0, (0, parcelRequire("2EwIC")).useScrollX)();
        const [scrollY] = (0, (0, parcelRequire("2EwIC")).useScrollY)();
        const shouldReset = (0, $5uXOq.useRef)(false);
        shouldReset.current = activeLine !== null;
        (0, $5uXOq.useEffect)(()=>{
            if (shouldReset.current) setActiveLine(null);
        }, [
            setActiveLine,
            scrollX,
            scrollY
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2b4ct.default), {
            scope: scope
        });
    };
});
parcelRegister("2b4ct", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b5cd8421248adba$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5xUHz = parcelRequire("5xUHz");
    var $2MaLN = parcelRequire("2MaLN");
    var $7Qbum = parcelRequire("7Qbum");
    var $0b5cd8421248adba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $2MaLN.default), (0, $5xUHz.default))((0, $7Qbum.default));
});
parcelRegister("5xUHz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb61d4d0410a4e3a$export$2e2bcd8739ae039);
    var $eS9xr = parcelRequire("eS9xr");
    const $fb61d4d0410a4e3a$var$mapDispatchToProps = (dispatch)=>({
            removeDependency: (payload)=>{
                dispatch((0, $eS9xr.deleteIssueLink)(payload));
            }
        });
    var $fb61d4d0410a4e3a$export$2e2bcd8739ae039 = $fb61d4d0410a4e3a$var$mapDispatchToProps;
});
parcelRegister("2MaLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4ff681263b043b7$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $7ppNi = parcelRequire("7ppNi");
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    var $d4ff681263b043b7$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        isEditMode: $1CGdp.isEditMode,
        issueStatusById: (0, $7ppNi.getIssueStatusById),
        syncStartEnabled: (0, $bHTqr.getSyncStartEnabled)
    });
});
parcelRegister("7Qbum", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b27bdbd2f31aa983$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1zlQp;
    var $6FMrA;
    var $aDKIU = parcelRequire("aDKIU");
    var $6iNxz = parcelRequire("6iNxz");
    var $TTKUQ = parcelRequire("TTKUQ");
    function $b27bdbd2f31aa983$export$2e2bcd8739ae039({ isEditMode: isEditMode, issueStatusById: issueStatusById, removeDependency: removeDependency, scope: scope, syncStartEnabled: syncStartEnabled }) {
        const [dependencySettings] = (0, (0, parcelRequire("1zlQp")).useDependencySettings)();
        const areIssuesOverlapping = (0, $5uXOq.useCallback)((fromItemScopeIndex, toItemScopeIndex)=>{
            const fromItem = scope[fromItemScopeIndex];
            if (!fromItem || fromItem.tag !== (0, $6iNxz.TABLE_ISSUE)) return false;
            const toItem = scope[toItemScopeIndex];
            if (!toItem || toItem.tag !== (0, $6iNxz.TABLE_ISSUE)) return false;
            return (0, $aDKIU.getIssueLinkIfOverlapping)(fromItem.value, toItem.value, issueStatusById, syncStartEnabled);
        }, [
            issueStatusById,
            scope,
            syncStartEnabled
        ]);
        return dependencySettings.display === (0, $TTKUQ.DEPENDENCY_SETTINGS).LINES ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6FMrA")).DependencyLineDetail), {
            onUnlink: removeDependency,
            canDelete: isEditMode,
            isOverlapping: areIssuesOverlapping
        }) : null;
    }
});
parcelRegister("6FMrA", function(module, exports) {
    $parcel$export(module.exports, "DependencyLinesOverlay", ()=>$b5d6d728915f2fc3$export$3caea3cf449c8260);
    $parcel$export(module.exports, "DependencyLineDetail", ()=>$b5d6d728915f2fc3$export$ad186fc2ddf9077);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $c32Ax;
    var $g1SUQ;
    var $1zlQp;
    function $b5d6d728915f2fc3$export$3caea3cf449c8260({ getDrawableLine: getDrawableLine }) {
        const [dependencyLines] = (0, (0, parcelRequire("1zlQp")).useDependencyLines)();
        const [activeLine, { setActiveLine: setActiveLine }] = (0, (0, parcelRequire("1zlQp")).useActiveLine)();
        const drawableLines = getDrawableLine && (0, ($parcel$interopDefault($3JOCw)))(dependencyLines.map(getDrawableLine).filter(Boolean), (d)=>d && [
                d.from.id,
                d.to.id,
                d.from.y,
                d.to.y
            ].join());
        const onDependencyClick = (event, params)=>{
            const clickedLine = {
                fromId: params.fromId,
                fromIndexOnScope: params.fromIndexOnScope,
                toId: params.toId,
                toIndexOnScope: params.toIndexOnScope,
                x: event.clientX,
                y: event.clientY
            };
            setActiveLine(clickedLine);
        };
        const selectedDependency = activeLine ? {
            fromId: activeLine.fromId,
            toId: activeLine.toId,
            fromIndex: activeLine.fromIndexOnScope,
            toIndex: activeLine.toIndexOnScope
        } : undefined;
        return drawableLines?.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c32Ax")).default), {
            dependencies: drawableLines,
            onDependencyClick: onDependencyClick,
            selectedDependency: selectedDependency
        }) : null;
    }
    function $b5d6d728915f2fc3$export$ad186fc2ddf9077({ onUnlink: onUnlink, canDelete: canDelete, isOverlapping: isOverlapping }) {
        const [linksDetails] = (0, (0, parcelRequire("1zlQp")).useDependencyLines)();
        const [activeLine, { setActiveLine: setActiveLine }] = (0, (0, parcelRequire("1zlQp")).useActiveLine)();
        if (!activeLine || linksDetails.length === 0) return null;
        const { x: x, y: y, fromId: fromId, fromIndexOnScope: fromIndexOnScope, toId: toId, toIndexOnScope: toIndexOnScope } = activeLine;
        const currentLineLinks = linksDetails.filter((item)=>item.fromIssue.id === fromId && item.toIssue.id === toId && item.fromIssue.indexOnScope === fromIndexOnScope && item.toIssue.indexOnScope === toIndexOnScope);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g1SUQ")).default), {
            position: {
                left: x,
                top: y
            },
            links: currentLineLinks,
            canDelete: canDelete,
            onUnlink: onUnlink,
            isOverlapping: isOverlapping,
            onClose: ()=>setActiveLine(null)
        });
    }
});
parcelRegister("c32Ax", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abcd90738f5b2cb5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $9cikT;
    const $abcd90738f5b2cb5$var$SvgOverlay = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
        const selectedDependencyLine = selectedDependency && dependencies.find((dependency)=>dependency.from.id === selectedDependency.fromId && dependency.to.id === selectedDependency.toId && dependency.from.indexOnScope === selectedDependency.fromIndex && dependency.to.indexOnScope === selectedDependency.toIndex);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement($abcd90738f5b2cb5$var$SvgContainer, {
            className: (0, $0afb8a62e53619f1$export$1e54f8b472a07d8d)
        }, dependencies.map((dependency)=>{
            if (dependency !== selectedDependencyLine) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cikT")).default), {
                key: `${dependency.from.id}-${dependency.to.id}-${dependency.from.y}-${dependency.to.y}`,
                ...dependency,
                onClick: onDependencyClick,
                isSelected: false
            });
            return null;
        }), selectedDependencyLine && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cikT")).default), {
            ...selectedDependencyLine,
            onClick: onDependencyClick,
            isSelected: true
        })));
    };
    $abcd90738f5b2cb5$var$SvgOverlay.defaultProps = {
        selectedDependency: undefined,
        onDependencyClick: (0, ($parcel$interopDefault($8Rkzz))),
        dependencies: []
    };
    var $abcd90738f5b2cb5$export$2e2bcd8739ae039 = $abcd90738f5b2cb5$var$SvgOverlay;
    const $abcd90738f5b2cb5$var$SvgContainer = (0, $47bDC.default).svg.withConfig({
        componentId: "sc-7b34v9-0"
    })({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        transition: 'opacity 0.2s ease-in-out',
        overflow: 'visible',
        pointerEvents: 'none'
    });
});
const $0afb8a62e53619f1$export$1e54f8b472a07d8d = 'dependencies-overlay';
const $0afb8a62e53619f1$export$cd944e09ecad5145 = 'dependency-line';
parcelRegister("9cikT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7dcd03412ef5592d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ajpes = parcelRequire("ajpes");
    var $eTXmK;
    var $3bDjY;
    var $koVbs;
    var $iHPnC;
    var $8zOmE;
    var $2NMNM;
    var $eGwbr;
    var $6k94P;
    const $7dcd03412ef5592d$var$DependencyLine = ({ from: from, to: to, itemHeight: itemHeight, isOverlapping: isOverlapping, isSelected: isSelected, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const onPathClick = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("eTXmK")).default)('timeline-dependency-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'line'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dependencyLine', {
                isOverlapping: isOverlapping
            });
            onClick(event, {
                fromId: from.id,
                toId: to.id,
                isOverlapping: isOverlapping,
                fromIndexOnScope: from.indexOnScope,
                toIndexOnScope: to.indexOnScope
            });
        }, [
            createAnalyticsEvent,
            isOverlapping,
            from,
            to,
            onClick
        ]);
        const onPathMouseEnter = (0, $5uXOq.useCallback)(()=>{
            setIsHovered(true);
        }, []);
        const onPathMouseLeave = (0, $5uXOq.useCallback)(()=>{
            setIsHovered(false);
        }, []);
        const path = (0, (0, parcelRequire("6k94P")).getPath)(from, to, itemHeight);
        const gradientId = `linear-gradient-${from.id}-${to.id}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (isHovered || isSelected) && (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: gradientId,
            x1: from.x,
            x2: to.x,
            y1: from.y,
            y2: to.y,
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0%",
            stopColor: (0, (0, parcelRequire("iHPnC")).getValueFromColor)(from.color)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "100%",
            stopColor: (0, (0, parcelRequire("iHPnC")).getValueFromColor)(to.color)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: path,
            fill: "transparent",
            strokeWidth: "2",
            stroke: $7dcd03412ef5592d$export$a73db48ef11a2bc3({
                isOverlapping: isOverlapping,
                isSelected: isSelected,
                isHovered: isHovered,
                gradientId: gradientId
            }),
            pointerEvents: "none",
            "data-testid": "aais-dependency-lines-overlay.common.ui.line.dependency-line"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "mouse",
            mousePosition: "top",
            content: formatMessage((0, (0, parcelRequire("eGwbr")).default).viewDetail),
            tag: "g"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7dcd03412ef5592d$var$InteractivePath, {
            className: (0, $0afb8a62e53619f1$export$cd944e09ecad5145),
            d: path,
            stroke: "transparent",
            strokeWidth: "9",
            fill: "none",
            cursor: "pointer",
            onClick: onPathClick,
            onMouseEnter: onPathMouseEnter,
            onMouseLeave: onPathMouseLeave,
            "data-testid": "aais-dependency-lines-overlay.common.ui.line.interactive-path"
        })));
    };
    $7dcd03412ef5592d$var$DependencyLine.whyDidYouRender = true;
    var $7dcd03412ef5592d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($7dcd03412ef5592d$var$DependencyLine, (0, ($parcel$interopDefault($ajpes))));
    const $7dcd03412ef5592d$var$InteractivePath = (0, $5uXOq.forwardRef)(({ as: C = "path", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_lcxv1yxs",
                __cmplp.className
            ])
        });
    });
    const $7dcd03412ef5592d$export$a73db48ef11a2bc3 = ({ isOverlapping: isOverlapping, isSelected: isSelected, isHovered: isHovered, gradientId: gradientId })=>{
        const isHighlighted = isSelected || isHovered;
        if (isOverlapping) {
            if (isHighlighted) return `var(--ds-background-danger-bold-hovered, ${(0, $829f609a65d26a98$exports).R500})`;
            return `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$exports).R300})`;
        }
        if (isHighlighted) return `url(#${gradientId})`;
        return `var(--ds-border-bold, ${(0, $829f609a65d26a98$exports).N50})`;
    };
});
parcelRegister("eGwbr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$188f0fa73c4b9066$export$2e2bcd8739ae039);
    var $7VHMR;
    var $188f0fa73c4b9066$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewDetail: {
            "id": "aais-dependency-lines-overlay.common.line.view-detail",
            "defaultMessage": "View dependency detail"
        }
    });
});
parcelRegister("6k94P", function(module, exports) {
    $parcel$export(module.exports, "getPath", ()=>$eb5c0917a150e0bd$export$2aa3fd96c49a84a8);
    var $8QpSo;
    const $eb5c0917a150e0bd$var$calculateMidPoint = (from, to)=>({
            x: (from.x + to.x) / 2,
            y: (from.y + to.y) / 2
        });
    const $eb5c0917a150e0bd$var$getY = (p1, p2, x)=>{
        const m = (p2.y - p1.y) / (p2.x - p1.x);
        return m * (x - p1.x) + p1.y;
    };
    const $eb5c0917a150e0bd$var$generateSegment = (start, end, offset)=>{
        const c1 = {
            x: start.x + offset.x,
            y: start.y
        };
        const c2 = {
            x: start.x + offset.x,
            y: start.y + offset.y
        };
        const s1 = {
            x: start.x,
            y: $eb5c0917a150e0bd$var$getY(c2, end, start.x)
        };
        return `M${start.x} ${start.y} C${c1.x} ${c1.y} ${c2.x} ${c2.y} ${s1.x} ${s1.y} L${s1.x} ${s1.y} ${end.x} ${end.y}`;
    };
    const $eb5c0917a150e0bd$var$getSegmentOffsets = (from, to, halfItemHeight)=>{
        const fromOffset = {
            x: halfItemHeight,
            y: from.y <= to.y ? halfItemHeight : -halfItemHeight
        };
        const toOffset = {
            x: -fromOffset.x,
            y: -fromOffset.y
        };
        return [
            fromOffset,
            toOffset
        ];
    };
    const $eb5c0917a150e0bd$var$generateComplexPath = (from, to, halfItemHeight)=>{
        const middle = $eb5c0917a150e0bd$var$calculateMidPoint(from, to);
        const [fromOffset, toOffset] = $eb5c0917a150e0bd$var$getSegmentOffsets(from, to, halfItemHeight);
        return `${$eb5c0917a150e0bd$var$generateSegment(from, middle, fromOffset)} ${$eb5c0917a150e0bd$var$generateSegment(to, middle, toOffset)}`;
    };
    const $eb5c0917a150e0bd$var$generateSinglePath = (from, to, itemHeight)=>{
        const diffX = Math.abs(from.x - to.x);
        const progression = itemHeight + diffX * 0.1;
        return `M${from.x} ${from.y} C${from.x + progression} ${from.y} ${to.x - progression} ${to.y} ${to.x} ${to.y}`;
    };
    const $eb5c0917a150e0bd$export$2aa3fd96c49a84a8 = (0, (0, parcelRequire("8QpSo")).default)((from, to, itemHeight)=>from.x > to.x ? $eb5c0917a150e0bd$var$generateComplexPath(from, to, itemHeight / 2) : $eb5c0917a150e0bd$var$generateSinglePath(from, to, itemHeight));
});
parcelRegister("g1SUQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25bf1c89593464fa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $1I7E8;
    var $co1wz;
    var $2OMDV;
    var $1tKcG;
    var $egeYB;
    class $25bf1c89593464fa$export$55aef0c69232da84 extends (0, $5uXOq.Component) {
        componentDidUpdate() {
            const { links: links, onClose: onClose } = this.props;
            if (links.length === 0) onClose();
        }
        render() {
            const { position: position, ...contentProps } = this.props;
            if ((0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition.m2')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: true,
                strategy: "absolute",
                onClose: contentProps.onClose,
                placement: "bottom-start",
                content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("egeYB")).default), contentProps),
                trigger: ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement($25bf1c89593464fa$var$Anchor, {
                        top: position.top,
                        left: position.left,
                        ref: ref
                    }),
                testId: "portfolio-3-dependency-line-detail.common.ui.modal.portfolio-dependency-line-detail-popup"
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1tKcG")).default), {
                position: position,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("egeYB")).default), {
                    ...contentProps,
                    onClose: contentProps.onClose
                }),
                onClose: contentProps.onClose
            });
        }
    }
    var $25bf1c89593464fa$export$2e2bcd8739ae039 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('tooltip', {
        onUnlink: 'unlinked'
    })($25bf1c89593464fa$export$55aef0c69232da84);
    const $25bf1c89593464fa$var$Anchor = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { left: left, top: top, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_t50dub": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.left}px`),
                "--_1bsv5hl": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.top}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t _1ltvdw55 _154ikz78",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1tKcG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce7d483365831907$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $dC5iT;
    var $8CUq3;
    var $J8W7q;
    const $ce7d483365831907$var$ChartModal = ({ position: position, content: content, testId: testId, onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement($ce7d483365831907$var$InlineDialogWrapper, {
            "data-test-id": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            isOpen: true,
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: (0, (0, parcelRequire("8CUq3")).xcss)({
                    pointerEvents: 'initial'
                })
            }, content),
            onClose: onClose,
            closeOnScroll: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ce7d483365831907$var$ModalAnchor, position)));
    $ce7d483365831907$var$ChartModal.defaultProps = {
        testId: undefined
    };
    var $ce7d483365831907$export$2e2bcd8739ae039 = $ce7d483365831907$var$ChartModal;
    const $ce7d483365831907$var$InlineDialogWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _lcxvglyw _ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _hc7q15vq _njtz15vq _bp7o1ceh",
                __cmplp.className
            ])
        });
    });
    const $ce7d483365831907$var$ModalAnchor = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { left: left, top: top, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_t50dub": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.left}px`),
                "--_1bsv5hl": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.top}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t _1ltvdw55 _154ikz78",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("egeYB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fc7195c3567e862$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2kh23;
    var $8QpSo;
    var $gtreQ;
    var $cgL5K;
    var $4R6GH;
    var $koVbs;
    var $1p96B;
    var $DVljb;
    var $h7glD;
    var $ejkLh;
    var $3wpeS;
    var $c9xwE;
    const $2fc7195c3567e862$var$createUnlinkHandler = (0, (0, parcelRequire("8QpSo")).default)((itemKey, type, fromId, toId, onUnlink, callback)=>()=>{
            onUnlink({
                itemKey: itemKey,
                type: type,
                sourceItemKey: fromId,
                targetItemKey: toId
            });
            if (callback) callback();
        });
    const $2fc7195c3567e862$var$SimpleOverlapWarning = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Warning, null, (0, ($parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$WarningIconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            size: "small",
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            weight: "bold",
            color: "inherit"
        }, formatMessage((0, (0, parcelRequire("3wpeS")).default).offTrack)));
    };
    const $2fc7195c3567e862$var$OverlapWarning = ({ fromIssue: fromIssue, toIssue: toIssue })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        if (!(fromIssue && fromIssue.dueDate && fromIssue.dueDate > 0 && toIssue && toIssue.startDate && toIssue.startDate > 0)) return null;
        const leadTime = toIssue.startDate - fromIssue.dueDate;
        let overlapPeriod = null;
        if (leadTime === 1) overlapPeriod = formatMessage((0, (0, parcelRequire("3wpeS")).default).lessThanOneDayLeadTime);
        else overlapPeriod = (0, (0, parcelRequire("2kh23")).default)(fromIssue.dueDate, toIssue.startDate, {
            locale: (0, (0, parcelRequire("1p96B")).getLocale)(locale)
        });
        return overlapPeriod ? (0, ($parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Warning, null, (0, ($parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$WarningIconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            size: "small",
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            weight: "bold",
            color: "inherit"
        }, `${formatMessage((0, (0, parcelRequire("3wpeS")).default).overlapDatesMessage)} (${overlapPeriod})`, ' ')) : null;
    };
    const $2fc7195c3567e862$var$ModalContent = (props)=>{
        const { links: links, onUnlink: onUnlink, onClose: onClose, canDelete: canDelete, isOverlapping: isOverlapping, id: id, simpleOverlap: simpleOverlap = false } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (links.length === 0) return null;
        const { fromIssue: fromIssue, toIssue: toIssue, isOfftrack: isOfftrack } = links[0];
        let isDependenciesDatesOverlapping = false;
        if (simpleOverlap && (0, (0, parcelRequire("4R6GH")).fg)('dependency_visualisation_program_board_fe_and_be')) isDependenciesDatesOverlapping = isOfftrack ?? false;
        else if (isOverlapping) isDependenciesDatesOverlapping = isOverlapping(fromIssue.indexOnScope, toIssue.indexOnScope);
        const defaultOutwardDependencyDescription = formatMessage((0, (0, parcelRequire("3wpeS")).default).blocks);
        const shouldCloseOnUnlink = links.length <= 1;
        const dependenciesBlock = links.map((link, index)=>{
            const { fromIssue: fromIssue, toIssue: toIssue, issueLinkType: issueLinkType, itemKey: itemKey } = link;
            const renderOverlapWarning = ()=>{
                if (simpleOverlap) return (0, ($parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$SimpleOverlapWarning, null);
                return (0, ($parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$OverlapWarning, {
                    fromIssue: fromIssue,
                    toIssue: toIssue
                });
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: `${issueLinkType.id}_${fromIssue.id}_${toIssue.id}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h7glD")).default), fromIssue), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c9xwE")).default), {
                label: issueLinkType.outward ?? defaultOutwardDependencyDescription,
                isOverlapping: isDependenciesDatesOverlapping,
                onUnlink: canDelete ? $2fc7195c3567e862$var$createUnlinkHandler(itemKey, issueLinkType.id, fromIssue.id, toIssue.id, onUnlink, shouldCloseOnUnlink ? onClose : undefined) : undefined
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h7glD")).default), toIssue), isDependenciesDatesOverlapping && (0, (0, parcelRequire("4R6GH")).fg)('dependency_visualisation_program_board_fe_and_be') && renderOverlapWarning(), isDependenciesDatesOverlapping && !(0, (0, parcelRequire("4R6GH")).fg)('dependency_visualisation_program_board_fe_and_be') && (0, ($parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$OverlapWarning, {
                fromIssue: fromIssue,
                toIssue: toIssue
            }), index < links.length - 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ejkLh")).default), null) : null);
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Container, {
            id: id,
            "data-testid": "portfolio-3-dependency-line-detail.common.ui.content.container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Content, null, dependenciesBlock));
    };
    $2fc7195c3567e862$var$ModalContent.defaultProps = {
        onUnlink: (0, ($parcel$interopDefault($8Rkzz))),
        onClose: (0, ($parcel$interopDefault($8Rkzz))),
        canDelete: false
    };
    var $2fc7195c3567e862$export$2e2bcd8739ae039 = $2fc7195c3567e862$var$ModalContent;
    const $2fc7195c3567e862$var$TOOLTIP_Z_INDEX = 13;
    const $2fc7195c3567e862$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi _bfhkhp5a _1bsbp3fh _16qsanr3 _2rko1l7b _c71l1mjv _1reo1wug _18m91wug _1pbyilow",
                __cmplp.className
            ])
        });
    });
    const $2fc7195c3567e862$var$Content = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $2fc7195c3567e862$var$Warning = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _19pkutpp _zulp1b66",
                __cmplp.className
            ])
        });
    });
    const $2fc7195c3567e862$var$WarningIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _ae4v1h6o _1n261g80",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h7glD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa6aba85930eb9e5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8RXs9;
    var $2FvnI;
    var $jVjIH;
    var $jceGp;
    const $fa6aba85930eb9e5$var$DependencyCard = (props)=>{
        const { title: title, issueKey: issueKey, projectKey: projectKey, iconUrl: iconUrl, typeName: typeName, intl: { formatMessage: formatMessage } } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$Content, null, (0, ($parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$ContentLeft, null, (0, ($parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$TitleContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$TypeIconContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jVjIH")).default), {
            src: iconUrl || '',
            alt: formatMessage((0, (0, parcelRequire("jceGp")).default).iconAltText, {
                typeName: typeName
            })
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$IssueLinkContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvnI")).default), {
            issueKey: issueKey,
            projectKey: projectKey
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$Title, {
            title: title
        }, title)))));
    };
    $fa6aba85930eb9e5$var$DependencyCard.displayName = 'DependencyCard';
    var $fa6aba85930eb9e5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($fa6aba85930eb9e5$var$DependencyCard);
    const $fa6aba85930eb9e5$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _kqswh2mm _1yt41pyq _bfhk1s4m",
                __cmplp.className
            ])
        });
    });
    const $fa6aba85930eb9e5$var$Content = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc",
                __cmplp.className
            ])
        });
    });
    const $fa6aba85930eb9e5$var$ContentLeft = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _16jlkb7n _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $fa6aba85930eb9e5$var$TitleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswh2mm _2lx2vrvc _4cvr1h6o _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $fa6aba85930eb9e5$var$TypeIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
    const $fa6aba85930eb9e5$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _vwz41tcg _syaz1fxt _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $fa6aba85930eb9e5$var$IssueLinkContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y9ia1q9c _1txj12x7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jVjIH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82127cf68330cc05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $82127cf68330cc05$var$Icon = ({ src: src, alt: alt, size: size })=>(0, ($parcel$interopDefault($5uXOq))).createElement($82127cf68330cc05$var$IconImage, {
            src: src,
            alt: alt,
            width: size,
            height: size
        });
    $82127cf68330cc05$var$Icon.defaultProps = {
        alt: '',
        size: '16px'
    };
    var $82127cf68330cc05$export$2e2bcd8739ae039 = $82127cf68330cc05$var$Icon;
    const $82127cf68330cc05$var$IconImage = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _2rko1l7b",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jceGp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$567d8624a9993f3b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $567d8624a9993f3b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        iconAltText: {
            "id": "portfolio-3-dependency-line-detail.common.ui.content.card.icon-alt-text",
            "defaultMessage": "{typeName} issue type"
        }
    });
});
parcelRegister("ejkLh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82cf6945d1e605c6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $82cf6945d1e605c6$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1yt4pxbi",
                __cmplp.className
            ])
        });
    });
    const $82cf6945d1e605c6$var$Line = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _vchhusvi _4t3it94y _1bsb1osq _19itukkb",
                __cmplp.className
            ])
        });
    });
    var $82cf6945d1e605c6$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($82cf6945d1e605c6$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($82cf6945d1e605c6$var$Line, null));
});
parcelRegister("3wpeS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8a703673539a6f1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d8a703673539a6f1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        blocks: {
            "id": "portfolio-3-dependency-line-detail.common.ui.content.blocks",
            "defaultMessage": "blocks"
        },
        overlapDatesMessage: {
            "id": "portfolio-3-dependency-line-detail.common.ui.content.overlap-dates-message",
            "defaultMessage": "Dates overlap"
        },
        lessThanOneDayLeadTime: {
            "id": "portfolio-3-dependency-line-detail.common.ui.content.less-than-one-day-lead-time",
            "defaultMessage": "less than 1 day"
        },
        offTrack: {
            "id": "portfolio-3-dependency-line-detail.common.ui.content.off-track",
            "defaultMessage": "Off-track"
        }
    });
});
parcelRegister("c9xwE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9cab14210217549d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $458iJ;
    var $2ZvSj;
    const $9cab14210217549d$var$Separator = ({ label: label, isOverlapping: isOverlapping, onUnlink: onUnlink })=>(0, ($parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$SeparatorContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$Line, {
            isOverlapping: isOverlapping
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$IconWrapper, {
            isOverlapping: isOverlapping
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("458iJ"))))), {
            size: "small",
            label: label,
            primaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$Line, {
            isOverlapping: isOverlapping
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$TextContainer, null, label), onUnlink && (0, ($parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$UnlinkButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2ZvSj")).default), {
            onClick: onUnlink
        })));
    var $9cab14210217549d$export$2e2bcd8739ae039 = $9cab14210217549d$var$Separator;
    const $9cab14210217549d$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $9cab14210217549d$var$SeparatorContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _18u0pxbi _2hwxu2gc _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $9cab14210217549d$var$TextContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _4cvr1h6o _11c81oud _vwz4dlk8",
                __cmplp.className
            ])
        });
    });
    const $9cab14210217549d$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isOverlapping: isOverlapping, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbgktf _4t3igktf _16qs14w9 _2rko1ssb",
                __cmplp.isOverlapping ? "_bfhkk8x7" : "_bfhk1849",
                __cmplp.className
            ])
        });
    });
    const $9cab14210217549d$var$Line = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isOverlapping: isOverlapping, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i19bv _19it1hdd",
                __cmplp.isOverlapping ? "_1h6dk8x7" : "_1h6d1849",
                __cmplp.className
            ])
        });
    });
    const $9cab14210217549d$var$UnlinkButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _ae4v1h6o _1n261g80",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2ZvSj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fedf5e35b4f7698$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $fVnbM;
    var $fKe1H;
    var $3bDjY;
    var $8RXs9;
    var $2OMDV;
    var $8zOmE;
    var $1qzuX;
    class $3fedf5e35b4f7698$var$UnlinkButton extends (0, $5uXOq.Component) {
        render() {
            const { intl: { formatMessage: formatMessage } } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage((0, (0, parcelRequire("1qzuX")).default).unlink)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                testId: "portfolio-3-dependency-line-detail.common.ui.content.common.components.unlink-button.unlink-button",
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fKe1H"))))), {
                    label: formatMessage((0, (0, parcelRequire("1qzuX")).default).unlink),
                    size: "medium"
                }),
                spacing: "compact",
                appearance: "subtle",
                onClick: this.onClick
            }));
        }
        constructor(...args){
            super(...args);
            this.onClick = (event, analyticsEvent)=>{
                event.stopPropagation();
                this.props.onClick();
                const [actionSubject, action] = (0, $39bd3c5308a092a2$export$de7a70543cfab9e).split(' ');
                const analyticsPayload = {
                    source: 'dependencyLineDetail'
                };
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: action,
                    actionSubject: actionSubject
                }), analyticsPayload);
            };
        }
    }
    var $3fedf5e35b4f7698$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("8RXs9")).default), (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('button', {
        onClick: 'clicked'
    }))($3fedf5e35b4f7698$var$UnlinkButton);
});
parcelRegister("fKe1H", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b766083acbc37908$var$_react = $b766083acbc37908$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $b766083acbc37908$var$_linkBroken = $b766083acbc37908$var$_interopRequireDefault((parcelRequire("90mMF")));
    function $b766083acbc37908$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b766083acbc37908$var$UnlinkIcon = (props)=>$b766083acbc37908$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.72 14.43a.97.97 0 0 0-1.37 0l-2.09 2.06a1.93 1.93 0 0 1-1.37.57c-.59 0-1.13-.26-1.52-.74-.63-.78-.5-1.93.2-2.64l1.32-1.32.69-.69a.97.97 0 0 0 0-1.38.97.97 0 0 0-1.37 0l-2.07 2.07a3.89 3.89 0 0 0 0 5.5l.01.01A3.87 3.87 0 0 0 8.89 19a3.87 3.87 0 0 0 2.75-1.14l2.08-2.08a.95.95 0 0 0 0-1.34m-3.44-4.87a.97.97 0 0 0 1.37 0l2.09-2.06c.37-.37.85-.57 1.37-.57.59 0 1.14.26 1.53.74.63.78.51 1.93-.2 2.64l-1.32 1.32-.69.69a.97.97 0 0 0 0 1.38c.38.38 1 .38 1.38 0l2.07-2.07a3.89 3.89 0 0 0 0-5.5l-.01-.01A3.87 3.87 0 0 0 15.11 5a3.87 3.87 0 0 0-2.75 1.14l-2.08 2.09a.95.95 0 0 0 0 1.35M8.92 4.62l.4.97a1 1 0 1 1-1.85.77l-.4-.97a1 1 0 1 1 1.85-.76M5.38 7.08l.97.4a1 1 0 0 1-.77 1.85l-.97-.4a1 1 0 0 1 .77-1.85m9.94 10.41a1 1 0 0 0-.54 1.31l.4.97a1 1 0 1 0 1.84-.77l-.4-.97a1 1 0 0 0-1.31-.54m2.18-2.17a1 1 0 0 0 .54 1.31l.97.4a1 1 0 0 0 .77-1.85l-.97-.4a1 1 0 0 0-1.31.54"/></svg>`
        }, props, {
            newIcon: $b766083acbc37908$var$_linkBroken.default
        }));
    $b766083acbc37908$var$UnlinkIcon.displayName = 'UnlinkIcon';
    var $b766083acbc37908$var$_default = module.exports.default = $b766083acbc37908$var$UnlinkIcon;
});
parcelRegister("90mMF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $68e5c989bea2984f$var$_react = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $68e5c989bea2984f$var$_UNSAFE_baseNew = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $68e5c989bea2984f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $68e5c989bea2984f$var$LinkBrokenIcon = (props)=>$68e5c989bea2984f$var$_react.default.createElement($68e5c989bea2984f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3.5 8-.75.75a3.182 3.182 0 0 0 4.5 4.5L8 12.5m0-9 .75-.75a3.182 3.182 0 0 1 4.5 4.5L12.5 8M5.25 1v3M1 5.25h3m11 5.5h-3M10.75 15v-3"/>`
        }, props));
    $68e5c989bea2984f$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
    var $68e5c989bea2984f$var$_default = module.exports.default = $68e5c989bea2984f$var$LinkBrokenIcon;
});
const $39bd3c5308a092a2$export$de7a70543cfab9e = 'issueDependencyLink deleted';
parcelRegister("1qzuX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dac8baf8a85055d9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dac8baf8a85055d9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unlink: {
            "id": "portfolio-3-dependency-line-detail.common.ui.content.common.components.unlink-button.unlink",
            "defaultMessage": "Remove dependency"
        }
    });
});
parcelRegister("j9exh", function(module, exports) {
    $parcel$export(module.exports, "DependencyLinesContainer", ()=>$623b1120dd2b3a0c$export$b17a53f6e3b42b6b);
    var $bC2fB;
    var $kUt4O = parcelRequire("kUt4O");
    var $38Z5N = parcelRequire("38Z5N");
    const $623b1120dd2b3a0c$export$b17a53f6e3b42b6b = (0, (0, parcelRequire("bC2fB")).connect)((0, $kUt4O.default), {})((0, $38Z5N.DependencyLinesContainer));
});
parcelRegister("kUt4O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c7efccf3880e505$export$2e2bcd8739ae039);
    var $6iNxz = parcelRequire("6iNxz");
    var $jAIJh = parcelRequire("jAIJh");
    var $3YtPS = parcelRequire("3YtPS");
    var $9c7efccf3880e505$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        scope: (0, $6iNxz.getTableItems),
        timelineRange: (0, $jAIJh.getTimelineRange)
    });
});
parcelRegister("38Z5N", function(module, exports) {
    $parcel$export(module.exports, "DependencyLinesContainer", ()=>$21fa055605a80bbf$export$b17a53f6e3b42b6b);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $cGv9m;
    var $hE4fC;
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $8LV9S;
    var $jxhnO = parcelRequire("jxhnO");
    var $3kqr7 = parcelRequire("3kqr7");
    const $21fa055605a80bbf$var$SCROLL_PADDING = 2e6;
    const $21fa055605a80bbf$export$b17a53f6e3b42b6b = ({ scope: scope, timelineRange: timelineRange })=>{
        const [columnWidths] = (0, (0, parcelRequire("8LV9S")).useColumnWidths)({
            preview: false
        });
        const [isResizing] = (0, (0, parcelRequire("8LV9S")).useIsResizing)();
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const width = zoomLevel ? (0, (0, parcelRequire("cGv9m")).getContainerWidth)(zoomLevel) : columnWidths.at(-1) ?? 0;
        const marginLeft = columnWidths.reduce((totalWidth, curWidth, index)=>index < columnWidths.length - 1 ? totalWidth + curWidth : totalWidth, 0);
        if (isResizing) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
            layer: (0, $6hYE8.Z_INDEX_LAYER).DEPENDENCY_LINES
        }, (zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $21fa055605a80bbf$var$containerStyles,
                style: {
                    zIndex: zIndex
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jxhnO.TimelineAligned), {
                offset: $21fa055605a80bbf$var$SCROLL_PADDING
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $21fa055605a80bbf$var$layerAlignedStyles,
                style: {
                    width: width,
                    marginLeft: marginLeft
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3kqr7.default), {
                width: width,
                scope: scope,
                startIndex: 0,
                stopIndex: Infinity,
                timelineRange: timelineRange
            })))));
    };
    const $21fa055605a80bbf$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        pointerEvents: 'none'
    });
    const $21fa055605a80bbf$var$layerAlignedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        height: '100%'
    });
});
parcelRegister("3kqr7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3cfa77682ab8f07$export$2e2bcd8739ae039);
    var $bC2fB;
    var $j1P04 = parcelRequire("j1P04");
    var $4IRZB = parcelRequire("4IRZB");
    var $e3cfa77682ab8f07$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $j1P04.default), {})((0, $4IRZB.default));
});
parcelRegister("j1P04", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6384dc73932fa8f6$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $7ppNi = parcelRequire("7ppNi");
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    var $6384dc73932fa8f6$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        isOptimizedMode: $1CGdp.isOptimizedMode,
        issueStatusById: (0, $7ppNi.getIssueStatusById),
        syncStartEnabled: (0, $bHTqr.getSyncStartEnabled)
    });
});
parcelRegister("4IRZB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f58db79ff06bfb29$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5kbpS = parcelRequire("5kbpS");
    var $kFsv3;
    var $1zlQp;
    var $6FMrA;
    var $aDKIU = parcelRequire("aDKIU");
    var $6iNxz = parcelRequire("6iNxz");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $g5X3G;
    var $iJ4DB = parcelRequire("iJ4DB");
    function $f58db79ff06bfb29$export$2e2bcd8739ae039({ isOptimizedMode: isOptimizedMode, issueStatusById: issueStatusById, scope: scope, width: width, startIndex: startIndex, stopIndex: stopIndex, syncStartEnabled: syncStartEnabled, timelineRange: timelineRange }) {
        const [dependencySettings] = (0, (0, parcelRequire("1zlQp")).useDependencySettings)();
        const getDrawableLine = (0, $5uXOq.useCallback)((dependencyLine)=>{
            const { fromIssue: fromIssue, toIssue: toIssue, drawable: drawable } = dependencyLine;
            if (!drawable) return;
            const { indexOnScope: fromItemScopeIndex, id: sourceItemKey } = fromIssue;
            const fromItem = scope[fromItemScopeIndex];
            if (!fromItem || fromItem.tag !== (0, $6iNxz.TABLE_ISSUE)) return;
            const { indexOnScope: toItemScopeIndex, id: targetItemKey } = toIssue;
            const toItem = scope[toItemScopeIndex];
            if (!toItem || toItem.tag !== (0, $6iNxz.TABLE_ISSUE)) return;
            const fromItemInLimitedScope = fromItemScopeIndex >= startIndex && fromItemScopeIndex < stopIndex;
            const toItemInLimitedScope = toItemScopeIndex >= startIndex && toItemScopeIndex < stopIndex;
            const dependencyLineTraversesVisibleArea = fromItemScopeIndex < startIndex && toItemScopeIndex > stopIndex || fromItemScopeIndex > stopIndex && toItemScopeIndex < startIndex;
            if (fromItemInLimitedScope || toItemInLimitedScope || dependencyLineTraversesVisibleArea) {
                const { baselineStart: fromBaselineStart, baselineEnd: fromBaselineEnd } = isOptimizedMode && !(0, ($parcel$interopDefault($5kbpS)))(fromItem.value.optimized) ? fromItem.value.optimized : fromItem.value;
                const fromPositions = (0, $iJ4DB.getPositionsForBar)({
                    baselineStart: fromBaselineStart,
                    baselineEnd: fromBaselineEnd
                }, timelineRange);
                const { baselineStart: baselineStart, baselineEnd: baselineEnd } = isOptimizedMode && !(0, ($parcel$interopDefault($5kbpS)))(toItem.value.optimized) ? toItem.value.optimized : toItem.value;
                const toPositions = (0, $iJ4DB.getPositionsForBar)({
                    baselineStart: baselineStart,
                    baselineEnd: baselineEnd
                }, timelineRange);
                const isOverlapping = (0, $aDKIU.getIssueLinkIfOverlapping)(fromItem.value, toItem.value, issueStatusById, syncStartEnabled);
                return {
                    to: {
                        id: (0, (0, parcelRequire("g5X3G")).toIssueId)(targetItemKey),
                        indexOnScope: toItemScopeIndex,
                        y: (0, $b752691db4fdc48e$export$7e4216a402b21d20) + scope[toItemScopeIndex].topOffset - (0, $TTKUQ.SCOPE_ROW_HEIGHT) / 2,
                        x: toPositions.leftPositionPercentage * width / 100,
                        color: (0, (0, parcelRequire("kFsv3")).GREY)
                    },
                    from: {
                        id: (0, (0, parcelRequire("g5X3G")).toIssueId)(sourceItemKey),
                        indexOnScope: fromItemScopeIndex,
                        y: (0, $b752691db4fdc48e$export$7e4216a402b21d20) + scope[fromItemScopeIndex].topOffset - (0, $TTKUQ.SCOPE_ROW_HEIGHT) / 2,
                        x: (100 - fromPositions.rightPositionPercentage) * width / 100,
                        color: (0, (0, parcelRequire("kFsv3")).GREY)
                    },
                    itemHeight: (0, $TTKUQ.SCOPE_ROW_HEIGHT),
                    isOverlapping: isOverlapping
                };
            }
        }, [
            isOptimizedMode,
            issueStatusById,
            scope,
            startIndex,
            stopIndex,
            syncStartEnabled,
            timelineRange,
            width
        ]);
        if (dependencySettings.display !== (0, $TTKUQ.DEPENDENCY_SETTINGS).LINES) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6FMrA")).DependencyLinesOverlay), {
            getDrawableLine: getDrawableLine
        });
    }
});
parcelRegister("5kbpS", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $3e07ad12f38214bd$var$func = $lVx1a('isEmpty', (parcelRequire("gccSB")), (parcelRequire("bUoRH")));
    $3e07ad12f38214bd$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $3e07ad12f38214bd$var$func;
});
const $b752691db4fdc48e$export$7e4216a402b21d20 = 90;
parcelRegister("iJ4DB", function(module, exports) {
    $parcel$export(module.exports, "getPositionsForBar", ()=>$9b4f887f65289845$export$32e9788ba7124f57);
    var $4R6GH;
    var $flnZx;
    var $4nDwW = parcelRequire("4nDwW");
    const $9b4f887f65289845$var$GRADIENT_LENGTH_PERCENTAGE = 30;
    const $9b4f887f65289845$var$MINIMUM_LEFT_FORCED_GRADIENT_PERCENTAGE = 12;
    const $9b4f887f65289845$var$MAXIMUM_RIGHT_FORCED_GRADIENT_PERCENTAGE = 100 - $9b4f887f65289845$var$MINIMUM_LEFT_FORCED_GRADIENT_PERCENTAGE;
    const $9b4f887f65289845$export$32e9788ba7124f57 = ({ baselineStart: baselineStart, baselineEnd: baselineEnd }, timelineRange, forcedGradients)=>{
        const timelineSize = timelineRange.end - timelineRange.start;
        const timestampToTimelineLeftPercentage = (time)=>((0, (0, parcelRequire("flnZx")).startOfUtcDay)(time) - timelineRange.start) / timelineSize * 100;
        const timestampToTimelineRightPercentage = (time)=>((0, (0, parcelRequire("flnZx")).endOfUtcDay)(time) - timelineRange.start) / timelineSize * 100;
        let leftPositionPercentage = 0;
        let rightPositionPercentage = 0;
        let leftAnchorPercentage = 0;
        let rightAnchorPercentage = 100;
        if ((0, $4nDwW.isDefined)(baselineStart) && (0, $4nDwW.isDefined)(baselineEnd)) {
            const minBaselineStart = (0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline') ? Math.min(baselineStart, baselineEnd) : baselineStart;
            const maxBaselineEnd = (0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline') ? Math.max(baselineStart, baselineEnd) : baselineEnd;
            leftPositionPercentage = timestampToTimelineLeftPercentage(minBaselineStart);
            rightPositionPercentage = 100 - timestampToTimelineRightPercentage(maxBaselineEnd);
        } else if ((0, $4nDwW.isDefined)(baselineStart)) {
            leftPositionPercentage = timestampToTimelineLeftPercentage(baselineStart);
            rightPositionPercentage = 100 - (leftPositionPercentage + $9b4f887f65289845$var$GRADIENT_LENGTH_PERCENTAGE);
            rightAnchorPercentage = 0;
        } else if ((0, $4nDwW.isDefined)(baselineEnd)) {
            rightPositionPercentage = 100 - timestampToTimelineRightPercentage(baselineEnd);
            leftPositionPercentage = 100 - (rightPositionPercentage + $9b4f887f65289845$var$GRADIENT_LENGTH_PERCENTAGE);
            leftAnchorPercentage = 100;
        }
        if (forcedGradients) {
            const earliestStartPercentage = timestampToTimelineLeftPercentage(forcedGradients.earliestStart);
            const latestEndPercentage = timestampToTimelineRightPercentage(forcedGradients.latestEnd);
            if (forcedGradients.left) leftPositionPercentage = Math.min(timestampToTimelineRightPercentage(forcedGradients.earliestEnd) - $9b4f887f65289845$var$GRADIENT_LENGTH_PERCENTAGE, earliestStartPercentage);
            if (forcedGradients.right) rightPositionPercentage = 100 - Math.max(timestampToTimelineLeftPercentage(forcedGradients.latestStart) + $9b4f887f65289845$var$GRADIENT_LENGTH_PERCENTAGE, latestEndPercentage);
            const totalPercentage = 100 - (leftPositionPercentage + rightPositionPercentage);
            if (forcedGradients.left) leftAnchorPercentage = Math.max($9b4f887f65289845$var$MINIMUM_LEFT_FORCED_GRADIENT_PERCENTAGE, 100 * (earliestStartPercentage - leftPositionPercentage) / totalPercentage);
            if (forcedGradients.right) rightAnchorPercentage = Math.min($9b4f887f65289845$var$MAXIMUM_RIGHT_FORCED_GRADIENT_PERCENTAGE, 100 * (latestEndPercentage - leftPositionPercentage) / totalPercentage);
        }
        return {
            leftPositionPercentage: leftPositionPercentage,
            rightPositionPercentage: rightPositionPercentage,
            leftAnchorPercentage: leftAnchorPercentage,
            rightAnchorPercentage: rightAnchorPercentage
        };
    };
});
parcelRegister("8G9be", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15a01e6d1884032e$export$2e2bcd8739ae039);
    var $1zlQp;
    var $bC2fB;
    var $5Tv1R = parcelRequire("5Tv1R");
    var $15a01e6d1884032e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $5Tv1R.default), {})((0, (0, parcelRequire("1zlQp")).DependencyLineContainer));
});
parcelRegister("5Tv1R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cbca890e63b17748$export$2e2bcd8739ae039);
    var $jcw0u;
    var $4R6GH;
    var $4ENQh;
    var $cGv9m;
    var $1CGdp = parcelRequire("1CGdp");
    var $ddv1K = parcelRequire("ddv1K");
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $6iNxz = parcelRequire("6iNxz");
    var $jAIJh = parcelRequire("jAIJh");
    var $kWDpn = parcelRequire("kWDpn");
    var $fHJiO = parcelRequire("fHJiO");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $g5X3G;
    var $iJ4DB = parcelRequire("iJ4DB");
    function $cbca890e63b17748$export$25634793c5cb4ee3(timelineRange, timeScale, from, to) {
        const { baselineStart: fromStart, baselineEnd: fromEnd } = from.tag === (0, $6iNxz.TABLE_ISSUE) ? from.value : {};
        const { baselineStart: toStart, baselineEnd: toEnd } = to.tag === (0, $6iNxz.TABLE_ISSUE) ? to.value : {};
        const fromHasDate = (0, $4nDwW.isDefined)(fromStart) || (0, $4nDwW.isDefined)(fromEnd);
        const toHasDate = (0, $4nDwW.isDefined)(toStart) || (0, $4nDwW.isDefined)(toEnd);
        if (!fromHasDate || !toHasDate) return false;
        const { mode: selectedZoomLevel } = timeScale;
        const isScrollableTimeline = (0, (0, parcelRequire("cGv9m")).getZoomLevel)(selectedZoomLevel) !== undefined;
        if (isScrollableTimeline) return true;
        const fromPositions = (0, $iJ4DB.getPositionsForBar)({
            ...from.tag === (0, $6iNxz.TABLE_ISSUE) && {
                baselineStart: fromStart,
                baselineEnd: fromEnd
            }
        }, timelineRange);
        const toPositions = (0, $iJ4DB.getPositionsForBar)({
            ...to.tag === (0, $6iNxz.TABLE_ISSUE) && {
                baselineStart: toStart,
                baselineEnd: toEnd
            }
        }, timelineRange);
        return toPositions.leftPositionPercentage < 100 && toPositions.leftPositionPercentage > 0 && 100 - fromPositions.rightPositionPercentage < 100 && 100 - fromPositions.rightPositionPercentage > 0;
    }
    const $cbca890e63b17748$var$logDependencyLinesInconsistencyError = ()=>{
        const errorMessage = 'Incorrect issue type found when rendering dependency lines';
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                packageName: (0, $TTKUQ.PACKAGE_NAME),
                id: (0, $TTKUQ.ERROR_REPORTING_PACKAGE).ROADMAP,
                teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: errorMessage
            },
            error: new Error(errorMessage),
            skipSentry: true
        });
    };
    const $cbca890e63b17748$var$getDependencyLinesPureFunc = (tableItems, uniqueLinks, timelineRange, timeScale, issueTypesById, issueLinkTypes, projectsById, dependencySettings)=>{
        if (dependencySettings.display !== (0, $TTKUQ.DEPENDENCY_SETTINGS).LINES) return [];
        const getIssueId = (tableItem)=>{
            if (tableItem.tag !== (0, $6iNxz.TABLE_ISSUE)) return undefined;
            return tableItem.value.id;
        };
        const tableItemsIndexMap = tableItems.reduce((map, tableItem, index)=>{
            const issueId = getIssueId(tableItem);
            if (!issueId) return map;
            if (map[issueId]) map[issueId].push(index);
            else map[issueId] = [
                index
            ];
            return map;
        }, {});
        return uniqueLinks.reduce((lines, currentLink)=>{
            const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey, type: type, itemKey: itemKey } = currentLink;
            const issueItemFromIndexes = Object.prototype.hasOwnProperty.call(tableItemsIndexMap, sourceItemKey) ? tableItemsIndexMap[sourceItemKey] : [];
            const issueItemToIndexes = Object.prototype.hasOwnProperty.call(tableItemsIndexMap, targetItemKey) ? tableItemsIndexMap[targetItemKey] : [];
            const linkOccurrences = issueItemFromIndexes.flatMap((a)=>issueItemToIndexes.map((b)=>({
                        from: a,
                        to: b
                    })));
            linkOccurrences.forEach(({ from: from, to: to })=>{
                const issueItemFrom = tableItems[from];
                if (!issueItemFrom || issueItemFrom.tag !== (0, $6iNxz.TABLE_ISSUE)) return;
                const issueItemTo = tableItems[to];
                if (!issueItemTo || issueItemTo.tag !== (0, $6iNxz.TABLE_ISSUE)) return;
                const lineWithinHorizontalBounds = $cbca890e63b17748$export$25634793c5cb4ee3(timelineRange, timeScale, issueItemFrom, issueItemTo);
                const areInSameGroup = issueItemFrom.group === issueItemTo.group;
                const drawable = areInSameGroup && lineWithinHorizontalBounds;
                const rawSourceIssue = (0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline') ? (0, $fHJiO.swapIssueBaselineDatesIfInverted)(issueItemFrom.value) : issueItemFrom.value;
                const rawTargetIssue = (0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline') ? (0, $fHJiO.swapIssueBaselineDatesIfInverted)(issueItemTo.value) : issueItemTo.value;
                const sourceIssueType = issueTypesById[rawSourceIssue.type];
                const targetIssueType = issueTypesById[rawTargetIssue.type];
                if (!sourceIssueType || !targetIssueType) {
                    $cbca890e63b17748$var$logDependencyLinesInconsistencyError();
                    return;
                }
                lines.push({
                    itemKey: itemKey,
                    fromIssue: {
                        indexOnScope: from,
                        id: (0, (0, parcelRequire("g5X3G")).toIssueId)(sourceItemKey),
                        issueKey: rawSourceIssue.issueKey,
                        projectKey: projectsById[rawSourceIssue.project].key,
                        title: rawSourceIssue.summary,
                        typeName: sourceIssueType.name,
                        iconUrl: sourceIssueType.iconUrl,
                        startDate: rawSourceIssue.baselineStart || 0,
                        dueDate: rawSourceIssue.baselineEnd || 0,
                        isHidden: false
                    },
                    toIssue: {
                        indexOnScope: to,
                        id: (0, (0, parcelRequire("g5X3G")).toIssueId)(targetItemKey),
                        issueKey: rawTargetIssue.issueKey,
                        projectKey: projectsById[rawTargetIssue.project].key,
                        title: rawTargetIssue.summary,
                        typeName: targetIssueType.name,
                        iconUrl: targetIssueType.iconUrl,
                        startDate: rawTargetIssue.baselineStart || 0,
                        dueDate: rawTargetIssue.baselineEnd || 0,
                        isHidden: false
                    },
                    issueLinkType: {
                        ...issueLinkTypes[type]
                    },
                    drawable: drawable
                });
            });
            return lines;
        }, []);
    };
    const $cbca890e63b17748$export$b5efd9fe27e8d42 = (0, (0, parcelRequire("4ENQh")).monitor).timeFunction($cbca890e63b17748$var$getDependencyLinesPureFunc, 'roadmap_timeline_schedule_dependencyLines_provider_query_getDependencyLinesPure');
    const $cbca890e63b17748$var$getDependencyLines = (0, $3YtPS.createSelector)([
        (0, $6iNxz.getTableItems),
        (0, $ddv1K.getUniqueLinks),
        (0, $jAIJh.getTimelineRange),
        (0, $kWDpn.getTimeScaleViewSettings),
        (0, $kllqP.getIssueTypesById),
        (0, $ddv1K.getDependencyIssueLinkTypesById),
        (0, $jpXKt.getProjectsById),
        (0, $kWDpn.getDependencySettings),
        (0, $1CGdp.isOptimizedMode)
    ], $cbca890e63b17748$export$b5efd9fe27e8d42);
    const $cbca890e63b17748$var$mapStateToProps = (state, props)=>({
            dependencyLines: $cbca890e63b17748$var$getDependencyLines(state, props),
            dependencySettings: (0, $kWDpn.getDependencySettings)(state)
        });
    var $cbca890e63b17748$export$2e2bcd8739ae039 = $cbca890e63b17748$var$mapStateToProps;
});
parcelRegister("21TKe", function(module, exports) {
    $parcel$export(module.exports, "EmptyList", ()=>$9991a83ddae3e5e3$export$f3f2e7ed2b6256b1);
    var $bC2fB;
    var $5LLZF = parcelRequire("5LLZF");
    var $bvrX2 = parcelRequire("bvrX2");
    const $9991a83ddae3e5e3$export$f3f2e7ed2b6256b1 = (0, (0, parcelRequire("bC2fB")).connect)((0, $5LLZF.mapStateToProps), {})((0, $bvrX2.EmptyListModeContainer));
});
parcelRegister("5LLZF", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$6a6b010605632769$export$c31df4bd766f9c35);
    var $bHTqr = parcelRequire("bHTqr");
    var $g7bEf = parcelRequire("g7bEf");
    var $3YtPS = parcelRequire("3YtPS");
    const $6a6b010605632769$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        columns: (0, $g7bEf.getColumns),
        dateConfiguration: (0, $bHTqr.getDateConfiguration)
    });
});
parcelRegister("bvrX2", function(module, exports) {
    $parcel$export(module.exports, "EmptyListModeContainer", ()=>$7bfb3f011550a53d$export$e7e15e52c348e2b);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $8Razh = parcelRequire("8Razh");
    var $d3UHJ = parcelRequire("d3UHJ");
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $8LV9S;
    const $7bfb3f011550a53d$export$e7e15e52c348e2b = ({ columns: columns, dateConfiguration: dateConfiguration })=>{
        const [columnWidths] = (0, (0, parcelRequire("8LV9S")).useColumnWidths)({
            preview: true
        });
        const marginLeft = columnWidths.reduce((totalWidth, curWidth, index)=>index < columnWidths.length - 1 ? totalWidth + curWidth : totalWidth, 0);
        const emptyFieldWidth = columnWidths.at(-1);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
            layer: (0, $6hYE8.Z_INDEX_LAYER).EMPTY_LIST_OVERLAY
        }, (zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $7bfb3f011550a53d$var$containerStyles,
                style: {
                    zIndex: zIndex
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $7bfb3f011550a53d$var$layerAlignedStyles,
                style: {
                    width: emptyFieldWidth,
                    marginLeft: marginLeft
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $7bfb3f011550a53d$var$emptyStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Razh.default), {
                columns: columns,
                getMatchingConfiguredDate: (0, $d3UHJ.getMatchingConfiguredDate)(dateConfiguration),
                width: emptyFieldWidth
            })))));
    };
    const $7bfb3f011550a53d$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        pointerEvents: 'none'
    });
    const $7bfb3f011550a53d$var$layerAlignedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        height: '100%',
        top: '90px',
        pointerEvents: 'initial'
    });
    const $7bfb3f011550a53d$var$emptyStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        width: '100%',
        height: '100%',
        transition: 'opacity 0.2s ease-in-out',
        overflow: 'visible'
    });
});
parcelRegister("8Razh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90556c4b047e5a30$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6sDjx = parcelRequire("6sDjx");
    var $168on = parcelRequire("168on");
    var $90556c4b047e5a30$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $6sDjx.default))((0, $168on.default));
});
parcelRegister("6sDjx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3160c8477313228e$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $4ArTT = parcelRequire("4ArTT");
    const $3160c8477313228e$var$dispatchMethods = (dispatch)=>({
            hideColumn: (id)=>{
                dispatch({
                    type: (0, $4ArTT.HIDE_COLUMN),
                    id: id,
                    meta: {
                        source: (0, $4ArTT.AFM_HIDE_FIELD)
                    }
                });
            },
            showColumn: (id)=>{
                dispatch({
                    type: (0, $4ArTT.SHOW_COLUMN),
                    id: id,
                    meta: {
                        source: (0, $4ArTT.AFM_ADD_FIELD)
                    }
                });
                if (id === 'breakdown' || id === 'progressByEstimation') dispatch((0, $bkasS.fetchHistoricalDoneIssues)());
            },
            moveColumn: (columnToMove, moveToTheIndexOf)=>{
                dispatch((0, $4ArTT.move)({
                    columnToMove: columnToMove,
                    moveToTheIndexOf: moveToTheIndexOf
                }, {
                    source: (0, $4ArTT.AFM_DRAG_FIELD)
                }));
            }
        });
    var $3160c8477313228e$export$2e2bcd8739ae039 = $3160c8477313228e$var$dispatchMethods;
});
parcelRegister("168on", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b29801cb398e12d1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $fVnbM;
    var $dC5iT;
    var $8CUq3;
    var $cvwjV;
    var $koVbs;
    var $ixSW4 = parcelRequire("ixSW4");
    var $fPgrM = parcelRequire("fPgrM");
    var $1lcmX = parcelRequire("1lcmX");
    const $b29801cb398e12d1$var$calculateOpacity = (width)=>{
        if (width >= (0, $f86c4f8964354dbd$export$7bf66c9f4ca32280)) return 1;
        if (width <= (0, $f86c4f8964354dbd$export$289ebd139efb3d0f)) return 0;
        return (width - (0, $f86c4f8964354dbd$export$289ebd139efb3d0f)) / ((0, $f86c4f8964354dbd$export$7bf66c9f4ca32280) - (0, $f86c4f8964354dbd$export$289ebd139efb3d0f));
    };
    const $b29801cb398e12d1$var$EmptyFields = ({ width: width, columns: columns, showColumn: showColumn, moveColumn: moveColumn, hideColumn: hideColumn, getMatchingConfiguredDate: getMatchingConfiguredDate, AdvancedFieldsMenu: AdvancedFieldsMenu })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const renderMenuTrigger = (menuTriggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                ...menuTriggerProps,
                appearance: "primary",
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.empty.trigger-menu-button"
            }, formatMessage((0, $fPgrM.default).addFields));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.empty",
            className: $1lcmX.container,
            style: {
                width: width,
                opacity: $b29801cb398e12d1$var$calculateOpacity(width)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1lcmX.imageGroup
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b29801cb398e12d1$var$imageStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cvwjV")).default), {
            alt: "",
            fill: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("h3", {
            className: (0, ($parcel$interopDefault($9ci4W)))($1lcmX.header, $1lcmX.text)
        }, formatMessage((0, $fPgrM.default).header)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
            className: $1lcmX.text
        }, formatMessage((0, $fPgrM.default).callToAction)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1lcmX.dropdown
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(AdvancedFieldsMenu, {
            id: "empty-view",
            columns: columns,
            hideColumn: hideColumn,
            showColumn: showColumn,
            moveColumn: moveColumn,
            getMatchingConfiguredDate: getMatchingConfiguredDate,
            isShortcutEnabled: false,
            renderMenuTrigger: renderMenuTrigger,
            placement: "right-end"
        }))));
    };
    var $b29801cb398e12d1$export$2e2bcd8739ae039 = (0, $ixSW4.withSlots)({
        AdvancedFieldsMenu: (0, $ixSW4.slots).AdvancedFieldsMenu
    })($b29801cb398e12d1$var$EmptyFields);
    const $b29801cb398e12d1$var$imageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        width: '360px',
        height: '269px'
    });
});
parcelRegister("cvwjV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be4702d69c73c531$export$2e2bcd8739ae039);
    var $dCLgq;
    var $52kLV = parcelRequire("52kLV");
    const $be4702d69c73c531$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($52kLV)),
        srcDark: ($parcel$interopDefault($52kLV)),
        autoDark: false
    });
    var $be4702d69c73c531$export$2e2bcd8739ae039 = $be4702d69c73c531$var$Illustration;
    const $be4702d69c73c531$export$a179c88182cb9d56 = [
        0,
        0,
        335,
        269
    ];
});
parcelRegister("52kLV", function(module, exports) {
    module.exports = new URL("plans-roadmap.8440d94d.svg", import.meta.url).toString();
});
const $f86c4f8964354dbd$export$7bf66c9f4ca32280 = 280;
const $f86c4f8964354dbd$export$289ebd139efb3d0f = 210;
parcelRegister("fPgrM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b72c14618d6760d$export$2e2bcd8739ae039);
    var $7VHMR;
    const $6b72c14618d6760d$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.empty.header",
            "defaultMessage": "Add a column to the view"
        },
        callToAction: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.empty.call-to-action",
            "defaultMessage": "Add columns (or fields) to this view and start planning in more details"
        },
        addFields: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.empty.add-fields",
            "defaultMessage": "Add fields"
        }
    });
    var $6b72c14618d6760d$export$2e2bcd8739ae039 = $6b72c14618d6760d$var$messages;
});
parcelRegister("1lcmX", function(module, exports) {
    $parcel$export(module.exports, "container", ()=>$0fa158e4fa28bbba$export$34e0f9847d4c02dd, (v)=>$0fa158e4fa28bbba$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "dropdown", ()=>$0fa158e4fa28bbba$export$81207e5cc4186890, (v)=>$0fa158e4fa28bbba$export$81207e5cc4186890 = v);
    $parcel$export(module.exports, "header", ()=>$0fa158e4fa28bbba$export$38e42c68cf43b5d4, (v)=>$0fa158e4fa28bbba$export$38e42c68cf43b5d4 = v);
    $parcel$export(module.exports, "imageGroup", ()=>$0fa158e4fa28bbba$export$915392582aa62df4, (v)=>$0fa158e4fa28bbba$export$915392582aa62df4 = v);
    $parcel$export(module.exports, "text", ()=>$0fa158e4fa28bbba$export$6f093cfa640b7166, (v)=>$0fa158e4fa28bbba$export$6f093cfa640b7166 = v);
    var $0fa158e4fa28bbba$export$34e0f9847d4c02dd;
    var $0fa158e4fa28bbba$export$81207e5cc4186890;
    var $0fa158e4fa28bbba$export$38e42c68cf43b5d4;
    var $0fa158e4fa28bbba$export$5c452ff88e35e47d;
    var $0fa158e4fa28bbba$export$915392582aa62df4;
    var $0fa158e4fa28bbba$export$6f093cfa640b7166;
    $0fa158e4fa28bbba$export$34e0f9847d4c02dd = `hgfPNG_container`;
    $0fa158e4fa28bbba$export$81207e5cc4186890 = `hgfPNG_dropdown`;
    $0fa158e4fa28bbba$export$38e42c68cf43b5d4 = `hgfPNG_header`;
    $0fa158e4fa28bbba$export$5c452ff88e35e47d = `hgfPNG_image`;
    $0fa158e4fa28bbba$export$915392582aa62df4 = `hgfPNG_imageGroup`;
    $0fa158e4fa28bbba$export$6f093cfa640b7166 = `hgfPNG_text`;
});
parcelRegister("crwfY", function(module, exports) {
    $parcel$export(module.exports, "ScrollShadowOverlay", ()=>$a82535bb8b966cbc$export$4fe72f1647b95ad6);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $2EwIC;
    const $a82535bb8b966cbc$var$HEADERS_HEIGHT = 90;
    const $a82535bb8b966cbc$var$GROUP_HEADER_HEIGHT = 40;
    const $a82535bb8b966cbc$export$4fe72f1647b95ad6 = ({ hasGroups: hasGroups })=>{
        const [scrollY] = (0, (0, parcelRequire("2EwIC")).useScrollY)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
            layer: (0, $6hYE8.Z_INDEX_LAYER).STICKY_HEADER_SCROLL_SHADOW
        }, (zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.overlay.scroll-shadow.sticky",
                xcss: [
                    $a82535bb8b966cbc$var$stickyStyles,
                    scrollY > 0 && $a82535bb8b966cbc$var$activeStickyStyles
                ],
                style: {
                    zIndex: zIndex
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: [
                    $a82535bb8b966cbc$var$cardStyles,
                    $a82535bb8b966cbc$var$raisedCardStyles
                ],
                style: {
                    height: $a82535bb8b966cbc$var$HEADERS_HEIGHT
                }
            }))), hasGroups && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
            layer: (0, $6hYE8.Z_INDEX_LAYER).STICKY_GROUP_SCROLL_SHADOW
        }, (zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.overlay.scroll-shadow.sticky",
                xcss: [
                    $a82535bb8b966cbc$var$stickyStyles,
                    scrollY > 0 && $a82535bb8b966cbc$var$activeStickyStyles
                ],
                style: {
                    zIndex: zIndex
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: [
                    $a82535bb8b966cbc$var$cardStyles,
                    $a82535bb8b966cbc$var$loweredCardStyles
                ],
                style: {
                    height: $a82535bb8b966cbc$var$HEADERS_HEIGHT + $a82535bb8b966cbc$var$GROUP_HEADER_HEIGHT
                }
            }))));
    };
    const $a82535bb8b966cbc$var$stickyStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky',
        top: 'space.0',
        left: 'space.0',
        width: '100%',
        height: '0',
        pointerEvents: 'none',
        transition: 'opacity 0.1s',
        opacity: 0
    });
    const $a82535bb8b966cbc$var$activeStickyStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        transition: 'opacity 0.2s',
        opacity: 1
    });
    const $a82535bb8b966cbc$var$cardStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxSizing: 'content-box',
        position: 'absolute',
        top: 'space.0',
        left: 'space.0',
        right: 'space.0'
    });
    const $a82535bb8b966cbc$var$loweredCardStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderBottom: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`}`
    });
    const $a82535bb8b966cbc$var$raisedCardStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxShadow: 'elevation.shadow.overflow'
    });
});
parcelRegister("lpjOV", function(module, exports) {
    $parcel$export(module.exports, "ScrollBar", ()=>$a36004d92d78a554$export$342551df3dea21fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $hE4fC;
    var $gFYJC;
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $2EwIC;
    var $8LV9S;
    const $a36004d92d78a554$export$342551df3dea21fb = ({ bottom: bottom })=>{
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [{ viewport: horizontalScrollingViewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [columnWidths] = (0, (0, parcelRequire("8LV9S")).useColumnWidths)({
            preview: true
        });
        const getTimelineLeftOffset = (columnWidths)=>columnWidths.reduce((totalWidth, curWidth, index)=>index < columnWidths.length - 1 ? totalWidth + curWidth : totalWidth, 0);
        const getTimelineWidth = (columnWidths)=>viewport.width - getTimelineLeftOffset(columnWidths);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
            layer: (0, $6hYE8.Z_INDEX_LAYER).HORIZONTAL_SCROLL_BAR
        }, (zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $a36004d92d78a554$var$wrapperStyles,
                style: {
                    left: getTimelineLeftOffset(columnWidths),
                    bottom: bottom,
                    zIndex: zIndex
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $a36004d92d78a554$var$containerStyles,
                role: "scrollbar",
                "aria-valuenow": horizontalScrollingViewport.offset,
                style: {
                    width: getTimelineWidth(columnWidths)
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gFYJC")).default), null))));
    };
    const $a36004d92d78a554$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky'
    });
    const $a36004d92d78a554$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative'
    });
});
parcelRegister("gFYJC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2553e468e8feee0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $76w8V;
    var $5lEJp;
    var $hE4fC;
    function $d2553e468e8feee0$var$useContentBound(useDefaultBound) {
        const [{ viewport: viewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [minimumViewportOffset, setMinimumViewportOffset] = (0, $5uXOq.useState)(1e10);
        const [maximumViewportOffset, setMaximumViewportOffset] = (0, $5uXOq.useState)(-10000000000);
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        const today = new Date(date.getTime());
        date.setFullYear(new Date().getFullYear() - 1);
        const oneYearAgo = new Date(date.getTime());
        date.setFullYear(new Date().getFullYear() + 2);
        const twoYearsLater = new Date(date.getTime());
        date.setFullYear(new Date().getFullYear());
        const [{ msToPx: msToPx, pxToMs: pxToMs }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        const minimumBound = {
            offset: oneYearAgo.getTime() - today.getTime(),
            width: msToPx(twoYearsLater.getTime() - oneYearAgo.getTime())
        };
        const offsetFromValues = [
            viewport.offset,
            minimumBound.offset
        ];
        const offsetToValues = [
            viewport.offset + pxToMs(viewport.width),
            minimumBound.offset + pxToMs(minimumBound.width)
        ];
        if (!useDefaultBound) {
            offsetFromValues.push(minimumViewportOffset);
            offsetToValues.push(maximumViewportOffset);
        }
        const offsetFrom = Math.min(...offsetFromValues);
        const offsetTo = Math.max(...offsetToValues);
        const duration = offsetTo - offsetFrom;
        (0, $5uXOq.useEffect)(()=>{
            setMinimumViewportOffset(offsetFrom);
            setMaximumViewportOffset(offsetTo);
        }, [
            offsetFrom,
            offsetTo
        ]);
        return {
            offset: offsetFrom,
            width: msToPx(duration)
        };
    }
    function $d2553e468e8feee0$var$useDragHandling(trackBarEl, dragHandlerEl) {
        const [{ smooth: smooth, viewport: viewport }, { setViewportOffset: setViewportOffset, setScrollingWithScrollBar: setScrollingWithScrollBar, setSmooth: setSmooth }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
        const [{ pxToMs: pxToMs }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        const triggeredStepRef = (0, $5uXOq.useRef)(false);
        const mouseDownOffsetRef = (0, $5uXOq.useRef)();
        const originalViewportOffsetRef = (0, $5uXOq.useRef)(0);
        const dragHandlerWidthRef = (0, $5uXOq.useRef)(0);
        const handleMouseDownInThumb = (0, $5uXOq.useCallback)((e)=>{
            if (dragHandlerEl === null) return;
            if (e.target !== dragHandlerEl) return;
            setIsDragging(true);
            setScrollingWithScrollBar(true);
            e.preventDefault();
            e.stopPropagation();
            dragHandlerWidthRef.current = dragHandlerEl.getBoundingClientRect().width;
            mouseDownOffsetRef.current = e.clientX;
            originalViewportOffsetRef.current = viewport.offset;
        }, [
            dragHandlerEl,
            viewport.offset,
            setScrollingWithScrollBar
        ]);
        const handleMouseDownInTrack = (0, $5uXOq.useCallback)((e)=>{
            if (trackBarEl === null || dragHandlerEl === null) return;
            if (e.target !== trackBarEl) return;
            const { left: thumbX } = dragHandlerEl.getBoundingClientRect();
            const directionMultiplier = e.clientX < thumbX ? -1 : 1;
            const distance = viewport.width * (0, (0, parcelRequire("5lEJp")).SCROLL_BUTTON_STEP) * directionMultiplier;
            setSmooth(true);
            setViewportOffset((offset)=>offset + pxToMs(distance), 'scrollbar');
            triggeredStepRef.current = true;
            e.preventDefault();
        }, [
            dragHandlerEl,
            pxToMs,
            setSmooth,
            setViewportOffset,
            trackBarEl,
            viewport.width
        ]);
        const handleMouseDown = (0, $5uXOq.useCallback)((e)=>{
            if (dragHandlerEl === null) return;
            if (e.target === dragHandlerEl) return handleMouseDownInThumb(e);
            if (e.target === trackBarEl) return handleMouseDownInTrack(e);
        }, [
            dragHandlerEl,
            handleMouseDownInThumb,
            handleMouseDownInTrack,
            trackBarEl
        ]);
        const handleMouseMove = (0, $5uXOq.useCallback)((e)=>{
            if (mouseDownOffsetRef.current == null) return;
            if (originalViewportOffsetRef.current == null) return;
            const currentMouseOffset = e.clientX;
            const mouseDeltaX = currentMouseOffset - mouseDownOffsetRef.current;
            const distanceInPx = mouseDeltaX / dragHandlerWidthRef.current * viewport.width;
            const nextViewportOffset = originalViewportOffsetRef.current + pxToMs(distanceInPx);
            setViewportOffset(nextViewportOffset, 'scrollbar');
            window.dispatchEvent(new WheelEvent('wheel', {
                deltaX: mouseDeltaX
            }));
        }, [
            setViewportOffset,
            viewport.width,
            pxToMs
        ]);
        const handleMouseUp = (0, $5uXOq.useCallback)(()=>{
            mouseDownOffsetRef.current = undefined;
            setIsDragging(false);
            setScrollingWithScrollBar(false);
        }, [
            setScrollingWithScrollBar
        ]);
        (0, $5uXOq.useEffect)(()=>{
            document.addEventListener('mousedown', handleMouseDown);
            return ()=>document.removeEventListener('mousedown', handleMouseDown);
        }, [
            handleMouseDown
        ]);
        (0, $5uXOq.useEffect)(()=>{
            document.addEventListener('mouseup', handleMouseUp);
            return ()=>document.removeEventListener('mouseup', handleMouseUp);
        }, [
            handleMouseUp
        ]);
        (0, $5uXOq.useEffect)(()=>{
            document.addEventListener('mousemove', handleMouseMove);
            return ()=>document.removeEventListener('mousemove', handleMouseMove);
        }, [
            handleMouseMove
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (smooth && triggeredStepRef.current) {
                setSmooth(false);
                triggeredStepRef.current = false;
            }
        }, [
            setSmooth,
            smooth
        ]);
        return isDragging;
    }
    const $d2553e468e8feee0$var$useDragHandlerStyle = (isDragging)=>{
        const [{ viewport: viewport }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const contentBound = $d2553e468e8feee0$var$useContentBound(!isDragging);
        const scale = viewport.width / contentBound.width;
        const [{ msToPx: msToPx }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        if (viewport.width === 0) return {
            width: 0,
            left: 0
        };
        return {
            width: viewport.width * scale - 7,
            left: msToPx(viewport.offset - contentBound.offset) * scale
        };
    };
    function $d2553e468e8feee0$export$f2f142948c143045() {
        const trackRef = (0, $5uXOq.useRef)(null);
        const thumbRef = (0, $5uXOq.useRef)(null);
        const isDragging = $d2553e468e8feee0$var$useDragHandling(trackRef.current, thumbRef.current);
        const dragHandlerStyle = $d2553e468e8feee0$var$useDragHandlerStyle(isDragging);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("76w8V")).Track), {
            ref: trackRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("76w8V")).Thumb), {
            ref: thumbRef,
            ...dragHandlerStyle
        }));
    }
    function $d2553e468e8feee0$export$2e2bcd8739ae039() {
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        if (zoomLevel === undefined) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d2553e468e8feee0$export$f2f142948c143045, null);
    }
});
parcelRegister("76w8V", function(module, exports) {
    $parcel$export(module.exports, "Track", ()=>$605b04f3cd6747f7$export$13921ac0cc260818);
    $parcel$export(module.exports, "Thumb", ()=>$605b04f3cd6747f7$export$6521433ed15a34db);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $605b04f3cd6747f7$var$SCROLLBAR_HEIGHT = 10;
    const $605b04f3cd6747f7$export$13921ac0cc260818 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _4t3i19bv _bfhkqzid _2rko19bv _1ltvidpf _1xi2idpf _94n5idpf _o7ks5r0a _irr31fy5",
                __cmplp.className
            ])
        });
    });
    const $605b04f3cd6747f7$export$6521433ed15a34db = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { left: left, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_6f8077": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}px`),
                "--_159zbtr": (0, (0, parcelRequire("lD23V")).default)(`translateX(${__cmplp.left}px)`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1hdq _t9ec1vqn _kqswstnw _4t3i19bv _2rko19bv _bfhk70z6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("l64uT", function(module, exports) {
    $parcel$export(module.exports, "AddFields", ()=>$dd10c30376328417$export$8f28f5cfc721d377);
    var $bC2fB;
    var $gpldw = parcelRequire("gpldw");
    var $bvoLt = parcelRequire("bvoLt");
    var $5q20n = parcelRequire("5q20n");
    const $dd10c30376328417$export$8f28f5cfc721d377 = (0, (0, parcelRequire("bC2fB")).connect)((0, $bvoLt.mapStateToProps), (0, $gpldw.default))((0, $5q20n.AddFields));
});
parcelRegister("gpldw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69f8f180c392c3b4$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $4ArTT = parcelRequire("4ArTT");
    const $69f8f180c392c3b4$var$dispatchMethods = (dispatch)=>({
            hideColumn: (id)=>{
                dispatch({
                    type: (0, $4ArTT.HIDE_COLUMN),
                    id: id,
                    meta: {
                        source: (0, $4ArTT.AFM_HIDE_FIELD)
                    }
                });
            },
            showColumn: (id)=>{
                dispatch({
                    type: (0, $4ArTT.SHOW_COLUMN),
                    id: id,
                    meta: {
                        source: (0, $4ArTT.AFM_ADD_FIELD)
                    }
                });
                if (id === 'breakdown' || id === 'progressByEstimation') dispatch((0, $bkasS.fetchHistoricalDoneIssues)());
            },
            moveColumn: (columnToMove, moveToTheIndexOf)=>{
                dispatch((0, $4ArTT.move)({
                    columnToMove: columnToMove,
                    moveToTheIndexOf: moveToTheIndexOf
                }, {
                    source: (0, $4ArTT.AFM_DRAG_FIELD)
                }));
            }
        });
    var $69f8f180c392c3b4$export$2e2bcd8739ae039 = $69f8f180c392c3b4$var$dispatchMethods;
});
parcelRegister("bvoLt", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$fd1218e6707627fe$export$c31df4bd766f9c35);
    var $1CGdp = parcelRequire("1CGdp");
    var $bHTqr = parcelRequire("bHTqr");
    var $kWDpn = parcelRequire("kWDpn");
    var $g7bEf = parcelRequire("g7bEf");
    var $3YtPS = parcelRequire("3YtPS");
    const $fd1218e6707627fe$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        columns: (0, $g7bEf.getColumns),
        dateConfiguration: (0, $bHTqr.getDateConfiguration),
        isExportMode: $1CGdp.isExportMode,
        isConfluenceMacro: $1CGdp.isConfluenceMacro,
        viewMode: (0, $kWDpn.getViewMode)
    });
});
parcelRegister("5q20n", function(module, exports) {
    $parcel$export(module.exports, "AddFields", ()=>$3fccd68298a99a76$export$8f28f5cfc721d377);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $3J2mc;
    var $l9sxf = parcelRequire("l9sxf");
    var $4Hrpg = parcelRequire("4Hrpg");
    var $d3UHJ = parcelRequire("d3UHJ");
    var $2EgSf = parcelRequire("2EgSf");
    const $3fccd68298a99a76$export$8f28f5cfc721d377 = ({ isExportMode: isExportMode, isConfluenceMacro: isConfluenceMacro, columns: columns, hideColumn: hideColumn, showColumn: showColumn, moveColumn: moveColumn, dateConfiguration: dateConfiguration, viewMode: viewMode })=>{
        const visibleColumns = (0, $5uXOq.useMemo)(()=>columns.filter((column)=>column.isVisible), [
            columns
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const renderMenuTrigger = (menuTriggerProps)=>viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4Hrpg.default), {
                numberOfVisibleFields: visibleColumns.length,
                ...menuTriggerProps
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        const renderEmptyFields = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $3fccd68298a99a76$var$textContainerStyles
            }, formatMessage((0, $2EgSf.default).noFields));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $3fccd68298a99a76$var$containerStyles,
            "data-test-class": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.field.header"
        }, !isExportMode && !isConfluenceMacro ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $l9sxf.default), {
            id: "add-fields-header",
            columns: columns,
            hideColumn: hideColumn,
            showColumn: showColumn,
            moveColumn: moveColumn,
            getMatchingConfiguredDate: (0, $d3UHJ.getMatchingConfiguredDate)(dateConfiguration),
            isShortcutEnabled: false,
            renderMenuTrigger: renderMenuTrigger
        }), viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST && visibleColumns.length === 1 && renderEmptyFields(), viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE && visibleColumns.length === 0 && renderEmptyFields()) : undefined);
    };
    const $3fccd68298a99a76$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box'
    });
    const $3fccd68298a99a76$var$textContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.150',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
});
parcelRegister("4Hrpg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ce5d51bb0267f79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k9tnV;
    var $fVnbM;
    var $9lMrf;
    var $koVbs;
    var $1XJ20;
    var $ihPUd = parcelRequire("ihPUd");
    var $5tLMo = parcelRequire("5tLMo");
    const $5ce5d51bb0267f79$var$AdvancedFieldsTrigger = (0, $5uXOq.forwardRef)(({ numberOfVisibleFields: numberOfVisibleFields, isSelected: isSelected, ...menuTriggerProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const previousNumberOfVisibleFields = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(numberOfVisibleFields);
        (0, $5uXOq.useEffect)(()=>{
            const couldExceedViewport = numberOfVisibleFields > previousNumberOfVisibleFields;
            if (wrapperRef.current && isSelected && couldExceedViewport) (0, (0, parcelRequire("k9tnV")).default)(wrapperRef.current, (0, $5tLMo.SCROLL_OPTIONS));
        }, [
            numberOfVisibleFields,
            previousNumberOfVisibleFields,
            isSelected
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: numberOfVisibleFields > 1 ? '56px' : undefined
            },
            ref: wrapperRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ref: ref,
            ...menuTriggerProps,
            isSelected: isSelected,
            appearance: "default",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-trigger",
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: formatMessage((0, $ihPUd.default).fields)
            })
        }));
    });
    var $5ce5d51bb0267f79$export$2e2bcd8739ae039 = $5ce5d51bb0267f79$var$AdvancedFieldsTrigger;
});
parcelRegister("5tLMo", function(module, exports) {
    $parcel$export(module.exports, "SCROLL_OPTIONS", ()=>$fe6d070e9bf92300$export$a47da6bbcf4c3c28);
    const $fe6d070e9bf92300$export$a47da6bbcf4c3c28 = {
        scrollMode: 'if-needed',
        block: 'end',
        inline: 'end'
    };
});
parcelRegister("2EgSf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b722fec93af7dc8$export$2e2bcd8739ae039);
    var $7VHMR;
    const $9b722fec93af7dc8$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noFields: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.add-fields.no-fields",
            "defaultMessage": "Use the Fields button to add columns to this view."
        }
    });
    var $9b722fec93af7dc8$export$2e2bcd8739ae039 = $9b722fec93af7dc8$var$messages;
});
parcelRegister("4abst", function(module, exports) {
    $parcel$export(module.exports, "FieldSubheader", ()=>$ec5054c487f70188$export$d838025dfc96dd0b);
    var $bC2fB;
    var $8bh9q = parcelRequire("8bh9q");
    var $ia2Gu = parcelRequire("ia2Gu");
    var $9LjuP = parcelRequire("9LjuP");
    const $ec5054c487f70188$export$d838025dfc96dd0b = (0, (0, parcelRequire("bC2fB")).connect)((0, $ia2Gu.default), (0, $8bh9q.default))((0, $9LjuP.FieldSubheader));
});
parcelRegister("8bh9q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9326b945bf2ff1e$export$2e2bcd8739ae039);
    var $dBbgF = parcelRequire("dBbgF");
    const $e9326b945bf2ff1e$var$mapDispatchToProps = (dispatch)=>({
            changeSort: (sorting)=>{
                dispatch((0, $dBbgF.changeSort)({
                    sorting: sorting
                }));
            }
        });
    var $e9326b945bf2ff1e$export$2e2bcd8739ae039 = $e9326b945bf2ff1e$var$mapDispatchToProps;
});
parcelRegister("ia2Gu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$456a623391ba9ee3$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $j0XCX = parcelRequire("j0XCX");
    var $456a623391ba9ee3$export$2e2bcd8739ae039 = (state)=>({
            sorting: (0, $j0XCX.getVisualisationSorting)(state),
            customFields: (0, $19iju.getCustomFields)(state)
        });
});
parcelRegister("9LjuP", function(module, exports) {
    $parcel$export(module.exports, "FieldSubheader", ()=>$2e4f1ccf696693c7$export$d838025dfc96dd0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $eTXmK;
    var $8pJHi = parcelRequire("8pJHi");
    var $dbcp2 = parcelRequire("dbcp2");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $1Cyfv = parcelRequire("1Cyfv");
    var $5kh9d = parcelRequire("5kh9d");
    var $bfc1S = parcelRequire("bfc1S");
    const $2e4f1ccf696693c7$export$d838025dfc96dd0b = ({ title: title, icon: icon, column: column, useColumnToggle: useColumnToggle, customFields: customFields, sorting: sorting, changeSort: changeSort, collapsible: collapsible })=>{
        const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
        const containerRef = (0, $5uXOq.useRef)(null);
        const isSorted = sorting.field === column.attribute;
        const sortDirection = isSorted ? sorting.direction : (0, $TTKUQ.SORT_DIRECTION).ASCENDING;
        const updateSort = (0, $5uXOq.useCallback)(()=>{
            const isCurrentFieldSorted = sorting.field === column.attribute;
            if (isCurrentFieldSorted && sorting.direction === (0, $TTKUQ.SORT_DIRECTION).DESCENDING) {
                (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).SORT_BY_FIELD);
                changeSort((0, $8pJHi.defaultSorting));
            } else {
                const newDirection = sorting.direction === (0, $TTKUQ.SORT_DIRECTION).ASCENDING ? (0, $TTKUQ.SORT_DIRECTION).DESCENDING : (0, $TTKUQ.SORT_DIRECTION).ASCENDING;
                const newSort = (0, $dbcp2.getSortConfiguration)(column.attribute, customFields, isCurrentFieldSorted ? newDirection : (0, $TTKUQ.SORT_DIRECTION).ASCENDING);
                (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).SORT_BY_FIELD);
                changeSort(newSort);
            }
        }, [
            changeSort,
            column.attribute,
            customFields,
            sorting.direction,
            sorting.field
        ]);
        const focusElement = (0, $5uXOq.useCallback)(()=>{
            setIsFocused(true);
        }, []);
        const blurElement = (0, $5uXOq.useCallback)(()=>{
            setIsFocused(false);
        }, []);
        const toggle = useColumnToggle();
        const collapse = (0, $5uXOq.useCallback)(()=>toggle(false), [
            toggle
        ]);
        const onContainerBlur = (0, $5uXOq.useCallback)((event)=>{
            if (containerRef.current && !containerRef.current.contains(event.relatedTarget) && containerRef.current !== event.relatedTarget) blurElement();
        }, [
            blurElement
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $2e4f1ccf696693c7$var$containerStyles,
            onFocus: focusElement,
            onMouseEnter: focusElement,
            onMouseLeave: blurElement,
            onBlur: onContainerBlur,
            "data-test-class": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.field.header"
        }, collapsible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bfc1S.Toggle), {
            onClick: collapse
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $2e4f1ccf696693c7$var$titleStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $2e4f1ccf696693c7$var$fieldTitleStyles
        }, title), icon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $2e4f1ccf696693c7$var$headerContentWrapperStyles
        }, icon)), column.isSortable && (isFocused || isSorted) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5kh9d.Sort), {
            sortDirection: sortDirection,
            onClick: updateSort,
            isSorted: isSorted
        }) : null);
    };
    const $2e4f1ccf696693c7$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 'space.150',
        paddingRight: 'space.150',
        boxSizing: 'border-box'
    });
    const $2e4f1ccf696693c7$var$headerContentWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        pointerEvents: 'initial'
    });
    const $2e4f1ccf696693c7$var$titleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        minWidth: 0,
        pointerEvents: 'none'
    });
    const $2e4f1ccf696693c7$var$fieldTitleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    });
});
parcelRegister("dbcp2", function(module, exports) {
    $parcel$export(module.exports, "getSortConfiguration", ()=>$02d8d8a72b1ee4cb$export$518fef3a003052f);
    $parcel$export(module.exports, "getOptionValueLabels", ()=>$02d8d8a72b1ee4cb$export$e1872e169bf7937e);
    $parcel$export(module.exports, "getStandardFieldsOptions", ()=>$02d8d8a72b1ee4cb$export$f28a1cca332467ab);
    $parcel$export(module.exports, "getCustomFieldsOptions", ()=>$02d8d8a72b1ee4cb$export$9cabfb437de15b20);
    var $5uXOq = parcelRequire("5uXOq");
    var $fZhYM;
    var $lj8SI;
    var $19iju = parcelRequire("19iju");
    var $bstHg = parcelRequire("bstHg");
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $6qpX6 = parcelRequire("6qpX6");
    var $fSBX0 = parcelRequire("fSBX0");
    var $hNd1A = parcelRequire("hNd1A");
    const $02d8d8a72b1ee4cb$export$2c756f10502e9fb9 = (fieldId)=>!(0, $5fACX.BUILT_IN_DATE_FIELDS).includes(fieldId);
    const $02d8d8a72b1ee4cb$export$518fef3a003052f = (fieldId, customFields, direction = (0, $TTKUQ.SORT_DIRECTION).ASCENDING)=>{
        if ($02d8d8a72b1ee4cb$export$2c756f10502e9fb9(fieldId)) {
            const customField = (0, $19iju.getCustomFieldById)(Number(fieldId), customFields);
            if (customField.length === 1) return {
                field: fieldId,
                type: (0, $TTKUQ.CustomFieldTypesToDataType)[customField[0].type.key],
                direction: direction,
                isCustomField: true
            };
        }
        return {
            field: fieldId,
            type: (0, $bstHg.ISSUE_FIELD_TO_TYPE_MAP)[fieldId],
            direction: direction
        };
    };
    const $02d8d8a72b1ee4cb$export$8ec6c1f91252b206 = (attribute, title, dateConfiguration)=>{
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
        if (attribute === baselineStartField.key || attribute === baselineEndField.key) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, title, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $hNd1A.configuredDateLozenge
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, "D")));
        return title;
    };
    const $02d8d8a72b1ee4cb$var$isCustomFieldSortable = (field)=>!!(0, $6qpX6.customFieldColumnProperties)((0, parcelRequire("fZhYM")).default([
            'type',
            'key'
        ], field)).isSortable;
    const $02d8d8a72b1ee4cb$export$e1872e169bf7937e = (intl, customFields, planningUnit)=>({
            ...customFields.reduce((prev, curr)=>Object.assign(prev, {
                    [curr.id]: curr.title
                }), {}),
            [(0, $bstHg.ISSUE_FIELDS).RANK]: intl.formatMessage((0, $fSBX0.default).rank),
            [(0, $bstHg.ISSUE_FIELDS).ASSIGNEE_FIELD]: intl.formatMessage((0, $ihPUd.default).assignee),
            [(0, $bstHg.ISSUE_FIELDS).REPORTER_FIELD]: intl.formatMessage((0, $ihPUd.default).reporter),
            [(0, $bstHg.ISSUE_FIELDS).DUE_DATE]: intl.formatMessage((0, $ihPUd.default).dueDate),
            [(0, $bstHg.ISSUE_FIELDS).PRIORITY_FIELD]: intl.formatMessage((0, $ihPUd.default).priority),
            [(0, $bstHg.ISSUE_FIELDS).STATUS_FIELD]: intl.formatMessage((0, $ihPUd.default).status),
            [(0, $bstHg.ISSUE_FIELDS).ESTIMATE]: intl.formatMessage((0, $fSBX0.default)[planningUnit]),
            [(0, $bstHg.ISSUE_FIELDS).TARGET_START_FIELD]: intl.formatMessage((0, $ihPUd.default).targetStart),
            [(0, $bstHg.ISSUE_FIELDS).TARGET_END_FIELD]: intl.formatMessage((0, $ihPUd.default).targetEnd),
            [(0, $bstHg.ISSUE_FIELDS).TEAM_FIELD]: intl.formatMessage((0, $ihPUd.default).team)
        });
    const $02d8d8a72b1ee4cb$export$f28a1cca332467ab = (dateConfiguration, labels, issuePrioritiesIdList)=>{
        const makeOption = (key, defaultDirection, isDisabled, tooltipContent)=>({
                content: $02d8d8a72b1ee4cb$export$8ec6c1f91252b206(key, labels[key], dateConfiguration),
                id: key,
                isDisabled: isDisabled ?? false,
                label: labels[key],
                tooltipContent: tooltipContent ?? null,
                value: key,
                ...defaultDirection ? {
                    defaultDirection: defaultDirection
                } : {}
            });
        const systemFieldsOptions = [
            makeOption((0, $bstHg.ISSUE_FIELDS).RANK),
            makeOption((0, $bstHg.ISSUE_FIELDS).ASSIGNEE_FIELD),
            makeOption((0, $bstHg.ISSUE_FIELDS).REPORTER_FIELD),
            makeOption((0, $bstHg.ISSUE_FIELDS).DUE_DATE),
            makeOption((0, $bstHg.ISSUE_FIELDS).PRIORITY_FIELD, (0, $TTKUQ.SORT_DIRECTION).DESCENDING, !issuePrioritiesIdList, (0, $ihPUd.default).disabledSortByPriorityTooltip),
            makeOption((0, $bstHg.ISSUE_FIELDS).STATUS_FIELD),
            makeOption((0, $bstHg.ISSUE_FIELDS).ESTIMATE),
            makeOption((0, $bstHg.ISSUE_FIELDS).TARGET_START_FIELD),
            makeOption((0, $bstHg.ISSUE_FIELDS).TARGET_END_FIELD),
            makeOption((0, $bstHg.ISSUE_FIELDS).TEAM_FIELD)
        ];
        return systemFieldsOptions;
    };
    const $02d8d8a72b1ee4cb$export$9cabfb437de15b20 = (customFields, dateConfiguration)=>{
        const customFieldsOptions = (0, $4nDwW.filterMap)($02d8d8a72b1ee4cb$var$isCustomFieldSortable, ({ id: id, title: title })=>({
                id: String(id),
                content: $02d8d8a72b1ee4cb$export$8ec6c1f91252b206(String(id), title, dateConfiguration),
                label: title,
                value: String(id)
            }), customFields);
        return customFieldsOptions;
    };
});
parcelRegister("fSBX0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbe9308bb2d93005$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fbe9308bb2d93005$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sortByLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.sort-by-label",
            "defaultMessage": "Sort by"
        },
        Hours: {
            "id": "simple-plans.view.main.tabs.roadmap.sort-by.option.estimate-hours",
            "defaultMessage": "Estimate (h)"
        },
        Days: {
            "id": "simple-plans.view.main.tabs.roadmap.sort-by.option.estimate-days",
            "defaultMessage": "Estimate (d)"
        },
        StoryPoints: {
            "id": "simple-plans.view.main.tabs.roadmap.sort-by.option.estimate-story-points",
            "defaultMessage": "Story points"
        },
        rank: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.rank",
            "defaultMessage": "Rank (default)"
        },
        ascending: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.ascending",
            "defaultMessage": "Ascending"
        },
        descending: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.descending",
            "defaultMessage": "Descending"
        }
    });
});
parcelRegister("hNd1A", function(module, exports) {
    $parcel$export(module.exports, "configuredDateLozenge", ()=>$cf411db24b9e3306$export$8f64b4dd67ed1dca, (v)=>$cf411db24b9e3306$export$8f64b4dd67ed1dca = v);
    $parcel$export(module.exports, "radioOptions", ()=>$cf411db24b9e3306$export$778efc6049c081e9, (v)=>$cf411db24b9e3306$export$778efc6049c081e9 = v);
    $parcel$export(module.exports, "row", ()=>$cf411db24b9e3306$export$120ff0929b202a6d, (v)=>$cf411db24b9e3306$export$120ff0929b202a6d = v);
    var $cf411db24b9e3306$export$8f64b4dd67ed1dca;
    var $cf411db24b9e3306$export$778efc6049c081e9;
    var $cf411db24b9e3306$export$120ff0929b202a6d;
    $cf411db24b9e3306$export$8f64b4dd67ed1dca = `_1OEXCW_configuredDateLozenge`;
    $cf411db24b9e3306$export$778efc6049c081e9 = `_1OEXCW_radioOptions`;
    $cf411db24b9e3306$export$120ff0929b202a6d = `_1OEXCW_row`;
});
parcelRegister("5kh9d", function(module, exports) {
    $parcel$export(module.exports, "Sort", ()=>$189e9fee048e280d$export$d43f91ac58cde147);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $ls8Y7;
    var $kAObg;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ge2s0 = parcelRequire("ge2s0");
    const $189e9fee048e280d$export$d43f91ac58cde147 = ({ sortDirection: sortDirection, onClick: onClick, isSorted: isSorted })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            style: {
                display: 'flex',
                alignItems: 'center',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                padding: 0
            },
            onClick: onClick,
            "aria-label": formatMessage(sortDirection === (0, $TTKUQ.SORT_DIRECTION).ASCENDING ? (0, $ge2s0.default).sortAscAriaLabel : (0, $ge2s0.default).sortDescAriaLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $189e9fee048e280d$var$alignedStyles,
            style: {
                color: isSorted ? undefined : `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})`
            }
        }, sortDirection === (0, $TTKUQ.SORT_DIRECTION).ASCENDING ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kAObg"))))), {
            size: "small",
            label: ""
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ls8Y7"))))), {
            size: "small",
            label: ""
        })));
    };
    const $189e9fee048e280d$var$alignedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'block',
        marginTop: 'space.025',
        marginLeft: 'space.negative.025'
    });
});
parcelRegister("ls8Y7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f9e32b81d01f795b$var$_react = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f9e32b81d01f795b$var$_arrowDown = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("cC5ib")));
    function $f9e32b81d01f795b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f9e32b81d01f795b$var$ArrowDownIcon = (props)=>$f9e32b81d01f795b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
        }, props, {
            newIcon: $f9e32b81d01f795b$var$_arrowDown.default
        }));
    $f9e32b81d01f795b$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
    var $f9e32b81d01f795b$var$_default = module.exports.default = $f9e32b81d01f795b$var$ArrowDownIcon;
});
parcelRegister("cC5ib", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $92ed238f23140736$var$_UNSAFE_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $92ed238f23140736$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $92ed238f23140736$var$ArrowDownIcon = (props)=>$92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1v12.75m-5-4.5 5 5 5-5"/>`
        }, props));
    $92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
    var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;
});
parcelRegister("kAObg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $efde1844fc0ef421$var$_react = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $efde1844fc0ef421$var$_arrowUp = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("kcHZS")));
    function $efde1844fc0ef421$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $efde1844fc0ef421$var$ArrowUpIcon = (props)=>$efde1844fc0ef421$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
        }, props, {
            newIcon: $efde1844fc0ef421$var$_arrowUp.default
        }));
    $efde1844fc0ef421$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
    var $efde1844fc0ef421$var$_default = module.exports.default = $efde1844fc0ef421$var$ArrowUpIcon;
});
parcelRegister("kcHZS", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb570e807ab2e210$var$_UNSAFE_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eb570e807ab2e210$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>$eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
        }, props));
    $eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
    var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;
});
parcelRegister("ge2s0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51458e09464ff881$export$2e2bcd8739ae039);
    var $7VHMR;
    var $51458e09464ff881$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sortAscAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.field.sort.sort-asc-aria-label",
            "defaultMessage": "Sorted in ascending direction"
        },
        sortDescAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.field.sort.sort-desc-aria-label",
            "defaultMessage": "Sorted in descending direction"
        }
    });
});
parcelRegister("bfc1S", function(module, exports) {
    $parcel$export(module.exports, "Toggle", ()=>$ceb28aa8e85f7ca3$export$bea8ebba691c5813);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $koVbs;
    var $3ypI1 = parcelRequire("3ypI1");
    const $ceb28aa8e85f7ca3$export$bea8ebba691c5813 = ({ style: style, ...props })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            "aria-label": formatMessage((0, $3ypI1.default).collapseAriaLabel),
            ...props,
            style: {
                position: 'absolute',
                inset: 0,
                borderRadius: 0,
                width: 'auto',
                height: 'auto',
                ...style
            }
        });
    };
});
parcelRegister("3ypI1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18d84ed13d5d8f79$export$2e2bcd8739ae039);
    var $7VHMR;
    var $18d84ed13d5d8f79$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        collapseAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.field.toggle.collapse-aria-label",
            "defaultMessage": "Collapse the column"
        }
    });
});
parcelRegister("ehW3P", function(module, exports) {
    $parcel$export(module.exports, "ScopeSubheader", ()=>$d3b4d391295c33e9$export$f0048d7bc2fa0c8c);
    var $bC2fB;
    var $kJHky = parcelRequire("kJHky");
    var $k6PuV = parcelRequire("k6PuV");
    const $d3b4d391295c33e9$export$f0048d7bc2fa0c8c = (0, (0, parcelRequire("bC2fB")).connect)((0, $kJHky.default), {})((0, $k6PuV.ScopeSubheader));
});
parcelRegister("kJHky", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61f6931b872b8f30$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $jLI87 = parcelRequire("jLI87");
    var $3YtPS = parcelRequire("3YtPS");
    var $61f6931b872b8f30$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $jLI87.getScope),
        (0, $1CGdp.isExportMode),
        (0, $1CGdp.getMode)
    ], ({ startLevelIssues: { rootIssuesCount: rootIssuesCount } }, exportMode, mode)=>({
            rankDigits: rootIssuesCount.toString().length,
            isReadOnly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
            isExportMode: exportMode
        }));
});
parcelRegister("k6PuV", function(module, exports) {
    $parcel$export(module.exports, "ScopeSubheader", ()=>$c874181ccb40f76c$export$f0048d7bc2fa0c8c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $ousew;
    var $koVbs;
    var $fAGMJ;
    var $jLQ0t = parcelRequire("jLQ0t");
    const $c874181ccb40f76c$export$f0048d7bc2fa0c8c = ({ totalSelected: totalSelected, isSelected: isSelected, isReadOnly: isReadOnly, isIndeterminate: isIndeterminate, toggleAllSelected: toggleAllSelected, rankDigits: rankDigits })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c874181ccb40f76c$var$containerStyles
        }, !isReadOnly && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            isChecked: isSelected,
            isIndeterminate: isIndeterminate,
            onChange: toggleAllSelected,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.scope.checkbox",
            ...(0, (0, parcelRequire("4R6GH")).fg)('portfolio-save-view-label-a11y') && {
                'aria-label': formatMessage((0, $jLQ0t.default).selectAllIssueLabel)
            }
        }), isSelected ? (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            style: {
                margin: 0
            },
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.scope.issues-selected-count"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $jLQ0t.default).selectedIssues,
            values: {
                totalSelected: totalSelected
            }
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $c874181ccb40f76c$var$rankHeaderStyles,
            style: {
                marginRight: 10 * rankDigits
            },
            "data-name": "rank-header"
        }, "#")));
    };
    const $c874181ccb40f76c$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        display: 'flex',
        alignItems: 'center',
        gap: 'space.100',
        paddingLeft: 'space.100',
        paddingRight: 'space.100',
        boxSizing: 'border-box'
    });
    const $c874181ccb40f76c$var$rankHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtlest',
        display: 'inline-flex'
    });
});
parcelRegister("jLQ0t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$908b59925870a48d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $908b59925870a48d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        scope: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.scope.scope",
            "defaultMessage": "Scope"
        },
        selectedIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.scope.selected-issues",
            "defaultMessage": "{totalSelected, plural, one {# issue} other {# issues}} selected"
        },
        selectAllIssueLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.subheader.scope.select-all-issue-label",
            "defaultMessage": "Select all issues"
        }
    });
});
parcelRegister("jLmIs", function(module, exports) {
    $parcel$export(module.exports, "TimelineSubheader", ()=>$7490ff90517abcc3$export$6dc3b67c47d61569);
    var $5uXOq = parcelRequire("5uXOq");
    var $fWEk3 = parcelRequire("fWEk3");
    const $7490ff90517abcc3$export$6dc3b67c47d61569 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWEk3.default), null);
});
parcelRegister("dJfym", function(module, exports) {
    $parcel$export(module.exports, "TableToolbar", ()=>$1cd4628e42e110cb$export$6a2d8ec0c309d683);
    var $5uXOq = parcelRequire("5uXOq");
    var $dPzs1;
    var $4R6GH;
    var $99BAr;
    var $ACELo;
    var $3J2mc;
    var $hE4fC;
    var $dCm1o;
    var $ciqMd = parcelRequire("ciqMd");
    var $kWGf6 = parcelRequire("kWGf6");
    var $4lLQW = parcelRequire("4lLQW");
    var $fjsf7 = parcelRequire("fjsf7");
    const $1cd4628e42e110cb$export$6a2d8ec0c309d683 = ({ isCollapsible: isCollapsible, onToggleFullscreen: onToggleFullscreen, isFullscreen: isFullscreen, viewMode: viewMode })=>{
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const toolbarItems = [
            {
                id: 'pan-left-right',
                element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kWGf6.default), {
                    direction: "left"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kWGf6.default), {
                    direction: "right"
                })),
                isVisible: Boolean(zoomLevel && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE),
                showDivider: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') && false
            },
            {
                id: 'today-button',
                element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fjsf7.default), null),
                isVisible: Boolean(zoomLevel && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE),
                showDivider: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') && true
            },
            {
                id: 'timeline-mode-switcher',
                element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4lLQW.default), null),
                isVisible: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE,
                showDivider: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') && false
            },
            {
                id: 'legend',
                element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ciqMd.default), null),
                isVisible: true,
                showDivider: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') && true
            },
            {
                id: 'fullscreen-button',
                element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99BAr")).default), {
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.toolbar.fullscreen",
                    onToggle: onToggleFullscreen,
                    analyticsAttributes: {
                        screenWidth: window.innerWidth,
                        screenHeight: window.innerHeight
                    },
                    withContainerStyles: false,
                    isFullscreen: isFullscreen,
                    isSubtle: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
                }),
                isVisible: true,
                showDivider: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') && false
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ACELo")).JiraBottomRightCornerOutlet), {
            orderFromRight: 2,
            id: "portfolio-3-plans-table-overlay"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dPzs1")).default), {
            items: toolbarItems,
            isCollapsible: isCollapsible
        }));
    };
});
parcelRegister("dPzs1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$009921c45d78ef32$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $42CjB;
    var $czDCn;
    var $8KJVQ;
    var $lRheX;
    var $3dGN0;
    var $4R6GH;
    var $koVbs;
    var $dCm1o;
    var $aaUcm;
    var $6rGzM;
    const $009921c45d78ef32$var$renderItem = (key, component, showDivider)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
            key: key
        }, showDivider && (0, ($parcel$interopDefault($5uXOq))).createElement($009921c45d78ef32$var$Divider, {
            "data-testid": "aais-timeline-toolbar.ui.container.divider"
        }), component);
    const $009921c45d78ef32$var$Toolbar = ({ items: items, isCollapsible: isCollapsible = true })=>{
        const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(true);
        const toggleIsExpanded = (0, $5uXOq.useCallback)(()=>{
            if (isCollapsible) setIsExpanded(!isExpanded);
        }, [
            isExpanded,
            isCollapsible,
            setIsExpanded
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isExpanded && !isCollapsible) setIsExpanded(true);
        }, [
            isExpanded,
            isCollapsible,
            setIsExpanded
        ]);
        const renderContent = ()=>items.filter(({ isVisible: isVisible = true })=>isVisible).map(({ id: id, element: element, showDivider: showDivider }, index)=>{
                return $009921c45d78ef32$var$renderItem(id, element, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && showDivider !== undefined ? showDivider : isCollapsible || index !== 0);
            });
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const COLLAPSED_WIDTH = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? '0px' : '32px';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($009921c45d78ef32$var$TimelineToolbarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6rGzM")).default), {
            isExpanded: isExpanded,
            collapsedWidth: COLLAPSED_WIDTH
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($009921c45d78ef32$var$TimelineToolbarContainer, null, !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && isCollapsible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: "aais-timeline-toolbar.ui.container.expand-button",
            appearance: "subtle",
            onClick: toggleIsExpanded,
            iconBefore: isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8KJVQ"))))), {
                label: formatMessage((0, (0, parcelRequire("aaUcm")).default).expandButtonLabel)
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("czDCn"))))), {
                label: formatMessage((0, (0, parcelRequire("aaUcm")).default).collapseButtonLabel)
            }),
            "aria-expanded": isExpanded,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-toolbar-expand-clicked'
            } : {}
        }), renderContent())), (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            label: isExpanded ? formatMessage((0, (0, parcelRequire("aaUcm")).default).expandButtonLabel) : formatMessage((0, (0, parcelRequire("aaUcm")).default).collapseButtonLabel),
            "aria-expanded": isExpanded,
            testId: "aais-timeline-toolbar.ui.container.expand-button",
            appearance: "subtle",
            onClick: toggleIsExpanded,
            icon: ()=>isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3dGN0"))))), {
                    label: "",
                    color: "currentColor"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lRheX"))))), {
                    label: "",
                    color: "currentColor"
                }),
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-toolbar-expand-clicked'
            } : {}
        }));
    };
    var $009921c45d78ef32$export$2e2bcd8739ae039 = $009921c45d78ef32$var$Toolbar;
    const $009921c45d78ef32$var$Divider = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkb5v6 _4t3i1tcg _1bsbt94y",
                __cmplp.className
            ])
        });
    });
    const $009921c45d78ef32$var$TimelineToolbarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkhp5a _1yt41b66 _1e0c1txw _19ith6cr _2rko1l7b _16qscbcv _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $009921c45d78ef32$var$TimelineToolbarContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulp1b66 _1o9zidpf _1puhidpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("czDCn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $92777c37de6ba579$var$_react = $92777c37de6ba579$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $92777c37de6ba579$var$_chevronLeft = $92777c37de6ba579$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $92777c37de6ba579$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $92777c37de6ba579$var$ChevronLeftCircleIcon = (props)=>$92777c37de6ba579$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></g></svg>`
        }, props, {
            newIcon: $92777c37de6ba579$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $92777c37de6ba579$var$ChevronLeftCircleIcon.displayName = 'ChevronLeftCircleIcon';
    var $92777c37de6ba579$var$_default = module.exports.default = $92777c37de6ba579$var$ChevronLeftCircleIcon;
});
parcelRegister("8KJVQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $65f63fbd27b0c00e$var$_react = $65f63fbd27b0c00e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $65f63fbd27b0c00e$var$_chevronRight = $65f63fbd27b0c00e$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $65f63fbd27b0c00e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $65f63fbd27b0c00e$var$ChevronRightCircleIcon = (props)=>$65f63fbd27b0c00e$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></g></svg>`
        }, props, {
            newIcon: $65f63fbd27b0c00e$var$_chevronRight.default,
            iconType: "utility"
        }));
    $65f63fbd27b0c00e$var$ChevronRightCircleIcon.displayName = 'ChevronRightCircleIcon';
    var $65f63fbd27b0c00e$var$_default = module.exports.default = $65f63fbd27b0c00e$var$ChevronRightCircleIcon;
});
parcelRegister("aaUcm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ec76cd846c1264c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2ec76cd846c1264c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        expandButtonLabel: {
            "id": "aais-timeline-toolbar.container.expand-button-label",
            "defaultMessage": "Expand timeline time period buttons"
        },
        collapseButtonLabel: {
            "id": "aais-timeline-toolbar.container.collapse-button-label",
            "defaultMessage": "Collapse timeline time period buttons"
        }
    });
});
parcelRegister("6rGzM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c037e2fcf2c9120$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $lObw7;
    var $dWt6p;
    var $7XYc4;
    var $dCm1o;
    const $3c037e2fcf2c9120$var$WidthExpander = ({ isExpanded: isExpanded, collapsedWidth: collapsedWidth, children: children })=>{
        const [width, setWidth] = (0, $5uXOq.useState)(isExpanded ? 'auto' : collapsedWidth);
        const prefersReducedMotion = (0, (0, parcelRequire("dWt6p")).useIsReducedMotion)();
        const duration = prefersReducedMotion ? 0 : (0, (0, parcelRequire("lObw7")).mediumDurationMs);
        const isFirstRender = (0, $5uXOq.useRef)(true);
        const state = (0, $5uXOq.useRef)(isExpanded ? 'expanded' : 'collapsed');
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (ref.current === null) return 0, ($parcel$interopDefault($8Rkzz));
            if (isFirstRender.current) {
                isFirstRender.current = false;
                return 0, ($parcel$interopDefault($8Rkzz));
            }
            if (prefersReducedMotion) {
                setWidth(isExpanded ? 'auto' : collapsedWidth);
                return 0, ($parcel$interopDefault($8Rkzz));
            }
            const expandedWidth = `${ref.current.offsetWidth}px`;
            if (state.current === 'transitioning') setWidth(isExpanded ? expandedWidth : collapsedWidth);
            else setWidth(expandedWidth);
            const immediate = setTimeout(()=>{
                if (!isExpanded) setWidth(collapsedWidth);
                state.current = 'transitioning';
            }, 1);
            const afterDuration = setTimeout(()=>{
                if (isExpanded) setWidth('auto');
                state.current = isExpanded ? 'expanded' : 'collapsed';
            }, (0, (0, parcelRequire("lObw7")).mediumDurationMs));
            return ()=>{
                clearTimeout(immediate);
                clearTimeout(afterDuration);
            };
        }, [
            isExpanded,
            collapsedWidth,
            duration,
            prefersReducedMotion
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3c037e2fcf2c9120$var$OuterWrapper, {
            width: width,
            duration: duration,
            "data-testid": "aais-timeline-toolbar.ui.container.width-expander"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3c037e2fcf2c9120$var$InnerWrapper, {
            ref: ref
        }, children));
    };
    var $3c037e2fcf2c9120$export$2e2bcd8739ae039 = $3c037e2fcf2c9120$var$WidthExpander;
    const $3c037e2fcf2c9120$var$OuterWrapperOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { duration: duration, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width),
                "--_7nn7wk": (0, (0, parcelRequire("lD23V")).default)(`width ${__cmplp.duration}ms ${(0, $eba99f58997c09b3$export$c07234257a03d5e9)}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _njlp1rql _1bsb1rkg _v5641lsu",
                __cmplp.className
            ])
        });
    });
    const $3c037e2fcf2c9120$var$OuterWrapperNew = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { duration: duration, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width),
                "--_7nn7wk": (0, (0, parcelRequire("lD23V")).default)(`width ${__cmplp.duration}ms ${(0, $eba99f58997c09b3$export$c07234257a03d5e9)}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _njlp1rql _1bsb1rkg _v5641lsu _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $3c037e2fcf2c9120$var$OuterWrapper = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $3c037e2fcf2c9120$var$OuterWrapperNew, $3c037e2fcf2c9120$var$OuterWrapperOld);
    const $3c037e2fcf2c9120$var$InnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf",
                __cmplp.className
            ])
        });
    });
});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
parcelRegister("99BAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6d923fac0cd07eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $gucb2;
    const $d6d923fac0cd07eb$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle })=>{
        const [isFullscreenState, setIsFullscreenState] = (0, $5uXOq.useState)(isFullscreenProp ?? defaultFullscreen);
        const isFullscreen = isFullscreenProp ?? isFullscreenState;
        const handleToggle = (wasFullscreen, globalStyle)=>{
            onToggle(wasFullscreen, globalStyle);
            setIsFullscreenState(!wasFullscreen);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gucb2")).default), {
            testId: testId,
            onToggle: handleToggle,
            getCustomRefs: getCustomRefs,
            analyticsAttributes: analyticsAttributes,
            withContainerStyles: withContainerStyles,
            defaultFullscreen: defaultFullscreen,
            isFullscreen: isFullscreen,
            renderAsResponsiveButton: renderAsResponsiveButton,
            shouldRenderContent: shouldRenderContent,
            isSubtle: isSubtle
        });
    };
    $d6d923fac0cd07eb$var$FullscreenButton.defaultProps = {
        onToggle: (0, ($parcel$interopDefault($8Rkzz))),
        getCustomRefs: ()=>[],
        analyticsAttributes: {}
    };
    var $d6d923fac0cd07eb$export$2e2bcd8739ae039 = $d6d923fac0cd07eb$var$FullscreenButton;
});
parcelRegister("gucb2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f59079bf3589c5a6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $42CjB;
    var $5JpK2;
    var $j2iKG;
    var $3bDjY;
    var $3Tty1;
    var $koVbs;
    var $g7crU;
    var $3HwlS;
    var $8zOmE;
    var $6lmg7;
    var $dCm1o;
    var $gydfO;
    const $f59079bf3589c5a6$var$removeFullScreenStyle = (customRefs)=>{
        document.getElementById('fullscreen-global-style')?.remove();
        if (customRefs) customRefs.forEach((ref)=>{
            if (ref !== null) ref.classList.remove('fullscreen');
        });
    };
    const $f59079bf3589c5a6$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const customRefElements = (0, $5uXOq.useRef)(null);
        const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, (0, parcelRequire("g7crU")).useIsFullscreen)();
        const globalStyle = document.createElement('style');
        const isFullscreen = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
        const handleKeysInFullScreen = (0, $5uXOq.useCallback)((e)=>{
            if (e.target instanceof HTMLElement && ([
                'INPUT',
                'TEXTAREA',
                'SELECT'
            ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
            const shortcutKeysToPrevent = [
                '/',
                'h'
            ];
            if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
            const navigationShortcuts = [
                '1',
                '2',
                '3',
                '4'
            ];
            if (!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
                onToggle(true, globalStyle);
                const customRefs = customRefElements.current;
                $f59079bf3589c5a6$var$removeFullScreenStyle(customRefs);
            }
        }, [
            globalStyle,
            onToggle
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isFullscreen) window?.addEventListener('keydown', handleKeysInFullScreen, true);
            else window?.removeEventListener('keydown', handleKeysInFullScreen, true);
            return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
        }, [
            isFullscreen,
            handleKeysInFullScreen
        ]);
        const createFullScreenStyle = (0, $5uXOq.useCallback)(()=>{
            const customElements = customRefElements.current;
            const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }";
            const hiddenStylesNode = document.createTextNode(hiddenStyles);
            globalStyle.id = 'fullscreen-global-style';
            globalStyle.appendChild(hiddenStylesNode);
            if (customElements) customElements.forEach((ref)=>{
                if (ref !== null) ref.classList.add('fullscreen');
            });
            document.head?.appendChild(globalStyle);
        }, [
            globalStyle
        ]);
        const onClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
                const analyticsAttributes = {
                    ...extraAnalyticsAttributes,
                    expandToFullscreen: !isFullscreenLayout
                };
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
                setIsFullScreenLayout(!isFullscreenLayout);
                onToggle(!isFullscreenLayout);
            } else {
                customRefElements.current = getCustomRefs();
                const customElements = customRefElements.current;
                const analyticsAttributes = {
                    ...extraAnalyticsAttributes,
                    expandToFullscreen: !isFullscreen
                };
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
                onToggle(isFullscreen, globalStyle);
                if (isFullscreen) $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
                else createFullScreenStyle();
            }
        };
        (0, $5uXOq.useEffect)(()=>{
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            if (isFullscreen) createFullScreenStyle();
            else $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
            return ()=>$f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
        }, [
            createFullScreenStyle,
            getCustomRefs,
            isFullscreen
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (defaultFullscreen) createFullScreenStyle();
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) setIsFullScreenLayout(false);
            };
        }, []);
        const renderButtonWithTooltip = ()=>{
            if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                label: isFullscreen ? formatMessage((0, (0, parcelRequire("gydfO")).default).exitFullScreen) : formatMessage((0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                onClick: onClick,
                icon: isFullscreen ? (0, ($parcel$interopDefault((0, parcelRequire("j2iKG"))))) : (0, ($parcel$interopDefault((0, parcelRequire("5JpK2"))))),
                appearance: isSubtle ? 'subtle' : 'default',
                isTooltipDisabled: false
            });
            if (renderAsResponsiveButton && !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lmg7")).ResponsiveButton), {
                label: isFullscreen ? formatMessage((0, (0, parcelRequire("gydfO")).default).exitFullScreen) : formatMessage((0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                icon: isFullscreen ? (0, ($parcel$interopDefault((0, parcelRequire("j2iKG"))))) : (0, ($parcel$interopDefault((0, parcelRequire("5JpK2"))))),
                onClick: onClick,
                testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button'
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage(isFullscreen ? (0, (0, parcelRequire("gydfO")).default).exitFullScreen : (0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                position: "top-end"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                appearance: "subtle",
                onClick: onClick,
                iconBefore: isFullscreen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("j2iKG"))))), {
                    color: "var(--ds-icon, #44546F)",
                    label: formatMessage((0, (0, parcelRequire("gydfO")).default).exitFullScreen),
                    spacing: "spacious"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5JpK2"))))), {
                    color: "var(--ds-icon, #44546F)",
                    label: formatMessage((0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                    spacing: "spacious"
                })
            }));
        };
        const keyMap = {
            z: {
                callback: ()=>{
                    setIsFullScreenLayout(!isFullscreenLayout);
                }
            }
        };
        if (!shouldRenderContent) return null;
        return withContainerStyles ? (0, ($parcel$interopDefault($5uXOq))).createElement($f59079bf3589c5a6$var$FullscreenButtonContainer, {
            "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
        }, renderButtonWithTooltip(), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), {
            keyMap: keyMap
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderButtonWithTooltip(), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), {
            keyMap: keyMap
        }));
    };
    var $f59079bf3589c5a6$export$2e2bcd8739ae039 = $f59079bf3589c5a6$var$FullscreenButton;
    const $f59079bf3589c5a6$var$FullscreenButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1sit",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("j2iKG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ddbcbff50c42c269$var$_react = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ddbcbff50c42c269$var$_shrinkDiagonal = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("8KRBa")));
    var $ddbcbff50c42c269$var$_fitToPage = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("2bcm3")));
    function $ddbcbff50c42c269$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ddbcbff50c42c269$var$ShrinkDiagonalIcon = (props)=>$ddbcbff50c42c269$var$_react.default.createElement($ddbcbff50c42c269$var$_shrinkDiagonal.default, Object.assign({
            LEGACY_fallbackIcon: $ddbcbff50c42c269$var$_fitToPage.default
        }, props));
    $ddbcbff50c42c269$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
    var $ddbcbff50c42c269$var$_default = module.exports.default = $ddbcbff50c42c269$var$ShrinkDiagonalIcon;
});
parcelRegister("8KRBa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $65fc322a3db160cb$var$_react = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $65fc322a3db160cb$var$_UNSAFE_baseNew = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $65fc322a3db160cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $65fc322a3db160cb$var$ShrinkDiagonalIcon = (props)=>$65fc322a3db160cb$var$_react.default.createElement($65fc322a3db160cb$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
        }, props));
    $65fc322a3db160cb$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
    var $65fc322a3db160cb$var$_default = module.exports.default = $65fc322a3db160cb$var$ShrinkDiagonalIcon;
});
parcelRegister("2bcm3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1966313a87133c34$var$_react = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1966313a87133c34$var$_shrinkDiagonal = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("8KRBa")));
    function $1966313a87133c34$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1966313a87133c34$var$MediaServicesFitToPageIcon = (props)=>$1966313a87133c34$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
        }, props, {
            newIcon: $1966313a87133c34$var$_shrinkDiagonal.default
        }));
    $1966313a87133c34$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
    var $1966313a87133c34$var$_default = module.exports.default = $1966313a87133c34$var$MediaServicesFitToPageIcon;
});
parcelRegister("3Tty1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ba57d5dc6c0de0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9IeM0;
    var $4lkOX;
    var $h0GOb;
    var $k4r7E;
    var $9fuVs;
    var $kspvB;
    let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
    let $6ba57d5dc6c0de0a$var$subscription = null;
    const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
        const parentRegistry = (0, $5uXOq.useContext)((0, (0, parcelRequire("9fuVs")).ShortcutRegistryContext)) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                    keyMap: (0, (0, parcelRequire("kspvB")).bindKeyMapWithErrorHandling)(keyMap, location),
                    label: label
                })), [
            label,
            parentRegistry,
            keyMap,
            location
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
            const removeKeyMap = addKeyMap();
            return ()=>{
                removeKeyMap();
                $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
                if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                    $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                    $6ba57d5dc6c0de0a$var$subscription = null;
                }
            };
        }, [
            addKeyMap
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || (0, (0, parcelRequire("h0GOb")).default)().subscribe((0, (0, parcelRequire("4lkOX")).default));
        }, [
            parentRegistry,
            keyMap
        ]);
        return null;
    };
    var $6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, (0, parcelRequire("9IeM0")).useKeyboardShortcutsToggle), ...props })=>{
        const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
        return isEnabled && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
    };
});
parcelRegister("4lkOX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f11d50ddafbb6f85$export$2e2bcd8739ae039);
    var $h0GOb;
    var $k4r7E;
    const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
    var $f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
        const { sequence: sequence, e: e } = keySequence || {};
        const activeKeyMap = (0, (0, parcelRequire("k4r7E")).rootRegistry).getActiveKeyMap();
        if (sequence !== undefined && activeKeyMap[sequence]) {
            activeKeyMap[sequence].callback(e);
            (0, (0, parcelRequire("h0GOb")).flush)();
        } else {
            const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
            if (!isFutureMatchPossible) (0, (0, parcelRequire("h0GOb")).flush)();
        }
    };
});
parcelRegister("h0GOb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$849cd54ac4017470$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "flush", ()=>$849cd54ac4017470$export$4909b86c8034bf73);
    var $kVLXA = parcelRequire("kVLXA");
    var $cab1K = parcelRequire("cab1K");
    parcelRequire("jG6Un");
    parcelRequire("eSGL3");
    parcelRequire("1oQta");
    parcelRequire("4kRRr");
    parcelRequire("d0pqD");
    parcelRequire("iQCJJ");
    parcelRequire("fjPtF");
    parcelRequire("2R2to");
    var $lIZQG;
    const $849cd54ac4017470$var$ignoredKeys = {
        Control: true,
        Meta: true,
        Shift: true,
        Alt: true,
        AltGraph: true,
        CapsLock: true,
        Fn: true,
        FnLock: true,
        Hyper: true,
        NumLock: true,
        OS: true,
        ScrollLock: true,
        Super: true,
        Symbol: true,
        SymbolLock: true
    };
    const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
    const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
    const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
    const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
        const elBlankets = document.querySelectorAll('.aui-blanket');
        if (elBlankets.length === 0) return true;
        const isAllHidden = Array.from(elBlankets || []).every((el)=>{
            if (el.getAttribute('aria-hidden') === 'true' || el.getAttribute('hidden') !== null) return true;
            return false;
        });
        return isAllHidden;
    };
    let $849cd54ac4017470$var$key$;
    const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
    var $849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
        if (!$849cd54ac4017470$var$key$) {
            $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, (0, parcelRequire("lIZQG")).toKeyWithModifiers));
            const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
                if (!key || !seq) return undefined;
                return {
                    sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                    e: key.e
                };
            });
            $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
        }
        return $849cd54ac4017470$var$key$;
    };
    const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
        $849cd54ac4017470$var$flush$.next();
    };
});
parcelRegister("kspvB", function(module, exports) {
    $parcel$export(module.exports, "bindKeyMapWithErrorHandling", ()=>$f9e30ab2465f6f16$export$77477772a9b904da);
    var $dJl1T;
    const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
            try {
                callback(e);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
            }
        };
    const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>Object.keys(keyMap).reduce((map, key)=>({
                ...map,
                [key]: {
                    ...keyMap[key],
                    callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
                }
            }), {});
});
parcelRegister("6lmg7", function(module, exports) {
    $parcel$export(module.exports, "ResponsiveButton", ()=>$aeaed609d1db7293$export$47e82d861696e68c);
    $parcel$export(module.exports, "ResponsiveLinkButton", ()=>$aeaed609d1db7293$export$50fd17babcd996ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $42CjB;
    var $1GGwS;
    var $krXdA;
    var $f5TWP;
    var $1kVqg;
    var $oGXFy;
    var $3bDjY;
    const $aeaed609d1db7293$export$47e82d861696e68c = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
        const mediaQueryBreakpoint = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
        const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kVqg")).Show), {
            below: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            ...restProps,
            icon: icon,
            appearance: appearance ?? 'default',
            label: label,
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
            ref: !isAboveBreakpoint ? ref : undefined,
            spacing: iconButtonSpacing
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kVqg")).Show), {
            above: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            ...restProps,
            iconBefore: icon,
            iconAfter: iconAfter,
            appearance: appearance ?? 'default',
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
            ref: isAboveBreakpoint ? ref : undefined,
            "aria-label": ariaLabel,
            spacing: buttonSpacing
        }, label)));
    });
    const $aeaed609d1db7293$export$50fd17babcd996ef = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
        const mediaQueryBreakpoint = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
        const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kVqg")).Show), {
            below: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("krXdA")).default), {
            ...restProps,
            icon: icon,
            appearance: appearance ?? 'default',
            label: label,
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
            href: restProps.href,
            ref: !isAboveBreakpoint ? ref : undefined,
            spacing: iconButtonSpacing
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kVqg")).Show), {
            above: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1GGwS")).default), {
            ...restProps,
            iconBefore: icon,
            iconAfter: iconAfter,
            appearance: appearance ?? 'default',
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
            href: restProps.href,
            ref: isAboveBreakpoint ? ref : undefined,
            "aria-label": ariaLabel,
            spacing: buttonSpacing
        }, label)));
    });
});
parcelRegister("1GGwS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9768e745d0380796$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhmo0;
    var $fuBHX;
    const $9768e745d0380796$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("fuBHX")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "LinkButton"
        }, baseProps.children);
    };
    const $9768e745d0380796$var$WithRef = (0, $5uXOq.forwardRef)($9768e745d0380796$var$LinkButtonBase);
    const $9768e745d0380796$var$LinkButton = (0, $5uXOq.memo)($9768e745d0380796$var$WithRef);
    var $9768e745d0380796$export$2e2bcd8739ae039 = $9768e745d0380796$var$LinkButton;
});
parcelRegister("1kVqg", function(module, exports) {
    $parcel$export(module.exports, "Show", ()=>$7b5b5f6fd54f1de9$export$f6a3d19be20f5819);
    var $f8Sb3;
    var $8CUq3;
    var $2pf2j;
    function $7b5b5f6fd54f1de9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7b5b5f6fd54f1de9$var$showAboveQueries = (0, (0, parcelRequire("2pf2j")).UNSAFE_buildAboveMediaQueryCSS)({
        display: 'revert'
    });
    const $7b5b5f6fd54f1de9$var$showBelowQueries = (0, (0, parcelRequire("2pf2j")).UNSAFE_buildBelowMediaQueryCSS)({
        display: 'revert'
    });
    const $7b5b5f6fd54f1de9$var$defaultHiddenStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $7b5b5f6fd54f1de9$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
        const resolvedStyles = (0, (0, parcelRequire("8CUq3")).parseXcss)(xcss);
        return (0, (0, parcelRequire("f8Sb3")).jsx)(AsElement, {
            className: resolvedStyles.static,
            css: [
                $7b5b5f6fd54f1de9$var$defaultHiddenStyles,
                above && $7b5b5f6fd54f1de9$var$showAboveQueries[above],
                below && $7b5b5f6fd54f1de9$var$showBelowQueries[below],
                resolvedStyles.emotion
            ]
        }, children);
    };
});
parcelRegister("2pf2j", function(module, exports) {
    $parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", ()=>$f32e5b846e53517d$export$918f8818cfbbeb2c);
    $parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", ()=>$f32e5b846e53517d$export$b2a4e2b0c6417297);
    var $f8Sb3;
    var $eXt4g;
    var $h9kUS;
    const $f32e5b846e53517d$export$918f8818cfbbeb2c = (input)=>{
        return (0, (0, parcelRequire("eXt4g")).UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
                ...acc,
                [breakpoint]: (0, (0, parcelRequire("f8Sb3")).css)({
                    [(0, (0, parcelRequire("h9kUS")).media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
                })
            }), {});
    };
    const $f32e5b846e53517d$export$b2a4e2b0c6417297 = (input)=>{
        return (0, (0, parcelRequire("eXt4g")).UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
            if (breakpoint === 'xxs') return acc;
            return {
                ...acc,
                [breakpoint]: (0, (0, parcelRequire("f8Sb3")).css)({
                    [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
                })
            };
        }, {});
    };
});
parcelRegister("eXt4g", function(module, exports) {
    $parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", ()=>$3f07a1aff81e4a42$export$2d293d9871c38e91);
    const $3f07a1aff81e4a42$export$e5ee4fe8b989fd09 = {
        xxs: {
            gridItemGutter: "var(--ds-space-200, 16px)",
            gridMargin: "var(--ds-space-200, 16px)",
            min: '0rem',
            max: '29.99rem'
        },
        xs: {
            gridItemGutter: "var(--ds-space-200, 16px)",
            gridMargin: "var(--ds-space-200, 16px)",
            min: '30rem',
            max: '47.99rem'
        },
        sm: {
            gridItemGutter: "var(--ds-space-200, 16px)",
            gridMargin: "var(--ds-space-300, 24px)",
            min: '48rem',
            max: '63.99rem'
        },
        md: {
            gridItemGutter: "var(--ds-space-300, 24px)",
            gridMargin: "var(--ds-space-400, 32px)",
            min: '64rem',
            max: '89.99rem'
        },
        lg: {
            gridItemGutter: "var(--ds-space-400, 32px)",
            gridMargin: "var(--ds-space-400, 32px)",
            min: '90rem',
            max: '110.49rem'
        },
        xl: {
            gridItemGutter: "var(--ds-space-400, 32px)",
            gridMargin: "var(--ds-space-500, 40px)",
            min: '110.5rem',
            max: null
        }
    };
    const $3f07a1aff81e4a42$export$2d293d9871c38e91 = Object.keys($3f07a1aff81e4a42$export$e5ee4fe8b989fd09);
    const $3f07a1aff81e4a42$export$b7ed752a57b4177b = $3f07a1aff81e4a42$export$2d293d9871c38e91[0];
});
const $7c15fdea32a398a0$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';
parcelRegister("gydfO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50014cef8f43c127$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50014cef8f43c127$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        enterFullScreen: {
            "id": "platform.fullscreen-button.enter-full-screen",
            "defaultMessage": "Enter full screen"
        },
        exitFullScreen: {
            "id": "platform.fullscreen-button.exit-full-screen",
            "defaultMessage": "Exit full screen"
        }
    });
});
parcelRegister("ACELo", function(module, exports) {
    $parcel$export(module.exports, "JiraBottomRightCornerOutlet", ()=>$8d24666022201b4c$export$ee54e6ed235df65e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7nsd3 = parcelRequire("7nsd3");
    var $heNNl;
    var $hvrWv;
    const $8d24666022201b4c$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
        const portalWrapper = (0, $5uXOq.useRef)(document.createElement('div'));
        const container = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerContainer)();
        if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
        const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerActions)();
        (0, $5uXOq.useEffect)(()=>{
            if (container) {
                const indexToRender = insertBottomRightCornerPortal({
                    orderFromRight: orderFromRight,
                    id: id
                });
                container.insertBefore(portalWrapper.current, container.children[indexToRender]);
            }
            const portalCurrent = portalWrapper.current;
            return ()=>{
                container?.removeChild(portalCurrent);
                removeBottomRightCornerPortal(id);
            };
        }, [
            container,
            id,
            orderFromRight,
            insertBottomRightCornerPortal,
            removeBottomRightCornerPortal
        ]);
        return (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$StyledOutlet, null, children), portalWrapper.current);
    };
    const $8d24666022201b4c$export$ee54e6ed235df65e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "bottom-right-corner-outlet",
            packageName: "jira-bottom-right-corner-controller",
            extraEventData: {
                portalId: props.id
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$OutletWithPortal, props));
    const $8d24666022201b4c$var$StyledOutlet = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1vgl1wug _1ko9pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ciqMd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38e980bb4a321bc7$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bFO6z = parcelRequire("bFO6z");
    var $j8nnD = parcelRequire("j8nnD");
    var $38e980bb4a321bc7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $bFO6z.default), {})((0, $j8nnD.default));
});
parcelRegister("bFO6z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6706162108fca136$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $bHTqr = parcelRequire("bHTqr");
    var $kWDpn = parcelRequire("kWDpn");
    const $6706162108fca136$var$mapStateToProps = (state)=>({
            currentScenarioColor: (0, $bHTqr.getCurrentScenarioColor)(state),
            viewMode: (0, $kWDpn.getViewMode)(state),
            isConfluenceMacro: (0, $1CGdp.isConfluenceMacro)(state),
            isEmbed: (0, $1CGdp.isEmbed)(state)
        });
    var $6706162108fca136$export$2e2bcd8739ae039 = $6706162108fca136$var$mapStateToProps;
});
parcelRegister("j8nnD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d35e5bf8584f5a39$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iyo13;
    var $3sAtt;
    var $aCxG8;
    var $3kWB1;
    var $lkBWh;
    var $kVzk2;
    var $ghIRv;
    var $7Vbz7;
    var $ea93E;
    var $bos4g;
    var $d14FQ;
    var $4R6GH;
    var $koVbs;
    var $3J2mc;
    var $4tmyL = parcelRequire("4tmyL");
    var $1p5w2 = parcelRequire("1p5w2");
    var $2dCdH = parcelRequire("2dCdH");
    const $d35e5bf8584f5a39$export$3c71a014887e3c84 = ({ currentScenarioColor: currentScenarioColor, viewMode: viewMode, isConfluenceMacro: isConfluenceMacro, isEmbed: isEmbed })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const sprintsMessage = formatMessage((0, $2dCdH.default).sprints);
        const rollupMessage = formatMessage((0, $2dCdH.default).rollup);
        const sprintDatesMessage = formatMessage((0, $2dCdH.default).sprintDates);
        const releaseDatesMessage = formatMessage((0, $2dCdH.default).releaseDates);
        const dateFieldsMessage = formatMessage((0, $2dCdH.default).dateFields);
        const unsavedChangeMessage = formatMessage((0, $2dCdH.default).unsavedChange);
        const noEndDateMessage = formatMessage((0, $2dCdH.default).noEndDate);
        const noStartDateMessage = formatMessage((0, $2dCdH.default).noStartDate);
        const rollupBarMessage = formatMessage((0, $2dCdH.default).rollupBar);
        const releasedMessage = formatMessage((0, $2dCdH.default).released);
        const onTrackMessage = formatMessage((0, $2dCdH.default).onTrack);
        const offTrackMessage = formatMessage((0, $2dCdH.default).offTrack);
        const dependencyMessage = formatMessage((0, $2dCdH.default).dependency);
        const dependencyWarningMessage = (0, (0, parcelRequire("4R6GH")).fg)('dependency_visualisation_program_board_fe_and_be') ? formatMessage((0, $2dCdH.default).dependencyOffTrack) : formatMessage((0, $2dCdH.default).dependencyWarning);
        const numberOfDependenciesMessage = formatMessage((0, $2dCdH.default).numberOfDependencies);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCxG8")).default), {
            title: formatMessage((0, $2dCdH.default).general)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("iyo13"))))), {
                size: "medium",
                label: sprintsMessage,
                primaryColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
            }),
            label: sprintsMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d14FQ")).default), {
                label: rollupMessage
            }),
            label: rollupMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ea93E")).SprintDateIcon), null),
            label: sprintDatesMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ea93E")).ReleaseDateIcon), null),
            label: releaseDatesMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ea93E")).DateFieldIcon), null),
            label: dateFieldsMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkBWh")).default), {
                label: unsavedChangeMessage,
                color: currentScenarioColor
            }),
            label: unsavedChangeMessage
        })), (isConfluenceMacro || isEmbed) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1p5w2.default), null), viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (isConfluenceMacro || isEmbed) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4tmyL.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCxG8")).default), {
            title: formatMessage((0, $2dCdH.default).issueBars)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Vbz7")).default), {
                type: "noEndDate"
            }),
            label: noEndDateMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Vbz7")).default), {
                type: "noStartDate"
            }),
            label: noStartDateMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Vbz7")).default), {
                type: "rollupDates"
            }),
            label: rollupBarMessage
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCxG8")).default), {
            title: formatMessage((0, $2dCdH.default).releases)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bos4g")).default), {
                type: "released"
            }),
            label: releasedMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bos4g")).default), {
                type: "unreleased"
            }),
            label: onTrackMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bos4g")).default), {
                type: "overdue-arj"
            }),
            label: offTrackMessage
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCxG8")).default), {
            title: formatMessage((0, $2dCdH.default).dependencies)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVzk2")).default), {
                label: dependencyMessage
            }),
            label: dependencyMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVzk2")).default), {
                label: dependencyMessage,
                withWarning: true
            }),
            label: dependencyWarningMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghIRv")).default), null),
            label: numberOfDependenciesMessage
        }))));
    };
    const $d35e5bf8584f5a39$var$Legend = ({ currentScenarioColor: currentScenarioColor, viewMode: viewMode, isConfluenceMacro: isConfluenceMacro, isEmbed: isEmbed })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3kWB1")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($d35e5bf8584f5a39$export$3c71a014887e3c84, {
            currentScenarioColor: currentScenarioColor,
            viewMode: viewMode,
            isConfluenceMacro: isConfluenceMacro,
            isEmbed: isEmbed
        }));
    };
    var $d35e5bf8584f5a39$export$2e2bcd8739ae039 = $d35e5bf8584f5a39$var$Legend;
});
parcelRegister("iyo13", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d81e080f0024ae1d$var$_react = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d81e080f0024ae1d$var$_sprint = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("8mG85")));
    function $d81e080f0024ae1d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d81e080f0024ae1d$var$SprintIcon = (props)=>$d81e080f0024ae1d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
        }, props, {
            newIcon: $d81e080f0024ae1d$var$_sprint.default
        }));
    $d81e080f0024ae1d$var$SprintIcon.displayName = 'SprintIcon';
    var $d81e080f0024ae1d$var$_default = module.exports.default = $d81e080f0024ae1d$var$SprintIcon;
});
parcelRegister("8mG85", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $61710ed7f2aa84a3$var$_react = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $61710ed7f2aa84a3$var$_UNSAFE_baseNew = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $61710ed7f2aa84a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $61710ed7f2aa84a3$var$SprintIcon = (props)=>$61710ed7f2aa84a3$var$_react.default.createElement($61710ed7f2aa84a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
        }, props));
    $61710ed7f2aa84a3$var$SprintIcon.displayName = 'SprintIcon';
    var $61710ed7f2aa84a3$var$_default = module.exports.default = $61710ed7f2aa84a3$var$SprintIcon;
});
parcelRegister("3sAtt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f375155c0b99249$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $7f375155c0b99249$var$LegendItem = ({ symbol: symbol, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7f375155c0b99249$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($7f375155c0b99249$var$Symbol, null, symbol), label);
    var $7f375155c0b99249$export$2e2bcd8739ae039 = $7f375155c0b99249$var$LegendItem;
    const $7f375155c0b99249$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1n3s _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $7f375155c0b99249$var$Symbol = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _1ul91tcg _4t3igktf _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aCxG8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5fcbebf23dc9490a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $5fcbebf23dc9490a$var$LegendSection = ({ title: title, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($5fcbebf23dc9490a$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1gjq _11c816g6 _vwz4v47k"
            ])
        }, title), children);
    var $5fcbebf23dc9490a$export$2e2bcd8739ae039 = $5fcbebf23dc9490a$var$LegendSection;
    const $5fcbebf23dc9490a$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $5fcbebf23dc9490a$var$TitleStyles = null;
});
parcelRegister("3kWB1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff29bd41aa013e69$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $42CjB;
    var $2Yv61;
    var $1I7E8;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $cSD7y;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $5ojXj;
    var $lq7p7;
    const $ff29bd41aa013e69$var$LegendNew = ({ children: children, appearance: appearance = 'icon', placement: placement = 'top-end', defaultIsOpen: defaultIsOpen = false })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClose = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'legend closed');
            setIsOpen(false);
        }, [
            createAnalyticsEvent,
            setIsOpen
        ]);
        const onToggle = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'legendButton');
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `legend ${isOpen ? 'closed' : 'opened'}`);
            setIsOpen((value)=>!value);
        }, [
            isOpen
        ]);
        const renderTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
            switch(appearance){
                case 'full':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                        ...triggerProps,
                        isSelected: isOpen,
                        onClick: onToggle,
                        iconBefore: (0, ($parcel$interopDefault((0, parcelRequire("2Yv61"))))),
                        ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                            interactionName: 'timeline-legend-trigger-clicked'
                        } : {}
                    }, formatMessage((0, (0, parcelRequire("5ojXj")).default).legend));
                case 'icon':
                default:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                        ...triggerProps,
                        isSelected: isOpen,
                        onClick: onToggle,
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("2Yv61"))))),
                        isTooltipDisabled: false,
                        label: formatMessage((0, (0, parcelRequire("5ojXj")).default).legend),
                        tooltip: {
                            position: 'top'
                        },
                        appearance: "subtle",
                        ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                            interactionName: 'timeline-legend-trigger-clicked'
                        } : {}
                    });
            }
        }, [
            appearance,
            formatMessage,
            isOpen,
            onToggle
        ]);
        const renderContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lq7p7")).default), {
                placement: placement
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $ff29bd41aa013e69$var$legendContentStyles,
                paddingInline: "space.200",
                paddingBlock: "space.250"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.250"
            }, children))), [
            children,
            placement
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            id: "timeline-legend",
            role: "dialog",
            isOpen: isOpen,
            placement: placement,
            onClose: onClose,
            trigger: renderTrigger,
            content: renderContent,
            label: formatMessage((0, (0, parcelRequire("5ojXj")).default).legend),
            shouldUseCaptureOnOutsideClick: true
        });
    };
    const $ff29bd41aa013e69$var$LegendOld = ({ children: children, defaultIsOpen: defaultIsOpen = false })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClose = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'legend closed');
            setIsOpen(false);
        }, [
            createAnalyticsEvent,
            setIsOpen
        ]);
        const onToggle = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'legendButton');
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `legend ${isOpen ? 'closed' : 'opened'}`);
            setIsOpen((value)=>!value);
        }, [
            isOpen
        ]);
        const renderContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lq7p7")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $ff29bd41aa013e69$var$legendContentStyles,
                paddingInline: "space.200",
                paddingBlock: "space.250"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.250"
            }, children))), [
            children
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            isOpen: isOpen,
            placement: "top-end",
            onClose: onClose,
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    onClick: onToggle,
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("2Yv61"))))),
                    isTooltipDisabled: false,
                    label: formatMessage((0, (0, parcelRequire("5ojXj")).default).legend),
                    tooltip: {
                        position: 'top'
                    },
                    appearance: "subtle",
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-legend-trigger-clicked'
                    } : {}
                }),
            content: renderContent,
            label: formatMessage((0, (0, parcelRequire("5ojXj")).default).legend),
            id: "timeline-legend",
            role: "dialog",
            shouldUseCaptureOnOutsideClick: true
        });
    };
    var $ff29bd41aa013e69$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $ff29bd41aa013e69$var$LegendNew, $ff29bd41aa013e69$var$LegendOld);
    const $ff29bd41aa013e69$var$legendContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxSizing: 'content-box',
        minWidth: `calc(${"var(--ds-space-100, 8px)"} * 35)`
    });
});
parcelRegister("5ojXj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4294c1079fc57a08$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4294c1079fc57a08$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        legend: {
            "id": "aais-timeline-legend.legend.legend-button.legend",
            "defaultMessage": "Legend"
        }
    });
});
parcelRegister("lq7p7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5de49db51bebb14b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cSD7y;
    const $5de49db51bebb14b$var$DEFAULT_OFFSET = 24;
    const $5de49db51bebb14b$var$ShrinkToFitNew = ({ children: children, placement: placement = 'top-end' })=>{
        const [offset, setOffset] = (0, $5uXOq.useState)({
            top: $5de49db51bebb14b$var$DEFAULT_OFFSET,
            bottom: $5de49db51bebb14b$var$DEFAULT_OFFSET
        });
        const rootRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const animationFrame = requestAnimationFrame(()=>{
                if (!rootRef.current) return;
                const rect = rootRef.current.getBoundingClientRect();
                const distanceFromTop = rect.top;
                const distanceFromBottom = window.innerHeight - rect.bottom;
                if (placement.startsWith('top')) setOffset({
                    top: $5de49db51bebb14b$var$DEFAULT_OFFSET,
                    bottom: distanceFromBottom
                });
                else setOffset({
                    top: distanceFromTop,
                    bottom: $5de49db51bebb14b$var$DEFAULT_OFFSET
                });
            });
            return ()=>cancelAnimationFrame(animationFrame);
        }, [
            placement
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: rootRef,
            style: {
                maxHeight: `calc(100vh - ${offset.bottom}px - ${offset.top}px)`
            }
        }, children);
    };
    const $5de49db51bebb14b$var$ShrinkToFitOld = ({ children: children })=>{
        const [bottomOffset, setBottomOffset] = (0, $5uXOq.useState)($5de49db51bebb14b$var$DEFAULT_OFFSET);
        const rootRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const animationFrame = requestAnimationFrame(()=>{
                if (!rootRef.current) return;
                const rect = rootRef.current.getBoundingClientRect();
                const distanceFromBottom = window.innerHeight - rect.bottom;
                setBottomOffset(distanceFromBottom);
            });
            return ()=>cancelAnimationFrame(animationFrame);
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: rootRef,
            style: {
                maxHeight: `calc(100vh - ${bottomOffset}px - ${$5de49db51bebb14b$var$DEFAULT_OFFSET}px)`
            }
        }, children);
    };
    var $5de49db51bebb14b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $5de49db51bebb14b$var$ShrinkToFitNew, $5de49db51bebb14b$var$ShrinkToFitOld);
});
parcelRegister("lkBWh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7db15e4c17fa9904$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $7db15e4c17fa9904$var$getIconContents = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            points: "10,6  18,6  18,14",
            fill: "currentColor"
        }));
    const $7db15e4c17fa9904$var$ChangeIndicatorIcon = ({ label: label, color: color = `var(--ds-icon-warning, ${0, $829f609a65d26a98$export$59619663aa6500fb})` })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $7db15e4c17fa9904$var$getIconContents,
            size: "medium",
            label: label,
            primaryColor: color
        });
    var $7db15e4c17fa9904$export$2e2bcd8739ae039 = $7db15e4c17fa9904$var$ChangeIndicatorIcon;
});
parcelRegister("kVzk2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52379331d4ac5ab1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $7WxSP;
    const $52379331d4ac5ab1$var$DependenciesIcon = ({ label: label, withWarning: withWarning = false })=>withWarning ? (0, ($parcel$interopDefault($5uXOq))).createElement($52379331d4ac5ab1$var$Container, {
            backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7WxSP"))))), {
            size: "medium",
            key: "dependencies",
            label: label,
            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7WxSP"))))), {
            size: "medium",
            key: "dependencies",
            label: label
        });
    var $52379331d4ac5ab1$export$2e2bcd8739ae039 = $52379331d4ac5ab1$var$DependenciesIcon;
    const $52379331d4ac5ab1$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1hphqkz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz15cr _bfhk3qkl _1bsbgktf _4t3igktf _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ghIRv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ead97f8ea075edd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $6ead97f8ea075edd$var$DependenciesIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($6ead97f8ea075edd$var$Container, null, "1");
    var $6ead97f8ea075edd$export$2e2bcd8739ae039 = $6ead97f8ea075edd$var$DependenciesIcon;
    const $6ead97f8ea075edd$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz15cr _bfhkl0rj _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7Vbz7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83cb82dc26d6c7bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $83cb82dc26d6c7bc$var$getIssueBarContents = (type)=>{
        const color = `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`;
        switch(type){
            case 'noStartDate':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "53",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
                    id: "noStartDate",
                    gradientUnits: "userSpaceOnUse"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
                    stopColor: color,
                    stopOpacity: "0"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
                    offset: ".75",
                    stopColor: color
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "53",
                    height: "16",
                    rx: "3",
                    fill: "url(#noStartDate)"
                }));
            case 'noEndDate':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "53",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
                    id: "noEndDate",
                    gradientUnits: "userSpaceOnUse"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
                    offset: "0.25",
                    stopColor: color
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
                    offset: "1",
                    stopColor: color,
                    stopOpacity: "0"
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "53",
                    height: "16",
                    rx: "3",
                    fill: "url(#noEndDate)"
                }));
            case 'rollupDates':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "53",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("pattern", {
                    id: "rollupDates",
                    patternUnits: "userSpaceOnUse",
                    width: "12",
                    height: "12",
                    x: "6",
                    y: "0",
                    patternTransform: "rotate(27.5)"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("line", {
                    x1: "3",
                    y1: "0",
                    x2: "3",
                    y2: "12",
                    opacity: "0.5",
                    stroke: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`,
                    strokeWidth: "6"
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "53",
                    height: "16",
                    rx: "3",
                    fill: color
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "53",
                    height: "16",
                    rx: "3",
                    fill: "url(#rollupDates)"
                }));
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "53",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "53",
                    height: "16",
                    rx: "3",
                    fill: color
                }));
        }
    };
    const $83cb82dc26d6c7bc$var$IssueBarIcon = ({ type: type })=>$83cb82dc26d6c7bc$var$getIssueBarContents(type);
    var $83cb82dc26d6c7bc$export$2e2bcd8739ae039 = $83cb82dc26d6c7bc$var$IssueBarIcon;
});
parcelRegister("ea93E", function(module, exports) {
    $parcel$export(module.exports, "DateFieldIcon", ()=>$a6a2101e7d968967$export$541e3c9f51736498);
    $parcel$export(module.exports, "SprintDateIcon", ()=>$a6a2101e7d968967$export$bf7e718e80af79ab);
    $parcel$export(module.exports, "ReleaseDateIcon", ()=>$a6a2101e7d968967$export$c99073909d241ba9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $dC5iT;
    var $8CUq3;
    const $a6a2101e7d968967$var$LetterIcon = ({ letter: letter })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a6a2101e7d968967$var$TextStyles,
            as: "span"
        }, letter));
    const $a6a2101e7d968967$export$541e3c9f51736498 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($a6a2101e7d968967$var$LetterIcon, {
            letter: "D"
        });
    const $a6a2101e7d968967$export$bf7e718e80af79ab = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($a6a2101e7d968967$var$LetterIcon, {
            letter: "S"
        });
    const $a6a2101e7d968967$export$c99073909d241ba9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($a6a2101e7d968967$var$LetterIcon, {
            letter: "R"
        });
    var $a6a2101e7d968967$export$2e2bcd8739ae039 = $a6a2101e7d968967$var$LetterIcon;
    const $a6a2101e7d968967$var$TextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: "var(--ds-space-200, 16px)",
        fontWeight: "var(--ds-font-weight-bold, 700)"
    });
});
parcelRegister("bos4g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b88fff45a0e514a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $cGbU6;
    var $f22iM;
    var $7XYc4;
    var $4R6GH;
    var $dCm1o;
    const $b88fff45a0e514a5$var$getIconColor = (type)=>{
        switch(type){
            case 'released':
                return `var(--ds-icon-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
            case 'unreleased':
                return `var(--ds-icon-information, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
            case 'overdue':
            case 'overdue-arj':
            default:
                return `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
        }
    };
    const $b88fff45a0e514a5$var$getIconContents = (type)=>{
        switch(type){
            case 'released':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M11.707 6.707a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
                    fill: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
                }));
            case 'overdue':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M7 4a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V4Zm1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    fill: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
                }));
            case 'overdue-arj':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: "4",
                    y: "7",
                    width: "8",
                    height: "2",
                    rx: "1",
                    fill: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
                }));
            case 'unreleased':
            default:
                return undefined;
        }
    };
    const $b88fff45a0e514a5$var$ReleaseStatusIconOld = ({ type: type })=>(0, ($parcel$interopDefault($5uXOq))).createElement($b88fff45a0e514a5$var$Container, {
            backgroundColor: $b88fff45a0e514a5$var$getIconColor(type)
        }, $b88fff45a0e514a5$var$getIconContents(type));
    const $b88fff45a0e514a5$var$ReleaseStatusIcon = ({ type: type })=>{
        switch(type){
            case 'released':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($b88fff45a0e514a5$var$Container, {
                    backgroundColor: $b88fff45a0e514a5$var$getIconColor(type)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("f22iM"))))), {
                    label: "",
                    color: "currentColor"
                }));
            case 'overdue':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M0.0175781 8C0.0175478 12.4085 3.59133 15.9823 7.99981 15.9823C12.4083 15.9823 15.9821 12.4085 15.982 8C15.982 3.59155 12.4083 0.0178225 7.99981 0.0178223C3.59136 0.017822 0.0176084 3.59155 0.0175781 8ZM7.24981 9V3.75H8.74981V9H7.24981ZM7.99981 12.25C8.5521 12.25 8.99981 11.8023 8.99981 11.25C8.99981 10.6977 8.5521 10.25 7.99981 10.25C7.44753 10.25 6.99981 10.6977 6.99981 11.25C6.99981 11.8023 7.44753 12.25 7.99981 12.25Z",
                    fill: $b88fff45a0e514a5$var$getIconColor(type)
                }));
            case 'overdue-arj':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($b88fff45a0e514a5$var$Container, {
                    backgroundColor: $b88fff45a0e514a5$var$getIconColor(type)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cGbU6"))))), {
                    label: "",
                    color: "currentColor"
                }));
            case 'unreleased':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($b88fff45a0e514a5$var$Container, {
                    backgroundColor: $b88fff45a0e514a5$var$getIconColor(type)
                });
            default:
                return undefined;
        }
    };
    var $b88fff45a0e514a5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2'), $b88fff45a0e514a5$var$ReleaseStatusIcon, $b88fff45a0e514a5$var$ReleaseStatusIconOld);
    const $b88fff45a0e514a5$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1hphqkz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz15cr _bfhk3qkl _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cGbU6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $93b2a42556cf480d$var$_react = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $93b2a42556cf480d$var$_UNSAFE_baseNew = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $93b2a42556cf480d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $93b2a42556cf480d$var$MinusIcon = (props)=>$93b2a42556cf480d$var$_react.default.createElement($93b2a42556cf480d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M2 8h12"/>`
        }, props));
    $93b2a42556cf480d$var$MinusIcon.displayName = 'MinusIcon';
    var $93b2a42556cf480d$var$_default = module.exports.default = $93b2a42556cf480d$var$MinusIcon;
});
parcelRegister("f22iM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $af18d40ba5b744b4$var$_UNSAFE_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>$af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
            type: 'utility'
        }, props));
    $af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;
});
parcelRegister("d14FQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d07f6596a5e169b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $6d07f6596a5e169b$var$getIconContents = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "m14.586 9-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 11H10a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0v-7a3 3 0 0 1 3-3h4.586Z",
            fill: "currentColor"
        }));
    const $6d07f6596a5e169b$var$RollupIcon = ({ label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $6d07f6596a5e169b$var$getIconContents,
            size: "medium",
            label: label,
            primaryColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
        });
    var $6d07f6596a5e169b$export$2e2bcd8739ae039 = $6d07f6596a5e169b$var$RollupIcon;
});
parcelRegister("4tmyL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95cd298196931639$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hrMOX = parcelRequire("hrMOX");
    var $6XdUI = parcelRequire("6XdUI");
    var $95cd298196931639$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hrMOX.default), {})((0, $6XdUI.default));
});
parcelRegister("hrMOX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$300d50c879f2b6f0$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $7WNtL = parcelRequire("7WNtL");
    var $300d50c879f2b6f0$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        colorByValue: (0, $j0XCX.getColorByValue),
        colorByList: (0, $7WNtL.getColorByList),
        customFields: (0, $19iju.getCustomFields)
    });
});
parcelRegister("7WNtL", function(module, exports) {
    $parcel$export(module.exports, "getColorByList", ()=>$26bc80d4b40e298f$export$6e40936c7fd316af);
    $parcel$export(module.exports, "getColorByLegends", ()=>$26bc80d4b40e298f$export$5420a01b46b86846);
    var $3nPAF;
    var $5nMRY = parcelRequire("5nMRY");
    var $19iju = parcelRequire("19iju");
    var $io4Ja = parcelRequire("io4Ja");
    var $g91SX = parcelRequire("g91SX");
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $dRVQG = parcelRequire("dRVQG");
    var $j0XCX = parcelRequire("j0XCX");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $gITL8 = parcelRequire("gITL8");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $26bc80d4b40e298f$export$7536fdb929ce63f0 = (allTeamsById, colourByValue, colourComponents, colourIssueTypes, colourLabels, colourMaps, colourPriorities, colourSelects, componentsById, customFieldsById, issuePriorities, issueTypesById, projectsById, selectOptionsById, statusCategoryById, teamManagedProjectByIssueTypeId)=>{
        if (colourByValue === (0, $gITL8.colourByOptions).COMPONENT) return colourComponents.reduce((acc, colourComponent)=>{
            if (colourComponent && (0, $4nDwW.isDefined)(colourComponent.colour) && !(0, parcelRequire("3nPAF")).default(colourComponent.colour) && colourComponent.components && !(0, parcelRequire("3nPAF")).default(colourComponent.components)) {
                if (!acc[colourComponent.colour]) acc[colourComponent.colour] = [];
                colourComponent.components.forEach((componentId)=>{
                    if (componentsById[Number(componentId)]) acc[colourComponent.colour || ''].push(componentsById[Number(componentId)].name);
                });
            }
            return acc;
        }, {});
        if (colourByValue === (0, $gITL8.colourByOptions).ISSUE_TYPE) return colourIssueTypes.reduce((acc, colourIssueType)=>{
            if (colourIssueType && (0, $4nDwW.isDefined)(colourIssueType.colour) && !(0, parcelRequire("3nPAF")).default(colourIssueType.colour) && colourIssueType.issueTypes && !(0, parcelRequire("3nPAF")).default(colourIssueType.issueTypes)) {
                if (!acc[colourIssueType.colour]) acc[colourIssueType.colour] = [];
                colourIssueType.issueTypes.forEach((issueTypeId)=>{
                    if (issueTypesById[issueTypeId]?.name) {
                        let issueTypeName = issueTypesById[issueTypeId].name;
                        if (teamManagedProjectByIssueTypeId[String(issueTypeId)]?.key) issueTypeName += ` (${teamManagedProjectByIssueTypeId[String(issueTypeId)].key})`;
                        if ((0, $4nDwW.isDefined)(colourIssueType.colour) && !(0, parcelRequire("3nPAF")).default(colourIssueType.colour)) acc[colourIssueType.colour].push(issueTypeName);
                    }
                });
            }
            return acc;
        }, {});
        if (colourByValue === (0, $gITL8.colourByOptions).LABEL) return colourLabels.reduce((acc, colourLabel)=>{
            if (colourLabel && (0, $4nDwW.isDefined)(colourLabel.colour) && !(0, parcelRequire("3nPAF")).default(colourLabel.colour) && colourLabel.labels && !(0, parcelRequire("3nPAF")).default(colourLabel.labels)) {
                if (!acc[colourLabel.colour]) acc[colourLabel.colour] = [];
                colourLabel.labels.forEach((label)=>{
                    acc[colourLabel.colour || ''].push(label);
                });
            }
            return acc;
        }, {});
        if (colourByValue === (0, $gITL8.colourByOptions).PRIORITY) return colourPriorities.reduce((acc, colourPriority)=>{
            if (colourPriority && (0, $4nDwW.isDefined)(colourPriority.colour) && !(0, parcelRequire("3nPAF")).default(colourPriority.colour) && colourPriority.priorities && !(0, parcelRequire("3nPAF")).default(colourPriority.priorities)) {
                if (!acc[colourPriority.colour]) acc[colourPriority.colour] = [];
                colourPriority.priorities.forEach((priorityId)=>{
                    if (issuePriorities[priorityId]) acc[colourPriority.colour || ''].push(issuePriorities[priorityId].name);
                });
            }
            return acc;
        }, {});
        if (colourByValue === (0, $gITL8.colourByOptions).PROJECT) {
            const projectColorMap = colourMaps.project;
            return Object.entries(projectColorMap).reduce((acc, [projectId, colour])=>{
                if (projectsById[projectId]) {
                    const projectColour = String(colour);
                    if (!acc[projectColour]) acc[projectColour] = [];
                    acc[projectColour].push(projectsById[projectId].name);
                }
                return acc;
            }, {});
        }
        if (colourByValue === (0, $gITL8.colourByOptions).STATUS) {
            const statusColorMap = colourMaps.status;
            return Object.entries(statusColorMap).reduce((acc, [id, colour])=>{
                const statusId = Number(id);
                if (statusCategoryById[statusId]) {
                    const statusColour = String(colour);
                    if (!acc[statusColour]) acc[statusColour] = [];
                    acc[statusColour].push(statusCategoryById[statusId].name);
                }
                return acc;
            }, {});
        }
        if (colourByValue === (0, $gITL8.colourByOptions).TEAM) {
            const teamColorMap = colourMaps.team;
            return Object.entries(teamColorMap).reduce((acc, [teamId, colour])=>{
                if (allTeamsById[teamId]) {
                    const teamColour = String(colour);
                    if (!acc[teamColour]) acc[teamColour] = [];
                    acc[teamColour].push(allTeamsById[teamId].title);
                }
                return acc;
            }, {});
        }
        if ((0, $j0XCX.isColorByCustomFieldOption)(colourByValue)) {
            if (!(0, parcelRequire("3nPAF")).default(customFieldsById)) {
                const customFieldType = customFieldsById[colourByValue] && customFieldsById[colourByValue].type && customFieldsById[colourByValue].type.key;
                if ((0, $4nDwW.isDefined)(customFieldType) && (0, $4nDwW.isDefined)(colourSelects[colourByValue])) return colourSelects[colourByValue].reduce((acc, { colour: colour, options: options })=>{
                    if (!(0, $4nDwW.isDefined)(colour)) return acc;
                    if (!(0, parcelRequire("3nPAF")).default(options)) {
                        if (!acc[colour]) acc[colour] = [];
                        if (customFieldType === (0, $TTKUQ.CustomFieldTypes).Labels) options.forEach((optionLabel)=>{
                            acc[colour].push(optionLabel);
                        });
                        else options.forEach((optionId)=>{
                            if (selectOptionsById[optionId]) acc[colour].push(selectOptionsById[optionId].value);
                        });
                    }
                    return acc;
                }, {});
            }
        }
        return {};
    };
    const $26bc80d4b40e298f$export$6e40936c7fd316af = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getAllTeamsById),
        (0, $j0XCX.getColorByValue),
        (0, $j0XCX.getColourComponents),
        (0, $j0XCX.getColourIssueTypes),
        (0, $j0XCX.getColourLabels),
        (0, $j0XCX.getColourMaps),
        (0, $j0XCX.getColourPriorities),
        (0, $j0XCX.getColourSelects),
        (0, $5nMRY.getComponentsById),
        (0, $19iju.getCustomFieldsById),
        (0, $io4Ja.getIssuePriorities),
        (0, $kllqP.getIssueTypesById),
        (0, $jpXKt.getProjectsById),
        (0, $19iju.getSelectOptionsById),
        (0, $g91SX.getStatusCategoryById),
        (0, $kllqP.getTeamManagedProjectByIssueTypeId)
    ], $26bc80d4b40e298f$export$7536fdb929ce63f0);
    const $26bc80d4b40e298f$export$289386843eb404e7 = (colorByValue, colorByList)=>{
        if (colorByValue === (0, $gITL8.colourByOptions).NONE || !colorByValue) return [];
        if ((0, parcelRequire("3nPAF")).default(colorByList)) return [];
        const colorByLegends = [];
        Object.keys(colorByList).forEach((colorKey)=>{
            colorByLegends.push({
                color: colorKey,
                label: colorByList[colorKey].join(', ')
            });
        });
        return colorByLegends;
    };
    const $26bc80d4b40e298f$export$5420a01b46b86846 = (0, $3YtPS.createSelector)([
        (0, $j0XCX.getColorByValue),
        $26bc80d4b40e298f$export$6e40936c7fd316af
    ], $26bc80d4b40e298f$export$289386843eb404e7);
});
parcelRegister("6XdUI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ca89c8a5545d376$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sAtt;
    var $aCxG8;
    var $94Frv;
    var $koVbs;
    var $j0XCX = parcelRequire("j0XCX");
    var $ajOp6 = parcelRequire("ajOp6");
    var $gITL8 = parcelRequire("gITL8");
    var $ihPUd = parcelRequire("ihPUd");
    var $gM97X = parcelRequire("gM97X");
    const $0ca89c8a5545d376$var$ColourByLegend = ({ colorByList: colorByList, colorByValue: colorByValue, customFields: customFields })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const colorByValueTitle = (0, $5uXOq.useMemo)(()=>{
            if (colorByValue === (0, $gITL8.colourByOptions).NONE || !colorByValue) return;
            if (Object.keys(colorByList).length === 0) return;
            const optionMessages = {
                ...(0, $ajOp6.default),
                allOtherIssues: (0, $ihPUd.default).allOtherIssues,
                issueType: (0, $ihPUd.default).issueType,
                label: (0, $ihPUd.default).label
            };
            if (!(0, $j0XCX.isColorByCustomFieldOption)(colorByValue)) return formatMessage(optionMessages[colorByValue]);
            const customField = customFields.find((field)=>field.id === Number(colorByValue));
            if (customField) return customField.title;
        }, [
            colorByList,
            colorByValue,
            customFields,
            formatMessage
        ]);
        if (!colorByValueTitle) return null;
        const showAllOtherIssuesColorLabel = colorByValue === (0, $gITL8.colourByOptions).COMPONENT || colorByValue === (0, $gITL8.colourByOptions).ISSUE_TYPE || colorByValue === (0, $gITL8.colourByOptions).LABEL || colorByValue === (0, $gITL8.colourByOptions).PRIORITY || (0, $j0XCX.isColorByCustomFieldOption)(colorByValue);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCxG8")).default), {
            title: formatMessage((0, $gM97X.default).colorBy, {
                colorByValueTitle: colorByValueTitle
            })
        }, showAllOtherIssuesColorLabel && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
            key: 0,
            symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("94Frv")).default), {
                backgroundColor: (0, $gITL8.DEFAULT_COLOR)
            }),
            label: formatMessage((0, $ihPUd.default).allOtherIssues)
        }), Object.entries(colorByList).map(([color, labels], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
                key: index,
                symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("94Frv")).default), {
                    backgroundColor: color
                }),
                label: labels.join(', ')
            })));
    };
    var $0ca89c8a5545d376$export$2e2bcd8739ae039 = $0ca89c8a5545d376$var$ColourByLegend;
});
parcelRegister("94Frv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dff9b2a02354a15b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $dff9b2a02354a15b$var$ColourByIcon = ({ backgroundColor: backgroundColor })=>(0, ($parcel$interopDefault($5uXOq))).createElement($dff9b2a02354a15b$var$Icon, {
            backgroundColor: backgroundColor
        });
    var $dff9b2a02354a15b$export$2e2bcd8739ae039 = $dff9b2a02354a15b$var$ColourByIcon;
    const $dff9b2a02354a15b$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1hphqkz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbpxbi _4t3ipxbi _2rkogqwt _bfhk3qkl",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ajOp6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ca288ad4e7e64ea$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5ca288ad4e7e64ea$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        colorBy: {
            "id": "portfolio-3-portfolio.common.color-by-legend.color-by",
            "defaultMessage": "Color by"
        },
        team: {
            "id": "portfolio-3-portfolio.common.color-by-legend.team",
            "defaultMessage": "Team"
        },
        priority: {
            "id": "portfolio-3-portfolio.common.color-by-legend.priority",
            "defaultMessage": "Priority"
        },
        project: {
            "id": "portfolio-3-portfolio.common.color-by-legend.project",
            "defaultMessage": "Project"
        },
        component: {
            "id": "portfolio-3-portfolio.common.color-by-legend.component",
            "defaultMessage": "Component"
        },
        status: {
            "id": "portfolio-3-portfolio.common.color-by-legend.status",
            "defaultMessage": "Status"
        },
        none: {
            "id": "portfolio-3-portfolio.common.color-by-legend.none",
            "defaultMessage": "None"
        }
    });
});
parcelRegister("gM97X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc1423451a7d6e2b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bc1423451a7d6e2b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        colorBy: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.color-by-legend.color-by",
            "defaultMessage": "Color by ({colorByValueTitle})"
        }
    });
});
parcelRegister("1p5w2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4770755bf6aa255$export$2e2bcd8739ae039);
    var $bC2fB;
    var $9q15i = parcelRequire("9q15i");
    var $io2Kd = parcelRequire("io2Kd");
    var $e4770755bf6aa255$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $9q15i.mapStateToProps), {})((0, $io2Kd.default));
});
parcelRegister("9q15i", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$794734d8951b90e8$export$c31df4bd766f9c35);
    var $6Ayrn = parcelRequire("6Ayrn");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $3YtPS = parcelRequire("3YtPS");
    const $794734d8951b90e8$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        enrichedHierarchyLevels: (0, $6Ayrn.getEnrichedHierarchyLevels),
        filteredIssues: (0, $bI9dZ.getFilteredIssues)
    });
});
parcelRegister("io2Kd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2be0c740bb44710a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sAtt;
    var $aCxG8;
    var $dL3Nz;
    var $koVbs;
    var $joTBk = parcelRequire("joTBk");
    const $2be0c740bb44710a$var$IssueTypesLegend = ({ enrichedHierarchyLevels: enrichedHierarchyLevels, filteredIssues: filteredIssues })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const issueTypes = (0, $5uXOq.useMemo)(()=>{
            const visibleIssueTypes = new Set(filteredIssues.map((issue)=>issue.type));
            return [
                ...enrichedHierarchyLevels
            ].sort((a, b)=>a.level - b.level).flatMap((level)=>level.issueTypes).filter((issueType)=>visibleIssueTypes.has(issueType.id));
        }, [
            enrichedHierarchyLevels,
            filteredIssues
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCxG8")).default), {
            title: formatMessage((0, $joTBk.default).issueTypes)
        }, issueTypes.map(({ name: name, iconUrl: iconUrl }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sAtt")).default), {
                key: index,
                symbol: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dL3Nz")).default), {
                    backgroundUrl: iconUrl
                }),
                label: name
            })));
    };
    var $2be0c740bb44710a$export$2e2bcd8739ae039 = $2be0c740bb44710a$var$IssueTypesLegend;
});
parcelRegister("dL3Nz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac335479dcbfe864$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $ac335479dcbfe864$var$IssueTypeIcon = ({ backgroundUrl: backgroundUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement($ac335479dcbfe864$var$Icon, {
            backgroundUrl: backgroundUrl
        });
    var $ac335479dcbfe864$export$2e2bcd8739ae039 = $ac335479dcbfe864$var$IssueTypeIcon;
    const $ac335479dcbfe864$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundUrl: backgroundUrl, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_i1vpsg": (0, (0, parcelRequire("lD23V")).default)(`url('${__cmplp.backgroundUrl}') no-repeat center / cover`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbpxbi _4t3ipxbi _11q7na74",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("joTBk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dd739559adfecc76$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dd739559adfecc76$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTypes: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.issue-types-legend.issue-types",
            "defaultMessage": "Issue types"
        }
    });
});
parcelRegister("2dCdH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fcb4344a7aa59f38$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fcb4344a7aa59f38$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        general: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.general",
            "defaultMessage": "General"
        },
        issueBars: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.issue-bars",
            "defaultMessage": "Issue bars"
        },
        releases: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.releases",
            "defaultMessage": "Releases"
        },
        dependencies: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.dependencies",
            "defaultMessage": "Dependencies"
        },
        sprints: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.sprints",
            "defaultMessage": "Sprints"
        },
        rollup: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.rollup",
            "defaultMessage": "Inferred value (roll-up)"
        },
        sprintDates: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.sprint-dates",
            "defaultMessage": "Sprint dates"
        },
        releaseDates: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.release-dates",
            "defaultMessage": "Release dates"
        },
        dateFields: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.date-fields",
            "defaultMessage": "Date fields"
        },
        unsavedChange: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.unsaved-change",
            "defaultMessage": "Unsaved change"
        },
        noEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.no-end-date",
            "defaultMessage": "No end date"
        },
        noStartDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.no-start-date",
            "defaultMessage": "No start date"
        },
        rollupBar: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.rollup-bar",
            "defaultMessage": "Inferred dates (roll-up)"
        },
        released: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.released",
            "defaultMessage": "Released"
        },
        onTrack: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.on-track",
            "defaultMessage": "On-track"
        },
        offTrack: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.off-track",
            "defaultMessage": "Off-track"
        },
        dependency: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.dependency",
            "defaultMessage": "Dependency"
        },
        dependencyWarning: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.dependency-warning",
            "defaultMessage": "Dependency warning"
        },
        dependencyOffTrack: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.dependency-off-track",
            "defaultMessage": "Off-track dependencies"
        },
        numberOfDependencies: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.number-of-dependencies",
            "defaultMessage": "Number of dependencies"
        }
    });
});
parcelRegister("kWGf6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e762470e2a366126$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ctqwA;
    var $h1TKi;
    var $a88oa;
    var $h1toL;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $aCpcO;
    var $hE4fC;
    var $dCm1o;
    var $eCnM4 = parcelRequire("eCnM4");
    function $e762470e2a366126$export$2e2bcd8739ae039({ direction: direction }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [smooth, { shiftTimeline: shiftTimeline, setSmooth: setSmooth }] = (0, (0, parcelRequire("hE4fC")).useSmooth)();
        const triggeredRef = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (smooth && triggeredRef.current) {
                setSmooth(false);
                triggeredRef.current = false;
            }
        }, [
            setSmooth,
            smooth
        ]);
        let label = formatMessage((0, $eCnM4.default).shiftTimelineLeft);
        let icon = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ctqwA"))))), {
            label: label,
            color: "currentColor"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("a88oa"))))), {
            label: label
        });
        if (direction === 'right') {
            label = formatMessage((0, $eCnM4.default).shiftTimelineRight);
            icon = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h1TKi"))))), {
                label: label,
                color: "currentColor"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h1toL"))))), {
                label: label
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            iconBefore: icon,
            onClick: ()=>{
                setSmooth(true);
                shiftTimeline(direction, 'scrollButton');
                triggeredRef.current = true;
            },
            testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.panning-control.ui.${direction}`
        }));
    }
});
parcelRegister("eCnM4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8a03c18f2709a56$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b8a03c18f2709a56$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shiftTimelineLeft: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.panning-control.shift-timeline-left",
            "defaultMessage": "Shift timeline left"
        },
        shiftTimelineRight: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.panning-control.shift-timeline-right",
            "defaultMessage": "Shift timeline right"
        }
    });
});
parcelRegister("4lLQW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d233a1f564d32c9b$export$2e2bcd8739ae039);
    var $bC2fB;
    var $ifqug = parcelRequire("ifqug");
    var $8gUzP = parcelRequire("8gUzP");
    var $f1oJN = parcelRequire("f1oJN");
    var $d233a1f564d32c9b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $8gUzP.default), (0, $ifqug.default))((0, $f1oJN.default));
});
parcelRegister("ifqug", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b98de3c5d79d555$export$2e2bcd8739ae039);
    var $j33D0 = parcelRequire("j33D0");
    const $2b98de3c5d79d555$var$mapDispatchToProps = (dispatch)=>({
            onTimeScaleCustomDatesChange: (payload)=>{
                dispatch((0, $j33D0.timeScaleCustomDatesChange)(payload));
            },
            onModeChange: (payload)=>{
                dispatch({
                    type: (0, $j33D0.CHANGE_MODE),
                    payload: payload
                });
            }
        });
    var $2b98de3c5d79d555$export$2e2bcd8739ae039 = $2b98de3c5d79d555$var$mapDispatchToProps;
});
parcelRegister("8gUzP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ecb0ff55b1c6a825$export$2e2bcd8739ae039);
    var $jAIJh = parcelRequire("jAIJh");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    const $ecb0ff55b1c6a825$var$getInitialCustomDateRangePure = ({ start: start, end: end })=>({
            fromDate: start,
            toDate: end
        });
    const $ecb0ff55b1c6a825$var$getInitialCustomDateRange = (0, $3YtPS.createSelector)([
        (0, $jAIJh.getTimelineRange)
    ], $ecb0ff55b1c6a825$var$getInitialCustomDateRangePure);
    const $ecb0ff55b1c6a825$export$a53beca3bcfc33c1 = (state)=>({
            customDateRange: (0, $kWDpn.getTimeScaleViewSettings)(state).customDateRange,
            initialCustomDateRange: $ecb0ff55b1c6a825$var$getInitialCustomDateRange(state),
            mode: (0, $kWDpn.getTimeScaleViewSettings)(state).mode
        });
    var $ecb0ff55b1c6a825$export$2e2bcd8739ae039 = $ecb0ff55b1c6a825$export$a53beca3bcfc33c1;
});
parcelRegister("f1oJN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49b895c851dd993b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $1R1Ge;
    var $7QSqG;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $9fuVs;
    var $1wbtX;
    var $koVbs;
    var $lfTZh;
    var $gh61P;
    var $flnZx;
    var $cOhVC;
    var $80HYw;
    var $86zlq;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $kxZPA;
    var $7B9cH = parcelRequire("7B9cH");
    const $49b895c851dd993b$var$LazyTimelineModeSwitcher = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("2lH7Q")), {
        moduleId: "./src/packages/aais/timeline-toolbar/src/ui/timeline-mode-switcher/index.tsx"
    });
    function $49b895c851dd993b$export$2e2bcd8739ae039({ mode: mode = (0, $TTKUQ.TIMELINE_MODES).MONTHS, onModeChange: onModeChange, customDateRange: customDateRange = {}, initialCustomDateRange: initialCustomDateRange = {}, onTimeScaleCustomDatesChange: onTimeScaleCustomDatesChange }) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [isCustomRangeDialogOpen, setCustomRangeDialogOpen] = (0, $5uXOq.useState)(false);
        const onItemClicked = (0, $5uXOq.useCallback)((value)=>{
            if (value === (0, $TTKUQ.TIMELINE_MODES).CUSTOM) {
                setCustomRangeDialogOpen((prev)=>!prev);
                return;
            }
            onModeChange(value);
        }, [
            onModeChange
        ]);
        const onCustomDatesApplied = (range)=>{
            setCustomRangeDialogOpen(false);
            onTimeScaleCustomDatesChange(range);
            onModeChange((0, $TTKUQ.TIMELINE_MODES).CUSTOM, range);
        };
        const getCustomRangeText = (0, $5uXOq.useCallback)(()=>{
            const { fromDate: fromDate, toDate: toDate, typeOfCustomDateRange: typeOfCustomDateRange } = customDateRange;
            if (typeOfCustomDateRange === (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).RELATIVE) {
                const { start: start, end: end } = (0, (0, parcelRequire("flnZx")).getRelativeDates)(customDateRange, new Date());
                return (0, (0, parcelRequire("80HYw")).getStringFromDates)(start, end, intl);
            }
            return (0, (0, parcelRequire("80HYw")).getStringFromDates)(fromDate, toDate, intl);
        }, [
            customDateRange,
            intl
        ]);
        const changeToWeeks = (0, $5uXOq.useCallback)(()=>{
            onItemClicked((0, $TTKUQ.TIMELINE_MODES).WEEKS);
        }, [
            onItemClicked
        ]);
        const changeToMonths = (0, $5uXOq.useCallback)(()=>{
            onItemClicked((0, $TTKUQ.TIMELINE_MODES).MONTHS);
        }, [
            onItemClicked
        ]);
        const changeToQuarters = (0, $5uXOq.useCallback)(()=>{
            onItemClicked((0, $TTKUQ.TIMELINE_MODES).QUARTERS);
        }, [
            onItemClicked
        ]);
        const changeToYears = (0, $5uXOq.useCallback)(()=>{
            onItemClicked((0, $TTKUQ.TIMELINE_MODES).YEARS);
        }, [
            onItemClicked
        ]);
        const changeToCustomRange = (0, $5uXOq.useCallback)(()=>{
            onItemClicked((0, $TTKUQ.TIMELINE_MODES).CUSTOM);
        }, [
            onItemClicked
        ]);
        const changeMode = (mode)=>{
            switch(mode){
                case (0, $TTKUQ.TIMELINE_MODES).WEEKS:
                    onItemClicked((0, $TTKUQ.TIMELINE_MODES).WEEKS);
                    break;
                case (0, $TTKUQ.TIMELINE_MODES).MONTHS:
                    onItemClicked((0, $TTKUQ.TIMELINE_MODES).MONTHS);
                    break;
                case (0, $TTKUQ.TIMELINE_MODES).QUARTERS:
                    onItemClicked((0, $TTKUQ.TIMELINE_MODES).QUARTERS);
                    break;
                case (0, $TTKUQ.TIMELINE_MODES).YEARS:
                    onItemClicked((0, $TTKUQ.TIMELINE_MODES).YEARS);
                    break;
                case (0, $TTKUQ.TIMELINE_MODES).CUSTOM:
                    onItemClicked((0, $TTKUQ.TIMELINE_MODES).CUSTOM);
                    break;
                default:
                    break;
            }
        };
        const modes = (0, $5uXOq.useMemo)(()=>[
                {
                    type: (0, $TTKUQ.TIMELINE_MODES).WEEKS,
                    title: (0, $7B9cH.default).timescaleWeeks,
                    keyBoardShortcut: 'W'
                },
                {
                    type: (0, $TTKUQ.TIMELINE_MODES).MONTHS,
                    title: (0, $7B9cH.default).timescaleMonths,
                    keyBoardShortcut: 'M'
                },
                {
                    type: (0, $TTKUQ.TIMELINE_MODES).QUARTERS,
                    title: (0, $7B9cH.default).timescaleQuarters,
                    keyBoardShortcut: 'Q'
                },
                {
                    type: (0, $TTKUQ.TIMELINE_MODES).YEARS,
                    title: (0, $7B9cH.default).timescaleYears,
                    keyBoardShortcut: 'Y'
                },
                {
                    type: (0, $TTKUQ.TIMELINE_MODES).CUSTOM,
                    title: (0, $7B9cH.default).timescaleCustom,
                    buttonTitle: getCustomRangeText(),
                    keyBoardShortcut: 'X',
                    group: 'Custom'
                }
            ], [
            getCustomRangeText
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
                width: "84px",
                height: "32px"
            }),
            name: "lazy-timeline-mode-switcher"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($49b895c851dd993b$var$LazyTimelineModeSwitcher, {
            modes: modes,
            onModeChange: changeMode,
            currentMode: mode
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86zlq")).UseShortcuts), {
            shortcutKey: "KeyW",
            onKeyDown: changeToWeeks
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86zlq")).UseShortcuts), {
            shortcutKey: "KeyM",
            onKeyDown: changeToMonths
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86zlq")).UseShortcuts), {
            shortcutKey: "KeyQ",
            onKeyDown: changeToQuarters
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86zlq")).UseShortcuts), {
            shortcutKey: "KeyY",
            onKeyDown: changeToYears
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86zlq")).UseShortcuts), {
            shortcutKey: "KeyX",
            onKeyDown: changeToCustomRange
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isCustomRangeDialogOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "716px",
            autoFocus: false,
            onClose: ()=>setCustomRangeDialogOpen(false)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, intl.formatMessage((0, $7B9cH.default).modalHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOhVC")).CustomDateRangeModalContent), {
            dateRange: (0, parcelRequire("3nPAF")).default(customDateRange) ? initialCustomDateRange : customDateRange,
            onConfirm: onCustomDatesApplied,
            onCancel: ()=>setCustomRangeDialogOpen(false)
        }))))));
    }
});
parcelRegister("1wbtX", function(module, exports) {
    $parcel$export(module.exports, "getKeyframes", ()=>$39c21c8edc6f2616$export$b2b5e866b2fbf2ec);
    $parcel$export(module.exports, "Skeleton", ()=>$39c21c8edc6f2616$export$8f31e4c4a37b8e9c);
    $parcel$export(module.exports, "Spacer", ()=>$39c21c8edc6f2616$export$d7a54cba636a8cd6);
    $parcel$export(module.exports, "SkeletonCompiled", ()=>$39c21c8edc6f2616$export$dc84d515085190e);
    $parcel$export(module.exports, "SpacerCompiled", ()=>$39c21c8edc6f2616$export$e477bb7d17087f28);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $47bDC = parcelRequire("47bDC");
    const $39c21c8edc6f2616$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
        const fromPositionX = -Math.abs(offsetX) - 300;
        const toPositionX = fromPositionX + 2000;
        return (0, $47bDC.keyframes)({
            '0%': {
                backgroundPosition: `${fromPositionX}px 0`
            },
            '100%': {
                backgroundPosition: `${toPositionX}px 0`
            }
        });
    };
    const $39c21c8edc6f2616$var$shimmer = $39c21c8edc6f2616$export$b2b5e866b2fbf2ec();
    const $39c21c8edc6f2616$export$8f31e4c4a37b8e9c = (0, $47bDC.default).div.withConfig({
        componentId: "ieqbub-0"
    })((props)=>({
            animationDelay: props.theme.animationDelay || '0s',
            animationDuration: '1s',
            animationFillMode: 'forwards',
            animationIterationCount: 'infinite',
            animationName: props.theme.animationName || $39c21c8edc6f2616$var$shimmer,
            animationTimingFunction: 'linear',
            backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`,
            backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $829f609a65d26a98$exports).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`} 50% )`,
            backgroundRepeat: 'no-repeat',
            borderRadius: '2px',
            height: props.height,
            width: props.width
        }));
    const $39c21c8edc6f2616$export$d7a54cba636a8cd6 = (0, $47bDC.default).div.withConfig({
        componentId: "ieqbub-1"
    })((props)=>({
            height: props.height
        }));
    const $39c21c8edc6f2616$export$dc84d515085190e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height),
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
                __cmplp.className
            ])
        });
    });
    const $39c21c8edc6f2616$export$e477bb7d17087f28 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1474",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cOhVC", function(module, exports) {
    $parcel$export(module.exports, "CustomDateRangeModalContent", ()=>$3dd62939ed45ac6e$export$93b481e4f8de5dc1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4R6GH;
    var $ousew;
    var $aCpcO;
    var $gh61P;
    var $9jW80;
    var $dO20C;
    var $kiWvh;
    var $c9xu9;
    const $3dd62939ed45ac6e$export$93b481e4f8de5dc1 = ({ dateRange: dateRange, showTodayIndicator: showTodayIndicator, setInitialFocusRef: setInitialFocusRef, onConfirm: onConfirm, onCancel: onCancel, onSelectedTabChange: onSelectedTabChange })=>{
        const { fromDate: fromDate, fromNowUnit: fromNowUnit = (0, (0, parcelRequire("gh61P")).DateUnits).MONTHS, fromNowUnitCount: fromNowUnitCount = 2, toDate: toDate, toNowUnitCount: toNowUnitCount = 1, toNowUnit: toNowUnit = (0, (0, parcelRequire("gh61P")).DateUnits).MONTHS, typeOfCustomDateRange: typeOfCustomDateRange = (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).FIXED } = dateRange;
        const [activeTabId, setActiveTabId] = (0, $5uXOq.useState)(typeOfCustomDateRange);
        const [fromNowUnitState, setFromNowUnit] = (0, $5uXOq.useState)(fromNowUnit);
        const [toNowUnitState, setToNowUnit] = (0, $5uXOq.useState)(toNowUnit);
        const [fromNowUnitCountState, setFromNowUnitCount] = (0, $5uXOq.useState)(fromNowUnitCount);
        const [toNowUnitCountState, setToNowUnitCount] = (0, $5uXOq.useState)(toNowUnitCount);
        const [fromDateState, setFromDate] = (0, $5uXOq.useState)(fromDate || Date.now());
        const [toDateState, setToDate] = (0, $5uXOq.useState)(toDate || Date.now());
        const isValidDateRange = (fromDate, toDate)=>fromDate != null && toDate != null && new Date(fromDate) <= new Date(toDate);
        const [isValid, setIsValidDateRange] = (0, $5uXOq.useState)(isValidDateRange(fromDateState, toDateState));
        const [isInvalidFormat, setInvalidFormat] = (0, $5uXOq.useState)(false);
        const onTabSelect = (selectedTab)=>{
            setActiveTabId(selectedTab.id);
            if (onSelectedTabChange) onSelectedTabChange();
        };
        const onApplyClicked = (0, $5uXOq.useCallback)(()=>{
            if (activeTabId === (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).FIXED) {
                onConfirm({
                    fromDate: fromDateState,
                    toDate: toDateState,
                    typeOfCustomDateRange: activeTabId
                });
                return;
            }
            const customDateRange = {
                toNowUnit: toNowUnitState,
                fromNowUnit: fromNowUnitState,
                typeOfCustomDateRange: activeTabId
            };
            if (toNowUnitCount != null) customDateRange.toNowUnitCount = Math.max(0, Math.round(toNowUnitCountState));
            if (fromNowUnitCount != null) customDateRange.fromNowUnitCount = Math.max(0, Math.round(fromNowUnitCountState));
            onConfirm(customDateRange);
        }, [
            activeTabId,
            fromDateState,
            fromNowUnitCount,
            fromNowUnitCountState,
            fromNowUnitState,
            onConfirm,
            toDateState,
            toNowUnitCount,
            toNowUnitCountState,
            toNowUnitState
        ]);
        const onFixedDateRangeChange = (0, $5uXOq.useCallback)((fromDate, toDate)=>{
            const isValid = isValidDateRange(fromDate, toDate);
            setIsValidDateRange(isValid);
            setFromDate(fromDate);
            setToDate(toDate);
        }, []);
        const onRelativeValuesChange = (0, $5uXOq.useCallback)((value, key)=>{
            if (typeof value === 'number') switch(key){
                case 'fromNowUnitCount':
                    setFromNowUnitCount(value);
                    break;
                case 'toNowUnitCount':
                    setToNowUnitCount(value);
                    break;
                default:
            }
            else if (typeof value === 'string') switch(key){
                case 'fromNowUnit':
                    setFromNowUnit(value);
                    break;
                case 'toNowUnit':
                    setToNowUnit(value);
                    break;
                default:
            }
        }, []);
        const tabs = (0, $5uXOq.useMemo)(()=>[
                {
                    id: (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).FIXED,
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kiWvh")).default).fixedTabLabel),
                    testId: 'portfolio-3-portfolio.app-simple-plans.top.time-scale.custom-modal-content.tabs.fixed',
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dO20C")).default), {
                        onChange: onFixedDateRangeChange,
                        fromDate: fromDateState,
                        toDate: toDateState,
                        isValidDateRange: isValid,
                        setInvalidFormat: setInvalidFormat
                    })
                },
                {
                    id: (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).RELATIVE,
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kiWvh")).default).relativeTabLabel),
                    testId: 'portfolio-3-portfolio.app-simple-plans.top.time-scale.custom-modal-content.tabs.relative',
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c9xu9")).default), {
                        toNowUnitCount: toNowUnitCountState,
                        fromNowUnitCount: fromNowUnitCountState,
                        toNowUnit: toNowUnitState,
                        fromNowUnit: fromNowUnitState,
                        onRelativeValuesChange: onRelativeValuesChange,
                        showTodayIndicator: showTodayIndicator
                    })
                }
            ], [
            fromDateState,
            fromNowUnitCountState,
            fromNowUnitState,
            isValid,
            onFixedDateRangeChange,
            onRelativeValuesChange,
            showTodayIndicator,
            toDateState,
            toNowUnitCountState,
            toNowUnitState
        ]);
        const selectedTab = tabs.find((tab)=>tab.id === activeTabId);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jW80")).default), {
            tabs: tabs,
            onSelect: onTabSelect,
            selected: selectedTab,
            ...(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? {
                setInitialFocusRef: setInitialFocusRef
            } : {}
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($3dd62939ed45ac6e$var$ButtonGroup, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            onClick: onCancel,
            testId: "portfolio-3-custom-date-range.ui.modal-content.cancel"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kiWvh")).default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "primary",
            isDisabled: !isValid && activeTabId === (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).FIXED || isInvalidFormat,
            onClick: onApplyClicked,
            testId: "portfolio-3-custom-date-range.ui.modal-content.submit"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kiWvh")).default).apply))));
    };
    const $3dd62939ed45ac6e$var$ButtonGroup = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _18s8r2fv _zulpu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9jW80", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8786ffc303565856$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fphHl;
    var $jxIT3;
    var $cte3m;
    var $8TQB5;
    var $4R6GH;
    var $6zIIM = parcelRequire("6zIIM");
    function $8786ffc303565856$export$2e2bcd8739ae039({ setInitialFocusRef: setInitialFocusRef, ...props }) {
        const selectedTabIndex = props.tabs.findIndex((tab)=>tab && tab.id === props.selected?.id);
        const curatedSelectedTabIndex = selectedTabIndex === -1 ? 0 : selectedTabIndex;
        const defaultSelectedTabIndex = props.tabs.findIndex((tab)=>tab && tab.id === props.defaultSelected?.id);
        const curatedDefaultSelectedTabIndex = defaultSelectedTabIndex === -1 ? 0 : defaultSelectedTabIndex;
        const handleChange = (index, analyticsEvent)=>{
            const tab = props.tabs[index];
            props.onSelect && props.onSelect(tab, index, analyticsEvent);
        };
        const tabs = ()=>(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fphHl")).default), {
                ...props,
                selected: props.selected ? curatedSelectedTabIndex : undefined,
                defaultSelected: props.defaultSelected ? curatedDefaultSelectedTabIndex : undefined,
                onChange: handleChange,
                id: "portfolio-common-tabs",
                shouldUnmountTabPanelOnChange: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cte3m")).default), null, props.tabs.map((tab, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jxIT3")).default), {
                    testId: tab?.testId,
                    key: index,
                    ref: index === selectedTabIndex ? setInitialFocusRef : undefined
                }, tab?.label))), props.tabs.map((tab, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TQB5")).default), {
                    key: index
                }, tab?.content))) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $6zIIM["tabs-container"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fphHl")).default), {
                ...props,
                selected: props.selected ? curatedSelectedTabIndex : undefined,
                defaultSelected: props.defaultSelected ? curatedDefaultSelectedTabIndex : undefined,
                onChange: handleChange,
                id: "portfolio-common-tabs",
                shouldUnmountTabPanelOnChange: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cte3m")).default), null, props.tabs.map((tab, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jxIT3")).default), {
                    testId: tab?.testId,
                    key: index
                }, tab?.label))), props.tabs.map((tab, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TQB5")).default), {
                    key: index
                }, tab?.content))));
        return props.direction === 'column' ? tabs() : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $6zIIM["tabs-row-wrapper"]
        }, tabs());
    }
    $8786ffc303565856$export$2e2bcd8739ae039.defaultProps = {
        direction: 'column'
    };
});
parcelRegister("fphHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4810d6c8b7d5c95d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $dWD6q;
    var $8emiI;
    function $4810d6c8b7d5c95d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4810d6c8b7d5c95d$var$baseStyles = {
        name: "7i0hsw",
        styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
    };
    const $4810d6c8b7d5c95d$var$tabsStyles = (0, (0, parcelRequire("8emiI")).getTabsStyles)();
    const $4810d6c8b7d5c95d$var$analyticsAttributes = {
        componentName: 'tabs',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>tabPanel && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dWD6q")).TabPanelContext).Provider, {
            value: {
                role: 'tabpanel',
                id: `${tabsId}-${index}-tab`,
                hidden: isSelected ? undefined : true,
                'aria-labelledby': `${tabsId}-${index}`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tabPanel);
    const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
        const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
        const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
        const selected = SelectedType === undefined ? selectedState : SelectedType;
        const childrenArray = (0, $5uXOq.Children).toArray(children).filter((child)=>Boolean(child));
        const [tabList, ...tabPanels] = childrenArray;
        const visited = (0, $5uXOq.useRef)(new Set([
            selected
        ]));
        if (!visited.current.has(selected)) visited.current.add(selected);
        const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
            if (onChangeProp) onChangeProp(index, analyticsEvent);
            setSelected(index);
        }, [
            onChangeProp
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'clicked',
            analyticsData: analyticsContext,
            ...$4810d6c8b7d5c95d$var$analyticsAttributes
        });
        const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[selected],
            index: selected,
            isSelected: true,
            tabsId: id
        }) : Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
                tabPanel: tabPanels[tabIndex],
                index: tabIndex,
                isSelected: tabIndex === selected,
                tabsId: id
            }));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: [
                $4810d6c8b7d5c95d$var$baseStyles,
                $4810d6c8b7d5c95d$var$tabsStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dWD6q")).TabListContext).Provider, {
            value: {
                selected: selected,
                onChange: onChangeAnalytics,
                tabsId: id
            }
        }, tabList), (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, tabPanelsWithContext)));
    };
    var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;
});
parcelRegister("dWD6q", function(module, exports) {
    $parcel$export(module.exports, "TabContext", ()=>$b47499898157cfdc$export$5a5d356ca5f10a0a);
    $parcel$export(module.exports, "TabListContext", ()=>$b47499898157cfdc$export$aa6907f9fd69e93b);
    $parcel$export(module.exports, "TabPanelContext", ()=>$b47499898157cfdc$export$2054129d247c3102);
    var $5uXOq = parcelRequire("5uXOq");
    const $b47499898157cfdc$export$5a5d356ca5f10a0a = (0, $5uXOq.createContext)(null);
    const $b47499898157cfdc$export$aa6907f9fd69e93b = (0, $5uXOq.createContext)(null);
    const $b47499898157cfdc$export$2054129d247c3102 = (0, $5uXOq.createContext)(null);
});
parcelRegister("8emiI", function(module, exports) {
    $parcel$export(module.exports, "getTabsStyles", ()=>$899bec80a30728c7$export$dd5afd2190fb792c);
    $parcel$export(module.exports, "getTabListStyles", ()=>$899bec80a30728c7$export$42a3c683c377bcb2);
    $parcel$export(module.exports, "getTabListStylesOld", ()=>$899bec80a30728c7$export$f208f8acf591dbc2);
    var $f8Sb3;
    var $6VxaK;
    const $899bec80a30728c7$var$tabInlinePadding = "var(--ds-space-100, 8px)";
    const $899bec80a30728c7$var$tabBlockPadding = "var(--ds-space-075, 6px)";
    const $899bec80a30728c7$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
    const $899bec80a30728c7$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
    const $899bec80a30728c7$var$getTabPanelStyles = ()=>({
            flexGrow: 1,
            minHeight: '0%',
            display: 'flex'
        });
    const $899bec80a30728c7$export$dd5afd2190fb792c = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tabpanel"]': $899bec80a30728c7$var$getTabPanelStyles(),
            '& > [hidden]': {
                display: 'none'
            }
        });
    const $899bec80a30728c7$var$tabLineStyles = {
        content: '""',
        bottom: 0,
        margin: 0,
        position: 'absolute',
        width: 'inherit',
        insetInlineStart: $899bec80a30728c7$var$tabInlinePadding,
        insetInlineEnd: 0
    };
    const $899bec80a30728c7$export$42a3c683c377bcb2 = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tab"]': $899bec80a30728c7$export$916c8b0fccbb37d2(),
            fontWeight: "var(--ds-font-weight-medium, 500)",
            marginInlineStart: $899bec80a30728c7$var$tabInlineMargin,
            '&::before': {
                ...$899bec80a30728c7$var$tabLineStyles,
                height: "var(--ds-border-width, 1px)",
                backgroundColor: (0, (0, parcelRequire("6VxaK")).tabLineColors).lineColor
            }
        });
    const $899bec80a30728c7$export$916c8b0fccbb37d2 = ()=>{
        const colors = (0, (0, parcelRequire("6VxaK")).tabColors);
        return {
            color: colors.labelColor,
            cursor: 'pointer',
            margin: 0,
            padding: `${$899bec80a30728c7$var$tabBlockPadding} ${$899bec80a30728c7$var$tabInlinePadding}`,
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:hover': {
                color: colors.hoverLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStyles,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).hoveredColor}`,
                    height: 0
                }
            },
            '&:active': {
                color: colors.activeLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStyles,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).activeColor}`,
                    height: 0
                }
            },
            '&[aria-selected="true"]': {
                color: colors.selectedColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStyles,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).selectedColor}`,
                    height: 0
                }
            }
        };
    };
    const $899bec80a30728c7$var$tabLineStylesOld = {
        content: '""',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        bottom: 0,
        margin: 0,
        position: 'absolute',
        width: 'inherit',
        insetInlineStart: $899bec80a30728c7$var$tabInlinePadding,
        insetInlineEnd: 0
    };
    const $899bec80a30728c7$export$f208f8acf591dbc2 = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tab"]': $899bec80a30728c7$export$442d081208938078(),
            fontWeight: "var(--ds-font-weight-medium, 500)",
            marginInlineStart: $899bec80a30728c7$var$tabInlineMargin,
            '&::before': {
                ...$899bec80a30728c7$var$tabLineStylesOld,
                height: $899bec80a30728c7$var$underlineHeight,
                backgroundColor: (0, (0, parcelRequire("6VxaK")).tabLineColors).lineColor
            }
        });
    const $899bec80a30728c7$export$442d081208938078 = ()=>{
        const colors = (0, (0, parcelRequire("6VxaK")).tabColors);
        return {
            color: colors.labelColor,
            cursor: 'pointer',
            margin: 0,
            padding: `${$899bec80a30728c7$var$tabBlockPadding} ${$899bec80a30728c7$var$tabInlinePadding}`,
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:hover': {
                color: colors.hoverLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStylesOld,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).hoveredColor}`,
                    height: 0
                }
            },
            '&:active': {
                color: colors.activeLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStylesOld,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).activeColor}`,
                    height: 0
                }
            },
            '&[aria-selected="true"]': {
                color: colors.selectedColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStylesOld,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).selectedColor}`,
                    height: 0
                }
            }
        };
    };
});
parcelRegister("6VxaK", function(module, exports) {
    $parcel$export(module.exports, "tabColors", ()=>$874e3836572be4cc$export$5159a1ad8efe50bc);
    $parcel$export(module.exports, "tabLineColors", ()=>$874e3836572be4cc$export$6be6fa4649b31472);
    const $874e3836572be4cc$export$5159a1ad8efe50bc = {
        labelColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        activeLabelColor: `var(--ds-text, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`,
        hoverLabelColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        selectedColor: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        focusBorderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`
    };
    const $874e3836572be4cc$export$6be6fa4649b31472 = {
        lineColor: `var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    };
});
parcelRegister("jxIT3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a23bdf24c904bdb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jhVLw;
    var $cgL5K;
    var $eQ4wW;
    const $5a23bdf24c904bdb$var$Tab = (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
        const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, (0, parcelRequire("eQ4wW")).useTab)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            onClick: onClick,
            id: id,
            "aria-controls": ariaControls,
            "aria-posinset": ariaPosinset,
            "aria-selected": ariaSelected,
            "aria-setsize": ariaSetsize,
            onKeyDown: onKeyDown,
            role: role,
            tabIndex: tabIndex,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            color: "inherit",
            maxLines: 1
        }, children)));
    });
    var $5a23bdf24c904bdb$export$2e2bcd8739ae039 = $5a23bdf24c904bdb$var$Tab;
});
parcelRegister("eQ4wW", function(module, exports) {
    $parcel$export(module.exports, "useTab", ()=>$4d8616502e4de6b0$export$fdf4756d5b8ef90a);
    $parcel$export(module.exports, "useTabList", ()=>$4d8616502e4de6b0$export$773e389e644c5874);
    $parcel$export(module.exports, "useTabPanel", ()=>$4d8616502e4de6b0$export$fae0121b5afe572d);
    var $5uXOq = parcelRequire("5uXOq");
    var $dWD6q;
    const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
        const tabData = (0, $5uXOq.useContext)((0, (0, parcelRequire("dWD6q")).TabContext));
        if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
        return tabData;
    };
    const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
        const tabListData = (0, $5uXOq.useContext)((0, (0, parcelRequire("dWD6q")).TabListContext));
        if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
        return tabListData;
    };
    const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
        const tabPanelData = (0, $5uXOq.useContext)((0, (0, parcelRequire("dWD6q")).TabPanelContext));
        if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
        return tabPanelData;
    };
});
parcelRegister("cte3m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15f9538b451f314$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $eQ4wW;
    var $dWD6q;
    var $8emiI;
    function $e15f9538b451f314$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15f9538b451f314$var$baseStyles = {
        name: "g0wsdz",
        styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
    };
    const $e15f9538b451f314$var$tabListStyles = (0, (0, parcelRequire("8emiI")).getTabListStyles)();
    const $e15f9538b451f314$var$tabListStylesOld = (0, (0, parcelRequire("8emiI")).getTabListStylesOld)();
    const $e15f9538b451f314$var$TabList = ({ children: children })=>{
        const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, (0, parcelRequire("eQ4wW")).useTabList)();
        const ref = (0, $5uXOq.createRef)();
        const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
        const length = childrenArray.length;
        const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
            const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
            if (newSelectedNode) newSelectedNode.focus();
            onChange(index);
        }, [
            tabsId,
            ref,
            onChange
        ]);
        const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (![
                'ArrowRight',
                'ArrowLeft',
                'Home',
                'End'
            ].includes(e.key)) return;
            e.preventDefault();
            const lastTabIndex = length - 1;
            if ([
                'Home',
                'End'
            ].includes(e.key)) {
                const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
                selectTabByIndex(newSelected);
                return;
            }
            const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
            const modifier = e.key === 'ArrowRight' ? 1 : -1;
            let newSelected = selectedIndex + modifier;
            if (newSelected < 0 || newSelected >= length) newSelected = newSelected < 0 ? lastTabIndex : 0;
            selectTabByIndex(newSelected);
        }, [
            length,
            selectTabByIndex
        ]);
        const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dWD6q")).TabContext).Provider, {
                value: {
                    onClick: ()=>onChange(index),
                    onKeyDown: onKeyDown,
                    'aria-setsize': length,
                    role: 'tab',
                    id: `${tabsId}-${index}`,
                    'aria-posinset': index + 1,
                    'aria-selected': isSelected,
                    'aria-controls': `${tabsId}-${index}-tab`,
                    tabIndex: isSelected ? 0 : -1
                },
                key: index
            }, tab), [
            length,
            onKeyDown,
            onChange,
            tabsId
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "tablist",
            ref: ref,
            css: [
                $e15f9538b451f314$var$baseStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $e15f9538b451f314$var$tabListStyles : $e15f9538b451f314$var$tabListStylesOld
            ]
        }, childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))));
    };
    var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;
});
parcelRegister("8TQB5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca06f45af60382a8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jhVLw;
    var $eQ4wW;
    const $ca06f45af60382a8$var$TabPanel = ({ children: children, testId: testId })=>{
        const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, (0, parcelRequire("eQ4wW")).useTabPanel)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            role: role,
            id: id,
            hidden: hidden,
            "aria-labelledby": ariaLabelledBy,
            tabIndex: tabIndex
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, children)));
    };
    var $ca06f45af60382a8$export$2e2bcd8739ae039 = $ca06f45af60382a8$var$TabPanel;
});
parcelRegister("6zIIM", function(module, exports) {
    $parcel$export(module.exports, "tabs-container", ()=>$4c98b3a8b00f8c47$export$47009996fffeb3bc, (v)=>$4c98b3a8b00f8c47$export$47009996fffeb3bc = v);
    $parcel$export(module.exports, "tabs-row-wrapper", ()=>$4c98b3a8b00f8c47$export$14ca765001cc894e, (v)=>$4c98b3a8b00f8c47$export$14ca765001cc894e = v);
    var $4c98b3a8b00f8c47$export$47009996fffeb3bc;
    var $4c98b3a8b00f8c47$export$14ca765001cc894e;
    $4c98b3a8b00f8c47$export$47009996fffeb3bc = `pakj-q_tabs-container`;
    $4c98b3a8b00f8c47$export$14ca765001cc894e = `pakj-q_tabs-row-wrapper`;
});
parcelRegister("dO20C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5102e33f0df1511d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $qfj8c;
    var $ousew;
    var $2Bbe3;
    var $fkfPc;
    var $7mFnP;
    const $5102e33f0df1511d$var$FixedDateRange = ({ fromDate: fromDate, toDate: toDate, isValidDateRange: isValidDateRange, onChange: onChange, setInvalidFormat: setInvalidFormat })=>{
        const [startDate, setStartDate] = (0, $5uXOq.useState)(new Date(fromDate));
        const [endDate, setEndDate] = (0, $5uXOq.useState)(new Date(toDate));
        const [startInvalid, setStartInvalid] = (0, $5uXOq.useState)(false);
        const [endInvalid, setEndInvalid] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setInvalidFormat(startInvalid || endInvalid);
        }, [
            startInvalid,
            endInvalid,
            setInvalidFormat
        ]);
        const onStartCalendarSelect = ({ iso: iso })=>{
            if (iso !== undefined) {
                const newStartDate = new Date(iso);
                setStartDate(newStartDate);
                onChange(newStartDate.getTime(), endDate.getTime());
                setStartInvalid(false);
            }
        };
        const onEndCalendarSelect = ({ iso: iso })=>{
            if (iso !== undefined) {
                const newEndDate = new Date(iso);
                setEndDate(newEndDate);
                onChange(startDate.getTime(), newEndDate.getTime());
                setEndInvalid(false);
            }
        };
        const onStartInputChange = (date)=>{
            setStartDate(date);
            onChange(date.getTime(), endDate.getTime());
        };
        const onEndInputChange = (date)=>{
            setEndDate(date);
            onChange(startDate.getTime(), date.getTime());
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5102e33f0df1511d$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5102e33f0df1511d$var$ColumnContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkfPc")).default), {
            id: "date-range-input-start-date",
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7mFnP")).default).from),
            date: startDate,
            onChange: onStartInputChange,
            setInvalidFormat: setStartInvalid
        }), !isValidDateRange && !startInvalid && !endInvalid && (0, ($parcel$interopDefault($5uXOq))).createElement($5102e33f0df1511d$var$ErrorMessageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7mFnP")).default).startDateAfterEndDateErrorMessage))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Bbe3")).default), {
            date: startDate,
            onSelect: onStartCalendarSelect
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($5102e33f0df1511d$var$ColumnContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkfPc")).default), {
            id: "date-range-input-end-date",
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7mFnP")).default).to),
            date: endDate,
            onChange: onEndInputChange,
            setInvalidFormat: setEndInvalid
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Bbe3")).default), {
            date: endDate,
            onSelect: onEndCalendarSelect
        })));
    };
    var $5102e33f0df1511d$export$2e2bcd8739ae039 = $5102e33f0df1511d$var$FixedDateRange;
    const $5102e33f0df1511d$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1yb4 _zulppxbi _1amj1bp4 _guasidpf _p1lu1bp4 _wfzokb7n",
                __cmplp.className
            ])
        });
    });
    const $5102e33f0df1511d$var$ColumnContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4",
                __cmplp.className
            ])
        });
    });
    const $5102e33f0df1511d$var$ErrorMessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4h8dc _19pk10v4 _otyr1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2Bbe3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac824a74566b8783$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $1f0Hs;
    var $cSD7y;
    var $gJZ5D;
    var $gh61P;
    var $aipk9;
    var $flnZx;
    var $DVljb;
    const $ac824a74566b8783$var$CalendarInput = ({ date: date, onSelect: onSelect })=>{
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const weekStartDay = (0, (0, parcelRequire("flnZx")).getWeekStartDay)(locale);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ac824a74566b8783$var$CalendarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1f0Hs")).default), {
            selected: [
                (0, (0, parcelRequire("aipk9")).formatDateUTC)(date.getTime(), (0, (0, parcelRequire("gh61P")).IsoDateFormat))
            ],
            onSelect: onSelect,
            weekStartDay: weekStartDay,
            locale: locale,
            defaultDay: date.getDate(),
            defaultYear: date.getFullYear(),
            defaultMonth: date.getMonth() + 1
        }));
    };
    const $ac824a74566b8783$var$CalendarInputOld = ({ date: date, onSelect: onSelect })=>{
        const [month, setMonth] = (0, $5uXOq.useState)(date.getMonth());
        const [year, setYear] = (0, $5uXOq.useState)(date.getFullYear());
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const weekStartDay = (0, (0, parcelRequire("flnZx")).getWeekStartDay)(locale);
        (0, $5uXOq.useEffect)(()=>{
            setMonth(date.getMonth());
            setYear(date.getFullYear());
        }, [
            date
        ]);
        const onChange = (event, _)=>{
            if (event.type === 'prev') {
                if (month === 0) {
                    setMonth(11);
                    setYear(year - 1);
                } else setMonth(month - 1);
            } else if (event.type === 'next') {
                if (month === 11) {
                    setMonth(0);
                    setYear(year + 1);
                } else setMonth(month + 1);
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ac824a74566b8783$var$CalendarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1f0Hs")).default), {
            selected: [
                (0, (0, parcelRequire("aipk9")).formatDateUTC)(date.getTime(), (0, (0, parcelRequire("gh61P")).IsoDateFormat))
            ],
            month: month + 1,
            year: year,
            onSelect: onSelect,
            onChange: onChange,
            day: 0,
            weekStartDay: weekStartDay,
            locale: locale
        }));
    };
    var $ac824a74566b8783$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $ac824a74566b8783$var$CalendarInput, $ac824a74566b8783$var$CalendarInputOld);
    const $ac824a74566b8783$var$CalendarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1oynm9n": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("gJZ5D")).default).N50A),
                "--_kxj3ud": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("gJZ5D")).default).N40A)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _16qss898 _2rko1l7b",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fkfPc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e6a9e7123169241$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7O4UO;
    var $qfj8c;
    var $cTemL;
    var $dC5iT;
    var $8CUq3;
    var $ousew;
    var $koVbs;
    var $aipk9;
    var $3cgJ4;
    var $5aZaL;
    const $5e6a9e7123169241$var$DATE_REGEX = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/;
    const $5e6a9e7123169241$var$isValidFormat = (dateString)=>$5e6a9e7123169241$var$DATE_REGEX.test(dateString);
    const $5e6a9e7123169241$var$DateInput = ({ id: id, label: label, date: date, onChange: onChange, setInvalidFormat: setInvalidFormat })=>{
        const formatDate = (date)=>(0, (0, parcelRequire("aipk9")).formatDateUTC)(date.getTime(), (0, $76b160230aa865be$export$43fa8699f5b8d098));
        const [value, setValue] = (0, $5uXOq.useState)(formatDate(date));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const setDateValue = (e)=>{
            const newDateString = e.target.value;
            setValue(newDateString);
            if ($5e6a9e7123169241$var$isValidFormat(newDateString)) {
                const parts = newDateString.split('/');
                const newDate = new Date(Date.UTC(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10)));
                setInvalidFormat(false);
                onChange(newDate);
            } else setInvalidFormat(true);
        };
        (0, $5uXOq.useEffect)(()=>{
            if (date) {
                setValue(formatDate(date));
                setInvalidFormat(false);
            }
        }, [
            date,
            setInvalidFormat
        ]);
        const getInvalidFormatMessage = ()=>{
            if (!$5e6a9e7123169241$var$isValidFormat(value)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("5aZaL")).default).wrongFormatErrorMessageLocalised));
            return null;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            id: id,
            label: label,
            name: "command",
            defaultValue: ""
        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3cgJ4")).default), {
                id: id,
                testId: "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.date-input.date-input",
                onChange: setDateValue,
                value: value,
                placeholder: (0, $76b160230aa865be$export$43fa8699f5b8d098),
                elemBeforeInput: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $5e6a9e7123169241$var$iconWrapperStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cTemL"))))), {
                    label: formatMessage((0, (0, parcelRequire("5aZaL")).default).calendarIcon)
                })),
                "aria-describedby": "date-input-field-validation-error-message"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($5e6a9e7123169241$var$ErrorMessageWrapper, {
            id: "date-input-field-validation-error-message"
        }, getInvalidFormatMessage()));
    };
    var $5e6a9e7123169241$export$2e2bcd8739ae039 = $5e6a9e7123169241$var$DateInput;
    const $5e6a9e7123169241$var$ErrorMessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4h8dc _19pk1b66 _4t3igktf",
                __cmplp.className
            ])
        });
    });
    const $5e6a9e7123169241$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.100'
    });
});
const $76b160230aa865be$export$43fa8699f5b8d098 = 'DD/MM/YYYY';
parcelRegister("5aZaL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fc858e725551042$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8fc858e725551042$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        calendarIcon: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.date-input.calendar-icon",
            "defaultMessage": "Calendar icon"
        },
        wrongFormatErrorMessageLocalised: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.date-input.wrong-format-error-message-localised",
            "defaultMessage": "Date format should be DD/MM/YYYY"
        }
    });
});
parcelRegister("7mFnP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eddcba78557dd5e7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $eddcba78557dd5e7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        from: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.from",
            "defaultMessage": "Start date"
        },
        to: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.to",
            "defaultMessage": "End date"
        },
        startDateAfterEndDateErrorMessage: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.start-date-after-end-date-error-message",
            "defaultMessage": "Start date must be before end date"
        }
    });
});
parcelRegister("kiWvh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f30548bcb010a7b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3f30548bcb010a7b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fixedTabLabel: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-tab-label",
            "defaultMessage": "Fixed"
        },
        relativeTabLabel: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.relative-tab-label",
            "defaultMessage": "Relative"
        },
        apply: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.apply",
            "defaultMessage": "Apply"
        },
        cancel: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.cancel",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("c9xu9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d01e0694aff6cb8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $7O4UO;
    var $kY99m;
    var $4R6GH;
    var $8RXs9;
    var $gh61P;
    var $flnZx;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $c4Fhi;
    var $80HYw;
    const $7d01e0694aff6cb8$var$ToOrFrom = {
        TO: 'to',
        FROM: 'from'
    };
    const $7d01e0694aff6cb8$var$getSelectOptions = (count, intl)=>[
            {
                value: (0, (0, parcelRequire("gh61P")).DateUnits).WEEKS,
                label: intl.formatMessage((0, (0, parcelRequire("c4Fhi")).default).weeks, {
                    count: count
                })
            },
            {
                value: (0, (0, parcelRequire("gh61P")).DateUnits).MONTHS,
                label: intl.formatMessage((0, (0, parcelRequire("c4Fhi")).default).months, {
                    count: count
                })
            }
        ];
    const $7d01e0694aff6cb8$var$RelativeDateRange = ({ fromNowUnit: fromNowUnit = (0, (0, parcelRequire("gh61P")).DateUnits).WEEKS, fromNowUnitCount: fromNowUnitCount = 0, intl: intl, onRelativeValuesChange: onRelativeValuesChange, showTodayIndicator: showTodayIndicator = true, toNowUnit: toNowUnit = (0, (0, parcelRequire("gh61P")).DateUnits).WEEKS, toNowUnitCount: toNowUnitCount = 0 })=>{
        const validateCount = (0, $5uXOq.useCallback)((toOrFrom, value)=>{
            const maxValuesMap = {
                [(0, (0, parcelRequire("gh61P")).DateUnits).DAYS]: 3650,
                [(0, (0, parcelRequire("gh61P")).DateUnits).WEEKS]: 520,
                [(0, (0, parcelRequire("gh61P")).DateUnits).MONTHS]: 120
            };
            const index = toOrFrom === $7d01e0694aff6cb8$var$ToOrFrom.TO ? toNowUnit : fromNowUnit;
            const max = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? (0, (0, parcelRequire("gh61P")).DATE_UNIT_MAX_VALUES)[index] : maxValuesMap[index];
            return Math.min(max, Math.abs(Number(value)));
        }, [
            toNowUnit,
            fromNowUnit
        ]);
        const onChangeCount = (0, $5uXOq.useCallback)(({ target: { name: name, value: value } })=>{
            const toOrFrom = name === 'toNowUnitCount' ? $7d01e0694aff6cb8$var$ToOrFrom.TO : $7d01e0694aff6cb8$var$ToOrFrom.FROM;
            const val = validateCount(toOrFrom, value);
            onRelativeValuesChange(Number(val), name);
        }, [
            onRelativeValuesChange,
            validateCount
        ]);
        const onBlurCount = (0, $5uXOq.useCallback)((e)=>{
            const { name: name, value: valueStr } = e.currentTarget;
            const val = Math.round(parseFloat(valueStr));
            onRelativeValuesChange(val, name);
        }, [
            onRelativeValuesChange
        ]);
        const onChangeUnit = (0, $5uXOq.useCallback)((value, name)=>{
            if (value && !Array.isArray(value)) onRelativeValuesChange(value.value, name);
        }, [
            onRelativeValuesChange
        ]);
        const getSelectValue = (0, $5uXOq.useCallback)((currentValue, count)=>$7d01e0694aff6cb8$var$getSelectOptions(count, intl).find(({ value: value })=>value === currentValue), [
            intl
        ]);
        const relativeRange = (0, $5uXOq.useCallback)(()=>{
            const { start: start, end: end } = (0, (0, parcelRequire("flnZx")).getRelativeDates)({
                toNowUnitCount: toNowUnitCount,
                fromNowUnitCount: fromNowUnitCount,
                toNowUnit: toNowUnit,
                fromNowUnit: fromNowUnit
            }, new Date());
            return (0, (0, parcelRequire("80HYw")).getStringFromDates)(start, end, intl);
        }, [
            fromNowUnit,
            fromNowUnitCount,
            intl,
            toNowUnit,
            toNowUnitCount
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const toVal = validateCount($7d01e0694aff6cb8$var$ToOrFrom.TO, toNowUnitCount);
            if (toVal !== toNowUnitCount) onRelativeValuesChange(toVal, 'toNowUnitCount');
            const fromVal = validateCount($7d01e0694aff6cb8$var$ToOrFrom.FROM, fromNowUnitCount);
            if (fromVal !== fromNowUnitCount) onRelativeValuesChange(fromVal, 'fromNowUnitCount');
        }, [
            toNowUnit,
            fromNowUnit,
            toNowUnitCount,
            fromNowUnitCount,
            onRelativeValuesChange,
            validateCount
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$RelativeDateRangeContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$ColumnsContainer, {
            showTodayIndicator: showTodayIndicator
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.to-now"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$Column, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            label: intl.formatMessage((0, (0, parcelRequire("c4Fhi")).default).toNowHeader),
            name: "toNowUnitCount"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$Column, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                ...fieldProps,
                min: 0,
                name: "toNowUnitCount",
                onBlur: onBlurCount,
                onChange: onChangeCount,
                type: "number",
                value: toNowUnitCount.toString(),
                width: 60
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$SelectWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                ...fieldProps,
                isTransparentBackground: false,
                isClearable: false,
                options: $7d01e0694aff6cb8$var$getSelectOptions(toNowUnitCount, intl),
                value: getSelectValue(toNowUnit, toNowUnitCount),
                onChange: (option)=>onChangeUnit(option, 'toNowUnit'),
                classNamePrefix: "relative-time-range-to-now-select"
            })))))), showTodayIndicator && (0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$NowBarColumn, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            label: intl.formatMessage((0, (0, parcelRequire("c4Fhi")).default).todayLabel),
            name: "todayLabel"
        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$NowBar, null, (0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$NowLine, {
                topOffset: 40
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.from-now"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$Column, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            label: intl.formatMessage((0, (0, parcelRequire("c4Fhi")).default).fromNowHeader),
            name: "fromNowUnitCount"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$Column, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                ...fieldProps,
                min: 0,
                name: "fromNowUnitCount",
                onBlur: onBlurCount,
                onChange: onChangeCount,
                type: "number",
                value: fromNowUnitCount.toString(),
                width: 60
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$SelectWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                ...fieldProps,
                classNamePrefix: "relative-time-range-from-now-select",
                isClearable: false,
                isTransparentBackground: false,
                onChange: (option)=>onChangeUnit(option, 'fromNowUnit'),
                options: $7d01e0694aff6cb8$var$getSelectOptions(fromNowUnitCount, intl),
                value: getSelectValue(fromNowUnit, fromNowUnitCount)
            }))))))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.selected-time-range"
        }, intl.formatMessage((0, (0, parcelRequire("c4Fhi")).default).timeRangeText), (0, ($parcel$interopDefault($5uXOq))).createElement($7d01e0694aff6cb8$var$TimeRange, null, relativeRange())));
    };
    var $7d01e0694aff6cb8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($7d01e0694aff6cb8$var$RelativeDateRange);
    const $7d01e0694aff6cb8$var$MARKER_LINE_WIDTH = 2;
    const $7d01e0694aff6cb8$var$POINTER_WIDTH = 8;
    const $7d01e0694aff6cb8$var$RelativeDateRangeContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbkbql",
                __cmplp.className
            ])
        });
    });
    const $7d01e0694aff6cb8$var$Column = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $7d01e0694aff6cb8$var$TimeRange = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p8n31",
                __cmplp.className
            ])
        });
    });
    const $7d01e0694aff6cb8$var$NowBar = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3iymf6 _1ltv1ssb _19pkukr8 _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $7d01e0694aff6cb8$var$NowLine = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { topOffset: topOffset, noMarker: noMarker, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_2iu6vl": (0, (0, parcelRequire("lD23V")).default)(__cmplp.topOffset, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _94n5idpf _1pbyegat _lcxvglyw _1bsbyh40 _1kl74oj4 _1kt9b3bt _1cs81if8 _kfgtidpf _1mp4idpf _1aukidpf _fntn1lpd _1n1j12me _1c9r12me _1pq8m65w",
                __cmplp.topOffset ? "_154i1rwy" : "_154iidpf",
                __cmplp.noMarker ? "_cfu1glyw" : "_cfu11ule",
                __cmplp.className
            ])
        });
    });
    const $7d01e0694aff6cb8$var$SelectWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul968cl",
                __cmplp.className
            ])
        });
    });
    const $7d01e0694aff6cb8$var$ColumnsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { showTodayIndicator: showTodayIndicator, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _n3tdpxbi _1uo31ch8",
                __cmplp.showTodayIndicator ? "_zulpxy5q" : "_zulpoahv",
                __cmplp.className
            ])
        });
    });
    const $7d01e0694aff6cb8$var$NowBarColumn = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1h6o _1e0c1txw _2lx21bp4 _1yt4otz2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("c4Fhi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08c3b3eeb8de77f2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $08c3b3eeb8de77f2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        weeks: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.weeks",
            "defaultMessage": "{count, plural, one {Week} other {Weeks}}"
        },
        months: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.months",
            "defaultMessage": "{count, plural, one {Month} other {Months}}"
        },
        toNowHeader: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.to-now-header",
            "defaultMessage": "Show the past"
        },
        fromNowHeader: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.from-now-header",
            "defaultMessage": "Show the next"
        },
        timeRangeText: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.time-range-text",
            "defaultMessage": "Selected time range is "
        },
        todayLabel: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.today-label",
            "defaultMessage": "Today"
        },
        timescaleCustom: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.timescale-custom",
            "defaultMessage": "Custom"
        },
        timescaleFrom: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.timescale-from",
            "defaultMessage": "From {fromDate}"
        },
        timescaleTo: {
            "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.timescale-to",
            "defaultMessage": "To {toDate}"
        }
    });
});
parcelRegister("80HYw", function(module, exports) {
    $parcel$export(module.exports, "getStringFromDates", ()=>$25e574dadd398920$export$ee3a0e6ec0a19206);
    var $gh61P;
    var $aipk9;
    var $c4Fhi;
    const $25e574dadd398920$export$60248f42f43df209 = (date, intl)=>{
        if (typeof date === 'number') return (0, (0, parcelRequire("aipk9")).formatTimestampWithIntl)(intl, date, (0, (0, parcelRequire("gh61P")).shortDateFormat));
        return date;
    };
    const $25e574dadd398920$export$ee3a0e6ec0a19206 = (fromDateTimestamp, toDateTimestamp, intl)=>{
        if (fromDateTimestamp && toDateTimestamp) return `${$25e574dadd398920$export$60248f42f43df209(fromDateTimestamp, intl)} \u{2013} ${$25e574dadd398920$export$60248f42f43df209(toDateTimestamp, intl)}`;
        if (fromDateTimestamp) return intl.formatMessage((0, (0, parcelRequire("c4Fhi")).default).timescaleFrom, {
            fromDate: $25e574dadd398920$export$60248f42f43df209(fromDateTimestamp, intl)
        });
        if (toDateTimestamp) return intl.formatMessage((0, (0, parcelRequire("c4Fhi")).default).timescaleTo, {
            toDate: $25e574dadd398920$export$60248f42f43df209(toDateTimestamp, intl)
        });
        return intl.formatMessage((0, (0, parcelRequire("c4Fhi")).default).timescaleCustom);
    };
});
parcelRegister("7B9cH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ecfeee260344f775$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ecfeee260344f775$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        timescaleCustom: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-custom",
            "defaultMessage": "Custom"
        },
        timescaleCustomRange: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-custom-range",
            "defaultMessage": "Custom range"
        },
        timescaleFrom: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-from",
            "defaultMessage": "From {fromDate}"
        },
        timescaleTo: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-to",
            "defaultMessage": "To {toDate}"
        },
        timescaleWeeks: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-weeks",
            "defaultMessage": "Weeks"
        },
        timescaleMonths: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-months",
            "defaultMessage": "Months"
        },
        timescaleQuarters: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-quarters",
            "defaultMessage": "Quarters"
        },
        timescaleYears: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-years",
            "defaultMessage": "Years"
        },
        modalHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.modal-header",
            "defaultMessage": "Select custom date range"
        }
    });
});
parcelRegister("2lH7Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("19PNG")
    ]).then(()=>parcelRequire('gskNf'));
});
parcelRegister("fjsf7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$472d4aa4fe99ae9e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $8lrJN;
    var $hE4fC;
    var $86zlq;
    var $1qMX7;
    var $953xE = parcelRequire("953xE");
    function $472d4aa4fe99ae9e$export$2e2bcd8739ae039() {
        const [, { backToToday: backToToday }] = (0, (0, parcelRequire("hE4fC")).useToday)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qMX7")).default), {
                letter: "T",
                message: (0, $953xE.default).todayTooltip
            }),
            position: "top-end"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86zlq")).UseShortcuts), {
            shortcutKey: "KeyT",
            onKeyDown: backToToday
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8lrJN")).default), {
            onClick: backToToday,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.today-button.today-button"
        }));
    }
});
parcelRegister("8lrJN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62a37da0263bb7b7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $4R6GH;
    var $koVbs;
    var $h61ge;
    const $62a37da0263bb7b7$var$TodayButton = ({ onClick: onClick, testId: testId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: testId,
            appearance: "subtle",
            onClick: onClick,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-today-clicked'
            } : {}
        }, formatMessage((0, (0, parcelRequire("h61ge")).default).today));
    };
    var $62a37da0263bb7b7$export$2e2bcd8739ae039 = $62a37da0263bb7b7$var$TodayButton;
});
parcelRegister("h61ge", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$545f7c2e83fc209b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $545f7c2e83fc209b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        today: {
            "id": "aais-timeline-toolbar.today-button.today",
            "defaultMessage": "Today"
        }
    });
});
parcelRegister("953xE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7571f2292e117ad$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c7571f2292e117ad$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        todayTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.today-button.today-tooltip",
            "defaultMessage": "Go to today"
        }
    });
});
parcelRegister("jVyaJ", function(module, exports) {
    $parcel$export(module.exports, "getDefaultStickyOffset", ()=>$2db40b9ac2cb80ad$export$c83894774d7d5eac);
    $parcel$export(module.exports, "makeRangeExtractor", ()=>$2db40b9ac2cb80ad$export$ec2d3be8fe7309ff);
    $parcel$export(module.exports, "makeColspan", ()=>$2db40b9ac2cb80ad$export$c1863025f66cc6c0);
    $parcel$export(module.exports, "getColumnIds", ()=>$2db40b9ac2cb80ad$export$3d88032e6be0ee47);
    $parcel$export(module.exports, "getViewportInset", ()=>$2db40b9ac2cb80ad$export$41658c9532196d27);
    $parcel$export(module.exports, "getAdditionalHeightToHideNativeScrollbar", ()=>$2db40b9ac2cb80ad$export$2491102f5e24761b);
    var $gAFMM = parcelRequire("gAFMM");
    var $3J2mc;
    const $2db40b9ac2cb80ad$var$uniq = (a)=>Array.from(new Set(a));
    const $2db40b9ac2cb80ad$export$c83894774d7d5eac = ()=>({
            vertical: 0,
            horizontal: 0
        });
    const $2db40b9ac2cb80ad$export$ec2d3be8fe7309ff = (stickyRows)=>({ above: above, within: within, below: below })=>{
            for(let cursor = (within[0] ?? 0) - 1; cursor >= 0; cursor--)if (stickyRows[cursor]) {
                const additional = above.includes(cursor) ? [] : [
                    cursor
                ];
                return $2db40b9ac2cb80ad$var$uniq([
                    0,
                    1,
                    ...additional,
                    ...above,
                    ...within,
                    ...below
                ]);
            }
            return $2db40b9ac2cb80ad$var$uniq([
                0,
                1,
                ...above,
                ...within,
                ...below
            ]);
        };
    const $2db40b9ac2cb80ad$export$c1863025f66cc6c0 = (viewMode, columns)=>({ column: column, row: row, columnWidths: columnWidths })=>{
            const numOfFields = columns.length - 2;
            if (row === 0) {
                const isFieldColumn = ({ tag: tag })=>tag === (0, $f3f8e80f7954f218$export$d6f887e0c1be1b74) || tag === (0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c) || tag === (0, $f3f8e80f7954f218$export$ccb33e29d92c9a58);
                if (column === 1) {
                    if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE) return numOfFields;
                    return numOfFields + 1;
                }
                return isFieldColumn(columns[column]) ? 0 : 1;
            }
            if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE) {
                if (columnWidths[column] === 0) return 0;
                const fieldsTotalWidth = (0, ($parcel$interopDefault($gAFMM)))(columnWidths.slice(1, columnWidths.length - 1));
                const fieldsCollapsed = fieldsTotalWidth <= (0, $f3f8e80f7954f218$export$2f0383777c41eca4);
                if (fieldsCollapsed) {
                    if (column === 1) return numOfFields;
                    if (column > 1 && column < 1 + numOfFields) return 0;
                } else {
                    let numberOfNextZeroColumns = 0;
                    while(columnWidths[column + numberOfNextZeroColumns + 1] === 0)numberOfNextZeroColumns++;
                    return numberOfNextZeroColumns + 1;
                }
            }
            return 1;
        };
    const $2db40b9ac2cb80ad$export$3d88032e6be0ee47 = (columns)=>columns.map((column)=>{
            switch(column.tag){
                case 0, $f3f8e80f7954f218$export$1c5a554c78c0cd12:
                case 0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c:
                case 0, $f3f8e80f7954f218$export$ccb33e29d92c9a58:
                case 0, $f3f8e80f7954f218$export$4f4c16e273d7a49d:
                    return column.tag;
                default:
                    return column.payload.id;
            }
        });
    const $2db40b9ac2cb80ad$export$41658c9532196d27 = (nativeScrollbarHeight)=>{
        const bottom = nativeScrollbarHeight > 0 ? 0 : (0, $052b0dc4013b4e55$export$431561c46c4ed1a8);
        return {
            top: 0,
            right: 0,
            bottom: bottom,
            left: 0
        };
    };
    const $2db40b9ac2cb80ad$export$2491102f5e24761b = (nativeScrollbarHeight)=>{
        if (nativeScrollbarHeight > 0) return nativeScrollbarHeight;
        return 0, $052b0dc4013b4e55$export$431561c46c4ed1a8;
    };
});
const $052b0dc4013b4e55$export$431561c46c4ed1a8 = 30;
parcelRegister("hXzDb", function(module, exports) {
    $parcel$export(module.exports, "BackgroundProvider", ()=>$4ddf424b9157f599$export$4ded3678e030391);
    var $bC2fB;
    var $7irU4 = parcelRequire("7irU4");
    var $j9Djp = parcelRequire("j9Djp");
    const $4ddf424b9157f599$export$4ded3678e030391 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7irU4.default), {})((0, $j9Djp.BackgroundProvider));
});
parcelRegister("7irU4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$630008c7f7dabd83$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $l38L3 = parcelRequire("l38L3");
    var $630008c7f7dabd83$export$2e2bcd8739ae039 = (state, { issue: issue })=>({
            isOptimized: (()=>{
                if (!issue) return false;
                if ((0, $1CGdp.getMode)(state) === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771) && issue.optimized != null) for (const [optimizedKey, optimizedValue] of Object.entries(issue.optimized)){
                    if ((0, $l38L3.hasValueChanged)((0, $l38L3.getCurrentValue)(issue, optimizedKey), optimizedValue)) return true;
                }
                return false;
            })()
        });
});
parcelRegister("j9Djp", function(module, exports) {
    $parcel$export(module.exports, "BackgroundProvider", ()=>$577a9240dc376efb$export$4ded3678e030391);
    var $5uXOq = parcelRequire("5uXOq");
    var $3Mh6R;
    const $577a9240dc376efb$export$4ded3678e030391 = (0, $5uXOq.memo)(({ issue: issue, index: index, isOptimized: isOptimized, children: children })=>{
        const parentIndicator = (0, (0, parcelRequire("3Mh6R")).useParentIndicator)({
            id: issue?.id,
            index: index
        });
        const isEven = issue?.rootIndex === undefined ? false : issue.rootIndex % 2 === 0;
        if (parentIndicator) return children({
            base: parentIndicator.blocked ? `var(--ds-background-danger, ${(0, $829f609a65d26a98$exports).R50})` : `var(--ds-background-selected, ${(0, $829f609a65d26a98$exports).B50})`
        });
        if (!issue) return children({
            base: 'transparent'
        });
        if (isOptimized) return children({
            base: isEven ? 'transparent' : `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$exports).N20})`,
            hover: "var(--ds-surface-sunken, #f7f8f9)"
        });
        return children({
            base: isEven ? `var(--ds-surface, ${(0, $829f609a65d26a98$exports).N0})` : `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$exports).N20})`,
            hover: "var(--ds-surface-sunken, #f7f8f9)"
        });
    });
});
parcelRegister("4rz0F", function(module, exports) {
    $parcel$export(module.exports, "Collapsible", ()=>$b3698b0f3bc639d1$export$6eb0f7ddcda6131f);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $bQYPY = parcelRequire("bQYPY");
    var $7MfoP = parcelRequire("7MfoP");
    const $b3698b0f3bc639d1$export$6eb0f7ddcda6131f = ({ columnIds: columnIds, resizer: resizer, defaultColumnWidths: defaultColumnWidths, onColumnWidthsChange: onColumnWidthsChange, children: children })=>{
        const widths = (0, $bQYPY.useCollapsibleWidths)({
            preview: true
        });
        const CollapseProvider = (0, (0, parcelRequire("4R6GH")).fg)('plans_performance_improvements') ? (0, $7MfoP.CollapseProvider) : (0, $7MfoP.CollapseProviderOld);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(CollapseProvider, {
            singleton: false,
            widths: widths,
            defaultWidths: defaultColumnWidths,
            columnIds: columnIds,
            resizer: resizer,
            updateWidths: onColumnWidthsChange
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($b3698b0f3bc639d1$var$Observer, null));
    };
    const $b3698b0f3bc639d1$var$Observer = ()=>{
        const widths = (0, $bQYPY.useCollapsibleWidths)({
            preview: false
        });
        const { cache: cache } = (0, $7MfoP.useActions)();
        (0, $5uXOq.useEffect)(()=>{
            cache(widths);
        }, [
            cache,
            widths
        ]);
        return null;
    };
});
parcelRegister("bQYPY", function(module, exports) {
    $parcel$export(module.exports, "useCollapsibleWidths", ()=>$0e11dacaa8b10261$export$92a14435c018da2f);
    $parcel$export(module.exports, "useColumnToggle", ()=>$0e11dacaa8b10261$export$4abe84cff4268bc0);
    $parcel$export(module.exports, "useColumnCollapsedOld", ()=>$0e11dacaa8b10261$export$e09ebf85598cb6e2);
    var $5uXOq = parcelRequire("5uXOq");
    var $fTQlL = parcelRequire("fTQlL");
    var $gAFMM = parcelRequire("gAFMM");
    var $aI0i7;
    var $2EwIC;
    var $8LV9S;
    var $7MfoP = parcelRequire("7MfoP");
    const $0e11dacaa8b10261$export$92a14435c018da2f = ({ preview: preview })=>{
        const [widths] = (0, (0, parcelRequire("8LV9S")).useColumnWidths)({
            preview: preview
        });
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        return (0, $5uXOq.useMemo)(()=>{
            const withLastDropped = (0, ($parcel$interopDefault($fTQlL)))(1)(widths);
            const refinedTimelineWidth = viewport.width - (0, ($parcel$interopDefault($gAFMM)))(withLastDropped);
            return withLastDropped.concat([
                refinedTimelineWidth
            ]);
        }, [
            viewport.width,
            widths
        ]);
    };
    const $0e11dacaa8b10261$export$4abe84cff4268bc0 = ()=>{
        const [{ row: row, column: column }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const { expand: expand, collapse: collapse, expandFields: expandFields, collapseFields: collapseFields } = (0, $7MfoP.useActions)();
        const isFieldsSection = row === 0 && column === 1;
        return (0, $5uXOq.useCallback)((expanding)=>{
            if (isFieldsSection) expanding ? expandFields() : collapseFields();
            else expanding ? expand(column) : collapse(column);
        }, [
            isFieldsSection,
            column,
            expand,
            collapse,
            expandFields,
            collapseFields
        ]);
    };
    const $0e11dacaa8b10261$export$e09ebf85598cb6e2 = ()=>{
        const [{ column: column, colSpan: colSpan }] = (0, (0, parcelRequire("aI0i7")).useCellColumn)();
        const [isCollapsed] = (0, $7MfoP.useCollapsedOld)({
            column: column,
            colSpan: colSpan
        });
        return isCollapsed;
    };
});
parcelRegister("fTQlL", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $b93499b56007d16b$var$func = $lVx1a('dropRight', (parcelRequire("jRdDX")));
    $b93499b56007d16b$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $b93499b56007d16b$var$func;
});
parcelRegister("jRdDX", function(module, exports) {
    var $dM3Z8 = parcelRequire("dM3Z8");
    var $kPZpS = parcelRequire("kPZpS");
    function $e74d8cddb0dff2ce$var$dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) return [];
        n = guard || n === undefined ? 1 : $kPZpS(n);
        n = length - n;
        return $dM3Z8(array, 0, n < 0 ? 0 : n);
    }
    module.exports = $e74d8cddb0dff2ce$var$dropRight;
});
parcelRegister("7MfoP", function(module, exports) {
    $parcel$export(module.exports, "CollapseProviderOld", ()=>$8ccf3e627b091986$export$ced190953b285c55);
    $parcel$export(module.exports, "CollapseProvider", ()=>$8ccf3e627b091986$export$d66be23e8fecb9c6);
    $parcel$export(module.exports, "useActions", ()=>$8ccf3e627b091986$export$bc923229a7fa61e7);
    $parcel$export(module.exports, "useCollapsedOld", ()=>$8ccf3e627b091986$export$1db106f820c282aa);
    $parcel$export(module.exports, "useColumnCollapsed", ()=>$8ccf3e627b091986$export$ecb77434815050ce);
    var $9nsRP = parcelRequire("9nsRP");
    var $j0fbq = parcelRequire("j0fbq");
    var $gAFMM = parcelRequire("gAFMM");
    var $3sQ5x;
    var $gg7kZ;
    var $6dDSs;
    var $iXqE5;
    const $8ccf3e627b091986$var$isFieldColumn = (columnId)=>columnId !== (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d) && columnId !== (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12);
    const $8ccf3e627b091986$var$getCollapsed = (widths)=>{
        const result = {
            FIELDS: $8ccf3e627b091986$var$isCollapsed(widths, {
                column: 1,
                colSpan: widths.length - 2
            })
        };
        for(let column = 0; column < widths.length; column++)result[column] = $8ccf3e627b091986$var$isCollapsed(widths, {
            column: column,
            colSpan: 1
        });
        return result;
    };
    const $8ccf3e627b091986$export$e324594224ef24da = {
        cache: (widths)=>({ getState: getState, setState: setState })=>{
                const { columnIds: columnIds, columnsPrecollapsed: columnsPrecollapsed, fieldsPrecollapsed: fieldsPrecollapsed } = getState();
                const columns = {
                    ...columnsPrecollapsed
                };
                const fields = {
                    ...fieldsPrecollapsed
                };
                const isFieldsCollapsed = $8ccf3e627b091986$var$isCollapsed(widths, {
                    column: 1,
                    colSpan: columnIds.length - 2
                });
                columnIds.forEach((columnId, column)=>{
                    if ($8ccf3e627b091986$var$isFieldColumn(columnId) && !isFieldsCollapsed) fields[columnId] = widths[column];
                    if (!$8ccf3e627b091986$var$isCollapsed(widths, {
                        column: column,
                        colSpan: 1
                    })) columns[columnId] = widths[column];
                });
                setState({
                    columnsPrecollapsed: columns,
                    fieldsPrecollapsed: fields
                });
            },
        expand: (column)=>({ getState: getState, dispatch: dispatch })=>{
                const { defaultWidths: defaultWidths, widths: widths, columnIds: columnIds, columnsPrecollapsed: columnsPrecollapsed } = getState();
                const columnId = columnIds[column];
                const defaultWidth = columnId === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d) ? (0, $f3f8e80f7954f218$export$7e9bb1a73c1c68af) : defaultWidths[column];
                const width = columnsPrecollapsed[columnId] ?? defaultWidth;
                dispatch($8ccf3e627b091986$export$e324594224ef24da.resize(column, width - widths[column]));
            },
        collapse: (column)=>({ getState: getState, dispatch: dispatch })=>{
                const { widths: widths } = getState();
                dispatch($8ccf3e627b091986$export$e324594224ef24da.resize(column, (0, $f3f8e80f7954f218$export$1c6fd712f054cbca) - widths[column]));
            },
        expandFields: ()=>({ getState: getState })=>{
                const { defaultWidths: defaultWidths, widths: widths, columnIds: columnIds, fieldsPrecollapsed: fieldsPrecollapsed, updateWidths: updateWidths } = getState();
                const nextWidths = columnIds.map((columnId, index)=>{
                    if (!$8ccf3e627b091986$var$isFieldColumn(columnId)) return widths[index];
                    if (columnIds.length === 3) return defaultWidths[index];
                    return fieldsPrecollapsed[columnId] ?? defaultWidths[index];
                });
                updateWidths(nextWidths);
            },
        collapseFields: ()=>({ getState: getState, dispatch: dispatch })=>{
                const { widths: widths, columnIds: columnIds } = getState();
                const lastFieldColumnIndex = columnIds.length - 2;
                const fieldsSectionWidth = (0, ($parcel$interopDefault($gAFMM)))(widths.slice(1, widths.length - 1));
                const delta = (0, $f3f8e80f7954f218$export$2f0383777c41eca4) - fieldsSectionWidth;
                dispatch($8ccf3e627b091986$export$e324594224ef24da.resize(lastFieldColumnIndex, delta));
            },
        resize: (column, delta)=>({ getState: getState, dispatch: dispatch })=>{
                const { widths: widths, resizer: resizer, updateWidths: updateWidths } = getState();
                if (column === widths.length - 1) return dispatch($8ccf3e627b091986$export$e324594224ef24da.resize(column - 1, -delta));
                let nextWidths = resizer({
                    column: column,
                    delta: delta
                })(widths);
                const remaining = delta - (nextWidths[column] - widths[column]);
                if (remaining !== 0 && column > 0) {
                    nextWidths = resizer({
                        column: column - 1,
                        delta: -remaining
                    })(nextWidths);
                    nextWidths = resizer({
                        column: column,
                        delta: remaining
                    })(nextWidths);
                }
                updateWidths(nextWidths);
            }
    };
    const $8ccf3e627b091986$export$d4c72bab9d6cc13a = {
        singleton: true,
        columnIds: [],
        fieldsPrecollapsed: {},
        columnsPrecollapsed: {},
        defaultWidths: [],
        collapsed: {
            FIELDS: false
        },
        widths: [],
        resizer: ()=>(0, ($parcel$interopDefault($9nsRP))),
        updateWidths: (0, ($parcel$interopDefault($j0fbq)))
    };
    const $8ccf3e627b091986$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $8ccf3e627b091986$export$d4c72bab9d6cc13a,
        actions: $8ccf3e627b091986$export$e324594224ef24da
    });
    const $8ccf3e627b091986$export$ced190953b285c55 = (0, (0, parcelRequire("gg7kZ")).createContainer)($8ccf3e627b091986$var$store, {
        onInit: ()=>({ setState: setState }, state)=>setState(state),
        onUpdate: ()=>({ setState: setState }, state)=>setState(state)
    });
    const $8ccf3e627b091986$export$d66be23e8fecb9c6 = (0, (0, parcelRequire("gg7kZ")).createContainer)($8ccf3e627b091986$var$store, {
        onInit: ()=>({ setState: setState }, state)=>setState({
                    ...state,
                    collapsed: $8ccf3e627b091986$var$getCollapsed(state.widths)
                }),
        onUpdate: ()=>({ setState: setState }, state)=>setState({
                    ...state,
                    collapsed: $8ccf3e627b091986$var$getCollapsed(state.widths)
                })
    });
    const $8ccf3e627b091986$export$bc923229a7fa61e7 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($8ccf3e627b091986$var$store);
    const $8ccf3e627b091986$var$isCollapsed = (widths, { column: column, colSpan: colSpan })=>{
        const accumulatedColumnWidth = widths.slice(column, column + colSpan).reduce((acc, width = Infinity)=>Number.isFinite(acc) && Number.isFinite(width) ? acc + width : Infinity, 0);
        const fieldsSectionWidth = (0, ($parcel$interopDefault($gAFMM)))(widths.slice(1, widths.length - 1));
        if (column === 1) return accumulatedColumnWidth <= (0, $f3f8e80f7954f218$export$1c6fd712f054cbca) || fieldsSectionWidth <= (0, $f3f8e80f7954f218$export$2f0383777c41eca4);
        if (column === widths.length - 1) return accumulatedColumnWidth <= (0, $f3f8e80f7954f218$export$2f0383777c41eca4);
        return accumulatedColumnWidth <= (0, $f3f8e80f7954f218$export$1c6fd712f054cbca);
    };
    const $8ccf3e627b091986$var$selectIsCollapsed = (0, (0, parcelRequire("6dDSs")).createSelector)([
        (state)=>state.widths,
        (state)=>state.singleton,
        (_, { column: column, colSpan: colSpan })=>({
                column: column,
                colSpan: colSpan
            })
    ], (widths, singleton, { column: column, colSpan: colSpan })=>{
        if (singleton) return false;
        return $8ccf3e627b091986$var$isCollapsed(widths, {
            column: column,
            colSpan: colSpan
        });
    });
    const $8ccf3e627b091986$export$1db106f820c282aa = (0, (0, parcelRequire("3sQ5x")).createHook)($8ccf3e627b091986$var$store, {
        selector: $8ccf3e627b091986$var$selectIsCollapsed
    });
    const $8ccf3e627b091986$export$d483125a0e684051 = (0, (0, parcelRequire("6dDSs")).createSelector)([
        (state)=>state.collapsed,
        (_, { isHeader: isHeader, column: column })=>({
                isHeader: isHeader,
                column: column
            })
    ], (collapsed, { isHeader: isHeader, column: column })=>collapsed?.[isHeader && column === 1 ? 'FIELDS' : column] ?? false);
    const $8ccf3e627b091986$export$ecb77434815050ce = (0, (0, parcelRequire("3sQ5x")).createHook)($8ccf3e627b091986$var$store, {
        selector: $8ccf3e627b091986$export$d483125a0e684051
    });
});
parcelRegister("9nsRP", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $6d3ca776efbbaef4$var$func = $lVx1a('identity', (parcelRequire("etyzk")), (parcelRequire("bUoRH")));
    $6d3ca776efbbaef4$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $6d3ca776efbbaef4$var$func;
});
parcelRegister("cispL", function(module, exports) {
    $parcel$export(module.exports, "ColumnWidthsProvider", ()=>$a53ec2810cff59bc$export$9b0658a77dfa159c);
    var $bC2fB;
    var $39l6J = parcelRequire("39l6J");
    var $keRFx = parcelRequire("keRFx");
    var $9CJAw = parcelRequire("9CJAw");
    const $a53ec2810cff59bc$export$9b0658a77dfa159c = (0, (0, parcelRequire("bC2fB")).connect)((0, $keRFx.default), (0, $39l6J.default))((0, $9CJAw.ColumnWidthsProvider));
});
parcelRegister("39l6J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83d761ffa01b5723$export$2e2bcd8739ae039);
    var $jZ1Vy = parcelRequire("jZ1Vy");
    const $83d761ffa01b5723$var$mapDispatchToProps = {
        updateTopLevelColumnWidths: (0, $jZ1Vy.updateColumnWidths)
    };
    var $83d761ffa01b5723$export$2e2bcd8739ae039 = $83d761ffa01b5723$var$mapDispatchToProps;
});
parcelRegister("jZ1Vy", function(module, exports) {
    $parcel$export(module.exports, "updateColumnWidths", ()=>$f9dcde8c9331d790$export$6688b13ec132acdf);
    const $f9dcde8c9331d790$export$6688b13ec132acdf = (payload)=>({
            type: (0, $eaefe8f4970420bd$export$47640bb49c9df5f2),
            payload: payload
        });
});
const $eaefe8f4970420bd$export$47640bb49c9df5f2 = 'state.ui.column-widths.UPDATE_COLUMN_WIDTHS';
parcelRegister("keRFx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66a8cf8d10d2df20$export$2e2bcd8739ae039);
    var $3J2mc;
    var $1CGdp = parcelRequire("1CGdp");
    var $1l6AC = parcelRequire("1l6AC");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    const $66a8cf8d10d2df20$export$b3ecbe7edfda865e = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getViewMode),
        (0, $kWDpn.getTimeScaleViewSettings)
    ], (viewMode, timeScale)=>{
        if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST) return false;
        if (timeScale.mode) return timeScale.mode !== 'custom';
        return undefined;
    });
    var $66a8cf8d10d2df20$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        isExportMode: $1CGdp.isExportMode,
        hasScrollableTimeline: $66a8cf8d10d2df20$export$b3ecbe7edfda865e,
        timelineExportWidth: (0, $1l6AC.getTimelineExportWidth)
    });
});
parcelRegister("9CJAw", function(module, exports) {
    $parcel$export(module.exports, "ColumnWidthsProvider", ()=>$06fff15eb2585e7d$export$9b0658a77dfa159c);
    var $5uXOq = parcelRequire("5uXOq");
    var $fTQlL = parcelRequire("fTQlL");
    var $3J2mc;
    var $2EwIC;
    var $2bpVm = parcelRequire("2bpVm");
    var $3AnUH = parcelRequire("3AnUH");
    var $cqddl = parcelRequire("cqddl");
    const $06fff15eb2585e7d$export$9b0658a77dfa159c = ({ viewMode: viewMode, viewId: viewId, columnIds: columnIds, columns: columns, children: children, isExportMode: isExportMode, hasScrollableTimeline: hasScrollableTimeline, timelineExportWidth: timelineExportWidth, updateTopLevelColumnWidths: updateTopLevelColumnWidths })=>{
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const allowOverflowed = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST;
        const allowSqueezing = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE;
        const isTimelineExport = isExportMode && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE;
        const defaultWidths = (0, $5uXOq.useMemo)(()=>(0, $3AnUH.getColumnDefaultWidths)(columns, viewMode, hasScrollableTimeline ?? true), [
            columns,
            viewMode,
            hasScrollableTimeline
        ]);
        const minWidths = (0, $5uXOq.useMemo)(()=>(0, $3AnUH.getColumnMinWidths)(columns, viewMode, hasScrollableTimeline ?? true, isExportMode), [
            columns,
            viewMode,
            hasScrollableTimeline,
            isExportMode
        ]);
        const squeezedWidths = (0, $5uXOq.useMemo)(()=>allowSqueezing ? (0, $2bpVm.getSqueezedWidths)(minWidths) : undefined, [
            allowSqueezing,
            minWidths
        ]);
        const [columnWidths, setColumnWidths] = (0, $2bpVm.useColumnWidths)(viewId, viewMode, columnIds, defaultWidths, minWidths, squeezedWidths);
        const canSqueeze = (0, $5uXOq.useCallback)((columnBeingResized)=>allowSqueezing && columnBeingResized === columnIds.length - 2, [
            allowSqueezing,
            columnIds.length
        ]);
        const prioritizeRestoring = (0, $5uXOq.useCallback)((columnBeingResized)=>columnBeingResized > 0, []);
        const resizer = (0, $5uXOq.useMemo)(()=>(hasScrollableTimeline ? (0, $cqddl.withScrollableTimeline)((0, $cqddl.makeResizer)) : (0, $cqddl.makeResizer))(viewport, (columnBeingResized, widths)=>{
                if (allowSqueezing && canSqueeze(columnBeingResized)) return [
                    widths[0],
                    ...minWidths.slice(1)
                ];
                return minWidths;
            }, ()=>squeezedWidths, canSqueeze, prioritizeRestoring, allowOverflowed), [
            hasScrollableTimeline,
            viewport,
            canSqueeze,
            prioritizeRestoring,
            allowOverflowed,
            allowSqueezing,
            minWidths,
            squeezedWidths
        ]);
        const withViewportConstraint = (0, $5uXOq.useMemo)(()=>resizer({
                column: -1,
                delta: 0
            })(isTimelineExport ? [
                ...(0, ($parcel$interopDefault($fTQlL)))(1, columnWidths),
                timelineExportWidth
            ] : columnWidths), [
            columnWidths,
            resizer,
            isTimelineExport,
            timelineExportWidth
        ]);
        const { scope: scopeWidth, fields: fieldsWidth } = (0, $2bpVm.getTopLevelColumnWidths)(withViewportConstraint, viewMode);
        (0, $5uXOq.useEffect)(()=>{
            updateTopLevelColumnWidths({
                scope: scopeWidth,
                fields: fieldsWidth,
                timeline: 0
            });
        }, [
            fieldsWidth,
            scopeWidth,
            updateTopLevelColumnWidths
        ]);
        if (viewport.width === 0) return null;
        return children({
            value: withViewportConstraint,
            onChange: setColumnWidths,
            resizer: resizer,
            defaultValue: defaultWidths
        });
    };
});
parcelRegister("2bpVm", function(module, exports) {
    $parcel$export(module.exports, "useColumnWidths", ()=>$04380b317e68aa08$export$d598237875812773);
    $parcel$export(module.exports, "getSqueezedWidths", ()=>$04380b317e68aa08$export$507b4bc8c7682408);
    $parcel$export(module.exports, "getTopLevelColumnWidths", ()=>$04380b317e68aa08$export$8186204ae5773ef0);
    var $5uXOq = parcelRequire("5uXOq");
    var $krGUg = parcelRequire("krGUg");
    var $fTQlL = parcelRequire("fTQlL");
    var $dTOUt = parcelRequire("dTOUt");
    var $gAFMM = parcelRequire("gAFMM");
    var $3J2mc;
    var $cqddl = parcelRequire("cqddl");
    var $3o4CA = parcelRequire("3o4CA");
    const $04380b317e68aa08$export$d598237875812773 = (viewId, viewMode, columnIds, defaultWidths, minWidths, squeezedWidths)=>{
        const columnIdsRef = (0, $5uXOq.useRef)(columnIds);
        columnIdsRef.current = columnIds;
        const [prevColumnIds, setPrevColumnIds] = (0, $5uXOq.useState)();
        const [prevViewId, setPrevViewId] = (0, $5uXOq.useState)();
        const [prevViewMode, setPrevViewMode] = (0, $5uXOq.useState)();
        const [state, setState] = (0, $5uXOq.useState)([]);
        const updateState = (0, $5uXOq.useCallback)((next)=>{
            setState(next);
            $3o4CA.persist(viewId, viewMode, columnIds, defaultWidths, minWidths)(next);
        }, [
            columnIds,
            defaultWidths,
            minWidths,
            viewId,
            viewMode
        ]);
        if (viewId !== prevViewId || prevViewMode !== viewMode) {
            const isTemporaryView = viewId < 0;
            const hasJustCloned = viewId >= 0 && (prevViewId ?? 0) < 0;
            if (!isTemporaryView && !hasJustCloned) {
                const [columnWidths, totalFieldsWidth] = $3o4CA.load(viewId, viewMode, columnIds, defaultWidths, minWidths);
                if (columnWidths.length >= 3 && squeezedWidths && totalFieldsWidth !== undefined) {
                    const fields = (columns)=>(0, ($parcel$interopDefault($krGUg)))(1)((0, ($parcel$interopDefault($fTQlL)))(1)(columns));
                    const fieldsWidths = (0, $cqddl.shrink)(fields(minWidths), fields(squeezedWidths))(fields(columnWidths), totalFieldsWidth - (0, ($parcel$interopDefault($gAFMM)))(fields(columnWidths)));
                    columnWidths.splice(1, columnWidths.length - 2, ...fieldsWidths);
                }
                setState(columnWidths);
            }
            if (hasJustCloned) updateState(state);
            setPrevViewId(viewId);
            setPrevViewMode(viewMode);
            setPrevColumnIds(columnIds);
            return [
                state,
                updateState
            ];
        }
        if (!(0, ($parcel$interopDefault($dTOUt)))(columnIds, prevColumnIds)) {
            setPrevColumnIds(columnIds);
            setState((current)=>columnIds.map((columnId, index)=>Math.max(minWidths[index], current[(prevColumnIds ?? []).indexOf(columnId)] ?? defaultWidths[index])));
        }
        return [
            state,
            updateState
        ];
    };
    const $04380b317e68aa08$export$507b4bc8c7682408 = (minWidths)=>{
        const numberOfColumns = minWidths.length;
        return minWidths.map((minWidth, index)=>{
            if (index === 0) return minWidth;
            if (index === 1) return numberOfColumns === 3 ? (0, $f3f8e80f7954f218$export$2f0383777c41eca4) : (0, $f3f8e80f7954f218$export$1c6fd712f054cbca);
            if (index === 2) return numberOfColumns === 3 ? 0 : (0, $f3f8e80f7954f218$export$2f0383777c41eca4) - (0, $f3f8e80f7954f218$export$1c6fd712f054cbca);
            return 0;
        });
    };
    const $04380b317e68aa08$export$8186204ae5773ef0 = (columnWidths, viewMode)=>{
        const scope = columnWidths[0] ?? 0;
        const fields = (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE ? columnWidths.slice(1, -1) : columnWidths.slice(1)).reduce((width, widthSum)=>widthSum + width, 0);
        return {
            scope: scope,
            fields: fields,
            timeline: 0
        };
    };
});
parcelRegister("krGUg", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $ee279c93d28f55ec$var$func = $lVx1a('drop', (parcelRequire("6Z1fe")));
    $ee279c93d28f55ec$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $ee279c93d28f55ec$var$func;
});
parcelRegister("6Z1fe", function(module, exports) {
    var $dM3Z8 = parcelRequire("dM3Z8");
    var $kPZpS = parcelRequire("kPZpS");
    function $515967c07865fd93$var$drop(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) return [];
        n = guard || n === undefined ? 1 : $kPZpS(n);
        return $dM3Z8(array, n < 0 ? 0 : n, length);
    }
    module.exports = $515967c07865fd93$var$drop;
});
parcelRegister("cqddl", function(module, exports) {
    $parcel$export(module.exports, "shrink", ()=>$6e7930800e88418a$export$8b1f3092f5e28575);
    $parcel$export(module.exports, "makeResizer", ()=>$6e7930800e88418a$export$c958cd3feac5f3b3);
    $parcel$export(module.exports, "withScrollableTimeline", ()=>$6e7930800e88418a$export$c71bab19959a069c);
    var $fTQlL = parcelRequire("fTQlL");
    var $gAFMM = parcelRequire("gAFMM");
    const $6e7930800e88418a$export$8b1f3092f5e28575 = (minWidths, squeezedWidths)=>(widths, delta)=>{
            const result = [];
            let deductedDelta = delta;
            for(let i = widths.length - 1; i >= 0; i--){
                const current = widths[i];
                let next = current;
                if (current >= minWidths[i]) next = Math.max(current + deductedDelta, minWidths[i]);
                result[i] = next;
                deductedDelta = Math.min(deductedDelta + current - next, 0);
            }
            if (deductedDelta < 0 && squeezedWidths !== undefined) return $6e7930800e88418a$export$8b1f3092f5e28575(squeezedWidths)(result, deductedDelta);
            return result;
        };
    const $6e7930800e88418a$export$f5a3671eeb78c1ed = (viewportWidth, minWidth)=>(widths)=>{
            const result = [];
            const lastIndex = widths.length - 1;
            let remaining = viewportWidth;
            for(let i = 0; i < widths.length; i++){
                const width = widths[i];
                if (i === lastIndex) result[i] = Math.max(remaining, minWidth);
                else result[i] = width;
                remaining -= widths[i];
            }
            return result;
        };
    const $6e7930800e88418a$export$c958cd3feac5f3b3 = (viewport, getMinWidths, getSqueezedWidths, canSqueeze, prioritizeRestoring, overflowAllowed)=>({ column: column, delta: delta })=>(widths)=>{
                const minWidths = getMinWidths(column, widths);
                const squeezedWidths = getSqueezedWidths?.(column, widths);
                const left = (arr)=>arr.slice(0, column + 1);
                const right = (arr)=>arr.slice(column + 1);
                let refinedDelta = delta;
                if (!overflowAllowed) {
                    const maxAllowedDelta = viewport.width - (0, ($parcel$interopDefault($gAFMM)))(left(widths)) - (0, ($parcel$interopDefault($gAFMM)))(right(minWidths));
                    refinedDelta = Math.min(delta, maxAllowedDelta);
                }
                if (prioritizeRestoring(column)) {
                    for(let i = 0; i < widths.length; i++)if (widths[i] < minWidths[i] && delta > 0) {
                        const current = widths[i];
                        const deltaForCurrent = Math.min(refinedDelta, minWidths[i] - widths[i]);
                        return $6e7930800e88418a$export$c958cd3feac5f3b3(viewport, getMinWidths, getSqueezedWidths, canSqueeze, prioritizeRestoring, overflowAllowed)({
                            column: column,
                            delta: refinedDelta - deltaForCurrent
                        })([
                            ...widths.slice(0, i),
                            current + deltaForCurrent,
                            ...widths.slice(i + 1)
                        ]);
                    }
                }
                const leftResized = $6e7930800e88418a$export$8b1f3092f5e28575(left(minWidths), canSqueeze(column) ? squeezedWidths : minWidths)(left(widths), refinedDelta);
                let resized = [
                    ...leftResized,
                    ...right(widths)
                ];
                if (!overflowAllowed) {
                    const exceeded = (0, ($parcel$interopDefault($gAFMM)))(resized) - viewport.width;
                    resized = [
                        ...left(resized),
                        ...$6e7930800e88418a$export$8b1f3092f5e28575(right(minWidths))(right(widths), -exceeded)
                    ];
                }
                resized = $6e7930800e88418a$export$f5a3671eeb78c1ed(viewport.width, minWidths.at(-1) ?? 0)(resized);
                return resized;
            };
    const $6e7930800e88418a$export$c71bab19959a069c = (originalResizer)=>(viewport, getMinWidths, getSqueezedWidths, canSqueeze, prioritizeRestoring)=>({ column: column, delta: delta })=>(widths)=>{
                    const minTimelineColumnWidth = 32;
                    const proxiedMinWidths = (...args)=>(0, ($parcel$interopDefault($fTQlL)))(1)(getMinWidths(...args)).concat(minTimelineColumnWidth);
                    let proxiedWidths = (0, ($parcel$interopDefault($fTQlL)))(1)(widths);
                    proxiedWidths = proxiedWidths.concat(Math.max(viewport.width - (0, ($parcel$interopDefault($gAFMM)))(proxiedWidths), minTimelineColumnWidth));
                    const result = originalResizer(viewport, proxiedMinWidths, getSqueezedWidths, canSqueeze, prioritizeRestoring, false)({
                        column: column,
                        delta: delta
                    })(proxiedWidths);
                    return (0, ($parcel$interopDefault($fTQlL)))(1)(result).concat(4e6);
                };
});
parcelRegister("3o4CA", function(module, exports) {
    $parcel$export(module.exports, "load", ()=>$7803ad72c096be74$export$11e63f7b0f3d9900);
    $parcel$export(module.exports, "persist", ()=>$7803ad72c096be74$export$9a6132153fba2e0);
    var $gAFMM = parcelRequire("gAFMM");
    var $dJl1T;
    var $3J2mc;
    const $7803ad72c096be74$var$LOCALSTORAGE_PERSIST_KEY = 'persist:@portfolio/common/sections2';
    const $7803ad72c096be74$export$11e63f7b0f3d9900 = (viewId, viewMode, columnIds, defaultWidths, minWidths)=>{
        try {
            const storedData = JSON.parse(localStorage.getItem($7803ad72c096be74$var$LOCALSTORAGE_PERSIST_KEY) ?? '');
            const sections = JSON.parse(storedData.sections ?? '{}');
            const viewPrefix = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST ? '-list' : '';
            const mainKey = `view-${viewId}${viewPrefix}-main-sections`;
            const fieldsKey = `view-${viewId}${viewPrefix}-fields-section`;
            const normalizeWidth = (width, defaultWidth, minWidth)=>{
                const numbered = Number(width);
                return Number.isNaN(numbered) ? defaultWidth : Math.max(numbered, minWidth);
            };
            const totalFieldsWidth = normalizeWidth(sections?.[mainKey]?.widths['fields-column'] ?? sections?.[fieldsKey]?.totalWidth, undefined, 0);
            const columnWidths = columnIds.map((columnId, index)=>{
                if (columnId === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12)) return normalizeWidth(sections?.[mainKey]?.widths?.['scope-column'], defaultWidths[index], minWidths[index]);
                if (columnId === (0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c) && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST) return minWidths[index];
                if (columnId === (0, $f3f8e80f7954f218$export$ccb33e29d92c9a58) && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE) return totalFieldsWidth ?? 136;
                return normalizeWidth(sections?.[fieldsKey]?.widths?.[columnId], defaultWidths[index], minWidths[index]);
            });
            return [
                columnWidths,
                totalFieldsWidth
            ];
        } catch (error) {
            if (error instanceof Error) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('portfolio-3.table.column-widths-provider', 'Failed to get stored values for column widths', error);
            return [
                defaultWidths,
                undefined
            ];
        }
    };
    const $7803ad72c096be74$export$9a6132153fba2e0 = (viewId, viewMode, columnIds, defaultWidths, minWidths)=>(columnWidths)=>{
            try {
                const storedData = JSON.parse(localStorage.getItem($7803ad72c096be74$var$LOCALSTORAGE_PERSIST_KEY) || '{}');
                const sections = JSON.parse(storedData.sections || '{}');
                const viewPrefix = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST ? '-list' : '';
                const mainKey = `view-${viewId}${viewPrefix}-main-sections`;
                const fieldsKey = `view-${viewId}${viewPrefix}-fields-section`;
                if (!sections[mainKey]?.widths) sections[mainKey] = {
                    widths: {}
                };
                if (!sections[fieldsKey]?.widths) sections[fieldsKey] = {
                    widths: {}
                };
                sections[fieldsKey].totalWidth = (0, ($parcel$interopDefault($gAFMM)))(columnWidths.slice(1, columnWidths.length - 1));
                sections[mainKey].widths['fields-column'] = sections[fieldsKey].totalWidth;
                columnIds.forEach((columnId, index)=>{
                    const width = Math.max(columnWidths[index], minWidths[index]);
                    if (columnId === (0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c) && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST) return undefined;
                    if (columnId === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12)) sections[mainKey].widths['scope-column'] = width;
                    sections[fieldsKey].widths[columnId] = width;
                });
                storedData.sections = JSON.stringify(sections);
                localStorage.setItem($7803ad72c096be74$var$LOCALSTORAGE_PERSIST_KEY, JSON.stringify(storedData));
            } catch (error) {
                if (error instanceof Error) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('portfolio-3.table.column-widths-provider', 'Failed to set stored values for column widths', error);
            }
        };
});
parcelRegister("3AnUH", function(module, exports) {
    $parcel$export(module.exports, "getColumnDefaultWidths", ()=>$db8cc3c7bff3bebc$export$76485c98952a7c7e);
    $parcel$export(module.exports, "getColumnMinWidths", ()=>$db8cc3c7bff3bebc$export$dcfa728dc5e39e28);
    var $3J2mc;
    var $d3UHJ = parcelRequire("d3UHJ");
    const $db8cc3c7bff3bebc$export$76485c98952a7c7e = (columns, viewMode, hasScrollableTimeline)=>columns.map((column)=>{
            if (column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12)) return 300;
            if (column.tag === (0, $f3f8e80f7954f218$export$ccb33e29d92c9a58)) return 136;
            if (column.tag === (0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c)) return 0;
            if (column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d)) return hasScrollableTimeline ? 4e6 : (0, $f3f8e80f7954f218$export$2f0383777c41eca4);
            return (0, $d3UHJ.getDefaultWidth)(column.payload.id, viewMode);
        });
    const $db8cc3c7bff3bebc$export$dcfa728dc5e39e28 = (columns, viewMode, hasScrollableTimeline, isExportMode)=>columns.map((column, index)=>{
            if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE && columns.length === 3 && index === 1) return 0, $f3f8e80f7954f218$export$2f0383777c41eca4;
            if (column.tag === (0, $f3f8e80f7954f218$export$1c5a554c78c0cd12)) return 300;
            if (column.tag === (0, $f3f8e80f7954f218$export$ccb33e29d92c9a58)) return 136;
            if (column.tag === (0, $f3f8e80f7954f218$export$5a619ff7a6fbfc2c)) return 136;
            if (column.tag === (0, $f3f8e80f7954f218$export$4f4c16e273d7a49d)) {
                if (isExportMode) return 0;
                return hasScrollableTimeline ? 4e6 : (0, $f3f8e80f7954f218$export$2f0383777c41eca4);
            }
            const isCollapsible = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE;
            return (0, $d3UHJ.getMinWidth)(column.payload.id, isCollapsible, viewMode);
        });
});
parcelRegister("h3GjG", function(module, exports) {
    $parcel$export(module.exports, "DependencyDragCreate", ()=>$a50d5a099ee7334f$export$198fc62c34e2c7ff);
    var $bC2fB;
    var $f3FX0 = parcelRequire("f3FX0");
    var $jEXEU = parcelRequire("jEXEU");
    var $f2XJn = parcelRequire("f2XJn");
    const $a50d5a099ee7334f$export$198fc62c34e2c7ff = (0, (0, parcelRequire("bC2fB")).connect)((0, $jEXEU.mapStateToProps), (0, $f3FX0.mapDispatchToProps))((0, $f2XJn.DependencyDragCreate));
});
parcelRegister("f3FX0", function(module, exports) {
    $parcel$export(module.exports, "mapDispatchToProps", ()=>$4efe9e81e09d93ed$export$9e6a17cf56877796);
    var $eS9xr = parcelRequire("eS9xr");
    const $4efe9e81e09d93ed$export$9e6a17cf56877796 = {
        addIssueLink: $eS9xr.addIssueLink
    };
});
parcelRegister("jEXEU", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$b2e85da180040c58$export$c31df4bd766f9c35);
    var $ddv1K = parcelRequire("ddv1K");
    var $jpgxP = parcelRequire("jpgxP");
    var $6iNxz = parcelRequire("6iNxz");
    var $3YtPS = parcelRequire("3YtPS");
    const $b2e85da180040c58$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        items: (0, $6iNxz.getTableItems),
        outgoingLinks: (0, $ddv1K.getOutgoingLinks),
        dependencySettings: (0, $jpgxP.getDependencySettingsInfo)
    });
});
parcelRegister("f2XJn", function(module, exports) {
    $parcel$export(module.exports, "DependencyDragCreate", ()=>$41faad26265e2455$export$198fc62c34e2c7ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $8vyMo;
    var $HQByC = parcelRequire("HQByC");
    const $41faad26265e2455$export$198fc62c34e2c7ff = ({ rows: rows, items: items, addIssueLink: addIssueLink, outgoingLinks: outgoingLinks, dependencySettings: dependencySettings })=>{
        const handleDrop = (0, $HQByC.useDropHandling)(addIssueLink, outgoingLinks, dependencySettings);
        (0, $5uXOq.useEffect)(()=>(0, (0, parcelRequire("8vyMo")).monitorForDependencyCreate)({
                onDrop: ({ source: source, location: location })=>{
                    const { position: position, issueLinkType: issueLinkType } = source.data;
                    const target = location.current.dropTargets[0];
                    if (!target) return;
                    if (position !== 'start' && position !== 'end') return;
                    if (typeof issueLinkType !== 'number') return;
                    if (!(0, $HQByC.isDragCreatePayload)(target.data) || !(0, $HQByC.isDragCreatePayload)(source.data)) return;
                    const sourceIssue = (0, $HQByC.getIssue)(rows, items, source.data.row);
                    const targetIssue = (0, $HQByC.getIssue)(rows, items, target.data.row);
                    if (!sourceIssue || !targetIssue) return;
                    handleDrop({
                        dragSourcePosition: position,
                        dragSourceIssueId: sourceIssue.id,
                        dropTargetIssueId: targetIssue.id,
                        issueLinkType: issueLinkType
                    });
                }
            }), [
            handleDrop,
            items,
            rows
        ]);
        return null;
    };
});
parcelRegister("HQByC", function(module, exports) {
    $parcel$export(module.exports, "isDragCreatePayload", ()=>$da57d39d9a1da336$export$26d198b4b4a105bd);
    $parcel$export(module.exports, "getIssue", ()=>$da57d39d9a1da336$export$34403cb88b30d33b);
    $parcel$export(module.exports, "useDropHandling", ()=>$da57d39d9a1da336$export$5048b513d451ea75);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $6iNxz = parcelRequire("6iNxz");
    var $5pcBc = parcelRequire("5pcBc");
    const $da57d39d9a1da336$var$DEPENDENCY_CREATION_ERROR_FLAG_ID = 'dragPreviewDependencyCreationErrorFlag';
    const $da57d39d9a1da336$export$26d198b4b4a105bd = (data)=>{
        if (typeof data !== 'object' || data === null) return false;
        if (!('row' in data) || typeof data.row !== 'number') return false;
        return true;
    };
    const $da57d39d9a1da336$export$397fdf5288bc3736 = (item)=>item?.tag === (0, $6iNxz.TABLE_ISSUE) ? item.value : undefined;
    const $da57d39d9a1da336$export$34403cb88b30d33b = (rows, items, rowIndex)=>{
        const row = rows[rowIndex];
        if (row?.tag !== (0, $f3f8e80f7954f218$export$867af8e076780d5d)) return undefined;
        const item = items[row.payload.itemIndex];
        if (item?.tag !== (0, $6iNxz.TABLE_ISSUE)) return undefined;
        return item.value;
    };
    const $da57d39d9a1da336$export$5048b513d451ea75 = (addIssueLink, outgoingLinks, dependencySettings)=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        return (0, $5uXOq.useCallback)(({ dragSourcePosition: dragSourcePosition, dragSourceIssueId: dragSourceIssueId, dropTargetIssueId: dropTargetIssueId, issueLinkType: issueLinkType })=>{
            if (dropTargetIssueId == null || dragSourceIssueId == null) return false;
            const [source, target] = dragSourcePosition === 'end' ? [
                dragSourceIssueId,
                dropTargetIssueId
            ] : [
                dropTargetIssueId,
                dragSourceIssueId
            ];
            if (source === target) return false;
            const outgoingLinksForItem = outgoingLinks[source] || [];
            const existingLinkArray = outgoingLinksForItem.filter((link)=>link.targetItemKey === target && link.type === issueLinkType);
            if (existingLinkArray.length > 0) return false;
            const dependencyIssueLinkTypes = dependencySettings.dependencyIssueLinkTypes ?? [];
            const hasIssueLinkTypeConfigured = dependencyIssueLinkTypes.find((linkType)=>linkType.issueLinkTypeId === issueLinkType);
            if (!hasIssueLinkTypeConfigured) {
                showFlag({
                    id: $da57d39d9a1da336$var$DEPENDENCY_CREATION_ERROR_FLAG_ID,
                    title: (0, $5pcBc.default).noLinkTypeFlagTitle,
                    type: 'error',
                    description: (0, $5pcBc.default).noLinkTypeFlagDescription,
                    isAutoDismiss: true,
                    actions: [
                        {
                            content: (0, $5pcBc.default).noLinkTypeFlagLink,
                            href: 'https://support.atlassian.com/jira-software-cloud/docs/configure-dependencies-in-jira-for-advanced-roadmaps/',
                            target: '_blank'
                        }
                    ]
                });
                return false;
            }
            addIssueLink({
                sourceItemKey: source,
                targetItemKey: target,
                type: issueLinkType
            });
            return true;
        }, [
            addIssueLink,
            outgoingLinks,
            showFlag,
            dependencySettings?.dependencyIssueLinkTypes
        ]);
    };
});
parcelRegister("dQp5d", function(module, exports) {
    $parcel$export(module.exports, "AutoScrollObserver", ()=>$3b18c7becefb04e8$export$3659071cb5d1608c);
    var $6mYSR;
    const $3b18c7becefb04e8$export$3659071cb5d1608c = ({ scrollRef: scrollRef })=>{
        (0, (0, parcelRequire("6mYSR")).useDragAndDropAutoScroll)(scrollRef, 'vertical');
        return null;
    };
});
parcelRegister("74EGL", function(module, exports) {
    $parcel$export(module.exports, "DragScrollLock", ()=>$611d3567dd321241$export$c9b49b670b9c59fd);
    var $5uXOq = parcelRequire("5uXOq");
    var $f9Tpd;
    var $3Mh6R;
    const $611d3567dd321241$export$c9b49b670b9c59fd = ()=>{
        const isDragging = (0, (0, parcelRequire("3Mh6R")).useIsDragging)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9Tpd")).default), {
            axis: "horizontal",
            enabled: isDragging
        });
    };
});
parcelRegister("cyHFd", function(module, exports) {
    $parcel$export(module.exports, "DragAndDropProvider", ()=>$0aa44b1a4ddfc13d$export$a060f930f4360ebe);
    var $bC2fB;
    var $bYEbU = parcelRequire("bYEbU");
    var $9QYog = parcelRequire("9QYog");
    var $6zNEV = parcelRequire("6zNEV");
    const $0aa44b1a4ddfc13d$export$a060f930f4360ebe = (0, (0, parcelRequire("bC2fB")).connect)((0, $9QYog.default), (0, $bYEbU.default))((0, $6zNEV.DragAndDropProvider));
});
parcelRegister("bYEbU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47c7ac802799fbff$export$2e2bcd8739ae039);
    var $bkasS = parcelRequire("bkasS");
    var $fI3Hm = parcelRequire("fI3Hm");
    const $47c7ac802799fbff$var$mapDispatchToProps = {
        onMove: (0, $bkasS.moveIssue),
        onInvalidRanking: (0, $fI3Hm.addFlag)
    };
    var $47c7ac802799fbff$export$2e2bcd8739ae039 = $47c7ac802799fbff$var$mapDispatchToProps;
});
parcelRegister("9QYog", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ccf4e4681e39bb6$export$2e2bcd8739ae039);
    var $eDjFz = parcelRequire("eDjFz");
    var $4ENQh;
    var $6Ayrn = parcelRequire("6Ayrn");
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $jLI87 = parcelRequire("jLI87");
    var $6iNxz = parcelRequire("6iNxz");
    var $j0XCX = parcelRequire("j0XCX");
    var $bREsp = parcelRequire("bREsp");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    const $9ccf4e4681e39bb6$export$8448badc5d8eb2d6 = (tableItems, issueTypes, projects, hierarchyLevelsByLevel)=>{
        const id = (0, ($parcel$interopDefault($eDjFz)))('id');
        const issueTypesById = (0, $4nDwW.indexBy)(id, issueTypes);
        const projectsById = (0, $4nDwW.indexBy)(id, projects);
        const enhance = (issue)=>{
            const result = {};
            for (const key of Object.keys(issue))result[key] = issue[key];
            result.type = issueTypesById[issue.type] || (0, $bREsp.DEFAULT_SCRATCH_ISSUE_TYPE);
            result.project = projectsById[issue.project];
            return result;
        };
        return tableItems.map((item)=>{
            switch(item.tag){
                case 0, $6iNxz.TABLE_ISSUE:
                    {
                        const { tag: tag, value: issue, group: group, parentGroup: parentGroup, groupCombination: groupCombination } = item;
                        const enhancedIssue = {
                            tag: tag,
                            value: enhance(issue),
                            group: group,
                            parentGroup: parentGroup,
                            groupCombination: groupCombination
                        };
                        return enhancedIssue;
                    }
                case 0, $6iNxz.TABLE_GROUP_HEADER:
                    {
                        const { tag: tag, value: { id: id, isExpanded: isExpanded, level: level, rootIssuesCount: rootIssuesCount }, group: group, parentGroup: parentGroup } = item;
                        const enhancedHeader = {
                            tag: tag,
                            value: {
                                id: id,
                                isExpanded: isExpanded,
                                level: hierarchyLevelsByLevel[level],
                                rootIssuesCount: rootIssuesCount
                            },
                            group: group,
                            parentGroup: parentGroup
                        };
                        return enhancedHeader;
                    }
                default:
                    return item;
            }
        });
    };
    const $9ccf4e4681e39bb6$export$1e3085667260a419 = (0, (0, parcelRequire("4ENQh")).monitor).timeFunction($9ccf4e4681e39bb6$export$8448badc5d8eb2d6, 'roadmap_scope_issues_query_getEnhancedIssuesPure');
    const $9ccf4e4681e39bb6$export$39b2928f3df68999 = (0, $3YtPS.createSelector)([
        (0, $6iNxz.getTableItems),
        (0, $kllqP.getIssueTypes),
        (0, $jpXKt.getProjects),
        (0, $6Ayrn.getHierarchyLevelsByLevel)
    ], $9ccf4e4681e39bb6$export$1e3085667260a419);
    var $9ccf4e4681e39bb6$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        $9ccf4e4681e39bb6$export$39b2928f3df68999,
        (0, $6iNxz.getDisableDnD),
        (0, $jLI87.getScope),
        (0, $j0XCX.getVisualisationSorting)
    ], (issues, disableDnD, scope, sorting)=>({
            disableDnD: disableDnD,
            issues: issues,
            startLevel: scope.startLevelIssues.level,
            sorting: sorting
        }));
});
parcelRegister("6zNEV", function(module, exports) {
    $parcel$export(module.exports, "DragAndDropProvider", ()=>$1435a769e0067da1$export$a060f930f4360ebe);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $6mYSR;
    var $hQn2A;
    var $KrpYl = parcelRequire("KrpYl");
    var $kBUyj = parcelRequire("kBUyj");
    var $f1kEW = parcelRequire("f1kEW");
    const $1435a769e0067da1$var$DragAndDropProviderInternal = (props)=>{
        const { children: children, issues: issues, sorting: sorting, onMove: onMove, onInvalidRanking: onInvalidRanking } = props;
        const dropStateRef = (0, $5uXOq.useRef)((0, $kBUyj.initialDropState));
        const getDropState = (0, $5uXOq.useCallback)(()=>dropStateRef.current, [
            dropStateRef
        ]);
        const setDropState = (0, $5uXOq.useCallback)((dropState)=>{
            dropStateRef.current = dropState;
        }, [
            dropStateRef
        ]);
        const computeDropState = (0, $5uXOq.useCallback)((dragTarget, dropTarget)=>{
            if (!(0, $KrpYl.isSortByRank)(sorting.field)) return 0, $kBUyj.initialDropState;
            const parameters = {
                dragTarget: dragTarget,
                dropTarget: dropTarget
            };
            const oldParameters = dropStateRef.current.parameters;
            if (!(0, ($parcel$interopDefault($ajpes)))(parameters, oldParameters)) dropStateRef.current = (0, $f1kEW.getNewDropState)(issues, parameters);
            return dropStateRef.current;
        }, [
            issues,
            sorting,
            dropStateRef
        ]);
        const getIndicators = (0, $5uXOq.useCallback)((dragTarget, dropTarget)=>{
            const { indicators: indicators } = computeDropState(dragTarget, dropTarget);
            return indicators;
        }, [
            computeDropState
        ]);
        const onDragStart = (0, $5uXOq.useCallback)(()=>{
            (0, $f1kEW.disableUserSelection)(true);
            if (!(0, $KrpYl.isSortByRank)(sorting.field)) onInvalidRanking({
                key: (0, $9e169ee721864a4b$export$5d75f74c1d4d448d)
            });
        }, [
            onInvalidRanking,
            sorting
        ]);
        const onDrag = (0, $5uXOq.useCallback)((dragTarget, dropTarget)=>{
            computeDropState(dragTarget, dropTarget);
        }, [
            computeDropState
        ]);
        const onDrop = (0, $5uXOq.useCallback)((dragTarget, dropTarget)=>{
            (0, $f1kEW.disableUserSelection)(false);
            if (!dropTarget) {
                setDropState((0, $kBUyj.initialDropState));
                return;
            }
            const { type: type, action: action, blocked: blocked } = getDropState();
            if (type !== (0, $63f186813d17e3fe$export$6182a67c5764bd0f) && action && !blocked && (0, $KrpYl.isSortByRank)(sorting.field)) onMove({
                ...action,
                dragAndDrop: true
            });
            if (blocked !== undefined) switch(blocked.reason){
                case 0, $df54714521c59c27$export$73be6a137cb5279e:
                    {
                        const { context: context } = blocked;
                        onInvalidRanking({
                            key: (0, $9e169ee721864a4b$export$8a72c64e90d56fab),
                            context: {
                                ...context,
                                issueKey: (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, context.issueKey)
                            }
                        });
                        break;
                    }
                case 0, $df54714521c59c27$export$2a990a1f401d71c8:
                    {
                        const { context: context } = blocked;
                        onInvalidRanking({
                            key: (0, $9e169ee721864a4b$export$ac1a967dceae5708),
                            context: {
                                ...context,
                                issueKey: (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, context.issueKey)
                            }
                        });
                        break;
                    }
                default:
                    break;
            }
            setDropState((0, $kBUyj.initialDropState));
        }, [
            getDropState,
            onInvalidRanking,
            onMove,
            setDropState,
            sorting
        ]);
        (0, (0, parcelRequire("6mYSR")).useDragAndDropMonitor)({
            onDragStart: onDragStart,
            onDrag: onDrag,
            onDrop: onDrop,
            getIndicators: getIndicators
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $1435a769e0067da1$export$a060f930f4360ebe = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hQn2A")).DragAndDropContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($1435a769e0067da1$var$DragAndDropProviderInternal, props, children));
});
const $63f186813d17e3fe$export$2c56a3da224d2361 = 'view.main.tabs.roadmap.scope.issues.DROP_INVALID_SIBLING';
const $63f186813d17e3fe$export$818ea92c669038b0 = 'view.main.tabs.roadmap.scope.issues.DROP_INVALID_CHILD';
const $63f186813d17e3fe$export$d4ead6ccaed25c5f = 'view.main.tabs.roadmap.scope.issues.DROP_SIBLING';
const $63f186813d17e3fe$export$56b564d4a01df705 = 'view.main.tabs.roadmap.scope.issues.DROP_CHILD';
const $63f186813d17e3fe$export$6182a67c5764bd0f = 'view.main.tabs.roadmap.scope.issues.DROP_NONE';
const $63f186813d17e3fe$export$8c3e240870cf415c = 'REPARENT_TMP_TO_EXTERNAL_ERROR';
const $63f186813d17e3fe$export$5f5b0f14f53c9487 = 'REPARENT_CMP_TO_TMP_ERROR';
parcelRegister("KrpYl", function(module, exports) {
    $parcel$export(module.exports, "isTableGroupItem", ()=>$af271fd5c46bc4c2$export$e38ba878103876f0);
    $parcel$export(module.exports, "isSortByRank", ()=>$af271fd5c46bc4c2$export$3016207d237b956b);
    $parcel$export(module.exports, "getNewDropState", ()=>$af271fd5c46bc4c2$export$b4d00e619e08b746);
    var $c12LJ;
    var $6iNxz = parcelRequire("6iNxz");
    var $bstHg = parcelRequire("bstHg");
    function $af271fd5c46bc4c2$export$e38ba878103876f0(issue) {
        return 'height' in issue;
    }
    const $af271fd5c46bc4c2$export$217282697bf60d2 = (index, newIndex)=>{
        if (newIndex > index) return {
            indexBefore: newIndex,
            indexAfter: newIndex + 1
        };
        if (newIndex < index) return {
            indexBefore: newIndex - 1,
            indexAfter: newIndex
        };
        return {
            indexBefore: newIndex - 1,
            indexAfter: newIndex + 1
        };
    };
    const $af271fd5c46bc4c2$var$getRelativePosition = ({ issue: issue, itemBefore: itemBefore, itemAfter: itemAfter })=>{
        if (itemAfter?.tag === (0, $6iNxz.TABLE_ISSUE) && issue.value.level === itemAfter.value.level) return {
            anchor: itemAfter.value.id,
            relation: 'BEFORE'
        };
        if (itemBefore?.tag === (0, $6iNxz.TABLE_ISSUE)) return {
            anchor: itemBefore.value.id,
            relation: 'AFTER'
        };
        return {
            anchor: undefined,
            relation: 'LAST'
        };
    };
    const $af271fd5c46bc4c2$var$findPreviousSibling = (items, startIndex, id, level)=>{
        for(let i = startIndex; i >= 0; i--){
            const item = items[i];
            if (item?.tag === (0, $6iNxz.TABLE_ISSUE)) {
                const itemIsNotSelf = item.value.id !== id;
                const itemIsSameLevel = item.value.level === level;
                if (itemIsNotSelf && itemIsSameLevel) return item;
                if (item.value.level > level) return undefined;
            } else return undefined;
        }
        return undefined;
    };
    const $af271fd5c46bc4c2$var$getReparentDropState = ({ issue: issue, parentProject: parentProject, parentId: parentId })=>{
        const { value: { project: project, level: level } } = issue;
        if (parentId !== undefined) {
            if (level !== (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL)) {
                if (project.isSimplified && project.id !== parentProject.id) return {
                    parentId: null,
                    type: (0, $63f186813d17e3fe$export$818ea92c669038b0),
                    errorType: (0, $63f186813d17e3fe$export$8c3e240870cf415c)
                };
                if (!project.isSimplified && parentProject.isSimplified) return {
                    parentId: null,
                    type: (0, $63f186813d17e3fe$export$818ea92c669038b0),
                    errorType: (0, $63f186813d17e3fe$export$5f5b0f14f53c9487)
                };
            }
        }
        return {
            parentId: parentId,
            type: (0, $63f186813d17e3fe$export$56b564d4a01df705),
            errorType: null
        };
    };
    const $af271fd5c46bc4c2$export$3016207d237b956b = (sortByField)=>sortByField === (0, $bstHg.ISSUE_FIELDS).RANK;
    const $af271fd5c46bc4c2$export$b4d00e619e08b746 = ({ items: items, index: index, newIndex: newIndex, startLevel: startLevel })=>{
        const draggedItem = items[index];
        if (draggedItem?.tag !== (0, $6iNxz.TABLE_ISSUE)) throw new Error(`Dragged item  was expected to be ${(0, $6iNxz.TABLE_ISSUE)}, but was ${draggedItem.tag}.`);
        const { value: { id: id, level: level, parent: parent }, group: group } = draggedItem;
        const defaultDropState = {
            id: id,
            group: group,
            parentId: parent,
            anchor: undefined,
            relation: null,
            type: (0, $63f186813d17e3fe$export$6182a67c5764bd0f),
            errorType: null
        };
        const invalidDropState = {
            ...defaultDropState,
            type: (0, $63f186813d17e3fe$export$2c56a3da224d2361)
        };
        if (index === newIndex) return defaultDropState;
        const { indexBefore: indexBefore, indexAfter: indexAfter } = $af271fd5c46bc4c2$export$217282697bf60d2(index, newIndex);
        const itemBefore = items[indexBefore];
        const itemAfter = items[indexAfter];
        const isDropInSameGroup = group === itemBefore?.group;
        if (!isDropInSameGroup) return invalidDropState;
        const isDropAtStart = newIndex === 0;
        const isDropAfterGroup = itemBefore?.tag === (0, $6iNxz.TABLE_GROUP);
        if (isDropAtStart || isDropAfterGroup) {
            if (level === startLevel) return {
                ...defaultDropState,
                ...$af271fd5c46bc4c2$var$getRelativePosition({
                    issue: draggedItem,
                    itemAfter: itemAfter
                }),
                parentId: null,
                type: (0, $63f186813d17e3fe$export$d4ead6ccaed25c5f)
            };
            return invalidDropState;
        }
        const isDropAfterGroupHeader = itemBefore?.tag === (0, $6iNxz.TABLE_GROUP_HEADER);
        if (isDropAfterGroupHeader) {
            const { value: { level: { level: groupHeaderLevel } } } = itemBefore;
            const willOrphanSubtask = level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL);
            if (level === groupHeaderLevel && !willOrphanSubtask) return {
                ...defaultDropState,
                ...$af271fd5c46bc4c2$var$getRelativePosition({
                    issue: draggedItem,
                    itemAfter: itemAfter
                }),
                parentId: null,
                type: (0, $63f186813d17e3fe$export$d4ead6ccaed25c5f)
            };
            return invalidDropState;
        }
        const isDropAfterIssue = itemBefore?.tag === (0, $6iNxz.TABLE_ISSUE);
        if (isDropAfterIssue) {
            const { value: { id: issueBeforeId, level: issueBeforeLevel, project: issueBeforeProject } } = itemBefore;
            const isReparent = level === issueBeforeLevel - 1;
            if (isReparent) {
                const reparentState = $af271fd5c46bc4c2$var$getReparentDropState({
                    issue: draggedItem,
                    parentProject: issueBeforeProject,
                    parentId: issueBeforeId
                });
                return reparentState.errorType === null ? {
                    ...defaultDropState,
                    ...reparentState,
                    ...$af271fd5c46bc4c2$var$getRelativePosition({
                        issue: draggedItem,
                        itemBefore: itemBefore,
                        itemAfter: itemAfter
                    })
                } : {
                    ...defaultDropState,
                    ...reparentState
                };
            }
            const isInsertBetweenParentAndChild = itemAfter?.tag === (0, $6iNxz.TABLE_ISSUE) && level > itemAfter.value.level;
            if (!isInsertBetweenParentAndChild) {
                const sibling = $af271fd5c46bc4c2$var$findPreviousSibling(items, indexBefore, id, level);
                if (sibling !== undefined) {
                    const { value: { project: siblingProject, parent: siblingParent } } = sibling;
                    const willOrphanSubtask = level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL) && siblingParent === undefined;
                    if (willOrphanSubtask) return invalidDropState;
                    const isAlsoReparent = parent !== siblingParent;
                    if (isAlsoReparent) {
                        const reparentState = $af271fd5c46bc4c2$var$getReparentDropState({
                            issue: draggedItem,
                            parentProject: siblingProject,
                            parentId: siblingParent
                        });
                        return reparentState.errorType === null ? {
                            ...defaultDropState,
                            ...reparentState,
                            ...$af271fd5c46bc4c2$var$getRelativePosition({
                                issue: draggedItem,
                                itemBefore: itemBefore,
                                itemAfter: itemAfter
                            })
                        } : {
                            ...defaultDropState,
                            ...reparentState
                        };
                    }
                    return {
                        ...defaultDropState,
                        ...$af271fd5c46bc4c2$var$getRelativePosition({
                            issue: draggedItem,
                            itemBefore: itemBefore,
                            itemAfter: itemAfter
                        }),
                        type: (0, $63f186813d17e3fe$export$d4ead6ccaed25c5f)
                    };
                }
            }
        }
        return invalidDropState;
    };
});
parcelRegister("kBUyj", function(module, exports) {
    $parcel$export(module.exports, "initialDropState", ()=>$28184ff3cfa9fe4a$export$9bfc48465d72b9d6);
    $parcel$export(module.exports, "HEADER_ROWS", ()=>$28184ff3cfa9fe4a$export$dcd2c52bd968bbf0);
    const $28184ff3cfa9fe4a$export$9bfc48465d72b9d6 = {
        type: (0, $63f186813d17e3fe$export$6182a67c5764bd0f)
    };
    const $28184ff3cfa9fe4a$export$dcd2c52bd968bbf0 = 2;
});
const $df54714521c59c27$export$1868bd20d88499 = 'CHANGED_GROUP';
const $df54714521c59c27$export$b74126d79e8aaada = 'ORPHANED_SUBTASK';
const $df54714521c59c27$export$73be6a137cb5279e = 'REPARENT_TMP_TO_EXTERNAL';
const $df54714521c59c27$export$2a990a1f401d71c8 = 'REPARENT_CMP_TO_TMP';
parcelRegister("f1kEW", function(module, exports) {
    $parcel$export(module.exports, "disableUserSelection", ()=>$f90949a5dab9d6cc$export$76b6147b732706db);
    $parcel$export(module.exports, "getNewDropState", ()=>$f90949a5dab9d6cc$export$b4d00e619e08b746);
    var $hIkqU = parcelRequire("hIkqU");
    var $c12LJ;
    var $6iNxz = parcelRequire("6iNxz");
    var $6uqhN = parcelRequire("6uqhN");
    var $4y9A5 = parcelRequire("4y9A5");
    var $kBUyj = parcelRequire("kBUyj");
    const $f90949a5dab9d6cc$export$76b6147b732706db = (disableSelection)=>{
        const body = (0, $4y9A5.getBody)();
        body.classList.toggle($6uqhN.unselected, disableSelection);
    };
    const $f90949a5dab9d6cc$var$truncateSummary = (originalSummary, maxLength = 50)=>{
        if (originalSummary.length > maxLength) return `${originalSummary.slice(0, maxLength - 3)}...`;
        return originalSummary;
    };
    const $f90949a5dab9d6cc$export$4a030f6192bebe03 = (projectKey, issueNum, summary)=>{
        const isScenarioIssue = issueNum === undefined;
        return isScenarioIssue ? $f90949a5dab9d6cc$var$truncateSummary(summary) : `${projectKey}-${issueNum}`;
    };
    const $f90949a5dab9d6cc$export$7316081079848ed = (index)=>index - (0, $kBUyj.HEADER_ROWS);
    const $f90949a5dab9d6cc$export$7cc8f7e82292e147 = (issues, dragIndex, dropIndex, closestEdge)=>{
        const correctedDragIndex = $f90949a5dab9d6cc$export$7316081079848ed(dragIndex);
        const correctedDropIndex = $f90949a5dab9d6cc$export$7316081079848ed(dropIndex);
        const dragItem = issues[correctedDragIndex];
        const dropItem = issues[correctedDropIndex];
        if (dragItem?.tag !== (0, $6iNxz.TABLE_ISSUE)) throw new Error(`Dragged item was expected to be ${(0, $6iNxz.TABLE_ISSUE)}, but was ${dragItem.tag}.`);
        const isDraggingOverBottomEdge = closestEdge === 'bottom';
        const beforeDropPosition = isDraggingOverBottomEdge ? correctedDropIndex : correctedDropIndex - 1;
        const afterDropPosition = isDraggingOverBottomEdge ? correctedDropIndex + 1 : correctedDropIndex;
        const beforeDropItem = issues[beforeDropPosition];
        const afterDropItem = issues[afterDropPosition];
        const previousSiblingItemOrHeader = (0, ($parcel$interopDefault($hIkqU)))(issues, (item)=>item.tag !== (0, $6iNxz.TABLE_ISSUE) || item.value.level >= dragItem.value.level, beforeDropPosition);
        const previousSiblingItem = previousSiblingItemOrHeader?.tag === (0, $6iNxz.TABLE_ISSUE) && previousSiblingItemOrHeader.value.level === dragItem.value.level ? previousSiblingItemOrHeader : undefined;
        return {
            dragItem: dragItem,
            dropItem: dropItem,
            beforeDropItem: beforeDropItem,
            afterDropItem: afterDropItem,
            previousSiblingItem: previousSiblingItem
        };
    };
    const $f90949a5dab9d6cc$export$c1fc09ee137842c = (relatedItems, closestEdge)=>{
        const { dragItem: dragItem, dropItem: dropItem, beforeDropItem: beforeDropItem, afterDropItem: afterDropItem } = relatedItems;
        if (dragItem === dropItem) return 0, $63f186813d17e3fe$export$6182a67c5764bd0f;
        if (dropItem.tag === (0, $6iNxz.TABLE_GROUP_HEADER)) {
            const dragItemLevel = dragItem.value.level;
            const dropItemLevel = dropItem.value.level.level;
            if (dragItemLevel !== dropItemLevel) return 0, $63f186813d17e3fe$export$6182a67c5764bd0f;
            return 0, $63f186813d17e3fe$export$56b564d4a01df705;
        }
        if (dropItem.tag === (0, $6iNxz.TABLE_BLANK_ROW)) {
            const dragItemParent = dragItem.value.parent;
            if (!dragItemParent) return 0, $63f186813d17e3fe$export$6182a67c5764bd0f;
            return 0, $63f186813d17e3fe$export$56b564d4a01df705;
        }
        if (dropItem.tag !== (0, $6iNxz.TABLE_ISSUE)) return 0, $63f186813d17e3fe$export$6182a67c5764bd0f;
        const dragItemLevel = dragItem.value.level;
        const dropItemLevel = dropItem.value.level;
        const isDraggingOverParent = dragItemLevel === dropItemLevel - 1;
        if (isDraggingOverParent) return 0, $63f186813d17e3fe$export$56b564d4a01df705;
        if (dragItem === beforeDropItem || dragItem === afterDropItem) return 0, $63f186813d17e3fe$export$6182a67c5764bd0f;
        const isDraggingOverSibling = dragItemLevel === dropItemLevel;
        const isDraggingOverLowerHalf = closestEdge === 'bottom';
        const isNextItemLowerLevelIssue = afterDropItem.tag === (0, $6iNxz.TABLE_ISSUE) && afterDropItem.value.level < dragItemLevel;
        if (isDraggingOverSibling && isDraggingOverLowerHalf && isNextItemLowerLevelIssue) return 0, $63f186813d17e3fe$export$6182a67c5764bd0f;
        if (isDraggingOverSibling) return 0, $63f186813d17e3fe$export$d4ead6ccaed25c5f;
        const isDraggingOverLowerLevel = dragItemLevel > dropItemLevel;
        if (afterDropItem.tag !== (0, $6iNxz.TABLE_ISSUE) && isDraggingOverLowerHalf && isDraggingOverLowerLevel) return 0, $63f186813d17e3fe$export$d4ead6ccaed25c5f;
        if (afterDropItem.tag === (0, $6iNxz.TABLE_ISSUE)) {
            const afterDropItemLevel = afterDropItem.value.level;
            const isAfterDropPositionOfEqualOrHigherLevel = afterDropItemLevel >= dragItemLevel;
            if (isDraggingOverLowerHalf && isDraggingOverLowerLevel && isAfterDropPositionOfEqualOrHigherLevel) return 0, $63f186813d17e3fe$export$d4ead6ccaed25c5f;
        }
        return 0, $63f186813d17e3fe$export$6182a67c5764bd0f;
    };
    const $f90949a5dab9d6cc$export$5cc27adca5a0f20a = (relatedItems, type)=>{
        const { dragItem: dragItem, dropItem: dropItem } = relatedItems;
        if (dragItem.group !== dropItem.group) return {
            reason: (0, $df54714521c59c27$export$1868bd20d88499)
        };
        if (dragItem.value.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)) {
            if (dropItem.tag === (0, $6iNxz.TABLE_GROUP_HEADER) && dropItem.value.level.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL)) return {
                reason: (0, $df54714521c59c27$export$b74126d79e8aaada)
            };
            if (dropItem.tag === (0, $6iNxz.TABLE_ISSUE) && dropItem.value.level === (0, (0, parcelRequire("c12LJ")).SUB_TASK_LEVEL) && dropItem.value.parent === undefined) return {
                reason: (0, $df54714521c59c27$export$b74126d79e8aaada)
            };
        }
        if (dropItem.tag === (0, $6iNxz.TABLE_ISSUE)) {
            const isDragOverParent = dragItem.value.level === dropItem.value.level - 1;
            const isDragOverOwnParent = dragItem.value.parent === dropItem.value.id;
            const isReparentOverParent = isDragOverParent && !isDragOverOwnParent;
            const isDragOverSibling = dragItem.value.level === dropItem.value.level;
            const isSiblingParentOwnParent = dragItem.value.parent === dropItem.value.parent;
            const isReparentOverSibling = isDragOverSibling && !isSiblingParentOwnParent;
            if (isReparentOverParent || isReparentOverSibling) {
                const parentId = $f90949a5dab9d6cc$export$e6e327a97512715e(relatedItems, type);
                const level = dragItem.value.level;
                const project = dragItem.value.project;
                const parentProject = dropItem.value.project;
                if (parentId !== undefined) {
                    if (level !== (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL)) {
                        if (project.isSimplified && project.id !== parentProject.id) return {
                            reason: (0, $df54714521c59c27$export$73be6a137cb5279e),
                            context: {
                                projectName: project.name,
                                destinationProjectName: parentProject.name,
                                issueKey: $f90949a5dab9d6cc$export$4a030f6192bebe03(project.key, dragItem.value.issueKey, dragItem.value.summary)
                            }
                        };
                        if (!project.isSimplified && parentProject.isSimplified) return {
                            reason: (0, $df54714521c59c27$export$2a990a1f401d71c8),
                            context: {
                                projectName: project.name,
                                destinationProjectName: parentProject.name,
                                issueKey: $f90949a5dab9d6cc$export$4a030f6192bebe03(project.key, dragItem.value.issueKey, dragItem.value.summary)
                            }
                        };
                    }
                }
            }
        }
    };
    const $f90949a5dab9d6cc$export$e6e327a97512715e = (relatedItems, type)=>{
        const { dragItem: dragItem, dropItem: dropItem, previousSiblingItem: previousSiblingItem } = relatedItems;
        if (dropItem.tag === (0, $6iNxz.TABLE_ISSUE)) {
            if (type === (0, $63f186813d17e3fe$export$56b564d4a01df705)) return dropItem.value.id;
            if (type === (0, $63f186813d17e3fe$export$d4ead6ccaed25c5f)) {
                if (dragItem.value.level === dropItem.value.level) return dropItem.value.parent;
                if (previousSiblingItem?.tag === (0, $6iNxz.TABLE_ISSUE)) return previousSiblingItem.value.parent;
            }
        }
    };
    const $f90949a5dab9d6cc$export$fbbc9f98d1d2faa5 = (dropItem, dropType, closestEdge)=>{
        if (dropItem.tag === (0, $6iNxz.TABLE_ISSUE)) {
            if (dropType === (0, $63f186813d17e3fe$export$56b564d4a01df705)) return {
                anchor: dropItem.value.id,
                relation: 'AFTER'
            };
            if (dropType === (0, $63f186813d17e3fe$export$d4ead6ccaed25c5f)) return {
                anchor: dropItem.value.id,
                relation: closestEdge === 'bottom' ? 'AFTER' : 'BEFORE'
            };
        }
        return {
            anchor: undefined,
            relation: 'LAST'
        };
    };
    const $f90949a5dab9d6cc$export$e0388331a963a299 = (relatedItems, type, closestEdge)=>{
        const { dragItem: dragItem, dropItem: dropItem } = relatedItems;
        const id = dragItem.value.id;
        const group = dragItem.group;
        const parentId = $f90949a5dab9d6cc$export$e6e327a97512715e(relatedItems, type);
        const { anchor: anchor, relation: relation } = $f90949a5dab9d6cc$export$fbbc9f98d1d2faa5(dropItem, type, closestEdge);
        return {
            id: id,
            group: group,
            parentId: parentId,
            anchor: anchor,
            relation: relation
        };
    };
    const $f90949a5dab9d6cc$export$f2cba6d6e848aa24 = (relatedItems, type, dragIndex, dropIndex, closestEdge, blocked)=>{
        const { dropItem: dropItem } = relatedItems;
        const dragIndicator = {
            type: (0, $f4bc18652544ec5d$export$ac420e079415a2e4),
            index: dragIndex
        };
        const parentId = $f90949a5dab9d6cc$export$e6e327a97512715e(relatedItems, type);
        if (type === (0, $63f186813d17e3fe$export$56b564d4a01df705)) {
            if (dropItem.tag === (0, $6iNxz.TABLE_GROUP_HEADER) || dropItem.tag === (0, $6iNxz.TABLE_BLANK_ROW)) return [
                dragIndicator,
                {
                    type: (0, $f4bc18652544ec5d$export$ce952aa7163824ef),
                    index: dropIndex,
                    blocked: !!blocked
                }
            ];
            return [
                dragIndicator,
                {
                    type: (0, $f4bc18652544ec5d$export$ce952aa7163824ef),
                    id: parentId,
                    blocked: !!blocked
                }
            ];
        }
        if (type === (0, $63f186813d17e3fe$export$d4ead6ccaed25c5f)) return [
            dragIndicator,
            {
                type: (0, $f4bc18652544ec5d$export$1ac9dafc96a1c957),
                index: closestEdge === 'top' ? dropIndex : dropIndex + 1,
                edge: 'top',
                blocked: !!blocked
            },
            {
                type: (0, $f4bc18652544ec5d$export$ce952aa7163824ef),
                id: parentId,
                blocked: !!blocked
            }
        ];
        return [
            dragIndicator
        ];
    };
    const $f90949a5dab9d6cc$export$463c13b827acccfb = (parameters)=>({
            type: (0, $63f186813d17e3fe$export$6182a67c5764bd0f),
            parameters: parameters,
            indicators: [
                {
                    type: (0, $f4bc18652544ec5d$export$ac420e079415a2e4),
                    index: parameters.dragTarget.index
                }
            ]
        });
    const $f90949a5dab9d6cc$export$b4d00e619e08b746 = (issues, parameters)=>{
        const { dragTarget: dragTarget, dropTarget: dropTarget } = parameters;
        if (!dropTarget) return $f90949a5dab9d6cc$export$463c13b827acccfb(parameters);
        const dragIndex = dragTarget.index;
        const dropIndex = dropTarget.index;
        const closestEdge = dropTarget.closestEdge;
        const relatedItems = $f90949a5dab9d6cc$export$7cc8f7e82292e147(issues, dragIndex, dropIndex, closestEdge);
        const type = $f90949a5dab9d6cc$export$c1fc09ee137842c(relatedItems, closestEdge);
        const action = $f90949a5dab9d6cc$export$e0388331a963a299(relatedItems, type, closestEdge);
        const blocked = $f90949a5dab9d6cc$export$5cc27adca5a0f20a(relatedItems, type);
        const indicators = $f90949a5dab9d6cc$export$f2cba6d6e848aa24(relatedItems, type, dragIndex, dropIndex, closestEdge, blocked);
        return {
            type: type,
            parameters: parameters,
            action: action,
            blocked: blocked,
            indicators: indicators
        };
    };
});
parcelRegister("hIkqU", function(module, exports) {
    var $bptzf = parcelRequire("bptzf");
    var $apUNl = parcelRequire("apUNl");
    var $0353f9604956038c$var$findLast = $bptzf($apUNl);
    module.exports = $0353f9604956038c$var$findLast;
});
parcelRegister("apUNl", function(module, exports) {
    var $b5dwA = parcelRequire("b5dwA");
    var $bxDef = parcelRequire("bxDef");
    var $kPZpS = parcelRequire("kPZpS");
    var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
    function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) return -1;
        var index = length - 1;
        if (fromIndex !== undefined) {
            index = $kPZpS(fromIndex);
            index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
        }
        return $b5dwA(array, $bxDef(predicate, 3), index, true);
    }
    module.exports = $79584b713e0c6354$var$findLastIndex;
});
parcelRegister("6uqhN", function(module, exports) {
    $parcel$export(module.exports, "blankRow", ()=>$4b99ef481eeb50fc$export$34126cd4b89016d9, (v)=>$4b99ef481eeb50fc$export$34126cd4b89016d9 = v);
    $parcel$export(module.exports, "drop-child-even", ()=>$4b99ef481eeb50fc$export$33961997e0dff007, (v)=>$4b99ef481eeb50fc$export$33961997e0dff007 = v);
    $parcel$export(module.exports, "drop-child-odd", ()=>$4b99ef481eeb50fc$export$2977ee011e0be97e, (v)=>$4b99ef481eeb50fc$export$2977ee011e0be97e = v);
    $parcel$export(module.exports, "drop-container", ()=>$4b99ef481eeb50fc$export$6f8a0a68c6ddd84d, (v)=>$4b99ef481eeb50fc$export$6f8a0a68c6ddd84d = v);
    $parcel$export(module.exports, "drop-invalid-child-even", ()=>$4b99ef481eeb50fc$export$74e6643589062a13, (v)=>$4b99ef481eeb50fc$export$74e6643589062a13 = v);
    $parcel$export(module.exports, "drop-invalid-child-odd", ()=>$4b99ef481eeb50fc$export$6fe78eff732df301, (v)=>$4b99ef481eeb50fc$export$6fe78eff732df301 = v);
    $parcel$export(module.exports, "drop-invalid-sibling", ()=>$4b99ef481eeb50fc$export$7749340e380680e0, (v)=>$4b99ef481eeb50fc$export$7749340e380680e0 = v);
    $parcel$export(module.exports, "drop-sibling", ()=>$4b99ef481eeb50fc$export$5a26b02d9ff5edbe, (v)=>$4b99ef481eeb50fc$export$5a26b02d9ff5edbe = v);
    $parcel$export(module.exports, "isDragging", ()=>$4b99ef481eeb50fc$export$9e9bc3c487fccc00, (v)=>$4b99ef481eeb50fc$export$9e9bc3c487fccc00 = v);
    $parcel$export(module.exports, "isInvalid", ()=>$4b99ef481eeb50fc$export$eac50920cf2fd59a, (v)=>$4b99ef481eeb50fc$export$eac50920cf2fd59a = v);
    $parcel$export(module.exports, "row-with-indentation", ()=>$4b99ef481eeb50fc$export$3fe691ddfc79d8d5, (v)=>$4b99ef481eeb50fc$export$3fe691ddfc79d8d5 = v);
    $parcel$export(module.exports, "unselected", ()=>$4b99ef481eeb50fc$export$dcf867063481ae2c, (v)=>$4b99ef481eeb50fc$export$dcf867063481ae2c = v);
    var $4b99ef481eeb50fc$export$34126cd4b89016d9;
    var $4b99ef481eeb50fc$export$33961997e0dff007;
    var $4b99ef481eeb50fc$export$2977ee011e0be97e;
    var $4b99ef481eeb50fc$export$6f8a0a68c6ddd84d;
    var $4b99ef481eeb50fc$export$74e6643589062a13;
    var $4b99ef481eeb50fc$export$6fe78eff732df301;
    var $4b99ef481eeb50fc$export$7749340e380680e0;
    var $4b99ef481eeb50fc$export$5a26b02d9ff5edbe;
    var $4b99ef481eeb50fc$export$8b6211bf7f067794;
    var $4b99ef481eeb50fc$export$9e9bc3c487fccc00;
    var $4b99ef481eeb50fc$export$eac50920cf2fd59a;
    var $4b99ef481eeb50fc$export$3fe691ddfc79d8d5;
    var $4b99ef481eeb50fc$export$dcf867063481ae2c;
    $4b99ef481eeb50fc$export$34126cd4b89016d9 = `BVYcca_blankRow`;
    $4b99ef481eeb50fc$export$33961997e0dff007 = `BVYcca_drop-child-even`;
    $4b99ef481eeb50fc$export$2977ee011e0be97e = `BVYcca_drop-child-odd`;
    $4b99ef481eeb50fc$export$6f8a0a68c6ddd84d = `BVYcca_drop-container`;
    $4b99ef481eeb50fc$export$74e6643589062a13 = `BVYcca_drop-invalid-child-even`;
    $4b99ef481eeb50fc$export$6fe78eff732df301 = `BVYcca_drop-invalid-child-odd`;
    $4b99ef481eeb50fc$export$7749340e380680e0 = `BVYcca_drop-invalid-sibling`;
    $4b99ef481eeb50fc$export$5a26b02d9ff5edbe = `BVYcca_drop-sibling`;
    $4b99ef481eeb50fc$export$8b6211bf7f067794 = `BVYcca_group-team-avatar`;
    $4b99ef481eeb50fc$export$9e9bc3c487fccc00 = `BVYcca_isDragging`;
    $4b99ef481eeb50fc$export$eac50920cf2fd59a = `BVYcca_isInvalid`;
    $4b99ef481eeb50fc$export$3fe691ddfc79d8d5 = `BVYcca_row-with-indentation`;
    $4b99ef481eeb50fc$export$dcf867063481ae2c = `BVYcca_unselected`;
});
parcelRegister("8nzhj", function(module, exports) {
    $parcel$export(module.exports, "ColumnDragAutoScroll", ()=>$b4a9f15b40b67148$export$99fc94830ceb11f6);
    var $5uXOq = parcelRequire("5uXOq");
    var $7gWdR = parcelRequire("7gWdR");
    var $8LV9S;
    var $aFeC0 = parcelRequire("aFeC0");
    const $b4a9f15b40b67148$export$99fc94830ceb11f6 = ({ containerRef: containerRef })=>{
        const [columnWidths] = (0, (0, parcelRequire("8LV9S")).useColumnWidths)({
            preview: false
        });
        const marginLeft = columnWidths[0];
        const monitors = (0, $5uXOq.useMemo)(()=>[
                ({ start: start, update: update, end: end })=>(0, $7gWdR.monitorForElements)({
                        canMonitor: ({ source: source })=>source.data.type === (0, $057a94f006b9ba47$export$7f092194d45e1f0d),
                        onDragStart: start,
                        onDropTargetChange: ({ location: location })=>update(location.current.input),
                        onDrag: ({ location: location })=>update(location.current.input),
                        onDrop: end
                    })
            ], []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aFeC0.DragAutoScroll), {
            allowedAxis: "horizontal",
            containerRef: containerRef,
            insetHitbox: {
                top: 50,
                left: marginLeft
            },
            monitors: monitors
        });
    };
});
parcelRegister("aFeC0", function(module, exports) {
    $parcel$export(module.exports, "DragAutoScroll", ()=>$75660d04f3dd3050$export$c66fb8d6aaa5d7c7);
    var $5uXOq = parcelRequire("5uXOq");
    var $4hDdm = parcelRequire("4hDdm");
    var $2EwIC;
    var $hGVpX = parcelRequire("hGVpX");
    const $75660d04f3dd3050$var$MAX_SPEED = 0.5;
    const $75660d04f3dd3050$export$c66fb8d6aaa5d7c7 = ({ containerRef: containerRef, allowedAxis: allowedAxis, insetHitbox: insetHitbox, monitors: monitors })=>{
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const autoscroll = (0, $5uXOq.useCallback)((timeSinceLastFrame, { pageX: pageX, pageY: pageY })=>{
            const { top: top = 0, bottom: bottom = 0, left: left = 0, right: right = 0 } = insetHitbox;
            const edgeDistances = {
                top: pageY - viewport.top - top,
                bottom: viewport.top + viewport.height - pageY - bottom,
                left: pageX - viewport.left - left,
                right: viewport.left + viewport.width - pageX - right
            };
            const velocity = (distanceToTheEdge)=>distanceToTheEdge <= 0 ? 0 : Math.max($75660d04f3dd3050$var$MAX_SPEED - distanceToTheEdge / 200, 0);
            const containerEl = containerRef.current;
            if (containerEl) {
                if (allowedAxis === 'horizontal' || allowedAxis === 'both') {
                    let xAmount = velocity(edgeDistances.right) * timeSinceLastFrame;
                    if (xAmount === 0) xAmount = -velocity(edgeDistances.left) * timeSinceLastFrame;
                    if (!Number.isNaN(xAmount) && xAmount !== 0) containerEl.scrollLeft += xAmount;
                }
                if (allowedAxis === 'vertical' || allowedAxis === 'both') {
                    let yAmount = velocity(edgeDistances.bottom) * timeSinceLastFrame;
                    if (yAmount === 0) yAmount = -velocity(edgeDistances.top) * timeSinceLastFrame;
                    if (!Number.isNaN(yAmount) && yAmount !== 0) containerEl.scrollTop += yAmount;
                }
            }
        }, [
            allowedAxis,
            containerRef,
            insetHitbox,
            viewport.height,
            viewport.left,
            viewport.top,
            viewport.width
        ]);
        const { start: start, end: end, update: update } = (0, $hGVpX.useScheduler)(autoscroll);
        (0, $5uXOq.useEffect)(()=>(0, $4hDdm.combine)(...monitors.map((monitor)=>monitor({
                    start: start,
                    update: update,
                    end: end
                }))), [
            start,
            end,
            update,
            monitors
        ]);
        return null;
    };
});
parcelRegister("hGVpX", function(module, exports) {
    $parcel$export(module.exports, "useScheduler", ()=>$21bdf82cb2d76c97$export$a9fb6bc18c647ec4);
    var $5uXOq = parcelRequire("5uXOq");
    const $21bdf82cb2d76c97$export$a9fb6bc18c647ec4 = (onFrame)=>{
        const lastFrameTimestampRef = (0, $5uXOq.useRef)();
        const latestArgs = (0, $5uXOq.useRef)();
        const frameIdRef = (0, $5uXOq.useRef)();
        const loop = (0, $5uXOq.useCallback)(()=>{
            const now = Date.now();
            if (latestArgs.current !== undefined && lastFrameTimestampRef.current !== undefined) onFrame(now - lastFrameTimestampRef.current, latestArgs.current);
            lastFrameTimestampRef.current = Date.now();
            frameIdRef.current = requestAnimationFrame(loop);
        }, [
            onFrame
        ]);
        const start = (0, $5uXOq.useCallback)(()=>{
            lastFrameTimestampRef.current = Date.now();
            frameIdRef.current = requestAnimationFrame(loop);
        }, [
            loop
        ]);
        const update = (0, $5uXOq.useCallback)((args)=>{
            latestArgs.current = args;
        }, []);
        const end = (0, $5uXOq.useCallback)(()=>{
            lastFrameTimestampRef.current = undefined;
            if (frameIdRef.current !== undefined) cancelAnimationFrame(frameIdRef.current);
            frameIdRef.current = undefined;
            latestArgs.current = undefined;
        }, []);
        return {
            start: start,
            update: update,
            end: end
        };
    };
});
const $057a94f006b9ba47$export$7f092194d45e1f0d = 'column';
parcelRegister("lx3ag", function(module, exports) {
    $parcel$export(module.exports, "ColumnDragManager", ()=>$ef90996782d6359c$export$906ee24237563db2);
    var $bC2fB;
    var $3FggL = parcelRequire("3FggL");
    var $dzye0 = parcelRequire("dzye0");
    var $fO57s = parcelRequire("fO57s");
    const $ef90996782d6359c$export$906ee24237563db2 = (0, (0, parcelRequire("bC2fB")).connect)((0, $dzye0.mapStateToProps), (0, $3FggL.mapDispatchToProps))((0, $fO57s.ColumnDragManager));
});
parcelRegister("3FggL", function(module, exports) {
    $parcel$export(module.exports, "mapDispatchToProps", ()=>$2431272cf6570a77$export$9e6a17cf56877796);
    var $4ArTT = parcelRequire("4ArTT");
    const $2431272cf6570a77$export$9e6a17cf56877796 = (dispatch)=>({
            moveColumn: (columnToMove, moveToTheIndexOf)=>{
                dispatch((0, $4ArTT.move)({
                    columnToMove: columnToMove,
                    moveToTheIndexOf: moveToTheIndexOf
                }, {
                    source: 'drag-field'
                }));
            }
        });
});
parcelRegister("dzye0", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$4ef7364acc3b0212$export$c31df4bd766f9c35);
    var $3YtPS = parcelRequire("3YtPS");
    var $iTACj = parcelRequire("iTACj");
    const $4ef7364acc3b0212$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        columnIds: (0, $iTACj.getColumnIds)
    });
});
parcelRegister("iTACj", function(module, exports) {
    $parcel$export(module.exports, "getColumnIds", ()=>$d9e627a7499ca76f$export$3d88032e6be0ee47);
    var $g7bEf = parcelRequire("g7bEf");
    var $3YtPS = parcelRequire("3YtPS");
    const $d9e627a7499ca76f$export$3d88032e6be0ee47 = (0, $3YtPS.createSelector)([
        (0, $g7bEf.getColumns)
    ], (columns)=>columns.filter((column)=>column.isVisible).map((column)=>column.id));
});
parcelRegister("fO57s", function(module, exports) {
    $parcel$export(module.exports, "ColumnDragManager", ()=>$3bea33026de09ce0$export$906ee24237563db2);
    var $5uXOq = parcelRequire("5uXOq");
    var $12xYT;
    var $biEfA;
    var $7gWdR = parcelRequire("7gWdR");
    var $eQrWf = parcelRequire("eQrWf");
    const $3bea33026de09ce0$export$906ee24237563db2 = ({ columnIds: columnIds, moveColumn: moveColumn })=>{
        const [lastDropped, setLastDropped] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!lastDropped) return;
            const element = document.querySelector(`[data-column-id="${lastDropped}"]`);
            if (!element) return;
            (0, (0, parcelRequire("12xYT")).triggerPostMoveFlash)(element);
            setLastDropped(null);
        }, [
            lastDropped
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return (0, $7gWdR.monitorForElements)({
                canMonitor: ({ source: source })=>source.data.type === (0, $057a94f006b9ba47$export$7f092194d45e1f0d),
                onDrop: ({ source: source, location: location })=>{
                    const target = location.current.dropTargets[0];
                    if (!target) return;
                    const sourceColumnId = source.data.columnId;
                    const targetColumnId = target.data.columnId;
                    const closestEdge = (0, (0, parcelRequire("biEfA")).extractClosestEdge)(target.data);
                    if (typeof sourceColumnId !== 'string' || typeof targetColumnId !== 'string' || !closestEdge) return;
                    const destinationColumnId = (0, $eQrWf.getDestinationColumnId)(sourceColumnId, targetColumnId, columnIds, closestEdge);
                    moveColumn(sourceColumnId, destinationColumnId);
                    setLastDropped(sourceColumnId);
                }
            });
        }, [
            columnIds,
            moveColumn
        ]);
        return null;
    };
});
parcelRegister("12xYT", function(module, exports) {
    $parcel$export(module.exports, "triggerPostMoveFlash", ()=>$fa7651cb4dd047e2$export$f5b5f29328df2633);
    var $lObw7;
    function $fa7651cb4dd047e2$export$f5b5f29328df2633(element) {
        element.animate([
            {
                backgroundColor: "var(--ds-background-selected, #E9F2FF)"
            },
            {}
        ], {
            duration: (0, (0, parcelRequire("lObw7")).largeDurationMs),
            easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
            iterations: 1
        });
    }
});
parcelRegister("eQrWf", function(module, exports) {
    $parcel$export(module.exports, "getDestinationColumnId", ()=>$1f95368e27ddced8$export$53ee0fe2e0d463d);
    var $9EGGH;
    const $1f95368e27ddced8$export$53ee0fe2e0d463d = (sourceColumnId, targetColumnId, columnIds, closestEdge)=>{
        const sourceIndex = columnIds.indexOf(sourceColumnId);
        const targetIndex = columnIds.indexOf(targetColumnId);
        const destinationIndex = (0, (0, parcelRequire("9EGGH")).getReorderDestinationIndex)({
            startIndex: sourceIndex,
            indexOfTarget: targetIndex,
            closestEdgeOfTarget: closestEdge,
            axis: 'horizontal'
        });
        return columnIds[destinationIndex];
    };
});
parcelRegister("9EGGH", function(module, exports) {
    $parcel$export(module.exports, "getReorderDestinationIndex", ()=>$178b6900979d74e0$export$846f792f51b92b6e);
    function $178b6900979d74e0$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
        if (startIndex === -1 || indexOfTarget === -1) return startIndex;
        if (startIndex === indexOfTarget) return startIndex;
        if (closestEdgeOfTarget == null) return indexOfTarget;
        const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
        const isMovingForward = startIndex < indexOfTarget;
        if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
        return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
    }
});
parcelRegister("2A3Yi", function(module, exports) {
    $parcel$export(module.exports, "ColumnDragScrollLock", ()=>$c3d2d1f8acabc6e0$export$5db7790c78a54b90);
    var $5uXOq = parcelRequire("5uXOq");
    var $f9Tpd;
    var $f1ybZ = parcelRequire("f1ybZ");
    const $c3d2d1f8acabc6e0$export$5db7790c78a54b90 = ()=>{
        const isColumnDragging = (0, $f1ybZ.useIsColumnDragging)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9Tpd")).default), {
            axis: "vertical",
            enabled: isColumnDragging
        });
    };
});
parcelRegister("f1ybZ", function(module, exports) {
    $parcel$export(module.exports, "useIsColumnDragging", ()=>$9f778543518baad8$export$42cad2e4ef905137);
    var $5uXOq = parcelRequire("5uXOq");
    var $7gWdR = parcelRequire("7gWdR");
    const $9f778543518baad8$export$42cad2e4ef905137 = ()=>{
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)({
                canMonitor: ({ source: source })=>source.data.type === (0, $057a94f006b9ba47$export$7f092194d45e1f0d),
                onDragStart: ()=>setIsDragging(true),
                onDrop: ()=>setIsDragging(false)
            }), []);
        return isDragging;
    };
});
parcelRegister("g1rn7", function(module, exports) {
    $parcel$export(module.exports, "EnhancedCell", ()=>$45462b46efc4f945$export$880cb9a2bc0ae11b);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $7XYc4;
    var $4R6GH;
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $eT70U;
    var $4hgLn;
    var $bQYPY = parcelRequire("bQYPY");
    var $7MfoP = parcelRequire("7MfoP");
    var $diwsr = parcelRequire("diwsr");
    var $841ox = parcelRequire("841ox");
    var $g0ezx = parcelRequire("g0ezx");
    var $7DWY4 = parcelRequire("7DWY4");
    var $5DJ44 = parcelRequire("5DJ44");
    var $hEBQR = parcelRequire("hEBQR");
    const $45462b46efc4f945$export$58738aac62db7c0e = ({ hasBorderTop: hasBorderTop, hasBorderBottom: hasBorderBottom, hasDragIndicator: hasDragIndicator, hasDropIndicator: hasDropIndicator, columnText: columnText, resizeHandle: resizeHandle, clipped: clipped, hasBackground: hasBackground, columnId: columnId, isDraggableColumn: isDraggableColumn, hasColumnDropIndicator: hasColumnDropIndicator, children: children, rowType: rowType = 'body', ...restProps })=>{
        const { column: column } = restProps;
        const ref = (0, $5uXOq.useRef)(null);
        const isFocusWithin = (0, $hEBQR.useFocusWithin)(ref);
        const zIndex = (0, $eHJCm.useZIndex)({
            rowType: rowType,
            column: column,
            level: (()=>{
                if (rowType === 'body') return (0, $6hYE8.Z_INDEX_LEVEL).DEFAULT;
                if (isFocusWithin) return (0, $6hYE8.Z_INDEX_LEVEL).FOCUSED;
                return undefined;
            })()
        });
        const [collapsed] = (0, $7MfoP.useColumnCollapsed)({
            isHeader: rowType === 'header',
            column: column
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
            ...restProps,
            xcss: $45462b46efc4f945$var$cellStyles,
            style: {
                zIndex: zIndex
            },
            ref: ref
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($45462b46efc4f945$var$MemoedCellInner, {
            hasBorderTop: hasBorderTop,
            hasBorderBottom: hasBorderBottom,
            hasDragIndicator: hasDragIndicator,
            hasDropIndicator: hasDropIndicator,
            columnText: columnText,
            resizeHandle: resizeHandle,
            clipped: clipped,
            hasBackground: hasBackground,
            columnId: columnId,
            isDraggableColumn: isDraggableColumn,
            hasColumnDropIndicator: hasColumnDropIndicator,
            collapsed: collapsed
        }, children));
    };
    const $45462b46efc4f945$export$1653f275659e02f = ({ hasBorderTop: hasBorderTop, hasBorderBottom: hasBorderBottom, hasDragIndicator: hasDragIndicator, hasDropIndicator: hasDropIndicator, columnText: columnText, resizeHandle: resizeHandle, clipped: clipped, hasBackground: hasBackground, columnId: columnId, isDraggableColumn: isDraggableColumn, hasColumnDropIndicator: hasColumnDropIndicator, children: children, ...restProps })=>{
        const { row: row } = (0, (0, parcelRequire("eT70U")).useRow)();
        const { column: column } = restProps;
        const ref = (0, $5uXOq.useRef)(null);
        const isFocusWithin = (0, $hEBQR.useFocusWithin)(ref);
        const zIndex = (0, $eHJCm.useZIndex)({
            row: row,
            column: column,
            level: isFocusWithin ? (0, $6hYE8.Z_INDEX_LEVEL).FOCUSED : (0, $6hYE8.Z_INDEX_LEVEL).DEFAULT
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
            ...restProps,
            xcss: $45462b46efc4f945$var$cellStyles,
            style: {
                zIndex: zIndex
            },
            ref: ref
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($45462b46efc4f945$var$MemoedCellInnerOld, {
            hasBorderTop: hasBorderTop,
            hasBorderBottom: hasBorderBottom,
            hasDragIndicator: hasDragIndicator,
            hasDropIndicator: hasDropIndicator,
            columnText: columnText,
            resizeHandle: resizeHandle,
            clipped: clipped,
            hasBackground: hasBackground,
            columnId: columnId,
            isDraggableColumn: isDraggableColumn,
            hasColumnDropIndicator: hasColumnDropIndicator
        }, children));
    };
    const $45462b46efc4f945$var$CellInner = ({ hasBorderTop: hasBorderTop = false, hasBorderBottom: hasBorderBottom = false, hasDragIndicator: hasDragIndicator = false, hasDropIndicator: hasDropIndicator = false, hasBackground: hasBackground = true, columnText: columnText, resizeHandle: resizeHandle, clipped: clipped = true, columnId: columnId, isDraggableColumn: isDraggableColumn = false, hasColumnDropIndicator: hasColumnDropIndicator = false, collapsed: collapsed = false, children: children })=>{
        const contents = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $45462b46efc4f945$var$wrapperStyles,
                hasBorderTop && $45462b46efc4f945$var$borderTopStyles,
                hasBorderBottom && $45462b46efc4f945$var$borderBottomStyles,
                collapsed && $45462b46efc4f945$var$collapsedStyles,
                clipped && $45462b46efc4f945$var$clippedStyles,
                !hasBackground && $45462b46efc4f945$var$stripBackgroundStyles,
                $45462b46efc4f945$var$focusStyles
            ]
        }, !collapsed && children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isDraggableColumn && columnId && (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5DJ44.DraggableColumn), {
            columnId: columnId,
            renderTrigger: ({ ref: ref, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $g0ezx.ColumnDragHandle), {
                    ref: ref,
                    columnId: columnId,
                    ...props
                }),
            isDisabled: collapsed
        }, contents) : contents, collapsed && columnText, resizeHandle, hasColumnDropIndicator && (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7DWY4.ColumnDropIndicator), {
            columnId: columnId
        }), hasDragIndicator && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $diwsr.DragIndicator), null), hasDropIndicator && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $841ox.DropIndicator), null));
    };
    const $45462b46efc4f945$var$MemoedCellInner = (0, $5uXOq.memo)($45462b46efc4f945$var$CellInner);
    const $45462b46efc4f945$var$CellInnerOld = ({ hasBorderTop: hasBorderTop = false, hasBorderBottom: hasBorderBottom = false, hasDragIndicator: hasDragIndicator = false, hasDropIndicator: hasDropIndicator = false, hasBackground: hasBackground = true, columnText: columnText, resizeHandle: resizeHandle, clipped: clipped = true, columnId: columnId, isDraggableColumn: isDraggableColumn = false, hasColumnDropIndicator: hasColumnDropIndicator = false, children: children })=>{
        const collapsed = (0, $bQYPY.useColumnCollapsedOld)();
        const contents = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $45462b46efc4f945$var$wrapperStyles,
                hasBorderTop && $45462b46efc4f945$var$borderTopStyles,
                hasBorderBottom && $45462b46efc4f945$var$borderBottomStyles,
                collapsed && $45462b46efc4f945$var$collapsedStyles,
                clipped && $45462b46efc4f945$var$clippedStyles,
                !hasBackground && $45462b46efc4f945$var$stripBackgroundStyles,
                $45462b46efc4f945$var$focusStyles
            ]
        }, !collapsed && children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isDraggableColumn && columnId && (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5DJ44.DraggableColumn), {
            columnId: columnId,
            renderTrigger: ({ ref: ref, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $g0ezx.ColumnDragHandle), {
                    ref: ref,
                    columnId: columnId,
                    ...props
                }),
            isDisabled: collapsed
        }, contents) : contents, collapsed && columnText, resizeHandle, hasColumnDropIndicator && (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7DWY4.ColumnDropIndicator), {
            columnId: columnId
        }), hasDragIndicator && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $diwsr.DragIndicator), null), hasDropIndicator && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $841ox.DropIndicator), null));
    };
    const $45462b46efc4f945$var$MemoedCellInnerOld = (0, $5uXOq.memo)($45462b46efc4f945$var$CellInnerOld);
    const $45462b46efc4f945$export$880cb9a2bc0ae11b = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('plans_performance_improvements'), $45462b46efc4f945$export$58738aac62db7c0e, $45462b46efc4f945$export$1653f275659e02f);
    const $45462b46efc4f945$var$cellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'elevation.surface',
        verticalAlign: 'top'
    });
    const $45462b46efc4f945$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        borderRight: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`}`,
        background: 'var(--plan-grid-row-background)',
        overflow: 'initial',
        transition: 'background-color 0.1s ease'
    });
    const $45462b46efc4f945$var$borderTopStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTop: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`}`
    });
    const $45462b46efc4f945$var$borderBottomStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderBottom: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`}`
    });
    const $45462b46efc4f945$var$collapsedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: 'unset'
    });
    const $45462b46efc4f945$var$clippedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden'
    });
    const $45462b46efc4f945$var$focusStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':focus-within': {
            overflow: 'initial'
        }
    });
    const $45462b46efc4f945$var$stripBackgroundStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        '--plan-grid-row-background': 'elevation.surface',
        ':hover': {
            '--plan-grid-row-background': 'elevation.surface'
        }
    });
});
parcelRegister("4hgLn", function(module, exports) {
    $parcel$export(module.exports, "Cell", ()=>$ad8cd6ed2391e65d$export$f6f0c3fe4ec306ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $aI0i7;
    var $8LV9S;
    var $eT70U;
    const $ad8cd6ed2391e65d$export$f6f0c3fe4ec306ea = (0, $5uXOq.forwardRef)(({ column: column, colSpan: colSpan, style: style, top: top, xcss: xcssStyles, ...restProps }, ref)=>{
        const { row: row, height: height } = (0, (0, parcelRequire("eT70U")).useRow)();
        const [left] = (0, (0, parcelRequire("8LV9S")).useColumnStickyOffset)({
            column: column,
            preview: true
        });
        const [colSpanForZeroWidthColumns] = (0, (0, parcelRequire("8LV9S")).useColSpan)({
            row: row,
            column: column,
            preview: true
        });
        const isSticky = top !== undefined || left !== undefined;
        if (colSpanForZeroWidthColumns === 0) return null;
        const finalColSpan = colSpan ?? colSpanForZeroWidthColumns;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aI0i7")).CellProvider), {
            row: row,
            column: column,
            colSpan: finalColSpan
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "td",
            ref: ref,
            colSpan: finalColSpan,
            xcss: [
                $ad8cd6ed2391e65d$var$cellStyles,
                isSticky && $ad8cd6ed2391e65d$var$stickyStyles,
                ...Array.isArray(xcssStyles) ? xcssStyles : [
                    xcssStyles
                ]
            ],
            style: {
                top: top,
                left: left,
                height: height,
                ...style
            },
            ...restProps
        }));
    });
    const $ad8cd6ed2391e65d$var$cellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.0',
        padding: 'space.0',
        position: 'relative'
    });
    const $ad8cd6ed2391e65d$var$stickyStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'sticky'
    });
});
parcelRegister("diwsr", function(module, exports) {
    $parcel$export(module.exports, "DragIndicator", ()=>$af444be401087236$export$5929dc158973a58a);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $3Mh6R;
    var $6hYE8 = parcelRequire("6hYE8");
    var $eHJCm = parcelRequire("eHJCm");
    var $aI0i7;
    const $af444be401087236$export$5929dc158973a58a = ()=>{
        const [{ row: row }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const indicator = (0, (0, parcelRequire("3Mh6R")).useDragIndicator)(row);
        if (!indicator) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHJCm.ZIndex), {
            layer: (0, $6hYE8.Z_INDEX_LAYER).ISSUE_BARS
        }, (zIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $af444be401087236$var$coverStyles,
                style: {
                    zIndex: zIndex
                }
            }));
    };
    const $af444be401087236$var$coverStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        zIndex: 'auto',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 'space.0',
        left: 'space.0',
        backgroundColor: 'color.background.accent.gray.subtler',
        pointerEvents: 'none'
    });
});
parcelRegister("841ox", function(module, exports) {
    $parcel$export(module.exports, "DropIndicator", ()=>$0e9b35c664d50575$export$62ed72bc21f6b8a6);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $3Mh6R;
    var $aI0i7;
    const $0e9b35c664d50575$var$getIconColor = (type)=>{
        switch(type){
            case 'blocked':
                return `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$c6930421db9fa514})`;
            case 'allowed':
            default:
                return `var(--ds-icon-brand, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
        }
    };
    const $0e9b35c664d50575$var$getBorderColor = (type)=>{
        switch(type){
            case 'blocked':
                return `var(--ds-border-danger, ${0, $829f609a65d26a98$export$c6930421db9fa514})`;
            case 'allowed':
            default:
                return `var(--ds-border-brand, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
        }
    };
    const $0e9b35c664d50575$export$62ed72bc21f6b8a6 = ()=>{
        const [{ row: row, column: column }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const indicator = (0, (0, parcelRequire("3Mh6R")).useDropIndicator)(row);
        if (!indicator) return null;
        const { edge: edge, blocked: blocked } = indicator;
        const type = blocked ? 'blocked' : 'allowed';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $0e9b35c664d50575$var$lineStyles,
                column === 0 && $0e9b35c664d50575$var$terminalStyles,
                edge === 'top' && $0e9b35c664d50575$var$topStyles,
                edge === 'bottom' && $0e9b35c664d50575$var$bottomStyles
            ],
            style: {
                '--drop-border-color': $0e9b35c664d50575$var$getBorderColor(type),
                '--drop-icon-color': $0e9b35c664d50575$var$getIconColor(type)
            }
        });
    };
    const $0e9b35c664d50575$var$lineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        pointerEvents: 'none',
        position: 'absolute',
        width: '100%',
        height: '2px',
        background: 'var(--drop-border-color)'
    });
    const $0e9b35c664d50575$var$terminalStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        '::before': {
            content: '""',
            position: 'absolute',
            height: '0',
            width: '0',
            top: '-3px',
            borderTop: `${"var(--ds-space-050, 4px)"} solid transparent`,
            borderBottom: `${"var(--ds-space-050, 4px)"} solid transparent`,
            borderLeft: `${"var(--ds-space-100, 8px)"} solid var(--drop-icon-color)`
        }
    });
    const $0e9b35c664d50575$var$topStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        top: '-1px'
    });
    const $0e9b35c664d50575$var$bottomStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        bottom: '-1px'
    });
});
parcelRegister("g0ezx", function(module, exports) {
    $parcel$export(module.exports, "ColumnDragHandle", ()=>$a50f2bb12da78284$export$826d0335a222057d);
    var $bC2fB;
    var $8BMpH = parcelRequire("8BMpH");
    var $7tVZI = parcelRequire("7tVZI");
    var $kO5Iz = parcelRequire("kO5Iz");
    const $a50f2bb12da78284$export$826d0335a222057d = (0, (0, parcelRequire("bC2fB")).connect)((0, $7tVZI.mapStateToProps), (0, $8BMpH.mapDispatchToProps))((0, $kO5Iz.ColumnDragHandle));
});
parcelRegister("8BMpH", function(module, exports) {
    $parcel$export(module.exports, "mapDispatchToProps", ()=>$e9bb46071e7136d1$export$9e6a17cf56877796);
    var $4ArTT = parcelRequire("4ArTT");
    const $e9bb46071e7136d1$export$9e6a17cf56877796 = (dispatch)=>({
            hideColumn: (id)=>{
                dispatch({
                    type: (0, $4ArTT.HIDE_COLUMN),
                    id: id,
                    meta: {
                        source: (0, $4ArTT.HIDE_FIELD)
                    }
                });
            },
            moveColumn: (columnToMove, moveToTheIndexOf)=>{
                dispatch((0, $4ArTT.move)({
                    columnToMove: columnToMove,
                    moveToTheIndexOf: moveToTheIndexOf
                }, {
                    source: (0, $4ArTT.DRAG_FIELD)
                }));
            }
        });
});
parcelRegister("7tVZI", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$2485fabb779fe1c5$export$c31df4bd766f9c35);
    var $3YtPS = parcelRequire("3YtPS");
    var $iTACj = parcelRequire("iTACj");
    const $2485fabb779fe1c5$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        columnIds: (0, $iTACj.getColumnIds)
    });
});
parcelRegister("kO5Iz", function(module, exports) {
    $parcel$export(module.exports, "ColumnDragHandle", ()=>$11f38deb75f10dff$export$826d0335a222057d);
    var $5uXOq = parcelRequire("5uXOq");
    var $BLPHT;
    var $6B7KL;
    var $ctqwA;
    var $h1TKi;
    var $i28qQ;
    var $dQO6P;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $koVbs;
    var $7mPT9;
    var $iwfmd;
    var $jtYtu = parcelRequire("jtYtu");
    const $11f38deb75f10dff$export$826d0335a222057d = (0, $5uXOq.forwardRef)(({ columnId: columnId, isVisible: isVisible, isHidden: isHidden, columnIds: columnIds, moveColumn: moveColumn, hideColumn: hideColumn }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [isTriggerHovered, setIsTriggerHovered] = (0, $5uXOq.useState)(false);
        const showHandle = (isVisible || isOpen) && !isHidden;
        const showExpanded = isTriggerHovered || isOpen;
        const columnIndex = columnIds.indexOf(columnId);
        const handleHide = (0, $5uXOq.useCallback)(()=>{
            hideColumn(columnId);
        }, [
            columnId,
            hideColumn
        ]);
        const handleMove = (0, $5uXOq.useCallback)((direction)=>{
            const targetIndex = direction === 'left' ? columnIndex - 1 : columnIndex + 1;
            moveColumn(columnId, columnIds[targetIndex]);
        }, [
            columnId,
            columnIds,
            columnIndex,
            moveColumn
        ]);
        const handleMoveLeft = (0, $5uXOq.useCallback)(()=>handleMove('left'), [
            handleMove
        ]);
        const handleMoveRight = (0, $5uXOq.useCallback)(()=>handleMove('right'), [
            handleMove
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isHidden) setIsOpen(false);
        }, [
            isHidden
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
                    onHoverChanged: setIsTriggerHovered
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                    ref: (0, (0, parcelRequire("7mPT9")).mergeRefs)(triggerRef, ref),
                    xcss: [
                        $11f38deb75f10dff$var$triggerStyles,
                        showHandle && $11f38deb75f10dff$var$visibleStyles,
                        showExpanded && $11f38deb75f10dff$var$expandedStyles
                    ],
                    "aria-label": formatMessage((0, $jtYtu.default).dragHandleLabel),
                    "aria-description": formatMessage((0, $jtYtu.default).dragHandleDescription),
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.utils.draggable-column.drag-handle",
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: [
                        $11f38deb75f10dff$var$iconStyles,
                        showExpanded && $11f38deb75f10dff$var$visibleStyles
                    ]
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dQO6P"))))), {
                    color: "var(--ds-icon-inverse, #FFFFFF)",
                    label: ""
                })))),
            isOpen: isOpen,
            onOpenChange: (attrs)=>setIsOpen(attrs.isOpen)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ctqwA"))))), {
                color: columnIndex === 0 ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)",
                label: ""
            }),
            onClick: handleMoveLeft,
            isDisabled: columnIndex === 0
        }, formatMessage((0, $jtYtu.default).moveFieldLeft)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h1TKi"))))), {
                color: columnIndex === columnIds.length - 1 ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)",
                label: ""
            }),
            onClick: handleMoveRight,
            isDisabled: columnIndex === columnIds.length - 1
        }, formatMessage((0, $jtYtu.default).moveFieldRight)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("i28qQ"))))), {
                color: "var(--ds-icon, #44546F)",
                label: ""
            }),
            onClick: handleHide
        }, formatMessage((0, $jtYtu.default).hideField)));
    });
    const $11f38deb75f10dff$var$triggerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        height: '5px',
        width: '12px',
        border: `2px solid ${"var(--ds-border-inverse, #FFFFFF)"}`,
        borderRadius: '5px',
        visibility: 'hidden',
        boxSizing: 'content-box',
        position: 'absolute',
        top: '-5px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 'card',
        cursor: 'grab'
    });
    const $11f38deb75f10dff$var$expandedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-accent-blue-subtle, #579DFF)",
        height: '14px',
        top: '-10px'
    });
    const $11f38deb75f10dff$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        visibility: 'hidden',
        transform: 'rotate(90deg)'
    });
    const $11f38deb75f10dff$var$visibleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        visibility: 'visible'
    });
});
parcelRegister("jtYtu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66bc2cb7975ef32e$export$2e2bcd8739ae039);
    var $7VHMR;
    const $66bc2cb7975ef32e$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        dragHandleLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.utils.draggable-column.drag-handle.drag-handle-label",
            "defaultMessage": "Drag handle"
        },
        dragHandleDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.utils.draggable-column.drag-handle.drag-handle-description",
            "defaultMessage": "Drag to reorder, click for more options"
        },
        hideField: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.utils.draggable-column.drag-handle.hide-field",
            "defaultMessage": "Hide field"
        },
        moveFieldLeft: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.utils.draggable-column.drag-handle.move-field-left",
            "defaultMessage": "Move field left"
        },
        moveFieldRight: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.utils.draggable-column.drag-handle.move-field-right",
            "defaultMessage": "Move field right"
        }
    });
    var $66bc2cb7975ef32e$export$2e2bcd8739ae039 = $66bc2cb7975ef32e$var$messages;
});
parcelRegister("7DWY4", function(module, exports) {
    $parcel$export(module.exports, "ColumnDropIndicator", ()=>$ae5694a1aa630509$export$265e69d63cbbbb15);
    var $bC2fB;
    var $ebG51 = parcelRequire("ebG51");
    var $9k4F1 = parcelRequire("9k4F1");
    const $ae5694a1aa630509$export$265e69d63cbbbb15 = (0, (0, parcelRequire("bC2fB")).connect)((0, $ebG51.mapStateToProps), {})((0, $9k4F1.ColumnDropIndicator));
});
parcelRegister("ebG51", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$567f03efc2dfa501$export$c31df4bd766f9c35);
    var $3YtPS = parcelRequire("3YtPS");
    var $iTACj = parcelRequire("iTACj");
    const $567f03efc2dfa501$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        columnIds: (0, $iTACj.getColumnIds)
    });
});
parcelRegister("9k4F1", function(module, exports) {
    $parcel$export(module.exports, "ColumnDropIndicator", ()=>$788cfedabdd75e70$export$265e69d63cbbbb15);
    var $5uXOq = parcelRequire("5uXOq");
    var $biEfA;
    var $7gWdR = parcelRequire("7gWdR");
    var $dC5iT;
    var $8CUq3;
    var $2EwIC;
    var $491Qk = parcelRequire("491Qk");
    const $788cfedabdd75e70$export$cdb7fd9d999c7168 = 50;
    const $788cfedabdd75e70$export$265e69d63cbbbb15 = ({ columnId: columnId, columnIds: columnIds })=>{
        const [{ height: height }] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [showIndicator, setShowIndicator] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)({
                canMonitor: ({ source: source })=>source.data.type === (0, $057a94f006b9ba47$export$7f092194d45e1f0d),
                onDrag: ({ source: source, location: location })=>{
                    const target = location.current.dropTargets[0];
                    if (!target) return;
                    const sourceColumnId = source.data.columnId;
                    const targetColumnId = target.data.columnId;
                    const closestEdge = (0, (0, parcelRequire("biEfA")).extractClosestEdge)(target.data);
                    if (typeof sourceColumnId !== 'string' || typeof targetColumnId !== 'string' || !closestEdge) return;
                    setShowIndicator((0, $491Qk.shouldShowIndicator)(sourceColumnId, targetColumnId, columnIds, closestEdge, columnId));
                },
                onDropTargetChange: ({ location: location })=>{
                    const target = location.current.dropTargets[0];
                    if (!target) setShowIndicator(false);
                },
                onDrop: ()=>setShowIndicator(false)
            }), [
            columnId,
            columnIds
        ]);
        (0, $5uXOq.useEffect)(()=>()=>setShowIndicator(false), [
            columnIds
        ]);
        return showIndicator && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $788cfedabdd75e70$var$indicatorStyles,
            style: {
                height: height - $788cfedabdd75e70$export$cdb7fd9d999c7168
            }
        });
    };
    const $788cfedabdd75e70$var$indicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-border-brand, #0C66E4)",
        pointerEvents: 'none',
        position: 'absolute',
        width: '2px',
        top: '0',
        right: '-1px',
        '::before': {
            content: '""',
            position: 'absolute',
            height: '0',
            width: '0',
            right: '-3px',
            borderTop: `${"var(--ds-space-100, 8px)"} solid ${"var(--ds-border-brand, #0C66E4)"}`,
            borderLeft: `${"var(--ds-space-050, 4px)"} solid transparent`,
            borderRight: `${"var(--ds-space-050, 4px)"} solid transparent`
        }
    });
});
parcelRegister("491Qk", function(module, exports) {
    $parcel$export(module.exports, "shouldShowIndicator", ()=>$9c22bbb7d03f7bff$export$b9da9b6a730799ff);
    var $9EGGH;
    const $9c22bbb7d03f7bff$export$b9da9b6a730799ff = (sourceColumnId, targetColumnId, columnIds, closestEdge, columnId)=>{
        const sourceIndex = columnIds.indexOf(sourceColumnId);
        const targetIndex = columnIds.indexOf(targetColumnId);
        const destinationIndex = (0, (0, parcelRequire("9EGGH")).getReorderDestinationIndex)({
            startIndex: sourceIndex,
            indexOfTarget: targetIndex,
            closestEdgeOfTarget: closestEdge,
            axis: 'horizontal'
        });
        if (sourceIndex === destinationIndex) return false;
        if (!columnId) return destinationIndex === 0 && closestEdge === 'left';
        const index = columnIds.indexOf(columnId);
        if (index === targetIndex) return closestEdge === 'right';
        if (index + 1 === targetIndex) return closestEdge === 'left';
        return false;
    };
});
parcelRegister("5DJ44", function(module, exports) {
    $parcel$export(module.exports, "DraggableColumn", ()=>$8dc051921ec218d1$export$a80792b86712355c);
    var $5uXOq = parcelRequire("5uXOq");
    var $7gWdR = parcelRequire("7gWdR");
    var $dC5iT;
    var $8CUq3;
    var $iwfmd;
    var $k5nD7 = parcelRequire("k5nD7");
    var $f1ybZ = parcelRequire("f1ybZ");
    const $8dc051921ec218d1$export$a80792b86712355c = ({ columnId: columnId, children: children, renderTrigger: renderTrigger, isDisabled: isDisabled })=>{
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const isColumnDragging = (0, $f1ybZ.useIsColumnDragging)();
        const triggerRef = (0, $5uXOq.useRef)(null);
        const containerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!containerRef.current) return;
            const container = containerRef.current;
            const trigger = triggerRef.current;
            const data = {
                type: (0, $057a94f006b9ba47$export$7f092194d45e1f0d),
                columnId: columnId
            };
            return (0, $7gWdR.draggable)({
                element: container,
                dragHandle: trigger ?? container,
                getInitialData: ()=>data,
                onDragStart: ()=>setIsDragging(true),
                onDrop: ()=>setIsDragging(false)
            });
        }, [
            columnId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwfmd")).default), {
            onHoverChanged: setIsHovered
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: containerRef,
            xcss: $8dc051921ec218d1$var$containerStyles,
            "data-column-id": columnId,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.utils.draggable-column"
        }, children, isColumnDragging && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $k5nD7.ColumnDropTarget), {
            columnId: columnId,
            isDragging: isDragging
        }), renderTrigger({
            ref: triggerRef,
            isVisible: isHovered,
            isHidden: Boolean(isDragging || isDisabled)
        })));
    };
    const $8dc051921ec218d1$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        width: '100%',
        height: '100%'
    });
});
parcelRegister("k5nD7", function(module, exports) {
    $parcel$export(module.exports, "ColumnDropTarget", ()=>$fff05a525c09b1d7$export$e8a325e09c5453d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $biEfA;
    var $7gWdR = parcelRequire("7gWdR");
    var $dC5iT;
    var $8CUq3;
    var $2EwIC;
    const $fff05a525c09b1d7$export$cdb7fd9d999c7168 = 50;
    const $fff05a525c09b1d7$export$e8a325e09c5453d5 = ({ columnId: columnId, isDragging: isDragging })=>{
        const [{ height: height }] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const targetRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!targetRef.current) return;
            const target = targetRef.current;
            const data = {
                type: (0, $057a94f006b9ba47$export$7f092194d45e1f0d),
                columnId: columnId
            };
            return (0, $7gWdR.dropTargetForElements)({
                element: target,
                canDrop: ({ source: source })=>source.data.columnId !== columnId,
                getData: ({ input: input, element: element })=>(0, (0, parcelRequire("biEfA")).attachClosestEdge)(data, {
                        input: input,
                        element: element,
                        allowedEdges: [
                            'left',
                            'right'
                        ]
                    })
            });
        }, [
            columnId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: targetRef,
            xcss: [
                $fff05a525c09b1d7$var$indicatorStyles,
                isDragging && $fff05a525c09b1d7$var$draggingStyles
            ],
            style: {
                height: height - $fff05a525c09b1d7$export$cdb7fd9d999c7168
            }
        });
    };
    const $fff05a525c09b1d7$var$indicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        top: 'space.0',
        left: 'space.0',
        width: '100%',
        position: 'absolute'
    });
    const $fff05a525c09b1d7$var$draggingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.accent.gray.subtler',
        opacity: '0.5'
    });
});
parcelRegister("hEBQR", function(module, exports) {
    $parcel$export(module.exports, "useFocusWithin", ()=>$399c2e84e54787a1$export$420e68273165f4ec);
    var $5uXOq = parcelRequire("5uXOq");
    const $399c2e84e54787a1$export$420e68273165f4ec = (ref)=>{
        const [isFocusWithin, setIsFocusWithin] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            const element = ref.current;
            if (!element) return;
            const update = ()=>setIsFocusWithin(element.matches(':focus-within'));
            element.addEventListener('focusin', update);
            element.addEventListener('focusout', update);
            return ()=>{
                element.removeEventListener('focusin', update);
                element.removeEventListener('focusout', update);
            };
        });
        return isFocusWithin;
    };
});
parcelRegister("3t5zX", function(module, exports) {
    $parcel$export(module.exports, "EnhancedContainer", ()=>$674c8d7920098e06$export$d79d1f64c95f1fea);
    var $5uXOq = parcelRequire("5uXOq");
    var $8CUq3;
    var $leRLW;
    var $doZTA;
    const $674c8d7920098e06$export$d79d1f64c95f1fea = ({ xcss: xcssStyles, ...restProps })=>{
        const [{ match: { params: params } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { planId: planId, scenarioId: scenarioId } = params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("leRLW")).Container), {
            scope: `${planId}-${scenarioId}`,
            xcss: [
                $674c8d7920098e06$var$containerStyles,
                ...Array.isArray(xcssStyles) ? xcssStyles : [
                    xcssStyles
                ]
            ],
            ...restProps
        });
    };
    const $674c8d7920098e06$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        zIndex: 0
    });
});
parcelRegister("leRLW", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$0ed9bb4314aed233$export$42a852a2b6b56249);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $7mPT9;
    var $2m0b6;
    var $2EwIC;
    const $0ed9bb4314aed233$var$defaultViewportInset = {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0
    };
    const $0ed9bb4314aed233$var$Inner = ({ xcss: xcssStyles, children: children, containerRef: containerRef, viewportInset: viewportInset = $0ed9bb4314aed233$var$defaultViewportInset, outerRef: outerRef = null, ...props })=>{
        const ref = (0, (0, parcelRequire("7mPT9")).default)(containerRef, outerRef);
        const frameId = (0, $5uXOq.useRef)();
        const initialY = (0, $5uXOq.useRef)(0);
        const scrollStart = (0, $5uXOq.useRef)(-1);
        const { scrollTo: scrollTo, setRect: setRect, updateIsScrollingY: updateIsScrollingY } = (0, (0, parcelRequire("2EwIC")).useContainerActions)();
        const onScrollEnd = (0, $5uXOq.useCallback)(()=>{
            scrollStart.current = -1;
            initialY.current = 0;
            updateIsScrollingY(false);
            if (frameId.current) {
                cancelAnimationFrame(frameId.current);
                frameId.current = undefined;
            }
        }, [
            updateIsScrollingY
        ]);
        const scrollTick = (0, $5uXOq.useCallback)(()=>{
            if (!containerRef.current) return;
            const now = performance.now();
            const scrollTime = now - scrollStart.current;
            const { scrollLeft: scrollLeft, scrollTop: scrollTop } = containerRef.current;
            if (scrollTime >= (0, $a1135a9ad1fa73d0$export$a9b912713512229e)) onScrollEnd();
            else {
                if (initialY.current !== scrollTop) updateIsScrollingY(true);
                scrollTo({
                    x: scrollLeft,
                    y: scrollTop,
                    passive: true
                });
                frameId.current = requestAnimationFrame(scrollTick);
            }
        }, [
            containerRef,
            scrollTo,
            onScrollEnd,
            updateIsScrollingY
        ]);
        const handleScroll = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
            scrollStart.current = performance.now();
            if (!frameId.current) {
                initialY.current = currentTarget.scrollTop;
                frameId.current = requestAnimationFrame(scrollTick);
            }
        }, [
            scrollTick
        ]);
        const handleResize = (0, $5uXOq.useCallback)(()=>{
            if (!containerRef.current) return;
            const { top: top, left: left } = containerRef.current.getBoundingClientRect();
            const trimingSize = 1;
            return setRect({
                top: top + viewportInset.top,
                left: left + viewportInset.left,
                width: containerRef.current.clientWidth - (viewportInset.left + viewportInset.right) - trimingSize,
                height: containerRef.current.clientHeight - (viewportInset.top + viewportInset.bottom) - trimingSize
            });
        }, [
            containerRef,
            setRect,
            viewportInset.bottom,
            viewportInset.left,
            viewportInset.right,
            viewportInset.top
        ]);
        (0, (0, parcelRequire("2m0b6")).useResizeObserver)({
            ref: containerRef,
            onResize: handleResize
        });
        (0, $5uXOq.useEffect)(()=>()=>{
                frameId.current && cancelAnimationFrame(frameId.current);
            }, []);
        const withInset = (inner)=>{
            const hasViewportInset = viewportInset?.top !== 0 && viewportInset?.right !== 0 && viewportInset?.bottom !== 0 && viewportInset?.left !== 0;
            if (!hasViewportInset) return inner;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                style: {
                    marginTop: viewportInset.top,
                    marginRight: viewportInset.right,
                    marginBottom: viewportInset.bottom,
                    marginLeft: viewportInset.left
                }
            }, inner);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: ref,
            onScroll: handleScroll,
            xcss: [
                $0ed9bb4314aed233$var$containerStyles,
                ...Array.isArray(xcssStyles) ? xcssStyles : [
                    xcssStyles
                ]
            ],
            ...props
        }, withInset(children));
    };
    const $0ed9bb4314aed233$export$42a852a2b6b56249 = ({ scope: scope, width: width, height: height, ...innerProps })=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const scrollTo = (0, $5uXOq.useCallback)(({ x: x, y: y, smooth: smooth })=>{
            const containerEl = containerRef.current;
            if (!containerEl) return;
            if (smooth) containerEl.style.scrollBehavior = 'smooth';
            if (x !== undefined) containerEl.scrollLeft = x;
            if (y !== undefined) containerEl.scrollTop = y;
            if (smooth) containerEl.style.scrollBehavior = 'auto';
        }, []);
        const containerProps = {
            scrollTo: scrollTo,
            ...scope !== undefined && {
                scope: scope
            },
            ...width !== undefined && {
                width: width
            },
            ...height !== undefined && {
                height: height
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2EwIC")).ContainerProvider), containerProps, (0, ($parcel$interopDefault($5uXOq))).createElement($0ed9bb4314aed233$var$Inner, {
            ...innerProps,
            containerRef: containerRef
        }));
    };
    const $0ed9bb4314aed233$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'stretch',
        flexDirection: 'column',
        overflow: 'auto',
        minWidth: '0',
        minHeight: '0'
    });
});
parcelRegister("2m0b6", function(module, exports) {
    $parcel$export(module.exports, "createResizeObserverHook", ()=>$072291c9ed048772$export$87a9d3e287304ae4);
    $parcel$export(module.exports, "useResizeObserver", ()=>$072291c9ed048772$export$683480f191c0e3ea);
    $parcel$export(module.exports, "flushResizeObservers", ()=>$072291c9ed048772$export$a181ef2a6d0a1bb6);
    $parcel$export(module.exports, "useRectObserver", ()=>$072291c9ed048772$export$e58143dc89297272);
    var $5uXOq = parcelRequire("5uXOq");
    var $eUdQc;
    function $072291c9ed048772$export$87a9d3e287304ae4(params) {
        const group = new (0, (0, parcelRequire("eUdQc")).ResizeObserverGroup)(params?.debouncePeriod);
        function useResizeObserver({ ref: ref, onResize: onResize }) {
            const onResizeRef = (0, $5uXOq.useRef)(onResize);
            (0, $5uXOq.useEffect)(()=>{
                onResizeRef.current = onResize;
            });
            const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
            (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
                ref,
                stableOnResize
            ]);
        }
        return {
            useResizeObserver: useResizeObserver,
            flushResizeObservers: ()=>group.flush()
        };
    }
    const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
    function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
        const [rect, setRect] = (0, $5uXOq.useState)(null);
        const onResize = ()=>{
            if (ref.current) setRect(ref.current.getBoundingClientRect());
        };
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!ref.current) throw new Error([
                'useRectObserver: ref is not available on mount.',
                'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
                'This will not work properly. Please update your code so that refs are always attached to components on mount.'
            ].join('\n'));
            setRect(ref.current.getBoundingClientRect());
        }, [
            ref
        ]);
        useResizeObserverDI({
            ref: ref,
            onResize: onResize
        });
        return rect;
    }
});
parcelRegister("eUdQc", function(module, exports) {
    $parcel$export(module.exports, "ResizeObserverGroup", ()=>$52e6ab4254804b44$export$607798bbe2869c0);
    var $7nsd3 = parcelRequire("7nsd3");
    var $lFKmC = parcelRequire("lFKmC");
    class $52e6ab4254804b44$export$607798bbe2869c0 {
        constructor(debouncePeriod = 16){
            this.subscribers = new Map();
            this.pendingUpdates = new Map();
            this.onResize = (entries)=>{
                entries.forEach((entry)=>{
                    const subscriber = this.subscribers.get(entry.target);
                    if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
                });
                this.scheduleFlush();
            };
            this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
            this.scheduleFlush = debouncePeriod > 0 ? (0, ($parcel$interopDefault($lFKmC)))(()=>{
                this.flush();
            }, debouncePeriod, {
                trailing: true,
                maxWait: 32
            }) : ()=>{
                this.flush();
            };
        }
        observe(ref, callback) {
            if (!ref.current) return ()=>{};
            this.subscribers.set(ref.current, {
                element: ref.current,
                callback: callback
            });
            this.observer?.observe(ref.current);
            return ()=>{
                if (!ref.current) return;
                this.subscribers.delete(ref.current);
                this.pendingUpdates.delete(ref.current);
                this.observer?.unobserve(ref.current);
            };
        }
        flush() {
            const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
            this.pendingUpdates.clear();
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                entries.forEach(({ callback: callback })=>{
                    callback();
                });
            });
        }
    }
});
const $a1135a9ad1fa73d0$export$a9b912713512229e = 150;
parcelRegister("ixYfg", function(module, exports) {
    $parcel$export(module.exports, "FieldAccessories", ()=>$e5f605e3fa8d7af6$export$79e852a97b56f18b);
    var $bC2fB;
    var $f0wdj = parcelRequire("f0wdj");
    var $64JXV = parcelRequire("64JXV");
    const $e5f605e3fa8d7af6$export$79e852a97b56f18b = (0, (0, parcelRequire("bC2fB")).connect)((0, $f0wdj.mapStateToProps), {})((0, $64JXV.FieldAccessories));
});
parcelRegister("f0wdj", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$ab6ec3c52946da22$export$c31df4bd766f9c35);
    var $bHTqr = parcelRequire("bHTqr");
    var $g7bEf = parcelRequire("g7bEf");
    const $ab6ec3c52946da22$export$c31df4bd766f9c35 = (state, { columnId: columnId })=>({
            column: (0, $g7bEf.getColumns)(state).find((column)=>column.id === columnId),
            dateConfiguration: (0, $bHTqr.getDateConfiguration)(state)
        });
});
parcelRegister("64JXV", function(module, exports) {
    $parcel$export(module.exports, "FieldAccessories", ()=>$580cd6106d924512$export$79e852a97b56f18b);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $fAImD = parcelRequire("fAImD");
    var $d3UHJ = parcelRequire("d3UHJ");
    const $580cd6106d924512$export$79e852a97b56f18b = ({ column: column, dateConfiguration: dateConfiguration, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getColumnTitle = (title)=>{
            if (typeof title === 'string') return title;
            return formatMessage(title);
        };
        const getMatchingConfiguredDateFields = (0, $d3UHJ.getMatchingConfiguredDate)(dateConfiguration);
        const configurableDate = getMatchingConfiguredDateFields(column.id);
        const tooltip = (0, $fAImD.getConfiguredDateTooltip)(configurableDate);
        const columnTitle = getColumnTitle(column.title);
        const titleTooltip = tooltip ? formatMessage(tooltip, {
            title: columnTitle
        }) : columnTitle;
        const icon = column.HeaderContent ? (0, ($parcel$interopDefault($5uXOq))).createElement(column.HeaderContent, null) : configurableDate && titleTooltip && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: titleTooltip
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') ? $580cd6106d924512$var$iconStyles : $580cd6106d924512$var$iconStylesOld
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, "D")));
        return children({
            title: columnTitle,
            icon: icon,
            column: column
        });
    };
    const $580cd6106d924512$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        cursor: 'pointer',
        marginLeft: 'space.050',
        marginRight: 'space.050',
        display: 'flex',
        alignItems: 'center'
    });
    const $580cd6106d924512$var$iconStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        cursor: 'pointer',
        marginLeft: 'space.050',
        marginRight: 'space.050',
        display: 'flex',
        alignItems: 'center',
        zIndex: 999
    });
});
parcelRegister("86PwE", function(module, exports) {
    $parcel$export(module.exports, "HorizontalScrollingSync", ()=>$8e24312c95df711c$export$f15283c409f0a3aa);
    var $gVi3o = parcelRequire("gVi3o");
    const $8e24312c95df711c$export$f15283c409f0a3aa = ({ offset: offset, columnWidths: columnWidths })=>{
        (0, $gVi3o.useScrollXSync)(offset);
        (0, $gVi3o.useViewportSync)(columnWidths);
        return null;
    };
});
parcelRegister("gVi3o", function(module, exports) {
    $parcel$export(module.exports, "useScrollXSync", ()=>$f7ea1f05823fd351$export$c26dc5f2e0cdda0a);
    $parcel$export(module.exports, "useViewportSync", ()=>$f7ea1f05823fd351$export$bc9523282040a795);
    var $5uXOq = parcelRequire("5uXOq");
    var $fTQlL = parcelRequire("fTQlL");
    var $cGv9m;
    var $hE4fC;
    var $2EwIC;
    const $f7ea1f05823fd351$export$c26dc5f2e0cdda0a = (leftPadding)=>{
        const [, { scrollTo: horizontalScrollTo, addScrollHandler: horizontalAddEventListener, removeScrollHandler: horizontalRemoveEventListener }] = (0, (0, parcelRequire("hE4fC")).useHorizontalScrolling)();
        const horizontalScrollXRef = (0, $5uXOq.useRef)();
        const [, { scrollTo: treegridScrollTo, addScrollHandler: treegridAddEventListener, removeScrollHandler: treegridRemoveEventListener }] = (0, (0, parcelRequire("2EwIC")).useScrollX)();
        (0, $5uXOq.useEffect)(()=>{
            const handler = ({ scrollX: scrollX })=>{
                if (scrollX - leftPadding !== horizontalScrollXRef.current) {
                    horizontalScrollTo(scrollX - leftPadding, 'external');
                    horizontalScrollXRef.current = scrollX - leftPadding;
                }
            };
            treegridAddEventListener(handler);
            return ()=>{
                treegridRemoveEventListener(handler);
            };
        }, [
            horizontalScrollTo,
            leftPadding,
            treegridAddEventListener,
            treegridRemoveEventListener
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handler = ({ offsetInPx: offsetInPx, smooth: smooth, source: source })=>{
                const nextTreegridScrollX = Math.round(offsetInPx) + leftPadding;
                if (source !== 'external') {
                    horizontalScrollXRef.current = Math.round(offsetInPx);
                    treegridScrollTo({
                        x: nextTreegridScrollX,
                        smooth: smooth
                    });
                }
            };
            horizontalAddEventListener(handler);
            return ()=>{
                horizontalRemoveEventListener(handler);
            };
        }, [
            horizontalAddEventListener,
            horizontalRemoveEventListener,
            treegridScrollTo,
            leftPadding
        ]);
    };
    const $f7ea1f05823fd351$export$bc9523282040a795 = (columnWidths)=>{
        const [zoomLevel] = (0, (0, parcelRequire("hE4fC")).useZoomLevel)();
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [, { resize: resize }] = (0, (0, parcelRequire("hE4fC")).useTimelineRuler)();
        const horizontalScrollViewportWidth = viewport.width - (0, ($parcel$interopDefault($fTQlL)))(1)(columnWidths).reduce((a, b)=>a + b, 0);
        (0, $5uXOq.useEffect)(()=>{
            if (!zoomLevel) return;
            resize({
                viewport: {
                    width: horizontalScrollViewportWidth,
                    position: {
                        left: 0,
                        top: 0
                    }
                },
                container: {
                    width: (0, (0, parcelRequire("cGv9m")).getContainerWidth)(zoomLevel),
                    duration: (0, (0, parcelRequire("cGv9m")).getContainerDuration)(zoomLevel)
                }
            });
        }, [
            zoomLevel,
            resize,
            horizontalScrollViewportWidth
        ]);
        return null;
    };
});
parcelRegister("8Fn01", function(module, exports) {
    $parcel$export(module.exports, "ItemProvider", ()=>$010e7cfce8b8219a$export$20d7a9065849b23d);
    var $bC2fB;
    var $bbenl = parcelRequire("bbenl");
    var $8Y8tF = parcelRequire("8Y8tF");
    const $010e7cfce8b8219a$export$20d7a9065849b23d = (0, (0, parcelRequire("bC2fB")).connect)((0, $bbenl.default), {})((0, $8Y8tF.ItemProvider));
});
parcelRegister("bbenl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$927be1c6f85ac042$export$2e2bcd8739ae039);
    var $6iNxz = parcelRequire("6iNxz");
    var $927be1c6f85ac042$export$2e2bcd8739ae039 = (state, { itemIndex: itemIndex })=>({
            item: (0, $6iNxz.getTableItems)(state)[itemIndex]
        });
});
parcelRegister("8Y8tF", function(module, exports) {
    $parcel$export(module.exports, "ItemProvider", ()=>$65d725972450dd85$export$20d7a9065849b23d);
    var $5uXOq = parcelRequire("5uXOq");
    var $eex53 = parcelRequire("eex53");
    var $caqUf = parcelRequire("caqUf");
    const $65d725972450dd85$var$withoutTopOffset = (0, ($parcel$interopDefault($caqUf)))('topOffset');
    const $65d725972450dd85$export$20d7a9065849b23d = ({ item: item, children: children })=>{
        const memoedRef = (0, $5uXOq.useRef)(item);
        memoedRef.current = (0, ($parcel$interopDefault($eex53)))($65d725972450dd85$var$withoutTopOffset(item), $65d725972450dd85$var$withoutTopOffset(memoedRef.current)) ? memoedRef.current : item;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($65d725972450dd85$export$73c50a4fd6dc74c9, {
            item: memoedRef.current
        }, children);
    };
    const $65d725972450dd85$export$73c50a4fd6dc74c9 = (0, $5uXOq.memo)(({ item: item, children: children })=>children(item));
});
parcelRegister("cte8I", function(module, exports) {
    $parcel$export(module.exports, "ResizeHandle", ()=>$0b6564062d269cc5$export$33f2411a0ad35be7);
    var $5uXOq = parcelRequire("5uXOq");
    var $8CUq3;
    var $7XYc4;
    var $4R6GH;
    var $aI0i7;
    var $2EwIC;
    var $h0pMA;
    var $f1ybZ = parcelRequire("f1ybZ");
    const $0b6564062d269cc5$var$ResizeHandleNew = ()=>{
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [{ row: row }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const style = (0, $5uXOq.useMemo)(()=>{
            switch(row){
                case 0:
                    return {
                        height: viewport.height
                    };
                case 1:
                    return {
                        height: viewport.height - 50
                    };
                default:
                    return undefined;
            }
        }, [
            viewport.height,
            row
        ]);
        const isColumnDragging = (0, $f1ybZ.useIsColumnDragging)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h0pMA")).ResizeHandle), {
            xcss: [
                $0b6564062d269cc5$var$resizeHandleStyles,
                isColumnDragging && $0b6564062d269cc5$var$disabledStyles
            ],
            style: style,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.utils.resize-handle.separator-fields-column"
        });
    };
    const $0b6564062d269cc5$var$ResizeHandleOld = ()=>{
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [{ row: row }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const style = (0, $5uXOq.useMemo)(()=>{
            switch(row){
                case 0:
                    return {
                        height: viewport.height
                    };
                case 1:
                    return {
                        height: viewport.height - 50
                    };
                default:
                    return undefined;
            }
        }, [
            viewport.height,
            row
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h0pMA")).ResizeHandle), {
            xcss: $0b6564062d269cc5$var$resizeHandleStyles,
            style: style,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.utils.resize-handle.separator-fields-column"
        });
    };
    const $0b6564062d269cc5$export$33f2411a0ad35be7 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns'), $0b6564062d269cc5$var$ResizeHandleNew, $0b6564062d269cc5$var$ResizeHandleOld);
    const $0b6564062d269cc5$var$resizeHandleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.0',
        right: '-0.5px',
        zIndex: 1
    });
    const $0b6564062d269cc5$var$disabledStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        pointerEvents: 'none'
    });
});
parcelRegister("h0pMA", function(module, exports) {
    $parcel$export(module.exports, "ResizeHandle", ()=>$8ce2a01c6b5a0908$export$33f2411a0ad35be7);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $gwIPs;
    var $4R6GH;
    var $aI0i7;
    var $2EwIC;
    var $8LV9S;
    var $7uKTG;
    const $8ce2a01c6b5a0908$export$33f2411a0ad35be7 = ({ style: style, xcss: xcssStyles, testId: testId })=>{
        const [resizePayload, { hover: hover, activate: activate }] = (0, (0, parcelRequire("7uKTG")).useResize)();
        const [{ column: column, colSpan: colSpan }] = (0, (0, parcelRequire("aI0i7")).useCell)();
        const [scrollX] = (0, (0, parcelRequire("2EwIC")).useScrollX)();
        const [visible] = (0, (0, parcelRequire("8LV9S")).useResizerVisible)({
            column: column,
            scrollX: scrollX,
            preview: true
        });
        const columnToResize = column + (colSpan - 1);
        const { resize: resize } = (0, (0, parcelRequire("8LV9S")).useGridActions)();
        const hovered = resizePayload.column === columnToResize && resizePayload.hovered;
        const active = resizePayload.column === columnToResize && resizePayload.active;
        const handleMouseMove = (0, $5uXOq.useCallback)(()=>{
            if (!hovered) hover(columnToResize, true);
        }, [
            columnToResize,
            hover,
            hovered
        ]);
        const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
            hover(columnToResize, false);
        }, [
            columnToResize,
            hover
        ]);
        const handleMouseDown = (0, $5uXOq.useCallback)((e)=>{
            e.preventDefault();
            activate(columnToResize, true);
            const blanketEl = document.createElement('div');
            blanketEl.style.zIndex = String((0, (0, parcelRequire("gwIPs")).layers).blanket);
            blanketEl.style.position = 'fixed';
            blanketEl.style.inset = '0px';
            blanketEl.style.cursor = 'ew-resize';
            let delta = 0;
            const anchorOffset = e.clientX;
            const handleMouseMove = (e)=>{
                delta = e.clientX - anchorOffset;
                resize(columnToResize, delta);
            };
            const handleMouseUp = ()=>{
                activate(columnToResize, false);
                resize(columnToResize, delta, true);
                document.body.removeChild(blanketEl);
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
            document.body.appendChild(blanketEl);
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }, [
            activate,
            columnToResize,
            resize
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            role: "separator",
            "aria-orientation": "horizontal",
            onMouseMove: handleMouseMove,
            onMouseLeave: handleMouseLeave,
            onMouseDown: handleMouseDown,
            xcss: (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') ? [
                $8ce2a01c6b5a0908$var$handleStyles,
                (hovered || active) && $8ce2a01c6b5a0908$var$activeStyles,
                visible && $8ce2a01c6b5a0908$var$visibleStyles,
                ...Array.isArray(xcssStyles) ? xcssStyles : [
                    xcssStyles
                ]
            ] : [
                $8ce2a01c6b5a0908$var$handleStyles,
                (hovered || active) && $8ce2a01c6b5a0908$var$activeStyles,
                visible && $8ce2a01c6b5a0908$var$visibleStyles,
                xcssStyles
            ],
            style: style,
            testId: testId
        });
    };
    const $8ce2a01c6b5a0908$var$handleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '2px',
        position: 'relative',
        cursor: 'ew-resize',
        visibility: 'hidden',
        '::before': {
            content: '""',
            position: 'absolute',
            inset: 'space.0',
            left: 'space.negative.050',
            right: 'space.negative.050'
        }
    });
    const $8ce2a01c6b5a0908$var$activeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.selected.bold'
    });
    const $8ce2a01c6b5a0908$var$visibleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        visibility: 'visible'
    });
});
parcelRegister("7uKTG", function(module, exports) {
    $parcel$export(module.exports, "useResize", ()=>$f0d93c7a514f3d9d$export$e8b771555dc4a003);
    var $3sQ5x;
    var $iXqE5;
    var $eCcQD;
    const $f0d93c7a514f3d9d$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            column: undefined,
            hovered: false,
            active: false
        },
        actions: (0, parcelRequire("eCcQD")).actions
    });
    const $f0d93c7a514f3d9d$export$e8b771555dc4a003 = (0, (0, parcelRequire("3sQ5x")).createHook)($f0d93c7a514f3d9d$var$store);
});
parcelRegister("eCcQD", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$9a1c24e1c2e250de$export$e324594224ef24da);
    const $9a1c24e1c2e250de$export$e324594224ef24da = {
        hover: (column, value)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                if (state.active && column !== state.column) return;
                setState({
                    column: column,
                    hovered: value
                });
            },
        activate: (column, value)=>({ setState: setState })=>{
                setState({
                    column: column,
                    active: value
                });
            }
    };
});
parcelRegister("7s7Sp", function(module, exports) {
    $parcel$export(module.exports, "ScrollIntoView", ()=>$9700a5abf6300483$export$f76d2d7265193504);
    var $bC2fB;
    var $hESoG = parcelRequire("hESoG");
    var $kuN9k = parcelRequire("kuN9k");
    const $9700a5abf6300483$export$f76d2d7265193504 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hESoG.default), {})((0, $kuN9k.ScrollIntoView));
});
parcelRegister("hESoG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb698d739482924c$export$2e2bcd8739ae039);
    var $6L8iB = parcelRequire("6L8iB");
    var $3YtPS = parcelRequire("3YtPS");
    var $fb698d739482924c$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        scrollIntoViewIndex: (0, $6L8iB.getScrollIntoViewIndex),
        rowConfigs: (0, $6L8iB.getRowConfigs)
    });
});
parcelRegister("kuN9k", function(module, exports) {
    $parcel$export(module.exports, "ScrollIntoView", ()=>$96a025b80eba3843$export$f76d2d7265193504);
    var $5uXOq = parcelRequire("5uXOq");
    var $2EwIC;
    var $5jWqO = parcelRequire("5jWqO");
    const $96a025b80eba3843$export$f76d2d7265193504 = ({ rowConfigs: rowConfigs, scrollIntoViewIndex: scrollIntoViewIndex })=>{
        const [{ height: height }] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [scrollY, { scrollTo: scrollTo }] = (0, (0, parcelRequire("2EwIC")).useScrollY)();
        const nextScrollYRef = (0, $5uXOq.useRef)(scrollY);
        const viewport = [
            scrollY + 130,
            scrollY + height - 80
        ];
        const element = scrollIntoViewIndex && (0, $5jWqO.getRowVerticalBound)(rowConfigs, scrollIntoViewIndex);
        const distance = element && (0, $5jWqO.distanceIntoView)(viewport, element);
        nextScrollYRef.current = scrollY + (distance ?? 0);
        (0, $5uXOq.useEffect)(()=>{
            const nextScrollY = nextScrollYRef.current;
            if (scrollIntoViewIndex !== undefined) scrollTo({
                y: nextScrollY
            });
        }, [
            scrollIntoViewIndex,
            scrollTo
        ]);
        return null;
    };
});
parcelRegister("5jWqO", function(module, exports) {
    $parcel$export(module.exports, "getRowVerticalBound", ()=>$401b6a64da3873c0$export$3f4749604a4df635);
    $parcel$export(module.exports, "distanceIntoView", ()=>$401b6a64da3873c0$export$cdeb0f3f6596610d);
    const $401b6a64da3873c0$export$3f4749604a4df635 = (rowConfigs, row)=>{
        const lower = rowConfigs.slice(0, row).reduce((acc, { height: height })=>acc + height, 0);
        const upper = lower + rowConfigs[row].height;
        return [
            lower,
            upper
        ];
    };
    const $401b6a64da3873c0$export$cdeb0f3f6596610d = (viewport, element)=>{
        if (element[1] > viewport[1]) return element[1] - viewport[1];
        if (element[0] < viewport[0]) return element[0] - viewport[0];
        return 0;
    };
});
parcelRegister("2fN10", function(module, exports) {
    $parcel$export(module.exports, "ScrollReset", ()=>$9160476c85ef5631$export$31b0b4b9e79b0e37);
    var $5uXOq = parcelRequire("5uXOq");
    var $3J2mc;
    var $hE4fC;
    var $2EwIC;
    const $9160476c85ef5631$export$31b0b4b9e79b0e37 = ({ viewId: viewId, viewMode: viewMode })=>{
        const [, { backToToday: backToToday }] = (0, (0, parcelRequire("hE4fC")).useToday)();
        const { scrollTo: scrollTo } = (0, (0, parcelRequire("2EwIC")).useContainerActions)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE) backToToday();
            else scrollTo({
                x: 0
            });
        }, [
            backToToday,
            scrollTo,
            viewId,
            viewMode
        ]);
        return null;
    };
});
parcelRegister("dhREm", function(module, exports) {
    $parcel$export(module.exports, "TimelineDragAutoScroll", ()=>$a8fc40de164862d7$export$99b9a64969eac79);
    var $5uXOq = parcelRequire("5uXOq");
    var $8vyMo;
    var $8LV9S;
    var $aFeC0 = parcelRequire("aFeC0");
    var $h9QIu = parcelRequire("h9QIu");
    const $a8fc40de164862d7$export$99b9a64969eac79 = ({ containerRef: containerRef })=>{
        const [columnWidths] = (0, (0, parcelRequire("8LV9S")).useColumnWidths)({
            preview: false
        });
        const marginLeft = columnWidths.reduce((totalWidth, curWidth, index)=>index < columnWidths.length - 1 ? totalWidth + curWidth : totalWidth, 0);
        const monitors = (0, $5uXOq.useMemo)(()=>[
                ({ start: start, update: update, end: end })=>(0, $h9QIu.monitorForIssueBarUpdate)({
                        onDragStart: start,
                        onDragEnd: end,
                        onDrag: update
                    }),
                ({ start: start, update: update, end: end })=>(0, (0, parcelRequire("8vyMo")).monitorForDependencyCreate)({
                        onDragStart: start,
                        onDropTargetChange: ({ location: location })=>update(location.current.input),
                        onDrag: ({ location: location })=>update(location.current.input),
                        onDrop: end
                    })
            ], []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aFeC0.DragAutoScroll), {
            allowedAxis: "both",
            containerRef: containerRef,
            insetHitbox: {
                top: 90,
                left: marginLeft
            },
            monitors: monitors
        });
    };
});
parcelRegister("h9QIu", function(module, exports) {
    $parcel$export(module.exports, "monitorForIssueBarUpdate", ()=>$e5ea5c60c4f61820$export$80a12a95186a4db6);
    var $8KRRD = parcelRequire("8KRRD");
    const $e5ea5c60c4f61820$export$80a12a95186a4db6 = ({ onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd })=>{
        const stripPageY = (callback)=>({ pageX: pageX })=>callback({
                    pageX: pageX,
                    pageY: NaN
                });
        const handleDragStart = stripPageY(onDragStart);
        const handleDrag = stripPageY(onDrag);
        const handleDragEnd = stripPageY(onDragEnd);
        (0, $8KRRD.default).addEventListener('dragstart', handleDragStart);
        (0, $8KRRD.default).addEventListener('drag', handleDrag);
        (0, $8KRRD.default).addEventListener('dragend', handleDragEnd);
        return ()=>{
            (0, $8KRRD.default).removeEventListener('dragstart', handleDragStart);
            (0, $8KRRD.default).removeEventListener('drag', handleDrag);
            (0, $8KRRD.default).removeEventListener('dragend', handleDragEnd);
        };
    };
});
parcelRegister("kk57f", function(module, exports) {
    $parcel$export(module.exports, "TimelineDragAutoScroll", ()=>$82c525a49368385d$export$99b9a64969eac79);
    var $5uXOq = parcelRequire("5uXOq");
    var $8vyMo;
    var $2EwIC;
    var $8LV9S;
    var $cwTC1 = parcelRequire("cwTC1");
    const $82c525a49368385d$var$MAX_SPEED = 0.5;
    const $82c525a49368385d$export$99b9a64969eac79 = ({ containerRef: containerRef })=>{
        const [viewport] = (0, (0, parcelRequire("2EwIC")).useViewport)();
        const [columnWidths] = (0, (0, parcelRequire("8LV9S")).useColumnWidths)({
            preview: false
        });
        const marginLeft = columnWidths.reduce((totalWidth, curWidth, index)=>index < columnWidths.length - 1 ? totalWidth + curWidth : totalWidth, 0);
        const autoscroll = (0, $5uXOq.useCallback)((timeSinceLastFrame, { pageX: pageX, pageY: pageY })=>{
            const edgeDistances = {
                top: pageY - viewport.top - 90,
                bottom: viewport.top + viewport.height - pageY,
                left: pageX - viewport.left - marginLeft,
                right: viewport.left + viewport.width - pageX
            };
            const velocity = (distanceToTheEdge)=>distanceToTheEdge <= 0 ? 0 : Math.max($82c525a49368385d$var$MAX_SPEED - distanceToTheEdge / 200, 0);
            const containerEl = containerRef.current;
            if (containerEl) {
                let xAmount = velocity(edgeDistances.right) * timeSinceLastFrame;
                if (xAmount === 0) xAmount = -velocity(edgeDistances.left) * timeSinceLastFrame;
                if (!Number.isNaN(xAmount) && xAmount !== 0) containerEl.scrollLeft += xAmount;
                let yAmount = velocity(edgeDistances.bottom) * timeSinceLastFrame;
                if (yAmount === 0) yAmount = -velocity(edgeDistances.top) * timeSinceLastFrame;
                if (!Number.isNaN(yAmount) && yAmount !== 0) containerEl.scrollTop += yAmount;
            }
        }, [
            containerRef,
            marginLeft,
            viewport.height,
            viewport.left,
            viewport.top,
            viewport.width
        ]);
        const { start: start, end: end, update: update } = (0, $cwTC1.useScheduler)(autoscroll);
        (0, $5uXOq.useEffect)(()=>(0, $cwTC1.monitorForIssueBarUpdate)({
                onDragStart: start,
                onDragEnd: end,
                onDrag: update
            }), [
            start,
            end,
            update
        ]);
        (0, $5uXOq.useEffect)(()=>(0, (0, parcelRequire("8vyMo")).monitorForDependencyCreate)({
                onDragStart: start,
                onDropTargetChange: ({ location: location })=>update(location.current.input),
                onDrag: ({ location: location })=>update(location.current.input),
                onDrop: end
            }), [
            start,
            end,
            update
        ]);
        return null;
    };
});
parcelRegister("cwTC1", function(module, exports) {
    $parcel$export(module.exports, "useScheduler", ()=>$2af9a336c2d117dc$export$a9fb6bc18c647ec4);
    $parcel$export(module.exports, "monitorForIssueBarUpdate", ()=>$2af9a336c2d117dc$export$80a12a95186a4db6);
    var $5uXOq = parcelRequire("5uXOq");
    var $8KRRD = parcelRequire("8KRRD");
    const $2af9a336c2d117dc$export$a9fb6bc18c647ec4 = (onFrame)=>{
        const lastFrameTimestampRef = (0, $5uXOq.useRef)();
        const latestArgs = (0, $5uXOq.useRef)();
        const frameIdRef = (0, $5uXOq.useRef)();
        const loop = (0, $5uXOq.useCallback)(()=>{
            const now = Date.now();
            if (latestArgs.current !== undefined && lastFrameTimestampRef.current !== undefined) onFrame(now - lastFrameTimestampRef.current, latestArgs.current);
            lastFrameTimestampRef.current = Date.now();
            frameIdRef.current = requestAnimationFrame(loop);
        }, [
            onFrame
        ]);
        const start = (0, $5uXOq.useCallback)(()=>{
            lastFrameTimestampRef.current = Date.now();
            frameIdRef.current = requestAnimationFrame(loop);
        }, [
            loop
        ]);
        const update = (0, $5uXOq.useCallback)((args)=>{
            latestArgs.current = args;
        }, []);
        const end = (0, $5uXOq.useCallback)(()=>{
            lastFrameTimestampRef.current = undefined;
            if (frameIdRef.current !== undefined) cancelAnimationFrame(frameIdRef.current);
            frameIdRef.current = undefined;
            latestArgs.current = undefined;
        }, []);
        return {
            start: start,
            update: update,
            end: end
        };
    };
    const $2af9a336c2d117dc$export$80a12a95186a4db6 = ({ onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd })=>{
        const stripPageY = (callback)=>({ pageX: pageX })=>callback({
                    pageX: pageX,
                    pageY: NaN
                });
        const handleDragStart = stripPageY(onDragStart);
        const handleDrag = stripPageY(onDrag);
        const handleDragEnd = stripPageY(onDragEnd);
        (0, $8KRRD.default).addEventListener('dragstart', handleDragStart);
        (0, $8KRRD.default).addEventListener('drag', handleDrag);
        (0, $8KRRD.default).addEventListener('dragend', handleDragEnd);
        return ()=>{
            (0, $8KRRD.default).removeEventListener('dragstart', handleDragStart);
            (0, $8KRRD.default).removeEventListener('drag', handleDrag);
            (0, $8KRRD.default).removeEventListener('dragend', handleDragEnd);
        };
    };
});
parcelRegister("4KvFW", function(module, exports) {
    $parcel$export(module.exports, "ViewExperienceSuccessTracker", ()=>$fbc6b35e9cf5d4b5$export$6f8a0a73a3c8e51a);
    var $5uXOq = parcelRequire("5uXOq");
    var $gEcei = parcelRequire("gEcei");
    const $fbc6b35e9cf5d4b5$var$TriggerExperienceSuccess = ({ onExperienceSuccess: onExperienceSuccess })=>{
        (0, $5uXOq.useEffect)(()=>{
            onExperienceSuccess?.();
        }, [
            onExperienceSuccess
        ]);
        return null;
    };
    const $fbc6b35e9cf5d4b5$export$6f8a0a73a3c8e51a = (0, $gEcei.default)($fbc6b35e9cf5d4b5$var$TriggerExperienceSuccess, 'portfolio-3.simple-plans.roadmap.table');
});
parcelRegister("hN22E", function(module, exports) {
    $parcel$export(module.exports, "TableSkeleton", ()=>$c99eb1e716cde283$export$7afc19c20799c3c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $8CUq3;
    var $koVbs;
    var $3KPkz;
    var $iZLaw;
    var $9IGpV;
    var $ihPUd = parcelRequire("ihPUd");
    var $4hgLn;
    var $lvtWn;
    var $2KkNy;
    var $3t5zX = parcelRequire("3t5zX");
    var $33aBE = parcelRequire("33aBE");
    const $c99eb1e716cde283$var$HeaderRow = ({ index: index, columns: columns })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
            index: index,
            style: {
                '--plan-grid-row-background': `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20A})`
            }
        }, columns.map((column, index)=>{
            switch(column.tag){
                case 'SCOPE':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
                        key: index,
                        column: index,
                        xcss: [
                            $c99eb1e716cde283$var$cellStyles,
                            $c99eb1e716cde283$var$headerCellStyles
                        ]
                    }, intl.formatMessage((0, $33aBE.default).issue));
                case 'FIELDS':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
                        key: index,
                        column: index,
                        xcss: [
                            $c99eb1e716cde283$var$cellStyles,
                            $c99eb1e716cde283$var$headerCellStyles
                        ]
                    }, intl.formatMessage((0, $33aBE.default).fields));
                case 'TIMELINE':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
                        key: index,
                        column: index,
                        xcss: [
                            $c99eb1e716cde283$var$cellStyles,
                            $c99eb1e716cde283$var$headerCellStyles
                        ]
                    });
                default:
                    return null;
            }
        }));
    };
    const $c99eb1e716cde283$var$SubheaderRow = ({ index: index, columns: columns })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
            index: index
        }, columns.map((column, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
                key: index,
                column: index,
                xcss: [
                    $c99eb1e716cde283$var$cellStyles,
                    $c99eb1e716cde283$var$headerCellStyles
                ]
            })));
    const $c99eb1e716cde283$var$BodyRow = ({ index: index, columns: columns, animate: animate })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
            index: index
        }, columns.map((column, index)=>{
            switch(column.tag){
                case 'SCOPE':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
                        key: index,
                        column: index,
                        xcss: $c99eb1e716cde283$var$cellStyles
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        style: {
                            width: '100%',
                            height: '600px'
                        }
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KPkz")).default), {
                        ariaLabel: intl.formatMessage((0, $ihPUd.default).loadingIssuesMessage),
                        numOfIssues: 11,
                        sidePadding: 16,
                        showIssueSelectCheckbox: true,
                        showIssueWithoutParent: true,
                        animate: animate
                    })));
                case 'FIELDS':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
                        key: index,
                        column: index,
                        xcss: $c99eb1e716cde283$var$cellStyles
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        style: {
                            width: '100%',
                            height: '600px'
                        }
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iZLaw")).default), {
                        ariaLabel: intl.formatMessage((0, $ihPUd.default).loadingIssuesMessage),
                        numOfRows: 13,
                        spaceInBetween: 12,
                        animate: animate
                    })));
                case 'TIMELINE':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
                        key: index,
                        column: index,
                        xcss: $c99eb1e716cde283$var$cellStyles
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        style: {
                            width: '100%',
                            height: '600px'
                        }
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9IGpV")).default), {
                        ariaLabel: intl.formatMessage((0, $ihPUd.default).loadingIssuesMessage),
                        animate: animate
                    })));
                default:
                    return null;
            }
        }));
    };
    const $c99eb1e716cde283$export$7afc19c20799c3c1 = ({ animate: animate = true })=>{
        const columnConfigs = [
            {
                id: 'scope',
                sticky: false
            },
            {
                id: 'fields',
                sticky: false
            },
            {
                id: 'timeline',
                sticky: false
            }
        ];
        const columnWidths = [
            200,
            ...Array(1).fill(300),
            undefined
        ];
        const rowConfigs = [
            {
                sticky: false,
                height: 50,
                thead: true,
                top: 0
            },
            {
                sticky: false,
                height: 40,
                thead: true,
                top: 50
            },
            {
                sticky: false,
                height: 550,
                thead: false,
                top: 90
            }
        ];
        const rows = [
            {
                tag: 'HEADER',
                content: 'header'
            },
            {
                tag: 'SUBHEADER',
                content: 'subheader'
            },
            {
                tag: 'BODY',
                content: 'body'
            }
        ];
        const columns = [
            {
                tag: 'SCOPE',
                name: 'scope'
            },
            {
                tag: 'FIELDS',
                name: 'fields'
            },
            {
                tag: 'TIMELINE',
                name: 'timeline'
            }
        ];
        const stickyOffset = {
            vertical: 0,
            horizontal: 0
        };
        const uniq = (a)=>Array.from(new Set(a));
        const rangeExtractor = ({ above: above, within: within, below: below })=>uniq([
                0,
                1,
                ...above,
                ...within,
                ...below
            ]);
        const renderRow = (_row, _columns, index)=>{
            const row = rows[index];
            if (row.tag === 'HEADER') return (0, ($parcel$interopDefault($5uXOq))).createElement($c99eb1e716cde283$var$HeaderRow, {
                key: index,
                index: index,
                columns: columns
            });
            if (row.tag === 'SUBHEADER') return (0, ($parcel$interopDefault($5uXOq))).createElement($c99eb1e716cde283$var$SubheaderRow, {
                key: index,
                index: index,
                columns: columns
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($c99eb1e716cde283$var$BodyRow, {
                key: index,
                index: index,
                columns: columns,
                animate: animate
            });
        };
        const renderEmpty = (height)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
                index: -1,
                height: height
            }, columns.map((_, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
                    key: index,
                    column: index,
                    xcss: $c99eb1e716cde283$var$cellStyles
                })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3t5zX.EnhancedContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvtWn")).Grid), {
            columnConfigs: columnConfigs,
            columnWidths: columnWidths,
            rowConfigs: rowConfigs,
            row: renderRow,
            empty: renderEmpty,
            overscan: 20,
            stickyOffset: stickyOffset,
            rangeExtractor: rangeExtractor,
            onColumnWidthsChange: ()=>null
        }, (table)=>table));
    };
    const $c99eb1e716cde283$var$cellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRight: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`}`,
        backgroundColor: 'elevation.surface',
        paddingTop: 'space.0',
        paddingBottom: 'space.0',
        paddingLeft: 'space.250',
        boxSizing: 'border-box',
        verticalAlign: 'middle',
        fontWeight: '500',
        zIndex: 0,
        ':nth-of-type(1)': {
            paddingLeft: 'space.250'
        },
        '::after': {
            content: '""',
            position: 'absolute',
            inset: 'space.0',
            background: 'var(--plan-grid-row-background)',
            zIndex: -1
        }
    });
    const $c99eb1e716cde283$var$headerCellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N30})`}`
    });
});
parcelRegister("3KPkz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56cbec5fa42e4386$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cn3Ob;
    var $jnD30;
    var $hlzJ2 = parcelRequire("hlzJ2");
    var $fNobW;
    var $co1wz;
    var $7KnaJ;
    var $5kC1b = parcelRequire("5kC1b");
    class $56cbec5fa42e4386$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                numOfIssues: 10,
                rowHeight: (0, (0, parcelRequire("7KnaJ")).RECT_ROW_HEIGHT),
                showIssueWithoutParent: false,
                showIssueSelectCheckbox: false,
                sidePadding: 8,
                spaceInBetween: 8,
                topPadding: 8,
                animate: true
            };
        }
        render() {
            const { ariaLabel: ariaLabel, numOfIssues: numOfIssues, showIssueSelectCheckbox: showIssueSelectCheckbox, showIssueWithoutParent: showIssueWithoutParent, animate: animate } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
                name: "issue-hierarchy-skeleton"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hlzJ2.AutoSizer), null, ({ width: width, height: height })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5kC1b.skeleton,
                    style: {
                        width: width,
                        height: height
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnD30")).default), {
                    ariaLabel: ariaLabel,
                    width: width,
                    height: height,
                    ...(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? {
                        animate: animate
                    } : {},
                    ...(0, (0, parcelRequire("7KnaJ")).DEFAULT_CONTENT_LOADER_PROPS)
                }, showIssueSelectCheckbox && this.getCheckboxes(), (0, parcelRequire("cn3Ob")).default(0, numOfIssues).map((index)=>this.getIssues(index, width)), showIssueWithoutParent && this.getIssueWithoutParentBlock(width)))));
        }
        constructor(...args){
            super(...args);
            this.checkboxSize = 16;
            this.getCheckboxes = ()=>{
                const { numOfIssues: numOfIssues, sidePadding: sidePadding, spaceInBetween: spaceInBetween, rowHeight: rowHeight, topPadding: topPadding } = this.props;
                const extraSpaceToCenter = Math.floor((rowHeight - this.checkboxSize) / 2);
                return (0, parcelRequire("cn3Ob")).default(0, numOfIssues).map((index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                        key: index
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                        x: sidePadding,
                        y: index * (rowHeight + spaceInBetween) + topPadding + extraSpaceToCenter,
                        ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
                        width: this.checkboxSize,
                        height: this.checkboxSize
                    })));
            };
            this.getIssues = (index, width)=>{
                const { sidePadding: sidePadding, spaceInBetween: spaceInBetween, rowHeight: rowHeight, topPadding: topPadding, showIssueSelectCheckbox: showIssueSelectCheckbox } = this.props;
                const spaceBetweenIssueAndCheckbox = 44;
                const indentToShowHierarchy = 20;
                let xCordinate = showIssueSelectCheckbox ? sidePadding + (this.checkboxSize + spaceBetweenIssueAndCheckbox) : sidePadding;
                xCordinate = index % 2 === 0 ? xCordinate : xCordinate + indentToShowHierarchy;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                    key: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: xCordinate,
                    y: index * (rowHeight + spaceInBetween) + topPadding,
                    ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
                    width: width / 2,
                    height: rowHeight
                }));
            };
            this.getIssueWithoutParentBlock = (width)=>{
                const { numOfIssues: numOfIssues, sidePadding: sidePadding, spaceInBetween: spaceInBetween, rowHeight: rowHeight, topPadding: topPadding } = this.props;
                const indentToShowPerHierarchyIssueCount = 30;
                return (0, parcelRequire("cn3Ob")).default(numOfIssues, numOfIssues + 3).map((index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                        key: index
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                        x: index === numOfIssues ? sidePadding : sidePadding + indentToShowPerHierarchyIssueCount,
                        y: index * (rowHeight + spaceInBetween) + topPadding,
                        ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
                        width: index === numOfIssues ? width / 2 : width / 3,
                        height: rowHeight
                    })));
            };
        }
    }
});
parcelRegister("hlzJ2", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $2YmwZ = parcelRequire("2YmwZ");
    Object.defineProperty(module.exports, 'default', {
        enumerable: true,
        get: function get() {
            return $ca101c26fb9a4d49$var$_interopRequireDefault($2YmwZ).default;
        }
    });
    Object.defineProperty(module.exports, 'AutoSizer', {
        enumerable: true,
        get: function get() {
            return $ca101c26fb9a4d49$var$_interopRequireDefault($2YmwZ).default;
        }
    });
    function $ca101c26fb9a4d49$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
});
parcelRegister("2YmwZ", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $knQh8 = parcelRequire("knQh8");
    var $22a2a99166405134$var$_extends3 = $22a2a99166405134$var$_interopRequireDefault($knQh8);
    var $29Ol4 = parcelRequire("29Ol4");
    var $22a2a99166405134$var$_getPrototypeOf2 = $22a2a99166405134$var$_interopRequireDefault($29Ol4);
    var $aXTp8 = parcelRequire("aXTp8");
    var $22a2a99166405134$var$_classCallCheck3 = $22a2a99166405134$var$_interopRequireDefault($aXTp8);
    var $4tLNB = parcelRequire("4tLNB");
    var $22a2a99166405134$var$_createClass3 = $22a2a99166405134$var$_interopRequireDefault($4tLNB);
    var $5pMaQ = parcelRequire("5pMaQ");
    var $22a2a99166405134$var$_possibleConstructorReturn3 = $22a2a99166405134$var$_interopRequireDefault($5pMaQ);
    var $gHLl6 = parcelRequire("gHLl6");
    var $22a2a99166405134$var$_inherits3 = $22a2a99166405134$var$_interopRequireDefault($gHLl6);
    var $5uXOq = parcelRequire("5uXOq");
    var $22a2a99166405134$var$React = $22a2a99166405134$var$_interopRequireWildcard($5uXOq);
    var $7ydDp = parcelRequire("7ydDp");
    var $22a2a99166405134$var$_detectElementResize2 = $22a2a99166405134$var$_interopRequireDefault($7ydDp);
    var $8rCP3;
    var $22a2a99166405134$var$_propTypes2 = $22a2a99166405134$var$_interopRequireDefault((0, parcelRequire("8rCP3")));
    function $22a2a99166405134$var$_interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function $22a2a99166405134$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $22a2a99166405134$var$AutoSizer = function(_React$PureComponent) {
        (0, $22a2a99166405134$var$_inherits3.default)(AutoSizer, _React$PureComponent);
        function AutoSizer() {
            var _ref;
            var _temp, _this, _ret;
            (0, $22a2a99166405134$var$_classCallCheck3.default)(this, AutoSizer);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = (0, $22a2a99166405134$var$_possibleConstructorReturn3.default)(this, (_ref = AutoSizer.__proto__ || (0, $22a2a99166405134$var$_getPrototypeOf2.default)(AutoSizer)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                height: _this.props.defaultHeight || 0,
                width: _this.props.defaultWidth || 0
            }, _this._onResize = function() {
                var _this$props = _this.props, disableHeight = _this$props.disableHeight, disableWidth = _this$props.disableWidth, onResize = _this$props.onResize;
                if (_this._parentNode) {
                    var _height = _this._parentNode.offsetHeight || 0;
                    var _width = _this._parentNode.offsetWidth || 0;
                    var win = _this._window || window;
                    var _style = win.getComputedStyle(_this._parentNode) || {};
                    var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
                    var paddingRight = parseInt(_style.paddingRight, 10) || 0;
                    var paddingTop = parseInt(_style.paddingTop, 10) || 0;
                    var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
                    var newHeight = _height - paddingTop - paddingBottom;
                    var newWidth = _width - paddingLeft - paddingRight;
                    if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
                        _this.setState({
                            height: _height - paddingTop - paddingBottom,
                            width: _width - paddingLeft - paddingRight
                        });
                        onResize({
                            height: _height,
                            width: _width
                        });
                    }
                }
            }, _this._setRef = function(autoSizer) {
                _this._autoSizer = autoSizer;
            }, _temp), (0, $22a2a99166405134$var$_possibleConstructorReturn3.default)(_this, _ret);
        }
        (0, $22a2a99166405134$var$_createClass3.default)(AutoSizer, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    var nonce = this.props.nonce;
                    if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
                        this._parentNode = this._autoSizer.parentNode;
                        this._window = this._autoSizer.parentNode.ownerDocument.defaultView;
                        this._detectElementResize = (0, $22a2a99166405134$var$_detectElementResize2.default)(nonce, this._window);
                        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
                        this._onResize();
                    }
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (this._detectElementResize && this._parentNode) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
                }
            },
            {
                key: 'render',
                value: function render() {
                    var _props = this.props, children = _props.children, className = _props.className, disableHeight = _props.disableHeight, disableWidth = _props.disableWidth, style = _props.style;
                    var _state = this.state, height = _state.height, width = _state.width;
                    var outerStyle = {
                        overflow: 'visible'
                    };
                    var childParams = {};
                    if (!disableHeight) {
                        outerStyle.height = 0;
                        childParams.height = height;
                    }
                    if (!disableWidth) {
                        outerStyle.width = 0;
                        childParams.width = width;
                    }
                    return $22a2a99166405134$var$React.createElement('div', {
                        className: className,
                        ref: this._setRef,
                        style: (0, $22a2a99166405134$var$_extends3.default)({}, outerStyle, style)
                    }, children(childParams));
                }
            }
        ]);
        return AutoSizer;
    }($22a2a99166405134$var$React.PureComponent);
    $22a2a99166405134$var$AutoSizer.defaultProps = {
        onResize: function onResize() {},
        disableHeight: false,
        disableWidth: false,
        style: {}
    };
    $22a2a99166405134$var$AutoSizer.propTypes = null;
    module.exports.default = $22a2a99166405134$var$AutoSizer;
});
parcelRegister("knQh8", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$ed6e817027dc4fd8$export$1e511d4a378977f5, (v)=>$ed6e817027dc4fd8$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$ed6e817027dc4fd8$export$2e2bcd8739ae039, (v)=>$ed6e817027dc4fd8$export$2e2bcd8739ae039 = v);
    var $ed6e817027dc4fd8$export$1e511d4a378977f5;
    var $ed6e817027dc4fd8$export$2e2bcd8739ae039;
    "use strict";
    $ed6e817027dc4fd8$export$1e511d4a378977f5 = true;
    var $cjLx9 = parcelRequire("cjLx9");
    var $ed6e817027dc4fd8$var$_assign2 = $ed6e817027dc4fd8$var$_interopRequireDefault($cjLx9);
    function $ed6e817027dc4fd8$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    $ed6e817027dc4fd8$export$2e2bcd8739ae039 = $ed6e817027dc4fd8$var$_assign2.default || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
});
parcelRegister("cjLx9", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("6qqLf")),
        __esModule: true
    };
});
parcelRegister("6qqLf", function(module, exports) {
    parcelRequire("lsZw3");
    module.exports = (parcelRequire("dv4GG")).Object.assign;
});
parcelRegister("lsZw3", function(module, exports) {
    var $8EFNH = parcelRequire("8EFNH");
    $8EFNH($8EFNH.S + $8EFNH.F, 'Object', {
        assign: (parcelRequire("eCvdn"))
    });
});
parcelRegister("8EFNH", function(module, exports) {
    var $pe18r = parcelRequire("pe18r");
    var $dv4GG = parcelRequire("dv4GG");
    var $gnejD = parcelRequire("gnejD");
    var $kM6mh = parcelRequire("kM6mh");
    var $aMccP = parcelRequire("aMccP");
    var $64d27bdec060590e$var$PROTOTYPE = 'prototype';
    var $64d27bdec060590e$var$$export = function(type, name, source) {
        var IS_FORCED = type & $64d27bdec060590e$var$$export.F;
        var IS_GLOBAL = type & $64d27bdec060590e$var$$export.G;
        var IS_STATIC = type & $64d27bdec060590e$var$$export.S;
        var IS_PROTO = type & $64d27bdec060590e$var$$export.P;
        var IS_BIND = type & $64d27bdec060590e$var$$export.B;
        var IS_WRAP = type & $64d27bdec060590e$var$$export.W;
        var exports = IS_GLOBAL ? $dv4GG : $dv4GG[name] || ($dv4GG[name] = {});
        var expProto = exports[$64d27bdec060590e$var$PROTOTYPE];
        var target = IS_GLOBAL ? $pe18r : IS_STATIC ? $pe18r[name] : ($pe18r[name] || {})[$64d27bdec060590e$var$PROTOTYPE];
        var key, own, out;
        if (IS_GLOBAL) source = name;
        for(key in source){
            own = !IS_FORCED && target && target[key] !== undefined;
            if (own && $aMccP(exports, key)) continue;
            out = own ? target[key] : source[key];
            exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $gnejD(out, $pe18r) : IS_WRAP && target[key] == out ? function(C) {
                var F = function(a, b, c) {
                    if (this instanceof C) {
                        switch(arguments.length){
                            case 0:
                                return new C();
                            case 1:
                                return new C(a);
                            case 2:
                                return new C(a, b);
                        }
                        return new C(a, b, c);
                    }
                    return C.apply(this, arguments);
                };
                F[$64d27bdec060590e$var$PROTOTYPE] = C[$64d27bdec060590e$var$PROTOTYPE];
                return F;
            }(out) : IS_PROTO && typeof out == 'function' ? $gnejD(Function.call, out) : out;
            if (IS_PROTO) {
                (exports.virtual || (exports.virtual = {}))[key] = out;
                if (type & $64d27bdec060590e$var$$export.R && expProto && !expProto[key]) $kM6mh(expProto, key, out);
            }
        }
    };
    $64d27bdec060590e$var$$export.F = 1;
    $64d27bdec060590e$var$$export.G = 2;
    $64d27bdec060590e$var$$export.S = 4;
    $64d27bdec060590e$var$$export.P = 8;
    $64d27bdec060590e$var$$export.B = 16;
    $64d27bdec060590e$var$$export.W = 32;
    $64d27bdec060590e$var$$export.U = 64;
    $64d27bdec060590e$var$$export.R = 128;
    module.exports = $64d27bdec060590e$var$$export;
});
parcelRegister("pe18r", function(module, exports) {
    var $04bd3575bb3eed01$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
    if (typeof __g == 'number') __g = $04bd3575bb3eed01$var$global;
});
parcelRegister("dv4GG", function(module, exports) {
    var $9d41ce6d167d80d2$var$core = module.exports = {
        version: '2.6.12'
    };
    if (typeof __e == 'number') __e = $9d41ce6d167d80d2$var$core;
});
parcelRegister("gnejD", function(module, exports) {
    var $jd5tk = parcelRequire("jd5tk");
    module.exports = function(fn, that, length) {
        $jd5tk(fn);
        if (that === undefined) return fn;
        switch(length){
            case 1:
                return function(a) {
                    return fn.call(that, a);
                };
            case 2:
                return function(a, b) {
                    return fn.call(that, a, b);
                };
            case 3:
                return function(a, b, c) {
                    return fn.call(that, a, b, c);
                };
        }
        return function() {
            return fn.apply(that, arguments);
        };
    };
});
parcelRegister("jd5tk", function(module, exports) {
    module.exports = function(it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
    };
});
parcelRegister("kM6mh", function(module, exports) {
    var $30LaA = parcelRequire("30LaA");
    var $evesF = parcelRequire("evesF");
    module.exports = (parcelRequire("hn2oF")) ? function(object, key, value) {
        return $30LaA.f(object, key, $evesF(1, value));
    } : function(object, key, value) {
        object[key] = value;
        return object;
    };
});
parcelRegister("30LaA", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$2315f61bd3482fc3$export$2d1720544b23b823, (v)=>$2315f61bd3482fc3$export$2d1720544b23b823 = v);
    var $2315f61bd3482fc3$export$2d1720544b23b823;
    var $6rs9h = parcelRequire("6rs9h");
    var $dzU8d = parcelRequire("dzU8d");
    var $7Af9t = parcelRequire("7Af9t");
    var $2315f61bd3482fc3$var$dP = Object.defineProperty;
    $2315f61bd3482fc3$export$2d1720544b23b823 = (parcelRequire("hn2oF")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        $6rs9h(O);
        P = $7Af9t(P, true);
        $6rs9h(Attributes);
        if ($dzU8d) try {
            return $2315f61bd3482fc3$var$dP(O, P, Attributes);
        } catch (e) {}
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
    };
});
parcelRegister("6rs9h", function(module, exports) {
    var $6VwBm = parcelRequire("6VwBm");
    module.exports = function(it) {
        if (!$6VwBm(it)) throw TypeError(it + ' is not an object!');
        return it;
    };
});
parcelRegister("6VwBm", function(module, exports) {
    module.exports = function(it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
    };
});
parcelRegister("dzU8d", function(module, exports) {
    module.exports = !(parcelRequire("hn2oF")) && !(parcelRequire("5nD9T"))(function() {
        return Object.defineProperty((parcelRequire("iSIdA"))('div'), 'a', {
            get: function() {
                return 7;
            }
        }).a != 7;
    });
});
parcelRegister("hn2oF", function(module, exports) {
    module.exports = !(parcelRequire("5nD9T"))(function() {
        return Object.defineProperty({}, 'a', {
            get: function() {
                return 7;
            }
        }).a != 7;
    });
});
parcelRegister("5nD9T", function(module, exports) {
    module.exports = function(exec) {
        try {
            return !!exec();
        } catch (e) {
            return true;
        }
    };
});
parcelRegister("iSIdA", function(module, exports) {
    var $6VwBm = parcelRequire("6VwBm");
    var $pe18r = parcelRequire("pe18r");
    var $dbef91f2a743dd1e$require$document = $pe18r.document;
    var $dbef91f2a743dd1e$var$is = $6VwBm($dbef91f2a743dd1e$require$document) && $6VwBm($dbef91f2a743dd1e$require$document.createElement);
    module.exports = function(it) {
        return $dbef91f2a743dd1e$var$is ? $dbef91f2a743dd1e$require$document.createElement(it) : {};
    };
});
parcelRegister("7Af9t", function(module, exports) {
    var $6VwBm = parcelRequire("6VwBm");
    module.exports = function(it, S) {
        if (!$6VwBm(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !$6VwBm(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !$6VwBm(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !$6VwBm(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
    };
});
parcelRegister("evesF", function(module, exports) {
    module.exports = function(bitmap, value) {
        return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
        };
    };
});
parcelRegister("aMccP", function(module, exports) {
    var $7d87daef9d4e91b8$var$hasOwnProperty = {}.hasOwnProperty;
    module.exports = function(it, key) {
        return $7d87daef9d4e91b8$var$hasOwnProperty.call(it, key);
    };
});
parcelRegister("eCvdn", function(module, exports) {
    'use strict';
    var $hn2oF = parcelRequire("hn2oF");
    var $8rKxD = parcelRequire("8rKxD");
    var $1Jjbj = parcelRequire("1Jjbj");
    var $gvEJa = parcelRequire("gvEJa");
    var $8tRkg = parcelRequire("8tRkg");
    var $2A2jr = parcelRequire("2A2jr");
    var $aa4cd3e3ae28fa7e$var$$assign = Object.assign;
    module.exports = !$aa4cd3e3ae28fa7e$var$$assign || (parcelRequire("5nD9T"))(function() {
        var A = {};
        var B = {};
        var S = Symbol();
        var K = 'abcdefghijklmnopqrst';
        A[S] = 7;
        K.split('').forEach(function(k) {
            B[k] = k;
        });
        return $aa4cd3e3ae28fa7e$var$$assign({}, A)[S] != 7 || Object.keys($aa4cd3e3ae28fa7e$var$$assign({}, B)).join('') != K;
    }) ? function assign(target, source) {
        var T = $8tRkg(target);
        var aLen = arguments.length;
        var index = 1;
        var getSymbols = $1Jjbj.f;
        var isEnum = $gvEJa.f;
        while(aLen > index){
            var S = $2A2jr(arguments[index++]);
            var keys = getSymbols ? $8rKxD(S).concat(getSymbols(S)) : $8rKxD(S);
            var length = keys.length;
            var j = 0;
            var key;
            while(length > j){
                key = keys[j++];
                if (!$hn2oF || isEnum.call(S, key)) T[key] = S[key];
            }
        }
        return T;
    } : $aa4cd3e3ae28fa7e$var$$assign;
});
parcelRegister("8rKxD", function(module, exports) {
    var $aW8ua = parcelRequire("aW8ua");
    var $aIGUN = parcelRequire("aIGUN");
    module.exports = Object.keys || function keys(O) {
        return $aW8ua(O, $aIGUN);
    };
});
parcelRegister("aW8ua", function(module, exports) {
    var $aMccP = parcelRequire("aMccP");
    var $59DzK = parcelRequire("59DzK");
    var $7f65e7394a9ddf07$var$arrayIndexOf = (parcelRequire("6FnDv"))(false);
    var $7f65e7394a9ddf07$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
    module.exports = function(object, names) {
        var O = $59DzK(object);
        var i = 0;
        var result = [];
        var key;
        for(key in O)if (key != $7f65e7394a9ddf07$var$IE_PROTO) $aMccP(O, key) && result.push(key);
        while(names.length > i)if ($aMccP(O, key = names[i++])) ~$7f65e7394a9ddf07$var$arrayIndexOf(result, key) || result.push(key);
        return result;
    };
});
parcelRegister("59DzK", function(module, exports) {
    var $2A2jr = parcelRequire("2A2jr");
    var $ie6R6 = parcelRequire("ie6R6");
    module.exports = function(it) {
        return $2A2jr($ie6R6(it));
    };
});
parcelRegister("2A2jr", function(module, exports) {
    var $eYYzh = parcelRequire("eYYzh");
    module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
        return $eYYzh(it) == 'String' ? it.split('') : Object(it);
    };
});
parcelRegister("eYYzh", function(module, exports) {
    var $ae85a6d59702a8f0$var$toString = {}.toString;
    module.exports = function(it) {
        return $ae85a6d59702a8f0$var$toString.call(it).slice(8, -1);
    };
});
parcelRegister("ie6R6", function(module, exports) {
    module.exports = function(it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
    };
});
parcelRegister("6FnDv", function(module, exports) {
    var $59DzK = parcelRequire("59DzK");
    var $lpAeO = parcelRequire("lpAeO");
    var $7XibQ = parcelRequire("7XibQ");
    module.exports = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
            var O = $59DzK($this);
            var length = $lpAeO(O.length);
            var index = $7XibQ(fromIndex, length);
            var value;
            if (IS_INCLUDES && el != el) while(length > index){
                value = O[index++];
                if (value != value) return true;
            }
            else for(; length > index; index++)if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
            }
            return !IS_INCLUDES && -1;
        };
    };
});
parcelRegister("lpAeO", function(module, exports) {
    var $h2TDF = parcelRequire("h2TDF");
    var $f9680adf10caefa3$var$min = Math.min;
    module.exports = function(it) {
        return it > 0 ? $f9680adf10caefa3$var$min($h2TDF(it), 0x1fffffffffffff) : 0;
    };
});
parcelRegister("h2TDF", function(module, exports) {
    var $c68dc842fc575f58$var$ceil = Math.ceil;
    var $c68dc842fc575f58$var$floor = Math.floor;
    module.exports = function(it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? $c68dc842fc575f58$var$floor : $c68dc842fc575f58$var$ceil)(it);
    };
});
parcelRegister("7XibQ", function(module, exports) {
    var $h2TDF = parcelRequire("h2TDF");
    var $5cac2746a26f7adf$var$max = Math.max;
    var $5cac2746a26f7adf$var$min = Math.min;
    module.exports = function(index, length) {
        index = $h2TDF(index);
        return index < 0 ? $5cac2746a26f7adf$var$max(index + length, 0) : $5cac2746a26f7adf$var$min(index, length);
    };
});
parcelRegister("4BPKE", function(module, exports) {
    var $35b2c2e77589c562$var$shared = (parcelRequire("inCOl"))('keys');
    var $42V7x = parcelRequire("42V7x");
    module.exports = function(key) {
        return $35b2c2e77589c562$var$shared[key] || ($35b2c2e77589c562$var$shared[key] = $42V7x(key));
    };
});
parcelRegister("inCOl", function(module, exports) {
    var $dv4GG = parcelRequire("dv4GG");
    var $pe18r = parcelRequire("pe18r");
    var $d6187b0aaf68f232$var$SHARED = '__core-js_shared__';
    var $d6187b0aaf68f232$var$store = $pe18r[$d6187b0aaf68f232$var$SHARED] || ($pe18r[$d6187b0aaf68f232$var$SHARED] = {});
    (module.exports = function(key, value) {
        return $d6187b0aaf68f232$var$store[key] || ($d6187b0aaf68f232$var$store[key] = value !== undefined ? value : {});
    })('versions', []).push({
        version: $dv4GG.version,
        mode: (parcelRequire("6uq1C")) ? 'pure' : 'global',
        copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
    });
});
parcelRegister("6uq1C", function(module, exports) {
    module.exports = true;
});
parcelRegister("42V7x", function(module, exports) {
    var $2f23a8463a1ba411$var$id = 0;
    var $2f23a8463a1ba411$var$px = Math.random();
    module.exports = function(key) {
        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$2f23a8463a1ba411$var$id + $2f23a8463a1ba411$var$px).toString(36));
    };
});
parcelRegister("aIGUN", function(module, exports) {
    module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
});
parcelRegister("1Jjbj", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$1428df70697477af$export$2d1720544b23b823, (v)=>$1428df70697477af$export$2d1720544b23b823 = v);
    var $1428df70697477af$export$2d1720544b23b823;
    $1428df70697477af$export$2d1720544b23b823 = Object.getOwnPropertySymbols;
});
parcelRegister("gvEJa", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$c04f223f8947297b$export$2d1720544b23b823, (v)=>$c04f223f8947297b$export$2d1720544b23b823 = v);
    var $c04f223f8947297b$export$2d1720544b23b823;
    $c04f223f8947297b$export$2d1720544b23b823 = ({}).propertyIsEnumerable;
});
parcelRegister("8tRkg", function(module, exports) {
    var $ie6R6 = parcelRequire("ie6R6");
    module.exports = function(it) {
        return Object($ie6R6(it));
    };
});
parcelRegister("29Ol4", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("22VpG")),
        __esModule: true
    };
});
parcelRegister("22VpG", function(module, exports) {
    parcelRequire("7Invg");
    module.exports = (parcelRequire("dv4GG")).Object.getPrototypeOf;
});
parcelRegister("7Invg", function(module, exports) {
    var $8tRkg = parcelRequire("8tRkg");
    var $97OQk = parcelRequire("97OQk");
    (parcelRequire("8iDav"))('getPrototypeOf', function() {
        return function getPrototypeOf(it) {
            return $97OQk($8tRkg(it));
        };
    });
});
parcelRegister("97OQk", function(module, exports) {
    var $aMccP = parcelRequire("aMccP");
    var $8tRkg = parcelRequire("8tRkg");
    var $6a4c34daf431297a$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
    var $6a4c34daf431297a$var$ObjectProto = Object.prototype;
    module.exports = Object.getPrototypeOf || function(O) {
        O = $8tRkg(O);
        if ($aMccP(O, $6a4c34daf431297a$var$IE_PROTO)) return O[$6a4c34daf431297a$var$IE_PROTO];
        if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
        return O instanceof Object ? $6a4c34daf431297a$var$ObjectProto : null;
    };
});
parcelRegister("8iDav", function(module, exports) {
    var $8EFNH = parcelRequire("8EFNH");
    var $dv4GG = parcelRequire("dv4GG");
    var $5nD9T = parcelRequire("5nD9T");
    module.exports = function(KEY, exec) {
        var fn = ($dv4GG.Object || {})[KEY] || Object[KEY];
        var exp = {};
        exp[KEY] = exec(fn);
        $8EFNH($8EFNH.S + $8EFNH.F * $5nD9T(function() {
            fn(1);
        }), 'Object', exp);
    };
});
parcelRegister("aXTp8", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$7fba6438b4dbf46b$export$1e511d4a378977f5, (v)=>$7fba6438b4dbf46b$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$7fba6438b4dbf46b$export$2e2bcd8739ae039, (v)=>$7fba6438b4dbf46b$export$2e2bcd8739ae039 = v);
    var $7fba6438b4dbf46b$export$1e511d4a378977f5;
    var $7fba6438b4dbf46b$export$2e2bcd8739ae039;
    "use strict";
    $7fba6438b4dbf46b$export$1e511d4a378977f5 = true;
    $7fba6438b4dbf46b$export$2e2bcd8739ae039 = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
});
parcelRegister("4tLNB", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$342ef2b9df8992a7$export$1e511d4a378977f5, (v)=>$342ef2b9df8992a7$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$342ef2b9df8992a7$export$2e2bcd8739ae039, (v)=>$342ef2b9df8992a7$export$2e2bcd8739ae039 = v);
    var $342ef2b9df8992a7$export$1e511d4a378977f5;
    var $342ef2b9df8992a7$export$2e2bcd8739ae039;
    "use strict";
    $342ef2b9df8992a7$export$1e511d4a378977f5 = true;
    var $aWlLP = parcelRequire("aWlLP");
    var $342ef2b9df8992a7$var$_defineProperty2 = $342ef2b9df8992a7$var$_interopRequireDefault($aWlLP);
    function $342ef2b9df8992a7$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    $342ef2b9df8992a7$export$2e2bcd8739ae039 = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                (0, $342ef2b9df8992a7$var$_defineProperty2.default)(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
});
parcelRegister("aWlLP", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("cEZdw")),
        __esModule: true
    };
});
parcelRegister("cEZdw", function(module, exports) {
    parcelRequire("7vx5B");
    var $dv4GG = parcelRequire("dv4GG");
    var $9378b4ec927c6689$require$$Object = $dv4GG.Object;
    module.exports = function defineProperty(it, key, desc) {
        return $9378b4ec927c6689$require$$Object.defineProperty(it, key, desc);
    };
});
parcelRegister("7vx5B", function(module, exports) {
    var $8EFNH = parcelRequire("8EFNH");
    $8EFNH($8EFNH.S + $8EFNH.F * !(parcelRequire("hn2oF")), 'Object', {
        defineProperty: (parcelRequire("30LaA")).f
    });
});
parcelRegister("5pMaQ", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$3f14a7e1704920da$export$1e511d4a378977f5, (v)=>$3f14a7e1704920da$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$3f14a7e1704920da$export$2e2bcd8739ae039, (v)=>$3f14a7e1704920da$export$2e2bcd8739ae039 = v);
    var $3f14a7e1704920da$export$1e511d4a378977f5;
    var $3f14a7e1704920da$export$2e2bcd8739ae039;
    "use strict";
    $3f14a7e1704920da$export$1e511d4a378977f5 = true;
    var $kt6ai = parcelRequire("kt6ai");
    var $3f14a7e1704920da$var$_typeof3 = $3f14a7e1704920da$var$_interopRequireDefault($kt6ai);
    function $3f14a7e1704920da$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    $3f14a7e1704920da$export$2e2bcd8739ae039 = function(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && ((typeof call === "undefined" ? "undefined" : (0, $3f14a7e1704920da$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
    };
});
parcelRegister("kt6ai", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$ee6b4c58df698443$export$1e511d4a378977f5, (v)=>$ee6b4c58df698443$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$ee6b4c58df698443$export$2e2bcd8739ae039, (v)=>$ee6b4c58df698443$export$2e2bcd8739ae039 = v);
    var $ee6b4c58df698443$export$1e511d4a378977f5;
    var $ee6b4c58df698443$export$2e2bcd8739ae039;
    "use strict";
    $ee6b4c58df698443$export$1e511d4a378977f5 = true;
    var $5YQKd = parcelRequire("5YQKd");
    var $ee6b4c58df698443$var$_iterator2 = $ee6b4c58df698443$var$_interopRequireDefault($5YQKd);
    var $V3332 = parcelRequire("V3332");
    var $ee6b4c58df698443$var$_symbol2 = $ee6b4c58df698443$var$_interopRequireDefault($V3332);
    var $ee6b4c58df698443$var$_typeof = typeof $ee6b4c58df698443$var$_symbol2.default === "function" && typeof $ee6b4c58df698443$var$_iterator2.default === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof $ee6b4c58df698443$var$_symbol2.default === "function" && obj.constructor === $ee6b4c58df698443$var$_symbol2.default && obj !== $ee6b4c58df698443$var$_symbol2.default.prototype ? "symbol" : typeof obj;
    };
    function $ee6b4c58df698443$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    $ee6b4c58df698443$export$2e2bcd8739ae039 = typeof $ee6b4c58df698443$var$_symbol2.default === "function" && $ee6b4c58df698443$var$_typeof($ee6b4c58df698443$var$_iterator2.default) === "symbol" ? function(obj) {
        return typeof obj === "undefined" ? "undefined" : $ee6b4c58df698443$var$_typeof(obj);
    } : function(obj) {
        return obj && typeof $ee6b4c58df698443$var$_symbol2.default === "function" && obj.constructor === $ee6b4c58df698443$var$_symbol2.default && obj !== $ee6b4c58df698443$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $ee6b4c58df698443$var$_typeof(obj);
    };
});
parcelRegister("5YQKd", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("hpbwm")),
        __esModule: true
    };
});
parcelRegister("hpbwm", function(module, exports) {
    parcelRequire("ltQ0T");
    parcelRequire("fQXw1");
    module.exports = (parcelRequire("3iakE")).f('iterator');
});
parcelRegister("ltQ0T", function(module, exports) {
    'use strict';
    var $fa34a72ca0e00838$var$$at = (parcelRequire("TnwZj"))(true);
    (parcelRequire("bH4Ac"))(String, 'String', function(iterated) {
        this._t = String(iterated);
        this._i = 0;
    }, function() {
        var O = this._t;
        var index = this._i;
        var point;
        if (index >= O.length) return {
            value: undefined,
            done: true
        };
        point = $fa34a72ca0e00838$var$$at(O, index);
        this._i += point.length;
        return {
            value: point,
            done: false
        };
    });
});
parcelRegister("TnwZj", function(module, exports) {
    var $h2TDF = parcelRequire("h2TDF");
    var $ie6R6 = parcelRequire("ie6R6");
    module.exports = function(TO_STRING) {
        return function(that, pos) {
            var s = String($ie6R6(that));
            var i = $h2TDF(pos);
            var l = s.length;
            var a, b;
            if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
            a = s.charCodeAt(i);
            return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
        };
    };
});
parcelRegister("bH4Ac", function(module, exports) {
    'use strict';
    var $6uq1C = parcelRequire("6uq1C");
    var $8EFNH = parcelRequire("8EFNH");
    var $3VDKT = parcelRequire("3VDKT");
    var $kM6mh = parcelRequire("kM6mh");
    var $eu895 = parcelRequire("eu895");
    var $jEAut = parcelRequire("jEAut");
    var $8nOHH = parcelRequire("8nOHH");
    var $97OQk = parcelRequire("97OQk");
    var $883743f265dc0269$var$ITERATOR = (parcelRequire("cNfss"))('iterator');
    var $883743f265dc0269$var$BUGGY = !([].keys && 'next' in [].keys());
    var $883743f265dc0269$var$FF_ITERATOR = '@@iterator';
    var $883743f265dc0269$var$KEYS = 'keys';
    var $883743f265dc0269$var$VALUES = 'values';
    var $883743f265dc0269$var$returnThis = function() {
        return this;
    };
    module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $jEAut(Constructor, NAME, next);
        var getMethod = function(kind) {
            if (!$883743f265dc0269$var$BUGGY && kind in proto) return proto[kind];
            switch(kind){
                case $883743f265dc0269$var$KEYS:
                    return function keys() {
                        return new Constructor(this, kind);
                    };
                case $883743f265dc0269$var$VALUES:
                    return function values() {
                        return new Constructor(this, kind);
                    };
            }
            return function entries() {
                return new Constructor(this, kind);
            };
        };
        var TAG = NAME + ' Iterator';
        var DEF_VALUES = DEFAULT == $883743f265dc0269$var$VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[$883743f265dc0269$var$ITERATOR] || proto[$883743f265dc0269$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
        var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype;
        if ($anyNative) {
            IteratorPrototype = $97OQk($anyNative.call(new Base()));
            if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
                $8nOHH(IteratorPrototype, TAG, true);
                if (!$6uq1C && typeof IteratorPrototype[$883743f265dc0269$var$ITERATOR] != 'function') $kM6mh(IteratorPrototype, $883743f265dc0269$var$ITERATOR, $883743f265dc0269$var$returnThis);
            }
        }
        if (DEF_VALUES && $native && $native.name !== $883743f265dc0269$var$VALUES) {
            VALUES_BUG = true;
            $default = function values() {
                return $native.call(this);
            };
        }
        if ((!$6uq1C || FORCED) && ($883743f265dc0269$var$BUGGY || VALUES_BUG || !proto[$883743f265dc0269$var$ITERATOR])) $kM6mh(proto, $883743f265dc0269$var$ITERATOR, $default);
        $eu895[NAME] = $default;
        $eu895[TAG] = $883743f265dc0269$var$returnThis;
        if (DEFAULT) {
            methods = {
                values: DEF_VALUES ? $default : getMethod($883743f265dc0269$var$VALUES),
                keys: IS_SET ? $default : getMethod($883743f265dc0269$var$KEYS),
                entries: $entries
            };
            if (FORCED) {
                for(key in methods)if (!(key in proto)) $3VDKT(proto, key, methods[key]);
            } else $8EFNH($8EFNH.P + $8EFNH.F * ($883743f265dc0269$var$BUGGY || VALUES_BUG), NAME, methods);
        }
        return methods;
    };
});
parcelRegister("3VDKT", function(module, exports) {
    module.exports = (parcelRequire("kM6mh"));
});
parcelRegister("eu895", function(module, exports) {
    module.exports = {};
});
parcelRegister("jEAut", function(module, exports) {
    'use strict';
    var $l5MPs = parcelRequire("l5MPs");
    var $evesF = parcelRequire("evesF");
    var $8nOHH = parcelRequire("8nOHH");
    var $e4ee0efba5a7f6a9$var$IteratorPrototype = {};
    (parcelRequire("kM6mh"))($e4ee0efba5a7f6a9$var$IteratorPrototype, (parcelRequire("cNfss"))('iterator'), function() {
        return this;
    });
    module.exports = function(Constructor, NAME, next) {
        Constructor.prototype = $l5MPs($e4ee0efba5a7f6a9$var$IteratorPrototype, {
            next: $evesF(1, next)
        });
        $8nOHH(Constructor, NAME + ' Iterator');
    };
});
parcelRegister("l5MPs", function(module, exports) {
    var $6rs9h = parcelRequire("6rs9h");
    var $hrzgw = parcelRequire("hrzgw");
    var $aIGUN = parcelRequire("aIGUN");
    var $f5aff1030646fd55$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
    var $f5aff1030646fd55$var$Empty = function() {};
    var $f5aff1030646fd55$var$PROTOTYPE = 'prototype';
    var $f5aff1030646fd55$var$createDict = function() {
        var iframe = (parcelRequire("iSIdA"))('iframe');
        var i = $aIGUN.length;
        var lt = '<';
        var gt = '>';
        var iframeDocument;
        iframe.style.display = 'none';
        (parcelRequire("fW23X")).appendChild(iframe);
        iframe.src = 'javascript:';
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
        iframeDocument.close();
        $f5aff1030646fd55$var$createDict = iframeDocument.F;
        while(i--)delete $f5aff1030646fd55$var$createDict[$f5aff1030646fd55$var$PROTOTYPE][$aIGUN[i]];
        return $f5aff1030646fd55$var$createDict();
    };
    module.exports = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
            $f5aff1030646fd55$var$Empty[$f5aff1030646fd55$var$PROTOTYPE] = $6rs9h(O);
            result = new $f5aff1030646fd55$var$Empty();
            $f5aff1030646fd55$var$Empty[$f5aff1030646fd55$var$PROTOTYPE] = null;
            result[$f5aff1030646fd55$var$IE_PROTO] = O;
        } else result = $f5aff1030646fd55$var$createDict();
        return Properties === undefined ? result : $hrzgw(result, Properties);
    };
});
parcelRegister("hrzgw", function(module, exports) {
    var $30LaA = parcelRequire("30LaA");
    var $6rs9h = parcelRequire("6rs9h");
    var $8rKxD = parcelRequire("8rKxD");
    module.exports = (parcelRequire("hn2oF")) ? Object.defineProperties : function defineProperties(O, Properties) {
        $6rs9h(O);
        var keys = $8rKxD(Properties);
        var length = keys.length;
        var i = 0;
        var P;
        while(length > i)$30LaA.f(O, P = keys[i++], Properties[P]);
        return O;
    };
});
parcelRegister("fW23X", function(module, exports) {
    var $pe18r = parcelRequire("pe18r");
    var $b99ddf714ab9b2ae$require$document = $pe18r.document;
    module.exports = $b99ddf714ab9b2ae$require$document && $b99ddf714ab9b2ae$require$document.documentElement;
});
parcelRegister("8nOHH", function(module, exports) {
    var $30LaA = parcelRequire("30LaA");
    var $61a7cd74d8b334f9$require$def = $30LaA.f;
    var $aMccP = parcelRequire("aMccP");
    var $61a7cd74d8b334f9$var$TAG = (parcelRequire("cNfss"))('toStringTag');
    module.exports = function(it, tag, stat) {
        if (it && !$aMccP(it = stat ? it : it.prototype, $61a7cd74d8b334f9$var$TAG)) $61a7cd74d8b334f9$require$def(it, $61a7cd74d8b334f9$var$TAG, {
            configurable: true,
            value: tag
        });
    };
});
parcelRegister("cNfss", function(module, exports) {
    var $95060d4712c30789$var$store = (parcelRequire("inCOl"))('wks');
    var $42V7x = parcelRequire("42V7x");
    var $pe18r = parcelRequire("pe18r");
    var $95060d4712c30789$require$Symbol = $pe18r.Symbol;
    var $95060d4712c30789$var$USE_SYMBOL = typeof $95060d4712c30789$require$Symbol == 'function';
    var $95060d4712c30789$var$$exports = module.exports = function(name) {
        return $95060d4712c30789$var$store[name] || ($95060d4712c30789$var$store[name] = $95060d4712c30789$var$USE_SYMBOL && $95060d4712c30789$require$Symbol[name] || ($95060d4712c30789$var$USE_SYMBOL ? $95060d4712c30789$require$Symbol : $42V7x)('Symbol.' + name));
    };
    $95060d4712c30789$var$$exports.store = $95060d4712c30789$var$store;
});
parcelRegister("fQXw1", function(module, exports) {
    parcelRequire("bSOrM");
    var $pe18r = parcelRequire("pe18r");
    var $kM6mh = parcelRequire("kM6mh");
    var $eu895 = parcelRequire("eu895");
    var $b8a9e0dc29c7f4f5$var$TO_STRING_TAG = (parcelRequire("cNfss"))('toStringTag');
    var $b8a9e0dc29c7f4f5$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
    for(var $b8a9e0dc29c7f4f5$var$i = 0; $b8a9e0dc29c7f4f5$var$i < $b8a9e0dc29c7f4f5$var$DOMIterables.length; $b8a9e0dc29c7f4f5$var$i++){
        var $b8a9e0dc29c7f4f5$var$NAME = $b8a9e0dc29c7f4f5$var$DOMIterables[$b8a9e0dc29c7f4f5$var$i];
        var $b8a9e0dc29c7f4f5$var$Collection = $pe18r[$b8a9e0dc29c7f4f5$var$NAME];
        var $b8a9e0dc29c7f4f5$var$proto = $b8a9e0dc29c7f4f5$var$Collection && $b8a9e0dc29c7f4f5$var$Collection.prototype;
        if ($b8a9e0dc29c7f4f5$var$proto && !$b8a9e0dc29c7f4f5$var$proto[$b8a9e0dc29c7f4f5$var$TO_STRING_TAG]) $kM6mh($b8a9e0dc29c7f4f5$var$proto, $b8a9e0dc29c7f4f5$var$TO_STRING_TAG, $b8a9e0dc29c7f4f5$var$NAME);
        $eu895[$b8a9e0dc29c7f4f5$var$NAME] = $eu895.Array;
    }
});
parcelRegister("bSOrM", function(module, exports) {
    'use strict';
    var $hvcNK = parcelRequire("hvcNK");
    var $2WIr8 = parcelRequire("2WIr8");
    var $eu895 = parcelRequire("eu895");
    var $59DzK = parcelRequire("59DzK");
    module.exports = (parcelRequire("bH4Ac"))(Array, 'Array', function(iterated, kind) {
        this._t = $59DzK(iterated);
        this._i = 0;
        this._k = kind;
    }, function() {
        var O = this._t;
        var kind = this._k;
        var index = this._i++;
        if (!O || index >= O.length) {
            this._t = undefined;
            return $2WIr8(1);
        }
        if (kind == 'keys') return $2WIr8(0, index);
        if (kind == 'values') return $2WIr8(0, O[index]);
        return $2WIr8(0, [
            index,
            O[index]
        ]);
    }, 'values');
    $eu895.Arguments = $eu895.Array;
    $hvcNK('keys');
    $hvcNK('values');
    $hvcNK('entries');
});
parcelRegister("hvcNK", function(module, exports) {
    module.exports = function() {};
});
parcelRegister("2WIr8", function(module, exports) {
    module.exports = function(done, value) {
        return {
            value: value,
            done: !!done
        };
    };
});
parcelRegister("3iakE", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$265b1149da5b805d$export$2d1720544b23b823, (v)=>$265b1149da5b805d$export$2d1720544b23b823 = v);
    var $265b1149da5b805d$export$2d1720544b23b823;
    $265b1149da5b805d$export$2d1720544b23b823 = (parcelRequire("cNfss"));
});
parcelRegister("V3332", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("5MRee")),
        __esModule: true
    };
});
parcelRegister("5MRee", function(module, exports) {
    parcelRequire("dV330");
    parcelRequire("55SkS");
    parcelRequire("8IAUf");
    parcelRequire("fvEHr");
    module.exports = (parcelRequire("dv4GG")).Symbol;
});
parcelRegister("dV330", function(module, exports) {
    'use strict';
    var $pe18r = parcelRequire("pe18r");
    var $aMccP = parcelRequire("aMccP");
    var $hn2oF = parcelRequire("hn2oF");
    var $8EFNH = parcelRequire("8EFNH");
    var $3VDKT = parcelRequire("3VDKT");
    var $hXWWY = parcelRequire("hXWWY");
    var $a222f66347247ddd$require$META = $hXWWY.KEY;
    var $5nD9T = parcelRequire("5nD9T");
    var $inCOl = parcelRequire("inCOl");
    var $8nOHH = parcelRequire("8nOHH");
    var $42V7x = parcelRequire("42V7x");
    var $cNfss = parcelRequire("cNfss");
    var $3iakE = parcelRequire("3iakE");
    var $eKGZg = parcelRequire("eKGZg");
    var $8yCLj = parcelRequire("8yCLj");
    var $imb3o = parcelRequire("imb3o");
    var $6rs9h = parcelRequire("6rs9h");
    var $6VwBm = parcelRequire("6VwBm");
    var $8tRkg = parcelRequire("8tRkg");
    var $59DzK = parcelRequire("59DzK");
    var $7Af9t = parcelRequire("7Af9t");
    var $evesF = parcelRequire("evesF");
    var $l5MPs = parcelRequire("l5MPs");
    var $2JUNR = parcelRequire("2JUNR");
    var $56mOV = parcelRequire("56mOV");
    var $1Jjbj = parcelRequire("1Jjbj");
    var $30LaA = parcelRequire("30LaA");
    var $8rKxD = parcelRequire("8rKxD");
    var $a222f66347247ddd$var$gOPD = $56mOV.f;
    var $a222f66347247ddd$var$dP = $30LaA.f;
    var $a222f66347247ddd$var$gOPN = $2JUNR.f;
    var $a222f66347247ddd$var$$Symbol = $pe18r.Symbol;
    var $a222f66347247ddd$var$$JSON = $pe18r.JSON;
    var $a222f66347247ddd$var$_stringify = $a222f66347247ddd$var$$JSON && $a222f66347247ddd$var$$JSON.stringify;
    var $a222f66347247ddd$var$PROTOTYPE = 'prototype';
    var $a222f66347247ddd$var$HIDDEN = $cNfss('_hidden');
    var $a222f66347247ddd$var$TO_PRIMITIVE = $cNfss('toPrimitive');
    var $a222f66347247ddd$var$isEnum = {}.propertyIsEnumerable;
    var $a222f66347247ddd$var$SymbolRegistry = $inCOl('symbol-registry');
    var $a222f66347247ddd$var$AllSymbols = $inCOl('symbols');
    var $a222f66347247ddd$var$OPSymbols = $inCOl('op-symbols');
    var $a222f66347247ddd$var$ObjectProto = Object[$a222f66347247ddd$var$PROTOTYPE];
    var $a222f66347247ddd$var$USE_NATIVE = typeof $a222f66347247ddd$var$$Symbol == 'function' && !!$1Jjbj.f;
    var $a222f66347247ddd$var$QObject = $pe18r.QObject;
    var $a222f66347247ddd$var$setter = !$a222f66347247ddd$var$QObject || !$a222f66347247ddd$var$QObject[$a222f66347247ddd$var$PROTOTYPE] || !$a222f66347247ddd$var$QObject[$a222f66347247ddd$var$PROTOTYPE].findChild;
    var $a222f66347247ddd$var$setSymbolDesc = $hn2oF && $5nD9T(function() {
        return $l5MPs($a222f66347247ddd$var$dP({}, 'a', {
            get: function() {
                return $a222f66347247ddd$var$dP(this, 'a', {
                    value: 7
                }).a;
            }
        })).a != 7;
    }) ? function(it, key, D) {
        var protoDesc = $a222f66347247ddd$var$gOPD($a222f66347247ddd$var$ObjectProto, key);
        if (protoDesc) delete $a222f66347247ddd$var$ObjectProto[key];
        $a222f66347247ddd$var$dP(it, key, D);
        if (protoDesc && it !== $a222f66347247ddd$var$ObjectProto) $a222f66347247ddd$var$dP($a222f66347247ddd$var$ObjectProto, key, protoDesc);
    } : $a222f66347247ddd$var$dP;
    var $a222f66347247ddd$var$wrap = function(tag) {
        var sym = $a222f66347247ddd$var$AllSymbols[tag] = $l5MPs($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE]);
        sym._k = tag;
        return sym;
    };
    var $a222f66347247ddd$var$isSymbol = $a222f66347247ddd$var$USE_NATIVE && typeof $a222f66347247ddd$var$$Symbol.iterator == 'symbol' ? function(it) {
        return typeof it == 'symbol';
    } : function(it) {
        return it instanceof $a222f66347247ddd$var$$Symbol;
    };
    var $a222f66347247ddd$var$$defineProperty = function defineProperty(it, key, D) {
        if (it === $a222f66347247ddd$var$ObjectProto) $a222f66347247ddd$var$$defineProperty($a222f66347247ddd$var$OPSymbols, key, D);
        $6rs9h(it);
        key = $7Af9t(key, true);
        $6rs9h(D);
        if ($aMccP($a222f66347247ddd$var$AllSymbols, key)) {
            if (!D.enumerable) {
                if (!$aMccP(it, $a222f66347247ddd$var$HIDDEN)) $a222f66347247ddd$var$dP(it, $a222f66347247ddd$var$HIDDEN, $evesF(1, {}));
                it[$a222f66347247ddd$var$HIDDEN][key] = true;
            } else {
                if ($aMccP(it, $a222f66347247ddd$var$HIDDEN) && it[$a222f66347247ddd$var$HIDDEN][key]) it[$a222f66347247ddd$var$HIDDEN][key] = false;
                D = $l5MPs(D, {
                    enumerable: $evesF(0, false)
                });
            }
            return $a222f66347247ddd$var$setSymbolDesc(it, key, D);
        }
        return $a222f66347247ddd$var$dP(it, key, D);
    };
    var $a222f66347247ddd$var$$defineProperties = function defineProperties(it, P) {
        $6rs9h(it);
        var keys = $8yCLj(P = $59DzK(P));
        var i = 0;
        var l = keys.length;
        var key;
        while(l > i)$a222f66347247ddd$var$$defineProperty(it, key = keys[i++], P[key]);
        return it;
    };
    var $a222f66347247ddd$var$$create = function create(it, P) {
        return P === undefined ? $l5MPs(it) : $a222f66347247ddd$var$$defineProperties($l5MPs(it), P);
    };
    var $a222f66347247ddd$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
        var E = $a222f66347247ddd$var$isEnum.call(this, key = $7Af9t(key, true));
        if (this === $a222f66347247ddd$var$ObjectProto && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !$aMccP($a222f66347247ddd$var$OPSymbols, key)) return false;
        return E || !$aMccP(this, key) || !$aMccP($a222f66347247ddd$var$AllSymbols, key) || $aMccP(this, $a222f66347247ddd$var$HIDDEN) && this[$a222f66347247ddd$var$HIDDEN][key] ? E : true;
    };
    var $a222f66347247ddd$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
        it = $59DzK(it);
        key = $7Af9t(key, true);
        if (it === $a222f66347247ddd$var$ObjectProto && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !$aMccP($a222f66347247ddd$var$OPSymbols, key)) return;
        var D = $a222f66347247ddd$var$gOPD(it, key);
        if (D && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !($aMccP(it, $a222f66347247ddd$var$HIDDEN) && it[$a222f66347247ddd$var$HIDDEN][key])) D.enumerable = true;
        return D;
    };
    var $a222f66347247ddd$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
        var names = $a222f66347247ddd$var$gOPN($59DzK(it));
        var result = [];
        var i = 0;
        var key;
        while(names.length > i)if (!$aMccP($a222f66347247ddd$var$AllSymbols, key = names[i++]) && key != $a222f66347247ddd$var$HIDDEN && key != $a222f66347247ddd$require$META) result.push(key);
        return result;
    };
    var $a222f66347247ddd$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
        var IS_OP = it === $a222f66347247ddd$var$ObjectProto;
        var names = $a222f66347247ddd$var$gOPN(IS_OP ? $a222f66347247ddd$var$OPSymbols : $59DzK(it));
        var result = [];
        var i = 0;
        var key;
        while(names.length > i)if ($aMccP($a222f66347247ddd$var$AllSymbols, key = names[i++]) && (IS_OP ? $aMccP($a222f66347247ddd$var$ObjectProto, key) : true)) result.push($a222f66347247ddd$var$AllSymbols[key]);
        return result;
    };
    if (!$a222f66347247ddd$var$USE_NATIVE) {
        $a222f66347247ddd$var$$Symbol = function Symbol() {
            if (this instanceof $a222f66347247ddd$var$$Symbol) throw TypeError('Symbol is not a constructor!');
            var tag = $42V7x(arguments.length > 0 ? arguments[0] : undefined);
            var $set = function(value) {
                if (this === $a222f66347247ddd$var$ObjectProto) $set.call($a222f66347247ddd$var$OPSymbols, value);
                if ($aMccP(this, $a222f66347247ddd$var$HIDDEN) && $aMccP(this[$a222f66347247ddd$var$HIDDEN], tag)) this[$a222f66347247ddd$var$HIDDEN][tag] = false;
                $a222f66347247ddd$var$setSymbolDesc(this, tag, $evesF(1, value));
            };
            if ($hn2oF && $a222f66347247ddd$var$setter) $a222f66347247ddd$var$setSymbolDesc($a222f66347247ddd$var$ObjectProto, tag, {
                configurable: true,
                set: $set
            });
            return $a222f66347247ddd$var$wrap(tag);
        };
        $3VDKT($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE], 'toString', function toString() {
            return this._k;
        });
        $56mOV.f = $a222f66347247ddd$var$$getOwnPropertyDescriptor;
        $30LaA.f = $a222f66347247ddd$var$$defineProperty;
        (parcelRequire("7X6HN")).f = $2JUNR.f = $a222f66347247ddd$var$$getOwnPropertyNames;
        (parcelRequire("gvEJa")).f = $a222f66347247ddd$var$$propertyIsEnumerable;
        $1Jjbj.f = $a222f66347247ddd$var$$getOwnPropertySymbols;
        if ($hn2oF && !(parcelRequire("6uq1C"))) $3VDKT($a222f66347247ddd$var$ObjectProto, 'propertyIsEnumerable', $a222f66347247ddd$var$$propertyIsEnumerable, true);
        $3iakE.f = function(name) {
            return $a222f66347247ddd$var$wrap($cNfss(name));
        };
    }
    $8EFNH($8EFNH.G + $8EFNH.W + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, {
        Symbol: $a222f66347247ddd$var$$Symbol
    });
    for(var $a222f66347247ddd$var$es6Symbols = 'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $a222f66347247ddd$var$j = 0; $a222f66347247ddd$var$es6Symbols.length > $a222f66347247ddd$var$j;)$cNfss($a222f66347247ddd$var$es6Symbols[$a222f66347247ddd$var$j++]);
    for(var $a222f66347247ddd$var$wellKnownSymbols = $8rKxD($cNfss.store), $a222f66347247ddd$var$k = 0; $a222f66347247ddd$var$wellKnownSymbols.length > $a222f66347247ddd$var$k;)$eKGZg($a222f66347247ddd$var$wellKnownSymbols[$a222f66347247ddd$var$k++]);
    $8EFNH($8EFNH.S + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, 'Symbol', {
        'for': function(key) {
            return $aMccP($a222f66347247ddd$var$SymbolRegistry, key += '') ? $a222f66347247ddd$var$SymbolRegistry[key] : $a222f66347247ddd$var$SymbolRegistry[key] = $a222f66347247ddd$var$$Symbol(key);
        },
        keyFor: function keyFor(sym) {
            if (!$a222f66347247ddd$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
            for(var key in $a222f66347247ddd$var$SymbolRegistry)if ($a222f66347247ddd$var$SymbolRegistry[key] === sym) return key;
        },
        useSetter: function() {
            $a222f66347247ddd$var$setter = true;
        },
        useSimple: function() {
            $a222f66347247ddd$var$setter = false;
        }
    });
    $8EFNH($8EFNH.S + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, 'Object', {
        create: $a222f66347247ddd$var$$create,
        defineProperty: $a222f66347247ddd$var$$defineProperty,
        defineProperties: $a222f66347247ddd$var$$defineProperties,
        getOwnPropertyDescriptor: $a222f66347247ddd$var$$getOwnPropertyDescriptor,
        getOwnPropertyNames: $a222f66347247ddd$var$$getOwnPropertyNames,
        getOwnPropertySymbols: $a222f66347247ddd$var$$getOwnPropertySymbols
    });
    var $a222f66347247ddd$var$FAILS_ON_PRIMITIVES = $5nD9T(function() {
        $1Jjbj.f(1);
    });
    $8EFNH($8EFNH.S + $8EFNH.F * $a222f66347247ddd$var$FAILS_ON_PRIMITIVES, 'Object', {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
            return $1Jjbj.f($8tRkg(it));
        }
    });
    $a222f66347247ddd$var$$JSON && $8EFNH($8EFNH.S + $8EFNH.F * (!$a222f66347247ddd$var$USE_NATIVE || $5nD9T(function() {
        var S = $a222f66347247ddd$var$$Symbol();
        return $a222f66347247ddd$var$_stringify([
            S
        ]) != '[null]' || $a222f66347247ddd$var$_stringify({
            a: S
        }) != '{}' || $a222f66347247ddd$var$_stringify(Object(S)) != '{}';
    })), 'JSON', {
        stringify: function stringify(it) {
            var args = [
                it
            ];
            var i = 1;
            var replacer, $replacer;
            while(arguments.length > i)args.push(arguments[i++]);
            $replacer = replacer = args[1];
            if (!$6VwBm(replacer) && it === undefined || $a222f66347247ddd$var$isSymbol(it)) return;
            if (!$imb3o(replacer)) replacer = function(key, value) {
                if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
                if (!$a222f66347247ddd$var$isSymbol(value)) return value;
            };
            args[1] = replacer;
            return $a222f66347247ddd$var$_stringify.apply($a222f66347247ddd$var$$JSON, args);
        }
    });
    $a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE][$a222f66347247ddd$var$TO_PRIMITIVE] || (parcelRequire("kM6mh"))($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE], $a222f66347247ddd$var$TO_PRIMITIVE, $a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE].valueOf);
    $8nOHH($a222f66347247ddd$var$$Symbol, 'Symbol');
    $8nOHH(Math, 'Math', true);
    $8nOHH($pe18r.JSON, 'JSON', true);
});
parcelRegister("hXWWY", function(module, exports) {
    var $d145aca8ddc395e4$var$META = (parcelRequire("42V7x"))('meta');
    var $6VwBm = parcelRequire("6VwBm");
    var $aMccP = parcelRequire("aMccP");
    var $30LaA = parcelRequire("30LaA");
    var $d145aca8ddc395e4$require$setDesc = $30LaA.f;
    var $d145aca8ddc395e4$var$id = 0;
    var $d145aca8ddc395e4$var$isExtensible = Object.isExtensible || function() {
        return true;
    };
    var $d145aca8ddc395e4$var$FREEZE = !(parcelRequire("5nD9T"))(function() {
        return $d145aca8ddc395e4$var$isExtensible(Object.preventExtensions({}));
    });
    var $d145aca8ddc395e4$var$setMeta = function(it) {
        $d145aca8ddc395e4$require$setDesc(it, $d145aca8ddc395e4$var$META, {
            value: {
                i: 'O' + ++$d145aca8ddc395e4$var$id,
                w: {}
            }
        });
    };
    var $d145aca8ddc395e4$var$fastKey = function(it, create) {
        if (!$6VwBm(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
        if (!$aMccP(it, $d145aca8ddc395e4$var$META)) {
            if (!$d145aca8ddc395e4$var$isExtensible(it)) return 'F';
            if (!create) return 'E';
            $d145aca8ddc395e4$var$setMeta(it);
        }
        return it[$d145aca8ddc395e4$var$META].i;
    };
    var $d145aca8ddc395e4$var$getWeak = function(it, create) {
        if (!$aMccP(it, $d145aca8ddc395e4$var$META)) {
            if (!$d145aca8ddc395e4$var$isExtensible(it)) return true;
            if (!create) return false;
            $d145aca8ddc395e4$var$setMeta(it);
        }
        return it[$d145aca8ddc395e4$var$META].w;
    };
    var $d145aca8ddc395e4$var$onFreeze = function(it) {
        if ($d145aca8ddc395e4$var$FREEZE && $d145aca8ddc395e4$var$meta.NEED && $d145aca8ddc395e4$var$isExtensible(it) && !$aMccP(it, $d145aca8ddc395e4$var$META)) $d145aca8ddc395e4$var$setMeta(it);
        return it;
    };
    var $d145aca8ddc395e4$var$meta = module.exports = {
        KEY: $d145aca8ddc395e4$var$META,
        NEED: false,
        fastKey: $d145aca8ddc395e4$var$fastKey,
        getWeak: $d145aca8ddc395e4$var$getWeak,
        onFreeze: $d145aca8ddc395e4$var$onFreeze
    };
});
parcelRegister("eKGZg", function(module, exports) {
    var $pe18r = parcelRequire("pe18r");
    var $dv4GG = parcelRequire("dv4GG");
    var $6uq1C = parcelRequire("6uq1C");
    var $3iakE = parcelRequire("3iakE");
    var $30LaA = parcelRequire("30LaA");
    var $abd6b4ec55be4dfa$require$defineProperty = $30LaA.f;
    module.exports = function(name) {
        var $Symbol = $dv4GG.Symbol || ($dv4GG.Symbol = $6uq1C ? {} : $pe18r.Symbol || {});
        if (name.charAt(0) != '_' && !(name in $Symbol)) $abd6b4ec55be4dfa$require$defineProperty($Symbol, name, {
            value: $3iakE.f(name)
        });
    };
});
parcelRegister("8yCLj", function(module, exports) {
    var $8rKxD = parcelRequire("8rKxD");
    var $1Jjbj = parcelRequire("1Jjbj");
    var $gvEJa = parcelRequire("gvEJa");
    module.exports = function(it) {
        var result = $8rKxD(it);
        var getSymbols = $1Jjbj.f;
        if (getSymbols) {
            var symbols = getSymbols(it);
            var isEnum = $gvEJa.f;
            var i = 0;
            var key;
            while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
        }
        return result;
    };
});
parcelRegister("imb3o", function(module, exports) {
    var $eYYzh = parcelRequire("eYYzh");
    module.exports = Array.isArray || function isArray(arg) {
        return $eYYzh(arg) == 'Array';
    };
});
parcelRegister("2JUNR", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$1febd8a8d519c7f4$export$2d1720544b23b823, (v)=>$1febd8a8d519c7f4$export$2d1720544b23b823 = v);
    var $1febd8a8d519c7f4$export$2d1720544b23b823;
    var $59DzK = parcelRequire("59DzK");
    var $7X6HN = parcelRequire("7X6HN");
    var $1febd8a8d519c7f4$require$gOPN = $7X6HN.f;
    var $1febd8a8d519c7f4$var$toString = {}.toString;
    var $1febd8a8d519c7f4$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    var $1febd8a8d519c7f4$var$getWindowNames = function(it) {
        try {
            return $1febd8a8d519c7f4$require$gOPN(it);
        } catch (e) {
            return $1febd8a8d519c7f4$var$windowNames.slice();
        }
    };
    $1febd8a8d519c7f4$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
        return $1febd8a8d519c7f4$var$windowNames && $1febd8a8d519c7f4$var$toString.call(it) == '[object Window]' ? $1febd8a8d519c7f4$var$getWindowNames(it) : $1febd8a8d519c7f4$require$gOPN($59DzK(it));
    };
});
parcelRegister("7X6HN", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$5ca33ea82ab61dc4$export$2d1720544b23b823, (v)=>$5ca33ea82ab61dc4$export$2d1720544b23b823 = v);
    var $5ca33ea82ab61dc4$export$2d1720544b23b823;
    var $aW8ua = parcelRequire("aW8ua");
    var $5ca33ea82ab61dc4$var$hiddenKeys = (parcelRequire("aIGUN")).concat('length', 'prototype');
    $5ca33ea82ab61dc4$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return $aW8ua(O, $5ca33ea82ab61dc4$var$hiddenKeys);
    };
});
parcelRegister("56mOV", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$3b6f36f483e8e31a$export$2d1720544b23b823, (v)=>$3b6f36f483e8e31a$export$2d1720544b23b823 = v);
    var $3b6f36f483e8e31a$export$2d1720544b23b823;
    var $gvEJa = parcelRequire("gvEJa");
    var $evesF = parcelRequire("evesF");
    var $59DzK = parcelRequire("59DzK");
    var $7Af9t = parcelRequire("7Af9t");
    var $aMccP = parcelRequire("aMccP");
    var $dzU8d = parcelRequire("dzU8d");
    var $3b6f36f483e8e31a$var$gOPD = Object.getOwnPropertyDescriptor;
    $3b6f36f483e8e31a$export$2d1720544b23b823 = (parcelRequire("hn2oF")) ? $3b6f36f483e8e31a$var$gOPD : function getOwnPropertyDescriptor(O, P) {
        O = $59DzK(O);
        P = $7Af9t(P, true);
        if ($dzU8d) try {
            return $3b6f36f483e8e31a$var$gOPD(O, P);
        } catch (e) {}
        if ($aMccP(O, P)) return $evesF(!$gvEJa.f.call(O, P), O[P]);
    };
});
parcelRegister("55SkS", function(module, exports) {});
parcelRegister("8IAUf", function(module, exports) {
    (parcelRequire("eKGZg"))('asyncIterator');
});
parcelRegister("fvEHr", function(module, exports) {
    (parcelRequire("eKGZg"))('observable');
});
parcelRegister("gHLl6", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$c295621de530ae6b$export$1e511d4a378977f5, (v)=>$c295621de530ae6b$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$c295621de530ae6b$export$2e2bcd8739ae039, (v)=>$c295621de530ae6b$export$2e2bcd8739ae039 = v);
    var $c295621de530ae6b$export$1e511d4a378977f5;
    var $c295621de530ae6b$export$2e2bcd8739ae039;
    "use strict";
    $c295621de530ae6b$export$1e511d4a378977f5 = true;
    var $2gkZm = parcelRequire("2gkZm");
    var $c295621de530ae6b$var$_setPrototypeOf2 = $c295621de530ae6b$var$_interopRequireDefault($2gkZm);
    var $gqjuI = parcelRequire("gqjuI");
    var $c295621de530ae6b$var$_create2 = $c295621de530ae6b$var$_interopRequireDefault($gqjuI);
    var $kt6ai = parcelRequire("kt6ai");
    var $c295621de530ae6b$var$_typeof3 = $c295621de530ae6b$var$_interopRequireDefault($kt6ai);
    function $c295621de530ae6b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    $c295621de530ae6b$export$2e2bcd8739ae039 = function(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $c295621de530ae6b$var$_typeof3.default)(superClass)));
        subClass.prototype = (0, $c295621de530ae6b$var$_create2.default)(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) $c295621de530ae6b$var$_setPrototypeOf2.default ? (0, $c295621de530ae6b$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
    };
});
parcelRegister("2gkZm", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("9Eo5e")),
        __esModule: true
    };
});
parcelRegister("9Eo5e", function(module, exports) {
    parcelRequire("58apJ");
    module.exports = (parcelRequire("dv4GG")).Object.setPrototypeOf;
});
parcelRegister("58apJ", function(module, exports) {
    var $8EFNH = parcelRequire("8EFNH");
    $8EFNH($8EFNH.S, 'Object', {
        setPrototypeOf: (parcelRequire("kyYcY")).set
    });
});
parcelRegister("kyYcY", function(module, exports) {
    var $6VwBm = parcelRequire("6VwBm");
    var $6rs9h = parcelRequire("6rs9h");
    var $ef85afb423a719a5$var$check = function(O, proto) {
        $6rs9h(O);
        if (!$6VwBm(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
    };
    module.exports = {
        set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
            try {
                set = (parcelRequire("gnejD"))(Function.call, (parcelRequire("56mOV")).f(Object.prototype, '__proto__').set, 2);
                set(test, []);
                buggy = !(test instanceof Array);
            } catch (e) {
                buggy = true;
            }
            return function setPrototypeOf(O, proto) {
                $ef85afb423a719a5$var$check(O, proto);
                if (buggy) O.__proto__ = proto;
                else set(O, proto);
                return O;
            };
        }({}, false) : undefined),
        check: $ef85afb423a719a5$var$check
    };
});
parcelRegister("gqjuI", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("2cRis")),
        __esModule: true
    };
});
parcelRegister("2cRis", function(module, exports) {
    parcelRequire("8Agfc");
    var $dv4GG = parcelRequire("dv4GG");
    var $19b60b5f041438df$require$$Object = $dv4GG.Object;
    module.exports = function create(P, D) {
        return $19b60b5f041438df$require$$Object.create(P, D);
    };
});
parcelRegister("8Agfc", function(module, exports) {
    var $8EFNH = parcelRequire("8EFNH");
    $8EFNH($8EFNH.S, 'Object', {
        create: (parcelRequire("l5MPs"))
    });
});
parcelRegister("7ydDp", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $57f648f37539eed1$var$createDetectElementResize;
    function $57f648f37539eed1$var$createDetectElementResize(nonce, hostWindow) {
        var _window;
        if (typeof hostWindow !== 'undefined') _window = hostWindow;
        else if (typeof window !== 'undefined') _window = window;
        else if (typeof self !== 'undefined') _window = self;
        else _window = $parcel$global;
        var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;
        if (!attachEvent) {
            var requestFrame = function() {
                var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function(fn) {
                    return _window.setTimeout(fn, 20);
                };
                return function(fn) {
                    return raf(fn);
                };
            }();
            var cancelFrame = function() {
                var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
                return function(id) {
                    return cancel(id);
                };
            }();
            var resetTriggers = function resetTriggers(element) {
                var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
                contract.scrollLeft = contract.scrollWidth;
                contract.scrollTop = contract.scrollHeight;
                expandChild.style.width = expand.offsetWidth + 1 + 'px';
                expandChild.style.height = expand.offsetHeight + 1 + 'px';
                expand.scrollLeft = expand.scrollWidth;
                expand.scrollTop = expand.scrollHeight;
            };
            var checkTriggers = function checkTriggers(element) {
                return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
            };
            var scrollListener = function scrollListener(e) {
                if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) return;
                var element = this;
                resetTriggers(this);
                if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
                this.__resizeRAF__ = requestFrame(function() {
                    if (checkTriggers(element)) {
                        element.__resizeLast__.width = element.offsetWidth;
                        element.__resizeLast__.height = element.offsetHeight;
                        element.__resizeListeners__.forEach(function(fn) {
                            fn.call(element, e);
                        });
                    }
                });
            };
            var animation = false, keyframeprefix = '', animationstartevent = 'animationstart', domPrefixes = 'Webkit Moz O ms'.split(' '), startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '), pfx = '';
            var elm = _window.document.createElement('fakeelement');
            if (elm.style.animationName !== undefined) animation = true;
            if (animation === false) {
                for(var i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                    pfx = domPrefixes[i];
                    keyframeprefix = '-' + pfx.toLowerCase() + '-';
                    animationstartevent = startEvents[i];
                    animation = true;
                    break;
                }
            }
            var animationName = 'resizeanim';
            var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
            var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
        }
        var createStyles = function createStyles(doc) {
            if (!doc.getElementById('detectElementResize')) {
                var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName('head')[0], style = doc.createElement('style');
                style.id = 'detectElementResize';
                style.type = 'text/css';
                if (nonce != null) style.setAttribute('nonce', nonce);
                if (style.styleSheet) style.styleSheet.cssText = css;
                else style.appendChild(doc.createTextNode(css));
                head.appendChild(style);
            }
        };
        var addResizeListener = function addResizeListener(element, fn) {
            if (attachEvent) element.attachEvent('onresize', fn);
            else {
                if (!element.__resizeTriggers__) {
                    var doc = element.ownerDocument;
                    var elementStyle = _window.getComputedStyle(element);
                    if (elementStyle && elementStyle.position == 'static') element.style.position = 'relative';
                    createStyles(doc);
                    element.__resizeLast__ = {};
                    element.__resizeListeners__ = [];
                    (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
                    element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
                    element.appendChild(element.__resizeTriggers__);
                    resetTriggers(element);
                    element.addEventListener('scroll', scrollListener, true);
                    element.__scrollListener__ = scrollListener;
                    if (animationstartevent) {
                        element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                            if (e.animationName == animationName) resetTriggers(element);
                        };
                        element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                    }
                }
                element.__resizeListeners__.push(fn);
            }
        };
        var removeResizeListener = function removeResizeListener(element, fn) {
            if (attachEvent) element.detachEvent('onresize', fn);
            else {
                element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
                if (!element.__resizeListeners__.length) {
                    if (element.__scrollListener__) element.removeEventListener('scroll', element.__scrollListener__, true);
                    if (element.__resizeTriggers__.__animationListener__) {
                        element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                        element.__resizeTriggers__.__animationListener__ = null;
                    }
                    try {
                        element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                    } catch (e) {}
                }
            }
        };
        return {
            addResizeListener: addResizeListener,
            removeResizeListener: removeResizeListener
        };
    }
});
parcelRegister("5kC1b", function(module, exports) {
    $parcel$export(module.exports, "skeleton", ()=>$3e1c4f9a0d30fa8d$export$2a0674ff2eb10214, (v)=>$3e1c4f9a0d30fa8d$export$2a0674ff2eb10214 = v);
    var $3e1c4f9a0d30fa8d$export$2a0674ff2eb10214;
    $3e1c4f9a0d30fa8d$export$2a0674ff2eb10214 = `wVb0Qa_skeleton`;
});
parcelRegister("iZLaw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc42e27aeb14696f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cn3Ob;
    var $jnD30;
    var $hlzJ2 = parcelRequire("hlzJ2");
    var $fNobW;
    var $co1wz;
    var $7KnaJ;
    var $5kC1b = parcelRequire("5kC1b");
    class $bc42e27aeb14696f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                rowHeight: (0, (0, parcelRequire("7KnaJ")).RECT_ROW_HEIGHT),
                sidePadding: 8,
                spaceInBetween: 8,
                topPadding: 8,
                animate: true
            };
        }
        render() {
            const { numOfRows: numOfRows, ariaLabel: ariaLabel, rowHeight: rowHeight, animate: animate } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
                name: "list-skeleton"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hlzJ2.AutoSizer), null, ({ width: width, height: height })=>{
                const rowCount = numOfRows || Math.floor(height / rowHeight) - 1;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5kC1b.skeleton,
                    style: {
                        width: width,
                        height: height
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnD30")).default), {
                    ariaLabel: ariaLabel,
                    width: width,
                    height: height,
                    ...(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? {
                        animate: animate
                    } : {},
                    ...(0, (0, parcelRequire("7KnaJ")).DEFAULT_CONTENT_LOADER_PROPS)
                }, (0, parcelRequire("cn3Ob")).default(0, rowCount).map((index)=>this.getSkeletonFragments(index, width)))));
            }));
        }
        constructor(...args){
            super(...args);
            this.getSkeletonFragments = (index, width)=>{
                const { rowHeight: rowHeight, sidePadding: sidePadding, spaceInBetween: spaceInBetween, topPadding: topPadding } = this.props;
                const rectWidth = width - sidePadding * 2;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                    key: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: sidePadding,
                    y: index * (rowHeight + spaceInBetween) + topPadding,
                    ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
                    width: rectWidth < 0 ? 0 : rectWidth,
                    height: rowHeight
                }));
            };
        }
    }
});
parcelRegister("9IGpV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1eb7124b0a4cb451$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jnD30;
    var $hlzJ2 = parcelRequire("hlzJ2");
    var $fNobW;
    var $co1wz;
    var $7KnaJ;
    var $5kC1b = parcelRequire("5kC1b");
    class $1eb7124b0a4cb451$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                rowHeight: (0, (0, parcelRequire("7KnaJ")).RECT_ROW_HEIGHT),
                sidePadding: 8,
                topPadding: 8,
                animate: true
            };
        }
        render() {
            const { ariaLabel: ariaLabel, rowHeight: rowHeight, sidePadding: sidePadding, topPadding: topPadding, animate: animate } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
                name: "timeline-skeleton"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hlzJ2.AutoSizer), null, ({ width: width, height: height })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $5kC1b.skeleton,
                    style: {
                        width: width,
                        height: height
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnD30")).default), {
                    ariaLabel: ariaLabel,
                    width: width,
                    height: height,
                    ...(0, (0, parcelRequire("co1wz")).ff)('com.atlassian.rm.jpo.transposition') ? {
                        animate: animate
                    } : {},
                    ...(0, (0, parcelRequire("7KnaJ")).DEFAULT_CONTENT_LOADER_PROPS)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: sidePadding,
                    y: topPadding,
                    ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
                    width: width / 2,
                    height: rowHeight
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: sidePadding + 100,
                    y: topPadding + 90,
                    ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
                    width: width / 2,
                    height: rowHeight
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: sidePadding + 200,
                    y: topPadding + 132,
                    ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
                    width: width / 5,
                    height: rowHeight
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: sidePadding + 250,
                    y: topPadding + 258,
                    ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
                    width: width / 3,
                    height: rowHeight
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: sidePadding + 300,
                    y: topPadding + 342,
                    ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
                    width: width / 2,
                    height: rowHeight
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: sidePadding + 350,
                    y: topPadding + 468,
                    ...(0, (0, parcelRequire("7KnaJ")).RECT_BORDER_RADIUS),
                    width: width / 2,
                    height: rowHeight
                })))));
        }
    }
});
parcelRegister("33aBE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b567fecee731fe88$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b567fecee731fe88$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issue: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.skeleton.issue",
            "defaultMessage": "Issue"
        },
        fields: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.skeleton.fields",
            "defaultMessage": "Fields"
        }
    });
});
parcelRegister("93t2h", function(module, exports) {
    $parcel$export(module.exports, "PlanTableWrapper", ()=>$254d7c6c7e1ef7b2$export$4ef3b8f45df64cd1);
    var $bC2fB;
    var $kO1SR = parcelRequire("kO1SR");
    var $3KnS0 = parcelRequire("3KnS0");
    var $6ceiy = parcelRequire("6ceiy");
    const $254d7c6c7e1ef7b2$export$4ef3b8f45df64cd1 = (0, (0, parcelRequire("bC2fB")).connect)((0, $3KnS0.default), (0, $kO1SR.default))((0, $6ceiy.PlanTableWrapper));
});
parcelRegister("kO1SR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70c6eae903a8262c$export$2e2bcd8739ae039);
    var $i6pdT = parcelRequire("i6pdT");
    var $jfp3Z = parcelRequire("jfp3Z");
    const $70c6eae903a8262c$var$mapDispatchToProps = (dispatch)=>({
            onRoadmapView: (analyticsEvent)=>{
                dispatch((0, $i6pdT.sendViewRoadmapScreenAnalyticsEvent)(analyticsEvent));
            },
            reportTimeToInteractive: (payload)=>dispatch((0, $jfp3Z.reportTimeToInteractive)(payload))
        });
    var $70c6eae903a8262c$export$2e2bcd8739ae039 = $70c6eae903a8262c$var$mapDispatchToProps;
});
parcelRegister("3KnS0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa997bd1388e4613$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $aa997bd1388e4613$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        mode: (0, $1CGdp.getMode),
        viewMode: (0, $kWDpn.getViewMode),
        isReportMode: $1CGdp.isReportMode,
        isConfluenceMacro: $1CGdp.isConfluenceMacro,
        isEmbed: $1CGdp.isEmbed
    });
});
parcelRegister("6ceiy", function(module, exports) {
    $parcel$export(module.exports, "PlanTableWrapper", ()=>$2de1861bc9766740$export$4ef3b8f45df64cd1);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $7cFR3;
    var $8dO33;
    var $2i4sA;
    var $7iJwP;
    var $4R6GH;
    var $g7crU;
    var $3HwlS;
    var $3J2mc;
    var $hGiZz;
    var $nXNNJ;
    var $ks7qB;
    var $igD1g;
    var $g295Q;
    var $aPRoZ;
    var $dUk9j;
    var $db0fs = parcelRequire("db0fs");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fkq9X = parcelRequire("fkq9X");
    var $iXVV6;
    var $isuse;
    var $efvDm;
    var $k9JTq;
    var $l8ruj;
    var $99gkn;
    var $4cSmd = parcelRequire("4cSmd");
    var $3oPSC = parcelRequire("3oPSC");
    var $l38L3 = parcelRequire("l38L3");
    var $8G9be = parcelRequire("8G9be");
    var $dJfym = parcelRequire("dJfym");
    var $jVyaJ = parcelRequire("jVyaJ");
    var $dQp5d = parcelRequire("dQp5d");
    var $74EGL = parcelRequire("74EGL");
    var $cyHFd = parcelRequire("cyHFd");
    var $lx3ag = parcelRequire("lx3ag");
    var $2A3Yi = parcelRequire("2A3Yi");
    var $3t5zX = parcelRequire("3t5zX");
    var $7s7Sp = parcelRequire("7s7Sp");
    var $4KvFW = parcelRequire("4KvFW");
    const $2de1861bc9766740$export$4ef3b8f45df64cd1 = ({ mode: mode, viewMode: viewMode, isReportMode: isReportMode, isConfluenceMacro: isConfluenceMacro, isEmbed: isEmbed, reportTimeToInteractive: reportTimeToInteractive, onRoadmapView: onRoadmapView, exportAppWidth: exportAppWidth, children: children })=>{
        const shouldShowNav4 = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)();
        const useCurrentSpotlight = shouldShowNav4 ? (0, (0, parcelRequire("aPRoZ")).useCurrentSpotlight) : (0, (0, parcelRequire("aPRoZ")).useCurrentSpotlightOld);
        const { software: edition } = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        let isFullscreen;
        let setIsFullscreen;
        if (shouldShowNav4) [isFullscreen, { setIsFullscreen: setIsFullscreen }] = (0, (0, parcelRequire("g7crU")).useIsFullscreen)();
        else [isFullscreen, setIsFullscreen] = (0, $5uXOq.useState)(false);
        const [{ spotlight: onboardingSpotlight }] = useCurrentSpotlight();
        const [cttOnboardingSpotlight] = (0, (0, parcelRequire("igD1g")).useCttSpotlight)();
        const spotlightSelection = onboardingSpotlight === (0, (0, parcelRequire("aPRoZ")).Spotlights).Inactive ? cttOnboardingSpotlight : onboardingSpotlight;
        const isExportMode = mode === (0, $ab4be2e1e204af69$export$f79b1fae3e63e441);
        const nativeScrollbarHeight = (0, (0, parcelRequire("hGiZz")).useNativeScrollbarHeight)() ?? 0;
        const shouldHideScrollbar = !isExportMode && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE;
        const viewportInset = (0, $5uXOq.useMemo)(()=>shouldHideScrollbar ? (0, $jVyaJ.getViewportInset)(nativeScrollbarHeight) : undefined, [
            shouldHideScrollbar,
            nativeScrollbarHeight
        ]);
        const additionalHeightToHideNativeScrollbar = shouldHideScrollbar ? (0, $jVyaJ.getAdditionalHeightToHideNativeScrollbar)(nativeScrollbarHeight) : 0;
        const toggleFullscreen = (0, $5uXOq.useCallback)(()=>{
            setIsFullscreen(!isFullscreen);
        }, [
            isFullscreen,
            setIsFullscreen
        ]);
        const ref = (0, $5uXOq.useRef)(null);
        const withSpotlight = spotlightSelection === (0, (0, parcelRequire("aPRoZ")).Spotlights).HeartOfPlan || spotlightSelection === (0, (0, parcelRequire("g295Q")).CttSpotlights).Scope;
        (0, $5uXOq.useLayoutEffect)(()=>{
            reportTimeToInteractive({
                isNewSidebarEnabled: true,
                isTransposed: true
            });
        }, [
            reportTimeToInteractive
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (ref?.current && viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST) ref.current.scrollLeft = 0;
        }, [
            viewMode
        ]);
        const [smartCardClient] = (0, $5uXOq.useState)(()=>new (0, (0, parcelRequire("7cFR3")).default)());
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "view-advanced-roadmaps-timeline"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2i4sA")).ViewExperienceTrackingProvider), {
            experience: (0, $l38L3.getExperienceName)(isReportMode, isConfluenceMacro, isEmbed),
            analyticsSource: "portfolio3",
            application: (0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO),
            edition: edition,
            additionalAttributes: {
                synthetic: (0, (0, parcelRequire("nXNNJ")).isPollinatorTenant)()
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $db0fs.default), {
            location: "portfolio-3.simple-plans.roadmap.state-or-global-error",
            locationType: "path",
            locationPrefix: "roadmap"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dO33")).SmartCardProvider), {
            client: smartCardClient
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: (0, $TTKUQ.ERROR_REPORTING_PACKAGE).ROADMAP,
            attributes: {
                isTransposed: true
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            id: (0, $TTKUQ.ERROR_REPORTING_PACKAGE).ROADMAP,
            packageName: (0, $TTKUQ.PACKAGE_NAME),
            teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM),
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                isTransposed: 'true'
            }
        }, !isExportMode && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "view-advanced-roadmaps-timeline-overlay"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dJfym.TableToolbar), {
            viewMode: viewMode,
            isCollapsible: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE,
            onToggleFullscreen: toggleFullscreen,
            isFullscreen: isFullscreen
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fkq9X.ZIndexProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cyHFd.DragAndDropProvider), null, (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lx3ag.ColumnDragManager), null), (0, (0, parcelRequire("4R6GH")).fg)('plan_timeline_drag_and_drop_field_columns') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2A3Yi.ColumnDragScrollLock), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dQp5d.AutoScrollObserver), {
            scrollRef: ref
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $74EGL.DragScrollLock), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cSmd.DependenciesFlyoutProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8G9be.default), null, withSpotlight && !shouldShowNav4 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUk9j")).SpotlightTarget), {
            name: (0, (0, parcelRequire("aPRoZ")).Spotlights).HeartOfPlan
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUk9j")).SpotlightTarget), {
            name: (0, (0, parcelRequire("g295Q")).CttSpotlights).Scope
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $2de1861bc9766740$var$spotlightPlaceholderStyles
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $2de1861bc9766740$var$hiddenOverflowStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3t5zX.EnhancedContainer), {
            xcss: [
                withSpotlight && !shouldShowNav4 && $2de1861bc9766740$var$spotlightContainerStyles,
                isFullscreen && $2de1861bc9766740$var$fullscreenContainerStyles,
                isExportMode && $2de1861bc9766740$var$exportContainerStyles
            ],
            width: exportAppWidth,
            style: {
                bottom: -additionalHeightToHideNativeScrollbar
            },
            viewportInset: viewportInset,
            outerRef: ref,
            "data-scroll": "lockable",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.wrapper.table"
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3oPSC.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7s7Sp.ScrollIntoView), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cSmd.DependenciesFlyoutOverlay), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ks7qB")).default), null))))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: onRoadmapView
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4KvFW.ViewExperienceSuccessTracker), null)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
            data: {
                viewMode: viewMode,
                isTransposed: true
            }
        })));
    };
    const $2de1861bc9766740$var$spotlightPlaceholderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        pointerEvents: 'none'
    });
    const $2de1861bc9766740$var$hiddenOverflowStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        position: 'relative',
        width: '100%'
    });
    const $2de1861bc9766740$var$fullscreenContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'fixed',
        background: 'elevation.surface',
        zIndex: 1,
        '::before': {
            content: '""',
            background: 'elevation.surface',
            position: 'absolute',
            zIndex: -1
        }
    });
    const $2de1861bc9766740$var$spotlightContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        pointerEvents: 'none',
        zIndex: (0, $2ac30dbb3094ef55$export$8b2f0f816c634962) + 1
    });
    const $2de1861bc9766740$var$exportContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        zIndex: 1
    });
});
parcelRegister("lyodz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0ff337d956b1f78$export$2e2bcd8739ae039);
    var $6ximF;
    var $bC2fB;
    var $cpa6r = parcelRequire("cpa6r");
    var $b0ff337d956b1f78$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $cpa6r.default))((0, (0, parcelRequire("6ximF")).LocalStorageCommandSubscriber));
});
parcelRegister("6ximF", function(module, exports) {
    $parcel$export(module.exports, "LocalStorageCommandSubscriber", ()=>$d6a276e37401383c$export$f91a581fe8f664e2);
    var $5uXOq = parcelRequire("5uXOq");
    var $3gQiM;
    const $d6a276e37401383c$export$f91a581fe8f664e2 = (props)=>{
        (0, $5uXOq.useEffect)(()=>{
            const commands = (0, (0, parcelRequire("3gQiM")).storage).get((0, $9168d3ebb9134764$export$41284951b2635542)) || null;
            if (Array.isArray(commands) && commands.length) {
                commands.forEach(({ type: commandType, values: values })=>{
                    const command = props[commandType];
                    if (typeof command === 'function') command(...values);
                });
                (0, (0, parcelRequire("3gQiM")).storage).clearAll();
            }
        }, []);
        return null;
    };
});
const $9168d3ebb9134764$export$41284951b2635542 = 'commands';
parcelRegister("3gQiM", function(module, exports) {
    $parcel$export(module.exports, "storage", ()=>$c461297d8a449fbe$export$ddcffe0146c8f882);
    var $eNf8a;
    const $c461297d8a449fbe$export$ddcffe0146c8f882 = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)('use-local-storage-command');
});
parcelRegister("cpa6r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df5101ba21584f81$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    var $dQ2Hi = parcelRequire("dQ2Hi");
    var $dBbgF = parcelRequire("dBbgF");
    var $5lzYR = parcelRequire("5lzYR");
    const $df5101ba21584f81$var$mapDispatchToProps = (dispatch)=>({
            groupBy: (group)=>group && dispatch((0, $dBbgF.changeGroup)({
                    grouping: group
                })),
            resetHierarchyFilter: ()=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                    value: {
                        start: undefined,
                        end: undefined
                    }
                }));
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                    value: {
                        start: undefined,
                        end: undefined
                    }
                }));
            },
            changeHierarchyFilter: (start, end)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                    value: {
                        start: start + 1,
                        end: end + 1
                    }
                }));
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                    value: {
                        start: start,
                        end: end
                    }
                }));
            },
            changeStatusFilter: (value)=>dispatch((0, $834it.change)({
                    id: (0, $cGbfF.STATUS_KEY_FILTER_ID),
                    value: value
                })),
            changeTeamFilter: (itemKey)=>dispatch((0, $834it.change)({
                    id: (0, $cGbfF.TEAM_FILTER_ID),
                    value: [
                        itemKey
                    ]
                })),
            changePriorityFilter: (priorityId)=>dispatch((0, $834it.change)({
                    id: (0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID),
                    value: [
                        priorityId
                    ]
                })),
            changeDependenciesFilter: (value)=>dispatch((0, $834it.change)({
                    id: (0, $cGbfF.DEPENDENCIES_FILTER_ID),
                    value: value
                })),
            changeAssigneeFilter: (assigneeId)=>dispatch((0, $834it.change)({
                    id: (0, $cGbfF.ASSIGNEE_FILTER_ID),
                    value: [
                        assigneeId
                    ]
                })),
            changeIssueWarningFilter: (warningTypes)=>dispatch((0, $834it.change)({
                    id: (0, $cGbfF.ISSUE_WARNING_FILTER_ID),
                    value: warningTypes
                })),
            changeEnabledWarningType: (warningTypes)=>dispatch((0, $5lzYR.resetEnabledWarningType)(new Set(warningTypes))),
            changeDateRangeFilter: (dateRange)=>dispatch((0, $834it.change)({
                    id: (0, $cGbfF.DATE_RANGE_FILTER_ID),
                    value: dateRange
                })),
            clearFilter: ()=>dispatch((0, $834it.clearAll)()),
            toggleViewMode: (mode)=>dispatch((0, $dQ2Hi.changeViewMode)(mode))
        });
    var $df5101ba21584f81$export$2e2bcd8739ae039 = $df5101ba21584f81$var$mapDispatchToProps;
});
parcelRegister("9equ5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8f39195ec58e2e8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $6Ingq;
    var $6Pmud;
    var $3bDjY;
    var $koVbs;
    var $3DtgV = parcelRequire("3DtgV");
    const $d8f39195ec58e2e8$var$ButtonContainer = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$BaseButtonContainer, {
            "data-component-selector": "ButtonContainer",
            ...props
        }, children);
    const $d8f39195ec58e2e8$var$HeaderToggle = ({ mode: mode, setMode: setMode })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        switch(mode){
            case 'hidden':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$Bar, {
                    "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$BarSection, {
                    key: "Show toolbar",
                    justifyContent: "center",
                    onClick: ()=>setMode('toolbar'),
                    "aria-expanded": false,
                    "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar-section-show"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, $3DtgV.default).showRefinementOptions)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$ButtonContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                    label: formatMessage((0, $3DtgV.default).showRefinementOptions)
                }))))));
            case 'toolbar':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$Bar, {
                    "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$BarSection, {
                    key: "Hide toolbar",
                    justifyContent: "end",
                    onClick: ()=>setMode('hidden'),
                    "aria-expanded": true,
                    "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar-section-hide"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, $3DtgV.default).hideRefinementOptions)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$ButtonContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Pmud"))))), {
                    label: formatMessage((0, $3DtgV.default).hideRefinementOptions)
                }))))), (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$BarSection, {
                    key: "Show header",
                    justifyContent: "start",
                    onClick: ()=>setMode('visible'),
                    "aria-expanded": false,
                    "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar-section-show"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, $3DtgV.default).showHeader)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$ButtonContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                    label: formatMessage((0, $3DtgV.default).showHeader)
                }))))));
            case 'visible':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$Bar, {
                    "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$BarSection, {
                    key: "Hide header",
                    justifyContent: "center",
                    onClick: ()=>setMode('toolbar'),
                    "aria-expanded": true,
                    "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar-section-hide"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, $3DtgV.default).hideHeader)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8f39195ec58e2e8$var$ButtonContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Pmud"))))), {
                    label: formatMessage((0, $3DtgV.default).hideHeader)
                }))))));
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        }
    };
    var $d8f39195ec58e2e8$export$2e2bcd8739ae039 = $d8f39195ec58e2e8$var$HeaderToggle;
    const $d8f39195ec58e2e8$var$ButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4utpp _154iutpp _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $d8f39195ec58e2e8$var$BarSection = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { justifyContent: justifyContent, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_knsc5k": (0, (0, parcelRequire("lD23V")).default)(__cmplp.justifyContent)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4t3i1tcg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _11q7glyw _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _16qsglyw _80omtlke _1bahdlq5 _qy8a1id0 _6l561id0 _1v8vojai _12yjojai _1ebu5ynh _yqmw5ynh _16bj1f5i _nfpi1f5i _13hk1qap _1u0rnli6 _v4nb5ynh _cuqb1f5i _7ehiglyw",
                __cmplp.className
            ])
        });
    });
    const $d8f39195ec58e2e8$var$Bar = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _1bsb1osq _4t3i1tcg _1pbykb7n _kqswh2mm _1kt9b3bt _1mp41osq _kfgtyh40 _rfx3yh40 _1rushloo _1cs8stnw _qnecidpf _19woidpf _dsq4glyw _154pidpf _pdyk1hrg _gc16idpf _1n361pie _r2ecglyw _spuikb7n _r3ldkb7n _1046v8b6 _1egjv8b6 _1wlykb7n _xk06kb7n _1scov8b6 _1xznv8b6",
                __cmplp.className
            ])
        });
    });
    const $d8f39195ec58e2e8$var$BaseButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q71f5i _2rko1ssb _4t3i1tcg _1bsb1tcg _16qs1b5k _19it178y _v5641fx5 _l8ku1k0e",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3DtgV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93b1fc05cabaafde$export$2e2bcd8739ae039);
    var $7VHMR;
    var $93b1fc05cabaafde$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        hideRefinementOptions: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.hide-refinement-options",
            "defaultMessage": "Hide refinement options"
        },
        showRefinementOptions: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.show-refinement-options",
            "defaultMessage": "Show refinement options"
        },
        hideHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.hide-header",
            "defaultMessage": "Hide header"
        },
        showHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.show-header",
            "defaultMessage": "Show header"
        }
    });
});
parcelRegister("4eyJU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d0ab753dcb79bb2c$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    var $bC2fB;
    var $dLSrE = parcelRequire("dLSrE");
    var $01qsx = parcelRequire("01qsx");
    const $d0ab753dcb79bb2c$export$3a977cd83f945733 = (state)=>(0, $bHTqr.getPlan)(state).title;
    const $d0ab753dcb79bb2c$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        mode: (0, $1CGdp.getMode),
        isReadOnly: $1CGdp.isReadOnly,
        isArchived: $1CGdp.isArchived,
        plan: (0, $bHTqr.getPlan)
    });
    var $d0ab753dcb79bb2c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($d0ab753dcb79bb2c$var$mapStateToProps, {})((0, $01qsx.PageHeader));
});
parcelRegister("dLSrE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7240c27160eae38$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $3YtPS = parcelRequire("3YtPS");
    var $bC2fB;
    var $9pxpi = parcelRequire("9pxpi");
    const $c7240c27160eae38$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        mode: (0, $1CGdp.getMode)
    });
    var $c7240c27160eae38$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($c7240c27160eae38$var$mapStateToProps, {})((0, $9pxpi.Toolbar));
});
parcelRegister("9pxpi", function(module, exports) {
    $parcel$export(module.exports, "Toolbar", ()=>$8b95f99b9d525758$export$4c260019440d418f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4R6GH;
    var $1UEDB;
    var $aPRoZ;
    var $dUk9j;
    var $lygBN = parcelRequire("lygBN");
    var $4x9aM = parcelRequire("4x9aM");
    var $4Y7Vp = parcelRequire("4Y7Vp");
    var $dCm1o;
    var $Zf4mw = parcelRequire("Zf4mw");
    var $kO4PD = parcelRequire("kO4PD");
    var $a4Rpy = parcelRequire("a4Rpy");
    var $7IfyA = parcelRequire("7IfyA");
    var $g9aLQ = parcelRequire("g9aLQ");
    var $aLFO3 = parcelRequire("aLFO3");
    const $8b95f99b9d525758$export$4c260019440d418f = ({ mode: mode, headerMode: headerMode = 'visible' })=>{
        const { data: data } = (0, (0, parcelRequire("1UEDB")).usePlan)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($8b95f99b9d525758$var$RowContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($8b95f99b9d525758$var$LeftAlignment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $g9aLQ.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUk9j")).SpotlightTarget), {
            name: (0, (0, parcelRequire("aPRoZ")).Spotlights).ShowAndTell
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8b95f99b9d525758$var$LeftAlignment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $Zf4mw.default), null), mode !== (0, $ab4be2e1e204af69$export$e91bb82ec00eb771) && mode !== (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7IfyA.default), null)))), (0, ($parcel$interopDefault($5uXOq))).createElement($8b95f99b9d525758$var$RightAlignment, null, mode !== (0, $ab4be2e1e204af69$export$e91bb82ec00eb771) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a4Rpy.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUk9j")).SpotlightTarget), {
            name: (0, (0, parcelRequire("aPRoZ")).Spotlights).ListMode
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLFO3.default), null)), data?.isReadOnly === false && (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4x9aM.default), null, (enabled)=>enabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4Y7Vp.default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUk9j")).SpotlightTarget), {
            name: (0, (0, parcelRequire("aPRoZ")).Spotlights).FindYourLook
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lygBN.default), null)), headerMode === 'toolbar' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kO4PD.default), null))));
    };
    const $8b95f99b9d525758$var$RowContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulpu2gc _1bah1yb4",
                __cmplp.className
            ])
        });
    });
    const $8b95f99b9d525758$var$RightAlignment = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $8b95f99b9d525758$var$LeftAlignment = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1h6o _1e0c1txw _zulpu2gc _1bah1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1UEDB", function(module, exports) {
    $parcel$export(module.exports, "usePlan", ()=>$fe5ea6cf6b4cbe02$export$6734677f23034ac5);
    var $c1N9v;
    var $2YP9W;
    const $fe5ea6cf6b4cbe02$export$6734677f23034ac5 = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c1N9v")).staticPlanSidebarNavigationResource));
});
parcelRegister("lygBN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58588479cd2bb676$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $bC2fB;
    var $8811T = parcelRequire("8811T");
    var $gL703 = parcelRequire("gL703");
    var $3xKRV = parcelRequire("3xKRV");
    const $58588479cd2bb676$var$withAnalyticsContext = (Component)=>({ analyticsAttributes: analyticsAttributes, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceName: "viewSettings",
                sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
                attributes: analyticsAttributes
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, rest));
    const $58588479cd2bb676$var$ViewWithAnalyticsContext = $58588479cd2bb676$var$withAnalyticsContext((0, $3xKRV.default));
    var $58588479cd2bb676$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $gL703.default), (0, $8811T.default))($58588479cd2bb676$var$ViewWithAnalyticsContext);
});
parcelRegister("8811T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83060cc5da54cfa6$export$2e2bcd8739ae039);
    var $clsih = parcelRequire("clsih");
    var $duJmw = parcelRequire("duJmw");
    var $aGrEZ = parcelRequire("aGrEZ");
    var $7kNeW = parcelRequire("7kNeW");
    var $dBbgF = parcelRequire("dBbgF");
    var $83060cc5da54cfa6$export$2e2bcd8739ae039 = (dispatch)=>({
            clearAllComponentColours: ()=>{
                dispatch((0, $clsih.clearAllComponentColours)());
            },
            clearAllComponentGroups: ()=>{
                dispatch((0, $duJmw.clearAll)());
            },
            clearAllCustomFieldValuesGroups: (grouping)=>{
                dispatch((0, $aGrEZ.clearAll)({
                    grouping: grouping
                }));
            },
            clearAllIssueTypeColours: ()=>{
                dispatch((0, $clsih.clearAllIssueTypeColours)());
            },
            clearAllLabelColours: ()=>{
                dispatch((0, $clsih.clearAllLabelColours)());
            },
            clearAllLabelGroups: ()=>{
                dispatch((0, $7kNeW.clearAll)());
            },
            clearAllPriorityColours: ()=>{
                dispatch((0, $clsih.clearAllPriorityColours)());
            },
            clearAllSelectColours: ()=>{
                dispatch((0, $clsih.clearAllSelectColours)());
            },
            toggleShowSprints: (showSprints)=>{
                dispatch((0, $dBbgF.toggleShowSprints)({
                    showSprints: showSprints
                }));
            }
        });
});
parcelRegister("gL703", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f045a2cbcf1ac89f$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $kWDpn = parcelRequire("kWDpn");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $30sno = parcelRequire("30sno");
    const $f045a2cbcf1ac89f$var$getAnalyticsAttributes = (0, $3YtPS.createSelector)([
        (0, $bHTqr.getPlan),
        (0, $jpXKt.getIsSimplifiedProjectAvailable),
        (0, $kWDpn.getColorByViewSettings),
        (0, $j0XCX.getVisualisationGrouping),
        (0, $j0XCX.getVisualisationSorting),
        (0, $j0XCX.getShowSprints),
        (0, $kWDpn.getDependencySettings),
        (0, $kWDpn.getRollupViewSettings),
        (0, $19iju.getCustomFields)
    ], (plan, planContainsNextGenIssues, colorBy, grouping, sorting, showSprints, dependencySettings, rollUpSettings, customFields)=>({
            viewSettingsDetails: {
                colorBy: colorBy.colourByValue,
                sortBy: sorting.field,
                groupBy: (0, $30sno.getGroupForAnalyticEvent)(grouping, customFields),
                showCapacityOnTimeline: showSprints,
                dependencyStyle: dependencySettings.display,
                rollUpDates: rollUpSettings.showingRolledUpDate,
                rollUpOthers: rollUpSettings.showRolledUpOthers
            },
            planId: plan.id,
            planContainsNextGenIssues: planContainsNextGenIssues
        }));
    var $f045a2cbcf1ac89f$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        analyticsAttributes: $f045a2cbcf1ac89f$var$getAnalyticsAttributes,
        colourByConfiguration: (0, $kWDpn.getColorByViewSettings),
        grouping: (0, $j0XCX.getVisualisationGrouping),
        groupingByMultiValueCustomField: (0, $j0XCX.isGroupByMultiValueCustomField),
        showSprints: (0, $j0XCX.getShowSprints)
    });
});
parcelRegister("3xKRV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08ed512100c4a0b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $42CjB;
    var $5KZxU;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $ousew;
    var $8RXs9;
    var $3HwlS;
    var $aCpcO;
    var $fAGMJ;
    var $J8W7q;
    var $i2qlb = parcelRequire("i2qlb");
    var $j0XCX = parcelRequire("j0XCX");
    var $4nDwW = parcelRequire("4nDwW");
    var $gITL8 = parcelRequire("gITL8");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $8zOmE;
    var $dCm1o;
    var $9RoRH = parcelRequire("9RoRH");
    var $8t5Q5 = parcelRequire("8t5Q5");
    var $1Lwa3 = parcelRequire("1Lwa3");
    var $7d5vc = parcelRequire("7d5vc");
    var $k0bqi = parcelRequire("k0bqi");
    var $4ggfX = parcelRequire("4ggfX");
    var $bkMJm = parcelRequire("bkMJm");
    var $7jSf8 = parcelRequire("7jSf8");
    var $7nEUj = parcelRequire("7nEUj");
    var $35huV = parcelRequire("35huV");
    var $7V9IL = parcelRequire("7V9IL");
    var $fG4bS = parcelRequire("fG4bS");
    var $3AWz7 = parcelRequire("3AWz7");
    var $8SFDO = parcelRequire("8SFDO");
    var $gH9CP = parcelRequire("gH9CP");
    var $9H7in = parcelRequire("9H7in");
    class $08ed512100c4a0b0$export$4d0b6d35abb3362d extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                ColourBy: $4ggfX.default,
                ColourByIssueType: $8t5Q5.default,
                ColourByLabel: $1Lwa3.default,
                ColourByComponent: $9RoRH.default,
                ColourByPriority: $7d5vc.default,
                ColourBySelect: $k0bqi.default,
                DependencySettings: $7jSf8.default,
                GroupBy: $7V9IL.default,
                GroupByComponents: $7nEUj.default,
                SortBy: $gH9CP.default,
                EstimateRollup: $8SFDO.default,
                groupingByMultiValueCustomField: false
            };
        }
        render() {
            const { intl: intl } = this.props;
            return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                        xcss: $08ed512100c4a0b0$var$contentContainerStyles,
                        paddingInline: "space.300",
                        paddingBlock: "space.200"
                    }, this.renderContent()),
                isOpen: this.state.isOpen,
                trigger: this.renderTriggerButton,
                onClose: ()=>{
                    if (this.state.isDialogLocked) return;
                    this.setState({
                        isOpen: false
                    }, ()=>{
                        this.buttonRef.current?.focus();
                    });
                },
                placement: "bottom-end",
                shouldRenderToParent: true,
                role: "dialog",
                ...(0, (0, parcelRequire("4R6GH")).fg)('portfolio-dialog-name-a11y') && {
                    label: intl.formatMessage((0, $3AWz7.default).triggerButtonLabel)
                }
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), null, this.renderContent()),
                isOpen: this.state.isOpen,
                onClose: ()=>{
                    if (this.state.isDialogLocked) return;
                    this.setState({
                        isOpen: false
                    }, ()=>{
                        this.buttonRef.current?.focus();
                    });
                },
                placement: "bottom-end"
            }, this.renderTriggerButton());
        }
        constructor(...args){
            super(...args);
            this.state = {
                isOpen: !!this.props.isDefaultOpen,
                isDialogLocked: false
            };
            this.buttonRef = (0, $5uXOq.createRef)();
            this.toggleDialogLocked = (isDialogLocked)=>{
                this.setState({
                    isDialogLocked: isDialogLocked
                });
            };
            this.toggleMenu = (_, analyticsEvent)=>{
                this.setState(({ isOpen: isOpen })=>{
                    if (!isOpen) {
                        const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).INLINE_DIALOG_VIEWED.split(' ');
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                            actionSubject: actionSubject,
                            action: action
                        }));
                    }
                    return {
                        isOpen: !isOpen
                    };
                });
            };
            this.renderTriggerButton = (props)=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                const { isOpen: isOpen } = this.state;
                return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5KZxU"))))), {
                            label: ""
                        }),
                    label: formatMessage((0, $3AWz7.default).triggerButtonLabel),
                    isSelected: isOpen,
                    onClick: this.toggleMenu,
                    ref: this.buttonRef,
                    "aria-expanded": this.state.isOpen,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.button",
                    isTooltipDisabled: false,
                    ...props
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5KZxU"))))), {
                        label: ""
                    }),
                    isSelected: isOpen,
                    onClick: this.toggleMenu,
                    ref: this.buttonRef,
                    "aria-expanded": this.state.isOpen,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.button",
                    ...props
                }, formatMessage((0, $3AWz7.default).triggerButtonLabel));
            };
            this.renderColourByIssueTypeLegend = ()=>{
                const { ColourByIssueType: ColourByIssueType } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $9H7in.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2
                }, ColourByIssueType && (0, ($parcel$interopDefault($5uXOq))).createElement(ColourByIssueType, {
                    onMenuToggle: this.toggleDialogLocked
                }))));
            };
            this.renderColourByLabelLegend = ()=>{
                const { ColourByLabel: ColourByLabel } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $9H7in.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2
                }, ColourByLabel && (0, ($parcel$interopDefault($5uXOq))).createElement(ColourByLabel, {
                    onMenuToggle: this.toggleDialogLocked
                }))));
            };
            this.renderColourByComponentLegend = ()=>{
                const { ColourByComponent: ColourByComponent } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $9H7in.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2
                }, ColourByComponent && (0, ($parcel$interopDefault($5uXOq))).createElement(ColourByComponent, {
                    onMenuToggle: this.toggleDialogLocked
                }))));
            };
            this.renderColourByPriorityLegend = ()=>{
                const { ColourByPriority: ColourByPriority } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $9H7in.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2
                }, ColourByPriority && (0, ($parcel$interopDefault($5uXOq))).createElement(ColourByPriority, {
                    onMenuToggle: this.toggleDialogLocked
                }))));
            };
            this.renderColourBySelectLegend = ()=>{
                const { ColourBySelect: ColourBySelect } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $9H7in.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2
                }, ColourBySelect && (0, ($parcel$interopDefault($5uXOq))).createElement(ColourBySelect, {
                    onMenuToggle: this.toggleDialogLocked
                }))));
            };
            this.renderColourByClearButton = ()=>{
                const { clearAllComponentColours: clearAllComponentColours, clearAllIssueTypeColours: clearAllIssueTypeColours, clearAllLabelColours: clearAllLabelColours, clearAllPriorityColours: clearAllPriorityColours, clearAllSelectColours: clearAllSelectColours, colourByConfiguration: { colourByValue: colourByValue } } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    onClick: (e)=>{
                        e.preventDefault();
                        if (colourByValue === (0, $gITL8.colourByOptions).COMPONENT) clearAllComponentColours();
                        else if (colourByValue === (0, $gITL8.colourByOptions).ISSUE_TYPE) clearAllIssueTypeColours();
                        else if (colourByValue === (0, $gITL8.colourByOptions).LABEL) clearAllLabelColours();
                        else if (colourByValue === (0, $gITL8.colourByOptions).PRIORITY) clearAllPriorityColours();
                        else if ((0, $j0XCX.isColorByCustomFieldOption)(colourByValue)) clearAllSelectColours();
                    },
                    spacing: "compact",
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.clear-all-colors"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $3AWz7.default).clearAllColours));
            };
            this.shouldShowClearButton = ()=>{
                const { colourByConfiguration: { colourByValue: colourByValue, colourIssueTypes: colourIssueTypes, colourLabels: colourLabels, colourPriorities: colourPriorities, colourSelects: colourSelects, colourComponents: colourComponents } } = this.props;
                if (colourByValue === (0, $gITL8.colourByOptions).COMPONENT) {
                    const isAddingNewComponentColour = colourComponents.some(({ colour: colour })=>!colour);
                    return colourComponents.length > (isAddingNewComponentColour ? 1 : 0);
                }
                if (colourByValue === (0, $gITL8.colourByOptions).ISSUE_TYPE) {
                    if ((0, $4nDwW.isDefined)(colourIssueTypes)) {
                        const isAddingNewIssueTypeColour = colourIssueTypes.some(({ colour: colour })=>!colour);
                        return colourIssueTypes.length > (isAddingNewIssueTypeColour ? 1 : 0);
                    }
                    return false;
                }
                if (colourByValue === (0, $gITL8.colourByOptions).LABEL) {
                    const isAddingNewLabelColour = colourLabels.some(({ colour: colour })=>!colour);
                    return colourLabels.length > (isAddingNewLabelColour ? 1 : 0);
                }
                if (colourByValue === (0, $gITL8.colourByOptions).PRIORITY) {
                    if ((0, $4nDwW.isDefined)(colourPriorities)) {
                        const isAddingNewPriorityColour = colourPriorities.some(({ colour: colour })=>!colour);
                        return colourPriorities.length > (isAddingNewPriorityColour ? 1 : 0);
                    }
                    return false;
                }
                if ((0, $j0XCX.isColorByCustomFieldOption)(colourByValue)) {
                    const isAddingNewSelectColour = (colourSelects[colourByValue] || []).some(({ colour: colour })=>!colour);
                    return (colourSelects[colourByValue] || []).length > (isAddingNewSelectColour ? 1 : 0);
                }
                return false;
            };
            this.shouldShowClearAllGroupsButton = ()=>{
                const { grouping: grouping, groupingByMultiValueCustomField: groupingByMultiValueCustomField } = this.props;
                return grouping === (0, $TTKUQ.GROUPING).COMPONENT || grouping === (0, $TTKUQ.GROUPING).LABEL || groupingByMultiValueCustomField;
            };
            this.onClearAllGroups = (e = {
                preventDefault: ()=>{}
            })=>{
                e.preventDefault && e.preventDefault();
                const { clearAllCustomFieldValuesGroups: clearAllCustomFieldValuesGroups, clearAllComponentGroups: clearAllComponentGroups, clearAllLabelGroups: clearAllLabelGroups, grouping: grouping } = this.props;
                if (grouping === (0, $TTKUQ.GROUPING).COMPONENT) return clearAllComponentGroups();
                if (grouping === (0, $TTKUQ.GROUPING).LABEL) return clearAllLabelGroups();
                return clearAllCustomFieldValuesGroups(grouping);
            };
            this.renderClearAllGroupsButton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    spacing: "compact",
                    onClick: this.onClearAllGroups,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.clear-all-groups"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $3AWz7.default).clearAllGroups));
            this.handleKeyDownCapture = (e)=>{
                if (e.key === 'Escape' && !this.state.isDialogLocked) this.setState({
                    isOpen: false
                }, ()=>{
                    this.buttonRef.current?.focus();
                });
            };
            this.renderContent = ()=>{
                const { ColourBy: ColourBy, DependencySettings: DependencySettings, GroupBy: GroupBy, GroupByComponents: GroupByComponents, SortBy: SortBy, EstimateRollup: EstimateRollup, colourByConfiguration: { colourByValue: colourByValue }, grouping: grouping, showSprints: showSprints, toggleShowSprints: toggleShowSprints, intl: intl, groupingByMultiValueCustomField: groupingByMultiValueCustomField } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9H7in.settingsList,
                    onKeyDownCapture: this.handleKeyDownCapture
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("table", null, (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", null, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $9H7in.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bkMJm.default).colourByLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    className: $9H7in.viewSettingSelect,
                    ...!this.shouldShowClearButton() && {
                        colSpan: 2
                    }
                }, ColourBy && (0, ($parcel$interopDefault($5uXOq))).createElement(ColourBy, {
                    onMenuToggle: this.toggleDialogLocked
                })), this.shouldShowClearButton() && (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    className: $9H7in.clearAllButton
                }, this.renderColourByClearButton())), colourByValue === (0, $gITL8.colourByOptions).COMPONENT && this.renderColourByComponentLegend(), colourByValue === (0, $gITL8.colourByOptions).ISSUE_TYPE ? this.renderColourByIssueTypeLegend() : null, colourByValue === (0, $gITL8.colourByOptions).LABEL && this.renderColourByLabelLegend(), colourByValue === (0, $gITL8.colourByOptions).PRIORITY ? this.renderColourByPriorityLegend() : null, (0, $j0XCX.isColorByCustomFieldOption)(colourByValue) && this.renderColourBySelectLegend(), SortBy && (0, ($parcel$interopDefault($5uXOq))).createElement(SortBy, {
                    onMenuToggle: this.toggleDialogLocked
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $9H7in.groupByRow : $9H7in.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).groupBy)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    className: $9H7in.viewSettingSelect,
                    ...!this.shouldShowClearAllGroupsButton() && {
                        colSpan: 2
                    }
                }, GroupBy && (0, ($parcel$interopDefault($5uXOq))).createElement(GroupBy, {
                    onMenuToggle: this.toggleDialogLocked
                })), this.shouldShowClearAllGroupsButton() && (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    className: $9H7in.clearAllButton
                }, this.renderClearAllGroupsButton())), grouping === (0, $TTKUQ.GROUPING).COMPONENT && GroupByComponents && (0, ($parcel$interopDefault($5uXOq))).createElement(GroupByComponents, {
                    onMenuToggle: this.toggleDialogLocked
                }), grouping === (0, $TTKUQ.GROUPING).LABEL && (0, $fG4bS.default) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fG4bS.default), {
                    onMenuToggle: this.toggleDialogLocked
                }), groupingByMultiValueCustomField && (0, $35huV.default) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $35huV.default), {
                    onMenuToggle: this.toggleDialogLocked
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $9H7in.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9H7in.showCapacityCheckbox
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    defaultChecked: showSprints,
                    isDisabled: grouping !== (0, $TTKUQ.GROUPING).SPRINT && grouping !== (0, $TTKUQ.GROUPING).TEAM,
                    label: intl.formatMessage({
                        ...(0, $3AWz7.default).showSprintsOnTimeline
                    }),
                    onChange: (_, analyticsEvent)=>{
                        const nextValue = !showSprints;
                        const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SHOW_CAPACITY_ON_TIMELINE_CHANGED.split(' ');
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                            actionSubject: actionSubject,
                            action: action
                        }), actionSubjectId, {
                            newPlanSettingValue: nextValue
                        });
                        toggleShowSprints(nextValue);
                    },
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.show-capacity-checkbox",
                    value: "show-sprints"
                })), grouping !== (0, $TTKUQ.GROUPING).SPRINT && grouping !== (0, $TTKUQ.GROUPING).TEAM && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9H7in.checkboxInfo,
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.show-capacity-checkbox-info"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $3AWz7.default).onlyAvailableForTeamOrSprint)))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $9H7in.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    className: $9H7in.topAlignedTd
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $3AWz7.default).dependencySettingsLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2,
                    className: $9H7in.topAlignedTd
                }, DependencySettings && (0, ($parcel$interopDefault($5uXOq))).createElement(DependencySettings, {
                    onMenuToggle: this.toggleDialogLocked
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $9H7in.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    className: $9H7in.topAlignedTd
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9H7in.rollupSetting
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $3AWz7.default).rollupLabel))), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2,
                    className: $9H7in.topAlignedTd
                }, EstimateRollup && (0, ($parcel$interopDefault($5uXOq))).createElement(EstimateRollup, null)))))));
            };
        }
    }
    var $08ed512100c4a0b0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($08ed512100c4a0b0$export$4d0b6d35abb3362d);
    const $08ed512100c4a0b0$var$contentContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxWidth: '496px'
    });
});
parcelRegister("5KZxU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4310fd5ff8fcaeb0$var$_react = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4310fd5ff8fcaeb0$var$_customize = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("4QAwn")));
    function $4310fd5ff8fcaeb0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4310fd5ff8fcaeb0$var$PreferencesIcon = (props)=>$4310fd5ff8fcaeb0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
        }, props, {
            newIcon: $4310fd5ff8fcaeb0$var$_customize.default
        }));
    $4310fd5ff8fcaeb0$var$PreferencesIcon.displayName = 'PreferencesIcon';
    var $4310fd5ff8fcaeb0$var$_default = module.exports.default = $4310fd5ff8fcaeb0$var$PreferencesIcon;
});
parcelRegister("4QAwn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3878591d802e976a$var$_UNSAFE_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3878591d802e976a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3878591d802e976a$var$CustomizeIcon = (props)=>$3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
        }, props));
    $3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
    var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;
});
parcelRegister("9RoRH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef1790f256767ca0$export$2e2bcd8739ae039);
    var $5nMRY = parcelRequire("5nMRY");
    var $jpXKt = parcelRequire("jpXKt");
    var $kWDpn = parcelRequire("kWDpn");
    var $clsih = parcelRequire("clsih");
    var $bC2fB;
    var $1QyzH = parcelRequire("1QyzH");
    const $ef1790f256767ca0$var$mapStateToProps = (state)=>({
            colourByConfiguration: (0, $kWDpn.getColorByViewSettings)(state),
            components: (0, $5nMRY.getComponents)(state),
            projectsById: (0, $jpXKt.getProjectsById)(state)
        });
    const $ef1790f256767ca0$var$mapDispatchToProps = (dispatch)=>({
            addComponentColour: ()=>{
                dispatch((0, $clsih.addComponentColour)());
            },
            updateComponentColour: (payload)=>{
                dispatch((0, $clsih.updateComponentColour)(payload));
            },
            removeComponentColour: (payload)=>{
                dispatch((0, $clsih.removeComponentColour)(payload));
            }
        });
    var $ef1790f256767ca0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($ef1790f256767ca0$var$mapStateToProps, $ef1790f256767ca0$var$mapDispatchToProps)((0, $1QyzH.default));
});
parcelRegister("1QyzH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32d46099fa6485c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $lV634;
    var $9lMrf;
    var $3bDjY;
    var $ousew;
    var $8RXs9;
    var $aCpcO;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $4Ai8V = parcelRequire("4Ai8V");
    var $gITL8 = parcelRequire("gITL8");
    var $ihPUd = parcelRequire("ihPUd");
    var $3AWz7 = parcelRequire("3AWz7");
    var $1IIyY = parcelRequire("1IIyY");
    var $24w68 = parcelRequire("24w68");
    const $32d46099fa6485c5$var$optionsToComponents = (options)=>options.map((x)=>x.value);
    class $32d46099fa6485c5$export$1c8038c4bb24c6bf extends (0, $5uXOq.Component) {
        render() {
            const { colourByConfiguration: { colourComponents: colourComponents }, intl: intl } = this.props;
            const isAddingNewComponentColour = colourComponents.some(({ colour: colour })=>!colour);
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $24w68.list
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $24w68.row
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                className: $24w68.allOtherIssuesButton,
                isDisabled: true,
                ariaLabel: intl.formatMessage((0, $3AWz7.default).allOtherIssuesButtonLabel),
                iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: intl.formatMessage((0, $gITL8.colourPickerPaletteLabels)[0, $gITL8.DEFAULT_COLOR]),
                    position: "top"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $24w68.swatch,
                    style: {
                        backgroundColor: (0, $gITL8.DEFAULT_COLOR)
                    }
                }))
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $24w68.allOtherIssues
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).allOtherIssues))), colourComponents.map(this.renderRow), isAddingNewComponentColour ? null : this.renderAddComponent()));
        }
        constructor(...args){
            super(...args);
            this.state = {
                keySuffix: 0
            };
            this.availableComponents = ()=>{
                const { components: components, colourByConfiguration: { colourComponents: colourComponents } } = this.props;
                const usedComponents = new Set((0, $4nDwW.chain)((x)=>x.components, colourComponents));
                return components.map((component)=>component.id.toString()).filter((component)=>!usedComponents.has(component));
            };
            this.componentIdsToOptions = (componentIds)=>{
                const { components: components, projectsById: projectsById } = this.props;
                return componentIds.reduce((options, componentId)=>{
                    const component = components.find((component)=>component.id.toString() === componentId);
                    if (component) {
                        const option = {
                            value: component.id.toString(),
                            label: component.projectId ? `${component.name} (${projectsById[component.projectId].key})` : component.name
                        };
                        options.push(option);
                    }
                    return options;
                }, []);
            };
            this.onComponentsChange = (index, options)=>{
                const { updateComponentColour: updateComponentColour, removeComponentColour: removeComponentColour } = this.props;
                if ((0, parcelRequire("lV634")).default(options) || (0, parcelRequire("3nPAF")).default(options)) {
                    removeComponentColour({
                        index: index
                    });
                    this.setState((prevState)=>({
                            keySuffix: prevState.keySuffix + 1
                        }));
                } else updateComponentColour({
                    index: index,
                    components: $32d46099fa6485c5$var$optionsToComponents(options)
                });
            };
            this.onColourChange = (index)=>(colour)=>{
                    const { updateComponentColour: updateComponentColour, removeComponentColour: removeComponentColour } = this.props;
                    if (colour) updateComponentColour({
                        index: index,
                        colour: colour
                    });
                    else removeComponentColour({
                        index: index
                    });
                };
            this.renderRow = (colourComponent, index)=>{
                const { colour: colour, components: components } = colourComponent;
                const availableComponents = this.availableComponents();
                const { intl: intl, onMenuToggle: onMenuToggle } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $24w68.row,
                    key: `${index}-${colour || ''}-${this.state.keySuffix}`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4Ai8V.default), {
                    colour: colour,
                    onColourChange: this.onColourChange(index),
                    position: "left",
                    ariaLabel: colour ? intl.formatMessage((0, $1IIyY.default).editLabelColorAriaLabel) : intl.formatMessage((0, $1IIyY.default).chooseLabelColorAriaLabel)
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $24w68.componentSelect
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                    "aria-label": intl.formatMessage((0, $1IIyY.default).selectComponentLabel),
                    classNamePrefix: `portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by-component_select-component-${index}`,
                    defaultValue: this.componentIdsToOptions(components),
                    isDisabled: !colour,
                    isMulti: true,
                    menuPlacement: "auto",
                    menuPortalTarget: (0, $4y9A5.getBody)(),
                    onChange: (options)=>this.onComponentsChange(index, options),
                    onMenuClose: ()=>{
                        onMenuToggle(false);
                    },
                    onMenuOpen: ()=>{
                        onMenuToggle(true);
                    },
                    options: this.componentIdsToOptions(availableComponents),
                    placeholder: intl.formatMessage(colour ? (0, $1IIyY.default).findComponent : (0, $1IIyY.default).chooseColour),
                    styles: {
                        menuPortal: (styles)=>({
                                ...styles,
                                zIndex: 1000
                            })
                    },
                    inputId: "portfolio-3.simple-plans_main_tabs_roadmap.view-settings.colourByComponent.select-component"
                }))));
            };
            this.renderAddComponent = ()=>{
                const { addComponentColour: addComponentColour } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: `${$24w68.addLabelButton} ${$24w68.row}`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                        label: ""
                    }),
                    onClick: (e)=>{
                        e.preventDefault();
                        addComponentColour();
                    },
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.add-color-link"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    className: $24w68.addLabel
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $1IIyY.default).addComponent)))));
            };
        }
    }
    var $32d46099fa6485c5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($32d46099fa6485c5$export$1c8038c4bb24c6bf);
});
parcelRegister("4Ai8V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5eefc149a499e563$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3zNHM = parcelRequire("3zNHM");
    var $koVbs;
    var $gITL8 = parcelRequire("gITL8");
    const $5eefc149a499e563$var$ColourPicker = ({ colour: colour, position: position = 'left', isDisabled: isDisabled = false, selectedColourSwatchSize: selectedColourSwatchSize = 'small', onColourChange: onColourChange, ariaLabel: ariaLabel })=>{
        const [color, setColor] = (0, $5uXOq.useState)(colour);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const colorPalette = (0, $5uXOq.useMemo)(()=>(0, $gITL8.colourPickerPalette).map((colour)=>({
                    label: formatMessage((0, $gITL8.colourPickerPaletteLabels)[colour]),
                    value: colour
                })), [
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3zNHM.default), {
            palette: colorPalette,
            selectedColor: color,
            showDefaultSwatchColor: !!color,
            selectedColourSwatchSize: selectedColourSwatchSize,
            isDisabledSelectedSwatch: isDisabled,
            popperProps: {
                strategy: 'fixed',
                placement: position,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [
                                0,
                                10
                            ]
                        }
                    }
                ]
            },
            cols: colorPalette.length / 2,
            onChange: (newColor)=>{
                setColor(newColor);
                onColourChange(newColor);
            },
            label: ariaLabel
        });
    };
    var $5eefc149a499e563$export$2e2bcd8739ae039 = $5eefc149a499e563$var$ColourPicker;
});
parcelRegister("3zNHM", function(module, exports) {
    $parcel$export(module.exports, "Compact", ()=>$06f62cb25bd09d8d$export$6479582a9c9e50ce);
    $parcel$export(module.exports, "default", ()=>$06f62cb25bd09d8d$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "ColorPaletteMenu", ()=>(parcelRequire("lGTQx")).default);
    var $3PpqK = parcelRequire("3PpqK");
    var $kD00A = parcelRequire("kD00A");
    var $lGTQx = parcelRequire("lGTQx");
    const { Compact: $06f62cb25bd09d8d$export$6479582a9c9e50ce, Standard: $06f62cb25bd09d8d$export$d5a1f56087d42b19 } = (0, $kD00A.Mode);
    var $06f62cb25bd09d8d$export$2e2bcd8739ae039 = (0, $3PpqK.default);
});
parcelRegister("3PpqK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f994db29f75e4622$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b9dFI;
    var $1ErJq = parcelRequire("1ErJq");
    var $jKrb6 = parcelRequire("jKrb6");
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    var $8RXs9;
    var $7oXeG = parcelRequire("7oXeG");
    function $f994db29f75e4622$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f994db29f75e4622$var$defaultPopperProps = {
        strategy: 'fixed',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            }
        ],
        placement: 'bottom-start'
    };
    const $f994db29f75e4622$var$packageName = "platform-pkg";
    const $f994db29f75e4622$var$packageVersion = "0.0.0-use.local";
    class $f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $f994db29f75e4622$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl } = this.props;
            const { options: options, value: value } = (0, $5dAp2.getOptions)(palette, selectedColor, showDefaultSwatchColor);
            const fullLabel = this.getFullLabel(intl, value, label);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("b9dFI")).default), {
                target: ({ ref: ref, isOpen: isOpen })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                        css: $f994db29f75e4622$var$colorCardWrapperStyles,
                        ref: ref
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $1ErJq.default), {
                        ...value,
                        label: fullLabel,
                        expanded: isOpen,
                        swatchSize: selectedColourSwatchSize,
                        isDisabled: isDisabledSelectedSwatch,
                        id: triggerId
                    })),
                popperProps: popperProps,
                maxMenuWidth: "auto",
                minMenuWidth: "auto",
                options: options,
                "aria-label": fullLabel,
                value: value,
                components: $jKrb6,
                onChange: this.onChangeSelect,
                searchThreshold: Number.MAX_VALUE,
                cols: cols,
                checkMarkColor: checkMarkColor,
                onKeyDown: this.onKeyDown,
                isTabbing: this.state.isTabbing,
                onOptionKeyDown: this.onOptionKeyDown
            });
        }
        constructor(...args){
            super(...args);
            this.createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
            this.state = {
                isTabbing: false
            };
            this.changeAnalyticsCaller = ()=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                    action: 'clicked',
                    actionSubject: 'color-picker',
                    attributes: {
                        componentName: 'color-picker',
                        packageName: $f994db29f75e4622$var$packageName,
                        packageVersion: $f994db29f75e4622$var$packageVersion
                    }
                })(createAnalyticsEvent);
                return undefined;
            };
            this.onChangeSelect = (option)=>{
                this.props.onChange(option.value, this.changeAnalyticsCaller());
            };
            this.onOptionKeyDown = (value)=>{
                this.props.onChange(value, this.changeAnalyticsCaller());
            };
            this.onKeyDown = (e)=>{
                const key = e.key;
                if (key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) this.setState({
                    isTabbing: true
                });
                else if (key === (0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2) || key === (0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8)) this.setState({
                    isTabbing: false
                });
                else if (key === (0, $8fa07a9626e5ffeb$export$929c2026f4dd54a2)) e.stopPropagation();
            };
            this.getFullLabel = (intl, value, label)=>{
                if (value && value.label) return intl.formatMessage((0, $7oXeG.default).colorPickerAriaLabel, {
                    color: value.label,
                    message: label
                });
                else return label;
            };
        }
    }
    const $f994db29f75e4622$export$2fcf66ed38ff3cf5 = (0, (0, parcelRequire("8RXs9")).default)($f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase);
    var $f994db29f75e4622$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'color-picker',
        packageName: $f994db29f75e4622$var$packageName,
        packageVersion: $f994db29f75e4622$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)()($f994db29f75e4622$export$2fcf66ed38ff3cf5));
    const $f994db29f75e4622$var$colorCardWrapperStyles = {
        name: "1r5gb7q",
        styles: "display:inline-block"
    };
});
parcelRegister("1ErJq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$609735830782207d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $VSDnB;
    var $f8Sb3;
    function $609735830782207d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $609735830782207d$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id })=>{
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            event.currentTarget.focus();
            if (onClick) {
                event.preventDefault();
                onClick();
            }
        }, [
            onClick
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: [
                $609735830782207d$var$sharedColorContainerStyles,
                swatchSize === 'small' ? $609735830782207d$var$smallColorContainerSize : $609735830782207d$var$defaultColorContainerSize,
                $609735830782207d$var$colorCardButtonStyles,
                expanded && !(0, (0, parcelRequire("VSDnB")).fg)('platform-design-system-dsp-20821-color-pickr-focus') && $609735830782207d$var$colorCardButtonFocusedStyles
            ],
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            "aria-label": label,
            "aria-expanded": expanded,
            "aria-haspopup": true,
            type: "button",
            id: id
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $609735830782207d$var$colorCardWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $609735830782207d$var$colorCardContentStyles,
                swatchSize === 'small' ? $609735830782207d$var$smallColorCardContentSize : $609735830782207d$var$defaultColorCardContentSize
            ],
            style: {
                background: value || 'transparent'
            }
        }))));
    };
    var $609735830782207d$export$2e2bcd8739ae039 = $609735830782207d$var$ColorCard;
    const $609735830782207d$var$sharedColorContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        position: 'relative',
        border: '2px solid transparent',
        boxSizing: 'border-box',
        borderRadius: '6px',
        transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        padding: "var(--ds-space-0, 0px)",
        cursor: 'pointer',
        outline: 'none'
    });
    const $609735830782207d$var$smallColorContainerSize = {
        name: "1435ao5",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);top:var(--ds-space-negative-025, -2px)"
    };
    const $609735830782207d$var$defaultColorContainerSize = {
        name: "1uafl10",
        styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px)"
    };
    const $609735830782207d$var$colorCardButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':hover': {
            borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
        },
        ':not(:focus):hover, :focus': {
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
            outline: 'none'
        }
    });
    const $609735830782207d$var$colorCardButtonFocusedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
        outline: 'none'
    });
    const $609735830782207d$var$colorCardWrapperStyles = {
        name: "10qlvma",
        styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
    };
    const $609735830782207d$var$colorCardContentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$4b16f52932fda51)})`}`
    });
    const $609735830782207d$var$smallColorCardContentSize = {
        name: "1rrhp72",
        styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
    };
    const $609735830782207d$var$defaultColorCardContentSize = {
        name: "ljflj6",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
    };
});
parcelRegister("jKrb6", function(module, exports) {
    $parcel$export(module.exports, "MenuList", ()=>$b794a85d007e2dce$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "Option", ()=>$b794a85d007e2dce$export$36d18380658d5d20);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$b794a85d007e2dce$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "Placeholder", ()=>$b794a85d007e2dce$export$84712d0562a614b8);
    var $l0sd0 = parcelRequire("l0sd0");
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    var $koVbs;
    var $7oXeG = parcelRequire("7oXeG");
    function $b794a85d007e2dce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b794a85d007e2dce$export$d4c4e98c5044dc8 = (props)=>{
        const { selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b794a85d007e2dce$var$colorPaletteContainerStyles,
            role: "listbox",
            "aria-label": formatMessage((0, $7oXeG.default).menuListAriaLabel),
            style: {
                maxWidth: cols ? (0, $5dAp2.getWidth)(cols) : undefined
            },
            ref: innerRef
        }, children);
    };
    const $b794a85d007e2dce$export$36d18380658d5d20 = (props)=>{
        const { data: { value: value, label: label }, selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b794a85d007e2dce$var$colorCardWrapperStyles,
            ...innerProps,
            "aria-label": label
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $l0sd0.default), {
            type: (0, $8fa07a9626e5ffeb$export$9fea11a016bc5bcf),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            focused: isFocused,
            selected: isSelected,
            onKeyDown: (value)=>onOptionKeyDown(value),
            isTabbing: isTabbing
        }));
    };
    const $b794a85d007e2dce$export$ec98719d3db7f2e4 = ()=>null;
    const $b794a85d007e2dce$export$84712d0562a614b8 = ()=>null;
    const $b794a85d007e2dce$var$colorCardWrapperStyles = {
        name: "yotnll",
        styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
    };
    const $b794a85d007e2dce$var$colorPaletteContainerStyles = {
        name: "4t056h",
        styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
    };
});
parcelRegister("l0sd0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d681a23420d49946$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eJbwP;
    var $3bDjY;
    var $f8Sb3;
    var $bWn3s;
    function $d681a23420d49946$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d681a23420d49946$var$ColorCard = (0, $5uXOq.forwardRef)((props, componentRef)=>{
        const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $829f609a65d26a98$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown } = props;
        const ref = (0, $5uXOq.useRef)(null);
        const isInitialFocus = (0, $5uXOq.useRef)(true);
        const isColorPaletteMenu = type === (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963);
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            if (onClick) {
                event.preventDefault();
                onClick(event, value);
            }
        }, [
            onClick,
            value
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && onClick && (event.key === (0, $8fa07a9626e5ffeb$export$8152f929a25a0ff4) || event.key === (0, $8fa07a9626e5ffeb$export$e51a3576c045c8d5))) {
                event.preventDefault();
                if (isTabbing) event.stopPropagation();
                onClick(event, value);
            }
            if (isColorPaletteMenu) onKeyDown?.(event);
            else if (event.key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) {
                event.preventDefault();
                event.stopPropagation();
            }
        }, [
            isColorPaletteMenu,
            isTabbing,
            value,
            onClick,
            onKeyDown
        ]);
        (0, $5uXOq.useImperativeHandle)(componentRef, ()=>({
                focus: ()=>{
                    if (isColorPaletteMenu) {
                        if (isInitialFocus.current) {
                            autoFocus && !initialFocusRef && ref.current?.focus();
                            isInitialFocus.current = false;
                        } else ref.current?.focus();
                    }
                }
            }), [
            autoFocus,
            isColorPaletteMenu,
            initialFocusRef
        ]);
        const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
        const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
        const ariaChecked = isColorPaletteMenu ? selected : undefined;
        const ariaLabel = isColorPaletteMenu ? label : undefined;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (tooltipProps)=>{
            delete tooltipProps['aria-describedby'];
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...tooltipProps,
                ref: initialFocusRef ? (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    ref,
                    tooltipProps.ref,
                    initialFocusRef
                ]) : (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    ref,
                    tooltipProps.ref
                ]),
                role: role,
                tabIndex: selected ? 0 : -1,
                "aria-checked": ariaChecked,
                "aria-label": ariaLabel,
                css: [
                    $d681a23420d49946$var$sharedColorContainerStyles,
                    (isColorPaletteMenu || isTabbing === undefined || isTabbing) && $d681a23420d49946$var$colorCardOptionTabbingStyles,
                    focused && (isColorPaletteMenu || !isTabbing) && $d681a23420d49946$var$colorCardOptionFocusedStyles
                ],
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onKeyDown: handleKeyDown
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $d681a23420d49946$var$colorCardWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $d681a23420d49946$var$colorCardContentStyles,
                style: {
                    background: value || 'transparent'
                }
            }, selected && (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eJbwP"))))), {
                color: checkMarkColor,
                label: "",
                spacing: "spacious",
                LEGACY_margin: "1px"
            }))));
        });
    });
    var $d681a23420d49946$export$2e2bcd8739ae039 = $d681a23420d49946$var$ColorCard;
    const $d681a23420d49946$var$colorCardOptionTabbingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':hover, :focus': {
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`
        }
    });
    const $d681a23420d49946$var$colorCardOptionFocusedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`
    });
    const $d681a23420d49946$var$sharedColorContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        position: 'relative',
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)",
        border: '2px solid transparent',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-border-radius-200, 6px)",
        transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        padding: "var(--ds-space-0, 0px)",
        cursor: 'pointer',
        outline: 'none'
    });
    const $d681a23420d49946$var$colorCardWrapperStyles = {
        name: "10qlvma",
        styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
    };
    const $d681a23420d49946$var$colorCardContentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$4b16f52932fda51)})`}`
    });
});
parcelRegister("eJbwP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));
    var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
    function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>$ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
        }, props));
    $ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;
});
parcelRegister("4DXCl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $36190cbd288fec69$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36190cbd288fec69$var$EditorDoneIcon = (props)=>$36190cbd288fec69$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $36190cbd288fec69$var$_checkMark.default
        }));
    $36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;
});
const $8fa07a9626e5ffeb$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $8fa07a9626e5ffeb$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac = 32;
const $8fa07a9626e5ffeb$export$e51a3576c045c8d5 = ' ';
const $8fa07a9626e5ffeb$export$8152f929a25a0ff4 = 'Enter';
const $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $8fa07a9626e5ffeb$export$1734a06b2397c2a8 = 'ArrowDown';
const $8fa07a9626e5ffeb$export$842fd6cf65a6b80c = 'ArrowLeft';
const $8fa07a9626e5ffeb$export$695331c89a36efd6 = 'ArrowRight';
const $8fa07a9626e5ffeb$export$10f6869ed0a7d75b = 'Tab';
const $8fa07a9626e5ffeb$export$929c2026f4dd54a2 = 'Escape';
parcelRegister("bWn3s", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$8b16fea90e636ddb$export$c9058316764c140e);
    var $dv0OY;
    var $3XwZB;
    function $8b16fea90e636ddb$export$c9058316764c140e(refs) {
        return (0, (0, parcelRequire("3XwZB")).createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, (0, parcelRequire("dv0OY")).assignRef)(ref, newValue)));
    }
});
parcelRegister("3XwZB", function(module, exports) {
    $parcel$export(module.exports, "createCallbackRef", ()=>$2e2079715de82b22$export$35a19128eb4acba4);
    function $2e2079715de82b22$export$35a19128eb4acba4(callback) {
        let current = null;
        return {
            get current () {
                return current;
            },
            set current (value){
                const last = current;
                if (last !== value) {
                    current = value;
                    callback(value, last);
                }
            }
        };
    }
});
parcelRegister("5dAp2", function(module, exports) {
    $parcel$export(module.exports, "getWidth", ()=>$38874a93fb14a10d$export$3c49c185de0c2bfc);
    $parcel$export(module.exports, "getOptions", ()=>$38874a93fb14a10d$export$d2312e68e1f5ad00);
    var $k5uoT;
    var $8QpSo;
    var $kD00A = parcelRequire("kD00A");
    const $38874a93fb14a10d$export$3c49c185de0c2bfc = (cols, mode)=>{
        const width = cols * ((0, $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac) + (0, (0, parcelRequire("k5uoT")).gridSize)() / 2);
        return mode === (0, $kD00A.Mode).Standard ? width + (0, (0, parcelRequire("k5uoT")).gridSize)() : width;
    };
    const $38874a93fb14a10d$export$d2312e68e1f5ad00 = (0, (0, parcelRequire("8QpSo")).default)((palette, selectedColor, showDefaultSwatchColor)=>{
        let focusedItemIndex = 0;
        let defaultSelectedColor = palette[0];
        if (!showDefaultSwatchColor) defaultSelectedColor = {
            label: '',
            value: ''
        };
        const value = palette.find((color, index)=>{
            if (color.value === selectedColor) {
                focusedItemIndex = index;
                return true;
            }
            return false;
        }) || defaultSelectedColor;
        return {
            options: palette,
            value: value,
            focusedItemIndex: focusedItemIndex
        };
    });
});
parcelRegister("kD00A", function(module, exports) {
    $parcel$export(module.exports, "Mode", ()=>$e25de60b37efd75a$export$9484bbecc3c49a2e);
    var $e25de60b37efd75a$export$9484bbecc3c49a2e;
    (function(Mode) {
        Mode[Mode["Compact"] = 0] = "Compact";
        Mode[Mode["Standard"] = 1] = "Standard";
    })($e25de60b37efd75a$export$9484bbecc3c49a2e || ($e25de60b37efd75a$export$9484bbecc3c49a2e = {}));
});
parcelRegister("7oXeG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d42a6da5a6d06680$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d42a6da5a6d06680$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        colorPickerAriaLabel: {
            id: 'jira.color-picker.src.color-picker-aria-label',
            defaultMessage: '{color} selected, {message}',
            description: 'This text is used as aria-label text in color picker component'
        },
        menuListAriaLabel: {
            id: 'jira.color-picker.src.menu-list-aria-label',
            defaultMessage: 'Color picker list',
            description: 'This text is used as aria-label text for the listbox element in color picker component'
        }
    });
});
parcelRegister("lGTQx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5e30770a4da4328$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kD00A = parcelRequire("kD00A");
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $l0sd0 = parcelRequire("l0sd0");
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    function $c5e30770a4da4328$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c5e30770a4da4328$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $kD00A.Mode).Standard, initialFocusRef: initialFocusRef })=>{
        const { options: options, value: selectedValue } = (0, $5dAp2.getOptions)(palette, selectedColor);
        const fullLabel = `${label}, ${selectedValue.label} selected`;
        const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
        const [focusedIndex, setFocusedIndex] = (0, $5uXOq.useState)(selectedColorIndex);
        const createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
        const changeAnalyticsCaller = ()=>{
            if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-palette-menu',
                attributes: {
                    componentName: 'color-picker',
                    packageName: "platform-pkg",
                    packageVersion: "0.0.0-use.local"
                }
            })(createAnalyticsEvent);
            return undefined;
        };
        const colorCardRefs = (0, $5uXOq.useMemo)(()=>[], []);
        const handleChange = (event, value)=>{
            onChange(event, value, changeAnalyticsCaller());
        };
        (0, $5uXOq.useEffect)(()=>{
            colorCardRefs[focusedIndex]?.focus();
        }, [
            focusedIndex,
            colorCardRefs
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const numItems = options.length;
            switch(event.key){
                case 0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8:
                case 0, $8fa07a9626e5ffeb$export$695331c89a36efd6:
                    setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                    break;
                case 0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2:
                case 0, $8fa07a9626e5ffeb$export$842fd6cf65a6b80c:
                    setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                    break;
                case 0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b:
                    if (isFocusLockEnabled) {
                        event.preventDefault();
                        event.stopPropagation();
                        setFocusedIndex(selectedColorIndex);
                    }
                    break;
                default:
                    break;
            }
        }, [
            isFocusLockEnabled,
            selectedColorIndex,
            setFocusedIndex,
            options
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-label": fullLabel,
            role: isInsideMenu ? 'menu' : 'radiogroup',
            css: [
                $c5e30770a4da4328$var$colorPaletteMenuStyles,
                mode === (0, $kD00A.Mode).Standard && $c5e30770a4da4328$var$colorPaletteMenuStandardStyles
            ],
            style: {
                width: `${(0, $5dAp2.getWidth)(cols, mode)}px`
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $c5e30770a4da4328$var$colorPaletteContainerStyles,
                mode === (0, $kD00A.Mode).Compact && $c5e30770a4da4328$var$colorPaletteContainerCompactStyles
            ]
        }, options.map(({ label: label, value: value }, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $c5e30770a4da4328$var$colorCardWrapperStyles,
                key: value
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $l0sd0.default), {
                type: (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963),
                label: label,
                value: value,
                checkMarkColor: checkMarkColor,
                isOption: true,
                selected: value === selectedValue.value,
                onClick: handleChange,
                ref: (ref)=>{
                    colorCardRefs[index] = ref;
                },
                autoFocus: autoFocus,
                initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
                isInsideMenu: isInsideMenu,
                onKeyDown: handleKeyDown
            })))));
    };
    var $c5e30770a4da4328$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'color-picker',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    })((0, (0, parcelRequire("cb25w")).default)()($c5e30770a4da4328$export$4bbfe93c6a14e8e6));
    const $c5e30770a4da4328$var$colorCardWrapperStyles = {
        name: "yotnll",
        styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
    };
    const $c5e30770a4da4328$var$colorPaletteContainerStyles = {
        name: "4t056h",
        styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
    };
    const $c5e30770a4da4328$var$colorPaletteContainerCompactStyles = {
        name: "h6te2n",
        styles: "padding:var(--ds-space-0, 0)"
    };
    const $c5e30770a4da4328$var$colorPaletteMenuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        position: 'relative',
        margin: "var(--ds-space-0, 0)",
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    });
    const $c5e30770a4da4328$var$colorPaletteMenuStandardStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)}, 0 0 8px ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)}`})`
    });
});
parcelRegister("3AWz7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fa4fd61ab294669$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2fa4fd61ab294669$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        triggerButtonLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.trigger-button-label",
            "defaultMessage": "View settings"
        },
        clearAllColours: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.clear-all-colours",
            "defaultMessage": "Clear all colors"
        },
        clearAllGroups: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.clear-all-groups",
            "defaultMessage": "Clear all groups"
        },
        showSprintsOnTimeline: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.show-sprints-on-timeline",
            "defaultMessage": "Show capacity on timeline"
        },
        onlyAvailableForTeamOrSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.only-available-for-team-or-sprint",
            "defaultMessage": "Only available when grouping by team or sprint"
        },
        rollupLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-label",
            "defaultMessage": "Roll-up"
        },
        dependencySettingsLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings-label",
            "defaultMessage": "Dependency style"
        },
        allOtherIssuesButtonLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.all-other-issues-button-label",
            "defaultMessage": "Gray"
        }
    });
});
parcelRegister("1IIyY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ca23f03e8bde4e3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2ca23f03e8bde4e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        findComponent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.find-component",
            "defaultMessage": "Choose component"
        },
        selectComponentLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.select-component-label",
            "defaultMessage": "Select component"
        },
        chooseColour: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.choose-colour",
            "defaultMessage": "Choose color"
        },
        selectColour: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.select-colour",
            "defaultMessage": "Select color"
        },
        addComponent: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.add-component",
            "defaultMessage": "Add color"
        },
        chooseLabelColorAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.choose-label-color-aria-label",
            "defaultMessage": "Choose a label color"
        },
        editLabelColorAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.edit-label-color-aria-label",
            "defaultMessage": "Edit label color"
        }
    });
});
parcelRegister("24w68", function(module, exports) {
    $parcel$export(module.exports, "addLabel", ()=>$1824da7ef3526d53$export$7382a268046a9fb1, (v)=>$1824da7ef3526d53$export$7382a268046a9fb1 = v);
    $parcel$export(module.exports, "addLabelButton", ()=>$1824da7ef3526d53$export$2e19006997105e3f, (v)=>$1824da7ef3526d53$export$2e19006997105e3f = v);
    $parcel$export(module.exports, "allOtherIssues", ()=>$1824da7ef3526d53$export$5cfe825620032318, (v)=>$1824da7ef3526d53$export$5cfe825620032318 = v);
    $parcel$export(module.exports, "allOtherIssuesButton", ()=>$1824da7ef3526d53$export$dc5d9523e11716f6, (v)=>$1824da7ef3526d53$export$dc5d9523e11716f6 = v);
    $parcel$export(module.exports, "componentSelect", ()=>$1824da7ef3526d53$export$30ae6ac4023c3a21, (v)=>$1824da7ef3526d53$export$30ae6ac4023c3a21 = v);
    $parcel$export(module.exports, "list", ()=>$1824da7ef3526d53$export$8837f4fc672e936d, (v)=>$1824da7ef3526d53$export$8837f4fc672e936d = v);
    $parcel$export(module.exports, "row", ()=>$1824da7ef3526d53$export$120ff0929b202a6d, (v)=>$1824da7ef3526d53$export$120ff0929b202a6d = v);
    $parcel$export(module.exports, "swatch", ()=>$1824da7ef3526d53$export$c672d9950c40fe0a, (v)=>$1824da7ef3526d53$export$c672d9950c40fe0a = v);
    var $1824da7ef3526d53$export$7382a268046a9fb1;
    var $1824da7ef3526d53$export$2e19006997105e3f;
    var $1824da7ef3526d53$export$5cfe825620032318;
    var $1824da7ef3526d53$export$dc5d9523e11716f6;
    var $1824da7ef3526d53$export$30ae6ac4023c3a21;
    var $1824da7ef3526d53$export$8837f4fc672e936d;
    var $1824da7ef3526d53$export$120ff0929b202a6d;
    var $1824da7ef3526d53$export$c672d9950c40fe0a;
    $1824da7ef3526d53$export$7382a268046a9fb1 = `fVtzqW_addLabel`;
    $1824da7ef3526d53$export$2e19006997105e3f = `fVtzqW_addLabelButton`;
    $1824da7ef3526d53$export$5cfe825620032318 = `fVtzqW_allOtherIssues`;
    $1824da7ef3526d53$export$dc5d9523e11716f6 = `fVtzqW_allOtherIssuesButton`;
    $1824da7ef3526d53$export$30ae6ac4023c3a21 = `fVtzqW_componentSelect`;
    $1824da7ef3526d53$export$8837f4fc672e936d = `fVtzqW_list`;
    $1824da7ef3526d53$export$120ff0929b202a6d = `fVtzqW_row`;
    $1824da7ef3526d53$export$c672d9950c40fe0a = `fVtzqW_swatch`;
});
parcelRegister("8t5Q5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4a86a0114a896cd$export$2e2bcd8739ae039);
    var $bC2fB;
    var $1LHb3 = parcelRequire("1LHb3");
    var $9lvUW = parcelRequire("9lvUW");
    var $kfszw = parcelRequire("kfszw");
    var $b4a86a0114a896cd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $9lvUW.default), (0, $1LHb3.default))((0, $kfszw.default));
});
parcelRegister("1LHb3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b9162e8779b85cc$export$2e2bcd8739ae039);
    var $clsih = parcelRequire("clsih");
    const $4b9162e8779b85cc$var$mapDispatchToProps = (dispatch)=>({
            addIssueTypeColour: ()=>{
                dispatch((0, $clsih.addIssueTypeColour)());
            },
            removeIssueTypeColour: (payload)=>{
                dispatch((0, $clsih.removeIssueTypeColour)(payload));
            },
            updateIssueTypeColour: (payload)=>{
                dispatch((0, $clsih.updateIssueTypeColour)(payload));
            }
        });
    var $4b9162e8779b85cc$export$2e2bcd8739ae039 = $4b9162e8779b85cc$var$mapDispatchToProps;
});
parcelRegister("9lvUW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae4ca07669ad84e5$export$2e2bcd8739ae039);
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $j0XCX = parcelRequire("j0XCX");
    const $ae4ca07669ad84e5$var$mapStateToProps = (state)=>({
            colourIssueTypes: (0, $j0XCX.getColourIssueTypes)(state),
            issueTypeIds: (0, $kllqP.getIssueTypeIds)(state),
            issueTypeIdsOfCompanyManagedProjects: (0, $kllqP.getIssueTypeIdsOfCompanyManagedProjects)(state),
            issueTypesById: (0, $kllqP.getIssueTypesById)(state),
            issueTypesByName: (0, $kllqP.getIssueTypesByName)(state),
            projectsById: (0, $jpXKt.getProjectsById)(state),
            teamManagedProjectByIssueTypeId: (0, $kllqP.getTeamManagedProjectByIssueTypeId)(state),
            teamManagedProjectsSortedByName: (0, $jpXKt.getTeamManagedProjectsSortedByName)(state),
            issueTypeIconByName: (0, $kllqP.getIssueTypeIconByName)(state)
        });
    var $ae4ca07669ad84e5$export$2e2bcd8739ae039 = $ae4ca07669ad84e5$var$mapStateToProps;
});
parcelRegister("kfszw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ed54112e17a3798$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $hGgHi = parcelRequire("hGgHi");
    var $kGsr8 = parcelRequire("kGsr8");
    var $ujWmd;
    var $9lMrf;
    var $cgL5K;
    var $3bDjY;
    var $koVbs;
    var $aCpcO;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $4Ai8V = parcelRequire("4Ai8V");
    var $gITL8 = parcelRequire("gITL8");
    var $ihPUd = parcelRequire("ihPUd");
    var $3AWz7 = parcelRequire("3AWz7");
    var $2Q3fF = parcelRequire("2Q3fF");
    var $f5DFW = parcelRequire("f5DFW");
    var $aSmtb = parcelRequire("aSmtb");
    function $9ed54112e17a3798$export$d154e1e62b02b1c7(props) {
        const { colourIssueTypes: colourIssueTypes, issueTypesById: issueTypesById, issueTypeIdsOfCompanyManagedProjects: issueTypeIdsOfCompanyManagedProjects, teamManagedProjectsSortedByName: teamManagedProjectsSortedByName, onMenuToggle: onMenuToggle, removeIssueTypeColour: removeIssueTypeColour, updateIssueTypeColour: updateIssueTypeColour, issueTypesByName: issueTypesByName, addIssueTypeColour: addIssueTypeColour, issueTypeIds: issueTypeIds, projectsById: projectsById, teamManagedProjectByIssueTypeId: teamManagedProjectByIssueTypeId, issueTypeIconByName: issueTypeIconByName } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const sortOptionsByLabel = (options)=>options.map((issueTypeId)=>({
                    label: issueTypesById[issueTypeId].name,
                    value: issueTypeId
                })).sort((a, b)=>a.label.localeCompare(b.label));
        const getIssueTypesValues = (issueTypeIds)=>issueTypeIds.reduce((acc, issueTypeId)=>{
                if (issueTypesById[issueTypeId]?.name) acc.push({
                    label: issueTypesById[issueTypeId].name,
                    value: issueTypeId
                });
                return acc;
            }, []);
        const getIssueTypesOptions = (availableIssueTypeIds)=>{
            if (teamManagedProjectsSortedByName.length) {
                const allIssueTypeNameOptions = {
                    label: undefined,
                    options: (0, $aSmtb.getIssueTypeNamesWithMoreThanOneOccurrence)(Array.from(availableIssueTypeIds), issueTypesById).sort((name, otherName)=>name.localeCompare(otherName)).map((name)=>({
                            label: formatMessage((0, $2Q3fF.default).allIssueTypesOption, {
                                issueTypeName: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                                    as: "strong"
                                }, name)
                            }),
                            value: name
                        }))
                };
                const issueTypesOptions = teamManagedProjectsSortedByName.reduce((acc, project)=>{
                    const availableProjectIssueTypeIds = project.issueTypeIds.filter((issueTypeId)=>availableIssueTypeIds.has(issueTypeId));
                    if (availableProjectIssueTypeIds.length) acc.push({
                        label: project.id,
                        options: sortOptionsByLabel(availableProjectIssueTypeIds)
                    });
                    return acc;
                }, []);
                if (issueTypeIdsOfCompanyManagedProjects.length) {
                    const availableProjectIssueTypeIds = issueTypeIdsOfCompanyManagedProjects.filter((issueTypeId)=>availableIssueTypeIds.has(issueTypeId));
                    issueTypesOptions.unshift({
                        label: formatMessage((0, $2Q3fF.default).companyManagedProjectsLabel),
                        options: sortOptionsByLabel(availableProjectIssueTypeIds)
                    });
                }
                issueTypesOptions.unshift(allIssueTypeNameOptions);
                return issueTypesOptions;
            }
            const availableProjectIssueTypeIds = issueTypeIdsOfCompanyManagedProjects.filter((issueTypeId)=>availableIssueTypeIds.has(issueTypeId));
            return sortOptionsByLabel(availableProjectIssueTypeIds);
        };
        const onIssueTypesChange = (index, options)=>{
            if ((0, ($parcel$interopDefault($hGgHi)))(options) || (0, ($parcel$interopDefault($gccSB)))(options)) removeIssueTypeColour({
                index: index
            });
            else {
                const issueTypeIds = [];
                if (Array.isArray(options)) {
                    options.forEach(({ value: value })=>{
                        if (typeof value === 'number') issueTypeIds.push(value);
                        else if (typeof value === 'string') (issueTypesByName[value] ?? []).forEach(({ id: id })=>issueTypeIds.push(id));
                    });
                    updateIssueTypeColour({
                        index: index,
                        issueTypes: (0, ($parcel$interopDefault($kGsr8)))(issueTypeIds)
                    });
                }
            }
        };
        const onColourChange = (index)=>(colour)=>{
                if ((0, $4nDwW.isDefined)(colour)) updateIssueTypeColour({
                    index: index,
                    colour: colour
                });
                else removeIssueTypeColour({
                    index: index
                });
            };
        const formatIssueTypeGroupLabel = (option)=>{
            if (projectsById[option.label]) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $f5DFW.projectHeading
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                appearance: "square",
                size: "xsmall",
                src: projectsById[option.label]?.avatarUrl
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $f5DFW.projectName
            }, projectsById[option.label].name)));
            return option.label;
        };
        const formatIssueTypeOptionLabel = (option, { context: context })=>{
            const iconUrl = typeof option.value === 'string' ? `url(${issueTypeIconByName[option.value]})` : `url(${issueTypesById[option.value]?.iconUrl})`;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $f5DFW.issueTypeOption
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    backgroundImage: iconUrl
                },
                className: $f5DFW.issueTypeOptionIcon
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, context === 'value' && teamManagedProjectByIssueTypeId[option.value]?.key ? `${option.label} (${teamManagedProjectByIssueTypeId[option.value].key})` : option.label)));
        };
        const availableIssueTypeIds = (0, $5uXOq.useMemo)(()=>{
            const usedIssueTypeIds = new Set((0, $4nDwW.chain)((x)=>x.issueTypes, colourIssueTypes));
            return new Set(issueTypeIds.filter((issueTypeId)=>!usedIssueTypeIds.has(issueTypeId)));
        }, [
            colourIssueTypes,
            issueTypeIds
        ]);
        const renderRow = (colourIssueType, index)=>{
            const { colour: colour, issueTypes: issueTypes = [] } = colourIssueType;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: `${index}-${colour || ''}`,
                className: $f5DFW.row
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4Ai8V.default), {
                colour: colour,
                onColourChange: onColourChange(index),
                position: "left"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $f5DFW.issueTypeSelect
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                "aria-label": formatMessage((0, $4nDwW.isDefined)(colour) ? (0, $2Q3fF.default).selectIssueType : (0, $2Q3fF.default).selectColour),
                classNamePrefix: `portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by-issue-type_select-issue-type-${index}`,
                closeMenuOnSelect: false,
                defaultValue: getIssueTypesValues(issueTypes),
                formatGroupLabel: formatIssueTypeGroupLabel,
                formatOptionLabel: formatIssueTypeOptionLabel,
                isDisabled: !colour,
                isMulti: true,
                menuPlacement: "auto",
                menuPortalTarget: (0, $4y9A5.getBody)(),
                onChange: (options)=>onIssueTypesChange(index, options),
                onMenuClose: ()=>onMenuToggle(false),
                onMenuOpen: ()=>onMenuToggle(true),
                options: getIssueTypesOptions(availableIssueTypeIds),
                placeholder: formatMessage((0, $4nDwW.isDefined)(colour) ? (0, $2Q3fF.default).chooseIssueType : (0, $2Q3fF.default).chooseColour),
                styles: {
                    menuPortal: (styles)=>({
                            ...styles,
                            zIndex: 1000
                        })
                },
                inputId: "portfolio-3.simple-plans_main_tabs_roadmap.view-settings.selectIssueType"
            }))));
        };
        const renderAddColourLink = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $f5DFW.addColourLink
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                appearance: "link",
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                    label: formatMessage((0, $2Q3fF.default).addColour)
                }),
                onClick: ()=>addIssueTypeColour(),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.add-color-link"
            }, formatMessage((0, $2Q3fF.default).addColour)));
        const isAddingNewIssueTypeColour = colourIssueTypes.some(({ colour: colour })=>!colour);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $f5DFW.list
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $f5DFW.row
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            className: $f5DFW.allOtherIssuesButton,
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage((0, $gITL8.colourPickerPaletteLabels)[0, $gITL8.DEFAULT_COLOR]),
                position: "top"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $f5DFW.swatch,
                style: {
                    backgroundColor: (0, $gITL8.DEFAULT_COLOR)
                }
            })),
            isDisabled: true,
            ariaLabel: formatMessage((0, $3AWz7.default).allOtherIssuesButtonLabel)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $f5DFW.allOtherIssues
        }, formatMessage((0, $ihPUd.default).allOtherIssues))), colourIssueTypes.map(renderRow), !isAddingNewIssueTypeColour && renderAddColourLink()));
    }
    var $9ed54112e17a3798$export$2e2bcd8739ae039 = $9ed54112e17a3798$export$d154e1e62b02b1c7;
});
parcelRegister("2Q3fF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65f4b99d2c94e3e8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $65f4b99d2c94e3e8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addColour: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.add-colour",
            "defaultMessage": "Add color"
        },
        chooseColour: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.choose-colour",
            "defaultMessage": "Choose color"
        },
        selectColour: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.select-colour",
            "defaultMessage": "Select color"
        },
        chooseIssueType: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.choose-issue-type",
            "defaultMessage": "Choose issue type"
        },
        selectIssueType: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.select-issue-type",
            "defaultMessage": "Select issue type"
        },
        companyManagedProjectsLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.company-managed-projects-label",
            "defaultMessage": "Company-managed projects"
        },
        allIssueTypesOption: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.all-issue-types-option",
            "defaultMessage": "All {issueTypeName} issue types"
        }
    });
});
parcelRegister("f5DFW", function(module, exports) {
    $parcel$export(module.exports, "addColourLink", ()=>$afc6196348465ed7$export$f627f0c01f3c5e2e, (v)=>$afc6196348465ed7$export$f627f0c01f3c5e2e = v);
    $parcel$export(module.exports, "allOtherIssues", ()=>$afc6196348465ed7$export$5cfe825620032318, (v)=>$afc6196348465ed7$export$5cfe825620032318 = v);
    $parcel$export(module.exports, "allOtherIssuesButton", ()=>$afc6196348465ed7$export$dc5d9523e11716f6, (v)=>$afc6196348465ed7$export$dc5d9523e11716f6 = v);
    $parcel$export(module.exports, "issueTypeOption", ()=>$afc6196348465ed7$export$9e44a4a997031111, (v)=>$afc6196348465ed7$export$9e44a4a997031111 = v);
    $parcel$export(module.exports, "issueTypeOptionIcon", ()=>$afc6196348465ed7$export$a7a1cf00f122df53, (v)=>$afc6196348465ed7$export$a7a1cf00f122df53 = v);
    $parcel$export(module.exports, "issueTypeSelect", ()=>$afc6196348465ed7$export$d3fef5ce4a91e9ce, (v)=>$afc6196348465ed7$export$d3fef5ce4a91e9ce = v);
    $parcel$export(module.exports, "list", ()=>$afc6196348465ed7$export$8837f4fc672e936d, (v)=>$afc6196348465ed7$export$8837f4fc672e936d = v);
    $parcel$export(module.exports, "projectHeading", ()=>$afc6196348465ed7$export$55437923f4020fe1, (v)=>$afc6196348465ed7$export$55437923f4020fe1 = v);
    $parcel$export(module.exports, "projectName", ()=>$afc6196348465ed7$export$551361c7c5b2aef8, (v)=>$afc6196348465ed7$export$551361c7c5b2aef8 = v);
    $parcel$export(module.exports, "row", ()=>$afc6196348465ed7$export$120ff0929b202a6d, (v)=>$afc6196348465ed7$export$120ff0929b202a6d = v);
    $parcel$export(module.exports, "swatch", ()=>$afc6196348465ed7$export$c672d9950c40fe0a, (v)=>$afc6196348465ed7$export$c672d9950c40fe0a = v);
    var $afc6196348465ed7$export$f627f0c01f3c5e2e;
    var $afc6196348465ed7$export$5cfe825620032318;
    var $afc6196348465ed7$export$dc5d9523e11716f6;
    var $afc6196348465ed7$export$9e44a4a997031111;
    var $afc6196348465ed7$export$a7a1cf00f122df53;
    var $afc6196348465ed7$export$d3fef5ce4a91e9ce;
    var $afc6196348465ed7$export$8837f4fc672e936d;
    var $afc6196348465ed7$export$55437923f4020fe1;
    var $afc6196348465ed7$export$551361c7c5b2aef8;
    var $afc6196348465ed7$export$120ff0929b202a6d;
    var $afc6196348465ed7$export$c672d9950c40fe0a;
    $afc6196348465ed7$export$f627f0c01f3c5e2e = `Xirf0q_addColourLink`;
    $afc6196348465ed7$export$5cfe825620032318 = `Xirf0q_allOtherIssues`;
    $afc6196348465ed7$export$dc5d9523e11716f6 = `Xirf0q_allOtherIssuesButton`;
    $afc6196348465ed7$export$9e44a4a997031111 = `Xirf0q_issueTypeOption`;
    $afc6196348465ed7$export$a7a1cf00f122df53 = `Xirf0q_issueTypeOptionIcon`;
    $afc6196348465ed7$export$d3fef5ce4a91e9ce = `Xirf0q_issueTypeSelect`;
    $afc6196348465ed7$export$8837f4fc672e936d = `Xirf0q_list`;
    $afc6196348465ed7$export$55437923f4020fe1 = `Xirf0q_projectHeading`;
    $afc6196348465ed7$export$551361c7c5b2aef8 = `Xirf0q_projectName`;
    $afc6196348465ed7$export$120ff0929b202a6d = `Xirf0q_row`;
    $afc6196348465ed7$export$c672d9950c40fe0a = `Xirf0q_swatch`;
});
parcelRegister("aSmtb", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypeNamesWithMoreThanOneOccurrence", ()=>$675509b2a881a770$export$b955839f34ef1f6);
    const $675509b2a881a770$export$b955839f34ef1f6 = (issueTypeIds, issueTypesById)=>{
        const issueTypeNameCounter = {};
        const namesWithMoreThanOneOccurrence = [];
        issueTypeIds.forEach((issueTypeId)=>{
            const issueType = issueTypesById[issueTypeId];
            if (issueType !== undefined) {
                const count = issueTypeNameCounter[issueType.name];
                if (count === undefined) issueTypeNameCounter[issueType.name] = 1;
                else if (count === 1) {
                    issueTypeNameCounter[issueType.name] = 2;
                    namesWithMoreThanOneOccurrence.push(issueType.name);
                }
            }
        });
        return namesWithMoreThanOneOccurrence;
    };
});
parcelRegister("1Lwa3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5eb7780ca462a50c$export$2e2bcd8739ae039);
    var $abnJk = parcelRequire("abnJk");
    var $kWDpn = parcelRequire("kWDpn");
    var $clsih = parcelRequire("clsih");
    var $bC2fB;
    var $05dPY = parcelRequire("05dPY");
    const $5eb7780ca462a50c$var$mapStateToProps = (state)=>({
            colourByConfiguration: (0, $kWDpn.getColorByViewSettings)(state),
            issueLabels: (0, $abnJk.getIssueLabels)(state)
        });
    const $5eb7780ca462a50c$var$mapDispatchToProps = (dispatch)=>({
            addLabelColour: ()=>{
                dispatch((0, $clsih.addLabelColour)());
            },
            updateLabelColour: (payload)=>{
                dispatch((0, $clsih.updateLabelColour)(payload));
            },
            removeLabelColour: (payload)=>{
                dispatch((0, $clsih.removeLabelColour)(payload));
            }
        });
    var $5eb7780ca462a50c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($5eb7780ca462a50c$var$mapStateToProps, $5eb7780ca462a50c$var$mapDispatchToProps)((0, $05dPY.default));
});
parcelRegister("05dPY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73ef02761ca55e26$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $lV634;
    var $9lMrf;
    var $3bDjY;
    var $ousew;
    var $8RXs9;
    var $aCpcO;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $4Ai8V = parcelRequire("4Ai8V");
    var $gITL8 = parcelRequire("gITL8");
    var $ihPUd = parcelRequire("ihPUd");
    var $3AWz7 = parcelRequire("3AWz7");
    var $fwcY4 = parcelRequire("fwcY4");
    var $fp1c4 = parcelRequire("fp1c4");
    const $73ef02761ca55e26$var$labelsToOptions = (labels)=>labels.map((label)=>({
                value: label,
                label: label
            }));
    const $73ef02761ca55e26$var$optionsToLabels = (options)=>options.map((x)=>x.value);
    class $73ef02761ca55e26$export$7029547aac054d9e extends (0, $5uXOq.Component) {
        render() {
            const { colourByConfiguration: { colourLabels: colourLabels }, intl: intl } = this.props;
            const isAddingNewLabelColour = colourLabels.some(({ colour: colour })=>!colour);
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fp1c4.list
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fp1c4.row
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                className: $fp1c4.allOtherIssuesButton,
                isDisabled: true,
                iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: intl.formatMessage((0, $gITL8.colourPickerPaletteLabels)[0, $gITL8.DEFAULT_COLOR]),
                    position: "top"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $fp1c4.swatch,
                    style: {
                        backgroundColor: (0, $gITL8.DEFAULT_COLOR)
                    }
                })),
                ariaLabel: intl.formatMessage((0, $3AWz7.default).allOtherIssuesButtonLabel)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fp1c4.allOtherIssues
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).allOtherIssues))), colourLabels.map(this.renderRow), isAddingNewLabelColour ? null : this.renderAddLabel()));
        }
        constructor(...args){
            super(...args);
            this.state = {
                keySuffix: 0
            };
            this.availableLabels = ()=>{
                const { issueLabels: issueLabels, colourByConfiguration: { colourLabels: colourLabels } } = this.props;
                const usedLabels = new Set((0, $4nDwW.chain)((x)=>x.labels, colourLabels));
                return issueLabels.filter((label)=>!usedLabels.has(label));
            };
            this.onLabelsChange = (index, options)=>{
                const { updateLabelColour: updateLabelColour, removeLabelColour: removeLabelColour } = this.props;
                if ((0, parcelRequire("lV634")).default(options) || (0, parcelRequire("3nPAF")).default(options)) {
                    removeLabelColour({
                        index: index
                    });
                    this.setState((prevState)=>({
                            keySuffix: prevState.keySuffix + 1
                        }));
                } else updateLabelColour({
                    index: index,
                    labels: $73ef02761ca55e26$var$optionsToLabels(options)
                });
            };
            this.onColourChange = (index)=>(colour)=>{
                    const { updateLabelColour: updateLabelColour, removeLabelColour: removeLabelColour } = this.props;
                    if (colour) updateLabelColour({
                        index: index,
                        colour: colour
                    });
                    else removeLabelColour({
                        index: index
                    });
                };
            this.renderRow = (colourLabel, index)=>{
                const { colour: colour, labels: labels } = colourLabel;
                const issueLabels = this.availableLabels();
                const { intl: intl, onMenuToggle: onMenuToggle } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $fp1c4.row,
                    key: `${index}-${colour || ''}-${this.state.keySuffix}`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4Ai8V.default), {
                    colour: colour,
                    onColourChange: this.onColourChange(index),
                    position: "left"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $fp1c4.labelSelect
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                    "aria-label": intl.formatMessage(colour ? (0, $fwcY4.default).selectVisibleLabel : (0, $fwcY4.default).selectColour),
                    classNamePrefix: `portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by-label_select-label-${index}`,
                    defaultValue: $73ef02761ca55e26$var$labelsToOptions(labels),
                    isDisabled: !colour,
                    isMulti: true,
                    menuPlacement: "auto",
                    menuPortalTarget: (0, $4y9A5.getBody)(),
                    onChange: (options)=>this.onLabelsChange(index, options),
                    onMenuClose: ()=>{
                        onMenuToggle(false);
                    },
                    onMenuOpen: ()=>{
                        onMenuToggle(true);
                    },
                    options: $73ef02761ca55e26$var$labelsToOptions(issueLabels),
                    placeholder: intl.formatMessage(colour ? (0, $fwcY4.default).chooseLabel : (0, $fwcY4.default).chooseColour),
                    styles: {
                        menuPortal: (styles)=>({
                                ...styles,
                                zIndex: 1000
                            })
                    },
                    inputId: "portfolio-3.simple-plans_main_tabs_roadmap.view-settings.colourByLabel_select"
                }))));
            };
            this.renderAddLabel = ()=>{
                const { addLabelColour: addLabelColour } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: `${$fp1c4.addLabelButton} ${$fp1c4.row}`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                        label: ""
                    }),
                    onClick: (e)=>{
                        e.preventDefault();
                        addLabelColour();
                    },
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.add-color-link"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    className: $fp1c4.addLabel
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $fwcY4.default).addLabel)))));
            };
        }
    }
    var $73ef02761ca55e26$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($73ef02761ca55e26$export$7029547aac054d9e);
});
parcelRegister("fwcY4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d804e1f87186393$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0d804e1f87186393$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chooseLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.choose-label",
            "defaultMessage": "Choose label"
        },
        selectVisibleLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.select-visible-label",
            "defaultMessage": "Select label"
        },
        chooseColour: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.choose-colour",
            "defaultMessage": "Choose color"
        },
        selectColour: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.select-colour",
            "defaultMessage": "Select color"
        },
        addLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.add-label",
            "defaultMessage": "Add color"
        }
    });
});
parcelRegister("fp1c4", function(module, exports) {
    $parcel$export(module.exports, "addLabel", ()=>$b36a1ddda0d9378c$export$7382a268046a9fb1, (v)=>$b36a1ddda0d9378c$export$7382a268046a9fb1 = v);
    $parcel$export(module.exports, "addLabelButton", ()=>$b36a1ddda0d9378c$export$2e19006997105e3f, (v)=>$b36a1ddda0d9378c$export$2e19006997105e3f = v);
    $parcel$export(module.exports, "allOtherIssues", ()=>$b36a1ddda0d9378c$export$5cfe825620032318, (v)=>$b36a1ddda0d9378c$export$5cfe825620032318 = v);
    $parcel$export(module.exports, "allOtherIssuesButton", ()=>$b36a1ddda0d9378c$export$dc5d9523e11716f6, (v)=>$b36a1ddda0d9378c$export$dc5d9523e11716f6 = v);
    $parcel$export(module.exports, "labelSelect", ()=>$b36a1ddda0d9378c$export$519b192a392926cb, (v)=>$b36a1ddda0d9378c$export$519b192a392926cb = v);
    $parcel$export(module.exports, "list", ()=>$b36a1ddda0d9378c$export$8837f4fc672e936d, (v)=>$b36a1ddda0d9378c$export$8837f4fc672e936d = v);
    $parcel$export(module.exports, "row", ()=>$b36a1ddda0d9378c$export$120ff0929b202a6d, (v)=>$b36a1ddda0d9378c$export$120ff0929b202a6d = v);
    $parcel$export(module.exports, "swatch", ()=>$b36a1ddda0d9378c$export$c672d9950c40fe0a, (v)=>$b36a1ddda0d9378c$export$c672d9950c40fe0a = v);
    var $b36a1ddda0d9378c$export$7382a268046a9fb1;
    var $b36a1ddda0d9378c$export$2e19006997105e3f;
    var $b36a1ddda0d9378c$export$5cfe825620032318;
    var $b36a1ddda0d9378c$export$dc5d9523e11716f6;
    var $b36a1ddda0d9378c$export$519b192a392926cb;
    var $b36a1ddda0d9378c$export$8837f4fc672e936d;
    var $b36a1ddda0d9378c$export$120ff0929b202a6d;
    var $b36a1ddda0d9378c$export$c672d9950c40fe0a;
    $b36a1ddda0d9378c$export$7382a268046a9fb1 = `dYaZ6G_addLabel`;
    $b36a1ddda0d9378c$export$2e19006997105e3f = `dYaZ6G_addLabelButton`;
    $b36a1ddda0d9378c$export$5cfe825620032318 = `dYaZ6G_allOtherIssues`;
    $b36a1ddda0d9378c$export$dc5d9523e11716f6 = `dYaZ6G_allOtherIssuesButton`;
    $b36a1ddda0d9378c$export$519b192a392926cb = `dYaZ6G_labelSelect`;
    $b36a1ddda0d9378c$export$8837f4fc672e936d = `dYaZ6G_list`;
    $b36a1ddda0d9378c$export$120ff0929b202a6d = `dYaZ6G_row`;
    $b36a1ddda0d9378c$export$c672d9950c40fe0a = `dYaZ6G_swatch`;
});
parcelRegister("7d5vc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e2479c79f72127f$export$2e2bcd8739ae039);
    var $bC2fB;
    var $lA0Fw = parcelRequire("lA0Fw");
    var $dzlrY = parcelRequire("dzlrY");
    var $2zdMw = parcelRequire("2zdMw");
    var $3e2479c79f72127f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $dzlrY.default), (0, $lA0Fw.default))((0, $2zdMw.default));
});
parcelRegister("lA0Fw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a58da671eb9883b$export$2e2bcd8739ae039);
    var $clsih = parcelRequire("clsih");
    var $8a58da671eb9883b$export$2e2bcd8739ae039 = (dispatch)=>({
            addPriorityColour: ()=>{
                dispatch((0, $clsih.addPriorityColour)());
            },
            removePriorityColour: (payload)=>{
                dispatch((0, $clsih.removePriorityColour)(payload));
            },
            updatePriorityColour: (payload)=>{
                dispatch((0, $clsih.updatePriorityColour)(payload));
            }
        });
});
parcelRegister("dzlrY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db94bfd4a05c979e$export$2e2bcd8739ae039);
    var $io4Ja = parcelRequire("io4Ja");
    var $j0XCX = parcelRequire("j0XCX");
    const $db94bfd4a05c979e$var$mapStateToProps = (state)=>({
            colourPriorities: (0, $j0XCX.getColourPriorities)(state),
            issuePrioritiesIdList: (0, $io4Ja.getIssuePrioritiesIdList)(state) ?? undefined,
            prioritiesById: (0, $io4Ja.getIssuePriorities)(state)
        });
    var $db94bfd4a05c979e$export$2e2bcd8739ae039 = $db94bfd4a05c979e$var$mapStateToProps;
});
parcelRegister("2zdMw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b39733db0341f14$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $lV634;
    var $9lMrf;
    var $3bDjY;
    var $8RXs9;
    var $aCpcO;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $4Ai8V = parcelRequire("4Ai8V");
    var $gITL8 = parcelRequire("gITL8");
    var $ihPUd = parcelRequire("ihPUd");
    var $3AWz7 = parcelRequire("3AWz7");
    var $c2bsR = parcelRequire("c2bsR");
    var $9N5Mt = parcelRequire("9N5Mt");
    var $2HSRR = parcelRequire("2HSRR");
    class $9b39733db0341f14$export$189655d48e326ed1 extends (0, $5uXOq.Component) {
        render() {
            const { colourPriorities: colourPriorities, intl: { formatMessage: formatMessage } } = this.props;
            const isAddingNewPriorityColour = colourPriorities.some(({ colour: colour })=>!colour);
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $9N5Mt.list
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $9N5Mt.row
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                className: $9N5Mt.allOtherIssuesButton,
                iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage((0, $gITL8.colourPickerPaletteLabels)[0, $gITL8.DEFAULT_COLOR]),
                    position: "top"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9N5Mt.swatch,
                    style: {
                        backgroundColor: (0, $gITL8.DEFAULT_COLOR)
                    }
                })),
                isDisabled: true,
                ariaLabel: formatMessage((0, $3AWz7.default).allOtherIssuesButtonLabel)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $9N5Mt.allOtherIssues
            }, formatMessage((0, $ihPUd.default).allOtherIssues))), colourPriorities.map(this.renderRow), !isAddingNewPriorityColour && this.renderAddColourLink()));
        }
        constructor(...args){
            super(...args);
            this.onPrioritiesChange = (index, options)=>{
                const { updatePriorityColour: updatePriorityColour, removePriorityColour: removePriorityColour } = this.props;
                if ((0, parcelRequire("lV634")).default(options) || (0, parcelRequire("3nPAF")).default(options)) removePriorityColour({
                    index: index
                });
                else updatePriorityColour({
                    index: index,
                    priorities: (0, $2HSRR.getOptionsToPriorityIds)(options)
                });
            };
            this.renderPriorityOption = (option)=>{
                const priorityIcon = this.props.prioritiesById[option.value]?.iconUrl;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9N5Mt.priorityOption
                }, priorityIcon && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    style: {
                        backgroundImage: `url(${priorityIcon})`
                    },
                    className: $9N5Mt.priorityOptionIcon
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, option.label)));
            };
            this.renderRow = (colourPriority, index)=>{
                const { intl: intl, onMenuToggle: onMenuToggle, prioritiesById: prioritiesById, colourPriorities: colourPriorities, issuePrioritiesIdList: issuePrioritiesIdList, updatePriorityColour: updatePriorityColour, removePriorityColour: removePriorityColour } = this.props;
                const { colour: colour, priorities: priorities = [] } = colourPriority;
                const availablePriorities = (0, $2HSRR.getAvailablePriorities)(colourPriorities, issuePrioritiesIdList);
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    key: `${index}-${colour || ''}`,
                    "data-testid": `select-priority-wrapper-${index}`,
                    className: $9N5Mt.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4Ai8V.default), {
                    colour: colour,
                    onColourChange: (0, $2HSRR.onColourChange)(index, removePriorityColour, updatePriorityColour),
                    position: "left"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9N5Mt.prioritySelect
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                    "aria-label": intl.formatMessage((0, $c2bsR.default).choosePriority),
                    classNamePrefix: `portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by-priority_select-priority-${index}`,
                    closeMenuOnSelect: false,
                    defaultValue: (0, $2HSRR.getPriorityIdsToOptions)(priorities, prioritiesById),
                    formatOptionLabel: this.renderPriorityOption,
                    isDisabled: !colour,
                    isMulti: true,
                    menuPlacement: "auto",
                    inputId: "priority-select",
                    menuPortalTarget: (0, $4y9A5.getBody)(),
                    onChange: (options)=>this.onPrioritiesChange(index, options),
                    onMenuClose: ()=>onMenuToggle(false),
                    onMenuOpen: ()=>onMenuToggle(true),
                    options: (0, $2HSRR.getPriorityIdsToOptions)(availablePriorities, prioritiesById),
                    placeholder: intl.formatMessage((0, $4nDwW.isDefined)(colour) ? (0, $c2bsR.default).choosePriority : (0, $c2bsR.default).chooseColour),
                    styles: {
                        menuPortal: (styles)=>({
                                ...styles,
                                zIndex: 1000
                            })
                    }
                })));
            };
            this.renderAddColourLink = ()=>{
                const { addPriorityColour: addPriorityColour, intl: { formatMessage: formatMessage } } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $9N5Mt.addColourLink
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                        label: formatMessage((0, $c2bsR.default).addColour)
                    }),
                    onClick: ()=>addPriorityColour(),
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-priority.add-color-link"
                }, formatMessage((0, $c2bsR.default).addColour))));
            };
        }
    }
    var $9b39733db0341f14$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($9b39733db0341f14$export$189655d48e326ed1);
});
parcelRegister("c2bsR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3d142ec5bc80ce8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e3d142ec5bc80ce8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addColour: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-priority.add-colour",
            "defaultMessage": "Add color"
        },
        chooseColour: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-priority.choose-colour",
            "defaultMessage": "Choose color"
        },
        choosePriority: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-priority.choose-priority",
            "defaultMessage": "Choose priority"
        },
        chooseLabelColorAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-priority.choose-label-color-aria-label",
            "defaultMessage": "Choose a label color"
        },
        editLabelColorAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-priority.edit-label-color-aria-label",
            "defaultMessage": "Edit label color"
        }
    });
});
parcelRegister("9N5Mt", function(module, exports) {
    $parcel$export(module.exports, "addColourLink", ()=>$720d2ca308e39d31$export$f627f0c01f3c5e2e, (v)=>$720d2ca308e39d31$export$f627f0c01f3c5e2e = v);
    $parcel$export(module.exports, "allOtherIssues", ()=>$720d2ca308e39d31$export$5cfe825620032318, (v)=>$720d2ca308e39d31$export$5cfe825620032318 = v);
    $parcel$export(module.exports, "allOtherIssuesButton", ()=>$720d2ca308e39d31$export$dc5d9523e11716f6, (v)=>$720d2ca308e39d31$export$dc5d9523e11716f6 = v);
    $parcel$export(module.exports, "list", ()=>$720d2ca308e39d31$export$8837f4fc672e936d, (v)=>$720d2ca308e39d31$export$8837f4fc672e936d = v);
    $parcel$export(module.exports, "priorityOption", ()=>$720d2ca308e39d31$export$155152b53237140d, (v)=>$720d2ca308e39d31$export$155152b53237140d = v);
    $parcel$export(module.exports, "priorityOptionIcon", ()=>$720d2ca308e39d31$export$e51be9b6e86c3e6e, (v)=>$720d2ca308e39d31$export$e51be9b6e86c3e6e = v);
    $parcel$export(module.exports, "prioritySelect", ()=>$720d2ca308e39d31$export$ee83c1b866c8c1f4, (v)=>$720d2ca308e39d31$export$ee83c1b866c8c1f4 = v);
    $parcel$export(module.exports, "row", ()=>$720d2ca308e39d31$export$120ff0929b202a6d, (v)=>$720d2ca308e39d31$export$120ff0929b202a6d = v);
    $parcel$export(module.exports, "swatch", ()=>$720d2ca308e39d31$export$c672d9950c40fe0a, (v)=>$720d2ca308e39d31$export$c672d9950c40fe0a = v);
    var $720d2ca308e39d31$export$f627f0c01f3c5e2e;
    var $720d2ca308e39d31$export$5cfe825620032318;
    var $720d2ca308e39d31$export$dc5d9523e11716f6;
    var $720d2ca308e39d31$export$8837f4fc672e936d;
    var $720d2ca308e39d31$export$155152b53237140d;
    var $720d2ca308e39d31$export$e51be9b6e86c3e6e;
    var $720d2ca308e39d31$export$ee83c1b866c8c1f4;
    var $720d2ca308e39d31$export$120ff0929b202a6d;
    var $720d2ca308e39d31$export$c672d9950c40fe0a;
    $720d2ca308e39d31$export$f627f0c01f3c5e2e = `tsWTQG_addColourLink`;
    $720d2ca308e39d31$export$5cfe825620032318 = `tsWTQG_allOtherIssues`;
    $720d2ca308e39d31$export$dc5d9523e11716f6 = `tsWTQG_allOtherIssuesButton`;
    $720d2ca308e39d31$export$8837f4fc672e936d = `tsWTQG_list`;
    $720d2ca308e39d31$export$155152b53237140d = `tsWTQG_priorityOption`;
    $720d2ca308e39d31$export$e51be9b6e86c3e6e = `tsWTQG_priorityOptionIcon`;
    $720d2ca308e39d31$export$ee83c1b866c8c1f4 = `tsWTQG_prioritySelect`;
    $720d2ca308e39d31$export$120ff0929b202a6d = `tsWTQG_row`;
    $720d2ca308e39d31$export$c672d9950c40fe0a = `tsWTQG_swatch`;
});
parcelRegister("2HSRR", function(module, exports) {
    $parcel$export(module.exports, "getPriorityIdsToOptions", ()=>$7fbd63299e334fbe$export$95876874e89972af);
    $parcel$export(module.exports, "getOptionsToPriorityIds", ()=>$7fbd63299e334fbe$export$8e3d2d44e81969a9);
    $parcel$export(module.exports, "getAvailablePriorities", ()=>$7fbd63299e334fbe$export$c6cdd4b9fa03ef76);
    $parcel$export(module.exports, "onColourChange", ()=>$7fbd63299e334fbe$export$3c5f96994762a26);
    var $4Rr1a;
    var $2rMKg;
    var $4nDwW = parcelRequire("4nDwW");
    const $7fbd63299e334fbe$export$95876874e89972af = (priorityIds, prioritiesById)=>priorityIds.reduce((acc, priorityId)=>{
            if (prioritiesById[priorityId]) acc.push({
                label: prioritiesById[priorityId].name,
                value: priorityId
            });
            return acc;
        }, []);
    const $7fbd63299e334fbe$export$8e3d2d44e81969a9 = (options)=>(0, parcelRequire("4Rr1a")).default((0, parcelRequire("2rMKg")).default('value'), options);
    const $7fbd63299e334fbe$export$c6cdd4b9fa03ef76 = (colourPriorities, issuePrioritiesIdList = [])=>{
        const usedPriorities = new Set((0, $4nDwW.chain)((x)=>x.priorities, colourPriorities));
        return issuePrioritiesIdList.filter((priorityId)=>!usedPriorities.has(priorityId));
    };
    const $7fbd63299e334fbe$export$3c5f96994762a26 = (index, removePriorityColour, updatePriorityColour)=>(colour)=>{
            if ((0, $4nDwW.isDefined)(colour)) updatePriorityColour({
                index: index,
                colour: colour
            });
            else removePriorityColour({
                index: index
            });
        };
});
parcelRegister("k0bqi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1e06b5b1715357e$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $kWDpn = parcelRequire("kWDpn");
    var $j0XCX = parcelRequire("j0XCX");
    var $clsih = parcelRequire("clsih");
    var $bC2fB;
    var $aaqE5 = parcelRequire("aaqE5");
    const $e1e06b5b1715357e$var$mapStateToProps = (state)=>({
            colourByConfiguration: (0, $kWDpn.getColorByViewSettings)(state),
            selectOptionsFromIssues: (0, $j0XCX.getSelectOptionsFromIssues)(state),
            selectOptions: (0, $19iju.getSelectOptions)(state)
        });
    const $e1e06b5b1715357e$var$mapDispatchToProps = (dispatch)=>({
            addSelectColour: ()=>{
                dispatch((0, $clsih.addSelectColour)());
            },
            updateSelectColour: (payload)=>{
                dispatch((0, $clsih.updateSelectColour)(payload));
            },
            removeSelectColour: (payload)=>{
                dispatch((0, $clsih.removeSelectColour)(payload));
            }
        });
    var $e1e06b5b1715357e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($e1e06b5b1715357e$var$mapStateToProps, $e1e06b5b1715357e$var$mapDispatchToProps)((0, $aaqE5.default));
});
parcelRegister("aaqE5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$498ad193d39923c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $lV634;
    var $9lMrf;
    var $ousew;
    var $8RXs9;
    var $aCpcO;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $4Ai8V = parcelRequire("4Ai8V");
    var $gITL8 = parcelRequire("gITL8");
    var $ihPUd = parcelRequire("ihPUd");
    var $3AWz7 = parcelRequire("3AWz7");
    var $2Fqnf = parcelRequire("2Fqnf");
    var $484U6 = parcelRequire("484U6");
    const $498ad193d39923c1$export$742fca7ce59eb416 = (values, options)=>values.map((value)=>{
            const label = options.find((option)=>option.id.toString() === value);
            return {
                value: value,
                label: label ? label.value : value
            };
        });
    const $498ad193d39923c1$var$optionsToLabels = (options)=>options.map((x)=>x.value);
    class $498ad193d39923c1$var$ColourBySelect extends (0, $5uXOq.Component) {
        render() {
            const { intl: intl } = this.props;
            const values = this.getValues();
            const isAddingNewLabelColour = values.some(({ colour: colour })=>!colour);
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $484U6.list
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $484U6.row
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                className: $484U6.allOtherIssuesButton,
                isDisabled: true,
                iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $484U6.swatch,
                    style: {
                        backgroundColor: (0, $gITL8.DEFAULT_COLOR)
                    }
                }),
                ariaLabel: intl.formatMessage((0, $3AWz7.default).allOtherIssuesButtonLabel)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $484U6.allOtherIssues
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).allOtherIssues))), values.map(this.renderRow), isAddingNewLabelColour ? null : this.renderAddLabel()));
        }
        constructor(...args){
            super(...args);
            this.state = {
                keySuffix: 0
            };
            this.getAvailableOptions = ()=>{
                const { selectOptionsFromIssues: selectOptionsFromIssues } = this.props;
                const usedOptions = new Set((0, $4nDwW.chain)((x)=>x.options, this.getValues()));
                return selectOptionsFromIssues.filter((option)=>!usedOptions.has(option)).map((option)=>option.toString());
            };
            this.onLabelsChange = (index, options)=>{
                const { updateSelectColour: updateSelectColour, removeSelectColour: removeSelectColour } = this.props;
                if ((0, parcelRequire("lV634")).default(options) || (0, parcelRequire("3nPAF")).default(options)) {
                    removeSelectColour({
                        index: index
                    });
                    this.setState((prevState)=>({
                            keySuffix: prevState.keySuffix + 1
                        }));
                } else updateSelectColour({
                    index: index,
                    options: $498ad193d39923c1$var$optionsToLabels(options)
                });
            };
            this.onColourChange = (index)=>(colour)=>{
                    const { updateSelectColour: updateSelectColour, removeSelectColour: removeSelectColour } = this.props;
                    if (colour) updateSelectColour({
                        index: index,
                        colour: colour
                    });
                    else removeSelectColour({
                        index: index
                    });
                };
            this.renderRow = (colourSelect, index)=>{
                const { intl: intl, onMenuToggle: onMenuToggle, selectOptions: selectOptions } = this.props;
                const { colour: colour, options: options } = colourSelect;
                const availableOptions = this.getAvailableOptions();
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $484U6.row,
                    key: `${index}-${colour || ''}-${this.state.keySuffix}`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4Ai8V.default), {
                    colour: colour,
                    onColourChange: this.onColourChange(index),
                    position: "left"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $484U6.labelSelect
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                    classNamePrefix: `portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by-select_select-select-${index}`,
                    defaultValue: $498ad193d39923c1$export$742fca7ce59eb416(options, selectOptions),
                    isDisabled: !colour,
                    isMulti: true,
                    menuPlacement: "auto",
                    menuPortalTarget: (0, $4y9A5.getBody)(),
                    onChange: (options)=>this.onLabelsChange(index, options),
                    onMenuClose: ()=>{
                        onMenuToggle(false);
                    },
                    onMenuOpen: ()=>{
                        onMenuToggle(true);
                    },
                    options: $498ad193d39923c1$export$742fca7ce59eb416(availableOptions, selectOptions),
                    placeholder: intl.formatMessage(colour ? (0, $2Fqnf.default).findLabel : (0, $2Fqnf.default).selectLabel),
                    styles: {
                        menuPortal: (styles)=>({
                                ...styles,
                                zIndex: 1000
                            })
                    },
                    "aria-label": intl.formatMessage((0, $2Fqnf.default).selectLabel)
                }))));
            };
            this.renderAddLabel = ()=>{
                const { addSelectColour: addSelectColour } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: `${$484U6.addLabelButton} ${$484U6.row}`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                        label: ""
                    }),
                    onClick: (e)=>{
                        e.preventDefault();
                        addSelectColour();
                    },
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-select.add-color-link"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    className: $484U6.addLabel
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $2Fqnf.default).addLabel)))));
            };
            this.getValues = ()=>{
                const { colourByConfiguration: { colourSelects: colourSelects, colourByValue: colourByValue } } = this.props;
                return colourSelects[colourByValue] || [];
            };
        }
    }
    var $498ad193d39923c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($498ad193d39923c1$var$ColourBySelect);
});
parcelRegister("2Fqnf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$490f8d0af2da8d28$export$2e2bcd8739ae039);
    var $7VHMR;
    var $490f8d0af2da8d28$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        findLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-select.find-label",
            "defaultMessage": "Choose option"
        },
        selectLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-select.select-label",
            "defaultMessage": "Choose color"
        },
        addLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-select.add-label",
            "defaultMessage": "Add color"
        }
    });
});
parcelRegister("484U6", function(module, exports) {
    $parcel$export(module.exports, "addLabel", ()=>$301bb69380082964$export$7382a268046a9fb1, (v)=>$301bb69380082964$export$7382a268046a9fb1 = v);
    $parcel$export(module.exports, "addLabelButton", ()=>$301bb69380082964$export$2e19006997105e3f, (v)=>$301bb69380082964$export$2e19006997105e3f = v);
    $parcel$export(module.exports, "allOtherIssues", ()=>$301bb69380082964$export$5cfe825620032318, (v)=>$301bb69380082964$export$5cfe825620032318 = v);
    $parcel$export(module.exports, "allOtherIssuesButton", ()=>$301bb69380082964$export$dc5d9523e11716f6, (v)=>$301bb69380082964$export$dc5d9523e11716f6 = v);
    $parcel$export(module.exports, "labelSelect", ()=>$301bb69380082964$export$519b192a392926cb, (v)=>$301bb69380082964$export$519b192a392926cb = v);
    $parcel$export(module.exports, "list", ()=>$301bb69380082964$export$8837f4fc672e936d, (v)=>$301bb69380082964$export$8837f4fc672e936d = v);
    $parcel$export(module.exports, "row", ()=>$301bb69380082964$export$120ff0929b202a6d, (v)=>$301bb69380082964$export$120ff0929b202a6d = v);
    $parcel$export(module.exports, "swatch", ()=>$301bb69380082964$export$c672d9950c40fe0a, (v)=>$301bb69380082964$export$c672d9950c40fe0a = v);
    var $301bb69380082964$export$7382a268046a9fb1;
    var $301bb69380082964$export$2e19006997105e3f;
    var $301bb69380082964$export$5cfe825620032318;
    var $301bb69380082964$export$dc5d9523e11716f6;
    var $301bb69380082964$export$519b192a392926cb;
    var $301bb69380082964$export$8837f4fc672e936d;
    var $301bb69380082964$export$120ff0929b202a6d;
    var $301bb69380082964$export$c672d9950c40fe0a;
    $301bb69380082964$export$7382a268046a9fb1 = `Z0-zja_addLabel`;
    $301bb69380082964$export$2e19006997105e3f = `Z0-zja_addLabelButton`;
    $301bb69380082964$export$5cfe825620032318 = `Z0-zja_allOtherIssues`;
    $301bb69380082964$export$dc5d9523e11716f6 = `Z0-zja_allOtherIssuesButton`;
    $301bb69380082964$export$519b192a392926cb = `Z0-zja_labelSelect`;
    $301bb69380082964$export$8837f4fc672e936d = `Z0-zja_list`;
    $301bb69380082964$export$120ff0929b202a6d = `Z0-zja_row`;
    $301bb69380082964$export$c672d9950c40fe0a = `Z0-zja_swatch`;
});
parcelRegister("4ggfX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60792201874acae1$export$2e2bcd8739ae039);
    var $bC2fB;
    var $kP9zu = parcelRequire("kP9zu");
    var $ddfWM = parcelRequire("ddfWM");
    var $1HKYT = parcelRequire("1HKYT");
    var $60792201874acae1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $ddfWM.default), (0, $kP9zu.default))((0, $1HKYT.default));
});
parcelRegister("kP9zu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f416510fde51cf28$export$2e2bcd8739ae039);
    var $clsih = parcelRequire("clsih");
    var $f416510fde51cf28$export$2e2bcd8739ae039 = (dispatch)=>({
            setColourByValue: (payload)=>{
                dispatch((0, $clsih.setColourByValue)(payload));
            },
            setColourMap: (payload)=>{
                dispatch((0, $clsih.setColourMap)(payload));
            },
            setPriorityColourMap: (payload)=>{
                dispatch((0, $clsih.setPriorityColourMap)(payload));
            }
        });
});
parcelRegister("ddfWM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88b2fdbea5052178$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $io4Ja = parcelRequire("io4Ja");
    var $kWDpn = parcelRequire("kWDpn");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $88b2fdbea5052178$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        colourByValue: (0, $j0XCX.getColorByValue),
        colourMaps: (0, $j0XCX.getColourMaps),
        colourPriorities: (0, $j0XCX.getColourPriorities),
        filterableCustomFields: (0, $19iju.getFilterableCustomFields),
        issuePrioritiesIdList: (0, $io4Ja.getIssuePrioritiesIdList),
        viewMode: (0, $kWDpn.getViewMode)
    });
});
parcelRegister("1HKYT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dd031060a6c93ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $8EeRK;
    var $eTXmK;
    var $koVbs;
    var $3J2mc;
    var $i2qlb = parcelRequire("i2qlb");
    var $j0XCX = parcelRequire("j0XCX");
    var $4nDwW = parcelRequire("4nDwW");
    var $gITL8 = parcelRequire("gITL8");
    var $1Cyfv = parcelRequire("1Cyfv");
    var $8zOmE;
    var $2NMNM;
    var $el0Tu = parcelRequire("el0Tu");
    var $bkMJm = parcelRequire("bkMJm");
    var $i43rb = parcelRequire("i43rb");
    function $2dd031060a6c93ed$var$ColourBy({ colourByValue: colourByValue, colourMaps: colourMaps, colourPriorities: colourPriorities, filterableCustomFields: filterableCustomFields, isDefaultMenuOpen: isDefaultMenuOpen = false, issuePrioritiesIdList: issuePrioritiesIdList, onMenuToggle: onMenuToggle, setColourByValue: setColourByValue, setColourMap: setColourMap, setPriorityColourMap: setPriorityColourMap, viewMode: viewMode = (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const createDefaultMap = (id)=>{
            if (id === (0, $gITL8.colourByOptions).STATUS) return 0, $gITL8.statusColourMap;
            return {};
        };
        const createPriorityColourMap = ()=>{
            if ((0, $4nDwW.isDefined)(issuePrioritiesIdList) && issuePrioritiesIdList.length >= (0, $gITL8.priorityColourMap).length) {
                const [floorChunkSize, ceilChunkSize] = (0, parcelRequire("8EeRK")).default([
                    Math.floor,
                    Math.ceil
                ])(issuePrioritiesIdList.length / (0, $gITL8.priorityColourMap).length);
                const chunks = issuePrioritiesIdList.length % (0, $gITL8.priorityColourMap).length === 1 ? [
                    floorChunkSize,
                    ceilChunkSize,
                    floorChunkSize
                ] : [
                    ceilChunkSize,
                    floorChunkSize,
                    ceilChunkSize
                ];
                setPriorityColourMap({
                    chunks: chunks,
                    issuePrioritiesIdList: issuePrioritiesIdList
                });
            }
        };
        const changeColourBy = ({ value: value })=>{
            (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).CHANGE_COLOR_BY_SETTING);
            setColourByValue({
                id: value
            });
            const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).COLOR_BY_CLICKED.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject,
                action: action
            }), actionSubjectId, {
                newPlanSettingValue: value
            });
            if (!(0, $j0XCX.isColorByCustomFieldOption)(value)) {
                if (value === (0, $gITL8.colourByOptions).PRIORITY && (0, parcelRequire("3nPAF")).default(colourPriorities)) createPriorityColourMap();
                else if (colourMaps[value] && Object.keys(colourMaps[value]).length === 0) {
                    const map = createDefaultMap(value);
                    setColourMap({
                        id: value,
                        map: map
                    });
                }
            }
        };
        const getColourByOptionsFromStandardFields = ()=>Object.keys((0, $i43rb.colorByLabelsMap)).map((key)=>({
                    id: key.toString(),
                    content: formatMessage((0, $i43rb.colorByLabelsMap)[key]),
                    label: formatMessage((0, $i43rb.colorByLabelsMap)[key]),
                    value: key.toString()
                }));
        const getColourByOptionsFromCustomFields = ()=>filterableCustomFields.map(({ id: id, title: title })=>({
                    id: id.toString(),
                    content: title,
                    label: title,
                    value: id.toString()
                }));
        const standardFieldsOptions = getColourByOptionsFromStandardFields();
        const customFieldsOptions = getColourByOptionsFromCustomFields();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $el0Tu.default), {
            classNamePrefix: "portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by",
            customFieldsOptions: customFieldsOptions,
            handleOnChange: changeColourBy,
            isDefaultMenuOpen: isDefaultMenuOpen,
            isDisabled: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST,
            onMenuToggle: onMenuToggle,
            selectedFieldId: colourByValue,
            standardFieldsOptions: standardFieldsOptions,
            label: formatMessage((0, $bkMJm.default).colourByLabel)
        });
    }
    var $2dd031060a6c93ed$export$2e2bcd8739ae039 = $2dd031060a6c93ed$var$ColourBy;
});
parcelRegister("el0Tu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd291041f50a8816$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $820Wv;
    var $3bDjY;
    var $koVbs;
    var $gJZ5D;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $4y9A5 = parcelRequire("4y9A5");
    var $ihPUd = parcelRequire("ihPUd");
    var $iUfaw = parcelRequire("iUfaw");
    var $730E3 = parcelRequire("730E3");
    function $fd291041f50a8816$var$ViewSettingSelect({ classNamePrefix: classNamePrefix, customFieldsOptions: customFieldsOptions, handleOnChange: handleOnChange, isDefaultMenuOpen: isDefaultMenuOpen = false, isDisabled: isDisabled = false, onMenuToggle: onMenuToggle, selectedFieldId: selectedFieldId, standardFieldsOptions: standardFieldsOptions, label: label }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(isDefaultMenuOpen);
        const groupedOptions = [
            {
                label: '',
                options: standardFieldsOptions
            }
        ];
        if (customFieldsOptions.length > 0) {
            const sortedCustomFieldsOptions = customFieldsOptions.sort((a, b)=>a.label.localeCompare(b.label));
            groupedOptions.push({
                label: formatMessage((0, $ihPUd.default).customFields),
                options: sortedCustomFieldsOptions
            });
        }
        const selectedValue = [
            ...standardFieldsOptions,
            ...customFieldsOptions
        ].find(({ id: id })=>id === selectedFieldId);
        const formatOptionLabel = ({ content: content, isDisabled: isDisabled, tooltipContent: tooltipContent }, { context: context })=>{
            if (context === 'menu') {
                if (isDisabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $730E3.option
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, content), (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: formatMessage(tooltipContent),
                    position: "top"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("820Wv"))))), {
                    color: "currentColor",
                    label: formatMessage(tooltipContent),
                    LEGACY_primaryColor: `var(--ds-blanket, ${(0, (0, parcelRequire("gJZ5D")).default).N500})`,
                    LEGACY_size: "small"
                })))));
                return content;
            }
            return content;
        };
        const tooltipContent = ()=>{
            if (isDisabled) return formatMessage((0, $iUfaw.default).optionDisabledInListView);
            if (!isMenuOpen) return selectedValue?.label;
            return null;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            blurInputOnSelect: true,
            classNamePrefix: classNamePrefix,
            closeMenuOnSelect: true,
            formatOptionLabel: formatOptionLabel,
            isDisabled: isDisabled,
            menuIsOpen: isMenuOpen,
            menuPortalTarget: window.STORYBOOK_ENV ? undefined : (0, $4y9A5.getBody)(),
            onChange: handleOnChange,
            onMenuClose: ()=>{
                setIsMenuOpen(false);
                onMenuToggle(false);
            },
            onMenuOpen: ()=>{
                setIsMenuOpen(true);
                onMenuToggle(true);
            },
            options: groupedOptions,
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 999
                    })
            },
            value: selectedValue,
            "aria-label": formatMessage((0, $iUfaw.default).selectAriaLabel, {
                label: label,
                selectedValue: selectedValue?.label
            })
        }));
    }
    var $fd291041f50a8816$export$2e2bcd8739ae039 = $fd291041f50a8816$var$ViewSettingSelect;
});
parcelRegister("820Wv", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5d8f3dcf908a8bd0$var$_react = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5d8f3dcf908a8bd0$var$_information = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("jxZHv")));
    var $5d8f3dcf908a8bd0$var$_panel = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("kkuz9")));
    function $5d8f3dcf908a8bd0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5d8f3dcf908a8bd0$var$InformationIcon = (props)=>$5d8f3dcf908a8bd0$var$_react.default.createElement($5d8f3dcf908a8bd0$var$_information.default, Object.assign({
            LEGACY_fallbackIcon: $5d8f3dcf908a8bd0$var$_panel.default
        }, props));
    $5d8f3dcf908a8bd0$var$InformationIcon.Name = 'InformationIconMigration';
    var $5d8f3dcf908a8bd0$var$_default = module.exports.default = $5d8f3dcf908a8bd0$var$InformationIcon;
});
parcelRegister("jxZHv", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e3b0f5e112f2bb60$var$_react = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e3b0f5e112f2bb60$var$_UNSAFE_baseNew = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e3b0f5e112f2bb60$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e3b0f5e112f2bb60$var$InformationIcon = (props)=>$e3b0f5e112f2bb60$var$_react.default.createElement($e3b0f5e112f2bb60$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-7.5-.75H6a.75.75 0 0 1 .75.75v4h-1.5V6.75H4.5zM6 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $e3b0f5e112f2bb60$var$InformationIcon.displayName = 'InformationIcon';
    var $e3b0f5e112f2bb60$var$_default = module.exports.default = $e3b0f5e112f2bb60$var$InformationIcon;
});
parcelRegister("iUfaw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d62cc0d8785cc96$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6d62cc0d8785cc96$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        optionDisabledInListView: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.view-setting-select.option-disabled-in-list-view",
            "defaultMessage": "This option is unavailable in list view"
        },
        selectAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.view-setting-select.select-aria-label",
            "defaultMessage": "{label} {selectedValue}"
        }
    });
});
parcelRegister("730E3", function(module, exports) {
    $parcel$export(module.exports, "option", ()=>$52195050885043c6$export$a75d1723e6bda2ec, (v)=>$52195050885043c6$export$a75d1723e6bda2ec = v);
    var $52195050885043c6$export$a75d1723e6bda2ec;
    $52195050885043c6$export$a75d1723e6bda2ec = `LpNIna_option`;
});
parcelRegister("bkMJm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57409c2900678e37$export$2e2bcd8739ae039);
    var $7VHMR;
    var $57409c2900678e37$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        colourByLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by.colour-by-label",
            "defaultMessage": "Color by"
        }
    });
});
parcelRegister("i43rb", function(module, exports) {
    $parcel$export(module.exports, "colorByLabelsMap", ()=>$792b460a90025104$export$1fba1ddb0e3b4298);
    var $gITL8 = parcelRequire("gITL8");
    var $ihPUd = parcelRequire("ihPUd");
    const $792b460a90025104$export$1fba1ddb0e3b4298 = {
        [(0, $gITL8.colourByOptions).NONE]: (0, $ihPUd.default).none,
        [(0, $gITL8.colourByOptions).COMPONENT]: (0, $ihPUd.default).component,
        [(0, $gITL8.colourByOptions).EPIC]: (0, $ihPUd.default).epic,
        [(0, $gITL8.colourByOptions).ISSUE_TYPE]: (0, $ihPUd.default).issueType,
        [(0, $gITL8.colourByOptions).LABEL]: (0, $ihPUd.default).label,
        [(0, $gITL8.colourByOptions).PRIORITY]: (0, $ihPUd.default).priority,
        [(0, $gITL8.colourByOptions).PROJECT]: (0, $ihPUd.default).project,
        [(0, $gITL8.colourByOptions).STATUS]: (0, $ihPUd.default).status,
        [(0, $gITL8.colourByOptions).TEAM]: (0, $ihPUd.default).team
    };
});
parcelRegister("7jSf8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ef47a124cd397c1$export$2e2bcd8739ae039);
    var $bC2fB;
    var $gBzCD = parcelRequire("gBzCD");
    var $aJQce = parcelRequire("aJQce");
    var $8nEMm = parcelRequire("8nEMm");
    var $3ef47a124cd397c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $aJQce.default), (0, $gBzCD.default))((0, $8nEMm.default));
});
parcelRegister("gBzCD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55e9816ae1b826f$export$2e2bcd8739ae039);
    var $hLj4s = parcelRequire("hLj4s");
    var $d55e9816ae1b826f$export$2e2bcd8739ae039 = (dispatch)=>({
            changeDisplay: (payload)=>{
                dispatch((0, $hLj4s.changeDisplay)(payload));
            }
        });
});
parcelRegister("aJQce", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec82999180ee589b$export$2e2bcd8739ae039);
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $ec82999180ee589b$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        dependencySettings: (0, $kWDpn.getDependencySettings),
        viewMode: (0, $kWDpn.getViewMode)
    });
});
parcelRegister("8nEMm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$280c191ffa56d4fb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $4R6GH;
    var $ousew;
    var $koVbs;
    var $fAGMJ;
    var $3J2mc;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $bChGW;
    var $i2qlb = parcelRequire("i2qlb");
    var $4y9A5 = parcelRequire("4y9A5");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $2XkvT = parcelRequire("2XkvT");
    var $bT4kr = parcelRequire("bT4kr");
    const { LINES: $280c191ffa56d4fb$var$LINES, DEFAULT: $280c191ffa56d4fb$var$DEFAULT, COUNT: $280c191ffa56d4fb$var$COUNT } = (0, $TTKUQ.DEPENDENCY_SETTINGS);
    const $280c191ffa56d4fb$export$e161bc0b9865a0b7 = [
        {
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $2XkvT.default).default),
            value: $280c191ffa56d4fb$var$DEFAULT
        },
        {
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $2XkvT.default).lines),
            value: $280c191ffa56d4fb$var$LINES
        }
    ];
    const $280c191ffa56d4fb$var$CheckboxWrapper = ({ isVisuallyRefreshed: isVisuallyRefreshed, children: children })=>{
        return isVisuallyRefreshed ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlockStart: "space.075",
            xcss: $280c191ffa56d4fb$var$checkboxWrapperStyles
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $bT4kr.checkboxWrapper
        }, children);
    };
    const $280c191ffa56d4fb$var$Option = (props)=>{
        const innerProps = {
            ...props.innerProps,
            role: 'option',
            'aria-disabled': props.isDisabled
        };
        const Elem = (0, (0, parcelRequire("bChGW")).components).Option;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Elem, {
            ...props,
            innerProps: innerProps
        });
    };
    function $280c191ffa56d4fb$export$2e2bcd8739ae039({ changeDisplay: changeDisplay, dependencySettings: dependencySettings, onMenuToggle: onMenuToggle, viewMode: viewMode }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { display: display } = dependencySettings;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleOptionClick = (0, $5uXOq.useCallback)((setting)=>{
            changeDisplay({
                display: setting
            });
        }, [
            changeDisplay
        ]);
        const onCheckSelected = (0, $5uXOq.useCallback)((event)=>{
            const nextValue = event.target.checked ? $280c191ffa56d4fb$var$COUNT : $280c191ffa56d4fb$var$DEFAULT;
            const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).DEPENDENCY_TYPE_CLICKED.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject,
                action: action
            }), actionSubjectId, {
                newPlanSettingValue: nextValue
            });
            handleOptionClick(nextValue);
        }, [
            createAnalyticsEvent,
            handleOptionClick
        ]);
        const triggerId = display === $280c191ffa56d4fb$var$LINES ? $280c191ffa56d4fb$var$LINES : $280c191ffa56d4fb$var$DEFAULT;
        const selectedValue = (0, $5uXOq.useMemo)(()=>$280c191ffa56d4fb$export$e161bc0b9865a0b7.find(({ value: value })=>value === triggerId), [
            triggerId
        ]);
        const onSelectChange = (0, $5uXOq.useCallback)(({ value: value })=>{
            const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).DEPENDENCY_TYPE_CLICKED.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject,
                action: action
            }), actionSubjectId, {
                newPlanSettingValue: value === $280c191ffa56d4fb$var$DEFAULT ? 'badges' : value
            });
            changeDisplay({
                display: value
            });
        }, [
            changeDisplay,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $2XkvT.default).disabledTooltip) : null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            blurInputOnSelect: true,
            closeMenuOnSelect: true,
            isMulti: false,
            isDisabled: viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST,
            isSearchable: false,
            components: {
                Option: $280c191ffa56d4fb$var$Option
            },
            menuPortalTarget: (0, $4y9A5.getBody)(),
            onChange: onSelectChange,
            onMenuClose: ()=>onMenuToggle(false),
            onMenuOpen: ()=>onMenuToggle(true),
            options: $280c191ffa56d4fb$export$e161bc0b9865a0b7,
            styles: {
                menuPortal: (styles)=>({
                        ...styles,
                        zIndex: 1000
                    })
            },
            value: selectedValue,
            "aria-label": formatMessage((0, $2XkvT.default).dependencySettingAriaLabel, {
                selectedOption: selectedValue?.value === $280c191ffa56d4fb$var$DEFAULT ? 'Badges' : selectedValue?.value
            })
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($280c191ffa56d4fb$var$CheckboxWrapper, {
            isVisuallyRefreshed: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            isDisabled: display === $280c191ffa56d4fb$var$LINES,
            isChecked: display === $280c191ffa56d4fb$var$COUNT,
            onChange: onCheckSelected,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $2XkvT.default).count)
        })));
    }
    const $280c191ffa56d4fb$var$checkboxWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.negative.100'
    });
});
parcelRegister("2XkvT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ccff5de90de4d7e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1ccff5de90de4d7e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        default: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings.default",
            "defaultMessage": "Badges"
        },
        lines: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings.lines",
            "defaultMessage": "Lines"
        },
        count: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings.count",
            "defaultMessage": "Show number of dependencies"
        },
        disabledTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings.disabled-tooltip",
            "defaultMessage": "This option is unavailable in list view"
        },
        dependencySettingAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings.dependency-setting-aria-label",
            "defaultMessage": "Dependency style {selectedOption}"
        }
    });
});
parcelRegister("bT4kr", function(module, exports) {
    $parcel$export(module.exports, "checkboxWrapper", ()=>$8a7830600abecaa0$export$8b18e1c47ccc2c63, (v)=>$8a7830600abecaa0$export$8b18e1c47ccc2c63 = v);
    var $8a7830600abecaa0$export$8b18e1c47ccc2c63;
    $8a7830600abecaa0$export$8b18e1c47ccc2c63 = `Dx8POa_checkboxWrapper`;
});
parcelRegister("7nEUj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$24fdf3168bdf03cc$export$2e2bcd8739ae039);
    var $bC2fB;
    var $dDj09 = parcelRequire("dDj09");
    var $h2XBl = parcelRequire("h2XBl");
    var $9UY3D = parcelRequire("9UY3D");
    var $24fdf3168bdf03cc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $h2XBl.default), (0, $dDj09.default))((0, $9UY3D.default));
});
parcelRegister("dDj09", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80cc3be93b624997$export$2e2bcd8739ae039);
    var $duJmw = parcelRequire("duJmw");
    const $80cc3be93b624997$var$mapDispatchToProps = (dispatch)=>({
            addGroup: (group)=>{
                dispatch((0, $duJmw.add)(group));
            },
            updateGroup: (groupId, patch)=>{
                dispatch((0, $duJmw.update)({
                    id: groupId,
                    patch: patch
                }));
            },
            removeGroup: (groupId)=>{
                dispatch((0, $duJmw.remove)(groupId));
            }
        });
    var $80cc3be93b624997$export$2e2bcd8739ae039 = $80cc3be93b624997$var$mapDispatchToProps;
});
parcelRegister("h2XBl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e6f900009285283$export$2e2bcd8739ae039);
    var $5nMRY = parcelRequire("5nMRY");
    var $jpXKt = parcelRequire("jpXKt");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $0e6f900009285283$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        componentGroups: (0, $kWDpn.getComponentGroupsViewSettings),
        componentsById: (0, $5nMRY.getComponentsById),
        projectsById: (0, $jpXKt.getProjectsById)
    });
});
parcelRegister("9UY3D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b70379713f93412$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b1yMp;
    var $2rMKg;
    var $h35CY;
    var $hpnKp;
    var $9lMrf;
    var $8RXs9;
    var $aCpcO;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $fWp2V = parcelRequire("fWp2V");
    var $bXs7i = parcelRequire("bXs7i");
    var $ca3ei = parcelRequire("ca3ei");
    const $3b70379713f93412$var$trimName = (name)=>{
        const maxLength = 254;
        return name.length > maxLength ? name.substring(0, maxLength) : name;
    };
    class $3b70379713f93412$var$GroupByComponents extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.isNewGroupNameValid = (newName)=>{
                const allGroupNames = new Set(this.props.componentGroups.map(({ name: name })=>name));
                return !allGroupNames.has(newName);
            };
            this.isAllOtherIssuesGroup = (id)=>id === (0, $10afd8ee8013ce61$export$526fec6b76d5bc5);
            this.onCreateGroup = ()=>this.setState({
                    isCreating: true
                });
            this.onCancelCreateGroup = ()=>this.setState({
                    isCreating: false
                });
            this.onConfirmingCreateGroup = (newName)=>{
                this.onCancelCreateGroup();
                if (newName.length === 0 || !this.isNewGroupNameValid(newName)) return;
                this.props.addGroup({
                    id: $3b70379713f93412$var$trimName(newName).toLowerCase(),
                    name: $3b70379713f93412$var$trimName(newName),
                    isExpanded: true,
                    components: []
                });
            };
            this.onConfirmingUpdateGroup = (id, newName)=>{
                if (newName.length === 0 || !this.isNewGroupNameValid(newName)) return;
                this.props.updateGroup(id, {
                    id: $3b70379713f93412$var$trimName(newName).toLowerCase(),
                    name: $3b70379713f93412$var$trimName(newName)
                });
            };
            this.onUpdatingComponentsInGroup = (id, selectValue)=>{
                if ((0, $4nDwW.isDefined)(selectValue)) this.props.updateGroup(id, {
                    components: selectValue.map(({ value: value })=>value)
                });
            };
            this.toggleExpanded = (id, isExpanded)=>this.props.updateGroup(id, {
                    isExpanded: isExpanded
                });
            this.renderComponentSelect = (groupId, components)=>{
                const { componentsById: componentsById, intl: { formatMessage: formatMessage }, onMenuToggle: onMenuToggle, projectsById: projectsById } = this.props;
                const allComponents = Object.keys(componentsById).map((k)=>componentsById[parseFloat(k)]);
                const options = (0, parcelRequire("h35CY")).default((0, parcelRequire("b1yMp")).default((0, parcelRequire("hpnKp")).default, (0, parcelRequire("2rMKg")).default('name')))(allComponents).map(({ id: id, name: name, projectId: projectId })=>({
                        value: id,
                        label: `${name} (${projectsById[projectId].key})`
                    }));
                const valueOptions = options.filter(({ value: value })=>components.includes(value));
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $ca3ei.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $ca3ei.componentSelect
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                    autoFocus: true,
                    classNamePrefix: "group-by-custom-options-select",
                    defaultValue: valueOptions,
                    isMulti: true,
                    menuPlacement: "auto",
                    menuPortalTarget: (0, $4y9A5.getBody)(),
                    onChange: (value)=>this.onUpdatingComponentsInGroup(groupId, value),
                    onMenuClose: ()=>{
                        onMenuToggle(false);
                    },
                    onMenuOpen: ()=>{
                        onMenuToggle(true);
                    },
                    options: options,
                    "aria-label": formatMessage((0, $bXs7i.default).componentPlaceholder),
                    placeholder: formatMessage((0, $bXs7i.default).componentPlaceholder),
                    styles: {
                        menuPortal: (styles)=>({
                                ...styles,
                                zIndex: 1000
                            })
                    }
                })))));
            };
            this.renderGroup = (group)=>{
                const { id: id, isExpanded: isExpanded, components: components } = group;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                    key: id
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $ca3ei.row,
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.components.group"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWp2V.default), {
                    groupName: group.name,
                    groupId: id,
                    isExpanded: isExpanded,
                    onConfirm: (newName)=>{
                        this.onConfirmingUpdateGroup(id, newName);
                    },
                    onCancel: this.onCancelCreateGroup,
                    onDelete: this.props.removeGroup,
                    onToggleExpanded: this.toggleExpanded
                }))), !this.isAllOtherIssuesGroup(id) && isExpanded && this.renderComponentSelect(id, components));
            };
            this.state = {
                isCreating: false
            };
        }
        render() {
            const { intl: { formatMessage: formatMessage } } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.props.componentGroups.map(this.renderGroup), this.state.isCreating && (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                className: $ca3ei.row,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.components.creating-group-row"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                colSpan: 2
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWp2V.default), {
                shouldCreateGroup: true,
                onConfirm: this.onConfirmingCreateGroup,
                onCancel: this.onCancelCreateGroup
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                colSpan: 2
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ca3ei.componentGroup
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: `${$ca3ei.icon} ${$ca3ei.blue}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: ""
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                appearance: "link",
                onClick: this.onCreateGroup,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.components.create-components-group"
            }, formatMessage((0, $bXs7i.default).createGroup))))));
        }
    }
    var $3b70379713f93412$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($3b70379713f93412$var$GroupByComponents);
});
parcelRegister("fWp2V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$add0e6e6ccd86864$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hUqzg;
    var $h1toL;
    var $bP37O;
    var $k4n86;
    var $gtreQ;
    var $kY99m;
    var $3bDjY;
    var $ousew;
    var $aCpcO;
    var $gJZ5D;
    var $1gQ7U;
    var $J8W7q;
    var $iAUhA;
    var $84qTJ = parcelRequire("84qTJ");
    var $gITL8 = parcelRequire("gITL8");
    var $ihPUd = parcelRequire("ihPUd");
    var $1cJPY = parcelRequire("1cJPY");
    var $ikTAN = parcelRequire("ikTAN");
    const $add0e6e6ccd86864$var$COMPONENT_GROUP_TEMPORARY_ID = 'jpo_group_temp_id';
    class $add0e6e6ccd86864$var$Group extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                groupId: $add0e6e6ccd86864$var$COMPONENT_GROUP_TEMPORARY_ID,
                groupName: '',
                isExpanded: false,
                shouldCreateGroup: false,
                onDelete: ()=>{},
                onToggleExpanded: ()=>{}
            };
        }
        render() {
            const { intl: intl, groupId: groupId, groupName: groupName, isExpanded: isExpanded, shouldCreateGroup: shouldCreateGroup, onConfirm: onConfirm, onCancel: onCancel } = this.props;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ikTAN.group
            }, !(this.isAllOtherIssuesGroup(groupId) || shouldCreateGroup) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ikTAN.expandCollapseChevron,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.expand-group-wrapper"
            }, isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gQ7U")).IconButton), {
                onClick: this.onChevronDownClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("k4n86"))))), {
                label: intl.formatMessage((0, $1cJPY.default).collapseButtonLabel)
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gQ7U")).IconButton), {
                onClick: this.onChevronRightClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h1toL"))))), {
                label: intl.formatMessage((0, $1cJPY.default).expandButtonLabel)
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ikTAN.icon
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bP37O"))))), {
                label: ""
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ikTAN.groupTitleSection
            }, this.isAllOtherIssuesGroup(groupId) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).allOtherIssues) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ikTAN.groupTitle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iAUhA")).default), {
                defaultValue: groupName,
                editView: ({ errorMessage: errorMessage, ...fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                        content: errorMessage,
                        isOpen: fieldProps.isInvalid,
                        placement: "right"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                        ...fieldProps,
                        autoFocus: shouldCreateGroup,
                        elemAfterInput: fieldProps && fieldProps.isInvalid && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                            label: "",
                            primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
                        }),
                        "aria-label": intl.formatMessage((0, $1cJPY.default).groupPlaceholder),
                        maxLength: 256,
                        placeholder: intl.formatMessage((0, $1cJPY.default).groupPlaceholder),
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.group-name-input"
                    })),
                onCancel: onCancel,
                onConfirm: onConfirm,
                readView: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                        content: groupName
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $ikTAN.groupTitleReadViewContainer
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, groupName))),
                startWithEditViewOpen: shouldCreateGroup,
                validate: this.validateGroupTitle
            })), !shouldCreateGroup && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ikTAN.trashButton,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.delete-group-button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                appearance: "subtle",
                onClick: this.onTrashButtonClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hUqzg"))))), {
                label: intl.formatMessage((0, $1cJPY.default).deleteButtonLabel),
                LEGACY_size: "small",
                LEGACY_primaryColor: (0, $gITL8.DEFAULT_COLOR),
                color: "var(--ds-icon-subtle, #626F86)"
            })))))));
        }
        constructor(...args){
            super(...args);
            this.onTrashButtonClick = (e)=>{
                e.preventDefault();
                const { groupId: groupId, onDelete: onDelete } = this.props;
                onDelete(groupId);
            };
            this.onChevronDownClick = (e)=>{
                e.preventDefault();
                const { groupId: groupId, onToggleExpanded: onToggleExpanded } = this.props;
                onToggleExpanded(groupId, false);
            };
            this.onChevronRightClick = (e)=>{
                e.preventDefault();
                const { groupId: groupId, onToggleExpanded: onToggleExpanded } = this.props;
                onToggleExpanded(groupId, true);
            };
            this.isAllOtherIssuesGroup = (groupId)=>groupId === (0, $10afd8ee8013ce61$export$526fec6b76d5bc5);
            this.validateGroupTitle = (title)=>{
                if (title.length < 256) return;
                return this.props.intl.formatMessage((0, $1cJPY.default).tooLongInputErrorMessage);
            };
        }
    }
    var $add0e6e6ccd86864$export$2e2bcd8739ae039 = (0, $84qTJ.injectIntlWithDefaultProps)($add0e6e6ccd86864$var$Group);
});
parcelRegister("84qTJ", function(module, exports) {
    $parcel$export(module.exports, "injectIntlWithDefaultProps", ()=>$2990fa35a8be2256$export$c4e12df8dd8762cd);
    var $8RXs9;
    function $2990fa35a8be2256$export$c4e12df8dd8762cd(WrappedComponent) {
        return (0, (0, parcelRequire("8RXs9")).default)(WrappedComponent);
    }
});
parcelRegister("1cJPY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52cc006bdc86c4b1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $52cc006bdc86c4b1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        groupPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.group-placeholder",
            "defaultMessage": "Untitled group"
        },
        tooLongInputErrorMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.too-long-input-error-message",
            "defaultMessage": "Group title cannot be longer than 255 characters"
        },
        expandButtonLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.expand-button-label",
            "defaultMessage": "Expand"
        },
        collapseButtonLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.collapse-button-label",
            "defaultMessage": "Collapse"
        },
        deleteButtonLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.delete-button-label",
            "defaultMessage": "Delete"
        }
    });
});
parcelRegister("ikTAN", function(module, exports) {
    $parcel$export(module.exports, "expandCollapseChevron", ()=>$d59537c91644ba9d$export$a39acbc38d158393, (v)=>$d59537c91644ba9d$export$a39acbc38d158393 = v);
    $parcel$export(module.exports, "group", ()=>$d59537c91644ba9d$export$e5e25fbcc1f7affe, (v)=>$d59537c91644ba9d$export$e5e25fbcc1f7affe = v);
    $parcel$export(module.exports, "groupTitle", ()=>$d59537c91644ba9d$export$91bc5dc3bf221ff4, (v)=>$d59537c91644ba9d$export$91bc5dc3bf221ff4 = v);
    $parcel$export(module.exports, "groupTitleReadViewContainer", ()=>$d59537c91644ba9d$export$a74a63e6c2387008, (v)=>$d59537c91644ba9d$export$a74a63e6c2387008 = v);
    $parcel$export(module.exports, "groupTitleSection", ()=>$d59537c91644ba9d$export$ef200e02c037d06, (v)=>$d59537c91644ba9d$export$ef200e02c037d06 = v);
    $parcel$export(module.exports, "icon", ()=>$d59537c91644ba9d$export$1ca1ec8b29a4ce27, (v)=>$d59537c91644ba9d$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "trashButton", ()=>$d59537c91644ba9d$export$bdb39bfcac72c125, (v)=>$d59537c91644ba9d$export$bdb39bfcac72c125 = v);
    var $d59537c91644ba9d$export$a39acbc38d158393;
    var $d59537c91644ba9d$export$e5e25fbcc1f7affe;
    var $d59537c91644ba9d$export$91bc5dc3bf221ff4;
    var $d59537c91644ba9d$export$a74a63e6c2387008;
    var $d59537c91644ba9d$export$ef200e02c037d06;
    var $d59537c91644ba9d$export$1ca1ec8b29a4ce27;
    var $d59537c91644ba9d$export$bdb39bfcac72c125;
    $d59537c91644ba9d$export$a39acbc38d158393 = `taeYma_expandCollapseChevron`;
    $d59537c91644ba9d$export$e5e25fbcc1f7affe = `taeYma_group`;
    $d59537c91644ba9d$export$91bc5dc3bf221ff4 = `taeYma_groupTitle`;
    $d59537c91644ba9d$export$a74a63e6c2387008 = `taeYma_groupTitleReadViewContainer`;
    $d59537c91644ba9d$export$ef200e02c037d06 = `taeYma_groupTitleSection`;
    $d59537c91644ba9d$export$1ca1ec8b29a4ce27 = `taeYma_icon`;
    $d59537c91644ba9d$export$bdb39bfcac72c125 = `taeYma_trashButton`;
});
parcelRegister("bXs7i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f62e70122bd7bae1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f62e70122bd7bae1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createGroup: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.components.create-group",
            "defaultMessage": "Create group"
        },
        componentPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.components.component-placeholder",
            "defaultMessage": "Choose a component"
        }
    });
});
parcelRegister("ca3ei", function(module, exports) {
    $parcel$export(module.exports, "blue", ()=>$8da8ec8765c73b9b$export$2aa0182783e7e9de, (v)=>$8da8ec8765c73b9b$export$2aa0182783e7e9de = v);
    $parcel$export(module.exports, "componentGroup", ()=>$8da8ec8765c73b9b$export$26fe3bb68f295d9, (v)=>$8da8ec8765c73b9b$export$26fe3bb68f295d9 = v);
    $parcel$export(module.exports, "componentSelect", ()=>$8da8ec8765c73b9b$export$30ae6ac4023c3a21, (v)=>$8da8ec8765c73b9b$export$30ae6ac4023c3a21 = v);
    $parcel$export(module.exports, "icon", ()=>$8da8ec8765c73b9b$export$1ca1ec8b29a4ce27, (v)=>$8da8ec8765c73b9b$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "row", ()=>$8da8ec8765c73b9b$export$120ff0929b202a6d, (v)=>$8da8ec8765c73b9b$export$120ff0929b202a6d = v);
    var $8da8ec8765c73b9b$export$2aa0182783e7e9de;
    var $8da8ec8765c73b9b$export$26fe3bb68f295d9;
    var $8da8ec8765c73b9b$export$30ae6ac4023c3a21;
    var $8da8ec8765c73b9b$export$a39acbc38d158393;
    var $8da8ec8765c73b9b$export$91bc5dc3bf221ff4;
    var $8da8ec8765c73b9b$export$ef200e02c037d06;
    var $8da8ec8765c73b9b$export$1ca1ec8b29a4ce27;
    var $8da8ec8765c73b9b$export$120ff0929b202a6d;
    var $8da8ec8765c73b9b$export$bdb39bfcac72c125;
    $8da8ec8765c73b9b$export$2aa0182783e7e9de = `epJkjG_blue`;
    $8da8ec8765c73b9b$export$26fe3bb68f295d9 = `epJkjG_componentGroup`;
    $8da8ec8765c73b9b$export$30ae6ac4023c3a21 = `epJkjG_componentSelect`;
    $8da8ec8765c73b9b$export$a39acbc38d158393 = `epJkjG_expandCollapseChevron`;
    $8da8ec8765c73b9b$export$91bc5dc3bf221ff4 = `epJkjG_groupTitle`;
    $8da8ec8765c73b9b$export$ef200e02c037d06 = `epJkjG_groupTitleSection`;
    $8da8ec8765c73b9b$export$1ca1ec8b29a4ce27 = `epJkjG_icon`;
    $8da8ec8765c73b9b$export$120ff0929b202a6d = `epJkjG_row`;
    $8da8ec8765c73b9b$export$bdb39bfcac72c125 = `epJkjG_trashButton`;
});
parcelRegister("35huV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f76a496e2519470$export$2e2bcd8739ae039);
    var $bC2fB;
    var $f5rsm = parcelRequire("f5rsm");
    var $a9XZL = parcelRequire("a9XZL");
    var $frIXg = parcelRequire("frIXg");
    var $4f76a496e2519470$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $a9XZL.default), (0, $f5rsm.default))((0, $frIXg.default));
});
parcelRegister("f5rsm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4bc782e91ae34dc$export$2e2bcd8739ae039);
    var $aGrEZ = parcelRequire("aGrEZ");
    const $f4bc782e91ae34dc$var$mapDispatchToProps = (dispatch)=>({
            addGroup: (grouping, group)=>{
                dispatch((0, $aGrEZ.add)({
                    grouping: grouping,
                    group: group
                }));
            },
            updateGroup: (grouping, groupId, patch)=>{
                dispatch((0, $aGrEZ.update)({
                    grouping: grouping,
                    id: groupId,
                    patch: patch
                }));
            },
            removeGroup: (grouping, groupId)=>{
                dispatch((0, $aGrEZ.remove)({
                    grouping: grouping,
                    id: groupId
                }));
            }
        });
    var $f4bc782e91ae34dc$export$2e2bcd8739ae039 = $f4bc782e91ae34dc$var$mapDispatchToProps;
});
parcelRegister("a9XZL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b02474cb4cc53ad$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $ewRil = parcelRequire("ewRil");
    var $j0XCX = parcelRequire("j0XCX");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $cScrq = parcelRequire("cScrq");
    const $0b02474cb4cc53ad$var$getGroupingCustomFieldType = (0, $3YtPS.createSelector)([
        (0, $19iju.getCustomFieldsById),
        (0, $j0XCX.getVisualisationGrouping)
    ], (customFieldsById, grouping)=>{
        if (!(0, $cScrq.isRoadmapGroupedByCustomField)(grouping)) return '';
        const fieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
        if ((0, $4nDwW.isDefined)(customFieldsById)) return customFieldsById[fieldId]?.type.key;
        return '';
    });
    const $0b02474cb4cc53ad$var$getCustomFieldOptions = (0, $3YtPS.createSelector)([
        (0, $j0XCX.getVisualisationGrouping),
        (0, $19iju.getSelectOptions)
    ], (grouping, selectOptions)=>{
        if (!(0, $cScrq.isRoadmapGroupedByCustomField)(grouping)) return [];
        const fieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
        return selectOptions.filter((option)=>option.fieldId === fieldId);
    });
    const $0b02474cb4cc53ad$var$getCustomLabelFieldOptions = (0, $3YtPS.createSelector)([
        $0b02474cb4cc53ad$var$getGroupingCustomFieldType,
        (0, $ewRil.getCustomLabelsByField),
        (0, $j0XCX.getVisualisationGrouping)
    ], (groupingCustomFieldType, customLabelsByField, grouping)=>{
        if (!(0, $cScrq.isRoadmapGroupedByCustomField)(grouping)) return [];
        if (groupingCustomFieldType === (0, $TTKUQ.CustomFieldTypes).Labels) {
            const fieldId = parseInt((0, $cScrq.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
            return customLabelsByField[fieldId] || [];
        }
        return [];
    });
    var $0b02474cb4cc53ad$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        customFieldValuesGroups: (0, $j0XCX.getCustomFieldValuesGroups),
        customLabelFieldOptions: $0b02474cb4cc53ad$var$getCustomLabelFieldOptions,
        grouping: (0, $j0XCX.getVisualisationGrouping),
        groupingCustomFieldType: $0b02474cb4cc53ad$var$getGroupingCustomFieldType,
        selectOptions: $0b02474cb4cc53ad$var$getCustomFieldOptions
    });
});
parcelRegister("ewRil", function(module, exports) {
    $parcel$export(module.exports, "getCustomLabelsByField", ()=>$5b21f641c0598417$export$cd4f35dafaa09986);
    const $5b21f641c0598417$export$cd4f35dafaa09986 = (state)=>state.domain.customLabelsByField;
});
parcelRegister("frIXg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb8799f0b03b670f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b1yMp;
    var $2rMKg;
    var $h35CY;
    var $hpnKp;
    var $9lMrf;
    var $koVbs;
    var $aCpcO;
    var $gJZ5D;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fWp2V = parcelRequire("fWp2V");
    var $fDUYp = parcelRequire("fDUYp");
    var $gKWoe = parcelRequire("gKWoe");
    function $cb8799f0b03b670f$export$2e2bcd8739ae039({ addGroup: addGroup, customFieldValuesGroups: customFieldValuesGroups, customLabelFieldOptions: customLabelFieldOptions, grouping: grouping, groupingCustomFieldType: groupingCustomFieldType, onMenuToggle: onMenuToggle, selectOptions: selectOptions, removeGroup: removeGroup, updateGroup: updateGroup }) {
        const [isCreating, setIsCreating] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const trimName = (name)=>{
            const maxLength = 254;
            return name.length > maxLength ? name.substring(0, maxLength) : name;
        };
        const isNewGroupNameValid = (newName)=>{
            const allGroupNames = new Set(customFieldValuesGroups.map(({ name: name })=>name));
            return !allGroupNames.has(newName);
        };
        const onCreateGroup = ()=>{
            setIsCreating(true);
        };
        const onCancelCreateGroup = ()=>{
            setIsCreating(false);
        };
        const onConfirmingCreateGroup = (newName)=>{
            onCancelCreateGroup();
            if (newName.length === 0 || !isNewGroupNameValid(newName)) return;
            addGroup(grouping, {
                id: trimName(newName).toLowerCase(),
                name: trimName(newName),
                isExpanded: true,
                [grouping]: []
            });
        };
        const onConfirmingUpdateGroup = (id, newName)=>{
            if (newName.length === 0 || !isNewGroupNameValid(newName)) return;
            updateGroup(grouping, id, {
                id: trimName(newName).toLowerCase(),
                name: trimName(newName)
            });
        };
        const onUpdatingValuesInGroup = (id, selectValue)=>{
            if ((0, $4nDwW.isDefined)(selectValue)) updateGroup(grouping, id, {
                [grouping]: selectValue.map(({ value: value })=>value)
            });
        };
        const toggleExpanded = (id, isExpanded)=>{
            updateGroup(grouping, id, {
                isExpanded: isExpanded
            });
        };
        const renderComponentSelect = (groupId, values)=>{
            let options = [];
            let valueOptions = [];
            if (groupingCustomFieldType === (0, $TTKUQ.CustomFieldTypes).Labels) {
                options = customLabelFieldOptions.map((label)=>({
                        value: label,
                        label: label
                    }));
                valueOptions = options.filter(({ value: value })=>values.includes(value));
            } else {
                options = (0, parcelRequire("h35CY")).default((0, parcelRequire("b1yMp")).default((0, parcelRequire("hpnKp")).default, (0, parcelRequire("2rMKg")).default('value')))(selectOptions).map(({ id: id, value: value })=>({
                        value: id,
                        label: value
                    }));
                valueOptions = options.filter(({ value: value })=>values.includes(value));
            }
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                className: $gKWoe.row
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                colSpan: 2
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gKWoe.customFieldValueSelect
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                autoFocus: true,
                classNamePrefix: "group-by-custom-options-select",
                defaultValue: valueOptions,
                isMulti: true,
                menuPortalTarget: (0, $4y9A5.getBody)(),
                onChange: (value)=>onUpdatingValuesInGroup(groupId, value),
                onMenuClose: ()=>{
                    onMenuToggle(false);
                },
                onMenuOpen: ()=>{
                    onMenuToggle(true);
                },
                options: options,
                placeholder: formatMessage((0, $fDUYp.default).componentPlaceholder),
                "aria-label": formatMessage((0, $fDUYp.default).componentPlaceholder),
                styles: {
                    menuPortal: (styles)=>({
                            ...styles,
                            zIndex: 1000
                        })
                }
            })))));
        };
        const renderGroup = (group)=>{
            const { id: id, isExpanded: isExpanded, [grouping]: values } = group;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: id
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                className: $gKWoe.row,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.custom-fields.group"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                colSpan: 2
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWp2V.default), {
                groupId: id,
                groupName: group.name,
                isExpanded: isExpanded,
                onCancel: onCancelCreateGroup,
                onConfirm: (newName)=>{
                    onConfirmingUpdateGroup(id, newName);
                },
                onDelete: (groupId)=>removeGroup(grouping, groupId),
                onToggleExpanded: toggleExpanded
            }))), id !== (0, $10afd8ee8013ce61$export$526fec6b76d5bc5) && isExpanded && renderComponentSelect(id, values));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, customFieldValuesGroups.map(renderGroup), isCreating && (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
            className: $gKWoe.row
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            colSpan: 2
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWp2V.default), {
            onCancel: onCancelCreateGroup,
            onConfirm: onConfirmingCreateGroup,
            shouldCreateGroup: true
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            colSpan: 2
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gKWoe.customFieldValuesGroup
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gKWoe.icon
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
            label: "",
            primaryColor: `var(--ds-text-brand, ${(0, (0, parcelRequire("gJZ5D")).default).B400})`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "link",
            onClick: onCreateGroup,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.custom-fields.create-custom-field-values-group"
        }, formatMessage((0, $fDUYp.default).createGroup))))));
    }
});
parcelRegister("fDUYp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$114d82581d5cc03e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $114d82581d5cc03e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createGroup: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.custom-fields.create-group",
            "defaultMessage": "Create group"
        },
        componentPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.custom-fields.component-placeholder",
            "defaultMessage": "Choose a value"
        }
    });
});
parcelRegister("gKWoe", function(module, exports) {
    $parcel$export(module.exports, "customFieldValueSelect", ()=>$c32e3c3d0ecb3dc8$export$ce6e55e8280c094f, (v)=>$c32e3c3d0ecb3dc8$export$ce6e55e8280c094f = v);
    $parcel$export(module.exports, "customFieldValuesGroup", ()=>$c32e3c3d0ecb3dc8$export$492b91577b69d574, (v)=>$c32e3c3d0ecb3dc8$export$492b91577b69d574 = v);
    $parcel$export(module.exports, "icon", ()=>$c32e3c3d0ecb3dc8$export$1ca1ec8b29a4ce27, (v)=>$c32e3c3d0ecb3dc8$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "row", ()=>$c32e3c3d0ecb3dc8$export$120ff0929b202a6d, (v)=>$c32e3c3d0ecb3dc8$export$120ff0929b202a6d = v);
    var $c32e3c3d0ecb3dc8$export$ce6e55e8280c094f;
    var $c32e3c3d0ecb3dc8$export$492b91577b69d574;
    var $c32e3c3d0ecb3dc8$export$91bc5dc3bf221ff4;
    var $c32e3c3d0ecb3dc8$export$1ca1ec8b29a4ce27;
    var $c32e3c3d0ecb3dc8$export$120ff0929b202a6d;
    $c32e3c3d0ecb3dc8$export$ce6e55e8280c094f = `_6yml3W_customFieldValueSelect`;
    $c32e3c3d0ecb3dc8$export$492b91577b69d574 = `_6yml3W_customFieldValuesGroup`;
    $c32e3c3d0ecb3dc8$export$91bc5dc3bf221ff4 = `_6yml3W_groupTitle`;
    $c32e3c3d0ecb3dc8$export$1ca1ec8b29a4ce27 = `_6yml3W_icon`;
    $c32e3c3d0ecb3dc8$export$120ff0929b202a6d = `_6yml3W_row`;
});
parcelRegister("7V9IL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6eb8766f60840ee$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7Q3AB = parcelRequire("7Q3AB");
    var $5Ud5C = parcelRequire("5Ud5C");
    var $dOsnc = parcelRequire("dOsnc");
    var $e6eb8766f60840ee$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $5Ud5C.mapStateToProps), (0, $7Q3AB.default))((0, $dOsnc.default));
});
parcelRegister("7Q3AB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c75b156610a8ca5b$export$2e2bcd8739ae039);
    var $dBbgF = parcelRequire("dBbgF");
    const $c75b156610a8ca5b$var$mapDispatchToProps = (dispatch)=>({
            changeGroup: (group)=>{
                dispatch((0, $dBbgF.changeGroup)({
                    grouping: group
                }));
            }
        });
    var $c75b156610a8ca5b$export$2e2bcd8739ae039 = $c75b156610a8ca5b$var$mapDispatchToProps;
});
parcelRegister("5Ud5C", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$502e48639dfb6421$export$c31df4bd766f9c35);
    var $1CGdp = parcelRequire("1CGdp");
    var $19iju = parcelRequire("19iju");
    var $jpgxP = parcelRequire("jpgxP");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    const $502e48639dfb6421$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        customFields: (0, $19iju.getCustomFields),
        grouping: (0, $j0XCX.getVisualisationGrouping),
        isAtlasConnectInstalled: $jpgxP.isAtlasConnectInstalled,
        isEmbedMode: (0, $1CGdp.isEmbed),
        isConfluenceMacroMode: (0, $1CGdp.isConfluenceMacro)
    });
});
parcelRegister("dOsnc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c72209f85b20bc8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eTXmK;
    var $koVbs;
    var $i2qlb = parcelRequire("i2qlb");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $30sno = parcelRequire("30sno");
    var $1Cyfv = parcelRequire("1Cyfv");
    var $8zOmE;
    var $2NMNM;
    var $el0Tu = parcelRequire("el0Tu");
    var $lAlnN = parcelRequire("lAlnN");
    function $1c72209f85b20bc8$export$2e2bcd8739ae039({ changeGroup: changeGroup, customFields: customFields, grouping: grouping, isDefaultMenuOpen: isDefaultMenuOpen = false, onMenuToggle: onMenuToggle, isAtlasConnectInstalled: isAtlasConnectInstalled, isEmbedMode: isEmbedMode, isConfluenceMacroMode: isConfluenceMacroMode }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isEmbedOrMacro = isEmbedMode || isConfluenceMacroMode;
        const changeGroupBy = ({ type: type, value: value })=>{
            (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).CHANGE_GROUP_BY_SETTING);
            changeGroup(value);
            const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).GROUP_BY_CLICKED.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject,
                action: action
            }), actionSubjectId, {
                newPlanSettingValue: type
            });
        };
        const standardFieldsOptions = Object.keys((0, $30sno.standardFieldsGroupings)(isAtlasConnectInstalled, isEmbedOrMacro)).map((key)=>({
                content: formatMessage((0, $30sno.getGroupByStandardFieldLabel)(key, isEmbedOrMacro)),
                id: key,
                label: formatMessage((0, $30sno.getGroupByStandardFieldLabel)(key, isEmbedOrMacro)),
                type: key,
                value: key
            }));
        const customFieldsOptions = Object.entries((0, $30sno.getGroupingCustomFields)(customFields)).map(([key, { title: title, type: type }])=>({
                content: title,
                id: key,
                label: title,
                type: type,
                value: key
            })) ?? [];
        if (!isAtlasConnectInstalled && grouping === (0, $TTKUQ.GROUPING).GOALS) changeGroupBy({
            type: 'standard',
            value: (0, $TTKUQ.GROUPING).NONE
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $el0Tu.default), {
            classNamePrefix: "portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_group-by",
            customFieldsOptions: customFieldsOptions,
            handleOnChange: changeGroupBy,
            isDefaultMenuOpen: isDefaultMenuOpen,
            onMenuToggle: onMenuToggle,
            standardFieldsOptions: standardFieldsOptions,
            selectedFieldId: grouping,
            label: formatMessage((0, $lAlnN.default).groupByLabel)
        });
    }
});
parcelRegister("lAlnN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca538eb53e01b9bf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ca538eb53e01b9bf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        groupByLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.group-by-label",
            "defaultMessage": "Group by"
        }
    });
});
parcelRegister("fG4bS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c4b60e37e72c13c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $flT7y = parcelRequire("flT7y");
    var $hCx7w = parcelRequire("hCx7w");
    var $gWGTd = parcelRequire("gWGTd");
    var $6c4b60e37e72c13c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hCx7w.default), (0, $flT7y.default))((0, $gWGTd.default));
});
parcelRegister("flT7y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cee4b9d0413685c3$export$2e2bcd8739ae039);
    var $7kNeW = parcelRequire("7kNeW");
    const $cee4b9d0413685c3$var$mapDispatchToProps = (dispatch)=>({
            addGroup: (name)=>{
                dispatch((0, $7kNeW.add)({
                    id: name.toLowerCase(),
                    name: name,
                    isExpanded: true,
                    labels: []
                }));
            },
            updateGroup: (groupId, patch)=>{
                dispatch((0, $7kNeW.update)({
                    id: groupId,
                    patch: patch
                }));
            },
            removeGroup: (groupId)=>{
                dispatch((0, $7kNeW.remove)(groupId));
            }
        });
    var $cee4b9d0413685c3$export$2e2bcd8739ae039 = $cee4b9d0413685c3$var$mapDispatchToProps;
});
parcelRegister("hCx7w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6be8a25e74ebc7d$export$2e2bcd8739ae039);
    var $abnJk = parcelRequire("abnJk");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    const $a6be8a25e74ebc7d$export$a9e58a8ee6cd2485 = (issueLabels)=>issueLabels.map((label)=>({
                value: label,
                label: label
            }));
    const $a6be8a25e74ebc7d$var$getSelectOptions = (0, $3YtPS.createSelector)([
        (0, $abnJk.getIssueLabels)
    ], $a6be8a25e74ebc7d$export$a9e58a8ee6cd2485);
    var $a6be8a25e74ebc7d$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        labelGroups: (0, $kWDpn.getLabelsGroupViewSettings),
        selectOptions: $a6be8a25e74ebc7d$var$getSelectOptions,
        groupAttribute: ()=>'labels'
    });
});
parcelRegister("gWGTd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3294bf3238a17f13$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9lMrf;
    var $8RXs9;
    var $aCpcO;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $fWp2V = parcelRequire("fWp2V");
    var $fVvDG = parcelRequire("fVvDG");
    var $hR5MO = parcelRequire("hR5MO");
    const $3294bf3238a17f13$var$trimName = (name)=>{
        const maxLength = 254;
        return name.length > maxLength ? name.substring(0, maxLength) : name;
    };
    class $3294bf3238a17f13$var$GroupByLabels extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.isNewGroupNameValid = (newName)=>{
                const allGroupNames = new Set(this.props.labelGroups.map(({ name: name })=>name));
                return !allGroupNames.has(newName);
            };
            this.isAllOtherIssuesGroup = (id)=>id === (0, $10afd8ee8013ce61$export$526fec6b76d5bc5);
            this.onCreateGroup = ()=>this.setState({
                    isCreating: true
                });
            this.onCancelCreateGroup = ()=>this.setState({
                    isCreating: false
                });
            this.onConfirmingCreateGroup = (newName)=>{
                this.onCancelCreateGroup();
                if (newName.length === 0 || !this.isNewGroupNameValid(newName)) return;
                this.props.addGroup($3294bf3238a17f13$var$trimName(newName));
            };
            this.onConfirmingUpdateGroup = (id, newName)=>{
                if (newName.length === 0 || !this.isNewGroupNameValid(newName)) return;
                this.props.updateGroup(id, {
                    id: $3294bf3238a17f13$var$trimName(newName).toLowerCase(),
                    name: $3294bf3238a17f13$var$trimName(newName)
                });
            };
            this.onUpdatingValuesInGroup = (id, selectValue)=>{
                if ((0, $4nDwW.isDefined)(selectValue)) this.props.updateGroup(id, {
                    [this.props.groupAttribute]: selectValue.map(({ value: value })=>value)
                });
            };
            this.toggleExpanded = (id, isExpanded)=>this.props.updateGroup(id, {
                    isExpanded: isExpanded
                });
            this.renderSelect = (groupId, groupValues)=>{
                const { intl: { formatMessage: formatMessage }, onMenuToggle: onMenuToggle, selectOptions: selectOptions } = this.props;
                const valueOptions = selectOptions.filter(({ value: value })=>groupValues.includes(value));
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $hR5MO.row
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $hR5MO.labelSelect
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                    autoFocus: true,
                    classNamePrefix: "group-by-custom-options-select",
                    defaultValue: valueOptions,
                    isMulti: true,
                    menuPlacement: "auto",
                    menuPortalTarget: (0, $4y9A5.getBody)(),
                    onChange: (value)=>this.onUpdatingValuesInGroup(groupId, value),
                    onMenuClose: ()=>{
                        onMenuToggle(false);
                    },
                    onMenuOpen: ()=>{
                        onMenuToggle(true);
                    },
                    options: selectOptions,
                    placeholder: formatMessage((0, $fVvDG.default).labelPlaceholder),
                    "aria-label": formatMessage((0, $fVvDG.default).labelPlaceholder),
                    styles: {
                        menuPortal: (styles)=>({
                                ...styles,
                                zIndex: 1000
                            })
                    }
                })))));
            };
            this.renderGroup = (group)=>{
                const { groupAttribute: groupAttribute, removeGroup: removeGroup } = this.props;
                const { id: id, isExpanded: isExpanded, [groupAttribute]: groupValues } = group;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                    key: id
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                    className: $hR5MO.row,
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.labels.group"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                    colSpan: 2
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWp2V.default), {
                    groupName: group.name,
                    groupId: id,
                    isExpanded: isExpanded,
                    onConfirm: (newName)=>{
                        this.onConfirmingUpdateGroup(id, newName);
                    },
                    onCancel: this.onCancelCreateGroup,
                    onDelete: removeGroup,
                    onToggleExpanded: this.toggleExpanded
                }))), !this.isAllOtherIssuesGroup(id) && isExpanded && this.renderSelect(id, groupValues));
            };
            this.state = {
                isCreating: false
            };
        }
        render() {
            const { intl: { formatMessage: formatMessage }, labelGroups: labelGroups } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, labelGroups.map(this.renderGroup), this.state.isCreating && (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                className: $hR5MO.row,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.labels.label-group-creating"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                colSpan: 2
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fWp2V.default), {
                shouldCreateGroup: true,
                onConfirm: this.onConfirmingCreateGroup,
                onCancel: this.onCancelCreateGroup
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                colSpan: 2
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $hR5MO.labelGroup
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: `${$hR5MO.icon} ${$hR5MO.blue}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: ""
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                appearance: "link",
                onClick: this.onCreateGroup,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.labels.create-labels-group"
            }, formatMessage((0, $fVvDG.default).createGroup))))));
        }
    }
    var $3294bf3238a17f13$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($3294bf3238a17f13$var$GroupByLabels);
});
parcelRegister("fVvDG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3aaf41f8095c078d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3aaf41f8095c078d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createGroup: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.labels.create-group",
            "defaultMessage": "Create group"
        },
        labelPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.labels.label-placeholder",
            "defaultMessage": "Choose a label"
        }
    });
});
parcelRegister("hR5MO", function(module, exports) {
    $parcel$export(module.exports, "blue", ()=>$cffbdfee41f324ba$export$2aa0182783e7e9de, (v)=>$cffbdfee41f324ba$export$2aa0182783e7e9de = v);
    $parcel$export(module.exports, "icon", ()=>$cffbdfee41f324ba$export$1ca1ec8b29a4ce27, (v)=>$cffbdfee41f324ba$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "labelGroup", ()=>$cffbdfee41f324ba$export$cd3543f471a6c0aa, (v)=>$cffbdfee41f324ba$export$cd3543f471a6c0aa = v);
    $parcel$export(module.exports, "labelSelect", ()=>$cffbdfee41f324ba$export$519b192a392926cb, (v)=>$cffbdfee41f324ba$export$519b192a392926cb = v);
    $parcel$export(module.exports, "row", ()=>$cffbdfee41f324ba$export$120ff0929b202a6d, (v)=>$cffbdfee41f324ba$export$120ff0929b202a6d = v);
    var $cffbdfee41f324ba$export$2aa0182783e7e9de;
    var $cffbdfee41f324ba$export$a39acbc38d158393;
    var $cffbdfee41f324ba$export$91bc5dc3bf221ff4;
    var $cffbdfee41f324ba$export$ef200e02c037d06;
    var $cffbdfee41f324ba$export$1ca1ec8b29a4ce27;
    var $cffbdfee41f324ba$export$cd3543f471a6c0aa;
    var $cffbdfee41f324ba$export$519b192a392926cb;
    var $cffbdfee41f324ba$export$120ff0929b202a6d;
    var $cffbdfee41f324ba$export$bdb39bfcac72c125;
    $cffbdfee41f324ba$export$2aa0182783e7e9de = `x5vVhW_blue`;
    $cffbdfee41f324ba$export$a39acbc38d158393 = `x5vVhW_expandCollapseChevron`;
    $cffbdfee41f324ba$export$91bc5dc3bf221ff4 = `x5vVhW_groupTitle`;
    $cffbdfee41f324ba$export$ef200e02c037d06 = `x5vVhW_groupTitleSection`;
    $cffbdfee41f324ba$export$1ca1ec8b29a4ce27 = `x5vVhW_icon`;
    $cffbdfee41f324ba$export$cd3543f471a6c0aa = `x5vVhW_labelGroup`;
    $cffbdfee41f324ba$export$519b192a392926cb = `x5vVhW_labelSelect`;
    $cffbdfee41f324ba$export$120ff0929b202a6d = `x5vVhW_row`;
    $cffbdfee41f324ba$export$bdb39bfcac72c125 = `x5vVhW_trashButton`;
});
parcelRegister("8SFDO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40d375b9dc507c13$export$2e2bcd8739ae039);
    var $cukx3 = parcelRequire("cukx3");
    var $kWDpn = parcelRequire("kWDpn");
    var $fJ4u7 = parcelRequire("fJ4u7");
    var $bC2fB;
    var $aXnTH = parcelRequire("aXnTH");
    const $40d375b9dc507c13$var$mapStateToProps = (state)=>({
            rollupSettings: (0, $kWDpn.getRollupViewSettings)(state)
        });
    const $40d375b9dc507c13$var$mapDispatchToProps = (dispatch)=>({
            setShowingRolledUpDates: (shouldShow)=>{
                dispatch((0, $fJ4u7.setShowRolledUpDates)({
                    shouldShow: shouldShow
                }));
                dispatch((0, $cukx3.calculateStatusOfAllReleases)());
            },
            setShowRolledUpOthers: (shouldShow)=>{
                dispatch((0, $fJ4u7.setShowRolledUpOthers)({
                    shouldShow: shouldShow
                }));
            }
        });
    var $40d375b9dc507c13$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($40d375b9dc507c13$var$mapStateToProps, $40d375b9dc507c13$var$mapDispatchToProps)((0, $aXnTH.default));
});
parcelRegister("aXnTH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa6ec6854bb5b562$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lAcHL;
    var $c8oLN;
    var $jldZL;
    var $4R6GH;
    var $koVbs;
    var $fAGMJ;
    var $i2qlb = parcelRequire("i2qlb");
    var $ihPUd = parcelRequire("ihPUd");
    var $8zOmE;
    var $dCm1o;
    var $9KC5G = parcelRequire("9KC5G");
    var $gSjfg = parcelRequire("gSjfg");
    const $fa6ec6854bb5b562$var$FieldsetWrapper = ({ isVisuallyRefreshed: isVisuallyRefreshed, intl: intl, children: children })=>{
        if (isVisuallyRefreshed) return (0, ($parcel$interopDefault($5uXOq))).createElement("fieldset", null, (0, ($parcel$interopDefault($5uXOq))).createElement("legend", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, intl.formatMessage((0, $9KC5G.default).rollupGroupLabel))), children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8oLN")).default), {
            block: "space.150"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lAcHL")).default), {
            legend: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, intl.formatMessage((0, $9KC5G.default).rollupGroupLabel))
        }, children));
    };
    const $fa6ec6854bb5b562$var$EstimateRollup = ({ rollupSettings: { showingRolledUpDate: showingRolledUpDate, showRolledUpOthers: showRolledUpOthers }, setShowingRolledUpDates: setShowingRolledUpDates, setShowRolledUpOthers: setShowRolledUpOthers })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const othersMessage = (0, $9KC5G.default).showRolledUpOthers;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fa6ec6854bb5b562$var$FieldsetWrapper, {
            isVisuallyRefreshed: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2'),
            intl: intl
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gSjfg.option
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gSjfg.checkboxWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            name: "roll-up",
            "aria-describedby": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-dates",
            isChecked: showingRolledUpDate,
            label: intl.formatMessage((0, $ihPUd.default).dates),
            onChange: (_, analyticsEvent)=>{
                const nextValue = !showingRolledUpDate;
                const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ROLL_UP_DATES_CHANGED.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    actionSubject: actionSubject,
                    action: action
                }), actionSubjectId, {
                    newPlanSettingValue: nextValue
                });
                setShowingRolledUpDates(nextValue);
            },
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-dates"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-dates",
            className: $gSjfg.description
        }, intl.formatMessage({
            ...(0, $9KC5G.default).showingRolledUpDatesDescription
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gSjfg.option
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gSjfg.checkboxWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            name: "roll-up",
            "aria-describedby": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-others",
            isChecked: showRolledUpOthers,
            label: intl.formatMessage({
                ...othersMessage
            }),
            onChange: (_, analyticsEvent)=>{
                const nextValue = !showRolledUpOthers;
                const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ROLL_UP_OTHERS_CHANGED.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    actionSubject: actionSubject,
                    action: action
                }), actionSubjectId, {
                    newPlanSettingValue: nextValue
                });
                setShowRolledUpOthers(nextValue);
            },
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-others"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-others",
            className: $gSjfg.description
        }, intl.formatMessage({
            ...(0, $9KC5G.default).showRolledUpOthersDescription
        }))));
    };
    var $fa6ec6854bb5b562$export$2e2bcd8739ae039 = $fa6ec6854bb5b562$var$EstimateRollup;
});
parcelRegister("lAcHL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7b2d071bcebf40f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $2x3Cb;
    function $e7b2d071bcebf40f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e7b2d071bcebf40f$var$fieldSetStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    const $e7b2d071bcebf40f$var$Fieldset = ({ children: children, legend: legend })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("fieldset", {
            css: $e7b2d071bcebf40f$var$fieldSetStyles
        }, legend && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Legend), null, legend), children);
    };
    var $e7b2d071bcebf40f$export$2e2bcd8739ae039 = $e7b2d071bcebf40f$var$Fieldset;
});
parcelRegister("9KC5G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e4d83b032e0e0a5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1e4d83b032e0e0a5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        showingRolledUpDatesDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.showing-rolled-up-dates-description",
            "defaultMessage": "Show a roll-up of dates in the fields and timeline sections."
        },
        showRolledUpOthers: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.show-rolled-up-others",
            "defaultMessage": "Others"
        },
        showRolledUpOthersDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.show-rolled-up-others-description",
            "defaultMessage": "Show a roll-up of sprints, releases, teams, and estimates in the fields section."
        },
        rollupGroupLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-group-label",
            "defaultMessage": "roll-up"
        },
        showRolledUpLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.show-rolled-up-label",
            "defaultMessage": "Show rolled-up values in fields"
        },
        showRolledUpLabelDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.show-rolled-up-label-description",
            "defaultMessage": "For parent issues, show a preview of the rolled-up values of the child issues in the corresponding fields."
        }
    });
});
parcelRegister("gSjfg", function(module, exports) {
    $parcel$export(module.exports, "checkboxWrapper", ()=>$c4909e2ca013ddfc$export$8b18e1c47ccc2c63, (v)=>$c4909e2ca013ddfc$export$8b18e1c47ccc2c63 = v);
    $parcel$export(module.exports, "description", ()=>$c4909e2ca013ddfc$export$6d59db4903f20f7d, (v)=>$c4909e2ca013ddfc$export$6d59db4903f20f7d = v);
    $parcel$export(module.exports, "option", ()=>$c4909e2ca013ddfc$export$a75d1723e6bda2ec, (v)=>$c4909e2ca013ddfc$export$a75d1723e6bda2ec = v);
    var $c4909e2ca013ddfc$export$8b18e1c47ccc2c63;
    var $c4909e2ca013ddfc$export$6d59db4903f20f7d;
    var $c4909e2ca013ddfc$export$a75d1723e6bda2ec;
    $c4909e2ca013ddfc$export$8b18e1c47ccc2c63 = `xVA1UG_checkboxWrapper`;
    $c4909e2ca013ddfc$export$6d59db4903f20f7d = `xVA1UG_description`;
    $c4909e2ca013ddfc$export$a75d1723e6bda2ec = `xVA1UG_option`;
});
parcelRegister("gH9CP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70d2f1bb7118f565$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5Jsdo = parcelRequire("5Jsdo");
    var $hMmy3 = parcelRequire("hMmy3");
    var $dMrSQ = parcelRequire("dMrSQ");
    var $70d2f1bb7118f565$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hMmy3.default), (0, $5Jsdo.default))((0, $dMrSQ.default));
});
parcelRegister("5Jsdo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$279e6fb55b9f62e1$export$2e2bcd8739ae039);
    var $dBbgF = parcelRequire("dBbgF");
    const $279e6fb55b9f62e1$var$mapDispatchToProps = (dispatch)=>({
            changeSort: (sortBy)=>{
                dispatch((0, $dBbgF.changeSort)({
                    sorting: sortBy
                }));
            }
        });
    var $279e6fb55b9f62e1$export$2e2bcd8739ae039 = $279e6fb55b9f62e1$var$mapDispatchToProps;
});
parcelRegister("hMmy3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fc39e65749620e3$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $io4Ja = parcelRequire("io4Ja");
    var $bHTqr = parcelRequire("bHTqr");
    var $j0XCX = parcelRequire("j0XCX");
    var $3YtPS = parcelRequire("3YtPS");
    var $9fc39e65749620e3$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        customFields: (0, $19iju.getCustomFields),
        sorting: (0, $j0XCX.getVisualisationSorting),
        dateConfiguration: (0, $bHTqr.getDateConfiguration),
        planningUnit: (0, $bHTqr.getPlanningUnit),
        issuePrioritiesIdList: (0, $io4Ja.getIssuePrioritiesIdList)
    });
});
parcelRegister("dMrSQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$480d6f3c43e07b76$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3rLiX;
    var $eTXmK;
    var $koVbs;
    var $i2qlb = parcelRequire("i2qlb");
    var $ja8Lc = parcelRequire("ja8Lc");
    var $bstHg = parcelRequire("bstHg");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $1Cyfv = parcelRequire("1Cyfv");
    var $8zOmE;
    var $2NMNM;
    var $el0Tu = parcelRequire("el0Tu");
    var $fSBX0 = parcelRequire("fSBX0");
    var $hNd1A = parcelRequire("hNd1A");
    var $dbcp2 = parcelRequire("dbcp2");
    function $480d6f3c43e07b76$var$SortBy({ changeSort: changeSort, customFields: customFields, dateConfiguration: dateConfiguration, issuePrioritiesIdList: issuePrioritiesIdList, isDefaultMenuOpen: isDefaultMenuOpen = false, onMenuToggle: onMenuToggle, planningUnit: planningUnit, sorting: sorting }) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleOnChange = ({ defaultDirection: defaultDirection, value: value })=>{
            (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).SORT_BY_FIELD);
            const sortConfiguration = (0, $dbcp2.getSortConfiguration)(String(value), customFields, defaultDirection);
            changeSort(sortConfiguration);
            const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SORT_BY_CLICKED.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: actionSubject,
                action: action
            }), actionSubjectId, {
                newPlanSettingValue: sortConfiguration.isCustomField ? `customfield_${sortConfiguration.type}` : (0, $ja8Lc.getFieldKey)(sortConfiguration.field, planningUnit)
            });
        };
        const onDirectionSelect = (direction)=>{
            changeSort({
                ...sorting,
                direction: direction
            });
        };
        const optionLabels = (0, $dbcp2.getOptionValueLabels)(intl, customFields, planningUnit);
        const standardFieldsOptions = (0, $dbcp2.getStandardFieldsOptions)(dateConfiguration, optionLabels, issuePrioritiesIdList);
        const customFieldsOptions = (0, $dbcp2.getCustomFieldsOptions)(customFields, dateConfiguration);
        const sortDirectionsOptions = [
            {
                name: 'sortDirection',
                value: (0, $TTKUQ.SORT_DIRECTION).ASCENDING,
                label: intl.formatMessage((0, $fSBX0.default).ascending),
                testId: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.ascending'
            },
            {
                name: 'sortDirection',
                value: (0, $TTKUQ.SORT_DIRECTION).DESCENDING,
                label: intl.formatMessage((0, $fSBX0.default).descending),
                testId: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.descending'
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
            className: sorting.field !== (0, $bstHg.ISSUE_FIELDS).RANK ? '' : $hNd1A.row
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null, intl.formatMessage((0, $fSBX0.default).sortByLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            colSpan: 2
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $el0Tu.default), {
            classNamePrefix: "portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_sort-by",
            customFieldsOptions: customFieldsOptions,
            handleOnChange: handleOnChange,
            isDefaultMenuOpen: isDefaultMenuOpen,
            onMenuToggle: onMenuToggle,
            standardFieldsOptions: standardFieldsOptions,
            selectedFieldId: sorting.field,
            label: intl.formatMessage((0, $fSBX0.default).sortByLabel)
        }))), sorting.field !== (0, $bstHg.ISSUE_FIELDS).RANK && (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
            className: $hNd1A.row
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("td", null), (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
            colSpan: 2
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $hNd1A.radioOptions
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3rLiX")).default), {
            onChange: (e)=>onDirectionSelect(e.target.value),
            options: sortDirectionsOptions,
            value: sorting.direction
        })))));
    }
    var $480d6f3c43e07b76$export$2e2bcd8739ae039 = $480d6f3c43e07b76$var$SortBy;
});
parcelRegister("9H7in", function(module, exports) {
    $parcel$export(module.exports, "checkboxInfo", ()=>$70edc9f1d36853cc$export$403f69544f111ddc, (v)=>$70edc9f1d36853cc$export$403f69544f111ddc = v);
    $parcel$export(module.exports, "clearAllButton", ()=>$70edc9f1d36853cc$export$82c3bde2d8663425, (v)=>$70edc9f1d36853cc$export$82c3bde2d8663425 = v);
    $parcel$export(module.exports, "groupByRow", ()=>$70edc9f1d36853cc$export$23669b90095d853d, (v)=>$70edc9f1d36853cc$export$23669b90095d853d = v);
    $parcel$export(module.exports, "rollupSetting", ()=>$70edc9f1d36853cc$export$f1cbbb54ba02ac4f, (v)=>$70edc9f1d36853cc$export$f1cbbb54ba02ac4f = v);
    $parcel$export(module.exports, "row", ()=>$70edc9f1d36853cc$export$120ff0929b202a6d, (v)=>$70edc9f1d36853cc$export$120ff0929b202a6d = v);
    $parcel$export(module.exports, "settingsList", ()=>$70edc9f1d36853cc$export$e7df410635e138ff, (v)=>$70edc9f1d36853cc$export$e7df410635e138ff = v);
    $parcel$export(module.exports, "showCapacityCheckbox", ()=>$70edc9f1d36853cc$export$1ed190a3824c90ae, (v)=>$70edc9f1d36853cc$export$1ed190a3824c90ae = v);
    $parcel$export(module.exports, "topAlignedTd", ()=>$70edc9f1d36853cc$export$ff94d69d5395970d, (v)=>$70edc9f1d36853cc$export$ff94d69d5395970d = v);
    $parcel$export(module.exports, "viewSettingSelect", ()=>$70edc9f1d36853cc$export$24a4da606ee32d0c, (v)=>$70edc9f1d36853cc$export$24a4da606ee32d0c = v);
    var $70edc9f1d36853cc$export$403f69544f111ddc;
    var $70edc9f1d36853cc$export$82c3bde2d8663425;
    var $70edc9f1d36853cc$export$23669b90095d853d;
    var $70edc9f1d36853cc$export$f1cbbb54ba02ac4f;
    var $70edc9f1d36853cc$export$120ff0929b202a6d;
    var $70edc9f1d36853cc$export$e7df410635e138ff;
    var $70edc9f1d36853cc$export$1ed190a3824c90ae;
    var $70edc9f1d36853cc$export$ff94d69d5395970d;
    var $70edc9f1d36853cc$export$24a4da606ee32d0c;
    $70edc9f1d36853cc$export$403f69544f111ddc = `hzFZ5q_checkboxInfo`;
    $70edc9f1d36853cc$export$82c3bde2d8663425 = `hzFZ5q_clearAllButton`;
    $70edc9f1d36853cc$export$23669b90095d853d = `hzFZ5q_groupByRow`;
    $70edc9f1d36853cc$export$f1cbbb54ba02ac4f = `hzFZ5q_rollupSetting`;
    $70edc9f1d36853cc$export$120ff0929b202a6d = `hzFZ5q_row`;
    $70edc9f1d36853cc$export$e7df410635e138ff = `hzFZ5q_settingsList`;
    $70edc9f1d36853cc$export$1ed190a3824c90ae = `hzFZ5q_showCapacityCheckbox`;
    $70edc9f1d36853cc$export$ff94d69d5395970d = `hzFZ5q_topAlignedTd`;
    $70edc9f1d36853cc$export$24a4da606ee32d0c = `hzFZ5q_viewSettingSelect`;
});
parcelRegister("4x9aM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66181a0d43f02b70$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    var $bC2fB;
    var $esF6E = parcelRequire("esF6E");
    const $66181a0d43f02b70$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        isAutoSchedulerEnabled: (0, $bHTqr.getAutoSchedulerEnabled)
    });
    var $66181a0d43f02b70$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($66181a0d43f02b70$var$mapStateToProps, {})((0, $esF6E.default));
});
parcelRegister("esF6E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2e8a284497d79ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $3HwlS;
    var $6jY6G;
    const $e2e8a284497d79ed$var$AutoSchedulerSwitch = (props)=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { name: routeName } = route;
        const { children: children, isAutoSchedulerEnabled: isAutoSchedulerEnabled } = props;
        if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children(isAutoSchedulerEnabled && routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children(isAutoSchedulerEnabled));
    };
    var $e2e8a284497d79ed$export$2e2bcd8739ae039 = $e2e8a284497d79ed$var$AutoSchedulerSwitch;
});
parcelRegister("4Y7Vp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6c50c26f2b8512f$export$2e2bcd8739ae039);
    var $f8C8L = parcelRequire("f8C8L");
    var $1CGdp = parcelRequire("1CGdp");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $dRVQG = parcelRequire("dRVQG");
    var $bC2fB;
    var $hKdG0 = parcelRequire("hKdG0");
    const $d6c50c26f2b8512f$var$mapStateToProps = (state)=>{
        const mode = (0, $1CGdp.getMode)(state);
        return {
            showSpinner: mode === (0, $ab4be2e1e204af69$export$7536581a3f6533cb),
            selectedIssueCount: (0, $bI9dZ.getSelectedIssues)(state).length,
            existingTeams: (0, $dRVQG.getExistingTeams)(state)
        };
    };
    const $d6c50c26f2b8512f$var$mapDispatchToProps = (dispatch)=>({
            onOptimize: (analyticsEvent)=>{
                dispatch((0, $f8C8L.startOptimize)(analyticsEvent));
            }
        });
    var $d6c50c26f2b8512f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($d6c50c26f2b8512f$var$mapStateToProps, $d6c50c26f2b8512f$var$mapDispatchToProps)((0, $hKdG0.default));
});
parcelRegister("f8C8L", function(module, exports) {
    $parcel$export(module.exports, "BEFORE_APPLY_CHANGE", ()=>$47ca425c9bc61744$export$76a37d622d00e9f7);
    $parcel$export(module.exports, "AFTER_APPLY_CHANGE", ()=>$47ca425c9bc61744$export$10e12d040017c5fd);
    $parcel$export(module.exports, "BEFORE_OPTIMIZE_CALCULATION", ()=>$47ca425c9bc61744$export$68b581ada2ac0283);
    $parcel$export(module.exports, "AFTER_OPTIMIZE_CALCULATION", ()=>$47ca425c9bc61744$export$152246657c0e60d3);
    $parcel$export(module.exports, "startOptimize", ()=>$47ca425c9bc61744$export$95aeb3ead71202f6);
    $parcel$export(module.exports, "cancelOptimize", ()=>$47ca425c9bc61744$export$22316cffb5125c18);
    $parcel$export(module.exports, "applyChange", ()=>$47ca425c9bc61744$export$6fbe08f3dbfbccb2);
    $parcel$export(module.exports, "default", ()=>$47ca425c9bc61744$export$2e2bcd8739ae039);
    parcelRequire("dcevF");
    var $hIYGf = parcelRequire("hIYGf");
    var $2XSIf;
    var $4Rr1a;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    var $1CGdp = parcelRequire("1CGdp");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $cZF7S = parcelRequire("cZF7S");
    var $lYuBN = parcelRequire("lYuBN");
    var $36p1o = parcelRequire("36p1o");
    var $7vqYD = parcelRequire("7vqYD");
    var $77QEM = parcelRequire("77QEM");
    var $goTVH = parcelRequire("goTVH");
    var $24CMK = parcelRequire("24CMK");
    var $atnIT = parcelRequire("atnIT");
    var $kX5YK = parcelRequire("kX5YK");
    var $fy2pg = parcelRequire("fy2pg");
    const $47ca425c9bc61744$export$982c77cfe4f10899 = 'command.optimize.START_OPTIMIZE';
    const $47ca425c9bc61744$export$b552825ff76c8dca = 'command.optimize.CANCEL_OPTIMIZE';
    const $47ca425c9bc61744$export$b6d845d94d76e436 = 'command.optimize.APPLY_CHANGE';
    const $47ca425c9bc61744$export$76a37d622d00e9f7 = 'command.optimize.BEFORE_APPLY_CHANGE';
    const $47ca425c9bc61744$export$10e12d040017c5fd = 'command.optimize.AFTER_APPLY_CHANGE';
    const $47ca425c9bc61744$export$68b581ada2ac0283 = 'command.optimize.BEFORE_OPTIMIZE_CALCULATION';
    const $47ca425c9bc61744$export$152246657c0e60d3 = 'command.optimize.AFTER_OPTIMIZE_CALCULATION';
    const $47ca425c9bc61744$export$95aeb3ead71202f6 = (analyticsEvent)=>({
            type: $47ca425c9bc61744$export$982c77cfe4f10899,
            meta: {
                analyticsEvent: analyticsEvent
            }
        });
    const $47ca425c9bc61744$export$22316cffb5125c18 = ()=>({
            type: $47ca425c9bc61744$export$b552825ff76c8dca
        });
    const $47ca425c9bc61744$export$6fbe08f3dbfbccb2 = ()=>({
            type: $47ca425c9bc61744$export$b6d845d94d76e436
        });
    const $47ca425c9bc61744$export$52e6dbf58c39b42b = ()=>({
            type: $47ca425c9bc61744$export$76a37d622d00e9f7
        });
    const $47ca425c9bc61744$export$cc3f63d32a5b42ff = ()=>({
            type: $47ca425c9bc61744$export$10e12d040017c5fd
        });
    const $47ca425c9bc61744$export$f370c41c3524f7bd = ()=>({
            type: $47ca425c9bc61744$export$68b581ada2ac0283
        });
    const $47ca425c9bc61744$export$1c02c78aae1d79d1 = (analyticsEvent)=>({
            type: $47ca425c9bc61744$export$152246657c0e60d3,
            meta: {
                analyticsEvent: analyticsEvent
            }
        });
    const $47ca425c9bc61744$var$APPLY_CHANGES_POLL_DELAY = 1000;
    const $47ca425c9bc61744$var$AUTO_SCHEDULE_FIRST_POLL_DELAY = 300;
    const $47ca425c9bc61744$var$AUTO_SCHEDULE_NEXT_POLL_DELAY = 1000;
    function* $47ca425c9bc61744$export$59e7395bfe4ec720(error) {
        yield (0, $aNOuE.put)((0, $24CMK.genericError)(error));
        yield (0, $aNOuE.put)($47ca425c9bc61744$export$22316cffb5125c18());
    }
    function* $47ca425c9bc61744$export$17eb80881f8092da() {
        const url = (0, $fy2pg.urls).pollOptimize;
        const { id: planId, currentScenarioId: scenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const body = {
            planId: planId,
            scenarioId: scenarioId
        };
        const calculationId = (yield (0, $aNOuE.select)((0, $cZF7S.getSolution))).id;
        try {
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const { done: done, running: running } = yield (0, $aNOuE.call)(response.json.bind(response));
                if (done && done.id === calculationId && !running) yield (0, $aNOuE.put)((0, $7vqYD.setLatest)(true));
                else yield (0, $aNOuE.put)((0, $7vqYD.setLatest)(false));
            } else yield (0, $aNOuE.call)($47ca425c9bc61744$export$59e7395bfe4ec720, {
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            });
        } catch (e) {
            const errorPayload = {
                message: e.message,
                stackTrace: e.stack
            };
            yield (0, $aNOuE.call)($47ca425c9bc61744$export$59e7395bfe4ec720, errorPayload);
        }
    }
    function* $47ca425c9bc61744$export$3f6a30e15340a142(id, body, meta) {
        const url = (0, $fy2pg.urls).pollOptimize;
        yield (0, $aNOuE.call)((0, $hIYGf.delay), $47ca425c9bc61744$var$AUTO_SCHEDULE_FIRST_POLL_DELAY);
        while(true){
            if ((yield (0, $aNOuE.select)((0, $1CGdp.getMode))) !== (0, $ab4be2e1e204af69$export$7536581a3f6533cb)) break;
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if ((yield (0, $aNOuE.select)((0, $1CGdp.getMode))) !== (0, $ab4be2e1e204af69$export$7536581a3f6533cb)) break;
            if (response.ok) {
                const { done: done, running: running } = yield (0, $aNOuE.call)(response.json.bind(response));
                if (done && done.id >= id) {
                    yield (0, $aNOuE.put)($47ca425c9bc61744$export$1c02c78aae1d79d1(meta.analyticsEvent));
                    yield (0, $aNOuE.call)((0, $goTVH.getBacklog));
                    yield (0, $aNOuE.put)((0, $7vqYD.setValidity)(true));
                    yield (0, $aNOuE.put)((0, $lYuBN.setMode)((0, $ab4be2e1e204af69$export$e91bb82ec00eb771)));
                    break;
                } else if (!(running && running.id >= id)) {
                    yield (0, $aNOuE.call)($47ca425c9bc61744$export$59e7395bfe4ec720, {
                        message: 'Unexpected response'
                    });
                    break;
                }
            } else {
                yield (0, $aNOuE.call)($47ca425c9bc61744$export$59e7395bfe4ec720, {
                    ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                    requestInfo: {
                        url: url,
                        type: (0, $77QEM.POST),
                        status: response.status,
                        body: body
                    }
                });
                break;
            }
            yield (0, $aNOuE.call)((0, $hIYGf.delay), $47ca425c9bc61744$var$AUTO_SCHEDULE_NEXT_POLL_DELAY);
        }
    }
    function* $47ca425c9bc61744$export$120948c802b124a1(meta) {
        yield (0, $aNOuE.put)((0, $lYuBN.setMode)((0, $ab4be2e1e204af69$export$7536581a3f6533cb)));
        const url = (0, $fy2pg.urls).startOptimize;
        const { id: planId, currentScenarioId: scenarioId, autoScheduleConfiguration: basicCalculationConfiguration } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const selectedIssueIdsToSchedule = (0, parcelRequire("4Rr1a")).default((issue)=>issue.id, (yield (0, $aNOuE.select)((0, $bI9dZ.getSelectedIssues))));
        const calculationConfiguration = selectedIssueIdsToSchedule.length > 0 ? (0, parcelRequire("2XSIf")).default('selectedIssueIds', selectedIssueIdsToSchedule, basicCalculationConfiguration) : basicCalculationConfiguration;
        const body = {
            planId: planId,
            scenarioId: scenarioId,
            calculationConfiguration: calculationConfiguration
        };
        try {
            yield (0, $aNOuE.put)($47ca425c9bc61744$export$f370c41c3524f7bd());
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const { id: id } = yield (0, $aNOuE.call)(response.json.bind(response));
                yield (0, $aNOuE.call)($47ca425c9bc61744$export$3f6a30e15340a142, id, body, meta);
            } else if (response.status === 404) yield (0, $aNOuE.call)($47ca425c9bc61744$export$59e7395bfe4ec720, {
                message: '',
                description: (0, $ihPUd.default).planNotFound
            });
            else yield (0, $aNOuE.call)($47ca425c9bc61744$export$59e7395bfe4ec720, {
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            });
        } catch (e) {
            const errorPayload = {
                message: e.message,
                stackTrace: e.stack
            };
            yield (0, $aNOuE.call)($47ca425c9bc61744$export$59e7395bfe4ec720, errorPayload);
        }
    }
    function* $47ca425c9bc61744$export$d6be908d04ca3821(error) {
        yield (0, $aNOuE.put)((0, $24CMK.genericError)(error));
        yield (0, $aNOuE.put)((0, $7vqYD.setProgress)(null));
    }
    function* $47ca425c9bc61744$export$37a8543ad18a3592(id) {
        const url = (0, $fy2pg.urls).pollApplying(id);
        while(true){
            yield (0, $aNOuE.call)((0, $hIYGf.delay), $47ca425c9bc61744$var$APPLY_CHANGES_POLL_DELAY);
            if ((yield (0, $aNOuE.select)((0, $1CGdp.getMode))) !== (0, $ab4be2e1e204af69$export$e91bb82ec00eb771)) {
                yield (0, $aNOuE.put)((0, $7vqYD.setProgress)(null));
                break;
            }
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.GET)
            });
            if (response.ok) {
                const { done: done, progressPercent: progress } = yield (0, $aNOuE.call)(response.json.bind(response));
                if (done) {
                    yield (0, $aNOuE.call)((0, $goTVH.getBacklog));
                    const result = yield (0, $aNOuE.call)((0, $atnIT.getPlanInfo));
                    if (!result) return;
                    const { sequence: sequence } = result;
                    yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
                    yield (0, $aNOuE.put)((0, $kX5YK.getChangesMetadata)());
                    yield (0, $aNOuE.put).resolve($47ca425c9bc61744$export$cc3f63d32a5b42ff());
                    yield (0, $aNOuE.put)((0, $lYuBN.setMode)((0, $ab4be2e1e204af69$export$250171a898bf7ef)));
                    break;
                } else if ((0, $4nDwW.isDefined)(progress)) yield (0, $aNOuE.put)((0, $7vqYD.setProgress)(progress));
                else {
                    yield (0, $aNOuE.call)($47ca425c9bc61744$export$d6be908d04ca3821, {
                        message: 'Unexpected response'
                    });
                    break;
                }
            } else {
                yield (0, $aNOuE.call)($47ca425c9bc61744$export$d6be908d04ca3821, {
                    ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                    requestInfo: {
                        url: url,
                        type: (0, $77QEM.GET),
                        status: response.status
                    }
                });
                break;
            }
        }
    }
    function* $47ca425c9bc61744$export$73eb4bd5eeb73fa8() {
        const calculationId = (yield (0, $aNOuE.select)((0, $cZF7S.getSolution))).id;
        const progress = yield (0, $aNOuE.select)((0, $cZF7S.getApplyingProgress));
        if (!(0, $4nDwW.isDefined)(calculationId) || (0, $4nDwW.isDefined)(progress)) return;
        yield (0, $aNOuE.call)($47ca425c9bc61744$export$17eb80881f8092da);
        const isSolutionLatest = yield (0, $aNOuE.select)((0, $cZF7S.getIsSolutionLatest));
        yield (0, $aNOuE.put)((0, $7vqYD.setProgress)(0));
        if (!isSolutionLatest) {
            yield (0, $aNOuE.put)((0, $7vqYD.setProgress)(null));
            return;
        }
        const url = (0, $fy2pg.urls).applyChange;
        const { id: planId, currentScenarioId: scenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const body = {
            planId: planId,
            scenarioId: scenarioId,
            calculationId: calculationId
        };
        try {
            yield (0, $aNOuE.put)($47ca425c9bc61744$export$52e6dbf58c39b42b());
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const { taskId: id } = yield (0, $aNOuE.call)(response.json.bind(response));
                yield (0, $aNOuE.call)($47ca425c9bc61744$export$37a8543ad18a3592, id);
            } else yield (0, $aNOuE.call)($47ca425c9bc61744$export$d6be908d04ca3821, {
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            });
        } catch (e) {
            const errorPayload = {
                message: e.message,
                stackTrace: e.stack
            };
            yield (0, $aNOuE.call)($47ca425c9bc61744$export$d6be908d04ca3821, errorPayload);
        }
    }
    function* $47ca425c9bc61744$export$aaad525afb68b6c0({ meta: meta }) {
        yield (0, $aNOuE.put)((0, $lYuBN.setMode)((0, $ab4be2e1e204af69$export$7536581a3f6533cb)));
        const isSolutionValid = yield (0, $aNOuE.select)((0, $cZF7S.getIsSolutionValid));
        if (isSolutionValid) yield (0, $aNOuE.call)($47ca425c9bc61744$export$17eb80881f8092da);
        const isSolutionLatest = yield (0, $aNOuE.select)((0, $cZF7S.getIsSolutionLatest));
        if (isSolutionValid && isSolutionLatest) yield (0, $aNOuE.put)((0, $lYuBN.setMode)((0, $ab4be2e1e204af69$export$e91bb82ec00eb771)));
        else yield (0, $aNOuE.call)($47ca425c9bc61744$export$120948c802b124a1, meta);
    }
    function* $47ca425c9bc61744$export$71f9684b6236e5f8() {
        yield (0, $aNOuE.put)((0, $lYuBN.setMode)((0, $ab4be2e1e204af69$export$250171a898bf7ef)));
    }
    function* $47ca425c9bc61744$export$b48ee7217010719d() {
        yield (0, $6u3NN.takeLatest)($47ca425c9bc61744$export$982c77cfe4f10899, $47ca425c9bc61744$export$aaad525afb68b6c0);
    }
    function* $47ca425c9bc61744$export$eca955165f78089b() {
        yield (0, $6u3NN.takeLatest)($47ca425c9bc61744$export$b552825ff76c8dca, $47ca425c9bc61744$export$71f9684b6236e5f8);
    }
    function* $47ca425c9bc61744$export$1f1bbef5df68d102() {
        yield (0, $6u3NN.takeEvery)($47ca425c9bc61744$export$b6d845d94d76e436, $47ca425c9bc61744$export$73eb4bd5eeb73fa8);
    }
    function* $47ca425c9bc61744$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($47ca425c9bc61744$export$b48ee7217010719d);
        yield (0, $aNOuE.fork)($47ca425c9bc61744$export$eca955165f78089b);
        yield (0, $aNOuE.fork)($47ca425c9bc61744$export$1f1bbef5df68d102);
    }
});
parcelRegister("atnIT", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_PLAN", ()=>$e5dd7e0c0de6bc1f$export$20cc563653555d6e);
    $parcel$export(module.exports, "updateIncludeCompletedIssuesForDays", ()=>$e5dd7e0c0de6bc1f$export$14b5ae4431410e37);
    $parcel$export(module.exports, "updatePlan", ()=>$e5dd7e0c0de6bc1f$export$6246b08e191feb20);
    $parcel$export(module.exports, "getPlanInfo", ()=>$e5dd7e0c0de6bc1f$export$bf5dcfa60204106b);
    $parcel$export(module.exports, "default", ()=>$e5dd7e0c0de6bc1f$export$2e2bcd8739ae039);
    var $83IGl;
    var $ik0Qc;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $4R6GH;
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $l2RHV = parcelRequire("l2RHV");
    var $idmiV = parcelRequire("idmiV");
    var $jZcxq = parcelRequire("jZcxq");
    var $5pKo7 = parcelRequire("5pKo7");
    var $77QEM = parcelRequire("77QEM");
    var $goTVH = parcelRequire("goTVH");
    var $24CMK = parcelRequire("24CMK");
    var $hvOzF = parcelRequire("hvOzF");
    var $acJ7S = parcelRequire("acJ7S");
    const $e5dd7e0c0de6bc1f$var$DELETE_PLAN = 'command.plan.DELETE_PLAN';
    const $e5dd7e0c0de6bc1f$export$20cc563653555d6e = 'command.plan.UPDATE_PLAN';
    const $e5dd7e0c0de6bc1f$var$UPDATE_INCLUDED_COMPLETED_ISSUES_FOR_DAYS = 'command.plan.UPDATE_INCLUDED_COMPLETED_ISSUES_FOR_DAYS';
    const $e5dd7e0c0de6bc1f$export$14b5ae4431410e37 = (payload)=>({
            type: $e5dd7e0c0de6bc1f$var$UPDATE_INCLUDED_COMPLETED_ISSUES_FOR_DAYS,
            payload: payload
        });
    const $e5dd7e0c0de6bc1f$export$947e41df5a20fab3 = ()=>({
            type: $e5dd7e0c0de6bc1f$var$DELETE_PLAN,
            payload: {}
        });
    const $e5dd7e0c0de6bc1f$export$6246b08e191feb20 = (payload, onComplete)=>({
            type: $e5dd7e0c0de6bc1f$export$20cc563653555d6e,
            payload: payload,
            onComplete: onComplete
        });
    function* $e5dd7e0c0de6bc1f$export$d96ee885e1ac10be({ payload: payload, onComplete: onComplete }) {
        const { domain: { plan: { id: id, autoScheduleConfiguration: autoScheduleConfiguration } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        if (!id) throw new Error('No plan to update');
        let updatePayload = payload;
        if ((0, $4nDwW.isDefined)(updatePayload.autoScheduleConfiguration)) updatePayload = (0, parcelRequire("ik0Qc")).default(updatePayload, {
            autoScheduleConfiguration: (0, parcelRequire("ik0Qc")).default(autoScheduleConfiguration, updatePayload.autoScheduleConfiguration)
        });
        yield (0, $aNOuE.put)((0, $jZcxq.update)(updatePayload));
        const url = (0, $acJ7S.urls).update(id);
        const body = (0, $acJ7S.transformUpdatePayload)(updatePayload);
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
            method: (0, $77QEM.POST),
            body: body
        });
        if (!response.ok) {
            if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                const error = new Error(response.text());
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'do-update-plan-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
        }
        if (onComplete) onComplete();
    }
    function* $e5dd7e0c0de6bc1f$export$90daf630220ca848({ payload: payload }) {
        const { domain: { plan: { id: id } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        if (id == null) return;
        const body = {
            planId: id,
            enabled: payload.autoSchedulerEnabled
        };
        const res = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $acJ7S.urls).toggleAutoSchedule(), {
            method: (0, $77QEM.POST),
            body: body
        });
        if (!res.ok) {
            if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                const error = new Error(res.text());
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'do-update-auto-scheduler-enabled-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(res, (yield (0, $aNOuE.call)(res.text.bind(res)))),
                requestInfo: {
                    url: (0, $acJ7S.urls).toggleAutoSchedule(),
                    type: (0, $77QEM.POST),
                    status: res.status,
                    body: body
                }
            }));
        }
    }
    function* $e5dd7e0c0de6bc1f$export$c09da2867831af5() {
        const { domain: { app: { browserHistory: browserHistory }, plan: { id: id } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        if (!id) throw new Error('No plan to delete');
        try {
            yield (0, $aNOuE.put)({
                type: (0, $5pKo7.DISABLE_DELETE)
            });
            const url = (0, $acJ7S.urls).delete(id);
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.DELETE)
            });
            if (response.ok) {
                if ((0, $4nDwW.isDefined)(browserHistory)) yield (0, $aNOuE.call)(browserHistory.push, (0, $l2RHV.default).managePortfolio);
                else yield (0, $aNOuE.call)((0, $idmiV.redirect), (0, $l2RHV.default).jiraHome);
            } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                const error = new Error(response.text());
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'do-delete-plan-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.DELETE),
                    status: response.status,
                    body: {}
                }
            }));
        } finally{
            yield (0, $aNOuE.put)({
                type: (0, $5pKo7.ENABLE_DELETE)
            });
        }
    }
    function* $e5dd7e0c0de6bc1f$var$doUpdateIncludeCompletedIssuesForDays({ payload: { days: days } }) {
        yield (0, $aNOuE.call)($e5dd7e0c0de6bc1f$export$d96ee885e1ac10be, {
            payload: {
                includeCompletedIssuesFor: days
            }
        });
        yield (0, $aNOuE.call)((0, $goTVH.getBacklog));
    }
    function* $e5dd7e0c0de6bc1f$export$bf5dcfa60204106b() {
        const { domain: { plan: { id: id, currentScenarioId: currentScenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        if (id == null || !currentScenarioId) return;
        const url = (0, $acJ7S.urls).get(id, currentScenarioId);
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
            method: (0, $77QEM.GET)
        });
        if (response.ok) return yield (0, $aNOuE.call)(response.json.bind(response));
        if (!response.ok) {
            if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                const error = new Error(response.text());
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'do-plan-info-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: {}
                }
            }));
        }
    }
    function* $e5dd7e0c0de6bc1f$export$3097d32aa598c8e2() {
        yield (0, $6u3NN.takeEvery)($e5dd7e0c0de6bc1f$var$DELETE_PLAN, $e5dd7e0c0de6bc1f$export$c09da2867831af5);
    }
    function* $e5dd7e0c0de6bc1f$export$3cf225935bd15c51() {
        yield (0, $6u3NN.takeEvery)($e5dd7e0c0de6bc1f$export$20cc563653555d6e, $e5dd7e0c0de6bc1f$export$d96ee885e1ac10be);
    }
    function* $e5dd7e0c0de6bc1f$export$99bfa39e154b395e() {
        yield (0, $6u3NN.takeEvery)((0, $jZcxq.UPDATE_AUTO_SCHEDULER_ENABLED), $e5dd7e0c0de6bc1f$export$90daf630220ca848);
    }
    function* $e5dd7e0c0de6bc1f$export$e09672252ff2cf70() {
        yield (0, $6u3NN.takeEvery)($e5dd7e0c0de6bc1f$var$UPDATE_INCLUDED_COMPLETED_ISSUES_FOR_DAYS, $e5dd7e0c0de6bc1f$var$doUpdateIncludeCompletedIssuesForDays);
    }
    function* $e5dd7e0c0de6bc1f$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($e5dd7e0c0de6bc1f$export$3097d32aa598c8e2);
        yield (0, $aNOuE.fork)($e5dd7e0c0de6bc1f$export$3cf225935bd15c51);
        yield (0, $aNOuE.fork)($e5dd7e0c0de6bc1f$export$e09672252ff2cf70);
        yield (0, $aNOuE.fork)($e5dd7e0c0de6bc1f$export$99bfa39e154b395e);
    }
});
parcelRegister("l2RHV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb5965aa1076c21a$export$2e2bcd8739ae039);
    var $eJyeb = parcelRequire("eJyeb");
    var $fb5965aa1076c21a$export$2e2bcd8739ae039 = {
        managePortfolio: (0, $eJyeb.proxyContextSafeUrl)('/jira/plans'),
        administration: (0, $eJyeb.proxyContextSafeUrl)('/secure/PortfolioPermissions.jspa'),
        jiraHome: (0, $eJyeb.proxyContextSafeUrl)('/jira/dashboards/last-visited'),
        manageCustomFields: (0, $eJyeb.proxyContextSafeUrl)('/secure/admin/ViewCustomFields.jspa')
    };
});
parcelRegister("jZcxq", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$4f4f5243ad488cac$export$4a991c87e640ef77);
    $parcel$export(module.exports, "UPDATE", ()=>$4f4f5243ad488cac$export$e271b26eefe41db8);
    $parcel$export(module.exports, "ADD_PLAN_SCENARIO", ()=>$4f4f5243ad488cac$export$7366bdbb08ff990d);
    $parcel$export(module.exports, "ENABLE_PLAN_SCENARIOS", ()=>$4f4f5243ad488cac$export$194b93e0925d4c62);
    $parcel$export(module.exports, "REMOVE_PLAN_SCENARIO", ()=>$4f4f5243ad488cac$export$eca14a501ab8708e);
    $parcel$export(module.exports, "DISABLE_PLAN_SCENARIOS", ()=>$4f4f5243ad488cac$export$4d024fa49048ae59);
    $parcel$export(module.exports, "UPDATE_PLAN_SCENARIO", ()=>$4f4f5243ad488cac$export$60e8b04bc54d4cc2);
    $parcel$export(module.exports, "UPDATE_AUTO_SCHEDULER_ENABLED", ()=>$4f4f5243ad488cac$export$19bb50c9d1b6706f);
    $parcel$export(module.exports, "reset", ()=>$4f4f5243ad488cac$export$aad8462122ac592b);
    $parcel$export(module.exports, "update", ()=>$4f4f5243ad488cac$export$722fbec263ad908a);
    $parcel$export(module.exports, "updateAutoSchedulerEnabled", ()=>$4f4f5243ad488cac$export$6b069c9e8291cced);
    $parcel$export(module.exports, "addPlanScenario", ()=>$4f4f5243ad488cac$export$ef567162fe046f26);
    $parcel$export(module.exports, "enablePlanScenarios", ()=>$4f4f5243ad488cac$export$1d8cd5385dd8eed2);
    $parcel$export(module.exports, "removePlanScenario", ()=>$4f4f5243ad488cac$export$2101863918c1e241);
    $parcel$export(module.exports, "disablePlanScenarios", ()=>$4f4f5243ad488cac$export$fc07c1be35f7a22d);
    $parcel$export(module.exports, "updatePlanScenario", ()=>$4f4f5243ad488cac$export$b611a5f0b8f8b9de);
    const $4f4f5243ad488cac$export$4a991c87e640ef77 = 'state.domain.plan.RESET';
    const $4f4f5243ad488cac$export$e271b26eefe41db8 = 'state.domain.plan.UPDATE';
    const $4f4f5243ad488cac$export$7366bdbb08ff990d = 'state.domain.plan.ADD_PLAN_SCENARIO';
    const $4f4f5243ad488cac$export$194b93e0925d4c62 = 'state.domain.plan.ENABLE_PLAN_SCENARIOS';
    const $4f4f5243ad488cac$export$eca14a501ab8708e = 'state.domain.plan.REMOVE_PLAN_SCENARIO';
    const $4f4f5243ad488cac$export$4d024fa49048ae59 = 'state.domain.plan.DISABLE_PLAN_SCENARIOS';
    const $4f4f5243ad488cac$export$60e8b04bc54d4cc2 = 'state.domain.plan.UPDATE_PLAN_SCENARIO';
    const $4f4f5243ad488cac$export$19bb50c9d1b6706f = 'state.domain.plan.UPDATE_AUTO_SCHEDULER_ENABLED';
    const $4f4f5243ad488cac$export$aad8462122ac592b = (payload)=>({
            type: $4f4f5243ad488cac$export$4a991c87e640ef77,
            payload: payload
        });
    const $4f4f5243ad488cac$export$722fbec263ad908a = (payload)=>({
            type: $4f4f5243ad488cac$export$e271b26eefe41db8,
            payload: payload
        });
    const $4f4f5243ad488cac$export$6b069c9e8291cced = (payload)=>({
            type: $4f4f5243ad488cac$export$19bb50c9d1b6706f,
            payload: payload
        });
    const $4f4f5243ad488cac$export$ef567162fe046f26 = (payload)=>({
            type: $4f4f5243ad488cac$export$7366bdbb08ff990d,
            payload: payload
        });
    const $4f4f5243ad488cac$export$1d8cd5385dd8eed2 = (payload)=>({
            type: $4f4f5243ad488cac$export$194b93e0925d4c62,
            payload: payload
        });
    const $4f4f5243ad488cac$export$2101863918c1e241 = (payload)=>({
            type: $4f4f5243ad488cac$export$eca14a501ab8708e,
            payload: payload
        });
    const $4f4f5243ad488cac$export$fc07c1be35f7a22d = (scenarioToKeepId)=>({
            type: $4f4f5243ad488cac$export$4d024fa49048ae59,
            scenarioToKeepId: scenarioToKeepId
        });
    const $4f4f5243ad488cac$export$b611a5f0b8f8b9de = (payload)=>({
            type: $4f4f5243ad488cac$export$60e8b04bc54d4cc2,
            payload: payload
        });
});
parcelRegister("5pKo7", function(module, exports) {
    $parcel$export(module.exports, "SET_DELETE_DIALOG_VISIBILITY", ()=>$05a56763884d0ccf$export$7ba9245b25391992);
    $parcel$export(module.exports, "ENABLE_DELETE", ()=>$05a56763884d0ccf$export$ff1973e9dc85021b);
    $parcel$export(module.exports, "DISABLE_DELETE", ()=>$05a56763884d0ccf$export$2ea4734ebbcd83c4);
    $parcel$export(module.exports, "REDIRECT_TO_SETTINGS", ()=>$05a56763884d0ccf$export$1244ece369641a83);
    const $05a56763884d0ccf$export$7ba9245b25391992 = 'state.ui.top.title-bar.plan-settings.TOGGLE_DELETE_DIALOG_VISIBILITY';
    const $05a56763884d0ccf$export$ff1973e9dc85021b = 'state.ui.top.title-bar.plan-settings.ENABLE_DELETE';
    const $05a56763884d0ccf$export$2ea4734ebbcd83c4 = 'state.ui.top.title-bar.plan-settings.DISABLE_DELETE';
    const $05a56763884d0ccf$export$1244ece369641a83 = 'state.ui.top.title-bar.plan-settings.REDIRECT_TO_SETTINGS';
    const $05a56763884d0ccf$export$fac3bf18cd62bfe3 = (redirectFrom)=>({
            type: $05a56763884d0ccf$export$1244ece369641a83,
            payload: redirectFrom
        });
    const $05a56763884d0ccf$export$ad6a13eccaf22bdb = (visibility)=>({
            type: $05a56763884d0ccf$export$7ba9245b25391992,
            payload: visibility
        });
});
parcelRegister("acJ7S", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$0aa62dc51f4da7e9$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "transformUpdatePayload", ()=>$0aa62dc51f4da7e9$export$faf8dd22c72e24c0);
    var $bstHg = parcelRequire("bstHg");
    const $0aa62dc51f4da7e9$export$bcae9ba627f604b6 = {
        update: (id)=>`/rest/jpo/1.0/plans/${id}/update`,
        delete: (id)=>`/rest/jpo/1.0/plans/${id}`,
        get: (planId, scenarioId)=>`/rest/jpo/1.0/planinfo/${planId}/scenario/${scenarioId}`,
        toggleAutoSchedule: ()=>'/rest/jpo/1.0/plans/autoSchedulerEnabled'
    };
    const $0aa62dc51f4da7e9$export$faf8dd22c72e24c0 = (update)=>{
        const result = {};
        for (const key of Object.keys(update)){
            const value = update[key];
            if (key === 'autoScheduleConfiguration') result.calculationConfiguration = {
                value: value
            };
            else if ([
                'baselineStartField',
                'baselineEndField'
            ].includes(key)) {
                if (typeof value === 'object' && typeof value.id === 'string') {
                    const convertedId = (0, $bstHg.TARGET_DATE_FIELD_TO_API_DATE_FIELD_MAP)[value.id] || value.id;
                    result[`${key}Id`] = {
                        value: convertedId
                    };
                }
            } else result[key] = {
                value: value
            };
        }
        delete result.autoSchedulerEnabled;
        return result;
    };
});
parcelRegister("kX5YK", function(module, exports) {
    $parcel$export(module.exports, "COMMIT_CHANGES", ()=>$f10a3d0c849d974e$export$a031474266a52bb4);
    $parcel$export(module.exports, "getChangesMetadata", ()=>$f10a3d0c849d974e$export$35be11ad3df1110);
    $parcel$export(module.exports, "commitChanges", ()=>$f10a3d0c849d974e$export$53720dfce17bb85a);
    $parcel$export(module.exports, "revertChanges", ()=>$f10a3d0c849d974e$export$d269e5e1393c5f8a);
    $parcel$export(module.exports, "getNotificationPreference", ()=>$f10a3d0c849d974e$export$3c3771868e06ade1);
    $parcel$export(module.exports, "saveNotificationPreference", ()=>$f10a3d0c849d974e$export$7b2133f0c970c6e2);
    $parcel$export(module.exports, "updateLastCommittedTimestamp", ()=>$f10a3d0c849d974e$export$f734abf5c5cd3d95);
    $parcel$export(module.exports, "default", ()=>$f10a3d0c849d974e$export$2e2bcd8739ae039);
    var $cDeeP;
    var $bWXax;
    var $8MQZK;
    var $2JlG5;
    var $83IGl;
    var $4Rr1a;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $dJl1T;
    var $4ENQh;
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $hu7Cn = parcelRequire("hu7Cn");
    var $jw86H = parcelRequire("jw86H");
    var $ddv1K = parcelRequire("ddv1K");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $gFhwb = parcelRequire("gFhwb");
    var $jeUPY = parcelRequire("jeUPY");
    var $d3quy = parcelRequire("d3quy");
    var $6TEBn = parcelRequire("6TEBn");
    var $dRVQG = parcelRequire("dRVQG");
    var $25viM = parcelRequire("25viM");
    var $9FFuD = parcelRequire("9FFuD");
    var $fP57B = parcelRequire("fP57B");
    var $gFvn5 = parcelRequire("gFvn5");
    var $96USE = parcelRequire("96USE");
    var $bt366 = parcelRequire("bt366");
    var $7CxJ7 = parcelRequire("7CxJ7");
    var $5bPxr = parcelRequire("5bPxr");
    var $flUdG = parcelRequire("flUdG");
    var $1Gv61 = parcelRequire("1Gv61");
    var $75oAU = parcelRequire("75oAU");
    var $9mxDT = parcelRequire("9mxDT");
    var $ebcEl = parcelRequire("ebcEl");
    var $iNyXb = parcelRequire("iNyXb");
    var $91SKv = parcelRequire("91SKv");
    var $3VttY = parcelRequire("3VttY");
    var $21mdo = parcelRequire("21mdo");
    var $3ODbh = parcelRequire("3ODbh");
    var $aHSC5 = parcelRequire("aHSC5");
    var $ccIrM = parcelRequire("ccIrM");
    var $77QEM = parcelRequire("77QEM");
    var $8qbLi = parcelRequire("8qbLi");
    var $goTVH = parcelRequire("goTVH");
    var $bYhSc = parcelRequire("bYhSc");
    var $3pJIs = parcelRequire("3pJIs");
    var $5zPyn = parcelRequire("5zPyn");
    var $knys8 = parcelRequire("knys8");
    var $bNKh8 = parcelRequire("bNKh8");
    var $24CMK = parcelRequire("24CMK");
    var $eS9xr = parcelRequire("eS9xr");
    var $bkasS = parcelRequire("bkasS");
    var $aEqRm = parcelRequire("aEqRm");
    var $gIlW4 = parcelRequire("gIlW4");
    var $cukx3 = parcelRequire("cukx3");
    var $ar6WC = parcelRequire("ar6WC");
    var $47ZoL = parcelRequire("47ZoL");
    var $1zNSi = parcelRequire("1zNSi");
    var $aHSC5 = parcelRequire("aHSC5");
    var $ccIrM = parcelRequire("ccIrM");
    var $iNyXb = parcelRequire("iNyXb");
    var $91SKv = parcelRequire("91SKv");
    const $f10a3d0c849d974e$export$308972e7a1f0c32f = 'command.update-jira.GET_CHANGES_METADATA';
    const $f10a3d0c849d974e$export$7636b4e7de1cbb0c = 'command.update-jira.GET_NOTIFICATION_PREFERENCE';
    const $f10a3d0c849d974e$export$5de96f956f57013f = 'command.update-jira.SAVE_NOTIFICATION_PREFERENCE';
    const $f10a3d0c849d974e$export$a031474266a52bb4 = 'command.update-jira.COMMIT_CHANGES';
    const $f10a3d0c849d974e$export$c73a59414b3152da = 'command.update-jira.REVERT_CHANGES';
    const $f10a3d0c849d974e$export$a9f3c3bb2f676e06 = 'command.update-jira.INTERRUPT';
    const $f10a3d0c849d974e$export$e4edc10ab54a304a = 'command.update-jira.UPDATE_LAST_COMMITTED_TIMESTAMP';
    const $f10a3d0c849d974e$var$COMMIT_SCENARIO_CHANGES_BATCH_SIZE = 5;
    const $f10a3d0c849d974e$export$35be11ad3df1110 = ()=>({
            type: $f10a3d0c849d974e$export$308972e7a1f0c32f
        });
    const $f10a3d0c849d974e$export$53720dfce17bb85a = (payload, meta)=>({
            type: $f10a3d0c849d974e$export$a031474266a52bb4,
            payload: payload,
            meta: meta
        });
    const $f10a3d0c849d974e$export$d269e5e1393c5f8a = (payload)=>({
            type: $f10a3d0c849d974e$export$c73a59414b3152da,
            payload: payload
        });
    const $f10a3d0c849d974e$export$3c3771868e06ade1 = ()=>({
            type: $f10a3d0c849d974e$export$7636b4e7de1cbb0c
        });
    const $f10a3d0c849d974e$export$7b2133f0c970c6e2 = (payload)=>({
            type: $f10a3d0c849d974e$export$5de96f956f57013f,
            payload: payload
        });
    const $f10a3d0c849d974e$export$7b7d62677a00f822 = ()=>({
            type: $f10a3d0c849d974e$export$a9f3c3bb2f676e06
        });
    const $f10a3d0c849d974e$export$f734abf5c5cd3d95 = ()=>({
            type: $f10a3d0c849d974e$export$e4edc10ab54a304a
        });
    const $f10a3d0c849d974e$export$b85cd17f8fbba1f1 = (state, metaData)=>{
        const requiredUserKeys = metaData.map((value)=>value.lastChangeUser);
        const availableUserKeys = (0, $hu7Cn.getAssigneeList)(state).map((assignee)=>assignee.personId);
        return (0, parcelRequire("cDeeP")).default(requiredUserKeys, availableUserKeys);
    };
    function* $f10a3d0c849d974e$export$5c1594403ad65fa3() {
        const sprints = yield (0, $aNOuE.select)((0, $d3quy.getSprints));
        const originalIssues = yield (0, $aNOuE.select)((0, $bI9dZ.getOriginalIssues));
        const issuesById = yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById));
        yield (0, $aNOuE.put)((0, $9mxDT.reset)({
            category: (0, $TTKUQ.ENTITY).ISSUE
        }));
        const warnings = [];
        for (const issueId of Object.keys(originalIssues)){
            const issue = issuesById[issueId];
            const originalIssue = originalIssues[issueId];
            if (issue) {
                if (issue.id == null) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('plans.accessing-property-of-undefined', 'doGetChangeWarnings originalIssues[issueId] is undefined');
                if (issue.id?.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX)) || (0, parcelRequire("2JlG5")).default('sprint', originalIssue) && issue.sprint !== originalIssue.sprint) {
                    const sprint = issue.sprint && (0, $6TEBn.getSprintById)(sprints, issue.sprint);
                    if (sprint && sprint.state === 'ACTIVE') warnings.push({
                        category: (0, $TTKUQ.ENTITY).ISSUE,
                        itemId: issueId,
                        warnings: (0, $1zNSi.getChangeWarning)((0, $1zNSi.ADDED_TO_ACTIVE_SPRINT))
                    });
                    const removedSprint = (0, $6TEBn.getSprintById)(sprints, originalIssue.sprint);
                    if (removedSprint && removedSprint.state === 'ACTIVE') warnings.push({
                        category: (0, $TTKUQ.ENTITY).ISSUE,
                        itemId: issueId,
                        warnings: (0, $1zNSi.getChangeWarning)((0, $1zNSi.REMOVED_FROM_ACTIVE_SPRINT))
                    });
                }
            }
        }
        if (warnings.length) yield (0, $aNOuE.put)((0, $9mxDT.addBulk)(warnings));
    }
    const $f10a3d0c849d974e$export$b874b322b7832120 = (issueLinksMetadata, issueLinksValuesForIssues, issueLinkOriginalsForIssues)=>{
        const issueLinksValues = {};
        for (const issueId of Object.keys(issueLinksValuesForIssues))for (const issueLinkId of Object.keys(issueLinksValuesForIssues[issueId]))issueLinksValues[issueLinkId] = issueLinksValuesForIssues[issueId][issueLinkId];
        const issueLinksOriginals = {};
        for (const issueId of Object.keys(issueLinkOriginalsForIssues))for (const issueLinkId of Object.keys(issueLinkOriginalsForIssues[issueId]))issueLinksOriginals[issueLinkId] = issueLinkOriginalsForIssues[issueId][issueLinkId];
        return Object.keys(issueLinksMetadata).filter((issueLinkId)=>{
            if (!(0, $4nDwW.isDefined)(issueLinksOriginals[issueLinkId]) && !(0, $4nDwW.isDefined)(issueLinksValues[issueLinkId])) return false;
            return true;
        }).map((issueLinkId)=>{
            const issueLinkMetadata = issueLinksMetadata[issueLinkId];
            switch(issueLinkMetadata.scenarioType){
                case 'DELETED':
                    {
                        const issueLink = issueLinksOriginals[issueLinkId];
                        return {
                            itemKey: issueLinkId,
                            originals: {},
                            scenarioType: 'DELETED',
                            sourceItemKey: issueLink.sourceItemKey,
                            targetItemKey: issueLink.targetItemKey,
                            values: {
                                type: issueLink.type
                            }
                        };
                    }
                default:
                    {
                        const issueLink = issueLinksValues[issueLinkId];
                        return {
                            itemKey: issueLinkId,
                            originals: {},
                            scenarioType: 'ADDED',
                            sourceItemKey: issueLink.sourceItemKey,
                            targetItemKey: issueLink.targetItemKey,
                            values: {
                                type: issueLink.type
                            }
                        };
                    }
            }
        });
    };
    const $f10a3d0c849d974e$export$1ef8ba280e7555c0 = (issueChangesMetadata, issuesById, scenarioRemovedIssuesById, originalIssues, issueLinks)=>{
        const allIssuesById = {
            ...issuesById,
            ...scenarioRemovedIssuesById
        };
        const modifiedOriginalIssues = originalIssues;
        for (const issueId of Object.keys(issueLinks))if (!(0, $4nDwW.isDefined)(modifiedOriginalIssues[issueId])) modifiedOriginalIssues[issueId] = {};
        const definedIssuesIds = Object.keys(modifiedOriginalIssues).filter((id)=>allIssuesById[id]);
        return definedIssuesIds.map((id)=>(0, $bI9dZ.toApiIssue)(allIssuesById[id], modifiedOriginalIssues[id], issueChangesMetadata[id]?.scenarioType));
    };
    function* $f10a3d0c849d974e$export$d9d7693e2245e256() {
        try {
            const state = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
            const { domain: { plan: { id: id, currentScenarioId: currentScenarioId }, sequence: sequence } } = state;
            const body = (0, $ar6WC.getChangesMetadataBody)({
                id: id,
                currentScenarioId: currentScenarioId
            }, sequence);
            yield (0, $aNOuE.put)($ebcEl.sent());
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $ar6WC.urls).getScenarioChangesMetadata, {
                profile: (0, $ar6WC.urls).getScenarioChangesMetadata,
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const json = yield (0, $aNOuE.call)(response.json.bind(response));
                const issueLinkValues = yield (0, $aNOuE.select)((0, $ddv1K.getIssueLinks));
                const issueLinkOriginals = yield (0, $aNOuE.select)((0, $ddv1K.getIssueLinkOriginals));
                const issueLinks = yield (0, $aNOuE.call)($f10a3d0c849d974e$export$b874b322b7832120, {
                    ...json.metaData.issueLinks
                }, issueLinkValues, issueLinkOriginals);
                const issuesMapById = yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById));
                const scenarioRemovedIssuesById = yield (0, $aNOuE.select)((0, $gFhwb.getScenarioRemovedIssueMapById));
                const originalIssues = yield (0, $aNOuE.select)((0, $bI9dZ.getOriginalIssues));
                const issueLinkChangesData = yield (0, $aNOuE.call)((0, $ddv1K.getIssueLinkChangesDataPure), issueLinks);
                const issues = yield (0, $aNOuE.call)($f10a3d0c849d974e$export$1ef8ba280e7555c0, json.metaData.issues, issuesMapById, scenarioRemovedIssuesById, originalIssues, issueLinkChangesData);
                yield (0, $aNOuE.put)($ebcEl.success({
                    ...json,
                    issues: issues,
                    issueLinks: issueLinks
                }));
                const allChangesMetaData = yield (0, $aNOuE.select)((0, $25viM.getAllChangesMetaData));
                const keys = $f10a3d0c849d974e$export$b85cd17f8fbba1f1(state, allChangesMetaData);
                yield (0, $aNOuE.put)((0, $bNKh8.populateUserPickerOptions)());
                yield (0, $aNOuE.put)((0, $8qbLi.fetchAssigneeListForKeys)({
                    keys: keys,
                    fetchAllAssignees: true
                }));
                yield (0, $aNOuE.call)($f10a3d0c849d974e$export$5c1594403ad65fa3);
                yield (0, $aNOuE.put)($ebcEl.afterSuccess());
            } else yield (0, $aNOuE.put)($ebcEl.error({
                code: response.status,
                message: yield (0, $aNOuE.call)(response.json.bind(response))
            }));
        } catch (e) {
            yield (0, $aNOuE.put)($ebcEl.error({
                code: 0,
                message: {
                    error: e.message
                }
            }));
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $f10a3d0c849d974e$export$f88a659cb8822a85() {
        let shouldNotifyWatchers;
        try {
            shouldNotifyWatchers = yield (0, $aNOuE.call)((0, $47ZoL.getNotifyWatchersPreference));
        } catch (err) {}
        yield (0, $aNOuE.put)($aHSC5.updateNotificationPreference({
            shouldNotifyWatchers: shouldNotifyWatchers
        }));
    }
    function* $f10a3d0c849d974e$export$25a1a7245485adb4({ payload: { shouldNotifyWatchers: shouldNotifyWatchers } }) {
        try {
            yield (0, $aNOuE.call)((0, $47ZoL.setNotifyWatchersPreference), shouldNotifyWatchers);
        } catch (err) {
            return undefined;
        }
    }
    function* $f10a3d0c849d974e$export$df46215683194476(bulkCommitEntitiesBatch, plannedCapacityChangesByItemKey, issueIdToProcessedId, processedIssueChanges, issueLinkToIssueMap, notifyWatchers) {
        const bulkResponse = yield (0, $aNOuE.call)((0, $3pJIs.executeBulkCommitRequest), bulkCommitEntitiesBatch, notifyWatchers);
        let success = true;
        let tryBatchAgainFromIndex = null;
        for (const entityResponse of bulkResponse?.orderedCommitResults ?? []){
            const id = entityResponse.itemKey;
            if (entityResponse.entityType !== (0, $5zPyn.BulkCommitEntityType).ISSUE_LINK) yield (0, $aNOuE.put)($iNyXb.incrementNumberOfCommittedChanges());
            if (!entityResponse.success) success = false;
            switch(entityResponse.entityType){
                case (0, $5zPyn.BulkCommitEntityType).X_PROJECT_VERSION:
                    yield (0, $aNOuE.call)($knys8.handleCrossProjectVersionCommitResponse, entityResponse);
                    break;
                case (0, $5zPyn.BulkCommitEntityType).VERSION:
                    yield (0, $aNOuE.call)($cukx3.handleVersionCommitResponse, entityResponse);
                    break;
                case (0, $5zPyn.BulkCommitEntityType).TEAM:
                    yield (0, $aNOuE.call)((0, $gIlW4.handleTeamBulkCommitResponse), entityResponse);
                    break;
                case (0, $5zPyn.BulkCommitEntityType).RESOURCE:
                    yield (0, $aNOuE.call)((0, $gIlW4.handleResourceBulkCommitResponse), entityResponse);
                    break;
                case (0, $5zPyn.BulkCommitEntityType).PLANNED_CAPACITY:
                    {
                        const plannedCapacityChange = plannedCapacityChangesByItemKey.get(id);
                        yield (0, $aNOuE.call)((0, $aEqRm.handlePlannedCapacityBulkCommitResponse), entityResponse, plannedCapacityChange);
                        break;
                    }
                case (0, $5zPyn.BulkCommitEntityType).ISSUE:
                    {
                        const isJiraScreenDisplayed = yield (0, $aNOuE.call)((0, $bkasS.handleIssueCommitResponse), entityResponse, notifyWatchers);
                        if (isJiraScreenDisplayed) {
                            success = true;
                            if (bulkCommitEntitiesBatch.length > bulkResponse.orderedCommitResults.length) tryBatchAgainFromIndex = bulkResponse.orderedCommitResults.length;
                        }
                        const processedId = entityResponse.generatedId ?? id;
                        processedIssueChanges.push(processedId);
                        if (processedId !== id) {
                            issueIdToProcessedId.set(id, processedId);
                            yield (0, $aNOuE.put)($fP57B.updateIssueReferences({
                                oldId: id,
                                newId: processedId
                            }));
                        }
                        break;
                    }
                case (0, $5zPyn.BulkCommitEntityType).ISSUE_LINK:
                    {
                        let associatedIssueId = issueLinkToIssueMap.get(entityResponse.itemKey);
                        if (issueIdToProcessedId.has(associatedIssueId)) associatedIssueId = issueIdToProcessedId.get(associatedIssueId);
                        yield (0, $aNOuE.call)($eS9xr.handleIssueLinkCommitResponse, entityResponse, associatedIssueId);
                        break;
                    }
                default:
            }
            if (!success || tryBatchAgainFromIndex !== null) break;
        }
        return {
            issueIdToProcessedId: issueIdToProcessedId,
            processedIssueChanges: processedIssueChanges,
            success: success,
            tryBatchAgainFromIndex: tryBatchAgainFromIndex
        };
    }
    function* $f10a3d0c849d974e$export$73b4b802f205083a(selectedChanges, selectedIssues, notifyWatchers) {
        const allPlannedCapacityChanges = yield (0, $aNOuE.select)((0, $d3quy.getPlannedCapacityChanges));
        const plannedCapacityChangesByItemKey = allPlannedCapacityChanges.reduce((map, change)=>{
            if ((0, $4nDwW.isDefined)(change.values.itemKey)) map.set(change.values.itemKey, change);
            return map;
        }, new Map());
        const { bulkCommitEntities: bulkCommitEntities, issueLinkOnlyIssueChangesCount: issueLinkOnlyIssueChangesCount, issueLinkToIssueMap: issueLinkToIssueMap } = yield (0, $aNOuE.call)((0, $3pJIs.createBulkCommitRequestEntityList), selectedChanges, selectedIssues, allPlannedCapacityChanges);
        let issueIdToProcessedId = new Map();
        let processedIssueChanges = [];
        const issueChangesMetaData = yield (0, $aNOuE.select)((0, $bI9dZ.getIssueChangesMetaData));
        for(let i = 0; i < bulkCommitEntities.length; i += $f10a3d0c849d974e$var$COMMIT_SCENARIO_CHANGES_BATCH_SIZE){
            let tryBatchAgainFromIndex = null;
            let success = true;
            let bulkCommitEntitiesBatch = bulkCommitEntities.slice(i, i + $f10a3d0c849d974e$var$COMMIT_SCENARIO_CHANGES_BATCH_SIZE);
            if (yield (0, $aNOuE.select)((0, $25viM.getIsSavingInterrupted))) break;
            ({ issueIdToProcessedId: issueIdToProcessedId, processedIssueChanges: processedIssueChanges, success: success, tryBatchAgainFromIndex: tryBatchAgainFromIndex } = yield (0, $aNOuE.call)($f10a3d0c849d974e$export$df46215683194476, bulkCommitEntitiesBatch, plannedCapacityChangesByItemKey, issueIdToProcessedId, processedIssueChanges, issueLinkToIssueMap, notifyWatchers));
            while(tryBatchAgainFromIndex !== null){
                bulkCommitEntitiesBatch = bulkCommitEntitiesBatch.slice(tryBatchAgainFromIndex);
                ({ issueIdToProcessedId: issueIdToProcessedId, processedIssueChanges: processedIssueChanges, success: success, tryBatchAgainFromIndex: tryBatchAgainFromIndex } = yield (0, $aNOuE.call)($f10a3d0c849d974e$export$df46215683194476, bulkCommitEntitiesBatch, plannedCapacityChangesByItemKey, issueIdToProcessedId, processedIssueChanges, issueLinkToIssueMap, notifyWatchers));
            }
            if (!success) break;
        }
        for(let i = 0; i < issueLinkOnlyIssueChangesCount; i++)yield (0, $aNOuE.put)($iNyXb.incrementNumberOfCommittedChanges());
        yield (0, $aNOuE.put)((0, $3ODbh.toggleSelectedIssues)({
            isSelected: false,
            toggleAll: true,
            ids: []
        }));
        yield (0, $aNOuE.put)((0, $21mdo.updateExpandedIssueLinks)(Object.fromEntries(issueIdToProcessedId)));
        yield (0, $aNOuE.call)((0, $bkasS.getHiddenIssues), processedIssueChanges.filter((id)=>!issueChangesMetaData[id] || issueChangesMetaData[id].scenarioType !== 'DELETED'));
        yield (0, $aNOuE.put)((0, $7CxJ7.reset)({}));
    }
    function* $f10a3d0c849d974e$export$1da733c3857c6e08({ payload: { actions: actions, notifyWatchers: notifyWatchers } }) {
        (0, (0, parcelRequire("4ENQh")).monitor).startTask((0, $TTKUQ.PERFORMANCE_KEYS).COMMIT_CHANGES_TIME_TO_SAVE);
        const data = yield (0, $aNOuE.select)((0, $25viM.getFilteredReviewChanges));
        if (!data.length) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: 'Get changes before committing them'
            }));
            return;
        }
        const selectedChanges = yield (0, $aNOuE.select)((0, $25viM.getSelectedChanges));
        const selectedChangesCount = yield (0, $aNOuE.select)((0, $25viM.getSelectedChangesCount));
        const selectedIssues = yield (0, $aNOuE.select)((0, $25viM.getSortedByHierarchySelectedIssues));
        const committedChangesSets = (0, parcelRequire("4Rr1a")).default((items)=>new Set(items), selectedChanges);
        yield (0, $aNOuE.put)($iNyXb.start(selectedChangesCount));
        try {
            (0, (0, parcelRequire("4ENQh")).monitor).startTask((0, $TTKUQ.PERFORMANCE_KEYS).COMMIT_CHANGES_TIME_TO_PERSIST);
            yield (0, $aNOuE.call)($f10a3d0c849d974e$export$73b4b802f205083a, selectedChanges, selectedIssues, notifyWatchers);
            (0, (0, parcelRequire("4ENQh")).monitor).finishTask((0, $TTKUQ.PERFORMANCE_KEYS).COMMIT_CHANGES_TIME_TO_PERSIST, {
                scalingFactors: (0, parcelRequire("4Rr1a")).default((changes)=>changes.size, committedChangesSets)
            });
            yield (0, $aNOuE.call)((0, $goTVH.getBacklog));
            if (actions.success) for (const action of actions.success)yield (0, $aNOuE.put)(action);
        } catch (e) {
            yield (0, $aNOuE.call)((0, $goTVH.getBacklog));
            if (actions.error) yield (0, $aNOuE.put)(actions.error);
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        } finally{
            yield (0, $aNOuE.put)($iNyXb.stop());
            yield (0, $aNOuE.call)($f10a3d0c849d974e$export$d9d7693e2245e256);
            const data = yield (0, $aNOuE.select)((0, $25viM.getReviewChanges));
            const filteredData = yield (0, $aNOuE.select)((0, $25viM.getFilteredReviewChanges));
            const isOutOfSync = yield (0, $aNOuE.select)((0, $25viM.getIsOutOfSync));
            if (!filteredData.length && !isOutOfSync) yield (0, $aNOuE.put)($aHSC5.clearFilter((0, $ccIrM.USER_FILTER_ID)));
            if (!data.length && !isOutOfSync) yield (0, $aNOuE.put)($aHSC5.closeUpdateJiraDialog());
            data.forEach((uncommittedChange)=>committedChangesSets[uncommittedChange.category]?.delete(uncommittedChange.id));
            (0, (0, parcelRequire("4ENQh")).monitor).finishTask((0, $TTKUQ.PERFORMANCE_KEYS).COMMIT_CHANGES_TIME_TO_SAVE, {
                scalingFactors: (0, parcelRequire("4Rr1a")).default((changes)=>changes.size, committedChangesSets)
            });
        }
    }
    function* $f10a3d0c849d974e$export$c90b346a1ef1c74e(selectedChanges) {
        const issueChangesMetaData = yield (0, $aNOuE.select)((0, $bI9dZ.getIssueChangesMetaData));
        const issueLinkChanges = yield (0, $aNOuE.select)((0, $ddv1K.getIssueLinkChangesData));
        const revertedIssueLinkChanges = new Set();
        loop: for (const id of selectedChanges)for (const { itemKey: itemKey } of issueLinkChanges[id] || []){
            if (yield (0, $aNOuE.select)((0, $25viM.getIsRevertingInterrupted))) break loop;
            if (revertedIssueLinkChanges.has(itemKey)) continue;
            const response = yield (0, $aNOuE.call)($eS9xr.revertChange, itemKey, id);
            if (!response.ok) {
                yield (0, $aNOuE.put).resolve($f10a3d0c849d974e$export$7b7d62677a00f822());
                break;
            }
            revertedIssueLinkChanges.add(itemKey);
        }
        for (const id of selectedChanges){
            if (yield (0, $aNOuE.select)((0, $25viM.getIsRevertingInterrupted))) break;
            if (issueChangesMetaData[id]) {
                const response = yield (0, $aNOuE.call)((0, $bkasS.revertChange), id);
                yield (0, $aNOuE.put)($91SKv.incrementNumberOfRevertedChanges());
                if (!response.ok) {
                    yield (0, $aNOuE.put).resolve($f10a3d0c849d974e$export$7b7d62677a00f822());
                    break;
                }
            } else yield (0, $aNOuE.put)($91SKv.incrementNumberOfRevertedChanges());
        }
        const patches = yield (0, $aNOuE.select)((0, $bI9dZ.getOriginalIssues));
        yield (0, $aNOuE.put)((0, $3ODbh.toggleSelectedIssues)({
            isSelected: false,
            toggleAll: true,
            ids: []
        }));
        yield (0, $aNOuE.put)((0, $96USE.bulkUpdate)(patches));
        yield (0, $aNOuE.put)((0, $96USE.removeWithoutIssueKey)());
        yield (0, $aNOuE.put)((0, $7CxJ7.reset)({}));
    }
    function* $f10a3d0c849d974e$export$c311273348377937(selectedChanges) {
        for (const id of selectedChanges){
            if (yield (0, $aNOuE.select)((0, $25viM.getIsRevertingInterrupted))) break;
            const response = yield (0, $aNOuE.call)($knys8.revertChange, id);
            yield (0, $aNOuE.put)($91SKv.incrementNumberOfRevertedChanges());
            if (!response.ok) {
                yield (0, $aNOuE.put).resolve($f10a3d0c849d974e$export$7b7d62677a00f822());
                break;
            }
            yield* (0, $bYhSc.default)(function*() {
                const originals = yield (0, $aNOuE.select)((0, $jw86H.getOriginalCrossProjectVersions));
                if (id.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $aNOuE.call)($knys8.removeCrossProjectVersionFromStore, id);
                else {
                    const removedCrossProjectVersionsById = yield (0, $aNOuE.select)((0, $jw86H.getRemovedCrossProjectVersionsById));
                    const removedCrossProjectVersion = removedCrossProjectVersionsById[id];
                    if ((0, $4nDwW.isDefined)(removedCrossProjectVersion)) yield (0, $aNOuE.call)($knys8.addRemovedCrossProjectVersionToMainCrossProjectVersionsList, removedCrossProjectVersion);
                    yield (0, $aNOuE.put)($gFvn5.bulkUpdate({
                        [id]: originals[id]
                    }));
                    yield (0, $aNOuE.put)($bt366.reset((0, parcelRequire("bWXax")).default(id, originals)));
                }
            });
        }
    }
    function* $f10a3d0c849d974e$export$337fbf4febbb6d6e(selectedChanges) {
        for (const id of selectedChanges){
            if (yield (0, $aNOuE.select)((0, $25viM.getIsRevertingInterrupted))) break;
            const response = yield (0, $aNOuE.call)($cukx3.revertChange, id);
            yield (0, $aNOuE.put)($91SKv.incrementNumberOfRevertedChanges());
            if (!response.ok) {
                yield (0, $aNOuE.put).resolve($f10a3d0c849d974e$export$7b7d62677a00f822());
                break;
            }
            const originals = yield (0, $aNOuE.select)((0, $9FFuD.getOriginalVersions));
            const originalVersion = originals[id];
            if (id.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $aNOuE.call)($cukx3.removeVersionFromStore, id);
            else {
                const removedVersionsById = yield (0, $aNOuE.select)((0, $9FFuD.getRemovedVersionsById));
                const removedVersion = removedVersionsById[id];
                if ((0, $4nDwW.isDefined)(removedVersion)) yield (0, $aNOuE.call)($cukx3.addRemovedVersionToMainVersionsList, removedVersion);
                const versionsById = yield (0, $aNOuE.select)((0, $9FFuD.getVersionsById));
                const version = versionsById[id];
                if (Object.keys(originalVersion).includes('crossProjectVersion')) {
                    if ((0, $4nDwW.isDefined)(version.crossProjectVersion)) yield (0, $aNOuE.call)($knys8.removeVersionFromCrossProjectVersion, id, version.crossProjectVersion);
                    if ((0, $4nDwW.isDefined)(originalVersion.crossProjectVersion)) yield (0, $aNOuE.call)($knys8.addVersionInCrossProjectVersion, id, originalVersion.crossProjectVersion);
                }
                yield (0, $aNOuE.put)((0, $3VttY.bulkUpdate)({
                    [id]: originals[id]
                }));
            }
            yield (0, $aNOuE.put)((0, $75oAU.reset)((0, parcelRequire("bWXax")).default(id, originals)));
        }
    }
    function* $f10a3d0c849d974e$export$ca9a89fd41789c0d(selectedChanges) {
        for (const id of selectedChanges){
            if (yield (0, $aNOuE.select)((0, $25viM.getIsRevertingInterrupted))) break;
            const response = yield (0, $aNOuE.call)((0, $gIlW4.revertResourceChange), id);
            yield (0, $aNOuE.put)($91SKv.incrementNumberOfRevertedChanges());
            if (!response.ok) {
                yield (0, $aNOuE.put).resolve($f10a3d0c849d974e$export$7b7d62677a00f822());
                break;
            }
            const originals = yield (0, $aNOuE.select)((0, $jeUPY.getOriginalResources));
            yield (0, $aNOuE.put)((0, $flUdG.reset)((0, parcelRequire("bWXax")).default(id, originals)));
        }
    }
    function* $f10a3d0c849d974e$export$76a9f8d4d2d6478c(selectedChanges) {
        for (const id of selectedChanges){
            if (yield (0, $aNOuE.select)((0, $25viM.getIsRevertingInterrupted))) break;
            const response = yield (0, $aNOuE.call)((0, $gIlW4.revertTeamChange), id);
            yield (0, $aNOuE.put)($91SKv.incrementNumberOfRevertedChanges());
            if (!response.ok) {
                yield (0, $aNOuE.put).resolve($f10a3d0c849d974e$export$7b7d62677a00f822());
                break;
            }
            const originals = yield (0, $aNOuE.select)((0, $dRVQG.getOriginalTeams));
            yield (0, $aNOuE.put)((0, $1Gv61.reset)((0, parcelRequire("bWXax")).default(id, originals)));
        }
    }
    function* $f10a3d0c849d974e$export$90c04c22c0e8a50f(selectedChanges) {
        const allPlannedCapacityChanges = yield (0, $aNOuE.select)((0, $d3quy.getPlannedCapacityChanges));
        for (const id of selectedChanges){
            if (yield (0, $aNOuE.select)((0, $25viM.getIsRevertingInterrupted))) break;
            const plannedCapacityChanges = allPlannedCapacityChanges.filter((capacityChange)=>capacityChange.iterationId === id);
            for (const plannedCapacityChange of plannedCapacityChanges){
                const { teamId: teamId, iterationId: iterationId } = plannedCapacityChange.values;
                const response = yield (0, $aNOuE.call)((0, $aEqRm.revertPlannedCapacityChange), plannedCapacityChange);
                if (!response.ok) {
                    yield (0, $aNOuE.put)($f10a3d0c849d974e$export$7b7d62677a00f822());
                    break;
                }
                const originals = yield (0, $aNOuE.select)((0, $d3quy.getOriginalPlannedCapacities));
                yield (0, $aNOuE.put)((0, $5bPxr.reset)((0, parcelRequire("8MQZK")).default([
                    teamId,
                    iterationId
                ], originals)));
            }
            yield (0, $aNOuE.put)($91SKv.incrementNumberOfRevertedChanges());
        }
    }
    function* $f10a3d0c849d974e$export$ecf66aaaea5ca30a({ payload: { actions: actions } }) {
        const data = yield (0, $aNOuE.select)((0, $25viM.getFilteredReviewChanges));
        if (!data.length) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: 'Get changes before reverting them'
            }));
            return;
        }
        const selectedChanges = yield (0, $aNOuE.select)((0, $25viM.getSelectedChanges));
        const selectedChangesCount = yield (0, $aNOuE.select)((0, $25viM.getSelectedChangesCount));
        yield (0, $aNOuE.put)($91SKv.start(selectedChangesCount));
        try {
            yield (0, $aNOuE.call)($f10a3d0c849d974e$export$c90b346a1ef1c74e, selectedChanges[(0, $TTKUQ.ENTITY).ISSUE]);
            yield (0, $aNOuE.call)($f10a3d0c849d974e$export$337fbf4febbb6d6e, selectedChanges[(0, $TTKUQ.ENTITY).RELEASE]);
            yield (0, $aNOuE.call)($f10a3d0c849d974e$export$c311273348377937, selectedChanges[(0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE]);
            yield (0, $aNOuE.call)($f10a3d0c849d974e$export$ca9a89fd41789c0d, selectedChanges[(0, $TTKUQ.ENTITY).RESOURCE]);
            yield (0, $aNOuE.call)($f10a3d0c849d974e$export$76a9f8d4d2d6478c, selectedChanges[(0, $TTKUQ.ENTITY).TEAM]);
            yield (0, $aNOuE.call)($f10a3d0c849d974e$export$90c04c22c0e8a50f, selectedChanges[(0, $TTKUQ.ENTITY).SPRINT]);
            yield (0, $aNOuE.call)((0, $goTVH.getBacklog));
            if (actions.success) for (const action of actions.success)yield (0, $aNOuE.put)(action);
        } catch (e) {
            yield (0, $aNOuE.call)((0, $goTVH.getBacklog));
            if (actions.error) yield (0, $aNOuE.put)(actions.error);
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        } finally{
            yield (0, $aNOuE.put)($91SKv.stop());
            yield (0, $aNOuE.call)($f10a3d0c849d974e$export$d9d7693e2245e256);
            const data = yield (0, $aNOuE.select)((0, $25viM.getReviewChanges));
            const filteredData = yield (0, $aNOuE.select)((0, $25viM.getFilteredReviewChanges));
            const isOutOfSync = yield (0, $aNOuE.select)((0, $25viM.getIsOutOfSync));
            if (!filteredData.length && !isOutOfSync) yield (0, $aNOuE.put)($aHSC5.clearFilter((0, $ccIrM.USER_FILTER_ID)));
            if (!data.length && !isOutOfSync) yield (0, $aNOuE.put)($aHSC5.closeUpdateJiraDialog());
        }
    }
    function* $f10a3d0c849d974e$export$b869f89bdc5d5ec1() {
        if (yield (0, $aNOuE.select)((0, $25viM.getIsSaving))) yield (0, $aNOuE.put)($iNyXb.interrupt());
        else if (yield (0, $aNOuE.select)((0, $25viM.getIsReverting))) yield (0, $aNOuE.put)($91SKv.interrupt());
    }
    function* $f10a3d0c849d974e$export$555af14e14350990() {
        const state = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const { domain: { plan: { id: planId } } } = state;
        if (!planId) return;
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $ar6WC.urls).updateLastCommittedTimestamp(planId), {
            method: (0, $77QEM.POST)
        });
        if (!response.ok) throw new Error('There was an error when trying to update the plan');
    }
    function* $f10a3d0c849d974e$export$96494dda9a3d57b4() {
        yield (0, $6u3NN.takeLatest)($f10a3d0c849d974e$export$308972e7a1f0c32f, $f10a3d0c849d974e$export$d9d7693e2245e256);
    }
    function* $f10a3d0c849d974e$export$6f18501cc25be345() {
        yield (0, $6u3NN.takeLatest)($f10a3d0c849d974e$export$a031474266a52bb4, $f10a3d0c849d974e$export$1da733c3857c6e08);
    }
    function* $f10a3d0c849d974e$export$73f92641dfd20b98() {
        yield (0, $6u3NN.takeLatest)($f10a3d0c849d974e$export$c73a59414b3152da, $f10a3d0c849d974e$export$ecf66aaaea5ca30a);
    }
    function* $f10a3d0c849d974e$export$e0e74359047007f8() {
        yield (0, $6u3NN.takeLatest)($f10a3d0c849d974e$export$e4edc10ab54a304a, $f10a3d0c849d974e$export$555af14e14350990);
    }
    function* $f10a3d0c849d974e$export$aa6c1e215cb7ce11() {
        yield (0, $6u3NN.takeLatest)($f10a3d0c849d974e$export$7636b4e7de1cbb0c, $f10a3d0c849d974e$export$f88a659cb8822a85);
    }
    function* $f10a3d0c849d974e$export$12a5127652e2889e() {
        yield (0, $6u3NN.takeLatest)($f10a3d0c849d974e$export$5de96f956f57013f, $f10a3d0c849d974e$export$25a1a7245485adb4);
    }
    function* $f10a3d0c849d974e$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($f10a3d0c849d974e$export$96494dda9a3d57b4);
        yield (0, $aNOuE.fork)($f10a3d0c849d974e$export$6f18501cc25be345);
        yield (0, $aNOuE.fork)($f10a3d0c849d974e$export$73f92641dfd20b98);
        yield (0, $aNOuE.fork)($f10a3d0c849d974e$export$e0e74359047007f8);
        yield (0, $aNOuE.fork)($f10a3d0c849d974e$export$aa6c1e215cb7ce11);
        yield (0, $aNOuE.fork)($f10a3d0c849d974e$export$12a5127652e2889e);
        yield (0, $aNOuE.fork)(function*() {
            yield (0, $6u3NN.takeLatest)($f10a3d0c849d974e$export$a9f3c3bb2f676e06, $f10a3d0c849d974e$export$b869f89bdc5d5ec1);
        });
    }
});
parcelRegister("8MQZK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$665bea1f65433fb1$export$2e2bcd8739ae039);
    var $c9RLn;
    var $5oZ01;
    var $cWyha;
    var $2XSIf;
    var $bWXax;
    var $cXTmV;
    var $cBX85;
    var $665bea1f65433fb1$var$dissocPath = (0, (0, parcelRequire("c9RLn")).default)(function dissocPath(path, obj) {
        switch(path.length){
            case 0:
                return obj;
            case 1:
                return (0, (0, parcelRequire("5oZ01")).default)(path[0]) && (0, (0, parcelRequire("cWyha")).default)(obj) ? (0, (0, parcelRequire("cXTmV")).default)(path[0], 1, obj) : (0, (0, parcelRequire("bWXax")).default)(path[0], obj);
            default:
                var head = path[0];
                var tail = Array.prototype.slice.call(path, 1);
                if (obj[head] == null) return obj;
                else if ((0, (0, parcelRequire("5oZ01")).default)(head) && (0, (0, parcelRequire("cWyha")).default)(obj)) return (0, (0, parcelRequire("cBX85")).default)(head, dissocPath(tail, obj[head]), obj);
                else return (0, (0, parcelRequire("2XSIf")).default)(head, dissocPath(tail, obj[head]), obj);
        }
    });
    var $665bea1f65433fb1$export$2e2bcd8739ae039 = $665bea1f65433fb1$var$dissocPath;
});
parcelRegister("9mxDT", function(module, exports) {
    $parcel$export(module.exports, "ADD_BULK", ()=>$e8411891d1617c39$export$4f864ebd809b742);
    $parcel$export(module.exports, "RESET", ()=>$e8411891d1617c39$export$4a991c87e640ef77);
    $parcel$export(module.exports, "addBulk", ()=>$e8411891d1617c39$export$18971c0c4ca9e2fe);
    $parcel$export(module.exports, "reset", ()=>$e8411891d1617c39$export$aad8462122ac592b);
    const $e8411891d1617c39$export$4f864ebd809b742 = 'state.domain.update-jira.changes-warnings.ADD_BULK';
    const $e8411891d1617c39$export$4a991c87e640ef77 = 'state.domain.update-jira.changes-warnings.RESET';
    const $e8411891d1617c39$export$18971c0c4ca9e2fe = (payload)=>({
            type: $e8411891d1617c39$export$4f864ebd809b742,
            payload: payload
        });
    const $e8411891d1617c39$export$aad8462122ac592b = (payload)=>({
            type: $e8411891d1617c39$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("ebcEl", function(module, exports) {
    $parcel$export(module.exports, "SENT", ()=>$345d3c9bc64b14fd$export$f083ed52efef4a01);
    $parcel$export(module.exports, "SUCCESS", ()=>$345d3c9bc64b14fd$export$638cc6e36b2a737a);
    $parcel$export(module.exports, "AFTER_SUCCESS", ()=>$345d3c9bc64b14fd$export$c1338e083bd3d6c5);
    $parcel$export(module.exports, "ERROR", ()=>$345d3c9bc64b14fd$export$103bedf43ba882db);
    $parcel$export(module.exports, "sent", ()=>$345d3c9bc64b14fd$export$50bb50b39823aeba);
    $parcel$export(module.exports, "success", ()=>$345d3c9bc64b14fd$export$fe7c49d056ea1d88);
    $parcel$export(module.exports, "afterSuccess", ()=>$345d3c9bc64b14fd$export$43fb54a6937a3c03);
    $parcel$export(module.exports, "error", ()=>$345d3c9bc64b14fd$export$a3bc9b8ed74fc);
    const $345d3c9bc64b14fd$export$f083ed52efef4a01 = 'state.domain.update-jira.changes.SENT';
    const $345d3c9bc64b14fd$export$638cc6e36b2a737a = 'state.domain.update-jira.changes.SUCCESS';
    const $345d3c9bc64b14fd$export$c1338e083bd3d6c5 = 'state.domain.update-jira.changes.AFTER_SUCCESS';
    const $345d3c9bc64b14fd$export$103bedf43ba882db = 'state.domain.update-jira.changes.ERROR';
    const $345d3c9bc64b14fd$export$50bb50b39823aeba = ()=>({
            type: $345d3c9bc64b14fd$export$f083ed52efef4a01
        });
    const $345d3c9bc64b14fd$export$fe7c49d056ea1d88 = (payload)=>({
            type: $345d3c9bc64b14fd$export$638cc6e36b2a737a,
            payload: payload
        });
    const $345d3c9bc64b14fd$export$43fb54a6937a3c03 = ()=>({
            type: $345d3c9bc64b14fd$export$c1338e083bd3d6c5
        });
    const $345d3c9bc64b14fd$export$a3bc9b8ed74fc = (payload)=>({
            type: $345d3c9bc64b14fd$export$103bedf43ba882db,
            payload: payload
        });
});
parcelRegister("91SKv", function(module, exports) {
    $parcel$export(module.exports, "START", ()=>$c936c0ffebb8fdc1$export$21c466265830bc3a);
    $parcel$export(module.exports, "INCREMENT_NUMBER_OF_REVERTED_CHANGES", ()=>$c936c0ffebb8fdc1$export$3eb3aeac2dc57cff);
    $parcel$export(module.exports, "INTERRUPT", ()=>$c936c0ffebb8fdc1$export$a9f3c3bb2f676e06);
    $parcel$export(module.exports, "STOP", ()=>$c936c0ffebb8fdc1$export$82b9a23e44460c20);
    $parcel$export(module.exports, "start", ()=>$c936c0ffebb8fdc1$export$b3571188c770cc5a);
    $parcel$export(module.exports, "incrementNumberOfRevertedChanges", ()=>$c936c0ffebb8fdc1$export$7ef033a43cf24941);
    $parcel$export(module.exports, "interrupt", ()=>$c936c0ffebb8fdc1$export$7b7d62677a00f822);
    $parcel$export(module.exports, "stop", ()=>$c936c0ffebb8fdc1$export$fa6813432f753b0d);
    const $c936c0ffebb8fdc1$export$21c466265830bc3a = 'state.domain.update-jira.revert.START';
    const $c936c0ffebb8fdc1$export$3eb3aeac2dc57cff = 'state.domain.update-jira.revert.INCREMENT_NUMBER_OF_REVERTED_CHANGES';
    const $c936c0ffebb8fdc1$export$a9f3c3bb2f676e06 = 'state.domain.update-jira.revert.INTERRUPT';
    const $c936c0ffebb8fdc1$export$82b9a23e44460c20 = 'state.domain.update-jira.revert.STOP';
    const $c936c0ffebb8fdc1$export$b3571188c770cc5a = (totalChanges)=>({
            type: $c936c0ffebb8fdc1$export$21c466265830bc3a,
            payload: totalChanges
        });
    const $c936c0ffebb8fdc1$export$7ef033a43cf24941 = ()=>({
            type: $c936c0ffebb8fdc1$export$3eb3aeac2dc57cff
        });
    const $c936c0ffebb8fdc1$export$7b7d62677a00f822 = ()=>({
            type: $c936c0ffebb8fdc1$export$a9f3c3bb2f676e06
        });
    const $c936c0ffebb8fdc1$export$fa6813432f753b0d = ()=>({
            type: $c936c0ffebb8fdc1$export$82b9a23e44460c20
        });
});
parcelRegister("aHSC5", function(module, exports) {
    $parcel$export(module.exports, "OPEN_UPDATE_JIRA_DIALOG", ()=>$6527b5cbee0741ae$export$200e9ae2a09a2e08);
    $parcel$export(module.exports, "CLOSE_UPDATE_JIRA_DIALOG", ()=>$6527b5cbee0741ae$export$e69c7d485722335e);
    $parcel$export(module.exports, "EXPAND_UPDATE_JIRA_DIALOG_CHANGE", ()=>$6527b5cbee0741ae$export$21158182fc61c195);
    $parcel$export(module.exports, "COLLAPSE_UPDATE_JIRA_DIALOG_CHANGE", ()=>$6527b5cbee0741ae$export$22e3a9f5b7095d0e);
    $parcel$export(module.exports, "CLOSE_COMMIT_WARNING_FLAG", ()=>$6527b5cbee0741ae$export$68f98813700bf28a);
    $parcel$export(module.exports, "SELECT_CHANGE", ()=>$6527b5cbee0741ae$export$3988ad83d406c69a);
    $parcel$export(module.exports, "DESELECT_CHANGE", ()=>$6527b5cbee0741ae$export$5279058cec1d0a47);
    $parcel$export(module.exports, "SELECT_ALL_CHANGES", ()=>$6527b5cbee0741ae$export$4d81e085299caab3);
    $parcel$export(module.exports, "DESELECT_ALL_CHANGES", ()=>$6527b5cbee0741ae$export$e83712732e630a07);
    $parcel$export(module.exports, "REPLACE_SELECTED_CHANGES", ()=>$6527b5cbee0741ae$export$6eb56e01d786a268);
    $parcel$export(module.exports, "SORT_CHANGES", ()=>$6527b5cbee0741ae$export$4df47d0242175a06);
    $parcel$export(module.exports, "CHANGE_FILTER", ()=>$6527b5cbee0741ae$export$d02a1637d15b4bed);
    $parcel$export(module.exports, "CLEAR_FILTER", ()=>$6527b5cbee0741ae$export$80f6e3f69ac5bef4);
    $parcel$export(module.exports, "UPDATE_NOTIFICATION_PREFERENCE", ()=>$6527b5cbee0741ae$export$ba367bd16fc3c33c);
    $parcel$export(module.exports, "CHANGE_QUICK_SELECT", ()=>$6527b5cbee0741ae$export$afe070bce8c7789a);
    $parcel$export(module.exports, "expandChange", ()=>$6527b5cbee0741ae$export$5d5b64526974bb5b);
    $parcel$export(module.exports, "collapseChange", ()=>$6527b5cbee0741ae$export$2c8a6ea62723bd5c);
    $parcel$export(module.exports, "selectChange", ()=>$6527b5cbee0741ae$export$4711beb50aac99ca);
    $parcel$export(module.exports, "selectAllChanges", ()=>$6527b5cbee0741ae$export$528e92eb1d1ed679);
    $parcel$export(module.exports, "deselectChange", ()=>$6527b5cbee0741ae$export$cfdf286e64c890ef);
    $parcel$export(module.exports, "deselectAllChanges", ()=>$6527b5cbee0741ae$export$f329ca2428faec41);
    $parcel$export(module.exports, "replaceSelectedChanges", ()=>$6527b5cbee0741ae$export$af5446a491c79a66);
    $parcel$export(module.exports, "openUpdateJiraDialog", ()=>$6527b5cbee0741ae$export$9556be913e22e834);
    $parcel$export(module.exports, "closeUpdateJiraDialog", ()=>$6527b5cbee0741ae$export$63ccf6460d2b3a2d);
    $parcel$export(module.exports, "closeCommitWarningFlag", ()=>$6527b5cbee0741ae$export$d9feb970119457c2);
    $parcel$export(module.exports, "sortChanges", ()=>$6527b5cbee0741ae$export$6d088339d2e39cdd);
    $parcel$export(module.exports, "changeFilter", ()=>$6527b5cbee0741ae$export$347972a19297a2b7);
    $parcel$export(module.exports, "clearFilter", ()=>$6527b5cbee0741ae$export$77cedf2a856f1597);
    $parcel$export(module.exports, "updateNotificationPreference", ()=>$6527b5cbee0741ae$export$bb54798cc2dbcdbb);
    $parcel$export(module.exports, "changeQuickSelect", ()=>$6527b5cbee0741ae$export$c18a1ba68b68c2bd);
    const $6527b5cbee0741ae$export$200e9ae2a09a2e08 = 'state.ui.top.title-bar.update-jira.OPEN_UPDATE_JIRA_DIALOG';
    const $6527b5cbee0741ae$export$e69c7d485722335e = 'state.ui.top.title-bar.update-jira.CLOSE_UPDATE_JIRA_DIALOG';
    const $6527b5cbee0741ae$export$21158182fc61c195 = 'state.ui.top.title-bar.update-jira.EXPAND_UPDATE_JIRA_DIALOG_CHANGE';
    const $6527b5cbee0741ae$export$22e3a9f5b7095d0e = 'state.ui.top.title-bar.update-jira.COLLAPSE_UPDATE_JIRA_DIALOG_CHANGE';
    const $6527b5cbee0741ae$export$68f98813700bf28a = 'state.ui.top.title-bar.update-jira.CLOSE_COMMIT_WARNING_FLAG';
    const $6527b5cbee0741ae$export$3988ad83d406c69a = 'state.ui.top.title-bar.update-jira.SELECT_CHANGE';
    const $6527b5cbee0741ae$export$5279058cec1d0a47 = 'state.ui.top.title-bar.update-jira.DESELECT_CHANGE';
    const $6527b5cbee0741ae$export$4d81e085299caab3 = 'state.ui.top.title-bar.update-jira.SELECT_ALL_CHANGES';
    const $6527b5cbee0741ae$export$e83712732e630a07 = 'state.ui.top.title-bar.update-jira.DESELECT_ALL_CHANGES';
    const $6527b5cbee0741ae$export$6eb56e01d786a268 = 'state.ui.top.title-bar.update-jira.REPLACE_SELECTED_CHANGES';
    const $6527b5cbee0741ae$export$4df47d0242175a06 = 'state.ui.top.title-bar.update-jira.SORT_CHANGES';
    const $6527b5cbee0741ae$export$d02a1637d15b4bed = 'state.ui.top.title-bar.update-jira.CHANGE_FILTER';
    const $6527b5cbee0741ae$export$80f6e3f69ac5bef4 = 'state.ui.top.title-bar.update-jira.CLEAR_FILTER';
    const $6527b5cbee0741ae$export$ba367bd16fc3c33c = 'state.ui.top.title-bar.update-jira.UPDATE_NOTIFICATION_PREFERENCE';
    const $6527b5cbee0741ae$export$afe070bce8c7789a = 'state.ui.top.title-bar.update-jira.SET_QUICK_SELECT';
    const $6527b5cbee0741ae$export$5d5b64526974bb5b = (changeId, category)=>({
            type: $6527b5cbee0741ae$export$21158182fc61c195,
            payload: {
                id: changeId,
                category: category
            }
        });
    const $6527b5cbee0741ae$export$2c8a6ea62723bd5c = (changeId, category)=>({
            type: $6527b5cbee0741ae$export$22e3a9f5b7095d0e,
            payload: {
                id: changeId,
                category: category
            }
        });
    const $6527b5cbee0741ae$export$4711beb50aac99ca = (changeId, category)=>({
            type: $6527b5cbee0741ae$export$3988ad83d406c69a,
            payload: {
                id: changeId,
                category: category
            }
        });
    const $6527b5cbee0741ae$export$528e92eb1d1ed679 = (changes)=>({
            type: $6527b5cbee0741ae$export$4d81e085299caab3,
            payload: changes
        });
    const $6527b5cbee0741ae$export$cfdf286e64c890ef = (changeId, category)=>({
            type: $6527b5cbee0741ae$export$5279058cec1d0a47,
            payload: {
                id: changeId,
                category: category
            }
        });
    const $6527b5cbee0741ae$export$f329ca2428faec41 = ()=>({
            type: $6527b5cbee0741ae$export$e83712732e630a07
        });
    const $6527b5cbee0741ae$export$af5446a491c79a66 = (changes)=>({
            type: $6527b5cbee0741ae$export$6eb56e01d786a268,
            payload: changes
        });
    const $6527b5cbee0741ae$export$9556be913e22e834 = ()=>({
            type: $6527b5cbee0741ae$export$200e9ae2a09a2e08
        });
    const $6527b5cbee0741ae$export$63ccf6460d2b3a2d = ()=>({
            type: $6527b5cbee0741ae$export$e69c7d485722335e
        });
    const $6527b5cbee0741ae$export$d9feb970119457c2 = ()=>({
            type: $6527b5cbee0741ae$export$68f98813700bf28a
        });
    const $6527b5cbee0741ae$export$6d088339d2e39cdd = (sortBy, sortDirection)=>({
            type: $6527b5cbee0741ae$export$4df47d0242175a06,
            payload: {
                sortBy: sortBy,
                sortDirection: sortDirection
            }
        });
    const $6527b5cbee0741ae$export$347972a19297a2b7 = (payload)=>({
            type: $6527b5cbee0741ae$export$d02a1637d15b4bed,
            payload: payload
        });
    const $6527b5cbee0741ae$export$77cedf2a856f1597 = (payload)=>({
            type: $6527b5cbee0741ae$export$80f6e3f69ac5bef4,
            payload: payload
        });
    const $6527b5cbee0741ae$export$bb54798cc2dbcdbb = (payload)=>({
            type: $6527b5cbee0741ae$export$ba367bd16fc3c33c,
            payload: payload
        });
    const $6527b5cbee0741ae$export$c18a1ba68b68c2bd = (payload)=>({
            type: $6527b5cbee0741ae$export$afe070bce8c7789a,
            payload: payload
        });
});
parcelRegister("3pJIs", function(module, exports) {
    $parcel$export(module.exports, "executeBulkCommitRequest", ()=>$084a08c5295a5bc9$export$1a42b6fc7ec66ade);
    $parcel$export(module.exports, "createBulkCommitRequestEntityList", ()=>$084a08c5295a5bc9$export$902136b0124933d2);
    var $83IGl;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $kbGxr = parcelRequire("kbGxr");
    var $ddv1K = parcelRequire("ddv1K");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $gFhwb = parcelRequire("gFhwb");
    var $36p1o = parcelRequire("36p1o");
    var $iNyXb = parcelRequire("iNyXb");
    var $42ZEf = parcelRequire("42ZEf");
    var $ccCF0 = parcelRequire("ccCF0");
    var $77QEM = parcelRequire("77QEM");
    var $hjabd = parcelRequire("hjabd");
    var $asXbx = parcelRequire("asXbx");
    var $aH97t = parcelRequire("aH97t");
    var $5zPyn = parcelRequire("5zPyn");
    const $084a08c5295a5bc9$export$a9f3c3bb2f676e06 = 'command.update-jira.INTERRUPT';
    const $084a08c5295a5bc9$export$7b7d62677a00f822 = ()=>({
            type: $084a08c5295a5bc9$export$a9f3c3bb2f676e06
        });
    function* $084a08c5295a5bc9$export$1a42b6fc7ec66ade(bulkCommitIssues, notifyWatchers) {
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = (0, $aH97t.bulkCommitBody)({
            id: planId,
            currentScenarioId: currentScenarioId
        }, sequence, bulkCommitIssues, notifyWatchers);
        const response = yield* $asXbx.json({
            url: (0, $aH97t.bulkCommitUrl),
            profile: (0, $aH97t.bulkCommitUrl),
            method: (0, $77QEM.POST),
            body: body
        });
        if (!response.ok) {
            yield (0, $aNOuE.put).resolve($084a08c5295a5bc9$export$7b7d62677a00f822());
            return undefined;
        }
        const responseBody = response.data;
        yield (0, $aNOuE.put)((0, $36p1o.update)(responseBody.sequenceChanges));
        return responseBody;
    }
    function* $084a08c5295a5bc9$export$e328200534490fb3(selectedChanges) {
        yield (0, $aNOuE.put)((0, $42ZEf.reset)([]));
        const issueChangesMetaData = yield (0, $aNOuE.select)((0, $bI9dZ.getIssueChangesMetaData));
        const issueAndIssueLinkCommitEntities = [];
        let issueLinkOnlyIssueChangesCount = 0;
        const issueIdsBeingCommitted = new Set();
        const issuesById = yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById));
        for (const id of selectedChanges){
            const parentIdOfThisIssue = issuesById[id]?.parent;
            if ((0, $kbGxr.isScenarioIssue)(parentIdOfThisIssue) && !issueIdsBeingCommitted.has(parentIdOfThisIssue)) {
                const uncommittedWarnings = yield (0, $aNOuE.call)((0, $hjabd.inspectForCommitWarnings), undefined, {
                    error: 'UNCOMMITTED_PARENT',
                    errorMessages: []
                });
                yield (0, $aNOuE.put)((0, $ccCF0.add)({
                    category: (0, $TTKUQ.ENTITY).ISSUE,
                    itemId: id,
                    warnings: uncommittedWarnings
                }));
                yield (0, $aNOuE.put)((0, $iNyXb.incrementNumberOfCommittedChanges)());
                yield (0, $aNOuE.put).resolve($084a08c5295a5bc9$export$7b7d62677a00f822());
                break;
            }
            if (issueChangesMetaData[id]) {
                issueAndIssueLinkCommitEntities.push({
                    entityType: (0, $5zPyn.BulkCommitEntityType).ISSUE,
                    itemKey: id
                });
                issueIdsBeingCommitted.add(id);
            } else issueLinkOnlyIssueChangesCount += 1;
        }
        const issueLinkChanges = yield (0, $aNOuE.select)((0, $ddv1K.getIssueLinkChangesData));
        const issueLinkChangesSet = new Set();
        const issueLinkToIssueMap = new Map();
        for (const issueId of selectedChanges){
            for (const { itemKey: itemKey } of issueLinkChanges[issueId] ?? [])if (!issueLinkChangesSet.has(itemKey)) {
                issueAndIssueLinkCommitEntities.push({
                    entityType: (0, $5zPyn.BulkCommitEntityType).ISSUE_LINK,
                    itemKey: itemKey
                });
                issueLinkChangesSet.add(itemKey);
                issueLinkToIssueMap.set(itemKey, issueId);
            }
        }
        return {
            issueAndIssueLinkCommitEntities: issueAndIssueLinkCommitEntities,
            issueLinkOnlyIssueChangesCount: issueLinkOnlyIssueChangesCount,
            issueLinkToIssueMap: issueLinkToIssueMap
        };
    }
    function* $084a08c5295a5bc9$export$902136b0124933d2(selectedChanges, selectedIssues, allPlannedCapacityChanges) {
        const bulkCommitEntities = [];
        selectedChanges[(0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE]?.forEach((id)=>{
            bulkCommitEntities.push({
                entityType: (0, $5zPyn.BulkCommitEntityType).X_PROJECT_VERSION,
                itemKey: id
            });
        });
        selectedChanges[(0, $TTKUQ.ENTITY).RELEASE]?.forEach((id)=>{
            bulkCommitEntities.push({
                entityType: (0, $5zPyn.BulkCommitEntityType).VERSION,
                itemKey: id
            });
        });
        selectedChanges[(0, $TTKUQ.ENTITY).TEAM]?.forEach((id)=>{
            bulkCommitEntities.push({
                entityType: (0, $5zPyn.BulkCommitEntityType).TEAM,
                itemKey: id
            });
        });
        selectedChanges[(0, $TTKUQ.ENTITY).RESOURCE]?.forEach((id)=>{
            bulkCommitEntities.push({
                entityType: (0, $5zPyn.BulkCommitEntityType).RESOURCE,
                itemKey: id
            });
        });
        selectedChanges[(0, $TTKUQ.ENTITY).SPRINT]?.forEach((id)=>{
            allPlannedCapacityChanges.filter((capacityChange)=>capacityChange.iterationId === id && (0, $4nDwW.isDefined)(capacityChange.values.itemKey)).forEach((capacityChange)=>bulkCommitEntities.push({
                    entityType: (0, $5zPyn.BulkCommitEntityType).PLANNED_CAPACITY,
                    itemKey: capacityChange.values.itemKey
                }));
        });
        const { issueAndIssueLinkCommitEntities: issueAndIssueLinkCommitEntities, issueLinkOnlyIssueChangesCount: issueLinkOnlyIssueChangesCount, issueLinkToIssueMap: issueLinkToIssueMap } = yield (0, $aNOuE.call)($084a08c5295a5bc9$export$e328200534490fb3, selectedIssues);
        bulkCommitEntities.push(...issueAndIssueLinkCommitEntities);
        return {
            bulkCommitEntities: bulkCommitEntities,
            issueLinkOnlyIssueChangesCount: issueLinkOnlyIssueChangesCount,
            issueLinkToIssueMap: issueLinkToIssueMap
        };
    }
});
parcelRegister("aH97t", function(module, exports) {
    $parcel$export(module.exports, "bulkCommitUrl", ()=>$45111fd55e16d6dd$export$7c4e50214fe2513b);
    $parcel$export(module.exports, "bulkCommitBody", ()=>$45111fd55e16d6dd$export$10adece601c6a143);
    var $cBJwN;
    var $ar6WC = parcelRequire("ar6WC");
    const $45111fd55e16d6dd$export$7c4e50214fe2513b = '/rest/jpo/1.0/bulk-commit';
    const $45111fd55e16d6dd$export$10adece601c6a143 = ({ id: planId, currentScenarioId: scenarioId }, sequence, orderedCommitEntities, notifyWatchers = true)=>{
        if (!planId || !scenarioId) throw new Error('Need both plan and scenario to commit or get changes');
        const payload = {
            planId: planId,
            scenarioId: scenarioId,
            sequence: (0, parcelRequire("cBJwN")).default((0, $ar6WC.sequenceKeys).map((key)=>[
                    key,
                    {
                        current: sequence[key]?.current ?? 0
                    }
                ])),
            orderedCommitEntities: orderedCommitEntities,
            notifyWatchers: notifyWatchers
        };
        return payload;
    };
});
parcelRegister("5zPyn", function(module, exports) {
    $parcel$export(module.exports, "BulkCommitEntityType", ()=>$af41fbd15b891d27$export$491435a7bc7b10e7);
    const $af41fbd15b891d27$export$491435a7bc7b10e7 = {
        X_PROJECT_VERSION: 'X_PROJECT_VERSION',
        VERSION: 'VERSION',
        TEAM: 'TEAM',
        RESOURCE: 'RESOURCE',
        PLANNED_CAPACITY: 'PLANNED_CAPACITY',
        ISSUE: 'ISSUE',
        ISSUE_LINK: 'ISSUE_LINK'
    };
});
parcelRegister("knys8", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "ADD_RELEASE", ()=>$c56391e0603f160a$export$2bdfac268df97e49);
    $parcel$export(module.exports, "UPDATE_RELEASE", ()=>$c56391e0603f160a$export$3f90e3abee6e8d70);
    $parcel$export(module.exports, "DELETE_RELEASE", ()=>$c56391e0603f160a$export$440c54a43c85f449);
    $parcel$export(module.exports, "ALIGN_DATES_OF_RELEASES", ()=>$c56391e0603f160a$export$4192fcdf48d80cf0);
    $parcel$export(module.exports, "VIEW_RELEASE_IN_ROADMAP", ()=>$c56391e0603f160a$export$a54e64fcc2f0026f);
    $parcel$export(module.exports, "addRelease", ()=>$c56391e0603f160a$export$d7ff8290d1a14fa1);
    $parcel$export(module.exports, "updateRelease", ()=>$c56391e0603f160a$export$a5f005f0031c650d);
    $parcel$export(module.exports, "deleteRelease", ()=>$c56391e0603f160a$export$41b4061737a08cd);
    $parcel$export(module.exports, "alignDatesOfReleases", ()=>$c56391e0603f160a$export$bb284c7cbd912e33);
    $parcel$export(module.exports, "viewReleaseInRoadmap", ()=>$c56391e0603f160a$export$4ddde390df08566c);
    $parcel$export(module.exports, "addRemovedCrossProjectVersionToMainCrossProjectVersionsList", ()=>$c56391e0603f160a$export$a9e2c51d05f71323);
    $parcel$export(module.exports, "handleCrossProjectVersionWarnings", ()=>$c56391e0603f160a$export$788bc0a886dbb81f);
    $parcel$export(module.exports, "handleCrossProjectVersionCommitResponse", ()=>$c56391e0603f160a$export$3ca5d248d9658375);
    $parcel$export(module.exports, "revertChange", ()=>$c56391e0603f160a$export$be623675b8f208ee);
    $parcel$export(module.exports, "addVersionInCrossProjectVersion", ()=>$c56391e0603f160a$export$8e127e72248d08);
    $parcel$export(module.exports, "removeVersionFromCrossProjectVersion", ()=>$c56391e0603f160a$export$ac89d6cd5251dbf4);
    $parcel$export(module.exports, "addCrossProjectVersionInStore", ()=>$c56391e0603f160a$export$3b6da5955bae8c75);
    $parcel$export(module.exports, "removeCrossProjectVersionFromStore", ()=>$c56391e0603f160a$export$4bbfd299114d60db);
    $parcel$export(module.exports, "doUpdateVersion", ()=>$c56391e0603f160a$export$740de856a6989843);
    $parcel$export(module.exports, "updateStateAfterAddingVersion", ()=>$c56391e0603f160a$export$476de812fbbb6302);
    $parcel$export(module.exports, "doAddVersion", ()=>$c56391e0603f160a$export$89ca6b91461e4dc);
    $parcel$export(module.exports, "updateStateAfterDeletingCrossProjectVersion", ()=>$c56391e0603f160a$export$ed51d7a10005fa33);
    $parcel$export(module.exports, "doDeleteVersion", ()=>$c56391e0603f160a$export$c7f0d1a6ee665364);
    $parcel$export(module.exports, "doAlignDatesOfReleases", ()=>$c56391e0603f160a$export$4653b8ba9e3d5d06);
    $parcel$export(module.exports, "doViewReleaseInRoadmap", ()=>$c56391e0603f160a$export$6305f6649b21cb82);
    $parcel$export(module.exports, "watchAddVersion", ()=>$c56391e0603f160a$export$7636f00a67e1b930);
    $parcel$export(module.exports, "watchUpdateVersion", ()=>$c56391e0603f160a$export$919e3b6069d2417d);
    $parcel$export(module.exports, "watchDeleteVersion", ()=>$c56391e0603f160a$export$877c3b6cd35254fd);
    $parcel$export(module.exports, "watchAlignDatesOfReleases", ()=>$c56391e0603f160a$export$37dcd128d22a75be);
    $parcel$export(module.exports, "watchViewReleaseInRoadmap", ()=>$c56391e0603f160a$export$20993805280f607e);
    $parcel$export(module.exports, "default", ()=>$c56391e0603f160a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "openProjectReleasesFlyout", ()=>(parcelRequire("9MFji")).openFlyout);
    $parcel$export(module.exports, "closeProjectReleasesFlyout", ()=>(parcelRequire("9MFji")).closeFlyout);
    $parcel$export(module.exports, "setModeForCreateUpdateDialog", ()=>(parcelRequire("77qPV")).setMode);
    $parcel$export(module.exports, "openCreateUpdateDialog", ()=>(parcelRequire("77qPV")).openDialog);
    $parcel$export(module.exports, "closeCreateUpdateDialog", ()=>(parcelRequire("77qPV")).closeDialog);
    $parcel$export(module.exports, "openAlignDatesDialog", ()=>(parcelRequire("jl9zM")).openDialog);
    $parcel$export(module.exports, "closeAlignDatesDialog", ()=>(parcelRequire("jl9zM")).closeDialog);
    $parcel$export(module.exports, "openDeleteDialog", ()=>(parcelRequire("3rJDR")).openDialog);
    $parcel$export(module.exports, "closeDeleteDialog", ()=>(parcelRequire("3rJDR")).closeDialog);
    $parcel$export(module.exports, "CREATE_RELEASE", ()=>$9f0e8f377b448222$export$afecb711a599950a);
    $parcel$export(module.exports, "EDIT_RELEASE", ()=>$9f0e8f377b448222$export$b9385259cf8397cd);
    var $bWXax;
    var $83IGl;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $4R6GH;
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $jw86H = parcelRequire("jw86H");
    var $bHTqr = parcelRequire("bHTqr");
    var $gFvn5 = parcelRequire("gFvn5");
    var $bt366 = parcelRequire("bt366");
    var $fHpRV = parcelRequire("fHpRV");
    var $36p1o = parcelRequire("36p1o");
    var $ccCF0 = parcelRequire("ccCF0");
    var $cGbfF = parcelRequire("cGbfF");
    var $jl9zM = parcelRequire("jl9zM");
    var $3rJDR = parcelRequire("3rJDR");
    var $77qPV = parcelRequire("77qPV");
    var $77QEM = parcelRequire("77QEM");
    var $bYhSc = parcelRequire("bYhSc");
    var $hNEap = parcelRequire("hNEap");
    var $hjabd = parcelRequire("hjabd");
    var $24CMK = parcelRequire("24CMK");
    var $834it = parcelRequire("834it");
    var $asXbx = parcelRequire("asXbx");
    var $hvOzF = parcelRequire("hvOzF");
    var $fCn53 = parcelRequire("fCn53");
    var $9MFji = parcelRequire("9MFji");
    var $77qPV = parcelRequire("77qPV");
    var $jl9zM = parcelRequire("jl9zM");
    var $3rJDR = parcelRequire("3rJDR");
    let $c56391e0603f160a$var$versionsCommands = {};
    const $c56391e0603f160a$export$2bdfac268df97e49 = 'command.cross-project-versions.ADD_RELEASE';
    const $c56391e0603f160a$export$3f90e3abee6e8d70 = 'command.cross-project-versions.UPDATE_RELEASE';
    const $c56391e0603f160a$export$440c54a43c85f449 = 'command.cross-project-versions.DELETE_RELEASE';
    const $c56391e0603f160a$export$4192fcdf48d80cf0 = 'command.cross-project-versions.ALIGN_DATES_OF_RELEASES';
    const $c56391e0603f160a$export$a54e64fcc2f0026f = 'command.cross-project-versions.VIEW_RELEASE_IN_ROADMAP';
    const $c56391e0603f160a$export$d7ff8290d1a14fa1 = (version, analyticsEvent)=>({
            type: $c56391e0603f160a$export$2bdfac268df97e49,
            payload: version,
            meta: {
                analyticsEvent: analyticsEvent
            }
        });
    const $c56391e0603f160a$export$a5f005f0031c650d = (payload)=>({
            type: $c56391e0603f160a$export$3f90e3abee6e8d70,
            payload: payload
        });
    const $c56391e0603f160a$export$41b4061737a08cd = (payload)=>({
            type: $c56391e0603f160a$export$440c54a43c85f449,
            payload: payload
        });
    const $c56391e0603f160a$export$bb284c7cbd912e33 = (payload)=>({
            type: $c56391e0603f160a$export$4192fcdf48d80cf0,
            payload: payload
        });
    const $c56391e0603f160a$export$4ddde390df08566c = (filterValue)=>({
            type: $c56391e0603f160a$export$a54e64fcc2f0026f,
            payload: filterValue
        });
    function* $c56391e0603f160a$export$a9e2c51d05f71323(removedVersion) {
        const { id: id } = removedVersion;
        yield (0, $aNOuE.put)($fHpRV.remove(id));
        yield (0, $aNOuE.put)($gFvn5.add(removedVersion));
    }
    function* $c56391e0603f160a$export$788bc0a886dbb81f(entityResponse) {
        if (entityResponse.success) {
            const internalEntity = entityResponse.entity?.entity;
            const warnings = yield (0, $aNOuE.call)((0, $hjabd.inspectForCommitWarnings), internalEntity, entityResponse.error);
            if (warnings.length) yield (0, $aNOuE.put)((0, $ccCF0.add)({
                category: (0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE,
                itemId: entityResponse.generatedId ?? entityResponse.itemKey,
                warnings: warnings
            }));
        } else yield (0, $aNOuE.put)((0, $ccCF0.add)({
            category: (0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE,
            itemId: entityResponse.generatedId ?? entityResponse.itemKey,
            warnings: [
                (0, $hjabd.defaultWarning)
            ]
        }));
    }
    function* $c56391e0603f160a$export$3ca5d248d9658375(entityResponse) {
        yield (0, $aNOuE.call)($c56391e0603f160a$export$788bc0a886dbb81f, entityResponse);
        const id = entityResponse.itemKey;
        const newId = entityResponse.generatedId ?? id;
        const removedCrossProjectVersionsById = yield (0, $aNOuE.select)((0, $jw86H.getRemovedCrossProjectVersionsById));
        const removedCrossProjectVersion = removedCrossProjectVersionsById[id];
        if (newId !== id) {
            yield (0, $aNOuE.put)($gFvn5.bulkUpdate({
                [id]: {
                    id: newId
                }
            }));
            yield (0, $aNOuE.call)($c56391e0603f160a$var$versionsCommands.updateReferences, {
                crossProjectVersion: [
                    [
                        id,
                        newId
                    ]
                ]
            });
        }
        if ((0, $4nDwW.isDefined)(removedCrossProjectVersion)) {
            yield (0, $aNOuE.put)($fHpRV.remove(id));
            yield (0, $aNOuE.call)($c56391e0603f160a$var$versionsCommands.updateReferences, {
                crossProjectVersion: [
                    [
                        id,
                        null
                    ]
                ]
            });
        }
        const originals = yield (0, $aNOuE.select)((0, $jw86H.getOriginalCrossProjectVersions));
        yield (0, $aNOuE.put)($bt366.reset((0, parcelRequire("bWXax")).default(id, originals)));
    }
    function* $c56391e0603f160a$export$be623675b8f208ee(id) {
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const body = (0, $hNEap.revertBody)({
            id: planId,
            currentScenarioId: currentScenarioId
        }, sequence, id);
        const response = yield* $asXbx.json({
            url: (0, $fCn53.urls).revertChanges,
            method: 'POST',
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = response.data;
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
        }
        return response;
    }
    function* $c56391e0603f160a$export$8e127e72248d08(versionId, crossProjectVersionId) {
        const removedCrossProjectVersionsById = yield (0, $aNOuE.select)((0, $jw86H.getRemovedCrossProjectVersionsById));
        const removedCrossProjectVersion = removedCrossProjectVersionsById[crossProjectVersionId];
        if ((0, $4nDwW.isDefined)(removedCrossProjectVersion)) yield (0, $aNOuE.put)($fHpRV.addVersionInCrossProjectVersion({
            crossProjectVersionId: crossProjectVersionId,
            versionId: versionId
        }));
        else yield (0, $aNOuE.put)($gFvn5.addVersionInCrossProjectVersion({
            crossProjectVersionId: crossProjectVersionId,
            versionId: versionId
        }));
    }
    function* $c56391e0603f160a$export$ac89d6cd5251dbf4(versionId, crossProjectVersionId) {
        const removedCrossProjectVersionsById = yield (0, $aNOuE.select)((0, $jw86H.getRemovedCrossProjectVersionsById));
        const removedCrossProjectVersion = removedCrossProjectVersionsById[crossProjectVersionId];
        if ((0, $4nDwW.isDefined)(removedCrossProjectVersion)) yield (0, $aNOuE.put)($fHpRV.removeVersionFromCrossProjectVersion({
            crossProjectVersionId: crossProjectVersionId,
            versionId: versionId
        }));
        else yield (0, $aNOuE.put)($gFvn5.removeVersionFromCrossProjectVersion({
            crossProjectVersionId: crossProjectVersionId,
            versionId: versionId
        }));
    }
    function* $c56391e0603f160a$export$3b6da5955bae8c75({ id: id, name: name, versions: versions }) {
        yield (0, $aNOuE.put)($gFvn5.add({
            id: id,
            name: name,
            versions: []
        }));
        for (const versionId of versions){
            const patch = {
                versionId: versionId,
                patch: {
                    crossProjectVersion: id
                }
            };
            yield (0, $aNOuE.call)($c56391e0603f160a$var$versionsCommands.updateVersion, patch);
        }
    }
    function* $c56391e0603f160a$export$4bbfd299114d60db(versionId) {
        yield (0, $aNOuE.put)($gFvn5.remove(versionId));
        yield (0, $aNOuE.call)($c56391e0603f160a$var$versionsCommands.revertReferences, {
            crossProjectVersion: [
                versionId
            ]
        });
        const originals = yield (0, $aNOuE.select)((0, $jw86H.getOriginalCrossProjectVersions));
        yield (0, $aNOuE.put)($bt366.reset((0, parcelRequire("bWXax")).default(versionId, originals)));
    }
    function* $c56391e0603f160a$export$740de856a6989843({ payload: payload }) {
        yield (0, $aNOuE.put)((0, $77qPV.initiateRequest)());
        try {
            const url = (0, $fCn53.urls).update;
            const body = (0, $fCn53.updateVersionBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), payload);
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const { versionId: versionId, patch: patch } = payload;
                const crossProjectVersionsById = yield (0, $aNOuE.select)((0, $jw86H.getCrossProjectVersionsById));
                const { name: originalName } = crossProjectVersionsById[versionId];
                const { change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
                yield* (0, $bYhSc.default)(function*() {
                    yield (0, $aNOuE.put)($gFvn5.bulkUpdate({
                        [versionId]: patch
                    }));
                    yield (0, $aNOuE.put)($bt366.update({
                        id: versionId,
                        values: {
                            name: originalName
                        }
                    }));
                    yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
                    yield (0, $aNOuE.put)((0, $77qPV.closeDialog)());
                });
            } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
                const error = new Error(response.text());
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'update-cross-project-versions-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
            yield (0, $aNOuE.put)((0, $77qPV.resetRequest)());
        } catch  {
            yield (0, $aNOuE.put)((0, $77qPV.resetRequest)());
        }
    }
    function* $c56391e0603f160a$export$476de812fbbb6302({ name: name, versions: versions }, newVersionId, sequence) {
        yield* (0, $bYhSc.default)(function*() {
            yield (0, $aNOuE.call)($c56391e0603f160a$export$3b6da5955bae8c75, {
                id: newVersionId,
                name: name,
                versions: versions
            });
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            yield (0, $aNOuE.put)($bt366.update({
                id: newVersionId,
                values: {}
            }));
            yield (0, $aNOuE.put)((0, $77qPV.closeDialog)());
        });
    }
    function* $c56391e0603f160a$export$89ca6b91461e4dc({ payload: payload }) {
        yield (0, $aNOuE.put)((0, $77qPV.initiateRequest)());
        try {
            const url = (0, $fCn53.urls).add;
            const body = (0, $fCn53.addVersionBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), payload);
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const { itemKey: itemKey, change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
                yield (0, $aNOuE.call)($c56391e0603f160a$export$476de812fbbb6302, payload, itemKey, sequence);
            } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
                const error = new Error(response.text());
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'add-cross-project-versions-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
            yield (0, $aNOuE.put)((0, $77qPV.resetRequest)());
        } catch  {
            yield (0, $aNOuE.put)((0, $77qPV.resetRequest)());
        }
    }
    function* $c56391e0603f160a$export$ed51d7a10005fa33(crossProjectVersion, sequence) {
        yield* (0, $bYhSc.default)(function*() {
            if (crossProjectVersion.id.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $aNOuE.call)($c56391e0603f160a$export$4bbfd299114d60db, crossProjectVersion.id);
            else {
                yield (0, $aNOuE.put)($gFvn5.remove(crossProjectVersion.id));
                yield (0, $aNOuE.put)($fHpRV.add(crossProjectVersion));
                yield (0, $aNOuE.put)($bt366.update({
                    id: crossProjectVersion.id,
                    values: {}
                }));
            }
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            yield (0, $aNOuE.put)((0, $3rJDR.closeDialog)());
        });
    }
    function* $c56391e0603f160a$export$c7f0d1a6ee665364({ payload: payload }) {
        const { crossProjectVersion: crossProjectVersion, doesRemoveVersions: doesRemoveVersions } = payload;
        yield (0, $aNOuE.put)((0, $3rJDR.initiateRequest)());
        try {
            const url = (0, $fCn53.urls).delete;
            const body = (0, $fCn53.deleteVersionBody)((yield (0, $aNOuE.select)((0, $bHTqr.getPlan))), payload);
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const { change: { sequence: sequence } } = yield (0, $aNOuE.call)(response.json.bind(response));
                yield (0, $aNOuE.call)($c56391e0603f160a$export$ed51d7a10005fa33, crossProjectVersion, sequence);
                if (doesRemoveVersions) {
                    const { versions: versions } = crossProjectVersion;
                    for (const versionId of versions)if (versionId.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $aNOuE.call)($c56391e0603f160a$var$versionsCommands.updateStateAfterDeletingVersion, versionId, sequence);
                    else yield (0, $aNOuE.call)($c56391e0603f160a$var$versionsCommands.updateStateAfterRemovingVersion, versionId, sequence);
                }
            } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) {
                const error = new Error(response.text());
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'delete-cross-project-versions-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
            yield (0, $aNOuE.put)((0, $3rJDR.resetRequest)());
        } catch  {
            yield (0, $aNOuE.put)((0, $3rJDR.resetRequest)());
        }
    }
    function* $c56391e0603f160a$export$4653b8ba9e3d5d06({ payload: payload }) {
        const { versions: versions, patch: patch } = payload;
        yield (0, $aNOuE.put)((0, $jl9zM.initiateRequest)());
        for (const versionId of versions){
            const patchConfig = {
                versionId: versionId,
                patch: patch
            };
            yield (0, $aNOuE.put)($c56391e0603f160a$var$versionsCommands.updateRelease(patchConfig));
        }
        yield (0, $aNOuE.put)((0, $jl9zM.resetRequest)());
        yield (0, $aNOuE.put)((0, $jl9zM.closeDialog)());
    }
    function* $c56391e0603f160a$export$6305f6649b21cb82({ payload: payload }) {
        yield (0, $aNOuE.put)((0, $834it.clear)((0, $cGbfF.RELEASE_FILTER_ID)));
        yield (0, $aNOuE.put)((0, $834it.change)({
            id: (0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID),
            value: payload
        }));
    }
    function* $c56391e0603f160a$export$7636f00a67e1b930() {
        yield (0, $6u3NN.takeEvery)($c56391e0603f160a$export$2bdfac268df97e49, $c56391e0603f160a$export$89ca6b91461e4dc);
    }
    function* $c56391e0603f160a$export$919e3b6069d2417d() {
        yield (0, $6u3NN.takeEvery)($c56391e0603f160a$export$3f90e3abee6e8d70, $c56391e0603f160a$export$740de856a6989843);
    }
    function* $c56391e0603f160a$export$877c3b6cd35254fd() {
        yield (0, $6u3NN.takeEvery)($c56391e0603f160a$export$440c54a43c85f449, $c56391e0603f160a$export$c7f0d1a6ee665364);
    }
    function* $c56391e0603f160a$export$37dcd128d22a75be() {
        yield (0, $6u3NN.takeEvery)($c56391e0603f160a$export$4192fcdf48d80cf0, $c56391e0603f160a$export$4653b8ba9e3d5d06);
    }
    function* $c56391e0603f160a$export$20993805280f607e() {
        yield (0, $6u3NN.takeEvery)($c56391e0603f160a$export$a54e64fcc2f0026f, $c56391e0603f160a$export$6305f6649b21cb82);
    }
    function $c56391e0603f160a$export$2e2bcd8739ae039(versionCommandsModule) {
        $c56391e0603f160a$var$versionsCommands = versionCommandsModule;
        return function*() {
            yield (0, $aNOuE.fork)($c56391e0603f160a$export$7636f00a67e1b930);
            yield (0, $aNOuE.fork)($c56391e0603f160a$export$919e3b6069d2417d);
            yield (0, $aNOuE.fork)($c56391e0603f160a$export$877c3b6cd35254fd);
            yield (0, $aNOuE.fork)($c56391e0603f160a$export$37dcd128d22a75be);
            yield (0, $aNOuE.fork)($c56391e0603f160a$export$20993805280f607e);
        };
    }
});
parcelRegister("fHpRV", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$f1bbf56e0f17683c$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD", ()=>$f1bbf56e0f17683c$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "REMOVE", ()=>$f1bbf56e0f17683c$export$29d55e1f664a246b);
    $parcel$export(module.exports, "ADD_VERSION_IN_CROSS_PROJECT_VERSION", ()=>$f1bbf56e0f17683c$export$5bb382b7a9364fa0);
    $parcel$export(module.exports, "REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION", ()=>$f1bbf56e0f17683c$export$cfd29272fccd14f8);
    $parcel$export(module.exports, "reset", ()=>$f1bbf56e0f17683c$export$aad8462122ac592b);
    $parcel$export(module.exports, "add", ()=>$f1bbf56e0f17683c$export$e16d8520af44a096);
    $parcel$export(module.exports, "remove", ()=>$f1bbf56e0f17683c$export$cd7f480d6b8286c3);
    $parcel$export(module.exports, "addVersionInCrossProjectVersion", ()=>$f1bbf56e0f17683c$export$8e127e72248d08);
    $parcel$export(module.exports, "removeVersionFromCrossProjectVersion", ()=>$f1bbf56e0f17683c$export$ac89d6cd5251dbf4);
    const $f1bbf56e0f17683c$export$4a991c87e640ef77 = 'state.domain.removed-cross-project-versions.RESET';
    const $f1bbf56e0f17683c$export$bb6389024b71c2ae = 'state.domain.removed-cross-project-versions.ADD';
    const $f1bbf56e0f17683c$export$29d55e1f664a246b = 'state.domain.removed-cross-project-versions.REMOVE';
    const $f1bbf56e0f17683c$export$5bb382b7a9364fa0 = 'state.domain.removed-cross-project-versions.ADD_VERSION_IN_CROSS_PROJECT_VERSION';
    const $f1bbf56e0f17683c$export$cfd29272fccd14f8 = 'state.domain.removed-cross-project-versions.REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION';
    const $f1bbf56e0f17683c$export$aad8462122ac592b = (payload)=>({
            type: $f1bbf56e0f17683c$export$4a991c87e640ef77,
            payload: payload
        });
    const $f1bbf56e0f17683c$export$e16d8520af44a096 = (payload)=>({
            type: $f1bbf56e0f17683c$export$bb6389024b71c2ae,
            payload: payload
        });
    const $f1bbf56e0f17683c$export$cd7f480d6b8286c3 = (versionId)=>({
            type: $f1bbf56e0f17683c$export$29d55e1f664a246b,
            versionId: versionId
        });
    const $f1bbf56e0f17683c$export$8e127e72248d08 = (payload)=>({
            type: $f1bbf56e0f17683c$export$5bb382b7a9364fa0,
            payload: payload
        });
    const $f1bbf56e0f17683c$export$ac89d6cd5251dbf4 = (payload)=>({
            type: $f1bbf56e0f17683c$export$cfd29272fccd14f8,
            payload: payload
        });
});
parcelRegister("jl9zM", function(module, exports) {
    $parcel$export(module.exports, "OPEN_DIALOG", ()=>$65058344ec7bd80c$export$fb283a8049ce78e7);
    $parcel$export(module.exports, "CLOSE_DIALOG", ()=>$65058344ec7bd80c$export$194b247a9d6170da);
    $parcel$export(module.exports, "INITIATE_REQUEST", ()=>$65058344ec7bd80c$export$4580e708995fb75f);
    $parcel$export(module.exports, "RESET_REQUEST", ()=>$65058344ec7bd80c$export$31889003e5372a7f);
    $parcel$export(module.exports, "openDialog", ()=>$65058344ec7bd80c$export$45f11db5513b93db);
    $parcel$export(module.exports, "closeDialog", ()=>$65058344ec7bd80c$export$34bf1befb2fab61a);
    $parcel$export(module.exports, "initiateRequest", ()=>$65058344ec7bd80c$export$82f68a404cfea29);
    $parcel$export(module.exports, "resetRequest", ()=>$65058344ec7bd80c$export$b38f09eddeeb56fb);
    const $65058344ec7bd80c$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.releases.cross-project-releases.align-dates-dialog.SET_MODE';
    const $65058344ec7bd80c$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.cross-project-releases.align-dates-dialog.OPEN_DIALOG';
    const $65058344ec7bd80c$export$194b247a9d6170da = 'state.ui.main.tabs.releases.cross-project-releases.align-dates-dialog.CLOSE_DIALOG';
    const $65058344ec7bd80c$export$4580e708995fb75f = 'state.ui.main.tabs.releases.cross-project-releases.align-dates-dialog.INITIATE_REQUEST';
    const $65058344ec7bd80c$export$31889003e5372a7f = 'state.ui.main.tabs.releases.cross-project-releases.align-dates-dialog.RESET_REQUEST';
    const $65058344ec7bd80c$export$45f11db5513b93db = (versionId)=>({
            type: $65058344ec7bd80c$export$fb283a8049ce78e7,
            versionId: versionId
        });
    const $65058344ec7bd80c$export$34bf1befb2fab61a = ()=>({
            type: $65058344ec7bd80c$export$194b247a9d6170da
        });
    const $65058344ec7bd80c$export$82f68a404cfea29 = ()=>({
            type: $65058344ec7bd80c$export$4580e708995fb75f
        });
    const $65058344ec7bd80c$export$b38f09eddeeb56fb = ()=>({
            type: $65058344ec7bd80c$export$31889003e5372a7f
        });
});
parcelRegister("3rJDR", function(module, exports) {
    $parcel$export(module.exports, "OPEN_DIALOG", ()=>$ef998de2275e3ec6$export$fb283a8049ce78e7);
    $parcel$export(module.exports, "CLOSE_DIALOG", ()=>$ef998de2275e3ec6$export$194b247a9d6170da);
    $parcel$export(module.exports, "INITIATE_REQUEST", ()=>$ef998de2275e3ec6$export$4580e708995fb75f);
    $parcel$export(module.exports, "RESET_REQUEST", ()=>$ef998de2275e3ec6$export$31889003e5372a7f);
    $parcel$export(module.exports, "openDialog", ()=>$ef998de2275e3ec6$export$45f11db5513b93db);
    $parcel$export(module.exports, "closeDialog", ()=>$ef998de2275e3ec6$export$34bf1befb2fab61a);
    $parcel$export(module.exports, "initiateRequest", ()=>$ef998de2275e3ec6$export$82f68a404cfea29);
    $parcel$export(module.exports, "resetRequest", ()=>$ef998de2275e3ec6$export$b38f09eddeeb56fb);
    const $ef998de2275e3ec6$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.cross-project-releases.delete-release-dialog.OPEN_DIALOG';
    const $ef998de2275e3ec6$export$194b247a9d6170da = 'state.ui.main.tabs.releases.cross-project-releases.delete-release-dialog.CLOSE_DIALOG';
    const $ef998de2275e3ec6$export$4580e708995fb75f = 'state.ui.main.tabs.releases.cross-project-releases.delete-release-dialog.INITIATE_REQUEST';
    const $ef998de2275e3ec6$export$31889003e5372a7f = 'state.ui.main.tabs.releases.cross-project-releases.delete-release-dialog.RESET_REQUEST';
    const $ef998de2275e3ec6$export$45f11db5513b93db = (versionId)=>({
            type: $ef998de2275e3ec6$export$fb283a8049ce78e7,
            versionId: versionId
        });
    const $ef998de2275e3ec6$export$34bf1befb2fab61a = ()=>({
            type: $ef998de2275e3ec6$export$194b247a9d6170da
        });
    const $ef998de2275e3ec6$export$82f68a404cfea29 = ()=>({
            type: $ef998de2275e3ec6$export$4580e708995fb75f
        });
    const $ef998de2275e3ec6$export$b38f09eddeeb56fb = ()=>({
            type: $ef998de2275e3ec6$export$31889003e5372a7f
        });
});
parcelRegister("77qPV", function(module, exports) {
    $parcel$export(module.exports, "SET_MODE", ()=>$711adc50d557ae51$export$27a86d4a6fd7f204);
    $parcel$export(module.exports, "OPEN_DIALOG", ()=>$711adc50d557ae51$export$fb283a8049ce78e7);
    $parcel$export(module.exports, "CLOSE_DIALOG", ()=>$711adc50d557ae51$export$194b247a9d6170da);
    $parcel$export(module.exports, "INITIATE_REQUEST", ()=>$711adc50d557ae51$export$4580e708995fb75f);
    $parcel$export(module.exports, "RESET_REQUEST", ()=>$711adc50d557ae51$export$31889003e5372a7f);
    $parcel$export(module.exports, "setMode", ()=>$711adc50d557ae51$export$d4f039427a1beff1);
    $parcel$export(module.exports, "openDialog", ()=>$711adc50d557ae51$export$45f11db5513b93db);
    $parcel$export(module.exports, "closeDialog", ()=>$711adc50d557ae51$export$34bf1befb2fab61a);
    $parcel$export(module.exports, "initiateRequest", ()=>$711adc50d557ae51$export$82f68a404cfea29);
    $parcel$export(module.exports, "resetRequest", ()=>$711adc50d557ae51$export$b38f09eddeeb56fb);
    const $711adc50d557ae51$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.SET_MODE';
    const $711adc50d557ae51$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.OPEN_DIALOG';
    const $711adc50d557ae51$export$194b247a9d6170da = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.CLOSE_DIALOG';
    const $711adc50d557ae51$export$4580e708995fb75f = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.INITIATE_REQUEST';
    const $711adc50d557ae51$export$31889003e5372a7f = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.RESET_REQUEST';
    const $711adc50d557ae51$export$d4f039427a1beff1 = (payload)=>({
            type: $711adc50d557ae51$export$27a86d4a6fd7f204,
            payload: payload
        });
    const $711adc50d557ae51$export$45f11db5513b93db = (versionId = null)=>({
            type: $711adc50d557ae51$export$fb283a8049ce78e7,
            payload: {
                versionId: versionId
            }
        });
    const $711adc50d557ae51$export$34bf1befb2fab61a = ()=>({
            type: $711adc50d557ae51$export$194b247a9d6170da
        });
    const $711adc50d557ae51$export$82f68a404cfea29 = ()=>({
            type: $711adc50d557ae51$export$4580e708995fb75f
        });
    const $711adc50d557ae51$export$b38f09eddeeb56fb = ()=>({
            type: $711adc50d557ae51$export$31889003e5372a7f
        });
});
parcelRegister("fCn53", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$9fa8df74ebe06cf4$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "addVersionBody", ()=>$9fa8df74ebe06cf4$export$a19bf42e0b3d7082);
    $parcel$export(module.exports, "updateVersionBody", ()=>$9fa8df74ebe06cf4$export$80a1d0573753ab10);
    $parcel$export(module.exports, "deleteVersionBody", ()=>$9fa8df74ebe06cf4$export$4c6bb7db8f86d168);
    const $9fa8df74ebe06cf4$export$bcae9ba627f604b6 = {
        add: '/rest/jpo/1.0/xprojectversions/add',
        update: '/rest/jpo/1.0/xprojectversions/update',
        delete: '/rest/jpo/1.0/xprojectversions/delete',
        revertChanges: '/rest/jpo/1.0/xprojectversions/revert'
    };
    const $9fa8df74ebe06cf4$export$a19bf42e0b3d7082 = (plan, { name: name, versions: versions })=>{
        const { id: planId, currentScenarioId: scenarioId } = plan;
        return {
            planId: planId,
            scenarioId: scenarioId,
            description: {
                name: {
                    value: name
                }
            },
            versions: versions
        };
    };
    const $9fa8df74ebe06cf4$export$80a1d0573753ab10 = (plan, { versionId: versionId, patch: patch })=>{
        const { id: planId, currentScenarioId: scenarioId } = plan;
        return {
            planId: planId,
            scenarioId: scenarioId,
            itemKeys: [
                versionId
            ],
            description: {
                name: {
                    value: patch.name
                }
            }
        };
    };
    const $9fa8df74ebe06cf4$export$4c6bb7db8f86d168 = ({ id: planId, currentScenarioId: scenarioId }, { crossProjectVersion: crossProjectVersion, doesRemoveVersions: doesRemoveVersions })=>{
        const { id: versionId, versions: projectVersions } = crossProjectVersion;
        if (doesRemoveVersions) return {
            itemKeys: [
                versionId
            ],
            planId: planId,
            scenarioId: scenarioId,
            versionItemKeys: projectVersions
        };
        return {
            itemKeys: [
                versionId
            ],
            planId: planId,
            scenarioId: scenarioId
        };
    };
});
parcelRegister("9MFji", function(module, exports) {
    $parcel$export(module.exports, "OPEN_FLYOUT", ()=>$4d4454f3645e5986$export$aece46899d04da75);
    $parcel$export(module.exports, "CLOSE_FLYOUT", ()=>$4d4454f3645e5986$export$818850ad86c540b1);
    $parcel$export(module.exports, "openFlyout", ()=>$4d4454f3645e5986$export$a297e31c5d8808a1);
    $parcel$export(module.exports, "closeFlyout", ()=>$4d4454f3645e5986$export$7670f8956d89067d);
    const $4d4454f3645e5986$export$aece46899d04da75 = 'state.ui.main.tabs.releases.cross-project-releases.releases-table.project-releases.OPEN_FLYOUT';
    const $4d4454f3645e5986$export$818850ad86c540b1 = 'state.ui.main.tabs.releases.cross-project-releases.releases-table.project-releases.CLOSE_FLYOUT';
    const $4d4454f3645e5986$export$a297e31c5d8808a1 = (crossProjectVersionId)=>({
            type: $4d4454f3645e5986$export$aece46899d04da75,
            payload: {
                crossProjectVersionId: crossProjectVersionId
            }
        });
    const $4d4454f3645e5986$export$7670f8956d89067d = ()=>({
            type: $4d4454f3645e5986$export$818850ad86c540b1
        });
});
const $9f0e8f377b448222$export$afecb711a599950a = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.CREATE_RELEASE';
const $9f0e8f377b448222$export$b9385259cf8397cd = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.EDIT_RELEASE';
parcelRegister("aEqRm", function(module, exports) {
    $parcel$export(module.exports, "update", ()=>$a8dfe1fbd76b3fc7$export$722fbec263ad908a);
    $parcel$export(module.exports, "remove", ()=>$a8dfe1fbd76b3fc7$export$cd7f480d6b8286c3);
    $parcel$export(module.exports, "handlePlannedCapacityBulkCommitResponse", ()=>$a8dfe1fbd76b3fc7$export$8b600fda5e69f9a2);
    $parcel$export(module.exports, "revertPlannedCapacityChange", ()=>$a8dfe1fbd76b3fc7$export$980a5ed5057b9945);
    $parcel$export(module.exports, "default", ()=>$a8dfe1fbd76b3fc7$export$2e2bcd8739ae039);
    var $8MQZK;
    var $fes2p;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $4R6GH;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $bHTqr = parcelRequire("bHTqr");
    var $d3quy = parcelRequire("d3quy");
    var $25viM = parcelRequire("25viM");
    var $5bPxr = parcelRequire("5bPxr");
    var $7IEdi = parcelRequire("7IEdi");
    var $36p1o = parcelRequire("36p1o");
    var $ccCF0 = parcelRequire("ccCF0");
    var $77QEM = parcelRequire("77QEM");
    var $bYhSc = parcelRequire("bYhSc");
    var $hNEap = parcelRequire("hNEap");
    var $24CMK = parcelRequire("24CMK");
    var $asXbx = parcelRequire("asXbx");
    var $hvOzF = parcelRequire("hvOzF");
    var $hXq2A = parcelRequire("hXq2A");
    var $9KXuH = parcelRequire("9KXuH");
    const $a8dfe1fbd76b3fc7$export$e271b26eefe41db8 = 'command.planned-capacities.UPDATE';
    const $a8dfe1fbd76b3fc7$export$4a991c87e640ef77 = 'command.planned-capacities.RESET';
    const $a8dfe1fbd76b3fc7$export$29d55e1f664a246b = 'command.planned-capacities.REMOVE';
    const $a8dfe1fbd76b3fc7$export$aad8462122ac592b = (payload)=>({
            type: $a8dfe1fbd76b3fc7$export$4a991c87e640ef77,
            payload: payload
        });
    const $a8dfe1fbd76b3fc7$export$722fbec263ad908a = (payload)=>({
            type: $a8dfe1fbd76b3fc7$export$e271b26eefe41db8,
            payload: payload
        });
    const $a8dfe1fbd76b3fc7$export$cd7f480d6b8286c3 = (payload)=>({
            type: $a8dfe1fbd76b3fc7$export$29d55e1f664a246b,
            payload: payload
        });
    function* $a8dfe1fbd76b3fc7$export$4884fd84d9484e78(block, promise) {
        if (!promise || !promise?.resolve || !promise?.reject) return yield (0, $aNOuE.call)(block);
        try {
            const result = yield (0, $aNOuE.call)(block);
            promise.resolve(result);
        } catch (err) {
            promise.reject(err);
        }
    }
    function* $a8dfe1fbd76b3fc7$export$8b600fda5e69f9a2(entityResponse, plannedCapacityChange) {
        const capacitySelectorProps = (0, parcelRequire("fes2p")).default([
            'teamId',
            'iterationId'
        ], plannedCapacityChange.values);
        const currentPlannedCapacity = yield (0, $aNOuE.select)((0, $d3quy.getCapacityForTeamAndIteration), capacitySelectorProps);
        const wasRemoved = !currentPlannedCapacity;
        const id = entityResponse.itemKey;
        const newId = entityResponse.generatedId;
        const hasNewId = (0, $4nDwW.isDefined)(newId) && id !== newId;
        if (!wasRemoved && hasNewId) yield (0, $aNOuE.put)((0, $7IEdi.update)({
            ...plannedCapacityChange.values,
            itemKey: newId
        }));
        const { teamId: teamId, iterationId: iterationId } = plannedCapacityChange.values;
        const originals = yield (0, $aNOuE.select)((0, $d3quy.getOriginalPlannedCapacities));
        yield (0, $aNOuE.put)((0, $5bPxr.reset)((0, parcelRequire("8MQZK")).default([
            teamId,
            iterationId
        ], originals)));
    }
    function* $a8dfe1fbd76b3fc7$export$980a5ed5057b9945(plannedCapacityChange) {
        const { id: planId, currentScenarioId: currentScenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const sequence = yield (0, $aNOuE.select)((0, $25viM.getSequence));
        if (!(0, $4nDwW.isDefined)(plannedCapacityChange.values.itemKey)) return;
        if (!(0, $4nDwW.isDefined)(planId)) return;
        const body = (0, $hNEap.revertBody)({
            id: planId,
            currentScenarioId: currentScenarioId
        }, sequence, plannedCapacityChange.values.itemKey);
        const capacitySelectorProps = (0, parcelRequire("fes2p")).default([
            'teamId',
            'iterationId'
        ], plannedCapacityChange.values);
        const original = yield (0, $aNOuE.select)((0, $d3quy.getOriginalCapacityForTeamAndIteration), capacitySelectorProps);
        const { iterationId: iterationId } = plannedCapacityChange.values;
        const response = yield (0, $aNOuE.call)((0, $asXbx.jsonOrError), {
            url: (0, $hXq2A.urls).revertPlannedCapacity,
            method: (0, $77QEM.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = response.data;
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            if (original.capacity === null) {
                const removePayload = (0, parcelRequire("fes2p")).default([
                    'teamId',
                    'iterationId'
                ], plannedCapacityChange.values);
                yield (0, $aNOuE.put)((0, $7IEdi.remove)(removePayload));
            } else yield (0, $aNOuE.put)((0, $7IEdi.update)(original));
        } else yield (0, $aNOuE.put)((0, $ccCF0.add)({
            category: (0, $TTKUQ.ENTITY).PLANNED_CAPACITY,
            itemId: iterationId,
            warnings: [
                (0, $9KXuH.warning)
            ]
        }));
        return response;
    }
    const $a8dfe1fbd76b3fc7$export$6b79266acc025ac2 = (action)=>{
        const payload = {
            teamKey: {
                value: action.payload.teamId
            },
            iterationId: {
                value: parseInt(action.payload.iterationId, 10)
            },
            schedulingMode: {
                value: action.payload.schedulingMode
            },
            planningUnit: {
                value: action.payload.planningUnit
            },
            capacity: {
                value: action.payload.capacity
            }
        };
        return payload;
    };
    function* $a8dfe1fbd76b3fc7$export$5e3deeaaf3eca751(action) {
        const { id: planId, currentScenarioId: scenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        if (!(0, $4nDwW.isDefined)(planId)) return;
        const capacitySelectorProps = (0, parcelRequire("fes2p")).default([
            'teamId',
            'iterationId'
        ], action.payload);
        const original = yield (0, $aNOuE.select)((0, $d3quy.getOriginalCapacityForTeamAndIteration), capacitySelectorProps);
        const currentPlannedCapacity = yield (0, $aNOuE.select)((0, $d3quy.getCapacityForTeamAndIteration), capacitySelectorProps);
        const isAddingNewCapacity = !original && !currentPlannedCapacity;
        let originalUpdatePayload;
        if (!original) {
            if (currentPlannedCapacity) originalUpdatePayload = currentPlannedCapacity;
            else originalUpdatePayload = {
                ...action.payload,
                capacity: null
            };
            yield (0, $aNOuE.put)((0, $5bPxr.update)(originalUpdatePayload));
        } else originalUpdatePayload = original;
        const endpoint = isAddingNewCapacity ? (0, $hXq2A.urls).addPlannedCapacity : (0, $hXq2A.urls).updatePlannedCapacity;
        const { itemKey: itemKey } = isAddingNewCapacity ? {} : currentPlannedCapacity || original || {};
        yield (0, $aNOuE.put)((0, $7IEdi.update)({
            ...action.payload,
            itemKey: itemKey
        }));
        const response = yield (0, $aNOuE.call)((0, $asXbx.jsonOrError), {
            url: endpoint,
            method: (0, $77QEM.POST),
            body: {
                planId: planId,
                scenarioId: scenarioId,
                itemKey: itemKey,
                description: $a8dfe1fbd76b3fc7$export$6b79266acc025ac2(action)
            }
        });
        if (response.ok) {
            const { itemKey: itemKey, change: { sequence: sequence } } = response.data;
            yield* (0, $bYhSc.default)(function*() {
                yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
                if (isAddingNewCapacity) {
                    yield (0, $aNOuE.put)((0, $5bPxr.update)({
                        ...originalUpdatePayload,
                        itemKey: itemKey
                    }));
                    yield (0, $aNOuE.put)((0, $7IEdi.update)({
                        ...action.payload,
                        itemKey: itemKey
                    }));
                }
            });
            if (response.data) return response.data;
        } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
            const error = new Error(response.text());
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: (0, $hvOzF.toErrorID)(error, 'do-update-planned-capacity-fetch-failed'),
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        } else {
            const { error: error } = response.data;
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: error
            }));
        }
    }
    function* $a8dfe1fbd76b3fc7$export$d28ae27ab8b30e55(action) {
        const { payload: { promise: promise, ...payload }, type: type } = action;
        yield (0, $aNOuE.call)($a8dfe1fbd76b3fc7$export$4884fd84d9484e78, function*() {
            return yield (0, $aNOuE.call)($a8dfe1fbd76b3fc7$export$5e3deeaaf3eca751, {
                type: type,
                payload: payload
            });
        }, promise);
    }
    function* $a8dfe1fbd76b3fc7$export$2cdaaf942b1444db(action) {
        const { id: planId, currentScenarioId: scenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const capacitySelectorProps = (0, parcelRequire("fes2p")).default([
            'teamId',
            'iterationId'
        ], action.payload);
        const currentPlannedCapacity = yield (0, $aNOuE.select)((0, $d3quy.getCapacityForTeamAndIteration), capacitySelectorProps);
        const original = yield (0, $aNOuE.select)((0, $d3quy.getOriginalCapacityForTeamAndIteration), capacitySelectorProps);
        if (!(0, $4nDwW.isDefined)(planId)) return;
        if (!currentPlannedCapacity) return;
        if (!original) {
            const clone = yield (0, $aNOuE.select)((0, $d3quy.getCapacityForTeamAndIteration), capacitySelectorProps);
            if (clone) yield (0, $aNOuE.put)((0, $5bPxr.update)(clone));
        }
        yield (0, $aNOuE.put)((0, $7IEdi.remove)(capacitySelectorProps));
        if (original && original.capacity === null) yield (0, $aNOuE.put)((0, $5bPxr.remove)(capacitySelectorProps));
        const response = yield (0, $aNOuE.call)((0, $asXbx.jsonOrError), {
            url: (0, $hXq2A.urls).deletePlannedCapacity,
            method: (0, $77QEM.POST),
            body: {
                planId: planId,
                scenarioId: scenarioId,
                itemKeys: [
                    currentPlannedCapacity.itemKey
                ]
            }
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = response.data;
            yield (0, $aNOuE.put)((0, $36p1o.update)(sequence));
            if (response.data) return response.data;
        } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
            const error = new Error(response.text());
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: (0, $hvOzF.toErrorID)(error, 'do-remove-planned-capacity-fetch-failed'),
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        } else {
            const { error: error } = response.data;
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: error
            }));
        }
    }
    function* $a8dfe1fbd76b3fc7$export$7ff84668db579d28(action) {
        const { payload: { promise: promise, ...payload }, type: type } = action;
        yield (0, $aNOuE.call)($a8dfe1fbd76b3fc7$export$4884fd84d9484e78, function*() {
            return yield (0, $aNOuE.call)($a8dfe1fbd76b3fc7$export$2cdaaf942b1444db, {
                type: type,
                payload: payload
            });
        }, promise);
    }
    function* $a8dfe1fbd76b3fc7$export$95a8c56f6b8521b1() {
        yield (0, $6u3NN.takeEvery)($a8dfe1fbd76b3fc7$export$e271b26eefe41db8, $a8dfe1fbd76b3fc7$export$d28ae27ab8b30e55);
    }
    function* $a8dfe1fbd76b3fc7$export$ebb3588e2061e641() {
        yield (0, $6u3NN.takeEvery)($a8dfe1fbd76b3fc7$export$29d55e1f664a246b, $a8dfe1fbd76b3fc7$export$7ff84668db579d28);
    }
    function* $a8dfe1fbd76b3fc7$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($a8dfe1fbd76b3fc7$export$95a8c56f6b8521b1);
        yield (0, $aNOuE.fork)($a8dfe1fbd76b3fc7$export$ebb3588e2061e641);
    }
});
parcelRegister("hXq2A", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$c935bbc601ed7b83$export$bcae9ba627f604b6);
    const $c935bbc601ed7b83$export$bcae9ba627f604b6 = {
        addPlannedCapacity: '/rest/jpo/1.0/plannedcapacity/add',
        updatePlannedCapacity: '/rest/jpo/1.0/plannedcapacity/update',
        deletePlannedCapacity: '/rest/jpo/1.0/plannedcapacity/delete',
        revertPlannedCapacity: '/rest/jpo/1.0/plannedcapacity/revert'
    };
});
parcelRegister("9KXuH", function(module, exports) {
    $parcel$export(module.exports, "warning", ()=>$eabf6133d422f2de$export$491112666e282270);
    var $7VHMR;
    const $eabf6133d422f2de$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        defaultWarningHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.planned-capacities.default-warning-header",
            "defaultMessage": "Could not be committed for unknown reasons."
        },
        defaultWarningContent: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.planned-capacities.default-warning-content",
            "defaultMessage": "Sprint capacity could not be committed for unknown reasons. Please contact your administrator."
        }
    });
    const $eabf6133d422f2de$export$491112666e282270 = {
        header: $eabf6133d422f2de$var$messages.defaultWarningHeader,
        message: $eabf6133d422f2de$var$messages.defaultWarningContent,
        messageValues: {}
    };
    var $eabf6133d422f2de$export$2e2bcd8739ae039 = $eabf6133d422f2de$var$messages;
});
parcelRegister("47ZoL", function(module, exports) {
    $parcel$export(module.exports, "setNotifyWatchersPreference", ()=>$884ac8a617218843$export$d606e07e0273c036);
    $parcel$export(module.exports, "getNotifyWatchersPreference", ()=>$884ac8a617218843$export$3a214b30d45c783);
    var $cuHs1 = parcelRequire("cuHs1");
    var $5fACX = parcelRequire("5fACX");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $aHuqL;
    const $884ac8a617218843$export$d1b8c46158563cca = (issue)=>{
        const associateTargetDates = (_, key)=>{
            if (key === 'baselineStart') return 0, $5fACX.TARGET_START_FIELD;
            if (key === 'baselineEnd') return 0, $5fACX.TARGET_END_FIELD;
            return key;
        };
        return {
            ...issue,
            values: (0, ($parcel$interopDefault($cuHs1)))(issue.values, associateTargetDates),
            originals: (0, ($parcel$interopDefault($cuHs1)))(issue.originals, associateTargetDates)
        };
    };
    const $884ac8a617218843$export$d606e07e0273c036 = (preference)=>(0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, $TTKUQ.NOTIFY_WATCHERS_KEY), preference);
    const $884ac8a617218843$export$3a214b30d45c783 = async ()=>{
        const preference = await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).get((0, $TTKUQ.NOTIFY_WATCHERS_KEY));
        return typeof preference === 'boolean' ? preference : undefined;
    };
});
parcelRegister("1zNSi", function(module, exports) {
    $parcel$export(module.exports, "REMOVED_FROM_ACTIVE_SPRINT", ()=>$2f74aa858d5949b8$export$ca127c6dfeba9a68);
    $parcel$export(module.exports, "ADDED_TO_ACTIVE_SPRINT", ()=>$2f74aa858d5949b8$export$9f2d02783b5aa8ad);
    $parcel$export(module.exports, "getChangeWarning", ()=>$2f74aa858d5949b8$export$998fb70d79c8dba2);
    var $b82OD = parcelRequire("b82OD");
    const $2f74aa858d5949b8$export$ca127c6dfeba9a68 = 'state.updateJira.changesWarnings.REMOVED_FROM_ACTIVE_SPRINT';
    const $2f74aa858d5949b8$export$9f2d02783b5aa8ad = 'state.updateJira.changesWarnings.ADDED_TO_ACTIVE_SPRINT';
    const $2f74aa858d5949b8$export$998fb70d79c8dba2 = (error)=>{
        switch(error){
            case $2f74aa858d5949b8$export$ca127c6dfeba9a68:
                return [
                    {
                        header: (0, $b82OD.default).removedFromActiveSprintHeader,
                        message: (0, $b82OD.default).removedFromActiveSprintMessage,
                        messageValues: {}
                    }
                ];
            case $2f74aa858d5949b8$export$9f2d02783b5aa8ad:
                return [
                    {
                        header: (0, $b82OD.default).addedToActiveSprintHeader,
                        message: (0, $b82OD.default).addedToActiveSprintMessage,
                        messageValues: {}
                    }
                ];
            default:
                return [];
        }
    };
});
parcelRegister("b82OD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9eb79cff809f5490$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9eb79cff809f5490$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removedFromActiveSprintHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.update-jira.removed-from-active-sprint-header",
            "defaultMessage": "This issue has been removed from an active sprint"
        },
        removedFromActiveSprintMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.update-jira.removed-from-active-sprint-message",
            "defaultMessage": "Saving this change will remove the issue from the scope of a sprint that's in progress."
        },
        addedToActiveSprintHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.update-jira.added-to-active-sprint-header",
            "defaultMessage": "This issue will be added to an active sprint"
        },
        addedToActiveSprintMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.command.update-jira.added-to-active-sprint-message",
            "defaultMessage": "Saving this change will add the issue to a sprint that's already in progress."
        }
    });
});
parcelRegister("fy2pg", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$b60942e72297cfe8$export$bcae9ba627f604b6);
    const $b60942e72297cfe8$export$bcae9ba627f604b6 = {
        startOptimize: '/rest/jpo/1.0/scheduling',
        pollOptimize: '/rest/jpo/1.0/scheduling/poll',
        applyChange: '/rest/jpo/1.0/scheduling/commit',
        pollApplying: (id)=>`/rest/jpo/1.0/scheduling/commit/${id}`
    };
});
parcelRegister("hKdG0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$468ffe368ca378fd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $16T6Y;
    var $9yOBd;
    var $eCeGD;
    var $42CjB;
    var $fP37g;
    var $dC5iT;
    var $f5TWP;
    var $3bDjY;
    var $4R6GH;
    var $ousew;
    var $koVbs;
    var $3HwlS;
    var $aCpcO;
    var $gJZ5D;
    var $J8W7q;
    var $enoTt;
    var $4y9A5 = parcelRequire("4y9A5");
    var $4nDwW = parcelRequire("4nDwW");
    var $dCm1o;
    var $eymZF = parcelRequire("eymZF");
    var $5I8AK = parcelRequire("5I8AK");
    var $cA7TF = parcelRequire("cA7TF");
    function $468ffe368ca378fd$var$Optimize({ existingTeams: existingTeams, onOptimize: onOptimize, selectedIssueCount: selectedIssueCount, showSpinner: showSpinner }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isConfigureDialogOpen, setIsConfigureDialogOpen] = (0, $5uXOq.useState)(false);
        const ref = (0, $5uXOq.useRef)(null);
        const onWindowClick = (0, $5uXOq.useCallback)((e)=>{
            const node = e.target;
            if (!isConfigureDialogOpen || !(0, $4nDwW.isDefined)(ref.current) || node instanceof Element && ref.current.contains(node)) return;
            setIsConfigureDialogOpen(!isConfigureDialogOpen);
        }, [
            isConfigureDialogOpen
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, $4y9A5.getBody)().addEventListener('click', onWindowClick);
            return ()=>(0, $4y9A5.getBody)().removeEventListener('click', onWindowClick);
        }, [
            onWindowClick
        ]);
        const onClick = ()=>{
            setIsConfigureDialogOpen(!isConfigureDialogOpen);
        };
        const onPreviewResults = (_, analyticsEvent)=>{
            setIsConfigureDialogOpen(!isConfigureDialogOpen);
            onOptimize(analyticsEvent);
        };
        const getTooltipMessage = ()=>{
            if (existingTeams.length === 0) return formatMessage((0, $5I8AK.default).noTeamsAvailableTooltip);
            return formatMessage((0, $5I8AK.default).optimizeTooltip);
        };
        const isButtonDisabled = showSpinner || existingTeams.length === 0;
        const disabledTheme = (current, themeProps)=>({
                ...current(themeProps),
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    background: `var(--ds-background-disabled, ${(0, (0, parcelRequire("gJZ5D")).default).N20A})`,
                    color: `var(--ds-text-disabled, ${(0, (0, parcelRequire("gJZ5D")).default).N70})`,
                    cursor: 'not-allowed'
                }
            });
        const buttonIconAfter = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $cA7TF.optimizeButtonAfterIcons
        }, selectedIssueCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), null, selectedIssueCount), showSpinner && (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.spinner",
            className: $cA7TF.spinnerContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), null)));
        const buttonRef = (0, $5uXOq.useRef)(null);
        const handleKeyDownCapture = (e)=>{
            if (e.key === 'Escape') {
                setIsConfigureDialogOpen(false);
                setTimeout(()=>{
                    buttonRef.current?.focus();
                });
            }
        };
        const showIconAfter = selectedIssueCount > 0 || showSpinner;
        const getAutoscheduleButton = ()=>{
            if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                alignBlock: "center"
            }, showIconAfter ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                iconBefore: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fP37g"))))), {
                        color: "var(--ds-icon, #44546F)",
                        ...iconProps
                    }),
                "aria-label": formatMessage((0, $5I8AK.default).optimize),
                appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? 'default' : 'subtle',
                onClick: onClick,
                "aria-haspopup": "dialog",
                ref: buttonRef,
                isDisabled: isButtonDisabled,
                isSelected: isConfigureDialogOpen,
                "aria-expanded": isConfigureDialogOpen
            }, selectedIssueCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), null, selectedIssueCount), showSpinner && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                paddingInlineStart: "space.050",
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.spinner"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), null))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fP37g"))))), {
                        color: "var(--ds-icon, #44546F)",
                        ...iconProps
                    }),
                label: formatMessage((0, $5I8AK.default).optimize),
                appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? 'default' : 'subtle',
                onClick: onClick,
                "aria-haspopup": "dialog",
                ref: buttonRef,
                isDisabled: isButtonDisabled,
                isSelected: isConfigureDialogOpen,
                "aria-expanded": isConfigureDialogOpen
            })));
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.button"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $cA7TF.optimizeButtonIconOnly
            }, isButtonDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
                ...showIconAfter && {
                    iconAfter: buttonIconAfter
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fP37g"))))), {
                    label: "",
                    color: "currentColor"
                }),
                theme: disabledTheme,
                ref: buttonRef,
                "aria-expanded": isConfigureDialogOpen,
                "aria-label": formatMessage((0, $5I8AK.default).optimize)
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                ...showIconAfter && {
                    iconAfter: buttonIconAfter
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fP37g"))))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
                appearance: "subtle",
                isSelected: isConfigureDialogOpen,
                onClick: onClick,
                ref: buttonRef,
                "aria-expanded": isConfigureDialogOpen,
                ariaLabel: `${formatMessage((0, $5I8AK.default).optimize)} - ${getTooltipMessage()}`
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $cA7TF.optimizeButtonLabelOnly
            }, isButtonDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
                ...showIconAfter && {
                    iconAfter: buttonIconAfter
                },
                theme: disabledTheme,
                ref: buttonRef,
                "aria-expanded": isConfigureDialogOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $5I8AK.default).optimize)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                ...showIconAfter && {
                    iconAfter: buttonIconAfter
                },
                isSelected: isConfigureDialogOpen,
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fP37g"))))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
                ref: buttonRef,
                "aria-expanded": isConfigureDialogOpen,
                appearance: "subtle",
                onClick: onClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $5I8AK.default).optimize))));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            onKeyDownCapture: handleKeyDownCapture
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eymZF.default), {
                onPreviewResults: onPreviewResults
            })),
            isOpen: isConfigureDialogOpen,
            onClose: ()=>{
                setTimeout(()=>{
                    buttonRef.current?.focus();
                });
            },
            noPaddings: true,
            placement: "bottom-end",
            strategy: "absolute"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: getTooltipMessage(),
            position: "bottom"
        }, getAutoscheduleButton())));
    }
    var $468ffe368ca378fd$export$2e2bcd8739ae039 = $468ffe368ca378fd$var$Optimize;
});
parcelRegister("fP37g", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b84e09430e3d870a$var$_react = $b84e09430e3d870a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b84e09430e3d870a$var$_calendarPlus = $b84e09430e3d870a$var$_interopRequireDefault((parcelRequire("a8TPt")));
    var $b84e09430e3d870a$var$_schedule = $b84e09430e3d870a$var$_interopRequireDefault((parcelRequire("jLkwd")));
    function $b84e09430e3d870a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b84e09430e3d870a$var$CalendarPlusIcon = (props)=>$b84e09430e3d870a$var$_react.default.createElement($b84e09430e3d870a$var$_calendarPlus.default, Object.assign({
            LEGACY_fallbackIcon: $b84e09430e3d870a$var$_schedule.default
        }, props));
    $b84e09430e3d870a$var$CalendarPlusIcon.Name = 'CalendarPlusIconMigration';
    var $b84e09430e3d870a$var$_default = module.exports.default = $b84e09430e3d870a$var$CalendarPlusIcon;
});
parcelRegister("a8TPt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7625f5488f011efd$var$_react = $7625f5488f011efd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7625f5488f011efd$var$_UNSAFE_baseNew = $7625f5488f011efd$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $7625f5488f011efd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7625f5488f011efd$var$CalendarPlusIcon = (props)=>$7625f5488f011efd$var$_react.default.createElement($7625f5488f011efd$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h4.5m-5.75-7.5V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m3.5 5v.75m-9-5.75V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5M10 13h3m0 0h3m-3 0v-3m0 3v3"/>`
        }, props));
    $7625f5488f011efd$var$CalendarPlusIcon.displayName = 'CalendarPlusIcon';
    var $7625f5488f011efd$var$_default = module.exports.default = $7625f5488f011efd$var$CalendarPlusIcon;
});
parcelRegister("jLkwd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e63252aa89439377$var$_react = $e63252aa89439377$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $e63252aa89439377$var$_calendarPlus = $e63252aa89439377$var$_interopRequireDefault((parcelRequire("a8TPt")));
    function $e63252aa89439377$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e63252aa89439377$var$ScheduleIcon = (props)=>$e63252aa89439377$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M19 10.341V7.006A2 2 0 0 0 17.006 5H4.994A2 2 0 0 0 3 7.006v9.988A2 2 0 0 0 4.994 19h6.809a6 6 0 0 1-.72-2.001c-3.028 0-6.083-.002-6.083-.005C5 16.994 5 7 4.994 7 4.994 7 17 7 17 7.006V10c.701 0 1.374.12 2 .341"/><path d="M5 4v1h2V4a1 1 0 0 0-2 0m10 0v1h2V4a1 1 0 0 0-2 0M4 7h14v2H4zm14 8v-1.01a1 1 0 0 0-1-.99c-.56 0-1 .44-1 .99V15h-1.01a1 1 0 0 0-.99 1c0 .56.44 1 .99 1H16v1.01a1 1 0 0 0 1 .99c.56 0 1-.44 1-.99V17h1.01a1 1 0 0 0 .99-1c0-.56-.44-1-.99-1zm-1 6a5 5 0 1 1 0-10 5 5 0 0 1 0 10"/></g></svg>`
        }, props, {
            newIcon: $e63252aa89439377$var$_calendarPlus.default
        }));
    $e63252aa89439377$var$ScheduleIcon.displayName = 'ScheduleIcon';
    var $e63252aa89439377$var$_default = module.exports.default = $e63252aa89439377$var$ScheduleIcon;
});
parcelRegister("eymZF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2d83a6fbea12e5c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $lTypq = parcelRequire("lTypq");
    var $kAZad = parcelRequire("kAZad");
    var $9ZkY0 = parcelRequire("9ZkY0");
    var $c2d83a6fbea12e5c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $kAZad.default), (0, $lTypq.default))((0, $9ZkY0.default));
});
parcelRegister("lTypq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$091d7fc58203f3d9$export$2e2bcd8739ae039);
    var $atnIT = parcelRequire("atnIT");
    const $091d7fc58203f3d9$var$mapDispatchToProps = (dispatch)=>({
            updateAutoScheduleConfiguration: (payload)=>{
                dispatch((0, $atnIT.updatePlan)({
                    autoScheduleConfiguration: payload
                }));
            }
        });
    var $091d7fc58203f3d9$export$2e2bcd8739ae039 = $091d7fc58203f3d9$var$mapDispatchToProps;
});
parcelRegister("kAZad", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2f918ba40de869f$export$2e2bcd8739ae039);
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    var $e2f918ba40de869f$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        autoScheduleConfiguration: (0, $bHTqr.getAutoScheduleConfiguration),
        selectedIssuesCount: (state)=>(0, $bI9dZ.getSelectedIssues)(state).length
    });
});
parcelRegister("9ZkY0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$11f31b5691d6de5b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $jouoW;
    var $5Zxxp;
    var $ousew;
    var $aCpcO;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $4cwkM = parcelRequire("4cwkM");
    var $ihPUd = parcelRequire("ihPUd");
    var $an9Wx = parcelRequire("an9Wx");
    var $ePSqJ = parcelRequire("ePSqJ");
    const $11f31b5691d6de5b$var$OVERWRITE_OPTIONS = [
        {
            value: (0, $TTKUQ.AUTO_SCHEDULE_OVERWRITE).ALL_VALUES,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $an9Wx.default).overwriteAllValues)
        },
        {
            value: (0, $TTKUQ.AUTO_SCHEDULE_OVERWRITE).EMPTY_VALUES_ONLY,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $an9Wx.default).overwriteEmptyValuesOnly)
        }
    ];
    const $11f31b5691d6de5b$var$OVERWRITE_ISSUE_VALUES = [
        {
            value: (0, $TTKUQ.ISSUE_VALUES).SPRINT,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).sprints)
        },
        {
            value: (0, $TTKUQ.ISSUE_VALUES).RELEASE,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).releases)
        },
        {
            value: (0, $TTKUQ.ISSUE_VALUES).TEAM,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).teams)
        }
    ];
    const $11f31b5691d6de5b$var$API_KEYS_FOR_OVERWRITE_ISSUE_VALUES = {
        [(0, $TTKUQ.ISSUE_VALUES).SPRINT]: 'ignoreSprints',
        [(0, $TTKUQ.ISSUE_VALUES).RELEASE]: 'ignoreReleases',
        [(0, $TTKUQ.ISSUE_VALUES).TEAM]: 'ignoreTeams'
    };
    class $11f31b5691d6de5b$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { onPreviewResults: onPreviewResults, selectedIssuesCount: selectedIssuesCount } = this.props;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.container
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.topDescription
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.descriptionParagraph
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $an9Wx.default).selectiveSchedulingDescriptionParagraphOne)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.descriptionParagraph
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $an9Wx.default).selectiveSchedulingDescriptionParagraphTwo)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.descriptionParagraph
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Zxxp")).default), {
                articleId: (0, $TTKUQ.IPH_IDS).AUTO_SCHEDULE,
                fallbackComponent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cwkM.default), {
                    href: (0, $4cwkM.default).URLs.schedulingWork
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $an9Wx.default).iphLink)),
                appearance: "link",
                spacing: "none"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $an9Wx.default).iphLink))), selectedIssuesCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.selectedIssueCount
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $an9Wx.default).selectiveSchedulingSelectedIssues,
                values: {
                    count: selectedIssuesCount
                }
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.configurationSection
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.overwriteTitle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                size: "xsmall",
                as: "h2",
                id: "overwrite-issue-values-title"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $an9Wx.default).overwriteTitle))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                id: "overwrite-issue-values-desc",
                className: `${$ePSqJ.textSizeH200} ${$ePSqJ.overwriteDescription}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $an9Wx.default).overwriteDescription)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                role: "grid",
                "aria-labelledby": "overwrite-issue-values-title",
                "aria-describedby": "overwrite-issue-values-desc",
                "aria-busy": "true"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                role: "rowgroup"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                role: "row",
                className: $ePSqJ.configurationTableHeader
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.optionsHeader
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.issueValuesHeader
            }, $11f31b5691d6de5b$var$OVERWRITE_ISSUE_VALUES.map(({ label: label, value: value }, colIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    id: `column-${colIndex}`,
                    role: "columnheader",
                    key: value,
                    className: $ePSqJ.textSizeH200
                }, label))))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                role: "rowgroup",
                className: $ePSqJ.configurationTableContent
            }, $11f31b5691d6de5b$var$OVERWRITE_OPTIONS.map(({ label: label, value: optionValue }, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    role: "row",
                    key: optionValue,
                    className: $ePSqJ.configurationOptionRow
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    id: `row-${rowIndex}`,
                    role: "rowheader",
                    className: `${$ePSqJ.optionsContent} ${$ePSqJ.textSizeH200}`
                }, label), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $ePSqJ.issueValueSelection
                }, $11f31b5691d6de5b$var$OVERWRITE_ISSUE_VALUES.map(({ value: issueValue }, colIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        role: "gridcell",
                        key: issueValue
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                        isChecked: this.isOptionSelected(issueValue, optionValue),
                        "aria-labelledby": `column-${colIndex} row-${rowIndex}`,
                        name: issueValue,
                        value: optionValue,
                        onChange: ()=>this.onConfigurationChange(issueValue, optionValue)
                    }))))))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ePSqJ.actionFooter
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.preview-results",
                appearance: "primary",
                onClick: onPreviewResults
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $an9Wx.default).previewResults)))))));
        }
        constructor(...args){
            super(...args);
            this.isOptionSelected = (issueValue, overwriteOption)=>{
                const { autoScheduleConfiguration: autoScheduleConfiguration } = this.props;
                const apiKey = $11f31b5691d6de5b$var$API_KEYS_FOR_OVERWRITE_ISSUE_VALUES[issueValue];
                return (0, $4nDwW.isDefined)(autoScheduleConfiguration) && (autoScheduleConfiguration[apiKey] === true && overwriteOption === (0, $TTKUQ.AUTO_SCHEDULE_OVERWRITE).ALL_VALUES || autoScheduleConfiguration[apiKey] === false && overwriteOption === (0, $TTKUQ.AUTO_SCHEDULE_OVERWRITE).EMPTY_VALUES_ONLY);
            };
            this.onConfigurationChange = (issueValue, overwriteOption)=>{
                this.props.updateAutoScheduleConfiguration({
                    [$11f31b5691d6de5b$var$API_KEYS_FOR_OVERWRITE_ISSUE_VALUES[issueValue]]: overwriteOption === (0, $TTKUQ.AUTO_SCHEDULE_OVERWRITE).ALL_VALUES
                });
            };
        }
    }
});
parcelRegister("5Zxxp", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanelLink", ()=>$b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
    $parcel$export(module.exports, "default", ()=>$b0d1b3c2fea05784$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bHDKL;
    var $e4yMr;
    var $jpY8v;
    var $4R6GH;
    var $6BNJk;
    var $kspz4;
    var $hsmeR;
    const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const [, { setNavigationData: setNavigationData }] = (0, (0, parcelRequire("kspz4")).useHelpPanelActions)();
        const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
            openRightSidebar((0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID), (0, (0, parcelRequire("6BNJk")).HELP_PANEL_WIDTH), false, true);
            if (resetHistory) setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                },
                history: []
            });
            else setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                }
            });
        };
        return !(0, (0, parcelRequire("jpY8v")).isIE11)() ? handleOnClick : undefined;
    };
    const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, href: href, ...props })=>{
        const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
        const handleOnClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) event.preventDefault();
            onClick?.(event, analyticsEvent);
            onOpenInProductHelpArticle?.(articleId, (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]);
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) return onOpenInProductHelpArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            ...props,
            onClick: handleOnClick,
            href: href ?? 'https://support.atlassian.com',
            appearance: "default",
            testId: props.testId
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
        return onOpenInProductHelpArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            onClick: handleOnClick,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
            ])
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
    };
    var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
    const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
});
parcelRegister("an9Wx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d65cf8fb218d9dc9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d65cf8fb218d9dc9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        selectiveSchedulingDescriptionParagraphOne: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.selective-scheduling-description-paragraph-one",
            "defaultMessage": "Select which estimated issues you want to auto-schedule using the checkboxes in the Scope section of your plan."
        },
        selectiveSchedulingDescriptionParagraphTwo: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.selective-scheduling-description-paragraph-two",
            "defaultMessage": "If you select none, the auto-scheduler will create a plan for all of your estimated issues based on their ranking, the velocity of teams in your plan, and any dependencies you set."
        },
        iphLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.iph-link",
            "defaultMessage": "See what the auto-scheduler does"
        },
        selectiveSchedulingSelectedIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.selective-scheduling-selected-issues",
            "defaultMessage": "{count, plural, one {# issue} other {# issues}} selected"
        },
        overwriteTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.overwrite-title",
            "defaultMessage": "Overwriting issue values"
        },
        overwriteDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.overwrite-description",
            "defaultMessage": "You can choose to overwrite fields that have existing values, or to set values only if the fields are empty."
        },
        overwriteAllValues: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.overwrite-all-values",
            "defaultMessage": "All values"
        },
        overwriteEmptyValuesOnly: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.overwrite-empty-values-only",
            "defaultMessage": "Empty values only"
        },
        previewResults: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.preview-results",
            "defaultMessage": "Preview results"
        }
    });
});
parcelRegister("ePSqJ", function(module, exports) {
    $parcel$export(module.exports, "actionFooter", ()=>$acd00cc9219c1165$export$c4cc592d9243d26f, (v)=>$acd00cc9219c1165$export$c4cc592d9243d26f = v);
    $parcel$export(module.exports, "configurationOptionRow", ()=>$acd00cc9219c1165$export$32cce1bfe9972049, (v)=>$acd00cc9219c1165$export$32cce1bfe9972049 = v);
    $parcel$export(module.exports, "configurationSection", ()=>$acd00cc9219c1165$export$2f6b858d2dafa41f, (v)=>$acd00cc9219c1165$export$2f6b858d2dafa41f = v);
    $parcel$export(module.exports, "configurationTableContent", ()=>$acd00cc9219c1165$export$a1e1ff5fd61ffaa6, (v)=>$acd00cc9219c1165$export$a1e1ff5fd61ffaa6 = v);
    $parcel$export(module.exports, "configurationTableHeader", ()=>$acd00cc9219c1165$export$5eb22442b30132f0, (v)=>$acd00cc9219c1165$export$5eb22442b30132f0 = v);
    $parcel$export(module.exports, "container", ()=>$acd00cc9219c1165$export$34e0f9847d4c02dd, (v)=>$acd00cc9219c1165$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "descriptionParagraph", ()=>$acd00cc9219c1165$export$1f4ab7e80c81cd5a, (v)=>$acd00cc9219c1165$export$1f4ab7e80c81cd5a = v);
    $parcel$export(module.exports, "issueValueSelection", ()=>$acd00cc9219c1165$export$f7a502964befde9d, (v)=>$acd00cc9219c1165$export$f7a502964befde9d = v);
    $parcel$export(module.exports, "issueValuesHeader", ()=>$acd00cc9219c1165$export$58488719ec949635, (v)=>$acd00cc9219c1165$export$58488719ec949635 = v);
    $parcel$export(module.exports, "optionsContent", ()=>$acd00cc9219c1165$export$cdad7d6f330222f7, (v)=>$acd00cc9219c1165$export$cdad7d6f330222f7 = v);
    $parcel$export(module.exports, "optionsHeader", ()=>$acd00cc9219c1165$export$e13f53816edc1a22, (v)=>$acd00cc9219c1165$export$e13f53816edc1a22 = v);
    $parcel$export(module.exports, "overwriteDescription", ()=>$acd00cc9219c1165$export$1b7365b65607ab6, (v)=>$acd00cc9219c1165$export$1b7365b65607ab6 = v);
    $parcel$export(module.exports, "overwriteTitle", ()=>$acd00cc9219c1165$export$3cd49a6a901c298c, (v)=>$acd00cc9219c1165$export$3cd49a6a901c298c = v);
    $parcel$export(module.exports, "selectedIssueCount", ()=>$acd00cc9219c1165$export$4c800cfa9cf69f7, (v)=>$acd00cc9219c1165$export$4c800cfa9cf69f7 = v);
    $parcel$export(module.exports, "textSizeH200", ()=>$acd00cc9219c1165$export$5ac20e88bf8a38cb, (v)=>$acd00cc9219c1165$export$5ac20e88bf8a38cb = v);
    $parcel$export(module.exports, "topDescription", ()=>$acd00cc9219c1165$export$8b2bc455bfb5f6da, (v)=>$acd00cc9219c1165$export$8b2bc455bfb5f6da = v);
    var $acd00cc9219c1165$export$c4cc592d9243d26f;
    var $acd00cc9219c1165$export$32cce1bfe9972049;
    var $acd00cc9219c1165$export$2f6b858d2dafa41f;
    var $acd00cc9219c1165$export$a1e1ff5fd61ffaa6;
    var $acd00cc9219c1165$export$5eb22442b30132f0;
    var $acd00cc9219c1165$export$34e0f9847d4c02dd;
    var $acd00cc9219c1165$export$1f4ab7e80c81cd5a;
    var $acd00cc9219c1165$export$f7a502964befde9d;
    var $acd00cc9219c1165$export$58488719ec949635;
    var $acd00cc9219c1165$export$cdad7d6f330222f7;
    var $acd00cc9219c1165$export$e13f53816edc1a22;
    var $acd00cc9219c1165$export$1b7365b65607ab6;
    var $acd00cc9219c1165$export$3cd49a6a901c298c;
    var $acd00cc9219c1165$export$4c800cfa9cf69f7;
    var $acd00cc9219c1165$export$5ac20e88bf8a38cb;
    var $acd00cc9219c1165$export$8b2bc455bfb5f6da;
    $acd00cc9219c1165$export$c4cc592d9243d26f = `q0XS9W_actionFooter`;
    $acd00cc9219c1165$export$32cce1bfe9972049 = `q0XS9W_configurationOptionRow`;
    $acd00cc9219c1165$export$2f6b858d2dafa41f = `q0XS9W_configurationSection`;
    $acd00cc9219c1165$export$a1e1ff5fd61ffaa6 = `q0XS9W_configurationTableContent`;
    $acd00cc9219c1165$export$5eb22442b30132f0 = `q0XS9W_configurationTableHeader`;
    $acd00cc9219c1165$export$34e0f9847d4c02dd = `q0XS9W_container`;
    $acd00cc9219c1165$export$1f4ab7e80c81cd5a = `q0XS9W_descriptionParagraph`;
    $acd00cc9219c1165$export$f7a502964befde9d = `q0XS9W_issueValueSelection`;
    $acd00cc9219c1165$export$58488719ec949635 = `q0XS9W_issueValuesHeader`;
    $acd00cc9219c1165$export$cdad7d6f330222f7 = `q0XS9W_optionsContent`;
    $acd00cc9219c1165$export$e13f53816edc1a22 = `q0XS9W_optionsHeader`;
    $acd00cc9219c1165$export$1b7365b65607ab6 = `q0XS9W_overwriteDescription`;
    $acd00cc9219c1165$export$3cd49a6a901c298c = `q0XS9W_overwriteTitle`;
    $acd00cc9219c1165$export$4c800cfa9cf69f7 = `q0XS9W_selectedIssueCount`;
    $acd00cc9219c1165$export$5ac20e88bf8a38cb = `q0XS9W_textSizeH200`;
    $acd00cc9219c1165$export$8b2bc455bfb5f6da = `q0XS9W_topDescription`;
});
parcelRegister("5I8AK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81114a4da2fd1806$export$2e2bcd8739ae039);
    var $7VHMR;
    var $81114a4da2fd1806$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        optimize: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.optimize",
            "defaultMessage": "Auto-schedule"
        },
        optimizeTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.optimize-tooltip",
            "defaultMessage": "Schedule work based on estimates"
        },
        noTeamsAvailableTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.no-teams-available-tooltip",
            "defaultMessage": "Add a team to your plan to auto-schedule issues"
        }
    });
});
parcelRegister("cA7TF", function(module, exports) {
    $parcel$export(module.exports, "optimizeButtonAfterIcons", ()=>$928ef8fec761bcc9$export$e48a95239c5524fa, (v)=>$928ef8fec761bcc9$export$e48a95239c5524fa = v);
    $parcel$export(module.exports, "optimizeButtonIconOnly", ()=>$928ef8fec761bcc9$export$15f0da71eb6e87f0, (v)=>$928ef8fec761bcc9$export$15f0da71eb6e87f0 = v);
    $parcel$export(module.exports, "optimizeButtonLabelOnly", ()=>$928ef8fec761bcc9$export$2a6a8de8f55597e9, (v)=>$928ef8fec761bcc9$export$2a6a8de8f55597e9 = v);
    $parcel$export(module.exports, "spinnerContainer", ()=>$928ef8fec761bcc9$export$140fd7bd1291a3e4, (v)=>$928ef8fec761bcc9$export$140fd7bd1291a3e4 = v);
    var $928ef8fec761bcc9$export$e48a95239c5524fa;
    var $928ef8fec761bcc9$export$15f0da71eb6e87f0;
    var $928ef8fec761bcc9$export$2a6a8de8f55597e9;
    var $928ef8fec761bcc9$export$140fd7bd1291a3e4;
    $928ef8fec761bcc9$export$e48a95239c5524fa = `viPLjG_optimizeButtonAfterIcons`;
    $928ef8fec761bcc9$export$15f0da71eb6e87f0 = `viPLjG_optimizeButtonIconOnly`;
    $928ef8fec761bcc9$export$2a6a8de8f55597e9 = `viPLjG_optimizeButtonLabelOnly`;
    $928ef8fec761bcc9$export$140fd7bd1291a3e4 = `viPLjG_spinnerContainer`;
});
parcelRegister("Zf4mw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3641ec08a0ddbc66$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $bC2fB;
    var $9mKeD = parcelRequire("9mKeD");
    var $atjqR = parcelRequire("atjqR");
    const $3641ec08a0ddbc66$var$mapDispatchToProps = (dispatch)=>({
            clearAllFilters: ()=>{
                dispatch((0, $834it.clearAll)());
            }
        });
    var $3641ec08a0ddbc66$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $9mKeD.default), $3641ec08a0ddbc66$var$mapDispatchToProps)((0, $atjqR.default));
});
parcelRegister("9mKeD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e4e0fe7665533d1$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $eOe9K = parcelRequire("eOe9K");
    var $iIikD = parcelRequire("iIikD");
    var $jpgxP = parcelRequire("jpgxP");
    var $3YtPS = parcelRequire("3YtPS");
    var $1e4e0fe7665533d1$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        customFieldsWithFilteringAllowed: (0, $eOe9K.getCustomFieldsWithFilteringAllowed),
        filtersAppliedCount: (0, $iIikD.getFilterCount),
        isAtlasConnectInstalled: $jpgxP.isAtlasConnectInstalled,
        isEmbedMode: (0, $1CGdp.isEmbed),
        isConfluenceMacroMode: (0, $1CGdp.isConfluenceMacro)
    });
});
parcelRegister("atjqR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aac4476e729218f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $16T6Y;
    var $bTqXB;
    var $hORKG;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $co1wz;
    var $4R6GH;
    var $ousew;
    var $7mPT9;
    var $3HwlS;
    var $9L6Zg;
    var $aCpcO;
    var $cGbfF = parcelRequire("cGbfF");
    var $84qTJ = parcelRequire("84qTJ");
    var $dCm1o;
    var $dkdSe = parcelRequire("dkdSe");
    var $gaqty = parcelRequire("gaqty");
    var $5RQ6f = parcelRequire("5RQ6f");
    var $eLNbt = parcelRequire("eLNbt");
    var $cjRl2 = parcelRequire("cjRl2");
    var $8BWE6 = parcelRequire("8BWE6");
    var $1oRGd = parcelRequire("1oRGd");
    var $gGJs5 = parcelRequire("gGJs5");
    var $jHgLR = parcelRequire("jHgLR");
    var $6n5IZ = parcelRequire("6n5IZ");
    var $4JCNT = parcelRequire("4JCNT");
    var $fHkGj = parcelRequire("fHkGj");
    var $lvX0J = parcelRequire("lvX0J");
    var $darOt = parcelRequire("darOt");
    var $iwDde = parcelRequire("iwDde");
    var $fRUVe = parcelRequire("fRUVe");
    var $lT095 = parcelRequire("lT095");
    var $18IeQ = parcelRequire("18IeQ");
    var $lmROZ = parcelRequire("lmROZ");
    var $a7CKR = parcelRequire("a7CKR");
    var $7vVVB = parcelRequire("7vVVB");
    var $2Oi0P = parcelRequire("2Oi0P");
    var $eiEJ0 = parcelRequire("eiEJ0");
    class $aac4476e729218f6$var$FilterBar extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                AssigneeFilter: (0, $8BWE6.default)((0, $dkdSe.default)),
                ComponentFilter: (0, $8BWE6.default)((0, $gaqty.default)),
                CustomFieldFilter: (0, $8BWE6.default)((0, $5RQ6f.default)),
                DependenciesFilter: (0, $8BWE6.default)((0, $cjRl2.default)),
                HierarchyFilter: $gGJs5.default,
                IssueTypesKeyFilter: (0, $8BWE6.default)((0, $4JCNT.default)),
                IssuePrioritiesFilter: (0, $8BWE6.default)((0, $6n5IZ.default)),
                LabelFilter: (0, $8BWE6.default)((0, $lvX0J.default)),
                ProjectFilter: (0, $8BWE6.default)((0, $fRUVe.default)),
                ReleaseFilter: (0, $8BWE6.default)((0, $lT095.default)),
                SprintFilter: (0, $8BWE6.default)((0, $lmROZ.default)),
                StatusKeyFilter: (0, $8BWE6.default)((0, $a7CKR.default)),
                SummaryFilter: $2Oi0P.default,
                TeamFilter: (0, $8BWE6.default)((0, $eiEJ0.default)),
                ReporterFilter: (0, $8BWE6.default)((0, $18IeQ.default)),
                GoalFilter: (0, $8BWE6.default)((0, $1oRGd.default)),
                IdeaFilter: (0, $8BWE6.default)((0, $jHgLR.default)),
                DateRangeFilter: $eLNbt.default,
                IssueWarningFilter: (0, $8BWE6.default)((0, $fHkGj.default)),
                Options: $iwDde.default
            };
        }
        render() {
            return this.renderFilters();
        }
        constructor(...args){
            super(...args);
            this.state = {
                inlineDialogContentEl: null,
                isMenuOpen: false,
                isOpen: !!this.props.isDefaultOpenMenu
            };
            this.buttonRef = (0, $5uXOq.createRef)();
            this.onFiltersRender = (el)=>{
                if (this.state.inlineDialogContentEl) return;
                this.setState(()=>({
                        inlineDialogContentEl: el
                    }));
            };
            this.onClose = ()=>{
                this.setState({
                    isOpen: false
                }, ()=>{
                    !this.state.isOpen && this.buttonRef.current?.focus();
                });
            };
            this.toggleOpen = ()=>{
                const { isOpen: isOpen, inlineDialogContentEl: inlineDialogContentEl } = this.state;
                this.setState({
                    isOpen: !isOpen,
                    inlineDialogContentEl: isOpen ? inlineDialogContentEl : null
                }, ()=>{
                    !this.state.isOpen && this.buttonRef.current?.focus();
                });
            };
            this.renderTriggerButton = (triggerProps)=>{
                const { filtersAppliedCount: filtersAppliedCount } = this.props;
                const { ref: ref, ...restTriggerProps } = triggerProps || {
                    ref: null
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    iconAfter: filtersAppliedCount > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
                        appearance: "primary"
                    }, filtersAppliedCount) : (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))), {
                        label: "",
                        color: "currentColor"
                    }) || undefined,
                    ...restTriggerProps,
                    ref: (0, (0, parcelRequire("7mPT9")).mergeRefs)(this.buttonRef, ref),
                    "aria-expanded": this.state.isOpen,
                    iconBefore: !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bTqXB"))))), {
                        label: ""
                    }) : undefined,
                    isSelected: this.state.isOpen,
                    onClick: this.toggleOpen,
                    testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.button"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, $darOt.default).header : (0, $darOt.default).headerOld));
            };
            this.renderStandardFieldsFilters = (setInitialFocusRef)=>{
                const { AssigneeFilter: AssigneeFilter, ReporterFilter: ReporterFilter, ComponentFilter: ComponentFilter, DependenciesFilter: DependenciesFilter, IssueTypesKeyFilter: IssueTypesKeyFilter, IssuePrioritiesFilter: IssuePrioritiesFilter, LabelFilter: LabelFilter, ProjectFilter: ProjectFilter, ReleaseFilter: ReleaseFilter, SprintFilter: SprintFilter, StatusKeyFilter: StatusKeyFilter, SummaryFilter: SummaryFilter, HierarchyFilter: HierarchyFilter, TeamFilter: TeamFilter, GoalFilter: GoalFilter, IdeaFilter: IdeaFilter, DateRangeFilter: DateRangeFilter, IssueWarningFilter: IssueWarningFilter, isAtlasConnectInstalled: isAtlasConnectInstalled } = this.props;
                const { inlineDialogContentEl: inlineDialogContentEl } = this.state;
                const isEmbedOrMacro = this.props.isEmbedMode || this.props.isConfluenceMacroMode;
                const filters = [
                    {
                        filter: HierarchyFilter && (0, ($parcel$interopDefault($5uXOq))).createElement(HierarchyFilter, null),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.HIERARCHY_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(SummaryFilter, {
                            inputRef: setInitialFocusRef
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.SUMMARY_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(ReleaseFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.RELEASE_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(TeamFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.TEAM_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(AssigneeFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.ASSIGNEE_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(SprintFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.SPRINT_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(ProjectFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.PROJECT_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(IssuePrioritiesFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID])
                    },
                    {
                        filter: IssueTypesKeyFilter && (0, ($parcel$interopDefault($5uXOq))).createElement(IssueTypesKeyFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.COMPONENT_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(LabelFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.LABEL_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(DependenciesFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.DEPENDENCIES_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(ReporterFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.REPORTER_FILTER_ID])
                    },
                    {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(StatusKeyFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.STATUS_KEY_FILTER_ID])
                    }
                ];
                const goalsFilterIndex = 7;
                if (isAtlasConnectInstalled) filters.splice(goalsFilterIndex, 0, {
                    filter: (0, ($parcel$interopDefault($5uXOq))).createElement(GoalFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.GOAL_FILTER_ID])
                });
                if ((0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') && !isEmbedOrMacro) {
                    const ideasFilterIndex = isAtlasConnectInstalled ? goalsFilterIndex + 1 : goalsFilterIndex;
                    filters.splice(ideasFilterIndex, 0, {
                        filter: (0, ($parcel$interopDefault($5uXOq))).createElement(IdeaFilter, {
                            parentScrollContainer: inlineDialogContentEl
                        }),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.IDEA_FILTER_ID])
                    });
                }
                filters.push({
                    filter: IssueWarningFilter && (0, ($parcel$interopDefault($5uXOq))).createElement(IssueWarningFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.ISSUE_WARNING_FILTER_ID])
                });
                filters.push({
                    filter: DateRangeFilter && (0, ($parcel$interopDefault($5uXOq))).createElement(DateRangeFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default)[0, $cGbfF.DATE_RANGE_FILTER_ID])
                });
                return filters.map(({ filter: filter, label: label }, index)=>filter && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        key: index,
                        className: $7vVVB.filterRow
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: (0, ($parcel$interopDefault($9ci4W)))($7vVVB.filterRowLabel, {
                            [$7vVVB.hierarchyFilterLabel]: index === 0
                        })
                    }, label), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $7vVVB.filterRowFilter
                    }, filter)));
            };
            this.renderFilters = ()=>{
                const { clearAllFilters: clearAllFilters, filtersAppliedCount: filtersAppliedCount, Options: Options, intl: intl } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                    content: ({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            className: $7vVVB.filtersDialog
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            className: $7vVVB.filtersHeader
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                            appearance: "link",
                            interactionName: "arj-timeline-clear-all-filters",
                            isDisabled: !filtersAppliedCount,
                            onClick: clearAllFilters,
                            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.clear-all-filters"
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $darOt.default).clearAllFiltersLabel))), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement($aac4476e729218f6$var$FiltersList, {
                            ref: this.onFiltersRender
                        }, this.renderStandardFieldsFilters(setInitialFocusRef), this.renderCustomFieldsFilters()) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            className: $7vVVB.filtersList,
                            ref: this.onFiltersRender
                        }, this.renderStandardFieldsFilters(setInitialFocusRef), this.renderCustomFieldsFilters()), Options && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            className: $7vVVB.filterOptions
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Options, null)))),
                    isOpen: this.state.isOpen,
                    onClose: this.onClose,
                    trigger: this.renderTriggerButton,
                    shouldRenderToParent: true,
                    role: "dialog",
                    placement: "bottom-start",
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jira-portfolio-filter-bar-aria-dialog-name-a11y') && {
                        label: intl.formatMessage((0, $darOt.default).dialogLabel)
                    }
                });
            };
            this.renderCustomFieldsFilters = ()=>{
                const { CustomFieldFilter: CustomFieldFilter, customFieldsWithFilteringAllowed: customFieldsWithFilteringAllowed } = this.props;
                const { inlineDialogContentEl: inlineDialogContentEl } = this.state;
                return customFieldsWithFilteringAllowed.map((field)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        key: field.id,
                        className: $7vVVB.filterRow
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $7vVVB.filterRowLabel
                    }, field.title), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $7vVVB.filterRowFilter
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement(CustomFieldFilter, {
                        field: field,
                        parentScrollContainer: inlineDialogContentEl
                    }))));
            };
        }
    }
    var $aac4476e729218f6$export$2e2bcd8739ae039 = (0, $84qTJ.injectIntlWithDefaultProps)($aac4476e729218f6$var$FilterBar);
    const $aac4476e729218f6$var$FiltersList = ({ children: children, ref: ref })=>{
        const banner = (0, (0, parcelRequire("9L6Zg")).useBanner)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: banner.isEnabled ? [
                $aac4476e729218f6$var$filtersListStyles,
                $aac4476e729218f6$var$filtersListStylesWithBanner
            ] : [
                $aac4476e729218f6$var$filtersListStyles
            ],
            ref: ref
        }, children);
    };
    const $aac4476e729218f6$var$filtersListStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxHeight: 'calc(100vh - 309px)',
        msOverflowStyle: 'auto',
        overflowY: 'auto',
        paddingInline: 'space.300',
        paddingBlockEnd: 'space.100'
    });
    const $aac4476e729218f6$var$filtersListStylesWithBanner = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxHeight: 'calc(100vh - 373px)'
    });
});
parcelRegister("dkdSe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4822f9dab23c6ea$export$2e2bcd8739ae039);
    var $bC2fB;
    var $1lv15 = parcelRequire("1lv15");
    var $1AoSp = parcelRequire("1AoSp");
    var $fnT96 = parcelRequire("fnT96");
    var $d4822f9dab23c6ea$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $1AoSp.default), (0, $1lv15.default))((0, $fnT96.default));
});
parcelRegister("1lv15", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ceb5ccb5b961941$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $6ceb5ccb5b961941$var$mapDispatchToProps = (dispatch)=>({
            onRequestChange: (payload)=>dispatch((0, $834it.change)({
                    id: (0, $cGbfF.ASSIGNEE_FILTER_ID),
                    value: payload
                })),
            onRequestClear: ()=>dispatch((0, $834it.clear)((0, $cGbfF.ASSIGNEE_FILTER_ID)))
        });
    var $6ceb5ccb5b961941$export$2e2bcd8739ae039 = $6ceb5ccb5b961941$var$mapDispatchToProps;
});
parcelRegister("1AoSp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e24bfe5a4c0d3687$export$2e2bcd8739ae039);
    var $3zBJm = parcelRequire("3zBJm");
    var $iIikD = parcelRequire("iIikD");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    const $e24bfe5a4c0d3687$var$mapStateToProps = (0, $3YtPS.createSelector)([
        (0, $3zBJm.getAssigneeForFilter),
        (0, $iIikD.getFilters)
    ], (assignees, { [(0, $cGbfF.ASSIGNEE_FILTER_ID)]: { id: id, value: value } })=>({
            id: id,
            value: value,
            assignees: assignees
        }));
    var $e24bfe5a4c0d3687$export$2e2bcd8739ae039 = $e24bfe5a4c0d3687$var$mapStateToProps;
});
parcelRegister("fnT96", function(module, exports) {
    $parcel$export(module.exports, "AssigneeCheckbox", ()=>$85f8c98b3d8fc4be$export$7235937fc5668072);
    $parcel$export(module.exports, "TriggerButtonText", ()=>$85f8c98b3d8fc4be$export$8bd0edd7ca02ab5f);
    $parcel$export(module.exports, "default", ()=>$85f8c98b3d8fc4be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8EB5I;
    var $jVZZA;
    var $3DBzg;
    var $3nPAF;
    var $5XN59;
    var $bQZTk;
    var $1I7E8;
    var $cSD7y;
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $9174a = parcelRequire("9174a");
    var $cGbfF = parcelRequire("cGbfF");
    var $aIMtT = parcelRequire("aIMtT");
    var $8QHq4 = parcelRequire("8QHq4");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $fcnWP = parcelRequire("fcnWP");
    function $85f8c98b3d8fc4be$export$7235937fc5668072({ person: person, checked: checked, onChange: onChange }) {
        const { title: title, email: email, avatarUrl: avatarUrl } = person.jiraUser;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            value: person.personId,
            isChecked: checked,
            onChange: onChange,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8QHq4.UserSelectItem), {
                email: email,
                label: title,
                icon: avatarUrl
            })
        });
    }
    function $85f8c98b3d8fc4be$var$AssigneeFilter({ intl: intl, searchQuery: searchQuery, onQueryChange: onQueryChange, value: value, onRequestChange: onRequestChange, onRequestClear: onRequestClear, assignees: assignees, setInitialFocusRef: setInitialFocusRef }) {
        const isSelected = (assignee)=>(0, parcelRequire("3DBzg")).default(assignee.personId, value);
        const handleAssigneeCheckboxChange = (e)=>{
            const { value: personId, checked: checked } = e.currentTarget;
            const nextValue = (()=>{
                const withoutTheAssignee = (0, parcelRequire("jVZZA")).default((0, parcelRequire("bQZTk")).default((0, parcelRequire("8EB5I")).default(personId), (0, parcelRequire("5XN59")).default))(value);
                if (!checked) return withoutTheAssignee;
                return withoutTheAssignee.concat([
                    personId
                ]);
            })();
            onRequestChange(nextValue);
        };
        const assigneesToDisplay = (0, $9174a.sort)((0, $9174a.filter)(searchQuery, assignees));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
            isVisible: !!value.length,
            onClearClick: onRequestClear
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
            placeholder: intl.formatMessage((0, $fcnWP.default).searchAssigneePlaceholder),
            searchQuery: searchQuery,
            onQueryChange: onQueryChange,
            ariaLabel: intl.formatMessage((0, $fcnWP.default).searchAssigneeLabel),
            setInitialFocusRef: setInitialFocusRef
        }), assigneesToDisplay.map((assignee, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($85f8c98b3d8fc4be$export$7235937fc5668072, {
                checked: isSelected(assignee),
                onChange: handleAssigneeCheckboxChange,
                person: assignee
            }))), (0, parcelRequire("3nPAF")).default(assigneesToDisplay) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
    }
    const $85f8c98b3d8fc4be$var$getNames = (assignees, selected)=>{
        const selectedAssignees = assignees.filter((person)=>selected.has(person.personId));
        const names = selectedAssignees.map((person)=>person.jiraUser.title);
        return names.join(', ');
    };
    function $85f8c98b3d8fc4be$export$8bd0edd7ca02ab5f({ value: value, persons: persons }) {
        const selected = new Set(value);
        if (selected.size === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $fcnWP.default).emptyPlaceholder);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
            text: $85f8c98b3d8fc4be$var$getNames(persons, selected)
        });
    }
    function $85f8c98b3d8fc4be$var$AssigneeFilterDialogOld(props) {
        const { isOpen: isOpen, onOpenChange: onOpenChange, value: value, intl: intl, assignees: assignees } = props;
        const ariaText = ()=>{
            const selected = new Set(value);
            return `${intl.formatMessage((0, $darOt.default)[0, $cGbfF.ASSIGNEE_FILTER_ID])}, ${selected.size > 0 ? $85f8c98b3d8fc4be$var$getNames(assignees, selected) : intl.formatMessage((0, $fcnWP.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            noPaddings: true,
            maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
            minWidth: (0, $3iCBQ.FILTER_WIDTH),
            isOpen: isOpen,
            onClose: onOpenChange,
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($85f8c98b3d8fc4be$var$AssigneeFilter, props)),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter.trigger-btn",
            triggerButtonText: (0, ($parcel$interopDefault($5uXOq))).createElement($85f8c98b3d8fc4be$export$8bd0edd7ca02ab5f, {
                value: props.value,
                persons: props.assignees
            }),
            ariaLabel: ariaText()
        }));
    }
    function $85f8c98b3d8fc4be$var$AssigneeFilterDialog(props) {
        const { isOpen: isOpen, onOpenChange: onOpenChange, value: value, intl: intl, assignees: assignees } = props;
        const ariaText = ()=>{
            const selected = new Set(value);
            return `${intl.formatMessage((0, $darOt.default)[0, $cGbfF.ASSIGNEE_FILTER_ID])}, ${selected.size > 0 ? $85f8c98b3d8fc4be$var$getNames(assignees, selected) : intl.formatMessage((0, $fcnWP.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            placement: "bottom-start",
            shouldUseCaptureOnOutsideClick: true,
            shouldFitContainer: true,
            autoFocus: true,
            onClose: ()=>{
                onOpenChange({
                    isOpen: false
                });
            },
            content: (contentProps)=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($85f8c98b3d8fc4be$var$AssigneeFilter, {
                    ...props,
                    setInitialFocusRef: contentProps.setInitialFocusRef
                }));
            },
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter",
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                    ...triggerProps,
                    isOpen: isOpen,
                    onOpenChange: onOpenChange,
                    testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter.trigger-btn",
                    triggerButtonText: (0, ($parcel$interopDefault($5uXOq))).createElement($85f8c98b3d8fc4be$export$8bd0edd7ca02ab5f, {
                        value: props.value,
                        persons: props.assignees
                    }),
                    ariaLabel: ariaText()
                })
        });
    }
    var $85f8c98b3d8fc4be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('migrate_plan_filter_to_popup', (0, (0, parcelRequire("8RXs9")).default)($85f8c98b3d8fc4be$var$AssigneeFilterDialog), (0, (0, parcelRequire("8RXs9")).default)($85f8c98b3d8fc4be$var$AssigneeFilterDialogOld));
});
parcelRegister("73AQn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f8a706c563c53fd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $aCpcO;
    var $ihPUd = parcelRequire("ihPUd");
    function $0f8a706c563c53fd$export$2e2bcd8739ae039({ onClearClick: onClearClick, isVisible: isVisible }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: {
                display: isVisible ? 'inline-flex' : 'none'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "link",
            onClick: onClearClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).clearFilterText)));
    }
});
parcelRegister("ae7BI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac628ecd234df997$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8JOG8 = parcelRequire("8JOG8");
    var $gdlk4 = parcelRequire("gdlk4");
    function $ac628ecd234df997$export$2e2bcd8739ae039({ text: text }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: text
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $gdlk4.filterText
        }, text));
    }
});
parcelRegister("gdlk4", function(module, exports) {
    $parcel$export(module.exports, "filterText", ()=>$bcde66771160cf89$export$dac863774b2ab841, (v)=>$bcde66771160cf89$export$dac863774b2ab841 = v);
    var $bcde66771160cf89$export$dac863774b2ab841;
    $bcde66771160cf89$export$dac863774b2ab841 = `_053xKW_filterText`;
});
parcelRegister("3iCBQ", function(module, exports) {
    $parcel$export(module.exports, "FILTER_MAX_WIDTH", ()=>$cc478cde16fcb35f$export$13b4adfaabd254c6);
    $parcel$export(module.exports, "FILTER_WIDTH", ()=>$cc478cde16fcb35f$export$f8cf4f7345271a9b);
    var $c94kS = parcelRequire("c94kS");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $hitlf = parcelRequire("hitlf");
    var $b7IdY = parcelRequire("b7IdY");
    var $fzuho = parcelRequire("fzuho");
    var $aIMtT = parcelRequire("aIMtT");
    const $cc478cde16fcb35f$export$13b4adfaabd254c6 = 450;
    const $cc478cde16fcb35f$export$f8cf4f7345271a9b = 300;
});
parcelRegister("c94kS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f2c1ac723302bf0f$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ingq;
    var $f5TWP;
    var $8CUq3;
    var $cSD7y;
    var $aCpcO;
    var $lhW2u = parcelRequire("lhW2u");
    function $f2c1ac723302bf0f$export$9f9a8ca5937d380a(props) {
        const { isOpen: isOpen, testId: testId, triggerButtonText: triggerButtonText, ariaLabel: ariaLabel, onOpenChange: onOpenChange } = props;
        const onOpenChangeHandle = ()=>{
            onOpenChange({
                isOpen: !isOpen
            });
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lhW2u.filterButtonWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                label: ""
            }),
            isSelected: isOpen,
            onClick: onOpenChangeHandle,
            testId: testId,
            ariaLabel: ariaLabel
        }, triggerButtonText)));
    }
    const $f2c1ac723302bf0f$export$4129321aecd13375 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { isOpen: isOpen, testId: testId, triggerButtonText: triggerButtonText, ariaLabel: ariaLabel, onOpenChange: onOpenChange, ...restProps } = props;
        const onOpenChangeHandle = ()=>{
            onOpenChange({
                isOpen: !isOpen
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $f2c1ac723302bf0f$var$buttonWrapperStyle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            ...restProps,
            ref: ref,
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                label: ""
            }),
            isSelected: isOpen,
            onClick: onOpenChangeHandle,
            testId: testId,
            ariaLabel: ariaLabel,
            shouldFitContainer: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw"
            ])
        }, triggerButtonText)));
    });
    const $f2c1ac723302bf0f$var$buttonWrapperStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '278px'
    });
    const $f2c1ac723302bf0f$var$buttonTextStyles = null;
    var $f2c1ac723302bf0f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('migrate_plan_filter_to_popup', $f2c1ac723302bf0f$export$4129321aecd13375, $f2c1ac723302bf0f$export$9f9a8ca5937d380a);
});
parcelRegister("lhW2u", function(module, exports) {
    $parcel$export(module.exports, "filterButtonWrapper", ()=>$f7f834e017d71243$export$706db85642e6c245, (v)=>$f7f834e017d71243$export$706db85642e6c245 = v);
    var $f7f834e017d71243$export$706db85642e6c245;
    $f7f834e017d71243$export$706db85642e6c245 = `bnOPCW_filterButtonWrapper`;
});
parcelRegister("hitlf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$675563717f55bdbc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $8JOG8 = parcelRequire("8JOG8");
    var $85JQx = parcelRequire("85JQx");
    function $675563717f55bdbc$export$2e2bcd8739ae039({ avatarUrl: avatarUrl, name: name, projectKey: projectKey, id: id, appearance: appearance = 'circle', size: size = 'small' }) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $85JQx.projectTitleContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: appearance,
            size: size,
            src: avatarUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            id: id,
            content: name
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${size === 'small' ? $85JQx["small-spacing"] : $85JQx["xsmall-spacing"]} ${$85JQx.projectTitle}`
        }, name, " ", projectKey && `(${projectKey})`))));
    }
});
parcelRegister("85JQx", function(module, exports) {
    $parcel$export(module.exports, "projectTitle", ()=>$5e425a7b26006e93$export$d98ff0eab640b056, (v)=>$5e425a7b26006e93$export$d98ff0eab640b056 = v);
    $parcel$export(module.exports, "projectTitleContainer", ()=>$5e425a7b26006e93$export$2474dce96b358573, (v)=>$5e425a7b26006e93$export$2474dce96b358573 = v);
    $parcel$export(module.exports, "small-spacing", ()=>$5e425a7b26006e93$export$f501eb5ad30f4376, (v)=>$5e425a7b26006e93$export$f501eb5ad30f4376 = v);
    $parcel$export(module.exports, "xsmall-spacing", ()=>$5e425a7b26006e93$export$72ca87e592414a1a, (v)=>$5e425a7b26006e93$export$72ca87e592414a1a = v);
    var $5e425a7b26006e93$export$d98ff0eab640b056;
    var $5e425a7b26006e93$export$2474dce96b358573;
    var $5e425a7b26006e93$export$f501eb5ad30f4376;
    var $5e425a7b26006e93$export$72ca87e592414a1a;
    $5e425a7b26006e93$export$d98ff0eab640b056 = `j-gf7G_projectTitle`;
    $5e425a7b26006e93$export$2474dce96b358573 = `j-gf7G_projectTitleContainer`;
    $5e425a7b26006e93$export$f501eb5ad30f4376 = `j-gf7G_small-spacing`;
    $5e425a7b26006e93$export$72ca87e592414a1a = `j-gf7G_xsmall-spacing`;
});
parcelRegister("b7IdY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e0a975044a2fd55$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $ihPUd = parcelRequire("ihPUd");
    var $8qxM8 = parcelRequire("8qxM8");
    var $9e0a975044a2fd55$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8qxM8.noMatchFoundText
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).noMatchFoundText));
});
parcelRegister("8qxM8", function(module, exports) {
    $parcel$export(module.exports, "checkboxLabel", ()=>$622af387cae140f5$export$68673652bda1864d, (v)=>$622af387cae140f5$export$68673652bda1864d = v);
    $parcel$export(module.exports, "defaultTeamAvatar", ()=>$622af387cae140f5$export$aa80651379a69724, (v)=>$622af387cae140f5$export$aa80651379a69724 = v);
    $parcel$export(module.exports, "noMatchFoundText", ()=>$622af387cae140f5$export$432ba9be018e81c2, (v)=>$622af387cae140f5$export$432ba9be018e81c2 = v);
    $parcel$export(module.exports, "teamAvatarItem", ()=>$622af387cae140f5$export$a15af679b64a13e5, (v)=>$622af387cae140f5$export$a15af679b64a13e5 = v);
    var $622af387cae140f5$export$68673652bda1864d;
    var $622af387cae140f5$export$aa80651379a69724;
    var $622af387cae140f5$export$432ba9be018e81c2;
    var $622af387cae140f5$export$a15af679b64a13e5;
    $622af387cae140f5$export$68673652bda1864d = `oVM_OG_checkboxLabel`;
    $622af387cae140f5$export$aa80651379a69724 = `oVM_OG_defaultTeamAvatar`;
    $622af387cae140f5$export$432ba9be018e81c2 = `oVM_OG_noMatchFoundText`;
    $622af387cae140f5$export$a15af679b64a13e5 = `oVM_OG_teamAvatarItem`;
});
parcelRegister("fzuho", function(module, exports) {
    var $TTKUQ = parcelRequire("TTKUQ");
    const { CHECKED: $47b08530f6ef75e7$export$be74dcf36d511131, UNCHECKED: $47b08530f6ef75e7$export$4bfe604431277125, INDETERMINATE: $47b08530f6ef75e7$export$c5a6fe907430212e } = (0, $TTKUQ.CHECKBOX_STATES);
    const $47b08530f6ef75e7$export$de039e868213edc8 = (categoryStatuses, selectedStatuses)=>{
        if (selectedStatuses.size > 0 && categoryStatuses.every((el)=>selectedStatuses.has(el))) return $47b08530f6ef75e7$export$be74dcf36d511131;
        if (categoryStatuses.some((el)=>selectedStatuses.has(el))) return $47b08530f6ef75e7$export$c5a6fe907430212e;
        return $47b08530f6ef75e7$export$4bfe604431277125;
    };
});
parcelRegister("fcnWP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97638ced526ba750$export$2e2bcd8739ae039);
    var $7VHMR;
    var $97638ced526ba750$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchAssigneePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter.search-assignee-placeholder",
            "defaultMessage": "Show issues from assignees"
        },
        searchAssigneeLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter.search-assignee-label",
            "defaultMessage": "Choose from assignees"
        }
    });
});
parcelRegister("gaqty", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f75fb76dc8283217$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4N4aJ = parcelRequire("4N4aJ");
    var $29mkD = parcelRequire("29mkD");
    var $5CMq8 = parcelRequire("5CMq8");
    var $f75fb76dc8283217$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $29mkD.default), (0, $4N4aJ.default))((0, $5CMq8.default));
});
parcelRegister("4N4aJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6be6b09c36f419c$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $f6be6b09c36f419c$var$mapDispatchToProps = (dispatch)=>({
            changeFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.COMPONENT_FILTER_ID),
                    value: payload
                }));
            },
            clearFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.COMPONENT_FILTER_ID)));
            }
        });
    var $f6be6b09c36f419c$export$2e2bcd8739ae039 = $f6be6b09c36f419c$var$mapDispatchToProps;
});
parcelRegister("29mkD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f436bdf4ff4c54a$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $jpXKt = parcelRequire("jpXKt");
    var $cGbfF = parcelRequire("cGbfF");
    const $9f436bdf4ff4c54a$var$mapStateToProps = (state)=>{
        const projects = (0, $jpXKt.getProjects)(state);
        const { [(0, $cGbfF.COMPONENT_FILTER_ID)]: { id: id, value: value } } = (0, $iIikD.getFilters)(state);
        return {
            id: id,
            value: value,
            projects: projects
        };
    };
    var $9f436bdf4ff4c54a$export$2e2bcd8739ae039 = $9f436bdf4ff4c54a$var$mapStateToProps;
});
parcelRegister("5CMq8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ad2c9ec707397da$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $cGbfF = parcelRequire("cGbfF");
    var $4nDwW = parcelRequire("4nDwW");
    var $8JOG8 = parcelRequire("8JOG8");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $8qxM8 = parcelRequire("8qxM8");
    var $hitlf = parcelRequire("hitlf");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $gEDII = parcelRequire("gEDII");
    class $8ad2c9ec707397da$var$ComponentFilter extends (0, $5uXOq.Component) {
        render() {
            const { intl: intl, onOpenChange: onOpenChange, isOpen: isOpen, value: value, clearFilter: clearFilter, searchQuery: searchQuery, onQueryChange: onQueryChange } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                noPaddings: true,
                maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
                minWidth: (0, $3iCBQ.FILTER_WIDTH),
                onClose: onOpenChange,
                isOpen: isOpen,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: !!value.length,
                    onClearClick: clearFilter
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    placeholder: intl.formatMessage((0, $gEDII.default).searchComponentsPlaceholder),
                    searchQuery: searchQuery,
                    onQueryChange: onQueryChange,
                    ariaLabel: intl.formatMessage((0, $gEDII.default).searchComponentsLabel)
                }), this.renderProjectGroups()),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter.trigger-btn",
                triggerButtonText: this.renderFilterText(),
                ariaLabel: this.ariaText()
            }));
        }
        constructor(...args){
            super(...args);
            this.constructFilterText = ()=>{
                const { value: value, projects: projects } = this.props;
                return (0, $4nDwW.chain)(({ components: components })=>components || [], projects).filter(({ id: id })=>value.includes(id)).map(({ name: name })=>name).join(', ');
            };
            this.renderFilterText = ()=>{
                const { value: value } = this.props;
                const filterText = this.constructFilterText();
                return value.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: filterText
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $gEDII.default).emptyPlaceholder);
            };
            this.ariaText = ()=>{
                const { value: value, intl: intl } = this.props;
                const filterText = this.constructFilterText();
                return `${intl.formatMessage((0, $darOt.default)[0, $cGbfF.COMPONENT_FILTER_ID])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $gEDII.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
            };
            this.isComponentSelected = (component)=>this.props.value.includes(component);
            this.onComponentClick = (clickedComponent)=>{
                const { value: value, changeFilter: changeFilter } = this.props;
                if (this.isComponentSelected(clickedComponent)) changeFilter(value.filter((component)=>component !== clickedComponent));
                else changeFilter([
                    ...value,
                    clickedComponent
                ]);
            };
            this.renderComponents = (components)=>components.map(({ id: id, name: name })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: id
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        id: `${id}`,
                        key: id,
                        isChecked: this.isComponentSelected(id),
                        onChange: ()=>this.onComponentClick(id),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                            content: name,
                            id: id
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $8qxM8.checkboxLabel
                        }, name))
                    })));
            this.renderProjectGroups = ()=>{
                const filteredProjects = this.getFilteredProjects();
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, filteredProjects.map(({ id: id, name: name, key: key, components: components, avatarUrl: avatarUrl })=>{
                    const projectTitle = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hitlf.default), {
                        avatarUrl: avatarUrl,
                        id: id,
                        projectKey: key,
                        name: name
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuGroup), {
                        heading: projectTitle,
                        key: id
                    }, this.renderComponents(components));
                }), filteredProjects.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
            };
            this.getFilteredProjects = ()=>{
                const { projects: projects } = this.props;
                const searchQuery = this.props.searchQuery.toLowerCase();
                const filteredProjects = [];
                for (const project of projects){
                    const { components: components = [] } = project;
                    const filteredComponents = components.filter(({ name: name })=>name.toLowerCase().includes(searchQuery));
                    if (filteredComponents.length > 0) filteredProjects.push({
                        ...project,
                        components: filteredComponents
                    });
                }
                return filteredProjects;
            };
        }
    }
    var $8ad2c9ec707397da$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($8ad2c9ec707397da$var$ComponentFilter);
});
parcelRegister("gEDII", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05cdba3014733eb6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $05cdba3014733eb6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchComponentsPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter.search-components-placeholder",
            "defaultMessage": "Show issues from components"
        },
        searchComponentsLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter.search-components-label",
            "defaultMessage": "Choose from components"
        }
    });
});
parcelRegister("5RQ6f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f84cb827db92ecc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $dzp0m = parcelRequire("dzp0m");
    var $jLHoP = parcelRequire("jLHoP");
    var $cjd9u = parcelRequire("cjd9u");
    function $8f84cb827db92ecc$export$2e2bcd8739ae039({ field: field, parentScrollContainer: parentScrollContainer, ...filterItemHocProps }) {
        const fieldKey = field.type && field.type.key;
        switch(fieldKey){
            case (0, $TTKUQ.CustomFieldTypes).Labels:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dzp0m.default), {
                    customField: field,
                    parentScrollContainer: parentScrollContainer,
                    ...filterItemHocProps
                });
            case (0, $TTKUQ.CustomFieldTypes).AssetObject:
            case (0, $TTKUQ.CustomFieldTypes).MultiSelect:
                if (!(0, (0, parcelRequire("4R6GH")).fg)('asset-custom-field-internal-support')) {
                    if (fieldKey === (0, $TTKUQ.CustomFieldTypes).AssetObject) return null;
                }
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jLHoP.default), {
                    customField: field,
                    parentScrollContainer: parentScrollContainer,
                    ...filterItemHocProps
                });
            case (0, $TTKUQ.CustomFieldTypes).MultiCheckboxes:
            case (0, $TTKUQ.CustomFieldTypes).RadioButtons:
            case (0, $TTKUQ.CustomFieldTypes).SingleSelect:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cjd9u.default), {
                    customField: field,
                    parentScrollContainer: parentScrollContainer,
                    ...filterItemHocProps
                });
            default:
                return null;
        }
    }
});
parcelRegister("dzp0m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f150b718b002c78$export$2e2bcd8739ae039);
    var $bC2fB;
    var $eVcBw = parcelRequire("eVcBw");
    var $4o2Td = parcelRequire("4o2Td");
    var $4zzHt = parcelRequire("4zzHt");
    var $4f150b718b002c78$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $4o2Td.default), (0, $eVcBw.default))((0, $4zzHt.default));
});
parcelRegister("eVcBw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec6e5c8065168b83$export$2e2bcd8739ae039);
    var $24CMK = parcelRequire("24CMK");
    var $eiyR0 = parcelRequire("eiyR0");
    const $ec6e5c8065168b83$var$mapDispatchToProps = (dispatch, props)=>({
            onChange (value) {
                dispatch((0, $eiyR0.update)({
                    customField: props.customField,
                    value: value
                }));
            },
            onRequestClear () {
                dispatch((0, $eiyR0.clear)({
                    customField: props.customField
                }));
            },
            genericError (payload) {
                dispatch((0, $24CMK.genericError)(payload));
            }
        });
    var $ec6e5c8065168b83$export$2e2bcd8739ae039 = $ec6e5c8065168b83$var$mapDispatchToProps;
});
parcelRegister("4o2Td", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68df037d5e2c00e9$export$2e2bcd8739ae039);
    var $fZhYM;
    var $eOe9K = parcelRequire("eOe9K");
    var $3YtPS = parcelRequire("3YtPS");
    const $68df037d5e2c00e9$export$d9fe1e02b9e05ed7 = (state)=>state.domain.customLabelsByField;
    const $68df037d5e2c00e9$var$getLabelsForField = (state, { customField: customField })=>$68df037d5e2c00e9$export$d9fe1e02b9e05ed7(state)[customField.id];
    const $68df037d5e2c00e9$var$getValue = (state, { customField: customField })=>{
        const customFieldFilter = (0, $eOe9K.getCustomFieldFilter)(state);
        return (0, parcelRequire("fZhYM")).default([
            'value',
            customField.id
        ], customFieldFilter) ?? [];
    };
    var $68df037d5e2c00e9$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        options: $68df037d5e2c00e9$var$getLabelsForField,
        value: $68df037d5e2c00e9$var$getValue
    });
});
parcelRegister("4zzHt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$056a1eb8577a4a11$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cTYeP;
    var $7Zjd1;
    var $ousew;
    var $koVbs;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $eOe9K = parcelRequire("eOe9K");
    var $8JOG8 = parcelRequire("8JOG8");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $c94kS = parcelRequire("c94kS");
    var $dBBQT = parcelRequire("dBBQT");
    var $cGU59 = parcelRequire("cGU59");
    const $056a1eb8577a4a11$var$Label = ({ value: value = [], onOpenChange: onOpenChange, isOpen: isOpen, customField: customField, searchQuery: searchQuery, onQueryChange: onQueryChange, onRequestClear: onRequestClear, options: options = [], onChange: onChange })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const constructFilterText = ()=>{
            const noValueOption = (0, parcelRequire("cTYeP")).default((0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID), value) ? [
                intl.formatMessage((0, $dBBQT.default).noValue)
            ] : [];
            const optionsText = options.filter((label)=>(0, parcelRequire("cTYeP")).default(label, value));
            return noValueOption.concat(optionsText).join(', ');
        };
        const renderFilterText = ()=>{
            const filterText = constructFilterText();
            return value.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                text: filterText
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dBBQT.default).emptyPlaceholder);
        };
        const isOptionSelected = (optionId)=>(0, parcelRequire("cTYeP")).default(optionId, value);
        const handleOptionClick = (label)=>{
            const filtered = value.filter((opt)=>opt !== label);
            if (isOptionSelected(label)) onChange(filtered);
            else onChange([
                ...filtered,
                label
            ]);
        };
        const renderOptions = ()=>{
            const filteredOptions = (0, parcelRequire("7Zjd1")).default((a, b)=>a.localeCompare(b), options.filter((option)=>option.toLowerCase().includes(searchQuery.toLowerCase())));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, filteredOptions.length > 0 && !searchQuery ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                key: (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                id: `${(0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)}`,
                key: (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID),
                isChecked: isOptionSelected(`${(0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)}`),
                onChange: ()=>handleOptionClick(`${(0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)}`),
                label: (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    className: $cGU59.optionLabel
                }, intl.formatMessage((0, $dBBQT.default).noValue))
            })) : null, filteredOptions.map((label)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                    key: label
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    id: label,
                    key: label,
                    isChecked: isOptionSelected(label),
                    onChange: ()=>handleOptionClick(label),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                        id: label,
                        content: label
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                        className: $cGU59.optionLabel
                    }, label))
                }))), filteredOptions.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            noPaddings: true,
            maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
            minWidth: (0, $3iCBQ.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            position: "bottom left",
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                isVisible: !!value.length,
                onClearClick: onRequestClear
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                placeholder: intl.formatMessage((0, $dBBQT.default).searchPlaceholder, {
                    fieldName: customField.title
                }),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange
            }), renderOptions())
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            triggerButtonText: renderFilterText(),
            testId: `portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.label.trigger-btn.${customField.id}`,
            ariaLabel: customField.title
        }));
    };
    var $056a1eb8577a4a11$export$2e2bcd8739ae039 = $056a1eb8577a4a11$var$Label;
});
parcelRegister("dBBQT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b738846875b8f30$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1b738846875b8f30$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.search-placeholder",
            "defaultMessage": "Choose an option"
        },
        noMatchFoundText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.no-match-found-text",
            "defaultMessage": "No matches"
        },
        noValue: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.no-value",
            "defaultMessage": "No value"
        }
    });
});
parcelRegister("cGU59", function(module, exports) {
    $parcel$export(module.exports, "noMatchFoundText", ()=>$93d4e90950a624d6$export$432ba9be018e81c2, (v)=>$93d4e90950a624d6$export$432ba9be018e81c2 = v);
    $parcel$export(module.exports, "optionLabel", ()=>$93d4e90950a624d6$export$245ad05b0468ea5e, (v)=>$93d4e90950a624d6$export$245ad05b0468ea5e = v);
    var $93d4e90950a624d6$export$432ba9be018e81c2;
    var $93d4e90950a624d6$export$245ad05b0468ea5e;
    $93d4e90950a624d6$export$432ba9be018e81c2 = `IIii6q_noMatchFoundText`;
    $93d4e90950a624d6$export$245ad05b0468ea5e = `IIii6q_optionLabel`;
});
parcelRegister("jLHoP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1d556c699f52a98$export$2e2bcd8739ae039);
    var $bC2fB;
    var $jFHDS = parcelRequire("jFHDS");
    var $5NFta = parcelRequire("5NFta");
    var $gRfUa = parcelRequire("gRfUa");
    var $c1d556c699f52a98$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $5NFta.default), (0, $jFHDS.default))((0, $gRfUa.default));
});
parcelRegister("jFHDS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88410eb1cddfe2f4$export$2e2bcd8739ae039);
    var $eiyR0 = parcelRequire("eiyR0");
    const $88410eb1cddfe2f4$var$mapDispatchToProps = (dispatch, props)=>({
            onChange (value) {
                dispatch((0, $eiyR0.update)({
                    customField: props.customField,
                    value: value
                }));
            },
            onRequestClear: ()=>{
                dispatch((0, $eiyR0.clear)({
                    customField: props.customField
                }));
            }
        });
    var $88410eb1cddfe2f4$export$2e2bcd8739ae039 = $88410eb1cddfe2f4$var$mapDispatchToProps;
});
parcelRegister("5NFta", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a13c39f2009c279$export$2e2bcd8739ae039);
    var $fZhYM;
    var $19iju = parcelRequire("19iju");
    var $eOe9K = parcelRequire("eOe9K");
    var $3YtPS = parcelRequire("3YtPS");
    const $4a13c39f2009c279$export$8ba04a2269d8d395 = (state, { customField: customField })=>{
        const selectOptions = (0, $19iju.getSelectOptions)(state);
        return selectOptions.filter((opt)=>opt.fieldId === customField.id);
    };
    const $4a13c39f2009c279$export$ba9a994fdfb4baba = (state, { customField: customField })=>{
        const customFieldFilter = (0, $eOe9K.getCustomFieldFilter)(state);
        return (0, parcelRequire("fZhYM")).default([
            'value',
            String(customField.id)
        ], customFieldFilter) || [];
    };
    var $4a13c39f2009c279$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        options: $4a13c39f2009c279$export$8ba04a2269d8d395,
        value: $4a13c39f2009c279$export$ba9a994fdfb4baba
    });
});
parcelRegister("gRfUa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$170b72ffb6b8498f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cTYeP;
    var $cDeeP;
    var $3DBzg;
    var $4S1OS;
    var $2rMKg;
    var $h35CY;
    var $48UFW;
    var $f5OZ1;
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $eOe9K = parcelRequire("eOe9K");
    var $8JOG8 = parcelRequire("8JOG8");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $dBBQT = parcelRequire("dBBQT");
    var $cGU59 = parcelRequire("cGU59");
    class $170b72ffb6b8498f$var$MultiSelect extends (0, $5uXOq.Component) {
        render() {
            const { customField: customField, intl: intl, isOpen: isOpen, onOpenChange: onOpenChange, onQueryChange: onQueryChange, onRequestClear: onRequestClear, searchQuery: searchQuery, value: value } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                noPaddings: true,
                maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
                minWidth: (0, $3iCBQ.FILTER_WIDTH),
                onClose: onOpenChange,
                isOpen: isOpen,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: !!value.length,
                    onClearClick: onRequestClear
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    placeholder: intl.formatMessage((0, $dBBQT.default).searchPlaceholder, {
                        fieldName: customField.title
                    }),
                    searchQuery: searchQuery,
                    onQueryChange: onQueryChange
                }), this.renderOptions())
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                triggerButtonText: this.renderFilterText(),
                testId: `portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.multi-select.trigger-btn.${customField.id}`,
                ariaLabel: this.ariaText()
            }));
        }
        constructor(...args){
            super(...args);
            this.constructFilterText = ()=>{
                const { intl: intl, options: options, value: value } = this.props;
                const noValueOption = {
                    id: (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID),
                    value: intl.formatMessage((0, $dBBQT.default).noValue)
                };
                const uniqueLabels = [
                    noValueOption
                ].concat(options).reduce((acc, option)=>{
                    if (value.includes(`${option.id}`)) return acc.add(option.value);
                    return acc;
                }, new Set());
                return [
                    ...uniqueLabels
                ].join(', ');
            };
            this.renderFilterText = ()=>{
                const { value: value } = this.props;
                return value.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: this.constructFilterText()
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dBBQT.default).emptyPlaceholder);
            };
            this.ariaText = ()=>{
                const { value: value, intl: intl, customField: customField } = this.props;
                const filterText = this.constructFilterText();
                return `${customField.title}, ${value.length > 0 ? filterText : intl.formatMessage((0, $dBBQT.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
            };
            this.isOptionSelectedNew = (optionValue)=>{
                const { value: value, options: options } = this.props;
                if (optionValue === (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)) return (0, parcelRequire("3DBzg")).default(optionValue, value);
                const matchingOptionIds = options.filter((option)=>option.value === optionValue).map((option)=>option.id.toString());
                return (0, parcelRequire("4S1OS")).default(matchingOptionIds, value).length > 0;
            };
            this.isOptionSelected = (optionId)=>(0, parcelRequire("cTYeP")).default(optionId, this.props.value);
            this.handleOptionClickNew = (optionValue)=>{
                const { onChange: onChange, value: value, options: options } = this.props;
                const matchingOptionIds = optionValue === (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID) ? [
                    (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)
                ] : options.filter((option)=>option.value === optionValue).map((option)=>option.id.toString());
                const isSelected = value.some((opt)=>matchingOptionIds.includes(opt));
                if (isSelected) onChange((0, parcelRequire("cDeeP")).default(value, matchingOptionIds));
                else onChange((0, parcelRequire("48UFW")).default(matchingOptionIds, value));
            };
            this.handleOptionClick = (optionId)=>{
                const { onChange: onChange, value: value } = this.props;
                const filtered = value.filter((opt)=>opt !== optionId);
                if (this.isOptionSelected(optionId)) onChange(filtered);
                else onChange([
                    ...filtered,
                    optionId
                ]);
            };
            this.renderOptions = ()=>{
                const { intl: intl, options: options } = this.props;
                const filteredOptions = (0, parcelRequire("h35CY")).default((0, parcelRequire("2rMKg")).default('value'), options.filter((option)=>option.value.toLowerCase().includes(this.props.searchQuery.toLowerCase())));
                const dedupedOptions = (0, parcelRequire("f5OZ1")).default((0, parcelRequire("2rMKg")).default('value'), filteredOptions);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, options.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                    key: (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    id: `${(0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)}`,
                    key: (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID),
                    isChecked: this.isOptionSelected(`${(0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)}`),
                    onChange: ()=>this.handleOptionClick(`${(0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)}`),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                        className: $cGU59.optionLabel
                    }, intl.formatMessage((0, $dBBQT.default).noValue))
                })) : null, dedupedOptions.map(({ value: value })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: value
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        id: `${value}`,
                        key: value,
                        isChecked: this.isOptionSelectedNew(`${value}`),
                        onChange: ()=>this.handleOptionClickNew(`${value}`),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                            id: value,
                            content: value
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $cGU59.optionLabel
                        }, value))
                    }))), !filteredOptions.length && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $cGU59.noMatchFoundText
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dBBQT.default).noMatchFoundText)));
            };
        }
    }
    var $170b72ffb6b8498f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($170b72ffb6b8498f$var$MultiSelect);
});
parcelRegister("cjd9u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b8a7a248bc78689$export$2e2bcd8739ae039);
    var $bC2fB;
    var $frTTO = parcelRequire("frTTO");
    var $iq3mj = parcelRequire("iq3mj");
    var $8Ovcu = parcelRequire("8Ovcu");
    var $7b8a7a248bc78689$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $iq3mj.mapStateToProps), (0, $frTTO.default))((0, $8Ovcu.default));
});
parcelRegister("frTTO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7426aeec1a4c486f$export$2e2bcd8739ae039);
    var $eiyR0 = parcelRequire("eiyR0");
    const $7426aeec1a4c486f$var$mapDispatchToProps = (dispatch, props)=>({
            onChange (value) {
                dispatch((0, $eiyR0.update)({
                    customField: props.customField,
                    value: value
                }));
            },
            onRequestClear () {
                dispatch((0, $eiyR0.clear)({
                    customField: props.customField
                }));
            }
        });
    var $7426aeec1a4c486f$export$2e2bcd8739ae039 = $7426aeec1a4c486f$var$mapDispatchToProps;
});
parcelRegister("iq3mj", function(module, exports) {
    $parcel$export(module.exports, "mapStateToProps", ()=>$4e9edbb37bb31559$export$c31df4bd766f9c35);
    var $fZhYM;
    var $19iju = parcelRequire("19iju");
    var $eOe9K = parcelRequire("eOe9K");
    var $3YtPS = parcelRequire("3YtPS");
    const $4e9edbb37bb31559$var$getOptions = (state, { customField: customField })=>(0, $19iju.getSelectOptions)(state).filter((opt)=>opt.fieldId === customField.id);
    const $4e9edbb37bb31559$var$getValue = (state, { customField: customField })=>{
        const customFieldFilter = (0, $eOe9K.getCustomFieldFilter)(state);
        return (0, parcelRequire("fZhYM")).default([
            'value',
            String(customField.id)
        ], customFieldFilter) || [];
    };
    const $4e9edbb37bb31559$export$c31df4bd766f9c35 = (0, $3YtPS.createStructuredSelector)({
        options: $4e9edbb37bb31559$var$getOptions,
        value: $4e9edbb37bb31559$var$getValue
    });
});
parcelRegister("8Ovcu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79f736dfdbd6eb59$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cTYeP;
    var $cDeeP;
    var $3DBzg;
    var $4S1OS;
    var $2rMKg;
    var $h35CY;
    var $48UFW;
    var $d8iBX;
    var $f5OZ1;
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $eOe9K = parcelRequire("eOe9K");
    var $8JOG8 = parcelRequire("8JOG8");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $dBBQT = parcelRequire("dBBQT");
    var $cGU59 = parcelRequire("cGU59");
    class $79f736dfdbd6eb59$var$SingleSelect extends (0, $5uXOq.Component) {
        render() {
            const { intl: intl, value: value, onOpenChange: onOpenChange, isOpen: isOpen, customField: customField, searchQuery: searchQuery, onQueryChange: onQueryChange, onRequestClear: onRequestClear } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                noPaddings: true,
                maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
                minWidth: (0, $3iCBQ.FILTER_WIDTH),
                onClose: onOpenChange,
                isOpen: isOpen,
                position: "bottom left",
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: !!value.length,
                    onClearClick: onRequestClear
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    placeholder: intl.formatMessage((0, $dBBQT.default).searchPlaceholder, {
                        fieldName: customField.title
                    }),
                    searchQuery: searchQuery,
                    onQueryChange: onQueryChange
                }), this.renderOptions())
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                triggerButtonText: this.renderFilterText(),
                testId: `portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.single-select.trigger-btn.${customField.id}`,
                ariaLabel: this.ariaText()
            })));
        }
        constructor(...args){
            super(...args);
            this.constructFilterText = ()=>{
                const { intl: intl, options: options, value: value } = this.props;
                const noValueOption = {
                    id: (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID),
                    value: intl.formatMessage((0, $dBBQT.default).noValue)
                };
                return (0, parcelRequire("d8iBX")).default([
                    noValueOption
                ].concat(options).filter(({ id: id })=>(0, parcelRequire("3DBzg")).default(`${id}`, value)).map((0, parcelRequire("2rMKg")).default('value'))).join(', ');
            };
            this.renderFilterText = ()=>{
                const value = this.props.value;
                const filterText = this.constructFilterText();
                return value.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: filterText
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dBBQT.default).emptyPlaceholder);
            };
            this.ariaText = ()=>{
                const { value: value, intl: intl, customField: customField } = this.props;
                const filterText = this.constructFilterText();
                return `${customField.title}, ${value.length > 0 ? filterText : intl.formatMessage((0, $dBBQT.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
            };
            this.isOptionSelectedNew = (optionValue)=>{
                const { value: value, options: options } = this.props;
                if (optionValue === (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)) return (0, parcelRequire("3DBzg")).default(optionValue, value);
                const matchingOptionIds = options.filter((option)=>option.value === optionValue).map((option)=>option.id.toString());
                return (0, parcelRequire("4S1OS")).default(matchingOptionIds, value).length > 0;
            };
            this.isOptionSelected = (optionId)=>{
                const value = this.props.value;
                return (0, parcelRequire("cTYeP")).default(optionId, value);
            };
            this.handleOptionClickNew = (optionValue)=>{
                const { onChange: onChange, value: value, options: options } = this.props;
                const matchingOptionIds = optionValue === (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID) ? [
                    (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)
                ] : options.filter((option)=>option.value === optionValue).map((option)=>option.id.toString());
                const isSelected = value.some((opt)=>matchingOptionIds.includes(opt));
                if (isSelected) onChange((0, parcelRequire("cDeeP")).default(value, matchingOptionIds));
                else onChange((0, parcelRequire("48UFW")).default(matchingOptionIds, value));
            };
            this.handleOptionClick = (optionId)=>{
                const { value: value, onChange: onChange } = this.props;
                const filtered = value.filter((opt)=>opt !== optionId);
                if (this.isOptionSelected(optionId)) onChange(filtered);
                else onChange([
                    ...filtered,
                    optionId
                ]);
            };
            this.renderOptions = ()=>{
                const { intl: intl, options: options } = this.props;
                const filteredOptions = (0, parcelRequire("h35CY")).default((0, parcelRequire("2rMKg")).default('value'), options.filter((option)=>option.value.toLowerCase().includes(this.props.searchQuery.toLowerCase())));
                const dedupedOptions = (0, parcelRequire("f5OZ1")).default((0, parcelRequire("2rMKg")).default('value'), filteredOptions);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, options.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                    key: (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    id: `${(0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)}`,
                    key: (0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID),
                    isChecked: this.isOptionSelected(`${(0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)}`),
                    onChange: ()=>this.handleOptionClick(`${(0, $eOe9K.NO_CUSTOM_FIELD_VALUE_ID)}`),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                        className: $cGU59.optionLabel
                    }, intl.formatMessage((0, $dBBQT.default).noValue))
                })) : null, dedupedOptions.map(({ value: value })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: value
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        id: `${value}`,
                        key: value,
                        isChecked: this.isOptionSelectedNew(`${value}`),
                        onChange: ()=>this.handleOptionClickNew(`${value}`),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                            id: value,
                            content: value
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $cGU59.optionLabel
                        }, value))
                    }))), filteredOptions.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $cGU59.noMatchFoundText
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $dBBQT.default).noMatchFoundText)));
            };
        }
    }
    var $79f736dfdbd6eb59$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($79f736dfdbd6eb59$var$SingleSelect);
});
parcelRegister("eLNbt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f3cfd117d16ec27$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4RdXD = parcelRequire("4RdXD");
    var $9ePqi = parcelRequire("9ePqi");
    var $9Xsfz = parcelRequire("9Xsfz");
    var $1f3cfd117d16ec27$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $9ePqi.default), (0, $4RdXD.default))((0, $9Xsfz.DateRangeFilter));
});
parcelRegister("4RdXD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2b77189fdf936fa$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $c2b77189fdf936fa$var$mapDispatchToProps = (dispatch)=>({
            onDateRangeChange: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.DATE_RANGE_FILTER_ID),
                    value: payload
                }));
            }
        });
    var $c2b77189fdf936fa$export$2e2bcd8739ae039 = $c2b77189fdf936fa$var$mapDispatchToProps;
});
parcelRegister("9ePqi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1dc5628a169d406$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    const $c1dc5628a169d406$var$mapStateToProps = (0, $3YtPS.createSelector)([
        (0, $iIikD.getFilters)
    ], ({ [(0, $cGbfF.DATE_RANGE_FILTER_ID)]: { id: id, value: { startDate: startDate, endDate: endDate } } })=>({
            id: id,
            startDate: startDate,
            endDate: endDate
        }));
    var $c1dc5628a169d406$export$2e2bcd8739ae039 = $c1dc5628a169d406$var$mapStateToProps;
});
parcelRegister("9Xsfz", function(module, exports) {
    $parcel$export(module.exports, "DateRangeFilter", ()=>$2e79414637aa5314$export$26dc5fbaa253de80);
    var $5uXOq = parcelRequire("5uXOq");
    var $cHapz;
    var $2x3Cb;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $koVbs;
    var $aT988 = parcelRequire("aT988");
    var $5N8pB = parcelRequire("5N8pB");
    const $2e79414637aa5314$export$26dc5fbaa253de80 = ({ startDate: startTimestamp, endDate: endTimestamp, onDateRangeChange: onDateRangeChange })=>{
        const { locale: locale, formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const startDate = (0, $5N8pB.convertToDateString)(startTimestamp);
        const endDate = (0, $5N8pB.convertToDateString)(endTimestamp);
        const onStartInputChange = (newStartDate)=>{
            onDateRangeChange((0, $5N8pB.createAndHandleDateRangeChange)(newStartDate, endDate));
        };
        const onEndInputChange = (newEndDate)=>{
            onDateRangeChange((0, $5N8pB.createAndHandleDateRangeChange)(startDate, newEndDate));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $2e79414637aa5314$var$filterContainerStyles,
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            grow: "fill"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: "date-range-filter-from"
        }, formatMessage((0, $aT988.default).startDateLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHapz")).default), {
            locale: locale,
            value: startDate,
            onChange: onStartInputChange,
            placeholder: formatMessage((0, $aT988.default).noDatePlaceholder),
            maxDate: endDate,
            id: "date-range-filter-from"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            grow: "fill"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: "date-range-filter-to"
        }, formatMessage((0, $aT988.default).endDateLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHapz")).default), {
            locale: locale,
            value: endDate,
            minDate: startDate,
            placeholder: formatMessage((0, $aT988.default).noDatePlaceholder),
            onChange: onEndInputChange,
            id: "date-range-filter-to"
        })));
    };
    const $2e79414637aa5314$var$filterContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '278px'
    });
});
parcelRegister("aT988", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c813277d6db4199$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4c813277d6db4199$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        startDateLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.date-range-filter.start-date-label",
            "defaultMessage": "Start date"
        },
        endDateLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.date-range-filter.end-date-label",
            "defaultMessage": "End date"
        },
        noDatePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.date-range-filter.no-date-placeholder",
            "defaultMessage": "None"
        }
    });
});
parcelRegister("5N8pB", function(module, exports) {
    $parcel$export(module.exports, "convertToDateString", ()=>$97436b63790b35fa$export$329b86aa495c7d2b);
    $parcel$export(module.exports, "createAndHandleDateRangeChange", ()=>$97436b63790b35fa$export$19d9ed0dfec2c07a);
    var $gh61P;
    var $aipk9;
    var $flnZx;
    const $97436b63790b35fa$export$329b86aa495c7d2b = (timestamp)=>timestamp !== undefined ? (0, (0, parcelRequire("aipk9")).formatDateUTC)(timestamp, (0, (0, parcelRequire("gh61P")).IsoDateFormat)) : '';
    const $97436b63790b35fa$export$677e82bae63eb855 = (date)=>date !== undefined && date !== '' ? (0, (0, parcelRequire("flnZx")).startOfUtcDay)(date) : undefined;
    const $97436b63790b35fa$export$19d9ed0dfec2c07a = (newStartDate, newEndDate)=>{
        const startDateTmp = $97436b63790b35fa$export$677e82bae63eb855(newStartDate);
        const endDateTmp = $97436b63790b35fa$export$677e82bae63eb855(newEndDate);
        return {
            ...startDateTmp !== undefined && {
                startDate: startDateTmp
            },
            ...endDateTmp !== undefined && {
                endDate: endDateTmp
            }
        };
    };
});
parcelRegister("cjRl2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1a5be5b9dc3c644$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5b9vj = parcelRequire("5b9vj");
    var $1naQb = parcelRequire("1naQb");
    var $clYOq = parcelRequire("clYOq");
    var $e1a5be5b9dc3c644$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $1naQb.default), (0, $5b9vj.default))((0, $clYOq.default));
});
parcelRegister("5b9vj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15f9833ca9443510$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $15f9833ca9443510$var$mapDispatchToProps = (dispatch)=>({
            changeDependenciesFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.DEPENDENCIES_FILTER_ID),
                    value: payload
                }));
            }
        });
    var $15f9833ca9443510$export$2e2bcd8739ae039 = $15f9833ca9443510$var$mapDispatchToProps;
});
parcelRegister("1naQb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7975aa18b70ebffc$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $cGbfF = parcelRequire("cGbfF");
    const $7975aa18b70ebffc$var$mapStateToProps = (state)=>{
        const { [(0, $cGbfF.DEPENDENCIES_FILTER_ID)]: { id: id, value: value } } = (0, $iIikD.getFilters)(state);
        return {
            id: id,
            issues: (0, $gFhwb.getIssues)(state),
            issueMapById: (0, $gFhwb.getIssueMapById)(state),
            issueTypes: (0, $kllqP.getIssueTypes)(state),
            projectsById: (0, $jpXKt.getProjectsById)(state),
            value: value
        };
    };
    var $7975aa18b70ebffc$export$2e2bcd8739ae039 = $7975aa18b70ebffc$var$mapStateToProps;
});
parcelRegister("clYOq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f3324eb5b39f81f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $6Ingq;
    var $jouoW;
    var $8RXs9;
    var $aCpcO;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $iqIcG;
    var $i2qlb = parcelRequire("i2qlb");
    var $cGbfF = parcelRequire("cGbfF");
    var $cSDJf = parcelRequire("cSDJf");
    var $2OMDV;
    var $8zOmE;
    var $3iCBQ = parcelRequire("3iCBQ");
    var $darOt = parcelRequire("darOt");
    var $k4Lpi = parcelRequire("k4Lpi");
    var $kvabd = parcelRequire("kvabd");
    const $6f3324eb5b39f81f$export$d742e2fb7de0884c = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('radioButton', {
        onChange: 'changed'
    })((0, (0, parcelRequire("jouoW")).default));
    const $6f3324eb5b39f81f$var$AsyncSelectWithAnalytics = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('asyncSelect', {
        onChange: 'changed'
    })((0, $cSDJf.AsyncSelect));
    function $6f3324eb5b39f81f$var$isDepdendencyFilterValueHasTransitive(val) {
        return val.type === 'specificIssue';
    }
    class $6f3324eb5b39f81f$export$51af50c438784b95 extends (0, $5uXOq.Component) {
        render() {
            const { props: props, onDependencyFilterChange: onDependencyFilterChange } = this;
            const { intl: intl, issueMapById: issueMapById, value: value, isOpen: isOpen } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                noPaddings: true,
                maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
                minWidth: (0, $3iCBQ.FILTER_WIDTH),
                overflow: "visible",
                onClose: this.onOpenChange,
                isOpen: isOpen,
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter",
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), {
                    style: {
                        overflow: 'visible'
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuGroup), {
                    heading: intl.formatMessage((0, $k4Lpi.default).showIssues)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement($6f3324eb5b39f81f$export$d742e2fb7de0884c, {
                    isChecked: value.type === 'off',
                    label: intl.formatMessage((0, $k4Lpi.default).allIssues),
                    name: "showIssues",
                    onChange: (_, analyticsEvent)=>onDependencyFilterChange({
                            type: 'off'
                        }, analyticsEvent),
                    value: "off"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement($6f3324eb5b39f81f$export$d742e2fb7de0884c, {
                    isChecked: value.type === 'on',
                    label: intl.formatMessage((0, $k4Lpi.default).hasDependencies),
                    name: "showIssues",
                    onChange: (_, analyticsEvent)=>onDependencyFilterChange({
                            type: 'on'
                        }, analyticsEvent),
                    value: "on"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement($6f3324eb5b39f81f$export$d742e2fb7de0884c, {
                    isChecked: value.type === 'offtrack',
                    label: intl.formatMessage((0, $k4Lpi.default).offtrackDependencies),
                    name: "showIssues",
                    onChange: (_, analyticsEvent)=>onDependencyFilterChange({
                            type: 'offtrack'
                        }, analyticsEvent),
                    value: "offtrack"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement($6f3324eb5b39f81f$export$d742e2fb7de0884c, {
                    isChecked: value.type === 'specificIssue',
                    label: intl.formatMessage((0, $k4Lpi.default).specificIssue),
                    name: "showIssues",
                    onChange: (_, analyticsEvent)=>onDependencyFilterChange({
                            type: 'specificIssue'
                        }, analyticsEvent),
                    value: "specificIssue"
                }))), value.type === 'specificIssue' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($6f3324eb5b39f81f$var$AsyncSelectWithAnalytics, {
                    className: $kvabd.issueSelector,
                    defaultOptions: true,
                    defaultValue: value.issueId && issueMapById[value.issueId],
                    formatOptionLabel: this.renderDependencyIssue,
                    getOptionValue: this.getDependencyIssueValue,
                    getOptionLabel: this.getDependencyIssueValue,
                    isClearable: true,
                    isTransparentBackground: false,
                    loadOptions: this.loadOptions,
                    menuPlacement: "auto",
                    onChange: this.onIssueChange,
                    placeholder: intl.formatMessage((0, $k4Lpi.default).issueSelectorPlaceholder),
                    autoFocus: true
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $kvabd.includeTransitive
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    isChecked: value.includeTransitive,
                    label: intl.formatMessage((0, $k4Lpi.default).includeTransitive),
                    onChange: (_, analyticsEvent)=>onDependencyFilterChange({
                            type: 'specificIssue',
                            issueId: value.issueId,
                            includeTransitive: !value.includeTransitive
                        }, analyticsEvent)
                }))) : null)
            }, this.renderTriggerButton());
        }
        constructor(...args){
            super(...args);
            this.onIssueChange = (issue, _, analyticsEvent)=>{
                const { props: props, onDependencyFilterChange: onDependencyFilterChange } = this;
                const { value: value } = props;
                onDependencyFilterChange({
                    type: 'specificIssue',
                    issueId: issue && issue.id,
                    includeTransitive: $6f3324eb5b39f81f$var$isDepdendencyFilterValueHasTransitive(value) && value.includeTransitive || false
                }, analyticsEvent);
            };
            this.onOpenChange = ({ isOpen: isOpen, ignoreMenuOpen: ignoreMenuOpen }, analyticsEvent)=>{
                const { props: props, onDependencyFilterChange: onDependencyFilterChange } = this;
                const { value: value, onOpenChange: onOpenChange } = props;
                if (!ignoreMenuOpen && props.isMenuOpen) return;
                if (!isOpen && value.type === 'specificIssue' && !value.issueId) onDependencyFilterChange({
                    type: 'off'
                }, analyticsEvent);
                onOpenChange({
                    isOpen: isOpen
                });
            };
            this.onDependencyFilterChange = (payload, analyticsEvent)=>{
                this.props.changeDependenciesFilter(payload);
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATED_DEPENDENCIES_FILTER.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: action,
                    actionSubject: actionSubject
                }), {
                    type: payload.type
                });
            };
            this.toggleOpen = (_, analyticsEvent)=>{
                const { isOpen: isOpen } = this.props;
                this.onOpenChange({
                    isOpen: !isOpen,
                    ignoreMenuOpen: true
                }, analyticsEvent);
            };
            this.getIssueKey = ({ issueKey: issueKey, project: projectId })=>{
                const { projectsById: projectsById } = this.props;
                const project = projectsById[projectId || NaN];
                const key = issueKey ? `${project.key}-${issueKey}` : project.key;
                return key;
            };
            this.getDependencyIssueValue = (issue)=>`${this.getIssueKey(issue)} ${issue.summary}`;
            this.loadOptions = (query)=>{
                const q = query.toLowerCase();
                const issues = this.props.issues.filter((issue)=>this.getDependencyIssueValue(issue).toLowerCase().includes(q)).slice(0, 50);
                return Promise.resolve(issues);
            };
            this.renderDependencyIssue = (issue)=>{
                const { issueTypes: issueTypes } = this.props;
                const issueType = issueTypes.find(({ id: id })=>id === issue.type);
                return (0, (0, parcelRequire("iqIcG")).selectIssueOption)({
                    icon: issueType && issueType.iconUrl,
                    label: this.getDependencyIssueValue(issue)
                });
            };
            this.renderTriggerButton = ()=>{
                const { intl: intl, issueMapById: issueMapById, value: value, isOpen: isOpen } = this.props;
                let triggerButtonText = '';
                if (value.type === 'specificIssue') {
                    const { issueId: issueId } = value;
                    if (issueId && issueMapById[issueId]) triggerButtonText = intl.formatMessage((0, $k4Lpi.default).specificIssueTrigger, {
                        issueKey: this.getIssueKey(issueMapById[issueId])
                    });
                    else triggerButtonText = intl.formatMessage((0, $k4Lpi.default).offTrigger);
                } else triggerButtonText = intl.formatMessage((0, $k4Lpi.default)[`${value.type}Trigger`]);
                const ariaText = ()=>`${intl.formatMessage((0, $darOt.default)[0, $cGbfF.DEPENDENCIES_FILTER_ID])}, ${triggerButtonText} ${intl.formatMessage((0, $darOt.default).selected)}`;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $kvabd.filterButtonWrapper
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: ""
                    }),
                    isSelected: isOpen,
                    onClick: this.toggleOpen,
                    ariaLabel: ariaText(),
                    testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.trigger-btn"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: (0, ($parcel$interopDefault($9ci4W)))($kvabd.filterButton, {
                        [$kvabd.filterButtonApplied]: value.type !== 'off'
                    })
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $kvabd.buttonText
                }, triggerButtonText)))));
            };
        }
    }
    var $6f3324eb5b39f81f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($6f3324eb5b39f81f$export$51af50c438784b95);
});
parcelRegister("k4Lpi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ecb364c02d46332$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ecb364c02d46332$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        showIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.show-issues",
            "defaultMessage": "Show issues"
        },
        allIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.all-issues",
            "defaultMessage": "All issues"
        },
        hasDependencies: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.has-dependencies",
            "defaultMessage": "Has dependencies"
        },
        specificIssue: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.specific-issue",
            "defaultMessage": "Specific issue"
        },
        offtrackDependencies: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.offtrack-dependencies",
            "defaultMessage": "Overlapping dates"
        },
        issueSelectorPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.issue-selector-placeholder",
            "defaultMessage": "Choose issue..."
        },
        offTrigger: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.off-trigger",
            "defaultMessage": "All issues"
        },
        onTrigger: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.on-trigger",
            "defaultMessage": "Issues with dependencies"
        },
        specificIssueTrigger: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.specific-issue-trigger",
            "defaultMessage": "Dependencies of {issueKey}"
        },
        offtrackTrigger: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.offtrack-trigger",
            "defaultMessage": "Issues with overlapping dates"
        },
        includeTransitive: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.include-transitive",
            "defaultMessage": "Include dependency chain"
        }
    });
});
parcelRegister("kvabd", function(module, exports) {
    $parcel$export(module.exports, "buttonText", ()=>$eece996767c2b46a$export$c058c12a17cc5c02, (v)=>$eece996767c2b46a$export$c058c12a17cc5c02 = v);
    $parcel$export(module.exports, "filterButton", ()=>$eece996767c2b46a$export$64796c58ca8c33ef, (v)=>$eece996767c2b46a$export$64796c58ca8c33ef = v);
    $parcel$export(module.exports, "filterButtonApplied", ()=>$eece996767c2b46a$export$d3cfd886ed244cea, (v)=>$eece996767c2b46a$export$d3cfd886ed244cea = v);
    $parcel$export(module.exports, "filterButtonWrapper", ()=>$eece996767c2b46a$export$706db85642e6c245, (v)=>$eece996767c2b46a$export$706db85642e6c245 = v);
    $parcel$export(module.exports, "includeTransitive", ()=>$eece996767c2b46a$export$8348ef9c4a261b73, (v)=>$eece996767c2b46a$export$8348ef9c4a261b73 = v);
    $parcel$export(module.exports, "issueSelector", ()=>$eece996767c2b46a$export$a849e6f9952698a4, (v)=>$eece996767c2b46a$export$a849e6f9952698a4 = v);
    var $eece996767c2b46a$export$c058c12a17cc5c02;
    var $eece996767c2b46a$export$64796c58ca8c33ef;
    var $eece996767c2b46a$export$d3cfd886ed244cea;
    var $eece996767c2b46a$export$706db85642e6c245;
    var $eece996767c2b46a$export$8348ef9c4a261b73;
    var $eece996767c2b46a$export$a849e6f9952698a4;
    $eece996767c2b46a$export$c058c12a17cc5c02 = `o5zuRq_buttonText`;
    $eece996767c2b46a$export$64796c58ca8c33ef = `o5zuRq_filterButton`;
    $eece996767c2b46a$export$d3cfd886ed244cea = `o5zuRq_filterButtonApplied`;
    $eece996767c2b46a$export$706db85642e6c245 = `o5zuRq_filterButtonWrapper`;
    $eece996767c2b46a$export$8348ef9c4a261b73 = `o5zuRq_includeTransitive`;
    $eece996767c2b46a$export$a849e6f9952698a4 = `o5zuRq_issueSelector`;
});
parcelRegister("8BWE6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3a804529a92f2ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $f3a804529a92f2ed$export$2e2bcd8739ae039(WrappedComponent) {
        return class FilterItem extends (0, $5uXOq.Component) {
            componentDidUpdate(_, prevState) {
                const { parentScrollContainer: parentScrollContainer } = this.props;
                if (!parentScrollContainer) return;
                if (this.state.isOpen && !prevState.isOpen) parentScrollContainer.addEventListener('scroll', this.onParentScroll);
                else if (!this.state.isOpen && prevState.isOpen) parentScrollContainer.removeEventListener('scroll', this.onParentScroll);
            }
            componentWillUnmount() {
                if (this.props.parentScrollContainer) this.props.parentScrollContainer.removeEventListener('scroll', this.onParentScroll);
            }
            render() {
                const { parentScrollContainer: parentScrollContainer, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.state,
                    ...restProps,
                    onOpenChange: this.onOpenChange,
                    onQueryChange: this.onQueryChange
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    searchQuery: '',
                    isOpen: !!this.props.isInitiallyOpen
                };
                this.onParentScroll = ()=>{
                    if (this.state.isOpen) this.setState({
                        isOpen: false
                    });
                };
                this.onOpenChange = ({ isOpen: isOpen })=>{
                    this.setState({
                        isOpen: isOpen
                    });
                };
                this.onQueryChange = (searchQuery)=>{
                    this.setState({
                        searchQuery: searchQuery
                    });
                };
            }
        };
    }
});
parcelRegister("1oRGd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed39c6b652bc3354$export$2e2bcd8739ae039);
    var $bC2fB;
    var $8fYac = parcelRequire("8fYac");
    var $ikH4h = parcelRequire("ikH4h");
    var $crJCb = parcelRequire("crJCb");
    var $ed39c6b652bc3354$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $ikH4h.default), (0, $8fYac.default))((0, $crJCb.default));
});
parcelRegister("8fYac", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b558b7c7a66fee2$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $4b558b7c7a66fee2$var$mapDispatchToProps = (dispatch)=>({
            changeGoalsFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.GOAL_FILTER_ID),
                    value: payload
                }));
            },
            clearGoalsFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.GOAL_FILTER_ID)));
            }
        });
    var $4b558b7c7a66fee2$export$2e2bcd8739ae039 = $4b558b7c7a66fee2$var$mapDispatchToProps;
});
parcelRegister("ikH4h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a24539623b49be96$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $bZA5o = parcelRequire("bZA5o");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    const $a24539623b49be96$var$mapStateToProps = (0, $3YtPS.createSelector)([
        (0, $bZA5o.getIssueGoalARIs),
        (0, $iIikD.getFilters),
        (0, $bZA5o.getDefinedGoals)
    ], (issueGoalARIs, { [(0, $cGbfF.GOAL_FILTER_ID)]: { id: id, value: value } }, definedGoalsByARI)=>({
            definedGoalsByARI: definedGoalsByARI,
            issueGoalARIs: issueGoalARIs,
            id: id,
            value: value
        }));
    var $a24539623b49be96$export$2e2bcd8739ae039 = $a24539623b49be96$var$mapStateToProps;
});
parcelRegister("crJCb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd19cd73bf5bafd4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $1I7E8;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $4R6GH;
    var $ousew;
    var $koVbs;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $cGbfF = parcelRequire("cGbfF");
    var $aIMtT = parcelRequire("aIMtT");
    var $2Ywmz;
    var $3uePO;
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $b4WKR = parcelRequire("b4WKR");
    const $fd19cd73bf5bafd4$var$GoalFilter = ({ clearGoalsFilter: clearGoalsFilter, value: value, searchQuery: searchQuery, onOpenChange: onOpenChange, isOpen: isOpen, onQueryChange: onQueryChange, changeGoalsFilter: changeGoalsFilter, issueGoalARIs: issueGoalARIs, definedGoalsByARI: definedGoalsByARI })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isGoalsSelected = !(0, ($parcel$interopDefault($gccSB)))(definedGoalsByARI) && value.length > 0;
        const onGoalClick = (id)=>{
            if (isGoalSelected(id)) changeGoalsFilter(value.filter((goalId)=>goalId !== id));
            else changeGoalsFilter([
                ...value,
                id
            ]);
        };
        const constructFilterText = ()=>{
            const goalNames = value.flatMap((goalARI)=>{
                const definedGoal = definedGoalsByARI[goalARI];
                return definedGoal.name;
            });
            const sortedGoalNames = goalNames.sort();
            return sortedGoalNames.join(', ');
        };
        const renderFilterText = ()=>{
            if (isGoalsSelected) {
                const filterText = constructFilterText();
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: filterText
                });
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $b4WKR.default).emptyPlaceholder);
        };
        const ariaText = ()=>{
            const filterText = isGoalsSelected ? constructFilterText() : formatMessage((0, $b4WKR.default).emptyPlaceholder);
            return `${formatMessage((0, $darOt.default)[0, $cGbfF.GOAL_FILTER_ID])}, ${filterText} ${formatMessage((0, $darOt.default).selected)}`;
        };
        const isGoalSelected = (goalARI)=>value.includes(goalARI);
        const filterGoalsWithSearchQuery = (goalARI)=>{
            const definedGoal = definedGoalsByARI[goalARI];
            return definedGoal ? definedGoal.name.toLowerCase().includes(searchQuery.toLowerCase()) : false;
        };
        const filteredGoalARIs = issueGoalARIs.filter(filterGoalsWithSearchQuery);
        if ((0, (0, parcelRequire("4R6GH")).fg)('migrate_plan_filter_to_popup')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            placement: "bottom-start",
            shouldReturnFocus: true,
            shouldRenderToParent: true,
            isOpen: isOpen,
            onClose: ()=>onOpenChange({
                    isOpen: false
                }),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter",
            trigger: ({ ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                    ...triggerProps,
                    ref: ref,
                    isOpen: isOpen,
                    onOpenChange: onOpenChange,
                    triggerButtonText: renderFilterText(),
                    testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter.trigger-btn",
                    ariaLabel: ariaText()
                }),
            content: ({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: isGoalsSelected,
                    onClearClick: clearGoalsFilter
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    setInitialFocusRef: setInitialFocusRef,
                    placeholder: formatMessage((0, $b4WKR.default).searchGoalsPlaceholder),
                    searchQuery: searchQuery,
                    onQueryChange: onQueryChange
                }), filteredGoalARIs.map((goalARI)=>{
                    const { name: name, state: state } = definedGoalsByARI[goalARI];
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: goalARI
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        id: `${goalARI}`,
                        isChecked: isGoalSelected(goalARI),
                        onChange: ()=>onGoalClick(goalARI),
                        label: state !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                            xcss: $fd19cd73bf5bafd4$var$filterItemContentStyles
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Ywmz")).GoalIcon), {
                            state: state.value
                        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                            xcss: $fd19cd73bf5bafd4$var$goalNameWrapperStyles
                        }, name), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uePO")).GoalTracker), {
                            label: state.label,
                            value: state.value,
                            score: state.score
                        })) : name
                    }));
                }), filteredGoalARIs.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null))
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            noPaddings: true,
            maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
            minWidth: (0, $3iCBQ.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                isVisible: isGoalsSelected,
                onClearClick: clearGoalsFilter
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                placeholder: formatMessage((0, $b4WKR.default).searchGoalsPlaceholder),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange
            }), filteredGoalARIs.map((goalARI)=>{
                const { name: name, state: state } = definedGoalsByARI[goalARI];
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                    key: goalARI
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    id: `${goalARI}`,
                    isChecked: isGoalSelected(goalARI),
                    onChange: ()=>onGoalClick(goalARI),
                    label: state !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                        xcss: $fd19cd73bf5bafd4$var$filterItemContentStyles
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Ywmz")).GoalIcon), {
                        state: state.value
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                        xcss: $fd19cd73bf5bafd4$var$goalNameWrapperStyles
                    }, name), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uePO")).GoalTracker), {
                        label: state.label,
                        value: state.value,
                        score: state.score
                    })) : name
                }));
            }), filteredGoalARIs.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null)),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            triggerButtonText: renderFilterText(),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter.trigger-btn",
            ariaLabel: ariaText()
        }));
    };
    const $fd19cd73bf5bafd4$var$filterItemContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        lineHeight: '24px',
        display: 'flex',
        flexDirection: 'row',
        maxWidth: '390px'
    });
    const $fd19cd73bf5bafd4$var$goalNameWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        marginLeft: 'space.050',
        marginRight: 'space.050'
    });
    var $fd19cd73bf5bafd4$export$2e2bcd8739ae039 = $fd19cd73bf5bafd4$var$GoalFilter;
});
parcelRegister("b4WKR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a2c0bc4a851a168$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6a2c0bc4a851a168$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchGoalsPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter.search-goals-placeholder",
            "defaultMessage": "Show issues from goals"
        }
    });
});
parcelRegister("gGJs5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e81c0e8d76003ad4$export$2e2bcd8739ae039);
    var $bC2fB;
    var $8Pklj = parcelRequire("8Pklj");
    var $eDXJI = parcelRequire("eDXJI");
    var $1QIXB = parcelRequire("1QIXB");
    var $e81c0e8d76003ad4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $eDXJI.default), (0, $8Pklj.default))((0, $1QIXB.default));
});
parcelRegister("8Pklj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e38d95773cd675f$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    var $7K8Pq = parcelRequire("7K8Pq");
    const $8e38d95773cd675f$var$mapDispatchToProps = (dispatch)=>({
            onHierarchyChange: (payload)=>{
                dispatch((0, $7K8Pq.clearInlineCreate)());
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.HIERARCHY_FILTER_ID),
                    value: {
                        start: payload.start + 1,
                        end: payload.end + 1
                    }
                }));
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
                    value: payload
                }));
            }
        });
    var $8e38d95773cd675f$export$2e2bcd8739ae039 = $8e38d95773cd675f$var$mapDispatchToProps;
});
parcelRegister("eDXJI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e11ecc579c420693$export$2e2bcd8739ae039);
    var $7bnpM = parcelRequire("7bnpM");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $3YtPS = parcelRequire("3YtPS");
    var $e11ecc579c420693$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $6Ayrn.getHierarchyLevels),
        (0, $7bnpM.getHierarchyFilter)
    ], (hierarchy, { id: id, value: { start: start, end: end } })=>({
            id: id,
            hierarchy: hierarchy,
            start: start,
            end: end
        }));
});
parcelRegister("1QIXB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb5de8934d4ac1ae$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7ThHn;
    var $9U6ZH;
    var $5iJtk;
    var $sqeVT;
    var $4R6GH;
    var $koVbs;
    var $cB0Hq;
    var $52ura;
    var $itmJb;
    var $cCp0W = parcelRequire("cCp0W");
    var $9nVCT = parcelRequire("9nVCT");
    var $25CAr = parcelRequire("25CAr");
    const $fb5de8934d4ac1ae$var$comparator = (0, parcelRequire("7ThHn")).default((0, parcelRequire("5iJtk")).default);
    function $fb5de8934d4ac1ae$var$HierarchyFilter({ end: end, hierarchy: hierarchy, id: id, onHierarchyChange: onHierarchyChange, start: start }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const handleOnChange = (selection)=>{
            if (selection.start && selection.end) onHierarchyChange({
                start: selection.start.value,
                end: selection.end.value
            });
        };
        const hierarchyLevelRangeItems = hierarchy.map(({ level: level, title: title })=>({
                content: title,
                id: level,
                value: level
            }));
        let rangeSelectorProps = {
            groups: [
                {
                    id: id,
                    items: hierarchyLevelRangeItems
                }
            ],
            comparator: $fb5de8934d4ac1ae$var$comparator,
            onChange: handleOnChange
        };
        const startItem = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('value', start), hierarchyLevelRangeItems);
        const endItem = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('value', end), hierarchyLevelRangeItems);
        if (startItem) rangeSelectorProps = {
            ...rangeSelectorProps,
            start: {
                ...startItem,
                label: formatMessage((0, $9nVCT.default).topHierarchyLevelLabel),
                name: 'topHierarchyLevel',
                showTooltip: true
            }
        };
        if (endItem) rangeSelectorProps = {
            ...rangeSelectorProps,
            end: {
                ...endItem,
                label: formatMessage((0, $9nVCT.default).bottomHierarchyLevelLabel),
                name: 'bottomHierarchyLevel',
                showTooltip: true
            }
        };
        const shouldDisplayHierarchyLink = (0, (0, parcelRequire("4R6GH")).fg)('eou_plans_filters_hierachy_link') && isAdmin;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("4R6GH")).fg)('eou_plans_filters_hierachy_link') ? $25CAr.hierarchyFilter : $25CAr.hierarchyFilterLegacy
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("52ura")).default), rangeSelectorProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cB0Hq")).default), {
            footerContent: shouldDisplayHierarchyLink ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cCp0W.default), null) : undefined,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.from",
            ariaLabel: formatMessage((0, $9nVCT.default).hierarchyFrom)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $25CAr.separator
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cB0Hq")).default), {
            footerContent: shouldDisplayHierarchyLink ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cCp0W.default), null) : undefined,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.to",
            ariaLabel: formatMessage((0, $9nVCT.default).hierarchyTo)
        })));
    }
    var $fb5de8934d4ac1ae$export$2e2bcd8739ae039 = $fb5de8934d4ac1ae$var$HierarchyFilter;
});
parcelRegister("7ThHn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5beb6603f842bf01$export$2e2bcd8739ae039);
    var $ccUYa;
    var $5beb6603f842bf01$var$comparator = (0, (0, parcelRequire("ccUYa")).default)(function comparator(pred) {
        return function(a, b) {
            return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
        };
    });
    var $5beb6603f842bf01$export$2e2bcd8739ae039 = $5beb6603f842bf01$var$comparator;
});
parcelRegister("5iJtk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3dc1e7f7a10af4da$export$2e2bcd8739ae039);
    var $c9RLn;
    var $3dc1e7f7a10af4da$var$gt = (0, (0, parcelRequire("c9RLn")).default)(function gt(a, b) {
        return a > b;
    });
    var $3dc1e7f7a10af4da$export$2e2bcd8739ae039 = $3dc1e7f7a10af4da$var$gt;
});
parcelRegister("cB0Hq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$112faa13181324da$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4Rr1a;
    var $fVnbM;
    var $aRoVz;
    var $6Ingq;
    var $dC5iT;
    var $8CUq3;
    var $1iMQ1;
    class $112faa13181324da$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                defaultValue: null,
                isLoading: false,
                groups: [],
                onChange: ()=>{},
                placement: 'bottom-start',
                testId: ''
            };
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.defaultValue !== nextProps.defaultValue) this.setState(()=>({
                    selectedItem: nextProps.defaultValue
                }));
        }
        render() {
            const { groups: groups = [], isLoading: isLoading, placement: placement, placeholder: placeholder, testId: testId } = this.props;
            const { selectedItem: selectedItem } = this.state;
            const { footerContent: footerContent, defaultOpen: defaultOpen } = this.props;
            let buttonContent = placeholder !== null && placeholder !== undefined ? placeholder : 'Select from a list';
            if (selectedItem) buttonContent = selectedItem.content;
            const triggerContent = ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ref: triggerRef,
                    ...props,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: ""
                    }),
                    "aria-label": this.props.ariaLabel
                }, buttonContent);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).default), {
                defaultOpen: defaultOpen,
                isLoading: isLoading,
                placement: placement,
                testId: testId,
                trigger: triggerContent
            }, (0, parcelRequire("4Rr1a")).default(this.createGroupElement, groups), footerContent && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $112faa13181324da$var$FooterStyles
            }, footerContent));
        }
        constructor(...args){
            super(...args);
            this.state = {
                selectedItem: this.props.defaultValue
            };
            this.handleClick = (item, group, e)=>{
                this.setState({
                    selectedItem: item
                });
                if (this.props.onChange) this.props.onChange(item, group, e);
            };
            this.createItemElement = (item, group)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                    key: item.id,
                    onClick: (e)=>this.handleClick(item, group, e),
                    title: item.tooltipDescription,
                    ...item
                }, item.content);
            this.createGroupElement = (group)=>{
                const itemElements = (0, parcelRequire("4Rr1a")).default((item)=>this.createItemElement(item, group), group.items);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                    key: group.id,
                    title: group.heading
                }, itemElements);
            };
        }
    }
    const $112faa13181324da$var$FooterStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTopColor: 'color.border',
        borderTopStyle: 'solid',
        borderTopWidth: 'border.width',
        position: 'sticky',
        backgroundColor: 'elevation.surface.overlay',
        bottom: 'space.0'
    });
});
parcelRegister("52ura", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d563d49f75afa9c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7ThHn;
    var $5WJLw;
    var $7O4UO;
    var $3bDjY;
    class $d563d49f75afa9c1$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                comparator: (0, parcelRequire("7ThHn")).default((0, parcelRequire("5WJLw")).default),
                onChange: ()=>{}
            };
        }
        getStartSelectProps() {
            const { groups: groups, start: start, end: end, comparator: comparator, onChange: onRangeChange } = this.props;
            const newGroups = groups.map(({ items: items, ...group })=>({
                    ...group,
                    items: items.map((item)=>({
                            ...item,
                            isDisabled: end ? comparator(item.value, end.value) > 0 : false
                        }))
                }));
            return {
                groups: newGroups,
                defaultValue: start,
                onChange: (item)=>onRangeChange({
                        start: item,
                        end: end
                    })
            };
        }
        getEndSelectProps() {
            const { groups: groups, start: start, end: end, comparator: comparator, onChange: onRangeChange } = this.props;
            const newGroups = groups.map(({ items: items, ...group })=>({
                    ...group,
                    items: items.map((item)=>({
                            ...item,
                            isDisabled: start ? comparator(start.value, item.value) > 0 : false
                        }))
                }));
            return {
                groups: newGroups,
                defaultValue: end,
                onChange: (item)=>onRangeChange({
                        start: start,
                        end: item
                    })
            };
        }
        render() {
            const { children: children, end: end, start: start } = this.props;
            const [startSelect, separator, endSelect] = children;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.getSelectComponent(start, (0, $5uXOq.cloneElement)(startSelect, this.getStartSelectProps())), separator, this.getSelectComponent(end, (0, $5uXOq.cloneElement)(endSelect, this.getEndSelectProps())));
        }
        constructor(...args){
            super(...args);
            this.getSelectComponent = (level, itemSelectEl)=>{
                if (level && level.label && level.name) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    label: level.label,
                    name: level.name
                }, ()=>{
                    if (level.showTooltip) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                        content: level.content
                    }, itemSelectEl);
                    return itemSelectEl;
                });
                return itemSelectEl;
            };
        }
    }
});
parcelRegister("5WJLw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4545de96c7565cb2$export$2e2bcd8739ae039);
    var $c9RLn;
    var $4545de96c7565cb2$var$lt = (0, (0, parcelRequire("c9RLn")).default)(function lt(a, b) {
        return a < b;
    });
    var $4545de96c7565cb2$export$2e2bcd8739ae039 = $4545de96c7565cb2$var$lt;
});
parcelRegister("cCp0W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$389d8105a94247a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $hDzhb;
    var $9nVCT = parcelRequire("9nVCT");
    const $389d8105a94247a1$var$HierarchyLink = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'click',
                actionSubject: 'hierarchyLink'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.hierarchy-link.hierarchy-link",
            component: $389d8105a94247a1$var$CustomComponentButton,
            onClick: onClick
        }, formatMessage((0, $9nVCT.default).hierarchyFooterLink));
    };
    const $389d8105a94247a1$var$CustomComponentButton = (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
            ...props,
            ref: ref,
            href: "/jira/settings/issues/issue-hierarchy"
        }, children));
    var $389d8105a94247a1$export$2e2bcd8739ae039 = $389d8105a94247a1$var$HierarchyLink;
});
parcelRegister("9nVCT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07bbe24cef8dcecc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $07bbe24cef8dcecc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        topHierarchyLevelLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.top-hierarchy-level-label",
            "defaultMessage": "From"
        },
        bottomHierarchyLevelLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.bottom-hierarchy-level-label",
            "defaultMessage": "To"
        },
        hierarchyFrom: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.hierarchy-from",
            "defaultMessage": "Hierarchy from:"
        },
        hierarchyTo: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.hierarchy-to",
            "defaultMessage": "Hierarchy to:"
        },
        hierarchyFooterLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.hierarchy-footer-link",
            "defaultMessage": "Configure hierarchy"
        }
    });
});
parcelRegister("25CAr", function(module, exports) {
    $parcel$export(module.exports, "hierarchyFilter", ()=>$1859fae8db6f4da9$export$a1a07870f153942d, (v)=>$1859fae8db6f4da9$export$a1a07870f153942d = v);
    $parcel$export(module.exports, "hierarchyFilterLegacy", ()=>$1859fae8db6f4da9$export$ab86d56d0160e929, (v)=>$1859fae8db6f4da9$export$ab86d56d0160e929 = v);
    $parcel$export(module.exports, "separator", ()=>$1859fae8db6f4da9$export$3e523c77c1f23f8c, (v)=>$1859fae8db6f4da9$export$3e523c77c1f23f8c = v);
    var $1859fae8db6f4da9$export$a1a07870f153942d;
    var $1859fae8db6f4da9$export$ab86d56d0160e929;
    var $1859fae8db6f4da9$export$3e523c77c1f23f8c;
    $1859fae8db6f4da9$export$a1a07870f153942d = `SBxuMW_hierarchyFilter`;
    $1859fae8db6f4da9$export$ab86d56d0160e929 = `SBxuMW_hierarchyFilterLegacy`;
    $1859fae8db6f4da9$export$3e523c77c1f23f8c = `SBxuMW_separator`;
});
parcelRegister("jHgLR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e290261387bcdd50$export$2e2bcd8739ae039);
    var $bC2fB;
    var $dPqu3 = parcelRequire("dPqu3");
    var $dbvx8 = parcelRequire("dbvx8");
    var $j30js = parcelRequire("j30js");
    var $e290261387bcdd50$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $dbvx8.default), (0, $dPqu3.default))((0, $j30js.default));
});
parcelRegister("dPqu3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd040947bfc98d8e$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $bd040947bfc98d8e$var$mapDispatchToProps = (dispatch)=>({
            changeFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.IDEA_FILTER_ID),
                    value: payload
                }));
            },
            clearFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.IDEA_FILTER_ID)));
            }
        });
    var $bd040947bfc98d8e$export$2e2bcd8739ae039 = $bd040947bfc98d8e$var$mapDispatchToProps;
});
parcelRegister("dbvx8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab29210bc571e324$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    const $ab29210bc571e324$var$mapStateToProps = (0, $3YtPS.createSelector)((0, $iIikD.getFilters), ({ [(0, $cGbfF.IDEA_FILTER_ID)]: { id: id, value: value } })=>({
            id: id,
            value: value
        }));
    var $ab29210bc571e324$export$2e2bcd8739ae039 = $ab29210bc571e324$var$mapStateToProps;
});
parcelRegister("j30js", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95b8976a5b205b3d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $apXzN;
    var $4T9Cd;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $cGbfF = parcelRequire("cGbfF");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $cQrCD = parcelRequire("cQrCD");
    const $95b8976a5b205b3d$var$FilteredIdeas = ({ value: value, changeFilter: changeFilter, searchQuery: searchQuery })=>{
        const [associatedIssues] = (0, (0, parcelRequire("apXzN")).useAssociatedIssues)();
        const isIdeaSelected = (id)=>value.includes(id);
        const onIdeaClicked = (id)=>{
            if (isIdeaSelected(id)) changeFilter(value.filter((ideaId)=>ideaId !== id));
            else changeFilter([
                ...value,
                id
            ]);
        };
        const summaryFilter = (ideaId)=>{
            if (!associatedIssues) return false;
            const idea = associatedIssues[ideaId];
            return idea ? idea.summary.toLowerCase().includes(searchQuery.toLowerCase()) : false;
        };
        const filteredAssociatedIssueIds = associatedIssues ? Object.keys(associatedIssues).filter(summaryFilter) : [];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, filteredAssociatedIssueIds.map((associatedIssueId)=>{
            if (!associatedIssues) return null;
            const issue = associatedIssues[associatedIssueId];
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                key: associatedIssueId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                id: `${associatedIssueId}`,
                isChecked: isIdeaSelected(associatedIssueId),
                onChange: ()=>onIdeaClicked(associatedIssueId),
                label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4T9Cd")).AssociatedIssuesView), {
                    associatedIssues: [
                        issue
                    ]
                })
            }));
        }), filteredAssociatedIssueIds.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
    };
    const $95b8976a5b205b3d$var$constructFilterText = (value, associatedIssues)=>value.map((issueId)=>associatedIssues[issueId]).filter(Boolean).map((issue)=>issue.summary).sort().join(', ');
    const $95b8976a5b205b3d$var$IdeaFilter = ({ clearFilter: clearFilter, value: value, searchQuery: searchQuery, onOpenChange: onOpenChange, isOpen: isOpen, onQueryChange: onQueryChange, changeFilter: changeFilter })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [associatedIssuesInStore] = (0, (0, parcelRequire("apXzN")).useAssociatedIssues)();
        const associatedIssues = associatedIssuesInStore || {};
        const isSelected = value.length > 0;
        const renderFilterText = ()=>{
            if (isSelected) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                text: $95b8976a5b205b3d$var$constructFilterText(value, associatedIssues)
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cQrCD.default).emptyPlaceholder);
        };
        const ariaText = ()=>{
            const filterText = isSelected ? $95b8976a5b205b3d$var$constructFilterText(value, associatedIssues) : formatMessage((0, $cQrCD.default).emptyPlaceholder);
            return `${formatMessage((0, $darOt.default)[0, $cGbfF.IDEA_FILTER_ID])}, ${filterText} ${formatMessage((0, $darOt.default).selected)}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            noPaddings: true,
            maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
            minWidth: (0, $3iCBQ.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                isVisible: isSelected,
                onClearClick: clearFilter
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                placeholder: formatMessage((0, $cQrCD.default).searchIdeasPlaceholder),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($95b8976a5b205b3d$var$FilteredIdeas, {
                value: value,
                changeFilter: changeFilter,
                searchQuery: searchQuery
            })),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.idea-filter.idea-filter"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            triggerButtonText: renderFilterText(),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.idea-filter.trigger-btn",
            ariaLabel: ariaText()
        }));
    };
    var $95b8976a5b205b3d$export$2e2bcd8739ae039 = $95b8976a5b205b3d$var$IdeaFilter;
});
parcelRegister("cQrCD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$176c80da516acecd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $176c80da516acecd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.idea-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchIdeasPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.idea-filter.search-ideas-placeholder",
            "defaultMessage": "Show issues from ideas"
        }
    });
});
parcelRegister("6n5IZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7afc323932633b20$export$2e2bcd8739ae039);
    var $cSD7y;
    var $bC2fB;
    var $8nPA3 = parcelRequire("8nPA3");
    var $b1nZi = parcelRequire("b1nZi");
    var $20Y4Y = parcelRequire("20Y4Y");
    var $89qOS = parcelRequire("89qOS");
    const $7afc323932633b20$var$OldComponent = (0, (0, parcelRequire("bC2fB")).connect)((0, $b1nZi.default), (0, $8nPA3.default))((0, $20Y4Y.default));
    const $7afc323932633b20$var$NewComponent = (0, (0, parcelRequire("bC2fB")).connect)((0, $b1nZi.default), (0, $8nPA3.default))((0, $89qOS.default));
    var $7afc323932633b20$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('migrate_plan_filter_to_popup', $7afc323932633b20$var$NewComponent, $7afc323932633b20$var$OldComponent);
});
parcelRegister("8nPA3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f2c9621f125d51f7$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $f2c9621f125d51f7$var$mapDispatchToProps = (dispatch)=>({
            changeIssuePrioritiesFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID),
                    value: payload
                }));
            },
            clearIssuePrioritiesFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID)));
            }
        });
    var $f2c9621f125d51f7$export$2e2bcd8739ae039 = $f2c9621f125d51f7$var$mapDispatchToProps;
});
parcelRegister("b1nZi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cab96c8f18b22a05$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $io4Ja = parcelRequire("io4Ja");
    var $cGbfF = parcelRequire("cGbfF");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $cab96c8f18b22a05$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $io4Ja.getIssuePriorities),
        (0, $iIikD.getFilters),
        (0, $io4Ja.getIssuePrioritiesIdList),
        (0, $io4Ja.getIssuePriorities)
    ], (issuePriorities, { [(0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID)]: { id: id, value: value } }, issuePrioritiesIdList, prioritiesById)=>({
            id: id,
            value: value,
            issuePriorities: (0, $4nDwW.isDefined)(issuePrioritiesIdList) ? issuePrioritiesIdList.map((id)=>prioritiesById[id]) : Object.values(issuePriorities)
        }));
});
parcelRegister("20Y4Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ed498dd6eb436ac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cTYeP;
    var $jVZZA;
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $i2qlb = parcelRequire("i2qlb");
    var $cGbfF = parcelRequire("cGbfF");
    var $aIMtT = parcelRequire("aIMtT");
    var $2OMDV;
    var $8zOmE;
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $hitlf = parcelRequire("hitlf");
    var $c94kS = parcelRequire("c94kS");
    parcelRequire("8qxM8");
    var $darOt = parcelRequire("darOt");
    var $fNtKX = parcelRequire("fNtKX");
    const $0ed498dd6eb436ac$var$CheckboxWithAnalytics = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('checkbox', {
        onChange: 'changed'
    })((0, (0, parcelRequire("fAGMJ")).default));
    class $0ed498dd6eb436ac$var$IssuePrioritiesFilter extends (0, $5uXOq.Component) {
        render() {
            const { intl: intl, isOpen: isOpen, value: value, searchQuery: searchQuery, onOpenChange: onOpenChange, onQueryChange: onQueryChange, clearIssuePrioritiesFilter: clearIssuePrioritiesFilter } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                noPaddings: true,
                maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
                minWidth: (0, $3iCBQ.FILTER_WIDTH),
                onClose: onOpenChange,
                isOpen: isOpen,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: !!value.length,
                    onClearClick: clearIssuePrioritiesFilter
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    placeholder: intl.formatMessage((0, $fNtKX.default).searchPriorityPlaceholder),
                    searchQuery: searchQuery,
                    onQueryChange: onQueryChange,
                    ariaLabel: intl.formatMessage((0, $fNtKX.default).searchPriorityLabel)
                }), this.getIssuePriorities()),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                triggerButtonText: this.renderFilterText(),
                ariaLabel: this.ariaText(),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter.trigger-btn"
            }));
        }
        constructor(...args){
            super(...args);
            this.constructFilterText = ()=>{
                const { issuePriorities: issuePriorities, value: value } = this.props;
                return issuePriorities.filter(({ id: id })=>(0, parcelRequire("cTYeP")).default(id, value)).map(({ name: name })=>name).join(', ');
            };
            this.renderFilterText = ()=>{
                const { value: value } = this.props;
                return value.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: this.constructFilterText()
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $fNtKX.default).emptyPlaceholder);
            };
            this.ariaText = ()=>{
                const { value: value, intl: intl } = this.props;
                const filterText = this.constructFilterText();
                return `${intl.formatMessage((0, $darOt.default)[0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $fNtKX.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
            };
            this.isIssuePrioritySelected = (issuePriorityId)=>(0, parcelRequire("cTYeP")).default(issuePriorityId, this.props.value);
            this.filterIssueTypesWithSearchQuery = (issuePriority)=>issuePriority.name.toLowerCase().includes(this.props.searchQuery.toLowerCase());
            this.getIssuePrioritiesOrder = (issuePriorityIds)=>{
                const { issuePriorities: issuePriorities } = this.props;
                return issuePriorities.filter(({ id: id })=>issuePriorityIds.includes(id)).map((_, index)=>index);
            };
            this.onIssuePriorityClick = (issuePriorityId, analyticsEvent)=>{
                const { value: value, changeIssuePrioritiesFilter: changeIssuePrioritiesFilter } = this.props;
                let issuePriorityIds;
                if (this.isIssuePrioritySelected(issuePriorityId)) {
                    issuePriorityIds = (0, parcelRequire("jVZZA")).default((issuePriority)=>issuePriority !== issuePriorityId, value);
                    changeIssuePrioritiesFilter(issuePriorityIds);
                } else {
                    issuePriorityIds = [
                        ...value,
                        issuePriorityId
                    ];
                    changeIssuePrioritiesFilter(issuePriorityIds);
                }
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATED_ISSUE_PRIORITIES_FILTER.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: action,
                    actionSubject: actionSubject
                }), {
                    issuePrioritiesOrder: this.getIssuePrioritiesOrder(issuePriorityIds)
                });
            };
            this.getIssuePrioritiesOptions = (issuePriorities)=>issuePriorities.map(({ name: name, id: id, iconUrl: iconUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: id
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement($0ed498dd6eb436ac$var$CheckboxWithAnalytics, {
                        id: `${id}`,
                        key: id,
                        isChecked: this.isIssuePrioritySelected(id),
                        onChange: (_, analyticsEvent)=>this.onIssuePriorityClick(id, analyticsEvent),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hitlf.default), {
                            avatarUrl: iconUrl,
                            id: id,
                            name: name,
                            appearance: "square",
                            size: "xsmall"
                        })
                    })));
            this.getIssuePriorities = ()=>{
                const { issuePriorities: issuePriorities } = this.props;
                const filteredIssuePriorities = issuePriorities.filter(this.filterIssueTypesWithSearchQuery);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.getIssuePrioritiesOptions(filteredIssuePriorities), filteredIssuePriorities.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
            };
        }
    }
    var $0ed498dd6eb436ac$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($0ed498dd6eb436ac$var$IssuePrioritiesFilter);
});
parcelRegister("fNtKX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87a723e063c69ea3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $87a723e063c69ea3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchPriorityPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter.search-priority-placeholder",
            "defaultMessage": "Show issues from issue priority"
        },
        searchPriorityLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter.search-priority-label",
            "defaultMessage": "Choose from priorities"
        }
    });
});
parcelRegister("89qOS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40e23a81e1c83577$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $ousew;
    var $koVbs;
    var $fAGMJ;
    var $6SblS;
    var $i2qlb = parcelRequire("i2qlb");
    var $cGbfF = parcelRequire("cGbfF");
    var $aIMtT = parcelRequire("aIMtT");
    var $2OMDV;
    var $8zOmE;
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $b7IdY = parcelRequire("b7IdY");
    var $hitlf = parcelRequire("hitlf");
    var $c94kS = parcelRequire("c94kS");
    parcelRequire("8qxM8");
    var $darOt = parcelRequire("darOt");
    var $fNtKX = parcelRequire("fNtKX");
    const $40e23a81e1c83577$var$CheckboxWithAnalytics = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('checkbox', {
        onChange: 'changed'
    })((0, (0, parcelRequire("fAGMJ")).default));
    function $40e23a81e1c83577$var$IssuePrioritiesFilter({ issuePriorities: issuePriorities, value: value, searchQuery: searchQuery, changeIssuePrioritiesFilter: changeIssuePrioritiesFilter, isOpen: isOpen, onOpenChange: onOpenChange, onQueryChange: onQueryChange, clearIssuePrioritiesFilter: clearIssuePrioritiesFilter }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const constructFilterText = ()=>{
            return issuePriorities.filter(({ id: id })=>value.includes(id)).map(({ name: name })=>name).join(', ');
        };
        const renderFilterText = ()=>{
            return value.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                text: constructFilterText()
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $fNtKX.default).emptyPlaceholder);
        };
        const ariaText = ()=>{
            const filterText = constructFilterText();
            return `${formatMessage((0, $darOt.default)[0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID])}, ${value.length > 0 ? filterText : formatMessage((0, $fNtKX.default).emptyPlaceholder)} ${formatMessage((0, $darOt.default).selected)}`;
        };
        const isIssuePrioritySelected = (issuePriorityId)=>value.includes(issuePriorityId);
        const filterIssueTypesWithSearchQuery = (issuePriority)=>issuePriority.name.toLowerCase().includes(searchQuery.toLowerCase());
        const getIssuePrioritiesOrder = (issuePriorityIds)=>{
            return issuePriorities.filter(({ id: id })=>issuePriorityIds.includes(id)).map((_, index)=>index);
        };
        const onIssuePriorityClick = (issuePriorityId, analyticsEvent)=>{
            let issuePriorityIds;
            if (isIssuePrioritySelected(issuePriorityId)) {
                issuePriorityIds = value.filter((issuePriority)=>issuePriority !== issuePriorityId);
                changeIssuePrioritiesFilter(issuePriorityIds);
            } else {
                issuePriorityIds = [
                    ...value,
                    issuePriorityId
                ];
                changeIssuePrioritiesFilter(issuePriorityIds);
            }
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATED_ISSUE_PRIORITIES_FILTER.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), {
                issuePrioritiesOrder: getIssuePrioritiesOrder(issuePriorityIds)
            });
        };
        const getIssuePrioritiesOptions = (filteredIssuePriorities)=>filteredIssuePriorities.map(({ name: name, id: id, iconUrl: iconUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                    key: id
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($40e23a81e1c83577$var$CheckboxWithAnalytics, {
                    id: `${id}`,
                    key: id,
                    isChecked: isIssuePrioritySelected(id),
                    onChange: (_, analyticsEvent)=>onIssuePriorityClick(id, analyticsEvent),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hitlf.default), {
                        avatarUrl: iconUrl,
                        id: id,
                        name: name,
                        appearance: "square",
                        size: "xsmall"
                    })
                })));
        const getIssuePriorities = ()=>{
            const filteredIssuePriorities = issuePriorities.filter(filterIssueTypesWithSearchQuery);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, getIssuePrioritiesOptions(filteredIssuePriorities), filteredIssuePriorities.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            placement: "bottom-start",
            isOpen: isOpen,
            shouldUseCaptureOnOutsideClick: true,
            shouldRenderToParent: true,
            autoFocus: true,
            onClose: ()=>{
                onOpenChange({
                    isOpen: false
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: !!value.length,
                    onClearClick: clearIssuePrioritiesFilter
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    placeholder: formatMessage((0, $fNtKX.default).searchPriorityPlaceholder),
                    searchQuery: searchQuery,
                    onQueryChange: onQueryChange,
                    ariaLabel: formatMessage((0, $fNtKX.default).searchPriorityLabel),
                    setInitialFocusRef: setInitialFocusRef
                }), getIssuePriorities()),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter",
            trigger: ({ ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                    ...triggerProps,
                    ref: ref,
                    isOpen: isOpen,
                    onOpenChange: onOpenChange,
                    triggerButtonText: renderFilterText(),
                    ariaLabel: ariaText(),
                    testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter.trigger-btn"
                })
        });
    }
    var $40e23a81e1c83577$export$2e2bcd8739ae039 = $40e23a81e1c83577$var$IssuePrioritiesFilter;
});
parcelRegister("4JCNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f7edb0eb25c1491$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3gmNL = parcelRequire("3gmNL");
    var $lNHbm = parcelRequire("lNHbm");
    var $4CbZ5 = parcelRequire("4CbZ5");
    var $0f7edb0eb25c1491$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $lNHbm.default), (0, $3gmNL.default))((0, $4CbZ5.default));
});
parcelRegister("3gmNL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1f726b5fdf4c90a$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $b1f726b5fdf4c90a$var$mapDispatchToProps = (dispatch)=>({
            changeIssueTypeKeyFilter: (value)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID),
                    value: value
                }));
            },
            clearIssueTypeKeyFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID)));
            }
        });
    var $b1f726b5fdf4c90a$export$2e2bcd8739ae039 = $b1f726b5fdf4c90a$var$mapDispatchToProps;
});
parcelRegister("lNHbm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3566f649669dcfe9$export$2e2bcd8739ae039);
    var $fn8B5 = parcelRequire("fn8B5");
    var $kGsr8 = parcelRequire("kGsr8");
    var $hHRm5 = parcelRequire("hHRm5");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $kllqP = parcelRequire("kllqP");
    var $3YtPS = parcelRequire("3YtPS");
    const $3566f649669dcfe9$export$cdd41b88f440e95a = (hierarchyTitles, issueTypeIconByKey, issueTypeById)=>{
        const issueTypeByLevel = (0, ($parcel$interopDefault($fn8B5)))(Object.values(issueTypeById), ({ level: level })=>level);
        return Object.entries(issueTypeByLevel).sort(([firstLevel], [secondLevel])=>Number(secondLevel) - Number(firstLevel)).reduce((acc, [level, issueTypes])=>{
            const aggregatedIssueTypes = (0, ($parcel$interopDefault($kGsr8)))(issueTypes.map(({ name: name })=>name)).sort().map((name)=>({
                    name: name,
                    iconUrl: issueTypeIconByKey[`${level} ${name}`] ?? '#'
                }));
            const aggregatedIssueTypeHierarchy = {
                level: Number(level),
                title: hierarchyTitles[Number(level)] ?? '',
                issueTypes: aggregatedIssueTypes
            };
            acc.push(aggregatedIssueTypeHierarchy);
            return acc;
        }, []);
    };
    const $3566f649669dcfe9$var$getAggregatedIssueTypeHierarchies = (0, $3YtPS.createSelector)([
        (0, $6Ayrn.getHierarchyTitles),
        (0, $kllqP.getIssueTypeIconByKey),
        (0, $6Ayrn.getIssueTypeWithLevelById)
    ], $3566f649669dcfe9$export$cdd41b88f440e95a);
    const $3566f649669dcfe9$var$mapStateToProps = (state)=>({
            value: (0, $hHRm5.getIssueTypeKeyFilterValue)(state),
            aggregatedIssueTypeHierarchy: $3566f649669dcfe9$var$getAggregatedIssueTypeHierarchies(state)
        });
    var $3566f649669dcfe9$export$2e2bcd8739ae039 = $3566f649669dcfe9$var$mapStateToProps;
});
parcelRegister("4CbZ5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4bac30f3d0a293c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Ot1C = parcelRequire("5Ot1C");
    var $koVbs;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $hitlf = parcelRequire("hitlf");
    parcelRequire("8qxM8");
    var $fdPSg = parcelRequire("fdPSg");
    var $aD1Xg = parcelRequire("aD1Xg");
    const $4bac30f3d0a293c1$var$IssueTypeKeyFilter = ({ value: value, aggregatedIssueTypeHierarchy: aggregatedIssueTypeHierarchy, searchQuery: searchQuery, isOpen: isOpen, onOpenChange: onOpenChange, onQueryChange: onQueryChange, changeIssueTypeKeyFilter: changeIssueTypeKeyFilter, clearIssueTypeKeyFilter: clearIssueTypeKeyFilter })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getValueMatcher = (level, name)=>(currentValue)=>currentValue.level === level && currentValue.name === name;
        const onIssueTypeKeyClick = (level, name, isChecked)=>{
            if (isChecked) changeIssueTypeKeyFilter((0, ($parcel$interopDefault($5Ot1C)))(value, getValueMatcher(level, name)));
            else changeIssueTypeKeyFilter([
                ...value,
                {
                    level: level,
                    name: name
                }
            ]);
        };
        const renderIssueTypeKeyOptions = (level, aggregatedIssueTypes)=>aggregatedIssueTypes.map(({ name: name, iconUrl: iconUrl })=>{
                const isChecked = value.some(getValueMatcher(level, name));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                    key: name
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    isChecked: isChecked,
                    onChange: ()=>onIssueTypeKeyClick(level, name, isChecked),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hitlf.default), {
                        avatarUrl: iconUrl,
                        name: name,
                        appearance: "square",
                        size: "xsmall"
                    })
                }));
            });
        const renderIssueTypeKeyGroups = ()=>{
            const groupItems = aggregatedIssueTypeHierarchy.map(({ level: level, title: title, issueTypes: issueTypes })=>{
                const filtered = issueTypes.filter(({ name: name })=>name.toLowerCase().includes(searchQuery.toLowerCase()));
                if (filtered.length === 0) return null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuGroup), {
                    heading: title,
                    key: level
                }, renderIssueTypeKeyOptions(level, filtered));
            }).filter((groupItem)=>groupItem !== null);
            return groupItems.length > 0 ? groupItems : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            noPaddings: true,
            maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
            minWidth: (0, $3iCBQ.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                isVisible: value.length > 0,
                onClearClick: clearIssueTypeKeyFilter
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                placeholder: formatMessage((0, $fdPSg.default).searchIssueTypePlaceholder),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange,
                ariaLabel: formatMessage((0, $fdPSg.default).searchIssueTypeLabel)
            }), renderIssueTypeKeyGroups()),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-types-key-filter"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aD1Xg.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            value: value,
            aggregatedIssueTypeHierarchy: aggregatedIssueTypeHierarchy
        }));
    };
    var $4bac30f3d0a293c1$export$2e2bcd8739ae039 = $4bac30f3d0a293c1$var$IssueTypeKeyFilter;
});
parcelRegister("5Ot1C", function(module, exports) {
    var $2GdQn = parcelRequire("2GdQn");
    var $8BRGu = parcelRequire("8BRGu");
    var $bxDef = parcelRequire("bxDef");
    var $8LQ84 = parcelRequire("8LQ84");
    var $jGJpR = parcelRequire("jGJpR");
    function $43b82310b1b35f52$var$reject(collection, predicate) {
        var func = $8LQ84(collection) ? $2GdQn : $8BRGu;
        return func(collection, $jGJpR($bxDef(predicate, 3)));
    }
    module.exports = $43b82310b1b35f52$var$reject;
});
parcelRegister("8BRGu", function(module, exports) {
    var $e7pfQ = parcelRequire("e7pfQ");
    function $644b6c0ae483a6c5$var$baseFilter(collection, predicate) {
        var result = [];
        $e7pfQ(collection, function(value, index, collection) {
            if (predicate(value, index, collection)) result.push(value);
        });
        return result;
    }
    module.exports = $644b6c0ae483a6c5$var$baseFilter;
});
parcelRegister("fdPSg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$833216d299cec3fb$export$2e2bcd8739ae039);
    var $7VHMR;
    var $833216d299cec3fb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchIssueTypePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-types-key-filter.search-issue-type-placeholder",
            "defaultMessage": "Show issues from issue types"
        },
        searchIssueTypeLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-types-key-filter.search-issue-type-label",
            "defaultMessage": "Choose from issue types"
        }
    });
});
parcelRegister("aD1Xg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$720b83cc29eb74be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $cGbfF = parcelRequire("cGbfF");
    var $ae7BI = parcelRequire("ae7BI");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $dJOV1 = parcelRequire("dJOV1");
    const $720b83cc29eb74be$var$IssueTypesFilterTrigger = ({ value: value, aggregatedIssueTypeHierarchy: aggregatedIssueTypeHierarchy, isOpen: isOpen, onOpenChange: onOpenChange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const validValues = value.filter(({ level: level, name: name })=>aggregatedIssueTypeHierarchy.find(({ level: hierarchyLevel })=>level === hierarchyLevel)?.issueTypes.some(({ name: aggregatedName })=>name === aggregatedName) ?? false);
        const filteredIssueTypeNames = validValues.map(({ name: name })=>name).join(', ');
        const triggerLabel = validValues.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
            text: filteredIssueTypeNames
        }) : formatMessage((0, $dJOV1.default).placeholder);
        const ariaLabel = `${formatMessage((0, $darOt.default)[0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID])}, ${validValues.length > 0 ? filteredIssueTypeNames : formatMessage((0, $dJOV1.default).placeholder)} ${formatMessage((0, $darOt.default).selected)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            triggerButtonText: triggerLabel,
            ariaLabel: ariaLabel,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-types-key-filter.trigger"
        });
    };
    var $720b83cc29eb74be$export$2e2bcd8739ae039 = $720b83cc29eb74be$var$IssueTypesFilterTrigger;
});
parcelRegister("dJOV1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2ba3f3ad561e1ce$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d2ba3f3ad561e1ce$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-types-key-filter.trigger.placeholder",
            "defaultMessage": "All"
        }
    });
});
parcelRegister("fHkGj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73cb05743b9f901e$export$2e2bcd8739ae039);
    var $bC2fB;
    var $aVJa0 = parcelRequire("aVJa0");
    var $vAPl1 = parcelRequire("vAPl1");
    var $ck9bf = parcelRequire("ck9bf");
    var $73cb05743b9f901e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $vAPl1.default), (0, $aVJa0.default))((0, $ck9bf.IssueWarningFilter));
});
parcelRegister("aVJa0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d750ae611e0200a5$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $d750ae611e0200a5$var$mapDispatchToProps = (dispatch)=>({
            onWarningFilterChange: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.ISSUE_WARNING_FILTER_ID),
                    value: payload
                }));
            },
            onClearWarningFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.ISSUE_WARNING_FILTER_ID)));
            }
        });
    var $d750ae611e0200a5$export$2e2bcd8739ae039 = $d750ae611e0200a5$var$mapDispatchToProps;
});
parcelRegister("vAPl1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f2eabbe77a778f0$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    const $0f2eabbe77a778f0$var$mapStateToProps = (0, $3YtPS.createSelector)([
        (0, $iIikD.getFilters)
    ], ({ [(0, $cGbfF.ISSUE_WARNING_FILTER_ID)]: { id: id, value: value } })=>({
            id: id,
            value: value
        }));
    var $0f2eabbe77a778f0$export$2e2bcd8739ae039 = $0f2eabbe77a778f0$var$mapStateToProps;
});
parcelRegister("ck9bf", function(module, exports) {
    $parcel$export(module.exports, "IssueWarningFilter", ()=>$949c2d9dff4e3fad$export$3813e023bf5ce236);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $4R6GH;
    var $koVbs;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $qjIxt = parcelRequire("qjIxt");
    var $cGbfF = parcelRequire("cGbfF");
    var $la6bP = parcelRequire("la6bP");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $bdvCx = parcelRequire("bdvCx");
    const $949c2d9dff4e3fad$var$WarningMenuItem = ({ warningType: warningType, messages: messages, value: value, onWarningFilterChange: onWarningFilterChange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onChange = (0, $5uXOq.useCallback)(()=>onWarningFilterChange(value.includes(warningType) ? value.filter((x)=>x !== warningType) : [
                ...value,
                warningType
            ]), [
            onWarningFilterChange,
            warningType,
            value
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
            key: warningType
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            id: warningType,
            key: warningType,
            isChecked: value.includes(warningType),
            onChange: onChange,
            label: formatMessage(messages.header)
        }));
    };
    const $949c2d9dff4e3fad$export$3813e023bf5ce236 = ({ value: value, onWarningFilterChange: onWarningFilterChange, onClearWarningFilter: onClearWarningFilter, onOpenChange: onOpenChange, isOpen: isOpen })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const filterText = (0, $5uXOq.useMemo)(()=>value.length > 0 ? value.map((id)=>(0, $qjIxt.WarningTypes)[id]).filter((messages)=>messages !== undefined).map((messages)=>formatMessage(messages.header)).join(', ') : '', [
            value,
            formatMessage
        ]);
        return (0, (0, parcelRequire("4R6GH")).fg)('migrate_plan_filter_to_popup') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: ()=>onOpenChange({
                    isOpen: false
                }),
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: true,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-warning-filter",
            placement: "bottom-start",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: !!value.length,
                    onClearClick: onClearWarningFilter
                }), Object.entries((0, $qjIxt.WarningTypes)).map(([warningType, messages])=>{
                    if (!(0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline') && warningType === (0, $la6bP.START_DATE_AFTER_END_DATE)) return null;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement($949c2d9dff4e3fad$var$WarningMenuItem, {
                        key: warningType,
                        warningType: warningType,
                        messages: messages,
                        value: value,
                        onWarningFilterChange: onWarningFilterChange
                    });
                })),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                    ...triggerProps,
                    isOpen: isOpen,
                    onOpenChange: onOpenChange,
                    testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-warning-filter.trigger-btn",
                    triggerButtonText: value.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                        text: filterText
                    }) : formatMessage((0, $bdvCx.default).emptyPlaceholder),
                    ariaLabel: `${formatMessage((0, $darOt.default)[0, $cGbfF.ISSUE_WARNING_FILTER_ID])}, ${value.length > 0 ? filterText : formatMessage((0, $bdvCx.default).emptyPlaceholder)} ${formatMessage((0, $darOt.default).selected)}`
                })
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            noPaddings: true,
            maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
            minWidth: (0, $3iCBQ.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                isVisible: !!value.length,
                onClearClick: onClearWarningFilter
            }), Object.entries((0, $qjIxt.WarningTypes)).map(([warningType, messages])=>{
                if (!(0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline') && warningType === (0, $la6bP.START_DATE_AFTER_END_DATE)) return null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement($949c2d9dff4e3fad$var$WarningMenuItem, {
                    key: warningType,
                    warningType: warningType,
                    messages: messages,
                    value: value,
                    onWarningFilterChange: onWarningFilterChange
                });
            })),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-warning-filter"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-warning-filter.trigger-btn",
            triggerButtonText: value.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                text: filterText
            }) : formatMessage((0, $bdvCx.default).emptyPlaceholder),
            ariaLabel: `${formatMessage((0, $darOt.default)[0, $cGbfF.ISSUE_WARNING_FILTER_ID])}, ${value.length > 0 ? filterText : formatMessage((0, $bdvCx.default).emptyPlaceholder)} ${formatMessage((0, $darOt.default).selected)}`
        }));
    };
});
parcelRegister("bdvCx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa307d17bdac52cb$export$2e2bcd8739ae039);
    var $7VHMR;
    var $aa307d17bdac52cb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-warning-filter.empty-placeholder",
            "defaultMessage": "All issues"
        }
    });
});
parcelRegister("lvX0J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05e07cd1aaccc220$export$2e2bcd8739ae039);
    var $bC2fB;
    var $2NTLH = parcelRequire("2NTLH");
    var $a5YTj = parcelRequire("a5YTj");
    var $4gP1r = parcelRequire("4gP1r");
    var $05e07cd1aaccc220$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $a5YTj.default), (0, $2NTLH.default))((0, $4gP1r.default));
});
parcelRegister("2NTLH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32a0aa3b8a9b9b9d$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $32a0aa3b8a9b9b9d$var$mapDispatchToProps = (dispatch)=>({
            changeFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.LABEL_FILTER_ID),
                    value: payload
                }));
            },
            clearFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.LABEL_FILTER_ID)));
            }
        });
    var $32a0aa3b8a9b9b9d$export$2e2bcd8739ae039 = $32a0aa3b8a9b9b9d$var$mapDispatchToProps;
});
parcelRegister("a5YTj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0efc9675d64bf4c7$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $abnJk = parcelRequire("abnJk");
    var $cGbfF = parcelRequire("cGbfF");
    const $0efc9675d64bf4c7$var$mapStateToProps = (state)=>{
        const labels = (0, $abnJk.getIssueLabels)(state);
        const { [(0, $cGbfF.LABEL_FILTER_ID)]: { id: id, value: value } } = (0, $iIikD.getFilters)(state);
        return {
            id: id,
            value: value,
            labels: labels
        };
    };
    var $0efc9675d64bf4c7$export$2e2bcd8739ae039 = $0efc9675d64bf4c7$var$mapStateToProps;
});
parcelRegister("4gP1r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6010533e6275e9ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cTYeP;
    var $jVZZA;
    var $1I7E8;
    var $4R6GH;
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $kHGzZ = parcelRequire("kHGzZ");
    var $cGbfF = parcelRequire("cGbfF");
    var $8JOG8 = parcelRequire("8JOG8");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $8qxM8 = parcelRequire("8qxM8");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $aEQb5 = parcelRequire("aEQb5");
    class $6010533e6275e9ad$var$LabelFilter extends (0, $5uXOq.Component) {
        render() {
            const { intl: intl, labels: labels, onOpenChange: onOpenChange, isOpen: isOpen, value: value, clearFilter: clearFilter, searchQuery: searchQuery, onQueryChange: onQueryChange } = this.props;
            const searchResultLabels = labels.filter(this.filterLabelsWithSearchQuery);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('migrate_plan_filter_to_popup')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                noPaddings: true,
                maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
                minWidth: (0, $3iCBQ.FILTER_WIDTH),
                onClose: onOpenChange,
                isOpen: isOpen,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: !!value.length,
                    onClearClick: clearFilter
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    placeholder: intl.formatMessage((0, $aEQb5.default).searchLabelsPlaceholder),
                    searchQuery: searchQuery,
                    onQueryChange: onQueryChange,
                    ariaLabel: intl.formatMessage((0, $aEQb5.default).searchLabelsAriaLabel)
                }), !!searchResultLabels.length && this.renderNoLabel(), this.renderLabels(searchResultLabels)),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.trigger-btn",
                triggerButtonText: this.renderFilterText(),
                ariaLabel: this.ariaText()
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: isOpen,
                placement: "bottom-start",
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: true,
                onClose: ()=>{
                    onOpenChange({
                        isOpen: false
                    });
                },
                content: (contentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                        isVisible: !!value.length,
                        onClearClick: clearFilter
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                        placeholder: intl.formatMessage((0, $aEQb5.default).searchLabelsPlaceholder),
                        searchQuery: searchQuery,
                        onQueryChange: onQueryChange,
                        ariaLabel: intl.formatMessage((0, $aEQb5.default).searchLabelsAriaLabel),
                        setInitialFocusRef: contentProps.setInitialFocusRef
                    }), !!searchResultLabels.length && this.renderNoLabel(), this.renderLabels(searchResultLabels)),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter",
                trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                        ...triggerProps,
                        isOpen: isOpen,
                        onOpenChange: onOpenChange,
                        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.trigger-btn",
                        triggerButtonText: this.renderFilterText(),
                        ariaLabel: this.ariaText()
                    })
            });
        }
        constructor(...args){
            super(...args);
            this.constructFilterText = ()=>{
                const { labels: labels, value: value, intl: intl } = this.props;
                const filteredValues = labels.filter((label)=>(0, parcelRequire("cTYeP")).default(label, value));
                return (0, parcelRequire("cTYeP")).default((0, $kHGzZ.NO_LABEL_ID), value) ? [
                    intl.formatMessage({
                        ...(0, $aEQb5.default).noLabelsFilterText
                    }),
                    ...filteredValues
                ].join(', ') : filteredValues.join(', ');
            };
            this.renderFilterText = ()=>{
                const { value: value } = this.props;
                const filterText = this.constructFilterText();
                return value.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: filterText
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $aEQb5.default).emptyPlaceholder);
            };
            this.ariaText = ()=>{
                const { value: value, intl: intl } = this.props;
                const filterText = this.constructFilterText();
                return `${intl.formatMessage((0, $darOt.default)[0, $cGbfF.LABEL_FILTER_ID])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $aEQb5.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
            };
            this.isLabelSelected = (label)=>(0, parcelRequire("cTYeP")).default(label, this.props.value);
            this.filterLabelsWithSearchQuery = (label)=>label.toLowerCase().includes(this.props.searchQuery.toLowerCase());
            this.onLabelClick = (clickedLabel)=>{
                const { value: value, changeFilter: changeFilter } = this.props;
                if (this.isLabelSelected(clickedLabel)) changeFilter((0, parcelRequire("jVZZA")).default((label)=>label !== clickedLabel, value));
                else changeFilter([
                    ...value,
                    clickedLabel
                ]);
            };
            this.renderNoLabel = ()=>{
                const { intl: intl } = this.props;
                const name = intl.formatMessage({
                    ...(0, $aEQb5.default).noLabelsFilterText
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    id: (0, $kHGzZ.NO_LABEL_ID),
                    key: (0, $kHGzZ.NO_LABEL_ID),
                    isChecked: this.isLabelSelected((0, $kHGzZ.NO_LABEL_ID)),
                    onChange: ()=>this.onLabelClick((0, $kHGzZ.NO_LABEL_ID)),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                        content: name,
                        id: (0, $kHGzZ.NO_LABEL_ID)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                        className: $8qxM8.checkboxLabel
                    }, name))
                }));
            };
            this.renderLabels = (searchResultLabels)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, searchResultLabels.map((label, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: label
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        id: `${index}`,
                        key: index,
                        isChecked: this.isLabelSelected(label),
                        onChange: ()=>this.onLabelClick(label),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                            content: label,
                            id: index
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $8qxM8.checkboxLabel
                        }, label))
                    }))), searchResultLabels.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
        }
    }
    var $6010533e6275e9ad$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($6010533e6275e9ad$var$LabelFilter);
});
parcelRegister("aEQb5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1dc190e8c84d9cc3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1dc190e8c84d9cc3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchLabelsPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.search-labels-placeholder",
            "defaultMessage": "Show issues from labels"
        },
        noLabelsFilterText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.no-labels-filter-text",
            "defaultMessage": "No label"
        },
        searchLabelsAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.search-labels-aria-label",
            "defaultMessage": "Choose from labels"
        }
    });
});
parcelRegister("iwDde", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b540514862ba1f0e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jylWu = parcelRequire("jylWu");
    const $b540514862ba1f0e$var$FilterOptions = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jylWu.default), null));
    var $b540514862ba1f0e$export$2e2bcd8739ae039 = $b540514862ba1f0e$var$FilterOptions;
});
parcelRegister("jylWu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de32657afbb8d73a$export$2e2bcd8739ae039);
    var $bC2fB;
    var $5oxYR = parcelRequire("5oxYR");
    var $bOHM6 = parcelRequire("bOHM6");
    var $ftF5T = parcelRequire("ftF5T");
    var $de32657afbb8d73a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $bOHM6.default), (0, $5oxYR.default))((0, $ftF5T.default));
});
parcelRegister("5oxYR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65c4ee7fd727bde1$export$2e2bcd8739ae039);
    var $8Lnid = parcelRequire("8Lnid");
    const $65c4ee7fd727bde1$var$mapDispatchToProps = (dispatch)=>({
            toggleShowFullHierarchy: ()=>{
                dispatch((0, $8Lnid.toggleShowFullHierarchy)());
            }
        });
    var $65c4ee7fd727bde1$export$2e2bcd8739ae039 = $65c4ee7fd727bde1$var$mapDispatchToProps;
});
parcelRegister("bOHM6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42d70bd37904c971$export$2e2bcd8739ae039);
    var $gl667 = parcelRequire("gl667");
    var $3YtPS = parcelRequire("3YtPS");
    const $42d70bd37904c971$var$mapStateToProps = (0, $3YtPS.createSelector)([
        (0, $gl667.getShowFullHierarchy)
    ], (showFullHierarchy)=>({
            showFullHierarchy: showFullHierarchy
        }));
    var $42d70bd37904c971$export$2e2bcd8739ae039 = $42d70bd37904c971$var$mapStateToProps;
});
parcelRegister("ftF5T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be6cdb1bef9c99ec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $fAGMJ;
    var $33yHi = parcelRequire("33yHi");
    class $be6cdb1bef9c99ec$var$ShowFullHierarchyOption extends (0, $5uXOq.Component) {
        render() {
            const { showFullHierarchy: showFullHierarchy, intl: intl } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                onChange: this.toggleShowFullHierarchy,
                label: intl.formatMessage((0, $33yHi.default).showFullHierarchy),
                isChecked: showFullHierarchy
            });
        }
        constructor(...args){
            super(...args);
            this.toggleShowFullHierarchy = ()=>{
                this.props.toggleShowFullHierarchy();
            };
        }
    }
    var $be6cdb1bef9c99ec$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($be6cdb1bef9c99ec$var$ShowFullHierarchyOption);
});
parcelRegister("33yHi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a29071d647f0492$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7a29071d647f0492$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        showFullHierarchy: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.options.show-full-hierarchy.show-full-hierarchy",
            "defaultMessage": "Show full hierarchy"
        }
    });
});
parcelRegister("fRUVe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c81b744610f83f68$export$2e2bcd8739ae039);
    var $bC2fB;
    var $gguYm = parcelRequire("gguYm");
    var $5BdXI = parcelRequire("5BdXI");
    var $hFOPH = parcelRequire("hFOPH");
    var $c81b744610f83f68$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $5BdXI.default), (0, $gguYm.default))((0, $hFOPH.default));
});
parcelRegister("gguYm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c713ae7489bda940$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $c713ae7489bda940$var$mapDispatchToProps = (dispatch)=>({
            changeProjectFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.PROJECT_FILTER_ID),
                    value: payload
                }));
            },
            clearProjectFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.PROJECT_FILTER_ID)));
            }
        });
    var $c713ae7489bda940$export$2e2bcd8739ae039 = $c713ae7489bda940$var$mapDispatchToProps;
});
parcelRegister("5BdXI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a423fe127f664f74$export$2e2bcd8739ae039);
    var $b1yMp;
    var $2rMKg;
    var $h35CY;
    var $hpnKp;
    var $iIikD = parcelRequire("iIikD");
    var $jpXKt = parcelRequire("jpXKt");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $a423fe127f664f74$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $jpXKt.getProjects),
        (0, $iIikD.getFilters)
    ], (projects, { [(0, $cGbfF.PROJECT_FILTER_ID)]: { id: id, value: value } })=>({
            id: id,
            value: value,
            projects: (0, parcelRequire("h35CY")).default((0, parcelRequire("b1yMp")).default((0, parcelRequire("hpnKp")).default, (0, parcelRequire("2rMKg")).default('name')))(projects)
        }));
});
parcelRegister("hFOPH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7150c2d430f457a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b1yMp;
    var $cTYeP;
    var $jVZZA;
    var $gfe9F;
    var $3DBzg;
    var $2rMKg;
    var $hpnKp;
    var $1I7E8;
    var $4R6GH;
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $cGbfF = parcelRequire("cGbfF");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $hitlf = parcelRequire("hitlf");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $jm6kV = parcelRequire("jm6kV");
    class $c7150c2d430f457a$var$ProjectFilter extends (0, $5uXOq.Component) {
        render() {
            const { intl: intl, onOpenChange: onOpenChange, isOpen: isOpen, value: value, clearProjectFilter: clearProjectFilter, searchQuery: searchQuery, onQueryChange: onQueryChange } = this.props;
            if (!(0, (0, parcelRequire("4R6GH")).fg)('migrate_plan_filter_to_popup')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                noPaddings: true,
                maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
                minWidth: (0, $3iCBQ.FILTER_WIDTH),
                onClose: onOpenChange,
                isOpen: isOpen,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: !!value.length,
                    onClearClick: clearProjectFilter
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    placeholder: intl.formatMessage((0, $jm6kV.default).searchProjectPlaceholder),
                    searchQuery: searchQuery,
                    onQueryChange: onQueryChange,
                    ariaLabel: intl.formatMessage((0, $jm6kV.default).searchProjectLabel)
                }), this.renderProjectGroups()),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter.trigger-btn",
                triggerButtonText: this.renderFilterText(),
                ariaLabel: this.ariaText()
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: isOpen,
                placement: "bottom-start",
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: true,
                onClose: ()=>{
                    onOpenChange({
                        isOpen: false
                    });
                },
                content: (contentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                        isVisible: !!value.length,
                        onClearClick: clearProjectFilter
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                        placeholder: intl.formatMessage((0, $jm6kV.default).searchProjectPlaceholder),
                        searchQuery: searchQuery,
                        onQueryChange: onQueryChange,
                        ariaLabel: intl.formatMessage((0, $jm6kV.default).searchProjectLabel),
                        setInitialFocusRef: contentProps.setInitialFocusRef
                    }), this.renderProjectGroups()),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter",
                trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                        ...triggerProps,
                        isOpen: isOpen,
                        onOpenChange: onOpenChange,
                        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter.trigger-btn",
                        triggerButtonText: this.renderFilterText(),
                        ariaLabel: this.ariaText()
                    })
            });
        }
        constructor(...args){
            super(...args);
            this.constructFilterText = ()=>{
                const { projects: projects, value: value } = this.props;
                return projects.filter(({ id: id })=>(0, parcelRequire("cTYeP")).default(id, value)).map(({ name: name })=>name).join(', ');
            };
            this.renderFilterText = ()=>{
                const { value: value } = this.props;
                const filterText = this.constructFilterText();
                return value.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: filterText
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $jm6kV.default).emptyPlaceholder);
            };
            this.ariaText = ()=>{
                const { value: value, intl: intl } = this.props;
                const filterText = this.constructFilterText();
                return `${intl.formatMessage((0, $darOt.default)[0, $cGbfF.PROJECT_FILTER_ID])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $jm6kV.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
            };
            this.isProjectSelected = (projectId)=>(0, parcelRequire("cTYeP")).default(projectId, this.props.value);
            this.filterProjectsWithSearchQuery = (project)=>{
                const queryMatchProp = (0, parcelRequire("b1yMp")).default((0, parcelRequire("3DBzg")).default((0, parcelRequire("hpnKp")).default(this.props.searchQuery)), (0, parcelRequire("hpnKp")).default, (0, parcelRequire("gfe9F")).default((0, parcelRequire("2rMKg")).default)(project));
                return queryMatchProp('name') || queryMatchProp('key');
            };
            this.onProjectClick = (projectId)=>{
                const { value: value, changeProjectFilter: changeProjectFilter } = this.props;
                if (this.isProjectSelected(projectId)) changeProjectFilter((0, parcelRequire("jVZZA")).default((project)=>project !== projectId, value));
                else changeProjectFilter([
                    ...value,
                    projectId
                ]);
            };
            this.renderProjectGroups = ()=>{
                const searchResultProjects = this.props.projects.filter(this.filterProjectsWithSearchQuery);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, searchResultProjects.map(({ id: id, key: key, name: name, avatarUrl: avatarUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: id
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        id: `${id}`,
                        key: id,
                        isChecked: this.isProjectSelected(id),
                        onChange: ()=>this.onProjectClick(id),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hitlf.default), {
                            avatarUrl: avatarUrl,
                            id: id,
                            projectKey: key,
                            name: name
                        })
                    }))), searchResultProjects.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
            };
        }
    }
    var $c7150c2d430f457a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($c7150c2d430f457a$var$ProjectFilter);
});
parcelRegister("jm6kV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e5a0c8c78aa09798$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e5a0c8c78aa09798$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchProjectPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter.search-project-placeholder",
            "defaultMessage": "Show issues from projects"
        },
        searchProjectLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter.search-project-label",
            "defaultMessage": "Choose from projects"
        }
    });
});
parcelRegister("lT095", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c40e4a46fb53361$export$2e2bcd8739ae039);
    var $bC2fB;
    var $cElAb = parcelRequire("cElAb");
    var $iCdVK = parcelRequire("iCdVK");
    var $gqAC4 = parcelRequire("gqAC4");
    var $7c40e4a46fb53361$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $iCdVK.default), (0, $cElAb.default))((0, $gqAC4.default));
});
parcelRegister("cElAb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$565008bf6708058c$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    var $565008bf6708058c$export$2e2bcd8739ae039 = (dispatch)=>({
            changeReleaseFilter: (id, payload)=>{
                dispatch((0, $834it.change)({
                    id: id,
                    value: payload
                }));
            },
            clearReleaseFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID)));
                dispatch((0, $834it.clear)((0, $cGbfF.RELEASE_FILTER_ID)));
            }
        });
});
parcelRegister("iCdVK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a68ecf30284ad328$export$2e2bcd8739ae039);
    var $jw86H = parcelRequire("jw86H");
    var $iIikD = parcelRequire("iIikD");
    var $jpXKt = parcelRequire("jpXKt");
    var $9FFuD = parcelRequire("9FFuD");
    var $cGbfF = parcelRequire("cGbfF");
    var $c33ef = parcelRequire("c33ef");
    var $3YtPS = parcelRequire("3YtPS");
    const $a68ecf30284ad328$var$mapStateToProps = (0, $3YtPS.createSelector)([
        (0, $jpXKt.getProjects),
        (0, $jw86H.getCrossProjectVersions),
        (0, $jw86H.getCrossProjectVersionsById),
        (0, $9FFuD.getVersionsById),
        (0, $iIikD.getFilters)
    ], (projects, crossProjectVersions, crossProjectVersionsById, versionsById, { [(0, $cGbfF.RELEASE_FILTER_ID)]: { id: id, value: value }, [(0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID)]: { value: crossProjectReleaseFilterValue = [] } })=>({
            id: id,
            value: value,
            crossProjectReleaseFilterValue: crossProjectReleaseFilterValue,
            crossProjectVersions: (0, $c33ef.sortAsLowerCaseByNameProp)(crossProjectVersions),
            projects: (0, $c33ef.sortAsLowerCaseByNameProp)(projects),
            versionsById: versionsById,
            crossProjectVersionsById: crossProjectVersionsById
        }));
    var $a68ecf30284ad328$export$2e2bcd8739ae039 = $a68ecf30284ad328$var$mapStateToProps;
});
parcelRegister("c33ef", function(module, exports) {
    $parcel$export(module.exports, "sortAsLowerCaseByNameProp", ()=>$8a38c47a81ef33bd$export$93166931f01f58c9);
    var $b1yMp;
    var $2rMKg;
    var $h35CY;
    var $hpnKp;
    const $8a38c47a81ef33bd$export$93166931f01f58c9 = (0, parcelRequire("h35CY")).default((0, parcelRequire("b1yMp")).default((0, parcelRequire("hpnKp")).default, (0, parcelRequire("2rMKg")).default('name')));
});
parcelRegister("gqAC4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$757a1398ace0e1d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cTYeP;
    var $jVZZA;
    var $3nPAF;
    var $lj8SI;
    var $1I7E8;
    var $4R6GH;
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $lz7VR = parcelRequire("lz7VR");
    var $cGbfF = parcelRequire("cGbfF");
    var $hA24D = parcelRequire("hA24D");
    var $c33ef = parcelRequire("c33ef");
    var $4nDwW = parcelRequire("4nDwW");
    var $8JOG8 = parcelRequire("8JOG8");
    var $ihPUd = parcelRequire("ihPUd");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $8qxM8 = parcelRequire("8qxM8");
    var $hitlf = parcelRequire("hitlf");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $aLCXC = parcelRequire("aLCXC");
    var $keD28 = parcelRequire("keD28");
    class $757a1398ace0e1d0$var$ReleaseFilter extends (0, $5uXOq.Component) {
        render() {
            const { intl: intl, onOpenChange: onOpenChange, isOpen: isOpen, searchQuery: searchQuery } = this.props;
            const searchResultsLength = this.getFilteredProjects().length + this.getFilteredCrossProjectVersions().length;
            const label = searchResultsLength > 0 ? intl.formatMessage((0, $aLCXC.default).searchResultsCount, {
                totalCount: searchResultsLength
            }) : intl.formatMessage((0, $ihPUd.default).noMatchFoundText);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('migrate_plan_filter_to_popup')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                noPaddings: true,
                maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
                minWidth: (0, $3iCBQ.FILTER_WIDTH),
                onClose: onOpenChange,
                isOpen: isOpen,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: this.shouldClearRenderButtonRender(),
                    onClearClick: this.onClearClick
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    placeholder: intl.formatMessage((0, $aLCXC.default).searchReleasesPlaceholder),
                    searchQuery: searchQuery,
                    ariaLabel: intl.formatMessage((0, $aLCXC.default).searchReleasesLabel),
                    onQueryChange: this.onSearchQueryChange
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hA24D.DelayedAnnouncer), {
                    ref: this.announcerRef,
                    label: label
                }), !(0, parcelRequire("3nPAF")).default(this.props.versionsById) && this.renderNoReleases(), this.renderCrossProjectReleasesGroup(), this.renderProjectGroups(), searchResultsLength === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null)),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                triggerButtonText: this.renderFilterText(),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.trigger-btn",
                ariaLabel: this.ariaText()
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: isOpen,
                placement: "bottom-start",
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: true,
                onClose: ()=>{
                    onOpenChange({
                        isOpen: false
                    });
                },
                content: (contentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                        isVisible: this.shouldClearRenderButtonRender(),
                        onClearClick: this.onClearClick
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                        placeholder: intl.formatMessage((0, $aLCXC.default).searchReleasesPlaceholder),
                        searchQuery: searchQuery,
                        ariaLabel: intl.formatMessage((0, $aLCXC.default).searchReleasesLabel),
                        onQueryChange: this.onSearchQueryChange,
                        setInitialFocusRef: contentProps.setInitialFocusRef
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hA24D.DelayedAnnouncer), {
                        ref: this.announcerRef,
                        label: label
                    }), !(0, parcelRequire("3nPAF")).default(this.props.versionsById) && this.renderNoReleases(), this.renderCrossProjectReleasesGroup(), this.renderProjectGroups(), searchResultsLength === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null)),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter",
                trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                        ...triggerProps,
                        isOpen: isOpen,
                        onOpenChange: onOpenChange,
                        triggerButtonText: this.renderFilterText(),
                        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.trigger-btn",
                        ariaLabel: this.ariaText()
                    })
            });
        }
        constructor(...args){
            super(...args);
            this.announcerRef = (0, $5uXOq.createRef)();
            this.onVersionClick = (id, isSelected)=>{
                const { value: value, changeReleaseFilter: changeReleaseFilter } = this.props;
                if (isSelected) changeReleaseFilter((0, $cGbfF.RELEASE_FILTER_ID), [
                    ...value,
                    id
                ]);
                else changeReleaseFilter((0, $cGbfF.RELEASE_FILTER_ID), (0, parcelRequire("jVZZA")).default((version)=>version !== id, value));
            };
            this.onCrossProjectVersionClick = (id, isSelected)=>{
                const { crossProjectReleaseFilterValue: crossProjectReleaseFilterValue, changeReleaseFilter: changeReleaseFilter } = this.props;
                if (isSelected) changeReleaseFilter((0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID), [
                    ...crossProjectReleaseFilterValue,
                    id
                ]);
                else changeReleaseFilter((0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID), (0, parcelRequire("jVZZA")).default((version)=>version !== id, crossProjectReleaseFilterValue));
            };
            this.onClearClick = ()=>this.props.clearReleaseFilter();
            this.getVersion = (versionId)=>{
                const { versionsById: versionsById } = this.props;
                return versionsById[versionId];
            };
            this.filterProjectsWithSearchQuery = (project)=>project.versions.map(this.getVersion).some(this.filterVersionsWithSearchQuery);
            this.filterVersionsWithSearchQuery = (version)=>{
                const { name: name, crossProjectVersion: crossProjectVersion } = version;
                const { crossProjectVersionsById: crossProjectVersionsById, searchQuery: searchQuery } = this.props;
                if ((0, $4nDwW.isDefined)(crossProjectVersion) && (0, $4nDwW.isDefined)(crossProjectVersionsById[crossProjectVersion])) return name.toLowerCase().includes(searchQuery.toLowerCase()) || crossProjectVersionsById[crossProjectVersion].name.toLowerCase().includes(searchQuery.toLowerCase());
                return name.toLowerCase().includes(searchQuery.toLowerCase());
            };
            this.constructFilterText = ()=>{
                const { versionsById: versionsById, value: value, crossProjectVersions: crossProjectVersions, crossProjectReleaseFilterValue: crossProjectReleaseFilterValue, intl: intl } = this.props;
                const versionNames = (0, $c33ef.sortAsLowerCaseByNameProp)((0, $4nDwW.values)(versionsById)).filter(({ id: id })=>(0, parcelRequire("cTYeP")).default(id, value)).map(({ name: name })=>name);
                const crossProjectVersionNames = (0, $c33ef.sortAsLowerCaseByNameProp)(crossProjectVersions).filter(({ id: id })=>(0, parcelRequire("cTYeP")).default(id, crossProjectReleaseFilterValue)).map(({ name: name })=>name);
                if ((0, parcelRequire("cTYeP")).default((0, $lz7VR.NO_RELEASE_ID), value)) return [
                    intl.formatMessage({
                        ...(0, $aLCXC.default).noReleasesFilterText
                    }),
                    ...versionNames,
                    ...crossProjectVersionNames
                ].join(', ');
                return [
                    ...versionNames,
                    ...crossProjectVersionNames
                ].join(', ');
            };
            this.renderFilterText = ()=>{
                const { value: value, crossProjectReleaseFilterValue: crossProjectReleaseFilterValue } = this.props;
                const filterText = this.constructFilterText();
                return value.length > 0 || crossProjectReleaseFilterValue.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: filterText
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $aLCXC.default).emptyPlaceholder);
            };
            this.ariaText = ()=>{
                const { value: value, intl: intl } = this.props;
                const filterText = this.constructFilterText();
                return `${intl.formatMessage((0, $darOt.default)[0, $cGbfF.RELEASE_FILTER_ID])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $aLCXC.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
            };
            this.getFilteredCrossProjectVersions = ()=>{
                const { crossProjectVersions: crossProjectVersions, searchQuery: searchQuery } = this.props;
                return crossProjectVersions.filter(({ name: name })=>name.toLowerCase().includes(searchQuery.toLowerCase()));
            };
            this.renderCrossProjectReleasesGroup = ()=>{
                const { intl: intl, crossProjectReleaseFilterValue: crossProjectReleaseFilterValue } = this.props;
                const isSelected = (versionId)=>(0, parcelRequire("cTYeP")).default(versionId, crossProjectReleaseFilterValue);
                const filteredCrossProjectVersions = this.getFilteredCrossProjectVersions();
                if (filteredCrossProjectVersions.length === 0) return null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuGroup), {
                    heading: intl.formatMessage((0, $ihPUd.default).crossProjectReleases)
                }, filteredCrossProjectVersions.length > 0 && filteredCrossProjectVersions.map((version)=>{
                    const { id: id, name: name } = version;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: id
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        id: id,
                        key: id,
                        name: name,
                        isChecked: isSelected(id),
                        onChange: ()=>this.onCrossProjectVersionClick(id, !isSelected(id)),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                            id: id,
                            content: name
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $8qxM8.checkboxLabel
                        }, name))
                    }));
                }));
            };
            this.getFilteredProjects = ()=>{
                const { projects: projects } = this.props;
                return projects.filter((project)=>project.isReleasesEnabled && this.filterProjectsWithSearchQuery(project));
            };
            this.renderProjectGroups = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.getFilteredProjects().map(({ id: id, name: name, key: key, versions: versions, avatarUrl: avatarUrl })=>{
                    const projectTitle = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hitlf.default), {
                        avatarUrl: avatarUrl,
                        id: id,
                        projectKey: key,
                        name: name
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuGroup), {
                        heading: projectTitle,
                        key: id
                    }, this.renderVersionOptions(versions));
                }));
            this.renderVersionOptions = (versions)=>{
                const { value: value, crossProjectVersionsById: crossProjectVersionsById } = this.props;
                const isSelected = (versionId)=>(0, parcelRequire("cTYeP")).default(versionId, value);
                const sortedVersionObjects = (0, $c33ef.sortAsLowerCaseByNameProp)(versions.map(this.getVersion));
                return sortedVersionObjects.filter(this.filterVersionsWithSearchQuery).map((version)=>{
                    const { id: id, name: name, crossProjectVersion: crossProjectVersion } = version;
                    const doesHaveCrossProjectVersionThatIsNotDeleted = (0, $4nDwW.isDefined)(crossProjectVersion) && (0, $4nDwW.isDefined)(crossProjectVersionsById[crossProjectVersion]);
                    const crossProjectVersionName = doesHaveCrossProjectVersionThatIsNotDeleted ? crossProjectVersionsById[crossProjectVersion].name : '';
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: id
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        id: id,
                        key: id,
                        name: name,
                        isChecked: isSelected(id),
                        onChange: ()=>this.onVersionClick(id, !isSelected(id)),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $keD28.crossProjectReleaseOption
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $keD28.crossProjectReleaseName
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                            content: name,
                            id: id
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, name))), (0, $4nDwW.isDefined)(crossProjectVersion) && (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $keD28.crossProjectReleaseLozenge
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                            maxWidth: 100
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                            content: crossProjectVersionName
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, crossProjectVersionName)))))
                    }));
                });
            };
            this.renderNoReleases = ()=>{
                const { value: value, intl: intl } = this.props;
                const id = (0, $lz7VR.NO_RELEASE_ID);
                const name = intl.formatMessage({
                    ...(0, $aLCXC.default).noReleasesFilterText
                });
                const isSelected = (versionId)=>(0, parcelRequire("cTYeP")).default(versionId, value);
                const selected = isSelected(id);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    id: id,
                    key: id,
                    name: name,
                    isChecked: selected,
                    onChange: ()=>this.onVersionClick(id, !isSelected(id)),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                        content: name,
                        id: id
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                        className: $8qxM8.checkboxLabel
                    }, name))
                }));
            };
            this.shouldClearRenderButtonRender = ()=>{
                const { value: value, crossProjectReleaseFilterValue: crossProjectReleaseFilterValue } = this.props;
                if (!(value.length || crossProjectReleaseFilterValue.length)) return false;
                return true;
            };
            this.onSearchQueryChange = (query)=>{
                this.props.onQueryChange(query);
                this.announcerRef.current?.announce();
            };
        }
    }
    var $757a1398ace0e1d0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($757a1398ace0e1d0$var$ReleaseFilter);
});
parcelRegister("hA24D", function(module, exports) {
    $parcel$export(module.exports, "DelayedAnnouncer", ()=>$9f65368a57d92bee$export$92b86912c718fcf2);
    var $5uXOq = parcelRequire("5uXOq");
    var $jldZL;
    const $9f65368a57d92bee$export$92b86912c718fcf2 = (0, $5uXOq.forwardRef)(({ label: label, waitBeforeAnnouncement: waitBeforeAnnouncement = 300 }, ref)=>{
        const [isAnnounced, setIsAnnounced] = (0, $5uXOq.useState)(false);
        const announcementTrigger = (0, $5uXOq.useCallback)(()=>{
            setIsAnnounced(false);
            const timer = setTimeout(()=>{
                setIsAnnounced(true);
            }, waitBeforeAnnouncement);
            return ()=>clearTimeout(timer);
        }, [
            waitBeforeAnnouncement
        ]);
        (0, $5uXOq.useImperativeHandle)(ref, ()=>({
                announce: announcementTrigger
            }));
        (0, $5uXOq.useEffect)(announcementTrigger, [
            waitBeforeAnnouncement,
            announcementTrigger,
            label
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "status",
            "aria-live": "polite",
            "aria-atomic": "false"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: String(isAnnounced)
        }, label)));
    });
});
parcelRegister("aLCXC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$84f8f2e6e3118863$export$2e2bcd8739ae039);
    var $7VHMR;
    var $84f8f2e6e3118863$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchReleasesPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.search-releases-placeholder",
            "defaultMessage": "Show issues from releases"
        },
        noReleasesFilterText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.no-releases-filter-text",
            "defaultMessage": "No release"
        },
        searchReleasesLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.search-releases-label",
            "defaultMessage": "Choose from releases"
        },
        searchResultsCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.search-results-count",
            "defaultMessage": "{totalCount, plural, one {# suggestion} other {# suggestions}} available"
        }
    });
});
parcelRegister("keD28", function(module, exports) {
    $parcel$export(module.exports, "crossProjectReleaseLozenge", ()=>$ebb364a83db723cf$export$be8ecdd1dde7847a, (v)=>$ebb364a83db723cf$export$be8ecdd1dde7847a = v);
    $parcel$export(module.exports, "crossProjectReleaseName", ()=>$ebb364a83db723cf$export$ad543e317dba39b7, (v)=>$ebb364a83db723cf$export$ad543e317dba39b7 = v);
    $parcel$export(module.exports, "crossProjectReleaseOption", ()=>$ebb364a83db723cf$export$dd5faf32de3b1cad, (v)=>$ebb364a83db723cf$export$dd5faf32de3b1cad = v);
    var $ebb364a83db723cf$export$be8ecdd1dde7847a;
    var $ebb364a83db723cf$export$ad543e317dba39b7;
    var $ebb364a83db723cf$export$dd5faf32de3b1cad;
    $ebb364a83db723cf$export$be8ecdd1dde7847a = `mo_vea_crossProjectReleaseLozenge`;
    $ebb364a83db723cf$export$ad543e317dba39b7 = `mo_vea_crossProjectReleaseName`;
    $ebb364a83db723cf$export$dd5faf32de3b1cad = `mo_vea_crossProjectReleaseOption`;
});
parcelRegister("18IeQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec7f544df83660f8$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hOrsb = parcelRequire("hOrsb");
    var $f27Ae = parcelRequire("f27Ae");
    var $3cpPS = parcelRequire("3cpPS");
    var $ec7f544df83660f8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $f27Ae.default), (0, $hOrsb.default))((0, $3cpPS.default));
});
parcelRegister("hOrsb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44db4c7f8fb9b474$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $44db4c7f8fb9b474$var$mapDispatchToProps = (dispatch)=>({
            onRequestChange: (payload)=>dispatch((0, $834it.change)({
                    id: (0, $cGbfF.REPORTER_FILTER_ID),
                    value: payload
                })),
            onRequestClear: ()=>dispatch((0, $834it.clear)((0, $cGbfF.REPORTER_FILTER_ID)))
        });
    var $44db4c7f8fb9b474$export$2e2bcd8739ae039 = $44db4c7f8fb9b474$var$mapDispatchToProps;
});
parcelRegister("f27Ae", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$176560e14f69593a$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $hHrJz = parcelRequire("hHrJz");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    const $176560e14f69593a$var$mapStateToProps = (0, $3YtPS.createSelector)([
        (0, $hHrJz.getReporterForFilter),
        (0, $iIikD.getFilters)
    ], (reporters, { [(0, $cGbfF.REPORTER_FILTER_ID)]: { id: id, value: value } })=>({
            id: id,
            value: value,
            reporters: reporters
        }));
    var $176560e14f69593a$export$2e2bcd8739ae039 = $176560e14f69593a$var$mapStateToProps;
});
parcelRegister("3cpPS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b0a4413d7cd32c7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8EB5I;
    var $jVZZA;
    var $3DBzg;
    var $3nPAF;
    var $5XN59;
    var $bQZTk;
    var $1I7E8;
    var $4R6GH;
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $9TcyW = parcelRequire("9TcyW");
    var $cGbfF = parcelRequire("cGbfF");
    var $aIMtT = parcelRequire("aIMtT");
    var $8QHq4 = parcelRequire("8QHq4");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $6jd5z = parcelRequire("6jd5z");
    function $6b0a4413d7cd32c7$export$2ed0b1dd6bae3b05({ person: person, checked: checked, onChange: onChange }) {
        const { title: title, email: email, avatarUrl: avatarUrl } = person.jiraUser;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            value: person.personId,
            isChecked: checked,
            onChange: onChange,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8QHq4.UserSelectItem), {
                email: email,
                label: title,
                icon: avatarUrl
            })
        });
    }
    function $6b0a4413d7cd32c7$var$ReporterFilter({ intl: intl, searchQuery: searchQuery, onQueryChange: onQueryChange, value: value, onRequestChange: onRequestChange, onRequestClear: onRequestClear, reporters: reporters, setInitialFocusRef: setInitialFocusRef }) {
        const isSelected = (reporter)=>(0, parcelRequire("3DBzg")).default(reporter.personId, value);
        const handleReporterCheckboxChange = (e)=>{
            const { value: personId, checked: checked } = e.currentTarget;
            const nextValue = (()=>{
                const withoutTheReporter = (0, parcelRequire("jVZZA")).default((0, parcelRequire("bQZTk")).default((0, parcelRequire("8EB5I")).default(personId), (0, parcelRequire("5XN59")).default))(value);
                if (!checked) return withoutTheReporter;
                return withoutTheReporter.concat([
                    personId
                ]);
            })();
            onRequestChange(nextValue);
        };
        const reportersToDisplay = (0, $9TcyW.sortPerson)((0, $9TcyW.filter)(searchQuery, reporters));
        const additionalProps = (0, (0, parcelRequire("4R6GH")).fg)('migrate_plan_filter_to_popup') ? {
            setInitialFocusRef: setInitialFocusRef
        } : {};
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
            isVisible: !!value.length,
            onClearClick: onRequestClear
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
            placeholder: intl.formatMessage((0, $6jd5z.default).searchReporterPlaceholder),
            searchQuery: searchQuery,
            onQueryChange: onQueryChange,
            ariaLabel: intl.formatMessage((0, $6jd5z.default).searchReporterLabel),
            ...additionalProps
        }), reportersToDisplay.map((reporter, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($6b0a4413d7cd32c7$export$2ed0b1dd6bae3b05, {
                checked: isSelected(reporter),
                onChange: handleReporterCheckboxChange,
                person: reporter
            }))), (0, parcelRequire("3nPAF")).default(reportersToDisplay) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
    }
    const $6b0a4413d7cd32c7$var$getNames = (reporters, selected)=>{
        const selectedReporters = reporters.filter((person)=>selected.has(person.personId));
        const names = selectedReporters.map((person)=>person.jiraUser.title);
        return names.join(', ');
    };
    function $6b0a4413d7cd32c7$export$8bd0edd7ca02ab5f({ value: value, persons: persons }) {
        const selected = new Set(value);
        if (selected.size === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $6jd5z.default).emptyPlaceholder);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
            text: $6b0a4413d7cd32c7$var$getNames(persons, selected)
        });
    }
    function $6b0a4413d7cd32c7$var$ReporterFilterDialog(props) {
        const { isOpen: isOpen, onOpenChange: onOpenChange, value: value, intl: intl, reporters: reporters } = props;
        const ariaText = ()=>{
            const selected = new Set(value);
            return `${intl.formatMessage((0, $darOt.default)[0, $cGbfF.REPORTER_FILTER_ID])}, ${selected.size > 0 ? $6b0a4413d7cd32c7$var$getNames(reporters, selected) : intl.formatMessage((0, $6jd5z.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
        };
        if (!(0, (0, parcelRequire("4R6GH")).fg)('migrate_plan_filter_to_popup')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            noPaddings: true,
            maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
            minWidth: (0, $3iCBQ.FILTER_WIDTH),
            isOpen: isOpen,
            onClose: onOpenChange,
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($6b0a4413d7cd32c7$var$ReporterFilter, props)),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter.trigger-btn",
            triggerButtonText: (0, ($parcel$interopDefault($5uXOq))).createElement($6b0a4413d7cd32c7$export$8bd0edd7ca02ab5f, {
                value: props.value,
                persons: props.reporters
            }),
            ariaLabel: ariaText()
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            placement: "bottom-start",
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: true,
            onClose: ()=>{
                onOpenChange({
                    isOpen: false
                });
            },
            content: (contentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($6b0a4413d7cd32c7$var$ReporterFilter, {
                    ...props,
                    setInitialFocusRef: contentProps.setInitialFocusRef
                })),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter",
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                    ...triggerProps,
                    isOpen: isOpen,
                    onOpenChange: onOpenChange,
                    testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter.trigger-btn",
                    triggerButtonText: (0, ($parcel$interopDefault($5uXOq))).createElement($6b0a4413d7cd32c7$export$8bd0edd7ca02ab5f, {
                        value: props.value,
                        persons: props.reporters
                    }),
                    ariaLabel: ariaText()
                })
        });
    }
    var $6b0a4413d7cd32c7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($6b0a4413d7cd32c7$var$ReporterFilterDialog);
});
parcelRegister("9TcyW", function(module, exports) {
    $parcel$export(module.exports, "sortPerson", ()=>$188348f4b57ef715$export$92171731eacb7568);
    $parcel$export(module.exports, "filter", ()=>$188348f4b57ef715$export$3dea766d36a8935f);
    var $8ibtc;
    var $jVZZA;
    var $3DBzg;
    var $fkC9P;
    var $bQZTk;
    var $2rMKg;
    var $h35CY;
    var $hpnKp;
    const $188348f4b57ef715$var$sortByPersonTitle = (0, parcelRequire("h35CY")).default((el)=>(0, parcelRequire("hpnKp")).default(el.jiraUser.title));
    const $188348f4b57ef715$export$92171731eacb7568 = (0, parcelRequire("bQZTk")).default($188348f4b57ef715$var$sortByPersonTitle);
    const $188348f4b57ef715$var$getFullText = (0, parcelRequire("bQZTk")).default((0, parcelRequire("2rMKg")).default('jiraUser'), (user)=>[
            user?.email ?? '',
            user.title
        ], (0, parcelRequire("fkC9P")).default(' '), (0, parcelRequire("hpnKp")).default);
    const $188348f4b57ef715$var$matchQuery = (0, parcelRequire("8ibtc")).default((query, person)=>(0, parcelRequire("3DBzg")).default((0, parcelRequire("hpnKp")).default(query))($188348f4b57ef715$var$getFullText(person)));
    const $188348f4b57ef715$export$3dea766d36a8935f = (0, parcelRequire("8ibtc")).default((query, people)=>(0, parcelRequire("jVZZA")).default($188348f4b57ef715$var$matchQuery(query))(people));
});
parcelRegister("6jd5z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e2cce02f6bebce3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9e2cce02f6bebce3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchReporterPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter.search-reporter-placeholder",
            "defaultMessage": "Show issues from reporters"
        },
        searchReporterLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter.search-reporter-label",
            "defaultMessage": "Choose from reporters"
        }
    });
});
parcelRegister("lmROZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$169a550e4c6efcf0$export$2e2bcd8739ae039);
    var $bC2fB;
    var $fWibm = parcelRequire("fWibm");
    var $5Xc3I = parcelRequire("5Xc3I");
    var $gqHUO = parcelRequire("gqHUO");
    var $169a550e4c6efcf0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $5Xc3I.default), (0, $fWibm.default))((0, $gqHUO.default));
});
parcelRegister("fWibm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b908f1add8aa2de6$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    var $b908f1add8aa2de6$export$2e2bcd8739ae039 = (dispatch)=>({
            changeFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.SPRINT_FILTER_ID),
                    value: payload
                }));
            },
            clearFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.SPRINT_FILTER_ID)));
            }
        });
});
parcelRegister("5Xc3I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b51da2ad51a7851$export$2e2bcd8739ae039);
    var $d3quy = parcelRequire("d3quy");
    const $1b51da2ad51a7851$var$mapStateToProps = (state)=>({
            allSprints: (0, $d3quy.getAllSprints)(state),
            externalSprints: (0, $d3quy.getExternalSprints)(state),
            filterSprints: (0, $d3quy.getUniqueFilterSprints)(state),
            sprintsAndTeamsByIssueSources: (0, $d3quy.getSprintsAndTeamsByIssueSources)(state),
            sprintsByIdMap: (0, $d3quy.getSprintByIdMap)(state),
            sprintStatesCategories: (0, $d3quy.getSprintStatesCategories)(state)
        });
    var $1b51da2ad51a7851$export$2e2bcd8739ae039 = $1b51da2ad51a7851$var$mapStateToProps;
});
parcelRegister("gqHUO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4e98f3cd1fb52bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $1I7E8;
    var $4R6GH;
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $eqNmi = parcelRequire("eqNmi");
    var $6TEBn = parcelRequire("6TEBn");
    var $cGbfF = parcelRequire("cGbfF");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8JOG8 = parcelRequire("8JOG8");
    var $ihPUd = parcelRequire("ihPUd");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $1wIs9 = parcelRequire("1wIs9");
    var $8hgbg = parcelRequire("8hgbg");
    const { CHECKED: $a4e98f3cd1fb52bf$export$be74dcf36d511131, UNCHECKED: $a4e98f3cd1fb52bf$export$4bfe604431277125, INDETERMINATE: $a4e98f3cd1fb52bf$export$c5a6fe907430212e } = (0, $TTKUQ.CHECKBOX_STATES);
    class $a4e98f3cd1fb52bf$var$SprintFilter extends (0, $5uXOq.Component) {
        render() {
            const { allSprints: allSprints, clearFilter: clearFilter, filterSprints: filterSprints, intl: intl, isOpen: isOpen, onOpenChange: onOpenChange, onQueryChange: onQueryChange, searchQuery: searchQuery } = this.props;
            if (!(0, (0, parcelRequire("4R6GH")).fg)('migrate_plan_filter_to_popup')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                noPaddings: true,
                onClose: onOpenChange,
                isOpen: isOpen,
                maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
                minWidth: (0, $3iCBQ.FILTER_WIDTH),
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: filterSprints.size > 0,
                    onClearClick: clearFilter
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    placeholder: intl.formatMessage((0, $1wIs9.default).searchSprintPlaceholder),
                    searchQuery: searchQuery,
                    onQueryChange: onQueryChange,
                    ariaLabel: intl.formatMessage((0, $1wIs9.default).searchSprintLabel)
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                    key: `${(0, $eqNmi.NO_SPRINT_ID)}-checkbox`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    id: (0, $eqNmi.NO_SPRINT_ID),
                    key: (0, $eqNmi.NO_SPRINT_ID),
                    isChecked: this.isSelected((0, $eqNmi.NO_SPRINT_ID)),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).noSprintLabel),
                    onChange: ()=>this.onItemClick((0, $eqNmi.NO_SPRINT_ID))
                })), searchQuery && allSprints.some(this.filterSprintsWithSearchQuery) || allSprints.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.renderSprintStateCategories(), this.renderSprintsWithTeams(), this.renderSprintsWithoutTeams(), this.renderExternalSprints()) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null)),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.trigger-btn",
                triggerButtonText: this.renderFilterText(),
                ariaLabel: this.ariaText()
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: isOpen,
                placement: "bottom-start",
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: true,
                onClose: ()=>{
                    onOpenChange({
                        isOpen: false
                    });
                },
                content: (contentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                        isVisible: filterSprints.size > 0,
                        onClearClick: clearFilter
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                        placeholder: intl.formatMessage((0, $1wIs9.default).searchSprintPlaceholder),
                        searchQuery: searchQuery,
                        onQueryChange: onQueryChange,
                        ariaLabel: intl.formatMessage((0, $1wIs9.default).searchSprintLabel),
                        setInitialFocusRef: contentProps.setInitialFocusRef
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: `${(0, $eqNmi.NO_SPRINT_ID)}-checkbox`
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        id: (0, $eqNmi.NO_SPRINT_ID),
                        key: (0, $eqNmi.NO_SPRINT_ID),
                        isChecked: this.isSelected((0, $eqNmi.NO_SPRINT_ID)),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).noSprintLabel),
                        onChange: ()=>this.onItemClick((0, $eqNmi.NO_SPRINT_ID))
                    })), searchQuery && allSprints.some(this.filterSprintsWithSearchQuery) || allSprints.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.renderSprintStateCategories(), this.renderSprintsWithTeams(), this.renderSprintsWithoutTeams(), this.renderExternalSprints()) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null)),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter",
                trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                        ...triggerProps,
                        isOpen: isOpen,
                        onOpenChange: onOpenChange,
                        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.trigger-btn",
                        triggerButtonText: this.renderFilterText(),
                        ariaLabel: this.ariaText()
                    })
            });
        }
        constructor(...args){
            super(...args);
            this.constructFilterText = ()=>{
                const { filterSprints: filterSprints, intl: intl, sprintsByIdMap: sprintsByIdMap } = this.props;
                const filteredSprintsTitles = [];
                if (filterSprints.has((0, $eqNmi.NO_SPRINT_ID))) filteredSprintsTitles.push(intl.formatMessage((0, $ihPUd.default).noSprintLabel));
                [
                    ...filterSprints
                ].forEach((sprintId)=>{
                    if (sprintsByIdMap[sprintId] && sprintsByIdMap[sprintId].title) filteredSprintsTitles.push(sprintsByIdMap[sprintId].title);
                });
                return filteredSprintsTitles.join(', ');
            };
            this.renderFilterText = ()=>{
                if (this.props.filterSprints.size > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: this.constructFilterText()
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $1wIs9.default).emptyPlaceholder);
            };
            this.ariaText = ()=>{
                const { filterSprints: filterSprints, intl: intl } = this.props;
                const filterText = this.constructFilterText();
                return `${intl.formatMessage((0, $darOt.default)[0, $cGbfF.SPRINT_FILTER_ID])}, ${filterSprints.size > 0 ? filterText : intl.formatMessage((0, $1wIs9.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
            };
            this.filterSprintsWithSearchQuery = (sprint)=>sprint.title.toLowerCase().includes(this.props.searchQuery.toLowerCase());
            this.renderLozenge = (sprintState)=>{
                const { intl: intl } = this.props;
                const lozengeContent = (0, $6TEBn.getSprintStateLozengeContent)(intl);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                    appearance: (0, $6TEBn.getLozengeAppearance)(sprintState)
                }, lozengeContent(sprintState));
            };
            this.onItemGroupClick = (sprintIds, checkboxState)=>{
                const newFilterSprint = new Set(this.props.filterSprints);
                if (checkboxState === $a4e98f3cd1fb52bf$export$4bfe604431277125) for (const id of sprintIds)newFilterSprint.add(id);
                else for (const id of sprintIds)newFilterSprint.delete(id);
                this.props.changeFilter(Array.from(newFilterSprint));
            };
            this.isSelected = (id)=>this.props.filterSprints.has(id);
            this.onItemClick = (id)=>{
                const { filterSprints: filterSprints, changeFilter: changeFilter } = this.props;
                const newFilterSprint = new Set(filterSprints);
                if (this.isSelected(id)) newFilterSprint.delete(id);
                else newFilterSprint.add(id);
                changeFilter(Array.from(newFilterSprint));
            };
            this.renderSprintsGroup = (heading, sprints, renderSprintStateLozenge)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuGroup), {
                    heading: heading,
                    key: heading
                }, sprints.map((sprint)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: sprint.id
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        isChecked: this.props.filterSprints.has(sprint.id),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            className: $8hgbg["sprint-title-container"]
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                            content: sprint.title
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $8hgbg["sprint-title"]
                        }, sprint.title)), renderSprintStateLozenge(sprint.state)),
                        onChange: ()=>this.onItemClick(sprint.id)
                    }))));
            this.renderSprintStateCategories = ()=>{
                const { sprintStatesCategories: sprintStatesCategories } = this.props;
                if (!sprintStatesCategories.length) return null;
                const { intl: intl } = this.props;
                const checkboxContent = (0, $6TEBn.getSprintStateLabel)(intl);
                return sprintStatesCategories.map(({ checkboxState: checkboxState, sprintIds: sprintIds, sprintState: sprintState })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: `${sprintState}-stateCheckbox`
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        isChecked: checkboxState !== $a4e98f3cd1fb52bf$export$4bfe604431277125,
                        isDisabled: !sprintIds.length,
                        isIndeterminate: checkboxState === $a4e98f3cd1fb52bf$export$c5a6fe907430212e,
                        label: checkboxContent(sprintState),
                        onChange: ()=>this.onItemGroupClick(sprintIds, checkboxState)
                    })));
            };
            this.renderSprintsWithTeams = ()=>{
                const { searchQuery: searchQuery, sprintsAndTeamsByIssueSources: { sprintsWithTeams: sprintsWithTeams } } = this.props;
                if (sprintsWithTeams.length) return sprintsWithTeams.map((sprintsInGroup)=>{
                    const sprints = searchQuery ? sprintsInGroup.sprints.filter(this.filterSprintsWithSearchQuery) : sprintsInGroup.sprints;
                    if (!sprints.length) return null;
                    return this.renderSprintsGroup(sprintsInGroup.teams.join(', '), sprints, (sprintState)=>this.renderLozenge(sprintState));
                });
                return null;
            };
            this.renderSprintsWithoutTeams = ()=>{
                const { intl: { formatMessage: formatMessage }, searchQuery: searchQuery, sprintsAndTeamsByIssueSources: { sprintsWithoutTeams: sprintsWithoutTeams } } = this.props;
                if (sprintsWithoutTeams.length) {
                    const sprints = searchQuery ? sprintsWithoutTeams.filter(this.filterSprintsWithSearchQuery) : sprintsWithoutTeams;
                    if (!sprints.length) return null;
                    return this.renderSprintsGroup(formatMessage((0, $ihPUd.default).noAssociatedTeams), sprints, (sprintState)=>this.renderLozenge(sprintState));
                }
                return null;
            };
            this.renderExternalSprints = ()=>{
                const { externalSprints: externalSprints, intl: { formatMessage: formatMessage }, searchQuery: searchQuery } = this.props;
                const filteredExternalSprints = searchQuery ? externalSprints.filter(this.filterSprintsWithSearchQuery) : externalSprints;
                if (!filteredExternalSprints.length) return null;
                return this.renderSprintsGroup(formatMessage((0, $ihPUd.default).otherSprints), filteredExternalSprints, (sprintState)=>this.renderLozenge((0, $TTKUQ.EXTERNAL_SPRINT) || sprintState));
            };
        }
    }
    var $a4e98f3cd1fb52bf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($a4e98f3cd1fb52bf$var$SprintFilter);
});
parcelRegister("1wIs9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dbd0b05e05b7a683$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dbd0b05e05b7a683$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchSprintPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.search-sprint-placeholder",
            "defaultMessage": "Show issues from sprints"
        },
        categoriesLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.categories-label",
            "defaultMessage": "All {state} sprints"
        },
        searchSprintLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.search-sprint-label",
            "defaultMessage": "Choose from sprints"
        }
    });
});
parcelRegister("8hgbg", function(module, exports) {
    $parcel$export(module.exports, "sprint-title", ()=>$606c7668f3f66478$export$bfd119284cd59066, (v)=>$606c7668f3f66478$export$bfd119284cd59066 = v);
    $parcel$export(module.exports, "sprint-title-container", ()=>$606c7668f3f66478$export$9ae592458084b2f1, (v)=>$606c7668f3f66478$export$9ae592458084b2f1 = v);
    var $606c7668f3f66478$export$bfd119284cd59066;
    var $606c7668f3f66478$export$9ae592458084b2f1;
    $606c7668f3f66478$export$bfd119284cd59066 = `gJJ7dW_sprint-title`;
    $606c7668f3f66478$export$9ae592458084b2f1 = `gJJ7dW_sprint-title-container`;
});
parcelRegister("a7CKR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67cd8d039ad0dc84$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hUeJR = parcelRequire("hUeJR");
    var $kOtN6 = parcelRequire("kOtN6");
    var $68X5d = parcelRequire("68X5d");
    var $67cd8d039ad0dc84$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $kOtN6.default), (0, $hUeJR.default))((0, $68X5d.default));
});
parcelRegister("hUeJR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c60b7adeef9c3b3f$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $c60b7adeef9c3b3f$var$mapDispatchToProps = (dispatch)=>({
            changeFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.STATUS_KEY_FILTER_ID),
                    value: payload
                }));
            },
            clearFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.STATUS_KEY_FILTER_ID)));
            }
        });
    var $c60b7adeef9c3b3f$export$2e2bcd8739ae039 = $c60b7adeef9c3b3f$var$mapDispatchToProps;
});
parcelRegister("kOtN6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9437877e94e1e2fc$export$2e2bcd8739ae039);
    var $48ZJQ = parcelRequire("48ZJQ");
    var $g91SX = parcelRequire("g91SX");
    const $9437877e94e1e2fc$var$mapStateToProps = (state)=>({
            statusOptionsByCategory: (0, $48ZJQ.getStatusKeyFilterOptionsByCategory)(state),
            categoryNameById: (0, $g91SX.getCategoryNameById)(state),
            value: (0, $48ZJQ.getStatusKeyFilterValue)(state),
            allCategoryCheckedState: (0, $48ZJQ.getAllStatusKeyOfCategoryChecked)(state)
        });
    var $9437877e94e1e2fc$export$2e2bcd8739ae039 = $9437877e94e1e2fc$var$mapStateToProps;
});
parcelRegister("68X5d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8279d175fcbf5ac3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $vNXgH = parcelRequire("vNXgH");
    var $ousew;
    var $koVbs;
    var $fQeLt;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $lQB2Q = parcelRequire("lQB2Q");
    var $cGbfF = parcelRequire("cGbfF");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $c94kS = parcelRequire("c94kS");
    parcelRequire("8qxM8");
    var $darOt = parcelRequire("darOt");
    var $iUvyr = parcelRequire("iUvyr");
    var $c9LXM = parcelRequire("c9LXM");
    const $8279d175fcbf5ac3$var$isUnsaved = (statusName)=>statusName === (0, $lQB2Q.UNSAVED_STATUS).name;
    const $8279d175fcbf5ac3$var$StatusKeyFilter = (props)=>{
        const { value: selectedStatusKeys, statusOptionsByCategory: statusOptionsByCategory, categoryNameById: categoryNameById, allCategoryCheckedState: allCategoryCheckedState, searchQuery: searchQuery, isOpen: isOpen, changeFilter: changeFilter, clearFilter: clearFilter, onQueryChange: onQueryChange, onOpenChange: onOpenChange } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isStatusKeySelected = (statusKey)=>selectedStatusKeys.some((selectedStatusKey)=>(0, ($parcel$interopDefault($ajpes)))(selectedStatusKey, statusKey));
        const onStatusKeyClick = (clickedStatusKey)=>{
            const newValue = isStatusKeySelected(clickedStatusKey) ? selectedStatusKeys.filter((selectedStatusKey)=>!(0, ($parcel$interopDefault($ajpes)))(selectedStatusKey, clickedStatusKey)) : [
                ...selectedStatusKeys,
                clickedStatusKey
            ];
            changeFilter(newValue);
        };
        const onCategoryClick = (clickedCategory)=>{
            const allStatusNamesFromCategory = statusOptionsByCategory.get(clickedCategory) ?? [];
            const isCategorySelected = allStatusNamesFromCategory.length > 0 && allStatusNamesFromCategory.every((statusName)=>isStatusKeySelected({
                    category: clickedCategory,
                    name: statusName
                }));
            if (isCategorySelected) {
                const newValue = selectedStatusKeys.filter(({ category: category })=>category !== `${clickedCategory}`);
                changeFilter(newValue);
            } else changeFilter((0, ($parcel$interopDefault($vNXgH)))([
                ...selectedStatusKeys,
                ...allStatusNamesFromCategory.map((statusName)=>({
                        category: `${clickedCategory}`,
                        name: statusName
                    }))
            ], (0, ($parcel$interopDefault($ajpes)))));
        };
        const onClearFilter = ()=>{
            clearFilter();
        };
        const filterStatusesWithSearchQuery = (statusName)=>statusName.toLowerCase().includes(searchQuery.toLowerCase());
        const filteredStatusOptionsByCategory = Array.from(statusOptionsByCategory.entries()).reduce((acc, [category, statusNames])=>{
            const filteredStatusNames = statusNames.filter(filterStatusesWithSearchQuery);
            if (filteredStatusNames.length > 0) acc.set(category, filteredStatusNames);
            return acc;
        }, new Map());
        const renderStatus = (name, category)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fQeLt")).StatusLozenge), {
                value: {
                    id: 'N/A',
                    name: name,
                    statusCategory: {
                        id: category
                    }
                }
            });
        const renderTriggerButton = ()=>{
            const text = selectedStatusKeys.length > 0 ? selectedStatusKeys.map(({ name: name })=>$8279d175fcbf5ac3$var$isUnsaved(name) ? formatMessage((0, $iUvyr.default).unsavedIssues) : name).join(', ') : formatMessage((0, $iUvyr.default).emptyPlaceholder);
            const ariaText = `${formatMessage((0, $darOt.default)[0, $cGbfF.STATUS_KEY_FILTER_ID])}, ${text} ${formatMessage((0, $darOt.default).selected)}`;
            const renderFilterText = ()=>{
                if (selectedStatusKeys.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: text
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $iUvyr.default).emptyPlaceholder);
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.trigger-btn",
                triggerButtonText: renderFilterText(),
                ariaLabel: ariaText
            });
        };
        const renderDropList = ()=>{
            if (filteredStatusOptionsByCategory.size === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, Array.from(filteredStatusOptionsByCategory.keys()).map((category)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                    key: `${category}-categoryCheckboxes`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    testId: `portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.${category}`,
                    isChecked: allCategoryCheckedState[category] === (0, $TTKUQ.CHECKBOX_STATES).CHECKED || allCategoryCheckedState[category] === (0, $TTKUQ.CHECKBOX_STATES).INDETERMINATE,
                    isIndeterminate: allCategoryCheckedState[category] === (0, $TTKUQ.CHECKBOX_STATES).INDETERMINATE,
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                        className: $c9LXM.categoriesLabel
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                        ...(0, $iUvyr.default).categoriesLabel,
                        values: {
                            status: renderStatus(categoryNameById.get(category) ?? '', Number(category))
                        }
                    })),
                    onChange: ()=>onCategoryClick(category)
                }))), Array.from(filteredStatusOptionsByCategory.entries()).map(([category, statusNames])=>{
                if (statusNames.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuGroup), {
                    heading: categoryNameById.get(category) ?? '',
                    key: `${category}-statusCheckboxes`
                }, statusNames.map((statusName)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: statusName
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        testId: `portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.${statusName}`,
                        isChecked: isStatusKeySelected({
                            category: category,
                            name: statusName
                        }),
                        onChange: ()=>onStatusKeyClick({
                                category: category,
                                name: statusName
                            }),
                        label: $8279d175fcbf5ac3$var$isUnsaved(statusName) ? formatMessage({
                            ...(0, $iUvyr.default).unsavedIssues
                        }) : renderStatus(statusName, Number(category))
                    }))));
                return null;
            }));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            noPaddings: true,
            maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
            minWidth: (0, $3iCBQ.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                isVisible: selectedStatusKeys.length > 0,
                onClearClick: onClearFilter
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                placeholder: formatMessage((0, $iUvyr.default).searchStatusPlaceholder),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange,
                ariaLabel: formatMessage((0, $iUvyr.default).searchStatusLabel)
            }), renderDropList()),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter"
        }, renderTriggerButton());
    };
    $8279d175fcbf5ac3$var$StatusKeyFilter.defaultProps = {
        isOpen: false
    };
    var $8279d175fcbf5ac3$export$2e2bcd8739ae039 = $8279d175fcbf5ac3$var$StatusKeyFilter;
});
parcelRegister("iUvyr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$928c61b5006cd6a3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $928c61b5006cd6a3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchStatusPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.search-status-placeholder",
            "defaultMessage": "Show issues from statuses"
        },
        categoriesLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.categories-label",
            "defaultMessage": "All {status} statuses"
        },
        unsavedIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.unsaved-issues",
            "defaultMessage": "Unsaved issues"
        },
        searchStatusLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.search-status-label",
            "defaultMessage": "Choose from statuses"
        }
    });
});
parcelRegister("c9LXM", function(module, exports) {
    $parcel$export(module.exports, "categoriesLabel", ()=>$8d9b87ce8998b235$export$70d32fb684f1516d, (v)=>$8d9b87ce8998b235$export$70d32fb684f1516d = v);
    var $8d9b87ce8998b235$export$70d32fb684f1516d;
    $8d9b87ce8998b235$export$70d32fb684f1516d = `POzVCG_categoriesLabel`;
});
parcelRegister("7vVVB", function(module, exports) {
    $parcel$export(module.exports, "filterOptions", ()=>$57885cf345cc535b$export$60d56ed3961c839c, (v)=>$57885cf345cc535b$export$60d56ed3961c839c = v);
    $parcel$export(module.exports, "filterRow", ()=>$57885cf345cc535b$export$58c9fd6b8a6e3f69, (v)=>$57885cf345cc535b$export$58c9fd6b8a6e3f69 = v);
    $parcel$export(module.exports, "filterRowFilter", ()=>$57885cf345cc535b$export$174af62556826970, (v)=>$57885cf345cc535b$export$174af62556826970 = v);
    $parcel$export(module.exports, "filterRowLabel", ()=>$57885cf345cc535b$export$fdca09c2d96ecd0d, (v)=>$57885cf345cc535b$export$fdca09c2d96ecd0d = v);
    $parcel$export(module.exports, "filtersDialog", ()=>$57885cf345cc535b$export$95dc403e64e1a72e, (v)=>$57885cf345cc535b$export$95dc403e64e1a72e = v);
    $parcel$export(module.exports, "filtersHeader", ()=>$57885cf345cc535b$export$32665f30e610c72b, (v)=>$57885cf345cc535b$export$32665f30e610c72b = v);
    $parcel$export(module.exports, "filtersList", ()=>$57885cf345cc535b$export$c569aa76df9ea47e, (v)=>$57885cf345cc535b$export$c569aa76df9ea47e = v);
    $parcel$export(module.exports, "hierarchyFilterLabel", ()=>$57885cf345cc535b$export$c5e7ce4aedd187d9, (v)=>$57885cf345cc535b$export$c5e7ce4aedd187d9 = v);
    var $57885cf345cc535b$export$60d56ed3961c839c;
    var $57885cf345cc535b$export$58c9fd6b8a6e3f69;
    var $57885cf345cc535b$export$174af62556826970;
    var $57885cf345cc535b$export$fdca09c2d96ecd0d;
    var $57885cf345cc535b$export$95dc403e64e1a72e;
    var $57885cf345cc535b$export$32665f30e610c72b;
    var $57885cf345cc535b$export$c569aa76df9ea47e;
    var $57885cf345cc535b$export$c5e7ce4aedd187d9;
    $57885cf345cc535b$export$60d56ed3961c839c = `_6cBvHG_filterOptions`;
    $57885cf345cc535b$export$58c9fd6b8a6e3f69 = `_6cBvHG_filterRow`;
    $57885cf345cc535b$export$174af62556826970 = `_6cBvHG_filterRowFilter`;
    $57885cf345cc535b$export$fdca09c2d96ecd0d = `_6cBvHG_filterRowLabel`;
    $57885cf345cc535b$export$95dc403e64e1a72e = `_6cBvHG_filtersDialog`;
    $57885cf345cc535b$export$32665f30e610c72b = `_6cBvHG_filtersHeader`;
    $57885cf345cc535b$export$c569aa76df9ea47e = `_6cBvHG_filtersList`;
    $57885cf345cc535b$export$c5e7ce4aedd187d9 = `_6cBvHG_hierarchyFilterLabel`;
});
parcelRegister("2Oi0P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0573ee0d355c2e8$export$2e2bcd8739ae039);
    var $bC2fB;
    var $gGXJQ = parcelRequire("gGXJQ");
    var $986Ym = parcelRequire("986Ym");
    var $3ZutY = parcelRequire("3ZutY");
    var $e0573ee0d355c2e8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $986Ym.default), (0, $gGXJQ.default))((0, $3ZutY.default));
});
parcelRegister("gGXJQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1976b5dec84b269d$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $1976b5dec84b269d$var$mapDispatchToProps = (dispatch)=>({
            changeSummaryFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.SUMMARY_FILTER_ID),
                    value: payload
                }));
            },
            clearSummaryFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.SUMMARY_FILTER_ID)));
            }
        });
    var $1976b5dec84b269d$export$2e2bcd8739ae039 = $1976b5dec84b269d$var$mapDispatchToProps;
});
parcelRegister("986Ym", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e007a90b87feba43$export$2e2bcd8739ae039);
    var $iIikD = parcelRequire("iIikD");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    var $e007a90b87feba43$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $iIikD.getFilters)
    ], ({ [(0, $cGbfF.SUMMARY_FILTER_ID)]: { id: id, value: value } })=>({
            id: id,
            value: value
        }));
});
parcelRegister("3ZutY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a908e204eed64d7e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $9ci4W = parcelRequire("9ci4W");
    var $d5Zn3;
    var $kY99m;
    var $8RXs9;
    var $gJZ5D;
    var $1gQ7U;
    var $cGbfF = parcelRequire("cGbfF");
    var $darOt = parcelRequire("darOt");
    var $S0Mek = parcelRequire("S0Mek");
    var $4RUqZ = parcelRequire("4RUqZ");
    class $a908e204eed64d7e$var$SummaryFilter extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            if (props.value !== state.value) return {
                value: props.value,
                query: props.value || ''
            };
            return null;
        }
        render() {
            const { intl: intl, inputRef: inputRef } = this.props;
            const { query: query } = this.state;
            const hasInput = query.length > 0;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, ($parcel$interopDefault($9ci4W)))($4RUqZ.searchFieldContainer, {
                    [$4RUqZ.hasInput]: hasInput
                })
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                autoFocus: true,
                ref: inputRef,
                elemAfterInput: hasInput && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $4RUqZ.clearSearchField
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gQ7U")).IconButton), {
                    onClick: this.onClearQuery,
                    tabIndex: -1,
                    ariaLabel: intl.formatMessage((0, $S0Mek.default).clearButtonLabel)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d5Zn3"))))), {
                    label: "",
                    primaryColor: `var(--ds-icon-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N70})`,
                    size: "small"
                }))),
                onChange: this.onFieldChange,
                placeholder: intl.formatMessage((0, $S0Mek.default).placeholder),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.summary-filter",
                value: query,
                "aria-label": intl.formatMessage((0, $darOt.default)[0, $cGbfF.SUMMARY_FILTER_ID])
            }));
        }
        constructor(...args){
            super(...args);
            this.state = {
                query: this.props.value || '',
                value: this.props.value
            };
            this.applyQuery = (query)=>{
                const { changeSummaryFilter: changeSummaryFilter } = this.props;
                changeSummaryFilter(query);
            };
            this.applyQueryDebounced = (0, ($parcel$interopDefault($lFKmC)))(this.applyQuery, 250);
            this.onFieldChange = (e)=>{
                const query = e.target.value;
                this.setState({
                    query: query
                });
                this.applyQueryDebounced(query);
            };
            this.onClearQuery = ()=>{
                this.setState({
                    query: ''
                });
                this.applyQueryDebounced('');
            };
        }
    }
    var $a908e204eed64d7e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($a908e204eed64d7e$var$SummaryFilter);
});
parcelRegister("S0Mek", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4edddf0d172c72a9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4edddf0d172c72a9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.summary-filter.placeholder",
            "defaultMessage": "Type issue keys, summaries"
        },
        clearButtonLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.summary-filter.clear-button-label",
            "defaultMessage": "clear"
        }
    });
});
parcelRegister("4RUqZ", function(module, exports) {
    $parcel$export(module.exports, "clearSearchField", ()=>$38b7e3551d2df778$export$b80a961de74058b, (v)=>$38b7e3551d2df778$export$b80a961de74058b = v);
    $parcel$export(module.exports, "hasInput", ()=>$38b7e3551d2df778$export$303c88434854a784, (v)=>$38b7e3551d2df778$export$303c88434854a784 = v);
    $parcel$export(module.exports, "searchFieldContainer", ()=>$38b7e3551d2df778$export$d5ce248efb7645dd, (v)=>$38b7e3551d2df778$export$d5ce248efb7645dd = v);
    var $38b7e3551d2df778$export$b80a961de74058b;
    var $38b7e3551d2df778$export$303c88434854a784;
    var $38b7e3551d2df778$export$d5ce248efb7645dd;
    $38b7e3551d2df778$export$b80a961de74058b = `_3aa0cW_clearSearchField`;
    $38b7e3551d2df778$export$303c88434854a784 = `_3aa0cW_hasInput`;
    $38b7e3551d2df778$export$d5ce248efb7645dd = `_3aa0cW_searchFieldContainer`;
});
parcelRegister("eiEJ0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ca1109e0a7b573c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $asj29 = parcelRequire("asj29");
    var $4Gxjx = parcelRequire("4Gxjx");
    var $l63az = parcelRequire("l63az");
    var $5ca1109e0a7b573c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $4Gxjx.default), (0, $asj29.default))((0, $l63az.default));
});
parcelRegister("asj29", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$890f5c5ac844a2f8$export$2e2bcd8739ae039);
    var $834it = parcelRequire("834it");
    var $cGbfF = parcelRequire("cGbfF");
    const $890f5c5ac844a2f8$var$mapDispatchToProps = (dispatch)=>({
            changeTeamFilter: (payload)=>{
                dispatch((0, $834it.change)({
                    id: (0, $cGbfF.TEAM_FILTER_ID),
                    value: payload
                }));
            },
            clearTeamFilter: ()=>{
                dispatch((0, $834it.clear)((0, $cGbfF.TEAM_FILTER_ID)));
            }
        });
    var $890f5c5ac844a2f8$export$2e2bcd8739ae039 = $890f5c5ac844a2f8$var$mapDispatchToProps;
});
parcelRegister("4Gxjx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2e64e6a00ff8781$export$2e2bcd8739ae039);
    var $b1yMp;
    var $2rMKg;
    var $h35CY;
    var $hpnKp;
    var $iIikD = parcelRequire("iIikD");
    var $dRVQG = parcelRequire("dRVQG");
    var $cGbfF = parcelRequire("cGbfF");
    var $3YtPS = parcelRequire("3YtPS");
    const $a2e64e6a00ff8781$var$mapStateToProps = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getExistingTeams),
        (0, $iIikD.getFilters)
    ], (teams, { [(0, $cGbfF.TEAM_FILTER_ID)]: { id: id, value: value } })=>({
            id: id,
            value: value,
            teams: (0, parcelRequire("h35CY")).default((0, parcelRequire("b1yMp")).default((0, parcelRequire("hpnKp")).default, (0, parcelRequire("2rMKg")).default('title')))(teams)
        }));
    var $a2e64e6a00ff8781$export$2e2bcd8739ae039 = $a2e64e6a00ff8781$var$mapStateToProps;
});
parcelRegister("l63az", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa329ae08e10f9b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cTYeP;
    var $jVZZA;
    var $ujWmd;
    var $h8cgU;
    var $ousew;
    var $8RXs9;
    var $fAGMJ;
    var $6SblS;
    var $J8W7q;
    var $l3m9K = parcelRequire("l3m9K");
    var $cGbfF = parcelRequire("cGbfF");
    var $8JOG8 = parcelRequire("8JOG8");
    var $aIMtT = parcelRequire("aIMtT");
    var $73AQn = parcelRequire("73AQn");
    var $ae7BI = parcelRequire("ae7BI");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $8qxM8 = parcelRequire("8qxM8");
    var $c94kS = parcelRequire("c94kS");
    var $darOt = parcelRequire("darOt");
    var $1oG4P = parcelRequire("1oG4P");
    class $aa329ae08e10f9b8$var$TeamFilter extends (0, $5uXOq.Component) {
        render() {
            const { intl: intl, onOpenChange: onOpenChange, isOpen: isOpen, value: value, clearTeamFilter: clearTeamFilter, searchQuery: searchQuery, onQueryChange: onQueryChange } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
                noPaddings: true,
                maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
                minWidth: (0, $3iCBQ.FILTER_WIDTH),
                onClose: onOpenChange,
                isOpen: isOpen,
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter",
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
                    isVisible: !!value.length,
                    onClearClick: clearTeamFilter
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
                    placeholder: intl.formatMessage((0, $1oG4P.default).searchTeamPlaceholder),
                    searchQuery: searchQuery,
                    onQueryChange: onQueryChange,
                    ariaLabel: intl.formatMessage((0, $1oG4P.default).searchTeamLabel)
                }), this.props.teams.length > 0 && this.renderNoTeams(), this.renderProjectGroups())
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c94kS.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter.trigger-btn",
                triggerButtonText: this.renderFilterText(),
                ariaLabel: this.ariaText()
            }));
        }
        constructor(...args){
            super(...args);
            this.constructFilterText = ()=>{
                const { teams: teams, value: value, intl: intl } = this.props;
                const noTeamText = value.length > 1 ? `${intl.formatMessage((0, $1oG4P.default).noTeamFilterText)}, ` : intl.formatMessage((0, $1oG4P.default).noTeamFilterText);
                return ((0, parcelRequire("cTYeP")).default((0, $l3m9K.NO_TEAM_ID), value) ? noTeamText : '') + teams.filter(({ id: id })=>(0, parcelRequire("cTYeP")).default(id, value)).map(({ title: title })=>title).join(', ');
            };
            this.renderFilterText = ()=>{
                const { value: value } = this.props;
                const filterText = this.constructFilterText();
                return value.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ae7BI.default), {
                    text: filterText
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $1oG4P.default).emptyPlaceholder);
            };
            this.ariaText = ()=>{
                const { value: value, intl: intl } = this.props;
                const filterText = this.constructFilterText();
                return `${intl.formatMessage((0, $darOt.default)[0, $cGbfF.TEAM_FILTER_ID])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $1oG4P.default).emptyPlaceholder)} ${intl.formatMessage((0, $darOt.default).selected)}`;
            };
            this.isTeamSelected = (teamTitle)=>(0, parcelRequire("cTYeP")).default(teamTitle, this.props.value);
            this.filterTeamsWithSearchQuery = (team)=>team.title.toLowerCase().includes(this.props.searchQuery.toLowerCase());
            this.onTeamClick = (id)=>{
                const { value: value, changeTeamFilter: changeTeamFilter } = this.props;
                if (this.isTeamSelected(id)) changeTeamFilter((0, parcelRequire("jVZZA")).default((team)=>team !== id, value));
                else changeTeamFilter([
                    ...value,
                    id
                ]);
            };
            this.renderProjectGroups = ()=>{
                const { teams: teams } = this.props;
                const searchResultTeams = teams.filter(this.filterTeamsWithSearchQuery);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, searchResultTeams.map(({ avatarUrl: avatarUrl = '', id: id, title: title })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                        key: id
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                        id: id,
                        key: id,
                        isChecked: this.isTeamSelected(id),
                        onChange: ()=>this.onTeamClick(id),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                            id: id,
                            content: title
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            className: $8qxM8.teamAvatarItem
                        }, !avatarUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            className: $8qxM8.defaultTeamAvatar
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))), {
                            label: "",
                            size: "small"
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                            size: "small",
                            src: avatarUrl
                        }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $8qxM8.checkboxLabel
                        }, title)))
                    }))), searchResultTeams.length === 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
            };
            this.renderNoTeams = ()=>{
                const { intl: intl } = this.props;
                const title = intl.formatMessage({
                    ...(0, $1oG4P.default).noTeamFilterText
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                    id: (0, $l3m9K.NO_TEAM_ID),
                    key: (0, $l3m9K.NO_TEAM_ID),
                    isChecked: this.isTeamSelected((0, $l3m9K.NO_TEAM_ID)),
                    onChange: ()=>this.onTeamClick((0, $l3m9K.NO_TEAM_ID)),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                        id: (0, $l3m9K.NO_TEAM_ID),
                        content: title
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                        className: $8qxM8.checkboxLabel
                    }, title))
                }));
            };
        }
    }
    var $aa329ae08e10f9b8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($aa329ae08e10f9b8$var$TeamFilter);
});
parcelRegister("1oG4P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c0cb5573c70a043$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9c0cb5573c70a043$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter.empty-placeholder",
            "defaultMessage": "All"
        },
        searchTeamPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter.search-team-placeholder",
            "defaultMessage": "Show issues from teams"
        },
        noTeamFilterText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter.no-team-filter-text",
            "defaultMessage": "No team"
        },
        searchTeamLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter.search-team-label",
            "defaultMessage": "Choose from teams"
        }
    });
});
parcelRegister("kO4PD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efff1e7f95f90386$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $5rzqz;
    var $bC2fB;
    var $cP24C;
    var $6UIy4 = parcelRequire("6UIy4");
    var $luChX = parcelRequire("luChX");
    var $aQbCJ = parcelRequire("aQbCJ");
    var $7dFyj = parcelRequire("7dFyj");
    const $efff1e7f95f90386$var$withGicModalOpen = (WrappedComponent)=>(props)=>{
            const [{ isModalOpen: isModalOpen }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                isGicModalOpen: isModalOpen
            });
        };
    const $efff1e7f95f90386$var$HooksInjector = (props)=>{
        const { clear: clear } = (0, (0, parcelRequire("cP24C")).useAdvancedRoadmapsSummaryDataResource)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('refactor_update_jira_to_functional_component')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7dFyj.default), {
            ...props,
            clearSummaryPageCache: clear
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aQbCJ.default), {
            ...props,
            clearSummaryPageCache: clear
        });
    };
    var $efff1e7f95f90386$export$2e2bcd8739ae039 = $efff1e7f95f90386$var$withGicModalOpen((0, (0, parcelRequire("bC2fB")).connect)((0, $luChX.default), (0, $6UIy4.default))($efff1e7f95f90386$var$HooksInjector));
});
parcelRegister("5rzqz", function(module, exports) {
    $parcel$export(module.exports, "useTriggerIssueCreateModal", ()=>$0a31d64d52b4b5e9$export$71e0eb7b8a91a156);
    $parcel$export(module.exports, "useOpenIssueCreateModal", ()=>$0a31d64d52b4b5e9$export$47cf258b1046080b);
    $parcel$export(module.exports, "withNewGICProvider", ()=>$0a31d64d52b4b5e9$export$558a195c5bfe3787);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $co1wz;
    var $4R6GH;
    var $1Nspv;
    var $bGrWH;
    var $8zOmE;
    var $2NMNM;
    var $f5nIZ;
    var $2YP9W;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $hULKg;
    var $cKWWX;
    var $6k7U1;
    const $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a = {
        inProgressIssueID: undefined,
        isModalOpen: false,
        isSubsequentLoad: false,
        isSubTaskCreationOpen: false,
        isCreateLinkedIssue: false,
        wasStateRestored: false,
        payload: null,
        id: 'create-issue-dialog',
        title: null,
        sectionMessage: null,
        submitErrorMessage: undefined,
        globalEventNamespaces: [
            (0, (0, parcelRequire("bGrWH")).GLOBAL_EVENT_NAMESPACE)
        ],
        fieldsToAddInPublishedData: [],
        alertsToBeLinked: undefined,
        onIssueCreate: null,
        onClose: null,
        displayOnlyRequiredFields: false,
        disableCreationSuccessFlag: false,
        displayCreateAnotherIssueToggle: true,
        displaySitePicker: false,
        disableProjectDropdown: false,
        disableIssueTypeDropdown: false,
        triggerPointKey: (0, (0, parcelRequire("hULKg")).TRIGGER_POINT_KEY_NOT_DEFINED),
        context: undefined,
        minimizableModalView: 'modal',
        persistentModalView: undefined,
        shouldPushMiniModalDiscoverability: undefined,
        shouldShowMiniModalSpotlight: undefined,
        wasModalRetriggered: false,
        openIssueCreateModalNextState: {},
        shouldInitFetchConfig: false,
        interactedWithModalChangerButtons: false,
        isModalLoadInContext: false,
        disableMinimizableModal: false,
        displayMinimizableButtons: true,
        displayHeaderActionContainer: true,
        overrideUseRequestTypeFieldsToggleState: undefined,
        containerStyle: {},
        isMiniDesignEnabled: false,
        isEnrolledAndTargetedForGicMultipleLayouts: false,
        sessionId: undefined,
        FieldWrapperComponent: undefined,
        ExternalControls: undefined,
        isCustomBoardWithIcc: false,
        jqlSwimlaneId: undefined,
        swimlaneMode: undefined,
        prefilledCustomFields: {},
        ecosystemCallback: undefined,
        product: undefined,
        actionSource: undefined
    };
    const $0a31d64d52b4b5e9$export$e324594224ef24da = {
        restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
                const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
                if (!isModalOpen && stateToRestore.isModalOpen) (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(isSubsequentLoad);
                setState(stateToRestore);
            },
        openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isModalOpen) setState({
                    wasModalRetriggered: true,
                    openIssueCreateModalNextState: nextState
                });
                else {
                    (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                    const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                    const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                    const nextModalView = isDiscoverabilityPushEnabled ? (0, (0, parcelRequire("6k7U1")).getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                    setState({
                        ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                        ...isDiscoverabilityPushEnabled && {
                            minimizableModalView: nextModalView,
                            persistentModalView: currentState.persistentModalView,
                            ...(0, (0, parcelRequire("6k7U1")).discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                        },
                        inProgressIssueID: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: currentState.isModalOpen,
                        ...nextState
                    });
                }
            },
        closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
                const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
                const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
                setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    callbackPayload: undefined,
                    ...shouldPersistDiscoverabilityState && {
                        shouldPushMiniModalDiscoverability: true
                    },
                    ...isDiscoverabilityPushEnabled && {
                        persistentModalView: currentState.persistentModalView
                    },
                    ...shouldUpdatePersistentModalView && {
                        persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                    },
                    isModalOpen: false,
                    isSubsequentLoad: true
                });
                (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).abort({
                    metadata: {
                        wasStateRestored: getState().wasStateRestored
                    }
                });
            },
        clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    sectionMessage: null
                });
            },
        setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    displayOnlyRequiredFields: nextState
                });
            },
        setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
                setState({
                    minimizableModalView: minimizableModalView,
                    interactedWithModalChangerButtons: true
                });
            },
        resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
                if (applyNextState) {
                    const currentState = getState();
                    (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                        ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                            persistentModalView: currentState.persistentModalView
                        },
                        inProgressIssueID: currentState.inProgressIssueID,
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: false,
                        minimizableModalView: 'modal',
                        openIssueCreateModalNextState: {},
                        shouldInitFetchConfig: true,
                        ...currentState.openIssueCreateModalNextState
                    });
                } else setState({
                    minimizableModalView: 'modal',
                    wasModalRetriggered: false,
                    openIssueCreateModalNextState: {}
                });
            },
        resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
                setState({
                    shouldInitFetchConfig: false
                });
            },
        setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    callbackPayload: {
                        id: currentState.callbackPayload?.id ?? '',
                        data: callbackPayload
                    }
                });
            },
        setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
                });
            },
        dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    shouldShowMiniModalSpotlight: false
                });
            },
        setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    persistentModalView: persistentModalView
                });
            },
        removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
                if (!(0, (0, parcelRequire("co1wz")).ff)('linked-alerts-in-gic_onvr6')) return;
                const currentState = getState();
                const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
                setState({
                    alertsToBeLinked: alertsToBeLinked
                });
            },
        setSessionId: (sessionId)=>({ setState: setState })=>{
                setState({
                    sessionId: sessionId
                });
            }
    };
    const $0a31d64d52b4b5e9$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
        initialState: $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
        actions: $0a31d64d52b4b5e9$export$e324594224ef24da
    });
    const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0a31d64d52b4b5e9$var$store);
    const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0a31d64d52b4b5e9$var$store);
    const $0a31d64d52b4b5e9$export$71e0eb7b8a91a156 = ()=>{
        const createState = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState();
        const createActions = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
        const openIssueCreateModalWithAnalytics = (0, $5uXOq.useCallback)((nextState)=>{
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                gicViewState: nextState?.minimizableModalView,
                isSubtask: nextState?.isSubTaskCreationOpen,
                triggerPointKey: nextState?.triggerPointKey,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...nextState?.product ? {
                        product: nextState.product
                    } : {},
                    ...nextState?.actionSource ? {
                        actionSource: nextState.actionSource
                    } : {}
                } : {}
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
            openIssueCreateModal(nextState);
        }, [
            createAnalyticsEvent,
            openIssueCreateModal
        ]);
        return [
            createState,
            {
                ...otherActions,
                openIssueCreateModal: openIssueCreateModalWithAnalytics
            }
        ];
    };
    const $0a31d64d52b4b5e9$export$47cf258b1046080b = ()=>{
        const { openIssueCreateModal: openIssueCreateModal } = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setSitePickerState: setSitePickerState }] = (0, (0, parcelRequire("cKWWX")).useSitePickerContext)();
        return (0, $5uXOq.useCallback)((nextState)=>{
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                gicViewState: nextState?.minimizableModalView,
                isSubtask: nextState?.isSubTaskCreationOpen,
                triggerPointKey: nextState?.triggerPointKey,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...nextState?.product ? {
                        product: nextState.product
                    } : {},
                    ...nextState?.actionSource ? {
                        actionSource: nextState.actionSource
                    } : {}
                } : {}
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
            if (nextState?.payload?.overrideCloudId && (0, (0, parcelRequire("4R6GH")).fg)('jira_ai_issue_create_site_user_preference')) setSitePickerState({
                selectedCloudId: nextState?.payload?.overrideCloudId
            });
            openIssueCreateModal(nextState);
        }, [
            createAnalyticsEvent,
            openIssueCreateModal,
            setSitePickerState
        ]);
    };
    const $0a31d64d52b4b5e9$export$4c674fe824b8f278 = (0, (0, parcelRequire("51nlc")).createSubscriber)($0a31d64d52b4b5e9$var$store);
    function $0a31d64d52b4b5e9$export$558a195c5bfe3787(WrappedComponent) {
        return (props)=>{
            const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $0a31d64d52b4b5e9$export$71e0eb7b8a91a156();
            const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources));
            const currentIssueCreateVisibility = data && data?.gicOptInStatus;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                openIssueCreateModal: openIssueCreateModal,
                closeIssueCreateModal: closeIssueCreateModal,
                currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
                ...props
            });
        };
    }
});
parcelRegister("1Nspv", function(module, exports) {
    $parcel$export(module.exports, "CreateIssueUFOExperience", ()=>$ff7fb599b8d98642$export$cd75c112ac11a83b);
    $parcel$export(module.exports, "StatusFieldLoad", ()=>$ff7fb599b8d98642$export$e890e797a25e655c);
    $parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", ()=>$ff7fb599b8d98642$export$70208657c8d471a7);
    $parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", ()=>$ff7fb599b8d98642$export$b2d8f8edec75f571);
    var $atdLB;
    var $duUGa;
    const $ff7fb599b8d98642$export$cd75c112ac11a83b = new (0, (0, parcelRequire("duUGa")).UFOExperience)('global-issue-create.create-issue', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'global-issue-create.create-issue'
    });
    const $ff7fb599b8d98642$export$e890e797a25e655c = new (0, (0, parcelRequire("duUGa")).UFOExperience)('global-issue-create.create-issue.status-field', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $ff7fb599b8d98642$export$70208657c8d471a7 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('modern-global-issue-create.modal.issue-submit', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'modern-global-issue-create.modal.issue-submit'
    });
    const $ff7fb599b8d98642$export$b2d8f8edec75f571 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('ecosystem-api-new-gic-prefilling', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'ecosystem-api-new-gic-prefilling'
    });
});
parcelRegister("bGrWH", function(module, exports) {
    $parcel$export(module.exports, "REQUIRED", ()=>$4aabf2a0e09eb856$export$b1c05b34d317c074);
    $parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$1a020bd73f33e5a);
    $parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$9eadc594a5383580);
    $parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a1a7caa1e4a73c9f);
    $parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$cf70f9220e6a2f50);
    $parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$aac4661200ba4104);
    $parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a23c32d5cf54cba0);
    $parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$74ab3898ae683660);
    $parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$983715bb9b0f9b2c);
    $parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", ()=>$4aabf2a0e09eb856$export$40f6793dd75f4e52);
    $parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", ()=>$4aabf2a0e09eb856$export$3bf5bce483cc2c30);
    $parcel$export(module.exports, "ISSUE_CREATE_TYPE", ()=>$4aabf2a0e09eb856$export$30cc1fd33e7c7258);
    $parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", ()=>$4aabf2a0e09eb856$export$8170252f0ea43511);
    const $4aabf2a0e09eb856$export$17bcab948893a9ba = 'worklog';
    const $4aabf2a0e09eb856$export$b1c05b34d317c074 = 'REQUIRED';
    const $4aabf2a0e09eb856$export$f10b32dfda12e96e = 'unknown';
    const $4aabf2a0e09eb856$export$e5e4b8c32e68dd0b = 'networkError';
    const $4aabf2a0e09eb856$export$2d06efb8146cd043 = 'graphQLError';
    const $4aabf2a0e09eb856$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
    const $4aabf2a0e09eb856$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
    const $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
    const $4aabf2a0e09eb856$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
    const $4aabf2a0e09eb856$export$aac4661200ba4104 = 'worklog_startDate';
    const $4aabf2a0e09eb856$export$a23c32d5cf54cba0 = 'worklog_description';
    const $4aabf2a0e09eb856$export$74ab3898ae683660 = [
        'worklog_adjustmentAmount',
        'worklog_adjustEstimate',
        'worklog_activate'
    ];
    const $4aabf2a0e09eb856$export$63fd567c1d0aca19 = [
        ...$4aabf2a0e09eb856$export$74ab3898ae683660,
        $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f,
        $4aabf2a0e09eb856$export$cf70f9220e6a2f50,
        $4aabf2a0e09eb856$export$aac4661200ba4104,
        $4aabf2a0e09eb856$export$a23c32d5cf54cba0
    ];
    const $4aabf2a0e09eb856$export$983715bb9b0f9b2c = {
        [$4aabf2a0e09eb856$export$17bcab948893a9ba]: $4aabf2a0e09eb856$export$63fd567c1d0aca19
    };
    const $4aabf2a0e09eb856$export$40f6793dd75f4e52 = {
        behavior: 'auto',
        scrollMode: 'if-needed',
        block: 'start'
    };
    const $4aabf2a0e09eb856$export$3bf5bce483cc2c30 = [
        'com.atlassian.servicedesk:sd-request-participants'
    ];
    const $4aabf2a0e09eb856$export$30cc1fd33e7c7258 = {
        linkedIssue: 'LINKED_ISSUE_CREATE',
        standard: 'STANDARD'
    };
    const $4aabf2a0e09eb856$export$8170252f0ea43511 = 'QuickCreateIssue';
});
parcelRegister("hULKg", function(module, exports) {
    $parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", ()=>$62659eb193cd5c9c$export$a05673a22505d5ee);
    $parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", ()=>$62659eb193cd5c9c$export$c78d329777576aa0);
    $parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", ()=>$62659eb193cd5c9c$export$992ab052fd10f8e8);
    $parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", ()=>$62659eb193cd5c9c$export$affdc3af7a9a4677);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", ()=>$62659eb193cd5c9c$export$7e9cfd1f59e60910);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", ()=>$62659eb193cd5c9c$export$708499dcd016e5e9);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", ()=>$62659eb193cd5c9c$export$e1c8789144c4c810);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", ()=>$62659eb193cd5c9c$export$c5afabb7a17e802);
    $parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$2086a63173b79b56);
    $parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$fe1e5e4597147709);
    $parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$9bc326812a93707);
    $parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", ()=>$62659eb193cd5c9c$export$f352934e06f44599);
    $parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", ()=>$62659eb193cd5c9c$export$6ae07c77acc64360);
    $parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", ()=>$62659eb193cd5c9c$export$b41d0684e4b6ab1);
    $parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", ()=>$62659eb193cd5c9c$export$be9b2b1329ff7ec9);
    $parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", ()=>$62659eb193cd5c9c$export$aa348159181703a0);
    $parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", ()=>$62659eb193cd5c9c$export$f90eec3841adf619);
    $parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", ()=>$62659eb193cd5c9c$export$718822a309bffada);
    $parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", ()=>$62659eb193cd5c9c$export$2753dafac81e805c);
    $parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", ()=>$62659eb193cd5c9c$export$7c4d5cc5711d9294);
    $parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", ()=>$62659eb193cd5c9c$export$998dfc72404b9e14);
    $parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", ()=>$62659eb193cd5c9c$export$fc180a4b5785d2f4);
    $parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", ()=>$62659eb193cd5c9c$export$946ec0b21cb84fd0);
    $parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", ()=>$62659eb193cd5c9c$export$5b97e2844e620e54);
    $parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", ()=>$62659eb193cd5c9c$export$b99842c2cf46f6be);
    $parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", ()=>$62659eb193cd5c9c$export$8d987f6e80b74000);
    $parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$8de9fa43731c4b5b);
    $parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", ()=>$62659eb193cd5c9c$export$87249ccbfd10fb78);
    $parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", ()=>$62659eb193cd5c9c$export$c0eeeb31d264de76);
    $parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", ()=>$62659eb193cd5c9c$export$f546e18e46478c84);
    $parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", ()=>$62659eb193cd5c9c$export$1784e634ba79f1f9);
    $parcel$export(module.exports, "JWM_INLINE_CREATE", ()=>$62659eb193cd5c9c$export$145eb8935a34e85e);
    $parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", ()=>$62659eb193cd5c9c$export$32648b574a536c8b);
    $parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", ()=>$62659eb193cd5c9c$export$c0e2ab74dfaa67cc);
    const $62659eb193cd5c9c$export$a05673a22505d5ee = 'forge-open-issue-create';
    const $62659eb193cd5c9c$export$c78d329777576aa0 = 'global-create-button';
    const $62659eb193cd5c9c$export$992ab052fd10f8e8 = 'mobile-global-create-button';
    const $62659eb193cd5c9c$export$affdc3af7a9a4677 = 'keyboard-shortcut';
    const $62659eb193cd5c9c$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
    const $62659eb193cd5c9c$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
    const $62659eb193cd5c9c$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
    const $62659eb193cd5c9c$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
    const $62659eb193cd5c9c$export$2086a63173b79b56 = 'jsw-releases-create-issue';
    const $62659eb193cd5c9c$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
    const $62659eb193cd5c9c$export$9bc326812a93707 = 'jsw-security-create-issue';
    const $62659eb193cd5c9c$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
    const $62659eb193cd5c9c$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
    const $62659eb193cd5c9c$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
    const $62659eb193cd5c9c$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
    const $62659eb193cd5c9c$export$235b856f54db8916 = 'jwm-board-create-issue';
    const $62659eb193cd5c9c$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
    const $62659eb193cd5c9c$export$8e135b62470e5f9a = 'jwm-list-create-issue';
    const $62659eb193cd5c9c$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
    const $62659eb193cd5c9c$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
    const $62659eb193cd5c9c$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
    const $62659eb193cd5c9c$export$aa348159181703a0 = 'software-create-issue-dialog';
    const $62659eb193cd5c9c$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
    const $62659eb193cd5c9c$export$718822a309bffada = 'create-linked-issue-command-palette';
    const $62659eb193cd5c9c$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
    const $62659eb193cd5c9c$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
    const $62659eb193cd5c9c$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
    const $62659eb193cd5c9c$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
    const $62659eb193cd5c9c$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
    const $62659eb193cd5c9c$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
    const $62659eb193cd5c9c$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
    const $62659eb193cd5c9c$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
    const $62659eb193cd5c9c$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
    const $62659eb193cd5c9c$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
    const $62659eb193cd5c9c$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
    const $62659eb193cd5c9c$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
    const $62659eb193cd5c9c$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
    const $62659eb193cd5c9c$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
    const $62659eb193cd5c9c$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
    const $62659eb193cd5c9c$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
    const $62659eb193cd5c9c$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
    const $62659eb193cd5c9c$export$f546e18e46478c84 = 'issue-create-embed-trigger';
    const $62659eb193cd5c9c$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
    const $62659eb193cd5c9c$export$145eb8935a34e85e = 'jwm-inline-create';
    const $62659eb193cd5c9c$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
    const $62659eb193cd5c9c$export$818f24c6c32e18a = 'jira-calendar-create-issue';
    const $62659eb193cd5c9c$export$f352408886aa304b = 'connect-app-ecosystem';
    const $62659eb193cd5c9c$export$c0e2ab74dfaa67cc = {
        FIELD_IDS: [
            'description'
        ],
        TRIGGER_POINTS: [
            'service-desk-gen-ai-pir'
        ]
    };
});
parcelRegister("cKWWX", function(module, exports) {
    $parcel$export(module.exports, "useSitePickerContext", ()=>$c8055d212e869a3c$export$f8b5aae013e4cf77);
    var $3sQ5x;
    var $iXqE5;
    const $c8055d212e869a3c$export$d4c72bab9d6cc13a = {
        selectedCloudId: '',
        siteDomain: ''
    };
    const $c8055d212e869a3c$export$e324594224ef24da = {
        setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    selectedCloudId: selectedCloudId || '',
                    siteDomain: siteDomain || ''
                });
            }
    };
    const $c8055d212e869a3c$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue.fields.site-picker',
        initialState: $c8055d212e869a3c$export$d4c72bab9d6cc13a,
        actions: $c8055d212e869a3c$export$e324594224ef24da
    });
    const $c8055d212e869a3c$export$f8b5aae013e4cf77 = (0, (0, parcelRequire("3sQ5x")).createHook)($c8055d212e869a3c$export$6f57813fe9f31bf9);
});
parcelRegister("6k7U1", function(module, exports) {
    $parcel$export(module.exports, "startGlobalIssueCreateMetrics", ()=>$8a2e4df39a48d5af$export$550b19803bc962ec);
    $parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", ()=>$8a2e4df39a48d5af$export$f6bc17a4d9120156);
    $parcel$export(module.exports, "discoverabilityPushModalViewOverride", ()=>$8a2e4df39a48d5af$export$8d246e5e04f0b424);
    $parcel$export(module.exports, "getNextModalView", ()=>$8a2e4df39a48d5af$export$720579602bb055a2);
    var $eTXmK;
    var $1Nspv;
    var $gEaAu;
    var $huY3x;
    const $8a2e4df39a48d5af$export$550b19803bc962ec = (isSubsequentLoad)=>{
        (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).start();
        const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoadSubsequent) : (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoad);
        if (isSubsequentLoad) (0, (0, parcelRequire("eTXmK")).default)('global-issue.create-modal-subsequent');
        else (0, (0, parcelRequire("eTXmK")).default)('global-issue.create-modal');
        globalIssueCreateModalLoadMetric.start();
        (0, (0, parcelRequire("huY3x")).startGlobalIssueCreateTTIWithAdjustments)();
    };
    const $8a2e4df39a48d5af$export$f6bc17a4d9120156 = (triggerPoint)=>{
        if (!triggerPoint) return false;
        const acceptedTriggerPoints = [
            'global-create-button',
            'keyboard-shortcut'
        ];
        return acceptedTriggerPoints.includes(triggerPoint);
    };
    const $8a2e4df39a48d5af$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
        if (!shouldPushDiscoverability) return undefined;
        return {
            minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
            shouldPushMiniModalDiscoverability: true,
            shouldShowMiniModalSpotlight: isTriggerAccepted
        };
    };
    const $8a2e4df39a48d5af$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
        if (isTriggerAccepted) return persistentView || defaultView;
        return defaultView;
    };
});
parcelRegister("gEaAu", function(module, exports) {
    $parcel$export(module.exports, "globalIssueCreateModalLoad", ()=>$ee246606338fc99e$export$5a01a7fa84b239c8);
    $parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", ()=>$ee246606338fc99e$export$c50ad3c31b6fcfc6);
    $parcel$export(module.exports, "successFlagDisplay", ()=>$ee246606338fc99e$export$4b2382574525bb0f);
    $parcel$export(module.exports, "successFlagAddToSprintAction", ()=>$ee246606338fc99e$export$7839bdaa2f6a2385);
    $parcel$export(module.exports, "successFlagClearFiltersAction", ()=>$ee246606338fc99e$export$c1592e4d8d98963e);
    var $dGrdR;
    const $ee246606338fc99e$export$5a01a7fa84b239c8 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-modal'
    });
    const $ee246606338fc99e$export$c50ad3c31b6fcfc6 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-modal-subsequent'
    });
    const $ee246606338fc99e$export$4b2382574525bb0f = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-display'
    });
    const $ee246606338fc99e$export$7839bdaa2f6a2385 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
    });
    const $ee246606338fc99e$export$c1592e4d8d98963e = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
    });
});
parcelRegister("huY3x", function(module, exports) {
    $parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874);
    $parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", ()=>$06c7e44c59602f0c$export$457c9fb71ad5b3a9);
    $parcel$export(module.exports, "markGicTti", ()=>$06c7e44c59602f0c$export$ef664dac649a716c);
    $parcel$export(module.exports, "stopTTI", ()=>$06c7e44c59602f0c$export$30ca4c461fab486c);
    $parcel$export(module.exports, "cancelTTI", ()=>$06c7e44c59602f0c$export$27f2445288b528c);
    $parcel$export(module.exports, "markIframeLoad", ()=>$06c7e44c59602f0c$export$7a2709fc1e33401a);
    $parcel$export(module.exports, "markFieldsRegistered", ()=>$06c7e44c59602f0c$export$cf3893335c93e33b);
    $parcel$export(module.exports, "markOnInitResolved", ()=>$06c7e44c59602f0c$export$d86f4868694f2aa7);
    var $dGrdR;
    var $a1HyB;
    const $06c7e44c59602f0c$export$9f3d6f17e1da7874 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-tti-with-adjustments',
        timings: [
            {
                key: 'gic-tti-delta',
                startMark: 'gic-tti'
            },
            {
                key: 'script-execution',
                startMark: 'iframe-load'
            },
            {
                key: 'loading-indicators-visibility',
                startMark: 'fields-registered'
            },
            {
                key: 'time-until-oninit-resolved',
                endMark: 'oninit-resolved'
            },
            {
                key: 'gic-all-fields-tti',
                endMark: 'gic-all-fields-loaded'
            }
        ],
        featureFlags: (0, (0, parcelRequire("a1HyB")).TTIFFs)
    });
    const $06c7e44c59602f0c$export$457c9fb71ad5b3a9 = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.start();
    };
    const $06c7e44c59602f0c$export$ef664dac649a716c = ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('gic-tti');
    const $06c7e44c59602f0c$export$30ca4c461fab486c = (customData)=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.stop({
            customData: customData
        });
    };
    const $06c7e44c59602f0c$export$27f2445288b528c = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.cancel();
    };
    const $06c7e44c59602f0c$export$7a2709fc1e33401a = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('iframe-load');
    };
    const $06c7e44c59602f0c$export$cf3893335c93e33b = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('fields-registered');
    };
    const $06c7e44c59602f0c$export$d86f4868694f2aa7 = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('oninit-resolved');
    };
});
parcelRegister("cP24C", function(module, exports) {
    $parcel$export(module.exports, "useAdvancedRoadmapsSummaryDataResource", ()=>$d012d2ead08788e3$export$263a4c831540778e);
    var $2YP9W;
    var $lv9xW;
    var $lv9xW;
    var $gZ6zR;
    const $d012d2ead08788e3$export$263a4c831540778e = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource));
});
parcelRegister("gZ6zR", function(module, exports) {
    $parcel$export(module.exports, "IssueStatus", ()=>$ad83cd0410dc011b$export$559eb15a98685419);
    $parcel$export(module.exports, "BlockType", ()=>$ad83cd0410dc011b$export$48808c686fe495c4);
    const $ad83cd0410dc011b$export$559eb15a98685419 = {
        TODO: 'TODO',
        IN_PROGRESS: 'IN_PROGRESS',
        DONE: 'DONE'
    };
    const $ad83cd0410dc011b$export$de194318c6dccbc1 = {
        INITIATIVE: 'INITIATIVE',
        EPIC: 'EPIC'
    };
    const $ad83cd0410dc011b$export$48808c686fe495c4 = {
        DELAY_WORK: 'DELAY_WORK',
        CRITICAL_PATH: 'CRITICAL_PATH',
        BLOCK_WORK: 'BLOCK_WORK'
    };
});
parcelRegister("6UIy4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e71ad48ccae4335$export$2e2bcd8739ae039);
    var $eTXmK;
    var $kX5YK = parcelRequire("kX5YK");
    var $iNyXb = parcelRequire("iNyXb");
    var $91SKv = parcelRequire("91SKv");
    var $aHSC5 = parcelRequire("aHSC5");
    var $1Cyfv = parcelRequire("1Cyfv");
    var $2e71ad48ccae4335$export$2e2bcd8739ae039 = (dispatch)=>({
            openDialog: (e)=>{
                (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).OPEN_REVIEW_CHANGES, e.timeStamp);
                dispatch((0, $kX5YK.getChangesMetadata)());
                dispatch((0, $kX5YK.getNotificationPreference)());
                dispatch((0, $aHSC5.openUpdateJiraDialog)());
            },
            closeDialog: ()=>{
                dispatch((0, $aHSC5.closeUpdateJiraDialog)());
            },
            updateJira: (analyticsEvent, notifyWatchers)=>{
                dispatch((0, $kX5YK.commitChanges)({
                    actions: {
                        success: [
                            (0, $kX5YK.saveNotificationPreference)({
                                shouldNotifyWatchers: notifyWatchers
                            }),
                            (0, $aHSC5.deselectAllChanges)(),
                            (0, $kX5YK.updateLastCommittedTimestamp)()
                        ]
                    },
                    notifyWatchers: notifyWatchers
                }, {
                    analyticsEvent: analyticsEvent
                }));
            },
            revertChanges: ()=>{
                dispatch((0, $kX5YK.revertChanges)({
                    actions: {
                        success: [
                            (0, $aHSC5.deselectAllChanges)()
                        ]
                    }
                }));
            },
            closeCommitWarningFlag: ()=>{
                dispatch((0, $aHSC5.closeCommitWarningFlag)());
            },
            interruptCommitting: ()=>{
                dispatch((0, $iNyXb.interrupt)());
            },
            interruptReverting: ()=>{
                dispatch((0, $91SKv.interrupt)());
            },
            updateNotificationPreference: (shouldNotifyWatchers)=>{
                dispatch((0, $aHSC5.updateNotificationPreference)({
                    shouldNotifyWatchers: shouldNotifyWatchers
                }));
            }
        });
});
parcelRegister("luChX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fec27e69c4ec4e30$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpgxP = parcelRequire("jpgxP");
    var $dRVQG = parcelRequire("dRVQG");
    var $25viM = parcelRequire("25viM");
    var $3YtPS = parcelRequire("3YtPS");
    var $lL58V = parcelRequire("lL58V");
    const $fec27e69c4ec4e30$var$getHiddenIssuesDialogVisibilityState = (state)=>state.ui.Top.TitleBar.HiddenIssues.isDialogOpen;
    const $fec27e69c4ec4e30$export$518824cf31321346 = (0, $3YtPS.createSelector)([
        (0, $25viM.getReviewChangesCount),
        (0, $lL58V.getDialogVisibilityState),
        (0, $25viM.getIsLoading),
        (0, $25viM.getIsSaving),
        (0, $25viM.getIsSavingInterrupted),
        (0, $25viM.getIsReverting),
        (0, $25viM.getIsRevertingInterrupted),
        (0, $25viM.getIsOutOfSync),
        $fec27e69c4ec4e30$var$getHiddenIssuesDialogVisibilityState,
        (0, $1CGdp.getMode),
        (0, $25viM.getCommitWarnings),
        (0, $25viM.getChangesWarnings),
        (0, $25viM.getCommittedChangesCount),
        (0, $25viM.getIsCommitWarningFlagClosed),
        (0, $25viM.getSelectedChangesCount),
        (0, $25viM.getIsLoaded),
        (0, $jpgxP.isNonPublishingEditor),
        (0, $25viM.getNotificationPreference),
        (0, $bI9dZ.getIsIssuesLoading)
    ], (changesCount, isDialogOpen, isLoading, isSaving, isSavingInterrupted, isReverting, isRevertingInterrupted, isOutOfSync, hiddenIssuesDialogIsOpen, mode, commitWarnings, changesWarnings, committedChangesCount, isCommitWarningFlagClosed, selectedChangesCount, isLoaded, isNonPublishingEditor, shouldNotifyWatchers, isIssuesLoading)=>({
            changesCount: changesCount,
            isDialogOpen: isDialogOpen,
            isLoading: isLoading,
            isSaving: isSaving,
            isSavingInterrupted: isSavingInterrupted,
            isReadOnly: mode !== (0, $ab4be2e1e204af69$export$250171a898bf7ef),
            isOptimizing: mode === (0, $ab4be2e1e204af69$export$7536581a3f6533cb),
            isOptimized: mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771),
            isReverting: isReverting,
            isRevertingInterrupted: isRevertingInterrupted,
            isOutOfSync: isOutOfSync,
            hiddenIssuesDialogIsOpen: hiddenIssuesDialogIsOpen,
            commitWarningMeta: (0, $lL58V.getCommitWarningMeta)(commitWarnings, changesWarnings, isSaving, committedChangesCount, isCommitWarningFlagClosed, isLoaded),
            selectedChangesCount: selectedChangesCount,
            isNonPublishingEditor: isNonPublishingEditor,
            shouldNotifyWatchers: shouldNotifyWatchers,
            isIssuesLoading: isIssuesLoading
        }));
    const $fec27e69c4ec4e30$var$changesSelector = (0, $3YtPS.createSelector)([
        (0, $25viM.getFilteredReviewChanges),
        (0, $25viM.getSortDirection),
        (0, $25viM.getExpandedChanges)
    ], (filteredReviewChanges, sortDirection, expandedChanges)=>(0, $lL58V.expandChanges)((0, $lL58V.sortChanges)(filteredReviewChanges, sortDirection), expandedChanges));
    const $fec27e69c4ec4e30$var$getHasPlanOnlyTeamsPure = (teams)=>teams.some(({ isPlanTeam: isPlanTeam })=>isPlanTeam);
    const $fec27e69c4ec4e30$var$getHasPlanOnlyTeams = (0, $3YtPS.createSelector)([
        (0, $dRVQG.getTeams)
    ], $fec27e69c4ec4e30$var$getHasPlanOnlyTeamsPure);
    var $fec27e69c4ec4e30$export$2e2bcd8739ae039 = (state)=>({
            ...$fec27e69c4ec4e30$export$518824cf31321346(state),
            changes: $fec27e69c4ec4e30$var$changesSelector(state),
            currentScenarioColor: (0, $bHTqr.getCurrentScenarioColor)(state),
            dateConfiguration: (0, $bHTqr.getDateConfiguration)(state),
            typeToLevel: (0, $6Ayrn.getTypeToLevel)(state),
            hasPlanOnlyTeams: $fec27e69c4ec4e30$var$getHasPlanOnlyTeams(state)
        });
});
parcelRegister("lL58V", function(module, exports) {
    $parcel$export(module.exports, "getDialogVisibilityState", ()=>$f880984f67504ea3$export$2ca6bc717c6809d7);
    $parcel$export(module.exports, "getCommitWarningMeta", ()=>$f880984f67504ea3$export$86715c8d56b29ac1);
    $parcel$export(module.exports, "sortChanges", ()=>$f880984f67504ea3$export$6d088339d2e39cdd);
    $parcel$export(module.exports, "expandChanges", ()=>$f880984f67504ea3$export$6c63a5e0a507d94c);
    var $ltEPm;
    var $3nPAF;
    var $5XN59;
    var $j0d94;
    var $7Zjd1;
    var $bjzU8;
    var $bI9dZ = parcelRequire("bI9dZ");
    var $60TfX = parcelRequire("60TfX");
    var $ipX5U = parcelRequire("ipX5U");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $f880984f67504ea3$export$2ca6bc717c6809d7 = (state)=>state.ui.Top.TitleBar.UpdateJira.isDialogOpen;
    const $f880984f67504ea3$export$86715c8d56b29ac1 = (commitWarnings, changesWarnings, isSaving, committedChangesCount, isCommitWarningFlagClosed, isLoaded)=>{
        const failedCommitCount = (0, parcelRequire("j0d94")).default((numWarnings, warnings)=>numWarnings + (warnings ? Object.keys(warnings).length : 0), 0, (0, parcelRequire("bjzU8")).default(commitWarnings));
        return {
            commitWarningsExists: !(0, parcelRequire("ltEPm")).default((0, parcelRequire("3nPAF")).default)((0, parcelRequire("bjzU8")).default(commitWarnings)) || !(0, parcelRequire("ltEPm")).default((0, parcelRequire("3nPAF")).default)((0, parcelRequire("bjzU8")).default(changesWarnings)),
            shouldShowCommitWarningFlag: isLoaded && (0, parcelRequire("5XN59")).default(isSaving) && (0, parcelRequire("5XN59")).default(isCommitWarningFlagClosed),
            successfulCommitCount: committedChangesCount - failedCommitCount,
            failedCommitCount: failedCommitCount
        };
    };
    const $f880984f67504ea3$export$51575a0b7be323d2 = (changeA, changeB)=>{
        if (changeA.lastModified && changeB.lastModified) return changeA.lastModified.date < changeB.lastModified.date ? -1 : 1;
        return 0;
    };
    const $f880984f67504ea3$export$f28150f7dedb9772 = (changeA, changeB)=>{
        if (changeA.lastModified && changeB.lastModified) return changeA.lastModified.date > changeB.lastModified.date ? -1 : 1;
        return 0;
    };
    const $f880984f67504ea3$export$6d088339d2e39cdd = (changes, sortDirection)=>{
        if (sortDirection === 'ASC') return (0, parcelRequire("7Zjd1")).default($f880984f67504ea3$export$f28150f7dedb9772, changes);
        return (0, parcelRequire("7Zjd1")).default($f880984f67504ea3$export$51575a0b7be323d2, changes);
    };
    const $f880984f67504ea3$export$abd126f47bcb7dde = (change)=>{
        const { category: category, lastModified: lastModified, warnings: warnings, ...rest } = change;
        let changedAttributes;
        switch(change.category){
            case (0, $TTKUQ.ENTITY).ISSUE:
                {
                    const { type: type, details: details } = change;
                    changedAttributes = [
                        ...(0, $bI9dZ.getChangedAttributes)(details, type)
                    ];
                    break;
                }
            case (0, $TTKUQ.ENTITY).RELEASE:
                {
                    const { type: type, details: { values: values, originals: originals } } = change;
                    changedAttributes = [
                        ...(0, $ipX5U.getChangedAttributes)(values, originals, type)
                    ];
                    break;
                }
            case (0, $TTKUQ.ENTITY).TEAM:
            case (0, $TTKUQ.ENTITY).RESOURCE:
                return (0, $60TfX.expandChangesForTeam)(change);
            case (0, $TTKUQ.ENTITY).SPRINT:
                changedAttributes = Object.keys(change.details.originals);
                break;
            default:
                return [];
        }
        return changedAttributes.map((attributeName)=>({
                ...rest,
                type: (0, $TTKUQ.SCENARIO_TYPE).NONE,
                category: category,
                attributeName: attributeName,
                warnings: []
            }));
    };
    const $f880984f67504ea3$export$6c63a5e0a507d94c = (collapsedChanges, expandedChanges)=>{
        const changes = [];
        collapsedChanges.forEach((change)=>{
            const { id: id, category: category, changeCount: changeCount } = change;
            changes.push(change);
            const isExpanded = expandedChanges[category].includes(id);
            if (isExpanded && (change.type === (0, $TTKUQ.SCENARIO_TYPE).ADDED || changeCount > 1)) changes.push(...$f880984f67504ea3$export$abd126f47bcb7dde(change));
        });
        return changes;
    };
});
parcelRegister("aQbCJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e875bf9a5b39360$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $5LWLA;
    var $i28qQ;
    var $1R1Ge;
    var $juxqI;
    var $dC5iT;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $9fuVs;
    var $5Zxxp;
    var $ousew;
    var $enoTt;
    var $i2qlb = parcelRequire("i2qlb");
    var $biWSr = parcelRequire("biWSr");
    var $84qTJ = parcelRequire("84qTJ");
    var $4nDwW = parcelRequire("4nDwW");
    var $4cwkM = parcelRequire("4cwkM");
    var $idmiV = parcelRequire("idmiV");
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $8BWE6 = parcelRequire("8BWE6");
    var $gZDvj = parcelRequire("gZDvj");
    var $hS7Kp = parcelRequire("hS7Kp");
    var $30u2g = parcelRequire("30u2g");
    var $vH6RR = parcelRequire("vH6RR");
    var $eeWRL = parcelRequire("eeWRL");
    var $4C5T3 = parcelRequire("4C5T3");
    var $7zIWQ = parcelRequire("7zIWQ");
    var $6bYOl = parcelRequire("6bYOl");
    var $cO2Va = parcelRequire("cO2Va");
    var $cfRKD = parcelRequire("cfRKD");
    var $dhNbN = parcelRequire("dhNbN");
    var $k0aEA = parcelRequire("k0aEA");
    var $4h04l = parcelRequire("4h04l");
    var $yFIAE = parcelRequire("yFIAE");
    var $lSLIm = parcelRequire("lSLIm");
    var $geig8 = parcelRequire("geig8");
    var $eVODA = parcelRequire("eVODA");
    const $5e875bf9a5b39360$var$DIALOG_NON_TABLE_HEIGHT = 200;
    const $5e875bf9a5b39360$var$DIALOG_MIN_HEIGHT = 500;
    const $5e875bf9a5b39360$export$1bd567d0d45faa0b = (props, handleStopAction, openDiscardConfirmation)=>{
        const { intl: intl, isLoading: isLoading, isSaving: isSaving, isSavingInterrupted: isSavingInterrupted, isReadOnly: isReadOnly, isReverting: isReverting, isRevertingInterrupted: isRevertingInterrupted, isOutOfSync: isOutOfSync, updateJira: updateJira, selectedChangesCount: selectedChangesCount, isNonPublishingEditor: isNonPublishingEditor, isGicModalOpen: isGicModalOpen = false, clearSummaryPageCache: clearSummaryPageCache, changesCount: changesCount } = props;
        const discardAction = {
            text: intl.formatMessage((0, $cO2Va.default).updateJiraDialogRevertButtonText),
            onClick: openDiscardConfirmation,
            appearance: 'subtle',
            isDisabled: isOutOfSync || isLoading || selectedChangesCount === 0 || isReverting,
            isLoading: false,
            isVisible: !(isSaving || isReadOnly || isReverting),
            testId: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-selected-changes'
        };
        if (!(isSaving || isReverting)) return [
            discardAction,
            {
                text: intl?.formatMessage((0, $cO2Va.default).updateJiraDialogUpdateButtonText),
                type: 'save',
                onClick: (e, analyticsEvent)=>{
                    updateJira(analyticsEvent, props.shouldNotifyWatchers);
                    clearSummaryPageCache();
                    const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SAVE_SELECTED_CHANGES_IN_JIRA_CLICKED.split(' ');
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                        action: action,
                        actionSubject: actionSubject
                    }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SAVE_SELECTED_CHANGES_IN_JIRA_CLICKED, {
                        changesCount: changesCount
                    });
                },
                appearance: 'primary',
                isDisabled: isOutOfSync || isLoading || selectedChangesCount === 0 || isNonPublishingEditor || isGicModalOpen,
                isVisible: !isReadOnly,
                autoFocus: true,
                tooltip: isGicModalOpen ? intl?.formatMessage((0, $cO2Va.default).disabledTooltipForUpdateJiraWhenGicIsOpen) : intl?.formatMessage((0, $cO2Va.default).disabledTooltipForUpdateJira),
                testId: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.save-selected-changes'
            }
        ];
        return [
            {
                text: !(isSavingInterrupted || isRevertingInterrupted) ? intl.formatMessage((0, $cO2Va.default).updateJiraDialogStopButtonText) : intl.formatMessage((0, $cO2Va.default).updateJiraDialogStoppingButtonText),
                onClick: ()=>{
                    handleStopAction();
                },
                isLoading: isSavingInterrupted || isRevertingInterrupted,
                isDisabled: isSavingInterrupted || isRevertingInterrupted
            },
            discardAction
        ];
    };
    class $5e875bf9a5b39360$var$UpdateJira extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                ChangesTable: $eeWRL.default,
                Footer: $cfRKD.default,
                QuickSelectors: $4h04l.default,
                RequiredFieldsDialog: $yFIAE.default,
                ChangeStatusDialog: $hS7Kp.default,
                UserFilter: (0, $8BWE6.default)((0, $6bYOl.default))
            };
        }
        render() {
            const { intl: intl, changes: changes, changesCount: changesCount, isDialogOpen: isDialogOpen, isLoading: isLoading, isSaving: isSaving, isReadOnly: isReadOnly, isOptimizing: isOptimizing, isOptimized: isOptimized, isReverting: isReverting, isOutOfSync: isOutOfSync, onChangeListModified: onChangeListModified, hiddenIssuesDialogIsOpen: hiddenIssuesDialogIsOpen, closeCommitWarningFlag: closeCommitWarningFlag, commitWarningMeta: { commitWarningsExists: commitWarningsExists, shouldShowCommitWarningFlag: shouldShowCommitWarningFlag, successfulCommitCount: successfulCommitCount, failedCommitCount: failedCommitCount }, ChangesTable: ChangesTable, QuickSelectors: QuickSelectors, UserFilter: UserFilter, currentScenarioColor: currentScenarioColor, dateConfiguration: dateConfiguration, typeToLevel: typeToLevel, isIssuesLoading: isIssuesLoading, hasPlanOnlyTeams: hasPlanOnlyTeams } = this.props;
            if (isIssuesLoading) return null;
            let width = 'x-large';
            let height;
            let dialogContent;
            switch(true){
                case isOutOfSync:
                    dialogContent = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $geig8["out-of-sync"]
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                        label: "",
                        dangerouslySetGlyph: (0, ($parcel$interopDefault($biWSr)))
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $geig8["out-of-sync-message"],
                        onClick: this.refresh
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, intl.formatMessage((0, $cO2Va.default).outOfSyncMessageConcurrentEditing)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, intl.formatMessage((0, $cO2Va.default).refreshCtaOld, {
                        span: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                                role: "button",
                                tabIndex: 0
                            }, chunks)
                    }))));
                    break;
                case isLoading:
                    dialogContent = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $geig8.spinner
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), {
                        size: "large"
                    }));
                    break;
                default:
                    width = '90vw';
                    height = Math.max($5e875bf9a5b39360$var$DIALOG_NON_TABLE_HEIGHT + (0, $85c8de56229e3cc7$export$88e6c5bab2ff80e8) * changes.length, $5e875bf9a5b39360$var$DIALOG_MIN_HEIGHT);
                    dialogContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                        space: "space.100",
                        xcss: $5e875bf9a5b39360$var$dialogContentContainerStyles
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "p"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                        ...(0, $cO2Va.default).updateJiraDialogBodyTop,
                        values: {
                            link: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Zxxp")).default), {
                                    articleId: "5jV03VyuxP6cfYQwcKWxWO",
                                    fallbackComponent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cwkM.default), {
                                        href: (0, $4cwkM.default).URLs.committingChangesToJira
                                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cO2Va.default).updateJiraDialogReadMoreText)),
                                    appearance: "link",
                                    spacing: "none",
                                    onClick: this.handleCloseDialog
                                }, chunks)
                        }
                    })), hasPlanOnlyTeams && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "p"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cO2Va.default).updateJiraDialogBodyBottom))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $geig8.filters
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        style: {
                            flexGrow: 1
                        }
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement(QuickSelectors, {
                        changes: changes
                    })), (0, ($parcel$interopDefault($5uXOq))).createElement(UserFilter, null)), (0, ($parcel$interopDefault($5uXOq))).createElement(ChangesTable, {
                        changes: changes,
                        commitWarningsExists: commitWarningsExists,
                        isUpdating: isSaving || isReverting,
                        isReadOnly: isReadOnly,
                        changesCount: changesCount
                    }));
            }
            const headerText = intl.formatMessage((0, $cO2Va.default).updateJiraDialogHeader, {
                changesCount: changesCount
            });
            const shouldIncludeTimeframePlanningAnalyticsAttributes = changesCount > 0 && isDialogOpen && !isLoading && !isSaving && !isReverting;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $geig8.updateJiraButton
            }, (0, $4nDwW.isDefined)(onChangeListModified) && isDialogOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $30u2g.default), {
                onChangeListModified: onChangeListModified,
                changesCount: changesCount,
                isSaving: isSaving
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceName: "reviewChanges",
                sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
                attributes: shouldIncludeTimeframePlanningAnalyticsAttributes ? {
                    roadmapChangeDetails: (0, $eVODA.getAttributesForIssuesWithTimeframeChanges)(changes, dateConfiguration, typeToLevel),
                    changesCount: changesCount
                } : {}
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lSLIm.default), {
                currentScenarioColor: currentScenarioColor,
                changesCount: changesCount,
                isOptimizing: isOptimizing,
                isOptimized: isOptimized,
                isReadOnly: isReadOnly,
                openDialog: this.handleOpenDialog,
                ref: this.buttonRef
            }), isDialogOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.state.openedDialogWithChanges ? this.renderDialog(headerText, dialogContent, width, height) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7zIWQ.default), {
                handleCloseDialog: this.handleCloseDialog
            })), hiddenIssuesDialogIsOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $gZDvj.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $vH6RR.default), {
                successfulCommitCount: successfulCommitCount,
                failedCommitCount: failedCommitCount,
                show: shouldShowCommitWarningFlag,
                onClose: ()=>{
                    closeCommitWarningFlag();
                }
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceName: "discardChanges",
                sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4C5T3.default), {
                isOpen: this.state.isDiscardConfirmationOpen,
                onConfirm: this.handleDiscardConfirmation,
                onCancel: this.closeDiscardConfirmation
            })))));
        }
        constructor(...args){
            super(...args);
            this.buttonRef = (0, $5uXOq.createRef)();
            this.state = {
                isDiscardConfirmationOpen: false,
                openedDialogWithChanges: false
            };
            this.toggleNotification = (next)=>{
                this.props.updateNotificationPreference(next);
            };
            this.openDiscardConfirmation = (_, analyticsEvent)=>{
                const { changesCount: changesCount } = this.props;
                this.setState({
                    isDiscardConfirmationOpen: true
                });
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).DISCARD_SELECTED_CHANGES_CLICKED.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: action,
                    actionSubject: actionSubject
                }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).DISCARD_SELECTED_CHANGES_CLICKED, {
                    changesCount: changesCount
                });
            };
            this.closeDiscardConfirmation = ()=>{
                this.setState({
                    isDiscardConfirmationOpen: false
                });
            };
            this.handleDiscardConfirmation = (_, analyticsEvent)=>{
                this.setState({
                    isDiscardConfirmationOpen: false
                });
                this.props.revertChanges();
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REVERT_SCENARIO.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: action,
                    actionSubject: actionSubject
                }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REVERT_SCENARIO, {
                    changesCount: this.props.selectedChangesCount
                });
            };
            this.refresh = (e)=>{
                if (e.target.getAttribute('role') === 'button') (0, $idmiV.reload)();
            };
            this.handleStopAction = ()=>{
                const { isSaving: isSaving, interruptCommitting: interruptCommitting, interruptReverting: interruptReverting } = this.props;
                if (isSaving) interruptCommitting();
                else interruptReverting();
            };
            this.handleCloseDialog = (_, analyticsEvent)=>{
                const { closeDialog: closeDialog, changesCount: changesCount } = this.props;
                if ((0, $4nDwW.isDefined)(analyticsEvent)) {
                    const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_CANCEL_CLICKED.split(' ');
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                        action: action,
                        actionSubject: actionSubject
                    }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_CANCEL_CLICKED, {
                        changesCount: changesCount
                    });
                }
                closeDialog();
                this.buttonRef.current?.focus();
            };
            this.renderDialog = (headerText, dialogContent, width, height)=>{
                const { intl: intl, selectedChangesCount: selectedChangesCount, RequiredFieldsDialog: RequiredFieldsDialogComponent, ChangeStatusDialog: ChangeStatusDialogComponent, Footer: FooterComponent, changesCount: changesCount, shouldNotifyWatchers: shouldNotifyWatchers, isSaving: isSaving, isReverting: isReverting } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
                    attributes: {
                        changesCount: changesCount
                    }
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                    autoFocus: true,
                    shouldReturnFocus: true,
                    shouldCloseOnEscapePress: !(isSaving || isReverting),
                    onClose: this.handleCloseDialog,
                    shouldCloseOnOverlayClick: false,
                    width: width,
                    height: height
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $5e875bf9a5b39360$var$headerStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dhNbN.default), null, headerText), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    appearance: "subtle",
                    label: intl.formatMessage((0, $cO2Va.default).closeDialog),
                    spacing: "compact",
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ"))))),
                    onClick: this.handleCloseDialog,
                    testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.selected-field-remove-button"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $geig8.body
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $geig8.dialogContent,
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-dialog-content"
                }, dialogContent), (0, ($parcel$interopDefault($5uXOq))).createElement(RequiredFieldsDialogComponent, null), (0, ($parcel$interopDefault($5uXOq))).createElement(ChangeStatusDialogComponent, null)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $geig8.footerParent,
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-dialog-footer"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(FooterComponent, {
                    leftActions: changesCount !== 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $k0aEA.NotificationToggle), {
                        active: shouldNotifyWatchers,
                        onChange: this.toggleNotification
                    }) : null,
                    actions: $5e875bf9a5b39360$export$1bd567d0d45faa0b(this.props, this.handleStopAction, this.openDiscardConfirmation),
                    selectedChangesCount: selectedChangesCount
                }))))));
            };
            this.handleOpenDialog = (e)=>{
                const { openDialog: openDialog, changesCount: changesCount } = this.props;
                this.setState({
                    openedDialogWithChanges: changesCount !== 0
                });
                openDialog(e);
            };
        }
    }
    const $5e875bf9a5b39360$var$headerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.250',
        paddingRight: 'space.250',
        paddingLeft: 'space.250',
        paddingBottom: 'space.100',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    });
    const $5e875bf9a5b39360$var$dialogContentContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.075',
        marginBottom: 'space.150'
    });
    var $5e875bf9a5b39360$export$2e2bcd8739ae039 = (0, $84qTJ.injectIntlWithDefaultProps)($5e875bf9a5b39360$var$UpdateJira);
});
parcelRegister("biWSr", function(module, exports) {
    module.exports = "<svg width=\"200\" height=\"184\" xmlns=\"http://www.w3.org/2000/svg\"><defs><linearGradient x1=\"0%\" y1=\"50.007%\" x2=\"99.999%\" y2=\"50.007%\" id=\"a\"><stop stop-color=\"#6C798F\" offset=\"0%\"></stop><stop stop-color=\"#6C798F\" stop-opacity=\".1\" offset=\"100%\"></stop></linearGradient><linearGradient x1=\"-6635.484%\" y1=\"-2%\" y2=\"-2%\" id=\"b\"><stop stop-color=\"#99C1FF\" stop-opacity=\"0\" offset=\"0%\"></stop><stop stop-color=\"#93BEFF\" stop-opacity=\".04\" offset=\"1%\"></stop><stop stop-color=\"#78ADFF\" stop-opacity=\".22\" offset=\"5%\"></stop><stop stop-color=\"#5E9EFF\" stop-opacity=\".38\" offset=\"9%\"></stop><stop stop-color=\"#4790FF\" stop-opacity=\".53\" offset=\"14%\"></stop><stop stop-color=\"#3484FF\" stop-opacity=\".66\" offset=\"20%\"></stop><stop stop-color=\"#247AFF\" stop-opacity=\".77\" offset=\"25%\"></stop><stop stop-color=\"#1672FF\" stop-opacity=\".85\" offset=\"32%\"></stop><stop stop-color=\"#0C6CFF\" stop-opacity=\".92\" offset=\"40%\"></stop><stop stop-color=\"#0568FF\" stop-opacity=\".97\" offset=\"49%\"></stop><stop stop-color=\"#0166FF\" stop-opacity=\".99\" offset=\"63%\"></stop><stop stop-color=\"#0065FF\" offset=\"100%\"></stop></linearGradient><linearGradient x1=\"0%\" y1=\"14049%\" x2=\"10440%\" y2=\"14049%\" id=\"c\"><stop stop-color=\"#99C1FF\" stop-opacity=\"0\" offset=\"0%\"></stop><stop stop-color=\"#93BEFF\" stop-opacity=\".04\" offset=\"1%\"></stop><stop stop-color=\"#78ADFF\" stop-opacity=\".22\" offset=\"5%\"></stop><stop stop-color=\"#5E9EFF\" stop-opacity=\".38\" offset=\"9%\"></stop><stop stop-color=\"#4790FF\" stop-opacity=\".53\" offset=\"14%\"></stop><stop stop-color=\"#3484FF\" stop-opacity=\".66\" offset=\"20%\"></stop><stop stop-color=\"#247AFF\" stop-opacity=\".77\" offset=\"25%\"></stop><stop stop-color=\"#1672FF\" stop-opacity=\".85\" offset=\"32%\"></stop><stop stop-color=\"#0C6CFF\" stop-opacity=\".92\" offset=\"40%\"></stop><stop stop-color=\"#0568FF\" stop-opacity=\".97\" offset=\"49%\"></stop><stop stop-color=\"#0166FF\" stop-opacity=\".99\" offset=\"63%\"></stop><stop stop-color=\"#0065FF\" offset=\"100%\"></stop></linearGradient></defs><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M106 167.73v-39.56A40.57 40.57 0 1 0 65.45 87.6H25.88c-.004-32.416 19.521-61.643 49.47-74.049 29.948-12.406 64.42-5.548 87.341 17.375 22.92 22.923 29.774 57.397 17.364 87.344-12.41 29.947-41.639 49.468-74.055 49.46z\" fill=\"url(#a)\" transform=\"translate(-1 8)\"></path><path d=\"M101.85 169.27v-39.56c22.406 0 40.57-18.164 40.57-40.57s-18.164-40.57-40.57-40.57-40.57 18.164-40.57 40.57H21.71C21.71 44.88 57.59 9 101.85 9s80.14 35.88 80.14 80.14-35.88 80.14-80.14 80.14v-.01z\" fill=\"#0065FF\"></path><path d=\"M182 89.14c.088-42.717-33.345-77.995-76.005-80.199-42.66-2.204-79.55 29.44-83.865 71.939L8.75 79.67a3.06 3.06 0 0 0-2.62 5l30.56 36.63c1.08 1.3 3 1.47 3.4.39l36.63-30.57c3-1.75 1.93-5.15-.78-5.4l-14.38-1.3c2.525-21.65 21.705-37.435 43.436-35.748 21.731 1.686 38.246 20.242 37.4 42.022-.846 21.78-18.75 39-40.546 38.996h1.55v39.53c43.618-.876 78.538-36.453 78.6-80.08z\" fill=\"#0065FF\"></path><path d=\"M104.4 161.27h-1.55 1.55z\" fill=\"url(#b)\" transform=\"translate(-1 8)\"></path><path fill=\"url(#c)\" d=\"M0 121.71h102.85v39.57H0z\" transform=\"translate(-1 8)\"></path><path d=\"M101.85 129.71v39.57h1.55v-39.57h-1.55z\" fill=\"#0065FF\"></path><path d=\"M102.85 121.71v39.57h1.55v-39.57h-1.55z\" fill=\"url(#c)\" transform=\"translate(-1 8)\"></path></g></svg>";
});
parcelRegister("gZDvj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee8574fe7dabe349$export$2e2bcd8739ae039);
    var $bC2fB;
    var $jIjPO = parcelRequire("jIjPO");
    var $i8MbW = parcelRequire("i8MbW");
    var $lphh7 = parcelRequire("lphh7");
    var $ee8574fe7dabe349$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $i8MbW.default), (0, $jIjPO.default))((0, $lphh7.default));
});
parcelRegister("jIjPO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0654c64089a2ac3$export$2e2bcd8739ae039);
    const $e0654c64089a2ac3$var$mapDispatchToProps = (dispatch)=>({
            closeDialog: ()=>{
                dispatch({
                    type: (0, $0477a90a9bc5200c$export$b1f17581bba10917)
                });
            }
        });
    var $e0654c64089a2ac3$export$2e2bcd8739ae039 = $e0654c64089a2ac3$var$mapDispatchToProps;
});
parcelRegister("i8MbW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$998b21591018add7$export$2e2bcd8739ae039);
    var $jpXKt = parcelRequire("jpXKt");
    var $25viM = parcelRequire("25viM");
    var $3YtPS = parcelRequire("3YtPS");
    const $998b21591018add7$var$getDialogVisibilityState = (state)=>state.ui.Top.TitleBar.HiddenIssues.isDialogOpen;
    const $998b21591018add7$var$mapStateToProps = (0, $3YtPS.createSelector)([
        $998b21591018add7$var$getDialogVisibilityState,
        (0, $jpXKt.getProjects),
        (0, $25viM.getHiddenIssues)
    ], (isDialogOpen, projects, hiddenIssues)=>({
            isDialogOpen: isDialogOpen,
            projects: projects,
            hiddenIssues: hiddenIssues
        }));
    var $998b21591018add7$export$2e2bcd8739ae039 = $998b21591018add7$var$mapStateToProps;
});
parcelRegister("lphh7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b3813fef55072c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2hXfb;
    var $d4xRU;
    var $3KRpp;
    var $koVbs;
    var $eJyeb = parcelRequire("eJyeb");
    var $4nDwW = parcelRequire("4nDwW");
    var $idmiV = parcelRequire("idmiV");
    var $jb48y = parcelRequire("jb48y");
    function $5b3813fef55072c4$var$HiddenIssuesDialog({ closeDialog: closeDialog, hiddenIssues: hiddenIssues, isDialogOpen: isDialogOpen, projects: projects }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectsById = (0, $4nDwW.indexBy)((project)=>project.id, projects);
        const issueKeys = hiddenIssues.map((issue)=>{
            const project = projectsById[issue.projectId];
            return `${project.key}-${issue.issueKey}`;
        });
        let title;
        let description;
        if (hiddenIssues.length === 1) {
            const hiddenIssuesUrl = (0, $eJyeb.proxyContextSafeUrl)(`/browse/${issueKeys[0]}`);
            title = (0, ($parcel$interopDefault($5uXOq))).createElement($5b3813fef55072c4$var$BaseButtonContainer, {
                role: "button",
                tabIndex: 0,
                onClick: ()=>(0, $idmiV.openInNewTab)(hiddenIssuesUrl),
                onKeyDown: ()=>(0, $idmiV.openInNewTab)(hiddenIssuesUrl)
            }, formatMessage((0, $jb48y.default).issueNotVisibleHeader, {
                issueKey: issueKeys[0],
                span: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", null, chunk)
            }));
            description = formatMessage((0, $jb48y.default).issueNotVisible);
        } else {
            const hiddenIssuesUrl = (0, $eJyeb.proxyContextSafeUrl)(`/issues/?jql=key in (${issueKeys.join(', ')}) order by key`);
            title = (0, ($parcel$interopDefault($5uXOq))).createElement($5b3813fef55072c4$var$BaseButtonContainer, {
                role: "button",
                tabIndex: 0,
                onClick: ()=>(0, $idmiV.openInNewTab)(hiddenIssuesUrl),
                onKeyDown: ()=>(0, $idmiV.openInNewTab)(hiddenIssuesUrl)
            }, formatMessage((0, $jb48y.default).issuesNotVisibleHeader, {
                numIssues: hiddenIssues.length,
                span: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", null, chunk)
            }));
            description = formatMessage((0, $jb48y.default).issuesNotVisible);
        }
        return isDialogOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).FlagGroup), {
            onDismissed: closeDialog
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2hXfb"))))), {
                label: "",
                primaryColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$exports).P300})`
            }),
            id: "hidden-issues-info-flag",
            title: title,
            description: description
        })) : null;
    }
    var $5b3813fef55072c4$export$2e2bcd8739ae039 = $5b3813fef55072c4$var$HiddenIssuesDialog;
    const $5b3813fef55072c4$var$BaseButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tjqh6uv _1myktlke _hhgo18uv _110q8stv _1newnqa1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jb48y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8017e2876a7e0af6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8017e2876a7e0af6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueNotVisibleHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.hidden-issues.issue-not-visible-header",
            "defaultMessage": "<span>{issueKey}</span> is no longer visible in your plan"
        },
        issueNotVisible: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.hidden-issues.issue-not-visible",
            "defaultMessage": "This issue is missing some details that are specified in the issue sources of your plan. To make this issue visible, add these missing details to the issue."
        },
        issuesNotVisibleHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.hidden-issues.issues-not-visible-header",
            "defaultMessage": "<span>{numIssues} issues</span> are no longer visible in your plan"
        },
        issuesNotVisible: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.hidden-issues.issues-not-visible",
            "defaultMessage": "These issues are missing some details that are specified in the issue sources of your plan. To make these issues visible, add these missing details to the issues."
        }
    });
});
parcelRegister("hS7Kp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc5b25b93a0f7337$export$2e2bcd8739ae039);
    var $bC2fB;
    var $j3NJ0 = parcelRequire("j3NJ0");
    var $fVKkY = parcelRequire("fVKkY");
    var $6G9Nl = parcelRequire("6G9Nl");
    var $cc5b25b93a0f7337$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $fVKkY.default), (0, $j3NJ0.default))((0, $6G9Nl.default));
});
parcelRegister("j3NJ0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67f43be204c2955f$export$2e2bcd8739ae039);
    var $gpDcx = parcelRequire("gpDcx");
    var $67f43be204c2955f$export$2e2bcd8739ae039 = (dispatch)=>({
            success: ()=>{
                dispatch((0, $gpDcx.success)());
            },
            fail: ()=>{
                dispatch((0, $gpDcx.fail)());
            },
            cancel: ()=>{
                dispatch((0, $gpDcx.cancel)());
            }
        });
});
parcelRegister("fVKkY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92ae65ec1e95de24$export$2e2bcd8739ae039);
    var $3YtPS = parcelRequire("3YtPS");
    const $92ae65ec1e95de24$var$getChangeStatusDialog = (state)=>state.domain.updateJira.changeStatus;
    const $92ae65ec1e95de24$var$mapStateToProps = (0, $3YtPS.createSelector)([
        $92ae65ec1e95de24$var$getChangeStatusDialog
    ], (changeStatus)=>({
            ...changeStatus
        }));
    var $92ae65ec1e95de24$export$2e2bcd8739ae039 = $92ae65ec1e95de24$var$mapStateToProps;
});
parcelRegister("6G9Nl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8bcf0eff246a207$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $jpZIw;
    var $7k8fo;
    var $dXq4S;
    var $g5X3G;
    var $koeKL;
    const $b8bcf0eff246a207$var$getAriIssueId = (issueId = '', cloudId = '')=>(0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: issueId ?? ''
        });
    const $b8bcf0eff246a207$var$FocusUnlock = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
            whiteList: (0, $5uXOq.useCallback)(()=>false, []),
            returnFocus: true,
            autoFocus: false
        });
    const $b8bcf0eff246a207$var$ChangeStatusDialog = ({ isWaiting: isWaiting, issueKeyInJira: issueKeyInJira, transitionId: transitionId, issueId: issueId, success: success, fail: fail, cancel: cancel })=>{
        const openIssueTransitionModal = (0, (0, parcelRequire("jpZIw")).useOpenIssueTransitionModal)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isWaiting) return;
            const handleDialogSuccess = ()=>success();
            const handleDialogCancel = ()=>cancel();
            const handleDialogError = ()=>fail();
            const issueKey = (0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKeyInJira || '');
            const transitionIdString = transitionId || '';
            const ariIssueId = $b8bcf0eff246a207$var$getAriIssueId(issueId, cloudId);
            openIssueTransitionModal?.({
                payload: {
                    issueId: ariIssueId,
                    issueKey: issueKey,
                    transitionId: transitionIdString
                },
                triggerPointKey: 'issue-transition-advanced-roadmaps-jira-transition',
                onDialogSuccess: handleDialogSuccess,
                onDialogCancel: handleDialogCancel,
                onDialogError: handleDialogError
            });
        }, [
            isWaiting,
            issueKeyInJira,
            transitionId,
            success,
            cancel,
            fail,
            openIssueTransitionModal,
            issueId,
            cloudId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7k8fo")).default), null, (stackIndex)=>stackIndex ? (0, ($parcel$interopDefault($5uXOq))).createElement($b8bcf0eff246a207$var$FocusUnlock, null) : null);
    };
    var $b8bcf0eff246a207$export$2e2bcd8739ae039 = $b8bcf0eff246a207$var$ChangeStatusDialog;
});
parcelRegister("7k8fo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfab18894e2c8c3f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $dfab18894e2c8c3f$var$isAuiDialogEvent = (ev)=>{
        if (!(ev instanceof CustomEvent)) return false;
        const hasAuiDialogElement = ev.detail?.layerElement?.classList?.contains('aui-dialog2');
        return hasAuiDialogElement;
    };
    class $dfab18894e2c8c3f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            document.addEventListener('legacyJiraDialogBeforeShow', this.incrementStackIndex);
            document.addEventListener('legacyJiraDialogBeforeHide', this.decrementStackIndex);
            document.addEventListener('on-before-aui-layer-show', this.incrementStackIndexWhenAuiDialog);
            document.addEventListener('on-before-aui-layer-hide', this.decrementStackIndexWhenAuiDialog);
        }
        componentWillUnmount() {
            document.removeEventListener('legacyJiraDialogBeforeShow', this.incrementStackIndex);
            document.removeEventListener('legacyJiraDialogBeforeHide', this.decrementStackIndex);
            document.removeEventListener('on-before-aui-layer-show', this.incrementStackIndexWhenAuiDialog);
            document.removeEventListener('on-before-aui-layer-hide', this.decrementStackIndexWhenAuiDialog);
        }
        render() {
            return this.props.children(this.state.stackIndex);
        }
        constructor(...args){
            super(...args);
            this.state = {
                stackIndex: 0
            };
            this.incrementStackIndex = ()=>{
                this.setState((oldState)=>({
                        stackIndex: oldState.stackIndex + 1
                    }));
            };
            this.decrementStackIndex = ()=>{
                this.setState((oldState)=>({
                        stackIndex: oldState.stackIndex - 1
                    }));
            };
            this.incrementStackIndexWhenAuiDialog = (ev)=>{
                if (!$dfab18894e2c8c3f$var$isAuiDialogEvent(ev)) return;
                this.incrementStackIndex();
            };
            this.decrementStackIndexWhenAuiDialog = (ev)=>{
                if (!$dfab18894e2c8c3f$var$isAuiDialogEvent(ev)) return;
                this.decrementStackIndex();
            };
        }
    }
});
parcelRegister("30u2g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa30e0e8441a8beb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $fa30e0e8441a8beb$var$ChangesCountMonitor = ({ changesCount: changesCount, onChangeListModified: onChangeListModified, isSaving: isSaving })=>{
        const lastCount = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isSaving) {
                if (lastCount.current !== undefined && lastCount.current !== changesCount) onChangeListModified();
                lastCount.current = changesCount;
            }
        }, [
            changesCount,
            onChangeListModified,
            isSaving
        ]);
        return null;
    };
    var $fa30e0e8441a8beb$export$2e2bcd8739ae039 = $fa30e0e8441a8beb$var$ChangesCountMonitor;
});
parcelRegister("vH6RR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45747d8cb27f6778$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $btivG;
    var $gtreQ;
    var $7R4eB;
    var $d4xRU;
    var $3KRpp;
    var $ousew;
    var $gJZ5D;
    var $aPDFE = parcelRequire("aPDFE");
    function $45747d8cb27f6778$var$CommitWarningNotification(props) {
        const { show: show, failedCommitCount: failedCommitCount, successfulCommitCount: successfulCommitCount, onClose: onClose } = props;
        if (!show) return null;
        let title;
        let description;
        let icon;
        const onlySuccessful = successfulCommitCount && !failedCommitCount;
        if (onlySuccessful) {
            title = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $aPDFE.default).successHeaderText);
            description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $aPDFE.default).successContentText,
                values: {
                    successfulCommitCount: successfulCommitCount
                }
            });
            icon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
                label: "",
                primaryColor: `var(--ds-icon-success, ${(0, (0, parcelRequire("gJZ5D")).default).G300})`
            });
        } else {
            title = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $aPDFE.default).warningHeaderText,
                values: {
                    successfulCommitCount: successfulCommitCount
                }
            });
            if (!successfulCommitCount) description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $aPDFE.default).warningContentText,
                values: {
                    failedCommitCount: failedCommitCount
                }
            });
            else description = (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $aPDFE.default).warningWithSuccessContentSuccessText,
                values: {
                    successfulCommitCount: successfulCommitCount
                }
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $aPDFE.default).warningWithSuccessContentWarningText,
                values: {
                    failedCommitCount: failedCommitCount
                }
            })));
            icon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                label: "",
                primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).FlagGroup), {
            onDismissed: onClose
        }, onlySuccessful ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7R4eB")).default), {
            id: "portfolio-3-app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification",
            title: title,
            description: description,
            icon: icon,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.auto-dismiss-flag"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            id: "commit-warning-modification-flag",
            title: title,
            description: description,
            icon: icon
        }));
    }
    var $45747d8cb27f6778$export$2e2bcd8739ae039 = $45747d8cb27f6778$var$CommitWarningNotification;
});
parcelRegister("aPDFE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d123da63b3b2634d$export$2e2bcd8739ae039);
    var $7VHMR;
    const $d123da63b3b2634d$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        warningHeaderText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.warning-header-text",
            "defaultMessage": "{successfulCommitCount, plural, =0 {Changes couldn't be saved} other {Some changes couldn't be saved}}"
        },
        warningWithSuccessContentSuccessText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.warning-with-success-content-success-text",
            "defaultMessage": "{successfulCommitCount, plural, one {# change was} other {# changes were}} successfully saved to your plan."
        },
        warningWithSuccessContentWarningText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.warning-with-success-content-warning-text",
            "defaultMessage": "However, {failedCommitCount, plural, one {# change} other {# changes}} could not be committed."
        },
        warningContentText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.warning-content-text",
            "defaultMessage": "{failedCommitCount, plural, =0 {Your plan is out of sync due to concurrent editing.} one {# change couldn't be saved.} other {# changes couldn't be saved.}}"
        },
        successHeaderText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.success-header-text",
            "defaultMessage": "Success"
        },
        successContentText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.success-content-text",
            "defaultMessage": "{successfulCommitCount, plural, one {# change was} other {# changes were}} successfully saved in Jira."
        }
    });
    var $d123da63b3b2634d$export$2e2bcd8739ae039 = $d123da63b3b2634d$var$messages;
});
const $85c8de56229e3cc7$export$88e6c5bab2ff80e8 = 30;
parcelRegister("eeWRL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87773c7e17b6476a$export$2e2bcd8739ae039);
    var $eTh6Z = parcelRequire("eTh6Z");
    var $bC2fB;
    var $aT1oD = parcelRequire("aT1oD");
    var $3ynIE = parcelRequire("3ynIE");
    var $4yDrk = parcelRequire("4yDrk");
    var $87773c7e17b6476a$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($eTh6Z)))((0, $4yDrk.withScrollTracking), (0, (0, parcelRequire("bC2fB")).connect)((0, $3ynIE.default), (0, $aT1oD.default)))((0, $4yDrk.default));
});
parcelRegister("eTh6Z", function(module, exports) {
    module.exports = (parcelRequire("dfIYp"));
});
parcelRegister("dfIYp", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $9a5f8fdb0f7ea6a9$var$func = $lVx1a('flowRight', (parcelRequire("gQpZf")));
    $9a5f8fdb0f7ea6a9$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $9a5f8fdb0f7ea6a9$var$func;
});
parcelRegister("gQpZf", function(module, exports) {
    var $2cFTm = parcelRequire("2cFTm");
    var $c435a924a6b06c3e$var$flowRight = $2cFTm(true);
    module.exports = $c435a924a6b06c3e$var$flowRight;
});
parcelRegister("aT1oD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4d9156a4ca1e2f5$export$2e2bcd8739ae039);
    var $aHSC5 = parcelRequire("aHSC5");
    var $f4d9156a4ca1e2f5$export$2e2bcd8739ae039 = (dispatch)=>({
            sortChanges: (sortBy, sortDirection)=>{
                dispatch((0, $aHSC5.sortChanges)(sortBy, sortDirection));
            }
        });
});
parcelRegister("3ynIE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d44b47149ac43b13$export$2e2bcd8739ae039);
    var $25viM = parcelRequire("25viM");
    var $3YtPS = parcelRequire("3YtPS");
    var $d44b47149ac43b13$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        sortBy: (0, $25viM.getSortBy),
        sortDirection: (0, $25viM.getSortDirection)
    });
});
parcelRegister("4yDrk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44f82e9d63ececb4$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "withScrollTracking", ()=>$44f82e9d63ececb4$export$391633ede08dabb1);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8CUq3;
    var $koVbs;
    var $TMTLS = parcelRequire("TMTLS");
    var $i2qlb = parcelRequire("i2qlb");
    var $ihPUd = parcelRequire("ihPUd");
    var $leRLW;
    var $lvtWn;
    var $2KkNy;
    var $8FWzM = parcelRequire("8FWzM");
    var $4UPk3 = parcelRequire("4UPk3");
    var $hZKo2 = parcelRequire("hZKo2");
    var $5m4E3 = parcelRequire("5m4E3");
    const $44f82e9d63ececb4$var$stickyOffset = {
        vertical: 0,
        horizontal: 0
    };
    function $44f82e9d63ececb4$export$2e2bcd8739ae039({ changes: changes, isUpdating: isUpdating, commitWarningsExists: commitWarningsExists, isReadOnly: isReadOnly, changesCount: changesCount }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [gridRows, setGridRows] = (0, $5uXOq.useState)([]);
        const [rowConfig, setRowConfig] = (0, $5uXOq.useState)([]);
        const [columnConfig, setColumnConfig] = (0, $5uXOq.useState)([]);
        const colConfigs = (0, $5uXOq.useCallback)(()=>{
            const configs = [
                {
                    id: 'details',
                    sticky: false,
                    name: formatMessage((0, $hZKo2.default).titleColumnHeader),
                    width: 120
                },
                {
                    id: 'category',
                    sticky: false,
                    name: formatMessage((0, $hZKo2.default).categoryColumnHeader),
                    width: 40
                },
                {
                    id: 'type',
                    sticky: false,
                    name: formatMessage((0, $hZKo2.default).whatChangedColumnHeader),
                    width: 45
                },
                {
                    id: 'current',
                    sticky: false,
                    name: '',
                    width: 32
                },
                {
                    id: 'new',
                    sticky: false,
                    name: formatMessage((0, $ihPUd.default).new),
                    width: 32
                },
                {
                    id: 'lastModified',
                    sticky: false,
                    name: formatMessage((0, $hZKo2.default).lastModifiedColumnHeader),
                    width: 28
                }
            ];
            if (!isReadOnly) configs.unshift({
                id: 'isSelected',
                sticky: false,
                name: '',
                width: 7
            });
            if (commitWarningsExists) configs.unshift({
                id: 'warnings',
                sticky: false,
                name: '',
                width: 7
            });
            return configs;
        }, [
            isReadOnly,
            commitWarningsExists,
            formatMessage
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const rowsList = [
                {
                    tag: 'HEADER',
                    content: 'header'
                }
            ];
            const rowConfigs = [
                {
                    sticky: true,
                    height: 25,
                    thead: true,
                    top: 0
                }
            ];
            changes.forEach((x, i)=>{
                rowsList.push({
                    tag: 'BODY',
                    content: `content${i + 1}`
                });
                rowConfigs.push({
                    sticky: false,
                    height: 30,
                    thead: false,
                    top: 25 + i * 30
                });
            });
            setGridRows(rowsList);
            setRowConfig(rowConfigs);
            setColumnConfig(colConfigs());
        }, [
            changes,
            colConfigs
        ]);
        const renderRow = (_row, _columns, index)=>{
            const row = gridRows[index];
            if (row.tag === 'HEADER') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4UPk3.default), {
                index: index,
                columns: _columns,
                columnConfig: columnConfig,
                changes: changes,
                commitWarningsExists: commitWarningsExists,
                isReadOnly: isReadOnly,
                isUpdating: isUpdating
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8FWzM.default), {
                key: index,
                rowIndex: index,
                columnConfig: columnConfig,
                change: changes[index - 1],
                isUpdating: isUpdating
            });
        };
        const columnWidths = (0, $5uXOq.useMemo)(()=>{
            const widths = [];
            columnConfig.forEach((col)=>{
                widths.push(col.width);
            });
            return widths;
        }, [
            columnConfig
        ]);
        const emptyRow = (height)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
                index: -1,
                height: height
            });
        const uniq = (a)=>Array.from(new Set(a));
        const makeRangeExtractor = (_rowConfig)=>({ above: above, within: within, below: below })=>{
                for(let cursor = (within[0] ?? 0) - 1; cursor >= 0; cursor--)if (_rowConfig[cursor].sticky) {
                    const additional = above.includes(cursor) ? [] : [
                        cursor
                    ];
                    return uniq([
                        0,
                        ...additional,
                        ...above,
                        ...within,
                        ...below
                    ]);
                }
                return uniq([
                    0,
                    ...above,
                    ...within,
                    ...below
                ]);
            };
        const rangeExtractor = (0, $5uXOq.useMemo)(()=>makeRangeExtractor(rowConfig), [
            makeRangeExtractor,
            rowConfig
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("leRLW")).Container), {
            xcss: [
                $44f82e9d63ececb4$var$gridContainerStyles
            ],
            "data-scroll": "lockable"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5m4E3.default), {
            changes: changes,
            changesCount: changesCount
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lvtWn")).Grid), {
            columnWidths: columnWidths,
            columnConfigs: columnConfig,
            rowConfigs: rowConfig,
            row: renderRow,
            empty: emptyRow,
            overscan: 10,
            onColumnWidthsChange: (0, ($parcel$interopDefault($8Rkzz))),
            stickyOffset: $44f82e9d63ececb4$var$stickyOffset,
            ariaLabel: formatMessage((0, $hZKo2.default).tableAriaLabel),
            role: "grid",
            rangeExtractor: rangeExtractor,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table",
            dataName: "update-jira-dialog-content"
        }, (table)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, table)));
    }
    const $44f82e9d63ececb4$export$391633ede08dabb1 = (WrappedComponent)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $TMTLS.default), {
                analyticsEvent: (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).COMMIT_MODAL_SCROLLED
            }, (handleScroll)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...props,
                    handleScroll: handleScroll
                }));
    const $44f82e9d63ececb4$var$gridContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: '1 1 auto',
        overflowY: 'auto',
        marginTop: 'space.200',
        marginBottom: 'space.200',
        marginLeft: 'space.0',
        marginRight: 'space.0'
    });
});
parcelRegister("TMTLS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3cbfe3cbafdced97$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $c0cft = parcelRequire("c0cft");
    const $3cbfe3cbafdced97$var$ScrollLongTaskAnalytics = (0, $5uXOq.memo)(({ attributes: attributes, analyticsEvent: analyticsEvent, children: children, includeFirstScroll: includeFirstScroll = false, delay: delay = (0, $f3558fde0349ba17$export$3e6e59880a7a1435) })=>{
        const isInitialTimeout = (0, $5uXOq.useRef)(!includeFirstScroll);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleScroll = ()=>{
            if (isInitialTimeout.current) {
                isInitialTimeout.current = false;
                return;
            }
            (0, $c0cft.longTask).trackWithTimeout(analyticsEvent, createAnalyticsEvent, delay, attributes);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children(handleScroll));
    });
    var $3cbfe3cbafdced97$export$2e2bcd8739ae039 = $3cbfe3cbafdced97$var$ScrollLongTaskAnalytics;
});
const $f3558fde0349ba17$export$3e6e59880a7a1435 = 300;
parcelRegister("c0cft", function(module, exports) {
    $parcel$export(module.exports, "longTask", ()=>$b6b0298add3cf827$export$be097c2d334688c0);
    $parcel$export(module.exports, "context", ()=>$b6b0298add3cf827$export$a078c61943f9dbbe);
    $parcel$export(module.exports, "default", ()=>$b6b0298add3cf827$export$2e2bcd8739ae039);
    var $4ENQh;
    var $7XAb4;
    var $8zOmE;
    var $i2qlb = parcelRequire("i2qlb");
    const $b6b0298add3cf827$export$be097c2d334688c0 = (0, (0, parcelRequire("7XAb4")).default)((0, (0, parcelRequire("4ENQh")).SPA_APP_NAME));
    const $b6b0298add3cf827$export$a078c61943f9dbbe = {
        PLAN: 'plan',
        PROGRAM: 'program',
        TEAMS: 'teams'
    };
    function $b6b0298add3cf827$var$getGasV3TrackEventTriggerFn(eventName, actionSubjectId) {
        return function triggerTrackAnalyticsEvent(analyticsEvent, metaData = {}) {
            if (actionSubjectId) {
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, eventName, actionSubjectId, metaData);
                return;
            }
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, eventName, metaData);
        };
    }
    const $b6b0298add3cf827$var$triggerCalculationDurationAnalytics = $b6b0298add3cf827$var$getGasV3TrackEventTriggerFn((0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CALCULATE_PLAN);
    const $b6b0298add3cf827$var$triggerCreateCrossProjectReleaseAnalytics = $b6b0298add3cf827$var$getGasV3TrackEventTriggerFn((0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CREATE_CROSS_PROJECT_RELEASE);
    const $b6b0298add3cf827$var$triggerUpdateJiraEventAnalytics = $b6b0298add3cf827$var$getGasV3TrackEventTriggerFn((0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_JIRA);
    function $b6b0298add3cf827$var$triggerViewRoadmapEventAnalytics(analyticsEvent, group, colourByOption, colours, sortByField, teamsTotalCount, teamsScrumCount, teamsKanbanCount, teamsSharedCount, externalTeamsTotalCount, sourcesTotalCount, sourcesBoardCount, sourcesProjectCount, sourcesFilterCount, rollupSettings, showSprints, showWarnings, planPermission, instancePermission, planningUnit, sprintActiveCount, sprintFutureCount, sprintFutureSetDates, sprintFutureInferredDates, hasSprintsWithInconsistentDates, hasAtlasPermissions, isAtlasConnectInstalled, timelineType, customTimelineType, fieldColumns, issuesCount, dependenciesCount, dependenciesViewSetting, issuesWithFixedStartDateCount, issuesWithFixedEndDateCount, issuesWithSprintStartDateCount, issuesWithSprintEndDateCount, issuesWithReleaseStartDateCount, issuesWithReleaseEndDateCount, viewsInPlanCount, viewsWithDependencyBadgesCount, viewsWithDependencyLinesCount, viewsWithDependencyCountCount, planCreatedDate, teamsShownInPlan, projectsShownInPlan, boardsShownInPlan, filtersShownInPlan, sourcesProjectCountJswCmpCount, sourcesProjectCountJswTmpCount, sourcesProjectCountJwmCmpCount, sourcesProjectCountJwmTmpCount, sourcesProjectCountJsmCmpCount, sourcesProjectCountCmpCount, sourcesProjectCountTmpCount, isMultiScenariosEnabled, scenariosCount, hierarchyLevels, selectedFilters, isSamplePlan, maxOverlappingSprints, autoSchedulerEnabled, fiscalMonth, viewMode, urlPersistenceEstimate, isMacroProxy) {
        const { showingRolledUpDate: showingRolledUpDate, showRolledUpOthers: showRolledUpOthers } = rollupSettings;
        const payload = {
            group: group,
            colourByOption: colourByOption,
            colours: colours,
            sortByField: sortByField,
            teamsTotalCount: teamsTotalCount,
            teamsScrumCount: teamsScrumCount,
            teamsKanbanCount: teamsKanbanCount,
            teamsSharedCount: teamsSharedCount,
            externalTeamsTotalCount: externalTeamsTotalCount,
            sourcesTotalCount: sourcesTotalCount,
            sourcesBoardCount: sourcesBoardCount,
            sourcesProjectCount: sourcesProjectCount,
            sourcesFilterCount: sourcesFilterCount,
            showingRolledUpDate: showingRolledUpDate,
            showRolledUpOthers: showRolledUpOthers,
            showSprints: showSprints,
            showWarnings: showWarnings,
            planPermission: planPermission,
            instancePermission: instancePermission,
            planningUnit: planningUnit,
            sprintActiveCount: sprintActiveCount,
            sprintFutureCount: sprintFutureCount,
            sprintFutureSetDates: sprintFutureSetDates,
            sprintFutureInferredDates: sprintFutureInferredDates,
            hasSprintsWithInconsistentDates: hasSprintsWithInconsistentDates,
            hasAtlasPermissions: hasAtlasPermissions,
            isAtlasConnectInstalled: isAtlasConnectInstalled,
            customTimelineType: customTimelineType,
            timelineType: timelineType,
            fieldColumns: fieldColumns,
            issuesCount: issuesCount,
            dependenciesCount: dependenciesCount,
            dependenciesViewSetting: dependenciesViewSetting,
            issuesWithFixedStartDateCount: issuesWithFixedStartDateCount,
            issuesWithFixedEndDateCount: issuesWithFixedEndDateCount,
            issuesWithSprintStartDateCount: issuesWithSprintStartDateCount,
            issuesWithSprintEndDateCount: issuesWithSprintEndDateCount,
            issuesWithReleaseStartDateCount: issuesWithReleaseStartDateCount,
            issuesWithReleaseEndDateCount: issuesWithReleaseEndDateCount,
            viewsInPlanCount: viewsInPlanCount,
            viewsWithDependencyBadgesCount: viewsWithDependencyBadgesCount,
            viewsWithDependencyLinesCount: viewsWithDependencyLinesCount,
            viewsWithDependencyCountCount: viewsWithDependencyCountCount,
            planCreatedDate: planCreatedDate,
            teamsShownInPlan: teamsShownInPlan,
            projectsShownInPlan: projectsShownInPlan,
            boardsShownInPlan: boardsShownInPlan,
            filtersShownInPlan: filtersShownInPlan,
            sourcesProjectCountJswCmpCount: sourcesProjectCountJswCmpCount,
            sourcesProjectCountJswTmpCount: sourcesProjectCountJswTmpCount,
            sourcesProjectCountJwmCmpCount: sourcesProjectCountJwmCmpCount,
            sourcesProjectCountJwmTmpCount: sourcesProjectCountJwmTmpCount,
            sourcesProjectCountJsmCmpCount: sourcesProjectCountJsmCmpCount,
            sourcesProjectCountCmpCount: sourcesProjectCountCmpCount,
            sourcesProjectCountTmpCount: sourcesProjectCountTmpCount,
            isMultiScenariosEnabled: isMultiScenariosEnabled,
            scenariosCount: scenariosCount,
            hierarchyLevels: hierarchyLevels,
            selectedFilters: selectedFilters,
            isSamplePlan: isSamplePlan,
            maxOverlappingSprints: maxOverlappingSprints,
            autoSchedulerEnabled: autoSchedulerEnabled,
            fiscalMonth: fiscalMonth,
            viewMode: viewMode,
            urlPersistenceEstimate: urlPersistenceEstimate,
            isMacroProxy: isMacroProxy
        };
        (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics)(analyticsEvent, payload);
    }
    var $b6b0298add3cf827$export$2e2bcd8739ae039 = {
        triggerUpdateJiraEventAnalytics: $b6b0298add3cf827$var$triggerUpdateJiraEventAnalytics,
        triggerViewRoadmapEventAnalytics: $b6b0298add3cf827$var$triggerViewRoadmapEventAnalytics,
        triggerCalculationDurationAnalytics: $b6b0298add3cf827$var$triggerCalculationDurationAnalytics,
        triggerCreateCrossProjectReleaseAnalytics: $b6b0298add3cf827$var$triggerCreateCrossProjectReleaseAnalytics
    };
});
parcelRegister("7XAb4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5e04866f173da80$export$2e2bcd8739ae039);
    var $7wqBZ;
    var $if7bx;
    var $8CsHB;
    var $cJpFl;
    var $8zOmE;
    const $f5e04866f173da80$export$fd37aa2563e8b3e8 = (analyticsEvent, offset = 0, additionalAttributes)=>(observationData)=>{
            if ((0, (0, parcelRequire("cJpFl")).isExpandedObservationData)(observationData)) {
                const eventStartTimes = observationData.events.map((event)=>event.timestamp);
                const startTime = Math.min(observationData.startTimestamp, ...eventStartTimes);
                const measureTimespan = performance.now() - startTime - offset;
                const endTimeStamp = startTime + measureTimespan;
                const events = observationData.events.filter((event)=>event.timestamp <= endTimeStamp);
                const analyticsData = {
                    ...(0, (0, parcelRequire("if7bx")).generateLongTaskAnalyticsSummary)(`${observationData.type}`, events),
                    measureTimespan: measureTimespan,
                    events: events,
                    ...additionalAttributes
                };
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, observationData.type, analyticsData);
            }
        };
    var $f5e04866f173da80$export$2e2bcd8739ae039 = (appId)=>{
        let scrollTrackingTimeout = false;
        const start = (type)=>{
            (0, (0, parcelRequire("7wqBZ")).getLongTasksMetrics)(type).start(appId);
        };
        const stop = (type, reporter = (0, (0, parcelRequire("8CsHB")).genericReporter))=>{
            (0, (0, parcelRequire("7wqBZ")).getLongTasksMetrics)(type).stop((param)=>{
                reporter(param);
            });
        };
        return {
            start: start,
            stop: stop,
            trackWithTimeout: (type, createAnalyticsEvent, wait = (0, $e1f79410291896f0$export$3e6e59880a7a1435), additionalAttributes)=>{
                if (!scrollTrackingTimeout) start(type);
                else clearTimeout(scrollTrackingTimeout);
                scrollTrackingTimeout = setTimeout(()=>{
                    const [actionSubject, action] = type.split(' ');
                    const analyticsEvent = createAnalyticsEvent({
                        action: action,
                        actionSubject: actionSubject
                    });
                    const scrollReporter = $f5e04866f173da80$export$fd37aa2563e8b3e8(analyticsEvent, wait, additionalAttributes);
                    stop(type, scrollReporter);
                    scrollTrackingTimeout = false;
                }, wait);
            },
            clearTimeout: ()=>{
                if (scrollTrackingTimeout) clearTimeout(scrollTrackingTimeout);
            }
        };
    };
});
parcelRegister("7wqBZ", function(module, exports) {
    $parcel$export(module.exports, "getLongTasksMetrics", ()=>$f85af650a825558e$export$b092a8653a66aa5e);
    var $gJBT6 = parcelRequire("gJBT6");
    var $x9xyg;
    var $6RCeq;
    var $cJpFl;
    let $f85af650a825558e$var$observer = null;
    const $f85af650a825558e$var$stopObserver = ()=>{
        if ($f85af650a825558e$var$observer) {
            $f85af650a825558e$var$observer.disconnect();
            $f85af650a825558e$var$observer = null;
        }
    };
    const $f85af650a825558e$export$b092a8653a66aa5e = (0, ($parcel$interopDefault($gJBT6)))((type)=>{
        const clearData = {
            type: type
        };
        let isStarted = false;
        let observationData = {
            ...clearData
        };
        const isDnd = /dnd$/.test(type.toLowerCase());
        return {
            start: (appName, startPerformanceMark, extra = {})=>{
                if (window.PerformanceObserver && !isStarted) try {
                    const startTimestamp = (0, (0, parcelRequire("6RCeq")).default).now();
                    observationData = {
                        type: observationData.type,
                        startTimestamp: startTimestamp,
                        dragStartEndTimestamp: startTimestamp,
                        eventStartPerformanceMark: startPerformanceMark,
                        events: [],
                        appName: appName,
                        extra: extra
                    };
                    isStarted = true;
                    $f85af650a825558e$var$stopObserver();
                    $f85af650a825558e$var$observer = new window.PerformanceObserver((list)=>{
                        list.getEntries().forEach((entry)=>{
                            if (entry.entryType === 'longtask') {
                                if (!(0, (0, parcelRequire("cJpFl")).isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                                observationData.events.push({
                                    timestamp: entry.startTime,
                                    duration: entry.duration
                                });
                            } else if (entry.entryType === 'event' && entry.name === 'dragstart') observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                        });
                    });
                    $f85af650a825558e$var$observer.observe({
                        type: 'longtask'
                    });
                    if (isDnd) $f85af650a825558e$var$observer.observe({
                        type: 'event',
                        durationThreshold: 48
                    });
                } catch (e) {}
            },
            stop: (callback, extra = {})=>{
                if ((0, (0, parcelRequire("6RCeq")).default).now && isStarted) {
                    const stopTimestamp = (0, (0, parcelRequire("6RCeq")).default).now();
                    setTimeout(()=>{
                        $f85af650a825558e$var$stopObserver();
                        callback({
                            ...observationData
                        }, extra, stopTimestamp);
                        observationData = {
                            ...clearData
                        };
                        isStarted = false;
                    });
                }
            },
            stopIfNoMark: (performanceMark)=>{
                if ($f85af650a825558e$var$observer && performanceMark) {
                    const perfMark = (0, (0, parcelRequire("x9xyg")).getMark)(performanceMark);
                    if (!perfMark) {
                        $f85af650a825558e$var$stopObserver();
                        observationData = {
                            ...clearData
                        };
                        isStarted = false;
                    }
                }
            }
        };
    });
});
parcelRegister("cJpFl", function(module, exports) {
    $parcel$export(module.exports, "isExpandedObservationData", ()=>$3e1de7ace69512d1$export$3d38a87309e205a4);
    const $3e1de7ace69512d1$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;
});
parcelRegister("if7bx", function(module, exports) {
    $parcel$export(module.exports, "triggerAnalytics", ()=>$3a39af364070fc96$export$2c57de8a70f64057);
    $parcel$export(module.exports, "generateLongTaskAnalyticsSummary", ()=>$3a39af364070fc96$export$2be2635781d23aab);
    $parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", ()=>$3a39af364070fc96$export$c674a20081e82c6a);
    $parcel$export(module.exports, "getAverageResultsFromContinuousActions", ()=>$3a39af364070fc96$export$c36fdc326d0c207c);
    $parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", ()=>$3a39af364070fc96$export$7e5f2df95eca342a);
    var $gZFbt = parcelRequire("gZFbt");
    var $iThRn = parcelRequire("iThRn");
    var $6oxJH = parcelRequire("6oxJH");
    const $3a39af364070fc96$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
    const $3a39af364070fc96$export$2be2635781d23aab = (prefix, longTasks)=>{
        const durations = longTasks.map((task)=>task.duration);
        return {
            [`${prefix}LongTaskCount`]: longTasks.length,
            [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
            [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
        };
    };
    const $3a39af364070fc96$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
        const summary = $3a39af364070fc96$export$2be2635781d23aab(prefix, longTasks);
        if (!sloSettings) return summary;
        const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
        const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
        const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
        return {
            [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
            ...summary
        };
    };
    const $3a39af364070fc96$export$c36fdc326d0c207c = (prefix, data)=>({
            [`${prefix}ClusterCount`]: (0, ($parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterCount`) || 0,
            [`${prefix}ClusterCountAvg`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterCount`) || 0,
            [`${prefix}ClusterAvg`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvg`) || 0,
            [`${prefix}ClusterDistanceAvg`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterDistanceAvg`) || 0,
            [`${prefix}ClusterAvgLongTaskCount`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
            [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, ($parcel$interopDefault($iThRn)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, ($parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
            [`${prefix}Count`]: data.length
        });
    const $3a39af364070fc96$export$7e5f2df95eca342a = (prefix, longTasks)=>{
        const clusters = longTasks.reduce((foundClusters, task)=>{
            if (foundClusters.length === 0) foundClusters.push({
                tasks: [],
                start: 0,
                stop: 0
            });
            const prevCluster = foundClusters[foundClusters.length - 1];
            const taskEnd = task.timestamp + task.duration;
            if (prevCluster.tasks.length === 0) {
                prevCluster.tasks.push(task);
                prevCluster.start = task.timestamp;
                prevCluster.stop = taskEnd;
            } else if (task.timestamp - prevCluster.stop < 100) {
                prevCluster.tasks.push(task);
                prevCluster.stop = taskEnd;
            } else foundClusters.push({
                tasks: [
                    task
                ],
                start: task.timestamp,
                stop: taskEnd
            });
            return foundClusters;
        }, []);
        const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
        const tasksDurations = longTasks.map((task)=>task.duration);
        const gapsBetweenClusters = clusters.length > 1 ? clusters.reduce((gaps, cluster, i)=>{
            if (gaps.length === 0) {
                gaps.push({
                    start: cluster.stop,
                    stop: null
                });
                return gaps;
            }
            gaps[gaps.length - 1].stop = cluster.start;
            if (i !== clusters.length - 1) gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }, []).map((gap)=>gap.stop - gap.start) : [];
        return {
            [`${prefix}ClusterCount`]: clusters.length,
            [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
            [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
            [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
            [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
        };
    };
});
parcelRegister("gZFbt", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $520Yb = parcelRequire("520Yb");
    function $c5f24a2590a3cbef$var$meanBy(array, iteratee) {
        return $520Yb(array, $bxDef(iteratee, 2));
    }
    module.exports = $c5f24a2590a3cbef$var$meanBy;
});
parcelRegister("520Yb", function(module, exports) {
    var $gBzAF = parcelRequire("gBzAF");
    var $3a9de433504d679a$var$NAN = 0 / 0;
    function $3a9de433504d679a$var$baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? $gBzAF(array, iteratee) / length : $3a9de433504d679a$var$NAN;
    }
    module.exports = $3a9de433504d679a$var$baseMean;
});
parcelRegister("6oxJH", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $gBzAF = parcelRequire("gBzAF");
    function $4a7f273a61dd10a7$var$sumBy(array, iteratee) {
        return array && array.length ? $gBzAF(array, $bxDef(iteratee, 2)) : 0;
    }
    module.exports = $4a7f273a61dd10a7$var$sumBy;
});
parcelRegister("8CsHB", function(module, exports) {
    $parcel$export(module.exports, "genericReporter", ()=>$fb974fbed382ceb2$export$bf7963bc28dd02c2);
    var $cJpFl;
    var $if7bx;
    const $fb974fbed382ceb2$export$bf7963bc28dd02c2 = (observationData, featureFlags = {})=>{
        if ((0, (0, parcelRequire("cJpFl")).isExpandedObservationData)(observationData)) {
            const triggerSoftwareAnalytics = (0, (0, parcelRequire("if7bx")).triggerAnalytics)(`software.${observationData.appName}`);
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...(0, (0, parcelRequire("if7bx")).generateLongTaskAnalyticsSummary)(`${observationData.type}`, observationData.events),
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
                ...featureFlags
            };
            triggerSoftwareAnalytics(`long-tasks-${observationData.type}`, analyticsData);
        }
    };
});
const $e1f79410291896f0$export$3e6e59880a7a1435 = 300;
parcelRegister("8FWzM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91fca6f4803f6c63$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $gccSB = parcelRequire("gccSB");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $k5uoT;
    var $4R6GH;
    var $koVbs;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    var $bFINk = parcelRequire("bFINk");
    var $4hgLn;
    var $2KkNy;
    var $eVODA = parcelRequire("eVODA");
    var $cyBwV = parcelRequire("cyBwV");
    var $hZKo2 = parcelRequire("hZKo2");
    var $2VZLn = parcelRequire("2VZLn");
    var $hd6NZ = parcelRequire("hd6NZ");
    var $2rtR8 = parcelRequire("2rtR8");
    var $hk4z2 = parcelRequire("hk4z2");
    var $glNJ3 = parcelRequire("glNJ3");
    var $N7srt = parcelRequire("N7srt");
    var $3Zlmd = parcelRequire("3Zlmd");
    var $dqW1t = parcelRequire("dqW1t");
    var $faAjx = parcelRequire("faAjx");
    function $91fca6f4803f6c63$export$2e2bcd8739ae039({ change: change, rowIndex: rowIndex, isUpdating: isUpdating, columnConfig: columnConfig, SelectChangeCell: SelectChangeCell = (0, $2VZLn.default), IssueTitleCell: IssueTitleCell = (0, $2rtR8.default), ValueChangeComponent: ValueChangeComponent = (0, $3Zlmd.default), WhatChangedComponent: WhatChangedComponent = (0, $faAjx.default) }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (!change) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        const commitWarningCellRenderer = ()=>{
            if ((0, ($parcel$interopDefault($gccSB)))(change.warnings)) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bFINk.default), {
                warnings: change.warnings,
                zIndex: (0, (0, parcelRequire("4R6GH")).fg)('review_changes_error_message_display') ? (0, (0, parcelRequire("k5uoT")).layers).flag() : undefined
            });
        };
        const selectCellRenderer = ()=>{
            const { id: id, category: category, type: type } = change;
            if (type === (0, $TTKUQ.SCENARIO_TYPE).NONE) return null;
            let items = [
                {
                    id: id,
                    category: category
                }
            ];
            if ((category === (0, $TTKUQ.ENTITY).TEAM || category === (0, $TTKUQ.ENTITY).RESOURCE) && change.details.changes.length > 0) {
                items = [];
                const uniqIds = new Set();
                const addItem = (item)=>{
                    const uniqId = `${item.category}:${item.id}`;
                    if (!uniqIds.has(uniqId)) {
                        uniqIds.add(uniqId);
                        items.push(item);
                    }
                };
                const detailChanges = change.details.changes;
                for (const detailChange of detailChanges)if (detailChange.category === (0, $TTKUQ.ENTITY).RESOURCE) addItem({
                    id: detailChange.resourceId,
                    category: detailChange.category
                });
                else addItem({
                    id: id,
                    category: category
                });
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectChangeCell, {
                id: (0, $eVODA.getIdForChangeCategory)(id, category),
                items: items,
                isUpdating: isUpdating
            });
        };
        const titleCellRenderer = ()=>{
            if (change?.type && change?.type !== (0, $TTKUQ.SCENARIO_TYPE).NONE) switch(change.category){
                case (0, $TTKUQ.ENTITY).ISSUE:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(IssueTitleCell, {
                        details: change.details
                    });
                case (0, $TTKUQ.ENTITY).RELEASE:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hk4z2.default), {
                        details: change.details
                    });
                case (0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hd6NZ.default), {
                        crossProjectVersion: change.details.values
                    });
                case (0, $TTKUQ.ENTITY).TEAM:
                case (0, $TTKUQ.ENTITY).RESOURCE:
                    {
                        const teamDetail = change.details;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $N7srt.default), {
                            name: teamDetail.title.name,
                            avatarUrl: teamDetail.title.avatarUrl,
                            id: change.id,
                            category: change.category
                        });
                    }
                case (0, $TTKUQ.ENTITY).SPRINT:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $glNJ3.default), {
                        sprint: change.details.values,
                        id: change.id,
                        category: change.category
                    });
                default:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null);
        };
        const categoryCellRenderer = ()=>{
            const { type: type } = change;
            if (type !== (0, $TTKUQ.SCENARIO_TYPE).NONE) switch(change.category){
                case (0, $TTKUQ.ENTITY).ISSUE:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, $hZKo2.default).issueCategory));
                case (0, $TTKUQ.ENTITY).TEAM:
                case (0, $TTKUQ.ENTITY).RESOURCE:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, $hZKo2.default).teamCategory));
                case (0, $TTKUQ.ENTITY).RELEASE:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, $hZKo2.default).releaseCategory));
                case (0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, $ihPUd.default).crossProjectRelease));
                case (0, $TTKUQ.ENTITY).SPRINT:
                    {
                        const schedulingMode = (0, ($parcel$interopDefault($9XE6b)))(change, [
                            'details',
                            'values',
                            'schedulingMode'
                        ]);
                        const label = formatMessage(schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).kanban ? (0, $hZKo2.default).iterationCategory : (0, $hZKo2.default).sprintCategory);
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, label);
                    }
                default:
                    return null;
            }
            return null;
        };
        const whatChangedCellRenderer = ()=>{
            const scenarioType = change.type;
            const { attributeName: attributeName, changeCount: changeCount, id: id, category: category } = change;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WhatChangedComponent, {
                attributeName: attributeName,
                changeType: scenarioType,
                changeCount: changeCount,
                id: id,
                category: category,
                changeDetails: change
            });
        };
        const valueCellRenderer = (dataKey)=>(0, ($parcel$interopDefault($5uXOq))).createElement(ValueChangeComponent, {
                change: change,
                valueType: dataKey
            });
        const lastModifiedCellRenderer = ()=>{
            const { date: date, title: title, personId: personId, avatarUrl: avatarUrl, dateFormat: dateFormat } = change.lastModified || {};
            if (!change.lastModified || !personId || !date) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cyBwV.default), {
                date: date,
                title: title,
                personId: personId,
                avatarUrl: avatarUrl,
                dateFormat: dateFormat || ''
            });
        };
        const bodyCellRenderer = (column)=>{
            switch(column.id){
                case 'warnings':
                    return commitWarningCellRenderer();
                case 'isSelected':
                    return selectCellRenderer();
                case 'details':
                    return titleCellRenderer();
                case 'category':
                    return categoryCellRenderer();
                case 'type':
                    return whatChangedCellRenderer();
                case (0, $dqW1t.VALUE_TYPE).CURRENT:
                    return valueCellRenderer((0, $dqW1t.VALUE_TYPE).CURRENT);
                case (0, $dqW1t.VALUE_TYPE).NEW:
                    return valueCellRenderer((0, $dqW1t.VALUE_TYPE).NEW);
                case 'lastModified':
                    return lastModifiedCellRenderer();
                default:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
            index: rowIndex
        }, columnConfig.map((column, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
                style: {
                    zIndex: 1
                },
                xcss: $91fca6f4803f6c63$var$cellStyles,
                column: index,
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $91fca6f4803f6c63$var$cellContainer
            }, bodyCellRenderer(column)))));
    }
    const $91fca6f4803f6c63$var$cellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'elevation.surface',
        verticalAlign: 'top'
    });
    const $91fca6f4803f6c63$var$cellContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        alignContent: 'center',
        paddingRight: 'space.100',
        backgroundColor: 'elevation.surface',
        overflow: 'hidden',
        transition: 'background-color 0.1s ease',
        ':focus-within': {
            overflow: 'initial'
        }
    });
});
parcelRegister("eVODA", function(module, exports) {
    $parcel$export(module.exports, "getExpandedChanges", ()=>$75bdec05d08e5d44$export$bacc19472f5797fe);
    $parcel$export(module.exports, "getAttributesForIssuesWithTimeframeChanges", ()=>$75bdec05d08e5d44$export$23ee0086b01df145);
    $parcel$export(module.exports, "getIdForChangeCategory", ()=>$75bdec05d08e5d44$export$26928ed5ec19a0d);
    var $fZhYM;
    var $aipk9;
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $75bdec05d08e5d44$export$bacc19472f5797fe = (changes)=>{
        const result = [];
        const uniqIds = new Set();
        const addItem = (item)=>{
            const uniqId = `${item.category}:${item.id}`;
            if (!uniqIds.has(uniqId)) {
                uniqIds.add(uniqId);
                result.push(item);
            }
        };
        for (const change of changes)if (change.type !== (0, $TTKUQ.SCENARIO_TYPE).NONE) {
            if (change.category === (0, $TTKUQ.ENTITY).TEAM) addItem({
                id: change.id,
                category: change.category
            });
            if (change.category === (0, $TTKUQ.ENTITY).TEAM || change.category === (0, $TTKUQ.ENTITY).RESOURCE) change.details.changes.filter((additionalChange)=>additionalChange.category === (0, $TTKUQ.ENTITY).RESOURCE).forEach((additionalChange)=>{
                addItem({
                    id: additionalChange.resourceId || '0',
                    category: (0, $TTKUQ.ENTITY).RESOURCE
                });
            });
            else addItem({
                id: change.id,
                category: change.category
            });
        }
        return result;
    };
    const $75bdec05d08e5d44$var$formatDate = (timestamp)=>{
        if (!(0, $4nDwW.isDefined)(timestamp)) return timestamp;
        return (0, (0, parcelRequire("aipk9")).formatDateUTC)(timestamp, 'YYYY-MM-DD HH:mm:ss');
    };
    const $75bdec05d08e5d44$var$hasDateChange = (dateField, originals)=>{
        if (dateField.type === (0, $5fACX.DATEFIELD_TYPES).BUILT_IN && originals[dateField.key] !== undefined) return true;
        if (dateField.type === (0, $5fACX.DATEFIELD_TYPES).CUSTOM) {
            if ((0, parcelRequire("fZhYM")).default([
                `customField-${dateField.key}`,
                'value'
            ], originals) !== undefined) return true;
        }
        return false;
    };
    const $75bdec05d08e5d44$var$getConfiguredDateValues = (dateField, originals, values)=>{
        if (dateField.type === (0, $5fACX.DATEFIELD_TYPES).CUSTOM) return {
            current: $75bdec05d08e5d44$var$formatDate((0, parcelRequire("fZhYM")).default([
                `customField-${dateField.key}`,
                'value'
            ], originals) || null),
            new: $75bdec05d08e5d44$var$formatDate((0, parcelRequire("fZhYM")).default([
                `customField-${dateField.key}`,
                'value'
            ], values) || null)
        };
        return {
            current: $75bdec05d08e5d44$var$formatDate((0, parcelRequire("fZhYM")).default([
                dateField.key
            ], originals) || null),
            new: $75bdec05d08e5d44$var$formatDate((0, parcelRequire("fZhYM")).default([
                dateField.key
            ], values) || null)
        };
    };
    const $75bdec05d08e5d44$export$23ee0086b01df145 = (changes, dateConfiguration, typeToLevel)=>{
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
        const isIssueWithTimeframeChanges = (change)=>{
            const originals = (0, parcelRequire("fZhYM")).default([
                'details',
                'originals'
            ], change);
            if (change.category !== (0, $TTKUQ.ENTITY).ISSUE || change.type === 'NONE' || originals === undefined) return false;
            if ($75bdec05d08e5d44$var$hasDateChange(baselineStartField, originals) || $75bdec05d08e5d44$var$hasDateChange(baselineEndField, originals)) return true;
            return false;
        };
        const changeAnalyticsAttributes = (change)=>{
            let start = {
                current: null,
                new: null
            };
            let end = {
                current: null,
                new: null
            };
            const originals = (0, parcelRequire("fZhYM")).default([
                'details',
                'originals'
            ], change);
            const values = (0, parcelRequire("fZhYM")).default([
                'details',
                'values'
            ], change);
            if (originals !== undefined && values !== undefined) {
                start = $75bdec05d08e5d44$var$getConfiguredDateValues(baselineStartField, originals, values);
                end = $75bdec05d08e5d44$var$getConfiguredDateValues(baselineEndField, originals, values);
            }
            const type = (0, parcelRequire("fZhYM")).default([
                'details',
                'values',
                'type'
            ], change);
            const hierarchyLevel = typeToLevel(type);
            return {
                issueId: change.id,
                lastModifiedDate: $75bdec05d08e5d44$var$formatDate(change.lastModified?.date),
                lastModifiedUser: change.lastModified?.personId,
                start: {
                    type: baselineStartField.type,
                    ...start,
                    changed: start.current !== start.new
                },
                end: {
                    type: baselineEndField.type,
                    ...end,
                    changed: end.current !== end.new
                },
                hierarchyLevel: hierarchyLevel
            };
        };
        return (0, $4nDwW.filterMap)(isIssueWithTimeframeChanges, changeAnalyticsAttributes, changes);
    };
    const $75bdec05d08e5d44$export$26928ed5ec19a0d = (id, category)=>{
        switch(category){
            case (0, $TTKUQ.ENTITY).ISSUE:
                return `issue_change_${id}`;
            case (0, $TTKUQ.ENTITY).RELEASE:
                return `release_change_${id}`;
            case (0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE:
                return `cross_project_release_change_${id}`;
            case (0, $TTKUQ.ENTITY).TEAM:
                return `team_change_${id}`;
            case (0, $TTKUQ.ENTITY).RESOURCE:
                return `resource_change_${id}`;
            case (0, $TTKUQ.ENTITY).PLANNED_CAPACITY:
                return `planned_capacity_change_${id}`;
            case (0, $TTKUQ.ENTITY).SPRINT:
                return `sprint_change_${id}`;
            default:
                return id;
        }
    };
});
parcelRegister("cyBwV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d2900c7613cc49c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4mBKK;
    var $ujWmd;
    var $3bDjY;
    var $koVbs;
    var $15rEL;
    var $gh61P;
    var $aipk9;
    var $gB7RK = parcelRequire("gB7RK");
    function $9d2900c7613cc49c$var$LastModified(props) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { personId: personId, title: title, date: date, avatarUrl: avatarUrl } = props;
        const daysDifference = (0, (0, parcelRequire("4mBKK")).default)(new Date(), date);
        const formatRelative = (intl, date)=>{
            const { time: time, unit: unit } = (0, (0, parcelRequire("15rEL")).getRelativeTimeAndUnit)(date);
            return intl.formatRelativeTime(time, unit);
        };
        const getDate = (intl, value)=>(0, (0, parcelRequire("aipk9")).formatTimestampWithIntl)(intl, value, (0, (0, parcelRequire("gh61P")).shortDateFormat));
        const dateDisplayString = daysDifference > 7 ? getDate(intl, date) : formatRelative(intl, date);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gB7RK.container
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $gB7RK.label,
            title: dateDisplayString
        }, dateDisplayString), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gB7RK.avatar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: title || personId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "xsmall",
            src: avatarUrl,
            name: title || personId
        })))));
    }
    var $9d2900c7613cc49c$export$2e2bcd8739ae039 = $9d2900c7613cc49c$var$LastModified;
});
parcelRegister("15rEL", function(module, exports) {
    $parcel$export(module.exports, "getRelativeTimeAndUnit", ()=>$dff2faa5ae8b6f27$export$307c4b8ee56b97bb);
    $parcel$export(module.exports, "FormattedRelativeV2", ()=>$dff2faa5ae8b6f27$export$7317ee2f88fd1276);
    var $5uXOq = parcelRequire("5uXOq");
    var $j7anB;
    var $2tElP;
    const $dff2faa5ae8b6f27$var$getTimeInUnits = (unitValue)=>{
        const seconds = unitValue / 1000;
        const minutes = seconds / 60;
        const hours = minutes / 60;
        const days = hours / 24;
        const weeks = days / 7;
        const months = weeks / 4;
        const years = months / 12;
        return {
            seconds: seconds,
            minutes: minutes,
            hours: hours,
            days: days,
            weeks: weeks,
            months: months,
            years: years
        };
    };
    const $dff2faa5ae8b6f27$export$307c4b8ee56b97bb = (value, units)=>{
        const timeInMilliseconds = new Date(value);
        const delta = timeInMilliseconds - Date.now();
        let valueInUnit;
        if (!units) {
            const { value: time, unit: unit } = (0, (0, parcelRequire("j7anB")).selectUnit)(timeInMilliseconds, new Date());
            return {
                time: time,
                unit: unit
            };
        }
        const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $dff2faa5ae8b6f27$var$getTimeInUnits(delta);
        switch(units){
            case 'second':
                valueInUnit = seconds;
                break;
            case 'minute':
                valueInUnit = minutes;
                break;
            case 'hour':
                valueInUnit = hours;
                break;
            case 'day':
                valueInUnit = days;
                break;
            case 'week':
                valueInUnit = weeks;
                break;
            case 'month':
                valueInUnit = months;
                break;
            case 'year':
                valueInUnit = years;
                break;
            default:
                valueInUnit = 0;
                break;
        }
        return {
            time: Math.ceil(valueInUnit),
            unit: units
        };
    };
    const $dff2faa5ae8b6f27$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
        const { time: time, unit: unit } = $dff2faa5ae8b6f27$export$307c4b8ee56b97bb(value, units);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2tElP")).default), {
            value: time,
            unit: unit,
            numeric: style === 'numeric' ? 'always' : 'auto',
            format: format,
            updateIntervalInSeconds: updateInterval
        }, children);
    };
    $dff2faa5ae8b6f27$export$7317ee2f88fd1276.displayName = 'FormattedRelative';
});
parcelRegister("gB7RK", function(module, exports) {
    $parcel$export(module.exports, "avatar", ()=>$c156340d2c8dce8f$export$345c5736c8054f22, (v)=>$c156340d2c8dce8f$export$345c5736c8054f22 = v);
    $parcel$export(module.exports, "container", ()=>$c156340d2c8dce8f$export$34e0f9847d4c02dd, (v)=>$c156340d2c8dce8f$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "label", ()=>$c156340d2c8dce8f$export$1237798dc640739a, (v)=>$c156340d2c8dce8f$export$1237798dc640739a = v);
    var $c156340d2c8dce8f$export$345c5736c8054f22;
    var $c156340d2c8dce8f$export$34e0f9847d4c02dd;
    var $c156340d2c8dce8f$export$1237798dc640739a;
    $c156340d2c8dce8f$export$345c5736c8054f22 = `RCUxaq_avatar`;
    $c156340d2c8dce8f$export$34e0f9847d4c02dd = `RCUxaq_container`;
    $c156340d2c8dce8f$export$1237798dc640739a = `RCUxaq_label`;
});
parcelRegister("hZKo2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$627fc71543ce20fe$export$2e2bcd8739ae039);
    var $7VHMR;
    var $627fc71543ce20fe$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title-column-header",
            "defaultMessage": "Title"
        },
        categoryColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.category-column-header",
            "defaultMessage": "Category"
        },
        whatChangedColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed-column-header",
            "defaultMessage": "What changed"
        },
        oldValueColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.old-value-column-header",
            "defaultMessage": "Current (Jira)"
        },
        lastModifiedColumnHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.last-modified-column-header",
            "defaultMessage": "Last modified"
        },
        issueCategory: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.issue-category",
            "defaultMessage": "Issue"
        },
        teamCategory: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.team-category",
            "defaultMessage": "Team"
        },
        releaseCategory: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.release-category",
            "defaultMessage": "Release"
        },
        sprintCategory: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.sprint-category",
            "defaultMessage": "Sprint"
        },
        iterationCategory: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.iteration-category",
            "defaultMessage": "Iteration"
        },
        exceptions: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.exceptions",
            "defaultMessage": "Exceptions"
        },
        tableAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.table-aria-label",
            "defaultMessage": "Update Jira changes table"
        },
        lastModifiedColumnAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.last-modified-column-aria-label",
            "defaultMessage": "Last modified"
        }
    });
});
parcelRegister("2VZLn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a7161e68745f384$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fAGMJ;
    var $bC2fB;
    var $80vdF = parcelRequire("80vdF");
    var $5dVCl = parcelRequire("5dVCl");
    class $0a7161e68745f384$export$d4456a5c5e486524 extends (0, $5uXOq.Component) {
        render() {
            const { id: id, isUpdating: isUpdating } = this.props;
            const isSelected = this.isSelected();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                "aria-labelledby": id,
                isChecked: isSelected,
                isDisabled: isUpdating,
                onChange: this.handleChange,
                testId: `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.select-change.cell.checkbox-${id}`
            });
        }
        constructor(...args){
            super(...args);
            this.isSelected = ()=>{
                const { items: items, selectedChanges: selectedChanges } = this.props;
                return items.length > 0 && items.every((item)=>this.isItemSelected(item, selectedChanges));
            };
            this.isItemSelected = ({ id: id, category: category }, selectedChanges)=>selectedChanges[category] && selectedChanges[category].includes(id);
            this.handleChange = ()=>{
                const { items: items, select: select, deselect: deselect } = this.props;
                const isSelected = this.isSelected();
                if (isSelected) items.forEach((item)=>deselect(item.id, item.category));
                else items.forEach((item)=>select(item.id, item.category));
            };
        }
    }
    var $0a7161e68745f384$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $5dVCl.default), (0, $80vdF.default))($0a7161e68745f384$export$d4456a5c5e486524);
});
parcelRegister("80vdF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4887b82a1faa2e51$export$2e2bcd8739ae039);
    var $aHSC5 = parcelRequire("aHSC5");
    var $ccIrM = parcelRequire("ccIrM");
    const $4887b82a1faa2e51$var$mapDispatchToProps = (dispatch)=>({
            select: (changeId, category)=>{
                dispatch((0, $aHSC5.selectChange)(changeId, category));
                dispatch((0, $aHSC5.changeQuickSelect)((0, $ccIrM.QuickSelectOption).NONE));
            },
            deselect: (changeId, category)=>{
                dispatch((0, $aHSC5.deselectChange)(changeId, category));
                dispatch((0, $aHSC5.changeQuickSelect)((0, $ccIrM.QuickSelectOption).NONE));
            }
        });
    var $4887b82a1faa2e51$export$2e2bcd8739ae039 = $4887b82a1faa2e51$var$mapDispatchToProps;
});
parcelRegister("5dVCl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2a9dcb24e08549b$export$2e2bcd8739ae039);
    var $25viM = parcelRequire("25viM");
    var $3YtPS = parcelRequire("3YtPS");
    var $d2a9dcb24e08549b$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedChanges: (0, $25viM.getSelectedChanges)
    });
});
parcelRegister("hd6NZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4feff14763370d51$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eVODA = parcelRequire("eVODA");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8JOG8 = parcelRequire("8JOG8");
    var $cneCo = parcelRequire("cneCo");
    function $4feff14763370d51$export$2e2bcd8739ae039(props) {
        const { name: releaseName, id: id } = props.crossProjectVersion;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: releaseName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $cneCo.crossProjectReleaseTitle,
            id: (0, $eVODA.getIdForChangeCategory)(id, (0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE),
            "data-testid": `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title.cross-project-release.cross-project-release-title-container-${id}`
        }, releaseName));
    }
});
parcelRegister("cneCo", function(module, exports) {
    $parcel$export(module.exports, "crossProjectReleaseTitle", ()=>$9022f8e699599906$export$693a2a1482e505bb, (v)=>$9022f8e699599906$export$693a2a1482e505bb = v);
    var $9022f8e699599906$export$693a2a1482e505bb;
    $9022f8e699599906$export$693a2a1482e505bb = `oAtGSG_crossProjectReleaseTitle`;
});
parcelRegister("2rtR8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5abdcb1bbe350ec0$export$2e2bcd8739ae039);
    var $bC2fB;
    var $kvKDC = parcelRequire("kvKDC");
    var $jZQBM = parcelRequire("jZQBM");
    var $5abdcb1bbe350ec0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $kvKDC.default), {})((0, $jZQBM.default));
});
parcelRegister("kvKDC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a3299f8e935885b$export$2e2bcd8739ae039);
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $3YtPS = parcelRequire("3YtPS");
    var $8a3299f8e935885b$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        projects: (0, $jpXKt.getProjects),
        issueTypes: (0, $kllqP.getIssueTypes)
    });
});
parcelRegister("jZQBM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28bc0dc6e6681e11$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2rMKg;
    var $8CUq3;
    var $2FvnI;
    var $eVODA = parcelRequire("eVODA");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8JOG8 = parcelRequire("8JOG8");
    var $2bTvq = parcelRequire("2bTvq");
    function $28bc0dc6e6681e11$export$2e2bcd8739ae039({ projects: projects, issueTypes: issueTypes, details: details }) {
        const projectsByIdMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), projects);
        const issueTypesByIdMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), issueTypes);
        const { issueKey: issueKey, values: { summary: summary, project: projectId, type: issueTypeId }, id: id } = details;
        const projectKey = projectId ? projectsByIdMap[projectId]?.key || '' : '';
        const issueType = issueTypesByIdMap[issueTypeId];
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $2bTvq.issueTitle,
            id: (0, $eVODA.getIdForChangeCategory)(id, (0, $TTKUQ.ENTITY).ISSUE),
            "data-testid": `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title.issue.issue-title-container-${id}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $2bTvq.issueIcon,
            style: {
                backgroundSize: 'contain',
                backgroundImage: issueType && `url(${issueType.iconUrl})`
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvnI")).default), {
            projectKey: projectKey,
            issueKey: issueKey,
            xcssStyles: $28bc0dc6e6681e11$var$issueLinkStyles
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: summary,
            id: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $2bTvq.issueSummary
        }, summary)));
    }
    const $28bc0dc6e6681e11$var$issueLinkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap'
    });
});
parcelRegister("2bTvq", function(module, exports) {
    $parcel$export(module.exports, "issueIcon", ()=>$1987aa2d672e64e0$export$415983cbc1f2b3fe, (v)=>$1987aa2d672e64e0$export$415983cbc1f2b3fe = v);
    $parcel$export(module.exports, "issueSummary", ()=>$1987aa2d672e64e0$export$7c7bc027bbbea103, (v)=>$1987aa2d672e64e0$export$7c7bc027bbbea103 = v);
    $parcel$export(module.exports, "issueTitle", ()=>$1987aa2d672e64e0$export$12781bd67c11efd8, (v)=>$1987aa2d672e64e0$export$12781bd67c11efd8 = v);
    var $1987aa2d672e64e0$export$415983cbc1f2b3fe;
    var $1987aa2d672e64e0$export$7c7bc027bbbea103;
    var $1987aa2d672e64e0$export$12781bd67c11efd8;
    $1987aa2d672e64e0$export$415983cbc1f2b3fe = `Od-IXa_issueIcon`;
    $1987aa2d672e64e0$export$7c7bc027bbbea103 = `Od-IXa_issueSummary`;
    $1987aa2d672e64e0$export$12781bd67c11efd8 = `Od-IXa_issueTitle`;
});
parcelRegister("hk4z2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34bcbc98436d5b57$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7B6du = parcelRequire("7B6du");
    var $2PhMk = parcelRequire("2PhMk");
    var $34bcbc98436d5b57$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7B6du.default), {})((0, $2PhMk.default));
});
parcelRegister("7B6du", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46ab6c3707bf0672$export$2e2bcd8739ae039);
    var $3YtPS = parcelRequire("3YtPS");
    var $46ab6c3707bf0672$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (_, ownProps)=>ownProps
    ], (ownProps)=>({
            ...ownProps
        }));
});
parcelRegister("2PhMk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$24130780e3c6f091$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eVODA = parcelRequire("eVODA");
    var $eJyeb = parcelRequire("eJyeb");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8JOG8 = parcelRequire("8JOG8");
    var $cBgPC = parcelRequire("cBgPC");
    const $24130780e3c6f091$export$1f2d195ca7827fba = (version)=>{
        const { id: id, projects: projects } = version;
        const project = projects[0];
        return (0, $eJyeb.proxyContextSafeUrl)(`/browse/${project.key}/fixforversion/${id}`);
    };
    function $24130780e3c6f091$export$2e2bcd8739ae039(props) {
        const { details: version } = props;
        const { id: id, projects: projects, values: { name: releaseName } } = version;
        const { avatarUrl: projectAvatar, name: projectName } = projects[0];
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $cBgPC.releaseTitle,
            id: (0, $eVODA.getIdForChangeCategory)(id, (0, $TTKUQ.ENTITY).RELEASE),
            "data-testid": `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title.release.release-title-container-${id}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$cBgPC.projectIcon}`,
            style: {
                backgroundSize: 'contain',
                backgroundImage: `url(${projectAvatar})`
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: `${releaseName} (${projectName})`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $cBgPC.titleText
        }, id.startsWith((0, $TTKUQ.SCENARIO_ISSUE_ID_PREFIX)) ? `${releaseName} (${projectName})` : (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: $24130780e3c6f091$export$1f2d195ca7827fba(version),
            target: "_blank",
            rel: "noopener noreferrer"
        }, releaseName, " (", projectName, ")"))));
    }
});
parcelRegister("cBgPC", function(module, exports) {
    $parcel$export(module.exports, "projectIcon", ()=>$92c5ff21c8e0f7ff$export$e595ab851fd6d370, (v)=>$92c5ff21c8e0f7ff$export$e595ab851fd6d370 = v);
    $parcel$export(module.exports, "releaseTitle", ()=>$92c5ff21c8e0f7ff$export$2189f9364c53a5b7, (v)=>$92c5ff21c8e0f7ff$export$2189f9364c53a5b7 = v);
    $parcel$export(module.exports, "titleText", ()=>$92c5ff21c8e0f7ff$export$318bb85fd83e5f1a, (v)=>$92c5ff21c8e0f7ff$export$318bb85fd83e5f1a = v);
    var $92c5ff21c8e0f7ff$export$e595ab851fd6d370;
    var $92c5ff21c8e0f7ff$export$2189f9364c53a5b7;
    var $92c5ff21c8e0f7ff$export$318bb85fd83e5f1a;
    $92c5ff21c8e0f7ff$export$e595ab851fd6d370 = `_8mBR-W_projectIcon`;
    $92c5ff21c8e0f7ff$export$2189f9364c53a5b7 = `_8mBR-W_releaseTitle`;
    $92c5ff21c8e0f7ff$export$318bb85fd83e5f1a = `_8mBR-W_titleText`;
});
parcelRegister("glNJ3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c63097d60bf2c25b$export$2e2bcd8739ae039);
    var $bC2fB;
    var $eCOXJ = parcelRequire("eCOXJ");
    var $kUK5P = parcelRequire("kUK5P");
    var $c63097d60bf2c25b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $eCOXJ.default), {})((0, $kUK5P.default));
});
parcelRegister("eCOXJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4053994f9952a0$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $2e4053994f9952a0$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        (0, $bHTqr.getIssueSourcesById),
        (_, ownProps)=>ownProps
    ], (issueSourcesById, ownProps)=>{
        const { sprint: sprint } = ownProps;
        const issueSourceId = sprint.issueSources && sprint.issueSources[0];
        const issueSource = issueSourcesById[issueSourceId];
        const boardId = issueSource && issueSource.type === (0, $TTKUQ.ISSUE_SOURCE_TYPES).BOARD ? issueSource.value : undefined;
        return {
            boardId: boardId
        };
    });
});
parcelRegister("kUK5P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$581fbf9f5859db19$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aipk9;
    var $eVODA = parcelRequire("eVODA");
    var $eJyeb = parcelRequire("eJyeb");
    var $jHacM = parcelRequire("jHacM");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8JOG8 = parcelRequire("8JOG8");
    var $if3br = parcelRequire("if3br");
    class $581fbf9f5859db19$var$SprintTitle extends (0, $5uXOq.Component) {
        generateSprintUrl() {
            const { boardId: boardId, sprint: sprint } = this.props;
            if (sprint && (0, $4nDwW.isDefined)(boardId) && boardId !== '') {
                let url = (0, $eJyeb.proxyContextSafeUrl)(`/secure/RapidBoard.jspa?rapidView=${boardId}`);
                if (sprint.state === (0, $TTKUQ.SPRINT_STATES).CLOSED) url += `&view=reporting&chart=sprintRetrospective&sprint=${sprint.id}`;
                else if (sprint.state === (0, $TTKUQ.SPRINT_STATES).FUTURE) url += '&view=planning';
                return url;
            }
        }
        render() {
            const { sprint: sprint, boardId: boardId, id: id, category: category } = this.props;
            let sprintName;
            if (sprint.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).kanban) sprintName = `${(0, (0, parcelRequire("aipk9")).formatDateUTC)(sprint.startDate, 'DD MMM')} - ` + `${(0, (0, parcelRequire("aipk9")).formatDateUTC)(sprint.endDate, 'DD MMM')}`;
            else sprintName = sprint.title;
            const sprintUrl = sprint.schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).scrum && (0, $4nDwW.isDefined)(boardId) && boardId !== '' && this.generateSprintUrl();
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $if3br.sprintTitle,
                id: (0, $eVODA.getIdForChangeCategory)(id, category),
                "data-testid": `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title.sprint.sprint-title-container-${id}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $if3br.projectIcon
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jHacM.default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                content: `${sprintName}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $if3br.titleText
            }, (0, $4nDwW.isDefined)(sprintUrl) && sprintUrl !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: this.generateSprintUrl(),
                target: "_blank",
                rel: "noopener noreferrer"
            }, sprintName) : `${sprintName}`)));
        }
    }
    var $581fbf9f5859db19$export$2e2bcd8739ae039 = $581fbf9f5859db19$var$SprintTitle;
});
parcelRegister("if3br", function(module, exports) {
    $parcel$export(module.exports, "projectIcon", ()=>$d47c18ea6a0fd620$export$e595ab851fd6d370, (v)=>$d47c18ea6a0fd620$export$e595ab851fd6d370 = v);
    $parcel$export(module.exports, "sprintTitle", ()=>$d47c18ea6a0fd620$export$d36673c13d5182d, (v)=>$d47c18ea6a0fd620$export$d36673c13d5182d = v);
    $parcel$export(module.exports, "titleText", ()=>$d47c18ea6a0fd620$export$318bb85fd83e5f1a, (v)=>$d47c18ea6a0fd620$export$318bb85fd83e5f1a = v);
    var $d47c18ea6a0fd620$export$e595ab851fd6d370;
    var $d47c18ea6a0fd620$export$d36673c13d5182d;
    var $d47c18ea6a0fd620$export$318bb85fd83e5f1a;
    $d47c18ea6a0fd620$export$e595ab851fd6d370 = `_5tEYsq_projectIcon`;
    $d47c18ea6a0fd620$export$d36673c13d5182d = `_5tEYsq_sprintTitle`;
    $d47c18ea6a0fd620$export$318bb85fd83e5f1a = `_5tEYsq_titleText`;
});
parcelRegister("N7srt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc3bd41eb784db2e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $h8cgU;
    var $eVODA = parcelRequire("eVODA");
    var $8JOG8 = parcelRequire("8JOG8");
    var $gxynT = parcelRequire("gxynT");
    function $dc3bd41eb784db2e$export$2e2bcd8739ae039(props) {
        const { id: id, category: category, avatarUrl: teamAvatarUrl, name: teamName } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gxynT.teamTitle,
            id: (0, $eVODA.getIdForChangeCategory)(id, category),
            "data-testid": `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title.team.team-title-container-${id}`
        }, !teamAvatarUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gxynT.defaultTeamAvatar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))), {
            label: "",
            size: "small"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$gxynT.teamIcon}`,
            style: teamAvatarUrl ? {
                backgroundSize: 'contain',
                backgroundImage: `url(${teamAvatarUrl})`
            } : {}
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: teamName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gxynT.titleText
        }, teamName)));
    }
});
parcelRegister("gxynT", function(module, exports) {
    $parcel$export(module.exports, "defaultTeamAvatar", ()=>$c0aa666a78b0ef6d$export$aa80651379a69724, (v)=>$c0aa666a78b0ef6d$export$aa80651379a69724 = v);
    $parcel$export(module.exports, "teamIcon", ()=>$c0aa666a78b0ef6d$export$6d74194612a54b7, (v)=>$c0aa666a78b0ef6d$export$6d74194612a54b7 = v);
    $parcel$export(module.exports, "teamTitle", ()=>$c0aa666a78b0ef6d$export$f1ea300f5bc512fd, (v)=>$c0aa666a78b0ef6d$export$f1ea300f5bc512fd = v);
    $parcel$export(module.exports, "titleText", ()=>$c0aa666a78b0ef6d$export$318bb85fd83e5f1a, (v)=>$c0aa666a78b0ef6d$export$318bb85fd83e5f1a = v);
    var $c0aa666a78b0ef6d$export$aa80651379a69724;
    var $c0aa666a78b0ef6d$export$6d74194612a54b7;
    var $c0aa666a78b0ef6d$export$f1ea300f5bc512fd;
    var $c0aa666a78b0ef6d$export$318bb85fd83e5f1a;
    $c0aa666a78b0ef6d$export$aa80651379a69724 = `_5-wTfW_defaultTeamAvatar`;
    $c0aa666a78b0ef6d$export$6d74194612a54b7 = `_5-wTfW_teamIcon`;
    $c0aa666a78b0ef6d$export$f1ea300f5bc512fd = `_5-wTfW_teamTitle`;
    $c0aa666a78b0ef6d$export$318bb85fd83e5f1a = `_5-wTfW_titleText`;
});
parcelRegister("3Zlmd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9639a8ab0dcf4080$export$2e2bcd8739ae039);
    var $bC2fB;
    var $1Ybwy = parcelRequire("1Ybwy");
    var $7Qq1s = parcelRequire("7Qq1s");
    var $9639a8ab0dcf4080$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $1Ybwy.default), {})((0, $7Qq1s.default));
});
parcelRegister("1Ybwy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3c4928b1f5d967b$export$2e2bcd8739ae039);
    var $25viM = parcelRequire("25viM");
    var $3YtPS = parcelRequire("3YtPS");
    const $c3c4928b1f5d967b$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        expandedChanges: (0, $25viM.getExpandedChanges)
    });
    var $c3c4928b1f5d967b$export$2e2bcd8739ae039 = $c3c4928b1f5d967b$var$querySelector;
});
parcelRegister("7Qq1s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d54c8d51b56ef5ee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $aipk9;
    var $60TfX = parcelRequire("60TfX");
    var $5fACX = parcelRequire("5fACX");
    var $84qTJ = parcelRequire("84qTJ");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8JOG8 = parcelRequire("8JOG8");
    var $bSywi = parcelRequire("bSywi");
    var $1BOrS = parcelRequire("1BOrS");
    var $190ki = parcelRequire("190ki");
    var $9y7MQ = parcelRequire("9y7MQ");
    var $b5p6y = parcelRequire("b5p6y");
    var $amSD3 = parcelRequire("amSD3");
    var $lYv6u = parcelRequire("lYv6u");
    var $793WC = parcelRequire("793WC");
    var $1gc7b = parcelRequire("1gc7b");
    var $2e0YB = parcelRequire("2e0YB");
    var $1mpFV = parcelRequire("1mpFV");
    var $7zxVh = parcelRequire("7zxVh");
    var $eaJmx = parcelRequire("eaJmx");
    var $2EcU8 = parcelRequire("2EcU8");
    var $dl8GJ = parcelRequire("dl8GJ");
    var $jsjls = parcelRequire("jsjls");
    var $4LjFo = parcelRequire("4LjFo");
    var $9RKil = parcelRequire("9RKil");
    var $cQ391 = parcelRequire("cQ391");
    var $8TGna = parcelRequire("8TGna");
    var $dqW1t = parcelRequire("dqW1t");
    class $d54c8d51b56ef5ee$var$ValueChangeCell extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                AssigneeComponent: (0, $190ki.default),
                CrossProjectReleaseComponent: (0, $amSD3.default),
                EstimateComponent: (0, $793WC.default),
                IssueLinkComponent: (0, $2e0YB.default),
                ProjectComponent: (0, $2EcU8.default),
                PriorityComponent: (0, $eaJmx.default),
                ReleaseComponent: (0, $dl8GJ.default),
                SprintComponent: (0, $4LjFo.default),
                TeamComponent: (0, $8TGna.default),
                CustomFieldComponent: (0, $lYv6u.default),
                PlannedCapacityComponent: (0, $jsjls.default),
                StatusComponent: (0, $9RKil.default),
                GoalsComponent: (0, $1gc7b.default),
                AssociatedIssuesComponent: (0, $9y7MQ.default)
            };
        }
        render() {
            const { intl: intl, change: change, expandedChanges: expandedChanges } = this.props;
            const { attributeName: attributeName, id: id, category: category, type: type, changeCount: changeCount } = change;
            if (type === (0, $TTKUQ.SCENARIO_TYPE).DELETED) return null;
            const values = this.getValues();
            const isExpanded = (0, $4nDwW.isDefined)(expandedChanges) && expandedChanges[category].includes(id);
            const hasMultipleChanges = (type === (0, $TTKUQ.SCENARIO_TYPE).ADDED || type === (0, $TTKUQ.SCENARIO_TYPE).ADDEDEXISTING) && changeCount > 0 || type === (0, $TTKUQ.SCENARIO_TYPE).MULTIPLE;
            if (hasMultipleChanges && isExpanded) return null;
            if (hasMultipleChanges) return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $cQ391["multiple-label"]
            }, intl.formatMessage((0, $7zxVh.default).multipleChanges)));
            if ((0, $4nDwW.isDefined)(attributeName)) {
                const value = values[attributeName];
                if (attributeName.startsWith('issueLink-')) {
                    if (!value) return '-';
                    const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey, values: { type: type } } = value;
                    const { IssueLinkComponent: IssueLinkComponent } = this.props;
                    if (sourceItemKey === id) return (0, ($parcel$interopDefault($5uXOq))).createElement(IssueLinkComponent, {
                        issue: targetItemKey,
                        linkType: type,
                        direction: (0, $TTKUQ.ISSUE_LINK_DIRECTION).OUTWARD
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(IssueLinkComponent, {
                        issue: sourceItemKey,
                        linkType: type,
                        direction: (0, $TTKUQ.ISSUE_LINK_DIRECTION).INWARD
                    });
                }
                if (attributeName.startsWith('customField')) {
                    if (!value) return '-';
                    const { CustomFieldComponent: CustomFieldComponent } = this.props;
                    const { id: id, value: customFieldValue } = value;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(CustomFieldComponent, {
                        id: id,
                        value: customFieldValue,
                        attributeName: attributeName
                    });
                }
                if (attributeName.startsWith('teamVelocity')) {
                    const { PlannedCapacityComponent: PlannedCapacityComponent } = this.props;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(PlannedCapacityComponent, {
                        plannedCapacity: values[attributeName]
                    });
                }
                switch(attributeName){
                    case 'assignee':
                        {
                            const { AssigneeComponent: AssigneeComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(AssigneeComponent, {
                                assignee: value
                            });
                        }
                    case 0, $5fACX.TARGET_START_FIELD:
                    case 0, $5fACX.TARGET_END_FIELD:
                    case 'dueDate':
                        {
                            const date = value;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, date ? (0, (0, parcelRequire("aipk9")).formatDateWithIntl)(intl, date) : '-');
                        }
                    case 'iterationLength':
                        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, value !== undefined ? `${value}  ${intl.formatMessage((0, $7zxVh.default).weeks)}` : '-');
                    case 'crossProjectVersion':
                        {
                            const crossProjectVersionId = value;
                            const { CrossProjectReleaseComponent: CrossProjectReleaseComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, (0, $4nDwW.isDefined)(crossProjectVersionId) ? (0, ($parcel$interopDefault($5uXOq))).createElement(CrossProjectReleaseComponent, {
                                crossProjectVersionId: crossProjectVersionId
                            }) : '-');
                        }
                    case 'end':
                        {
                            const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bSywi.default), {
                                end: value,
                                emptyMessage: "-"
                            });
                            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                                style: {
                                    paddingRight: "var(--ds-space-050, 4px)"
                                }
                            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                                content: content,
                                id: value
                            }, content));
                        }
                    case 'fixVersions':
                        {
                            const { ReleaseComponent: ReleaseComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(ReleaseComponent, {
                                fixVersions: value
                            });
                        }
                    case 'lexoRank':
                    case 'description':
                        return null;
                    case 'parent':
                        {
                            const { IssueLinkComponent: IssueLinkComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(IssueLinkComponent, {
                                issue: value
                            });
                        }
                    case 'priority':
                        {
                            const { PriorityComponent: PriorityComponent, change: change } = this.props;
                            const details = change.details;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(PriorityComponent, {
                                priority: value,
                                project: details.values.project
                            });
                        }
                    case 'project':
                        {
                            const { ProjectComponent: ProjectComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(ProjectComponent, {
                                project: value
                            });
                        }
                    case 'start':
                        {
                            const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1BOrS.default), {
                                start: value,
                                delta: values.delta,
                                emptyMessage: "-"
                            });
                            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                                style: {
                                    paddingRight: "var(--ds-space-050, 4px)"
                                }
                            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                                content: content,
                                id: value
                            }, content));
                        }
                    case 'sprint':
                        {
                            const { SprintComponent: SprintComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(SprintComponent, {
                                sprint: value
                            });
                        }
                    case 'status':
                        {
                            const { StatusComponent: StatusComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(StatusComponent, {
                                statusId: value
                            });
                        }
                    case 'statusTransition':
                        return null;
                    case 'team':
                        {
                            const { TeamComponent: TeamComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(TeamComponent, {
                                team: value
                            });
                        }
                    case 'timeEstimate':
                        {
                            const { EstimateComponent: EstimateComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(EstimateComponent, {
                                timeEstimate: value
                            });
                        }
                    case 'exceptions':
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, "-");
                    case 'components':
                    case 'addedComponents':
                    case 'removedComponents':
                        {
                            const details = this.props.change.details;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b5p6y.default), {
                                project: details.values.project,
                                components: value,
                                isAdded: attributeName !== 'removedComponents'
                            });
                        }
                    case 'labels':
                    case 'addedLabels':
                    case 'removedLabels':
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $1mpFV.default), {
                            labels: value || [],
                            isAdded: attributeName !== 'removedLabels'
                        });
                    case 'color':
                        return null;
                    case 'goals':
                        {
                            const { GoalsComponent: GoalsComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(GoalsComponent, {
                                goals: value
                            });
                        }
                    case 'associatedIssueIds':
                        {
                            const { AssociatedIssuesComponent: AssociatedIssuesComponent } = this.props;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement(AssociatedIssuesComponent, {
                                associatedIssuesIds: value
                            });
                        }
                    default:
                        {
                            const text = (0, $4nDwW.isDefined)(value) ? value : '-';
                            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                                content: text
                            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, text));
                        }
                }
            }
            return null;
        }
        constructor(...args){
            super(...args);
            this.getValues = ()=>{
                const { change: change, valueType: valueType } = this.props;
                switch(change.category){
                    case (0, $TTKUQ.ENTITY).ISSUE:
                    case (0, $TTKUQ.ENTITY).RELEASE:
                    case (0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE:
                    case (0, $TTKUQ.ENTITY).SPRINT:
                        if (valueType === (0, $dqW1t.VALUE_TYPE).CURRENT) return change.details.originals;
                        return change.details.values;
                    case (0, $TTKUQ.ENTITY).TEAM:
                    case (0, $TTKUQ.ENTITY).RESOURCE:
                        {
                            const detailChange = (0, $60TfX.getDetailChange)(change);
                            if (!detailChange) return {};
                            if (valueType === (0, $dqW1t.VALUE_TYPE).CURRENT) return {
                                [detailChange.attributeName]: detailChange.originalValue
                            };
                            return {
                                [detailChange.attributeName]: detailChange.currentValue
                            };
                        }
                    default:
                        return {};
                }
            };
        }
    }
    var $d54c8d51b56ef5ee$export$2e2bcd8739ae039 = (0, $84qTJ.injectIntlWithDefaultProps)($d54c8d51b56ef5ee$var$ValueChangeCell);
});
parcelRegister("bSywi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5280892890ad3d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $aipk9;
    var $6X8w9 = parcelRequire("6X8w9");
    var $ipX5U = parcelRequire("ipX5U");
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    function $b5280892890ad3d5$var$ReleaseDate(props) {
        const { intl: intl, end: end, emptyMessage: emptyMessage } = props;
        const { formatTimestamp: formatTimestamp } = (0, (0, parcelRequire("aipk9")).useDateFormatter)();
        if (end === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, emptyMessage);
        const { method: method } = (0, $ipX5U.getEndDateMethod)(end);
        if (method === (0, $6X8w9.DATE_METHODS).FIXED_DATE && (0, $4nDwW.isDefined)(end)) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, formatTimestamp(end));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, intl.formatMessage((0, $ihPUd.default).afterAllIssuesAreCompleted));
    }
    var $b5280892890ad3d5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($b5280892890ad3d5$var$ReleaseDate);
});
parcelRegister("1BOrS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6fb7cc17792e5d86$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $aipk9;
    var $6X8w9 = parcelRequire("6X8w9");
    var $ipX5U = parcelRequire("ipX5U");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $ihPUd = parcelRequire("ihPUd");
    function $6fb7cc17792e5d86$var$StartDate(props) {
        const { intl: intl, start: start, delta: delta, emptyMessage: emptyMessage } = props;
        const { formatTimestamp: formatTimestamp } = (0, (0, parcelRequire("aipk9")).useDateFormatter)();
        if (start === undefined && delta === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, emptyMessage);
        const { method: method, quantity: quantity = 0, unit: unit = 0, direction: direction = (0, $TTKUQ.DIRECTIONS).AFTER } = (0, $ipX5U.getStartDateMethod)(start, delta);
        let message;
        if (method === (0, $6X8w9.DATE_METHODS).FIXED_DATE && (0, $4nDwW.isDefined)(start)) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, formatTimestamp(start));
        if (method === (0, $6X8w9.DATE_METHODS).RELATIVE_TO_PREVIOUS_RELEASE) {
            if (quantity === 0) {
                message = intl.formatMessage((0, $ihPUd.default).whenPreviousReleaseEnds);
                return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, message);
            }
            message = intl.formatMessage((0, $ihPUd.default).relativeToPreviousRelease, {
                factor: `${quantity} ${unit} ${intl.formatMessage((0, $ihPUd.default)[direction])}`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, message);
        }
        message = intl.formatMessage((0, $ihPUd.default).asEarlyAsPossible);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, message);
    }
    var $6fb7cc17792e5d86$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($6fb7cc17792e5d86$var$StartDate);
});
parcelRegister("190ki", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5cd71332f3bdab1$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hELdh = parcelRequire("hELdh");
    var $7GPPa = parcelRequire("7GPPa");
    var $f5cd71332f3bdab1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hELdh.default), {})((0, $7GPPa.default));
});
parcelRegister("hELdh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f9ddc1af088687b$export$2e2bcd8739ae039);
    var $hu7Cn = parcelRequire("hu7Cn");
    const $0f9ddc1af088687b$export$78fb49a702cc1f2 = (state)=>({
            assigneeList: (0, $hu7Cn.getAssigneeList)(state)
        });
    var $0f9ddc1af088687b$export$2e2bcd8739ae039 = $0f9ddc1af088687b$export$78fb49a702cc1f2;
});
parcelRegister("7GPPa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$271df6637a1dd562$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $8JOG8 = parcelRequire("8JOG8");
    var $c5575 = parcelRequire("c5575");
    var $kwi44 = parcelRequire("kwi44");
    function $271df6637a1dd562$export$2e2bcd8739ae039(props) {
        const { assignee: assignee, assigneeList: assigneeList } = props;
        if (!assignee) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "-");
        const person = assigneeList.find((person)=>person.personId === assignee);
        if (person) {
            const { jiraUser: { title: title, avatarUrl: avatarUrl } } = person;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                content: title,
                id: assignee
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $kwi44.avatar
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "xsmall",
                src: avatarUrl
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $kwi44.title
            }, title));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c5575.default), null));
    }
});
parcelRegister("c5575", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a74ceb65131e801$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8RXs9;
    var $ihPUd = parcelRequire("ihPUd");
    function $1a74ceb65131e801$var$NotInPlanMessage(_) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).notInPlan);
    }
    var $1a74ceb65131e801$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($1a74ceb65131e801$var$NotInPlanMessage);
});
parcelRegister("kwi44", function(module, exports) {
    $parcel$export(module.exports, "avatar", ()=>$ef04cf12fed6069d$export$345c5736c8054f22, (v)=>$ef04cf12fed6069d$export$345c5736c8054f22 = v);
    $parcel$export(module.exports, "title", ()=>$ef04cf12fed6069d$export$fb184b623420d9be, (v)=>$ef04cf12fed6069d$export$fb184b623420d9be = v);
    var $ef04cf12fed6069d$export$345c5736c8054f22;
    var $ef04cf12fed6069d$export$fb184b623420d9be;
    $ef04cf12fed6069d$export$345c5736c8054f22 = `J-Y8fq_avatar`;
    $ef04cf12fed6069d$export$fb184b623420d9be = `J-Y8fq_title`;
});
parcelRegister("9y7MQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e045ea625bff7cd$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3AMQP = parcelRequire("3AMQP");
    var $j3dnG = parcelRequire("j3dnG");
    var $7e045ea625bff7cd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $3AMQP.default), null)((0, $j3dnG.AssociatedIssues));
});
parcelRegister("3AMQP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bbc35bc0ca3d6dd6$export$2e2bcd8739ae039);
    var $jwsTD;
    const $bbc35bc0ca3d6dd6$var$mapStateToProps = (state)=>({
            associatedIssues: (0, (0, parcelRequire("jwsTD")).getAssociatedIssues)(state.domain.associatedIssues)
        });
    var $bbc35bc0ca3d6dd6$export$2e2bcd8739ae039 = $bbc35bc0ca3d6dd6$var$mapStateToProps;
});
parcelRegister("j3dnG", function(module, exports) {
    $parcel$export(module.exports, "AssociatedIssues", ()=>$76508c5afade00ec$export$9eac0eb1b0d13f0d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $dC5iT;
    var $cgL5K;
    var $8JOG8 = parcelRequire("8JOG8");
    const $76508c5afade00ec$export$9eac0eb1b0d13f0d = ({ associatedIssuesIds: associatedIssuesIds, associatedIssues: associatedIssues })=>{
        if ((0, ($parcel$interopDefault($gccSB)))(associatedIssuesIds)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, "-");
        const associatedIssuesNames = associatedIssuesIds.map((id)=>associatedIssues?.[id]?.summary).filter((name)=>!!name).sort().join(', ');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: associatedIssuesNames
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, associatedIssuesNames));
    };
});
parcelRegister("b5p6y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af7142304fefe73a$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6OtbS = parcelRequire("6OtbS");
    var $4tIrW = parcelRequire("4tIrW");
    var $af7142304fefe73a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6OtbS.default), {})((0, $4tIrW.default));
});
parcelRegister("6OtbS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5fe2ea959b2836a2$export$2e2bcd8739ae039);
    var $5nMRY = parcelRequire("5nMRY");
    const $5fe2ea959b2836a2$var$querySelector = (state)=>({
            componentDetails: (0, $5nMRY.getComponentsByProjectId)(state)
        });
    var $5fe2ea959b2836a2$export$2e2bcd8739ae039 = $5fe2ea959b2836a2$var$querySelector;
});
parcelRegister("4tIrW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21ac8d806cf813a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kCf27 = parcelRequire("kCf27");
    class $21ac8d806cf813a5$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const title = this.getComponents().map((component)=>component.name).join(', ');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kCf27.default), {
                tooltip: title,
                tags: this.getComponents().map((component)=>component.name),
                isRemoved: !this.props.isAdded
            });
        }
        constructor(...args){
            super(...args);
            this.getComponents = ()=>{
                const { componentDetails: componentDetails, components: components, project: project } = this.props;
                if (!components || !project) return [];
                return componentDetails[project.toString()].filter((component)=>components.includes(component.id));
            };
        }
    }
});
parcelRegister("kCf27", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$163709468a156775$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $d9xxV;
    var $3bDjY;
    var $lFFD7 = parcelRequire("lFFD7");
    function $163709468a156775$export$2e2bcd8739ae039(props) {
        const { tooltip: tooltip, tags: tags, isRemoved: isRemoved, width: width } = props;
        let componentClass = $lFFD7.component;
        if (isRemoved) componentClass = `${componentClass} ${$lFFD7.componentRemoved}`;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lFFD7.componentsContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltip
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lFFD7.tagContainer,
            style: {
                maxWidth: width
            }
        }, tags.map((tag, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: componentClass,
                key: i
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9xxV")).default), {
                text: tag
            })))))));
    }
});
parcelRegister("lFFD7", function(module, exports) {
    $parcel$export(module.exports, "component", ()=>$fc6db82622736576$export$d8556a2a8f973135, (v)=>$fc6db82622736576$export$d8556a2a8f973135 = v);
    $parcel$export(module.exports, "componentRemoved", ()=>$fc6db82622736576$export$95ba871b46255fbb, (v)=>$fc6db82622736576$export$95ba871b46255fbb = v);
    $parcel$export(module.exports, "componentsContainer", ()=>$fc6db82622736576$export$77d38a6d62c7a7c9, (v)=>$fc6db82622736576$export$77d38a6d62c7a7c9 = v);
    $parcel$export(module.exports, "tagContainer", ()=>$fc6db82622736576$export$89a4c13858b336ea, (v)=>$fc6db82622736576$export$89a4c13858b336ea = v);
    var $fc6db82622736576$export$d8556a2a8f973135;
    var $fc6db82622736576$export$95ba871b46255fbb;
    var $fc6db82622736576$export$77d38a6d62c7a7c9;
    var $fc6db82622736576$export$89a4c13858b336ea;
    $fc6db82622736576$export$d8556a2a8f973135 = `_9m15JG_component`;
    $fc6db82622736576$export$95ba871b46255fbb = `_9m15JG_componentRemoved`;
    $fc6db82622736576$export$77d38a6d62c7a7c9 = `_9m15JG_componentsContainer`;
    $fc6db82622736576$export$89a4c13858b336ea = `_9m15JG_tagContainer`;
});
parcelRegister("amSD3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc7f3a77cb9bdde3$export$2e2bcd8739ae039);
    var $bC2fB;
    var $hSDuU = parcelRequire("hSDuU");
    var $9f9UJ = parcelRequire("9f9UJ");
    var $fc7f3a77cb9bdde3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $hSDuU.default), {})((0, $9f9UJ.default));
});
parcelRegister("hSDuU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fdef07a0a75c75c2$export$2e2bcd8739ae039);
    var $jw86H = parcelRequire("jw86H");
    var $3YtPS = parcelRequire("3YtPS");
    var $fdef07a0a75c75c2$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        crossProjectVersions: (0, $jw86H.getCrossProjectVersions),
        removedCrossProjectVersions: (0, $jw86H.getRemovedCrossProjectVersions)
    });
});
parcelRegister("9f9UJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$198d54d850ac17b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2rMKg;
    var $4nDwW = parcelRequire("4nDwW");
    var $8JOG8 = parcelRequire("8JOG8");
    var $c5575 = parcelRequire("c5575");
    function $198d54d850ac17b8$export$2e2bcd8739ae039(props) {
        const { crossProjectVersionId: crossProjectVersionId, crossProjectVersions: crossProjectVersions, removedCrossProjectVersions: removedCrossProjectVersions } = props;
        const crossProjectVersionsByIdMap = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), [
            ...crossProjectVersions,
            ...removedCrossProjectVersions
        ]);
        const crossProjectVersion = crossProjectVersionsByIdMap[crossProjectVersionId];
        return (0, $4nDwW.isDefined)(crossProjectVersion) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: crossProjectVersion.name,
            id: crossProjectVersionId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, crossProjectVersion.name)) : (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c5575.default), null));
    }
});
parcelRegister("lYv6u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e885ac680391651$export$2e2bcd8739ae039);
    var $bC2fB;
    var $belxf = parcelRequire("belxf");
    var $2e9OZ = parcelRequire("2e9OZ");
    var $7e885ac680391651$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $belxf.default), {})((0, $2e9OZ.default));
});
parcelRegister("belxf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c754e7218590c72$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $3YtPS = parcelRequire("3YtPS");
    const $3c754e7218590c72$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        customFields: (0, $19iju.getSupportedCustomFields)
    });
    var $3c754e7218590c72$export$2e2bcd8739ae039 = $3c754e7218590c72$var$mapStateToProps;
});
parcelRegister("2e9OZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e11c7650f07b67ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $b1KRQ = parcelRequire("b1KRQ");
    var $hEQRk = parcelRequire("hEQRk");
    var $fJsFL = parcelRequire("fJsFL");
    var $VsuYp = parcelRequire("VsuYp");
    var $hyAS6 = parcelRequire("hyAS6");
    function $e11c7650f07b67ce$export$2e2bcd8739ae039(props) {
        const { customFields: customFields, id: id, value: value, attributeName: attributeName } = props;
        if (!(0, $4nDwW.isDefined)(value)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, "-");
        const field = customFields.find((field)=>field.id.toString() === id.toString());
        const emptyElement = (0, ($parcel$interopDefault($5uXOq))).createElement("div", null);
        if (!field) return emptyElement;
        if (typeof value === 'string' || typeof value === 'number') {
            const valueString = value === 'string' ? value : String(value);
            switch(field.type.key){
                case (0, $TTKUQ.CustomFieldTypes).TextField:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $VsuYp.default), {
                        value: valueString
                    });
                case (0, $TTKUQ.CustomFieldTypes).NumberField:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $VsuYp.default), {
                        value: valueString
                    });
                case (0, $TTKUQ.CustomFieldTypes).SingleSelect:
                case (0, $TTKUQ.CustomFieldTypes).RadioButtons:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fJsFL.default), {
                        value: valueString
                    });
                case (0, $TTKUQ.CustomFieldTypes).DatePicker:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b1KRQ.default), {
                        value: value
                    });
                case (0, $TTKUQ.CustomFieldTypes).UserPicker:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hyAS6.default), {
                        value: valueString
                    });
                default:
                    return emptyElement;
            }
        } else switch(field.type.key){
            case (0, $TTKUQ.CustomFieldTypes).Labels:
            case (0, $TTKUQ.CustomFieldTypes).MultiSelect:
            case (0, $TTKUQ.CustomFieldTypes).MultiCheckboxes:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hEQRk.default), {
                    value: value,
                    attributeName: attributeName
                });
            default:
                return emptyElement;
        }
    }
});
parcelRegister("b1KRQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38b789694916cdac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aipk9;
    var $8JOG8 = parcelRequire("8JOG8");
    function $38b789694916cdac$export$2e2bcd8739ae039(props) {
        const { value: value } = props;
        const { formatTimestamp: formatTimestamp } = (0, (0, parcelRequire("aipk9")).useDateFormatter)();
        const getFormattedDate = (value)=>formatTimestamp(value);
        const date = typeof value === 'number' ? getFormattedDate(value) : value;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: date
        }, date);
    }
});
parcelRegister("hEQRk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c05646d38b820bdc$export$2e2bcd8739ae039);
    var $bC2fB;
    var $eBSfM = parcelRequire("eBSfM");
    var $ljSwh = parcelRequire("ljSwh");
    var $c05646d38b820bdc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $eBSfM.default), {})((0, $ljSwh.default));
});
parcelRegister("eBSfM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$429720ce6f5a1fed$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $3YtPS = parcelRequire("3YtPS");
    const $429720ce6f5a1fed$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        selectOptions: (0, $19iju.getSelectOptions)
    });
    var $429720ce6f5a1fed$export$2e2bcd8739ae039 = $429720ce6f5a1fed$var$querySelector;
});
parcelRegister("ljSwh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bac0d6c393b4318c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kCf27 = parcelRequire("kCf27");
    class $bac0d6c393b4318c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { value: value = [], attributeName: attributeName } = this.props;
            const options = value.map(this.getValue).map((option)=>option.value);
            const title = options.join(', ');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kCf27.default), {
                tooltip: title,
                tags: options,
                isRemoved: attributeName.startsWith('customFieldValueRemoved'),
                width: "150px"
            });
        }
        constructor(...args){
            super(...args);
            this.getValue = (id)=>{
                const { selectOptions: selectOptions } = this.props;
                const option = selectOptions.find((option)=>option.id.toString() === id.toString());
                if (!option) return {
                    value: id
                };
                return option;
            };
        }
    }
});
parcelRegister("fJsFL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8d820311435cb79$export$2e2bcd8739ae039);
    var $bC2fB;
    var $1abHY = parcelRequire("1abHY");
    var $eLrjz = parcelRequire("eLrjz");
    var $b8d820311435cb79$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $1abHY.default), {})((0, $eLrjz.default));
});
parcelRegister("1abHY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3604c8d3967331f7$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $3YtPS = parcelRequire("3YtPS");
    const $3604c8d3967331f7$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        singleSelectionOptions: (0, $19iju.getSelectOptions)
    });
    var $3604c8d3967331f7$export$2e2bcd8739ae039 = $3604c8d3967331f7$var$mapStateToProps;
});
parcelRegister("eLrjz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87ccc017d59375ae$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8JOG8 = parcelRequire("8JOG8");
    function $87ccc017d59375ae$export$2e2bcd8739ae039(props) {
        const { value: value, singleSelectionOptions: singleSelectionOptions } = props;
        const option = singleSelectionOptions.find((option)=>option.id.toString() === value);
        if (!option) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, value);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: option.value
        }, option.value);
    }
});
parcelRegister("VsuYp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba42d8d7e0479eb1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8JOG8 = parcelRequire("8JOG8");
    function $ba42d8d7e0479eb1$export$2e2bcd8739ae039(props) {
        const { value: value } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: value
        }, value);
    }
});
parcelRegister("hyAS6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$378bbe503441b856$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3IHJJ = parcelRequire("3IHJJ");
    var $allPz = parcelRequire("allPz");
    var $378bbe503441b856$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $3IHJJ.default), {})((0, $allPz.default));
});
parcelRegister("3IHJJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cf4321dd3ba5325$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    const $6cf4321dd3ba5325$var$querySelector = (state)=>({
            userList: (0, $19iju.getUserPickerOptions)(state).userList
        });
    var $6cf4321dd3ba5325$export$2e2bcd8739ae039 = $6cf4321dd3ba5325$var$querySelector;
});
parcelRegister("allPz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$568e88ce841d0951$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $c5575 = parcelRequire("c5575");
    var $4nDwW = parcelRequire("4nDwW");
    var $8JOG8 = parcelRequire("8JOG8");
    var $2j7nF = parcelRequire("2j7nF");
    function $568e88ce841d0951$export$2e2bcd8739ae039(props) {
        const { value: value, userList: userList } = props;
        if (!(0, $4nDwW.isDefined)(value)) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "-");
        const user = userList.find((person)=>person.value === value);
        if (user) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: user.label,
            id: value
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $2j7nF.avatar
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "xsmall",
            src: user.icon
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $2j7nF.title
        }, user.label));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c5575.default), null));
    }
});
parcelRegister("2j7nF", function(module, exports) {
    $parcel$export(module.exports, "avatar", ()=>$1ae314c2bb9cd8a5$export$345c5736c8054f22, (v)=>$1ae314c2bb9cd8a5$export$345c5736c8054f22 = v);
    $parcel$export(module.exports, "title", ()=>$1ae314c2bb9cd8a5$export$fb184b623420d9be, (v)=>$1ae314c2bb9cd8a5$export$fb184b623420d9be = v);
    var $1ae314c2bb9cd8a5$export$345c5736c8054f22;
    var $1ae314c2bb9cd8a5$export$fb184b623420d9be;
    $1ae314c2bb9cd8a5$export$345c5736c8054f22 = `Fod5uq_avatar`;
    $1ae314c2bb9cd8a5$export$fb184b623420d9be = `Fod5uq_title`;
});
parcelRegister("793WC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c511b1fbb27d142$export$2e2bcd8739ae039);
    var $bC2fB;
    var $ikN82 = parcelRequire("ikN82");
    var $kpSDw = parcelRequire("kpSDw");
    var $0c511b1fbb27d142$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $ikN82.default), {})((0, $kpSDw.default));
});
parcelRegister("ikN82", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4e5cda496efebfb$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    var $jpgxP = parcelRequire("jpgxP");
    const $d4e5cda496efebfb$var$querySelector = (state)=>({
            plan: (0, $bHTqr.getPlan)(state),
            workingHours: (0, $jpgxP.getJiraHoursPerDay)(state)
        });
    var $d4e5cda496efebfb$export$2e2bcd8739ae039 = $d4e5cda496efebfb$var$querySelector;
});
parcelRegister("kpSDw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a46a0d15d06c285$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ekXoi = parcelRequire("ekXoi");
    var $4nDwW = parcelRequire("4nDwW");
    const $7a46a0d15d06c285$var$planningUnits = {
        storyPoints: 'StoryPoints',
        days: 'Days',
        hours: 'Hours'
    };
    class $7a46a0d15d06c285$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        getEstimateValue(planningUnit, timeEstimate) {
            switch(planningUnit){
                case $7a46a0d15d06c285$var$planningUnits.days:
                    return (0, $ekXoi.convertSecondsToDays)(timeEstimate, this.props.workingHours);
                case $7a46a0d15d06c285$var$planningUnits.hours:
                    return (0, $ekXoi.convertSecondsToHours)(timeEstimate);
                case $7a46a0d15d06c285$var$planningUnits.storyPoints:
                    return 0;
                default:
                    throw new Error(`Unexpected planningUnit: ${planningUnit}`);
            }
        }
        getEstimateText() {
            const { plan: { planningUnit: planningUnit }, timeEstimate: timeEstimate } = this.props;
            const estimateValue = this.getEstimateValue(planningUnit, timeEstimate);
            return this.round(estimateValue).toString();
        }
        render() {
            const { timeEstimate: timeEstimate } = this.props;
            if (!(0, $4nDwW.isDefined)(timeEstimate)) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "-");
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, this.getEstimateText());
        }
        constructor(...args){
            super(...args);
            this.round = (number)=>Math.round(number * 1000) / 1000;
        }
    }
});
parcelRegister("1gc7b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2099c18c95c06b1d$export$2e2bcd8739ae039);
    var $bC2fB;
    var $k2zvh = parcelRequire("k2zvh");
    var $d4qkp = parcelRequire("d4qkp");
    var $2099c18c95c06b1d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $k2zvh.default), null)((0, $d4qkp.GoalComponent));
});
parcelRegister("k2zvh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$602bddfd287ddfeb$export$2e2bcd8739ae039);
    var $bZA5o = parcelRequire("bZA5o");
    const $602bddfd287ddfeb$var$mapStateToProps = (state)=>({
            lazyGoalsByARI: (0, $bZA5o.getLazyGoalsByARI)(state)
        });
    var $602bddfd287ddfeb$export$2e2bcd8739ae039 = $602bddfd287ddfeb$var$mapStateToProps;
});
parcelRegister("d4qkp", function(module, exports) {
    $parcel$export(module.exports, "GoalComponent", ()=>$b9efbb9be802f183$export$f0d5b65a3d10deb5);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $cgL5K;
    var $8JOG8 = parcelRequire("8JOG8");
    const $b9efbb9be802f183$export$f0d5b65a3d10deb5 = ({ goals: goals, lazyGoalsByARI: lazyGoalsByARI })=>{
        const allGoals = goals.reduce((acc, goalARI)=>{
            const lazyGoal = lazyGoalsByARI[goalARI]?.goal;
            if (lazyGoal) acc.push(lazyGoal);
            return acc;
        }, []);
        if ((0, ($parcel$interopDefault($gccSB)))(allGoals)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, "-");
        const sortedGoalNames = allGoals.map((goal)=>goal.name).sort().join(', ');
        const sortedGoalKeys = allGoals.map((goal)=>goal.key).sort().join(', ');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: sortedGoalNames
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, sortedGoalKeys));
    };
});
parcelRegister("2e0YB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7fef5671516351da$export$2e2bcd8739ae039);
    var $bC2fB;
    var $iPhA5 = parcelRequire("iPhA5");
    var $3ahP3 = parcelRequire("3ahP3");
    var $7fef5671516351da$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $iPhA5.default), {})((0, $3ahP3.default));
});
parcelRegister("iPhA5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7869fa9e9383db87$export$2e2bcd8739ae039);
    var $kllqP = parcelRequire("kllqP");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $jpgxP = parcelRequire("jpgxP");
    var $3YtPS = parcelRequire("3YtPS");
    var $7869fa9e9383db87$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        issues: (0, $gFhwb.getIssues),
        issuesInChangeData: (0, $bI9dZ.getIssueChangesData),
        issueLinkTypes: (state)=>(0, $jpgxP.getIssueLinkTypesInfo)(state).issueLinkTypes,
        issueTypes: (0, $kllqP.getIssueTypes),
        projects: (0, $jpXKt.getProjects)
    });
});
parcelRegister("3ahP3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10f8c86ed097a0f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8CUq3;
    var $2FvnI;
    var $4nDwW = parcelRequire("4nDwW");
    var $8JOG8 = parcelRequire("8JOG8");
    var $64ySJ = parcelRequire("64ySJ");
    var $c5575 = parcelRequire("c5575");
    var $am9JO = parcelRequire("am9JO");
    function $10f8c86ed097a0f7$export$2e2bcd8739ae039(props) {
        const { issue: issueId, issues: issues, issuesInChangeData: issuesInChangeData, issueLinkTypes: issueLinkTypes, issueTypes: issueTypes, linkType: linkType, direction: direction, projects: projects } = props;
        const NotInPlanComponent = (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c5575.default), null));
        if (!issueId) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "-");
        const targetIssueFromChangeData = issuesInChangeData.find((currentIssue)=>currentIssue.id === issueId);
        const targetIssueFromBacklog = issues.find((currentIssue)=>currentIssue.id === issueId);
        if (!((0, $4nDwW.isDefined)(targetIssueFromChangeData) || (0, $4nDwW.isDefined)(targetIssueFromBacklog))) return NotInPlanComponent;
        let summary;
        let project;
        let type;
        let issueKey;
        if ((0, $4nDwW.isDefined)(targetIssueFromChangeData)) ({ values: { summary: summary, project: project, type: type }, issueKey: issueKey } = targetIssueFromChangeData);
        else if ((0, $4nDwW.isDefined)(targetIssueFromBacklog)) ({ summary: summary, project: project, type: type, issueKey: issueKey } = targetIssueFromBacklog);
        const targetProject = projects.find((currentProject)=>currentProject.id === project);
        const issueType = issueTypes.find((currentIssueType)=>currentIssueType.id === type);
        const link = linkType && issueLinkTypes.find(({ id: id })=>id === linkType);
        const issueLinkType = link && direction && (0, $64ySJ.titleCase)(link[direction]);
        if (targetProject && issueType) {
            const { key: projectKey } = targetProject;
            const title = `${issueLinkType ? `${issueLinkType} ` : ''}${projectKey}${issueKey ? `-${issueKey}` : ''} ${summary || ''}`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                content: title,
                id: issueId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $am9JO.issueTitle
            }, issueLinkType ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $am9JO.issueLinkType
            }, issueLinkType) : null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $am9JO.issueIcon,
                style: {
                    backgroundSize: 'contain',
                    backgroundImage: issueType && `url(${issueType.iconUrl})`
                }
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvnI")).default), {
                projectKey: projectKey,
                issueKey: issueKey,
                xcssStyles: $10f8c86ed097a0f7$var$issueLinkStyles
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $am9JO.issueSummary
            }, summary)));
        }
        return NotInPlanComponent;
    }
    const $10f8c86ed097a0f7$var$issueLinkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap'
    });
});
parcelRegister("am9JO", function(module, exports) {
    $parcel$export(module.exports, "issueIcon", ()=>$78a3832e8276c182$export$415983cbc1f2b3fe, (v)=>$78a3832e8276c182$export$415983cbc1f2b3fe = v);
    $parcel$export(module.exports, "issueLinkType", ()=>$78a3832e8276c182$export$294038f9fee3cea7, (v)=>$78a3832e8276c182$export$294038f9fee3cea7 = v);
    $parcel$export(module.exports, "issueSummary", ()=>$78a3832e8276c182$export$7c7bc027bbbea103, (v)=>$78a3832e8276c182$export$7c7bc027bbbea103 = v);
    $parcel$export(module.exports, "issueTitle", ()=>$78a3832e8276c182$export$12781bd67c11efd8, (v)=>$78a3832e8276c182$export$12781bd67c11efd8 = v);
    var $78a3832e8276c182$export$415983cbc1f2b3fe;
    var $78a3832e8276c182$export$294038f9fee3cea7;
    var $78a3832e8276c182$export$7c7bc027bbbea103;
    var $78a3832e8276c182$export$12781bd67c11efd8;
    $78a3832e8276c182$export$415983cbc1f2b3fe = `-1QI8a_issueIcon`;
    $78a3832e8276c182$export$294038f9fee3cea7 = `-1QI8a_issueLinkType`;
    $78a3832e8276c182$export$7c7bc027bbbea103 = `-1QI8a_issueSummary`;
    $78a3832e8276c182$export$12781bd67c11efd8 = `-1QI8a_issueTitle`;
});
parcelRegister("1mpFV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b87c60634513a5b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kCf27 = parcelRequire("kCf27");
    function $1b87c60634513a5b$export$2e2bcd8739ae039(props) {
        const { labels: labels, isAdded: isAdded } = props;
        const title = labels.join(', ');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kCf27.default), {
            tooltip: title,
            tags: labels,
            isRemoved: !isAdded,
            width: "150px"
        });
    }
});
parcelRegister("7zxVh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cf9d50fcf31292b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6cf9d50fcf31292b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        multipleChanges: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.value-change.multiple-changes",
            "defaultMessage": "Multiple"
        },
        weeks: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.value-change.weeks",
            "defaultMessage": "Weeks"
        }
    });
});
parcelRegister("eaJmx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$073b59ad5d2529ad$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6g6Md = parcelRequire("6g6Md");
    var $kQaKi = parcelRequire("kQaKi");
    var $073b59ad5d2529ad$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6g6Md.default), {})((0, $kQaKi.default));
});
parcelRegister("6g6Md", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$696af2b16dfaa1d2$export$2e2bcd8739ae039);
    var $io4Ja = parcelRequire("io4Ja");
    var $jpXKt = parcelRequire("jpXKt");
    const $696af2b16dfaa1d2$var$querySelector = (state, ownProps)=>({
            prioritiesByIdMap: (0, $io4Ja.getIssuePriorities)(state),
            priorityIdsForProject: ownProps.project && (0, $jpXKt.getIssuePriorityIdsByProjectId)(state)[ownProps.project] || []
        });
    var $696af2b16dfaa1d2$export$2e2bcd8739ae039 = $696af2b16dfaa1d2$var$querySelector;
});
parcelRegister("kQaKi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c89cc4175dc9a39f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $eJyeb = parcelRequire("eJyeb");
    var $8JOG8 = parcelRequire("8JOG8");
    var $c5575 = parcelRequire("c5575");
    var $cXaUB = parcelRequire("cXaUB");
    function $c89cc4175dc9a39f$export$2e2bcd8739ae039(props) {
        const { prioritiesByIdMap: prioritiesByIdMap, priority: priority, priorityIdsForProject: priorityIdsForProject } = props;
        if (!priority) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "-");
        const targetPriority = prioritiesByIdMap[priority];
        if (targetPriority && priorityIdsForProject.includes(priority)) {
            const { iconUrl: iconUrl, name: name } = targetPriority;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                content: name,
                id: priority
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $cXaUB.avatar
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "xsmall",
                src: (0, $eJyeb.proxyContextSafeUrl)(iconUrl)
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $cXaUB.title
            }, name));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c5575.default), null));
    }
});
parcelRegister("cXaUB", function(module, exports) {
    $parcel$export(module.exports, "avatar", ()=>$96e375a0f6c7eaaa$export$345c5736c8054f22, (v)=>$96e375a0f6c7eaaa$export$345c5736c8054f22 = v);
    $parcel$export(module.exports, "title", ()=>$96e375a0f6c7eaaa$export$fb184b623420d9be, (v)=>$96e375a0f6c7eaaa$export$fb184b623420d9be = v);
    var $96e375a0f6c7eaaa$export$345c5736c8054f22;
    var $96e375a0f6c7eaaa$export$fb184b623420d9be;
    $96e375a0f6c7eaaa$export$345c5736c8054f22 = `jhcJ8q_avatar`;
    $96e375a0f6c7eaaa$export$fb184b623420d9be = `jhcJ8q_title`;
});
parcelRegister("2EcU8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9abba6d258bdcc6$export$2e2bcd8739ae039);
    var $bC2fB;
    var $1BCeQ = parcelRequire("1BCeQ");
    var $71L7w = parcelRequire("71L7w");
    var $e9abba6d258bdcc6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $1BCeQ.default), {})((0, $71L7w.default));
});
parcelRegister("1BCeQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff6201ab0072e808$export$2e2bcd8739ae039);
    var $jpXKt = parcelRequire("jpXKt");
    const $ff6201ab0072e808$var$querySelector = (state)=>({
            projects: (0, $jpXKt.getProjects)(state)
        });
    var $ff6201ab0072e808$export$2e2bcd8739ae039 = $ff6201ab0072e808$var$querySelector;
});
parcelRegister("71L7w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2923adc06395bc85$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $8JOG8 = parcelRequire("8JOG8");
    var $c5575 = parcelRequire("c5575");
    var $9e4fR = parcelRequire("9e4fR");
    function $2923adc06395bc85$export$2e2bcd8739ae039(props) {
        const { project: project, projects: projects } = props;
        const targetProject = projects.find((currentProject)=>currentProject.id === project);
        if (targetProject) {
            const { avatarUrl: avatarUrl, name: name } = targetProject;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                id: project,
                content: name
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $9e4fR.avatar
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "xsmall",
                src: avatarUrl
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $9e4fR.name
            }, name));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c5575.default), null));
    }
});
parcelRegister("9e4fR", function(module, exports) {
    $parcel$export(module.exports, "avatar", ()=>$6b78b8c7fe5d2305$export$345c5736c8054f22, (v)=>$6b78b8c7fe5d2305$export$345c5736c8054f22 = v);
    $parcel$export(module.exports, "name", ()=>$6b78b8c7fe5d2305$export$a8ff84c12d48cfa6, (v)=>$6b78b8c7fe5d2305$export$a8ff84c12d48cfa6 = v);
    var $6b78b8c7fe5d2305$export$345c5736c8054f22;
    var $6b78b8c7fe5d2305$export$a8ff84c12d48cfa6;
    $6b78b8c7fe5d2305$export$345c5736c8054f22 = `I5-f4G_avatar`;
    $6b78b8c7fe5d2305$export$a8ff84c12d48cfa6 = `I5-f4G_name`;
});
parcelRegister("dl8GJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0b6f04e4097e53e$export$2e2bcd8739ae039);
    var $cSD7y;
    var $bC2fB;
    var $7rM1N = parcelRequire("7rM1N");
    var $iqGwj = parcelRequire("iqGwj");
    const $b0b6f04e4097e53e$var$ReleaseOld = (0, (0, parcelRequire("bC2fB")).connect)((0, $7rM1N.mapStateToPropsOld), {})((0, $iqGwj.default));
    const $b0b6f04e4097e53e$var$Release = (0, (0, parcelRequire("bC2fB")).connect)((0, $7rM1N.default), {})((0, $iqGwj.default));
    var $b0b6f04e4097e53e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('review_changes_error_message_display', $b0b6f04e4097e53e$var$Release, $b0b6f04e4097e53e$var$ReleaseOld);
});
parcelRegister("7rM1N", function(module, exports) {
    $parcel$export(module.exports, "mapStateToPropsOld", ()=>$6f0d8e69d9df8240$export$54ca68d7ee17f324);
    $parcel$export(module.exports, "default", ()=>$6f0d8e69d9df8240$export$2e2bcd8739ae039);
    var $9FFuD = parcelRequire("9FFuD");
    var $3YtPS = parcelRequire("3YtPS");
    const $6f0d8e69d9df8240$export$54ca68d7ee17f324 = (state)=>({
            versions: [
                ...(0, $9FFuD.getVersions)(state),
                ...(0, $9FFuD.getRemovedVersions)(state)
            ]
        });
    const $6f0d8e69d9df8240$var$getVersionsMemoized = ()=>(0, $3YtPS.createSelector)((0, $9FFuD.getVersions), (0, $9FFuD.getRemovedVersions), (versions, removedVersions)=>[
                ...versions,
                ...removedVersions
            ]);
    const $6f0d8e69d9df8240$var$mapStateToPropsFactory = ()=>{
        const getVersionsInstance = $6f0d8e69d9df8240$var$getVersionsMemoized();
        return (state)=>({
                versions: getVersionsInstance(state)
            });
    };
    const $6f0d8e69d9df8240$var$mapStateToProps = $6f0d8e69d9df8240$var$mapStateToPropsFactory;
    var $6f0d8e69d9df8240$export$2e2bcd8739ae039 = $6f0d8e69d9df8240$var$mapStateToProps;
});
parcelRegister("iqGwj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$774cb116e735fbbd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $8RXs9;
    var $8JOG8 = parcelRequire("8JOG8");
    var $ihPUd = parcelRequire("ihPUd");
    function $774cb116e735fbbd$var$Release({ intl: intl, fixVersions: fixVersions = [], versions: versions }) {
        const versionNames = fixVersions && fixVersions.map((fixVersion)=>{
            const targetVersion = versions.find((currentVersion)=>currentVersion.id === fixVersion);
            if (targetVersion) return targetVersion.name;
            return intl.formatMessage((0, $ihPUd.default).notInPlan);
        });
        const placeholder = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, "-");
        return versionNames ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: versionNames.join(', ')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, versionNames.join(', '))) : placeholder;
    }
    var $774cb116e735fbbd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($774cb116e735fbbd$var$Release);
});
parcelRegister("jsjls", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$740256a69134c1c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $6TEBn = parcelRequire("6TEBn");
    var $4nDwW = parcelRequire("4nDwW");
    var $kd6lS = parcelRequire("kd6lS");
    const $740256a69134c1c5$var$hoursPerDay = 8;
    class $740256a69134c1c5$var$PlannedCapacity extends (0, $5uXOq.Component) {
        getConvertedValue() {
            const { capacity: capacity, planningUnit: planningUnit } = this.props.plannedCapacity;
            return (0, $6TEBn.convertCapacityByPlanningUnit)({
                capacity: capacity || 0,
                planningUnit: planningUnit,
                workingHours: $740256a69134c1c5$var$hoursPerDay
            });
        }
        render() {
            const { intl: intl, plannedCapacity: plannedCapacity } = this.props;
            if (!(0, $4nDwW.isDefined)(plannedCapacity)) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "-");
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, this.getConvertedValue(), ' ', intl.formatMessage((0, $kd6lS.default).plannedCapacityUnits, {
                planningUnit: plannedCapacity.planningUnit
            }));
        }
    }
    var $740256a69134c1c5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($740256a69134c1c5$var$PlannedCapacity);
});
parcelRegister("kd6lS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc148de65dd5c408$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fc148de65dd5c408$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        plannedCapacityUnits: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.value-change.sprint-velocity.planned-capacity-units",
            "defaultMessage": "{planningUnit, select, Hours {hours} StoryPoints {points} Days {days} other {points}}"
        }
    });
});
parcelRegister("4LjFo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$304ca7a31de72d81$export$2e2bcd8739ae039);
    var $bC2fB;
    var $4RjHV = parcelRequire("4RjHV");
    var $lfIjg = parcelRequire("lfIjg");
    var $304ca7a31de72d81$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $4RjHV.default), {})((0, $lfIjg.default));
});
parcelRegister("4RjHV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cd7e5283e5a71d6$export$2e2bcd8739ae039);
    var $d3quy = parcelRequire("d3quy");
    const $6cd7e5283e5a71d6$var$querySelector = (state)=>({
            sprints: (0, $d3quy.getSprints)(state),
            externalSprintsById: (0, $d3quy.getExternalSprintsById)(state)
        });
    var $6cd7e5283e5a71d6$export$2e2bcd8739ae039 = $6cd7e5283e5a71d6$var$querySelector;
});
parcelRegister("lfIjg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f85ac05cac6f76a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $8JOG8 = parcelRequire("8JOG8");
    var $c5575 = parcelRequire("c5575");
    var $2cX2c = parcelRequire("2cX2c");
    function $0f85ac05cac6f76a$var$Sprint(props) {
        const { intl: intl, sprint: sprint, sprints: sprints, externalSprintsById: externalSprintsById } = props;
        if (!sprint) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "-");
        const targetSprint = sprints.find((currentSprint)=>currentSprint.id === sprint);
        if (targetSprint) {
            const { title: title } = targetSprint;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                content: title,
                id: sprint
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, title));
        }
        const externalSprint = externalSprintsById[sprint];
        if (externalSprint) {
            const { title: title } = externalSprint;
            const externalSprintText = intl.formatMessage((0, $2cX2c.default).externalSprint);
            const text = `${title} (${externalSprintText})`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                content: text,
                id: sprint
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, text));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c5575.default), null));
    }
    var $0f85ac05cac6f76a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($0f85ac05cac6f76a$var$Sprint);
});
parcelRegister("2cX2c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e00f7203bed6918d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e00f7203bed6918d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        externalSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.value-change.sprint.external-sprint",
            "defaultMessage": "External sprint"
        }
    });
});
parcelRegister("9RKil", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0bcebd35435169c4$export$2e2bcd8739ae039);
    var $bC2fB;
    var $66wJG = parcelRequire("66wJG");
    var $jBnSC = parcelRequire("jBnSC");
    var $0bcebd35435169c4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $66wJG.default), {})((0, $jBnSC.default));
});
parcelRegister("66wJG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b26f93b16c8dbf9$export$2e2bcd8739ae039);
    var $7ppNi = parcelRequire("7ppNi");
    const $2b26f93b16c8dbf9$var$querySelector = (state)=>({
            issueStatusesById: (0, $7ppNi.getIssueStatusById)(state)
        });
    var $2b26f93b16c8dbf9$export$2e2bcd8739ae039 = $2b26f93b16c8dbf9$var$querySelector;
});
parcelRegister("jBnSC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1c03c24c404d692$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fQeLt;
    class $e1c03c24c404d692$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { statusId: statusId, issueStatusesById: issueStatusesById } = this.props;
            const status = statusId && issueStatusesById && issueStatusesById[statusId];
            if (!status) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "-");
            const { id: id, name: name, categoryId: categoryId } = status;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": `status-changed-${id}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fQeLt")).StatusLozenge), {
                value: {
                    id: id,
                    name: name,
                    statusCategory: {
                        id: categoryId
                    }
                }
            }));
        }
    }
});
parcelRegister("cQ391", function(module, exports) {
    $parcel$export(module.exports, "multiple-label", ()=>$958cc7d207d87958$export$463ec856c7c8a0fb, (v)=>$958cc7d207d87958$export$463ec856c7c8a0fb = v);
    var $958cc7d207d87958$export$463ec856c7c8a0fb;
    $958cc7d207d87958$export$463ec856c7c8a0fb = `Kph_na_multiple-label`;
});
parcelRegister("8TGna", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$011106e23a5b9a99$export$2e2bcd8739ae039);
    var $bC2fB;
    var $flw6q = parcelRequire("flw6q");
    var $ekFGl = parcelRequire("ekFGl");
    var $011106e23a5b9a99$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $flw6q.default), {})((0, $ekFGl.default));
});
parcelRegister("flw6q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab05f30cd1c04c36$export$2e2bcd8739ae039);
    var $dRVQG = parcelRequire("dRVQG");
    var $3YtPS = parcelRequire("3YtPS");
    var $ab05f30cd1c04c36$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        teams: (0, $dRVQG.getTeams)
    });
});
parcelRegister("ekFGl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09879de90a71fe02$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $h8cgU;
    var $8JOG8 = parcelRequire("8JOG8");
    var $c5575 = parcelRequire("c5575");
    var $1rlNN = parcelRequire("1rlNN");
    function $09879de90a71fe02$export$2e2bcd8739ae039(props) {
        const { team: team, teams: teams } = props;
        if (!team) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "-");
        const targetTeam = teams.find((currentTeam)=>currentTeam.id === team);
        if (targetTeam) {
            const { avatarUrl: avatarUrl, title: title } = targetTeam;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $1rlNN["title-group"]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $1rlNN.avatar
            }, !avatarUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $1rlNN.defaultTeamAvatar
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))), {
                label: "",
                size: "small"
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                size: "xsmall",
                src: avatarUrl
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                content: title,
                id: team
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $1rlNN.title
            }, title))));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $c5575.default), null));
    }
});
parcelRegister("1rlNN", function(module, exports) {
    $parcel$export(module.exports, "avatar", ()=>$10c93984fb332fb9$export$345c5736c8054f22, (v)=>$10c93984fb332fb9$export$345c5736c8054f22 = v);
    $parcel$export(module.exports, "defaultTeamAvatar", ()=>$10c93984fb332fb9$export$aa80651379a69724, (v)=>$10c93984fb332fb9$export$aa80651379a69724 = v);
    $parcel$export(module.exports, "title", ()=>$10c93984fb332fb9$export$fb184b623420d9be, (v)=>$10c93984fb332fb9$export$fb184b623420d9be = v);
    $parcel$export(module.exports, "title-group", ()=>$10c93984fb332fb9$export$6bdb7531c44b5e4e, (v)=>$10c93984fb332fb9$export$6bdb7531c44b5e4e = v);
    var $10c93984fb332fb9$export$345c5736c8054f22;
    var $10c93984fb332fb9$export$aa80651379a69724;
    var $10c93984fb332fb9$export$fb184b623420d9be;
    var $10c93984fb332fb9$export$6bdb7531c44b5e4e;
    $10c93984fb332fb9$export$345c5736c8054f22 = `ihzk7q_avatar`;
    $10c93984fb332fb9$export$aa80651379a69724 = `ihzk7q_defaultTeamAvatar`;
    $10c93984fb332fb9$export$fb184b623420d9be = `ihzk7q_title`;
    $10c93984fb332fb9$export$6bdb7531c44b5e4e = `ihzk7q_title-group`;
});
parcelRegister("dqW1t", function(module, exports) {
    $parcel$export(module.exports, "VALUE_TYPE", ()=>$7c360e44217eb483$export$1345b4a1d6c7126b);
    const $7c360e44217eb483$export$1345b4a1d6c7126b = {
        CURRENT: 'current',
        NEW: 'new'
    };
});
parcelRegister("faAjx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7717a921e53c85a7$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6GpMe = parcelRequire("6GpMe");
    var $kSADz = parcelRequire("kSADz");
    var $8wVCM = parcelRequire("8wVCM");
    var $7717a921e53c85a7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $kSADz.default), (0, $6GpMe.default))((0, $8wVCM.default));
});
parcelRegister("6GpMe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d99d39ea32038bc9$export$2e2bcd8739ae039);
    var $aHSC5 = parcelRequire("aHSC5");
    var $d99d39ea32038bc9$export$2e2bcd8739ae039 = (dispatch)=>({
            expandChange: (id, category)=>{
                dispatch((0, $aHSC5.expandChange)(id, category));
            },
            collapseChange: (id, category)=>{
                dispatch((0, $aHSC5.collapseChange)(id, category));
            }
        });
});
parcelRegister("kSADz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$183da3c64321ba03$export$2e2bcd8739ae039);
    var $19iju = parcelRequire("19iju");
    var $bHTqr = parcelRequire("bHTqr");
    var $dRVQG = parcelRequire("dRVQG");
    var $25viM = parcelRequire("25viM");
    var $3YtPS = parcelRequire("3YtPS");
    const $183da3c64321ba03$var$querySelector = (0, $3YtPS.createStructuredSelector)({
        plan: (0, $bHTqr.getPlan),
        expandedChanges: (0, $25viM.getExpandedChanges),
        customFields: (0, $19iju.getSupportedCustomFields),
        teamsById: (0, $dRVQG.getTeamsById)
    });
    var $183da3c64321ba03$export$2e2bcd8739ae039 = $183da3c64321ba03$var$querySelector;
});
parcelRegister("8wVCM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0f8efc873c349be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fZhYM;
    var $6Ingq;
    var $ebd3R;
    var $lj8SI;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $ousew;
    var $8RXs9;
    var $eOEXL = parcelRequire("eOEXL");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $8JOG8 = parcelRequire("8JOG8");
    var $ihPUd = parcelRequire("ihPUd");
    var $dCm1o;
    var $e7HS5 = parcelRequire("e7HS5");
    var $bgsRZ = parcelRequire("bgsRZ");
    const $a0f8efc873c349be$var$SpanWithTitle = ({ value: value })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
            content: value
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, value));
    const $a0f8efc873c349be$var$SpanWithTitleAndParenthetical = ({ value: value, parenthetical: parenthetical })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: `${value} (${parenthetical})`,
            position: "mouse",
            tag: "span"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $bgsRZ["attribute-with-parenthetical"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, value, "\xa0"), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $bgsRZ.parenthetical
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "("), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $bgsRZ.ellipsed
        }, parenthetical), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, ")"))));
    const $a0f8efc873c349be$var$ChevronContainer = ({ children: children })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $a0f8efc873c349be$var$ChevronContainerStyles
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: `${$bgsRZ.icon} ${$bgsRZ.toggle}`
        }, children);
    class $a0f8efc873c349be$var$WhatChangedCell extends (0, $5uXOq.Component) {
        renderChevron() {
            const isExpanded = this.isExpanded();
            return (0, ($parcel$interopDefault($5uXOq))).createElement($a0f8efc873c349be$var$ChevronContainer, null, isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                label: "",
                size: "medium"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))), {
                label: "",
                size: "medium"
            }));
        }
        onKeyDownHandler(e) {
            if (e.key === 'Enter') {
                const { expandChange: expandChange, collapseChange: collapseChange, id: id, category: category } = this.props;
                this.isExpanded() ? collapseChange(id, category) : expandChange(id, category);
            }
        }
        render() {
            const { attributeName: attributeName, intl: intl, changeType: changeType, changeCount: changeCount, expandChange: expandChange, collapseChange: collapseChange, id: id, category: category, changeDetails: changeDetails, teamsById: teamsById } = this.props;
            const messages = {
                ...(0, $e7HS5.default),
                assignee: (0, $ihPUd.default).assignee,
                crossProjectVersion: (0, $ihPUd.default).crossProjectRelease,
                dueDate: (0, $ihPUd.default).dueDate,
                name: (0, $ihPUd.default).name,
                status: (0, $ihPUd.default).status
            };
            const isExpanded = this.isExpanded();
            switch(changeType){
                case (0, $TTKUQ.SCENARIO_TYPE).ADDED:
                case (0, $TTKUQ.SCENARIO_TYPE).ADDEDEXISTING:
                    {
                        const label = changeType === (0, $TTKUQ.SCENARIO_TYPE).ADDED ? messages.createdLabel : messages.addedLabel;
                        if (changeCount > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                            "aria-expanded": isExpanded,
                            className: `${$bgsRZ.multiple} ${$bgsRZ.toggle}`,
                            onClick: ()=>isExpanded ? collapseChange(id, category) : expandChange(id, category),
                            onKeyDown: this.onKeyDownHandler
                        }, this.renderChevron(), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                            className: $bgsRZ.label
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                            appearance: "new"
                        }, intl.formatMessage(label)), ' +', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                            ...messages.changeCount,
                            values: {
                                count: changeCount
                            }
                        })));
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                            appearance: "new"
                        }, intl.formatMessage(label));
                    }
                case (0, $TTKUQ.SCENARIO_TYPE).MULTIPLE:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                        "aria-expanded": isExpanded,
                        className: `${$bgsRZ.multiple} ${$bgsRZ.toggle}`,
                        onClick: ()=>isExpanded ? collapseChange(id, category) : expandChange(id, category),
                        onKeyDown: this.onKeyDownHandler
                    }, this.renderChevron(), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                        className: $bgsRZ.label
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                        ...messages.changeCount,
                        values: {
                            count: changeCount
                        }
                    })));
                case (0, $TTKUQ.SCENARIO_TYPE).DELETED:
                    if (category === (0, $TTKUQ.ENTITY).RELEASE || category === (0, $TTKUQ.ENTITY).ISSUE) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                        appearance: "removed"
                    }, intl.formatMessage(messages.excludedLabel));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                        appearance: "removed"
                    }, intl.formatMessage(messages.deletedLabel));
                case 'EXCLUDED':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                        appearance: "removed"
                    }, intl.formatMessage(messages.excludedLabel));
                default:
                    {
                        if (attributeName === 'timeEstimate') {
                            const { plan: { planningUnit: planningUnit } } = this.props;
                            if (planningUnit === (0, $TTKUQ.PLANNING_UNITS).DAYS) return (0, ($parcel$interopDefault($5uXOq))).createElement($a0f8efc873c349be$var$SpanWithTitle, {
                                value: intl.formatMessage(messages.timeEstimateDays)
                            });
                            return (0, ($parcel$interopDefault($5uXOq))).createElement($a0f8efc873c349be$var$SpanWithTitle, {
                                value: intl.formatMessage(messages.timeEstimateHours)
                            });
                        }
                        if (category === (0, $TTKUQ.ENTITY).ISSUE && attributeName === 'associatedIssueIds') {
                            const message = intl.formatMessage(messages.ideasChanged);
                            return (0, ($parcel$interopDefault($5uXOq))).createElement($a0f8efc873c349be$var$SpanWithTitle, {
                                value: message
                            });
                        }
                        if (category === (0, $TTKUQ.ENTITY).RESOURCE && attributeName !== 'addedMember' && attributeName !== 'removedMember') {
                            const resourceChange = changeDetails && changeDetails.details && (0, $eOEXL.isTeamAndResourceDetails)(changeDetails) && changeDetails.details.changes.find((change)=>change.resourceId === id);
                            const additionalInfo = resourceChange && resourceChange.personTitle ? `(${resourceChange.personTitle})` : '';
                            const change = messages[attributeName || ''] ? `${intl.formatMessage(messages[attributeName])} ${additionalInfo}` : '';
                            return (0, ($parcel$interopDefault($5uXOq))).createElement($a0f8efc873c349be$var$SpanWithTitle, {
                                value: change
                            });
                        }
                        if (category === (0, $TTKUQ.ENTITY).SPRINT && (0, $4nDwW.isDefined)(attributeName) && attributeName.startsWith('teamVelocity-')) {
                            const schedulingMode = (0, parcelRequire("fZhYM")).default([
                                'details',
                                'values',
                                'schedulingMode'
                            ], changeDetails);
                            const teamId = (0, parcelRequire("fZhYM")).default([
                                'details',
                                'values',
                                attributeName || '',
                                'teamId'
                            ], changeDetails) || '';
                            const team = teamsById[teamId] || {};
                            const attrTitle = intl.formatMessage(schedulingMode === (0, $TTKUQ.SCHEDULE_MODE).kanban ? messages.iterationVelocity : messages.plannedCapacity);
                            return (0, ($parcel$interopDefault($5uXOq))).createElement($a0f8efc873c349be$var$SpanWithTitleAndParenthetical, {
                                value: attrTitle,
                                parenthetical: team.title
                            });
                        }
                        if (attributeName && attributeName.startsWith('issueLink-')) {
                            const scenarioType = (0, parcelRequire("fZhYM")).default([
                                'details',
                                'values',
                                attributeName || '',
                                'scenarioType'
                            ], changeDetails) || (0, parcelRequire("fZhYM")).default([
                                'details',
                                'originals',
                                attributeName || '',
                                'scenarioType'
                            ], changeDetails);
                            let message;
                            switch(scenarioType){
                                case (0, $TTKUQ.SCENARIO_TYPE).ADDED:
                                    message = intl.formatMessage(messages.issueLinkCreated);
                                    break;
                                case (0, $TTKUQ.SCENARIO_TYPE).DELETED:
                                    message = intl.formatMessage(messages.issueLinkRemoved);
                                    break;
                                default:
                                    throw new Error(`Unexpected issue link scenarioType: ${scenarioType || ''}`);
                            }
                            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                                title: message
                            }, message);
                        }
                        if (attributeName && attributeName.startsWith('customField')) {
                            const { customFields: customFields } = this.props;
                            const customFieldId = attributeName.split('-')[1];
                            const field = customFields && customFields.find((field)=>field.id.toString() === customFieldId);
                            const fieldTitle = field ? field.title : '';
                            if (attributeName.startsWith('customFieldValueAdded')) return (0, ($parcel$interopDefault($5uXOq))).createElement($a0f8efc873c349be$var$SpanWithTitle, {
                                value: intl.formatMessage(messages.customFieldAdded, {
                                    field: fieldTitle
                                })
                            });
                            if (attributeName.startsWith('customFieldValueRemoved')) return (0, ($parcel$interopDefault($5uXOq))).createElement($a0f8efc873c349be$var$SpanWithTitle, {
                                value: intl.formatMessage(messages.customFieldRemoved, {
                                    field: fieldTitle
                                })
                            });
                            return field ? (0, ($parcel$interopDefault($5uXOq))).createElement($a0f8efc873c349be$var$SpanWithTitle, {
                                value: field.title
                            }) : '';
                        }
                        let change = '';
                        if (attributeName === 'fixVersions') change = intl.formatMessage((0, $ihPUd.default).releases);
                        else change = messages[attributeName || ''] ? intl.formatMessage(messages[attributeName]) : '';
                        return (0, ($parcel$interopDefault($5uXOq))).createElement($a0f8efc873c349be$var$SpanWithTitle, {
                            value: change
                        });
                    }
            }
        }
        constructor(...args){
            super(...args);
            this.isExpanded = ()=>{
                const { expandedChanges: expandedChanges, id: id, category: category } = this.props;
                return expandedChanges[category].includes(id);
            };
        }
    }
    const $a0f8efc873c349be$var$ChevronContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'pointer',
        paddingRight: 'space.050',
        verticalAlign: 'middle',
        fontSize: 'unset',
        color: 'color.text'
    });
    var $a0f8efc873c349be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($a0f8efc873c349be$var$WhatChangedCell);
});
parcelRegister("eOEXL", function(module, exports) {
    $parcel$export(module.exports, "isTeamAndResourceDetails", ()=>$abffd52f917a5010$export$ac245c21e3e1be07);
    function $abffd52f917a5010$export$ac245c21e3e1be07(change) {
        return true;
    }
});
parcelRegister("bgsRZ", function(module, exports) {
    $parcel$export(module.exports, "attribute-with-parenthetical", ()=>$8337953ffab9c520$export$c67771312808b708, (v)=>$8337953ffab9c520$export$c67771312808b708 = v);
    $parcel$export(module.exports, "ellipsed", ()=>$8337953ffab9c520$export$6ce21b76224237ee, (v)=>$8337953ffab9c520$export$6ce21b76224237ee = v);
    $parcel$export(module.exports, "icon", ()=>$8337953ffab9c520$export$1ca1ec8b29a4ce27, (v)=>$8337953ffab9c520$export$1ca1ec8b29a4ce27 = v);
    $parcel$export(module.exports, "label", ()=>$8337953ffab9c520$export$1237798dc640739a, (v)=>$8337953ffab9c520$export$1237798dc640739a = v);
    $parcel$export(module.exports, "multiple", ()=>$8337953ffab9c520$export$939ddaa3205df08e, (v)=>$8337953ffab9c520$export$939ddaa3205df08e = v);
    $parcel$export(module.exports, "parenthetical", ()=>$8337953ffab9c520$export$1d02494d67adba65, (v)=>$8337953ffab9c520$export$1d02494d67adba65 = v);
    $parcel$export(module.exports, "toggle", ()=>$8337953ffab9c520$export$e03c1c3201ee8bb7, (v)=>$8337953ffab9c520$export$e03c1c3201ee8bb7 = v);
    var $8337953ffab9c520$export$c67771312808b708;
    var $8337953ffab9c520$export$6ce21b76224237ee;
    var $8337953ffab9c520$export$1ca1ec8b29a4ce27;
    var $8337953ffab9c520$export$1237798dc640739a;
    var $8337953ffab9c520$export$939ddaa3205df08e;
    var $8337953ffab9c520$export$1d02494d67adba65;
    var $8337953ffab9c520$export$e03c1c3201ee8bb7;
    $8337953ffab9c520$export$c67771312808b708 = `WoPb7q_attribute-with-parenthetical`;
    $8337953ffab9c520$export$6ce21b76224237ee = `WoPb7q_ellipsed`;
    $8337953ffab9c520$export$1ca1ec8b29a4ce27 = `WoPb7q_icon`;
    $8337953ffab9c520$export$1237798dc640739a = `WoPb7q_label`;
    $8337953ffab9c520$export$939ddaa3205df08e = `WoPb7q_multiple`;
    $8337953ffab9c520$export$1d02494d67adba65 = `WoPb7q_parenthetical`;
    $8337953ffab9c520$export$e03c1c3201ee8bb7 = `WoPb7q_toggle`;
});
parcelRegister("4UPk3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a367753be8254384$export$2e2bcd8739ae039);
    var $bC2fB;
    var $e9fJ8 = parcelRequire("e9fJ8");
    var $ce7aY = parcelRequire("ce7aY");
    var $e7pd9 = parcelRequire("e7pd9");
    var $a367753be8254384$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $ce7aY.default), (0, $e9fJ8.default))((0, $e7pd9.default));
});
parcelRegister("e9fJ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2c74776eade230f$export$2e2bcd8739ae039);
    var $aHSC5 = parcelRequire("aHSC5");
    var $e2c74776eade230f$export$2e2bcd8739ae039 = (dispatch)=>({
            sortChanges: (sortBy, sortDirection)=>{
                dispatch((0, $aHSC5.sortChanges)(sortBy, sortDirection));
            }
        });
});
parcelRegister("ce7aY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a1a9c24074f75a7$export$2e2bcd8739ae039);
    var $25viM = parcelRequire("25viM");
    var $3YtPS = parcelRequire("3YtPS");
    var $1a1a9c24074f75a7$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        sortBy: (0, $25viM.getSortBy),
        sortDirection: (0, $25viM.getSortDirection)
    });
});
parcelRegister("e7pd9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$683a449548847fc3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $8RBk4;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $koVbs;
    var $4hgLn;
    var $2KkNy;
    var $hZKo2 = parcelRequire("hZKo2");
    var $O7QJz = parcelRequire("O7QJz");
    var $4NMyj = parcelRequire("4NMyj");
    var $dqW1t = parcelRequire("dqW1t");
    function $683a449548847fc3$export$2e2bcd8739ae039({ changes: changes, sortBy: sortBy, columnConfig: columnConfig, sortDirection: sortDirection, isUpdating: isUpdating, index: index, columns: columns, sortChanges: sortChanges, SelectChangeHeader: SelectChangeHeader = (0, $O7QJz.default) }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const selectColumnHeaderRenderer = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(SelectChangeHeader, {
                changes: changes,
                isUpdating: isUpdating
            });
        const oldValueColumnHeaderRenderer = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, ($parcel$interopDefault($9ci4W)))($4NMyj.oldColumnHeader, $4NMyj.columnHeader)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                size: "UNSAFE_small",
                weight: "semibold",
                color: "color.text.subtlest"
            }, formatMessage((0, $hZKo2.default).oldValueColumnHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $4NMyj.oldColumnHeaderArrow
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                label: "",
                size: "small"
            })));
        const sort = ()=>{
            sortChanges(sortBy, sortDirection === 'ASC' ? 'DESC' : 'ASC');
        };
        const lastModifiedColumnHeaderRenderer = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                "aria-label": formatMessage((0, $hZKo2.default).lastModifiedColumnAriaLabel),
                className: $4NMyj.modifiedGridColumnHeader,
                onClick: sort
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                "data-sortdir": sortDirection
            }, formatMessage((0, $hZKo2.default).lastModifiedColumnHeader)));
        const columnHeaderRenderer = (title)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, ($parcel$interopDefault($9ci4W)))($4NMyj.commonColumnHeader, $4NMyj.columnHeader)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, title));
        const headerCellRenderer = (column)=>{
            switch(column.id){
                case 'isSelected':
                    return selectColumnHeaderRenderer();
                case (0, $dqW1t.VALUE_TYPE).CURRENT:
                    return oldValueColumnHeaderRenderer();
                case 'lastModified':
                    return lastModifiedColumnHeaderRenderer();
                default:
                    {
                        const col = columnConfig.find((x)=>x.id === column.id);
                        return columnHeaderRenderer(col?.name || '');
                    }
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KkNy")).Row), {
            index: index
        }, columns.map((column, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hgLn")).Cell), {
                style: {
                    zIndex: 2
                },
                xcss: $683a449548847fc3$var$cellStyles,
                key: i,
                column: i,
                top: 0
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $683a449548847fc3$var$cellContainer
            }, headerCellRenderer(column)))));
    }
    const $683a449548847fc3$var$cellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'elevation.surface',
        verticalAlign: 'top'
    });
    const $683a449548847fc3$var$cellContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: 'space.0',
        alignContent: 'center',
        paddingRight: 'space.100',
        borderBottom: `2px solid ${"var(--ds-background-accent-gray-subtler, var(--adg3-color-N50))"}`,
        backgroundColor: 'elevation.surface',
        overflow: 'hidden',
        transition: 'background-color 0.1s ease',
        ':focus-within': {
            overflow: 'initial'
        }
    });
});
parcelRegister("O7QJz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87db544d012eb395$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2rMKg;
    var $8RXs9;
    var $fAGMJ;
    var $eVODA = parcelRequire("eVODA");
    var $4nDwW = parcelRequire("4nDwW");
    var $bC2fB;
    var $5Veft = parcelRequire("5Veft");
    var $jEtXX = parcelRequire("jEtXX");
    var $5LpUp = parcelRequire("5LpUp");
    const $87db544d012eb395$export$be74dcf36d511131 = 'checked';
    const $87db544d012eb395$export$4bfe604431277125 = 'unchecked';
    const $87db544d012eb395$export$c5a6fe907430212e = 'indeterminate';
    const $87db544d012eb395$export$a3f38dab6b48dc8d = (changes, selectedChanges)=>{
        const selectedChangesCount = (0, $4nDwW.valuesLength)(selectedChanges);
        const changesCount = changes.length;
        if (changesCount > 0 && changesCount === selectedChangesCount) return $87db544d012eb395$export$be74dcf36d511131;
        if (selectedChangesCount > 0) return $87db544d012eb395$export$c5a6fe907430212e;
        return $87db544d012eb395$export$4bfe604431277125;
    };
    class $87db544d012eb395$export$881caa45becfe0fd extends (0, $5uXOq.Component) {
        render() {
            const { changes: changes, isUpdating: isUpdating, selectedChanges: selectedChanges, intl: intl } = this.props;
            const expandedChanges = (0, $eVODA.getExpandedChanges)(changes);
            const status = $87db544d012eb395$export$a3f38dab6b48dc8d(expandedChanges, selectedChanges);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
                isChecked: status === $87db544d012eb395$export$be74dcf36d511131 || status === $87db544d012eb395$export$c5a6fe907430212e,
                isIndeterminate: status === $87db544d012eb395$export$c5a6fe907430212e,
                isDisabled: isUpdating,
                onChange: this.handleChange,
                "aria-label": intl.formatMessage((0, $jEtXX.default).selectHeaderAriaLabel)
            });
        }
        constructor(...args){
            super(...args);
            this.handleChange = ()=>{
                const { changes: changes, selectAll: selectAll, deselectAll: deselectAll, selectedChanges: selectedChanges } = this.props;
                const expandedChanges = (0, $eVODA.getExpandedChanges)(changes);
                const status = $87db544d012eb395$export$a3f38dab6b48dc8d(expandedChanges, selectedChanges);
                if (status === $87db544d012eb395$export$be74dcf36d511131 || status === $87db544d012eb395$export$c5a6fe907430212e) deselectAll();
                else {
                    const changesByCategory = (0, $4nDwW.groupBy)((0, parcelRequire("2rMKg")).default('category'), expandedChanges);
                    selectAll((0, $4nDwW.mapValues)((0, parcelRequire("2rMKg")).default('id'), changesByCategory));
                }
            };
        }
    }
    var $87db544d012eb395$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $5LpUp.default), (0, $5Veft.default))((0, (0, parcelRequire("8RXs9")).default)($87db544d012eb395$export$881caa45becfe0fd));
});
parcelRegister("5Veft", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c935f129eed66b$export$2e2bcd8739ae039);
    var $aHSC5 = parcelRequire("aHSC5");
    const $62c935f129eed66b$var$mapDispatchToProps = (dispatch)=>({
            selectAll: (changes)=>{
                dispatch((0, $aHSC5.selectAllChanges)(changes));
            },
            deselectAll: ()=>{
                dispatch((0, $aHSC5.deselectAllChanges)());
            }
        });
    var $62c935f129eed66b$export$2e2bcd8739ae039 = $62c935f129eed66b$var$mapDispatchToProps;
});
parcelRegister("jEtXX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4238635876628c61$export$2e2bcd8739ae039);
    var $7VHMR;
    const $4238635876628c61$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        selectHeaderAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.select-change.header.select-header-aria-label",
            "defaultMessage": "Select all issues"
        }
    });
    var $4238635876628c61$export$2e2bcd8739ae039 = $4238635876628c61$var$messages;
});
parcelRegister("5LpUp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ecbc626b0a936e5$export$2e2bcd8739ae039);
    var $25viM = parcelRequire("25viM");
    var $3YtPS = parcelRequire("3YtPS");
    var $9ecbc626b0a936e5$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedChanges: (0, $25viM.getSelectedChanges)
    });
});
parcelRegister("4NMyj", function(module, exports) {
    $parcel$export(module.exports, "columnHeader", ()=>$37f1668b6d85a67b$export$d13f5cc425f7d974, (v)=>$37f1668b6d85a67b$export$d13f5cc425f7d974 = v);
    $parcel$export(module.exports, "commonColumnHeader", ()=>$37f1668b6d85a67b$export$b0e1aafbbb4a8b15, (v)=>$37f1668b6d85a67b$export$b0e1aafbbb4a8b15 = v);
    $parcel$export(module.exports, "modifiedGridColumnHeader", ()=>$37f1668b6d85a67b$export$8956cb9ad7faa898, (v)=>$37f1668b6d85a67b$export$8956cb9ad7faa898 = v);
    $parcel$export(module.exports, "oldColumnHeader", ()=>$37f1668b6d85a67b$export$6eedf6f5a4447774, (v)=>$37f1668b6d85a67b$export$6eedf6f5a4447774 = v);
    $parcel$export(module.exports, "oldColumnHeaderArrow", ()=>$37f1668b6d85a67b$export$4bbd2d49469545b1, (v)=>$37f1668b6d85a67b$export$4bbd2d49469545b1 = v);
    var $37f1668b6d85a67b$export$8995574774093d93;
    var $37f1668b6d85a67b$export$d13f5cc425f7d974;
    var $37f1668b6d85a67b$export$b0e1aafbbb4a8b15;
    var $37f1668b6d85a67b$export$34e0f9847d4c02dd;
    var $37f1668b6d85a67b$export$85fc379452d91af0;
    var $37f1668b6d85a67b$export$711e2b273dbb00ac;
    var $37f1668b6d85a67b$export$91fbaa0417f2b694;
    var $37f1668b6d85a67b$export$4754f93c9af7081d;
    var $37f1668b6d85a67b$export$8956cb9ad7faa898;
    var $37f1668b6d85a67b$export$6eedf6f5a4447774;
    var $37f1668b6d85a67b$export$4bbd2d49469545b1;
    var $37f1668b6d85a67b$export$9852986a3ec5f6a0;
    var $37f1668b6d85a67b$export$ce666bf02318c957;
    $37f1668b6d85a67b$export$8995574774093d93 = `ldgrhG_ReactVirtualized__Table__headerRow`;
    $37f1668b6d85a67b$export$d13f5cc425f7d974 = `ldgrhG_columnHeader`;
    $37f1668b6d85a67b$export$b0e1aafbbb4a8b15 = `ldgrhG_commonColumnHeader`;
    $37f1668b6d85a67b$export$34e0f9847d4c02dd = `ldgrhG_container`;
    $37f1668b6d85a67b$export$85fc379452d91af0 = `ldgrhG_grid`;
    $37f1668b6d85a67b$export$711e2b273dbb00ac = `ldgrhG_gridContainer`;
    $37f1668b6d85a67b$export$91fbaa0417f2b694 = `ldgrhG_hideScrollBar`;
    $37f1668b6d85a67b$export$4754f93c9af7081d = `ldgrhG_modifiedColumnHeader`;
    $37f1668b6d85a67b$export$8956cb9ad7faa898 = `ldgrhG_modifiedGridColumnHeader`;
    $37f1668b6d85a67b$export$6eedf6f5a4447774 = `ldgrhG_oldColumnHeader`;
    $37f1668b6d85a67b$export$4bbd2d49469545b1 = `ldgrhG_oldColumnHeaderArrow`;
    $37f1668b6d85a67b$export$9852986a3ec5f6a0 = `ldgrhG_table`;
    $37f1668b6d85a67b$export$ce666bf02318c957 = `ldgrhG_tableRow`;
});
parcelRegister("5m4E3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5289c2d30d875211$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $jldZL;
    var $koVbs;
    var $9NoyN = parcelRequire("9NoyN");
    var $1AAhm = parcelRequire("1AAhm");
    const $5289c2d30d875211$var$VisuallyHiddenAnnouncement = ({ changes: changes, changesCount: changesCount })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { listChangeAuthors: listChangeAuthors, countCategories: countCategories } = (0, $1AAhm.useChangesInfo)();
        const { userName: userName, userList: userList, isSingleUser: isSingleUser } = listChangeAuthors(changes);
        const isAllUsers = changes.length === changesCount;
        const userSelectOptions = isAllUsers ? 'all' : isSingleUser && 'one';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            "aria-live": "polite"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, $9NoyN.default).tableChangesAnnouncement, {
            users: userSelectOptions,
            userName: userName,
            userList: userList,
            changes: countCategories(changes)
        })));
    };
    var $5289c2d30d875211$export$2e2bcd8739ae039 = $5289c2d30d875211$var$VisuallyHiddenAnnouncement;
});
parcelRegister("9NoyN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b57f8fc5dd55e930$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b57f8fc5dd55e930$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tableChangesAnnouncement: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.table-changes-announcement",
            "defaultMessage": "{users, select, all {All users changed {changes}} one {{userName} changed {changes}} other {{userList} changed {changes}}}"
        },
        issueCategoryCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.issue-category-count",
            "defaultMessage": "{issueCount, plural, one {# issue} other {# issues}}"
        },
        teamCategoryCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.team-category-count",
            "defaultMessage": "{teamCount, plural, one {# team} other {# teams}}"
        },
        releaseCategoryCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.release-category-count",
            "defaultMessage": "{releaseCount, plural, one {# release} other {# releases}}"
        },
        crossProjectReleaseCategoryCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.cross-project-release-category-count",
            "defaultMessage": "{crossProjectReleaseCount, plural, one {# cross project release} other {# cross project releases}}"
        },
        resourceCategoryCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.resource-category-count",
            "defaultMessage": "{resourceCount, plural, one {# resource} other {# resources}}"
        },
        sprintCategoryCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.sprint-category-count",
            "defaultMessage": "{sprintCount, plural, one {# sprint} other {# sprints}}"
        },
        plannedCapacityCategoryCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.planned-capacity-category-count",
            "defaultMessage": "{plannedCapacityCount, plural, one {# planned capacity} other {# planned capacities}}"
        }
    });
});
parcelRegister("1AAhm", function(module, exports) {
    $parcel$export(module.exports, "useChangesInfo", ()=>$d76775cdd9db2a5f$export$32f532c0138bdd60);
    var $koVbs;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $9NoyN = parcelRequire("9NoyN");
    const $d76775cdd9db2a5f$export$32f532c0138bdd60 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const stringFormatter = new Intl.ListFormat('en-US', {
            style: 'long',
            type: 'conjunction'
        });
        const getCategoryCounts = (tableChanges)=>{
            const categoryCounts = {};
            tableChanges.forEach((item)=>{
                if (item.category) categoryCounts[item.category] = (categoryCounts[item.category] || 0) + 1;
            });
            return categoryCounts;
        };
        const listChangeAuthors = (tableChanges)=>{
            const changeAuthorsSet = new Set();
            tableChanges.forEach((item)=>{
                if (item?.lastModified?.title) changeAuthorsSet.add(item.lastModified.title);
            });
            const isSingleUser = changeAuthorsSet.size === 1;
            return {
                userName: isSingleUser ? Array.from(changeAuthorsSet)[0] : undefined,
                userList: !isSingleUser ? stringFormatter.format(Array.from(changeAuthorsSet)) : undefined,
                isSingleUser: isSingleUser
            };
        };
        const countCategories = (tableChanges)=>{
            const categoriesObj = getCategoryCounts(tableChanges);
            const categoryCounts = [];
            for (const [key] of Object.entries(categoriesObj)){
                let message;
                let countKey;
                switch(key){
                    case (0, $TTKUQ.ENTITY).ISSUE:
                        message = (0, $9NoyN.default).issueCategoryCount;
                        countKey = 'issueCount';
                        break;
                    case (0, $TTKUQ.ENTITY).TEAM:
                        message = (0, $9NoyN.default).teamCategoryCount;
                        countKey = 'teamCount';
                        break;
                    case (0, $TTKUQ.ENTITY).RELEASE:
                        message = (0, $9NoyN.default).releaseCategoryCount;
                        countKey = 'releaseCount';
                        break;
                    case (0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE:
                        message = (0, $9NoyN.default).crossProjectReleaseCategoryCount;
                        countKey = 'crossProjectReleaseCount';
                        break;
                    case (0, $TTKUQ.ENTITY).RESOURCE:
                        message = (0, $9NoyN.default).resourceCategoryCount;
                        countKey = 'resourceCount';
                        break;
                    case (0, $TTKUQ.ENTITY).SPRINT:
                        message = (0, $9NoyN.default).sprintCategoryCount;
                        countKey = 'sprintCount';
                        break;
                    case (0, $TTKUQ.ENTITY).PLANNED_CAPACITY:
                        message = (0, $9NoyN.default).plannedCapacityCategoryCount;
                        countKey = 'plannedCapacityCount';
                        break;
                    default:
                        break;
                }
                if (message && countKey) categoryCounts.push(formatMessage(message, {
                    [countKey]: categoriesObj[key]
                }));
            }
            return stringFormatter.format(categoryCounts);
        };
        return {
            listChangeAuthors: listChangeAuthors,
            countCategories: countCategories
        };
    };
});
parcelRegister("4C5T3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cafa82658238ea11$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $koVbs;
    var $ihPUd = parcelRequire("ihPUd");
    var $fwKu0 = parcelRequire("fwKu0");
    function $cafa82658238ea11$export$2e2bcd8739ae039({ isOpen: isOpen, onConfirm: onConfirm, onCancel: onCancel }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (!isOpen) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            onClose: onCancel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $fwKu0.default).title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, formatMessage((0, $fwKu0.default).message)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: onCancel,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-confirmation.cancel"
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            onClick: onConfirm,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-confirmation.confirm"
        }, formatMessage((0, $fwKu0.default).confirm)))));
    }
});
parcelRegister("fwKu0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9c69aba401f542a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c9c69aba401f542a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        confirm: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-confirmation.confirm",
            "defaultMessage": "Discard changes"
        },
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-confirmation.title",
            "defaultMessage": "Confirm discard"
        },
        message: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-confirmation.message",
            "defaultMessage": "Are you sure you want to discard the selected changes?"
        }
    });
});
parcelRegister("7zIWQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0dcaeec53cd0a4c6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $hTEpF;
    var $i28qQ;
    var $1R1Ge;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $9fuVs;
    var $j3Z0B;
    var $koVbs;
    var $5oFIy;
    var $I0YJU = parcelRequire("I0YJU");
    var $heMan = parcelRequire("heMan");
    const $0dcaeec53cd0a4c6$var$EmptyDialog = ({ handleCloseDialog: handleCloseDialog })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                changesCount: 0
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            shouldReturnFocus: true,
            shouldCloseOnEscapePress: true,
            onClose: handleCloseDialog,
            shouldCloseOnOverlayClick: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0dcaeec53cd0a4c6$var$relativeStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0dcaeec53cd0a4c6$var$closeIconAbsoluteStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            label: formatMessage((0, $heMan.default).closeIconLabel),
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ"))))),
            onClick: handleCloseDialog,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.empty-dialog.selected-field-remove-button"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            header: formatMessage((0, $heMan.default).noChangesDialogHeader),
            description: formatMessage((0, $heMan.default).noChangesDialogDescription),
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $I0YJU.default), {
                onClick: handleCloseDialog,
                articleId: "5jV03VyuxP6cfYQwcKWxWO"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                color: "color.link"
            }, formatMessage((0, $heMan.default).noChangesDialogActionButtonText))),
            renderImage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $0dcaeec53cd0a4c6$var$emptyImageContainerStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $0dcaeec53cd0a4c6$var$emptyImageStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j3Z0B")).default), {
                    alt: ""
                })))
        }))));
    };
    const $0dcaeec53cd0a4c6$var$relativeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative'
    });
    const $0dcaeec53cd0a4c6$var$closeIconAbsoluteStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.250',
        right: 'space.250'
    });
    const $0dcaeec53cd0a4c6$var$emptyImageContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 'space.400'
    });
    const $0dcaeec53cd0a4c6$var$emptyImageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '160px'
    });
    var $0dcaeec53cd0a4c6$export$2e2bcd8739ae039 = $0dcaeec53cd0a4c6$var$EmptyDialog;
});
parcelRegister("j3Z0B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$819779665aeff682$export$2e2bcd8739ae039);
    var $dCLgq;
    var $5EqyZ = parcelRequire("5EqyZ");
    const $819779665aeff682$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5EqyZ)),
        srcDark: ($parcel$interopDefault($5EqyZ)),
        autoDark: false
    });
    var $819779665aeff682$export$2e2bcd8739ae039 = $819779665aeff682$var$Illustration;
    const $819779665aeff682$export$a179c88182cb9d56 = [
        0,
        0,
        160,
        160
    ];
});
parcelRegister("5EqyZ", function(module, exports) {
    module.exports = new URL("celebrate.45e473a6.svg", import.meta.url).toString();
});
parcelRegister("I0YJU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f846ff809c3c5151$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5ILhZ;
    var $8CUq3;
    var $5Zxxp;
    const $f846ff809c3c5151$var$HelpPanelButton = ({ onClick: onClick, articleId: articleId, articleType: articleType = 'HELP_ARTICLE', children: children })=>{
        const onOpenInProductHelpArticle = (0, (0, parcelRequire("5Zxxp")).useHelpPanelLink)();
        const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent);
            onOpenInProductHelpArticle?.(articleId, articleType);
        }, [
            onClick,
            onOpenInProductHelpArticle,
            articleType,
            articleId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $f846ff809c3c5151$var$pressableStyles,
            onClick: handleClick,
            backgroundColor: "color.background.neutral.subtle"
        }, children);
    };
    const $f846ff809c3c5151$var$pressableStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.link',
        ':hover': {
            textDecoration: 'underline'
        }
    });
    var $f846ff809c3c5151$export$2e2bcd8739ae039 = $f846ff809c3c5151$var$HelpPanelButton;
});
parcelRegister("heMan", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ac1e41102adea26$export$2e2bcd8739ae039);
    var $7VHMR;
    const $9ac1e41102adea26$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noChangesDialogHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.empty-dialog.no-changes-dialog-header",
            "defaultMessage": "Your plan is up to date!"
        },
        noChangesDialogDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.empty-dialog.no-changes-dialog-description",
            "defaultMessage": "Any changes you make to the issues in your plan, including creating new ones, will appear here for your approval. These changes aren't applied until you decide your plan is ready to go."
        },
        noChangesDialogActionButtonText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.empty-dialog.no-changes-dialog-action-button-text",
            "defaultMessage": "Read how to save changes in your plan."
        },
        closeIconLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.empty-dialog.close-icon-label",
            "defaultMessage": "Close dialog"
        }
    });
    var $9ac1e41102adea26$export$2e2bcd8739ae039 = $9ac1e41102adea26$var$messages;
});
parcelRegister("6bYOl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea2289231b7d1306$export$2e2bcd8739ae039);
    var $bC2fB;
    var $jOpLS = parcelRequire("jOpLS");
    var $6sjGg = parcelRequire("6sjGg");
    var $bIyos = parcelRequire("bIyos");
    var $ea2289231b7d1306$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6sjGg.default), (0, $jOpLS.default))((0, $bIyos.default));
});
parcelRegister("jOpLS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$675fb4d3143ac3ee$export$2e2bcd8739ae039);
    var $aHSC5 = parcelRequire("aHSC5");
    var $ccIrM = parcelRequire("ccIrM");
    const $675fb4d3143ac3ee$var$mapDispatchToProps = (dispatch)=>({
            onRequestChange: ({ value: value, visibleIssueIds: visibleIssueIds })=>dispatch((0, $aHSC5.changeFilter)({
                    id: (0, $ccIrM.USER_FILTER_ID),
                    value: value,
                    visibleIssueIds: visibleIssueIds
                })),
            onRequestClear: ()=>dispatch((0, $aHSC5.clearFilter)((0, $ccIrM.USER_FILTER_ID)))
        });
    var $675fb4d3143ac3ee$export$2e2bcd8739ae039 = $675fb4d3143ac3ee$var$mapDispatchToProps;
});
parcelRegister("6sjGg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf4c69066f54bbb3$export$2e2bcd8739ae039);
    var $hu7Cn = parcelRequire("hu7Cn");
    var $6WWH1 = parcelRequire("6WWH1");
    var $eSUNk = parcelRequire("eSUNk");
    var $25viM = parcelRequire("25viM");
    var $3YtPS = parcelRequire("3YtPS");
    const $bf4c69066f54bbb3$export$f320820d53e740a0 = (reviewChanges, assigneesById)=>{
        const result = [];
        for (const { lastModified: lastModified } of reviewChanges)if (!result.some((el)=>el && lastModified && el.personId === lastModified.personId)) {
            const { personId: personId } = lastModified || {};
            if (personId && assigneesById[personId]) result.push(assigneesById[personId]);
        }
        return result;
    };
    const $bf4c69066f54bbb3$export$27701b0bf8892f62 = (0, $3YtPS.createSelector)([
        (0, $25viM.getReviewChanges),
        (0, $hu7Cn.getAssigneesById)
    ], $bf4c69066f54bbb3$export$f320820d53e740a0);
    const $bf4c69066f54bbb3$var$mapStateToProps = (0, $3YtPS.createSelector)([
        $bf4c69066f54bbb3$export$27701b0bf8892f62,
        (0, $eSUNk.getUserFilter),
        (0, $25viM.getReviewChanges),
        (0, $6WWH1.getCurrentUser)
    ], (users, { value: value }, reviewChanges, currentUser)=>({
            users: users,
            value: value,
            reviewChanges: reviewChanges,
            currentUser: currentUser
        }));
    var $bf4c69066f54bbb3$export$2e2bcd8739ae039 = $bf4c69066f54bbb3$var$mapStateToProps;
});
parcelRegister("bIyos", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c4142b77f5aec46$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8EB5I;
    var $jVZZA;
    var $3DBzg;
    var $3nPAF;
    var $5XN59;
    var $bQZTk;
    var $ao4Ml = parcelRequire("ao4Ml");
    var $8RXs9;
    var $6SblS;
    var $J8W7q;
    var $i2qlb = parcelRequire("i2qlb");
    var $9174a = parcelRequire("9174a");
    var $fnT96 = parcelRequire("fnT96");
    var $73AQn = parcelRequire("73AQn");
    var $3iCBQ = parcelRequire("3iCBQ");
    var $b7IdY = parcelRequire("b7IdY");
    var $96Lce = parcelRequire("96Lce");
    var $aIMtT = parcelRequire("aIMtT");
    var $8zOmE;
    var $2NMNM;
    var $c7Q5k = parcelRequire("c7Q5k");
    var $eHm7k = parcelRequire("eHm7k");
    function $0c4142b77f5aec46$var$UserFilter({ intl: intl, searchQuery: searchQuery, onQueryChange: onQueryChange, value: value, onRequestChange: onRequestChange, onRequestClear: onRequestClear, users: users, reviewChanges: reviewChanges, currentUser: currentUser }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isSelected = (user)=>(0, parcelRequire("3DBzg")).default(user.personId, value);
        const handleCheckboxChange = (e)=>{
            const { value: personId, checked: checked } = e.currentTarget;
            const nextValue = (()=>{
                const withoutUser = (0, parcelRequire("jVZZA")).default((0, parcelRequire("bQZTk")).default((0, parcelRequire("8EB5I")).default(personId), (0, parcelRequire("5XN59")).default))(value);
                if (!checked) return withoutUser;
                return [
                    ...withoutUser,
                    personId
                ];
            })();
            const visibleIssueIds = reviewChanges.filter((change)=>{
                if (change.lastModified?.personId !== undefined) return nextValue.includes(change.lastModified?.personId);
                return false;
            }).map((change)=>change.id);
            onRequestChange({
                value: nextValue,
                visibleIssueIds: visibleIssueIds
            });
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_USER_FILTER_CHANGED.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            }), {
                isCurrentUser: currentUser.key === personId,
                checked: checked
            });
        };
        const usersToDisplay = (0, $9174a.sort)((0, $9174a.filter)(searchQuery, users));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $73AQn.default), {
            isVisible: !!value.length,
            onClearClick: onRequestClear
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aIMtT.default), {
            placeholder: intl.formatMessage((0, $c7Q5k.default).searchPlaceholder),
            searchQuery: searchQuery,
            onQueryChange: onQueryChange
        }), usersToDisplay.map((user, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuItem), {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fnT96.AssigneeCheckbox), {
                checked: isSelected(user),
                onChange: handleCheckboxChange,
                person: user
            }))), (0, parcelRequire("3nPAF")).default(usersToDisplay) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $b7IdY.default), null));
    }
    function $0c4142b77f5aec46$var$UserFilterDialog(props) {
        const { isOpen: isOpen, onOpenChange: onOpenChange } = props;
        const dialogRef = (0, $5uXOq.useRef)(null);
        (0, $96Lce.useHandleDialogClose)(dialogRef, onOpenChange, isOpen);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: dialogRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            noPaddings: true,
            maxWidth: (0, $3iCBQ.FILTER_MAX_WIDTH),
            isOpen: isOpen,
            onClose: onOpenChange,
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6SblS")).DialogMenuContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($0c4142b77f5aec46$var$UserFilter, props)),
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.filters.user-filter"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHm7k.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            triggerButtonText: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fnT96.TriggerButtonText), {
                value: props.value,
                persons: props.users
            })
        })));
    }
    var $0c4142b77f5aec46$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($0c4142b77f5aec46$var$UserFilterDialog);
});
parcelRegister("96Lce", function(module, exports) {
    $parcel$export(module.exports, "useHandleDialogClose", ()=>$a9a29901b5597550$export$b53868bd1fa52e47);
    var $5uXOq = parcelRequire("5uXOq");
    const $a9a29901b5597550$export$b53868bd1fa52e47 = (dialogRef, onOpenChange, isOpen)=>{
        (0, $5uXOq.useEffect)(()=>{
            const handleClickOutside = (event)=>{
                if (dialogRef.current && !dialogRef.current.contains(event.target)) {
                    event.preventDefault();
                    onOpenChange({
                        isOpen: false
                    });
                }
            };
            const handleKeyDown = (event)=>{
                if (event.key === 'Escape') {
                    event.preventDefault();
                    onOpenChange({
                        isOpen: false
                    });
                }
            };
            if (isOpen) {
                document.addEventListener('mousedown', handleClickOutside);
                document.addEventListener('touchstart', handleClickOutside);
                document.addEventListener('keydown', handleKeyDown);
            }
            return ()=>{
                document.removeEventListener('mousedown', handleClickOutside);
                document.removeEventListener('touchstart', handleClickOutside);
                document.removeEventListener('keydown', handleKeyDown);
            };
        }, [
            isOpen,
            onOpenChange,
            dialogRef
        ]);
    };
});
parcelRegister("c7Q5k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5e0a3a7b4b74af5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b5e0a3a7b4b74af5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.filters.user-filter.search-placeholder",
            "defaultMessage": "Choose users..."
        }
    });
});
parcelRegister("eHm7k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5449fa9969fb0cfe$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ingq;
    var $koVbs;
    var $aCpcO;
    var $53cPq = parcelRequire("53cPq");
    var $ciLU4 = parcelRequire("ciLU4");
    const $5449fa9969fb0cfe$var$TriggerButton = ({ isOpen: isOpen, onOpenChange: onOpenChange, triggerButtonText: triggerButtonText })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const handleOpenChange = ()=>{
            onOpenChange({
                isOpen: !isOpen
            });
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $ciLU4.filterButtonWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                label: ""
            }),
            isSelected: isOpen,
            onClick: handleOpenChange,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.filters.user-filter.trigger-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $ciLU4.buttonTextContainer,
            "aria-live": "polite",
            "aria-atomic": "true"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $ciLU4.buttonLabel
        }, intl.formatMessage((0, $53cPq.default).filterByLabel), ":"), triggerButtonText))));
    };
    var $5449fa9969fb0cfe$export$2e2bcd8739ae039 = $5449fa9969fb0cfe$var$TriggerButton;
});
parcelRegister("53cPq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00d3e5ab18ff0505$export$2e2bcd8739ae039);
    var $7VHMR;
    var $00d3e5ab18ff0505$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filterByLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.filters.user-filter.trigger-button.filter-by-label",
            "defaultMessage": "Last modified by"
        }
    });
});
parcelRegister("ciLU4", function(module, exports) {
    $parcel$export(module.exports, "buttonLabel", ()=>$8f4c5313efe8dd9c$export$47614749115bca3d, (v)=>$8f4c5313efe8dd9c$export$47614749115bca3d = v);
    $parcel$export(module.exports, "buttonTextContainer", ()=>$8f4c5313efe8dd9c$export$4ee7107eea12c1bc, (v)=>$8f4c5313efe8dd9c$export$4ee7107eea12c1bc = v);
    $parcel$export(module.exports, "filterButtonWrapper", ()=>$8f4c5313efe8dd9c$export$706db85642e6c245, (v)=>$8f4c5313efe8dd9c$export$706db85642e6c245 = v);
    var $8f4c5313efe8dd9c$export$47614749115bca3d;
    var $8f4c5313efe8dd9c$export$4ee7107eea12c1bc;
    var $8f4c5313efe8dd9c$export$706db85642e6c245;
    $8f4c5313efe8dd9c$export$47614749115bca3d = `_5f2lVa_buttonLabel`;
    $8f4c5313efe8dd9c$export$4ee7107eea12c1bc = `_5f2lVa_buttonTextContainer`;
    $8f4c5313efe8dd9c$export$706db85642e6c245 = `_5f2lVa_filterButtonWrapper`;
});
parcelRegister("cO2Va", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c1222a95a1371d2$export$2e2bcd8739ae039);
    var $7VHMR;
    const $8c1222a95a1371d2$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        updateJiraDialogHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-header",
            "defaultMessage": "Unsaved changes"
        },
        updateJiraDialogBodyTop: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-body-top",
            "defaultMessage": "Save issues and releases created or changed in your plan so they update in your project. <link>Read more about saving changes.</link>"
        },
        updateJiraDialogBodyBottom: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-body-bottom",
            "defaultMessage": "To assign issues to a team, save a plan-only team here first before converting it to an Atlassian team."
        },
        updateJiraDialogReadMoreText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-read-more-text",
            "defaultMessage": "Read more about saving changes."
        },
        updateJiraDialogContentNoChanges: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-content-no-changes",
            "defaultMessage": "There are no unsaved changes"
        },
        updateJiraDialogRevertButtonText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-revert-button-text",
            "defaultMessage": "Discard selected changes"
        },
        updateJiraDialogUpdateButtonText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-update-button-text",
            "defaultMessage": "Save changes"
        },
        updateJiraDialogUpdateButtonTextOld: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-update-button-text-old",
            "defaultMessage": "Save selected changes in Jira"
        },
        updateJiraDialogStopButtonText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-stop-button-text",
            "defaultMessage": "Quit"
        },
        updateJiraDialogStoppingButtonText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-stopping-button-text",
            "defaultMessage": "Quitting"
        },
        outOfSyncMessageConcurrentEditing: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.out-of-sync-message-concurrent-editing",
            "defaultMessage": "Your plan is out of sync due to concurrent editing."
        },
        refreshCta: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.refresh-cta",
            "defaultMessage": "Refresh to get the latest version. Your changes will not be lost."
        },
        refreshButton: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.refresh-button",
            "defaultMessage": "Refresh"
        },
        refreshCtaOld: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.refresh-cta-old",
            "defaultMessage": "<span>Refresh</span> to get the latest version. Your changes will not be lost."
        },
        disabledTooltipForUpdateJira: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.disabled-tooltip-for-update-jira",
            "defaultMessage": "You don't have permission to save changes in Jira."
        },
        disabledTooltipForUpdateJiraWhenGicIsOpen: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.disabled-tooltip-for-update-jira-when-gic-is-open",
            "defaultMessage": "You can't save selected changes in Jira because you already have an issue in creation."
        },
        closeDialog: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.close-dialog",
            "defaultMessage": "Close dialog"
        }
    });
    var $8c1222a95a1371d2$export$2e2bcd8739ae039 = $8c1222a95a1371d2$var$messages;
});
parcelRegister("cfRKD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd7bf6d17c57ff31$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7aZhi = parcelRequire("7aZhi");
    var $k0GtF = parcelRequire("k0GtF");
    var $cd7bf6d17c57ff31$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $7aZhi.default), {})((0, $k0GtF.default));
});
parcelRegister("7aZhi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09d0ee3c32fbcd96$export$2e2bcd8739ae039);
    var $25viM = parcelRequire("25viM");
    var $3YtPS = parcelRequire("3YtPS");
    var $09d0ee3c32fbcd96$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedChanges: (0, $25viM.getSelectedChanges),
        isSaving: (0, $25viM.getIsSaving),
        commitProgressStats: (0, $25viM.getCommitProgressStats),
        isReverting: (0, $25viM.getIsReverting),
        revertProgressStats: (0, $25viM.getRevertProgressStats)
    });
});
parcelRegister("k0GtF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2c8cff44c11c132$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ldJSL;
    var $gtreQ;
    var $99gkn;
    var $eTXmK;
    var $3bDjY;
    var $aCpcO;
    var $enoTt;
    var $1Cyfv = parcelRequire("1Cyfv");
    var $8zOmE;
    var $53N4c = parcelRequire("53N4c");
    var $4CC0m = parcelRequire("4CC0m");
    var $l90kR = parcelRequire("l90kR");
    function $b2c8cff44c11c132$var$UpdateJiraDialogFooter(props) {
        const { actions: actions, leftActions: leftActions = null, rightActions: rightActions, selectedChanges: selectedChanges, selectedChangesCount: selectedChangesCount, isSaving: isSaving, commitProgressStats: { numberOfCommittedChanges: numberOfCommittedChanges, totalChanges: totalCommitChanges }, isReverting: isReverting, revertProgressStats: { numberOfRevertedChanges: numberOfRevertedChanges, totalChanges: totalRevertChanges } } = props;
        const onTooltipShowHandler = (analyticsEvent)=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'warningIcon');
        const scalingFactors = Object.fromEntries(Object.entries(selectedChanges).map(([entity, ids])=>[
                entity,
                ids.length
            ]));
        const getFooterRight = ()=>{
            if (rightActions) return rightActions;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, actions.filter(({ isVisible: isVisible = true })=>isVisible).map(({ appearance: appearance, autoFocus: autoFocus = false, isDisabled: isDisabled, isLoading: isLoading, onClick: onClick, testId: testId = '', text: text, tooltip: tooltip, type: type })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $l90kR.buttonWrapper,
                    key: text
                }, isDisabled && selectedChangesCount > 0 && tooltip && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: tooltip,
                    position: "top",
                    onShow: onTooltipShowHandler
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                    primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y500})`,
                    label: tooltip
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: appearance,
                    isDisabled: isDisabled,
                    onClick: (e, analyticsEvent)=>{
                        onClick(e, analyticsEvent);
                        if (type === 'save' && scalingFactors) {
                            (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).SAVE_REVIEW_CHANGES, e.timeStamp);
                            (0, (0, parcelRequire("99gkn")).addUFOCustomData)(scalingFactors);
                        }
                    },
                    iconAfter: isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), {
                        invertColor: !isDisabled
                    }) : undefined,
                    autoFocus: autoFocus,
                    testId: testId
                }, text))));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $l90kR.footer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $l90kR.footerLeft
        }, leftActions), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $l90kR.progressContainer
        }, isSaving && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $l90kR.commitProgress
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $53N4c.default), {
            label: {
                ...(0, $4CC0m.default).committingChangesLabelNoElipsis
            },
            countOfThingsDone: numberOfCommittedChanges,
            countOfThingsToDo: totalCommitChanges
        })), isReverting && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $l90kR.commitProgress
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $53N4c.default), {
            label: {
                ...(0, $4CC0m.default).revertingChangesLabelNoElipsis
            },
            countOfThingsDone: numberOfRevertedChanges,
            countOfThingsToDo: totalRevertChanges
        })), getFooterRight())));
    }
    var $b2c8cff44c11c132$export$2e2bcd8739ae039 = $b2c8cff44c11c132$var$UpdateJiraDialogFooter;
});
parcelRegister("53N4c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1eb6324790eb5088$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $ousew;
    var $5QBp9;
    var $enoTt;
    var $6kk8R = parcelRequire("6kk8R");
    var $6vXl7 = parcelRequire("6vXl7");
    function $1eb6324790eb5088$export$2e2bcd8739ae039(props) {
        const { label: label, countOfThingsDone: countOfThingsDone, countOfThingsToDo: countOfThingsToDo } = props;
        const percentage = countOfThingsToDo === 0 ? 0 : Math.floor(100 * countOfThingsDone / countOfThingsToDo);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $6vXl7.container
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5QBp9")).default), {
            label: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $6vXl7.labelWrapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $6vXl7.spinnerWrapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), {
                size: "small"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                as: "strong"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), label))),
            percentage: percentage,
            progressMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $6kk8R.default).progress,
                values: {
                    countOfThingsDone: countOfThingsDone,
                    countOfThingsToDo: countOfThingsToDo,
                    percentage: percentage
                }
            })
        })));
    }
});
parcelRegister("5QBp9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6485fe301358383$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lRoNk;
    var $2yre0 = parcelRequire("2yre0");
    function $a6485fe301358383$export$2e2bcd8739ae039(props) {
        const { label: label, percentage: percentage, progressMessage: progressMessage } = props;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $2yre0.container
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $2yre0.header
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, label), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, progressMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lRoNk")).default), {
            percentage: percentage
        })));
    }
});
parcelRegister("lRoNk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05be56655376e6c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $38B5a = parcelRequire("38B5a");
    function $05be56655376e6c5$export$2e2bcd8739ae039(props) {
        const { percentage: percentage } = props;
        if (percentage < 0 || percentage > 100) throw new Error(`Percentage must be within [0, 100] range, got ${percentage}`);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $38B5a.container
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $38B5a.bar,
            style: {
                width: `${percentage}%`
            }
        })));
    }
});
parcelRegister("38B5a", function(module, exports) {
    $parcel$export(module.exports, "bar", ()=>$248ee23a8cbc0b44$export$d927737047eb3867, (v)=>$248ee23a8cbc0b44$export$d927737047eb3867 = v);
    $parcel$export(module.exports, "container", ()=>$248ee23a8cbc0b44$export$34e0f9847d4c02dd, (v)=>$248ee23a8cbc0b44$export$34e0f9847d4c02dd = v);
    var $248ee23a8cbc0b44$export$d927737047eb3867;
    var $248ee23a8cbc0b44$export$34e0f9847d4c02dd;
    $248ee23a8cbc0b44$export$d927737047eb3867 = `WF5SHW_bar`;
    $248ee23a8cbc0b44$export$34e0f9847d4c02dd = `WF5SHW_container`;
});
parcelRegister("2yre0", function(module, exports) {
    $parcel$export(module.exports, "container", ()=>$1dc3e00508173ca9$export$34e0f9847d4c02dd, (v)=>$1dc3e00508173ca9$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "header", ()=>$1dc3e00508173ca9$export$38e42c68cf43b5d4, (v)=>$1dc3e00508173ca9$export$38e42c68cf43b5d4 = v);
    var $1dc3e00508173ca9$export$34e0f9847d4c02dd;
    var $1dc3e00508173ca9$export$38e42c68cf43b5d4;
    $1dc3e00508173ca9$export$34e0f9847d4c02dd = `EEOLLq_container`;
    $1dc3e00508173ca9$export$38e42c68cf43b5d4 = `EEOLLq_header`;
});
parcelRegister("6kk8R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc9cc24f99863e8f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cc9cc24f99863e8f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        progress: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.components.progress.progress",
            "defaultMessage": "{countOfThingsDone} of {countOfThingsToDo} changes \u2014 {percentage}%"
        },
        label: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.components.progress.label",
            "defaultMessage": "Saving in Jira..."
        }
    });
});
parcelRegister("6vXl7", function(module, exports) {
    $parcel$export(module.exports, "container", ()=>$4be3aaf332ba7d51$export$34e0f9847d4c02dd, (v)=>$4be3aaf332ba7d51$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "labelWrapper", ()=>$4be3aaf332ba7d51$export$61bb151bc9360b59, (v)=>$4be3aaf332ba7d51$export$61bb151bc9360b59 = v);
    $parcel$export(module.exports, "spinnerWrapper", ()=>$4be3aaf332ba7d51$export$d043ff22bb17d686, (v)=>$4be3aaf332ba7d51$export$d043ff22bb17d686 = v);
    var $4be3aaf332ba7d51$export$34e0f9847d4c02dd;
    var $4be3aaf332ba7d51$export$61bb151bc9360b59;
    var $4be3aaf332ba7d51$export$d043ff22bb17d686;
    $4be3aaf332ba7d51$export$34e0f9847d4c02dd = `p0eKqa_container`;
    $4be3aaf332ba7d51$export$61bb151bc9360b59 = `p0eKqa_labelWrapper`;
    $4be3aaf332ba7d51$export$d043ff22bb17d686 = `p0eKqa_spinnerWrapper`;
});
parcelRegister("4CC0m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b1b7aebd71db182$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3b1b7aebd71db182$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        committingChangesLabelNoElipsis: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.modal-footer.committing-changes-label-no-elipsis",
            "defaultMessage": "Saving in Jira"
        },
        revertingChangesLabelNoElipsis: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.modal-footer.reverting-changes-label-no-elipsis",
            "defaultMessage": "Discarding changes"
        }
    });
});
parcelRegister("l90kR", function(module, exports) {
    $parcel$export(module.exports, "buttonWrapper", ()=>$f64ab2dcc6b240ff$export$a3b9b213fa74e4fd, (v)=>$f64ab2dcc6b240ff$export$a3b9b213fa74e4fd = v);
    $parcel$export(module.exports, "commitProgress", ()=>$f64ab2dcc6b240ff$export$b4e6005b1986f726, (v)=>$f64ab2dcc6b240ff$export$b4e6005b1986f726 = v);
    $parcel$export(module.exports, "footer", ()=>$f64ab2dcc6b240ff$export$adb608be33961c98, (v)=>$f64ab2dcc6b240ff$export$adb608be33961c98 = v);
    $parcel$export(module.exports, "footerLeft", ()=>$f64ab2dcc6b240ff$export$4ba0eff4a9437fb, (v)=>$f64ab2dcc6b240ff$export$4ba0eff4a9437fb = v);
    $parcel$export(module.exports, "progressContainer", ()=>$f64ab2dcc6b240ff$export$2612087cf48ded35, (v)=>$f64ab2dcc6b240ff$export$2612087cf48ded35 = v);
    var $f64ab2dcc6b240ff$export$a3b9b213fa74e4fd;
    var $f64ab2dcc6b240ff$export$b4e6005b1986f726;
    var $f64ab2dcc6b240ff$export$adb608be33961c98;
    var $f64ab2dcc6b240ff$export$4ba0eff4a9437fb;
    var $f64ab2dcc6b240ff$export$2612087cf48ded35;
    $f64ab2dcc6b240ff$export$a3b9b213fa74e4fd = `UZNJmq_buttonWrapper`;
    $f64ab2dcc6b240ff$export$b4e6005b1986f726 = `UZNJmq_commitProgress`;
    $f64ab2dcc6b240ff$export$adb608be33961c98 = `UZNJmq_footer`;
    $f64ab2dcc6b240ff$export$4ba0eff4a9437fb = `UZNJmq_footerLeft`;
    $f64ab2dcc6b240ff$export$2612087cf48ded35 = `UZNJmq_progressContainer`;
});
parcelRegister("dhNbN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9add2e18392771a8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $kdO7l;
    const $9add2e18392771a8$var$ModalHeader = ({ children: children })=>{
        const { titleId: titleId } = (0, (0, parcelRequire("kdO7l")).useModal)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "h2",
            size: "medium",
            id: titleId
        }, children);
    };
    var $9add2e18392771a8$export$2e2bcd8739ae039 = $9add2e18392771a8$var$ModalHeader;
});
parcelRegister("k0aEA", function(module, exports) {
    $parcel$export(module.exports, "NotificationToggle", ()=>$d7a96716fb30b9a5$export$9f77dec5f8cc764a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $iRH6p;
    var $3bDjY;
    var $koVbs;
    var $fAGMJ;
    var $gJZ5D;
    var $1MFUU = parcelRequire("1MFUU");
    const $d7a96716fb30b9a5$export$9f77dec5f8cc764a = ({ active: active, onChange: onChange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleCheckboxChange = (0, $5uXOq.useCallback)((e)=>onChange(e.target.checked), [
            onChange
        ]);
        const label = formatMessage((0, $1MFUU.default).notifyWatchers);
        const tooltip = formatMessage((0, $1MFUU.default).notifyWatchersDesc);
        const tooltipAriaLabel = formatMessage((0, $1MFUU.default).notifyWatchersTooltipAriaLabel);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d7a96716fb30b9a5$var$NotifyWatchersContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.notification-toggle.checkbox",
            isChecked: active,
            onChange: handleCheckboxChange,
            label: label
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltip
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                role: "button",
                tabIndex: 0,
                ...tooltipProps
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("iRH6p"))))), {
                label: tooltipAriaLabel,
                primaryColor: `var(--ds-icon-information, ${(0, (0, parcelRequire("gJZ5D")).default).B400})`
            }))));
    };
    const $d7a96716fb30b9a5$var$NotifyWatchersContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iRH6p", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $dbbe9c7ad934f1e0$var$_react = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $dbbe9c7ad934f1e0$var$_information = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("2Yv61")));
    function $dbbe9c7ad934f1e0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $dbbe9c7ad934f1e0$var$EditorInfoIcon = (props)=>$dbbe9c7ad934f1e0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
        }, props, {
            newIcon: $dbbe9c7ad934f1e0$var$_information.default
        }));
    $dbbe9c7ad934f1e0$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
    var $dbbe9c7ad934f1e0$var$_default = module.exports.default = $dbbe9c7ad934f1e0$var$EditorInfoIcon;
});
parcelRegister("1MFUU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29b3b9c8c62e3f1d$export$2e2bcd8739ae039);
    var $7VHMR;
    const $29b3b9c8c62e3f1d$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notifyWatchers: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.notification-toggle.notify-watchers",
            "defaultMessage": "Send update notifications"
        },
        notifyWatchersDesc: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.notification-toggle.notify-watchers-desc",
            "defaultMessage": "Users associated with these issues will be notified of the change as per their notification settings."
        },
        notifyWatchersTooltipAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.notification-toggle.notify-watchers-tooltip-aria-label",
            "defaultMessage": "More info"
        }
    });
    var $29b3b9c8c62e3f1d$export$2e2bcd8739ae039 = $29b3b9c8c62e3f1d$var$messages;
});
parcelRegister("4h04l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f826cf43f67eba9b$export$2e2bcd8739ae039);
    var $bC2fB;
    var $11FT3 = parcelRequire("11FT3");
    var $k6iFc = parcelRequire("k6iFc");
    var $9ltpK = parcelRequire("9ltpK");
    var $f826cf43f67eba9b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $k6iFc.default), (0, $11FT3.default))((0, $9ltpK.default));
});
parcelRegister("11FT3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e56e652103ea551$export$2e2bcd8739ae039);
    var $aHSC5 = parcelRequire("aHSC5");
    const $9e56e652103ea551$var$mapDispatchToProps = (dispatch)=>({
            replaceSelection: (changes)=>{
                dispatch((0, $aHSC5.replaceSelectedChanges)(changes));
            },
            changeQuickSelect: (option)=>{
                dispatch((0, $aHSC5.changeQuickSelect)(option));
            }
        });
    var $9e56e652103ea551$export$2e2bcd8739ae039 = $9e56e652103ea551$var$mapDispatchToProps;
});
parcelRegister("k6iFc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d0da7a940d91166$export$2e2bcd8739ae039);
    var $bI9dZ = parcelRequire("bI9dZ");
    var $eSUNk = parcelRequire("eSUNk");
    var $dccsa = parcelRequire("dccsa");
    var $3YtPS = parcelRequire("3YtPS");
    const $9d0da7a940d91166$var$getUserFilterValuesPure = (userFilter)=>userFilter.value;
    const $9d0da7a940d91166$var$getUserFilterValues = (0, $3YtPS.createSelector)([
        (0, $eSUNk.getUserFilter)
    ], $9d0da7a940d91166$var$getUserFilterValuesPure);
    var $9d0da7a940d91166$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        selectedIssues: (0, $bI9dZ.getSelected),
        userFilter: $9d0da7a940d91166$var$getUserFilterValues,
        option: (0, $dccsa.getQuickSelectOption)
    });
});
parcelRegister("dccsa", function(module, exports) {
    $parcel$export(module.exports, "getQuickSelectOption", ()=>$d76ef1f1d3cd42c8$export$4c274803eed73060);
    const $d76ef1f1d3cd42c8$export$4c274803eed73060 = (state)=>state.ui.Top.TitleBar.UpdateJira.quickSelectOption;
});
parcelRegister("9ltpK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$20e9e8e6d407bbc4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $16T6Y;
    var $ldJSL;
    var $f5TWP;
    var $8CUq3;
    var $koVbs;
    var $cYlk7;
    var $aCpcO;
    var $i2qlb = parcelRequire("i2qlb");
    var $ccIrM = parcelRequire("ccIrM");
    var $4nDwW = parcelRequire("4nDwW");
    var $8zOmE;
    var $2NMNM;
    var $lTpMH = parcelRequire("lTpMH");
    var $4gA82 = parcelRequire("4gA82");
    const $20e9e8e6d407bbc4$var$QuickSelectors = ({ selectedIssues: selectedIssues, changes: changes, replaceSelection: replaceSelection, userFilter: userFilter, option: option, changeQuickSelect: changeQuickSelect })=>{
        const currentUserData = (0, (0, parcelRequire("cYlk7")).useCurrentUser)().data.user;
        const isCurrentUserFilteredOut = userFilter.length > 0 && (0, $4nDwW.isDefined)(currentUserData.accountId) && !userFilter.includes(currentUserData.accountId);
        const hasTimelineSelection = selectedIssues.size > 0;
        const defaultSelection = (()=>{
            if (hasTimelineSelection) return (0, $ccIrM.QuickSelectOption).TIMELINE;
            if (!isCurrentUserFilteredOut) return (0, $ccIrM.QuickSelectOption).MINE;
            return (0, $ccIrM.QuickSelectOption).NONE;
        })();
        const isInitialRender = (0, $5uXOq.useRef)(true);
        const lastChanges = (0, $5uXOq.useRef)(changes.length);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const applySelection = (0, $5uXOq.useCallback)((changes)=>{
            replaceSelection(changes);
        }, [
            replaceSelection
        ]);
        const getSelectionsFromOption = (0, $5uXOq.useCallback)((option)=>{
            let newSelections;
            switch(option){
                case (0, $ccIrM.QuickSelectOption).MINE:
                    newSelections = (0, $4gA82.getMyChanges)(changes, currentUserData.accountId);
                    break;
                case (0, $ccIrM.QuickSelectOption).TODAY:
                    newSelections = (0, $4gA82.getTodaysChanges)(changes);
                    break;
                case (0, $ccIrM.QuickSelectOption).TIMELINE:
                    newSelections = (0, $4gA82.getTimelineChanges)(changes, selectedIssues);
                    break;
                default:
                    newSelections = (0, $4gA82.getAllChanges)(changes);
                    break;
            }
            return newSelections;
        }, [
            changes,
            currentUserData.accountId,
            selectedIssues
        ]);
        const selectIssuesOnOptionChange = (0, $5uXOq.useCallback)((option)=>{
            applySelection(getSelectionsFromOption(option));
        }, [
            applySelection,
            getSelectionsFromOption
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isInitialRender.current) {
                isInitialRender.current = false;
                changeQuickSelect(defaultSelection);
                selectIssuesOnOptionChange(defaultSelection);
            }
        }, [
            changeQuickSelect,
            defaultSelection,
            selectIssuesOnOptionChange
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isInitialRender.current && lastChanges.current !== changes.length) {
                if (option !== (0, $ccIrM.QuickSelectOption).NONE) selectIssuesOnOptionChange(option);
                lastChanges.current = changes.length;
            }
        }, [
            changes,
            selectIssuesOnOptionChange,
            option
        ]);
        const getIssueCountFromOption = (0, $5uXOq.useCallback)((option)=>{
            let issueCount = 0;
            switch(option){
                case (0, $ccIrM.QuickSelectOption).MINE:
                    ({ length: issueCount } = (0, $4gA82.filterChangesByUserId)(changes, currentUserData.accountId));
                    break;
                case (0, $ccIrM.QuickSelectOption).TODAY:
                    ({ length: issueCount } = (0, $4gA82.filterChangesByToday)(changes));
                    break;
                case (0, $ccIrM.QuickSelectOption).TIMELINE:
                    ({ length: issueCount } = (0, $4gA82.filterChangesBySelectedOnTimeline)(changes, selectedIssues));
                    break;
                default:
                    break;
            }
            return issueCount;
        }, [
            changes,
            currentUserData.accountId,
            selectedIssues
        ]);
        const options = [
            {
                value: (0, $ccIrM.QuickSelectOption).MINE,
                label: formatMessage((0, $lTpMH.default).changedByMeLabel),
                isDisabled: isCurrentUserFilteredOut,
                count: getIssueCountFromOption((0, $ccIrM.QuickSelectOption).MINE)
            },
            {
                value: (0, $ccIrM.QuickSelectOption).TODAY,
                label: formatMessage((0, $lTpMH.default).changedTodayLabel),
                count: getIssueCountFromOption((0, $ccIrM.QuickSelectOption).TODAY)
            },
            {
                value: (0, $ccIrM.QuickSelectOption).TIMELINE,
                label: formatMessage((0, $lTpMH.default).selectedOnTimelineLabel),
                count: getIssueCountFromOption((0, $ccIrM.QuickSelectOption).TIMELINE)
            }
        ];
        const handleSelect = (clickedOption)=>{
            const selectOrDeselectOption = option === clickedOption ? (0, $ccIrM.QuickSelectOption).NONE : clickedOption;
            changeQuickSelect(selectOrDeselectOption);
            selectIssuesOnOptionChange(selectOrDeselectOption);
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_QUICK_SELECT_CLICKED.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            }), {
                option: selectOrDeselectOption
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, options.map(({ value: value, label: label, isDisabled: isDisabled, count: count }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                key: `${value}-quick-select`,
                isSelected: option === value,
                isDisabled: isDisabled,
                onClick: ()=>{
                    handleSelect(value);
                },
                testId: `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.button-${value}`,
                autoFocus: index === 0
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $20e9e8e6d407bbc4$var$buttonLabelStyles
            }, label, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $20e9e8e6d407bbc4$var$changeCountBadgeStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
                appearance: option === value ? 'primary' : 'default'
            }, count))))));
    };
    var $20e9e8e6d407bbc4$export$2e2bcd8739ae039 = $20e9e8e6d407bbc4$var$QuickSelectors;
    const $20e9e8e6d407bbc4$var$buttonLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center'
    });
    const $20e9e8e6d407bbc4$var$changeCountBadgeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075'
    });
});
parcelRegister("lTpMH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5894081a00e3eb40$export$2e2bcd8739ae039);
    var $7VHMR;
    const $5894081a00e3eb40$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        changedByMeLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.changed-by-me-label",
            "defaultMessage": "Changed by me"
        },
        changedTodayLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.changed-today-label",
            "defaultMessage": "Changed today"
        },
        selectedOnTimelineLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.selected-on-timeline-label",
            "defaultMessage": "Selected on timeline"
        }
    });
    var $5894081a00e3eb40$export$2e2bcd8739ae039 = $5894081a00e3eb40$var$messages;
});
parcelRegister("4gA82", function(module, exports) {
    $parcel$export(module.exports, "filterChangesByUserId", ()=>$f53695d3f0cc0c3e$export$6ad6ae02a5d4389d);
    $parcel$export(module.exports, "filterChangesByToday", ()=>$f53695d3f0cc0c3e$export$c977bb716da717fe);
    $parcel$export(module.exports, "filterChangesBySelectedOnTimeline", ()=>$f53695d3f0cc0c3e$export$f6bae42563193061);
    $parcel$export(module.exports, "getMyChanges", ()=>$f53695d3f0cc0c3e$export$e155176f8d445f89);
    $parcel$export(module.exports, "getTodaysChanges", ()=>$f53695d3f0cc0c3e$export$6f496663abc2170a);
    $parcel$export(module.exports, "getTimelineChanges", ()=>$f53695d3f0cc0c3e$export$baa60d2323310e21);
    $parcel$export(module.exports, "getAllChanges", ()=>$f53695d3f0cc0c3e$export$56552f518dc96f0f);
    var $f1uil;
    var $2rMKg;
    var $4nDwW = parcelRequire("4nDwW");
    var $eVODA = parcelRequire("eVODA");
    const $f53695d3f0cc0c3e$export$6ad6ae02a5d4389d = (changes, myUserId)=>{
        let filteredChanges = [];
        if (myUserId) filteredChanges = changes.filter((change)=>change.lastModified && myUserId === change.lastModified.personId);
        return filteredChanges;
    };
    const $f53695d3f0cc0c3e$export$c977bb716da717fe = (changes)=>{
        const now = new Date();
        return changes.filter((change)=>change.lastModified && (0, (0, parcelRequire("f1uil")).default)(now, new Date(change.lastModified?.date)));
    };
    const $f53695d3f0cc0c3e$export$f6bae42563193061 = (changes, selection)=>changes.filter((change)=>selection.has(change.id));
    const $f53695d3f0cc0c3e$var$getChangeIdsByCategory = (changes)=>{
        const changesByCategory = (0, $4nDwW.groupBy)((0, parcelRequire("2rMKg")).default('category'), (0, $eVODA.getExpandedChanges)(changes));
        return (0, $4nDwW.mapValues)((0, parcelRequire("2rMKg")).default('id'), changesByCategory);
    };
    const $f53695d3f0cc0c3e$export$e155176f8d445f89 = (changes, myUserId)=>$f53695d3f0cc0c3e$var$getChangeIdsByCategory($f53695d3f0cc0c3e$export$6ad6ae02a5d4389d(changes, myUserId));
    const $f53695d3f0cc0c3e$export$6f496663abc2170a = (changes)=>$f53695d3f0cc0c3e$var$getChangeIdsByCategory($f53695d3f0cc0c3e$export$c977bb716da717fe(changes));
    const $f53695d3f0cc0c3e$export$baa60d2323310e21 = (changes, selection)=>$f53695d3f0cc0c3e$var$getChangeIdsByCategory($f53695d3f0cc0c3e$export$f6bae42563193061(changes, selection));
    const $f53695d3f0cc0c3e$export$56552f518dc96f0f = (changes)=>$f53695d3f0cc0c3e$var$getChangeIdsByCategory(changes);
});
parcelRegister("yFIAE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f1a40284a3f14ffa$export$2e2bcd8739ae039);
    var $bC2fB;
    var $8mRVf = parcelRequire("8mRVf");
    var $6hhJn = parcelRequire("6hhJn");
    var $jmWco = parcelRequire("jmWco");
    var $f1a40284a3f14ffa$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6hhJn.default), (0, $8mRVf.default))((0, $jmWco.default));
});
parcelRegister("8mRVf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f2b442b54b4c91fe$export$2e2bcd8739ae039);
    var $lTHzT = parcelRequire("lTHzT");
    const $f2b442b54b4c91fe$var$mapDispatchToProps = (dispatch)=>({
            handleSubmit: (id)=>dispatch((0, $lTHzT.submit)({
                    generatedItemId: id
                })),
            handleCancel: ()=>dispatch((0, $lTHzT.cancel)()),
            handleCancelAll: ()=>dispatch((0, $lTHzT.cancel)()),
            handleFailure: ()=>dispatch((0, $lTHzT.fail)())
        });
    var $f2b442b54b4c91fe$export$2e2bcd8739ae039 = $f2b442b54b4c91fe$var$mapDispatchToProps;
});
parcelRegister("6hhJn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c658ef4d1c231894$export$2e2bcd8739ae039);
    var $9U6ZH;
    var $2rMKg;
    var $19iju = parcelRequire("19iju");
    var $6Ayrn = parcelRequire("6Ayrn");
    var $kllqP = parcelRequire("kllqP");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $jpgxP = parcelRequire("jpgxP");
    var $dRVQG = parcelRequire("dRVQG");
    var $25viM = parcelRequire("25viM");
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    const $c658ef4d1c231894$var$getStartDateCustomField = (0, $3YtPS.createSelector)([
        (0, $19iju.getCustomFields)
    ], (customFields)=>customFields.find(({ defaultStartDateCustomField: defaultStartDateCustomField })=>defaultStartDateCustomField));
    const $c658ef4d1c231894$var$getRequiredFields = (state)=>state.domain.updateJira.requiredFields;
    const $c658ef4d1c231894$var$getIssueKey = (issueKey, project, projectsById)=>{
        if (project && projectsById[project]) return `${projectsById[project].key}${issueKey ? `-${issueKey}` : ''}`;
        return null;
    };
    var $c658ef4d1c231894$export$2e2bcd8739ae039 = (0, $3YtPS.createSelector)([
        $c658ef4d1c231894$var$getRequiredFields,
        (0, $25viM.getFilteredReviewChanges),
        (0, $kllqP.getIssueTypes),
        (0, $jpgxP.getSystemInfo),
        (0, $jpgxP.getAgileInfo),
        (0, $gFhwb.getIssueMapById),
        (0, $jpXKt.getProjectsById),
        $c658ef4d1c231894$var$getStartDateCustomField,
        (0, $6Ayrn.getTypeToLevel),
        (0, $bHTqr.getPlan),
        (0, $dRVQG.getTeamsById)
    ], (requiredFields, reviewChanges, issueTypes, systemInfo, agileInfo, issuesMappedById, projectsById, startDateCustomField, getIssueTypeToHierarchyLevel, planInfo, teamsById)=>{
        const { isWaiting: isWaiting } = requiredFields;
        if (!isWaiting) {
            const inactiveProps = {
                isOpen: false
            };
            return inactiveProps;
        }
        const { issueId: issueId, error: error } = requiredFields;
        const jiraConfig = {
            hoursPerDay: systemInfo.jiraHoursPerDay,
            daysPerWeek: systemInfo.jiraDaysPerWeek
        };
        const issueTypesById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), issueTypes);
        const issueChange = (0, parcelRequire("9U6ZH")).default((change)=>change.id === issueId, reviewChanges);
        const issue = issueChange?.details;
        const fullIssue = issuesMappedById[issueId];
        if (!issue || !fullIssue) throw new Error('Cannot retrieve issue details for required fields dialog');
        const parentIssue = (()=>{
            const pIssue = fullIssue.parent != null ? issuesMappedById[fullIssue.parent] : undefined;
            if (pIssue?.type == null || pIssue?.issueKey == null || pIssue?.project == null) return;
            const parentIssueKey = $c658ef4d1c231894$var$getIssueKey(pIssue.issueKey, pIssue.project, projectsById);
            if (!parentIssueKey) return;
            return {
                key: parentIssueKey,
                hierarchyLevel: getIssueTypeToHierarchyLevel(pIssue.type)
            };
        })();
        const activeStateProps = {
            isOpen: true,
            issue: issue,
            error: error,
            issueTypesById: issueTypesById,
            agileConfig: agileInfo,
            jiraConfig: jiraConfig,
            parentIssue: parentIssue,
            startDateCustomField: startDateCustomField,
            planInfo: planInfo,
            projectsById: projectsById,
            teamsById: teamsById
        };
        return activeStateProps;
    });
});
parcelRegister("jmWco", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef89b11f20e2c05e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $5kbpS = parcelRequire("5kbpS");
    var $4R6GH;
    var $koVbs;
    var $hULKg;
    var $5rzqz;
    var $idQXL = parcelRequire("idQXL");
    var $7pdff = parcelRequire("7pdff");
    var $dZDIg = parcelRequire("dZDIg");
    const $ef89b11f20e2c05e$var$getDocumentRoot = ()=>document.body;
    const $ef89b11f20e2c05e$var$tryMoveElementToContainer = (container, el)=>{
        if (container) {
            el.remove();
            container.appendChild(el);
        }
    };
    const $ef89b11f20e2c05e$var$DEFAULT_OPEN_GIC_MODAL_VALUES = {
        id: 'jpo-dialogs-jira-create-issue',
        triggerPointKey: (0, (0, parcelRequire("hULKg")).JPO_DIALOGS_CREATE_ISSUE_TRIGGER),
        disableCreationSuccessFlag: true,
        disableProjectDropdown: true,
        disableIssueTypeDropdown: true,
        displayOnlyRequiredFields: false,
        displayCreateAnotherIssueToggle: false
    };
    const $ef89b11f20e2c05e$var$useGlobalIssueCreateModal = ()=>{
        const [, { openIssueCreateModal: openIssueCreateModal }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const showDialog = (0, $5uXOq.useCallback)(({ payload: payload, handleSubmit: handleSubmit, handleCancel: handleCancel, isSubTask: isSubTask, errorMessages: errorMessages })=>{
            openIssueCreateModal({
                ...$ef89b11f20e2c05e$var$DEFAULT_OPEN_GIC_MODAL_VALUES,
                payload: payload,
                title: formatMessage((0, $idQXL.default).requiredFieldsDialogTitle),
                isSubTaskCreationOpen: isSubTask,
                onIssueCreate: (data)=>handleSubmit(data.issueId.toString()),
                onClose: ()=>handleCancel(),
                submitErrorMessage: (0, ($parcel$interopDefault($5kbpS)))(errorMessages) ? undefined : errorMessages?.join('\n')
            });
        }, [
            formatMessage,
            openIssueCreateModal
        ]);
        return {
            showDialog: showDialog
        };
    };
    const $ef89b11f20e2c05e$var$RequiredFieldsDialog = (props)=>{
        const { showDialog: showDialog } = $ef89b11f20e2c05e$var$useGlobalIssueCreateModal();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('refactor_update_jira_to_functional_component')) {
            if (props.isOpen) return (0, ($parcel$interopDefault($5uXOq))).createElement($ef89b11f20e2c05e$var$RequiredFieldsDialogClass, {
                ...props,
                formatMessage: formatMessage,
                showDialog: showDialog
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($ef89b11f20e2c05e$var$RequiredFieldsDialogClass, {
                ...props,
                formatMessage: formatMessage
            });
        }
        return ((0, ($parcel$interopDefault($5uXOq))).createElement($ef89b11f20e2c05e$var$RequiredFieldsDialogClass, {
            ...props,
            showDialog: showDialog,
            formatMessage: formatMessage
        }));
    };
    class $ef89b11f20e2c05e$var$RequiredFieldsDialogClass extends (0, $5uXOq.Component) {
        createLegacyDialogInRefContainer(activeProps) {
            const { formatMessage: formatMessage, issue: issue, issueTypesById: issueTypesById, agileConfig: agileConfig, jiraConfig: jiraConfig, projectsById: projectsById } = activeProps;
            const jQueryDeferred = (0, $7pdff.default).create({
                formatMessage: formatMessage,
                issue: issue,
                issueTypesById: issueTypesById,
                agileConfig: agileConfig,
                jiraConfig: jiraConfig,
                isIssueSimplified: projectsById[issue.values.project].isSimplified,
                onRenderCallback: (dialog)=>{
                    $ef89b11f20e2c05e$var$tryMoveElementToContainer(this.containerRef, dialog);
                }
            });
            return jQueryDeferred;
        }
        render() {
            const root = $ef89b11f20e2c05e$var$getDocumentRoot();
            const container = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: (ref)=>{
                    this.containerRef = ref;
                }
            });
            return (0, ($parcel$interopDefault($7nsd3))).createPortal(container, root);
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.isOpen !== this.props.isOpen;
        }
        async componentDidUpdate() {
            if (this.containerRef) this.containerRef.innerHTML = '';
            if (!this.props.isOpen) return;
            const activeProps = this.props;
            const { handleSubmit: handleSubmit, handleCancel: handleCancel, handleCancelAll: handleCancelAll, handleFailure: handleFailure, issue: issue, agileConfig: agileConfig, issueTypesById: issueTypesById, error: error, parentIssue: parentIssue, startDateCustomField: startDateCustomField, planInfo: planInfo, projectsById: projectsById, teamsById: teamsById } = activeProps;
            const isIssueSimplified = projectsById[issue.values.project].isSimplified;
            const isModernDialogEnabled = window.IssueCreate && window.IssueCreate.Visibility.isEnabled;
            if (isModernDialogEnabled && this.props.showDialog) {
                const { payload: payload, isSubTask: isSubTask } = await (0, $dZDIg.getOpenIssueCreateModalPayload)({
                    issue: issue,
                    agileConfig: agileConfig,
                    issueTypesById: issueTypesById,
                    planInfo: planInfo,
                    startDateCustomField: startDateCustomField,
                    parentIssue: parentIssue,
                    isIssueSimplified: isIssueSimplified,
                    teamsById: teamsById
                });
                this.props.showDialog({
                    payload: payload,
                    handleSubmit: handleSubmit,
                    handleCancel: handleCancel,
                    isSubTask: isSubTask,
                    errorMessages: error?.errorMessages
                });
            } else this.createLegacyDialogInRefContainer(activeProps).done(({ id: id })=>handleSubmit(id)).fail(({ reason: reason })=>{
                if (reason === 'cancel') handleCancel();
                else if (reason === 'cancel-all') handleCancelAll();
                else handleFailure();
            });
        }
        constructor(...args){
            super(...args);
            this.containerRef = null;
        }
    }
    var $ef89b11f20e2c05e$export$2e2bcd8739ae039 = $ef89b11f20e2c05e$var$RequiredFieldsDialog;
});
parcelRegister("idQXL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62f30815d4a1a9eb$export$2e2bcd8739ae039);
    var $7VHMR;
    var $62f30815d4a1a9eb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        requiredFieldsDialogTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.required-fields-dialog.required-fields-dialog-title",
            "defaultMessage": "Set required fields"
        }
    });
});
parcelRegister("7pdff", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b23c4f08420a87d$export$2e2bcd8739ae039);
    var $2XSIf;
    var $3pSjV;
    var $jVZZA;
    var $7myQy;
    var $aipk9;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $6Od7e = parcelRequire("6Od7e");
    var $1BCTH = parcelRequire("1BCTH");
    var $6Ev0T = parcelRequire("6Ev0T");
    const $3b23c4f08420a87d$var$createCreateIssueModel = ({ projectId: projectId, issueTypeId: issueTypeId, parentIssueId: parentIssueId })=>{
        const $ = (0, $1BCTH.getJquery)();
        const RequiredFieldsCreateIssueModel = (0, $1BCTH.getJira)().Forms.CreateIssueModel.extend({
            getActiveFieldIds () {
                const deferred = new $.Deferred();
                const activeFieldsIds = [];
                this.getRequiredFields().done((requiredFields)=>{
                    requiredFields.forEach((requiredField)=>{
                        if (!activeFieldsIds.includes(requiredField.id)) activeFieldsIds.push(requiredField.id);
                    });
                    deferred.resolve(activeFieldsIds);
                });
                return deferred;
            },
            getUseConfigurableForm () {
                return $.when(true);
            },
            setUseConfigurableForm () {}
        });
        return new RequiredFieldsCreateIssueModel({
            projectId: projectId,
            issueType: issueTypeId,
            parentIssueId: parentIssueId
        });
    };
    const $3b23c4f08420a87d$var$disableSelect = ($el)=>{
        const $ = (0, $1BCTH.getJquery)();
        if ($el.length > 0) {
            $el.addClass('aui-disabled');
            $('input', $el).prop('disabled', true);
            $('span', $el).css('pointer-events', 'none');
            if ($('.aui-disabled-blanket').length === 0) $el.append('<div class="aui-disabled-blanket" style="height: 30px;"></div>');
        }
    };
    const $3b23c4f08420a87d$var$isCommittedFixVersion = (versionId)=>(0, parcelRequire("7myQy")).default(Number, +versionId);
    const $3b23c4f08420a87d$var$formatEstimates = ({ seconds: seconds, hoursPerDay: hoursPerDay, daysPerWeek: daysPerWeek })=>{
        if (!seconds) return undefined;
        const durations = {
            h: 3600,
            m: 60,
            s: 1
        };
        const format = [
            {
                unit: 'w',
                seconds: durations.h * hoursPerDay * daysPerWeek
            },
            {
                unit: 'd',
                seconds: durations.h * hoursPerDay
            },
            {
                unit: 'h',
                seconds: durations.h
            },
            {
                unit: 'm',
                seconds: durations.m
            },
            {
                unit: 's',
                seconds: durations.s
            }
        ];
        let remainingSeconds = seconds;
        let retVal = '';
        format.forEach((entry)=>{
            const x = Math.floor(remainingSeconds / entry.seconds);
            if (x > 0) {
                retVal += `${x}${entry.unit} `;
                remainingSeconds -= x * entry.seconds;
            }
        });
        return retVal.trim();
    };
    const $3b23c4f08420a87d$var$timestampToFormattedDate = (timestampValue)=>(0, (0, parcelRequire("aipk9")).formatDateUTC)(timestampValue, (0, $TTKUQ.DefaultDateFormat));
    const $3b23c4f08420a87d$var$formatCustomField = (customField)=>{
        if (customField.typeKey === (0, $TTKUQ.CustomFieldTypes).DatePicker) return $3b23c4f08420a87d$var$timestampToFormattedDate(customField.value);
        return customField.value;
    };
    const $3b23c4f08420a87d$var$isCustomFieldKey = (key)=>key.startsWith('customField');
    const $3b23c4f08420a87d$export$ca7888bf604d23e8 = ({ issue: issue, agileConfig: agileConfig, isIssueSimplified: isIssueSimplified })=>{
        const { epicLabelField: epicLabelField, storyPointsField: storyPointsField, storyPointEstimateField: storyPointEstimateField } = agileConfig;
        const nonScenarioFixVersions = (0, parcelRequire("jVZZA")).default($3b23c4f08420a87d$var$isCommittedFixVersion, (0, parcelRequire("3pSjV")).default([], issue.values.fixVersions));
        let prefilledFields = {
            summary: issue.values.summary,
            description: issue.values.description || '',
            fixVersions: nonScenarioFixVersions,
            issuetype: issue.values.type
        };
        if (issue.values.dueDate) prefilledFields = (0, parcelRequire("2XSIf")).default('duedate', $3b23c4f08420a87d$var$timestampToFormattedDate(issue.values.dueDate), prefilledFields);
        Object.entries(issue.values).forEach(([key, value])=>{
            if (key && value) {
                if ($3b23c4f08420a87d$var$isCustomFieldKey(key)) {
                    const customField = issue.values[key];
                    prefilledFields[`customfield_${customField.id}`] = $3b23c4f08420a87d$var$formatCustomField(customField);
                } else if (!prefilledFields[key]) prefilledFields[key] = issue.values[key];
            }
        });
        if (epicLabelField) prefilledFields[epicLabelField] = issue.values.summary;
        if (issue.values.storyPoints) {
            if (isIssueSimplified && storyPointsField) prefilledFields[storyPointsField] = issue.values.storyPoints;
            else if (!isIssueSimplified && storyPointEstimateField) prefilledFields[storyPointEstimateField] = issue.values.storyPoints;
        }
        return prefilledFields;
    };
    const $3b23c4f08420a87d$var$create = (params)=>{
        const { issue: issue, issueTypesById: issueTypesById, jiraConfig: jiraConfig } = params;
        const $ = (0, $1BCTH.getJquery)();
        const _ = (0, $1BCTH.getUnderscore)();
        const deferred = new $.Deferred();
        const isSubTask = issueTypesById[issue.values.type] && issueTypesById[issue.values.type].subTask === true;
        const isSubTaskCreationPossible = ()=>{
            const isCommittedParentId = (0, parcelRequire("7myQy")).default(Number, +issue.values.parent);
            return !isSubTask || isCommittedParentId;
        };
        if (!isSubTaskCreationPossible) {
            deferred.reject({
                type: 'client-sub-task-creation-impossible'
            });
            return deferred;
        }
        const prefilledFields = $3b23c4f08420a87d$export$ca7888bf604d23e8(params);
        const formattedEstimates = $3b23c4f08420a87d$var$formatEstimates({
            seconds: issue.values.timeEstimate,
            hoursPerDay: jiraConfig.hoursPerDay,
            daysPerWeek: jiraConfig.daysPerWeek
        });
        const parentId = isSubTask ? issue.values.parent : undefined;
        const createIssueModel = $3b23c4f08420a87d$var$createCreateIssueModel({
            projectId: issue.values.project,
            issueTypeId: issue.values.type,
            parentIssueId: parentId
        });
        const title = params.formatMessage((0, $6Ev0T.default).requiredFieldsDialogTitle);
        (0, $6Od7e.default).showDialog({
            deferred: deferred,
            model: createIssueModel,
            prefilledFields: prefilledFields,
            title: title,
            hideConfigureFields: true,
            onRenderCallback: ($dialog)=>{
                if (formattedEstimates) {
                    $('#timetracking_originalestimate', $dialog).val(formattedEstimates);
                    $('#timetracking_remainingestimate', $dialog).val(formattedEstimates);
                    $('#timetracking', $dialog).val(formattedEstimates);
                }
                const el = $dialog.get(0);
                params.onRenderCallback(el);
            },
            onContentRefreshedCallback: (quickFormElement)=>{
                _.defer(()=>{
                    $3b23c4f08420a87d$var$disableSelect($('#project-single-select', quickFormElement));
                    $3b23c4f08420a87d$var$disableSelect($('#issuetype-single-select', quickFormElement));
                });
            }
        });
        return deferred;
    };
    var $3b23c4f08420a87d$export$2e2bcd8739ae039 = {
        create: $3b23c4f08420a87d$var$create
    };
});
parcelRegister("6Od7e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e0e6090179e561b$export$2e2bcd8739ae039);
    var $1BCTH = parcelRequire("1BCTH");
    const $9e0e6090179e561b$var$createCreateIssueForm = ({ model: model, title: title, prefilledFields: prefilledFields = {} })=>{
        const $ = (0, $1BCTH.getJquery)();
        const JIRA = (0, $1BCTH.getJira)();
        const CustomFormContainer = JIRA.Forms.Container.extend({
            lazyInit () {
                const options = this.options();
                options.prefilledValues.fieldsToRetain = Object.keys(options.prefilledValues);
                this.prefilledValues = $.param(options.prefilledValues, true);
                this.options = ()=>options;
                this._super();
            },
            render () {
                const deferred = $.Deferred();
                this.lazyInit();
                this.model.getUseConfigurableForm().done((isConfigurable)=>{
                    if (isConfigurable) this.configurableForm.render(this.prefilledValues).done((_, scripts)=>{
                        deferred.resolveWith(this, [
                            this.$element
                        ]);
                        this.$element.append(scripts);
                    });
                    else this.unconfigurableForm.render.render(this.prefilledValues).done((_, scripts)=>{
                        deferred.resolveWith(this, [
                            this.$element,
                            scripts
                        ]);
                        this.$element.append(scripts);
                    });
                }).fail(()=>{
                    deferred.resolveWith(this, [
                        this.$element
                    ]);
                });
                return deferred.promise();
            }
        });
        return new CustomFormContainer(()=>{
            const globalEventNamespaces = [
                'QuickCreateEpic'
            ];
            const configurableForm = new JIRA.Forms.ConfigurableCreateIssueForm({
                model: model,
                title: title,
                globalEventNamespaces: globalEventNamespaces
            });
            const unconfigurableForm = new JIRA.Forms.UnconfigurableCreateIssueForm({
                model: model,
                title: title,
                globalEventNamespaces: globalEventNamespaces
            });
            return {
                globalEventNamespaces: globalEventNamespaces,
                model: model,
                configurableForm: configurableForm,
                unconfigurableForm: unconfigurableForm,
                errorHandler: new JIRA.Forms.CreateIssueError(),
                prefilledValues: prefilledFields
            };
        });
    };
    const $9e0e6090179e561b$var$bind = (element, eventKey, func)=>{
        if (element) (0, $1BCTH.getAjs)().$(element).bind(eventKey, func);
    };
    const $9e0e6090179e561b$var$unbind = (element, eventKey, func)=>{
        const AJS = (0, $1BCTH.getAjs)();
        if (element && eventKey) {
            if (func) AJS.$(element).unbind(eventKey, func);
            else AJS.$(element).unbind(eventKey);
        }
    };
    const $9e0e6090179e561b$var$showDialog = ({ model: model, prefilledFields: prefilledFields, title: title, hideConfigureFields: hideConfigureFields, hideCancelAllLink: hideCancelAllLink, deferred: deferred, onRenderCallback: onRenderCallback, onContentRefreshedCallback: onContentRefreshedCallback })=>{
        const JIRA = (0, $1BCTH.getJira)();
        const $ = (0, $1BCTH.getJquery)();
        const form = $9e0e6090179e561b$var$createCreateIssueForm({
            model: model,
            title: title,
            prefilledFields: prefilledFields
        });
        const dialog = form.asDialog({
            id: 'jpo-dialogs-jira-create-issue'
        });
        const cancelAllLink = !hideCancelAllLink ? $('<a href="javascript:void(0);" class="jpo-cancel-all">Cancel All</a>') : undefined;
        const onIssueCreated = (_, data)=>{
            const issueData = data.createdIssueDetails;
            const result = {
                id: issueData.id,
                key: issueData.key,
                title: issueData.fields.summary,
                issuetypeId: issueData.fields.issuetype.id
            };
            deferred.resolve(result);
        };
        const onContentRefreshed = ()=>{
            const quickForm = dialog.getQuickForm();
            const quickFormElement = quickForm.$element;
            onContentRefreshedCallback && onContentRefreshedCallback(quickFormElement);
        };
        const onValidationError = ()=>{
            const quickForm = dialog.getQuickForm();
            const quickFormElement = quickForm.$element;
            onContentRefreshedCallback && onContentRefreshedCallback(quickFormElement);
        };
        const onRender = ()=>{
            const quickForm = dialog.getQuickForm();
            const quickFormElement = quickForm.$element;
            $('label.qf-create-another', quickFormElement).remove();
            if (hideConfigureFields) $('.qf-form-operations', quickFormElement).remove();
            if (cancelAllLink !== undefined) {
                $('.form-footer .buttons', quickFormElement).append(cancelAllLink);
                cancelAllLink.on('click', ()=>{
                    const undim = true;
                    dialog.hide(undim, {
                        reason: 'cancel-all'
                    });
                    dialog.destroy();
                });
            }
            onRenderCallback && onRenderCallback(dialog.$popup);
            $9e0e6090179e561b$var$bind(form.configurableForm, 'issueCreated', onIssueCreated);
            $9e0e6090179e561b$var$bind(form.unconfigurableForm, 'issueCreated', onIssueCreated);
            $9e0e6090179e561b$var$bind(form.configurableForm, 'validationError', onValidationError);
            $9e0e6090179e561b$var$bind(form.unconfigurableForm, 'validationError', onValidationError);
            $9e0e6090179e561b$var$unbind(form, 'configurableFormRendered', onRender);
            $9e0e6090179e561b$var$unbind(form, 'unconfigurableFormRendered', onRender);
        };
        const onDialogHide = (event, dialogObj, reason)=>{
            if (event && event.isDefaultPrevented()) return;
            let reasonValue = reason;
            if (reasonValue === 'esc') reasonValue = 'cancel';
            $9e0e6090179e561b$var$unbind(form.configurableForm, 'issueCreated', onIssueCreated);
            $9e0e6090179e561b$var$unbind(form.unconfigurableForm, 'issueCreated', onIssueCreated);
            $9e0e6090179e561b$var$unbind(form.configurableForm, 'validationError', onValidationError);
            $9e0e6090179e561b$var$unbind(form.unconfigurableForm, 'validationError', onValidationError);
            $9e0e6090179e561b$var$unbind(form, 'configurableFormRendered', onRender);
            $9e0e6090179e561b$var$unbind(form, 'unconfigurableFormRendered', onRender);
            $9e0e6090179e561b$var$unbind(form, 'contentRefreshed', onContentRefreshed);
            $9e0e6090179e561b$var$unbind(dialogObj, 'Dialog.hide', onDialogHide);
            $9e0e6090179e561b$var$unbind(document, 'QuickCreateIssueInEpic.validationError', onValidationError);
            if (JIRA.EpicPicker) $9e0e6090179e561b$var$unbind(document, JIRA.EpicPicker.READY_EVENT);
            if (cancelAllLink) cancelAllLink.off('click');
            if (reasonValue === 'cancel' || reasonValue === 'cancel-all') deferred.reject({
                reason: reasonValue
            });
            else deferred.reject({
                type: 'cancel-operation-unknown'
            });
        };
        $9e0e6090179e561b$var$bind(form, 'configurableFormRendered', onRender);
        $9e0e6090179e561b$var$bind(form, 'unconfigurableFormRendered', onRender);
        $9e0e6090179e561b$var$bind(form, 'contentRefreshed', onContentRefreshed);
        $9e0e6090179e561b$var$bind(dialog, 'Dialog.hide', onDialogHide);
        dialog.show();
    };
    var $9e0e6090179e561b$export$2e2bcd8739ae039 = {
        showDialog: $9e0e6090179e561b$var$showDialog
    };
});
parcelRegister("1BCTH", function(module, exports) {
    $parcel$export(module.exports, "getJquery", ()=>$354fb71a3e22a7fb$export$6c7e070cd85c6c57);
    $parcel$export(module.exports, "getUnderscore", ()=>$354fb71a3e22a7fb$export$2243344b1bb4828d);
    $parcel$export(module.exports, "getJira", ()=>$354fb71a3e22a7fb$export$57a8ce65afe89b19);
    $parcel$export(module.exports, "getAjs", ()=>$354fb71a3e22a7fb$export$5f49845c47c8d9ba);
    var $4nDwW = parcelRequire("4nDwW");
    const $354fb71a3e22a7fb$var$callback = ()=>{};
    $354fb71a3e22a7fb$var$callback.split = ()=>[];
    const $354fb71a3e22a7fb$var$getJqueryValue = ()=>window && window.require && window.require('jquery', $354fb71a3e22a7fb$var$callback);
    const $354fb71a3e22a7fb$var$getUnderscoreValue = ()=>window && window.require && window.require('underscore', $354fb71a3e22a7fb$var$callback);
    const $354fb71a3e22a7fb$var$getJiraValue = ()=>window && window.JIRA;
    const $354fb71a3e22a7fb$var$getAjsValue = ()=>window && window.AJS;
    const $354fb71a3e22a7fb$var$getGlobal = (getValue)=>{
        let value;
        return ()=>{
            if (!(0, $4nDwW.isDefined)(value)) value = getValue();
            return value;
        };
    };
    const $354fb71a3e22a7fb$export$6c7e070cd85c6c57 = $354fb71a3e22a7fb$var$getGlobal($354fb71a3e22a7fb$var$getJqueryValue);
    const $354fb71a3e22a7fb$export$2243344b1bb4828d = $354fb71a3e22a7fb$var$getGlobal($354fb71a3e22a7fb$var$getUnderscoreValue);
    const $354fb71a3e22a7fb$export$57a8ce65afe89b19 = $354fb71a3e22a7fb$var$getGlobal($354fb71a3e22a7fb$var$getJiraValue);
    const $354fb71a3e22a7fb$export$5f49845c47c8d9ba = $354fb71a3e22a7fb$var$getGlobal($354fb71a3e22a7fb$var$getAjsValue);
});
parcelRegister("6Ev0T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0790a14a834b7af4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0790a14a834b7af4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        requiredFieldsDialogTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.required-fields-dialog.uncontrolled-legacy-dialog.required-fields-dialog-title",
            "defaultMessage": "Set required fields"
        }
    });
});
parcelRegister("dZDIg", function(module, exports) {
    $parcel$export(module.exports, "getOpenIssueCreateModalPayload", ()=>$dc4a91ac2e54c3b6$export$72c3f78108cf2fcc);
    var $gZL7V = parcelRequire("gZL7V");
    var $jcw0u;
    var $aipk9;
    var $c12LJ;
    var $68rG5 = parcelRequire("68rG5");
    var $8DSSe = parcelRequire("8DSSe");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $dc4a91ac2e54c3b6$var$timestampToFormattedDate = (timestampValue)=>timestampValue != null && (0, (0, parcelRequire("aipk9")).formatDateUTC)(timestampValue, 'YYYY-MM-DD');
    const $dc4a91ac2e54c3b6$var$isCustomFieldKey = (key)=>key.startsWith('customField');
    const $dc4a91ac2e54c3b6$export$cefe233909b19f98 = (payload)=>(0, $8DSSe.default)((0, $68rG5.urls).getDescription, {
            method: 'POST',
            body: {
                ...payload,
                renderRaw: true
            }
        }).then((response)=>response.json());
    const $dc4a91ac2e54c3b6$var$CUSTOM_FIELD_MAP = {
        [(0, $TTKUQ.CustomFieldTypes).DatePicker]: 'datePickerFields',
        [(0, $TTKUQ.CustomFieldTypes).TextField]: 'singleLineTextFields',
        [(0, $TTKUQ.CustomFieldTypes).UserPicker]: 'singleSelectUserPickerFields',
        [(0, $TTKUQ.CustomFieldTypes).NumberField]: 'numberFields',
        [(0, $TTKUQ.CustomFieldTypes).MultiSelect]: 'multipleSelectFields',
        [(0, $TTKUQ.CustomFieldTypes).Labels]: 'labelsFields',
        [(0, $TTKUQ.CustomFieldTypes).MultiCheckboxes]: 'multipleSelectFields',
        [(0, $TTKUQ.CustomFieldTypes).SingleSelect]: 'singleSelectFields',
        [(0, $TTKUQ.CustomFieldTypes).RadioButtons]: 'singleSelectFields',
        [(0, $TTKUQ.CustomFieldTypes).Url]: 'urlFields'
    };
    const $dc4a91ac2e54c3b6$var$transformCustomFieldKey = (ckey)=>ckey?.replace(/customFieldValueAdded-|customFieldValueRemoved-|customField-/gi, 'customfield_');
    const $dc4a91ac2e54c3b6$export$72c3f78108cf2fcc = async ({ issue: issue, agileConfig: agileConfig, issueTypesById: issueTypesById, planInfo: planInfo, teamsById: teamsById, startDateCustomField: startDateCustomField, parentIssue: parentIssue, isIssueSimplified: isIssueSimplified }, fetchDescription = $dc4a91ac2e54c3b6$export$cefe233909b19f98)=>{
        const { epicLinkField: epicLinkField, storyPointsField: storyPointsField, sprintsField: sprintsField, storyPointEstimateField: storyPointEstimateField, targetStartField: targetStartField, targetEndField: targetEndField, teamField: teamField } = agileConfig;
        const { values: values } = issue;
        const { type: type, project: project } = values;
        if (type == null) throw Error('Error opening GIC, no issue type');
        const isSubTask = !!issueTypesById[type]?.subTask;
        const payload = Object.entries(values).reduce((result, [key, val])=>{
            if (!result.defaultValues || !result.customFieldsToPreserveOnFormRecreation) return result;
            if (val == null) return result;
            if ($dc4a91ac2e54c3b6$var$isCustomFieldKey(key)) {
                if (key.includes('customFieldValueRemoved')) return result;
                const { id: customFieldId, typeKey: typeKey = '', value: customFieldValue } = val;
                if (customFieldValue == null) return result;
                const fieldType = $dc4a91ac2e54c3b6$var$CUSTOM_FIELD_MAP[typeKey];
                if (!fieldType) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: (0, $TTKUQ.ERROR_REPORTING_PACKAGE).GIC,
                            packageName: (0, $TTKUQ.PACKAGE_NAME),
                            teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                        },
                        error: new Error(`Unsupported custom field ${typeKey}`),
                        sendToPrivacyUnsafeSplunk: false
                    });
                    return result;
                }
                const newVal = (()=>{
                    switch(fieldType){
                        case 'singleLineTextFields':
                            return {
                                fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(key),
                                text: customFieldValue
                            };
                        case 'datePickerFields':
                            return {
                                fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(key),
                                date: {
                                    formattedDate: $dc4a91ac2e54c3b6$var$timestampToFormattedDate(customFieldValue)
                                }
                            };
                        case 'singleSelectUserPickerFields':
                            return {
                                fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(key),
                                user: {
                                    accountId: customFieldValue
                                }
                            };
                        case 'numberFields':
                            return {
                                fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(key),
                                value: customFieldValue
                            };
                        case 'singleSelectFields':
                            return {
                                fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(key),
                                option: {
                                    optionId: customFieldValue
                                }
                            };
                        case 'multipleSelectFields':
                            return {
                                fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(key),
                                options: Array.isArray(customFieldValue) ? customFieldValue.map((val)=>({
                                        optionId: val
                                    })) : [
                                    {
                                        optionId: customFieldValue
                                    }
                                ]
                            };
                        case 'urlFields':
                            return {
                                fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(key),
                                url: customFieldValue
                            };
                        case 'labelsFields':
                            return {
                                fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(key),
                                labels: Array.isArray(customFieldValue) ? customFieldValue.map((val)=>({
                                        name: val
                                    })) : [
                                    {
                                        name: customFieldValue
                                    }
                                ]
                            };
                        default:
                            return result;
                    }
                })();
                if (!newVal) return result;
                result.customFieldsToPreserveOnFormRecreation.push(`customfield_${customFieldId}`);
                result.defaultValues[fieldType] = (result.defaultValues[fieldType] || []).concat(newVal);
                return result;
            }
            switch(key){
                case 'summary':
                    result.defaultValues.singleLineTextFields = (result.defaultValues.singleLineTextFields || []).concat({
                        fieldId: key,
                        text: val
                    });
                    break;
                case 'storyPoints':
                    result.defaultValues.numberFields = (result.defaultValues.numberFields || []).concat({
                        fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(isIssueSimplified ? storyPointEstimateField : storyPointsField),
                        value: val
                    });
                    break;
                case 'dueDate':
                    if (typeof val === 'number' || typeof val === 'string') result.defaultValues.datePickerFields = (result.defaultValues.datePickerFields || []).concat({
                        fieldId: 'duedate',
                        date: {
                            formattedDate: $dc4a91ac2e54c3b6$var$timestampToFormattedDate(val)
                        }
                    });
                    break;
                case 'startDate':
                    if (typeof val === 'number' || typeof val === 'string') result.defaultValues.datePickerFields = (result.defaultValues.datePickerFields || []).concat({
                        fieldId: startDateCustomField ? `customField-${startDateCustomField.id}` : 'startdate',
                        date: {
                            formattedDate: $dc4a91ac2e54c3b6$var$timestampToFormattedDate(val)
                        }
                    });
                    break;
                case 'targetStart':
                case 'targetEnd':
                    {
                        if (!(typeof val === 'number' || typeof val === 'string')) break;
                        const fieldIdKey = key === 'targetStart' ? targetStartField : targetEndField;
                        result.defaultValues.datePickerFields = (result.defaultValues.datePickerFields || []).concat({
                            fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(fieldIdKey),
                            date: {
                                formattedDate: $dc4a91ac2e54c3b6$var$timestampToFormattedDate(val)
                            }
                        });
                        break;
                    }
                case 'sprint':
                    result.defaultValues.sprintsField = {
                        fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(sprintsField),
                        sprints: Array.isArray(val) ? val.map((sprint)=>({
                                sprintId: sprint
                            })) : [
                            {
                                sprintId: val
                            }
                        ]
                    };
                    break;
                case 'assignee':
                case 'reporter':
                    result.defaultValues.singleSelectUserPickerFields = (result.defaultValues.singleSelectUserPickerFields || []).concat({
                        fieldId: key,
                        user: {
                            accountId: val
                        }
                    });
                    break;
                case 'parent':
                    result.defaultValues.parentField = {
                        issueId: val
                    };
                    if (isSubTask && val != null) result.parentId = {
                        parentId: String(val)
                    };
                    break;
                case 'labels':
                    {
                        const labelValue = {
                            fieldId: key,
                            labels: Array.isArray(val) ? val.map((label)=>({
                                    name: label
                                })) : [
                                {
                                    name: val
                                }
                            ]
                        };
                        result.defaultValues.labelsFields = Array.isArray(result.defaultValues.labelsFields) ? result.defaultValues.labelsFields.concat(labelValue) : [
                            labelValue
                        ];
                        break;
                    }
                case 'fixVersions':
                    result.defaultValues.multipleVersionPickerFields = {
                        fieldId: key,
                        versions: Array.isArray(val) ? val.map((sprint)=>({
                                versionId: sprint
                            })) : [
                            {
                                versionId: val
                            }
                        ]
                    };
                    break;
                case 'components':
                    result.defaultValues.components = Array.isArray(val) ? val.map((val)=>({
                            componentId: val
                        })) : [
                        {
                            componentId: val
                        }
                    ];
                    break;
                case 'team':
                    {
                        const team = values.team ? teamsById[values.team] : null;
                        const teamId = team && team.externalId ? team.externalId : '';
                        const teamVal = {
                            fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(teamField),
                            team: {
                                teamId: teamId
                            }
                        };
                        result.defaultValues.atlassianTeamFields = teamVal;
                        break;
                    }
                case 'type':
                case 'project':
                case 'lexoRank':
                case 'issueLink':
                case 'description':
                case 'color':
                default:
                    break;
            }
            return result;
        }, {
            defaultValues: {},
            customFieldsToPreserveOnFormRecreation: []
        });
        payload.issueType = {
            issueTypeId: String(type)
        };
        if (project) payload.project = {
            projectId: String(project)
        };
        if (values.description) {
            const { value: value } = await fetchDescription({
                planId: planInfo.id,
                scenarioId: planInfo.currentScenarioId,
                itemKey: issue.id
            });
            const descriptionVal = {
                fieldId: 'description',
                richText: {
                    wikiText: value
                }
            };
            (0, ($parcel$interopDefault($gZL7V)))(payload, 'defaultValues.richTextFields', Array.isArray(payload.defaultValues?.richTextFields) ? payload.defaultValues?.richTextFields.concat(descriptionVal) : [
                descriptionVal
            ]);
        }
        if (parentIssue?.hierarchyLevel === (0, (0, parcelRequire("c12LJ")).EPIC_LEVEL)) (0, ($parcel$interopDefault($gZL7V)))(payload, 'defaultValues.epicLinkField', {
            fieldId: $dc4a91ac2e54c3b6$var$transformCustomFieldKey(epicLinkField),
            epicLink: {
                issueKey: parentIssue.key
            }
        });
        return {
            payload: payload,
            isSubTask: isSubTask
        };
    };
});
parcelRegister("lSLIm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f8cf983854f3122$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $86zlq;
    var $9jGhM = parcelRequire("9jGhM");
    var $hwjHH = parcelRequire("hwjHH");
    const $0f8cf983854f3122$var$ReviewChangesButtonWrapper = (0, $5uXOq.forwardRef)(({ currentScenarioColor: currentScenarioColor, changesCount: changesCount, isOptimizing: isOptimizing, isOptimized: isOptimized, isReadOnly: isReadOnly, openDialog: openDialog }, ref)=>{
        const [hasCountChanged, setHasCountChanged] = (0, $5uXOq.useState)(false);
        const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
        const toggleSetHasCountChanged = (0, $5uXOq.useCallback)((hasCountUpdated)=>setHasCountChanged(hasCountUpdated), []);
        const activateSpotlight = (0, $5uXOq.useCallback)(()=>setIsSpotlightActive(true), []);
        const closeSpotlight = (0, $5uXOq.useCallback)(()=>{
            setIsSpotlightActive(false);
        }, []);
        const handleOpenDialog = (0, $5uXOq.useCallback)((e)=>{
            if (isSpotlightActive && hasCountChanged) setIsSpotlightActive(false);
            openDialog(e);
        }, [
            isSpotlightActive,
            openDialog,
            setIsSpotlightActive,
            hasCountChanged
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hwjHH.default), {
            changesCount: changesCount,
            onCountChanged: toggleSetHasCountChanged
        }), !(isOptimizing || isOptimized || isReadOnly) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86zlq")).UseShortcuts), {
            shortcutKey: "KeyR",
            onKeyDown: handleOpenDialog
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $9jGhM.default), {
            ref: ref,
            hasCountChanged: hasCountChanged,
            toggleSetHasCountChanged: toggleSetHasCountChanged,
            isSpotlightActive: isSpotlightActive,
            openDialog: handleOpenDialog,
            closeSpotlight: closeSpotlight,
            activateSpotlight: activateSpotlight,
            currentScenarioColor: currentScenarioColor,
            changesCount: changesCount,
            isOptimizing: isOptimizing
        }));
    });
    var $0f8cf983854f3122$export$2e2bcd8739ae039 = $0f8cf983854f3122$var$ReviewChangesButtonWrapper;
});
parcelRegister("9jGhM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1161b69bd5c2dc65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $16T6Y;
    var $eCeGD;
    var $k6T4f;
    var $5Fk4Z;
    var $gkD4s;
    var $4oNEb;
    var $1V7PR;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $koVbs;
    var $gJZ5D;
    var $1qMX7;
    var $igD1g;
    var $g295Q;
    var $aPRoZ;
    var $gITL8 = parcelRequire("gITL8");
    var $90yGq;
    var $5yZ4w = parcelRequire("5yZ4w");
    var $50xcD = parcelRequire("50xcD");
    const $1161b69bd5c2dc65$var$ReviewChangesButton = (0, $5uXOq.forwardRef)(({ hasCountChanged: hasCountChanged, changesCount: changesCount, isSpotlightActive: isSpotlightActive, isOptimizing: isOptimizing, currentScenarioColor: currentScenarioColor, openDialog: openDialog, closeSpotlight: closeSpotlight, activateSpotlight: activateSpotlight, toggleSetHasCountChanged: toggleSetHasCountChanged }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gkD4s")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1V7PR")).Reference), null, ({ ref: popperRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
                name: (0, (0, parcelRequire("g295Q")).CttSpotlights).ReviewChanges
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
                name: (0, (0, parcelRequire("aPRoZ")).Spotlights).SaveYourChanges
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1qMX7")).default), {
                    letter: "R"
                }),
                position: "bottom"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $1161b69bd5c2dc65$var$buttonContainerStyles,
                ref: popperRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k6T4f")).Pulse), {
                radius: 4,
                pulse: hasCountChanged && isSpotlightActive
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                onClick: openDialog,
                isDisabled: isOptimizing,
                appearance: "primary",
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.review-changes-button",
                ref: ref
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $1161b69bd5c2dc65$var$buttonLabelStyles
            }, formatMessage((0, $5yZ4w.default).updateJiraButtonText), changesCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: [
                    $1161b69bd5c2dc65$var$changeCountBadgeStyles
                ]
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), {
                style: {
                    backgroundColor: currentScenarioColor,
                    color: currentScenarioColor ? (0, $gITL8.colourPaletteTextColoursMap)[currentScenarioColor] || `var(--ds-text-inverse, ${(0, (0, parcelRequire("gJZ5D")).default).N0})` : `var(--ds-text-inverse, ${(0, (0, parcelRequire("gJZ5D")).default).N0})`
                },
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.change-count"
            }, changesCount)))))))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), {
            placement: "bottom-end"
        }, ({ ref: popperRef, style: style })=>hasCountChanged && accountId ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("igD1g")).CttOnboardingProvider), {
                isGlobal: true,
                accountId: accountId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                ref: popperRef,
                style: style,
                xcss: $1161b69bd5c2dc65$var$spotlightContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $50xcD.default), {
                closeSpotlight: closeSpotlight,
                activateSpotlight: activateSpotlight,
                isSpotlightActive: isSpotlightActive,
                toggleSetHasCountChanged: toggleSetHasCountChanged
            }))) : null));
    });
    const $1161b69bd5c2dc65$var$buttonLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center'
    });
    const $1161b69bd5c2dc65$var$changeCountBadgeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginTop: '0',
        marginRight: 'space.025',
        marginLeft: 'space.075',
        marginBottom: '0',
        outline: 0,
        borderRadius: '2em'
    });
    const $1161b69bd5c2dc65$var$buttonContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: 'min-content'
    });
    const $1161b69bd5c2dc65$var$spotlightContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        zIndex: 'spotlight'
    });
    var $1161b69bd5c2dc65$export$2e2bcd8739ae039 = $1161b69bd5c2dc65$var$ReviewChangesButton;
});
parcelRegister("5yZ4w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$900845a313e0672b$export$2e2bcd8739ae039);
    var $7VHMR;
    const $900845a313e0672b$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        updateJiraButtonText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.update-jira-button-text",
            "defaultMessage": "Unsaved changes"
        }
    });
    var $900845a313e0672b$export$2e2bcd8739ae039 = $900845a313e0672b$var$messages;
});
parcelRegister("50xcD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$170a428eb1aa4919$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $cYlk7;
    var $igD1g;
    var $h28Ml = parcelRequire("h28Ml");
    const $170a428eb1aa4919$export$709a19d72c2ee36f = 'jira.user.plans.review-changes.onboarding';
    const $170a428eb1aa4919$export$9be1266bb791b74d = (accountId)=>`/rest/api/3/user/properties/${$170a428eb1aa4919$export$709a19d72c2ee36f}?accountId=${accountId}`;
    const $170a428eb1aa4919$var$ReviewChangesSpotlightManager = ({ closeSpotlight: closeSpotlight, activateSpotlight: activateSpotlight, isSpotlightActive: isSpotlightActive, toggleSetHasCountChanged: toggleSetHasCountChanged })=>{
        const { data: { user: { accountId: accountId } } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const [cttOnboarding] = (0, (0, parcelRequire("igD1g")).useCttOnboardingTour)();
        const getUserProperty = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("eusud")).performGetRequest)($170a428eb1aa4919$export$9be1266bb791b74d(accountId ?? '')), [
            accountId
        ]);
        const updateUserProperty = (0, $5uXOq.useCallback)((timestamp)=>(0, (0, parcelRequire("eusud")).performPutRequest)($170a428eb1aa4919$export$9be1266bb791b74d(accountId ?? ''), {
                body: JSON.stringify({
                    timestamp: timestamp
                })
            }), [
            accountId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            getUserProperty().then((userProperty)=>{
                if (!userProperty?.value?.timestamp) activateSpotlight();
            }).catch((error)=>{
                if (error?.statusCode === 404) activateSpotlight();
            });
        }, [
            activateSpotlight,
            getUserProperty
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (cttOnboarding.visible && isSpotlightActive) toggleSetHasCountChanged(false);
        }, [
            isSpotlightActive,
            cttOnboarding.visible,
            toggleSetHasCountChanged
        ]);
        return isSpotlightActive && !(cttOnboarding.isTakingOnboardingTour || cttOnboarding.visible) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $h28Ml.default), {
            closeSpotlight: closeSpotlight,
            updateUserProperty: updateUserProperty
        }) : null;
    };
    var $170a428eb1aa4919$export$2e2bcd8739ae039 = $170a428eb1aa4919$var$ReviewChangesSpotlightManager;
});
parcelRegister("h28Ml", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e1bccb6569da3d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $i28qQ;
    var $5ujeO;
    var $koVbs;
    var $i2qlb = parcelRequire("i2qlb");
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $1cyCl = parcelRequire("1cyCl");
    const $7e1bccb6569da3d5$var$ReviewChangesSpotlight = ({ closeSpotlight: closeSpotlight, updateUserProperty: updateUserProperty })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            updateUserProperty(Date.now());
        }, [
            updateUserProperty
        ]);
        const handleCloseDialog = (_, analyticsEvent)=>{
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLOSE_UNSAVED_CHANGES_SPOTLIGHT.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLOSE_UNSAVED_CHANGES_SPOTLIGHT);
            closeSpotlight();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "reviewChangesSpotlight",
            sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ujeO")).default), {
            headingAfterElement: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                appearance: "subtle",
                label: formatMessage((0, $1cyCl.default).closeSpotlight),
                spacing: "compact",
                icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("i28qQ"))))), {
                        ...iconProps,
                        color: "var(--ds-icon-inverse, #FFFFFF)"
                    }),
                onClick: handleCloseDialog,
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.review-changes-spotlight-manager.review-changes-spotlight.selected-field-remove-button"
            }),
            heading: formatMessage((0, $1cyCl.default).updateJiraSpotlightTitle)
        }, formatMessage((0, $1cyCl.default).updateJiraSpotlightBody)));
    };
    var $7e1bccb6569da3d5$export$2e2bcd8739ae039 = $7e1bccb6569da3d5$var$ReviewChangesSpotlight;
});
parcelRegister("1cyCl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8bbcd43245ceadc$export$2e2bcd8739ae039);
    var $7VHMR;
    const $b8bbcd43245ceadc$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        updateJiraSpotlightTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.review-changes-spotlight-manager.review-changes-spotlight.update-jira-spotlight-title",
            "defaultMessage": "Your plan has unsaved changes"
        },
        updateJiraSpotlightBody: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.review-changes-spotlight-manager.review-changes-spotlight.update-jira-spotlight-body",
            "defaultMessage": "Save issues created or changed in your plan so they update in your projects."
        },
        closeSpotlight: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.review-changes-spotlight-manager.review-changes-spotlight.close-spotlight",
            "defaultMessage": "Close unsaved changes spotlight"
        }
    });
    var $b8bbcd43245ceadc$export$2e2bcd8739ae039 = $b8bbcd43245ceadc$var$messages;
});
parcelRegister("hwjHH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3f56b2195816b44$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $a3f56b2195816b44$var$SpotlightChangesCountMonitor = (0, $5uXOq.memo)(({ changesCount: changesCount, onCountChanged: onCountChanged })=>{
        const prevChangesCount = (0, $5uXOq.useRef)(changesCount);
        (0, $5uXOq.useEffect)(()=>{
            if (changesCount !== 0 && changesCount !== prevChangesCount.current) onCountChanged(true);
            prevChangesCount.current = changesCount;
        }, [
            changesCount,
            onCountChanged
        ]);
        return null;
    });
    var $a3f56b2195816b44$export$2e2bcd8739ae039 = $a3f56b2195816b44$var$SpotlightChangesCountMonitor;
});
parcelRegister("geig8", function(module, exports) {
    $parcel$export(module.exports, "body", ()=>$bd0c1e112e46b146$export$32180ef41b15b513, (v)=>$bd0c1e112e46b146$export$32180ef41b15b513 = v);
    $parcel$export(module.exports, "dialogContent", ()=>$bd0c1e112e46b146$export$1a09c8e9a482a512, (v)=>$bd0c1e112e46b146$export$1a09c8e9a482a512 = v);
    $parcel$export(module.exports, "filters", ()=>$bd0c1e112e46b146$export$82462a21aead86ed, (v)=>$bd0c1e112e46b146$export$82462a21aead86ed = v);
    $parcel$export(module.exports, "footerParent", ()=>$bd0c1e112e46b146$export$dc0b18c34163d3d8, (v)=>$bd0c1e112e46b146$export$dc0b18c34163d3d8 = v);
    $parcel$export(module.exports, "out-of-sync", ()=>$bd0c1e112e46b146$export$3ee20dc3519c4984, (v)=>$bd0c1e112e46b146$export$3ee20dc3519c4984 = v);
    $parcel$export(module.exports, "out-of-sync-message", ()=>$bd0c1e112e46b146$export$b66d7f757063937e, (v)=>$bd0c1e112e46b146$export$b66d7f757063937e = v);
    $parcel$export(module.exports, "spinner", ()=>$bd0c1e112e46b146$export$641374ffb95bc399, (v)=>$bd0c1e112e46b146$export$641374ffb95bc399 = v);
    $parcel$export(module.exports, "updateJiraButton", ()=>$bd0c1e112e46b146$export$cca14117b277a7bc, (v)=>$bd0c1e112e46b146$export$cca14117b277a7bc = v);
    var $bd0c1e112e46b146$export$32180ef41b15b513;
    var $bd0c1e112e46b146$export$fe7e0a090115fdda;
    var $bd0c1e112e46b146$export$187bfbaba8563c7b;
    var $bd0c1e112e46b146$export$1a09c8e9a482a512;
    var $bd0c1e112e46b146$export$82462a21aead86ed;
    var $bd0c1e112e46b146$export$dc0b18c34163d3d8;
    var $bd0c1e112e46b146$export$38e42c68cf43b5d4;
    var $bd0c1e112e46b146$export$3ee20dc3519c4984;
    var $bd0c1e112e46b146$export$b66d7f757063937e;
    var $bd0c1e112e46b146$export$641374ffb95bc399;
    var $bd0c1e112e46b146$export$fb184b623420d9be;
    var $bd0c1e112e46b146$export$cca14117b277a7bc;
    $bd0c1e112e46b146$export$32180ef41b15b513 = `pHrIna_body`;
    $bd0c1e112e46b146$export$fe7e0a090115fdda = `pHrIna_button-label`;
    $bd0c1e112e46b146$export$187bfbaba8563c7b = `pHrIna_changeCountBadge`;
    $bd0c1e112e46b146$export$1a09c8e9a482a512 = `pHrIna_dialogContent`;
    $bd0c1e112e46b146$export$82462a21aead86ed = `pHrIna_filters`;
    $bd0c1e112e46b146$export$dc0b18c34163d3d8 = `pHrIna_footerParent`;
    $bd0c1e112e46b146$export$38e42c68cf43b5d4 = `pHrIna_header`;
    $bd0c1e112e46b146$export$3ee20dc3519c4984 = `pHrIna_out-of-sync`;
    $bd0c1e112e46b146$export$b66d7f757063937e = `pHrIna_out-of-sync-message`;
    $bd0c1e112e46b146$export$641374ffb95bc399 = `pHrIna_spinner`;
    $bd0c1e112e46b146$export$fb184b623420d9be = `pHrIna_title`;
    $bd0c1e112e46b146$export$cca14117b277a7bc = `pHrIna_updateJiraButton`;
});
parcelRegister("7dFyj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e3fbb68612ed227$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $42CjB;
    var $5LWLA;
    var $i28qQ;
    var $1R1Ge;
    var $juxqI;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $8Ec39;
    var $9fuVs;
    var $39xOx;
    var $5Zxxp;
    var $ousew;
    var $koVbs;
    var $enoTt;
    var $i2qlb = parcelRequire("i2qlb");
    var $c10z2 = parcelRequire("c10z2");
    var $4nDwW = parcelRequire("4nDwW");
    var $4cwkM = parcelRequire("4cwkM");
    var $idmiV = parcelRequire("idmiV");
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $8BWE6 = parcelRequire("8BWE6");
    var $gZDvj = parcelRequire("gZDvj");
    var $hS7Kp = parcelRequire("hS7Kp");
    var $30u2g = parcelRequire("30u2g");
    var $vH6RR = parcelRequire("vH6RR");
    var $eeWRL = parcelRequire("eeWRL");
    var $4C5T3 = parcelRequire("4C5T3");
    var $7zIWQ = parcelRequire("7zIWQ");
    var $6bYOl = parcelRequire("6bYOl");
    var $cO2Va = parcelRequire("cO2Va");
    var $cfRKD = parcelRequire("cfRKD");
    var $dhNbN = parcelRequire("dhNbN");
    var $k0aEA = parcelRequire("k0aEA");
    var $4h04l = parcelRequire("4h04l");
    var $yFIAE = parcelRequire("yFIAE");
    var $lSLIm = parcelRequire("lSLIm");
    var $eVODA = parcelRequire("eVODA");
    const $8e3fbb68612ed227$var$DIALOG_NON_TABLE_HEIGHT = 200;
    const $8e3fbb68612ed227$var$DIALOG_MIN_HEIGHT = 500;
    const $8e3fbb68612ed227$export$1bd567d0d45faa0b = (props, handleStopAction, openDiscardConfirmation, formatMessage)=>{
        const { isLoading: isLoading, isSaving: isSaving, isSavingInterrupted: isSavingInterrupted, isReadOnly: isReadOnly, isReverting: isReverting, isRevertingInterrupted: isRevertingInterrupted, isOutOfSync: isOutOfSync, updateJira: updateJira, selectedChangesCount: selectedChangesCount, isNonPublishingEditor: isNonPublishingEditor, isGicModalOpen: isGicModalOpen = false, clearSummaryPageCache: clearSummaryPageCache, changesCount: changesCount } = props;
        const discardAction = {
            text: formatMessage((0, $cO2Va.default).updateJiraDialogRevertButtonText),
            onClick: openDiscardConfirmation,
            appearance: 'subtle',
            isDisabled: isOutOfSync || isLoading || selectedChangesCount === 0 || isReverting,
            isLoading: false,
            isVisible: !(isSaving || isReadOnly || isReverting),
            testId: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-selected-changes'
        };
        if (!(isSaving || isReverting)) return [
            discardAction,
            {
                text: formatMessage((0, $cO2Va.default).updateJiraDialogUpdateButtonText),
                type: 'save',
                onClick: (e, analyticsEvent)=>{
                    updateJira(analyticsEvent, props.shouldNotifyWatchers);
                    clearSummaryPageCache();
                    const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SAVE_SELECTED_CHANGES_IN_JIRA_CLICKED.split(' ');
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                        action: action,
                        actionSubject: actionSubject
                    }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SAVE_SELECTED_CHANGES_IN_JIRA_CLICKED, {
                        changesCount: changesCount
                    });
                },
                appearance: 'primary',
                isDisabled: isOutOfSync || isLoading || selectedChangesCount === 0 || isNonPublishingEditor || isGicModalOpen,
                isVisible: !isReadOnly,
                autoFocus: true,
                tooltip: isGicModalOpen ? formatMessage((0, $cO2Va.default).disabledTooltipForUpdateJiraWhenGicIsOpen) : formatMessage((0, $cO2Va.default).disabledTooltipForUpdateJira),
                testId: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.save-selected-changes'
            }
        ];
        return [
            {
                text: !(isSavingInterrupted || isRevertingInterrupted) ? formatMessage((0, $cO2Va.default).updateJiraDialogStopButtonText) : formatMessage((0, $cO2Va.default).updateJiraDialogStoppingButtonText),
                onClick: ()=>{
                    handleStopAction();
                },
                isLoading: isSavingInterrupted || isRevertingInterrupted,
                isDisabled: isSavingInterrupted || isRevertingInterrupted
            },
            discardAction
        ];
    };
    const $8e3fbb68612ed227$export$5f536f6fe584a085 = (0, $8BWE6.default)((0, $6bYOl.default));
    const $8e3fbb68612ed227$var$UpdateJira = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { changes: changes, changesCount: changesCount, isDialogOpen: isDialogOpen, isLoading: isLoading, isSaving: isSaving, isReadOnly: isReadOnly, isOptimizing: isOptimizing, isOptimized: isOptimized, isReverting: isReverting, isOutOfSync: isOutOfSync, openDialog: openDialog, onChangeListModified: onChangeListModified, hiddenIssuesDialogIsOpen: hiddenIssuesDialogIsOpen, closeCommitWarningFlag: closeCommitWarningFlag, commitWarningMeta: { commitWarningsExists: commitWarningsExists, shouldShowCommitWarningFlag: shouldShowCommitWarningFlag, successfulCommitCount: successfulCommitCount, failedCommitCount: failedCommitCount }, selectedChangesCount: selectedChangesCount, currentScenarioColor: currentScenarioColor, dateConfiguration: dateConfiguration, typeToLevel: typeToLevel, shouldNotifyWatchers: shouldNotifyWatchers, isIssuesLoading: isIssuesLoading, hasPlanOnlyTeams: hasPlanOnlyTeams, interruptCommitting: interruptCommitting, interruptReverting: interruptReverting, closeDialog: closeDialog } = props;
        const buttonRef = (0, $5uXOq.createRef)();
        const [isDiscardConfirmationOpen, setIsDiscardConfirmationOpen] = (0, $5uXOq.useState)(false);
        const [openedDialogWithChanges, setOpenedDialogWithChanges] = (0, $5uXOq.useState)(false);
        const toggleNotification = (next)=>{
            props.updateNotificationPreference(next);
        };
        const openDiscardConfirmation = (_, analyticsEvent)=>{
            setIsDiscardConfirmationOpen(true);
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).DISCARD_SELECTED_CHANGES_CLICKED.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).DISCARD_SELECTED_CHANGES_CLICKED, {
                changesCount: changesCount
            });
        };
        const closeDiscardConfirmation = ()=>{
            setIsDiscardConfirmationOpen(false);
        };
        const handleDiscardConfirmation = (_, analyticsEvent)=>{
            setIsDiscardConfirmationOpen(false);
            props.revertChanges();
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REVERT_SCENARIO.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REVERT_SCENARIO, {
                changesCount: props.selectedChangesCount
            });
        };
        const refresh = ()=>{
            (0, $idmiV.reload)();
        };
        const handleStopAction = ()=>{
            if (isSaving) interruptCommitting();
            else interruptReverting();
        };
        const handleCloseDialog = (_, analyticsEvent)=>{
            if ((0, $4nDwW.isDefined)(analyticsEvent)) {
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_CANCEL_CLICKED.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: action,
                    actionSubject: actionSubject
                }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_CANCEL_CLICKED, {
                    changesCount: changesCount
                });
            }
            closeDialog();
            buttonRef.current?.focus();
        };
        const renderDialog = (headerText, dialogContent, width, height)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
                attributes: {
                    changesCount: changesCount
                }
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ec39")).default), {
                name: "jira-plan-save-scenario-change-dialog"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                id: "jira-plan.save-scenario-change-dialog",
                packageName: "jiraPortfolio3Portfolio",
                teamName: "Advanced Roadmaps",
                fallback: "flag"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                shouldReturnFocus: true,
                shouldCloseOnEscapePress: !(isSaving || isReverting),
                onClose: handleCloseDialog,
                shouldCloseOnOverlayClick: false,
                width: width,
                height: height
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $8e3fbb68612ed227$var$headerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dhNbN.default), null, headerText), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                appearance: "subtle",
                label: formatMessage((0, $cO2Va.default).closeDialog),
                spacing: "compact",
                icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ"))))),
                onClick: handleCloseDialog,
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.selected-field-remove-button"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $8e3fbb68612ed227$var$bodyStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                xcss: $8e3fbb68612ed227$var$dialogContentStyles,
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-dialog-content"
            }, dialogContent), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $yFIAE.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hS7Kp.default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-dialog-footer"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cfRKD.default), {
                leftActions: changesCount !== 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $k0aEA.NotificationToggle), {
                    active: shouldNotifyWatchers,
                    onChange: toggleNotification
                }) : null,
                actions: $8e3fbb68612ed227$export$1bd567d0d45faa0b(props, handleStopAction, openDiscardConfirmation, formatMessage),
                selectedChangesCount: selectedChangesCount
            }))))))));
        const handleOpenDialog = (e)=>{
            setOpenedDialogWithChanges(changesCount !== 0);
            openDialog(e);
        };
        if (isIssuesLoading) return null;
        let width = 'x-large';
        let height;
        let dialogContent;
        switch(true){
            case isOutOfSync:
                dialogContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                    xcss: $8e3fbb68612ed227$var$outOfSyncStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    label: "",
                    dangerouslySetGlyph: (0, ($parcel$interopDefault($c10z2)))
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $8e3fbb68612ed227$var$outOfSyncMessageStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "p"
                }, formatMessage((0, $cO2Va.default).outOfSyncMessageConcurrentEditing)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "p"
                }, formatMessage((0, $cO2Va.default).refreshCta)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $8e3fbb68612ed227$var$refreshButtonStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                    appearance: "primary",
                    onClick: refresh
                }, formatMessage((0, $cO2Va.default).refreshButton)))));
                break;
            case isLoading:
                dialogContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                    xcss: $8e3fbb68612ed227$var$spinnerStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), {
                    size: "large"
                }));
                break;
            default:
                width = '90vw';
                height = Math.max($8e3fbb68612ed227$var$DIALOG_NON_TABLE_HEIGHT + (0, $85c8de56229e3cc7$export$88e6c5bab2ff80e8) * changes.length, $8e3fbb68612ed227$var$DIALOG_MIN_HEIGHT);
                dialogContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                    space: "space.100",
                    xcss: $8e3fbb68612ed227$var$dialogContentContainerStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "p"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, $cO2Va.default).updateJiraDialogBodyTop,
                    values: {
                        link: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Zxxp")).default), {
                                articleId: "5jV03VyuxP6cfYQwcKWxWO",
                                fallbackComponent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cwkM.default), {
                                    href: (0, $4cwkM.default).URLs.committingChangesToJira
                                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cO2Va.default).updateJiraDialogReadMoreText)),
                                appearance: "link",
                                spacing: "none",
                                onClick: handleCloseDialog
                            }, chunks)
                    }
                })), hasPlanOnlyTeams && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "p"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cO2Va.default).updateJiraDialogBodyBottom))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                    xcss: $8e3fbb68612ed227$var$filterStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                    grow: "fill"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4h04l.default), {
                    changes: changes
                })), (0, ($parcel$interopDefault($5uXOq))).createElement($8e3fbb68612ed227$export$5f536f6fe584a085, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eeWRL.default), {
                    changes: changes,
                    commitWarningsExists: commitWarningsExists,
                    isUpdating: isSaving || isReverting,
                    isReadOnly: isReadOnly,
                    changesCount: changesCount
                }));
        }
        const headerText = formatMessage((0, $cO2Va.default).updateJiraDialogHeader, {
            changesCount: changesCount
        });
        const shouldIncludeTimeframePlanningAnalyticsAttributes = changesCount > 0 && isDialogOpen && !isLoading && !isSaving && !isReverting;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8e3fbb68612ed227$var$updateJiraButtonStyles
        }, (0, $4nDwW.isDefined)(onChangeListModified) && isDialogOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $30u2g.default), {
            onChangeListModified: onChangeListModified,
            changesCount: changesCount,
            isSaving: isSaving
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "reviewChanges",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            attributes: shouldIncludeTimeframePlanningAnalyticsAttributes ? {
                roadmapChangeDetails: (0, $eVODA.getAttributesForIssuesWithTimeframeChanges)(changes, dateConfiguration, typeToLevel),
                changesCount: changesCount
            } : {}
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lSLIm.default), {
            currentScenarioColor: currentScenarioColor,
            changesCount: changesCount,
            isOptimizing: isOptimizing,
            isOptimized: isOptimized,
            isReadOnly: isReadOnly,
            openDialog: handleOpenDialog,
            ref: buttonRef
        }), isDialogOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, openedDialogWithChanges ? renderDialog(headerText, dialogContent, width, height) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7zIWQ.default), {
            handleCloseDialog: handleCloseDialog
        })), hiddenIssuesDialogIsOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $gZDvj.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $vH6RR.default), {
            successfulCommitCount: successfulCommitCount,
            failedCommitCount: failedCommitCount,
            show: shouldShowCommitWarningFlag,
            onClose: ()=>{
                closeCommitWarningFlag();
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "discardChanges",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4C5T3.default), {
            isOpen: isDiscardConfirmationOpen,
            onConfirm: handleDiscardConfirmation,
            onCancel: closeDiscardConfirmation
        }))));
    };
    const $8e3fbb68612ed227$var$headerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.250',
        paddingRight: 'space.250',
        paddingLeft: 'space.250',
        paddingBottom: 'space.100',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    });
    const $8e3fbb68612ed227$var$dialogContentContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.075',
        marginBottom: 'space.150'
    });
    const $8e3fbb68612ed227$var$bodyStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        display: 'flex',
        flex: '1 1 auto',
        paddingBlock: 'space.025',
        paddingInline: 'space.250',
        maxHeight: 'calc(100% - 120px)',
        minHeight: '0'
    });
    const $8e3fbb68612ed227$var$dialogContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: '1 1 auto'
    });
    const $8e3fbb68612ed227$var$spinnerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $8e3fbb68612ed227$var$outOfSyncStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.250',
        alignItems: 'center'
    });
    const $8e3fbb68612ed227$var$outOfSyncMessageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlock: 'space.250',
        textAlign: 'center'
    });
    const $8e3fbb68612ed227$var$refreshButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.100'
    });
    const $8e3fbb68612ed227$var$filterStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.100'
    });
    const $8e3fbb68612ed227$var$updateJiraButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.050'
    });
    var $8e3fbb68612ed227$export$2e2bcd8739ae039 = $8e3fbb68612ed227$var$UpdateJira;
});
parcelRegister("c10z2", function(module, exports) {
    module.exports = "<svg width=\"200\" height=\"184\" xmlns=\"http://www.w3.org/2000/svg\"><defs><linearGradient x1=\"0%\" y1=\"50.007%\" x2=\"99.999%\" y2=\"50.007%\" id=\"a\"><stop stop-color=\"#6C798F\" offset=\"0%\"></stop><stop stop-color=\"#6C798F\" stop-opacity=\".1\" offset=\"100%\"></stop></linearGradient><linearGradient x1=\"-6635.484%\" y1=\"-2%\" y2=\"-2%\" id=\"b\"><stop stop-color=\"#99C1FF\" stop-opacity=\"0\" offset=\"0%\"></stop><stop stop-color=\"#93BEFF\" stop-opacity=\".04\" offset=\"1%\"></stop><stop stop-color=\"#78ADFF\" stop-opacity=\".22\" offset=\"5%\"></stop><stop stop-color=\"#5E9EFF\" stop-opacity=\".38\" offset=\"9%\"></stop><stop stop-color=\"#4790FF\" stop-opacity=\".53\" offset=\"14%\"></stop><stop stop-color=\"#3484FF\" stop-opacity=\".66\" offset=\"20%\"></stop><stop stop-color=\"#247AFF\" stop-opacity=\".77\" offset=\"25%\"></stop><stop stop-color=\"#1672FF\" stop-opacity=\".85\" offset=\"32%\"></stop><stop stop-color=\"#0C6CFF\" stop-opacity=\".92\" offset=\"40%\"></stop><stop stop-color=\"#0568FF\" stop-opacity=\".97\" offset=\"49%\"></stop><stop stop-color=\"#0166FF\" stop-opacity=\".99\" offset=\"63%\"></stop><stop stop-color=\"#0065FF\" offset=\"100%\"></stop></linearGradient><linearGradient x1=\"0%\" y1=\"14049%\" x2=\"10440%\" y2=\"14049%\" id=\"c\"><stop stop-color=\"#99C1FF\" stop-opacity=\"0\" offset=\"0%\"></stop><stop stop-color=\"#93BEFF\" stop-opacity=\".04\" offset=\"1%\"></stop><stop stop-color=\"#78ADFF\" stop-opacity=\".22\" offset=\"5%\"></stop><stop stop-color=\"#5E9EFF\" stop-opacity=\".38\" offset=\"9%\"></stop><stop stop-color=\"#4790FF\" stop-opacity=\".53\" offset=\"14%\"></stop><stop stop-color=\"#3484FF\" stop-opacity=\".66\" offset=\"20%\"></stop><stop stop-color=\"#247AFF\" stop-opacity=\".77\" offset=\"25%\"></stop><stop stop-color=\"#1672FF\" stop-opacity=\".85\" offset=\"32%\"></stop><stop stop-color=\"#0C6CFF\" stop-opacity=\".92\" offset=\"40%\"></stop><stop stop-color=\"#0568FF\" stop-opacity=\".97\" offset=\"49%\"></stop><stop stop-color=\"#0166FF\" stop-opacity=\".99\" offset=\"63%\"></stop><stop stop-color=\"#0065FF\" offset=\"100%\"></stop></linearGradient></defs><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M106 167.73v-39.56A40.57 40.57 0 1 0 65.45 87.6H25.88c-.004-32.416 19.521-61.643 49.47-74.049 29.948-12.406 64.42-5.548 87.341 17.375 22.92 22.923 29.774 57.397 17.364 87.344-12.41 29.947-41.639 49.468-74.055 49.46z\" fill=\"url(#a)\" transform=\"translate(-1 8)\"></path><path d=\"M101.85 169.27v-39.56c22.406 0 40.57-18.164 40.57-40.57s-18.164-40.57-40.57-40.57-40.57 18.164-40.57 40.57H21.71C21.71 44.88 57.59 9 101.85 9s80.14 35.88 80.14 80.14-35.88 80.14-80.14 80.14v-.01z\" fill=\"#0065FF\"></path><path d=\"M182 89.14c.088-42.717-33.345-77.995-76.005-80.199-42.66-2.204-79.55 29.44-83.865 71.939L8.75 79.67a3.06 3.06 0 0 0-2.62 5l30.56 36.63c1.08 1.3 3 1.47 3.4.39l36.63-30.57c3-1.75 1.93-5.15-.78-5.4l-14.38-1.3c2.525-21.65 21.705-37.435 43.436-35.748 21.731 1.686 38.246 20.242 37.4 42.022-.846 21.78-18.75 39-40.546 38.996h1.55v39.53c43.618-.876 78.538-36.453 78.6-80.08z\" fill=\"#0065FF\"></path><path d=\"M104.4 161.27h-1.55 1.55z\" fill=\"url(#b)\" transform=\"translate(-1 8)\"></path><path fill=\"url(#c)\" d=\"M0 121.71h102.85v39.57H0z\" transform=\"translate(-1 8)\"></path><path d=\"M101.85 129.71v39.57h1.55v-39.57h-1.55z\" fill=\"#0065FF\"></path><path d=\"M102.85 121.71v39.57h1.55v-39.57h-1.55z\" fill=\"url(#c)\" transform=\"translate(-1 8)\"></path></g></svg>";
});
parcelRegister("a4Rpy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57bc7e82cfcf5130$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bH1LI = parcelRequire("bH1LI");
    var $6IE5x = parcelRequire("6IE5x");
    var $fYlx6 = parcelRequire("fYlx6");
    var $57bc7e82cfcf5130$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6IE5x.default), (0, $bH1LI.default))((0, $fYlx6.default));
});
parcelRegister("bH1LI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b5cc0055c16c0fa$export$2e2bcd8739ae039);
    var $5lzYR = parcelRequire("5lzYR");
    var $23472 = parcelRequire("23472");
    const $2b5cc0055c16c0fa$var$mapDispatchToProps = (dispatch)=>({
            setSearchQuery: (value)=>{
                dispatch((0, $23472.setSearchQuery)(value));
                dispatch((0, $23472.toggleIssueSearch)(true));
            },
            toggleShowWarning: ()=>{
                dispatch((0, $5lzYR.toggleShowWarning)());
            },
            toggleWarningByType: (type)=>{
                dispatch((0, $5lzYR.toggleWarningByType)(type));
            }
        });
    var $2b5cc0055c16c0fa$export$2e2bcd8739ae039 = $2b5cc0055c16c0fa$var$mapDispatchToProps;
});
parcelRegister("23472", function(module, exports) {
    $parcel$export(module.exports, "RESET_SEARCH_RESULTS", ()=>$25624c2332356e0f$export$ca438e92d01957dc);
    $parcel$export(module.exports, "SEARCH_ICON_CLICK", ()=>$25624c2332356e0f$export$7cbc0bf0e3faadbe);
    $parcel$export(module.exports, "SET_ACTIVE_SEARCH_RESULT_INDEX", ()=>$25624c2332356e0f$export$dee502a60050bab0);
    $parcel$export(module.exports, "SET_SEARCH_QUERY", ()=>$25624c2332356e0f$export$6c3b572d2d64ae9);
    $parcel$export(module.exports, "STARTED_SEARCH_RESULT_NAVIGATION", ()=>$25624c2332356e0f$export$d2f4281b9c017343);
    $parcel$export(module.exports, "TOGGLE_ISSUE_SEARCH", ()=>$25624c2332356e0f$export$98cb10bd2faa93c7);
    $parcel$export(module.exports, "setSearchQuery", ()=>$25624c2332356e0f$export$2cd1e14773f5e71b);
    $parcel$export(module.exports, "setActiveSearchResultIndex", ()=>$25624c2332356e0f$export$a7062054d7b425ce);
    $parcel$export(module.exports, "searchIconClick", ()=>$25624c2332356e0f$export$2aabb555469c35c);
    $parcel$export(module.exports, "startedSearchResultNavigation", ()=>$25624c2332356e0f$export$6e39a71f2e10c895);
    $parcel$export(module.exports, "toggleIssueSearch", ()=>$25624c2332356e0f$export$58338d7218e4ff1d);
    const $25624c2332356e0f$export$ca438e92d01957dc = 'state.ui.main.tabs.roadmap.scope.header.search.RESET_SEARCH_RESULTS';
    const $25624c2332356e0f$export$7cbc0bf0e3faadbe = 'state.ui.main.tabs.roadmap.scope.header.search.SEARCH_ICON_CLICK';
    const $25624c2332356e0f$export$dee502a60050bab0 = 'state.ui.main.tabs.roadmap.scope.header.search.SET_ACTIVE_SEARCH_RESULT_INDEX';
    const $25624c2332356e0f$export$6c3b572d2d64ae9 = 'state.ui.main.tabs.roadmap.scope.header.search.SET_SEARCH_QUERY';
    const $25624c2332356e0f$export$d2f4281b9c017343 = 'state.ui.main.tabs.roadmap.scope.header.search.STARTED_SEARCH_RESULT_NAVIGATION';
    const $25624c2332356e0f$export$98cb10bd2faa93c7 = 'state.ui.main.tabs.roadmap.scope.header.search.TOGGLE_ISSUE_SEARCH';
    const $25624c2332356e0f$export$2cd1e14773f5e71b = (payload)=>({
            type: $25624c2332356e0f$export$6c3b572d2d64ae9,
            payload: payload
        });
    const $25624c2332356e0f$export$a7062054d7b425ce = (payload)=>({
            type: $25624c2332356e0f$export$dee502a60050bab0,
            payload: payload
        });
    const $25624c2332356e0f$export$dc60b1e0f93b4b42 = ()=>({
            type: $25624c2332356e0f$export$ca438e92d01957dc
        });
    const $25624c2332356e0f$export$2aabb555469c35c = ()=>({
            type: $25624c2332356e0f$export$7cbc0bf0e3faadbe
        });
    const $25624c2332356e0f$export$6e39a71f2e10c895 = ()=>({
            type: $25624c2332356e0f$export$d2f4281b9c017343
        });
    const $25624c2332356e0f$export$58338d7218e4ff1d = (payload)=>({
            type: $25624c2332356e0f$export$98cb10bd2faa93c7,
            payload: payload
        });
});
parcelRegister("6IE5x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f2a3d5485b5b936$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $kWDpn = parcelRequire("kWDpn");
    var $eIyFU = parcelRequire("eIyFU");
    var $3YtPS = parcelRequire("3YtPS");
    var $3f2a3d5485b5b936$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        disabledWarnings: (0, $eIyFU.getDisabledWarnings),
        issueTypesById: (0, $kllqP.getIssueTypesById),
        issuesById: (0, $gFhwb.getIssueMapById),
        mode: (0, $1CGdp.getMode),
        projectsById: (0, $jpXKt.getProjectsById),
        showWarning: (state)=>(0, $kWDpn.getWarningViewSettings)(state).showWarning,
        warnings: (0, $eIyFU.getAggregatedWarnings)
    });
});
parcelRegister("fYlx6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$430a126d9be2abc6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $fVnbM;
    var $eCeGD;
    var $42CjB;
    var $bU3PY;
    var $34Rrn;
    var $1I7E8;
    var $cgL5K;
    var $3TyLU;
    var $1kVqg;
    var $3bDjY;
    var $4R6GH;
    var $ousew;
    var $8RXs9;
    var $gJZ5D;
    var $i2qlb = parcelRequire("i2qlb");
    var $la6bP = parcelRequire("la6bP");
    var $iXVV6;
    var $8zOmE;
    var $dCm1o;
    var $l2FUY = parcelRequire("l2FUY");
    var $6UWCS = parcelRequire("6UWCS");
    var $exJQm = parcelRequire("exJQm");
    class $430a126d9be2abc6$var$WarningCenter extends (0, $5uXOq.Component) {
        render() {
            const { warnings: warnings, showWarning: showWarning, toggleWarningByType: toggleWarningByType, disabledWarnings: disabledWarnings, issuesById: issuesById, setSearchQuery: setSearchQuery, issueTypesById: issueTypesById, projectsById: projectsById, toggleShowWarning: toggleShowWarning } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                content: ({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $l2FUY.default), {
                        focusRef: setInitialFocusRef,
                        disabledWarnings: disabledWarnings,
                        issueTypesById: issueTypesById,
                        issuesById: issuesById,
                        onTypeIdChange: this.handleTypeIdChange,
                        projectsById: projectsById,
                        setSearchQuery: setSearchQuery,
                        showWarning: showWarning,
                        toggleShowWarning: toggleShowWarning,
                        toggleWarningByType: toggleWarningByType,
                        typeId: this.state.typeId,
                        warnings: warnings
                    }),
                isOpen: this.state.isOpen,
                trigger: this.renderTriggerButton,
                shouldRenderToParent: true,
                role: "dialog",
                onClose: this.onClose,
                placement: "bottom-end"
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isOpen: false,
                typeId: null
            };
            this.buttonRef = (0, $5uXOq.createRef)();
            this.toggleWarningCenter = ()=>{
                if (this.state.isOpen) {
                    this.setState({
                        isOpen: false
                    }, ()=>{
                        !this.state.isOpen && this.buttonRef.current?.focus();
                    });
                    return;
                }
                this.setState({
                    isOpen: true
                });
                const { createAnalyticsEvent: createAnalyticsEvent = null } = this.props;
                if (!createAnalyticsEvent) return;
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).OPENED_WARNING_CENTER.split(' ');
                const analyticsEvent = createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
            };
            this.onClose = ()=>{
                this.setState({
                    isOpen: false
                }, ()=>{
                    !this.state.isOpen && this.buttonRef.current?.focus();
                });
            };
            this.handleTypeIdChange = (typeId)=>{
                this.setState({
                    typeId: typeId
                });
                if (typeof typeId !== 'string') return;
                const { createAnalyticsEvent: createAnalyticsEvent = null } = this.props;
                if (!createAnalyticsEvent) return;
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).FILTERED_WARNING_TYPE.split(' ');
                const analyticsEvent = createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                });
                const warningType = (0, $la6bP.WARNING_TYPE_NUMBER_MAP)[typeId] || null;
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                    warningType: warningType
                });
            };
            this.renderTriggerButton = (triggerProps)=>{
                const { intl: intl, mode: mode, showWarning: showWarning } = this.props;
                const { ref: ref, ...restTriggerProps } = triggerProps || {
                    ref: null
                };
                const WarningIconComponent = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
                        label: "",
                        color: showWarning ? "var(--ds-icon-warning, #E56910)" : 'currentColor'
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("34Rrn"))))), {
                        label: "",
                        color: showWarning ? "var(--ds-icon-warning, #E56910)" : undefined
                    }), [
                    showWarning
                ]);
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.warning-centre-button",
                    ref: ref
                }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, mode !== (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) && mode !== (0, $ab4be2e1e204af69$export$b07c15b79440feb8) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...restTriggerProps,
                    label: intl.formatMessage((0, $6UWCS.default).warningsButtonLabel),
                    onClick: this.toggleWarningCenter,
                    ref: this.buttonRef,
                    icon: WarningIconComponent,
                    isTooltipDisabled: false,
                    testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.custom-theme-button"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3TyLU")).Hide), {
                    above: "lg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...restTriggerProps,
                    label: intl.formatMessage((0, $6UWCS.default).warningsButtonLabel),
                    onClick: this.toggleWarningCenter,
                    ref: this.buttonRef,
                    icon: WarningIconComponent,
                    isTooltipDisabled: false,
                    testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.custom-theme-button"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kVqg")).Show), {
                    above: "lg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                    ...restTriggerProps,
                    appearance: "default",
                    onClick: this.toggleWarningCenter,
                    ref: this.buttonRef,
                    iconBefore: showWarning ? WarningIconComponent : undefined
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    color: showWarning ? 'color.text.accent.orange' : undefined,
                    weight: "medium"
                }, intl.formatMessage((0, $6UWCS.default).warningsButtonLabel)))))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                    ...restTriggerProps,
                    appearance: "default",
                    onClick: this.toggleWarningCenter,
                    ref: this.buttonRef,
                    iconBefore: showWarning ? WarningIconComponent : undefined
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    color: showWarning ? 'color.text.accent.orange' : undefined,
                    weight: "medium"
                }, intl.formatMessage((0, $6UWCS.default).warningsButtonLabel)))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, mode !== (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) && mode !== (0, $ab4be2e1e204af69$export$b07c15b79440feb8) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $exJQm.warningsButtonIconOnly
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $6UWCS.default).warningsButtonLabel)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: showWarning ? 'warning' : 'default',
                    ...restTriggerProps,
                    ref: this.buttonRef,
                    onClick: this.toggleWarningCenter,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
                        label: intl.formatMessage((0, $6UWCS.default).warningsButtonLabel),
                        color: showWarning ? "var(--ds-icon-warning, #E56910)" : undefined,
                        LEGACY_primaryColor: showWarning ? `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})` : `var(--ds-icon-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N200})`,
                        spacing: "spacious",
                        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.custom-theme-button"
                    })
                }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: mode !== (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) && mode !== (0, $ab4be2e1e204af69$export$b07c15b79440feb8) ? $exJQm.warningsButtonIconLabel : ''
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: showWarning ? 'warning' : 'default',
                    ...restTriggerProps,
                    ref: this.buttonRef,
                    onClick: this.toggleWarningCenter,
                    iconBefore: showWarning ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
                        label: "",
                        color: "var(--ds-icon-warning, #E56910)",
                        LEGACY_primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
                    }) : undefined
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $6UWCS.default).warningsButtonLabel)))));
            };
        }
    }
    const $430a126d9be2abc6$var$WarningCenterWithIntl = (0, (0, parcelRequire("8RXs9")).default)((0, (0, parcelRequire("cb25w")).default)()($430a126d9be2abc6$var$WarningCenter));
    var $430a126d9be2abc6$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "warningsCenter",
            sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($430a126d9be2abc6$var$WarningCenterWithIntl, props));
});
parcelRegister("3TyLU", function(module, exports) {
    $parcel$export(module.exports, "Hide", ()=>$f53ed0348d5d3206$export$bed28288a051538);
    var $f8Sb3;
    var $8CUq3;
    var $2pf2j;
    const $f53ed0348d5d3206$var$hideAboveQueries = (0, (0, parcelRequire("2pf2j")).UNSAFE_buildAboveMediaQueryCSS)({
        display: 'none'
    });
    const $f53ed0348d5d3206$var$hideBelowQueries = (0, (0, parcelRequire("2pf2j")).UNSAFE_buildBelowMediaQueryCSS)({
        display: 'none'
    });
    const $f53ed0348d5d3206$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
        const resolvedStyles = (0, (0, parcelRequire("8CUq3")).parseXcss)(xcss);
        return (0, (0, parcelRequire("f8Sb3")).jsx)(AsElement, {
            className: resolvedStyles.static,
            css: [
                above && $f53ed0348d5d3206$var$hideAboveQueries[above],
                below && $f53ed0348d5d3206$var$hideBelowQueries[below],
                resolvedStyles.emotion
            ]
        }, children);
    };
});
parcelRegister("l2FUY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d09cc4b1794f64e8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3gt3f;
    var $8RBk4;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $dTlW6;
    var $4R6GH;
    var $5Zxxp;
    var $ousew;
    var $koVbs;
    var $aCpcO;
    var $i2qlb = parcelRequire("i2qlb");
    var $qjIxt = parcelRequire("qjIxt");
    var $la6bP = parcelRequire("la6bP");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $4cwkM = parcelRequire("4cwkM");
    var $8zOmE;
    var $2NMNM;
    var $l5rxb = parcelRequire("l5rxb");
    var $hHMgk = parcelRequire("hHMgk");
    var $iFkVG = parcelRequire("iFkVG");
    const $d09cc4b1794f64e8$var$Content = ({ warnings: warnings, toggleWarningByType: toggleWarningByType, disabledWarnings: disabledWarnings, issuesById: issuesById, setSearchQuery: setSearchQuery, issueTypesById: issueTypesById, projectsById: projectsById, typeId: typeId, onTypeIdChange: onTypeIdChange, showWarning: showWarning, toggleShowWarning: toggleShowWarning, focusRef: focusRef })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getOnIssueItemClick = (issue)=>()=>{
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).LOCATED_WARNING_ISSUE_ITEM.split(' ');
                const analyticsEvent = createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                });
                const warningType = typeof typeId === 'string' ? (0, $la6bP.WARNING_TYPE_NUMBER_MAP)[typeId] || null : null;
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                    warningType: warningType
                });
                setSearchQuery(issue.summary);
            };
        const getOnToggleWarningByType = (key, nextState)=>()=>{
                const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).TOGGLED_WARNING_TYPE.split(' ');
                const analyticsEvent = createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                });
                const warningType = (0, $la6bP.WARNING_TYPE_NUMBER_MAP)[key] || null;
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                    selectedOption: nextState ? 1 : 0,
                    warningType: warningType
                });
                toggleWarningByType(key);
            };
        const getWarningDialogContent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $d09cc4b1794f64e8$var$warningsDialogHeaderStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $hHMgk.default).warningsDialogHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.100"
            }, Object.entries((0, $qjIxt.WarningTypes)).map(([key, value])=>{
                if (!(0, (0, parcelRequire("4R6GH")).fg)('due_date_warning_on_plan_timeline') && key === (0, $la6bP.START_DATE_AFTER_END_DATE)) return null;
                const { header: header } = value;
                const isEnabled = !(disabledWarnings || []).includes(key);
                const issueCount = warnings[key] && warnings[key].length || 0;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                    key: key,
                    spread: "space-between"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $d09cc4b1794f64e8$var$warningToggleAndTextStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dTlW6")).default), {
                    isChecked: isEnabled,
                    onChange: getOnToggleWarningByType(key, !isEnabled),
                    testId: `portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.toggle-warning-type--${key}`,
                    label: formatMessage(header)
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), header)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, isEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, issueCount === 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    isDisabled: true,
                    className: $iFkVG.disabledWarningButton
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $hHMgk.default).zeroCountWarningText)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    onClick: ()=>onTypeIdChange(key),
                    appearance: "link",
                    isDisabled: issueCount === 0,
                    className: $iFkVG.affectedIssuesCount,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                        label: ""
                    })
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, $hHMgk.default).warningCountText,
                    values: {
                        count: issueCount
                    }
                }))), !isEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                    appearance: "link",
                    isDisabled: true,
                    className: $iFkVG.disabledWarningButton
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $hHMgk.default).disabledIssueStatusText))));
            })));
        const getTypeDefinedWarningDialogContent = (typeId)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-type-modal"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $d09cc4b1794f64e8$var$issueListHeaderStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $qjIxt.WarningTypes)[typeId].header), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $d09cc4b1794f64e8$var$warningDescriptionStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $qjIxt.WarningTypes)[typeId].description))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $d09cc4b1794f64e8$var$issueListContainerStyles
            }, (warnings[typeId] || []).map((issueId)=>{
                const issue = issuesById[issueId];
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $l5rxb.default), {
                    key: issueId,
                    onClick: getOnIssueItemClick(issue),
                    issue: issue,
                    projectKey: projectsById[issue.project.toString()].key,
                    issueType: issueTypesById[issue.type.toString()]
                });
            })));
        let content = getWarningDialogContent();
        if ((0, $4nDwW.isDefined)(typeId) && typeId !== '') content = getTypeDefinedWarningDialogContent(typeId);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-centre-modal",
            xcss: $d09cc4b1794f64e8$var$modalContentHeightStyles
        }, (!(0, $4nDwW.isDefined)(typeId) || typeId === '') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d09cc4b1794f64e8$var$topDescriptionStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d09cc4b1794f64e8$var$warningCenterHeaderStyles,
            as: "h2"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $hHMgk.default).warningCenterHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d09cc4b1794f64e8$var$warningCenterIntroStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $hHMgk.default).warningsDialogDescriptionAndDocumentationLink,
            values: {
                link: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Zxxp")).default), {
                    articleId: (0, $TTKUQ.IPH_IDS).WARNING_CENTER,
                    fallbackComponent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cwkM.default), {
                        href: (0, $4cwkM.default).URLs.warningsDialog,
                        tagRef: focusRef
                    }, formatMessage((0, $hHMgk.default).iphLink)),
                    appearance: "link",
                    spacing: "none"
                }, formatMessage((0, $hHMgk.default).iphLink))
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d09cc4b1794f64e8$var$toggleWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dTlW6")).default), {
            isChecked: showWarning,
            onChange: toggleShowWarning,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.toggle-warnings-visibility",
            label: formatMessage((0, $hHMgk.default).showWarningsOnYourTimeline)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $hHMgk.default).showWarningsOnYourTimeline))), (0, $4nDwW.isDefined)(typeId) && typeId !== '' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d09cc4b1794f64e8$var$backButtonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "link",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3gt3f"))))), {
                label: ""
            }),
            onClick: ()=>onTypeIdChange(null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $hHMgk.default).goBackToOverview))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d09cc4b1794f64e8$var$contentBoxStyles
        }, content));
    };
    var $d09cc4b1794f64e8$export$2e2bcd8739ae039 = $d09cc4b1794f64e8$var$Content;
    const $d09cc4b1794f64e8$var$warningToggleAndTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        alignItems: 'center'
    });
    const $d09cc4b1794f64e8$var$warningsDialogHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        fontWeight: '600',
        paddingLeft: 'space.075',
        paddingBottom: 'space.150'
    });
    const $d09cc4b1794f64e8$var$issueListHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.250'
    });
    const $d09cc4b1794f64e8$var$warningDescriptionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtle',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $d09cc4b1794f64e8$var$issueListContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxHeight: '400px',
        overflowY: 'auto'
    });
    const $d09cc4b1794f64e8$var$modalContentHeightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxHeight: 'calc(100vh - 188px)'
    });
    const $d09cc4b1794f64e8$var$topDescriptionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.200',
        backgroundColor: 'color.background.neutral'
    });
    const $d09cc4b1794f64e8$var$warningCenterHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.150',
        font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: 'color.text',
        marginLeft: 'space.075'
    });
    const $d09cc4b1794f64e8$var$warningCenterIntroStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.100',
        marginLeft: 'space.075'
    });
    const $d09cc4b1794f64e8$var$toggleWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignItems: 'center',
        display: 'flex'
    });
    const $d09cc4b1794f64e8$var$backButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.150'
    });
    const $d09cc4b1794f64e8$var$contentBoxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.200',
        width: '595px'
    });
});
parcelRegister("dTlW6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3db77843cf29c460$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $7fA4P;
    var $aFYTH;
    var $lahQ6;
    var $hzG2v;
    const $3db77843cf29c460$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $3db77843cf29c460$var$analyticsAttributes = {
        componentName: 'toggle',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $3db77843cf29c460$var$iconSizeMap = {
        regular: 'small',
        large: 'medium'
    };
    const $3db77843cf29c460$var$Toggle = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)((props, ref)=>{
        const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
        const isControlled = typeof isChecked === 'undefined';
        const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
        const handleBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnBlur,
            action: 'blur',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedFocus,
            action: 'focus',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleChange = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event, analyticsEvent)=>{
                if (isControlled) setChecked((checked)=>!checked);
                return providedChange(event, analyticsEvent);
            },
            action: 'change',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const shouldChecked = isControlled ? checked : isChecked;
        const controlProps = {
            'data-checked': shouldChecked ? shouldChecked : undefined,
            'data-disabled': isDisabled ? isDisabled : undefined,
            'data-size': size,
            'data-testid': testId ? testId : undefined
        };
        const toggleStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hzG2v")).getStyles)(size), [
            size
        ]);
        const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
        const labelId = (0, (0, parcelRequire("9KnKW")).useId)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            ...controlProps,
            css: toggleStyles
        }, label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: labelId,
            hidden: true
        }, label) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: ref,
            checked: shouldChecked,
            disabled: isDisabled,
            id: id,
            name: name,
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus,
            type: "checkbox",
            value: value,
            "data-testid": testId && `${testId}--input`,
            "aria-labelledby": label ? labelId : undefined,
            "aria-describedby": descriptionId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: !shouldChecked,
            position: "left"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("7fA4P"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-check-icon`
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: shouldChecked,
            position: "right"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("aFYTH"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-cross-icon`
        }))));
    }));
    $3db77843cf29c460$var$Toggle.displayName = 'Toggle';
    var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;
});
parcelRegister("7fA4P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));
    var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
    function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>$5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
        }, props));
    $5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;
});
parcelRegister("aFYTH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c5cf8a572bea882$var$_react = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c5cf8a572bea882$var$_cross = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("bjGSs")));
    var $7c5cf8a572bea882$var$_close = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("2C7j9")));
    function $7c5cf8a572bea882$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c5cf8a572bea882$var$CrossIcon = (props)=>$7c5cf8a572bea882$var$_react.default.createElement($7c5cf8a572bea882$var$_cross.default, Object.assign({
            LEGACY_fallbackIcon: $7c5cf8a572bea882$var$_close.default
        }, props));
    $7c5cf8a572bea882$var$CrossIcon.Name = 'CrossIconMigration';
    var $7c5cf8a572bea882$var$_default = module.exports.default = $7c5cf8a572bea882$var$CrossIcon;
});
parcelRegister("lahQ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca1cdaa1eb34599d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    const $ca1cdaa1eb34599d$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'opacity 0.2s ease',
        position: 'absolute',
        insetBlockStart: 'space.025'
    });
    const $ca1cdaa1eb34599d$var$iconContainerRegularStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '16px',
        height: '16px'
    });
    const $ca1cdaa1eb34599d$var$iconContainerLargeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '20px',
        height: '20px'
    });
    const $ca1cdaa1eb34599d$var$hiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $ca1cdaa1eb34599d$var$leftStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineStart: '3px'
    });
    const $ca1cdaa1eb34599d$var$rightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineEnd: '3px'
    });
    const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: [
                $ca1cdaa1eb34599d$var$iconContainerStyles,
                isHidden && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$hiddenStyles,
                size === 'regular' && $ca1cdaa1eb34599d$var$iconContainerRegularStyles,
                size === 'large' && $ca1cdaa1eb34599d$var$iconContainerLargeStyles,
                position === 'left' && $ca1cdaa1eb34599d$var$leftStyles,
                position === 'right' && $ca1cdaa1eb34599d$var$rightStyles
            ]
        }, children);
    };
    var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;
});
parcelRegister("hzG2v", function(module, exports) {
    $parcel$export(module.exports, "getStyles", ()=>$3af6a5b9114f4fd0$export$ffd58b7f6f099a57);
    var $f8Sb3;
    var $VSDnB;
    var $k5uoT;
    var $3VjLl;
    const $3af6a5b9114f4fd0$var$globalGridSize = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $3af6a5b9114f4fd0$var$dimensions = {
        regular: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 4
        },
        large: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2 + $3af6a5b9114f4fd0$var$globalGridSize / 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 5
        }
    };
    const $3af6a5b9114f4fd0$var$getHeight = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].height;
    const $3af6a5b9114f4fd0$var$getWidth = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].width;
    const $3af6a5b9114f4fd0$var$borderWidth = 2;
    const $3af6a5b9114f4fd0$var$paddingUnitless = $3af6a5b9114f4fd0$var$globalGridSize / 4;
    const $3af6a5b9114f4fd0$var$transition = 'transform 0.2s ease';
    const $3af6a5b9114f4fd0$export$ffd58b7f6f099a57 = (size)=>{
        const colors = (0, (0, parcelRequire("3VjLl")).getColors)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            boxSizing: 'content-box',
            display: 'inline-block',
            padding: $3af6a5b9114f4fd0$var$borderWidth,
            margin: $3af6a5b9114f4fd0$var$borderWidth,
            backgroundClip: 'content-box',
            backgroundColor: colors.backgroundColorUnchecked,
            borderRadius: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid transparent`,
            height: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            position: 'relative',
            transition: `${$3af6a5b9114f4fd0$var$transition}`,
            width: `${$3af6a5b9114f4fd0$var$getWidth({
                size: size
            })}px`,
            '&[data-checked]': {
                backgroundColor: colors.backgroundColorChecked,
                color: colors.iconColorChecked
            },
            '&[data-disabled]:not([data-checked])': {
                backgroundColor: colors.backgroundColorUncheckedDisabled
            },
            '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            '&:focus-within': {
                border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid ${colors.borderColorFocus}`
            },
            '&:hover': {
                backgroundColor: colors.backgroundColorUncheckedHover,
                cursor: 'pointer'
            },
            '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
                cursor: 'not-allowed'
            },
            '&[data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedHover
            },
            '&:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorUncheckedHover
            },
            '&[data-disabled]:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            color: colors.iconColorUnchecked,
            '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
                color: colors.iconColorDisabled
            },
            'input[type="checkbox"]': {
                opacity: 0,
                margin: 0,
                padding: 0,
                border: 'none',
                '&:focus': {
                    outline: 'none !important'
                }
            },
            '::before': {
                backgroundColor: colors.handleBackgroundColor,
                borderRadius: "var(--ds-border-radius-circle, 50%)",
                content: '""',
                position: 'absolute',
                transform: 'initial',
                transition: $3af6a5b9114f4fd0$var$transition,
                insetBlockEnd: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`,
                height: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                width: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                insetInlineStart: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`
            },
            '&[data-checked]::before': {
                backgroundColor: colors.handleBackgroundColorChecked,
                transform: `translateX(${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                })}px)`
            },
            '&[data-disabled]::before': {
                backgroundColor: colors.handleBackgroundColorDisabled,
                zIndex: 1
            },
            ...size === 'large' && !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && {
                '> span > span': {
                    height: '20px',
                    width: '20px'
                }
            },
            '@media screen and (forced-colors: active)': {
                '::before': {
                    filter: 'grayscale(100%) invert(1)'
                },
                '&:focus-within': {
                    outline: '1px solid'
                }
            }
        });
    };
});
parcelRegister("3VjLl", function(module, exports) {
    $parcel$export(module.exports, "getColors", ()=>$7761f9acd89472cc$export$6cee60e8aa85e528);
    const $7761f9acd89472cc$var$colorMap = {
        backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
        backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
        backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
        backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        borderColorFocus: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        iconColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        iconColorDisabled: `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    };
    const $7761f9acd89472cc$export$6cee60e8aa85e528 = ()=>$7761f9acd89472cc$var$colorMap;
});
parcelRegister("l5rxb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6011cf2b5d33c51$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8CUq3;
    var $2FvnI;
    var $4FQBz = parcelRequire("4FQBz");
    function $b6011cf2b5d33c51$export$2e2bcd8739ae039(props) {
        const { issue: issue, issueType: issueType, projectKey: projectKey, onClick: onClick } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4FQBz.issueTitle,
            onClick: onClick,
            tabIndex: 0,
            role: "button",
            onKeyPress: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4FQBz.issueIcon,
            style: {
                backgroundImage: issueType && `url(${issueType.iconUrl})`
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $4FQBz.issueSummary,
            title: issue.summary
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2FvnI")).default), {
            issueKey: issue.issueKey,
            projectKey: projectKey,
            xcssStyles: $b6011cf2b5d33c51$var$issueLinkStyles
        }), issue.summary));
    }
    const $b6011cf2b5d33c51$var$issueLinkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'nowrap',
        marginRight: 'space.075'
    });
});
parcelRegister("4FQBz", function(module, exports) {
    $parcel$export(module.exports, "issueIcon", ()=>$3673cbfcb853e53b$export$415983cbc1f2b3fe, (v)=>$3673cbfcb853e53b$export$415983cbc1f2b3fe = v);
    $parcel$export(module.exports, "issueSummary", ()=>$3673cbfcb853e53b$export$7c7bc027bbbea103, (v)=>$3673cbfcb853e53b$export$7c7bc027bbbea103 = v);
    $parcel$export(module.exports, "issueTitle", ()=>$3673cbfcb853e53b$export$12781bd67c11efd8, (v)=>$3673cbfcb853e53b$export$12781bd67c11efd8 = v);
    var $3673cbfcb853e53b$export$415983cbc1f2b3fe;
    var $3673cbfcb853e53b$export$7c7bc027bbbea103;
    var $3673cbfcb853e53b$export$12781bd67c11efd8;
    $3673cbfcb853e53b$export$415983cbc1f2b3fe = `LFMl9q_issueIcon`;
    $3673cbfcb853e53b$export$7c7bc027bbbea103 = `LFMl9q_issueSummary`;
    $3673cbfcb853e53b$export$12781bd67c11efd8 = `LFMl9q_issueTitle`;
});
parcelRegister("hHMgk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1812172f6b2dead1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1812172f6b2dead1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        warningCenterHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-center-header",
            "defaultMessage": "Warning center"
        },
        warningsDialogHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warnings-dialog-header",
            "defaultMessage": "Show on timeline"
        },
        disabledIssueStatusText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.disabled-issue-status-text",
            "defaultMessage": "disabled"
        },
        warningCountText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-count-text",
            "defaultMessage": "{count, plural, one {# issue} other {# issues}}"
        },
        zeroCountWarningText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.zero-count-warning-text",
            "defaultMessage": "-"
        },
        warningsDialogDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warnings-dialog-description",
            "defaultMessage": "Configure which warnings you want to see in your plan. {link}"
        },
        warningsDialogDescriptionAndDocumentationLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warnings-dialog-description-and-documentation-link",
            "defaultMessage": "Configure which warnings you want to see in your plan. Use the filter menu to only show issues with warnings. {link}"
        },
        iphLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.iph-link",
            "defaultMessage": "How do I resolve these warnings?"
        },
        showWarningsOnYourTimeline: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.show-warnings-on-your-timeline",
            "defaultMessage": "Show warnings on your timeline"
        },
        goBackToOverview: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.go-back-to-overview",
            "defaultMessage": "Go back to overview"
        }
    });
});
parcelRegister("iFkVG", function(module, exports) {
    $parcel$export(module.exports, "affectedIssuesCount", ()=>$d96c4a734daded63$export$7beaea76dcc76433, (v)=>$d96c4a734daded63$export$7beaea76dcc76433 = v);
    $parcel$export(module.exports, "disabledWarningButton", ()=>$d96c4a734daded63$export$3b51cc1f96246e43, (v)=>$d96c4a734daded63$export$3b51cc1f96246e43 = v);
    var $d96c4a734daded63$export$7beaea76dcc76433;
    var $d96c4a734daded63$export$3b51cc1f96246e43;
    $d96c4a734daded63$export$7beaea76dcc76433 = `_6nmt9a_affectedIssuesCount`;
    $d96c4a734daded63$export$3b51cc1f96246e43 = `_6nmt9a_disabledWarningButton`;
});
parcelRegister("6UWCS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd2378119bb4b1a2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fd2378119bb4b1a2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        warningsButtonLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.warnings-button-label",
            "defaultMessage": "Warnings"
        }
    });
});
parcelRegister("exJQm", function(module, exports) {
    $parcel$export(module.exports, "warningsButtonIconLabel", ()=>$a967b558d76f5e51$export$fb2e2236de94c4bc, (v)=>$a967b558d76f5e51$export$fb2e2236de94c4bc = v);
    $parcel$export(module.exports, "warningsButtonIconOnly", ()=>$a967b558d76f5e51$export$be7fa4316fd602e4, (v)=>$a967b558d76f5e51$export$be7fa4316fd602e4 = v);
    var $a967b558d76f5e51$export$fb2e2236de94c4bc;
    var $a967b558d76f5e51$export$be7fa4316fd602e4;
    $a967b558d76f5e51$export$fb2e2236de94c4bc = `Tcej8q_warningsButtonIconLabel`;
    $a967b558d76f5e51$export$be7fa4316fd602e4 = `Tcej8q_warningsButtonIconOnly`;
});
parcelRegister("7IfyA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fcc6a6ec5ec33f4$export$2e2bcd8739ae039);
    var $bC2fB;
    var $c0i7H = parcelRequire("c0i7H");
    var $615Dp = parcelRequire("615Dp");
    var $dAM3B = parcelRequire("dAM3B");
    var $3fcc6a6ec5ec33f4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $615Dp.default), (0, $c0i7H.default))((0, $dAM3B.default));
});
parcelRegister("c0i7H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$969a95d2599b2774$export$2e2bcd8739ae039);
    var $aqDY3 = parcelRequire("aqDY3");
    var $c5JsS = parcelRequire("c5JsS");
    var $969a95d2599b2774$export$2e2bcd8739ae039 = {
        discardChanges: $aqDY3.discardChanges,
        saveView: $aqDY3.saveView,
        saveViewAs: $aqDY3.saveViewAs,
        removeError: $c5JsS.removeError,
        deleteView: $aqDY3.deleteView,
        setSaveViewAsDialogStatus: $c5JsS.setSaveViewAsDialogStatus,
        switchView: $aqDY3.switchView
    };
});
parcelRegister("615Dp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0882f1a41213bfb$export$2e2bcd8739ae039);
    var $e5wyW;
    var $4R6GH;
    var $1CGdp = parcelRequire("1CGdp");
    var $7QGzp = parcelRequire("7QGzp");
    var $3YtPS = parcelRequire("3YtPS");
    const $e0882f1a41213bfb$var$selector = (0, $3YtPS.createStructuredSelector)({
        views: (0, $7QGzp.getViews),
        activeView: (0, $7QGzp.getActiveView),
        errors: (0, $7QGzp.getErrors),
        saveViewAsDialogStatus: (0, $7QGzp.getSaveViewAsDialogStatus),
        readOnly: (0, $1CGdp.isReadOnly),
        isSmartLink: $1CGdp.isSmartLink
    });
    const $e0882f1a41213bfb$var$selectorOld = (0, $3YtPS.createStructuredSelector)({
        views: (0, $7QGzp.getViews),
        activeView: (0, $7QGzp.getActiveView),
        errors: (0, $7QGzp.getErrors),
        saveViewAsDialogStatus: (0, $7QGzp.getSaveViewAsDialogStatus),
        readOnly: (0, $1CGdp.isReadOnly)
    });
    var $e0882f1a41213bfb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans'), $e0882f1a41213bfb$var$selector, $e0882f1a41213bfb$var$selectorOld);
});
parcelRegister("dAM3B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53a2d9a577a73916$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $5Fk4Z;
    var $eTXmK;
    var $4R6GH;
    var $CLvmV = parcelRequire("CLvmV");
    var $1Cyfv = parcelRequire("1Cyfv");
    var $6Z2Mh = parcelRequire("6Z2Mh");
    var $gqWZS = parcelRequire("gqWZS");
    var $h43GJ = parcelRequire("h43GJ");
    var $kYwHG = parcelRequire("kYwHG");
    var $iXvsQ = parcelRequire("iXvsQ");
    var $8Q3SD = parcelRequire("8Q3SD");
    var $sSwfb = parcelRequire("sSwfb");
    function $53a2d9a577a73916$var$getDeleteDefaultViewError(errors) {
        const err = errors.find((one)=>one instanceof (0, $CLvmV.DeleteErrorDefaultView));
        if (!err) return null;
        if (!(err instanceof (0, $CLvmV.DeleteErrorDefaultView))) return null;
        return err;
    }
    function $53a2d9a577a73916$var$getConflictError(errors) {
        const err = errors.find((one)=>one instanceof (0, $CLvmV.UpdateErrorConflicted));
        if (!err) return null;
        if (!(err instanceof (0, $CLvmV.UpdateErrorConflicted))) return null;
        return err;
    }
    function $53a2d9a577a73916$var$getNonExistingError(errors) {
        const err = errors.find((one)=>one instanceof (0, $CLvmV.UpdateErrorNotExists));
        if (!err) return null;
        if (!(err instanceof (0, $CLvmV.UpdateErrorNotExists))) return null;
        return err;
    }
    function $53a2d9a577a73916$var$getDuplicateViewError(errors) {
        const err = errors.find((one)=>one instanceof (0, $CLvmV.SaveAsErrorDuplicateView));
        if (!err) return null;
        if (!(err instanceof (0, $CLvmV.SaveAsErrorDuplicateView))) return null;
        return err;
    }
    function $53a2d9a577a73916$export$2e2bcd8739ae039({ views: views, activeView: activeView, errors: errors, saveView: saveView, saveViewAs: saveViewAs, discardChanges: discardChanges, deleteView: deleteView, removeError: removeError, duplicateSection: duplicateSection, saveViewAsDialogStatus: saveViewAsDialogStatus, setSaveViewAsDialogStatus: setSaveViewAsDialogStatus, readOnly: readOnly, switchView: switchView, isSmartLink: isSmartLink }) {
        const [saving, setSaving] = (0, $5uXOq.useState)(false);
        const [deleting, setDeleting] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (saveViewAsDialogStatus !== 'CLOSED') {
                const firstChild = buttonRef.current?.firstElementChild;
                if (firstChild instanceof HTMLElement && firstChild.focus) firstChild.focus();
            }
        }, [
            saveViewAsDialogStatus
        ]);
        const handleActiveViewChange = (e, id)=>{
            if (id !== activeView.id) {
                (0, (0, parcelRequire("eTXmK")).default)((0, $1Cyfv.KEYS).SWITCH_VIEW, e.timeStamp);
                switchView(id);
            }
        };
        const openSaveAsDialog = ()=>{
            setSaveViewAsDialogStatus('OPEN');
        };
        const duplicateViewError = $53a2d9a577a73916$var$getDuplicateViewError(errors);
        const closeSaveAsDialog = ()=>{
            setSaveViewAsDialogStatus('CLOSED');
            if (duplicateViewError) removeError(duplicateViewError);
        };
        const buttonRef = (0, $5uXOq.useRef)(null);
        const handleRequestSaveAs = ({ name: name, asDefault: asDefault })=>{
            saveViewAs({
                name: name,
                asDefault: asDefault,
                duplicateSection: duplicateSection
            });
        };
        const openSavingDialog = ()=>setSaving(true);
        const closeSavingDialog = ()=>setSaving(false);
        const confirmSaving = ()=>{
            if (activeView.id === (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28)) return openSaveAsDialog();
            saveView({
                overwrite: false
            });
            closeSavingDialog();
        };
        const confirmDiscarding = ()=>{
            discardChanges(activeView.id);
        };
        const openDeletingDialog = ()=>setDeleting(true);
        const closeDeletingDialog = ()=>setDeleting(false);
        const confirmDeleting = ()=>{
            deleteView(activeView.id);
            closeDeletingDialog();
        };
        const conflictError = $53a2d9a577a73916$var$getConflictError(errors);
        const closeConflictDialog = ()=>{
            if (conflictError) removeError(conflictError);
        };
        const handleConflictRequestSaveAs = ()=>{
            closeConflictDialog();
            openSaveAsDialog();
        };
        const handleConflictRequestDiscardChanges = ()=>{
            closeConflictDialog();
            discardChanges(activeView.id);
        };
        const handleConflictRequestOverwrite = ()=>{
            closeConflictDialog();
            saveView({
                overwrite: true
            });
        };
        const nonExistingError = $53a2d9a577a73916$var$getNonExistingError(errors);
        const closeNonExistingDialog = ()=>{
            if (nonExistingError) removeError(nonExistingError);
        };
        const handleNonExistingRequestSaveAs = ()=>{
            closeNonExistingDialog();
            openSaveAsDialog();
        };
        const handleNonExistingRequestDiscardChanges = ()=>{
            closeNonExistingDialog();
            deleteView(activeView.id, false);
        };
        const handleTitleChange = ()=>{
            if (duplicateViewError) removeError(duplicateViewError);
        };
        const deleteDefaultViewError = $53a2d9a577a73916$var$getDeleteDefaultViewError(errors);
        const closeDeleteErrorNotification = ()=>{
            if (deleteDefaultViewError) removeError(deleteDefaultViewError);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: "view-actions"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Q3SD.default), {
            views: views,
            isReadOnly: readOnly,
            onRequestDiscardChanges: confirmDiscarding,
            onRequestViewChange: handleActiveViewChange,
            onRequestSave: openSavingDialog,
            onRequestSaveAs: openSaveAsDialog,
            onRequestDelete: openDeletingDialog,
            buttonRef: buttonRef,
            ...(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? {
                isSmartLink: isSmartLink
            } : {}
        }), !(0, parcelRequire("3nPAF")).default(views) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, saving && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $sSwfb.default), {
            onConfirm: confirmSaving,
            onClose: closeSavingDialog,
            viewName: activeView.name
        }), saveViewAsDialogStatus !== 'CLOSED' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iXvsQ.default), {
            hasDuplicateViewError: !!duplicateViewError,
            isSaving: saveViewAsDialogStatus === 'SAVING',
            onChange: handleTitleChange,
            onSubmit: handleRequestSaveAs,
            onClose: closeSaveAsDialog
        }), deleting && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $h43GJ.default), {
            viewName: activeView.name,
            onConfirm: confirmDeleting,
            onClose: closeDeletingDialog
        }), conflictError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $6Z2Mh.default), {
            conflictError: conflictError,
            onRequestOverwrite: handleConflictRequestOverwrite,
            onRequestSaveAs: handleConflictRequestSaveAs,
            onRequestDiscardChanges: handleConflictRequestDiscardChanges,
            onClose: closeConflictDialog
        }), nonExistingError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kYwHG.default), {
            viewName: nonExistingError.viewName,
            onRequestSaveAs: handleNonExistingRequestSaveAs,
            onRequestDiscardChanges: handleNonExistingRequestDiscardChanges,
            onClose: closeNonExistingDialog
        }), deleteDefaultViewError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $gqWZS.default), {
            viewName: deleteDefaultViewError.viewName,
            dismissFlag: closeDeleteErrorNotification
        }))));
    }
});
parcelRegister("6Z2Mh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$573c37a53821523f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $cgL5K;
    var $jouoW;
    var $9fuVs;
    var $koVbs;
    var $gh61P;
    var $aipk9;
    var $ihPUd = parcelRequire("ihPUd");
    var $hnGYY = parcelRequire("hnGYY");
    var $gLnKt = parcelRequire("gLnKt");
    var $lV7zB = parcelRequire("lV7zB");
    function $573c37a53821523f$export$2e2bcd8739ae039({ conflictError: { viewName: viewName, modifiedBy: modifiedBy, modifiedAt: modifiedAt }, onClose: onClose, onRequestOverwrite: onRequestOverwrite, onRequestSaveAs: onRequestSaveAs, onRequestDiscardChanges: onRequestDiscardChanges }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { formatTimestamp: formatTimestamp } = (0, (0, parcelRequire("aipk9")).useDateFormatter)();
        const options = [
            {
                message: (0, $gLnKt.default).overwrite,
                action: onRequestOverwrite,
                isFocused: true
            },
            {
                message: (0, $gLnKt.default).saveAs,
                action: onRequestSaveAs,
                isFocused: false
            },
            {
                message: (0, $gLnKt.default).discardChanges,
                action: onRequestDiscardChanges,
                isFocused: false
            }
        ];
        const [selectedIndex, setSelectedIndex] = (0, $5uXOq.useState)(-1);
        const handleRadioButtonChange = (idx)=>()=>setSelectedIndex(idx);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: onClose,
            shouldCloseOnOverlayClick: true,
            shouldCloseOnEscapePress: true,
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $gLnKt.default).heading))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, formatMessage((0, $gLnKt.default).message, {
            name: viewName,
            strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "strong"
                }, chunks)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lV7zB.updatedInfoGroup
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lV7zB.headersColor
        }, formatMessage((0, $gLnKt.default).modifiedByHeader)), (0, $hnGYY.ViewUser)(modifiedBy)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lV7zB.modifiedAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lV7zB.headersColor
        }, formatMessage((0, $gLnKt.default).modifiedAtHeader)), formatTimestamp(modifiedAt.getTime() - modifiedAt.getTimezoneOffset() * 60000, (0, (0, parcelRequire("gh61P")).longDateTimeFormat)))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lV7zB.actionGroup
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$lV7zB.actionGroupHeader} ${$lV7zB.headersColor}`
        }, formatMessage((0, $gLnKt.default).actionGroupHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lV7zB.actionGroupRadios
        }, options.map(({ message: message }, idx)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                isChecked: idx === selectedIndex,
                key: idx,
                label: formatMessage(message),
                onChange: handleRadioButtonChange(idx)
            }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            isDisabled: selectedIndex === -1,
            onClick: options[selectedIndex] && options[selectedIndex].action
        }, formatMessage((0, $ihPUd.default).confirm)))));
    }
});
parcelRegister("hnGYY", function(module, exports) {
    $parcel$export(module.exports, "ViewUser", ()=>$ae4b32217b042f2c$export$f1f3b3137c27ba7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $3bDjY;
    var $lDESc = parcelRequire("lDESc");
    const $ae4b32217b042f2c$export$f1f3b3137c27ba7d = (user)=>user ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: user.email
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $lDESc.avatarWithTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            src: user.avatarUrl,
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $lDESc.userTitle
        }, user.title))) : '';
});
parcelRegister("lDESc", function(module, exports) {
    $parcel$export(module.exports, "avatarWithTitle", ()=>$fc0cf208b38608b3$export$ab485147d010f3a4, (v)=>$fc0cf208b38608b3$export$ab485147d010f3a4 = v);
    $parcel$export(module.exports, "userTitle", ()=>$fc0cf208b38608b3$export$6c3180b0bb3c4aaa, (v)=>$fc0cf208b38608b3$export$6c3180b0bb3c4aaa = v);
    var $fc0cf208b38608b3$export$ab485147d010f3a4;
    var $fc0cf208b38608b3$export$c15bf4ef59dc517d;
    var $fc0cf208b38608b3$export$6c3180b0bb3c4aaa;
    $fc0cf208b38608b3$export$ab485147d010f3a4 = `t08fYq_avatarWithTitle`;
    $fc0cf208b38608b3$export$c15bf4ef59dc517d = `t08fYq_mutedColor`;
    $fc0cf208b38608b3$export$6c3180b0bb3c4aaa = `t08fYq_userTitle`;
});
parcelRegister("gLnKt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e64a6352407228a3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e64a6352407228a3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.heading",
            "defaultMessage": "Are you sure you want to save?"
        },
        message: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.message",
            "defaultMessage": "<strong>{name}</strong> was updated during your session by the following."
        },
        actionGroupHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.action-group-header",
            "defaultMessage": "Would you like to"
        },
        overwrite: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.overwrite",
            "defaultMessage": "Overwrite their changes"
        },
        saveAs: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.save-as",
            "defaultMessage": "Save as a new view"
        },
        discardChanges: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.discard-changes",
            "defaultMessage": "Discard your changes"
        },
        modifiedByHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.modified-by-header",
            "defaultMessage": "Who"
        },
        modifiedAtHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.modified-at-header",
            "defaultMessage": "When"
        }
    });
});
parcelRegister("lV7zB", function(module, exports) {
    $parcel$export(module.exports, "actionGroup", ()=>$ff54cbb864ad972c$export$90bccb1402e26e40, (v)=>$ff54cbb864ad972c$export$90bccb1402e26e40 = v);
    $parcel$export(module.exports, "actionGroupHeader", ()=>$ff54cbb864ad972c$export$9c67da48344f8b9a, (v)=>$ff54cbb864ad972c$export$9c67da48344f8b9a = v);
    $parcel$export(module.exports, "actionGroupRadios", ()=>$ff54cbb864ad972c$export$90a6f280bce1c5d1, (v)=>$ff54cbb864ad972c$export$90a6f280bce1c5d1 = v);
    $parcel$export(module.exports, "headersColor", ()=>$ff54cbb864ad972c$export$7335ea925f0de853, (v)=>$ff54cbb864ad972c$export$7335ea925f0de853 = v);
    $parcel$export(module.exports, "modifiedAt", ()=>$ff54cbb864ad972c$export$8e2c99dc0786c8ea, (v)=>$ff54cbb864ad972c$export$8e2c99dc0786c8ea = v);
    $parcel$export(module.exports, "updatedInfoGroup", ()=>$ff54cbb864ad972c$export$60e028c712f447af, (v)=>$ff54cbb864ad972c$export$60e028c712f447af = v);
    var $ff54cbb864ad972c$export$90bccb1402e26e40;
    var $ff54cbb864ad972c$export$9c67da48344f8b9a;
    var $ff54cbb864ad972c$export$90a6f280bce1c5d1;
    var $ff54cbb864ad972c$export$7335ea925f0de853;
    var $ff54cbb864ad972c$export$8e2c99dc0786c8ea;
    var $ff54cbb864ad972c$export$60e028c712f447af;
    $ff54cbb864ad972c$export$90bccb1402e26e40 = `THfINa_actionGroup`;
    $ff54cbb864ad972c$export$9c67da48344f8b9a = `THfINa_actionGroupHeader`;
    $ff54cbb864ad972c$export$90a6f280bce1c5d1 = `THfINa_actionGroupRadios`;
    $ff54cbb864ad972c$export$7335ea925f0de853 = `THfINa_headersColor`;
    $ff54cbb864ad972c$export$8e2c99dc0786c8ea = `THfINa_modifiedAt`;
    $ff54cbb864ad972c$export$60e028c712f447af = `THfINa_updatedInfoGroup`;
});
parcelRegister("gqWZS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d33299840395793a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gtreQ;
    var $cgL5K;
    var $d4xRU;
    var $3KRpp;
    var $koVbs;
    var $gJZ5D;
    var $jHlrZ = parcelRequire("jHlrZ");
    function $d33299840395793a$var$DeleteErrorNotification({ dismissFlag: dismissFlag, viewName: viewName }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = formatMessage((0, $jHlrZ.default).title);
        const description = formatMessage((0, $jHlrZ.default).description, {
            viewName: viewName,
            strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "strong"
                }, chunks)
        });
        const icon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            label: formatMessage((0, $jHlrZ.default).deleteErrorIconLabel),
            primaryColor: `var(--ds-icon-warning, ${(0, (0, parcelRequire("gJZ5D")).default).Y300})`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).FlagGroup), {
            onDismissed: dismissFlag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            id: "delete-error-notification-flag",
            title: title,
            description: description,
            icon: icon
        }));
    }
    var $d33299840395793a$export$2e2bcd8739ae039 = $d33299840395793a$var$DeleteErrorNotification;
});
parcelRegister("jHlrZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e4be532c3c58cc1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3e4be532c3c58cc1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deleteErrorIconLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.delete-error-notification.delete-error-icon-label",
            "defaultMessage": "Delete error warning"
        },
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.delete-error-notification.title",
            "defaultMessage": "Unable to delete view"
        },
        description: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.delete-error-notification.description",
            "defaultMessage": "<strong>{viewName}</strong> could not be deleted as it has been set as the default view for this plan"
        }
    });
});
parcelRegister("h43GJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40dc439db3f2fb16$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $cgL5K;
    var $9fuVs;
    var $koVbs;
    var $ihPUd = parcelRequire("ihPUd");
    var $iNZBa = parcelRequire("iNZBa");
    function $40dc439db3f2fb16$export$2e2bcd8739ae039({ viewName: viewName, onConfirm: onConfirm, onClose: onClose }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: onClose,
            shouldCloseOnOverlayClick: true,
            shouldCloseOnEscapePress: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "warning"
        }, formatMessage((0, $iNZBa.default).heading))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, formatMessage((0, $iNZBa.default).message, {
            name: viewName,
            strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "strong"
                }, chunks)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: onClose,
            testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.deleting-dialog.delete-view-config-dialog-cancel-button"
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "warning",
            onClick: onConfirm,
            testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.deleting-dialog.delete-view-config-dialog-delete-button"
        }, formatMessage((0, $ihPUd.default).delete)))));
    }
});
parcelRegister("iNZBa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2aa113bc5a2f7fd2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2aa113bc5a2f7fd2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.deleting-dialog.heading",
            "defaultMessage": "Delete saved view"
        },
        message: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.deleting-dialog.message",
            "defaultMessage": "Deleting <strong>{name}</strong> will remove it from this plan, and everyone currently using this view will no longer see it."
        }
    });
});
parcelRegister("kYwHG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d752929cb0331574$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $cgL5K;
    var $jouoW;
    var $9fuVs;
    var $koVbs;
    var $ihPUd = parcelRequire("ihPUd");
    var $4TKS5 = parcelRequire("4TKS5");
    var $8HxO5 = parcelRequire("8HxO5");
    function $d752929cb0331574$export$2e2bcd8739ae039({ onClose: onClose, onRequestDiscardChanges: onRequestDiscardChanges, onRequestSaveAs: onRequestSaveAs, viewName: viewName }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const options = [
            {
                message: (0, $4TKS5.default).saveAs,
                action: onRequestSaveAs
            },
            {
                message: (0, $4TKS5.default).discardChanges,
                action: onRequestDiscardChanges
            }
        ];
        const [selectedIndex, setSelectedIndex] = (0, $5uXOq.useState)(-1);
        const handleRadioButtonChange = (idx)=>()=>setSelectedIndex(idx);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: onClose,
            shouldCloseOnOverlayClick: true,
            shouldCloseOnEscapePress: true,
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $4TKS5.default).heading))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, formatMessage((0, $4TKS5.default).message, {
            name: viewName,
            strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "strong"
                }, chunks)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8HxO5.actionGroup,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.not-existing-dialog"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8HxO5.actionGroupHeader
        }, formatMessage((0, $4TKS5.default).actionGroupHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $8HxO5.actionGroupRadios
        }, options.map(({ message: message }, idx)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                isChecked: idx === selectedIndex,
                key: idx,
                label: formatMessage(message),
                onChange: handleRadioButtonChange(idx)
            }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            isDisabled: selectedIndex === -1,
            onClick: options[selectedIndex] && options[selectedIndex].action,
            testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.view-non-existing-dialog-confirm-button"
        }, formatMessage((0, $ihPUd.default).confirm)))));
    }
});
parcelRegister("4TKS5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de922cf96b084002$export$2e2bcd8739ae039);
    var $7VHMR;
    var $de922cf96b084002$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.heading",
            "defaultMessage": "Save deleted view"
        },
        actionGroupHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.action-group-header",
            "defaultMessage": "Do you want to:"
        },
        message: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.message",
            "defaultMessage": "<strong>{name}</strong> was deleted by someone else during your session."
        },
        saveAs: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.save-as",
            "defaultMessage": "Save as a new view"
        },
        discardChanges: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.discard-changes",
            "defaultMessage": "Discard your changes"
        }
    });
});
parcelRegister("8HxO5", function(module, exports) {
    $parcel$export(module.exports, "actionGroup", ()=>$655c903350e91af0$export$90bccb1402e26e40, (v)=>$655c903350e91af0$export$90bccb1402e26e40 = v);
    $parcel$export(module.exports, "actionGroupHeader", ()=>$655c903350e91af0$export$9c67da48344f8b9a, (v)=>$655c903350e91af0$export$9c67da48344f8b9a = v);
    $parcel$export(module.exports, "actionGroupRadios", ()=>$655c903350e91af0$export$90a6f280bce1c5d1, (v)=>$655c903350e91af0$export$90a6f280bce1c5d1 = v);
    var $655c903350e91af0$export$90bccb1402e26e40;
    var $655c903350e91af0$export$9c67da48344f8b9a;
    var $655c903350e91af0$export$90a6f280bce1c5d1;
    $655c903350e91af0$export$90bccb1402e26e40 = `_8w1NhG_actionGroup`;
    $655c903350e91af0$export$9c67da48344f8b9a = `_8w1NhG_actionGroupHeader`;
    $655c903350e91af0$export$90a6f280bce1c5d1 = `_8w1NhG_actionGroupRadios`;
});
parcelRegister("iXvsQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc08a8f85e12b7ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $qfj8c;
    var $7O4UO;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $kY99m;
    var $9fuVs;
    var $koVbs;
    var $aCpcO;
    var $fAGMJ;
    var $ihPUd = parcelRequire("ihPUd");
    var $aMrc6 = parcelRequire("aMrc6");
    var $jrJ9O = parcelRequire("jrJ9O");
    const $fc08a8f85e12b7ad$var$MAX_VIEW_NAME_LENGTH = 200;
    function $fc08a8f85e12b7ad$export$2e2bcd8739ae039({ hasDuplicateViewError: hasDuplicateViewError, isSaving: isSaving, onChange: onChange, onClose: onClose, onSubmit: onSubmit }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [name, setName] = (0, $5uXOq.useState)('');
        const [asDefault, markAsDefault] = (0, $5uXOq.useState)(false);
        const handleTitleChange = (e)=>{
            onChange();
            if (e.currentTarget instanceof HTMLInputElement) setName(e.currentTarget.value.substr(0, $fc08a8f85e12b7ad$var$MAX_VIEW_NAME_LENGTH + 1));
        };
        const handleMarkAsDefaultChange = (e)=>{
            if (e.currentTarget instanceof HTMLInputElement) markAsDefault(e.currentTarget.checked);
        };
        const isMaximumNameLengthExceeded = name.length > $fc08a8f85e12b7ad$var$MAX_VIEW_NAME_LENGTH;
        const errorMessage = (()=>{
            if (hasDuplicateViewError) return formatMessage((0, $aMrc6.default).duplicateView);
            if (isMaximumNameLengthExceeded) return formatMessage((0, $aMrc6.default).maximumNameLengthExceeded, {
                number: $fc08a8f85e12b7ad$var$MAX_VIEW_NAME_LENGTH
            });
        })();
        const hasError = hasDuplicateViewError || isMaximumNameLengthExceeded;
        const submit = ()=>onSubmit({
                name: name.trim(),
                asDefault: asDefault
            });
        const canSubmit = name.trim() !== '' && !hasError;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: onClose,
            shouldCloseOnOverlayClick: true,
            shouldCloseOnEscapePress: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $aMrc6.default).headingCreate))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, formatMessage((0, $aMrc6.default).messageCreate), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $jrJ9O.formItemWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            isRequired: true,
            label: formatMessage((0, $aMrc6.default).title),
            name: "viewName"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                ...fieldProps,
                autoFocus: true,
                isInvalid: hasError,
                onChange: handleTitleChange,
                placeholder: formatMessage((0, $aMrc6.default).titlePlaceholder),
                testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.input",
                value: name
            }), !hasError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, formatMessage((0, $aMrc6.default).titleHint)), hasError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), {
                testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.error-message"
            }, errorMessage || '')))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $jrJ9O.formItemWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAGMJ")).default), {
            isChecked: asDefault,
            onChange: handleMarkAsDefaultChange,
            label: formatMessage((0, $aMrc6.default).makeDefaultCheckboxLabel)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: `${$jrJ9O.fieldHint} ${$jrJ9O.checkboxHint}`
        }, formatMessage((0, $aMrc6.default).makeDefaultCheckboxHint)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            onClick: onClose,
            testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.cancel-button"
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "primary",
            isDisabled: !canSubmit,
            isLoading: isSaving,
            onClick: submit,
            testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.save-button"
        }, formatMessage((0, $aMrc6.default).save)))));
    }
});
parcelRegister("aMrc6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a3837bbc23a7f4e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2a3837bbc23a7f4e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        headingCreate: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.heading-create",
            "defaultMessage": "Create a new view"
        },
        messageCreate: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.message-create",
            "defaultMessage": "Make a new view of your plan, and change the view settings to tell a different story. This new view will inherit the filters and settings of the currently selected view."
        },
        title: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.title",
            "defaultMessage": "Title"
        },
        titlePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.title-placeholder",
            "defaultMessage": "Capacity planning"
        },
        titleHint: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.title-hint",
            "defaultMessage": "Choose a name that others will recognize"
        },
        makeDefaultCheckboxLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.make-default-checkbox-label",
            "defaultMessage": "Make default for everyone"
        },
        makeDefaultCheckboxHint: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.make-default-checkbox-hint",
            "defaultMessage": "Use as initial view for everyone"
        },
        save: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.save",
            "defaultMessage": "Save"
        },
        duplicateView: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.duplicate-view",
            "defaultMessage": "This name is already being used. Enter another name."
        },
        maximumNameLengthExceeded: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.maximum-name-length-exceeded",
            "defaultMessage": "This name exceeds {number, plural, one {# character} other {# characters}}"
        }
    });
});
parcelRegister("jrJ9O", function(module, exports) {
    $parcel$export(module.exports, "checkboxHint", ()=>$e2839140ce9a9bed$export$1ca662024e10e76a, (v)=>$e2839140ce9a9bed$export$1ca662024e10e76a = v);
    $parcel$export(module.exports, "fieldHint", ()=>$e2839140ce9a9bed$export$6963c9681059ce1e, (v)=>$e2839140ce9a9bed$export$6963c9681059ce1e = v);
    $parcel$export(module.exports, "formItemWrapper", ()=>$e2839140ce9a9bed$export$d5ee42b7cad50777, (v)=>$e2839140ce9a9bed$export$d5ee42b7cad50777 = v);
    var $e2839140ce9a9bed$export$1ca662024e10e76a;
    var $e2839140ce9a9bed$export$6963c9681059ce1e;
    var $e2839140ce9a9bed$export$48db87e3f4768880;
    var $e2839140ce9a9bed$export$d5ee42b7cad50777;
    $e2839140ce9a9bed$export$1ca662024e10e76a = `OuAaVW_checkboxHint`;
    $e2839140ce9a9bed$export$6963c9681059ce1e = `OuAaVW_fieldHint`;
    $e2839140ce9a9bed$export$48db87e3f4768880 = `OuAaVW_fieldLabel`;
    $e2839140ce9a9bed$export$d5ee42b7cad50777 = `OuAaVW_formItemWrapper`;
});
parcelRegister("8Q3SD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$417fcb05d0e6de80$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nPAF;
    var $8r8wv;
    var $2rMKg;
    var $4xCjg;
    var $fVnbM;
    var $aRoVz;
    var $6Ingq;
    var $lj8SI;
    var $cgL5K;
    var $3bDjY;
    var $4R6GH;
    var $5Zxxp;
    var $koVbs;
    var $1iMQ1;
    var $iZLaw;
    var $g7G9N = parcelRequire("g7G9N");
    var $kgpiC = parcelRequire("kgpiC");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fOXM3 = parcelRequire("fOXM3");
    var $idmiV = parcelRequire("idmiV");
    var $lVJAU;
    var $dNkho = parcelRequire("dNkho");
    var $d79ld = parcelRequire("d79ld");
    function $417fcb05d0e6de80$var$MenuItemLabel({ view: view }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $d79ld.viewName
        }, view.id !== (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28) ? (0, $fOXM3.getMigratedPresetViewName)(view) : formatMessage((0, $dNkho.default).untitled)));
    }
    const $417fcb05d0e6de80$var$TriggerEl = ({ views: views, activeViewName: activeViewName = '', elemAfter: elemAfter })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if ((0, parcelRequire("3nPAF")).default(views)) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, $dNkho.default).savedViews)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: activeViewName,
            position: "top",
            delay: 500
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d79ld.view
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $d79ld.viewName
        }, activeViewName), " ", elemAfter)));
    };
    function $417fcb05d0e6de80$var$ModifiedView({ activeViewName: activeViewName, onRequestSave: onRequestSave, onRequestSaveAs: onRequestSaveAs, onRequestDiscardChanges: onRequestDiscardChanges, onRequestDelete: onRequestDelete, isReadOnly: isReadOnly, isDraft: isDraft }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (!activeViewName) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            component: "div",
            isSelected: true,
            role: "menuitem",
            description: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $d79ld.modifiedViewActions
            }, isReadOnly ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                spacing: "none",
                appearance: "link",
                onClick: isDraft ? onRequestSaveAs : onRequestSave,
                testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.save-current-view"
            }, formatMessage((0, $dNkho.default).saveChanges)), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $d79ld.actionSeparator
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                spacing: "none",
                appearance: "link",
                onClick: isDraft ? onRequestDelete : onRequestDiscardChanges
            }, formatMessage(isDraft ? (0, $dNkho.default).delete : (0, $dNkho.default).reset))),
            elemAfter: (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $d79ld.lozengeContainer
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, isDraft ? formatMessage((0, $dNkho.default).draft) : formatMessage((0, $dNkho.default).edited)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $d79ld.modifiedViewName
        }, activeViewName));
    }
    function $417fcb05d0e6de80$var$SavedViewSwitcher({ onRequestSave: onRequestSave, onRequestSaveAs: onRequestSaveAs, onRequestDiscardChanges: onRequestDiscardChanges, onRequestViewChange: onRequestViewChange, onRequestDelete: onRequestDelete, views: views, isReadOnly: isReadOnly, defaultOpen: defaultOpen = false, buttonRef: buttonRef, isSmartLink: isSmartLink }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const openInProductHelp = (0, (0, parcelRequire("5Zxxp")).useHelpPanelLink)();
        const activeView = views.find((0, parcelRequire("2rMKg")).default('active'));
        const activeViewName = (0, $4nDwW.isDefined)(activeView) && activeView.id !== (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28) ? (0, $fOXM3.getMigratedPresetViewName)(activeView) : formatMessage((0, $dNkho.default).untitled);
        if (!(0, parcelRequire("3nPAF")).default(views) && !activeView) throw new Error('active view not found');
        const renderViewItemsList = ()=>{
            if ((0, parcelRequire("3nPAF")).default(views)) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.skeleton",
                className: $d79ld.viewsListSkeleton,
                role: "menuitem"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iZLaw")).default), {
                numOfRows: 5,
                rowHeight: 32,
                spaceInBetween: 8,
                ariaLabel: formatMessage((0, $dNkho.default).skeletonAriaLabel)
            }));
            const reorderedViews = (0, parcelRequire("4xCjg")).default((0, parcelRequire("8r8wv")).default((0, parcelRequire("2rMKg")).default('active'), views));
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $d79ld.viewsList
            }, reorderedViews.map((view, index)=>{
                const isActiveViewSelected = !view.modified && index === 0;
                const isActiveViewModified = view.modified && index === 0;
                if (isActiveViewModified) return null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                    isSelected: isActiveViewSelected,
                    key: view.id,
                    onClick: (e)=>{
                        onRequestViewChange(e, view.id);
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($417fcb05d0e6de80$var$MenuItemLabel, {
                    view: view
                }));
            })));
        };
        const onClickManageViews = ()=>{
            const planId = (0, $g7G9N.getPlanId)();
            const scenarioId = (0, $g7G9N.getScenarioId)();
            if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) push((0, $idmiV.buildManageViewsPath)(planId, scenarioId));
        };
        const onClickLearnMore = ()=>openInProductHelp?.((0, $TTKUQ.IPH_IDS).SAVED_VIEWS);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.button",
            ref: buttonRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.dropdown-menu",
            defaultOpen: defaultOpen,
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ref: triggerRef,
                    ...props,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: ""
                    }),
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kgpiC.default), null)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $d79ld.viewTrigger
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($417fcb05d0e6de80$var$TriggerEl, {
                    views: views,
                    activeViewName: activeViewName,
                    elemAfter: activeView?.modified ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                        className: $d79ld.activeLozengeContainer
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, activeView.id === (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28) ? formatMessage((0, $dNkho.default).draft) : formatMessage((0, $dNkho.default).edited))) : null
                })))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            title: formatMessage((0, $dNkho.default).savedViews)
        }, activeView?.modified && (0, ($parcel$interopDefault($5uXOq))).createElement($417fcb05d0e6de80$var$ModifiedView, {
            onRequestSave: onRequestSave,
            onRequestSaveAs: onRequestSaveAs,
            activeViewName: activeViewName,
            onRequestDiscardChanges: onRequestDiscardChanges,
            onRequestDelete: onRequestDelete,
            isReadOnly: isReadOnly,
            isDraft: activeView.id === (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28)
        }), renderViewItemsList()), (!isSmartLink && (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') || !(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            onClick: onClickLearnMore
        }, formatMessage((0, $dNkho.default).iphLink))), !isReadOnly && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            onClick: onClickManageViews
        }, formatMessage((0, $dNkho.default).manageViews)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
            onClick: onRequestSaveAs
        }, formatMessage((0, $dNkho.default).createANewView)))));
    }
    var $417fcb05d0e6de80$export$2e2bcd8739ae039 = $417fcb05d0e6de80$var$SavedViewSwitcher;
});
parcelRegister("4xCjg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34e7f5fc87d3739b$export$2e2bcd8739ae039);
    var $btPXa;
    var $7WM3o;
    var $34e7f5fc87d3739b$var$unnest = (0, (0, parcelRequire("7WM3o")).default)((0, (0, parcelRequire("btPXa")).default));
    var $34e7f5fc87d3739b$export$2e2bcd8739ae039 = $34e7f5fc87d3739b$var$unnest;
});
parcelRegister("kgpiC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13908d64d2fe6b65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $13908d64d2fe6b65$var$Glyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            height: "24",
            width: "24",
            fill: "none",
            viewBox: "0 0 24 24",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "13",
            height: "3",
            x: "5",
            y: "5",
            fill: "currentColor",
            rx: "1.5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "10",
            height: "3",
            x: "10",
            y: "10.5",
            fill: "currentColor",
            rx: "1.5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "9",
            height: "3",
            x: "5",
            y: "16",
            fill: "currentColor",
            rx: "1.5"
        }));
    var $13908d64d2fe6b65$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $13908d64d2fe6b65$var$Glyph,
            label: ""
        });
});
parcelRegister("dNkho", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa37edd4cce5512e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $aa37edd4cce5512e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createANewView: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.create-a-new-view",
            "defaultMessage": "Create a new view"
        },
        draft: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.draft",
            "defaultMessage": "draft"
        },
        edited: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.edited",
            "defaultMessage": "edited"
        },
        manageViews: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.manage-views",
            "defaultMessage": "Manage saved views"
        },
        reset: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.reset",
            "defaultMessage": "Reset"
        },
        delete: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.delete",
            "defaultMessage": "Delete"
        },
        saveChanges: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.save-changes",
            "defaultMessage": "Save"
        },
        savedViews: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.saved-views",
            "defaultMessage": "Saved views"
        },
        untitled: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.untitled",
            "defaultMessage": "Untitled"
        },
        iphLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.iph-link",
            "defaultMessage": "Read more about saved views"
        },
        skeletonAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.skeleton-aria-label",
            "defaultMessage": "Loading"
        }
    });
});
parcelRegister("d79ld", function(module, exports) {
    $parcel$export(module.exports, "actionSeparator", ()=>$98c32cc59aeaec08$export$7927c1cdebe68d43, (v)=>$98c32cc59aeaec08$export$7927c1cdebe68d43 = v);
    $parcel$export(module.exports, "activeLozengeContainer", ()=>$98c32cc59aeaec08$export$d9bc97eff0df9d6c, (v)=>$98c32cc59aeaec08$export$d9bc97eff0df9d6c = v);
    $parcel$export(module.exports, "lozengeContainer", ()=>$98c32cc59aeaec08$export$eb4875e6806aa5a, (v)=>$98c32cc59aeaec08$export$eb4875e6806aa5a = v);
    $parcel$export(module.exports, "modifiedViewActions", ()=>$98c32cc59aeaec08$export$6a9188a55c849b46, (v)=>$98c32cc59aeaec08$export$6a9188a55c849b46 = v);
    $parcel$export(module.exports, "modifiedViewName", ()=>$98c32cc59aeaec08$export$4975e08bd497572f, (v)=>$98c32cc59aeaec08$export$4975e08bd497572f = v);
    $parcel$export(module.exports, "view", ()=>$98c32cc59aeaec08$export$c4ddc81c7b2c8d7a, (v)=>$98c32cc59aeaec08$export$c4ddc81c7b2c8d7a = v);
    $parcel$export(module.exports, "viewName", ()=>$98c32cc59aeaec08$export$560239d3315fb15a, (v)=>$98c32cc59aeaec08$export$560239d3315fb15a = v);
    $parcel$export(module.exports, "viewTrigger", ()=>$98c32cc59aeaec08$export$164f82e58a010d8e, (v)=>$98c32cc59aeaec08$export$164f82e58a010d8e = v);
    $parcel$export(module.exports, "viewsList", ()=>$98c32cc59aeaec08$export$59a28b0ab50de038, (v)=>$98c32cc59aeaec08$export$59a28b0ab50de038 = v);
    $parcel$export(module.exports, "viewsListSkeleton", ()=>$98c32cc59aeaec08$export$d9a879e41895b0d8, (v)=>$98c32cc59aeaec08$export$d9a879e41895b0d8 = v);
    var $98c32cc59aeaec08$export$7927c1cdebe68d43;
    var $98c32cc59aeaec08$export$d9bc97eff0df9d6c;
    var $98c32cc59aeaec08$export$eb4875e6806aa5a;
    var $98c32cc59aeaec08$export$6a9188a55c849b46;
    var $98c32cc59aeaec08$export$4975e08bd497572f;
    var $98c32cc59aeaec08$export$c4ddc81c7b2c8d7a;
    var $98c32cc59aeaec08$export$560239d3315fb15a;
    var $98c32cc59aeaec08$export$164f82e58a010d8e;
    var $98c32cc59aeaec08$export$59a28b0ab50de038;
    var $98c32cc59aeaec08$export$d9a879e41895b0d8;
    $98c32cc59aeaec08$export$7927c1cdebe68d43 = `FM3apa_actionSeparator`;
    $98c32cc59aeaec08$export$d9bc97eff0df9d6c = `FM3apa_activeLozengeContainer`;
    $98c32cc59aeaec08$export$eb4875e6806aa5a = `FM3apa_lozengeContainer`;
    $98c32cc59aeaec08$export$6a9188a55c849b46 = `FM3apa_modifiedViewActions`;
    $98c32cc59aeaec08$export$4975e08bd497572f = `FM3apa_modifiedViewName`;
    $98c32cc59aeaec08$export$c4ddc81c7b2c8d7a = `FM3apa_view`;
    $98c32cc59aeaec08$export$560239d3315fb15a = `FM3apa_viewName`;
    $98c32cc59aeaec08$export$164f82e58a010d8e = `FM3apa_viewTrigger`;
    $98c32cc59aeaec08$export$59a28b0ab50de038 = `FM3apa_viewsList`;
    $98c32cc59aeaec08$export$d9a879e41895b0d8 = `FM3apa_viewsListSkeleton`;
});
parcelRegister("sSwfb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6739c52e66ada1c7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $cgL5K;
    var $9fuVs;
    var $koVbs;
    var $ihPUd = parcelRequire("ihPUd");
    var $7v1Sy = parcelRequire("7v1Sy");
    function $6739c52e66ada1c7$var$SavingDialog({ viewName: viewName, onConfirm: onConfirm, onClose: onClose }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: onClose,
            shouldCloseOnOverlayClick: true,
            shouldCloseOnEscapePress: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $7v1Sy.default).heading, {
            viewName: viewName
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, formatMessage((0, $7v1Sy.default).message, {
            viewName: viewName,
            strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "strong"
                }, chunks)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            onClick: onConfirm,
            testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.saving-dialog.view-save-changes-save-button"
        }, formatMessage((0, $ihPUd.default).save)))));
    }
    var $6739c52e66ada1c7$export$2e2bcd8739ae039 = $6739c52e66ada1c7$var$SavingDialog;
});
parcelRegister("7v1Sy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f2d0750fa0fd1d6c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f2d0750fa0fd1d6c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saving-dialog.heading",
            "defaultMessage": "Save changes to {viewName}"
        },
        message: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saving-dialog.message",
            "defaultMessage": "Everyone who uses <strong>{viewName}</strong> to view this plan will see your changes. Are you sure you want to continue?"
        }
    });
});
parcelRegister("g9aLQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4e00b05f9d36f16$export$2e2bcd8739ae039);
    var $bC2fB;
    var $c3kY0 = parcelRequire("c3kY0");
    var $h3KSj = parcelRequire("h3KSj");
    var $kqjRT = parcelRequire("kqjRT");
    var $c4e00b05f9d36f16$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $h3KSj.default), (0, $c3kY0.default))((0, $kqjRT.default));
});
parcelRegister("c3kY0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d7eeab362f1e33d$export$2e2bcd8739ae039);
    var $5APQl = parcelRequire("5APQl");
    var $23472 = parcelRequire("23472");
    const $5d7eeab362f1e33d$var$mapDispatchToProps = (dispatch)=>({
            expandHierarchy: ()=>{
                dispatch((0, $5APQl.expandIssueWithAncestors)());
            },
            searchIconClick: ()=>{
                dispatch((0, $23472.searchIconClick)());
            },
            setActiveSearchResultIndex: (payload)=>{
                dispatch((0, $23472.setActiveSearchResultIndex)(payload));
            },
            setSearchQuery: (query)=>{
                dispatch((0, $23472.setSearchQuery)(query));
            },
            startedSearchResultNavigation: ()=>{
                dispatch((0, $23472.startedSearchResultNavigation)());
            },
            toggleIssueSearch: (isOpen)=>{
                dispatch((0, $23472.toggleIssueSearch)(isOpen));
            }
        });
    var $5d7eeab362f1e33d$export$2e2bcd8739ae039 = $5d7eeab362f1e33d$var$mapDispatchToProps;
});
parcelRegister("h3KSj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d24026269fa6f246$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $jLI87 = parcelRequire("jLI87");
    var $3YtPS = parcelRequire("3YtPS");
    var $d24026269fa6f246$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        searchQuery: (0, $jLI87.getSearchQuery),
        issueSearchResults: (0, $jLI87.searchForIssues),
        activeSearchResultIndex: (0, $jLI87.getActiveSearchResultIndex),
        isConfluenceMacro: $1CGdp.isConfluenceMacro,
        isEmbed: $1CGdp.isEmbed
    });
});
parcelRegister("kqjRT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2154c8e8e854a55b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $hGgHi = parcelRequire("hGgHi");
    var $9ci4W = parcelRequire("9ci4W");
    var $hyOJh;
    var $6Ingq;
    var $6Pmud;
    var $d5Zn3;
    var $tvuR8;
    var $dC5iT;
    var $kY99m;
    var $4R6GH;
    var $koVbs;
    var $gJZ5D;
    var $1gQ7U;
    var $7UUKs;
    var $kW2wY = parcelRequire("kW2wY");
    var $2xSAL;
    var $dCm1o;
    var $7jcng = parcelRequire("7jcng");
    var $1C37T = parcelRequire("1C37T");
    var $iK4cj = parcelRequire("iK4cj");
    const $2154c8e8e854a55b$var$SearchSummary = ({ searchQuery: searchQuery, totalResults: totalResults, onDismiss: onDismiss, activeSearchResultIndex: activeSearchResultIndex, navigateResults: navigateResults })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const hasSearchQuery = searchQuery.trim() !== '';
        const displayedActiveIndex = activeSearchResultIndex + 1;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $iK4cj.searchSummaryContainer
        }, hasSearchQuery && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: $iK4cj.summaryCount
        }, Math.min(displayedActiveIndex, totalResults), "/", totalResults), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, ($parcel$interopDefault($9ci4W)))($iK4cj.iconWrapper, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $iK4cj.justifyCentered : undefined, {
                [$iK4cj.disabled]: totalResults === 0 || displayedActiveIndex === 1
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gQ7U")).IconButton), {
            onClick: ()=>navigateResults('up'),
            ariaLabel: formatMessage((0, $1C37T.default).viewPreviousSearchDataArialabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Pmud"))))), {
            label: "",
            primaryColor: `var(--ds-text-subtlest, ${(0, (0, parcelRequire("gJZ5D")).default).N90})`
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, ($parcel$interopDefault($9ci4W)))($iK4cj.iconWrapper, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $iK4cj.justifyCentered : undefined, {
                [$iK4cj.disabled]: totalResults === 0 || displayedActiveIndex === totalResults
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gQ7U")).IconButton), {
            onClick: ()=>navigateResults('down'),
            ariaLabel: formatMessage((0, $1C37T.default).viewNextSearchDataArialabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
            label: "",
            primaryColor: `var(--ds-text-subtlest, ${(0, (0, parcelRequire("gJZ5D")).default).N90})`
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $iK4cj.iconWrapper,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.input-close"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gQ7U")).IconButton), {
            onClick: onDismiss,
            ariaLabel: formatMessage((0, $1C37T.default).clearSearchDataArialabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d5Zn3"))))), {
            label: "",
            size: "small",
            primaryColor: `var(--ds-text-subtle, ${(0, (0, parcelRequire("gJZ5D")).default).N70})`
        })))));
    };
    const $2154c8e8e854a55b$var$Search = ({ searchQuery: searchQuery, setSearchQuery: setSearchQuery, issueSearchResults: { total: total }, searchIconClick: searchIconClick, startedSearchResultNavigation: startedSearchResultNavigation, setActiveSearchResultIndex: setActiveSearchResultIndex, activeSearchResultIndex: activeSearchResultIndex, expandHierarchy: expandHierarchy, IssueSearchWarningFlagComponent: IssueSearchWarningFlagComponent = (0, $7jcng.default), toggleIssueSearch: toggleIssueSearch, isConfluenceMacro: isConfluenceMacro, isEmbed: isEmbed })=>{
        const [searchString, setSearchString] = (0, $5uXOq.useState)(searchQuery);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isVisuallyRefreshed = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2');
        const closeSearchIfEmpty = ()=>{
            if (searchQuery.trim() === '') toggleIssueSearch(false);
        };
        const [isTouched, setIsTouched] = (0, $5uXOq.useState)(false);
        const searchInputRef = (0, $5uXOq.useRef)(null);
        const isSearchBoxEmpty = searchString.trim() === '';
        const closeSearchbar = ()=>{
            setSearchString('');
            toggleIssueSearch(false);
            searchInputRef.current && searchInputRef.current.blur();
        };
        const focusSearchInput = ()=>{
            if (!(0, ($parcel$interopDefault($hGgHi)))(searchInputRef) && !(0, ($parcel$interopDefault($hGgHi)))(searchInputRef.current)) setTimeout(()=>searchInputRef.current && searchInputRef.current.focus(), 0);
        };
        const navigateResults = (direction)=>{
            if (!isTouched) {
                setIsTouched(true);
                startedSearchResultNavigation();
            }
            const nextIndex = direction === 'up' ? Math.max(0, activeSearchResultIndex - 1) : Math.min(activeSearchResultIndex + 1, total - 1);
            setActiveSearchResultIndex(nextIndex);
            expandHierarchy();
        };
        const handleKeyPress = (e)=>{
            const { key: key, shiftKey: shiftKey } = e;
            if (key === 'Escape') closeSearchbar();
            else if (key === 'ArrowUp' || key === 'Enter' && shiftKey) navigateResults('up');
            else if (key === 'ArrowDown' || key === 'Enter') navigateResults('down');
        };
        const searchQueryChange = (0, $5uXOq.useCallback)((query)=>{
            setSearchQuery(query);
            setActiveSearchResultIndex(0);
            expandHierarchy();
        }, [
            expandHierarchy,
            setActiveSearchResultIndex,
            setSearchQuery
        ]);
        const debouncedSearchQueryChange = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(searchQueryChange, 300), [
            searchQueryChange
        ]);
        (0, $5uXOq.useEffect)(()=>{
            debouncedSearchQueryChange(searchString);
        }, [
            debouncedSearchQueryChange,
            searchString
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setSearchString(searchQuery);
        }, [
            searchQuery
        ]);
        const searchBox = (0, $5uXOq.useRef)(null);
        (0, $kW2wY.useOnClickOutside)(searchBox, ()=>closeSearchIfEmpty());
        const elemAfterInput = isSearchBoxEmpty ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $iK4cj.searchIconWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("tvuR8"))))), {
            label: formatMessage((0, $1C37T.default).searchIconLabel),
            size: "small",
            primaryColor: `var(--ds-text-subtlest, ${(0, (0, parcelRequire("gJZ5D")).default).N90})`
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement($2154c8e8e854a55b$var$SearchSummary, {
            searchQuery: searchString,
            onDismiss: ()=>closeSearchbar(),
            totalResults: total,
            activeSearchResultIndex: activeSearchResultIndex,
            navigateResults: navigateResults
        });
        const elemBeforeInput = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingInlineStart: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyOJh"))))), {
            color: "currentColor",
            label: formatMessage((0, $1C37T.default).searchIconLabel),
            spacing: "none"
        }));
        const renderCustomSearchField = ({ textFieldProps: textFieldProps })=>{
            const textField = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                ...textFieldProps,
                elemAfterInput: isVisuallyRefreshed ? !isSearchBoxEmpty && elemAfterInput : elemAfterInput,
                elemBeforeInput: isVisuallyRefreshed ? elemBeforeInput : undefined,
                isCompact: true,
                width: isVisuallyRefreshed ? '200px' : undefined,
                onKeyDown: (e)=>{
                    handleKeyPress(e);
                }
            });
            return textField;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.page-header.search",
            ref: searchBox
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7UUKs")).default), {
            onFocusSearch: ()=>{
                toggleIssueSearch(true);
                searchIconClick();
                focusSearchInput();
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(IssueSearchWarningFlagComponent, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2xSAL")).SearchField), {
            maxLength: 255,
            onChange: (e)=>{
                toggleIssueSearch(true);
                setSearchString(e);
                searchIconClick();
            },
            value: searchString,
            ariaLabelText: formatMessage((0, $1C37T.default).searchFieldAriaLabel),
            placeholder: formatMessage(isVisuallyRefreshed ? (0, $1C37T.default).searchPlaceholder : (0, $1C37T.default).searchPlaceholderOld),
            inputRef: searchInputRef,
            renderCustomSearchField: renderCustomSearchField,
            isAutocompleteDisabled: isConfluenceMacro || isEmbed,
            placeholderAlwaysVisible: isVisuallyRefreshed,
            isAlwaysExpanded: isVisuallyRefreshed
        }));
    };
    var $2154c8e8e854a55b$export$2e2bcd8739ae039 = $2154c8e8e854a55b$var$Search;
});
parcelRegister("7UUKs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3995d62974a8c9f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dF9Z3;
    const $e3995d62974a8c9f$var$HijackBrowserSearch = ({ onFocusSearch: onFocusSearch })=>{
        const onGlobalSearch = (0, $5uXOq.useCallback)(({ event: event })=>{
            event.preventDefault();
            onFocusSearch();
        }, [
            onFocusSearch
        ]);
        (0, (0, parcelRequire("dF9Z3")).useGlobalSearch)(onGlobalSearch);
        return null;
    };
    var $e3995d62974a8c9f$export$2e2bcd8739ae039 = $e3995d62974a8c9f$var$HijackBrowserSearch;
});
parcelRegister("dF9Z3", function(module, exports) {
    $parcel$export(module.exports, "isMacOS", ()=>$3300b05877fade72$export$6159e43e50a41987);
    $parcel$export(module.exports, "useGlobalSearch", ()=>$3300b05877fade72$export$1df85516f1b3e335);
    $parcel$export(module.exports, "default", ()=>$3300b05877fade72$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fW62l = parcelRequire("fW62l");
    var $8zOmE;
    var $2NMNM;
    const $3300b05877fade72$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
    const $3300b05877fade72$export$1df85516f1b3e335 = (callback, getGlobalDocument = ()=>document)=>{
        (0, $5uXOq.useEffect)(()=>{
            const trackGlobalSearch = (event)=>{
                const isMacOs = $3300b05877fade72$export$6159e43e50a41987();
                if (isMacOs && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('f') && event.metaKey || !isMacOs && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('f') && event.ctrlKey) callback({
                    isMacOs: isMacOs,
                    event: event
                });
            };
            getGlobalDocument().addEventListener('keydown', trackGlobalSearch);
            return ()=>getGlobalDocument().removeEventListener('keydown', trackGlobalSearch);
        }, [
            callback,
            getGlobalDocument
        ]);
    };
    const $3300b05877fade72$var$GlobalSearchTracker = ({ getGlobalDocument: getGlobalDocument = ()=>document, fireAnalytics: fireAnalytics = (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics), analyticsAttributes: analyticsAttributes = {} })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onGlobalSearch = (0, $5uXOq.useCallback)(({ isMacOs: isMacOs })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'triggered',
                actionSubject: 'globalSearch'
            });
            const attributes = {
                ...analyticsAttributes,
                isMacOs: isMacOs
            };
            fireAnalytics(analyticsEvent, 'globalSearch triggered', attributes);
        }, [
            analyticsAttributes,
            createAnalyticsEvent,
            fireAnalytics
        ]);
        $3300b05877fade72$export$1df85516f1b3e335(onGlobalSearch, getGlobalDocument);
        return null;
    };
    var $3300b05877fade72$export$2e2bcd8739ae039 = $3300b05877fade72$var$GlobalSearchTracker;
});
parcelRegister("kW2wY", function(module, exports) {
    $parcel$export(module.exports, "useOnClickOutside", ()=>$b4b347575cc8a03b$export$9afc64c180e82dc4);
    var $5uXOq = parcelRequire("5uXOq");
    function $b4b347575cc8a03b$export$9afc64c180e82dc4(ref, handler) {
        (0, $5uXOq.useEffect)(()=>{
            const listener = (event)=>{
                if (!ref.current || event.target instanceof Node && ref.current.contains(event.target)) return;
                handler(event);
            };
            document.addEventListener('mousedown', listener);
            return ()=>{
                document.removeEventListener('mousedown', listener);
            };
        }, [
            ref,
            handler
        ]);
    }
});
parcelRegister("7jcng", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$711c8b07c7b78035$export$2e2bcd8739ae039);
    var $bC2fB;
    var $6ofW0 = parcelRequire("6ofW0");
    var $ax7TX = parcelRequire("ax7TX");
    var $jCqNO = parcelRequire("jCqNO");
    var $711c8b07c7b78035$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $ax7TX.default), (0, $6ofW0.default))((0, $jCqNO.default));
});
parcelRegister("6ofW0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e43e9923d460b93e$export$2e2bcd8739ae039);
    var $fI3Hm = parcelRequire("fI3Hm");
    const $e43e9923d460b93e$var$mapDispatchToProps = {
        onAddFlag: (0, $fI3Hm.addFlag),
        onRemoveFlag: (0, $fI3Hm.removeFlag)
    };
    var $e43e9923d460b93e$export$2e2bcd8739ae039 = $e43e9923d460b93e$var$mapDispatchToProps;
});
parcelRegister("ax7TX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$edaece9121ea7f46$export$2e2bcd8739ae039);
    var $jLI87 = parcelRequire("jLI87");
    var $3YtPS = parcelRequire("3YtPS");
    var $edaece9121ea7f46$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        issueSearchResults: (0, $jLI87.searchForIssues)
    });
});
parcelRegister("jCqNO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfb9fcb9d3ebc33c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $cfb9fcb9d3ebc33c$var$IssueSearchWarningFlag = ({ issueSearchResults: { resultsHiddenByFilter: resultsHiddenByFilter }, onAddFlag: onAddFlag, onRemoveFlag: onRemoveFlag })=>{
        (0, $5uXOq.useEffect)(()=>{
            if (resultsHiddenByFilter.length > 0) onAddFlag({
                key: (0, $9e169ee721864a4b$export$225669431bad5551)
            });
            else if (resultsHiddenByFilter.length === 0) onRemoveFlag({
                key: (0, $9e169ee721864a4b$export$225669431bad5551)
            });
        }, [
            resultsHiddenByFilter,
            onAddFlag,
            onRemoveFlag
        ]);
        return null;
    };
    var $cfb9fcb9d3ebc33c$export$2e2bcd8739ae039 = $cfb9fcb9d3ebc33c$var$IssueSearchWarningFlag;
});
parcelRegister("1C37T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00c2568f5745f92e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $00c2568f5745f92e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchPlaceholderOld: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.search-placeholder-old",
            "defaultMessage": "Search"
        },
        searchPlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.search-field-placeholder",
            "defaultMessage": "Search timeline"
        },
        searchFieldAriaLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.search-field-aria-label",
            "defaultMessage": "Find Issue"
        },
        viewPreviousSearchDataArialabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.view-previous-search-data-arialabel",
            "defaultMessage": "View previous search data"
        },
        viewNextSearchDataArialabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.view-next-search-data-arialabel",
            "defaultMessage": "View next search data"
        },
        clearSearchDataArialabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.clear-search-data-arialabel",
            "defaultMessage": "Clear search data"
        },
        searchIconLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.search-icon-label",
            "defaultMessage": "Search"
        }
    });
});
parcelRegister("iK4cj", function(module, exports) {
    $parcel$export(module.exports, "disabled", ()=>$da4fc76dd6e75481$export$683472f6198a076e, (v)=>$da4fc76dd6e75481$export$683472f6198a076e = v);
    $parcel$export(module.exports, "iconWrapper", ()=>$da4fc76dd6e75481$export$38e6d710c8ae6ec3, (v)=>$da4fc76dd6e75481$export$38e6d710c8ae6ec3 = v);
    $parcel$export(module.exports, "justifyCentered", ()=>$da4fc76dd6e75481$export$dac91f10ba0a2944, (v)=>$da4fc76dd6e75481$export$dac91f10ba0a2944 = v);
    $parcel$export(module.exports, "searchIconWrapper", ()=>$da4fc76dd6e75481$export$908581d7efaaac0d, (v)=>$da4fc76dd6e75481$export$908581d7efaaac0d = v);
    $parcel$export(module.exports, "searchSummaryContainer", ()=>$da4fc76dd6e75481$export$6e9fe1cbf67e5c6, (v)=>$da4fc76dd6e75481$export$6e9fe1cbf67e5c6 = v);
    $parcel$export(module.exports, "summaryCount", ()=>$da4fc76dd6e75481$export$9d29bafa0761180, (v)=>$da4fc76dd6e75481$export$9d29bafa0761180 = v);
    var $da4fc76dd6e75481$export$683472f6198a076e;
    var $da4fc76dd6e75481$export$38e6d710c8ae6ec3;
    var $da4fc76dd6e75481$export$dac91f10ba0a2944;
    var $da4fc76dd6e75481$export$908581d7efaaac0d;
    var $da4fc76dd6e75481$export$6e9fe1cbf67e5c6;
    var $da4fc76dd6e75481$export$9d29bafa0761180;
    $da4fc76dd6e75481$export$683472f6198a076e = `QjmutW_disabled`;
    $da4fc76dd6e75481$export$38e6d710c8ae6ec3 = `QjmutW_iconWrapper`;
    $da4fc76dd6e75481$export$dac91f10ba0a2944 = `QjmutW_justifyCentered`;
    $da4fc76dd6e75481$export$908581d7efaaac0d = `QjmutW_searchIconWrapper`;
    $da4fc76dd6e75481$export$6e9fe1cbf67e5c6 = `QjmutW_searchSummaryContainer`;
    $da4fc76dd6e75481$export$9d29bafa0761180 = `QjmutW_summaryCount`;
});
parcelRegister("aLFO3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2e88357255431f1$export$2e2bcd8739ae039);
    var $bC2fB;
    var $bVuca = parcelRequire("bVuca");
    var $4xWtu = parcelRequire("4xWtu");
    var $iLW5z = parcelRequire("iLW5z");
    var $a2e88357255431f1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $4xWtu.default), (0, $bVuca.default))((0, $iLW5z.ViewModeSwitcher));
});
parcelRegister("bVuca", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a640e21320e1748$export$2e2bcd8739ae039);
    var $dQ2Hi = parcelRequire("dQ2Hi");
    const $1a640e21320e1748$var$mapDispatchToProps = {
        changeViewMode: $dQ2Hi.changeViewMode
    };
    var $1a640e21320e1748$export$2e2bcd8739ae039 = $1a640e21320e1748$var$mapDispatchToProps;
});
parcelRegister("4xWtu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$371919352ee098f6$export$2e2bcd8739ae039);
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    const $371919352ee098f6$var$mapStateToProps = (0, $3YtPS.createStructuredSelector)({
        mode: (0, $kWDpn.getViewMode)
    });
    var $371919352ee098f6$export$2e2bcd8739ae039 = $371919352ee098f6$var$mapStateToProps;
});
parcelRegister("iLW5z", function(module, exports) {
    $parcel$export(module.exports, "ViewModeSwitcher", ()=>$f269a8548a17a698$export$d5ac5813985c55c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $kMSay;
    var $koVbs;
    var $3J2mc;
    var $86zlq;
    var $ihPUd = parcelRequire("ihPUd");
    var $8zOmE;
    var $2NMNM;
    var $1aUn4;
    var $8XvK6 = parcelRequire("8XvK6");
    const $f269a8548a17a698$export$d5ac5813985c55c6 = ({ mode: mode, changeViewMode: changeViewMode })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const tracePress = (0, (0, parcelRequire("kMSay")).default)('arj-toggle-view-mode');
        const testIdPrefix = 'portfolio-3-portfolio.app-simple-plans.top.page-header.view-mode-switcher.toggle-button.';
        const options = [
            {
                id: (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE,
                label: formatMessage((0, $ihPUd.default).timeline),
                testId: `${testIdPrefix}${(0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE}`
            },
            {
                id: (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST,
                label: formatMessage((0, $8XvK6.default).listOptionLabel),
                testId: `${testIdPrefix}${(0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST}`
            }
        ];
        const onChange = (0, $5uXOq.useCallback)((viewMode, event)=>{
            tracePress(event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'viewMode', {
                viewMode: viewMode
            });
            changeViewMode(viewMode);
        }, [
            tracePress,
            changeViewMode,
            createAnalyticsEvent
        ]);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            tracePress(event.timeStamp);
            const viewMode = mode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE ? (0, (0, parcelRequire("3J2mc")).VIEW_MODES).LIST : (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE;
            changeViewMode(viewMode);
        }, [
            tracePress,
            changeViewMode,
            mode
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86zlq")).UseShortcuts), {
            shortcutKey: "KeyL",
            onKeyDown: onKeyDown
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aUn4")).default), {
            label: formatMessage((0, $8XvK6.default).toggleButtonsLabel),
            options: options,
            selectedOption: mode,
            onChange: onChange
        }));
    };
});
parcelRegister("1aUn4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3938a8ce9ce3c5ba$export$2e2bcd8739ae039);
    var $7XYc4;
    var $dCm1o;
    var $6maaD;
    var $1AOfx;
    var $3938a8ce9ce3c5ba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), (0, (0, parcelRequire("6maaD")).ToggleButtons), (0, (0, parcelRequire("1AOfx")).default));
});
parcelRegister("6maaD", function(module, exports) {
    $parcel$export(module.exports, "ToggleButtons", ()=>$5bbd957d88c15d3d$export$34301fadafd0cd9d);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    const $5bbd957d88c15d3d$export$34301fadafd0cd9d = ({ options: options, selectedOption: selectedOption, onChange: onChange, label: label, isCompact: isCompact })=>{
        const getButtonWithContext = (0, $5uXOq.useCallback)(({ option: option, isSelected: isSelected })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                key: option.id,
                role: "radio",
                "aria-checked": isSelected,
                xcss: [
                    $5bbd957d88c15d3d$var$baseStyles,
                    !isCompact && $5bbd957d88c15d3d$var$wideStyles,
                    isSelected && $5bbd957d88c15d3d$var$selectedStyles
                ],
                onClick: (event)=>!isSelected && onChange(option.id, event),
                isDisabled: option.isDisabled,
                testId: option.testId
            }, option.label), [
            onChange,
            isCompact
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            role: "radiogroup",
            xcss: $5bbd957d88c15d3d$var$containerStyles,
            "aria-label": label,
            as: "fieldset"
        }, options.map((option)=>getButtonWithContext({
                option: option,
                isSelected: option.id === selectedOption
            }))));
    };
    const $5bbd957d88c15d3d$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderColor: 'color.border',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: "var(--ds-border-radius-100, 4px)",
        paddingInline: 'space.025',
        gap: 'space.025',
        display: 'inline-flex',
        alignItems: 'center',
        height: '2rem'
    });
    const $5bbd957d88c15d3d$var$baseStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-neutral-subtle, #00000000)",
        border: '1px solid transparent',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        color: 'color.text.subtle',
        height: '26px',
        fontWeight: '500',
        padding: 'space.0',
        ':hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            color: 'color.text.subtle'
        },
        ':active': {
            background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
            color: 'color.text.subtle'
        },
        ':focus': {
            outlineOffset: 'space.0'
        },
        ':disabled': {
            background: "var(--ds-background-disabled, #091E4208)",
            color: 'color.text.disabled'
        }
    });
    const $5bbd957d88c15d3d$var$selectedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-selected, #E9F2FF)",
        border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
        color: 'color.text.selected',
        cursor: 'default',
        ':hover': {
            background: "var(--ds-background-selected, #E9F2FF)",
            color: 'color.text.selected'
        }
    });
    const $5bbd957d88c15d3d$var$wideStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.150',
        paddingRight: 'space.150'
    });
});
parcelRegister("1AOfx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3d0d9bc4668d1db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gwIPs;
    var $iR4uK;
    var $gmQXa;
    let $b3d0d9bc4668d1db$var$uniqueId = 0;
    var $b3d0d9bc4668d1db$export$2e2bcd8739ae039 = ({ label: label, options: options, selectedOption: selectedOption, onChange: onChange })=>{
        (0, (0, parcelRequire("gmQXa")).assertPrecondition)(()=>({
                precondition: options.length > 0,
                message: `ToggleButtons requires at least one option, but received ${options.length}`
            }));
        (0, (0, parcelRequire("gmQXa")).assertPrecondition)(()=>({
                precondition: (0, (0, parcelRequire("gmQXa")).findDuplicateIds)(options) === null,
                message: `ToggleButtons requires that every option has a unique ID, but received "${(0, (0, parcelRequire("gmQXa")).findDuplicateIds)(options)}" multiple times`
            }));
        (0, (0, parcelRequire("gmQXa")).assertPrecondition)(()=>({
                precondition: options.findIndex((option)=>option.id === selectedOption) !== -1,
                message: `ToggleButtons requires that the selectedOption matches the ID of one of the passed options, but "${selectedOption}" did not`
            }));
        const [id] = (0, $5uXOq.useState)(()=>`toggle-buttons-${$b3d0d9bc4668d1db$var$uniqueId++}`);
        const fieldsetRef = (0, $5uXOq.useRef)(null);
        const selectedOptionRef = (0, $5uXOq.useRef)();
        const [selectedOptionPosition, setSelectedOptionPosition] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            const fieldset = fieldsetRef.current;
            if (!fieldset || !window.ResizeObserver) return ()=>{};
            const resizeObserver = new window.ResizeObserver(()=>{
                const element = selectedOptionRef.current;
                if (element) setSelectedOptionPosition({
                    left: element.offsetLeft,
                    top: element.offsetTop,
                    width: element.offsetWidth,
                    height: element.offsetHeight
                });
            });
            resizeObserver.observe(fieldset);
            return ()=>{
                resizeObserver.unobserve(fieldset);
            };
        }, [
            selectedOption
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b3d0d9bc4668d1db$var$Fieldset, {
            ref: fieldsetRef,
            selectedOptionPosition: selectedOptionPosition
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("legend", null, label), options.map((option)=>{
            const isChecked = selectedOption === option.id;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iR4uK")).default), {
                key: option.id,
                name: id,
                value: option.id,
                isChecked: isChecked,
                isDisabled: !!option.isDisabled,
                onChange: onChange,
                ref: isChecked ? selectedOptionRef : undefined,
                testId: option.testId
            }, option.label);
        }));
    };
    const $b3d0d9bc4668d1db$var$selectedOptionIndicator = {
        backgroundColor: `${`var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N0})`} !important`,
        borderRadius: `${(0, (0, parcelRequire("gwIPs")).borderRadius)}px !important`
    };
    const $b3d0d9bc4668d1db$var$Fieldset = (0, $5uXOq.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedOptionPosition: selectedOptionPosition, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_ozn9do": (0, (0, parcelRequire("lD23V")).default)(__cmplp.selectedOptionPosition?.left, "px"),
                "--_1ibdxcf": (0, (0, parcelRequire("lD23V")).default)(__cmplp.selectedOptionPosition?.top, "px"),
                "--_1ggrzjo": (0, (0, parcelRequire("lD23V")).default)(__cmplp.selectedOptionPosition?.width, "px"),
                "--_1797z6d": (0, (0, parcelRequire("lD23V")).default)(__cmplp.selectedOptionPosition?.height, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1n261g80 _1bsb1ris _p12f1osq _kqswh2mm _bfhk1s4m _2rko1l7b _1yt41b66 _11c8qk37 _k48p1pd9 _vwz41clk _1p1dangw _syazaj1x _1r9t7mnp _ho6m1wmp _soiet94y _1se6t94y _1jdg1n1a _z71v1n1a _1o5t1n1a _irrs1n1a _p8t715vq _b4u715vq _1qiiidpf _12o6idpf _19mbidpf _1ob8idpf _1jhnstnw _10bvh2mm _1nvfze3t _1nei1b66 _rt2pze3t _bmksze3t _fhioidpf _1kt9b3bt _1cs8stnw _1rus1tag _rfx31wa3 _qs2z1l1k _1cg61yx9 _mlfedkwg",
                __cmplp.selectedOptionPosition ? "_cfu11ule" : "_cfu1glyw",
                __cmplp.selectedOptionPosition?.left ? "_qnecejz7" : "_qnecidpf",
                __cmplp.selectedOptionPosition?.top ? "_1auk1nuc" : "_1aukidpf",
                __cmplp.selectedOptionPosition?.width ? "_1mp412nj" : "_1mp4idpf",
                __cmplp.selectedOptionPosition?.height ? "_kfgt1d85" : "_kfgtidpf",
                !__cmplp.selectedOptionPosition && "_15e91tag _1ph31wa3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iR4uK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e56adc76929ce8ab$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $e56adc76929ce8ab$export$2e2bcd8739ae039 = (0, $5uXOq.forwardRef)(({ name: name, value: value, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, children: children, testId: testId }, ref)=>{
        const id = `${name}-${value}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e56adc76929ce8ab$var$Container, {
            ref: ref
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            type: "radio",
            id: id,
            name: name,
            value: value,
            checked: isChecked,
            disabled: isDisabled,
            "data-testid": testId,
            onChange: (event)=>onChange(value, event)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("label", {
            htmlFor: id
        }, children));
    });
    const $e56adc76929ce8ab$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11127mnp _1q091wmp _pytkt94y _5hv9t94y _2x4g1n1a _12hv1n1a _x5bd1n1a _1rgf1n1a _1yzy15vq _bgrh15vq _v69yidpf _ogxmidpf _1qtqidpf _n9z4idpf _khufstnw _15pj1ule _136ejjoz _1vzltlke _1ioh1l7b _1hhy73ad _1emz73ad _1efl8q0r _7el91vt6 _15pqglyw _vrjh14ae _c2fy18uv _ynfu18uv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gmQXa", function(module, exports) {
    $parcel$export(module.exports, "findDuplicateIds", ()=>$1d35542953a1be7d$export$e5f5e25214715ca1);
    $parcel$export(module.exports, "assertPrecondition", ()=>$1d35542953a1be7d$export$5565eefbe4b468a0);
    const $1d35542953a1be7d$export$e5f5e25214715ca1 = (options)=>{
        for(let i = 0; i < options.length - 1; ++i)for(let j = i + 1; j < options.length; ++j){
            if (options[i].id === options[j].id) return options[i].id;
        }
        return null;
    };
    const $1d35542953a1be7d$export$5565eefbe4b468a0 = (evaluatePrecondition)=>{};
});
parcelRegister("8XvK6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b90e4f3ca8b8057$export$2e2bcd8739ae039);
    var $7VHMR;
    const $3b90e4f3ca8b8057$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        toggleButtonsLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.view-mode-switcher.toggle-buttons-label",
            "defaultMessage": "Select view mode"
        },
        listOptionLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.view-mode-switcher.list-option-label",
            "defaultMessage": "List"
        }
    });
    var $3b90e4f3ca8b8057$export$2e2bcd8739ae039 = $3b90e4f3ca8b8057$var$messages;
});
parcelRegister("01qsx", function(module, exports) {
    $parcel$export(module.exports, "PageHeader", ()=>$7c8ae376ef5a51c6$export$53f1cd6809577fc5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fuUnn;
    var $jbeEq;
    var $lj8SI;
    var $cS37j;
    var $koVbs;
    var $4wFog = parcelRequire("4wFog");
    var $8gDdC = parcelRequire("8gDdC");
    const $7c8ae376ef5a51c6$export$53f1cd6809577fc5 = ({ mode: mode, title: title, actions: actions, titleDecorators: titleDecorators, plan: plan, showPlanTitle: showPlanTitle = false, isReadOnly: isReadOnly = false, isArchived: isArchived = false, withBreadcrumbs: withBreadcrumbs = true })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (mode === (0, $ab4be2e1e204af69$export$e91bb82ec00eb771)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4wFog.default), null);
        const { id: id, scenarios: scenarios, currentScenarioId: currentScenarioId, title: planTitle, multiScenarioEnabled: multiScenarioEnabled } = plan;
        const scenarioTitle = scenarios && scenarios.find((s)=>s.id === currentScenarioId)?.title || '';
        const getTitle = ()=>{
            if (showPlanTitle) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, planTitle, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, " / ", title));
            return title;
        };
        const headerTitle = getTitle();
        const breadcrumbs = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jbeEq")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuUnn")).default), {
            text: formatMessage((0, $8gDdC.default).breadcrumbTitle),
            href: "/jira/plans/"
        }), planTitle && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuUnn")).default), {
            truncationWidth: 300,
            text: `${planTitle}`,
            href: `/jira/plans/${id}/`
        }), multiScenarioEnabled && scenarioTitle && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fuUnn")).default), {
            truncationWidth: 300,
            text: `${scenarioTitle}`,
            href: `/jira/plans/${id}/scenarios/${currentScenarioId}/timeline`
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            disableTitleStyles: true,
            truncateTitle: true,
            actions: (0, ($parcel$interopDefault($5uXOq))).createElement($7c8ae376ef5a51c6$var$FiltersContainer, null, actions),
            breadcrumbs: withBreadcrumbs ? breadcrumbs : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c8ae376ef5a51c6$var$TitleWrapper, null, headerTitle && (0, ($parcel$interopDefault($5uXOq))).createElement($7c8ae376ef5a51c6$var$Heading, null, headerTitle), isReadOnly && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            isBold: true
        }, formatMessage((0, $8gDdC.default).readOnly)), isArchived && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            isBold: true
        }, formatMessage((0, $8gDdC.default).archived)), titleDecorators)));
    };
    const $7c8ae376ef5a51c6$var$Heading = (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _vwz4xy5q _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _1bto1l2s _o5721q9c _11c81p5s _k48p1wq8",
                __cmplp.className
            ])
        });
    });
    const $7c8ae376ef5a51c6$var$TitleWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulpu2gc _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $7c8ae376ef5a51c6$var$FiltersContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _o5724jg8 _zulp1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $57MwZ;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("57MwZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9694e728fd1ea060$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eeGIy;
    const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;
});
parcelRegister("eeGIy", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$0c196d37a4e8266c$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$0c196d37a4e8266c$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$0c196d37a4e8266c$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$0c196d37a4e8266c$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$0c196d37a4e8266c$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$0c196d37a4e8266c$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c196d37a4e8266c$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0c196d37a4e8266c$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $0c196d37a4e8266c$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $0c196d37a4e8266c$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $0c196d37a4e8266c$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $0c196d37a4e8266c$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $0c196d37a4e8266c$var$bottomBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$outerStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $0c196d37a4e8266c$var$titleStyles,
                truncateTitle && $0c196d37a4e8266c$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleWrapperStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleContainerStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$actionStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0c196d37a4e8266c$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("4wFog", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63fd11771330a95f$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3vRrb = parcelRequire("3vRrb");
    var $6ATpv = parcelRequire("6ATpv");
    var $gca6r = parcelRequire("gca6r");
    var $63fd11771330a95f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6ATpv.default), (0, $3vRrb.default))((0, $gca6r.default));
});
parcelRegister("3vRrb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6422406c9bc65756$export$2e2bcd8739ae039);
    var $f8C8L = parcelRequire("f8C8L");
    const $6422406c9bc65756$var$mapDispatchToProps = (dispatch)=>({
            onApply: ()=>{
                dispatch((0, $f8C8L.applyChange)());
            },
            onCancel: ()=>{
                dispatch((0, $f8C8L.cancelOptimize)());
            }
        });
    var $6422406c9bc65756$export$2e2bcd8739ae039 = $6422406c9bc65756$var$mapDispatchToProps;
});
parcelRegister("6ATpv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60208800008a2bf3$export$2e2bcd8739ae039);
    var $jLI87 = parcelRequire("jLI87");
    var $cZF7S = parcelRequire("cZF7S");
    var $3YtPS = parcelRequire("3YtPS");
    var $60208800008a2bf3$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        allIssues: (0, $jLI87.getAllIssuesWithOriginalAndOptimized),
        filteredIssues: (0, $jLI87.getIssuesWithOriginalsAndOptimized),
        isLatest: (0, $cZF7S.getIsSolutionLatest),
        progress: (0, $cZF7S.getApplyingProgress)
    });
});
parcelRegister("gca6r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f288b10809ec5e70$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yOBd;
    var $ldJSL;
    var $f5TWP;
    var $8CUq3;
    var $ousew;
    var $8RXs9;
    var $aCpcO;
    var $enoTt;
    var $i2qlb = parcelRequire("i2qlb");
    var $l38L3 = parcelRequire("l38L3");
    var $4nDwW = parcelRequire("4nDwW");
    var $ihPUd = parcelRequire("ihPUd");
    var $8zOmE;
    var $i43VC = parcelRequire("i43VC");
    var $8BWZG = parcelRequire("8BWZG");
    var $ax4Wp = parcelRequire("ax4Wp");
    class $f288b10809ec5e70$var$ApplyOptimisation extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            if ((0, $4nDwW.isDefined)(props.progress) && !props.isLatest && !state.isDialogOpen) return {
                isDialogOpen: true
            };
            return null;
        }
        render() {
            if (this.state.isDialogOpen) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $i43VC.default), {
                closeDialog: this.closeDialog
            });
            const { allIssues: allIssues, filteredIssues: filteredIssues, intl: intl, onApply: onApply, progress: progress } = this.props;
            const optimizedFilteredIssuesCount = filteredIssues.filter(this.isOptimized).length || 0;
            const optimizedAllIssuesCount = allIssues.filter(this.isOptimized).length || 0;
            const issueCountMessage = optimizedFilteredIssuesCount === optimizedAllIssuesCount ? intl.formatMessage((0, $8BWZG.default).previewingAllIssues, {
                issueCount: optimizedFilteredIssuesCount,
                strong: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                        as: "span",
                        xcss: $f288b10809ec5e70$var$inlineDisplay
                    }, chunk)
            }) : intl.formatMessage((0, $8BWZG.default).previewingFilteredIssues, {
                filteredIssueCount: optimizedFilteredIssuesCount,
                allIssueCount: optimizedAllIssuesCount,
                strong: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                        as: "span",
                        xcss: $f288b10809ec5e70$var$inlineDisplay
                    }, chunk)
            });
            const applyingButtonTheme = (current, themeProps)=>({
                    ...current(themeProps),
                    buttonStyles: {
                        ...current(themeProps).buttonStyles,
                        background: `var(--ds-background-information, ${(0, $829f609a65d26a98$exports).N10A})`,
                        color: `var(--ds-text-information, ${(0, $829f609a65d26a98$exports).N60})`
                    }
                });
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ax4Wp.spaPreviewResultsOverlay
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ax4Wp.spaPreviewHeaderSection
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ax4Wp.previewTitle
            }, issueCountMessage), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ax4Wp.actionButtons
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                onClick: this.handleCancelClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                className: $ax4Wp.cancelButton
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $ihPUd.default).cancel))), (0, $4nDwW.isDefined)(progress) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
                isDisabled: true,
                onClick: onApply,
                iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("enoTt")).default), null),
                theme: applyingButtonTheme
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $8BWZG.default).applying,
                values: {
                    progress: progress
                }
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                appearance: "primary",
                onClick: onApply
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $8BWZG.default).apply))))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $ax4Wp.spaPreviewDescription
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $8BWZG.default).previewingIssuesDescription))));
        }
        constructor(...args){
            super(...args);
            this.state = {
                isDialogOpen: false
            };
            this.closeDialog = ()=>{
                this.setState({
                    isDialogOpen: false
                });
            };
            this.isOptimized = (issue)=>{
                let isOptimized = false;
                if ((0, $4nDwW.isDefined)(issue.optimized)) {
                    for (const [optimizedKey, optimizedValue] of Object.entries(issue.optimized))if ((0, $l38L3.hasValueChanged)((0, $l38L3.getCurrentValue)(issue, optimizedKey), optimizedValue)) {
                        isOptimized = true;
                        break;
                    }
                }
                return isOptimized;
            };
            this.handleCancelClick = (_, analyticsEvent)=>{
                this.props.onCancel();
                const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_CANCEL_OPTIMIZATION.split(' ');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                    action: eventAction,
                    actionSubject: actionSubject
                }));
            };
        }
    }
    var $f288b10809ec5e70$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($f288b10809ec5e70$var$ApplyOptimisation);
    const $f288b10809ec5e70$var$inlineDisplay = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline',
        fontWeight: 'bold'
    });
});
parcelRegister("i43VC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e596e613c72dcb1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $5LWLA;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $ousew;
    var $koVbs;
    var $aCpcO;
    var $022Ki = parcelRequire("022Ki");
    var $ihPUd = parcelRequire("ihPUd");
    var $idmiV = parcelRequire("idmiV");
    var $93lL7 = parcelRequire("93lL7");
    var $1ixrC = parcelRequire("1ixrC");
    function $7e596e613c72dcb1$export$2e2bcd8739ae039({ closeDialog: closeDialog }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const refreshButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            onClick: (0, $idmiV.reload),
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $93lL7.default).modalRefreshBtn));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: true,
            onClose: closeDialog
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, $93lL7.default).modalHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $1ixrC["modal-body"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: "",
            dangerouslySetGlyph: (0, ($parcel$interopDefault($022Ki)))
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $93lL7.default).notLatestMessage), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $93lL7.default).refreshMessage,
            values: {
                refreshButton: refreshButton
            }
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: closeDialog
        }, formatMessage((0, $ihPUd.default).cancel)))));
    }
});
parcelRegister("022Ki", function(module, exports) {
    module.exports = "<svg width=\"200\" height=\"184\" xmlns=\"http://www.w3.org/2000/svg\"><defs><linearGradient x1=\"0%\" y1=\"50.007%\" x2=\"99.999%\" y2=\"50.007%\" id=\"a\"><stop stop-color=\"#6C798F\" offset=\"0%\"></stop><stop stop-color=\"#6C798F\" stop-opacity=\".1\" offset=\"100%\"></stop></linearGradient><linearGradient x1=\"-6635.484%\" y1=\"-2%\" y2=\"-2%\" id=\"b\"><stop stop-color=\"#99C1FF\" stop-opacity=\"0\" offset=\"0%\"></stop><stop stop-color=\"#93BEFF\" stop-opacity=\".04\" offset=\"1%\"></stop><stop stop-color=\"#78ADFF\" stop-opacity=\".22\" offset=\"5%\"></stop><stop stop-color=\"#5E9EFF\" stop-opacity=\".38\" offset=\"9%\"></stop><stop stop-color=\"#4790FF\" stop-opacity=\".53\" offset=\"14%\"></stop><stop stop-color=\"#3484FF\" stop-opacity=\".66\" offset=\"20%\"></stop><stop stop-color=\"#247AFF\" stop-opacity=\".77\" offset=\"25%\"></stop><stop stop-color=\"#1672FF\" stop-opacity=\".85\" offset=\"32%\"></stop><stop stop-color=\"#0C6CFF\" stop-opacity=\".92\" offset=\"40%\"></stop><stop stop-color=\"#0568FF\" stop-opacity=\".97\" offset=\"49%\"></stop><stop stop-color=\"#0166FF\" stop-opacity=\".99\" offset=\"63%\"></stop><stop stop-color=\"#0065FF\" offset=\"100%\"></stop></linearGradient><linearGradient x1=\"0%\" y1=\"14049%\" x2=\"10440%\" y2=\"14049%\" id=\"c\"><stop stop-color=\"#99C1FF\" stop-opacity=\"0\" offset=\"0%\"></stop><stop stop-color=\"#93BEFF\" stop-opacity=\".04\" offset=\"1%\"></stop><stop stop-color=\"#78ADFF\" stop-opacity=\".22\" offset=\"5%\"></stop><stop stop-color=\"#5E9EFF\" stop-opacity=\".38\" offset=\"9%\"></stop><stop stop-color=\"#4790FF\" stop-opacity=\".53\" offset=\"14%\"></stop><stop stop-color=\"#3484FF\" stop-opacity=\".66\" offset=\"20%\"></stop><stop stop-color=\"#247AFF\" stop-opacity=\".77\" offset=\"25%\"></stop><stop stop-color=\"#1672FF\" stop-opacity=\".85\" offset=\"32%\"></stop><stop stop-color=\"#0C6CFF\" stop-opacity=\".92\" offset=\"40%\"></stop><stop stop-color=\"#0568FF\" stop-opacity=\".97\" offset=\"49%\"></stop><stop stop-color=\"#0166FF\" stop-opacity=\".99\" offset=\"63%\"></stop><stop stop-color=\"#0065FF\" offset=\"100%\"></stop></linearGradient></defs><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M106 167.73v-39.56A40.57 40.57 0 1 0 65.45 87.6H25.88c-.004-32.416 19.521-61.643 49.47-74.049 29.948-12.406 64.42-5.548 87.341 17.375 22.92 22.923 29.774 57.397 17.364 87.344-12.41 29.947-41.639 49.468-74.055 49.46z\" fill=\"url(#a)\" transform=\"translate(-1 8)\"></path><path d=\"M101.85 169.27v-39.56c22.406 0 40.57-18.164 40.57-40.57s-18.164-40.57-40.57-40.57-40.57 18.164-40.57 40.57H21.71C21.71 44.88 57.59 9 101.85 9s80.14 35.88 80.14 80.14-35.88 80.14-80.14 80.14v-.01z\" fill=\"#0065FF\"></path><path d=\"M182 89.14c.088-42.717-33.345-77.995-76.005-80.199-42.66-2.204-79.55 29.44-83.865 71.939L8.75 79.67a3.06 3.06 0 0 0-2.62 5l30.56 36.63c1.08 1.3 3 1.47 3.4.39l36.63-30.57c3-1.75 1.93-5.15-.78-5.4l-14.38-1.3c2.525-21.65 21.705-37.435 43.436-35.748 21.731 1.686 38.246 20.242 37.4 42.022-.846 21.78-18.75 39-40.546 38.996h1.55v39.53c43.618-.876 78.538-36.453 78.6-80.08z\" fill=\"#0065FF\"></path><path d=\"M104.4 161.27h-1.55 1.55z\" fill=\"url(#b)\" transform=\"translate(-1 8)\"></path><path fill=\"url(#c)\" d=\"M0 121.71h102.85v39.57H0z\" transform=\"translate(-1 8)\"></path><path d=\"M101.85 129.71v39.57h1.55v-39.57h-1.55z\" fill=\"#0065FF\"></path><path d=\"M102.85 121.71v39.57h1.55v-39.57h-1.55z\" fill=\"url(#c)\" transform=\"translate(-1 8)\"></path></g></svg>";
});
parcelRegister("93lL7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a34e8035b26a91ba$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a34e8035b26a91ba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        modalHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.dialog.modal-header",
            "defaultMessage": "Applying changes"
        },
        modalRefreshBtn: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.dialog.modal-refresh-btn",
            "defaultMessage": "Refresh"
        },
        notLatestMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.dialog.not-latest-message",
            "defaultMessage": "Changes are out of sync due to concurrent auto-scheduling."
        },
        refreshMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.dialog.refresh-message",
            "defaultMessage": "{refreshButton} to see the latest changes."
        }
    });
});
parcelRegister("1ixrC", function(module, exports) {
    $parcel$export(module.exports, "modal-body", ()=>$0f216a470261822d$export$2f7d9971875d27cc, (v)=>$0f216a470261822d$export$2f7d9971875d27cc = v);
    var $0f216a470261822d$export$2f7d9971875d27cc;
    $0f216a470261822d$export$2f7d9971875d27cc = `hacwPa_modal-body`;
});
parcelRegister("8BWZG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ddebc5d08707eca$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7ddebc5d08707eca$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        apply: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.apply",
            "defaultMessage": "Accept changes"
        },
        applying: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.applying",
            "defaultMessage": "Applying changes ({progress}%)"
        },
        previewingAllIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.previewing-all-issues",
            "defaultMessage": "Previewing a total of <strong>{issueCount}</strong> auto-scheduled issues"
        },
        previewingFilteredIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.previewing-filtered-issues",
            "defaultMessage": "Previewing <strong>{filteredIssueCount}</strong> of <strong>{allIssueCount}</strong> auto-scheduled issues"
        },
        previewingIssuesDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.previewing-issues-description",
            "defaultMessage": "By accepting, your plan will be updated with these changes. You'll still need to review and save all changes in your plan to Jira."
        }
    });
});
parcelRegister("ax4Wp", function(module, exports) {
    $parcel$export(module.exports, "actionButtons", ()=>$7ab0d19eefa23850$export$b6fb1741c7f64881, (v)=>$7ab0d19eefa23850$export$b6fb1741c7f64881 = v);
    $parcel$export(module.exports, "cancelButton", ()=>$7ab0d19eefa23850$export$4ededb8e5b56a6fb, (v)=>$7ab0d19eefa23850$export$4ededb8e5b56a6fb = v);
    $parcel$export(module.exports, "previewTitle", ()=>$7ab0d19eefa23850$export$435aa072d3c70d67, (v)=>$7ab0d19eefa23850$export$435aa072d3c70d67 = v);
    $parcel$export(module.exports, "spaPreviewDescription", ()=>$7ab0d19eefa23850$export$8bec8fcb49760d0a, (v)=>$7ab0d19eefa23850$export$8bec8fcb49760d0a = v);
    $parcel$export(module.exports, "spaPreviewHeaderSection", ()=>$7ab0d19eefa23850$export$949d9c874bca1a72, (v)=>$7ab0d19eefa23850$export$949d9c874bca1a72 = v);
    $parcel$export(module.exports, "spaPreviewResultsOverlay", ()=>$7ab0d19eefa23850$export$51725f5aed7fd5b7, (v)=>$7ab0d19eefa23850$export$51725f5aed7fd5b7 = v);
    var $7ab0d19eefa23850$export$b6fb1741c7f64881;
    var $7ab0d19eefa23850$export$4ededb8e5b56a6fb;
    var $7ab0d19eefa23850$export$435aa072d3c70d67;
    var $7ab0d19eefa23850$export$8bec8fcb49760d0a;
    var $7ab0d19eefa23850$export$949d9c874bca1a72;
    var $7ab0d19eefa23850$export$51725f5aed7fd5b7;
    $7ab0d19eefa23850$export$b6fb1741c7f64881 = `x0kt5W_actionButtons`;
    $7ab0d19eefa23850$export$4ededb8e5b56a6fb = `x0kt5W_cancelButton`;
    $7ab0d19eefa23850$export$435aa072d3c70d67 = `x0kt5W_previewTitle`;
    $7ab0d19eefa23850$export$8bec8fcb49760d0a = `x0kt5W_spaPreviewDescription`;
    $7ab0d19eefa23850$export$949d9c874bca1a72 = `x0kt5W_spaPreviewHeaderSection`;
    $7ab0d19eefa23850$export$51725f5aed7fd5b7 = `x0kt5W_spaPreviewResultsOverlay`;
});
parcelRegister("8gDdC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d34df12b88b17fa7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d34df12b88b17fa7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pageTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.page-title",
            "defaultMessage": "Timeline"
        },
        breadcrumbTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.breadcrumb-title",
            "defaultMessage": "Plans"
        },
        readOnly: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.read-only",
            "defaultMessage": "Read-Only"
        },
        archived: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.archived",
            "defaultMessage": "Archived"
        }
    });
});
parcelRegister("jtvPP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec84c37f60c6fede$export$2e2bcd8739ae039);
    var $bC2fB;
    var $dFBY7 = parcelRequire("dFBY7");
    var $eV4Pz = parcelRequire("eV4Pz");
    var $1gTWL = parcelRequire("1gTWL");
    var $ec84c37f60c6fede$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $eV4Pz.default), (0, $dFBY7.default))((0, $1gTWL.default));
});
parcelRegister("dFBY7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74311c9bc4a0a26d$export$2e2bcd8739ae039);
    var $lHoMG = parcelRequire("lHoMG");
    var $lUlnG = parcelRequire("lUlnG");
    var $74311c9bc4a0a26d$export$2e2bcd8739ae039 = {
        createScenario: $lHoMG.createScenario,
        toggleDialogVisibility: $lUlnG.toggleDialogVisibility
    };
});
parcelRegister("lHoMG", function(module, exports) {
    $parcel$export(module.exports, "enableScenarios", ()=>$36b0f61e7a225398$export$2069dd79b5cbd8b2);
    $parcel$export(module.exports, "createScenario", ()=>$36b0f61e7a225398$export$eb4b17f0922257e2);
    $parcel$export(module.exports, "deleteScenario", ()=>$36b0f61e7a225398$export$2aa284e9acf25212);
    $parcel$export(module.exports, "disableScenarios", ()=>$36b0f61e7a225398$export$8efa580e75af7168);
    $parcel$export(module.exports, "updateScenario", ()=>$36b0f61e7a225398$export$7d797dece46a4b0a);
    $parcel$export(module.exports, "default", ()=>$36b0f61e7a225398$export$2e2bcd8739ae039);
    var $83IGl;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $idmiV = parcelRequire("idmiV");
    var $bHTqr = parcelRequire("bHTqr");
    var $jZcxq = parcelRequire("jZcxq");
    var $lUlnG = parcelRequire("lUlnG");
    var $77QEM = parcelRequire("77QEM");
    var $24CMK = parcelRequire("24CMK");
    var $73zqP = parcelRequire("73zqP");
    const $36b0f61e7a225398$export$d5260d2dd06aa25 = 'command.scenarios.ENABLE_SCENARIOS';
    const $36b0f61e7a225398$export$726212a28c977994 = 'command.scenarios.CREATE_SCENARIO';
    const $36b0f61e7a225398$export$d0eccde1378805f6 = 'command.scenarios.DELETE_SCENARIO';
    const $36b0f61e7a225398$export$1c2ff7f28b1aacb1 = 'command.scenarios.DISABLE_SCENARIOS';
    const $36b0f61e7a225398$export$60e8b04bc54d4cc2 = 'command.scenarios.UPDATE_PLAN_SCENARIO';
    const $36b0f61e7a225398$export$2069dd79b5cbd8b2 = (payload)=>({
            type: $36b0f61e7a225398$export$d5260d2dd06aa25,
            payload: payload
        });
    const $36b0f61e7a225398$export$eb4b17f0922257e2 = (payload)=>({
            type: $36b0f61e7a225398$export$726212a28c977994,
            payload: payload
        });
    const $36b0f61e7a225398$export$2aa284e9acf25212 = (payload)=>({
            type: $36b0f61e7a225398$export$d0eccde1378805f6,
            payload: payload
        });
    const $36b0f61e7a225398$export$8efa580e75af7168 = (scenarioToKeepId)=>({
            type: $36b0f61e7a225398$export$1c2ff7f28b1aacb1,
            scenarioToKeepId: scenarioToKeepId
        });
    const $36b0f61e7a225398$export$7d797dece46a4b0a = (payload)=>({
            type: $36b0f61e7a225398$export$60e8b04bc54d4cc2,
            payload: payload
        });
    function* $36b0f61e7a225398$export$21845d2e88ce6583({ payload: payload }) {
        try {
            const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
            if (!planId) throw new Error('Plan id is not available');
            if (!currentScenarioId) throw new Error('Scenario id is not available');
            yield (0, $aNOuE.put)((0, $lUlnG.initiateRequest)());
            const body = {
                planId: planId,
                ...payload
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $73zqP.urls).enable, {
                method: (0, $77QEM.POST),
                body: body
            });
            yield (0, $aNOuE.put)((0, $lUlnG.toggleDialogVisibility)(false));
            yield (0, $aNOuE.put)((0, $lUlnG.completeRequest)());
            if (!response.ok) {
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                    requestInfo: {
                        url: (0, $73zqP.urls).scenarios,
                        type: (0, $77QEM.POST),
                        status: response.status,
                        body: body
                    }
                }));
                return;
            }
            yield (0, $aNOuE.put)((0, $jZcxq.enablePlanScenarios)([
                {
                    id: currentScenarioId,
                    planId: planId,
                    title: payload.title,
                    color: payload.color
                }
            ]));
        } catch (e) {
            yield (0, $aNOuE.put)((0, $lUlnG.completeRequest)());
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $36b0f61e7a225398$export$a613f554292bedd({ payload: { redirect: redirect, ...rest } }) {
        try {
            const { domain: { app: { browserHistory: browserHistory }, plan: { id: planId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
            if (!planId) throw new Error('Plan ID is missing');
            yield (0, $aNOuE.put)((0, $lUlnG.initiateRequest)());
            const body = {
                planId: planId,
                ...rest
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $73zqP.urls).scenarios, {
                method: (0, $77QEM.POST),
                body: body
            });
            yield (0, $aNOuE.put)((0, $lUlnG.toggleDialogVisibility)(false));
            yield (0, $aNOuE.put)((0, $lUlnG.completeRequest)());
            if (!response.ok) {
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                    requestInfo: {
                        url: (0, $73zqP.urls).scenarios,
                        type: (0, $77QEM.POST),
                        status: response.status,
                        body: body
                    }
                }));
                return;
            }
            const { id: id } = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.put)((0, $jZcxq.addPlanScenario)({
                id: id,
                planId: planId,
                title: rest.title,
                color: rest.color
            }));
            if (redirect && (0, $4nDwW.isDefined)(browserHistory)) yield (0, $aNOuE.call)((0, $idmiV.redirectToNewScenario), browserHistory, id);
        } catch (e) {
            yield (0, $aNOuE.put)((0, $lUlnG.completeRequest)());
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $36b0f61e7a225398$export$99fac75bb20ed97f({ payload: { scenarioId: scenarioId, title: title } }) {
        let deletedScenario;
        try {
            const { domain: { app: { browserHistory: browserHistory }, plan: { id: planId, currentScenarioId: currentScenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
            if (!planId) throw new Error('Plan ID is missing');
            deletedScenario = {
                id: scenarioId,
                title: title,
                planId: planId
            };
            yield (0, $aNOuE.put)((0, $jZcxq.removePlanScenario)(deletedScenario));
            const body = {
                planId: planId,
                scenarioId: scenarioId
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $73zqP.urls).delete, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!response.ok) {
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                    requestInfo: {
                        url: (0, $73zqP.urls).scenarios,
                        type: (0, $77QEM.POST),
                        status: response.status,
                        body: body
                    }
                }));
                yield (0, $aNOuE.put)((0, $jZcxq.addPlanScenario)(deletedScenario));
                return;
            }
            if (currentScenarioId === scenarioId && (0, $4nDwW.isDefined)(browserHistory)) {
                const scenarios = yield (0, $aNOuE.select)((0, $bHTqr.getPlanScenarios));
                yield (0, $aNOuE.call)((0, $idmiV.redirectToNewScenario), browserHistory, scenarios[0].id);
            }
        } catch (e) {
            if (deletedScenario) yield (0, $aNOuE.put)((0, $jZcxq.addPlanScenario)(deletedScenario));
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $36b0f61e7a225398$export$e7dcec382a8c3081({ scenarioToKeepId: scenarioToKeepId }) {
        const { domain: { app: { browserHistory: browserHistory }, plan: { id: planId, currentScenarioId: currentScenarioId, scenarios: scenarios } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        try {
            if (!planId) throw new Error('Plan ID is missing');
            yield (0, $aNOuE.put)((0, $jZcxq.disablePlanScenarios)(scenarioToKeepId));
            const body = {
                planId: planId,
                scenarioToKeepId: scenarioToKeepId
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $73zqP.urls).disable, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!response.ok) {
                yield (0, $aNOuE.put)((0, $jZcxq.enablePlanScenarios)(scenarios || []));
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                    requestInfo: {
                        url: (0, $73zqP.urls).scenarios,
                        type: (0, $77QEM.POST),
                        status: response.status,
                        body: body
                    }
                }));
                return;
            }
            if (currentScenarioId !== scenarioToKeepId && (0, $4nDwW.isDefined)(browserHistory)) {
                const scenarios = yield (0, $aNOuE.select)((0, $bHTqr.getPlanScenarios));
                yield (0, $aNOuE.call)((0, $idmiV.redirectToNewScenario), browserHistory, scenarios[0].id);
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $jZcxq.enablePlanScenarios)(scenarios || []));
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $36b0f61e7a225398$export$e1834d7eb47a78d7({ payload: payload }) {
        try {
            const { domain: { plan: { id: planId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
            if (!planId) throw new Error('Plan ID is missing');
            const patch = Object.keys(payload).reduce((acc, el)=>{
                if (el === 'id') return Object.assign(acc, {
                    scenarioId: payload[el]
                });
                return Object.assign(acc, {
                    [el]: {
                        value: payload[el]
                    }
                });
            }, {});
            const body = {
                planId: planId,
                ...patch
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $73zqP.urls).update, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!response.ok) {
                yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                    ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                    requestInfo: {
                        url: (0, $73zqP.urls).update,
                        type: (0, $77QEM.POST),
                        status: response.status,
                        body: body
                    }
                }));
                return;
            }
            yield (0, $aNOuE.put)((0, $jZcxq.updatePlanScenario)(payload));
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $36b0f61e7a225398$export$a95809cfa8d2bf7e() {
        yield (0, $6u3NN.takeEvery)($36b0f61e7a225398$export$d5260d2dd06aa25, $36b0f61e7a225398$export$21845d2e88ce6583);
    }
    function* $36b0f61e7a225398$export$68468727d6129272() {
        yield (0, $6u3NN.takeEvery)($36b0f61e7a225398$export$726212a28c977994, $36b0f61e7a225398$export$a613f554292bedd);
    }
    function* $36b0f61e7a225398$export$17e1ec902a44bd43() {
        yield (0, $6u3NN.takeEvery)($36b0f61e7a225398$export$d0eccde1378805f6, $36b0f61e7a225398$export$99fac75bb20ed97f);
    }
    function* $36b0f61e7a225398$export$786e98554684a8d3() {
        yield (0, $6u3NN.takeEvery)($36b0f61e7a225398$export$1c2ff7f28b1aacb1, $36b0f61e7a225398$export$e7dcec382a8c3081);
    }
    function* $36b0f61e7a225398$export$138e003c42190081() {
        yield (0, $6u3NN.takeEvery)($36b0f61e7a225398$export$60e8b04bc54d4cc2, $36b0f61e7a225398$export$e1834d7eb47a78d7);
    }
    function* $36b0f61e7a225398$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($36b0f61e7a225398$export$a95809cfa8d2bf7e);
        yield (0, $aNOuE.fork)($36b0f61e7a225398$export$68468727d6129272);
        yield (0, $aNOuE.fork)($36b0f61e7a225398$export$17e1ec902a44bd43);
        yield (0, $aNOuE.fork)($36b0f61e7a225398$export$786e98554684a8d3);
        yield (0, $aNOuE.fork)($36b0f61e7a225398$export$138e003c42190081);
    }
});
parcelRegister("lUlnG", function(module, exports) {
    $parcel$export(module.exports, "TOGGLE_SCENARIOS_DIALOG_VISIBILITY", ()=>$223ec210f5e6fa43$export$6439a3c47494e26c);
    $parcel$export(module.exports, "INITIATE_REQUEST", ()=>$223ec210f5e6fa43$export$4580e708995fb75f);
    $parcel$export(module.exports, "COMPLETE_REQUEST", ()=>$223ec210f5e6fa43$export$dbf282afa56573f1);
    $parcel$export(module.exports, "toggleDialogVisibility", ()=>$223ec210f5e6fa43$export$3e2a6f206c6cc8da);
    $parcel$export(module.exports, "initiateRequest", ()=>$223ec210f5e6fa43$export$82f68a404cfea29);
    $parcel$export(module.exports, "completeRequest", ()=>$223ec210f5e6fa43$export$64739a9c2bbf975d);
    const $223ec210f5e6fa43$export$6439a3c47494e26c = 'state.ui.settings.scenarios.TOGGLE_SCENARIOS_DIALOG_VISIBILITY';
    const $223ec210f5e6fa43$export$4580e708995fb75f = 'state.ui.settings.scenarios.INITIATE_REQUEST';
    const $223ec210f5e6fa43$export$dbf282afa56573f1 = 'state.ui.settings.scenarios.COMPLETE_REQUEST';
    const $223ec210f5e6fa43$export$3e2a6f206c6cc8da = (visibility)=>({
            type: $223ec210f5e6fa43$export$6439a3c47494e26c,
            payload: visibility
        });
    const $223ec210f5e6fa43$export$82f68a404cfea29 = ()=>({
            type: $223ec210f5e6fa43$export$4580e708995fb75f
        });
    const $223ec210f5e6fa43$export$64739a9c2bbf975d = ()=>({
            type: $223ec210f5e6fa43$export$dbf282afa56573f1
        });
});
parcelRegister("73zqP", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$7e8d1a143301d7b7$export$bcae9ba627f604b6);
    const $7e8d1a143301d7b7$export$bcae9ba627f604b6 = {
        enable: '/rest/jpo/1.0/plans/enableMultiScenario',
        disable: '/rest/jpo/1.0/plans/disableMultiScenario',
        scenarios: '/rest/jpo/1.0/scenarios',
        delete: '/rest/jpo/1.0/scenarios/delete',
        update: '/rest/jpo/1.0/scenarios/update'
    };
});
parcelRegister("eV4Pz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55e8adc3e5ae5458$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    const $55e8adc3e5ae5458$var$isScenariosDialogOpen = (state)=>state.ui.Settings.Scenarios.isModalDialogOpen;
    const $55e8adc3e5ae5458$var$isProcessingRequest = (state)=>state.ui.Settings.Scenarios.isProcessingRequest;
    var $55e8adc3e5ae5458$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        currentScenarioId: $bHTqr.currentScenarioId,
        isMultiScenarioEnabled: $bHTqr.isMultiScenarioEnabled,
        isProcessingRequest: $55e8adc3e5ae5458$var$isProcessingRequest,
        isReadOnly: $1CGdp.isReadOnly,
        isScenariosDialogOpen: $55e8adc3e5ae5458$var$isScenariosDialogOpen,
        mode: (0, $1CGdp.getMode),
        planScenarios: (0, $bHTqr.getPlanScenarios)
    });
});
parcelRegister("1gTWL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe8703ba45a7e9d7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8r8wv;
    var $sqeVT;
    var $4xCjg;
    var $fVnbM;
    var $6Ingq;
    var $gsEeL;
    var $9lMrf;
    var $3bDjY;
    var $ousew;
    var $8RXs9;
    var $1iMQ1;
    var $iX54r = parcelRequire("iX54r");
    var $4nDwW = parcelRequire("4nDwW");
    var $8JOG8 = parcelRequire("8JOG8");
    var $idmiV = parcelRequire("idmiV");
    var $6XsPQ;
    var $86jFH = parcelRequire("86jFH");
    var $96AAv = parcelRequire("96AAv");
    class $fe8703ba45a7e9d7$var$Scenarios extends (0, $5uXOq.Component) {
        static getDerivedStateFromProps(props, state) {
            if (state.selectedScenarioId !== props.currentScenarioId) return {
                ...state,
                selectedScenarioId: props.currentScenarioId
            };
            return null;
        }
        render() {
            const { planScenarios: planScenarios, isMultiScenarioEnabled: isMultiScenarioEnabled, isProcessingRequest: isProcessingRequest, createScenario: createScenario, isScenariosDialogOpen: isScenariosDialogOpen, toggleDialogVisibility: toggleDialogVisibility, isReadOnly: isReadOnly, mode: mode } = this.props;
            const { selectedScenarioId: selectedScenarioId, isDropMenuOpen: isDropMenuOpen } = this.state;
            if (isMultiScenarioEnabled !== true || !(0, $4nDwW.isDefined)(planScenarios) || planScenarios.length < 1) return null;
            const selectedScenario = planScenarios.find((scenario)=>scenario.id === selectedScenarioId);
            const triggerTitle = selectedScenario ? selectedScenario.title : '';
            const selectedScenarioColor = selectedScenario ? selectedScenario.color : '';
            if (isReadOnly) return this.renderScenarioTitle(triggerTitle, selectedScenarioColor);
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $96AAv.scenarioWrapper
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).default), {
                trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                        content: triggerTitle,
                        position: "bottom"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                        iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                            label: ""
                        }),
                        isSelected: isDropMenuOpen,
                        ref: triggerRef,
                        ...props
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $96AAv.scenarioButton
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: $96AAv.scenarioSwatch,
                        style: {
                            backgroundColor: selectedScenarioColor
                        }
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        className: `${$96AAv.scenarioTitle} ${mode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) ? $96AAv.isReportMode : ''}`
                    }, triggerTitle)))),
                onOpenChange: this.onOpenChange
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $96AAv.scenarioSwitcherMenuHeader
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $86jFH.default).scenarios)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $96AAv.scenariosList
            }, this.scenarioListRenderer()), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                    label: ""
                }),
                onClick: ()=>{
                    toggleDialogVisibility(true);
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $86jFH.default).createScenario)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gsEeL"))))), {
                    label: ""
                }),
                onClick: ()=>(0, $idmiV.redirectToSettingsSubPage)('scenarios')
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $86jFH.default).manageScenarios))), isScenariosDialogOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iX54r.default), {
                isProcessingRequest: isProcessingRequest,
                isMultiScenarioEnabled: isMultiScenarioEnabled,
                createScenario: (payload)=>createScenario({
                        ...payload,
                        redirect: true
                    }),
                onClose: ()=>{
                    toggleDialogVisibility(false);
                }
            })));
        }
        constructor(...args){
            super(...args);
            this.state = {
                selectedScenarioId: this.props.currentScenarioId,
                isDropMenuOpen: false
            };
            this.onScenarioChange = (sid)=>{
                const { currentScenarioId: currentScenarioId } = this.props;
                if (currentScenarioId === sid) return;
                this.setState(()=>({
                        selectedScenarioId: sid
                    }));
                (0, $idmiV.redirectToNewScenario)(this.props.history, sid);
            };
            this.onOpenChange = ({ isOpen: isOpen })=>{
                this.setState({
                    isDropMenuOpen: isOpen
                });
            };
            this.scenarioListRenderer = ()=>{
                const { selectedScenarioId: selectedScenarioId } = this.state;
                const scenarios = (0, parcelRequire("4xCjg")).default((0, parcelRequire("8r8wv")).default((0, parcelRequire("sqeVT")).default('id', selectedScenarioId), this.props.planScenarios));
                return scenarios.map(({ color: color, id: id, title: title })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                        key: id,
                        className: selectedScenarioId === id ? $96AAv.activeScenarioItem : ''
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iMQ1")).DropMenuItem), {
                        elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                            className: $96AAv.scenarioItemColor,
                            style: {
                                backgroundColor: color
                            }
                        }),
                        id: id,
                        isSelected: selectedScenarioId === id,
                        onClick: ()=>{
                            this.onScenarioChange(id);
                        }
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8JOG8.default), {
                        content: title,
                        id: id
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, title)))));
            };
            this.renderScenarioTitle = (scenarioTitle, color)=>{
                const { mode: mode } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $96AAv.scenarioReadOnlyWrapper
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: scenarioTitle,
                    position: "bottom"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $96AAv.scenario
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $96AAv.scenarioSwatch,
                    style: {
                        backgroundColor: color
                    }
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: `${$96AAv.scenarioTitle} ${mode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) ? ` ${$96AAv.isReportMode}` : ''}`
                }, scenarioTitle)))));
            };
        }
    }
    const $fe8703ba45a7e9d7$var$ScenariosWithHistory = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6XsPQ")).HistoryAdapter), null, (history)=>(0, ($parcel$interopDefault($5uXOq))).createElement($fe8703ba45a7e9d7$var$Scenarios, {
                history: history,
                ...props
            }));
    var $fe8703ba45a7e9d7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($fe8703ba45a7e9d7$var$ScenariosWithHistory);
    const $fe8703ba45a7e9d7$export$fdb9142e471a5606 = (0, (0, parcelRequire("8RXs9")).default)($fe8703ba45a7e9d7$var$Scenarios);
});
parcelRegister("iX54r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16de177d095eacc0$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3dseP = parcelRequire("3dseP");
    var $9z2wO = parcelRequire("9z2wO");
    var $16de177d095eacc0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $3dseP.default), {})((0, $9z2wO.default));
});
parcelRegister("3dseP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e950e8dee61ce3a$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    var $3YtPS = parcelRequire("3YtPS");
    var $8e950e8dee61ce3a$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        currentScenarioId: $bHTqr.currentScenarioId,
        planScenarios: (0, $bHTqr.getPlanScenarios)
    });
});
parcelRegister("9z2wO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ef8e4b99415bb16$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cDeeP;
    var $fVnbM;
    var $efXp3;
    var $qfj8c;
    var $7O4UO;
    var $lAcHL;
    var $kxqHl;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $3rLiX;
    var $kY99m;
    var $9fuVs;
    var $8RXs9;
    parcelRequire("iqIcG");
    var $7K5PP;
    var $4nDwW = parcelRequire("4nDwW");
    var $4Ai8V = parcelRequire("4Ai8V");
    var $gITL8 = parcelRequire("gITL8");
    var $ihPUd = parcelRequire("ihPUd");
    var $3NFsF = parcelRequire("3NFsF");
    var $8UcLA = parcelRequire("8UcLA");
    const $8ef8e4b99415bb16$var$SCENARIO_TYPES = {
        BLANK: 'blank',
        COPY: 'copy'
    };
    class $8ef8e4b99415bb16$export$cf131c1c2576cfd8 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.buttonRef = (0, $5uXOq.createRef)();
            this.submitForm = (fields)=>{
                const { scenarioTitle: scenarioTitle, scenarioColour: scenarioColour } = fields;
                const payload = {
                    title: scenarioTitle.trim(),
                    color: scenarioColour
                };
                if (!fields.scenarioType) payload.scenarioId = this.props.currentScenarioId;
                else if (fields.scenarioType === $8ef8e4b99415bb16$var$SCENARIO_TYPES.COPY) payload.scenarioId = fields.scenarioId.value;
                this.props.createScenario(payload);
            };
            this.setScenarioTitleFieldValidity = (isValid)=>{
                this.setState({
                    isScenarioTitleFieldValid: isValid
                });
            };
            this.validateScenarioTitle = (scenarioTitle)=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                if (!(0, $4nDwW.isDefined)(scenarioTitle)) {
                    this.setScenarioTitleFieldValidity(false);
                    return '';
                }
                if (scenarioTitle.trim() === '') {
                    this.setScenarioTitleFieldValidity(false);
                    return formatMessage((0, $3NFsF.default).scenarioTitleEmpty);
                }
                if (scenarioTitle.length > 255) {
                    this.setScenarioTitleFieldValidity(false);
                    return formatMessage((0, $3NFsF.default).titleLengthValidation);
                }
                this.setScenarioTitleFieldValidity(true);
                return '';
            };
            this.getDefaultScenarioOption = ()=>this.getScenarioOptions().find(({ value: value })=>value === this.props.currentScenarioId);
            this.getScenarioOptions = ()=>{
                const { currentScenarioId: currentScenarioId, intl: { formatMessage: formatMessage }, planScenarios: planScenarios = [] } = this.props;
                return planScenarios.map(({ id: id, title: title })=>({
                        label: `${title} ${id === currentScenarioId ? formatMessage((0, $3NFsF.default).currentScenarioLabel) : ''}`,
                        value: id
                    }));
            };
            this.getDefaultColour = ()=>{
                const { planScenarios: planScenarios = [] } = this.props;
                const colors = (0, parcelRequire("cDeeP")).default((0, $gITL8.colourPickerPalette), planScenarios.map(({ color: color })=>color));
                return colors[0] || (0, $gITL8.colourPickerPalette)[0];
            };
            this.state = {
                isScenarioTitleFieldValid: false
            };
        }
        render() {
            const { intl: { formatMessage: formatMessage }, isMultiScenarioEnabled: isMultiScenarioEnabled = false, isProcessingRequest: isProcessingRequest, onClose: onClose, planScenarios: planScenarios = [] } = this.props;
            const { isScenarioTitleFieldValid: isScenarioTitleFieldValid } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                autoFocus: true,
                onClose: onClose,
                shouldCloseOnEscapePress: !isProcessingRequest,
                shouldCloseOnOverlayClick: !isProcessingRequest
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage(isMultiScenarioEnabled ? (0, $3NFsF.default).dialogTitle : (0, $3NFsF.default).dialogTitleFirstScenario))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
                style: {
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
                    marginBottom: "var(--ds-space-300, 24px)"
                }
            }, formatMessage((0, $3NFsF.default).requiredFieldsSummary), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kxqHl")).default), null)), !isMultiScenarioEnabled && formatMessage((0, $3NFsF.default).firstScenarioDescription), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("efXp3")).default), {
                onSubmit: this.submitForm
            }, ({ formProps: formProps, getState: getState })=>(0, ($parcel$interopDefault($5uXOq))).createElement("form", formProps, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $8UcLA.scenarioTitleAndColourFields
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $8UcLA.scenarioTitle
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    "aria-required": true,
                    defaultValue: isMultiScenarioEnabled ? undefined : planScenarios[0].title,
                    isDisabled: isProcessingRequest,
                    isRequired: true,
                    label: formatMessage((0, $3NFsF.default).scenarioTitle),
                    name: "scenarioTitle",
                    validate: this.validateScenarioTitle
                }, ({ fieldProps: fieldProps, meta: meta })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                        ...fieldProps,
                        testId: "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.title",
                        onBlur: (value)=>fieldProps.onChange(value || ''),
                        placeholder: formatMessage((0, $3NFsF.default).scenarioTitlePlaceholder)
                    }), (0, $4nDwW.isDefined)(meta.error) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, meta.error)))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "aria-label": formatMessage((0, $3NFsF.default).scenarioColor),
                    className: $8UcLA.scenarioColour
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    defaultValue: this.getDefaultColour(),
                    isDisabled: isProcessingRequest,
                    name: "scenarioColour"
                }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $4Ai8V.default), {
                        colour: fieldProps.value,
                        onColourChange: (colour)=>{
                            (0, $4nDwW.isDefined)(colour) && fieldProps.onChange(colour);
                        },
                        position: "bottom-start",
                        selectedColourSwatchSize: "default"
                    })))), isMultiScenarioEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $8UcLA.radioGroup
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lAcHL")).default), {
                    legend: formatMessage((0, $3NFsF.default).scenarioCreateFrom)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    defaultValue: $8ef8e4b99415bb16$var$SCENARIO_TYPES.COPY,
                    isDisabled: isProcessingRequest,
                    name: "scenarioType"
                }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3rLiX")).default), {
                        onChange: fieldProps.onChange,
                        options: [
                            {
                                label: formatMessage((0, $3NFsF.default).createFromBlank),
                                value: $8ef8e4b99415bb16$var$SCENARIO_TYPES.BLANK
                            },
                            {
                                label: formatMessage((0, $3NFsF.default).createFromScenario),
                                value: $8ef8e4b99415bb16$var$SCENARIO_TYPES.COPY
                            }
                        ],
                        value: fieldProps.value
                    })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    defaultValue: this.getDefaultScenarioOption(),
                    isDisabled: getState().values.scenarioType === $8ef8e4b99415bb16$var$SCENARIO_TYPES.BLANK || isProcessingRequest,
                    name: "scenarioId"
                }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        ...fieldProps,
                        menuPortalTarget: document.body,
                        options: this.getScenarioOptions(),
                        styles: {
                            menuPortal: (base)=>({
                                    ...base,
                                    zIndex: 9999
                                })
                        },
                        "aria-label": formatMessage((0, $3NFsF.default).scenarioList)
                    }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $8UcLA.hiddenSubmitButton
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                    type: "submit",
                    ref: this.buttonRef
                }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "subtle",
                isDisabled: isProcessingRequest,
                onClick: onClose
            }, formatMessage((0, $ihPUd.default).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "primary",
                isDisabled: !isScenarioTitleFieldValid || isProcessingRequest,
                onClick: ()=>{
                    if (this.buttonRef.current) this.buttonRef.current.click();
                }
            }, formatMessage((0, $ihPUd.default).create)))));
        }
    }
    var $8ef8e4b99415bb16$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($8ef8e4b99415bb16$export$cf131c1c2576cfd8);
});
parcelRegister("3NFsF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8bd00a1232041fb$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b8bd00a1232041fb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        currentScenarioLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.current-scenario-label",
            "defaultMessage": "(current)"
        },
        dialogTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.dialog-title",
            "defaultMessage": "Create scenario"
        },
        dialogTitleFirstScenario: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.dialog-title-first-scenario",
            "defaultMessage": "Create first scenario"
        },
        titleLengthValidation: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.title-length-validation",
            "defaultMessage": "The scenario title cannot exceed 255 characters."
        },
        firstScenarioDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.first-scenario-description",
            "defaultMessage": "Any changes that aren't saved yet will exist in this scenario. You can also create additional scenarios at any time."
        },
        scenarioTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-title",
            "defaultMessage": "Scenario name"
        },
        scenarioTitlePlaceholder: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-title-placeholder",
            "defaultMessage": "e.g. Best case"
        },
        scenarioColor: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-color",
            "defaultMessage": "Color"
        },
        scenarioCreateFrom: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-create-from",
            "defaultMessage": "Create from"
        },
        createFromBlank: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.create-from-blank",
            "defaultMessage": "Blank scenario"
        },
        createFromScenario: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.create-from-scenario",
            "defaultMessage": "Copy of:"
        },
        scenarioTitleEmpty: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-title-empty",
            "defaultMessage": "Please enter a scenario title"
        },
        scenarioList: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-list",
            "defaultMessage": "Scenario List"
        },
        requiredFieldsSummary: {
            "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.required-fields-summary",
            "defaultMessage": "Required fields are marked with an asterisk"
        }
    });
});
parcelRegister("8UcLA", function(module, exports) {
    $parcel$export(module.exports, "hiddenSubmitButton", ()=>$67bd74e072fc9952$export$925df3919f606a09, (v)=>$67bd74e072fc9952$export$925df3919f606a09 = v);
    $parcel$export(module.exports, "radioGroup", ()=>$67bd74e072fc9952$export$7246d22ab0922ede, (v)=>$67bd74e072fc9952$export$7246d22ab0922ede = v);
    $parcel$export(module.exports, "scenarioColour", ()=>$67bd74e072fc9952$export$27312fbca74027aa, (v)=>$67bd74e072fc9952$export$27312fbca74027aa = v);
    $parcel$export(module.exports, "scenarioTitle", ()=>$67bd74e072fc9952$export$7140c7d1fc768b45, (v)=>$67bd74e072fc9952$export$7140c7d1fc768b45 = v);
    $parcel$export(module.exports, "scenarioTitleAndColourFields", ()=>$67bd74e072fc9952$export$73ef3d6ff19f8c4e, (v)=>$67bd74e072fc9952$export$73ef3d6ff19f8c4e = v);
    var $67bd74e072fc9952$export$925df3919f606a09;
    var $67bd74e072fc9952$export$7246d22ab0922ede;
    var $67bd74e072fc9952$export$27312fbca74027aa;
    var $67bd74e072fc9952$export$7140c7d1fc768b45;
    var $67bd74e072fc9952$export$73ef3d6ff19f8c4e;
    $67bd74e072fc9952$export$925df3919f606a09 = `YsU-kW_hiddenSubmitButton`;
    $67bd74e072fc9952$export$7246d22ab0922ede = `YsU-kW_radioGroup`;
    $67bd74e072fc9952$export$27312fbca74027aa = `YsU-kW_scenarioColour`;
    $67bd74e072fc9952$export$7140c7d1fc768b45 = `YsU-kW_scenarioTitle`;
    $67bd74e072fc9952$export$73ef3d6ff19f8c4e = `YsU-kW_scenarioTitleAndColourFields`;
});
parcelRegister("6XsPQ", function(module, exports) {
    $parcel$export(module.exports, "HistoryAdapter", ()=>$c364a1ba7d823379$export$d852f51b8427aefc);
    var $5uXOq = parcelRequire("5uXOq");
    var $1bQGJ;
    var $8oKIZ;
    class $c364a1ba7d823379$var$HistoryAdapterComponent extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.compatibleHistory = (0, (0, parcelRequire("8oKIZ")).createReactRouterCompatibleHistory)(props.history);
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.children !== this.props.children;
        }
        componentWillUnmount() {
            this.compatibleHistory.destroy && this.compatibleHistory.destroy();
        }
        render() {
            const { children: children } = this.props;
            return children(this.compatibleHistory);
        }
    }
    const $c364a1ba7d823379$export$d852f51b8427aefc = (0, (0, parcelRequire("1bQGJ")).withRouter)($c364a1ba7d823379$var$HistoryAdapterComponent);
});
parcelRegister("8oKIZ", function(module, exports) {
    $parcel$export(module.exports, "createReactRouterCompatibleHistory", ()=>$e043da36553b4806$export$2df73cd79c2401bf);
    var $bxYf9 = parcelRequire("bxYf9");
    const $e043da36553b4806$export$2df73cd79c2401bf = (history)=>{
        let cleaned = false;
        let listeners = [];
        const listen = (callback)=>{
            if (cleaned) return ()=>{};
            const unsubscribe = (0, ($parcel$interopDefault($bxYf9)))(history.listen(callback));
            const listener = {
                unsubscribe: unsubscribe
            };
            listeners.push(listener);
            return (0, ($parcel$interopDefault($bxYf9)))(()=>{
                listener.unsubscribe();
            });
        };
        const cleanup = ()=>{
            listeners.forEach(({ unsubscribe: unsubscribe })=>{
                unsubscribe();
            });
            cleaned = true;
            listeners = [];
        };
        return {
            get length () {
                return history.length;
            },
            get location () {
                return history.location;
            },
            get action () {
                return history.action;
            },
            get index () {
                return history.index;
            },
            get entries () {
                return history.entries;
            },
            push: (path, state)=>history.push(path, state),
            replace: (path, state)=>history.replace(path, state),
            go: (n)=>history.go(n),
            goBack: ()=>history.goBack(),
            goForward: ()=>history.goForward(),
            createHref: (...args)=>history.createHref(...args),
            canGo: (n)=>{
                if (history.canGo) return history.canGo(n);
                return true;
            },
            listen: listen,
            block: (blocker)=>history.block(blocker),
            destroy: cleanup
        };
    };
});
parcelRegister("86jFH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78b10d7277fff700$export$2e2bcd8739ae039);
    var $7VHMR;
    var $78b10d7277fff700$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createScenario: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.scenarios.create-scenario",
            "defaultMessage": "Create scenario"
        },
        manageScenarios: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.scenarios.manage-scenarios",
            "defaultMessage": "Manage scenarios"
        },
        scenarios: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.scenarios.scenarios",
            "defaultMessage": "Scenarios"
        }
    });
});
parcelRegister("96AAv", function(module, exports) {
    $parcel$export(module.exports, "activeScenarioItem", ()=>$6a110e286607a1da$export$6e80c944f5ea7131, (v)=>$6a110e286607a1da$export$6e80c944f5ea7131 = v);
    $parcel$export(module.exports, "isReportMode", ()=>$6a110e286607a1da$export$e8610bde98f41d48, (v)=>$6a110e286607a1da$export$e8610bde98f41d48 = v);
    $parcel$export(module.exports, "scenario", ()=>$6a110e286607a1da$export$e2ad0c7f6240be88, (v)=>$6a110e286607a1da$export$e2ad0c7f6240be88 = v);
    $parcel$export(module.exports, "scenarioButton", ()=>$6a110e286607a1da$export$4e53d53c8142d230, (v)=>$6a110e286607a1da$export$4e53d53c8142d230 = v);
    $parcel$export(module.exports, "scenarioItemColor", ()=>$6a110e286607a1da$export$247f77ab0548faac, (v)=>$6a110e286607a1da$export$247f77ab0548faac = v);
    $parcel$export(module.exports, "scenarioReadOnlyWrapper", ()=>$6a110e286607a1da$export$3ecc174cb094193, (v)=>$6a110e286607a1da$export$3ecc174cb094193 = v);
    $parcel$export(module.exports, "scenarioSwatch", ()=>$6a110e286607a1da$export$92a23dd764ffe399, (v)=>$6a110e286607a1da$export$92a23dd764ffe399 = v);
    $parcel$export(module.exports, "scenarioSwitcherMenuHeader", ()=>$6a110e286607a1da$export$804f30839e65bc86, (v)=>$6a110e286607a1da$export$804f30839e65bc86 = v);
    $parcel$export(module.exports, "scenarioTitle", ()=>$6a110e286607a1da$export$7140c7d1fc768b45, (v)=>$6a110e286607a1da$export$7140c7d1fc768b45 = v);
    $parcel$export(module.exports, "scenarioWrapper", ()=>$6a110e286607a1da$export$43aa57aac2608ff2, (v)=>$6a110e286607a1da$export$43aa57aac2608ff2 = v);
    $parcel$export(module.exports, "scenariosList", ()=>$6a110e286607a1da$export$a0006f0efe0fb9b4, (v)=>$6a110e286607a1da$export$a0006f0efe0fb9b4 = v);
    var $6a110e286607a1da$export$6e80c944f5ea7131;
    var $6a110e286607a1da$export$e8610bde98f41d48;
    var $6a110e286607a1da$export$e2ad0c7f6240be88;
    var $6a110e286607a1da$export$4e53d53c8142d230;
    var $6a110e286607a1da$export$247f77ab0548faac;
    var $6a110e286607a1da$export$3ecc174cb094193;
    var $6a110e286607a1da$export$92a23dd764ffe399;
    var $6a110e286607a1da$export$804f30839e65bc86;
    var $6a110e286607a1da$export$7140c7d1fc768b45;
    var $6a110e286607a1da$export$43aa57aac2608ff2;
    var $6a110e286607a1da$export$a0006f0efe0fb9b4;
    $6a110e286607a1da$export$6e80c944f5ea7131 = `oWhgpG_activeScenarioItem`;
    $6a110e286607a1da$export$e8610bde98f41d48 = `oWhgpG_isReportMode`;
    $6a110e286607a1da$export$e2ad0c7f6240be88 = `oWhgpG_scenario`;
    $6a110e286607a1da$export$4e53d53c8142d230 = `oWhgpG_scenarioButton`;
    $6a110e286607a1da$export$247f77ab0548faac = `oWhgpG_scenarioItemColor`;
    $6a110e286607a1da$export$3ecc174cb094193 = `oWhgpG_scenarioReadOnlyWrapper`;
    $6a110e286607a1da$export$92a23dd764ffe399 = `oWhgpG_scenarioSwatch`;
    $6a110e286607a1da$export$804f30839e65bc86 = `oWhgpG_scenarioSwitcherMenuHeader`;
    $6a110e286607a1da$export$7140c7d1fc768b45 = `oWhgpG_scenarioTitle`;
    $6a110e286607a1da$export$43aa57aac2608ff2 = `oWhgpG_scenarioWrapper`;
    $6a110e286607a1da$export$a0006f0efe0fb9b4 = `oWhgpG_scenariosList`;
});
parcelRegister("hIIRC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$372d4fb4b8db1a96$export$2e2bcd8739ae039);
    var $bC2fB;
    var $2TYgD = parcelRequire("2TYgD");
    var $6mZQO = parcelRequire("6mZQO");
    var $gapWT = parcelRequire("gapWT");
    var $gapWT = parcelRequire("gapWT");
    var $372d4fb4b8db1a96$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $6mZQO.default), (0, $2TYgD.default))((0, $gapWT.default));
});
parcelRegister("2TYgD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5a6cc9610425541$export$2e2bcd8739ae039);
    var $b0D0x = parcelRequire("b0D0x");
    var $2XjH3 = parcelRequire("2XjH3");
    var $1lSJI = parcelRequire("1lSJI");
    const $c5a6cc9610425541$var$mapDispatchToProps = (dispatch)=>({
            getExportCsvScopeItems: (csvIntlMessages, additionalData)=>{
                dispatch((0, $b0D0x.getExportCsvScopeItems)(csvIntlMessages, additionalData));
            },
            planExportedAnalytics: (payload)=>{
                dispatch((0, $b0D0x.planExportedAnalytics)(payload));
            },
            openShareReportDialog: ()=>{
                dispatch((0, $2XjH3.createShareReportUrl)());
                dispatch({
                    type: (0, $1lSJI.OPEN_SHARE_REPORT_DIALOG)
                });
            },
            closeShareReportDialog: ()=>{
                dispatch({
                    type: (0, $1lSJI.CLOSE_SHARE_REPORT_DIALOG)
                });
            },
            updateShareReportUrl: (payload)=>{
                dispatch({
                    type: (0, $1lSJI.UPDATE_SHARE_AS),
                    payload: payload
                });
                dispatch((0, $2XjH3.createShareReportUrl)());
            }
        });
    var $c5a6cc9610425541$export$2e2bcd8739ae039 = $c5a6cc9610425541$var$mapDispatchToProps;
});
parcelRegister("b0D0x", function(module, exports) {
    $parcel$export(module.exports, "CLICK_EXPORT_TO_CSV_ANALYTICS", ()=>$35c11b9e9ceeaa74$export$aeee1a25bc7adb7d);
    $parcel$export(module.exports, "PLAN_EXPORTED_ANALYTICS", ()=>$35c11b9e9ceeaa74$export$d0842f9ff391ee31);
    $parcel$export(module.exports, "planExportedAnalytics", ()=>$35c11b9e9ceeaa74$export$b46290bf6060fea2);
    $parcel$export(module.exports, "EXPORT_EVENT_TYPE", ()=>$35c11b9e9ceeaa74$export$deb2e5b0ecff69f9);
    $parcel$export(module.exports, "getExportCsvScopeItems", ()=>$35c11b9e9ceeaa74$export$982142380268f802);
    $parcel$export(module.exports, "default", ()=>$35c11b9e9ceeaa74$export$2e2bcd8739ae039);
    var $jpUKq = parcelRequire("jpUKq");
    var $2rMKg;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $co1wz;
    var $aipk9;
    var $1CGdp = parcelRequire("1CGdp");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $hu7Cn = parcelRequire("hu7Cn");
    var $4NBVJ = parcelRequire("4NBVJ");
    var $5nMRY = parcelRequire("5nMRY");
    var $19iju = parcelRequire("19iju");
    var $ekXoi = parcelRequire("ekXoi");
    var $bYYus = parcelRequire("bYYus");
    var $io4Ja = parcelRequire("io4Ja");
    var $7ppNi = parcelRequire("7ppNi");
    var $kllqP = parcelRequire("kllqP");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $4sJY8 = parcelRequire("4sJY8");
    var $bzDof = parcelRequire("bzDof");
    var $d3quy = parcelRequire("d3quy");
    var $jpgxP = parcelRequire("jpgxP");
    var $dRVQG = parcelRequire("dRVQG");
    var $jAIJh = parcelRequire("jAIJh");
    var $9FFuD = parcelRequire("9FFuD");
    var $kWDpn = parcelRequire("kWDpn");
    var $bkasS = parcelRequire("bkasS");
    var $dpHie = parcelRequire("dpHie");
    var $6VZXM = parcelRequire("6VZXM");
    var $e5V2f = parcelRequire("e5V2f");
    const $35c11b9e9ceeaa74$export$a8eb40e0b086759e = 'command.export-roadmap.CLICK_EXPORT_TO_CSV';
    const $35c11b9e9ceeaa74$export$aeee1a25bc7adb7d = 'command.export-roadmap.CLICK_EXPORT_TO_CSV_ANALYTICS';
    const $35c11b9e9ceeaa74$export$d0842f9ff391ee31 = 'command.export-roadmap.PLAN_EXPORTED_ANALYTICS';
    const $35c11b9e9ceeaa74$export$b46290bf6060fea2 = (payload)=>({
            type: $35c11b9e9ceeaa74$export$d0842f9ff391ee31,
            payload: payload
        });
    const $35c11b9e9ceeaa74$export$deb2e5b0ecff69f9 = {
        PNG: '.png',
        CSV: '.csv',
        LINK: 'Link',
        EMBED: 'Embed',
        CONFLUENCE: 'Confluence',
        DEPENDENCY_REPORT_CONFLUENCE: 'DependencyReportConfluence'
    };
    const $35c11b9e9ceeaa74$export$982142380268f802 = (csvIntlMessages, additionalData)=>({
            type: $35c11b9e9ceeaa74$export$a8eb40e0b086759e,
            csvIntlMessages: csvIntlMessages,
            additionalData: additionalData
        });
    function* $35c11b9e9ceeaa74$export$b4d6459e13978f3c({ csvIntlMessages: csvIntlMessages, additionalData: { goalsByARI: goalsByARI, associatedIssues: associatedIssues } = {
        goalsByARI: {},
        associatedIssues: {}
    } }) {
        const assigneesById = yield (0, $aNOuE.select)((0, $hu7Cn.getAssigneesById));
        const reportersById = yield (0, $aNOuE.select)((0, $bzDof.getReportersById));
        const componentsById = yield (0, $aNOuE.select)((0, $5nMRY.getComponentsById));
        const allCustomFields = yield (0, $aNOuE.select)((0, $19iju.getCustomFields));
        const dateConfiguration = yield (0, $aNOuE.select)((0, $bHTqr.getDateConfiguration));
        const estimateFromHistoryIssues = yield (0, $aNOuE.select)((0, $4NBVJ.getEstimateFromHistoryIssues));
        const externalSprintsById = yield (0, $aNOuE.select)((0, $d3quy.getExternalSprintsById));
        const externalTeamsById = yield (0, $aNOuE.select)((0, $dRVQG.getAdditionalTeamsById));
        const issueIdToDescendantsIdMap = yield (0, $aNOuE.select)((0, $bI9dZ.getDescendantIdsByParent));
        const issueMapById = yield (0, $aNOuE.select)((0, $gFhwb.getIssueMapById));
        const issuePrioritiesById = yield (0, $aNOuE.select)((0, $io4Ja.getIssuePriorities));
        const issueStatusesById = yield (0, $aNOuE.select)((0, $7ppNi.getIssueStatusById));
        const issues = yield (0, $aNOuE.select)((0, $gFhwb.getIssues));
        const issueTypesById = yield (0, $aNOuE.select)((0, $kllqP.getIssueTypesById));
        const plan = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const projectsById = yield (0, $aNOuE.select)((0, $jpXKt.getProjectsById));
        const rollUpMap = yield (0, $aNOuE.select)((0, $4sJY8.getRollupMap));
        const scopeItemsForExport = yield (0, $aNOuE.select)((0, $bYYus.getScopeItemsForExport));
        const showRolledUpDates = yield (0, $aNOuE.select)((0, $kWDpn.getShowRolledUpDates));
        const showRolledUpOthers = yield (0, $aNOuE.select)((0, $kWDpn.getShowRolledUpOthers));
        const selectOptionsById = yield (0, $aNOuE.select)((0, $19iju.getSelectOptionsById));
        const sprintsById = yield (0, $aNOuE.select)((0, $d3quy.getSprintByIdMap));
        const systemInfo = yield (0, $aNOuE.select)((0, $jpgxP.getSystemInfo));
        const teamsById = yield (0, $aNOuE.select)((0, $dRVQG.getTeamsById));
        const userPickerOptions = yield (0, $aNOuE.select)((0, $19iju.getUserPickerOptions));
        const isAtlasConnectInstalled = yield (0, $aNOuE.select)((0, $jpgxP.isAtlasConnectInstalled));
        const isEmbedMode = yield (0, $aNOuE.select)((0, $1CGdp.isEmbed));
        const isConfluenceMacroMode = yield (0, $aNOuE.select)((0, $1CGdp.isConfluenceMacro));
        const isEmbedOrMacro = isEmbedMode || isConfluenceMacroMode;
        let userPickerOptionsById = {};
        if (userPickerOptions?.userList) userPickerOptionsById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('value'), userPickerOptions.userList);
        const versions = yield (0, $aNOuE.select)((0, $9FFuD.getVersions));
        yield (0, $aNOuE.call)((0, $bkasS.getHistoricalDoneIssues));
        const historyIssues = yield (0, $aNOuE.select)((0, $bI9dZ.getHistoryIssues));
        const scopeItems = scopeItemsForExport.map((issue)=>{
            const { assignee: assignee, reporter: reporter, components: components, dueDate: dueDate, fixVersions: fixVersions, id: id, labels: labels, parent: parent, priority: priority, project: project, status: status, summary: summary, targetEnd: targetEnd, targetStart: targetStart, team: team, type: type, customFields: customFields, goals: goals, associatedIssueIds: associatedIssueIds } = issue;
            const dataRecordStandardFields = {
                assignee: assignee ? (0, $e5V2f.getIssueAssigneeName)(assignee, assigneesById) : '',
                reporter: reporter ? (0, $e5V2f.getIssueReporterName)(reporter, reportersById) : '',
                components: components && components.length ? (0, $e5V2f.joinIssueComponents)(components, componentsById) : '',
                dueDate: dueDate ? (0, (0, parcelRequire("aipk9")).formatDateUTC)(dueDate, (0, $TTKUQ.DefaultDateFormat)) : '',
                estimate: (0, $ekXoi.getEstimateValue)(plan.planningUnit, issue, systemInfo.jiraHoursPerDay) || '',
                key: (0, $e5V2f.getIssueKey)(issue, projectsById) || '',
                labels: labels ? (0, $e5V2f.joinIssueLabels)(labels) : '',
                parent: parent ? (0, $e5V2f.getIssueParentSummary)(parent, issueMapById) : '',
                priority: priority ? (0, $e5V2f.getIssuePriorityName)(priority, issuePrioritiesById) : '',
                project: project ? (0, $e5V2f.getIssueProjectName)(project, projectsById) : '',
                release: fixVersions ? (0, $e5V2f.getIssueReleaseName)(fixVersions, versions) : '',
                sprint: (0, $e5V2f.getIssueSprintName)(issue, sprintsById, externalSprintsById, csvIntlMessages) || '',
                status: status ? (0, $e5V2f.getIssueStatusName)(status, issueStatusesById) : '',
                summary: summary || '',
                targetEnd: targetEnd ? (0, (0, parcelRequire("aipk9")).formatDateUTC)(targetEnd, (0, $TTKUQ.DefaultDateFormat)) : '',
                targetStart: targetStart ? (0, (0, parcelRequire("aipk9")).formatDateUTC)(targetStart, (0, $TTKUQ.DefaultDateFormat)) : '',
                team: team ? (0, $e5V2f.getIssueTeamName)(team, teamsById, externalTeamsById, csvIntlMessages) : '',
                type: type ? (0, $e5V2f.getIssueTypeName)(type, issueTypesById) : ''
            };
            let dataRecordRolledUpOrInferredDateFields = {};
            if (plan.issueInferredDateSelection || showRolledUpDates) dataRecordRolledUpOrInferredDateFields = (0, $e5V2f.getIssueInferredDates)(issue, dateConfiguration);
            let dataRecordRollupOtherFields = {};
            if (showRolledUpOthers) {
                const { sprint: sprint, estimate: estimate, release: release, team: team } = rollUpMap[id];
                dataRecordRollupOtherFields = {
                    sprintRollUp: sprint ? (0, $e5V2f.getIssueRollUpSprintName)(sprint, sprintsById, externalSprintsById, csvIntlMessages.labels.completed) : '',
                    estimateRollUp: (0, $ekXoi.getEstimateRollupValue)(estimate, plan.planningUnit, systemInfo.jiraHoursPerDay) || '',
                    releaseRollUp: release ? (0, $e5V2f.getIssueReleaseName)(release, versions) : '',
                    teamRollUp: team ? (0, $e5V2f.getIssueRollupTeamNames)(team, teamsById, externalTeamsById, csvIntlMessages) : ''
                };
            }
            const dataRecordProgressEstimateFields = (0, $e5V2f.getIssueEstimateProgressBreakdown)(issue, issueIdToDescendantsIdMap, issueStatusesById, issueMapById, plan.planningUnit, systemInfo.jiraHoursPerDay, estimateFromHistoryIssues);
            const dataRecordProgressCountFields = (0, $e5V2f.getIssueCountProgressBreakdown)(issue, issues, issueStatusesById, issueMapById, historyIssues);
            const dataRecordCustomFields = allCustomFields && allCustomFields.length && customFields ? allCustomFields.reduce((accumulator, customField)=>{
                accumulator[customField.id] = (0, $e5V2f.getIssueCustomFieldValue)(customFields, customField, selectOptionsById, userPickerOptionsById) || '';
                return accumulator;
            }, {}) : {};
            return {
                ...dataRecordStandardFields,
                ...dataRecordProgressEstimateFields,
                ...dataRecordProgressCountFields,
                ...dataRecordCustomFields,
                ...dataRecordRolledUpOrInferredDateFields,
                ...dataRecordRollupOtherFields,
                ...isAtlasConnectInstalled ? (0, $dpHie.getGoalValues)(goals, goalsByARI) : {},
                ...(0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') && !isEmbedOrMacro ? (0, $6VZXM.getIdeaValues)(associatedIssueIds || [], associatedIssues || {}) : {}
            };
        });
        yield (0, $aNOuE.put)({
            type: $35c11b9e9ceeaa74$export$aeee1a25bc7adb7d,
            payload: {
                issueExportCount: scopeItems && scopeItems.length ? scopeItems.length : 0
            }
        });
        const csvData = new Blob([
            (0, $e5V2f.prepareCSVData)(allCustomFields, plan.planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, scopeItems, isAtlasConnectInstalled, isEmbedMode, isConfluenceMacroMode)
        ], {
            type: 'text/csv;charset=utf-8;'
        });
        const exportName = csvIntlMessages.exportName;
        (0, $jpUKq.saveAs)(csvData, (0, $e5V2f.getExportCsvFileName)(exportName, (0, $jAIJh.getTodayDate)()));
        yield (0, $aNOuE.put)($35c11b9e9ceeaa74$export$b46290bf6060fea2({
            exportFormat: $35c11b9e9ceeaa74$export$deb2e5b0ecff69f9.CSV
        }));
    }
    function* $35c11b9e9ceeaa74$export$c582f49da0d1e51() {
        yield (0, $6u3NN.takeEvery)($35c11b9e9ceeaa74$export$a8eb40e0b086759e, $35c11b9e9ceeaa74$export$b4d6459e13978f3c);
    }
    function* $35c11b9e9ceeaa74$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($35c11b9e9ceeaa74$export$c582f49da0d1e51);
    }
});
parcelRegister("jpUKq", function(module, exports) {
    var $e22c5f112f49df3f$var$saveAs = $e22c5f112f49df3f$var$saveAs || function(view) {
        "use strict";
        if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
        var doc = view.document, get_URL = function() {
            return view.URL || view.webkitURL || view;
        }, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = "download" in save_link, click = function(node) {
            var event = new MouseEvent("click");
            node.dispatchEvent(event);
        }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function(ex) {
            (view.setImmediate || view.setTimeout)(function() {
                throw ex;
            }, 0);
        }, force_saveable_type = "application/octet-stream", arbitrary_revoke_timeout = 40000, revoke = function(file) {
            var revoker = function() {
                if (typeof file === "string") get_URL().revokeObjectURL(file);
                else file.remove();
            };
            setTimeout(revoker, arbitrary_revoke_timeout);
        }, dispatch = function(filesaver, event_types, event) {
            event_types = [].concat(event_types);
            var i = event_types.length;
            while(i--){
                var listener = filesaver["on" + event_types[i]];
                if (typeof listener === "function") try {
                    listener.call(filesaver, event || filesaver);
                } catch (ex) {
                    throw_outside(ex);
                }
            }
        }, auto_bom = function(blob) {
            if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
                String.fromCharCode(0xFEFF),
                blob
            ], {
                type: blob.type
            });
            return blob;
        }, FileSaver = function(blob, name, no_auto_bom) {
            if (!no_auto_bom) blob = auto_bom(blob);
            var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function() {
                dispatch(filesaver, "writestart progress write writeend".split(" "));
            }, fs_error = function() {
                if ((is_chrome_ios || force && is_safari) && view.FileReader) {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                        var popup = view.open(url, '_blank');
                        if (!popup) view.location.href = url;
                        url = undefined;
                        filesaver.readyState = filesaver.DONE;
                        dispatch_all();
                    };
                    reader.readAsDataURL(blob);
                    filesaver.readyState = filesaver.INIT;
                    return;
                }
                if (!object_url) object_url = get_URL().createObjectURL(blob);
                if (force) view.location.href = object_url;
                else {
                    var opened = view.open(object_url, "_blank");
                    if (!opened) view.location.href = object_url;
                }
                filesaver.readyState = filesaver.DONE;
                dispatch_all();
                revoke(object_url);
            };
            filesaver.readyState = filesaver.INIT;
            if (can_use_save_link) {
                object_url = get_URL().createObjectURL(blob);
                setTimeout(function() {
                    save_link.href = object_url;
                    save_link.download = name;
                    click(save_link);
                    dispatch_all();
                    revoke(object_url);
                    filesaver.readyState = filesaver.DONE;
                });
                return;
            }
            fs_error();
        }, FS_proto = FileSaver.prototype, saveAs = function(blob, name, no_auto_bom) {
            return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
        };
        if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
            name = name || blob.name || "download";
            if (!no_auto_bom) blob = auto_bom(blob);
            return navigator.msSaveOrOpenBlob(blob, name);
        };
        FS_proto.abort = function() {};
        FS_proto.readyState = FS_proto.INIT = 0;
        FS_proto.WRITING = 1;
        FS_proto.DONE = 2;
        FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
        return saveAs;
    }(typeof self !== "undefined" && self || typeof window !== "undefined" && window || module.exports.content);
    if (0, module.exports) module.exports.saveAs = $e22c5f112f49df3f$var$saveAs;
    else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
        return $e22c5f112f49df3f$var$saveAs;
    });
});
parcelRegister("bYYus", function(module, exports) {
    $parcel$export(module.exports, "getScopeItemsForExport", ()=>$d9b3354f9ef1a255$export$4dcfa5cdaa5f20c1);
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $1cIjo = parcelRequire("1cIjo");
    var $jLI87 = parcelRequire("jLI87");
    const $d9b3354f9ef1a255$export$f9b9f1184e09598e = (issuesWithOriginalsAndOptimized, isExpanded, { value: { start: start, end: end } })=>{
        const issuesById = (0, $4nDwW.indexBy)(({ id: id })=>id, issuesWithOriginalsAndOptimized);
        const issuesByParent = (0, $4nDwW.groupBy)(({ parent: parent })=>parent || '', issuesWithOriginalsAndOptimized.filter(({ parent: parent })=>parent));
        const scopeItems = (0, $jLI87.buildScope)(issuesWithOriginalsAndOptimized, issuesByParent, issuesById, isExpanded, start, end, '', undefined, issuesWithOriginalsAndOptimized, true);
        const issuesWithoutParent = scopeItems.issuesWithoutParent.flatMap((item)=>item.issues);
        const items = [
            ...scopeItems.startLevelIssues.issues,
            ...issuesWithoutParent
        ];
        return items;
    };
    const $d9b3354f9ef1a255$export$4dcfa5cdaa5f20c1 = (0, $3YtPS.createSelector)([
        (0, $jLI87.getIssuesWithOriginalsAndOptimized),
        (0, $jLI87.getIsExpanded),
        (0, $1cIjo.getHierarchyRangeFilter)
    ], $d9b3354f9ef1a255$export$f9b9f1184e09598e);
});
parcelRegister("dpHie", function(module, exports) {
    $parcel$export(module.exports, "getGoalValues", ()=>$f603cbb0c883fc78$export$abab68205e6c1d55);
    const $f603cbb0c883fc78$export$abab68205e6c1d55 = (issueGoalARIs = [], goalsByARI)=>issueGoalARIs.reduce((goalValues, issueGoalARI)=>{
            const goal = goalsByARI[issueGoalARI];
            if (goal !== undefined) {
                goalValues[0, $237d6663431e3fe9$export$c029c3f1c363635d].push(goal.name);
                const goalStatus = goal?.state?.label;
                if (goalStatus !== undefined) goalValues[0, $237d6663431e3fe9$export$f33fc1dddb5c20e9].push(goalStatus);
            }
            return goalValues;
        }, {
            [(0, $237d6663431e3fe9$export$c029c3f1c363635d)]: [],
            [(0, $237d6663431e3fe9$export$f33fc1dddb5c20e9)]: []
        });
});
const $237d6663431e3fe9$export$c029c3f1c363635d = 'goalName';
const $237d6663431e3fe9$export$f33fc1dddb5c20e9 = 'goalStatus';
parcelRegister("6VZXM", function(module, exports) {
    $parcel$export(module.exports, "getIdeaValues", ()=>$a7f206eb3b2786a9$export$89ad1b65a68d2015);
    const $a7f206eb3b2786a9$export$89ad1b65a68d2015 = (issueIds, associatedIssues)=>issueIds.reduce((values, issueGoalARI)=>{
            const issue = associatedIssues[issueGoalARI];
            if (issue) values[0, $f421f46bad35dbe5$export$990054d3891c9a93].push(issue.summary);
            return values;
        }, {
            [(0, $f421f46bad35dbe5$export$990054d3891c9a93)]: []
        });
});
const $f421f46bad35dbe5$export$990054d3891c9a93 = 'ideaName';
parcelRegister("e5V2f", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypeName", ()=>$8a475de8fe9b9fa7$export$7fbe5338a34739de);
    $parcel$export(module.exports, "getIssueProjectName", ()=>$8a475de8fe9b9fa7$export$6c241f86e023d701);
    $parcel$export(module.exports, "getIssueReleaseName", ()=>$8a475de8fe9b9fa7$export$84c842134cc1fd5b);
    $parcel$export(module.exports, "getIssueTeamName", ()=>$8a475de8fe9b9fa7$export$97d1f1aabb59f95);
    $parcel$export(module.exports, "getIssueAssigneeName", ()=>$8a475de8fe9b9fa7$export$3a850b8a681ae00c);
    $parcel$export(module.exports, "getIssueReporterName", ()=>$8a475de8fe9b9fa7$export$b558665a8c393051);
    $parcel$export(module.exports, "getIssueSprintName", ()=>$8a475de8fe9b9fa7$export$87ef4e1f3d511d73);
    $parcel$export(module.exports, "getIssueRollupTeamNames", ()=>$8a475de8fe9b9fa7$export$f0f50e989285e516);
    $parcel$export(module.exports, "getIssueRollUpSprintName", ()=>$8a475de8fe9b9fa7$export$ef7f668cfde40b02);
    $parcel$export(module.exports, "getIssueInferredDates", ()=>$8a475de8fe9b9fa7$export$461993bb60cf4f52);
    $parcel$export(module.exports, "getIssueParentSummary", ()=>$8a475de8fe9b9fa7$export$e0f55aa59712c593);
    $parcel$export(module.exports, "getIssuePriorityName", ()=>$8a475de8fe9b9fa7$export$4978b3d56d2e8888);
    $parcel$export(module.exports, "joinIssueLabels", ()=>$8a475de8fe9b9fa7$export$3fb12692aa6c9f2a);
    $parcel$export(module.exports, "joinIssueComponents", ()=>$8a475de8fe9b9fa7$export$b4ac423912d147e4);
    $parcel$export(module.exports, "getIssueKey", ()=>$8a475de8fe9b9fa7$export$4a030f6192bebe03);
    $parcel$export(module.exports, "getIssueCustomFieldValue", ()=>$8a475de8fe9b9fa7$export$97d480ec651a5128);
    $parcel$export(module.exports, "getIssueStatusName", ()=>$8a475de8fe9b9fa7$export$9ae9a4e7a54bf810);
    $parcel$export(module.exports, "getIssueEstimateProgressBreakdown", ()=>$8a475de8fe9b9fa7$export$8ad3db919cdd9608);
    $parcel$export(module.exports, "getIssueCountProgressBreakdown", ()=>$8a475de8fe9b9fa7$export$ff7aae3d2c7f6af0);
    $parcel$export(module.exports, "getExportCsvFileName", ()=>$8a475de8fe9b9fa7$export$e88b298904081119);
    $parcel$export(module.exports, "getExportPngFileName", ()=>$8a475de8fe9b9fa7$export$311cf81586e3cd12);
    $parcel$export(module.exports, "prepareCSVData", ()=>$8a475de8fe9b9fa7$export$63353f144eea0dc4);
    var $co1wz;
    var $4R6GH;
    var $aipk9;
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $5fRdR = parcelRequire("5fRdR");
    var $4sJY8 = parcelRequire("4sJY8");
    var $cJ4Kn = parcelRequire("cJ4Kn");
    var $iXRWw = parcelRequire("iXRWw");
    const $8a475de8fe9b9fa7$var$DateTypes = {
        Start: 'START',
        End: 'END',
        Other: 'OTHER'
    };
    const $8a475de8fe9b9fa7$var$issueField = {
        [$8a475de8fe9b9fa7$var$DateTypes.Start]: 'baselineStart',
        [$8a475de8fe9b9fa7$var$DateTypes.End]: 'baselineEnd',
        [$8a475de8fe9b9fa7$var$DateTypes.Other]: undefined
    };
    const $8a475de8fe9b9fa7$export$7fbe5338a34739de = (issueTypeId, issueTypesById)=>{
        const issueType = issueTypesById[String(issueTypeId)];
        if (issueType) return issueType.name;
        return null;
    };
    const $8a475de8fe9b9fa7$export$6c241f86e023d701 = (issueProjectId, projectsById)=>{
        const issueProject = projectsById[issueProjectId];
        if (issueProject) return issueProject.name;
        return null;
    };
    const $8a475de8fe9b9fa7$export$84c842134cc1fd5b = (issueFixVersions, versions)=>{
        const issueRelease = issueFixVersions.map((fixVersion)=>{
            const issueReleaseData = versions.find(({ id: id })=>id === fixVersion);
            if (issueReleaseData) return issueReleaseData.name;
            return null;
        }).filter(Boolean);
        if (issueRelease && issueRelease.length) return issueRelease.join(', ');
        return null;
    };
    const $8a475de8fe9b9fa7$export$97d1f1aabb59f95 = (issueTeamId, teamsById, externalTeamsById, csvIntlMessages)=>{
        if (teamsById[issueTeamId]) return teamsById[issueTeamId].title;
        if (externalTeamsById[issueTeamId]) return `${externalTeamsById[issueTeamId].title} ${csvIntlMessages.labels.external}`;
        return null;
    };
    const $8a475de8fe9b9fa7$export$3a850b8a681ae00c = (issueAssigneeId, assigneesById)=>{
        if (issueAssigneeId === 'unassigned') return null;
        const assignee = assigneesById[issueAssigneeId];
        if (assignee) return assignee.jiraUser && assignee.jiraUser.title;
        return null;
    };
    const $8a475de8fe9b9fa7$export$b558665a8c393051 = (issueReporterId, reportersById)=>{
        const reporter = reportersById[issueReporterId];
        if (reporter) return reporter.jiraUser && reporter.jiraUser.title;
        return null;
    };
    const $8a475de8fe9b9fa7$export$87ef4e1f3d511d73 = (issue, sprintsById, externalSprintsById, csvIntlMessages)=>{
        let issueSprintNames = [];
        if ((0, $4nDwW.isDefined)(issue.sprint)) {
            if (sprintsById[issue.sprint]) issueSprintNames.push(sprintsById[issue.sprint].title);
            else if (externalSprintsById[issue.sprint]) issueSprintNames.push(`${externalSprintsById[issue.sprint].title} ${csvIntlMessages.labels.external}`);
        }
        if (issue.completedSprints && issue.completedSprints.length) issueSprintNames = [
            ...issueSprintNames,
            ...issue.completedSprints.map((completedSprint)=>{
                if (sprintsById[completedSprint]) return `${sprintsById[completedSprint].title} ${csvIntlMessages.labels.completed}`;
                if (externalSprintsById[completedSprint]) return `${externalSprintsById[completedSprint].title} ${csvIntlMessages.labels.external} ${csvIntlMessages.labels.completed}`;
                return null;
            }).filter(Boolean)
        ];
        if (issueSprintNames && issueSprintNames.length) return issueSprintNames.join(' + ');
        return null;
    };
    const $8a475de8fe9b9fa7$export$f0f50e989285e516 = (teamIds, teamsById, externalTeamsById, csvIntlMessages)=>teamIds.map((id)=>$8a475de8fe9b9fa7$export$97d1f1aabb59f95(id, teamsById, externalTeamsById, csvIntlMessages) || '').join(', ');
    const $8a475de8fe9b9fa7$export$ef7f668cfde40b02 = (sprintRollUpForIssue, sprintsById, externalSprintsById, completedSprintsMsg)=>{
        const mapSprintNames = (ids)=>(ids || []).map((sprintId)=>{
                const externalSprint = externalSprintsById[sprintId];
                const sprint = sprintsById[sprintId] || {};
                return externalSprint ? externalSprint.title : sprint.title || completedSprintsMsg;
            });
        return mapSprintNames(sprintRollUpForIssue).sort((a, b)=>a.localeCompare(b)).join(', ');
    };
    const $8a475de8fe9b9fa7$export$fd2749ffa89ee868 = (issue, dateType)=>{
        const issueFieldDateType = $8a475de8fe9b9fa7$var$issueField[dateType];
        const date = typeof issueFieldDateType !== 'undefined' ? issue[issueFieldDateType] : undefined;
        return (0, $4nDwW.isDefined)(date) ? (0, (0, parcelRequire("aipk9")).formatDateUTC)(date, (0, $TTKUQ.DefaultDateFormat)) : '';
    };
    const $8a475de8fe9b9fa7$export$584f5c625cd2e6d8 = (issue, type)=>{
        if (type !== $8a475de8fe9b9fa7$var$DateTypes.Other) {
            const attribute = $8a475de8fe9b9fa7$var$issueField[type];
            const inferredFrom = issue?.inferred?.[attribute] ?? (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).NONE;
            return inferredFrom;
        }
        return (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).NONE;
    };
    const $8a475de8fe9b9fa7$export$461993bb60cf4f52 = (issue, dateConfiguration)=>({
            [`${dateConfiguration.baselineStartField.key}${$8a475de8fe9b9fa7$export$584f5c625cd2e6d8(issue, $8a475de8fe9b9fa7$var$DateTypes.Start) === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP ? 'RollUp' : ''}`]: $8a475de8fe9b9fa7$export$fd2749ffa89ee868(issue, $8a475de8fe9b9fa7$var$DateTypes.Start),
            [`${dateConfiguration.baselineEndField.key}${$8a475de8fe9b9fa7$export$584f5c625cd2e6d8(issue, $8a475de8fe9b9fa7$var$DateTypes.End) === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP ? 'RollUp' : ''}`]: $8a475de8fe9b9fa7$export$fd2749ffa89ee868(issue, $8a475de8fe9b9fa7$var$DateTypes.End)
        });
    const $8a475de8fe9b9fa7$export$e0f55aa59712c593 = (issueParentId, issueMapById)=>{
        const issueParent = issueMapById[issueParentId];
        if (issueParent) return issueParent.summary;
        return null;
    };
    const $8a475de8fe9b9fa7$export$4978b3d56d2e8888 = (issuePriorityId, issuePriorities)=>{
        const issuePriority = issuePriorities[issuePriorityId];
        if (issuePriority) return issuePriority.name;
        return null;
    };
    const $8a475de8fe9b9fa7$export$3fb12692aa6c9f2a = (issueLabels)=>issueLabels.join(', ');
    const $8a475de8fe9b9fa7$export$b4ac423912d147e4 = (issueComponents, componentsById)=>{
        const issueComponentsNames = issueComponents.map((componentId)=>componentsById[componentId] ? componentsById[componentId].name : null).filter(Boolean);
        if (issueComponentsNames && issueComponentsNames.length) return issueComponentsNames.join(', ');
        return null;
    };
    const $8a475de8fe9b9fa7$export$4a030f6192bebe03 = (issue, projectsById)=>{
        const { issueKey: issueKey = '', project: project } = issue;
        if (project && projectsById[project]) return `${projectsById[project].key}${issueKey ? `-${issueKey}` : ''}`;
        return null;
    };
    const $8a475de8fe9b9fa7$export$97d480ec651a5128 = (issueCustomFields, customField, selectOptionsById, userPickerOptionsById)=>{
        const { id: customFieldId, type: customFieldType } = customField;
        if (!issueCustomFields || !customFieldId || !customFieldType || !customFieldType.key) return null;
        switch(customFieldType.key){
            case (0, $TTKUQ.CustomFieldTypes).DatePicker:
                return issueCustomFields[customFieldId] ? (0, (0, parcelRequire("aipk9")).formatDateUTC)(issueCustomFields[customFieldId], (0, $TTKUQ.DefaultDateFormat)) : null;
            case (0, $TTKUQ.CustomFieldTypes).Labels:
                return issueCustomFields[customFieldId] ? issueCustomFields[customFieldId].join(', ') : null;
            case (0, $TTKUQ.CustomFieldTypes).RadioButtons:
            case (0, $TTKUQ.CustomFieldTypes).SingleSelect:
                return issueCustomFields[customFieldId] && selectOptionsById[issueCustomFields[customFieldId]] ? selectOptionsById[issueCustomFields[customFieldId]].value : null;
            case (0, $TTKUQ.CustomFieldTypes).MultiCheckboxes:
            case (0, $TTKUQ.CustomFieldTypes).AssetObject:
            case (0, $TTKUQ.CustomFieldTypes).MultiSelect:
                if (!(0, (0, parcelRequire("4R6GH")).fg)('asset-custom-field-internal-support')) {
                    if (customFieldType.key === (0, $TTKUQ.CustomFieldTypes).AssetObject) return issueCustomFields[customFieldId];
                }
                return issueCustomFields[customFieldId] ? issueCustomFields[customFieldId].map((customFieldSelectedOptionId)=>selectOptionsById[customFieldSelectedOptionId] ? selectOptionsById[customFieldSelectedOptionId].value : null).filter(Boolean).join(', ') : null;
            case (0, $TTKUQ.CustomFieldTypes).UserPicker:
                {
                    if (issueCustomFields[customFieldId] === 'unassigned') return null;
                    const user = userPickerOptionsById[issueCustomFields[customFieldId]];
                    if (user) return user.label;
                    return null;
                }
            default:
                return issueCustomFields[customFieldId];
        }
    };
    const $8a475de8fe9b9fa7$export$9ae9a4e7a54bf810 = (issueStatusId, issueStatusesById)=>{
        const issueStatus = issueStatusesById[issueStatusId];
        if (issueStatus) return issueStatus.name;
        return null;
    };
    const $8a475de8fe9b9fa7$export$8ad3db919cdd9608 = (issue, issueIdToDescendantsIdMap, issueStatusesById, issueMapById, planningUnit, workingHours, estimateFromHistoryIssues)=>{
        let progressRemaining = 0;
        let progressCompleted = 0;
        let progressPercentage = 0;
        const issueBreakdownByEstimate = (0, $cJ4Kn.getBreakdownByEstimate)(issue, issueIdToDescendantsIdMap, issueStatusesById, issueMapById, planningUnit, workingHours, estimateFromHistoryIssues);
        if (issueBreakdownByEstimate) {
            const { byCategoryId: byCategoryId, total: total } = issueBreakdownByEstimate;
            if ((0, $4nDwW.isDefined)(byCategoryId) && (0, $4nDwW.isDefined)(total) && total > 0) {
                progressRemaining = byCategoryId[(0, $TTKUQ.ISSUE_STATUS_CATEGORIES).TODO] + byCategoryId[(0, $TTKUQ.ISSUE_STATUS_CATEGORIES).INPROGRESS];
                progressCompleted = byCategoryId[(0, $TTKUQ.ISSUE_STATUS_CATEGORIES).DONE];
                progressPercentage = (0, $5fRdR.roundToTwoDigit)(progressCompleted / total * 100);
            }
        }
        return {
            progressPercentage: progressPercentage,
            progressCompleted: progressCompleted,
            progressRemaining: progressRemaining
        };
    };
    const $8a475de8fe9b9fa7$export$ff7aae3d2c7f6af0 = (issue, issues, issueStatusesById, issueMapById, historyIssues)=>{
        let progressIssueCount = 0;
        let toDoIssueCount = 0;
        let inProgressIssueCount = 0;
        let doneIssueCount = 0;
        let totalIssueCount = 0;
        const issueCountBreakdown = (0, $cJ4Kn.getBreakdown)(issue, (0, $4nDwW.mapGroupsToIds)((0, $4sJY8.getChildrenByParentPure)(issues)), issueStatusesById, issueMapById, historyIssues);
        if (issueCountBreakdown) {
            const { byCategoryId: byCategoryId, total: total } = issueCountBreakdown;
            if ((0, $4nDwW.isDefined)(byCategoryId) && (0, $4nDwW.isDefined)(total) && total > 0) {
                toDoIssueCount = byCategoryId[(0, $TTKUQ.ISSUE_STATUS_CATEGORIES).TODO];
                inProgressIssueCount = byCategoryId[(0, $TTKUQ.ISSUE_STATUS_CATEGORIES).INPROGRESS];
                doneIssueCount = byCategoryId[(0, $TTKUQ.ISSUE_STATUS_CATEGORIES).DONE];
                totalIssueCount = total;
                progressIssueCount = (0, $5fRdR.roundToTwoDigit)(doneIssueCount / totalIssueCount * 100);
            }
        }
        return {
            progressIssueCount: progressIssueCount,
            toDoIssueCount: toDoIssueCount,
            inProgressIssueCount: inProgressIssueCount,
            doneIssueCount: doneIssueCount,
            totalIssueCount: totalIssueCount
        };
    };
    const $8a475de8fe9b9fa7$export$319cb38742ef325d = (planningUnit, csvColumnHeadings, showRolledUpOthers = false)=>{
        if (planningUnit === (0, $TTKUQ.PlanningUnits).days) return showRolledUpOthers ? csvColumnHeadings.estimateDaysRollUp : csvColumnHeadings.estimateDays;
        if (planningUnit === (0, $TTKUQ.PlanningUnits).hours) return showRolledUpOthers ? csvColumnHeadings.estimateHoursRollUp : csvColumnHeadings.estimateHours;
        return showRolledUpOthers ? csvColumnHeadings.estimateStoryPointsRollUp : csvColumnHeadings.estimateStoryPoints;
    };
    const $8a475de8fe9b9fa7$export$6a7d553643acdfa3 = (planningUnit, csvColumnHeadings)=>{
        if (planningUnit === (0, $TTKUQ.PlanningUnits).days) return csvColumnHeadings.progressCompletedDays;
        if (planningUnit === (0, $TTKUQ.PlanningUnits).hours) return csvColumnHeadings.progressCompletedHours;
        return csvColumnHeadings.progressCompletedStoryPoints;
    };
    const $8a475de8fe9b9fa7$export$d260d342fb74a279 = (planningUnit, csvColumnHeadings)=>{
        if (planningUnit === (0, $TTKUQ.PlanningUnits).days) return csvColumnHeadings.progressRemainingDays;
        if (planningUnit === (0, $TTKUQ.PlanningUnits).hours) return csvColumnHeadings.progressRemainingHours;
        return csvColumnHeadings.progressRemainingStoryPoints;
    };
    const $8a475de8fe9b9fa7$var$getStandardFieldsColumnHeadings = (planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled, isEmbed, isConfluenceMacro)=>{
        const { columnHeadings: columnHeadings } = csvIntlMessages;
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
        const isEmbedOrMacro = isEmbed || isConfluenceMacro;
        return [
            {
                label: columnHeadings.type,
                value: 'type',
                show: true
            },
            {
                label: columnHeadings.summary,
                value: 'summary',
                show: true
            },
            {
                label: columnHeadings.project,
                value: 'project',
                show: true
            },
            {
                label: columnHeadings.releaseRollUp,
                value: 'releaseRollUp',
                show: showRolledUpOthers
            },
            {
                label: columnHeadings.release,
                value: 'release',
                show: true
            },
            {
                label: columnHeadings.teamRollUp,
                value: 'teamRollUp',
                show: showRolledUpOthers
            },
            {
                label: columnHeadings.team,
                value: 'team',
                show: true
            },
            {
                label: columnHeadings.assignee,
                value: 'assignee',
                show: true
            },
            {
                label: columnHeadings.reporter,
                value: 'reporter',
                show: true
            },
            {
                label: columnHeadings.sprintRollUp,
                value: 'sprintRollUp',
                show: showRolledUpOthers
            },
            {
                label: columnHeadings.sprint,
                value: 'sprint',
                show: true
            },
            {
                label: columnHeadings.targetStartDateRollUp,
                value: 'targetStartRollUp',
                show: showRolledUpDates && (baselineStartField.key === 'targetStart' || baselineEndField.key === 'targetStart')
            },
            {
                label: columnHeadings.targetStartDate,
                value: 'targetStart',
                show: true
            },
            {
                label: columnHeadings.targetEndDateRollUp,
                value: 'targetEndRollUp',
                show: showRolledUpDates && (baselineStartField.key === 'targetEnd' || baselineEndField.key === 'targetEnd')
            },
            {
                label: columnHeadings.targetEndDate,
                value: 'targetEnd',
                show: true
            },
            {
                label: columnHeadings.dueDateRollUp,
                value: 'dueDateRollUp',
                show: showRolledUpDates && (baselineStartField.key === 'dueDate' || baselineEndField.key === 'dueDate')
            },
            {
                label: columnHeadings.dueDate,
                value: 'dueDate',
                show: true
            },
            {
                label: $8a475de8fe9b9fa7$export$319cb38742ef325d(planningUnit, columnHeadings, showRolledUpOthers),
                value: 'estimateRollUp',
                show: showRolledUpOthers
            },
            {
                label: $8a475de8fe9b9fa7$export$319cb38742ef325d(planningUnit, columnHeadings),
                value: 'estimate',
                show: true
            },
            {
                label: columnHeadings.parent,
                value: 'parent',
                show: true
            },
            {
                label: columnHeadings.priority,
                value: 'priority',
                show: true
            },
            {
                label: columnHeadings.labels,
                value: 'labels',
                show: true
            },
            {
                label: columnHeadings.components,
                value: 'components',
                show: true
            },
            {
                label: columnHeadings.key,
                value: 'key',
                show: true
            },
            {
                label: columnHeadings.status,
                value: 'status',
                show: true
            },
            {
                label: columnHeadings[0, $237d6663431e3fe9$export$c029c3f1c363635d],
                value: (0, $237d6663431e3fe9$export$c029c3f1c363635d),
                show: isAtlasConnectInstalled
            },
            {
                label: columnHeadings[0, $237d6663431e3fe9$export$f33fc1dddb5c20e9],
                value: (0, $237d6663431e3fe9$export$f33fc1dddb5c20e9),
                show: isAtlasConnectInstalled
            },
            {
                label: columnHeadings[0, $f421f46bad35dbe5$export$990054d3891c9a93],
                value: (0, $f421f46bad35dbe5$export$990054d3891c9a93),
                show: (0, (0, parcelRequire("co1wz")).ff)('polaris-arj-eap-override') && !isEmbedOrMacro
            }
        ].filter((item)=>item.show);
    };
    const $8a475de8fe9b9fa7$var$getProgressBreakdownColumnHeadings = (planningUnit, csvIntlMessages)=>{
        const { columnHeadings: columnHeadings } = csvIntlMessages;
        return [
            {
                label: columnHeadings.progressPercentage,
                value: 'progressPercentage',
                show: true
            },
            {
                label: $8a475de8fe9b9fa7$export$6a7d553643acdfa3(planningUnit, columnHeadings),
                value: 'progressCompleted',
                show: true
            },
            {
                label: $8a475de8fe9b9fa7$export$d260d342fb74a279(planningUnit, columnHeadings),
                value: 'progressRemaining',
                show: true
            }
        ];
    };
    const $8a475de8fe9b9fa7$var$getIssueCountBreakdownColumnHeadings = (csvIntlMessages)=>{
        const { columnHeadings: columnHeadings } = csvIntlMessages;
        return [
            {
                label: columnHeadings.progressIssueCount,
                value: 'progressIssueCount',
                show: true
            },
            {
                label: columnHeadings.toDoIssueCount,
                value: 'toDoIssueCount',
                show: true
            },
            {
                label: columnHeadings.inProgressIssueCount,
                value: 'inProgressIssueCount',
                show: true
            },
            {
                label: columnHeadings.doneIssueCount,
                value: 'doneIssueCount',
                show: true
            },
            {
                label: columnHeadings.totalIssueCount,
                value: 'totalIssueCount',
                show: true
            }
        ];
    };
    const $8a475de8fe9b9fa7$export$892b30033766af0d = (customFields, planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled, isEmbed, isConfluenceMacro)=>{
        const { columnHeadings: columnHeadings } = csvIntlMessages;
        const standardFieldsColumnHeadings = $8a475de8fe9b9fa7$var$getStandardFieldsColumnHeadings(planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled, isEmbed, isConfluenceMacro);
        const progressBreakdownColumnHeadings = $8a475de8fe9b9fa7$var$getProgressBreakdownColumnHeadings(planningUnit, csvIntlMessages);
        const issueCountBreakdownColumnHeadings = $8a475de8fe9b9fa7$var$getIssueCountBreakdownColumnHeadings(csvIntlMessages);
        const customFieldColumnHeadings = customFields.map((customField)=>({
                label: customField.title,
                value: String(customField.id),
                show: true
            }));
        Object.values(dateConfiguration).forEach(({ key: key })=>{
            const index = customFieldColumnHeadings.findIndex(({ value: value })=>key === value);
            if (index === -1) return;
            const customField = customFields.find(({ id: id })=>key === String(id)) || {
                title: undefined,
                id: undefined
            };
            customFieldColumnHeadings.splice(index, 0, {
                label: `${customField.title} ${columnHeadings.rollUp}`,
                value: `${customField.id}RollUp`,
                show: true
            });
        });
        return [
            ...standardFieldsColumnHeadings,
            ...progressBreakdownColumnHeadings,
            ...issueCountBreakdownColumnHeadings,
            ...customFieldColumnHeadings
        ];
    };
    const $8a475de8fe9b9fa7$var$getExportFileName = (exportName = '', date, ext = '')=>{
        const fileName = [
            exportName.trim(),
            (0, (0, parcelRequire("aipk9")).formatDateUTC)(date.getTime(), (0, $TTKUQ.EXPORT_FILE_DATE_FORMAT))
        ].filter(Boolean).join('_');
        const safeFileName = fileName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        return `${safeFileName}.${ext}`;
    };
    const $8a475de8fe9b9fa7$export$e88b298904081119 = (exportName = '', date)=>$8a475de8fe9b9fa7$var$getExportFileName(exportName, date, 'csv');
    const $8a475de8fe9b9fa7$export$311cf81586e3cd12 = (exportName = '', date)=>$8a475de8fe9b9fa7$var$getExportFileName(exportName, date, 'png');
    const $8a475de8fe9b9fa7$export$63353f144eea0dc4 = (customFields, planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, scopeItemsArray, isAtlasConnectInstalled, isEmbed, isConfluenceMacro)=>{
        const headingsArray = $8a475de8fe9b9fa7$export$892b30033766af0d(customFields, planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled, isEmbed, isConfluenceMacro);
        return (0, $iXRWw.buildCSV)(headingsArray, scopeItemsArray);
    };
});
parcelRegister("iXRWw", function(module, exports) {
    $parcel$export(module.exports, "buildCSV", ()=>$e6884a5672549a9b$export$8bfbf32dccc29440);
    const $e6884a5672549a9b$var$NEW_LINE = '\r\n';
    const $e6884a5672549a9b$export$8bfbf32dccc29440 = (headers, scopeItems)=>{
        const visibleHeaders = headers.filter(({ show: show })=>show);
        const lines = [];
        lines.push(`${visibleHeaders.map(({ label: label })=>label).join(',')}`);
        const headerKeys = visibleHeaders.map(({ value: value })=>value);
        scopeItems.forEach((scopeItem)=>{
            const line = headerKeys.map((headerKey)=>{
                const scopeItemValue = scopeItem[headerKey];
                if (scopeItemValue === undefined || scopeItemValue === null) return '';
                if (Array.isArray(scopeItemValue)) return `"${scopeItemValue.join(',').replaceAll('"', '""')}"`;
                return `"${`${scopeItemValue}`.replaceAll('"', '""')}"`;
            }).join(',');
            lines.push(line);
        });
        return lines.join($e6884a5672549a9b$var$NEW_LINE);
    };
});
parcelRegister("2XjH3", function(module, exports) {
    $parcel$export(module.exports, "createShareReportUrl", ()=>$5bd5dd946daed81d$export$4018fa062b22188);
    $parcel$export(module.exports, "default", ()=>$5bd5dd946daed81d$export$2e2bcd8739ae039);
    var $83IGl;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $4R6GH;
    var $8DSSe = parcelRequire("8DSSe");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $idmiV = parcelRequire("idmiV");
    var $2aY8P = parcelRequire("2aY8P");
    var $fw0PB = parcelRequire("fw0PB");
    var $kWDpn = parcelRequire("kWDpn");
    var $1lSJI = parcelRequire("1lSJI");
    var $77QEM = parcelRequire("77QEM");
    var $24CMK = parcelRequire("24CMK");
    var $hvOzF = parcelRequire("hvOzF");
    var $aE6sV = parcelRequire("aE6sV");
    const $5bd5dd946daed81d$export$8409ec1a90ca0eda = 'command.share-report.CREATE_SHARE_REPORT_URL';
    const $5bd5dd946daed81d$export$4018fa062b22188 = ()=>({
            type: $5bd5dd946daed81d$export$8409ec1a90ca0eda
        });
    function* $5bd5dd946daed81d$var$getViewConfig(shareAs) {
        switch(shareAs){
            case (0, $TTKUQ.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE:
                return {
                    filtersV1: yield (0, $aNOuE.select)((0, $2aY8P.getDependencyFilters))
                };
            default:
                return yield (0, $aNOuE.select)((0, $kWDpn.getViewSettings));
        }
    }
    function $5bd5dd946daed81d$var$getViewType(shareAs) {
        switch(shareAs){
            case (0, $TTKUQ.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE:
                return 0, $TTKUQ.DEPENDENCY_REPORT_SHARE_TYPE;
            default:
                return 0, $TTKUQ.TIMELINE_SHARE_TYPE;
        }
    }
    function* $5bd5dd946daed81d$export$9a491b3da4e6dfec() {
        const { domain: { plan: { id: id, currentScenarioId: currentScenarioId } } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
        const shareAs = yield (0, $aNOuE.select)((0, $fw0PB.getShareAsState));
        const viewConfig = yield (0, $aNOuE.call)($5bd5dd946daed81d$var$getViewConfig, shareAs);
        if (!id) throw new Error('No plan to share');
        try {
            yield (0, $aNOuE.put)((0, $1lSJI.setLoadingShareReport)(true));
            const url = (0, $aE6sV.urls).share;
            const body = {
                entityId: id,
                entityType: 'PLAN',
                parameters: {
                    viewConfig: viewConfig,
                    scenarioId: currentScenarioId,
                    version: 3,
                    view: $5bd5dd946daed81d$var$getViewType(shareAs)
                }
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (response.ok) {
                const json = yield (0, $aNOuE.call)(response.json.bind(response));
                const location = yield (0, $aNOuE.call)((0, $idmiV.getLocation));
                const domain = location.origin;
                const hash = json.hash;
                let url = `${domain}/jira/plans/reports/${hash}`;
                if (shareAs === (0, $TTKUQ.SHARE_AS).EMBED) url = `${domain}/secure/PlanEmbeddedReport.jspa?r=${hash}`;
                if (shareAs === (0, $TTKUQ.SHARE_AS).CONFLUENCE || shareAs === (0, $TTKUQ.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE) url = `${domain}/secure/PortfolioRoadmapConfluence.jspa?r=${hash}`;
                yield (0, $aNOuE.put)((0, $1lSJI.updateShareReportUrl)(url));
            } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
                const error = new Error(response.text());
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $hvOzF.toErrorID)(error, 'do-create-share-report-fetch-failed'),
                        packageName: (0, $TTKUQ.PACKAGE_NAME),
                        teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
        } finally{
            yield (0, $aNOuE.put)((0, $1lSJI.setLoadingShareReport)(false));
        }
    }
    function* $5bd5dd946daed81d$export$6926c353b9065c36() {
        yield (0, $6u3NN.takeEvery)($5bd5dd946daed81d$export$8409ec1a90ca0eda, $5bd5dd946daed81d$export$9a491b3da4e6dfec);
    }
    function* $5bd5dd946daed81d$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($5bd5dd946daed81d$export$6926c353b9065c36);
    }
});
parcelRegister("2aY8P", function(module, exports) {
    $parcel$export(module.exports, "NO_SPRINT_ID", ()=>$7217c202725abbd5$export$43e4bd26116c3832);
    $parcel$export(module.exports, "getDependencyFilters", ()=>$7217c202725abbd5$export$9f024de859700a05);
    $parcel$export(module.exports, "getGroupBy", ()=>$7217c202725abbd5$export$53a21aeef48e14a8);
    $parcel$export(module.exports, "getDerivedRollupBy", ()=>$7217c202725abbd5$export$b34fa994a0b1a04f);
    $parcel$export(module.exports, "getDerivedRollupHierarchyLevel", ()=>$7217c202725abbd5$export$ee8383ff306b4af6);
    $parcel$export(module.exports, "getIssueInFocus", ()=>$7217c202725abbd5$export$252546b1d2d4555b);
    $parcel$export(module.exports, "getIssueFilter", ()=>$7217c202725abbd5$export$d04c3e551cb51203);
    $parcel$export(module.exports, "getProjectFilter", ()=>$7217c202725abbd5$export$4939fc722e810d76);
    $parcel$export(module.exports, "getIssueLinkTypeFilter", ()=>$7217c202725abbd5$export$b41266013927b954);
    $parcel$export(module.exports, "getDependenciesFilters", ()=>$7217c202725abbd5$export$ca70415d2879aa3f);
    $parcel$export(module.exports, "getStagePosAndScale", ()=>$7217c202725abbd5$export$39638c949f8528e7);
    $parcel$export(module.exports, "matchesSprintFilter", ()=>$7217c202725abbd5$export$27808ca17f8ac6d9);
    $parcel$export(module.exports, "getRolledUpIssuesLinks", ()=>$7217c202725abbd5$export$875d2ee98e4be59a);
    $parcel$export(module.exports, "getShowReset", ()=>$7217c202725abbd5$export$9501b94120bcbbda);
    $parcel$export(module.exports, "getUniqueFilterSprints", ()=>$7217c202725abbd5$export$5e2f833fb9b859c6);
    $parcel$export(module.exports, "getSprintStatesCategories", ()=>$7217c202725abbd5$export$14fe519a54423fb3);
    $parcel$export(module.exports, "getExternalSprintsForDependencyReport", ()=>$7217c202725abbd5$export$6993027b8d88ec7a);
    $parcel$export(module.exports, "getShowAddDependency", ()=>$7217c202725abbd5$export$a74c8bcabfc4ae12);
    $parcel$export(module.exports, "getAddDependencyFromIssueId", ()=>$7217c202725abbd5$export$9afef5a663d87a37);
    $parcel$export(module.exports, "getDependencyReportStatus", ()=>$7217c202725abbd5$export$f96c47160d780e3d);
    var $c12LJ;
    var $4nDwW = parcelRequire("4nDwW");
    var $3YtPS = parcelRequire("3YtPS");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $losuA = parcelRequire("losuA");
    var $cTA2K = parcelRequire("cTA2K");
    var $ddv1K = parcelRequire("ddv1K");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $gFhwb = parcelRequire("gFhwb");
    var $d3quy = parcelRequire("d3quy");
    var $6TEBn = parcelRequire("6TEBn");
    const $7217c202725abbd5$export$43e4bd26116c3832 = (0, $TTKUQ.UNDEFINED_KEY);
    const $7217c202725abbd5$export$9f024de859700a05 = (state)=>state.ui.Main.Tabs.Dependencies.Filters;
    const $7217c202725abbd5$export$53a21aeef48e14a8 = (state)=>state.ui.Main.Tabs.Dependencies.Filters.groupBy;
    const $7217c202725abbd5$export$b34fa994a0b1a04f = (state)=>$7217c202725abbd5$export$53a21aeef48e14a8(state) === (0, $losuA.GroupBy).EPIC_LEVEL ? (0, $cTA2K.ROLLUP_BY_OPTION).HIERARCHY : state.ui.Main.Tabs.Dependencies.Filters.rollupBy;
    const $7217c202725abbd5$export$ee8383ff306b4af6 = (state)=>$7217c202725abbd5$export$53a21aeef48e14a8(state) === (0, $losuA.GroupBy).EPIC_LEVEL ? (0, (0, parcelRequire("c12LJ")).STORY_LEVEL) : state.ui.Main.Tabs.Dependencies.Filters.rollupHierarchyLevel;
    const $7217c202725abbd5$export$252546b1d2d4555b = (state)=>state.ui.Main.Tabs.Dependencies.Filters.issueInFocus;
    const $7217c202725abbd5$export$d04c3e551cb51203 = (state)=>state.ui.Main.Tabs.Dependencies.Filters.issueFilter;
    const $7217c202725abbd5$export$4939fc722e810d76 = (state)=>state.ui.Main.Tabs.Dependencies.Filters.projectFilter;
    const $7217c202725abbd5$export$d63c00efb8ec5b93 = (state)=>state.ui.Main.Tabs.Dependencies.Filters.sprintFilter;
    const $7217c202725abbd5$export$b41266013927b954 = (state)=>state.ui.Main.Tabs.Dependencies.Filters.issueLinkTypeFilter;
    const $7217c202725abbd5$export$ca70415d2879aa3f = (state)=>state.ui.Main.Tabs.Dependencies.Filters;
    const $7217c202725abbd5$export$39638c949f8528e7 = (state)=>state.ui.Main.Tabs.Dependencies.StagePosAndScale;
    const $7217c202725abbd5$var$getIssueFilterSafePure = (issuesById, issueFilter)=>{
        if (issueFilter !== null && issuesById[issueFilter]) return issueFilter;
        return null;
    };
    const $7217c202725abbd5$export$cc776683b8ca2a1a = (0, $3YtPS.createSelector)([
        (0, $gFhwb.getIssueMapById),
        $7217c202725abbd5$export$d04c3e551cb51203
    ], $7217c202725abbd5$var$getIssueFilterSafePure);
    const $7217c202725abbd5$export$14dac874d99ad1a4 = (issueId, incomingLinks, outgoingLinks)=>{
        const specificIssueLinks = new Set();
        const queue = [
            issueId
        ];
        while(queue.length > 0){
            const id = queue.pop();
            for (const link of incomingLinks[id] || []){
                const id = link.sourceItemKey;
                if (!specificIssueLinks.has(id)) {
                    specificIssueLinks.add(id);
                    queue.push(id);
                }
            }
        }
        const outgoingQueue = [
            issueId
        ];
        while(outgoingQueue.length > 0){
            const outgoingQueueId = outgoingQueue.pop();
            for (const outgoingLink of outgoingLinks[outgoingQueueId] || []){
                const outgoingId = outgoingLink.targetItemKey;
                if (!specificIssueLinks.has(outgoingId)) {
                    specificIssueLinks.add(outgoingId);
                    outgoingQueue.push(outgoingId);
                }
            }
        }
        return specificIssueLinks;
    };
    const $7217c202725abbd5$export$27808ca17f8ac6d9 = (issue, sprintFilter)=>{
        const issueSprints = [
            ...issue.completedSprints || [],
            issue.sprint
        ].filter((0, $4nDwW.isDefined));
        return sprintFilter.has($7217c202725abbd5$export$43e4bd26116c3832) && issueSprints.length === 0 || issueSprints.some((sprint)=>sprintFilter.has(sprint));
    };
    const $7217c202725abbd5$export$c9b72860ad1772c6 = (internalOutgoingLinks, internalIncomingLinks, parentsAndDescendant, rollupBy, rollupHierarchyLevel, issueMap, issueInFocus, issueFilter, issues, projectFilter, issueLinkTypeFilter, sprintFilter)=>{
        const results = {};
        let hasDependency = false;
        let issuesToHighlight = new Set();
        let activeIssue = issueInFocus;
        if ((0, $4nDwW.isDefined)(issueFilter)) {
            const issueMatchesFilter = issues.find((issue)=>issue.id === issueFilter);
            if (issueMatchesFilter) activeIssue = issueMatchesFilter.id;
        }
        if ((0, $4nDwW.isDefined)(activeIssue)) {
            const chain = $7217c202725abbd5$export$14dac874d99ad1a4(activeIssue, internalIncomingLinks, internalOutgoingLinks);
            issuesToHighlight = new Set([
                ...chain,
                activeIssue
            ]);
        }
        const otherIssues = new Set();
        Object.keys(internalOutgoingLinks).forEach((key)=>{
            const links = internalOutgoingLinks[key];
            if (links.length > 0) hasDependency = true;
            links.forEach((link)=>{
                const sourceIssue = issueMap[link.sourceItemKey];
                const targetIssue = issueMap[link.targetItemKey];
                if (sourceIssue && targetIssue) {
                    if (Array.isArray(projectFilter) && projectFilter.length > 0 && !(projectFilter.includes(sourceIssue.project.toString()) || projectFilter.includes(targetIssue.project.toString()))) return;
                    if (Array.isArray(issueLinkTypeFilter) && issueLinkTypeFilter.length > 0 && !issueLinkTypeFilter.includes(link.type.toString())) return;
                    if (Array.isArray(sprintFilter) && sprintFilter.length > 0) {
                        const filterSprints = new Set(sprintFilter);
                        if (!($7217c202725abbd5$export$27808ca17f8ac6d9(sourceIssue, filterSprints) || $7217c202725abbd5$export$27808ca17f8ac6d9(targetIssue, filterSprints))) return;
                    }
                }
                let sourceItemKey = null;
                let targetItemKey = null;
                let isSourceRolledUp = false;
                let isTargetRolledUp = false;
                if (rollupBy !== 'team') {
                    sourceItemKey = link.sourceItemKey;
                    targetItemKey = link.targetItemKey;
                    if (sourceIssue.level < rollupHierarchyLevel && parentsAndDescendant[link.sourceItemKey]) {
                        const ancestors = parentsAndDescendant[link.sourceItemKey].ancestors;
                        const ancestorMatchesLevel = ancestors.find((ancestor)=>ancestor.level === rollupHierarchyLevel);
                        isSourceRolledUp = true;
                        if (ancestorMatchesLevel) sourceItemKey = ancestorMatchesLevel.id;
                        else {
                            otherIssues.add(sourceItemKey);
                            sourceItemKey = 'other';
                        }
                    }
                    if (targetIssue.level < rollupHierarchyLevel && parentsAndDescendant[link.targetItemKey]) {
                        const ancestors = parentsAndDescendant[link.targetItemKey].ancestors;
                        const ancestorMatchesLevel = ancestors.find((ancestor)=>ancestor.level === rollupHierarchyLevel);
                        isTargetRolledUp = true;
                        if (ancestorMatchesLevel) targetItemKey = ancestorMatchesLevel.id;
                        else {
                            otherIssues.add(targetItemKey);
                            targetItemKey = 'other';
                        }
                    }
                }
                if (rollupBy === 'team') {
                    if (!(0, $4nDwW.isDefined)(sourceIssue.team)) {
                        otherIssues.add(sourceIssue.id);
                        sourceItemKey = 'other';
                    } else sourceItemKey = sourceIssue.team;
                    if (!(0, $4nDwW.isDefined)(targetIssue.team)) {
                        otherIssues.add(targetIssue.id);
                        targetItemKey = 'other';
                    } else targetItemKey = targetIssue.team;
                    isSourceRolledUp = true;
                    isTargetRolledUp = true;
                }
                if ((0, $4nDwW.isDefined)(issueFilter) && (!issuesToHighlight.has(sourceItemKey) || !issuesToHighlight.has(targetItemKey))) return;
                if ((0, $4nDwW.isDefined)(sourceItemKey) && !results[sourceItemKey]) results[sourceItemKey] = {};
                if ((0, $4nDwW.isDefined)(sourceItemKey) && (0, $4nDwW.isDefined)(targetItemKey) && !results[sourceItemKey][targetItemKey]) results[sourceItemKey][targetItemKey] = {
                    type: rollupBy === 'team' ? 'team' : 'issue',
                    links: [],
                    highlight: false,
                    rollup: false
                };
                if ((0, $4nDwW.isDefined)(sourceItemKey) && (0, $4nDwW.isDefined)(targetItemKey) && results[sourceItemKey] && results[sourceItemKey][targetItemKey]) {
                    results[sourceItemKey][targetItemKey].links.push(link);
                    if (isTargetRolledUp && isSourceRolledUp) results[sourceItemKey][targetItemKey].rollup = true;
                    if (issuesToHighlight.has(sourceItemKey) && issuesToHighlight.has(targetItemKey)) results[sourceItemKey][targetItemKey].highlight = true;
                }
            });
        });
        return {
            links: results,
            otherIssues: [
                ...otherIssues
            ],
            activeIssue: activeIssue,
            hasDependency: hasDependency
        };
    };
    const $7217c202725abbd5$export$875d2ee98e4be59a = (0, $3YtPS.createSelector)([
        (0, $ddv1K.getInternalOutgoingLinks),
        (0, $ddv1K.getInternalIncomingLinks),
        (0, $bI9dZ.getWholeHierarchyParentAndDescendant),
        $7217c202725abbd5$export$b34fa994a0b1a04f,
        $7217c202725abbd5$export$ee8383ff306b4af6,
        (0, $gFhwb.getIssueMapById),
        $7217c202725abbd5$export$252546b1d2d4555b,
        $7217c202725abbd5$export$cc776683b8ca2a1a,
        (0, $gFhwb.getIssues),
        $7217c202725abbd5$export$4939fc722e810d76,
        $7217c202725abbd5$export$b41266013927b954,
        $7217c202725abbd5$export$d63c00efb8ec5b93
    ], $7217c202725abbd5$export$c9b72860ad1772c6);
    const $7217c202725abbd5$var$getShowResetPure = (groupBy, rollupBy, issueFilter, projectFilter, issueLinkTypeFilter, sprintFilter)=>(0, $4nDwW.isDefined)(rollupBy) && rollupBy !== (0, $cTA2K.ROLLUP_BY_OPTION).NONE || (0, $4nDwW.isDefined)(groupBy) && groupBy !== (0, $losuA.GroupBy).NONE || (0, $4nDwW.isDefined)(issueFilter) && issueFilter !== '' || Array.isArray(projectFilter) && projectFilter.length > 0 || Array.isArray(issueLinkTypeFilter) && issueLinkTypeFilter.length > 0 || Array.isArray(sprintFilter) && sprintFilter.length > 0;
    const $7217c202725abbd5$export$9501b94120bcbbda = (0, $3YtPS.createSelector)([
        $7217c202725abbd5$export$53a21aeef48e14a8,
        $7217c202725abbd5$export$b34fa994a0b1a04f,
        $7217c202725abbd5$export$d04c3e551cb51203,
        $7217c202725abbd5$export$4939fc722e810d76,
        $7217c202725abbd5$export$b41266013927b954,
        $7217c202725abbd5$export$d63c00efb8ec5b93
    ], $7217c202725abbd5$var$getShowResetPure);
    const $7217c202725abbd5$export$5e2f833fb9b859c6 = (0, $3YtPS.createSelector)([
        $7217c202725abbd5$export$d63c00efb8ec5b93
    ], (sprintIds)=>new Set((0, $4nDwW.isDefined)(sprintIds) ? sprintIds : []));
    const $7217c202725abbd5$export$14fe519a54423fb3 = (0, $3YtPS.createSelector)([
        (0, $d3quy.getSprintsIdsByState),
        (0, $d3quy.getExternalSprintsIds),
        $7217c202725abbd5$export$5e2f833fb9b859c6
    ], (0, $6TEBn.getSprintStatesCategoriesPure));
    const $7217c202725abbd5$var$getExternalSprintsForDependencyReportPure = (externalSprints)=>{
        const _externalSprints = externalSprints;
        _externalSprints.forEach((_, index)=>{
            _externalSprints[index].state = (0, $TTKUQ.EXTERNAL_SPRINT);
        });
        return _externalSprints;
    };
    const $7217c202725abbd5$export$6993027b8d88ec7a = (0, $3YtPS.createSelector)([
        (0, $d3quy.getExternalSprints)
    ], $7217c202725abbd5$var$getExternalSprintsForDependencyReportPure);
    const $7217c202725abbd5$export$a74c8bcabfc4ae12 = (state)=>state.ui.Main.Tabs.Dependencies.AddDependency.show;
    const $7217c202725abbd5$export$9afef5a663d87a37 = (state)=>state.ui.Main.Tabs.Dependencies.AddDependency.fromIssueId;
    const $7217c202725abbd5$export$9ef1ee05899da938 = (state)=>state.ui.Main.Tabs.Dependencies.AddDependency;
    const $7217c202725abbd5$export$f96c47160d780e3d = (state)=>state.ui.Main.Tabs.Dependencies.ReportState.status;
});
parcelRegister("losuA", function(module, exports) {
    $parcel$export(module.exports, "GroupBy", ()=>$e182f3e50e4277db$export$9abad2bb8d934a7f);
    const $e182f3e50e4277db$export$9abad2bb8d934a7f = {
        NONE: 'none',
        PROJECT: 'project',
        TEAM: 'team',
        SPRINT: 'sprint',
        EPIC_LEVEL: 'epic_level'
    };
});
parcelRegister("cTA2K", function(module, exports) {
    $parcel$export(module.exports, "ROLLUP_BY_OPTION", ()=>$ee9bffbec03c3c82$export$d9fa0ec49073b3ae);
    $parcel$export(module.exports, "UNASSIGNED", ()=>$ee9bffbec03c3c82$export$3f4d79509888a8a1);
    $parcel$export(module.exports, "NO_PARENT_GROUP_SUFFIX", ()=>$ee9bffbec03c3c82$export$377cc8309f78ea89);
    $parcel$export(module.exports, "OTHER_GROUP_ID", ()=>$ee9bffbec03c3c82$export$1c43c7cada5ed38c);
    $parcel$export(module.exports, "GROUP_BY_SPRINT_FIELD", ()=>$ee9bffbec03c3c82$export$3087c867fbc13a45);
    var $losuA = parcelRequire("losuA");
    const $ee9bffbec03c3c82$export$c53d0f541b41b88e = 'none';
    const $ee9bffbec03c3c82$export$fe791c4fa892e400 = 'project';
    const $ee9bffbec03c3c82$export$bc8b984358922f81 = 'team';
    const $ee9bffbec03c3c82$export$346285e0085a3842 = 'epic_level';
    const $ee9bffbec03c3c82$export$b2223f32ad2e34cb = 'hierarchy';
    const $ee9bffbec03c3c82$export$a316570a0dbfd2b0 = 'sprint';
    const $ee9bffbec03c3c82$export$d9fa0ec49073b3ae = {
        NONE: $ee9bffbec03c3c82$export$c53d0f541b41b88e,
        HIERARCHY: $ee9bffbec03c3c82$export$b2223f32ad2e34cb,
        TEAM: $ee9bffbec03c3c82$export$bc8b984358922f81
    };
    const $ee9bffbec03c3c82$export$3f4d79509888a8a1 = 'unassigned';
    const $ee9bffbec03c3c82$export$377cc8309f78ea89 = 'no_parent_group';
    const $ee9bffbec03c3c82$export$1c43c7cada5ed38c = 'other';
    const $ee9bffbec03c3c82$export$3087c867fbc13a45 = 'groupBySprintField';
});
parcelRegister("fw0PB", function(module, exports) {
    $parcel$export(module.exports, "getShareAsState", ()=>$702fff763fdb2c57$export$fe89daf00abed1f6);
    const $702fff763fdb2c57$export$fe89daf00abed1f6 = (state)=>state.ui.Top.TitleBar.ShareReport.shareAs;
});
parcelRegister("1lSJI", function(module, exports) {
    $parcel$export(module.exports, "OPEN_SHARE_REPORT_DIALOG", ()=>$42e28f795151a721$export$836085c4d81f251d);
    $parcel$export(module.exports, "CLOSE_SHARE_REPORT_DIALOG", ()=>$42e28f795151a721$export$f50cb06862f792a8);
    $parcel$export(module.exports, "LOADING_SHARE_REPORT_URL", ()=>$42e28f795151a721$export$876c0239d6fbc58e);
    $parcel$export(module.exports, "UPDATE_SHARE_REPORT_URL", ()=>$42e28f795151a721$export$d3f43cf16dd0c690);
    $parcel$export(module.exports, "UPDATE_SHARE_AS", ()=>$42e28f795151a721$export$f38e20411ca33587);
    $parcel$export(module.exports, "setLoadingShareReport", ()=>$42e28f795151a721$export$2294ae698e2f6b56);
    $parcel$export(module.exports, "updateShareReportUrl", ()=>$42e28f795151a721$export$a1efe1f9253d8d3);
    const $42e28f795151a721$export$836085c4d81f251d = 'state.ui.top.title-bar.share-report.OPEN_SHARE_REPORT_DIALOG';
    const $42e28f795151a721$export$f50cb06862f792a8 = 'state.ui.top.title-bar.share-report.CLOSE_SHARE_REPORT_DIALOG';
    const $42e28f795151a721$export$876c0239d6fbc58e = 'state.ui.top.title-bar.share-report.LOADING_SHARE_REPORT_URL';
    const $42e28f795151a721$export$d3f43cf16dd0c690 = 'state.ui.top.title-bar.share-report.UPDATE_SHARE_REPORT_URL';
    const $42e28f795151a721$export$f38e20411ca33587 = 'state.ui.top.title-bar.share-report.UPDATE_SHARE_AS';
    const $42e28f795151a721$export$2294ae698e2f6b56 = (isLoading)=>({
            type: $42e28f795151a721$export$876c0239d6fbc58e,
            payload: {
                isLoading: isLoading
            }
        });
    const $42e28f795151a721$export$a1efe1f9253d8d3 = (url)=>({
            type: $42e28f795151a721$export$d3f43cf16dd0c690,
            payload: {
                url: url
            }
        });
    const $42e28f795151a721$export$f7081aac54367c97 = (shareAs)=>({
            type: $42e28f795151a721$export$f38e20411ca33587,
            payload: {
                shareAs: shareAs
            }
        });
});
parcelRegister("aE6sV", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$e9b9ea997caecf51$export$bcae9ba627f604b6);
    const $e9b9ea997caecf51$export$bcae9ba627f604b6 = {
        share: '/rest/jpo/1.0/genericreport/share'
    };
});
parcelRegister("6mZQO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bda3795527227b12$export$2e2bcd8739ae039);
    var $1CGdp = parcelRequire("1CGdp");
    var $9SFhm = parcelRequire("9SFhm");
    var $2aY8P = parcelRequire("2aY8P");
    var $bZA5o = parcelRequire("bZA5o");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $fw0PB = parcelRequire("fw0PB");
    var $jK6Qc = parcelRequire("jK6Qc");
    var $3YtPS = parcelRequire("3YtPS");
    const $bda3795527227b12$export$2ca6bc717c6809d7 = (state)=>state.ui.Top.TitleBar.ShareReport.isDialogOpen;
    const $bda3795527227b12$export$20bb0d907fbbe433 = (state)=>state.ui.Top.TitleBar.ShareReport.isLoading;
    const $bda3795527227b12$export$988c39a43dd06466 = (state)=>state.ui.Top.TitleBar.ShareReport.url;
    var $bda3795527227b12$export$2e2bcd8739ae039 = (0, $3YtPS.createStructuredSelector)({
        isLoading: $bda3795527227b12$export$20bb0d907fbbe433,
        isOpen: $bda3795527227b12$export$2ca6bc717c6809d7,
        mode: (0, $1CGdp.getMode),
        noIssuesInPlan: (state)=>(0, $jK6Qc.getEnhancedIssues)(state).length === 0,
        readOnly: (0, $1CGdp.isReadOnly),
        isReportMode: $1CGdp.isReportMode,
        planModeForAnalytics: (0, $1CGdp.getPlanModeForAnalytics),
        dependencyReportStatus: (0, $2aY8P.getDependencyReportStatus),
        shareAs: (0, $fw0PB.getShareAsState),
        url: $bda3795527227b12$export$988c39a43dd06466,
        analyticsEvent: (0, $1CGdp.getAnalyticsEvent),
        isIssuesLoading: (0, $bI9dZ.getIsIssuesLoading),
        planTitle: (0, $bHTqr.getPlanTitle),
        definedGoalsByARI: (0, $bZA5o.getDefinedGoals),
        associatedIssues: (0, $9SFhm.getAssociatedIssues)
    });
});
parcelRegister("gapWT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc6b623201120bf5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $jZX0t;
    var $1R1Ge;
    var $ayWDM;
    var $juVrZ;
    var $kzjuk;
    var $g2EiV;
    var $gjTBi;
    var $gZEU1;
    var $3bDjY;
    var $9fuVs;
    var $4R6GH;
    var $koVbs;
    var $3HwlS;
    var $aCpcO;
    var $i2qlb = parcelRequire("i2qlb");
    var $brWHE = parcelRequire("brWHE");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $2OMDV;
    var $iXVV6;
    var $8zOmE;
    var $dCm1o;
    var $3Vb6m = parcelRequire("3Vb6m");
    var $8w9wf = parcelRequire("8w9wf");
    var $c37Ug = parcelRequire("c37Ug");
    var $fyrT6 = parcelRequire("fyrT6");
    const $cc6b623201120bf5$var$ButtonItemWithAnalytics = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('tab', {
        onClick: 'clicked'
    })((0, (0, parcelRequire("ayWDM")).default));
    function $cc6b623201120bf5$var$ShareReport({ analyticsEvent: analyticsEvent, closeShareReportDialog: closeShareReportDialog, confluenceMacroType: confluenceMacroType, dependencyReportStatus: dependencyReportStatus, getExportCsvScopeItems: getExportCsvScopeItems, isIssuesLoading: isIssuesLoading, isLoading: isLoading, isOpen: isOpen = false, isReportMode: isReportMode, mode: mode, noIssuesInPlan: noIssuesInPlan, openShareReportDialog: openShareReportDialog, planExportedAnalytics: planExportedAnalytics, planModeForAnalytics: planModeForAnalytics, planTitle: planTitle, readOnly: readOnly, shareAs: shareAs, updateShareReportUrl: updateShareReportUrl, url: url, definedGoalsByARI: definedGoalsByARI, associatedIssues: associatedIssues }) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const open = (_, analyticsEvent)=>{
            resetShareAsReduxState();
            openShareReportDialog();
            if (readOnly && shareAs !== (0, $TTKUQ.SHARE_AS).PNG && shareAs !== (0, $TTKUQ.SHARE_AS).CSV) updateShareReportUrl({
                shareAs: (0, $TTKUQ.SHARE_AS).CSV
            });
            const [actionSubject, action] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SHARE_REPORT.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SHARE_REPORT);
        };
        const close = ()=>closeShareReportDialog();
        const resetShareAsReduxState = ()=>{
            if (confluenceMacroType === (0, $TTKUQ.TIMELINE_SHARE_TYPE) && shareAs === (0, $TTKUQ.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE) updateShareReportUrl({
                shareAs: (0, $TTKUQ.SHARE_AS).LINK
            });
            else if (confluenceMacroType === (0, $TTKUQ.DEPENDENCY_REPORT_SHARE_TYPE) && shareAs !== (0, $TTKUQ.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE) updateShareReportUrl({
                shareAs: (0, $TTKUQ.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE
            });
        };
        const getShareDialogNavigationItems = ()=>{
            const navigationItems = [
                {
                    action: (0, $TTKUQ.SHARE_AS).LINK,
                    label: intl.formatMessage((0, $c37Ug.default).shareAsLink)
                },
                {
                    action: (0, $TTKUQ.SHARE_AS).EMBED,
                    label: intl.formatMessage((0, $c37Ug.default).shareAsEmbed)
                },
                {
                    action: (0, $TTKUQ.SHARE_AS).CONFLUENCE,
                    label: intl.formatMessage((0, $c37Ug.default).shareAsConfluence)
                },
                {
                    action: (0, $TTKUQ.SHARE_AS).CSV,
                    label: intl.formatMessage((0, $c37Ug.default).shareAsSpreadsheetCsv)
                },
                {
                    action: (0, $TTKUQ.SHARE_AS).PNG,
                    label: intl.formatMessage((0, $c37Ug.default).shareAsPng)
                }
            ];
            return navigationItems.map(({ action: action, label: label })=>{
                const isSelected = shareAs === action;
                const isDisabled = isReportMode && action !== (0, $TTKUQ.SHARE_AS).CSV || readOnly && ![
                    (0, $TTKUQ.SHARE_AS).CSV,
                    (0, $TTKUQ.SHARE_AS).PNG
                ].includes(action);
                return (0, ($parcel$interopDefault($5uXOq))).createElement($cc6b623201120bf5$var$ButtonItemWithAnalytics, {
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: action,
                    onClick: (_, analyticsEvent)=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, action, {
                            planMode: planModeForAnalytics
                        });
                        updateShareReportUrl({
                            shareAs: action
                        });
                    },
                    testId: `portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-${action.toLowerCase()}`
                }, label);
            });
        };
        const isDependencyReportReadonlyOrReportMode = ()=>confluenceMacroType === (0, $TTKUQ.DEPENDENCY_REPORT_SHARE_TYPE) && (mode === (0, $ab4be2e1e204af69$export$b07c15b79440feb8) || mode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7));
        if (isDependencyReportReadonlyOrReportMode()) return null;
        const shareAsButtonTextFormatted = intl.formatMessage((0, $c37Ug.default).shareButtonText);
        const isDisabled = isIssuesLoading || confluenceMacroType === (0, $TTKUQ.DEPENDENCY_REPORT_SHARE_TYPE) && dependencyReportStatus !== (0, $brWHE.ReportStatus).SUCCESS;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "shareReport",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-report-button"
        }, !(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && mode !== (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) && mode !== (0, $ab4be2e1e204af69$export$b07c15b79440feb8) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $fyrT6.shareButtonIconOnly
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: shareAsButtonTextFormatted
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            ariaLabel: shareAsButtonTextFormatted,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jZX0t"))))), {
                label: ""
            }),
            onClick: open,
            appearance: "subtle",
            isDisabled: isDisabled
        }))), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("jZX0t"))))),
            onClick: open,
            appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? 'default' : 'subtle',
            isDisabled: isDisabled,
            label: shareAsButtonTextFormatted,
            isTooltipDisabled: false
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: mode !== (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7) && mode !== (0, $ab4be2e1e204af69$export$b07c15b79440feb8) ? $fyrT6.shareButtonLabelOnly : ''
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jZX0t"))))), {
                label: ""
            }),
            onClick: open,
            appearance: "subtle",
            isDisabled: isDisabled
        }, shareAsButtonTextFormatted))), isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            autoFocus: false,
            onClose: close,
            width: "x-large",
            label: intl.formatMessage((0, $c37Ug.default).sharePlanLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $fyrT6.modalBody
        }, confluenceMacroType === (0, $TTKUQ.TIMELINE_SHARE_TYPE) ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $fyrT6.sideNavigation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZEU1")).default), {
            label: intl.formatMessage((0, $c37Ug.default).shareHeader)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g2EiV")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juVrZ")).default), null, intl.formatMessage((0, $c37Ug.default).shareHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kzjuk")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjTBi")).default), null, getShareDialogNavigationItems())))) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3Vb6m.default), {
            intl: intl,
            isLoading: isLoading,
            onClose: close,
            shareAs: shareAs,
            updateShareReportUrl: updateShareReportUrl,
            url: url,
            getExportCsvScopeItems: getExportCsvScopeItems,
            noIssuesInPlan: noIssuesInPlan,
            PNGExportContentComponent: (0, $8w9wf.default),
            planMode: planModeForAnalytics,
            isReportMode: isReportMode,
            analyticsEvent: analyticsEvent,
            planExportedAnalytics: planExportedAnalytics,
            confluenceMacroType: confluenceMacroType,
            planTitle: planTitle,
            definedGoalsByARI: definedGoalsByARI,
            associatedIssues: associatedIssues
        })))));
    }
    var $cc6b623201120bf5$export$2e2bcd8739ae039 = $cc6b623201120bf5$var$ShareReport;
});
parcelRegister("jZX0t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
    function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e8f17c524b03e26b$var$ShareIcon = (props)=>$e8f17c524b03e26b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
        }, props, {
            newIcon: $e8f17c524b03e26b$var$_share.default
        }));
    $e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
    var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;
});
parcelRegister("empdx", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a746ae65a0e1944c$var$_react = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a746ae65a0e1944c$var$_UNSAFE_baseNew = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a746ae65a0e1944c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a746ae65a0e1944c$var$ShareIcon = (props)=>$a746ae65a0e1944c$var$_react.default.createElement($a746ae65a0e1944c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
        }, props));
    $a746ae65a0e1944c$var$ShareIcon.displayName = 'ShareIcon';
    var $a746ae65a0e1944c$var$_default = module.exports.default = $a746ae65a0e1944c$var$ShareIcon;
});
parcelRegister("brWHE", function(module, exports) {
    $parcel$export(module.exports, "ReportStatus", ()=>$da7a6538750a7298$export$8133a9c5bfc78dc);
    const $da7a6538750a7298$export$8133a9c5bfc78dc = {
        LOADING: 'loading',
        SUCCESS: 'success',
        WARNING: 'warning'
    };
});
parcelRegister("3Vb6m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$550bb6969d38f267$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $cLFIZ;
    var $2hXfb;
    var $cgL5K;
    var $kY99m;
    var $5Zxxp;
    var $ousew;
    var $aCpcO;
    var $i2qlb = parcelRequire("i2qlb");
    var $b0D0x = parcelRequire("b0D0x");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $4cwkM = parcelRequire("4cwkM");
    var $ihPUd = parcelRequire("ihPUd");
    var $8zOmE;
    var $fyrT6 = parcelRequire("fyrT6");
    var $5lSKe = parcelRequire("5lSKe");
    var $cAVWg = parcelRequire("cAVWg");
    var $8w9wf = parcelRequire("8w9wf");
    var $h8a27 = parcelRequire("h8a27");
    class $550bb6969d38f267$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { intl: { formatMessage: formatMessage }, isLoading: isLoading, isReportMode: isReportMode, onClose: onClose, shareAs: shareAs, planTitle: planTitle } = this.props;
            const { isCopied: isCopied } = this.state;
            const isConfluenceSharing = shareAs === (0, $TTKUQ.SHARE_AS).CONFLUENCE || this.isConfluenceSharingType(shareAs);
            if (shareAs === (0, $TTKUQ.SHARE_AS).CSV) {
                const { getExportCsvScopeItems: getExportCsvScopeItems, noIssuesInPlan: noIssuesInPlan, definedGoalsByARI: definedGoalsByARI, associatedIssues: associatedIssues } = this.props;
                const csvIntlMessages = (0, $h8a27.getCsvIntlMessages)(formatMessage, planTitle);
                const onClickExport = (additionalData = {
                    goalsByARI: {},
                    associatedIssues: {}
                })=>{
                    if (!noIssuesInPlan) {
                        getExportCsvScopeItems(csvIntlMessages, additionalData);
                        this.setState({
                            didCsvDownload: true
                        });
                    }
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5lSKe.CSVExport), {
                    isReportMode: isReportMode,
                    noIssuesInPlan: noIssuesInPlan,
                    onClickExport: onClickExport,
                    onClose: onClose,
                    definedGoalsByARI: definedGoalsByARI,
                    associatedIssues: associatedIssues
                });
            }
            if (shareAs === (0, $TTKUQ.SHARE_AS).PNG) {
                const { planMode: planMode } = this.props;
                let { PNGExportContentComponent: PNGExportContentComponent } = this.props;
                PNGExportContentComponent = PNGExportContentComponent || (0, $8w9wf.default);
                return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $fyrT6.content
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $fyrT6.contentHeading
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                    size: "medium",
                    as: "h2"
                }, formatMessage((0, $cAVWg.default).shareDialogHeader))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $fyrT6.contentBody
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(PNGExportContentComponent, {
                    onClose: onClose,
                    planMode: planMode
                }))));
            }
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.content
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.contentHeading
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                size: "medium",
                as: "h2"
            }, formatMessage({
                ...(0, $cAVWg.default).shareDialogHeader
            }))), isConfluenceSharing ? this.confluenceSharingIntro() : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage({
                ...(0, $cAVWg.default).urlLabel
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.urlForm
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.urlTextfield,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.url"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                "aria-label": formatMessage({
                    ...(0, $cAVWg.default).confluenceUrlLabel
                }),
                isReadOnly: true,
                ref: (fieldRef)=>{
                    this.input = fieldRef;
                },
                value: this.textFieldValue()
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.copyButton
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                appearance: "primary",
                onClick: this.copyToClipboard,
                isDisabled: isLoading,
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.copy-button"
            }, formatMessage({
                ...(0, $cAVWg.default).copyButtonText
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.copiedMessage,
                role: "alert",
                "aria-live": "polite",
                style: {
                    visibility: isCopied ? 'visible' : 'hidden'
                }
            }, formatMessage({
                ...(0, $cAVWg.default).copiedButtonText
            }))), isConfluenceSharing ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.accessControl
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.accessControlMacroIcon
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2hXfb"))))), {
                label: formatMessage((0, $cAVWg.default).accessControlNoteIcon),
                size: "medium"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.accessControlMessage
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cAVWg.default).accessControlMacroDescription))) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.accessControl
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cLFIZ"))))), {
                label: formatMessage({
                    ...(0, $cAVWg.default).accessControlIcon
                }),
                color: "currentColor",
                spacing: "spacious"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.accessControlMessage
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, $cAVWg.default).accessControlDescriptionTimeline,
                values: {
                    action: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "strong"
                    }, formatMessage((0, $cAVWg.default).accessControlView))
                }
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $fyrT6.contentFooter
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
                onClick: onClose,
                appearance: "subtle"
            }, formatMessage((0, $ihPUd.default).cancel)))));
        }
        constructor(...args){
            super(...args);
            this.state = {
                isCopied: false,
                didCsvDownload: false
            };
            this.componentDidUpdate = ()=>{
                this.selectTextInUrlField();
            };
            this.componentWillUnmount = ()=>{
                const { shareAs: shareAs, analyticsEvent: analyticsEvent } = this.props;
                if (analyticsEvent && shareAs === (0, $TTKUQ.SHARE_AS).CSV) {
                    const { planMode: planMode } = this.props;
                    const { didCsvDownload: didCsvDownload } = this.state;
                    const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).EXPORT_CSV_MODAL_CLOSED.split(' ');
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                        action: action,
                        actionSubject: actionSubject
                    }), actionSubjectId, {
                        didDownload: didCsvDownload,
                        planMode: planMode
                    });
                }
            };
            this.selectTextInUrlField = ()=>{
                if (this.input) this.input.select();
            };
            this.copyToClipboard = ()=>{
                const { planExportedAnalytics: planExportedAnalytics, shareAs: shareAs } = this.props;
                this.selectTextInUrlField();
                document.execCommand('copy');
                if (this.input) this.input.focus();
                this.setState({
                    isCopied: true
                }, ()=>{
                    setTimeout(()=>{
                        if (this.input) this.input.blur();
                        this.setState({
                            isCopied: false
                        });
                    }, 5000);
                });
                const exportFormats = Object.values((0, $b0D0x.EXPORT_EVENT_TYPE));
                if (exportFormats.includes(shareAs)) planExportedAnalytics({
                    exportFormat: shareAs
                });
            };
            this.getUrl = ()=>{
                const { url: url, shareAs: shareAs } = this.props;
                if (shareAs === (0, $TTKUQ.SHARE_AS).EMBED) return `<iframe src='${url}' width='1024' height='640' style='border:1px solid #ccc;'></iframe>`;
                return url;
            };
            this.getConfluenceMacroSharingMessage = ()=>{
                const { confluenceMacroType: confluenceMacroType } = this.props;
                switch(confluenceMacroType){
                    case 0, $TTKUQ.DEPENDENCY_REPORT_SHARE_TYPE:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cAVWg.default).confluenceDependencyMacroSharingMessage);
                    default:
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $cAVWg.default).confluenceTimelineMacroSharingMessage);
                }
            };
            this.confluenceSharingIntro = ()=>{
                const { intl: intl, onClose: onClose } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, this.getConfluenceMacroSharingMessage()), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, $cAVWg.default).confluenceMacroSharingInstructions,
                    values: {
                        link: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Zxxp")).default), {
                            articleId: (0, $TTKUQ.IPH_IDS).SHARE_CONFLUENCE,
                            fallbackComponent: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cwkM.default), {
                                href: (0, $4cwkM.default).URLs.schedulingWork
                            }, intl.formatMessage((0, $cAVWg.default).confluenceMacroIph)),
                            appearance: "link",
                            spacing: "none",
                            onClick: onClose
                        }, intl.formatMessage((0, $cAVWg.default).confluenceMacroIph))
                    }
                })));
            };
            this.textFieldValue = ()=>{
                const { intl: intl, isLoading: isLoading } = this.props;
                return isLoading ? intl.formatMessage({
                    ...(0, $cAVWg.default).generatingUrl
                }) : this.getUrl();
            };
            this.isConfluenceSharingType = (shareAs)=>shareAs === (0, $TTKUQ.SHARE_AS).CONFLUENCE || shareAs === (0, $TTKUQ.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE;
        }
    }
});
parcelRegister("cLFIZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $94ba3d7556c02568$var$_react = $94ba3d7556c02568$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $94ba3d7556c02568$var$_lockLocked = $94ba3d7556c02568$var$_interopRequireDefault((parcelRequire("bwyQI")));
    var $94ba3d7556c02568$var$_lockCircle = $94ba3d7556c02568$var$_interopRequireDefault((parcelRequire("e18s4")));
    function $94ba3d7556c02568$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $94ba3d7556c02568$var$LockLockedIcon = (props)=>$94ba3d7556c02568$var$_react.default.createElement($94ba3d7556c02568$var$_lockLocked.default, Object.assign({
            LEGACY_fallbackIcon: $94ba3d7556c02568$var$_lockCircle.default
        }, props));
    $94ba3d7556c02568$var$LockLockedIcon.Name = 'LockLockedIconMigration';
    var $94ba3d7556c02568$var$_default = module.exports.default = $94ba3d7556c02568$var$LockLockedIcon;
});
parcelRegister("bwyQI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $863db7350f859785$var$_UNSAFE_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $863db7350f859785$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $863db7350f859785$var$LockLockedIcon = (props)=>$863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
        }, props));
    $863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
    var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;
});
parcelRegister("e18s4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a347b707a6f1e26b$var$_react = $a347b707a6f1e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $a347b707a6f1e26b$var$_lockLocked = $a347b707a6f1e26b$var$_interopRequireDefault((parcelRequire("bwyQI")));
    function $a347b707a6f1e26b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a347b707a6f1e26b$var$LockCircleIcon = (props)=>$a347b707a6f1e26b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M12.02 8h-.04A1.98 1.98 0 0 0 10 9.98V11h1V9.99a.99.99 0 0 1 .99-.99h.02a.99.99 0 0 1 .99.99V11h1V9.98A1.98 1.98 0 0 0 12.02 8M10 11h1v1h-1zm3 0h1v1h-1zm0 1h-3a1 1 0 0 0-1 1v2a1 1 0 0 0 .99 1h4.02c.55 0 .99-.44.99-1v-2a1 1 0 0 0-1-1z"/></g></svg>`
        }, props, {
            newIcon: $a347b707a6f1e26b$var$_lockLocked.default
        }));
    $a347b707a6f1e26b$var$LockCircleIcon.displayName = 'LockCircleIcon';
    var $a347b707a6f1e26b$var$_default = module.exports.default = $a347b707a6f1e26b$var$LockCircleIcon;
});
parcelRegister("fyrT6", function(module, exports) {
    $parcel$export(module.exports, "accessControl", ()=>$b52fa9e4b0d704b0$export$fdd9c2c09d78ce4c, (v)=>$b52fa9e4b0d704b0$export$fdd9c2c09d78ce4c = v);
    $parcel$export(module.exports, "accessControlMacroIcon", ()=>$b52fa9e4b0d704b0$export$56923094f5f1fa12, (v)=>$b52fa9e4b0d704b0$export$56923094f5f1fa12 = v);
    $parcel$export(module.exports, "accessControlMessage", ()=>$b52fa9e4b0d704b0$export$83744063017ab4a, (v)=>$b52fa9e4b0d704b0$export$83744063017ab4a = v);
    $parcel$export(module.exports, "content", ()=>$b52fa9e4b0d704b0$export$a7db06668cad9adb, (v)=>$b52fa9e4b0d704b0$export$a7db06668cad9adb = v);
    $parcel$export(module.exports, "contentBody", ()=>$b52fa9e4b0d704b0$export$95dc927f26875787, (v)=>$b52fa9e4b0d704b0$export$95dc927f26875787 = v);
    $parcel$export(module.exports, "contentBodyIntro", ()=>$b52fa9e4b0d704b0$export$a75a3bae055e85c8, (v)=>$b52fa9e4b0d704b0$export$a75a3bae055e85c8 = v);
    $parcel$export(module.exports, "contentFooter", ()=>$b52fa9e4b0d704b0$export$553e225968be56ef, (v)=>$b52fa9e4b0d704b0$export$553e225968be56ef = v);
    $parcel$export(module.exports, "contentHeading", ()=>$b52fa9e4b0d704b0$export$91dccde366be8185, (v)=>$b52fa9e4b0d704b0$export$91dccde366be8185 = v);
    $parcel$export(module.exports, "copiedMessage", ()=>$b52fa9e4b0d704b0$export$4c3060136220ba05, (v)=>$b52fa9e4b0d704b0$export$4c3060136220ba05 = v);
    $parcel$export(module.exports, "copyButton", ()=>$b52fa9e4b0d704b0$export$82c3bb3cf4f0e46, (v)=>$b52fa9e4b0d704b0$export$82c3bb3cf4f0e46 = v);
    $parcel$export(module.exports, "modalBody", ()=>$b52fa9e4b0d704b0$export$475ea8af95eb4516, (v)=>$b52fa9e4b0d704b0$export$475ea8af95eb4516 = v);
    $parcel$export(module.exports, "shareButtonIconOnly", ()=>$b52fa9e4b0d704b0$export$2ddc19957d825cb3, (v)=>$b52fa9e4b0d704b0$export$2ddc19957d825cb3 = v);
    $parcel$export(module.exports, "shareButtonLabelOnly", ()=>$b52fa9e4b0d704b0$export$c8eafe09676fbaa, (v)=>$b52fa9e4b0d704b0$export$c8eafe09676fbaa = v);
    $parcel$export(module.exports, "sideNavigation", ()=>$b52fa9e4b0d704b0$export$176e221cffa2e044, (v)=>$b52fa9e4b0d704b0$export$176e221cffa2e044 = v);
    $parcel$export(module.exports, "urlForm", ()=>$b52fa9e4b0d704b0$export$1fc77b9f6ff29e1c, (v)=>$b52fa9e4b0d704b0$export$1fc77b9f6ff29e1c = v);
    $parcel$export(module.exports, "urlTextfield", ()=>$b52fa9e4b0d704b0$export$f2518e279dc5ad83, (v)=>$b52fa9e4b0d704b0$export$f2518e279dc5ad83 = v);
    var $b52fa9e4b0d704b0$export$fdd9c2c09d78ce4c;
    var $b52fa9e4b0d704b0$export$56923094f5f1fa12;
    var $b52fa9e4b0d704b0$export$83744063017ab4a;
    var $b52fa9e4b0d704b0$export$a7db06668cad9adb;
    var $b52fa9e4b0d704b0$export$95dc927f26875787;
    var $b52fa9e4b0d704b0$export$a75a3bae055e85c8;
    var $b52fa9e4b0d704b0$export$553e225968be56ef;
    var $b52fa9e4b0d704b0$export$91dccde366be8185;
    var $b52fa9e4b0d704b0$export$4c3060136220ba05;
    var $b52fa9e4b0d704b0$export$82c3bb3cf4f0e46;
    var $b52fa9e4b0d704b0$export$42436f1f3fbda47f;
    var $b52fa9e4b0d704b0$export$475ea8af95eb4516;
    var $b52fa9e4b0d704b0$export$644913298ab745fc;
    var $b52fa9e4b0d704b0$export$2ddc19957d825cb3;
    var $b52fa9e4b0d704b0$export$c8eafe09676fbaa;
    var $b52fa9e4b0d704b0$export$176e221cffa2e044;
    var $b52fa9e4b0d704b0$export$1fc77b9f6ff29e1c;
    var $b52fa9e4b0d704b0$export$f2518e279dc5ad83;
    $b52fa9e4b0d704b0$export$fdd9c2c09d78ce4c = `_93vqlG_accessControl`;
    $b52fa9e4b0d704b0$export$56923094f5f1fa12 = `_93vqlG_accessControlMacroIcon`;
    $b52fa9e4b0d704b0$export$83744063017ab4a = `_93vqlG_accessControlMessage`;
    $b52fa9e4b0d704b0$export$a7db06668cad9adb = `_93vqlG_content`;
    $b52fa9e4b0d704b0$export$95dc927f26875787 = `_93vqlG_contentBody`;
    $b52fa9e4b0d704b0$export$a75a3bae055e85c8 = `_93vqlG_contentBodyIntro`;
    $b52fa9e4b0d704b0$export$553e225968be56ef = `_93vqlG_contentFooter`;
    $b52fa9e4b0d704b0$export$91dccde366be8185 = `_93vqlG_contentHeading`;
    $b52fa9e4b0d704b0$export$4c3060136220ba05 = `_93vqlG_copiedMessage`;
    $b52fa9e4b0d704b0$export$82c3bb3cf4f0e46 = `_93vqlG_copyButton`;
    $b52fa9e4b0d704b0$export$42436f1f3fbda47f = `_93vqlG_generateLinkButton`;
    $b52fa9e4b0d704b0$export$475ea8af95eb4516 = `_93vqlG_modalBody`;
    $b52fa9e4b0d704b0$export$644913298ab745fc = `_93vqlG_shareButton`;
    $b52fa9e4b0d704b0$export$2ddc19957d825cb3 = `_93vqlG_shareButtonIconOnly`;
    $b52fa9e4b0d704b0$export$c8eafe09676fbaa = `_93vqlG_shareButtonLabelOnly`;
    $b52fa9e4b0d704b0$export$176e221cffa2e044 = `_93vqlG_sideNavigation`;
    $b52fa9e4b0d704b0$export$1fc77b9f6ff29e1c = `_93vqlG_urlForm`;
    $b52fa9e4b0d704b0$export$f2518e279dc5ad83 = `_93vqlG_urlTextfield`;
});
parcelRegister("5lSKe", function(module, exports) {
    $parcel$export(module.exports, "CSVExport", ()=>$446a72f30595f51f$export$44886573e792865b);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yOBd;
    var $ldJSL;
    var $61MPp;
    var $cgL5K;
    var $92Z2l;
    var $3bDjY;
    var $koVbs;
    var $aCpcO;
    var $gJZ5D;
    var $ihPUd = parcelRequire("ihPUd");
    var $fyrT6 = parcelRequire("fyrT6");
    var $cAVWg = parcelRequire("cAVWg");
    const $446a72f30595f51f$export$44886573e792865b = ({ isReportMode: isReportMode, noIssuesInPlan: noIssuesInPlan, onClickExport: onClickExport, onClose: onClose, definedGoalsByARI: definedGoalsByARI, associatedIssues: associatedIssues })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClickExportWithAdditionalData = (0, $5uXOq.useCallback)(()=>{
            onClickExport({
                goalsByARI: definedGoalsByARI,
                associatedIssues: associatedIssues
            });
        }, [
            onClickExport,
            definedGoalsByARI,
            associatedIssues
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $fyrT6.content
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("h3", {
            className: $fyrT6.contentHeading
        }, formatMessage((0, $cAVWg.default).shareDialogHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $fyrT6.contentBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $fyrT6.contentBodyIntro
        }, isReportMode && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage((0, $cAVWg.default).reportModeMessage))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage((0, $cAVWg.default).exportCsvIntro)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage((0, $cAVWg.default).plansExportCsvIntro2)))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $fyrT6.contentFooter
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: noIssuesInPlan && formatMessage((0, $cAVWg.default).noIssuesToExportTooltip)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            appearance: "primary",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("61MPp"))))), {
                label: ""
            }),
            onClick: onClickExportWithAdditionalData,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.csv-export.export-spreadsheet",
            theme: (current, themeProps)=>({
                    ...current(themeProps),
                    buttonStyles: {
                        ...current(themeProps).buttonStyles,
                        ...noIssuesInPlan && {
                            background: `var(--ds-background-disabled, ${(0, (0, parcelRequire("gJZ5D")).default).N20A})`,
                            color: `var(--ds-text-disabled, ${(0, (0, parcelRequire("gJZ5D")).default).N70})`,
                            cursor: 'not-allowed'
                        }
                    }
                })
        }, formatMessage((0, $cAVWg.default).exportCsvButton))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage((0, $ihPUd.default).cancel))))));
    };
});
parcelRegister("61MPp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4638b6534bbbec0b$var$_react = $4638b6534bbbec0b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4638b6534bbbec0b$var$_upload = $4638b6534bbbec0b$var$_interopRequireDefault((parcelRequire("50qBU")));
    function $4638b6534bbbec0b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4638b6534bbbec0b$var$ExportIcon = (props)=>$4638b6534bbbec0b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
        }, props, {
            newIcon: $4638b6534bbbec0b$var$_upload.default
        }));
    $4638b6534bbbec0b$var$ExportIcon.displayName = 'ExportIcon';
    var $4638b6534bbbec0b$var$_default = module.exports.default = $4638b6534bbbec0b$var$ExportIcon;
});
parcelRegister("50qBU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3a519821f4edd432$var$_react = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3a519821f4edd432$var$_UNSAFE_baseNew = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3a519821f4edd432$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3a519821f4edd432$var$UploadIcon = (props)=>$3a519821f4edd432$var$_react.default.createElement($3a519821f4edd432$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
        }, props));
    $3a519821f4edd432$var$UploadIcon.displayName = 'UploadIcon';
    var $3a519821f4edd432$var$_default = module.exports.default = $3a519821f4edd432$var$UploadIcon;
});
parcelRegister("cAVWg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ab0328ed7eff1bf$export$2e2bcd8739ae039);
    var $7VHMR;
    const $2ab0328ed7eff1bf$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareDialogHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.share-dialog-header",
            "defaultMessage": "Share plan"
        },
        urlLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.url-label",
            "defaultMessage": "Copy the link to share this plan:"
        },
        generatingUrl: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.generating-url",
            "defaultMessage": "Generating ..."
        },
        copyButtonText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.copy-button-text",
            "defaultMessage": "Copy"
        },
        copiedButtonText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.copied-button-text",
            "defaultMessage": "Copied!"
        },
        accessControlIcon: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.access-control-icon",
            "defaultMessage": "Access Control:"
        },
        accessControlNoteIcon: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.access-control-note-icon",
            "defaultMessage": "note"
        },
        accessControlDescriptionTimeline: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.access-control-description-timeline",
            "defaultMessage": "Anyone with access to this plan will be able to {action} this timeline. It will not be editable from the link (read-only)."
        },
        accessControlMacroDescription: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.access-control-macro-description",
            "defaultMessage": "The macro shares a view-only version of your plan. Viewers won\u2019t be able to make changes from your Confluence page."
        },
        accessControlView: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.access-control-view",
            "defaultMessage": "view"
        },
        confluenceTimelineMacroSharingMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.confluence-timeline-macro-sharing-message",
            "defaultMessage": "Share your timeline to a Confluence page."
        },
        confluenceDependencyMacroSharingMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.confluence-dependency-macro-sharing-message",
            "defaultMessage": "Share your dependencies view to a Confluence page."
        },
        confluenceMacroSharingInstructions: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.confluence-macro-sharing-instructions",
            "defaultMessage": "Copy the link below, and paste it into your Confluence page. {link}."
        },
        confluenceMacroIph: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.confluence-macro-iph",
            "defaultMessage": "Read more about sharing a plan to Confluence"
        },
        exportCsvIntro: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-intro",
            "defaultMessage": "Create a spreadsheet from your plan that can be opened with programs like Excel."
        },
        plansExportCsvIntro2: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.plans-export-csv-intro-2",
            "defaultMessage": "When you export your plan to .csv, Plans will only export issues that are currently visible in your plan. Use filters, view settings, and sorting options to include or exclude issues from your .csv file."
        },
        exportCsvButton: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-button",
            "defaultMessage": "Export to .csv"
        },
        noIssuesToExportTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.no-issues-to-export-tooltip",
            "defaultMessage": "There are no issues to export"
        },
        exportCsvColumnHeadingHierarchy: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-hierarchy",
            "defaultMessage": "Hierarchy"
        },
        exportCsvColumnHeadingTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-title",
            "defaultMessage": "Title"
        },
        exportCsvColumnHeadingProject: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-project",
            "defaultMessage": "Project"
        },
        exportCsvColumnHeadingReleases: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-releases",
            "defaultMessage": "Releases"
        },
        exportCsvColumnHeadingTeam: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-team",
            "defaultMessage": "Team"
        },
        exportCsvColumnHeadingSprint: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-sprint",
            "defaultMessage": "Sprint"
        },
        exportCsvColumnHeadingTargetStartDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-target-start-date",
            "defaultMessage": "Target start date"
        },
        exportCsvColumnHeadingTargetEndDate: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-target-end-date",
            "defaultMessage": "Target end date"
        },
        exportCsvColumnHeadingEstimateDays: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-estimate-days",
            "defaultMessage": "Estimates (d)"
        },
        exportCsvColumnHeadingEstimateHours: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-estimate-hours",
            "defaultMessage": "Estimates (h)"
        },
        exportCsvColumnHeadingStoryPoints: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-story-points",
            "defaultMessage": "Story points"
        },
        exportCsvColumnHeadingParent: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-parent",
            "defaultMessage": "Parent"
        },
        exportCsvColumnHeadingPriority: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-priority",
            "defaultMessage": "Priority"
        },
        exportCsvColumnHeadingLabels: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-labels",
            "defaultMessage": "Labels"
        },
        exportCsvColumnHeadingComponents: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-components",
            "defaultMessage": "Components"
        },
        exportCsvColumnHeadingGoalName: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-goal-name",
            "defaultMessage": "Goal"
        },
        exportCsvColumnHeadingGoalStatus: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-goal-status",
            "defaultMessage": "Goal status"
        },
        exportCsvColumnHeadingIdea: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-idea",
            "defaultMessage": "Idea"
        },
        exportCsvColumnHeadingIssueKey: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-issue-key",
            "defaultMessage": "Issue key"
        },
        exportCsvColumnHeadingIssueStatus: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-issue-status",
            "defaultMessage": "Issue status"
        },
        exportCsvColumnHeadingProgressPercentage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-percentage",
            "defaultMessage": "Progress (%)"
        },
        exportCsvColumnHeadingProgressCompletedDays: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-completed-days",
            "defaultMessage": "Progress completed (d)"
        },
        exportCsvColumnHeadingProgressCompletedHours: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-completed-hours",
            "defaultMessage": "Progress completed (h)"
        },
        exportCsvColumnHeadingProgressCompletedStoryPoints: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-completed-story-points",
            "defaultMessage": "Progress completed (sp)"
        },
        exportCsvColumnHeadingProgressRemainingDays: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-remaining-days",
            "defaultMessage": "Progress remaining (d)"
        },
        exportCsvColumnHeadingProgressRemainingHours: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-remaining-hours",
            "defaultMessage": "Progress remaining (h)"
        },
        exportCsvColumnHeadingProgressRemainingStoryPoints: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-remaining-story-points",
            "defaultMessage": "Progress remaining (sp)"
        },
        exportCsvColumnHeadingProgressIssueCountPercentage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-issue-count-percentage",
            "defaultMessage": "Progress (%) issue count (IC)"
        },
        exportCsvColumnHeadingToDoIssueCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-to-do-issue-count",
            "defaultMessage": "To do IC"
        },
        exportCsvColumnHeadingInProgressIssueCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-in-progress-issue-count",
            "defaultMessage": "In progress IC"
        },
        exportCsvColumnHeadingDoneIssueCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-done-issue-count",
            "defaultMessage": "Done IC"
        },
        exportCsvColumnHeadingTotalIssueCount: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-total-issue-count",
            "defaultMessage": "Total IC"
        },
        exportCsvColumnHeadingRollUp: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-roll-up",
            "defaultMessage": "(roll-up)"
        },
        exportCsvExternalLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-external-label",
            "defaultMessage": "[EXT]"
        },
        exportCsvCompletedLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-completed-label",
            "defaultMessage": "[COMPLETED]"
        },
        reportModeMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.report-mode-message",
            "defaultMessage": "When viewing a plan from a shared link, you can only export data to a .csv file."
        },
        exportCsvFilename: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-filename",
            "defaultMessage": "Plans {planTitle}"
        },
        confluenceUrlLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.confluence-url-label",
            "defaultMessage": "Confluence URL"
        }
    });
    var $2ab0328ed7eff1bf$export$2e2bcd8739ae039 = $2ab0328ed7eff1bf$var$messages;
});
parcelRegister("8w9wf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66a094ffa30a2f3b$export$2e2bcd8739ae039);
    var $b0D0x = parcelRequire("b0D0x");
    var $bC2fB;
    var $jWhoD = parcelRequire("jWhoD");
    var $d2AmW = parcelRequire("d2AmW");
    var $66a094ffa30a2f3b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $jWhoD.default), {
        planExportedAnalytics: $b0D0x.planExportedAnalytics
    })((0, $d2AmW.default));
});
parcelRegister("jWhoD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a98885b80c870571$export$2e2bcd8739ae039);
    var $bHTqr = parcelRequire("bHTqr");
    var $gFhwb = parcelRequire("gFhwb");
    var $1l6AC = parcelRequire("1l6AC");
    var $6iNxz = parcelRequire("6iNxz");
    var $kWDpn = parcelRequire("kWDpn");
    var $3YtPS = parcelRequire("3YtPS");
    var $ktlIh = parcelRequire("ktlIh");
    const $a98885b80c870571$export$c7f8b8401976f675 = (0, $3YtPS.createSelector)([
        (0, $kWDpn.getTimeScaleViewSettings)
    ], (0, $ktlIh.getInitialExportDateRange));
    const $a98885b80c870571$export$34fe7608eea15efe = (0, $3YtPS.createSelector)([
        (0, $6iNxz.getTableItems)
    ], (tableItems)=>tableItems.filter((ti)=>ti.tag === (0, $6iNxz.TABLE_ISSUE)).length);
    const $a98885b80c870571$var$mapStateToProps = (state)=>({
            fieldsWidth: (0, $1l6AC.getFieldsWidth)(state),
            scopeWidth: (0, $1l6AC.getScopeWidth)(state),
            timelineExportWidth: (0, $1l6AC.getTimelineExportWidth)(state),
            initialTimelineDateRange: $a98885b80c870571$export$c7f8b8401976f675(state),
            numIssuesInPlan: (0, $gFhwb.getAllIssues)(state).length,
            numIssues: $a98885b80c870571$export$34fe7608eea15efe(state),
            planTitle: (0, $bHTqr.getPlan)(state).title,
            viewMode: (0, $kWDpn.getViewMode)(state)
        });
    var $a98885b80c870571$export$2e2bcd8739ae039 = $a98885b80c870571$var$mapStateToProps;
});
parcelRegister("ktlIh", function(module, exports) {
    $parcel$export(module.exports, "EXPORT_PNG_TIMELINE_WIDTH_OPTIONS", ()=>$1bebf18806c83987$export$463117a55a1baf95);
    $parcel$export(module.exports, "getInitialExportDateRange", ()=>$1bebf18806c83987$export$4fa0ed0bf0ea5915);
    var $gh61P;
    var $flnZx;
    var $jAIJh = parcelRequire("jAIJh");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    const $1bebf18806c83987$export$463117a55a1baf95 = {
        NONE: 'none',
        SMALL: 'small',
        MEDIUM: 'medium',
        LARGE: 'large',
        CUSTOM: 'custom'
    };
    const $1bebf18806c83987$export$b6d465111d914331 = (str)=>str.replace(/\/$/, '');
    const $1bebf18806c83987$export$4fa0ed0bf0ea5915 = (timescaleViewSettings = {
        mode: (0, $TTKUQ.TIMELINE_MODES).MONTHS
    }, todayDate = (0, $jAIJh.getTodayDate)())=>{
        const { mode: mode, customDateRange: customDateRange } = timescaleViewSettings;
        const toNowMultiplier = 1;
        const fromNowMultiplier = 3;
        let relativeDateRange = {
            typeOfCustomDateRange: (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).RELATIVE,
            fromNowUnitCount: fromNowMultiplier,
            toNowUnitCount: toNowMultiplier,
            fromNowUnit: (0, (0, parcelRequire("gh61P")).DateUnits).MONTHS,
            toNowUnit: (0, (0, parcelRequire("gh61P")).DateUnits).MONTHS
        };
        switch(mode){
            case (0, $TTKUQ.TIMELINE_MODES).CUSTOM:
                if ((0, $4nDwW.isDefined)(customDateRange)) {
                    if (customDateRange.typeOfCustomDateRange === (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).FIXED) return customDateRange;
                    relativeDateRange = customDateRange;
                }
                break;
            case (0, $TTKUQ.TIMELINE_MODES).WEEKS:
                relativeDateRange.fromNowUnit = (0, (0, parcelRequire("gh61P")).DateUnits).WEEKS;
                relativeDateRange.toNowUnit = (0, (0, parcelRequire("gh61P")).DateUnits).WEEKS;
                break;
            case (0, $TTKUQ.TIMELINE_MODES).QUARTERS:
                relativeDateRange.fromNowUnit = (0, (0, parcelRequire("gh61P")).DateUnits).MONTHS;
                relativeDateRange.toNowUnit = (0, (0, parcelRequire("gh61P")).DateUnits).MONTHS;
                relativeDateRange.fromNowUnitCount = 3 * fromNowMultiplier;
                relativeDateRange.toNowUnitCount = 3 * toNowMultiplier;
                break;
            case (0, $TTKUQ.TIMELINE_MODES).YEARS:
                relativeDateRange.fromNowUnit = (0, (0, parcelRequire("gh61P")).DateUnits).MONTHS;
                relativeDateRange.toNowUnit = (0, (0, parcelRequire("gh61P")).DateUnits).MONTHS;
                relativeDateRange.fromNowUnitCount = 12 * fromNowMultiplier;
                relativeDateRange.toNowUnitCount = 12 * toNowMultiplier;
                break;
            case (0, $TTKUQ.TIMELINE_MODES).MONTHS:
            default:
                break;
        }
        const { start: start, end: end } = (0, (0, parcelRequire("flnZx")).getRelativeDates)(relativeDateRange, todayDate);
        return {
            typeOfCustomDateRange: (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).FIXED,
            fromDate: start,
            toDate: end
        };
    };
});
parcelRegister("d2AmW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3cd338cf2023bfea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $lFKmC = parcelRequire("lFKmC");
    var $jpUKq = parcelRequire("jpUKq");
    var $ldJSL;
    var $2hXfb;
    var $92Z2l;
    var $3bDjY;
    var $ousew;
    var $koVbs;
    var $4ENQh;
    var $aCpcO;
    var $3J2mc;
    var $enoTt;
    var $i2qlb = parcelRequire("i2qlb");
    var $b0D0x = parcelRequire("b0D0x");
    var $e5V2f = parcelRequire("e5V2f");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $4cwkM = parcelRequire("4cwkM");
    var $ihPUd = parcelRequire("ihPUd");
    var $5oFIy;
    var $8zOmE;
    var $2NMNM;
    var $iXVV6;
    var $3kWYO = parcelRequire("3kWYO");
    var $d3ou3 = parcelRequire("d3ou3");
    var $7iVXo = parcelRequire("7iVXo");
    var $ktlIh = parcelRequire("ktlIh");
    const $3cd338cf2023bfea$var$MAX_VISIBLE_ISSUES = 500;
    const $3cd338cf2023bfea$var$DAY_MS = 86400000;
    const $3cd338cf2023bfea$var$WARNING_ISSUE_COUNT_LIMIT = 150;
    const $3cd338cf2023bfea$var$presetWidths = {
        none: '0',
        small: '400',
        medium: '700',
        large: '900',
        custom: ''
    };
    const $3cd338cf2023bfea$var$buildIframeUrls = (href, scopeWidth, fieldsWidth, fromDate, toDate)=>{
        const url = new URL(href);
        url.searchParams.set('scopeWidth', scopeWidth.toString());
        url.searchParams.set('fieldsWidth', fieldsWidth.toString());
        url.searchParams.set('startInPreviewMode', '1');
        if ((0, $4nDwW.isDefined)(fromDate)) url.searchParams.set('fromDate', fromDate.toString());
        if ((0, $4nDwW.isDefined)(toDate)) url.searchParams.set('toDate', toDate.toString());
        const { pathname: pathname, hash: hash } = url;
        const iframeURL = `${pathname.replace(/\/timeline\/?/, '')}/export/${url.search}${hash}`;
        url.searchParams.set('startInPreviewMode', '0');
        const downloadModeIframeURL = `${pathname.replace(/\/timeline\/?/, '')}/export/${url.search}${hash}`;
        return {
            iframeURL: iframeURL,
            downloadModeIframeURL: downloadModeIframeURL
        };
    };
    function $3cd338cf2023bfea$var$PngExport({ fieldsWidth: fieldsWidth, scopeWidth: scopeWidth, initialTimelineDateRange: initialTimelineDateRange, numIssuesInPlan: numIssuesInPlan, numIssues: numIssues, onClose: onClose, planMode: planMode, planTitle: planTitle, SpinnerComponent: SpinnerComponent = (0, (0, parcelRequire("enoTt")).default), renderPreviewIframe: renderPreviewIframe = true, testIframeUrl: testIframeUrl = null, planExportedAnalytics: planExportedAnalytics, viewMode: viewMode }) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const didFinishInitialPreview = (0, $5uXOq.useRef)(false);
        const didDownload = (0, $5uXOq.useRef)(false);
        const isUnmounting = (0, $5uXOq.useRef)(false);
        const [isDownloading, setIsDownloading] = (0, $5uXOq.useState)(false);
        const [isDownloadModeReady, setIsDownloadModeReady] = (0, $5uXOq.useState)(false);
        const defaultSelection = viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE ? (0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).LARGE : (0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).NONE;
        const [selection, setSelection] = (0, $5uXOq.useState)(defaultSelection);
        const [customValue, setCustomValue] = (0, $5uXOq.useState)($3cd338cf2023bfea$var$presetWidths.large);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [imgData, setImgData] = (0, $5uXOq.useState)(null);
        const [timelineDateRange, setTimelineDateRange] = (0, $5uXOq.useState)(initialTimelineDateRange);
        const iframeRef = (0, $5uXOq.useRef)(null);
        const downloadModeIframeRef = (0, $5uXOq.useRef)(null);
        const isInvalidCustomValue = selection === (0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM && customValue.trim() !== '' && (Number(customValue) > 5000 || Number(customValue) < 400);
        const timelineDays = (0, $4nDwW.isDefined)(timelineDateRange.toDate) && (0, $4nDwW.isDefined)(timelineDateRange.fromDate) ? Math.round((timelineDateRange.toDate - timelineDateRange.fromDate) / $3cd338cf2023bfea$var$DAY_MS) : 0;
        const handleSetSelection = (type, analyticsEvent)=>{
            const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).EXPORT_PNG_CHANGE_TIMELINE_WIDTH.split(' ');
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), actionSubjectId, {
                timelineWidth: type
            });
            setCustomValue($3cd338cf2023bfea$var$presetWidths[type]);
            setSelection(type);
        };
        function changeWidth(newWidth) {
            if (iframeRef.current !== null && iframeRef.current.contentWindow) {
                if (didFinishInitialPreview.current) (0, (0, parcelRequire("4ENQh")).monitor).startTask((0, $TTKUQ.PERFORMANCE_KEYS).EXPORT_PNG.SUBSEQUENT_PREVIEW, {
                    scalingFactors: {
                        issuesInPlan: numIssuesInPlan,
                        issuesInExport: numIssues
                    }
                });
            }
            const changeWidthOnIframe = (iframe)=>{
                if (iframe.current !== null && iframe.current.contentWindow) {
                    setImgData(null);
                    setIsDownloadModeReady(false);
                    iframe.current && iframe.current.contentWindow.postMessage({
                        type: 'updateTimelineWidth',
                        payload: {
                            fieldsWidth: fieldsWidth,
                            scopeWidth: scopeWidth,
                            timelineExport: newWidth
                        }
                    });
                }
            };
            changeWidthOnIframe(iframeRef);
            changeWidthOnIframe(downloadModeIframeRef);
        }
        const debouncedChangeWidth = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($lFKmC)))(changeWidth, 1000));
        const handleChangeTimelineDateRange = (newCustomDates)=>{
            const range = {
                ...timelineDateRange,
                ...newCustomDates
            };
            setTimelineDateRange(range);
            if (iframeRef.current !== null && iframeRef.current.contentWindow) (0, (0, parcelRequire("4ENQh")).monitor).startTask((0, $TTKUQ.PERFORMANCE_KEYS).EXPORT_PNG.SUBSEQUENT_PREVIEW, {
                scalingFactors: {
                    issuesInPlan: numIssuesInPlan,
                    issuesInExport: numIssues
                }
            });
            const changeDateRangeOnIframe = (iframe)=>{
                if (iframe.current !== null && iframe.current.contentWindow) {
                    setImgData(null);
                    setIsDownloadModeReady(false);
                    iframe.current?.contentWindow.postMessage({
                        type: 'updateTimelineDateRange',
                        payload: {
                            timelineDateRange: range
                        }
                    });
                }
            };
            changeDateRangeOnIframe(iframeRef);
            changeDateRangeOnIframe(downloadModeIframeRef);
        };
        function downloadImageFromIframe() {
            if (downloadModeIframeRef.current && downloadModeIframeRef.current.contentWindow) downloadModeIframeRef.current.contentWindow.postMessage({
                type: 'downloadImage'
            });
        }
        const handleDownload = (_, analyticsEvent)=>{
            (0, (0, parcelRequire("4ENQh")).monitor).startTask((0, $TTKUQ.PERFORMANCE_KEYS).EXPORT_PNG.EXPORT, {
                scalingFactors: {
                    issuesInPlan: numIssuesInPlan,
                    issuesInExport: numIssues
                }
            });
            setIsDownloading(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'exportPngDownload', {
                issuesInPlan: numIssuesInPlan,
                issuesInExport: numIssues,
                timelineWidth: selection,
                timelineDays: timelineDays,
                planMode: planMode
            });
            downloadImageFromIframe();
        };
        const doDownload = (0, $5uXOq.useCallback)(async (imgData)=>{
            if (imgData !== null) {
                const res = await fetch(imgData);
                const blob = await res.blob();
                (0, $jpUKq.saveAs)(blob, (0, $e5V2f.getExportPngFileName)(intl.formatMessage((0, $3kWYO.default).pngExportName, {
                    planTitle: planTitle
                }), new Date()));
                didDownload.current = true;
                planExportedAnalytics({
                    exportFormat: (0, $b0D0x.EXPORT_EVENT_TYPE).PNG,
                    issuesInPlan: numIssuesInPlan,
                    issuesInExport: numIssues,
                    timelineWidth: selection,
                    timelineDays: timelineDays
                });
            }
            setIsDownloading(false);
        }, [
            intl,
            planTitle,
            planExportedAnalytics,
            numIssuesInPlan,
            numIssues,
            selection,
            timelineDays
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isInvalidCustomValue) return;
            debouncedChangeWidth.current(Number(customValue));
        }, [
            customValue,
            isInvalidCustomValue
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const listener = (event)=>{
                switch(event.data.type){
                    case 'profile':
                        {
                            const { profileAction: profileAction, profileKey: profileKey } = event.data.payload;
                            if (!profileAction || !profileKey) throw new Error('profileAction or profileKey missing in profile event');
                            const profileFunc = profileAction === 'start' ? (0, (0, parcelRequire("4ENQh")).monitor).startProfile.bind((0, (0, parcelRequire("4ENQh")).monitor)) : (0, (0, parcelRequire("4ENQh")).monitor).finishProfile.bind((0, (0, parcelRequire("4ENQh")).monitor));
                            profileFunc(profileKey);
                            break;
                        }
                    case 'downloadModeReady':
                        setIsDownloadModeReady(true);
                        break;
                    case 'exportedImage':
                        setImgData(event.data.payload.image);
                        (0, (0, parcelRequire("4ENQh")).monitor).finishTask((0, $TTKUQ.PERFORMANCE_KEYS).EXPORT_PNG.SUBSEQUENT_PREVIEW);
                        break;
                    case 'initialExportedImage':
                        setImgData(event.data.payload.image);
                        (0, (0, parcelRequire("4ENQh")).monitor).finishTask((0, $TTKUQ.PERFORMANCE_KEYS).EXPORT_PNG.INITIAL_PREVIEW);
                        didFinishInitialPreview.current = true;
                        break;
                    case 'fullExportedImage':
                        doDownload(event.data.payload.image);
                        (0, (0, parcelRequire("4ENQh")).monitor).finishTask((0, $TTKUQ.PERFORMANCE_KEYS).EXPORT_PNG.EXPORT);
                        break;
                    default:
                        break;
                }
            };
            window.addEventListener('message', listener);
            return ()=>window.removeEventListener('message', listener);
        }, [
            doDownload
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("4ENQh")).monitor).startTask((0, $TTKUQ.PERFORMANCE_KEYS).EXPORT_PNG.INITIAL_PREVIEW, {
                scalingFactors: {
                    issuesInPlan: numIssuesInPlan,
                    issuesInExport: numIssues
                }
            });
            (0, (0, parcelRequire("4ENQh")).monitor).startProfile((0, $TTKUQ.PROFILE_KEYS).EXPORT_PNG.INITIAL_LOAD);
        }, [
            numIssues,
            numIssuesInPlan
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                isUnmounting.current = true;
            }, []);
        (0, $5uXOq.useEffect)(()=>()=>{
                if (isUnmounting.current) {
                    const [actionSubject, action, actionSubjectId] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).EXPORT_PNG_MODAL_CLOSED.split(' ');
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                        action: action,
                        actionSubject: actionSubject
                    }), actionSubjectId, {
                        issuesInPlan: numIssuesInPlan,
                        issuesInExport: numIssues,
                        isDownloading: isDownloading,
                        isGeneratingPreview: imgData === null && !isDownloadModeReady && !isDownloading && numIssues <= $3cd338cf2023bfea$var$MAX_VISIBLE_ISSUES,
                        isShowingTooManyIssuesWarning: numIssues > $3cd338cf2023bfea$var$MAX_VISIBLE_ISSUES,
                        didDownload: didDownload.current,
                        viewMode: viewMode
                    });
                }
            }, [
            createAnalyticsEvent,
            imgData,
            isDownloading,
            isDownloadModeReady,
            numIssues,
            numIssuesInPlan,
            viewMode
        ]);
        let iframeURL = '';
        let downloadModeIframeURL = '';
        const URLs = $3cd338cf2023bfea$var$buildIframeUrls(window.location.href, scopeWidth, fieldsWidth, initialTimelineDateRange.fromDate, initialTimelineDateRange.toDate);
        iframeURL = (0, $4nDwW.isDefined)(testIframeUrl) ? `${testIframeUrl}&startInPreviewMode=1` : URLs.iframeURL;
        downloadModeIframeURL = (0, $4nDwW.isDefined)(testIframeUrl) ? `${testIframeUrl}&startInPreviewMode=0` : URLs.downloadModeIframeURL;
        let invalidMsg = null;
        if (numIssues > $3cd338cf2023bfea$var$MAX_VISIBLE_ISSUES) invalidMsg = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "warning"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                viewDisplayed: 'tooManyIssuesWarning',
                issuesInPlan: numIssuesInPlan,
                issuesInExport: numIssues
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $3kWYO.default).tooManyIssues,
            values: {
                visibleIssues: numIssues
            }
        }), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $3kWYO.default).plansMaxIssues,
            values: {
                maxIssues: $3cd338cf2023bfea$var$MAX_VISIBLE_ISSUES
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $3kWYO.default).maxIssuesSuggestion,
            values: {
                maxIssues: $3cd338cf2023bfea$var$MAX_VISIBLE_ISSUES
            }
        })));
        else if (numIssues <= 0) invalidMsg = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "warning"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                viewDisplayed: 'noIssuesWarning',
                issuesInPlan: numIssuesInPlan,
                issuesInExport: numIssues
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $3kWYO.default).noIssues));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "exportPng",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d3ou3.container
        }, invalidMsg || (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                viewDisplayed: 'exportControls',
                issuesInPlan: numIssuesInPlan,
                issuesInExport: numIssues
            }
        }), viewMode === (0, (0, parcelRequire("3J2mc")).VIEW_MODES).TIMELINE && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $7iVXo.default), {
            isDisabled: isDownloading,
            selection: selection,
            setSelection: handleSetSelection,
            customWidth: customValue,
            setCustomWidth: setCustomValue,
            customDateRange: timelineDateRange,
            setCustomDateRange: handleChangeTimelineDateRange
        }), isInvalidCustomValue && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-test-id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.invalid-timeline-message",
            className: $d3ou3.errorMessage
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, intl.formatMessage((0, $3kWYO.default).customValueErrorMessage))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d3ou3.previewContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d3ou3.previewBadge
        }, imgData === null || !isDownloadModeReady || isDownloading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d3ou3.spinnerContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(SpinnerComponent, {
            size: "small",
            invertColor: true
        })), intl.formatMessage(isDownloading ? (0, $3kWYO.default).exportingMessage : (0, $3kWYO.default).loadingMessage, {
            visibleIssues: numIssues
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, numIssues > (0, $TTKUQ.NUM_ISSUES_IN_EXPORT_PREVIEW) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, $3kWYO.default).previewLozenge,
            values: {
                visibleIssues: numIssues,
                previewIssues: (0, $TTKUQ.NUM_ISSUES_IN_EXPORT_PREVIEW)
            }
        }) : intl.formatMessage((0, $3kWYO.default).previewLozengeBasic))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d3ou3.previewPane
        }, imgData !== null && isDownloadModeReady && (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            "data-test-id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.preview-image",
            src: imgData,
            className: $d3ou3.previewImage,
            alt: intl.formatMessage((0, $3kWYO.default).pngExportImageAlt, {
                planTitle: planTitle
            })
        }))))), numIssues > $3cd338cf2023bfea$var$WARNING_ISSUE_COUNT_LIMIT && numIssues <= $3cd338cf2023bfea$var$MAX_VISIBLE_ISSUES && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: intl.formatMessage((0, $3kWYO.default).filterIssuesMessage)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d3ou3.warningMessage
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2hXfb"))))), {
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, intl.formatMessage((0, $3kWYO.default).warningMessage), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, $4cwkM.default), {
            href: (0, $4cwkM.default).URLs.exportPng
        }, intl.formatMessage((0, $ihPUd.default).learnMore))))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $d3ou3.footer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            appearance: "primary",
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.download",
            isDisabled: isInvalidCustomValue || imgData === null || !isDownloadModeReady || isDownloading,
            onClick: handleDownload
        }, intl.formatMessage(isDownloading ? (0, $3kWYO.default).downloading : (0, $3kWYO.default).downloadButtonLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.cancel-button",
            appearance: "subtle",
            onClick: onClose
        }, intl.formatMessage((0, $ihPUd.default).cancel))))), renderPreviewIframe && numIssues <= $3cd338cf2023bfea$var$MAX_VISIBLE_ISSUES && numIssues > 0 && (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement("iframe", {
            ref: iframeRef,
            title: intl.formatMessage((0, $3kWYO.default).previewModeTitle),
            className: $d3ou3.collapsedIframe,
            src: iframeURL
        }), document.body || document.createElement('div')), renderPreviewIframe && numIssues <= $3cd338cf2023bfea$var$MAX_VISIBLE_ISSUES && numIssues > 0 && (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement("iframe", {
            ref: downloadModeIframeRef,
            title: intl.formatMessage((0, $3kWYO.default).downloadModeTitle),
            className: $d3ou3.collapsedIframe,
            src: downloadModeIframeURL
        }), document.body || document.createElement('div')));
    }
    var $3cd338cf2023bfea$export$2e2bcd8739ae039 = $3cd338cf2023bfea$var$PngExport;
});
parcelRegister("3kWYO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bad4271c73a4b86$export$2e2bcd8739ae039);
    var $7VHMR;
    const $1bad4271c73a4b86$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        previewModeTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.preview-mode-title",
            "defaultMessage": "Export png preview mode"
        },
        downloadModeTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.download-mode-title",
            "defaultMessage": "Export png download mode"
        },
        tooManyIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.too-many-issues",
            "defaultMessage": "Your plan view is currently showing {visibleIssues, plural, one {# issue} other {# issues}}."
        },
        noIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.no-issues",
            "defaultMessage": "Your plan view is not showing any issues."
        },
        plansMaxIssues: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.plans-max-issues",
            "defaultMessage": "Plans can only export {maxIssues, plural, one {# issue} other {# issues}} to a PNG at one time. Please use filters to hide issues from your plan view."
        },
        maxIssuesSuggestion: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.max-issues-suggestion",
            "defaultMessage": "If you want a snapshot of your data that contains more than {maxIssues, plural, one {# issue} other {# issues}}, we recommend exporting your issues as a .csv file."
        },
        previewLozenge: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.preview-lozenge",
            "defaultMessage": "Previewing {previewIssues} of {visibleIssues, plural, one {# issue} other {# issues}}"
        },
        previewLozengeBasic: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.preview-lozenge-basic",
            "defaultMessage": "Preview"
        },
        downloading: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.downloading",
            "defaultMessage": "Downloading..."
        },
        downloadButtonLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.download-button-label",
            "defaultMessage": "Download"
        },
        customValueErrorMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.custom-value-error-message",
            "defaultMessage": "Timeline width must be between 400 and 5000 pixels"
        },
        loadingMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.loading-message",
            "defaultMessage": "Generating preview..."
        },
        exportingMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.exporting-message",
            "defaultMessage": "Exporting {visibleIssues, plural, one {# issue} other {# issues}}..."
        },
        warningMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.warning-message",
            "defaultMessage": "Your export could take a few minutes."
        },
        filterIssuesMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.filter-issues-message",
            "defaultMessage": "Filter issues from your timeline and hide unnecessary columns to make it faster."
        },
        pngExportName: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.png-export-name",
            "defaultMessage": "Plans {planTitle}"
        },
        pngExportImageAlt: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.png-export-image-alt",
            "defaultMessage": "{planTitle} preview"
        }
    });
    var $1bad4271c73a4b86$export$2e2bcd8739ae039 = $1bad4271c73a4b86$var$messages;
});
parcelRegister("d3ou3", function(module, exports) {
    $parcel$export(module.exports, "collapsedIframe", ()=>$980e8c22940799ea$export$56a50ac285b8f9fc, (v)=>$980e8c22940799ea$export$56a50ac285b8f9fc = v);
    $parcel$export(module.exports, "container", ()=>$980e8c22940799ea$export$34e0f9847d4c02dd, (v)=>$980e8c22940799ea$export$34e0f9847d4c02dd = v);
    $parcel$export(module.exports, "errorMessage", ()=>$980e8c22940799ea$export$493b5823483d2c4e, (v)=>$980e8c22940799ea$export$493b5823483d2c4e = v);
    $parcel$export(module.exports, "footer", ()=>$980e8c22940799ea$export$adb608be33961c98, (v)=>$980e8c22940799ea$export$adb608be33961c98 = v);
    $parcel$export(module.exports, "previewBadge", ()=>$980e8c22940799ea$export$95cbb0d5b186c892, (v)=>$980e8c22940799ea$export$95cbb0d5b186c892 = v);
    $parcel$export(module.exports, "previewContainer", ()=>$980e8c22940799ea$export$8aade8ce2b5d7e87, (v)=>$980e8c22940799ea$export$8aade8ce2b5d7e87 = v);
    $parcel$export(module.exports, "previewImage", ()=>$980e8c22940799ea$export$b5db251096956c0d, (v)=>$980e8c22940799ea$export$b5db251096956c0d = v);
    $parcel$export(module.exports, "previewPane", ()=>$980e8c22940799ea$export$c3bb42c40ca018ec, (v)=>$980e8c22940799ea$export$c3bb42c40ca018ec = v);
    $parcel$export(module.exports, "spinnerContainer", ()=>$980e8c22940799ea$export$140fd7bd1291a3e4, (v)=>$980e8c22940799ea$export$140fd7bd1291a3e4 = v);
    $parcel$export(module.exports, "warningMessage", ()=>$980e8c22940799ea$export$8abc02a5a17d88e4, (v)=>$980e8c22940799ea$export$8abc02a5a17d88e4 = v);
    var $980e8c22940799ea$export$56a50ac285b8f9fc;
    var $980e8c22940799ea$export$34e0f9847d4c02dd;
    var $980e8c22940799ea$export$493b5823483d2c4e;
    var $980e8c22940799ea$export$adb608be33961c98;
    var $980e8c22940799ea$export$95cbb0d5b186c892;
    var $980e8c22940799ea$export$8aade8ce2b5d7e87;
    var $980e8c22940799ea$export$b5db251096956c0d;
    var $980e8c22940799ea$export$c3bb42c40ca018ec;
    var $980e8c22940799ea$export$140fd7bd1291a3e4;
    var $980e8c22940799ea$export$8abc02a5a17d88e4;
    $980e8c22940799ea$export$56a50ac285b8f9fc = `g8i1ia_collapsedIframe`;
    $980e8c22940799ea$export$34e0f9847d4c02dd = `g8i1ia_container`;
    $980e8c22940799ea$export$493b5823483d2c4e = `g8i1ia_errorMessage`;
    $980e8c22940799ea$export$adb608be33961c98 = `g8i1ia_footer`;
    $980e8c22940799ea$export$95cbb0d5b186c892 = `g8i1ia_previewBadge`;
    $980e8c22940799ea$export$8aade8ce2b5d7e87 = `g8i1ia_previewContainer`;
    $980e8c22940799ea$export$b5db251096956c0d = `g8i1ia_previewImage`;
    $980e8c22940799ea$export$c3bb42c40ca018ec = `g8i1ia_previewPane`;
    $980e8c22940799ea$export$140fd7bd1291a3e4 = `g8i1ia_spinnerContainer`;
    $980e8c22940799ea$export$8abc02a5a17d88e4 = `g8i1ia_warningMessage`;
});
parcelRegister("7iVXo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be0923e740c94ace$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7O4UO;
    var $dC5iT;
    var $8CUq3;
    var $jouoW;
    var $koVbs;
    var $3cgJ4;
    var $hA24D = parcelRequire("hA24D");
    var $fyzJF = parcelRequire("fyzJF");
    var $ktlIh = parcelRequire("ktlIh");
    var $hGZWB = parcelRequire("hGZWB");
    var $dpIyg = parcelRequire("dpIyg");
    const $be0923e740c94ace$var$ExportTimelineSettings = ({ isDisabled: isDisabled, selection: selection, setSelection: setSelection, customWidth: customWidth, setCustomWidth: setCustomWidth, customDateRange: customDateRange, setCustomDateRange: setCustomDateRange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const announcerRef = (0, $5uXOq.useRef)(null);
        const createSelectionSetter = (type)=>(_, analyticsEvent)=>setSelection(type, analyticsEvent);
        const timelineSettingsContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            gap: 'space.100'
        });
        const timelineSettingsField = (0, (0, parcelRequire("8CUq3")).xcss)({
            marginTop: 'space.negative.075',
            gap: 'space.025'
        });
        const timelineWidthContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
            display: 'flex',
            alignItems: 'center',
            gap: 'space.100'
        });
        const customTextBoxContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
            alignItems: 'center',
            caretColor: 'color.icon.accent.gray.subtle',
            display: 'flex',
            marginLeft: 'space.100'
        });
        const customTextBoxContainerLabel = (0, (0, parcelRequire("8CUq3")).xcss)({
            marginLeft: 'space.050',
            color: 'color.text.subtle',
            fontSize: '16px'
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: timelineSettingsContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: timelineSettingsField
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("fieldset", {
            className: $dpIyg.timelineSettingsFieldset
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("legend", {
            className: $dpIyg.timelineSettingsLegend
        }, formatMessage((0, $hGZWB.default).widthLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: timelineWidthContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.small-timeline",
            isDisabled: isDisabled,
            isChecked: selection === (0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).SMALL,
            onChange: createSelectionSetter((0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).SMALL),
            label: formatMessage((0, $hGZWB.default).smallLabel)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.medium-timeline",
            isDisabled: isDisabled,
            isChecked: selection === (0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).MEDIUM,
            onChange: createSelectionSetter((0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).MEDIUM),
            label: formatMessage((0, $hGZWB.default).mediumLabel)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.large-timeline",
            isDisabled: isDisabled,
            isChecked: selection === (0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).LARGE,
            onChange: createSelectionSetter((0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).LARGE),
            label: formatMessage((0, $hGZWB.default).largeLabel)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-timeline",
            isDisabled: isDisabled,
            isChecked: selection === (0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM,
            onChange: createSelectionSetter((0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM),
            label: formatMessage((0, $hGZWB.default).customLabel)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: customTextBoxContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3cgJ4")).default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-timeline-width",
            isCompact: true,
            isDisabled: selection !== (0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM || isDisabled,
            type: "number",
            value: customWidth,
            min: 400,
            max: 5000,
            onChange: (e)=>{
                setCustomWidth(e.target.value);
                announcerRef.current?.announce();
            },
            width: "80",
            "aria-label": formatMessage((0, $hGZWB.default).customWidthPixelLabelText)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $hA24D.DelayedAnnouncer), {
            ref: announcerRef,
            label: customWidth
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: customTextBoxContainerLabel
        }, formatMessage((0, $hGZWB.default).customWidthPixelLabel)))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: timelineSettingsField
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            label: formatMessage((0, $hGZWB.default).timelineRangeLabel),
            name: "timelineRange",
            defaultValue: ""
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $fyzJF.default), {
                fieldProps: fieldProps,
                customDateRange: customDateRange,
                onCustomDatesChange: setCustomDateRange,
                isDisabled: selection === (0, $ktlIh.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).NONE || isDisabled
            })))));
    };
    var $be0923e740c94ace$export$2e2bcd8739ae039 = $be0923e740c94ace$var$ExportTimelineSettings;
});
parcelRegister("fyzJF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dbd0baeb920f4d9b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cTemL;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $aCpcO;
    var $gh61P;
    var $flnZx;
    var $J8W7q;
    var $cOhVC;
    var $80HYw;
    function $dbd0baeb920f4d9b$export$2e2bcd8739ae039({ customDateRange: customDateRange, isDisabled: isDisabled = false, onCustomDatesChange: onCustomDatesChange, fieldProps: fieldProps }) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [isCustomRangeDialogOpen, setIsCustomRangeDialogOpen] = (0, $5uXOq.useState)(false);
        const [dialogPosition, setDialogPosition] = (0, $5uXOq.useState)('bottom-end');
        const ref = (0, $5uXOq.useRef)(null);
        const onCustomDatesApplied = (range)=>{
            setIsCustomRangeDialogOpen(false);
            onCustomDatesChange(range);
        };
        const recalculateDialogPosition = ()=>{
            setDialogPosition('auto-end');
        };
        (0, $5uXOq.useEffect)(()=>{
            setDialogPosition('bottom-end');
        }, [
            dialogPosition
        ]);
        const customItemDialogContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOhVC")).CustomDateRangeModalContent), {
            dateRange: customDateRange,
            onConfirm: onCustomDatesApplied,
            onCancel: ()=>setIsCustomRangeDialogOpen(false),
            onSelectedTabChange: recalculateDialogPosition
        });
        const onItemClicked = ()=>{
            setIsCustomRangeDialogOpen((prevIsCustomRangeDialogOpen)=>!prevIsCustomRangeDialogOpen);
        };
        const getButtonText = ()=>{
            const { fromDate: fromDate, toDate: toDate, typeOfCustomDateRange: typeOfCustomDateRange } = customDateRange;
            if (typeOfCustomDateRange === (0, (0, parcelRequire("gh61P")).CUSTOM_TIME_RANGE_TYPES).RELATIVE) {
                const { start: start, end: end } = (0, (0, parcelRequire("flnZx")).getRelativeDates)(customDateRange, new Date());
                return (0, (0, parcelRequire("80HYw")).getStringFromDates)(start, end, intl);
            }
            return (0, (0, parcelRequire("80HYw")).getStringFromDates)(fromDate, toDate, intl);
        };
        const buttonWithIcon = (0, (0, parcelRequire("8CUq3")).xcss)({
            marginLeft: 'space.100'
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("J8W7q")).default), {
            content: customItemDialogContent,
            isOpen: isCustomRangeDialogOpen,
            maxWidth: 716,
            overflow: "visible",
            placement: dialogPosition
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCpcO")).default), {
            onClick: ()=>onItemClicked(),
            ...fieldProps,
            "aria-labelledby": `${fieldProps?.['aria-labelledby']} ${fieldProps?.id}-buttonText`,
            isDisabled: isDisabled,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.custom-timeline-range.button",
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: buttonWithIcon
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cTemL"))))), {
                label: ""
            }))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            id: `${fieldProps?.id}-buttonText`
        }, getButtonText()))));
    }
});
parcelRegister("hGZWB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0a797074f51fb61$export$2e2bcd8739ae039);
    var $7VHMR;
    const $b0a797074f51fb61$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        widthLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.width-label",
            "defaultMessage": "Timeline width"
        },
        smallLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.small-label",
            "defaultMessage": "Small"
        },
        mediumLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.medium-label",
            "defaultMessage": "Medium"
        },
        largeLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.large-label",
            "defaultMessage": "Large"
        },
        customLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-label",
            "defaultMessage": "Custom"
        },
        customWidthPixelLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-width-pixel-label",
            "defaultMessage": "px"
        },
        hideTimelineTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.hide-timeline-tooltip",
            "defaultMessage": "Hide timeline"
        },
        smallTimelineTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.small-timeline-tooltip",
            "defaultMessage": "Small timeline"
        },
        mediumTimelineTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.medium-timeline-tooltip",
            "defaultMessage": "Medium timeline"
        },
        largeTimelineTooltip: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.large-timeline-tooltip",
            "defaultMessage": "Large timeline"
        },
        customWidthPixelLabelText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-width-pixel-label-text",
            "defaultMessage": "Enter 400 to 5000 pixels"
        },
        timelineRangeLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.timeline-range-label",
            "defaultMessage": "Timeline range"
        }
    });
    var $b0a797074f51fb61$export$2e2bcd8739ae039 = $b0a797074f51fb61$var$messages;
});
parcelRegister("dpIyg", function(module, exports) {
    $parcel$export(module.exports, "timelineSettingsFieldset", ()=>$9c402b31d76408ee$export$801db1482b62a3ee, (v)=>$9c402b31d76408ee$export$801db1482b62a3ee = v);
    $parcel$export(module.exports, "timelineSettingsLegend", ()=>$9c402b31d76408ee$export$3c04ee4c4b5472b8, (v)=>$9c402b31d76408ee$export$3c04ee4c4b5472b8 = v);
    var $9c402b31d76408ee$export$801db1482b62a3ee;
    var $9c402b31d76408ee$export$3c04ee4c4b5472b8;
    $9c402b31d76408ee$export$801db1482b62a3ee = `FQwbrG_timelineSettingsFieldset`;
    $9c402b31d76408ee$export$3c04ee4c4b5472b8 = `FQwbrG_timelineSettingsLegend`;
});
parcelRegister("h8a27", function(module, exports) {
    $parcel$export(module.exports, "getCsvIntlMessages", ()=>$f84f9e909739e9f7$export$7652b5caf942c20);
    var $ihPUd = parcelRequire("ihPUd");
    var $cAVWg = parcelRequire("cAVWg");
    const $f84f9e909739e9f7$export$7652b5caf942c20 = (formatMessage, planTitle)=>{
        const columnHeadingRollUpLabel = formatMessage((0, $cAVWg.default).exportCsvColumnHeadingRollUp);
        return {
            exportName: formatMessage((0, $cAVWg.default).exportCsvFilename, {
                planTitle: planTitle
            }),
            columnHeadings: {
                type: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingHierarchy),
                summary: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingTitle),
                project: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingProject),
                releaseRollUp: `${formatMessage((0, $cAVWg.default).exportCsvColumnHeadingReleases)} ${columnHeadingRollUpLabel}`,
                release: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingReleases),
                teamRollUp: `${formatMessage((0, $cAVWg.default).exportCsvColumnHeadingTeam)} ${columnHeadingRollUpLabel}`,
                team: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingTeam),
                assignee: formatMessage((0, $ihPUd.default).assignee),
                reporter: formatMessage((0, $ihPUd.default).reporter),
                sprintRollUp: `${formatMessage((0, $cAVWg.default).exportCsvColumnHeadingSprint)} ${columnHeadingRollUpLabel}`,
                sprint: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingSprint),
                targetStartDateRollUp: `${formatMessage((0, $cAVWg.default).exportCsvColumnHeadingTargetStartDate)} ${columnHeadingRollUpLabel}`,
                targetStartDate: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingTargetStartDate),
                targetEndDateRollUp: `${formatMessage((0, $cAVWg.default).exportCsvColumnHeadingTargetEndDate)} ${columnHeadingRollUpLabel}`,
                targetEndDate: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingTargetEndDate),
                dueDateRollUp: `${formatMessage((0, $ihPUd.default).dueDate)} ${columnHeadingRollUpLabel}`,
                dueDate: formatMessage((0, $ihPUd.default).dueDate),
                estimateDaysRollUp: `${formatMessage((0, $cAVWg.default).exportCsvColumnHeadingEstimateDays)} ${columnHeadingRollUpLabel}`,
                estimateDays: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingEstimateDays),
                estimateHoursRollUp: `${formatMessage((0, $cAVWg.default).exportCsvColumnHeadingEstimateHours)} ${columnHeadingRollUpLabel}`,
                estimateHours: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingEstimateHours),
                estimateStoryPointsRollUp: `${formatMessage((0, $cAVWg.default).exportCsvColumnHeadingStoryPoints)} ${columnHeadingRollUpLabel}`,
                estimateStoryPoints: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingStoryPoints),
                [(0, $237d6663431e3fe9$export$c029c3f1c363635d)]: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingGoalName),
                [(0, $237d6663431e3fe9$export$f33fc1dddb5c20e9)]: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingGoalStatus),
                [(0, $f421f46bad35dbe5$export$990054d3891c9a93)]: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingIdea),
                parent: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingParent),
                priority: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingPriority),
                labels: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingLabels),
                components: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingComponents),
                key: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingIssueKey),
                status: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingIssueStatus),
                progressPercentage: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingProgressPercentage),
                progressCompletedDays: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingProgressCompletedDays),
                progressCompletedHours: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingProgressCompletedHours),
                progressCompletedStoryPoints: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingProgressCompletedStoryPoints),
                progressRemainingDays: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingProgressRemainingDays),
                progressRemainingHours: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingProgressRemainingHours),
                progressRemainingStoryPoints: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingProgressRemainingStoryPoints),
                progressIssueCount: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingProgressIssueCountPercentage),
                toDoIssueCount: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingToDoIssueCount),
                inProgressIssueCount: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingInProgressIssueCount),
                doneIssueCount: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingDoneIssueCount),
                totalIssueCount: formatMessage((0, $cAVWg.default).exportCsvColumnHeadingTotalIssueCount),
                rollUp: columnHeadingRollUpLabel
            },
            labels: {
                external: formatMessage((0, $cAVWg.default).exportCsvExternalLabel),
                completed: formatMessage((0, $cAVWg.default).exportCsvCompletedLabel)
            }
        };
    };
});
parcelRegister("c37Ug", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f430136446844358$export$2e2bcd8739ae039);
    var $7VHMR;
    const $f430136446844358$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareButtonText: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-button-text",
            "defaultMessage": "Share"
        },
        shareHeader: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-header",
            "defaultMessage": "Share plan as"
        },
        shareAsLink: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-link",
            "defaultMessage": "Link"
        },
        shareAsEmbed: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-embed",
            "defaultMessage": "Embed"
        },
        shareAsConfluence: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-confluence",
            "defaultMessage": "Confluence"
        },
        shareAsSpreadsheetCsv: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-spreadsheet-csv",
            "defaultMessage": "CSV"
        },
        shareAsPng: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-png",
            "defaultMessage": "Image (.png)"
        },
        sharePlanLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-plan-label",
            "defaultMessage": "Share plan"
        }
    });
    var $f430136446844358$export$2e2bcd8739ae039 = $f430136446844358$var$messages;
});
parcelRegister("cDVLS", function(module, exports) {
    $parcel$export(module.exports, "ReportAppBase", ()=>$17bcc27093beab72$export$cf6ecc6613a7b841);
    $parcel$export(module.exports, "PlanAppBase", ()=>$17bcc27093beab72$export$9ffe420d3b5fa4bd);
    $parcel$export(module.exports, "SettingsAppBase", ()=>$17bcc27093beab72$export$de97c218c12a59a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ikVyE = parcelRequire("ikVyE");
    var $jD5no;
    var $kb4zh;
    var $2i4sA;
    var $39xOx;
    var $4R6GH;
    var $3HwlS;
    var $7CnwK;
    var $nXNNJ;
    var $48B3j = parcelRequire("48B3j");
    var $cyd8j = parcelRequire("cyd8j");
    var $agFkl = parcelRequire("agFkl");
    var $d5vwV = parcelRequire("d5vwV");
    var $jqP0M = parcelRequire("jqP0M");
    var $65tNY = parcelRequire("65tNY");
    var $c3WQb;
    var $efvDm;
    var $9dbF6;
    var $38Y30;
    var $4dRjY;
    var $dZw8H;
    var $k9JTq;
    var $DVljb;
    var $2YP9W;
    var $doZTA;
    var $5W2CW;
    var $Sf4aO;
    var $5QXst;
    const $17bcc27093beab72$export$cf6ecc6613a7b841 = ({ withReduxStore: withReduxStore, paddingLeft: paddingLeft = true, paddingRight: paddingRight = true, children: children, store: store = (0, $48B3j.default) })=>{
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const editions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanReportPageInitialChecksResource));
        if (error?.statusCode === 401) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38Y30")).RedirectToLoginPage), null);
        if (loading || data === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        if (!data.success) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5W2CW")).ErrorScreen), {
            errorMessage: data.errorMessage,
            planId: data.planId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "spa-app.advanced-roadmaps-plan.report",
            packageName: "jiraSpaAppsAdvancedRoadmaps",
            teamName: "advanced-roadmaps"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2i4sA")).ViewExperienceTrackingProvider), {
            experience: "viewPortfolio3",
            analyticsSource: "portfolio3",
            application: (0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO),
            edition: editions.software,
            additionalAttributes: {
                synthetic: (0, (0, parcelRequire("nXNNJ")).isPollinatorTenant)()
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "software"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            store: withReduxStore ? store : undefined,
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Sf4aO")).AnalyticsInitializer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $agFkl.default), null, document.body && (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement((0, $d5vwV.default), null), document.body), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ikVyE.PersistGate), {
            loading: null,
            persistor: (0, $48B3j.persistor)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $65tNY.default), {
            locale: locale
        }), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement($17bcc27093beab72$var$Container, {
            paddingLeft: paddingLeft ? "var(--ds-space-300, 24px)" : undefined,
            paddingRight: paddingRight ? "var(--ds-space-300, 24px)" : undefined,
            className: "arj"
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement($17bcc27093beab72$var$ContainerOld, {
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            className: "arj"
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jqP0M.default), null))))));
    };
    const $17bcc27093beab72$export$9ffe420d3b5fa4bd = ({ appKey: appKey = 'spa-app.advanced-roadmaps-plan.default', withReduxStore: withReduxStore, paddingLeft: paddingLeft = true, paddingRight: paddingRight = true, children: children, store: store = (0, $48B3j.default), planView: planView })=>{
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const editions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("5QXst")).usePlanCheck)();
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        if (error?.statusCode === 401) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38Y30")).RedirectToLoginPage), null);
        if (loading || data === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        if (!data.success) {
            const planId = Number.isNaN(match.params.planId) ? undefined : Number(match.params.planId);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5W2CW")).ErrorScreen), {
                errorMessage: data.errorMessage,
                planId: planId
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: appKey,
            packageName: "jiraSpaAppsAdvancedRoadmaps",
            teamName: "advanced-roadmaps"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2i4sA")).ViewExperienceTrackingProvider), {
            experience: "viewPortfolio3",
            analyticsSource: "portfolio3",
            application: (0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO),
            edition: editions.software,
            additionalAttributes: {
                synthetic: (0, (0, parcelRequire("nXNNJ")).isPollinatorTenant)(),
                ...(0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? {
                    isEmbed: (0, (0, parcelRequire("7CnwK")).isPlanEmbed)()
                } : {}
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "software"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            store: withReduxStore ? store : undefined,
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Sf4aO")).AnalyticsInitializer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $agFkl.default), null, document.body && (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement((0, $d5vwV.default), null), document.body), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ikVyE.PersistGate), {
            loading: null,
            persistor: (0, $48B3j.persistor)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $65tNY.default), {
            locale: locale,
            planView: planView
        }), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement($17bcc27093beab72$var$Container, {
            paddingLeft: paddingLeft ? "var(--ds-space-300, 24px)" : undefined,
            paddingRight: paddingRight ? "var(--ds-space-300, 24px)" : undefined,
            className: "arj"
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement($17bcc27093beab72$var$ContainerOld, {
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            className: "arj"
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jqP0M.default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cyd8j.default), null))))));
    };
    const $17bcc27093beab72$export$de97c218c12a59a0 = ({ children: children, appKey: appKey = 'spa-app.advanced-roadmaps-plan.settings', paddingLeft: paddingLeft = true, paddingRight: paddingRight = true, store: store = (0, $48B3j.default) })=>{
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const editions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource));
        if (error?.statusCode === 401) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38Y30")).RedirectToLoginPage), null);
        if (loading || data === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        if (!data.success) {
            const planId = Number.isNaN(match.params.planId) ? undefined : Number(match.params.planId);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5W2CW")).ErrorScreen), {
                errorMessage: data.errorMessage,
                planId: planId
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: appKey,
            packageName: "jiraSpaAppsAdvancedRoadmaps",
            teamName: "advanced-roadmaps"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2i4sA")).ViewExperienceTrackingProvider), {
            experience: "viewPortfolio3PlanSettings",
            analyticsSource: "portfolio3",
            application: (0, (0, parcelRequire("efvDm")).JIRA_PORTFOLIO),
            edition: editions.software,
            additionalAttributes: {
                synthetic: (0, (0, parcelRequire("nXNNJ")).isPollinatorTenant)()
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "software"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            store: store,
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Sf4aO")).AnalyticsInitializer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $agFkl.default), null, document.body && (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement((0, $d5vwV.default), null), document.body), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ikVyE.PersistGate), {
            loading: null,
            persistor: (0, $48B3j.persistor)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $65tNY.default), {
            locale: locale
        }), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement($17bcc27093beab72$var$Container, {
            paddingLeft: paddingLeft ? "var(--ds-space-300, 24px)" : undefined,
            paddingRight: paddingRight ? "var(--ds-space-300, 24px)" : undefined,
            className: "arj"
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement($17bcc27093beab72$var$ContainerOld, {
            paddingLeft: true,
            paddingRight: true,
            className: "arj"
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jqP0M.default), null))))));
    };
    const $17bcc27093beab72$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { paddingLeft: paddingLeft, paddingRight: paddingRight, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_13zau0z": (0, (0, parcelRequire("lD23V")).default)(__cmplp.paddingLeft),
                "--_2zfw7a": (0, (0, parcelRequire("lD23V")).default)(__cmplp.paddingRight)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _19bvl75z _u5f310pk _4t3i1osq _18m91wug",
                __cmplp.className
            ])
        });
    });
    const $17bcc27093beab72$var$ContainerOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { paddingLeft: paddingLeft, paddingRight: paddingRight, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _4t3i1osq",
                __cmplp.paddingLeft && "_19bv1jfw",
                __cmplp.paddingRight && "_u5f31ejb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ikVyE", function(module, exports) {
    $parcel$export(module.exports, "PersistGate", ()=>$d596be0a204c6498$export$311ca220e7478cda);
    var $5uXOq = parcelRequire("5uXOq");
    var $d596be0a204c6498$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function $d596be0a204c6498$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $d596be0a204c6498$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $d596be0a204c6498$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $d596be0a204c6498$export$311ca220e7478cda = function(_PureComponent) {
        $d596be0a204c6498$var$_inherits(PersistGate, _PureComponent);
        function PersistGate() {
            var _ref;
            var _temp, _this, _ret;
            $d596be0a204c6498$var$_classCallCheck(this, PersistGate);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $d596be0a204c6498$var$_possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                bootstrapped: false
            }, _this.handlePersistorState = function() {
                var persistor = _this.props.persistor;
                var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
                if (bootstrapped) {
                    if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).then(function() {
                        return _this.setState({
                            bootstrapped: true
                        });
                    }).catch(function() {
                        return _this.setState({
                            bootstrapped: true
                        });
                    });
                    else _this.setState({
                        bootstrapped: true
                    });
                    _this._unsubscribe && _this._unsubscribe();
                }
            }, _temp), $d596be0a204c6498$var$_possibleConstructorReturn(_this, _ret);
        }
        $d596be0a204c6498$var$_createClass(PersistGate, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                    this.handlePersistorState();
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this._unsubscribe && this._unsubscribe();
                }
            },
            {
                key: 'render',
                value: function render() {
                    if (typeof this.props.children === 'function') return this.props.children(this.state.bootstrapped);
                    return this.state.bootstrapped ? this.props.children : this.props.loading;
                }
            }
        ]);
        return PersistGate;
    }((0, $5uXOq.PureComponent));
    $d596be0a204c6498$export$311ca220e7478cda.defaultProps = {
        loading: null
    };
});
parcelRegister("7CnwK", function(module, exports) {
    $parcel$export(module.exports, "isPlanEmbed", ()=>$cd3a4216f2726f2c$export$263395d7e2de6252);
    $parcel$export(module.exports, "useIsPlanEmbed", ()=>$cd3a4216f2726f2c$export$b9d3e01e19575c1f);
    var $lODMY;
    const $cd3a4216f2726f2c$export$72c92e5434325ff3 = (path)=>{
        const embedPathRegex = /^\/jira\/plans\/\d+\/scenarios\/\d+\/(timeline|summary|calendar|program\/\d+|dependencies)\/embed$/;
        return embedPathRegex.test(path);
    };
    const $cd3a4216f2726f2c$export$263395d7e2de6252 = ()=>window && $cd3a4216f2726f2c$export$72c92e5434325ff3(window.location.pathname);
    const $cd3a4216f2726f2c$export$b9d3e01e19575c1f = (0, (0, parcelRequire("lODMY")).createRouterSelector)(({ location: { pathname: pathname } })=>$cd3a4216f2726f2c$export$72c92e5434325ff3(pathname));
});
parcelRegister("48B3j", function(module, exports) {
    $parcel$export(module.exports, "persistor", ()=>$45f1c62245e1b4a7$export$7b682ac9934ca3e4);
    $parcel$export(module.exports, "default", ()=>$45f1c62245e1b4a7$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    parcelRequire("5j69e");
    var $5gmG2 = parcelRequire("5gmG2");
    var $dcevF = parcelRequire("dcevF");
    var $jcw0u;
    var $nXNNJ;
    var $y9aeT = parcelRequire("y9aeT");
    var $5AWLh = parcelRequire("5AWLh");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $dFesP = parcelRequire("dFesP");
    var $cIN1f = parcelRequire("cIN1f");
    var $a3uQu = parcelRequire("a3uQu");
    var $9L0go = parcelRequire("9L0go");
    var $hyUwT = parcelRequire("hyUwT");
    var $kfvhW = parcelRequire("kfvhW");
    var $c446i = parcelRequire("c446i");
    var $ekiVv = parcelRequire("ekiVv");
    var $eWre9 = parcelRequire("eWre9");
    const $45f1c62245e1b4a7$var$composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : (0, $3f2cs.compose);
    const $45f1c62245e1b4a7$var$middlewares = [];
    const $45f1c62245e1b4a7$var$sagaMiddleware = (0, $dcevF.default)({
        onError: (error)=>{
            const id = (0, $y9aeT.isEnvironmentError)(error) ? (0, $TTKUQ.ERROR_REPORTING_PACKAGE).ENVIRONMENT : (0, $TTKUQ.ERROR_REPORTING_PACKAGE).REDUX_SAGA;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: id,
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    synthetic: (0, (0, parcelRequire("nXNNJ")).isPollinatorTenant)()
                }
            });
            $45f1c62245e1b4a7$var$store.dispatch((0, $eWre9.showError)(error.message, error.stack, window?.location.hash, window?.location.pathname));
        }
    });
    $45f1c62245e1b4a7$var$middlewares.push((0, $5AWLh.errorReporterMiddleware));
    $45f1c62245e1b4a7$var$middlewares.push($45f1c62245e1b4a7$var$sagaMiddleware);
    $45f1c62245e1b4a7$var$middlewares.push((0, $c446i.default));
    const $45f1c62245e1b4a7$var$store = (0, $3f2cs.createStore)((0, $ekiVv.default), $45f1c62245e1b4a7$var$composeEnhancers((0, $3f2cs.applyMiddleware)(...$45f1c62245e1b4a7$var$middlewares), (0, $kfvhW.default)()));
    const $45f1c62245e1b4a7$export$7b682ac9934ca3e4 = (0, $5gmG2.default)($45f1c62245e1b4a7$var$store);
    var $45f1c62245e1b4a7$export$2e2bcd8739ae039 = $45f1c62245e1b4a7$var$store;
    $45f1c62245e1b4a7$var$sagaMiddleware.run((0, $dFesP.default));
    (0, $a3uQu.default)($45f1c62245e1b4a7$var$store);
    if ((0, $hyUwT.getInitialMode)() !== (0, $ab4be2e1e204af69$export$f79b1fae3e63e441)) (0, $cIN1f.default)($45f1c62245e1b4a7$var$store);
    (0, $9L0go.default)($45f1c62245e1b4a7$var$store);
});
parcelRegister("dFesP", function(module, exports) {
    $parcel$export(module.exports, "initialLoad", ()=>$80a366357bb7362a$export$b70fe0c8c3456154);
    $parcel$export(module.exports, "default", ()=>$80a366357bb7362a$export$2e2bcd8739ae039);
    var $2XSIf;
    var $h2uoz;
    var $dv869;
    var $fZhYM;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $4R6GH;
    var $4ENQh;
    var $eJyeb = parcelRequire("eJyeb");
    var $21fMI = parcelRequire("21fMI");
    var $5fACX = parcelRequire("5fACX");
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $idmiV = parcelRequire("idmiV");
    var $1CGdp = parcelRequire("1CGdp");
    var $bZA5o = parcelRequire("bZA5o");
    var $fP57B = parcelRequire("fP57B");
    var $lYuBN = parcelRequire("lYuBN");
    var $hyUwT = parcelRequire("hyUwT");
    var $fI3Hm = parcelRequire("fI3Hm");
    var $f27x7 = parcelRequire("f27x7");
    var $jZcxq = parcelRequire("jZcxq");
    var $f7tuF = parcelRequire("f7tuF");
    var $eVLBZ = parcelRequire("eVLBZ");
    var $atabv = parcelRequire("atabv");
    var $b2VIw = parcelRequire("b2VIw");
    var $bREsp = parcelRequire("bREsp");
    var $hHqKh = parcelRequire("hHqKh");
    var $eiyR0 = parcelRequire("eiyR0");
    var $7Gle9 = parcelRequire("7Gle9");
    var $eWre9 = parcelRequire("eWre9");
    var $7haN1 = parcelRequire("7haN1");
    var $8VrCi = parcelRequire("8VrCi");
    var $g7G9N = parcelRequire("g7G9N");
    var $i6pdT = parcelRequire("i6pdT");
    var $77QEM = parcelRequire("77QEM");
    var $8qbLi = parcelRequire("8qbLi");
    var $3JxKh = parcelRequire("3JxKh");
    var $goTVH = parcelRequire("goTVH");
    var $bYhSc = parcelRequire("bYhSc");
    var $knys8 = parcelRequire("knys8");
    var $bNKh8 = parcelRequire("bNKh8");
    var $b3jqF = parcelRequire("b3jqF");
    var $24CMK = parcelRequire("24CMK");
    var $b0D0x = parcelRequire("b0D0x");
    var $ced6B = parcelRequire("ced6B");
    var $834it = parcelRequire("834it");
    var $3dEaa = parcelRequire("3dEaa");
    var $jlryX = parcelRequire("jlryX");
    var $10aT8 = parcelRequire("10aT8");
    var $eS9xr = parcelRequire("eS9xr");
    var $5tChd = parcelRequire("5tChd");
    var $d3uMD = parcelRequire("d3uMD");
    var $bkasS = parcelRequire("bkasS");
    var $1g63B = parcelRequire("1g63B");
    var $f8C8L = parcelRequire("f8C8L");
    var $jGylU = parcelRequire("jGylU");
    var $f9pTa = parcelRequire("f9pTa");
    var $atnIT = parcelRequire("atnIT");
    var $aEqRm = parcelRequire("aEqRm");
    var $kLOUj = parcelRequire("kLOUj");
    var $2jrtN = parcelRequire("2jrtN");
    var $lHoMG = parcelRequire("lHoMG");
    var $5APQl = parcelRequire("5APQl");
    var $2XjH3 = parcelRequire("2XjH3");
    var $bIaKQ = parcelRequire("bIaKQ");
    var $gIlW4 = parcelRequire("gIlW4");
    var $jfp3Z = parcelRequire("jfp3Z");
    var $4K5PQ = parcelRequire("4K5PQ");
    var $kX5YK = parcelRequire("kX5YK");
    var $cukx3 = parcelRequire("cukx3");
    var $aqDY3 = parcelRequire("aqDY3");
    var $gaFm9 = parcelRequire("gaFm9");
    var $5PKZw = parcelRequire("5PKZw");
    const $80a366357bb7362a$export$b70fe0c8c3456154 = (payload)=>({
            type: (0, $7abf4765f09faedb$export$bf72183eb20c4d57),
            payload: payload
        });
    const $80a366357bb7362a$export$b6770a6d5ff091de = ()=>({
            type: (0, $7abf4765f09faedb$export$a60cf13a28cbf30f)
        });
    const $80a366357bb7362a$var$INVERTED_TARGET_START_END_API_MAP = (0, parcelRequire("dv869")).default((0, $5fACX.TARGET_START_END_API_MAP));
    const $80a366357bb7362a$export$43f2c3001ad105a9 = (field)=>{
        const newId = (0, parcelRequire("fZhYM")).default([
            field.id
        ], $80a366357bb7362a$var$INVERTED_TARGET_START_END_API_MAP);
        return newId ? {
            ...field,
            id: newId,
            key: newId
        } : field;
    };
    const $80a366357bb7362a$var$getWarnings = (dateField, dateFieldStatus, customFields)=>{
        if (dateFieldStatus === (0, $5fACX.DateFieldStatus).UNAVAILABLE) {
            const apiDateField = customFields.find((field)=>String(field.id) === dateField.key);
            return {
                code: (0, $5fACX.DATEFIELD_WARNINGS).UNAVAILABLE,
                apiDateField: apiDateField
            };
        }
        if (dateFieldStatus === (0, $5fACX.DateFieldStatus).NOT_EXIST) return {
            code: (0, $5fACX.DATEFIELD_WARNINGS).NOT_EXIST
        };
        return undefined;
    };
    const $80a366357bb7362a$export$183a142021de15c4 = (planInfo)=>({
            baselineStartField: $80a366357bb7362a$export$43f2c3001ad105a9(planInfo.plan.baselineStartField),
            baselineEndField: $80a366357bb7362a$export$43f2c3001ad105a9(planInfo.plan.baselineEndField)
        });
    function $80a366357bb7362a$export$ab3a3f2027ecddbb(planInfo) {
        if (planInfo.dateFieldStatuses == null) return undefined;
        if (planInfo.dateFieldStatuses != null && (planInfo.dateFieldStatuses.startFieldStatus !== (0, $5fACX.DateFieldStatus).OK || planInfo.dateFieldStatuses.endFieldStatus !== (0, $5fACX.DateFieldStatus).OK)) {
            const dateWarnings = {};
            const startWarning = $80a366357bb7362a$var$getWarnings(planInfo.plan.baselineStartField, planInfo.dateFieldStatuses.startFieldStatus, planInfo.customFields);
            const endWarning = $80a366357bb7362a$var$getWarnings(planInfo.plan.baselineEndField, planInfo.dateFieldStatuses.endFieldStatus, planInfo.customFields);
            if (startWarning) dateWarnings.baselineStartField = (0, parcelRequire("h2uoz")).default([
                'warning'
            ], startWarning, (0, $21fMI.extractStartDateField)(planInfo));
            if (endWarning) dateWarnings.baselineEndField = (0, parcelRequire("h2uoz")).default([
                'warning'
            ], endWarning, (0, $5fACX.DUE_DATE_FIELD));
            if (startWarning || endWarning) return dateWarnings;
        }
        return undefined;
    }
    function* $80a366357bb7362a$var$doBacklog(backlogResponse, sprints) {
        let backlog = null;
        if (backlogResponse.ok) yield* (0, $bYhSc.default)(function*() {
            (0, (0, parcelRequire("4ENQh")).monitor).setMark('jira.fe-spa.advanced-roadmaps.product.parse-json:start');
            backlog = yield (0, $aNOuE.call)(backlogResponse.json.bind(backlogResponse));
            (0, (0, parcelRequire("4ENQh")).monitor).setMark('jira.fe-spa.advanced-roadmaps.product.parse-json:end');
            yield (0, $aNOuE.call)((0, $bIaKQ.populateExternalSprints), backlog?.sprints ?? [], sprints);
            yield (0, $aNOuE.put)((0, $fP57B.resetBacklog)(backlog));
            const teams = backlog.teams?.map((0, $bREsp.prepareTeam)) ?? [];
            yield (0, $aNOuE.put)((0, $atabv.setAdditionalTeams)(teams));
            yield (0, $aNOuE.put)((0, $fP57B.afterResetBacklog)());
            yield (0, $aNOuE.put)($cukx3.calculateStatusOfAllReleases());
            yield (0, $aNOuE.call)((0, $8qbLi.populateAssigneesFromProfiles), backlog?.assigneeProfiles ?? {});
            yield (0, $aNOuE.call)((0, $2jrtN.populateReportersFromProfiles), backlog?.reporterProfiles ?? {});
        });
        else {
            yield (0, $aNOuE.call)((0, $8qbLi.populateAssignees));
            const body = yield (0, $aNOuE.call)((0, $3JxKh.backlogBody), {
                id: (0, $g7G9N.getPlanId)() || 1,
                currentScenarioId: (0, $g7G9N.getScenarioId)() || 1
            });
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(backlogResponse, (yield (0, $aNOuE.call)(backlogResponse.text.bind(backlogResponse)))),
                requestInfo: {
                    url: (0, $3JxKh.urls).backlog,
                    type: (0, $77QEM.POST),
                    status: backlogResponse.status,
                    body: body
                }
            }));
        }
        return backlog;
    }
    function* $80a366357bb7362a$var$fetchJson(url) {
        try {
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: 'GET'
            });
            if (response.ok) return yield (0, $aNOuE.call)(response.json.bind(response));
        } catch (e) {}
        throw new Error(`Failed to fetch page data for plan: ${url}`);
    }
    function* $80a366357bb7362a$var$getBasicRequiredPlanInfo() {
        const reportHash = yield (0, $aNOuE.call)((0, $g7G9N.getReportHash));
        if ((0, $4nDwW.isDefined)(reportHash)) {
            let response;
            const earlyPreloadBasicPlanInfoPromise = window.__ARJ_BASIC_PLAN_INFO_FOR_REPORT_PROMISE__;
            delete window.__ARJ_BASIC_PLAN_INFO_FOR_REPORT_PROMISE__;
            if (earlyPreloadBasicPlanInfoPromise) response = yield earlyPreloadBasicPlanInfoPromise;
            if (!(0, $4nDwW.isDefined)(response)) response = yield (0, $aNOuE.call)($80a366357bb7362a$var$fetchJson, `/rest/jpo/1.0/reportinfo/generic/${reportHash}`);
            yield (0, $aNOuE.put)((0, $jZcxq.update)({
                id: response.planId,
                currentScenarioId: response.scenarioId
            }));
            return {
                planId: response.planId,
                scenarioId: response.scenarioId,
                reportInfo: response.data
            };
        }
        return {
            planId: yield (0, $aNOuE.call)((0, $g7G9N.getPlanId)),
            scenarioId: yield (0, $aNOuE.call)((0, $g7G9N.getScenarioId)),
            reportInfo: undefined
        };
    }
    function* $80a366357bb7362a$export$ad018cca17f6d021(savedViewsInfo, appMode) {
        if (appMode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7)) yield (0, $aNOuE.put)((0, $aqDY3.fetchHistoricalIssueForView)());
        else if (savedViewsInfo) yield (0, $aNOuE.call)((0, $aqDY3.initializeViews), savedViewsInfo);
    }
    function* $80a366357bb7362a$var$doInitialLoadSetPlanSystemInfo(pageData, payload) {
        const { planDefaultsInfo: planDefaultsInfo, planInfo: planInfo, hierarchyInfo: hierarchyInfo, issueStatusCategoryInfo: issueStatusCategoryInfo, systemInfo: systemInfo, agileInfo: agileInfo, issueLinkTypesInfo: issueLinkTypesInfo, dependencySettingsInfo: dependencySettingsInfo, loadingLimitsInfo: loadingLimitsInfo, isAtlasConnectInstalled: isAtlasConnectInstalled, hasAtlasPermissions: hasAtlasPermissions } = pageData;
        yield (0, $aNOuE.put).resolve((0, $eVLBZ.setSystemInfo)({
            agileInfo: agileInfo,
            issueLinkTypesInfo: issueLinkTypesInfo,
            dependencySettingsInfo: dependencySettingsInfo,
            systemInfo: {
                ...systemInfo,
                ...payload
            },
            loadingLimitsInfo: loadingLimitsInfo,
            isAtlasConnectInstalled: isAtlasConnectInstalled,
            hasAtlasPermissions: hasAtlasPermissions
        }));
        yield (0, $aNOuE.put)((0, $f27x7.setPlanDefaults)(planDefaultsInfo));
        yield (0, $aNOuE.put).resolve((0, $fP57B.setPlanInfo)({
            planInfo: planInfo,
            hierarchyInfo: hierarchyInfo,
            issueStatusCategoryInfo: issueStatusCategoryInfo
        }));
    }
    function* $80a366357bb7362a$var$doInitialLoadDependencyReportConfluenceMacro(pageData, payload, backlogTask) {
        yield (0, $aNOuE.call)($80a366357bb7362a$var$doInitialLoadSetPlanSystemInfo, pageData, payload);
        yield* $80a366357bb7362a$var$doBacklog((yield (0, $aNOuE.join)(backlogTask)), pageData.planInfo.sprints);
        yield (0, $aNOuE.put)((0, $7haN1.setIsLoading)(false));
        yield (0, $aNOuE.put)($80a366357bb7362a$export$b6770a6d5ff091de());
    }
    function* $80a366357bb7362a$var$doInitialLoadTimeline(pageData, payload, appMode, backlogTask) {
        const { planInfo: planInfo, userProperties: userProperties, savedViewsInfoFull: savedViewsInfoFull, customFieldsOptions: customFieldsOptions, isAtlasConnectInstalled: isAtlasConnectInstalled } = pageData;
        yield (0, $aNOuE.call)($80a366357bb7362a$var$doInitialLoadSetPlanSystemInfo, pageData, payload);
        yield (0, $aNOuE.put)((0, $b2VIw.updateUserIsOnboarded)(Boolean(userProperties.onboadingShown)));
        if (!userProperties.onboadingShown) {
            if (appMode === (0, $ab4be2e1e204af69$export$250171a898bf7ef)) yield (0, $aNOuE.put).resolve((0, $1g63B.setIntroOpen)(true));
        }
        yield* $80a366357bb7362a$var$doBacklog((yield (0, $aNOuE.join)(backlogTask)), planInfo.sprints);
        const isMacroProxy = yield (0, $aNOuE.select)((0, $1CGdp.isConfluenceMacroProxy));
        if (isAtlasConnectInstalled && (!isMacroProxy || !(0, (0, parcelRequire("4R6GH")).fg)('remove_goal_field_on_plan_macro'))) {
            const goalARIs = yield (0, $aNOuE.select)((0, $bZA5o.getIssueGoalARIs));
            yield (0, $aNOuE.put)((0, $10aT8.fetchGoals)(goalARIs));
        }
        yield (0, $aNOuE.call)((0, $bNKh8.doPopulateUserPickerOptions));
        yield (0, $aNOuE.put)((0, $eiyR0.reset)({
            customFields: planInfo.customFields
        }));
        yield (0, $aNOuE.call)($80a366357bb7362a$export$ad018cca17f6d021, savedViewsInfoFull, appMode);
        yield (0, $aNOuE.put)((0, $gaFm9.calculateWarnings)());
        yield (0, $aNOuE.put)($cukx3.calculateStatusOfAllReleases());
        yield (0, $aNOuE.put)((0, $7haN1.setIsLoading)(false));
        const dateWarnings = $80a366357bb7362a$export$ab3a3f2027ecddbb(planInfo);
        if (dateWarnings) yield (0, $aNOuE.put)((0, $jZcxq.update)(dateWarnings));
        yield (0, $aNOuE.put)($80a366357bb7362a$export$b6770a6d5ff091de());
        yield (0, $aNOuE.put)((0, $aqDY3.applyModificationsForInactiveViews)(savedViewsInfoFull));
        if (customFieldsOptions) {
            const selectOptions = customFieldsOptions.map(({ customFieldId: fieldId, options: options })=>options.map((option)=>(0, parcelRequire("2XSIf")).default('fieldId', fieldId, option))).reduce((a, b)=>a.concat(b), []);
            yield (0, $aNOuE.put)((0, $f7tuF.reset)(selectOptions));
        }
        if (payload.planView) yield (0, $aNOuE.put)((0, $hHqKh.changeActiveFilterView)(payload.planView));
    }
    function* $80a366357bb7362a$var$populateReportConfig(parameters, pageData, payload, appMode, backlogTask) {
        switch(parameters.view){
            case 0, $TTKUQ.DEPENDENCY_REPORT_SHARE_TYPE:
                yield (0, $aNOuE.call)((0, $b3jqF.populateDependencyReportFilterSettings), parameters.viewConfig.filtersV1);
                yield (0, $aNOuE.call)($80a366357bb7362a$var$doInitialLoadDependencyReportConfluenceMacro, pageData, payload, backlogTask);
                break;
            default:
                yield (0, $aNOuE.call)((0, $aqDY3.populateReportViewSettings), parameters.viewConfig);
                yield (0, $aNOuE.call)($80a366357bb7362a$var$doInitialLoadTimeline, pageData, payload, appMode, backlogTask);
        }
    }
    function* $80a366357bb7362a$export$d25a2f5a3aab9b8({ payload: payload }) {
        yield (0, $aNOuE.put)((0, $7haN1.setIsLoading)(true));
        yield (0, $aNOuE.put)((0, $lYuBN.setMode)((0, $hyUwT.getInitialMode)()));
        const basicPlanInfo = yield (0, $aNOuE.call)($80a366357bb7362a$var$getBasicRequiredPlanInfo);
        (0, (0, parcelRequire("4ENQh")).monitor).initializeContextualAnalyticsData({
            planId: basicPlanInfo.planId,
            scenarioId: basicPlanInfo.scenarioId
        });
        const appMode = yield (0, $aNOuE.select)((0, $1CGdp.getMode));
        const backlogTask = yield (0, $aNOuE.fork)((0, $goTVH.fetchBacklog), true, basicPlanInfo.planId, basicPlanInfo.scenarioId);
        const pageData = yield (0, $aNOuE.call)((0, $jGylU.getPageDataFromInfoMetadata), basicPlanInfo);
        if (pageData === (0, $9e169ee721864a4b$export$1c67cc6ab03450a2)) {
            yield (0, $aNOuE.put)((0, $eWre9.setIsProjectLimitExceeded)());
            if (appMode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7)) return;
            yield (0, $aNOuE.call)((0, $idmiV.redirect), (0, $eJyeb.proxyContextSafeUrl)(`/jira/plans/${basicPlanInfo.planId}/setup`));
            return;
        }
        const { planInfo: planInfo, reportInfo: reportInfo } = pageData;
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = $80a366357bb7362a$export$183a142021de15c4(planInfo);
        planInfo.plan.baselineStartField = baselineStartField;
        planInfo.plan.baselineEndField = baselineEndField;
        if (appMode === (0, $ab4be2e1e204af69$export$e3d31417f21c1ce7)) {
            if (!reportInfo) throw new Error('Failed to fetch report data');
            yield (0, $aNOuE.put).resolve((0, $7Gle9.setConfluenceMacroType)(reportInfo.parameters.view));
            yield (0, $aNOuE.call)($80a366357bb7362a$var$populateReportConfig, reportInfo.parameters, pageData, payload, appMode, backlogTask);
        } else if (planInfo.readOnly && appMode !== (0, $ab4be2e1e204af69$export$f79b1fae3e63e441)) {
            yield (0, $aNOuE.put)((0, $lYuBN.setMode)((0, $ab4be2e1e204af69$export$b07c15b79440feb8)));
            yield (0, $aNOuE.call)($80a366357bb7362a$var$doInitialLoadTimeline, pageData, payload, appMode, backlogTask);
        } else yield (0, $aNOuE.call)($80a366357bb7362a$var$doInitialLoadTimeline, pageData, payload, appMode, backlogTask);
    }
    function* $80a366357bb7362a$var$initialLoadWith401Handled(action) {
        try {
            yield (0, $aNOuE.call)($80a366357bb7362a$export$d25a2f5a3aab9b8, action);
        } catch (err) {
            if (err instanceof Error && err.message.includes('no-jira-software-access-for-user')) {
                yield (0, $aNOuE.put)((0, $fI3Hm.pushFlag)({
                    key: (0, $9e169ee721864a4b$export$a23067a331938f15)
                }));
                return;
            }
            throw err;
        }
    }
    function* $80a366357bb7362a$export$e8f373ba4bb4eba9() {
        yield (0, $6u3NN.takeLatest)((0, $7abf4765f09faedb$export$bf72183eb20c4d57), $80a366357bb7362a$var$initialLoadWith401Handled);
    }
    const $80a366357bb7362a$var$rootSaga = function*() {
        yield (0, $aNOuE.fork)((0, $3dEaa.default));
        yield (0, $aNOuE.fork)((0, $8qbLi.default));
        yield (0, $aNOuE.fork)((0, $gaFm9.default));
        yield (0, $aNOuE.fork)((0, $knys8.default)($cukx3));
        yield (0, $aNOuE.fork)((0, $bNKh8.default));
        yield (0, $aNOuE.fork)((0, $ced6B.default));
        yield (0, $aNOuE.fork)((0, $8VrCi.cancelOnReset), (0, $jlryX.default));
        yield (0, $aNOuE.fork)((0, $8VrCi.cancelOnReset), (0, $bkasS.default));
        yield (0, $aNOuE.fork)((0, $8VrCi.cancelOnReset), (0, $eS9xr.default));
        yield (0, $aNOuE.fork)((0, $8VrCi.cancelOnReset), (0, $d3uMD.default));
        yield (0, $aNOuE.fork)((0, $f8C8L.default));
        yield (0, $aNOuE.fork)((0, $f9pTa.default));
        yield (0, $aNOuE.fork)((0, $8VrCi.cancelOnReset), (0, $atnIT.default));
        yield (0, $aNOuE.fork)((0, $kLOUj.default));
        yield (0, $aNOuE.fork)((0, $lHoMG.default));
        yield (0, $aNOuE.fork)((0, $5APQl.default));
        yield (0, $aNOuE.fork)((0, $b0D0x.default));
        yield (0, $aNOuE.fork)((0, $2XjH3.default));
        yield (0, $aNOuE.fork)((0, $8VrCi.cancelOnReset), (0, $aqDY3.default));
        yield (0, $aNOuE.fork)((0, $gIlW4.default));
        yield (0, $aNOuE.fork)((0, $jfp3Z.default));
        yield (0, $aNOuE.fork)((0, $4K5PQ.default));
        yield (0, $aNOuE.fork)((0, $8VrCi.cancelOnReset), (0, $kX5YK.default));
        yield (0, $aNOuE.fork)((0, $cukx3.default)($knys8));
        yield (0, $aNOuE.fork)($80a366357bb7362a$export$e8f373ba4bb4eba9);
        yield (0, $aNOuE.fork)((0, $834it.default));
        yield (0, $aNOuE.fork)((0, $1g63B.default));
        yield (0, $aNOuE.fork)((0, $bIaKQ.default));
        yield (0, $aNOuE.fork)((0, $i6pdT.default));
        yield (0, $aNOuE.fork)((0, $aEqRm.default));
        yield (0, $aNOuE.fork)((0, $5tChd.default));
        yield (0, $aNOuE.fork)((0, $10aT8.default));
    };
    function* $80a366357bb7362a$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)((0, $24CMK.default));
        while(true)try {
            yield (0, $aNOuE.call)($80a366357bb7362a$var$rootSaga);
            break;
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
});
parcelRegister("dv869", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d4473bda03ded4c$export$2e2bcd8739ae039);
    var $ccUYa;
    var $76p2G;
    var $9d4473bda03ded4c$var$invertObj = (0, (0, parcelRequire("ccUYa")).default)(function invertObj(obj) {
        var props = (0, (0, parcelRequire("76p2G")).default)(obj);
        var len = props.length;
        var idx = 0;
        var out = {};
        while(idx < len){
            var key = props[idx];
            out[obj[key]] = key;
            idx += 1;
        }
        return out;
    });
    var $9d4473bda03ded4c$export$2e2bcd8739ae039 = $9d4473bda03ded4c$var$invertObj;
});
parcelRegister("21fMI", function(module, exports) {
    $parcel$export(module.exports, "extractStartDateField", ()=>$d38ca2f26ef4f8b9$export$5840ec613b05dae0);
    var $5fACX = parcelRequire("5fACX");
    const $d38ca2f26ef4f8b9$export$5840ec613b05dae0 = (planInfo)=>{
        const startDateCustomField = planInfo.customFields.find((field)=>field.defaultStartDateCustomField);
        if (!startDateCustomField) throw new Error('missing Start Date Custom field in server response');
        return {
            id: `customfield_${startDateCustomField.id}`,
            key: `${startDateCustomField.id}`,
            type: (0, $5fACX.DATEFIELD_TYPES).CUSTOM
        };
    };
});
parcelRegister("hyUwT", function(module, exports) {
    $parcel$export(module.exports, "getInitialMode", ()=>$db027eac9ff08a7c$export$31f8cb84db5999fd);
    $parcel$export(module.exports, "default", ()=>$db027eac9ff08a7c$export$2e2bcd8739ae039);
    var $2XSIf;
    var $4R6GH;
    var $5jgat;
    var $idmiV = parcelRequire("idmiV");
    var $4SlaE;
    var $fP57B = parcelRequire("fP57B");
    var $lYuBN = parcelRequire("lYuBN");
    const $db027eac9ff08a7c$export$31f8cb84db5999fd = ()=>{
        if ((0, $idmiV.isReportView)()) return 0, $ab4be2e1e204af69$export$e3d31417f21c1ce7;
        if ((0, $idmiV.isExportView)()) return 0, $ab4be2e1e204af69$export$f79b1fae3e63e441;
        if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) {
            if ((0, (0, parcelRequire("5jgat")).isEmbedSmartLinkView)()) return 0, $ab4be2e1e204af69$export$b07c15b79440feb8;
        }
        return 0, $ab4be2e1e204af69$export$250171a898bf7ef;
    };
    const $db027eac9ff08a7c$var$getInitialState = ()=>({
            mode: $db027eac9ff08a7c$export$31f8cb84db5999fd(),
            analyticsEvent: (0, (0, parcelRequire("4SlaE")).createTestEvent)(),
            hasReportedInitialLoadAnalytics: false,
            isPlanInfoReady: false,
            isExportPreview: (0, $idmiV.isExportPreview)()
        });
    var $db027eac9ff08a7c$export$2e2bcd8739ae039 = (state = $db027eac9ff08a7c$var$getInitialState(), action)=>{
        switch(action.type){
            case 0, $lYuBN.REPORT_INITIAL_LOAD_ANALYTICS:
                return {
                    ...state,
                    hasReportedInitialLoadAnalytics: true
                };
            case 0, $lYuBN.SET_MODE:
                {
                    const mode = action.payload;
                    if (state.mode === (0, $ab4be2e1e204af69$export$b07c15b79440feb8)) return state;
                    return (0, parcelRequire("2XSIf")).default('mode', mode, state);
                }
            case 0, $lYuBN.SET_ANALYTICS_EVENT:
                {
                    const analyticsEvent = action.payload;
                    return (0, parcelRequire("2XSIf")).default('analyticsEvent', analyticsEvent, state);
                }
            case 0, $fP57B.SET_PLAN_INFO:
                return (0, parcelRequire("2XSIf")).default('isPlanInfoReady', true, state);
            case 0, $lYuBN.SET_IS_EXPORT_PREVIEW:
                return (0, parcelRequire("2XSIf")).default('isExportPreview', action.payload, state);
            case 0, $lYuBN.SET_BROWSER_HISTORY:
                {
                    const browserHistory = action.payload;
                    return (0, parcelRequire("2XSIf")).default('browserHistory', browserHistory, state);
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("4SlaE", function(module, exports) {
    $parcel$export(module.exports, "createTestEvent", ()=>$a6805ac46b86576f$export$85f5d5efce614e62);
    var $1SrMX;
    const $a6805ac46b86576f$export$85f5d5efce614e62 = (payload = {
        payload: {
            action: 'thisIsADumyAction',
            actionSubject: 'thisIsADumyActionSubject'
        }
    })=>new (0, (0, parcelRequire("1SrMX")).default)(payload);
});
parcelRegister("f27x7", function(module, exports) {
    $parcel$export(module.exports, "SET_PLAN_DEFAULTS", ()=>$d9f95ca1d9dccc24$export$2f67879ed146c53a);
    $parcel$export(module.exports, "setPlanDefaults", ()=>$d9f95ca1d9dccc24$export$6bd5a8361ba5d3f);
    const $d9f95ca1d9dccc24$export$2f67879ed146c53a = 'state.domain.planDefaults.SET_PLAN_DEFAULTS';
    const $d9f95ca1d9dccc24$export$6bd5a8361ba5d3f = (payload)=>({
            type: $d9f95ca1d9dccc24$export$2f67879ed146c53a,
            payload: payload
        });
});
parcelRegister("eVLBZ", function(module, exports) {
    $parcel$export(module.exports, "SET_SYSTEM_INFO", ()=>$0f04c4fec28742a8$export$988c147bb85b1b82);
    $parcel$export(module.exports, "setSystemInfo", ()=>$0f04c4fec28742a8$export$a6d44ded8a2c25c6);
    const $0f04c4fec28742a8$export$988c147bb85b1b82 = 'state.domain.system.SET_SYSTEM_INFO';
    const $0f04c4fec28742a8$export$a6d44ded8a2c25c6 = (payload)=>({
            type: $0f04c4fec28742a8$export$988c147bb85b1b82,
            payload: payload
        });
});
parcelRegister("b2VIw", function(module, exports) {
    $parcel$export(module.exports, "UPDATE", ()=>$42a49adb165628c9$export$e271b26eefe41db8);
    $parcel$export(module.exports, "updateUserIsOnboarded", ()=>$42a49adb165628c9$export$20517a0faa9bbb17);
    const $42a49adb165628c9$export$e271b26eefe41db8 = 'state.ui.eap.UPDATE';
    const $42a49adb165628c9$export$20517a0faa9bbb17 = (payload)=>({
            type: $42a49adb165628c9$export$e271b26eefe41db8,
            payload: payload
        });
});
parcelRegister("7Gle9", function(module, exports) {
    $parcel$export(module.exports, "SET_CONFLUENCE_MACRO_TYPE", ()=>$49eefeb546348c73$export$47da29bdd98ccf6e);
    $parcel$export(module.exports, "setConfluenceMacroType", ()=>$49eefeb546348c73$export$ba97b0acf6b6d58f);
    const $49eefeb546348c73$export$47da29bdd98ccf6e = 'state.ui.confluence-macro.SET_CONFLUENCE_MACRO_TYPE';
    const $49eefeb546348c73$export$ba97b0acf6b6d58f = (payload)=>({
            type: $49eefeb546348c73$export$47da29bdd98ccf6e,
            payload: payload
        });
});
parcelRegister("8VrCi", function(module, exports) {
    $parcel$export(module.exports, "cancelOnReset", ()=>$2b6716f4853feab5$export$891f184cc76108ba);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $5PKZw = parcelRequire("5PKZw");
    function* $2b6716f4853feab5$export$891f184cc76108ba(saga, options) {
        const { cancelAction: cancelAction = (0, $5PKZw.RESET_REDUX_STORE) } = {
            ...options
        };
        const task = yield (0, $aNOuE.fork)(saga);
        yield (0, $aNOuE.take)(cancelAction);
        yield (0, $aNOuE.cancel)(task);
        yield (0, $aNOuE.call)($2b6716f4853feab5$export$891f184cc76108ba, saga, options);
    }
});
parcelRegister("5PKZw", function(module, exports) {
    $parcel$export(module.exports, "RESET_REDUX_STORE", ()=>$63867686bfb97d98$export$fbb68db26834815d);
    $parcel$export(module.exports, "RESTORE_REDUX_STORE", ()=>$63867686bfb97d98$export$2e5623391f1ce3b5);
    $parcel$export(module.exports, "resetReduxStore", ()=>$63867686bfb97d98$export$6c0dcd2cdf8ea8de);
    $parcel$export(module.exports, "restoreReduxStore", ()=>$63867686bfb97d98$export$61e7b1f8f9c1a24b);
    const $63867686bfb97d98$export$fbb68db26834815d = 'state.RESET_REDUX_STORE';
    const $63867686bfb97d98$export$2e5623391f1ce3b5 = 'state.RESTORE_REDUX_STORE';
    const $63867686bfb97d98$export$6c0dcd2cdf8ea8de = ()=>({
            type: $63867686bfb97d98$export$fbb68db26834815d
        });
    const $63867686bfb97d98$export$61e7b1f8f9c1a24b = (initialState)=>({
            type: $63867686bfb97d98$export$2e5623391f1ce3b5,
            payload: initialState
        });
});
parcelRegister("b3jqF", function(module, exports) {
    $parcel$export(module.exports, "populateDependencyReportFilterSettings", ()=>$4f46a67997918020$export$9f242b44e4270ddf);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $iLfHk = parcelRequire("iLfHk");
    var $iLfHk = parcelRequire("iLfHk");
    function* $4f46a67997918020$export$9f242b44e4270ddf(filterSettings) {
        yield (0, $aNOuE.put)((0, $iLfHk.initiateFilters)(filterSettings));
    }
});
parcelRegister("3dEaa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34125858e7543a8b$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $1CGdp = parcelRequire("1CGdp");
    var $9wckG = parcelRequire("9wckG");
    var $fI3Hm = parcelRequire("fI3Hm");
    var $dlYZF = parcelRequire("dlYZF");
    var $fGE0C = parcelRequire("fGE0C");
    const $34125858e7543a8b$var$EDIT_MODE_ONLY_FLAGS = [
        {
            key: (0, $9e169ee721864a4b$export$42d68c08a5ace658)
        },
        {
            key: (0, $9e169ee721864a4b$export$a1a68e80ebef1446)
        }
    ];
    const $34125858e7543a8b$var$RANKING_WARNING_FLAGS = [
        {
            key: (0, $9e169ee721864a4b$export$5d75f74c1d4d448d)
        },
        {
            key: (0, $9e169ee721864a4b$export$8a72c64e90d56fab)
        },
        {
            key: (0, $9e169ee721864a4b$export$ac1a967dceae5708)
        }
    ];
    function* $34125858e7543a8b$export$5b63f32dd550acba({ payload: payload }) {
        const isReadOnly = yield (0, $aNOuE.select)((0, $1CGdp.isReadOnly));
        const allFlags = yield (0, $aNOuE.select)((0, $9wckG.getFlags));
        const { key: key } = payload;
        let shouldPushFlag = false;
        if (!isReadOnly) shouldPushFlag = true;
        else if (!$34125858e7543a8b$var$EDIT_MODE_ONLY_FLAGS.some(({ key: editModeOnlyKey })=>editModeOnlyKey === key)) shouldPushFlag = true;
        if ($34125858e7543a8b$var$RANKING_WARNING_FLAGS.some(({ key: rankingWarningKey })=>rankingWarningKey === key) && !allFlags.includes(key)) shouldPushFlag = true;
        if (shouldPushFlag) yield (0, $aNOuE.put)((0, $fI3Hm.pushFlag)(payload));
    }
    function* $34125858e7543a8b$export$cfaf9da3a08e8d3e({ payload: payload }) {
        const flagName = (0, $fGE0C.transformDismissedFlagName)(payload.key);
        if (flagName) yield (0, $aNOuE.put)((0, $dlYZF.updateHiddenFlagDate)({
            key: flagName
        }));
    }
    function* $34125858e7543a8b$export$2e2bcd8739ae039() {
        yield (0, $6u3NN.takeEvery)((0, $fI3Hm.ADD_FLAG), $34125858e7543a8b$export$5b63f32dd550acba);
        yield (0, $6u3NN.takeEvery)((0, $fI3Hm.DISMISS_FLAG), $34125858e7543a8b$export$cfaf9da3a08e8d3e);
    }
});
parcelRegister("dlYZF", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_HIDDEN_FLAG_DATE", ()=>$65ed489624eed22f$export$9383ffe2e65d2eb7);
    $parcel$export(module.exports, "CLEAR_HIDDEN_FLAG_DATE", ()=>$65ed489624eed22f$export$32941719fac87cfb);
    $parcel$export(module.exports, "updateHiddenFlagDate", ()=>$65ed489624eed22f$export$4088c054a6cf051d);
    $parcel$export(module.exports, "clearHiddenFlagDate", ()=>$65ed489624eed22f$export$8eb5fdb4567a7333);
    const $65ed489624eed22f$export$9383ffe2e65d2eb7 = 'state.domain.hiddenFlags.UPDATE_HIDDEN_FLAG_DATE';
    const $65ed489624eed22f$export$32941719fac87cfb = 'state.domain.hiddenFlags.CLEAR_HIDDEN_FLAG_DATE';
    const $65ed489624eed22f$export$4088c054a6cf051d = (payload)=>({
            type: $65ed489624eed22f$export$9383ffe2e65d2eb7,
            payload: payload
        });
    const $65ed489624eed22f$export$8eb5fdb4567a7333 = (payload)=>({
            type: $65ed489624eed22f$export$32941719fac87cfb,
            payload: payload
        });
});
parcelRegister("fGE0C", function(module, exports) {
    $parcel$export(module.exports, "transformDismissedFlagName", ()=>$7ec160e7758b62fb$export$96e4348af167b4b);
    const $7ec160e7758b62fb$export$96e4348af167b4b = (flagKey)=>{
        switch(flagKey){
            case 'issue-limit-warning':
                return 0, $9e169ee721864a4b$export$42d68c08a5ace658;
            case 'reparent-tmp-to-external-warning':
                return 0, $9e169ee721864a4b$export$8a72c64e90d56fab;
            case 'reparent-cmp-to-tmp-warning':
                return 0, $9e169ee721864a4b$export$ac1a967dceae5708;
            default:
                return '';
        }
    };
});
parcelRegister("d3uMD", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypesForIds", ()=>$03b282d987369cc2$export$fb83572fb8b10534);
    $parcel$export(module.exports, "default", ()=>$03b282d987369cc2$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $8DSSe = parcelRequire("8DSSe");
    var $XZtO4 = parcelRequire("XZtO4");
    var $77QEM = parcelRequire("77QEM");
    var $24CMK = parcelRequire("24CMK");
    var $3LbEZ = parcelRequire("3LbEZ");
    const $03b282d987369cc2$var$GET_ISSUE_TYPES_FOR_IDS = 'command.issue-type.GET_ISSUE_TYPES_FOR_IDS';
    const $03b282d987369cc2$export$fb83572fb8b10534 = (payload)=>({
            type: $03b282d987369cc2$var$GET_ISSUE_TYPES_FOR_IDS,
            payload: payload
        });
    function* $03b282d987369cc2$export$747c2876415a1f3e({ payload: payload }) {
        const url = (0, $3LbEZ.urls).issueTypesForIds;
        const body = {
            ids: payload
        };
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
            method: 'POST',
            body: body
        });
        if (response.ok) {
            const issueTypes = yield (0, $aNOuE.call)(response.json.bind(response));
            yield (0, $aNOuE.put)($XZtO4.add(issueTypes));
        } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
            ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: 'POST',
                status: response.status,
                body: body
            }
        }));
    }
    function* $03b282d987369cc2$export$5e4065bac8fb3930() {
        yield (0, $6u3NN.takeEvery)($03b282d987369cc2$var$GET_ISSUE_TYPES_FOR_IDS, $03b282d987369cc2$export$747c2876415a1f3e);
    }
    function* $03b282d987369cc2$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($03b282d987369cc2$export$5e4065bac8fb3930);
    }
});
parcelRegister("XZtO4", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$15ede7201cc85c14$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD", ()=>$15ede7201cc85c14$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "reset", ()=>$15ede7201cc85c14$export$aad8462122ac592b);
    $parcel$export(module.exports, "add", ()=>$15ede7201cc85c14$export$e16d8520af44a096);
    const $15ede7201cc85c14$export$4a991c87e640ef77 = 'state.domain.issue-types.RESET';
    const $15ede7201cc85c14$export$bb6389024b71c2ae = 'state.domain.issue-types.ADD';
    const $15ede7201cc85c14$export$aad8462122ac592b = (payload)=>({
            type: $15ede7201cc85c14$export$4a991c87e640ef77,
            payload: payload
        });
    const $15ede7201cc85c14$export$e16d8520af44a096 = (payload)=>({
            type: $15ede7201cc85c14$export$bb6389024b71c2ae,
            payload: payload
        });
});
parcelRegister("3LbEZ", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$dbc96f9547fcafcf$export$bcae9ba627f604b6);
    const $dbc96f9547fcafcf$export$bcae9ba627f604b6 = {
        issueTypesForIds: '/rest/jpo/1.0/issuetypes'
    };
});
parcelRegister("1g63B", function(module, exports) {
    $parcel$export(module.exports, "setIntroOpen", ()=>$98b49c498fd9228b$export$e235b69f47ba4464);
    $parcel$export(module.exports, "default", ()=>$98b49c498fd9228b$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $8DSSe = parcelRequire("8DSSe");
    var $iG8V9 = parcelRequire("iG8V9");
    var $77QEM = parcelRequire("77QEM");
    var $24CMK = parcelRequire("24CMK");
    var $3SwrI = parcelRequire("3SwrI");
    const $98b49c498fd9228b$export$e235b69f47ba4464 = (payload)=>({
            type: (0, $iG8V9.SET_INTRO_OPEN),
            payload: payload
        });
    function* $98b49c498fd9228b$export$29f7d6751d659711({ payload: payload }) {
        try {
            const url = (0, $3SwrI.urls).set;
            const body = (0, $3SwrI.setUserPropertyBody)('onboadingShown', payload);
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), url, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!response.ok) yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $77QEM.POST),
                    status: response.status,
                    body: body
                }
            }));
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $98b49c498fd9228b$export$1a6b50881f96a8ec() {
        yield (0, $6u3NN.takeEvery)((0, $iG8V9.SET_ONBOARDING_SHOWN), $98b49c498fd9228b$export$29f7d6751d659711);
    }
    function* $98b49c498fd9228b$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($98b49c498fd9228b$export$1a6b50881f96a8ec);
    }
});
parcelRegister("iG8V9", function(module, exports) {
    $parcel$export(module.exports, "SET_INTRO_OPEN", ()=>$73925687ba491343$export$c92e1b6fc8685e50);
    $parcel$export(module.exports, "SET_ONBOARDING_SHOWN", ()=>$73925687ba491343$export$e0391b0512509585);
    $parcel$export(module.exports, "SET_ACTIVE_CARD", ()=>$73925687ba491343$export$b335940c72c522b7);
    const $73925687ba491343$export$c92e1b6fc8685e50 = 'state.ui.onboarding.SET_INTRO_OPEN';
    const $73925687ba491343$export$e0391b0512509585 = 'state.ui.onboarding.SET_ONBOARDING_SHOWN';
    const $73925687ba491343$export$b335940c72c522b7 = 'state.ui.onboarding.SET_ACTIVE_CARD';
    const $73925687ba491343$export$15c7f29739be525d = (payload)=>({
            type: $73925687ba491343$export$e0391b0512509585,
            payload: payload
        });
    const $73925687ba491343$export$c408a3a8a6e2d351 = (payload)=>({
            type: $73925687ba491343$export$b335940c72c522b7,
            payload: payload
        });
});
parcelRegister("3SwrI", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$25f8f7575af2cc67$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "setUserPropertyBody", ()=>$25f8f7575af2cc67$export$4901ba1ed7ae3875);
    const $25f8f7575af2cc67$export$bcae9ba627f604b6 = {
        set: '/rest/jpo/1.0/pluginUserProperties/set'
    };
    const $25f8f7575af2cc67$export$4901ba1ed7ae3875 = (key, value)=>({
            key: key,
            value: value
        });
});
parcelRegister("jGylU", function(module, exports) {
    $parcel$export(module.exports, "getPageDataFromInfoMetadata", ()=>$43d60a62838a8fa3$export$ce6ea50e8812f057);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $4ENQh;
    var $6NgSc;
    var $4nDwW = parcelRequire("4nDwW");
    var $asXbx = parcelRequire("asXbx");
    function* $43d60a62838a8fa3$export$ce6ea50e8812f057(basicPlanInfo) {
        if (!(0, $4nDwW.isDefined)(basicPlanInfo)) throw new Error('Basic plan info missing for non-wrm page data loading');
        const { planId: planId, scenarioId: scenarioId, reportInfo: reportInfo } = basicPlanInfo;
        let response;
        const url = '/rest/jpo/1.0/info/metadata';
        const earlyPreloadInfoMetadataPromise = window.__ARJ_INFO_METADATA_PROMISE__;
        delete window.__ARJ_INFO_METADATA_PROMISE__;
        if (earlyPreloadInfoMetadataPromise) {
            const responseObj = yield earlyPreloadInfoMetadataPromise;
            const ok = responseObj.ok;
            const data = yield responseObj.json();
            response = {
                ok: ok,
                data: data
            };
            const start = Math.floor((0, (0, parcelRequire("6NgSc")).extractStartTime)('jira.fe-spa.advanced-roadmaps.early-preload.info-metadata:start'));
            const end = Math.ceil((0, (0, parcelRequire("6NgSc")).extractStartTime)('jira.fe-spa.advanced-roadmaps.early-preload.info-metadata:end'));
            (0, (0, parcelRequire("4ENQh")).monitor).recordCustomProfile(url, {
                start: start,
                end: end
            });
        }
        if (!(0, $4nDwW.isDefined)(response)) response = yield (0, $aNOuE.call)((0, $asXbx.json), {
            url: url,
            method: 'POST',
            body: {
                planId: planId,
                scenarioId: scenarioId,
                includeCustomFieldsOptions: true
            },
            profile: url
        });
        if ((0, $4nDwW.isDefined)(response) && response.ok) {
            if ('errorMessage' in response.data) {
                if (response.data.errorMessage === (0, $9e169ee721864a4b$export$1c67cc6ab03450a2)) return 0, $9e169ee721864a4b$export$1c67cc6ab03450a2;
            } else return {
                planDefaultsInfo: response.data.planDefaults,
                planInfo: response.data.simplePlan,
                hierarchyInfo: response.data.hierarchy,
                issueStatusCategoryInfo: response.data.issueStatus,
                systemInfo: response.data.system,
                agileInfo: response.data.agile,
                issueLinkTypesInfo: response.data.issueLinks,
                dependencySettingsInfo: response.data.dependencySettings,
                userProperties: response.data.pluginUser,
                loadingLimitsInfo: response.data.loadingLimits,
                savedViewsInfoFull: response.data.savedViewsInfoFull,
                customFieldsOptions: response.data.customFieldsOptions,
                isAtlasConnectInstalled: response.data.isAtlasConnectInstalled,
                hasAtlasPermissions: response.data.hasAtlasPermissions,
                reportInfo: reportInfo
            };
        }
        throw new Error('Failed to fetch page data for plan');
    }
});
parcelRegister("f9pTa", function(module, exports) {
    $parcel$export(module.exports, "establishPermission", ()=>$cb048afe5138163e$export$e2b6dc333326621);
    $parcel$export(module.exports, "revokePermission", ()=>$cb048afe5138163e$export$2d04b98d90274ff1);
    $parcel$export(module.exports, "revokeAllPermissions", ()=>$cb048afe5138163e$export$cbbad8f9b6cf6c33);
    $parcel$export(module.exports, "fetchPermissions", ()=>$cb048afe5138163e$export$4f24ecba11982e9d);
    $parcel$export(module.exports, "fetchTeamPermissions", ()=>$cb048afe5138163e$export$eb658a558727ba9f);
    $parcel$export(module.exports, "default", ()=>$cb048afe5138163e$export$2e2bcd8739ae039);
    var $8r8wv;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $8DSSe = parcelRequire("8DSSe");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $1CGdp = parcelRequire("1CGdp");
    var $6WWH1 = parcelRequire("6WWH1");
    var $bHTqr = parcelRequire("bHTqr");
    var $5NIow = parcelRequire("5NIow");
    var $77QEM = parcelRequire("77QEM");
    var $8qbLi = parcelRequire("8qbLi");
    var $24CMK = parcelRequire("24CMK");
    var $4JEPY = parcelRequire("4JEPY");
    const $cb048afe5138163e$export$b9a6161393332468 = 'command.permissions.FETCH_PERMISSIONS';
    const $cb048afe5138163e$export$2158053a23d9487 = 'command.permissions.ESTABLISH_PERMISSION';
    const $cb048afe5138163e$export$de33a2a8581dd543 = 'command.permissions.REVOKE_PERMISSION';
    const $cb048afe5138163e$export$fe39957c0d22d76b = 'command.permissions.REVOKE_ALL_PERMISSIONS';
    const $cb048afe5138163e$export$42789425ce10f663 = 'command.permissions.FETCH_TEAM_PERMISSIONS';
    const $cb048afe5138163e$export$e2b6dc333326621 = (payload)=>({
            type: $cb048afe5138163e$export$2158053a23d9487,
            payload: payload
        });
    const $cb048afe5138163e$export$2d04b98d90274ff1 = (payload)=>({
            type: $cb048afe5138163e$export$de33a2a8581dd543,
            payload: payload
        });
    const $cb048afe5138163e$export$cbbad8f9b6cf6c33 = (payload)=>({
            type: $cb048afe5138163e$export$fe39957c0d22d76b,
            payload: payload
        });
    const $cb048afe5138163e$export$4f24ecba11982e9d = ()=>({
            type: $cb048afe5138163e$export$b9a6161393332468
        });
    const $cb048afe5138163e$export$eb658a558727ba9f = (orgId, siteId)=>({
            type: $cb048afe5138163e$export$42789425ce10f663,
            orgId: orgId,
            siteId: siteId
        });
    const $cb048afe5138163e$export$778f86d0002199a6 = (payload)=>`Failed to add "${payload.holder.type}" permission for "${payload.holder.key}"`;
    const $cb048afe5138163e$export$4a5061a17a8f71cf = (payload)=>`Failed to delete "${payload.holder.type}" permission for "${payload.holder.key}"`;
    function* $cb048afe5138163e$export$20993e109b0754be({ payload: payload }) {
        try {
            yield (0, $aNOuE.put)((0, $5NIow.removePermission)(payload));
            const { id: planId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
            const body = {
                permission: {
                    permission: payload.permission,
                    holder: payload.holder
                },
                planId: planId
            };
            if (!payload.holder) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    id: (0, $TTKUQ.ERROR_REPORTING_PACKAGE).APP,
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                attributes: {
                    message: `Removing permission - Permission holder is undefined in ${JSON.stringify(payload)}`
                },
                sendToPrivacyUnsafeSplunk: true
            });
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $4JEPY.urls).revoke, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!response.ok) {
                const error = (0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response))));
                yield (0, $aNOuE.put)((0, $5NIow.addPermission)(payload));
                yield (0, $aNOuE.put)((0, $24CMK.httpRequestError)(response, error, {
                    method: (0, $77QEM.POST)
                }));
                return;
            }
            const { removed: removed } = yield (0, $aNOuE.call)(response.json.bind(response));
            if (!removed.length) {
                yield (0, $aNOuE.put)((0, $5NIow.addPermission)(payload));
                throw (()=>({
                        message: $cb048afe5138163e$export$4a5061a17a8f71cf(payload)
                    }))();
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $cb048afe5138163e$export$97f2c8a7346cddbe({ payload: payload }) {
        try {
            yield (0, $aNOuE.put)((0, $5NIow.addPermission)(payload));
            const { id: planId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
            const body = {
                permission: {
                    permission: payload.permission,
                    holder: payload.holder
                },
                planId: planId
            };
            const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $4JEPY.urls).establish, {
                method: (0, $77QEM.POST),
                body: body
            });
            if (!response.ok) {
                const error = (0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response))));
                yield (0, $aNOuE.put)((0, $5NIow.removePermission)(payload));
                yield (0, $aNOuE.put)((0, $24CMK.httpRequestError)(response, error, {
                    method: (0, $77QEM.POST)
                }));
                return;
            }
            const { added: added } = yield (0, $aNOuE.call)(response.json.bind(response));
            if (!added.length) {
                yield (0, $aNOuE.put)((0, $5NIow.removePermission)(payload));
                throw (()=>({
                        message: $cb048afe5138163e$export$778f86d0002199a6(payload)
                    }))();
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $cb048afe5138163e$export$cdd82d420769a463({ payload: payload }) {
        try {
            if (payload.permission === 'EDIT') {
                const currentUser = yield (0, $aNOuE.select)((0, $6WWH1.getCurrentUser));
                const [[currentUserPermissions], permissions] = (0, parcelRequire("8r8wv")).default(({ holder: { key: key } })=>key === currentUser.key, (yield (0, $aNOuE.select)((0, $6WWH1.getPlanEditorPermissions))));
                yield (0, $aNOuE.all)(permissions.map((permission)=>(0, $aNOuE.call)($cb048afe5138163e$export$20993e109b0754be, {
                        type: $cb048afe5138163e$export$de33a2a8581dd543,
                        payload: {
                            ...permission,
                            permission: payload.permission
                        }
                    })));
                if (currentUserPermissions) yield (0, $aNOuE.call)($cb048afe5138163e$export$20993e109b0754be, {
                    type: $cb048afe5138163e$export$de33a2a8581dd543,
                    payload: {
                        ...currentUserPermissions,
                        permission: payload.permission
                    }
                });
            } else {
                const permissions = yield (0, $aNOuE.select)((0, $6WWH1.getPlanViewerPermissions));
                yield (0, $aNOuE.all)(permissions.map((permission)=>(0, $aNOuE.call)($cb048afe5138163e$export$20993e109b0754be, {
                        type: $cb048afe5138163e$export$de33a2a8581dd543,
                        payload: {
                            ...permission,
                            permission: payload.permission
                        }
                    })));
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $cb048afe5138163e$export$8452b742476a15ac() {
        try {
            const isReadOnlyMode = yield (0, $aNOuE.select)((0, $1CGdp.isReadOnly));
            if (!isReadOnlyMode) {
                yield (0, $aNOuE.put)((0, $5NIow.toggleFetchInProggress)(true));
                const { id: planId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
                if ((0, $4nDwW.isDefined)(planId)) {
                    const permissionsResponse = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $4JEPY.urls).get(planId), {
                        method: (0, $77QEM.GET),
                        profile: (0, $4JEPY.urls).get(':id')
                    });
                    if (permissionsResponse && permissionsResponse.ok) {
                        const { permissions: permissions } = yield (0, $aNOuE.call)(permissionsResponse.json.bind(permissionsResponse));
                        const userKeys = permissions.filter((p)=>p.holder.type === 'ACCOUNT_ID').map((p)=>p.holder.key);
                        if (userKeys.length) {
                            const users = yield (0, $aNOuE.call)((0, $8qbLi.getUsers), {
                                keys: userKeys
                            });
                            const enhancedPermissions = permissions.map((permission)=>{
                                const user = users.find((user)=>user.accountId === permission.accountId);
                                if (user) return {
                                    ...permission,
                                    email: user.email,
                                    avatarUrl: user.avatarUrl
                                };
                                return permission;
                            });
                            yield (0, $aNOuE.put)((0, $5NIow.setPermissions)(enhancedPermissions));
                        } else yield (0, $aNOuE.put)((0, $5NIow.setPermissions)(permissions));
                        yield (0, $aNOuE.put)((0, $5NIow.toggleFetchInProggress)(false));
                    } else if (permissionsResponse) {
                        const error = (0, $77QEM.parseError)(permissionsResponse, (yield (0, $aNOuE.call)(permissionsResponse.text.bind(permissionsResponse))));
                        yield (0, $aNOuE.put)((0, $24CMK.httpRequestError)(permissionsResponse, error, {
                            method: (0, $77QEM.GET)
                        }));
                    }
                }
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $cb048afe5138163e$export$8c75928f3cfbbaa2({ orgId: orgId, siteId: siteId }) {
        try {
            const teamPermissions = yield (0, $aNOuE.select)((0, $6WWH1.getTeamPermissions));
            if (!(0, $4nDwW.isDefined)(teamPermissions) || !(0, $4nDwW.isDefined)(teamPermissions.canViewTeams) || !(0, $4nDwW.isDefined)(teamPermissions.canCreateTeams)) {
                const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $4JEPY.urls).getTeamsPermissionV4(orgId, siteId ?? 'None'), {
                    method: (0, $77QEM.GET)
                });
                if (response.ok) {
                    const { permissions: permissions } = yield (0, $aNOuE.call)(response.json.bind(response));
                    yield (0, $aNOuE.put)((0, $5NIow.setTeamPermissions)({
                        canViewTeams: Array.isArray(permissions) && permissions.length > 0 && permissions.includes('CAN_VIEW_TEAMS'),
                        canCreateTeams: Array.isArray(permissions) && permissions.length > 0 && permissions.includes('CAN_CREATE_TEAMS')
                    }));
                } else {
                    const message = yield (0, $aNOuE.call)(response.text.bind(response));
                    throw new Error(`Failed to retrieve team permissions: ${message}`);
                }
            }
        } catch (e) {
            yield (0, $aNOuE.put)((0, $5NIow.setTeamPermissions)({
                canViewTeams: false,
                canCreateTeams: false
            }));
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
    function* $cb048afe5138163e$export$ff2e827105f76051() {
        yield (0, $6u3NN.takeEvery)($cb048afe5138163e$export$b9a6161393332468, $cb048afe5138163e$export$8452b742476a15ac);
    }
    function* $cb048afe5138163e$export$4a978780d71ec34c() {
        yield (0, $6u3NN.takeEvery)($cb048afe5138163e$export$de33a2a8581dd543, $cb048afe5138163e$export$20993e109b0754be);
    }
    function* $cb048afe5138163e$export$7d210b1b6e021c6f() {
        yield (0, $6u3NN.takeEvery)($cb048afe5138163e$export$fe39957c0d22d76b, $cb048afe5138163e$export$cdd82d420769a463);
    }
    function* $cb048afe5138163e$export$695e0c43372db94b() {
        yield (0, $6u3NN.takeEvery)($cb048afe5138163e$export$2158053a23d9487, $cb048afe5138163e$export$97f2c8a7346cddbe);
    }
    function* $cb048afe5138163e$export$77730714e7314625() {
        yield (0, $6u3NN.takeEvery)($cb048afe5138163e$export$42789425ce10f663, $cb048afe5138163e$export$8c75928f3cfbbaa2);
    }
    function* $cb048afe5138163e$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($cb048afe5138163e$export$ff2e827105f76051);
        yield (0, $aNOuE.fork)($cb048afe5138163e$export$695e0c43372db94b);
        yield (0, $aNOuE.fork)($cb048afe5138163e$export$4a978780d71ec34c);
        yield (0, $aNOuE.fork)($cb048afe5138163e$export$7d210b1b6e021c6f);
        yield (0, $aNOuE.fork)($cb048afe5138163e$export$77730714e7314625);
    }
});
parcelRegister("5NIow", function(module, exports) {
    $parcel$export(module.exports, "SET_PERMISSIONS", ()=>$0dcd0fc99d5555e3$export$2942bd9e290bbd66);
    $parcel$export(module.exports, "TOGGLE_FETCH_PLAN_PERMISSIONS_IN_PROGRESS", ()=>$0dcd0fc99d5555e3$export$f5e5b4f9add4f24f);
    $parcel$export(module.exports, "ADD_PERMISSION", ()=>$0dcd0fc99d5555e3$export$daea955f3c0bef8f);
    $parcel$export(module.exports, "REMOVE_PERMISSION", ()=>$0dcd0fc99d5555e3$export$10984e8384291f74);
    $parcel$export(module.exports, "SET_CURRENT_USER", ()=>$0dcd0fc99d5555e3$export$c6dfa1844d1d3b74);
    $parcel$export(module.exports, "SET_TEAM_PERMISSIONS", ()=>$0dcd0fc99d5555e3$export$1155c6bdb5740e0e);
    $parcel$export(module.exports, "setPermissions", ()=>$0dcd0fc99d5555e3$export$e4bd73c83a5e34e4);
    $parcel$export(module.exports, "toggleFetchInProggress", ()=>$0dcd0fc99d5555e3$export$3a1e7e56a0d004d4);
    $parcel$export(module.exports, "addPermission", ()=>$0dcd0fc99d5555e3$export$7a841ea48c61adb7);
    $parcel$export(module.exports, "removePermission", ()=>$0dcd0fc99d5555e3$export$15a6812353e636e4);
    $parcel$export(module.exports, "setTeamPermissions", ()=>$0dcd0fc99d5555e3$export$5cffc2df64325dce);
    const $0dcd0fc99d5555e3$export$2942bd9e290bbd66 = 'state.domain.permissions.SET_PERMISSIONS';
    const $0dcd0fc99d5555e3$export$f5e5b4f9add4f24f = 'state.domain.permissions.TOGGLE_FETCH_PLAN_PERMISSIONS_IN_PROGRESS';
    const $0dcd0fc99d5555e3$export$daea955f3c0bef8f = 'state.domain.permissions.ADD_PERMISSION';
    const $0dcd0fc99d5555e3$export$10984e8384291f74 = 'state.domain.permissions.REMOVE_PERMISSION';
    const $0dcd0fc99d5555e3$export$c6dfa1844d1d3b74 = 'state.domain.permissions.SET_CURRENT_USER';
    const $0dcd0fc99d5555e3$export$1155c6bdb5740e0e = 'state.domain.teams.SET_TEAM_PERMISSIONS';
    const $0dcd0fc99d5555e3$export$e4bd73c83a5e34e4 = (payload)=>({
            type: $0dcd0fc99d5555e3$export$2942bd9e290bbd66,
            payload: payload
        });
    const $0dcd0fc99d5555e3$export$3a1e7e56a0d004d4 = (payload)=>({
            type: $0dcd0fc99d5555e3$export$f5e5b4f9add4f24f,
            payload: payload
        });
    const $0dcd0fc99d5555e3$export$7a841ea48c61adb7 = (payload)=>({
            type: $0dcd0fc99d5555e3$export$daea955f3c0bef8f,
            payload: payload
        });
    const $0dcd0fc99d5555e3$export$15a6812353e636e4 = (payload)=>({
            type: $0dcd0fc99d5555e3$export$10984e8384291f74,
            payload: payload
        });
    const $0dcd0fc99d5555e3$export$64e99e757b084e7c = (payload)=>({
            type: $0dcd0fc99d5555e3$export$c6dfa1844d1d3b74,
            payload: payload
        });
    const $0dcd0fc99d5555e3$export$5cffc2df64325dce = (payload)=>({
            type: $0dcd0fc99d5555e3$export$1155c6bdb5740e0e,
            payload: payload
        });
});
parcelRegister("4JEPY", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$bc6a0057fbae6aab$export$bcae9ba627f604b6);
    const $bc6a0057fbae6aab$export$bcae9ba627f604b6 = {
        get: (id)=>`/rest/jpo/1.0/permissions/${id}`,
        establish: '/rest/jpo/1.0/permissions/establish',
        revoke: '/rest/jpo/1.0/permissions/revoke',
        getTeamsPermission: (orgId)=>`/gateway/api/v3/teams/permission/self/organization/${orgId}`,
        getTeamsPermissionV4: (orgId, siteId)=>`/gateway/api/v4/teams/permission/self/organization/${orgId}?siteId=${siteId}`
    };
});
parcelRegister("kLOUj", function(module, exports) {
    $parcel$export(module.exports, "getProjectsForIds", ()=>$019f5fda10db61ab$export$eb70922768388871);
    $parcel$export(module.exports, "default", ()=>$019f5fda10db61ab$export$2e2bcd8739ae039);
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $6u3NN = parcelRequire("6u3NN");
    var $jcw0u;
    var $4R6GH;
    var $8DSSe = parcelRequire("8DSSe");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $bHTqr = parcelRequire("bHTqr");
    var $k5Usd = parcelRequire("k5Usd");
    var $lKGSc = parcelRequire("lKGSc");
    var $bREsp = parcelRequire("bREsp");
    var $77QEM = parcelRequire("77QEM");
    var $24CMK = parcelRequire("24CMK");
    var $hvOzF = parcelRequire("hvOzF");
    var $8Tdiw = parcelRequire("8Tdiw");
    const $019f5fda10db61ab$var$GET_PROJECTS_FOR_IDS = 'command.project.GET_PROJECTS_FOR_IDS';
    const $019f5fda10db61ab$export$eb70922768388871 = (payload)=>({
            type: $019f5fda10db61ab$var$GET_PROJECTS_FOR_IDS,
            payload: payload
        });
    function* $019f5fda10db61ab$export$50d69cf9752fdea9({ payload: payload }) {
        const { id: planId, currentScenarioId: scenarioId } = yield (0, $aNOuE.select)((0, $bHTqr.getPlan));
        const body = {
            planId: planId,
            scenarioId: scenarioId,
            ids: payload
        };
        const response = yield (0, $aNOuE.call)((0, $8DSSe.default), (0, $8Tdiw.urls).projectInfoForIds, {
            method: 'POST',
            body: body
        });
        if (response.ok) {
            const projectInfoByIdResponse = yield (0, $aNOuE.call)(response.json.bind(response));
            const { projects: projects, issuePriorityInformation: issuePriorityInformation } = projectInfoByIdResponse;
            yield (0, $aNOuE.put)($lKGSc.add($bREsp.prepareProjects(projects, issuePriorityInformation)));
            yield (0, $aNOuE.put)($k5Usd.add(issuePriorityInformation.issuePriorities));
        } else if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_3')) {
            const error = new Error(response.text());
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: (0, $hvOzF.toErrorID)(error, 'do-get-project-info-for-ids-fetch-failed'),
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        } else yield (0, $aNOuE.put)((0, $24CMK.genericError)({
            ...(0, $77QEM.parseError)(response, (yield (0, $aNOuE.call)(response.text.bind(response)))),
            requestInfo: {
                url: (0, $8Tdiw.urls).projectInfoForIds,
                type: 'POST',
                status: response.status,
                body: body
            }
        }));
    }
    function* $019f5fda10db61ab$export$14e7ff07dd2407a3() {
        yield (0, $6u3NN.takeEvery)($019f5fda10db61ab$var$GET_PROJECTS_FOR_IDS, $019f5fda10db61ab$export$50d69cf9752fdea9);
    }
    function* $019f5fda10db61ab$export$2e2bcd8739ae039() {
        yield (0, $aNOuE.fork)($019f5fda10db61ab$export$14e7ff07dd2407a3);
    }
});
parcelRegister("k5Usd", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$bd4d45a92afb28fd$export$4a991c87e640ef77);
    $parcel$export(module.exports, "ADD", ()=>$bd4d45a92afb28fd$export$bb6389024b71c2ae);
    $parcel$export(module.exports, "reset", ()=>$bd4d45a92afb28fd$export$aad8462122ac592b);
    $parcel$export(module.exports, "add", ()=>$bd4d45a92afb28fd$export$e16d8520af44a096);
    const $bd4d45a92afb28fd$export$4a991c87e640ef77 = 'state.domain.issue-priorities.RESET';
    const $bd4d45a92afb28fd$export$bb6389024b71c2ae = 'state.domain.issue-priorities.ADD';
    const $bd4d45a92afb28fd$export$aad8462122ac592b = (payload)=>({
            type: $bd4d45a92afb28fd$export$4a991c87e640ef77,
            payload: payload
        });
    const $bd4d45a92afb28fd$export$e16d8520af44a096 = (payload)=>({
            type: $bd4d45a92afb28fd$export$bb6389024b71c2ae,
            payload: payload
        });
});
parcelRegister("8Tdiw", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$0840a7012f47d0d0$export$bcae9ba627f604b6);
    const $0840a7012f47d0d0$export$bcae9ba627f604b6 = {
        projectInfoForIds: '/rest/jpo/1.0/projects/info'
    };
});
parcelRegister("2jrtN", function(module, exports) {
    $parcel$export(module.exports, "populateReportersFromProfiles", ()=>$ef448d3016b1e8c2$export$f795a896e279d1d9);
    var $83IGl;
    parcelRequire("kUiRw");
    var $aNOuE = parcelRequire("aNOuE");
    var $2AO3f = parcelRequire("2AO3f");
    var $24CMK = parcelRequire("24CMK");
    function* $ef448d3016b1e8c2$export$f795a896e279d1d9(reporterProfiles) {
        try {
            const { domain: { issues: issues } } = yield (0, $aNOuE.select)((0, parcelRequire("83IGl")).default);
            const allPersonsMap = {};
            for (const reporter of Object.values(reporterProfiles))allPersonsMap[reporter.accountId] = {
                personId: reporter.accountId,
                jiraUser: reporter
            };
            const issueReporterMap = {};
            issues.forEach((issue)=>{
                if (issue.reporter) {
                    const reporterPerson = allPersonsMap[issue.reporter];
                    if (reporterPerson) issueReporterMap[issue.id] = reporterPerson;
                }
            });
            yield (0, $aNOuE.put)((0, $2AO3f.updateIssueReporterMap)(issueReporterMap));
        } catch (e) {
            yield (0, $aNOuE.put)((0, $24CMK.genericError)({
                message: e.message,
                stackTrace: e.stack
            }));
        }
    }
});
parcelRegister("2AO3f", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_ISSUE_REPORTER_MAP", ()=>$632fa5b1a291936b$export$23b774f011fb0045);
    $parcel$export(module.exports, "updateIssueReporterMap", ()=>$632fa5b1a291936b$export$8fe130820bc3f47e);
    const $632fa5b1a291936b$export$23b774f011fb0045 = 'state.domain.reporters.UPDATE_ISSUE_REPORTER_MAP';
    const $632fa5b1a291936b$export$8fe130820bc3f47e = (payload)=>({
            type: $632fa5b1a291936b$export$23b774f011fb0045,
            payload: payload
        });
});
parcelRegister("cIN1f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2bb72203fd075ed7$export$2e2bcd8739ae039);
    var $8EB5I;
    var $aqDY3 = parcelRequire("aqDY3");
    var $kWDpn = parcelRequire("kWDpn");
    var $7QGzp = parcelRequire("7QGzp");
    var $5TMug = parcelRequire("5TMug");
    function $2bb72203fd075ed7$export$2e2bcd8739ae039(store) {
        const observer = ()=>{
            const state = store.getState();
            const activeView = (0, $7QGzp.getActiveView)(state);
            if (!activeView) return;
            const preferences = (0, $kWDpn.getViewSettings)(state);
            if ((0, parcelRequire("8EB5I")).default(preferences, activeView.preferences)) return;
            store.dispatch((0, $aqDY3.modifyView)({
                id: activeView.id,
                preferences: preferences
            }));
        };
        return store.subscribe((0, $5TMug.relaxedScheduler)(observer));
    }
});
parcelRegister("5TMug", function(module, exports) {
    $parcel$export(module.exports, "makeRelationsMap", ()=>$bc30a8b348ee42c3$export$28b13bfc110f7aa);
    $parcel$export(module.exports, "relaxedScheduler", ()=>$bc30a8b348ee42c3$export$d999bead76c31bfe);
    const $bc30a8b348ee42c3$export$28b13bfc110f7aa = ()=>({
            issueType: new Set(),
            project: new Set(),
            sprint: new Set(),
            version: new Set()
        });
    const $bc30a8b348ee42c3$export$d999bead76c31bfe = (callback)=>{
        let executionTime = 25;
        const requestCallback = window.requestIdleCallback || ((f)=>setTimeout(f, 2 * executionTime));
        let isScheduled = false;
        let scheduleNextCall = false;
        let wrapper;
        const schedule = ()=>{
            isScheduled = true;
            requestCallback(wrapper);
        };
        wrapper = ()=>{
            isScheduled = false;
            const startMark = performance.now();
            callback();
            executionTime = performance.now() - startMark;
            if (scheduleNextCall) {
                scheduleNextCall = false;
                schedule();
            }
        };
        return ()=>{
            if (scheduleNextCall) return;
            if (isScheduled) {
                scheduleNextCall = true;
                return;
            }
            schedule();
        };
    };
});
parcelRegister("a3uQu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b00d28ba841aba40$export$2e2bcd8739ae039);
    var $d3uMD = parcelRequire("d3uMD");
    var $kLOUj = parcelRequire("kLOUj");
    var $bIaKQ = parcelRequire("bIaKQ");
    var $cukx3 = parcelRequire("cukx3");
    var $kllqP = parcelRequire("kllqP");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $d3quy = parcelRequire("d3quy");
    var $9FFuD = parcelRequire("9FFuD");
    var $5TMug = parcelRequire("5TMug");
    const $b00d28ba841aba40$var$requestActionCreators = {
        issueType: (0, $d3uMD.getIssueTypesForIds),
        project: (0, $kLOUj.getProjectsForIds),
        sprint: (0, $bIaKQ.getSprintsForIds),
        version: (0, $cukx3.getReleasesForIds)
    };
    const $b00d28ba841aba40$export$646c2b2ed0073599 = (check, entities, typeToAttributes)=>{
        for (const entity of entities)for (const type of Object.keys(typeToAttributes)){
            const attributes = [].concat(typeToAttributes[type]);
            for (const attribute of attributes){
                const id = entity[attribute];
                if (Array.isArray(id)) id.forEach((id)=>check(type, id));
                else check(type, id);
            }
        }
    };
    const $b00d28ba841aba40$var$createObserver = (store)=>{
        const resolvedRelations = (0, $5TMug.makeRelationsMap)();
        const observer = ()=>{
            const state = store.getState();
            const lookup = {
                issueType: (0, $kllqP.getIssueTypesById)(state),
                project: (0, $jpXKt.getProjectsById)(state),
                sprint: (0, $d3quy.getAllSprintsIncludingDisabledByIdMap)(state),
                version: (0, $9FFuD.getVersionsById)(state)
            };
            const unresolvedRelations = (0, $5TMug.makeRelationsMap)();
            const track = (type, id)=>{
                unresolvedRelations[type].add(id);
                resolvedRelations[type].add(id);
            };
            const check = (type, id)=>{
                const lookupValue = lookup[type][id];
                if (id && !(lookupValue || resolvedRelations[type].has(id))) track(type, id);
            };
            $b00d28ba841aba40$export$646c2b2ed0073599(check, (0, $gFhwb.getAllIssues)(state), {
                project: 'project',
                issueType: 'type',
                sprint: [
                    'sprint',
                    'completedSprints'
                ],
                version: 'fixVersions'
            });
            for (const type of Object.keys(unresolvedRelations)){
                const ids = unresolvedRelations[type];
                if (ids.size > 0) store.dispatch($b00d28ba841aba40$var$requestActionCreators[type]([
                    ...ids
                ]));
            }
        };
        return store.subscribe((0, $5TMug.relaxedScheduler)(observer));
    };
    var $b00d28ba841aba40$export$2e2bcd8739ae039 = $b00d28ba841aba40$var$createObserver;
});
parcelRegister("9L0go", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea97802ef7e2a232$export$2e2bcd8739ae039);
    var $7vqYD = parcelRequire("7vqYD");
    var $5TMug = parcelRequire("5TMug");
    const $ea97802ef7e2a232$var$createObserver = (store)=>{
        let currentState;
        const observer = ()=>{
            const previousState = currentState;
            currentState = store.getState();
            if (!previousState) store.dispatch((0, $7vqYD.setValidity)(false));
            else if (currentState.domain.solution.isValid) {
                if (previousState.domain.sequence !== currentState.domain.sequence || previousState.domain.plan !== currentState.domain.plan || previousState.ui.Main.Tabs.Roadmap.Scope.Issues.selected !== currentState.ui.Main.Tabs.Roadmap.Scope.Issues.selected) store.dispatch((0, $7vqYD.setValidity)(false));
            }
        };
        return store.subscribe((0, $5TMug.relaxedScheduler)(observer));
    };
    var $ea97802ef7e2a232$export$2e2bcd8739ae039 = $ea97802ef7e2a232$var$createObserver;
});
parcelRegister("c446i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15dfd2795171b13b$export$2e2bcd8739ae039);
    var $cDeeP;
    var $8EB5I;
    var $9U6ZH;
    var $4wiYB;
    var $fZhYM;
    var $2rMKg;
    var $sqeVT;
    var $b8GVJ;
    var $4R6GH;
    var $aipk9;
    var $nXNNJ;
    var $khIwz;
    var $c0cft = parcelRequire("c0cft");
    var $i2qlb = parcelRequire("i2qlb");
    var $knys8 = parcelRequire("knys8");
    var $b0D0x = parcelRequire("b0D0x");
    var $f8C8L = parcelRequire("f8C8L");
    var $atnIT = parcelRequire("atnIT");
    var $5eMyh = parcelRequire("5eMyh");
    var $gIlW4 = parcelRequire("gIlW4");
    var $kX5YK = parcelRequire("kX5YK");
    var $1CGdp = parcelRequire("1CGdp");
    var $jw86H = parcelRequire("jw86H");
    var $19iju = parcelRequire("19iju");
    var $iIikD = parcelRequire("iIikD");
    var $ddv1K = parcelRequire("ddv1K");
    var $kllqP = parcelRequire("kllqP");
    var $bI9dZ = parcelRequire("bI9dZ");
    var $bHTqr = parcelRequire("bHTqr");
    var $jpXKt = parcelRequire("jpXKt");
    var $gFhwb = parcelRequire("gFhwb");
    var $ja8Lc = parcelRequire("ja8Lc");
    var $d3quy = parcelRequire("d3quy");
    var $jpgxP = parcelRequire("jpgxP");
    var $60TfX = parcelRequire("60TfX");
    var $dRVQG = parcelRequire("dRVQG");
    var $jAIJh = parcelRequire("jAIJh");
    var $faayJ = parcelRequire("faayJ");
    var $25viM = parcelRequire("25viM");
    var $cyGmD = parcelRequire("cyGmD");
    var $9FFuD = parcelRequire("9FFuD");
    var $kWDpn = parcelRequire("kWDpn");
    var $7QGzp = parcelRequire("7QGzp");
    var $j0XCX = parcelRequire("j0XCX");
    var $jK6Qc = parcelRequire("jK6Qc");
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $30sno = parcelRequire("30sno");
    var $8zOmE;
    var $fP57B = parcelRequire("fP57B");
    var $jNv9f = parcelRequire("jNv9f");
    var $ebcEl = parcelRequire("ebcEl");
    var $4ArTT = parcelRequire("4ArTT");
    var $lIIFg = parcelRequire("lIIFg");
    var $eiyR0 = parcelRequire("eiyR0");
    var $cGbfF = parcelRequire("cGbfF");
    var $21mdo = parcelRequire("21mdo");
    var $j33D0 = parcelRequire("j33D0");
    var $dBbgF = parcelRequire("dBbgF");
    var $3t3Pr = parcelRequire("3t3Pr");
    var $23472 = parcelRequire("23472");
    var $aoVGF = parcelRequire("aoVGF");
    var $dFbEI = parcelRequire("dFbEI");
    var $87fK4 = parcelRequire("87fK4");
    const $15dfd2795171b13b$var$changesOfType = (changes, selectedChanges, scenarioType)=>{
        const changesById = (0, $4nDwW.indexBy)((0, parcelRequire("2rMKg")).default('id'), changes);
        return selectedChanges.filter((id)=>changesById[id].metaData.scenarioType === scenarioType).length;
    };
    const $15dfd2795171b13b$var$typeOfCustomField = (field)=>{
        const fieldKey = field && (0, parcelRequire("fZhYM")).default([
            'type',
            'key'
        ], field);
        const fieldType = fieldKey && fieldKey.split(':')[1] || '';
        return `customfield_${fieldType}`;
    };
    const $15dfd2795171b13b$var$filterSourceMap = {
        '#plan/backlog': (0, $cGbfF.ROADMAP_FILTER_SOURCE),
        '#plan/releases': (0, $cGbfF.RELEASE_FILTER_SOURCE)
    };
    const $15dfd2795171b13b$var$isPredefined = (view)=>!(0, $4nDwW.isDefined)(view.createdBy) && !(0, $4nDwW.isDefined)(view.updatedBy);
    const $15dfd2795171b13b$var$handleAnalyticsError = (analyticsArgs)=>(action)=>{
            try {
                return analyticsArgs(action);
            } catch (error) {
                (0, $87fK4.logAnalyticsError)(error, `analytics failed in ${action.type}`);
            }
        };
    class $15dfd2795171b13b$var$AnalyticsMiddleware {
        constructor(){
            this.apply = (store)=>(next)=>$15dfd2795171b13b$var$handleAnalyticsError((action)=>{
                        switch(action.type){
                            case 0, $fP57B.AFTER_RESET_BACKLOG:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const dependencyCount = (0, $4nDwW.valuesKeysLength)(state.domain.issueLinks.values);
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).RESET_BACKLOG.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).RESET_BACKLOG, {
                                            dependencyCount: dependencyCount
                                        });
                                    }
                                    break;
                                }
                            case 0, $f8C8L.BEFORE_APPLY_CHANGE:
                                this.applyChangeTimer = new (0, (0, parcelRequire("khIwz")).default)();
                                this.applyChangeTimer.start();
                                break;
                            case 0, $f8C8L.AFTER_APPLY_CHANGE:
                                if ((0, $4nDwW.isDefined)(this.applyChangeTimer) && this.applyChangeTimer.isStarted() && !this.applyChangeTimer.isStopped()) {
                                    this.applyChangeTimer.stop();
                                    const state = store.getState();
                                    const { id: planId } = (0, $bHTqr.getPlan)(state);
                                    if ((0, $4nDwW.isDefined)(planId)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_ACCEPT_OPTIMIZATION.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            totalTimeInMillis: this.applyChangeTimer.duration()
                                        });
                                    }
                                }
                                break;
                            case 0, $f8C8L.BEFORE_OPTIMIZE_CALCULATION:
                                this.optimizeCalculationTimer = new (0, (0, parcelRequire("khIwz")).default)();
                                this.optimizeCalculationTimer.start();
                                break;
                            case 0, $f8C8L.AFTER_OPTIMIZE_CALCULATION:
                                {
                                    const afterOptimizeCalculationAction = action;
                                    if ((0, $4nDwW.isDefined)(this.optimizeCalculationTimer) && this.optimizeCalculationTimer.isStarted() && !this.optimizeCalculationTimer.isStopped()) {
                                        this.optimizeCalculationTimer.stop();
                                        const state = store.getState();
                                        const { id: planId } = (0, $bHTqr.getPlan)(state);
                                        if ((0, $4nDwW.isDefined)(planId)) {
                                            const selectedIssues = (0, $bI9dZ.getSelectedIssues)(state);
                                            (0, $c0cft.default).triggerCalculationDurationAnalytics(afterOptimizeCalculationAction.meta.analyticsEvent, {
                                                totalTimeInMillis: this.optimizeCalculationTimer.duration(),
                                                isSelectiveScheduling: selectedIssues.length > 0
                                            });
                                        }
                                    }
                                    break;
                                }
                            case 0, $kX5YK.COMMIT_CHANGES:
                                {
                                    const commitChangesAction = action;
                                    const state = store.getState();
                                    const countForGoals = (0, $25viM.getCountForGoals)(state);
                                    if (countForGoals.numGoalsRemoved || countForGoals.numGoalsAdded) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'goals updated', {
                                            source: 'Plans',
                                            ...countForGoals
                                        });
                                    }
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const teamsData = state.domain.teams;
                                    const versionChanges = (0, $9FFuD.getVersionChanges)(state);
                                    const crossProjectVersionChanges = (0, $jw86H.getCrossProjectVersionChanges)(state);
                                    const selectedChanges = (0, $25viM.getSelectedChanges)(state);
                                    const selectedVersionChanges = selectedChanges[(0, $TTKUQ.ENTITY).RELEASE];
                                    const selectedCrossProjectVersionChanges = selectedChanges[(0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE];
                                    const changedAttributeCounts = (0, $bI9dZ.getIssueAttributeChangeCounts)(state);
                                    const createdIssueCount = (0, $bI9dZ.getCreatedIssueCount)(state);
                                    const countForStatusCategory = (0, $25viM.getCountForStatusCategory)(state);
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) (0, $c0cft.default).triggerUpdateJiraEventAnalytics(commitChangesAction.meta.analyticsEvent, {
                                        teamCreateCount: teamsData.filter((team)=>team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED).length,
                                        teamUpdateCount: teamsData.filter((team)=>team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).UPDATED).length,
                                        versionCreateCount: $15dfd2795171b13b$var$changesOfType(versionChanges, selectedVersionChanges, (0, $TTKUQ.SCENARIO_TYPE).ADDED),
                                        versionUpdateCount: $15dfd2795171b13b$var$changesOfType(versionChanges, selectedVersionChanges, (0, $TTKUQ.SCENARIO_TYPE).UPDATED),
                                        versionRemoveCount: $15dfd2795171b13b$var$changesOfType(versionChanges, selectedVersionChanges, (0, $TTKUQ.SCENARIO_TYPE).DELETED),
                                        versionCPRCreateCount: $15dfd2795171b13b$var$changesOfType(crossProjectVersionChanges, selectedCrossProjectVersionChanges, (0, $TTKUQ.SCENARIO_TYPE).ADDED),
                                        versionCPRUpdateCount: $15dfd2795171b13b$var$changesOfType(crossProjectVersionChanges, selectedCrossProjectVersionChanges, (0, $TTKUQ.SCENARIO_TYPE).UPDATED),
                                        versionCPRRemoveCount: $15dfd2795171b13b$var$changesOfType(crossProjectVersionChanges, selectedCrossProjectVersionChanges, (0, $TTKUQ.SCENARIO_TYPE).DELETED),
                                        issueCreateCount: createdIssueCount,
                                        assigneeChangeCount: changedAttributeCounts.assignee || 0,
                                        baselineStartChangeCount: changedAttributeCounts.baselineStart || 0,
                                        baselineEndChangeCount: changedAttributeCounts.baselineEnd || 0,
                                        customFieldChangeCount: changedAttributeCounts.customField || 0,
                                        dueDateChangeCount: changedAttributeCounts.dueDate || 0,
                                        fixVersionsChangeCount: changedAttributeCounts.fixVersions || 0,
                                        labelsChangeCount: changedAttributeCounts.labels || 0,
                                        lexoRankChangeCount: changedAttributeCounts.lexoRank || 0,
                                        parentChangeCount: changedAttributeCounts.parent || 0,
                                        priorityChangeCount: changedAttributeCounts.priority || 0,
                                        sprintChangeCount: changedAttributeCounts.sprint || 0,
                                        storyPointsChangeCount: changedAttributeCounts.storyPoints || 0,
                                        summaryChangeCount: changedAttributeCounts.summary || 0,
                                        descriptionChangeCount: changedAttributeCounts.description || 0,
                                        teamChangeCount: changedAttributeCounts.team || 0,
                                        componentsChangeCount: changedAttributeCounts.components || 0,
                                        countForStatusCategory: countForStatusCategory
                                    });
                                    break;
                                }
                            case 0, $74616ed8f6aff060$export$242fccfb90c57247:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_ISSUE.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        const addAction = action;
                                        const attributes = (0, $87fK4.getIssueAnalyticAttributes)(addAction.payload.issue, (0, $kllqP.getIssueTypesById)(state), (0, $jpXKt.getProjectsById)(state), {});
                                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_ISSUE, attributes);
                                    }
                                    break;
                                }
                            case 0, $74616ed8f6aff060$export$b6c322dbc4f2f8ac:
                                {
                                    const state = store.getState();
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const selectedIssues = (0, $bI9dZ.getSelectedIssues)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_ISSUES.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    const bulkUpdateAction = action;
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        if (bulkUpdateAction.payload && bulkUpdateAction.payload.parent) {
                                            const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REPARENT_ISSUES.split(' ');
                                            analyticsEvent.update({
                                                action: eventAction,
                                                actionSubject: actionSubject
                                            });
                                        }
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            issueCount: selectedIssues.length,
                                            attributes: Object.keys(bulkUpdateAction.payload).filter((key)=>key !== 'id')
                                        });
                                    }
                                    break;
                                }
                            case 0, $74616ed8f6aff060$export$d46fd8e9a2a59b28:
                                {
                                    const state = store.getState();
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_ISSUE.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    const updateAction = action;
                                    const issue = (0, $gFhwb.getIssueMapById)(state)[updateAction.payload.id];
                                    const updatedFields = Object.keys(updateAction.payload).filter((key)=>key !== 'id');
                                    const attributes = (0, $87fK4.getIssueAnalyticAttributes)(issue, (0, $kllqP.getIssueTypesById)(state), (0, $jpXKt.getProjectsById)(state), {
                                        updatedFields: updatedFields
                                    });
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
                                    break;
                                }
                            case 0, $74616ed8f6aff060$export$9bbbeac0bf5bf14:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const rankAction = action;
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const issueId = rankAction.payload.itemKeys[0];
                                        const issue = (0, $gFhwb.getIssueMapById)(state)[issueId];
                                        const attributes = (0, $87fK4.getIssueAnalyticAttributes)(issue, (0, $kllqP.getIssueTypesById)(state), (0, $jpXKt.getProjectsById)(state), {
                                            method: 'dragged'
                                        });
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).RANK_ISSUE.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).RANK_ISSUE, attributes);
                                    }
                                    break;
                                }
                            case 0, $5eMyh.VIEW_ROADMAP:
                                {
                                    const state = store.getState();
                                    if ((0, $1CGdp.isExportMode)(state)) break;
                                    const viewRoadmapAction = action;
                                    const autoSchedulerEnabled = (0, $bHTqr.getAutoSchedulerEnabled)(state);
                                    const { id: planId, currentScenarioId: scenarioId, isSamplePlan: isSamplePlan } = (0, $bHTqr.getPlan)(state);
                                    const planningUnit = (0, $bHTqr.getPlanningUnit)(state);
                                    const customFields = (0, $19iju.getCustomFields)(state);
                                    const group = (0, $30sno.getGroupForAnalyticEvent)((0, $kWDpn.getVisualisationViewSettings)(state).grouping, customFields);
                                    const sorting = (0, $kWDpn.getVisualisationViewSettings)(state).sorting;
                                    const sortingField = (0, $ja8Lc.getFieldKey)(sorting.field, planningUnit);
                                    const sortByField = sorting.isCustomField ? `customfield_${sorting.type}` : sortingField;
                                    const showSprints = (0, $kWDpn.getVisualisationViewSettings)(state).showSprints;
                                    const showWarnings = (0, $kWDpn.getWarningViewSettings)(state).showWarning;
                                    const rollupSettings = (0, $kWDpn.getRollupViewSettings)(state);
                                    let colourBy = (0, $j0XCX.getColorByValue)(state);
                                    if ((0, $j0XCX.isColorByCustomFieldOption)(colourBy)) {
                                        const customFieldsById = (0, $19iju.getCustomFieldsById)(state);
                                        const CFTypeKey = customFieldsById[colourBy]?.type?.key;
                                        const CFTypeName = (0, $dFbEI.CustomFieldTypeNameMap)[CFTypeKey];
                                        colourBy = CFTypeName || (0, $dFbEI.CustomFieldTypeNameMap).default;
                                    }
                                    const colours = (0, $87fK4.getColoursUsedInPlan)((0, $kWDpn.getColorByViewSettings)(state));
                                    const existingTeams = state.domain.teams.filter((team)=>team.scenarioType !== 'DELETED');
                                    const teamsScrumCount = existingTeams.filter((team)=>team.schedulingMode === 'Scrum').length;
                                    const teamsKanbanCount = existingTeams.filter((team)=>team.schedulingMode === 'Kanban').length;
                                    const teamsSharedCount = existingTeams.filter((team)=>team.shareable).length;
                                    const projectsShownInPlan = (0, $bHTqr.getIssueSources)(state).filter((source)=>source.type === 'Project').map((project)=>Number(project.value));
                                    const boardsShownInPlan = (0, $bHTqr.getIssueSources)(state).filter((source)=>source.type === 'Board').map((board)=>Number(board.value));
                                    const filtersShownInPlan = (0, $bHTqr.getIssueSources)(state).filter((source)=>source.type === 'Filter').map((filter)=>Number(filter.value));
                                    const sourcesTotalCount = (0, $bHTqr.getIssueSources)(state).length;
                                    const sourcesBoardCount = boardsShownInPlan.length;
                                    const sourcesProjectCount = projectsShownInPlan.length;
                                    const sourcesFilterCount = filtersShownInPlan.length;
                                    const planPermission = (0, $1CGdp.getPlanUserRole)(state);
                                    const instancePermission = (0, $jpgxP.getInstanceUserRole)(state);
                                    const { active: sprintActiveCount, future: sprintFutureCount, sprintFutureSetDates: sprintFutureSetDatesCount, sprintFutureInferredDates: sprintFutureInferredDatesCount } = (0, $87fK4.countFutureSprintDates)(state.domain.sprints);
                                    const { issuesWithFixedStartDateCount: issuesWithFixedStartDateCount, issuesWithFixedEndDateCount: issuesWithFixedEndDateCount, issuesWithSprintStartDateCount: issuesWithSprintStartDateCount, issuesWithSprintEndDateCount: issuesWithSprintEndDateCount, issuesWithReleaseStartDateCount: issuesWithReleaseStartDateCount, issuesWithReleaseEndDateCount: issuesWithReleaseEndDateCount } = (0, $87fK4.countIssueInferredDates)(state.domain.plan, state.domain.issues, state.domain.versions);
                                    const fieldColumns = (0, $kWDpn.getFieldColumnsViewSettingsByViewMode)(state).columns.filter((field)=>field.isVisible).map((field)=>field.id);
                                    const issuesCount = (0, $gFhwb.getAllIssues)(state).length;
                                    const dependenciesCount = (0, $ddv1K.getUniqueLinks)(state).length;
                                    const dependencySettings = (0, $kWDpn.getDependencySettings)(state);
                                    const dependencySettingsDisplay = dependencySettings ? dependencySettings.display : '';
                                    const planCreatedTimestamp = (0, $bHTqr.getCreatedTimestamp)(state) || 0;
                                    const planCreatedDate = (0, (0, parcelRequire("aipk9")).formatDateUTC)(planCreatedTimestamp * 1000, 'YYYY-MM-DD HH:mm:ss');
                                    const allTeams = (0, $dRVQG.getAllTeams)(state);
                                    const teamsShownInPlan = allTeams.map(({ id: id })=>Number(id));
                                    const externalTeams = (0, $dRVQG.getAdditionalTeams)(state);
                                    const multiScenarioEnabled = !!(0, $bHTqr.isMultiScenarioEnabled)(state);
                                    const scenarios = (0, $bHTqr.getPlanScenarios)(state);
                                    const scenariosCount = scenarios?.length || 1;
                                    const { selectedFilters: selectedFilters, hierarchyLevels: hierarchyLevels } = (0, $iIikD.getFiltersAndHierarchyLevelsForAnalytics)(state);
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const customDateRange = (0, $kWDpn.getTimeScaleViewSettings)(state).customDateRange || {};
                                        const zoomLevel = (0, $jAIJh.getZoomLevel)(state);
                                        const { timelineType: timelineType, customTimelineType: customTimelineType } = (0, $87fK4.getTimelineAttributes)(customDateRange, zoomLevel);
                                        const views = (0, $7QGzp.getViews)(state);
                                        const viewsInPlanCount = views.length;
                                        const viewsWithDependencyBadgesCount = views.filter((view)=>view.preferences.dependencySettingsV0.display === 'default').length;
                                        const viewsWithDependencyLinesCount = views.filter((view)=>view.preferences.dependencySettingsV0.display === 'lines').length;
                                        const viewsWithDependencyCountCount = views.filter((view)=>view.preferences.dependencySettingsV0.display === 'count').length;
                                        const projects = (0, $jpXKt.getProjects)(state);
                                        const projectsByType = (0, parcelRequire("4wiYB")).default((0, parcelRequire("b8GVJ")).default([
                                            'projectTypeKey',
                                            'isSimplified'
                                        ]), projects);
                                        const sourcesProjectCountJswCmpCount = projectsByType[`${(0, $TTKUQ.PROJECT_TYPE_KEY).SOFTWARE},false`]?.length ?? 0;
                                        const sourcesProjectCountJswTmpCount = projectsByType[`${(0, $TTKUQ.PROJECT_TYPE_KEY).SOFTWARE},true`]?.length ?? 0;
                                        const sourcesProjectCountJwmCmpCount = projectsByType[`${(0, $TTKUQ.PROJECT_TYPE_KEY).WORK_MANAGEMENT},false`]?.length ?? 0;
                                        const sourcesProjectCountJwmTmpCount = projectsByType[`${(0, $TTKUQ.PROJECT_TYPE_KEY).WORK_MANAGEMENT},true`]?.length ?? 0;
                                        const sourcesProjectCountJsmCmpCount = projectsByType[`${(0, $TTKUQ.PROJECT_TYPE_KEY).SERVICE_MANAGEMENT},false`]?.length ?? 0;
                                        const sourcesProjectCountCmpCount = sourcesProjectCountJswCmpCount + sourcesProjectCountJwmCmpCount + sourcesProjectCountJsmCmpCount;
                                        const sourcesProjectCountTmpCount = sourcesProjectCountJswTmpCount + sourcesProjectCountJwmTmpCount;
                                        const fiscalMonth = (0, $jpgxP.getFiscalMonth)(state);
                                        const hasSprintsWithInconsistentDates = (0, $d3quy.getSprintIdsWithDatesIsInconsistent)(state).length > 0;
                                        const hasAtlasPermissions = (0, $jpgxP.getHasAtlasPermissions)(state);
                                        const isAtlasConnectInstalled = (0, $jpgxP.isAtlasConnectInstalledSystem)(state);
                                        const tagTableItems = (0, $jK6Qc.getTagTableItems)(state);
                                        const rowHeights = tagTableItems.map((tableItem)=>tableItem.height || 1);
                                        const maxOverlappingSprints = Math.max(...rowHeights, 0);
                                        const viewMode = (0, $kWDpn.getViewMode)(state);
                                        const urlPersistenceEstimate = (0, (0, parcelRequire("4R6GH")).fg)('plans_-_url_persistence_estimates') ? (0, $cyGmD.getUrlPersistenceEstimate)(state) : undefined;
                                        const isMacroProxy = (0, $1CGdp.isConfluenceMacroProxy)(state);
                                        (0, $c0cft.default).triggerViewRoadmapEventAnalytics(viewRoadmapAction.meta.analyticsEvent, group, colourBy, colours, sortByField, existingTeams.length, teamsScrumCount, teamsKanbanCount, teamsSharedCount, externalTeams.length, sourcesTotalCount, sourcesBoardCount, sourcesProjectCount, sourcesFilterCount, rollupSettings, showSprints, showWarnings, planPermission, instancePermission, planningUnit, sprintActiveCount, sprintFutureCount, sprintFutureSetDatesCount, sprintFutureInferredDatesCount, hasSprintsWithInconsistentDates, hasAtlasPermissions, isAtlasConnectInstalled, timelineType, customTimelineType, fieldColumns, issuesCount, dependenciesCount, dependencySettingsDisplay, issuesWithFixedStartDateCount, issuesWithFixedEndDateCount, issuesWithSprintStartDateCount, issuesWithSprintEndDateCount, issuesWithReleaseStartDateCount, issuesWithReleaseEndDateCount, viewsInPlanCount, viewsWithDependencyBadgesCount, viewsWithDependencyLinesCount, viewsWithDependencyCountCount, planCreatedDate, teamsShownInPlan, projectsShownInPlan, boardsShownInPlan, filtersShownInPlan, sourcesProjectCountJswCmpCount, sourcesProjectCountJswTmpCount, sourcesProjectCountJwmCmpCount, sourcesProjectCountJwmTmpCount, sourcesProjectCountJsmCmpCount, sourcesProjectCountCmpCount, sourcesProjectCountTmpCount, multiScenarioEnabled, scenariosCount, hierarchyLevels, selectedFilters, isSamplePlan, maxOverlappingSprints, autoSchedulerEnabled, fiscalMonth, viewMode, urlPersistenceEstimate, isMacroProxy);
                                    }
                                    break;
                                }
                            case 0, $74616ed8f6aff060$export$20130dbd048fc414:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const expandAllAnalyticsAction = action;
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).EXPANDED_ALL_ISSUES.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            hierarchyLevels: expandAllAnalyticsAction.payload.hierarchyLevels
                                        });
                                    }
                                    break;
                                }
                            case 0, $74616ed8f6aff060$export$39babeb2e7944629:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const collapseAllAnalyticsAction = action;
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).COLLAPSED_ALL_ISSUES.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            hierarchyLevels: collapseAllAnalyticsAction.payload.hierarchyLevels
                                        });
                                    }
                                    break;
                                }
                            case 0, $eiyR0.UPDATE:
                                {
                                    const state = store.getState();
                                    const filterChangeAction = action;
                                    const customFieldId = filterChangeAction.payload.customField.id;
                                    const nextFilterValue = filterChangeAction.payload.value;
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_FILTER.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    let source = '';
                                    if (typeof window !== 'undefined') {
                                        const { hash: hash } = window.location;
                                        source = $15dfd2795171b13b$var$filterSourceMap[hash];
                                    }
                                    const filterValue = (0, parcelRequire("fZhYM")).default([
                                        (0, $cGbfF.CUSTOM_FIELD_FILTER_ID),
                                        `${customFieldId}`
                                    ], (0, $iIikD.getRawFilters)(state));
                                    const addition = (0, parcelRequire("cDeeP")).default(nextFilterValue || [], filterValue || []);
                                    const addedOrRemoved = addition.length > 0 ? 1 : 0;
                                    const itemCount = nextFilterValue.length;
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        filterID: (0, $cGbfF.CUSTOM_FIELD_FILTER_ID),
                                        plan: (0, $c0cft.context).PLAN,
                                        source: source,
                                        addedOrRemoved: addedOrRemoved,
                                        itemCount: itemCount,
                                        customFieldType: filterChangeAction.payload.customField.type.key
                                    });
                                    break;
                                }
                            case 0, $eiyR0.CLEAR:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_FILTER.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        let source = '';
                                        if (typeof window !== 'undefined') {
                                            const { hash: hash } = window.location;
                                            source = $15dfd2795171b13b$var$filterSourceMap[hash];
                                        }
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            planId: planId,
                                            scenarioId: scenarioId,
                                            filterID: (0, $cGbfF.CUSTOM_FIELD_FILTER_ID),
                                            plan: (0, $c0cft.context).PLAN,
                                            source: source,
                                            addedOrRemoved: 0,
                                            itemCount: 0
                                        });
                                    }
                                    break;
                                }
                            case 0, $lIIFg.CHANGE:
                                {
                                    if (action.bypassAnalytics) break;
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const filterChangeAction = action;
                                    const filterID = filterChangeAction.payload.id;
                                    const currentRawFilters = (0, $iIikD.getRawFilters)(state);
                                    const currentRawFilter = currentRawFilters[filterID];
                                    const filterValue = currentRawFilter && currentRawFilter.value;
                                    const nextFilterValue = filterChangeAction.payload.value;
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_FILTER.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if (!this.ignoredFilterIds.includes(filterID)) {
                                        let addedOrRemoved = 0;
                                        let itemCount = 0;
                                        let source = '';
                                        if (typeof window !== 'undefined') {
                                            const { hash: hash } = window.location;
                                            source = $15dfd2795171b13b$var$filterSourceMap[hash];
                                        }
                                        if (filterID === (0, $cGbfF.SUMMARY_FILTER_ID)) {
                                            if (nextFilterValue === '') {
                                                addedOrRemoved = 0;
                                                itemCount = 0;
                                            } else {
                                                addedOrRemoved = 1;
                                                itemCount = 1;
                                            }
                                        } else if (filterID === (0, $cGbfF.DEPENDENCIES_FILTER_ID) && typeof nextFilterValue === 'object' && 'type' in nextFilterValue) addedOrRemoved = filterValue && nextFilterValue.type === 'off' ? 0 : 1;
                                        else {
                                            const addition = (0, parcelRequire("cDeeP")).default(nextFilterValue || [], filterValue || []);
                                            addedOrRemoved = addition.length > 0 ? 1 : 0;
                                            itemCount = nextFilterValue.length;
                                        }
                                        if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            planId: planId,
                                            scenarioId: scenarioId,
                                            filterID: filterID,
                                            plan: (0, $c0cft.context).PLAN,
                                            source: source,
                                            addedOrRemoved: addedOrRemoved,
                                            itemCount: itemCount
                                        });
                                    }
                                    break;
                                }
                            case 0, $lIIFg.CLEAR_ALL:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLEAR_FILTERS.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        let source = '';
                                        if (typeof window !== 'undefined') {
                                            const { hash: hash } = window.location;
                                            source = $15dfd2795171b13b$var$filterSourceMap[hash];
                                        }
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            planId: planId,
                                            scenarioId: scenarioId,
                                            plan: (0, $c0cft.context).PLAN,
                                            source: source
                                        });
                                    }
                                    break;
                                }
                            case 0, $lIIFg.CLEAR:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const filterChangeAction = action;
                                    const filterID = filterChangeAction.payload;
                                    if (!this.ignoredFilterIds.includes(filterID) && (0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_FILTER.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        let source = '';
                                        if (typeof window !== 'undefined') {
                                            const { hash: hash } = window.location;
                                            source = $15dfd2795171b13b$var$filterSourceMap[hash];
                                        }
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            planId: planId,
                                            scenarioId: scenarioId,
                                            filterID: filterID,
                                            plan: (0, $c0cft.context).PLAN,
                                            source: source,
                                            addedOrRemoved: 0,
                                            itemCount: 0
                                        });
                                    }
                                    break;
                                }
                            case 0, $knys8.ADD_RELEASE:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const addCrossProjectReleaseCommand = action;
                                    const crossProjectRelease = addCrossProjectReleaseCommand.payload;
                                    const projectReleaseCount = crossProjectRelease.versions.length;
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) (0, $c0cft.default).triggerCreateCrossProjectReleaseAnalytics(addCrossProjectReleaseCommand.meta.analyticsEvent, {
                                        projectReleaseCount: projectReleaseCount
                                    });
                                    break;
                                }
                            case 0, $gIlW4.CREATE_TEAM:
                                {
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).PRIVATE_TEAM_CREATED.split(' ');
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(store.getState());
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
                                    break;
                                }
                            case 0, $gIlW4.SHARE_TEAM:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).TEAM_IS_SHARED.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
                                    }
                                    break;
                                }
                            case 0, $atnIT.UPDATE_PLAN:
                                {
                                    const state = store.getState();
                                    const updatePlanAction = action;
                                    const configuredDates = updatePlanAction.payload.baselineStartField || updatePlanAction.payload.baselineEndField;
                                    if (configuredDates) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CONFIGURABLE_DATE_CHANGED.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
                                        const updatedPlan = {
                                            ...(0, $bHTqr.getPlan)(state),
                                            ...updatePlanAction.payload
                                        };
                                        const isPlanUsingAnyCustomDates = (plan)=>plan.baselineStartField.type === (0, $5fACX.DATEFIELD_TYPES).CUSTOM || plan.baselineEndField.type === (0, $5fACX.DATEFIELD_TYPES).CUSTOM;
                                        const isPrevPlanUsingCustomDates = isPlanUsingAnyCustomDates((0, $bHTqr.getPlan)(state));
                                        const isNextPlanUsingCustomDates = isPlanUsingAnyCustomDates(updatedPlan);
                                        if (!isPrevPlanUsingCustomDates && isNextPlanUsingCustomDates) {
                                            const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CUSTOM_CONFIGURABLE_DATE_USED.split(' ');
                                            analyticsEvent.update({
                                                action: eventAction,
                                                actionSubject: actionSubject
                                            });
                                            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
                                        } else if (isPrevPlanUsingCustomDates && !isNextPlanUsingCustomDates) {
                                            const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).NO_CUSTOM_CONFIGURABLE_DATES_USED.split(' ');
                                            analyticsEvent.update({
                                                action: eventAction,
                                                actionSubject: actionSubject
                                            });
                                            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
                                        }
                                    }
                                    break;
                                }
                            case 0, $jNv9f.UPDATE_PARENT:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const updateParentAction = action;
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REPARENT_ISSUE.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        const method = updateParentAction.payload.isDragAndDrop ? {
                                            method: 'dragged'
                                        } : {};
                                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).REPARENT_ISSUE, method);
                                    }
                                    break;
                                }
                            case 0, $3t3Pr.SET_ACTIVE_VIEW:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const { payload: { id: id } } = action;
                                    const activeView = (0, $7QGzp.getViews)(state).find((view)=>view.id === id);
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SET_ACTIVE_VIEW.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId) && (0, $4nDwW.isDefined)(activeView)) {
                                        const isPredefinedView = $15dfd2795171b13b$var$isPredefined(activeView);
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            planId: planId,
                                            scenarioId: scenarioId,
                                            presetName: (0, $87fK4.getPresetName)(activeView),
                                            isDefault: activeView.isDefault ? 1 : 0,
                                            isPredefined: isPredefinedView ? 1 : 0,
                                            isCustom: isPredefinedView ? 0 : 1,
                                            isEdited: activeView.modified ? 1 : 0
                                        });
                                    }
                                    break;
                                }
                            case 0, $3t3Pr.SAVE_VIEW:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const { payload: { id: id } } = action;
                                    const view = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('id', id))((0, $7QGzp.getViews)(state));
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SAVE_VIEW.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId) && (0, $4nDwW.isDefined)(view)) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        isDefault: view.isDefault ? 1 : 0,
                                        isCustom: view.isUnchangedPredefinedView ? 0 : 1
                                    });
                                    break;
                                }
                            case 0, $3t3Pr.ADD_VIEW:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const { payload: payload } = action;
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_VIEW.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId) && (0, $4nDwW.isDefined)(payload)) {
                                        const isPredefinedView = $15dfd2795171b13b$var$isPredefined(payload);
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            planId: planId,
                                            scenarioId: scenarioId,
                                            isDefault: payload.isDefault ? 1 : 0,
                                            isCustom: isPredefinedView ? 0 : 1
                                        });
                                    }
                                    break;
                                }
                            case 0, $3t3Pr.RESET:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const { payload: payload } = action;
                                    const activeView = payload.find((view)=>view.active === true);
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).RESET_VIEWS.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId) && (0, $4nDwW.isDefined)(activeView)) {
                                        const isPredefinedView = $15dfd2795171b13b$var$isPredefined(activeView);
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            planId: planId,
                                            scenarioId: scenarioId,
                                            presetName: (0, $87fK4.getPresetName)(activeView),
                                            isDefault: activeView.isDefault ? 1 : 0,
                                            isPredefined: isPredefinedView ? 1 : 0,
                                            isCustom: isPredefinedView ? 0 : 1,
                                            isEdited: activeView.modified ? 1 : 0
                                        });
                                    }
                                    break;
                                }
                            case 0, $4ArTT.HIDE_COLUMN:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const viewMode = (0, $kWDpn.getViewMode)(state);
                                    const { id: id, meta: { source: source } } = action;
                                    const isCustomField = !!parseInt(id, 10);
                                    let fieldName = id;
                                    if (isCustomField) {
                                        const field = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('id', parseInt(id, 10)))(state.domain.customFields);
                                        fieldName = $15dfd2795171b13b$var$typeOfCustomField(field);
                                    }
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).HIDE_COLUMN.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        fieldName: fieldName,
                                        viewMode: viewMode,
                                        source: source
                                    });
                                    break;
                                }
                            case 0, $4ArTT.SHOW_COLUMN:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const viewMode = (0, $kWDpn.getViewMode)(state);
                                    const { id: id, meta: { source: source } } = action;
                                    const isCustomField = !!parseInt(id, 10);
                                    let fieldName = id;
                                    if (isCustomField) {
                                        const field = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('id', parseInt(id, 10)))(state.domain.customFields);
                                        fieldName = $15dfd2795171b13b$var$typeOfCustomField(field);
                                    }
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SHOW_COLUMN.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        fieldName: fieldName,
                                        viewMode: viewMode,
                                        source: source
                                    });
                                    break;
                                }
                            case 0, $4ArTT.MOVE_COLUMN:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const viewMode = (0, $kWDpn.getViewMode)(state);
                                    const { payload: { columnToMove: columnToMove }, meta: { source: source } } = action;
                                    const isCustomField = !!parseInt(columnToMove, 10);
                                    let fieldName = columnToMove;
                                    if (isCustomField) {
                                        const field = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('id', parseInt(columnToMove, 10)))(state.domain.customFields);
                                        fieldName = $15dfd2795171b13b$var$typeOfCustomField(field);
                                    }
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).MOVE_COLUMN.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        fieldName: fieldName,
                                        viewMode: viewMode,
                                        source: source
                                    });
                                    break;
                                }
                            case 0, $3t3Pr.MARK_AS_DEFAULT_VIEW:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const { payload: { id: id } } = action;
                                    const viewMarkedAsDefault = (0, parcelRequire("9U6ZH")).default((0, parcelRequire("sqeVT")).default('id', id))((0, $7QGzp.getViews)(state));
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).MARK_AS_DEFAULT_VIEW.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId) && (0, $4nDwW.isDefined)(viewMarkedAsDefault)) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        isDefault: 1,
                                        isPredefined: viewMarkedAsDefault.isUnchangedPredefinedView ? 1 : 0,
                                        isCustom: viewMarkedAsDefault.isUnchangedPredefinedView ? 0 : 1,
                                        isEdited: viewMarkedAsDefault.modified ? 1 : 0
                                    });
                                    break;
                                }
                            case 0, $j33D0.CHANGE_OPTION:
                                {
                                    const state = store.getState();
                                    const { id: planId } = (0, $bHTqr.getPlan)(state);
                                    const customDateRange = (0, $kWDpn.getTimeScaleViewSettings)(state).customDateRange || {};
                                    const zoomLevel = (0, $jAIJh.getZoomLevel)(state);
                                    const { timelineType: timelineType, customTimelineType: customTimelineType } = (0, $87fK4.getTimelineAttributes)(customDateRange, zoomLevel);
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SELECT_TIMELINE_RANGE.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if ((0, $4nDwW.isDefined)(planId)) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        plan: (0, $c0cft.context).PLAN,
                                        timelineType: timelineType,
                                        customTimelineType: customTimelineType
                                    });
                                    break;
                                }
                            case 0, $j33D0.CHANGE_MODE:
                                {
                                    const state = store.getState();
                                    const { payload: payload } = action;
                                    const { id: planId } = (0, $bHTqr.getPlan)(state);
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SELECT_TIMELINE_RANGE.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if (payload !== (0, $TTKUQ.TIMELINE_MODES).CUSTOM) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        plan: (0, $c0cft.context).PLAN,
                                        timelineType: payload
                                    });
                                    break;
                                }
                            case 0, $j33D0.CHANGE_CUSTOM_DATES:
                                {
                                    const state = store.getState();
                                    const { payload: payload } = action;
                                    const { id: planId } = (0, $bHTqr.getPlan)(state);
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).SELECT_TIMELINE_RANGE.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    const { timelineType: timelineType, customTimelineType: customTimelineType } = (0, $87fK4.getTimelineAttributes)(payload);
                                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        plan: (0, $c0cft.context).PLAN,
                                        timelineType: timelineType,
                                        customTimelineType: customTimelineType
                                    });
                                    break;
                                }
                            case 0, $23472.SEARCH_ICON_CLICK:
                                {
                                    const state = store.getState();
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ISSUE_SEARCH_ICON_CLICK.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
                                    break;
                                }
                            case 0, $23472.STARTED_SEARCH_RESULT_NAVIGATION:
                                {
                                    const state = store.getState();
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).ISSUE_SEARCH_STARTED_SEARCH_RESULT_NAVIGATION.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
                                    break;
                                }
                            case 0, $b0D0x.CLICK_EXPORT_TO_CSV_ANALYTICS:
                                {
                                    const state = store.getState();
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                    const { selectedFilters: selectedFilters, hierarchyLevels: hierarchyLevels } = (0, $iIikD.getFiltersAndHierarchyLevelsForAnalytics)(state);
                                    const clickExportToCsvAction = action;
                                    const issueExportCount = clickExportToCsvAction.payload.issueExportCount;
                                    if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId) && (0, $4nDwW.isDefined)(issueExportCount)) {
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_EXPORT_TO_CSV.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                                            planId: planId,
                                            scenarioId: scenarioId,
                                            plan: (0, $c0cft.context).PLAN,
                                            issueExportCount: issueExportCount,
                                            hierarchyLevels: hierarchyLevels,
                                            planMode: (0, $1CGdp.getPlanModeForAnalytics)(state),
                                            selectedFilters: selectedFilters
                                        });
                                    }
                                    break;
                                }
                            case 0, $b0D0x.PLAN_EXPORTED_ANALYTICS:
                                {
                                    const state = store.getState();
                                    const planExportedAction = action;
                                    const attributes = planExportedAction.payload;
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).PLAN_EXPORTED.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    const allAttributes = {
                                        planMode: (0, $1CGdp.getPlanModeForAnalytics)(state),
                                        ...attributes
                                    };
                                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).PLAN_EXPORTED, allAttributes);
                                    break;
                                }
                            case 0, $ebcEl.AFTER_SUCCESS:
                                {
                                    const state = store.getState();
                                    const feStateChangeCount = (0, $25viM.getReviewChangesCount)(state);
                                    const backendChangeCount = (0, $25viM.getReviewChanges)(state).length;
                                    const isDialogOpen = state.ui.Top.TitleBar.UpdateJira.isDialogOpen;
                                    if (isDialogOpen) {
                                        const { id: planId, currentScenarioId: scenarioId } = (0, $bHTqr.getPlan)(state);
                                        const changeCounts = {
                                            fromFrontendState: {
                                                total: feStateChangeCount,
                                                issuesIncludingLinks: (0, $bI9dZ.getIssueChangeCount)(state),
                                                issueLinks: (0, $bI9dZ.getIssueChangesWithChangedLinksCount)(state),
                                                versions: (0, $9FFuD.getVersionChangeCount)(state),
                                                crossProjectVersions: (0, $jw86H.getCrossProjectVersionChangeCount)(state),
                                                teamsAndResources: (0, $60TfX.getTeamOrResourceChangeCount)(state)
                                            },
                                            fromBackend: {
                                                total: backendChangeCount,
                                                issuesIncludingLinks: (0, $bI9dZ.getIssueChanges)(state).length,
                                                issueLinks: (0, $bI9dZ.getIssueChangesWithChangedLinks)(state).length,
                                                versions: (0, $9FFuD.getVersionChanges)(state).length,
                                                crossProjectVersions: (0, $jw86H.getCrossProjectVersionChanges)(state).length,
                                                teamsAndResources: (0, $60TfX.getTeamAndResourceChanges)(state).length
                                            }
                                        };
                                        const hasMismatch = !(0, parcelRequire("8EB5I")).default(changeCounts.fromFrontendState, changeCounts.fromBackend);
                                        const synthetic = (0, (0, parcelRequire("nXNNJ")).isPollinatorTenant)();
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [actionSubject, eventAction] = (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).COMMIT_MODAL_LOADED_CHANGES.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        if ((0, $4nDwW.isDefined)(planId) && (0, $4nDwW.isDefined)(scenarioId)) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).COMMIT_MODAL_LOADED_CHANGES, {
                                            planId: planId,
                                            scenarioId: scenarioId,
                                            changeCounts: changeCounts,
                                            hasMismatch: hasMismatch,
                                            synthetic: synthetic
                                        });
                                    }
                                    break;
                                }
                            case 0, $aoVGF.TOGGLE_TOOLBAR:
                                {
                                    const state = store.getState();
                                    const grouping = (0, $j0XCX.getVisualisationGrouping)(state);
                                    const mode = (0, $1CGdp.getMode)(state);
                                    const showToolBar = (0, $faayJ.getToolBarVisibilityState)(state);
                                    const filteredIssues = (0, $bI9dZ.getFilteredIssues)(state).length;
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, action] = (showToolBar ? (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).COLLAPSE_TOOL_BAR : (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).EXPAND_TOOL_BAR).split(' ');
                                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                                        action: action,
                                        actionSubject: actionSubject
                                    }), {
                                        browserInnerWidth: window.innerWidth,
                                        browserInnerHeight: window.innerHeight,
                                        browserOuterWidth: window.outerWidth,
                                        browserOuterHeight: window.outerHeight,
                                        browserZoomPercentage: window.outerWidth / window.innerWidth * 100,
                                        filteredIssues: filteredIssues,
                                        grouping: grouping,
                                        isFullScreen: window.screen.availWidth === window.screen.width && window.screen.availHeight === window.screen.height,
                                        mode: mode,
                                        screenWidth: window.screen.width,
                                        screenHeight: window.screen.height
                                    });
                                    break;
                                }
                            case 0, $21mdo.SET_IS_EXPANDED:
                                {
                                    const { payload: payload } = action;
                                    const keys = Object.keys(payload);
                                    if (keys.length === 1) {
                                        const state = store.getState();
                                        const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                        const [item] = keys[0].split(':');
                                        const expand = payload[keys[0]];
                                        const [actionSubject, eventAction] = (expand ? (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).EXPAND_SCOPE_ITEM : (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).COLLAPSE_SCOPE_ITEM).split(' ');
                                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        }), {
                                            item: item
                                        });
                                    }
                                    break;
                                }
                            case 0, $dBbgF.TOGGLE_EXPAND_GROUP:
                                {
                                    const state = store.getState();
                                    const { payload: payload } = action;
                                    const { grouping: grouping, expand: expand } = payload;
                                    const analyticsEvent = (0, $1CGdp.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (expand ? (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).EXPAND_SCOPE_GROUP : (0, $i2qlb.PRODUCT_ANALYTICS_EVENT_NAMES).COLLAPSE_SCOPE_GROUP).split(' ');
                                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    }), {
                                        grouping: grouping
                                    });
                                    break;
                                }
                            default:
                                break;
                        }
                        return next(action);
                    });
            this.ignoredFilterIds = [
                (0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID),
                (0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID),
                (0, $cGbfF.CUSTOM_FIELD_FILTER_ID)
            ];
        }
    }
    const $15dfd2795171b13b$var$middleware = new $15dfd2795171b13b$var$AnalyticsMiddleware();
    var $15dfd2795171b13b$export$2e2bcd8739ae039 = $15dfd2795171b13b$var$middleware.apply;
});
parcelRegister("khIwz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74e36b9087b56afb$export$2e2bcd8739ae039);
    var $7kcEp;
    class $74e36b9087b56afb$export$2e2bcd8739ae039 {
        constructor(){
            this.timer = {
                startTime: undefined,
                endTime: undefined
            };
        }
        start() {
            if (this.isStopped()) throw new Error('Timer has already been stopped');
            if (this.isStarted()) throw new Error('Timer has already been started');
            this.timer.startTime = (0, (0, parcelRequire("7kcEp")).default).now();
        }
        stop() {
            if (!this.isStarted()) throw new Error("Timer hasn't been started");
            if (this.isStopped()) throw new Error('Timer has already been stopped');
            this.timer.endTime = (0, (0, parcelRequire("7kcEp")).default).now();
        }
        duration() {
            if (this.timer.startTime === undefined) throw new Error("Timer hasn't been started");
            if (this.timer.endTime === undefined) throw new Error("Timer hasn't been stopped");
            return this.timer.endTime - this.timer.startTime;
        }
        isStarted() {
            return this.timer.startTime !== undefined;
        }
        isStopped() {
            return this.timer.endTime !== undefined;
        }
    }
});
parcelRegister("7kcEp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4eae3950929da18f$export$2e2bcd8739ae039);
    var $77RzN;
    var $4eae3950929da18f$export$2e2bcd8739ae039 = {
        lastFullPageLoad () {
            const timing = (0, (0, parcelRequire("77RzN")).default).timing;
            const isCurrentPageLoadComplete = timing.loadEventEnd > 0;
            return isCurrentPageLoadComplete ? timing.loadEventEnd - timing.navigationStart : undefined;
        },
        now () {
            return (0, (0, parcelRequire("77RzN")).default).now();
        }
    };
});
parcelRegister("77RzN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a51e99ca2246de8c$export$2e2bcd8739ae039);
    const $a51e99ca2246de8c$var$performance = window.performance;
    var $a51e99ca2246de8c$export$2e2bcd8739ae039 = $a51e99ca2246de8c$var$performance;
});
parcelRegister("faayJ", function(module, exports) {
    $parcel$export(module.exports, "getToolBarVisibilityState", ()=>$2d36082708956908$export$d758e0d1efb191df);
    const $2d36082708956908$export$d758e0d1efb191df = (state)=>state.ui.Top.TitleBar.ToolBar.showToolBar;
});
parcelRegister("cyGmD", function(module, exports) {
    $parcel$export(module.exports, "getUrlPersistenceEstimate", ()=>$bd0cc9408c41e4e9$export$a5ab44622c5ebb2e);
    var $7OFAf = parcelRequire("7OFAf");
    var $ajpes = parcelRequire("ajpes");
    var $dJl1T;
    var $3YtPS = parcelRequire("3YtPS");
    var $cGbfF = parcelRequire("cGbfF");
    var $7QGzp = parcelRequire("7QGzp");
    const $bd0cc9408c41e4e9$var$ARRAY_FILTERS = [
        (0, $cGbfF.PROJECT_FILTER_ID),
        (0, $cGbfF.CROSS_PROJECT_RELEASE_FILTER_ID),
        (0, $cGbfF.RELEASE_FILTER_ID),
        (0, $cGbfF.TEAM_FILTER_ID),
        (0, $cGbfF.ASSIGNEE_FILTER_ID),
        (0, $cGbfF.REPORTER_FILTER_ID),
        (0, $cGbfF.LABEL_FILTER_ID),
        (0, $cGbfF.COMPONENT_FILTER_ID),
        (0, $cGbfF.STATUS_FILTER_ID),
        (0, $cGbfF.ISSUE_WARNING_FILTER_ID),
        (0, $cGbfF.SPRINT_FILTER_ID),
        (0, $cGbfF.ISSUE_TYPES_FILTER_ID),
        (0, $cGbfF.ISSUE_PRIORITIES_FILTER_ID),
        (0, $cGbfF.GOAL_FILTER_ID),
        (0, $cGbfF.IDEA_FILTER_ID)
    ];
    const $bd0cc9408c41e4e9$export$a5ab44622c5ebb2e = (0, $3YtPS.createSelector)([
        (0, $7QGzp.getActiveView)
    ], (activeView)=>{
        try {
            const originalPreferences = activeView.original?.preferences;
            const currentPreferences = activeView.preferences;
            return $bd0cc9408c41e4e9$export$fc82c409b750c2c0(originalPreferences, currentPreferences);
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('app-simple-plans.query.url-persistance', 'Failed to compute url estimates');
            return undefined;
        }
    });
    const $bd0cc9408c41e4e9$export$fc82c409b750c2c0 = (originalPreferences, currentPreferences)=>{
        if (originalPreferences === undefined) return {
            keyCount: 0,
            totalValueLength: 0,
            unsavedSettingsMetrics: []
        };
        const unsavedSettingsMetrics = (0, ($parcel$interopDefault($7OFAf)))($bd0cc9408c41e4e9$export$d1c59f566e19a1f8(originalPreferences, currentPreferences), $bd0cc9408c41e4e9$export$9684d0e8581cd51a(originalPreferences, currentPreferences), $bd0cc9408c41e4e9$export$b90803f3972ac035(originalPreferences, currentPreferences));
        const totalValueLength = unsavedSettingsMetrics.reduce((accumulator, { valueLength: valueLength })=>accumulator + valueLength, 0);
        return {
            keyCount: unsavedSettingsMetrics.length,
            totalValueLength: totalValueLength,
            unsavedSettingsMetrics: unsavedSettingsMetrics
        };
    };
    const $bd0cc9408c41e4e9$export$b90803f3972ac035 = (originalPreferences, currentPreferences)=>{
        const result = [];
        const computeEstimateUsingToString = $bd0cc9408c41e4e9$var$computeEstimateUsingToStringTransformer(originalPreferences, currentPreferences);
        const computeEstimateUsingJsonStringify = $bd0cc9408c41e4e9$var$computeEstimateUsingJsonStringifyTransformer(originalPreferences, currentPreferences);
        computeEstimateUsingJsonStringify(result, 'colourByV2', (preferences)=>preferences?.colourByV2);
        computeEstimateUsingJsonStringify(result, 'timeScaleV1', (preferences)=>preferences?.timeScaleV1);
        computeEstimateUsingJsonStringify(result, 'issueExpansionsV0', (preferences)=>preferences?.issueExpansionsV0);
        computeEstimateUsingJsonStringify(result, 'fieldColumnsV0', (preferences)=>preferences?.fieldColumnsV0);
        computeEstimateUsingJsonStringify(result, 'listFieldColumnsV0', (preferences)=>preferences?.listFieldColumnsV0);
        computeEstimateUsingJsonStringify(result, 'filterOptionsV1', (preferences)=>preferences?.filterOptionsV1);
        computeEstimateUsingJsonStringify(result, 'rollupSettingsV0', (preferences)=>preferences?.rollupSettingsV0);
        computeEstimateUsingJsonStringify(result, 'highlightedVersionsV0', (preferences)=>preferences?.highlightedVersionsV0);
        computeEstimateUsingJsonStringify(result, 'componentGroupsV0', (preferences)=>preferences?.componentGroupsV0);
        computeEstimateUsingJsonStringify(result, 'labelGroupsV0', (preferences)=>preferences?.labelGroupsV0);
        computeEstimateUsingJsonStringify(result, 'customFieldValuesGroupsV0', (preferences)=>preferences?.customFieldValuesGroupsV0);
        computeEstimateUsingJsonStringify(result, 'warningSettingsV1', (preferences)=>preferences?.warningSettingsV1);
        computeEstimateUsingJsonStringify(result, 'dateConstraintsV0', (preferences)=>preferences?.dateConstraintsV0);
        computeEstimateUsingJsonStringify(result, 'visualisationsV0', (preferences)=>preferences?.visualisationsV0);
        computeEstimateUsingJsonStringify(result, 'dependencySettingsV0', (preferences)=>preferences?.dependencySettingsV0);
        computeEstimateUsingToString(result, 'viewModeV0', (preferences)=>preferences?.viewModeV0?.mode);
        return result;
    };
    const $bd0cc9408c41e4e9$export$d1c59f566e19a1f8 = (originalPreferences, currentPreferences)=>{
        const result = [];
        $bd0cc9408c41e4e9$var$ARRAY_FILTERS.forEach((key)=>{
            const originalValue = originalPreferences?.filtersV1?.[key]?.value;
            const currentValue = currentPreferences?.filtersV1?.[key]?.value;
            if (!(0, ($parcel$interopDefault($ajpes)))(originalValue, currentValue)) result.push({
                key: key,
                valueLength: currentValue?.join(',')?.length ?? 0
            });
        });
        return result;
    };
    const $bd0cc9408c41e4e9$export$9684d0e8581cd51a = (originalPreferences, currentPreferences)=>{
        const result = [];
        const hierarchyFilterOriginalValue = originalPreferences?.filtersV1?.[0, $cGbfF.HIERARCHY_FILTER_ID]?.value;
        const hierarchyFilterCurrentValue = currentPreferences?.filtersV1?.[0, $cGbfF.HIERARCHY_FILTER_ID]?.value;
        if (!(0, ($parcel$interopDefault($ajpes)))(hierarchyFilterOriginalValue, hierarchyFilterCurrentValue)) result.push({
            key: (0, $cGbfF.HIERARCHY_FILTER_ID),
            valueLength: (hierarchyFilterCurrentValue?.start?.toString().length ?? 0) + (hierarchyFilterCurrentValue?.end?.toString().length ?? 0)
        });
        const hierarchyRangeFilterOriginalValue = originalPreferences?.filtersV1?.[0, $cGbfF.HIERARCHY_RANGE_FILTER_ID]?.value;
        const hierarchyRangeFilterCurrentValue = currentPreferences?.filtersV1?.[0, $cGbfF.HIERARCHY_RANGE_FILTER_ID]?.value;
        if (!(0, ($parcel$interopDefault($ajpes)))(hierarchyRangeFilterOriginalValue, hierarchyRangeFilterCurrentValue)) result.push({
            key: (0, $cGbfF.HIERARCHY_RANGE_FILTER_ID),
            valueLength: (hierarchyRangeFilterCurrentValue?.start?.toString().length ?? 0) + (hierarchyRangeFilterCurrentValue?.end?.toString().length ?? 0)
        });
        const computeEstimateUsingToString = $bd0cc9408c41e4e9$var$computeEstimateUsingToStringTransformer(originalPreferences, currentPreferences);
        computeEstimateUsingToString(result, (0, $cGbfF.SUMMARY_FILTER_ID), (preferences)=>preferences?.filtersV1?.[0, $cGbfF.SUMMARY_FILTER_ID]?.value);
        computeEstimateUsingToString(result, (0, $cGbfF.DEPENDENCIES_FILTER_ID), (preferences)=>preferences?.filtersV1?.[0, $cGbfF.DEPENDENCIES_FILTER_ID]?.value?.type);
        const statusKeyFilterOriginalValue = originalPreferences?.filtersV1?.[0, $cGbfF.STATUS_KEY_FILTER_ID]?.value;
        const statusKeyFilterCurrentValue = currentPreferences?.filtersV1?.[0, $cGbfF.STATUS_KEY_FILTER_ID]?.value;
        if (!(0, ($parcel$interopDefault($ajpes)))(statusKeyFilterOriginalValue, statusKeyFilterCurrentValue)) result.push({
            key: (0, $cGbfF.STATUS_KEY_FILTER_ID),
            valueLength: statusKeyFilterCurrentValue?.map(({ name: name })=>name)?.join(',')?.length ?? 0
        });
        const issueTypeKeyFilterOriginalValue = originalPreferences?.filtersV1?.[0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID]?.value;
        const issueTypeKeyFilterCurrentValue = currentPreferences?.filtersV1?.[0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID]?.value;
        if (!(0, ($parcel$interopDefault($ajpes)))(issueTypeKeyFilterOriginalValue, issueTypeKeyFilterCurrentValue)) result.push({
            key: (0, $cGbfF.ISSUE_TYPE_KEY_FILTER_ID),
            valueLength: issueTypeKeyFilterCurrentValue?.map(({ name: name })=>name)?.join(',')?.length ?? 0
        });
        const customFieldFilterOriginalValue = originalPreferences?.filtersV1?.[0, $cGbfF.CUSTOM_FIELD_FILTER_ID]?.value;
        const customFieldFilterCurrentValue = currentPreferences?.filtersV1?.[0, $cGbfF.CUSTOM_FIELD_FILTER_ID]?.value;
        if (!(0, ($parcel$interopDefault($ajpes)))(customFieldFilterOriginalValue, customFieldFilterCurrentValue)) Object.keys(customFieldFilterCurrentValue ?? {}).forEach((key)=>{
            const originalValue = customFieldFilterOriginalValue?.[key];
            const currentValue = customFieldFilterCurrentValue?.[key];
            if (!(0, ($parcel$interopDefault($ajpes)))(originalValue, currentValue)) result.push({
                key: `${(0, $cGbfF.CUSTOM_FIELD_FILTER_ID)}.${key}`,
                valueLength: currentValue?.join(',')?.length ?? 0
            });
        });
        const dateRangeFilterOriginalValue = originalPreferences?.filtersV1?.[0, $cGbfF.DATE_RANGE_FILTER_ID]?.value;
        const dateRangeFilterCurrentValue = currentPreferences?.filtersV1?.[0, $cGbfF.DATE_RANGE_FILTER_ID]?.value;
        if (!(0, ($parcel$interopDefault($ajpes)))(dateRangeFilterOriginalValue, dateRangeFilterCurrentValue)) result.push({
            key: (0, $cGbfF.DATE_RANGE_FILTER_ID),
            valueLength: (dateRangeFilterCurrentValue?.startDate?.toString()?.length ?? 0) + (dateRangeFilterCurrentValue?.endDate?.toString()?.length ?? 0)
        });
        return result;
    };
    const $bd0cc9408c41e4e9$var$computeEstimateUsingJsonStringifyTransformer = (orginalPreferences, currentPreferences)=>(accumulator, key, selector)=>{
            const originalValue = selector(orginalPreferences);
            const currentValue = selector(currentPreferences);
            if (!(0, ($parcel$interopDefault($ajpes)))(originalValue, currentValue)) accumulator.push({
                key: key,
                valueLength: JSON.stringify(currentValue).length ?? 0
            });
        };
    const $bd0cc9408c41e4e9$var$computeEstimateUsingToStringTransformer = (orginalPreferences, currentPreferences)=>(accumulater, key, selector)=>{
            const originalValue = selector(orginalPreferences);
            const currentValue = selector(currentPreferences);
            if (!(0, ($parcel$interopDefault($ajpes)))(originalValue, currentValue)) accumulater.push({
                key: key,
                valueLength: String(currentValue)?.length ?? 0
            });
        };
});
parcelRegister("7OFAf", function(module, exports) {
    var $2Z8Cv = parcelRequire("2Z8Cv");
    var $ekcP3 = parcelRequire("ekcP3");
    var $jHlUS = parcelRequire("jHlUS");
    var $8LQ84 = parcelRequire("8LQ84");
    function $5b0d7592c3de24e2$var$concat() {
        var length = arguments.length;
        if (!length) return [];
        var args = Array(length - 1), array = arguments[0], index = length;
        while(index--)args[index - 1] = arguments[index];
        return $2Z8Cv($8LQ84(array) ? $jHlUS(array) : [
            array
        ], $ekcP3(args, 1));
    }
    module.exports = $5b0d7592c3de24e2$var$concat;
});
parcelRegister("aoVGF", function(module, exports) {
    $parcel$export(module.exports, "TOGGLE_TOOLBAR", ()=>$44a70b58aeea9e87$export$ccc9db851a286742);
    const $44a70b58aeea9e87$export$ccc9db851a286742 = 'state.ui.top.title-bar.tool-bar.TOGGLE_TOOLBAR';
    const $44a70b58aeea9e87$export$5ffe462ecc322803 = ()=>({
            type: $44a70b58aeea9e87$export$ccc9db851a286742
        });
});
parcelRegister("dFbEI", function(module, exports) {
    $parcel$export(module.exports, "CustomFieldTypeNameMap", ()=>$afc7aac47fdd056c$export$3edd42a6692bc382);
    const $afc7aac47fdd056c$var$TypeKeyMap = {
        TEAM_CF_TYPE: 'com.atlassian.teams:rm-teams-custom-field-team',
        ATLASSIAN_TEAM_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
        ORGANIZATIONS_CF_TYPE: 'com.atlassian.servicedesk:sd-customer-organizations',
        MULTI_USER_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
        SELECT_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
        DATETIME_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
        DATE_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker',
        STORY_POINT_ESTIMATE_CF_TYPE: 'com.pyxis.greenhopper.jira:jsw-story-points',
        PARENT_CF_TYPE: 'com.atlassian.jpo:jpo-custom-field-parent',
        BASELINE_START_CF_TYPE: 'com.atlassian.jpo:jpo-custom-field-baseline-start',
        BASELINE_END_CF_TYPE: 'com.atlassian.jpo:jpo-custom-field-baseline-end',
        SPRINT_CF_GLOBAL_TYPE: 'com.pyxis.greenhopper.jira:gh-sprint',
        MULTI_CHECKBOXES_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
        NUMBER_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
        USER_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
        URL_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
        TEXT_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
        TEXT_AREA_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
        MULTI_VERSION_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion',
        RADIO_BUTTONS_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
        LABELS_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
        MULTI_GROUP_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker',
        VERSION_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:version',
        GROUP_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker',
        ASSETS_CF_TYPE: 'com.atlassian.servicedesk.assets-plugin:assetfield',
        SERVICE_ENTITY_CF_TYPE: 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype',
        REQUEST_PARTICIPANTS_CF_TYPE: 'com.atlassian.servicedesk:sd-request-participants',
        REQUEST_TYPE_CF_TYPE: 'com.atlassian.servicedesk:vp-origin',
        EPIC_NAME_TYPE: 'com.pyxis.greenhopper.jira:gh-epic-label',
        EPIC_STATUS_TYPE: 'com.pyxis.greenhopper.jira:gh-epic-status',
        EPIC_COLOR_TYPE: 'com.pyxis.greenhopper.jira:gh-epic-color',
        COLOR_CF_TYPE: 'com.pyxis.greenhopper.jira:jsw-issue-color',
        EPIC_TYPE: 'com.pyxis.greenhopper.jira:gh-epic-link',
        RANK_CF_TYPE: 'com.pyxis.greenhopper.jira:gh-lexo-rank',
        REQUEST_FEEDBACK_CF_TYPE: 'com.atlassian.servicedesk:sd-request-feedback',
        REQUEST_FEEDBACK_DATE_CF_TYPE: 'com.atlassian.servicedesk:sd-request-feedback-date',
        APPROVALS_CF_TYPE: 'com.atlassian.servicedesk.approvals-plugin:sd-approvals',
        REQUEST_LANGUAGE_CF_TYPE: 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language',
        MULTI_SELECT_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
        DEV_SUMMARY_CF_TYPE: 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf',
        FIRST_RESPONSE_DATE_CF_TYPE: 'com.atlassian.jira.ext.charting:firstresponsedate',
        TIME_IN_STATUS_CF_TYPE: 'com.atlassian.jira.ext.charting:timeinstatus',
        UUID_CF_TYPE: 'com.atlassian.jconnect.jconnect-plugin:uuid',
        GOOGLE_MAP_CF_TYPE: 'com.atlassian.jconnect.jconnect-plugin:location',
        SLA_CF_TYPE: 'com.atlassian.servicedesk:sd-sla-field',
        CASCADING_SELECT_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
        LAST_UPDATER_CF_TYPE: 'com.atlassian.jira.toolkit:lastupdaterorcommenter',
        USER_PROPERTY_CF_TYPE: 'com.atlassian.jira.toolkit:userproperty',
        TEXT_READONLY_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
        PROJECT_PICKER_CF_TYPE: 'com.atlassian.jira.plugin.system.customfieldtypes:project',
        PARTICIPANTS_CF_TYPE: 'com.atlassian.jira.toolkit:participants',
        COMMENTS_NUMBER_CF_TYPE: 'com.atlassian.jira.toolkit:comments',
        ATTACHMENTS_NUMBER_CF_TYPE: 'com.atlassian.jira.toolkit:attachments',
        MESSAGE_CF_TYPE: 'com.atlassian.jira.toolkit:viewmessage',
        MESSAGE_EDIT_CF_TYPE: 'com.atlassian.jira.toolkit:message',
        LAST_COMMENT_DATE_CF_TYPE: 'com.atlassian.jira.toolkit:LastCommentDate',
        LAST_COMMENT_UF_CF_TYPE: 'com.atlassian.jira.toolkit:lastusercommented',
        REPORTER_DOMAIN_CF_TYPE: 'com.atlassian.jira.toolkit:reporterdomain',
        ASSIGNEE_DOMAIN_CF_TYPE: 'com.atlassian.jira.toolkit:assigneedomain',
        LAST_COMMENT_DAYS_CF_TYPE: 'com.atlassian.jira.toolkit:dayslastcommented',
        RESPONDERS_CF_TYPE: 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype',
        ENTITLEMENT_CF_TYPE: 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement',
        WORK_CATEGORY_CF_TYPE: 'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype',
        MARKETPLACE_CF_TYPE: 'com.atlassian.plugins.atlassian-connect-plugin',
        CMDB_OBJECT_CF_TYPE: 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype',
        FORGE_CF_TYPE: 'ari:cloud:ecosystem::extension',
        FORMS_TOTAL_TYPE: 'com.atlassian.jira.plugins.proforma-managed-fields:forms-total-field-cftype',
        FORMS_SUBMITTED_TYPE: 'com.atlassian.jira.plugins.proforma-managed-fields:forms-submitted-field-cftype',
        FORMS_OPEN_TYPE: 'com.atlassian.jira.plugins.proforma-managed-fields:forms-open-field-cftype',
        FORMS_LOCKED_TYPE: 'com.atlassian.jira.plugins.proforma-managed-fields:forms-locked-field-cftype',
        FORMULA_CF_TYPE: 'jira.polaris:formula',
        INTERVAL_CF_TYPE: 'jira.polaris:interval',
        REACTIONS_CF_TYPE: 'jira.polaris:reactions',
        SLIDER_CF_TYPE: 'jira.polaris:slider',
        RATING_CF_TYPE: 'jira.polaris:rating',
        BOOLEAN_CF_TYPE: 'jira.polaris:boolean'
    };
    const $afc7aac47fdd056c$export$3edd42a6692bc382 = {
        [$afc7aac47fdd056c$var$TypeKeyMap.DEV_SUMMARY_CF_TYPE]: 'Dev Summary Custom Field',
        [$afc7aac47fdd056c$var$TypeKeyMap.TEAM_CF_TYPE]: 'Team',
        [$afc7aac47fdd056c$var$TypeKeyMap.ATLASSIAN_TEAM_CF_TYPE]: 'Team Picker (single team)',
        [$afc7aac47fdd056c$var$TypeKeyMap.ORGANIZATIONS_CF_TYPE]: 'Organizations',
        [$afc7aac47fdd056c$var$TypeKeyMap.MULTI_USER_CF_TYPE]: 'User Picker (multiple users)',
        [$afc7aac47fdd056c$var$TypeKeyMap.SELECT_CF_TYPE]: 'Select List (single choice)',
        [$afc7aac47fdd056c$var$TypeKeyMap.DATETIME_CF_TYPE]: 'Date Time Picker',
        [$afc7aac47fdd056c$var$TypeKeyMap.REQUEST_TYPE_CF_TYPE]: 'Customer Request Type Custom Field',
        [$afc7aac47fdd056c$var$TypeKeyMap.EPIC_NAME_TYPE]: 'Name of Epic',
        [$afc7aac47fdd056c$var$TypeKeyMap.EPIC_STATUS_TYPE]: 'Status of Epic',
        [$afc7aac47fdd056c$var$TypeKeyMap.EPIC_COLOR_TYPE]: 'Color of Epic',
        [$afc7aac47fdd056c$var$TypeKeyMap.EPIC_TYPE]: 'Epic Link Relationship',
        [$afc7aac47fdd056c$var$TypeKeyMap.DATE_CF_TYPE]: 'Date Picker',
        [$afc7aac47fdd056c$var$TypeKeyMap.STORY_POINT_ESTIMATE_CF_TYPE]: 'Story point estimate value',
        [$afc7aac47fdd056c$var$TypeKeyMap.COLOR_CF_TYPE]: 'Issue color',
        [$afc7aac47fdd056c$var$TypeKeyMap.PARENT_CF_TYPE]: 'Parent Link',
        [$afc7aac47fdd056c$var$TypeKeyMap.BASELINE_START_CF_TYPE]: 'Target start',
        [$afc7aac47fdd056c$var$TypeKeyMap.BASELINE_END_CF_TYPE]: 'Target end',
        [$afc7aac47fdd056c$var$TypeKeyMap.FIRST_RESPONSE_DATE_CF_TYPE]: 'Date of First Response',
        [$afc7aac47fdd056c$var$TypeKeyMap.TIME_IN_STATUS_CF_TYPE]: 'Time in Status',
        [$afc7aac47fdd056c$var$TypeKeyMap.SPRINT_CF_GLOBAL_TYPE]: 'Jira Sprint Field',
        [$afc7aac47fdd056c$var$TypeKeyMap.RANK_CF_TYPE]: 'Global Rank',
        [$afc7aac47fdd056c$var$TypeKeyMap.MULTI_CHECKBOXES_CF_TYPE]: 'Checkboxes',
        [$afc7aac47fdd056c$var$TypeKeyMap.REQUEST_PARTICIPANTS_CF_TYPE]: 'Request Participants',
        [$afc7aac47fdd056c$var$TypeKeyMap.UUID_CF_TYPE]: 'UUID Field',
        [$afc7aac47fdd056c$var$TypeKeyMap.GOOGLE_MAP_CF_TYPE]: 'Custom Google Map Field',
        [$afc7aac47fdd056c$var$TypeKeyMap.NUMBER_CF_TYPE]: 'Number Field',
        [$afc7aac47fdd056c$var$TypeKeyMap.REQUEST_FEEDBACK_CF_TYPE]: 'Satisfaction',
        [$afc7aac47fdd056c$var$TypeKeyMap.REQUEST_FEEDBACK_DATE_CF_TYPE]: 'Satisfaction date',
        [$afc7aac47fdd056c$var$TypeKeyMap.APPROVALS_CF_TYPE]: 'Approvals',
        [$afc7aac47fdd056c$var$TypeKeyMap.SLA_CF_TYPE]: 'SLA CustomField Type',
        [$afc7aac47fdd056c$var$TypeKeyMap.REQUEST_LANGUAGE_CF_TYPE]: 'Request language',
        [$afc7aac47fdd056c$var$TypeKeyMap.USER_CF_TYPE]: 'User Picker (single user)',
        [$afc7aac47fdd056c$var$TypeKeyMap.URL_CF_TYPE]: 'Url Field',
        [$afc7aac47fdd056c$var$TypeKeyMap.TEXT_CF_TYPE]: 'Text Field (single line)',
        [$afc7aac47fdd056c$var$TypeKeyMap.TEXT_AREA_CF_TYPE]: 'Text Field (multi-line)',
        [$afc7aac47fdd056c$var$TypeKeyMap.MULTI_SELECT_CF_TYPE]: 'Select List (multiple choices)',
        [$afc7aac47fdd056c$var$TypeKeyMap.CASCADING_SELECT_CF_TYPE]: 'Select List (cascading)',
        [$afc7aac47fdd056c$var$TypeKeyMap.RADIO_BUTTONS_CF_TYPE]: 'Radio Buttons',
        [$afc7aac47fdd056c$var$TypeKeyMap.LABELS_CF_TYPE]: 'Labels',
        [$afc7aac47fdd056c$var$TypeKeyMap.VERSION_CF_TYPE]: 'Version Picker (single version)',
        [$afc7aac47fdd056c$var$TypeKeyMap.MULTI_VERSION_CF_TYPE]: 'Version Picker (multiple version)',
        [$afc7aac47fdd056c$var$TypeKeyMap.LAST_UPDATER_CF_TYPE]: 'Username of last updater or commenter',
        [$afc7aac47fdd056c$var$TypeKeyMap.USER_PROPERTY_CF_TYPE]: 'User Property Field (< 255 characters)',
        [$afc7aac47fdd056c$var$TypeKeyMap.TEXT_READONLY_CF_TYPE]: 'Text Field (read only)',
        [$afc7aac47fdd056c$var$TypeKeyMap.PROJECT_PICKER_CF_TYPE]: 'Project Picker (single project)',
        [$afc7aac47fdd056c$var$TypeKeyMap.PARTICIPANTS_CF_TYPE]: 'Participants of an issue',
        [$afc7aac47fdd056c$var$TypeKeyMap.COMMENTS_NUMBER_CF_TYPE]: 'Number of comments',
        [$afc7aac47fdd056c$var$TypeKeyMap.ATTACHMENTS_NUMBER_CF_TYPE]: 'Number of attachments',
        [$afc7aac47fdd056c$var$TypeKeyMap.MESSAGE_CF_TYPE]: 'Message Custom Field (for view)',
        [$afc7aac47fdd056c$var$TypeKeyMap.MESSAGE_EDIT_CF_TYPE]: 'Message Custom Field (for edit)',
        [$afc7aac47fdd056c$var$TypeKeyMap.LAST_COMMENT_DATE_CF_TYPE]: 'Last public comment date',
        [$afc7aac47fdd056c$var$TypeKeyMap.LAST_COMMENT_UF_CF_TYPE]: 'Last commented by a User Flag',
        [$afc7aac47fdd056c$var$TypeKeyMap.GROUP_CF_TYPE]: 'Group Picker (single group)',
        [$afc7aac47fdd056c$var$TypeKeyMap.MULTI_GROUP_CF_TYPE]: 'Group Picker (multiple groups)',
        [$afc7aac47fdd056c$var$TypeKeyMap.REPORTER_DOMAIN_CF_TYPE]: 'Domain of Reporter',
        [$afc7aac47fdd056c$var$TypeKeyMap.ASSIGNEE_DOMAIN_CF_TYPE]: 'Domain of Assignee',
        [$afc7aac47fdd056c$var$TypeKeyMap.LAST_COMMENT_DAYS_CF_TYPE]: 'Days since last comment',
        [$afc7aac47fdd056c$var$TypeKeyMap.ASSETS_CF_TYPE]: 'External asset platform',
        [$afc7aac47fdd056c$var$TypeKeyMap.CMDB_OBJECT_CF_TYPE]: 'Assets objects',
        [$afc7aac47fdd056c$var$TypeKeyMap.RESPONDERS_CF_TYPE]: 'Responders',
        [$afc7aac47fdd056c$var$TypeKeyMap.FORGE_CF_TYPE]: 'Forge',
        [$afc7aac47fdd056c$var$TypeKeyMap.WORK_CATEGORY_CF_TYPE]: 'Work Category',
        [$afc7aac47fdd056c$var$TypeKeyMap.FORMS_TOTAL_TYPE]: 'Total forms',
        [$afc7aac47fdd056c$var$TypeKeyMap.FORMS_SUBMITTED_TYPE]: 'Submitted forms',
        [$afc7aac47fdd056c$var$TypeKeyMap.FORMS_LOCKED_TYPE]: 'Locked forms',
        [$afc7aac47fdd056c$var$TypeKeyMap.FORMS_OPEN_TYPE]: 'Open forms',
        [$afc7aac47fdd056c$var$TypeKeyMap.ENTITLEMENT_CF_TYPE]: 'Entitlement',
        [$afc7aac47fdd056c$var$TypeKeyMap.FORMULA_CF_TYPE]: 'Custom Formula (Jira Product Discovery)',
        [$afc7aac47fdd056c$var$TypeKeyMap.INTERVAL_CF_TYPE]: 'Date Inverval (Jira Product Discovery)',
        [$afc7aac47fdd056c$var$TypeKeyMap.REACTIONS_CF_TYPE]: 'Reactions (Jira Product Discovery)',
        [$afc7aac47fdd056c$var$TypeKeyMap.RATING_CF_TYPE]: 'Rating (Jira Product Discovery)',
        [$afc7aac47fdd056c$var$TypeKeyMap.SLIDER_CF_TYPE]: 'Slider (Jira Product Discovery)',
        [$afc7aac47fdd056c$var$TypeKeyMap.BOOLEAN_CF_TYPE]: 'Checkbox (Jira Product Discovery)',
        default: 'Unknown'
    };
});
parcelRegister("87fK4", function(module, exports) {
    $parcel$export(module.exports, "countFutureSprintDates", ()=>$352fe5c838507bf6$export$9bd2edfcf92cf271);
    $parcel$export(module.exports, "countIssueInferredDates", ()=>$352fe5c838507bf6$export$2e9dafbfe356d9ad);
    $parcel$export(module.exports, "getColoursUsedInPlan", ()=>$352fe5c838507bf6$export$6076dd623bc4deb);
    $parcel$export(module.exports, "getIssueAnalyticAttributes", ()=>$352fe5c838507bf6$export$b6a1c462ad352e48);
    $parcel$export(module.exports, "getTimelineAttributes", ()=>$352fe5c838507bf6$export$936ca6b7e73b7cfb);
    $parcel$export(module.exports, "logAnalyticsError", ()=>$352fe5c838507bf6$export$736397007665a3b6);
    $parcel$export(module.exports, "getPresetName", ()=>$352fe5c838507bf6$export$70447d77c8eef9d);
    var $b1yMp;
    var $8Tt2N;
    var $3nPAF;
    var $ik0Qc;
    var $bjzU8;
    var $jcw0u;
    var $5fACX = parcelRequire("5fACX");
    var $4nDwW = parcelRequire("4nDwW");
    var $gITL8 = parcelRequire("gITL8");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $fOXM3 = parcelRequire("fOXM3");
    const $352fe5c838507bf6$export$9bd2edfcf92cf271 = (0, parcelRequire("b1yMp")).default((result)=>{
        const { sprintFutureSetDates: sprintFutureSetDates = 0, sprintFutureInferredDates: sprintFutureInferredDates = 0 } = result;
        return (0, parcelRequire("ik0Qc")).default({
            closed: 0,
            active: 0,
            future: sprintFutureSetDates + sprintFutureInferredDates,
            sprintFutureSetDates: sprintFutureSetDates,
            sprintFutureInferredDates: sprintFutureInferredDates
        })(result);
    }, (0, parcelRequire("8Tt2N")).default((sprint)=>{
        if (sprint.state === (0, $TTKUQ.SPRINT_STATES).FUTURE) return sprint.planned ? 'sprintFutureSetDates' : 'sprintFutureInferredDates';
        return String(sprint.state).toLowerCase();
    }));
    const $352fe5c838507bf6$var$inferringReleaseStart = (allReleases, issueReleases)=>{
        if (issueReleases.length === 0) return false;
        const releaseToCheck = allReleases.find((release)=>release.id === issueReleases[0]);
        return releaseToCheck?.start != null;
    };
    const $352fe5c838507bf6$var$inferringReleaseEnd = (allReleases, issueReleases)=>{
        if (issueReleases.length === 0) return false;
        const releaseToCheck = allReleases.find((release)=>release.id === issueReleases[0]);
        return releaseToCheck?.end != null;
    };
    const $352fe5c838507bf6$export$2e9dafbfe356d9ad = (plan, issues, releases)=>{
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField, issueInferredDateSelection: issueInferredDateSelection } = plan;
        let startInferred = 0;
        let endInferred = 0;
        let issuesWithFixedStartDateCount = 0;
        let issuesWithFixedEndDateCount = 0;
        let issuesWithSprintStartDateCount = 0;
        let issuesWithSprintEndDateCount = 0;
        let issuesWithReleaseStartDateCount = 0;
        let issuesWithReleaseEndDateCount = 0;
        issues.forEach((issue)=>{
            let startDate;
            let endDate;
            if (baselineStartField.type === (0, $5fACX.DATEFIELD_TYPES).BUILT_IN) startDate = issue[baselineStartField.key];
            else {
                const customFields = issue.customFields;
                startDate = customFields ? customFields[baselineStartField.key] : null;
            }
            if (baselineEndField.type === (0, $5fACX.DATEFIELD_TYPES).BUILT_IN) endDate = issue[baselineEndField.key];
            else {
                const customFields = issue.customFields;
                endDate = customFields ? customFields[baselineEndField.key] : null;
            }
            if (startDate == null && endDate == null) {
                if (issueInferredDateSelection === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).SPRINT && issue.sprint != null) {
                    startInferred += 1;
                    endInferred += 1;
                } else if (issueInferredDateSelection === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).RELEASE) {
                    if (issue.fixVersions && issue.fixVersions.length !== 0) {
                        if ($352fe5c838507bf6$var$inferringReleaseStart(releases, issue.fixVersions)) startInferred += 1;
                        if (issue.fixVersions != null && $352fe5c838507bf6$var$inferringReleaseEnd(releases, issue.fixVersions)) endInferred += 1;
                    }
                }
            }
            if (startDate != null) issuesWithFixedStartDateCount += 1;
            if (endDate != null) issuesWithFixedEndDateCount += 1;
        });
        if (issueInferredDateSelection === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).SPRINT) {
            issuesWithSprintStartDateCount = startInferred;
            issuesWithSprintEndDateCount = endInferred;
        } else if (issueInferredDateSelection === (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).RELEASE) {
            issuesWithReleaseStartDateCount = startInferred;
            issuesWithReleaseEndDateCount = endInferred;
        }
        return {
            issuesWithFixedStartDateCount: issuesWithFixedStartDateCount,
            issuesWithFixedEndDateCount: issuesWithFixedEndDateCount,
            issuesWithSprintStartDateCount: issuesWithSprintStartDateCount,
            issuesWithSprintEndDateCount: issuesWithSprintEndDateCount,
            issuesWithReleaseStartDateCount: issuesWithReleaseStartDateCount,
            issuesWithReleaseEndDateCount: issuesWithReleaseEndDateCount
        };
    };
    const $352fe5c838507bf6$export$76c52757c67889ee = (colourByViewSettings, colourByOption)=>{
        const colours = (0, parcelRequire("bjzU8")).default(colourByViewSettings.colourMaps[colourByOption]).map((colour)=>{
            const colourMessage = (0, $gITL8.colourPickerPaletteLabels)[colour];
            if (colourMessage === undefined || colourMessage.defaultMessage === undefined) return colour;
            return colourMessage.defaultMessage;
        });
        if ((0, parcelRequire("3nPAF")).default(colours)) return {};
        return {
            averageOptionsPerColour: 1,
            colours: colours,
            count: colours.length
        };
    };
    const $352fe5c838507bf6$var$getAverageOptionsPerColour = (colours)=>colours.reduce((acc, { colour: colour, ...rest })=>acc + Object.values(rest)[0].length, 0) / colours.length;
    const $352fe5c838507bf6$var$getColourNames = (colours)=>colours.reduce((acc, { colour: colour })=>{
            if ((0, $4nDwW.isDefined)(colour)) acc.push((0, $gITL8.colourPickerPaletteLabels)[colour]?.defaultMessage || colour);
            return acc;
        }, []);
    const $352fe5c838507bf6$export$dd20b0398a9cbc92 = (colourByViewSettings, colourViewSettings)=>{
        const colours = colourByViewSettings[colourViewSettings];
        if (!(0, $4nDwW.isDefined)(colours) || (0, parcelRequire("3nPAF")).default(colours)) return {};
        return {
            averageOptionsPerColour: $352fe5c838507bf6$var$getAverageOptionsPerColour(colours),
            colours: $352fe5c838507bf6$var$getColourNames(colours),
            count: colours.length
        };
    };
    const $352fe5c838507bf6$export$6076dd623bc4deb = (colourByViewSettings)=>({
            [(0, $gITL8.colourByOptions).COMPONENT]: $352fe5c838507bf6$export$dd20b0398a9cbc92(colourByViewSettings, 'colourComponents'),
            [(0, $gITL8.colourByOptions).ISSUE_TYPE]: $352fe5c838507bf6$export$dd20b0398a9cbc92(colourByViewSettings, 'colourIssueTypes'),
            [(0, $gITL8.colourByOptions).LABEL]: $352fe5c838507bf6$export$dd20b0398a9cbc92(colourByViewSettings, 'colourLabels'),
            [(0, $gITL8.colourByOptions).PRIORITY]: $352fe5c838507bf6$export$dd20b0398a9cbc92(colourByViewSettings, 'colourPriorities'),
            [(0, $gITL8.colourByOptions).PROJECT]: $352fe5c838507bf6$export$76c52757c67889ee(colourByViewSettings, (0, $gITL8.colourByOptions).PROJECT),
            [(0, $gITL8.colourByOptions).STATUS]: $352fe5c838507bf6$export$76c52757c67889ee(colourByViewSettings, (0, $gITL8.colourByOptions).STATUS),
            [(0, $gITL8.colourByOptions).TEAM]: $352fe5c838507bf6$export$76c52757c67889ee(colourByViewSettings, (0, $gITL8.colourByOptions).TEAM)
        });
    const $352fe5c838507bf6$export$b6a1c462ad352e48 = (issue, issueTypesById, projectsById, additionalAttributes = {})=>{
        const issueAttributes = {
            ...(0, $4nDwW.isDefined)(issue.id) && {
                issueId: issue.id
            },
            issueTypeId: issue.type,
            issueType: issueTypesById[issue.type]?.name,
            hierarchyLevel: issue.level,
            isSimplified: projectsById[issue.project]?.isSimplified
        };
        return Object.assign(additionalAttributes, issueAttributes);
    };
    const $352fe5c838507bf6$export$936ca6b7e73b7cfb = (customDateRange, zoomLevel)=>{
        let timelineType;
        let customTimelineType = '';
        switch(zoomLevel){
            case (0, $TTKUQ.ZOOM_LEVELS).WEEKS:
            case (0, $TTKUQ.ZOOM_LEVELS).MONTHS:
            case (0, $TTKUQ.ZOOM_LEVELS).QUARTERS:
            case (0, $TTKUQ.ZOOM_LEVELS).YEARS:
                timelineType = zoomLevel;
                break;
            default:
                timelineType = (0, $TTKUQ.TIMELINE_MODES).CUSTOM;
                if (!(0, parcelRequire("3nPAF")).default(customDateRange)) customTimelineType = customDateRange.typeOfCustomDateRange;
                break;
        }
        return {
            customTimelineType: customTimelineType,
            timelineType: timelineType
        };
    };
    const $352fe5c838507bf6$export$736397007665a3b6 = (error, message)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                packageName: (0, $TTKUQ.PACKAGE_NAME),
                id: (0, $TTKUQ.ERROR_REPORTING_PACKAGE).ROADMAP,
                teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: message
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const $352fe5c838507bf6$export$70447d77c8eef9d = (view)=>{
        const presets = (0, $fOXM3.getPresetViewNames)();
        const viewName = (0, $fOXM3.getMigratedPresetViewName)(view);
        const presetNames = [
            ...Object.values(presets),
            'Untitled'
        ];
        if (presetNames.indexOf(viewName) >= 0) return viewName;
        return 'Custom';
    };
});
parcelRegister("ekiVv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c156b97b27921fcb$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $5PKZw = parcelRequire("5PKZw");
    var $1PbEc = parcelRequire("1PbEc");
    var $a3C3p = parcelRequire("a3C3p");
    const $c156b97b27921fcb$var$appReducer = (0, $5AWLh.combineReducers)({
        domain: $1PbEc.default,
        ui: $a3C3p.default
    });
    const $c156b97b27921fcb$var$rootReducer = (state, action)=>{
        if (action.type === (0, $5PKZw.RESTORE_REDUX_STORE)) return $c156b97b27921fcb$var$appReducer(action.payload, action);
        if (action.type === (0, $5PKZw.RESET_REDUX_STORE)) return $c156b97b27921fcb$var$appReducer(undefined, action);
        return $c156b97b27921fcb$var$appReducer(state, action);
    };
    var $c156b97b27921fcb$export$2e2bcd8739ae039 = $c156b97b27921fcb$var$rootReducer;
});
parcelRegister("1PbEc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a78a25c3d536c2aa$export$2e2bcd8739ae039);
    var $8r8wv;
    var $fZhYM;
    var $bFU4G;
    var $5AWLh = parcelRequire("5AWLh");
    var $1CGdp = parcelRequire("1CGdp");
    var $fP57B = parcelRequire("fP57B");
    var $hyUwT = parcelRequire("hyUwT");
    var $4LQMg = parcelRequire("4LQMg");
    var $bRAUY = parcelRequire("bRAUY");
    var $gFvn5 = parcelRequire("gFvn5");
    var $4vKON = parcelRequire("4vKON");
    var $waHpx = parcelRequire("waHpx");
    var $e70sI = parcelRequire("e70sI");
    var $1JzSf = parcelRequire("1JzSf");
    var $6jtxr = parcelRequire("6jtxr");
    var $8RuCQ = parcelRequire("8RuCQ");
    var $6ilAc = parcelRequire("6ilAc");
    var $91Ud6 = parcelRequire("91Ud6");
    var $6WmT5 = parcelRequire("6WmT5");
    var $fI3Hm = parcelRequire("fI3Hm");
    var $eMdVg = parcelRequire("eMdVg");
    var $gZ60W = parcelRequire("gZ60W");
    var $e46qz = parcelRequire("e46qz");
    var $iZU3k = parcelRequire("iZU3k");
    var $cF8Ig = parcelRequire("cF8Ig");
    var $6C64m = parcelRequire("6C64m");
    var $fwwCN = parcelRequire("fwwCN");
    var $jmZTI = parcelRequire("jmZTI");
    var $djjTM = parcelRequire("djjTM");
    var $j98hI = parcelRequire("j98hI");
    var $fowRS = parcelRequire("fowRS");
    var $k5Usd = parcelRequire("k5Usd");
    var $kwV2P = parcelRequire("kwV2P");
    var $5kRpF = parcelRequire("5kRpF");
    var $9pvTD = parcelRequire("9pvTD");
    var $j0jFd = parcelRequire("j0jFd");
    var $k6GaG = parcelRequire("k6GaG");
    var $XZtO4 = parcelRequire("XZtO4");
    var $6vyDR = parcelRequire("6vyDR");
    var $96USE = parcelRequire("96USE");
    var $25S6Y = parcelRequire("25S6Y");
    var $caw8G = parcelRequire("caw8G");
    var $l8sST = parcelRequire("l8sST");
    var $bt366 = parcelRequire("bt366");
    var $9eef5 = parcelRequire("9eef5");
    var $7CxJ7 = parcelRequire("7CxJ7");
    var $3uAl4 = parcelRequire("3uAl4");
    var $5bPxr = parcelRequire("5bPxr");
    var $1lVR7 = parcelRequire("1lVR7");
    var $flUdG = parcelRequire("flUdG");
    var $iDo90 = parcelRequire("iDo90");
    var $1Gv61 = parcelRequire("1Gv61");
    var $atDoK = parcelRequire("atDoK");
    var $75oAU = parcelRequire("75oAU");
    var $1zxoG = parcelRequire("1zxoG");
    var $l0Sgj = parcelRequire("l0Sgj");
    var $jxA5Y = parcelRequire("jxA5Y");
    var $6OROt = parcelRequire("6OROt");
    var $6NSGj = parcelRequire("6NSGj");
    var $jZcxq = parcelRequire("jZcxq");
    var $6QRPg = parcelRequire("6QRPg");
    var $7IEdi = parcelRequire("7IEdi");
    var $asyNJ = parcelRequire("asyNJ");
    var $lKGSc = parcelRequire("lKGSc");
    var $isNtK = parcelRequire("isNtK");
    var $fHpRV = parcelRequire("fHpRV");
    var $9TzdE = parcelRequire("9TzdE");
    var $jgiLJ = parcelRequire("jgiLJ");
    var $7VKWh = parcelRequire("7VKWh");
    var $9MEZ6 = parcelRequire("9MEZ6");
    var $bWg8d = parcelRequire("bWg8d");
    var $le5Fc = parcelRequire("le5Fc");
    var $4v10j = parcelRequire("4v10j");
    var $36p1o = parcelRequire("36p1o");
    var $eJcEl = parcelRequire("eJcEl");
    var $7vqYD = parcelRequire("7vqYD");
    var $83Ok6 = parcelRequire("83Ok6");
    var $bNf5i = parcelRequire("bNf5i");
    var $fvKei = parcelRequire("fvKei");
    var $NYww6 = parcelRequire("NYww6");
    var $lsSZO = parcelRequire("lsSZO");
    var $k0NEx = parcelRequire("k0NEx");
    var $daVLx = parcelRequire("daVLx");
    var $8Db15 = parcelRequire("8Db15");
    var $7TMvt = parcelRequire("7TMvt");
    var $lzW8Z = parcelRequire("lzW8Z");
    var $bREsp = parcelRequire("bREsp");
    var $7ovQ1 = parcelRequire("7ovQ1");
    var $4KffT = parcelRequire("4KffT");
    var $3VttY = parcelRequire("3VttY");
    var $6Oo0u = parcelRequire("6Oo0u");
    var $lIIFg = parcelRequire("lIIFg");
    var $cGbfF = parcelRequire("cGbfF");
    var $829nG = parcelRequire("829nG");
    var $3v3MM = parcelRequire("3v3MM");
    var $41Ia9 = parcelRequire("41Ia9");
    const $a78a25c3d536c2aa$var$getIssueLimitFlagActions = (appMode, numIssues, limits, more, hiddenFlags)=>{
        const flags = [];
        if (!(0, $1CGdp.isReadOnlyPure)(appMode)) {
            if ((numIssues > limits.absoluteIssueLimit || more) && !(0, $bREsp.isFlagHidden)((0, $9e169ee721864a4b$export$42d68c08a5ace658), hiddenFlags)) flags.push((0, $fI3Hm.pushFlag)({
                key: (0, $9e169ee721864a4b$export$42d68c08a5ace658)
            }));
            else if (numIssues <= limits.absoluteIssueLimit) flags.push((0, $fI3Hm.removeFlag)({
                key: (0, $9e169ee721864a4b$export$42d68c08a5ace658)
            }));
        }
        return flags;
    };
    const $a78a25c3d536c2aa$var$getViewSettingsActions = (issues, filters)=>{
        const dependenciesFilterValue = filters[0, $cGbfF.DEPENDENCIES_FILTER_ID]?.value;
        const removeFilter = dependenciesFilterValue && dependenciesFilterValue.type === 'specificIssue' && !issues.some(({ id: id })=>id === dependenciesFilterValue.issueId);
        return removeFilter ? [
            $lIIFg.change({
                id: (0, $cGbfF.DEPENDENCIES_FILTER_ID),
                value: {
                    type: 'off'
                }
            })
        ] : [];
    };
    const $a78a25c3d536c2aa$var$getIssueData = (state, issues, scenarioRemovedIssues)=>{
        const { originalIssues: originalIssues, hierarchy: hierarchy, issueTypes: issueTypes, projects: projects } = state;
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = state.plan;
        const dateConfiguration = {
            baselineStartField: baselineStartField,
            baselineEndField: baselineEndField
        };
        const releasesDisabledProject = projects.reduce((acc, { isReleasesEnabled: isReleasesEnabled, id: id })=>{
            if (!isReleasesEnabled) acc.push(id);
            return acc;
        }, []);
        const stateIssues = (0, $bREsp.prepareIssues)(issues, {
            levels: hierarchy.levels,
            issueTypes: issueTypes,
            dateConfiguration: dateConfiguration,
            releasesDisabledProject: releasesDisabledProject
        });
        const stateScenarioRemovedIssues = (0, $bREsp.prepareIssues)(scenarioRemovedIssues, {
            levels: hierarchy.levels,
            issueTypes: issueTypes,
            dateConfiguration: dateConfiguration,
            releasesDisabledProject: releasesDisabledProject
        });
        const stateOriginalIssues = (0, $bREsp.prepareOriginalIssues)(issues, dateConfiguration, scenarioRemovedIssues);
        const stateIssueGoals = (0, $bREsp.prepareIssueGoals)(stateIssues, stateOriginalIssues);
        const stateIssueLabels = (0, $bREsp.prepareIssueLabels)(stateIssues, originalIssues);
        const stateIssueLinks = (0, $bREsp.prepareIssueLinks)(issues, state.system.dependencySettingsInfo);
        const customLabelsByField = (0, $bREsp.prepareCustomLabels)(stateIssues, originalIssues, state.customFields);
        return {
            issues: stateIssues,
            scenarioRemovedIssues: stateScenarioRemovedIssues,
            originalIssues: stateOriginalIssues,
            issueLabels: stateIssueLabels,
            issueLinks: stateIssueLinks,
            customLabelsByField: customLabelsByField,
            goalARIs: stateIssueGoals
        };
    };
    const $a78a25c3d536c2aa$var$resetBacklog = (state, payload, extractIssueFn)=>{
        const { app: app, hiddenFlags: hiddenFlags, issueTypes: issueTypes, projects: projects } = state;
        const calculationResult = payload.calculationResult;
        const issuesToProcess = extractIssueFn(payload);
        const stateIssueData = $a78a25c3d536c2aa$var$getIssueData(state, issuesToProcess, payload.scenarioRemovedIssues);
        const flagActions = $a78a25c3d536c2aa$var$getIssueLimitFlagActions(app.mode, stateIssueData.issues.length, state.system.loadingLimitsInfo, payload.more, hiddenFlags);
        const viewSettingsActions = $a78a25c3d536c2aa$var$getViewSettingsActions(stateIssueData.issues, state.viewSettings.filtersV1);
        return {
            viewSettings: viewSettingsActions,
            flags: flagActions,
            issueTypes: [
                (0, $XZtO4.reset)(issueTypes)
            ],
            projects: [
                (0, $lKGSc.reset)(projects)
            ],
            issues: [
                (0, $96USE.reset)(stateIssueData.issues)
            ],
            issueLabels: [
                (0, $fwwCN.reset)(stateIssueData.issueLabels)
            ],
            customLabelsByField: [
                (0, $1JzSf.resetAll)(stateIssueData.customLabelsByField)
            ],
            issueLinks: [
                (0, $djjTM.reset)(stateIssueData.issueLinks)
            ],
            lexorank: [
                $caw8G.resetAdjustments([])
            ],
            scenarioRemovedIssues: [
                (0, $bWg8d.reset)(stateIssueData.scenarioRemovedIssues)
            ],
            solution: calculationResult && !calculationResult.error ? [
                (0, $7vqYD.reset)((0, $bREsp.prepareSolution)(calculationResult))
            ] : [],
            originalIssues: [
                (0, $7CxJ7.reset)(stateIssueData.originalIssues)
            ]
        };
    };
    const $a78a25c3d536c2aa$var$composite = (state, action)=>{
        switch(action.type){
            case 0, $fP57B.SET_PLAN_INFO:
                {
                    const { planInfo: planInfo, planInfo: { crossProjectVersions: crossProjectVersions, customFields: customFields, issueStatuses: issueStatuses, issuePriorityInformation: issuePriorityInformation, issueTypes: issueTypes, projects: projects, sequence: sequence, sprints: sprints, teams: teams, plannedCapacities: plannedCapacities, persons: persons, releaseStatuses: releaseStatuses }, hierarchyInfo: hierarchyInfo, issueStatusCategoryInfo: { issueStatusCategories: issueStatusCategories } } = action.payload;
                    const SET_PLAN_INFO_START_MARK = performance.now();
                    const versions = (0, $bREsp.prepareVersions)(projects, crossProjectVersions, {
                        isPreparingRemovedVersions: false
                    });
                    const removedVersions = (0, $bREsp.prepareVersions)(projects, crossProjectVersions, {
                        isPreparingRemovedVersions: true
                    });
                    const allReleaseStatuses = (0, $bREsp.prepareReleaseStatuses)(releaseStatuses);
                    const existingCrossProjectVersions = (0, $bREsp.prepareCrossProjectVersions)(crossProjectVersions, versions, {
                        isPreparingDeletedCrossProjectVersions: false
                    });
                    const deletedCrossProjectVersions = (0, $bREsp.prepareCrossProjectVersions)(crossProjectVersions, versions, {
                        isPreparingDeletedCrossProjectVersions: true
                    });
                    const preparedPlannedCapacities = (0, $bREsp.prepareWRMPlannedCapacities)(plannedCapacities);
                    const preparedOriginalPlannedCapacities = (0, $bREsp.prepareWRMOriginalPlannedCapacities)(plannedCapacities);
                    const [preparedSprints, disabledSprints] = (0, parcelRequire("8r8wv")).default((x)=>x.isDisabled !== true)((0, $bREsp.prepareSprints)(sprints, planInfo));
                    const preparedHierarchyInfo = {
                        levels: hierarchyInfo.levels
                    };
                    const result = {
                        crossProjectVersions: [
                            (0, $gFvn5.reset)(existingCrossProjectVersions)
                        ],
                        customFields: [
                            (0, $waHpx.reset)(customFields)
                        ],
                        hierarchy: [
                            (0, $e46qz.reset)(preparedHierarchyInfo)
                        ],
                        issueTypes: [
                            (0, $XZtO4.reset)(issueTypes)
                        ],
                        plan: [
                            (0, $jZcxq.reset)((0, $bREsp.preparePlan)(planInfo))
                        ],
                        projects: [
                            (0, $lKGSc.reset)((0, $bREsp.prepareProjects)(projects, issuePriorityInformation))
                        ],
                        sequence: sequence ? [
                            (0, $36p1o.reset)(sequence)
                        ] : [],
                        versions: [
                            (0, $3VttY.reset)(versions)
                        ],
                        sprints: [
                            (0, $bNf5i.reset)(preparedSprints)
                        ],
                        disabledSprints: [
                            (0, $8RuCQ.reset)(disabledSprints)
                        ],
                        plannedCapacities: [
                            (0, $7IEdi.reset)(preparedPlannedCapacities)
                        ],
                        teams: [
                            (0, $k0NEx.reset)((0, $bREsp.prepareTeams)(teams))
                        ],
                        issueStatusCategories: issueStatusCategories ? [
                            (0, $5kRpF.reset)(issueStatusCategories)
                        ] : [],
                        issuePriorities: [
                            (0, $k5Usd.reset)(issuePriorityInformation.issuePriorities)
                        ],
                        issueStatuses: [
                            (0, $j0jFd.reset)(issueStatuses)
                        ],
                        releaseStatuses: [
                            (0, $7ovQ1.reset)(allReleaseStatuses)
                        ],
                        removedCrossProjectVersions: [
                            (0, $fHpRV.reset)(deletedCrossProjectVersions)
                        ],
                        removedVersions: [
                            (0, $jgiLJ.reset)(removedVersions)
                        ],
                        originalVersions: [
                            (0, $75oAU.reset)((0, $bREsp.prepareOriginalVersions)(projects, crossProjectVersions))
                        ],
                        originalCrossProjectVersions: [
                            (0, $bt366.reset)((0, $bREsp.prepareOriginalCrossProjectVersions)(crossProjectVersions))
                        ],
                        originalPlannedCapacities: [
                            (0, $5bPxr.reset)(preparedOriginalPlannedCapacities)
                        ],
                        originalTeams: [
                            (0, $1Gv61.reset)((0, $bREsp.prepareOriginalTeams)(teams))
                        ],
                        originalResources: [
                            (0, $flUdG.reset)((0, $bREsp.prepareOriginalResources)(teams))
                        ],
                        persons: [
                            (0, $jxA5Y.reset)(persons)
                        ]
                    };
                    (0, (0, parcelRequire("bFU4G")).addSpanToAll)('reducer', (0, $fP57B.SET_PLAN_INFO), [
                        {
                            name: 'redux'
                        }
                    ], SET_PLAN_INFO_START_MARK);
                    return result;
                }
            case 0, $fP57B.RESET_BACKLOG:
                return $a78a25c3d536c2aa$var$resetBacklog(state, action.payload, (backlog)=>backlog.issues);
            case 0, $fP57B.UPDATE_ISSUE_REFERENCES:
                {
                    const { oldId: oldId, newId: newId } = action.payload;
                    const actions = {};
                    const dependenciesFilterValue = (0, parcelRequire("fZhYM")).default([
                        (0, $cGbfF.DEPENDENCIES_FILTER_ID),
                        'value'
                    ], state.viewSettings.filtersV1);
                    if (dependenciesFilterValue && dependenciesFilterValue.type === 'specificIssue' && dependenciesFilterValue.issueId === oldId) actions.viewSettings = [
                        $lIIFg.change({
                            id: (0, $cGbfF.DEPENDENCIES_FILTER_ID),
                            value: {
                                ...dependenciesFilterValue,
                                issueId: newId
                            }
                        })
                    ];
                    let bulkIssuesUpdates = {
                        [oldId]: {
                            id: newId
                        }
                    };
                    bulkIssuesUpdates = state.issues.filter(({ parent: parent })=>parent === oldId).reduce((payload, { id: id })=>{
                        payload[id] = {
                            parent: newId
                        };
                        return payload;
                    }, bulkIssuesUpdates);
                    actions.issues = [
                        (0, $96USE.bulkUpdate)(bulkIssuesUpdates)
                    ];
                    return actions;
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return {};
                }
        }
    };
    var $a78a25c3d536c2aa$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        app: $hyUwT.default,
        assignees: $4LQMg.default,
        crossProjectVersions: $4vKON.default,
        customFields: $e70sI.default,
        externalIssues: $91Ud6.default,
        flags: $eMdVg.default,
        goals: $6C64m.default,
        hiddenFlags: $gZ60W.default,
        hierarchy: $iZU3k.default,
        issues: $25S6Y.default,
        issueLabels: $jmZTI.default,
        issueLinks: $j98hI.default,
        issueModal: $fowRS.default,
        issuePriorities: $kwV2P.default,
        issueStatusCategories: $9pvTD.default,
        issueStatuses: $k6GaG.default,
        issueTypes: $6vyDR.default,
        lexorank: $l8sST.default,
        originalCrossProjectVersions: $9eef5.default,
        originalIssues: $3uAl4.default,
        originalPlannedCapacities: $1lVR7.default,
        originalTeams: $atDoK.default,
        originalResources: $iDo90.default,
        originalVersions: $1zxoG.default,
        permissions: $l0Sgj.default,
        persons: $6OROt.default,
        plan: $6QRPg.default,
        planDefaults: $6NSGj.default,
        projects: $isNtK.default,
        releaseStatuses: $4KffT.default,
        reporters: $9MEZ6.default,
        removedCrossProjectVersions: $9TzdE.default,
        removedVersions: $7VKWh.default,
        scenarioRemovedIssues: $le5Fc.default,
        sequence: $eJcEl.default,
        solution: $83Ok6.default,
        sprints: $fvKei.default,
        plannedCapacities: $asyNJ.default,
        system: $NYww6.default,
        teams: $daVLx.default,
        teamsAdditional: $lsSZO.default,
        updateJira: $8Db15.default,
        versions: $6Oo0u.default,
        warnings: $41Ia9.default,
        historyIssues: $cF8Ig.default,
        selectOptions: $4v10j.default,
        customLabelsByField: $6jtxr.default,
        userPickerOptions: $lzW8Z.default,
        userIsOnboarded: $7TMvt.default,
        externalSprints: $6WmT5.default,
        disabledSprints: $6ilAc.default,
        viewSettings: $829nG.default,
        views: $3v3MM.default,
        associatedIssues: $bRAUY.associatedIssuesDomainReducer
    }, $a78a25c3d536c2aa$var$composite);
});
parcelRegister("4LQMg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91a573db4a3213a3$export$2e2bcd8739ae039);
    var $4DrGU;
    var $fZhYM;
    var $bjzU8;
    var $c8uhD = parcelRequire("c8uhD");
    const $91a573db4a3213a3$var$initialState = {
        issueAssigneeMap: {},
        assigneeList: []
    };
    const $91a573db4a3213a3$export$fff63944c1108d5c = (existingPeople, newPeople)=>{
        const indexedExistingPeople = (0, parcelRequire("4DrGU")).default((0, parcelRequire("fZhYM")).default([
            'jiraUser',
            'accountId'
        ]), existingPeople);
        const indexedNewPeople = (0, parcelRequire("4DrGU")).default((0, parcelRequire("fZhYM")).default([
            'jiraUser',
            'accountId'
        ]), newPeople);
        const mergedUsers = {
            ...indexedExistingPeople,
            ...indexedNewPeople
        };
        return (0, parcelRequire("bjzU8")).default(mergedUsers);
    };
    var $91a573db4a3213a3$export$2e2bcd8739ae039 = (state = $91a573db4a3213a3$var$initialState, action)=>{
        switch(action.type){
            case 0, $c8uhD.UPDATE_ISSUE_ASSIGNEE_MAP:
                return {
                    ...state,
                    issueAssigneeMap: {
                        ...state.issueAssigneeMap,
                        ...action.payload
                    }
                };
            case 0, $c8uhD.UPDATE_ASSIGNEES_LIST:
                {
                    const { people: people } = action.payload;
                    return {
                        ...state,
                        assigneeList: $91a573db4a3213a3$export$fff63944c1108d5c(state.assigneeList, people)
                    };
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("bRAUY", function(module, exports) {
    $parcel$export(module.exports, "associatedIssuesDomainReducer", ()=>$0477a2ec61a0c1b2$export$cff9c7286adf7959);
    var $apXzN;
    var $6wsPo = parcelRequire("6wsPo");
    const $0477a2ec61a0c1b2$export$cff9c7286adf7959 = (state = (0, (0, parcelRequire("apXzN")).initialState), action)=>{
        switch(action.type){
            case 0, $6wsPo.SET_ASSOCIATED_ISSUES:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("4vKON", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe0406a43522435c$export$2e2bcd8739ae039);
    var $ik0Qc;
    var $bREsp = parcelRequire("bREsp");
    var $gFvn5 = parcelRequire("gFvn5");
    const $fe0406a43522435c$var$initialState = [];
    var $fe0406a43522435c$export$2e2bcd8739ae039 = (state = $fe0406a43522435c$var$initialState, action)=>{
        switch(action.type){
            case 0, $gFvn5.RESET:
                return [
                    ...action.payload
                ];
            case 0, $gFvn5.ADD:
                return [
                    ...state,
                    action.payload
                ];
            case 0, $gFvn5.REMOVE:
                {
                    const removedId = action.payload;
                    return state.filter(({ id: id })=>id !== removedId);
                }
            case 0, $gFvn5.BULK_UPDATE:
                {
                    const { payload: payload } = action;
                    const result = [];
                    for (const item of state){
                        const patch = payload[item.id];
                        if (patch) result.push((0, parcelRequire("ik0Qc")).default(item, patch));
                        else result.push(item);
                    }
                    return result;
                }
            case 0, $gFvn5.ADD_VERSION_IN_CROSS_PROJECT_VERSION:
                {
                    const { crossProjectVersionId: crossProjectVersionId, versionId: versionId } = action.payload;
                    return [
                        ...state.map((crossProjectVersion)=>{
                            const { id: id, versions: versions } = crossProjectVersion;
                            if (id === crossProjectVersionId) return {
                                ...crossProjectVersion,
                                versions: [
                                    ...versions,
                                    versionId
                                ]
                            };
                            return crossProjectVersion;
                        })
                    ];
                }
            case 0, $gFvn5.REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION:
                {
                    const { crossProjectVersionId: crossProjectVersionId, versionId: versionId } = action.payload;
                    return [
                        ...state.map((crossProjectVersion)=>{
                            const { id: id, versions: versions } = crossProjectVersion;
                            if (id === crossProjectVersionId) return {
                                ...crossProjectVersion,
                                versions: versions.filter((vid)=>vid !== versionId)
                            };
                            return crossProjectVersion;
                        })
                    ];
                }
            case 0, $gFvn5.UPDATE_REFERENCES:
                return (0, $bREsp.updateRefs)(state, action.payload);
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("e70sI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7eb17cb6b67ce517$export$2e2bcd8739ae039);
    var $ik0Qc;
    var $waHpx = parcelRequire("waHpx");
    const $7eb17cb6b67ce517$var$initialState = [];
    var $7eb17cb6b67ce517$export$2e2bcd8739ae039 = (state = $7eb17cb6b67ce517$var$initialState, action)=>{
        switch(action.type){
            case 0, $waHpx.RESET:
                return [
                    ...action.payload
                ];
            case 0, $waHpx.ADD:
                return [
                    ...state,
                    ...action.payload
                ];
            case 0, $waHpx.UPDATE:
                {
                    const { payload: payload } = action;
                    return state.map((customField)=>{
                        if (customField.id === payload.id) return (0, parcelRequire("ik0Qc")).default(customField, payload);
                        return customField;
                    });
                }
            case 0, $waHpx.REMOVE:
                return state.filter((field)=>field.id !== action.payload);
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("6jtxr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a58a75f9b61b1b26$export$2e2bcd8739ae039);
    var $1JzSf = parcelRequire("1JzSf");
    const $a58a75f9b61b1b26$var$initialState = {};
    var $a58a75f9b61b1b26$export$2e2bcd8739ae039 = (state = $a58a75f9b61b1b26$var$initialState, action)=>{
        switch(action.type){
            case 0, $1JzSf.RESET_ALL:
                return action.payload;
            case 0, $1JzSf.RESET:
                {
                    const { customFieldId: customFieldId, labels: labels } = action.payload;
                    return {
                        ...state,
                        [customFieldId]: labels.sort()
                    };
                }
            case 0, $1JzSf.ADD:
                {
                    const { customFieldId: customFieldId, labels: labels } = action.payload;
                    const labelsSet = new Set((state[customFieldId] || []).concat(labels));
                    return {
                        ...state,
                        [customFieldId]: Array.from(labelsSet).sort()
                    };
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("6ilAc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee1f8060e300b905$export$2e2bcd8739ae039);
    var $8RuCQ = parcelRequire("8RuCQ");
    const $ee1f8060e300b905$var$initialState = [];
    var $ee1f8060e300b905$export$2e2bcd8739ae039 = (state = $ee1f8060e300b905$var$initialState, action)=>{
        switch(action.type){
            case 0, $8RuCQ.RESET:
                return action.payload.map((sprint)=>({
                        ...sprint,
                        id: sprint.id.toString()
                    }));
            case 0, $8RuCQ.ADD:
                return [
                    ...state,
                    ...action.payload.map((sprint)=>({
                            ...sprint,
                            id: sprint.id.toString()
                        }))
                ];
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("91Ud6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32884065339cb6fd$export$2e2bcd8739ae039);
    var $gPkyZ = parcelRequire("gPkyZ");
    const $32884065339cb6fd$var$initialState = {};
    var $32884065339cb6fd$export$2e2bcd8739ae039 = (state = $32884065339cb6fd$var$initialState, action)=>{
        switch(action.type){
            case 0, $gPkyZ.ADD:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("6WmT5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6f60c3b6a3c21bf$export$2e2bcd8739ae039);
    var $3W33Z = parcelRequire("3W33Z");
    const $a6f60c3b6a3c21bf$var$initialState = [];
    var $a6f60c3b6a3c21bf$export$2e2bcd8739ae039 = (state = $a6f60c3b6a3c21bf$var$initialState, action)=>{
        switch(action.type){
            case 0, $3W33Z.RESET:
                return action.payload.map((sprint)=>({
                        ...sprint,
                        id: sprint.id.toString()
                    }));
            case 0, $3W33Z.ADD:
                return [
                    ...state,
                    ...action.payload.map((sprint)=>({
                            ...sprint,
                            id: sprint.id.toString()
                        }))
                ];
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("eMdVg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cdf7fb4482dadd45$export$2e2bcd8739ae039);
    var $fI3Hm = parcelRequire("fI3Hm");
    const $cdf7fb4482dadd45$var$initialState = [];
    const $cdf7fb4482dadd45$var$pushFlag = (state, key, context)=>[
            {
                key: key,
                context: context
            }
        ].concat(state.filter(({ key: previousFlagKey })=>previousFlagKey !== key));
    const $cdf7fb4482dadd45$var$removeFlagOccurrenceFromState = (state, key)=>{
        const filteredState = state.filter(({ key: previousFlagKey })=>previousFlagKey !== key);
        return filteredState;
    };
    const $cdf7fb4482dadd45$var$removeLatestFlag = (state)=>{
        const topFlagRemoved = state.slice(1);
        return topFlagRemoved;
    };
    function $cdf7fb4482dadd45$export$2e2bcd8739ae039(state = $cdf7fb4482dadd45$var$initialState, action) {
        switch(action.type){
            case 0, $fI3Hm.PUSH_FLAG:
                {
                    const { payload: { key: key, context: context } } = action;
                    return $cdf7fb4482dadd45$var$pushFlag(state, key, context);
                }
            case 0, $fI3Hm.REMOVE_FLAG:
                return $cdf7fb4482dadd45$var$removeFlagOccurrenceFromState(state, action.payload.key);
            case 0, $fI3Hm.DISMISS_FLAG:
                return $cdf7fb4482dadd45$var$removeLatestFlag(state);
            default:
                return state;
        }
    }
});
parcelRegister("gZ60W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$396941b2ff401ba6$export$2e2bcd8739ae039);
    var $b9Xhh = parcelRequire("b9Xhh");
    var $bqD5G = parcelRequire("bqD5G");
    var $dlYZF = parcelRequire("dlYZF");
    const $396941b2ff401ba6$var$initialState = {};
    const $396941b2ff401ba6$var$oneWeek = 604800000;
    const $396941b2ff401ba6$var$MAX_MULTIPLIER = 3;
    const $396941b2ff401ba6$var$calculateWeeksTime = (multiplier)=>Date.now() + $396941b2ff401ba6$var$oneWeek * 2 * multiplier;
    const $396941b2ff401ba6$var$updateHiddenFlagDate = (state, flag)=>{
        if (state[flag]) {
            const currentMultiplier = state[flag].multiplier;
            const newMultiplier = currentMultiplier < $396941b2ff401ba6$var$MAX_MULTIPLIER ? currentMultiplier + 1 : $396941b2ff401ba6$var$MAX_MULTIPLIER;
            return {
                ...state,
                [flag]: {
                    multiplier: newMultiplier,
                    hiddenUntilTimestamp: $396941b2ff401ba6$var$calculateWeeksTime(newMultiplier)
                }
            };
        }
        return {
            ...state,
            [flag]: {
                multiplier: 1,
                hiddenUntilTimestamp: $396941b2ff401ba6$var$calculateWeeksTime(1)
            }
        };
    };
    const $396941b2ff401ba6$var$clearHiddenFlagDate = (state, flag)=>{
        const nextState = {
            ...state
        };
        delete nextState[flag];
        return nextState;
    };
    function $396941b2ff401ba6$var$reducer(state = $396941b2ff401ba6$var$initialState, action) {
        switch(action.type){
            case 0, $dlYZF.UPDATE_HIDDEN_FLAG_DATE:
                return $396941b2ff401ba6$var$updateHiddenFlagDate(state, action.payload.key);
            case 0, $dlYZF.CLEAR_HIDDEN_FLAG_DATE:
                return $396941b2ff401ba6$var$clearHiddenFlagDate(state, action.payload.key);
            default:
                return state;
        }
    }
    var $396941b2ff401ba6$export$2e2bcd8739ae039 = (0, $b9Xhh.persistReducer)({
        key: (0, $bqD5G.getPlanPrefixedKey)('hidden-flags')
    }, $396941b2ff401ba6$var$reducer);
});
parcelRegister("e46qz", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$0da966f0509c9a41$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$0da966f0509c9a41$export$aad8462122ac592b);
    const $0da966f0509c9a41$export$4a991c87e640ef77 = 'state.domain.hierarchy.RESET';
    const $0da966f0509c9a41$export$aad8462122ac592b = (payload)=>({
            type: $0da966f0509c9a41$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("iZU3k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7444b821a5ae2da3$export$2e2bcd8739ae039);
    var $e46qz = parcelRequire("e46qz");
    const $7444b821a5ae2da3$var$initialState = {
        levels: []
    };
    const $7444b821a5ae2da3$var$hierarchyReducer = (state = $7444b821a5ae2da3$var$initialState, action)=>{
        switch(action.type){
            case 0, $e46qz.RESET:
                return {
                    levels: action.payload.levels
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
    var $7444b821a5ae2da3$export$2e2bcd8739ae039 = $7444b821a5ae2da3$var$hierarchyReducer;
});
parcelRegister("cF8Ig", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dd71875ccb178bc7$export$2e2bcd8739ae039);
    var $jNv9f = parcelRequire("jNv9f");
    const $dd71875ccb178bc7$var$initialState = [];
    var $dd71875ccb178bc7$export$2e2bcd8739ae039 = (state = $dd71875ccb178bc7$var$initialState, action)=>{
        switch(action.type){
            case 0, $jNv9f.RESET:
                return action.payload;
            case 0, $jNv9f.UPDATE_PARENT:
                {
                    const { id: id, parent: parent } = action.payload;
                    return state.map((historyIssue)=>{
                        if (historyIssue.id === id) return {
                            ...historyIssue,
                            parent: parent
                        };
                        return historyIssue;
                    });
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("6C64m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e786cac8a3679e9$export$2e2bcd8739ae039);
    var $3jjep = parcelRequire("3jjep");
    const $4e786cac8a3679e9$var$initialState = {
        lazyGoalsByARI: {},
        searchesInProgress: 0
    };
    var $4e786cac8a3679e9$export$2e2bcd8739ae039 = (state = $4e786cac8a3679e9$var$initialState, action)=>{
        switch(action.type){
            case 0, $3jjep.FETCH_GOALS_START:
                return {
                    ...state,
                    lazyGoalsByARI: {
                        ...action.payload,
                        ...state.lazyGoalsByARI
                    }
                };
            case 0, $3jjep.FETCH_GOALS_SUCCESS:
                return {
                    ...state,
                    lazyGoalsByARI: {
                        ...state.lazyGoalsByARI,
                        ...action.payload
                    }
                };
            case 0, $3jjep.FETCH_GOALS_FAIL:
                return {
                    ...state,
                    lazyGoalsByARI: {
                        ...state.lazyGoalsByARI,
                        ...action.payload
                    }
                };
            case 0, $3jjep.SEARCH_GOALS_START:
                return {
                    ...state,
                    searchesInProgress: state.searchesInProgress + 1
                };
            case 0, $3jjep.SEARCH_GOALS_SUCCESS:
                return {
                    ...state,
                    lazyGoalsByARI: {
                        ...state.lazyGoalsByARI,
                        ...action.payload
                    },
                    searchesInProgress: Math.min(state.searchesInProgress - 1, 0)
                };
            case 0, $3jjep.SEARCH_GOALS_FAIL:
                return {
                    ...state,
                    searchesInProgress: Math.min(state.searchesInProgress - 1, 0)
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("jmZTI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b873df3c64783171$export$2e2bcd8739ae039);
    var $fwwCN = parcelRequire("fwwCN");
    const $b873df3c64783171$var$initialState = [];
    var $b873df3c64783171$export$2e2bcd8739ae039 = (state = $b873df3c64783171$var$initialState, action)=>{
        switch(action.type){
            case 0, $fwwCN.ADD:
                return [
                    ...state,
                    action.payload
                ].sort();
            case 0, $fwwCN.RESET:
                return action.payload;
            case 0, $fwwCN.REMOVE:
                return state.filter((label)=>label !== action.payload).sort();
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("j98hI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$970753d931c1245b$export$2e2bcd8739ae039);
    var $2XSIf;
    var $bWXax;
    var $bCilb;
    var $4nDwW = parcelRequire("4nDwW");
    var $djjTM = parcelRequire("djjTM");
    const $970753d931c1245b$var$initialState = {
        values: {},
        originals: {}
    };
    const $970753d931c1245b$var$updateLink = (f, { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey }, state)=>(0, parcelRequire("bCilb")).default({
            values: {
                [sourceItemKey]: f,
                [targetItemKey]: f
            }
        }, state);
    var $970753d931c1245b$export$2e2bcd8739ae039 = (state = $970753d931c1245b$var$initialState, action)=>{
        const { values: values } = state;
        switch(action.type){
            case 0, $djjTM.ADD:
                {
                    const { pendingKey: pendingKey, ...link } = action.payload;
                    const { itemKey: itemKey, sourceItemKey: sourceItemKey, targetItemKey: targetItemKey } = link;
                    if (!values[sourceItemKey]) values[sourceItemKey] = {};
                    if (!values[targetItemKey]) values[targetItemKey] = {};
                    const optimisticState = $970753d931c1245b$var$updateLink((0, parcelRequire("2XSIf")).default(itemKey, link), link, state);
                    if ((0, $4nDwW.isDefined)(pendingKey)) return $970753d931c1245b$var$updateLink((0, parcelRequire("bWXax")).default(pendingKey), link, optimisticState);
                    return optimisticState;
                }
            case 0, $djjTM.RESET:
                return action.payload;
            case 0, $djjTM.REMOVE:
                {
                    const link = action.payload;
                    return $970753d931c1245b$var$updateLink((0, parcelRequire("bWXax")).default(link.itemKey), link, state);
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("fowRS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9de83237720b079$export$2e2bcd8739ae039);
    var $g1lIV = parcelRequire("g1lIV");
    const $c9de83237720b079$export$d4c72bab9d6cc13a = {
        issueBeingEdited: null,
        isLoadingIssueDescription: false
    };
    const $c9de83237720b079$var$reducer = (state = $c9de83237720b079$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $g1lIV.SET_ISSUE_BEING_EDITED:
                return {
                    ...state,
                    issueBeingEdited: action.payload
                };
            case 0, $g1lIV.SET_LOADING_ISSUE_DESCRIPTION:
                return {
                    ...state,
                    isLoadingIssueDescription: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    var $c9de83237720b079$export$2e2bcd8739ae039 = $c9de83237720b079$var$reducer;
});
parcelRegister("kwV2P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b001a80a9b2eeb09$export$2e2bcd8739ae039);
    var $k5Usd = parcelRequire("k5Usd");
    const $b001a80a9b2eeb09$var$initialState = {};
    var $b001a80a9b2eeb09$export$2e2bcd8739ae039 = (state = $b001a80a9b2eeb09$var$initialState, action)=>{
        switch(action.type){
            case 0, $k5Usd.RESET:
                return action.payload;
            case 0, $k5Usd.ADD:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                return state;
        }
    };
});
parcelRegister("5kRpF", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$d944e6320b89eac6$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$d944e6320b89eac6$export$aad8462122ac592b);
    const $d944e6320b89eac6$export$4a991c87e640ef77 = 'state.domain.issue-status-categories.RESET';
    const $d944e6320b89eac6$export$aad8462122ac592b = (payload)=>({
            type: $d944e6320b89eac6$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("9pvTD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8faa0c72f05c61ba$export$2e2bcd8739ae039);
    var $5kRpF = parcelRequire("5kRpF");
    const $8faa0c72f05c61ba$var$initialState = [];
    var $8faa0c72f05c61ba$export$2e2bcd8739ae039 = (state = $8faa0c72f05c61ba$var$initialState, action)=>{
        switch(action.type){
            case 0, $5kRpF.RESET:
                return [
                    ...action.payload
                ];
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("j0jFd", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$846b1b3a05aee3f4$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$846b1b3a05aee3f4$export$aad8462122ac592b);
    const $846b1b3a05aee3f4$export$4a991c87e640ef77 = 'state.domain.issue-statuses.RESET';
    const $846b1b3a05aee3f4$export$aad8462122ac592b = (payload)=>({
            type: $846b1b3a05aee3f4$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("k6GaG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$233ce3938d59faa0$export$2e2bcd8739ae039);
    var $j0jFd = parcelRequire("j0jFd");
    const $233ce3938d59faa0$var$initialState = [];
    var $233ce3938d59faa0$export$2e2bcd8739ae039 = (state = $233ce3938d59faa0$var$initialState, action)=>{
        switch(action.type){
            case 0, $j0jFd.RESET:
                return [
                    ...action.payload
                ];
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("6vyDR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aeeeac008e6cfdc3$export$2e2bcd8739ae039);
    var $XZtO4 = parcelRequire("XZtO4");
    const $aeeeac008e6cfdc3$var$initialState = [];
    var $aeeeac008e6cfdc3$export$2e2bcd8739ae039 = (state = $aeeeac008e6cfdc3$var$initialState, action)=>{
        switch(action.type){
            case 0, $XZtO4.RESET:
                return action.payload.map(({ id: id, ...rest })=>({
                        ...rest,
                        id: parseInt(id, 10)
                    }));
            case 0, $XZtO4.ADD:
                return [
                    ...state,
                    ...action.payload.map(({ id: id, ...rest })=>({
                            ...rest,
                            id: parseInt(id, 10)
                        }))
                ];
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("25S6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$051ac33faf0c4ad4$export$2e2bcd8739ae039);
    var $02IP9;
    var $2XSIf;
    var $64Ty4;
    var $c4FLA;
    var $ik0Qc;
    var $5H7dz;
    var $sqeVT;
    var $48UFW;
    var $2vokC = parcelRequire("2vokC");
    var $4nDwW = parcelRequire("4nDwW");
    var $96USE = parcelRequire("96USE");
    const $051ac33faf0c4ad4$var$initialState = [];
    const $051ac33faf0c4ad4$var$mergeIssueValues = (key, stateValue, payloadValue)=>key === 'customFields' ? (0, parcelRequire("ik0Qc")).default(stateValue, payloadValue) : payloadValue;
    var $051ac33faf0c4ad4$export$2e2bcd8739ae039 = (state = $051ac33faf0c4ad4$var$initialState, action)=>{
        switch(action.type){
            case 0, $96USE.RESET:
                return [
                    ...action.payload
                ];
            case 0, $96USE.UPDATE:
                {
                    const { payload: payload } = action;
                    const index = state.findIndex(({ id: id })=>id === payload.id);
                    return (0, parcelRequire("02IP9")).default(index, (issue)=>(0, parcelRequire("5H7dz")).default($051ac33faf0c4ad4$var$mergeIssueValues, issue, payload), state);
                }
            case 0, $96USE.BULK_LABEL_UPDATE:
                {
                    const { payload: payload } = action;
                    const applyPatch = (issue)=>{
                        const issueUpdate = payload[issue.id];
                        if (!(0, $4nDwW.isDefined)(issueUpdate)) return issue;
                        const patch = {
                            labels: issueUpdate.labels?.value
                        };
                        switch(issueUpdate.labels?.fieldAction){
                            case (0, $2vokC.FieldAction).ADD:
                                patch.labels = (0, parcelRequire("48UFW")).default(patch.labels, issue.labels || []);
                                break;
                            case (0, $2vokC.FieldAction).REMOVE:
                                patch.labels = issue.labels?.filter((label)=>!patch.labels.includes(label));
                                break;
                            default:
                                break;
                        }
                        return (0, parcelRequire("5H7dz")).default($051ac33faf0c4ad4$var$mergeIssueValues, issue, patch);
                    };
                    return state.map(applyPatch);
                }
            case 0, $96USE.BULK_UPDATE:
                {
                    const { payload: payload } = action;
                    const applyPatch = (issue)=>{
                        const patch = payload[issue.id];
                        if (!(0, $4nDwW.isDefined)(patch)) return issue;
                        return (0, parcelRequire("5H7dz")).default($051ac33faf0c4ad4$var$mergeIssueValues, issue, patch);
                    };
                    return state.map(applyPatch);
                }
            case 0, $96USE.ADD:
                {
                    const parentId = action.payload.parent;
                    const position = parentId ? (0, parcelRequire("64Ty4")).default((0, parcelRequire("sqeVT")).default('id', parentId), state) : -1;
                    if (position >= 0) return (0, parcelRequire("c4FLA")).default(position + 1, action.payload, state);
                    return [
                        ...state,
                        action.payload
                    ];
                }
            case 0, $96USE.RANK:
                {
                    const { payload: { itemKeys: [id], anchor: anchor } } = action;
                    if (anchor === undefined) return state;
                    const movedIssueIndex = state.findIndex((issue)=>issue.id === id);
                    const anchorIssue = state.find((issue)=>issue.id === anchor);
                    if (!anchorIssue) throw new Error(`Anchor with id ${anchor} not found!`);
                    return (0, parcelRequire("02IP9")).default(movedIssueIndex, (0, parcelRequire("2XSIf")).default('lexoRank', anchorIssue.lexoRank), state);
                }
            case 0, $96USE.BULK_RANK:
                {
                    const { payload: { itemKeys: itemKeys, anchor: anchor } } = action;
                    const itemKeysSet = new Set(itemKeys);
                    if (anchor === undefined) return state;
                    const anchorIssue = state.find((el)=>el.id === anchor);
                    if (!anchorIssue) throw new Error(`Anchor with id ${anchor} not found!`);
                    const lexoRank = anchorIssue.lexoRank;
                    const result = [];
                    for (const issue of state)if (itemKeysSet.has(issue.id)) result.push({
                        ...issue,
                        lexoRank: lexoRank
                    });
                    else result.push(issue);
                    return result;
                }
            case 0, $96USE.REMOVE_WITHOUT_ISSUE_KEY:
                return state.filter(({ issueKey: issueKey })=>issueKey);
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("c4FLA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ca641b5fa44d235$export$2e2bcd8739ae039);
    var $IYMZh;
    var $8ca641b5fa44d235$var$insert = (0, (0, parcelRequire("IYMZh")).default)(function insert(idx, elt, list) {
        idx = idx < list.length && idx >= 0 ? idx : list.length;
        var result = Array.prototype.slice.call(list, 0);
        result.splice(idx, 0, elt);
        return result;
    });
    var $8ca641b5fa44d235$export$2e2bcd8739ae039 = $8ca641b5fa44d235$var$insert;
});
parcelRegister("l8sST", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$124ac724ccdee484$export$2e2bcd8739ae039);
    var $2XSIf;
    var $c4FLA;
    var $8jZmX;
    var $ik0Qc;
    var $caw8G = parcelRequire("caw8G");
    const $124ac724ccdee484$var$initialState = {
        issueAdjustments: [],
        versionAdjustments: []
    };
    var $124ac724ccdee484$export$2e2bcd8739ae039 = (state = $124ac724ccdee484$var$initialState, action)=>{
        const actionType = action.type;
        switch(actionType){
            case 0, $caw8G.RESET_ADJUSTMENTS:
                return (0, parcelRequire("ik0Qc")).default(state, {
                    issueAdjustments: [
                        ...action.payload
                    ]
                });
            case 0, $caw8G.ADJUST_ISSUE_LEXORANK:
                {
                    const { anchor: anchor, itemKeys: [id], relation: relation } = action.payload;
                    if (anchor === undefined) return state;
                    const adjustments = state.issueAdjustments.filter((x)=>x !== id);
                    const anchorAdjustment = adjustments.indexOf(anchor);
                    if (anchorAdjustment < 0) {
                        const items = relation === 'AFTER' ? [
                            anchor,
                            id
                        ] : [
                            id,
                            anchor
                        ];
                        return (0, parcelRequire("2XSIf")).default('issueAdjustments', [
                            ...adjustments,
                            ...items
                        ], state);
                    }
                    const adjustment = anchorAdjustment + (relation === 'AFTER' ? 1 : 0);
                    return (0, parcelRequire("2XSIf")).default('issueAdjustments', (0, parcelRequire("c4FLA")).default(adjustment, id, adjustments), state);
                }
            case 0, $caw8G.BULK_ADJUST_ISSUE_LEXORANK:
                {
                    const { anchor: anchor, itemKeys: itemKeys, relation: relation } = action.payload;
                    const itemKeysSet = new Set(itemKeys);
                    const adjustments = state.issueAdjustments.filter((id)=>!itemKeysSet.has(id));
                    if (relation === 'LAST') return (0, parcelRequire("2XSIf")).default('issueAdjustments', [
                        ...adjustments,
                        ...itemKeys
                    ], state);
                    if (anchor === undefined) return state;
                    const anchorAdjustment = adjustments.indexOf(anchor);
                    if (anchorAdjustment < 0) {
                        const items = relation === 'AFTER' ? [
                            anchor,
                            ...itemKeys
                        ] : [
                            ...itemKeys,
                            anchor
                        ];
                        return (0, parcelRequire("2XSIf")).default('issueAdjustments', [
                            ...adjustments,
                            ...items
                        ], state);
                    }
                    const adjustment = anchorAdjustment + (relation === 'AFTER' ? 1 : 0);
                    return (0, parcelRequire("2XSIf")).default('issueAdjustments', (0, parcelRequire("8jZmX")).default(adjustment, itemKeys, adjustments), state);
                }
            case 0, $caw8G.ADJUST_VERSION_LEXORANK:
                {
                    const { anchor: anchor, id: id, relation: relation } = action.payload;
                    if (anchor === undefined) return state;
                    const adjustments = state.versionAdjustments.filter((x)=>x !== id);
                    const anchorAdjustment = adjustments.indexOf(anchor);
                    if (anchorAdjustment < 0) {
                        const items = relation === 'AFTER' ? [
                            anchor,
                            id
                        ] : [
                            id,
                            anchor
                        ];
                        return (0, parcelRequire("2XSIf")).default('versionAdjustments', [
                            ...adjustments,
                            ...items
                        ], state);
                    }
                    const adjustment = anchorAdjustment + (relation === 'AFTER' ? 1 : 0);
                    return (0, parcelRequire("2XSIf")).default('versionAdjustments', (0, parcelRequire("c4FLA")).default(adjustment, id, adjustments), state);
                }
            case 0, $caw8G.UPDATE_VERSION_LEXORANK_ADJUSTMENTS:
                {
                    const { payload: payload } = action;
                    const patches = Object.keys(payload);
                    const versionAdjustments = state.versionAdjustments.map((versionId)=>patches.includes(versionId) ? payload[versionId] : versionId);
                    return (0, parcelRequire("2XSIf")).default('versionAdjustments', versionAdjustments, state);
                }
            default:
                actionType;
                return state;
        }
    };
});
parcelRegister("8jZmX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60efb3bce9ceb896$export$2e2bcd8739ae039);
    var $IYMZh;
    var $60efb3bce9ceb896$var$insertAll = (0, (0, parcelRequire("IYMZh")).default)(function insertAll(idx, elts, list) {
        idx = idx < list.length && idx >= 0 ? idx : list.length;
        return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
    });
    var $60efb3bce9ceb896$export$2e2bcd8739ae039 = $60efb3bce9ceb896$var$insertAll;
});
parcelRegister("9eef5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$24122b207c489f03$export$2e2bcd8739ae039);
    var $ik0Qc;
    var $bREsp = parcelRequire("bREsp");
    var $bt366 = parcelRequire("bt366");
    const $24122b207c489f03$var$initialState = {};
    var $24122b207c489f03$export$2e2bcd8739ae039 = (state = $24122b207c489f03$var$initialState, action)=>{
        switch(action.type){
            case 0, $bt366.RESET:
                return {
                    ...action.payload
                };
            case 0, $bt366.UPDATE:
                {
                    const { id: id, values: values } = action.payload;
                    return {
                        ...state,
                        [id]: (0, parcelRequire("ik0Qc")).default(values, state[id])
                    };
                }
            case 0, $bt366.UPDATE_REFERENCES:
                return (0, $bREsp.updateRefs)(state, action.payload);
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("3uAl4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfe0e11534781538$export$2e2bcd8739ae039);
    var $bWXax;
    var $ik0Qc;
    var $5H7dz;
    var $iavfW;
    var $4nDwW = parcelRequire("4nDwW");
    var $7CxJ7 = parcelRequire("7CxJ7");
    const $dfe0e11534781538$var$initialState = {};
    var $dfe0e11534781538$export$2e2bcd8739ae039 = (state = $dfe0e11534781538$var$initialState, action)=>{
        switch(action.type){
            case 0, $7CxJ7.RESET:
                return {
                    ...action.payload
                };
            case 0, $7CxJ7.UPDATE:
                {
                    const { id: id, ...originals } = action.payload;
                    const mergeValues = (key, payloadValue, stateValue)=>key === 'customFields' ? (0, parcelRequire("ik0Qc")).default(payloadValue, stateValue) : stateValue;
                    return {
                        ...state,
                        [id]: (0, parcelRequire("5H7dz")).default(mergeValues, originals, state[id] || {})
                    };
                }
            case 0, $7CxJ7.REVERT_FIELDS:
                {
                    const { id: id, fields: fields } = action.payload;
                    const originalIssue = state[id];
                    const newOriginalIssue = (0, $4nDwW.pickBy)((_, key)=>!fields.includes(key), originalIssue);
                    if (Object.keys(newOriginalIssue).length === 0) return (0, parcelRequire("bWXax")).default(id, state);
                    return {
                        ...state,
                        [id]: {
                            ...newOriginalIssue
                        }
                    };
                }
            case 0, $7CxJ7.REMOVE:
                return (0, parcelRequire("iavfW")).default(action.payload, state);
            default:
                return state;
        }
    };
});
parcelRegister("1lVR7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7346f3a3bc6fad1a$export$2e2bcd8739ae039);
    var $h2uoz;
    var $8MQZK;
    var $4Rr1a;
    var $5bPxr = parcelRequire("5bPxr");
    const $7346f3a3bc6fad1a$var$initialState = {};
    var $7346f3a3bc6fad1a$export$2e2bcd8739ae039 = (state = $7346f3a3bc6fad1a$var$initialState, action)=>{
        switch(action.type){
            case 0, $5bPxr.RESET:
                {
                    const resetAction = action;
                    return {
                        ...resetAction.payload
                    };
                }
            case 0, $5bPxr.UPDATE:
                {
                    const updateAction = action;
                    const { iterationId: iterationId, teamId: teamId } = updateAction.payload;
                    return (0, parcelRequire("h2uoz")).default([
                        teamId,
                        iterationId
                    ], updateAction.payload, state);
                }
            case 0, $5bPxr.REMOVE:
                {
                    const { payload: { teamId: teamId, iterationId: iterationId } } = action;
                    return (0, parcelRequire("8MQZK")).default([
                        teamId,
                        iterationId
                    ], state);
                }
            case 0, $5bPxr.UPDATE_TEAM_ID:
                {
                    const { payload: { oldId: oldId, newId: newId } } = action;
                    const newState = {
                        ...state
                    };
                    if (newState[oldId]) {
                        newState[newId] = (0, parcelRequire("4Rr1a")).default((capacity)=>({
                                ...capacity,
                                teamId: newId
                            }), newState[oldId]);
                        delete newState[oldId];
                    }
                    return newState;
                }
            default:
                return state;
        }
    };
});
parcelRegister("iDo90", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8dc618382d07ddc9$export$2e2bcd8739ae039);
    var $5KaGt;
    var $flUdG = parcelRequire("flUdG");
    const $8dc618382d07ddc9$var$initialState = {};
    var $8dc618382d07ddc9$export$2e2bcd8739ae039 = (state = $8dc618382d07ddc9$var$initialState, action)=>{
        switch(action.type){
            case 0, $flUdG.RESET:
                return {
                    ...action.payload
                };
            case 0, $flUdG.UPDATE:
                {
                    const { itemKey: itemKey, ...originals } = action.payload;
                    return {
                        ...state,
                        [itemKey]: (0, parcelRequire("5KaGt")).default(originals, state[itemKey] || {})
                    };
                }
            default:
                return state;
        }
    };
});
parcelRegister("atDoK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef3c4018de6f8e1b$export$2e2bcd8739ae039);
    var $ik0Qc;
    var $1Gv61 = parcelRequire("1Gv61");
    const $ef3c4018de6f8e1b$var$initialState = {};
    var $ef3c4018de6f8e1b$export$2e2bcd8739ae039 = (state = $ef3c4018de6f8e1b$var$initialState, action)=>{
        switch(action.type){
            case 0, $1Gv61.RESET:
                return {
                    ...action.payload
                };
            case 0, $1Gv61.UPDATE:
                {
                    const { id: id, ...originals } = action.payload;
                    return {
                        ...state,
                        [id]: (0, parcelRequire("ik0Qc")).default(originals, state[id])
                    };
                }
            default:
                return state;
        }
    };
});
parcelRegister("1zxoG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c2b50619d5ff6a1$export$2e2bcd8739ae039);
    var $ik0Qc;
    var $bREsp = parcelRequire("bREsp");
    var $75oAU = parcelRequire("75oAU");
    const $2c2b50619d5ff6a1$var$initialState = {};
    var $2c2b50619d5ff6a1$export$2e2bcd8739ae039 = (state = $2c2b50619d5ff6a1$var$initialState, action)=>{
        switch(action.type){
            case 0, $75oAU.RESET:
                return {
                    ...action.payload
                };
            case 0, $75oAU.UPDATE:
                {
                    const { id: id, values: values } = action.payload;
                    return {
                        ...state,
                        [id]: (0, parcelRequire("ik0Qc")).default(values, state[id])
                    };
                }
            case 0, $75oAU.UPDATE_REFERENCES:
                return (0, $bREsp.updateRefs)(state, action.payload);
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("l0Sgj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af06aa530ccccc3d$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $5NIow = parcelRequire("5NIow");
    var $SNDgE = parcelRequire("SNDgE");
    const $af06aa530ccccc3d$var$currentUser = (state = {}, action)=>{
        switch(action.type){
            case 0, $5NIow.SET_CURRENT_USER:
                {
                    const { displayName: displayName, key: key, emailAddress: email, avatarUrls: avatarUrls } = action.payload;
                    return {
                        displayName: displayName,
                        key: key,
                        email: email,
                        avatarUrl: avatarUrls['48x48']
                    };
                }
            default:
                return state;
        }
    };
    const $af06aa530ccccc3d$var$isFetchPlanPermissionsInProgress = (state = false, action)=>{
        switch(action.type){
            case 0, $5NIow.TOGGLE_FETCH_PLAN_PERMISSIONS_IN_PROGRESS:
                return action.payload;
            default:
                return state;
        }
    };
    const $af06aa530ccccc3d$var$teamPermissions = (state = {}, action)=>{
        switch(action.type){
            case 0, $5NIow.SET_TEAM_PERMISSIONS:
                return action.payload;
            default:
                return state;
        }
    };
    var $af06aa530ccccc3d$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        planPermissions: $SNDgE.default,
        currentUser: $af06aa530ccccc3d$var$currentUser,
        isFetchPlanPermissionsInProgress: $af06aa530ccccc3d$var$isFetchPlanPermissionsInProgress,
        teamPermissions: $af06aa530ccccc3d$var$teamPermissions
    });
});
parcelRegister("SNDgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63933dd5a84f3397$export$2e2bcd8739ae039);
    var $5NIow = parcelRequire("5NIow");
    const $63933dd5a84f3397$var$initialState = [];
    const $63933dd5a84f3397$var$permissionReducer = (state, action)=>{
        switch(action.type){
            case 0, $5NIow.ADD_PERMISSION:
                if (state.holder.key !== action.payload.holder.key) return state;
                return {
                    ...state,
                    permissions: state.permissions.concat(action.payload.permission)
                };
            case 0, $5NIow.REMOVE_PERMISSION:
                if (state.holder.key !== action.payload.holder.key) return state;
                return {
                    ...state,
                    permissions: state.permissions.filter((role)=>role !== action.payload.permission)
                };
            default:
                return state;
        }
    };
    var $63933dd5a84f3397$export$2e2bcd8739ae039 = (state = $63933dd5a84f3397$var$initialState, action)=>{
        switch(action.type){
            case 0, $5NIow.SET_PERMISSIONS:
                return [
                    ...action.payload
                ];
            case 0, $5NIow.ADD_PERMISSION:
                {
                    const { holder: holder } = action.payload;
                    const existingPermission = state.find((permission)=>permission.holder.key === holder.key);
                    if (!existingPermission) {
                        const { permission: permission, ...rest } = action.payload;
                        return state.concat({
                            ...rest,
                            permissions: [
                                permission
                            ]
                        });
                    }
                    return state.map((permission)=>$63933dd5a84f3397$var$permissionReducer(permission, action));
                }
            case 0, $5NIow.REMOVE_PERMISSION:
                return state.map((permission)=>$63933dd5a84f3397$var$permissionReducer(permission, action)).filter((permission)=>permission.permissions.length > 0);
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("6OROt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8dded0c2f0a09f4$export$2e2bcd8739ae039);
    var $jxA5Y = parcelRequire("jxA5Y");
    const $e8dded0c2f0a09f4$var$initialState = [];
    var $e8dded0c2f0a09f4$export$2e2bcd8739ae039 = (state = $e8dded0c2f0a09f4$var$initialState, action)=>{
        switch(action.type){
            case 0, $jxA5Y.RESET:
                return action.payload;
            case 0, $jxA5Y.ADD:
                return [
                    ...state,
                    action.payload
                ];
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("6NSGj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73bc9aa7a7c0a40a$export$2e2bcd8739ae039);
    var $f27x7 = parcelRequire("f27x7");
    var $73bc9aa7a7c0a40a$export$2e2bcd8739ae039 = (state = {}, action)=>{
        if (action.type === (0, $f27x7.SET_PLAN_DEFAULTS)) return action.payload;
        return state;
    };
});
parcelRegister("6QRPg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8eb323d0498f57ca$export$2e2bcd8739ae039);
    var $4TFUc = parcelRequire("4TFUc");
    var $5fACX = parcelRequire("5fACX");
    var $jZcxq = parcelRequire("jZcxq");
    const $8eb323d0498f57ca$var$initialState = {
        title: (0, $4TFUc.tryExtractPlanTitleFromDocument)(),
        planningUnit: 'StoryPoints',
        issueSources: [],
        includeCompletedIssuesFor: (0, $08d1cd363c5f7148$export$6afdd25b4da87159),
        autoScheduleConfiguration: {
            ignoreSprints: false,
            ignoreReleases: false,
            ignoreTeams: false
        },
        syncStartEnabled: false,
        issueInferredDateSelection: (0, $5fACX.ISSUE_INFERRED_DATE_SELECTION).SPRINT,
        baselineStartField: (0, $5fACX.TARGET_START_DATE_FIELD),
        baselineEndField: (0, $5fACX.DUE_DATE_FIELD),
        isSamplePlan: false,
        autoSchedulerEnabled: false,
        planStatus: 'ACTIVE',
        planType: undefined,
        creatorAccountId: ''
    };
    var $8eb323d0498f57ca$export$2e2bcd8739ae039 = (state = $8eb323d0498f57ca$var$initialState, action)=>{
        switch(action.type){
            case 0, $jZcxq.RESET:
                return {
                    ...action.payload
                };
            case 0, $jZcxq.UPDATE:
                return {
                    ...state,
                    ...action.payload
                };
            case 0, $jZcxq.ENABLE_PLAN_SCENARIOS:
                return {
                    ...state,
                    multiScenarioEnabled: true,
                    scenarios: action.payload
                };
            case 0, $jZcxq.ADD_PLAN_SCENARIO:
                return {
                    ...state,
                    scenarios: [
                        action.payload,
                        ...state.scenarios || []
                    ]
                };
            case 0, $jZcxq.UPDATE_PLAN_SCENARIO:
                {
                    if (!state.scenarios) return state;
                    const { id: id, ...values } = action.payload;
                    const scenarios = state.scenarios.map((scenario)=>{
                        if (scenario.id === id) return {
                            ...scenario,
                            ...values
                        };
                        return scenario;
                    });
                    return {
                        ...state,
                        scenarios: scenarios
                    };
                }
            case 0, $jZcxq.REMOVE_PLAN_SCENARIO:
                {
                    const { id: id } = action.payload;
                    return {
                        ...state,
                        scenarios: state.scenarios && state.scenarios.filter((scenario)=>scenario.id !== id)
                    };
                }
            case 0, $jZcxq.DISABLE_PLAN_SCENARIOS:
                {
                    const { scenarioToKeepId: scenarioToKeepId } = action;
                    return {
                        ...state,
                        multiScenarioEnabled: false,
                        scenarios: state.scenarios && state.scenarios.filter((scenario)=>scenario.id === scenarioToKeepId)
                    };
                }
            case 0, $jZcxq.UPDATE_AUTO_SCHEDULER_ENABLED:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("4TFUc", function(module, exports) {
    $parcel$export(module.exports, "tryExtractPlanTitleFromDocument", ()=>$5e3728c69cf5368f$export$38c9cfaa14d648d1);
    const $5e3728c69cf5368f$var$DOCUMENT_TITLE_DIVIDER_PLANS = ' - Plans - ';
    const $5e3728c69cf5368f$export$38c9cfaa14d648d1 = ()=>{
        if (globalThis.document && globalThis.document?.title) {
            const index = document.title.lastIndexOf($5e3728c69cf5368f$var$DOCUMENT_TITLE_DIVIDER_PLANS);
            return index === -1 ? undefined : document.title.substring(0, index);
        }
        return undefined;
    };
});
parcelRegister("asyNJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ba06c4376363ad9$export$2e2bcd8739ae039);
    var $h2uoz;
    var $8MQZK;
    var $4Rr1a;
    var $7IEdi = parcelRequire("7IEdi");
    const $2ba06c4376363ad9$var$initialState = {};
    var $2ba06c4376363ad9$export$2e2bcd8739ae039 = (state = $2ba06c4376363ad9$var$initialState, action)=>{
        switch(action.type){
            case 0, $7IEdi.RESET:
                {
                    const resetAction = action;
                    return {
                        ...resetAction.payload
                    };
                }
            case 0, $7IEdi.UPDATE:
                {
                    const updateAction = action;
                    const { iterationId: iterationId, teamId: teamId } = updateAction.payload;
                    return (0, parcelRequire("h2uoz")).default([
                        teamId,
                        iterationId
                    ], updateAction.payload, state);
                }
            case 0, $7IEdi.REMOVE:
                {
                    const { payload: { teamId: teamId, iterationId: iterationId } } = action;
                    return (0, parcelRequire("8MQZK")).default([
                        teamId,
                        iterationId
                    ], state);
                }
            case 0, $7IEdi.UPDATE_TEAM_ID:
                {
                    const { payload: { oldId: oldId, newId: newId } } = action;
                    const newState = {
                        ...state
                    };
                    if (newState[oldId]) {
                        newState[newId] = (0, parcelRequire("4Rr1a")).default((capacity)=>({
                                ...capacity,
                                teamId: newId
                            }), newState[oldId]);
                        delete newState[oldId];
                    }
                    return newState;
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("isNtK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67d1bd80f5ed944e$export$2e2bcd8739ae039);
    var $4nDwW = parcelRequire("4nDwW");
    var $lKGSc = parcelRequire("lKGSc");
    const $67d1bd80f5ed944e$var$initialState = [];
    var $67d1bd80f5ed944e$export$2e2bcd8739ae039 = (state = $67d1bd80f5ed944e$var$initialState, action)=>{
        switch(action.type){
            case 0, $lKGSc.RESET:
                if (action.payload.length > 1) return action.payload.map((project)=>({
                        ...project,
                        isDefault: false
                    }));
                return action.payload.map((project)=>({
                        ...project,
                        isDefault: true
                    }));
            case 0, $lKGSc.ADD:
                return [
                    ...state,
                    ...action.payload
                ];
            case 0, $lKGSc.ADD_VERSION_IN_PROJECT:
                {
                    const { projectId: projectId, versionId: versionId } = action.payload;
                    const project = state.find(({ id: id })=>id === projectId);
                    if ((0, $4nDwW.isDefined)(project)) {
                        const restOfTheProjects = state.filter(({ id: id })=>id !== projectId);
                        return [
                            ...restOfTheProjects,
                            {
                                ...project,
                                versions: [
                                    ...project.versions,
                                    versionId
                                ]
                            }
                        ];
                    }
                    return state;
                }
            case 0, $lKGSc.SET_DEFAULT_PROJECT:
                {
                    const projectId = action.payload.projectId;
                    return state.map((project)=>({
                            ...project,
                            isDefault: project.id === projectId
                        }));
                }
            case 0, $lKGSc.REMOVE_VERSION_FROM_PROJECT:
                {
                    const { projectId: projectId, versionId: versionId } = action.payload;
                    const project = state.find(({ id: id })=>id === projectId);
                    if ((0, $4nDwW.isDefined)(project)) {
                        const newVersions = project.versions.filter((id)=>id !== versionId);
                        const restOfTheProjects = state.filter(({ id: id })=>id !== projectId);
                        return [
                            ...restOfTheProjects,
                            {
                                ...project,
                                versions: [
                                    ...newVersions
                                ]
                            }
                        ];
                    }
                    return state;
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("9TzdE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$39e6d00578164af9$export$2e2bcd8739ae039);
    var $c33ef = parcelRequire("c33ef");
    var $fHpRV = parcelRequire("fHpRV");
    const $39e6d00578164af9$var$initialState = [];
    var $39e6d00578164af9$export$2e2bcd8739ae039 = (state = $39e6d00578164af9$var$initialState, action)=>{
        switch(action.type){
            case 0, $fHpRV.RESET:
                return (0, $c33ef.sortAsLowerCaseByNameProp)([
                    ...action.payload
                ]);
            case 0, $fHpRV.ADD:
                return [
                    ...state,
                    action.payload
                ];
            case 0, $fHpRV.REMOVE:
                {
                    const removedId = action.versionId;
                    return state.filter(({ id: id })=>id !== removedId);
                }
            case 0, $fHpRV.ADD_VERSION_IN_CROSS_PROJECT_VERSION:
                {
                    const { crossProjectVersionId: crossProjectVersionId, versionId: versionId } = action.payload;
                    return [
                        ...state.map((crossProjectVersion)=>{
                            const { id: id, versions: versions } = crossProjectVersion;
                            if (id === crossProjectVersionId) return {
                                ...crossProjectVersion,
                                versions: [
                                    ...versions,
                                    versionId
                                ]
                            };
                            return crossProjectVersion;
                        })
                    ];
                }
            case 0, $fHpRV.REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION:
                {
                    const { crossProjectVersionId: crossProjectVersionId, versionId: versionId } = action.payload;
                    return [
                        ...state.map((crossProjectVersion)=>{
                            const { id: id, versions: versions } = crossProjectVersion;
                            if (id === crossProjectVersionId) return {
                                ...crossProjectVersion,
                                versions: versions.filter((vid)=>vid !== versionId)
                            };
                            return crossProjectVersion;
                        })
                    ];
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("7VKWh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f14702d71e124130$export$2e2bcd8739ae039);
    var $c33ef = parcelRequire("c33ef");
    var $jgiLJ = parcelRequire("jgiLJ");
    const $f14702d71e124130$var$initialState = [];
    var $f14702d71e124130$export$2e2bcd8739ae039 = (state = $f14702d71e124130$var$initialState, action)=>{
        switch(action.type){
            case 0, $jgiLJ.RESET:
                return (0, $c33ef.sortAsLowerCaseByNameProp)([
                    ...action.payload
                ]);
            case 0, $jgiLJ.ADD:
                return [
                    ...state,
                    action.payload
                ];
            case 0, $jgiLJ.REMOVE:
                {
                    const removedId = action.versionId;
                    return state.filter(({ id: id })=>id !== removedId);
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("9MEZ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8208d3d7dba0178$export$2e2bcd8739ae039);
    var $2AO3f = parcelRequire("2AO3f");
    const $e8208d3d7dba0178$var$initialState = {
        issueReporterMap: {},
        reporterList: []
    };
    var $e8208d3d7dba0178$export$2e2bcd8739ae039 = (state = $e8208d3d7dba0178$var$initialState, action)=>{
        switch(action.type){
            case 0, $2AO3f.UPDATE_ISSUE_REPORTER_MAP:
                return {
                    ...state,
                    issueReporterMap: {
                        ...state.issueReporterMap,
                        ...action.payload
                    }
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("le5Fc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$944a5a5fa0d92058$export$2e2bcd8739ae039);
    var $bWg8d = parcelRequire("bWg8d");
    const $944a5a5fa0d92058$var$initialState = [];
    var $944a5a5fa0d92058$export$2e2bcd8739ae039 = (state = $944a5a5fa0d92058$var$initialState, action)=>{
        switch(action.type){
            case 0, $bWg8d.RESET:
                return [
                    ...action.payload
                ];
            case 0, $bWg8d.ADD:
                return [
                    ...state,
                    action.payload
                ];
            case 0, $bWg8d.BULK_ADD:
                return [
                    ...state,
                    ...action.payload
                ];
            case 0, $bWg8d.REMOVE:
                return state.filter(({ id: id })=>id !== action.payload);
            case 0, $bWg8d.BULK_REMOVE:
                return state.filter(({ id: id })=>!action.payload.includes(id));
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("4v10j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb0998c7f990761d$export$2e2bcd8739ae039);
    var $f7tuF = parcelRequire("f7tuF");
    const $eb0998c7f990761d$var$initialState = [];
    var $eb0998c7f990761d$export$2e2bcd8739ae039 = (state = $eb0998c7f990761d$var$initialState, action)=>{
        switch(action.type){
            case 0, $f7tuF.RESET:
                return action.payload;
            case 0, $f7tuF.ADD:
                {
                    const { payload: payload } = action;
                    const newItems = payload.map((item)=>item.id);
                    return [
                        ...payload,
                        ...state.filter((item)=>!newItems.includes(item.id))
                    ];
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("eJcEl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec615df334ed7a9b$export$2e2bcd8739ae039);
    var $36p1o = parcelRequire("36p1o");
    const $ec615df334ed7a9b$var$initialState = {};
    var $ec615df334ed7a9b$export$2e2bcd8739ae039 = (state = $ec615df334ed7a9b$var$initialState, action)=>{
        switch(action.type){
            case 0, $36p1o.INCREMENT:
                {
                    const newState = {
                        ...state
                    };
                    for (const key of action.payload){
                        const { current: current } = newState[key] || {
                            current: 0
                        };
                        newState[key] = {
                            before: current,
                            current: current + 1
                        };
                    }
                    return newState;
                }
            case 0, $36p1o.RESET:
                return {
                    ...action.payload
                };
            case 0, $36p1o.UPDATE:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("83Ok6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$093fe0d55dc14203$export$2e2bcd8739ae039);
    var $7vqYD = parcelRequire("7vqYD");
    const $093fe0d55dc14203$var$initialState = {
        isLatest: false,
        isValid: false,
        applyingProgress: null,
        projects: {},
        teams: {}
    };
    var $093fe0d55dc14203$export$2e2bcd8739ae039 = (state = $093fe0d55dc14203$var$initialState, action)=>{
        switch(action.type){
            case 0, $7vqYD.SET_LATEST:
                {
                    const isLatest = action.payload;
                    return {
                        ...state,
                        isLatest: isLatest
                    };
                }
            case 0, $7vqYD.SET_VALIDITY:
                {
                    const isValid = action.payload;
                    return {
                        ...state,
                        isValid: isValid
                    };
                }
            case 0, $7vqYD.SET_PROGRESS:
                {
                    const applyingProgress = action.payload;
                    return {
                        ...state,
                        applyingProgress: applyingProgress
                    };
                }
            case 0, $7vqYD.RESET:
                {
                    const solution = action.payload;
                    return {
                        ...state,
                        ...solution,
                        applyingProgress: null,
                        isValid: false
                    };
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("bNf5i", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$9dcf65d9c6ed00b1$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$9dcf65d9c6ed00b1$export$aad8462122ac592b);
    const $9dcf65d9c6ed00b1$export$4a991c87e640ef77 = 'state.domain.sprints.RESET';
    const $9dcf65d9c6ed00b1$export$aad8462122ac592b = (payload)=>({
            type: $9dcf65d9c6ed00b1$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("fvKei", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93807c63be533852$export$2e2bcd8739ae039);
    var $bNf5i = parcelRequire("bNf5i");
    const $93807c63be533852$var$initialState = [];
    var $93807c63be533852$export$2e2bcd8739ae039 = (state = $93807c63be533852$var$initialState, action)=>{
        switch(action.type){
            case 0, $bNf5i.RESET:
                return [
                    ...action.payload
                ];
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("NYww6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c087369b1f10cb2$export$2e2bcd8739ae039);
    var $lzeFL;
    var $4nDwW = parcelRequire("4nDwW");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $eVLBZ = parcelRequire("eVLBZ");
    const $8c087369b1f10cb2$var$defaultInitialConfig = {
        locale: (0, (0, parcelRequire("lzeFL")).defaultLocale)
    };
    const $8c087369b1f10cb2$export$d4c72bab9d6cc13a = {
        systemInfo: {
            lookAndFeel: {
                dateFormat: (0, $TTKUQ.DefaultDateFormat)
            },
            jiraHoursPerDay: 8,
            jiraDaysPerWeek: 5,
            jiraTitle: '',
            permission: 'Viewer',
            isAdmin: false,
            fiscalMonth: 1,
            accountId: '',
            userName: '',
            userEmailAddress: '',
            avatarUrl: '',
            ...$8c087369b1f10cb2$var$defaultInitialConfig
        },
        agileInfo: {
            version: '',
            epicLinkField: '',
            epicLabelField: '',
            sprintsField: '',
            storyPointsField: '',
            storyPointFieldName: '',
            storyPointEstimateField: '',
            storyPointEstimateFieldName: '',
            targetStartField: '',
            targetEndField: '',
            teamField: ''
        },
        issueLinkTypesInfo: {
            isIssueLinkingEnabled: true,
            issueLinkTypes: []
        },
        dependencySettingsInfo: {
            dependencyIssueLinkTypes: []
        },
        loadingLimitsInfo: {
            absoluteIssueLimit: Infinity,
            defaultAbsoluteIssueLimit: Infinity,
            defaultHierarchyIssueLimit: Infinity,
            defaultProjectLimit: Infinity,
            projectLimit: Infinity
        },
        isAtlasConnectInstalled: false,
        hasAtlasPermissions: false
    };
    const $8c087369b1f10cb2$export$534a5ce135e639a = ({ issueLinkTypesInfo: issueLinkTypesInfo, dependencySettingsInfo: dependencySettingsInfo, ...rest })=>{
        const { issueLinkTypes: issueLinkTypes } = issueLinkTypesInfo;
        const { dependencyIssueLinkTypes: dependencyIssueLinkTypes } = dependencySettingsInfo;
        const dependencyIssueLinkTypeById = (0, $4nDwW.indexBy)((dependencyIssueLinkType)=>dependencyIssueLinkType.issueLinkTypeId, dependencyIssueLinkTypes);
        const remappedIssueLinkTypes = issueLinkTypes.map((issueLinkType)=>{
            const dependencyIssueLinkType = dependencyIssueLinkTypeById[issueLinkType.id];
            if (dependencyIssueLinkType && !dependencyIssueLinkType.isOutward) return {
                ...issueLinkType,
                outward: issueLinkType.inward,
                inward: issueLinkType.outward
            };
            return issueLinkType;
        });
        return {
            ...rest,
            dependencySettingsInfo: dependencySettingsInfo,
            issueLinkTypesInfo: {
                ...issueLinkTypesInfo,
                issueLinkTypes: remappedIssueLinkTypes
            }
        };
    };
    var $8c087369b1f10cb2$export$2e2bcd8739ae039 = (state = $8c087369b1f10cb2$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $eVLBZ.SET_SYSTEM_INFO:
                return $8c087369b1f10cb2$export$534a5ce135e639a(action.payload);
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("lsSZO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c7ebae8fa4e8b5c$export$2e2bcd8739ae039);
    var $atabv = parcelRequire("atabv");
    const $2c7ebae8fa4e8b5c$var$initialState = [];
    var $2c7ebae8fa4e8b5c$export$2e2bcd8739ae039 = (state = $2c7ebae8fa4e8b5c$var$initialState, action)=>{
        switch(action.type){
            case 0, $atabv.SET:
                {
                    const payload = action.payload;
                    return [
                        ...payload
                    ];
                }
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("daVLx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a649f171c11f153$export$2e2bcd8739ae039);
    var $ik0Qc;
    var $TTKUQ = parcelRequire("TTKUQ");
    var $k0NEx = parcelRequire("k0NEx");
    const $8a649f171c11f153$var$initialState = [];
    var $8a649f171c11f153$export$2e2bcd8739ae039 = (state = $8a649f171c11f153$var$initialState, action)=>{
        switch(action.type){
            case 0, $k0NEx.ADD:
                return [
                    action.payload,
                    ...state
                ];
            case 0, $k0NEx.RESET:
                return [
                    ...action.payload
                ];
            case 0, $k0NEx.REMOVE:
                {
                    const removePayload = action.payload;
                    if (removePayload.action === 'COMMIT') return state.filter((team)=>!(removePayload.id === team.id && (team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).DELETED || team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).EXCLUDED)));
                    return state.filter((team)=>!(removePayload.id === team.id && (team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED || team.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDEDEXISTING)));
                }
            case 0, $k0NEx.UPDATE:
                {
                    const updatePayload = action.payload;
                    return state.map((team)=>{
                        if (team.id === updatePayload.teamId) return {
                            ...team,
                            ...updatePayload.patch
                        };
                        return team;
                    });
                }
            case 0, $k0NEx.UPDATE_RESOURCE:
                {
                    const { teamId: teamId, resourceId: resourceId, itemKey: itemKey } = action.payload;
                    return state.map((team)=>{
                        if (team.id === teamId) {
                            const resources = team.resources.map((resource)=>{
                                if (resource.itemKey === resourceId) return {
                                    ...resource,
                                    scenarioType: undefined,
                                    values: (0, parcelRequire("ik0Qc")).default(resource.values, resource.originals),
                                    originals: {},
                                    itemKey: itemKey
                                };
                                return resource;
                            });
                            return {
                                ...team,
                                resources: resources
                            };
                        }
                        return team;
                    });
                }
            case 0, $k0NEx.ADD_MEMBER:
                {
                    const payload = action.payload;
                    return state.map((team)=>{
                        if (team.id === payload.teamId) return {
                            ...team,
                            resources: [
                                ...team.resources,
                                payload.resource
                            ]
                        };
                        return team;
                    });
                }
            case 0, $k0NEx.REMOVE_MEMBER:
                {
                    const payload = action.payload;
                    return state.map((team)=>{
                        if (team.id === payload.teamId) {
                            if (payload.resource.scenarioType === (0, $TTKUQ.SCENARIO_TYPE).ADDED) return {
                                ...team,
                                resources: team.resources.filter((resource)=>resource.itemKey !== payload.resource.itemKey)
                            };
                            return {
                                ...team,
                                resources: team.resources.map((resource)=>resource.itemKey === payload.resource.itemKey ? {
                                        ...resource,
                                        scenarioType: (0, $TTKUQ.SCENARIO_TYPE).DELETED
                                    } : resource)
                            };
                        }
                        return team;
                    });
                }
            case 0, $k0NEx.SET_SHARED:
                {
                    const { teamId: teamId, externalId: externalId } = action;
                    return state.map((team)=>{
                        if (team.id === teamId) return {
                            ...team,
                            externalId: externalId,
                            shareable: true
                        };
                        return team;
                    });
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("8Db15", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b31d75cdb2c0e8a$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $35pTH = parcelRequire("35pTH");
    var $j4C7H = parcelRequire("j4C7H");
    var $2zsnR = parcelRequire("2zsnR");
    var $9M6vE = parcelRequire("9M6vE");
    var $80keO = parcelRequire("80keO");
    var $5U9FF = parcelRequire("5U9FF");
    var $duoQx = parcelRequire("duoQx");
    var $gmCkj = parcelRequire("gmCkj");
    var $8b31d75cdb2c0e8a$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        changes: $2zsnR.default,
        changesWarnings: $j4C7H.default,
        commit: $9M6vE.default,
        revert: $duoQx.default,
        hiddenIssues: $80keO.default,
        warnings: $gmCkj.default,
        requiredFields: $5U9FF.default,
        changeStatus: $35pTH.default
    });
});
parcelRegister("35pTH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d277d4fee5bf2973$export$2e2bcd8739ae039);
    var $gpDcx = parcelRequire("gpDcx");
    const $d277d4fee5bf2973$var$initialState = {
        issueId: '',
        isWaiting: false,
        issueKeyInJira: undefined,
        transitionId: undefined
    };
    var $d277d4fee5bf2973$export$2e2bcd8739ae039 = (state = $d277d4fee5bf2973$var$initialState, action)=>{
        switch(action.type){
            case 0, $gpDcx.LOAD:
                return {
                    ...state,
                    isWaiting: true,
                    ...action.payload
                };
            case 0, $gpDcx.CANCEL:
                return {
                    ...state,
                    isWaiting: false
                };
            case 0, $gpDcx.SUCCESS:
                return {
                    ...state,
                    isWaiting: false
                };
            case 0, $gpDcx.FAIL:
                return {
                    ...state,
                    isWaiting: false
                };
            default:
                return state;
        }
    };
});
parcelRegister("j4C7H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$119007a47e1aa0b2$export$2e2bcd8739ae039);
    var $h2uoz;
    var $aHSC5 = parcelRequire("aHSC5");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $iNyXb = parcelRequire("iNyXb");
    var $9mxDT = parcelRequire("9mxDT");
    const $119007a47e1aa0b2$var$initialState = {
        [(0, $TTKUQ.ENTITY).ISSUE]: {},
        [(0, $TTKUQ.ENTITY).RELEASE]: {},
        [(0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE]: {},
        [(0, $TTKUQ.ENTITY).TEAM]: {},
        [(0, $TTKUQ.ENTITY).RESOURCE]: {},
        [(0, $TTKUQ.ENTITY).SPRINT]: {},
        [(0, $TTKUQ.ENTITY).PLANNED_CAPACITY]: {},
        [(0, $TTKUQ.ENTITY).NONE]: {}
    };
    var $119007a47e1aa0b2$export$2e2bcd8739ae039 = (state = $119007a47e1aa0b2$var$initialState, action)=>{
        switch(action.type){
            case 0, $9mxDT.RESET:
                return {
                    ...state,
                    [action.payload.category]: {}
                };
            case 0, $9mxDT.ADD_BULK:
                return action.payload.reduce((nextState, { category: category, itemId: itemId, warnings: warnings })=>{
                    const nextWarnings = (nextState[category][itemId] || []).concat(warnings);
                    return (0, parcelRequire("h2uoz")).default([
                        category,
                        itemId
                    ], nextWarnings, nextState);
                }, state);
            case 0, $iNyXb.START:
            case 0, $aHSC5.OPEN_UPDATE_JIRA_DIALOG:
                return $119007a47e1aa0b2$var$initialState;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("2zsnR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e74f77941c80a0cc$export$2e2bcd8739ae039);
    var $ebcEl = parcelRequire("ebcEl");
    const $e74f77941c80a0cc$var$initialState = {
        status: $230cb0d7945ed3ed$export$16250ffd632e517a
    };
    var $e74f77941c80a0cc$export$2e2bcd8739ae039 = (state = $e74f77941c80a0cc$var$initialState, action)=>{
        switch(action.type){
            case 0, $ebcEl.SENT:
                return {
                    status: $230cb0d7945ed3ed$export$26d55645375ca9a
                };
            case 0, $ebcEl.SUCCESS:
                return {
                    status: $230cb0d7945ed3ed$export$638cc6e36b2a737a,
                    data: action.payload
                };
            case 0, $ebcEl.ERROR:
                return {
                    status: $230cb0d7945ed3ed$export$103bedf43ba882db,
                    error: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("9M6vE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f21b6e49964b1bb$export$2e2bcd8739ae039);
    var $iNyXb = parcelRequire("iNyXb");
    const $2f21b6e49964b1bb$var$initialState = {
        inProgress: false,
        isInterrupted: false,
        progressStats: {
            numberOfCommittedChanges: 0,
            totalChanges: 0
        },
        changesCommitted: 0
    };
    var $2f21b6e49964b1bb$export$2e2bcd8739ae039 = (state = $2f21b6e49964b1bb$var$initialState, action)=>{
        switch(action.type){
            case 0, $iNyXb.START:
                return {
                    ...state,
                    inProgress: true,
                    progressStats: {
                        numberOfCommittedChanges: 0,
                        totalChanges: action.payload
                    }
                };
            case 0, $iNyXb.INCREMENT_NUMBER_OF_COMMITTED_CHANGES:
                return {
                    ...state,
                    progressStats: {
                        ...state.progressStats,
                        numberOfCommittedChanges: state.progressStats.numberOfCommittedChanges + 1
                    }
                };
            case 0, $iNyXb.INTERRUPT:
                return {
                    ...state,
                    isInterrupted: true
                };
            case 0, $iNyXb.STOP:
                return {
                    ...state,
                    inProgress: false,
                    isInterrupted: false,
                    progressStats: {
                        ...$2f21b6e49964b1bb$var$initialState.progressStats
                    },
                    changesCommitted: state.progressStats.numberOfCommittedChanges
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("80keO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63846f6c784f6eaf$export$2e2bcd8739ae039);
    var $42ZEf = parcelRequire("42ZEf");
    const $63846f6c784f6eaf$var$initialState = [];
    var $63846f6c784f6eaf$export$2e2bcd8739ae039 = (state = $63846f6c784f6eaf$var$initialState, action)=>{
        switch(action.type){
            case 0, $42ZEf.RESET:
                return [
                    ...action.payload
                ];
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("5U9FF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d7addfe38206b541$export$2e2bcd8739ae039);
    var $lTHzT = parcelRequire("lTHzT");
    const $d7addfe38206b541$var$initialState = {
        isWaiting: false
    };
    var $d7addfe38206b541$export$2e2bcd8739ae039 = (state = $d7addfe38206b541$var$initialState, action)=>{
        switch(action.type){
            case 0, $lTHzT.LOAD:
                {
                    const { issueId: issueId, error: error } = action.payload;
                    return {
                        isWaiting: true,
                        issueId: issueId,
                        error: error
                    };
                }
            case 0, $lTHzT.CANCEL:
            case 0, $lTHzT.SUBMIT:
            case 0, $lTHzT.FAIL:
                return {
                    isWaiting: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("duoQx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6fac94e420af4601$export$2e2bcd8739ae039);
    var $91SKv = parcelRequire("91SKv");
    const $6fac94e420af4601$var$initialState = {
        inProgress: false,
        isInterrupted: false,
        progressStats: {
            numberOfRevertedChanges: 0,
            totalChanges: 0
        }
    };
    var $6fac94e420af4601$export$2e2bcd8739ae039 = (state = $6fac94e420af4601$var$initialState, action)=>{
        switch(action.type){
            case 0, $91SKv.START:
                return {
                    ...state,
                    inProgress: true,
                    progressStats: {
                        numberOfRevertedChanges: 0,
                        totalChanges: action.payload
                    }
                };
            case 0, $91SKv.INCREMENT_NUMBER_OF_REVERTED_CHANGES:
                return {
                    ...state,
                    progressStats: {
                        ...state.progressStats,
                        numberOfRevertedChanges: state.progressStats.numberOfRevertedChanges + 1
                    }
                };
            case 0, $91SKv.INTERRUPT:
                return {
                    ...state,
                    isInterrupted: true
                };
            case 0, $91SKv.STOP:
                return {
                    inProgress: false,
                    isInterrupted: false,
                    progressStats: {
                        ...$6fac94e420af4601$var$initialState.progressStats
                    }
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("gmCkj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5aab043d50caec0a$export$2e2bcd8739ae039);
    var $aHSC5 = parcelRequire("aHSC5");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $iNyXb = parcelRequire("iNyXb");
    var $ccCF0 = parcelRequire("ccCF0");
    const $5aab043d50caec0a$var$initialState = {
        [(0, $TTKUQ.ENTITY).ISSUE]: {},
        [(0, $TTKUQ.ENTITY).RELEASE]: {},
        [(0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE]: {},
        [(0, $TTKUQ.ENTITY).TEAM]: {},
        [(0, $TTKUQ.ENTITY).RESOURCE]: {},
        [(0, $TTKUQ.ENTITY).SPRINT]: {}
    };
    var $5aab043d50caec0a$export$2e2bcd8739ae039 = (state = $5aab043d50caec0a$var$initialState, action)=>{
        switch(action.type){
            case 0, $ccCF0.ADD:
                {
                    const { category: category, itemId: itemId, warnings: warnings } = action.payload;
                    return {
                        ...state,
                        [category]: {
                            ...state[category],
                            [itemId]: warnings
                        }
                    };
                }
            case 0, $iNyXb.START:
            case 0, $aHSC5.OPEN_UPDATE_JIRA_DIALOG:
                return $5aab043d50caec0a$var$initialState;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("7TMvt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86845283ac528cc5$export$2e2bcd8739ae039);
    var $b2VIw = parcelRequire("b2VIw");
    const $86845283ac528cc5$var$initialState = null;
    var $86845283ac528cc5$export$2e2bcd8739ae039 = (state = $86845283ac528cc5$var$initialState, action)=>{
        switch(action.type){
            case 0, $b2VIw.UPDATE:
                return action.payload;
            default:
                return state;
        }
    };
});
parcelRegister("lzW8Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4963e27d53a4f4c6$export$2e2bcd8739ae039);
    var $4DrGU;
    var $2rMKg;
    var $h35CY;
    var $hpnKp;
    var $bjzU8;
    var $2J7k2 = parcelRequire("2J7k2");
    const $4963e27d53a4f4c6$var$initialState = {
        userList: []
    };
    const $4963e27d53a4f4c6$export$fff63944c1108d5c = (existingPeople, newPeople)=>{
        const indexedExistingPeople = (0, parcelRequire("4DrGU")).default((0, parcelRequire("2rMKg")).default('value'), existingPeople);
        const indexedNewPeople = (0, parcelRequire("4DrGU")).default((0, parcelRequire("2rMKg")).default('value'), newPeople);
        const mergedUsers = {
            ...indexedExistingPeople,
            ...indexedNewPeople
        };
        return (0, parcelRequire("h35CY")).default((el)=>(0, parcelRequire("hpnKp")).default(el.label), (0, parcelRequire("bjzU8")).default(mergedUsers));
    };
    var $4963e27d53a4f4c6$export$2e2bcd8739ae039 = (state = $4963e27d53a4f4c6$var$initialState, action)=>{
        switch(action.type){
            case 0, $2J7k2.RESET:
                return {
                    ...state,
                    userList: $4963e27d53a4f4c6$export$fff63944c1108d5c(state.userList, action.payload)
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("7ovQ1", function(module, exports) {
    $parcel$export(module.exports, "RESET", ()=>$ad0165ad6c4dbb44$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$ad0165ad6c4dbb44$export$aad8462122ac592b);
    const $ad0165ad6c4dbb44$export$4a991c87e640ef77 = 'state.domain.version-statuses.RESET';
    const $ad0165ad6c4dbb44$export$aad8462122ac592b = (payload)=>({
            type: $ad0165ad6c4dbb44$export$4a991c87e640ef77,
            payload: payload
        });
});
parcelRegister("4KffT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e138af0d1693ac2$export$2e2bcd8739ae039);
    var $7ovQ1 = parcelRequire("7ovQ1");
    const $7e138af0d1693ac2$var$initialState = [];
    var $7e138af0d1693ac2$export$2e2bcd8739ae039 = (state = $7e138af0d1693ac2$var$initialState, action)=>{
        switch(action.type){
            case 0, $7ovQ1.RESET:
                return [
                    ...action.payload
                ];
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("6Oo0u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$20e6ad46ec9379de$export$2e2bcd8739ae039);
    var $02IP9;
    var $2XSIf;
    var $ik0Qc;
    var $bREsp = parcelRequire("bREsp");
    var $3VttY = parcelRequire("3VttY");
    const $20e6ad46ec9379de$var$initialState = [];
    var $20e6ad46ec9379de$export$2e2bcd8739ae039 = (state = $20e6ad46ec9379de$var$initialState, action)=>{
        switch(action.type){
            case 0, $3VttY.RESET:
                return [
                    ...action.payload
                ];
            case 0, $3VttY.ADD:
                return [
                    ...state,
                    action.payload
                ];
            case 0, $3VttY.REMOVE:
                {
                    const removedId = action.payload;
                    return state.filter(({ id: id })=>id !== removedId);
                }
            case 0, $3VttY.RANK:
                {
                    const { payload: { id: id, anchor: anchor } } = action;
                    if (anchor === undefined) return state;
                    const movedVersionIndex = state.findIndex((issue)=>issue.id === id);
                    const anchorVersion = state.find((version)=>version.id === anchor);
                    if (!anchorVersion) throw new Error(`Anchor with id ${anchor} not found!`);
                    return (0, parcelRequire("02IP9")).default(movedVersionIndex, (0, parcelRequire("2XSIf")).default('lexoRank', anchorVersion.lexoRank), state);
                }
            case 0, $3VttY.BULK_UPDATE:
                {
                    const { payload: payload } = action;
                    const result = [];
                    for (const item of state){
                        const patch = payload[item.id];
                        if (patch) result.push((0, parcelRequire("ik0Qc")).default(item, patch));
                        else result.push(item);
                    }
                    return result;
                }
            case 0, $3VttY.UPDATE_REFERENCES:
                return (0, $bREsp.updateRefs)(state, action.payload);
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("3v3MM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de1873dc5d482550$export$2e2bcd8739ae039);
    var $2XSIf;
    var $jVZZA;
    var $bCWbL;
    var $cXQc6;
    var $bQZTk;
    var $3t3Pr = parcelRequire("3t3Pr");
    var $4WvE6 = parcelRequire("4WvE6");
    const $de1873dc5d482550$var$initialState = [];
    const $de1873dc5d482550$var$update = (state, id, updater)=>state.map((view)=>view.id === id ? updater(view) : view);
    const $de1873dc5d482550$var$reducer = (state = $de1873dc5d482550$var$initialState, action)=>{
        switch(action.type){
            case 0, $3t3Pr.RESET:
                return action.payload;
            case 0, $3t3Pr.SET_ACTIVE_VIEW:
                {
                    const { id: viewId } = action.payload;
                    return state.map((view)=>(0, parcelRequire("2XSIf")).default('active', view.id === viewId)(view));
                }
            case 0, $3t3Pr.MARK_AS_DEFAULT_VIEW:
                {
                    const { id: viewId } = action.payload;
                    const nextState = state.map((0, parcelRequire("2XSIf")).default('isDefault', false));
                    return $de1873dc5d482550$var$update(nextState, viewId, (0, parcelRequire("bCWbL")).default({
                        isDefault: true
                    }));
                }
            case 0, $3t3Pr.ADD_VIEW:
                {
                    const newView = action.payload;
                    let nextState = state;
                    if (newView.isDefault) nextState = nextState.map((0, parcelRequire("2XSIf")).default('isDefault', false));
                    return [
                        ...nextState,
                        action.payload
                    ];
                }
            case 0, $3t3Pr.UPDATE_VIEW:
                return $de1873dc5d482550$var$update(state, action.payload.id, (0, parcelRequire("bCWbL")).default(action.payload));
            case 0, $3t3Pr.MODIFY_VIEW:
                {
                    const { id: id, preferences: preferences } = action.payload;
                    return $de1873dc5d482550$var$update(state, id, (view)=>{
                        const brandNewUpdate = !view.original;
                        return {
                            ...view,
                            preferences: preferences,
                            persisted: brandNewUpdate ? {
                                preferences: preferences
                            } : view.persisted,
                            original: brandNewUpdate && id !== (0, $2d3f0303b0f7650a$export$bbf45675c6d09c28) ? view : view.original,
                            modified: true
                        };
                    });
                }
            case 0, $3t3Pr.DISCARD_CHANGES:
                {
                    const { id: id } = action.payload;
                    const view = state.find((one)=>one.id === id);
                    if (!view || !view.original) return state;
                    return $de1873dc5d482550$var$update(state, view.id, (view)=>{
                        if (view.original) return (0, parcelRequire("cXQc6")).default(view.original, {
                            modified: false,
                            active: view.active,
                            isDefault: view.isDefault
                        });
                        return view;
                    });
                }
            case 0, $3t3Pr.SAVE_VIEW:
                {
                    const { id: id, version: version, name: name } = action.payload;
                    return $de1873dc5d482550$var$update(state, id, (viewFromState)=>{
                        let modified = false;
                        let original = null;
                        if (viewFromState.version === version) {
                            modified = viewFromState.modified;
                            original = viewFromState.original;
                        }
                        return (0, parcelRequire("bCWbL")).default({
                            name: name,
                            version: version,
                            modified: modified,
                            original: original
                        }, viewFromState);
                    });
                }
            case 0, $3t3Pr.CHANGE_ID:
                {
                    const { previous: previous, next: next } = action.payload;
                    return $de1873dc5d482550$var$update(state, previous, (0, parcelRequire("2XSIf")).default('id', next));
                }
            case 0, $3t3Pr.REMOVE_VIEW:
                {
                    const { id: id } = action.payload;
                    return (0, parcelRequire("bQZTk")).default((0, parcelRequire("jVZZA")).default((one)=>one.id !== id), $4WvE6.trySetActiveView)(state);
                }
            default:
                return state;
        }
    };
    var $de1873dc5d482550$export$2e2bcd8739ae039 = $de1873dc5d482550$var$reducer;
});
parcelRegister("4WvE6", function(module, exports) {
    $parcel$export(module.exports, "trySetActiveView", ()=>$a4af28fb8d880348$export$5b04e006128dde6e);
    var $2XSIf;
    function $a4af28fb8d880348$export$5b04e006128dde6e(state) {
        const hasActive = state.some((one)=>one.active);
        if (hasActive) return state;
        const [nextState] = state.reduce(([acc, set], view)=>{
            if (!set && view.isDefault) {
                const nextView = (0, parcelRequire("2XSIf")).default('active', true)(view);
                return [
                    [
                        ...acc,
                        nextView
                    ],
                    true
                ];
            }
            return [
                [
                    ...acc,
                    view
                ],
                set
            ];
        }, [
            [],
            false
        ]);
        return nextState;
    }
});
parcelRegister("41Ia9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$351a13df0c0eaac6$export$2e2bcd8739ae039);
    var $hfaJb = parcelRequire("hfaJb");
    const $351a13df0c0eaac6$export$d4c72bab9d6cc13a = {
        byIssue: {},
        transitiveIssueIds: [],
        allWarningsByIssue: {}
    };
    var $351a13df0c0eaac6$export$2e2bcd8739ae039 = (state = $351a13df0c0eaac6$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $hfaJb.SET_WARNINGS:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("a3C3p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fd0e7940523ef5e$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $1O8jI = parcelRequire("1O8jI");
    var $cr1uH = parcelRequire("cr1uH");
    var $1BZac = parcelRequire("1BZac");
    var $ejSCC = parcelRequire("ejSCC");
    var $hNq4y = parcelRequire("hNq4y");
    var $8x0Vs = parcelRequire("8x0Vs");
    var $6PVu3 = parcelRequire("6PVu3");
    var $9fd0e7940523ef5e$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        Top: $6PVu3.default,
        Main: $1BZac.default,
        Errors: $cr1uH.default,
        Settings: $8x0Vs.default,
        Onboarding: $ejSCC.default,
        SectionWidths: $hNq4y.default,
        ConfluenceMacro: $1O8jI.default
    });
});
parcelRegister("1O8jI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46677e505f35a3ff$export$2e2bcd8739ae039);
    var $TTKUQ = parcelRequire("TTKUQ");
    var $7Gle9 = parcelRequire("7Gle9");
    const $46677e505f35a3ff$var$initialState = {
        confluenceMacroType: (0, $TTKUQ.TIMELINE_SHARE_TYPE)
    };
    var $46677e505f35a3ff$export$2e2bcd8739ae039 = (state = $46677e505f35a3ff$var$initialState, action)=>{
        switch(action.type){
            case 0, $7Gle9.SET_CONFLUENCE_MACRO_TYPE:
                return {
                    ...state,
                    confluenceMacroType: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("cr1uH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83ff9b323e4ea11d$export$2e2bcd8739ae039);
    var $ik0Qc;
    var $eWre9 = parcelRequire("eWre9");
    const $83ff9b323e4ea11d$export$d4c72bab9d6cc13a = {
        errors: [],
        isErrorLogDialogOpen: false,
        isProjectLimitExceeded: false
    };
    var $83ff9b323e4ea11d$export$2e2bcd8739ae039 = (state = $83ff9b323e4ea11d$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $eWre9.SHOW_ERROR:
                {
                    const { title: title, message: message, stackTrace: stackTrace, details: details, locationHash: locationHash, locationPath: locationPath, description: description } = action.payload;
                    return (0, parcelRequire("ik0Qc")).default(state, {
                        errors: [
                            {
                                id: state.errors.length,
                                title: title,
                                message: message,
                                stackTrace: stackTrace,
                                details: details,
                                locationHash: locationHash,
                                locationPath: locationPath,
                                description: description
                            },
                            ...state.errors
                        ]
                    });
                }
            case 0, $eWre9.HIDE_ERROR:
                return (0, parcelRequire("ik0Qc")).default(state, {
                    errors: state.errors.slice(1)
                });
            case 0, $eWre9.HIDE_ALL_ERRORS:
                return (0, parcelRequire("ik0Qc")).default(state, {
                    errors: []
                });
            case 0, $eWre9.SHOW_ERROR_LOG_DIALOG:
                return (0, parcelRequire("ik0Qc")).default(state, {
                    isErrorLogDialogOpen: true
                });
            case 0, $eWre9.HIDE_ERROR_LOG_DIALOG:
                return (0, parcelRequire("ik0Qc")).default(state, {
                    isErrorLogDialogOpen: false
                });
            case 0, $eWre9.SET_IS_PROJECT_LIMIT_EXCEEDED:
                return {
                    ...state,
                    isProjectLimitExceeded: true
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("1BZac", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9b2dbe0f598ae12$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $1UmjP = parcelRequire("1UmjP");
    var $f9b2dbe0f598ae12$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        Tabs: $1UmjP.default
    });
});
parcelRegister("1UmjP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$763ccb29caf70892$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $9ZYip = parcelRequire("9ZYip");
    var $dWw8p = parcelRequire("dWw8p");
    var $56diO = parcelRequire("56diO");
    var $aq0Qq = parcelRequire("aq0Qq");
    var $763ccb29caf70892$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        Roadmap: $56diO.default,
        Releases: $dWw8p.default,
        Teams: $aq0Qq.default,
        Dependencies: $9ZYip.default
    });
});
parcelRegister("9ZYip", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01ffe765d840dd00$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $jsbgK = parcelRequire("jsbgK");
    var $hXZGo = parcelRequire("hXZGo");
    var $3VaSK = parcelRequire("3VaSK");
    var $4jXTN = parcelRequire("4jXTN");
    var $01ffe765d840dd00$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        AddDependency: $jsbgK.default,
        Filters: $hXZGo.default,
        ReportState: $3VaSK.default,
        StagePosAndScale: $4jXTN.default
    });
});
parcelRegister("jsbgK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$146df247fa0f61f8$export$2e2bcd8739ae039);
    var $bGvUo = parcelRequire("bGvUo");
    const $146df247fa0f61f8$var$initialState = {
        show: false
    };
    var $146df247fa0f61f8$export$2e2bcd8739ae039 = (state = $146df247fa0f61f8$var$initialState, action)=>{
        switch(action.type){
            case 0, $bGvUo.SHOW_ADD_DEPENDENCY:
                return {
                    ...state,
                    show: true
                };
            case 0, $bGvUo.HIDE_ADD_DEPENDENCY:
                return {
                    ...state,
                    show: false,
                    fromIssueId: undefined
                };
            case 0, $bGvUo.SHOW_ADD_DEPENDENCY_FROM_ISSUE:
                return {
                    ...state,
                    show: true,
                    fromIssueId: action.payload
                };
            default:
                return state;
        }
    };
});
parcelRegister("bGvUo", function(module, exports) {
    $parcel$export(module.exports, "SHOW_ADD_DEPENDENCY", ()=>$cae2b35271993df4$export$930cb2608d44b969);
    $parcel$export(module.exports, "HIDE_ADD_DEPENDENCY", ()=>$cae2b35271993df4$export$fd6dfcc200390a20);
    $parcel$export(module.exports, "SHOW_ADD_DEPENDENCY_FROM_ISSUE", ()=>$cae2b35271993df4$export$d0f393b30f752ecb);
    $parcel$export(module.exports, "showAddDependency", ()=>$cae2b35271993df4$export$636ddd791d583885);
    $parcel$export(module.exports, "hideAddDependency", ()=>$cae2b35271993df4$export$ff8355cfea6e30e1);
    $parcel$export(module.exports, "showAddDependencyFromIssue", ()=>$cae2b35271993df4$export$4c249c02fe79d5e6);
    const $cae2b35271993df4$export$930cb2608d44b969 = 'state.ui.main.tabs.dependencies.addDependency.SHOW_ADD_DEPENDENCY';
    const $cae2b35271993df4$export$fd6dfcc200390a20 = 'state.ui.main.tabs.dependencies.addDependency.HIDE_ADD_DEPENDENCY';
    const $cae2b35271993df4$export$d0f393b30f752ecb = 'state.ui.main.tabs.dependencies.addDependency.SHOW_ADD_DEPENDENCY_FROM_ISSUE';
    const $cae2b35271993df4$export$636ddd791d583885 = ()=>({
            type: $cae2b35271993df4$export$930cb2608d44b969
        });
    const $cae2b35271993df4$export$ff8355cfea6e30e1 = ()=>({
            type: $cae2b35271993df4$export$fd6dfcc200390a20
        });
    const $cae2b35271993df4$export$4c249c02fe79d5e6 = (id)=>({
            type: $cae2b35271993df4$export$d0f393b30f752ecb,
            payload: id
        });
});
parcelRegister("hXZGo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$433102171bda3b2a$export$2e2bcd8739ae039);
    var $iLfHk = parcelRequire("iLfHk");
    const $433102171bda3b2a$var$initialState = {
        rollupBy: null,
        rollupHierarchyLevel: -1,
        groupBy: null,
        issueInFocus: null,
        issueFilter: null,
        projectFilter: null,
        sprintFilter: null,
        issueLinkTypeFilter: null
    };
    var $433102171bda3b2a$export$2e2bcd8739ae039 = (state = $433102171bda3b2a$var$initialState, action)=>{
        switch(action.type){
            case 0, $iLfHk.SET_ROLLUP_FILTER:
                return {
                    ...state,
                    rollupBy: action.payload.rollupBy,
                    rollupHierarchyLevel: action.payload.rollupHierarchyLevel,
                    issueFilter: null
                };
            case 0, $iLfHk.SET_ISSUE_IN_FOCUS:
                return {
                    ...state,
                    issueInFocus: action.payload
                };
            case 0, $iLfHk.SET_GROUP_BY:
                return {
                    ...state,
                    groupBy: action.payload
                };
            case 0, $iLfHk.SET_ISSUE_FILTER:
                return {
                    ...state,
                    issueFilter: action.payload
                };
            case 0, $iLfHk.SET_PROJECT_FILTER:
                return {
                    ...state,
                    projectFilter: action.payload
                };
            case 0, $iLfHk.SET_ISSUE_LINK_TYPE_FILTER:
                return {
                    ...state,
                    issueLinkTypeFilter: action.payload
                };
            case 0, $iLfHk.SET_SPRINT_FILTER:
                return {
                    ...state,
                    sprintFilter: action.payload
                };
            case 0, $iLfHk.RESET_FILTERS:
                return {
                    ...state,
                    ...$433102171bda3b2a$var$initialState
                };
            case 0, $iLfHk.INITIATE_FILTERS:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("3VaSK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa1c4bf25e088a98$export$2e2bcd8739ae039);
    var $baqyD = parcelRequire("baqyD");
    var $brWHE = parcelRequire("brWHE");
    const $fa1c4bf25e088a98$var$initialState = {
        status: (0, $brWHE.ReportStatus).LOADING
    };
    var $fa1c4bf25e088a98$export$2e2bcd8739ae039 = (state = $fa1c4bf25e088a98$var$initialState, action)=>{
        switch(action.type){
            case 0, $baqyD.SET_REPORT_STATUS:
                return {
                    ...state,
                    status: action.payload
                };
            default:
                return state;
        }
    };
});
parcelRegister("baqyD", function(module, exports) {
    $parcel$export(module.exports, "SET_REPORT_STATUS", ()=>$1d73080895973fbd$export$61d1aa0baef12c2d);
    $parcel$export(module.exports, "setReportStatus", ()=>$1d73080895973fbd$export$c708fed96182e84a);
    const $1d73080895973fbd$export$61d1aa0baef12c2d = 'state.ui.main.tabs.dependencies.report-state.SET_REPORT_STATUS';
    const $1d73080895973fbd$export$c708fed96182e84a = (status)=>({
            type: $1d73080895973fbd$export$61d1aa0baef12c2d,
            payload: status
        });
});
parcelRegister("4jXTN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06b8648bdde0934f$export$2e2bcd8739ae039);
    var $4ocW3 = parcelRequire("4ocW3");
    const $06b8648bdde0934f$var$initialState = {
        x: 0,
        y: 0,
        scale: 1
    };
    var $06b8648bdde0934f$export$2e2bcd8739ae039 = (state = $06b8648bdde0934f$var$initialState, action)=>{
        switch(action.type){
            case 0, $4ocW3.SET_STAGE_POSITION_SCALE:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                return state;
        }
    };
});
parcelRegister("4ocW3", function(module, exports) {
    $parcel$export(module.exports, "SET_STAGE_POSITION_SCALE", ()=>$5c2e1f478113fc02$export$3568144dfe0024c2);
    $parcel$export(module.exports, "setStagePositionAndScale", ()=>$5c2e1f478113fc02$export$4cb0c81df7018081);
    const $5c2e1f478113fc02$export$3568144dfe0024c2 = 'state.ui.main.tabs.dependencies.stage-position-scale.SET_STAGE_POSITION_SCALE';
    const $5c2e1f478113fc02$export$4cb0c81df7018081 = (pos)=>({
            type: $5c2e1f478113fc02$export$3568144dfe0024c2,
            payload: pos
        });
});
parcelRegister("dWw8p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$554d40c01775ab0a$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $f8JxC = parcelRequire("f8JxC");
    var $22Xl5 = parcelRequire("22Xl5");
    var $bM8eo = parcelRequire("bM8eo");
    var $554d40c01775ab0a$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        CrossProjectReleases: $f8JxC.default,
        ProjectReleases: $bM8eo.default,
        ReleasesFilter: $22Xl5.default
    });
});
parcelRegister("f8JxC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3e71dd4e10cddad$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $2UsR5 = parcelRequire("2UsR5");
    var $5j3Iv = parcelRequire("5j3Iv");
    var $3hxMX = parcelRequire("3hxMX");
    var $6mUv8 = parcelRequire("6mUv8");
    var $e3e71dd4e10cddad$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        ReleaseDialog: $3hxMX.default,
        ReleasesTable: $6mUv8.default,
        AlignDatesDialog: $2UsR5.default,
        DeleteReleaseDialog: $5j3Iv.default
    });
});
parcelRegister("2UsR5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d4687684f69311d$export$2e2bcd8739ae039);
    var $jl9zM = parcelRequire("jl9zM");
    const $8d4687684f69311d$var$initialState = {
        isDialogOpen: false,
        versionId: '',
        isProcessingRequest: false
    };
    var $8d4687684f69311d$export$2e2bcd8739ae039 = (state = $8d4687684f69311d$var$initialState, action)=>{
        switch(action.type){
            case 0, $jl9zM.OPEN_DIALOG:
                return {
                    ...state,
                    isDialogOpen: true,
                    versionId: action.versionId
                };
            case 0, $jl9zM.CLOSE_DIALOG:
                return $8d4687684f69311d$var$initialState;
            case 0, $jl9zM.INITIATE_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: true
                };
            case 0, $jl9zM.RESET_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("5j3Iv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fb0ec0c1a27b272$export$2e2bcd8739ae039);
    var $3rJDR = parcelRequire("3rJDR");
    const $4fb0ec0c1a27b272$var$initialState = {
        isDialogOpen: false,
        versionId: '',
        isProcessingRequest: false
    };
    var $4fb0ec0c1a27b272$export$2e2bcd8739ae039 = (state = $4fb0ec0c1a27b272$var$initialState, action)=>{
        switch(action.type){
            case 0, $3rJDR.OPEN_DIALOG:
                return {
                    ...state,
                    isDialogOpen: true,
                    versionId: action.versionId
                };
            case 0, $3rJDR.CLOSE_DIALOG:
                return $4fb0ec0c1a27b272$var$initialState;
            case 0, $3rJDR.INITIATE_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: true
                };
            case 0, $3rJDR.RESET_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("3hxMX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8430400bffc865a$export$2e2bcd8739ae039);
    var $77qPV = parcelRequire("77qPV");
    const $a8430400bffc865a$var$initialState = {
        mode: (0, $9f0e8f377b448222$export$afecb711a599950a),
        isDialogOpen: false,
        isProcessingRequest: false,
        versionId: null
    };
    var $a8430400bffc865a$export$2e2bcd8739ae039 = (state = $a8430400bffc865a$var$initialState, action)=>{
        switch(action.type){
            case 0, $77qPV.SET_MODE:
                return {
                    ...state,
                    mode: action.payload
                };
            case 0, $77qPV.OPEN_DIALOG:
                {
                    const { versionId: versionId } = action.payload;
                    return {
                        ...state,
                        isDialogOpen: true,
                        versionId: versionId
                    };
                }
            case 0, $77qPV.CLOSE_DIALOG:
                return {
                    ...state,
                    isDialogOpen: false,
                    versionId: null
                };
            case 0, $77qPV.INITIATE_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: true
                };
            case 0, $77qPV.RESET_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("6mUv8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09ba93d0d2f9fd68$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $kLst8 = parcelRequire("kLst8");
    var $09ba93d0d2f9fd68$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        ProjectReleases: $kLst8.default
    });
});
parcelRegister("kLst8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f5c3813379c87a7$export$2e2bcd8739ae039);
    var $9MFji = parcelRequire("9MFji");
    const $0f5c3813379c87a7$export$d4c72bab9d6cc13a = {
        isFlyoutOpen: false,
        currentCrossProjectVersionId: null
    };
    var $0f5c3813379c87a7$export$2e2bcd8739ae039 = (state = $0f5c3813379c87a7$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $9MFji.OPEN_FLYOUT:
                return {
                    isFlyoutOpen: true,
                    currentCrossProjectVersionId: action.payload.crossProjectVersionId
                };
            case 0, $9MFji.CLOSE_FLYOUT:
                return {
                    ...$0f5c3813379c87a7$export$d4c72bab9d6cc13a
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("22Xl5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ccd128787b28f95$export$2e2bcd8739ae039);
    var $2Dkq0 = parcelRequire("2Dkq0");
    const $9ccd128787b28f95$var$initialState = {
        textFilter: '',
        statusFilter: []
    };
    var $9ccd128787b28f95$export$2e2bcd8739ae039 = (state = $9ccd128787b28f95$var$initialState, action)=>{
        switch(action.type){
            case 0, $2Dkq0.SET_TEXT_FILTER:
                return {
                    ...state,
                    textFilter: action.textFilter
                };
            case 0, $2Dkq0.SET_STATUS_FILTER:
                return {
                    ...state,
                    statusFilter: action.statusFilter
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("2Dkq0", function(module, exports) {
    $parcel$export(module.exports, "SET_TEXT_FILTER", ()=>$5e2e750b1f191974$export$3ff6c5ed0a39e295);
    $parcel$export(module.exports, "SET_STATUS_FILTER", ()=>$5e2e750b1f191974$export$fab3161b91e72a41);
    $parcel$export(module.exports, "setTextFilter", ()=>$5e2e750b1f191974$export$18ecd839459a178a);
    $parcel$export(module.exports, "setStatusFilter", ()=>$5e2e750b1f191974$export$53079c817c07f5a2);
    const $5e2e750b1f191974$export$3ff6c5ed0a39e295 = 'state.ui.main.tabs.releases.filter.SET_TEXT_FILTER';
    const $5e2e750b1f191974$export$fab3161b91e72a41 = 'state.ui.main.tabs.releases.filter.SET_STATUS_FILTER';
    const $5e2e750b1f191974$export$18ecd839459a178a = (textFilter)=>({
            type: $5e2e750b1f191974$export$3ff6c5ed0a39e295,
            textFilter: textFilter
        });
    const $5e2e750b1f191974$export$53079c817c07f5a2 = (statusFilter)=>({
            type: $5e2e750b1f191974$export$fab3161b91e72a41,
            statusFilter: statusFilter
        });
});
parcelRegister("bM8eo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$11d1401d0a90c63f$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $8rdO8 = parcelRequire("8rdO8");
    var $kT4Zb = parcelRequire("kT4Zb");
    var $2PMeS = parcelRequire("2PMeS");
    var $5UtmW = parcelRequire("5UtmW");
    var $11d1401d0a90c63f$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        ReleasesTable: $5UtmW.default,
        ReleaseDialog: $2PMeS.default,
        DeleteReleaseDialog: $kT4Zb.default,
        AddToCprDialog: $8rdO8.default
    });
});
parcelRegister("8rdO8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86080bec6e1af119$export$2e2bcd8739ae039);
    var $2Cx2m = parcelRequire("2Cx2m");
    const $86080bec6e1af119$var$initialState = {
        isDialogOpen: false,
        versionId: ''
    };
    var $86080bec6e1af119$export$2e2bcd8739ae039 = (state = $86080bec6e1af119$var$initialState, action)=>{
        switch(action.type){
            case 0, $2Cx2m.OPEN_DIALOG:
                return {
                    ...state,
                    isDialogOpen: true,
                    versionId: action.versionId
                };
            case 0, $2Cx2m.CLOSE_DIALOG:
                return $86080bec6e1af119$var$initialState;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("kT4Zb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$20092345a6275426$export$2e2bcd8739ae039);
    var $kcnfF = parcelRequire("kcnfF");
    var $kyJxl = parcelRequire("kyJxl");
    const $20092345a6275426$var$initialState = {
        mode: (0, $kyJxl.DELETE_RELEASE),
        isDialogOpen: false,
        versionId: '',
        isProcessingRequest: false
    };
    var $20092345a6275426$export$2e2bcd8739ae039 = (state = $20092345a6275426$var$initialState, action)=>{
        switch(action.type){
            case 0, $kcnfF.SET_MODE:
                return {
                    ...state,
                    mode: action.payload
                };
            case 0, $kcnfF.OPEN_DIALOG:
                return {
                    ...state,
                    isDialogOpen: true,
                    versionId: action.versionId
                };
            case 0, $kcnfF.CLOSE_DIALOG:
                return $20092345a6275426$var$initialState;
            case 0, $kcnfF.INITIATE_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: true
                };
            case 0, $kcnfF.RESET_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("2PMeS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e835e26b8b28c043$export$2e2bcd8739ae039);
    var $1yVQz = parcelRequire("1yVQz");
    const $e835e26b8b28c043$var$initialState = {
        mode: (0, $d912598f161dc1cb$export$afecb711a599950a),
        isDialogOpen: false,
        projectId: 0,
        isProcessingRequest: false
    };
    var $e835e26b8b28c043$export$2e2bcd8739ae039 = (state = $e835e26b8b28c043$var$initialState, action)=>{
        switch(action.type){
            case 0, $1yVQz.SET_MODE:
                return {
                    ...state,
                    mode: action.payload
                };
            case 0, $1yVQz.OPEN_DIALOG:
                {
                    const { projectId: projectId, versionId: versionId } = action.payload;
                    return {
                        ...state,
                        isDialogOpen: true,
                        projectId: projectId,
                        versionId: versionId
                    };
                }
            case 0, $1yVQz.CLOSE_DIALOG:
                return {
                    ...state,
                    projectId: 0,
                    versionId: null,
                    isDialogOpen: false
                };
            case 0, $1yVQz.INITIATE_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: true
                };
            case 0, $1yVQz.RESET_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("5UtmW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6049c69c94a25871$export$2e2bcd8739ae039);
    var $gGkgE = parcelRequire("gGkgE");
    const $6049c69c94a25871$export$d4c72bab9d6cc13a = {
        isRanking: false
    };
    var $6049c69c94a25871$export$2e2bcd8739ae039 = (state = $6049c69c94a25871$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $gGkgE.SET_RANKING_STATE:
                return {
                    isRanking: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("56diO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d2194b18bb18942$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $hTomk = parcelRequire("hTomk");
    var $9xQmH = parcelRequire("9xQmH");
    var $6X2VO = parcelRequire("6X2VO");
    var $dPzUj = parcelRequire("dPzUj");
    var $9iNdL = parcelRequire("9iNdL");
    var $8d2194b18bb18942$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        Fields: $hTomk.default,
        Scope: $9xQmH.default,
        Timeline: $9iNdL.default,
        TimelinePreview: $dPzUj.default,
        StickyHeader: $6X2VO.default
    });
});
parcelRegister("hTomk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$270b50bad55b8a58$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $8DV6t = parcelRequire("8DV6t");
    var $8ha15 = parcelRequire("8ha15");
    var $270b50bad55b8a58$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        Assignee: $8DV6t.default,
        CustomFields: $8ha15.default
    });
});
parcelRegister("8DV6t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63308f3f43020e87$export$2e2bcd8739ae039);
    var $g6VWU = parcelRequire("g6VWU");
    const $63308f3f43020e87$var$initialState = {
        isFetchAssigneeListInProgress: false,
        issueIdForFetchAssigneeListProgress: ''
    };
    var $63308f3f43020e87$export$2e2bcd8739ae039 = (state = $63308f3f43020e87$var$initialState, action)=>{
        switch(action.type){
            case 0, $g6VWU.FETCH_ASSIGNEES_START:
                return {
                    isFetchAssigneeListInProgress: true,
                    issueIdForFetchAssigneeListProgress: action.payload.issueId
                };
            case 0, $g6VWU.FETCH_ASSIGNEES_STOP:
                return {
                    isFetchAssigneeListInProgress: false,
                    issueIdForFetchAssigneeListProgress: action.payload.issueId
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("8ha15", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$401a62989582a74c$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $02SZ0 = parcelRequire("02SZ0");
    var $401a62989582a74c$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        UserPicker: $02SZ0.default
    });
});
parcelRegister("02SZ0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d371fab64044e8a3$export$2e2bcd8739ae039);
    var $3Ujui = parcelRequire("3Ujui");
    const $d371fab64044e8a3$var$initialState = {
        isFetchUserListInProgress: false,
        issueId: ''
    };
    var $d371fab64044e8a3$export$2e2bcd8739ae039 = (state = $d371fab64044e8a3$var$initialState, action)=>{
        switch(action.type){
            case 0, $3Ujui.FETCH_USER_START:
                return {
                    isFetchUserListInProgress: true,
                    issueId: action.payload.issueId
                };
            case 0, $3Ujui.FETCH_USER_STOP:
                return {
                    isFetchUserListInProgress: false,
                    issueId: action.payload.issueId
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("9xQmH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c77a32244e9fd58$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $jHL0V = parcelRequire("jHL0V");
    var $cy8s7 = parcelRequire("cy8s7");
    var $gcH2z = parcelRequire("gcH2z");
    var $6c77a32244e9fd58$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        Issues: $gcH2z.default,
        InlineCreate: $cy8s7.default,
        Header: $jHL0V.default
    });
});
parcelRegister("jHL0V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df5b773005b26383$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $cComJ = parcelRequire("cComJ");
    var $df5b773005b26383$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        Search: $cComJ.default
    });
});
parcelRegister("cComJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69f9b5963b2db263$export$2e2bcd8739ae039);
    var $23472 = parcelRequire("23472");
    const $69f9b5963b2db263$var$initialState = {
        activeSearchResultIndex: 1,
        isSearchBoxOpen: false,
        searchQuery: ''
    };
    const $69f9b5963b2db263$var$reducer = (state = $69f9b5963b2db263$var$initialState, action)=>{
        switch(action.type){
            case 0, $23472.RESET_SEARCH_RESULTS:
                return $69f9b5963b2db263$var$initialState;
            case 0, $23472.SET_ACTIVE_SEARCH_RESULT_INDEX:
                return {
                    ...state,
                    activeSearchResultIndex: action.payload
                };
            case 0, $23472.SET_SEARCH_QUERY:
                return {
                    ...state,
                    searchQuery: action.payload
                };
            case 0, $23472.TOGGLE_ISSUE_SEARCH:
                return {
                    ...state,
                    isSearchBoxOpen: action.payload
                };
            default:
                return state;
        }
    };
    var $69f9b5963b2db263$export$2e2bcd8739ae039 = $69f9b5963b2db263$var$reducer;
});
parcelRegister("gcH2z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8402e481cdc17863$export$2e2bcd8739ae039);
    var $7haN1 = parcelRequire("7haN1");
    var $aPV8A = parcelRequire("aPV8A");
    const $8402e481cdc17863$export$d4c72bab9d6cc13a = {
        selected: new Set(),
        lastSelected: {},
        isLoading: true,
        isLoadingHistory: false,
        isSavingIssue: false
    };
    const $8402e481cdc17863$var$reducer = (state = $8402e481cdc17863$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $7haN1.RESET:
                return {
                    isLoading: state.isLoading,
                    selected: new Set(),
                    lastSelected: {},
                    isSavingIssue: false,
                    isLoadingHistory: false
                };
            case 0, $7haN1.SET_IS_LOADING:
                return {
                    ...state,
                    isLoading: action.payload
                };
            case 0, $7haN1.SET_IS_LOADING_HISTORY:
                return {
                    ...state,
                    isLoadingHistory: action.payload
                };
            case 0, $7haN1.SET_IS_SAVING:
                return {
                    ...state,
                    isSavingIssue: action.payload
                };
            default:
                action;
                return (0, $aPV8A.default)(state, action);
        }
    };
    var $8402e481cdc17863$export$2e2bcd8739ae039 = $8402e481cdc17863$var$reducer;
});
parcelRegister("aPV8A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c2723b277a936f4$export$2e2bcd8739ae039);
    var $4nDwW = parcelRequire("4nDwW");
    var $3ODbh = parcelRequire("3ODbh");
    const $2c2723b277a936f4$var$reducer = (state, action)=>{
        switch(action.type){
            case 0, $3ODbh.TOGGLE_SELECTED_ISSUES:
                {
                    const { payload: { ids: ids, isSelected: isSelected, group: group, toggleAll: toggleAll } } = action;
                    if (toggleAll === true) return {
                        ...state,
                        selected: isSelected ? new Set(ids) : new Set(),
                        lastSelected: {}
                    };
                    const selected = new Set(state.selected);
                    for (const id of ids)if (isSelected) selected.add(id);
                    else selected.delete(id);
                    if ((0, $4nDwW.isDefined)(action.payload.currentIssueId) && ids.length) selected.delete(action.payload.currentIssueId);
                    return {
                        ...state,
                        selected: selected,
                        lastSelected: {
                            id: ids.slice(-1)[0],
                            group: group,
                            isSelected: isSelected
                        }
                    };
                }
            default:
                return state;
        }
    };
    var $2c2723b277a936f4$export$2e2bcd8739ae039 = $2c2723b277a936f4$var$reducer;
});
parcelRegister("6X2VO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6209ef2125f8badf$export$2e2bcd8739ae039);
    var $7oNzf = parcelRequire("7oNzf");
    const $6209ef2125f8badf$var$initialState = {
        scrollTop: 0
    };
    var $6209ef2125f8badf$export$2e2bcd8739ae039 = (state = $6209ef2125f8badf$var$initialState, action)=>{
        if (action.type === (0, $7oNzf.SET_STICKY_HEADER_SCROLL)) return {
            ...state,
            ...action.payload
        };
        return state;
    };
});
parcelRegister("dPzUj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f204816061208a97$export$2e2bcd8739ae039);
    var $kSwbB;
    var $cTYeP;
    var $cBJwN;
    var $bAv9r;
    var $76p2G;
    var $4Rr1a;
    var $7p8Aa;
    var $6nTyZ;
    var $4nDwW = parcelRequire("4nDwW");
    var $k49aW = parcelRequire("k49aW");
    function $f204816061208a97$var$update(oldState, issueIds, operation) {
        const op = ([issueId, issue])=>[
                issueId,
                (0, parcelRequire("cTYeP")).default(issueId, issueIds) ? operation(issue, issueId) : issue
            ];
        const previews = (0, parcelRequire("cBJwN")).default((0, parcelRequire("4Rr1a")).default(op, (0, parcelRequire("6nTyZ")).default(oldState.previews)));
        return {
            ...oldState,
            previews: previews
        };
    }
    var $f204816061208a97$export$2e2bcd8739ae039 = (state = null, action)=>{
        if (action.type === (0, $k49aW.SET_PREVIEW_ISSUES)) {
            const { activeIssueId: activeIssueId, issueAndAncestors: issueAndAncestors, strictDescendents: strictDescendents } = action.payload;
            const previews = (0, parcelRequire("cBJwN")).default((0, parcelRequire("kSwbB")).default((0, parcelRequire("6nTyZ")).default(issueAndAncestors), (0, parcelRequire("6nTyZ")).default(strictDescendents)));
            const strictAncestorIds = (0, parcelRequire("7p8Aa")).default((0, parcelRequire("bAv9r")).default(activeIssueId), (0, parcelRequire("76p2G")).default(issueAndAncestors));
            return {
                activeIssueId: activeIssueId,
                strictAncestorIds: strictAncestorIds,
                strictDescendentIds: (0, parcelRequire("76p2G")).default(strictDescendents),
                previews: previews
            };
        }
        if (!state) return state;
        switch(action.type){
            case 0, $k49aW.MOVE_ISSUE_AND_DESCENDENTS:
                {
                    const { delta: delta, targetStart: targetStart, targetEnd: targetEnd } = action.payload;
                    const { strictDescendentIds: strictDescendentIds, activeIssueId: activeIssueId } = state;
                    return $f204816061208a97$var$update(state, [
                        ...strictDescendentIds,
                        activeIssueId
                    ], (issue, issueId)=>{
                        const shift = (num)=>(0, $4nDwW.isDefined)(num) ? delta + num : undefined;
                        const rest = {
                            ...issue
                        };
                        if (issueId === activeIssueId) delete rest.inferred;
                        return {
                            ...rest,
                            baselineStart: shift(issueId === activeIssueId ? targetStart : issue.baselineStart),
                            baselineEnd: shift(issueId === activeIssueId ? targetEnd : issue.baselineEnd)
                        };
                    });
                }
            case 0, $k49aW.SET_ISSUES_START:
                {
                    const { issueIds: issueIds, baselineStart: baselineStart } = action.payload;
                    return $f204816061208a97$var$update(state, issueIds, ({ baselineEnd: baselineEnd, shouldSync: shouldSync, inferred: inferred })=>{
                        const newInferred = inferred;
                        if (newInferred) delete newInferred.baselineStart;
                        return {
                            inferred: newInferred,
                            baselineStart: baselineStart,
                            baselineEnd: baselineEnd,
                            shouldSync: shouldSync
                        };
                    });
                }
            case 0, $k49aW.SET_ISSUES_END:
                {
                    const { issueIds: issueIds, baselineEnd: baselineEnd } = action.payload;
                    return $f204816061208a97$var$update(state, issueIds, ({ baselineStart: baselineStart, shouldSync: shouldSync, inferred: inferred })=>{
                        const newInferred = inferred;
                        if (newInferred) delete newInferred.baselineEnd;
                        return {
                            inferred: newInferred,
                            baselineStart: baselineStart,
                            baselineEnd: baselineEnd,
                            shouldSync: shouldSync
                        };
                    });
                }
            case 0, $k49aW.CLEAR_PREVIEW:
                return null;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("bAv9r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86fb387a7d9b6ef1$export$2e2bcd8739ae039);
    var $ebXyp;
    var $c9RLn;
    var $86fb387a7d9b6ef1$var$identical = (0, (0, parcelRequire("c9RLn")).default)((0, (0, parcelRequire("ebXyp")).default));
    var $86fb387a7d9b6ef1$export$2e2bcd8739ae039 = $86fb387a7d9b6ef1$var$identical;
});
parcelRegister("9iNdL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9102f746e1343202$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $hBpbh = parcelRequire("hBpbh");
    var $6JMQR = parcelRequire("6JMQR");
    var $9102f746e1343202$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        ReleaseBar: $hBpbh.default,
        Schedule: $6JMQR.default
    });
});
parcelRegister("hBpbh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4598ffbe1d32718$export$2e2bcd8739ae039);
    parcelRequire("5j69e");
    var $bL3GI = parcelRequire("bL3GI");
    var $bqD5G = parcelRequire("bqD5G");
    var $b9Xhh = parcelRequire("b9Xhh");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $5BBQV = parcelRequire("5BBQV");
    const $a4598ffbe1d32718$export$d4c72bab9d6cc13a = {
        mode: (0, $TTKUQ.RELEASE),
        isFlyoutOpen: false,
        versionIds: [],
        prevVersionIds: [],
        highlightedVersionIds: new Set()
    };
    const $a4598ffbe1d32718$export$1650419e431d3ba3 = (state = $a4598ffbe1d32718$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $5BBQV.SET_MODE:
                return {
                    ...state,
                    mode: action.payload
                };
            case 0, $5BBQV.OPEN_FLYOUT:
                {
                    const { mode: mode, versionIds: versionIds } = action.payload;
                    return {
                        mode: mode,
                        isFlyoutOpen: true,
                        versionIds: versionIds,
                        highlightedVersionIds: state.highlightedVersionIds
                    };
                }
            case 0, $5BBQV.UPDATE_FLYOUT:
                {
                    const { mode: mode, versionIds: versionIds, prevVersionIds: prevVersionIds } = action.payload;
                    return {
                        ...state,
                        mode: mode,
                        versionIds: versionIds,
                        prevVersionIds: prevVersionIds
                    };
                }
            case 0, $5BBQV.CLOSE_FLYOUT:
                return {
                    ...state,
                    isFlyoutOpen: false
                };
            case 0, $5BBQV.TOGGLE_RELEASE_HIGHLIGHT:
                {
                    const { versionId: versionId } = action;
                    const highlightedVersionIds = new Set(state.highlightedVersionIds);
                    if (highlightedVersionIds.has(versionId)) highlightedVersionIds.delete(versionId);
                    else highlightedVersionIds.add(versionId);
                    return {
                        ...state,
                        highlightedVersionIds: highlightedVersionIds
                    };
                }
            case 0, $5BBQV.RESET_RELEASE_HIGHLIGHTS:
                return {
                    ...state,
                    highlightedVersionIds: new Set(action.versionIds)
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
    const $a4598ffbe1d32718$var$SetTransform = (0, $bL3GI.default)((highlightedVersionIds)=>[
            ...highlightedVersionIds
        ], (highlightedVersionIds)=>new Set(highlightedVersionIds), {
        whitelist: [
            'highlightedVersionIds'
        ]
    });
    var $a4598ffbe1d32718$export$2e2bcd8739ae039 = (0, $b9Xhh.persistReducer)({
        key: (0, $bqD5G.getPlanPrefixedKey)('release-bar'),
        whitelist: [
            'highlightedVersionIds'
        ],
        transforms: [
            $a4598ffbe1d32718$var$SetTransform
        ]
    }, $a4598ffbe1d32718$export$1650419e431d3ba3);
});
parcelRegister("6JMQR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb8cd28f21ec4a5f$export$2e2bcd8739ae039);
    var $62dg4 = parcelRequire("62dg4");
    const $bb8cd28f21ec4a5f$var$initialState = {
        onlyEnabledIssueId: null
    };
    var $bb8cd28f21ec4a5f$export$2e2bcd8739ae039 = (state = $bb8cd28f21ec4a5f$var$initialState, action)=>{
        switch(action.type){
            case 0, $62dg4.ENABLE_ONLY_ISSUE_ID:
                return {
                    ...state,
                    onlyEnabledIssueId: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("aq0Qq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da01f4414e4160a9$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $9nR0b = parcelRequire("9nR0b");
    var $ib357 = parcelRequire("ib357");
    var $da01f4414e4160a9$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        TeamsList: $ib357.default,
        CreateTeam: $9nR0b.default
    });
});
parcelRegister("9nR0b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67364a09fa31df4d$export$2e2bcd8739ae039);
    var $duqH3 = parcelRequire("duqH3");
    const $67364a09fa31df4d$var$initialState = {
        addedTWPTeamTitle: undefined,
        addedTWPTeamId: undefined,
        isCreateTwpFormLoading: false
    };
    var $67364a09fa31df4d$export$2e2bcd8739ae039 = (state = $67364a09fa31df4d$var$initialState, action)=>{
        switch(action.type){
            case 0, $duqH3.STORE_ADDED_TWP_TEAM:
                return {
                    ...state,
                    addedTWPTeamTitle: action.payload.teamTitle,
                    addedTWPTeamId: action.payload.teamId
                };
            case 0, $duqH3.RESET_ADDED_TWP_TEAM:
                return {
                    ...state,
                    addedTWPTeamTitle: undefined,
                    addedTWPTeamId: undefined
                };
            case 0, $duqH3.LOAD_CREATE_TWP_FORM:
                return {
                    ...state,
                    isCreateTwpFormLoading: true
                };
            case 0, $duqH3.RESET_CREATE_TWP_FORM:
                return {
                    ...state,
                    isCreateTwpFormLoading: false
                };
            default:
                return state;
        }
    };
});
parcelRegister("ib357", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$868471f748d2e770$export$2e2bcd8739ae039);
    var $6Qf3i = parcelRequire("6Qf3i");
    const $868471f748d2e770$var$initialState = {
        isDialogOpen: false,
        isProcessingRequest: false,
        showSharedTeamSuccessFlag: false
    };
    var $868471f748d2e770$export$2e2bcd8739ae039 = (state = $868471f748d2e770$var$initialState, action)=>{
        switch(action.type){
            case 0, $6Qf3i.OPEN_TEAMS_DIALOG:
                return {
                    ...state,
                    ...action.payload,
                    isDialogOpen: true
                };
            case 0, $6Qf3i.CLOSE_TEAMS_DIALOG:
                return {
                    ...state,
                    isDialogOpen: false
                };
            case 0, $6Qf3i.INITIATE_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: true
                };
            case 0, $6Qf3i.RESET_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: false
                };
            case 0, $6Qf3i.SET_MODE:
                return {
                    ...state,
                    dialogMode: action.payload
                };
            case 0, $6Qf3i.SHOW_SHARED_TEAM_SUCCESS_FLAG:
                return {
                    ...state,
                    showSharedTeamSuccessFlag: action.payload.showSharedTeamSuccessFlag
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("ejSCC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aecf648e8d08ad5a$export$2e2bcd8739ae039);
    var $iG8V9 = parcelRequire("iG8V9");
    const $aecf648e8d08ad5a$var$initialState = {
        isIntroOpen: false,
        activeCard: ''
    };
    var $aecf648e8d08ad5a$export$2e2bcd8739ae039 = (state = $aecf648e8d08ad5a$var$initialState, action)=>{
        switch(action.type){
            case 0, $iG8V9.SET_ACTIVE_CARD:
                return {
                    ...state,
                    activeCard: action.payload
                };
            case 0, $iG8V9.SET_INTRO_OPEN:
                return {
                    ...state,
                    isIntroOpen: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("hNq4y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97b66d3297eebea2$export$2e2bcd8739ae039);
    var $TTKUQ = parcelRequire("TTKUQ");
    const $97b66d3297eebea2$var$initialState = {
        scope: (0, $TTKUQ.EXPORT_VIEW_DEFAULT_SCOPE_WIDTH),
        fields: (0, $TTKUQ.EXPORT_VIEW_DEFAULT_FIELDS_WIDTH),
        timeline: 0,
        timelineExport: (0, $TTKUQ.EXPORT_VIEW_DEFAULT_TIMELINE_WIDTH)
    };
    var $97b66d3297eebea2$export$2e2bcd8739ae039 = (state = $97b66d3297eebea2$var$initialState, action)=>{
        switch(action.type){
            case 0, $eaefe8f4970420bd$export$47640bb49c9df5f2:
                return {
                    ...state,
                    ...action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("8x0Vs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$372a5de382f28a6a$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $9Crp2 = parcelRequire("9Crp2");
    var $l8kvJ = parcelRequire("l8kvJ");
    var $372a5de382f28a6a$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        Scenarios: $9Crp2.default,
        Views: $l8kvJ.default
    });
});
parcelRegister("9Crp2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95ce817615cfdf4d$export$2e2bcd8739ae039);
    var $lUlnG = parcelRequire("lUlnG");
    const $95ce817615cfdf4d$var$initialState = {
        isModalDialogOpen: false,
        isProcessingRequest: false
    };
    var $95ce817615cfdf4d$export$2e2bcd8739ae039 = (state = $95ce817615cfdf4d$var$initialState, action)=>{
        switch(action.type){
            case 0, $lUlnG.TOGGLE_SCENARIOS_DIALOG_VISIBILITY:
                return {
                    ...state,
                    isModalDialogOpen: action.payload
                };
            case 0, $lUlnG.INITIATE_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: true
                };
            case 0, $lUlnG.COMPLETE_REQUEST:
                return {
                    ...state,
                    isProcessingRequest: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("l8kvJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9be4e3502771349f$export$2e2bcd8739ae039);
    var $edCT0 = parcelRequire("edCT0");
    const $9be4e3502771349f$var$initialState = {
        renameSaving: false
    };
    function $9be4e3502771349f$export$2e2bcd8739ae039(state = $9be4e3502771349f$var$initialState, action) {
        switch(action.type){
            case 0, $edCT0.SET_RENAME_SAVING:
                return {
                    ...state,
                    renameSaving: action.payload
                };
            default:
                return state;
        }
    }
});
parcelRegister("6PVu3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d727cec07047aa0$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $86Ylv = parcelRequire("86Ylv");
    var $3WjfJ = parcelRequire("3WjfJ");
    var $4d727cec07047aa0$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        TitleBar: $86Ylv.default,
        ViewBar: $3WjfJ.default
    });
});
parcelRegister("86Ylv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f160a2d9c01e257$export$2e2bcd8739ae039);
    var $5AWLh = parcelRequire("5AWLh");
    var $4RiVf = parcelRequire("4RiVf");
    var $5Bcf8 = parcelRequire("5Bcf8");
    var $3O4D4 = parcelRequire("3O4D4");
    var $b6PBL = parcelRequire("b6PBL");
    var $c7QrV = parcelRequire("c7QrV");
    var $6f160a2d9c01e257$export$2e2bcd8739ae039 = (0, $5AWLh.combineReducers)({
        PlanSettings: $5Bcf8.default,
        UpdateJira: $c7QrV.default,
        ShareReport: $3O4D4.default,
        HiddenIssues: $4RiVf.default,
        ToolBar: $b6PBL.default
    });
});
parcelRegister("4RiVf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa62b42ccf52f87b$export$2e2bcd8739ae039);
    const $fa62b42ccf52f87b$var$initialState = {
        isDialogOpen: false
    };
    var $fa62b42ccf52f87b$export$2e2bcd8739ae039 = (state = $fa62b42ccf52f87b$var$initialState, action)=>{
        switch(action.type){
            case 0, $0477a90a9bc5200c$export$9d631ffde1befd43:
                return {
                    isDialogOpen: true
                };
            case 0, $0477a90a9bc5200c$export$b1f17581bba10917:
                return {
                    isDialogOpen: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("5Bcf8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8731087be2732888$export$2e2bcd8739ae039);
    var $5pKo7 = parcelRequire("5pKo7");
    const $8731087be2732888$var$initialState = {
        planTitle: 'This is a fake plan title',
        planId: 11,
        deleteDialogOpen: false,
        deleteButtonEnabled: true,
        redirectFrom: null
    };
    var $8731087be2732888$export$2e2bcd8739ae039 = (state = $8731087be2732888$var$initialState, action)=>{
        switch(action.type){
            case 0, $5pKo7.SET_DELETE_DIALOG_VISIBILITY:
                return {
                    ...state,
                    deleteDialogOpen: action.payload
                };
            case 0, $5pKo7.REDIRECT_TO_SETTINGS:
                return {
                    ...state,
                    redirectFrom: action.payload
                };
            case 0, $5pKo7.ENABLE_DELETE:
                return {
                    ...state,
                    deleteButtonEnabled: true
                };
            case 0, $5pKo7.DISABLE_DELETE:
                return {
                    ...state,
                    deleteButtonEnabled: false
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("3O4D4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$062494a1fd6d83b4$export$2e2bcd8739ae039);
    var $TTKUQ = parcelRequire("TTKUQ");
    var $1lSJI = parcelRequire("1lSJI");
    const $062494a1fd6d83b4$var$initialState = {
        isDialogOpen: false,
        isLoading: false,
        url: '',
        shareAs: (0, $TTKUQ.SHARE_AS).LINK
    };
    var $062494a1fd6d83b4$export$2e2bcd8739ae039 = (state = $062494a1fd6d83b4$var$initialState, action)=>{
        switch(action.type){
            case 0, $1lSJI.OPEN_SHARE_REPORT_DIALOG:
                return {
                    ...state,
                    isDialogOpen: true
                };
            case 0, $1lSJI.CLOSE_SHARE_REPORT_DIALOG:
                return {
                    ...state,
                    isDialogOpen: false
                };
            case 0, $1lSJI.LOADING_SHARE_REPORT_URL:
                return {
                    ...state,
                    isLoading: action.payload.isLoading
                };
            case 0, $1lSJI.UPDATE_SHARE_REPORT_URL:
                return {
                    ...state,
                    url: action.payload.url
                };
            case 0, $1lSJI.UPDATE_SHARE_AS:
                return {
                    ...state,
                    shareAs: action.payload.shareAs
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("b6PBL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e3c75587a11e54e$export$2e2bcd8739ae039);
    var $aoVGF = parcelRequire("aoVGF");
    const $6e3c75587a11e54e$var$initialState = {
        showToolBar: true
    };
    var $6e3c75587a11e54e$export$2e2bcd8739ae039 = (state = $6e3c75587a11e54e$var$initialState, action)=>{
        switch(action.type){
            case 0, $aoVGF.TOGGLE_TOOLBAR:
                return {
                    ...state,
                    showToolBar: !state.showToolBar
                };
            default:
                {
                    const _exhaustiveCheck = action.type;
                    return state;
                }
        }
    };
});
parcelRegister("c7QrV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7de8926666135324$export$2e2bcd8739ae039);
    var $cTYeP;
    var $8EB5I;
    var $bCilb;
    var $jVZZA;
    var $4Rr1a;
    var $ik0Qc;
    var $7p8Aa;
    var $iNyXb = parcelRequire("iNyXb");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $aHSC5 = parcelRequire("aHSC5");
    var $ccIrM = parcelRequire("ccIrM");
    const $7de8926666135324$export$d4c72bab9d6cc13a = {
        isDialogOpen: false,
        expandedChanges: {
            [(0, $TTKUQ.ENTITY).ISSUE]: [],
            [(0, $TTKUQ.ENTITY).RELEASE]: [],
            [(0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE]: [],
            [(0, $TTKUQ.ENTITY).TEAM]: [],
            [(0, $TTKUQ.ENTITY).RESOURCE]: [],
            [(0, $TTKUQ.ENTITY).SPRINT]: [],
            [(0, $TTKUQ.ENTITY).PLANNED_CAPACITY]: [],
            [(0, $TTKUQ.ENTITY).NONE]: []
        },
        isCommitWarningFlagClosed: true,
        selectedChanges: {
            [(0, $TTKUQ.ENTITY).ISSUE]: [],
            [(0, $TTKUQ.ENTITY).RELEASE]: [],
            [(0, $TTKUQ.ENTITY).CROSS_PROJECT_RELEASE]: [],
            [(0, $TTKUQ.ENTITY).TEAM]: [],
            [(0, $TTKUQ.ENTITY).RESOURCE]: [],
            [(0, $TTKUQ.ENTITY).SPRINT]: [],
            [(0, $TTKUQ.ENTITY).PLANNED_CAPACITY]: [],
            [(0, $TTKUQ.ENTITY).NONE]: []
        },
        filters: {
            [(0, $ccIrM.USER_FILTER_ID)]: {
                id: (0, $ccIrM.USER_FILTER_ID),
                value: []
            }
        },
        sortBy: 'lastModified',
        sortDirection: 'ASC',
        shouldNotifyWatchers: true,
        quickSelectOption: (0, $ccIrM.QuickSelectOption).MINE
    };
    const $7de8926666135324$var$addId = (id)=>(ids)=>{
            const result = new Set(ids);
            result.add(id);
            return Array.from(result);
        };
    var $7de8926666135324$export$2e2bcd8739ae039 = (state = $7de8926666135324$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, $aHSC5.OPEN_UPDATE_JIRA_DIALOG:
                return {
                    ...state,
                    isDialogOpen: true,
                    isCommitWarningFlagClosed: true
                };
            case 0, $aHSC5.CLOSE_UPDATE_JIRA_DIALOG:
                return {
                    ...state,
                    isDialogOpen: false
                };
            case 0, $aHSC5.EXPAND_UPDATE_JIRA_DIALOG_CHANGE:
                {
                    const { id: id, category: category } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        expandedChanges: {
                            [category]: $7de8926666135324$var$addId(id)
                        }
                    }, state);
                }
            case 0, $aHSC5.COLLAPSE_UPDATE_JIRA_DIALOG_CHANGE:
                {
                    const { id: id, category: category } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        expandedChanges: {
                            [category]: (0, parcelRequire("7p8Aa")).default((0, parcelRequire("8EB5I")).default(id))
                        }
                    }, state);
                }
            case 0, $aHSC5.CLOSE_COMMIT_WARNING_FLAG:
            case 0, $iNyXb.START:
                return {
                    ...state,
                    isCommitWarningFlagClosed: true
                };
            case 0, $iNyXb.STOP:
                return {
                    ...state,
                    isCommitWarningFlagClosed: false
                };
            case 0, $aHSC5.SELECT_CHANGE:
                {
                    const { id: id, category: category } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        selectedChanges: {
                            [category]: $7de8926666135324$var$addId(id)
                        }
                    }, state);
                }
            case 0, $aHSC5.SELECT_ALL_CHANGES:
                return {
                    ...state,
                    selectedChanges: (0, parcelRequire("ik0Qc")).default(state.selectedChanges, {
                        ...action.payload
                    })
                };
            case 0, $aHSC5.DESELECT_CHANGE:
                {
                    const { id: id, category: category } = action.payload;
                    return (0, parcelRequire("bCilb")).default({
                        selectedChanges: {
                            [category]: (0, parcelRequire("7p8Aa")).default((0, parcelRequire("8EB5I")).default(id))
                        }
                    }, state);
                }
            case 0, $aHSC5.DESELECT_ALL_CHANGES:
                return {
                    ...state,
                    selectedChanges: {
                        ...$7de8926666135324$export$d4c72bab9d6cc13a.selectedChanges
                    }
                };
            case 0, $aHSC5.REPLACE_SELECTED_CHANGES:
                return {
                    ...state,
                    selectedChanges: {
                        ...$7de8926666135324$export$d4c72bab9d6cc13a.selectedChanges,
                        ...action.payload
                    }
                };
            case 0, $aHSC5.SORT_CHANGES:
                {
                    const { sortBy: sortBy, sortDirection: sortDirection } = action.payload;
                    return {
                        ...state,
                        sortBy: sortBy,
                        sortDirection: sortDirection
                    };
                }
            case 0, $aHSC5.CHANGE_FILTER:
                {
                    const { id: id, value: value, visibleIssueIds: visibleIssueIds } = action.payload;
                    const isVisible = (el)=>(0, parcelRequire("cTYeP")).default(el, visibleIssueIds);
                    const result = visibleIssueIds.length ? (0, parcelRequire("4Rr1a")).default((0, parcelRequire("jVZZA")).default(isVisible), state.selectedChanges) : state.selectedChanges;
                    return {
                        ...state,
                        filters: (0, parcelRequire("ik0Qc")).default(state.filters, {
                            [id]: {
                                id: id,
                                value: value
                            }
                        }),
                        selectedChanges: (0, parcelRequire("ik0Qc")).default(state.selectedChanges, result)
                    };
                }
            case 0, $aHSC5.CLEAR_FILTER:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        filters: {
                            ...state.filters,
                            [id]: {
                                ...$7de8926666135324$export$d4c72bab9d6cc13a.filters[id]
                            }
                        }
                    };
                }
            case 0, $aHSC5.UPDATE_NOTIFICATION_PREFERENCE:
                {
                    const { shouldNotifyWatchers: shouldNotifyWatchers } = action.payload;
                    return {
                        ...state,
                        shouldNotifyWatchers: shouldNotifyWatchers ?? true
                    };
                }
            case 0, $aHSC5.CHANGE_QUICK_SELECT:
                return {
                    ...state,
                    quickSelectOption: action.payload
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("3WjfJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebb86c5b77533bca$export$2e2bcd8739ae039);
    var $d89qs;
    var $8EB5I;
    var $bCilb;
    var $jVZZA;
    var $c5JsS = parcelRequire("c5JsS");
    const $ebb86c5b77533bca$var$initialState = {
        errors: [],
        saveViewAsDialogStatus: 'CLOSED'
    };
    function $ebb86c5b77533bca$export$2e2bcd8739ae039(state = $ebb86c5b77533bca$var$initialState, action) {
        switch(action.type){
            case 0, $c5JsS.ADD_ERROR:
                return (0, parcelRequire("bCilb")).default({
                    errors: (0, parcelRequire("d89qs")).default(action.payload)
                })(state);
            case 0, $c5JsS.REMOVE_ERROR:
                return (0, parcelRequire("bCilb")).default({
                    errors: (0, parcelRequire("jVZZA")).default((err)=>!(0, parcelRequire("8EB5I")).default(err, action.payload))
                })(state);
            case 0, $c5JsS.SET_SAVE_VIEW_AS_DIALOG_STATUS:
                return {
                    ...state,
                    saveViewAsDialogStatus: action.payload
                };
            default:
                return state;
        }
    }
});
parcelRegister("cyd8j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a858bf1fa7475be$export$2e2bcd8739ae039);
    var $bC2fB;
    var $eS9xr = parcelRequire("eS9xr");
    var $bkasS = parcelRequire("bkasS");
    var $aEqRm = parcelRequire("aEqRm");
    var $kllqP = parcelRequire("kllqP");
    var $d1qvx = parcelRequire("d1qvx");
    const $7a858bf1fa7475be$var$mapDispatchToProps = (dispatch)=>({
            updateIssue: (payload)=>{
                dispatch((0, $bkasS.updateIssueOrInlineCreate)(payload));
            },
            rankIssue: (payload)=>{
                dispatch((0, $bkasS.rankIssue)(payload));
            },
            bulkUpdateIssues: (payload)=>{
                dispatch((0, $bkasS.bulkIssuesUpdate)(payload));
            },
            addIssue: (payload)=>{
                dispatch((0, $bkasS.addIssue)(payload));
            },
            addIssueLink: (payload)=>{
                dispatch((0, $eS9xr.addIssueLink)(payload));
            },
            removeIssueLink: (payload)=>{
                dispatch((0, $eS9xr.deleteIssueLink)(payload));
            },
            updatePlannedCapacity: (payload)=>{
                dispatch((0, $aEqRm.update)(payload));
            },
            removePlannedCapacity: (payload)=>{
                dispatch((0, $aEqRm.remove)(payload));
            },
            updateIssueDatesOptimistic: (payload)=>{
                dispatch((0, $bkasS.updateIssueDatesOptimistic)(payload));
            }
        });
    const $7a858bf1fa7475be$var$mapStateToProps = (state)=>({
            issueTypesById: (0, $kllqP.getIssueTypesById)(state)
        });
    const $7a858bf1fa7475be$var$BridgeEventSubscriber = (0, (0, parcelRequire("bC2fB")).connect)($7a858bf1fa7475be$var$mapStateToProps, $7a858bf1fa7475be$var$mapDispatchToProps)((0, $d1qvx.default));
    var $7a858bf1fa7475be$export$2e2bcd8739ae039 = $7a858bf1fa7475be$var$BridgeEventSubscriber;
});
parcelRegister("d1qvx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2a822602f815971$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aEBy1;
    var $dQ7M4;
    const $e2a822602f815971$var$BridgeEventSubscriberView = ({ updateIssue: updateIssue, rankIssue: rankIssue, bulkUpdateIssues: bulkUpdateIssues, addIssue: addIssue, addIssueLink: addIssueLink, removeIssueLink: removeIssueLink, updatePlannedCapacity: updatePlannedCapacity, removePlannedCapacity: removePlannedCapacity, issueTypesById: issueTypesById, updateIssueDatesOptimistic: updateIssueDatesOptimistic })=>{
        const createPayload = (event)=>({
                ...event.payload,
                promise: {
                    resolve: event.resolve,
                    reject: event.reject
                }
            });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("aEBy1")).default).subscribe((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).UPDATE_ISSUE, async (event)=>{
                updateIssue(createPayload(event));
            });
            (0, (0, parcelRequire("aEBy1")).default).subscribe((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).RANK_ISSUE, async (event)=>{
                rankIssue(createPayload(event));
            });
            (0, (0, parcelRequire("aEBy1")).default).subscribe((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).UPDATE_ISSUES, async (event)=>{
                bulkUpdateIssues(createPayload(event));
            });
            (0, (0, parcelRequire("aEBy1")).default).subscribe((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).ADD_ISSUE, async (event)=>{
                const newIssue = event.payload;
                if (newIssue.level === undefined) {
                    const issueType = issueTypesById[Number(newIssue.type)];
                    if (issueType) newIssue.level = issueType.level;
                }
                addIssue(createPayload({
                    ...event,
                    payload: {
                        issue: newIssue,
                        skipRanking: true
                    }
                }));
            });
            (0, (0, parcelRequire("aEBy1")).default).subscribe((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).ADD_ISSUE_LINK, async (event)=>{
                addIssueLink(createPayload(event));
            });
            (0, (0, parcelRequire("aEBy1")).default).subscribe((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).REMOVE_ISSUE_LINK, async (event)=>{
                removeIssueLink(createPayload(event));
            });
            (0, (0, parcelRequire("aEBy1")).default).subscribe((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).UPDATE_PLANNED_CAPACITY, async (event)=>{
                updatePlannedCapacity(createPayload(event));
            });
            (0, (0, parcelRequire("aEBy1")).default).subscribe((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).REMOVE_PLANNED_CAPACITY, async (event)=>{
                removePlannedCapacity(createPayload(event));
            });
            (0, (0, parcelRequire("aEBy1")).default).subscribe((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).UPDATE_ISSUE_DATES_OPTIMISTIC, async (event)=>{
                updateIssueDatesOptimistic(createPayload(event));
            });
            (0, (0, parcelRequire("aEBy1")).default).ready();
        }, [
            updateIssue,
            rankIssue,
            bulkUpdateIssues,
            addIssue,
            addIssueLink,
            removeIssueLink,
            removePlannedCapacity,
            updatePlannedCapacity,
            issueTypesById,
            updateIssueDatesOptimistic
        ]);
        return null;
    };
    var $e2a822602f815971$export$2e2bcd8739ae039 = $e2a822602f815971$var$BridgeEventSubscriberView;
});
parcelRegister("aEBy1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a7b0d4cb34fce52$export$2e2bcd8739ae039);
    var $dQ7M4;
    class $7a7b0d4cb34fce52$var$PlanBridge {
        constructor(){
            this.isReady = false;
            this.eventBus = [];
            this.eventHandlers = {};
            this.dispatchBridgeEvent = (eventType, payload)=>{
                const promise = new Promise((resolve, reject)=>{
                    this.eventBus.push({
                        type: eventType,
                        payload: payload,
                        resolve: resolve,
                        reject: reject
                    });
                    if (this.isReady) this.executeEvents();
                });
                return promise;
            };
            this.subscribe = (eventType, handler)=>{
                this.eventHandlers[eventType] = handler;
            };
            this.unsubscribe = (eventType)=>{
                delete this.eventHandlers[eventType];
            };
            this.executeEvents = ()=>{
                const lastEvent = this.eventBus.pop();
                if (lastEvent && this.eventHandlers[lastEvent.type]) try {
                    this.eventHandlers[lastEvent.type](lastEvent);
                } catch (e) {
                    lastEvent.reject(e);
                }
                if (this.eventBus.length) this.executeEvents();
            };
            this.ready = ()=>{
                this.isReady = true;
                this.executeEvents();
            };
            this.actions = {
                addIssue: (payload)=>this.dispatchBridgeEvent((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).ADD_ISSUE, payload),
                updateIssue: (payload)=>this.dispatchBridgeEvent((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).UPDATE_ISSUE, payload),
                rankIssue: (payload)=>this.dispatchBridgeEvent((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).RANK_ISSUE, payload),
                bulkUpdateIssues: (payload)=>this.dispatchBridgeEvent((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).UPDATE_ISSUES, payload),
                addIssueLink: (payload)=>this.dispatchBridgeEvent((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).ADD_ISSUE_LINK, payload),
                removeIssueLink: (payload)=>this.dispatchBridgeEvent((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).REMOVE_ISSUE_LINK, payload),
                updatePlannedCapacity: (payload)=>this.dispatchBridgeEvent((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).UPDATE_PLANNED_CAPACITY, payload),
                removePlannedCapacity: (payload)=>this.dispatchBridgeEvent((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).REMOVE_PLANNED_CAPACITY, payload),
                updateIssueDatesOptimistic: (payload)=>this.dispatchBridgeEvent((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).UPDATE_ISSUE_DATES_OPTIMISTIC, payload),
                reviewChanges: ()=>this.dispatchBridgeEvent((0, (0, parcelRequire("dQ7M4")).BridgeEventValue).REVIEW_CHANGES, {})
            };
        }
    }
    const $7a7b0d4cb34fce52$var$planBridge = new $7a7b0d4cb34fce52$var$PlanBridge();
    var $7a7b0d4cb34fce52$export$2e2bcd8739ae039 = $7a7b0d4cb34fce52$var$planBridge;
});
parcelRegister("dQ7M4", function(module, exports) {
    $parcel$export(module.exports, "BridgeEventValue", ()=>$b616e4cd80493d9e$export$5e85930ccc594abf);
    const $b616e4cd80493d9e$export$5e85930ccc594abf = {
        ADD_ISSUE: 0,
        UPDATE_ISSUE: 1,
        UPDATE_ISSUES: 2,
        ADD_ISSUE_LINK: 3,
        REMOVE_ISSUE_LINK: 4,
        RANK_ISSUE: 5,
        UPDATE_PLANNED_CAPACITY: 6,
        REMOVE_PLANNED_CAPACITY: 7,
        REVIEW_CHANGES: 8,
        UPDATE_ISSUE_DATES_OPTIMISTIC: 9
    };
});
parcelRegister("agFkl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbf63cf308e1cdf2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g0Gtc;
    var $fGD72;
    var $jcw0u;
    var $4R6GH;
    var $hvOzF = parcelRequire("hvOzF");
    var $TTKUQ = parcelRequire("TTKUQ");
    var $bC2fB;
    var $24CMK = parcelRequire("24CMK");
    const $fbf63cf308e1cdf2$var$mapDispatchToProps = {
        genericError: $24CMK.genericError
    };
    class $fbf63cf308e1cdf2$var$PortfolioErrorBoundary extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.state = {
                hasError: false,
                error: null
            };
        }
        static getDerivedStateFromError(error) {
            return {
                hasError: true,
                error: error
            };
        }
        componentDidCatch(error) {
            const { message: message, stack: stackTrace } = error;
            if ((0, (0, parcelRequire("4R6GH")).fg)('improve_redux_saga_error_reporting_plans_batch_1')) (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: (0, $hvOzF.toErrorID)(error, message),
                    packageName: (0, $TTKUQ.PACKAGE_NAME),
                    teamName: (0, $TTKUQ.ERROR_REPORTING_TEAM)
                },
                sendToPrivacyUnsafeSplunk: true
            });
            else this.props.genericError({
                message: message,
                stackTrace: stackTrace,
                shouldReportError: false
            });
        }
        render() {
            if (this.state.hasError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0Gtc")).ExperienceFailureTracker), {
                location: "portfolio-3.simple-plans.view-error"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fGD72")).ErrorPage), {
                error: this.state.error
            }));
            return this.props.children;
        }
    }
    var $fbf63cf308e1cdf2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, $fbf63cf308e1cdf2$var$mapDispatchToProps)($fbf63cf308e1cdf2$var$PortfolioErrorBoundary);
});
parcelRegister("fGD72", function(module, exports) {
    $parcel$export(module.exports, "ErrorPage", ()=>$6d74f2bdfa7aa831$export$c120a0e80fd44ca6);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $hTEpF;
    var $tcn7E;
    var $gLj7z;
    var $2ewq8;
    var $4R6GH;
    var $koVbs;
    var $lrWmK = parcelRequire("lrWmK");
    var $hQ2i5;
    const $6d74f2bdfa7aa831$var$reloadPage = ()=>window.location.reload(true);
    const $6d74f2bdfa7aa831$var$contactSupport = ()=>{
        window.location.href = 'https://support.atlassian.com/contact/';
    };
    const $6d74f2bdfa7aa831$export$c120a0e80fd44ca6 = ({ error: error })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const traceId = (0, $5uXOq.useMemo)(()=>{
            const traceContext = (0, (0, parcelRequire("tcn7E")).getActiveTrace)();
            return traceContext?.traceId;
        }, []);
        let description = formatMessage((0, (0, parcelRequire("hQ2i5")).default).description);
        if (error) description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, description), traceId && (0, (0, parcelRequire("4R6GH")).fg)('jfp-trace-id-in-error-boundaries') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gLj7z")).ErrorHashAndTraceId), {
            error: error,
            traceId: traceId
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2ewq8")).ErrorHash), {
            error: error
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            imageUrl: (0, ($parcel$interopDefault($lrWmK))),
            size: "narrow",
            header: formatMessage((0, (0, parcelRequire("hQ2i5")).default).header),
            description: description,
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "primary",
                onClick: $6d74f2bdfa7aa831$var$reloadPage,
                testId: "error-boundary.ui.error-page.primary-action-button"
            }, formatMessage((0, (0, parcelRequire("hQ2i5")).default).reloadPageButton)),
            tertiaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "link",
                onClick: $6d74f2bdfa7aa831$var$contactSupport,
                testId: "error-boundary.ui.error-page.tertiary-action-button"
            }, formatMessage((0, (0, parcelRequire("hQ2i5")).default).contactSupportButton))
        });
    };
});
parcelRegister("gLj7z", function(module, exports) {
    $parcel$export(module.exports, "ErrorHashAndTraceId", ()=>$fe273132a82b30fc$export$61354a7dde2c2d3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $kobfu;
    var $ftF7i;
    const $fe273132a82b30fc$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
        const errorHash = (0, (0, parcelRequire("kobfu")).getErrorHash)(error);
        const source = `Hash ${errorHash}\nTrace ${traceId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            action: "rendered",
            actionSubject: "errorHashAndTraceId",
            attributes: {
                errorHash: errorHash,
                traceId: traceId
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "note"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ftF7i")).CodeBlockWithCopyButton), {
            source: source,
            copyCodeActionSubjectId: "copyErrorHashAndTraceId"
        })));
    };
});
parcelRegister("ftF7i", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockWithCopyButton", ()=>$92e21bbf80c400af$export$ced1fc74d907d387);
    var $5uXOq = parcelRequire("5uXOq");
    var $b8Qxt;
    var $dC5iT;
    var $8CUq3;
    var $lOZGq;
    const $92e21bbf80c400af$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $92e21bbf80c400af$var$wrapperStyles,
            role: "region"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).ActionContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).CopyAction), {
            source: source,
            actionSubjectId: copyCodeActionSubjectId
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b8Qxt")).default), {
            text: source,
            showLineNumbers: false,
            shouldWrapLongLines: false
        })));
    const $92e21bbf80c400af$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        position: 'relative'
    });
});
parcelRegister("b8Qxt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fd53c1f9dbca185$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $e4VnT;
    var $1HkQx;
    var $eCBnN;
    var $9Xp6L;
    const $4fd53c1f9dbca185$var$CodeBlock = (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
        const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
        const theme = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1HkQx")).getCodeBlockTheme)(numLines), [
            numLines
        ]);
        const getStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1HkQx")).getCodeBlockStyles)(theme), [
            theme
        ]);
        const styles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).css)(getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
            highlightedStartText,
            highlightedEndText,
            showLineNumbers,
            shouldWrapLongLines,
            getStyles
        ]);
        const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, (0, parcelRequire("e4VnT")).useHighlightLines)({
            highlight: highlight,
            testId: testId
        });
        const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
            getHighlightStyles,
            highlightedLines
        ]);
        const language = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("eCBnN")).normalizeLanguage)(providedLanguage), [
            providedLanguage
        ]);
        const languageToUse = text ? language : 'text';
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Xp6L")).default), {
            "data-code-lang": language,
            "data-ds--code--code-block": "",
            testId: testId,
            language: languageToUse,
            css: styles,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber,
            lineProps: getLineProps,
            shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
            shouldWrapLongLines: shouldWrapLongLines,
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
            text: text
        });
    });
    $4fd53c1f9dbca185$var$CodeBlock.displayName = 'CodeBlock';
    var $4fd53c1f9dbca185$export$2e2bcd8739ae039 = $4fd53c1f9dbca185$var$CodeBlock;
});
parcelRegister("e4VnT", function(module, exports) {
    $parcel$export(module.exports, "useHighlightLines", ()=>$a32b74c088f4b53f$export$84415a200bdf33ed);
    var $5uXOq = parcelRequire("5uXOq");
    const $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ = {
        'data-ds--code--row': ''
    };
    const $a32b74c088f4b53f$var$getLineStyleObject = (lineNumber, testId)=>{
        return testId ? {
            'data-testid': `${testId}-line-${lineNumber}`,
            ...$a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ
        } : $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ;
    };
    const $a32b74c088f4b53f$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
        const highlightedLines = (0, $5uXOq.useMemo)(()=>{
            if (!highlight) return [];
            return highlight.split(',').map((num)=>{
                if (num.indexOf('-') > 0) {
                    const [from, to] = num.split('-').map(Number).sort((a, b)=>a - b);
                    return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
                }
                return Number(num);
            }).reduce((acc, val)=>acc.concat(val), []) || [];
        }, [
            highlight
        ]);
        const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
            if (!highlight || highlightedLines.length === 0) return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
            if (highlightedLines.includes(lineNumber)) {
                const highlightedDataAttrObj = {
                    'data-ds--code--row--highlight': ''
                };
                return {
                    ...highlightedDataAttrObj,
                    ...$a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId)
                };
            }
            return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
        }, [
            highlight,
            testId
        ]);
        return {
            getHighlightStyles: getHighlightStyles,
            highlightedLines: highlightedLines
        };
    };
});
parcelRegister("1HkQx", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$a9c1aabaca189fa1$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$a9c1aabaca189fa1$export$57a2d4b573afd64a);
    var $lBXbx;
    var $8CJbG;
    const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("lBXbx")).SPACING),
            marginRight: (0, (0, parcelRequire("lBXbx")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $a9c1aabaca189fa1$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("lBXbx")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("lBXbx")).SPACING}px 0` : (0, (0, parcelRequire("lBXbx")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("lBXbx")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme),
                ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("lBXbx")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("lBXbx")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("8CJbG")).getBaseTheme)();
        const baseStyles = $a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("8CJbG")).getBaseTheme)(),
            ...(0, (0, parcelRequire("8CJbG")).getColorPalette)(),
            lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("lBXbx", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$6ec31795911692d1$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$6ec31795911692d1$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$6ec31795911692d1$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$6ec31795911692d1$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$6ec31795911692d1$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$6ec31795911692d1$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$6ec31795911692d1$export$1758fda69688282e);
    var $k5uoT;
    const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
    const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
    const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
    const $6ec31795911692d1$export$82ea42e772d49e5b = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
    const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
    const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("8CJbG", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$eac5fe855702cfc1$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$eac5fe855702cfc1$export$fe2a6478976e8b17);
    var $8QpSo;
    var $kTHGn;
    const $eac5fe855702cfc1$var$T800 = '#067384';
    const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
    const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("kTHGn")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
        });
    const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
        };
    });
    const $eac5fe855702cfc1$var$getTheme = ()=>({
            ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
            ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
        });
    var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;
});
parcelRegister("eCBnN", function(module, exports) {
    $parcel$export(module.exports, "normalizeLanguage", ()=>$d00516a0f8207944$export$f38728011c178796);
    var $8QpSo;
    var $8Y2ZY;
    const $d00516a0f8207944$export$f38728011c178796 = (0, (0, parcelRequire("8QpSo")).default)((language)=>{
        if (!language) return '';
        const match = (0, (0, parcelRequire("8Y2ZY")).SUPPORTED_LANGUAGES).find((val)=>{
            return val.name === language || val.alias.includes(language);
        });
        return match ? match.value : 'text';
    });
});
parcelRegister("8Y2ZY", function(module, exports) {
    $parcel$export(module.exports, "SUPPORTED_LANGUAGES", ()=>$012a854d92762508$export$7c77c3a9bb93870d);
    const $012a854d92762508$export$7c77c3a9bb93870d = [
        {
            name: 'PHP',
            alias: [
                'php',
                'php3',
                'php4',
                'php5'
            ],
            value: 'php'
        },
        {
            name: 'Java',
            alias: [
                'java'
            ],
            value: 'java'
        },
        {
            name: 'CSharp',
            alias: [
                'csharp',
                'c#'
            ],
            value: 'cs'
        },
        {
            name: 'Python',
            alias: [
                'python',
                'py'
            ],
            value: 'python'
        },
        {
            name: 'JavaScript',
            alias: [
                'javascript',
                'js'
            ],
            value: 'javascript'
        },
        {
            name: 'Html',
            alias: [
                'html'
            ],
            value: 'xml'
        },
        {
            name: 'C++',
            alias: [
                'c++',
                'cpp',
                'clike'
            ],
            value: 'cpp'
        },
        {
            name: 'Ruby',
            alias: [
                'ruby',
                'rb',
                'duby'
            ],
            value: 'ruby'
        },
        {
            name: 'Objective-C',
            alias: [
                'objective-c',
                'objectivec',
                'obj-c',
                'objc'
            ],
            value: 'objectivec'
        },
        {
            name: 'C',
            alias: [
                'c'
            ],
            value: 'cpp'
        },
        {
            name: 'Swift',
            alias: [
                'swift'
            ],
            value: 'swift'
        },
        {
            name: 'TeX',
            alias: [
                'tex',
                'latex'
            ],
            value: 'tex'
        },
        {
            name: 'Shell',
            alias: [
                'shell',
                'bash',
                'sh',
                'ksh',
                'zsh'
            ],
            value: 'shell'
        },
        {
            name: 'Scala',
            alias: [
                'scala'
            ],
            value: 'scala'
        },
        {
            name: 'Go',
            alias: [
                'go'
            ],
            value: 'go'
        },
        {
            name: 'ActionScript',
            alias: [
                'actionscript',
                'actionscript3',
                'as'
            ],
            value: 'actionscript'
        },
        {
            name: 'ColdFusion',
            alias: [
                'coldfusion'
            ],
            value: 'xml'
        },
        {
            name: 'JavaFX',
            alias: [
                'javafx',
                'jfx'
            ],
            value: 'java'
        },
        {
            name: 'VbNet',
            alias: [
                'vbnet',
                'vb.net',
                'vfp',
                'clipper',
                'xbase'
            ],
            value: 'vbnet'
        },
        {
            name: 'JSON',
            alias: [
                'json'
            ],
            value: 'json'
        },
        {
            name: 'MATLAB',
            alias: [
                'matlab'
            ],
            value: 'matlab'
        },
        {
            name: 'Groovy',
            alias: [
                'groovy'
            ],
            value: 'groovy'
        },
        {
            name: 'SQL',
            alias: [
                'sql',
                'postgresql',
                'postgres',
                'plpgsql',
                'psql',
                'postgresql-console',
                'postgres-console',
                'tsql',
                't-sql',
                'mysql',
                'sqlite'
            ],
            value: 'sql'
        },
        {
            name: 'R',
            alias: [
                'r'
            ],
            value: 'r'
        },
        {
            name: 'Perl',
            alias: [
                'perl',
                'pl'
            ],
            value: 'perl'
        },
        {
            name: 'Lua',
            alias: [
                'lua'
            ],
            value: 'lua'
        },
        {
            name: 'Pascal',
            alias: [
                'pas',
                'pascal',
                'objectpascal',
                'delphi'
            ],
            value: 'pascal'
        },
        {
            name: 'XML',
            alias: [
                'xml'
            ],
            value: 'xml'
        },
        {
            name: 'TypeScript',
            alias: [
                'typescript',
                'ts'
            ],
            value: 'typescript'
        },
        {
            name: 'CoffeeScript',
            alias: [
                'coffeescript',
                'coffee-script',
                'coffee'
            ],
            value: 'coffeescript'
        },
        {
            name: 'Haskell',
            alias: [
                'haskell',
                'hs'
            ],
            value: 'haskell'
        },
        {
            name: 'Puppet',
            alias: [
                'puppet'
            ],
            value: 'puppet'
        },
        {
            name: 'Arduino',
            alias: [
                'arduino'
            ],
            value: 'arduino'
        },
        {
            name: 'Fortran',
            alias: [
                'fortran'
            ],
            value: 'fortran'
        },
        {
            name: 'Erlang',
            alias: [
                'erlang',
                'erl'
            ],
            value: 'erlang'
        },
        {
            name: 'PowerShell',
            alias: [
                'powershell',
                'posh',
                'ps1',
                'psm1'
            ],
            value: 'powershell'
        },
        {
            name: 'Haxe',
            alias: [
                'haxe',
                'hx',
                'hxsl'
            ],
            value: 'haxe'
        },
        {
            name: 'Elixir',
            alias: [
                'elixir',
                'ex',
                'exs'
            ],
            value: 'elixir'
        },
        {
            name: 'Verilog',
            alias: [
                'verilog',
                'v'
            ],
            value: 'verilog'
        },
        {
            name: 'Rust',
            alias: [
                'rust'
            ],
            value: 'rust'
        },
        {
            name: 'VHDL',
            alias: [
                'vhdl'
            ],
            value: 'vhdl'
        },
        {
            name: 'Sass',
            alias: [
                'sass'
            ],
            value: 'less'
        },
        {
            name: 'OCaml',
            alias: [
                'ocaml'
            ],
            value: 'ocaml'
        },
        {
            name: 'Dart',
            alias: [
                'dart'
            ],
            value: 'dart'
        },
        {
            name: 'CSS',
            alias: [
                'css'
            ],
            value: 'css'
        },
        {
            name: 'reStructuredText',
            alias: [
                'restructuredtext',
                'rst',
                'rest'
            ],
            value: 'rest'
        },
        {
            name: 'Kotlin',
            alias: [
                'kotlin'
            ],
            value: 'kotlin'
        },
        {
            name: 'D',
            alias: [
                'd'
            ],
            value: 'd'
        },
        {
            name: 'Octave',
            alias: [
                'octave'
            ],
            value: 'matlab'
        },
        {
            name: 'QML',
            alias: [
                'qbs',
                'qml'
            ],
            value: 'qml'
        },
        {
            name: 'Prolog',
            alias: [
                'prolog'
            ],
            value: 'prolog'
        },
        {
            name: 'FoxPro',
            alias: [
                'foxpro',
                'purebasic'
            ],
            value: 'purebasic'
        },
        {
            name: 'Scheme',
            alias: [
                'scheme',
                'scm'
            ],
            value: 'scheme'
        },
        {
            name: 'CUDA',
            alias: [
                'cuda',
                'cu'
            ],
            value: 'cpp'
        },
        {
            name: 'Julia',
            alias: [
                'julia',
                'jl'
            ],
            value: 'julia'
        },
        {
            name: 'Racket',
            alias: [
                'racket',
                'rkt'
            ],
            value: 'lisp'
        },
        {
            name: 'Ada',
            alias: [
                'ada',
                'ada95',
                'ada2005'
            ],
            value: 'ada'
        },
        {
            name: 'Tcl',
            alias: [
                'tcl'
            ],
            value: 'tcl'
        },
        {
            name: 'Mathematica',
            alias: [
                'mathematica',
                'mma',
                'nb'
            ],
            value: 'mathematica'
        },
        {
            name: 'Autoit',
            alias: [
                'autoit'
            ],
            value: 'autoit'
        },
        {
            name: 'StandardML',
            alias: [
                'standardmL',
                'sml',
                'standardml'
            ],
            value: 'sml'
        },
        {
            name: 'Objective-J',
            alias: [
                'objective-j',
                'objectivej',
                'obj-j',
                'objj'
            ],
            value: 'objectivec'
        },
        {
            name: 'Smalltalk',
            alias: [
                'smalltalk',
                'squeak',
                'st'
            ],
            value: 'smalltalk'
        },
        {
            name: 'Vala',
            alias: [
                'vala',
                'vapi'
            ],
            value: 'vala'
        },
        {
            name: 'ABAP',
            alias: [
                'abap'
            ],
            value: 'sql'
        },
        {
            name: 'LiveScript',
            alias: [
                'livescript',
                'live-script'
            ],
            value: 'livescript'
        },
        {
            name: 'XQuery',
            alias: [
                'xquery',
                'xqy',
                'xq',
                'xql',
                'xqm'
            ],
            value: 'xquery'
        },
        {
            name: 'PlainText',
            alias: [
                'text',
                'plaintext'
            ],
            value: 'text'
        },
        {
            name: 'Yaml',
            alias: [
                'yaml',
                'yml'
            ],
            value: 'yaml'
        },
        {
            name: 'GraphQL',
            alias: [
                'graphql'
            ],
            value: 'graphql'
        },
        {
            name: 'AppleScript',
            alias: [
                'applescript'
            ],
            value: 'applescript'
        },
        {
            name: 'Clojure',
            alias: [
                'clojure'
            ],
            value: 'clojure'
        },
        {
            name: 'Diff',
            alias: [
                'diff'
            ],
            value: 'diff'
        },
        {
            name: 'VisualBasic',
            alias: [
                'visualbasic'
            ],
            value: 'visual-basic'
        },
        {
            name: 'JSX',
            alias: [
                'jsx'
            ],
            value: 'jsx'
        },
        {
            name: 'TSX',
            alias: [
                'tsx'
            ],
            value: 'tsx'
        },
        {
            name: 'SplunkSPL',
            alias: [
                'splunk-spl'
            ],
            value: 'splunk-spl'
        },
        {
            name: 'Dockerfile',
            alias: [
                'docker',
                'dockerfile'
            ],
            value: 'dockerfile'
        },
        {
            name: 'HCL',
            alias: [
                'hcl',
                'terraform'
            ],
            value: 'hcl'
        },
        {
            name: 'NGINX',
            alias: [
                'nginx'
            ],
            value: 'nginx'
        },
        {
            name: 'Protocol Buffers',
            alias: [
                'protobuf',
                'proto'
            ],
            value: 'protobuf'
        }
    ];
});
parcelRegister("9Xp6L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e296c4d390ff4a21$export$2e2bcd8739ae039);
    var $c8FD2;
    var $e296c4d390ff4a21$export$2e2bcd8739ae039 = (0, (0, parcelRequire("c8FD2")).default);
});
parcelRegister("c8FD2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64df4f4e00539958$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lp89O;
    const $64df4f4e00539958$var$generator = (options)=>{
        const { loader: loader } = options;
        class AsyncHighlighter extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            static{
                this.astGenerator = null;
            }
            static{
                this.highlightInstance = (0, (0, parcelRequire("lp89O")).default);
            }
            static preload() {
                return AsyncHighlighter.loadAstGenerator();
            }
            static loadAstGenerator() {
                AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                    AsyncHighlighter.astGenerator = astGenerator;
                    return astGenerator;
                });
                return AsyncHighlighter.astGeneratorPromise;
            }
            componentDidMount() {
                if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
                if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                    this.forceUpdate();
                });
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                    ...this.props,
                    astGenerator: AsyncHighlighter.astGenerator
                });
            }
        }
        return AsyncHighlighter;
    };
    const $64df4f4e00539958$var$asyncGenerator = $64df4f4e00539958$var$generator({
        loader: ()=>(parcelRequire("kN6qz")).then((module)=>{
                return module.default || module;
            })
    });
    var $64df4f4e00539958$export$2e2bcd8739ae039 = $64df4f4e00539958$var$asyncGenerator;
});
parcelRegister("lp89O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a813ccd1d5fae376$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iQkqt;
    var $jVB7m;
    const $a813ccd1d5fae376$var$Highlight = (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
        className: `language-${language}`
    }, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
        const code = text;
        const generatorClassName = 'prismjs';
        const containerProps = {
            ...rest,
            'data-testid': testId,
            className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
        };
        if (shouldWrapLongLines) codeTagProps.style = {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        };
        else codeTagProps.style = {
            whiteSpace: 'pre'
        };
        const codeBidiWarningConfig = {
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
        const rows = (0, (0, parcelRequire("iQkqt")).default)({
            astGenerator: astGenerator,
            code: code,
            language: language,
            shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
            lineProps: lineProps,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber
        });
        return (0, (0, parcelRequire("jVB7m")).default)({
            containerProps: containerProps,
            codeTagProps: codeTagProps,
            rows: rows,
            codeBidiWarningConfig: codeBidiWarningConfig
        });
    });
    var $a813ccd1d5fae376$export$2e2bcd8739ae039 = $a813ccd1d5fae376$var$Highlight;
});
parcelRegister("iQkqt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55dc1424d34091d6$export$2e2bcd8739ae039);
    var $eJUOt;
    var $eTMIA;
    var $8bliZ;
    var $g6MVu;
    const $55dc1424d34091d6$var$newLineRegex = /\n/g;
    function $55dc1424d34091d6$var$getNewLines(str) {
        return str.match($55dc1424d34091d6$var$newLineRegex);
    }
    function $55dc1424d34091d6$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
        const codeTree = (0, (0, parcelRequire("g6MVu")).default)(language, code, astGenerator);
        const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
        const createLine = (0, (0, parcelRequire("eJUOt")).default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
        const newTree = [];
        let lastLineBreakIndex = -1;
        let index = 0;
        const tree = (0, (0, parcelRequire("8bliZ")).default)(codeTree);
        while(index < tree.length){
            const testNode = tree[index];
            if (testNode.type === 'text') {
                index++;
                continue;
            }
            const node = testNode;
            const firstChildNode = node.children[0];
            if (firstChildNode.type === 'text') {
                const { value: value } = firstChildNode;
                const newLines = $55dc1424d34091d6$var$getNewLines(value);
                if (newLines) {
                    const splitValue = value.split('\n');
                    splitValue.forEach((text, i)=>{
                        const lineNumber = newTree.length + startingLineNumber;
                        const newChild = {
                            type: 'text',
                            value: `${text}\n`
                        };
                        if (i === 0) {
                            const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, (0, parcelRequire("eTMIA")).default)({
                                children: [
                                    newChild
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            }));
                            const line = createLine(children, lineNumber);
                            newTree.push(line);
                        } else if (i === splitValue.length - 1) {
                            const nextNode = tree[index + 1];
                            const stringChild = nextNode && nextNode.children && nextNode.children[0];
                            const lastLineInPreviousSpan = {
                                type: 'text',
                                value: `${text}`
                            };
                            if (stringChild) {
                                const newElem = (0, (0, parcelRequire("eTMIA")).default)({
                                    children: [
                                        lastLineInPreviousSpan
                                    ],
                                    className: node.properties.className,
                                    lineNumber: lineNumber
                                });
                                tree.splice(index + 1, 0, newElem);
                            } else {
                                const children = [
                                    lastLineInPreviousSpan
                                ];
                                const line = createLine(children, lineNumber, node.properties.className);
                                newTree.push(line);
                            }
                        } else {
                            const children = [
                                newChild
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    });
                    lastLineBreakIndex = index;
                }
            }
            index++;
        }
        if (lastLineBreakIndex !== tree.length - 1) {
            const children = tree.slice(lastLineBreakIndex + 1, tree.length);
            if (children && children.length) {
                const lineNumber = newTree.length + startingLineNumber;
                const line = createLine(children, lineNumber);
                newTree.push(line);
            }
        }
        if (shouldCreateParentElementForLines) return newTree;
        return newTree.flat(1);
    }
});
parcelRegister("eJUOt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9ccdbf71436a137$export$2e2bcd8739ae039);
    var $eTMIA;
    var $5FOwT;
    function $b9ccdbf71436a137$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
        return (children, lineNumber, className = [])=>{
            if (shouldCreateParentElementForLines || className.length > 0) return (0, (0, parcelRequire("eTMIA")).default)({
                children: children,
                lineNumber: lineNumber,
                showLineNumbers: showLineNumbers,
                lineProps: lineProps,
                className: className
            });
            else {
                if (showLineNumbers && lineNumber) children.unshift((0, (0, parcelRequire("5FOwT")).default)(lineNumber));
                return children;
            }
        };
    }
    var $b9ccdbf71436a137$export$2e2bcd8739ae039 = $b9ccdbf71436a137$var$createLineGenerator;
});
parcelRegister("eTMIA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6df5b208b9d23752$export$2e2bcd8739ae039);
    var $5FOwT;
    function $6df5b208b9d23752$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
        const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
        const properties = {
            ...propsPassedInFromCodeBlock,
            className: className
        };
        let currentChildren = children;
        if (lineNumber && showLineNumbers) {
            if (currentChildren.length === 1) currentChildren = [
                (0, (0, parcelRequire("5FOwT")).default)(lineNumber),
                ...currentChildren
            ];
            else currentChildren = [
                (0, (0, parcelRequire("5FOwT")).default)(lineNumber),
                {
                    type: 'element',
                    tagName: 'span',
                    properties: {
                        className: []
                    },
                    children: currentChildren
                }
            ];
        }
        return {
            type: 'element',
            tagName: 'span',
            properties: properties,
            children: currentChildren
        };
    }
});
parcelRegister("5FOwT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6257c3f70e94feb$export$2e2bcd8739ae039);
    function $c6257c3f70e94feb$export$2e2bcd8739ae039(lineNumber) {
        return {
            type: 'element',
            tagName: 'span',
            properties: {
                key: `line-number--${lineNumber}`,
                className: [
                    'comment',
                    'linenumber',
                    'ds-line-number'
                ],
                'data-ds--line-number': lineNumber
            },
            children: []
        };
    }
});
parcelRegister("8bliZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9f6debfd276481a$export$2e2bcd8739ae039);
    var $eTMIA;
    function $c9f6debfd276481a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
        let newTree = [];
        for(let i = 0; i < tree.length; i++){
            const node = tree[i];
            if (node.type === 'text') newTree.push((0, (0, parcelRequire("eTMIA")).default)({
                children: [
                    node
                ],
                lineNumber: offset,
                className: className
            }));
            else if (node.children) {
                const classNames = className.concat(node.properties.className || []);
                $c9f6debfd276481a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
            }
        }
        return newTree;
    }
});
parcelRegister("g6MVu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8213b6c690eefe35$export$2e2bcd8739ae039);
    function $8213b6c690eefe35$export$2e2bcd8739ae039(language, code, astGenerator) {
        if (language === 'text' || !astGenerator) return [
            {
                type: 'text',
                value: code
            }
        ];
        try {
            return astGenerator.highlight(code, language);
        } catch (e) {
            return [
                {
                    type: 'text',
                    value: code
                }
            ];
        }
    }
});
parcelRegister("jVB7m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98c01cbb865d4c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fBvqm;
    function $b98c01cbb865d4c1$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
        const renderedRows = rows.map((node, i)=>(0, (0, parcelRequire("fBvqm")).default)({
                node: node,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment${i}`
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", containerProps, (0, ($parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
    }
});
parcelRegister("fBvqm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fdda3a2c4411588$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lrHA4;
    var $31cgS;
    var $d3zI6;
    function $2fdda3a2c4411588$var$createClassNameString(classNames) {
        return classNames ? classNames.join(' ') : '';
    }
    function $2fdda3a2c4411588$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
        if (node.type === 'text') {
            const { value: value } = node;
            const textValue = `${value}`;
            if (codeBidiWarningConfig.codeBidiWarnings) {
                const decorated = (0, (0, parcelRequire("31cgS")).default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lrHA4")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningConfig.codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            return textValue;
        } else {
            const { properties: properties, tagName: tagName } = node;
            const childrenCreator = (0, (0, parcelRequire("d3zI6")).default)(codeBidiWarningConfig);
            const props = {
                ...properties,
                className: $2fdda3a2c4411588$var$createClassNameString(properties.className)
            };
            const children = childrenCreator(node.children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(tagName, {
                key: key,
                ...props
            }, children);
        }
    }
});
parcelRegister("lrHA4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e6443bd1dfeaac7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $abxiq;
    function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("abxiq", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$59fdc1b7b0ae96c9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jldZL;
    const $59fdc1b7b0ae96c9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $59fdc1b7b0ae96c9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("31cgS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e16562bd8c2aca9b$export$2e2bcd8739ae039);
    const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
parcelRegister("d3zI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcbc4a00f80b5d8f$export$2e2bcd8739ae039);
    var $fBvqm;
    function $dcbc4a00f80b5d8f$export$2e2bcd8739ae039(codeBidiWarningConfig) {
        let childrenCount = 0;
        return (children)=>{
            childrenCount += 1;
            return children.map((child, i)=>(0, (0, parcelRequire("fBvqm")).default)({
                    node: child,
                    codeBidiWarningConfig: codeBidiWarningConfig,
                    key: `code-segment-${childrenCount}-${i}`
                }));
        };
    }
});
parcelRegister("kN6qz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("as9qs").then(()=>parcelRequire('5zvIl'));
});
parcelRegister("lOZGq", function(module, exports) {
    $parcel$export(module.exports, "CopyAction", ()=>$b3c0013295f8779c$export$958df07cbf9735fc);
    $parcel$export(module.exports, "ActionContainer", ()=>$b3c0013295f8779c$export$37ab3bdebc286ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $ldJSL;
    var $3Fq5M;
    var $dC5iT;
    var $8CUq3;
    var $8zOmE;
    var $fEogx;
    const $b3c0013295f8779c$export$2ce9877c9c1aa16 = {
        PROMPT: 'Copy',
        SUCCESS: 'Copied!',
        FAILURE: 'Copy to clipboard failed'
    };
    const $b3c0013295f8779c$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        const handleSuccess = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.SUCCESS);
        }, [
            setTooltipMessage
        ]);
        const handleError = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.FAILURE);
        }, [
            setTooltipMessage
        ]);
        const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            actionSubjectId && (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
            navigator.clipboard.writeText(source).then(handleSuccess, handleError);
        }, [
            source,
            handleSuccess,
            handleError,
            actionSubjectId
        ]);
        const resetMessage = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        }, [
            setTooltipMessage
        ]);
        function shouldRender() {
            if (typeof document !== 'undefined') return Boolean(navigator?.clipboard?.writeText);
        }
        return shouldRender() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fEogx")).Action), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))),
            label: tooltipMessage,
            onClick: writeToClipboard,
            onMouseOver: resetMessage,
            onFocus: resetMessage,
            "aria-live": "assertive",
            "aria-atomic": "true",
            name: "Copy"
        }) : null;
    };
    const $b3c0013295f8779c$var$stopPropagation = (event)=>event.stopPropagation();
    const $b3c0013295f8779c$export$37ab3bdebc286ca = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b3c0013295f8779c$var$absolutePositionWrapperStyles,
            onMouseDown: $b3c0013295f8779c$var$stopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), {
            label: "actions"
        }, children));
    const $b3c0013295f8779c$var$absolutePositionWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        padding: 'space.050',
        zIndex: 'flag'
    });
});
parcelRegister("fEogx", function(module, exports) {
    $parcel$export(module.exports, "Action", ()=>$e6da05ade6347218$export$e19cd5f9376f8cee);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $3bDjY;
    const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
        const updateTooltip = (0, $5uXOq.useRef)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            updateTooltip.current?.();
        }, [
            tooltipLabel,
            label
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: ({ update: update })=>{
                updateTooltip.current = update;
                return tooltipLabel || label;
            },
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            isLoading: isLoading,
            appearance: "subtle",
            icon: icon,
            label: label,
            spacing: "compact",
            ...buttonProps
        }));
    };
});
parcelRegister("2ewq8", function(module, exports) {
    $parcel$export(module.exports, "ErrorHash", ()=>$c46845a765ccaa31$export$db1607d938d7ca33);
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $kobfu;
    var $ftF7i;
    const $c46845a765ccaa31$export$db1607d938d7ca33 = ({ error: error })=>{
        const errorHash = (0, (0, parcelRequire("kobfu")).getErrorHash)(error);
        const source = `Hash ${errorHash}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            action: "rendered",
            actionSubject: "errorHash",
            attributes: {
                errorHash: errorHash
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "note"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ftF7i")).CodeBlockWithCopyButton), {
            source: source,
            copyCodeActionSubjectId: "copyErrorHash"
        })));
    };
});
parcelRegister("lrWmK", function(module, exports) {
    module.exports = new URL("error-modal.9d4de729.svg", import.meta.url).toString();
});
parcelRegister("hQ2i5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$edfa46ed6fb093dd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $edfa46ed6fb093dd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        description: {
            "id": "error-boundary.page.description",
            "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
        },
        header: {
            "id": "error-boundary.page.header",
            "defaultMessage": "Something's gone wrong"
        },
        reloadPageButton: {
            "id": "error-boundary.page.reload-page-button",
            "defaultMessage": "Reload page"
        },
        contactSupportButton: {
            "id": "error-boundary.page.contact-support-button",
            "defaultMessage": "Contact support"
        }
    });
});
parcelRegister("d5vwV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dbefaba6eaf4e2b6$export$2e2bcd8739ae039);
    var $3YtPS = parcelRequire("3YtPS");
    var $bC2fB;
    var $gQ7rz = parcelRequire("gQ7rz");
    var $eWre9 = parcelRequire("eWre9");
    var $2S1WV = parcelRequire("2S1WV");
    const $dbefaba6eaf4e2b6$var$mapStateToProps = (0, $3YtPS.createSelector)([
        (0, $gQ7rz.getErrors),
        (0, $gQ7rz.getErrorLogDialogState)
    ], (errors, isErrorLogDialogOpen)=>({
            errors: errors,
            isErrorLogDialogOpen: isErrorLogDialogOpen
        }));
    const $dbefaba6eaf4e2b6$var$mapDispatchToProps = (dispatch)=>({
            hideError: ()=>{
                dispatch((0, $eWre9.hideError)());
            },
            hideAllErrors: ()=>{
                dispatch((0, $eWre9.hideAllErrors)());
            },
            showErrorLogDialog: ()=>{
                dispatch((0, $eWre9.showErrorLogDialog)());
            },
            hideErrorLogDialog: ()=>{
                dispatch((0, $eWre9.hideErrorLogDialog)());
            }
        });
    const $dbefaba6eaf4e2b6$var$ErrorNotification = (0, (0, parcelRequire("bC2fB")).connect)($dbefaba6eaf4e2b6$var$mapStateToProps, $dbefaba6eaf4e2b6$var$mapDispatchToProps)((0, $2S1WV.default));
    var $dbefaba6eaf4e2b6$export$2e2bcd8739ae039 = $dbefaba6eaf4e2b6$var$ErrorNotification;
});
parcelRegister("2S1WV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f63c5b19df219688$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $7nnPp;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $d4xRU;
    var $3KRpp;
    var $ousew;
    var $84qTJ = parcelRequire("84qTJ");
    var $ihPUd = parcelRequire("ihPUd");
    var $db0fs = parcelRequire("db0fs");
    var $bHk7n = parcelRequire("bHk7n");
    var $dmOPn = parcelRequire("dmOPn");
    var $gqIDR = parcelRequire("gqIDR");
    const $f63c5b19df219688$var$Description = ({ description: description })=>{
        const emailLink = (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://support.atlassian.com/contact",
            target: "_blank",
            rel: "noopener noreferrer"
        }, "https://support.atlassian.com/contact");
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: $gqIDR["email-link"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...description || (0, $dmOPn.default).errorMessage,
            values: {
                emailLink: emailLink
            }
        })));
    };
    const $f63c5b19df219688$var$getFlag = ({ id: id, title: title, description: description }, intl)=>({
            id: id,
            title: title || intl.formatMessage((0, $dmOPn.default).errorTitle),
            appearance: 'error',
            description: (0, ($parcel$interopDefault($5uXOq))).createElement($f63c5b19df219688$var$Description, {
                description: description
            }),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                label: intl.formatMessage((0, $dmOPn.default).errorIconLabel),
                primaryColor: "var(--ds-icon-danger, #FF5630)"
            })
        });
    class $f63c5b19df219688$var$ErrorNotification extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                ViewExperienceFailureTracker: $db0fs.default
            };
        }
        render() {
            if (window?.STORYBOOK_ENV) return null;
            const { intl: intl, errors: errors, isErrorLogDialogOpen: isErrorLogDialogOpen, showErrorLogDialog: showErrorLogDialog, hideErrorLogDialog: hideErrorLogDialog, ViewExperienceFailureTracker: ViewExperienceFailureTracker } = this.props;
            const actionsSingleError = [
                {
                    content: intl.formatMessage((0, $dmOPn.default).viewLog),
                    onClick: showErrorLogDialog
                },
                {
                    content: intl.formatMessage((0, $dmOPn.default).dismiss),
                    onClick: this.dismissFlag,
                    testId: 'portfolio-3-portfolio.app-simple-plans.error-notification.error-notification-flag.dismiss-btn'
                }
            ];
            const actions = [
                ...actionsSingleError,
                {
                    content: intl.formatMessage((0, $dmOPn.default).dismissAll),
                    onClick: this.dismissAllFlag,
                    testId: 'portfolio-3-portfolio.app-simple-plans.error-notification.error-notification-flag.dismiss-all-btn'
                }
            ];
            const errorOnTop = errors[errors.length - 1];
            let errorDetails;
            let ErrorInfoComponent;
            let ErrorDetailsComponent;
            if (errorOnTop) {
                const errorInfo = {
                    title: 'Stack Trace',
                    sections: [
                        {
                            title: `${errorOnTop.message}\n\n`,
                            info: errorOnTop.stackTrace || intl.formatMessage((0, $dmOPn.default).stackTraceNotFoundMessage)
                        }
                    ]
                };
                ErrorInfoComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bHk7n.default), errorInfo);
                if (errorOnTop.details) {
                    errorDetails = errorOnTop.details;
                    let requestInfoComponent;
                    if (errorDetails.requestInfo) {
                        const requestInfo = {
                            title: 'Request Information',
                            sections: [
                                {
                                    title: 'Url: ',
                                    info: errorDetails.requestInfo.url
                                },
                                {
                                    title: 'Type: ',
                                    info: errorDetails.requestInfo.type
                                },
                                {
                                    title: 'Status: ',
                                    info: errorDetails.requestInfo.status
                                },
                                {
                                    title: 'Data: ',
                                    info: JSON.stringify(errorDetails.requestInfo.body, undefined, 2) || ''
                                }
                            ]
                        };
                        requestInfoComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bHk7n.default), requestInfo);
                    }
                    const clientInfo = {
                        title: 'Client Information',
                        sections: [
                            {
                                title: 'User Agent: ',
                                info: errorDetails.clientInfo.userAgent
                            },
                            {
                                title: 'Local Time: ',
                                info: errorDetails.clientInfo.localTime
                            }
                        ]
                    };
                    const systemInfo = {
                        title: 'System Information',
                        sections: [
                            {
                                title: 'Jira Title: ',
                                info: errorDetails.systemInfo.jiraTitle
                            }
                        ]
                    };
                    ErrorDetailsComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, requestInfoComponent, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bHk7n.default), clientInfo), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $bHk7n.default), systemInfo));
                }
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(ViewExperienceFailureTracker, {
                location: "portfolio-3.simple-plans.state-or-global-error"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).FlagGroup), {
                onDismissed: this.dismissFlag
            }, errors.map((error)=>$f63c5b19df219688$var$getFlag(error, intl)).map((flag)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
                    actions: errors.length === 1 ? actionsSingleError : actions,
                    ...flag,
                    key: flag.id,
                    testId: "portfolio-3-portfolio.app-simple-plans.error-notification.error-notification-flag"
                }))), isErrorLogDialogOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                onClose: ()=>hideErrorLogDialog(),
                width: "x-large",
                autoFocus: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
                appearance: "danger"
            }, errorOnTop.title || intl.formatMessage((0, $dmOPn.default).errorTitle))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: $gqIDR["error-log"]
            }, ErrorDetailsComponent, ErrorInfoComponent)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "danger",
                onClick: ()=>hideErrorLogDialog()
            }, intl.formatMessage((0, $ihPUd.default).cancel))))));
        }
        constructor(...args){
            super(...args);
            this.dismissFlag = ()=>{
                const { hideError: hideError, hideErrorLogDialog: hideErrorLogDialog } = this.props;
                hideErrorLogDialog();
                hideError();
            };
            this.dismissAllFlag = ()=>{
                const { hideAllErrors: hideAllErrors, hideErrorLogDialog: hideErrorLogDialog } = this.props;
                hideErrorLogDialog();
                hideAllErrors();
            };
        }
    }
    var $f63c5b19df219688$export$2e2bcd8739ae039 = (0, $84qTJ.injectIntlWithDefaultProps)($f63c5b19df219688$var$ErrorNotification);
});
parcelRegister("bHk7n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3903ecfa3572eb8e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $43aiT = parcelRequire("43aiT");
    function $3903ecfa3572eb8e$export$2e2bcd8739ae039(props) {
        const { title: title, sections: sections } = props;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("pre", {
            className: $43aiT["error-details"]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "h4",
            size: "small"
        }, title), sections.map((section, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("b", null, section.title), section.info))));
    }
});
parcelRegister("43aiT", function(module, exports) {
    $parcel$export(module.exports, "error-details", ()=>$2f2f6f5610bd5ee5$export$270a1f581400e0c9, (v)=>$2f2f6f5610bd5ee5$export$270a1f581400e0c9 = v);
    var $2f2f6f5610bd5ee5$export$270a1f581400e0c9;
    $2f2f6f5610bd5ee5$export$270a1f581400e0c9 = `kevL5G_error-details`;
});
parcelRegister("dmOPn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4b542687804c637$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e4b542687804c637$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorIconLabel: {
            "id": "portfolio-3-portfolio.app-simple-plans.error-notification.error-icon-label",
            "defaultMessage": "Error icon"
        },
        errorMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.error-notification.error-message",
            "defaultMessage": "Wait a few seconds, then try again. If this keeps happening, let us know at {emailLink}."
        },
        errorTitle: {
            "id": "portfolio-3-portfolio.app-simple-plans.error-notification.error-title",
            "defaultMessage": "Something went wrong."
        },
        stackTraceNotFoundMessage: {
            "id": "portfolio-3-portfolio.app-simple-plans.error-notification.stack-trace-not-found-message",
            "defaultMessage": "There is no stacktrace available."
        },
        viewLog: {
            "id": "portfolio-3-portfolio.app-simple-plans.error-notification.view-log",
            "defaultMessage": "View Log"
        },
        dismiss: {
            "id": "portfolio-3-portfolio.app-simple-plans.error-notification.dismiss",
            "defaultMessage": "Dismiss"
        },
        dismissAll: {
            "id": "portfolio-3-portfolio.app-simple-plans.error-notification.dismiss-all",
            "defaultMessage": "Dismiss all"
        }
    });
});
parcelRegister("gqIDR", function(module, exports) {
    $parcel$export(module.exports, "email-link", ()=>$bf61b3fe0f193955$export$1ab0abbc0e203d0, (v)=>$bf61b3fe0f193955$export$1ab0abbc0e203d0 = v);
    $parcel$export(module.exports, "error-log", ()=>$bf61b3fe0f193955$export$9e1a4430890c109, (v)=>$bf61b3fe0f193955$export$9e1a4430890c109 = v);
    var $bf61b3fe0f193955$export$1ab0abbc0e203d0;
    var $bf61b3fe0f193955$export$9e1a4430890c109;
    $bf61b3fe0f193955$export$1ab0abbc0e203d0 = `_8mXQ2q_email-link`;
    $bf61b3fe0f193955$export$9e1a4430890c109 = `_8mXQ2q_error-log`;
});
parcelRegister("jqP0M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd95f001c4438c09$export$2e2bcd8739ae039);
    var $bC2fB;
    var $8T80R = parcelRequire("8T80R");
    var $3Gp8B = parcelRequire("3Gp8B");
    var $bd95f001c4438c09$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((0, $8T80R.default), {})((0, $3Gp8B.default));
});
parcelRegister("8T80R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43ac9dac802c620d$export$2e2bcd8739ae039);
    var $bI9dZ = parcelRequire("bI9dZ");
    const $43ac9dac802c620d$var$mapStateToProps = (state)=>({
            isLoading: (0, $bI9dZ.getIsIssuesLoading)(state)
        });
    var $43ac9dac802c620d$export$2e2bcd8739ae039 = $43ac9dac802c620d$var$mapStateToProps;
});
parcelRegister("3Gp8B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0fa53a46133a99c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gEcei = parcelRequire("gEcei");
    class $b0fa53a46133a99c$var$ExperienceTracker extends (0, $5uXOq.Component) {
        componentDidUpdate(prevProps) {
            const { isLoading: isLoading, onExperienceSuccess: onExperienceSuccess } = this.props;
            if (prevProps.isLoading && !isLoading) onExperienceSuccess?.();
        }
        render() {
            return null;
        }
    }
    var $b0fa53a46133a99c$export$2e2bcd8739ae039 = (0, $gEcei.default)($b0fa53a46133a99c$var$ExperienceTracker, 'portfolio-3.simple-plans.backlog.request');
});
parcelRegister("65tNY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$89ee375661decc24$export$2e2bcd8739ae039);
    var $bC2fB;
    var $817Dt = parcelRequire("817Dt");
    var $Fgzyk = parcelRequire("Fgzyk");
    var $89ee375661decc24$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(null, (0, $817Dt.default))((0, $Fgzyk.ReduxStoreLifecycle));
});
parcelRegister("817Dt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d7567f90f3591ff5$export$2e2bcd8739ae039);
    var $dFesP = parcelRequire("dFesP");
    var $5PKZw = parcelRequire("5PKZw");
    var $hHqKh = parcelRequire("hHqKh");
    const $d7567f90f3591ff5$var$mapDispatchToProps = {
        initialLoad: $dFesP.initialLoad,
        restoreReduxStore: $5PKZw.restoreReduxStore,
        resetReduxStore: $5PKZw.resetReduxStore,
        changeActiveFilterView: $hHqKh.changeActiveFilterView
    };
    var $d7567f90f3591ff5$export$2e2bcd8739ae039 = $d7567f90f3591ff5$var$mapDispatchToProps;
});
parcelRegister("Fgzyk", function(module, exports) {
    $parcel$export(module.exports, "ReduxStoreLifecycle", ()=>$3cc5f8c066269393$export$1fe5fa347ba3315b);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $bI9dZ = parcelRequire("bI9dZ");
    var $48B3j = parcelRequire("48B3j");
    var $d7tG0 = parcelRequire("d7tG0");
    const $3cc5f8c066269393$export$1fe5fa347ba3315b = ({ locale: locale, initialLoad: initialLoad, restoreReduxStore: restoreReduxStore, resetReduxStore: resetReduxStore, changeActiveFilterView: changeActiveFilterView, planView: planView })=>{
        const [cachedState, cacheState] = (0, $d7tG0.useReduxStateCache)();
        (0, $5uXOq.useEffect)(()=>{
            if (cachedState) {
                try {
                    if (!cachedState.domain.plan.id) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('plans.plan-id-not-available', 'Plan id is not available while restoring Redux store state', {
                        loading: (0, $bI9dZ.getIsIssuesLoading)(cachedState)
                    });
                } catch (err) {}
                restoreReduxStore(cachedState);
                if (planView) changeActiveFilterView(planView);
            } else initialLoad({
                locale: locale,
                planView: planView
            });
        }, [
            cachedState,
            initialLoad,
            locale,
            restoreReduxStore,
            planView,
            changeActiveFilterView
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                const state = (0, $48B3j.default).getState();
                cacheState((0, $bI9dZ.getIsIssuesLoading)(state) ? undefined : state);
                try {
                    if (!state.domain.plan.id) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('plans.plan-id-not-available', 'Plan id is not available while caching Redux store state', {
                        loading: (0, $bI9dZ.getIsIssuesLoading)(state)
                    });
                } catch (err) {}
            }, [
            cacheState
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                resetReduxStore();
            }, [
            resetReduxStore
        ]);
        return null;
    };
});
parcelRegister("d7tG0", function(module, exports) {
    $parcel$export(module.exports, "useReduxStateCache", ()=>$e5dbba7a45acac39$export$624082a1a136a51e);
    var $5uXOq = parcelRequire("5uXOq");
    var $c3WQb;
    var $2YP9W;
    const $e5dbba7a45acac39$export$624082a1a136a51e = ()=>{
        const { data: initialState, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource));
        const cacheState = (0, $5uXOq.useCallback)((state)=>{
            update(()=>state);
        }, [
            update
        ]);
        return [
            initialState ?? undefined,
            cacheState
        ];
    };
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("Sf4aO", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsInitializer", ()=>$a0e2ad6c3be4e698$export$104a3bea6fcce96c);
    var $5uXOq = parcelRequire("5uXOq");
    var $j8DrX;
    var $c0cft = parcelRequire("c0cft");
    var $lYuBN = parcelRequire("lYuBN");
    var $48B3j = parcelRequire("48B3j");
    var $iXVV6;
    var $isuse;
    var $doZTA;
    const $a0e2ad6c3be4e698$export$104a3bea6fcce96c = ({ children: children })=>{
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const planId = match.params.planId ?? '';
        const scenarioId = match.params.scenarioId ?? '';
        const searchSessionId = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-search-session-id'), [
            planId
        ]);
        const contextAnalyticsDataAttributes = {
            planId: planId,
            scenarioId: scenarioId,
            context: (0, $c0cft.context).PLAN,
            ...searchSessionId && {
                searchSessionId: searchSessionId
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "portfolio3",
            attributes: contextAnalyticsDataAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: (analyticsEvent)=>(0, $48B3j.default).dispatch((0, $lYuBN.setAnalyticsEvent)(analyticsEvent))
        }), children);
    };
});
parcelRegister("5QXst", function(module, exports) {
    $parcel$export(module.exports, "usePlanCheck", ()=>$39893bc5a23ea220$export$e6f190cd203659ad);
    var $c3WQb;
    var $2YP9W;
    const $39893bc5a23ea220$export$e6f190cd203659ad = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource));
});
parcelRegister("2QgzU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd18eb466bb431d9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bd18eb466bb431d9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        timeline: {
            "id": "spa-apps-advanced-roadmaps-plan.plan-report.timeline",
            "defaultMessage": "Timeline"
        }
    });
});
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';
